(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 82381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$hr": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.$hr; },
/* harmony export */   "$xJ": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.$xJ; },
/* harmony export */   "$zK": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.$zK; },
/* harmony export */   "B4R": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.B4R; },
/* harmony export */   "BSq": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.BSq; },
/* harmony export */   "F5E": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.F5E; },
/* harmony export */   "FRj": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.FRj; },
/* harmony export */   "H8G": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.H8G; },
/* harmony export */   "JfL": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.JfL; },
/* harmony export */   "Jhp": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.Jhp; },
/* harmony export */   "JlX": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.JlX; },
/* harmony export */   "Jth": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.Jth; },
/* harmony export */   "KBB": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.KBB; },
/* harmony export */   "KCG": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.KCG; },
/* harmony export */   "LvZ": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.LvZ; },
/* harmony export */   "MLF": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.MLF; },
/* harmony export */   "ODz": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.ODz; },
/* harmony export */   "OUf": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.OUf; },
/* harmony export */   "Ooy": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.Ooy; },
/* harmony export */   "Pvg": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.Pvg; },
/* harmony export */   "QSL": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.QSL; },
/* harmony export */   "QjN": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.QjN; },
/* harmony export */   "R9e": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.R9e; },
/* harmony export */   "SFo": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.SFo; },
/* harmony export */   "SZC": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.SZC; },
/* harmony export */   "S__": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.S__; },
/* harmony export */   "SdH": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.SdH; },
/* harmony export */   "T01": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.T01; },
/* harmony export */   "TOz": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.TOz; },
/* harmony export */   "X3N": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.X3N; },
/* harmony export */   "XRW": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.XRW; },
/* harmony export */   "XfO": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.XfO; },
/* harmony export */   "XgB": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.XgB; },
/* harmony export */   "YOZ": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.YOZ; },
/* harmony export */   "YW8": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.YW8; },
/* harmony export */   "Yw6": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.Yw6; },
/* harmony export */   "Z0E": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.Z0E; },
/* harmony export */   "Z1S": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.Z1S; },
/* harmony export */   "ZAD": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.ZAD; },
/* harmony export */   "Zmg": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.Zmg; },
/* harmony export */   "_Wl": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__._Wl; },
/* harmony export */   "_q4": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__._q4; },
/* harmony export */   "be0": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.be0; },
/* harmony export */   "eVX": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.eVX; },
/* harmony export */   "eee": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.eee; },
/* harmony export */   "gdK": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.gdK; },
/* harmony export */   "hJE": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.hJE; },
/* harmony export */   "hKc": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.hKc; },
/* harmony export */   "i4D": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.i4D; },
/* harmony export */   "jZ5": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.jZ5; },
/* harmony export */   "kLt": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.kLt; },
/* harmony export */   "mM8": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.mM8; },
/* harmony export */   "mf5": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.mf5; },
/* harmony export */   "nJe": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.nJe; },
/* harmony export */   "o28": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.o28; },
/* harmony export */   "odP": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.odP; },
/* harmony export */   "p6y": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.p6y; },
/* harmony export */   "pJ9": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.pJ9; },
/* harmony export */   "ph5": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.ph5; },
/* harmony export */   "pv": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.pv; },
/* harmony export */   "qPp": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.qPp; },
/* harmony export */   "szC": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.szC; },
/* harmony export */   "tTm": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.tTm; },
/* harmony export */   "uGy": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.uGy; },
/* harmony export */   "vJ3": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.vJ3; },
/* harmony export */   "wJb": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.wJb; },
/* harmony export */   "wf_": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.wf_; },
/* harmony export */   "yYJ": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.yYJ; },
/* harmony export */   "z58": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.z58; },
/* harmony export */   "zTP": function() { return /* reexport safe */ _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__.zTP; }
/* harmony export */ });
/* harmony import */ var _cardano_multiplatform_lib_bg_wasm__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5752);
/* harmony import */ var _cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20630);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_cardano_multiplatform_lib_bg_wasm__WEBPACK_IMPORTED_MODULE_1__]);
_cardano_multiplatform_lib_bg_wasm__WEBPACK_IMPORTED_MODULE_1__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];



(0,_cardano_multiplatform_lib_bg_js__WEBPACK_IMPORTED_MODULE_0__/* .__wbg_set_wasm */ .oTL)(_cardano_multiplatform_lib_bg_wasm__WEBPACK_IMPORTED_MODULE_1__);


__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 20630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$hr": function() { return /* binding */ PlutusV2Script; },
/* harmony export */   "$xJ": function() { return /* binding */ NativeScript; },
/* harmony export */   "$zK": function() { return /* binding */ PlutusData; },
/* harmony export */   "B4R": function() { return /* binding */ Value; },
/* harmony export */   "BOx": function() { return /* binding */ __wbg_buffer_b7b08af79b0b0974; },
/* harmony export */   "BSq": function() { return /* binding */ Bip32PrivateKey; },
/* harmony export */   "D2P": function() { return /* binding */ __wbg_call_89af060b4e1523f2; },
/* harmony export */   "Dnr": function() { return /* binding */ __wbg_subarray_7c2e3576afe181d1; },
/* harmony export */   "F5E": function() { return /* binding */ Redeemers; },
/* harmony export */   "FRj": function() { return /* binding */ PlutusMap; },
/* harmony export */   "FyC": function() { return /* binding */ __wbg_globalThis_86b222e13bdf32ed; },
/* harmony export */   "Glo": function() { return /* binding */ __wbg_self_3093d5d1f7bcb682; },
/* harmony export */   "H8G": function() { return /* binding */ LinearFee; },
/* harmony export */   "Iui": function() { return /* binding */ __wbg_getRandomValues_3aa56aa6edec874c; },
/* harmony export */   "JfL": function() { return /* binding */ AssetName; },
/* harmony export */   "Jhp": function() { return /* binding */ BigInteger; },
/* harmony export */   "JlX": function() { return /* binding */ NetworkInfo; },
/* harmony export */   "Jth": function() { return /* binding */ DRep; },
/* harmony export */   "KBB": function() { return /* binding */ Certificate; },
/* harmony export */   "KCG": function() { return /* binding */ ChangeSelectionAlgo; },
/* harmony export */   "KxL": function() { return /* binding */ __wbindgen_bigint_from_u64; },
/* harmony export */   "LvZ": function() { return /* binding */ ConstrPlutusData; },
/* harmony export */   "MLF": function() { return /* binding */ MultiAsset; },
/* harmony export */   "N9V": function() { return /* binding */ __wbg_set_49185437f0ab06f8; },
/* harmony export */   "ODz": function() { return /* binding */ PlutusDataList; },
/* harmony export */   "OLm": function() { return /* binding */ __wbg_global_e5a3fe56f8be9485; },
/* harmony export */   "OQ_": function() { return /* binding */ __wbg_require_cca90b1a94a0255b; },
/* harmony export */   "OUf": function() { return /* binding */ Ed25519KeyHashList; },
/* harmony export */   "Ooy": function() { return /* binding */ SingleWithdrawalBuilder; },
/* harmony export */   "Or8": function() { return /* binding */ __wbindgen_throw; },
/* harmony export */   "Pvg": function() { return /* binding */ SingleMintBuilder; },
/* harmony export */   "QSL": function() { return /* binding */ RedeemerTag; },
/* harmony export */   "QjN": function() { return /* binding */ DatumOption; },
/* harmony export */   "R1Q": function() { return /* binding */ __wbg_new_525245e2b9901204; },
/* harmony export */   "R9e": function() { return /* binding */ Url; },
/* harmony export */   "RVh": function() { return /* binding */ __wbg_String_91fba7ded13ba54c; },
/* harmony export */   "SFo": function() { return /* binding */ Metadata; },
/* harmony export */   "SZC": function() { return /* binding */ hash_plutus_data; },
/* harmony export */   "S__": function() { return /* binding */ TransactionWitnessSetBuilder; },
/* harmony export */   "SdH": function() { return /* binding */ MapAssetNameToNonZeroInt64; },
/* harmony export */   "Ssi": function() { return /* binding */ __wbg_window_3bcfc4d31bc012f8; },
/* harmony export */   "T01": function() { return /* binding */ TransactionMetadatum; },
/* harmony export */   "TOz": function() { return /* binding */ AuxiliaryData; },
/* harmony export */   "WD8": function() { return /* binding */ __wbindgen_bigint_from_i64; },
/* harmony export */   "Wl7": function() { return /* binding */ __wbg_set_20cbc34131e76824; },
/* harmony export */   "WlW": function() { return /* binding */ __wbindgen_is_object; },
/* harmony export */   "X3N": function() { return /* binding */ NativeScriptList; },
/* harmony export */   "XP4": function() { return /* binding */ __wbindgen_is_undefined; },
/* harmony export */   "XRW": function() { return /* binding */ TransactionInput; },
/* harmony export */   "XfO": function() { return /* binding */ Script; },
/* harmony export */   "XgB": function() { return /* binding */ TransactionWitnessSet; },
/* harmony export */   "YOZ": function() { return /* binding */ AnchorDocHash; },
/* harmony export */   "YW8": function() { return /* binding */ Transaction; },
/* harmony export */   "Yw6": function() { return /* binding */ ExUnits; },
/* harmony export */   "Z0E": function() { return /* binding */ EnterpriseAddress; },
/* harmony export */   "Z1S": function() { return /* binding */ PlutusV1Script; },
/* harmony export */   "ZAD": function() { return /* binding */ TransactionUnspentOutput; },
/* harmony export */   "Zmg": function() { return /* binding */ PlutusScriptWitness; },
/* harmony export */   "_Wl": function() { return /* binding */ Ed25519KeyHash; },
/* harmony export */   "_q4": function() { return /* binding */ PrivateKey; },
/* harmony export */   "ak$": function() { return /* binding */ __wbg_new_a220cf903aa02ca2; },
/* harmony export */   "be0": function() { return /* binding */ LegacyRedeemer; },
/* harmony export */   "dFT": function() { return /* binding */ __wbg_new_ea1883e1e5e86686; },
/* harmony export */   "eFR": function() { return /* binding */ __wbg_set_d1e79e2388520f18; },
/* harmony export */   "eVX": function() { return /* binding */ TransactionOutputBuilder; },
/* harmony export */   "eYF": function() { return /* binding */ __wbindgen_is_string; },
/* harmony export */   "eee": function() { return /* binding */ Anchor; },
/* harmony export */   "eoR": function() { return /* binding */ __wbg_process_4a72847cc503995b; },
/* harmony export */   "gdK": function() { return /* binding */ PointerAddress; },
/* harmony export */   "gg_": function() { return /* binding */ __wbg_newnoargs_76313bd6ff35d0f2; },
/* harmony export */   "h4u": function() { return /* binding */ __wbindgen_string_new; },
/* harmony export */   "hJE": function() { return /* binding */ Credential; },
/* harmony export */   "hKc": function() { return /* binding */ TransactionBuilder; },
/* harmony export */   "hcz": function() { return /* binding */ __wbg_msCrypto_eb05e62b530a1508; },
/* harmony export */   "hdV": function() { return /* binding */ __wbindgen_error_new; },
/* harmony export */   "i4D": function() { return /* binding */ make_vkey_witness; },
/* harmony export */   "jZ5": function() { return /* binding */ ByronAddress; },
/* harmony export */   "kLt": function() { return /* binding */ Address; },
/* harmony export */   "kdS": function() { return /* binding */ __wbg_set_673dda6c73d19609; },
/* harmony export */   "mM8": function() { return /* binding */ NativeScriptWitnessInfo; },
/* harmony export */   "m_1": function() { return /* binding */ __wbindgen_object_clone_ref; },
/* harmony export */   "mf5": function() { return /* binding */ RewardAddress; },
/* harmony export */   "nJe": function() { return /* binding */ ScriptHash; },
/* harmony export */   "o$X": function() { return /* binding */ __wbindgen_is_function; },
/* harmony export */   "o28": function() { return /* binding */ hash_transaction; },
/* harmony export */   "oH7": function() { return /* binding */ __wbg_randomFillSync_5c9c955aa56b6049; },
/* harmony export */   "oHO": function() { return /* binding */ __wbindgen_memory; },
/* harmony export */   "oTL": function() { return /* binding */ __wbg_set_wasm; },
/* harmony export */   "odP": function() { return /* binding */ DatumHash; },
/* harmony export */   "p6y": function() { return /* binding */ RedeemerWitnessKey; },
/* harmony export */   "pJ9": function() { return /* binding */ MapAssetNameToCoin; },
/* harmony export */   "pT7": function() { return /* binding */ __wbindgen_number_new; },
/* harmony export */   "ph5": function() { return /* binding */ SingleInputBuilder; },
/* harmony export */   "pv": function() { return /* binding */ BaseAddress; },
/* harmony export */   "q4o": function() { return /* binding */ __wbg_crypto_1d1f22824a6a080c; },
/* harmony export */   "qPp": function() { return /* binding */ PlutusScript; },
/* harmony export */   "qeO": function() { return /* binding */ __wbg_newwithlength_ec548f448387c968; },
/* harmony export */   "qxi": function() { return /* binding */ __wbg_node_104a2ff8d6ea03a2; },
/* harmony export */   "sG1": function() { return /* binding */ __wbg_newwithbyteoffsetandlength_8a2cb9ca96b27ec9; },
/* harmony export */   "szC": function() { return /* binding */ TransactionBuilderConfigBuilder; },
/* harmony export */   "tTm": function() { return /* binding */ PartialPlutusWitness; },
/* harmony export */   "u9i": function() { return /* binding */ __wbg_call_1084a111329e68ce; },
/* harmony export */   "uGy": function() { return /* binding */ Rational; },
/* harmony export */   "uYV": function() { return /* binding */ __wbg_versions_f686565e586dd935; },
/* harmony export */   "ug$": function() { return /* binding */ __wbindgen_object_drop_ref; },
/* harmony export */   "vJ3": function() { return /* binding */ SingleCertificateBuilder; },
/* harmony export */   "wJb": function() { return /* binding */ ExUnitPrices; },
/* harmony export */   "wf_": function() { return /* binding */ TransactionHash; },
/* harmony export */   "wzW": function() { return /* binding */ __wbg_new_8608a2b51a5f6737; },
/* harmony export */   "yYJ": function() { return /* binding */ CostModels; },
/* harmony export */   "z58": function() { return /* binding */ PlutusV3Script; },
/* harmony export */   "zTP": function() { return /* binding */ LegacyRedeemerList; }
/* harmony export */ });
/* unused harmony exports emip3_encrypt_with_password, emip3_decrypt_with_password, encode_arbitrary_bytes_as_metadatum, decode_arbitrary_bytes_from_metadatum, min_script_fee, min_no_script_fee, min_fee, make_daedalus_bootstrap_witness, make_icarus_bootstrap_witness, compute_total_ex_units, hash_auxiliary_data, hash_script_data, calc_script_data_hash, calc_script_data_hash_from_witness, get_implicit_input, get_deposit, encode_json_str_to_metadatum, decode_metadatum_to_json_str, encode_json_str_to_plutus_datum, decode_plutus_datum_to_json_str, min_ada_required, CIP25Version, PlutusDataKind, GovActionKind, ScriptKind, Vote, Language, AddressHeaderKind, AuxiliaryDataKind, DatumOptionKind, NonceKind, DRepKind, ChunkableStringKind, RelayKind, RedeemersKind, CoinSelectionStrategyCIP2, CredentialKind, AddressKind, ByronAddrType, TransactionMetadatumKind, SpendingDataKind, MetadataJsonSchema, NativeScriptKind, TransactionOutputKind, VoterKind, DelegationDistributionKind, StakeDistributionKind, CardanoNodePlutusDatumSchema, CertificateKind, AddrAttributes, AddressContent, AddressId, AlonzoFormatTxOut, AssetNameList, AuthCommitteeHotCert, AuxiliaryDataHash, Bip32PublicKey, Block, BlockBodyHash, BlockHeaderHash, BootstrapWitness, BootstrapWitnessList, ByronScript, ByronTxOut, CIP25ChunkableString, CIP25FilesDetails, CIP25LabelMetadata, CIP25Metadata, CIP25MetadataDetails, CIP25MiniMetadataDetails, CIP25String64, CIP25String64List, CIP36Delegation, CIP36DelegationDistribution, CIP36DelegationList, CIP36DeregistrationCbor, CIP36DeregistrationWitness, CIP36KeyDeregistration, CIP36KeyRegistration, CIP36RegistrationCbor, CIP36RegistrationWitness, CertificateBuilderResult, CertificateList, CommitteeColdCredentialList, Constitution, ConwayFormatAuxData, ConwayFormatTxOut, Crc32, DNSName, DRepVotingThresholds, Ed25519Signature, FilesDetailsList, GenesisDelegateHash, GenesisHash, GovAction, GovActionId, GovActionIdList, HDAddressPayload, HardForkInitiationAction, Header, HeaderBody, InputAggregateWitnessData, InputBuilderResult, Int, IntList, Ipv4, Ipv6, KESSignature, KESVkey, LanguageList, LegacyDaedalusPrivateKey, MapAssetNameToU64, MapCommitteeColdCredentialToEpoch, MapGovActionIdToVotingProcedure, MapPlutusDataToPlutusData, MapRedeemerKeyToRedeemerVal, MapRewardAccountToCoin, MapStakeCredentialToDeltaCoin, MapTransactionIndexToAuxiliaryData, MapTransactionMetadatumToTransactionMetadatum, MapU64ToArrI64, MetadatumList, MetadatumMap, Mint, MintBuilderResult, MultiHostName, NetworkId, NewConstitution, NoConfidence, Nonce, NonceHash, OperationalCert, ParameterChangeAction, PlutusV1ScriptList, PlutusV2ScriptList, PlutusV3ScriptList, Pointer, PolicyIdList, PoolMetadata, PoolMetadataHash, PoolParams, PoolRegistration, PoolRetirement, PoolVotingThresholds, ProposalBuilder, ProposalBuilderResult, ProposalProcedure, ProposalProcedureList, ProtocolMagic, ProtocolParamUpdate, ProtocolVersion, PublicKey, RedeemerKey, RedeemerKeyList, RedeemerSetBuilder, RedeemerVal, RegCert, RegDrepCert, Relay, RelayList, RequiredWitnessSet, ResignCommitteeColdCert, RewardAccountList, ScriptAll, ScriptAny, ScriptDataHash, ScriptInvalidBefore, ScriptInvalidHereafter, ScriptNOfK, ScriptPubkey, ShelleyMAFormatAuxData, SignedTxBuilder, SingleHostAddr, SingleHostName, SingleOutputBuilderResult, SpendingData, StakeCredentialList, StakeDelegation, StakeDeregistration, StakeDistribution, StakeRegDelegCert, StakeRegistration, StakeVoteDelegCert, StakeVoteRegDelegCert, StakeholderId, SubCoin, TransactionBody, TransactionBodyList, TransactionBuilderConfig, TransactionInputList, TransactionMetadatumLabels, TransactionMetadatumList, TransactionOutput, TransactionOutputAmountBuilder, TransactionOutputList, TransactionWitnessSetList, TreasuryWithdrawalsAction, TxRedeemerBuilder, UnitInterval, UnregCert, UnregDrepCert, UntaggedRedeemer, UpdateCommittee, UpdateDrepCert, VRFCert, VRFKeyHash, VRFVkey, Vkeywitness, VkeywitnessList, VoteBuilder, VoteBuilderResult, VoteDelegCert, VoteRegDelegCert, Voter, VoterList, VotingProcedure, VotingProcedures, WithdrawalBuilderResult */
/* module decorator */ module = __webpack_require__.hmd(module);
let wasm;
function __wbg_set_wasm(val) {
    wasm = val;
}


const heap = new Array(128).fill(undefined);

heap.push(undefined, null, true, false);

function getObject(idx) { return heap[idx]; }

const lTextDecoder = typeof TextDecoder === 'undefined' ? (0, module.require)('util').TextDecoder : TextDecoder;

let cachedTextDecoder = new lTextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

let heap_next = heap.length;

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

function dropObject(idx) {
    if (idx < 132) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        wasm.__wbindgen_exn_store(addHeapObject(e));
    }
}

let WASM_VECTOR_LEN = 0;

const lTextEncoder = typeof TextEncoder === 'undefined' ? (0, module.require)('util').TextEncoder : TextEncoder;

let cachedTextEncoder = new lTextEncoder('utf-8');

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachedDataViewMemory0 = null;

function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
    return instance.ptr;
}
/**
* Encrypt using Emip3: https://github.com/Emurgo/EmIPs/blob/master/specs/emip-003.md
* @param {string} password
* @param {string} salt
* @param {string} nonce
* @param {string} data
* @returns {string}
*/
function emip3_encrypt_with_password(password, salt, nonce, data) {
    let deferred6_0;
    let deferred6_1;
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        const ptr0 = passStringToWasm0(password, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(salt, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(nonce, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ptr3 = passStringToWasm0(data, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len3 = WASM_VECTOR_LEN;
        wasm.emip3_encrypt_with_password(retptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
        var ptr5 = r0;
        var len5 = r1;
        if (r3) {
            ptr5 = 0; len5 = 0;
            throw takeObject(r2);
        }
        deferred6_0 = ptr5;
        deferred6_1 = len5;
        return getStringFromWasm0(ptr5, len5);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
        wasm.__wbindgen_free(deferred6_0, deferred6_1, 1);
    }
}

/**
* Decrypt using Emip3: https://github.com/Emurgo/EmIPs/blob/master/specs/emip-003.md
* @param {string} password
* @param {string} data
* @returns {string}
*/
function emip3_decrypt_with_password(password, data) {
    let deferred4_0;
    let deferred4_1;
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        const ptr0 = passStringToWasm0(password, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(data, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        wasm.emip3_decrypt_with_password(retptr, ptr0, len0, ptr1, len1);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
        var ptr3 = r0;
        var len3 = r1;
        if (r3) {
            ptr3 = 0; len3 = 0;
            throw takeObject(r2);
        }
        deferred4_0 = ptr3;
        deferred4_1 = len3;
        return getStringFromWasm0(ptr3, len3);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
        wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
    }
}

function isLikeNone(x) {
    return x === undefined || x === null;
}
/**
* encodes arbitrary bytes into chunks of 64 bytes (the limit for bytes) as a list to be valid Metadata
* @param {Uint8Array} bytes
* @returns {TransactionMetadatum}
*/
function encode_arbitrary_bytes_as_metadatum(bytes) {
    const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.encode_arbitrary_bytes_as_metadatum(ptr0, len0);
    return TransactionMetadatum.__wrap(ret);
}

/**
* decodes from chunks of bytes in a list to a byte vector if that is the metadata format, otherwise returns None
* @param {TransactionMetadatum} metadata
* @returns {Uint8Array | undefined}
*/
function decode_arbitrary_bytes_from_metadatum(metadata) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        _assertClass(metadata, TransactionMetadatum);
        wasm.decode_arbitrary_bytes_from_metadatum(retptr, metadata.__wbg_ptr);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        let v1;
        if (r0 !== 0) {
            v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
        }
        return v1;
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
*
* * Min fee for JUST the script, NOT including ref inputs
*
* @param {Transaction} tx
* @param {ExUnitPrices} ex_unit_prices
* @returns {bigint}
*/
function min_script_fee(tx, ex_unit_prices) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        _assertClass(tx, Transaction);
        _assertClass(ex_unit_prices, ExUnitPrices);
        wasm.min_script_fee(retptr, tx.__wbg_ptr, ex_unit_prices.__wbg_ptr);
        var r0 = getDataViewMemory0().getBigInt64(retptr + 8 * 0, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
        if (r3) {
            throw takeObject(r2);
        }
        return BigInt.asUintN(64, r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
* @param {Transaction} tx
* @param {LinearFee} linear_fee
* @returns {bigint}
*/
function min_no_script_fee(tx, linear_fee) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        _assertClass(tx, Transaction);
        _assertClass(linear_fee, LinearFee);
        wasm.min_no_script_fee(retptr, tx.__wbg_ptr, linear_fee.__wbg_ptr);
        var r0 = getDataViewMemory0().getBigInt64(retptr + 8 * 0, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
        if (r3) {
            throw takeObject(r2);
        }
        return BigInt.asUintN(64, r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
*
* * Calculates the cost of all ref scripts
* * * `total_ref_script_size` - Total size (original, not hashes) of all ref scripts. Duplicate scripts are counted as many times as they occur
*
* @param {Transaction} tx
* @param {LinearFee} linear_fee
* @param {ExUnitPrices} ex_unit_prices
* @param {bigint} total_ref_script_size
* @returns {bigint}
*/
function min_fee(tx, linear_fee, ex_unit_prices, total_ref_script_size) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        _assertClass(tx, Transaction);
        _assertClass(linear_fee, LinearFee);
        _assertClass(ex_unit_prices, ExUnitPrices);
        wasm.min_fee(retptr, tx.__wbg_ptr, linear_fee.__wbg_ptr, ex_unit_prices.__wbg_ptr, total_ref_script_size);
        var r0 = getDataViewMemory0().getBigInt64(retptr + 8 * 0, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
        if (r3) {
            throw takeObject(r2);
        }
        return BigInt.asUintN(64, r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
* @param {TransactionHash} tx_body_hash
* @param {ByronAddress} addr
* @param {LegacyDaedalusPrivateKey} key
* @returns {BootstrapWitness}
*/
function make_daedalus_bootstrap_witness(tx_body_hash, addr, key) {
    _assertClass(tx_body_hash, TransactionHash);
    _assertClass(addr, ByronAddress);
    _assertClass(key, LegacyDaedalusPrivateKey);
    const ret = wasm.make_daedalus_bootstrap_witness(tx_body_hash.__wbg_ptr, addr.__wbg_ptr, key.__wbg_ptr);
    return BootstrapWitness.__wrap(ret);
}

/**
* @param {TransactionHash} tx_body_hash
* @param {ByronAddress} addr
* @param {Bip32PrivateKey} key
* @returns {BootstrapWitness}
*/
function make_icarus_bootstrap_witness(tx_body_hash, addr, key) {
    _assertClass(tx_body_hash, TransactionHash);
    var ptr0 = tx_body_hash.__destroy_into_raw();
    _assertClass(addr, ByronAddress);
    var ptr1 = addr.__destroy_into_raw();
    _assertClass(key, Bip32PrivateKey);
    const ret = wasm.make_icarus_bootstrap_witness(ptr0, ptr1, key.__wbg_ptr);
    return BootstrapWitness.__wrap(ret);
}

/**
* @param {Redeemers} redeemers
* @returns {ExUnits}
*/
function compute_total_ex_units(redeemers) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        _assertClass(redeemers, Redeemers);
        wasm.compute_total_ex_units(retptr, redeemers.__wbg_ptr);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeObject(r1);
        }
        return ExUnits.__wrap(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

let cachedUint16ArrayMemory0 = null;

function getUint16ArrayMemory0() {
    if (cachedUint16ArrayMemory0 === null || cachedUint16ArrayMemory0.byteLength === 0) {
        cachedUint16ArrayMemory0 = new Uint16Array(wasm.memory.buffer);
    }
    return cachedUint16ArrayMemory0;
}

function getArrayU16FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint16ArrayMemory0().subarray(ptr / 2, ptr / 2 + len);
}

function passArray16ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 2, 2) >>> 0;
    getUint16ArrayMemory0().set(arg, ptr / 2);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

let cachedUint32ArrayMemory0 = null;

function getUint32ArrayMemory0() {
    if (cachedUint32ArrayMemory0 === null || cachedUint32ArrayMemory0.byteLength === 0) {
        cachedUint32ArrayMemory0 = new Uint32Array(wasm.memory.buffer);
    }
    return cachedUint32ArrayMemory0;
}

function getArrayU32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}
/**
* @param {AuxiliaryData} auxiliary_data
* @returns {AuxiliaryDataHash}
*/
function hash_auxiliary_data(auxiliary_data) {
    _assertClass(auxiliary_data, AuxiliaryData);
    const ret = wasm.hash_auxiliary_data(auxiliary_data.__wbg_ptr);
    return AuxiliaryDataHash.__wrap(ret);
}

/**
* @param {TransactionBody} tx_body
* @returns {TransactionHash}
*/
function hash_transaction(tx_body) {
    _assertClass(tx_body, TransactionBody);
    const ret = wasm.hash_transaction(tx_body.__wbg_ptr);
    return TransactionHash.__wrap(ret);
}

/**
* @param {PlutusData} plutus_data
* @returns {DatumHash}
*/
function hash_plutus_data(plutus_data) {
    _assertClass(plutus_data, PlutusData);
    const ret = wasm.hash_plutus_data(plutus_data.__wbg_ptr);
    return DatumHash.__wrap(ret);
}

/**
* Calculates the hash for script data (no plutus scripts) if it is necessary.
* Returns None if it was not necessary (no datums/redeemers) to include.
*
* Most users will not directly need this as when using the builders
* it will be invoked for you.
*
* Note: This WASM binding does not work with non-standard witness set
* encodings. If you created the witness set manually this is not an issue
* but for constructing it from deserializing a transaction/witness then
* please use calc_script_data_hash_from_witness()
* @param {Redeemers} redeemers
* @param {CostModels} cost_models
* @param {PlutusDataList | undefined} [datums]
* @returns {ScriptDataHash}
*/
function hash_script_data(redeemers, cost_models, datums) {
    _assertClass(redeemers, Redeemers);
    _assertClass(cost_models, CostModels);
    let ptr0 = 0;
    if (!isLikeNone(datums)) {
        _assertClass(datums, PlutusDataList);
        ptr0 = datums.__destroy_into_raw();
    }
    const ret = wasm.hash_script_data(redeemers.__wbg_ptr, cost_models.__wbg_ptr, ptr0);
    return ScriptDataHash.__wrap(ret);
}

/**
* Calculates the hash for script data (with plutus scripts) if it is necessary.
* Returns None if it was not necessary (no datums/redeemers) to include.
*
* Most users will not directly need this as when using the builders
* it will be invoked for you.
*
* Note: This WASM binding does not work with non-standard witness set
* encodings. If you created the witness set manually this is not an issue
* but for constructing it from deserializing a transaction/witness then
* please use calc_script_data_hash_from_witness()
* @param {Redeemers} redeemers
* @param {PlutusDataList} datums
* @param {CostModels} cost_models
* @param {LanguageList} used_langs
* @returns {ScriptDataHash | undefined}
*/
function calc_script_data_hash(redeemers, datums, cost_models, used_langs) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        _assertClass(redeemers, Redeemers);
        _assertClass(datums, PlutusDataList);
        _assertClass(cost_models, CostModels);
        _assertClass(used_langs, LanguageList);
        wasm.calc_script_data_hash(retptr, redeemers.__wbg_ptr, datums.__wbg_ptr, cost_models.__wbg_ptr, used_langs.__wbg_ptr);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeObject(r1);
        }
        return r0 === 0 ? undefined : ScriptDataHash.__wrap(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
* Calculates the hash for script data from a witness if it is necessary.
* Returns None if it was not necessary (no datums/redeemers) to include.
*
* Most users will not directly need this as when using the builders
* it will be invoked for you.
* @param {TransactionWitnessSet} witnesses
* @param {CostModels} cost_models
* @returns {ScriptDataHash | undefined}
*/
function calc_script_data_hash_from_witness(witnesses, cost_models) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        _assertClass(witnesses, TransactionWitnessSet);
        _assertClass(cost_models, CostModels);
        wasm.calc_script_data_hash_from_witness(retptr, witnesses.__wbg_ptr, cost_models.__wbg_ptr);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeObject(r1);
        }
        return r0 === 0 ? undefined : ScriptDataHash.__wrap(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
* @param {TransactionHash} tx_body_hash
* @param {PrivateKey} sk
* @returns {Vkeywitness}
*/
function make_vkey_witness(tx_body_hash, sk) {
    _assertClass(tx_body_hash, TransactionHash);
    _assertClass(sk, PrivateKey);
    const ret = wasm.make_vkey_witness(tx_body_hash.__wbg_ptr, sk.__wbg_ptr);
    return Vkeywitness.__wrap(ret);
}

/**
* @param {TransactionBody} txbody
* @param {bigint} pool_deposit
* @param {bigint} key_deposit
* @returns {Value}
*/
function get_implicit_input(txbody, pool_deposit, key_deposit) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        _assertClass(txbody, TransactionBody);
        wasm.get_implicit_input(retptr, txbody.__wbg_ptr, pool_deposit, key_deposit);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeObject(r1);
        }
        return Value.__wrap(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
* @param {TransactionBody} txbody
* @param {bigint} pool_deposit
* @param {bigint} key_deposit
* @returns {bigint}
*/
function get_deposit(txbody, pool_deposit, key_deposit) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        _assertClass(txbody, TransactionBody);
        wasm.get_deposit(retptr, txbody.__wbg_ptr, pool_deposit, key_deposit);
        var r0 = getDataViewMemory0().getBigInt64(retptr + 8 * 0, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
        if (r3) {
            throw takeObject(r2);
        }
        return BigInt.asUintN(64, r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
* Converts JSON to Metadata according to MetadataJsonSchema
* @param {string} json
* @param {MetadataJsonSchema} schema
* @returns {TransactionMetadatum}
*/
function encode_json_str_to_metadatum(json, schema) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.encode_json_str_to_metadatum(retptr, ptr0, len0, schema);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeObject(r1);
        }
        return TransactionMetadatum.__wrap(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
* Converts Metadata to JSON according to MetadataJsonSchema
* @param {TransactionMetadatum} metadatum
* @param {MetadataJsonSchema} schema
* @returns {string}
*/
function decode_metadatum_to_json_str(metadatum, schema) {
    let deferred2_0;
    let deferred2_1;
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        _assertClass(metadatum, TransactionMetadatum);
        wasm.decode_metadatum_to_json_str(retptr, metadatum.__wbg_ptr, schema);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
        var ptr1 = r0;
        var len1 = r1;
        if (r3) {
            ptr1 = 0; len1 = 0;
            throw takeObject(r2);
        }
        deferred2_0 = ptr1;
        deferred2_1 = len1;
        return getStringFromWasm0(ptr1, len1);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
* @param {string} json
* @param {CardanoNodePlutusDatumSchema} schema
* @returns {PlutusData}
*/
function encode_json_str_to_plutus_datum(json, schema) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.encode_json_str_to_plutus_datum(retptr, ptr0, len0, schema);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeObject(r1);
        }
        return PlutusData.__wrap(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
* @param {PlutusData} datum
* @param {CardanoNodePlutusDatumSchema} schema
* @returns {string}
*/
function decode_plutus_datum_to_json_str(datum, schema) {
    let deferred2_0;
    let deferred2_1;
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        _assertClass(datum, PlutusData);
        wasm.decode_plutus_datum_to_json_str(retptr, datum.__wbg_ptr, schema);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
        var ptr1 = r0;
        var len1 = r1;
        if (r3) {
            ptr1 = 0; len1 = 0;
            throw takeObject(r2);
        }
        deferred2_0 = ptr1;
        deferred2_1 = len1;
        return getStringFromWasm0(ptr1, len1);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
* @param {TransactionOutput} output
* @param {bigint} coins_per_utxo_byte
* @returns {bigint}
*/
function min_ada_required(output, coins_per_utxo_byte) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        _assertClass(output, TransactionOutput);
        wasm.min_ada_required(retptr, output.__wbg_ptr, coins_per_utxo_byte);
        var r0 = getDataViewMemory0().getBigInt64(retptr + 8 * 0, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
        if (r3) {
            throw takeObject(r2);
        }
        return BigInt.asUintN(64, r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

let cachedBigInt64ArrayMemory0 = null;

function getBigInt64ArrayMemory0() {
    if (cachedBigInt64ArrayMemory0 === null || cachedBigInt64ArrayMemory0.byteLength === 0) {
        cachedBigInt64ArrayMemory0 = new BigInt64Array(wasm.memory.buffer);
    }
    return cachedBigInt64ArrayMemory0;
}

function getArrayI64FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getBigInt64ArrayMemory0().subarray(ptr / 8, ptr / 8 + len);
}

let cachedBigUint64ArrayMemory0 = null;

function getBigUint64ArrayMemory0() {
    if (cachedBigUint64ArrayMemory0 === null || cachedBigUint64ArrayMemory0.byteLength === 0) {
        cachedBigUint64ArrayMemory0 = new BigUint64Array(wasm.memory.buffer);
    }
    return cachedBigUint64ArrayMemory0;
}

function passArray64ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 8, 8) >>> 0;
    getBigUint64ArrayMemory0().set(arg, ptr / 8);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function getArrayU64FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getBigUint64ArrayMemory0().subarray(ptr / 8, ptr / 8 + len);
}
/**
*/
const ChangeSelectionAlgo = Object.freeze({ Default:0,"0":"Default", });
/**
* Which version of the CIP25 spec to use. See CIP25 for details.
* This will change how things are encoded but for the most part contains
* the same information.
*/
const CIP25Version = Object.freeze({
/**
* Initial version of CIP25 with only string (utf8) asset names allowed.
*/
V1:0,"0":"V1",
/**
* Second version of CIP25. Supports any type of asset names.
*/
V2:1,"1":"V2", });
/**
*/
const PlutusDataKind = Object.freeze({ ConstrPlutusData:0,"0":"ConstrPlutusData",Map:1,"1":"Map",List:2,"2":"List",Integer:3,"3":"Integer",Bytes:4,"4":"Bytes", });
/**
*/
const GovActionKind = Object.freeze({ ParameterChangeAction:0,"0":"ParameterChangeAction",HardForkInitiationAction:1,"1":"HardForkInitiationAction",TreasuryWithdrawalsAction:2,"2":"TreasuryWithdrawalsAction",NoConfidence:3,"3":"NoConfidence",UpdateCommittee:4,"4":"UpdateCommittee",NewConstitution:5,"5":"NewConstitution",InfoAction:6,"6":"InfoAction", });
/**
*/
const ScriptKind = Object.freeze({ Native:0,"0":"Native",PlutusV1:1,"1":"PlutusV1",PlutusV2:2,"2":"PlutusV2",PlutusV3:3,"3":"PlutusV3", });
/**
*/
const Vote = Object.freeze({ No:0,"0":"No",Yes:1,"1":"Yes",Abstain:2,"2":"Abstain", });
/**
*/
const Language = Object.freeze({ PlutusV1:0,"0":"PlutusV1",PlutusV2:1,"1":"PlutusV2",PlutusV3:2,"2":"PlutusV3", });
/**
* Careful: this enum doesn't include the network ID part of the header
* ex: base address isn't 0b0000_0000 but instead 0b0000
* Use `header_matches_kind` if you don't want to implement the bitwise operators yourself
*/
const AddressHeaderKind = Object.freeze({ BasePaymentKeyStakeKey:0,"0":"BasePaymentKeyStakeKey",BasePaymentScriptStakeKey:1,"1":"BasePaymentScriptStakeKey",BasePaymentKeyStakeScript:2,"2":"BasePaymentKeyStakeScript",BasePaymentScriptStakeScript:3,"3":"BasePaymentScriptStakeScript",PointerKey:4,"4":"PointerKey",PointerScript:5,"5":"PointerScript",EnterpriseKey:6,"6":"EnterpriseKey",EnterpriseScript:7,"7":"EnterpriseScript",Byron:8,"8":"Byron",RewardKey:14,"14":"RewardKey",RewardScript:15,"15":"RewardScript", });
/**
*/
const AuxiliaryDataKind = Object.freeze({ Shelley:0,"0":"Shelley",ShelleyMA:1,"1":"ShelleyMA",Conway:2,"2":"Conway", });
/**
*/
const DatumOptionKind = Object.freeze({ Hash:0,"0":"Hash",Datum:1,"1":"Datum", });
/**
*/
const NonceKind = Object.freeze({ Identity:0,"0":"Identity",Hash:1,"1":"Hash", });
/**
*/
const DRepKind = Object.freeze({ Key:0,"0":"Key",Script:1,"1":"Script",AlwaysAbstain:2,"2":"AlwaysAbstain",AlwaysNoConfidence:3,"3":"AlwaysNoConfidence", });
/**
*/
const ChunkableStringKind = Object.freeze({ Single:0,"0":"Single",Chunked:1,"1":"Chunked", });
/**
*/
const RelayKind = Object.freeze({ SingleHostAddr:0,"0":"SingleHostAddr",SingleHostName:1,"1":"SingleHostName",MultiHostName:2,"2":"MultiHostName", });
/**
*/
const RedeemersKind = Object.freeze({ ArrLegacyRedeemer:0,"0":"ArrLegacyRedeemer",MapRedeemerKeyToRedeemerVal:1,"1":"MapRedeemerKeyToRedeemerVal", });
/**
*/
const CoinSelectionStrategyCIP2 = Object.freeze({
/**
* Performs CIP2's Largest First ada-only selection. Will error if outputs contain non-ADA assets.
*/
LargestFirst:0,"0":"LargestFirst",
/**
* Performs CIP2's Random Improve ada-only selection. Will error if outputs contain non-ADA assets.
*/
RandomImprove:1,"1":"RandomImprove",
/**
* Same as LargestFirst, but before adding ADA, will insert by largest-first for each asset type.
*/
LargestFirstMultiAsset:2,"2":"LargestFirstMultiAsset",
/**
* Same as RandomImprove, but before adding ADA, will insert by random-improve for each asset type.
*/
RandomImproveMultiAsset:3,"3":"RandomImproveMultiAsset", });
/**
*/
const CredentialKind = Object.freeze({ PubKey:0,"0":"PubKey",Script:1,"1":"Script", });
/**
*/
const AddressKind = Object.freeze({ Base:0,"0":"Base",Ptr:1,"1":"Ptr",Enterprise:2,"2":"Enterprise",Reward:3,"3":"Reward",Byron:4,"4":"Byron", });
/**
*/
const RedeemerTag = Object.freeze({ Spend:0,"0":"Spend",Mint:1,"1":"Mint",Cert:2,"2":"Cert",Reward:3,"3":"Reward",Voting:4,"4":"Voting",Proposing:5,"5":"Proposing", });
/**
*/
const ByronAddrType = Object.freeze({ PublicKey:0,"0":"PublicKey",Script:1,"1":"Script",Redeem:2,"2":"Redeem", });
/**
*/
const TransactionMetadatumKind = Object.freeze({ Map:0,"0":"Map",List:1,"1":"List",Int:2,"2":"Int",Bytes:3,"3":"Bytes",Text:4,"4":"Text", });
/**
*/
const SpendingDataKind = Object.freeze({ SpendingDataPubKey:0,"0":"SpendingDataPubKey",SpendingDataScript:1,"1":"SpendingDataScript",SpendingDataRedeem:2,"2":"SpendingDataRedeem", });
/**
*/
const MetadataJsonSchema = Object.freeze({ NoConversions:0,"0":"NoConversions",BasicConversions:1,"1":"BasicConversions",DetailedSchema:2,"2":"DetailedSchema", });
/**
*/
const NativeScriptKind = Object.freeze({ ScriptPubkey:0,"0":"ScriptPubkey",ScriptAll:1,"1":"ScriptAll",ScriptAny:2,"2":"ScriptAny",ScriptNOfK:3,"3":"ScriptNOfK",ScriptInvalidBefore:4,"4":"ScriptInvalidBefore",ScriptInvalidHereafter:5,"5":"ScriptInvalidHereafter", });
/**
*/
const TransactionOutputKind = Object.freeze({ AlonzoFormatTxOut:0,"0":"AlonzoFormatTxOut",ConwayFormatTxOut:1,"1":"ConwayFormatTxOut", });
/**
*/
const VoterKind = Object.freeze({ ConstitutionalCommitteeHotKeyHash:0,"0":"ConstitutionalCommitteeHotKeyHash",ConstitutionalCommitteeHotScriptHash:1,"1":"ConstitutionalCommitteeHotScriptHash",DRepKeyHash:2,"2":"DRepKeyHash",DRepScriptHash:3,"3":"DRepScriptHash",StakingPoolKeyHash:4,"4":"StakingPoolKeyHash", });
/**
*/
const DelegationDistributionKind = Object.freeze({ Weighted:0,"0":"Weighted",Legacy:1,"1":"Legacy", });
/**
*/
const StakeDistributionKind = Object.freeze({ SingleKey:0,"0":"SingleKey",BootstrapEra:1,"1":"BootstrapEra", });
/**
* JSON <-> PlutusData conversion schemas.
* Follows ScriptDataJsonSchema in cardano-cli defined at:
* https://github.com/input-output-hk/cardano-node/blob/master/cardano-api/src/Cardano/Api/ScriptData.hs#L254
*
* All methods here have the following restrictions due to limitations on dependencies:
* * JSON numbers above u64::MAX (positive) or below i64::MIN (negative) will throw errors
* * Hex strings for bytes don't accept odd-length (half-byte) strings.
*      cardano-cli seems to support these however but it seems to be different than just 0-padding
*      on either side when tested so proceed with caution
*/
const CardanoNodePlutusDatumSchema = Object.freeze({
/**
* ScriptDataJsonNoSchema in cardano-node.
*
* This is the format used by --script-data-value in cardano-cli
* This tries to accept most JSON but does not support the full spectrum of Plutus datums.
* From JSON:
* * null/true/false/floats NOT supported
* * strings starting with 0x are treated as hex bytes. All other strings are encoded as their utf8 bytes.
* To JSON:
* * ConstrPlutusData not supported in ANY FORM (neither keys nor values)
* * Lists not supported in keys
* * Maps not supported in keys
*/
BasicConversions:0,"0":"BasicConversions",
/**
* ScriptDataJsonDetailedSchema in cardano-node.
*
* This is the format used by --script-data-file in cardano-cli
* This covers almost all (only minor exceptions) Plutus datums, but the JSON must conform to a strict schema.
* The schema specifies that ALL keys and ALL values must be contained in a JSON map with 2 cases:
* 1. For ConstrPlutusData there must be two fields "constructor" contianing a number and "fields" containing its fields
*    e.g. { "constructor": 2, "fields": [{"int": 2}, {"list": [{"bytes": "CAFEF00D"}]}]}
* 2. For all other cases there must be only one field named "int", "bytes", "list" or "map"
*    BigInteger's value is a JSON number e.g. {"int": 100}
*    Bytes' value is a hex string representing the bytes WITHOUT any prefix e.g. {"bytes": "CAFEF00D"}
*    Lists' value is a JSON list of its elements encoded via the same schema e.g. {"list": [{"bytes": "CAFEF00D"}]}
*    Maps' value is a JSON list of objects, one for each key-value pair in the map, with keys "k" and "v"
*          respectively with their values being the plutus datum encoded via this same schema
*          e.g. {"map": [
*              {"k": {"int": 2}, "v": {"int": 5}},
*              {"k": {"map": [{"k": {"list": [{"int": 1}]}, "v": {"bytes": "FF03"}}]}, "v": {"list": []}}
*          ]}
* From JSON:
* * null/true/false/floats NOT supported
* * the JSON must conform to a very specific schema
* To JSON:
* * all Plutus datums should be fully supported outside of the integer range limitations outlined above.
*/
DetailedSchema:1,"1":"DetailedSchema", });
/**
*/
const CertificateKind = Object.freeze({ StakeRegistration:0,"0":"StakeRegistration",StakeDeregistration:1,"1":"StakeDeregistration",StakeDelegation:2,"2":"StakeDelegation",PoolRegistration:3,"3":"PoolRegistration",PoolRetirement:4,"4":"PoolRetirement",RegCert:5,"5":"RegCert",UnregCert:6,"6":"UnregCert",VoteDelegCert:7,"7":"VoteDelegCert",StakeVoteDelegCert:8,"8":"StakeVoteDelegCert",StakeRegDelegCert:9,"9":"StakeRegDelegCert",VoteRegDelegCert:10,"10":"VoteRegDelegCert",StakeVoteRegDelegCert:11,"11":"StakeVoteRegDelegCert",AuthCommitteeHotCert:12,"12":"AuthCommitteeHotCert",ResignCommitteeColdCert:13,"13":"ResignCommitteeColdCert",RegDrepCert:14,"14":"RegDrepCert",UnregDrepCert:15,"15":"UnregDrepCert",UpdateDrepCert:16,"16":"UpdateDrepCert", });

const AddrAttributesFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_addrattributes_free(ptr >>> 0, 1));
/**
*/
class AddrAttributes {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AddrAttributes.prototype);
        obj.__wbg_ptr = ptr;
        AddrAttributesFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AddrAttributesFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_addrattributes_free(ptr, 0);
    }
    /**
    * @param {HDAddressPayload | undefined} [hdap]
    * @param {ProtocolMagic | undefined} [protocol_magic]
    * @returns {AddrAttributes}
    */
    static new_bootstrap_era(hdap, protocol_magic) {
        let ptr0 = 0;
        if (!isLikeNone(hdap)) {
            _assertClass(hdap, HDAddressPayload);
            ptr0 = hdap.__destroy_into_raw();
        }
        let ptr1 = 0;
        if (!isLikeNone(protocol_magic)) {
            _assertClass(protocol_magic, ProtocolMagic);
            ptr1 = protocol_magic.__destroy_into_raw();
        }
        const ret = wasm.addrattributes_new_bootstrap_era(ptr0, ptr1);
        return AddrAttributes.__wrap(ret);
    }
    /**
    * @param {Bip32PublicKey} pubk
    * @param {HDAddressPayload | undefined} hdap
    * @param {ProtocolMagic} protocol_magic
    * @returns {AddrAttributes}
    */
    static new_single_key(pubk, hdap, protocol_magic) {
        _assertClass(pubk, Bip32PublicKey);
        let ptr0 = 0;
        if (!isLikeNone(hdap)) {
            _assertClass(hdap, HDAddressPayload);
            ptr0 = hdap.__destroy_into_raw();
        }
        _assertClass(protocol_magic, ProtocolMagic);
        var ptr1 = protocol_magic.__destroy_into_raw();
        const ret = wasm.addrattributes_new_single_key(pubk.__wbg_ptr, ptr0, ptr1);
        return AddrAttributes.__wrap(ret);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes.
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.addrattributes_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {AddrAttributes}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.addrattributes_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AddrAttributes.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.addrattributes_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {AddrAttributes}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.addrattributes_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AddrAttributes.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {StakeDistribution} stake_distribution
    */
    set_stake_distribution(stake_distribution) {
        _assertClass(stake_distribution, StakeDistribution);
        wasm.addrattributes_set_stake_distribution(this.__wbg_ptr, stake_distribution.__wbg_ptr);
    }
    /**
    * @returns {StakeDistribution | undefined}
    */
    stake_distribution() {
        const ret = wasm.addrattributes_stake_distribution(this.__wbg_ptr);
        return ret === 0 ? undefined : StakeDistribution.__wrap(ret);
    }
    /**
    * @param {HDAddressPayload} derivation_path
    */
    set_derivation_path(derivation_path) {
        _assertClass(derivation_path, HDAddressPayload);
        wasm.addrattributes_set_derivation_path(this.__wbg_ptr, derivation_path.__wbg_ptr);
    }
    /**
    * @returns {HDAddressPayload | undefined}
    */
    derivation_path() {
        const ret = wasm.addrattributes_derivation_path(this.__wbg_ptr);
        return ret === 0 ? undefined : HDAddressPayload.__wrap(ret);
    }
    /**
    * @param {ProtocolMagic} protocol_magic
    */
    set_protocol_magic(protocol_magic) {
        _assertClass(protocol_magic, ProtocolMagic);
        wasm.addrattributes_set_protocol_magic(this.__wbg_ptr, protocol_magic.__wbg_ptr);
    }
    /**
    * @returns {ProtocolMagic | undefined}
    */
    protocol_magic() {
        const ret = wasm.addrattributes_protocol_magic(this.__wbg_ptr);
        return ret === 0 ? undefined : ProtocolMagic.__wrap(ret);
    }
    /**
    * @returns {AddrAttributes}
    */
    static new() {
        const ret = wasm.addrattributes_new();
        return AddrAttributes.__wrap(ret);
    }
}

const AddressFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_address_free(ptr >>> 0, 1));
/**
*/
class Address {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Address.prototype);
        obj.__wbg_ptr = ptr;
        AddressFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AddressFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_address_free(ptr, 0);
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.address_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.address_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Address}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.address_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Address.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * header has 4 bits addr type discrim then 4 bits network discrim.
    * Copied from shelley.cddl:
    *
    * base address
    * bits 7-6: 00
    * bit 5: stake cred is keyhash/scripthash
    * bit 4: payment cred is keyhash/scripthash
    * bits 3-0: network id
    *
    * pointer address
    * bits 7-5: 010
    * bit 4: payment cred is keyhash/scripthash
    * bits 3-0: network id
    *
    * enterprise address
    * bits 7-5: 010
    * bit 4: payment cred is keyhash/scripthash
    * bits 3-0: network id
    *
    * reward addresses:
    * bits 7-5: 111
    * bit 4: credential is keyhash/scripthash
    * bits 3-0: network id
    *
    * byron addresses:
    * bits 7-4: 1000
    * bits 3-0: unrelated data (recall: no network ID in Byron addresses)
    * @returns {number}
    */
    header() {
        const ret = wasm.address_header(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} header
    * @param {AddressHeaderKind} kind
    * @returns {boolean}
    */
    static header_matches_kind(header, kind) {
        const ret = wasm.address_header_matches_kind(header, kind);
        return ret !== 0;
    }
    /**
    * @param {string | undefined} [prefix]
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            var ptr0 = isLikeNone(prefix) ? 0 : passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len0 = WASM_VECTOR_LEN;
            wasm.address_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech_str
    * @returns {Address}
    */
    static from_bech32(bech_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.address_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Address.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *     * Note: bech32-encoded Byron addresses will also pass validation here
    *
    * @param {string} bech_str
    * @returns {boolean}
    */
    static is_valid_bech32(bech_str) {
        const ptr0 = passStringToWasm0(bech_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.address_is_valid_bech32(ptr0, len0);
        return ret !== 0;
    }
    /**
    * @param {string} bech_str
    * @returns {boolean}
    */
    static is_valid(bech_str) {
        const ptr0 = passStringToWasm0(bech_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.address_is_valid(ptr0, len0);
        return ret !== 0;
    }
    /**
    * @returns {number}
    */
    network_id() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.address_network_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Note: by convention, the key inside reward addresses are considered payment credentials
    * @returns {Credential | undefined}
    */
    payment_cred() {
        const ret = wasm.address_payment_cred(this.__wbg_ptr);
        return ret === 0 ? undefined : Credential.__wrap(ret);
    }
    /**
    * Note: by convention, the key inside reward addresses are NOT considered staking credentials
    * Note: None is returned pointer addresses as the chain history is required to resolve its associated cred
    * @returns {Credential | undefined}
    */
    staking_cred() {
        const ret = wasm.address_staking_cred(this.__wbg_ptr);
        return ret === 0 ? undefined : Credential.__wrap(ret);
    }
    /**
    * @returns {AddressKind}
    */
    kind() {
        const ret = wasm.address_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.address_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} data
    * @returns {Address}
    */
    static from_raw_bytes(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(data, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.address_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Address.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.address_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} hex
    * @returns {Address}
    */
    static from_hex(hex) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(hex, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.address_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Address.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const AddressContentFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_addresscontent_free(ptr >>> 0, 1));
/**
*/
class AddressContent {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AddressContent.prototype);
        obj.__wbg_ptr = ptr;
        AddressContentFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AddressContentFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_addresscontent_free(ptr, 0);
    }
    /**
    * @param {ByronAddrType} addr_type
    * @param {SpendingData} spending_data
    * @param {AddrAttributes} attributes
    * @returns {AddressContent}
    */
    static hash_and_create(addr_type, spending_data, attributes) {
        _assertClass(spending_data, SpendingData);
        _assertClass(attributes, AddrAttributes);
        const ret = wasm.addresscontent_hash_and_create(addr_type, spending_data.__wbg_ptr, attributes.__wbg_ptr);
        return AddressContent.__wrap(ret);
    }
    /**
    * @param {PublicKey} pubkey
    * @param {ProtocolMagic | undefined} [protocol_magic]
    * @returns {AddressContent}
    */
    static new_redeem(pubkey, protocol_magic) {
        _assertClass(pubkey, PublicKey);
        let ptr0 = 0;
        if (!isLikeNone(protocol_magic)) {
            _assertClass(protocol_magic, ProtocolMagic);
            ptr0 = protocol_magic.__destroy_into_raw();
        }
        const ret = wasm.addresscontent_new_redeem(pubkey.__wbg_ptr, ptr0);
        return AddressContent.__wrap(ret);
    }
    /**
    * @param {Bip32PublicKey} xpub
    * @param {ProtocolMagic | undefined} [protocol_magic]
    * @returns {AddressContent}
    */
    static new_simple(xpub, protocol_magic) {
        _assertClass(xpub, Bip32PublicKey);
        let ptr0 = 0;
        if (!isLikeNone(protocol_magic)) {
            _assertClass(protocol_magic, ProtocolMagic);
            ptr0 = protocol_magic.__destroy_into_raw();
        }
        const ret = wasm.addresscontent_new_simple(xpub.__wbg_ptr, ptr0);
        return AddressContent.__wrap(ret);
    }
    /**
    * Do we want to remove this or keep it for people who were using old Byron code?
    * @returns {ByronAddress}
    */
    to_address() {
        const ret = wasm.addresscontent_to_address(this.__wbg_ptr);
        return ByronAddress.__wrap(ret);
    }
    /**
    * returns the byron protocol magic embedded in the address, or mainnet id if none is present
    * note: for bech32 addresses, you need to use network_id instead
    * @returns {ProtocolMagic}
    */
    byron_protocol_magic() {
        const ret = wasm.addresscontent_byron_protocol_magic(this.__wbg_ptr);
        return ProtocolMagic.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    network_id() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.addresscontent_network_id(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Bip32PublicKey} key
    * @param {ProtocolMagic} protocol_magic
    * @returns {AddressContent}
    */
    static icarus_from_key(key, protocol_magic) {
        _assertClass(key, Bip32PublicKey);
        _assertClass(protocol_magic, ProtocolMagic);
        const ret = wasm.addresscontent_icarus_from_key(key.__wbg_ptr, protocol_magic.__wbg_ptr);
        return AddressContent.__wrap(ret);
    }
    /**
    * Check if the Addr can be reconstructed with a specific xpub
    * @param {Bip32PublicKey} xpub
    * @returns {boolean}
    */
    identical_with_pubkey(xpub) {
        _assertClass(xpub, Bip32PublicKey);
        const ret = wasm.addresscontent_identical_with_pubkey(this.__wbg_ptr, xpub.__wbg_ptr);
        return ret !== 0;
    }
    /**
    *
    *             * Serialize this type to CBOR bytes.
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.addresscontent_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {AddressContent}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.addresscontent_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AddressContent.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.addresscontent_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {AddressContent}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.addresscontent_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AddressContent.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {AddressId}
    */
    address_id() {
        const ret = wasm.addresscontent_address_id(this.__wbg_ptr);
        return AddressId.__wrap(ret);
    }
    /**
    * @returns {AddrAttributes}
    */
    addr_attributes() {
        const ret = wasm.addresscontent_addr_attributes(this.__wbg_ptr);
        return AddrAttributes.__wrap(ret);
    }
    /**
    * @returns {ByronAddrType}
    */
    addr_type() {
        const ret = wasm.addresscontent_addr_type(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {AddressId} address_id
    * @param {AddrAttributes} addr_attributes
    * @param {ByronAddrType} addr_type
    * @returns {AddressContent}
    */
    static new(address_id, addr_attributes, addr_type) {
        _assertClass(address_id, AddressId);
        _assertClass(addr_attributes, AddrAttributes);
        const ret = wasm.addresscontent_new(address_id.__wbg_ptr, addr_attributes.__wbg_ptr, addr_type);
        return AddressContent.__wrap(ret);
    }
}

const AddressIdFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_addressid_free(ptr >>> 0, 1));
/**
*/
class AddressId {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AddressId.prototype);
        obj.__wbg_ptr = ptr;
        AddressIdFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AddressIdFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_addressid_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.addressid_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {AddressId}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.addressid_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AddressId.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.addressid_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {AddressId}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.addressid_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AddressId.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.addressid_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {AddressId}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.addressid_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AddressId.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {ByronAddrType} addr_type
    * @param {SpendingData} spending_data
    * @param {AddrAttributes} attrs
    * @returns {AddressId}
    */
    static new(addr_type, spending_data, attrs) {
        _assertClass(spending_data, SpendingData);
        _assertClass(attrs, AddrAttributes);
        const ret = wasm.addressid_new(addr_type, spending_data.__wbg_ptr, attrs.__wbg_ptr);
        return AddressId.__wrap(ret);
    }
}

const AlonzoFormatTxOutFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_alonzoformattxout_free(ptr >>> 0, 1));
/**
*/
class AlonzoFormatTxOut {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AlonzoFormatTxOut.prototype);
        obj.__wbg_ptr = ptr;
        AlonzoFormatTxOutFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AlonzoFormatTxOutFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_alonzoformattxout_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.alonzoformattxout_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.alonzoformattxout_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {AlonzoFormatTxOut}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.alonzoformattxout_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AlonzoFormatTxOut.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.alonzoformattxout_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.alonzoformattxout_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {AlonzoFormatTxOut}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.alonzoformattxout_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AlonzoFormatTxOut.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.alonzoformattxout_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.alonzoformattxout_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {AlonzoFormatTxOut}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.alonzoformattxout_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AlonzoFormatTxOut.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Address}
    */
    address() {
        const ret = wasm.alonzoformattxout_address(this.__wbg_ptr);
        return Address.__wrap(ret);
    }
    /**
    * @returns {Value}
    */
    amount() {
        const ret = wasm.alonzoformattxout_amount(this.__wbg_ptr);
        return Value.__wrap(ret);
    }
    /**
    * @param {DatumHash} datum_hash
    */
    set_datum_hash(datum_hash) {
        _assertClass(datum_hash, DatumHash);
        wasm.alonzoformattxout_set_datum_hash(this.__wbg_ptr, datum_hash.__wbg_ptr);
    }
    /**
    * @returns {DatumHash | undefined}
    */
    datum_hash() {
        const ret = wasm.alonzoformattxout_datum_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : DatumHash.__wrap(ret);
    }
    /**
    * @param {Address} address
    * @param {Value} amount
    * @returns {AlonzoFormatTxOut}
    */
    static new(address, amount) {
        _assertClass(address, Address);
        _assertClass(amount, Value);
        const ret = wasm.alonzoformattxout_new(address.__wbg_ptr, amount.__wbg_ptr);
        return AlonzoFormatTxOut.__wrap(ret);
    }
}

const AnchorFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_anchor_free(ptr >>> 0, 1));
/**
*/
class Anchor {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Anchor.prototype);
        obj.__wbg_ptr = ptr;
        AnchorFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AnchorFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_anchor_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.anchor_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.anchor_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Anchor}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.anchor_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Anchor.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.anchor_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.anchor_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Anchor}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.anchor_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Anchor.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.anchor_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.anchor_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Anchor}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.anchor_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Anchor.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Url}
    */
    anchor_url() {
        const ret = wasm.anchor_anchor_url(this.__wbg_ptr);
        return Url.__wrap(ret);
    }
    /**
    * @returns {AnchorDocHash}
    */
    anchor_doc_hash() {
        const ret = wasm.anchor_anchor_doc_hash(this.__wbg_ptr);
        return AnchorDocHash.__wrap(ret);
    }
    /**
    * @param {Url} anchor_url
    * @param {AnchorDocHash} anchor_doc_hash
    * @returns {Anchor}
    */
    static new(anchor_url, anchor_doc_hash) {
        _assertClass(anchor_url, Url);
        _assertClass(anchor_doc_hash, AnchorDocHash);
        const ret = wasm.anchor_new(anchor_url.__wbg_ptr, anchor_doc_hash.__wbg_ptr);
        return Anchor.__wrap(ret);
    }
}

const AnchorDocHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_anchordochash_free(ptr >>> 0, 1));
/**
*/
class AnchorDocHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AnchorDocHash.prototype);
        obj.__wbg_ptr = ptr;
        AnchorDocHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AnchorDocHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_anchordochash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.anchordochash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {AnchorDocHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.anchordochash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AnchorDocHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.anchordochash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {AnchorDocHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.anchordochash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AnchorDocHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.anchordochash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {AnchorDocHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.anchordochash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AnchorDocHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const AssetNameFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_assetname_free(ptr >>> 0, 1));
/**
*/
class AssetName {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AssetName.prototype);
        obj.__wbg_ptr = ptr;
        AssetNameFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AssetNameFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_assetname_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.assetname_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.assetname_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {AssetName}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.assetname_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AssetName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.assetname_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.assetname_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {AssetName}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.assetname_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AssetName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.assetname_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.assetname_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {AssetName}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.assetname_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AssetName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *     * Create an AssetName from utf8 string. 64 byte (not char!) maximum.
    *
    * @param {string} utf8_str
    * @returns {AssetName}
    */
    static from_str(utf8_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(utf8_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.assetname_from_str(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AssetName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *     * AssetName as a utf8 string if it's possible. Will error if the asset is not utf8
    *
    * @returns {string}
    */
    to_str() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.assetname_to_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.assetname_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {AssetName}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.assetname_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AssetName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.assetname_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {AssetName}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.assetname_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AssetName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const AssetNameListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_assetnamelist_free(ptr >>> 0, 1));
/**
*/
class AssetNameList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AssetNameList.prototype);
        obj.__wbg_ptr = ptr;
        AssetNameListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AssetNameListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_assetnamelist_free(ptr, 0);
    }
    /**
    * @returns {AssetNameList}
    */
    static new() {
        const ret = wasm.assetnamelist_new();
        return AssetNameList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.assetnamelist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {AssetName}
    */
    get(index) {
        const ret = wasm.assetnamelist_get(this.__wbg_ptr, index);
        return AssetName.__wrap(ret);
    }
    /**
    * @param {AssetName} elem
    */
    add(elem) {
        _assertClass(elem, AssetName);
        wasm.assetnamelist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const AuthCommitteeHotCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_authcommitteehotcert_free(ptr >>> 0, 1));
/**
*/
class AuthCommitteeHotCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AuthCommitteeHotCert.prototype);
        obj.__wbg_ptr = ptr;
        AuthCommitteeHotCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AuthCommitteeHotCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_authcommitteehotcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.authcommitteehotcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.authcommitteehotcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {AuthCommitteeHotCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.authcommitteehotcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AuthCommitteeHotCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.authcommitteehotcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.authcommitteehotcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {AuthCommitteeHotCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.authcommitteehotcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AuthCommitteeHotCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.authcommitteehotcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.authcommitteehotcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {AuthCommitteeHotCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.authcommitteehotcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AuthCommitteeHotCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    committee_cold_credential() {
        const ret = wasm.authcommitteehotcert_committee_cold_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {Credential}
    */
    committee_hot_credential() {
        const ret = wasm.authcommitteehotcert_committee_hot_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @param {Credential} committee_cold_credential
    * @param {Credential} committee_hot_credential
    * @returns {AuthCommitteeHotCert}
    */
    static new(committee_cold_credential, committee_hot_credential) {
        _assertClass(committee_cold_credential, Credential);
        _assertClass(committee_hot_credential, Credential);
        const ret = wasm.authcommitteehotcert_new(committee_cold_credential.__wbg_ptr, committee_hot_credential.__wbg_ptr);
        return AuthCommitteeHotCert.__wrap(ret);
    }
}

const AuxiliaryDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_auxiliarydata_free(ptr >>> 0, 1));
/**
*/
class AuxiliaryData {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AuxiliaryData.prototype);
        obj.__wbg_ptr = ptr;
        AuxiliaryDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AuxiliaryDataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_auxiliarydata_free(ptr, 0);
    }
    /**
    * @returns {AuxiliaryData}
    */
    static new() {
        const ret = wasm.auxiliarydata_new();
        return AuxiliaryData.__wrap(ret);
    }
    /**
    * @returns {Metadata | undefined}
    */
    metadata() {
        const ret = wasm.auxiliarydata_metadata(this.__wbg_ptr);
        return ret === 0 ? undefined : Metadata.__wrap(ret);
    }
    /**
    * @returns {NativeScriptList | undefined}
    */
    native_scripts() {
        const ret = wasm.auxiliarydata_native_scripts(this.__wbg_ptr);
        return ret === 0 ? undefined : NativeScriptList.__wrap(ret);
    }
    /**
    * @returns {PlutusV1ScriptList | undefined}
    */
    plutus_v1_scripts() {
        const ret = wasm.auxiliarydata_plutus_v1_scripts(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV1ScriptList.__wrap(ret);
    }
    /**
    * @returns {PlutusV2ScriptList | undefined}
    */
    plutus_v2_scripts() {
        const ret = wasm.auxiliarydata_plutus_v2_scripts(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV2ScriptList.__wrap(ret);
    }
    /**
    * Warning: overwrites any conflicting metadatum labels present
    * @param {Metadata} other
    */
    add_metadata(other) {
        _assertClass(other, Metadata);
        wasm.auxiliarydata_add_metadata(this.__wbg_ptr, other.__wbg_ptr);
    }
    /**
    * Warning: does not check for duplicates and may migrate eras
    * @param {NativeScriptList} scripts
    */
    add_native_scripts(scripts) {
        _assertClass(scripts, NativeScriptList);
        wasm.auxiliarydata_add_native_scripts(this.__wbg_ptr, scripts.__wbg_ptr);
    }
    /**
    * Warning: does not check for duplicates and may migrate eras
    * @param {PlutusV1ScriptList} scripts
    */
    add_plutus_v1_scripts(scripts) {
        _assertClass(scripts, PlutusV1ScriptList);
        wasm.auxiliarydata_add_plutus_v1_scripts(this.__wbg_ptr, scripts.__wbg_ptr);
    }
    /**
    * Warning: does not check for duplicates and may migrate eras
    * @param {PlutusV2ScriptList} scripts
    */
    add_plutus_v2_scripts(scripts) {
        _assertClass(scripts, PlutusV2ScriptList);
        wasm.auxiliarydata_add_plutus_v2_scripts(this.__wbg_ptr, scripts.__wbg_ptr);
    }
    /**
    * Adds everything present in other to self
    * May change the era the aux data is in if necessary
    * Warning: overwrites any metadatum labels present
    * also does not check for duplicates in scripts
    * @param {AuxiliaryData} other
    */
    add(other) {
        _assertClass(other, AuxiliaryData);
        wasm.auxiliarydata_add(this.__wbg_ptr, other.__wbg_ptr);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.auxiliarydata_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.auxiliarydata_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {AuxiliaryData}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.auxiliarydata_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AuxiliaryData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.auxiliarydata_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.auxiliarydata_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {AuxiliaryData}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.auxiliarydata_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AuxiliaryData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.auxiliarydata_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.auxiliarydata_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {AuxiliaryData}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.auxiliarydata_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AuxiliaryData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Metadata} shelley
    * @returns {AuxiliaryData}
    */
    static new_shelley(shelley) {
        _assertClass(shelley, Metadata);
        const ret = wasm.auxiliarydata_new_shelley(shelley.__wbg_ptr);
        return AuxiliaryData.__wrap(ret);
    }
    /**
    * @param {ShelleyMAFormatAuxData} shelley_ma
    * @returns {AuxiliaryData}
    */
    static new_shelley_ma(shelley_ma) {
        _assertClass(shelley_ma, ShelleyMAFormatAuxData);
        const ret = wasm.auxiliarydata_new_shelley_ma(shelley_ma.__wbg_ptr);
        return AuxiliaryData.__wrap(ret);
    }
    /**
    * @param {ConwayFormatAuxData} conway
    * @returns {AuxiliaryData}
    */
    static new_conway(conway) {
        _assertClass(conway, ConwayFormatAuxData);
        const ret = wasm.auxiliarydata_new_conway(conway.__wbg_ptr);
        return AuxiliaryData.__wrap(ret);
    }
    /**
    * @returns {AuxiliaryDataKind}
    */
    kind() {
        const ret = wasm.auxiliarydata_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Metadata | undefined}
    */
    as_shelley() {
        const ret = wasm.auxiliarydata_as_shelley(this.__wbg_ptr);
        return ret === 0 ? undefined : Metadata.__wrap(ret);
    }
    /**
    * @returns {ShelleyMAFormatAuxData | undefined}
    */
    as_shelley_ma() {
        const ret = wasm.auxiliarydata_as_shelley_ma(this.__wbg_ptr);
        return ret === 0 ? undefined : ShelleyMAFormatAuxData.__wrap(ret);
    }
    /**
    * @returns {ConwayFormatAuxData | undefined}
    */
    as_conway() {
        const ret = wasm.auxiliarydata_as_conway(this.__wbg_ptr);
        return ret === 0 ? undefined : ConwayFormatAuxData.__wrap(ret);
    }
}

const AuxiliaryDataHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_auxiliarydatahash_free(ptr >>> 0, 1));
/**
*/
class AuxiliaryDataHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AuxiliaryDataHash.prototype);
        obj.__wbg_ptr = ptr;
        AuxiliaryDataHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AuxiliaryDataHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_auxiliarydatahash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.auxiliarydatahash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {AuxiliaryDataHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.auxiliarydatahash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AuxiliaryDataHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.auxiliarydatahash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {AuxiliaryDataHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.auxiliarydatahash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AuxiliaryDataHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.auxiliarydatahash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {AuxiliaryDataHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.auxiliarydatahash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AuxiliaryDataHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const BaseAddressFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_baseaddress_free(ptr >>> 0, 1));
/**
*/
class BaseAddress {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(BaseAddress.prototype);
        obj.__wbg_ptr = ptr;
        BaseAddressFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BaseAddressFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_baseaddress_free(ptr, 0);
    }
    /**
    * @param {number} network
    * @param {Credential} payment
    * @param {Credential} stake
    * @returns {BaseAddress}
    */
    static new(network, payment, stake) {
        _assertClass(payment, Credential);
        _assertClass(stake, Credential);
        const ret = wasm.baseaddress_new(network, payment.__wbg_ptr, stake.__wbg_ptr);
        return BaseAddress.__wrap(ret);
    }
    /**
    * @returns {Address}
    */
    to_address() {
        const ret = wasm.baseaddress_to_address(this.__wbg_ptr);
        return Address.__wrap(ret);
    }
    /**
    * @param {Address} address
    * @returns {BaseAddress | undefined}
    */
    static from_address(address) {
        _assertClass(address, Address);
        const ret = wasm.baseaddress_from_address(address.__wbg_ptr);
        return ret === 0 ? undefined : BaseAddress.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    network_id() {
        const ret = wasm.baseaddress_network_id(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Credential}
    */
    payment() {
        const ret = wasm.baseaddress_payment(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {Credential}
    */
    stake() {
        const ret = wasm.baseaddress_stake(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
}

const BigIntegerFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_biginteger_free(ptr >>> 0, 1));
/**
*/
class BigInteger {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(BigInteger.prototype);
        obj.__wbg_ptr = ptr;
        BigIntegerFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BigIntegerFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_biginteger_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.biginteger_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.biginteger_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {BigInteger}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.biginteger_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BigInteger.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.biginteger_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.biginteger_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {BigInteger}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.biginteger_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BigInteger.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.biginteger_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.biginteger_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {BigInteger}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.biginteger_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BigInteger.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Int} x
    * @returns {BigInteger}
    */
    static from_int(x) {
        _assertClass(x, Int);
        const ret = wasm.biginteger_from_int(x.__wbg_ptr);
        return BigInteger.__wrap(ret);
    }
    /**
    * @param {string} s
    * @returns {BigInteger}
    */
    static from_str(s) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(s, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.biginteger_from_str(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BigInteger.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.biginteger_to_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * Converts to a u64
    * Returns None if the number was negative or too big for a u64
    * @returns {bigint | undefined}
    */
    as_u64() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.biginteger_as_u64(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Converts to an Int
    * Returns None when the number is too big for an Int (outside +/- 64-bit unsigned)
    * Retains encoding info if the original was encoded as an Int
    * @returns {Int | undefined}
    */
    as_int() {
        const ret = wasm.biginteger_as_int(this.__wbg_ptr);
        return ret === 0 ? undefined : Int.__wrap(ret);
    }
}

const Bip32PrivateKeyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_bip32privatekey_free(ptr >>> 0, 1));
/**
*/
class Bip32PrivateKey {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Bip32PrivateKey.prototype);
        obj.__wbg_ptr = ptr;
        Bip32PrivateKeyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Bip32PrivateKeyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_bip32privatekey_free(ptr, 0);
    }
    /**
    * derive this private key with the given index.
    *
    * # Security considerations
    *
    * * hard derivation index cannot be soft derived with the public key
    *
    * # Hard derivation vs Soft derivation
    *
    * If you pass an index below 0x80000000 then it is a soft derivation.
    * The advantage of soft derivation is that it is possible to derive the
    * public key too. I.e. derivation the private key with a soft derivation
    * index and then retrieving the associated public key is equivalent to
    * deriving the public key associated to the parent private key.
    *
    * Hard derivation index does not allow public key derivation.
    *
    * This is why deriving the private key should not fail while deriving
    * the public key may fail (if the derivation index is invalid).
    * @param {number} index
    * @returns {Bip32PrivateKey}
    */
    derive(index) {
        const ret = wasm.bip32privatekey_derive(this.__wbg_ptr, index);
        return Bip32PrivateKey.__wrap(ret);
    }
    /**
    * 128-byte xprv a key format in Cardano that some software still uses or requires
    * the traditional 96-byte xprv is simply encoded as
    * prv | chaincode
    * however, because some software may not know how to compute a public key from a private key,
    * the 128-byte inlines the public key in the following format
    * prv | pub | chaincode
    * so be careful if you see the term "xprv" as it could refer to either one
    * our library does not require the pub (instead we compute the pub key when needed)
    * @param {Uint8Array} bytes
    * @returns {Bip32PrivateKey}
    */
    static from_128_xprv(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.bip32privatekey_from_128_xprv(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Bip32PrivateKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * see from_128_xprv
    * @returns {Uint8Array}
    */
    to_128_xprv() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bip32privatekey_to_128_xprv(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Bip32PrivateKey}
    */
    static generate_ed25519_bip32() {
        const ret = wasm.bip32privatekey_generate_ed25519_bip32();
        return Bip32PrivateKey.__wrap(ret);
    }
    /**
    * @returns {PrivateKey}
    */
    to_raw_key() {
        const ret = wasm.bip32privatekey_to_raw_key(this.__wbg_ptr);
        return PrivateKey.__wrap(ret);
    }
    /**
    * @returns {Bip32PublicKey}
    */
    to_public() {
        const ret = wasm.bip32privatekey_to_public(this.__wbg_ptr);
        return Bip32PublicKey.__wrap(ret);
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {Bip32PrivateKey}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.bip32privatekey_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Bip32PrivateKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bip32privatekey_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {Bip32PrivateKey}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.bip32privatekey_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Bip32PrivateKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_bech32() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bip32privatekey_to_bech32(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {Uint8Array} entropy
    * @param {Uint8Array} password
    * @returns {Bip32PrivateKey}
    */
    static from_bip39_entropy(entropy, password) {
        const ptr0 = passArray8ToWasm0(entropy, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArray8ToWasm0(password, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.bip32privatekey_from_bip39_entropy(ptr0, len0, ptr1, len1);
        return Bip32PrivateKey.__wrap(ret);
    }
    /**
    * @returns {Uint8Array}
    */
    chaincode() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bip32privatekey_chaincode(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const Bip32PublicKeyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_bip32publickey_free(ptr >>> 0, 1));
/**
*/
class Bip32PublicKey {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Bip32PublicKey.prototype);
        obj.__wbg_ptr = ptr;
        Bip32PublicKeyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Bip32PublicKeyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_bip32publickey_free(ptr, 0);
    }
    /**
    * derive this public key with the given index.
    *
    * # Errors
    *
    * If the index is not a soft derivation index (< 0x80000000) then
    * calling this method will fail.
    *
    * # Security considerations
    *
    * * hard derivation index cannot be soft derived with the public key
    *
    * # Hard derivation vs Soft derivation
    *
    * If you pass an index below 0x80000000 then it is a soft derivation.
    * The advantage of soft derivation is that it is possible to derive the
    * public key too. I.e. derivation the private key with a soft derivation
    * index and then retrieving the associated public key is equivalent to
    * deriving the public key associated to the parent private key.
    *
    * Hard derivation index does not allow public key derivation.
    *
    * This is why deriving the private key should not fail while deriving
    * the public key may fail (if the derivation index is invalid).
    * @param {number} index
    * @returns {Bip32PublicKey}
    */
    derive(index) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bip32publickey_derive(retptr, this.__wbg_ptr, index);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Bip32PublicKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {PublicKey}
    */
    to_raw_key() {
        const ret = wasm.bip32publickey_to_raw_key(this.__wbg_ptr);
        return PublicKey.__wrap(ret);
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {Bip32PublicKey}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.bip32publickey_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Bip32PublicKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bip32publickey_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {Bip32PublicKey}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.bip32publickey_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Bip32PublicKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_bech32() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bip32publickey_to_bech32(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    chaincode() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bip32publickey_chaincode(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const BlockFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_block_free(ptr >>> 0, 1));
/**
*/
class Block {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Block.prototype);
        obj.__wbg_ptr = ptr;
        BlockFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BlockFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_block_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.block_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.block_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Block}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.block_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Block.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.block_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.block_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Block}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.block_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Block.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.block_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.block_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Block}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.block_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Block.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Header}
    */
    header() {
        const ret = wasm.block_header(this.__wbg_ptr);
        return Header.__wrap(ret);
    }
    /**
    * @returns {TransactionBodyList}
    */
    transaction_bodies() {
        const ret = wasm.block_transaction_bodies(this.__wbg_ptr);
        return TransactionBodyList.__wrap(ret);
    }
    /**
    * @returns {TransactionWitnessSetList}
    */
    transaction_witness_sets() {
        const ret = wasm.block_transaction_witness_sets(this.__wbg_ptr);
        return TransactionWitnessSetList.__wrap(ret);
    }
    /**
    * @returns {MapTransactionIndexToAuxiliaryData}
    */
    auxiliary_data_set() {
        const ret = wasm.block_auxiliary_data_set(this.__wbg_ptr);
        return MapTransactionIndexToAuxiliaryData.__wrap(ret);
    }
    /**
    * @returns {Uint16Array}
    */
    invalid_transactions() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.block_invalid_transactions(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU16FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 2, 2);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Header} header
    * @param {TransactionBodyList} transaction_bodies
    * @param {TransactionWitnessSetList} transaction_witness_sets
    * @param {MapTransactionIndexToAuxiliaryData} auxiliary_data_set
    * @param {Uint16Array} invalid_transactions
    * @returns {Block}
    */
    static new(header, transaction_bodies, transaction_witness_sets, auxiliary_data_set, invalid_transactions) {
        _assertClass(header, Header);
        _assertClass(transaction_bodies, TransactionBodyList);
        _assertClass(transaction_witness_sets, TransactionWitnessSetList);
        _assertClass(auxiliary_data_set, MapTransactionIndexToAuxiliaryData);
        const ptr0 = passArray16ToWasm0(invalid_transactions, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.block_new(header.__wbg_ptr, transaction_bodies.__wbg_ptr, transaction_witness_sets.__wbg_ptr, auxiliary_data_set.__wbg_ptr, ptr0, len0);
        return Block.__wrap(ret);
    }
}

const BlockBodyHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_blockbodyhash_free(ptr >>> 0, 1));
/**
*/
class BlockBodyHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(BlockBodyHash.prototype);
        obj.__wbg_ptr = ptr;
        BlockBodyHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BlockBodyHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_blockbodyhash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.blockbodyhash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {BlockBodyHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.blockbodyhash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BlockBodyHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.blockbodyhash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {BlockBodyHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.blockbodyhash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BlockBodyHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.blockbodyhash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {BlockBodyHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.blockbodyhash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BlockBodyHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const BlockHeaderHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_blockheaderhash_free(ptr >>> 0, 1));
/**
*/
class BlockHeaderHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(BlockHeaderHash.prototype);
        obj.__wbg_ptr = ptr;
        BlockHeaderHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BlockHeaderHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_blockheaderhash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.blockheaderhash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {BlockHeaderHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.blockheaderhash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BlockHeaderHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.blockheaderhash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {BlockHeaderHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.blockheaderhash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BlockHeaderHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.blockheaderhash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {BlockHeaderHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.blockheaderhash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BlockHeaderHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const BootstrapWitnessFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_bootstrapwitness_free(ptr >>> 0, 1));
/**
*/
class BootstrapWitness {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(BootstrapWitness.prototype);
        obj.__wbg_ptr = ptr;
        BootstrapWitnessFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BootstrapWitnessFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_bootstrapwitness_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bootstrapwitness_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bootstrapwitness_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {BootstrapWitness}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.bootstrapwitness_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BootstrapWitness.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bootstrapwitness_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bootstrapwitness_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {BootstrapWitness}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.bootstrapwitness_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BootstrapWitness.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bootstrapwitness_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bootstrapwitness_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {BootstrapWitness}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.bootstrapwitness_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BootstrapWitness.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {PublicKey}
    */
    public_key() {
        const ret = wasm.bootstrapwitness_public_key(this.__wbg_ptr);
        return PublicKey.__wrap(ret);
    }
    /**
    * @returns {Ed25519Signature}
    */
    signature() {
        const ret = wasm.bootstrapwitness_signature(this.__wbg_ptr);
        return Ed25519Signature.__wrap(ret);
    }
    /**
    * @returns {Uint8Array}
    */
    chain_code() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bootstrapwitness_chain_code(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {AddrAttributes}
    */
    attributes() {
        const ret = wasm.bootstrapwitness_attributes(this.__wbg_ptr);
        return AddrAttributes.__wrap(ret);
    }
    /**
    * @param {PublicKey} public_key
    * @param {Ed25519Signature} signature
    * @param {Uint8Array} chain_code
    * @param {AddrAttributes} attributes
    * @returns {BootstrapWitness}
    */
    static new(public_key, signature, chain_code, attributes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(public_key, PublicKey);
            _assertClass(signature, Ed25519Signature);
            const ptr0 = passArray8ToWasm0(chain_code, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            _assertClass(attributes, AddrAttributes);
            wasm.bootstrapwitness_new(retptr, public_key.__wbg_ptr, signature.__wbg_ptr, ptr0, len0, attributes.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return BootstrapWitness.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {AddressContent}
    */
    to_address() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bootstrapwitness_to_address(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return AddressContent.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const BootstrapWitnessListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_bootstrapwitnesslist_free(ptr >>> 0, 1));
/**
*/
class BootstrapWitnessList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(BootstrapWitnessList.prototype);
        obj.__wbg_ptr = ptr;
        BootstrapWitnessListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BootstrapWitnessListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_bootstrapwitnesslist_free(ptr, 0);
    }
    /**
    * @returns {BootstrapWitnessList}
    */
    static new() {
        const ret = wasm.bootstrapwitnesslist_new();
        return BootstrapWitnessList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.bootstrapwitnesslist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {BootstrapWitness}
    */
    get(index) {
        const ret = wasm.bootstrapwitnesslist_get(this.__wbg_ptr, index);
        return BootstrapWitness.__wrap(ret);
    }
    /**
    * @param {BootstrapWitness} elem
    */
    add(elem) {
        _assertClass(elem, BootstrapWitness);
        wasm.bootstrapwitnesslist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const ByronAddressFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_byronaddress_free(ptr >>> 0, 1));
/**
*/
class ByronAddress {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ByronAddress.prototype);
        obj.__wbg_ptr = ptr;
        ByronAddressFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ByronAddressFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_byronaddress_free(ptr, 0);
    }
    /**
    * @returns {string}
    */
    to_base58() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.byronaddress_to_base58(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} s
    * @returns {ByronAddress}
    */
    static from_base58(s) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(s, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.byronaddress_from_base58(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ByronAddress.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} s
    * @returns {boolean}
    */
    static is_valid(s) {
        const ptr0 = passStringToWasm0(s, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.byronaddress_is_valid(ptr0, len0);
        return ret !== 0;
    }
    /**
    * @returns {Address}
    */
    to_address() {
        const ret = wasm.byronaddress_to_address(this.__wbg_ptr);
        return Address.__wrap(ret);
    }
    /**
    * @param {Address} addr
    * @returns {ByronAddress | undefined}
    */
    static from_address(addr) {
        _assertClass(addr, Address);
        const ret = wasm.byronaddress_from_address(addr.__wbg_ptr);
        return ret === 0 ? undefined : ByronAddress.__wrap(ret);
    }
    /**
    * @param {AddressContent} address_content
    * @returns {ByronAddress}
    */
    static from_address_content(address_content) {
        _assertClass(address_content, AddressContent);
        const ret = wasm.byronaddress_from_address_content(address_content.__wbg_ptr);
        return ByronAddress.__wrap(ret);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes.
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.byronaddress_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ByronAddress}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.byronaddress_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ByronAddress.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.byronaddress_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ByronAddress}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.byronaddress_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ByronAddress.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {AddressContent}
    */
    content() {
        const ret = wasm.byronaddress_content(this.__wbg_ptr);
        return AddressContent.__wrap(ret);
    }
    /**
    * @returns {Crc32}
    */
    crc() {
        const ret = wasm.byronaddress_crc(this.__wbg_ptr);
        return Crc32.__wrap(ret);
    }
    /**
    * @param {AddressContent} content
    * @param {Crc32} crc
    * @returns {ByronAddress}
    */
    static new(content, crc) {
        _assertClass(content, AddressContent);
        _assertClass(crc, Crc32);
        const ret = wasm.byronaddress_new(content.__wbg_ptr, crc.__wbg_ptr);
        return ByronAddress.__wrap(ret);
    }
}

const ByronScriptFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_byronscript_free(ptr >>> 0, 1));
/**
*/
class ByronScript {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ByronScript.prototype);
        obj.__wbg_ptr = ptr;
        ByronScriptFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ByronScriptFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_byronscript_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.byronscript_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {ByronScript}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.byronscript_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ByronScript.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.byronscript_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {ByronScript}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.byronscript_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ByronScript.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.byronscript_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {ByronScript}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.byronscript_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ByronScript.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const ByronTxOutFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_byrontxout_free(ptr >>> 0, 1));
/**
*/
class ByronTxOut {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ByronTxOut.prototype);
        obj.__wbg_ptr = ptr;
        ByronTxOutFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ByronTxOutFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_byrontxout_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes.
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.byrontxout_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ByronTxOut}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.byrontxout_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ByronTxOut.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.byrontxout_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ByronTxOut}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.byrontxout_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ByronTxOut.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {ByronAddress}
    */
    address() {
        const ret = wasm.byrontxout_address(this.__wbg_ptr);
        return ByronAddress.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    amount() {
        const ret = wasm.byrontxout_amount(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {ByronAddress} address
    * @param {bigint} amount
    * @returns {ByronTxOut}
    */
    static new(address, amount) {
        _assertClass(address, ByronAddress);
        const ret = wasm.byrontxout_new(address.__wbg_ptr, amount);
        return ByronTxOut.__wrap(ret);
    }
}

const CIP25ChunkableStringFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip25chunkablestring_free(ptr >>> 0, 1));
/**
* A String that may or may not be chunked into 64-byte chunks to be able
* to conform to Cardano TX Metadata limitations.
* Most users should simply use CIP25ChunkableString::from_string() and CIP25ChunkableString::to_string()
* and avoid the explicit single/chunk interface:
* ```javascript
* let chunkableString = CIP25.CIP25ChunkableString.from_string("this can be any length and will automatically be chunked if needed");
* ```
*/
class CIP25ChunkableString {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP25ChunkableString.prototype);
        obj.__wbg_ptr = ptr;
        CIP25ChunkableStringFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP25ChunkableStringFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip25chunkablestring_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes.
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25chunkablestring_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {CIP25ChunkableString}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25chunkablestring_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25ChunkableString.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25chunkablestring_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {CIP25ChunkableString}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25chunkablestring_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25ChunkableString.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25chunkablestring_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25chunkablestring_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP25ChunkableString}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25chunkablestring_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25ChunkableString.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {CIP25String64} single
    * @returns {CIP25ChunkableString}
    */
    static new_single(single) {
        _assertClass(single, CIP25String64);
        const ret = wasm.cip25chunkablestring_new_single(single.__wbg_ptr);
        return CIP25ChunkableString.__wrap(ret);
    }
    /**
    * @param {CIP25String64List} chunked
    * @returns {CIP25ChunkableString}
    */
    static new_chunked(chunked) {
        _assertClass(chunked, CIP25String64List);
        const ret = wasm.cip25chunkablestring_new_chunked(chunked.__wbg_ptr);
        return CIP25ChunkableString.__wrap(ret);
    }
    /**
    * @returns {ChunkableStringKind}
    */
    kind() {
        const ret = wasm.cip25chunkablestring_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {CIP25String64 | undefined}
    */
    as_single() {
        const ret = wasm.cip25chunkablestring_as_single(this.__wbg_ptr);
        return ret === 0 ? undefined : CIP25String64.__wrap(ret);
    }
    /**
    * @returns {CIP25String64List | undefined}
    */
    as_chunked() {
        const ret = wasm.cip25chunkablestring_as_chunked(this.__wbg_ptr);
        return ret === 0 ? undefined : CIP25String64List.__wrap(ret);
    }
    /**
    * @param {string} str
    * @returns {CIP25ChunkableString}
    */
    static from_string(str) {
        const ptr0 = passStringToWasm0(str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.cip25chunkablestring_from_string(ptr0, len0);
        return CIP25ChunkableString.__wrap(ret);
    }
    /**
    * @returns {string}
    */
    to_string() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25chunkablestring_to_string(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const CIP25FilesDetailsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip25filesdetails_free(ptr >>> 0, 1));
/**
*/
class CIP25FilesDetails {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP25FilesDetails.prototype);
        obj.__wbg_ptr = ptr;
        CIP25FilesDetailsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP25FilesDetailsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip25filesdetails_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes.
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25filesdetails_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {CIP25FilesDetails}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25filesdetails_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25FilesDetails.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25filesdetails_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {CIP25FilesDetails}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25filesdetails_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25FilesDetails.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25filesdetails_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25filesdetails_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP25FilesDetails}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25filesdetails_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25FilesDetails.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {CIP25String64}
    */
    name() {
        const ret = wasm.cip25filesdetails_name(this.__wbg_ptr);
        return CIP25String64.__wrap(ret);
    }
    /**
    * @returns {CIP25String64}
    */
    media_type() {
        const ret = wasm.cip25filesdetails_media_type(this.__wbg_ptr);
        return CIP25String64.__wrap(ret);
    }
    /**
    * @returns {CIP25ChunkableString}
    */
    src() {
        const ret = wasm.cip25filesdetails_src(this.__wbg_ptr);
        return CIP25ChunkableString.__wrap(ret);
    }
    /**
    * @param {CIP25String64} name
    * @param {CIP25String64} media_type
    * @param {CIP25ChunkableString} src
    * @returns {CIP25FilesDetails}
    */
    static new(name, media_type, src) {
        _assertClass(name, CIP25String64);
        _assertClass(media_type, CIP25String64);
        _assertClass(src, CIP25ChunkableString);
        const ret = wasm.cip25filesdetails_new(name.__wbg_ptr, media_type.__wbg_ptr, src.__wbg_ptr);
        return CIP25FilesDetails.__wrap(ret);
    }
}

const CIP25LabelMetadataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip25labelmetadata_free(ptr >>> 0, 1));
/**
*/
class CIP25LabelMetadata {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP25LabelMetadata.prototype);
        obj.__wbg_ptr = ptr;
        CIP25LabelMetadataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP25LabelMetadataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip25labelmetadata_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes.
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25labelmetadata_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {CIP25LabelMetadata}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25labelmetadata_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25LabelMetadata.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25labelmetadata_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {CIP25LabelMetadata}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25labelmetadata_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25LabelMetadata.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25labelmetadata_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25labelmetadata_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP25LabelMetadata}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25labelmetadata_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25LabelMetadata.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Note that Version 1 can only support utf8 string asset names.
    * Version 2 can support any asset name.
    * @param {CIP25Version} version
    * @returns {CIP25LabelMetadata}
    */
    static new(version) {
        const ret = wasm.cip25labelmetadata_new(version);
        return CIP25LabelMetadata.__wrap(ret);
    }
    /**
    * If this is version 1 and the asset name is not a utf8 asset name
    * then this will return an error.
    * This function will never return an error for version 2.
    * On success, returns the previous details that were overwritten, or None otherwise.
    * @param {ScriptHash} policy_id
    * @param {AssetName} asset_name
    * @param {CIP25MetadataDetails} details
    * @returns {CIP25MetadataDetails | undefined}
    */
    set(policy_id, asset_name, details) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(policy_id, ScriptHash);
            _assertClass(asset_name, AssetName);
            _assertClass(details, CIP25MetadataDetails);
            wasm.cip25labelmetadata_set(retptr, this.__wbg_ptr, policy_id.__wbg_ptr, asset_name.__wbg_ptr, details.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 === 0 ? undefined : CIP25MetadataDetails.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {ScriptHash} policy_id
    * @param {AssetName} asset_name
    * @returns {CIP25MetadataDetails | undefined}
    */
    get(policy_id, asset_name) {
        _assertClass(policy_id, ScriptHash);
        _assertClass(asset_name, AssetName);
        const ret = wasm.cip25labelmetadata_get(this.__wbg_ptr, policy_id.__wbg_ptr, asset_name.__wbg_ptr);
        return ret === 0 ? undefined : CIP25MetadataDetails.__wrap(ret);
    }
    /**
    * @returns {CIP25Version}
    */
    version() {
        const ret = wasm.cip25labelmetadata_version(this.__wbg_ptr);
        return ret;
    }
}

const CIP25MetadataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip25metadata_free(ptr >>> 0, 1));
/**
* This is the entire metadata schema for CIP-25
* It can be parsed by passing in the CBOR bytes of the entire transaction metadata
* or by passing in an existing Metadata struct.
* Parsing from CBOR bytes should be marginally faster.
*/
class CIP25Metadata {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP25Metadata.prototype);
        obj.__wbg_ptr = ptr;
        CIP25MetadataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP25MetadataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip25metadata_free(ptr, 0);
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25metadata_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25metadata_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP25Metadata}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25metadata_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25Metadata.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Serialize to CBOR bytes compatible with tx metadata
    * Does not guarantee any specific type of CBOR format and should NOT
    * be used with round-tripping. It will ignore all non-CIP25 keys.
    * Use cml_cip25::metadate crate for round-tripping metadata.
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25metadata_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Deserialize from CBOR bytes compatible with tx metadata
    * Does not guarantee any specific type of CBOR format and should NOT
    * be used with round-tripping. It will ignore all non-CIP25 keys.
    * Use cml_cip25::metadate crate for round-tripping metadata.
    * @param {Uint8Array} data
    * @returns {CIP25Metadata}
    */
    static from_cbor_bytes(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(data, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25metadata_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25Metadata.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * The core details of the CIP25 spec
    * @returns {CIP25LabelMetadata}
    */
    key_721() {
        const ret = wasm.cip25metadata_key_721(this.__wbg_ptr);
        return CIP25LabelMetadata.__wrap(ret);
    }
    /**
    * @param {CIP25LabelMetadata} key_721
    * @returns {CIP25Metadata}
    */
    static new(key_721) {
        _assertClass(key_721, CIP25LabelMetadata);
        const ret = wasm.cip25metadata_new(key_721.__wbg_ptr);
        return CIP25Metadata.__wrap(ret);
    }
    /**
    * Create a Metadata containing only the CIP25 schema
    * @returns {Metadata}
    */
    to_metadata() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25metadata_to_metadata(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Metadata.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Read the CIP25 schema from a Metadata. Ignores all other data besides CIP25
    * Can fail if the Metadata does not conform to CIP25
    * @param {Metadata} metadata
    * @returns {CIP25Metadata}
    */
    static from_metadata(metadata) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(metadata, Metadata);
            wasm.cip25metadata_from_metadata(retptr, metadata.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25Metadata.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Add to an existing metadata (could be empty) the full CIP25 metadata
    * @param {Metadata} metadata
    */
    add_to_metadata(metadata) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(metadata, Metadata);
            wasm.cip25metadata_add_to_metadata(retptr, this.__wbg_ptr, metadata.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const CIP25MetadataDetailsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip25metadatadetails_free(ptr >>> 0, 1));
/**
*/
class CIP25MetadataDetails {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP25MetadataDetails.prototype);
        obj.__wbg_ptr = ptr;
        CIP25MetadataDetailsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP25MetadataDetailsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip25metadatadetails_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes.
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25metadatadetails_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {CIP25MetadataDetails}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25metadatadetails_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25MetadataDetails.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25metadatadetails_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {CIP25MetadataDetails}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25metadatadetails_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25MetadataDetails.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25metadatadetails_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25metadatadetails_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP25MetadataDetails}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25metadatadetails_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25MetadataDetails.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {CIP25String64}
    */
    name() {
        const ret = wasm.cip25metadatadetails_name(this.__wbg_ptr);
        return CIP25String64.__wrap(ret);
    }
    /**
    * @returns {CIP25ChunkableString}
    */
    image() {
        const ret = wasm.cip25metadatadetails_image(this.__wbg_ptr);
        return CIP25ChunkableString.__wrap(ret);
    }
    /**
    * @param {CIP25String64} media_type
    */
    set_media_type(media_type) {
        _assertClass(media_type, CIP25String64);
        wasm.cip25metadatadetails_set_media_type(this.__wbg_ptr, media_type.__wbg_ptr);
    }
    /**
    * @returns {CIP25String64 | undefined}
    */
    media_type() {
        const ret = wasm.cip25metadatadetails_media_type(this.__wbg_ptr);
        return ret === 0 ? undefined : CIP25String64.__wrap(ret);
    }
    /**
    * @param {CIP25ChunkableString} description
    */
    set_description(description) {
        _assertClass(description, CIP25ChunkableString);
        wasm.cip25metadatadetails_set_description(this.__wbg_ptr, description.__wbg_ptr);
    }
    /**
    * @returns {CIP25ChunkableString | undefined}
    */
    description() {
        const ret = wasm.cip25metadatadetails_description(this.__wbg_ptr);
        return ret === 0 ? undefined : CIP25ChunkableString.__wrap(ret);
    }
    /**
    * @param {FilesDetailsList} files
    */
    set_files(files) {
        _assertClass(files, FilesDetailsList);
        wasm.cip25metadatadetails_set_files(this.__wbg_ptr, files.__wbg_ptr);
    }
    /**
    * @returns {FilesDetailsList | undefined}
    */
    files() {
        const ret = wasm.cip25metadatadetails_files(this.__wbg_ptr);
        return ret === 0 ? undefined : FilesDetailsList.__wrap(ret);
    }
    /**
    * @param {CIP25String64} name
    * @param {CIP25ChunkableString} image
    * @returns {CIP25MetadataDetails}
    */
    static new(name, image) {
        _assertClass(name, CIP25String64);
        _assertClass(image, CIP25ChunkableString);
        const ret = wasm.cip25metadatadetails_new(name.__wbg_ptr, image.__wbg_ptr);
        return CIP25MetadataDetails.__wrap(ret);
    }
}

const CIP25MiniMetadataDetailsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip25minimetadatadetails_free(ptr >>> 0, 1));
/**
*/
class CIP25MiniMetadataDetails {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP25MiniMetadataDetails.prototype);
        obj.__wbg_ptr = ptr;
        CIP25MiniMetadataDetailsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP25MiniMetadataDetailsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip25minimetadatadetails_free(ptr, 0);
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25minimetadatadetails_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25minimetadatadetails_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP25MiniMetadataDetails}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25minimetadatadetails_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25MiniMetadataDetails.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {CIP25MiniMetadataDetails}
    */
    static new() {
        const ret = wasm.cip25minimetadatadetails_new();
        return CIP25MiniMetadataDetails.__wrap(ret);
    }
    /**
    * @param {CIP25String64} name
    */
    set_name(name) {
        _assertClass(name, CIP25String64);
        wasm.cip25minimetadatadetails_set_name(this.__wbg_ptr, name.__wbg_ptr);
    }
    /**
    * @returns {CIP25String64 | undefined}
    */
    name() {
        const ret = wasm.cip25minimetadatadetails_name(this.__wbg_ptr);
        return ret === 0 ? undefined : CIP25String64.__wrap(ret);
    }
    /**
    * @param {CIP25ChunkableString} image
    */
    set_image(image) {
        _assertClass(image, CIP25ChunkableString);
        wasm.cip25minimetadatadetails_set_image(this.__wbg_ptr, image.__wbg_ptr);
    }
    /**
    * @returns {CIP25ChunkableString | undefined}
    */
    image() {
        const ret = wasm.cip25minimetadatadetails_image(this.__wbg_ptr);
        return ret === 0 ? undefined : CIP25ChunkableString.__wrap(ret);
    }
    /**
    * loose parsing of CIP25 metadata to allow for common exceptions to the format
    * `metadatum` should represent the data where the `CIP25MetadataDetails` is in the cip25 structure
    * @param {TransactionMetadatum} metadatum
    * @returns {CIP25MiniMetadataDetails}
    */
    static loose_parse(metadatum) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(metadatum, TransactionMetadatum);
            wasm.cip25minimetadatadetails_loose_parse(retptr, metadatum.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25MiniMetadataDetails.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const CIP25String64Finalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip25string64_free(ptr >>> 0, 1));
/**
* A String of at most 64 bytes.
* This is to conform with Cardano metadata restrictions.
*/
class CIP25String64 {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP25String64.prototype);
        obj.__wbg_ptr = ptr;
        CIP25String64Finalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP25String64Finalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip25string64_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes.
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25string64_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {CIP25String64}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25string64_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25String64.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25string64_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {CIP25String64}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25string64_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25String64.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25string64_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25string64_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP25String64}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25string64_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25String64.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    get() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25string64_get(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} s
    * @returns {CIP25String64}
    */
    static new(s) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(s, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip25string64_new(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP25String64.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25string64_to_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip25string64_get_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const CIP25String64ListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip25string64list_free(ptr >>> 0, 1));
/**
*/
class CIP25String64List {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP25String64List.prototype);
        obj.__wbg_ptr = ptr;
        CIP25String64ListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP25String64ListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip25string64list_free(ptr, 0);
    }
    /**
    * @returns {CIP25String64List}
    */
    static new() {
        const ret = wasm.cip25string64list_new();
        return CIP25String64List.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.cip25string64list_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {CIP25String64}
    */
    get(index) {
        const ret = wasm.cip25string64list_get(this.__wbg_ptr, index);
        return CIP25String64.__wrap(ret);
    }
    /**
    * @param {CIP25String64} elem
    */
    add(elem) {
        _assertClass(elem, CIP25String64);
        wasm.cip25string64list_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const CIP36DelegationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip36delegation_free(ptr >>> 0, 1));
/**
*/
class CIP36Delegation {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP36Delegation.prototype);
        obj.__wbg_ptr = ptr;
        CIP36DelegationFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP36DelegationFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip36delegation_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36delegation_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36delegation_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {CIP36Delegation}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36delegation_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36Delegation.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36delegation_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36delegation_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {CIP36Delegation}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36delegation_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36Delegation.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36delegation_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36delegation_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP36Delegation}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36delegation_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36Delegation.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {PublicKey}
    */
    voting_pub_key() {
        const ret = wasm.cip36delegation_voting_pub_key(this.__wbg_ptr);
        return PublicKey.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    weight() {
        const ret = wasm.cip36delegation_weight(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {PublicKey} voting_pub_key
    * @param {number} weight
    * @returns {CIP36Delegation}
    */
    static new(voting_pub_key, weight) {
        _assertClass(voting_pub_key, PublicKey);
        const ret = wasm.cip36delegation_new(voting_pub_key.__wbg_ptr, weight);
        return CIP36Delegation.__wrap(ret);
    }
}

const CIP36DelegationDistributionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip36delegationdistribution_free(ptr >>> 0, 1));
/**
*/
class CIP36DelegationDistribution {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP36DelegationDistribution.prototype);
        obj.__wbg_ptr = ptr;
        CIP36DelegationDistributionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP36DelegationDistributionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip36delegationdistribution_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36delegationdistribution_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36delegationdistribution_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {CIP36DelegationDistribution}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36delegationdistribution_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36DelegationDistribution.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36delegationdistribution_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36delegationdistribution_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {CIP36DelegationDistribution}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36delegationdistribution_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36DelegationDistribution.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36delegationdistribution_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36delegationdistribution_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP36DelegationDistribution}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36delegationdistribution_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36DelegationDistribution.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {CIP36DelegationList} delegations
    * @returns {CIP36DelegationDistribution}
    */
    static new_weighted(delegations) {
        _assertClass(delegations, CIP36DelegationList);
        const ret = wasm.cip36delegationdistribution_new_weighted(delegations.__wbg_ptr);
        return CIP36DelegationDistribution.__wrap(ret);
    }
    /**
    * @param {PublicKey} legacy
    * @returns {CIP36DelegationDistribution}
    */
    static new_legacy(legacy) {
        _assertClass(legacy, PublicKey);
        const ret = wasm.cip36delegationdistribution_new_legacy(legacy.__wbg_ptr);
        return CIP36DelegationDistribution.__wrap(ret);
    }
    /**
    * @returns {DelegationDistributionKind}
    */
    kind() {
        const ret = wasm.cip36delegationdistribution_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {CIP36DelegationList | undefined}
    */
    as_weighted() {
        const ret = wasm.cip36delegationdistribution_as_weighted(this.__wbg_ptr);
        return ret === 0 ? undefined : CIP36DelegationList.__wrap(ret);
    }
    /**
    * @returns {PublicKey | undefined}
    */
    as_legacy() {
        const ret = wasm.cip36delegationdistribution_as_legacy(this.__wbg_ptr);
        return ret === 0 ? undefined : PublicKey.__wrap(ret);
    }
}

const CIP36DelegationListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip36delegationlist_free(ptr >>> 0, 1));
/**
*/
class CIP36DelegationList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP36DelegationList.prototype);
        obj.__wbg_ptr = ptr;
        CIP36DelegationListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP36DelegationListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip36delegationlist_free(ptr, 0);
    }
    /**
    * @returns {CIP36DelegationList}
    */
    static new() {
        const ret = wasm.cip36delegationlist_new();
        return CIP36DelegationList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.cip36delegationlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {CIP36Delegation}
    */
    get(index) {
        const ret = wasm.cip36delegationlist_get(this.__wbg_ptr, index);
        return CIP36Delegation.__wrap(ret);
    }
    /**
    * @param {CIP36Delegation} elem
    */
    add(elem) {
        _assertClass(elem, CIP36Delegation);
        wasm.cip36delegationlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const CIP36DeregistrationCborFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip36deregistrationcbor_free(ptr >>> 0, 1));
/**
*/
class CIP36DeregistrationCbor {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP36DeregistrationCbor.prototype);
        obj.__wbg_ptr = ptr;
        CIP36DeregistrationCborFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP36DeregistrationCborFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip36deregistrationcbor_free(ptr, 0);
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36deregistrationcbor_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36deregistrationcbor_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP36DeregistrationCbor}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36deregistrationcbor_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36DeregistrationCbor.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {CIP36KeyDeregistration}
    */
    key_deregistration() {
        const ret = wasm.cip36deregistrationcbor_key_deregistration(this.__wbg_ptr);
        return CIP36KeyDeregistration.__wrap(ret);
    }
    /**
    * @returns {CIP36DeregistrationWitness}
    */
    deregistration_witness() {
        const ret = wasm.cip36deregistrationcbor_deregistration_witness(this.__wbg_ptr);
        return CIP36DeregistrationWitness.__wrap(ret);
    }
    /**
    * @param {CIP36KeyDeregistration} key_deregistration
    * @param {CIP36DeregistrationWitness} deregistration_witness
    * @returns {CIP36DeregistrationCbor}
    */
    static new(key_deregistration, deregistration_witness) {
        _assertClass(key_deregistration, CIP36KeyDeregistration);
        _assertClass(deregistration_witness, CIP36DeregistrationWitness);
        const ret = wasm.cip36deregistrationcbor_new(key_deregistration.__wbg_ptr, deregistration_witness.__wbg_ptr);
        return CIP36DeregistrationCbor.__wrap(ret);
    }
}

const CIP36DeregistrationWitnessFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip36deregistrationwitness_free(ptr >>> 0, 1));
/**
*/
class CIP36DeregistrationWitness {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP36DeregistrationWitness.prototype);
        obj.__wbg_ptr = ptr;
        CIP36DeregistrationWitnessFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP36DeregistrationWitnessFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip36deregistrationwitness_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36deregistrationwitness_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36deregistrationwitness_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {CIP36DeregistrationWitness}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36deregistrationwitness_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36DeregistrationWitness.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36deregistrationwitness_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36deregistrationwitness_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {CIP36DeregistrationWitness}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36deregistrationwitness_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36DeregistrationWitness.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36deregistrationwitness_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36deregistrationwitness_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP36DeregistrationWitness}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36deregistrationwitness_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36DeregistrationWitness.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Ed25519Signature}
    */
    stake_witness() {
        const ret = wasm.cip36deregistrationwitness_stake_witness(this.__wbg_ptr);
        return Ed25519Signature.__wrap(ret);
    }
    /**
    * @param {Ed25519Signature} stake_witness
    * @returns {CIP36DeregistrationWitness}
    */
    static new(stake_witness) {
        _assertClass(stake_witness, Ed25519Signature);
        const ret = wasm.cip36deregistrationwitness_new(stake_witness.__wbg_ptr);
        return CIP36DeregistrationWitness.__wrap(ret);
    }
}

const CIP36KeyDeregistrationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip36keyderegistration_free(ptr >>> 0, 1));
/**
*/
class CIP36KeyDeregistration {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP36KeyDeregistration.prototype);
        obj.__wbg_ptr = ptr;
        CIP36KeyDeregistrationFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP36KeyDeregistrationFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip36keyderegistration_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36keyderegistration_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36keyderegistration_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {CIP36KeyDeregistration}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36keyderegistration_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36KeyDeregistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36keyderegistration_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36keyderegistration_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {CIP36KeyDeregistration}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36keyderegistration_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36KeyDeregistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36keyderegistration_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36keyderegistration_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP36KeyDeregistration}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36keyderegistration_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36KeyDeregistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {PublicKey}
    */
    stake_credential() {
        const ret = wasm.cip36keyderegistration_stake_credential(this.__wbg_ptr);
        return PublicKey.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    nonce() {
        const ret = wasm.cip36keyderegistration_nonce(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} voting_purpose
    */
    set_voting_purpose(voting_purpose) {
        wasm.cip36keyderegistration_set_voting_purpose(this.__wbg_ptr, voting_purpose);
    }
    /**
    * @returns {bigint}
    */
    voting_purpose() {
        const ret = wasm.cip36keyderegistration_voting_purpose(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
}

const CIP36KeyRegistrationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip36keyregistration_free(ptr >>> 0, 1));
/**
*/
class CIP36KeyRegistration {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP36KeyRegistration.prototype);
        obj.__wbg_ptr = ptr;
        CIP36KeyRegistrationFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP36KeyRegistrationFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip36keyregistration_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36keyregistration_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36keyregistration_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {CIP36KeyRegistration}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36keyregistration_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36KeyRegistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36keyregistration_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36keyregistration_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {CIP36KeyRegistration}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36keyregistration_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36KeyRegistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36keyregistration_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36keyregistration_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP36KeyRegistration}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36keyregistration_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36KeyRegistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {CIP36DelegationDistribution}
    */
    delegation() {
        const ret = wasm.cip36keyregistration_delegation(this.__wbg_ptr);
        return CIP36DelegationDistribution.__wrap(ret);
    }
    /**
    * @returns {PublicKey}
    */
    stake_credential() {
        const ret = wasm.cip36keyregistration_stake_credential(this.__wbg_ptr);
        return PublicKey.__wrap(ret);
    }
    /**
    * @returns {Address}
    */
    payment_address() {
        const ret = wasm.cip36keyregistration_payment_address(this.__wbg_ptr);
        return Address.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    nonce() {
        const ret = wasm.cip36keyregistration_nonce(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} voting_purpose
    */
    set_voting_purpose(voting_purpose) {
        wasm.cip36keyregistration_set_voting_purpose(this.__wbg_ptr, voting_purpose);
    }
    /**
    * @returns {bigint}
    */
    voting_purpose() {
        const ret = wasm.cip36keyregistration_voting_purpose(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
}

const CIP36RegistrationCborFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip36registrationcbor_free(ptr >>> 0, 1));
/**
*/
class CIP36RegistrationCbor {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP36RegistrationCbor.prototype);
        obj.__wbg_ptr = ptr;
        CIP36RegistrationCborFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP36RegistrationCborFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip36registrationcbor_free(ptr, 0);
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36registrationcbor_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36registrationcbor_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP36RegistrationCbor}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36registrationcbor_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36RegistrationCbor.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {CIP36KeyRegistration}
    */
    key_registration() {
        const ret = wasm.cip36registrationcbor_key_registration(this.__wbg_ptr);
        return CIP36KeyRegistration.__wrap(ret);
    }
    /**
    * @returns {CIP36RegistrationWitness}
    */
    registration_witness() {
        const ret = wasm.cip36registrationcbor_registration_witness(this.__wbg_ptr);
        return CIP36RegistrationWitness.__wrap(ret);
    }
    /**
    * @param {CIP36KeyRegistration} key_registration
    * @param {CIP36RegistrationWitness} registration_witness
    * @returns {CIP36RegistrationCbor}
    */
    static new(key_registration, registration_witness) {
        _assertClass(key_registration, CIP36KeyRegistration);
        _assertClass(registration_witness, CIP36RegistrationWitness);
        const ret = wasm.cip36registrationcbor_new(key_registration.__wbg_ptr, registration_witness.__wbg_ptr);
        return CIP36RegistrationCbor.__wrap(ret);
    }
}

const CIP36RegistrationWitnessFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cip36registrationwitness_free(ptr >>> 0, 1));
/**
*/
class CIP36RegistrationWitness {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CIP36RegistrationWitness.prototype);
        obj.__wbg_ptr = ptr;
        CIP36RegistrationWitnessFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CIP36RegistrationWitnessFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cip36registrationwitness_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36registrationwitness_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36registrationwitness_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {CIP36RegistrationWitness}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36registrationwitness_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36RegistrationWitness.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36registrationwitness_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36registrationwitness_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {CIP36RegistrationWitness}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36registrationwitness_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36RegistrationWitness.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36registrationwitness_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cip36registrationwitness_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CIP36RegistrationWitness}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cip36registrationwitness_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CIP36RegistrationWitness.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Ed25519Signature}
    */
    stake_witness() {
        const ret = wasm.cip36registrationwitness_stake_witness(this.__wbg_ptr);
        return Ed25519Signature.__wrap(ret);
    }
    /**
    * @param {Ed25519Signature} stake_witness
    * @returns {CIP36RegistrationWitness}
    */
    static new(stake_witness) {
        _assertClass(stake_witness, Ed25519Signature);
        const ret = wasm.cip36registrationwitness_new(stake_witness.__wbg_ptr);
        return CIP36RegistrationWitness.__wrap(ret);
    }
}

const CertificateFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_certificate_free(ptr >>> 0, 1));
/**
*/
class Certificate {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Certificate.prototype);
        obj.__wbg_ptr = ptr;
        CertificateFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CertificateFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_certificate_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.certificate_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.certificate_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Certificate}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.certificate_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Certificate.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.certificate_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.certificate_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Certificate}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.certificate_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Certificate.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.certificate_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.certificate_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Certificate}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.certificate_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Certificate.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Will be deprecated in the next era. Use RegCert instead which takes an explicit deposit amount, as that can change.
    * @param {Credential} stake_credential
    * @returns {Certificate}
    */
    static new_stake_registration(stake_credential) {
        _assertClass(stake_credential, Credential);
        const ret = wasm.certificate_new_stake_registration(stake_credential.__wbg_ptr);
        return Certificate.__wrap(ret);
    }
    /**
    * Will be deprecated in the next era. Use UnregCert instead which takes an explicit deposit amount, as that can change.
    * @param {Credential} stake_credential
    * @returns {Certificate}
    */
    static new_stake_deregistration(stake_credential) {
        _assertClass(stake_credential, Credential);
        const ret = wasm.certificate_new_stake_deregistration(stake_credential.__wbg_ptr);
        return Certificate.__wrap(ret);
    }
    /**
    * Delegate to a take pool only
    * @param {Credential} stake_credential
    * @param {Ed25519KeyHash} pool
    * @returns {Certificate}
    */
    static new_stake_delegation(stake_credential, pool) {
        _assertClass(stake_credential, Credential);
        _assertClass(pool, Ed25519KeyHash);
        const ret = wasm.certificate_new_stake_delegation(stake_credential.__wbg_ptr, pool.__wbg_ptr);
        return Certificate.__wrap(ret);
    }
    /**
    * @param {PoolParams} pool_params
    * @returns {Certificate}
    */
    static new_pool_registration(pool_params) {
        _assertClass(pool_params, PoolParams);
        const ret = wasm.certificate_new_pool_registration(pool_params.__wbg_ptr);
        return Certificate.__wrap(ret);
    }
    /**
    * @param {Ed25519KeyHash} pool
    * @param {bigint} epoch
    * @returns {Certificate}
    */
    static new_pool_retirement(pool, epoch) {
        _assertClass(pool, Ed25519KeyHash);
        const ret = wasm.certificate_new_pool_retirement(pool.__wbg_ptr, epoch);
        return Certificate.__wrap(ret);
    }
    /**
    * Registers a stake credential.
    * @param {Credential} stake_credential
    * @param {bigint} deposit
    * @returns {Certificate}
    */
    static new_reg_cert(stake_credential, deposit) {
        _assertClass(stake_credential, Credential);
        const ret = wasm.certificate_new_reg_cert(stake_credential.__wbg_ptr, deposit);
        return Certificate.__wrap(ret);
    }
    /**
    * Unregisters a stake credential.
    * @param {Credential} stake_credential
    * @param {bigint} deposit
    * @returns {Certificate}
    */
    static new_unreg_cert(stake_credential, deposit) {
        _assertClass(stake_credential, Credential);
        const ret = wasm.certificate_new_unreg_cert(stake_credential.__wbg_ptr, deposit);
        return Certificate.__wrap(ret);
    }
    /**
    * Delegate to a DRep for voting only
    * @param {Credential} stake_credential
    * @param {DRep} d_rep
    * @returns {Certificate}
    */
    static new_vote_deleg_cert(stake_credential, d_rep) {
        _assertClass(stake_credential, Credential);
        _assertClass(d_rep, DRep);
        const ret = wasm.certificate_new_vote_deleg_cert(stake_credential.__wbg_ptr, d_rep.__wbg_ptr);
        return Certificate.__wrap(ret);
    }
    /**
    * Delegate to a stake pool and a DRep
    * @param {Credential} stake_credential
    * @param {Ed25519KeyHash} pool
    * @param {DRep} d_rep
    * @returns {Certificate}
    */
    static new_stake_vote_deleg_cert(stake_credential, pool, d_rep) {
        _assertClass(stake_credential, Credential);
        _assertClass(pool, Ed25519KeyHash);
        _assertClass(d_rep, DRep);
        const ret = wasm.certificate_new_stake_vote_deleg_cert(stake_credential.__wbg_ptr, pool.__wbg_ptr, d_rep.__wbg_ptr);
        return Certificate.__wrap(ret);
    }
    /**
    * Register a stake credential and delegate to a pool in a single cert
    * @param {Credential} stake_credential
    * @param {Ed25519KeyHash} pool
    * @param {bigint} deposit
    * @returns {Certificate}
    */
    static new_stake_reg_deleg_cert(stake_credential, pool, deposit) {
        _assertClass(stake_credential, Credential);
        _assertClass(pool, Ed25519KeyHash);
        const ret = wasm.certificate_new_stake_reg_deleg_cert(stake_credential.__wbg_ptr, pool.__wbg_ptr, deposit);
        return Certificate.__wrap(ret);
    }
    /**
    * Register a stake credential and delegate to a DRep in a single cert
    * @param {Credential} stake_credential
    * @param {DRep} d_rep
    * @param {bigint} deposit
    * @returns {Certificate}
    */
    static new_vote_reg_deleg_cert(stake_credential, d_rep, deposit) {
        _assertClass(stake_credential, Credential);
        _assertClass(d_rep, DRep);
        const ret = wasm.certificate_new_vote_reg_deleg_cert(stake_credential.__wbg_ptr, d_rep.__wbg_ptr, deposit);
        return Certificate.__wrap(ret);
    }
    /**
    * Register a stake credential and delegate to a pool and a DRep in a single cert
    * @param {Credential} stake_credential
    * @param {Ed25519KeyHash} pool
    * @param {DRep} d_rep
    * @param {bigint} deposit
    * @returns {Certificate}
    */
    static new_stake_vote_reg_deleg_cert(stake_credential, pool, d_rep, deposit) {
        _assertClass(stake_credential, Credential);
        _assertClass(pool, Ed25519KeyHash);
        _assertClass(d_rep, DRep);
        const ret = wasm.certificate_new_stake_vote_reg_deleg_cert(stake_credential.__wbg_ptr, pool.__wbg_ptr, d_rep.__wbg_ptr, deposit);
        return Certificate.__wrap(ret);
    }
    /**
    * @param {Credential} committee_cold_credential
    * @param {Credential} committee_hot_credential
    * @returns {Certificate}
    */
    static new_auth_committee_hot_cert(committee_cold_credential, committee_hot_credential) {
        _assertClass(committee_cold_credential, Credential);
        _assertClass(committee_hot_credential, Credential);
        const ret = wasm.certificate_new_auth_committee_hot_cert(committee_cold_credential.__wbg_ptr, committee_hot_credential.__wbg_ptr);
        return Certificate.__wrap(ret);
    }
    /**
    * @param {Credential} committee_cold_credential
    * @param {Anchor | undefined} [anchor]
    * @returns {Certificate}
    */
    static new_resign_committee_cold_cert(committee_cold_credential, anchor) {
        _assertClass(committee_cold_credential, Credential);
        let ptr0 = 0;
        if (!isLikeNone(anchor)) {
            _assertClass(anchor, Anchor);
            ptr0 = anchor.__destroy_into_raw();
        }
        const ret = wasm.certificate_new_resign_committee_cold_cert(committee_cold_credential.__wbg_ptr, ptr0);
        return Certificate.__wrap(ret);
    }
    /**
    * @param {Credential} drep_credential
    * @param {bigint} deposit
    * @param {Anchor | undefined} [anchor]
    * @returns {Certificate}
    */
    static new_reg_drep_cert(drep_credential, deposit, anchor) {
        _assertClass(drep_credential, Credential);
        let ptr0 = 0;
        if (!isLikeNone(anchor)) {
            _assertClass(anchor, Anchor);
            ptr0 = anchor.__destroy_into_raw();
        }
        const ret = wasm.certificate_new_reg_drep_cert(drep_credential.__wbg_ptr, deposit, ptr0);
        return Certificate.__wrap(ret);
    }
    /**
    * @param {Credential} drep_credential
    * @param {bigint} deposit
    * @returns {Certificate}
    */
    static new_unreg_drep_cert(drep_credential, deposit) {
        _assertClass(drep_credential, Credential);
        const ret = wasm.certificate_new_unreg_drep_cert(drep_credential.__wbg_ptr, deposit);
        return Certificate.__wrap(ret);
    }
    /**
    * @param {Credential} drep_credential
    * @param {Anchor | undefined} [anchor]
    * @returns {Certificate}
    */
    static new_update_drep_cert(drep_credential, anchor) {
        _assertClass(drep_credential, Credential);
        let ptr0 = 0;
        if (!isLikeNone(anchor)) {
            _assertClass(anchor, Anchor);
            ptr0 = anchor.__destroy_into_raw();
        }
        const ret = wasm.certificate_new_update_drep_cert(drep_credential.__wbg_ptr, ptr0);
        return Certificate.__wrap(ret);
    }
    /**
    * @returns {CertificateKind}
    */
    kind() {
        const ret = wasm.certificate_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {StakeRegistration | undefined}
    */
    as_stake_registration() {
        const ret = wasm.certificate_as_stake_registration(this.__wbg_ptr);
        return ret === 0 ? undefined : StakeRegistration.__wrap(ret);
    }
    /**
    * @returns {StakeDeregistration | undefined}
    */
    as_stake_deregistration() {
        const ret = wasm.certificate_as_stake_deregistration(this.__wbg_ptr);
        return ret === 0 ? undefined : StakeDeregistration.__wrap(ret);
    }
    /**
    * @returns {StakeDelegation | undefined}
    */
    as_stake_delegation() {
        const ret = wasm.certificate_as_stake_delegation(this.__wbg_ptr);
        return ret === 0 ? undefined : StakeDelegation.__wrap(ret);
    }
    /**
    * @returns {PoolRegistration | undefined}
    */
    as_pool_registration() {
        const ret = wasm.certificate_as_pool_registration(this.__wbg_ptr);
        return ret === 0 ? undefined : PoolRegistration.__wrap(ret);
    }
    /**
    * @returns {PoolRetirement | undefined}
    */
    as_pool_retirement() {
        const ret = wasm.certificate_as_pool_retirement(this.__wbg_ptr);
        return ret === 0 ? undefined : PoolRetirement.__wrap(ret);
    }
    /**
    * @returns {RegCert | undefined}
    */
    as_reg_cert() {
        const ret = wasm.certificate_as_reg_cert(this.__wbg_ptr);
        return ret === 0 ? undefined : RegCert.__wrap(ret);
    }
    /**
    * @returns {UnregCert | undefined}
    */
    as_unreg_cert() {
        const ret = wasm.certificate_as_unreg_cert(this.__wbg_ptr);
        return ret === 0 ? undefined : UnregCert.__wrap(ret);
    }
    /**
    * @returns {VoteDelegCert | undefined}
    */
    as_vote_deleg_cert() {
        const ret = wasm.certificate_as_vote_deleg_cert(this.__wbg_ptr);
        return ret === 0 ? undefined : VoteDelegCert.__wrap(ret);
    }
    /**
    * @returns {StakeVoteDelegCert | undefined}
    */
    as_stake_vote_deleg_cert() {
        const ret = wasm.certificate_as_stake_vote_deleg_cert(this.__wbg_ptr);
        return ret === 0 ? undefined : StakeVoteDelegCert.__wrap(ret);
    }
    /**
    * @returns {StakeRegDelegCert | undefined}
    */
    as_stake_reg_deleg_cert() {
        const ret = wasm.certificate_as_stake_reg_deleg_cert(this.__wbg_ptr);
        return ret === 0 ? undefined : StakeRegDelegCert.__wrap(ret);
    }
    /**
    * @returns {VoteRegDelegCert | undefined}
    */
    as_vote_reg_deleg_cert() {
        const ret = wasm.certificate_as_vote_reg_deleg_cert(this.__wbg_ptr);
        return ret === 0 ? undefined : VoteRegDelegCert.__wrap(ret);
    }
    /**
    * @returns {StakeVoteRegDelegCert | undefined}
    */
    as_stake_vote_reg_deleg_cert() {
        const ret = wasm.certificate_as_stake_vote_reg_deleg_cert(this.__wbg_ptr);
        return ret === 0 ? undefined : StakeVoteRegDelegCert.__wrap(ret);
    }
    /**
    * @returns {AuthCommitteeHotCert | undefined}
    */
    as_auth_committee_hot_cert() {
        const ret = wasm.certificate_as_auth_committee_hot_cert(this.__wbg_ptr);
        return ret === 0 ? undefined : AuthCommitteeHotCert.__wrap(ret);
    }
    /**
    * @returns {ResignCommitteeColdCert | undefined}
    */
    as_resign_committee_cold_cert() {
        const ret = wasm.certificate_as_resign_committee_cold_cert(this.__wbg_ptr);
        return ret === 0 ? undefined : ResignCommitteeColdCert.__wrap(ret);
    }
    /**
    * @returns {RegDrepCert | undefined}
    */
    as_reg_drep_cert() {
        const ret = wasm.certificate_as_reg_drep_cert(this.__wbg_ptr);
        return ret === 0 ? undefined : RegDrepCert.__wrap(ret);
    }
    /**
    * @returns {UnregDrepCert | undefined}
    */
    as_unreg_drep_cert() {
        const ret = wasm.certificate_as_unreg_drep_cert(this.__wbg_ptr);
        return ret === 0 ? undefined : UnregDrepCert.__wrap(ret);
    }
    /**
    * @returns {UpdateDrepCert | undefined}
    */
    as_update_drep_cert() {
        const ret = wasm.certificate_as_update_drep_cert(this.__wbg_ptr);
        return ret === 0 ? undefined : UpdateDrepCert.__wrap(ret);
    }
}

const CertificateBuilderResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_certificatebuilderresult_free(ptr >>> 0, 1));
/**
*/
class CertificateBuilderResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CertificateBuilderResult.prototype);
        obj.__wbg_ptr = ptr;
        CertificateBuilderResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CertificateBuilderResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_certificatebuilderresult_free(ptr, 0);
    }
}

const CertificateListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_certificatelist_free(ptr >>> 0, 1));
/**
*/
class CertificateList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CertificateList.prototype);
        obj.__wbg_ptr = ptr;
        CertificateListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CertificateListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_certificatelist_free(ptr, 0);
    }
    /**
    * @returns {CertificateList}
    */
    static new() {
        const ret = wasm.certificatelist_new();
        return CertificateList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.certificatelist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {Certificate}
    */
    get(index) {
        const ret = wasm.certificatelist_get(this.__wbg_ptr, index);
        return Certificate.__wrap(ret);
    }
    /**
    * @param {Certificate} elem
    */
    add(elem) {
        _assertClass(elem, Certificate);
        wasm.certificatelist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const CommitteeColdCredentialListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_committeecoldcredentiallist_free(ptr >>> 0, 1));
/**
*/
class CommitteeColdCredentialList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CommitteeColdCredentialList.prototype);
        obj.__wbg_ptr = ptr;
        CommitteeColdCredentialListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CommitteeColdCredentialListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_committeecoldcredentiallist_free(ptr, 0);
    }
    /**
    * @returns {CommitteeColdCredentialList}
    */
    static new() {
        const ret = wasm.committeecoldcredentiallist_new();
        return CommitteeColdCredentialList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.committeecoldcredentiallist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {Credential}
    */
    get(index) {
        const ret = wasm.committeecoldcredentiallist_get(this.__wbg_ptr, index);
        return Credential.__wrap(ret);
    }
    /**
    * @param {Credential} elem
    */
    add(elem) {
        _assertClass(elem, Credential);
        wasm.committeecoldcredentiallist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const ConstitutionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_constitution_free(ptr >>> 0, 1));
/**
*/
class Constitution {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Constitution.prototype);
        obj.__wbg_ptr = ptr;
        ConstitutionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ConstitutionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_constitution_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.constitution_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.constitution_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Constitution}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.constitution_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Constitution.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.constitution_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.constitution_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Constitution}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.constitution_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Constitution.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.constitution_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.constitution_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Constitution}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.constitution_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Constitution.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Anchor}
    */
    anchor() {
        const ret = wasm.constitution_anchor(this.__wbg_ptr);
        return Anchor.__wrap(ret);
    }
    /**
    * @returns {ScriptHash | undefined}
    */
    script_hash() {
        const ret = wasm.constitution_script_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptHash.__wrap(ret);
    }
    /**
    * @param {Anchor} anchor
    * @param {ScriptHash | undefined} [script_hash]
    * @returns {Constitution}
    */
    static new(anchor, script_hash) {
        _assertClass(anchor, Anchor);
        let ptr0 = 0;
        if (!isLikeNone(script_hash)) {
            _assertClass(script_hash, ScriptHash);
            ptr0 = script_hash.__destroy_into_raw();
        }
        const ret = wasm.constitution_new(anchor.__wbg_ptr, ptr0);
        return Constitution.__wrap(ret);
    }
}

const ConstrPlutusDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_constrplutusdata_free(ptr >>> 0, 1));
/**
*/
class ConstrPlutusData {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ConstrPlutusData.prototype);
        obj.__wbg_ptr = ptr;
        ConstrPlutusDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ConstrPlutusDataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_constrplutusdata_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.constrplutusdata_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.constrplutusdata_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ConstrPlutusData}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.constrplutusdata_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ConstrPlutusData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.constrplutusdata_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.constrplutusdata_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ConstrPlutusData}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.constrplutusdata_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ConstrPlutusData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.constrplutusdata_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.constrplutusdata_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ConstrPlutusData}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.constrplutusdata_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ConstrPlutusData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint}
    */
    alternative() {
        const ret = wasm.constrplutusdata_alternative(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {PlutusDataList}
    */
    fields() {
        const ret = wasm.constrplutusdata_fields(this.__wbg_ptr);
        return PlutusDataList.__wrap(ret);
    }
    /**
    * @param {bigint} alternative
    * @param {PlutusDataList} fields
    * @returns {ConstrPlutusData}
    */
    static new(alternative, fields) {
        _assertClass(fields, PlutusDataList);
        const ret = wasm.constrplutusdata_new(alternative, fields.__wbg_ptr);
        return ConstrPlutusData.__wrap(ret);
    }
}

const ConwayFormatAuxDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_conwayformatauxdata_free(ptr >>> 0, 1));
/**
*/
class ConwayFormatAuxData {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ConwayFormatAuxData.prototype);
        obj.__wbg_ptr = ptr;
        ConwayFormatAuxDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ConwayFormatAuxDataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_conwayformatauxdata_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.conwayformatauxdata_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.conwayformatauxdata_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ConwayFormatAuxData}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.conwayformatauxdata_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ConwayFormatAuxData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.conwayformatauxdata_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.conwayformatauxdata_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ConwayFormatAuxData}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.conwayformatauxdata_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ConwayFormatAuxData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.conwayformatauxdata_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.conwayformatauxdata_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ConwayFormatAuxData}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.conwayformatauxdata_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ConwayFormatAuxData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Metadata} metadata
    */
    set_metadata(metadata) {
        _assertClass(metadata, Metadata);
        wasm.conwayformatauxdata_set_metadata(this.__wbg_ptr, metadata.__wbg_ptr);
    }
    /**
    * @returns {Metadata | undefined}
    */
    metadata() {
        const ret = wasm.conwayformatauxdata_metadata(this.__wbg_ptr);
        return ret === 0 ? undefined : Metadata.__wrap(ret);
    }
    /**
    * @param {NativeScriptList} native_scripts
    */
    set_native_scripts(native_scripts) {
        _assertClass(native_scripts, NativeScriptList);
        wasm.conwayformatauxdata_set_native_scripts(this.__wbg_ptr, native_scripts.__wbg_ptr);
    }
    /**
    * @returns {NativeScriptList | undefined}
    */
    native_scripts() {
        const ret = wasm.conwayformatauxdata_native_scripts(this.__wbg_ptr);
        return ret === 0 ? undefined : NativeScriptList.__wrap(ret);
    }
    /**
    * @param {PlutusV1ScriptList} plutus_v1_scripts
    */
    set_plutus_v1_scripts(plutus_v1_scripts) {
        _assertClass(plutus_v1_scripts, PlutusV1ScriptList);
        wasm.conwayformatauxdata_set_plutus_v1_scripts(this.__wbg_ptr, plutus_v1_scripts.__wbg_ptr);
    }
    /**
    * @returns {PlutusV1ScriptList | undefined}
    */
    plutus_v1_scripts() {
        const ret = wasm.conwayformatauxdata_plutus_v1_scripts(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV1ScriptList.__wrap(ret);
    }
    /**
    * @param {PlutusV2ScriptList} plutus_v2_scripts
    */
    set_plutus_v2_scripts(plutus_v2_scripts) {
        _assertClass(plutus_v2_scripts, PlutusV2ScriptList);
        wasm.conwayformatauxdata_set_plutus_v2_scripts(this.__wbg_ptr, plutus_v2_scripts.__wbg_ptr);
    }
    /**
    * @returns {PlutusV2ScriptList | undefined}
    */
    plutus_v2_scripts() {
        const ret = wasm.conwayformatauxdata_plutus_v2_scripts(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV2ScriptList.__wrap(ret);
    }
    /**
    * @param {PlutusV3ScriptList} plutus_v3_scripts
    */
    set_plutus_v3_scripts(plutus_v3_scripts) {
        _assertClass(plutus_v3_scripts, PlutusV3ScriptList);
        wasm.conwayformatauxdata_set_plutus_v3_scripts(this.__wbg_ptr, plutus_v3_scripts.__wbg_ptr);
    }
    /**
    * @returns {PlutusV3ScriptList | undefined}
    */
    plutus_v3_scripts() {
        const ret = wasm.conwayformatauxdata_plutus_v3_scripts(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV3ScriptList.__wrap(ret);
    }
    /**
    * @returns {ConwayFormatAuxData}
    */
    static new() {
        const ret = wasm.conwayformatauxdata_new();
        return ConwayFormatAuxData.__wrap(ret);
    }
}

const ConwayFormatTxOutFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_conwayformattxout_free(ptr >>> 0, 1));
/**
*/
class ConwayFormatTxOut {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ConwayFormatTxOut.prototype);
        obj.__wbg_ptr = ptr;
        ConwayFormatTxOutFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ConwayFormatTxOutFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_conwayformattxout_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.conwayformattxout_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.conwayformattxout_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ConwayFormatTxOut}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.conwayformattxout_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ConwayFormatTxOut.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.conwayformattxout_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.conwayformattxout_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ConwayFormatTxOut}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.conwayformattxout_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ConwayFormatTxOut.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.conwayformattxout_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.conwayformattxout_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ConwayFormatTxOut}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.conwayformattxout_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ConwayFormatTxOut.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Address}
    */
    address() {
        const ret = wasm.conwayformattxout_address(this.__wbg_ptr);
        return Address.__wrap(ret);
    }
    /**
    * @returns {Value}
    */
    amount() {
        const ret = wasm.conwayformattxout_amount(this.__wbg_ptr);
        return Value.__wrap(ret);
    }
    /**
    * @param {DatumOption} datum_option
    */
    set_datum_option(datum_option) {
        _assertClass(datum_option, DatumOption);
        wasm.conwayformattxout_set_datum_option(this.__wbg_ptr, datum_option.__wbg_ptr);
    }
    /**
    * @returns {DatumOption | undefined}
    */
    datum_option() {
        const ret = wasm.conwayformattxout_datum_option(this.__wbg_ptr);
        return ret === 0 ? undefined : DatumOption.__wrap(ret);
    }
    /**
    * @param {Script} script_reference
    */
    set_script_reference(script_reference) {
        _assertClass(script_reference, Script);
        wasm.conwayformattxout_set_script_reference(this.__wbg_ptr, script_reference.__wbg_ptr);
    }
    /**
    * @returns {Script | undefined}
    */
    script_reference() {
        const ret = wasm.conwayformattxout_script_reference(this.__wbg_ptr);
        return ret === 0 ? undefined : Script.__wrap(ret);
    }
    /**
    * @param {Address} address
    * @param {Value} amount
    * @returns {ConwayFormatTxOut}
    */
    static new(address, amount) {
        _assertClass(address, Address);
        _assertClass(amount, Value);
        const ret = wasm.conwayformattxout_new(address.__wbg_ptr, amount.__wbg_ptr);
        return ConwayFormatTxOut.__wrap(ret);
    }
}

const CostModelsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_costmodels_free(ptr >>> 0, 1));
/**
*/
class CostModels {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CostModels.prototype);
        obj.__wbg_ptr = ptr;
        CostModelsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CostModelsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_costmodels_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.costmodels_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.costmodels_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {CostModels}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.costmodels_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CostModels.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.costmodels_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.costmodels_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {CostModels}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.costmodels_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CostModels.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.costmodels_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.costmodels_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {CostModels}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.costmodels_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CostModels.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {MapU64ToArrI64}
    */
    inner() {
        const ret = wasm.costmodels_inner(this.__wbg_ptr);
        return MapU64ToArrI64.__wrap(ret);
    }
}

const Crc32Finalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_crc32_free(ptr >>> 0, 1));
/**
*/
class Crc32 {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Crc32.prototype);
        obj.__wbg_ptr = ptr;
        Crc32Finalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Crc32Finalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_crc32_free(ptr, 0);
    }
    /**
    * initialise a new CRC32 state
    * @returns {Crc32}
    */
    static new() {
        const ret = wasm.crc32_new();
        return Crc32.__wrap(ret);
    }
    /**
    * update the CRC32 with the given bytes.
    *
    * beware that the order in which you update the Crc32
    * matter
    * @param {Uint8Array} bytes
    */
    update(bytes) {
        const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.crc32_update(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * finalize the CRC32, recovering the computed value
    * @returns {number}
    */
    finalize() {
        const ret = wasm.crc32_finalize(this.__wbg_ptr);
        return ret >>> 0;
    }
}

const CredentialFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_credential_free(ptr >>> 0, 1));
/**
*/
class Credential {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Credential.prototype);
        obj.__wbg_ptr = ptr;
        CredentialFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CredentialFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_credential_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.credential_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.credential_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Credential}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.credential_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Credential.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.credential_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.credential_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Credential}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.credential_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Credential.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.credential_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.credential_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Credential}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.credential_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Credential.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Ed25519KeyHash} hash
    * @returns {Credential}
    */
    static new_pub_key(hash) {
        _assertClass(hash, Ed25519KeyHash);
        const ret = wasm.credential_new_pub_key(hash.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @param {ScriptHash} hash
    * @returns {Credential}
    */
    static new_script(hash) {
        _assertClass(hash, ScriptHash);
        const ret = wasm.credential_new_script(hash.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {CredentialKind}
    */
    kind() {
        const ret = wasm.credential_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Ed25519KeyHash | undefined}
    */
    as_pub_key() {
        const ret = wasm.credential_as_pub_key(this.__wbg_ptr);
        return ret === 0 ? undefined : Ed25519KeyHash.__wrap(ret);
    }
    /**
    * @returns {ScriptHash | undefined}
    */
    as_script() {
        const ret = wasm.credential_as_script(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptHash.__wrap(ret);
    }
}

const DNSNameFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_dnsname_free(ptr >>> 0, 1));
/**
*/
class DNSName {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DNSName.prototype);
        obj.__wbg_ptr = ptr;
        DNSNameFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DNSNameFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_dnsname_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.dnsname_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.dnsname_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {DNSName}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.dnsname_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DNSName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.dnsname_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.dnsname_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {DNSName}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.dnsname_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DNSName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.dnsname_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.dnsname_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {DNSName}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.dnsname_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DNSName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    get() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.dnsname_get(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const DRepFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_drep_free(ptr >>> 0, 1));
/**
*/
class DRep {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DRep.prototype);
        obj.__wbg_ptr = ptr;
        DRepFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DRepFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_drep_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.drep_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.drep_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {DRep}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.drep_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DRep.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.drep_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.drep_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {DRep}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.drep_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DRep.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.drep_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.drep_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {DRep}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.drep_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DRep.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Ed25519KeyHash} pool
    * @returns {DRep}
    */
    static new_key(pool) {
        _assertClass(pool, Ed25519KeyHash);
        const ret = wasm.drep_new_key(pool.__wbg_ptr);
        return DRep.__wrap(ret);
    }
    /**
    * @param {ScriptHash} script_hash
    * @returns {DRep}
    */
    static new_script(script_hash) {
        _assertClass(script_hash, ScriptHash);
        const ret = wasm.drep_new_script(script_hash.__wbg_ptr);
        return DRep.__wrap(ret);
    }
    /**
    * @returns {DRep}
    */
    static new_always_abstain() {
        const ret = wasm.drep_new_always_abstain();
        return DRep.__wrap(ret);
    }
    /**
    * @returns {DRep}
    */
    static new_always_no_confidence() {
        const ret = wasm.drep_new_always_no_confidence();
        return DRep.__wrap(ret);
    }
    /**
    * @returns {DRepKind}
    */
    kind() {
        const ret = wasm.drep_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Ed25519KeyHash | undefined}
    */
    as_key() {
        const ret = wasm.drep_as_key(this.__wbg_ptr);
        return ret === 0 ? undefined : Ed25519KeyHash.__wrap(ret);
    }
    /**
    * @returns {ScriptHash | undefined}
    */
    as_script() {
        const ret = wasm.drep_as_script(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptHash.__wrap(ret);
    }
}

const DRepVotingThresholdsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_drepvotingthresholds_free(ptr >>> 0, 1));
/**
*/
class DRepVotingThresholds {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DRepVotingThresholds.prototype);
        obj.__wbg_ptr = ptr;
        DRepVotingThresholdsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DRepVotingThresholdsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_drepvotingthresholds_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.drepvotingthresholds_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.drepvotingthresholds_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {DRepVotingThresholds}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.drepvotingthresholds_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DRepVotingThresholds.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.drepvotingthresholds_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.drepvotingthresholds_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {DRepVotingThresholds}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.drepvotingthresholds_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DRepVotingThresholds.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.drepvotingthresholds_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.drepvotingthresholds_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {DRepVotingThresholds}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.drepvotingthresholds_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DRepVotingThresholds.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {UnitInterval}
    */
    motion_no_confidence() {
        const ret = wasm.drepvotingthresholds_motion_no_confidence(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    committee_normal() {
        const ret = wasm.drepvotingthresholds_committee_normal(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    committee_no_confidence() {
        const ret = wasm.drepvotingthresholds_committee_no_confidence(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    update_constitution() {
        const ret = wasm.drepvotingthresholds_update_constitution(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    hard_fork_initiation() {
        const ret = wasm.drepvotingthresholds_hard_fork_initiation(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    pp_network_group() {
        const ret = wasm.drepvotingthresholds_pp_network_group(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    pp_economic_group() {
        const ret = wasm.drepvotingthresholds_pp_economic_group(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    pp_technical_group() {
        const ret = wasm.drepvotingthresholds_pp_technical_group(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    pp_governance_group() {
        const ret = wasm.drepvotingthresholds_pp_governance_group(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    treasury_withdrawal() {
        const ret = wasm.drepvotingthresholds_treasury_withdrawal(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @param {UnitInterval} motion_no_confidence
    * @param {UnitInterval} committee_normal
    * @param {UnitInterval} committee_no_confidence
    * @param {UnitInterval} update_constitution
    * @param {UnitInterval} hard_fork_initiation
    * @param {UnitInterval} pp_network_group
    * @param {UnitInterval} pp_economic_group
    * @param {UnitInterval} pp_technical_group
    * @param {UnitInterval} pp_governance_group
    * @param {UnitInterval} treasury_withdrawal
    * @returns {DRepVotingThresholds}
    */
    static new(motion_no_confidence, committee_normal, committee_no_confidence, update_constitution, hard_fork_initiation, pp_network_group, pp_economic_group, pp_technical_group, pp_governance_group, treasury_withdrawal) {
        _assertClass(motion_no_confidence, UnitInterval);
        _assertClass(committee_normal, UnitInterval);
        _assertClass(committee_no_confidence, UnitInterval);
        _assertClass(update_constitution, UnitInterval);
        _assertClass(hard_fork_initiation, UnitInterval);
        _assertClass(pp_network_group, UnitInterval);
        _assertClass(pp_economic_group, UnitInterval);
        _assertClass(pp_technical_group, UnitInterval);
        _assertClass(pp_governance_group, UnitInterval);
        _assertClass(treasury_withdrawal, UnitInterval);
        const ret = wasm.drepvotingthresholds_new(motion_no_confidence.__wbg_ptr, committee_normal.__wbg_ptr, committee_no_confidence.__wbg_ptr, update_constitution.__wbg_ptr, hard_fork_initiation.__wbg_ptr, pp_network_group.__wbg_ptr, pp_economic_group.__wbg_ptr, pp_technical_group.__wbg_ptr, pp_governance_group.__wbg_ptr, treasury_withdrawal.__wbg_ptr);
        return DRepVotingThresholds.__wrap(ret);
    }
}

const DatumHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_datumhash_free(ptr >>> 0, 1));
/**
*/
class DatumHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DatumHash.prototype);
        obj.__wbg_ptr = ptr;
        DatumHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DatumHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_datumhash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.datumhash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {DatumHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.datumhash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DatumHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.datumhash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {DatumHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.datumhash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DatumHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.datumhash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {DatumHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.datumhash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DatumHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const DatumOptionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_datumoption_free(ptr >>> 0, 1));
/**
*/
class DatumOption {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DatumOption.prototype);
        obj.__wbg_ptr = ptr;
        DatumOptionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DatumOptionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_datumoption_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.datumoption_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.datumoption_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {DatumOption}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.datumoption_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DatumOption.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.datumoption_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.datumoption_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {DatumOption}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.datumoption_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DatumOption.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.datumoption_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.datumoption_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {DatumOption}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.datumoption_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return DatumOption.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {DatumHash} datum_hash
    * @returns {DatumOption}
    */
    static new_hash(datum_hash) {
        _assertClass(datum_hash, DatumHash);
        const ret = wasm.datumoption_new_hash(datum_hash.__wbg_ptr);
        return DatumOption.__wrap(ret);
    }
    /**
    * @param {PlutusData} datum
    * @returns {DatumOption}
    */
    static new_datum(datum) {
        _assertClass(datum, PlutusData);
        const ret = wasm.datumoption_new_datum(datum.__wbg_ptr);
        return DatumOption.__wrap(ret);
    }
    /**
    * @returns {DatumOptionKind}
    */
    kind() {
        const ret = wasm.datumoption_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {DatumHash | undefined}
    */
    as_hash() {
        const ret = wasm.datumoption_as_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : DatumHash.__wrap(ret);
    }
    /**
    * @returns {PlutusData | undefined}
    */
    as_datum() {
        const ret = wasm.datumoption_as_datum(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusData.__wrap(ret);
    }
}

const Ed25519KeyHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ed25519keyhash_free(ptr >>> 0, 1));
/**
*/
class Ed25519KeyHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Ed25519KeyHash.prototype);
        obj.__wbg_ptr = ptr;
        Ed25519KeyHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Ed25519KeyHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ed25519keyhash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ed25519keyhash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {Ed25519KeyHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ed25519keyhash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Ed25519KeyHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ed25519keyhash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {Ed25519KeyHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ed25519keyhash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Ed25519KeyHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ed25519keyhash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {Ed25519KeyHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ed25519keyhash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Ed25519KeyHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const Ed25519KeyHashListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ed25519keyhashlist_free(ptr >>> 0, 1));
/**
*/
class Ed25519KeyHashList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Ed25519KeyHashList.prototype);
        obj.__wbg_ptr = ptr;
        Ed25519KeyHashListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Ed25519KeyHashListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ed25519keyhashlist_free(ptr, 0);
    }
    /**
    * @returns {Ed25519KeyHashList}
    */
    static new() {
        const ret = wasm.ed25519keyhashlist_new();
        return Ed25519KeyHashList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.ed25519keyhashlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {Ed25519KeyHash}
    */
    get(index) {
        const ret = wasm.ed25519keyhashlist_get(this.__wbg_ptr, index);
        return Ed25519KeyHash.__wrap(ret);
    }
    /**
    * @param {Ed25519KeyHash} elem
    */
    add(elem) {
        _assertClass(elem, Ed25519KeyHash);
        wasm.ed25519keyhashlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const Ed25519SignatureFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ed25519signature_free(ptr >>> 0, 1));
/**
*/
class Ed25519Signature {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Ed25519Signature.prototype);
        obj.__wbg_ptr = ptr;
        Ed25519SignatureFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Ed25519SignatureFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ed25519signature_free(ptr, 0);
    }
    /**
    * @returns {string}
    */
    to_bech32() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ed25519signature_to_bech32(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {Ed25519Signature}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ed25519signature_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Ed25519Signature.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ed25519signature_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {Ed25519Signature}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ed25519signature_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Ed25519Signature.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ed25519signature_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {Ed25519Signature}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ed25519signature_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Ed25519Signature.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const EnterpriseAddressFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_enterpriseaddress_free(ptr >>> 0, 1));
/**
*/
class EnterpriseAddress {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(EnterpriseAddress.prototype);
        obj.__wbg_ptr = ptr;
        EnterpriseAddressFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        EnterpriseAddressFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_enterpriseaddress_free(ptr, 0);
    }
    /**
    * @param {number} network
    * @param {Credential} payment
    * @returns {EnterpriseAddress}
    */
    static new(network, payment) {
        _assertClass(payment, Credential);
        const ret = wasm.enterpriseaddress_new(network, payment.__wbg_ptr);
        return EnterpriseAddress.__wrap(ret);
    }
    /**
    * @returns {Address}
    */
    to_address() {
        const ret = wasm.enterpriseaddress_to_address(this.__wbg_ptr);
        return Address.__wrap(ret);
    }
    /**
    * @param {Address} address
    * @returns {EnterpriseAddress | undefined}
    */
    static from_address(address) {
        _assertClass(address, Address);
        const ret = wasm.enterpriseaddress_from_address(address.__wbg_ptr);
        return ret === 0 ? undefined : EnterpriseAddress.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    network_id() {
        const ret = wasm.enterpriseaddress_network_id(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Credential}
    */
    payment() {
        const ret = wasm.enterpriseaddress_payment(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
}

const ExUnitPricesFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_exunitprices_free(ptr >>> 0, 1));
/**
*/
class ExUnitPrices {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ExUnitPrices.prototype);
        obj.__wbg_ptr = ptr;
        ExUnitPricesFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ExUnitPricesFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_exunitprices_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.exunitprices_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.exunitprices_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ExUnitPrices}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.exunitprices_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ExUnitPrices.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.exunitprices_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.exunitprices_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ExUnitPrices}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.exunitprices_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ExUnitPrices.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.exunitprices_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.exunitprices_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ExUnitPrices}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.exunitprices_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ExUnitPrices.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Rational}
    */
    mem_price() {
        const ret = wasm.exunitprices_mem_price(this.__wbg_ptr);
        return Rational.__wrap(ret);
    }
    /**
    * @returns {Rational}
    */
    step_price() {
        const ret = wasm.exunitprices_step_price(this.__wbg_ptr);
        return Rational.__wrap(ret);
    }
    /**
    * @param {Rational} mem_price
    * @param {Rational} step_price
    * @returns {ExUnitPrices}
    */
    static new(mem_price, step_price) {
        _assertClass(mem_price, Rational);
        _assertClass(step_price, Rational);
        const ret = wasm.exunitprices_new(mem_price.__wbg_ptr, step_price.__wbg_ptr);
        return ExUnitPrices.__wrap(ret);
    }
}

const ExUnitsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_exunits_free(ptr >>> 0, 1));
/**
*/
class ExUnits {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ExUnits.prototype);
        obj.__wbg_ptr = ptr;
        ExUnitsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ExUnitsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_exunits_free(ptr, 0);
    }
    /**
    * @param {ExUnits} other
    * @returns {ExUnits}
    */
    checked_add(other) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(other, ExUnits);
            wasm.exunits_checked_add(retptr, this.__wbg_ptr, other.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ExUnits.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.exunits_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.exunits_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ExUnits}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.exunits_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ExUnits.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.exunits_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.exunits_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ExUnits}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.exunits_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ExUnits.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.exunits_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.exunits_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ExUnits}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.exunits_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ExUnits.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint}
    */
    mem() {
        const ret = wasm.exunits_mem(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {bigint}
    */
    steps() {
        const ret = wasm.exunits_steps(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} mem
    * @param {bigint} steps
    * @returns {ExUnits}
    */
    static new(mem, steps) {
        const ret = wasm.exunits_new(mem, steps);
        return ExUnits.__wrap(ret);
    }
}

const FilesDetailsListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_filesdetailslist_free(ptr >>> 0, 1));
/**
*/
class FilesDetailsList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(FilesDetailsList.prototype);
        obj.__wbg_ptr = ptr;
        FilesDetailsListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FilesDetailsListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_filesdetailslist_free(ptr, 0);
    }
    /**
    * @returns {FilesDetailsList}
    */
    static new() {
        const ret = wasm.filesdetailslist_new();
        return FilesDetailsList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.filesdetailslist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {CIP25FilesDetails}
    */
    get(index) {
        const ret = wasm.filesdetailslist_get(this.__wbg_ptr, index);
        return CIP25FilesDetails.__wrap(ret);
    }
    /**
    * @param {CIP25FilesDetails} elem
    */
    add(elem) {
        _assertClass(elem, CIP25FilesDetails);
        wasm.filesdetailslist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const GenesisDelegateHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_genesisdelegatehash_free(ptr >>> 0, 1));
/**
*/
class GenesisDelegateHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(GenesisDelegateHash.prototype);
        obj.__wbg_ptr = ptr;
        GenesisDelegateHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GenesisDelegateHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_genesisdelegatehash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.genesisdelegatehash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {GenesisDelegateHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.genesisdelegatehash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return GenesisDelegateHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.genesisdelegatehash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {GenesisDelegateHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.genesisdelegatehash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return GenesisDelegateHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.genesisdelegatehash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {GenesisDelegateHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.genesisdelegatehash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return GenesisDelegateHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const GenesisHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_genesishash_free(ptr >>> 0, 1));
/**
*/
class GenesisHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(GenesisHash.prototype);
        obj.__wbg_ptr = ptr;
        GenesisHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GenesisHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_genesishash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.genesishash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {GenesisHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.genesishash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return GenesisHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.genesishash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {GenesisHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.genesishash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return GenesisHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.genesishash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {GenesisHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.genesishash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return GenesisHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const GovActionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_govaction_free(ptr >>> 0, 1));
/**
*/
class GovAction {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(GovAction.prototype);
        obj.__wbg_ptr = ptr;
        GovActionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GovActionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_govaction_free(ptr, 0);
    }
    /**
    * @returns {ScriptHash | undefined}
    */
    script_hash() {
        const ret = wasm.govaction_script_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptHash.__wrap(ret);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.govaction_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.govaction_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {GovAction}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.govaction_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return GovAction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.govaction_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.govaction_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {GovAction}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.govaction_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return GovAction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.govaction_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.govaction_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {GovAction}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.govaction_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return GovAction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {GovActionId | undefined} action_id
    * @param {ProtocolParamUpdate} update
    * @param {ScriptHash | undefined} [policy_hash]
    * @returns {GovAction}
    */
    static new_parameter_change_action(action_id, update, policy_hash) {
        let ptr0 = 0;
        if (!isLikeNone(action_id)) {
            _assertClass(action_id, GovActionId);
            ptr0 = action_id.__destroy_into_raw();
        }
        _assertClass(update, ProtocolParamUpdate);
        let ptr1 = 0;
        if (!isLikeNone(policy_hash)) {
            _assertClass(policy_hash, ScriptHash);
            ptr1 = policy_hash.__destroy_into_raw();
        }
        const ret = wasm.govaction_new_parameter_change_action(ptr0, update.__wbg_ptr, ptr1);
        return GovAction.__wrap(ret);
    }
    /**
    * @param {GovActionId | undefined} action_id
    * @param {ProtocolVersion} version
    * @returns {GovAction}
    */
    static new_hard_fork_initiation_action(action_id, version) {
        let ptr0 = 0;
        if (!isLikeNone(action_id)) {
            _assertClass(action_id, GovActionId);
            ptr0 = action_id.__destroy_into_raw();
        }
        _assertClass(version, ProtocolVersion);
        const ret = wasm.govaction_new_hard_fork_initiation_action(ptr0, version.__wbg_ptr);
        return GovAction.__wrap(ret);
    }
    /**
    * @param {MapRewardAccountToCoin} withdrawal
    * @param {ScriptHash | undefined} [policy_hash]
    * @returns {GovAction}
    */
    static new_treasury_withdrawals_action(withdrawal, policy_hash) {
        _assertClass(withdrawal, MapRewardAccountToCoin);
        let ptr0 = 0;
        if (!isLikeNone(policy_hash)) {
            _assertClass(policy_hash, ScriptHash);
            ptr0 = policy_hash.__destroy_into_raw();
        }
        const ret = wasm.govaction_new_treasury_withdrawals_action(withdrawal.__wbg_ptr, ptr0);
        return GovAction.__wrap(ret);
    }
    /**
    * @param {GovActionId | undefined} [action_id]
    * @returns {GovAction}
    */
    static new_no_confidence(action_id) {
        let ptr0 = 0;
        if (!isLikeNone(action_id)) {
            _assertClass(action_id, GovActionId);
            ptr0 = action_id.__destroy_into_raw();
        }
        const ret = wasm.govaction_new_no_confidence(ptr0);
        return GovAction.__wrap(ret);
    }
    /**
    * @param {GovActionId | undefined} action_id
    * @param {CommitteeColdCredentialList} cold_credentials
    * @param {MapCommitteeColdCredentialToEpoch} credentials
    * @param {UnitInterval} unit_interval
    * @returns {GovAction}
    */
    static new_update_committee(action_id, cold_credentials, credentials, unit_interval) {
        let ptr0 = 0;
        if (!isLikeNone(action_id)) {
            _assertClass(action_id, GovActionId);
            ptr0 = action_id.__destroy_into_raw();
        }
        _assertClass(cold_credentials, CommitteeColdCredentialList);
        _assertClass(credentials, MapCommitteeColdCredentialToEpoch);
        _assertClass(unit_interval, UnitInterval);
        const ret = wasm.govaction_new_update_committee(ptr0, cold_credentials.__wbg_ptr, credentials.__wbg_ptr, unit_interval.__wbg_ptr);
        return GovAction.__wrap(ret);
    }
    /**
    * @param {GovActionId | undefined} action_id
    * @param {Constitution} constitution
    * @returns {GovAction}
    */
    static new_new_constitution(action_id, constitution) {
        let ptr0 = 0;
        if (!isLikeNone(action_id)) {
            _assertClass(action_id, GovActionId);
            ptr0 = action_id.__destroy_into_raw();
        }
        _assertClass(constitution, Constitution);
        const ret = wasm.govaction_new_new_constitution(ptr0, constitution.__wbg_ptr);
        return GovAction.__wrap(ret);
    }
    /**
    * @returns {GovAction}
    */
    static new_info_action() {
        const ret = wasm.govaction_new_info_action();
        return GovAction.__wrap(ret);
    }
    /**
    * @returns {GovActionKind}
    */
    kind() {
        const ret = wasm.govaction_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {ParameterChangeAction | undefined}
    */
    as_parameter_change_action() {
        const ret = wasm.govaction_as_parameter_change_action(this.__wbg_ptr);
        return ret === 0 ? undefined : ParameterChangeAction.__wrap(ret);
    }
    /**
    * @returns {HardForkInitiationAction | undefined}
    */
    as_hard_fork_initiation_action() {
        const ret = wasm.govaction_as_hard_fork_initiation_action(this.__wbg_ptr);
        return ret === 0 ? undefined : HardForkInitiationAction.__wrap(ret);
    }
    /**
    * @returns {TreasuryWithdrawalsAction | undefined}
    */
    as_treasury_withdrawals_action() {
        const ret = wasm.govaction_as_treasury_withdrawals_action(this.__wbg_ptr);
        return ret === 0 ? undefined : TreasuryWithdrawalsAction.__wrap(ret);
    }
    /**
    * @returns {NoConfidence | undefined}
    */
    as_no_confidence() {
        const ret = wasm.govaction_as_no_confidence(this.__wbg_ptr);
        return ret === 0 ? undefined : NoConfidence.__wrap(ret);
    }
    /**
    * @returns {UpdateCommittee | undefined}
    */
    as_update_committee() {
        const ret = wasm.govaction_as_update_committee(this.__wbg_ptr);
        return ret === 0 ? undefined : UpdateCommittee.__wrap(ret);
    }
    /**
    * @returns {NewConstitution | undefined}
    */
    as_new_constitution() {
        const ret = wasm.govaction_as_new_constitution(this.__wbg_ptr);
        return ret === 0 ? undefined : NewConstitution.__wrap(ret);
    }
}

const GovActionIdFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_govactionid_free(ptr >>> 0, 1));
/**
*/
class GovActionId {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(GovActionId.prototype);
        obj.__wbg_ptr = ptr;
        GovActionIdFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GovActionIdFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_govactionid_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.govactionid_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.govactionid_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {GovActionId}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.govactionid_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return GovActionId.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.govactionid_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.govactionid_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {GovActionId}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.govactionid_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return GovActionId.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.govactionid_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.govactionid_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {GovActionId}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.govactionid_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return GovActionId.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {TransactionHash}
    */
    transaction_id() {
        const ret = wasm.govactionid_transaction_id(this.__wbg_ptr);
        return TransactionHash.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    gov_action_index() {
        const ret = wasm.govactionid_gov_action_index(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {TransactionHash} transaction_id
    * @param {bigint} gov_action_index
    * @returns {GovActionId}
    */
    static new(transaction_id, gov_action_index) {
        _assertClass(transaction_id, TransactionHash);
        const ret = wasm.govactionid_new(transaction_id.__wbg_ptr, gov_action_index);
        return GovActionId.__wrap(ret);
    }
}

const GovActionIdListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_govactionidlist_free(ptr >>> 0, 1));
/**
*/
class GovActionIdList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(GovActionIdList.prototype);
        obj.__wbg_ptr = ptr;
        GovActionIdListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GovActionIdListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_govactionidlist_free(ptr, 0);
    }
    /**
    * @returns {GovActionIdList}
    */
    static new() {
        const ret = wasm.govactionidlist_new();
        return GovActionIdList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.govactionidlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {GovActionId}
    */
    get(index) {
        const ret = wasm.govactionidlist_get(this.__wbg_ptr, index);
        return GovActionId.__wrap(ret);
    }
    /**
    * @param {GovActionId} elem
    */
    add(elem) {
        _assertClass(elem, GovActionId);
        wasm.govactionidlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const HDAddressPayloadFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_hdaddresspayload_free(ptr >>> 0, 1));
/**
*/
class HDAddressPayload {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(HDAddressPayload.prototype);
        obj.__wbg_ptr = ptr;
        HDAddressPayloadFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        HDAddressPayloadFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_hdaddresspayload_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes.
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.hdaddresspayload_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {HDAddressPayload}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.hdaddresspayload_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return HDAddressPayload.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.hdaddresspayload_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {HDAddressPayload}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.hdaddresspayload_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return HDAddressPayload.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    get() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.hdaddresspayload_get(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const HardForkInitiationActionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_hardforkinitiationaction_free(ptr >>> 0, 1));
/**
*/
class HardForkInitiationAction {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(HardForkInitiationAction.prototype);
        obj.__wbg_ptr = ptr;
        HardForkInitiationActionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        HardForkInitiationActionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_hardforkinitiationaction_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.hardforkinitiationaction_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.hardforkinitiationaction_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {HardForkInitiationAction}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.hardforkinitiationaction_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return HardForkInitiationAction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.hardforkinitiationaction_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.hardforkinitiationaction_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {HardForkInitiationAction}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.hardforkinitiationaction_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return HardForkInitiationAction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.hardforkinitiationaction_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.hardforkinitiationaction_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {HardForkInitiationAction}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.hardforkinitiationaction_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return HardForkInitiationAction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {GovActionId | undefined}
    */
    action_id() {
        const ret = wasm.hardforkinitiationaction_action_id(this.__wbg_ptr);
        return ret === 0 ? undefined : GovActionId.__wrap(ret);
    }
    /**
    * @returns {ProtocolVersion}
    */
    version() {
        const ret = wasm.hardforkinitiationaction_version(this.__wbg_ptr);
        return ProtocolVersion.__wrap(ret);
    }
    /**
    * @param {GovActionId | undefined} action_id
    * @param {ProtocolVersion} version
    * @returns {HardForkInitiationAction}
    */
    static new(action_id, version) {
        let ptr0 = 0;
        if (!isLikeNone(action_id)) {
            _assertClass(action_id, GovActionId);
            ptr0 = action_id.__destroy_into_raw();
        }
        _assertClass(version, ProtocolVersion);
        const ret = wasm.hardforkinitiationaction_new(ptr0, version.__wbg_ptr);
        return HardForkInitiationAction.__wrap(ret);
    }
}

const HeaderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_header_free(ptr >>> 0, 1));
/**
*/
class Header {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Header.prototype);
        obj.__wbg_ptr = ptr;
        HeaderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        HeaderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_header_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.header_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.header_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Header}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.header_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Header.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.header_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.header_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Header}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.header_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Header.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.header_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.header_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Header}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.header_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Header.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {HeaderBody}
    */
    header_body() {
        const ret = wasm.header_header_body(this.__wbg_ptr);
        return HeaderBody.__wrap(ret);
    }
    /**
    * @returns {KESSignature}
    */
    body_signature() {
        const ret = wasm.header_body_signature(this.__wbg_ptr);
        return KESSignature.__wrap(ret);
    }
    /**
    * @param {HeaderBody} header_body
    * @param {KESSignature} body_signature
    * @returns {Header}
    */
    static new(header_body, body_signature) {
        _assertClass(header_body, HeaderBody);
        _assertClass(body_signature, KESSignature);
        const ret = wasm.header_new(header_body.__wbg_ptr, body_signature.__wbg_ptr);
        return Header.__wrap(ret);
    }
}

const HeaderBodyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_headerbody_free(ptr >>> 0, 1));
/**
*/
class HeaderBody {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(HeaderBody.prototype);
        obj.__wbg_ptr = ptr;
        HeaderBodyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        HeaderBodyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_headerbody_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.headerbody_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.headerbody_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {HeaderBody}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.headerbody_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return HeaderBody.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.headerbody_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.headerbody_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {HeaderBody}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.headerbody_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return HeaderBody.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.headerbody_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.headerbody_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {HeaderBody}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.headerbody_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return HeaderBody.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint}
    */
    block_number() {
        const ret = wasm.headerbody_block_number(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {bigint}
    */
    slot() {
        const ret = wasm.headerbody_slot(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {BlockHeaderHash | undefined}
    */
    prev_hash() {
        const ret = wasm.headerbody_prev_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : BlockHeaderHash.__wrap(ret);
    }
    /**
    * @returns {PublicKey}
    */
    issuer_vkey() {
        const ret = wasm.headerbody_issuer_vkey(this.__wbg_ptr);
        return PublicKey.__wrap(ret);
    }
    /**
    * @returns {VRFVkey}
    */
    vrf_vkey() {
        const ret = wasm.headerbody_vrf_vkey(this.__wbg_ptr);
        return VRFVkey.__wrap(ret);
    }
    /**
    * @returns {VRFCert}
    */
    vrf_result() {
        const ret = wasm.headerbody_vrf_result(this.__wbg_ptr);
        return VRFCert.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    block_body_size() {
        const ret = wasm.headerbody_block_body_size(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {BlockBodyHash}
    */
    block_body_hash() {
        const ret = wasm.headerbody_block_body_hash(this.__wbg_ptr);
        return BlockBodyHash.__wrap(ret);
    }
    /**
    * @returns {OperationalCert}
    */
    operational_cert() {
        const ret = wasm.headerbody_operational_cert(this.__wbg_ptr);
        return OperationalCert.__wrap(ret);
    }
    /**
    * @returns {ProtocolVersion}
    */
    protocol_version() {
        const ret = wasm.headerbody_protocol_version(this.__wbg_ptr);
        return ProtocolVersion.__wrap(ret);
    }
    /**
    * @param {bigint} block_number
    * @param {bigint} slot
    * @param {BlockHeaderHash | undefined} prev_hash
    * @param {PublicKey} issuer_vkey
    * @param {VRFVkey} vrf_vkey
    * @param {VRFCert} vrf_result
    * @param {bigint} block_body_size
    * @param {BlockBodyHash} block_body_hash
    * @param {OperationalCert} operational_cert
    * @param {ProtocolVersion} protocol_version
    * @returns {HeaderBody}
    */
    static new(block_number, slot, prev_hash, issuer_vkey, vrf_vkey, vrf_result, block_body_size, block_body_hash, operational_cert, protocol_version) {
        let ptr0 = 0;
        if (!isLikeNone(prev_hash)) {
            _assertClass(prev_hash, BlockHeaderHash);
            ptr0 = prev_hash.__destroy_into_raw();
        }
        _assertClass(issuer_vkey, PublicKey);
        _assertClass(vrf_vkey, VRFVkey);
        _assertClass(vrf_result, VRFCert);
        _assertClass(block_body_hash, BlockBodyHash);
        _assertClass(operational_cert, OperationalCert);
        _assertClass(protocol_version, ProtocolVersion);
        const ret = wasm.headerbody_new(block_number, slot, ptr0, issuer_vkey.__wbg_ptr, vrf_vkey.__wbg_ptr, vrf_result.__wbg_ptr, block_body_size, block_body_hash.__wbg_ptr, operational_cert.__wbg_ptr, protocol_version.__wbg_ptr);
        return HeaderBody.__wrap(ret);
    }
}

const InputAggregateWitnessDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_inputaggregatewitnessdata_free(ptr >>> 0, 1));
/**
*/
class InputAggregateWitnessData {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        InputAggregateWitnessDataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_inputaggregatewitnessdata_free(ptr, 0);
    }
    /**
    * @returns {PlutusData | undefined}
    */
    plutus_data() {
        const ret = wasm.inputaggregatewitnessdata_plutus_data(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusData.__wrap(ret);
    }
}

const InputBuilderResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_inputbuilderresult_free(ptr >>> 0, 1));
/**
*/
class InputBuilderResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(InputBuilderResult.prototype);
        obj.__wbg_ptr = ptr;
        InputBuilderResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        InputBuilderResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_inputbuilderresult_free(ptr, 0);
    }
}

const IntFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_int_free(ptr >>> 0, 1));
/**
*/
class Int {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Int.prototype);
        obj.__wbg_ptr = ptr;
        IntFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        IntFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_int_free(ptr, 0);
    }
    /**
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.int_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} cbor_bytes
    * @returns {Int}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.int_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Int.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.int_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_json_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.int_to_json_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Int}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.int_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Int.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} x
    * @returns {Int}
    */
    static new(x) {
        const ret = wasm.int_new(x);
        return Int.__wrap(ret);
    }
    /**
    * @returns {string}
    */
    to_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.int_to_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {string} string
    * @returns {Int}
    */
    static from_str(string) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.int_from_str(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Int.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const IntListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_intlist_free(ptr >>> 0, 1));
/**
*/
class IntList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(IntList.prototype);
        obj.__wbg_ptr = ptr;
        IntListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        IntListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_intlist_free(ptr, 0);
    }
    /**
    * @returns {IntList}
    */
    static new() {
        const ret = wasm.intlist_new();
        return IntList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.intlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {Int}
    */
    get(index) {
        const ret = wasm.intlist_get(this.__wbg_ptr, index);
        return Int.__wrap(ret);
    }
    /**
    * @param {Int} elem
    */
    add(elem) {
        _assertClass(elem, Int);
        wasm.intlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const Ipv4Finalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ipv4_free(ptr >>> 0, 1));
/**
*/
class Ipv4 {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Ipv4.prototype);
        obj.__wbg_ptr = ptr;
        Ipv4Finalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Ipv4Finalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ipv4_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv4_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv4_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Ipv4}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ipv4_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Ipv4.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv4_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv4_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Ipv4}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ipv4_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Ipv4.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv4_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv4_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Ipv4}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ipv4_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Ipv4.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    get() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv4_get(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const Ipv6Finalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ipv6_free(ptr >>> 0, 1));
/**
*/
class Ipv6 {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Ipv6.prototype);
        obj.__wbg_ptr = ptr;
        Ipv6Finalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Ipv6Finalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ipv6_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv6_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv6_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Ipv6}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ipv6_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Ipv6.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv6_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv6_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Ipv6}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ipv6_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Ipv6.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv6_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv6_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Ipv6}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ipv6_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Ipv6.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    get() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ipv6_get(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const KESSignatureFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_kessignature_free(ptr >>> 0, 1));
/**
*/
class KESSignature {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(KESSignature.prototype);
        obj.__wbg_ptr = ptr;
        KESSignatureFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        KESSignatureFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_kessignature_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.kessignature_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.kessignature_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {KESSignature}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.kessignature_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return KESSignature.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.kessignature_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.kessignature_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {KESSignature}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.kessignature_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return KESSignature.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.kessignature_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.kessignature_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {KESSignature}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.kessignature_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return KESSignature.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    get() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.kessignature_get(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const KESVkeyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_kesvkey_free(ptr >>> 0, 1));
/**
*/
class KESVkey {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(KESVkey.prototype);
        obj.__wbg_ptr = ptr;
        KESVkeyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        KESVkeyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_kesvkey_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.kesvkey_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {KESVkey}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.kesvkey_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return KESVkey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.kesvkey_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {KESVkey}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.kesvkey_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return KESVkey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.kesvkey_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {KESVkey}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.kesvkey_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return KESVkey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const LanguageListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_languagelist_free(ptr >>> 0, 1));
/**
*/
class LanguageList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(LanguageList.prototype);
        obj.__wbg_ptr = ptr;
        LanguageListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LanguageListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_languagelist_free(ptr, 0);
    }
    /**
    * @returns {LanguageList}
    */
    static new() {
        const ret = wasm.languagelist_new();
        return LanguageList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.languagelist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {Language}
    */
    get(index) {
        const ret = wasm.languagelist_get(this.__wbg_ptr, index);
        return ret;
    }
    /**
    * @param {Language} elem
    */
    add(elem) {
        wasm.languagelist_add(this.__wbg_ptr, elem);
    }
}

const LegacyDaedalusPrivateKeyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_legacydaedalusprivatekey_free(ptr >>> 0, 1));
/**
*/
class LegacyDaedalusPrivateKey {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LegacyDaedalusPrivateKeyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_legacydaedalusprivatekey_free(ptr, 0);
    }
    /**
    * @returns {Uint8Array}
    */
    chaincode() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.legacydaedalusprivatekey_chaincode(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const LegacyRedeemerFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_legacyredeemer_free(ptr >>> 0, 1));
/**
*/
class LegacyRedeemer {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(LegacyRedeemer.prototype);
        obj.__wbg_ptr = ptr;
        LegacyRedeemerFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LegacyRedeemerFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_legacyredeemer_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.legacyredeemer_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.legacyredeemer_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {LegacyRedeemer}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.legacyredeemer_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return LegacyRedeemer.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.legacyredeemer_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.legacyredeemer_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {LegacyRedeemer}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.legacyredeemer_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return LegacyRedeemer.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.legacyredeemer_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.legacyredeemer_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {LegacyRedeemer}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.legacyredeemer_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return LegacyRedeemer.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {RedeemerTag}
    */
    tag() {
        const ret = wasm.legacyredeemer_tag(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {bigint}
    */
    index() {
        const ret = wasm.legacyredeemer_index(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {PlutusData}
    */
    data() {
        const ret = wasm.legacyredeemer_data(this.__wbg_ptr);
        return PlutusData.__wrap(ret);
    }
    /**
    * @returns {ExUnits}
    */
    ex_units() {
        const ret = wasm.legacyredeemer_ex_units(this.__wbg_ptr);
        return ExUnits.__wrap(ret);
    }
    /**
    * @param {RedeemerTag} tag
    * @param {bigint} index
    * @param {PlutusData} data
    * @param {ExUnits} ex_units
    * @returns {LegacyRedeemer}
    */
    static new(tag, index, data, ex_units) {
        _assertClass(data, PlutusData);
        _assertClass(ex_units, ExUnits);
        const ret = wasm.legacyredeemer_new(tag, index, data.__wbg_ptr, ex_units.__wbg_ptr);
        return LegacyRedeemer.__wrap(ret);
    }
}

const LegacyRedeemerListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_legacyredeemerlist_free(ptr >>> 0, 1));
/**
*/
class LegacyRedeemerList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(LegacyRedeemerList.prototype);
        obj.__wbg_ptr = ptr;
        LegacyRedeemerListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LegacyRedeemerListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_legacyredeemerlist_free(ptr, 0);
    }
    /**
    * @returns {LegacyRedeemerList}
    */
    static new() {
        const ret = wasm.legacyredeemerlist_new();
        return LegacyRedeemerList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.legacyredeemerlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {LegacyRedeemer}
    */
    get(index) {
        const ret = wasm.legacyredeemerlist_get(this.__wbg_ptr, index);
        return LegacyRedeemer.__wrap(ret);
    }
    /**
    * @param {LegacyRedeemer} elem
    */
    add(elem) {
        _assertClass(elem, LegacyRedeemer);
        wasm.legacyredeemerlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const LinearFeeFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_linearfee_free(ptr >>> 0, 1));
/**
* Careful: although the linear fee is the same for Byron & Shelley
* The value of the parameters and how fees are computed is not the same
*/
class LinearFee {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(LinearFee.prototype);
        obj.__wbg_ptr = ptr;
        LinearFeeFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LinearFeeFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_linearfee_free(ptr, 0);
    }
    /**
    *
    *     * * `coefficient` - minfee_a from protocol params
    *     * * `constant` - minfee_b from protocol params
    *     * * `ref_script_cost_per_bytes` - min_fee_ref_script_cost_per_byte from protocol params. New in Conway
    *
    * @param {bigint} coefficient
    * @param {bigint} constant
    * @param {bigint} ref_script_cost_per_byte
    * @returns {LinearFee}
    */
    static new(coefficient, constant, ref_script_cost_per_byte) {
        const ret = wasm.linearfee_new(coefficient, constant, ref_script_cost_per_byte);
        return LinearFee.__wrap(ret);
    }
    /**
    * minfee_a
    * @returns {bigint}
    */
    coefficient() {
        const ret = wasm.linearfee_coefficient(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * minfee_b
    * @returns {bigint}
    */
    constant() {
        const ret = wasm.linearfee_constant(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {bigint}
    */
    ref_script_cost_per_byte() {
        const ret = wasm.linearfee_ref_script_cost_per_byte(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
}

const MapAssetNameToCoinFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mapassetnametocoin_free(ptr >>> 0, 1));
/**
*/
class MapAssetNameToCoin {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MapAssetNameToCoin.prototype);
        obj.__wbg_ptr = ptr;
        MapAssetNameToCoinFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MapAssetNameToCoinFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mapassetnametocoin_free(ptr, 0);
    }
    /**
    * @param {AssetName} key
    * @returns {bigint | undefined}
    */
    get(key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(key, AssetName);
            wasm.mapassetnametocoin_get(retptr, this.__wbg_ptr, key.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {AssetName} key
    * @param {bigint} value
    * @returns {bigint | undefined}
    */
    insert(key, value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(key, AssetName);
            wasm.mapassetnametocoin_insert(retptr, this.__wbg_ptr, key.__wbg_ptr, value);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {MapAssetNameToCoin}
    */
    static new() {
        const ret = wasm.mapassetnametocoin_new();
        return MapAssetNameToCoin.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.mapassetnametocoin_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @returns {boolean}
    */
    is_empty() {
        const ret = wasm.mapassetnametocoin_is_empty(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @returns {AssetNameList}
    */
    keys() {
        const ret = wasm.mapassetnametocoin_keys(this.__wbg_ptr);
        return AssetNameList.__wrap(ret);
    }
}

const MapAssetNameToNonZeroInt64Finalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mapassetnametononzeroint64_free(ptr >>> 0, 1));
/**
*/
class MapAssetNameToNonZeroInt64 {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MapAssetNameToNonZeroInt64.prototype);
        obj.__wbg_ptr = ptr;
        MapAssetNameToNonZeroInt64Finalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MapAssetNameToNonZeroInt64Finalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mapassetnametononzeroint64_free(ptr, 0);
    }
    /**
    * @returns {MapAssetNameToNonZeroInt64}
    */
    static new() {
        const ret = wasm.mapassetnametononzeroint64_new();
        return MapAssetNameToNonZeroInt64.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.mapassetnametononzeroint64_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {AssetName} key
    * @param {bigint} value
    * @returns {bigint | undefined}
    */
    insert(key, value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(key, AssetName);
            wasm.mapassetnametononzeroint64_insert(retptr, this.__wbg_ptr, key.__wbg_ptr, value);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : r2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {AssetName} key
    * @returns {bigint | undefined}
    */
    get(key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(key, AssetName);
            wasm.mapassetnametononzeroint64_get(retptr, this.__wbg_ptr, key.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : r2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {AssetNameList}
    */
    keys() {
        const ret = wasm.mapassetnametononzeroint64_keys(this.__wbg_ptr);
        return AssetNameList.__wrap(ret);
    }
}

const MapAssetNameToU64Finalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mapassetnametou64_free(ptr >>> 0, 1));
/**
*/
class MapAssetNameToU64 {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MapAssetNameToU64.prototype);
        obj.__wbg_ptr = ptr;
        MapAssetNameToU64Finalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MapAssetNameToU64Finalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mapassetnametou64_free(ptr, 0);
    }
    /**
    * @returns {MapAssetNameToU64}
    */
    static new() {
        const ret = wasm.mapassetnametou64_new();
        return MapAssetNameToU64.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.mapassetnametou64_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {AssetName} key
    * @param {bigint} value
    * @returns {bigint | undefined}
    */
    insert(key, value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(key, AssetName);
            wasm.mapassetnametou64_insert(retptr, this.__wbg_ptr, key.__wbg_ptr, value);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {AssetName} key
    * @returns {bigint | undefined}
    */
    get(key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(key, AssetName);
            wasm.mapassetnametou64_get(retptr, this.__wbg_ptr, key.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {AssetNameList}
    */
    keys() {
        const ret = wasm.mapassetnametou64_keys(this.__wbg_ptr);
        return AssetNameList.__wrap(ret);
    }
}

const MapCommitteeColdCredentialToEpochFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mapcommitteecoldcredentialtoepoch_free(ptr >>> 0, 1));
/**
*/
class MapCommitteeColdCredentialToEpoch {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MapCommitteeColdCredentialToEpoch.prototype);
        obj.__wbg_ptr = ptr;
        MapCommitteeColdCredentialToEpochFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MapCommitteeColdCredentialToEpochFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mapcommitteecoldcredentialtoepoch_free(ptr, 0);
    }
    /**
    * @returns {MapCommitteeColdCredentialToEpoch}
    */
    static new() {
        const ret = wasm.mapcommitteecoldcredentialtoepoch_new();
        return MapCommitteeColdCredentialToEpoch.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.mapcommitteecoldcredentialtoepoch_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {Credential} key
    * @param {bigint} value
    * @returns {bigint | undefined}
    */
    insert(key, value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(key, Credential);
            wasm.mapcommitteecoldcredentialtoepoch_insert(retptr, this.__wbg_ptr, key.__wbg_ptr, value);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Credential} key
    * @returns {bigint | undefined}
    */
    get(key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(key, Credential);
            wasm.mapcommitteecoldcredentialtoepoch_get(retptr, this.__wbg_ptr, key.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {CommitteeColdCredentialList}
    */
    keys() {
        const ret = wasm.mapcommitteecoldcredentialtoepoch_keys(this.__wbg_ptr);
        return CommitteeColdCredentialList.__wrap(ret);
    }
}

const MapGovActionIdToVotingProcedureFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mapgovactionidtovotingprocedure_free(ptr >>> 0, 1));
/**
*/
class MapGovActionIdToVotingProcedure {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MapGovActionIdToVotingProcedure.prototype);
        obj.__wbg_ptr = ptr;
        MapGovActionIdToVotingProcedureFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MapGovActionIdToVotingProcedureFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mapgovactionidtovotingprocedure_free(ptr, 0);
    }
    /**
    * @returns {MapGovActionIdToVotingProcedure}
    */
    static new() {
        const ret = wasm.mapgovactionidtovotingprocedure_new();
        return MapGovActionIdToVotingProcedure.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.mapgovactionidtovotingprocedure_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {GovActionId} key
    * @param {VotingProcedure} value
    * @returns {VotingProcedure | undefined}
    */
    insert(key, value) {
        _assertClass(key, GovActionId);
        _assertClass(value, VotingProcedure);
        const ret = wasm.mapgovactionidtovotingprocedure_insert(this.__wbg_ptr, key.__wbg_ptr, value.__wbg_ptr);
        return ret === 0 ? undefined : VotingProcedure.__wrap(ret);
    }
    /**
    * @param {GovActionId} key
    * @returns {VotingProcedure | undefined}
    */
    get(key) {
        _assertClass(key, GovActionId);
        const ret = wasm.mapgovactionidtovotingprocedure_get(this.__wbg_ptr, key.__wbg_ptr);
        return ret === 0 ? undefined : VotingProcedure.__wrap(ret);
    }
    /**
    * @returns {GovActionIdList}
    */
    keys() {
        const ret = wasm.mapgovactionidtovotingprocedure_keys(this.__wbg_ptr);
        return GovActionIdList.__wrap(ret);
    }
}

const MapPlutusDataToPlutusDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mapplutusdatatoplutusdata_free(ptr >>> 0, 1));
/**
*/
class MapPlutusDataToPlutusData {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MapPlutusDataToPlutusData.prototype);
        obj.__wbg_ptr = ptr;
        MapPlutusDataToPlutusDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MapPlutusDataToPlutusDataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mapplutusdatatoplutusdata_free(ptr, 0);
    }
    /**
    * @returns {MapPlutusDataToPlutusData}
    */
    static new() {
        const ret = wasm.mapplutusdatatoplutusdata_new();
        return MapPlutusDataToPlutusData.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.mapplutusdatatoplutusdata_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {PlutusData} key
    * @param {PlutusData} value
    * @returns {PlutusData | undefined}
    */
    insert(key, value) {
        _assertClass(key, PlutusData);
        _assertClass(value, PlutusData);
        const ret = wasm.mapplutusdatatoplutusdata_insert(this.__wbg_ptr, key.__wbg_ptr, value.__wbg_ptr);
        return ret === 0 ? undefined : PlutusData.__wrap(ret);
    }
    /**
    * @param {PlutusData} key
    * @returns {PlutusData | undefined}
    */
    get(key) {
        _assertClass(key, PlutusData);
        const ret = wasm.mapplutusdatatoplutusdata_get(this.__wbg_ptr, key.__wbg_ptr);
        return ret === 0 ? undefined : PlutusData.__wrap(ret);
    }
    /**
    * @returns {PlutusDataList}
    */
    keys() {
        const ret = wasm.mapplutusdatatoplutusdata_keys(this.__wbg_ptr);
        return PlutusDataList.__wrap(ret);
    }
}

const MapRedeemerKeyToRedeemerValFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mapredeemerkeytoredeemerval_free(ptr >>> 0, 1));
/**
*/
class MapRedeemerKeyToRedeemerVal {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MapRedeemerKeyToRedeemerVal.prototype);
        obj.__wbg_ptr = ptr;
        MapRedeemerKeyToRedeemerValFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MapRedeemerKeyToRedeemerValFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mapredeemerkeytoredeemerval_free(ptr, 0);
    }
    /**
    * @returns {MapRedeemerKeyToRedeemerVal}
    */
    static new() {
        const ret = wasm.mapredeemerkeytoredeemerval_new();
        return MapRedeemerKeyToRedeemerVal.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.mapredeemerkeytoredeemerval_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {RedeemerKey} key
    * @param {RedeemerVal} value
    * @returns {RedeemerVal | undefined}
    */
    insert(key, value) {
        _assertClass(key, RedeemerKey);
        _assertClass(value, RedeemerVal);
        const ret = wasm.mapredeemerkeytoredeemerval_insert(this.__wbg_ptr, key.__wbg_ptr, value.__wbg_ptr);
        return ret === 0 ? undefined : RedeemerVal.__wrap(ret);
    }
    /**
    * @param {RedeemerKey} key
    * @returns {RedeemerVal | undefined}
    */
    get(key) {
        _assertClass(key, RedeemerKey);
        const ret = wasm.mapredeemerkeytoredeemerval_get(this.__wbg_ptr, key.__wbg_ptr);
        return ret === 0 ? undefined : RedeemerVal.__wrap(ret);
    }
    /**
    * @returns {RedeemerKeyList}
    */
    keys() {
        const ret = wasm.mapredeemerkeytoredeemerval_keys(this.__wbg_ptr);
        return RedeemerKeyList.__wrap(ret);
    }
}

const MapRewardAccountToCoinFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_maprewardaccounttocoin_free(ptr >>> 0, 1));
/**
*/
class MapRewardAccountToCoin {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MapRewardAccountToCoin.prototype);
        obj.__wbg_ptr = ptr;
        MapRewardAccountToCoinFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MapRewardAccountToCoinFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_maprewardaccounttocoin_free(ptr, 0);
    }
    /**
    * @returns {MapRewardAccountToCoin}
    */
    static new() {
        const ret = wasm.maprewardaccounttocoin_new();
        return MapRewardAccountToCoin.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.maprewardaccounttocoin_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {RewardAddress} key
    * @param {bigint} value
    * @returns {bigint | undefined}
    */
    insert(key, value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(key, RewardAddress);
            wasm.maprewardaccounttocoin_insert(retptr, this.__wbg_ptr, key.__wbg_ptr, value);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {RewardAddress} key
    * @returns {bigint | undefined}
    */
    get(key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(key, RewardAddress);
            wasm.maprewardaccounttocoin_get(retptr, this.__wbg_ptr, key.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {RewardAccountList}
    */
    keys() {
        const ret = wasm.maprewardaccounttocoin_keys(this.__wbg_ptr);
        return RewardAccountList.__wrap(ret);
    }
}

const MapStakeCredentialToDeltaCoinFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mapstakecredentialtodeltacoin_free(ptr >>> 0, 1));
/**
*/
class MapStakeCredentialToDeltaCoin {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MapStakeCredentialToDeltaCoin.prototype);
        obj.__wbg_ptr = ptr;
        MapStakeCredentialToDeltaCoinFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MapStakeCredentialToDeltaCoinFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mapstakecredentialtodeltacoin_free(ptr, 0);
    }
    /**
    * @returns {MapStakeCredentialToDeltaCoin}
    */
    static new() {
        const ret = wasm.mapstakecredentialtodeltacoin_new();
        return MapStakeCredentialToDeltaCoin.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.mapstakecredentialtodeltacoin_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {Credential} key
    * @param {Int} value
    * @returns {Int | undefined}
    */
    insert(key, value) {
        _assertClass(key, Credential);
        _assertClass(value, Int);
        const ret = wasm.mapstakecredentialtodeltacoin_insert(this.__wbg_ptr, key.__wbg_ptr, value.__wbg_ptr);
        return ret === 0 ? undefined : Int.__wrap(ret);
    }
    /**
    * @param {Credential} key
    * @returns {Int | undefined}
    */
    get(key) {
        _assertClass(key, Credential);
        const ret = wasm.mapstakecredentialtodeltacoin_get(this.__wbg_ptr, key.__wbg_ptr);
        return ret === 0 ? undefined : Int.__wrap(ret);
    }
    /**
    * @returns {StakeCredentialList}
    */
    keys() {
        const ret = wasm.mapstakecredentialtodeltacoin_keys(this.__wbg_ptr);
        return StakeCredentialList.__wrap(ret);
    }
}

const MapTransactionIndexToAuxiliaryDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_maptransactionindextoauxiliarydata_free(ptr >>> 0, 1));
/**
*/
class MapTransactionIndexToAuxiliaryData {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MapTransactionIndexToAuxiliaryData.prototype);
        obj.__wbg_ptr = ptr;
        MapTransactionIndexToAuxiliaryDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MapTransactionIndexToAuxiliaryDataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_maptransactionindextoauxiliarydata_free(ptr, 0);
    }
    /**
    * @returns {MapTransactionIndexToAuxiliaryData}
    */
    static new() {
        const ret = wasm.maptransactionindextoauxiliarydata_new();
        return MapTransactionIndexToAuxiliaryData.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.maptransactionindextoauxiliarydata_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} key
    * @param {AuxiliaryData} value
    * @returns {AuxiliaryData | undefined}
    */
    insert(key, value) {
        _assertClass(value, AuxiliaryData);
        const ret = wasm.maptransactionindextoauxiliarydata_insert(this.__wbg_ptr, key, value.__wbg_ptr);
        return ret === 0 ? undefined : AuxiliaryData.__wrap(ret);
    }
    /**
    * @param {number} key
    * @returns {AuxiliaryData | undefined}
    */
    get(key) {
        const ret = wasm.maptransactionindextoauxiliarydata_get(this.__wbg_ptr, key);
        return ret === 0 ? undefined : AuxiliaryData.__wrap(ret);
    }
    /**
    * @returns {Uint16Array}
    */
    keys() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.maptransactionindextoauxiliarydata_keys(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU16FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 2, 2);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const MapTransactionMetadatumToTransactionMetadatumFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_maptransactionmetadatumtotransactionmetadatum_free(ptr >>> 0, 1));
/**
*/
class MapTransactionMetadatumToTransactionMetadatum {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MapTransactionMetadatumToTransactionMetadatum.prototype);
        obj.__wbg_ptr = ptr;
        MapTransactionMetadatumToTransactionMetadatumFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MapTransactionMetadatumToTransactionMetadatumFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_maptransactionmetadatumtotransactionmetadatum_free(ptr, 0);
    }
    /**
    * @returns {MapTransactionMetadatumToTransactionMetadatum}
    */
    static new() {
        const ret = wasm.maptransactionmetadatumtotransactionmetadatum_new();
        return MapTransactionMetadatumToTransactionMetadatum.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.maptransactionmetadatumtotransactionmetadatum_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {TransactionMetadatum} key
    * @param {TransactionMetadatum} value
    * @returns {TransactionMetadatum | undefined}
    */
    insert(key, value) {
        _assertClass(key, TransactionMetadatum);
        _assertClass(value, TransactionMetadatum);
        const ret = wasm.maptransactionmetadatumtotransactionmetadatum_insert(this.__wbg_ptr, key.__wbg_ptr, value.__wbg_ptr);
        return ret === 0 ? undefined : TransactionMetadatum.__wrap(ret);
    }
    /**
    * @param {TransactionMetadatum} key
    * @returns {TransactionMetadatum | undefined}
    */
    get(key) {
        _assertClass(key, TransactionMetadatum);
        const ret = wasm.maptransactionmetadatumtotransactionmetadatum_get(this.__wbg_ptr, key.__wbg_ptr);
        return ret === 0 ? undefined : TransactionMetadatum.__wrap(ret);
    }
    /**
    * @returns {TransactionMetadatumList}
    */
    keys() {
        const ret = wasm.maptransactionmetadatumtotransactionmetadatum_keys(this.__wbg_ptr);
        return TransactionMetadatumList.__wrap(ret);
    }
}

const MapU64ToArrI64Finalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mapu64toarri64_free(ptr >>> 0, 1));
/**
*/
class MapU64ToArrI64 {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MapU64ToArrI64.prototype);
        obj.__wbg_ptr = ptr;
        MapU64ToArrI64Finalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MapU64ToArrI64Finalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mapu64toarri64_free(ptr, 0);
    }
    /**
    * @param {bigint} key
    * @returns {BigInt64Array | undefined}
    */
    get(key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mapu64toarri64_get(retptr, this.__wbg_ptr, key);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getArrayI64FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 8, 8);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} key
    * @param {BigInt64Array} value
    * @returns {BigInt64Array | undefined}
    */
    insert(key, value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray64ToWasm0(value, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.mapu64toarri64_insert(retptr, this.__wbg_ptr, key, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v2;
            if (r0 !== 0) {
                v2 = getArrayI64FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 8, 8);
            }
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {MapU64ToArrI64}
    */
    static new() {
        const ret = wasm.mapu64toarri64_new();
        return MapU64ToArrI64.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.mapu64toarri64_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @returns {boolean}
    */
    is_empty() {
        const ret = wasm.mapu64toarri64_is_empty(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @returns {BigUint64Array}
    */
    keys() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mapu64toarri64_keys(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU64FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 8, 8);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const MetadataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_metadata_free(ptr >>> 0, 1));
/**
*/
class Metadata {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Metadata.prototype);
        obj.__wbg_ptr = ptr;
        MetadataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MetadataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_metadata_free(ptr, 0);
    }
    /**
    * @returns {Metadata}
    */
    static new() {
        const ret = wasm.metadata_new();
        return Metadata.__wrap(ret);
    }
    /**
    * How many metadatum labels there are.
    * @returns {number}
    */
    len() {
        const ret = wasm.metadata_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * Replaces all metadatums of a given label, if any exist.
    * @param {bigint} key
    * @param {TransactionMetadatum} value
    */
    set(key, value) {
        _assertClass(value, TransactionMetadatum);
        wasm.metadata_set(this.__wbg_ptr, key, value.__wbg_ptr);
    }
    /**
    * Gets the Metadatum corresponding to a given label, if it exists.
    * Note: In the case of duplicate labels this only returns the first metadatum.
    * This is an extremely rare occurence on-chain but can happen.
    * @param {bigint} label
    * @returns {TransactionMetadatum | undefined}
    */
    get(label) {
        const ret = wasm.metadata_get(this.__wbg_ptr, label);
        return ret === 0 ? undefined : TransactionMetadatum.__wrap(ret);
    }
    /**
    * In the extremely unlikely situation there are duplicate labels, this gets all of a single label
    * @param {bigint} label
    * @returns {TransactionMetadatumList | undefined}
    */
    get_all(label) {
        const ret = wasm.metadata_get_all(this.__wbg_ptr, label);
        return ret === 0 ? undefined : TransactionMetadatumList.__wrap(ret);
    }
    /**
    * @returns {TransactionMetadatumLabels}
    */
    labels() {
        const ret = wasm.metadata_labels(this.__wbg_ptr);
        return TransactionMetadatumLabels.__wrap(ret);
    }
}

const MetadatumListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_metadatumlist_free(ptr >>> 0, 1));
/**
*/
class MetadatumList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MetadatumList.prototype);
        obj.__wbg_ptr = ptr;
        MetadatumListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MetadatumListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_metadatumlist_free(ptr, 0);
    }
    /**
    * @returns {MetadatumList}
    */
    static new() {
        const ret = wasm.metadatumlist_new();
        return MetadatumList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.metadatumlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {TransactionMetadatum}
    */
    get(index) {
        const ret = wasm.metadatumlist_get(this.__wbg_ptr, index);
        return TransactionMetadatum.__wrap(ret);
    }
    /**
    * @param {TransactionMetadatum} elem
    */
    add(elem) {
        _assertClass(elem, TransactionMetadatum);
        wasm.metadatumlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const MetadatumMapFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_metadatummap_free(ptr >>> 0, 1));
/**
*/
class MetadatumMap {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MetadatumMap.prototype);
        obj.__wbg_ptr = ptr;
        MetadatumMapFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MetadatumMapFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_metadatummap_free(ptr, 0);
    }
    /**
    * @returns {MetadatumMap}
    */
    static new() {
        const ret = wasm.metadatummap_new();
        return MetadatumMap.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.metadatummap_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * Replaces all metadatums of a given key, if any exist.
    * @param {TransactionMetadatum} key
    * @param {TransactionMetadatum} value
    */
    set(key, value) {
        _assertClass(key, TransactionMetadatum);
        _assertClass(value, TransactionMetadatum);
        wasm.metadatummap_set(this.__wbg_ptr, key.__wbg_ptr, value.__wbg_ptr);
    }
    /**
    * Gets the Metadatum corresponding to a given key, if it exists.
    * Note: In the case of duplicate keys this only returns the first metadatum.
    * This is an extremely rare occurence (2 total on mainnet) on-chain but can happen.
    * @param {TransactionMetadatum} key
    * @returns {TransactionMetadatum | undefined}
    */
    get(key) {
        _assertClass(key, TransactionMetadatum);
        const ret = wasm.metadatummap_get(this.__wbg_ptr, key.__wbg_ptr);
        return ret === 0 ? undefined : TransactionMetadatum.__wrap(ret);
    }
    /**
    * In the extremely unlikely situation there are duplicate keys, this gets all of a single key
    * @param {TransactionMetadatum} key
    * @returns {TransactionMetadatumList | undefined}
    */
    get_all(key) {
        _assertClass(key, TransactionMetadatum);
        const ret = wasm.metadatummap_get_all(this.__wbg_ptr, key.__wbg_ptr);
        return ret === 0 ? undefined : TransactionMetadatumList.__wrap(ret);
    }
    /**
    * @returns {MetadatumList}
    */
    keys() {
        const ret = wasm.metadatummap_keys(this.__wbg_ptr);
        return MetadatumList.__wrap(ret);
    }
}

const MintFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mint_free(ptr >>> 0, 1));
/**
*/
class Mint {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Mint.prototype);
        obj.__wbg_ptr = ptr;
        MintFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MintFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mint_free(ptr, 0);
    }
    /**
    * @returns {Mint}
    */
    static new() {
        const ret = wasm.mint_new();
        return Mint.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    policy_count() {
        const ret = wasm.mint_policy_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {ScriptHash} policy_id
    * @param {MapAssetNameToNonZeroInt64} assets
    * @returns {MapAssetNameToNonZeroInt64 | undefined}
    */
    insert_assets(policy_id, assets) {
        _assertClass(policy_id, ScriptHash);
        _assertClass(assets, MapAssetNameToNonZeroInt64);
        const ret = wasm.mint_insert_assets(this.__wbg_ptr, policy_id.__wbg_ptr, assets.__wbg_ptr);
        return ret === 0 ? undefined : MapAssetNameToNonZeroInt64.__wrap(ret);
    }
    /**
    * @param {ScriptHash} key
    * @returns {MapAssetNameToNonZeroInt64 | undefined}
    */
    get_assets(key) {
        _assertClass(key, ScriptHash);
        const ret = wasm.mint_get_assets(this.__wbg_ptr, key.__wbg_ptr);
        return ret === 0 ? undefined : MapAssetNameToNonZeroInt64.__wrap(ret);
    }
    /**
    * Get the value of policy_id:asset_name if it exists.
    * @param {ScriptHash} policy_id
    * @param {AssetName} asset
    * @returns {bigint | undefined}
    */
    get(policy_id, asset) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(policy_id, ScriptHash);
            _assertClass(asset, AssetName);
            wasm.mint_get(retptr, this.__wbg_ptr, policy_id.__wbg_ptr, asset.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : r2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Set the value of policy_id:asset_name to value.
    * Returns the previous value, or None if it didn't exist
    * @param {ScriptHash} policy_id
    * @param {AssetName} asset
    * @param {bigint} value
    * @returns {bigint | undefined}
    */
    set(policy_id, asset, value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(policy_id, ScriptHash);
            _assertClass(asset, AssetName);
            wasm.mint_set(retptr, this.__wbg_ptr, policy_id.__wbg_ptr, asset.__wbg_ptr, value);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : r2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {PolicyIdList}
    */
    keys() {
        const ret = wasm.mint_keys(this.__wbg_ptr);
        return PolicyIdList.__wrap(ret);
    }
    /**
    * Adds two mints together, checking value bounds.
    * Does not modify self, and instead returns the result.
    * @param {Mint} rhs
    * @returns {Mint}
    */
    checked_add(rhs) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(rhs, Mint);
            wasm.mint_checked_add(retptr, this.__wbg_ptr, rhs.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Mint.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Subtracts rhs from this mint.
    * This does not modify self, and instead returns the result.
    * @param {Mint} rhs
    * @returns {Mint}
    */
    checked_sub(rhs) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(rhs, Mint);
            wasm.mint_checked_sub(retptr, this.__wbg_ptr, rhs.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Mint.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Returns the multiasset where only positive (minting) entries are present
    * @returns {MultiAsset}
    */
    as_positive_multiasset() {
        const ret = wasm.mint_as_positive_multiasset(this.__wbg_ptr);
        return MultiAsset.__wrap(ret);
    }
    /**
    * Returns the multiasset where only negative (burning) entries are present
    * @returns {MultiAsset}
    */
    as_negative_multiasset() {
        const ret = wasm.mint_as_negative_multiasset(this.__wbg_ptr);
        return MultiAsset.__wrap(ret);
    }
}

const MintBuilderResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mintbuilderresult_free(ptr >>> 0, 1));
/**
*/
class MintBuilderResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MintBuilderResult.prototype);
        obj.__wbg_ptr = ptr;
        MintBuilderResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MintBuilderResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mintbuilderresult_free(ptr, 0);
    }
}

const MultiAssetFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_multiasset_free(ptr >>> 0, 1));
/**
*/
class MultiAsset {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MultiAsset.prototype);
        obj.__wbg_ptr = ptr;
        MultiAssetFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MultiAssetFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_multiasset_free(ptr, 0);
    }
    /**
    * @returns {MultiAsset}
    */
    static new() {
        const ret = wasm.multiasset_new();
        return MultiAsset.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    policy_count() {
        const ret = wasm.multiasset_policy_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {ScriptHash} policy_id
    * @param {MapAssetNameToCoin} assets
    * @returns {MapAssetNameToCoin | undefined}
    */
    insert_assets(policy_id, assets) {
        _assertClass(policy_id, ScriptHash);
        _assertClass(assets, MapAssetNameToCoin);
        const ret = wasm.multiasset_insert_assets(this.__wbg_ptr, policy_id.__wbg_ptr, assets.__wbg_ptr);
        return ret === 0 ? undefined : MapAssetNameToCoin.__wrap(ret);
    }
    /**
    * @param {ScriptHash} key
    * @returns {MapAssetNameToCoin | undefined}
    */
    get_assets(key) {
        _assertClass(key, ScriptHash);
        const ret = wasm.multiasset_get_assets(this.__wbg_ptr, key.__wbg_ptr);
        return ret === 0 ? undefined : MapAssetNameToCoin.__wrap(ret);
    }
    /**
    * Get the value of policy_id:asset_name if it exists.
    * @param {ScriptHash} policy_id
    * @param {AssetName} asset
    * @returns {bigint | undefined}
    */
    get(policy_id, asset) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(policy_id, ScriptHash);
            _assertClass(asset, AssetName);
            wasm.multiasset_get(retptr, this.__wbg_ptr, policy_id.__wbg_ptr, asset.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Set the value of policy_id:asset_name to value.
    * Returns the previous value, or None if it didn't exist
    * @param {ScriptHash} policy_id
    * @param {AssetName} asset
    * @param {bigint} value
    * @returns {bigint | undefined}
    */
    set(policy_id, asset, value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(policy_id, ScriptHash);
            _assertClass(asset, AssetName);
            wasm.multiasset_set(retptr, this.__wbg_ptr, policy_id.__wbg_ptr, asset.__wbg_ptr, value);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {PolicyIdList}
    */
    keys() {
        const ret = wasm.multiasset_keys(this.__wbg_ptr);
        return PolicyIdList.__wrap(ret);
    }
    /**
    * Adds to multiassets together, checking value bounds.
    * Does not modify self, and instead returns the result.
    * @param {MultiAsset} rhs
    * @returns {MultiAsset}
    */
    checked_add(rhs) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(rhs, MultiAsset);
            wasm.multiasset_checked_add(retptr, this.__wbg_ptr, rhs.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return MultiAsset.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Subtracts rhs from this multiasset.
    * This does not modify self, and instead returns the result.
    * If this would cause there to be fewer than 0 of a given asset
    * an error will be returned.
    * Use clamped_sub if you need to only try to remove assets when they exist
    * and ignore them when they don't.
    * @param {MultiAsset} rhs
    * @returns {MultiAsset}
    */
    checked_sub(rhs) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(rhs, MultiAsset);
            wasm.multiasset_checked_sub(retptr, this.__wbg_ptr, rhs.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return MultiAsset.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Sybtracts rhs from this multiasset.
    * If this would cause there to be 0 or fewer of a given asset
    * it will simply be removed entirely from the result.
    * @param {MultiAsset} rhs
    * @returns {MultiAsset}
    */
    clamped_sub(rhs) {
        _assertClass(rhs, MultiAsset);
        const ret = wasm.multiasset_clamped_sub(this.__wbg_ptr, rhs.__wbg_ptr);
        return MultiAsset.__wrap(ret);
    }
}

const MultiHostNameFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_multihostname_free(ptr >>> 0, 1));
/**
*/
class MultiHostName {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MultiHostName.prototype);
        obj.__wbg_ptr = ptr;
        MultiHostNameFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MultiHostNameFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_multihostname_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.multihostname_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.multihostname_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {MultiHostName}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.multihostname_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return MultiHostName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.multihostname_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.multihostname_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {MultiHostName}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.multihostname_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return MultiHostName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.multihostname_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.multihostname_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {MultiHostName}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.multihostname_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return MultiHostName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {DNSName}
    */
    dns_name() {
        const ret = wasm.multihostname_dns_name(this.__wbg_ptr);
        return DNSName.__wrap(ret);
    }
    /**
    * * `dns_name` - A SRV DNS record
    * @param {DNSName} dns_name
    * @returns {MultiHostName}
    */
    static new(dns_name) {
        _assertClass(dns_name, DNSName);
        const ret = wasm.multihostname_new(dns_name.__wbg_ptr);
        return MultiHostName.__wrap(ret);
    }
}

const NativeScriptFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_nativescript_free(ptr >>> 0, 1));
/**
*/
class NativeScript {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(NativeScript.prototype);
        obj.__wbg_ptr = ptr;
        NativeScriptFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NativeScriptFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_nativescript_free(ptr, 0);
    }
    /**
    * Returns an array of unique Ed25519KeyHashes
    * contained within this script recursively on any depth level.
    * The order of the keys in the result is not determined in any way.
    * @returns {Ed25519KeyHashList}
    */
    get_required_signers() {
        const ret = wasm.nativescript_get_required_signers(this.__wbg_ptr);
        return Ed25519KeyHashList.__wrap(ret);
    }
    /**
    * @returns {ScriptHash}
    */
    hash() {
        const ret = wasm.nativescript_hash(this.__wbg_ptr);
        return ScriptHash.__wrap(ret);
    }
    /**
    * @param {bigint | undefined} lower_bound
    * @param {bigint | undefined} upper_bound
    * @param {Ed25519KeyHashList} key_hashes
    * @returns {boolean}
    */
    verify(lower_bound, upper_bound, key_hashes) {
        _assertClass(key_hashes, Ed25519KeyHashList);
        const ret = wasm.nativescript_verify(this.__wbg_ptr, !isLikeNone(lower_bound), isLikeNone(lower_bound) ? BigInt(0) : lower_bound, !isLikeNone(upper_bound), isLikeNone(upper_bound) ? BigInt(0) : upper_bound, key_hashes.__wbg_ptr);
        return ret !== 0;
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nativescript_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nativescript_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {NativeScript}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.nativescript_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NativeScript.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nativescript_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nativescript_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {NativeScript}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.nativescript_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NativeScript.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nativescript_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nativescript_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {NativeScript}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.nativescript_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NativeScript.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Ed25519KeyHash} ed25519_key_hash
    * @returns {NativeScript}
    */
    static new_script_pubkey(ed25519_key_hash) {
        _assertClass(ed25519_key_hash, Ed25519KeyHash);
        const ret = wasm.nativescript_new_script_pubkey(ed25519_key_hash.__wbg_ptr);
        return NativeScript.__wrap(ret);
    }
    /**
    * @param {NativeScriptList} native_scripts
    * @returns {NativeScript}
    */
    static new_script_all(native_scripts) {
        _assertClass(native_scripts, NativeScriptList);
        const ret = wasm.nativescript_new_script_all(native_scripts.__wbg_ptr);
        return NativeScript.__wrap(ret);
    }
    /**
    * @param {NativeScriptList} native_scripts
    * @returns {NativeScript}
    */
    static new_script_any(native_scripts) {
        _assertClass(native_scripts, NativeScriptList);
        const ret = wasm.nativescript_new_script_any(native_scripts.__wbg_ptr);
        return NativeScript.__wrap(ret);
    }
    /**
    * @param {bigint} n
    * @param {NativeScriptList} native_scripts
    * @returns {NativeScript}
    */
    static new_script_n_of_k(n, native_scripts) {
        _assertClass(native_scripts, NativeScriptList);
        const ret = wasm.nativescript_new_script_n_of_k(n, native_scripts.__wbg_ptr);
        return NativeScript.__wrap(ret);
    }
    /**
    * Timelock validity intervals are half-open intervals [a, b). This field specifies the left (included) endpoint a.
    * @param {bigint} before
    * @returns {NativeScript}
    */
    static new_script_invalid_before(before) {
        const ret = wasm.nativescript_new_script_invalid_before(before);
        return NativeScript.__wrap(ret);
    }
    /**
    * Timelock validity intervals are half-open intervals [a, b). This field specifies the right (excluded) endpoint b.
    * @param {bigint} after
    * @returns {NativeScript}
    */
    static new_script_invalid_hereafter(after) {
        const ret = wasm.nativescript_new_script_invalid_hereafter(after);
        return NativeScript.__wrap(ret);
    }
    /**
    * @returns {NativeScriptKind}
    */
    kind() {
        const ret = wasm.nativescript_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {ScriptPubkey | undefined}
    */
    as_script_pubkey() {
        const ret = wasm.nativescript_as_script_pubkey(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptPubkey.__wrap(ret);
    }
    /**
    * @returns {ScriptAll | undefined}
    */
    as_script_all() {
        const ret = wasm.nativescript_as_script_all(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptAll.__wrap(ret);
    }
    /**
    * @returns {ScriptAny | undefined}
    */
    as_script_any() {
        const ret = wasm.nativescript_as_script_any(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptAny.__wrap(ret);
    }
    /**
    * @returns {ScriptNOfK | undefined}
    */
    as_script_n_of_k() {
        const ret = wasm.nativescript_as_script_n_of_k(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptNOfK.__wrap(ret);
    }
    /**
    * @returns {ScriptInvalidBefore | undefined}
    */
    as_script_invalid_before() {
        const ret = wasm.nativescript_as_script_invalid_before(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptInvalidBefore.__wrap(ret);
    }
    /**
    * @returns {ScriptInvalidHereafter | undefined}
    */
    as_script_invalid_hereafter() {
        const ret = wasm.nativescript_as_script_invalid_hereafter(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptInvalidHereafter.__wrap(ret);
    }
}

const NativeScriptListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_nativescriptlist_free(ptr >>> 0, 1));
/**
*/
class NativeScriptList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(NativeScriptList.prototype);
        obj.__wbg_ptr = ptr;
        NativeScriptListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NativeScriptListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_nativescriptlist_free(ptr, 0);
    }
    /**
    * @returns {NativeScriptList}
    */
    static new() {
        const ret = wasm.nativescriptlist_new();
        return NativeScriptList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.nativescriptlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {NativeScript}
    */
    get(index) {
        const ret = wasm.nativescriptlist_get(this.__wbg_ptr, index);
        return NativeScript.__wrap(ret);
    }
    /**
    * @param {NativeScript} elem
    */
    add(elem) {
        _assertClass(elem, NativeScript);
        wasm.nativescriptlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const NativeScriptWitnessInfoFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_nativescriptwitnessinfo_free(ptr >>> 0, 1));
/**
*/
class NativeScriptWitnessInfo {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(NativeScriptWitnessInfo.prototype);
        obj.__wbg_ptr = ptr;
        NativeScriptWitnessInfoFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NativeScriptWitnessInfoFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_nativescriptwitnessinfo_free(ptr, 0);
    }
    /**
    * Unsure which keys will sign, but you know the exact number to save on tx fee
    * @param {number} num
    * @returns {NativeScriptWitnessInfo}
    */
    static num_signatures(num) {
        const ret = wasm.nativescriptwitnessinfo_num_signatures(num);
        return NativeScriptWitnessInfo.__wrap(ret);
    }
    /**
    * This native script will be witnessed by exactly these keys
    * @param {Ed25519KeyHashList} vkeys
    * @returns {NativeScriptWitnessInfo}
    */
    static vkeys(vkeys) {
        _assertClass(vkeys, Ed25519KeyHashList);
        const ret = wasm.nativescriptwitnessinfo_vkeys(vkeys.__wbg_ptr);
        return NativeScriptWitnessInfo.__wrap(ret);
    }
    /**
    * You don't know how many keys will sign, so the maximum possible case will be assumed
    * @returns {NativeScriptWitnessInfo}
    */
    static assume_signature_count() {
        const ret = wasm.nativescriptwitnessinfo_assume_signature_count();
        return NativeScriptWitnessInfo.__wrap(ret);
    }
}

const NetworkIdFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_networkid_free(ptr >>> 0, 1));
/**
*/
class NetworkId {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(NetworkId.prototype);
        obj.__wbg_ptr = ptr;
        NetworkIdFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NetworkIdFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_networkid_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.networkid_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.networkid_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {NetworkId}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.networkid_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NetworkId.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.networkid_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.networkid_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {NetworkId}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.networkid_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NetworkId.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.networkid_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.networkid_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {NetworkId}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.networkid_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NetworkId.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} network
    * @returns {NetworkId}
    */
    static new(network) {
        const ret = wasm.networkid_new(network);
        return NetworkId.__wrap(ret);
    }
    /**
    * @returns {NetworkId}
    */
    static mainnet() {
        const ret = wasm.networkid_mainnet();
        return NetworkId.__wrap(ret);
    }
    /**
    * @returns {NetworkId}
    */
    static testnet() {
        const ret = wasm.networkid_testnet();
        return NetworkId.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    network() {
        const ret = wasm.networkid_network(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
}

const NetworkInfoFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_networkinfo_free(ptr >>> 0, 1));
/**
*/
class NetworkInfo {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(NetworkInfo.prototype);
        obj.__wbg_ptr = ptr;
        NetworkInfoFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NetworkInfoFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_networkinfo_free(ptr, 0);
    }
    /**
    * @param {number} network_id
    * @param {ProtocolMagic} protocol_magic
    * @returns {NetworkInfo}
    */
    static new(network_id, protocol_magic) {
        _assertClass(protocol_magic, ProtocolMagic);
        const ret = wasm.networkinfo_new(network_id, protocol_magic.__wbg_ptr);
        return NetworkInfo.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    network_id() {
        const ret = wasm.networkinfo_network_id(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {ProtocolMagic}
    */
    protocol_magic() {
        const ret = wasm.networkinfo_protocol_magic(this.__wbg_ptr);
        return ProtocolMagic.__wrap(ret);
    }
    /**
    * This is the old testnet - most likely you want to use preview()/preprod()
    * @returns {NetworkInfo}
    */
    static testnet() {
        const ret = wasm.networkinfo_testnet();
        return NetworkInfo.__wrap(ret);
    }
    /**
    * @returns {NetworkInfo}
    */
    static mainnet() {
        const ret = wasm.networkinfo_mainnet();
        return NetworkInfo.__wrap(ret);
    }
    /**
    * @returns {NetworkInfo}
    */
    static preview() {
        const ret = wasm.networkinfo_preview();
        return NetworkInfo.__wrap(ret);
    }
    /**
    * @returns {NetworkInfo}
    */
    static preprod() {
        const ret = wasm.networkinfo_preprod();
        return NetworkInfo.__wrap(ret);
    }
    /**
    * @returns {NetworkInfo}
    */
    static sancho_testnet() {
        const ret = wasm.networkinfo_sancho_testnet();
        return NetworkInfo.__wrap(ret);
    }
}

const NewConstitutionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_newconstitution_free(ptr >>> 0, 1));
/**
*/
class NewConstitution {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(NewConstitution.prototype);
        obj.__wbg_ptr = ptr;
        NewConstitutionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NewConstitutionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_newconstitution_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.newconstitution_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.newconstitution_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {NewConstitution}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.newconstitution_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NewConstitution.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.newconstitution_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.newconstitution_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {NewConstitution}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.newconstitution_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NewConstitution.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.newconstitution_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.newconstitution_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {NewConstitution}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.newconstitution_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NewConstitution.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {GovActionId | undefined}
    */
    action_id() {
        const ret = wasm.newconstitution_action_id(this.__wbg_ptr);
        return ret === 0 ? undefined : GovActionId.__wrap(ret);
    }
    /**
    * @returns {Constitution}
    */
    constitution() {
        const ret = wasm.newconstitution_constitution(this.__wbg_ptr);
        return Constitution.__wrap(ret);
    }
    /**
    * @param {GovActionId | undefined} action_id
    * @param {Constitution} constitution
    * @returns {NewConstitution}
    */
    static new(action_id, constitution) {
        let ptr0 = 0;
        if (!isLikeNone(action_id)) {
            _assertClass(action_id, GovActionId);
            ptr0 = action_id.__destroy_into_raw();
        }
        _assertClass(constitution, Constitution);
        const ret = wasm.newconstitution_new(ptr0, constitution.__wbg_ptr);
        return NewConstitution.__wrap(ret);
    }
}

const NoConfidenceFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_noconfidence_free(ptr >>> 0, 1));
/**
*/
class NoConfidence {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(NoConfidence.prototype);
        obj.__wbg_ptr = ptr;
        NoConfidenceFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NoConfidenceFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_noconfidence_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.noconfidence_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.noconfidence_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {NoConfidence}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.noconfidence_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NoConfidence.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.noconfidence_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.noconfidence_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {NoConfidence}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.noconfidence_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NoConfidence.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.noconfidence_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.noconfidence_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {NoConfidence}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.noconfidence_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NoConfidence.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {GovActionId | undefined}
    */
    action_id() {
        const ret = wasm.noconfidence_action_id(this.__wbg_ptr);
        return ret === 0 ? undefined : GovActionId.__wrap(ret);
    }
    /**
    * @param {GovActionId | undefined} [action_id]
    * @returns {NoConfidence}
    */
    static new(action_id) {
        let ptr0 = 0;
        if (!isLikeNone(action_id)) {
            _assertClass(action_id, GovActionId);
            ptr0 = action_id.__destroy_into_raw();
        }
        const ret = wasm.noconfidence_new(ptr0);
        return NoConfidence.__wrap(ret);
    }
}

const NonceFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_nonce_free(ptr >>> 0, 1));
/**
*/
class Nonce {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Nonce.prototype);
        obj.__wbg_ptr = ptr;
        NonceFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NonceFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_nonce_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nonce_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nonce_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Nonce}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.nonce_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Nonce.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nonce_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nonce_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Nonce}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.nonce_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Nonce.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nonce_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nonce_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Nonce}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.nonce_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Nonce.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Nonce}
    */
    static new_identity() {
        const ret = wasm.nonce_new_identity();
        return Nonce.__wrap(ret);
    }
    /**
    * @param {NonceHash} hash
    * @returns {Nonce}
    */
    static new_hash(hash) {
        _assertClass(hash, NonceHash);
        const ret = wasm.nonce_new_hash(hash.__wbg_ptr);
        return Nonce.__wrap(ret);
    }
    /**
    * @returns {NonceKind}
    */
    kind() {
        const ret = wasm.nonce_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {NonceHash | undefined}
    */
    as_hash() {
        const ret = wasm.nonce_as_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : NonceHash.__wrap(ret);
    }
}

const NonceHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_noncehash_free(ptr >>> 0, 1));
/**
*/
class NonceHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(NonceHash.prototype);
        obj.__wbg_ptr = ptr;
        NonceHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NonceHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_noncehash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.noncehash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {NonceHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.noncehash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NonceHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.noncehash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {NonceHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.noncehash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NonceHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.noncehash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {NonceHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.noncehash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return NonceHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const OperationalCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_operationalcert_free(ptr >>> 0, 1));
/**
*/
class OperationalCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(OperationalCert.prototype);
        obj.__wbg_ptr = ptr;
        OperationalCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OperationalCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_operationalcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.operationalcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.operationalcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {OperationalCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.operationalcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return OperationalCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.operationalcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.operationalcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {OperationalCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.operationalcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return OperationalCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.operationalcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.operationalcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {OperationalCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.operationalcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return OperationalCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {KESVkey}
    */
    hot_vkey() {
        const ret = wasm.operationalcert_hot_vkey(this.__wbg_ptr);
        return KESVkey.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    sequence_number() {
        const ret = wasm.operationalcert_sequence_number(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {bigint}
    */
    kes_period() {
        const ret = wasm.operationalcert_kes_period(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {Ed25519Signature}
    */
    sigma() {
        const ret = wasm.operationalcert_sigma(this.__wbg_ptr);
        return Ed25519Signature.__wrap(ret);
    }
    /**
    * @param {KESVkey} hot_vkey
    * @param {bigint} sequence_number
    * @param {bigint} kes_period
    * @param {Ed25519Signature} sigma
    * @returns {OperationalCert}
    */
    static new(hot_vkey, sequence_number, kes_period, sigma) {
        _assertClass(hot_vkey, KESVkey);
        _assertClass(sigma, Ed25519Signature);
        const ret = wasm.operationalcert_new(hot_vkey.__wbg_ptr, sequence_number, kes_period, sigma.__wbg_ptr);
        return OperationalCert.__wrap(ret);
    }
}

const ParameterChangeActionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_parameterchangeaction_free(ptr >>> 0, 1));
/**
*/
class ParameterChangeAction {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ParameterChangeAction.prototype);
        obj.__wbg_ptr = ptr;
        ParameterChangeActionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ParameterChangeActionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_parameterchangeaction_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.parameterchangeaction_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.parameterchangeaction_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ParameterChangeAction}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.parameterchangeaction_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ParameterChangeAction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.parameterchangeaction_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.parameterchangeaction_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ParameterChangeAction}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.parameterchangeaction_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ParameterChangeAction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.parameterchangeaction_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.parameterchangeaction_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ParameterChangeAction}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.parameterchangeaction_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ParameterChangeAction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {GovActionId | undefined}
    */
    action_id() {
        const ret = wasm.parameterchangeaction_action_id(this.__wbg_ptr);
        return ret === 0 ? undefined : GovActionId.__wrap(ret);
    }
    /**
    * @returns {ProtocolParamUpdate}
    */
    update() {
        const ret = wasm.parameterchangeaction_update(this.__wbg_ptr);
        return ProtocolParamUpdate.__wrap(ret);
    }
    /**
    * @returns {ScriptHash | undefined}
    */
    policy_hash() {
        const ret = wasm.parameterchangeaction_policy_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptHash.__wrap(ret);
    }
    /**
    * @param {GovActionId | undefined} action_id
    * @param {ProtocolParamUpdate} update
    * @param {ScriptHash | undefined} [policy_hash]
    * @returns {ParameterChangeAction}
    */
    static new(action_id, update, policy_hash) {
        let ptr0 = 0;
        if (!isLikeNone(action_id)) {
            _assertClass(action_id, GovActionId);
            ptr0 = action_id.__destroy_into_raw();
        }
        _assertClass(update, ProtocolParamUpdate);
        let ptr1 = 0;
        if (!isLikeNone(policy_hash)) {
            _assertClass(policy_hash, ScriptHash);
            ptr1 = policy_hash.__destroy_into_raw();
        }
        const ret = wasm.parameterchangeaction_new(ptr0, update.__wbg_ptr, ptr1);
        return ParameterChangeAction.__wrap(ret);
    }
}

const PartialPlutusWitnessFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_partialplutuswitness_free(ptr >>> 0, 1));
/**
* A partial Plutus witness
* It contains all the information needed to witness the Plutus script execution
* except for the redeemer tag and index
* Note: no datum is attached because only input script types have datums
*/
class PartialPlutusWitness {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PartialPlutusWitness.prototype);
        obj.__wbg_ptr = ptr;
        PartialPlutusWitnessFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PartialPlutusWitnessFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_partialplutuswitness_free(ptr, 0);
    }
    /**
    * @param {PlutusScriptWitness} script
    * @param {PlutusData} data
    * @returns {PartialPlutusWitness}
    */
    static new(script, data) {
        _assertClass(script, PlutusScriptWitness);
        _assertClass(data, PlutusData);
        const ret = wasm.partialplutuswitness_new(script.__wbg_ptr, data.__wbg_ptr);
        return PartialPlutusWitness.__wrap(ret);
    }
    /**
    * @returns {PlutusScriptWitness}
    */
    script() {
        const ret = wasm.partialplutuswitness_script(this.__wbg_ptr);
        return PlutusScriptWitness.__wrap(ret);
    }
    /**
    * @returns {PlutusData}
    */
    data() {
        const ret = wasm.partialplutuswitness_data(this.__wbg_ptr);
        return PlutusData.__wrap(ret);
    }
}

const PlutusDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_plutusdata_free(ptr >>> 0, 1));
/**
*/
class PlutusData {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PlutusData.prototype);
        obj.__wbg_ptr = ptr;
        PlutusDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PlutusDataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_plutusdata_free(ptr, 0);
    }
    /**
    *
    *     *  Convert to a Datum that will serialize equivalent to cardano-node's format
    *     *
    *     *  Please VERY STRONGLY consider using PlutusData::from_cbor_bytes() instead wherever possible.
    *     * You should try to never rely on a tool encoding CBOR a certain way as there are many possible,
    *     * and just because it matches with a specific datum, doesn't mean that a different datum won't differ.
    *     * This is critical as that means the datum hash won't match.
    *     * After creation a datum (or other hashable CBOR object) should only be treated as raw CBOR bytes,
    *     * or through a type that respects its specific CBOR format e.g. CML's PlutusData::from_cbor_bytes()
    *     *
    *     *  This function is just here in case there's no possible way at all to create from CBOR bytes and
    *     * thus cold only be constructed manually and then had this function called on it.
    *     *
    *     *  This is also the format that CSL and Lucid use
    *
    * @returns {PlutusData}
    */
    to_cardano_node_format() {
        const ret = wasm.plutusdata_to_cardano_node_format(this.__wbg_ptr);
        return PlutusData.__wrap(ret);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusdata_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusdata_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {PlutusData}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusdata_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusdata_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusdata_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {PlutusData}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusdata_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusdata_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusdata_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {PlutusData}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusdata_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {ConstrPlutusData} constr_plutus_data
    * @returns {PlutusData}
    */
    static new_constr_plutus_data(constr_plutus_data) {
        _assertClass(constr_plutus_data, ConstrPlutusData);
        const ret = wasm.plutusdata_new_constr_plutus_data(constr_plutus_data.__wbg_ptr);
        return PlutusData.__wrap(ret);
    }
    /**
    * @param {PlutusMap} map
    * @returns {PlutusData}
    */
    static new_map(map) {
        _assertClass(map, PlutusMap);
        const ret = wasm.plutusdata_new_map(map.__wbg_ptr);
        return PlutusData.__wrap(ret);
    }
    /**
    * @param {PlutusDataList} list
    * @returns {PlutusData}
    */
    static new_list(list) {
        _assertClass(list, PlutusDataList);
        const ret = wasm.plutusdata_new_list(list.__wbg_ptr);
        return PlutusData.__wrap(ret);
    }
    /**
    * @param {BigInteger} big_int
    * @returns {PlutusData}
    */
    static new_integer(big_int) {
        _assertClass(big_int, BigInteger);
        const ret = wasm.plutusdata_new_integer(big_int.__wbg_ptr);
        return PlutusData.__wrap(ret);
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {PlutusData}
    */
    static new_bytes(bytes) {
        const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.plutusdata_new_bytes(ptr0, len0);
        return PlutusData.__wrap(ret);
    }
    /**
    * @returns {PlutusDataKind}
    */
    kind() {
        const ret = wasm.plutusdata_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {ConstrPlutusData | undefined}
    */
    as_constr_plutus_data() {
        const ret = wasm.plutusdata_as_constr_plutus_data(this.__wbg_ptr);
        return ret === 0 ? undefined : ConstrPlutusData.__wrap(ret);
    }
    /**
    * @returns {PlutusMap | undefined}
    */
    as_map() {
        const ret = wasm.plutusdata_as_map(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusMap.__wrap(ret);
    }
    /**
    * @returns {PlutusDataList | undefined}
    */
    as_list() {
        const ret = wasm.plutusdata_as_list(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusDataList.__wrap(ret);
    }
    /**
    * @returns {BigInteger | undefined}
    */
    as_integer() {
        const ret = wasm.plutusdata_as_integer(this.__wbg_ptr);
        return ret === 0 ? undefined : BigInteger.__wrap(ret);
    }
    /**
    * @returns {Uint8Array | undefined}
    */
    as_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusdata_as_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const PlutusDataListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_plutusdatalist_free(ptr >>> 0, 1));
/**
*/
class PlutusDataList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PlutusDataList.prototype);
        obj.__wbg_ptr = ptr;
        PlutusDataListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PlutusDataListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_plutusdatalist_free(ptr, 0);
    }
    /**
    * @returns {PlutusDataList}
    */
    static new() {
        const ret = wasm.plutusdatalist_new();
        return PlutusDataList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.plutusdatalist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {PlutusData}
    */
    get(index) {
        const ret = wasm.plutusdatalist_get(this.__wbg_ptr, index);
        return PlutusData.__wrap(ret);
    }
    /**
    * @param {PlutusData} elem
    */
    add(elem) {
        _assertClass(elem, PlutusData);
        wasm.plutusdatalist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const PlutusMapFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_plutusmap_free(ptr >>> 0, 1));
/**
*/
class PlutusMap {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PlutusMap.prototype);
        obj.__wbg_ptr = ptr;
        PlutusMapFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PlutusMapFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_plutusmap_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusmap_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusmap_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {PlutusMap}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusmap_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusMap.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusmap_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusmap_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {PlutusMap}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusmap_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusMap.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {PlutusMap}
    */
    static new() {
        const ret = wasm.plutusmap_new();
        return PlutusMap.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.plutusmap_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @returns {boolean}
    */
    is_empty() {
        const ret = wasm.plutusmap_is_empty(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * Replaces all datums of a given key, if any exist.
    * @param {PlutusData} key
    * @param {PlutusData} value
    */
    set(key, value) {
        _assertClass(key, PlutusData);
        _assertClass(value, PlutusData);
        wasm.plutusmap_set(this.__wbg_ptr, key.__wbg_ptr, value.__wbg_ptr);
    }
    /**
    * Gets the plutus datum corresponding to a given key, if it exists.
    * Note: In the case of duplicate keys this only returns the first datum.
    * This is an extremely rare occurence on-chain but can happen.
    * @param {PlutusData} key
    * @returns {PlutusData | undefined}
    */
    get(key) {
        _assertClass(key, PlutusData);
        const ret = wasm.plutusmap_get(this.__wbg_ptr, key.__wbg_ptr);
        return ret === 0 ? undefined : PlutusData.__wrap(ret);
    }
    /**
    * In the extremely unlikely situation there are duplicate keys, this gets all of a single key
    * @param {PlutusData} key
    * @returns {PlutusDataList | undefined}
    */
    get_all(key) {
        _assertClass(key, PlutusData);
        const ret = wasm.plutusmap_get_all(this.__wbg_ptr, key.__wbg_ptr);
        return ret === 0 ? undefined : PlutusDataList.__wrap(ret);
    }
    /**
    * @returns {PlutusDataList}
    */
    keys() {
        const ret = wasm.plutusmap_keys(this.__wbg_ptr);
        return PlutusDataList.__wrap(ret);
    }
}

const PlutusScriptFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_plutusscript_free(ptr >>> 0, 1));
/**
* Version-agnostic Plutus script
*/
class PlutusScript {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PlutusScript.prototype);
        obj.__wbg_ptr = ptr;
        PlutusScriptFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PlutusScriptFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_plutusscript_free(ptr, 0);
    }
    /**
    * @param {PlutusV1Script} script
    * @returns {PlutusScript}
    */
    static from_v1(script) {
        _assertClass(script, PlutusV1Script);
        const ret = wasm.plutusscript_from_v1(script.__wbg_ptr);
        return PlutusScript.__wrap(ret);
    }
    /**
    * @param {PlutusV2Script} script
    * @returns {PlutusScript}
    */
    static from_v2(script) {
        _assertClass(script, PlutusV2Script);
        const ret = wasm.plutusscript_from_v2(script.__wbg_ptr);
        return PlutusScript.__wrap(ret);
    }
    /**
    * @param {PlutusV3Script} script
    * @returns {PlutusScript}
    */
    static from_v3(script) {
        _assertClass(script, PlutusV3Script);
        const ret = wasm.plutusscript_from_v3(script.__wbg_ptr);
        return PlutusScript.__wrap(ret);
    }
    /**
    * @returns {ScriptHash}
    */
    hash() {
        const ret = wasm.plutusscript_hash(this.__wbg_ptr);
        return ScriptHash.__wrap(ret);
    }
    /**
    * @returns {PlutusV1Script | undefined}
    */
    as_v1() {
        const ret = wasm.plutusscript_as_v1(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV1Script.__wrap(ret);
    }
    /**
    * @returns {PlutusV2Script | undefined}
    */
    as_v2() {
        const ret = wasm.plutusscript_as_v2(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV2Script.__wrap(ret);
    }
    /**
    * @returns {PlutusV3Script | undefined}
    */
    as_v3() {
        const ret = wasm.plutusscript_as_v3(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV3Script.__wrap(ret);
    }
    /**
    * @returns {Language}
    */
    version() {
        const ret = wasm.plutusscript_version(this.__wbg_ptr);
        return ret;
    }
}

const PlutusScriptWitnessFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_plutusscriptwitness_free(ptr >>> 0, 1));
/**
*/
class PlutusScriptWitness {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PlutusScriptWitness.prototype);
        obj.__wbg_ptr = ptr;
        PlutusScriptWitnessFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PlutusScriptWitnessFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_plutusscriptwitness_free(ptr, 0);
    }
    /**
    * @param {PlutusScript} script
    * @returns {PlutusScriptWitness}
    */
    static new_script(script) {
        _assertClass(script, PlutusScript);
        const ret = wasm.plutusscriptwitness_new_script(script.__wbg_ptr);
        return PlutusScriptWitness.__wrap(ret);
    }
    /**
    * @param {ScriptHash} hash
    * @returns {PlutusScriptWitness}
    */
    static new_ref(hash) {
        _assertClass(hash, ScriptHash);
        const ret = wasm.plutusscriptwitness_new_ref(hash.__wbg_ptr);
        return PlutusScriptWitness.__wrap(ret);
    }
    /**
    * @returns {ScriptHash}
    */
    hash() {
        const ret = wasm.plutusscriptwitness_hash(this.__wbg_ptr);
        return ScriptHash.__wrap(ret);
    }
}

const PlutusV1ScriptFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_plutusv1script_free(ptr >>> 0, 1));
/**
*/
class PlutusV1Script {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PlutusV1Script.prototype);
        obj.__wbg_ptr = ptr;
        PlutusV1ScriptFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PlutusV1ScriptFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_plutusv1script_free(ptr, 0);
    }
    /**
    * @returns {ScriptHash}
    */
    hash() {
        const ret = wasm.plutusv1script_hash(this.__wbg_ptr);
        return ScriptHash.__wrap(ret);
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv1script_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {PlutusV1Script}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv1script_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV1Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv1script_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {PlutusV1Script}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv1script_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV1Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv1script_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv1script_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {PlutusV1Script}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv1script_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV1Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv1script_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv1script_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {PlutusV1Script}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv1script_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV1Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv1script_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv1script_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {PlutusV1Script}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv1script_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV1Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const PlutusV1ScriptListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_plutusv1scriptlist_free(ptr >>> 0, 1));
/**
*/
class PlutusV1ScriptList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PlutusV1ScriptList.prototype);
        obj.__wbg_ptr = ptr;
        PlutusV1ScriptListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PlutusV1ScriptListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_plutusv1scriptlist_free(ptr, 0);
    }
    /**
    * @returns {PlutusV1ScriptList}
    */
    static new() {
        const ret = wasm.plutusv1scriptlist_new();
        return PlutusV1ScriptList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.plutusv1scriptlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {PlutusV1Script}
    */
    get(index) {
        const ret = wasm.plutusv1scriptlist_get(this.__wbg_ptr, index);
        return PlutusV1Script.__wrap(ret);
    }
    /**
    * @param {PlutusV1Script} elem
    */
    add(elem) {
        _assertClass(elem, PlutusV1Script);
        wasm.plutusv1scriptlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const PlutusV2ScriptFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_plutusv2script_free(ptr >>> 0, 1));
/**
*/
class PlutusV2Script {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PlutusV2Script.prototype);
        obj.__wbg_ptr = ptr;
        PlutusV2ScriptFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PlutusV2ScriptFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_plutusv2script_free(ptr, 0);
    }
    /**
    * @returns {ScriptHash}
    */
    hash() {
        const ret = wasm.plutusv2script_hash(this.__wbg_ptr);
        return ScriptHash.__wrap(ret);
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv2script_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {PlutusV2Script}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv2script_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV2Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv2script_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {PlutusV2Script}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv2script_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV2Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv2script_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv2script_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {PlutusV2Script}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv2script_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV2Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv2script_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv2script_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {PlutusV2Script}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv2script_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV2Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv2script_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv2script_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {PlutusV2Script}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv2script_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV2Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const PlutusV2ScriptListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_plutusv2scriptlist_free(ptr >>> 0, 1));
/**
*/
class PlutusV2ScriptList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PlutusV2ScriptList.prototype);
        obj.__wbg_ptr = ptr;
        PlutusV2ScriptListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PlutusV2ScriptListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_plutusv2scriptlist_free(ptr, 0);
    }
    /**
    * @returns {PlutusV2ScriptList}
    */
    static new() {
        const ret = wasm.plutusv2scriptlist_new();
        return PlutusV2ScriptList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.plutusv2scriptlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {PlutusV2Script}
    */
    get(index) {
        const ret = wasm.plutusv2scriptlist_get(this.__wbg_ptr, index);
        return PlutusV2Script.__wrap(ret);
    }
    /**
    * @param {PlutusV2Script} elem
    */
    add(elem) {
        _assertClass(elem, PlutusV2Script);
        wasm.plutusv2scriptlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const PlutusV3ScriptFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_plutusv3script_free(ptr >>> 0, 1));
/**
*/
class PlutusV3Script {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PlutusV3Script.prototype);
        obj.__wbg_ptr = ptr;
        PlutusV3ScriptFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PlutusV3ScriptFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_plutusv3script_free(ptr, 0);
    }
    /**
    * @returns {ScriptHash}
    */
    hash() {
        const ret = wasm.plutusv3script_hash(this.__wbg_ptr);
        return ScriptHash.__wrap(ret);
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv3script_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {PlutusV3Script}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv3script_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV3Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv3script_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {PlutusV3Script}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv3script_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV3Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv3script_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv3script_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {PlutusV3Script}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv3script_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV3Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv3script_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv3script_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {PlutusV3Script}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv3script_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV3Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv3script_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.plutusv3script_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {PlutusV3Script}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.plutusv3script_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PlutusV3Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const PlutusV3ScriptListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_plutusv3scriptlist_free(ptr >>> 0, 1));
/**
*/
class PlutusV3ScriptList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PlutusV3ScriptList.prototype);
        obj.__wbg_ptr = ptr;
        PlutusV3ScriptListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PlutusV3ScriptListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_plutusv3scriptlist_free(ptr, 0);
    }
    /**
    * @returns {PlutusV3ScriptList}
    */
    static new() {
        const ret = wasm.plutusv3scriptlist_new();
        return PlutusV3ScriptList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.plutusv3scriptlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {PlutusV3Script}
    */
    get(index) {
        const ret = wasm.plutusv3scriptlist_get(this.__wbg_ptr, index);
        return PlutusV3Script.__wrap(ret);
    }
    /**
    * @param {PlutusV3Script} elem
    */
    add(elem) {
        _assertClass(elem, PlutusV3Script);
        wasm.plutusv3scriptlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const PointerFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_pointer_free(ptr >>> 0, 1));
/**
*/
class Pointer {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Pointer.prototype);
        obj.__wbg_ptr = ptr;
        PointerFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PointerFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_pointer_free(ptr, 0);
    }
}

const PointerAddressFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_pointeraddress_free(ptr >>> 0, 1));
/**
*/
class PointerAddress {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PointerAddress.prototype);
        obj.__wbg_ptr = ptr;
        PointerAddressFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PointerAddressFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_pointeraddress_free(ptr, 0);
    }
    /**
    * @param {number} network
    * @param {Credential} payment
    * @param {Pointer} stake
    * @returns {PointerAddress}
    */
    static new(network, payment, stake) {
        _assertClass(payment, Credential);
        _assertClass(stake, Pointer);
        const ret = wasm.pointeraddress_new(network, payment.__wbg_ptr, stake.__wbg_ptr);
        return PointerAddress.__wrap(ret);
    }
    /**
    * @returns {Address}
    */
    to_address() {
        const ret = wasm.pointeraddress_to_address(this.__wbg_ptr);
        return Address.__wrap(ret);
    }
    /**
    * @param {Address} address
    * @returns {PointerAddress | undefined}
    */
    static from_address(address) {
        _assertClass(address, Address);
        const ret = wasm.pointeraddress_from_address(address.__wbg_ptr);
        return ret === 0 ? undefined : PointerAddress.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    network_id() {
        const ret = wasm.pointeraddress_network_id(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Credential}
    */
    payment() {
        const ret = wasm.pointeraddress_payment(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {Pointer}
    */
    stake() {
        const ret = wasm.pointeraddress_stake(this.__wbg_ptr);
        return Pointer.__wrap(ret);
    }
}

const PolicyIdListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_policyidlist_free(ptr >>> 0, 1));
/**
*/
class PolicyIdList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PolicyIdList.prototype);
        obj.__wbg_ptr = ptr;
        PolicyIdListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PolicyIdListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_policyidlist_free(ptr, 0);
    }
    /**
    * @returns {PolicyIdList}
    */
    static new() {
        const ret = wasm.policyidlist_new();
        return PolicyIdList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.policyidlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {ScriptHash}
    */
    get(index) {
        const ret = wasm.policyidlist_get(this.__wbg_ptr, index);
        return ScriptHash.__wrap(ret);
    }
    /**
    * @param {ScriptHash} elem
    */
    add(elem) {
        _assertClass(elem, ScriptHash);
        wasm.policyidlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const PoolMetadataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_poolmetadata_free(ptr >>> 0, 1));
/**
*/
class PoolMetadata {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PoolMetadata.prototype);
        obj.__wbg_ptr = ptr;
        PoolMetadataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PoolMetadataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_poolmetadata_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolmetadata_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolmetadata_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {PoolMetadata}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolmetadata_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolMetadata.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolmetadata_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolmetadata_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {PoolMetadata}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolmetadata_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolMetadata.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolmetadata_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolmetadata_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {PoolMetadata}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolmetadata_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolMetadata.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Url}
    */
    url() {
        const ret = wasm.poolmetadata_url(this.__wbg_ptr);
        return Url.__wrap(ret);
    }
    /**
    * @returns {PoolMetadataHash}
    */
    pool_metadata_hash() {
        const ret = wasm.poolmetadata_pool_metadata_hash(this.__wbg_ptr);
        return PoolMetadataHash.__wrap(ret);
    }
    /**
    * @param {Url} url
    * @param {PoolMetadataHash} pool_metadata_hash
    * @returns {PoolMetadata}
    */
    static new(url, pool_metadata_hash) {
        _assertClass(url, Url);
        _assertClass(pool_metadata_hash, PoolMetadataHash);
        const ret = wasm.poolmetadata_new(url.__wbg_ptr, pool_metadata_hash.__wbg_ptr);
        return PoolMetadata.__wrap(ret);
    }
}

const PoolMetadataHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_poolmetadatahash_free(ptr >>> 0, 1));
/**
*/
class PoolMetadataHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PoolMetadataHash.prototype);
        obj.__wbg_ptr = ptr;
        PoolMetadataHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PoolMetadataHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_poolmetadatahash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolmetadatahash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {PoolMetadataHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolmetadatahash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolMetadataHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolmetadatahash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {PoolMetadataHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolmetadatahash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolMetadataHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolmetadatahash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {PoolMetadataHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolmetadatahash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolMetadataHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const PoolParamsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_poolparams_free(ptr >>> 0, 1));
/**
*/
class PoolParams {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PoolParams.prototype);
        obj.__wbg_ptr = ptr;
        PoolParamsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PoolParamsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_poolparams_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolparams_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolparams_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {PoolParams}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolparams_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolParams.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolparams_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolparams_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {PoolParams}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolparams_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolParams.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolparams_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolparams_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {PoolParams}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolparams_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolParams.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Ed25519KeyHash}
    */
    operator() {
        const ret = wasm.poolparams_operator(this.__wbg_ptr);
        return Ed25519KeyHash.__wrap(ret);
    }
    /**
    * @returns {VRFKeyHash}
    */
    vrf_keyhash() {
        const ret = wasm.poolparams_vrf_keyhash(this.__wbg_ptr);
        return VRFKeyHash.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    pledge() {
        const ret = wasm.poolparams_pledge(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {bigint}
    */
    cost() {
        const ret = wasm.poolparams_cost(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {UnitInterval}
    */
    margin() {
        const ret = wasm.poolparams_margin(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {RewardAddress}
    */
    reward_account() {
        const ret = wasm.poolparams_reward_account(this.__wbg_ptr);
        return RewardAddress.__wrap(ret);
    }
    /**
    * @returns {Ed25519KeyHashList}
    */
    pool_owners() {
        const ret = wasm.poolparams_pool_owners(this.__wbg_ptr);
        return Ed25519KeyHashList.__wrap(ret);
    }
    /**
    * @returns {RelayList}
    */
    relays() {
        const ret = wasm.poolparams_relays(this.__wbg_ptr);
        return RelayList.__wrap(ret);
    }
    /**
    * @returns {PoolMetadata | undefined}
    */
    pool_metadata() {
        const ret = wasm.poolparams_pool_metadata(this.__wbg_ptr);
        return ret === 0 ? undefined : PoolMetadata.__wrap(ret);
    }
    /**
    * @param {Ed25519KeyHash} operator
    * @param {VRFKeyHash} vrf_keyhash
    * @param {bigint} pledge
    * @param {bigint} cost
    * @param {UnitInterval} margin
    * @param {RewardAddress} reward_account
    * @param {Ed25519KeyHashList} pool_owners
    * @param {RelayList} relays
    * @param {PoolMetadata | undefined} [pool_metadata]
    * @returns {PoolParams}
    */
    static new(operator, vrf_keyhash, pledge, cost, margin, reward_account, pool_owners, relays, pool_metadata) {
        _assertClass(operator, Ed25519KeyHash);
        _assertClass(vrf_keyhash, VRFKeyHash);
        _assertClass(margin, UnitInterval);
        _assertClass(reward_account, RewardAddress);
        _assertClass(pool_owners, Ed25519KeyHashList);
        _assertClass(relays, RelayList);
        let ptr0 = 0;
        if (!isLikeNone(pool_metadata)) {
            _assertClass(pool_metadata, PoolMetadata);
            ptr0 = pool_metadata.__destroy_into_raw();
        }
        const ret = wasm.poolparams_new(operator.__wbg_ptr, vrf_keyhash.__wbg_ptr, pledge, cost, margin.__wbg_ptr, reward_account.__wbg_ptr, pool_owners.__wbg_ptr, relays.__wbg_ptr, ptr0);
        return PoolParams.__wrap(ret);
    }
}

const PoolRegistrationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_poolregistration_free(ptr >>> 0, 1));
/**
*/
class PoolRegistration {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PoolRegistration.prototype);
        obj.__wbg_ptr = ptr;
        PoolRegistrationFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PoolRegistrationFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_poolregistration_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolregistration_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolregistration_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {PoolRegistration}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolregistration_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolRegistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolregistration_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolregistration_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {PoolRegistration}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolregistration_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolRegistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolregistration_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolregistration_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {PoolRegistration}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolregistration_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolRegistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {PoolParams}
    */
    pool_params() {
        const ret = wasm.poolregistration_pool_params(this.__wbg_ptr);
        return PoolParams.__wrap(ret);
    }
    /**
    * @param {PoolParams} pool_params
    * @returns {PoolRegistration}
    */
    static new(pool_params) {
        _assertClass(pool_params, PoolParams);
        const ret = wasm.poolregistration_new(pool_params.__wbg_ptr);
        return PoolRegistration.__wrap(ret);
    }
}

const PoolRetirementFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_poolretirement_free(ptr >>> 0, 1));
/**
*/
class PoolRetirement {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PoolRetirement.prototype);
        obj.__wbg_ptr = ptr;
        PoolRetirementFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PoolRetirementFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_poolretirement_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolretirement_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolretirement_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {PoolRetirement}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolretirement_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolRetirement.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolretirement_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolretirement_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {PoolRetirement}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolretirement_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolRetirement.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolretirement_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolretirement_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {PoolRetirement}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolretirement_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolRetirement.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Ed25519KeyHash}
    */
    pool() {
        const ret = wasm.poolretirement_pool(this.__wbg_ptr);
        return Ed25519KeyHash.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    epoch() {
        const ret = wasm.poolretirement_epoch(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {Ed25519KeyHash} pool
    * @param {bigint} epoch
    * @returns {PoolRetirement}
    */
    static new(pool, epoch) {
        _assertClass(pool, Ed25519KeyHash);
        const ret = wasm.poolretirement_new(pool.__wbg_ptr, epoch);
        return PoolRetirement.__wrap(ret);
    }
}

const PoolVotingThresholdsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_poolvotingthresholds_free(ptr >>> 0, 1));
/**
*/
class PoolVotingThresholds {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PoolVotingThresholds.prototype);
        obj.__wbg_ptr = ptr;
        PoolVotingThresholdsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PoolVotingThresholdsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_poolvotingthresholds_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolvotingthresholds_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolvotingthresholds_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {PoolVotingThresholds}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolvotingthresholds_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolVotingThresholds.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolvotingthresholds_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolvotingthresholds_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {PoolVotingThresholds}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolvotingthresholds_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolVotingThresholds.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolvotingthresholds_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.poolvotingthresholds_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {PoolVotingThresholds}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.poolvotingthresholds_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PoolVotingThresholds.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {UnitInterval}
    */
    motion_no_confidence() {
        const ret = wasm.poolvotingthresholds_motion_no_confidence(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    committee_normal() {
        const ret = wasm.poolvotingthresholds_committee_normal(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    committee_no_confidence() {
        const ret = wasm.poolvotingthresholds_committee_no_confidence(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    hard_fork_initiation() {
        const ret = wasm.poolvotingthresholds_hard_fork_initiation(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    security_relevant_parameter_voting_threshold() {
        const ret = wasm.poolvotingthresholds_security_relevant_parameter_voting_threshold(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @param {UnitInterval} motion_no_confidence
    * @param {UnitInterval} committee_normal
    * @param {UnitInterval} committee_no_confidence
    * @param {UnitInterval} hard_fork_initiation
    * @param {UnitInterval} security_relevant_parameter_voting_threshold
    * @returns {PoolVotingThresholds}
    */
    static new(motion_no_confidence, committee_normal, committee_no_confidence, hard_fork_initiation, security_relevant_parameter_voting_threshold) {
        _assertClass(motion_no_confidence, UnitInterval);
        _assertClass(committee_normal, UnitInterval);
        _assertClass(committee_no_confidence, UnitInterval);
        _assertClass(hard_fork_initiation, UnitInterval);
        _assertClass(security_relevant_parameter_voting_threshold, UnitInterval);
        const ret = wasm.poolvotingthresholds_new(motion_no_confidence.__wbg_ptr, committee_normal.__wbg_ptr, committee_no_confidence.__wbg_ptr, hard_fork_initiation.__wbg_ptr, security_relevant_parameter_voting_threshold.__wbg_ptr);
        return PoolVotingThresholds.__wrap(ret);
    }
}

const PrivateKeyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_privatekey_free(ptr >>> 0, 1));
/**
*/
class PrivateKey {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PrivateKey.prototype);
        obj.__wbg_ptr = ptr;
        PrivateKeyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PrivateKeyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_privatekey_free(ptr, 0);
    }
    /**
    * @returns {PublicKey}
    */
    to_public() {
        const ret = wasm.privatekey_to_public(this.__wbg_ptr);
        return PublicKey.__wrap(ret);
    }
    /**
    * @returns {PrivateKey}
    */
    static generate_ed25519() {
        const ret = wasm.privatekey_generate_ed25519();
        return PrivateKey.__wrap(ret);
    }
    /**
    * @returns {PrivateKey}
    */
    static generate_ed25519extended() {
        const ret = wasm.privatekey_generate_ed25519extended();
        return PrivateKey.__wrap(ret);
    }
    /**
    * Get private key from its bech32 representation
    * ```javascript
    * PrivateKey.from_bech32(&#39;ed25519_sk1ahfetf02qwwg4dkq7mgp4a25lx5vh9920cr5wnxmpzz9906qvm8qwvlts0&#39;);
    * ```
    * For an extended 25519 key
    * ```javascript
    * PrivateKey.from_bech32(&#39;ed25519e_sk1gqwl4szuwwh6d0yk3nsqcc6xxc3fpvjlevgwvt60df59v8zd8f8prazt8ln3lmz096ux3xvhhvm3ca9wj2yctdh3pnw0szrma07rt5gl748fp&#39;);
    * ```
    * @param {string} bech32_str
    * @returns {PrivateKey}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.privatekey_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PrivateKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_bech32() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.privatekey_to_bech32(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.privatekey_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {PrivateKey}
    */
    static from_extended_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.privatekey_from_extended_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PrivateKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {PrivateKey}
    */
    static from_normal_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.privatekey_from_normal_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PrivateKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} message
    * @returns {Ed25519Signature}
    */
    sign(message) {
        const ptr0 = passArray8ToWasm0(message, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.privatekey_sign(this.__wbg_ptr, ptr0, len0);
        return Ed25519Signature.__wrap(ret);
    }
}

const ProposalBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_proposalbuilder_free(ptr >>> 0, 1));
/**
*/
class ProposalBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ProposalBuilder.prototype);
        obj.__wbg_ptr = ptr;
        ProposalBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ProposalBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_proposalbuilder_free(ptr, 0);
    }
    /**
    * @returns {ProposalBuilder}
    */
    static new() {
        const ret = wasm.proposalbuilder_new();
        return ProposalBuilder.__wrap(ret);
    }
    /**
    * @param {ProposalProcedure} proposal
    * @returns {ProposalBuilder}
    */
    with_proposal(proposal) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(proposal, ProposalProcedure);
            var ptr0 = proposal.__destroy_into_raw();
            wasm.proposalbuilder_with_proposal(retptr, this.__wbg_ptr, ptr0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ProposalBuilder.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {ProposalProcedure} proposal
    * @param {NativeScript} native_script
    * @param {NativeScriptWitnessInfo} witness_info
    * @returns {ProposalBuilder}
    */
    with_native_script_proposal(proposal, native_script, witness_info) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(proposal, ProposalProcedure);
            var ptr0 = proposal.__destroy_into_raw();
            _assertClass(native_script, NativeScript);
            var ptr1 = native_script.__destroy_into_raw();
            _assertClass(witness_info, NativeScriptWitnessInfo);
            var ptr2 = witness_info.__destroy_into_raw();
            wasm.proposalbuilder_with_native_script_proposal(retptr, this.__wbg_ptr, ptr0, ptr1, ptr2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ProposalBuilder.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {ProposalProcedure} proposal
    * @param {PartialPlutusWitness} partial_witness
    * @param {Ed25519KeyHashList} required_signers
    * @param {PlutusData} datum
    * @returns {ProposalBuilder}
    */
    with_plutus_proposal(proposal, partial_witness, required_signers, datum) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(proposal, ProposalProcedure);
            _assertClass(partial_witness, PartialPlutusWitness);
            _assertClass(required_signers, Ed25519KeyHashList);
            _assertClass(datum, PlutusData);
            wasm.proposalbuilder_with_plutus_proposal(retptr, this.__wbg_ptr, proposal.__wbg_ptr, partial_witness.__wbg_ptr, required_signers.__wbg_ptr, datum.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ProposalBuilder.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {ProposalProcedure} proposal
    * @param {PartialPlutusWitness} partial_witness
    * @param {Ed25519KeyHashList} required_signers
    * @returns {ProposalBuilder}
    */
    with_plutus_proposal_inline_datum(proposal, partial_witness, required_signers) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(proposal, ProposalProcedure);
            var ptr0 = proposal.__destroy_into_raw();
            _assertClass(partial_witness, PartialPlutusWitness);
            var ptr1 = partial_witness.__destroy_into_raw();
            _assertClass(required_signers, Ed25519KeyHashList);
            var ptr2 = required_signers.__destroy_into_raw();
            wasm.proposalbuilder_with_plutus_proposal_inline_datum(retptr, this.__wbg_ptr, ptr0, ptr1, ptr2);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ProposalBuilder.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {ProposalBuilderResult}
    */
    build() {
        const ret = wasm.proposalbuilder_build(this.__wbg_ptr);
        return ProposalBuilderResult.__wrap(ret);
    }
}

const ProposalBuilderResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_proposalbuilderresult_free(ptr >>> 0, 1));
/**
*/
class ProposalBuilderResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ProposalBuilderResult.prototype);
        obj.__wbg_ptr = ptr;
        ProposalBuilderResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ProposalBuilderResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_proposalbuilderresult_free(ptr, 0);
    }
}

const ProposalProcedureFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_proposalprocedure_free(ptr >>> 0, 1));
/**
*/
class ProposalProcedure {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ProposalProcedure.prototype);
        obj.__wbg_ptr = ptr;
        ProposalProcedureFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ProposalProcedureFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_proposalprocedure_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.proposalprocedure_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.proposalprocedure_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ProposalProcedure}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.proposalprocedure_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ProposalProcedure.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.proposalprocedure_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.proposalprocedure_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ProposalProcedure}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.proposalprocedure_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ProposalProcedure.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.proposalprocedure_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.proposalprocedure_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ProposalProcedure}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.proposalprocedure_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ProposalProcedure.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint}
    */
    deposit() {
        const ret = wasm.proposalprocedure_deposit(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {RewardAddress}
    */
    reward_account() {
        const ret = wasm.proposalprocedure_reward_account(this.__wbg_ptr);
        return RewardAddress.__wrap(ret);
    }
    /**
    * @returns {GovAction}
    */
    gov_action() {
        const ret = wasm.proposalprocedure_gov_action(this.__wbg_ptr);
        return GovAction.__wrap(ret);
    }
    /**
    * @returns {Anchor}
    */
    anchor() {
        const ret = wasm.proposalprocedure_anchor(this.__wbg_ptr);
        return Anchor.__wrap(ret);
    }
    /**
    * @param {bigint} deposit
    * @param {RewardAddress} reward_account
    * @param {GovAction} gov_action
    * @param {Anchor} anchor
    * @returns {ProposalProcedure}
    */
    static new(deposit, reward_account, gov_action, anchor) {
        _assertClass(reward_account, RewardAddress);
        _assertClass(gov_action, GovAction);
        _assertClass(anchor, Anchor);
        const ret = wasm.proposalprocedure_new(deposit, reward_account.__wbg_ptr, gov_action.__wbg_ptr, anchor.__wbg_ptr);
        return ProposalProcedure.__wrap(ret);
    }
}

const ProposalProcedureListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_proposalprocedurelist_free(ptr >>> 0, 1));
/**
*/
class ProposalProcedureList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ProposalProcedureList.prototype);
        obj.__wbg_ptr = ptr;
        ProposalProcedureListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ProposalProcedureListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_proposalprocedurelist_free(ptr, 0);
    }
    /**
    * @returns {ProposalProcedureList}
    */
    static new() {
        const ret = wasm.proposalprocedurelist_new();
        return ProposalProcedureList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.proposalprocedurelist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {ProposalProcedure}
    */
    get(index) {
        const ret = wasm.proposalprocedurelist_get(this.__wbg_ptr, index);
        return ProposalProcedure.__wrap(ret);
    }
    /**
    * @param {ProposalProcedure} elem
    */
    add(elem) {
        _assertClass(elem, ProposalProcedure);
        wasm.proposalprocedurelist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const ProtocolMagicFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_protocolmagic_free(ptr >>> 0, 1));
/**
*/
class ProtocolMagic {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ProtocolMagic.prototype);
        obj.__wbg_ptr = ptr;
        ProtocolMagicFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ProtocolMagicFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_protocolmagic_free(ptr, 0);
    }
    /**
    * @param {number} pm
    * @returns {ProtocolMagic}
    */
    static new(pm) {
        const ret = wasm.protocolmagic_new(pm);
        return ProtocolMagic.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    to_int() {
        const ret = wasm.protocolmagic_to_int(this.__wbg_ptr);
        return ret >>> 0;
    }
}

const ProtocolParamUpdateFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_protocolparamupdate_free(ptr >>> 0, 1));
/**
*/
class ProtocolParamUpdate {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ProtocolParamUpdate.prototype);
        obj.__wbg_ptr = ptr;
        ProtocolParamUpdateFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ProtocolParamUpdateFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_protocolparamupdate_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ProtocolParamUpdate}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.protocolparamupdate_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ProtocolParamUpdate.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ProtocolParamUpdate}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.protocolparamupdate_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ProtocolParamUpdate.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ProtocolParamUpdate}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.protocolparamupdate_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ProtocolParamUpdate.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} minfee_a
    */
    set_minfee_a(minfee_a) {
        wasm.protocolparamupdate_set_minfee_a(this.__wbg_ptr, minfee_a);
    }
    /**
    * @returns {bigint | undefined}
    */
    minfee_a() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_minfee_a(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} minfee_b
    */
    set_minfee_b(minfee_b) {
        wasm.protocolparamupdate_set_minfee_b(this.__wbg_ptr, minfee_b);
    }
    /**
    * @returns {bigint | undefined}
    */
    minfee_b() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_minfee_b(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} max_block_body_size
    */
    set_max_block_body_size(max_block_body_size) {
        wasm.protocolparamupdate_set_max_block_body_size(this.__wbg_ptr, max_block_body_size);
    }
    /**
    * @returns {bigint | undefined}
    */
    max_block_body_size() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_max_block_body_size(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} max_transaction_size
    */
    set_max_transaction_size(max_transaction_size) {
        wasm.protocolparamupdate_set_max_transaction_size(this.__wbg_ptr, max_transaction_size);
    }
    /**
    * @returns {bigint | undefined}
    */
    max_transaction_size() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_max_transaction_size(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} max_block_header_size
    */
    set_max_block_header_size(max_block_header_size) {
        wasm.protocolparamupdate_set_max_block_header_size(this.__wbg_ptr, max_block_header_size);
    }
    /**
    * @returns {bigint | undefined}
    */
    max_block_header_size() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_max_block_header_size(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} key_deposit
    */
    set_key_deposit(key_deposit) {
        wasm.protocolparamupdate_set_key_deposit(this.__wbg_ptr, key_deposit);
    }
    /**
    * @returns {bigint | undefined}
    */
    key_deposit() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_key_deposit(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} pool_deposit
    */
    set_pool_deposit(pool_deposit) {
        wasm.protocolparamupdate_set_pool_deposit(this.__wbg_ptr, pool_deposit);
    }
    /**
    * @returns {bigint | undefined}
    */
    pool_deposit() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_pool_deposit(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} maximum_epoch
    */
    set_maximum_epoch(maximum_epoch) {
        wasm.protocolparamupdate_set_maximum_epoch(this.__wbg_ptr, maximum_epoch);
    }
    /**
    * @returns {bigint | undefined}
    */
    maximum_epoch() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_maximum_epoch(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} n_opt
    */
    set_n_opt(n_opt) {
        wasm.protocolparamupdate_set_n_opt(this.__wbg_ptr, n_opt);
    }
    /**
    * @returns {bigint | undefined}
    */
    n_opt() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_n_opt(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Rational} pool_pledge_influence
    */
    set_pool_pledge_influence(pool_pledge_influence) {
        _assertClass(pool_pledge_influence, Rational);
        wasm.protocolparamupdate_set_pool_pledge_influence(this.__wbg_ptr, pool_pledge_influence.__wbg_ptr);
    }
    /**
    * @returns {Rational | undefined}
    */
    pool_pledge_influence() {
        const ret = wasm.protocolparamupdate_pool_pledge_influence(this.__wbg_ptr);
        return ret === 0 ? undefined : Rational.__wrap(ret);
    }
    /**
    * @param {UnitInterval} expansion_rate
    */
    set_expansion_rate(expansion_rate) {
        _assertClass(expansion_rate, UnitInterval);
        wasm.protocolparamupdate_set_expansion_rate(this.__wbg_ptr, expansion_rate.__wbg_ptr);
    }
    /**
    * @returns {UnitInterval | undefined}
    */
    expansion_rate() {
        const ret = wasm.protocolparamupdate_expansion_rate(this.__wbg_ptr);
        return ret === 0 ? undefined : UnitInterval.__wrap(ret);
    }
    /**
    * @param {UnitInterval} treasury_growth_rate
    */
    set_treasury_growth_rate(treasury_growth_rate) {
        _assertClass(treasury_growth_rate, UnitInterval);
        wasm.protocolparamupdate_set_treasury_growth_rate(this.__wbg_ptr, treasury_growth_rate.__wbg_ptr);
    }
    /**
    * @returns {UnitInterval | undefined}
    */
    treasury_growth_rate() {
        const ret = wasm.protocolparamupdate_treasury_growth_rate(this.__wbg_ptr);
        return ret === 0 ? undefined : UnitInterval.__wrap(ret);
    }
    /**
    * @param {bigint} min_pool_cost
    */
    set_min_pool_cost(min_pool_cost) {
        wasm.protocolparamupdate_set_min_pool_cost(this.__wbg_ptr, min_pool_cost);
    }
    /**
    * @returns {bigint | undefined}
    */
    min_pool_cost() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_min_pool_cost(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} ada_per_utxo_byte
    */
    set_ada_per_utxo_byte(ada_per_utxo_byte) {
        wasm.protocolparamupdate_set_ada_per_utxo_byte(this.__wbg_ptr, ada_per_utxo_byte);
    }
    /**
    * @returns {bigint | undefined}
    */
    ada_per_utxo_byte() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_ada_per_utxo_byte(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {CostModels} cost_models_for_script_languages
    */
    set_cost_models_for_script_languages(cost_models_for_script_languages) {
        _assertClass(cost_models_for_script_languages, CostModels);
        wasm.protocolparamupdate_set_cost_models_for_script_languages(this.__wbg_ptr, cost_models_for_script_languages.__wbg_ptr);
    }
    /**
    * @returns {CostModels | undefined}
    */
    cost_models_for_script_languages() {
        const ret = wasm.protocolparamupdate_cost_models_for_script_languages(this.__wbg_ptr);
        return ret === 0 ? undefined : CostModels.__wrap(ret);
    }
    /**
    * @param {ExUnitPrices} execution_costs
    */
    set_execution_costs(execution_costs) {
        _assertClass(execution_costs, ExUnitPrices);
        wasm.protocolparamupdate_set_execution_costs(this.__wbg_ptr, execution_costs.__wbg_ptr);
    }
    /**
    * @returns {ExUnitPrices | undefined}
    */
    execution_costs() {
        const ret = wasm.protocolparamupdate_execution_costs(this.__wbg_ptr);
        return ret === 0 ? undefined : ExUnitPrices.__wrap(ret);
    }
    /**
    * @param {ExUnits} max_tx_ex_units
    */
    set_max_tx_ex_units(max_tx_ex_units) {
        _assertClass(max_tx_ex_units, ExUnits);
        wasm.protocolparamupdate_set_max_tx_ex_units(this.__wbg_ptr, max_tx_ex_units.__wbg_ptr);
    }
    /**
    * @returns {ExUnits | undefined}
    */
    max_tx_ex_units() {
        const ret = wasm.protocolparamupdate_max_tx_ex_units(this.__wbg_ptr);
        return ret === 0 ? undefined : ExUnits.__wrap(ret);
    }
    /**
    * @param {ExUnits} max_block_ex_units
    */
    set_max_block_ex_units(max_block_ex_units) {
        _assertClass(max_block_ex_units, ExUnits);
        wasm.protocolparamupdate_set_max_block_ex_units(this.__wbg_ptr, max_block_ex_units.__wbg_ptr);
    }
    /**
    * @returns {ExUnits | undefined}
    */
    max_block_ex_units() {
        const ret = wasm.protocolparamupdate_max_block_ex_units(this.__wbg_ptr);
        return ret === 0 ? undefined : ExUnits.__wrap(ret);
    }
    /**
    * @param {bigint} max_value_size
    */
    set_max_value_size(max_value_size) {
        wasm.protocolparamupdate_set_max_value_size(this.__wbg_ptr, max_value_size);
    }
    /**
    * @returns {bigint | undefined}
    */
    max_value_size() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_max_value_size(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} collateral_percentage
    */
    set_collateral_percentage(collateral_percentage) {
        wasm.protocolparamupdate_set_collateral_percentage(this.__wbg_ptr, collateral_percentage);
    }
    /**
    * @returns {bigint | undefined}
    */
    collateral_percentage() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_collateral_percentage(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} max_collateral_inputs
    */
    set_max_collateral_inputs(max_collateral_inputs) {
        wasm.protocolparamupdate_set_max_collateral_inputs(this.__wbg_ptr, max_collateral_inputs);
    }
    /**
    * @returns {bigint | undefined}
    */
    max_collateral_inputs() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_max_collateral_inputs(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {PoolVotingThresholds} pool_voting_thresholds
    */
    set_pool_voting_thresholds(pool_voting_thresholds) {
        _assertClass(pool_voting_thresholds, PoolVotingThresholds);
        wasm.protocolparamupdate_set_pool_voting_thresholds(this.__wbg_ptr, pool_voting_thresholds.__wbg_ptr);
    }
    /**
    * @returns {PoolVotingThresholds | undefined}
    */
    pool_voting_thresholds() {
        const ret = wasm.protocolparamupdate_pool_voting_thresholds(this.__wbg_ptr);
        return ret === 0 ? undefined : PoolVotingThresholds.__wrap(ret);
    }
    /**
    * @param {DRepVotingThresholds} d_rep_voting_thresholds
    */
    set_d_rep_voting_thresholds(d_rep_voting_thresholds) {
        _assertClass(d_rep_voting_thresholds, DRepVotingThresholds);
        wasm.protocolparamupdate_set_d_rep_voting_thresholds(this.__wbg_ptr, d_rep_voting_thresholds.__wbg_ptr);
    }
    /**
    * @returns {DRepVotingThresholds | undefined}
    */
    d_rep_voting_thresholds() {
        const ret = wasm.protocolparamupdate_d_rep_voting_thresholds(this.__wbg_ptr);
        return ret === 0 ? undefined : DRepVotingThresholds.__wrap(ret);
    }
    /**
    * @param {bigint} min_committee_size
    */
    set_min_committee_size(min_committee_size) {
        wasm.protocolparamupdate_set_min_committee_size(this.__wbg_ptr, min_committee_size);
    }
    /**
    * @returns {bigint | undefined}
    */
    min_committee_size() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_min_committee_size(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} committee_term_limit
    */
    set_committee_term_limit(committee_term_limit) {
        wasm.protocolparamupdate_set_committee_term_limit(this.__wbg_ptr, committee_term_limit);
    }
    /**
    * @returns {bigint | undefined}
    */
    committee_term_limit() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_committee_term_limit(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} governance_action_validity_period
    */
    set_governance_action_validity_period(governance_action_validity_period) {
        wasm.protocolparamupdate_set_governance_action_validity_period(this.__wbg_ptr, governance_action_validity_period);
    }
    /**
    * @returns {bigint | undefined}
    */
    governance_action_validity_period() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_governance_action_validity_period(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} governance_action_deposit
    */
    set_governance_action_deposit(governance_action_deposit) {
        wasm.protocolparamupdate_set_governance_action_deposit(this.__wbg_ptr, governance_action_deposit);
    }
    /**
    * @returns {bigint | undefined}
    */
    governance_action_deposit() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_governance_action_deposit(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} d_rep_deposit
    */
    set_d_rep_deposit(d_rep_deposit) {
        wasm.protocolparamupdate_set_d_rep_deposit(this.__wbg_ptr, d_rep_deposit);
    }
    /**
    * @returns {bigint | undefined}
    */
    d_rep_deposit() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_d_rep_deposit(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} d_rep_inactivity_period
    */
    set_d_rep_inactivity_period(d_rep_inactivity_period) {
        wasm.protocolparamupdate_set_d_rep_inactivity_period(this.__wbg_ptr, d_rep_inactivity_period);
    }
    /**
    * @returns {bigint | undefined}
    */
    d_rep_inactivity_period() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolparamupdate_d_rep_inactivity_period(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Rational} min_fee_ref_script_cost_per_byte
    */
    set_min_fee_ref_script_cost_per_byte(min_fee_ref_script_cost_per_byte) {
        _assertClass(min_fee_ref_script_cost_per_byte, Rational);
        wasm.protocolparamupdate_set_min_fee_ref_script_cost_per_byte(this.__wbg_ptr, min_fee_ref_script_cost_per_byte.__wbg_ptr);
    }
    /**
    * @returns {Rational | undefined}
    */
    min_fee_ref_script_cost_per_byte() {
        const ret = wasm.protocolparamupdate_min_fee_ref_script_cost_per_byte(this.__wbg_ptr);
        return ret === 0 ? undefined : Rational.__wrap(ret);
    }
    /**
    * @returns {ProtocolParamUpdate}
    */
    static new() {
        const ret = wasm.protocolparamupdate_new();
        return ProtocolParamUpdate.__wrap(ret);
    }
}

const ProtocolVersionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_protocolversion_free(ptr >>> 0, 1));
/**
*/
class ProtocolVersion {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ProtocolVersion.prototype);
        obj.__wbg_ptr = ptr;
        ProtocolVersionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ProtocolVersionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_protocolversion_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolversion_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolversion_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ProtocolVersion}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.protocolversion_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ProtocolVersion.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolversion_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolversion_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ProtocolVersion}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.protocolversion_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ProtocolVersion.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolversion_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protocolversion_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ProtocolVersion}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.protocolversion_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ProtocolVersion.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint}
    */
    major() {
        const ret = wasm.protocolversion_major(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {bigint}
    */
    minor() {
        const ret = wasm.protocolversion_minor(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} major
    * @param {bigint} minor
    * @returns {ProtocolVersion}
    */
    static new(major, minor) {
        const ret = wasm.protocolversion_new(major, minor);
        return ProtocolVersion.__wrap(ret);
    }
}

const PublicKeyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_publickey_free(ptr >>> 0, 1));
/**
* ED25519 key used as public key
*/
class PublicKey {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PublicKey.prototype);
        obj.__wbg_ptr = ptr;
        PublicKeyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PublicKeyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_publickey_free(ptr, 0);
    }
    /**
    * Get public key from its bech32 representation
    * Example:
    * ```javascript
    * const pkey = PublicKey.from_bech32(&#39;ed25519_pk1dgaagyh470y66p899txcl3r0jaeaxu6yd7z2dxyk55qcycdml8gszkxze2&#39;);
    * ```
    * @param {string} bech32_str
    * @returns {PublicKey}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.publickey_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PublicKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_bech32() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.publickey_to_bech32(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.publickey_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {PublicKey}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.publickey_from_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return PublicKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} data
    * @param {Ed25519Signature} signature
    * @returns {boolean}
    */
    verify(data, signature) {
        const ptr0 = passArray8ToWasm0(data, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(signature, Ed25519Signature);
        const ret = wasm.publickey_verify(this.__wbg_ptr, ptr0, len0, signature.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @returns {Ed25519KeyHash}
    */
    hash() {
        const ret = wasm.publickey_hash(this.__wbg_ptr);
        return Ed25519KeyHash.__wrap(ret);
    }
}

const RationalFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_rational_free(ptr >>> 0, 1));
/**
*/
class Rational {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Rational.prototype);
        obj.__wbg_ptr = ptr;
        RationalFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RationalFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_rational_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.rational_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.rational_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Rational}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.rational_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Rational.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.rational_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.rational_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Rational}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.rational_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Rational.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.rational_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.rational_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Rational}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.rational_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Rational.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint}
    */
    numerator() {
        const ret = wasm.rational_numerator(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {bigint}
    */
    denominator() {
        const ret = wasm.rational_denominator(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} numerator
    * @param {bigint} denominator
    * @returns {Rational}
    */
    static new(numerator, denominator) {
        const ret = wasm.rational_new(numerator, denominator);
        return Rational.__wrap(ret);
    }
}

const RedeemerKeyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_redeemerkey_free(ptr >>> 0, 1));
/**
*/
class RedeemerKey {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RedeemerKey.prototype);
        obj.__wbg_ptr = ptr;
        RedeemerKeyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RedeemerKeyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_redeemerkey_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemerkey_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemerkey_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {RedeemerKey}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.redeemerkey_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RedeemerKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemerkey_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemerkey_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {RedeemerKey}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.redeemerkey_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RedeemerKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemerkey_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemerkey_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {RedeemerKey}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.redeemerkey_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RedeemerKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {RedeemerTag}
    */
    tag() {
        const ret = wasm.redeemerkey_tag(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {bigint}
    */
    index() {
        const ret = wasm.redeemerkey_index(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {RedeemerTag} tag
    * @param {bigint} index
    * @returns {RedeemerKey}
    */
    static new(tag, index) {
        const ret = wasm.redeemerkey_new(tag, index);
        return RedeemerKey.__wrap(ret);
    }
}

const RedeemerKeyListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_redeemerkeylist_free(ptr >>> 0, 1));
/**
*/
class RedeemerKeyList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RedeemerKeyList.prototype);
        obj.__wbg_ptr = ptr;
        RedeemerKeyListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RedeemerKeyListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_redeemerkeylist_free(ptr, 0);
    }
    /**
    * @returns {RedeemerKeyList}
    */
    static new() {
        const ret = wasm.redeemerkeylist_new();
        return RedeemerKeyList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.redeemerkeylist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {RedeemerKey}
    */
    get(index) {
        const ret = wasm.redeemerkeylist_get(this.__wbg_ptr, index);
        return RedeemerKey.__wrap(ret);
    }
    /**
    * @param {RedeemerKey} elem
    */
    add(elem) {
        _assertClass(elem, RedeemerKey);
        wasm.redeemerkeylist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const RedeemerSetBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_redeemersetbuilder_free(ptr >>> 0, 1));
/**
* In order to calculate the index from the sorted set, "add_*" methods in this builder
* must be called along with the "add_*" methods in transaction builder.
*/
class RedeemerSetBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RedeemerSetBuilder.prototype);
        obj.__wbg_ptr = ptr;
        RedeemerSetBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RedeemerSetBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_redeemersetbuilder_free(ptr, 0);
    }
    /**
    * @returns {RedeemerSetBuilder}
    */
    static new() {
        const ret = wasm.redeemersetbuilder_new();
        return RedeemerSetBuilder.__wrap(ret);
    }
    /**
    * @returns {boolean}
    */
    is_empty() {
        const ret = wasm.redeemersetbuilder_is_empty(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * note: will override existing value if called twice with the same key
    * @param {RedeemerWitnessKey} key
    * @param {ExUnits} ex_units
    */
    update_ex_units(key, ex_units) {
        _assertClass(key, RedeemerWitnessKey);
        _assertClass(ex_units, ExUnits);
        wasm.redeemersetbuilder_update_ex_units(this.__wbg_ptr, key.__wbg_ptr, ex_units.__wbg_ptr);
    }
    /**
    * @param {InputBuilderResult} result
    */
    add_spend(result) {
        _assertClass(result, InputBuilderResult);
        wasm.redeemersetbuilder_add_spend(this.__wbg_ptr, result.__wbg_ptr);
    }
    /**
    * @param {MintBuilderResult} result
    */
    add_mint(result) {
        _assertClass(result, MintBuilderResult);
        wasm.redeemersetbuilder_add_mint(this.__wbg_ptr, result.__wbg_ptr);
    }
    /**
    * @param {WithdrawalBuilderResult} result
    */
    add_reward(result) {
        _assertClass(result, WithdrawalBuilderResult);
        wasm.redeemersetbuilder_add_reward(this.__wbg_ptr, result.__wbg_ptr);
    }
    /**
    * @param {CertificateBuilderResult} result
    */
    add_cert(result) {
        _assertClass(result, CertificateBuilderResult);
        wasm.redeemersetbuilder_add_cert(this.__wbg_ptr, result.__wbg_ptr);
    }
    /**
    * @param {ProposalBuilderResult} result
    */
    add_proposal(result) {
        _assertClass(result, ProposalBuilderResult);
        wasm.redeemersetbuilder_add_proposal(this.__wbg_ptr, result.__wbg_ptr);
    }
    /**
    * @param {VoteBuilderResult} result
    */
    add_vote(result) {
        _assertClass(result, VoteBuilderResult);
        wasm.redeemersetbuilder_add_vote(this.__wbg_ptr, result.__wbg_ptr);
    }
    /**
    * @param {boolean} default_to_dummy_exunits
    * @returns {Redeemers}
    */
    build(default_to_dummy_exunits) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemersetbuilder_build(retptr, this.__wbg_ptr, default_to_dummy_exunits);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Redeemers.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const RedeemerValFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_redeemerval_free(ptr >>> 0, 1));
/**
*/
class RedeemerVal {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RedeemerVal.prototype);
        obj.__wbg_ptr = ptr;
        RedeemerValFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RedeemerValFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_redeemerval_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemerval_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemerval_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {RedeemerVal}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.redeemerval_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RedeemerVal.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemerval_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemerval_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {RedeemerVal}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.redeemerval_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RedeemerVal.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemerval_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemerval_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {RedeemerVal}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.redeemerval_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RedeemerVal.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {PlutusData}
    */
    data() {
        const ret = wasm.redeemerval_data(this.__wbg_ptr);
        return PlutusData.__wrap(ret);
    }
    /**
    * @returns {ExUnits}
    */
    ex_units() {
        const ret = wasm.redeemerval_ex_units(this.__wbg_ptr);
        return ExUnits.__wrap(ret);
    }
    /**
    * @param {PlutusData} data
    * @param {ExUnits} ex_units
    * @returns {RedeemerVal}
    */
    static new(data, ex_units) {
        _assertClass(data, PlutusData);
        _assertClass(ex_units, ExUnits);
        const ret = wasm.redeemerval_new(data.__wbg_ptr, ex_units.__wbg_ptr);
        return RedeemerVal.__wrap(ret);
    }
}

const RedeemerWitnessKeyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_redeemerwitnesskey_free(ptr >>> 0, 1));
/**
*/
class RedeemerWitnessKey {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RedeemerWitnessKey.prototype);
        obj.__wbg_ptr = ptr;
        RedeemerWitnessKeyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RedeemerWitnessKeyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_redeemerwitnesskey_free(ptr, 0);
    }
    /**
    * @param {RedeemerTag} tag
    * @param {bigint} index
    * @returns {RedeemerWitnessKey}
    */
    static new(tag, index) {
        const ret = wasm.redeemerwitnesskey_new(tag, index);
        return RedeemerWitnessKey.__wrap(ret);
    }
    /**
    * @param {LegacyRedeemer} redeemer
    * @returns {RedeemerWitnessKey}
    */
    static from_redeemer(redeemer) {
        _assertClass(redeemer, LegacyRedeemer);
        const ret = wasm.redeemerwitnesskey_from_redeemer(redeemer.__wbg_ptr);
        return RedeemerWitnessKey.__wrap(ret);
    }
}

const RedeemersFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_redeemers_free(ptr >>> 0, 1));
/**
*/
class Redeemers {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Redeemers.prototype);
        obj.__wbg_ptr = ptr;
        RedeemersFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RedeemersFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_redeemers_free(ptr, 0);
    }
    /**
    * @returns {LegacyRedeemerList}
    */
    to_flat_format() {
        const ret = wasm.redeemers_to_flat_format(this.__wbg_ptr);
        return LegacyRedeemerList.__wrap(ret);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemers_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemers_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Redeemers}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.redeemers_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Redeemers.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemers_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemers_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Redeemers}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.redeemers_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Redeemers.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemers_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.redeemers_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Redeemers}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.redeemers_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Redeemers.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {LegacyRedeemerList} arr_legacy_redeemer
    * @returns {Redeemers}
    */
    static new_arr_legacy_redeemer(arr_legacy_redeemer) {
        _assertClass(arr_legacy_redeemer, LegacyRedeemerList);
        const ret = wasm.redeemers_new_arr_legacy_redeemer(arr_legacy_redeemer.__wbg_ptr);
        return Redeemers.__wrap(ret);
    }
    /**
    * @param {MapRedeemerKeyToRedeemerVal} map_redeemer_key_to_redeemer_val
    * @returns {Redeemers}
    */
    static new_map_redeemer_key_to_redeemer_val(map_redeemer_key_to_redeemer_val) {
        _assertClass(map_redeemer_key_to_redeemer_val, MapRedeemerKeyToRedeemerVal);
        const ret = wasm.redeemers_new_map_redeemer_key_to_redeemer_val(map_redeemer_key_to_redeemer_val.__wbg_ptr);
        return Redeemers.__wrap(ret);
    }
    /**
    * @returns {RedeemersKind}
    */
    kind() {
        const ret = wasm.redeemers_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {LegacyRedeemerList | undefined}
    */
    as_arr_legacy_redeemer() {
        const ret = wasm.redeemers_as_arr_legacy_redeemer(this.__wbg_ptr);
        return ret === 0 ? undefined : LegacyRedeemerList.__wrap(ret);
    }
    /**
    * @returns {MapRedeemerKeyToRedeemerVal | undefined}
    */
    as_map_redeemer_key_to_redeemer_val() {
        const ret = wasm.redeemers_as_map_redeemer_key_to_redeemer_val(this.__wbg_ptr);
        return ret === 0 ? undefined : MapRedeemerKeyToRedeemerVal.__wrap(ret);
    }
}

const RegCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_regcert_free(ptr >>> 0, 1));
/**
*/
class RegCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RegCert.prototype);
        obj.__wbg_ptr = ptr;
        RegCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RegCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_regcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.regcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.regcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {RegCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.regcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.regcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.regcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {RegCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.regcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.regcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.regcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {RegCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.regcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    stake_credential() {
        const ret = wasm.regcert_stake_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    deposit() {
        const ret = wasm.regcert_deposit(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {Credential} stake_credential
    * @param {bigint} deposit
    * @returns {RegCert}
    */
    static new(stake_credential, deposit) {
        _assertClass(stake_credential, Credential);
        const ret = wasm.regcert_new(stake_credential.__wbg_ptr, deposit);
        return RegCert.__wrap(ret);
    }
}

const RegDrepCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_regdrepcert_free(ptr >>> 0, 1));
/**
*/
class RegDrepCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RegDrepCert.prototype);
        obj.__wbg_ptr = ptr;
        RegDrepCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RegDrepCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_regdrepcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.regdrepcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.regdrepcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {RegDrepCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.regdrepcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RegDrepCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.regdrepcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.regdrepcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {RegDrepCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.regdrepcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RegDrepCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.regdrepcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.regdrepcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {RegDrepCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.regdrepcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RegDrepCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    drep_credential() {
        const ret = wasm.regdrepcert_drep_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    deposit() {
        const ret = wasm.regdrepcert_deposit(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {Anchor | undefined}
    */
    anchor() {
        const ret = wasm.regdrepcert_anchor(this.__wbg_ptr);
        return ret === 0 ? undefined : Anchor.__wrap(ret);
    }
    /**
    * @param {Credential} drep_credential
    * @param {bigint} deposit
    * @param {Anchor | undefined} [anchor]
    * @returns {RegDrepCert}
    */
    static new(drep_credential, deposit, anchor) {
        _assertClass(drep_credential, Credential);
        let ptr0 = 0;
        if (!isLikeNone(anchor)) {
            _assertClass(anchor, Anchor);
            ptr0 = anchor.__destroy_into_raw();
        }
        const ret = wasm.regdrepcert_new(drep_credential.__wbg_ptr, deposit, ptr0);
        return RegDrepCert.__wrap(ret);
    }
}

const RelayFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_relay_free(ptr >>> 0, 1));
/**
*/
class Relay {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Relay.prototype);
        obj.__wbg_ptr = ptr;
        RelayFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RelayFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_relay_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.relay_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.relay_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Relay}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.relay_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Relay.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.relay_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.relay_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Relay}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.relay_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Relay.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.relay_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.relay_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Relay}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.relay_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Relay.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {number | undefined} [port]
    * @param {Ipv4 | undefined} [ipv4]
    * @param {Ipv6 | undefined} [ipv6]
    * @returns {Relay}
    */
    static new_single_host_addr(port, ipv4, ipv6) {
        let ptr0 = 0;
        if (!isLikeNone(ipv4)) {
            _assertClass(ipv4, Ipv4);
            ptr0 = ipv4.__destroy_into_raw();
        }
        let ptr1 = 0;
        if (!isLikeNone(ipv6)) {
            _assertClass(ipv6, Ipv6);
            ptr1 = ipv6.__destroy_into_raw();
        }
        const ret = wasm.relay_new_single_host_addr(isLikeNone(port) ? 0xFFFFFF : port, ptr0, ptr1);
        return Relay.__wrap(ret);
    }
    /**
    * @param {number | undefined} port
    * @param {DNSName} dns_name
    * @returns {Relay}
    */
    static new_single_host_name(port, dns_name) {
        _assertClass(dns_name, DNSName);
        const ret = wasm.relay_new_single_host_name(isLikeNone(port) ? 0xFFFFFF : port, dns_name.__wbg_ptr);
        return Relay.__wrap(ret);
    }
    /**
    * @param {DNSName} dns_name
    * @returns {Relay}
    */
    static new_multi_host_name(dns_name) {
        _assertClass(dns_name, DNSName);
        const ret = wasm.relay_new_multi_host_name(dns_name.__wbg_ptr);
        return Relay.__wrap(ret);
    }
    /**
    * @returns {RelayKind}
    */
    kind() {
        const ret = wasm.relay_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {SingleHostAddr | undefined}
    */
    as_single_host_addr() {
        const ret = wasm.relay_as_single_host_addr(this.__wbg_ptr);
        return ret === 0 ? undefined : SingleHostAddr.__wrap(ret);
    }
    /**
    * @returns {SingleHostName | undefined}
    */
    as_single_host_name() {
        const ret = wasm.relay_as_single_host_name(this.__wbg_ptr);
        return ret === 0 ? undefined : SingleHostName.__wrap(ret);
    }
    /**
    * @returns {MultiHostName | undefined}
    */
    as_multi_host_name() {
        const ret = wasm.relay_as_multi_host_name(this.__wbg_ptr);
        return ret === 0 ? undefined : MultiHostName.__wrap(ret);
    }
}

const RelayListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_relaylist_free(ptr >>> 0, 1));
/**
*/
class RelayList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RelayList.prototype);
        obj.__wbg_ptr = ptr;
        RelayListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RelayListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_relaylist_free(ptr, 0);
    }
    /**
    * @returns {RelayList}
    */
    static new() {
        const ret = wasm.relaylist_new();
        return RelayList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.relaylist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {Relay}
    */
    get(index) {
        const ret = wasm.relaylist_get(this.__wbg_ptr, index);
        return Relay.__wrap(ret);
    }
    /**
    * @param {Relay} elem
    */
    add(elem) {
        _assertClass(elem, Relay);
        wasm.relaylist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const RequiredWitnessSetFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_requiredwitnessset_free(ptr >>> 0, 1));
/**
*/
class RequiredWitnessSet {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RequiredWitnessSet.prototype);
        obj.__wbg_ptr = ptr;
        RequiredWitnessSetFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RequiredWitnessSetFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_requiredwitnessset_free(ptr, 0);
    }
    /**
    * @param {Ed25519KeyHash} hash
    */
    add_vkey_key_hash(hash) {
        _assertClass(hash, Ed25519KeyHash);
        wasm.requiredwitnessset_add_vkey_key_hash(this.__wbg_ptr, hash.__wbg_ptr);
    }
    /**
    * @param {ByronAddress} address
    */
    add_bootstrap(address) {
        _assertClass(address, ByronAddress);
        wasm.requiredwitnessset_add_bootstrap(this.__wbg_ptr, address.__wbg_ptr);
    }
    /**
    * @param {ScriptHash} script_hash
    */
    add_script_ref(script_hash) {
        _assertClass(script_hash, ScriptHash);
        wasm.requiredwitnessset_add_script_ref(this.__wbg_ptr, script_hash.__wbg_ptr);
    }
    /**
    * @param {ScriptHash} script_hash
    */
    add_script_hash(script_hash) {
        _assertClass(script_hash, ScriptHash);
        wasm.requiredwitnessset_add_script_hash(this.__wbg_ptr, script_hash.__wbg_ptr);
    }
    /**
    * @param {DatumHash} plutus_datum
    */
    add_plutus_datum_hash(plutus_datum) {
        _assertClass(plutus_datum, DatumHash);
        wasm.requiredwitnessset_add_plutus_datum_hash(this.__wbg_ptr, plutus_datum.__wbg_ptr);
    }
    /**
    * @param {RedeemerWitnessKey} redeemer
    */
    add_redeemer_tag(redeemer) {
        _assertClass(redeemer, RedeemerWitnessKey);
        wasm.requiredwitnessset_add_redeemer_tag(this.__wbg_ptr, redeemer.__wbg_ptr);
    }
    /**
    * @param {RequiredWitnessSet} requirements
    */
    add_all(requirements) {
        _assertClass(requirements, RequiredWitnessSet);
        wasm.requiredwitnessset_add_all(this.__wbg_ptr, requirements.__wbg_ptr);
    }
    /**
    * @returns {RequiredWitnessSet}
    */
    static new() {
        const ret = wasm.requiredwitnessset_new();
        return RequiredWitnessSet.__wrap(ret);
    }
    /**
    * @param {RewardAddress} address
    */
    withdrawal_required_wits(address) {
        _assertClass(address, RewardAddress);
        wasm.requiredwitnessset_withdrawal_required_wits(this.__wbg_ptr, address.__wbg_ptr);
    }
}

const ResignCommitteeColdCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_resigncommitteecoldcert_free(ptr >>> 0, 1));
/**
*/
class ResignCommitteeColdCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ResignCommitteeColdCert.prototype);
        obj.__wbg_ptr = ptr;
        ResignCommitteeColdCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ResignCommitteeColdCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_resigncommitteecoldcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.resigncommitteecoldcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.resigncommitteecoldcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ResignCommitteeColdCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.resigncommitteecoldcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ResignCommitteeColdCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.resigncommitteecoldcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.resigncommitteecoldcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ResignCommitteeColdCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.resigncommitteecoldcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ResignCommitteeColdCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.resigncommitteecoldcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.resigncommitteecoldcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ResignCommitteeColdCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.resigncommitteecoldcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ResignCommitteeColdCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    committee_cold_credential() {
        const ret = wasm.resigncommitteecoldcert_committee_cold_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {Anchor | undefined}
    */
    anchor() {
        const ret = wasm.resigncommitteecoldcert_anchor(this.__wbg_ptr);
        return ret === 0 ? undefined : Anchor.__wrap(ret);
    }
    /**
    * @param {Credential} committee_cold_credential
    * @param {Anchor | undefined} [anchor]
    * @returns {ResignCommitteeColdCert}
    */
    static new(committee_cold_credential, anchor) {
        _assertClass(committee_cold_credential, Credential);
        let ptr0 = 0;
        if (!isLikeNone(anchor)) {
            _assertClass(anchor, Anchor);
            ptr0 = anchor.__destroy_into_raw();
        }
        const ret = wasm.resigncommitteecoldcert_new(committee_cold_credential.__wbg_ptr, ptr0);
        return ResignCommitteeColdCert.__wrap(ret);
    }
}

const RewardAccountListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_rewardaccountlist_free(ptr >>> 0, 1));
/**
*/
class RewardAccountList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RewardAccountList.prototype);
        obj.__wbg_ptr = ptr;
        RewardAccountListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RewardAccountListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_rewardaccountlist_free(ptr, 0);
    }
    /**
    * @returns {RewardAccountList}
    */
    static new() {
        const ret = wasm.rewardaccountlist_new();
        return RewardAccountList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.rewardaccountlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {RewardAddress}
    */
    get(index) {
        const ret = wasm.rewardaccountlist_get(this.__wbg_ptr, index);
        return RewardAddress.__wrap(ret);
    }
    /**
    * @param {RewardAddress} elem
    */
    add(elem) {
        _assertClass(elem, RewardAddress);
        wasm.rewardaccountlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const RewardAddressFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_rewardaddress_free(ptr >>> 0, 1));
/**
*/
class RewardAddress {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RewardAddress.prototype);
        obj.__wbg_ptr = ptr;
        RewardAddressFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RewardAddressFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_rewardaddress_free(ptr, 0);
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.rewardaddress_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.rewardaddress_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {RewardAddress}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.rewardaddress_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return RewardAddress.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {number} network
    * @param {Credential} payment
    * @returns {RewardAddress}
    */
    static new(network, payment) {
        _assertClass(payment, Credential);
        const ret = wasm.rewardaddress_new(network, payment.__wbg_ptr);
        return RewardAddress.__wrap(ret);
    }
    /**
    * @returns {Address}
    */
    to_address() {
        const ret = wasm.rewardaddress_to_address(this.__wbg_ptr);
        return Address.__wrap(ret);
    }
    /**
    * @param {Address} address
    * @returns {RewardAddress | undefined}
    */
    static from_address(address) {
        _assertClass(address, Address);
        const ret = wasm.rewardaddress_from_address(address.__wbg_ptr);
        return ret === 0 ? undefined : RewardAddress.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    network_id() {
        const ret = wasm.rewardaddress_network_id(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Credential}
    */
    payment() {
        const ret = wasm.rewardaddress_payment(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
}

const ScriptFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_script_free(ptr >>> 0, 1));
/**
*/
class Script {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Script.prototype);
        obj.__wbg_ptr = ptr;
        ScriptFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ScriptFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_script_free(ptr, 0);
    }
    /**
    * @returns {ScriptHash}
    */
    hash() {
        const ret = wasm.script_hash(this.__wbg_ptr);
        return ScriptHash.__wrap(ret);
    }
    /**
    * @returns {Language | undefined}
    */
    language() {
        const ret = wasm.script_language(this.__wbg_ptr);
        return ret === 3 ? undefined : ret;
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.script_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.script_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Script}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.script_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.script_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.script_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Script}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.script_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.script_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.script_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Script}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.script_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Script.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {NativeScript} script
    * @returns {Script}
    */
    static new_native(script) {
        _assertClass(script, NativeScript);
        const ret = wasm.script_new_native(script.__wbg_ptr);
        return Script.__wrap(ret);
    }
    /**
    * @param {PlutusV1Script} script
    * @returns {Script}
    */
    static new_plutus_v1(script) {
        _assertClass(script, PlutusV1Script);
        const ret = wasm.script_new_plutus_v1(script.__wbg_ptr);
        return Script.__wrap(ret);
    }
    /**
    * @param {PlutusV2Script} script
    * @returns {Script}
    */
    static new_plutus_v2(script) {
        _assertClass(script, PlutusV2Script);
        const ret = wasm.script_new_plutus_v2(script.__wbg_ptr);
        return Script.__wrap(ret);
    }
    /**
    * @param {PlutusV3Script} script
    * @returns {Script}
    */
    static new_plutus_v3(script) {
        _assertClass(script, PlutusV3Script);
        const ret = wasm.script_new_plutus_v3(script.__wbg_ptr);
        return Script.__wrap(ret);
    }
    /**
    * @returns {ScriptKind}
    */
    kind() {
        const ret = wasm.script_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {NativeScript | undefined}
    */
    as_native() {
        const ret = wasm.script_as_native(this.__wbg_ptr);
        return ret === 0 ? undefined : NativeScript.__wrap(ret);
    }
    /**
    * @returns {PlutusV1Script | undefined}
    */
    as_plutus_v1() {
        const ret = wasm.script_as_plutus_v1(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV1Script.__wrap(ret);
    }
    /**
    * @returns {PlutusV2Script | undefined}
    */
    as_plutus_v2() {
        const ret = wasm.script_as_plutus_v2(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV2Script.__wrap(ret);
    }
    /**
    * @returns {PlutusV3Script | undefined}
    */
    as_plutus_v3() {
        const ret = wasm.script_as_plutus_v3(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV3Script.__wrap(ret);
    }
}

const ScriptAllFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_scriptall_free(ptr >>> 0, 1));
/**
*/
class ScriptAll {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ScriptAll.prototype);
        obj.__wbg_ptr = ptr;
        ScriptAllFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ScriptAllFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_scriptall_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptall_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptall_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ScriptAll}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptall_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptAll.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptall_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptall_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ScriptAll}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptall_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptAll.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptall_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptall_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ScriptAll}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptall_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptAll.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {NativeScriptList}
    */
    native_scripts() {
        const ret = wasm.scriptall_native_scripts(this.__wbg_ptr);
        return NativeScriptList.__wrap(ret);
    }
    /**
    * @param {NativeScriptList} native_scripts
    * @returns {ScriptAll}
    */
    static new(native_scripts) {
        _assertClass(native_scripts, NativeScriptList);
        const ret = wasm.scriptall_new(native_scripts.__wbg_ptr);
        return ScriptAll.__wrap(ret);
    }
}

const ScriptAnyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_scriptany_free(ptr >>> 0, 1));
/**
*/
class ScriptAny {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ScriptAny.prototype);
        obj.__wbg_ptr = ptr;
        ScriptAnyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ScriptAnyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_scriptany_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptany_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptany_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ScriptAny}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptany_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptAny.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptany_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptany_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ScriptAny}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptany_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptAny.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptany_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptany_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ScriptAny}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptany_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptAny.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {NativeScriptList}
    */
    native_scripts() {
        const ret = wasm.scriptany_native_scripts(this.__wbg_ptr);
        return NativeScriptList.__wrap(ret);
    }
    /**
    * @param {NativeScriptList} native_scripts
    * @returns {ScriptAny}
    */
    static new(native_scripts) {
        _assertClass(native_scripts, NativeScriptList);
        const ret = wasm.scriptany_new(native_scripts.__wbg_ptr);
        return ScriptAny.__wrap(ret);
    }
}

const ScriptDataHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_scriptdatahash_free(ptr >>> 0, 1));
/**
*/
class ScriptDataHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ScriptDataHash.prototype);
        obj.__wbg_ptr = ptr;
        ScriptDataHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ScriptDataHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_scriptdatahash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptdatahash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {ScriptDataHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptdatahash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptDataHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptdatahash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {ScriptDataHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptdatahash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptDataHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptdatahash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {ScriptDataHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptdatahash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptDataHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const ScriptHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_scripthash_free(ptr >>> 0, 1));
/**
*/
class ScriptHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ScriptHash.prototype);
        obj.__wbg_ptr = ptr;
        ScriptHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ScriptHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_scripthash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scripthash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {ScriptHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scripthash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scripthash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {ScriptHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scripthash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scripthash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {ScriptHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scripthash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const ScriptInvalidBeforeFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_scriptinvalidbefore_free(ptr >>> 0, 1));
/**
*/
class ScriptInvalidBefore {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ScriptInvalidBefore.prototype);
        obj.__wbg_ptr = ptr;
        ScriptInvalidBeforeFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ScriptInvalidBeforeFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_scriptinvalidbefore_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptinvalidbefore_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptinvalidbefore_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ScriptInvalidBefore}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptinvalidbefore_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptInvalidBefore.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptinvalidbefore_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptinvalidbefore_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ScriptInvalidBefore}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptinvalidbefore_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptInvalidBefore.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptinvalidbefore_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptinvalidbefore_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ScriptInvalidBefore}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptinvalidbefore_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptInvalidBefore.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint}
    */
    before() {
        const ret = wasm.scriptinvalidbefore_before(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} before
    * @returns {ScriptInvalidBefore}
    */
    static new(before) {
        const ret = wasm.scriptinvalidbefore_new(before);
        return ScriptInvalidBefore.__wrap(ret);
    }
}

const ScriptInvalidHereafterFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_scriptinvalidhereafter_free(ptr >>> 0, 1));
/**
*/
class ScriptInvalidHereafter {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ScriptInvalidHereafter.prototype);
        obj.__wbg_ptr = ptr;
        ScriptInvalidHereafterFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ScriptInvalidHereafterFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_scriptinvalidhereafter_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptinvalidhereafter_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptinvalidhereafter_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ScriptInvalidHereafter}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptinvalidhereafter_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptInvalidHereafter.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptinvalidhereafter_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptinvalidhereafter_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ScriptInvalidHereafter}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptinvalidhereafter_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptInvalidHereafter.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptinvalidhereafter_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptinvalidhereafter_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ScriptInvalidHereafter}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptinvalidhereafter_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptInvalidHereafter.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint}
    */
    after() {
        const ret = wasm.scriptinvalidhereafter_after(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} after
    * @returns {ScriptInvalidHereafter}
    */
    static new(after) {
        const ret = wasm.scriptinvalidhereafter_new(after);
        return ScriptInvalidHereafter.__wrap(ret);
    }
}

const ScriptNOfKFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_scriptnofk_free(ptr >>> 0, 1));
/**
*/
class ScriptNOfK {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ScriptNOfK.prototype);
        obj.__wbg_ptr = ptr;
        ScriptNOfKFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ScriptNOfKFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_scriptnofk_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptnofk_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptnofk_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ScriptNOfK}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptnofk_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptNOfK.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptnofk_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptnofk_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ScriptNOfK}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptnofk_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptNOfK.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptnofk_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptnofk_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ScriptNOfK}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptnofk_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptNOfK.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint}
    */
    n() {
        const ret = wasm.scriptnofk_n(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {NativeScriptList}
    */
    native_scripts() {
        const ret = wasm.scriptnofk_native_scripts(this.__wbg_ptr);
        return NativeScriptList.__wrap(ret);
    }
    /**
    * @param {bigint} n
    * @param {NativeScriptList} native_scripts
    * @returns {ScriptNOfK}
    */
    static new(n, native_scripts) {
        _assertClass(native_scripts, NativeScriptList);
        const ret = wasm.scriptnofk_new(n, native_scripts.__wbg_ptr);
        return ScriptNOfK.__wrap(ret);
    }
}

const ScriptPubkeyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_scriptpubkey_free(ptr >>> 0, 1));
/**
*/
class ScriptPubkey {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ScriptPubkey.prototype);
        obj.__wbg_ptr = ptr;
        ScriptPubkeyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ScriptPubkeyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_scriptpubkey_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptpubkey_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptpubkey_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ScriptPubkey}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptpubkey_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptPubkey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptpubkey_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptpubkey_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ScriptPubkey}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptpubkey_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptPubkey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptpubkey_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.scriptpubkey_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ScriptPubkey}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.scriptpubkey_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ScriptPubkey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Ed25519KeyHash}
    */
    ed25519_key_hash() {
        const ret = wasm.scriptpubkey_ed25519_key_hash(this.__wbg_ptr);
        return Ed25519KeyHash.__wrap(ret);
    }
    /**
    * @param {Ed25519KeyHash} ed25519_key_hash
    * @returns {ScriptPubkey}
    */
    static new(ed25519_key_hash) {
        _assertClass(ed25519_key_hash, Ed25519KeyHash);
        const ret = wasm.scriptpubkey_new(ed25519_key_hash.__wbg_ptr);
        return ScriptPubkey.__wrap(ret);
    }
}

const ShelleyMAFormatAuxDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_shelleymaformatauxdata_free(ptr >>> 0, 1));
/**
*/
class ShelleyMAFormatAuxData {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ShelleyMAFormatAuxData.prototype);
        obj.__wbg_ptr = ptr;
        ShelleyMAFormatAuxDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ShelleyMAFormatAuxDataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_shelleymaformatauxdata_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.shelleymaformatauxdata_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.shelleymaformatauxdata_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {ShelleyMAFormatAuxData}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.shelleymaformatauxdata_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ShelleyMAFormatAuxData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.shelleymaformatauxdata_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.shelleymaformatauxdata_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {ShelleyMAFormatAuxData}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.shelleymaformatauxdata_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ShelleyMAFormatAuxData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.shelleymaformatauxdata_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.shelleymaformatauxdata_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {ShelleyMAFormatAuxData}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.shelleymaformatauxdata_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return ShelleyMAFormatAuxData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Metadata}
    */
    transaction_metadata() {
        const ret = wasm.shelleymaformatauxdata_transaction_metadata(this.__wbg_ptr);
        return Metadata.__wrap(ret);
    }
    /**
    * @returns {NativeScriptList}
    */
    auxiliary_scripts() {
        const ret = wasm.shelleymaformatauxdata_auxiliary_scripts(this.__wbg_ptr);
        return NativeScriptList.__wrap(ret);
    }
    /**
    * @param {Metadata} transaction_metadata
    * @param {NativeScriptList} auxiliary_scripts
    * @returns {ShelleyMAFormatAuxData}
    */
    static new(transaction_metadata, auxiliary_scripts) {
        _assertClass(transaction_metadata, Metadata);
        _assertClass(auxiliary_scripts, NativeScriptList);
        const ret = wasm.shelleymaformatauxdata_new(transaction_metadata.__wbg_ptr, auxiliary_scripts.__wbg_ptr);
        return ShelleyMAFormatAuxData.__wrap(ret);
    }
}

const SignedTxBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_signedtxbuilder_free(ptr >>> 0, 1));
/**
*/
class SignedTxBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SignedTxBuilder.prototype);
        obj.__wbg_ptr = ptr;
        SignedTxBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SignedTxBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_signedtxbuilder_free(ptr, 0);
    }
    /**
    * @param {TransactionBody} body
    * @param {TransactionWitnessSetBuilder} witness_set
    * @param {boolean} is_valid
    * @param {AuxiliaryData} auxiliary_data
    * @returns {SignedTxBuilder}
    */
    static new_with_data(body, witness_set, is_valid, auxiliary_data) {
        _assertClass(body, TransactionBody);
        _assertClass(witness_set, TransactionWitnessSetBuilder);
        _assertClass(auxiliary_data, AuxiliaryData);
        const ret = wasm.signedtxbuilder_new_with_data(body.__wbg_ptr, witness_set.__wbg_ptr, is_valid, auxiliary_data.__wbg_ptr);
        return SignedTxBuilder.__wrap(ret);
    }
    /**
    * @param {TransactionBody} body
    * @param {TransactionWitnessSetBuilder} witness_set
    * @param {boolean} is_valid
    * @returns {SignedTxBuilder}
    */
    static new_without_data(body, witness_set, is_valid) {
        _assertClass(body, TransactionBody);
        _assertClass(witness_set, TransactionWitnessSetBuilder);
        const ret = wasm.signedtxbuilder_new_without_data(body.__wbg_ptr, witness_set.__wbg_ptr, is_valid);
        return SignedTxBuilder.__wrap(ret);
    }
    /**
    *
    *     * Builds the final transaction and checks that all witnesses are there
    *
    * @returns {Transaction}
    */
    build_checked() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.signedtxbuilder_build_checked(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Transaction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *     * Builds the transaction without doing any witness checks.
    *     *
    *     * This can be useful if other witnesses will be added later.
    *     * e.g. CIP30 signing takes a Transaction with possible witnesses
    *     * to send to the wallet to fill in the missing ones.
    *
    * @returns {Transaction}
    */
    build_unchecked() {
        const ret = wasm.signedtxbuilder_build_unchecked(this.__wbg_ptr);
        return Transaction.__wrap(ret);
    }
    /**
    * @param {Vkeywitness} vkey
    */
    add_vkey(vkey) {
        _assertClass(vkey, Vkeywitness);
        wasm.signedtxbuilder_add_vkey(this.__wbg_ptr, vkey.__wbg_ptr);
    }
    /**
    * @param {BootstrapWitness} bootstrap
    */
    add_bootstrap(bootstrap) {
        _assertClass(bootstrap, BootstrapWitness);
        wasm.signedtxbuilder_add_bootstrap(this.__wbg_ptr, bootstrap.__wbg_ptr);
    }
    /**
    * @returns {TransactionBody}
    */
    body() {
        const ret = wasm.signedtxbuilder_body(this.__wbg_ptr);
        return TransactionBody.__wrap(ret);
    }
    /**
    * @returns {TransactionWitnessSetBuilder}
    */
    witness_set() {
        const ret = wasm.signedtxbuilder_witness_set(this.__wbg_ptr);
        return TransactionWitnessSetBuilder.__wrap(ret);
    }
    /**
    * @returns {boolean}
    */
    is_valid() {
        const ret = wasm.signedtxbuilder_is_valid(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @returns {AuxiliaryData | undefined}
    */
    auxiliary_data() {
        const ret = wasm.signedtxbuilder_auxiliary_data(this.__wbg_ptr);
        return ret === 0 ? undefined : AuxiliaryData.__wrap(ret);
    }
}

const SingleCertificateBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_singlecertificatebuilder_free(ptr >>> 0, 1));
/**
*/
class SingleCertificateBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SingleCertificateBuilder.prototype);
        obj.__wbg_ptr = ptr;
        SingleCertificateBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SingleCertificateBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_singlecertificatebuilder_free(ptr, 0);
    }
    /**
    * @param {Certificate} cert
    * @returns {SingleCertificateBuilder}
    */
    static new(cert) {
        _assertClass(cert, Certificate);
        const ret = wasm.singlecertificatebuilder_new(cert.__wbg_ptr);
        return SingleCertificateBuilder.__wrap(ret);
    }
    /**
    * note: particularly useful for StakeRegistration which doesn't require witnessing
    * @returns {CertificateBuilderResult}
    */
    skip_witness() {
        const ret = wasm.singlecertificatebuilder_skip_witness(this.__wbg_ptr);
        return CertificateBuilderResult.__wrap(ret);
    }
    /**
    * @returns {CertificateBuilderResult}
    */
    payment_key() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlecertificatebuilder_payment_key(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CertificateBuilderResult.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Signer keys don't have to be set. You can leave it empty and then add the required witnesses later
    * @param {NativeScript} native_script
    * @param {NativeScriptWitnessInfo} witness_info
    * @returns {CertificateBuilderResult}
    */
    native_script(native_script, witness_info) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(native_script, NativeScript);
            _assertClass(witness_info, NativeScriptWitnessInfo);
            wasm.singlecertificatebuilder_native_script(retptr, this.__wbg_ptr, native_script.__wbg_ptr, witness_info.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CertificateBuilderResult.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {PartialPlutusWitness} partial_witness
    * @param {Ed25519KeyHashList} required_signers
    * @returns {CertificateBuilderResult}
    */
    plutus_script(partial_witness, required_signers) {
        try {
            const ptr = this.__destroy_into_raw();
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(partial_witness, PartialPlutusWitness);
            _assertClass(required_signers, Ed25519KeyHashList);
            wasm.singlecertificatebuilder_plutus_script(retptr, ptr, partial_witness.__wbg_ptr, required_signers.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return CertificateBuilderResult.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const SingleHostAddrFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_singlehostaddr_free(ptr >>> 0, 1));
/**
*/
class SingleHostAddr {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SingleHostAddr.prototype);
        obj.__wbg_ptr = ptr;
        SingleHostAddrFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SingleHostAddrFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_singlehostaddr_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlehostaddr_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlehostaddr_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {SingleHostAddr}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.singlehostaddr_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SingleHostAddr.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlehostaddr_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlehostaddr_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {SingleHostAddr}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.singlehostaddr_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SingleHostAddr.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlehostaddr_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlehostaddr_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {SingleHostAddr}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.singlehostaddr_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SingleHostAddr.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {number | undefined}
    */
    port() {
        const ret = wasm.singlehostaddr_port(this.__wbg_ptr);
        return ret === 0xFFFFFF ? undefined : ret;
    }
    /**
    * @returns {Ipv4 | undefined}
    */
    ipv4() {
        const ret = wasm.singlehostaddr_ipv4(this.__wbg_ptr);
        return ret === 0 ? undefined : Ipv4.__wrap(ret);
    }
    /**
    * @returns {Ipv6 | undefined}
    */
    ipv6() {
        const ret = wasm.singlehostaddr_ipv6(this.__wbg_ptr);
        return ret === 0 ? undefined : Ipv6.__wrap(ret);
    }
    /**
    * @param {number | undefined} [port]
    * @param {Ipv4 | undefined} [ipv4]
    * @param {Ipv6 | undefined} [ipv6]
    * @returns {SingleHostAddr}
    */
    static new(port, ipv4, ipv6) {
        let ptr0 = 0;
        if (!isLikeNone(ipv4)) {
            _assertClass(ipv4, Ipv4);
            ptr0 = ipv4.__destroy_into_raw();
        }
        let ptr1 = 0;
        if (!isLikeNone(ipv6)) {
            _assertClass(ipv6, Ipv6);
            ptr1 = ipv6.__destroy_into_raw();
        }
        const ret = wasm.singlehostaddr_new(isLikeNone(port) ? 0xFFFFFF : port, ptr0, ptr1);
        return SingleHostAddr.__wrap(ret);
    }
}

const SingleHostNameFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_singlehostname_free(ptr >>> 0, 1));
/**
*/
class SingleHostName {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SingleHostName.prototype);
        obj.__wbg_ptr = ptr;
        SingleHostNameFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SingleHostNameFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_singlehostname_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlehostname_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlehostname_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {SingleHostName}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.singlehostname_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SingleHostName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlehostname_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlehostname_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {SingleHostName}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.singlehostname_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SingleHostName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlehostname_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlehostname_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {SingleHostName}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.singlehostname_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SingleHostName.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {number | undefined}
    */
    port() {
        const ret = wasm.singlehostname_port(this.__wbg_ptr);
        return ret === 0xFFFFFF ? undefined : ret;
    }
    /**
    * @returns {DNSName}
    */
    dns_name() {
        const ret = wasm.singlehostname_dns_name(this.__wbg_ptr);
        return DNSName.__wrap(ret);
    }
    /**
    * * `dns_name` - An A or AAAA DNS record
    * @param {number | undefined} port
    * @param {DNSName} dns_name
    * @returns {SingleHostName}
    */
    static new(port, dns_name) {
        _assertClass(dns_name, DNSName);
        const ret = wasm.singlehostname_new(isLikeNone(port) ? 0xFFFFFF : port, dns_name.__wbg_ptr);
        return SingleHostName.__wrap(ret);
    }
}

const SingleInputBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_singleinputbuilder_free(ptr >>> 0, 1));
/**
*/
class SingleInputBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SingleInputBuilder.prototype);
        obj.__wbg_ptr = ptr;
        SingleInputBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SingleInputBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_singleinputbuilder_free(ptr, 0);
    }
    /**
    * @param {TransactionInput} input
    * @param {TransactionOutput} utxo_info
    * @returns {SingleInputBuilder}
    */
    static new(input, utxo_info) {
        _assertClass(input, TransactionInput);
        _assertClass(utxo_info, TransactionOutput);
        const ret = wasm.singleinputbuilder_new(input.__wbg_ptr, utxo_info.__wbg_ptr);
        return SingleInputBuilder.__wrap(ret);
    }
    /**
    * @param {TransactionUnspentOutput} utxo
    * @returns {SingleInputBuilder}
    */
    static from_transaction_unspent_output(utxo) {
        _assertClass(utxo, TransactionUnspentOutput);
        const ret = wasm.singleinputbuilder_from_transaction_unspent_output(utxo.__wbg_ptr);
        return SingleInputBuilder.__wrap(ret);
    }
    /**
    * @returns {InputBuilderResult}
    */
    payment_key() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singleinputbuilder_payment_key(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return InputBuilderResult.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {NativeScript} native_script
    * @param {NativeScriptWitnessInfo} witness_info
    * @returns {InputBuilderResult}
    */
    native_script(native_script, witness_info) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(native_script, NativeScript);
            _assertClass(witness_info, NativeScriptWitnessInfo);
            wasm.singleinputbuilder_native_script(retptr, this.__wbg_ptr, native_script.__wbg_ptr, witness_info.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return InputBuilderResult.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {PartialPlutusWitness} partial_witness
    * @param {Ed25519KeyHashList} required_signers
    * @param {PlutusData} datum
    * @returns {InputBuilderResult}
    */
    plutus_script(partial_witness, required_signers, datum) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(partial_witness, PartialPlutusWitness);
            _assertClass(required_signers, Ed25519KeyHashList);
            _assertClass(datum, PlutusData);
            wasm.singleinputbuilder_plutus_script(retptr, this.__wbg_ptr, partial_witness.__wbg_ptr, required_signers.__wbg_ptr, datum.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return InputBuilderResult.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {PartialPlutusWitness} partial_witness
    * @param {Ed25519KeyHashList} required_signers
    * @returns {InputBuilderResult}
    */
    plutus_script_inline_datum(partial_witness, required_signers) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(partial_witness, PartialPlutusWitness);
            _assertClass(required_signers, Ed25519KeyHashList);
            wasm.singleinputbuilder_plutus_script_inline_datum(retptr, this.__wbg_ptr, partial_witness.__wbg_ptr, required_signers.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return InputBuilderResult.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const SingleMintBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_singlemintbuilder_free(ptr >>> 0, 1));
/**
*/
class SingleMintBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SingleMintBuilder.prototype);
        obj.__wbg_ptr = ptr;
        SingleMintBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SingleMintBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_singlemintbuilder_free(ptr, 0);
    }
    /**
    * @param {MapAssetNameToNonZeroInt64} assets
    * @returns {SingleMintBuilder}
    */
    static new(assets) {
        _assertClass(assets, MapAssetNameToNonZeroInt64);
        const ret = wasm.singlemintbuilder_new(assets.__wbg_ptr);
        return SingleMintBuilder.__wrap(ret);
    }
    /**
    * @param {AssetName} asset
    * @param {bigint} amount
    * @returns {SingleMintBuilder}
    */
    static new_single_asset(asset, amount) {
        _assertClass(asset, AssetName);
        const ret = wasm.singlemintbuilder_new_single_asset(asset.__wbg_ptr, amount);
        return SingleMintBuilder.__wrap(ret);
    }
    /**
    * @param {NativeScript} native_script
    * @param {NativeScriptWitnessInfo} witness_info
    * @returns {MintBuilderResult}
    */
    native_script(native_script, witness_info) {
        const ptr = this.__destroy_into_raw();
        _assertClass(native_script, NativeScript);
        _assertClass(witness_info, NativeScriptWitnessInfo);
        const ret = wasm.singlemintbuilder_native_script(ptr, native_script.__wbg_ptr, witness_info.__wbg_ptr);
        return MintBuilderResult.__wrap(ret);
    }
    /**
    * @param {PartialPlutusWitness} partial_witness
    * @param {Ed25519KeyHashList} required_signers
    * @returns {MintBuilderResult}
    */
    plutus_script(partial_witness, required_signers) {
        const ptr = this.__destroy_into_raw();
        _assertClass(partial_witness, PartialPlutusWitness);
        _assertClass(required_signers, Ed25519KeyHashList);
        const ret = wasm.singlemintbuilder_plutus_script(ptr, partial_witness.__wbg_ptr, required_signers.__wbg_ptr);
        return MintBuilderResult.__wrap(ret);
    }
}

const SingleOutputBuilderResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_singleoutputbuilderresult_free(ptr >>> 0, 1));
/**
*/
class SingleOutputBuilderResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SingleOutputBuilderResult.prototype);
        obj.__wbg_ptr = ptr;
        SingleOutputBuilderResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SingleOutputBuilderResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_singleoutputbuilderresult_free(ptr, 0);
    }
    /**
    * @param {TransactionOutput} output
    * @returns {SingleOutputBuilderResult}
    */
    static new(output) {
        _assertClass(output, TransactionOutput);
        const ret = wasm.singleoutputbuilderresult_new(output.__wbg_ptr);
        return SingleOutputBuilderResult.__wrap(ret);
    }
    /**
    * @returns {TransactionOutput}
    */
    output() {
        const ret = wasm.singleoutputbuilderresult_output(this.__wbg_ptr);
        return TransactionOutput.__wrap(ret);
    }
    /**
    * @returns {PlutusData | undefined}
    */
    communication_datum() {
        const ret = wasm.singleoutputbuilderresult_communication_datum(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusData.__wrap(ret);
    }
}

const SingleWithdrawalBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_singlewithdrawalbuilder_free(ptr >>> 0, 1));
/**
*/
class SingleWithdrawalBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SingleWithdrawalBuilder.prototype);
        obj.__wbg_ptr = ptr;
        SingleWithdrawalBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SingleWithdrawalBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_singlewithdrawalbuilder_free(ptr, 0);
    }
    /**
    * @param {RewardAddress} address
    * @param {bigint} amount
    * @returns {SingleWithdrawalBuilder}
    */
    static new(address, amount) {
        _assertClass(address, RewardAddress);
        const ret = wasm.singlewithdrawalbuilder_new(address.__wbg_ptr, amount);
        return SingleWithdrawalBuilder.__wrap(ret);
    }
    /**
    * @returns {WithdrawalBuilderResult}
    */
    payment_key() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.singlewithdrawalbuilder_payment_key(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return WithdrawalBuilderResult.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {NativeScript} native_script
    * @param {NativeScriptWitnessInfo} witness_info
    * @returns {WithdrawalBuilderResult}
    */
    native_script(native_script, witness_info) {
        try {
            const ptr = this.__destroy_into_raw();
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(native_script, NativeScript);
            _assertClass(witness_info, NativeScriptWitnessInfo);
            wasm.singlewithdrawalbuilder_native_script(retptr, ptr, native_script.__wbg_ptr, witness_info.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return WithdrawalBuilderResult.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {PartialPlutusWitness} partial_witness
    * @param {Ed25519KeyHashList} required_signers
    * @returns {WithdrawalBuilderResult}
    */
    plutus_script(partial_witness, required_signers) {
        try {
            const ptr = this.__destroy_into_raw();
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(partial_witness, PartialPlutusWitness);
            var ptr0 = partial_witness.__destroy_into_raw();
            _assertClass(required_signers, Ed25519KeyHashList);
            var ptr1 = required_signers.__destroy_into_raw();
            wasm.singlewithdrawalbuilder_plutus_script(retptr, ptr, ptr0, ptr1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return WithdrawalBuilderResult.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const SpendingDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_spendingdata_free(ptr >>> 0, 1));
/**
*/
class SpendingData {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SpendingData.prototype);
        obj.__wbg_ptr = ptr;
        SpendingDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SpendingDataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_spendingdata_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes.
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.spendingdata_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {SpendingData}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.spendingdata_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SpendingData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.spendingdata_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {SpendingData}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.spendingdata_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SpendingData.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Bip32PublicKey} pubkey
    * @returns {SpendingData}
    */
    static new_spending_data_pub_key(pubkey) {
        _assertClass(pubkey, Bip32PublicKey);
        const ret = wasm.spendingdata_new_spending_data_pub_key(pubkey.__wbg_ptr);
        return SpendingData.__wrap(ret);
    }
    /**
    * @param {ByronScript} script
    * @returns {SpendingData}
    */
    static new_spending_data_script(script) {
        _assertClass(script, ByronScript);
        const ret = wasm.spendingdata_new_spending_data_script(script.__wbg_ptr);
        return SpendingData.__wrap(ret);
    }
    /**
    * @param {PublicKey} redeem
    * @returns {SpendingData}
    */
    static new_spending_data_redeem(redeem) {
        _assertClass(redeem, PublicKey);
        const ret = wasm.spendingdata_new_spending_data_redeem(redeem.__wbg_ptr);
        return SpendingData.__wrap(ret);
    }
    /**
    * @returns {SpendingDataKind}
    */
    kind() {
        const ret = wasm.spendingdata_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Bip32PublicKey | undefined}
    */
    as_spending_data_pub_key() {
        const ret = wasm.spendingdata_as_spending_data_pub_key(this.__wbg_ptr);
        return ret === 0 ? undefined : Bip32PublicKey.__wrap(ret);
    }
    /**
    * @returns {ByronScript | undefined}
    */
    as_spending_data_script() {
        const ret = wasm.spendingdata_as_spending_data_script(this.__wbg_ptr);
        return ret === 0 ? undefined : ByronScript.__wrap(ret);
    }
    /**
    * @returns {PublicKey | undefined}
    */
    as_spending_data_redeem() {
        const ret = wasm.spendingdata_as_spending_data_redeem(this.__wbg_ptr);
        return ret === 0 ? undefined : PublicKey.__wrap(ret);
    }
}

const StakeCredentialListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_stakecredentiallist_free(ptr >>> 0, 1));
/**
*/
class StakeCredentialList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(StakeCredentialList.prototype);
        obj.__wbg_ptr = ptr;
        StakeCredentialListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StakeCredentialListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_stakecredentiallist_free(ptr, 0);
    }
    /**
    * @returns {StakeCredentialList}
    */
    static new() {
        const ret = wasm.stakecredentiallist_new();
        return StakeCredentialList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.stakecredentiallist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {Credential}
    */
    get(index) {
        const ret = wasm.stakecredentiallist_get(this.__wbg_ptr, index);
        return Credential.__wrap(ret);
    }
    /**
    * @param {Credential} elem
    */
    add(elem) {
        _assertClass(elem, Credential);
        wasm.stakecredentiallist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const StakeDelegationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_stakedelegation_free(ptr >>> 0, 1));
/**
*/
class StakeDelegation {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(StakeDelegation.prototype);
        obj.__wbg_ptr = ptr;
        StakeDelegationFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StakeDelegationFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_stakedelegation_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakedelegation_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakedelegation_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {StakeDelegation}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakedelegation_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeDelegation.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakedelegation_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakedelegation_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {StakeDelegation}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakedelegation_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeDelegation.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakedelegation_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakedelegation_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {StakeDelegation}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakedelegation_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeDelegation.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    stake_credential() {
        const ret = wasm.stakedelegation_stake_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {Ed25519KeyHash}
    */
    pool() {
        const ret = wasm.stakedelegation_pool(this.__wbg_ptr);
        return Ed25519KeyHash.__wrap(ret);
    }
    /**
    * @param {Credential} stake_credential
    * @param {Ed25519KeyHash} pool
    * @returns {StakeDelegation}
    */
    static new(stake_credential, pool) {
        _assertClass(stake_credential, Credential);
        _assertClass(pool, Ed25519KeyHash);
        const ret = wasm.stakedelegation_new(stake_credential.__wbg_ptr, pool.__wbg_ptr);
        return StakeDelegation.__wrap(ret);
    }
}

const StakeDeregistrationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_stakederegistration_free(ptr >>> 0, 1));
/**
*/
class StakeDeregistration {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(StakeDeregistration.prototype);
        obj.__wbg_ptr = ptr;
        StakeDeregistrationFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StakeDeregistrationFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_stakederegistration_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakederegistration_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakederegistration_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {StakeDeregistration}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakederegistration_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeDeregistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakederegistration_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakederegistration_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {StakeDeregistration}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakederegistration_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeDeregistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakederegistration_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakederegistration_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {StakeDeregistration}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakederegistration_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeDeregistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    stake_credential() {
        const ret = wasm.stakederegistration_stake_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @param {Credential} stake_credential
    * @returns {StakeDeregistration}
    */
    static new(stake_credential) {
        _assertClass(stake_credential, Credential);
        const ret = wasm.stakederegistration_new(stake_credential.__wbg_ptr);
        return StakeDeregistration.__wrap(ret);
    }
}

const StakeDistributionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_stakedistribution_free(ptr >>> 0, 1));
/**
*/
class StakeDistribution {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(StakeDistribution.prototype);
        obj.__wbg_ptr = ptr;
        StakeDistributionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StakeDistributionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_stakedistribution_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes.
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakedistribution_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {StakeDistribution}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakedistribution_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeDistribution.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakedistribution_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {StakeDistribution}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakedistribution_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeDistribution.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {StakeholderId} stakeholder_id
    * @returns {StakeDistribution}
    */
    static new_single_key(stakeholder_id) {
        _assertClass(stakeholder_id, StakeholderId);
        const ret = wasm.stakedistribution_new_single_key(stakeholder_id.__wbg_ptr);
        return StakeDistribution.__wrap(ret);
    }
    /**
    * @returns {StakeDistribution}
    */
    static new_bootstrap_era() {
        const ret = wasm.stakedistribution_new_bootstrap_era();
        return StakeDistribution.__wrap(ret);
    }
    /**
    * @returns {StakeDistributionKind}
    */
    kind() {
        const ret = wasm.stakedistribution_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {StakeholderId | undefined}
    */
    as_single_key() {
        const ret = wasm.stakedistribution_as_single_key(this.__wbg_ptr);
        return ret === 0 ? undefined : StakeholderId.__wrap(ret);
    }
}

const StakeRegDelegCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_stakeregdelegcert_free(ptr >>> 0, 1));
/**
*/
class StakeRegDelegCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(StakeRegDelegCert.prototype);
        obj.__wbg_ptr = ptr;
        StakeRegDelegCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StakeRegDelegCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_stakeregdelegcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeregdelegcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeregdelegcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {StakeRegDelegCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakeregdelegcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeRegDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeregdelegcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeregdelegcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {StakeRegDelegCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakeregdelegcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeRegDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeregdelegcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeregdelegcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {StakeRegDelegCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakeregdelegcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeRegDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    stake_credential() {
        const ret = wasm.stakeregdelegcert_stake_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {Ed25519KeyHash}
    */
    pool() {
        const ret = wasm.stakeregdelegcert_pool(this.__wbg_ptr);
        return Ed25519KeyHash.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    deposit() {
        const ret = wasm.stakeregdelegcert_deposit(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {Credential} stake_credential
    * @param {Ed25519KeyHash} pool
    * @param {bigint} deposit
    * @returns {StakeRegDelegCert}
    */
    static new(stake_credential, pool, deposit) {
        _assertClass(stake_credential, Credential);
        _assertClass(pool, Ed25519KeyHash);
        const ret = wasm.stakeregdelegcert_new(stake_credential.__wbg_ptr, pool.__wbg_ptr, deposit);
        return StakeRegDelegCert.__wrap(ret);
    }
}

const StakeRegistrationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_stakeregistration_free(ptr >>> 0, 1));
/**
*/
class StakeRegistration {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(StakeRegistration.prototype);
        obj.__wbg_ptr = ptr;
        StakeRegistrationFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StakeRegistrationFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_stakeregistration_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeregistration_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeregistration_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {StakeRegistration}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakeregistration_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeRegistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeregistration_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeregistration_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {StakeRegistration}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakeregistration_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeRegistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeregistration_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeregistration_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {StakeRegistration}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakeregistration_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeRegistration.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    stake_credential() {
        const ret = wasm.stakeregistration_stake_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @param {Credential} stake_credential
    * @returns {StakeRegistration}
    */
    static new(stake_credential) {
        _assertClass(stake_credential, Credential);
        const ret = wasm.stakeregistration_new(stake_credential.__wbg_ptr);
        return StakeRegistration.__wrap(ret);
    }
}

const StakeVoteDelegCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_stakevotedelegcert_free(ptr >>> 0, 1));
/**
*/
class StakeVoteDelegCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(StakeVoteDelegCert.prototype);
        obj.__wbg_ptr = ptr;
        StakeVoteDelegCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StakeVoteDelegCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_stakevotedelegcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakevotedelegcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakevotedelegcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {StakeVoteDelegCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakevotedelegcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeVoteDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakevotedelegcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakevotedelegcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {StakeVoteDelegCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakevotedelegcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeVoteDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakevotedelegcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakevotedelegcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {StakeVoteDelegCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakevotedelegcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeVoteDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    stake_credential() {
        const ret = wasm.stakevotedelegcert_stake_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {Ed25519KeyHash}
    */
    pool() {
        const ret = wasm.stakevotedelegcert_pool(this.__wbg_ptr);
        return Ed25519KeyHash.__wrap(ret);
    }
    /**
    * @returns {DRep}
    */
    d_rep() {
        const ret = wasm.stakevotedelegcert_d_rep(this.__wbg_ptr);
        return DRep.__wrap(ret);
    }
    /**
    * @param {Credential} stake_credential
    * @param {Ed25519KeyHash} pool
    * @param {DRep} d_rep
    * @returns {StakeVoteDelegCert}
    */
    static new(stake_credential, pool, d_rep) {
        _assertClass(stake_credential, Credential);
        _assertClass(pool, Ed25519KeyHash);
        _assertClass(d_rep, DRep);
        const ret = wasm.stakevotedelegcert_new(stake_credential.__wbg_ptr, pool.__wbg_ptr, d_rep.__wbg_ptr);
        return StakeVoteDelegCert.__wrap(ret);
    }
}

const StakeVoteRegDelegCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_stakevoteregdelegcert_free(ptr >>> 0, 1));
/**
*/
class StakeVoteRegDelegCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(StakeVoteRegDelegCert.prototype);
        obj.__wbg_ptr = ptr;
        StakeVoteRegDelegCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StakeVoteRegDelegCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_stakevoteregdelegcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakevoteregdelegcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakevoteregdelegcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {StakeVoteRegDelegCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakevoteregdelegcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeVoteRegDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakevoteregdelegcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakevoteregdelegcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {StakeVoteRegDelegCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakevoteregdelegcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeVoteRegDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakevoteregdelegcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakevoteregdelegcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {StakeVoteRegDelegCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakevoteregdelegcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeVoteRegDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    stake_credential() {
        const ret = wasm.stakevoteregdelegcert_stake_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {Ed25519KeyHash}
    */
    pool() {
        const ret = wasm.stakevoteregdelegcert_pool(this.__wbg_ptr);
        return Ed25519KeyHash.__wrap(ret);
    }
    /**
    * @returns {DRep}
    */
    d_rep() {
        const ret = wasm.stakevoteregdelegcert_d_rep(this.__wbg_ptr);
        return DRep.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    deposit() {
        const ret = wasm.stakevoteregdelegcert_deposit(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {Credential} stake_credential
    * @param {Ed25519KeyHash} pool
    * @param {DRep} d_rep
    * @param {bigint} deposit
    * @returns {StakeVoteRegDelegCert}
    */
    static new(stake_credential, pool, d_rep, deposit) {
        _assertClass(stake_credential, Credential);
        _assertClass(pool, Ed25519KeyHash);
        _assertClass(d_rep, DRep);
        const ret = wasm.stakevoteregdelegcert_new(stake_credential.__wbg_ptr, pool.__wbg_ptr, d_rep.__wbg_ptr, deposit);
        return StakeVoteRegDelegCert.__wrap(ret);
    }
}

const StakeholderIdFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_stakeholderid_free(ptr >>> 0, 1));
/**
*/
class StakeholderId {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(StakeholderId.prototype);
        obj.__wbg_ptr = ptr;
        StakeholderIdFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StakeholderIdFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_stakeholderid_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakeholderid_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {StakeholderId}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakeholderid_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeholderId.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeholderid_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {StakeholderId}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakeholderid_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeholderId.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.stakeholderid_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {StakeholderId}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.stakeholderid_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return StakeholderId.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Bip32PublicKey} pubk
    * @returns {StakeholderId}
    */
    static new(pubk) {
        _assertClass(pubk, Bip32PublicKey);
        const ret = wasm.stakeholderid_new(pubk.__wbg_ptr);
        return StakeholderId.__wrap(ret);
    }
}

const SubCoinFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_subcoin_free(ptr >>> 0, 1));

class SubCoin {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SubCoinFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_subcoin_free(ptr, 0);
    }
    /**
    * Converts base 10 floats to SubCoin.
    * This is the format used by blockfrost for ex units
    * Warning: If the passed in float was not meant to be base 10
    * this might result in a slightly inaccurate fraction.
    * @param {number} f
    * @returns {Rational}
    */
    static from_base10_f32(f) {
        const ret = wasm.subcoin_from_base10_f32(f);
        return Rational.__wrap(ret);
    }
}

const TransactionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transaction_free(ptr >>> 0, 1));
/**
*/
class Transaction {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Transaction.prototype);
        obj.__wbg_ptr = ptr;
        TransactionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transaction_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transaction_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transaction_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Transaction}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transaction_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Transaction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transaction_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transaction_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Transaction}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transaction_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Transaction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transaction_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transaction_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Transaction}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transaction_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Transaction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {TransactionBody}
    */
    body() {
        const ret = wasm.transaction_body(this.__wbg_ptr);
        return TransactionBody.__wrap(ret);
    }
    /**
    * @returns {TransactionWitnessSet}
    */
    witness_set() {
        const ret = wasm.transaction_witness_set(this.__wbg_ptr);
        return TransactionWitnessSet.__wrap(ret);
    }
    /**
    * @returns {boolean}
    */
    is_valid() {
        const ret = wasm.transaction_is_valid(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @returns {AuxiliaryData | undefined}
    */
    auxiliary_data() {
        const ret = wasm.transaction_auxiliary_data(this.__wbg_ptr);
        return ret === 0 ? undefined : AuxiliaryData.__wrap(ret);
    }
    /**
    * @param {TransactionBody} body
    * @param {TransactionWitnessSet} witness_set
    * @param {boolean} is_valid
    * @param {AuxiliaryData | undefined} [auxiliary_data]
    * @returns {Transaction}
    */
    static new(body, witness_set, is_valid, auxiliary_data) {
        _assertClass(body, TransactionBody);
        _assertClass(witness_set, TransactionWitnessSet);
        let ptr0 = 0;
        if (!isLikeNone(auxiliary_data)) {
            _assertClass(auxiliary_data, AuxiliaryData);
            ptr0 = auxiliary_data.__destroy_into_raw();
        }
        const ret = wasm.transaction_new(body.__wbg_ptr, witness_set.__wbg_ptr, is_valid, ptr0);
        return Transaction.__wrap(ret);
    }
}

const TransactionBodyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionbody_free(ptr >>> 0, 1));
/**
*/
class TransactionBody {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionBody.prototype);
        obj.__wbg_ptr = ptr;
        TransactionBodyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionBodyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionbody_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbody_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbody_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {TransactionBody}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionbody_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionBody.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbody_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbody_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {TransactionBody}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionbody_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionBody.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbody_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbody_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {TransactionBody}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionbody_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionBody.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {TransactionInputList}
    */
    inputs() {
        const ret = wasm.transactionbody_inputs(this.__wbg_ptr);
        return TransactionInputList.__wrap(ret);
    }
    /**
    * @returns {TransactionOutputList}
    */
    outputs() {
        const ret = wasm.transactionbody_outputs(this.__wbg_ptr);
        return TransactionOutputList.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    fee() {
        const ret = wasm.transactionbody_fee(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} ttl
    */
    set_ttl(ttl) {
        wasm.transactionbody_set_ttl(this.__wbg_ptr, ttl);
    }
    /**
    * @returns {bigint | undefined}
    */
    ttl() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbody_ttl(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {CertificateList} certs
    */
    set_certs(certs) {
        _assertClass(certs, CertificateList);
        wasm.transactionbody_set_certs(this.__wbg_ptr, certs.__wbg_ptr);
    }
    /**
    * @returns {CertificateList | undefined}
    */
    certs() {
        const ret = wasm.transactionbody_certs(this.__wbg_ptr);
        return ret === 0 ? undefined : CertificateList.__wrap(ret);
    }
    /**
    * @param {MapRewardAccountToCoin} withdrawals
    */
    set_withdrawals(withdrawals) {
        _assertClass(withdrawals, MapRewardAccountToCoin);
        wasm.transactionbody_set_withdrawals(this.__wbg_ptr, withdrawals.__wbg_ptr);
    }
    /**
    * @returns {MapRewardAccountToCoin | undefined}
    */
    withdrawals() {
        const ret = wasm.transactionbody_withdrawals(this.__wbg_ptr);
        return ret === 0 ? undefined : MapRewardAccountToCoin.__wrap(ret);
    }
    /**
    * @param {AuxiliaryDataHash} auxiliary_data_hash
    */
    set_auxiliary_data_hash(auxiliary_data_hash) {
        _assertClass(auxiliary_data_hash, AuxiliaryDataHash);
        wasm.transactionbody_set_auxiliary_data_hash(this.__wbg_ptr, auxiliary_data_hash.__wbg_ptr);
    }
    /**
    * @returns {AuxiliaryDataHash | undefined}
    */
    auxiliary_data_hash() {
        const ret = wasm.transactionbody_auxiliary_data_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : AuxiliaryDataHash.__wrap(ret);
    }
    /**
    * @param {bigint} validity_interval_start
    */
    set_validity_interval_start(validity_interval_start) {
        wasm.transactionbody_set_validity_interval_start(this.__wbg_ptr, validity_interval_start);
    }
    /**
    * @returns {bigint | undefined}
    */
    validity_interval_start() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbody_validity_interval_start(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Mint} mint
    */
    set_mint(mint) {
        _assertClass(mint, Mint);
        wasm.transactionbody_set_mint(this.__wbg_ptr, mint.__wbg_ptr);
    }
    /**
    * @returns {Mint | undefined}
    */
    mint() {
        const ret = wasm.transactionbody_mint(this.__wbg_ptr);
        return ret === 0 ? undefined : Mint.__wrap(ret);
    }
    /**
    * @param {ScriptDataHash} script_data_hash
    */
    set_script_data_hash(script_data_hash) {
        _assertClass(script_data_hash, ScriptDataHash);
        wasm.transactionbody_set_script_data_hash(this.__wbg_ptr, script_data_hash.__wbg_ptr);
    }
    /**
    * @returns {ScriptDataHash | undefined}
    */
    script_data_hash() {
        const ret = wasm.transactionbody_script_data_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptDataHash.__wrap(ret);
    }
    /**
    * @param {TransactionInputList} collateral_inputs
    */
    set_collateral_inputs(collateral_inputs) {
        _assertClass(collateral_inputs, TransactionInputList);
        wasm.transactionbody_set_collateral_inputs(this.__wbg_ptr, collateral_inputs.__wbg_ptr);
    }
    /**
    * @returns {TransactionInputList | undefined}
    */
    collateral_inputs() {
        const ret = wasm.transactionbody_collateral_inputs(this.__wbg_ptr);
        return ret === 0 ? undefined : TransactionInputList.__wrap(ret);
    }
    /**
    * @param {Ed25519KeyHashList} required_signers
    */
    set_required_signers(required_signers) {
        _assertClass(required_signers, Ed25519KeyHashList);
        wasm.transactionbody_set_required_signers(this.__wbg_ptr, required_signers.__wbg_ptr);
    }
    /**
    * @returns {Ed25519KeyHashList | undefined}
    */
    required_signers() {
        const ret = wasm.transactionbody_required_signers(this.__wbg_ptr);
        return ret === 0 ? undefined : Ed25519KeyHashList.__wrap(ret);
    }
    /**
    * @param {NetworkId} network_id
    */
    set_network_id(network_id) {
        _assertClass(network_id, NetworkId);
        wasm.transactionbody_set_network_id(this.__wbg_ptr, network_id.__wbg_ptr);
    }
    /**
    * @returns {NetworkId | undefined}
    */
    network_id() {
        const ret = wasm.transactionbody_network_id(this.__wbg_ptr);
        return ret === 0 ? undefined : NetworkId.__wrap(ret);
    }
    /**
    * @param {TransactionOutput} collateral_return
    */
    set_collateral_return(collateral_return) {
        _assertClass(collateral_return, TransactionOutput);
        wasm.transactionbody_set_collateral_return(this.__wbg_ptr, collateral_return.__wbg_ptr);
    }
    /**
    * @returns {TransactionOutput | undefined}
    */
    collateral_return() {
        const ret = wasm.transactionbody_collateral_return(this.__wbg_ptr);
        return ret === 0 ? undefined : TransactionOutput.__wrap(ret);
    }
    /**
    * @param {bigint} total_collateral
    */
    set_total_collateral(total_collateral) {
        wasm.transactionbody_set_total_collateral(this.__wbg_ptr, total_collateral);
    }
    /**
    * @returns {bigint | undefined}
    */
    total_collateral() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbody_total_collateral(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {TransactionInputList} reference_inputs
    */
    set_reference_inputs(reference_inputs) {
        _assertClass(reference_inputs, TransactionInputList);
        wasm.transactionbody_set_reference_inputs(this.__wbg_ptr, reference_inputs.__wbg_ptr);
    }
    /**
    * @returns {TransactionInputList | undefined}
    */
    reference_inputs() {
        const ret = wasm.transactionbody_reference_inputs(this.__wbg_ptr);
        return ret === 0 ? undefined : TransactionInputList.__wrap(ret);
    }
    /**
    * @param {VotingProcedures} voting_procedures
    */
    set_voting_procedures(voting_procedures) {
        _assertClass(voting_procedures, VotingProcedures);
        wasm.transactionbody_set_voting_procedures(this.__wbg_ptr, voting_procedures.__wbg_ptr);
    }
    /**
    * @returns {VotingProcedures | undefined}
    */
    voting_procedures() {
        const ret = wasm.transactionbody_voting_procedures(this.__wbg_ptr);
        return ret === 0 ? undefined : VotingProcedures.__wrap(ret);
    }
    /**
    * @param {ProposalProcedureList} proposal_procedures
    */
    set_proposal_procedures(proposal_procedures) {
        _assertClass(proposal_procedures, ProposalProcedureList);
        wasm.transactionbody_set_proposal_procedures(this.__wbg_ptr, proposal_procedures.__wbg_ptr);
    }
    /**
    * @returns {ProposalProcedureList | undefined}
    */
    proposal_procedures() {
        const ret = wasm.transactionbody_proposal_procedures(this.__wbg_ptr);
        return ret === 0 ? undefined : ProposalProcedureList.__wrap(ret);
    }
    /**
    * @param {bigint} current_treasury_value
    */
    set_current_treasury_value(current_treasury_value) {
        wasm.transactionbody_set_current_treasury_value(this.__wbg_ptr, current_treasury_value);
    }
    /**
    * @returns {bigint | undefined}
    */
    current_treasury_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbody_current_treasury_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} donation
    */
    set_donation(donation) {
        wasm.transactionbody_set_donation(this.__wbg_ptr, donation);
    }
    /**
    * @returns {bigint | undefined}
    */
    donation() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbody_donation(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {TransactionInputList} inputs
    * @param {TransactionOutputList} outputs
    * @param {bigint} fee
    * @returns {TransactionBody}
    */
    static new(inputs, outputs, fee) {
        _assertClass(inputs, TransactionInputList);
        _assertClass(outputs, TransactionOutputList);
        const ret = wasm.transactionbody_new(inputs.__wbg_ptr, outputs.__wbg_ptr, fee);
        return TransactionBody.__wrap(ret);
    }
}

const TransactionBodyListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionbodylist_free(ptr >>> 0, 1));
/**
*/
class TransactionBodyList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionBodyList.prototype);
        obj.__wbg_ptr = ptr;
        TransactionBodyListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionBodyListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionbodylist_free(ptr, 0);
    }
    /**
    * @returns {TransactionBodyList}
    */
    static new() {
        const ret = wasm.transactionbodylist_new();
        return TransactionBodyList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.transactionbodylist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {TransactionBody}
    */
    get(index) {
        const ret = wasm.transactionbodylist_get(this.__wbg_ptr, index);
        return TransactionBody.__wrap(ret);
    }
    /**
    * @param {TransactionBody} elem
    */
    add(elem) {
        _assertClass(elem, TransactionBody);
        wasm.transactionbodylist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const TransactionBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionbuilder_free(ptr >>> 0, 1));
/**
*/
class TransactionBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionBuilder.prototype);
        obj.__wbg_ptr = ptr;
        TransactionBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionbuilder_free(ptr, 0);
    }
    /**
    * This automatically selects and adds inputs from {inputs} consisting of just enough to cover
    * the outputs that have already been added.
    * This should be called after adding all certs/outputs/etc and will be an error otherwise.
    * Uses CIP2: https://github.com/cardano-foundation/CIPs/blob/master/CIP-0002/CIP-0002.md
    * Adding a change output must be called after via TransactionBuilder::add_change_if_needed()
    * This function, diverging from CIP2, takes into account fees and will attempt to add additional
    * inputs to cover the minimum fees. This does not, however, set the txbuilder's fee.
    * @param {CoinSelectionStrategyCIP2} strategy
    */
    select_utxos(strategy) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbuilder_select_utxos(retptr, this.__wbg_ptr, strategy);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {InputBuilderResult} result
    */
    add_input(result) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(result, InputBuilderResult);
            wasm.transactionbuilder_add_input(retptr, this.__wbg_ptr, result.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {InputBuilderResult} result
    */
    add_utxo(result) {
        _assertClass(result, InputBuilderResult);
        wasm.transactionbuilder_add_utxo(this.__wbg_ptr, result.__wbg_ptr);
    }
    /**
    * calculates how much the fee would increase if you added a given output
    * @param {InputBuilderResult} result
    * @returns {bigint}
    */
    fee_for_input(result) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(result, InputBuilderResult);
            wasm.transactionbuilder_fee_for_input(retptr, this.__wbg_ptr, result.__wbg_ptr);
            var r0 = getDataViewMemory0().getBigInt64(retptr + 8 * 0, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            return BigInt.asUintN(64, r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Add a reference input. Must be called BEFORE adding anything (inputs, certs, etc) that refer to this reference input.
    * @param {TransactionUnspentOutput} utxo
    */
    add_reference_input(utxo) {
        _assertClass(utxo, TransactionUnspentOutput);
        wasm.transactionbuilder_add_reference_input(this.__wbg_ptr, utxo.__wbg_ptr);
    }
    /**
    * Add explicit output via a TransactionOutput object
    * @param {SingleOutputBuilderResult} builder_result
    */
    add_output(builder_result) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(builder_result, SingleOutputBuilderResult);
            wasm.transactionbuilder_add_output(retptr, this.__wbg_ptr, builder_result.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * calculates how much the fee would increase if you added a given output
    * @param {SingleOutputBuilderResult} builder
    * @returns {bigint}
    */
    fee_for_output(builder) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(builder, SingleOutputBuilderResult);
            wasm.transactionbuilder_fee_for_output(retptr, this.__wbg_ptr, builder.__wbg_ptr);
            var r0 = getDataViewMemory0().getBigInt64(retptr + 8 * 0, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            return BigInt.asUintN(64, r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} fee
    */
    set_fee(fee) {
        wasm.transactionbuilder_set_fee(this.__wbg_ptr, fee);
    }
    /**
    * @param {bigint} ttl
    */
    set_ttl(ttl) {
        wasm.transactionbuilder_set_ttl(this.__wbg_ptr, ttl);
    }
    /**
    * @param {bigint} validity_start_interval
    */
    set_validity_start_interval(validity_start_interval) {
        wasm.transactionbuilder_set_validity_start_interval(this.__wbg_ptr, validity_start_interval);
    }
    /**
    * @param {CertificateBuilderResult} result
    */
    add_cert(result) {
        _assertClass(result, CertificateBuilderResult);
        wasm.transactionbuilder_add_cert(this.__wbg_ptr, result.__wbg_ptr);
    }
    /**
    * @param {ProposalBuilderResult} result
    */
    add_proposal(result) {
        _assertClass(result, ProposalBuilderResult);
        var ptr0 = result.__destroy_into_raw();
        wasm.transactionbuilder_add_proposal(this.__wbg_ptr, ptr0);
    }
    /**
    * @param {VoteBuilderResult} result
    */
    add_vote(result) {
        _assertClass(result, VoteBuilderResult);
        var ptr0 = result.__destroy_into_raw();
        wasm.transactionbuilder_add_vote(this.__wbg_ptr, ptr0);
    }
    /**
    * @returns {MapRewardAccountToCoin | undefined}
    */
    get_withdrawals() {
        const ret = wasm.transactionbuilder_get_withdrawals(this.__wbg_ptr);
        return ret === 0 ? undefined : MapRewardAccountToCoin.__wrap(ret);
    }
    /**
    * @param {WithdrawalBuilderResult} result
    */
    add_withdrawal(result) {
        _assertClass(result, WithdrawalBuilderResult);
        wasm.transactionbuilder_add_withdrawal(this.__wbg_ptr, result.__wbg_ptr);
    }
    /**
    * @returns {AuxiliaryData | undefined}
    */
    get_auxiliary_data() {
        const ret = wasm.transactionbuilder_get_auxiliary_data(this.__wbg_ptr);
        return ret === 0 ? undefined : AuxiliaryData.__wrap(ret);
    }
    /**
    * @param {AuxiliaryData} new_aux_data
    */
    set_auxiliary_data(new_aux_data) {
        _assertClass(new_aux_data, AuxiliaryData);
        wasm.transactionbuilder_set_auxiliary_data(this.__wbg_ptr, new_aux_data.__wbg_ptr);
    }
    /**
    * @param {AuxiliaryData} new_aux_data
    */
    add_auxiliary_data(new_aux_data) {
        _assertClass(new_aux_data, AuxiliaryData);
        wasm.transactionbuilder_add_auxiliary_data(this.__wbg_ptr, new_aux_data.__wbg_ptr);
    }
    /**
    * @param {MintBuilderResult} result
    */
    add_mint(result) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(result, MintBuilderResult);
            wasm.transactionbuilder_add_mint(retptr, this.__wbg_ptr, result.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Returns a copy of the current mint state in the builder
    * @returns {Mint | undefined}
    */
    get_mint() {
        const ret = wasm.transactionbuilder_get_mint(this.__wbg_ptr);
        return ret === 0 ? undefined : Mint.__wrap(ret);
    }
    /**
    * @param {TransactionBuilderConfig} cfg
    * @returns {TransactionBuilder}
    */
    static new(cfg) {
        _assertClass(cfg, TransactionBuilderConfig);
        const ret = wasm.transactionbuilder_new(cfg.__wbg_ptr);
        return TransactionBuilder.__wrap(ret);
    }
    /**
    * @param {InputBuilderResult} result
    */
    add_collateral(result) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(result, InputBuilderResult);
            wasm.transactionbuilder_add_collateral(retptr, this.__wbg_ptr, result.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Ed25519KeyHash} hash
    */
    add_required_signer(hash) {
        _assertClass(hash, Ed25519KeyHash);
        wasm.transactionbuilder_add_required_signer(this.__wbg_ptr, hash.__wbg_ptr);
    }
    /**
    * @param {NetworkId} network_id
    */
    set_network_id(network_id) {
        _assertClass(network_id, NetworkId);
        wasm.transactionbuilder_set_network_id(this.__wbg_ptr, network_id.__wbg_ptr);
    }
    /**
    * @returns {NetworkId | undefined}
    */
    network_id() {
        const ret = wasm.transactionbuilder_network_id(this.__wbg_ptr);
        return ret === 0 ? undefined : NetworkId.__wrap(ret);
    }
    /**
    * does not include refunds or withdrawals
    * @returns {Value}
    */
    get_explicit_input() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbuilder_get_explicit_input(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Value.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * withdrawals and refunds
    * @returns {Value}
    */
    get_implicit_input() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbuilder_get_implicit_input(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Value.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return explicit input plus implicit input plus mint
    * @returns {Value}
    */
    get_total_input() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbuilder_get_total_input(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Value.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Return explicit output plus implicit output plus burn (does not consider fee directly)
    * @returns {Value}
    */
    get_total_output() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbuilder_get_total_output(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Value.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * does not include fee
    * @returns {Value}
    */
    get_explicit_output() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbuilder_get_explicit_output(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Value.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint}
    */
    get_deposit() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbuilder_get_deposit(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getBigInt64(retptr + 8 * 0, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            return BigInt.asUintN(64, r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint | undefined}
    */
    get_fee_if_set() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbuilder_get_fee_if_set(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r2 = getDataViewMemory0().getBigInt64(retptr + 8 * 1, true);
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {TransactionOutput} output
    */
    set_collateral_return(output) {
        _assertClass(output, TransactionOutput);
        wasm.transactionbuilder_set_collateral_return(this.__wbg_ptr, output.__wbg_ptr);
    }
    /**
    * @returns {number}
    */
    full_size() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbuilder_full_size(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Uint32Array}
    */
    output_sizes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbuilder_output_sizes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU32FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Builds the transaction and moves to the next step redeemer units can be added and a draft tx can
    * be evaluated
    * NOTE: is_valid set to true
    * @param {ChangeSelectionAlgo} algo
    * @param {Address} change_address
    * @returns {TxRedeemerBuilder}
    */
    build_for_evaluation(algo, change_address) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(change_address, Address);
            wasm.transactionbuilder_build_for_evaluation(retptr, this.__wbg_ptr, algo, change_address.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TxRedeemerBuilder.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Builds the transaction and moves to the next step where any real witness can be added
    * NOTE: is_valid set to true
    * @param {ChangeSelectionAlgo} algo
    * @param {Address} change_address
    * @returns {SignedTxBuilder}
    */
    build(algo, change_address) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(change_address, Address);
            wasm.transactionbuilder_build(retptr, this.__wbg_ptr, algo, change_address.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SignedTxBuilder.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * used to override the exunit values initially provided when adding inputs
    * @param {RedeemerWitnessKey} redeemer
    * @param {ExUnits} ex_units
    */
    set_exunits(redeemer, ex_units) {
        _assertClass(redeemer, RedeemerWitnessKey);
        _assertClass(ex_units, ExUnits);
        wasm.transactionbuilder_set_exunits(this.__wbg_ptr, redeemer.__wbg_ptr, ex_units.__wbg_ptr);
    }
    /**
    * warning: sum of all parts of a transaction must equal 0. You cannot just set the fee to the min value and forget about it
    * warning: min_fee may be slightly larger than the actual minimum fee (ex: a few lovelaces)
    * this is done to simplify the library code, but can be fixed later
    * @param {boolean} script_calulation
    * @returns {bigint}
    */
    min_fee(script_calulation) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbuilder_min_fee(retptr, this.__wbg_ptr, script_calulation);
            var r0 = getDataViewMemory0().getBigInt64(retptr + 8 * 0, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            return BigInt.asUintN(64, r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Warning: this function will mutate the /fee/ field
    * Make sure to call this function last after setting all other tx-body properties
    * Editing inputs, outputs, mint, etc. after change been calculated
    * might cause a mismatch in calculated fee versus the required fee
    * @param {Address} address
    * @param {boolean} include_exunits
    * @returns {boolean}
    */
    add_change_if_needed(address, include_exunits) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(address, Address);
            wasm.transactionbuilder_add_change_if_needed(retptr, this.__wbg_ptr, address.__wbg_ptr, include_exunits);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 !== 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const TransactionBuilderConfigFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionbuilderconfig_free(ptr >>> 0, 1));
/**
*/
class TransactionBuilderConfig {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionBuilderConfig.prototype);
        obj.__wbg_ptr = ptr;
        TransactionBuilderConfigFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionBuilderConfigFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionbuilderconfig_free(ptr, 0);
    }
}

const TransactionBuilderConfigBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionbuilderconfigbuilder_free(ptr >>> 0, 1));
/**
*/
class TransactionBuilderConfigBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionBuilderConfigBuilder.prototype);
        obj.__wbg_ptr = ptr;
        TransactionBuilderConfigBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionBuilderConfigBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionbuilderconfigbuilder_free(ptr, 0);
    }
    /**
    * @returns {TransactionBuilderConfigBuilder}
    */
    static new() {
        const ret = wasm.transactionbuilderconfigbuilder_new();
        return TransactionBuilderConfigBuilder.__wrap(ret);
    }
    /**
    * @param {LinearFee} fee_algo
    * @returns {TransactionBuilderConfigBuilder}
    */
    fee_algo(fee_algo) {
        _assertClass(fee_algo, LinearFee);
        const ret = wasm.transactionbuilderconfigbuilder_fee_algo(this.__wbg_ptr, fee_algo.__wbg_ptr);
        return TransactionBuilderConfigBuilder.__wrap(ret);
    }
    /**
    * @param {bigint} coins_per_utxo_byte
    * @returns {TransactionBuilderConfigBuilder}
    */
    coins_per_utxo_byte(coins_per_utxo_byte) {
        const ret = wasm.transactionbuilderconfigbuilder_coins_per_utxo_byte(this.__wbg_ptr, coins_per_utxo_byte);
        return TransactionBuilderConfigBuilder.__wrap(ret);
    }
    /**
    * @param {bigint} pool_deposit
    * @returns {TransactionBuilderConfigBuilder}
    */
    pool_deposit(pool_deposit) {
        const ret = wasm.transactionbuilderconfigbuilder_pool_deposit(this.__wbg_ptr, pool_deposit);
        return TransactionBuilderConfigBuilder.__wrap(ret);
    }
    /**
    * @param {bigint} key_deposit
    * @returns {TransactionBuilderConfigBuilder}
    */
    key_deposit(key_deposit) {
        const ret = wasm.transactionbuilderconfigbuilder_key_deposit(this.__wbg_ptr, key_deposit);
        return TransactionBuilderConfigBuilder.__wrap(ret);
    }
    /**
    * @param {number} max_value_size
    * @returns {TransactionBuilderConfigBuilder}
    */
    max_value_size(max_value_size) {
        const ret = wasm.transactionbuilderconfigbuilder_max_value_size(this.__wbg_ptr, max_value_size);
        return TransactionBuilderConfigBuilder.__wrap(ret);
    }
    /**
    * @param {number} max_tx_size
    * @returns {TransactionBuilderConfigBuilder}
    */
    max_tx_size(max_tx_size) {
        const ret = wasm.transactionbuilderconfigbuilder_max_tx_size(this.__wbg_ptr, max_tx_size);
        return TransactionBuilderConfigBuilder.__wrap(ret);
    }
    /**
    * @param {boolean} prefer_pure_change
    * @returns {TransactionBuilderConfigBuilder}
    */
    prefer_pure_change(prefer_pure_change) {
        const ret = wasm.transactionbuilderconfigbuilder_prefer_pure_change(this.__wbg_ptr, prefer_pure_change);
        return TransactionBuilderConfigBuilder.__wrap(ret);
    }
    /**
    * @param {ExUnitPrices} ex_unit_prices
    * @returns {TransactionBuilderConfigBuilder}
    */
    ex_unit_prices(ex_unit_prices) {
        _assertClass(ex_unit_prices, ExUnitPrices);
        const ret = wasm.transactionbuilderconfigbuilder_ex_unit_prices(this.__wbg_ptr, ex_unit_prices.__wbg_ptr);
        return TransactionBuilderConfigBuilder.__wrap(ret);
    }
    /**
    * @param {CostModels} cost_models
    * @returns {TransactionBuilderConfigBuilder}
    */
    cost_models(cost_models) {
        _assertClass(cost_models, CostModels);
        const ret = wasm.transactionbuilderconfigbuilder_cost_models(this.__wbg_ptr, cost_models.__wbg_ptr);
        return TransactionBuilderConfigBuilder.__wrap(ret);
    }
    /**
    * @param {number} collateral_percentage
    * @returns {TransactionBuilderConfigBuilder}
    */
    collateral_percentage(collateral_percentage) {
        const ret = wasm.transactionbuilderconfigbuilder_collateral_percentage(this.__wbg_ptr, collateral_percentage);
        return TransactionBuilderConfigBuilder.__wrap(ret);
    }
    /**
    * @param {number} max_collateral_inputs
    * @returns {TransactionBuilderConfigBuilder}
    */
    max_collateral_inputs(max_collateral_inputs) {
        const ret = wasm.transactionbuilderconfigbuilder_max_collateral_inputs(this.__wbg_ptr, max_collateral_inputs);
        return TransactionBuilderConfigBuilder.__wrap(ret);
    }
    /**
    * @returns {TransactionBuilderConfig}
    */
    build() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionbuilderconfigbuilder_build(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionBuilderConfig.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const TransactionHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionhash_free(ptr >>> 0, 1));
/**
*/
class TransactionHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionHash.prototype);
        obj.__wbg_ptr = ptr;
        TransactionHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionhash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionhash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {TransactionHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionhash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionhash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {TransactionHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionhash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionhash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {TransactionHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionhash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const TransactionInputFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactioninput_free(ptr >>> 0, 1));
/**
*/
class TransactionInput {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionInput.prototype);
        obj.__wbg_ptr = ptr;
        TransactionInputFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionInputFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactioninput_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactioninput_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactioninput_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {TransactionInput}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactioninput_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionInput.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactioninput_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactioninput_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {TransactionInput}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactioninput_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionInput.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactioninput_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactioninput_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {TransactionInput}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactioninput_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionInput.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {TransactionHash}
    */
    transaction_id() {
        const ret = wasm.transactioninput_transaction_id(this.__wbg_ptr);
        return TransactionHash.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    index() {
        const ret = wasm.transactioninput_index(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {TransactionHash} transaction_id
    * @param {bigint} index
    * @returns {TransactionInput}
    */
    static new(transaction_id, index) {
        _assertClass(transaction_id, TransactionHash);
        const ret = wasm.transactioninput_new(transaction_id.__wbg_ptr, index);
        return TransactionInput.__wrap(ret);
    }
}

const TransactionInputListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactioninputlist_free(ptr >>> 0, 1));
/**
*/
class TransactionInputList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionInputList.prototype);
        obj.__wbg_ptr = ptr;
        TransactionInputListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionInputListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactioninputlist_free(ptr, 0);
    }
    /**
    * @returns {TransactionInputList}
    */
    static new() {
        const ret = wasm.transactioninputlist_new();
        return TransactionInputList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.transactioninputlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {TransactionInput}
    */
    get(index) {
        const ret = wasm.transactioninputlist_get(this.__wbg_ptr, index);
        return TransactionInput.__wrap(ret);
    }
    /**
    * @param {TransactionInput} elem
    */
    add(elem) {
        _assertClass(elem, TransactionInput);
        wasm.transactioninputlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const TransactionMetadatumFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionmetadatum_free(ptr >>> 0, 1));
/**
*/
class TransactionMetadatum {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionMetadatum.prototype);
        obj.__wbg_ptr = ptr;
        TransactionMetadatumFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionMetadatumFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionmetadatum_free(ptr, 0);
    }
    /**
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionmetadatum_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} cbor_bytes
    * @returns {TransactionMetadatum}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionmetadatum_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionMetadatum.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionmetadatum_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_json_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionmetadatum_to_json_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {TransactionMetadatum}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionmetadatum_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionMetadatum.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {MetadatumMap} map
    * @returns {TransactionMetadatum}
    */
    static new_map(map) {
        _assertClass(map, MetadatumMap);
        const ret = wasm.transactionmetadatum_new_map(map.__wbg_ptr);
        return TransactionMetadatum.__wrap(ret);
    }
    /**
    * @param {MetadatumList} elements
    * @returns {TransactionMetadatum}
    */
    static new_list(elements) {
        _assertClass(elements, MetadatumList);
        const ret = wasm.transactionmetadatum_new_list(elements.__wbg_ptr);
        return TransactionMetadatum.__wrap(ret);
    }
    /**
    * @param {Int} int
    * @returns {TransactionMetadatum}
    */
    static new_int(int) {
        _assertClass(int, Int);
        const ret = wasm.transactionmetadatum_new_int(int.__wbg_ptr);
        return TransactionMetadatum.__wrap(ret);
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {TransactionMetadatum}
    */
    static new_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionmetadatum_new_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionMetadatum.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} text
    * @returns {TransactionMetadatum}
    */
    static new_text(text) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionmetadatum_new_text(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionMetadatum.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {TransactionMetadatumKind}
    */
    kind() {
        const ret = wasm.transactionmetadatum_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {MetadatumMap | undefined}
    */
    as_map() {
        const ret = wasm.transactionmetadatum_as_map(this.__wbg_ptr);
        return ret === 0 ? undefined : MetadatumMap.__wrap(ret);
    }
    /**
    * @returns {MetadatumList | undefined}
    */
    as_list() {
        const ret = wasm.transactionmetadatum_as_list(this.__wbg_ptr);
        return ret === 0 ? undefined : MetadatumList.__wrap(ret);
    }
    /**
    * @returns {Int | undefined}
    */
    as_int() {
        const ret = wasm.transactionmetadatum_as_int(this.__wbg_ptr);
        return ret === 0 ? undefined : Int.__wrap(ret);
    }
    /**
    * @returns {Uint8Array | undefined}
    */
    as_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionmetadatum_as_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    as_text() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionmetadatum_as_text(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const TransactionMetadatumLabelsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionmetadatumlabels_free(ptr >>> 0, 1));
/**
*/
class TransactionMetadatumLabels {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionMetadatumLabels.prototype);
        obj.__wbg_ptr = ptr;
        TransactionMetadatumLabelsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionMetadatumLabelsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionmetadatumlabels_free(ptr, 0);
    }
    /**
    * @returns {TransactionMetadatumLabels}
    */
    static new() {
        const ret = wasm.transactionmetadatumlabels_new();
        return TransactionMetadatumLabels.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.transactionmetadatumlabels_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {bigint}
    */
    get(index) {
        const ret = wasm.transactionmetadatumlabels_get(this.__wbg_ptr, index);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} elem
    */
    add(elem) {
        wasm.transactionmetadatumlabels_add(this.__wbg_ptr, elem);
    }
}

const TransactionMetadatumListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionmetadatumlist_free(ptr >>> 0, 1));
/**
*/
class TransactionMetadatumList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionMetadatumList.prototype);
        obj.__wbg_ptr = ptr;
        TransactionMetadatumListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionMetadatumListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionmetadatumlist_free(ptr, 0);
    }
    /**
    * @returns {TransactionMetadatumList}
    */
    static new() {
        const ret = wasm.transactionmetadatumlist_new();
        return TransactionMetadatumList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.transactionmetadatumlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {TransactionMetadatum}
    */
    get(index) {
        const ret = wasm.transactionmetadatumlist_get(this.__wbg_ptr, index);
        return TransactionMetadatum.__wrap(ret);
    }
    /**
    * @param {TransactionMetadatum} elem
    */
    add(elem) {
        _assertClass(elem, TransactionMetadatum);
        wasm.transactionmetadatumlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const TransactionOutputFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionoutput_free(ptr >>> 0, 1));
/**
*/
class TransactionOutput {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionOutput.prototype);
        obj.__wbg_ptr = ptr;
        TransactionOutputFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionOutputFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionoutput_free(ptr, 0);
    }
    /**
    * @param {Address} address
    * @param {Value} amount
    * @param {DatumOption | undefined} [datum_option]
    * @param {Script | undefined} [script_reference]
    * @returns {TransactionOutput}
    */
    static new(address, amount, datum_option, script_reference) {
        _assertClass(address, Address);
        _assertClass(amount, Value);
        let ptr0 = 0;
        if (!isLikeNone(datum_option)) {
            _assertClass(datum_option, DatumOption);
            ptr0 = datum_option.__destroy_into_raw();
        }
        let ptr1 = 0;
        if (!isLikeNone(script_reference)) {
            _assertClass(script_reference, Script);
            ptr1 = script_reference.__destroy_into_raw();
        }
        const ret = wasm.transactionoutput_new(address.__wbg_ptr, amount.__wbg_ptr, ptr0, ptr1);
        return TransactionOutput.__wrap(ret);
    }
    /**
    * @returns {Address}
    */
    address() {
        const ret = wasm.transactionoutput_address(this.__wbg_ptr);
        return Address.__wrap(ret);
    }
    /**
    * @returns {Value}
    */
    amount() {
        const ret = wasm.transactionoutput_amount(this.__wbg_ptr);
        return Value.__wrap(ret);
    }
    /**
    * @param {Value} amount
    */
    set_amount(amount) {
        _assertClass(amount, Value);
        wasm.transactionoutput_set_amount(this.__wbg_ptr, amount.__wbg_ptr);
    }
    /**
    * @returns {DatumOption | undefined}
    */
    datum() {
        const ret = wasm.transactionoutput_datum(this.__wbg_ptr);
        return ret === 0 ? undefined : DatumOption.__wrap(ret);
    }
    /**
    * Get the datum hash from a tx output if present as a hash.
    * Returns None if there is no datum, or the datum is inlined.
    * Use TransactionOutput::datum() for inlined datums.
    * @returns {DatumHash | undefined}
    */
    datum_hash() {
        const ret = wasm.transactionoutput_datum_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : DatumHash.__wrap(ret);
    }
    /**
    * @returns {Script | undefined}
    */
    script_ref() {
        const ret = wasm.transactionoutput_script_ref(this.__wbg_ptr);
        return ret === 0 ? undefined : Script.__wrap(ret);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionoutput_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionoutput_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {TransactionOutput}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionoutput_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionOutput.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionoutput_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionoutput_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {TransactionOutput}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionoutput_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionOutput.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionoutput_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionoutput_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {TransactionOutput}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionoutput_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionOutput.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {AlonzoFormatTxOut} alonzo_format_tx_out
    * @returns {TransactionOutput}
    */
    static new_alonzo_format_tx_out(alonzo_format_tx_out) {
        _assertClass(alonzo_format_tx_out, AlonzoFormatTxOut);
        const ret = wasm.transactionoutput_new_alonzo_format_tx_out(alonzo_format_tx_out.__wbg_ptr);
        return TransactionOutput.__wrap(ret);
    }
    /**
    * @param {ConwayFormatTxOut} conway_format_tx_out
    * @returns {TransactionOutput}
    */
    static new_conway_format_tx_out(conway_format_tx_out) {
        _assertClass(conway_format_tx_out, ConwayFormatTxOut);
        const ret = wasm.transactionoutput_new_conway_format_tx_out(conway_format_tx_out.__wbg_ptr);
        return TransactionOutput.__wrap(ret);
    }
    /**
    * @returns {TransactionOutputKind}
    */
    kind() {
        const ret = wasm.transactionoutput_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {AlonzoFormatTxOut | undefined}
    */
    as_alonzo_format_tx_out() {
        const ret = wasm.transactionoutput_as_alonzo_format_tx_out(this.__wbg_ptr);
        return ret === 0 ? undefined : AlonzoFormatTxOut.__wrap(ret);
    }
    /**
    * @returns {ConwayFormatTxOut | undefined}
    */
    as_conway_format_tx_out() {
        const ret = wasm.transactionoutput_as_conway_format_tx_out(this.__wbg_ptr);
        return ret === 0 ? undefined : ConwayFormatTxOut.__wrap(ret);
    }
}

const TransactionOutputAmountBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionoutputamountbuilder_free(ptr >>> 0, 1));
/**
*/
class TransactionOutputAmountBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionOutputAmountBuilder.prototype);
        obj.__wbg_ptr = ptr;
        TransactionOutputAmountBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionOutputAmountBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionoutputamountbuilder_free(ptr, 0);
    }
    /**
    * @param {Value} amount
    * @returns {TransactionOutputAmountBuilder}
    */
    with_value(amount) {
        _assertClass(amount, Value);
        const ret = wasm.transactionoutputamountbuilder_with_value(this.__wbg_ptr, amount.__wbg_ptr);
        return TransactionOutputAmountBuilder.__wrap(ret);
    }
    /**
    * @param {MultiAsset} multiasset
    * @param {bigint} coins_per_utxo_byte
    * @returns {TransactionOutputAmountBuilder}
    */
    with_asset_and_min_required_coin(multiasset, coins_per_utxo_byte) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(multiasset, MultiAsset);
            wasm.transactionoutputamountbuilder_with_asset_and_min_required_coin(retptr, this.__wbg_ptr, multiasset.__wbg_ptr, coins_per_utxo_byte);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionOutputAmountBuilder.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {SingleOutputBuilderResult}
    */
    build() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionoutputamountbuilder_build(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return SingleOutputBuilderResult.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const TransactionOutputBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionoutputbuilder_free(ptr >>> 0, 1));
/**
* We introduce a builder-pattern format for creating transaction outputs
* This is because:
* 1. Some fields (i.e. data hash) are optional, and we can't easily expose Option<> in WASM
* 2. Some fields like amounts have many ways it could be set (some depending on other field values being known)
* 3. Easier to adapt as the output format gets more complicated in future Cardano releases
*/
class TransactionOutputBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionOutputBuilder.prototype);
        obj.__wbg_ptr = ptr;
        TransactionOutputBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionOutputBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionoutputbuilder_free(ptr, 0);
    }
    /**
    * @returns {TransactionOutputBuilder}
    */
    static new() {
        const ret = wasm.transactionoutputbuilder_new();
        return TransactionOutputBuilder.__wrap(ret);
    }
    /**
    * @param {Address} address
    * @returns {TransactionOutputBuilder}
    */
    with_address(address) {
        _assertClass(address, Address);
        const ret = wasm.transactionoutputbuilder_with_address(this.__wbg_ptr, address.__wbg_ptr);
        return TransactionOutputBuilder.__wrap(ret);
    }
    /**
    * A communication datum is one where the data hash is used in the tx output
    * Yet the full datum is included in the witness of the same transaction
    * @param {PlutusData} datum
    * @returns {TransactionOutputBuilder}
    */
    with_communication_data(datum) {
        _assertClass(datum, PlutusData);
        const ret = wasm.transactionoutputbuilder_with_communication_data(this.__wbg_ptr, datum.__wbg_ptr);
        return TransactionOutputBuilder.__wrap(ret);
    }
    /**
    * @param {DatumOption} datum
    * @returns {TransactionOutputBuilder}
    */
    with_data(datum) {
        _assertClass(datum, DatumOption);
        const ret = wasm.transactionoutputbuilder_with_data(this.__wbg_ptr, datum.__wbg_ptr);
        return TransactionOutputBuilder.__wrap(ret);
    }
    /**
    * @param {Script} script_ref
    * @returns {TransactionOutputBuilder}
    */
    with_reference_script(script_ref) {
        _assertClass(script_ref, Script);
        const ret = wasm.transactionoutputbuilder_with_reference_script(this.__wbg_ptr, script_ref.__wbg_ptr);
        return TransactionOutputBuilder.__wrap(ret);
    }
    /**
    * @returns {TransactionOutputAmountBuilder}
    */
    next() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionoutputbuilder_next(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionOutputAmountBuilder.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const TransactionOutputListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionoutputlist_free(ptr >>> 0, 1));
/**
*/
class TransactionOutputList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionOutputList.prototype);
        obj.__wbg_ptr = ptr;
        TransactionOutputListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionOutputListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionoutputlist_free(ptr, 0);
    }
    /**
    * @returns {TransactionOutputList}
    */
    static new() {
        const ret = wasm.transactionoutputlist_new();
        return TransactionOutputList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.transactionoutputlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {TransactionOutput}
    */
    get(index) {
        const ret = wasm.transactionoutputlist_get(this.__wbg_ptr, index);
        return TransactionOutput.__wrap(ret);
    }
    /**
    * @param {TransactionOutput} elem
    */
    add(elem) {
        _assertClass(elem, TransactionOutput);
        wasm.transactionoutputlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const TransactionUnspentOutputFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionunspentoutput_free(ptr >>> 0, 1));
/**
*/
class TransactionUnspentOutput {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionUnspentOutput.prototype);
        obj.__wbg_ptr = ptr;
        TransactionUnspentOutputFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionUnspentOutputFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionunspentoutput_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes.
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionunspentoutput_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {TransactionUnspentOutput}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionunspentoutput_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionUnspentOutput.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type does NOT support fine-tuned encoding options so this may or may not be
    *             * canonical CBOR and may or may not preserve round-trip encodings.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionunspentoutput_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {TransactionUnspentOutput}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionunspentoutput_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionUnspentOutput.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {TransactionInput} input
    * @param {TransactionOutput} output
    * @returns {TransactionUnspentOutput}
    */
    static new(input, output) {
        _assertClass(input, TransactionInput);
        _assertClass(output, TransactionOutput);
        const ret = wasm.transactionunspentoutput_new(input.__wbg_ptr, output.__wbg_ptr);
        return TransactionUnspentOutput.__wrap(ret);
    }
    /**
    * @returns {TransactionInput}
    */
    input() {
        const ret = wasm.transactionunspentoutput_input(this.__wbg_ptr);
        return TransactionInput.__wrap(ret);
    }
    /**
    * @returns {TransactionOutput}
    */
    output() {
        const ret = wasm.transactionunspentoutput_output(this.__wbg_ptr);
        return TransactionOutput.__wrap(ret);
    }
}

const TransactionWitnessSetFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionwitnessset_free(ptr >>> 0, 1));
/**
*/
class TransactionWitnessSet {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionWitnessSet.prototype);
        obj.__wbg_ptr = ptr;
        TransactionWitnessSetFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionWitnessSetFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionwitnessset_free(ptr, 0);
    }
    /**
    * @param {TransactionWitnessSet} other
    */
    add_all_witnesses(other) {
        _assertClass(other, TransactionWitnessSet);
        wasm.transactionwitnessset_add_all_witnesses(this.__wbg_ptr, other.__wbg_ptr);
    }
    /**
    * @returns {LanguageList}
    */
    languages() {
        const ret = wasm.transactionwitnessset_languages(this.__wbg_ptr);
        return LanguageList.__wrap(ret);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionwitnessset_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionwitnessset_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {TransactionWitnessSet}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionwitnessset_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionWitnessSet.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionwitnessset_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionwitnessset_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {TransactionWitnessSet}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionwitnessset_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionWitnessSet.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionwitnessset_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionwitnessset_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {TransactionWitnessSet}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.transactionwitnessset_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionWitnessSet.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {VkeywitnessList} vkeywitnesses
    */
    set_vkeywitnesses(vkeywitnesses) {
        _assertClass(vkeywitnesses, VkeywitnessList);
        wasm.transactionwitnessset_set_vkeywitnesses(this.__wbg_ptr, vkeywitnesses.__wbg_ptr);
    }
    /**
    * @returns {VkeywitnessList | undefined}
    */
    vkeywitnesses() {
        const ret = wasm.transactionwitnessset_vkeywitnesses(this.__wbg_ptr);
        return ret === 0 ? undefined : VkeywitnessList.__wrap(ret);
    }
    /**
    * @param {NativeScriptList} native_scripts
    */
    set_native_scripts(native_scripts) {
        _assertClass(native_scripts, NativeScriptList);
        wasm.transactionwitnessset_set_native_scripts(this.__wbg_ptr, native_scripts.__wbg_ptr);
    }
    /**
    * @returns {NativeScriptList | undefined}
    */
    native_scripts() {
        const ret = wasm.transactionwitnessset_native_scripts(this.__wbg_ptr);
        return ret === 0 ? undefined : NativeScriptList.__wrap(ret);
    }
    /**
    * @param {BootstrapWitnessList} bootstrap_witnesses
    */
    set_bootstrap_witnesses(bootstrap_witnesses) {
        _assertClass(bootstrap_witnesses, BootstrapWitnessList);
        wasm.transactionwitnessset_set_bootstrap_witnesses(this.__wbg_ptr, bootstrap_witnesses.__wbg_ptr);
    }
    /**
    * @returns {BootstrapWitnessList | undefined}
    */
    bootstrap_witnesses() {
        const ret = wasm.transactionwitnessset_bootstrap_witnesses(this.__wbg_ptr);
        return ret === 0 ? undefined : BootstrapWitnessList.__wrap(ret);
    }
    /**
    * @param {PlutusV1ScriptList} plutus_v1_scripts
    */
    set_plutus_v1_scripts(plutus_v1_scripts) {
        _assertClass(plutus_v1_scripts, PlutusV1ScriptList);
        wasm.transactionwitnessset_set_plutus_v1_scripts(this.__wbg_ptr, plutus_v1_scripts.__wbg_ptr);
    }
    /**
    * @returns {PlutusV1ScriptList | undefined}
    */
    plutus_v1_scripts() {
        const ret = wasm.transactionwitnessset_plutus_v1_scripts(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV1ScriptList.__wrap(ret);
    }
    /**
    * @param {PlutusDataList} plutus_datums
    */
    set_plutus_datums(plutus_datums) {
        _assertClass(plutus_datums, PlutusDataList);
        wasm.transactionwitnessset_set_plutus_datums(this.__wbg_ptr, plutus_datums.__wbg_ptr);
    }
    /**
    * @returns {PlutusDataList | undefined}
    */
    plutus_datums() {
        const ret = wasm.transactionwitnessset_plutus_datums(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusDataList.__wrap(ret);
    }
    /**
    * @param {Redeemers} redeemers
    */
    set_redeemers(redeemers) {
        _assertClass(redeemers, Redeemers);
        wasm.transactionwitnessset_set_redeemers(this.__wbg_ptr, redeemers.__wbg_ptr);
    }
    /**
    * @returns {Redeemers | undefined}
    */
    redeemers() {
        const ret = wasm.transactionwitnessset_redeemers(this.__wbg_ptr);
        return ret === 0 ? undefined : Redeemers.__wrap(ret);
    }
    /**
    * @param {PlutusV2ScriptList} plutus_v2_scripts
    */
    set_plutus_v2_scripts(plutus_v2_scripts) {
        _assertClass(plutus_v2_scripts, PlutusV2ScriptList);
        wasm.transactionwitnessset_set_plutus_v2_scripts(this.__wbg_ptr, plutus_v2_scripts.__wbg_ptr);
    }
    /**
    * @returns {PlutusV2ScriptList | undefined}
    */
    plutus_v2_scripts() {
        const ret = wasm.transactionwitnessset_plutus_v2_scripts(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV2ScriptList.__wrap(ret);
    }
    /**
    * @param {PlutusV3ScriptList} plutus_v3_scripts
    */
    set_plutus_v3_scripts(plutus_v3_scripts) {
        _assertClass(plutus_v3_scripts, PlutusV3ScriptList);
        wasm.transactionwitnessset_set_plutus_v3_scripts(this.__wbg_ptr, plutus_v3_scripts.__wbg_ptr);
    }
    /**
    * @returns {PlutusV3ScriptList | undefined}
    */
    plutus_v3_scripts() {
        const ret = wasm.transactionwitnessset_plutus_v3_scripts(this.__wbg_ptr);
        return ret === 0 ? undefined : PlutusV3ScriptList.__wrap(ret);
    }
    /**
    * @returns {TransactionWitnessSet}
    */
    static new() {
        const ret = wasm.transactionwitnessset_new();
        return TransactionWitnessSet.__wrap(ret);
    }
}

const TransactionWitnessSetBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionwitnesssetbuilder_free(ptr >>> 0, 1));
/**
* Builder de-duplicates witnesses as they are added
*/
class TransactionWitnessSetBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionWitnessSetBuilder.prototype);
        obj.__wbg_ptr = ptr;
        TransactionWitnessSetBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionWitnessSetBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionwitnesssetbuilder_free(ptr, 0);
    }
    /**
    * @param {Vkeywitness} vkey_witness
    */
    add_vkey(vkey_witness) {
        _assertClass(vkey_witness, Vkeywitness);
        wasm.transactionwitnesssetbuilder_add_vkey(this.__wbg_ptr, vkey_witness.__wbg_ptr);
    }
    /**
    * @param {BootstrapWitness} bootstrap
    */
    add_bootstrap(bootstrap) {
        _assertClass(bootstrap, BootstrapWitness);
        wasm.transactionwitnesssetbuilder_add_bootstrap(this.__wbg_ptr, bootstrap.__wbg_ptr);
    }
    /**
    * @param {Script} script
    */
    add_script(script) {
        _assertClass(script, Script);
        wasm.transactionwitnesssetbuilder_add_script(this.__wbg_ptr, script.__wbg_ptr);
    }
    /**
    * @returns {NativeScriptList}
    */
    get_native_script() {
        const ret = wasm.transactionwitnesssetbuilder_get_native_script(this.__wbg_ptr);
        return NativeScriptList.__wrap(ret);
    }
    /**
    * @returns {PlutusV1ScriptList}
    */
    get_plutus_v1_script() {
        const ret = wasm.transactionwitnesssetbuilder_get_plutus_v1_script(this.__wbg_ptr);
        return PlutusV1ScriptList.__wrap(ret);
    }
    /**
    * @returns {PlutusV2ScriptList}
    */
    get_plutus_v2_script() {
        const ret = wasm.transactionwitnesssetbuilder_get_plutus_v2_script(this.__wbg_ptr);
        return PlutusV2ScriptList.__wrap(ret);
    }
    /**
    * @param {PlutusData} plutus_datum
    */
    add_plutus_datum(plutus_datum) {
        _assertClass(plutus_datum, PlutusData);
        var ptr0 = plutus_datum.__destroy_into_raw();
        wasm.transactionwitnesssetbuilder_add_plutus_datum(this.__wbg_ptr, ptr0);
    }
    /**
    * @returns {PlutusDataList}
    */
    get_plutus_datum() {
        const ret = wasm.transactionwitnesssetbuilder_get_plutus_datum(this.__wbg_ptr);
        return PlutusDataList.__wrap(ret);
    }
    /**
    * @param {LegacyRedeemer} redeemer
    */
    add_redeemer(redeemer) {
        _assertClass(redeemer, LegacyRedeemer);
        wasm.transactionwitnesssetbuilder_add_redeemer(this.__wbg_ptr, redeemer.__wbg_ptr);
    }
    /**
    * @returns {LegacyRedeemerList}
    */
    get_redeemer() {
        const ret = wasm.transactionwitnesssetbuilder_get_redeemer(this.__wbg_ptr);
        return LegacyRedeemerList.__wrap(ret);
    }
    /**
    * @param {RequiredWitnessSet} required_wits
    */
    add_required_wits(required_wits) {
        _assertClass(required_wits, RequiredWitnessSet);
        wasm.transactionwitnesssetbuilder_add_required_wits(this.__wbg_ptr, required_wits.__wbg_ptr);
    }
    /**
    * @returns {TransactionWitnessSetBuilder}
    */
    static new() {
        const ret = wasm.transactionwitnesssetbuilder_new();
        return TransactionWitnessSetBuilder.__wrap(ret);
    }
    /**
    * @param {TransactionWitnessSet} wit_set
    */
    add_existing(wit_set) {
        _assertClass(wit_set, TransactionWitnessSet);
        wasm.transactionwitnesssetbuilder_add_existing(this.__wbg_ptr, wit_set.__wbg_ptr);
    }
    /**
    * @returns {TransactionWitnessSet}
    */
    build() {
        const ret = wasm.transactionwitnesssetbuilder_build(this.__wbg_ptr);
        return TransactionWitnessSet.__wrap(ret);
    }
    /**
    * @returns {RequiredWitnessSet}
    */
    remaining_wits() {
        const ret = wasm.transactionwitnesssetbuilder_remaining_wits(this.__wbg_ptr);
        return RequiredWitnessSet.__wrap(ret);
    }
    /**
    * @returns {TransactionWitnessSet}
    */
    try_build() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.transactionwitnesssetbuilder_try_build(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TransactionWitnessSet.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {RequiredWitnessSet} required_wits
    */
    merge_fake_witness(required_wits) {
        _assertClass(required_wits, RequiredWitnessSet);
        wasm.transactionwitnesssetbuilder_merge_fake_witness(this.__wbg_ptr, required_wits.__wbg_ptr);
    }
}

const TransactionWitnessSetListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_transactionwitnesssetlist_free(ptr >>> 0, 1));
/**
*/
class TransactionWitnessSetList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TransactionWitnessSetList.prototype);
        obj.__wbg_ptr = ptr;
        TransactionWitnessSetListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TransactionWitnessSetListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_transactionwitnesssetlist_free(ptr, 0);
    }
    /**
    * @returns {TransactionWitnessSetList}
    */
    static new() {
        const ret = wasm.transactionwitnesssetlist_new();
        return TransactionWitnessSetList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.transactionwitnesssetlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {TransactionWitnessSet}
    */
    get(index) {
        const ret = wasm.transactionwitnesssetlist_get(this.__wbg_ptr, index);
        return TransactionWitnessSet.__wrap(ret);
    }
    /**
    * @param {TransactionWitnessSet} elem
    */
    add(elem) {
        _assertClass(elem, TransactionWitnessSet);
        wasm.transactionwitnesssetlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const TreasuryWithdrawalsActionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_treasurywithdrawalsaction_free(ptr >>> 0, 1));
/**
*/
class TreasuryWithdrawalsAction {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TreasuryWithdrawalsAction.prototype);
        obj.__wbg_ptr = ptr;
        TreasuryWithdrawalsActionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TreasuryWithdrawalsActionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_treasurywithdrawalsaction_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.treasurywithdrawalsaction_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.treasurywithdrawalsaction_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {TreasuryWithdrawalsAction}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.treasurywithdrawalsaction_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TreasuryWithdrawalsAction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.treasurywithdrawalsaction_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.treasurywithdrawalsaction_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {TreasuryWithdrawalsAction}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.treasurywithdrawalsaction_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TreasuryWithdrawalsAction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.treasurywithdrawalsaction_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.treasurywithdrawalsaction_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {TreasuryWithdrawalsAction}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.treasurywithdrawalsaction_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return TreasuryWithdrawalsAction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {MapRewardAccountToCoin}
    */
    withdrawal() {
        const ret = wasm.treasurywithdrawalsaction_withdrawal(this.__wbg_ptr);
        return MapRewardAccountToCoin.__wrap(ret);
    }
    /**
    * @returns {ScriptHash | undefined}
    */
    policy_hash() {
        const ret = wasm.treasurywithdrawalsaction_policy_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptHash.__wrap(ret);
    }
    /**
    * @param {MapRewardAccountToCoin} withdrawal
    * @param {ScriptHash | undefined} [policy_hash]
    * @returns {TreasuryWithdrawalsAction}
    */
    static new(withdrawal, policy_hash) {
        _assertClass(withdrawal, MapRewardAccountToCoin);
        let ptr0 = 0;
        if (!isLikeNone(policy_hash)) {
            _assertClass(policy_hash, ScriptHash);
            ptr0 = policy_hash.__destroy_into_raw();
        }
        const ret = wasm.treasurywithdrawalsaction_new(withdrawal.__wbg_ptr, ptr0);
        return TreasuryWithdrawalsAction.__wrap(ret);
    }
}

const TxRedeemerBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_txredeemerbuilder_free(ptr >>> 0, 1));
/**
*/
class TxRedeemerBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TxRedeemerBuilder.prototype);
        obj.__wbg_ptr = ptr;
        TxRedeemerBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TxRedeemerBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_txredeemerbuilder_free(ptr, 0);
    }
    /**
    * Builds the transaction and moves to the next step where any real witness can be added
    * NOTE: is_valid set to true
    * Will NOT require you to have set required signers & witnesses
    * @returns {Redeemers}
    */
    build() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.txredeemerbuilder_build(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Redeemers.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * used to override the exunit values initially provided when adding inputs
    * @param {RedeemerWitnessKey} redeemer
    * @param {ExUnits} ex_units
    */
    set_exunits(redeemer, ex_units) {
        _assertClass(redeemer, RedeemerWitnessKey);
        _assertClass(ex_units, ExUnits);
        wasm.txredeemerbuilder_set_exunits(this.__wbg_ptr, redeemer.__wbg_ptr, ex_units.__wbg_ptr);
    }
    /**
    * Transaction body with a dummy values for redeemers & script_data_hash
    * Used for calculating exunits or required signers
    * @returns {TransactionBody}
    */
    draft_body() {
        const ret = wasm.txredeemerbuilder_draft_body(this.__wbg_ptr);
        return TransactionBody.__wrap(ret);
    }
    /**
    * @returns {AuxiliaryData | undefined}
    */
    auxiliary_data() {
        const ret = wasm.txredeemerbuilder_auxiliary_data(this.__wbg_ptr);
        return ret === 0 ? undefined : AuxiliaryData.__wrap(ret);
    }
    /**
    * Transaction body with a dummy values for redeemers & script_data_hash and padded with dummy witnesses
    * Used for calculating exunits
    * note: is_valid set to true
    * @returns {Transaction}
    */
    draft_tx() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.txredeemerbuilder_draft_tx(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Transaction.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const UnitIntervalFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_unitinterval_free(ptr >>> 0, 1));
/**
*/
class UnitInterval {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(UnitInterval.prototype);
        obj.__wbg_ptr = ptr;
        UnitIntervalFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        UnitIntervalFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_unitinterval_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unitinterval_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unitinterval_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {UnitInterval}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.unitinterval_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UnitInterval.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unitinterval_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unitinterval_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {UnitInterval}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.unitinterval_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UnitInterval.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unitinterval_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unitinterval_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {UnitInterval}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.unitinterval_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UnitInterval.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint}
    */
    start() {
        const ret = wasm.unitinterval_start(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {bigint}
    */
    end() {
        const ret = wasm.unitinterval_end(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} start
    * @param {bigint} end
    * @returns {UnitInterval}
    */
    static new(start, end) {
        const ret = wasm.unitinterval_new(start, end);
        return UnitInterval.__wrap(ret);
    }
}

const UnregCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_unregcert_free(ptr >>> 0, 1));
/**
*/
class UnregCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(UnregCert.prototype);
        obj.__wbg_ptr = ptr;
        UnregCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        UnregCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_unregcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unregcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unregcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {UnregCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.unregcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UnregCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unregcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unregcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {UnregCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.unregcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UnregCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unregcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unregcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {UnregCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.unregcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UnregCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    stake_credential() {
        const ret = wasm.unregcert_stake_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    deposit() {
        const ret = wasm.unregcert_deposit(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {Credential} stake_credential
    * @param {bigint} deposit
    * @returns {UnregCert}
    */
    static new(stake_credential, deposit) {
        _assertClass(stake_credential, Credential);
        const ret = wasm.unregcert_new(stake_credential.__wbg_ptr, deposit);
        return UnregCert.__wrap(ret);
    }
}

const UnregDrepCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_unregdrepcert_free(ptr >>> 0, 1));
/**
*/
class UnregDrepCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(UnregDrepCert.prototype);
        obj.__wbg_ptr = ptr;
        UnregDrepCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        UnregDrepCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_unregdrepcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unregdrepcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unregdrepcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {UnregDrepCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.unregdrepcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UnregDrepCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unregdrepcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unregdrepcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {UnregDrepCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.unregdrepcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UnregDrepCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unregdrepcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.unregdrepcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {UnregDrepCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.unregdrepcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UnregDrepCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    drep_credential() {
        const ret = wasm.unregdrepcert_drep_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    deposit() {
        const ret = wasm.unregdrepcert_deposit(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {Credential} drep_credential
    * @param {bigint} deposit
    * @returns {UnregDrepCert}
    */
    static new(drep_credential, deposit) {
        _assertClass(drep_credential, Credential);
        const ret = wasm.unregdrepcert_new(drep_credential.__wbg_ptr, deposit);
        return UnregDrepCert.__wrap(ret);
    }
}

const UntaggedRedeemerFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_untaggedredeemer_free(ptr >>> 0, 1));
/**
* Redeemer without the tag of index
* This allows builder code to return partial redeemers
* and then later have them placed in the right context
*/
class UntaggedRedeemer {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(UntaggedRedeemer.prototype);
        obj.__wbg_ptr = ptr;
        UntaggedRedeemerFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        UntaggedRedeemerFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_untaggedredeemer_free(ptr, 0);
    }
    /**
    * @param {PlutusData} data
    * @param {ExUnits} ex_units
    * @returns {UntaggedRedeemer}
    */
    static new(data, ex_units) {
        _assertClass(data, PlutusData);
        _assertClass(ex_units, ExUnits);
        const ret = wasm.untaggedredeemer_new(data.__wbg_ptr, ex_units.__wbg_ptr);
        return UntaggedRedeemer.__wrap(ret);
    }
}

const UpdateCommitteeFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_updatecommittee_free(ptr >>> 0, 1));
/**
*/
class UpdateCommittee {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(UpdateCommittee.prototype);
        obj.__wbg_ptr = ptr;
        UpdateCommitteeFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        UpdateCommitteeFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_updatecommittee_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.updatecommittee_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.updatecommittee_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {UpdateCommittee}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.updatecommittee_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UpdateCommittee.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.updatecommittee_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.updatecommittee_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {UpdateCommittee}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.updatecommittee_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UpdateCommittee.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.updatecommittee_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.updatecommittee_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {UpdateCommittee}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.updatecommittee_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UpdateCommittee.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {GovActionId | undefined}
    */
    action_id() {
        const ret = wasm.updatecommittee_action_id(this.__wbg_ptr);
        return ret === 0 ? undefined : GovActionId.__wrap(ret);
    }
    /**
    * @returns {CommitteeColdCredentialList}
    */
    cold_credentials() {
        const ret = wasm.updatecommittee_cold_credentials(this.__wbg_ptr);
        return CommitteeColdCredentialList.__wrap(ret);
    }
    /**
    * @returns {MapCommitteeColdCredentialToEpoch}
    */
    credentials() {
        const ret = wasm.updatecommittee_credentials(this.__wbg_ptr);
        return MapCommitteeColdCredentialToEpoch.__wrap(ret);
    }
    /**
    * @returns {UnitInterval}
    */
    unit_interval() {
        const ret = wasm.updatecommittee_unit_interval(this.__wbg_ptr);
        return UnitInterval.__wrap(ret);
    }
    /**
    * @param {GovActionId | undefined} action_id
    * @param {CommitteeColdCredentialList} cold_credentials
    * @param {MapCommitteeColdCredentialToEpoch} credentials
    * @param {UnitInterval} unit_interval
    * @returns {UpdateCommittee}
    */
    static new(action_id, cold_credentials, credentials, unit_interval) {
        let ptr0 = 0;
        if (!isLikeNone(action_id)) {
            _assertClass(action_id, GovActionId);
            ptr0 = action_id.__destroy_into_raw();
        }
        _assertClass(cold_credentials, CommitteeColdCredentialList);
        _assertClass(credentials, MapCommitteeColdCredentialToEpoch);
        _assertClass(unit_interval, UnitInterval);
        const ret = wasm.updatecommittee_new(ptr0, cold_credentials.__wbg_ptr, credentials.__wbg_ptr, unit_interval.__wbg_ptr);
        return UpdateCommittee.__wrap(ret);
    }
}

const UpdateDrepCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_updatedrepcert_free(ptr >>> 0, 1));
/**
*/
class UpdateDrepCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(UpdateDrepCert.prototype);
        obj.__wbg_ptr = ptr;
        UpdateDrepCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        UpdateDrepCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_updatedrepcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.updatedrepcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.updatedrepcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {UpdateDrepCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.updatedrepcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UpdateDrepCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.updatedrepcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.updatedrepcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {UpdateDrepCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.updatedrepcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UpdateDrepCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.updatedrepcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.updatedrepcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {UpdateDrepCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.updatedrepcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return UpdateDrepCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    drep_credential() {
        const ret = wasm.updatedrepcert_drep_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {Anchor | undefined}
    */
    anchor() {
        const ret = wasm.updatedrepcert_anchor(this.__wbg_ptr);
        return ret === 0 ? undefined : Anchor.__wrap(ret);
    }
    /**
    * @param {Credential} drep_credential
    * @param {Anchor | undefined} [anchor]
    * @returns {UpdateDrepCert}
    */
    static new(drep_credential, anchor) {
        _assertClass(drep_credential, Credential);
        let ptr0 = 0;
        if (!isLikeNone(anchor)) {
            _assertClass(anchor, Anchor);
            ptr0 = anchor.__destroy_into_raw();
        }
        const ret = wasm.updatedrepcert_new(drep_credential.__wbg_ptr, ptr0);
        return UpdateDrepCert.__wrap(ret);
    }
}

const UrlFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_url_free(ptr >>> 0, 1));
/**
*/
class Url {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Url.prototype);
        obj.__wbg_ptr = ptr;
        UrlFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        UrlFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_url_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.url_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.url_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Url}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.url_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Url.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.url_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.url_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Url}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.url_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Url.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.url_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.url_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Url}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.url_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Url.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    get() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.url_get(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const VRFCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_vrfcert_free(ptr >>> 0, 1));
/**
*/
class VRFCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(VRFCert.prototype);
        obj.__wbg_ptr = ptr;
        VRFCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VRFCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_vrfcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vrfcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vrfcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {VRFCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vrfcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VRFCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vrfcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vrfcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {VRFCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vrfcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VRFCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vrfcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vrfcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {VRFCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vrfcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VRFCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    output() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vrfcert_output(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    proof() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vrfcert_proof(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} output
    * @param {Uint8Array} proof
    * @returns {VRFCert}
    */
    static new(output, proof) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(output, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(proof, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.vrfcert_new(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VRFCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const VRFKeyHashFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_vrfkeyhash_free(ptr >>> 0, 1));
/**
*/
class VRFKeyHash {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(VRFKeyHash.prototype);
        obj.__wbg_ptr = ptr;
        VRFKeyHashFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VRFKeyHashFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_vrfkeyhash_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vrfkeyhash_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {VRFKeyHash}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vrfkeyhash_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VRFKeyHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vrfkeyhash_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {VRFKeyHash}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vrfkeyhash_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VRFKeyHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vrfkeyhash_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {VRFKeyHash}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vrfkeyhash_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VRFKeyHash.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const VRFVkeyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_vrfvkey_free(ptr >>> 0, 1));
/**
*/
class VRFVkey {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(VRFVkey.prototype);
        obj.__wbg_ptr = ptr;
        VRFVkeyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VRFVkeyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_vrfvkey_free(ptr, 0);
    }
    /**
    * @param {string} prefix
    * @returns {string}
    */
    to_bech32(prefix) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(prefix, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vrfvkey_to_bech32(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
    * @param {string} bech32_str
    * @returns {VRFVkey}
    */
    static from_bech32(bech32_str) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bech32_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vrfvkey_from_bech32(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VRFVkey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure
    *
    * @returns {Uint8Array}
    */
    to_raw_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vrfvkey_to_raw_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Parse from the direct raw bytes, without any CBOR structure
    *
    * @param {Uint8Array} bytes
    * @returns {VRFVkey}
    */
    static from_raw_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vrfvkey_from_raw_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VRFVkey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Direct raw bytes without any CBOR structure, as a hex-encoded string
    *
    * @returns {string}
    */
    to_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vrfvkey_to_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Parse from a hex string of the direct raw bytes, without any CBOR structure
    *
    * @param {string} input
    * @returns {VRFVkey}
    */
    static from_hex(input) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vrfvkey_from_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VRFVkey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const ValueFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_value_free(ptr >>> 0, 1));
/**
*/
class Value {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Value.prototype);
        obj.__wbg_ptr = ptr;
        ValueFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ValueFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_value_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.value_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.value_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Value}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.value_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Value.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.value_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.value_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Value}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.value_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Value.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.value_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.value_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Value}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.value_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Value.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint} coin
    * @returns {Value}
    */
    static from_coin(coin) {
        const ret = wasm.value_from_coin(coin);
        return Value.__wrap(ret);
    }
    /**
    * @param {bigint} coin
    * @param {MultiAsset} multiasset
    * @returns {Value}
    */
    static new(coin, multiasset) {
        _assertClass(multiasset, MultiAsset);
        const ret = wasm.value_new(coin, multiasset.__wbg_ptr);
        return Value.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    coin() {
        const ret = wasm.value_coin(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @returns {MultiAsset}
    */
    multi_asset() {
        const ret = wasm.value_multi_asset(this.__wbg_ptr);
        return MultiAsset.__wrap(ret);
    }
    /**
    * @returns {Value}
    */
    static zero() {
        const ret = wasm.value_zero();
        return Value.__wrap(ret);
    }
    /**
    * @returns {boolean}
    */
    is_zero() {
        const ret = wasm.value_is_zero(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @returns {boolean}
    */
    has_multiassets() {
        const ret = wasm.value_has_multiassets(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {Value} rhs
    * @returns {Value}
    */
    checked_add(rhs) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(rhs, Value);
            wasm.value_checked_add(retptr, this.__wbg_ptr, rhs.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Value.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Subtract ADA and/or assets
    * Removes an asset from the list if the result is 0 or less
    * Does not modify this object, instead the result is returned
    * None is returned if there would be integer underflow
    * @param {Value} rhs
    * @returns {Value}
    */
    checked_sub(rhs) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(rhs, Value);
            wasm.value_checked_sub(retptr, this.__wbg_ptr, rhs.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Value.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Value} rhs
    * @returns {Value}
    */
    clamped_sub(rhs) {
        _assertClass(rhs, Value);
        const ret = wasm.value_clamped_sub(this.__wbg_ptr, rhs.__wbg_ptr);
        return Value.__wrap(ret);
    }
}

const VkeywitnessFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_vkeywitness_free(ptr >>> 0, 1));
/**
*/
class Vkeywitness {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Vkeywitness.prototype);
        obj.__wbg_ptr = ptr;
        VkeywitnessFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VkeywitnessFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_vkeywitness_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vkeywitness_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vkeywitness_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Vkeywitness}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vkeywitness_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Vkeywitness.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vkeywitness_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vkeywitness_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Vkeywitness}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vkeywitness_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Vkeywitness.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vkeywitness_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.vkeywitness_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Vkeywitness}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.vkeywitness_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Vkeywitness.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {PublicKey}
    */
    vkey() {
        const ret = wasm.vkeywitness_vkey(this.__wbg_ptr);
        return PublicKey.__wrap(ret);
    }
    /**
    * @returns {Ed25519Signature}
    */
    ed25519_signature() {
        const ret = wasm.vkeywitness_ed25519_signature(this.__wbg_ptr);
        return Ed25519Signature.__wrap(ret);
    }
    /**
    * @param {PublicKey} vkey
    * @param {Ed25519Signature} ed25519_signature
    * @returns {Vkeywitness}
    */
    static new(vkey, ed25519_signature) {
        _assertClass(vkey, PublicKey);
        _assertClass(ed25519_signature, Ed25519Signature);
        const ret = wasm.vkeywitness_new(vkey.__wbg_ptr, ed25519_signature.__wbg_ptr);
        return Vkeywitness.__wrap(ret);
    }
}

const VkeywitnessListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_vkeywitnesslist_free(ptr >>> 0, 1));
/**
*/
class VkeywitnessList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(VkeywitnessList.prototype);
        obj.__wbg_ptr = ptr;
        VkeywitnessListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VkeywitnessListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_vkeywitnesslist_free(ptr, 0);
    }
    /**
    * @returns {VkeywitnessList}
    */
    static new() {
        const ret = wasm.vkeywitnesslist_new();
        return VkeywitnessList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.vkeywitnesslist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {Vkeywitness}
    */
    get(index) {
        const ret = wasm.vkeywitnesslist_get(this.__wbg_ptr, index);
        return Vkeywitness.__wrap(ret);
    }
    /**
    * @param {Vkeywitness} elem
    */
    add(elem) {
        _assertClass(elem, Vkeywitness);
        wasm.vkeywitnesslist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const VoteBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_votebuilder_free(ptr >>> 0, 1));
/**
*/
class VoteBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(VoteBuilder.prototype);
        obj.__wbg_ptr = ptr;
        VoteBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VoteBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_votebuilder_free(ptr, 0);
    }
    /**
    * @returns {VoteBuilder}
    */
    static new() {
        const ret = wasm.votebuilder_new();
        return VoteBuilder.__wrap(ret);
    }
    /**
    * @param {Voter} voter
    * @param {GovActionId} gov_action_id
    * @param {VotingProcedure} procedure
    * @returns {VoteBuilder}
    */
    with_vote(voter, gov_action_id, procedure) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(voter, Voter);
            _assertClass(gov_action_id, GovActionId);
            _assertClass(procedure, VotingProcedure);
            wasm.votebuilder_with_vote(retptr, this.__wbg_ptr, voter.__wbg_ptr, gov_action_id.__wbg_ptr, procedure.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VoteBuilder.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Voter} voter
    * @param {GovActionId} gov_action_id
    * @param {VotingProcedure} procedure
    * @param {NativeScript} native_script
    * @param {NativeScriptWitnessInfo} witness_info
    * @returns {VoteBuilder}
    */
    with_native_script_vote(voter, gov_action_id, procedure, native_script, witness_info) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(voter, Voter);
            _assertClass(gov_action_id, GovActionId);
            _assertClass(procedure, VotingProcedure);
            _assertClass(native_script, NativeScript);
            var ptr0 = native_script.__destroy_into_raw();
            _assertClass(witness_info, NativeScriptWitnessInfo);
            var ptr1 = witness_info.__destroy_into_raw();
            wasm.votebuilder_with_native_script_vote(retptr, this.__wbg_ptr, voter.__wbg_ptr, gov_action_id.__wbg_ptr, procedure.__wbg_ptr, ptr0, ptr1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VoteBuilder.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Voter} voter
    * @param {GovActionId} gov_action_id
    * @param {VotingProcedure} procedure
    * @param {PartialPlutusWitness} partial_witness
    * @param {Ed25519KeyHashList} required_signers
    * @param {PlutusData} datum
    * @returns {VoteBuilder}
    */
    with_plutus_vote(voter, gov_action_id, procedure, partial_witness, required_signers, datum) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(voter, Voter);
            _assertClass(gov_action_id, GovActionId);
            _assertClass(procedure, VotingProcedure);
            _assertClass(partial_witness, PartialPlutusWitness);
            _assertClass(required_signers, Ed25519KeyHashList);
            _assertClass(datum, PlutusData);
            wasm.votebuilder_with_plutus_vote(retptr, this.__wbg_ptr, voter.__wbg_ptr, gov_action_id.__wbg_ptr, procedure.__wbg_ptr, partial_witness.__wbg_ptr, required_signers.__wbg_ptr, datum.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VoteBuilder.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Voter} voter
    * @param {GovActionId} gov_action_id
    * @param {VotingProcedure} procedure
    * @param {PartialPlutusWitness} partial_witness
    * @param {Ed25519KeyHashList} required_signers
    * @returns {VoteBuilder}
    */
    with_plutus_vote_inline_datum(voter, gov_action_id, procedure, partial_witness, required_signers) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(voter, Voter);
            _assertClass(gov_action_id, GovActionId);
            _assertClass(procedure, VotingProcedure);
            _assertClass(partial_witness, PartialPlutusWitness);
            var ptr0 = partial_witness.__destroy_into_raw();
            _assertClass(required_signers, Ed25519KeyHashList);
            var ptr1 = required_signers.__destroy_into_raw();
            wasm.votebuilder_with_plutus_vote_inline_datum(retptr, this.__wbg_ptr, voter.__wbg_ptr, gov_action_id.__wbg_ptr, procedure.__wbg_ptr, ptr0, ptr1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VoteBuilder.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {VoteBuilderResult}
    */
    build() {
        const ret = wasm.votebuilder_build(this.__wbg_ptr);
        return VoteBuilderResult.__wrap(ret);
    }
}

const VoteBuilderResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_votebuilderresult_free(ptr >>> 0, 1));
/**
*/
class VoteBuilderResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(VoteBuilderResult.prototype);
        obj.__wbg_ptr = ptr;
        VoteBuilderResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VoteBuilderResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_votebuilderresult_free(ptr, 0);
    }
}

const VoteDelegCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_votedelegcert_free(ptr >>> 0, 1));
/**
*/
class VoteDelegCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(VoteDelegCert.prototype);
        obj.__wbg_ptr = ptr;
        VoteDelegCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VoteDelegCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_votedelegcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.votedelegcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.votedelegcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {VoteDelegCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.votedelegcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VoteDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.votedelegcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.votedelegcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {VoteDelegCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.votedelegcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VoteDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.votedelegcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.votedelegcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {VoteDelegCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.votedelegcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VoteDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    stake_credential() {
        const ret = wasm.votedelegcert_stake_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {DRep}
    */
    d_rep() {
        const ret = wasm.votedelegcert_d_rep(this.__wbg_ptr);
        return DRep.__wrap(ret);
    }
    /**
    * @param {Credential} stake_credential
    * @param {DRep} d_rep
    * @returns {VoteDelegCert}
    */
    static new(stake_credential, d_rep) {
        _assertClass(stake_credential, Credential);
        _assertClass(d_rep, DRep);
        const ret = wasm.votedelegcert_new(stake_credential.__wbg_ptr, d_rep.__wbg_ptr);
        return VoteDelegCert.__wrap(ret);
    }
}

const VoteRegDelegCertFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_voteregdelegcert_free(ptr >>> 0, 1));
/**
*/
class VoteRegDelegCert {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(VoteRegDelegCert.prototype);
        obj.__wbg_ptr = ptr;
        VoteRegDelegCertFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VoteRegDelegCertFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_voteregdelegcert_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.voteregdelegcert_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.voteregdelegcert_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {VoteRegDelegCert}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.voteregdelegcert_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VoteRegDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.voteregdelegcert_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.voteregdelegcert_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {VoteRegDelegCert}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.voteregdelegcert_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VoteRegDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.voteregdelegcert_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.voteregdelegcert_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {VoteRegDelegCert}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.voteregdelegcert_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VoteRegDelegCert.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Credential}
    */
    stake_credential() {
        const ret = wasm.voteregdelegcert_stake_credential(this.__wbg_ptr);
        return Credential.__wrap(ret);
    }
    /**
    * @returns {DRep}
    */
    d_rep() {
        const ret = wasm.voteregdelegcert_d_rep(this.__wbg_ptr);
        return DRep.__wrap(ret);
    }
    /**
    * @returns {bigint}
    */
    deposit() {
        const ret = wasm.voteregdelegcert_deposit(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {Credential} stake_credential
    * @param {DRep} d_rep
    * @param {bigint} deposit
    * @returns {VoteRegDelegCert}
    */
    static new(stake_credential, d_rep, deposit) {
        _assertClass(stake_credential, Credential);
        _assertClass(d_rep, DRep);
        const ret = wasm.voteregdelegcert_new(stake_credential.__wbg_ptr, d_rep.__wbg_ptr, deposit);
        return VoteRegDelegCert.__wrap(ret);
    }
}

const VoterFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_voter_free(ptr >>> 0, 1));
/**
*/
class Voter {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Voter.prototype);
        obj.__wbg_ptr = ptr;
        VoterFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VoterFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_voter_free(ptr, 0);
    }
    /**
    * @returns {Ed25519KeyHash | undefined}
    */
    key_hash() {
        const ret = wasm.voter_key_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : Ed25519KeyHash.__wrap(ret);
    }
    /**
    * @returns {ScriptHash | undefined}
    */
    script_hash() {
        const ret = wasm.voter_script_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptHash.__wrap(ret);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.voter_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.voter_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {Voter}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.voter_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Voter.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.voter_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.voter_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {Voter}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.voter_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Voter.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.voter_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.voter_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {Voter}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.voter_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Voter.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Ed25519KeyHash} ed25519_key_hash
    * @returns {Voter}
    */
    static new_constitutional_committee_hot_key_hash(ed25519_key_hash) {
        _assertClass(ed25519_key_hash, Ed25519KeyHash);
        const ret = wasm.voter_new_constitutional_committee_hot_key_hash(ed25519_key_hash.__wbg_ptr);
        return Voter.__wrap(ret);
    }
    /**
    * @param {ScriptHash} script_hash
    * @returns {Voter}
    */
    static new_constitutional_committee_hot_script_hash(script_hash) {
        _assertClass(script_hash, ScriptHash);
        const ret = wasm.voter_new_constitutional_committee_hot_script_hash(script_hash.__wbg_ptr);
        return Voter.__wrap(ret);
    }
    /**
    * @param {Ed25519KeyHash} ed25519_key_hash
    * @returns {Voter}
    */
    static new_d_rep_key_hash(ed25519_key_hash) {
        _assertClass(ed25519_key_hash, Ed25519KeyHash);
        const ret = wasm.voter_new_d_rep_key_hash(ed25519_key_hash.__wbg_ptr);
        return Voter.__wrap(ret);
    }
    /**
    * @param {ScriptHash} script_hash
    * @returns {Voter}
    */
    static new_d_rep_script_hash(script_hash) {
        _assertClass(script_hash, ScriptHash);
        const ret = wasm.voter_new_d_rep_script_hash(script_hash.__wbg_ptr);
        return Voter.__wrap(ret);
    }
    /**
    * @param {Ed25519KeyHash} ed25519_key_hash
    * @returns {Voter}
    */
    static new_staking_pool_key_hash(ed25519_key_hash) {
        _assertClass(ed25519_key_hash, Ed25519KeyHash);
        const ret = wasm.voter_new_staking_pool_key_hash(ed25519_key_hash.__wbg_ptr);
        return Voter.__wrap(ret);
    }
    /**
    * @returns {VoterKind}
    */
    kind() {
        const ret = wasm.voter_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Ed25519KeyHash | undefined}
    */
    as_constitutional_committee_hot_key_hash() {
        const ret = wasm.voter_as_constitutional_committee_hot_key_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : Ed25519KeyHash.__wrap(ret);
    }
    /**
    * @returns {ScriptHash | undefined}
    */
    as_constitutional_committee_hot_script_hash() {
        const ret = wasm.voter_as_constitutional_committee_hot_script_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptHash.__wrap(ret);
    }
    /**
    * @returns {Ed25519KeyHash | undefined}
    */
    as_d_rep_key_hash() {
        const ret = wasm.voter_as_d_rep_key_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : Ed25519KeyHash.__wrap(ret);
    }
    /**
    * @returns {ScriptHash | undefined}
    */
    as_d_rep_script_hash() {
        const ret = wasm.voter_as_d_rep_script_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : ScriptHash.__wrap(ret);
    }
    /**
    * @returns {Ed25519KeyHash | undefined}
    */
    as_staking_pool_key_hash() {
        const ret = wasm.voter_as_staking_pool_key_hash(this.__wbg_ptr);
        return ret === 0 ? undefined : Ed25519KeyHash.__wrap(ret);
    }
}

const VoterListFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_voterlist_free(ptr >>> 0, 1));
/**
*/
class VoterList {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(VoterList.prototype);
        obj.__wbg_ptr = ptr;
        VoterListFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VoterListFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_voterlist_free(ptr, 0);
    }
    /**
    * @returns {VoterList}
    */
    static new() {
        const ret = wasm.voterlist_new();
        return VoterList.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.voterlist_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {Voter}
    */
    get(index) {
        const ret = wasm.voterlist_get(this.__wbg_ptr, index);
        return Voter.__wrap(ret);
    }
    /**
    * @param {Voter} elem
    */
    add(elem) {
        _assertClass(elem, Voter);
        wasm.voterlist_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const VotingProcedureFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_votingprocedure_free(ptr >>> 0, 1));
/**
*/
class VotingProcedure {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(VotingProcedure.prototype);
        obj.__wbg_ptr = ptr;
        VotingProcedureFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VotingProcedureFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_votingprocedure_free(ptr, 0);
    }
    /**
    *
    *             * Serialize this type to CBOR bytes
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {Uint8Array}
    */
    to_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.votingprocedure_to_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings
    *
    * @returns {Uint8Array}
    */
    to_canonical_cbor_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.votingprocedure_to_canonical_cbor_bytes(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Create this type from CBOR bytes
    *
    * @param {Uint8Array} cbor_bytes
    * @returns {VotingProcedure}
    */
    static from_cbor_bytes(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(cbor_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.votingprocedure_from_cbor_bytes(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VotingProcedure.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes encoded as a hex string (useful for working with CIP30).
    *             * This type type supports encoding preservation so this will preserve round-trip CBOR formats.
    *             * If created from scratch the CBOR will be canonical.
    *
    * @returns {string}
    */
    to_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.votingprocedure_to_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Serialize this type to CBOR bytes using canonical CBOR encodings as hex bytes
    *
    * @returns {string}
    */
    to_canonical_cbor_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.votingprocedure_to_canonical_cbor_hex(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    *
    *             * Create this type from the CBOR bytes encoded as a hex string.
    *             * This is useful for interfacing with CIP30
    *
    * @param {string} cbor_bytes
    * @returns {VotingProcedure}
    */
    static from_cbor_hex(cbor_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(cbor_bytes, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.votingprocedure_from_cbor_hex(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VotingProcedure.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_json() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.votingprocedure_to_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
    * @returns {any}
    */
    to_js_value() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.votingprocedure_to_js_value(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} json
    * @returns {VotingProcedure}
    */
    static from_json(json) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.votingprocedure_from_json(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return VotingProcedure.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Vote}
    */
    vote() {
        const ret = wasm.votingprocedure_vote(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Anchor | undefined}
    */
    anchor() {
        const ret = wasm.votingprocedure_anchor(this.__wbg_ptr);
        return ret === 0 ? undefined : Anchor.__wrap(ret);
    }
    /**
    * @param {Vote} vote
    * @param {Anchor | undefined} [anchor]
    * @returns {VotingProcedure}
    */
    static new(vote, anchor) {
        let ptr0 = 0;
        if (!isLikeNone(anchor)) {
            _assertClass(anchor, Anchor);
            ptr0 = anchor.__destroy_into_raw();
        }
        const ret = wasm.votingprocedure_new(vote, ptr0);
        return VotingProcedure.__wrap(ret);
    }
}

const VotingProceduresFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_votingprocedures_free(ptr >>> 0, 1));
/**
*/
class VotingProcedures {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(VotingProcedures.prototype);
        obj.__wbg_ptr = ptr;
        VotingProceduresFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VotingProceduresFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_votingprocedures_free(ptr, 0);
    }
    /**
    * @returns {VotingProcedures}
    */
    static new() {
        const ret = wasm.votingprocedures_new();
        return VotingProcedures.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.votingprocedures_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {Voter} key
    * @param {MapGovActionIdToVotingProcedure} value
    * @returns {MapGovActionIdToVotingProcedure | undefined}
    */
    insert(key, value) {
        _assertClass(key, Voter);
        _assertClass(value, MapGovActionIdToVotingProcedure);
        const ret = wasm.votingprocedures_insert(this.__wbg_ptr, key.__wbg_ptr, value.__wbg_ptr);
        return ret === 0 ? undefined : MapGovActionIdToVotingProcedure.__wrap(ret);
    }
    /**
    * @param {Voter} key
    * @returns {MapGovActionIdToVotingProcedure | undefined}
    */
    get(key) {
        _assertClass(key, Voter);
        const ret = wasm.votingprocedures_get(this.__wbg_ptr, key.__wbg_ptr);
        return ret === 0 ? undefined : MapGovActionIdToVotingProcedure.__wrap(ret);
    }
    /**
    * @returns {VoterList}
    */
    keys() {
        const ret = wasm.votingprocedures_keys(this.__wbg_ptr);
        return VoterList.__wrap(ret);
    }
}

const WithdrawalBuilderResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_withdrawalbuilderresult_free(ptr >>> 0, 1));
/**
*/
class WithdrawalBuilderResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WithdrawalBuilderResult.prototype);
        obj.__wbg_ptr = ptr;
        WithdrawalBuilderResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WithdrawalBuilderResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_withdrawalbuilderresult_free(ptr, 0);
    }
}

function __wbindgen_is_object(arg0) {
    const val = getObject(arg0);
    const ret = typeof(val) === 'object' && val !== null;
    return ret;
};

function __wbindgen_string_new(arg0, arg1) {
    const ret = getStringFromWasm0(arg0, arg1);
    return addHeapObject(ret);
};

function __wbindgen_object_drop_ref(arg0) {
    takeObject(arg0);
};

function __wbindgen_throw(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
};

function __wbindgen_memory() {
    const ret = wasm.memory;
    return addHeapObject(ret);
};

function __wbindgen_is_function(arg0) {
    const ret = typeof(getObject(arg0)) === 'function';
    return ret;
};

function __wbindgen_is_string(arg0) {
    const ret = typeof(getObject(arg0)) === 'string';
    return ret;
};

function __wbindgen_object_clone_ref(arg0) {
    const ret = getObject(arg0);
    return addHeapObject(ret);
};

function __wbg_buffer_b7b08af79b0b0974(arg0) {
    const ret = getObject(arg0).buffer;
    return addHeapObject(ret);
};

function __wbg_new_a220cf903aa02ca2() {
    const ret = new Array();
    return addHeapObject(ret);
};

function __wbindgen_number_new(arg0) {
    const ret = arg0;
    return addHeapObject(ret);
};

function __wbg_newnoargs_76313bd6ff35d0f2(arg0, arg1) {
    const ret = new Function(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
};

function __wbg_new_8608a2b51a5f6737() {
    const ret = new Map();
    return addHeapObject(ret);
};

function __wbg_new_525245e2b9901204() {
    const ret = new Object();
    return addHeapObject(ret);
};

function __wbg_self_3093d5d1f7bcb682() { return handleError(function () {
    const ret = self.self;
    return addHeapObject(ret);
}, arguments) };

function __wbg_window_3bcfc4d31bc012f8() { return handleError(function () {
    const ret = window.window;
    return addHeapObject(ret);
}, arguments) };

function __wbg_globalThis_86b222e13bdf32ed() { return handleError(function () {
    const ret = globalThis.globalThis;
    return addHeapObject(ret);
}, arguments) };

function __wbg_global_e5a3fe56f8be9485() { return handleError(function () {
    const ret = __webpack_require__.g.global;
    return addHeapObject(ret);
}, arguments) };

function __wbindgen_is_undefined(arg0) {
    const ret = getObject(arg0) === undefined;
    return ret;
};

function __wbg_set_673dda6c73d19609(arg0, arg1, arg2) {
    getObject(arg0)[arg1 >>> 0] = takeObject(arg2);
};

function __wbg_call_1084a111329e68ce() { return handleError(function (arg0, arg1) {
    const ret = getObject(arg0).call(getObject(arg1));
    return addHeapObject(ret);
}, arguments) };

function __wbg_call_89af060b4e1523f2() { return handleError(function (arg0, arg1, arg2) {
    const ret = getObject(arg0).call(getObject(arg1), getObject(arg2));
    return addHeapObject(ret);
}, arguments) };

function __wbg_set_49185437f0ab06f8(arg0, arg1, arg2) {
    const ret = getObject(arg0).set(getObject(arg1), getObject(arg2));
    return addHeapObject(ret);
};

function __wbg_newwithbyteoffsetandlength_8a2cb9ca96b27ec9(arg0, arg1, arg2) {
    const ret = new Uint8Array(getObject(arg0), arg1 >>> 0, arg2 >>> 0);
    return addHeapObject(ret);
};

function __wbg_new_ea1883e1e5e86686(arg0) {
    const ret = new Uint8Array(getObject(arg0));
    return addHeapObject(ret);
};

function __wbg_newwithlength_ec548f448387c968(arg0) {
    const ret = new Uint8Array(arg0 >>> 0);
    return addHeapObject(ret);
};

function __wbg_subarray_7c2e3576afe181d1(arg0, arg1, arg2) {
    const ret = getObject(arg0).subarray(arg1 >>> 0, arg2 >>> 0);
    return addHeapObject(ret);
};

function __wbg_set_d1e79e2388520f18(arg0, arg1, arg2) {
    getObject(arg0).set(getObject(arg1), arg2 >>> 0);
};

function __wbg_crypto_1d1f22824a6a080c(arg0) {
    const ret = getObject(arg0).crypto;
    return addHeapObject(ret);
};

function __wbg_process_4a72847cc503995b(arg0) {
    const ret = getObject(arg0).process;
    return addHeapObject(ret);
};

function __wbg_versions_f686565e586dd935(arg0) {
    const ret = getObject(arg0).versions;
    return addHeapObject(ret);
};

function __wbg_node_104a2ff8d6ea03a2(arg0) {
    const ret = getObject(arg0).node;
    return addHeapObject(ret);
};

function __wbg_require_cca90b1a94a0255b() { return handleError(function () {
    const ret = module.require;
    return addHeapObject(ret);
}, arguments) };

function __wbg_msCrypto_eb05e62b530a1508(arg0) {
    const ret = getObject(arg0).msCrypto;
    return addHeapObject(ret);
};

function __wbg_randomFillSync_5c9c955aa56b6049() { return handleError(function (arg0, arg1) {
    getObject(arg0).randomFillSync(takeObject(arg1));
}, arguments) };

function __wbg_getRandomValues_3aa56aa6edec874c() { return handleError(function (arg0, arg1) {
    getObject(arg0).getRandomValues(getObject(arg1));
}, arguments) };

function __wbg_String_91fba7ded13ba54c(arg0, arg1) {
    const ret = String(getObject(arg1));
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

function __wbindgen_error_new(arg0, arg1) {
    const ret = new Error(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
};

function __wbindgen_bigint_from_i64(arg0) {
    const ret = arg0;
    return addHeapObject(ret);
};

function __wbindgen_bigint_from_u64(arg0) {
    const ret = BigInt.asUintN(64, arg0);
    return addHeapObject(ret);
};

function __wbg_set_20cbc34131e76824(arg0, arg1, arg2) {
    getObject(arg0)[takeObject(arg1)] = takeObject(arg2);
};



/***/ }),

/***/ 85573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* reexport safe */ _cardano_message_signing_bg_js__WEBPACK_IMPORTED_MODULE_0__.BF; },
/* harmony export */   "DZ": function() { return /* reexport safe */ _cardano_message_signing_bg_js__WEBPACK_IMPORTED_MODULE_0__.DZ; },
/* harmony export */   "J7": function() { return /* reexport safe */ _cardano_message_signing_bg_js__WEBPACK_IMPORTED_MODULE_0__.J7; },
/* harmony export */   "Jz": function() { return /* reexport safe */ _cardano_message_signing_bg_js__WEBPACK_IMPORTED_MODULE_0__.Jz; },
/* harmony export */   "PM": function() { return /* reexport safe */ _cardano_message_signing_bg_js__WEBPACK_IMPORTED_MODULE_0__.PM; },
/* harmony export */   "UP": function() { return /* reexport safe */ _cardano_message_signing_bg_js__WEBPACK_IMPORTED_MODULE_0__.UP; },
/* harmony export */   "VU": function() { return /* reexport safe */ _cardano_message_signing_bg_js__WEBPACK_IMPORTED_MODULE_0__.VU; },
/* harmony export */   "Wb": function() { return /* reexport safe */ _cardano_message_signing_bg_js__WEBPACK_IMPORTED_MODULE_0__.Wb; },
/* harmony export */   "Yh": function() { return /* reexport safe */ _cardano_message_signing_bg_js__WEBPACK_IMPORTED_MODULE_0__.Yh; },
/* harmony export */   "__": function() { return /* reexport safe */ _cardano_message_signing_bg_js__WEBPACK_IMPORTED_MODULE_0__.__; },
/* harmony export */   "f3": function() { return /* reexport safe */ _cardano_message_signing_bg_js__WEBPACK_IMPORTED_MODULE_0__.f3; }
/* harmony export */ });
/* harmony import */ var _cardano_message_signing_bg_wasm__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86789);
/* harmony import */ var _cardano_message_signing_bg_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78263);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_cardano_message_signing_bg_wasm__WEBPACK_IMPORTED_MODULE_1__]);
_cardano_message_signing_bg_wasm__WEBPACK_IMPORTED_MODULE_1__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];


(0,_cardano_message_signing_bg_js__WEBPACK_IMPORTED_MODULE_0__/* .__wbg_set_wasm */ .oT)(_cardano_message_signing_bg_wasm__WEBPACK_IMPORTED_MODULE_1__);


__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 78263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ HeaderMap; },
/* harmony export */   "DZ": function() { return /* binding */ COSESign1Builder; },
/* harmony export */   "J7": function() { return /* binding */ Int; },
/* harmony export */   "Jz": function() { return /* binding */ CBORValue; },
/* harmony export */   "Or": function() { return /* binding */ __wbindgen_throw; },
/* harmony export */   "PM": function() { return /* binding */ Headers; },
/* harmony export */   "UP": function() { return /* binding */ ProtectedHeaderMap; },
/* harmony export */   "VU": function() { return /* binding */ COSEKey; },
/* harmony export */   "Wb": function() { return /* binding */ BigNum; },
/* harmony export */   "Yh": function() { return /* binding */ KeyType; },
/* harmony export */   "__": function() { return /* binding */ Label; },
/* harmony export */   "f3": function() { return /* binding */ AlgorithmId; },
/* harmony export */   "fY": function() { return /* binding */ __wbindgen_debug_string; },
/* harmony export */   "h4": function() { return /* binding */ __wbindgen_string_new; },
/* harmony export */   "oT": function() { return /* binding */ __wbg_set_wasm; },
/* harmony export */   "ug": function() { return /* binding */ __wbindgen_object_drop_ref; }
/* harmony export */ });
/* unused harmony exports LabelKind, CBORSpecialType, ECKey, KeyOperation, SigContext, SignedMessageKind, CBORValueKind, CurveType, CBORArray, CBORObject, CBORSpecial, COSEEncrypt, COSEEncrypt0, COSERecipient, COSERecipients, COSESign, COSESign1, COSESignBuilder, COSESignature, COSESignatures, CounterSignature, EdDSA25519Key, Labels, PasswordEncryption, PubKeyEncryption, SigStructure, SignedMessage, TaggedCBOR */
/* module decorator */ module = __webpack_require__.hmd(module);
let wasm;
function __wbg_set_wasm(val) {
    wasm = val;
}


const heap = new Array(128).fill(undefined);

heap.push(undefined, null, true, false);

function getObject(idx) { return heap[idx]; }

let heap_next = heap.length;

function dropObject(idx) {
    if (idx < 132) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

const lTextDecoder = typeof TextDecoder === 'undefined' ? (0, module.require)('util').TextDecoder : TextDecoder;

let cachedTextDecoder = new lTextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachedUint8Memory0 = null;

function getUint8Memory0() {
    if (cachedUint8Memory0 === null || cachedUint8Memory0.byteLength === 0) {
        cachedUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8Memory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

let WASM_VECTOR_LEN = 0;

const lTextEncoder = typeof TextEncoder === 'undefined' ? (0, module.require)('util').TextEncoder : TextEncoder;

let cachedTextEncoder = new lTextEncoder('utf-8');

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8Memory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8Memory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8Memory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachedInt32Memory0 = null;

function getInt32Memory0() {
    if (cachedInt32Memory0 === null || cachedInt32Memory0.byteLength === 0) {
        cachedInt32Memory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachedInt32Memory0;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8Memory0().subarray(ptr / 1, ptr / 1 + len);
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8Memory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
    return instance.ptr;
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

let cachedFloat64Memory0 = null;

function getFloat64Memory0() {
    if (cachedFloat64Memory0 === null || cachedFloat64Memory0.byteLength === 0) {
        cachedFloat64Memory0 = new Float64Array(wasm.memory.buffer);
    }
    return cachedFloat64Memory0;
}
/**
*/
const AlgorithmId = Object.freeze({
/**
*r" EdDSA (Pure EdDSA, not HashedEdDSA) - the algorithm used for Cardano addresses
*/
EdDSA:0,"0":"EdDSA",
/**
*r" ChaCha20/Poly1305 w/ 256-bit key, 128-bit tag
*/
ChaCha20Poly1305:1,"1":"ChaCha20Poly1305", });
/**
*/
const LabelKind = Object.freeze({ Int:0,"0":"Int",Text:1,"1":"Text", });
/**
*/
const CBORSpecialType = Object.freeze({ Bool:0,"0":"Bool",Float:1,"1":"Float",Unassigned:2,"2":"Unassigned",Break:3,"3":"Break",Undefined:4,"4":"Undefined",Null:5,"5":"Null", });
/**
*/
const ECKey = Object.freeze({ CRV:0,"0":"CRV",X:1,"1":"X",Y:2,"2":"Y",D:3,"3":"D", });
/**
*/
const KeyOperation = Object.freeze({ Sign:0,"0":"Sign",Verify:1,"1":"Verify",Encrypt:2,"2":"Encrypt",Decrypt:3,"3":"Decrypt",WrapKey:4,"4":"WrapKey",UnwrapKey:5,"5":"UnwrapKey",DeriveKey:6,"6":"DeriveKey",DeriveBits:7,"7":"DeriveBits", });
/**
*/
const KeyType = Object.freeze({
/**
*r" octet key pair
*/
OKP:0,"0":"OKP",
/**
*r" 2-coord EC
*/
EC2:1,"1":"EC2",Symmetric:2,"2":"Symmetric", });
/**
*/
const SigContext = Object.freeze({ Signature:0,"0":"Signature",Signature1:1,"1":"Signature1",CounterSignature:2,"2":"CounterSignature", });
/**
*/
const SignedMessageKind = Object.freeze({ COSESIGN:0,"0":"COSESIGN",COSESIGN1:1,"1":"COSESIGN1", });
/**
*/
const CBORValueKind = Object.freeze({ Int:0,"0":"Int",Bytes:1,"1":"Bytes",Text:2,"2":"Text",Array:3,"3":"Array",Object:4,"4":"Object",TaggedCBOR:5,"5":"TaggedCBOR",Special:6,"6":"Special", });
/**
*/
const CurveType = Object.freeze({ P256:0,"0":"P256",P384:1,"1":"P384",P521:2,"2":"P521",X25519:3,"3":"X25519",X448:4,"4":"X448",Ed25519:5,"5":"Ed25519",Ed448:6,"6":"Ed448", });

const BigNumFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_bignum_free(ptr >>> 0));
/**
*/
class BigNum {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(BigNum.prototype);
        obj.__wbg_ptr = ptr;
        BigNumFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BigNumFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_bignum_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bignum_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {BigNum}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.bignum_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return BigNum.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} string
    * @returns {BigNum}
    */
    static from_str(string) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.bignum_from_str(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return BigNum.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_str() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.bignum_to_str(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @param {BigNum} other
    * @returns {BigNum}
    */
    checked_mul(other) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(other, BigNum);
            wasm.bignum_checked_mul(retptr, this.__wbg_ptr, other.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return BigNum.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {BigNum} other
    * @returns {BigNum}
    */
    checked_add(other) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(other, BigNum);
            wasm.bignum_checked_add(retptr, this.__wbg_ptr, other.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return BigNum.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {BigNum} other
    * @returns {BigNum}
    */
    checked_sub(other) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(other, BigNum);
            wasm.bignum_checked_sub(retptr, this.__wbg_ptr, other.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return BigNum.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const CBORArrayFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cborarray_free(ptr >>> 0));
/**
*/
class CBORArray {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CBORArray.prototype);
        obj.__wbg_ptr = ptr;
        CBORArrayFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CBORArrayFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cborarray_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cborarray_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {CBORArray}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cborarray_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return CBORArray.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {CBORArray}
    */
    static new() {
        const ret = wasm.cborarray_new();
        return CBORArray.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.cborarray_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {CBORValue}
    */
    get(index) {
        const ret = wasm.cborarray_get(this.__wbg_ptr, index);
        return CBORValue.__wrap(ret);
    }
    /**
    * @param {CBORValue} elem
    */
    add(elem) {
        _assertClass(elem, CBORValue);
        wasm.cborarray_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
    /**
    * @param {boolean} use_definite
    */
    set_definite_encoding(use_definite) {
        wasm.cborarray_set_definite_encoding(this.__wbg_ptr, use_definite);
    }
    /**
    * @returns {boolean}
    */
    is_definite() {
        const ret = wasm.cborarray_is_definite(this.__wbg_ptr);
        return ret !== 0;
    }
}

const CBORObjectFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cborobject_free(ptr >>> 0));
/**
*/
class CBORObject {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CBORObject.prototype);
        obj.__wbg_ptr = ptr;
        CBORObjectFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CBORObjectFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cborobject_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cborobject_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {CBORObject}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cborobject_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return CBORObject.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {CBORObject}
    */
    static new() {
        const ret = wasm.cborobject_new();
        return CBORObject.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.cborobject_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {CBORValue} key
    * @param {CBORValue} value
    * @returns {CBORValue | undefined}
    */
    insert(key, value) {
        _assertClass(key, CBORValue);
        _assertClass(value, CBORValue);
        const ret = wasm.cborobject_insert(this.__wbg_ptr, key.__wbg_ptr, value.__wbg_ptr);
        return ret === 0 ? undefined : CBORValue.__wrap(ret);
    }
    /**
    * @param {CBORValue} key
    * @returns {CBORValue | undefined}
    */
    get(key) {
        _assertClass(key, CBORValue);
        const ret = wasm.cborobject_get(this.__wbg_ptr, key.__wbg_ptr);
        return ret === 0 ? undefined : CBORValue.__wrap(ret);
    }
    /**
    * @returns {CBORArray}
    */
    keys() {
        const ret = wasm.cborobject_keys(this.__wbg_ptr);
        return CBORArray.__wrap(ret);
    }
    /**
    * @param {boolean} use_definite
    */
    set_definite_encoding(use_definite) {
        wasm.cborobject_set_definite_encoding(this.__wbg_ptr, use_definite);
    }
    /**
    * @returns {boolean}
    */
    is_definite() {
        const ret = wasm.cborobject_is_definite(this.__wbg_ptr);
        return ret !== 0;
    }
}

const CBORSpecialFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cborspecial_free(ptr >>> 0));
/**
*/
class CBORSpecial {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CBORSpecial.prototype);
        obj.__wbg_ptr = ptr;
        CBORSpecialFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CBORSpecialFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cborspecial_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cborspecial_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {CBORSpecial}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cborspecial_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return CBORSpecial.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {boolean} b
    * @returns {CBORSpecial}
    */
    static new_bool(b) {
        const ret = wasm.cborspecial_new_bool(b);
        return CBORSpecial.__wrap(ret);
    }
    /**
    * @param {number} u
    * @returns {CBORSpecial}
    */
    static new_unassigned(u) {
        const ret = wasm.cborspecial_new_unassigned(u);
        return CBORSpecial.__wrap(ret);
    }
    /**
    * @returns {CBORSpecial}
    */
    static new_break() {
        const ret = wasm.cborspecial_new_break();
        return CBORSpecial.__wrap(ret);
    }
    /**
    * @returns {CBORSpecial}
    */
    static new_null() {
        const ret = wasm.cborspecial_new_null();
        return CBORSpecial.__wrap(ret);
    }
    /**
    * @returns {CBORSpecial}
    */
    static new_undefined() {
        const ret = wasm.cborspecial_new_undefined();
        return CBORSpecial.__wrap(ret);
    }
    /**
    * @returns {CBORSpecialType}
    */
    kind() {
        const ret = wasm.cborspecial_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {boolean | undefined}
    */
    as_bool() {
        const ret = wasm.cborspecial_as_bool(this.__wbg_ptr);
        return ret === 0xFFFFFF ? undefined : ret !== 0;
    }
    /**
    * @returns {number | undefined}
    */
    as_float() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cborspecial_as_float(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r2 = getFloat64Memory0()[retptr / 8 + 1];
            return r0 === 0 ? undefined : r2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {number | undefined}
    */
    as_unassigned() {
        const ret = wasm.cborspecial_as_unassigned(this.__wbg_ptr);
        return ret === 0xFFFFFF ? undefined : ret;
    }
}

const CBORValueFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cborvalue_free(ptr >>> 0));
/**
*/
class CBORValue {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CBORValue.prototype);
        obj.__wbg_ptr = ptr;
        CBORValueFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CBORValueFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cborvalue_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cborvalue_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {CBORValue}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cborvalue_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return CBORValue.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Int} int
    * @returns {CBORValue}
    */
    static new_int(int) {
        _assertClass(int, Int);
        const ret = wasm.cborvalue_new_int(int.__wbg_ptr);
        return CBORValue.__wrap(ret);
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {CBORValue}
    */
    static new_bytes(bytes) {
        const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.cborvalue_new_bytes(ptr0, len0);
        return CBORValue.__wrap(ret);
    }
    /**
    * @param {string} text
    * @returns {CBORValue}
    */
    static new_text(text) {
        const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.cborvalue_new_text(ptr0, len0);
        return CBORValue.__wrap(ret);
    }
    /**
    * @param {CBORArray} arr
    * @returns {CBORValue}
    */
    static new_array(arr) {
        _assertClass(arr, CBORArray);
        const ret = wasm.cborvalue_new_array(arr.__wbg_ptr);
        return CBORValue.__wrap(ret);
    }
    /**
    * @param {CBORObject} obj
    * @returns {CBORValue}
    */
    static new_object(obj) {
        _assertClass(obj, CBORObject);
        const ret = wasm.cborvalue_new_object(obj.__wbg_ptr);
        return CBORValue.__wrap(ret);
    }
    /**
    * @param {TaggedCBOR} tagged
    * @returns {CBORValue}
    */
    static new_tagged(tagged) {
        _assertClass(tagged, TaggedCBOR);
        const ret = wasm.cborvalue_new_tagged(tagged.__wbg_ptr);
        return CBORValue.__wrap(ret);
    }
    /**
    * @param {CBORSpecial} special
    * @returns {CBORValue}
    */
    static new_special(special) {
        _assertClass(special, CBORSpecial);
        const ret = wasm.cborvalue_new_special(special.__wbg_ptr);
        return CBORValue.__wrap(ret);
    }
    /**
    * @param {Label} label
    * @returns {CBORValue}
    */
    static from_label(label) {
        _assertClass(label, Label);
        const ret = wasm.cborvalue_from_label(label.__wbg_ptr);
        return CBORValue.__wrap(ret);
    }
    /**
    * @returns {CBORValueKind}
    */
    kind() {
        const ret = wasm.cborvalue_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Int | undefined}
    */
    as_int() {
        const ret = wasm.cborvalue_as_int(this.__wbg_ptr);
        return ret === 0 ? undefined : Int.__wrap(ret);
    }
    /**
    * @returns {Uint8Array | undefined}
    */
    as_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cborvalue_as_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    as_text() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cborvalue_as_text(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {CBORArray | undefined}
    */
    as_array() {
        const ret = wasm.cborvalue_as_array(this.__wbg_ptr);
        return ret === 0 ? undefined : CBORArray.__wrap(ret);
    }
    /**
    * @returns {CBORObject | undefined}
    */
    as_object() {
        const ret = wasm.cborvalue_as_object(this.__wbg_ptr);
        return ret === 0 ? undefined : CBORObject.__wrap(ret);
    }
    /**
    * @returns {TaggedCBOR | undefined}
    */
    as_tagged() {
        const ret = wasm.cborvalue_as_tagged(this.__wbg_ptr);
        return ret === 0 ? undefined : TaggedCBOR.__wrap(ret);
    }
    /**
    * @returns {CBORSpecial | undefined}
    */
    as_special() {
        const ret = wasm.cborvalue_as_special(this.__wbg_ptr);
        return ret === 0 ? undefined : CBORSpecial.__wrap(ret);
    }
}

const COSEEncryptFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_coseencrypt_free(ptr >>> 0));
/**
*/
class COSEEncrypt {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(COSEEncrypt.prototype);
        obj.__wbg_ptr = ptr;
        COSEEncryptFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        COSEEncryptFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_coseencrypt_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.coseencrypt_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {COSEEncrypt}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.coseencrypt_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return COSEEncrypt.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Headers}
    */
    headers() {
        const ret = wasm.coseencrypt0_headers(this.__wbg_ptr);
        return Headers.__wrap(ret);
    }
    /**
    * @returns {Uint8Array | undefined}
    */
    ciphertext() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.coseencrypt_ciphertext(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {COSERecipients}
    */
    recipients() {
        const ret = wasm.coseencrypt_recipients(this.__wbg_ptr);
        return COSERecipients.__wrap(ret);
    }
    /**
    * @param {Headers} headers
    * @param {Uint8Array | undefined} ciphertext
    * @param {COSERecipients} recipients
    * @returns {COSEEncrypt}
    */
    static new(headers, ciphertext, recipients) {
        _assertClass(headers, Headers);
        var ptr0 = isLikeNone(ciphertext) ? 0 : passArray8ToWasm0(ciphertext, wasm.__wbindgen_malloc);
        var len0 = WASM_VECTOR_LEN;
        _assertClass(recipients, COSERecipients);
        const ret = wasm.coseencrypt_new(headers.__wbg_ptr, ptr0, len0, recipients.__wbg_ptr);
        return COSEEncrypt.__wrap(ret);
    }
}

const COSEEncrypt0Finalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_coseencrypt0_free(ptr >>> 0));
/**
*/
class COSEEncrypt0 {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(COSEEncrypt0.prototype);
        obj.__wbg_ptr = ptr;
        COSEEncrypt0Finalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        COSEEncrypt0Finalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_coseencrypt0_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.coseencrypt0_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {COSEEncrypt0}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.coseencrypt0_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return COSEEncrypt0.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Headers}
    */
    headers() {
        const ret = wasm.coseencrypt0_headers(this.__wbg_ptr);
        return Headers.__wrap(ret);
    }
    /**
    * @returns {Uint8Array | undefined}
    */
    ciphertext() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.coseencrypt0_ciphertext(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Headers} headers
    * @param {Uint8Array | undefined} [ciphertext]
    * @returns {COSEEncrypt0}
    */
    static new(headers, ciphertext) {
        _assertClass(headers, Headers);
        var ptr0 = isLikeNone(ciphertext) ? 0 : passArray8ToWasm0(ciphertext, wasm.__wbindgen_malloc);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.coseencrypt0_new(headers.__wbg_ptr, ptr0, len0);
        return COSEEncrypt0.__wrap(ret);
    }
}

const COSEKeyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cosekey_free(ptr >>> 0));
/**
*/
class COSEKey {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(COSEKey.prototype);
        obj.__wbg_ptr = ptr;
        COSEKeyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        COSEKeyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cosekey_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cosekey_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {COSEKey}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cosekey_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return COSEKey.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Label} key_type
    */
    set_key_type(key_type) {
        _assertClass(key_type, Label);
        wasm.cosekey_set_key_type(this.__wbg_ptr, key_type.__wbg_ptr);
    }
    /**
    * @returns {Label}
    */
    key_type() {
        const ret = wasm.cosekey_key_type(this.__wbg_ptr);
        return Label.__wrap(ret);
    }
    /**
    * @param {Uint8Array} key_id
    */
    set_key_id(key_id) {
        const ptr0 = passArray8ToWasm0(key_id, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.cosekey_set_key_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {Uint8Array | undefined}
    */
    key_id() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cosekey_key_id(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Label} algorithm_id
    */
    set_algorithm_id(algorithm_id) {
        _assertClass(algorithm_id, Label);
        wasm.cosekey_set_algorithm_id(this.__wbg_ptr, algorithm_id.__wbg_ptr);
    }
    /**
    * @returns {Label | undefined}
    */
    algorithm_id() {
        const ret = wasm.cosekey_algorithm_id(this.__wbg_ptr);
        return ret === 0 ? undefined : Label.__wrap(ret);
    }
    /**
    * @param {Labels} key_ops
    */
    set_key_ops(key_ops) {
        _assertClass(key_ops, Labels);
        wasm.cosekey_set_key_ops(this.__wbg_ptr, key_ops.__wbg_ptr);
    }
    /**
    * @returns {Labels | undefined}
    */
    key_ops() {
        const ret = wasm.cosekey_key_ops(this.__wbg_ptr);
        return ret === 0 ? undefined : Labels.__wrap(ret);
    }
    /**
    * @param {Uint8Array} base_init_vector
    */
    set_base_init_vector(base_init_vector) {
        const ptr0 = passArray8ToWasm0(base_init_vector, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.cosekey_set_base_init_vector(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {Uint8Array | undefined}
    */
    base_init_vector() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cosekey_base_init_vector(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Label} label
    * @returns {CBORValue | undefined}
    */
    header(label) {
        _assertClass(label, Label);
        const ret = wasm.cosekey_header(this.__wbg_ptr, label.__wbg_ptr);
        return ret === 0 ? undefined : CBORValue.__wrap(ret);
    }
    /**
    * @param {Label} label
    * @param {CBORValue} value
    */
    set_header(label, value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(label, Label);
            _assertClass(value, CBORValue);
            wasm.cosekey_set_header(retptr, this.__wbg_ptr, label.__wbg_ptr, value.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Label} key_type
    * @returns {COSEKey}
    */
    static new(key_type) {
        _assertClass(key_type, Label);
        const ret = wasm.cosekey_new(key_type.__wbg_ptr);
        return COSEKey.__wrap(ret);
    }
}

const COSERecipientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_coserecipient_free(ptr >>> 0));
/**
*/
class COSERecipient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(COSERecipient.prototype);
        obj.__wbg_ptr = ptr;
        COSERecipientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        COSERecipientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_coserecipient_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.coserecipient_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {COSERecipient}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.coserecipient_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return COSERecipient.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Headers}
    */
    headers() {
        const ret = wasm.coseencrypt0_headers(this.__wbg_ptr);
        return Headers.__wrap(ret);
    }
    /**
    * @returns {Uint8Array | undefined}
    */
    ciphertext() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.coseencrypt0_ciphertext(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Headers} headers
    * @param {Uint8Array | undefined} [ciphertext]
    * @returns {COSERecipient}
    */
    static new(headers, ciphertext) {
        _assertClass(headers, Headers);
        var ptr0 = isLikeNone(ciphertext) ? 0 : passArray8ToWasm0(ciphertext, wasm.__wbindgen_malloc);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.coseencrypt0_new(headers.__wbg_ptr, ptr0, len0);
        return COSERecipient.__wrap(ret);
    }
}

const COSERecipientsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_coserecipients_free(ptr >>> 0));
/**
*/
class COSERecipients {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(COSERecipients.prototype);
        obj.__wbg_ptr = ptr;
        COSERecipientsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        COSERecipientsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_coserecipients_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.coserecipients_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {COSERecipients}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.coserecipients_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return COSERecipients.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {COSERecipients}
    */
    static new() {
        const ret = wasm.coserecipients_new();
        return COSERecipients.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.coserecipients_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {COSERecipient}
    */
    get(index) {
        const ret = wasm.coserecipients_get(this.__wbg_ptr, index);
        return COSERecipient.__wrap(ret);
    }
    /**
    * @param {COSERecipient} elem
    */
    add(elem) {
        _assertClass(elem, COSERecipient);
        wasm.coserecipients_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const COSESignFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cosesign_free(ptr >>> 0));
/**
*/
class COSESign {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(COSESign.prototype);
        obj.__wbg_ptr = ptr;
        COSESignFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        COSESignFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cosesign_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cosesign_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {COSESign}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cosesign_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return COSESign.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Headers}
    */
    headers() {
        const ret = wasm.coseencrypt0_headers(this.__wbg_ptr);
        return Headers.__wrap(ret);
    }
    /**
    * @returns {Uint8Array | undefined}
    */
    payload() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.coseencrypt_ciphertext(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {COSESignatures}
    */
    signatures() {
        const ret = wasm.cosesign_signatures(this.__wbg_ptr);
        return COSESignatures.__wrap(ret);
    }
    /**
    * @param {Headers} headers
    * @param {Uint8Array | undefined} payload
    * @param {COSESignatures} signatures
    * @returns {COSESign}
    */
    static new(headers, payload, signatures) {
        _assertClass(headers, Headers);
        var ptr0 = isLikeNone(payload) ? 0 : passArray8ToWasm0(payload, wasm.__wbindgen_malloc);
        var len0 = WASM_VECTOR_LEN;
        _assertClass(signatures, COSESignatures);
        const ret = wasm.cosesign_new(headers.__wbg_ptr, ptr0, len0, signatures.__wbg_ptr);
        return COSESign.__wrap(ret);
    }
}

const COSESign1Finalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cosesign1_free(ptr >>> 0));
/**
*/
class COSESign1 {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(COSESign1.prototype);
        obj.__wbg_ptr = ptr;
        COSESign1Finalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        COSESign1Finalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cosesign1_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cosesign1_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {COSESign1}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cosesign1_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return COSESign1.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Headers}
    */
    headers() {
        const ret = wasm.coseencrypt0_headers(this.__wbg_ptr);
        return Headers.__wrap(ret);
    }
    /**
    * @returns {Uint8Array | undefined}
    */
    payload() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.coseencrypt_ciphertext(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    signature() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cosesign1_signature(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * For verifying, we will want to reverse-construct this SigStructure to check the signature against
    * # Arguments
    * * `external_aad` - External application data - see RFC 8152 section 4.3. Set to None if not using this.
    * @param {Uint8Array | undefined} [external_aad]
    * @param {Uint8Array | undefined} [external_payload]
    * @returns {SigStructure}
    */
    signed_data(external_aad, external_payload) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            var ptr0 = isLikeNone(external_aad) ? 0 : passArray8ToWasm0(external_aad, wasm.__wbindgen_malloc);
            var len0 = WASM_VECTOR_LEN;
            var ptr1 = isLikeNone(external_payload) ? 0 : passArray8ToWasm0(external_payload, wasm.__wbindgen_malloc);
            var len1 = WASM_VECTOR_LEN;
            wasm.cosesign1_signed_data(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return SigStructure.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Headers} headers
    * @param {Uint8Array | undefined} payload
    * @param {Uint8Array} signature
    * @returns {COSESign1}
    */
    static new(headers, payload, signature) {
        _assertClass(headers, Headers);
        var ptr0 = isLikeNone(payload) ? 0 : passArray8ToWasm0(payload, wasm.__wbindgen_malloc);
        var len0 = WASM_VECTOR_LEN;
        const ptr1 = passArray8ToWasm0(signature, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.cosesign1_new(headers.__wbg_ptr, ptr0, len0, ptr1, len1);
        return COSESign1.__wrap(ret);
    }
}

const COSESign1BuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cosesign1builder_free(ptr >>> 0));
/**
*/
class COSESign1Builder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(COSESign1Builder.prototype);
        obj.__wbg_ptr = ptr;
        COSESign1BuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        COSESign1BuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cosesign1builder_free(ptr);
    }
    /**
    * @param {Headers} headers
    * @param {Uint8Array} payload
    * @param {boolean} is_payload_external
    * @returns {COSESign1Builder}
    */
    static new(headers, payload, is_payload_external) {
        _assertClass(headers, Headers);
        const ptr0 = passArray8ToWasm0(payload, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.cosesign1builder_new(headers.__wbg_ptr, ptr0, len0, is_payload_external);
        return COSESign1Builder.__wrap(ret);
    }
    /**
    */
    hash_payload() {
        wasm.cosesign1builder_hash_payload(this.__wbg_ptr);
    }
    /**
    * @param {Uint8Array} external_aad
    */
    set_external_aad(external_aad) {
        const ptr0 = passArray8ToWasm0(external_aad, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.cosesign1builder_set_external_aad(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {SigStructure}
    */
    make_data_to_sign() {
        const ret = wasm.cosesign1builder_make_data_to_sign(this.__wbg_ptr);
        return SigStructure.__wrap(ret);
    }
    /**
    * @param {Uint8Array} signed_sig_structure
    * @returns {COSESign1}
    */
    build(signed_sig_structure) {
        const ptr0 = passArray8ToWasm0(signed_sig_structure, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.cosesign1builder_build(this.__wbg_ptr, ptr0, len0);
        return COSESign1.__wrap(ret);
    }
}

const COSESignBuilderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cosesignbuilder_free(ptr >>> 0));
/**
*/
class COSESignBuilder {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(COSESignBuilder.prototype);
        obj.__wbg_ptr = ptr;
        COSESignBuilderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        COSESignBuilderFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cosesignbuilder_free(ptr);
    }
    /**
    * @param {Headers} headers
    * @param {Uint8Array} payload
    * @param {boolean} is_payload_external
    * @returns {COSESignBuilder}
    */
    static new(headers, payload, is_payload_external) {
        _assertClass(headers, Headers);
        const ptr0 = passArray8ToWasm0(payload, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.cosesignbuilder_new(headers.__wbg_ptr, ptr0, len0, is_payload_external);
        return COSESignBuilder.__wrap(ret);
    }
    /**
    */
    hash_payload() {
        wasm.cosesignbuilder_hash_payload(this.__wbg_ptr);
    }
    /**
    * @param {Uint8Array} external_aad
    */
    set_external_aad(external_aad) {
        const ptr0 = passArray8ToWasm0(external_aad, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.cosesign1builder_set_external_aad(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {SigStructure}
    */
    make_data_to_sign() {
        const ret = wasm.cosesignbuilder_make_data_to_sign(this.__wbg_ptr);
        return SigStructure.__wrap(ret);
    }
    /**
    * @param {COSESignatures} signed_sig_structure
    * @returns {COSESign}
    */
    build(signed_sig_structure) {
        _assertClass(signed_sig_structure, COSESignatures);
        const ret = wasm.cosesignbuilder_build(this.__wbg_ptr, signed_sig_structure.__wbg_ptr);
        return COSESign.__wrap(ret);
    }
}

const COSESignatureFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cosesignature_free(ptr >>> 0));
/**
*/
class COSESignature {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(COSESignature.prototype);
        obj.__wbg_ptr = ptr;
        COSESignatureFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        COSESignatureFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cosesignature_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cosesignature_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {COSESignature}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cosesignature_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return COSESignature.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Headers}
    */
    headers() {
        const ret = wasm.coseencrypt0_headers(this.__wbg_ptr);
        return Headers.__wrap(ret);
    }
    /**
    * @returns {Uint8Array}
    */
    signature() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cosesign1_signature(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Headers} headers
    * @param {Uint8Array} signature
    * @returns {COSESignature}
    */
    static new(headers, signature) {
        _assertClass(headers, Headers);
        const ptr0 = passArray8ToWasm0(signature, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.cosesignature_new(headers.__wbg_ptr, ptr0, len0);
        return COSESignature.__wrap(ret);
    }
}

const COSESignaturesFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cosesignatures_free(ptr >>> 0));
/**
*/
class COSESignatures {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(COSESignatures.prototype);
        obj.__wbg_ptr = ptr;
        COSESignaturesFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        COSESignaturesFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cosesignatures_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cosesignatures_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {COSESignatures}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cosesignatures_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return COSESignatures.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {COSESignatures}
    */
    static new() {
        const ret = wasm.coserecipients_new();
        return COSESignatures.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.coserecipients_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {COSESignature}
    */
    get(index) {
        const ret = wasm.cosesignatures_get(this.__wbg_ptr, index);
        return COSESignature.__wrap(ret);
    }
    /**
    * @param {COSESignature} elem
    */
    add(elem) {
        _assertClass(elem, COSESignature);
        wasm.cosesignatures_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const CounterSignatureFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_countersignature_free(ptr >>> 0));
/**
*/
class CounterSignature {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CounterSignature.prototype);
        obj.__wbg_ptr = ptr;
        CounterSignatureFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CounterSignatureFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_countersignature_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.countersignature_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {CounterSignature}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.countersignature_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return CounterSignature.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {COSESignature} cose_signature
    * @returns {CounterSignature}
    */
    static new_single(cose_signature) {
        _assertClass(cose_signature, COSESignature);
        const ret = wasm.countersignature_new_single(cose_signature.__wbg_ptr);
        return CounterSignature.__wrap(ret);
    }
    /**
    * @param {COSESignatures} cose_signatures
    * @returns {CounterSignature}
    */
    static new_multi(cose_signatures) {
        _assertClass(cose_signatures, COSESignatures);
        const ret = wasm.countersignature_new_multi(cose_signatures.__wbg_ptr);
        return CounterSignature.__wrap(ret);
    }
    /**
    * @returns {COSESignatures}
    */
    signatures() {
        const ret = wasm.countersignature_new_multi(this.__wbg_ptr);
        return COSESignatures.__wrap(ret);
    }
}

const EdDSA25519KeyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_eddsa25519key_free(ptr >>> 0));
/**
*/
class EdDSA25519Key {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(EdDSA25519Key.prototype);
        obj.__wbg_ptr = ptr;
        EdDSA25519KeyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        EdDSA25519KeyFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_eddsa25519key_free(ptr);
    }
    /**
    * @param {Uint8Array} pubkey_bytes
    * @returns {EdDSA25519Key}
    */
    static new(pubkey_bytes) {
        const ptr0 = passArray8ToWasm0(pubkey_bytes, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.eddsa25519key_new(ptr0, len0);
        return EdDSA25519Key.__wrap(ret);
    }
    /**
    * @param {Uint8Array} private_key_bytes
    */
    set_private_key(private_key_bytes) {
        const ptr0 = passArray8ToWasm0(private_key_bytes, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.eddsa25519key_set_private_key(this.__wbg_ptr, ptr0, len0);
    }
    /**
    */
    is_for_signing() {
        wasm.eddsa25519key_is_for_signing(this.__wbg_ptr);
    }
    /**
    */
    is_for_verifying() {
        wasm.eddsa25519key_is_for_verifying(this.__wbg_ptr);
    }
    /**
    * @returns {COSEKey}
    */
    build() {
        const ret = wasm.eddsa25519key_build(this.__wbg_ptr);
        return COSEKey.__wrap(ret);
    }
}

const HeaderMapFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_headermap_free(ptr >>> 0));
/**
*/
class HeaderMap {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(HeaderMap.prototype);
        obj.__wbg_ptr = ptr;
        HeaderMapFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        HeaderMapFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_headermap_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.headermap_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {HeaderMap}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.headermap_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return HeaderMap.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Label} algorithm_id
    */
    set_algorithm_id(algorithm_id) {
        _assertClass(algorithm_id, Label);
        wasm.headermap_set_algorithm_id(this.__wbg_ptr, algorithm_id.__wbg_ptr);
    }
    /**
    * @returns {Label | undefined}
    */
    algorithm_id() {
        const ret = wasm.headermap_algorithm_id(this.__wbg_ptr);
        return ret === 0 ? undefined : Label.__wrap(ret);
    }
    /**
    * @param {Labels} criticality
    */
    set_criticality(criticality) {
        _assertClass(criticality, Labels);
        wasm.headermap_set_criticality(this.__wbg_ptr, criticality.__wbg_ptr);
    }
    /**
    * @returns {Labels | undefined}
    */
    criticality() {
        const ret = wasm.headermap_criticality(this.__wbg_ptr);
        return ret === 0 ? undefined : Labels.__wrap(ret);
    }
    /**
    * @param {Label} content_type
    */
    set_content_type(content_type) {
        _assertClass(content_type, Label);
        wasm.cosekey_set_algorithm_id(this.__wbg_ptr, content_type.__wbg_ptr);
    }
    /**
    * @returns {Label | undefined}
    */
    content_type() {
        const ret = wasm.cosekey_algorithm_id(this.__wbg_ptr);
        return ret === 0 ? undefined : Label.__wrap(ret);
    }
    /**
    * @param {Uint8Array} key_id
    */
    set_key_id(key_id) {
        const ptr0 = passArray8ToWasm0(key_id, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.headermap_set_key_id(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {Uint8Array | undefined}
    */
    key_id() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.headermap_key_id(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} init_vector
    */
    set_init_vector(init_vector) {
        const ptr0 = passArray8ToWasm0(init_vector, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.cosekey_set_base_init_vector(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {Uint8Array | undefined}
    */
    init_vector() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cosekey_base_init_vector(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} partial_init_vector
    */
    set_partial_init_vector(partial_init_vector) {
        const ptr0 = passArray8ToWasm0(partial_init_vector, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.headermap_set_partial_init_vector(this.__wbg_ptr, ptr0, len0);
    }
    /**
    * @returns {Uint8Array | undefined}
    */
    partial_init_vector() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.headermap_partial_init_vector(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getArrayU8FromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {CounterSignature} counter_signature
    */
    set_counter_signature(counter_signature) {
        _assertClass(counter_signature, CounterSignature);
        wasm.headermap_set_counter_signature(this.__wbg_ptr, counter_signature.__wbg_ptr);
    }
    /**
    * @returns {CounterSignature | undefined}
    */
    counter_signature() {
        const ret = wasm.headermap_counter_signature(this.__wbg_ptr);
        return ret === 0 ? undefined : CounterSignature.__wrap(ret);
    }
    /**
    * @param {Label} label
    * @returns {CBORValue | undefined}
    */
    header(label) {
        _assertClass(label, Label);
        const ret = wasm.headermap_header(this.__wbg_ptr, label.__wbg_ptr);
        return ret === 0 ? undefined : CBORValue.__wrap(ret);
    }
    /**
    * @param {Label} label
    * @param {CBORValue} value
    */
    set_header(label, value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(label, Label);
            _assertClass(value, CBORValue);
            wasm.headermap_set_header(retptr, this.__wbg_ptr, label.__wbg_ptr, value.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Labels}
    */
    keys() {
        const ret = wasm.headermap_keys(this.__wbg_ptr);
        return Labels.__wrap(ret);
    }
    /**
    * @returns {HeaderMap}
    */
    static new() {
        const ret = wasm.headermap_new();
        return HeaderMap.__wrap(ret);
    }
}

const HeadersFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_headers_free(ptr >>> 0));
/**
*/
class Headers {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Headers.prototype);
        obj.__wbg_ptr = ptr;
        HeadersFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        HeadersFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_headers_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.headers_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {Headers}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.headers_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return Headers.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {ProtectedHeaderMap}
    */
    protected() {
        const ret = wasm.headers_protected(this.__wbg_ptr);
        return ProtectedHeaderMap.__wrap(ret);
    }
    /**
    * @returns {HeaderMap}
    */
    unprotected() {
        const ret = wasm.headers_unprotected(this.__wbg_ptr);
        return HeaderMap.__wrap(ret);
    }
    /**
    * @param {ProtectedHeaderMap} protected_
    * @param {HeaderMap} unprotected_
    * @returns {Headers}
    */
    static new(protected_, unprotected_) {
        _assertClass(protected_, ProtectedHeaderMap);
        _assertClass(unprotected_, HeaderMap);
        const ret = wasm.headers_new(protected_.__wbg_ptr, unprotected_.__wbg_ptr);
        return Headers.__wrap(ret);
    }
}

const IntFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_int_free(ptr >>> 0));
/**
*/
class Int {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Int.prototype);
        obj.__wbg_ptr = ptr;
        IntFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        IntFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_int_free(ptr);
    }
    /**
    * @param {BigNum} x
    * @returns {Int}
    */
    static new(x) {
        _assertClass(x, BigNum);
        const ret = wasm.int_new(x.__wbg_ptr);
        return Int.__wrap(ret);
    }
    /**
    * @param {BigNum} x
    * @returns {Int}
    */
    static new_negative(x) {
        _assertClass(x, BigNum);
        const ret = wasm.int_new_negative(x.__wbg_ptr);
        return Int.__wrap(ret);
    }
    /**
    * @param {number} x
    * @returns {Int}
    */
    static new_i32(x) {
        const ret = wasm.int_new_i32(x);
        return Int.__wrap(ret);
    }
    /**
    * @returns {boolean}
    */
    is_positive() {
        const ret = wasm.int_is_positive(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @returns {BigNum | undefined}
    */
    as_positive() {
        const ret = wasm.int_as_positive(this.__wbg_ptr);
        return ret === 0 ? undefined : BigNum.__wrap(ret);
    }
    /**
    * @returns {BigNum | undefined}
    */
    as_negative() {
        const ret = wasm.int_as_negative(this.__wbg_ptr);
        return ret === 0 ? undefined : BigNum.__wrap(ret);
    }
    /**
    * @returns {number | undefined}
    */
    as_i32() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.int_as_i32(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            return r0 === 0 ? undefined : r1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const LabelFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_label_free(ptr >>> 0));
/**
*/
class Label {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Label.prototype);
        obj.__wbg_ptr = ptr;
        LabelFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LabelFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_label_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.label_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {Label}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.label_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return Label.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Int} int
    * @returns {Label}
    */
    static new_int(int) {
        _assertClass(int, Int);
        const ret = wasm.label_new_int(int.__wbg_ptr);
        return Label.__wrap(ret);
    }
    /**
    * @param {string} text
    * @returns {Label}
    */
    static new_text(text) {
        const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.label_new_text(ptr0, len0);
        return Label.__wrap(ret);
    }
    /**
    * @returns {LabelKind}
    */
    kind() {
        const ret = wasm.label_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {Int | undefined}
    */
    as_int() {
        const ret = wasm.label_as_int(this.__wbg_ptr);
        return ret === 0 ? undefined : Int.__wrap(ret);
    }
    /**
    * @returns {string | undefined}
    */
    as_text() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.label_as_text(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {AlgorithmId} id
    * @returns {Label}
    */
    static from_algorithm_id(id) {
        const ret = wasm.label_from_algorithm_id(id);
        return Label.__wrap(ret);
    }
    /**
    * @param {KeyType} key_type
    * @returns {Label}
    */
    static from_key_type(key_type) {
        const ret = wasm.label_from_key_type(key_type);
        return Label.__wrap(ret);
    }
    /**
    * @param {ECKey} ec_key
    * @returns {Label}
    */
    static from_ec_key(ec_key) {
        const ret = wasm.label_from_ec_key(ec_key);
        return Label.__wrap(ret);
    }
    /**
    * @param {CurveType} curve_type
    * @returns {Label}
    */
    static from_curve_type(curve_type) {
        const ret = wasm.label_from_curve_type(curve_type);
        return Label.__wrap(ret);
    }
    /**
    * @param {KeyOperation} key_op
    * @returns {Label}
    */
    static from_key_operation(key_op) {
        const ret = wasm.label_from_key_operation(key_op);
        return Label.__wrap(ret);
    }
}

const LabelsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_labels_free(ptr >>> 0));
/**
*/
class Labels {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Labels.prototype);
        obj.__wbg_ptr = ptr;
        LabelsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LabelsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_labels_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.labels_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {Labels}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.labels_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return Labels.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Labels}
    */
    static new() {
        const ret = wasm.coserecipients_new();
        return Labels.__wrap(ret);
    }
    /**
    * @returns {number}
    */
    len() {
        const ret = wasm.coserecipients_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} index
    * @returns {Label}
    */
    get(index) {
        const ret = wasm.labels_get(this.__wbg_ptr, index);
        return Label.__wrap(ret);
    }
    /**
    * @param {Label} elem
    */
    add(elem) {
        _assertClass(elem, Label);
        wasm.labels_add(this.__wbg_ptr, elem.__wbg_ptr);
    }
}

const PasswordEncryptionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_passwordencryption_free(ptr >>> 0));
/**
*/
class PasswordEncryption {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PasswordEncryption.prototype);
        obj.__wbg_ptr = ptr;
        PasswordEncryptionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PasswordEncryptionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_passwordencryption_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.passwordencryption_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {PasswordEncryption}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.passwordencryption_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return PasswordEncryption.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {COSEEncrypt0} data
    * @returns {PasswordEncryption}
    */
    static new(data) {
        _assertClass(data, COSEEncrypt0);
        const ret = wasm.passwordencryption_new(data.__wbg_ptr);
        return PasswordEncryption.__wrap(ret);
    }
}

const ProtectedHeaderMapFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_protectedheadermap_free(ptr >>> 0));
/**
*/
class ProtectedHeaderMap {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ProtectedHeaderMap.prototype);
        obj.__wbg_ptr = ptr;
        ProtectedHeaderMapFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ProtectedHeaderMapFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_protectedheadermap_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.protectedheadermap_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {ProtectedHeaderMap}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.protectedheadermap_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return ProtectedHeaderMap.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {ProtectedHeaderMap}
    */
    static new_empty() {
        const ret = wasm.protectedheadermap_new_empty();
        return ProtectedHeaderMap.__wrap(ret);
    }
    /**
    * @param {HeaderMap} header_map
    * @returns {ProtectedHeaderMap}
    */
    static new(header_map) {
        _assertClass(header_map, HeaderMap);
        const ret = wasm.protectedheadermap_new(header_map.__wbg_ptr);
        return ProtectedHeaderMap.__wrap(ret);
    }
    /**
    * @returns {HeaderMap}
    */
    deserialized_headers() {
        const ret = wasm.protectedheadermap_deserialized_headers(this.__wbg_ptr);
        return HeaderMap.__wrap(ret);
    }
}

const PubKeyEncryptionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_pubkeyencryption_free(ptr >>> 0));
/**
*/
class PubKeyEncryption {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PubKeyEncryption.prototype);
        obj.__wbg_ptr = ptr;
        PubKeyEncryptionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PubKeyEncryptionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_pubkeyencryption_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.pubkeyencryption_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {PubKeyEncryption}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.pubkeyencryption_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return PubKeyEncryption.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {COSEEncrypt} data
    * @returns {PubKeyEncryption}
    */
    static new(data) {
        _assertClass(data, COSEEncrypt);
        const ret = wasm.pubkeyencryption_new(data.__wbg_ptr);
        return PubKeyEncryption.__wrap(ret);
    }
}

const SigStructureFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_sigstructure_free(ptr >>> 0));
/**
*/
class SigStructure {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SigStructure.prototype);
        obj.__wbg_ptr = ptr;
        SigStructureFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SigStructureFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_sigstructure_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.sigstructure_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {SigStructure}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.sigstructure_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return SigStructure.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {SigContext}
    */
    context() {
        const ret = wasm.sigstructure_context(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {ProtectedHeaderMap}
    */
    body_protected() {
        const ret = wasm.sigstructure_body_protected(this.__wbg_ptr);
        return ProtectedHeaderMap.__wrap(ret);
    }
    /**
    * @returns {ProtectedHeaderMap | undefined}
    */
    sign_protected() {
        const ret = wasm.sigstructure_sign_protected(this.__wbg_ptr);
        return ret === 0 ? undefined : ProtectedHeaderMap.__wrap(ret);
    }
    /**
    * @returns {Uint8Array}
    */
    external_aad() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.sigstructure_external_aad(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    payload() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.sigstructure_payload(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {ProtectedHeaderMap} sign_protected
    */
    set_sign_protected(sign_protected) {
        _assertClass(sign_protected, ProtectedHeaderMap);
        wasm.sigstructure_set_sign_protected(this.__wbg_ptr, sign_protected.__wbg_ptr);
    }
    /**
    * @param {SigContext} context
    * @param {ProtectedHeaderMap} body_protected
    * @param {Uint8Array} external_aad
    * @param {Uint8Array} payload
    * @returns {SigStructure}
    */
    static new(context, body_protected, external_aad, payload) {
        _assertClass(body_protected, ProtectedHeaderMap);
        const ptr0 = passArray8ToWasm0(external_aad, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArray8ToWasm0(payload, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.sigstructure_new(context, body_protected.__wbg_ptr, ptr0, len0, ptr1, len1);
        return SigStructure.__wrap(ret);
    }
}

const SignedMessageFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_signedmessage_free(ptr >>> 0));
/**
*/
class SignedMessage {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SignedMessage.prototype);
        obj.__wbg_ptr = ptr;
        SignedMessageFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SignedMessageFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_signedmessage_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.signedmessage_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {SignedMessage}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.signedmessage_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return SignedMessage.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {COSESign} cose_sign
    * @returns {SignedMessage}
    */
    static new_cose_sign(cose_sign) {
        _assertClass(cose_sign, COSESign);
        const ret = wasm.signedmessage_new_cose_sign(cose_sign.__wbg_ptr);
        return SignedMessage.__wrap(ret);
    }
    /**
    * @param {COSESign1} cose_sign1
    * @returns {SignedMessage}
    */
    static new_cose_sign1(cose_sign1) {
        _assertClass(cose_sign1, COSESign1);
        const ret = wasm.signedmessage_new_cose_sign1(cose_sign1.__wbg_ptr);
        return SignedMessage.__wrap(ret);
    }
    /**
    * @param {string} s
    * @returns {SignedMessage}
    */
    static from_user_facing_encoding(s) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(s, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.signedmessage_from_user_facing_encoding(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return SignedMessage.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    to_user_facing_encoding() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.signedmessage_to_user_facing_encoding(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {SignedMessageKind}
    */
    kind() {
        const ret = wasm.signedmessage_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @returns {COSESign | undefined}
    */
    as_cose_sign() {
        const ret = wasm.signedmessage_as_cose_sign(this.__wbg_ptr);
        return ret === 0 ? undefined : COSESign.__wrap(ret);
    }
    /**
    * @returns {COSESign1 | undefined}
    */
    as_cose_sign1() {
        const ret = wasm.signedmessage_as_cose_sign1(this.__wbg_ptr);
        return ret === 0 ? undefined : COSESign1.__wrap(ret);
    }
}

const TaggedCBORFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_taggedcbor_free(ptr >>> 0));
/**
*/
class TaggedCBOR {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TaggedCBOR.prototype);
        obj.__wbg_ptr = ptr;
        TaggedCBORFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TaggedCBORFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_taggedcbor_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    to_bytes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.taggedcbor_to_bytes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Uint8Array} bytes
    * @returns {TaggedCBOR}
    */
    static from_bytes(bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.taggedcbor_from_bytes(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return TaggedCBOR.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {BigNum}
    */
    tag() {
        const ret = wasm.taggedcbor_tag(this.__wbg_ptr);
        return BigNum.__wrap(ret);
    }
    /**
    * @returns {CBORValue}
    */
    value() {
        const ret = wasm.taggedcbor_value(this.__wbg_ptr);
        return CBORValue.__wrap(ret);
    }
    /**
    * @param {BigNum} tag
    * @param {CBORValue} value
    * @returns {TaggedCBOR}
    */
    static new(tag, value) {
        _assertClass(tag, BigNum);
        _assertClass(value, CBORValue);
        const ret = wasm.taggedcbor_new(tag.__wbg_ptr, value.__wbg_ptr);
        return TaggedCBOR.__wrap(ret);
    }
}

function __wbindgen_object_drop_ref(arg0) {
    takeObject(arg0);
};

function __wbindgen_string_new(arg0, arg1) {
    const ret = getStringFromWasm0(arg0, arg1);
    return addHeapObject(ret);
};

function __wbindgen_debug_string(arg0, arg1) {
    const ret = debugString(getObject(arg1));
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getInt32Memory0()[arg0 / 4 + 1] = len1;
    getInt32Memory0()[arg0 / 4 + 0] = ptr1;
};

function __wbindgen_throw(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
};



/***/ }),

/***/ 55053:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.checkBounds = exports.assertInBound = exports.assertNum = exports.asserValidOffset = void 0;
var errors = __importStar(__webpack_require__(63810));
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function asserValidOffset(offset, ext, length) {
    if ((offset % 1) !== 0 || offset < 0)
        throw new RangeError('offset is not uint');
    if (offset + ext > length)
        throw new RangeError('Trying to access beyond buffer length');
}
exports.asserValidOffset = asserValidOffset;
function assertNum(n) {
    if (typeof n !== "number")
        throw new Error("expected a number");
}
exports.assertNum = assertNum;
function assertInBound(value, length, type) {
    if (Math.floor(value) !== value) {
        assertNum(value);
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) {
        throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    }
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
exports.assertInBound = assertInBound;
function checkBounds(buf, offset, byteLength) {
    assertNum(offset);
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
        assertInBound(offset, buf.length - (byteLength + 1));
    }
}
exports.checkBounds = checkBounds;


/***/ }),

/***/ 38157:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromAscii = exports.toAscii = void 0;
function toAscii(buf, start, end) {
    if (start === void 0) { start = 0; }
    if (end === void 0) { end = Infinity; }
    var ret = '';
    end = Math.min(buf.length, end);
    for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 0x7f);
    }
    return ret;
}
exports.toAscii = toAscii;
function fromAscii(str) {
    var len = str.length;
    var byteArray = new Array(len);
    for (var i = 0; i < str.length; ++i) {
        byteArray[i] = str.charCodeAt(i) & 0xff;
    }
    return new Uint8Array(byteArray);
}
exports.fromAscii = fromAscii;


/***/ }),

/***/ 18572:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromBase64 = exports.toBase64 = void 0;
var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
}
function toBase64(bytes) {
    var i, len = bytes.length, base64 = '';
    for (i = 0; i < len; i += 3) {
        base64 += chars[bytes[i] >> 2];
        base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64 += chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) {
        base64 = base64.substring(0, base64.length - 1) + '=';
    }
    else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + '==';
    }
    return base64;
}
exports.toBase64 = toBase64;
;
function fromBase64(base64) {
    var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') {
            bufferLength--;
        }
    }
    var bytes = new Uint8Array(bufferLength);
    for (i = 0; i < len; i += 4) {
        encoded1 = lookup[base64.charCodeAt(i)];
        encoded2 = lookup[base64.charCodeAt(i + 1)];
        encoded3 = lookup[base64.charCodeAt(i + 2)];
        encoded4 = lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
        bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
        bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }
    return bytes;
}
exports.fromBase64 = fromBase64;
;


/***/ }),

/***/ 72211:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.concatUint8Array = void 0;
function concatUint8Array() {
    var chunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        chunks[_i] = arguments[_i];
    }
    // if(!Array.isArray(chunks)) return new Uint8Array([]);
    if (!chunks.every(function (chunk) { return chunk instanceof Uint8Array; }))
        return new Uint8Array([]);
    if (chunks.length <= 0)
        return new Uint8Array([]);
    if (chunks.length === 1)
        return Uint8Array.prototype.slice.call(chunks[0]);
    var len = chunks.reduce(function (acc, chunk) { return acc + chunk.length; }, 0);
    var result = new Uint8Array(len);
    var offset = 0;
    var nChunks = chunks.length;
    for (var i = 0, chunk = void 0; i < nChunks;) {
        chunk = chunks[i++];
        result.set(chunk, offset);
        offset += chunk.length;
    }
    return result;
}
exports.concatUint8Array = concatUint8Array;


/***/ }),

/***/ 63810:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ERR_OUT_OF_RANGE = exports.ERR_INVALID_ARG_TYPE = exports.ERR_BUFFER_OUT_OF_BOUNDS = void 0;
function addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for (; i >= start + 4; i -= 3) {
        res = "_".concat(val.slice(i - 3, i)).concat(res);
    }
    return "".concat(val.slice(0, i)).concat(res);
}
function E(sym, getMessage, Base) {
    return /** @class */ (function (_super) {
        __extends(Uint8ArrayError, _super);
        function Uint8ArrayError() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.call(this) || this;
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, args),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack; // eslint-disable-line no-unused-expressions
            return _this;
        }
        Object.defineProperty(Uint8ArrayError.prototype, "code", {
            get: function () {
                return sym;
            },
            set: function (value) {
                Object.defineProperty(this, 'code', {
                    configurable: true,
                    enumerable: true,
                    value: value,
                    writable: true
                });
            },
            enumerable: false,
            configurable: true
        });
        Uint8ArrayError.prototype.toString = function () {
            return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
        };
        return Uint8ArrayError;
    }(Base));
}
exports.ERR_BUFFER_OUT_OF_BOUNDS = E('ERR_BUFFER_OUT_OF_BOUNDS', function (name) {
    if (name) {
        return "".concat(name, " is outside of buffer bounds");
    }
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
exports.ERR_INVALID_ARG_TYPE = E('ERR_INVALID_ARG_TYPE', function (name, actual) {
    return "The \"".concat(name, "\" argument must be of type number. Received type ").concat(typeof actual);
}, TypeError);
exports.ERR_OUT_OF_RANGE = E('ERR_OUT_OF_RANGE', function (str, range, input) {
    var msg = "The value of \"".concat(str, "\" is out of range.");
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) {
        received = addNumericalSeparator(String(input));
    }
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > (BigInt(1) << BigInt(32)) || input < -(BigInt(1) << BigInt(32))) {
            received = addNumericalSeparator(received);
        }
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);


/***/ }),

/***/ 14258:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromHex = exports.toHex = void 0;
var isUint8Array_1 = __webpack_require__(57416);
function toHex(buff) {
    if (!(0, isUint8Array_1.isUint8Array)(buff))
        throw new TypeError('toHex expects an `Uint8Array`;');
    var strArr = new Array(buff.length);
    buff.forEach(function (b, i) { return strArr[i] = b.toString(16).padStart(2, '0'); });
    return strArr.join('');
}
exports.toHex = toHex;
var hexChars = Object.freeze(Array.from("0123456789abcdef"));
function isLowerCaseHex(str) {
    return Array.from(str).every(function (ch) { return hexChars.includes(ch); });
}
function fromHex(str) {
    if (typeof str !== "string")
        throw new TypeError('fromHex expects an hexadecimal string;');
    str = str.toLowerCase();
    str = str.length % 2 === 0 ? str : '0' + str;
    var len = str.length / 2;
    var arr = new Array(len);
    for (var i = 0; i < len; i++) {
        var i2 = i * 2;
        var byte = str.substring(i2, i2 + 2);
        if (!isLowerCaseHex(byte))
            throw new TypeError('fromHex expects an hexadecimal string; input was: ' + str);
        arr[i] = parseInt("0x" + byte);
    }
    return new Uint8Array(arr);
}
exports.fromHex = fromHex;


/***/ }),

/***/ 44948:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(57416), exports);
__exportStar(__webpack_require__(61145), exports);
__exportStar(__webpack_require__(14258), exports);
__exportStar(__webpack_require__(38157), exports);
__exportStar(__webpack_require__(85207), exports);
__exportStar(__webpack_require__(84186), exports);
__exportStar(__webpack_require__(17979), exports);
__exportStar(__webpack_require__(72211), exports);
__exportStar(__webpack_require__(18572), exports);


/***/ }),

/***/ 57416:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isUint8Array = void 0;
function isUint8Array(stuff) {
    return stuff instanceof Uint8Array;
}
exports.isUint8Array = isUint8Array;


/***/ }),

/***/ 85207:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.readFloat64BE = exports.readFloat32BE = exports.readIntLE = exports.readBigUInt64BE = exports.readBigUInt64LE = exports.readUInt32BE = exports.readUint32BE = exports.readUInt32LE = exports.readUint32LE = exports.readUInt16BE = exports.readUint16BE = exports.readUInt16LE = exports.readUint16LE = exports.readUInt8 = exports.readUint8 = void 0;
var _asserts_1 = __webpack_require__(55053);
exports.readUint8 = readUInt8;
function readUInt8(buff, offset, noAssert) {
    if (noAssert === void 0) { noAssert = false; }
    offset = offset >>> 0;
    if (!noAssert)
        (0, _asserts_1.asserValidOffset)(offset, 1, buff.length);
    return buff[offset];
}
exports.readUInt8 = readUInt8;
exports.readUint16LE = readUInt16LE;
function readUInt16LE(buff, offset, noAssert) {
    if (noAssert === void 0) { noAssert = false; }
    offset = offset >>> 0;
    if (!noAssert)
        (0, _asserts_1.asserValidOffset)(offset, 2, buff.length);
    return buff[offset] | (buff[offset + 1] << 8);
}
exports.readUInt16LE = readUInt16LE;
exports.readUint16BE = readUInt16BE;
function readUInt16BE(buff, offset, noAssert) {
    if (noAssert === void 0) { noAssert = false; }
    offset = offset >>> 0;
    if (!noAssert)
        (0, _asserts_1.asserValidOffset)(offset, 2, buff.length);
    return (buff[offset] << 8) | buff[offset + 1];
}
exports.readUInt16BE = readUInt16BE;
exports.readUint32LE = readUInt32LE;
function readUInt32LE(buff, offset, noAssert) {
    if (noAssert === void 0) { noAssert = false; }
    offset = offset >>> 0;
    if (!noAssert)
        (0, _asserts_1.asserValidOffset)(offset, 4, buff.length);
    return ((buff[offset]) |
        (buff[offset + 1] << 8) |
        (buff[offset + 2] << 16)) +
        (buff[offset + 3] * 0x1000000);
}
exports.readUInt32LE = readUInt32LE;
exports.readUint32BE = readUInt32BE;
function readUInt32BE(buff, offset, noAssert) {
    if (noAssert === void 0) { noAssert = false; }
    offset = offset >>> 0;
    if (!noAssert)
        (0, _asserts_1.asserValidOffset)(offset, 4, buff.length);
    return (buff[offset] * 0x1000000) +
        ((buff[offset + 1] << 16) |
            (buff[offset + 2] << 8) |
            buff[offset + 3]);
}
exports.readUInt32BE = readUInt32BE;
function readBigUInt64LE(buff, offset) {
    offset = offset >>> 0;
    (0, _asserts_1.assertNum)(offset);
    var first = buff[offset];
    var last = buff[offset + 7];
    if (first === undefined || last === undefined) {
        (0, _asserts_1.assertInBound)(offset, buff.length - 8);
    }
    var lo = first +
        buff[++offset] * Math.pow(2, 8) +
        buff[++offset] * Math.pow(2, 16) +
        buff[++offset] * Math.pow(2, 24);
    var hi = buff[++offset] +
        buff[++offset] * Math.pow(2, 8) +
        buff[++offset] * Math.pow(2, 16) +
        last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
}
exports.readBigUInt64LE = readBigUInt64LE;
function readBigUInt64BE(buff, offset) {
    offset = offset >>> 0;
    (0, _asserts_1.assertNum)(offset);
    var first = buff[offset];
    var last = buff[offset + 7];
    if (first === undefined || last === undefined) {
        (0, _asserts_1.assertInBound)(offset, buff.length - 8);
    }
    var hi = first * Math.pow(2, 24) +
        buff[++offset] * Math.pow(2, 16) +
        buff[++offset] * Math.pow(2, 8) +
        buff[++offset];
    var lo = buff[++offset] * Math.pow(2, 24) +
        buff[++offset] * Math.pow(2, 16) +
        buff[++offset] * Math.pow(2, 8) +
        last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
}
exports.readBigUInt64BE = readBigUInt64BE;
function readIntLE(buff, offset, byteLength, noAssert) {
    if (noAssert === void 0) { noAssert = false; }
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert)
        (0, _asserts_1.asserValidOffset)(offset, byteLength, buff.length);
    var val = buff[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
        val += buff[offset + i] * mul;
    }
    mul *= 0x80;
    if (val >= mul)
        val -= Math.pow(2, 8 * byteLength);
    return val;
}
exports.readIntLE = readIntLE;
function readFloat32BE(buf, offset) {
    var buff = new ArrayBuffer(4);
    var asFloat32 = new Float32Array(buff);
    var asUint8 = new Uint8Array(buff);
    for (var i = offset; i < offset + 4; i++) {
        asUint8[i - offset] = buf[i];
    }
    return asFloat32[0];
}
exports.readFloat32BE = readFloat32BE;
function readFloat64BE(buf, offset) {
    var buff = new ArrayBuffer(8);
    var asFloat64 = new Float64Array(buff);
    var asUint8 = new Uint8Array(buff);
    for (var i = offset; i < offset + 8; i++) {
        asUint8[i - offset] = buf[i];
    }
    return asFloat64[0];
}
exports.readFloat64BE = readFloat64BE;


/***/ }),

/***/ 61145:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toUtf8 = exports.fromUtf8 = void 0;
function fromUtf8(string, units) {
    if (units === void 0) { units = Infinity; }
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for (var i = 0; i < length; ++i) {
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1)
                        bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1)
                        bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1)
                    bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        }
        else if (leadSurrogate) {
            // valid bmp char, but last char was a lead
            if ((units -= 3) > -1)
                bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0)
                break;
            bytes.push(codePoint);
        }
        else if (codePoint < 0x800) {
            if ((units -= 2) < 0)
                break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        }
        else if (codePoint < 0x10000) {
            if ((units -= 3) < 0)
                break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        }
        else if (codePoint < 0x110000) {
            if ((units -= 4) < 0)
                break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        }
        else {
            throw new Error('Invalid code point');
        }
    }
    return new Uint8Array(bytes);
}
exports.fromUtf8 = fromUtf8;
function toUtf8(buf, start, end) {
    if (start === void 0) { start = 0; }
    if (end === void 0) { end = Infinity; }
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while (i < end) {
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = (firstByte > 0xEF)
            ? 4
            : (firstByte > 0xDF)
                ? 3
                : (firstByte > 0xBF)
                    ? 2
                    : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch (bytesPerSequence) {
                case 1:
                    if (firstByte < 0x80) {
                        codePoint = firstByte;
                    }
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
                        if (tempCodePoint > 0x7F) {
                            codePoint = tempCodePoint;
                        }
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                            codePoint = tempCodePoint;
                        }
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                            codePoint = tempCodePoint;
                        }
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        }
        else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
exports.toUtf8 = toUtf8;
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
    }
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while (i < len) {
        res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    }
    return res;
}


/***/ }),

/***/ 17979:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.uint8ArrayEq = exports.lexCompare = void 0;
function lexCompare(a, b) {
    var min = a.length < b.length ? a : b;
    var minLen = min.length;
    for (var i = 0; i < minLen; i++) {
        var _a = a.at(i);
        var _b = b.at(i);
        if (_a === undefined)
            return -1 /* Ord.LT */;
        if (_b === undefined)
            return 1 /* Ord.GT */;
        if (_a < _b)
            return -1 /* Ord.LT */;
        if (_a > _b)
            return 1 /* Ord.GT */;
        // if( _a === _b ) continue;
    }
    return a.length === b.length ? 0 /* Ord.EQ */ :
        (a.length < b.length ? -1 /* Ord.LT */ : 1 /* Ord.GT */);
}
exports.lexCompare = lexCompare;
function uint8ArrayEq(a, b) {
    return a.length === b.length && a.every(function (n, i) { return n === b[i]; });
}
exports.uint8ArrayEq = uint8ArrayEq;


/***/ }),

/***/ 84186:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.writeFloat64BE = exports.writeBigUInt64BE = exports.writeBigUInt64LE = exports.writeUInt32BE = exports.writeUint32BE = exports.writeUInt32LE = exports.writeUint32LE = exports.writeUInt16BE = exports.writeUint16BE = exports.writeUInt16LE = exports.writeUint16LE = exports.writeUInt8 = exports.writeUint8 = exports.writeUIntBE = exports.writeUintBE = exports.writeUIntLE = exports.writeUintLE = void 0;
var _asserts_1 = __webpack_require__(55053);
var errors = __importStar(__webpack_require__(63810));
function checkInt(buf, value, offset, ext, max, min) {
    if (!(buf instanceof Uint8Array))
        throw new TypeError('"buffer" argument must be an Uint8Array instance');
    if (value > max || value < min)
        throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length)
        throw new RangeError('Index out of range');
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = typeof min === 'bigint' ? 'n' : '';
        var range = void 0;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) {
                range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            }
            else {
                range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") +
                    "".concat((byteLength + 1) * 8 - 1).concat(n);
            }
        }
        else {
            range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        }
        throw new errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    (0, _asserts_1.checkBounds)(buf, offset, byteLength);
}
exports.writeUintLE = writeUIntLE;
function writeUIntLE(buff, value, offset, byteLength, noAssert) {
    if (noAssert === void 0) { noAssert = false; }
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(buff, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    buff[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
        buff[offset + i] = (value / mul) & 0xFF;
    }
    return offset + byteLength;
}
exports.writeUIntLE = writeUIntLE;
exports.writeUintBE = writeUIntBE;
function writeUIntBE(buff, value, offset, byteLength, noAssert) {
    if (noAssert === void 0) { noAssert = false; }
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(buff, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    buff[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
        buff[offset + i] = (value / mul) & 0xFF;
    }
    return offset + byteLength;
}
exports.writeUIntBE = writeUIntBE;
exports.writeUint8 = writeUInt8;
function writeUInt8(buff, value, offset, noAssert) {
    if (noAssert === void 0) { noAssert = false; }
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(buff, value, offset, 1, 0xff, 0);
    buff[offset] = (value & 0xff);
    return offset + 1;
}
exports.writeUInt8 = writeUInt8;
exports.writeUint16LE = writeUInt16LE;
function writeUInt16LE(buff, value, offset, noAssert) {
    if (noAssert === void 0) { noAssert = false; }
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(buff, value, offset, 2, 0xffff, 0);
    buff[offset] = (value & 0xff);
    buff[offset + 1] = (value >>> 8);
    return offset + 2;
}
exports.writeUInt16LE = writeUInt16LE;
exports.writeUint16BE = writeUInt16BE;
function writeUInt16BE(buff, value, offset, noAssert) {
    if (noAssert === void 0) { noAssert = false; }
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(buff, value, offset, 2, 0xffff, 0);
    buff[offset] = (value >>> 8);
    buff[offset + 1] = (value & 0xff);
    return offset + 2;
}
exports.writeUInt16BE = writeUInt16BE;
exports.writeUint32LE = writeUInt32LE;
function writeUInt32LE(buff, value, offset, noAssert) {
    if (noAssert === void 0) { noAssert = false; }
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(buff, value, offset, 4, 0xffffffff, 0);
    buff[offset + 3] = (value >>> 24);
    buff[offset + 2] = (value >>> 16);
    buff[offset + 1] = (value >>> 8);
    buff[offset] = (value & 0xff);
    return offset + 4;
}
exports.writeUInt32LE = writeUInt32LE;
exports.writeUint32BE = writeUInt32BE;
function writeUInt32BE(buff, value, offset, noAssert) {
    if (noAssert === void 0) { noAssert = false; }
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
        checkInt(buff, value, offset, 4, 0xffffffff, 0);
    buff[offset] = (value >>> 24);
    buff[offset + 1] = (value >>> 16);
    buff[offset + 2] = (value >>> 8);
    buff[offset + 3] = (value & 0xff);
    return offset + 4;
}
exports.writeUInt32BE = writeUInt32BE;
function writeBigUInt64LE(buf, value, offset) {
    var min = BigInt(0);
    var max = BigInt('0xffffffffffffffff');
    checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
exports.writeBigUInt64LE = writeBigUInt64LE;
function writeBigUInt64BE(buf, value, offset) {
    var min = BigInt(0);
    var max = BigInt('0xffffffffffffffff');
    checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
exports.writeBigUInt64BE = writeBigUInt64BE;
function writeFloat64BE(buf, value, offset) {
    var buff = new ArrayBuffer(8);
    var asFloatArr = new Float64Array(buff);
    asFloatArr[0] = value;
    var asUint8 = new Uint8Array(buff);
    for (var i = 0; i < 8; i++) {
        buf[offset + i] = asUint8[i];
    }
    return offset + 8;
}
exports.writeFloat64BE = writeFloat64BE;


/***/ }),

/***/ 79958:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lz": function() { return /* reexport safe */ _uplc_tx_bg_js__WEBPACK_IMPORTED_MODULE_1__.Lz; }
/* harmony export */ });
/* harmony import */ var _uplc_tx_bg_wasm__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46335);
/* harmony import */ var _uplc_tx_bg_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22095);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_uplc_tx_bg_wasm__WEBPACK_IMPORTED_MODULE_0__]);
_uplc_tx_bg_wasm__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];



(0,_uplc_tx_bg_js__WEBPACK_IMPORTED_MODULE_1__/* .__wbg_set_wasm */ .oT)(_uplc_tx_bg_wasm__WEBPACK_IMPORTED_MODULE_0__);


__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 22095:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BO": function() { return /* binding */ __wbg_buffer_b7b08af79b0b0974; },
/* harmony export */   "Lz": function() { return /* binding */ eval_phase_two_raw; },
/* harmony export */   "Or": function() { return /* binding */ __wbindgen_throw; },
/* harmony export */   "aN": function() { return /* binding */ __wbg_length_8339fcf5d8ecd12e; },
/* harmony export */   "dF": function() { return /* binding */ __wbg_new_ea1883e1e5e86686; },
/* harmony export */   "eF": function() { return /* binding */ __wbg_set_d1e79e2388520f18; },
/* harmony export */   "h4": function() { return /* binding */ __wbindgen_string_new; },
/* harmony export */   "oH": function() { return /* binding */ __wbindgen_memory; },
/* harmony export */   "oT": function() { return /* binding */ __wbg_set_wasm; },
/* harmony export */   "sG": function() { return /* binding */ __wbg_newwithbyteoffsetandlength_8a2cb9ca96b27ec9; },
/* harmony export */   "ug": function() { return /* binding */ __wbindgen_object_drop_ref; }
/* harmony export */ });
/* unused harmony export apply_params_to_script */
/* module decorator */ module = __webpack_require__.hmd(module);
let wasm;
function __wbg_set_wasm(val) {
    wasm = val;
}


const lTextDecoder = typeof TextDecoder === 'undefined' ? (0, module.require)('util').TextDecoder : TextDecoder;

let cachedTextDecoder = new lTextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const heap = new Array(128).fill(undefined);

heap.push(undefined, null, true, false);

let heap_next = heap.length;

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

function getObject(idx) { return heap[idx]; }

function dropObject(idx) {
    if (idx < 132) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

let WASM_VECTOR_LEN = 0;

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

let cachedDataViewMemory0 = null;

function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    const mem = getDataViewMemory0();
    for (let i = 0; i < array.length; i++) {
        mem.setUint32(ptr + 4 * i, addHeapObject(array[i]), true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(takeObject(mem.getUint32(i, true)));
    }
    return result;
}
/**
* @param {Uint8Array} tx_bytes
* @param {(Uint8Array)[]} utxos_bytes_x
* @param {(Uint8Array)[]} utxos_bytes_y
* @param {Uint8Array} cost_mdls_bytes
* @param {bigint} initial_budget_n
* @param {bigint} initial_budget_d
* @param {bigint} slot_config_x
* @param {bigint} slot_config_y
* @param {number} slot_config_z
* @returns {(Uint8Array)[]}
*/
function eval_phase_two_raw(tx_bytes, utxos_bytes_x, utxos_bytes_y, cost_mdls_bytes, initial_budget_n, initial_budget_d, slot_config_x, slot_config_y, slot_config_z) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        const ptr0 = passArray8ToWasm0(tx_bytes, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(utxos_bytes_x, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passArrayJsValueToWasm0(utxos_bytes_y, wasm.__wbindgen_malloc);
        const len2 = WASM_VECTOR_LEN;
        const ptr3 = passArray8ToWasm0(cost_mdls_bytes, wasm.__wbindgen_malloc);
        const len3 = WASM_VECTOR_LEN;
        wasm.eval_phase_two_raw(retptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, initial_budget_n, initial_budget_d, slot_config_x, slot_config_y, slot_config_z);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
        if (r3) {
            throw takeObject(r2);
        }
        var v5 = getArrayJsValueFromWasm0(r0, r1).slice();
        wasm.__wbindgen_free(r0, r1 * 4, 4);
        return v5;
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}
/**
* @param {Uint8Array} params_bytes
* @param {Uint8Array} plutus_script_bytes
* @returns {Uint8Array}
*/
function apply_params_to_script(params_bytes, plutus_script_bytes) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        const ptr0 = passArray8ToWasm0(params_bytes, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArray8ToWasm0(plutus_script_bytes, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        wasm.apply_params_to_script(retptr, ptr0, len0, ptr1, len1);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
        if (r3) {
            throw takeObject(r2);
        }
        var v3 = getArrayU8FromWasm0(r0, r1).slice();
        wasm.__wbindgen_free(r0, r1 * 1, 1);
        return v3;
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

function __wbindgen_string_new(arg0, arg1) {
    const ret = getStringFromWasm0(arg0, arg1);
    return addHeapObject(ret);
};

function __wbindgen_memory() {
    const ret = wasm.memory;
    return addHeapObject(ret);
};

function __wbg_buffer_b7b08af79b0b0974(arg0) {
    const ret = getObject(arg0).buffer;
    return addHeapObject(ret);
};

function __wbg_newwithbyteoffsetandlength_8a2cb9ca96b27ec9(arg0, arg1, arg2) {
    const ret = new Uint8Array(getObject(arg0), arg1 >>> 0, arg2 >>> 0);
    return addHeapObject(ret);
};

function __wbg_new_ea1883e1e5e86686(arg0) {
    const ret = new Uint8Array(getObject(arg0));
    return addHeapObject(ret);
};

function __wbindgen_object_drop_ref(arg0) {
    takeObject(arg0);
};

function __wbg_length_8339fcf5d8ecd12e(arg0) {
    const ret = getObject(arg0).length;
    return ret;
};

function __wbg_set_d1e79e2388520f18(arg0, arg1, arg2) {
    getObject(arg0).set(getObject(arg1), arg2 >>> 0);
};

function __wbindgen_throw(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
};



/***/ }),

/***/ 75457:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SHA512_IV = exports.SHA384_IV = exports.SHA224_IV = exports.SHA256_IV = exports.HashMD = void 0;
exports.setBigUint64 = setBigUint64;
exports.Chi = Chi;
exports.Maj = Maj;
/**
 * Internal Merkle-Damgard hash utils.
 * @module
 */
const utils_ts_1 = __webpack_require__(98089);
/** Polyfill for Safari 14. https://caniuse.com/mdn-javascript_builtins_dataview_setbiguint64 */
function setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function')
        return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number((value >> _32n) & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/** Choice: a ? b : c */
function Chi(a, b, c) {
    return (a & b) ^ (~a & c);
}
/** Majority function, true if any two inputs is true. */
function Maj(a, b, c) {
    return (a & b) ^ (a & c) ^ (b & c);
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */
class HashMD extends utils_ts_1.Hash {
    constructor(blockLen, outputLen, padOffset, isLE) {
        super();
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, utils_ts_1.createView)(this.buffer);
    }
    update(data) {
        (0, utils_ts_1.aexists)(this);
        data = (0, utils_ts_1.toBytes)(data);
        (0, utils_ts_1.abytes)(data);
        const { view, buffer, blockLen } = this;
        const len = data.length;
        for (let pos = 0; pos < len;) {
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, utils_ts_1.createView)(data);
                for (; blockLen <= len - pos; pos += blockLen)
                    this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, utils_ts_1.aexists)(this);
        (0, utils_ts_1.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer, view, blockLen, isLE } = this;
        let { pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 0b10000000;
        (0, utils_ts_1.clean)(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for (let i = pos; i < blockLen; i++)
            buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, utils_ts_1.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4)
            throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length)
            throw new Error('_sha2: outputLen bigger than state');
        for (let i = 0; i < outLen; i++)
            oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer, outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen, buffer, length, finished, destroyed, pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen)
            to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
exports.HashMD = HashMD;
/**
 * Initial SHA-2 state: fractional parts of square roots of first 16 primes 2..53.
 * Check out `test/misc/sha2-gen-iv.js` for recomputation guide.
 */
/** Initial SHA256 state. Bits 0..32 of frac part of sqrt of primes 2..19 */
exports.SHA256_IV = Uint32Array.from([
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19,
]);
/** Initial SHA224 state. Bits 32..64 of frac part of sqrt of primes 23..53 */
exports.SHA224_IV = Uint32Array.from([
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4,
]);
/** Initial SHA384 state. Bits 0..64 of frac part of sqrt of primes 23..53 */
exports.SHA384_IV = Uint32Array.from([
    0xcbbb9d5d, 0xc1059ed8, 0x629a292a, 0x367cd507, 0x9159015a, 0x3070dd17, 0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31, 0x8eb44a87, 0x68581511, 0xdb0c2e0d, 0x64f98fa7, 0x47b5481d, 0xbefa4fa4,
]);
/** Initial SHA512 state. Bits 0..64 of frac part of sqrt of primes 2..19 */
exports.SHA512_IV = Uint32Array.from([
    0x6a09e667, 0xf3bcc908, 0xbb67ae85, 0x84caa73b, 0x3c6ef372, 0xfe94f82b, 0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1, 0x9b05688c, 0x2b3e6c1f, 0x1f83d9ab, 0xfb41bd6b, 0x5be0cd19, 0x137e2179,
]);
//# sourceMappingURL=_md.js.map

/***/ }),

/***/ 6873:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.toBig = exports.shrSL = exports.shrSH = exports.rotrSL = exports.rotrSH = exports.rotrBL = exports.rotrBH = exports.rotr32L = exports.rotr32H = exports.rotlSL = exports.rotlSH = exports.rotlBL = exports.rotlBH = exports.add5L = exports.add5H = exports.add4L = exports.add4H = exports.add3L = exports.add3H = void 0;
exports.add = add;
exports.fromBig = fromBig;
exports.split = split;
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const _32n = /* @__PURE__ */ BigInt(32);
function fromBig(n, le = false) {
    if (le)
        return { h: Number(n & U32_MASK64), l: Number((n >> _32n) & U32_MASK64) };
    return { h: Number((n >> _32n) & U32_MASK64) | 0, l: Number(n & U32_MASK64) | 0 };
}
function split(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for (let i = 0; i < len; i++) {
        const { h, l } = fromBig(lst[i], le);
        [Ah[i], Al[i]] = [h, l];
    }
    return [Ah, Al];
}
const toBig = (h, l) => (BigInt(h >>> 0) << _32n) | BigInt(l >>> 0);
exports.toBig = toBig;
// for Shift in [0, 32)
const shrSH = (h, _l, s) => h >>> s;
exports.shrSH = shrSH;
const shrSL = (h, l, s) => (h << (32 - s)) | (l >>> s);
exports.shrSL = shrSL;
// Right rotate for Shift in [1, 32)
const rotrSH = (h, l, s) => (h >>> s) | (l << (32 - s));
exports.rotrSH = rotrSH;
const rotrSL = (h, l, s) => (h << (32 - s)) | (l >>> s);
exports.rotrSL = rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotrBH = (h, l, s) => (h << (64 - s)) | (l >>> (s - 32));
exports.rotrBH = rotrBH;
const rotrBL = (h, l, s) => (h >>> (s - 32)) | (l << (64 - s));
exports.rotrBL = rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const rotr32H = (_h, l) => l;
exports.rotr32H = rotr32H;
const rotr32L = (h, _l) => h;
exports.rotr32L = rotr32L;
// Left rotate for Shift in [1, 32)
const rotlSH = (h, l, s) => (h << s) | (l >>> (32 - s));
exports.rotlSH = rotlSH;
const rotlSL = (h, l, s) => (l << s) | (h >>> (32 - s));
exports.rotlSL = rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotlBH = (h, l, s) => (l << (s - 32)) | (h >>> (64 - s));
exports.rotlBH = rotlBH;
const rotlBL = (h, l, s) => (h << (s - 32)) | (l >>> (64 - s));
exports.rotlBL = rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return { h: (Ah + Bh + ((l / 2 ** 32) | 0)) | 0, l: l | 0 };
}
// Addition with more than 2 elements
const add3L = (Al, Bl, Cl) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
exports.add3L = add3L;
const add3H = (low, Ah, Bh, Ch) => (Ah + Bh + Ch + ((low / 2 ** 32) | 0)) | 0;
exports.add3H = add3H;
const add4L = (Al, Bl, Cl, Dl) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
exports.add4L = add4L;
const add4H = (low, Ah, Bh, Ch, Dh) => (Ah + Bh + Ch + Dh + ((low / 2 ** 32) | 0)) | 0;
exports.add4H = add4H;
const add5L = (Al, Bl, Cl, Dl, El) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
exports.add5L = add5L;
const add5H = (low, Ah, Bh, Ch, Dh, Eh) => (Ah + Bh + Ch + Dh + Eh + ((low / 2 ** 32) | 0)) | 0;
exports.add5H = add5H;
// prettier-ignore
const u64 = {
    fromBig, split, toBig,
    shrSH, shrSL,
    rotrSH, rotrSL, rotrBH, rotrBL,
    rotr32H, rotr32L,
    rotlSH, rotlSL, rotlBH, rotlBL,
    add, add3L, add3H, add4L, add4H, add5H, add5L,
};
exports["default"] = u64;
//# sourceMappingURL=_u64.js.map

/***/ }),

/***/ 31945:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.crypto = void 0;
exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;
//# sourceMappingURL=crypto.js.map

/***/ }),

/***/ 79569:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hmac = exports.HMAC = void 0;
/**
 * HMAC: RFC2104 message authentication code.
 * @module
 */
const utils_ts_1 = __webpack_require__(98089);
class HMAC extends utils_ts_1.Hash {
    constructor(hash, _key) {
        super();
        this.finished = false;
        this.destroyed = false;
        (0, utils_ts_1.ahash)(hash);
        const key = (0, utils_ts_1.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function')
            throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for (let i = 0; i < pad.length; i++)
            pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for (let i = 0; i < pad.length; i++)
            pad[i] ^= 0x36 ^ 0x5c;
        this.oHash.update(pad);
        (0, utils_ts_1.clean)(pad);
    }
    update(buf) {
        (0, utils_ts_1.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, utils_ts_1.aexists)(this);
        (0, utils_ts_1.abytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash, iHash, finished, destroyed, blockLen, outputLen } = this;
        to = to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
exports.HMAC = HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 * @example
 * import { hmac } from '@noble/hashes/hmac';
 * import { sha256 } from '@noble/hashes/sha2';
 * const mac1 = hmac(sha256, 'key', 'message');
 */
const hmac = (hash, key, message) => new HMAC(hash, key).update(message).digest();
exports.hmac = hmac;
exports.hmac.create = (hash, key) => new HMAC(hash, key);
//# sourceMappingURL=hmac.js.map

/***/ }),

/***/ 29023:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pbkdf2 = pbkdf2;
exports.pbkdf2Async = pbkdf2Async;
/**
 * PBKDF (RFC 2898). Can be used to create a key from password and salt.
 * @module
 */
const hmac_ts_1 = __webpack_require__(79569);
// prettier-ignore
const utils_ts_1 = __webpack_require__(98089);
// Common prologue and epilogue for sync/async functions
function pbkdf2Init(hash, _password, _salt, _opts) {
    (0, utils_ts_1.ahash)(hash);
    const opts = (0, utils_ts_1.checkOpts)({ dkLen: 32, asyncTick: 10 }, _opts);
    const { c, dkLen, asyncTick } = opts;
    (0, utils_ts_1.anumber)(c);
    (0, utils_ts_1.anumber)(dkLen);
    (0, utils_ts_1.anumber)(asyncTick);
    if (c < 1)
        throw new Error('iterations (c) should be >= 1');
    const password = (0, utils_ts_1.kdfInputToBytes)(_password);
    const salt = (0, utils_ts_1.kdfInputToBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = hmac_ts_1.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return { c, dkLen, asyncTick, DK, PRF, PRFSalt };
}
function pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW)
        prfW.destroy();
    (0, utils_ts_1.clean)(u);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 * @example
 * const key = pbkdf2(sha256, 'password', 'salt', { dkLen: 32, c: Math.pow(2, 18) });
 */
function pbkdf2(hash, password, salt, opts) {
    const { c, dkLen, DK, PRF, PRFSalt } = pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, utils_ts_1.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for (let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen) {
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for (let ui = 1; ui < c; ui++) {
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for (let i = 0; i < Ti.length; i++)
                Ti[i] ^= u[i];
        }
    }
    return pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function. Async version.
 * @example
 * await pbkdf2Async(sha256, 'password', 'salt', { dkLen: 32, c: 500_000 });
 */
async function pbkdf2Async(hash, password, salt, opts) {
    const { c, dkLen, asyncTick, DK, PRF, PRFSalt } = pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, utils_ts_1.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for (let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen) {
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, utils_ts_1.asyncLoop)(c - 1, asyncTick, () => {
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for (let i = 0; i < Ti.length; i++)
                Ti[i] ^= u[i];
        });
    }
    return pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
//# sourceMappingURL=pbkdf2.js.map

/***/ }),

/***/ 39199:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha512_224 = exports.sha512_256 = exports.sha384 = exports.sha512 = exports.sha224 = exports.sha256 = exports.SHA512_256 = exports.SHA512_224 = exports.SHA384 = exports.SHA512 = exports.SHA224 = exports.SHA256 = void 0;
/**
 * SHA2 hash function. A.k.a. sha256, sha384, sha512, sha512_224, sha512_256.
 * SHA256 is the fastest hash implementable in JS, even faster than Blake3.
 * Check out [RFC 4634](https://datatracker.ietf.org/doc/html/rfc4634) and
 * [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */
const _md_ts_1 = __webpack_require__(75457);
const u64 = __webpack_require__(6873);
const utils_ts_1 = __webpack_require__(98089);
/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */
// prettier-ignore
const SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */
const SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends _md_ts_1.HashMD {
    constructor(outputLen = 32) {
        super(64, outputLen, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = _md_ts_1.SHA256_IV[0] | 0;
        this.B = _md_ts_1.SHA256_IV[1] | 0;
        this.C = _md_ts_1.SHA256_IV[2] | 0;
        this.D = _md_ts_1.SHA256_IV[3] | 0;
        this.E = _md_ts_1.SHA256_IV[4] | 0;
        this.F = _md_ts_1.SHA256_IV[5] | 0;
        this.G = _md_ts_1.SHA256_IV[6] | 0;
        this.H = _md_ts_1.SHA256_IV[7] | 0;
    }
    get() {
        const { A, B, C, D, E, F, G, H } = this;
        return [A, B, C, D, E, F, G, H];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for (let i = 0; i < 16; i++, offset += 4)
            SHA256_W[i] = view.getUint32(offset, false);
        for (let i = 16; i < 64; i++) {
            const W15 = SHA256_W[i - 15];
            const W2 = SHA256_W[i - 2];
            const s0 = (0, utils_ts_1.rotr)(W15, 7) ^ (0, utils_ts_1.rotr)(W15, 18) ^ (W15 >>> 3);
            const s1 = (0, utils_ts_1.rotr)(W2, 17) ^ (0, utils_ts_1.rotr)(W2, 19) ^ (W2 >>> 10);
            SHA256_W[i] = (s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16]) | 0;
        }
        // Compression function main loop, 64 rounds
        let { A, B, C, D, E, F, G, H } = this;
        for (let i = 0; i < 64; i++) {
            const sigma1 = (0, utils_ts_1.rotr)(E, 6) ^ (0, utils_ts_1.rotr)(E, 11) ^ (0, utils_ts_1.rotr)(E, 25);
            const T1 = (H + sigma1 + (0, _md_ts_1.Chi)(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const sigma0 = (0, utils_ts_1.rotr)(A, 2) ^ (0, utils_ts_1.rotr)(A, 13) ^ (0, utils_ts_1.rotr)(A, 22);
            const T2 = (sigma0 + (0, _md_ts_1.Maj)(A, B, C)) | 0;
            H = G;
            G = F;
            F = E;
            E = (D + T1) | 0;
            D = C;
            C = B;
            B = A;
            A = (T1 + T2) | 0;
        }
        // Add the compressed chunk to the current hash value
        A = (A + this.A) | 0;
        B = (B + this.B) | 0;
        C = (C + this.C) | 0;
        D = (D + this.D) | 0;
        E = (E + this.E) | 0;
        F = (F + this.F) | 0;
        G = (G + this.G) | 0;
        H = (H + this.H) | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, utils_ts_1.clean)(SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, utils_ts_1.clean)(this.buffer);
    }
}
exports.SHA256 = SHA256;
class SHA224 extends SHA256 {
    constructor() {
        super(28);
        this.A = _md_ts_1.SHA224_IV[0] | 0;
        this.B = _md_ts_1.SHA224_IV[1] | 0;
        this.C = _md_ts_1.SHA224_IV[2] | 0;
        this.D = _md_ts_1.SHA224_IV[3] | 0;
        this.E = _md_ts_1.SHA224_IV[4] | 0;
        this.F = _md_ts_1.SHA224_IV[5] | 0;
        this.G = _md_ts_1.SHA224_IV[6] | 0;
        this.H = _md_ts_1.SHA224_IV[7] | 0;
    }
}
exports.SHA224 = SHA224;
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const K512 = /* @__PURE__ */ (() => u64.split([
    '0x428a2f98d728ae22', '0x7137449123ef65cd', '0xb5c0fbcfec4d3b2f', '0xe9b5dba58189dbbc',
    '0x3956c25bf348b538', '0x59f111f1b605d019', '0x923f82a4af194f9b', '0xab1c5ed5da6d8118',
    '0xd807aa98a3030242', '0x12835b0145706fbe', '0x243185be4ee4b28c', '0x550c7dc3d5ffb4e2',
    '0x72be5d74f27b896f', '0x80deb1fe3b1696b1', '0x9bdc06a725c71235', '0xc19bf174cf692694',
    '0xe49b69c19ef14ad2', '0xefbe4786384f25e3', '0x0fc19dc68b8cd5b5', '0x240ca1cc77ac9c65',
    '0x2de92c6f592b0275', '0x4a7484aa6ea6e483', '0x5cb0a9dcbd41fbd4', '0x76f988da831153b5',
    '0x983e5152ee66dfab', '0xa831c66d2db43210', '0xb00327c898fb213f', '0xbf597fc7beef0ee4',
    '0xc6e00bf33da88fc2', '0xd5a79147930aa725', '0x06ca6351e003826f', '0x142929670a0e6e70',
    '0x27b70a8546d22ffc', '0x2e1b21385c26c926', '0x4d2c6dfc5ac42aed', '0x53380d139d95b3df',
    '0x650a73548baf63de', '0x766a0abb3c77b2a8', '0x81c2c92e47edaee6', '0x92722c851482353b',
    '0xa2bfe8a14cf10364', '0xa81a664bbc423001', '0xc24b8b70d0f89791', '0xc76c51a30654be30',
    '0xd192e819d6ef5218', '0xd69906245565a910', '0xf40e35855771202a', '0x106aa07032bbd1b8',
    '0x19a4c116b8d2d0c8', '0x1e376c085141ab53', '0x2748774cdf8eeb99', '0x34b0bcb5e19b48a8',
    '0x391c0cb3c5c95a63', '0x4ed8aa4ae3418acb', '0x5b9cca4f7763e373', '0x682e6ff3d6b2b8a3',
    '0x748f82ee5defb2fc', '0x78a5636f43172f60', '0x84c87814a1f0ab72', '0x8cc702081a6439ec',
    '0x90befffa23631e28', '0xa4506cebde82bde9', '0xbef9a3f7b2c67915', '0xc67178f2e372532b',
    '0xca273eceea26619c', '0xd186b8c721c0c207', '0xeada7dd6cde0eb1e', '0xf57d4f7fee6ed178',
    '0x06f067aa72176fba', '0x0a637dc5a2c898a6', '0x113f9804bef90dae', '0x1b710b35131c471b',
    '0x28db77f523047d84', '0x32caab7b40c72493', '0x3c9ebe0a15c9bebc', '0x431d67c49c100d4c',
    '0x4cc5d4becb3e42b6', '0x597f299cfc657e2a', '0x5fcb6fab3ad6faec', '0x6c44198c4a475817'
].map(n => BigInt(n))))();
const SHA512_Kh = /* @__PURE__ */ (() => K512[0])();
const SHA512_Kl = /* @__PURE__ */ (() => K512[1])();
// Reusable temporary buffers
const SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class SHA512 extends _md_ts_1.HashMD {
    constructor(outputLen = 64) {
        super(128, outputLen, 16, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = _md_ts_1.SHA512_IV[0] | 0;
        this.Al = _md_ts_1.SHA512_IV[1] | 0;
        this.Bh = _md_ts_1.SHA512_IV[2] | 0;
        this.Bl = _md_ts_1.SHA512_IV[3] | 0;
        this.Ch = _md_ts_1.SHA512_IV[4] | 0;
        this.Cl = _md_ts_1.SHA512_IV[5] | 0;
        this.Dh = _md_ts_1.SHA512_IV[6] | 0;
        this.Dl = _md_ts_1.SHA512_IV[7] | 0;
        this.Eh = _md_ts_1.SHA512_IV[8] | 0;
        this.El = _md_ts_1.SHA512_IV[9] | 0;
        this.Fh = _md_ts_1.SHA512_IV[10] | 0;
        this.Fl = _md_ts_1.SHA512_IV[11] | 0;
        this.Gh = _md_ts_1.SHA512_IV[12] | 0;
        this.Gl = _md_ts_1.SHA512_IV[13] | 0;
        this.Hh = _md_ts_1.SHA512_IV[14] | 0;
        this.Hl = _md_ts_1.SHA512_IV[15] | 0;
    }
    // prettier-ignore
    get() {
        const { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        return [Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for (let i = 0; i < 16; i++, offset += 4) {
            SHA512_W_H[i] = view.getUint32(offset);
            SHA512_W_L[i] = view.getUint32((offset += 4));
        }
        for (let i = 16; i < 80; i++) {
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = SHA512_W_H[i - 15] | 0;
            const W15l = SHA512_W_L[i - 15] | 0;
            const s0h = u64.rotrSH(W15h, W15l, 1) ^ u64.rotrSH(W15h, W15l, 8) ^ u64.shrSH(W15h, W15l, 7);
            const s0l = u64.rotrSL(W15h, W15l, 1) ^ u64.rotrSL(W15h, W15l, 8) ^ u64.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = SHA512_W_H[i - 2] | 0;
            const W2l = SHA512_W_L[i - 2] | 0;
            const s1h = u64.rotrSH(W2h, W2l, 19) ^ u64.rotrBH(W2h, W2l, 61) ^ u64.shrSH(W2h, W2l, 6);
            const s1l = u64.rotrSL(W2h, W2l, 19) ^ u64.rotrBL(W2h, W2l, 61) ^ u64.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = u64.add4L(s0l, s1l, SHA512_W_L[i - 7], SHA512_W_L[i - 16]);
            const SUMh = u64.add4H(SUMl, s0h, s1h, SHA512_W_H[i - 7], SHA512_W_H[i - 16]);
            SHA512_W_H[i] = SUMh | 0;
            SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        // Compression function main loop, 80 rounds
        for (let i = 0; i < 80; i++) {
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = u64.rotrSH(Eh, El, 14) ^ u64.rotrSH(Eh, El, 18) ^ u64.rotrBH(Eh, El, 41);
            const sigma1l = u64.rotrSL(Eh, El, 14) ^ u64.rotrSL(Eh, El, 18) ^ u64.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = (Eh & Fh) ^ (~Eh & Gh);
            const CHIl = (El & Fl) ^ (~El & Gl);
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = u64.add5L(Hl, sigma1l, CHIl, SHA512_Kl[i], SHA512_W_L[i]);
            const T1h = u64.add5H(T1ll, Hh, sigma1h, CHIh, SHA512_Kh[i], SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = u64.rotrSH(Ah, Al, 28) ^ u64.rotrBH(Ah, Al, 34) ^ u64.rotrBH(Ah, Al, 39);
            const sigma0l = u64.rotrSL(Ah, Al, 28) ^ u64.rotrBL(Ah, Al, 34) ^ u64.rotrBL(Ah, Al, 39);
            const MAJh = (Ah & Bh) ^ (Ah & Ch) ^ (Bh & Ch);
            const MAJl = (Al & Bl) ^ (Al & Cl) ^ (Bl & Cl);
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = u64.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = u64.add3L(T1l, sigma0l, MAJl);
            Ah = u64.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = u64.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = u64.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = u64.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = u64.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = u64.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = u64.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = u64.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = u64.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, utils_ts_1.clean)(SHA512_W_H, SHA512_W_L);
    }
    destroy() {
        (0, utils_ts_1.clean)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
exports.SHA512 = SHA512;
class SHA384 extends SHA512 {
    constructor() {
        super(48);
        this.Ah = _md_ts_1.SHA384_IV[0] | 0;
        this.Al = _md_ts_1.SHA384_IV[1] | 0;
        this.Bh = _md_ts_1.SHA384_IV[2] | 0;
        this.Bl = _md_ts_1.SHA384_IV[3] | 0;
        this.Ch = _md_ts_1.SHA384_IV[4] | 0;
        this.Cl = _md_ts_1.SHA384_IV[5] | 0;
        this.Dh = _md_ts_1.SHA384_IV[6] | 0;
        this.Dl = _md_ts_1.SHA384_IV[7] | 0;
        this.Eh = _md_ts_1.SHA384_IV[8] | 0;
        this.El = _md_ts_1.SHA384_IV[9] | 0;
        this.Fh = _md_ts_1.SHA384_IV[10] | 0;
        this.Fl = _md_ts_1.SHA384_IV[11] | 0;
        this.Gh = _md_ts_1.SHA384_IV[12] | 0;
        this.Gl = _md_ts_1.SHA384_IV[13] | 0;
        this.Hh = _md_ts_1.SHA384_IV[14] | 0;
        this.Hl = _md_ts_1.SHA384_IV[15] | 0;
    }
}
exports.SHA384 = SHA384;
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */
/** SHA512/224 IV */
const T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8, 0x19544da2, 0x73e19966, 0x89dcd4d6, 0x1dfab7ae, 0x32ff9c82, 0x679dd514, 0x582f9fcf,
    0x0f6d2b69, 0x7bd44da8, 0x77e36f73, 0x04c48942, 0x3f9d85a8, 0x6a1d36c8, 0x1112e6ad, 0x91d692a1,
]);
/** SHA512/256 IV */
const T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194, 0xfc2bf72c, 0x9f555fa3, 0xc84c64c2, 0x2393b86b, 0x6f53b151, 0x96387719, 0x5940eabd,
    0x96283ee2, 0xa88effe3, 0xbe5e1e25, 0x53863992, 0x2b0199fc, 0x2c85b8aa, 0x0eb72ddc, 0x81c52ca2,
]);
class SHA512_224 extends SHA512 {
    constructor() {
        super(28);
        this.Ah = T224_IV[0] | 0;
        this.Al = T224_IV[1] | 0;
        this.Bh = T224_IV[2] | 0;
        this.Bl = T224_IV[3] | 0;
        this.Ch = T224_IV[4] | 0;
        this.Cl = T224_IV[5] | 0;
        this.Dh = T224_IV[6] | 0;
        this.Dl = T224_IV[7] | 0;
        this.Eh = T224_IV[8] | 0;
        this.El = T224_IV[9] | 0;
        this.Fh = T224_IV[10] | 0;
        this.Fl = T224_IV[11] | 0;
        this.Gh = T224_IV[12] | 0;
        this.Gl = T224_IV[13] | 0;
        this.Hh = T224_IV[14] | 0;
        this.Hl = T224_IV[15] | 0;
    }
}
exports.SHA512_224 = SHA512_224;
class SHA512_256 extends SHA512 {
    constructor() {
        super(32);
        this.Ah = T256_IV[0] | 0;
        this.Al = T256_IV[1] | 0;
        this.Bh = T256_IV[2] | 0;
        this.Bl = T256_IV[3] | 0;
        this.Ch = T256_IV[4] | 0;
        this.Cl = T256_IV[5] | 0;
        this.Dh = T256_IV[6] | 0;
        this.Dl = T256_IV[7] | 0;
        this.Eh = T256_IV[8] | 0;
        this.El = T256_IV[9] | 0;
        this.Fh = T256_IV[10] | 0;
        this.Fl = T256_IV[11] | 0;
        this.Gh = T256_IV[12] | 0;
        this.Gl = T256_IV[13] | 0;
        this.Hh = T256_IV[14] | 0;
        this.Hl = T256_IV[15] | 0;
    }
}
exports.SHA512_256 = SHA512_256;
/**
 * SHA2-256 hash function from RFC 4634.
 *
 * It is the fastest JS hash, even faster than Blake3.
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 */
exports.sha256 = (0, utils_ts_1.createHasher)(() => new SHA256());
/** SHA2-224 hash function from RFC 4634 */
exports.sha224 = (0, utils_ts_1.createHasher)(() => new SHA224());
/** SHA2-512 hash function from RFC 4634. */
exports.sha512 = (0, utils_ts_1.createHasher)(() => new SHA512());
/** SHA2-384 hash function from RFC 4634. */
exports.sha384 = (0, utils_ts_1.createHasher)(() => new SHA384());
/**
 * SHA2-512/256 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */
exports.sha512_256 = (0, utils_ts_1.createHasher)(() => new SHA512_256());
/**
 * SHA2-512/224 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */
exports.sha512_224 = (0, utils_ts_1.createHasher)(() => new SHA512_224());
//# sourceMappingURL=sha2.js.map

/***/ }),

/***/ 23061:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha224 = exports.SHA224 = exports.sha256 = exports.SHA256 = void 0;
/**
 * SHA2-256 a.k.a. sha256. In JS, it is the fastest hash, even faster than Blake3.
 *
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 *
 * Check out [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 * @deprecated
 */
const sha2_ts_1 = __webpack_require__(39199);
/** @deprecated Use import from `noble/hashes/sha2` module */
exports.SHA256 = sha2_ts_1.SHA256;
/** @deprecated Use import from `noble/hashes/sha2` module */
exports.sha256 = sha2_ts_1.sha256;
/** @deprecated Use import from `noble/hashes/sha2` module */
exports.SHA224 = sha2_ts_1.SHA224;
/** @deprecated Use import from `noble/hashes/sha2` module */
exports.sha224 = sha2_ts_1.sha224;
//# sourceMappingURL=sha256.js.map

/***/ }),

/***/ 86262:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha512_256 = exports.SHA512_256 = exports.sha512_224 = exports.SHA512_224 = exports.sha384 = exports.SHA384 = exports.sha512 = exports.SHA512 = void 0;
/**
 * SHA2-512 a.k.a. sha512 and sha384. It is slower than sha256 in js because u64 operations are slow.
 *
 * Check out [RFC 4634](https://datatracker.ietf.org/doc/html/rfc4634) and
 * [the paper on truncated SHA512/256](https://eprint.iacr.org/2010/548.pdf).
 * @module
 * @deprecated
 */
const sha2_ts_1 = __webpack_require__(39199);
/** @deprecated Use import from `noble/hashes/sha2` module */
exports.SHA512 = sha2_ts_1.SHA512;
/** @deprecated Use import from `noble/hashes/sha2` module */
exports.sha512 = sha2_ts_1.sha512;
/** @deprecated Use import from `noble/hashes/sha2` module */
exports.SHA384 = sha2_ts_1.SHA384;
/** @deprecated Use import from `noble/hashes/sha2` module */
exports.sha384 = sha2_ts_1.sha384;
/** @deprecated Use import from `noble/hashes/sha2` module */
exports.SHA512_224 = sha2_ts_1.SHA512_224;
/** @deprecated Use import from `noble/hashes/sha2` module */
exports.sha512_224 = sha2_ts_1.sha512_224;
/** @deprecated Use import from `noble/hashes/sha2` module */
exports.SHA512_256 = sha2_ts_1.SHA512_256;
/** @deprecated Use import from `noble/hashes/sha2` module */
exports.sha512_256 = sha2_ts_1.sha512_256;
//# sourceMappingURL=sha512.js.map

/***/ }),

/***/ 98089:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.wrapXOFConstructorWithOpts = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.Hash = exports.nextTick = exports.swap32IfBE = exports.byteSwapIfBE = exports.swap8IfBE = exports.isLE = void 0;
exports.isBytes = isBytes;
exports.anumber = anumber;
exports.abytes = abytes;
exports.ahash = ahash;
exports.aexists = aexists;
exports.aoutput = aoutput;
exports.u8 = u8;
exports.u32 = u32;
exports.clean = clean;
exports.createView = createView;
exports.rotr = rotr;
exports.rotl = rotl;
exports.byteSwap = byteSwap;
exports.byteSwap32 = byteSwap32;
exports.bytesToHex = bytesToHex;
exports.hexToBytes = hexToBytes;
exports.asyncLoop = asyncLoop;
exports.utf8ToBytes = utf8ToBytes;
exports.bytesToUtf8 = bytesToUtf8;
exports.toBytes = toBytes;
exports.kdfInputToBytes = kdfInputToBytes;
exports.concatBytes = concatBytes;
exports.checkOpts = checkOpts;
exports.createHasher = createHasher;
exports.createOptHasher = createOptHasher;
exports.createXOFer = createXOFer;
exports.randomBytes = randomBytes;
// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const crypto_1 = __webpack_require__(31945);
/** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */
function isBytes(a) {
    return a instanceof Uint8Array || (ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array');
}
/** Asserts something is positive integer. */
function anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0)
        throw new Error('positive integer expected, got ' + n);
}
/** Asserts something is Uint8Array. */
function abytes(b, ...lengths) {
    if (!isBytes(b))
        throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length))
        throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
/** Asserts something is hash */
function ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function')
        throw new Error('Hash should be wrapped by utils.createHasher');
    anumber(h.outputLen);
    anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */
function aexists(instance, checkFinished = true) {
    if (instance.destroyed)
        throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished)
        throw new Error('Hash#digest() has already been called');
}
/** Asserts output is properly-sized byte array */
function aoutput(out, instance) {
    abytes(out);
    const min = instance.outputLen;
    if (out.length < min) {
        throw new Error('digestInto() expects output buffer of length at least ' + min);
    }
}
/** Cast u8 / u16 / u32 to u8. */
function u8(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** Cast u8 / u16 / u32 to u32. */
function u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
/** Zeroize a byte array. Warning: JS provides no guarantees. */
function clean(...arrays) {
    for (let i = 0; i < arrays.length; i++) {
        arrays[i].fill(0);
    }
}
/** Create DataView of an array for easy byte-level manipulation. */
function createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */
function rotr(word, shift) {
    return (word << (32 - shift)) | (word >>> shift);
}
/** The rotate left (circular left shift) operation for uint32 */
function rotl(word, shift) {
    return (word << shift) | ((word >>> (32 - shift)) >>> 0);
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */
exports.isLE = (() => new Uint8Array(new Uint32Array([0x11223344]).buffer)[0] === 0x44)();
/** The byte swap operation for uint32 */
function byteSwap(word) {
    return (((word << 24) & 0xff000000) |
        ((word << 8) & 0xff0000) |
        ((word >>> 8) & 0xff00) |
        ((word >>> 24) & 0xff));
}
/** Conditionally byte swap if on a big-endian platform */
exports.swap8IfBE = exports.isLE
    ? (n) => n
    : (n) => byteSwap(n);
/** @deprecated */
exports.byteSwapIfBE = exports.swap8IfBE;
/** In place byte swap for Uint32Array */
function byteSwap32(arr) {
    for (let i = 0; i < arr.length; i++) {
        arr[i] = byteSwap(arr[i]);
    }
    return arr;
}
exports.swap32IfBE = exports.isLE
    ? (u) => u
    : byteSwap32;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const hasHexBuiltin = /* @__PURE__ */ (() => 
// @ts-ignore
typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({ length: 256 }, (_, i) => i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string. Uses built-in function, when available.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */
function bytesToHex(bytes) {
    abytes(bytes);
    // @ts-ignore
    if (hasHexBuiltin)
        return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for (let i = 0; i < bytes.length; i++) {
        hex += hexes[bytes[i]];
    }
    return hex;
}
// We use optimized technique to convert hex string to byte array
const asciis = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function asciiToBase16(ch) {
    if (ch >= asciis._0 && ch <= asciis._9)
        return ch - asciis._0; // '2' => 50-48
    if (ch >= asciis.A && ch <= asciis.F)
        return ch - (asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= asciis.a && ch <= asciis.f)
        return ch - (asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array. Uses built-in function, when available.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */
function hexToBytes(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if (hasHexBuiltin)
        return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2)
        throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for (let ai = 0, hi = 0; ai < al; ai++, hi += 2) {
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
/**
 * There is no setImmediate in browser and setTimeout is slow.
 * Call of async fn will return Promise, which will be fullfiled only on
 * next scheduler queue processing step and this is exactly what we need.
 */
const nextTick = async () => { };
exports.nextTick = nextTick;
/** Returns control to thread each 'tick' ms to avoid blocking. */
async function asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for (let i = 0; i < iters; i++) {
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick)
            continue;
        await (0, exports.nextTick)();
        ts += diff;
    }
}
/**
 * Converts string to bytes using UTF8 encoding.
 * @example utf8ToBytes('abc') // Uint8Array.from([97, 98, 99])
 */
function utf8ToBytes(str) {
    if (typeof str !== 'string')
        throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Converts bytes to string using UTF8 encoding.
 * @example bytesToUtf8(Uint8Array.from([97, 98, 99])) // 'abc'
 */
function bytesToUtf8(bytes) {
    return new TextDecoder().decode(bytes);
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */
function toBytes(data) {
    if (typeof data === 'string')
        data = utf8ToBytes(data);
    abytes(data);
    return data;
}
/**
 * Helper for KDFs: consumes uint8array or string.
 * When string is passed, does utf8 decoding, using TextDecoder.
 */
function kdfInputToBytes(data) {
    if (typeof data === 'string')
        data = utf8ToBytes(data);
    abytes(data);
    return data;
}
/** Copies several Uint8Arrays into one. */
function concatBytes(...arrays) {
    let sum = 0;
    for (let i = 0; i < arrays.length; i++) {
        const a = arrays[i];
        abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for (let i = 0, pad = 0; i < arrays.length; i++) {
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function checkOpts(defaults, opts) {
    if (opts !== undefined && {}.toString.call(opts) !== '[object Object]')
        throw new Error('options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
/** For runtime check if class implements interface */
class Hash {
}
exports.Hash = Hash;
/** Wraps hash function, creating an interface on top of it */
function createHasher(hashCons) {
    const hashC = (msg) => hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = () => hashCons();
    return hashC;
}
function createOptHasher(hashCons) {
    const hashC = (msg, opts) => hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts) => hashCons(opts);
    return hashC;
}
function createXOFer(hashCons) {
    const hashC = (msg, opts) => hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts) => hashCons(opts);
    return hashC;
}
exports.wrapConstructor = createHasher;
exports.wrapConstructorWithOpts = createOptHasher;
exports.wrapXOFConstructorWithOpts = createXOFer;
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */
function randomBytes(bytesLength = 32) {
    if (crypto_1.crypto && typeof crypto_1.crypto.getRandomValues === 'function') {
        return crypto_1.crypto.getRandomValues(new Uint8Array(bytesLength));
    }
    // Legacy Node.js compatibility
    if (crypto_1.crypto && typeof crypto_1.crypto.randomBytes === 'function') {
        return Uint8Array.from(crypto_1.crypto.randomBytes(bytesLength));
    }
    throw new Error('crypto.getRandomValues must be defined');
}
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 79361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 79742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 42314:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
// browserify by default only pulls in files that are hard coded in requires
// In order of last to first in this file, the default wordlist will be chosen
// based on what is present. (Bundles may remove wordlists they don't need)
const wordlists = {};
exports.wordlists = wordlists;
let _default;
exports._default = _default;
try {
    exports._default = _default = __webpack_require__(40032);
    wordlists.czech = _default;
}
catch (err) { }
try {
    exports._default = _default = __webpack_require__(46996);
    wordlists.chinese_simplified = _default;
}
catch (err) { }
try {
    exports._default = _default = __webpack_require__(4262);
    wordlists.chinese_traditional = _default;
}
catch (err) { }
try {
    exports._default = _default = __webpack_require__(8013);
    wordlists.korean = _default;
}
catch (err) { }
try {
    exports._default = _default = __webpack_require__(11848);
    wordlists.french = _default;
}
catch (err) { }
try {
    exports._default = _default = __webpack_require__(72841);
    wordlists.italian = _default;
}
catch (err) { }
try {
    exports._default = _default = __webpack_require__(80659);
    wordlists.spanish = _default;
}
catch (err) { }
try {
    exports._default = _default = __webpack_require__(94472);
    wordlists.japanese = _default;
    wordlists.JA = _default;
}
catch (err) { }
try {
    exports._default = _default = __webpack_require__(71945);
    wordlists.portuguese = _default;
}
catch (err) { }
try {
    exports._default = _default = __webpack_require__(24573);
    wordlists.english = _default;
    wordlists.EN = _default;
}
catch (err) { }


/***/ }),

/***/ 2153:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];

__webpack_unused_export__ = ({ value: true });
const sha256_1 = __webpack_require__(23061);
const sha512_1 = __webpack_require__(86262);
const pbkdf2_1 = __webpack_require__(29023);
const utils_1 = __webpack_require__(98089);
const _wordlists_1 = __webpack_require__(42314);
let DEFAULT_WORDLIST = _wordlists_1._default;
const INVALID_MNEMONIC = 'Invalid mnemonic';
const INVALID_ENTROPY = 'Invalid entropy';
const INVALID_CHECKSUM = 'Invalid mnemonic checksum';
const WORDLIST_REQUIRED = 'A wordlist is required but a default could not be found.\n' +
    'Please pass a 2048 word array explicitly.';
function normalize(str) {
    return (str || '').normalize('NFKD');
}
function lpad(str, padString, length) {
    while (str.length < length) {
        str = padString + str;
    }
    return str;
}
function binaryToByte(bin) {
    return parseInt(bin, 2);
}
function bytesToBinary(bytes) {
    return bytes.map((x) => lpad(x.toString(2), '0', 8)).join('');
}
function deriveChecksumBits(entropyBuffer) {
    const ENT = entropyBuffer.length * 8;
    const CS = ENT / 32;
    const hash = sha256_1.sha256(Uint8Array.from(entropyBuffer));
    return bytesToBinary(Array.from(hash)).slice(0, CS);
}
function salt(password) {
    return 'mnemonic' + (password || '');
}
function mnemonicToSeedSync(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from(Buffer.from(normalize(mnemonic), 'utf8'));
    const saltBuffer = Uint8Array.from(Buffer.from(salt(normalize(password)), 'utf8'));
    const res = pbkdf2_1.pbkdf2(sha512_1.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64,
    });
    return Buffer.from(res);
}
__webpack_unused_export__ = mnemonicToSeedSync;
function mnemonicToSeed(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from(Buffer.from(normalize(mnemonic), 'utf8'));
    const saltBuffer = Uint8Array.from(Buffer.from(salt(normalize(password)), 'utf8'));
    return pbkdf2_1.pbkdf2Async(sha512_1.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64,
    }).then((res) => Buffer.from(res));
}
__webpack_unused_export__ = mnemonicToSeed;
function mnemonicToEntropy(mnemonic, wordlist) {
    wordlist = wordlist || DEFAULT_WORDLIST;
    if (!wordlist) {
        throw new Error(WORDLIST_REQUIRED);
    }
    const words = normalize(mnemonic).split(' ');
    if (words.length % 3 !== 0) {
        throw new Error(INVALID_MNEMONIC);
    }
    // convert word indices to 11 bit binary strings
    const bits = words
        .map((word) => {
        const index = wordlist.indexOf(word);
        if (index === -1) {
            throw new Error(INVALID_MNEMONIC);
        }
        return lpad(index.toString(2), '0', 11);
    })
        .join('');
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map(binaryToByte);
    if (entropyBytes.length < 16) {
        throw new Error(INVALID_ENTROPY);
    }
    if (entropyBytes.length > 32) {
        throw new Error(INVALID_ENTROPY);
    }
    if (entropyBytes.length % 4 !== 0) {
        throw new Error(INVALID_ENTROPY);
    }
    const entropy = Buffer.from(entropyBytes);
    const newChecksum = deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) {
        throw new Error(INVALID_CHECKSUM);
    }
    return entropy.toString('hex');
}
exports.oy = mnemonicToEntropy;
function entropyToMnemonic(entropy, wordlist) {
    if (!Buffer.isBuffer(entropy)) {
        entropy = Buffer.from(entropy, 'hex');
    }
    wordlist = wordlist || DEFAULT_WORDLIST;
    if (!wordlist) {
        throw new Error(WORDLIST_REQUIRED);
    }
    // 128 <= ENT <= 256
    if (entropy.length < 16) {
        throw new TypeError(INVALID_ENTROPY);
    }
    if (entropy.length > 32) {
        throw new TypeError(INVALID_ENTROPY);
    }
    if (entropy.length % 4 !== 0) {
        throw new TypeError(INVALID_ENTROPY);
    }
    const entropyBits = bytesToBinary(Array.from(entropy));
    const checksumBits = deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    const chunks = bits.match(/(.{1,11})/g);
    const words = chunks.map((binary) => {
        const index = binaryToByte(binary);
        return wordlist[index];
    });
    return wordlist[0] === '\u3042\u3044\u3053\u304f\u3057\u3093' // Japanese wordlist
        ? words.join('\u3000')
        : words.join(' ');
}
__webpack_unused_export__ = entropyToMnemonic;
function generateMnemonic(strength, rng, wordlist) {
    strength = strength || 128;
    if (strength % 32 !== 0) {
        throw new TypeError(INVALID_ENTROPY);
    }
    rng = rng || ((size) => Buffer.from(utils_1.randomBytes(size)));
    return entropyToMnemonic(rng(strength / 8), wordlist);
}
__webpack_unused_export__ = generateMnemonic;
function validateMnemonic(mnemonic, wordlist) {
    try {
        mnemonicToEntropy(mnemonic, wordlist);
    }
    catch (e) {
        return false;
    }
    return true;
}
__webpack_unused_export__ = validateMnemonic;
function setDefaultWordlist(language) {
    const result = _wordlists_1.wordlists[language];
    if (result) {
        DEFAULT_WORDLIST = result;
    }
    else {
        throw new Error('Could not find wordlist for language "' + language + '"');
    }
}
__webpack_unused_export__ = setDefaultWordlist;
function getDefaultWordlist() {
    if (!DEFAULT_WORDLIST) {
        throw new Error('No Default Wordlist set');
    }
    return Object.keys(_wordlists_1.wordlists).filter((lang) => {
        if (lang === 'JA' || lang === 'EN') {
            return false;
        }
        return _wordlists_1.wordlists[lang].every((word, index) => word === DEFAULT_WORDLIST[index]);
    })[0];
}
__webpack_unused_export__ = getDefaultWordlist;
var _wordlists_2 = __webpack_require__(42314);
__webpack_unused_export__ = _wordlists_2.wordlists;


/***/ }),

/***/ 48764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(79742)
const ieee754 = __webpack_require__(80645)
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

const K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ 25730:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);
var $reflectApply = __webpack_require__(59770);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),

/***/ 93192:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);
var $apply = __webpack_require__(1768);
var actualApply = __webpack_require__(25730);

/** @type {import('./applyBind')} */
module.exports = function applyBind() {
	return actualApply(bind, $apply, arguments);
};


/***/ }),

/***/ 1768:
/***/ (function(module) {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),

/***/ 68928:
/***/ (function(module) {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),

/***/ 40319:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);
var $TypeError = __webpack_require__(14453);

var $call = __webpack_require__(68928);
var $actualApply = __webpack_require__(25730);

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),

/***/ 59770:
/***/ (function(module) {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),

/***/ 55559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var setFunctionLength = __webpack_require__(67771);

var $defineProperty = __webpack_require__(24429);

var callBindBasic = __webpack_require__(40319);
var applyBind = __webpack_require__(93192);

module.exports = function callBind(originalFunction) {
	var func = callBindBasic(arguments);
	var adjustedLength = originalFunction.length - (arguments.length - 1);
	return setFunctionLength(
		func,
		1 + (adjustedLength > 0 ? adjustedLength : 0),
		true
	);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 17379:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var callBindBasic = __webpack_require__(40319);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


/***/ }),

/***/ 87394:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
module.exports = exports.default;

/***/ }),

/***/ 97561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(82512));
var _default = _index.default;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 98729:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDefaultOptions = getDefaultOptions;
exports.setDefaultOptions = setDefaultOptions;
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 52084:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(21603));
var _index2 = _interopRequireDefault(__webpack_require__(91354));
var _index3 = _interopRequireDefault(__webpack_require__(81370));
var _index4 = _interopRequireDefault(__webpack_require__(60623));
var _index5 = _interopRequireDefault(__webpack_require__(66226));
var _index6 = _interopRequireDefault(__webpack_require__(87394));
var _index7 = _interopRequireDefault(__webpack_require__(62699));
var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return _index7.default.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = (0, _index5.default)(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return (0, _index6.default)(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return (0, _index6.default)(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = (0, _index3.default)(date);

    // Padding
    return (0, _index6.default)(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return (0, _index6.default)(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return (0, _index6.default)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return (0, _index6.default)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return _index7.default.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return (0, _index6.default)(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = (0, _index4.default)(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return (0, _index6.default)(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = (0, _index2.default)(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return (0, _index6.default)(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return _index7.default.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = (0, _index.default)(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return (0, _index6.default)(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return (0, _index6.default)(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return (0, _index6.default)(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return (0, _index6.default)(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return _index7.default.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return _index7.default.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return (0, _index6.default)(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return (0, _index6.default)(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return _index7.default.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return _index7.default.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return _index7.default.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return (0, _index6.default)(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return (0, _index6.default)(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
  var minutes = (0, _index6.default)(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var _default = formatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 62699:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(87394));
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return (0, _index.default)(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return (0, _index.default)(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return (0, _index.default)(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return (0, _index.default)(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return (0, _index.default)(fractionalSeconds, token.length);
  }
};
var _default = formatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 95209:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var _default = longFormatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 93561:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
module.exports = exports.default;

/***/ }),

/***/ 21603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCDayOfYear;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
module.exports = exports.default;

/***/ }),

/***/ 91354:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCISOWeek;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(80079));
var _index3 = _interopRequireDefault(__webpack_require__(94275));
var _index4 = _interopRequireDefault(__webpack_require__(68734));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

/***/ }),

/***/ 81370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCISOWeekYear;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
var _index3 = _interopRequireDefault(__webpack_require__(80079));
function getUTCISOWeekYear(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
module.exports = exports.default;

/***/ }),

/***/ 60623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCWeek;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(69209));
var _index3 = _interopRequireDefault(__webpack_require__(34118));
var _index4 = _interopRequireDefault(__webpack_require__(68734));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

/***/ }),

/***/ 66226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCWeekYear;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
var _index3 = _interopRequireDefault(__webpack_require__(69209));
var _index4 = _interopRequireDefault(__webpack_require__(82084));
var _index5 = __webpack_require__(98729);
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = (0, _index5.getDefaultOptions)();
  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
module.exports = exports.default;

/***/ }),

/***/ 56736:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

/***/ }),

/***/ 68734:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = requiredArgs;
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
module.exports = exports.default;

/***/ }),

/***/ 80079:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCISOWeek;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
function startOfUTCISOWeek(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var weekStartsOn = 1;
  var date = (0, _index.default)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
module.exports = exports.default;

/***/ }),

/***/ 94275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCISOWeekYear;
var _index = _interopRequireDefault(__webpack_require__(81370));
var _index2 = _interopRequireDefault(__webpack_require__(80079));
var _index3 = _interopRequireDefault(__webpack_require__(68734));
function startOfUTCISOWeekYear(dirtyDate) {
  (0, _index3.default)(1, arguments);
  var year = (0, _index.default)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0, _index2.default)(fourthOfJanuary);
  return date;
}
module.exports = exports.default;

/***/ }),

/***/ 69209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCWeek;
var _index = _interopRequireDefault(__webpack_require__(71171));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
var _index3 = _interopRequireDefault(__webpack_require__(82084));
var _index4 = __webpack_require__(98729);
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0, _index2.default)(1, arguments);
  var defaultOptions = (0, _index4.getDefaultOptions)();
  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0, _index.default)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
module.exports = exports.default;

/***/ }),

/***/ 34118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCWeekYear;
var _index = _interopRequireDefault(__webpack_require__(66226));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
var _index3 = _interopRequireDefault(__webpack_require__(69209));
var _index4 = _interopRequireDefault(__webpack_require__(82084));
var _index5 = __webpack_require__(98729);
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0, _index2.default)(1, arguments);
  var defaultOptions = (0, _index5.getDefaultOptions)();
  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = (0, _index.default)(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0, _index3.default)(firstWeek, options);
  return date;
}
module.exports = exports.default;

/***/ }),

/***/ 82084:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toInteger;
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = exports.default;

/***/ }),

/***/ 5065:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addMilliseconds;
var _index = _interopRequireDefault(__webpack_require__(82084));
var _index2 = _interopRequireDefault(__webpack_require__(71171));
var _index3 = _interopRequireDefault(__webpack_require__(68734));
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var timestamp = (0, _index2.default)(dirtyDate).getTime();
  var amount = (0, _index.default)(dirtyAmount);
  return new Date(timestamp + amount);
}
module.exports = exports.default;

/***/ }),

/***/ 15616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = format;
var _index = _interopRequireDefault(__webpack_require__(39989));
var _index2 = _interopRequireDefault(__webpack_require__(33239));
var _index3 = _interopRequireDefault(__webpack_require__(71171));
var _index4 = _interopRequireDefault(__webpack_require__(52084));
var _index5 = _interopRequireDefault(__webpack_require__(95209));
var _index6 = _interopRequireDefault(__webpack_require__(93561));
var _index7 = __webpack_require__(56736);
var _index8 = _interopRequireDefault(__webpack_require__(82084));
var _index9 = _interopRequireDefault(__webpack_require__(68734));
var _index10 = __webpack_require__(98729);
var _index11 = _interopRequireDefault(__webpack_require__(97561));
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0, _index9.default)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = (0, _index10.getDefaultOptions)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = (0, _index3.default)(dirtyDate);
  if (!(0, _index.default)(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = (0, _index6.default)(originalDate);
  var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = _index5.default[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = _index4.default[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) {
        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) {
        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
module.exports = exports.default;

/***/ }),

/***/ 62382:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isDate;
var _typeof2 = _interopRequireDefault(__webpack_require__(18698));
var _index = _interopRequireDefault(__webpack_require__(68734));
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  (0, _index.default)(1, arguments);
  return value instanceof Date || (0, _typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
module.exports = exports.default;

/***/ }),

/***/ 39989:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isValid;
var _index = _interopRequireDefault(__webpack_require__(62382));
var _index2 = _interopRequireDefault(__webpack_require__(71171));
var _index3 = _interopRequireDefault(__webpack_require__(68734));
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0, _index3.default)(1, arguments);
  if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = (0, _index2.default)(dirtyDate);
  return !isNaN(Number(date));
}
module.exports = exports.default;

/***/ }),

/***/ 20289:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildFormatLongFn;
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
module.exports = exports.default;

/***/ }),

/***/ 16245:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildLocalizeFn;
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
module.exports = exports.default;

/***/ }),

/***/ 43421:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildMatchFn;
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
module.exports = exports.default;

/***/ }),

/***/ 78926:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildMatchPatternFn;
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
module.exports = exports.default;

/***/ }),

/***/ 71924:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
var _default = formatDistance;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 95062:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(20289));
var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0, _index.default)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0, _index.default)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0, _index.default)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var _default = formatLong;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 5102:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var _default = formatRelative;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 87839:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(16245));
var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: (0, _index.default)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0, _index.default)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0, _index.default)({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: (0, _index.default)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0, _index.default)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var _default = localize;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 9796:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(43421));
var _index2 = _interopRequireDefault(__webpack_require__(78926));
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: (0, _index2.default)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0, _index.default)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0, _index.default)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0, _index.default)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0, _index.default)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0, _index.default)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var _default = match;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 82512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(71924));
var _index2 = _interopRequireDefault(__webpack_require__(95062));
var _index3 = _interopRequireDefault(__webpack_require__(5102));
var _index4 = _interopRequireDefault(__webpack_require__(87839));
var _index5 = _interopRequireDefault(__webpack_require__(9796));
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _index.default,
  formatLong: _index2.default,
  formatRelative: _index3.default,
  localize: _index4.default,
  match: _index5.default,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var _default = locale;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 33239:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = subMilliseconds;
var _index = _interopRequireDefault(__webpack_require__(5065));
var _index2 = _interopRequireDefault(__webpack_require__(68734));
var _index3 = _interopRequireDefault(__webpack_require__(82084));
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0, _index2.default)(2, arguments);
  var amount = (0, _index3.default)(dirtyAmount);
  return (0, _index.default)(dirtyDate, -amount);
}
module.exports = exports.default;

/***/ }),

/***/ 71171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(64836)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toDate;
var _typeof2 = _interopRequireDefault(__webpack_require__(18698));
var _index = _interopRequireDefault(__webpack_require__(68734));
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0, _index.default)(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || (0, _typeof2.default)(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}
module.exports = exports.default;

/***/ }),

/***/ 12296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(24429);

var $SyntaxError = __webpack_require__(33464);
var $TypeError = __webpack_require__(14453);

var gopd = __webpack_require__(27296);

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),

/***/ 96504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(40319);
var gOPD = __webpack_require__(27296);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),

/***/ 27870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g3": function() { return /* binding */ StoreProvider; },
  "aD": function() { return /* binding */ action; },
  "Fl": function() { return /* binding */ computed; },
  "MT": function() { return /* binding */ dist_createStore; },
  "tl": function() { return /* binding */ createTypedHooks; },
  "I5": function() { return /* binding */ dist_thunk; }
});

// UNUSED EXPORTS: actionOn, createContextStore, createStoreActionsHook, createStoreDispatchHook, createStoreRehydratedHook, createStoreStateHook, createTransform, debug, generic, initializeUseStoreState, persist, reducer, thunkOn, unstable_effectOn, useLocalStore, useStore, useStoreActions, useStoreDispatch, useStoreRehydrated, useStoreState

// EXTERNAL MODULE: ./node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(52798);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}



;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var es = (thunk);
;// CONCATENATED MODULE: ./node_modules/immer/dist/immer.esm.mjs
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){var r;return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function g(n){O(n),n.p.forEach(S),n.p=null}function O(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s,v){if( false&&0,r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function F(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.g&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.R,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=i[s];"string"!=typeof p&&"number"!=typeof p&&(p=""+p),0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},N:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.R,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.R,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.R=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=N(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.g&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,R:void 0,t:n,k:this,C:!1,g:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.R.set(n,!0),t.o.set(n,r),t.R.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.R.set(n,!1):r.R.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.R=new Map,i(n.t,(function(r){n.R.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=N(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,g:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{F:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){F(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?g(c):O(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ var immer_esm = ((/* unused pure expression or super */ null && (fn)));
//# sourceMappingURL=immer.esm.js.map

// EXTERNAL MODULE: ./node_modules/fast-deep-equal/es6/index.js
var es6 = __webpack_require__(62991);
var es6_default = /*#__PURE__*/__webpack_require__.n(es6);
;// CONCATENATED MODULE: ./node_modules/easy-peasy/dist/index.js








var StoreContext = (0,react.createContext)();

var useNotInitialized = function useNotInitialized() {
  throw new Error('uSES not initialized!');
};

var useSyncExternalStoreWithSelector = useNotInitialized;
var initializeUseStoreState = function initializeUseStoreState(fn) {
  useSyncExternalStoreWithSelector = fn;
};

var refEquality = function refEquality(a, b) {
  return a === b;
};

function createStoreStateHook(Context) {
  return function useStoreState(mapState, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {}

    var store = (0,react.useContext)(Context);
    /*
    function useSyncExternalStoreWithSelector<Snapshot, Selection>(
        subscribe: (onStoreChange: () => void) => () => void,
        getSnapshot: () => Snapshot,
        getServerSnapshot: undefined | null | (() => Snapshot),
        selector: (snapshot: Snapshot) => Selection,
        isEqual?: (a: Selection, b: Selection) => boolean,
    ): Selection;
    */

    var selectedState = useSyncExternalStoreWithSelector(store.subscribe, store.getState, store.getServerState || store.getState, mapState, equalityFn);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
var useStoreState = createStoreStateHook(StoreContext);
function createStoreActionsHook(Context) {
  return function useStoreActions(mapActions) {
    var store = (0,react.useContext)(Context);
    return mapActions(store.getActions());
  };
}
var useStoreActions = createStoreActionsHook(StoreContext);
function createStoreDispatchHook(Context) {
  return function useStoreDispatch() {
    var store = (0,react.useContext)(Context);
    return store.dispatch;
  };
}
var useStoreDispatch = createStoreDispatchHook(StoreContext);
function useStore() {
  return (0,react.useContext)(StoreContext);
}
function createStoreRehydratedHook(Context) {
  return function useStoreRehydrated() {
    var store = (0,react.useContext)(Context);

    var _useState = (0,react.useState)(false),
        rehydrated = _useState[0],
        setRehydrated = _useState[1];

    (0,react.useEffect)(function () {
      store.persist.resolveRehydration().then(function () {
        return setRehydrated(true);
      });
    }, []);
    return rehydrated;
  };
}
var useStoreRehydrated = createStoreRehydratedHook(StoreContext);
function createTypedHooks() {
  return {
    useStoreActions: useStoreActions,
    useStoreDispatch: useStoreDispatch,
    useStoreState: useStoreState,
    useStoreRehydrated: useStoreRehydrated,
    useStore: useStore
  };
}

var actionSymbol = '$_a';
var actionOnSymbol = '$_aO';
var computedSymbol = '$_c';
var effectOnSymbol = '$_e';
var persistSymbol = '$_p';
var reducerSymbol = '$_r';
var thunkOnSymbol = '$_tO';
var thunkSymbol = '$_t';

var debug = function debug(state) {
  if (isDraft(state)) {
    return current(state);
  }

  return state;
};
var actionOn = function actionOn(targetResolver, fn, config) {
  var _ref;

  return _ref = {}, _ref[actionOnSymbol] = true, _ref.fn = fn, _ref.targetResolver = targetResolver, _ref.config = config, _ref;
};
var action = function action(fn, config) {
  var _ref2;

  return _ref2 = {}, _ref2[actionSymbol] = true, _ref2.fn = fn, _ref2.config = config, _ref2;
};
var defaultStateResolvers = [function (state) {
  return state;
}];
var computed = function computed(fnOrStateResolvers, fn) {
  var _ref4;

  if (typeof fn === 'function') {
    var _ref3;

    return _ref3 = {}, _ref3[computedSymbol] = true, _ref3.fn = fn, _ref3.stateResolvers = fnOrStateResolvers, _ref3;
  }

  return _ref4 = {}, _ref4[computedSymbol] = true, _ref4.fn = fnOrStateResolvers, _ref4.stateResolvers = defaultStateResolvers, _ref4;
};
function unstable_effectOn(dependencyResolvers, fn) {
  var _ref5;

  return _ref5 = {}, _ref5[effectOnSymbol] = true, _ref5.dependencyResolvers = dependencyResolvers, _ref5.fn = fn, _ref5;
}
function generic(value) {
  return value;
}
var persist = function persist(model, config) {
  var _objectSpread2;

  return (// if we are not running in a browser context this becomes a no-op
    typeof window === 'undefined' ? model : _objectSpread(_objectSpread({}, model), {}, (_objectSpread2 = {}, _objectSpread2[persistSymbol] = config, _objectSpread2))
  );
};
var thunkOn = function thunkOn(targetResolver, fn) {
  var _ref6;

  return _ref6 = {}, _ref6[thunkOnSymbol] = true, _ref6.fn = fn, _ref6.targetResolver = targetResolver, _ref6;
};
var dist_thunk = function thunk(fn) {
  var _ref7;

  return _ref7 = {}, _ref7[thunkSymbol] = true, _ref7.fn = fn, _ref7;
};
var reducer = function reducer(fn, config) {
  var _ref8;

  return _ref8 = {}, _ref8[reducerSymbol] = true, _ref8.fn = fn, _ref8.config = config, _ref8;
};

/**
 * We create our own immer instance to avoid potential issues with autoFreeze
 * becoming default enabled everywhere. We want to disable autofreeze as it
 * does not suit the design of Easy Peasy.
 * https://github.com/immerjs/immer/issues/681#issuecomment-705581111
 */

var easyPeasyImmer;
function dist_isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}
function clone(source) {
  function recursiveClone(current) {
    var next = Object.keys(current).reduce(function (acc, key) {
      if (Object.getOwnPropertyDescriptor(current, key).get == null) {
        acc[key] = current[key];
      }

      return acc;
    }, {});
    Object.keys(next).forEach(function (key) {
      if (dist_isPlainObject(next[key])) {
        next[key] = recursiveClone(next[key]);
      }
    });
    return next;
  }

  return recursiveClone(source);
}
function isPromise(x) {
  return x != null && typeof x === 'object' && typeof x.then === 'function';
}
function get(path, target) {
  return path.reduce(function (acc, cur) {
    return dist_isPlainObject(acc) ? acc[cur] : undefined;
  }, target);
}
function newify(currentPath, currentState, finalValue) {
  if (currentPath.length === 0) {
    return finalValue;
  }

  var newState = _objectSpread2({}, currentState);

  var key = currentPath[0];

  if (currentPath.length === 1) {
    newState[key] = finalValue;
  } else {
    newState[key] = newify(currentPath.slice(1), newState[key], finalValue);
  }

  return newState;
}
function set(path, target, value) {
  if (path.length === 0) {
    if (typeof value === 'object') {
      Object.keys(target).forEach(function (key) {
        delete target[key];
      });
      Object.keys(value).forEach(function (key) {
        target[key] = value[key];
      });
    }

    return;
  }

  path.reduce(function (acc, cur, idx) {
    if (idx + 1 === path.length) {
      acc[cur] = value;
    } else {
      acc[cur] = acc[cur] || {};
    }

    return acc[cur];
  }, target);
}
function createSimpleProduce(disableImmer) {
  if (disableImmer === void 0) {
    disableImmer = false;
  }

  return function simpleProduce(path, state, fn, config) {
    if (config && 'immer' in config ? (config == null ? void 0 : config.immer) === false : disableImmer) {
      var _current = get(path, state);

      var next = fn(_current);

      if (_current !== next) {
        return newify(path, state, next);
      }

      return state;
    }

    if (!easyPeasyImmer) {
      easyPeasyImmer = new un({
        // We need to ensure that we disable proxies if they aren't available
        // on the environment. Users need to ensure that they use the enableES5
        // feature of immer.
        useProxies: typeof Proxy !== 'undefined' && typeof Proxy.revocable !== 'undefined' && typeof Reflect !== 'undefined',
        // Autofreezing breaks easy-peasy, we need a mixed version of immutability
        // and mutability in order to apply updates to our computed properties
        autoFreeze: false
      });
    }

    if (path.length === 0) {
      var _draft = easyPeasyImmer.createDraft(state);

      var _result = fn(_draft);

      if (_result) {
        return r(_result) ? easyPeasyImmer.finishDraft(_result) : _result;
      }

      return easyPeasyImmer.finishDraft(_draft);
    }

    var parentPath = path.slice(0, path.length - 1);
    var draft = easyPeasyImmer.createDraft(state);
    var parent = get(parentPath, state);
    var current = get(path, draft);
    var result = fn(current);

    if (result) {
      parent[path[path.length - 1]] = result;
    }

    return easyPeasyImmer.finishDraft(draft);
  };
}

var pReduce = function pReduce(iterable, reducer, initialValue) {
  return new Promise(function (resolve, reject) {
    var iterator = iterable[Symbol.iterator]();
    var index = 0;

    var next = function next(total) {
      var element = iterator.next();

      if (element.done) {
        resolve(total);
        return;
      }

      Promise.all([total, element.value]).then(function (value) {
        return (// eslint-disable-next-line no-plusplus
          next(reducer(value[0], value[1], index++))
        );
      }).catch(function (err) {
        return reject(err);
      });
    };

    next(initialValue);
  });
};

var pSeries = function pSeries(tasks) {
  var results = [];
  return pReduce(tasks, function (_, task) {
    return task().then(function (value) {
      results.push(value);
    });
  }).then(function () {
    return results;
  });
};
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i += 1) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}
function useMemoOne( // getResult changes on every call,
getResult, // the inputs array changes on every call
inputs) {
  // using useState to generate initial value as it is lazy
  var initial = React.useState(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var committed = React.useRef(initial); // persist any uncommitted changes after they have been committed

  var isInputMatch = Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs)); // create a new cache if required

  var cache = isInputMatch ? committed.current : {
    inputs: inputs,
    result: getResult()
  }; // commit the cache

  React.useEffect(function () {
    committed.current = cache;
  }, [cache]);
  return cache.result;
}

function createReducer(disableImmer, _aRD, _cR, _cP) {
  var simpleProduce = createSimpleProduce(disableImmer);

  var runActionReducerAtPath = function runActionReducerAtPath(state, action, actionReducer, path, config) {
    return simpleProduce(path, state, function (draft) {
      return actionReducer(draft, action.payload);
    }, config);
  };

  var reducerForActions = function reducerForActions(state, action) {
    var actionReducer = _aRD[action.type];

    if (actionReducer) {
      return runActionReducerAtPath(state, action, actionReducer, actionReducer.def.meta.parent, actionReducer.def.config);
    }

    return state;
  };

  var reducerForCustomReducers = function reducerForCustomReducers(state, action) {
    return _cR.reduce(function (acc, _ref) {
      var parentPath = _ref.parentPath,
          key = _ref.key,
          reducer = _ref.reducer,
          config = _ref.config;
      return simpleProduce(parentPath, acc, function (draft) {
        draft[key] = reducer(r(draft[key]) ? e(draft[key]) : draft[key], action);
        return draft;
      }, config);
    }, state);
  };

  var rootReducer = function rootReducer(state, action) {
    var stateAfterActions = reducerForActions(state, action);
    var next = _cR.length > 0 ? reducerForCustomReducers(stateAfterActions, action) : stateAfterActions;

    if (state !== next) {
      _cP.forEach(function (_ref2) {
        var parentPath = _ref2.parentPath,
            bindComputedProperty = _ref2.bindComputedProperty;
        var parentState = get(parentPath, next);
        if (parentState != null) bindComputedProperty(parentState, next);
      });
    }

    return next;
  };

  return rootReducer;
}

var noopStorage = {
  getItem: function getItem() {
    return undefined;
  },
  setItem: function setItem() {
    return undefined;
  },
  removeItem: function removeItem() {
    return undefined;
  }
};

var getBrowerStorage = function getBrowerStorage(storageName) {
  var storageCache;
  return function () {
    if (!storageCache) {
      try {
        if (typeof window !== 'undefined' && typeof window[storageName] !== 'undefined') {
          storageCache = window[storageName];
        }
      } catch (_) {// swallow the failure
      }

      if (!storageCache) {
        storageCache = noopStorage;
      }
    }

    return storageCache;
  };
};

var localStorage = getBrowerStorage('localStorage');
var sessionStorage = getBrowerStorage('sessionStorage');

function createStorageWrapper(storage, transformers) {
  if (transformers === void 0) {
    transformers = [];
  }

  if (storage == null) {
    storage = sessionStorage();
  }

  if (typeof storage === 'string') {
    if (storage === 'localStorage') {
      storage = localStorage();
    } else if (storage === 'sessionStorage') {
      storage = sessionStorage();
    } else {
      if (false) {}

      storage = noopStorage;
    }
  }

  var outTransformers = [].concat(transformers).reverse();

  var serialize = function serialize(data) {
    if (transformers.length > 0 && data != null && typeof data === 'object') {
      Object.keys(data).forEach(function (key) {
        data[key] = transformers.reduce(function (acc, cur) {
          return cur.in(acc, key);
        }, data[key]);
      });
    }

    return storage === localStorage() || storage === sessionStorage() ? JSON.stringify({
      data: data
    }) : data;
  };

  var deserialize = function deserialize(data) {
    var result = storage === localStorage() || storage === sessionStorage() ? JSON.parse(data).data : data;

    if (outTransformers.length > 0 && result != null && typeof result === 'object') {
      Object.keys(result).forEach(function (key) {
        result[key] = outTransformers.reduce(function (acc, cur) {
          return cur.out(acc, key);
        }, result[key]);
      });
    }

    return result;
  };

  var isAsync = isPromise(storage.getItem('_'));
  return {
    getItem: function getItem(key) {
      if (isAsync) {
        return storage.getItem(key).then(function (wrapped) {
          return wrapped != null ? deserialize(wrapped) : undefined;
        });
      }

      var wrapped = storage.getItem(key);
      return wrapped != null ? deserialize(wrapped) : undefined;
    },
    setItem: function setItem(key, data) {
      return storage.setItem(key, serialize(data));
    },
    removeItem: function removeItem(key) {
      return storage.removeItem(key);
    }
  };
}

function extractPersistConfig(path, persistdef) {
  if (persistdef === void 0) {
    persistdef = {};
  }

  return {
    path: path,
    config: {
      allow: persistdef.allow || [],
      deny: persistdef.deny || [],
      mergeStrategy: persistdef.mergeStrategy || 'mergeDeep',
      storage: createStorageWrapper(persistdef.storage, persistdef.transformers)
    }
  };
}

function resolvePersistTargets(target, allow, deny) {
  var targets = Object.keys(target);

  if (allow.length > 0) {
    targets = targets.reduce(function (acc, cur) {
      if (allow.findIndex(function (x) {
        return x === cur;
      }) !== -1) {
        return [].concat(acc, [cur]);
      }

      return acc;
    }, []);
  }

  if (deny.length > 0) {
    targets = targets.reduce(function (acc, cur) {
      if (deny.findIndex(function (x) {
        return x === cur;
      }) !== -1) {
        return acc;
      }

      return [].concat(acc, [cur]);
    }, []);
  }

  return targets;
}

function createPersistenceClearer(persistKey, _r) {
  return function () {
    if (_r._i._persistenceConfig.length === 0) {
      return Promise.resolve();
    }

    return pSeries(_r._i._persistenceConfig.map(function (_ref) {
      var path = _ref.path,
          config = _ref.config;
      return function () {
        return Promise.resolve(config.storage.removeItem(persistKey(path)));
      };
    }));
  };
}

function createPersistor(persistKey, _r) {
  var persistPromise = Promise.resolve();
  var isPersisting = false;
  var nextPersistOperation;
  var timingMethod = typeof window === 'undefined' ? function (fn) {
    return fn();
  } : window.requestIdleCallback != null ? window.requestIdleCallback : window.requestAnimationFrame;

  var persist = function persist(nextState) {
    if (_r._i._persistenceConfig.length === 0) {
      return;
    }

    var operation = function operation() {
      isPersisting = true;
      persistPromise = new Promise(function (resolve) {
        timingMethod(function () {
          pSeries(_r._i._persistenceConfig.map(function (_ref2) {
            var path = _ref2.path,
                config = _ref2.config;
            return function () {
              var storage = config.storage,
                  allow = config.allow,
                  deny = config.deny;
              var persistRootState = clone(get(path, nextState));
              var persistTargets = resolvePersistTargets(persistRootState, allow, deny);
              var stateToPersist = {};
              persistTargets.map(function (key) {
                var targetPath = [].concat(path, [key]);
                var rawValue = get(targetPath, nextState);
                var value = dist_isPlainObject(rawValue) ? clone(rawValue) : rawValue;
                stateToPersist[key] = value;
              });
              return Promise.resolve(storage.setItem(persistKey(path), stateToPersist));
            };
          })).finally(function () {
            isPersisting = false;

            if (nextPersistOperation) {
              var next = nextPersistOperation;
              nextPersistOperation = null;
              next();
            } else {
              resolve();
            }
          });
        });
      });
    };

    if (isPersisting) {
      nextPersistOperation = operation;
    } else {
      operation();
    }
  };

  return {
    persist: persist,
    clear: createPersistenceClearer(persistKey, _r),
    flush: function flush() {
      if (nextPersistOperation) {
        nextPersistOperation();
      }

      return persistPromise;
    }
  };
}
function createPersistMiddleware(persistor, _r) {
  return function (_ref3) {
    var getState = _ref3.getState;
    return function (next) {
      return function (action) {
        var state = next(action);

        if (action && action.type !== '@action.ePRS' && _r._i._persistenceConfig.length > 0) {
          persistor.persist(getState());
        }

        return state;
      };
    };
  };
}
function rehydrateStateFromPersistIfNeeded(persistKey, replaceState, _r, root) {
  if (_r._i._persistenceConfig.length === 0) {
    return Promise.resolve();
  }

  var state = clone(_r._i._dS);
  var rehydrating = false;
  return pSeries(_r._i._persistenceConfig.map(function (persistInstance) {
    return function () {
      var path = persistInstance.path,
          config = persistInstance.config;
      var mergeStrategy = config.mergeStrategy,
          storage = config.storage;

      if (root && (path.length < 1 || path[0] !== root)) {
        return Promise.resolve();
      }

      var hasDataModelChanged = function hasDataModelChanged(dataModel, rehydratingModelData) {
        return dataModel != null && rehydratingModelData != null && (typeof dataModel !== typeof rehydratingModelData || Array.isArray(dataModel) && !Array.isArray(rehydratingModelData));
      };

      var applyRehydrationStrategy = function applyRehydrationStrategy(persistedState) {
        if (mergeStrategy === 'overwrite') {
          set(path, state, persistedState);
        } else if (mergeStrategy === 'mergeShallow') {
          var targetState = get(path, state);
          Object.keys(persistedState).forEach(function (key) {
            if (hasDataModelChanged(targetState[key], persistedState[key])) ; else {
              targetState[key] = persistedState[key];
            }
          });
        } else if (mergeStrategy === 'mergeDeep') {
          var _targetState = get(path, state);

          var setAt = function setAt(currentTargetState, currentPersistedState) {
            Object.keys(currentPersistedState).forEach(function (key) {
              if (hasDataModelChanged(currentTargetState[key], currentPersistedState[key])) ; else if (dist_isPlainObject(currentPersistedState[key])) {
                currentTargetState[key] = currentTargetState[key] || {};
                setAt(currentTargetState[key], currentPersistedState[key]);
              } else {
                currentTargetState[key] = currentPersistedState[key];
              }
            });
          };

          setAt(_targetState, persistedState);
        }
      };

      var rehydate = function rehydate(persistedState) {
        if (persistedState != null) {
          applyRehydrationStrategy(persistedState);
          rehydrating = true;
        }
      };

      var getItemResult = storage.getItem(persistKey(path));

      if (isPromise(getItemResult)) {
        return getItemResult.then(rehydate);
      }

      return Promise.resolve(rehydate(getItemResult));
    };
  })).then(function () {
    if (rehydrating) {
      replaceState(state);
    }
  });
}

function createActionCreator(def, _r) {
  function actionCreator(payload) {
    var action = {
      type: def.meta.type,
      payload: payload,
      config: def.config
    };

    if (def[actionOnSymbol] && def.meta.resolvedTargets) {
      payload.resolvedTargets = [].concat(def.meta.resolvedTargets);
    }

    return _r.dispatch(action);
  } // We bind the types to the creator for easy reference by consumers


  actionCreator.type = def.meta.type;
  return actionCreator;
}

function createThunkHandler(def, _r, injections, _aC) {
  return function (payload, fail) {
    var helpers = {
      dispatch: _r.dispatch,
      fail: fail,
      getState: function getState() {
        return get(def.meta.parent, _r.getState());
      },
      getStoreActions: function getStoreActions() {
        return _aC;
      },
      getStoreState: _r.getState,
      injections: injections,
      meta: {
        key: def.meta.actionName,
        parent: def.meta.parent,
        path: def.meta.path
      }
    };

    if (def[thunkOnSymbol] && def.meta.resolvedTargets) {
      payload.resolvedTargets = [].concat(def.meta.resolvedTargets);
    }

    return def.fn(get(def.meta.parent, _aC), payload, helpers);
  };
}

var logThunkEventListenerError = function logThunkEventListenerError(type, err) {
  // eslint-disable-next-line no-console
  console.log("Error in " + type); // eslint-disable-next-line no-console

  console.log(err);
};

var handleEventDispatchErrors$1 = function handleEventDispatchErrors(type, dispatcher) {
  return function () {
    try {
      var result = dispatcher.apply(void 0, arguments);

      if (isPromise(result)) {
        result.catch(function (err) {
          logThunkEventListenerError(type, err);
        });
      }
    } catch (err) {
      logThunkEventListenerError(type, err);
    }
  };
};

function createThunkActionsCreator(def, _r) {
  var actionCreator = function actionCreator(payload) {
    var dispatchStart = handleEventDispatchErrors$1(def.meta.startType, function () {
      return _r.dispatch({
        type: def.meta.startType,
        payload: payload
      });
    });
    var dispatchFail = handleEventDispatchErrors$1(def.meta.failType, function (err) {
      return _r.dispatch({
        type: def.meta.failType,
        payload: payload,
        error: err
      });
    });
    var dispatchSuccess = handleEventDispatchErrors$1(def.meta.successType, function (result) {
      return _r.dispatch({
        type: def.meta.successType,
        payload: payload,
        result: result
      });
    });
    dispatchStart();
    var failure = null;

    var fail = function fail(_failure) {
      failure = _failure;
    };

    var result = _r.dispatch(function () {
      return def.thunkHandler(payload, fail);
    });

    if (isPromise(result)) {
      return result.then(function (resolved) {
        if (failure) {
          dispatchFail(failure);
        } else {
          dispatchSuccess(resolved);
        }

        return resolved;
      });
    }

    if (failure) {
      dispatchFail(failure);
    } else {
      dispatchSuccess(result);
    }

    return result;
  };

  actionCreator.type = def.meta.type;
  actionCreator.successType = def.meta.successType;
  actionCreator.failType = def.meta.failType;
  actionCreator.startType = def.meta.startType;
  return actionCreator;
}

function createListenerMiddleware(_r) {
  return function () {
    return function (next) {
      return function (action) {
        var result = next(action);

        if (action && _r._i._lAM[action.type] && _r._i._lAM[action.type].length > 0) {
          var sourceAction = _r._i._aCD[action.type];

          _r._i._lAM[action.type].forEach(function (actionCreator) {
            actionCreator({
              type: sourceAction ? sourceAction.def.meta.type : action.type,
              payload: action.payload,
              error: action.error,
              result: action.result
            });
          });
        }

        return result;
      };
    };
  };
}
function bindListenerdefs(listenerdefs, _aC, _aCD, _lAM) {
  listenerdefs.forEach(function (def) {
    var targets = def.targetResolver(get(def.meta.parent, _aC), _aC);
    var targetTypes = (Array.isArray(targets) ? targets : [targets]).reduce(function (acc, target) {
      if (typeof target === 'function' && target.def.meta.type && _aCD[target.def.meta.type]) {
        if (target.def.meta.successType) {
          acc.push(target.def.meta.successType);
        } else {
          acc.push(target.def.meta.type);
        }
      } else if (typeof target === 'string') {
        acc.push(target);
      }

      return acc;
    }, []);
    def.meta.resolvedTargets = targetTypes;
    targetTypes.forEach(function (targetType) {
      var listenerReg = _lAM[targetType] || [];
      listenerReg.push(_aCD[def.meta.type]);
      _lAM[targetType] = listenerReg;
    });
  });
}

function createComputedPropertyBinder(parentPath, key, def, _r) {
  var runOnce = false;
  var prevInputs = [];
  var prevValue;
  var prevStoreState;
  var performingEqualityCheck = false;

  var areEqual = function areEqual(a, b) {
    performingEqualityCheck = true;
    var result = es6_default()(a, b);
    performingEqualityCheck = false;
    return result;
  };

  return function createComputedProperty(parentState, storeState) {
    Object.defineProperty(parentState, key, {
      configurable: true,
      enumerable: true,
      get: function get() {
        if (performingEqualityCheck) {
          return prevValue;
        }

        var inputs = def.stateResolvers.map(function (resolver) {
          return resolver(parentState, storeState);
        });

        if (runOnce && (storeState === prevStoreState || areInputsEqual(inputs, prevInputs) || // We don't want computed properties resolved every time an action
        // is handled by the reducer. They need to remain lazy, only being
        // computed when used by a component or getState call;
        _r._i._cS.isInReducer && // This is to account for strange errors that may occur via immer;
        new Error().stack.match(/shallowCopy/gi) !== null)) {
          return prevValue;
        }

        var newValue = def.fn.apply(def, inputs);

        if (!areEqual(newValue, prevValue)) {
          prevValue = newValue;
        }

        prevInputs = inputs;
        prevStoreState = storeState;
        runOnce = true;
        return prevValue;
      }
    });
  };
}
function createComputedPropertiesMiddleware(_r) {
  return function () {
    return function (next) {
      return function (action) {
        _r._i._cS.isInReducer = true;
        var result = next(action);
        _r._i._cS.isInReducer = false;
        return result;
      };
    };
  };
}

function createEffectsMiddleware(_r) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (_r._i._e.length === 0) {
          return next(action);
        }

        var prevState = store.getState();
        var result = next(action);
        var nextState = store.getState();

        if (prevState !== nextState) {
          _r._i._e.forEach(function (def) {
            var prevLocal = get(def.meta.parent, prevState);
            var nextLocal = get(def.meta.parent, nextState);
            var prevDependencies = def.dependencyResolvers.map(function (resolver) {
              return resolver(prevLocal, prevState);
            });
            var nextDependencies = def.dependencyResolvers.map(function (resolver) {
              return resolver(nextLocal, nextState);
            });
            var hasChanged = prevDependencies.some(function (dependency, idx) {
              return dependency !== nextDependencies[idx];
            });

            if (hasChanged) {
              def.actionCreator(prevDependencies, nextDependencies, action);
            }
          });
        }

        return result;
      };
    };
  };
}

var logEffectError = function logEffectError(err) {
  // As users can't get a handle on effects we need to report the error
  // eslint-disable-next-line no-console
  console.error(err);
};

function createEffectHandler(def, _r, injections, _aC) {
  var actions = get(def.meta.parent, _aC);
  var dispose;
  return function (change) {
    var helpers = {
      dispatch: _r.dispatch,
      getState: function getState() {
        return get(def.meta.parent, _r.getState());
      },
      getStoreActions: function getStoreActions() {
        return _aC;
      },
      getStoreState: _r.getState,
      injections: injections,
      meta: {
        key: def.meta.actionName,
        parent: def.meta.parent,
        path: def.meta.path
      }
    };

    if (dispose !== undefined) {
      var disposeResult = dispose();
      dispose = undefined;

      if (isPromise(disposeResult)) {
        disposeResult.catch(logEffectError);
      }
    }

    var effectResult = def.fn(actions, change, helpers);

    if (isPromise(effectResult)) {
      return effectResult.then(function (resolved) {
        if (typeof resolved === 'function') {
          if (false) {}
        }
      });
    }

    if (typeof effectResult === 'function') {
      dispose = effectResult;
    }

    return undefined;
  };
}

var logEffectEventListenerError = function logEffectEventListenerError(type, err) {
  // eslint-disable-next-line no-console
  console.log("Error in " + type); // eslint-disable-next-line no-console

  console.log(err);
};

var handleEventDispatchErrors = function handleEventDispatchErrors(type, dispatcher) {
  return function () {
    try {
      var result = dispatcher.apply(void 0, arguments);

      if (isPromise(result)) {
        result.catch(function (err) {
          logEffectEventListenerError(type, err);
        });
      }
    } catch (err) {
      logEffectEventListenerError(type, err);
    }
  };
};

function createEffectActionsCreator(def, _r, effectHandler) {
  var actionCreator = function actionCreator(previousDependencies, nextDependencies, action) {
    var change = {
      prev: previousDependencies,
      current: nextDependencies,
      action: action
    };
    var dispatchStart = handleEventDispatchErrors(def.meta.startType, function () {
      return _r.dispatch({
        type: def.meta.startType,
        change: change
      });
    });
    var dispatchSuccess = handleEventDispatchErrors(def.meta.successType, function () {
      return _r.dispatch({
        type: def.meta.successType,
        change: change
      });
    });
    dispatchStart();

    try {
      var result = _r.dispatch(function () {
        return effectHandler(change);
      });

      if (isPromise(result)) {
        return result.then(function (resolved) {
          dispatchSuccess(resolved);
          return resolved;
        }, logEffectError);
      }

      dispatchSuccess(result);
      return result;
    } catch (err) {
      logEffectError(err);
    }

    return undefined;
  };

  actionCreator.type = def.meta.type;
  actionCreator.startType = def.meta.startType;
  actionCreator.successType = def.meta.successType;
  actionCreator.failType = def.meta.failType;
  return actionCreator;
}

function extractDataFromModel(model, initialState, injections, _r) {
  var _dS = initialState;
  var _aCD = {};
  var _aC = {};
  var _aRD = {};
  var actionThunks = {};
  var _cP = [];
  var _cR = [];
  var _e = [];
  var _lAC = {};
  var _lAM = {};
  var listenerdefs = [];
  var _persistenceConfig = [];
  var _cS = {
    isInReducer: false
  };

  var recursiveExtractFromModel = function recursiveExtractFromModel(current, parentPath) {
    return Object.keys(current).forEach(function (key) {
      var value = current[key];
      var path = [].concat(parentPath, [key]);
      var meta = {
        parent: parentPath,
        path: path,
        key: key
      };

      var handleValueAsState = function handleValueAsState() {
        var initialParentRef = get(parentPath, initialState);

        if (initialParentRef && key in initialParentRef) {
          set(path, _dS, initialParentRef[key]);
        } else {
          set(path, _dS, value);
        }
      };

      if (key === persistSymbol) {
        _persistenceConfig.push(extractPersistConfig(parentPath, value));

        return;
      }

      if (value != null && typeof value === 'object') {
        if (value[actionSymbol] || value[actionOnSymbol]) {
          var def = _objectSpread2({}, value); // Determine the category of the action


          var category = def[actionSymbol] ? '@action' : '@actionOn'; // Establish the meta data describing the action

          def.meta = {
            actionName: meta.key,
            category: category,
            type: category + "." + meta.path.join('.'),
            parent: meta.parent,
            path: meta.path
          }; // Create the "action creator" function

          def.actionCreator = createActionCreator(def, _r); // Create a bidirectional relationship of the def/actionCreator

          def.actionCreator.def = def; // Create a bidirectional relationship of the def/reducer

          def.fn.def = def; // Add the action creator to lookup map

          _aCD[def.meta.type] = def.actionCreator; // Add the reducer to lookup map

          _aRD[def.meta.type] = def.fn; // We don't want to expose the internal action to consumers

          if (meta.key !== 'ePRS') {
            // Set the action creator in the "actions" object tree for
            // either the listeners object tree, or the standard actions/thunks
            // object tree
            if (def[actionOnSymbol]) {
              listenerdefs.push(def);
              set(path, _lAC, def.actionCreator);
            } else {
              set(path, _aC, def.actionCreator);
            }
          }
        } else if (value[thunkSymbol] || value[thunkOnSymbol]) {
          var _def = _objectSpread2({}, value); // Determine the category of the thunk


          var _category = _def[thunkSymbol] ? '@thunk' : '@thunkOn'; // Establish the meta data describing the thunk


          var type = _category + "." + meta.path.join('.');
          _def.meta = {
            actionName: meta.key,
            parent: meta.parent,
            path: meta.path,
            type: type,
            startType: type + "(start)",
            successType: type + "(success)",
            failType: type + "(fail)"
          }; // Create the function that will handle, i.e. be executed, when
          // the thunk action is created/dispatched

          _def.thunkHandler = createThunkHandler(_def, _r, injections, _aC); // Register the thunk handler

          set(path, actionThunks, _def.thunkHandler); // Create the "action creator" function

          _def.actionCreator = createThunkActionsCreator(_def, _r); // Create a bidirectional relationship of the def/actionCreator

          _def.actionCreator.def = _def; // Register the action creator within the lookup map

          _aCD[_def.meta.type] = _def.actionCreator; // Set the action creator in the "actions" object tree for
          // either the listeners object tree, or the standard actions/thunks
          // object tree

          if (_def[thunkOnSymbol]) {
            listenerdefs.push(_def);
            set(path, _lAC, _def.actionCreator);
          } else {
            set(path, _aC, _def.actionCreator);
          }
        } else if (value[computedSymbol]) {
          var parent = get(parentPath, _dS);
          var bindComputedProperty = createComputedPropertyBinder(parentPath, key, value, _r);
          bindComputedProperty(parent, _dS);

          _cP.push({
            key: key,
            parentPath: parentPath,
            bindComputedProperty: bindComputedProperty
          });
        } else if (value[reducerSymbol]) {
          _cR.push({
            key: key,
            parentPath: parentPath,
            reducer: value.fn,
            config: value.config
          });
        } else if (value[effectOnSymbol]) {
          var _def2 = _objectSpread2({}, value); // Establish the meta data describing the effect


          var _type = "@effectOn." + meta.path.join('.');

          _def2.meta = {
            type: _type,
            actionName: meta.key,
            parent: meta.parent,
            path: meta.path,
            startType: _type + "(start)",
            successType: _type + "(success)",
            failType: _type + "(fail)"
          };
          var effectHandler = createEffectHandler(_def2, _r, injections, _aC);
          var actionCreator = createEffectActionsCreator(_def2, _r, effectHandler);
          _def2.actionCreator = actionCreator;

          _e.push(_def2);
        } else if (dist_isPlainObject(value)) {
          var existing = get(path, _dS);

          if (existing == null) {
            set(path, _dS, {});
          }

          recursiveExtractFromModel(value, path);
        } else {
          handleValueAsState();
        }
      } else {
        handleValueAsState();
      }
    });
  };

  _persistenceConfig = _persistenceConfig.sort(function (a, b) {
    var aPath = a.path.join('.');
    var bPath = b.path.join('.');

    if (aPath < bPath) {
      return -1;
    }

    if (aPath > bPath) {
      return 1;
    }

    return 0;
  });
  recursiveExtractFromModel(model, []);
  bindListenerdefs(listenerdefs, _aC, _aCD, _lAM);
  return {
    _aCD: _aCD,
    _aC: _aC,
    _aRD: _aRD,
    _cP: _cP,
    _cR: _cR,
    _cS: _cS,
    _dS: _dS,
    _e: _e,
    _lAC: _lAC,
    _lAM: _lAM,
    _persistenceConfig: _persistenceConfig
  };
}

function dist_createStore(model, options) {
  if (options === void 0) {
    options = {};
  }

  var modelClone = clone(model);
  var _options = options,
      compose$1 = _options.compose,
      _options$devTools = _options.devTools,
      devTools = _options$devTools === void 0 ? "production" !== 'production' : _options$devTools,
      _options$disableImmer = _options.disableImmer,
      disableImmer = _options$disableImmer === void 0 ? false : _options$disableImmer,
      _options$enhancers = _options.enhancers,
      enhancers = _options$enhancers === void 0 ? [] : _options$enhancers,
      _options$initialState = _options.initialState,
      initialState = _options$initialState === void 0 ? undefined : _options$initialState,
      _options$injections = _options.injections,
      injections = _options$injections === void 0 ? {} : _options$injections,
      _options$middleware = _options.middleware,
      middleware = _options$middleware === void 0 ? [] : _options$middleware,
      _options$mockActions = _options.mockActions,
      mockActions = _options$mockActions === void 0 ? false : _options$mockActions,
      _options$name = _options.name,
      storeName = _options$name === void 0 ? "EasyPeasyStore" : _options$name,
      _options$version = _options.version,
      version = _options$version === void 0 ? 0 : _options$version,
      _options$reducerEnhan = _options.reducerEnhancer,
      reducerEnhancer = _options$reducerEnhan === void 0 ? function (rootReducer) {
    return rootReducer;
  } : _options$reducerEnhan;

  var bindReplaceState = function bindReplaceState(modelDef) {
    return _objectSpread2(_objectSpread2({}, modelDef), {}, {
      ePRS: action(function (_, payload) {
        return payload;
      })
    });
  };

  var _r = {};
  var modeldef = bindReplaceState(modelClone);
  var mockedActions = [];

  var persistKey = function persistKey(targetPath) {
    return "[" + storeName + "][" + version + "]" + (targetPath.length > 0 ? "[" + targetPath.join('.') + "]" : '');
  };

  var persistor = createPersistor(persistKey, _r);
  var persistMiddleware = createPersistMiddleware(persistor, _r);

  var replaceState = function replaceState(nextState) {
    return _r._i._aCD['@action.ePRS'](nextState);
  };

  var bindStoreInternals = function bindStoreInternals(state) {
    if (state === void 0) {
      state = {};
    }

    var data = extractDataFromModel(modeldef, state, injections, _r);
    _r._i = _objectSpread2(_objectSpread2({}, data), {}, {
      reducer: reducerEnhancer(createReducer(disableImmer, data._aRD, data._cR, data._cP))
    });
  };

  var mockActionsMiddleware = function mockActionsMiddleware() {
    return function () {
      return function (action) {
        if (action != null) {
          mockedActions.push(action);
        }

        return undefined;
      };
    };
  };

  var devToolConfig = devTools === true ? {} : devTools;
  var composeEnhancers = compose$1 || (devTools && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(_objectSpread2({
    name: storeName
  }, devToolConfig)) : compose);
  bindStoreInternals(initialState || {});
  var easyPeasyMiddleware = [createComputedPropertiesMiddleware(_r)].concat(middleware, [es, createListenerMiddleware(_r), createEffectsMiddleware(_r), persistMiddleware]);

  if (mockActions) {
    easyPeasyMiddleware.push(mockActionsMiddleware);
  }

  var store = createStore(_r._i.reducer, _r._i._dS, composeEnhancers.apply(void 0, [applyMiddleware.apply(void 0, easyPeasyMiddleware)].concat(enhancers)));
  store.subscribe(function () {
    _r._i._cS.isInReducer = false;
  });
  _r.dispatch = store.dispatch;
  _r.getState = store.getState;

  var bindActionCreators = function bindActionCreators() {
    Object.keys(store.dispatch).forEach(function (actionsKey) {
      delete store.dispatch[actionsKey];
    });
    Object.keys(_r._i._aC).forEach(function (key) {
      store.dispatch[key] = _r._i._aC[key];
    });
  };

  bindActionCreators();

  var rebindStore = function rebindStore(removeKey) {
    var currentState = store.getState();

    if (removeKey) {
      delete currentState[removeKey];
    }

    bindStoreInternals(currentState);
    store.replaceReducer(_r._i.reducer);
    replaceState(_r._i._dS);
    bindActionCreators();
  };

  var _resolveRehydration = rehydrateStateFromPersistIfNeeded(persistKey, replaceState, _r);

  return Object.assign(store, {
    addModel: function addModel(key, modelForKey) {
      if (modeldef[key] && "production" !== 'production') {}

      modeldef[key] = modelForKey;
      rebindStore(); // There may have been persisted state for a dynamic model. We should try
      // and rehydrate the specifc node

      var addModelRehydration = rehydrateStateFromPersistIfNeeded(persistKey, replaceState, _r, key);
      return {
        resolveRehydration: function resolveRehydration() {
          return addModelRehydration;
        }
      };
    },
    clearMockedActions: function clearMockedActions() {
      mockedActions = [];
    },
    getActions: function getActions() {
      return _r._i._aC;
    },
    getListeners: function getListeners() {
      return _r._i._lAC;
    },
    getMockedActions: function getMockedActions() {
      return [].concat(mockedActions);
    },
    getServerState: initialState,
    persist: {
      clear: persistor.clear,
      flush: persistor.flush,
      resolveRehydration: function resolveRehydration() {
        return _resolveRehydration;
      }
    },
    reconfigure: function reconfigure(newModel) {
      modeldef = bindReplaceState(newModel);
      rebindStore();
    },
    removeModel: function removeModel(key) {
      if (!modeldef[key]) {
        return;
      }

      delete modeldef[key];
      rebindStore(key);
    }
  });
}

function createContextStore(model, config) {
  if (config === void 0) {
    config = {};
  }

  // We create a mutable injections reference to allow updating it
  var _config = config,
      _config$injections = _config.injections,
      mutableInjections = _config$injections === void 0 ? {} : _config$injections;
  var StoreContext = createContext();

  function Provider(_ref) {
    var children = _ref.children,
        runtimeModel = _ref.runtimeModel,
        injections = _ref.injections;

    // If the user provided injections we need to ensure our mutable ref
    // is up to date. We could consider doing a shallow compare here?
    if (injections != null) {
      var nextInjections = typeof injections === 'function' ? injections(mutableInjections) : injections;
      var nextKeys = Object.keys(nextInjections);
      var removeKeys = Object.keys(mutableInjections).filter(function (k) {
        return !nextKeys.includes(k);
      });
      removeKeys.forEach(function (k) {
        delete mutableInjections[k];
      });
      Object.assign(mutableInjections, nextInjections);
    }

    var store = useMemoOne(function () {
      return dist_createStore(typeof model === 'function' ? model(runtimeModel) : model, _objectSpread(_objectSpread({}, config), {}, {
        originalInjections: mutableInjections
      }));
    }, []);
    return /*#__PURE__*/React.createElement(StoreContext.Provider, {
      value: store
    }, children);
  }

  function useStore() {
    return useContext(StoreContext);
  }

  return {
    Provider: Provider,
    useStore: useStore,
    useStoreState: createStoreStateHook(StoreContext),
    useStoreActions: createStoreActionsHook(StoreContext),
    useStoreDispatch: createStoreDispatchHook(StoreContext),
    useStoreRehydrated: createStoreRehydratedHook(StoreContext)
  };
}

/**
 * This file has been copied from redux-persist.
 * The intention being to support as much of the redux-persist API as possible.
 */
function createTransform(inbound, outbound, config) {
  if (config === void 0) {
    config = {};
  }

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(data, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(data, key, fullState) : data;
    },
    out: function out(data, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(data, key, fullState) : data;
    }
  };
}

/* eslint-disable react/prop-types */
function StoreProvider(_ref) {
  var children = _ref.children,
      store = _ref.store;
  return /*#__PURE__*/react.createElement(StoreContext.Provider, {
    value: store
  }, children);
}

function useLocalStore(modelCreator, dependencies, configCreator) {
  if (dependencies === void 0) {
    dependencies = [];
  }

  if (configCreator === void 0) {
    configCreator = null;
  }

  var storeRef = useRef();
  var configRef = useRef();
  var store = useMemoOne(function () {
    var previousState = storeRef.current != null ? storeRef.current.getState() : undefined;
    var config = configCreator != null ? configCreator(previousState, configRef.current) : undefined;

    var _store = dist_createStore(modelCreator(previousState), config);

    configRef.current = config;
    storeRef.current = _store;
    return _store;
  }, dependencies);

  var _useState = useState(function () {
    return store.getState();
  }),
      currentState = _useState[0],
      setCurrentState = _useState[1];

  useEffect(function () {
    setCurrentState(store.getState());
    store.subscribe(function () {
      var nextState = store.getState();

      if (currentState !== nextState) {
        setCurrentState(nextState);
      }
    });
  }, [store]);
  return [currentState, store.getActions(), store];
}

// React 18 requires the use of the useSyncExternalStore hook for external
initializeUseStoreState(with_selector.useSyncExternalStoreWithSelector);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 24429:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ 53981:
/***/ (function(module) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ 81648:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ 24726:
/***/ (function(module) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ 26712:
/***/ (function(module) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ 33464:
/***/ (function(module) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ 14453:
/***/ (function(module) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ 43915:
/***/ (function(module) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ 68892:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),

/***/ 58875:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),

/***/ 62991:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst


  var envHasBigInt64Array = typeof BigInt64Array !== 'undefined';


module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }


    if ((a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      for (i of a.entries())
        if (!equal(i[1], b.get(i[0]))) return false;
      return true;
    }

    if ((a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      return true;
    }

    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }


    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 94029:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(95320);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */
var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */
var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */
var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

/** @type {(x: unknown) => x is readonly unknown[]} */
function isArray(x) {
    return toStr.call(x) === '[object Array]';
}

/** @type {import('.')._internal} */
module.exports = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (isArray(list)) {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};


/***/ }),

/***/ 17648:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 58612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(17648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 40210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(68892);

var $Error = __webpack_require__(81648);
var $EvalError = __webpack_require__(53981);
var $RangeError = __webpack_require__(24726);
var $ReferenceError = __webpack_require__(26712);
var $SyntaxError = __webpack_require__(33464);
var $TypeError = __webpack_require__(14453);
var $URIError = __webpack_require__(43915);

var abs = __webpack_require__(59738);
var floor = __webpack_require__(76329);
var max = __webpack_require__(52264);
var min = __webpack_require__(55730);
var pow = __webpack_require__(20707);
var round = __webpack_require__(63862);
var sign = __webpack_require__(29550);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(27296);
var $defineProperty = __webpack_require__(24429);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(41405)();

var getProto = __webpack_require__(81618);
var $ObjectGPO = __webpack_require__(68899);
var $ReflectGPO = __webpack_require__(10443);

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(48824);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 68899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__(68892);

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ }),

/***/ 10443:
/***/ (function(module) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),

/***/ 81618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__(10443);
var originalGetProto = __webpack_require__(68899);

var getDunderProto = __webpack_require__(96504);

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ }),

/***/ 40690:
/***/ (function(module) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ 27296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(40690);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 31044:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(24429);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),

/***/ 41405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(55419);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 55419:
/***/ (function(module) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 96410:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(55419);

/** @type {import('.')} */
module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ 48824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(58612);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 35717:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 82584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(96410)();
var callBound = __webpack_require__(17379);

var $toString = callBound('Object.prototype.toString');

/** @type {import('.')} */
var isStandardArguments = function isArguments(value) {
	if (
		hasToStringTag
		&& value
		&& typeof value === 'object'
		&& Symbol.toStringTag in value
	) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

/** @type {import('.')} */
var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null
		&& typeof value === 'object'
		&& 'length' in value
		&& typeof value.length === 'number'
		&& value.length >= 0
		&& $toString(value) !== '[object Array]'
		&& 'callee' in value
		&& $toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

// @ts-expect-error TODO make this not error
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

/** @type {import('.')} */
module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),

/***/ 95320:
/***/ (function(module) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr.call(all) === toStr.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

module.exports = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};


/***/ }),

/***/ 48662:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(17379);
var safeRegexTest = __webpack_require__(79246);
var isFnRegex = safeRegexTest(/^\s*(?:function)?\*/);
var hasToStringTag = __webpack_require__(96410)();
var getProto = __webpack_require__(81618);

var toStr = callBound('Object.prototype.toString');
var fnToStr = callBound('Function.prototype.toString');

var getGeneratorFunc = function () { // eslint-disable-line consistent-return
	if (!hasToStringTag) {
		return false;
	}
	try {
		return Function('return function*() {}')();
	} catch (e) {
	}
};
/** @type {undefined | false | null | GeneratorFunctionConstructor} */
var GeneratorFunction;

/** @type {import('.')} */
module.exports = function isGeneratorFunction(fn) {
	if (typeof fn !== 'function') {
		return false;
	}
	if (isFnRegex(fnToStr(fn))) {
		return true;
	}
	if (!hasToStringTag) {
		var str = toStr(fn);
		return str === '[object GeneratorFunction]';
	}
	if (!getProto) {
		return false;
	}
	if (typeof GeneratorFunction === 'undefined') {
		var generatorFunc = getGeneratorFunc();
		GeneratorFunction = generatorFunc
			// eslint-disable-next-line no-extra-parens
			? /** @type {GeneratorFunctionConstructor} */ (getProto(generatorFunc))
			: false;
	}
	return getProto(fn) === GeneratorFunction;
};


/***/ }),

/***/ 98420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(17379);
var hasToStringTag = __webpack_require__(96410)();
var hasOwn = __webpack_require__(48824);
var gOPD = __webpack_require__(27296);

/** @type {import('.')} */
var fn;

if (hasToStringTag) {
	/** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */
	var $exec = callBound('RegExp.prototype.exec');
	/** @type {object} */
	var isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	/** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */
	var badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}

	/** @type {import('.')} */
	// @ts-expect-error TS can't figure out that the $exec call always throws
	// eslint-disable-next-line consistent-return
	fn = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {NonNullable<typeof gOPD>} */ (gOPD)(/** @type {{ lastIndex?: unknown }} */ (value), 'lastIndex');
		var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			// eslint-disable-next-line no-extra-parens
			$exec(value, /** @type {string} */ (/** @type {unknown} */ (badStringifier)));
		} catch (e) {
			return e === isRegexMarker;
		}
	};
} else {
	/** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */
	var $toString = callBound('Object.prototype.toString');
	/** @const @type {'[object RegExp]'} */
	var regexClass = '[object RegExp]';

	/** @type {import('.')} */
	fn = function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};
}

module.exports = fn;


/***/ }),

/***/ 85692:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var whichTypedArray = __webpack_require__(86430);

/** @type {import('.')} */
module.exports = function isTypedArray(value) {
	return !!whichTypedArray(value);
};


/***/ }),

/***/ 59738:
/***/ (function(module) {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),

/***/ 76329:
/***/ (function(module) {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ }),

/***/ 43678:
/***/ (function(module) {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),

/***/ 52264:
/***/ (function(module) {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),

/***/ 55730:
/***/ (function(module) {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),

/***/ 20707:
/***/ (function(module) {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),

/***/ 63862:
/***/ (function(module) {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ }),

/***/ 29550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(43678);

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ }),

/***/ 29548:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(64836);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.BroadcastChannel = BroadcastChannel;
exports.apiBaseUrl = apiBaseUrl;
exports.fetchData = fetchData;
exports.now = now;
var _regenerator = _interopRequireDefault(__webpack_require__(64687));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(38416));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(17156));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function fetchData(_x, _x2, _x3) {
  return _fetchData.apply(this, arguments);
}
function _fetchData() {
  _fetchData = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(path, __NEXTAUTH, logger) {
    var _ref,
      ctx,
      _ref$req,
      req,
      url,
      _req$headers,
      options,
      res,
      data,
      _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = _args.length > 3 && _args[3] !== undefined ? _args[3] : {}, ctx = _ref.ctx, _ref$req = _ref.req, req = _ref$req === void 0 ? ctx === null || ctx === void 0 ? void 0 : ctx.req : _ref$req;
          url = "".concat(apiBaseUrl(__NEXTAUTH), "/").concat(path);
          _context.prev = 2;
          options = {
            headers: _objectSpread({
              "Content-Type": "application/json"
            }, req !== null && req !== void 0 && (_req$headers = req.headers) !== null && _req$headers !== void 0 && _req$headers.cookie ? {
              cookie: req.headers.cookie
            } : {})
          };
          if (req !== null && req !== void 0 && req.body) {
            options.body = JSON.stringify(req.body);
            options.method = "POST";
          }
          _context.next = 7;
          return fetch(url, options);
        case 7:
          res = _context.sent;
          _context.next = 10;
          return res.json();
        case 10:
          data = _context.sent;
          if (res.ok) {
            _context.next = 13;
            break;
          }
          throw data;
        case 13:
          return _context.abrupt("return", Object.keys(data).length > 0 ? data : null);
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](2);
          logger.error("CLIENT_FETCH_ERROR", {
            error: _context.t0,
            url: url
          });
          return _context.abrupt("return", null);
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 16]]);
  }));
  return _fetchData.apply(this, arguments);
}
function apiBaseUrl(__NEXTAUTH) {
  if (typeof window === "undefined") {
    return "".concat(__NEXTAUTH.baseUrlServer).concat(__NEXTAUTH.basePathServer);
  }
  return __NEXTAUTH.basePath;
}
function now() {
  return Math.floor(Date.now() / 1000);
}
function BroadcastChannel() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "nextauth.message";
  return {
    receive: function receive(onReceive) {
      var handler = function handler(event) {
        var _event$newValue;
        if (event.key !== name) return;
        var message = JSON.parse((_event$newValue = event.newValue) !== null && _event$newValue !== void 0 ? _event$newValue : "{}");
        if ((message === null || message === void 0 ? void 0 : message.event) !== "session" || !(message !== null && message !== void 0 && message.data)) return;
        onReceive(message);
      };
      window.addEventListener("storage", handler);
      return function () {
        return window.removeEventListener("storage", handler);
      };
    },
    post: function post(message) {
      if (typeof window === "undefined") return;
      try {
        localStorage.setItem(name, JSON.stringify(_objectSpread(_objectSpread({}, message), {}, {
          timestamp: now()
        })));
      } catch (_unused) {}
    }
  };
}

/***/ }),

/***/ 36925:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(64836);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.UnsupportedStrategy = exports.UnknownError = exports.OAuthCallbackError = exports.MissingSecret = exports.MissingAuthorize = exports.MissingAdapterMethods = exports.MissingAdapter = exports.MissingAPIRoute = exports.InvalidCallbackUrl = exports.AccountNotLinkedError = void 0;
exports.adapterErrorHandler = adapterErrorHandler;
exports.capitalize = capitalize;
exports.eventsErrorHandler = eventsErrorHandler;
exports.upperSnake = upperSnake;
var _regenerator = _interopRequireDefault(__webpack_require__(64687));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(17156));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(38416));
var _classCallCheck2 = _interopRequireDefault(__webpack_require__(56690));
var _createClass2 = _interopRequireDefault(__webpack_require__(89728));
var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(94993));
var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(73808));
var _inherits2 = _interopRequireDefault(__webpack_require__(61655));
var _wrapNativeSuper2 = _interopRequireDefault(__webpack_require__(33496));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var UnknownError = exports.UnknownError = function (_Error) {
  function UnknownError(error) {
    var _message;
    var _this;
    (0, _classCallCheck2.default)(this, UnknownError);
    _this = _callSuper(this, UnknownError, [(_message = error === null || error === void 0 ? void 0 : error.message) !== null && _message !== void 0 ? _message : error]);
    _this.name = "UnknownError";
    _this.code = error.code;
    if (error instanceof Error) {
      _this.stack = error.stack;
    }
    return _this;
  }
  (0, _inherits2.default)(UnknownError, _Error);
  return (0, _createClass2.default)(UnknownError, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        name: this.name,
        message: this.message,
        stack: this.stack
      };
    }
  }]);
}((0, _wrapNativeSuper2.default)(Error));
var OAuthCallbackError = exports.OAuthCallbackError = function (_UnknownError) {
  function OAuthCallbackError() {
    var _this2;
    (0, _classCallCheck2.default)(this, OAuthCallbackError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, OAuthCallbackError, [].concat(args));
    (0, _defineProperty2.default)(_this2, "name", "OAuthCallbackError");
    return _this2;
  }
  (0, _inherits2.default)(OAuthCallbackError, _UnknownError);
  return (0, _createClass2.default)(OAuthCallbackError);
}(UnknownError);
var AccountNotLinkedError = exports.AccountNotLinkedError = function (_UnknownError2) {
  function AccountNotLinkedError() {
    var _this3;
    (0, _classCallCheck2.default)(this, AccountNotLinkedError);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this3 = _callSuper(this, AccountNotLinkedError, [].concat(args));
    (0, _defineProperty2.default)(_this3, "name", "AccountNotLinkedError");
    return _this3;
  }
  (0, _inherits2.default)(AccountNotLinkedError, _UnknownError2);
  return (0, _createClass2.default)(AccountNotLinkedError);
}(UnknownError);
var MissingAPIRoute = exports.MissingAPIRoute = function (_UnknownError3) {
  function MissingAPIRoute() {
    var _this4;
    (0, _classCallCheck2.default)(this, MissingAPIRoute);
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this4 = _callSuper(this, MissingAPIRoute, [].concat(args));
    (0, _defineProperty2.default)(_this4, "name", "MissingAPIRouteError");
    (0, _defineProperty2.default)(_this4, "code", "MISSING_NEXTAUTH_API_ROUTE_ERROR");
    return _this4;
  }
  (0, _inherits2.default)(MissingAPIRoute, _UnknownError3);
  return (0, _createClass2.default)(MissingAPIRoute);
}(UnknownError);
var MissingSecret = exports.MissingSecret = function (_UnknownError4) {
  function MissingSecret() {
    var _this5;
    (0, _classCallCheck2.default)(this, MissingSecret);
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    _this5 = _callSuper(this, MissingSecret, [].concat(args));
    (0, _defineProperty2.default)(_this5, "name", "MissingSecretError");
    (0, _defineProperty2.default)(_this5, "code", "NO_SECRET");
    return _this5;
  }
  (0, _inherits2.default)(MissingSecret, _UnknownError4);
  return (0, _createClass2.default)(MissingSecret);
}(UnknownError);
var MissingAuthorize = exports.MissingAuthorize = function (_UnknownError5) {
  function MissingAuthorize() {
    var _this6;
    (0, _classCallCheck2.default)(this, MissingAuthorize);
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    _this6 = _callSuper(this, MissingAuthorize, [].concat(args));
    (0, _defineProperty2.default)(_this6, "name", "MissingAuthorizeError");
    (0, _defineProperty2.default)(_this6, "code", "CALLBACK_CREDENTIALS_HANDLER_ERROR");
    return _this6;
  }
  (0, _inherits2.default)(MissingAuthorize, _UnknownError5);
  return (0, _createClass2.default)(MissingAuthorize);
}(UnknownError);
var MissingAdapter = exports.MissingAdapter = function (_UnknownError6) {
  function MissingAdapter() {
    var _this7;
    (0, _classCallCheck2.default)(this, MissingAdapter);
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }
    _this7 = _callSuper(this, MissingAdapter, [].concat(args));
    (0, _defineProperty2.default)(_this7, "name", "MissingAdapterError");
    (0, _defineProperty2.default)(_this7, "code", "EMAIL_REQUIRES_ADAPTER_ERROR");
    return _this7;
  }
  (0, _inherits2.default)(MissingAdapter, _UnknownError6);
  return (0, _createClass2.default)(MissingAdapter);
}(UnknownError);
var MissingAdapterMethods = exports.MissingAdapterMethods = function (_UnknownError7) {
  function MissingAdapterMethods() {
    var _this8;
    (0, _classCallCheck2.default)(this, MissingAdapterMethods);
    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }
    _this8 = _callSuper(this, MissingAdapterMethods, [].concat(args));
    (0, _defineProperty2.default)(_this8, "name", "MissingAdapterMethodsError");
    (0, _defineProperty2.default)(_this8, "code", "MISSING_ADAPTER_METHODS_ERROR");
    return _this8;
  }
  (0, _inherits2.default)(MissingAdapterMethods, _UnknownError7);
  return (0, _createClass2.default)(MissingAdapterMethods);
}(UnknownError);
var UnsupportedStrategy = exports.UnsupportedStrategy = function (_UnknownError8) {
  function UnsupportedStrategy() {
    var _this9;
    (0, _classCallCheck2.default)(this, UnsupportedStrategy);
    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }
    _this9 = _callSuper(this, UnsupportedStrategy, [].concat(args));
    (0, _defineProperty2.default)(_this9, "name", "UnsupportedStrategyError");
    (0, _defineProperty2.default)(_this9, "code", "CALLBACK_CREDENTIALS_JWT_ERROR");
    return _this9;
  }
  (0, _inherits2.default)(UnsupportedStrategy, _UnknownError8);
  return (0, _createClass2.default)(UnsupportedStrategy);
}(UnknownError);
var InvalidCallbackUrl = exports.InvalidCallbackUrl = function (_UnknownError9) {
  function InvalidCallbackUrl() {
    var _this10;
    (0, _classCallCheck2.default)(this, InvalidCallbackUrl);
    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }
    _this10 = _callSuper(this, InvalidCallbackUrl, [].concat(args));
    (0, _defineProperty2.default)(_this10, "name", "InvalidCallbackUrl");
    (0, _defineProperty2.default)(_this10, "code", "INVALID_CALLBACK_URL_ERROR");
    return _this10;
  }
  (0, _inherits2.default)(InvalidCallbackUrl, _UnknownError9);
  return (0, _createClass2.default)(InvalidCallbackUrl);
}(UnknownError);
function upperSnake(s) {
  return s.replace(/([A-Z])/g, "_$1").toUpperCase();
}
function capitalize(s) {
  return "".concat(s[0].toUpperCase()).concat(s.slice(1));
}
function eventsErrorHandler(methods, logger) {
  return Object.keys(methods).reduce(function (acc, name) {
    acc[name] = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
      var method,
        _args = arguments;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            method = methods[name];
            _context.next = 4;
            return method.apply(void 0, _args);
          case 4:
            return _context.abrupt("return", _context.sent);
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            logger.error("".concat(upperSnake(name), "_EVENT_ERROR"), _context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return acc;
  }, {});
}
function adapterErrorHandler(adapter, logger) {
  if (!adapter) return;
  return Object.keys(adapter).reduce(function (acc, name) {
    acc[name] = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
      var _len10,
        args,
        _key10,
        method,
        e,
        _args2 = arguments;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            for (_len10 = _args2.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
              args[_key10] = _args2[_key10];
            }
            logger.debug("adapter_".concat(name), {
              args: args
            });
            method = adapter[name];
            _context2.next = 6;
            return method.apply(void 0, args);
          case 6:
            return _context2.abrupt("return", _context2.sent);
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            logger.error("adapter_error_".concat(name), _context2.t0);
            e = new UnknownError(_context2.t0);
            e.name = "".concat(capitalize(name), "Error");
            throw e;
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 9]]);
    }));
    return acc;
  }, {});
}

/***/ }),

/***/ 33299:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var _interopRequireDefault = __webpack_require__(64836);
var _typeof = __webpack_require__(18698);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _exportNames = {
  SessionContext: true,
  useSession: true,
  getSession: true,
  getCsrfToken: true,
  getProviders: true,
  signIn: true,
  signOut: true,
  SessionProvider: true
};
exports.SessionContext = void 0;
exports.SessionProvider = SessionProvider;
exports.getCsrfToken = getCsrfToken;
exports.getProviders = getProviders;
exports.getSession = getSession;
exports.signIn = signIn;
exports.signOut = signOut;
exports.useSession = useSession;
var _regenerator = _interopRequireDefault(__webpack_require__(64687));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(38416));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(17156));
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(27424));
var React = _interopRequireWildcard(__webpack_require__(67294));
var _logger2 = _interopRequireWildcard(__webpack_require__(26553));
var _parseUrl = _interopRequireDefault(__webpack_require__(30762));
var _utils = __webpack_require__(29548);
var _jsxRuntime = __webpack_require__(85893);
var _types = __webpack_require__(527);
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});
var _process$env$NEXTAUTH, _ref, _process$env$NEXTAUTH2, _process$env$NEXTAUTH3, _React$createContext;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var __NEXTAUTH = {
  baseUrl: (0, _parseUrl.default)((_process$env$NEXTAUTH = process.env.NEXTAUTH_URL) !== null && _process$env$NEXTAUTH !== void 0 ? _process$env$NEXTAUTH : process.env.VERCEL_URL).origin,
  basePath: (0, _parseUrl.default)(process.env.NEXTAUTH_URL).path,
  baseUrlServer: (0, _parseUrl.default)((_ref = (_process$env$NEXTAUTH2 = process.env.NEXTAUTH_URL_INTERNAL) !== null && _process$env$NEXTAUTH2 !== void 0 ? _process$env$NEXTAUTH2 : process.env.NEXTAUTH_URL) !== null && _ref !== void 0 ? _ref : process.env.VERCEL_URL).origin,
  basePathServer: (0, _parseUrl.default)((_process$env$NEXTAUTH3 = process.env.NEXTAUTH_URL_INTERNAL) !== null && _process$env$NEXTAUTH3 !== void 0 ? _process$env$NEXTAUTH3 : process.env.NEXTAUTH_URL).path,
  _lastSync: 0,
  _session: undefined,
  _getSession: function _getSession() {}
};
var broadcast = (0, _utils.BroadcastChannel)();
var logger = (0, _logger2.proxyLogger)(_logger2.default, __NEXTAUTH.basePath);
function useOnline() {
  var _React$useState = React.useState(typeof navigator !== "undefined" ? navigator.onLine : false),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    isOnline = _React$useState2[0],
    setIsOnline = _React$useState2[1];
  var setOnline = function setOnline() {
    return setIsOnline(true);
  };
  var setOffline = function setOffline() {
    return setIsOnline(false);
  };
  React.useEffect(function () {
    window.addEventListener("online", setOnline);
    window.addEventListener("offline", setOffline);
    return function () {
      window.removeEventListener("online", setOnline);
      window.removeEventListener("offline", setOffline);
    };
  }, []);
  return isOnline;
}
var SessionContext = exports.SessionContext = (_React$createContext = React.createContext) === null || _React$createContext === void 0 ? void 0 : _React$createContext.call(React, undefined);
function useSession(options) {
  if (!SessionContext) {
    throw new Error("React Context is unavailable in Server Components");
  }
  var value = React.useContext(SessionContext);
  if (!value && "production" !== "production") {}
  var _ref2 = options !== null && options !== void 0 ? options : {},
    required = _ref2.required,
    onUnauthenticated = _ref2.onUnauthenticated;
  var requiredAndNotLoading = required && value.status === "unauthenticated";
  React.useEffect(function () {
    if (requiredAndNotLoading) {
      var url = "/api/auth/signin?".concat(new URLSearchParams({
        error: "SessionRequired",
        callbackUrl: window.location.href
      }));
      if (onUnauthenticated) onUnauthenticated();else window.location.href = url;
    }
  }, [requiredAndNotLoading, onUnauthenticated]);
  if (requiredAndNotLoading) {
    return {
      data: value.data,
      update: value.update,
      status: "loading"
    };
  }
  return value;
}
function getSession(_x) {
  return _getSession2.apply(this, arguments);
}
function _getSession2() {
  _getSession2 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(params) {
    var _params$broadcast;
    var session;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _utils.fetchData)("session", __NEXTAUTH, logger, params);
        case 2:
          session = _context3.sent;
          if ((_params$broadcast = params === null || params === void 0 ? void 0 : params.broadcast) !== null && _params$broadcast !== void 0 ? _params$broadcast : true) {
            broadcast.post({
              event: "session",
              data: {
                trigger: "getSession"
              }
            });
          }
          return _context3.abrupt("return", session);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getSession2.apply(this, arguments);
}
function getCsrfToken(_x2) {
  return _getCsrfToken.apply(this, arguments);
}
function _getCsrfToken() {
  _getCsrfToken = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4(params) {
    var response;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _utils.fetchData)("csrf", __NEXTAUTH, logger, params);
        case 2:
          response = _context4.sent;
          return _context4.abrupt("return", response === null || response === void 0 ? void 0 : response.csrfToken);
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _getCsrfToken.apply(this, arguments);
}
function getProviders() {
  return _getProviders.apply(this, arguments);
}
function _getProviders() {
  _getProviders = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee5() {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _utils.fetchData)("providers", __NEXTAUTH, logger);
        case 2:
          return _context5.abrupt("return", _context5.sent);
        case 3:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _getProviders.apply(this, arguments);
}
function signIn(_x3, _x4, _x5) {
  return _signIn.apply(this, arguments);
}
function _signIn() {
  _signIn = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee6(provider, options, authorizationParams) {
    var _ref5, _ref5$callbackUrl, callbackUrl, _ref5$redirect, redirect, baseUrl, providers, isCredentials, isEmail, isSupportingReturn, signInUrl, _signInUrl, res, data, _data$url, url, error;
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _ref5 = options !== null && options !== void 0 ? options : {}, _ref5$callbackUrl = _ref5.callbackUrl, callbackUrl = _ref5$callbackUrl === void 0 ? window.location.href : _ref5$callbackUrl, _ref5$redirect = _ref5.redirect, redirect = _ref5$redirect === void 0 ? true : _ref5$redirect;
          baseUrl = (0, _utils.apiBaseUrl)(__NEXTAUTH);
          _context6.next = 4;
          return getProviders();
        case 4:
          providers = _context6.sent;
          if (providers) {
            _context6.next = 8;
            break;
          }
          window.location.href = "".concat(baseUrl, "/error");
          return _context6.abrupt("return");
        case 8:
          if (!(!provider || !(provider in providers))) {
            _context6.next = 11;
            break;
          }
          window.location.href = "".concat(baseUrl, "/signin?").concat(new URLSearchParams({
            callbackUrl: callbackUrl
          }));
          return _context6.abrupt("return");
        case 11:
          isCredentials = providers[provider].type === "credentials";
          isEmail = providers[provider].type === "email";
          isSupportingReturn = isCredentials || isEmail;
          signInUrl = "".concat(baseUrl, "/").concat(isCredentials ? "callback" : "signin", "/").concat(provider);
          _signInUrl = "".concat(signInUrl).concat(authorizationParams ? "?".concat(new URLSearchParams(authorizationParams)) : "");
          _context6.t0 = fetch;
          _context6.t1 = _signInUrl;
          _context6.t2 = {
            "Content-Type": "application/x-www-form-urlencoded"
          };
          _context6.t3 = URLSearchParams;
          _context6.t4 = _objectSpread;
          _context6.t5 = _objectSpread({}, options);
          _context6.t6 = {};
          _context6.next = 25;
          return getCsrfToken();
        case 25:
          _context6.t7 = _context6.sent;
          _context6.t8 = callbackUrl;
          _context6.t9 = {
            csrfToken: _context6.t7,
            callbackUrl: _context6.t8,
            json: true
          };
          _context6.t10 = (0, _context6.t4)(_context6.t5, _context6.t6, _context6.t9);
          _context6.t11 = new _context6.t3(_context6.t10);
          _context6.t12 = {
            method: "post",
            headers: _context6.t2,
            body: _context6.t11
          };
          _context6.next = 33;
          return (0, _context6.t0)(_context6.t1, _context6.t12);
        case 33:
          res = _context6.sent;
          _context6.next = 36;
          return res.json();
        case 36:
          data = _context6.sent;
          if (!(redirect || !isSupportingReturn)) {
            _context6.next = 42;
            break;
          }
          url = (_data$url = data.url) !== null && _data$url !== void 0 ? _data$url : callbackUrl;
          window.location.href = url;
          if (url.includes("#")) window.location.reload();
          return _context6.abrupt("return");
        case 42:
          error = new URL(data.url).searchParams.get("error");
          if (!res.ok) {
            _context6.next = 46;
            break;
          }
          _context6.next = 46;
          return __NEXTAUTH._getSession({
            event: "storage"
          });
        case 46:
          return _context6.abrupt("return", {
            error: error,
            status: res.status,
            ok: res.ok,
            url: error ? null : data.url
          });
        case 47:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _signIn.apply(this, arguments);
}
function signOut(_x6) {
  return _signOut.apply(this, arguments);
}
function _signOut() {
  _signOut = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee7(options) {
    var _options$redirect;
    var _ref6, _ref6$callbackUrl, callbackUrl, baseUrl, fetchOptions, res, data, _data$url2, url;
    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _ref6 = options !== null && options !== void 0 ? options : {}, _ref6$callbackUrl = _ref6.callbackUrl, callbackUrl = _ref6$callbackUrl === void 0 ? window.location.href : _ref6$callbackUrl;
          baseUrl = (0, _utils.apiBaseUrl)(__NEXTAUTH);
          _context7.t0 = {
            "Content-Type": "application/x-www-form-urlencoded"
          };
          _context7.t1 = URLSearchParams;
          _context7.next = 6;
          return getCsrfToken();
        case 6:
          _context7.t2 = _context7.sent;
          _context7.t3 = callbackUrl;
          _context7.t4 = {
            csrfToken: _context7.t2,
            callbackUrl: _context7.t3,
            json: true
          };
          _context7.t5 = new _context7.t1(_context7.t4);
          fetchOptions = {
            method: "post",
            headers: _context7.t0,
            body: _context7.t5
          };
          _context7.next = 13;
          return fetch("".concat(baseUrl, "/signout"), fetchOptions);
        case 13:
          res = _context7.sent;
          _context7.next = 16;
          return res.json();
        case 16:
          data = _context7.sent;
          broadcast.post({
            event: "session",
            data: {
              trigger: "signout"
            }
          });
          if (!((_options$redirect = options === null || options === void 0 ? void 0 : options.redirect) !== null && _options$redirect !== void 0 ? _options$redirect : true)) {
            _context7.next = 23;
            break;
          }
          url = (_data$url2 = data.url) !== null && _data$url2 !== void 0 ? _data$url2 : callbackUrl;
          window.location.href = url;
          if (url.includes("#")) window.location.reload();
          return _context7.abrupt("return");
        case 23:
          _context7.next = 25;
          return __NEXTAUTH._getSession({
            event: "storage"
          });
        case 25:
          return _context7.abrupt("return", data);
        case 26:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _signOut.apply(this, arguments);
}
function SessionProvider(props) {
  if (!SessionContext) {
    throw new Error("React Context is unavailable in Server Components");
  }
  var children = props.children,
    basePath = props.basePath,
    refetchInterval = props.refetchInterval,
    refetchWhenOffline = props.refetchWhenOffline;
  if (basePath) __NEXTAUTH.basePath = basePath;
  var hasInitialSession = props.session !== undefined;
  __NEXTAUTH._lastSync = hasInitialSession ? (0, _utils.now)() : 0;
  var _React$useState3 = React.useState(function () {
      if (hasInitialSession) __NEXTAUTH._session = props.session;
      return props.session;
    }),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    session = _React$useState4[0],
    setSession = _React$useState4[1];
  var _React$useState5 = React.useState(!hasInitialSession),
    _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
    loading = _React$useState6[0],
    setLoading = _React$useState6[1];
  React.useEffect(function () {
    __NEXTAUTH._getSession = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
      var _ref4,
        event,
        storageEvent,
        _args = arguments;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref4 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, event = _ref4.event;
            _context.prev = 1;
            storageEvent = event === "storage";
            if (!(storageEvent || __NEXTAUTH._session === undefined)) {
              _context.next = 10;
              break;
            }
            __NEXTAUTH._lastSync = (0, _utils.now)();
            _context.next = 7;
            return getSession({
              broadcast: !storageEvent
            });
          case 7:
            __NEXTAUTH._session = _context.sent;
            setSession(__NEXTAUTH._session);
            return _context.abrupt("return");
          case 10:
            if (!(!event || __NEXTAUTH._session === null || (0, _utils.now)() < __NEXTAUTH._lastSync)) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return");
          case 12:
            __NEXTAUTH._lastSync = (0, _utils.now)();
            _context.next = 15;
            return getSession();
          case 15:
            __NEXTAUTH._session = _context.sent;
            setSession(__NEXTAUTH._session);
            _context.next = 22;
            break;
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](1);
            logger.error("CLIENT_SESSION_ERROR", _context.t0);
          case 22:
            _context.prev = 22;
            setLoading(false);
            return _context.finish(22);
          case 25:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 19, 22, 25]]);
    }));
    __NEXTAUTH._getSession();
    return function () {
      __NEXTAUTH._lastSync = 0;
      __NEXTAUTH._session = undefined;
      __NEXTAUTH._getSession = function () {};
    };
  }, []);
  React.useEffect(function () {
    var unsubscribe = broadcast.receive(function () {
      return __NEXTAUTH._getSession({
        event: "storage"
      });
    });
    return function () {
      return unsubscribe();
    };
  }, []);
  React.useEffect(function () {
    var _props$refetchOnWindo = props.refetchOnWindowFocus,
      refetchOnWindowFocus = _props$refetchOnWindo === void 0 ? true : _props$refetchOnWindo;
    var visibilityHandler = function visibilityHandler() {
      if (refetchOnWindowFocus && document.visibilityState === "visible") __NEXTAUTH._getSession({
        event: "visibilitychange"
      });
    };
    document.addEventListener("visibilitychange", visibilityHandler, false);
    return function () {
      return document.removeEventListener("visibilitychange", visibilityHandler, false);
    };
  }, [props.refetchOnWindowFocus]);
  var isOnline = useOnline();
  var shouldRefetch = refetchWhenOffline !== false || isOnline;
  React.useEffect(function () {
    if (refetchInterval && shouldRefetch) {
      var refetchIntervalTimer = setInterval(function () {
        if (__NEXTAUTH._session) {
          __NEXTAUTH._getSession({
            event: "poll"
          });
        }
      }, refetchInterval * 1000);
      return function () {
        return clearInterval(refetchIntervalTimer);
      };
    }
  }, [refetchInterval, shouldRefetch]);
  var value = React.useMemo(function () {
    return {
      data: session,
      status: loading ? "loading" : session ? "authenticated" : "unauthenticated",
      update: function update(data) {
        return (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
          var newSession;
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!(loading || !session)) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                setLoading(true);
                _context2.t0 = _utils.fetchData;
                _context2.t1 = __NEXTAUTH;
                _context2.t2 = logger;
                _context2.next = 8;
                return getCsrfToken();
              case 8:
                _context2.t3 = _context2.sent;
                _context2.t4 = data;
                _context2.t5 = {
                  csrfToken: _context2.t3,
                  data: _context2.t4
                };
                _context2.t6 = {
                  body: _context2.t5
                };
                _context2.t7 = {
                  req: _context2.t6
                };
                _context2.next = 15;
                return (0, _context2.t0)("session", _context2.t1, _context2.t2, _context2.t7);
              case 15:
                newSession = _context2.sent;
                setLoading(false);
                if (newSession) {
                  setSession(newSession);
                  broadcast.post({
                    event: "session",
                    data: {
                      trigger: "getSession"
                    }
                  });
                }
                return _context2.abrupt("return", newSession);
              case 19:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      }
    };
  }, [session, loading]);
  return (0, _jsxRuntime.jsx)(SessionContext.Provider, {
    value: value,
    children: children
  });
}

/***/ }),

/***/ 527:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

/***/ }),

/***/ 26553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(64836);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
exports.proxyLogger = proxyLogger;
exports.setLogger = setLogger;
var _regenerator = _interopRequireDefault(__webpack_require__(64687));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(38416));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(17156));
var _errors = __webpack_require__(36925);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function formatError(o) {
  if (o instanceof Error && !(o instanceof _errors.UnknownError)) {
    return {
      message: o.message,
      stack: o.stack,
      name: o.name
    };
  }
  if (hasErrorProperty(o)) {
    var _o$message;
    o.error = formatError(o.error);
    o.message = (_o$message = o.message) !== null && _o$message !== void 0 ? _o$message : o.error.message;
  }
  return o;
}
function hasErrorProperty(x) {
  return !!(x !== null && x !== void 0 && x.error);
}
var _logger = {
  error: function error(code, metadata) {
    metadata = formatError(metadata);
    console.error("[next-auth][error][".concat(code, "]"), "\nhttps://next-auth.js.org/errors#".concat(code.toLowerCase()), metadata.message, metadata);
  },
  warn: function warn(code) {
    console.warn("[next-auth][warn][".concat(code, "]"), "\nhttps://next-auth.js.org/warnings#".concat(code.toLowerCase()));
  },
  debug: function debug(code, metadata) {
    console.log("[next-auth][debug][".concat(code, "]"), metadata);
  }
};
function setLogger() {
  var newLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var debug = arguments.length > 1 ? arguments[1] : undefined;
  if (!debug) _logger.debug = function () {};
  if (newLogger.error) _logger.error = newLogger.error;
  if (newLogger.warn) _logger.warn = newLogger.warn;
  if (newLogger.debug) _logger.debug = newLogger.debug;
}
var _default = exports["default"] = _logger;
function proxyLogger() {
  var logger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _logger;
  var basePath = arguments.length > 1 ? arguments[1] : undefined;
  try {
    if (typeof window === "undefined") {
      return logger;
    }
    var clientLogger = {};
    var _loop = function _loop(level) {
      clientLogger[level] = function () {
        var _ref = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(code, metadata) {
          var url, body;
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _logger[level](code, metadata);
                if (level === "error") {
                  metadata = formatError(metadata);
                }
                ;
                metadata.client = true;
                url = "".concat(basePath, "/_log");
                body = new URLSearchParams(_objectSpread({
                  level: level,
                  code: code
                }, metadata));
                if (!navigator.sendBeacon) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return", navigator.sendBeacon(url, body));
              case 8:
                _context.next = 10;
                return fetch(url, {
                  method: "POST",
                  body: body,
                  keepalive: true
                });
              case 10:
                return _context.abrupt("return", _context.sent);
              case 11:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();
    };
    for (var level in logger) {
      _loop(level);
    }
    return clientLogger;
  } catch (_unused) {
    return _logger;
  }
}

/***/ }),

/***/ 30762:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = parseUrl;
function parseUrl(url) {
  var _url2;
  const defaultUrl = new URL("http://localhost:3000/api/auth");
  if (url && !url.startsWith("http")) {
    url = `https://${url}`;
  }
  const _url = new URL((_url2 = url) !== null && _url2 !== void 0 ? _url2 : defaultUrl);
  const path = (_url.pathname === "/" ? defaultUrl.pathname : _url.pathname).replace(/\/$/, "");
  const base = `${_url.origin}${path}`;
  return {
    origin: _url.origin,
    host: _url.host,
    path,
    base,
    toString: () => base
  };
}

/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(12957);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71210:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 28045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)["default"]);
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)["default"]);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageConfig = __webpack_require__(99309);
var _useIntersection = __webpack_require__(57190);
var _imageConfigContext = __webpack_require__(59977);
var _utils = __webpack_require__(63794);
var _normalizeTrailingSlash = __webpack_require__(82392);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 48418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(45753)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)["default"]);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(76273);
var _addLocale = __webpack_require__(22725);
var _routerContext = __webpack_require__(63462);
var _appRouterContext = __webpack_require__(21018);
var _useIntersection = __webpack_require__(57190);
var _getDomainLocale = __webpack_require__(71210);
var _addBasePath = __webpack_require__(98684);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 21018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 65980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _RedButton_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15873);
/* harmony import */ var _RedButton_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_RedButton_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var RedButton = function(param) {
    var onClick = param.onClick, style = param.style, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: onClick,
        className: "".concat((_RedButton_module_scss__WEBPACK_IMPORTED_MODULE_2___default().RedButton), " ").concat(style),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RedButton);


/***/ }),

/***/ 1705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Toggle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Toggle_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76214);
/* harmony import */ var _Toggle_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Toggle_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function Toggle(props) {
    var isActive = props.isActive, onClickToggle = props.onClickToggle, disabled = props.disabled, transparent = props.transparent;
    var handleClickToggle = function() {
        if (!disabled) {
            onClickToggle();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Toggle_module_scss__WEBPACK_IMPORTED_MODULE_1___default().toggleController),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_Toggle_module_scss__WEBPACK_IMPORTED_MODULE_1___default().toggle), " ").concat(disabled ? (_Toggle_module_scss__WEBPACK_IMPORTED_MODULE_1___default().disabled) : "", " ").concat(transparent ? (_Toggle_module_scss__WEBPACK_IMPORTED_MODULE_1___default().transparent) : ""),
            onClick: handleClickToggle,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "".concat((_Toggle_module_scss__WEBPACK_IMPORTED_MODULE_1___default().point), " ").concat(isActive ? (_Toggle_module_scss__WEBPACK_IMPORTED_MODULE_1___default().active) : "")
            })
        })
    });
}


/***/ }),

/***/ 78470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoaderButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _LoaderButton_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53488);
/* harmony import */ var _LoaderButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_LoaderButton_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function LoaderButton() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_LoaderButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loader)
    });
}


/***/ }),

/***/ 54512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ModalTemplate_ModalTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/components/Common/Modals/ModalTemplate/ModalTemplate.module.scss
var ModalTemplate_module = __webpack_require__(823);
var ModalTemplate_module_default = /*#__PURE__*/__webpack_require__.n(ModalTemplate_module);
// EXTERNAL MODULE: ./src/contexts/ModalContext.tsx
var ModalContext = __webpack_require__(86662);
// EXTERNAL MODULE: ./src/contexts/ResponsiveContext.tsx
var ResponsiveContext = __webpack_require__(24025);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/@radix-ui/primitive/dist/index.mjs
// packages/core/primitive/src/primitive.tsx
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler?.(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) {
      return ourEventHandler?.(event);
    }
  };
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-compose-refs/dist/index.mjs
// packages/react/compose-refs/src/compose-refs.tsx

function setRef(ref, value) {
  if (typeof ref === "function") {
    return ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
function composeRefs(...refs) {
  return (node) => {
    let hasCleanup = false;
    const cleanups = refs.map((ref) => {
      const cleanup = setRef(ref, node);
      if (!hasCleanup && typeof cleanup == "function") {
        hasCleanup = true;
      }
      return cleanup;
    });
    if (hasCleanup) {
      return () => {
        for (let i = 0; i < cleanups.length; i++) {
          const cleanup = cleanups[i];
          if (typeof cleanup == "function") {
            cleanup();
          } else {
            setRef(refs[i], null);
          }
        }
      };
    }
  };
}
function useComposedRefs(...refs) {
  return react.useCallback(composeRefs(...refs), refs);
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-context/dist/index.mjs
// packages/react/context/src/create-context.tsx


function createContext2(rootComponentName, defaultContext) {
  const Context = react.createContext(defaultContext);
  const Provider = (props) => {
    const { children, ...context } = props;
    const value = react.useMemo(() => context, Object.values(context));
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Context.Provider, { value, children });
  };
  Provider.displayName = rootComponentName + "Provider";
  function useContext2(consumerName) {
    const context = react.useContext(Context);
    if (context) return context;
    if (defaultContext !== void 0) return defaultContext;
    throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
  }
  return [Provider, useContext2];
}
function createContextScope(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext3(rootComponentName, defaultContext) {
    const BaseContext = react.createContext(defaultContext);
    const index = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    const Provider = (props) => {
      const { scope, children, ...context } = props;
      const Context = scope?.[scopeName]?.[index] || BaseContext;
      const value = react.useMemo(() => context, Object.values(context));
      return /* @__PURE__ */ (0,jsx_runtime.jsx)(Context.Provider, { value, children });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName, scope) {
      const Context = scope?.[scopeName]?.[index] || BaseContext;
      const context = react.useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [Provider, useContext2];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return react.createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = scope?.[scopeName] || scopeContexts;
      return react.useMemo(
        () => ({ [`__scope${scopeName}`]: { ...scope, [scopeName]: contexts } }),
        [scope, contexts]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [createContext3, composeContextScopes(createScope, ...createContextScopeDeps)];
}
function composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope = () => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return { ...nextScopes2, ...currentScope };
      }, {});
      return react.useMemo(() => ({ [`__scope${baseScope.scopeName}`]: nextScopes }), [nextScopes]);
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
// packages/react/use-layout-effect/src/use-layout-effect.tsx

var useLayoutEffect2 = globalThis?.document ? react.useLayoutEffect : () => {
};

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-id/dist/index.mjs
// packages/react/id/src/id.tsx


var useReactId = react_namespaceObject[" useId ".trim().toString()] || (() => void 0);
var count = 0;
function useId(deterministicId) {
  const [id, setId] = react.useState(useReactId());
  useLayoutEffect2(() => {
    if (!deterministicId) setId((reactId) => reactId ?? String(count++));
  }, [deterministicId]);
  return deterministicId || (id ? `radix-${id}` : "");
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
// src/use-controllable-state.tsx


var useInsertionEffect = react_namespaceObject[" useInsertionEffect ".trim().toString()] || useLayoutEffect2;
function useControllableState({
  prop,
  defaultProp,
  onChange = () => {
  },
  caller
}) {
  const [uncontrolledProp, setUncontrolledProp, onChangeRef] = useUncontrolledState({
    defaultProp,
    onChange
  });
  const isControlled = prop !== void 0;
  const value = isControlled ? prop : uncontrolledProp;
  if (true) {
    const isControlledRef = react.useRef(prop !== void 0);
    react.useEffect(() => {
      const wasControlled = isControlledRef.current;
      if (wasControlled !== isControlled) {
        const from = wasControlled ? "controlled" : "uncontrolled";
        const to = isControlled ? "controlled" : "uncontrolled";
        console.warn(
          `${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
        );
      }
      isControlledRef.current = isControlled;
    }, [isControlled, caller]);
  }
  const setValue = react.useCallback(
    (nextValue) => {
      if (isControlled) {
        const value2 = isFunction(nextValue) ? nextValue(prop) : nextValue;
        if (value2 !== prop) {
          onChangeRef.current?.(value2);
        }
      } else {
        setUncontrolledProp(nextValue);
      }
    },
    [isControlled, prop, setUncontrolledProp, onChangeRef]
  );
  return [value, setValue];
}
function useUncontrolledState({
  defaultProp,
  onChange
}) {
  const [value, setValue] = react.useState(defaultProp);
  const prevValueRef = react.useRef(value);
  const onChangeRef = react.useRef(onChange);
  useInsertionEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  react.useEffect(() => {
    if (prevValueRef.current !== value) {
      onChangeRef.current?.(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef]);
  return [value, setValue, onChangeRef];
}
function isFunction(value) {
  return typeof value === "function";
}

// src/use-controllable-state-reducer.tsx


var SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function useControllableStateReducer(reducer, userArgs, initialArg, init) {
  const { prop: controlledState, defaultProp, onChange: onChangeProp, caller } = userArgs;
  const isControlled = controlledState !== void 0;
  const onChange = useEffectEvent(onChangeProp);
  if (true) {
    const isControlledRef = React2.useRef(controlledState !== void 0);
    React2.useEffect(() => {
      const wasControlled = isControlledRef.current;
      if (wasControlled !== isControlled) {
        const from = wasControlled ? "controlled" : "uncontrolled";
        const to = isControlled ? "controlled" : "uncontrolled";
        console.warn(
          `${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
        );
      }
      isControlledRef.current = isControlled;
    }, [isControlled, caller]);
  }
  const args = [{ ...initialArg, state: defaultProp }];
  if (init) {
    args.push(init);
  }
  const [internalState, dispatch] = React2.useReducer(
    (state2, action) => {
      if (action.type === SYNC_STATE) {
        return { ...state2, state: action.state };
      }
      const next = reducer(state2, action);
      if (isControlled && !Object.is(next.state, state2.state)) {
        onChange(next.state);
      }
      return next;
    },
    ...args
  );
  const uncontrolledState = internalState.state;
  const prevValueRef = React2.useRef(uncontrolledState);
  React2.useEffect(() => {
    if (prevValueRef.current !== uncontrolledState) {
      prevValueRef.current = uncontrolledState;
      if (!isControlled) {
        onChange(uncontrolledState);
      }
    }
  }, [onChange, uncontrolledState, prevValueRef, isControlled]);
  const state = React2.useMemo(() => {
    const isControlled2 = controlledState !== void 0;
    if (isControlled2) {
      return { ...internalState, state: controlledState };
    }
    return internalState;
  }, [internalState, controlledState]);
  React2.useEffect(() => {
    if (isControlled && !Object.is(controlledState, internalState.state)) {
      dispatch({ type: SYNC_STATE, state: controlledState });
    }
  }, [controlledState, internalState.state, isControlled]);
  return [state, dispatch];
}

//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-slot/dist/index.mjs
"use client";

// src/slot.tsx



// @__NO_SIDE_EFFECTS__
function createSlot(ownerName) {
  const SlotClone = /* @__PURE__ */ createSlotClone(ownerName);
  const Slot2 = react.forwardRef((props, forwardedRef) => {
    const { children, ...slotProps } = props;
    const childrenArray = react.Children.toArray(children);
    const slottable = childrenArray.find(isSlottable);
    if (slottable) {
      const newElement = slottable.props.children;
      const newChildren = childrenArray.map((child) => {
        if (child === slottable) {
          if (react.Children.count(newElement) > 1) return react.Children.only(null);
          return react.isValidElement(newElement) ? newElement.props.children : null;
        } else {
          return child;
        }
      });
      return /* @__PURE__ */ (0,jsx_runtime.jsx)(SlotClone, { ...slotProps, ref: forwardedRef, children: react.isValidElement(newElement) ? react.cloneElement(newElement, void 0, newChildren) : null });
    }
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(SlotClone, { ...slotProps, ref: forwardedRef, children });
  });
  Slot2.displayName = `${ownerName}.Slot`;
  return Slot2;
}
var Slot = /* @__PURE__ */ (/* unused pure expression or super */ null && (createSlot("Slot")));
// @__NO_SIDE_EFFECTS__
function createSlotClone(ownerName) {
  const SlotClone = react.forwardRef((props, forwardedRef) => {
    const { children, ...slotProps } = props;
    const childrenRef = react.isValidElement(children) ? getElementRef(children) : void 0;
    const ref = useComposedRefs(childrenRef, forwardedRef);
    if (react.isValidElement(children)) {
      const props2 = mergeProps(slotProps, children.props);
      if (children.type !== react.Fragment) {
        props2.ref = ref;
      }
      return react.cloneElement(children, props2);
    }
    return react.Children.count(children) > 1 ? react.Children.only(null) : null;
  });
  SlotClone.displayName = `${ownerName}.SlotClone`;
  return SlotClone;
}
var SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function createSlottable(ownerName) {
  const Slottable2 = ({ children }) => {
    return /* @__PURE__ */ jsx(Fragment2, { children });
  };
  Slottable2.displayName = `${ownerName}.Slottable`;
  Slottable2.__radixId = SLOTTABLE_IDENTIFIER;
  return Slottable2;
}
var Slottable = /* @__PURE__ */ (/* unused pure expression or super */ null && (createSlottable("Slottable")));
function isSlottable(child) {
  return react.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === SLOTTABLE_IDENTIFIER;
}
function mergeProps(slotProps, childProps) {
  const overrideProps = { ...childProps };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          const result = childPropValue(...args);
          slotPropValue(...args);
          return result;
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = { ...slotPropValue, ...childPropValue };
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return { ...slotProps, ...overrideProps };
}
function getElementRef(element) {
  let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.mjs
// src/primitive.tsx




var NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
];
var Primitive = NODES.reduce((primitive, node) => {
  const Slot = createSlot(`Primitive.${node}`);
  const Node = react.forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? Slot : node;
    if (typeof window !== "undefined") {
      window[Symbol.for("radix-ui")] = true;
    }
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Comp, { ...primitiveProps, ref: forwardedRef });
  });
  Node.displayName = `Primitive.${node}`;
  return { ...primitive, [node]: Node };
}, {});
function dispatchDiscreteCustomEvent(target, event) {
  if (target) react_dom.flushSync(() => target.dispatchEvent(event));
}
var Root = (/* unused pure expression or super */ null && (Primitive));

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
// packages/react/use-callback-ref/src/use-callback-ref.tsx

function useCallbackRef(callback) {
  const callbackRef = react.useRef(callback);
  react.useEffect(() => {
    callbackRef.current = callback;
  });
  return react.useMemo(() => (...args) => callbackRef.current?.(...args), []);
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-use-escape-keydown/dist/index.mjs
// packages/react/use-escape-keydown/src/use-escape-keydown.tsx


function useEscapeKeydown(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
  const onEscapeKeyDown = useCallbackRef(onEscapeKeyDownProp);
  react.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onEscapeKeyDown(event);
      }
    };
    ownerDocument.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => ownerDocument.removeEventListener("keydown", handleKeyDown, { capture: true });
  }, [onEscapeKeyDown, ownerDocument]);
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
"use client";

// src/dismissable-layer.tsx







var DISMISSABLE_LAYER_NAME = "DismissableLayer";
var CONTEXT_UPDATE = "dismissableLayer.update";
var POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var originalBodyPointerEvents;
var DismissableLayerContext = react.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
});
var DismissableLayer = react.forwardRef(
  (props, forwardedRef) => {
    const {
      disableOutsidePointerEvents = false,
      onEscapeKeyDown,
      onPointerDownOutside,
      onFocusOutside,
      onInteractOutside,
      onDismiss,
      ...layerProps
    } = props;
    const context = react.useContext(DismissableLayerContext);
    const [node, setNode] = react.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = react.useState({});
    const composedRefs = useComposedRefs(forwardedRef, (node2) => setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [...context.layersWithOutsidePointerEventsDisabled].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = usePointerDownOutside((event) => {
      const target = event.target;
      const isPointerDownOnBranch = [...context.branches].some((branch) => branch.contains(target));
      if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
      onPointerDownOutside?.(event);
      onInteractOutside?.(event);
      if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = useFocusOutside((event) => {
      const target = event.target;
      const isFocusInBranch = [...context.branches].some((branch) => branch.contains(target));
      if (isFocusInBranch) return;
      onFocusOutside?.(event);
      onInteractOutside?.(event);
      if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    useEscapeKeydown((event) => {
      const isHighestLayer = index === context.layers.size - 1;
      if (!isHighestLayer) return;
      onEscapeKeyDown?.(event);
      if (!event.defaultPrevented && onDismiss) {
        event.preventDefault();
        onDismiss();
      }
    }, ownerDocument);
    react.useEffect(() => {
      if (!node) return;
      if (disableOutsidePointerEvents) {
        if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
          originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
          ownerDocument.body.style.pointerEvents = "none";
        }
        context.layersWithOutsidePointerEventsDisabled.add(node);
      }
      context.layers.add(node);
      dispatchUpdate();
      return () => {
        if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) {
          ownerDocument.body.style.pointerEvents = originalBodyPointerEvents;
        }
      };
    }, [node, ownerDocument, disableOutsidePointerEvents, context]);
    react.useEffect(() => {
      return () => {
        if (!node) return;
        context.layers.delete(node);
        context.layersWithOutsidePointerEventsDisabled.delete(node);
        dispatchUpdate();
      };
    }, [node, context]);
    react.useEffect(() => {
      const handleUpdate = () => force({});
      document.addEventListener(CONTEXT_UPDATE, handleUpdate);
      return () => document.removeEventListener(CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      Primitive.div,
      {
        ...layerProps,
        ref: composedRefs,
        style: {
          pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
          ...props.style
        },
        onFocusCapture: composeEventHandlers(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: composeEventHandlers(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: composeEventHandlers(
          props.onPointerDownCapture,
          pointerDownOutside.onPointerDownCapture
        )
      }
    );
  }
);
DismissableLayer.displayName = DISMISSABLE_LAYER_NAME;
var BRANCH_NAME = "DismissableLayerBranch";
var DismissableLayerBranch = react.forwardRef((props, forwardedRef) => {
  const context = react.useContext(DismissableLayerContext);
  const ref = react.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  react.useEffect(() => {
    const node = ref.current;
    if (node) {
      context.branches.add(node);
      return () => {
        context.branches.delete(node);
      };
    }
  }, [context.branches]);
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(Primitive.div, { ...props, ref: composedRefs });
});
DismissableLayerBranch.displayName = BRANCH_NAME;
function usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
  const handlePointerDownOutside = useCallbackRef(onPointerDownOutside);
  const isPointerInsideReactTreeRef = react.useRef(false);
  const handleClickRef = react.useRef(() => {
  });
  react.useEffect(() => {
    const handlePointerDown = (event) => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent2 = function() {
          handleAndDispatchCustomEvent(
            POINTER_DOWN_OUTSIDE,
            handlePointerDownOutside,
            eventDetail,
            { discrete: true }
          );
        };
        var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
        const eventDetail = { originalEvent: event };
        if (event.pointerType === "touch") {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
          ownerDocument.addEventListener("click", handleClickRef.current, { once: true });
        } else {
          handleAndDispatchPointerDownOutsideEvent2();
        }
      } else {
        ownerDocument.removeEventListener("click", handleClickRef.current);
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
    };
  }, [ownerDocument, handlePointerDownOutside]);
  return {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
  const handleFocusOutside = useCallbackRef(onFocusOutside);
  const isFocusInsideReactTreeRef = react.useRef(false);
  react.useEffect(() => {
    const handleFocus = (event) => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = { originalEvent: event };
        handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener("focusin", handleFocus);
    return () => ownerDocument.removeEventListener("focusin", handleFocus);
  }, [ownerDocument, handleFocusOutside]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function dispatchUpdate() {
  const event = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, { bubbles: false, cancelable: true, detail });
  if (handler) target.addEventListener(name, handler, { once: true });
  if (discrete) {
    dispatchDiscreteCustomEvent(target, event);
  } else {
    target.dispatchEvent(event);
  }
}
var dist_Root = (/* unused pure expression or super */ null && (DismissableLayer));
var Branch = (/* unused pure expression or super */ null && (DismissableLayerBranch));

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-focus-scope/dist/index.mjs
"use client";

// src/focus-scope.tsx





var AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var EVENT_OPTIONS = { bubbles: false, cancelable: true };
var FOCUS_SCOPE_NAME = "FocusScope";
var FocusScope = react.forwardRef((props, forwardedRef) => {
  const {
    loop = false,
    trapped = false,
    onMountAutoFocus: onMountAutoFocusProp,
    onUnmountAutoFocus: onUnmountAutoFocusProp,
    ...scopeProps
  } = props;
  const [container, setContainer] = react.useState(null);
  const onMountAutoFocus = useCallbackRef(onMountAutoFocusProp);
  const onUnmountAutoFocus = useCallbackRef(onUnmountAutoFocusProp);
  const lastFocusedElementRef = react.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, (node) => setContainer(node));
  const focusScope = react.useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  react.useEffect(() => {
    if (trapped) {
      let handleFocusIn2 = function(event) {
        if (focusScope.paused || !container) return;
        const target = event.target;
        if (container.contains(target)) {
          lastFocusedElementRef.current = target;
        } else {
          dist_focus(lastFocusedElementRef.current, { select: true });
        }
      }, handleFocusOut2 = function(event) {
        if (focusScope.paused || !container) return;
        const relatedTarget = event.relatedTarget;
        if (relatedTarget === null) return;
        if (!container.contains(relatedTarget)) {
          dist_focus(lastFocusedElementRef.current, { select: true });
        }
      }, handleMutations2 = function(mutations) {
        const focusedElement = document.activeElement;
        if (focusedElement !== document.body) return;
        for (const mutation of mutations) {
          if (mutation.removedNodes.length > 0) dist_focus(container);
        }
      };
      var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
      document.addEventListener("focusin", handleFocusIn2);
      document.addEventListener("focusout", handleFocusOut2);
      const mutationObserver = new MutationObserver(handleMutations2);
      if (container) mutationObserver.observe(container, { childList: true, subtree: true });
      return () => {
        document.removeEventListener("focusin", handleFocusIn2);
        document.removeEventListener("focusout", handleFocusOut2);
        mutationObserver.disconnect();
      };
    }
  }, [trapped, container, focusScope.paused]);
  react.useEffect(() => {
    if (container) {
      focusScopesStack.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS);
        container.addEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          focusFirst(removeLinks(getTabbableCandidates(container)), { select: true });
          if (document.activeElement === previouslyFocusedElement) {
            dist_focus(container);
          }
        }
      }
      return () => {
        container.removeEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS);
          container.addEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) {
            dist_focus(previouslyFocusedElement ?? document.body, { select: true });
          }
          container.removeEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [container, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  const handleKeyDown = react.useCallback(
    (event) => {
      if (!loop && !trapped) return;
      if (focusScope.paused) return;
      const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
      const focusedElement = document.activeElement;
      if (isTabKey && focusedElement) {
        const container2 = event.currentTarget;
        const [first, last] = getTabbableEdges(container2);
        const hasTabbableElementsInside = first && last;
        if (!hasTabbableElementsInside) {
          if (focusedElement === container2) event.preventDefault();
        } else {
          if (!event.shiftKey && focusedElement === last) {
            event.preventDefault();
            if (loop) dist_focus(first, { select: true });
          } else if (event.shiftKey && focusedElement === first) {
            event.preventDefault();
            if (loop) dist_focus(last, { select: true });
          }
        }
      }
    },
    [loop, trapped, focusScope.paused]
  );
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(Primitive.div, { tabIndex: -1, ...scopeProps, ref: composedRefs, onKeyDown: handleKeyDown });
});
FocusScope.displayName = FOCUS_SCOPE_NAME;
function focusFirst(candidates, { select = false } = {}) {
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    dist_focus(candidate, { select });
    if (document.activeElement !== previouslyFocusedElement) return;
  }
}
function getTabbableEdges(container) {
  const candidates = getTabbableCandidates(container);
  const first = findVisible(candidates, container);
  const last = findVisible(candidates.reverse(), container);
  return [first, last];
}
function getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node) => {
      const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
      if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function findVisible(elements, container) {
  for (const element of elements) {
    if (!isHidden(element, { upTo: container })) return element;
  }
}
function isHidden(node, { upTo }) {
  if (getComputedStyle(node).visibility === "hidden") return true;
  while (node) {
    if (upTo !== void 0 && node === upTo) return false;
    if (getComputedStyle(node).display === "none") return true;
    node = node.parentElement;
  }
  return false;
}
function isSelectableInput(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function dist_focus(element, { select = false } = {}) {
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({ preventScroll: true });
    if (element !== previouslyFocusedElement && isSelectableInput(element) && select)
      element.select();
  }
}
var focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) {
        activeFocusScope?.pause();
      }
      stack = arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      stack = arrayRemove(stack, focusScope);
      stack[0]?.resume();
    }
  };
}
function arrayRemove(array, item) {
  const updatedArray = [...array];
  const index = updatedArray.indexOf(item);
  if (index !== -1) {
    updatedArray.splice(index, 1);
  }
  return updatedArray;
}
function removeLinks(items) {
  return items.filter((item) => item.tagName !== "A");
}
var react_focus_scope_dist_Root = (/* unused pure expression or super */ null && (FocusScope));

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-portal/dist/index.mjs
"use client";

// src/portal.tsx





var PORTAL_NAME = "Portal";
var Portal = react.forwardRef((props, forwardedRef) => {
  const { container: containerProp, ...portalProps } = props;
  const [mounted, setMounted] = react.useState(false);
  useLayoutEffect2(() => setMounted(true), []);
  const container = containerProp || mounted && globalThis?.document?.body;
  return container ? react_dom.createPortal(/* @__PURE__ */ (0,jsx_runtime.jsx)(Primitive.div, { ...portalProps, ref: forwardedRef }), container) : null;
});
Portal.displayName = PORTAL_NAME;
var react_portal_dist_Root = (/* unused pure expression or super */ null && (Portal));

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-presence/dist/index.mjs
"use client";

// src/presence.tsx




// src/use-state-machine.tsx

function useStateMachine(initialState, machine) {
  return react.useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState ?? state;
  }, initialState);
}

// src/presence.tsx
var Presence = (props) => {
  const { present, children } = props;
  const presence = usePresence(present);
  const child = typeof children === "function" ? children({ present: presence.isPresent }) : react.Children.only(children);
  const ref = useComposedRefs(presence.ref, dist_getElementRef(child));
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? react.cloneElement(child, { ref }) : null;
};
Presence.displayName = "Presence";
function usePresence(present) {
  const [node, setNode] = react.useState();
  const stylesRef = react.useRef(null);
  const prevPresentRef = react.useRef(present);
  const prevAnimationNameRef = react.useRef("none");
  const initialState = present ? "mounted" : "unmounted";
  const [state, send] = useStateMachine(initialState, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  react.useEffect(() => {
    const currentAnimationName = getAnimationName(stylesRef.current);
    prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
  }, [state]);
  useLayoutEffect2(() => {
    const styles = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = getAnimationName(styles);
      if (present) {
        send("MOUNT");
      } else if (currentAnimationName === "none" || styles?.display === "none") {
        send("UNMOUNT");
      } else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) {
          send("ANIMATION_OUT");
        } else {
          send("UNMOUNT");
        }
      }
      prevPresentRef.current = present;
    }
  }, [present, send]);
  useLayoutEffect2(() => {
    if (node) {
      let timeoutId;
      const ownerWindow = node.ownerDocument.defaultView ?? window;
      const handleAnimationEnd = (event) => {
        const currentAnimationName = getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(event.animationName);
        if (event.target === node && isCurrentAnimation) {
          send("ANIMATION_END");
          if (!prevPresentRef.current) {
            const currentFillMode = node.style.animationFillMode;
            node.style.animationFillMode = "forwards";
            timeoutId = ownerWindow.setTimeout(() => {
              if (node.style.animationFillMode === "forwards") {
                node.style.animationFillMode = currentFillMode;
              }
            });
          }
        }
      };
      const handleAnimationStart = (event) => {
        if (event.target === node) {
          prevAnimationNameRef.current = getAnimationName(stylesRef.current);
        }
      };
      node.addEventListener("animationstart", handleAnimationStart);
      node.addEventListener("animationcancel", handleAnimationEnd);
      node.addEventListener("animationend", handleAnimationEnd);
      return () => {
        ownerWindow.clearTimeout(timeoutId);
        node.removeEventListener("animationstart", handleAnimationStart);
        node.removeEventListener("animationcancel", handleAnimationEnd);
        node.removeEventListener("animationend", handleAnimationEnd);
      };
    } else {
      send("ANIMATION_END");
    }
  }, [node, send]);
  return {
    isPresent: ["mounted", "unmountSuspended"].includes(state),
    ref: react.useCallback((node2) => {
      stylesRef.current = node2 ? getComputedStyle(node2) : null;
      setNode(node2);
    }, [])
  };
}
function getAnimationName(styles) {
  return styles?.animationName || "none";
}
function dist_getElementRef(element) {
  let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var react_presence_dist_Root = (/* unused pure expression or super */ null && (Presence));

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-focus-guards/dist/index.mjs
"use client";

// packages/react/focus-guards/src/focus-guards.tsx

var dist_count = 0;
function FocusGuards(props) {
  useFocusGuards();
  return props.children;
}
function useFocusGuards() {
  react.useEffect(() => {
    const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? createFocusGuard());
    document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? createFocusGuard());
    dist_count++;
    return () => {
      if (dist_count === 1) {
        document.querySelectorAll("[data-radix-focus-guard]").forEach((node) => node.remove());
      }
      dist_count--;
    };
  }, []);
}
function createFocusGuard() {
  const element = document.createElement("span");
  element.setAttribute("data-radix-focus-guard", "");
  element.tabIndex = 0;
  element.style.outline = "none";
  element.style.opacity = "0";
  element.style.position = "fixed";
  element.style.pointerEvents = "none";
  return element;
}
var react_focus_guards_dist_Root = (/* unused pure expression or super */ null && (FocusGuards));

//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/assignRef.js
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/useRef.js

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useRef_useCallbackRef(initialValue, callback) {
    var ref = (0,react.useState)(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/useMergeRef.js



var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;
var currentValues = new WeakMap();
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    var callbackRef = useRef_useCallbackRef(defaultValue || null, function (newValue) {
        return refs.forEach(function (ref) { return assignRef(ref, newValue); });
    });
    // handle refs changes - added or removed
    useIsomorphicLayoutEffect(function () {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function (ref) {
                if (!nextRefs_1.has(ref)) {
                    assignRef(ref, null);
                }
            });
            nextRefs_1.forEach(function (ref) {
                if (!prevRefs_1.has(ref)) {
                    assignRef(ref, current_1);
                }
            });
        }
        currentValues.set(callbackRef, refs);
    }, [refs]);
    return callbackRef;
}

;// CONCATENATED MODULE: ./node_modules/use-sidecar/dist/es2015/medium.js

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = (0,tslib_es6.__assign)({ async: true, ssr: false }, options);
    return medium;
}

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/medium.js

var effectCar = createSidecarMedium();

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/UI.js





var nothing = function () {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */
var RemoveScroll = react.forwardRef(function (props, parentRef) {
    var ref = react.useRef(null);
    var _a = react.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing,
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0,tslib_es6.__rest)(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]);
    var SideCar = sideCar;
    var containerRef = useMergeRefs([ref, parentRef]);
    var containerProps = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, rest), callbacks);
    return (react.createElement(react.Fragment, null,
        enabled && (react.createElement(SideCar, { sideCar: effectCar, removeScrollBar: removeScrollBar, shards: shards, noIsolation: noIsolation, inert: inert, setCallbacks: setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref, gapMode: gapMode })),
        forwardProps ? (react.cloneElement(react.Children.only(children), (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, containerProps), { ref: containerRef }))) : (react.createElement(Container, (0,tslib_es6.__assign)({}, containerProps, { className: className, ref: containerRef }), children))));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false,
};
RemoveScroll.classNames = {
    fullWidth: fullWidthClassName,
    zeroRight: zeroRightClassName,
};


;// CONCATENATED MODULE: ./node_modules/use-sidecar/dist/es2015/exports.js


var SideCar = function (_a) {
    var sideCar = _a.sideCar, rest = (0,tslib_es6.__rest)(_a, ["sideCar"]);
    if (!sideCar) {
        throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    }
    var Target = sideCar.read();
    if (!Target) {
        throw new Error('Sidecar medium not found');
    }
    return react.createElement(Target, (0,tslib_es6.__assign)({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

;// CONCATENATED MODULE: ./node_modules/get-nonce/dist/es2015/index.js
var currentNonce;
var setNonce = function (nonce) {
    currentNonce = nonce;
};
var getNonce = function () {
    if (currentNonce) {
        return currentNonce;
    }
    if (true) {
        return __webpack_require__.nc;
    }
    return undefined;
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/singleton.js

function makeStyleTag() {
    if (!document)
        return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = getNonce();
    if (nonce) {
        tag.setAttribute('nonce', nonce);
    }
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) {
        // @ts-ignore
        tag.styleSheet.cssText = css;
    }
    else {
        tag.appendChild(document.createTextNode(css));
    }
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function () {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function (style) {
            if (counter == 0) {
                if ((stylesheet = makeStyleTag())) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function () {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        },
    };
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/hook.js


/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */
var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles, isDynamic) {
        react.useEffect(function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, [styles && isDynamic]);
    };
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/component.js

/**
 * create a Component to add styles on demand
 * - styles are added when first instance is mounted
 * - styles are removed when the last instance is unmounted
 * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
 */
var styleSingleton = function () {
    var useStyle = styleHookSingleton();
    var Sheet = function (_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/index.js




;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0,
};
var parse = function (x) { return parseInt(x || '', 10) || 0; };
var getOffset = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function (gapMode) {
    if (gapMode === void 0) { gapMode = 'margin'; }
    if (typeof window === 'undefined') {
        return zeroGap;
    }
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
    };
};

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/component.js




var Style = styleSingleton();
var lockAttribute = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function (_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) { gapMode = 'margin'; }
    return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' &&
            "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";"),
    ]
        .filter(Boolean)
        .join(''), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function () {
    var counter = parseInt(document.body.getAttribute(lockAttribute) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function () {
    react.useEffect(function () {
        document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
        return function () {
            var newCounter = getCurrentUseCounter() - 1;
            if (newCounter <= 0) {
                document.body.removeAttribute(lockAttribute);
            }
            else {
                document.body.setAttribute(lockAttribute, newCounter.toString());
            }
        };
    }, []);
};
/**
 * Removes page scrollbar and blocks page scroll when mounted
 */
var RemoveScrollBar = function (_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    useLockAttribute();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */
    var gap = react.useMemo(function () { return getGapWidth(gapMode); }, [gapMode]);
    return react.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '') });
};

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/index.js





;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            },
        });
        // @ts-ignore
        window.addEventListener('test', options, options);
        // @ts-ignore
        window.removeEventListener('test', options, options);
    }
    catch (err) {
        passiveSupported = false;
    }
}
var nonPassive = passiveSupported ? { passive: false } : false;

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll = function (node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function (node, overflow) {
    if (!(node instanceof Element)) {
        return false;
    }
    var styles = window.getComputedStyle(node);
    return (
    // not-not-scrollable
    styles[overflow] !== 'hidden' &&
        // contains scroll inside self
        !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var elementCouldBeVScrolled = function (node) { return elementCanBeScrolled(node, 'overflowY'); };
var elementCouldBeHScrolled = function (node) { return elementCanBeScrolled(node, 'overflowX'); };
var locationCouldBeScrolled = function (axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
            current = current.host;
        }
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) {
                return true;
            }
        }
        current = current.parentNode;
    } while (current && current !== ownerDocument.body);
    return false;
};
var getVScrollVariables = function (_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight,
    ];
};
var getHScrollVariables = function (_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth,
    ];
};
var elementCouldBeScrolled = function (axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */
    return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) {
            target = target.host;
        }
        else {
            target = target.parentNode;
        }
    } while (
    // portaled content
    (!targetInLock && target !== document.body) ||
        // self content
        (targetInLock && (endTarget.contains(target) || endTarget === target)));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive &&
        ((noOverscroll && Math.abs(availableScroll) < 1) || (!noOverscroll && delta > availableScroll))) {
        shouldCancelScroll = true;
    }
    else if (!isDeltaPositive &&
        ((noOverscroll && Math.abs(availableScrollTop) < 1) || (!noOverscroll && -delta > availableScrollTop))) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/SideEffect.js






var getTouchXY = function (event) {
    return 'changedTouches' in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function (event) { return [event.deltaX, event.deltaY]; };
var extractRef = function (ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) { return x[0] === y[0] && x[1] === y[1]; };
var generateStyle = function (id) { return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n"); };
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = react.useRef([]);
    var touchStartRef = react.useRef([0, 0]);
    var activeAxis = react.useRef();
    var id = react.useState(idCounter++)[0];
    var Style = react.useState(styleSingleton)[0];
    var lastProps = react.useRef(props);
    react.useEffect(function () {
        lastProps.current = props;
    }, [props]);
    react.useEffect(function () {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0,tslib_es6.__spreadArray)([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
            allow_1.forEach(function (el) { return el.classList.add("allow-interactivity-".concat(id)); });
            return function () {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function (el) { return el.classList.remove("allow-interactivity-".concat(id)); });
            };
        }
        return;
    }, [props.inert, props.lockRef.current, props.shards]);
    var shouldCancelEvent = react.useCallback(function (event, parent) {
        if (('touches' in event && event.touches.length === 2) || (event.type === 'wheel' && event.ctrlKey)) {
            return !lastProps.current.allowPinchZoom;
        }
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
            return false;
        }
        var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
        if (!canBeScrolledInMainDirection) {
            return true;
        }
        if (canBeScrolledInMainDirection) {
            currentAxis = moveDirection;
        }
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
            // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) {
            return false;
        }
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
            activeAxis.current = currentAxis;
        }
        if (!currentAxis) {
            return true;
        }
        var cancelingAxis = activeAxis.current || currentAxis;
        return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = react.useCallback(function (_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
            // not the last active
            return;
        }
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function (e) { return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && deltaCompare(e.delta, delta); })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) {
                event.preventDefault();
            }
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || [])
                .map(extractRef)
                .filter(Boolean)
                .filter(function (node) { return node.contains(event.target); });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) {
                    event.preventDefault();
                }
            }
        }
    }, []);
    var shouldCancel = react.useCallback(function (name, delta, target, should) {
        var event = { name: name, delta: delta, target: target, should: should, shadowParent: getOutermostShadowParent(target) };
        shouldPreventQueue.current.push(event);
        setTimeout(function () {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) { return e !== event; });
        }, 1);
    }, []);
    var scrollTouchStart = react.useCallback(function (event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = react.useCallback(function (event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = react.useCallback(function (event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    react.useEffect(function () {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove,
        });
        document.addEventListener('wheel', shouldPrevent, nonPassive);
        document.addEventListener('touchmove', shouldPrevent, nonPassive);
        document.addEventListener('touchstart', scrollTouchStart, nonPassive);
        return function () {
            lockStack = lockStack.filter(function (inst) { return inst !== Style; });
            document.removeEventListener('wheel', shouldPrevent, nonPassive);
            document.removeEventListener('touchmove', shouldPrevent, nonPassive);
            document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return (react.createElement(react.Fragment, null,
        inert ? react.createElement(Style, { styles: generateStyle(id) }) : null,
        removeScrollBar ? react.createElement(RemoveScrollBar, { gapMode: props.gapMode }) : null));
}
function getOutermostShadowParent(node) {
    var shadowParent = null;
    while (node !== null) {
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/sidecar.js



/* harmony default export */ var sidecar = (exportSidecar(effectCar, RemoveScrollSideCar));

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/Combination.js




var ReactRemoveScroll = react.forwardRef(function (props, ref) { return (react.createElement(RemoveScroll, (0,tslib_es6.__assign)({}, props, { ref: ref, sideCar: sidecar }))); });
ReactRemoveScroll.classNames = RemoveScroll.classNames;
/* harmony default export */ var Combination = (ReactRemoveScroll);

;// CONCATENATED MODULE: ./node_modules/aria-hidden/dist/es2015/index.js
var getDefaultParent = function (originalTarget) {
    if (typeof document === 'undefined') {
        return null;
    }
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function (node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function (parent, targets) {
    return targets
        .map(function (target) {
        if (parent.contains(target)) {
            return target;
        }
        var correctedTarget = unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) {
            return correctedTarget;
        }
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    })
        .filter(function (x) { return Boolean(x); });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
    var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    if (!markerMap[markerName]) {
        markerMap[markerName] = new WeakMap();
    }
    var markerCounter = markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function (el) {
        if (!el || elementsToKeep.has(el)) {
            return;
        }
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function (parent) {
        if (!parent || elementsToStop.has(parent)) {
            return;
        }
        Array.prototype.forEach.call(parent.children, function (node) {
            if (elementsToKeep.has(node)) {
                deep(node);
            }
            else {
                try {
                    var attr = node.getAttribute(controlAttribute);
                    var alreadyHidden = attr !== null && attr !== 'false';
                    var counterValue = (counterMap.get(node) || 0) + 1;
                    var markerValue = (markerCounter.get(node) || 0) + 1;
                    counterMap.set(node, counterValue);
                    markerCounter.set(node, markerValue);
                    hiddenNodes.push(node);
                    if (counterValue === 1 && alreadyHidden) {
                        uncontrolledNodes.set(node, true);
                    }
                    if (markerValue === 1) {
                        node.setAttribute(markerName, 'true');
                    }
                    if (!alreadyHidden) {
                        node.setAttribute(controlAttribute, 'true');
                    }
                }
                catch (e) {
                    console.error('aria-hidden: cannot operate on ', node, e);
                }
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    lockCount++;
    return function () {
        hiddenNodes.forEach(function (node) {
            var counterValue = counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!uncontrolledNodes.has(node)) {
                    node.removeAttribute(controlAttribute);
                }
                uncontrolledNodes.delete(node);
            }
            if (!markerValue) {
                node.removeAttribute(markerName);
            }
        });
        lockCount--;
        if (!lockCount) {
            // clear
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledNodes = new WeakMap();
            markerMap = {};
        }
    };
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var hideOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-aria-hidden'; }
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live]')));
    return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
/**
 * Marks everything except given node(or nodes) as inert
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var inertOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-inert-ed'; }
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    return applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
/**
 * @returns if current browser supports inert
 */
var supportsInert = function () {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
/**
 * Automatic function to "suppress" DOM elements - _hide_ or _inert_ in the best possible way
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var suppressOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-suppressed'; }
    return (supportsInert() ? inertOthers : hideOthers)(originalTarget, parentNode, markerName);
};

;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-dialog/dist/index.mjs
"use client";

// src/dialog.tsx
















var DIALOG_NAME = "Dialog";
var [createDialogContext, createDialogScope] = createContextScope(DIALOG_NAME);
var [DialogProvider, useDialogContext] = createDialogContext(DIALOG_NAME);
var Dialog = (props) => {
  const {
    __scopeDialog,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = true
  } = props;
  const triggerRef = react.useRef(null);
  const contentRef = react.useRef(null);
  const [open, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen ?? false,
    onChange: onOpenChange,
    caller: DIALOG_NAME
  });
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    DialogProvider,
    {
      scope: __scopeDialog,
      triggerRef,
      contentRef,
      contentId: useId(),
      titleId: useId(),
      descriptionId: useId(),
      open,
      onOpenChange: setOpen,
      onOpenToggle: react.useCallback(() => setOpen((prevOpen) => !prevOpen), [setOpen]),
      modal,
      children
    }
  );
};
Dialog.displayName = DIALOG_NAME;
var TRIGGER_NAME = "DialogTrigger";
var DialogTrigger = react.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, ...triggerProps } = props;
    const context = useDialogContext(TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = useComposedRefs(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      Primitive.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: composeEventHandlers(props.onClick, context.onOpenToggle)
      }
    );
  }
);
DialogTrigger.displayName = TRIGGER_NAME;
var dist_PORTAL_NAME = "DialogPortal";
var [PortalProvider, usePortalContext] = createDialogContext(dist_PORTAL_NAME, {
  forceMount: void 0
});
var DialogPortal = (props) => {
  const { __scopeDialog, forceMount, children, container } = props;
  const context = useDialogContext(dist_PORTAL_NAME, __scopeDialog);
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(PortalProvider, { scope: __scopeDialog, forceMount, children: react.Children.map(children, (child) => /* @__PURE__ */ (0,jsx_runtime.jsx)(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Portal, { asChild: true, container, children: child }) })) });
};
DialogPortal.displayName = dist_PORTAL_NAME;
var OVERLAY_NAME = "DialogOverlay";
var DialogOverlay = react.forwardRef(
  (props, forwardedRef) => {
    const portalContext = usePortalContext(OVERLAY_NAME, props.__scopeDialog);
    const { forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = useDialogContext(OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(DialogOverlayImpl, { ...overlayProps, ref: forwardedRef }) }) : null;
  }
);
DialogOverlay.displayName = OVERLAY_NAME;
var dist_Slot = createSlot("DialogOverlay.RemoveScroll");
var DialogOverlayImpl = react.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, ...overlayProps } = props;
    const context = useDialogContext(OVERLAY_NAME, __scopeDialog);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ (0,jsx_runtime.jsx)(Combination, { as: dist_Slot, allowPinchZoom: true, shards: [context.contentRef], children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
        Primitive.div,
        {
          "data-state": getState(context.open),
          ...overlayProps,
          ref: forwardedRef,
          style: { pointerEvents: "auto", ...overlayProps.style }
        }
      ) })
    );
  }
);
var CONTENT_NAME = "DialogContent";
var DialogContent = react.forwardRef(
  (props, forwardedRef) => {
    const portalContext = usePortalContext(CONTENT_NAME, props.__scopeDialog);
    const { forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = useDialogContext(CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Presence, { present: forceMount || context.open, children: context.modal ? /* @__PURE__ */ (0,jsx_runtime.jsx)(DialogContentModal, { ...contentProps, ref: forwardedRef }) : /* @__PURE__ */ (0,jsx_runtime.jsx)(DialogContentNonModal, { ...contentProps, ref: forwardedRef }) });
  }
);
DialogContent.displayName = CONTENT_NAME;
var DialogContentModal = react.forwardRef(
  (props, forwardedRef) => {
    const context = useDialogContext(CONTENT_NAME, props.__scopeDialog);
    const contentRef = react.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, context.contentRef, contentRef);
    react.useEffect(() => {
      const content = contentRef.current;
      if (content) return hideOthers(content);
    }, []);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      DialogContentImpl,
      {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: composeEventHandlers(props.onCloseAutoFocus, (event) => {
          event.preventDefault();
          context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: composeEventHandlers(props.onPointerDownOutside, (event) => {
          const originalEvent = event.detail.originalEvent;
          const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
          const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
          if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: composeEventHandlers(
          props.onFocusOutside,
          (event) => event.preventDefault()
        )
      }
    );
  }
);
var DialogContentNonModal = react.forwardRef(
  (props, forwardedRef) => {
    const context = useDialogContext(CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = react.useRef(false);
    const hasPointerDownOutsideRef = react.useRef(false);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      DialogContentImpl,
      {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event) => {
          props.onCloseAutoFocus?.(event);
          if (!event.defaultPrevented) {
            if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
            event.preventDefault();
          }
          hasInteractedOutsideRef.current = false;
          hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event) => {
          props.onInteractOutside?.(event);
          if (!event.defaultPrevented) {
            hasInteractedOutsideRef.current = true;
            if (event.detail.originalEvent.type === "pointerdown") {
              hasPointerDownOutsideRef.current = true;
            }
          }
          const target = event.target;
          const targetIsTrigger = context.triggerRef.current?.contains(target);
          if (targetIsTrigger) event.preventDefault();
          if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) {
            event.preventDefault();
          }
        }
      }
    );
  }
);
var DialogContentImpl = react.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, trapFocus, onOpenAutoFocus, onCloseAutoFocus, ...contentProps } = props;
    const context = useDialogContext(CONTENT_NAME, __scopeDialog);
    const contentRef = react.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, contentRef);
    useFocusGuards();
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [
      /* @__PURE__ */ (0,jsx_runtime.jsx)(
        FocusScope,
        {
          asChild: true,
          loop: true,
          trapped: trapFocus,
          onMountAutoFocus: onOpenAutoFocus,
          onUnmountAutoFocus: onCloseAutoFocus,
          children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
            DismissableLayer,
            {
              role: "dialog",
              id: context.contentId,
              "aria-describedby": context.descriptionId,
              "aria-labelledby": context.titleId,
              "data-state": getState(context.open),
              ...contentProps,
              ref: composedRefs,
              onDismiss: () => context.onOpenChange(false)
            }
          )
        }
      ),
      /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [
        /* @__PURE__ */ (0,jsx_runtime.jsx)(TitleWarning, { titleId: context.titleId }),
        /* @__PURE__ */ (0,jsx_runtime.jsx)(DescriptionWarning, { contentRef, descriptionId: context.descriptionId })
      ] })
    ] });
  }
);
var TITLE_NAME = "DialogTitle";
var DialogTitle = react.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, ...titleProps } = props;
    const context = useDialogContext(TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Primitive.h2, { id: context.titleId, ...titleProps, ref: forwardedRef });
  }
);
DialogTitle.displayName = TITLE_NAME;
var DESCRIPTION_NAME = "DialogDescription";
var DialogDescription = react.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, ...descriptionProps } = props;
    const context = useDialogContext(DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Primitive.p, { id: context.descriptionId, ...descriptionProps, ref: forwardedRef });
  }
);
DialogDescription.displayName = DESCRIPTION_NAME;
var CLOSE_NAME = "DialogClose";
var DialogClose = react.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDialog, ...closeProps } = props;
    const context = useDialogContext(CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      Primitive.button,
      {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: composeEventHandlers(props.onClick, () => context.onOpenChange(false))
      }
    );
  }
);
DialogClose.displayName = CLOSE_NAME;
function getState(open) {
  return open ? "open" : "closed";
}
var TITLE_WARNING_NAME = "DialogTitleWarning";
var [WarningProvider, useWarningContext] = createContext2(TITLE_WARNING_NAME, {
  contentName: CONTENT_NAME,
  titleName: TITLE_NAME,
  docsSlug: "dialog"
});
var TitleWarning = ({ titleId }) => {
  const titleWarningContext = useWarningContext(TITLE_WARNING_NAME);
  const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
  react.useEffect(() => {
    if (titleId) {
      const hasTitle = document.getElementById(titleId);
      if (!hasTitle) console.error(MESSAGE);
    }
  }, [MESSAGE, titleId]);
  return null;
};
var DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var DescriptionWarning = ({ contentRef, descriptionId }) => {
  const descriptionWarningContext = useWarningContext(DESCRIPTION_WARNING_NAME);
  const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
  react.useEffect(() => {
    const describedById = contentRef.current?.getAttribute("aria-describedby");
    if (descriptionId && describedById) {
      const hasDescription = document.getElementById(descriptionId);
      if (!hasDescription) console.warn(MESSAGE);
    }
  }, [MESSAGE, contentRef, descriptionId]);
  return null;
};
var react_dialog_dist_Root = Dialog;
var Trigger = DialogTrigger;
var dist_Portal = DialogPortal;
var Overlay = DialogOverlay;
var Content = DialogContent;
var Title = DialogTitle;
var Description = DialogDescription;
var Close = DialogClose;

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/vaul/dist/index.mjs
'use client';
function __insertCSS(code) {
  if (!code || typeof document == 'undefined') return
  let head = document.head || document.getElementsByTagName('head')[0]
  let style = document.createElement('style')
  style.type = 'text/css'
  head.appendChild(style)
  ;style.styleSheet ? (style.styleSheet.cssText = code) : style.appendChild(document.createTextNode(code))
}





const DrawerContext = react.createContext({
    drawerRef: {
        current: null
    },
    overlayRef: {
        current: null
    },
    onPress: ()=>{},
    onRelease: ()=>{},
    onDrag: ()=>{},
    onNestedDrag: ()=>{},
    onNestedOpenChange: ()=>{},
    onNestedRelease: ()=>{},
    openProp: undefined,
    dismissible: false,
    isOpen: false,
    isDragging: false,
    keyboardIsOpen: {
        current: false
    },
    snapPointsOffset: null,
    snapPoints: null,
    handleOnly: false,
    modal: false,
    shouldFade: false,
    activeSnapPoint: null,
    onOpenChange: ()=>{},
    setActiveSnapPoint: ()=>{},
    closeDrawer: ()=>{},
    direction: 'bottom',
    shouldAnimate: {
        current: true
    },
    shouldScaleBackground: false,
    setBackgroundColorOnScale: true,
    noBodyStyles: false,
    container: null,
    autoFocus: false
});
const useDrawerContext = ()=>{
    const context = react.useContext(DrawerContext);
    if (!context) {
        throw new Error('useDrawerContext must be used within a Drawer.Root');
    }
    return context;
};

__insertCSS("[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(\n[data-state=closed]\n){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}");

function isMobileFirefox() {
    const userAgent = navigator.userAgent;
    return typeof window !== 'undefined' && (/Firefox/.test(userAgent) && /Mobile/.test(userAgent) || // Android Firefox
    /FxiOS/.test(userAgent) // iOS Firefox
    );
}
function isMac() {
    return testPlatform(/^Mac/);
}
function isIPhone() {
    return testPlatform(/^iPhone/);
}
function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function isIPad() {
    return testPlatform(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
    return isIPhone() || isIPad();
}
function testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator.platform) : undefined;
}

// This code comes from https://github.com/adobe/react-spectrum/blob/main/packages/%40react-aria/overlays/src/usePreventScroll.ts
const KEYBOARD_BUFFER = 24;
const dist_useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;
function chain$1(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks){
            if (typeof callback === 'function') {
                callback(...args);
            }
        }
    };
}
// @ts-ignore
const visualViewport = typeof document !== 'undefined' && window.visualViewport;
function isScrollable(node) {
    let style = window.getComputedStyle(node);
    return /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
}
function getScrollParent(node) {
    if (isScrollable(node)) {
        node = node.parentElement;
    }
    while(node && !isScrollable(node)){
        node = node.parentElement;
    }
    return node || document.scrollingElement || document.documentElement;
}
// HTML input types that do not cause the software keyboard to appear.
const nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let preventScrollCount = 0;
let restore;
/**
 * Prevents scrolling on the document body on mount, and
 * restores it on unmount. Also ensures that content does not
 * shift due to the scrollbars disappearing.
 */ function usePreventScroll(options = {}) {
    let { isDisabled } = options;
    dist_useIsomorphicLayoutEffect(()=>{
        if (isDisabled) {
            return;
        }
        preventScrollCount++;
        if (preventScrollCount === 1) {
            if (isIOS()) {
                restore = preventScrollMobileSafari();
            }
        }
        return ()=>{
            preventScrollCount--;
            if (preventScrollCount === 0) {
                restore == null ? void 0 : restore();
            }
        };
    }, [
        isDisabled
    ]);
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Prevent default on `touchmove` events inside a scrollable element when the scroll position is at the
//    top or bottom. This avoids the whole page scrolling instead, but does prevent overscrolling.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function preventScrollMobileSafari() {
    let scrollable;
    let lastY = 0;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = getScrollParent(e.target);
        if (scrollable === document.documentElement && scrollable === document.body) {
            return;
        }
        lastY = e.changedTouches[0].pageY;
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead. Unfortunately, this disables bounce scrolling when at
        // the top but it's the best we can do.
        let y = e.changedTouches[0].pageY;
        let scrollTop = scrollable.scrollTop;
        let bottom = scrollable.scrollHeight - scrollable.clientHeight;
        if (bottom === 0) {
            return;
        }
        if (scrollTop <= 0 && y > lastY || scrollTop >= bottom && y < lastY) {
            e.preventDefault();
        }
        lastY = y;
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        // Apply this change if we're not already focused on the target element
        if (isInput(target) && target !== document.activeElement) {
            e.preventDefault();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = 'translateY(-2000px)';
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = '';
            });
        }
    };
    let onFocus = (e)=>{
        let target = e.target;
        if (isInput(target)) {
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = 'translateY(-2000px)';
            requestAnimationFrame(()=>{
                target.style.transform = '';
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if (visualViewport) {
                    if (visualViewport.height < window.innerHeight) {
                        // If the keyboard is already visible, do this after one additional frame
                        // to wait for the transform to be removed.
                        requestAnimationFrame(()=>{
                            scrollIntoView(target);
                        });
                    } else {
                        // Otherwise, wait for the visual viewport to resize before scrolling so we can
                        // measure the correct position to scroll to.
                        visualViewport.addEventListener('resize', ()=>scrollIntoView(target), {
                            once: true
                        });
                    }
                }
            });
        }
    };
    let onWindowScroll = ()=>{
        // Last resort. If the window scrolled, scroll it back to the top.
        // It should always be at the top because the body will have a negative margin (see below).
        window.scrollTo(0, 0);
    };
    // Record the original scroll position so we can restore it.
    // Then apply a negative margin to the body to offset it by the scroll position. This will
    // enable us to scroll the window to the top, which is required for the rest of this to work.
    let scrollX = window.pageXOffset;
    let scrollY = window.pageYOffset;
    let restoreStyles = chain$1(setStyle(document.documentElement, 'paddingRight', `${window.innerWidth - document.documentElement.clientWidth}px`));
    // Scroll to the top. The negative margin on the body will make this appear the same.
    window.scrollTo(0, 0);
    let removeEvents = chain$1(addEvent(document, 'touchstart', onTouchStart, {
        passive: false,
        capture: true
    }), addEvent(document, 'touchmove', onTouchMove, {
        passive: false,
        capture: true
    }), addEvent(document, 'touchend', onTouchEnd, {
        passive: false,
        capture: true
    }), addEvent(document, 'focus', onFocus, true), addEvent(window, 'scroll', onWindowScroll));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreStyles();
        removeEvents();
        window.scrollTo(scrollX, scrollY);
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function setStyle(element, style, value) {
    // https://github.com/microsoft/TypeScript/issues/17827#issuecomment-391663310
    // @ts-ignore
    let cur = element.style[style];
    // @ts-ignore
    element.style[style] = value;
    return ()=>{
        // @ts-ignore
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function addEvent(target, event, handler, options) {
    // @ts-ignore
    target.addEventListener(event, handler, options);
    return ()=>{
        // @ts-ignore
        target.removeEventListener(event, handler, options);
    };
}
function scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    while(target && target !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = getScrollParent(target);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
            let scrollableTop = scrollable.getBoundingClientRect().top;
            let targetTop = target.getBoundingClientRect().top;
            let targetBottom = target.getBoundingClientRect().bottom;
            // Buffer is needed for some edge cases
            const keyboardHeight = scrollable.getBoundingClientRect().bottom + KEYBOARD_BUFFER;
            if (targetBottom > keyboardHeight) {
                scrollable.scrollTop += targetTop - scrollableTop;
            }
        }
        // @ts-ignore
        target = scrollable.parentElement;
    }
}
function isInput(target) {
    return target instanceof HTMLInputElement && !nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}

// This code comes from https://github.com/radix-ui/primitives/tree/main/packages/react/compose-refs
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function dist_setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    } else if (ref !== null && ref !== undefined) {
        ref.current = value;
    }
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function dist_composeRefs(...refs) {
    return (node)=>refs.forEach((ref)=>dist_setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function dist_useComposedRefs(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return react.useCallback(dist_composeRefs(...refs), refs);
}

const cache = new WeakMap();
function set(el, styles, ignoreCache = false) {
    if (!el || !(el instanceof HTMLElement)) return;
    let originalStyles = {};
    Object.entries(styles).forEach(([key, value])=>{
        if (key.startsWith('--')) {
            el.style.setProperty(key, value);
            return;
        }
        originalStyles[key] = el.style[key];
        el.style[key] = value;
    });
    if (ignoreCache) return;
    cache.set(el, originalStyles);
}
function dist_reset(el, prop) {
    if (!el || !(el instanceof HTMLElement)) return;
    let originalStyles = cache.get(el);
    if (!originalStyles) {
        return;
    }
    {
        el.style[prop] = originalStyles[prop];
    }
}
const isVertical = (direction)=>{
    switch(direction){
        case 'top':
        case 'bottom':
            return true;
        case 'left':
        case 'right':
            return false;
        default:
            return direction;
    }
};
function getTranslate(element, direction) {
    if (!element) {
        return null;
    }
    const style = window.getComputedStyle(element);
    const transform = // @ts-ignore
    style.transform || style.webkitTransform || style.mozTransform;
    let mat = transform.match(/^matrix3d\((.+)\)$/);
    if (mat) {
        // https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix3d
        return parseFloat(mat[1].split(', ')[isVertical(direction) ? 13 : 12]);
    }
    // https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
    mat = transform.match(/^matrix\((.+)\)$/);
    return mat ? parseFloat(mat[1].split(', ')[isVertical(direction) ? 5 : 4]) : null;
}
function dampenValue(v) {
    return 8 * (Math.log(v + 1) - 2);
}
function assignStyle(element, style) {
    if (!element) return ()=>{};
    const prevStyle = element.style.cssText;
    Object.assign(element.style, style);
    return ()=>{
        element.style.cssText = prevStyle;
    };
}
/**
 * Receives functions as arguments and returns a new function that calls all.
 */ function chain(...fns) {
    return (...args)=>{
        for (const fn of fns){
            if (typeof fn === 'function') {
                // @ts-ignore
                fn(...args);
            }
        }
    };
}

const TRANSITIONS = {
    DURATION: 0.5,
    EASE: [
        0.32,
        0.72,
        0,
        1
    ]
};
const VELOCITY_THRESHOLD = 0.4;
const CLOSE_THRESHOLD = 0.25;
const SCROLL_LOCK_TIMEOUT = 100;
const BORDER_RADIUS = 8;
const NESTED_DISPLACEMENT = 16;
const WINDOW_TOP_OFFSET = 26;
const DRAG_CLASS = 'vaul-dragging';

// This code comes from https://github.com/radix-ui/primitives/blob/main/packages/react/use-controllable-state/src/useControllableState.tsx
function dist_useCallbackRef(callback) {
    const callbackRef = react.useRef(callback);
    react.useEffect(()=>{
        callbackRef.current = callback;
    });
    // https://github.com/facebook/react/issues/19240
    return react.useMemo(()=>(...args)=>callbackRef.current == null ? void 0 : callbackRef.current.call(callbackRef, ...args), []);
}
function dist_useUncontrolledState({ defaultProp, onChange }) {
    const uncontrolledState = react.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = react.useRef(value);
    const handleChange = dist_useCallbackRef(onChange);
    react.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}
function dist_useControllableState({ prop, defaultProp, onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = dist_useUncontrolledState({
        defaultProp,
        onChange
    });
    const isControlled = prop !== undefined;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = dist_useCallbackRef(onChange);
    const setValue = react.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else {
            setUncontrolledProp(nextValue);
        }
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}

function useSnapPoints({ activeSnapPointProp, setActiveSnapPointProp, snapPoints, drawerRef, overlayRef, fadeFromIndex, onSnapPointChange, direction = 'bottom', container, snapToSequentialPoint }) {
    const [activeSnapPoint, setActiveSnapPoint] = dist_useControllableState({
        prop: activeSnapPointProp,
        defaultProp: snapPoints == null ? void 0 : snapPoints[0],
        onChange: setActiveSnapPointProp
    });
    const [windowDimensions, setWindowDimensions] = react.useState(typeof window !== 'undefined' ? {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
    } : undefined);
    react.useEffect(()=>{
        function onResize() {
            setWindowDimensions({
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight
            });
        }
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, []);
    const isLastSnapPoint = react.useMemo(()=>activeSnapPoint === (snapPoints == null ? void 0 : snapPoints[snapPoints.length - 1]) || null, [
        snapPoints,
        activeSnapPoint
    ]);
    const activeSnapPointIndex = react.useMemo(()=>{
        var _snapPoints_findIndex;
        return (_snapPoints_findIndex = snapPoints == null ? void 0 : snapPoints.findIndex((snapPoint)=>snapPoint === activeSnapPoint)) != null ? _snapPoints_findIndex : null;
    }, [
        snapPoints,
        activeSnapPoint
    ]);
    const shouldFade = snapPoints && snapPoints.length > 0 && (fadeFromIndex || fadeFromIndex === 0) && !Number.isNaN(fadeFromIndex) && snapPoints[fadeFromIndex] === activeSnapPoint || !snapPoints;
    const snapPointsOffset = react.useMemo(()=>{
        const containerSize = container ? {
            width: container.getBoundingClientRect().width,
            height: container.getBoundingClientRect().height
        } : typeof window !== 'undefined' ? {
            width: window.innerWidth,
            height: window.innerHeight
        } : {
            width: 0,
            height: 0
        };
        var _snapPoints_map;
        return (_snapPoints_map = snapPoints == null ? void 0 : snapPoints.map((snapPoint)=>{
            const isPx = typeof snapPoint === 'string';
            let snapPointAsNumber = 0;
            if (isPx) {
                snapPointAsNumber = parseInt(snapPoint, 10);
            }
            if (isVertical(direction)) {
                const height = isPx ? snapPointAsNumber : windowDimensions ? snapPoint * containerSize.height : 0;
                if (windowDimensions) {
                    return direction === 'bottom' ? containerSize.height - height : -containerSize.height + height;
                }
                return height;
            }
            const width = isPx ? snapPointAsNumber : windowDimensions ? snapPoint * containerSize.width : 0;
            if (windowDimensions) {
                return direction === 'right' ? containerSize.width - width : -containerSize.width + width;
            }
            return width;
        })) != null ? _snapPoints_map : [];
    }, [
        snapPoints,
        windowDimensions,
        container
    ]);
    const activeSnapPointOffset = react.useMemo(()=>activeSnapPointIndex !== null ? snapPointsOffset == null ? void 0 : snapPointsOffset[activeSnapPointIndex] : null, [
        snapPointsOffset,
        activeSnapPointIndex
    ]);
    const snapToPoint = react.useCallback((dimension)=>{
        var _snapPointsOffset_findIndex;
        const newSnapPointIndex = (_snapPointsOffset_findIndex = snapPointsOffset == null ? void 0 : snapPointsOffset.findIndex((snapPointDim)=>snapPointDim === dimension)) != null ? _snapPointsOffset_findIndex : null;
        onSnapPointChange(newSnapPointIndex);
        set(drawerRef.current, {
            transition: `transform ${TRANSITIONS.DURATION}s cubic-bezier(${TRANSITIONS.EASE.join(',')})`,
            transform: isVertical(direction) ? `translate3d(0, ${dimension}px, 0)` : `translate3d(${dimension}px, 0, 0)`
        });
        if (snapPointsOffset && newSnapPointIndex !== snapPointsOffset.length - 1 && fadeFromIndex !== undefined && newSnapPointIndex !== fadeFromIndex && newSnapPointIndex < fadeFromIndex) {
            set(overlayRef.current, {
                transition: `opacity ${TRANSITIONS.DURATION}s cubic-bezier(${TRANSITIONS.EASE.join(',')})`,
                opacity: '0'
            });
        } else {
            set(overlayRef.current, {
                transition: `opacity ${TRANSITIONS.DURATION}s cubic-bezier(${TRANSITIONS.EASE.join(',')})`,
                opacity: '1'
            });
        }
        setActiveSnapPoint(snapPoints == null ? void 0 : snapPoints[Math.max(newSnapPointIndex, 0)]);
    }, [
        drawerRef.current,
        snapPoints,
        snapPointsOffset,
        fadeFromIndex,
        overlayRef,
        setActiveSnapPoint
    ]);
    react.useEffect(()=>{
        if (activeSnapPoint || activeSnapPointProp) {
            var _snapPoints_findIndex;
            const newIndex = (_snapPoints_findIndex = snapPoints == null ? void 0 : snapPoints.findIndex((snapPoint)=>snapPoint === activeSnapPointProp || snapPoint === activeSnapPoint)) != null ? _snapPoints_findIndex : -1;
            if (snapPointsOffset && newIndex !== -1 && typeof snapPointsOffset[newIndex] === 'number') {
                snapToPoint(snapPointsOffset[newIndex]);
            }
        }
    }, [
        activeSnapPoint,
        activeSnapPointProp,
        snapPoints,
        snapPointsOffset,
        snapToPoint
    ]);
    function onRelease({ draggedDistance, closeDrawer, velocity, dismissible }) {
        if (fadeFromIndex === undefined) return;
        const currentPosition = direction === 'bottom' || direction === 'right' ? (activeSnapPointOffset != null ? activeSnapPointOffset : 0) - draggedDistance : (activeSnapPointOffset != null ? activeSnapPointOffset : 0) + draggedDistance;
        const isOverlaySnapPoint = activeSnapPointIndex === fadeFromIndex - 1;
        const isFirst = activeSnapPointIndex === 0;
        const hasDraggedUp = draggedDistance > 0;
        if (isOverlaySnapPoint) {
            set(overlayRef.current, {
                transition: `opacity ${TRANSITIONS.DURATION}s cubic-bezier(${TRANSITIONS.EASE.join(',')})`
            });
        }
        if (!snapToSequentialPoint && velocity > 2 && !hasDraggedUp) {
            if (dismissible) closeDrawer();
            else snapToPoint(snapPointsOffset[0]); // snap to initial point
            return;
        }
        if (!snapToSequentialPoint && velocity > 2 && hasDraggedUp && snapPointsOffset && snapPoints) {
            snapToPoint(snapPointsOffset[snapPoints.length - 1]);
            return;
        }
        // Find the closest snap point to the current position
        const closestSnapPoint = snapPointsOffset == null ? void 0 : snapPointsOffset.reduce((prev, curr)=>{
            if (typeof prev !== 'number' || typeof curr !== 'number') return prev;
            return Math.abs(curr - currentPosition) < Math.abs(prev - currentPosition) ? curr : prev;
        });
        const dim = isVertical(direction) ? window.innerHeight : window.innerWidth;
        if (velocity > VELOCITY_THRESHOLD && Math.abs(draggedDistance) < dim * 0.4) {
            const dragDirection = hasDraggedUp ? 1 : -1; // 1 = up, -1 = down
            // Don't do anything if we swipe upwards while being on the last snap point
            if (dragDirection > 0 && isLastSnapPoint && snapPoints) {
                snapToPoint(snapPointsOffset[snapPoints.length - 1]);
                return;
            }
            if (isFirst && dragDirection < 0 && dismissible) {
                closeDrawer();
            }
            if (activeSnapPointIndex === null) return;
            snapToPoint(snapPointsOffset[activeSnapPointIndex + dragDirection]);
            return;
        }
        snapToPoint(closestSnapPoint);
    }
    function onDrag({ draggedDistance }) {
        if (activeSnapPointOffset === null) return;
        const newValue = direction === 'bottom' || direction === 'right' ? activeSnapPointOffset - draggedDistance : activeSnapPointOffset + draggedDistance;
        // Don't do anything if we exceed the last(biggest) snap point
        if ((direction === 'bottom' || direction === 'right') && newValue < snapPointsOffset[snapPointsOffset.length - 1]) {
            return;
        }
        if ((direction === 'top' || direction === 'left') && newValue > snapPointsOffset[snapPointsOffset.length - 1]) {
            return;
        }
        set(drawerRef.current, {
            transform: isVertical(direction) ? `translate3d(0, ${newValue}px, 0)` : `translate3d(${newValue}px, 0, 0)`
        });
    }
    function getPercentageDragged(absDraggedDistance, isDraggingDown) {
        if (!snapPoints || typeof activeSnapPointIndex !== 'number' || !snapPointsOffset || fadeFromIndex === undefined) return null;
        // If this is true we are dragging to a snap point that is supposed to have an overlay
        const isOverlaySnapPoint = activeSnapPointIndex === fadeFromIndex - 1;
        const isOverlaySnapPointOrHigher = activeSnapPointIndex >= fadeFromIndex;
        if (isOverlaySnapPointOrHigher && isDraggingDown) {
            return 0;
        }
        // Don't animate, but still use this one if we are dragging away from the overlaySnapPoint
        if (isOverlaySnapPoint && !isDraggingDown) return 1;
        if (!shouldFade && !isOverlaySnapPoint) return null;
        // Either fadeFrom index or the one before
        const targetSnapPointIndex = isOverlaySnapPoint ? activeSnapPointIndex + 1 : activeSnapPointIndex - 1;
        // Get the distance from overlaySnapPoint to the one before or vice-versa to calculate the opacity percentage accordingly
        const snapPointDistance = isOverlaySnapPoint ? snapPointsOffset[targetSnapPointIndex] - snapPointsOffset[targetSnapPointIndex - 1] : snapPointsOffset[targetSnapPointIndex + 1] - snapPointsOffset[targetSnapPointIndex];
        const percentageDragged = absDraggedDistance / Math.abs(snapPointDistance);
        if (isOverlaySnapPoint) {
            return 1 - percentageDragged;
        } else {
            return percentageDragged;
        }
    }
    return {
        isLastSnapPoint,
        activeSnapPoint,
        shouldFade,
        getPercentageDragged,
        setActiveSnapPoint,
        activeSnapPointIndex,
        onRelease,
        onDrag,
        snapPointsOffset
    };
}

const noop = ()=>()=>{};
function useScaleBackground() {
    const { direction, isOpen, shouldScaleBackground, setBackgroundColorOnScale, noBodyStyles } = useDrawerContext();
    const timeoutIdRef = react.useRef(null);
    const initialBackgroundColor = (0,react.useMemo)(()=>document.body.style.backgroundColor, []);
    function getScale() {
        return (window.innerWidth - WINDOW_TOP_OFFSET) / window.innerWidth;
    }
    react.useEffect(()=>{
        if (isOpen && shouldScaleBackground) {
            if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
            const wrapper = document.querySelector('[data-vaul-drawer-wrapper]') || document.querySelector('[vaul-drawer-wrapper]');
            if (!wrapper) return;
            chain(setBackgroundColorOnScale && !noBodyStyles ? assignStyle(document.body, {
                background: 'black'
            }) : noop, assignStyle(wrapper, {
                transformOrigin: isVertical(direction) ? 'top' : 'left',
                transitionProperty: 'transform, border-radius',
                transitionDuration: `${TRANSITIONS.DURATION}s`,
                transitionTimingFunction: `cubic-bezier(${TRANSITIONS.EASE.join(',')})`
            }));
            const wrapperStylesCleanup = assignStyle(wrapper, {
                borderRadius: `${BORDER_RADIUS}px`,
                overflow: 'hidden',
                ...isVertical(direction) ? {
                    transform: `scale(${getScale()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
                } : {
                    transform: `scale(${getScale()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
                }
            });
            return ()=>{
                wrapperStylesCleanup();
                timeoutIdRef.current = window.setTimeout(()=>{
                    if (initialBackgroundColor) {
                        document.body.style.background = initialBackgroundColor;
                    } else {
                        document.body.style.removeProperty('background');
                    }
                }, TRANSITIONS.DURATION * 1000);
            };
        }
    }, [
        isOpen,
        shouldScaleBackground,
        initialBackgroundColor
    ]);
}

let previousBodyPosition = null;
/**
 * This hook is necessary to prevent buggy behavior on iOS devices (need to test on Android).
 * I won't get into too much detail about what bugs it solves, but so far I've found that setting the body to `position: fixed` is the most reliable way to prevent those bugs.
 * Issues that this hook solves:
 * https://github.com/emilkowalski/vaul/issues/435
 * https://github.com/emilkowalski/vaul/issues/433
 * And more that I discovered, but were just not reported.
 */ function usePositionFixed({ isOpen, modal, nested, hasBeenOpened, preventScrollRestoration, noBodyStyles }) {
    const [activeUrl, setActiveUrl] = react.useState(()=>typeof window !== 'undefined' ? window.location.href : '');
    const scrollPos = react.useRef(0);
    const setPositionFixed = react.useCallback(()=>{
        // All browsers on iOS will return true here.
        if (!isSafari()) return;
        // If previousBodyPosition is already set, don't set it again.
        if (previousBodyPosition === null && isOpen && !noBodyStyles) {
            previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left,
                height: document.body.style.height,
                right: 'unset'
            };
            // Update the dom inside an animation frame
            const { scrollX, innerHeight } = window;
            document.body.style.setProperty('position', 'fixed', 'important');
            Object.assign(document.body.style, {
                top: `${-scrollPos.current}px`,
                left: `${-scrollX}px`,
                right: '0px',
                height: 'auto'
            });
            window.setTimeout(()=>window.requestAnimationFrame(()=>{
                    // Attempt to check if the bottom bar appeared due to the position change
                    const bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollPos.current >= innerHeight) {
                        // Move the content further up so that the bottom bar doesn't hide it
                        document.body.style.top = `${-(scrollPos.current + bottomBarHeight)}px`;
                    }
                }), 300);
        }
    }, [
        isOpen
    ]);
    const restorePositionSetting = react.useCallback(()=>{
        // All browsers on iOS will return true here.
        if (!isSafari()) return;
        if (previousBodyPosition !== null && !noBodyStyles) {
            // Convert the position from "px" to Int
            const y = -parseInt(document.body.style.top, 10);
            const x = -parseInt(document.body.style.left, 10);
            // Restore styles
            Object.assign(document.body.style, previousBodyPosition);
            window.requestAnimationFrame(()=>{
                if (preventScrollRestoration && activeUrl !== window.location.href) {
                    setActiveUrl(window.location.href);
                    return;
                }
                window.scrollTo(x, y);
            });
            previousBodyPosition = null;
        }
    }, [
        activeUrl
    ]);
    react.useEffect(()=>{
        function onScroll() {
            scrollPos.current = window.scrollY;
        }
        onScroll();
        window.addEventListener('scroll', onScroll);
        return ()=>{
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
    react.useEffect(()=>{
        if (!modal) return;
        return ()=>{
            if (typeof document === 'undefined') return;
            // Another drawer is opened, safe to ignore the execution
            const hasDrawerOpened = !!document.querySelector('[data-vaul-drawer]');
            if (hasDrawerOpened) return;
            restorePositionSetting();
        };
    }, [
        modal,
        restorePositionSetting
    ]);
    react.useEffect(()=>{
        if (nested || !hasBeenOpened) return;
        // This is needed to force Safari toolbar to show **before** the drawer starts animating to prevent a gnarly shift from happening
        if (isOpen) {
            // avoid for standalone mode (PWA)
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
            !isStandalone && setPositionFixed();
            if (!modal) {
                window.setTimeout(()=>{
                    restorePositionSetting();
                }, 500);
            }
        } else {
            restorePositionSetting();
        }
    }, [
        isOpen,
        hasBeenOpened,
        activeUrl,
        modal,
        nested,
        setPositionFixed,
        restorePositionSetting
    ]);
    return {
        restorePositionSetting
    };
}

function vaul_dist_Root({ open: openProp, onOpenChange, children, onDrag: onDragProp, onRelease: onReleaseProp, snapPoints, shouldScaleBackground = false, setBackgroundColorOnScale = true, closeThreshold = CLOSE_THRESHOLD, scrollLockTimeout = SCROLL_LOCK_TIMEOUT, dismissible = true, handleOnly = false, fadeFromIndex = snapPoints && snapPoints.length - 1, activeSnapPoint: activeSnapPointProp, setActiveSnapPoint: setActiveSnapPointProp, fixed, modal = true, onClose, nested, noBodyStyles = false, direction = 'bottom', defaultOpen = false, disablePreventScroll = true, snapToSequentialPoint = false, preventScrollRestoration = false, repositionInputs = true, onAnimationEnd, container, autoFocus = false }) {
    var _drawerRef_current, _drawerRef_current1;
    const [isOpen = false, setIsOpen] = dist_useControllableState({
        defaultProp: defaultOpen,
        prop: openProp,
        onChange: (o)=>{
            onOpenChange == null ? void 0 : onOpenChange(o);
            if (!o && !nested) {
                restorePositionSetting();
            }
            setTimeout(()=>{
                onAnimationEnd == null ? void 0 : onAnimationEnd(o);
            }, TRANSITIONS.DURATION * 1000);
            if (o && !modal) {
                if (typeof window !== 'undefined') {
                    window.requestAnimationFrame(()=>{
                        document.body.style.pointerEvents = 'auto';
                    });
                }
            }
            if (!o) {
                // This will be removed when the exit animation ends (`500ms`)
                document.body.style.pointerEvents = 'auto';
            }
        }
    });
    const [hasBeenOpened, setHasBeenOpened] = react.useState(false);
    const [isDragging, setIsDragging] = react.useState(false);
    const [justReleased, setJustReleased] = react.useState(false);
    const overlayRef = react.useRef(null);
    const openTime = react.useRef(null);
    const dragStartTime = react.useRef(null);
    const dragEndTime = react.useRef(null);
    const lastTimeDragPrevented = react.useRef(null);
    const isAllowedToDrag = react.useRef(false);
    const nestedOpenChangeTimer = react.useRef(null);
    const pointerStart = react.useRef(0);
    const keyboardIsOpen = react.useRef(false);
    const shouldAnimate = react.useRef(!defaultOpen);
    const previousDiffFromInitial = react.useRef(0);
    const drawerRef = react.useRef(null);
    const drawerHeightRef = react.useRef(((_drawerRef_current = drawerRef.current) == null ? void 0 : _drawerRef_current.getBoundingClientRect().height) || 0);
    const drawerWidthRef = react.useRef(((_drawerRef_current1 = drawerRef.current) == null ? void 0 : _drawerRef_current1.getBoundingClientRect().width) || 0);
    const initialDrawerHeight = react.useRef(0);
    const onSnapPointChange = react.useCallback((activeSnapPointIndex)=>{
        // Change openTime ref when we reach the last snap point to prevent dragging for 500ms incase it's scrollable.
        if (snapPoints && activeSnapPointIndex === snapPointsOffset.length - 1) openTime.current = new Date();
    }, []);
    const { activeSnapPoint, activeSnapPointIndex, setActiveSnapPoint, onRelease: onReleaseSnapPoints, snapPointsOffset, onDrag: onDragSnapPoints, shouldFade, getPercentageDragged: getSnapPointsPercentageDragged } = useSnapPoints({
        snapPoints,
        activeSnapPointProp,
        setActiveSnapPointProp,
        drawerRef,
        fadeFromIndex,
        overlayRef,
        onSnapPointChange,
        direction,
        container,
        snapToSequentialPoint
    });
    usePreventScroll({
        isDisabled: !isOpen || isDragging || !modal || justReleased || !hasBeenOpened || !repositionInputs || !disablePreventScroll
    });
    const { restorePositionSetting } = usePositionFixed({
        isOpen,
        modal,
        nested: nested != null ? nested : false,
        hasBeenOpened,
        preventScrollRestoration,
        noBodyStyles
    });
    function getScale() {
        return (window.innerWidth - WINDOW_TOP_OFFSET) / window.innerWidth;
    }
    function onPress(event) {
        var _drawerRef_current, _drawerRef_current1;
        if (!dismissible && !snapPoints) return;
        if (drawerRef.current && !drawerRef.current.contains(event.target)) return;
        drawerHeightRef.current = ((_drawerRef_current = drawerRef.current) == null ? void 0 : _drawerRef_current.getBoundingClientRect().height) || 0;
        drawerWidthRef.current = ((_drawerRef_current1 = drawerRef.current) == null ? void 0 : _drawerRef_current1.getBoundingClientRect().width) || 0;
        setIsDragging(true);
        dragStartTime.current = new Date();
        // iOS doesn't trigger mouseUp after scrolling so we need to listen to touched in order to disallow dragging
        if (isIOS()) {
            window.addEventListener('touchend', ()=>isAllowedToDrag.current = false, {
                once: true
            });
        }
        // Ensure we maintain correct pointer capture even when going outside of the drawer
        event.target.setPointerCapture(event.pointerId);
        pointerStart.current = isVertical(direction) ? event.pageY : event.pageX;
    }
    function shouldDrag(el, isDraggingInDirection) {
        var _window_getSelection;
        let element = el;
        const highlightedText = (_window_getSelection = window.getSelection()) == null ? void 0 : _window_getSelection.toString();
        const swipeAmount = drawerRef.current ? getTranslate(drawerRef.current, direction) : null;
        const date = new Date();
        // Fixes https://github.com/emilkowalski/vaul/issues/483
        if (element.tagName === 'SELECT') {
            return false;
        }
        if (element.hasAttribute('data-vaul-no-drag') || element.closest('[data-vaul-no-drag]')) {
            return false;
        }
        if (direction === 'right' || direction === 'left') {
            return true;
        }
        // Allow scrolling when animating
        if (openTime.current && date.getTime() - openTime.current.getTime() < 500) {
            return false;
        }
        if (swipeAmount !== null) {
            if (direction === 'bottom' ? swipeAmount > 0 : swipeAmount < 0) {
                return true;
            }
        }
        // Don't drag if there's highlighted text
        if (highlightedText && highlightedText.length > 0) {
            return false;
        }
        // Disallow dragging if drawer was scrolled within `scrollLockTimeout`
        if (lastTimeDragPrevented.current && date.getTime() - lastTimeDragPrevented.current.getTime() < scrollLockTimeout && swipeAmount === 0) {
            lastTimeDragPrevented.current = date;
            return false;
        }
        if (isDraggingInDirection) {
            lastTimeDragPrevented.current = date;
            // We are dragging down so we should allow scrolling
            return false;
        }
        // Keep climbing up the DOM tree as long as there's a parent
        while(element){
            // Check if the element is scrollable
            if (element.scrollHeight > element.clientHeight) {
                if (element.scrollTop !== 0) {
                    lastTimeDragPrevented.current = new Date();
                    // The element is scrollable and not scrolled to the top, so don't drag
                    return false;
                }
                if (element.getAttribute('role') === 'dialog') {
                    return true;
                }
            }
            // Move up to the parent element
            element = element.parentNode;
        }
        // No scrollable parents not scrolled to the top found, so drag
        return true;
    }
    function onDrag(event) {
        if (!drawerRef.current) {
            return;
        }
        // We need to know how much of the drawer has been dragged in percentages so that we can transform background accordingly
        if (isDragging) {
            const directionMultiplier = direction === 'bottom' || direction === 'right' ? 1 : -1;
            const draggedDistance = (pointerStart.current - (isVertical(direction) ? event.pageY : event.pageX)) * directionMultiplier;
            const isDraggingInDirection = draggedDistance > 0;
            // Pre condition for disallowing dragging in the close direction.
            const noCloseSnapPointsPreCondition = snapPoints && !dismissible && !isDraggingInDirection;
            // Disallow dragging down to close when first snap point is the active one and dismissible prop is set to false.
            if (noCloseSnapPointsPreCondition && activeSnapPointIndex === 0) return;
            // We need to capture last time when drag with scroll was triggered and have a timeout between
            const absDraggedDistance = Math.abs(draggedDistance);
            const wrapper = document.querySelector('[data-vaul-drawer-wrapper]');
            const drawerDimension = direction === 'bottom' || direction === 'top' ? drawerHeightRef.current : drawerWidthRef.current;
            // Calculate the percentage dragged, where 1 is the closed position
            let percentageDragged = absDraggedDistance / drawerDimension;
            const snapPointPercentageDragged = getSnapPointsPercentageDragged(absDraggedDistance, isDraggingInDirection);
            if (snapPointPercentageDragged !== null) {
                percentageDragged = snapPointPercentageDragged;
            }
            // Disallow close dragging beyond the smallest snap point.
            if (noCloseSnapPointsPreCondition && percentageDragged >= 1) {
                return;
            }
            if (!isAllowedToDrag.current && !shouldDrag(event.target, isDraggingInDirection)) return;
            drawerRef.current.classList.add(DRAG_CLASS);
            // If shouldDrag gave true once after pressing down on the drawer, we set isAllowedToDrag to true and it will remain true until we let go, there's no reason to disable dragging mid way, ever, and that's the solution to it
            isAllowedToDrag.current = true;
            set(drawerRef.current, {
                transition: 'none'
            });
            set(overlayRef.current, {
                transition: 'none'
            });
            if (snapPoints) {
                onDragSnapPoints({
                    draggedDistance
                });
            }
            // Run this only if snapPoints are not defined or if we are at the last snap point (highest one)
            if (isDraggingInDirection && !snapPoints) {
                const dampenedDraggedDistance = dampenValue(draggedDistance);
                const translateValue = Math.min(dampenedDraggedDistance * -1, 0) * directionMultiplier;
                set(drawerRef.current, {
                    transform: isVertical(direction) ? `translate3d(0, ${translateValue}px, 0)` : `translate3d(${translateValue}px, 0, 0)`
                });
                return;
            }
            const opacityValue = 1 - percentageDragged;
            if (shouldFade || fadeFromIndex && activeSnapPointIndex === fadeFromIndex - 1) {
                onDragProp == null ? void 0 : onDragProp(event, percentageDragged);
                set(overlayRef.current, {
                    opacity: `${opacityValue}`,
                    transition: 'none'
                }, true);
            }
            if (wrapper && overlayRef.current && shouldScaleBackground) {
                // Calculate percentageDragged as a fraction (0 to 1)
                const scaleValue = Math.min(getScale() + percentageDragged * (1 - getScale()), 1);
                const borderRadiusValue = 8 - percentageDragged * 8;
                const translateValue = Math.max(0, 14 - percentageDragged * 14);
                set(wrapper, {
                    borderRadius: `${borderRadiusValue}px`,
                    transform: isVertical(direction) ? `scale(${scaleValue}) translate3d(0, ${translateValue}px, 0)` : `scale(${scaleValue}) translate3d(${translateValue}px, 0, 0)`,
                    transition: 'none'
                }, true);
            }
            if (!snapPoints) {
                const translateValue = absDraggedDistance * directionMultiplier;
                set(drawerRef.current, {
                    transform: isVertical(direction) ? `translate3d(0, ${translateValue}px, 0)` : `translate3d(${translateValue}px, 0, 0)`
                });
            }
        }
    }
    react.useEffect(()=>{
        window.requestAnimationFrame(()=>{
            shouldAnimate.current = true;
        });
    }, []);
    react.useEffect(()=>{
        var _window_visualViewport;
        function onVisualViewportChange() {
            if (!drawerRef.current || !repositionInputs) return;
            const focusedElement = document.activeElement;
            if (isInput(focusedElement) || keyboardIsOpen.current) {
                var _window_visualViewport;
                const visualViewportHeight = ((_window_visualViewport = window.visualViewport) == null ? void 0 : _window_visualViewport.height) || 0;
                const totalHeight = window.innerHeight;
                // This is the height of the keyboard
                let diffFromInitial = totalHeight - visualViewportHeight;
                const drawerHeight = drawerRef.current.getBoundingClientRect().height || 0;
                // Adjust drawer height only if it's tall enough
                const isTallEnough = drawerHeight > totalHeight * 0.8;
                if (!initialDrawerHeight.current) {
                    initialDrawerHeight.current = drawerHeight;
                }
                const offsetFromTop = drawerRef.current.getBoundingClientRect().top;
                // visualViewport height may change due to somq e subtle changes to the keyboard. Checking if the height changed by 60 or more will make sure that they keyboard really changed its open state.
                if (Math.abs(previousDiffFromInitial.current - diffFromInitial) > 60) {
                    keyboardIsOpen.current = !keyboardIsOpen.current;
                }
                if (snapPoints && snapPoints.length > 0 && snapPointsOffset && activeSnapPointIndex) {
                    const activeSnapPointHeight = snapPointsOffset[activeSnapPointIndex] || 0;
                    diffFromInitial += activeSnapPointHeight;
                }
                previousDiffFromInitial.current = diffFromInitial;
                // We don't have to change the height if the input is in view, when we are here we are in the opened keyboard state so we can correctly check if the input is in view
                if (drawerHeight > visualViewportHeight || keyboardIsOpen.current) {
                    const height = drawerRef.current.getBoundingClientRect().height;
                    let newDrawerHeight = height;
                    if (height > visualViewportHeight) {
                        newDrawerHeight = visualViewportHeight - (isTallEnough ? offsetFromTop : WINDOW_TOP_OFFSET);
                    }
                    // When fixed, don't move the drawer upwards if there's space, but rather only change it's height so it's fully scrollable when the keyboard is open
                    if (fixed) {
                        drawerRef.current.style.height = `${height - Math.max(diffFromInitial, 0)}px`;
                    } else {
                        drawerRef.current.style.height = `${Math.max(newDrawerHeight, visualViewportHeight - offsetFromTop)}px`;
                    }
                } else if (!isMobileFirefox()) {
                    drawerRef.current.style.height = `${initialDrawerHeight.current}px`;
                }
                if (snapPoints && snapPoints.length > 0 && !keyboardIsOpen.current) {
                    drawerRef.current.style.bottom = `0px`;
                } else {
                    // Negative bottom value would never make sense
                    drawerRef.current.style.bottom = `${Math.max(diffFromInitial, 0)}px`;
                }
            }
        }
        (_window_visualViewport = window.visualViewport) == null ? void 0 : _window_visualViewport.addEventListener('resize', onVisualViewportChange);
        return ()=>{
            var _window_visualViewport;
            return (_window_visualViewport = window.visualViewport) == null ? void 0 : _window_visualViewport.removeEventListener('resize', onVisualViewportChange);
        };
    }, [
        activeSnapPointIndex,
        snapPoints,
        snapPointsOffset
    ]);
    function closeDrawer(fromWithin) {
        cancelDrag();
        onClose == null ? void 0 : onClose();
        if (!fromWithin) {
            setIsOpen(false);
        }
        setTimeout(()=>{
            if (snapPoints) {
                setActiveSnapPoint(snapPoints[0]);
            }
        }, TRANSITIONS.DURATION * 1000); // seconds to ms
    }
    function resetDrawer() {
        if (!drawerRef.current) return;
        const wrapper = document.querySelector('[data-vaul-drawer-wrapper]');
        const currentSwipeAmount = getTranslate(drawerRef.current, direction);
        set(drawerRef.current, {
            transform: 'translate3d(0, 0, 0)',
            transition: `transform ${TRANSITIONS.DURATION}s cubic-bezier(${TRANSITIONS.EASE.join(',')})`
        });
        set(overlayRef.current, {
            transition: `opacity ${TRANSITIONS.DURATION}s cubic-bezier(${TRANSITIONS.EASE.join(',')})`,
            opacity: '1'
        });
        // Don't reset background if swiped upwards
        if (shouldScaleBackground && currentSwipeAmount && currentSwipeAmount > 0 && isOpen) {
            set(wrapper, {
                borderRadius: `${BORDER_RADIUS}px`,
                overflow: 'hidden',
                ...isVertical(direction) ? {
                    transform: `scale(${getScale()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
                    transformOrigin: 'top'
                } : {
                    transform: `scale(${getScale()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
                    transformOrigin: 'left'
                },
                transitionProperty: 'transform, border-radius',
                transitionDuration: `${TRANSITIONS.DURATION}s`,
                transitionTimingFunction: `cubic-bezier(${TRANSITIONS.EASE.join(',')})`
            }, true);
        }
    }
    function cancelDrag() {
        if (!isDragging || !drawerRef.current) return;
        drawerRef.current.classList.remove(DRAG_CLASS);
        isAllowedToDrag.current = false;
        setIsDragging(false);
        dragEndTime.current = new Date();
    }
    function onRelease(event) {
        if (!isDragging || !drawerRef.current) return;
        drawerRef.current.classList.remove(DRAG_CLASS);
        isAllowedToDrag.current = false;
        setIsDragging(false);
        dragEndTime.current = new Date();
        const swipeAmount = getTranslate(drawerRef.current, direction);
        if (!event || !shouldDrag(event.target, false) || !swipeAmount || Number.isNaN(swipeAmount)) return;
        if (dragStartTime.current === null) return;
        const timeTaken = dragEndTime.current.getTime() - dragStartTime.current.getTime();
        const distMoved = pointerStart.current - (isVertical(direction) ? event.pageY : event.pageX);
        const velocity = Math.abs(distMoved) / timeTaken;
        if (velocity > 0.05) {
            // `justReleased` is needed to prevent the drawer from focusing on an input when the drag ends, as it's not the intent most of the time.
            setJustReleased(true);
            setTimeout(()=>{
                setJustReleased(false);
            }, 200);
        }
        if (snapPoints) {
            const directionMultiplier = direction === 'bottom' || direction === 'right' ? 1 : -1;
            onReleaseSnapPoints({
                draggedDistance: distMoved * directionMultiplier,
                closeDrawer,
                velocity,
                dismissible
            });
            onReleaseProp == null ? void 0 : onReleaseProp(event, true);
            return;
        }
        // Moved upwards, don't do anything
        if (direction === 'bottom' || direction === 'right' ? distMoved > 0 : distMoved < 0) {
            resetDrawer();
            onReleaseProp == null ? void 0 : onReleaseProp(event, true);
            return;
        }
        if (velocity > VELOCITY_THRESHOLD) {
            closeDrawer();
            onReleaseProp == null ? void 0 : onReleaseProp(event, false);
            return;
        }
        var _drawerRef_current_getBoundingClientRect_height;
        const visibleDrawerHeight = Math.min((_drawerRef_current_getBoundingClientRect_height = drawerRef.current.getBoundingClientRect().height) != null ? _drawerRef_current_getBoundingClientRect_height : 0, window.innerHeight);
        var _drawerRef_current_getBoundingClientRect_width;
        const visibleDrawerWidth = Math.min((_drawerRef_current_getBoundingClientRect_width = drawerRef.current.getBoundingClientRect().width) != null ? _drawerRef_current_getBoundingClientRect_width : 0, window.innerWidth);
        const isHorizontalSwipe = direction === 'left' || direction === 'right';
        if (Math.abs(swipeAmount) >= (isHorizontalSwipe ? visibleDrawerWidth : visibleDrawerHeight) * closeThreshold) {
            closeDrawer();
            onReleaseProp == null ? void 0 : onReleaseProp(event, false);
            return;
        }
        onReleaseProp == null ? void 0 : onReleaseProp(event, true);
        resetDrawer();
    }
    react.useEffect(()=>{
        // Trigger enter animation without using CSS animation
        if (isOpen) {
            set(document.documentElement, {
                scrollBehavior: 'auto'
            });
            openTime.current = new Date();
        }
        return ()=>{
            dist_reset(document.documentElement, 'scrollBehavior');
        };
    }, [
        isOpen
    ]);
    function onNestedOpenChange(o) {
        const scale = o ? (window.innerWidth - NESTED_DISPLACEMENT) / window.innerWidth : 1;
        const initialTranslate = o ? -NESTED_DISPLACEMENT : 0;
        if (nestedOpenChangeTimer.current) {
            window.clearTimeout(nestedOpenChangeTimer.current);
        }
        set(drawerRef.current, {
            transition: `transform ${TRANSITIONS.DURATION}s cubic-bezier(${TRANSITIONS.EASE.join(',')})`,
            transform: isVertical(direction) ? `scale(${scale}) translate3d(0, ${initialTranslate}px, 0)` : `scale(${scale}) translate3d(${initialTranslate}px, 0, 0)`
        });
        if (!o && drawerRef.current) {
            nestedOpenChangeTimer.current = setTimeout(()=>{
                const translateValue = getTranslate(drawerRef.current, direction);
                set(drawerRef.current, {
                    transition: 'none',
                    transform: isVertical(direction) ? `translate3d(0, ${translateValue}px, 0)` : `translate3d(${translateValue}px, 0, 0)`
                });
            }, 500);
        }
    }
    function onNestedDrag(_event, percentageDragged) {
        if (percentageDragged < 0) return;
        const initialScale = (window.innerWidth - NESTED_DISPLACEMENT) / window.innerWidth;
        const newScale = initialScale + percentageDragged * (1 - initialScale);
        const newTranslate = -NESTED_DISPLACEMENT + percentageDragged * NESTED_DISPLACEMENT;
        set(drawerRef.current, {
            transform: isVertical(direction) ? `scale(${newScale}) translate3d(0, ${newTranslate}px, 0)` : `scale(${newScale}) translate3d(${newTranslate}px, 0, 0)`,
            transition: 'none'
        });
    }
    function onNestedRelease(_event, o) {
        const dim = isVertical(direction) ? window.innerHeight : window.innerWidth;
        const scale = o ? (dim - NESTED_DISPLACEMENT) / dim : 1;
        const translate = o ? -NESTED_DISPLACEMENT : 0;
        if (o) {
            set(drawerRef.current, {
                transition: `transform ${TRANSITIONS.DURATION}s cubic-bezier(${TRANSITIONS.EASE.join(',')})`,
                transform: isVertical(direction) ? `scale(${scale}) translate3d(0, ${translate}px, 0)` : `scale(${scale}) translate3d(${translate}px, 0, 0)`
            });
        }
    }
    react.useEffect(()=>{
        if (!modal) {
            // Need to do this manually unfortunately
            window.requestAnimationFrame(()=>{
                document.body.style.pointerEvents = 'auto';
            });
        }
    }, [
        modal
    ]);
    return /*#__PURE__*/ react.createElement(react_dialog_dist_Root, {
        defaultOpen: defaultOpen,
        onOpenChange: (open)=>{
            if (!dismissible && !open) return;
            if (open) {
                setHasBeenOpened(true);
            } else {
                closeDrawer(true);
            }
            setIsOpen(open);
        },
        open: isOpen
    }, /*#__PURE__*/ react.createElement(DrawerContext.Provider, {
        value: {
            activeSnapPoint,
            snapPoints,
            setActiveSnapPoint,
            drawerRef,
            overlayRef,
            onOpenChange,
            onPress,
            onRelease,
            onDrag,
            dismissible,
            shouldAnimate,
            handleOnly,
            isOpen,
            isDragging,
            shouldFade,
            closeDrawer,
            onNestedDrag,
            onNestedOpenChange,
            onNestedRelease,
            keyboardIsOpen,
            modal,
            snapPointsOffset,
            activeSnapPointIndex,
            direction,
            shouldScaleBackground,
            setBackgroundColorOnScale,
            noBodyStyles,
            container,
            autoFocus
        }
    }, children));
}
const dist_Overlay = /*#__PURE__*/ react.forwardRef(function({ ...rest }, ref) {
    const { overlayRef, snapPoints, onRelease, shouldFade, isOpen, modal, shouldAnimate } = useDrawerContext();
    const composedRef = dist_useComposedRefs(ref, overlayRef);
    const hasSnapPoints = snapPoints && snapPoints.length > 0;
    // Overlay is the component that is locking scroll, removing it will unlock the scroll without having to dig into Radix's Dialog library
    if (!modal) {
        return null;
    }
    const onMouseUp = react.useCallback((event)=>onRelease(event), [
        onRelease
    ]);
    return /*#__PURE__*/ react.createElement(Overlay, {
        onMouseUp: onMouseUp,
        ref: composedRef,
        "data-vaul-overlay": "",
        "data-vaul-snap-points": isOpen && hasSnapPoints ? 'true' : 'false',
        "data-vaul-snap-points-overlay": isOpen && shouldFade ? 'true' : 'false',
        "data-vaul-animate": (shouldAnimate == null ? void 0 : shouldAnimate.current) ? 'true' : 'false',
        ...rest
    });
});
dist_Overlay.displayName = 'Drawer.Overlay';
const dist_Content = /*#__PURE__*/ react.forwardRef(function({ onPointerDownOutside, style, onOpenAutoFocus, ...rest }, ref) {
    const { drawerRef, onPress, onRelease, onDrag, keyboardIsOpen, snapPointsOffset, activeSnapPointIndex, modal, isOpen, direction, snapPoints, container, handleOnly, shouldAnimate, autoFocus } = useDrawerContext();
    // Needed to use transition instead of animations
    const [delayedSnapPoints, setDelayedSnapPoints] = react.useState(false);
    const composedRef = dist_useComposedRefs(ref, drawerRef);
    const pointerStartRef = react.useRef(null);
    const lastKnownPointerEventRef = react.useRef(null);
    const wasBeyondThePointRef = react.useRef(false);
    const hasSnapPoints = snapPoints && snapPoints.length > 0;
    useScaleBackground();
    const isDeltaInDirection = (delta, direction, threshold = 0)=>{
        if (wasBeyondThePointRef.current) return true;
        const deltaY = Math.abs(delta.y);
        const deltaX = Math.abs(delta.x);
        const isDeltaX = deltaX > deltaY;
        const dFactor = [
            'bottom',
            'right'
        ].includes(direction) ? 1 : -1;
        if (direction === 'left' || direction === 'right') {
            const isReverseDirection = delta.x * dFactor < 0;
            if (!isReverseDirection && deltaX >= 0 && deltaX <= threshold) {
                return isDeltaX;
            }
        } else {
            const isReverseDirection = delta.y * dFactor < 0;
            if (!isReverseDirection && deltaY >= 0 && deltaY <= threshold) {
                return !isDeltaX;
            }
        }
        wasBeyondThePointRef.current = true;
        return true;
    };
    react.useEffect(()=>{
        if (hasSnapPoints) {
            window.requestAnimationFrame(()=>{
                setDelayedSnapPoints(true);
            });
        }
    }, []);
    function handleOnPointerUp(event) {
        pointerStartRef.current = null;
        wasBeyondThePointRef.current = false;
        onRelease(event);
    }
    return /*#__PURE__*/ react.createElement(Content, {
        "data-vaul-drawer-direction": direction,
        "data-vaul-drawer": "",
        "data-vaul-delayed-snap-points": delayedSnapPoints ? 'true' : 'false',
        "data-vaul-snap-points": isOpen && hasSnapPoints ? 'true' : 'false',
        "data-vaul-custom-container": container ? 'true' : 'false',
        "data-vaul-animate": (shouldAnimate == null ? void 0 : shouldAnimate.current) ? 'true' : 'false',
        ...rest,
        ref: composedRef,
        style: snapPointsOffset && snapPointsOffset.length > 0 ? {
            '--snap-point-height': `${snapPointsOffset[activeSnapPointIndex != null ? activeSnapPointIndex : 0]}px`,
            ...style
        } : style,
        onPointerDown: (event)=>{
            if (handleOnly) return;
            rest.onPointerDown == null ? void 0 : rest.onPointerDown.call(rest, event);
            pointerStartRef.current = {
                x: event.pageX,
                y: event.pageY
            };
            onPress(event);
        },
        onOpenAutoFocus: (e)=>{
            onOpenAutoFocus == null ? void 0 : onOpenAutoFocus(e);
            if (!autoFocus) {
                e.preventDefault();
            }
        },
        onPointerDownOutside: (e)=>{
            onPointerDownOutside == null ? void 0 : onPointerDownOutside(e);
            if (!modal || e.defaultPrevented) {
                e.preventDefault();
                return;
            }
            if (keyboardIsOpen.current) {
                keyboardIsOpen.current = false;
            }
        },
        onFocusOutside: (e)=>{
            if (!modal) {
                e.preventDefault();
                return;
            }
        },
        onPointerMove: (event)=>{
            lastKnownPointerEventRef.current = event;
            if (handleOnly) return;
            rest.onPointerMove == null ? void 0 : rest.onPointerMove.call(rest, event);
            if (!pointerStartRef.current) return;
            const yPosition = event.pageY - pointerStartRef.current.y;
            const xPosition = event.pageX - pointerStartRef.current.x;
            const swipeStartThreshold = event.pointerType === 'touch' ? 10 : 2;
            const delta = {
                x: xPosition,
                y: yPosition
            };
            const isAllowedToSwipe = isDeltaInDirection(delta, direction, swipeStartThreshold);
            if (isAllowedToSwipe) onDrag(event);
            else if (Math.abs(xPosition) > swipeStartThreshold || Math.abs(yPosition) > swipeStartThreshold) {
                pointerStartRef.current = null;
            }
        },
        onPointerUp: (event)=>{
            rest.onPointerUp == null ? void 0 : rest.onPointerUp.call(rest, event);
            pointerStartRef.current = null;
            wasBeyondThePointRef.current = false;
            onRelease(event);
        },
        onPointerOut: (event)=>{
            rest.onPointerOut == null ? void 0 : rest.onPointerOut.call(rest, event);
            handleOnPointerUp(lastKnownPointerEventRef.current);
        },
        onContextMenu: (event)=>{
            rest.onContextMenu == null ? void 0 : rest.onContextMenu.call(rest, event);
            if (lastKnownPointerEventRef.current) {
                handleOnPointerUp(lastKnownPointerEventRef.current);
            }
        }
    });
});
dist_Content.displayName = 'Drawer.Content';
const LONG_HANDLE_PRESS_TIMEOUT = 250;
const DOUBLE_TAP_TIMEOUT = 120;
const Handle = /*#__PURE__*/ react.forwardRef(function({ preventCycle = false, children, ...rest }, ref) {
    const { closeDrawer, isDragging, snapPoints, activeSnapPoint, setActiveSnapPoint, dismissible, handleOnly, isOpen, onPress, onDrag } = useDrawerContext();
    const closeTimeoutIdRef = react.useRef(null);
    const shouldCancelInteractionRef = react.useRef(false);
    function handleStartCycle() {
        // Stop if this is the second click of a double click
        if (shouldCancelInteractionRef.current) {
            handleCancelInteraction();
            return;
        }
        window.setTimeout(()=>{
            handleCycleSnapPoints();
        }, DOUBLE_TAP_TIMEOUT);
    }
    function handleCycleSnapPoints() {
        // Prevent accidental taps while resizing drawer
        if (isDragging || preventCycle || shouldCancelInteractionRef.current) {
            handleCancelInteraction();
            return;
        }
        // Make sure to clear the timeout id if the user releases the handle before the cancel timeout
        handleCancelInteraction();
        if (!snapPoints || snapPoints.length === 0) {
            if (!dismissible) {
                closeDrawer();
            }
            return;
        }
        const isLastSnapPoint = activeSnapPoint === snapPoints[snapPoints.length - 1];
        if (isLastSnapPoint && dismissible) {
            closeDrawer();
            return;
        }
        const currentSnapIndex = snapPoints.findIndex((point)=>point === activeSnapPoint);
        if (currentSnapIndex === -1) return; // activeSnapPoint not found in snapPoints
        const nextSnapPoint = snapPoints[currentSnapIndex + 1];
        setActiveSnapPoint(nextSnapPoint);
    }
    function handleStartInteraction() {
        closeTimeoutIdRef.current = window.setTimeout(()=>{
            // Cancel click interaction on a long press
            shouldCancelInteractionRef.current = true;
        }, LONG_HANDLE_PRESS_TIMEOUT);
    }
    function handleCancelInteraction() {
        if (closeTimeoutIdRef.current) {
            window.clearTimeout(closeTimeoutIdRef.current);
        }
        shouldCancelInteractionRef.current = false;
    }
    return /*#__PURE__*/ react.createElement("div", {
        onClick: handleStartCycle,
        onPointerCancel: handleCancelInteraction,
        onPointerDown: (e)=>{
            if (handleOnly) onPress(e);
            handleStartInteraction();
        },
        onPointerMove: (e)=>{
            if (handleOnly) onDrag(e);
        },
        // onPointerUp is already handled by the content component
        ref: ref,
        "data-vaul-drawer-visible": isOpen ? 'true' : 'false',
        "data-vaul-handle": "",
        "aria-hidden": "true",
        ...rest
    }, /*#__PURE__*/ react.createElement("span", {
        "data-vaul-handle-hitarea": "",
        "aria-hidden": "true"
    }, children));
});
Handle.displayName = 'Drawer.Handle';
function NestedRoot({ onDrag, onOpenChange, open: nestedIsOpen, ...rest }) {
    const { onNestedDrag, onNestedOpenChange, onNestedRelease } = useDrawerContext();
    if (!onNestedDrag) {
        throw new Error('Drawer.NestedRoot must be placed in another drawer');
    }
    return /*#__PURE__*/ react.createElement(vaul_dist_Root, {
        nested: true,
        open: nestedIsOpen,
        onClose: ()=>{
            onNestedOpenChange(false);
        },
        onDrag: (e, p)=>{
            onNestedDrag(e, p);
            onDrag == null ? void 0 : onDrag(e, p);
        },
        onOpenChange: (o)=>{
            if (o) {
                onNestedOpenChange(o);
            }
            onOpenChange == null ? void 0 : onOpenChange(o);
        },
        onRelease: onNestedRelease,
        ...rest
    });
}
function vaul_dist_Portal(props) {
    const context = useDrawerContext();
    const { container = context.container, ...portalProps } = props;
    return /*#__PURE__*/ react.createElement(dist_Portal, {
        container: container,
        ...portalProps
    });
}
const Drawer = {
    Root: vaul_dist_Root,
    NestedRoot,
    Content: dist_Content,
    Overlay: dist_Overlay,
    Trigger: Trigger,
    Portal: vaul_dist_Portal,
    Handle,
    Close: Close,
    Title: Title,
    Description: Description
};



// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Common/Modals/Drawer/Drawer.module.scss
var Drawer_module = __webpack_require__(57199);
var Drawer_module_default = /*#__PURE__*/__webpack_require__.n(Drawer_module);
;// CONCATENATED MODULE: ./src/components/Common/Modals/Drawer/Drawer.tsx








var Drawer_Drawer = function(_param) /*#__PURE__*/ {
    var _shouldScaleBackground = _param.shouldScaleBackground, shouldScaleBackground = _shouldScaleBackground === void 0 ? true : _shouldScaleBackground, props = _objectWithoutProperties(_param, [
        "shouldScaleBackground"
    ]);
    return (0,jsx_runtime.jsx)(Drawer.Root, (0,_object_spread/* default */.Z)({
        shouldScaleBackground: shouldScaleBackground
    }, props));
};
Drawer_Drawer.displayName = "Drawer";
var DrawerTrigger = Drawer.Trigger;
var DrawerPortal = Drawer.Portal;
var DrawerClose = Drawer.Close;
var DrawerOverlay = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = _objectWithoutProperties(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Drawer.Overlay, (0,_object_spread/* default */.Z)({
        ref: ref,
        className: classnames_default()((Drawer_module_default()).overlay, className)
    }, props));
});
DrawerOverlay.displayName = Drawer.Overlay.displayName;
var DrawerTitle = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = _objectWithoutProperties(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Drawer.Title, (0,_object_spread/* default */.Z)({
        ref: ref,
        className: classnames_default()((Drawer_module_default()).sronly, className)
    }, props));
});
DrawerTitle.displayName = "DrawerTitle";
var DrawerDescription = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = _objectWithoutProperties(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Drawer.Description, (0,_object_spread/* default */.Z)({
        ref: ref,
        className: classnames_default()((Drawer_module_default()).sronly, className)
    }, props));
});
DrawerDescription.displayName = "DrawerDescription";
var DrawerContent = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, props = _objectWithoutProperties(_param, [
        "className",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(DrawerPortal, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerOverlay, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer.Content, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: ref,
                className: classnames_default()((Drawer_module_default()).drawerContentWrapper, className)
            }, props), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerTitle, {
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (Drawer_module_default()).sronly,
                            children: "Wallet Modal"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerDescription, {
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (Drawer_module_default()).sronly,
                            children: "Use this modal to connect and manage your Cardano wallet."
                        })
                    }),
                    children
                ]
            }))
        ]
    });
});
DrawerContent.displayName = "DrawerContent";


// EXTERNAL MODULE: ./src/components/Common/Buttons/RedButton/RedButton.tsx
var RedButton = __webpack_require__(65980);
;// CONCATENATED MODULE: ./src/components/Common/Modals/ModalTemplate/ModalTemplate.tsx








// 🔹 Fix: Define the app root for accessibility
if (true) {
    lib_default().setAppElement("#__next"); // Ensure it only runs on the client
}
var ModalTemplate = function(param) {
    var active = param.active, children = param.children;
    var ref = (0,ModalContext/* useModal */.d)(), activeModal = ref.activeModal, closeModal = ref.closeModal;
    var screenSize = (0,ResponsiveContext/* useResponsive */.F)().screenSize;
    // if (activeModal === null || activeModal !== active) return null;
    if (screenSize === "mobile" || screenSize === "tablet") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer, {
            open: activeModal === active,
            onClose: function() {
                return closeModal();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ModalTemplate_module_default()).drawerContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RedButton/* default */.Z, {
                            style: (ModalTemplate_module_default()).closeButton,
                            onClick: function() {
                                return closeModal();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "x"
                            })
                        }),
                        children
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        isOpen: activeModal === active,
        onRequestClose: function() {
            return closeModal();
        },
        overlayClassName: (ModalTemplate_module_default()).overlay,
        className: (ModalTemplate_module_default()).modal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ModalTemplate_module_default()).modalContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RedButton/* default */.Z, {
                    style: (ModalTemplate_module_default()).closeButton,
                    onClick: function() {
                        return closeModal();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "x"
                    })
                }),
                children
            ]
        })
    });
};
/* harmony default export */ var ModalTemplate_ModalTemplate = (ModalTemplate);


/***/ }),

/***/ 96146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ModalTask_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55744);
/* harmony import */ var _ModalTask_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ModalTask_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _useModalTask__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14523);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75971);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_useModalTask__WEBPACK_IMPORTED_MODULE_2__, smart_db__WEBPACK_IMPORTED_MODULE_3__]);
([_useModalTask__WEBPACK_IMPORTED_MODULE_2__, smart_db__WEBPACK_IMPORTED_MODULE_3__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);





// ModalTransaction component definition
var ModalTask = function() {
    // Import custom hooks for clipboard copy state and handler function
    var ref = (0,_useModalTask__WEBPACK_IMPORTED_MODULE_2__/* .useModalTask */ .o)(), isModalOpen = ref.isModalOpen, txHash = ref.txHash, isTxError = ref.isTxError, txMessage = ref.txMessage, txConfirmed = ref.txConfirmed, copied = ref.copied, handleCopyToClipboard = ref.handleCopyToClipboard;
    return(// Render the modal with various transaction details
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
        className: (_ModalTask_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_ModalTask_module_scss__WEBPACK_IMPORTED_MODULE_4___default().layout),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: (_ModalTask_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                    children: "Operation Status"
                }),
                !(0,smart_db__WEBPACK_IMPORTED_MODULE_3__/* .isNullOrBlank */ .Xy7)(txMessage) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                    value: txMessage,
                    readOnly: true,
                    className: (_ModalTask_module_scss__WEBPACK_IMPORTED_MODULE_4___default().textarea)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_ModalTask_module_scss__WEBPACK_IMPORTED_MODULE_4___default().transDiv),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_ModalTask_module_scss__WEBPACK_IMPORTED_MODULE_4___default().transText),
                            children: "Status:"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat((_ModalTask_module_scss__WEBPACK_IMPORTED_MODULE_4___default().status), " ").concat(txConfirmed ? (_ModalTask_module_scss__WEBPACK_IMPORTED_MODULE_4___default().confirmed) : isTxError ? (_ModalTask_module_scss__WEBPACK_IMPORTED_MODULE_4___default().error) : (_ModalTask_module_scss__WEBPACK_IMPORTED_MODULE_4___default().waiting)),
                            children: txConfirmed ? "Completed" : isTxError ? "Error" : "Waiting..."
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalTask);

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 14523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useModalTask; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75971);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_1__]);
smart_db__WEBPACK_IMPORTED_MODULE_1__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];


// Custom hook for managing modal transaction state and clipboard functionality
function useModalTask() {
    var appStore = (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .useAppStore */ .qrW)();
    // State for tracking if text was successfully copied
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), copied = ref[0], setCopied = ref[1];
    // Function to handle copying text to clipboard
    var handleCopyToClipboard = function(text) {
        navigator.clipboard.writeText(text || "") // Writes text to clipboard (defaults to empty string if text is falsy)
        .then(function() {
            setCopied(true); // Sets `copied` to true upon successful copy
            setTimeout(function() {
                return setCopied(false);
            }, 1000); // Resets `copied` to false after 1 second
        }).catch(function(err) {
            console.error("Error copying text:", err); // Logs error if copying fails
        });
    };
    // Return the modal and clipboard states and their handlers
    return {
        isModalOpen: appStore.showProcessingTx,
        txHash: appStore.processingTxHash,
        isTxError: appStore.isFaildedTx,
        txMessage: appStore.processingTxMessage,
        txConfirmed: appStore.isConfirmedTx,
        copied: copied,
        handleCopyToClipboard: handleCopyToClipboard
    };
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 64857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33562);
/* harmony import */ var _ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _useModalTransaction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12353);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75971);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_useModalTransaction__WEBPACK_IMPORTED_MODULE_2__, smart_db__WEBPACK_IMPORTED_MODULE_3__]);
([_useModalTransaction__WEBPACK_IMPORTED_MODULE_2__, smart_db__WEBPACK_IMPORTED_MODULE_3__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);





// ModalTransaction component definition
var ModalTransaction = function() {
    // Import custom hooks for clipboard copy state and handler function
    var ref = (0,_useModalTransaction__WEBPACK_IMPORTED_MODULE_2__/* .useModalTransaction */ .x)(), isTxModalOpen = ref.isTxModalOpen, txHash = ref.txHash, isTxError = ref.isTxError, txMessage = ref.txMessage, txConfirmed = ref.txConfirmed, copied = ref.copied, handleCopyToClipboard = ref.handleCopyToClipboard;
    return(// Render the modal with various transaction details
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
        className: (_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().layout),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: (_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                    children: "Transaction Status"
                }),
                !(0,smart_db__WEBPACK_IMPORTED_MODULE_3__/* .isNullOrBlank */ .Xy7)(txMessage) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                    value: txMessage,
                    readOnly: true,
                    className: (_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().textarea)
                }),
                !(0,smart_db__WEBPACK_IMPORTED_MODULE_3__/* .isNullOrBlank */ .Xy7)(txHash) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().transDiv),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().transText),
                            children: "Tx Hash:"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat((_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().txHashContainer), " ").concat(copied ? txHash ? (_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().copied) : (_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().copiedError) : ""),
                            onClick: function() {
                                return handleCopyToClipboard(txHash);
                            },
                            style: {
                                cursor: "pointer"
                            },
                            children: [
                                (0,smart_db__WEBPACK_IMPORTED_MODULE_3__/* .formatHash */ .NI2)(txHash),
                                !copied ? // Icon for copying to clipboard
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    className: "bi bi-clipboard2 inline",
                                    viewBox: "0 0 16 16",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M3.5 2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5H12a.5.5 0 0 1 0-1h.5A1.5 1.5 0 0 1 14 2.5v12a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-12A1.5 1.5 0 0 1 3.5 1H4a.5.5 0 0 1 0 1z"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5"
                                        })
                                    ]
                                }) : txHash ? // Icon indicating copy success
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    className: "bi bi-clipboard2-check-fill inline",
                                    viewBox: "0 0 16 16",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585q.084.236.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5q.001-.264.085-.5m6.769 6.854-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708"
                                    })
                                }) : // Icon indicating copy failure
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    className: "inline bi bi-clipboard2-x",
                                    viewBox: "0 0 16 16",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M8 8.293 6.854 7.146a.5.5 0 1 0-.708.708L7.293 9l-1.147 1.146a.5.5 0 0 0 .708.708L8 9.707l1.146 1.147a.5.5 0 0 0 .708-.708L8.707 9l1.147-1.146a.5.5 0 0 0-.708-.708z"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().transDiv),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().transText),
                            children: "Status:"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat((_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().status), " ").concat(txConfirmed ? (_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().confirmed) : isTxError ? (_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().error) : (_ModalTransaction_module_scss__WEBPACK_IMPORTED_MODULE_4___default().waiting)),
                            children: txConfirmed ? "Confirmed" : isTxError ? "Error" : "Waiting..."
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalTransaction);

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 12353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useModalTransaction; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75971);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_1__]);
smart_db__WEBPACK_IMPORTED_MODULE_1__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];


// Custom hook for managing modal transaction state and clipboard functionality
function useModalTransaction() {
    var appStore = (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .useAppStore */ .qrW)();
    // State for tracking if text was successfully copied
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), copied = ref[0], setCopied = ref[1];
    // Function to handle copying text to clipboard
    var handleCopyToClipboard = function(text) {
        navigator.clipboard.writeText(text || "") // Writes text to clipboard (defaults to empty string if text is falsy)
        .then(function() {
            setCopied(true); // Sets `copied` to true upon successful copy
            setTimeout(function() {
                return setCopied(false);
            }, 1000); // Resets `copied` to false after 1 second
        }).catch(function(err) {
            console.error("Error copying text:", err); // Logs error if copying fails
        });
    };
    // Return the modal and clipboard states and their handlers
    return {
        isTxModalOpen: appStore.showProcessingTx,
        txHash: appStore.processingTxHash,
        isTxError: appStore.isFaildedTx,
        txMessage: appStore.processingTxMessage,
        txConfirmed: appStore.isConfirmedTx,
        copied: copied,
        handleCopyToClipboard: handleCopyToClipboard
    };
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 62867:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75971);
/* harmony import */ var _WalletInformationModal_WalletInformationModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33296);
/* harmony import */ var _WalletSelectorModal_WalletSelectorModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31985);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_1__, _WalletInformationModal_WalletInformationModal__WEBPACK_IMPORTED_MODULE_2__, _WalletSelectorModal_WalletSelectorModal__WEBPACK_IMPORTED_MODULE_3__]);
([smart_db__WEBPACK_IMPORTED_MODULE_1__, _WalletInformationModal_WalletInformationModal__WEBPACK_IMPORTED_MODULE_2__, _WalletSelectorModal_WalletSelectorModal__WEBPACK_IMPORTED_MODULE_3__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);




var WalletConnectorModal = function() {
    var walletStore = (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .useWalletActions */ .Za7)().walletStore;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: walletStore.isConnected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WalletInformationModal_WalletInformationModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WalletSelectorModal_WalletSelectorModal__WEBPACK_IMPORTED_MODULE_3__/* .WalletSelectorModal */ .v, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WalletConnectorModal);

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 33296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_constants_images__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24072);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75971);
/* harmony import */ var _WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21955);
/* harmony import */ var _WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_Common_Buttons_Toggle_Toggle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1705);
/* harmony import */ var _components_Common_Buttons_RedButton_RedButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65980);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_3__]);
smart_db__WEBPACK_IMPORTED_MODULE_3__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];








var WalletInformationModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    //--------------------------------------
    //  const { closeModal } = useModal();
    var closeModal = undefined;
    //--------------------------------------
    var ref6 = (0,smart_db__WEBPACK_IMPORTED_MODULE_3__/* .useWalletActions */ .Za7)(), session = ref6.session, walletStore = ref6.walletStore, createSignedSession = ref6.createSignedSession, walletRefresh = ref6.walletRefresh, walletDisconnect = ref6.walletDisconnect, handleClickToggleAdminMode = ref6.handleClickToggleAdminMode, handleClickToggleDontPromtForSigning = ref6.handleClickToggleDontPromtForSigning, handleToggleIsHide = ref6.handleToggleIsHide;
    //--------------------------------------
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), copySuccess = ref7[0], setCopySuccess = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(undefined), icon = ref8[0], setIcon = ref8[1];
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (walletStore.isConnected === true) {
            var ref, ref1;
            var walletName = session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.walletName;
            var icon = (ref1 = smart_db__WEBPACK_IMPORTED_MODULE_3__/* .CARDANO_WALLETS.find */ .OOZ.find(function(wallet) {
                return wallet.wallet === walletName;
            })) === null || ref1 === void 0 ? void 0 : ref1.icon;
            setIcon(icon === null || icon === void 0 ? void 0 : icon.href);
        }
    }, [
        walletStore.isConnected
    ]);
    //-------------------------
    var handleCopy = function(value) {
        if (value) {
            navigator.clipboard.writeText(value).then(function() {
                setCopySuccess(true);
                setTimeout(function() {
                    setCopySuccess(false);
                }, 2000);
            }).catch(function(err) {
                console.error("Failed to copy: ", err);
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
        className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().layout),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                    children: [
                        "Wallet [",
                        (ref = walletStore.info) === null || ref === void 0 ? void 0 : ref.walletName,
                        "]"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().header),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().headerIcon),
                            onClick: function() {
                                walletRefresh();
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    width: "24",
                                    height: "24",
                                    className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().icon),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
                                        href: _utils_constants_images__WEBPACK_IMPORTED_MODULE_7__/* .REFRESH */ .RG
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "Refresh"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().headerIcon),
                            onClick: function() {
                                handleToggleIsHide();
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    width: "24",
                                    height: "24",
                                    className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().icon),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
                                        href: walletStore.swHideBalance ? _utils_constants_images__WEBPACK_IMPORTED_MODULE_7__/* .HIDE */ .B8 : _utils_constants_images__WEBPACK_IMPORTED_MODULE_7__/* .SHOW */ .nr
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: walletStore.swHideBalance ? "Hide Balance" : "Show Balance"
                                })
                            ]
                        }),
                        (((ref1 = walletStore.info) === null || ref1 === void 0 ? void 0 : ref1.isWalletFromSeed) === true || ((ref2 = walletStore.info) === null || ref2 === void 0 ? void 0 : ref2.isWalletFromKey) === true) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().toogleIcon),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_Buttons_Toggle_Toggle__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    isActive: walletStore.swDoNotPromtForSigning || false,
                                    onClickToggle: function() {
                                        handleClickToggleDontPromtForSigning();
                                    },
                                    disabled: false,
                                    transparent: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "Auto"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().toogleIcon),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_Buttons_Toggle_Toggle__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    isActive: ((ref3 = walletStore.info) === null || ref3 === void 0 ? void 0 : ref3.isWalletValidatedWithSignedToken) || false,
                                    onClickToggle: function() {
                                        handleClickToggleAdminMode();
                                    },
                                    disabled: false,
                                    transparent: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "Admin"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inputInformatiopn),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                            htmlFor: "",
                            children: "Address"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().addressContainer),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().iconInput),
                                    children: [
                                        icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            src: icon.toString(),
                                            alt: "icon",
                                            width: 34,
                                            height: 24
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().dataContainer),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wallet_address),
                                                children: (ref4 = walletStore.info) === null || ref4 === void 0 ? void 0 : ref4.address
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    onClick: function() {
                                        var ref;
                                        return handleCopy(((ref = walletStore.info) === null || ref === void 0 ? void 0 : ref.address) || "");
                                    },
                                    children: copySuccess ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: _utils_constants_images__WEBPACK_IMPORTED_MODULE_7__/* .STATUS_GREEM */ .FJ,
                                        alt: "",
                                        height: 12,
                                        width: 15
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: smart_db__WEBPACK_IMPORTED_MODULE_3__/* .COPY.href */ .B4E.href,
                                        alt: "",
                                        height: 12,
                                        width: 15
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inputInformatiopn),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                            htmlFor: "",
                            children: "PaymentKeyHash"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().addressContainer),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().iconInput),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().dataContainer),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wallet_address),
                                            children: (ref5 = walletStore.info) === null || ref5 === void 0 ? void 0 : ref5.pkh
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    onClick: function() {
                                        var ref;
                                        return handleCopy(((ref = walletStore.info) === null || ref === void 0 ? void 0 : ref.pkh) || "");
                                    },
                                    children: copySuccess ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: _utils_constants_images__WEBPACK_IMPORTED_MODULE_7__/* .STATUS_GREEM */ .FJ,
                                        alt: "",
                                        height: 12,
                                        width: 15
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: smart_db__WEBPACK_IMPORTED_MODULE_3__/* .COPY.href */ .B4E.href,
                                        alt: "",
                                        height: 12,
                                        width: 15
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_WalletInformationModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().buttonDisconectContainer),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_Buttons_RedButton_RedButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        onClick: function() {
                            walletDisconnect(closeModal);
                        },
                        style: "",
                        children: "Disconect Wallet"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WalletInformationModal);

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 31985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ WalletSelectorModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75971);
/* harmony import */ var _WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43544);
/* harmony import */ var _WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_Common_Buttons_Toggle_Toggle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1705);
/* harmony import */ var _components_Common_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78470);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_4__]);
smart_db__WEBPACK_IMPORTED_MODULE_4__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];











var WalletSelectorModal = function() {
    var showWalletButtons = function showWalletButtons() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                availableWallets.map(function(wallet) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "".concat((_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().walletItem), " ").concat((_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().available)),
                        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!wallet.isInstalled) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            walletConnect(wallet, createSignedSession, true, true, closeModal)
                                        ];
                                    case 1:
                                        _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                width: 36,
                                height: 36,
                                alt: "".concat(wallet.name, " icon"),
                                src: wallet.icon.toString(),
                                className: (_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().walletIcon)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().walletLine),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: wallet.name
                                })
                            }),
                            walletStore.isConnecting && walletSelected === wallet.wallet && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                        ]
                    }, wallet.name);
                }),
                unAvailableWallets.map(function(wallet) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: wallet.link,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "".concat((_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().walletItem), " ").concat((_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().unAvailable)),
                            onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!!wallet.isInstalled) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                walletInstall(wallet)
                                            ];
                                        case 1:
                                            _state.sent();
                                            _state.label = 2;
                                        case 2:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    width: 36,
                                    height: 36,
                                    alt: "".concat(wallet.name, " icon"),
                                    src: wallet.icon.toString(),
                                    className: (_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().walletIcon)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().walletLine),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: wallet.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "Install"
                                        })
                                    ]
                                })
                            ]
                        })
                    }, wallet.name);
                })
            ]
        });
    };
    var showWalletsFromSeedButtons = function showWalletsFromSeedButtons() {
        return Object.entries(availableWalletsSeeds).map(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(param, 2), name = _param[0], seed = _param[1];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                className: "".concat((_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().walletItem), " ").concat((_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().available)),
                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    walletFromSeedConnect(name, seed, createSignedSession, true, closeModal)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: name
                    }),
                    walletStore.isConnecting && walletSelected === name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                ]
            }, "Wallet ".concat(name, " - Seed"));
        });
    };
    var showKeysWalletButtons = function showKeysWalletButtons() {
        return Object.entries(availableWalletsKeys).length > 0 ? Object.entries(availableWalletsKeys).map(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(param, 2), name = _param[0], key = _param[1];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                className: "".concat((_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().walletItem), " ").concat((_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().available)),
                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    walletFromKeyConnect(name, key, createSignedSession, true, closeModal)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: name
                    }),
                    walletStore.isConnecting && walletSelected === name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_LoaderButton_LoaderButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                ]
            }, "Wallet ".concat(name, " - Key"));
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: "Loading emulator wallets"
        });
    };
    var ref;
    var closeModal = undefined;
    var appStore = (0,smart_db__WEBPACK_IMPORTED_MODULE_4__/* .useAppStore */ .qrW)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), availableWallets = ref1[0], setAvailableWallets = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), unAvailableWallets = ref2[0], setUnAvailableWallets = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}), availableWalletsSeeds = ref3[0], setAvailableWalletsSeeds = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}), availableWalletsKeys = ref4[0], setAvailableWalletsKeys = ref4[1];
    var ref5 = (0,smart_db__WEBPACK_IMPORTED_MODULE_4__/* .useWalletActions */ .Za7)(), walletStore = ref5.walletStore, walletSelected = ref5.walletSelected, createSignedSession = ref5.createSignedSession, setCreateSignedSession = ref5.setCreateSignedSession, walletConnect = ref5.walletConnect, walletFromSeedConnect = ref5.walletFromSeedConnect, walletFromKeyConnect = ref5.walletFromKeyConnect, walletInstall = ref5.walletInstall;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var available = [];
        var unAvailable = [];
        walletStore.cardanoWallets.forEach(function(wallet) {
            wallet.isInstalled ? available.push(wallet) : unAvailable.push(wallet);
        });
        setAvailableWallets(available);
        setUnAvailableWallets(unAvailable);
        setAvailableWalletsSeeds({
            "Master 1": "dad cupboard hotel cause mansion feature oppose prevent install venue finish galaxy tone green volcano neglect coil toast future exchange prize social next tape",
            "Master 2": "laptop brief dune view concert rule raise roast vessel harbor discover own urge mail aisle patrol budget awesome mimic throw loop access transfer cousin"
        });
    }, [
        walletStore.cardanoWallets
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (walletStore.emulatorDB !== undefined) {
            var keys = walletStore.emulatorDB.privateKeys.reduce(function(acc, key, index) {
                acc["Emulator ".concat(index + 1)] = key;
                return acc;
            }, {});
            setAvailableWalletsKeys(keys);
        }
    }, [
        walletStore.emulatorDB
    ]);
    var handleClickToggle = function() {
        setCreateSignedSession(!createSignedSession);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
        className: (_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().layout),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    children: [
                        "Connect ",
                        "Mainnet",
                        " Wallet"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    className: (_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().bodyModal),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: (_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().walletList),
                            children: smart_db__WEBPACK_IMPORTED_MODULE_4__/* .isEmulator */ .Itp ? showKeysWalletButtons() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    showWalletButtons(),
                                    ((ref = appStore.siteSettings) === null || ref === void 0 ? void 0 : ref.debug) && showWalletsFromSeedButtons()
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_WalletSelectorModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().toogleIcon),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_Buttons_Toggle_Toggle__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    isActive: createSignedSession,
                                    onClickToggle: handleClickToggle,
                                    disabled: false,
                                    transparent: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "Admin"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 99165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Layout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75971);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_2__]);
smart_db__WEBPACK_IMPORTED_MODULE_2__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];



function Layout(param) {
    var children = param.children;
    //--------------------------------------
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isRefreshing = ref[0], setIsRefreshing = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsRefreshing(false);
    }, []);
    //-------------------------------------
    var appStore = (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .useAppStore */ .qrW)();
    //--------------------------------------
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: appStore.swInitApiCompleted && children
    });
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 37970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ initialAppState; },
/* harmony export */   "z": function() { return /* binding */ AppStateContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// // Initial state for the app, with default values.
var initialAppState = {
    sidebarState: "Protocol Area"
};
// Create a context for managing the app state globally.
var AppStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    appState: initialAppState,
    setAppState: function() {}
});


/***/ }),

/***/ 86662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useModal; },
/* harmony export */   "t": function() { return /* binding */ ModalContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
var useModal = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ModalContext);
    if (context === undefined) {
        throw new Error("useModal must be used within a ModalProvider");
    }
    return context;
};


/***/ }),

/***/ 76625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ModalProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Common_Modals_Modals_WalletConnectorModal_WalletConnectorModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62867);
/* harmony import */ var _components_Common_Modals_ModalTemplate_ModalTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54512);
/* harmony import */ var _utils_constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23531);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _ModalContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86662);
/* harmony import */ var _components_Common_Modals_Modals_ModalTransaction_ModalTransaction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64857);
/* harmony import */ var _components_Common_Modals_Modals_ModalTask_ModalTask__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96146);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_components_Common_Modals_Modals_WalletConnectorModal_WalletConnectorModal__WEBPACK_IMPORTED_MODULE_1__, _components_Common_Modals_Modals_ModalTransaction_ModalTransaction__WEBPACK_IMPORTED_MODULE_6__, _components_Common_Modals_Modals_ModalTask_ModalTask__WEBPACK_IMPORTED_MODULE_7__]);
([_components_Common_Modals_Modals_WalletConnectorModal_WalletConnectorModal__WEBPACK_IMPORTED_MODULE_1__, _components_Common_Modals_Modals_ModalTransaction_ModalTransaction__WEBPACK_IMPORTED_MODULE_6__, _components_Common_Modals_Modals_ModalTask_ModalTask__WEBPACK_IMPORTED_MODULE_7__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);









var ModalProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), activeModal = ref[0], setActiveModal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(undefined), modalData = ref1[0], setModalData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(undefined), handles = ref2[0], setHandles = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), dynamicModal = ref3[0], setDynamicModal = ref3[1];
    var openModal = function(modal, data, handles, component) {
        setActiveModal(modal);
        setModalData(data || undefined);
        setHandles(handles || undefined);
        setDynamicModal(component || null);
    };
    var closeModal = function() {
        setActiveModal(null);
        setModalData(undefined);
        setHandles(undefined);
        setDynamicModal(null);
    };
    var _obj;
    // Predefined modals
    var modalComponents = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _utils_constants_constants__WEBPACK_IMPORTED_MODULE_3__/* .ModalsEnums.WALLET_CONNECT */ .DC.WALLET_CONNECT, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_Modals_Modals_WalletConnectorModal_WalletConnectorModal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _utils_constants_constants__WEBPACK_IMPORTED_MODULE_3__/* .ModalsEnums.PROCESSING_TASK */ .DC.PROCESSING_TASK, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_Modals_Modals_ModalTask_ModalTask__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _utils_constants_constants__WEBPACK_IMPORTED_MODULE_3__/* .ModalsEnums.PROCESSING_TX */ .DC.PROCESSING_TX, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_Modals_Modals_ModalTransaction_ModalTransaction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})), _obj);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ModalContext__WEBPACK_IMPORTED_MODULE_5__/* .ModalContext.Provider */ .t.Provider, {
        value: {
            activeModal: activeModal,
            modalData: modalData,
            handles: handles,
            openModal: openModal,
            closeModal: closeModal
        },
        children: [
            activeModal !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_Modals_ModalTemplate_ModalTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                active: activeModal,
                children: modalComponents[activeModal] || dynamicModal || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        "Modal ",
                        activeModal,
                        " Not Implemented"
                    ]
                })
            }),
            children
        ]
    });
};

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 24025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useResponsive; },
/* harmony export */   "b": function() { return /* binding */ ResponsiveContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ResponsiveContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
var useResponsive = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ResponsiveContext);
    if (!context) {
        throw new Error("useResponsiveContext must be used within a Responsive Provider");
    }
    return context;
};


/***/ }),

/***/ 16223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ResponsiveProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ResponsiveContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24025);



var ResponsiveProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("mobile"), screenSize = ref[0], setScreenSize = ref[1];
    var updateScreenSize = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (window.matchMedia("(max-width: 640px)").matches) {
            setScreenSize("mobile");
        } else if (window.matchMedia("(max-width: 768px)").matches) {
            setScreenSize("tablet");
        } else if (window.matchMedia("(max-width: 1024px)").matches) {
            setScreenSize("tablet-large");
        } else {
            setScreenSize("desktop");
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var mobileQuery = window.matchMedia("(max-width: 640px)");
        var tabletQuery = window.matchMedia("(min-width: 641px) and (max-width: 768px)");
        var tabletLargeQuery = window.matchMedia("(min-width: 769px) and (max-width: 1024px)");
        updateScreenSize();
        mobileQuery.addEventListener("change", updateScreenSize);
        tabletQuery.addEventListener("change", updateScreenSize);
        tabletLargeQuery.addEventListener("change", updateScreenSize);
        return function() {
            mobileQuery.removeEventListener("change", updateScreenSize);
            tabletQuery.removeEventListener("change", updateScreenSize);
            tabletLargeQuery.removeEventListener("change", updateScreenSize);
        };
    }, [
        updateScreenSize
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ResponsiveContext__WEBPACK_IMPORTED_MODULE_2__/* .ResponsiveContext.Provider */ .b.Provider, {
        value: {
            screenSize: screenSize
        },
        children: children
    });
};


/***/ }),

/***/ 59754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ OTCEntity; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16567);
/* harmony import */ var _swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28660);
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reflect_metadata__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75971);
/* harmony import */ var _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16573);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_1__, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_2__]);
([smart_db__WEBPACK_IMPORTED_MODULE_1__, _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_2__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);





var _OTCEntity;



var OTCEntity = (_OTCEntity = /*#__PURE__*/ function(BaseSmartDBEntity) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(OTCEntity, BaseSmartDBEntity);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(OTCEntity);
    function OTCEntity() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, OTCEntity);
        var _this;
        _this = _super.apply(this, arguments);
        _this._NET_id_TN_Str = _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_2__/* .OTC_ID_TN_Str */ .VP;
        return _this;
    }
    return OTCEntity;
}(smart_db__WEBPACK_IMPORTED_MODULE_1__/* .BaseSmartDBEntity */ .twE), _OTCEntity._apiRoute = "otc", _OTCEntity._className = "OTC", _OTCEntity._plutusDataIsSubType = false, _OTCEntity._isOnlyDatum = true // Indicates that this entity is only a datum and do nt have other fields to save in the db.
, // The _is_NET_id_Unique flag indicates whether the Token ID is unique in the datum (for NFTs) or if it's a fungible token (FT).
_OTCEntity._is_NET_id_Unique = false, // #endregion fields
// #region db
_OTCEntity.defaultFieldsWhenUndefined = {}, _OTCEntity.alwaysFieldsForSelect = {}, _OTCEntity);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof PaymentPubKey === "undefined" ? Object : PaymentPubKey)
], OTCEntity.prototype, "od_creator", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof PolicyId === "undefined" ? Object : PolicyId)
], OTCEntity.prototype, "od_token_policy_id", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof TN === "undefined" ? Object : TN)
], OTCEntity.prototype, "od_token_tn", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof BigInt === "undefined" ? Object : BigInt)
], OTCEntity.prototype, "od_token_amount", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof PolicyId === "undefined" ? Object : PolicyId)
], OTCEntity.prototype, "od_otc_nft_policy_id", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof TN === "undefined" ? Object : TN)
], OTCEntity.prototype, "od_otc_nft_tn", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof PolicyId === "undefined" ? Object : PolicyId)
], OTCEntity.prototype, "od_mayz_policy_id", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof TN === "undefined" ? Object : TN)
], OTCEntity.prototype, "od_mayz_tn", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof BigInt === "undefined" ? Object : BigInt)
], OTCEntity.prototype, "od_mayz_locked", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof BigInt === "undefined" ? Object : BigInt)
], OTCEntity.prototype, "od_min_ada", void 0);
OTCEntity = (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_1__/* .asSmartDBEntity */ .F2s)()
], OTCEntity);

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ ProtocolEntity; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16567);
/* harmony import */ var _swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16573);
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28660);
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(reflect_metadata__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75971);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_0__, smart_db__WEBPACK_IMPORTED_MODULE_2__]);
([_utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_0__, smart_db__WEBPACK_IMPORTED_MODULE_2__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);





var _ProtocolEntity;



var ProtocolEntity = (_ProtocolEntity = /*#__PURE__*/ function(BaseSmartDBEntity) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ProtocolEntity, BaseSmartDBEntity);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ProtocolEntity);
    function ProtocolEntity() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, ProtocolEntity);
        var _this;
        _this = _super.apply(this, arguments);
        _this._NET_id_TN_Str = _utils_constants_on_chain__WEBPACK_IMPORTED_MODULE_0__/* .PROTOCOL_ID_TN_Str */ .Q8;
        return _this;
    }
    var _proto = ProtocolEntity.prototype;
    // #endregion db
    // #region class methods
    _proto.getNet_Address = function getNet_Address() {
        if ("Mainnet" === smart_db__WEBPACK_IMPORTED_MODULE_2__/* .LUCID_NETWORK_MAINNET_NAME */ .Pem) {
            return this.fProtocolValidator_AddressMainnet;
        } else {
            return this.fProtocolValidator_AddressTestnet;
        }
    };
    _proto.getNET_id_CS = function getNET_id_CS() {
        return this.fProtocolPolicyID_CS;
    };
    _proto.getOTC_Net_Address = function getOTC_Net_Address() {
        if ("Mainnet" === smart_db__WEBPACK_IMPORTED_MODULE_2__/* .LUCID_NETWORK_MAINNET_NAME */ .Pem) {
            return this.fOTCValidator_AddressMainnet;
        } else {
            return this.fOTCValidator_AddressTestnet;
        }
    };
    _proto.getOTC_NET_id_CS = function getOTC_NET_id_CS() {
        return this.fOTCPolicyID_CS;
    };
    return ProtocolEntity;
}(smart_db__WEBPACK_IMPORTED_MODULE_2__/* .BaseSmartDBEntity */ .twE), _ProtocolEntity._apiRoute = "protocol", _ProtocolEntity._className = "Protocol", _ProtocolEntity._plutusDataIsSubType = false, _ProtocolEntity._isOnlyDatum = false, // #endregion fields
// #region db
_ProtocolEntity.defaultFieldsWhenUndefined = {}, _ProtocolEntity.alwaysFieldsForSelect = {}, _ProtocolEntity);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)({
        isUnique: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", String)
], ProtocolEntity.prototype, "name", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof Script === "undefined" ? Object : Script)
], ProtocolEntity.prototype, "fProtocolScript", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", Object)
], ProtocolEntity.prototype, "fProtocolScript_Params", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)({
        isUnique: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof CS === "undefined" ? Object : CS)
], ProtocolEntity.prototype, "fProtocolPolicyID_CS", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", String)
], ProtocolEntity.prototype, "fProtocolValidator_AddressMainnet", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", String)
], ProtocolEntity.prototype, "fProtocolValidator_AddressTestnet", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)({
        isUnique: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", String)
], ProtocolEntity.prototype, "fProtocolValidator_Hash", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof Script === "undefined" ? Object : Script)
], ProtocolEntity.prototype, "fOTCScript", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", Object)
], ProtocolEntity.prototype, "fOTCScript_Params", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof CS === "undefined" ? Object : CS)
], ProtocolEntity.prototype, "fOTCPolicyID_CS", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", String)
], ProtocolEntity.prototype, "fOTCValidator_AddressMainnet", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", String)
], ProtocolEntity.prototype, "fOTCValidator_AddressTestnet", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", String)
], ProtocolEntity.prototype, "fOTCValidator_Hash", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)(),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof Script === "undefined" ? Object : Script)
], ProtocolEntity.prototype, "fOTC_NFT_PRE_Script", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)({
        isForDatum: true,
        type: String
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", Array)
], ProtocolEntity.prototype, "pd_admins", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", String)
], ProtocolEntity.prototype, "pd_token_admin_policy_id", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", String)
], ProtocolEntity.prototype, "pd_mayz_policy_id", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", String)
], ProtocolEntity.prototype, "pd_mayz_tn", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof BigInt === "undefined" ? Object : BigInt)
], ProtocolEntity.prototype, "pd_mayz_deposit_requirement", void 0);
(0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0x)({
        isForDatum: true
    }),
    (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__metadata)("design:type", typeof BigInt === "undefined" ? Object : BigInt)
], ProtocolEntity.prototype, "pd_min_ada", void 0);
ProtocolEntity = (0,_swc_helpers_src_ts_decorate_mjs__WEBPACK_IMPORTED_MODULE_6__.__decorate)([
    (0,smart_db__WEBPACK_IMPORTED_MODULE_2__/* .asSmartDBEntity */ .F2s)()
], ProtocolEntity);

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 58810:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ OTCApi; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16567);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75971);
/* harmony import */ var _Entities_OTC_Entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59754);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_0__, _Entities_OTC_Entity__WEBPACK_IMPORTED_MODULE_1__]);
([smart_db__WEBPACK_IMPORTED_MODULE_0__, _Entities_OTC_Entity__WEBPACK_IMPORTED_MODULE_1__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);





var OTCApi = /*#__PURE__*/ function(BaseSmartDBFrontEndTxApiCalls) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(OTCApi, BaseSmartDBFrontEndTxApiCalls);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(OTCApi);
    function OTCApi() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, OTCApi);
        return _super.apply(this, arguments);
    }
    return OTCApi;
}(smart_db__WEBPACK_IMPORTED_MODULE_0__/* .BaseSmartDBFrontEndTxApiCalls */ .jl9);
OTCApi._Entity = _Entities_OTC_Entity__WEBPACK_IMPORTED_MODULE_1__/* .OTCEntity */ .S;

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 83892:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ProtocolApi; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16567);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75971);
/* harmony import */ var _Entities_Protocol_Entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(193);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_0__, _Entities_Protocol_Entity__WEBPACK_IMPORTED_MODULE_1__]);
([smart_db__WEBPACK_IMPORTED_MODULE_0__, _Entities_Protocol_Entity__WEBPACK_IMPORTED_MODULE_1__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);





var ProtocolApi = /*#__PURE__*/ function(BaseSmartDBFrontEndTxApiCalls) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ProtocolApi, BaseSmartDBFrontEndTxApiCalls);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ProtocolApi);
    function ProtocolApi() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ProtocolApi);
        return _super.apply(this, arguments);
    }
    return ProtocolApi;
}(smart_db__WEBPACK_IMPORTED_MODULE_0__/* .BaseSmartDBFrontEndTxApiCalls */ .jl9);
ProtocolApi._Entity = _Entities_Protocol_Entity__WEBPACK_IMPORTED_MODULE_1__/* .ProtocolEntity */ .A;

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 1911:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* reexport safe */ _OTC_FrontEnd_Api_Calls__WEBPACK_IMPORTED_MODULE_0__.N; },
/* harmony export */   "O": function() { return /* reexport safe */ _Protocol_FrontEnd_Api_Calls__WEBPACK_IMPORTED_MODULE_1__.O; }
/* harmony export */ });
/* harmony import */ var _OTC_FrontEnd_Api_Calls__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58810);
/* harmony import */ var _Protocol_FrontEnd_Api_Calls__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83892);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_OTC_FrontEnd_Api_Calls__WEBPACK_IMPORTED_MODULE_0__, _Protocol_FrontEnd_Api_Calls__WEBPACK_IMPORTED_MODULE_1__]);
([_OTC_FrontEnd_Api_Calls__WEBPACK_IMPORTED_MODULE_0__, _Protocol_FrontEnd_Api_Calls__WEBPACK_IMPORTED_MODULE_1__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);



__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 12957:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MyApp; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_UI_Layout_Layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99165);
/* harmony import */ var _contexts_ModalProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76625);
/* harmony import */ var _contexts_ResponsiveProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16223);
/* harmony import */ var _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1911);
/* harmony import */ var _styles_global_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99067);
/* harmony import */ var _styles_global_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_global_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var easy_peasy__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27870);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var react_notifications_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1818);
/* harmony import */ var react_notifications_component__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_notifications_component__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_notifications_component_dist_theme_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58187);
/* harmony import */ var react_notifications_component_dist_theme_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_notifications_component_dist_theme_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75971);
/* harmony import */ var smart_db_dist_styles_css__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93998);
/* harmony import */ var smart_db_dist_styles_css__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(smart_db_dist_styles_css__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _contexts_AppState__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(37970);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_components_UI_Layout_Layout__WEBPACK_IMPORTED_MODULE_1__, _contexts_ModalProvider__WEBPACK_IMPORTED_MODULE_2__, _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_4__, smart_db__WEBPACK_IMPORTED_MODULE_11__]);
([_components_UI_Layout_Layout__WEBPACK_IMPORTED_MODULE_1__, _contexts_ModalProvider__WEBPACK_IMPORTED_MODULE_2__, _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_4__, smart_db__WEBPACK_IMPORTED_MODULE_11__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);


















function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps;
    // Use the useState hook to manage the app state locally within the component.
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(_contexts_AppState__WEBPACK_IMPORTED_MODULE_13__/* .initialAppState */ .g), appState = ref[0], setAppState = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(true), isLoadingApp = ref1[0], setIsLoadingApp = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(true), isLoadingProtocol = ref2[0], setIsLoadingProtocol = ref2[1];
    var fetchProtocol = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
            var protocol;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoadingProtocol(true);
                        return [
                            4,
                            _lib_SmartDB_FrontEnd__WEBPACK_IMPORTED_MODULE_4__/* .ProtocolApi.getOneByParamsApi_ */ .O.getOneByParamsApi_()
                        ];
                    case 1:
                        protocol = _state.sent();
                        // Update the context
                        setAppState(function(prev) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, prev), {
                                protocol: protocol
                            });
                        });
                        setIsLoadingProtocol(false); // Set loading to false after fetching the protocol
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchProtocol() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        var initialize = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchProtocol()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function initialize() {
                return _ref.apply(this, arguments);
            };
        }();
        if (isLoadingApp === false) {
            initialize();
        }
    }, [
        isLoadingApp
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_notifications_component__WEBPACK_IMPORTED_MODULE_9__.ReactNotifications, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_AppState__WEBPACK_IMPORTED_MODULE_13__/* .AppStateContext.Provider */ .z.Provider, {
                value: {
                    appState: appState,
                    setAppState: setAppState
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_auth_react__WEBPACK_IMPORTED_MODULE_7__.SessionProvider, {
                    session: pageProps.session,
                    refetchInterval: 0,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(easy_peasy__WEBPACK_IMPORTED_MODULE_6__/* .StoreProvider */ .g3, {
                        store: smart_db__WEBPACK_IMPORTED_MODULE_11__/* .globalStore */ .crs,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(smart_db__WEBPACK_IMPORTED_MODULE_11__/* .AppGeneral */ .Esd, {
                            loader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                            onLoadComplete: function() {
                                return setIsLoadingApp(false);
                            },
                            children: !isLoadingProtocol && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_ResponsiveProvider__WEBPACK_IMPORTED_MODULE_3__/* .ResponsiveProvider */ .$, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_ModalProvider__WEBPACK_IMPORTED_MODULE_2__/* .ModalProvider */ .D, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Layout_Layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, pageProps))
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 23531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DC": function() { return /* binding */ ModalsEnums; },
/* harmony export */   "Xz": function() { return /* binding */ TaskEnums; }
/* harmony export */ });
/* unused harmony export HandlesEnums */
//--------------------------------------------------------------
var ModalsEnums;
(function(ModalsEnums) {
    ModalsEnums["WALLET_CONNECT"] = "Wallet Connect";
    ModalsEnums["PROCESSING_TASK"] = "ProcessingTask";
    ModalsEnums["PROCESSING_TX"] = "ProcessingTx";
    ModalsEnums["CONFIRM_TX"] = "ConfirmTx";
})(ModalsEnums || (ModalsEnums = {}));
var TaskEnums;
(function(TaskEnums) {
    TaskEnums["CREATE_PROTOCOL"] = "CreateProtocol";
    TaskEnums["DELETE_PROTOCOL"] = "DeleteProtocol";
    TaskEnums["SYNC_PROTOCOL"] = "SyncProtocol";
    TaskEnums["ADD_TEST_TOKENS"] = "AddTestTokens";
})(TaskEnums || (TaskEnums = {}));
var HandlesEnums//--------------------------------------------------------------
;
(function(HandlesEnums) {})(HandlesEnums || (HandlesEnums = {}));


/***/ }),

/***/ 24072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B8": function() { return /* binding */ HIDE; },
/* harmony export */   "FJ": function() { return /* binding */ STATUS_GREEM; },
/* harmony export */   "RG": function() { return /* binding */ REFRESH; },
/* harmony export */   "nr": function() { return /* binding */ SHOW; },
/* harmony export */   "tJ": function() { return /* binding */ GENERIC; }
/* harmony export */ });
/* unused harmony exports CONNECTED_WALLET_ICON, ADA, WALLET */
var CONNECTED_WALLET_ICON = "/img/icons/wallet.svg#icon";
// export const DISCONNECTED_WALLET_ICON = '/icons/disconnectedWallet.svg#icon';
var REFRESH = "/img/icons/modal/refresh.svg#icon";
var HIDE = "/img/icons/modal/hide.svg#icon";
var SHOW = "/img/icons/modal/show.svg#icon";
var STATUS_GREEM = "/img/icons/status/green.svg";
var ADA = "/img/tokens/ada.png";
var GENERIC = "/img/tokens/generic.png";
var WALLET = "public/img/icons/wallet.svg";


/***/ }),

/***/ 16573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(module, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DC": function() { return /* binding */ TEST_TOKEN_TN_Str; },
/* harmony export */   "Ex": function() { return /* binding */ TEST_TOKEN_POLICY_CS; },
/* harmony export */   "Oi": function() { return /* binding */ MAYZ_TN_Str; },
/* harmony export */   "Q8": function() { return /* binding */ PROTOCOL_ID_TN_Str; },
/* harmony export */   "Rc": function() { return /* binding */ TxEnums; },
/* harmony export */   "VP": function() { return /* binding */ OTC_ID_TN_Str; },
/* harmony export */   "h": function() { return /* binding */ OTC_NFT_POLICY_PRE_CBORHEX; },
/* harmony export */   "n8": function() { return /* binding */ MAYZ_CS; },
/* harmony export */   "oH": function() { return /* binding */ OTC_SCRIPT_PRE_CBORHEX; },
/* harmony export */   "tz": function() { return /* binding */ ADMIN_TOKEN_POLICY_CS; },
/* harmony export */   "wz": function() { return /* binding */ PROTOCOL_SCRIPT_PRE_CBORHEX; }
/* harmony export */ });
/* unused harmony exports MAYZ_LOCK_AMOUNT, DeployProtocolTxParamsSchema, UpdateProtocolTxParamsSchema, CreateOtcTxParamsSchema, ClaimOtcTxParamsSchema, CloseOtcTxParamsSchema, CancelOtcTxParamsSchema */
/* harmony import */ var smart_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75971);
/* harmony import */ var _plutus_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17116);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([smart_db__WEBPACK_IMPORTED_MODULE_0__]);
smart_db__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
var ref, ref1, ref2;


//---------------------------------
// SMART CONTRACTS
//---------------------------------
// export const PROTOCOL_SCRIPT_PRE_CBORHEX =
//     '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';
// export const OTC_SCRIPT_PRE_CBORHEX =
//     '5912db010100323232323232323222533300332323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232532333032302402a13232323300502f15333035301f30363754002264646464a666072605600626464a666076604a60786ea80044c8c94ccc0f4c09cc0f8dd50008991919191919299982199980581f8051bae30383045375401c2a66608666ebcc068c114dd50028018a99982199980b19980c1980c9981b9bac30363045375407e464a66608a605e608c6ea80044cc07cdd6180f18239baa041375c6094608e6ea8004528180d98231baa301b3046375400246eacc0ccc118dd5000a5eb7bdb18005cdd30011119b89001002153330433375e6064608a6ea8014dd3000899baf00400e14a029405280a50333301e333301e3756606260886ea801cdd7181898221baa00d375c606a60886ea8034cdc0a40006eb4c094c110dd50068049bae30373044375401a900118129982299bb03030304337540186e98cc114cdd8181a18219baa00c30243043375401897adef6c604bd6f7b63018138069822182280118218009bac3042303f37540022c66660480700126eb8c0bcc0f8dd501da400460806eb0c100c0f4dd50008b199980181b0039bae302d303c375407290011bae302f303b37540082a666072604800626464a666076604a60786ea80044c94ccc0f0c0b8c0f4dd5199981201c0049bae302f303e37540769000099299981e99980281c8021bae3032303f37540102a66607a6602a0726eb8c050c0fcdd50040a99981e98061998169bab3033303f37540720146eb8c0c0c0fcdd501e0a99981e98061998169bab3033303f37540720086eb8c0c8c0fcdd5004099980781c9bae3014303f375401000229405280a5014a06602e60406608066ec0c078c0f8dd50039ba63304033760603a607c6ea801cc054c0f8dd5003a5eb7bdb1812f5bded8c06eb4c0ccc0f8dd50038b1bac3040303d37540022c666600606c00e6eb8c0b4c0f0dd501ca40046eb8c0bcc0ecdd50020a99981c980500189919299981d9812981e1baa001132533303c302e303d375466660480700126eb8c0bcc0f8dd501da4000264a66607a66600a0720086eb8c0c8c0fcdd50040a99981e9980a81c9bae3014303f37540102a66607a601866605a6eacc0ccc0fcdd501c8051bae3030303f37540782a66607a601866605a6eacc0ccc0fcdd501c8021bae3032303f3754010266601e0726eb8c050c0fcdd50040008a5014a029405281980b98101982019bb0301e303e375400e6e98cc100cdd8180e981f1baa0073015303e375400e97adef6c6033040337606056607c6ea801cdd31982019bb0302f303e375400e603e607c6ea801d2f5bded8c097adef6c60375a6066607c6ea801c58dd61820181e9baa001163333003036007375c605a60786ea80e52002375c605e60766ea801054ccc0e4cdc3a401000626464a666076604a60786ea80044c8c94ccc0f4c09cc0f8dd5000899191919191929998219980d81f9bae301a3045375401c2a66608666ebcc068c114dd50028018a99982199b884800002854ccc10ccdd7981918229baa005374c004266ebc0100045280a5014a02940c8c8c8c8c8c8c8c8c0eccc138c13c020cc138c13c01ccc138c13c018cc138c13c014cc138c13c010cc138c13c00ccc138c13c008cc138c13c004cc138c13cc140004cc138dd4008a5eb80c13c004c138004c134004c130004c12c004c128004c124004c110dd50069980e1bab30303043375400c66e00cdc0a40006eb4c0e0c10cdd500600418138069822182280118218009bac3042303f37540022c66660480700126eb8c0bcc0f8dd501da400460806eb0c100c0f4dd50008b199980181b0039bae302d303c375407290011bad303e303b37540662940888cdc4a400460506605e6eb0c048c0f4dd5001918171998161bab302b303e37546056607c6ea800400c0088888c94ccc0f0cdc39814800801099299981e9813981f1baa00113232533303f30293040375400226060660866e9ccc10cc0b8c104dd500119821982218209baa0014bd7025eb805300103d87a80003027302d304037540026084607e6ea8004530103d87a8000302800114c0103d87a80003302f37586024607a6ea80108c0b8ccc0b0dd59815981f1baa302b303e3754002008006606e6ea80c0c0e8c0dcdd50008a503039303a0023038001303437540562a66606460380542646600605a26464a66606a603e0042a66606a604e606c6ea8cccc0040c400cdd71814181b9baa034480004c94ccc0d8c080c0dcdd50008991919191919299981e1980a01c1bae3013303e37540082a666078605c6660586eacc0c8c0f8dd501c0051bae302f303e37540762a666078605c6660586eacc0c8c0f8dd501c1bae3032303e37540086eb8c0c4c0f8dd50020a99981e19baf3013303e375400a0062a66607866601c0706eb8c04cc0f8dd5002001099baf302b303e375400a6e980045280a5014a029405281980b180f9981f99bb037520126e98cc0fccdd81817181e9baa03a4c10101004bd6f7b6301981f99bb0302a303d37540066e98cc0fccdd81817181e9baa003301e303d375400697adef6c603303f33760603a607a6ea800cdd31981f99bb0301c303d37540066028607a6ea800d2f5bded8c097adef6c60375a6064607a6ea800cc078cc0f8cdd81818181e1baa002374c6607c66ec0c0bcc0f0dd50012610101004bd6f7b63025eb7bdb180c08001cc0f4c0f8008c0f0004dd6181d981c1baa00116333301d031003375c6050606e6ea80d1200216132533303630210031333001035004032153330363007003133300103500403214a044464a666072604660746ea80044c8c94ccc0ecc8cc004004c8c8cc004004dd5981a98201baa00722533304200114bd700991919299982119baf0063043003133046001330050050021330050050023043002304600230440013374a9001198201809981f1baa30410034bd701129998200008a50132533303e32533303f302930403754002264a6660806056002294454ccc100c0440045288a5030403754608860826ea800452819198078008981819821800a5eb80c10c00852889980180180098218008a99981d98051998159bab3031303d375400800a6eb8c0b8c0f4dd5003098051998159bab3031303d37540086eb8c0c4c0f4dd50009bae3030303d37540022940528181f98200009bac303e303b37540022c66660080020046eb8c0acc0e8dd5001a4004444464a66607266e1cc0980040084c94ccc0e8c090c0ecdd500089919299981e1813181e9baa0011302d33040374e66080004660806082607c6ea80052f5c097ae014c0103d87a80003024302a303d3754002607e60786ea8004530103d87a8000302500114c0103d87a80003302c3758601e60746ea80108c0acccc0a4dd59814181d9baa3028303b375400200800660686ea80b4dd7181b981a1baa02b16370e900091192999819980e8008a99981b181a9baa003150021615333033302500115333036303537540062a0042c2a666066603c0022a66606c606a6ea800c540085854ccc0ccc01000454ccc0d8c0d4dd50018a8010b0a99981999b87480200044c8c94ccc0e0c0ec0085401058dd6981c800981a9baa00316303337540046e1d200622233300433300633007330253758604860666ea800c8c94ccc0ccc074c0d0dd5000899b8f375c6070606a6ea80040105281804981a1baa30093034375400246eacc084c0d0dd5000a5eb7bdb180014dd30009119b89001002222533333303700214a0264646464a646660700042a66606a600200e26600c00690000a501323253330373375e607000498010140001533303733008005375a607260786eacc0e40084c00cdd30008a501533303733008005480004c00c024528181e001981d0011baf3039303a004375600aa666064603860666ea80044dd6981a181b9bab30373034375400229000181b00099199800800802111981b8011981b9ba60014bd70111299981b001099800a6103d87a80004bd6f7b630099191919299981b99b9148900002153330373371e91010000213300530283303b374c00297ae00031330054c103d87a8000006133300700700322330070023303d337606ea4010dd30018009bab3038003375c606c0046074006607000429405280a5022323330010010030022225333034002100113233300400430380033333018002375c60660026eacc0d0004888c94ccc0d8c04c0045300103d87a8000130273303a374c00297ae032333001001003002222533303b0021001132333004004303f0033333017002375c60740026eb4c0ec004888c94ccc0f4c09c004530103d87a80001302e33041375000297ae033700004002607a004606c00444464666002002008006444a66606800420022666006006606e004660086eacc0d800800488c8cc00400400c894ccc0c400452f5c02660646e98c00cc0cc004cc008008c0d00048c0bc00488cc010dd6180198161baa0020012302d302e302e302e302e302e302e302e302e00122323300100100322533302d00114a0264a66605666e3cdd718180010020a5113300300300130300012233330030024890048810000122225333028301200110041333300d004003323200230080013302c337606ea4008dd4000a5eb7bdb180888c94ccc0b0c024004530103d87a80001301d33030374c00297ae0333300900200500422232533302f301900114c0103d87a80001302033033375000297ae0337000020044a66604e00229445281111191980080080291299981580089981619bb0375200a6ea00112f5bded8c0264646464a66605866e400240084cc0c0cdd81ba9009375001000a2a66605866e3c0240084c94ccc0b4c05cc0b8dd500089981899bb037520146064605e6ea80040104010ccc01c0240200044cc0c0cdd81ba900237500026600c00c0066eb4c0b400cdd718158011817801181680098008009129998128008a4c264a66604c00229309919299981299b90375c604c60540086eb8c0980084cc014014cc0a400800458c0a8008c0a0004c0a00048c094c098c098c098c098c098c098c0980048c090c094c094c094c094c094c0940048c08cc090c090c0900048c8cc004004008894ccc08800452f5bded8c02664464646666010006004002444c646400464646600200200644a66605200229309929998150008a99981398021bad3029302c0021498584c8c8c8c94ccc0accdc81bae302c004375c60580062a666056601000226600e00e6605e0060042c2c6eb4c0b000cc0bc00cc0b4008c0b0008c0b00048ccc090c03800528251375660480066eb8c088008c090004cc008008c0940048888cccc01401000c008888ccc01000c0040088888c8cc004004014894ccc08c0044cc090cdd81ba9005374c00897adef6c6013232323253330243372001200426605066ec0dd48049ba6008005153330243371e012004264a66604a601e604c6ea80044cc0a4cdd81ba900a302a30273754002008200866600e01201000226605066ec0dd48011ba6001330060060033756604a0066eb8c08c008c09c008c0940048c02ccc078cdd2a40046603c6ea40052f5c06603c98103d87a80004bd70111119299980e99b87300a001002132533301e3008301f375400226464a666040601460426ea80044c044cc090dd39981200119812181298111baa0014bd7025eb805300103d87a80003008001302330203754002298103d87a8000300900114c0103d87a8000330103758601e603c6ea80108c03cccc034dd59806180f9baa00100400323253330193004301a3754002264a666034600860366ea80044c8c8c8c8c8c8c8c8c8c8c8c8c8c8c8c8c8c8c8c94ccc0c4c0d00084c07ccc0c80552f5c02c6eb4c0c8004c0c8008dd6981800098180011bae302e001302e002375c605800260580046eb8c0a8004c0a8008dd7181400098140011bad30260013026002375c604800260480046eb8c088004c088008dd71810000980e1baa00116301e301b3754002298103d87a8000300b301a37540026e1d2000370e90021299980c0008a6103d87a80001300633019301a0014bd70180080091299980b8008a4000266e01200233002002301a0012301730180012223253330143006301537540022900009bad30193016375400264a666028600c602a6ea8004530103d87a80001323300100137566034602e6ea8008894ccc064004530103d87a8000132323232533301a337220100042a66603466e3c0200084c02ccc078dd4000a5eb80530103d87a8000133006006003375a60360066eb8c064008c074008c06c004c8cc004004010894ccc0600045300103d87a80001323232325333019337220100042a66603266e3c0200084c028cc074dd3000a5eb80530103d87a8000133006006003375660340066eb8c060008c070008c068004dd2a40006e1d2002230133014301400122323300100100322533301300114bd70099192999809180280109980b00119802002000899802002000980b801180a80091808980918091809180918090009180818089808980898088009180798081808180818081808180818081808180800098049baa001300c300d002300b001300b00230090013005375400229309b2b2b9a5573aaae7955cfaba05742ae895d21';
// export const OTC_NFT_POLICY_PRE_CBORHEX =
//     '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';
var PROTOCOL_SCRIPT_PRE_CBORHEX = (ref = _plutus_json__WEBPACK_IMPORTED_MODULE_1__/* .validators.find */ .z2.find(function(v) {
    return v.title === "protocol.protocol.mint";
})) === null || ref === void 0 ? void 0 : ref.compiledCode;
var OTC_SCRIPT_PRE_CBORHEX = (ref1 = _plutus_json__WEBPACK_IMPORTED_MODULE_1__/* .validators.find */ .z2.find(function(v) {
    return v.title === "otc_validator.otc.spend";
})) === null || ref1 === void 0 ? void 0 : ref1.compiledCode;
var OTC_NFT_POLICY_PRE_CBORHEX = (ref2 = _plutus_json__WEBPACK_IMPORTED_MODULE_1__/* .validators.find */ .z2.find(function(v) {
    return v.title === "otc_nft_policy.otc_nft_policy.mint";
})) === null || ref2 === void 0 ? void 0 : ref2.compiledCode;
//---------------------------------
// ON CHAIN CONSTANTS
//---------------------------------
var PROTOCOL_ID_TN_Str = "ProtocolID";
var OTC_ID_TN_Str = "OTCID";
var MAYZ_CS = "e46f629f31e4a3c4ba16dd3bc396f24fb222f2776e7d698f2bda5018";
var MAYZ_TN_Str = "gMAYZ";
var MAYZ_LOCK_AMOUNT = 0n;
var ADMIN_TOKEN_POLICY_CS = "4a9d9a002e5245fd5e67525d912c991bc51e34b68d6a72fb03e80756";
var TEST_TOKEN_POLICY_CS = "aab33937400326885f7186e2725a84786266ec1eb06d397680233f80";
var TEST_TOKEN_TN_Str = "Token1";
var TxEnums;
(function(TxEnums) {
    TxEnums["PROTOCOL_DEPLOY"] = "Protocol - Deploy";
    TxEnums["PROTOCOL_UPDATE"] = "Protocol - Update";
    TxEnums["PROTOCOL_UPDATE_MIN_ADA"] = "Protocol - Update Min ADA";
    TxEnums["OTC_CREATE"] = "OTC - Create";
    TxEnums["OTC_CLAIM"] = "OTC - Claim";
    TxEnums["OTC_CLOSE"] = "OTC - Close";
    TxEnums["OTC_CANCEL"] = "OTC - Cancel";
})(TxEnums || (TxEnums = {}));
var DeployProtocolTxParamsSchema = smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T2L.object().shape({
    protocol_id: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    pd_admins: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.array */ .T2L.array().of(smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string()).required(),
    pd_token_admin_policy_id: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    pd_mayz_policy_id: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    pd_mayz_tn: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    pd_mayz_deposit_requirement: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.mixed */ .T2L.mixed().required()
});
var UpdateProtocolTxParamsSchema = smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T2L.object().shape({
    protocol_id: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    pd_admins: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.array */ .T2L.array().of(smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string()).required(),
    pd_token_admin_policy_id: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    pd_mayz_policy_id: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    pd_mayz_tn: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    pd_mayz_deposit_requirement: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.mixed */ .T2L.mixed().required()
});
var CreateOtcTxParamsSchema = smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T2L.object().shape({
    protocol_id: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    od_token_policy_id: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    od_token_tn: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    od_token_amount: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.mixed */ .T2L.mixed().required()
});
var ClaimOtcTxParamsSchema = smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T2L.object().shape({
    protocol_id: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    otcDbId: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required()
});
var CloseOtcTxParamsSchema = smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T2L.object().shape({
    otcDbId: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    protocol_id: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required()
});
var CancelOtcTxParamsSchema = smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T2L.object().shape({
    otcDbId: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required(),
    protocol_id: smart_db__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T2L.string().required()
});

__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 42474:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(83454);
(function(){var e={7160:function(e,t,r){var i=t;i.bignum=r(711);i.define=r(495).define;i.base=r(853);i.constants=r(7335);i.decoders=r(6701);i.encoders=r(3418)},495:function(e,t,r){var i=r(7160);var n=r(3782);var a=t;a.define=function define(e,t){return new Entity(e,t)};function Entity(e,t){this.name=e;this.body=t;this.decoders={};this.encoders={}}Entity.prototype._createNamed=function createNamed(e){var t;try{t=r(6144).runInThisContext("(function "+this.name+"(entity) {\n"+"  this._initNamed(entity);\n"+"})")}catch(e){t=function(e){this._initNamed(e)}}n(t,e);t.prototype._initNamed=function initnamed(t){e.call(this,t)};return new t(this)};Entity.prototype._getDecoder=function _getDecoder(e){e=e||"der";if(!this.decoders.hasOwnProperty(e))this.decoders[e]=this._createNamed(i.decoders[e]);return this.decoders[e]};Entity.prototype.decode=function decode(e,t,r){return this._getDecoder(t).decode(e,r)};Entity.prototype._getEncoder=function _getEncoder(e){e=e||"der";if(!this.encoders.hasOwnProperty(e))this.encoders[e]=this._createNamed(i.encoders[e]);return this.encoders[e]};Entity.prototype.encode=function encode(e,t,r){return this._getEncoder(t).encode(e,r)}},6483:function(e,t,r){var i=r(3782);var n=r(853).Reporter;var a=r(4300).Buffer;function DecoderBuffer(e,t){n.call(this,t);if(!a.isBuffer(e)){this.error("Input not Buffer");return}this.base=e;this.offset=0;this.length=e.length}i(DecoderBuffer,n);t.C=DecoderBuffer;DecoderBuffer.prototype.save=function save(){return{offset:this.offset,reporter:n.prototype.save.call(this)}};DecoderBuffer.prototype.restore=function restore(e){var t=new DecoderBuffer(this.base);t.offset=e.offset;t.length=this.offset;this.offset=e.offset;n.prototype.restore.call(this,e.reporter);return t};DecoderBuffer.prototype.isEmpty=function isEmpty(){return this.offset===this.length};DecoderBuffer.prototype.readUInt8=function readUInt8(e){if(this.offset+1<=this.length)return this.base.readUInt8(this.offset++,true);else return this.error(e||"DecoderBuffer overrun")};DecoderBuffer.prototype.skip=function skip(e,t){if(!(this.offset+e<=this.length))return this.error(t||"DecoderBuffer overrun");var r=new DecoderBuffer(this.base);r._reporterState=this._reporterState;r.offset=this.offset;r.length=this.offset+e;this.offset+=e;return r};DecoderBuffer.prototype.raw=function raw(e){return this.base.slice(e?e.offset:this.offset,this.length)};function EncoderBuffer(e,t){if(Array.isArray(e)){this.length=0;this.value=e.map((function(e){if(!(e instanceof EncoderBuffer))e=new EncoderBuffer(e,t);this.length+=e.length;return e}),this)}else if(typeof e==="number"){if(!(0<=e&&e<=255))return t.error("non-byte EncoderBuffer value");this.value=e;this.length=1}else if(typeof e==="string"){this.value=e;this.length=a.byteLength(e)}else if(a.isBuffer(e)){this.value=e;this.length=e.length}else{return t.error("Unsupported type: "+typeof e)}}t.R=EncoderBuffer;EncoderBuffer.prototype.join=function join(e,t){if(!e)e=new a(this.length);if(!t)t=0;if(this.length===0)return e;if(Array.isArray(this.value)){this.value.forEach((function(r){r.join(e,t);t+=r.length}))}else{if(typeof this.value==="number")e[t]=this.value;else if(typeof this.value==="string")e.write(this.value,t);else if(a.isBuffer(this.value))this.value.copy(e,t);t+=this.length}return e}},853:function(e,t,r){var i=t;i.Reporter=r(1293).b;i.DecoderBuffer=r(6483).C;i.EncoderBuffer=r(6483).R;i.Node=r(9374)},9374:function(e,t,r){var i=r(853).Reporter;var n=r(853).EncoderBuffer;var a=r(853).DecoderBuffer;var s=r(3523);var o=["seq","seqof","set","setof","objid","bool","gentime","utctime","null_","enum","int","objDesc","bitstr","bmpstr","charstr","genstr","graphstr","ia5str","iso646str","numstr","octstr","printstr","t61str","unistr","utf8str","videostr"];var h=["key","obj","use","optional","explicit","implicit","def","choice","any","contains"].concat(o);var u=["_peekTag","_decodeTag","_use","_decodeStr","_decodeObjid","_decodeTime","_decodeNull","_decodeInt","_decodeBool","_decodeList","_encodeComposite","_encodeStr","_encodeObjid","_encodeTime","_encodeNull","_encodeInt","_encodeBool"];function Node(e,t){var r={};this._baseState=r;r.enc=e;r.parent=t||null;r.children=null;r.tag=null;r.args=null;r.reverseArgs=null;r.choice=null;r.optional=false;r.any=false;r.obj=false;r.use=null;r.useDecoder=null;r.key=null;r["default"]=null;r.explicit=null;r.implicit=null;r.contains=null;if(!r.parent){r.children=[];this._wrap()}}e.exports=Node;var d=["enc","parent","children","tag","args","reverseArgs","choice","optional","any","obj","use","alteredUse","key","default","explicit","implicit","contains"];Node.prototype.clone=function clone(){var e=this._baseState;var t={};d.forEach((function(r){t[r]=e[r]}));var r=new this.constructor(t.parent);r._baseState=t;return r};Node.prototype._wrap=function wrap(){var e=this._baseState;h.forEach((function(t){this[t]=function _wrappedMethod(){var r=new this.constructor(this);e.children.push(r);return r[t].apply(r,arguments)}}),this)};Node.prototype._init=function init(e){var t=this._baseState;s(t.parent===null);e.call(this);t.children=t.children.filter((function(e){return e._baseState.parent===this}),this);s.equal(t.children.length,1,"Root node can have only one child")};Node.prototype._useArgs=function useArgs(e){var t=this._baseState;var r=e.filter((function(e){return e instanceof this.constructor}),this);e=e.filter((function(e){return!(e instanceof this.constructor)}),this);if(r.length!==0){s(t.children===null);t.children=r;r.forEach((function(e){e._baseState.parent=this}),this)}if(e.length!==0){s(t.args===null);t.args=e;t.reverseArgs=e.map((function(e){if(typeof e!=="object"||e.constructor!==Object)return e;var t={};Object.keys(e).forEach((function(r){if(r==(r|0))r|=0;var i=e[r];t[i]=r}));return t}))}};u.forEach((function(e){Node.prototype[e]=function _overrided(){var t=this._baseState;throw new Error(e+" not implemented for encoding: "+t.enc)}}));o.forEach((function(e){Node.prototype[e]=function _tagMethod(){var t=this._baseState;var r=Array.prototype.slice.call(arguments);s(t.tag===null);t.tag=e;this._useArgs(r);return this}}));Node.prototype.use=function use(e){s(e);var t=this._baseState;s(t.use===null);t.use=e;return this};Node.prototype.optional=function optional(){var e=this._baseState;e.optional=true;return this};Node.prototype.def=function def(e){var t=this._baseState;s(t["default"]===null);t["default"]=e;t.optional=true;return this};Node.prototype.explicit=function explicit(e){var t=this._baseState;s(t.explicit===null&&t.implicit===null);t.explicit=e;return this};Node.prototype.implicit=function implicit(e){var t=this._baseState;s(t.explicit===null&&t.implicit===null);t.implicit=e;return this};Node.prototype.obj=function obj(){var e=this._baseState;var t=Array.prototype.slice.call(arguments);e.obj=true;if(t.length!==0)this._useArgs(t);return this};Node.prototype.key=function key(e){var t=this._baseState;s(t.key===null);t.key=e;return this};Node.prototype.any=function any(){var e=this._baseState;e.any=true;return this};Node.prototype.choice=function choice(e){var t=this._baseState;s(t.choice===null);t.choice=e;this._useArgs(Object.keys(e).map((function(t){return e[t]})));return this};Node.prototype.contains=function contains(e){var t=this._baseState;s(t.use===null);t.contains=e;return this};Node.prototype._decode=function decode(e,t){var r=this._baseState;if(r.parent===null)return e.wrapResult(r.children[0]._decode(e,t));var i=r["default"];var n=true;var s=null;if(r.key!==null)s=e.enterKey(r.key);if(r.optional){var o=null;if(r.explicit!==null)o=r.explicit;else if(r.implicit!==null)o=r.implicit;else if(r.tag!==null)o=r.tag;if(o===null&&!r.any){var h=e.save();try{if(r.choice===null)this._decodeGeneric(r.tag,e,t);else this._decodeChoice(e,t);n=true}catch(e){n=false}e.restore(h)}else{n=this._peekTag(e,o,r.any);if(e.isError(n))return n}}var u;if(r.obj&&n)u=e.enterObject();if(n){if(r.explicit!==null){var d=this._decodeTag(e,r.explicit);if(e.isError(d))return d;e=d}var c=e.offset;if(r.use===null&&r.choice===null){if(r.any)var h=e.save();var l=this._decodeTag(e,r.implicit!==null?r.implicit:r.tag,r.any);if(e.isError(l))return l;if(r.any)i=e.raw(h);else e=l}if(t&&t.track&&r.tag!==null)t.track(e.path(),c,e.length,"tagged");if(t&&t.track&&r.tag!==null)t.track(e.path(),e.offset,e.length,"content");if(r.any)i=i;else if(r.choice===null)i=this._decodeGeneric(r.tag,e,t);else i=this._decodeChoice(e,t);if(e.isError(i))return i;if(!r.any&&r.choice===null&&r.children!==null){r.children.forEach((function decodeChildren(r){r._decode(e,t)}))}if(r.contains&&(r.tag==="octstr"||r.tag==="bitstr")){var p=new a(i);i=this._getUse(r.contains,e._reporterState.obj)._decode(p,t)}}if(r.obj&&n)i=e.leaveObject(u);if(r.key!==null&&(i!==null||n===true))e.leaveKey(s,r.key,i);else if(s!==null)e.exitKey(s);return i};Node.prototype._decodeGeneric=function decodeGeneric(e,t,r){var i=this._baseState;if(e==="seq"||e==="set")return null;if(e==="seqof"||e==="setof")return this._decodeList(t,e,i.args[0],r);else if(/str$/.test(e))return this._decodeStr(t,e,r);else if(e==="objid"&&i.args)return this._decodeObjid(t,i.args[0],i.args[1],r);else if(e==="objid")return this._decodeObjid(t,null,null,r);else if(e==="gentime"||e==="utctime")return this._decodeTime(t,e,r);else if(e==="null_")return this._decodeNull(t,r);else if(e==="bool")return this._decodeBool(t,r);else if(e==="objDesc")return this._decodeStr(t,e,r);else if(e==="int"||e==="enum")return this._decodeInt(t,i.args&&i.args[0],r);if(i.use!==null){return this._getUse(i.use,t._reporterState.obj)._decode(t,r)}else{return t.error("unknown tag: "+e)}};Node.prototype._getUse=function _getUse(e,t){var r=this._baseState;r.useDecoder=this._use(e,t);s(r.useDecoder._baseState.parent===null);r.useDecoder=r.useDecoder._baseState.children[0];if(r.implicit!==r.useDecoder._baseState.implicit){r.useDecoder=r.useDecoder.clone();r.useDecoder._baseState.implicit=r.implicit}return r.useDecoder};Node.prototype._decodeChoice=function decodeChoice(e,t){var r=this._baseState;var i=null;var n=false;Object.keys(r.choice).some((function(a){var s=e.save();var o=r.choice[a];try{var h=o._decode(e,t);if(e.isError(h))return false;i={type:a,value:h};n=true}catch(t){e.restore(s);return false}return true}),this);if(!n)return e.error("Choice not matched");return i};Node.prototype._createEncoderBuffer=function createEncoderBuffer(e){return new n(e,this.reporter)};Node.prototype._encode=function encode(e,t,r){var i=this._baseState;if(i["default"]!==null&&i["default"]===e)return;var n=this._encodeValue(e,t,r);if(n===undefined)return;if(this._skipDefault(n,t,r))return;return n};Node.prototype._encodeValue=function encode(e,t,r){var n=this._baseState;if(n.parent===null)return n.children[0]._encode(e,t||new i);var a=null;this.reporter=t;if(n.optional&&e===undefined){if(n["default"]!==null)e=n["default"];else return}var s=null;var o=false;if(n.any){a=this._createEncoderBuffer(e)}else if(n.choice){a=this._encodeChoice(e,t)}else if(n.contains){s=this._getUse(n.contains,r)._encode(e,t);o=true}else if(n.children){s=n.children.map((function(r){if(r._baseState.tag==="null_")return r._encode(null,t,e);if(r._baseState.key===null)return t.error("Child should have a key");var i=t.enterKey(r._baseState.key);if(typeof e!=="object")return t.error("Child expected, but input is not object");var n=r._encode(e[r._baseState.key],t,e);t.leaveKey(i);return n}),this).filter((function(e){return e}));s=this._createEncoderBuffer(s)}else{if(n.tag==="seqof"||n.tag==="setof"){if(!(n.args&&n.args.length===1))return t.error("Too many args for : "+n.tag);if(!Array.isArray(e))return t.error("seqof/setof, but data is not Array");var h=this.clone();h._baseState.implicit=null;s=this._createEncoderBuffer(e.map((function(r){var i=this._baseState;return this._getUse(i.args[0],e)._encode(r,t)}),h))}else if(n.use!==null){a=this._getUse(n.use,r)._encode(e,t)}else{s=this._encodePrimitive(n.tag,e);o=true}}var a;if(!n.any&&n.choice===null){var u=n.implicit!==null?n.implicit:n.tag;var d=n.implicit===null?"universal":"context";if(u===null){if(n.use===null)t.error("Tag could be omitted only for .use()")}else{if(n.use===null)a=this._encodeComposite(u,o,d,s)}}if(n.explicit!==null)a=this._encodeComposite(n.explicit,false,"context",a);return a};Node.prototype._encodeChoice=function encodeChoice(e,t){var r=this._baseState;var i=r.choice[e.type];if(!i){s(false,e.type+" not found in "+JSON.stringify(Object.keys(r.choice)))}return i._encode(e.value,t)};Node.prototype._encodePrimitive=function encodePrimitive(e,t){var r=this._baseState;if(/str$/.test(e))return this._encodeStr(t,e);else if(e==="objid"&&r.args)return this._encodeObjid(t,r.reverseArgs[0],r.args[1]);else if(e==="objid")return this._encodeObjid(t,null,null);else if(e==="gentime"||e==="utctime")return this._encodeTime(t,e);else if(e==="null_")return this._encodeNull();else if(e==="int"||e==="enum")return this._encodeInt(t,r.args&&r.reverseArgs[0]);else if(e==="bool")return this._encodeBool(t);else if(e==="objDesc")return this._encodeStr(t,e);else throw new Error("Unsupported tag: "+e)};Node.prototype._isNumstr=function isNumstr(e){return/^[0-9 ]*$/.test(e)};Node.prototype._isPrintstr=function isPrintstr(e){return/^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(e)}},1293:function(e,t,r){var i=r(3782);function Reporter(e){this._reporterState={obj:null,path:[],options:e||{},errors:[]}}t.b=Reporter;Reporter.prototype.isError=function isError(e){return e instanceof ReporterError};Reporter.prototype.save=function save(){var e=this._reporterState;return{obj:e.obj,pathLen:e.path.length}};Reporter.prototype.restore=function restore(e){var t=this._reporterState;t.obj=e.obj;t.path=t.path.slice(0,e.pathLen)};Reporter.prototype.enterKey=function enterKey(e){return this._reporterState.path.push(e)};Reporter.prototype.exitKey=function exitKey(e){var t=this._reporterState;t.path=t.path.slice(0,e-1)};Reporter.prototype.leaveKey=function leaveKey(e,t,r){var i=this._reporterState;this.exitKey(e);if(i.obj!==null)i.obj[t]=r};Reporter.prototype.path=function path(){return this._reporterState.path.join("/")};Reporter.prototype.enterObject=function enterObject(){var e=this._reporterState;var t=e.obj;e.obj={};return t};Reporter.prototype.leaveObject=function leaveObject(e){var t=this._reporterState;var r=t.obj;t.obj=e;return r};Reporter.prototype.error=function error(e){var t;var r=this._reporterState;var i=e instanceof ReporterError;if(i){t=e}else{t=new ReporterError(r.path.map((function(e){return"["+JSON.stringify(e)+"]"})).join(""),e.message||e,e.stack)}if(!r.options.partial)throw t;if(!i)r.errors.push(t);return t};Reporter.prototype.wrapResult=function wrapResult(e){var t=this._reporterState;if(!t.options.partial)return e;return{result:this.isError(e)?null:e,errors:t.errors}};function ReporterError(e,t){this.path=e;this.rethrow(t)}i(ReporterError,Error);ReporterError.prototype.rethrow=function rethrow(e){this.message=e+" at: "+(this.path||"(shallow)");if(Error.captureStackTrace)Error.captureStackTrace(this,ReporterError);if(!this.stack){try{throw new Error(this.message)}catch(e){this.stack=e.stack}}return this}},9791:function(e,t,r){var i=r(7335);t.tagClass={0:"universal",1:"application",2:"context",3:"private"};t.tagClassByName=i._reverse(t.tagClass);t.tag={0:"end",1:"bool",2:"int",3:"bitstr",4:"octstr",5:"null_",6:"objid",7:"objDesc",8:"external",9:"real",10:"enum",11:"embed",12:"utf8str",13:"relativeOid",16:"seq",17:"set",18:"numstr",19:"printstr",20:"t61str",21:"videostr",22:"ia5str",23:"utctime",24:"gentime",25:"graphstr",26:"iso646str",27:"genstr",28:"unistr",29:"charstr",30:"bmpstr"};t.tagByName=i._reverse(t.tag)},7335:function(e,t,r){var i=t;i._reverse=function reverse(e){var t={};Object.keys(e).forEach((function(r){if((r|0)==r)r=r|0;var i=e[r];t[i]=r}));return t};i.der=r(9791)},2259:function(e,t,r){var i=r(3782);var n=r(7160);var a=n.base;var s=n.bignum;var o=n.constants.der;function DERDecoder(e){this.enc="der";this.name=e.name;this.entity=e;this.tree=new DERNode;this.tree._init(e.body)}e.exports=DERDecoder;DERDecoder.prototype.decode=function decode(e,t){if(!(e instanceof a.DecoderBuffer))e=new a.DecoderBuffer(e,t);return this.tree._decode(e,t)};function DERNode(e){a.Node.call(this,"der",e)}i(DERNode,a.Node);DERNode.prototype._peekTag=function peekTag(e,t,r){if(e.isEmpty())return false;var i=e.save();var n=derDecodeTag(e,'Failed to peek tag: "'+t+'"');if(e.isError(n))return n;e.restore(i);return n.tag===t||n.tagStr===t||n.tagStr+"of"===t||r};DERNode.prototype._decodeTag=function decodeTag(e,t,r){var i=derDecodeTag(e,'Failed to decode tag of "'+t+'"');if(e.isError(i))return i;var n=derDecodeLen(e,i.primitive,'Failed to get length of "'+t+'"');if(e.isError(n))return n;if(!r&&i.tag!==t&&i.tagStr!==t&&i.tagStr+"of"!==t){return e.error('Failed to match tag: "'+t+'"')}if(i.primitive||n!==null)return e.skip(n,'Failed to match body of: "'+t+'"');var a=e.save();var s=this._skipUntilEnd(e,'Failed to skip indefinite length body: "'+this.tag+'"');if(e.isError(s))return s;n=e.offset-a.offset;e.restore(a);return e.skip(n,'Failed to match body of: "'+t+'"')};DERNode.prototype._skipUntilEnd=function skipUntilEnd(e,t){while(true){var r=derDecodeTag(e,t);if(e.isError(r))return r;var i=derDecodeLen(e,r.primitive,t);if(e.isError(i))return i;var n;if(r.primitive||i!==null)n=e.skip(i);else n=this._skipUntilEnd(e,t);if(e.isError(n))return n;if(r.tagStr==="end")break}};DERNode.prototype._decodeList=function decodeList(e,t,r,i){var n=[];while(!e.isEmpty()){var a=this._peekTag(e,"end");if(e.isError(a))return a;var s=r.decode(e,"der",i);if(e.isError(s)&&a)break;n.push(s)}return n};DERNode.prototype._decodeStr=function decodeStr(e,t){if(t==="bitstr"){var r=e.readUInt8();if(e.isError(r))return r;return{unused:r,data:e.raw()}}else if(t==="bmpstr"){var i=e.raw();if(i.length%2===1)return e.error("Decoding of string type: bmpstr length mismatch");var n="";for(var a=0;a<i.length/2;a++){n+=String.fromCharCode(i.readUInt16BE(a*2))}return n}else if(t==="numstr"){var s=e.raw().toString("ascii");if(!this._isNumstr(s)){return e.error("Decoding of string type: "+"numstr unsupported characters")}return s}else if(t==="octstr"){return e.raw()}else if(t==="objDesc"){return e.raw()}else if(t==="printstr"){var o=e.raw().toString("ascii");if(!this._isPrintstr(o)){return e.error("Decoding of string type: "+"printstr unsupported characters")}return o}else if(/str$/.test(t)){return e.raw().toString()}else{return e.error("Decoding of string type: "+t+" unsupported")}};DERNode.prototype._decodeObjid=function decodeObjid(e,t,r){var i;var n=[];var a=0;while(!e.isEmpty()){var s=e.readUInt8();a<<=7;a|=s&127;if((s&128)===0){n.push(a);a=0}}if(s&128)n.push(a);var o=n[0]/40|0;var h=n[0]%40;if(r)i=n;else i=[o,h].concat(n.slice(1));if(t){var u=t[i.join(" ")];if(u===undefined)u=t[i.join(".")];if(u!==undefined)i=u}return i};DERNode.prototype._decodeTime=function decodeTime(e,t){var r=e.raw().toString();if(t==="gentime"){var i=r.slice(0,4)|0;var n=r.slice(4,6)|0;var a=r.slice(6,8)|0;var s=r.slice(8,10)|0;var o=r.slice(10,12)|0;var h=r.slice(12,14)|0}else if(t==="utctime"){var i=r.slice(0,2)|0;var n=r.slice(2,4)|0;var a=r.slice(4,6)|0;var s=r.slice(6,8)|0;var o=r.slice(8,10)|0;var h=r.slice(10,12)|0;if(i<70)i=2e3+i;else i=1900+i}else{return e.error("Decoding "+t+" time is not supported yet")}return Date.UTC(i,n-1,a,s,o,h,0)};DERNode.prototype._decodeNull=function decodeNull(e){return null};DERNode.prototype._decodeBool=function decodeBool(e){var t=e.readUInt8();if(e.isError(t))return t;else return t!==0};DERNode.prototype._decodeInt=function decodeInt(e,t){var r=e.raw();var i=new s(r);if(t)i=t[i.toString(10)]||i;return i};DERNode.prototype._use=function use(e,t){if(typeof e==="function")e=e(t);return e._getDecoder("der").tree};function derDecodeTag(e,t){var r=e.readUInt8(t);if(e.isError(r))return r;var i=o.tagClass[r>>6];var n=(r&32)===0;if((r&31)===31){var a=r;r=0;while((a&128)===128){a=e.readUInt8(t);if(e.isError(a))return a;r<<=7;r|=a&127}}else{r&=31}var s=o.tag[r];return{cls:i,primitive:n,tag:r,tagStr:s}}function derDecodeLen(e,t,r){var i=e.readUInt8(r);if(e.isError(i))return i;if(!t&&i===128)return null;if((i&128)===0){return i}var n=i&127;if(n>4)return e.error("length octect is too long");i=0;for(var a=0;a<n;a++){i<<=8;var s=e.readUInt8(r);if(e.isError(s))return s;i|=s}return i}},6701:function(e,t,r){var i=t;i.der=r(2259);i.pem=r(8527)},8527:function(e,t,r){var i=r(3782);var n=r(4300).Buffer;var a=r(2259);function PEMDecoder(e){a.call(this,e);this.enc="pem"}i(PEMDecoder,a);e.exports=PEMDecoder;PEMDecoder.prototype.decode=function decode(e,t){var r=e.toString().split(/[\r\n]+/g);var i=t.label.toUpperCase();var s=/^-----(BEGIN|END) ([^-]+)-----$/;var o=-1;var h=-1;for(var u=0;u<r.length;u++){var d=r[u].match(s);if(d===null)continue;if(d[2]!==i)continue;if(o===-1){if(d[1]!=="BEGIN")break;o=u}else{if(d[1]!=="END")break;h=u;break}}if(o===-1||h===-1)throw new Error("PEM section not found for: "+i);var c=r.slice(o+1,h).join("");c.replace(/[^a-z0-9\+\/=]+/gi,"");var l=new n(c,"base64");return a.prototype.decode.call(this,l,t)}},7804:function(e,t,r){var i=r(3782);var n=r(4300).Buffer;var a=r(7160);var s=a.base;var o=a.constants.der;function DEREncoder(e){this.enc="der";this.name=e.name;this.entity=e;this.tree=new DERNode;this.tree._init(e.body)}e.exports=DEREncoder;DEREncoder.prototype.encode=function encode(e,t){return this.tree._encode(e,t).join()};function DERNode(e){s.Node.call(this,"der",e)}i(DERNode,s.Node);DERNode.prototype._encodeComposite=function encodeComposite(e,t,r,i){var a=encodeTag(e,t,r,this.reporter);if(i.length<128){var s=new n(2);s[0]=a;s[1]=i.length;return this._createEncoderBuffer([s,i])}var o=1;for(var h=i.length;h>=256;h>>=8)o++;var s=new n(1+1+o);s[0]=a;s[1]=128|o;for(var h=1+o,u=i.length;u>0;h--,u>>=8)s[h]=u&255;return this._createEncoderBuffer([s,i])};DERNode.prototype._encodeStr=function encodeStr(e,t){if(t==="bitstr"){return this._createEncoderBuffer([e.unused|0,e.data])}else if(t==="bmpstr"){var r=new n(e.length*2);for(var i=0;i<e.length;i++){r.writeUInt16BE(e.charCodeAt(i),i*2)}return this._createEncoderBuffer(r)}else if(t==="numstr"){if(!this._isNumstr(e)){return this.reporter.error("Encoding of string type: numstr supports "+"only digits and space")}return this._createEncoderBuffer(e)}else if(t==="printstr"){if(!this._isPrintstr(e)){return this.reporter.error("Encoding of string type: printstr supports "+"only latin upper and lower case letters, "+"digits, space, apostrophe, left and rigth "+"parenthesis, plus sign, comma, hyphen, "+"dot, slash, colon, equal sign, "+"question mark")}return this._createEncoderBuffer(e)}else if(/str$/.test(t)){return this._createEncoderBuffer(e)}else if(t==="objDesc"){return this._createEncoderBuffer(e)}else{return this.reporter.error("Encoding of string type: "+t+" unsupported")}};DERNode.prototype._encodeObjid=function encodeObjid(e,t,r){if(typeof e==="string"){if(!t)return this.reporter.error("string objid given, but no values map found");if(!t.hasOwnProperty(e))return this.reporter.error("objid not found in values map");e=t[e].split(/[\s\.]+/g);for(var i=0;i<e.length;i++)e[i]|=0}else if(Array.isArray(e)){e=e.slice();for(var i=0;i<e.length;i++)e[i]|=0}if(!Array.isArray(e)){return this.reporter.error("objid() should be either array or string, "+"got: "+JSON.stringify(e))}if(!r){if(e[1]>=40)return this.reporter.error("Second objid identifier OOB");e.splice(0,2,e[0]*40+e[1])}var a=0;for(var i=0;i<e.length;i++){var s=e[i];for(a++;s>=128;s>>=7)a++}var o=new n(a);var h=o.length-1;for(var i=e.length-1;i>=0;i--){var s=e[i];o[h--]=s&127;while((s>>=7)>0)o[h--]=128|s&127}return this._createEncoderBuffer(o)};function two(e){if(e<10)return"0"+e;else return e}DERNode.prototype._encodeTime=function encodeTime(e,t){var r;var i=new Date(e);if(t==="gentime"){r=[two(i.getFullYear()),two(i.getUTCMonth()+1),two(i.getUTCDate()),two(i.getUTCHours()),two(i.getUTCMinutes()),two(i.getUTCSeconds()),"Z"].join("")}else if(t==="utctime"){r=[two(i.getFullYear()%100),two(i.getUTCMonth()+1),two(i.getUTCDate()),two(i.getUTCHours()),two(i.getUTCMinutes()),two(i.getUTCSeconds()),"Z"].join("")}else{this.reporter.error("Encoding "+t+" time is not supported yet")}return this._encodeStr(r,"octstr")};DERNode.prototype._encodeNull=function encodeNull(){return this._createEncoderBuffer("")};DERNode.prototype._encodeInt=function encodeInt(e,t){if(typeof e==="string"){if(!t)return this.reporter.error("String int or enum given, but no values map");if(!t.hasOwnProperty(e)){return this.reporter.error("Values map doesn't contain: "+JSON.stringify(e))}e=t[e]}if(typeof e!=="number"&&!n.isBuffer(e)){var r=e.toArray();if(!e.sign&&r[0]&128){r.unshift(0)}e=new n(r)}if(n.isBuffer(e)){var i=e.length;if(e.length===0)i++;var a=new n(i);e.copy(a);if(e.length===0)a[0]=0;return this._createEncoderBuffer(a)}if(e<128)return this._createEncoderBuffer(e);if(e<256)return this._createEncoderBuffer([0,e]);var i=1;for(var s=e;s>=256;s>>=8)i++;var a=new Array(i);for(var s=a.length-1;s>=0;s--){a[s]=e&255;e>>=8}if(a[0]&128){a.unshift(0)}return this._createEncoderBuffer(new n(a))};DERNode.prototype._encodeBool=function encodeBool(e){return this._createEncoderBuffer(e?255:0)};DERNode.prototype._use=function use(e,t){if(typeof e==="function")e=e(t);return e._getEncoder("der").tree};DERNode.prototype._skipDefault=function skipDefault(e,t,r){var i=this._baseState;var n;if(i["default"]===null)return false;var a=e.join();if(i.defaultBuffer===undefined)i.defaultBuffer=this._encodeValue(i["default"],t,r).join();if(a.length!==i.defaultBuffer.length)return false;for(n=0;n<a.length;n++)if(a[n]!==i.defaultBuffer[n])return false;return true};function encodeTag(e,t,r,i){var n;if(e==="seqof")e="seq";else if(e==="setof")e="set";if(o.tagByName.hasOwnProperty(e))n=o.tagByName[e];else if(typeof e==="number"&&(e|0)===e)n=e;else return i.error("Unknown tag: "+e);if(n>=31)return i.error("Multi-octet tag encoding unsupported");if(!t)n|=32;n|=o.tagClassByName[r||"universal"]<<6;return n}},3418:function(e,t,r){var i=t;i.der=r(7804);i.pem=r(1564)},1564:function(e,t,r){var i=r(3782);var n=r(7804);function PEMEncoder(e){n.call(this,e);this.enc="pem"}i(PEMEncoder,n);e.exports=PEMEncoder;PEMEncoder.prototype.encode=function encode(e,t){var r=n.prototype.encode.call(this,e);var i=r.toString("base64");var a=["-----BEGIN "+t.label+"-----"];for(var s=0;s<i.length;s+=64)a.push(i.slice(s,s+64));a.push("-----END "+t.label+"-----");return a.join("\n")}},711:function(e,t,r){e=r.nmd(e);(function(e,t){"use strict";function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}function inherits(e,t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}function BN(e,t,r){if(BN.isBN(e)){return e}this.negative=0;this.words=null;this.length=0;this.red=null;if(e!==null){if(t==="le"||t==="be"){r=t;t=10}this._init(e||0,t||10,r||"be")}}if(typeof e==="object"){e.exports=BN}else{t.BN=BN}BN.BN=BN;BN.wordSize=26;var i;try{i=r(4300).Buffer}catch(e){}BN.isBN=function isBN(e){if(e instanceof BN){return true}return e!==null&&typeof e==="object"&&e.constructor.wordSize===BN.wordSize&&Array.isArray(e.words)};BN.max=function max(e,t){if(e.cmp(t)>0)return e;return t};BN.min=function min(e,t){if(e.cmp(t)<0)return e;return t};BN.prototype._init=function init(e,t,r){if(typeof e==="number"){return this._initNumber(e,t,r)}if(typeof e==="object"){return this._initArray(e,t,r)}if(t==="hex"){t=16}assert(t===(t|0)&&t>=2&&t<=36);e=e.toString().replace(/\s+/g,"");var i=0;if(e[0]==="-"){i++}if(t===16){this._parseHex(e,i)}else{this._parseBase(e,t,i)}if(e[0]==="-"){this.negative=1}this.strip();if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initNumber=function _initNumber(e,t,r){if(e<0){this.negative=1;e=-e}if(e<67108864){this.words=[e&67108863];this.length=1}else if(e<4503599627370496){this.words=[e&67108863,e/67108864&67108863];this.length=2}else{assert(e<9007199254740992);this.words=[e&67108863,e/67108864&67108863,1];this.length=3}if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initArray=function _initArray(e,t,r){assert(typeof e.length==="number");if(e.length<=0){this.words=[0];this.length=1;return this}this.length=Math.ceil(e.length/3);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0}var n,a;var s=0;if(r==="be"){for(i=e.length-1,n=0;i>=0;i-=3){a=e[i]|e[i-1]<<8|e[i-2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}else if(r==="le"){for(i=0,n=0;i<e.length;i+=3){a=e[i]|e[i+1]<<8|e[i+2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}return this.strip()};function parseHex(e,t,r){var i=0;var n=Math.min(e.length,r);for(var a=t;a<n;a++){var s=e.charCodeAt(a)-48;i<<=4;if(s>=49&&s<=54){i|=s-49+10}else if(s>=17&&s<=22){i|=s-17+10}else{i|=s&15}}return i}BN.prototype._parseHex=function _parseHex(e,t){this.length=Math.ceil((e.length-t)/6);this.words=new Array(this.length);for(var r=0;r<this.length;r++){this.words[r]=0}var i,n;var a=0;for(r=e.length-6,i=0;r>=t;r-=6){n=parseHex(e,r,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303;a+=24;if(a>=26){a-=26;i++}}if(r+6!==t){n=parseHex(e,t,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303}this.strip()};function parseBase(e,t,r,i){var n=0;var a=Math.min(e.length,r);for(var s=t;s<a;s++){var o=e.charCodeAt(s)-48;n*=i;if(o>=49){n+=o-49+10}else if(o>=17){n+=o-17+10}else{n+=o}}return n}BN.prototype._parseBase=function _parseBase(e,t,r){this.words=[0];this.length=1;for(var i=0,n=1;n<=67108863;n*=t){i++}i--;n=n/t|0;var a=e.length-r;var s=a%i;var o=Math.min(a,a-s)+r;var h=0;for(var u=r;u<o;u+=i){h=parseBase(e,u,u+i,t);this.imuln(n);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}if(s!==0){var d=1;h=parseBase(e,u,e.length,t);for(u=0;u<s;u++){d*=t}this.imuln(d);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}};BN.prototype.copy=function copy(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++){e.words[t]=this.words[t]}e.length=this.length;e.negative=this.negative;e.red=this.red};BN.prototype.clone=function clone(){var e=new BN(null);this.copy(e);return e};BN.prototype._expand=function _expand(e){while(this.length<e){this.words[this.length++]=0}return this};BN.prototype.strip=function strip(){while(this.length>1&&this.words[this.length-1]===0){this.length--}return this._normSign()};BN.prototype._normSign=function _normSign(){if(this.length===1&&this.words[0]===0){this.negative=0}return this};BN.prototype.inspect=function inspect(){return(this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"};var n=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"];var a=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];var s=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];BN.prototype.toString=function toString(e,t){e=e||10;t=t|0||1;var r;if(e===16||e==="hex"){r="";var i=0;var o=0;for(var h=0;h<this.length;h++){var u=this.words[h];var d=((u<<i|o)&16777215).toString(16);o=u>>>24-i&16777215;if(o!==0||h!==this.length-1){r=n[6-d.length]+d+r}else{r=d+r}i+=2;if(i>=26){i-=26;h--}}if(o!==0){r=o.toString(16)+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}if(e===(e|0)&&e>=2&&e<=36){var c=a[e];var l=s[e];r="";var p=this.clone();p.negative=0;while(!p.isZero()){var v=p.modn(l).toString(e);p=p.idivn(l);if(!p.isZero()){r=n[c-v.length]+v+r}else{r=v+r}}if(this.isZero()){r="0"+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}assert(false,"Base should be between 2 and 36")};BN.prototype.toNumber=function toNumber(){var e=this.words[0];if(this.length===2){e+=this.words[1]*67108864}else if(this.length===3&&this.words[2]===1){e+=4503599627370496+this.words[1]*67108864}else if(this.length>2){assert(false,"Number can only safely store up to 53 bits")}return this.negative!==0?-e:e};BN.prototype.toJSON=function toJSON(){return this.toString(16)};BN.prototype.toBuffer=function toBuffer(e,t){assert(typeof i!=="undefined");return this.toArrayLike(i,e,t)};BN.prototype.toArray=function toArray(e,t){return this.toArrayLike(Array,e,t)};BN.prototype.toArrayLike=function toArrayLike(e,t,r){var i=this.byteLength();var n=r||Math.max(1,i);assert(i<=n,"byte array longer than desired length");assert(n>0,"Requested array length <= 0");this.strip();var a=t==="le";var s=new e(n);var o,h;var u=this.clone();if(!a){for(h=0;h<n-i;h++){s[h]=0}for(h=0;!u.isZero();h++){o=u.andln(255);u.iushrn(8);s[n-h-1]=o}}else{for(h=0;!u.isZero();h++){o=u.andln(255);u.iushrn(8);s[h]=o}for(;h<n;h++){s[h]=0}}return s};if(Math.clz32){BN.prototype._countBits=function _countBits(e){return 32-Math.clz32(e)}}else{BN.prototype._countBits=function _countBits(e){var t=e;var r=0;if(t>=4096){r+=13;t>>>=13}if(t>=64){r+=7;t>>>=7}if(t>=8){r+=4;t>>>=4}if(t>=2){r+=2;t>>>=2}return r+t}}BN.prototype._zeroBits=function _zeroBits(e){if(e===0)return 26;var t=e;var r=0;if((t&8191)===0){r+=13;t>>>=13}if((t&127)===0){r+=7;t>>>=7}if((t&15)===0){r+=4;t>>>=4}if((t&3)===0){r+=2;t>>>=2}if((t&1)===0){r++}return r};BN.prototype.bitLength=function bitLength(){var e=this.words[this.length-1];var t=this._countBits(e);return(this.length-1)*26+t};function toBitArray(e){var t=new Array(e.bitLength());for(var r=0;r<t.length;r++){var i=r/26|0;var n=r%26;t[r]=(e.words[i]&1<<n)>>>n}return t}BN.prototype.zeroBits=function zeroBits(){if(this.isZero())return 0;var e=0;for(var t=0;t<this.length;t++){var r=this._zeroBits(this.words[t]);e+=r;if(r!==26)break}return e};BN.prototype.byteLength=function byteLength(){return Math.ceil(this.bitLength()/8)};BN.prototype.toTwos=function toTwos(e){if(this.negative!==0){return this.abs().inotn(e).iaddn(1)}return this.clone()};BN.prototype.fromTwos=function fromTwos(e){if(this.testn(e-1)){return this.notn(e).iaddn(1).ineg()}return this.clone()};BN.prototype.isNeg=function isNeg(){return this.negative!==0};BN.prototype.neg=function neg(){return this.clone().ineg()};BN.prototype.ineg=function ineg(){if(!this.isZero()){this.negative^=1}return this};BN.prototype.iuor=function iuor(e){while(this.length<e.length){this.words[this.length++]=0}for(var t=0;t<e.length;t++){this.words[t]=this.words[t]|e.words[t]}return this.strip()};BN.prototype.ior=function ior(e){assert((this.negative|e.negative)===0);return this.iuor(e)};BN.prototype.or=function or(e){if(this.length>e.length)return this.clone().ior(e);return e.clone().ior(this)};BN.prototype.uor=function uor(e){if(this.length>e.length)return this.clone().iuor(e);return e.clone().iuor(this)};BN.prototype.iuand=function iuand(e){var t;if(this.length>e.length){t=e}else{t=this}for(var r=0;r<t.length;r++){this.words[r]=this.words[r]&e.words[r]}this.length=t.length;return this.strip()};BN.prototype.iand=function iand(e){assert((this.negative|e.negative)===0);return this.iuand(e)};BN.prototype.and=function and(e){if(this.length>e.length)return this.clone().iand(e);return e.clone().iand(this)};BN.prototype.uand=function uand(e){if(this.length>e.length)return this.clone().iuand(e);return e.clone().iuand(this)};BN.prototype.iuxor=function iuxor(e){var t;var r;if(this.length>e.length){t=this;r=e}else{t=e;r=this}for(var i=0;i<r.length;i++){this.words[i]=t.words[i]^r.words[i]}if(this!==t){for(;i<t.length;i++){this.words[i]=t.words[i]}}this.length=t.length;return this.strip()};BN.prototype.ixor=function ixor(e){assert((this.negative|e.negative)===0);return this.iuxor(e)};BN.prototype.xor=function xor(e){if(this.length>e.length)return this.clone().ixor(e);return e.clone().ixor(this)};BN.prototype.uxor=function uxor(e){if(this.length>e.length)return this.clone().iuxor(e);return e.clone().iuxor(this)};BN.prototype.inotn=function inotn(e){assert(typeof e==="number"&&e>=0);var t=Math.ceil(e/26)|0;var r=e%26;this._expand(t);if(r>0){t--}for(var i=0;i<t;i++){this.words[i]=~this.words[i]&67108863}if(r>0){this.words[i]=~this.words[i]&67108863>>26-r}return this.strip()};BN.prototype.notn=function notn(e){return this.clone().inotn(e)};BN.prototype.setn=function setn(e,t){assert(typeof e==="number"&&e>=0);var r=e/26|0;var i=e%26;this._expand(r+1);if(t){this.words[r]=this.words[r]|1<<i}else{this.words[r]=this.words[r]&~(1<<i)}return this.strip()};BN.prototype.iadd=function iadd(e){var t;if(this.negative!==0&&e.negative===0){this.negative=0;t=this.isub(e);this.negative^=1;return this._normSign()}else if(this.negative===0&&e.negative!==0){e.negative=0;t=this.isub(e);e.negative=1;return t._normSign()}var r,i;if(this.length>e.length){r=this;i=e}else{r=e;i=this}var n=0;for(var a=0;a<i.length;a++){t=(r.words[a]|0)+(i.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}for(;n!==0&&a<r.length;a++){t=(r.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}this.length=r.length;if(n!==0){this.words[this.length]=n;this.length++}else if(r!==this){for(;a<r.length;a++){this.words[a]=r.words[a]}}return this};BN.prototype.add=function add(e){var t;if(e.negative!==0&&this.negative===0){e.negative=0;t=this.sub(e);e.negative^=1;return t}else if(e.negative===0&&this.negative!==0){this.negative=0;t=e.sub(this);this.negative=1;return t}if(this.length>e.length)return this.clone().iadd(e);return e.clone().iadd(this)};BN.prototype.isub=function isub(e){if(e.negative!==0){e.negative=0;var t=this.iadd(e);e.negative=1;return t._normSign()}else if(this.negative!==0){this.negative=0;this.iadd(e);this.negative=1;return this._normSign()}var r=this.cmp(e);if(r===0){this.negative=0;this.length=1;this.words[0]=0;return this}var i,n;if(r>0){i=this;n=e}else{i=e;n=this}var a=0;for(var s=0;s<n.length;s++){t=(i.words[s]|0)-(n.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}for(;a!==0&&s<i.length;s++){t=(i.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}if(a===0&&s<i.length&&i!==this){for(;s<i.length;s++){this.words[s]=i.words[s]}}this.length=Math.max(this.length,s);if(i!==this){this.negative=1}return this.strip()};BN.prototype.sub=function sub(e){return this.clone().isub(e)};function smallMulTo(e,t,r){r.negative=t.negative^e.negative;var i=e.length+t.length|0;r.length=i;i=i-1|0;var n=e.words[0]|0;var a=t.words[0]|0;var s=n*a;var o=s&67108863;var h=s/67108864|0;r.words[0]=o;for(var u=1;u<i;u++){var d=h>>>26;var c=h&67108863;var l=Math.min(u,t.length-1);for(var p=Math.max(0,u-e.length+1);p<=l;p++){var v=u-p|0;n=e.words[v]|0;a=t.words[p]|0;s=n*a+c;d+=s/67108864|0;c=s&67108863}r.words[u]=c|0;h=d|0}if(h!==0){r.words[u]=h|0}else{r.length--}return r.strip()}var o=function comb10MulTo(e,t,r){var i=e.words;var n=t.words;var a=r.words;var s=0;var o;var h;var u;var d=i[0]|0;var c=d&8191;var l=d>>>13;var p=i[1]|0;var v=p&8191;var b=p>>>13;var m=i[2]|0;var y=m&8191;var g=m>>>13;var _=i[3]|0;var w=_&8191;var M=_>>>13;var B=i[4]|0;var E=B&8191;var k=B>>>13;var A=i[5]|0;var N=A&8191;var P=A>>>13;var x=i[6]|0;var I=x&8191;var C=x>>>13;var D=i[7]|0;var T=D&8191;var j=D>>>13;var q=i[8]|0;var O=q&8191;var H=q>>>13;var L=i[9]|0;var z=L&8191;var F=L>>>13;var U=n[0]|0;var W=U&8191;var V=U>>>13;var G=n[1]|0;var J=G&8191;var Z=G>>>13;var X=n[2]|0;var Y=X&8191;var $=X>>>13;var Q=n[3]|0;var ee=Q&8191;var te=Q>>>13;var re=n[4]|0;var ie=re&8191;var ne=re>>>13;var ae=n[5]|0;var fe=ae&8191;var se=ae>>>13;var oe=n[6]|0;var he=oe&8191;var ue=oe>>>13;var de=n[7]|0;var ce=de&8191;var le=de>>>13;var pe=n[8]|0;var ve=pe&8191;var be=pe>>>13;var me=n[9]|0;var ye=me&8191;var ge=me>>>13;r.negative=e.negative^t.negative;r.length=19;o=Math.imul(c,W);h=Math.imul(c,V);h=h+Math.imul(l,W)|0;u=Math.imul(l,V);var _e=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(_e>>>26)|0;_e&=67108863;o=Math.imul(v,W);h=Math.imul(v,V);h=h+Math.imul(b,W)|0;u=Math.imul(b,V);o=o+Math.imul(c,J)|0;h=h+Math.imul(c,Z)|0;h=h+Math.imul(l,J)|0;u=u+Math.imul(l,Z)|0;var we=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(we>>>26)|0;we&=67108863;o=Math.imul(y,W);h=Math.imul(y,V);h=h+Math.imul(g,W)|0;u=Math.imul(g,V);o=o+Math.imul(v,J)|0;h=h+Math.imul(v,Z)|0;h=h+Math.imul(b,J)|0;u=u+Math.imul(b,Z)|0;o=o+Math.imul(c,Y)|0;h=h+Math.imul(c,$)|0;h=h+Math.imul(l,Y)|0;u=u+Math.imul(l,$)|0;var Me=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Me>>>26)|0;Me&=67108863;o=Math.imul(w,W);h=Math.imul(w,V);h=h+Math.imul(M,W)|0;u=Math.imul(M,V);o=o+Math.imul(y,J)|0;h=h+Math.imul(y,Z)|0;h=h+Math.imul(g,J)|0;u=u+Math.imul(g,Z)|0;o=o+Math.imul(v,Y)|0;h=h+Math.imul(v,$)|0;h=h+Math.imul(b,Y)|0;u=u+Math.imul(b,$)|0;o=o+Math.imul(c,ee)|0;h=h+Math.imul(c,te)|0;h=h+Math.imul(l,ee)|0;u=u+Math.imul(l,te)|0;var Se=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Se>>>26)|0;Se&=67108863;o=Math.imul(E,W);h=Math.imul(E,V);h=h+Math.imul(k,W)|0;u=Math.imul(k,V);o=o+Math.imul(w,J)|0;h=h+Math.imul(w,Z)|0;h=h+Math.imul(M,J)|0;u=u+Math.imul(M,Z)|0;o=o+Math.imul(y,Y)|0;h=h+Math.imul(y,$)|0;h=h+Math.imul(g,Y)|0;u=u+Math.imul(g,$)|0;o=o+Math.imul(v,ee)|0;h=h+Math.imul(v,te)|0;h=h+Math.imul(b,ee)|0;u=u+Math.imul(b,te)|0;o=o+Math.imul(c,ie)|0;h=h+Math.imul(c,ne)|0;h=h+Math.imul(l,ie)|0;u=u+Math.imul(l,ne)|0;var Be=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Be>>>26)|0;Be&=67108863;o=Math.imul(N,W);h=Math.imul(N,V);h=h+Math.imul(P,W)|0;u=Math.imul(P,V);o=o+Math.imul(E,J)|0;h=h+Math.imul(E,Z)|0;h=h+Math.imul(k,J)|0;u=u+Math.imul(k,Z)|0;o=o+Math.imul(w,Y)|0;h=h+Math.imul(w,$)|0;h=h+Math.imul(M,Y)|0;u=u+Math.imul(M,$)|0;o=o+Math.imul(y,ee)|0;h=h+Math.imul(y,te)|0;h=h+Math.imul(g,ee)|0;u=u+Math.imul(g,te)|0;o=o+Math.imul(v,ie)|0;h=h+Math.imul(v,ne)|0;h=h+Math.imul(b,ie)|0;u=u+Math.imul(b,ne)|0;o=o+Math.imul(c,fe)|0;h=h+Math.imul(c,se)|0;h=h+Math.imul(l,fe)|0;u=u+Math.imul(l,se)|0;var Ee=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ee>>>26)|0;Ee&=67108863;o=Math.imul(I,W);h=Math.imul(I,V);h=h+Math.imul(C,W)|0;u=Math.imul(C,V);o=o+Math.imul(N,J)|0;h=h+Math.imul(N,Z)|0;h=h+Math.imul(P,J)|0;u=u+Math.imul(P,Z)|0;o=o+Math.imul(E,Y)|0;h=h+Math.imul(E,$)|0;h=h+Math.imul(k,Y)|0;u=u+Math.imul(k,$)|0;o=o+Math.imul(w,ee)|0;h=h+Math.imul(w,te)|0;h=h+Math.imul(M,ee)|0;u=u+Math.imul(M,te)|0;o=o+Math.imul(y,ie)|0;h=h+Math.imul(y,ne)|0;h=h+Math.imul(g,ie)|0;u=u+Math.imul(g,ne)|0;o=o+Math.imul(v,fe)|0;h=h+Math.imul(v,se)|0;h=h+Math.imul(b,fe)|0;u=u+Math.imul(b,se)|0;o=o+Math.imul(c,he)|0;h=h+Math.imul(c,ue)|0;h=h+Math.imul(l,he)|0;u=u+Math.imul(l,ue)|0;var ke=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(ke>>>26)|0;ke&=67108863;o=Math.imul(T,W);h=Math.imul(T,V);h=h+Math.imul(j,W)|0;u=Math.imul(j,V);o=o+Math.imul(I,J)|0;h=h+Math.imul(I,Z)|0;h=h+Math.imul(C,J)|0;u=u+Math.imul(C,Z)|0;o=o+Math.imul(N,Y)|0;h=h+Math.imul(N,$)|0;h=h+Math.imul(P,Y)|0;u=u+Math.imul(P,$)|0;o=o+Math.imul(E,ee)|0;h=h+Math.imul(E,te)|0;h=h+Math.imul(k,ee)|0;u=u+Math.imul(k,te)|0;o=o+Math.imul(w,ie)|0;h=h+Math.imul(w,ne)|0;h=h+Math.imul(M,ie)|0;u=u+Math.imul(M,ne)|0;o=o+Math.imul(y,fe)|0;h=h+Math.imul(y,se)|0;h=h+Math.imul(g,fe)|0;u=u+Math.imul(g,se)|0;o=o+Math.imul(v,he)|0;h=h+Math.imul(v,ue)|0;h=h+Math.imul(b,he)|0;u=u+Math.imul(b,ue)|0;o=o+Math.imul(c,ce)|0;h=h+Math.imul(c,le)|0;h=h+Math.imul(l,ce)|0;u=u+Math.imul(l,le)|0;var Ae=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ae>>>26)|0;Ae&=67108863;o=Math.imul(O,W);h=Math.imul(O,V);h=h+Math.imul(H,W)|0;u=Math.imul(H,V);o=o+Math.imul(T,J)|0;h=h+Math.imul(T,Z)|0;h=h+Math.imul(j,J)|0;u=u+Math.imul(j,Z)|0;o=o+Math.imul(I,Y)|0;h=h+Math.imul(I,$)|0;h=h+Math.imul(C,Y)|0;u=u+Math.imul(C,$)|0;o=o+Math.imul(N,ee)|0;h=h+Math.imul(N,te)|0;h=h+Math.imul(P,ee)|0;u=u+Math.imul(P,te)|0;o=o+Math.imul(E,ie)|0;h=h+Math.imul(E,ne)|0;h=h+Math.imul(k,ie)|0;u=u+Math.imul(k,ne)|0;o=o+Math.imul(w,fe)|0;h=h+Math.imul(w,se)|0;h=h+Math.imul(M,fe)|0;u=u+Math.imul(M,se)|0;o=o+Math.imul(y,he)|0;h=h+Math.imul(y,ue)|0;h=h+Math.imul(g,he)|0;u=u+Math.imul(g,ue)|0;o=o+Math.imul(v,ce)|0;h=h+Math.imul(v,le)|0;h=h+Math.imul(b,ce)|0;u=u+Math.imul(b,le)|0;o=o+Math.imul(c,ve)|0;h=h+Math.imul(c,be)|0;h=h+Math.imul(l,ve)|0;u=u+Math.imul(l,be)|0;var Ne=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ne>>>26)|0;Ne&=67108863;o=Math.imul(z,W);h=Math.imul(z,V);h=h+Math.imul(F,W)|0;u=Math.imul(F,V);o=o+Math.imul(O,J)|0;h=h+Math.imul(O,Z)|0;h=h+Math.imul(H,J)|0;u=u+Math.imul(H,Z)|0;o=o+Math.imul(T,Y)|0;h=h+Math.imul(T,$)|0;h=h+Math.imul(j,Y)|0;u=u+Math.imul(j,$)|0;o=o+Math.imul(I,ee)|0;h=h+Math.imul(I,te)|0;h=h+Math.imul(C,ee)|0;u=u+Math.imul(C,te)|0;o=o+Math.imul(N,ie)|0;h=h+Math.imul(N,ne)|0;h=h+Math.imul(P,ie)|0;u=u+Math.imul(P,ne)|0;o=o+Math.imul(E,fe)|0;h=h+Math.imul(E,se)|0;h=h+Math.imul(k,fe)|0;u=u+Math.imul(k,se)|0;o=o+Math.imul(w,he)|0;h=h+Math.imul(w,ue)|0;h=h+Math.imul(M,he)|0;u=u+Math.imul(M,ue)|0;o=o+Math.imul(y,ce)|0;h=h+Math.imul(y,le)|0;h=h+Math.imul(g,ce)|0;u=u+Math.imul(g,le)|0;o=o+Math.imul(v,ve)|0;h=h+Math.imul(v,be)|0;h=h+Math.imul(b,ve)|0;u=u+Math.imul(b,be)|0;o=o+Math.imul(c,ye)|0;h=h+Math.imul(c,ge)|0;h=h+Math.imul(l,ye)|0;u=u+Math.imul(l,ge)|0;var Re=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Re>>>26)|0;Re&=67108863;o=Math.imul(z,J);h=Math.imul(z,Z);h=h+Math.imul(F,J)|0;u=Math.imul(F,Z);o=o+Math.imul(O,Y)|0;h=h+Math.imul(O,$)|0;h=h+Math.imul(H,Y)|0;u=u+Math.imul(H,$)|0;o=o+Math.imul(T,ee)|0;h=h+Math.imul(T,te)|0;h=h+Math.imul(j,ee)|0;u=u+Math.imul(j,te)|0;o=o+Math.imul(I,ie)|0;h=h+Math.imul(I,ne)|0;h=h+Math.imul(C,ie)|0;u=u+Math.imul(C,ne)|0;o=o+Math.imul(N,fe)|0;h=h+Math.imul(N,se)|0;h=h+Math.imul(P,fe)|0;u=u+Math.imul(P,se)|0;o=o+Math.imul(E,he)|0;h=h+Math.imul(E,ue)|0;h=h+Math.imul(k,he)|0;u=u+Math.imul(k,ue)|0;o=o+Math.imul(w,ce)|0;h=h+Math.imul(w,le)|0;h=h+Math.imul(M,ce)|0;u=u+Math.imul(M,le)|0;o=o+Math.imul(y,ve)|0;h=h+Math.imul(y,be)|0;h=h+Math.imul(g,ve)|0;u=u+Math.imul(g,be)|0;o=o+Math.imul(v,ye)|0;h=h+Math.imul(v,ge)|0;h=h+Math.imul(b,ye)|0;u=u+Math.imul(b,ge)|0;var Pe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Pe>>>26)|0;Pe&=67108863;o=Math.imul(z,Y);h=Math.imul(z,$);h=h+Math.imul(F,Y)|0;u=Math.imul(F,$);o=o+Math.imul(O,ee)|0;h=h+Math.imul(O,te)|0;h=h+Math.imul(H,ee)|0;u=u+Math.imul(H,te)|0;o=o+Math.imul(T,ie)|0;h=h+Math.imul(T,ne)|0;h=h+Math.imul(j,ie)|0;u=u+Math.imul(j,ne)|0;o=o+Math.imul(I,fe)|0;h=h+Math.imul(I,se)|0;h=h+Math.imul(C,fe)|0;u=u+Math.imul(C,se)|0;o=o+Math.imul(N,he)|0;h=h+Math.imul(N,ue)|0;h=h+Math.imul(P,he)|0;u=u+Math.imul(P,ue)|0;o=o+Math.imul(E,ce)|0;h=h+Math.imul(E,le)|0;h=h+Math.imul(k,ce)|0;u=u+Math.imul(k,le)|0;o=o+Math.imul(w,ve)|0;h=h+Math.imul(w,be)|0;h=h+Math.imul(M,ve)|0;u=u+Math.imul(M,be)|0;o=o+Math.imul(y,ye)|0;h=h+Math.imul(y,ge)|0;h=h+Math.imul(g,ye)|0;u=u+Math.imul(g,ge)|0;var xe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(xe>>>26)|0;xe&=67108863;o=Math.imul(z,ee);h=Math.imul(z,te);h=h+Math.imul(F,ee)|0;u=Math.imul(F,te);o=o+Math.imul(O,ie)|0;h=h+Math.imul(O,ne)|0;h=h+Math.imul(H,ie)|0;u=u+Math.imul(H,ne)|0;o=o+Math.imul(T,fe)|0;h=h+Math.imul(T,se)|0;h=h+Math.imul(j,fe)|0;u=u+Math.imul(j,se)|0;o=o+Math.imul(I,he)|0;h=h+Math.imul(I,ue)|0;h=h+Math.imul(C,he)|0;u=u+Math.imul(C,ue)|0;o=o+Math.imul(N,ce)|0;h=h+Math.imul(N,le)|0;h=h+Math.imul(P,ce)|0;u=u+Math.imul(P,le)|0;o=o+Math.imul(E,ve)|0;h=h+Math.imul(E,be)|0;h=h+Math.imul(k,ve)|0;u=u+Math.imul(k,be)|0;o=o+Math.imul(w,ye)|0;h=h+Math.imul(w,ge)|0;h=h+Math.imul(M,ye)|0;u=u+Math.imul(M,ge)|0;var Ie=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ie>>>26)|0;Ie&=67108863;o=Math.imul(z,ie);h=Math.imul(z,ne);h=h+Math.imul(F,ie)|0;u=Math.imul(F,ne);o=o+Math.imul(O,fe)|0;h=h+Math.imul(O,se)|0;h=h+Math.imul(H,fe)|0;u=u+Math.imul(H,se)|0;o=o+Math.imul(T,he)|0;h=h+Math.imul(T,ue)|0;h=h+Math.imul(j,he)|0;u=u+Math.imul(j,ue)|0;o=o+Math.imul(I,ce)|0;h=h+Math.imul(I,le)|0;h=h+Math.imul(C,ce)|0;u=u+Math.imul(C,le)|0;o=o+Math.imul(N,ve)|0;h=h+Math.imul(N,be)|0;h=h+Math.imul(P,ve)|0;u=u+Math.imul(P,be)|0;o=o+Math.imul(E,ye)|0;h=h+Math.imul(E,ge)|0;h=h+Math.imul(k,ye)|0;u=u+Math.imul(k,ge)|0;var Ce=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ce>>>26)|0;Ce&=67108863;o=Math.imul(z,fe);h=Math.imul(z,se);h=h+Math.imul(F,fe)|0;u=Math.imul(F,se);o=o+Math.imul(O,he)|0;h=h+Math.imul(O,ue)|0;h=h+Math.imul(H,he)|0;u=u+Math.imul(H,ue)|0;o=o+Math.imul(T,ce)|0;h=h+Math.imul(T,le)|0;h=h+Math.imul(j,ce)|0;u=u+Math.imul(j,le)|0;o=o+Math.imul(I,ve)|0;h=h+Math.imul(I,be)|0;h=h+Math.imul(C,ve)|0;u=u+Math.imul(C,be)|0;o=o+Math.imul(N,ye)|0;h=h+Math.imul(N,ge)|0;h=h+Math.imul(P,ye)|0;u=u+Math.imul(P,ge)|0;var De=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(De>>>26)|0;De&=67108863;o=Math.imul(z,he);h=Math.imul(z,ue);h=h+Math.imul(F,he)|0;u=Math.imul(F,ue);o=o+Math.imul(O,ce)|0;h=h+Math.imul(O,le)|0;h=h+Math.imul(H,ce)|0;u=u+Math.imul(H,le)|0;o=o+Math.imul(T,ve)|0;h=h+Math.imul(T,be)|0;h=h+Math.imul(j,ve)|0;u=u+Math.imul(j,be)|0;o=o+Math.imul(I,ye)|0;h=h+Math.imul(I,ge)|0;h=h+Math.imul(C,ye)|0;u=u+Math.imul(C,ge)|0;var Te=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Te>>>26)|0;Te&=67108863;o=Math.imul(z,ce);h=Math.imul(z,le);h=h+Math.imul(F,ce)|0;u=Math.imul(F,le);o=o+Math.imul(O,ve)|0;h=h+Math.imul(O,be)|0;h=h+Math.imul(H,ve)|0;u=u+Math.imul(H,be)|0;o=o+Math.imul(T,ye)|0;h=h+Math.imul(T,ge)|0;h=h+Math.imul(j,ye)|0;u=u+Math.imul(j,ge)|0;var je=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(je>>>26)|0;je&=67108863;o=Math.imul(z,ve);h=Math.imul(z,be);h=h+Math.imul(F,ve)|0;u=Math.imul(F,be);o=o+Math.imul(O,ye)|0;h=h+Math.imul(O,ge)|0;h=h+Math.imul(H,ye)|0;u=u+Math.imul(H,ge)|0;var qe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(qe>>>26)|0;qe&=67108863;o=Math.imul(z,ye);h=Math.imul(z,ge);h=h+Math.imul(F,ye)|0;u=Math.imul(F,ge);var Oe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Oe>>>26)|0;Oe&=67108863;a[0]=_e;a[1]=we;a[2]=Me;a[3]=Se;a[4]=Be;a[5]=Ee;a[6]=ke;a[7]=Ae;a[8]=Ne;a[9]=Re;a[10]=Pe;a[11]=xe;a[12]=Ie;a[13]=Ce;a[14]=De;a[15]=Te;a[16]=je;a[17]=qe;a[18]=Oe;if(s!==0){a[19]=s;r.length++}return r};if(!Math.imul){o=smallMulTo}function bigMulTo(e,t,r){r.negative=t.negative^e.negative;r.length=e.length+t.length;var i=0;var n=0;for(var a=0;a<r.length-1;a++){var s=n;n=0;var o=i&67108863;var h=Math.min(a,t.length-1);for(var u=Math.max(0,a-e.length+1);u<=h;u++){var d=a-u;var c=e.words[d]|0;var l=t.words[u]|0;var p=c*l;var v=p&67108863;s=s+(p/67108864|0)|0;v=v+o|0;o=v&67108863;s=s+(v>>>26)|0;n+=s>>>26;s&=67108863}r.words[a]=o;i=s;s=n}if(i!==0){r.words[a]=i}else{r.length--}return r.strip()}function jumboMulTo(e,t,r){var i=new FFTM;return i.mulp(e,t,r)}BN.prototype.mulTo=function mulTo(e,t){var r;var i=this.length+e.length;if(this.length===10&&e.length===10){r=o(this,e,t)}else if(i<63){r=smallMulTo(this,e,t)}else if(i<1024){r=bigMulTo(this,e,t)}else{r=jumboMulTo(this,e,t)}return r};function FFTM(e,t){this.x=e;this.y=t}FFTM.prototype.makeRBT=function makeRBT(e){var t=new Array(e);var r=BN.prototype._countBits(e)-1;for(var i=0;i<e;i++){t[i]=this.revBin(i,r,e)}return t};FFTM.prototype.revBin=function revBin(e,t,r){if(e===0||e===r-1)return e;var i=0;for(var n=0;n<t;n++){i|=(e&1)<<t-n-1;e>>=1}return i};FFTM.prototype.permute=function permute(e,t,r,i,n,a){for(var s=0;s<a;s++){i[s]=t[e[s]];n[s]=r[e[s]]}};FFTM.prototype.transform=function transform(e,t,r,i,n,a){this.permute(a,e,t,r,i,n);for(var s=1;s<n;s<<=1){var o=s<<1;var h=Math.cos(2*Math.PI/o);var u=Math.sin(2*Math.PI/o);for(var d=0;d<n;d+=o){var c=h;var l=u;for(var p=0;p<s;p++){var v=r[d+p];var b=i[d+p];var m=r[d+p+s];var y=i[d+p+s];var g=c*m-l*y;y=c*y+l*m;m=g;r[d+p]=v+m;i[d+p]=b+y;r[d+p+s]=v-m;i[d+p+s]=b-y;if(p!==o){g=h*c-u*l;l=h*l+u*c;c=g}}}}};FFTM.prototype.guessLen13b=function guessLen13b(e,t){var r=Math.max(t,e)|1;var i=r&1;var n=0;for(r=r/2|0;r;r=r>>>1){n++}return 1<<n+1+i};FFTM.prototype.conjugate=function conjugate(e,t,r){if(r<=1)return;for(var i=0;i<r/2;i++){var n=e[i];e[i]=e[r-i-1];e[r-i-1]=n;n=t[i];t[i]=-t[r-i-1];t[r-i-1]=-n}};FFTM.prototype.normalize13b=function normalize13b(e,t){var r=0;for(var i=0;i<t/2;i++){var n=Math.round(e[2*i+1]/t)*8192+Math.round(e[2*i]/t)+r;e[i]=n&67108863;if(n<67108864){r=0}else{r=n/67108864|0}}return e};FFTM.prototype.convert13b=function convert13b(e,t,r,i){var n=0;for(var a=0;a<t;a++){n=n+(e[a]|0);r[2*a]=n&8191;n=n>>>13;r[2*a+1]=n&8191;n=n>>>13}for(a=2*t;a<i;++a){r[a]=0}assert(n===0);assert((n&~8191)===0)};FFTM.prototype.stub=function stub(e){var t=new Array(e);for(var r=0;r<e;r++){t[r]=0}return t};FFTM.prototype.mulp=function mulp(e,t,r){var i=2*this.guessLen13b(e.length,t.length);var n=this.makeRBT(i);var a=this.stub(i);var s=new Array(i);var o=new Array(i);var h=new Array(i);var u=new Array(i);var d=new Array(i);var c=new Array(i);var l=r.words;l.length=i;this.convert13b(e.words,e.length,s,i);this.convert13b(t.words,t.length,u,i);this.transform(s,a,o,h,i,n);this.transform(u,a,d,c,i,n);for(var p=0;p<i;p++){var v=o[p]*d[p]-h[p]*c[p];h[p]=o[p]*c[p]+h[p]*d[p];o[p]=v}this.conjugate(o,h,i);this.transform(o,h,l,a,i,n);this.conjugate(l,a,i);this.normalize13b(l,i);r.negative=e.negative^t.negative;r.length=e.length+t.length;return r.strip()};BN.prototype.mul=function mul(e){var t=new BN(null);t.words=new Array(this.length+e.length);return this.mulTo(e,t)};BN.prototype.mulf=function mulf(e){var t=new BN(null);t.words=new Array(this.length+e.length);return jumboMulTo(this,e,t)};BN.prototype.imul=function imul(e){return this.clone().mulTo(e,this)};BN.prototype.imuln=function imuln(e){assert(typeof e==="number");assert(e<67108864);var t=0;for(var r=0;r<this.length;r++){var i=(this.words[r]|0)*e;var n=(i&67108863)+(t&67108863);t>>=26;t+=i/67108864|0;t+=n>>>26;this.words[r]=n&67108863}if(t!==0){this.words[r]=t;this.length++}return this};BN.prototype.muln=function muln(e){return this.clone().imuln(e)};BN.prototype.sqr=function sqr(){return this.mul(this)};BN.prototype.isqr=function isqr(){return this.imul(this.clone())};BN.prototype.pow=function pow(e){var t=toBitArray(e);if(t.length===0)return new BN(1);var r=this;for(var i=0;i<t.length;i++,r=r.sqr()){if(t[i]!==0)break}if(++i<t.length){for(var n=r.sqr();i<t.length;i++,n=n.sqr()){if(t[i]===0)continue;r=r.mul(n)}}return r};BN.prototype.iushln=function iushln(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=67108863>>>26-t<<26-t;var n;if(t!==0){var a=0;for(n=0;n<this.length;n++){var s=this.words[n]&i;var o=(this.words[n]|0)-s<<t;this.words[n]=o|a;a=s>>>26-t}if(a){this.words[n]=a;this.length++}}if(r!==0){for(n=this.length-1;n>=0;n--){this.words[n+r]=this.words[n]}for(n=0;n<r;n++){this.words[n]=0}this.length+=r}return this.strip()};BN.prototype.ishln=function ishln(e){assert(this.negative===0);return this.iushln(e)};BN.prototype.iushrn=function iushrn(e,t,r){assert(typeof e==="number"&&e>=0);var i;if(t){i=(t-t%26)/26}else{i=0}var n=e%26;var a=Math.min((e-n)/26,this.length);var s=67108863^67108863>>>n<<n;var o=r;i-=a;i=Math.max(0,i);if(o){for(var h=0;h<a;h++){o.words[h]=this.words[h]}o.length=a}if(a===0){}else if(this.length>a){this.length-=a;for(h=0;h<this.length;h++){this.words[h]=this.words[h+a]}}else{this.words[0]=0;this.length=1}var u=0;for(h=this.length-1;h>=0&&(u!==0||h>=i);h--){var d=this.words[h]|0;this.words[h]=u<<26-n|d>>>n;u=d&s}if(o&&u!==0){o.words[o.length++]=u}if(this.length===0){this.words[0]=0;this.length=1}return this.strip()};BN.prototype.ishrn=function ishrn(e,t,r){assert(this.negative===0);return this.iushrn(e,t,r)};BN.prototype.shln=function shln(e){return this.clone().ishln(e)};BN.prototype.ushln=function ushln(e){return this.clone().iushln(e)};BN.prototype.shrn=function shrn(e){return this.clone().ishrn(e)};BN.prototype.ushrn=function ushrn(e){return this.clone().iushrn(e)};BN.prototype.testn=function testn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r)return false;var n=this.words[r];return!!(n&i)};BN.prototype.imaskn=function imaskn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;assert(this.negative===0,"imaskn works only with positive numbers");if(this.length<=r){return this}if(t!==0){r++}this.length=Math.min(r,this.length);if(t!==0){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i}return this.strip()};BN.prototype.maskn=function maskn(e){return this.clone().imaskn(e)};BN.prototype.iaddn=function iaddn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.isubn(-e);if(this.negative!==0){if(this.length===1&&(this.words[0]|0)<e){this.words[0]=e-(this.words[0]|0);this.negative=0;return this}this.negative=0;this.isubn(e);this.negative=1;return this}return this._iaddn(e)};BN.prototype._iaddn=function _iaddn(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++){this.words[t]-=67108864;if(t===this.length-1){this.words[t+1]=1}else{this.words[t+1]++}}this.length=Math.max(this.length,t+1);return this};BN.prototype.isubn=function isubn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.iaddn(-e);if(this.negative!==0){this.negative=0;this.iaddn(e);this.negative=1;return this}this.words[0]-=e;if(this.length===1&&this.words[0]<0){this.words[0]=-this.words[0];this.negative=1}else{for(var t=0;t<this.length&&this.words[t]<0;t++){this.words[t]+=67108864;this.words[t+1]-=1}}return this.strip()};BN.prototype.addn=function addn(e){return this.clone().iaddn(e)};BN.prototype.subn=function subn(e){return this.clone().isubn(e)};BN.prototype.iabs=function iabs(){this.negative=0;return this};BN.prototype.abs=function abs(){return this.clone().iabs()};BN.prototype._ishlnsubmul=function _ishlnsubmul(e,t,r){var i=e.length+r;var n;this._expand(i);var a;var s=0;for(n=0;n<e.length;n++){a=(this.words[n+r]|0)+s;var o=(e.words[n]|0)*t;a-=o&67108863;s=(a>>26)-(o/67108864|0);this.words[n+r]=a&67108863}for(;n<this.length-r;n++){a=(this.words[n+r]|0)+s;s=a>>26;this.words[n+r]=a&67108863}if(s===0)return this.strip();assert(s===-1);s=0;for(n=0;n<this.length;n++){a=-(this.words[n]|0)+s;s=a>>26;this.words[n]=a&67108863}this.negative=1;return this.strip()};BN.prototype._wordDiv=function _wordDiv(e,t){var r=this.length-e.length;var i=this.clone();var n=e;var a=n.words[n.length-1]|0;var s=this._countBits(a);r=26-s;if(r!==0){n=n.ushln(r);i.iushln(r);a=n.words[n.length-1]|0}var o=i.length-n.length;var h;if(t!=="mod"){h=new BN(null);h.length=o+1;h.words=new Array(h.length);for(var u=0;u<h.length;u++){h.words[u]=0}}var d=i.clone()._ishlnsubmul(n,1,o);if(d.negative===0){i=d;if(h){h.words[o]=1}}for(var c=o-1;c>=0;c--){var l=(i.words[n.length+c]|0)*67108864+(i.words[n.length+c-1]|0);l=Math.min(l/a|0,67108863);i._ishlnsubmul(n,l,c);while(i.negative!==0){l--;i.negative=0;i._ishlnsubmul(n,1,c);if(!i.isZero()){i.negative^=1}}if(h){h.words[c]=l}}if(h){h.strip()}i.strip();if(t!=="div"&&r!==0){i.iushrn(r)}return{div:h||null,mod:i}};BN.prototype.divmod=function divmod(e,t,r){assert(!e.isZero());if(this.isZero()){return{div:new BN(0),mod:new BN(0)}}var i,n,a;if(this.negative!==0&&e.negative===0){a=this.neg().divmod(e,t);if(t!=="mod"){i=a.div.neg()}if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.iadd(e)}}return{div:i,mod:n}}if(this.negative===0&&e.negative!==0){a=this.divmod(e.neg(),t);if(t!=="mod"){i=a.div.neg()}return{div:i,mod:a.mod}}if((this.negative&e.negative)!==0){a=this.neg().divmod(e.neg(),t);if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.isub(e)}}return{div:a.div,mod:n}}if(e.length>this.length||this.cmp(e)<0){return{div:new BN(0),mod:this}}if(e.length===1){if(t==="div"){return{div:this.divn(e.words[0]),mod:null}}if(t==="mod"){return{div:null,mod:new BN(this.modn(e.words[0]))}}return{div:this.divn(e.words[0]),mod:new BN(this.modn(e.words[0]))}}return this._wordDiv(e,t)};BN.prototype.div=function div(e){return this.divmod(e,"div",false).div};BN.prototype.mod=function mod(e){return this.divmod(e,"mod",false).mod};BN.prototype.umod=function umod(e){return this.divmod(e,"mod",true).mod};BN.prototype.divRound=function divRound(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var r=t.div.negative!==0?t.mod.isub(e):t.mod;var i=e.ushrn(1);var n=e.andln(1);var a=r.cmp(i);if(a<0||n===1&&a===0)return t.div;return t.div.negative!==0?t.div.isubn(1):t.div.iaddn(1)};BN.prototype.modn=function modn(e){assert(e<=67108863);var t=(1<<26)%e;var r=0;for(var i=this.length-1;i>=0;i--){r=(t*r+(this.words[i]|0))%e}return r};BN.prototype.idivn=function idivn(e){assert(e<=67108863);var t=0;for(var r=this.length-1;r>=0;r--){var i=(this.words[r]|0)+t*67108864;this.words[r]=i/e|0;t=i%e}return this.strip()};BN.prototype.divn=function divn(e){return this.clone().idivn(e)};BN.prototype.egcd=function egcd(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=new BN(0);var s=new BN(1);var o=0;while(t.isEven()&&r.isEven()){t.iushrn(1);r.iushrn(1);++o}var h=r.clone();var u=t.clone();while(!t.isZero()){for(var d=0,c=1;(t.words[0]&c)===0&&d<26;++d,c<<=1);if(d>0){t.iushrn(d);while(d-- >0){if(i.isOdd()||n.isOdd()){i.iadd(h);n.isub(u)}i.iushrn(1);n.iushrn(1)}}for(var l=0,p=1;(r.words[0]&p)===0&&l<26;++l,p<<=1);if(l>0){r.iushrn(l);while(l-- >0){if(a.isOdd()||s.isOdd()){a.iadd(h);s.isub(u)}a.iushrn(1);s.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(a);n.isub(s)}else{r.isub(t);a.isub(i);s.isub(n)}}return{a:a,b:s,gcd:r.iushln(o)}};BN.prototype._invmp=function _invmp(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=r.clone();while(t.cmpn(1)>0&&r.cmpn(1)>0){for(var s=0,o=1;(t.words[0]&o)===0&&s<26;++s,o<<=1);if(s>0){t.iushrn(s);while(s-- >0){if(i.isOdd()){i.iadd(a)}i.iushrn(1)}}for(var h=0,u=1;(r.words[0]&u)===0&&h<26;++h,u<<=1);if(h>0){r.iushrn(h);while(h-- >0){if(n.isOdd()){n.iadd(a)}n.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(n)}else{r.isub(t);n.isub(i)}}var d;if(t.cmpn(1)===0){d=i}else{d=n}if(d.cmpn(0)<0){d.iadd(e)}return d};BN.prototype.gcd=function gcd(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone();var r=e.clone();t.negative=0;r.negative=0;for(var i=0;t.isEven()&&r.isEven();i++){t.iushrn(1);r.iushrn(1)}do{while(t.isEven()){t.iushrn(1)}while(r.isEven()){r.iushrn(1)}var n=t.cmp(r);if(n<0){var a=t;t=r;r=a}else if(n===0||r.cmpn(1)===0){break}t.isub(r)}while(true);return r.iushln(i)};BN.prototype.invm=function invm(e){return this.egcd(e).a.umod(e)};BN.prototype.isEven=function isEven(){return(this.words[0]&1)===0};BN.prototype.isOdd=function isOdd(){return(this.words[0]&1)===1};BN.prototype.andln=function andln(e){return this.words[0]&e};BN.prototype.bincn=function bincn(e){assert(typeof e==="number");var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r){this._expand(r+1);this.words[r]|=i;return this}var n=i;for(var a=r;n!==0&&a<this.length;a++){var s=this.words[a]|0;s+=n;n=s>>>26;s&=67108863;this.words[a]=s}if(n!==0){this.words[a]=n;this.length++}return this};BN.prototype.isZero=function isZero(){return this.length===1&&this.words[0]===0};BN.prototype.cmpn=function cmpn(e){var t=e<0;if(this.negative!==0&&!t)return-1;if(this.negative===0&&t)return 1;this.strip();var r;if(this.length>1){r=1}else{if(t){e=-e}assert(e<=67108863,"Number is too big");var i=this.words[0]|0;r=i===e?0:i<e?-1:1}if(this.negative!==0)return-r|0;return r};BN.prototype.cmp=function cmp(e){if(this.negative!==0&&e.negative===0)return-1;if(this.negative===0&&e.negative!==0)return 1;var t=this.ucmp(e);if(this.negative!==0)return-t|0;return t};BN.prototype.ucmp=function ucmp(e){if(this.length>e.length)return 1;if(this.length<e.length)return-1;var t=0;for(var r=this.length-1;r>=0;r--){var i=this.words[r]|0;var n=e.words[r]|0;if(i===n)continue;if(i<n){t=-1}else if(i>n){t=1}break}return t};BN.prototype.gtn=function gtn(e){return this.cmpn(e)===1};BN.prototype.gt=function gt(e){return this.cmp(e)===1};BN.prototype.gten=function gten(e){return this.cmpn(e)>=0};BN.prototype.gte=function gte(e){return this.cmp(e)>=0};BN.prototype.ltn=function ltn(e){return this.cmpn(e)===-1};BN.prototype.lt=function lt(e){return this.cmp(e)===-1};BN.prototype.lten=function lten(e){return this.cmpn(e)<=0};BN.prototype.lte=function lte(e){return this.cmp(e)<=0};BN.prototype.eqn=function eqn(e){return this.cmpn(e)===0};BN.prototype.eq=function eq(e){return this.cmp(e)===0};BN.red=function red(e){return new Red(e)};BN.prototype.toRed=function toRed(e){assert(!this.red,"Already a number in reduction context");assert(this.negative===0,"red works only with positives");return e.convertTo(this)._forceRed(e)};BN.prototype.fromRed=function fromRed(){assert(this.red,"fromRed works only with numbers in reduction context");return this.red.convertFrom(this)};BN.prototype._forceRed=function _forceRed(e){this.red=e;return this};BN.prototype.forceRed=function forceRed(e){assert(!this.red,"Already a number in reduction context");return this._forceRed(e)};BN.prototype.redAdd=function redAdd(e){assert(this.red,"redAdd works only with red numbers");return this.red.add(this,e)};BN.prototype.redIAdd=function redIAdd(e){assert(this.red,"redIAdd works only with red numbers");return this.red.iadd(this,e)};BN.prototype.redSub=function redSub(e){assert(this.red,"redSub works only with red numbers");return this.red.sub(this,e)};BN.prototype.redISub=function redISub(e){assert(this.red,"redISub works only with red numbers");return this.red.isub(this,e)};BN.prototype.redShl=function redShl(e){assert(this.red,"redShl works only with red numbers");return this.red.shl(this,e)};BN.prototype.redMul=function redMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.mul(this,e)};BN.prototype.redIMul=function redIMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.imul(this,e)};BN.prototype.redSqr=function redSqr(){assert(this.red,"redSqr works only with red numbers");this.red._verify1(this);return this.red.sqr(this)};BN.prototype.redISqr=function redISqr(){assert(this.red,"redISqr works only with red numbers");this.red._verify1(this);return this.red.isqr(this)};BN.prototype.redSqrt=function redSqrt(){assert(this.red,"redSqrt works only with red numbers");this.red._verify1(this);return this.red.sqrt(this)};BN.prototype.redInvm=function redInvm(){assert(this.red,"redInvm works only with red numbers");this.red._verify1(this);return this.red.invm(this)};BN.prototype.redNeg=function redNeg(){assert(this.red,"redNeg works only with red numbers");this.red._verify1(this);return this.red.neg(this)};BN.prototype.redPow=function redPow(e){assert(this.red&&!e.red,"redPow(normalNum)");this.red._verify1(this);return this.red.pow(this,e)};var h={k256:null,p224:null,p192:null,p25519:null};function MPrime(e,t){this.name=e;this.p=new BN(t,16);this.n=this.p.bitLength();this.k=new BN(1).iushln(this.n).isub(this.p);this.tmp=this._tmp()}MPrime.prototype._tmp=function _tmp(){var e=new BN(null);e.words=new Array(Math.ceil(this.n/13));return e};MPrime.prototype.ireduce=function ireduce(e){var t=e;var r;do{this.split(t,this.tmp);t=this.imulK(t);t=t.iadd(this.tmp);r=t.bitLength()}while(r>this.n);var i=r<this.n?-1:t.ucmp(this.p);if(i===0){t.words[0]=0;t.length=1}else if(i>0){t.isub(this.p)}else{if(t.strip!==undefined){t.strip()}else{t._strip()}}return t};MPrime.prototype.split=function split(e,t){e.iushrn(this.n,0,t)};MPrime.prototype.imulK=function imulK(e){return e.imul(this.k)};function K256(){MPrime.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f")}inherits(K256,MPrime);K256.prototype.split=function split(e,t){var r=4194303;var i=Math.min(e.length,9);for(var n=0;n<i;n++){t.words[n]=e.words[n]}t.length=i;if(e.length<=9){e.words[0]=0;e.length=1;return}var a=e.words[9];t.words[t.length++]=a&r;for(n=10;n<e.length;n++){var s=e.words[n]|0;e.words[n-10]=(s&r)<<4|a>>>22;a=s}a>>>=22;e.words[n-10]=a;if(a===0&&e.length>10){e.length-=10}else{e.length-=9}};K256.prototype.imulK=function imulK(e){e.words[e.length]=0;e.words[e.length+1]=0;e.length+=2;var t=0;for(var r=0;r<e.length;r++){var i=e.words[r]|0;t+=i*977;e.words[r]=t&67108863;t=i*64+(t/67108864|0)}if(e.words[e.length-1]===0){e.length--;if(e.words[e.length-1]===0){e.length--}}return e};function P224(){MPrime.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001")}inherits(P224,MPrime);function P192(){MPrime.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff")}inherits(P192,MPrime);function P25519(){MPrime.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed")}inherits(P25519,MPrime);P25519.prototype.imulK=function imulK(e){var t=0;for(var r=0;r<e.length;r++){var i=(e.words[r]|0)*19+t;var n=i&67108863;i>>>=26;e.words[r]=n;t=i}if(t!==0){e.words[e.length++]=t}return e};BN._prime=function prime(e){if(h[e])return h[e];var prime;if(e==="k256"){prime=new K256}else if(e==="p224"){prime=new P224}else if(e==="p192"){prime=new P192}else if(e==="p25519"){prime=new P25519}else{throw new Error("Unknown prime "+e)}h[e]=prime;return prime};function Red(e){if(typeof e==="string"){var t=BN._prime(e);this.m=t.p;this.prime=t}else{assert(e.gtn(1),"modulus must be greater than 1");this.m=e;this.prime=null}}Red.prototype._verify1=function _verify1(e){assert(e.negative===0,"red works only with positives");assert(e.red,"red works only with red numbers")};Red.prototype._verify2=function _verify2(e,t){assert((e.negative|t.negative)===0,"red works only with positives");assert(e.red&&e.red===t.red,"red works only with red numbers")};Red.prototype.imod=function imod(e){if(this.prime)return this.prime.ireduce(e)._forceRed(this);return e.umod(this.m)._forceRed(this)};Red.prototype.neg=function neg(e){if(e.isZero()){return e.clone()}return this.m.sub(e)._forceRed(this)};Red.prototype.add=function add(e,t){this._verify2(e,t);var r=e.add(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r._forceRed(this)};Red.prototype.iadd=function iadd(e,t){this._verify2(e,t);var r=e.iadd(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r};Red.prototype.sub=function sub(e,t){this._verify2(e,t);var r=e.sub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r._forceRed(this)};Red.prototype.isub=function isub(e,t){this._verify2(e,t);var r=e.isub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r};Red.prototype.shl=function shl(e,t){this._verify1(e);return this.imod(e.ushln(t))};Red.prototype.imul=function imul(e,t){this._verify2(e,t);return this.imod(e.imul(t))};Red.prototype.mul=function mul(e,t){this._verify2(e,t);return this.imod(e.mul(t))};Red.prototype.isqr=function isqr(e){return this.imul(e,e.clone())};Red.prototype.sqr=function sqr(e){return this.mul(e,e)};Red.prototype.sqrt=function sqrt(e){if(e.isZero())return e.clone();var t=this.m.andln(3);assert(t%2===1);if(t===3){var r=this.m.add(new BN(1)).iushrn(2);return this.pow(e,r)}var i=this.m.subn(1);var n=0;while(!i.isZero()&&i.andln(1)===0){n++;i.iushrn(1)}assert(!i.isZero());var a=new BN(1).toRed(this);var s=a.redNeg();var o=this.m.subn(1).iushrn(1);var h=this.m.bitLength();h=new BN(2*h*h).toRed(this);while(this.pow(h,o).cmp(s)!==0){h.redIAdd(s)}var u=this.pow(h,i);var d=this.pow(e,i.addn(1).iushrn(1));var c=this.pow(e,i);var l=n;while(c.cmp(a)!==0){var p=c;for(var v=0;p.cmp(a)!==0;v++){p=p.redSqr()}assert(v<l);var b=this.pow(u,new BN(1).iushln(l-v-1));d=d.redMul(b);u=b.redSqr();c=c.redMul(u);l=v}return d};Red.prototype.invm=function invm(e){var t=e._invmp(this.m);if(t.negative!==0){t.negative=0;return this.imod(t).redNeg()}else{return this.imod(t)}};Red.prototype.pow=function pow(e,t){if(t.isZero())return new BN(1).toRed(this);if(t.cmpn(1)===0)return e.clone();var r=4;var i=new Array(1<<r);i[0]=new BN(1).toRed(this);i[1]=e;for(var n=2;n<i.length;n++){i[n]=this.mul(i[n-1],e)}var a=i[0];var s=0;var o=0;var h=t.bitLength()%26;if(h===0){h=26}for(n=t.length-1;n>=0;n--){var u=t.words[n];for(var d=h-1;d>=0;d--){var c=u>>d&1;if(a!==i[0]){a=this.sqr(a)}if(c===0&&s===0){o=0;continue}s<<=1;s|=c;o++;if(o!==r&&(n!==0||d!==0))continue;a=this.mul(a,i[s]);o=0;s=0}h=26}return a};Red.prototype.convertTo=function convertTo(e){var t=e.umod(this.m);return t===e?t.clone():t};Red.prototype.convertFrom=function convertFrom(e){var t=e.clone();t.red=null;return t};BN.mont=function mont(e){return new Mont(e)};function Mont(e){Red.call(this,e);this.shift=this.m.bitLength();if(this.shift%26!==0){this.shift+=26-this.shift%26}this.r=new BN(1).iushln(this.shift);this.r2=this.imod(this.r.sqr());this.rinv=this.r._invmp(this.m);this.minv=this.rinv.mul(this.r).isubn(1).div(this.m);this.minv=this.minv.umod(this.r);this.minv=this.r.sub(this.minv)}inherits(Mont,Red);Mont.prototype.convertTo=function convertTo(e){return this.imod(e.ushln(this.shift))};Mont.prototype.convertFrom=function convertFrom(e){var t=this.imod(e.mul(this.rinv));t.red=null;return t};Mont.prototype.imul=function imul(e,t){if(e.isZero()||t.isZero()){e.words[0]=0;e.length=1;return e}var r=e.imul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.mul=function mul(e,t){if(e.isZero()||t.isZero())return new BN(0)._forceRed(this);var r=e.mul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.invm=function invm(e){var t=this.imod(e._invmp(this.m).mul(this.r2));return t._forceRed(this)}})( false||e,this)},1670:function(e,t,r){e=r.nmd(e);(function(e,t){"use strict";function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}function inherits(e,t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}function BN(e,t,r){if(BN.isBN(e)){return e}this.negative=0;this.words=null;this.length=0;this.red=null;if(e!==null){if(t==="le"||t==="be"){r=t;t=10}this._init(e||0,t||10,r||"be")}}if(typeof e==="object"){e.exports=BN}else{t.BN=BN}BN.BN=BN;BN.wordSize=26;var i;try{i=r(4300).Buffer}catch(e){}BN.isBN=function isBN(e){if(e instanceof BN){return true}return e!==null&&typeof e==="object"&&e.constructor.wordSize===BN.wordSize&&Array.isArray(e.words)};BN.max=function max(e,t){if(e.cmp(t)>0)return e;return t};BN.min=function min(e,t){if(e.cmp(t)<0)return e;return t};BN.prototype._init=function init(e,t,r){if(typeof e==="number"){return this._initNumber(e,t,r)}if(typeof e==="object"){return this._initArray(e,t,r)}if(t==="hex"){t=16}assert(t===(t|0)&&t>=2&&t<=36);e=e.toString().replace(/\s+/g,"");var i=0;if(e[0]==="-"){i++}if(t===16){this._parseHex(e,i)}else{this._parseBase(e,t,i)}if(e[0]==="-"){this.negative=1}this._strip();if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initNumber=function _initNumber(e,t,r){if(e<0){this.negative=1;e=-e}if(e<67108864){this.words=[e&67108863];this.length=1}else if(e<4503599627370496){this.words=[e&67108863,e/67108864&67108863];this.length=2}else{assert(e<9007199254740992);this.words=[e&67108863,e/67108864&67108863,1];this.length=3}if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initArray=function _initArray(e,t,r){assert(typeof e.length==="number");if(e.length<=0){this.words=[0];this.length=1;return this}this.length=Math.ceil(e.length/3);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0}var n,a;var s=0;if(r==="be"){for(i=e.length-1,n=0;i>=0;i-=3){a=e[i]|e[i-1]<<8|e[i-2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}else if(r==="le"){for(i=0,n=0;i<e.length;i+=3){a=e[i]|e[i+1]<<8|e[i+2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}return this._strip()};function parseHex(e,t,r){var i=0;var n=Math.min(e.length,r);var a=0;for(var s=t;s<n;s++){var o=e.charCodeAt(s)-48;i<<=4;var h;if(o>=49&&o<=54){h=o-49+10}else if(o>=17&&o<=22){h=o-17+10}else{h=o}i|=h;a|=h}assert(!(a&240),"Invalid character in "+e);return i}BN.prototype._parseHex=function _parseHex(e,t){this.length=Math.ceil((e.length-t)/6);this.words=new Array(this.length);for(var r=0;r<this.length;r++){this.words[r]=0}var i,n;var a=0;for(r=e.length-6,i=0;r>=t;r-=6){n=parseHex(e,r,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303;a+=24;if(a>=26){a-=26;i++}}if(r+6!==t){n=parseHex(e,t,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303}this._strip()};function parseBase(e,t,r,i){var n=0;var a=0;var s=Math.min(e.length,r);for(var o=t;o<s;o++){var h=e.charCodeAt(o)-48;n*=i;if(h>=49){a=h-49+10}else if(h>=17){a=h-17+10}else{a=h}assert(h>=0&&a<i,"Invalid character");n+=a}return n}BN.prototype._parseBase=function _parseBase(e,t,r){this.words=[0];this.length=1;for(var i=0,n=1;n<=67108863;n*=t){i++}i--;n=n/t|0;var a=e.length-r;var s=a%i;var o=Math.min(a,a-s)+r;var h=0;for(var u=r;u<o;u+=i){h=parseBase(e,u,u+i,t);this.imuln(n);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}if(s!==0){var d=1;h=parseBase(e,u,e.length,t);for(u=0;u<s;u++){d*=t}this.imuln(d);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}};BN.prototype.copy=function copy(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++){e.words[t]=this.words[t]}e.length=this.length;e.negative=this.negative;e.red=this.red};function move(e,t){e.words=t.words;e.length=t.length;e.negative=t.negative;e.red=t.red}BN.prototype._move=function _move(e){move(e,this)};BN.prototype.clone=function clone(){var e=new BN(null);this.copy(e);return e};BN.prototype._expand=function _expand(e){while(this.length<e){this.words[this.length++]=0}return this};BN.prototype._strip=function strip(){while(this.length>1&&this.words[this.length-1]===0){this.length--}return this._normSign()};BN.prototype._normSign=function _normSign(){if(this.length===1&&this.words[0]===0){this.negative=0}return this};if(typeof Symbol!=="undefined"&&typeof Symbol.for==="function"){BN.prototype[Symbol.for("nodejs.util.inspect.custom")]=inspect}else{BN.prototype.inspect=inspect}function inspect(){return(this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"}var n=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"];var a=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];var s=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];BN.prototype.toString=function toString(e,t){e=e||10;t=t|0||1;var r;if(e===16||e==="hex"){r="";var i=0;var o=0;for(var h=0;h<this.length;h++){var u=this.words[h];var d=((u<<i|o)&16777215).toString(16);o=u>>>24-i&16777215;if(o!==0||h!==this.length-1){r=n[6-d.length]+d+r}else{r=d+r}i+=2;if(i>=26){i-=26;h--}}if(o!==0){r=o.toString(16)+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}if(e===(e|0)&&e>=2&&e<=36){var c=a[e];var l=s[e];r="";var p=this.clone();p.negative=0;while(!p.isZero()){var v=p.modrn(l).toString(e);p=p.idivn(l);if(!p.isZero()){r=n[c-v.length]+v+r}else{r=v+r}}if(this.isZero()){r="0"+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}assert(false,"Base should be between 2 and 36")};BN.prototype.toNumber=function toNumber(){var e=this.words[0];if(this.length===2){e+=this.words[1]*67108864}else if(this.length===3&&this.words[2]===1){e+=4503599627370496+this.words[1]*67108864}else if(this.length>2){assert(false,"Number can only safely store up to 53 bits")}return this.negative!==0?-e:e};BN.prototype.toJSON=function toJSON(){return this.toString(16,2)};if(i){BN.prototype.toBuffer=function toBuffer(e,t){return this.toArrayLike(i,e,t)}}BN.prototype.toArray=function toArray(e,t){return this.toArrayLike(Array,e,t)};var o=function allocate(e,t){if(e.allocUnsafe){return e.allocUnsafe(t)}return new e(t)};BN.prototype.toArrayLike=function toArrayLike(e,t,r){this._strip();var i=this.byteLength();var n=r||Math.max(1,i);assert(i<=n,"byte array longer than desired length");assert(n>0,"Requested array length <= 0");var a=o(e,n);var s=t==="le"?"LE":"BE";this["_toArrayLike"+s](a,i);return a};BN.prototype._toArrayLikeLE=function _toArrayLikeLE(e,t){var r=0;var i=0;for(var n=0,a=0;n<this.length;n++){var s=this.words[n]<<a|i;e[r++]=s&255;if(r<e.length){e[r++]=s>>8&255}if(r<e.length){e[r++]=s>>16&255}if(a===6){if(r<e.length){e[r++]=s>>24&255}i=0;a=0}else{i=s>>>24;a+=2}}if(r<e.length){e[r++]=i;while(r<e.length){e[r++]=0}}};BN.prototype._toArrayLikeBE=function _toArrayLikeBE(e,t){var r=e.length-1;var i=0;for(var n=0,a=0;n<this.length;n++){var s=this.words[n]<<a|i;e[r--]=s&255;if(r>=0){e[r--]=s>>8&255}if(r>=0){e[r--]=s>>16&255}if(a===6){if(r>=0){e[r--]=s>>24&255}i=0;a=0}else{i=s>>>24;a+=2}}if(r>=0){e[r--]=i;while(r>=0){e[r--]=0}}};if(Math.clz32){BN.prototype._countBits=function _countBits(e){return 32-Math.clz32(e)}}else{BN.prototype._countBits=function _countBits(e){var t=e;var r=0;if(t>=4096){r+=13;t>>>=13}if(t>=64){r+=7;t>>>=7}if(t>=8){r+=4;t>>>=4}if(t>=2){r+=2;t>>>=2}return r+t}}BN.prototype._zeroBits=function _zeroBits(e){if(e===0)return 26;var t=e;var r=0;if((t&8191)===0){r+=13;t>>>=13}if((t&127)===0){r+=7;t>>>=7}if((t&15)===0){r+=4;t>>>=4}if((t&3)===0){r+=2;t>>>=2}if((t&1)===0){r++}return r};BN.prototype.bitLength=function bitLength(){var e=this.words[this.length-1];var t=this._countBits(e);return(this.length-1)*26+t};function toBitArray(e){var t=new Array(e.bitLength());for(var r=0;r<t.length;r++){var i=r/26|0;var n=r%26;t[r]=e.words[i]>>>n&1}return t}BN.prototype.zeroBits=function zeroBits(){if(this.isZero())return 0;var e=0;for(var t=0;t<this.length;t++){var r=this._zeroBits(this.words[t]);e+=r;if(r!==26)break}return e};BN.prototype.byteLength=function byteLength(){return Math.ceil(this.bitLength()/8)};BN.prototype.toTwos=function toTwos(e){if(this.negative!==0){return this.abs().inotn(e).iaddn(1)}return this.clone()};BN.prototype.fromTwos=function fromTwos(e){if(this.testn(e-1)){return this.notn(e).iaddn(1).ineg()}return this.clone()};BN.prototype.isNeg=function isNeg(){return this.negative!==0};BN.prototype.neg=function neg(){return this.clone().ineg()};BN.prototype.ineg=function ineg(){if(!this.isZero()){this.negative^=1}return this};BN.prototype.iuor=function iuor(e){while(this.length<e.length){this.words[this.length++]=0}for(var t=0;t<e.length;t++){this.words[t]=this.words[t]|e.words[t]}return this._strip()};BN.prototype.ior=function ior(e){assert((this.negative|e.negative)===0);return this.iuor(e)};BN.prototype.or=function or(e){if(this.length>e.length)return this.clone().ior(e);return e.clone().ior(this)};BN.prototype.uor=function uor(e){if(this.length>e.length)return this.clone().iuor(e);return e.clone().iuor(this)};BN.prototype.iuand=function iuand(e){var t;if(this.length>e.length){t=e}else{t=this}for(var r=0;r<t.length;r++){this.words[r]=this.words[r]&e.words[r]}this.length=t.length;return this._strip()};BN.prototype.iand=function iand(e){assert((this.negative|e.negative)===0);return this.iuand(e)};BN.prototype.and=function and(e){if(this.length>e.length)return this.clone().iand(e);return e.clone().iand(this)};BN.prototype.uand=function uand(e){if(this.length>e.length)return this.clone().iuand(e);return e.clone().iuand(this)};BN.prototype.iuxor=function iuxor(e){var t;var r;if(this.length>e.length){t=this;r=e}else{t=e;r=this}for(var i=0;i<r.length;i++){this.words[i]=t.words[i]^r.words[i]}if(this!==t){for(;i<t.length;i++){this.words[i]=t.words[i]}}this.length=t.length;return this._strip()};BN.prototype.ixor=function ixor(e){assert((this.negative|e.negative)===0);return this.iuxor(e)};BN.prototype.xor=function xor(e){if(this.length>e.length)return this.clone().ixor(e);return e.clone().ixor(this)};BN.prototype.uxor=function uxor(e){if(this.length>e.length)return this.clone().iuxor(e);return e.clone().iuxor(this)};BN.prototype.inotn=function inotn(e){assert(typeof e==="number"&&e>=0);var t=Math.ceil(e/26)|0;var r=e%26;this._expand(t);if(r>0){t--}for(var i=0;i<t;i++){this.words[i]=~this.words[i]&67108863}if(r>0){this.words[i]=~this.words[i]&67108863>>26-r}return this._strip()};BN.prototype.notn=function notn(e){return this.clone().inotn(e)};BN.prototype.setn=function setn(e,t){assert(typeof e==="number"&&e>=0);var r=e/26|0;var i=e%26;this._expand(r+1);if(t){this.words[r]=this.words[r]|1<<i}else{this.words[r]=this.words[r]&~(1<<i)}return this._strip()};BN.prototype.iadd=function iadd(e){var t;if(this.negative!==0&&e.negative===0){this.negative=0;t=this.isub(e);this.negative^=1;return this._normSign()}else if(this.negative===0&&e.negative!==0){e.negative=0;t=this.isub(e);e.negative=1;return t._normSign()}var r,i;if(this.length>e.length){r=this;i=e}else{r=e;i=this}var n=0;for(var a=0;a<i.length;a++){t=(r.words[a]|0)+(i.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}for(;n!==0&&a<r.length;a++){t=(r.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}this.length=r.length;if(n!==0){this.words[this.length]=n;this.length++}else if(r!==this){for(;a<r.length;a++){this.words[a]=r.words[a]}}return this};BN.prototype.add=function add(e){var t;if(e.negative!==0&&this.negative===0){e.negative=0;t=this.sub(e);e.negative^=1;return t}else if(e.negative===0&&this.negative!==0){this.negative=0;t=e.sub(this);this.negative=1;return t}if(this.length>e.length)return this.clone().iadd(e);return e.clone().iadd(this)};BN.prototype.isub=function isub(e){if(e.negative!==0){e.negative=0;var t=this.iadd(e);e.negative=1;return t._normSign()}else if(this.negative!==0){this.negative=0;this.iadd(e);this.negative=1;return this._normSign()}var r=this.cmp(e);if(r===0){this.negative=0;this.length=1;this.words[0]=0;return this}var i,n;if(r>0){i=this;n=e}else{i=e;n=this}var a=0;for(var s=0;s<n.length;s++){t=(i.words[s]|0)-(n.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}for(;a!==0&&s<i.length;s++){t=(i.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}if(a===0&&s<i.length&&i!==this){for(;s<i.length;s++){this.words[s]=i.words[s]}}this.length=Math.max(this.length,s);if(i!==this){this.negative=1}return this._strip()};BN.prototype.sub=function sub(e){return this.clone().isub(e)};function smallMulTo(e,t,r){r.negative=t.negative^e.negative;var i=e.length+t.length|0;r.length=i;i=i-1|0;var n=e.words[0]|0;var a=t.words[0]|0;var s=n*a;var o=s&67108863;var h=s/67108864|0;r.words[0]=o;for(var u=1;u<i;u++){var d=h>>>26;var c=h&67108863;var l=Math.min(u,t.length-1);for(var p=Math.max(0,u-e.length+1);p<=l;p++){var v=u-p|0;n=e.words[v]|0;a=t.words[p]|0;s=n*a+c;d+=s/67108864|0;c=s&67108863}r.words[u]=c|0;h=d|0}if(h!==0){r.words[u]=h|0}else{r.length--}return r._strip()}var h=function comb10MulTo(e,t,r){var i=e.words;var n=t.words;var a=r.words;var s=0;var o;var h;var u;var d=i[0]|0;var c=d&8191;var l=d>>>13;var p=i[1]|0;var v=p&8191;var b=p>>>13;var m=i[2]|0;var y=m&8191;var g=m>>>13;var _=i[3]|0;var w=_&8191;var M=_>>>13;var B=i[4]|0;var E=B&8191;var k=B>>>13;var A=i[5]|0;var N=A&8191;var P=A>>>13;var x=i[6]|0;var I=x&8191;var C=x>>>13;var D=i[7]|0;var T=D&8191;var j=D>>>13;var q=i[8]|0;var O=q&8191;var H=q>>>13;var L=i[9]|0;var z=L&8191;var F=L>>>13;var U=n[0]|0;var W=U&8191;var V=U>>>13;var G=n[1]|0;var J=G&8191;var Z=G>>>13;var X=n[2]|0;var Y=X&8191;var $=X>>>13;var Q=n[3]|0;var ee=Q&8191;var te=Q>>>13;var re=n[4]|0;var ie=re&8191;var ne=re>>>13;var ae=n[5]|0;var fe=ae&8191;var se=ae>>>13;var oe=n[6]|0;var he=oe&8191;var ue=oe>>>13;var de=n[7]|0;var ce=de&8191;var le=de>>>13;var pe=n[8]|0;var ve=pe&8191;var be=pe>>>13;var me=n[9]|0;var ye=me&8191;var ge=me>>>13;r.negative=e.negative^t.negative;r.length=19;o=Math.imul(c,W);h=Math.imul(c,V);h=h+Math.imul(l,W)|0;u=Math.imul(l,V);var _e=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(_e>>>26)|0;_e&=67108863;o=Math.imul(v,W);h=Math.imul(v,V);h=h+Math.imul(b,W)|0;u=Math.imul(b,V);o=o+Math.imul(c,J)|0;h=h+Math.imul(c,Z)|0;h=h+Math.imul(l,J)|0;u=u+Math.imul(l,Z)|0;var we=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(we>>>26)|0;we&=67108863;o=Math.imul(y,W);h=Math.imul(y,V);h=h+Math.imul(g,W)|0;u=Math.imul(g,V);o=o+Math.imul(v,J)|0;h=h+Math.imul(v,Z)|0;h=h+Math.imul(b,J)|0;u=u+Math.imul(b,Z)|0;o=o+Math.imul(c,Y)|0;h=h+Math.imul(c,$)|0;h=h+Math.imul(l,Y)|0;u=u+Math.imul(l,$)|0;var Me=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Me>>>26)|0;Me&=67108863;o=Math.imul(w,W);h=Math.imul(w,V);h=h+Math.imul(M,W)|0;u=Math.imul(M,V);o=o+Math.imul(y,J)|0;h=h+Math.imul(y,Z)|0;h=h+Math.imul(g,J)|0;u=u+Math.imul(g,Z)|0;o=o+Math.imul(v,Y)|0;h=h+Math.imul(v,$)|0;h=h+Math.imul(b,Y)|0;u=u+Math.imul(b,$)|0;o=o+Math.imul(c,ee)|0;h=h+Math.imul(c,te)|0;h=h+Math.imul(l,ee)|0;u=u+Math.imul(l,te)|0;var Se=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Se>>>26)|0;Se&=67108863;o=Math.imul(E,W);h=Math.imul(E,V);h=h+Math.imul(k,W)|0;u=Math.imul(k,V);o=o+Math.imul(w,J)|0;h=h+Math.imul(w,Z)|0;h=h+Math.imul(M,J)|0;u=u+Math.imul(M,Z)|0;o=o+Math.imul(y,Y)|0;h=h+Math.imul(y,$)|0;h=h+Math.imul(g,Y)|0;u=u+Math.imul(g,$)|0;o=o+Math.imul(v,ee)|0;h=h+Math.imul(v,te)|0;h=h+Math.imul(b,ee)|0;u=u+Math.imul(b,te)|0;o=o+Math.imul(c,ie)|0;h=h+Math.imul(c,ne)|0;h=h+Math.imul(l,ie)|0;u=u+Math.imul(l,ne)|0;var Be=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Be>>>26)|0;Be&=67108863;o=Math.imul(N,W);h=Math.imul(N,V);h=h+Math.imul(P,W)|0;u=Math.imul(P,V);o=o+Math.imul(E,J)|0;h=h+Math.imul(E,Z)|0;h=h+Math.imul(k,J)|0;u=u+Math.imul(k,Z)|0;o=o+Math.imul(w,Y)|0;h=h+Math.imul(w,$)|0;h=h+Math.imul(M,Y)|0;u=u+Math.imul(M,$)|0;o=o+Math.imul(y,ee)|0;h=h+Math.imul(y,te)|0;h=h+Math.imul(g,ee)|0;u=u+Math.imul(g,te)|0;o=o+Math.imul(v,ie)|0;h=h+Math.imul(v,ne)|0;h=h+Math.imul(b,ie)|0;u=u+Math.imul(b,ne)|0;o=o+Math.imul(c,fe)|0;h=h+Math.imul(c,se)|0;h=h+Math.imul(l,fe)|0;u=u+Math.imul(l,se)|0;var Ee=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ee>>>26)|0;Ee&=67108863;o=Math.imul(I,W);h=Math.imul(I,V);h=h+Math.imul(C,W)|0;u=Math.imul(C,V);o=o+Math.imul(N,J)|0;h=h+Math.imul(N,Z)|0;h=h+Math.imul(P,J)|0;u=u+Math.imul(P,Z)|0;o=o+Math.imul(E,Y)|0;h=h+Math.imul(E,$)|0;h=h+Math.imul(k,Y)|0;u=u+Math.imul(k,$)|0;o=o+Math.imul(w,ee)|0;h=h+Math.imul(w,te)|0;h=h+Math.imul(M,ee)|0;u=u+Math.imul(M,te)|0;o=o+Math.imul(y,ie)|0;h=h+Math.imul(y,ne)|0;h=h+Math.imul(g,ie)|0;u=u+Math.imul(g,ne)|0;o=o+Math.imul(v,fe)|0;h=h+Math.imul(v,se)|0;h=h+Math.imul(b,fe)|0;u=u+Math.imul(b,se)|0;o=o+Math.imul(c,he)|0;h=h+Math.imul(c,ue)|0;h=h+Math.imul(l,he)|0;u=u+Math.imul(l,ue)|0;var ke=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(ke>>>26)|0;ke&=67108863;o=Math.imul(T,W);h=Math.imul(T,V);h=h+Math.imul(j,W)|0;u=Math.imul(j,V);o=o+Math.imul(I,J)|0;h=h+Math.imul(I,Z)|0;h=h+Math.imul(C,J)|0;u=u+Math.imul(C,Z)|0;o=o+Math.imul(N,Y)|0;h=h+Math.imul(N,$)|0;h=h+Math.imul(P,Y)|0;u=u+Math.imul(P,$)|0;o=o+Math.imul(E,ee)|0;h=h+Math.imul(E,te)|0;h=h+Math.imul(k,ee)|0;u=u+Math.imul(k,te)|0;o=o+Math.imul(w,ie)|0;h=h+Math.imul(w,ne)|0;h=h+Math.imul(M,ie)|0;u=u+Math.imul(M,ne)|0;o=o+Math.imul(y,fe)|0;h=h+Math.imul(y,se)|0;h=h+Math.imul(g,fe)|0;u=u+Math.imul(g,se)|0;o=o+Math.imul(v,he)|0;h=h+Math.imul(v,ue)|0;h=h+Math.imul(b,he)|0;u=u+Math.imul(b,ue)|0;o=o+Math.imul(c,ce)|0;h=h+Math.imul(c,le)|0;h=h+Math.imul(l,ce)|0;u=u+Math.imul(l,le)|0;var Ae=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ae>>>26)|0;Ae&=67108863;o=Math.imul(O,W);h=Math.imul(O,V);h=h+Math.imul(H,W)|0;u=Math.imul(H,V);o=o+Math.imul(T,J)|0;h=h+Math.imul(T,Z)|0;h=h+Math.imul(j,J)|0;u=u+Math.imul(j,Z)|0;o=o+Math.imul(I,Y)|0;h=h+Math.imul(I,$)|0;h=h+Math.imul(C,Y)|0;u=u+Math.imul(C,$)|0;o=o+Math.imul(N,ee)|0;h=h+Math.imul(N,te)|0;h=h+Math.imul(P,ee)|0;u=u+Math.imul(P,te)|0;o=o+Math.imul(E,ie)|0;h=h+Math.imul(E,ne)|0;h=h+Math.imul(k,ie)|0;u=u+Math.imul(k,ne)|0;o=o+Math.imul(w,fe)|0;h=h+Math.imul(w,se)|0;h=h+Math.imul(M,fe)|0;u=u+Math.imul(M,se)|0;o=o+Math.imul(y,he)|0;h=h+Math.imul(y,ue)|0;h=h+Math.imul(g,he)|0;u=u+Math.imul(g,ue)|0;o=o+Math.imul(v,ce)|0;h=h+Math.imul(v,le)|0;h=h+Math.imul(b,ce)|0;u=u+Math.imul(b,le)|0;o=o+Math.imul(c,ve)|0;h=h+Math.imul(c,be)|0;h=h+Math.imul(l,ve)|0;u=u+Math.imul(l,be)|0;var Ne=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ne>>>26)|0;Ne&=67108863;o=Math.imul(z,W);h=Math.imul(z,V);h=h+Math.imul(F,W)|0;u=Math.imul(F,V);o=o+Math.imul(O,J)|0;h=h+Math.imul(O,Z)|0;h=h+Math.imul(H,J)|0;u=u+Math.imul(H,Z)|0;o=o+Math.imul(T,Y)|0;h=h+Math.imul(T,$)|0;h=h+Math.imul(j,Y)|0;u=u+Math.imul(j,$)|0;o=o+Math.imul(I,ee)|0;h=h+Math.imul(I,te)|0;h=h+Math.imul(C,ee)|0;u=u+Math.imul(C,te)|0;o=o+Math.imul(N,ie)|0;h=h+Math.imul(N,ne)|0;h=h+Math.imul(P,ie)|0;u=u+Math.imul(P,ne)|0;o=o+Math.imul(E,fe)|0;h=h+Math.imul(E,se)|0;h=h+Math.imul(k,fe)|0;u=u+Math.imul(k,se)|0;o=o+Math.imul(w,he)|0;h=h+Math.imul(w,ue)|0;h=h+Math.imul(M,he)|0;u=u+Math.imul(M,ue)|0;o=o+Math.imul(y,ce)|0;h=h+Math.imul(y,le)|0;h=h+Math.imul(g,ce)|0;u=u+Math.imul(g,le)|0;o=o+Math.imul(v,ve)|0;h=h+Math.imul(v,be)|0;h=h+Math.imul(b,ve)|0;u=u+Math.imul(b,be)|0;o=o+Math.imul(c,ye)|0;h=h+Math.imul(c,ge)|0;h=h+Math.imul(l,ye)|0;u=u+Math.imul(l,ge)|0;var Re=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Re>>>26)|0;Re&=67108863;o=Math.imul(z,J);h=Math.imul(z,Z);h=h+Math.imul(F,J)|0;u=Math.imul(F,Z);o=o+Math.imul(O,Y)|0;h=h+Math.imul(O,$)|0;h=h+Math.imul(H,Y)|0;u=u+Math.imul(H,$)|0;o=o+Math.imul(T,ee)|0;h=h+Math.imul(T,te)|0;h=h+Math.imul(j,ee)|0;u=u+Math.imul(j,te)|0;o=o+Math.imul(I,ie)|0;h=h+Math.imul(I,ne)|0;h=h+Math.imul(C,ie)|0;u=u+Math.imul(C,ne)|0;o=o+Math.imul(N,fe)|0;h=h+Math.imul(N,se)|0;h=h+Math.imul(P,fe)|0;u=u+Math.imul(P,se)|0;o=o+Math.imul(E,he)|0;h=h+Math.imul(E,ue)|0;h=h+Math.imul(k,he)|0;u=u+Math.imul(k,ue)|0;o=o+Math.imul(w,ce)|0;h=h+Math.imul(w,le)|0;h=h+Math.imul(M,ce)|0;u=u+Math.imul(M,le)|0;o=o+Math.imul(y,ve)|0;h=h+Math.imul(y,be)|0;h=h+Math.imul(g,ve)|0;u=u+Math.imul(g,be)|0;o=o+Math.imul(v,ye)|0;h=h+Math.imul(v,ge)|0;h=h+Math.imul(b,ye)|0;u=u+Math.imul(b,ge)|0;var Pe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Pe>>>26)|0;Pe&=67108863;o=Math.imul(z,Y);h=Math.imul(z,$);h=h+Math.imul(F,Y)|0;u=Math.imul(F,$);o=o+Math.imul(O,ee)|0;h=h+Math.imul(O,te)|0;h=h+Math.imul(H,ee)|0;u=u+Math.imul(H,te)|0;o=o+Math.imul(T,ie)|0;h=h+Math.imul(T,ne)|0;h=h+Math.imul(j,ie)|0;u=u+Math.imul(j,ne)|0;o=o+Math.imul(I,fe)|0;h=h+Math.imul(I,se)|0;h=h+Math.imul(C,fe)|0;u=u+Math.imul(C,se)|0;o=o+Math.imul(N,he)|0;h=h+Math.imul(N,ue)|0;h=h+Math.imul(P,he)|0;u=u+Math.imul(P,ue)|0;o=o+Math.imul(E,ce)|0;h=h+Math.imul(E,le)|0;h=h+Math.imul(k,ce)|0;u=u+Math.imul(k,le)|0;o=o+Math.imul(w,ve)|0;h=h+Math.imul(w,be)|0;h=h+Math.imul(M,ve)|0;u=u+Math.imul(M,be)|0;o=o+Math.imul(y,ye)|0;h=h+Math.imul(y,ge)|0;h=h+Math.imul(g,ye)|0;u=u+Math.imul(g,ge)|0;var xe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(xe>>>26)|0;xe&=67108863;o=Math.imul(z,ee);h=Math.imul(z,te);h=h+Math.imul(F,ee)|0;u=Math.imul(F,te);o=o+Math.imul(O,ie)|0;h=h+Math.imul(O,ne)|0;h=h+Math.imul(H,ie)|0;u=u+Math.imul(H,ne)|0;o=o+Math.imul(T,fe)|0;h=h+Math.imul(T,se)|0;h=h+Math.imul(j,fe)|0;u=u+Math.imul(j,se)|0;o=o+Math.imul(I,he)|0;h=h+Math.imul(I,ue)|0;h=h+Math.imul(C,he)|0;u=u+Math.imul(C,ue)|0;o=o+Math.imul(N,ce)|0;h=h+Math.imul(N,le)|0;h=h+Math.imul(P,ce)|0;u=u+Math.imul(P,le)|0;o=o+Math.imul(E,ve)|0;h=h+Math.imul(E,be)|0;h=h+Math.imul(k,ve)|0;u=u+Math.imul(k,be)|0;o=o+Math.imul(w,ye)|0;h=h+Math.imul(w,ge)|0;h=h+Math.imul(M,ye)|0;u=u+Math.imul(M,ge)|0;var Ie=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ie>>>26)|0;Ie&=67108863;o=Math.imul(z,ie);h=Math.imul(z,ne);h=h+Math.imul(F,ie)|0;u=Math.imul(F,ne);o=o+Math.imul(O,fe)|0;h=h+Math.imul(O,se)|0;h=h+Math.imul(H,fe)|0;u=u+Math.imul(H,se)|0;o=o+Math.imul(T,he)|0;h=h+Math.imul(T,ue)|0;h=h+Math.imul(j,he)|0;u=u+Math.imul(j,ue)|0;o=o+Math.imul(I,ce)|0;h=h+Math.imul(I,le)|0;h=h+Math.imul(C,ce)|0;u=u+Math.imul(C,le)|0;o=o+Math.imul(N,ve)|0;h=h+Math.imul(N,be)|0;h=h+Math.imul(P,ve)|0;u=u+Math.imul(P,be)|0;o=o+Math.imul(E,ye)|0;h=h+Math.imul(E,ge)|0;h=h+Math.imul(k,ye)|0;u=u+Math.imul(k,ge)|0;var Ce=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ce>>>26)|0;Ce&=67108863;o=Math.imul(z,fe);h=Math.imul(z,se);h=h+Math.imul(F,fe)|0;u=Math.imul(F,se);o=o+Math.imul(O,he)|0;h=h+Math.imul(O,ue)|0;h=h+Math.imul(H,he)|0;u=u+Math.imul(H,ue)|0;o=o+Math.imul(T,ce)|0;h=h+Math.imul(T,le)|0;h=h+Math.imul(j,ce)|0;u=u+Math.imul(j,le)|0;o=o+Math.imul(I,ve)|0;h=h+Math.imul(I,be)|0;h=h+Math.imul(C,ve)|0;u=u+Math.imul(C,be)|0;o=o+Math.imul(N,ye)|0;h=h+Math.imul(N,ge)|0;h=h+Math.imul(P,ye)|0;u=u+Math.imul(P,ge)|0;var De=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(De>>>26)|0;De&=67108863;o=Math.imul(z,he);h=Math.imul(z,ue);h=h+Math.imul(F,he)|0;u=Math.imul(F,ue);o=o+Math.imul(O,ce)|0;h=h+Math.imul(O,le)|0;h=h+Math.imul(H,ce)|0;u=u+Math.imul(H,le)|0;o=o+Math.imul(T,ve)|0;h=h+Math.imul(T,be)|0;h=h+Math.imul(j,ve)|0;u=u+Math.imul(j,be)|0;o=o+Math.imul(I,ye)|0;h=h+Math.imul(I,ge)|0;h=h+Math.imul(C,ye)|0;u=u+Math.imul(C,ge)|0;var Te=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Te>>>26)|0;Te&=67108863;o=Math.imul(z,ce);h=Math.imul(z,le);h=h+Math.imul(F,ce)|0;u=Math.imul(F,le);o=o+Math.imul(O,ve)|0;h=h+Math.imul(O,be)|0;h=h+Math.imul(H,ve)|0;u=u+Math.imul(H,be)|0;o=o+Math.imul(T,ye)|0;h=h+Math.imul(T,ge)|0;h=h+Math.imul(j,ye)|0;u=u+Math.imul(j,ge)|0;var je=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(je>>>26)|0;je&=67108863;o=Math.imul(z,ve);h=Math.imul(z,be);h=h+Math.imul(F,ve)|0;u=Math.imul(F,be);o=o+Math.imul(O,ye)|0;h=h+Math.imul(O,ge)|0;h=h+Math.imul(H,ye)|0;u=u+Math.imul(H,ge)|0;var qe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(qe>>>26)|0;qe&=67108863;o=Math.imul(z,ye);h=Math.imul(z,ge);h=h+Math.imul(F,ye)|0;u=Math.imul(F,ge);var Oe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Oe>>>26)|0;Oe&=67108863;a[0]=_e;a[1]=we;a[2]=Me;a[3]=Se;a[4]=Be;a[5]=Ee;a[6]=ke;a[7]=Ae;a[8]=Ne;a[9]=Re;a[10]=Pe;a[11]=xe;a[12]=Ie;a[13]=Ce;a[14]=De;a[15]=Te;a[16]=je;a[17]=qe;a[18]=Oe;if(s!==0){a[19]=s;r.length++}return r};if(!Math.imul){h=smallMulTo}function bigMulTo(e,t,r){r.negative=t.negative^e.negative;r.length=e.length+t.length;var i=0;var n=0;for(var a=0;a<r.length-1;a++){var s=n;n=0;var o=i&67108863;var h=Math.min(a,t.length-1);for(var u=Math.max(0,a-e.length+1);u<=h;u++){var d=a-u;var c=e.words[d]|0;var l=t.words[u]|0;var p=c*l;var v=p&67108863;s=s+(p/67108864|0)|0;v=v+o|0;o=v&67108863;s=s+(v>>>26)|0;n+=s>>>26;s&=67108863}r.words[a]=o;i=s;s=n}if(i!==0){r.words[a]=i}else{r.length--}return r._strip()}function jumboMulTo(e,t,r){return bigMulTo(e,t,r)}BN.prototype.mulTo=function mulTo(e,t){var r;var i=this.length+e.length;if(this.length===10&&e.length===10){r=h(this,e,t)}else if(i<63){r=smallMulTo(this,e,t)}else if(i<1024){r=bigMulTo(this,e,t)}else{r=jumboMulTo(this,e,t)}return r};function FFTM(e,t){this.x=e;this.y=t}FFTM.prototype.makeRBT=function makeRBT(e){var t=new Array(e);var r=BN.prototype._countBits(e)-1;for(var i=0;i<e;i++){t[i]=this.revBin(i,r,e)}return t};FFTM.prototype.revBin=function revBin(e,t,r){if(e===0||e===r-1)return e;var i=0;for(var n=0;n<t;n++){i|=(e&1)<<t-n-1;e>>=1}return i};FFTM.prototype.permute=function permute(e,t,r,i,n,a){for(var s=0;s<a;s++){i[s]=t[e[s]];n[s]=r[e[s]]}};FFTM.prototype.transform=function transform(e,t,r,i,n,a){this.permute(a,e,t,r,i,n);for(var s=1;s<n;s<<=1){var o=s<<1;var h=Math.cos(2*Math.PI/o);var u=Math.sin(2*Math.PI/o);for(var d=0;d<n;d+=o){var c=h;var l=u;for(var p=0;p<s;p++){var v=r[d+p];var b=i[d+p];var m=r[d+p+s];var y=i[d+p+s];var g=c*m-l*y;y=c*y+l*m;m=g;r[d+p]=v+m;i[d+p]=b+y;r[d+p+s]=v-m;i[d+p+s]=b-y;if(p!==o){g=h*c-u*l;l=h*l+u*c;c=g}}}}};FFTM.prototype.guessLen13b=function guessLen13b(e,t){var r=Math.max(t,e)|1;var i=r&1;var n=0;for(r=r/2|0;r;r=r>>>1){n++}return 1<<n+1+i};FFTM.prototype.conjugate=function conjugate(e,t,r){if(r<=1)return;for(var i=0;i<r/2;i++){var n=e[i];e[i]=e[r-i-1];e[r-i-1]=n;n=t[i];t[i]=-t[r-i-1];t[r-i-1]=-n}};FFTM.prototype.normalize13b=function normalize13b(e,t){var r=0;for(var i=0;i<t/2;i++){var n=Math.round(e[2*i+1]/t)*8192+Math.round(e[2*i]/t)+r;e[i]=n&67108863;if(n<67108864){r=0}else{r=n/67108864|0}}return e};FFTM.prototype.convert13b=function convert13b(e,t,r,i){var n=0;for(var a=0;a<t;a++){n=n+(e[a]|0);r[2*a]=n&8191;n=n>>>13;r[2*a+1]=n&8191;n=n>>>13}for(a=2*t;a<i;++a){r[a]=0}assert(n===0);assert((n&~8191)===0)};FFTM.prototype.stub=function stub(e){var t=new Array(e);for(var r=0;r<e;r++){t[r]=0}return t};FFTM.prototype.mulp=function mulp(e,t,r){var i=2*this.guessLen13b(e.length,t.length);var n=this.makeRBT(i);var a=this.stub(i);var s=new Array(i);var o=new Array(i);var h=new Array(i);var u=new Array(i);var d=new Array(i);var c=new Array(i);var l=r.words;l.length=i;this.convert13b(e.words,e.length,s,i);this.convert13b(t.words,t.length,u,i);this.transform(s,a,o,h,i,n);this.transform(u,a,d,c,i,n);for(var p=0;p<i;p++){var v=o[p]*d[p]-h[p]*c[p];h[p]=o[p]*c[p]+h[p]*d[p];o[p]=v}this.conjugate(o,h,i);this.transform(o,h,l,a,i,n);this.conjugate(l,a,i);this.normalize13b(l,i);r.negative=e.negative^t.negative;r.length=e.length+t.length;return r._strip()};BN.prototype.mul=function mul(e){var t=new BN(null);t.words=new Array(this.length+e.length);return this.mulTo(e,t)};BN.prototype.mulf=function mulf(e){var t=new BN(null);t.words=new Array(this.length+e.length);return jumboMulTo(this,e,t)};BN.prototype.imul=function imul(e){return this.clone().mulTo(e,this)};BN.prototype.imuln=function imuln(e){var t=e<0;if(t)e=-e;assert(typeof e==="number");assert(e<67108864);var r=0;for(var i=0;i<this.length;i++){var n=(this.words[i]|0)*e;var a=(n&67108863)+(r&67108863);r>>=26;r+=n/67108864|0;r+=a>>>26;this.words[i]=a&67108863}if(r!==0){this.words[i]=r;this.length++}return t?this.ineg():this};BN.prototype.muln=function muln(e){return this.clone().imuln(e)};BN.prototype.sqr=function sqr(){return this.mul(this)};BN.prototype.isqr=function isqr(){return this.imul(this.clone())};BN.prototype.pow=function pow(e){var t=toBitArray(e);if(t.length===0)return new BN(1);var r=this;for(var i=0;i<t.length;i++,r=r.sqr()){if(t[i]!==0)break}if(++i<t.length){for(var n=r.sqr();i<t.length;i++,n=n.sqr()){if(t[i]===0)continue;r=r.mul(n)}}return r};BN.prototype.iushln=function iushln(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=67108863>>>26-t<<26-t;var n;if(t!==0){var a=0;for(n=0;n<this.length;n++){var s=this.words[n]&i;var o=(this.words[n]|0)-s<<t;this.words[n]=o|a;a=s>>>26-t}if(a){this.words[n]=a;this.length++}}if(r!==0){for(n=this.length-1;n>=0;n--){this.words[n+r]=this.words[n]}for(n=0;n<r;n++){this.words[n]=0}this.length+=r}return this._strip()};BN.prototype.ishln=function ishln(e){assert(this.negative===0);return this.iushln(e)};BN.prototype.iushrn=function iushrn(e,t,r){assert(typeof e==="number"&&e>=0);var i;if(t){i=(t-t%26)/26}else{i=0}var n=e%26;var a=Math.min((e-n)/26,this.length);var s=67108863^67108863>>>n<<n;var o=r;i-=a;i=Math.max(0,i);if(o){for(var h=0;h<a;h++){o.words[h]=this.words[h]}o.length=a}if(a===0){}else if(this.length>a){this.length-=a;for(h=0;h<this.length;h++){this.words[h]=this.words[h+a]}}else{this.words[0]=0;this.length=1}var u=0;for(h=this.length-1;h>=0&&(u!==0||h>=i);h--){var d=this.words[h]|0;this.words[h]=u<<26-n|d>>>n;u=d&s}if(o&&u!==0){o.words[o.length++]=u}if(this.length===0){this.words[0]=0;this.length=1}return this._strip()};BN.prototype.ishrn=function ishrn(e,t,r){assert(this.negative===0);return this.iushrn(e,t,r)};BN.prototype.shln=function shln(e){return this.clone().ishln(e)};BN.prototype.ushln=function ushln(e){return this.clone().iushln(e)};BN.prototype.shrn=function shrn(e){return this.clone().ishrn(e)};BN.prototype.ushrn=function ushrn(e){return this.clone().iushrn(e)};BN.prototype.testn=function testn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r)return false;var n=this.words[r];return!!(n&i)};BN.prototype.imaskn=function imaskn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;assert(this.negative===0,"imaskn works only with positive numbers");if(this.length<=r){return this}if(t!==0){r++}this.length=Math.min(r,this.length);if(t!==0){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i}return this._strip()};BN.prototype.maskn=function maskn(e){return this.clone().imaskn(e)};BN.prototype.iaddn=function iaddn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.isubn(-e);if(this.negative!==0){if(this.length===1&&(this.words[0]|0)<=e){this.words[0]=e-(this.words[0]|0);this.negative=0;return this}this.negative=0;this.isubn(e);this.negative=1;return this}return this._iaddn(e)};BN.prototype._iaddn=function _iaddn(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++){this.words[t]-=67108864;if(t===this.length-1){this.words[t+1]=1}else{this.words[t+1]++}}this.length=Math.max(this.length,t+1);return this};BN.prototype.isubn=function isubn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.iaddn(-e);if(this.negative!==0){this.negative=0;this.iaddn(e);this.negative=1;return this}this.words[0]-=e;if(this.length===1&&this.words[0]<0){this.words[0]=-this.words[0];this.negative=1}else{for(var t=0;t<this.length&&this.words[t]<0;t++){this.words[t]+=67108864;this.words[t+1]-=1}}return this._strip()};BN.prototype.addn=function addn(e){return this.clone().iaddn(e)};BN.prototype.subn=function subn(e){return this.clone().isubn(e)};BN.prototype.iabs=function iabs(){this.negative=0;return this};BN.prototype.abs=function abs(){return this.clone().iabs()};BN.prototype._ishlnsubmul=function _ishlnsubmul(e,t,r){var i=e.length+r;var n;this._expand(i);var a;var s=0;for(n=0;n<e.length;n++){a=(this.words[n+r]|0)+s;var o=(e.words[n]|0)*t;a-=o&67108863;s=(a>>26)-(o/67108864|0);this.words[n+r]=a&67108863}for(;n<this.length-r;n++){a=(this.words[n+r]|0)+s;s=a>>26;this.words[n+r]=a&67108863}if(s===0)return this._strip();assert(s===-1);s=0;for(n=0;n<this.length;n++){a=-(this.words[n]|0)+s;s=a>>26;this.words[n]=a&67108863}this.negative=1;return this._strip()};BN.prototype._wordDiv=function _wordDiv(e,t){var r=this.length-e.length;var i=this.clone();var n=e;var a=n.words[n.length-1]|0;var s=this._countBits(a);r=26-s;if(r!==0){n=n.ushln(r);i.iushln(r);a=n.words[n.length-1]|0}var o=i.length-n.length;var h;if(t!=="mod"){h=new BN(null);h.length=o+1;h.words=new Array(h.length);for(var u=0;u<h.length;u++){h.words[u]=0}}var d=i.clone()._ishlnsubmul(n,1,o);if(d.negative===0){i=d;if(h){h.words[o]=1}}for(var c=o-1;c>=0;c--){var l=(i.words[n.length+c]|0)*67108864+(i.words[n.length+c-1]|0);l=Math.min(l/a|0,67108863);i._ishlnsubmul(n,l,c);while(i.negative!==0){l--;i.negative=0;i._ishlnsubmul(n,1,c);if(!i.isZero()){i.negative^=1}}if(h){h.words[c]=l}}if(h){h._strip()}i._strip();if(t!=="div"&&r!==0){i.iushrn(r)}return{div:h||null,mod:i}};BN.prototype.divmod=function divmod(e,t,r){assert(!e.isZero());if(this.isZero()){return{div:new BN(0),mod:new BN(0)}}var i,n,a;if(this.negative!==0&&e.negative===0){a=this.neg().divmod(e,t);if(t!=="mod"){i=a.div.neg()}if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.iadd(e)}}return{div:i,mod:n}}if(this.negative===0&&e.negative!==0){a=this.divmod(e.neg(),t);if(t!=="mod"){i=a.div.neg()}return{div:i,mod:a.mod}}if((this.negative&e.negative)!==0){a=this.neg().divmod(e.neg(),t);if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.isub(e)}}return{div:a.div,mod:n}}if(e.length>this.length||this.cmp(e)<0){return{div:new BN(0),mod:this}}if(e.length===1){if(t==="div"){return{div:this.divn(e.words[0]),mod:null}}if(t==="mod"){return{div:null,mod:new BN(this.modrn(e.words[0]))}}return{div:this.divn(e.words[0]),mod:new BN(this.modrn(e.words[0]))}}return this._wordDiv(e,t)};BN.prototype.div=function div(e){return this.divmod(e,"div",false).div};BN.prototype.mod=function mod(e){return this.divmod(e,"mod",false).mod};BN.prototype.umod=function umod(e){return this.divmod(e,"mod",true).mod};BN.prototype.divRound=function divRound(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var r=t.div.negative!==0?t.mod.isub(e):t.mod;var i=e.ushrn(1);var n=e.andln(1);var a=r.cmp(i);if(a<0||n===1&&a===0)return t.div;return t.div.negative!==0?t.div.isubn(1):t.div.iaddn(1)};BN.prototype.modrn=function modrn(e){var t=e<0;if(t)e=-e;assert(e<=67108863);var r=(1<<26)%e;var i=0;for(var n=this.length-1;n>=0;n--){i=(r*i+(this.words[n]|0))%e}return t?-i:i};BN.prototype.modn=function modn(e){return this.modrn(e)};BN.prototype.idivn=function idivn(e){var t=e<0;if(t)e=-e;assert(e<=67108863);var r=0;for(var i=this.length-1;i>=0;i--){var n=(this.words[i]|0)+r*67108864;this.words[i]=n/e|0;r=n%e}this._strip();return t?this.ineg():this};BN.prototype.divn=function divn(e){return this.clone().idivn(e)};BN.prototype.egcd=function egcd(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=new BN(0);var s=new BN(1);var o=0;while(t.isEven()&&r.isEven()){t.iushrn(1);r.iushrn(1);++o}var h=r.clone();var u=t.clone();while(!t.isZero()){for(var d=0,c=1;(t.words[0]&c)===0&&d<26;++d,c<<=1);if(d>0){t.iushrn(d);while(d-- >0){if(i.isOdd()||n.isOdd()){i.iadd(h);n.isub(u)}i.iushrn(1);n.iushrn(1)}}for(var l=0,p=1;(r.words[0]&p)===0&&l<26;++l,p<<=1);if(l>0){r.iushrn(l);while(l-- >0){if(a.isOdd()||s.isOdd()){a.iadd(h);s.isub(u)}a.iushrn(1);s.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(a);n.isub(s)}else{r.isub(t);a.isub(i);s.isub(n)}}return{a:a,b:s,gcd:r.iushln(o)}};BN.prototype._invmp=function _invmp(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=r.clone();while(t.cmpn(1)>0&&r.cmpn(1)>0){for(var s=0,o=1;(t.words[0]&o)===0&&s<26;++s,o<<=1);if(s>0){t.iushrn(s);while(s-- >0){if(i.isOdd()){i.iadd(a)}i.iushrn(1)}}for(var h=0,u=1;(r.words[0]&u)===0&&h<26;++h,u<<=1);if(h>0){r.iushrn(h);while(h-- >0){if(n.isOdd()){n.iadd(a)}n.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(n)}else{r.isub(t);n.isub(i)}}var d;if(t.cmpn(1)===0){d=i}else{d=n}if(d.cmpn(0)<0){d.iadd(e)}return d};BN.prototype.gcd=function gcd(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone();var r=e.clone();t.negative=0;r.negative=0;for(var i=0;t.isEven()&&r.isEven();i++){t.iushrn(1);r.iushrn(1)}do{while(t.isEven()){t.iushrn(1)}while(r.isEven()){r.iushrn(1)}var n=t.cmp(r);if(n<0){var a=t;t=r;r=a}else if(n===0||r.cmpn(1)===0){break}t.isub(r)}while(true);return r.iushln(i)};BN.prototype.invm=function invm(e){return this.egcd(e).a.umod(e)};BN.prototype.isEven=function isEven(){return(this.words[0]&1)===0};BN.prototype.isOdd=function isOdd(){return(this.words[0]&1)===1};BN.prototype.andln=function andln(e){return this.words[0]&e};BN.prototype.bincn=function bincn(e){assert(typeof e==="number");var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r){this._expand(r+1);this.words[r]|=i;return this}var n=i;for(var a=r;n!==0&&a<this.length;a++){var s=this.words[a]|0;s+=n;n=s>>>26;s&=67108863;this.words[a]=s}if(n!==0){this.words[a]=n;this.length++}return this};BN.prototype.isZero=function isZero(){return this.length===1&&this.words[0]===0};BN.prototype.cmpn=function cmpn(e){var t=e<0;if(this.negative!==0&&!t)return-1;if(this.negative===0&&t)return 1;this._strip();var r;if(this.length>1){r=1}else{if(t){e=-e}assert(e<=67108863,"Number is too big");var i=this.words[0]|0;r=i===e?0:i<e?-1:1}if(this.negative!==0)return-r|0;return r};BN.prototype.cmp=function cmp(e){if(this.negative!==0&&e.negative===0)return-1;if(this.negative===0&&e.negative!==0)return 1;var t=this.ucmp(e);if(this.negative!==0)return-t|0;return t};BN.prototype.ucmp=function ucmp(e){if(this.length>e.length)return 1;if(this.length<e.length)return-1;var t=0;for(var r=this.length-1;r>=0;r--){var i=this.words[r]|0;var n=e.words[r]|0;if(i===n)continue;if(i<n){t=-1}else if(i>n){t=1}break}return t};BN.prototype.gtn=function gtn(e){return this.cmpn(e)===1};BN.prototype.gt=function gt(e){return this.cmp(e)===1};BN.prototype.gten=function gten(e){return this.cmpn(e)>=0};BN.prototype.gte=function gte(e){return this.cmp(e)>=0};BN.prototype.ltn=function ltn(e){return this.cmpn(e)===-1};BN.prototype.lt=function lt(e){return this.cmp(e)===-1};BN.prototype.lten=function lten(e){return this.cmpn(e)<=0};BN.prototype.lte=function lte(e){return this.cmp(e)<=0};BN.prototype.eqn=function eqn(e){return this.cmpn(e)===0};BN.prototype.eq=function eq(e){return this.cmp(e)===0};BN.red=function red(e){return new Red(e)};BN.prototype.toRed=function toRed(e){assert(!this.red,"Already a number in reduction context");assert(this.negative===0,"red works only with positives");return e.convertTo(this)._forceRed(e)};BN.prototype.fromRed=function fromRed(){assert(this.red,"fromRed works only with numbers in reduction context");return this.red.convertFrom(this)};BN.prototype._forceRed=function _forceRed(e){this.red=e;return this};BN.prototype.forceRed=function forceRed(e){assert(!this.red,"Already a number in reduction context");return this._forceRed(e)};BN.prototype.redAdd=function redAdd(e){assert(this.red,"redAdd works only with red numbers");return this.red.add(this,e)};BN.prototype.redIAdd=function redIAdd(e){assert(this.red,"redIAdd works only with red numbers");return this.red.iadd(this,e)};BN.prototype.redSub=function redSub(e){assert(this.red,"redSub works only with red numbers");return this.red.sub(this,e)};BN.prototype.redISub=function redISub(e){assert(this.red,"redISub works only with red numbers");return this.red.isub(this,e)};BN.prototype.redShl=function redShl(e){assert(this.red,"redShl works only with red numbers");return this.red.shl(this,e)};BN.prototype.redMul=function redMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.mul(this,e)};BN.prototype.redIMul=function redIMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.imul(this,e)};BN.prototype.redSqr=function redSqr(){assert(this.red,"redSqr works only with red numbers");this.red._verify1(this);return this.red.sqr(this)};BN.prototype.redISqr=function redISqr(){assert(this.red,"redISqr works only with red numbers");this.red._verify1(this);return this.red.isqr(this)};BN.prototype.redSqrt=function redSqrt(){assert(this.red,"redSqrt works only with red numbers");this.red._verify1(this);return this.red.sqrt(this)};BN.prototype.redInvm=function redInvm(){assert(this.red,"redInvm works only with red numbers");this.red._verify1(this);return this.red.invm(this)};BN.prototype.redNeg=function redNeg(){assert(this.red,"redNeg works only with red numbers");this.red._verify1(this);return this.red.neg(this)};BN.prototype.redPow=function redPow(e){assert(this.red&&!e.red,"redPow(normalNum)");this.red._verify1(this);return this.red.pow(this,e)};var u={k256:null,p224:null,p192:null,p25519:null};function MPrime(e,t){this.name=e;this.p=new BN(t,16);this.n=this.p.bitLength();this.k=new BN(1).iushln(this.n).isub(this.p);this.tmp=this._tmp()}MPrime.prototype._tmp=function _tmp(){var e=new BN(null);e.words=new Array(Math.ceil(this.n/13));return e};MPrime.prototype.ireduce=function ireduce(e){var t=e;var r;do{this.split(t,this.tmp);t=this.imulK(t);t=t.iadd(this.tmp);r=t.bitLength()}while(r>this.n);var i=r<this.n?-1:t.ucmp(this.p);if(i===0){t.words[0]=0;t.length=1}else if(i>0){t.isub(this.p)}else{if(t.strip!==undefined){t.strip()}else{t._strip()}}return t};MPrime.prototype.split=function split(e,t){e.iushrn(this.n,0,t)};MPrime.prototype.imulK=function imulK(e){return e.imul(this.k)};function K256(){MPrime.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f")}inherits(K256,MPrime);K256.prototype.split=function split(e,t){var r=4194303;var i=Math.min(e.length,9);for(var n=0;n<i;n++){t.words[n]=e.words[n]}t.length=i;if(e.length<=9){e.words[0]=0;e.length=1;return}var a=e.words[9];t.words[t.length++]=a&r;for(n=10;n<e.length;n++){var s=e.words[n]|0;e.words[n-10]=(s&r)<<4|a>>>22;a=s}a>>>=22;e.words[n-10]=a;if(a===0&&e.length>10){e.length-=10}else{e.length-=9}};K256.prototype.imulK=function imulK(e){e.words[e.length]=0;e.words[e.length+1]=0;e.length+=2;var t=0;for(var r=0;r<e.length;r++){var i=e.words[r]|0;t+=i*977;e.words[r]=t&67108863;t=i*64+(t/67108864|0)}if(e.words[e.length-1]===0){e.length--;if(e.words[e.length-1]===0){e.length--}}return e};function P224(){MPrime.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001")}inherits(P224,MPrime);function P192(){MPrime.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff")}inherits(P192,MPrime);function P25519(){MPrime.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed")}inherits(P25519,MPrime);P25519.prototype.imulK=function imulK(e){var t=0;for(var r=0;r<e.length;r++){var i=(e.words[r]|0)*19+t;var n=i&67108863;i>>>=26;e.words[r]=n;t=i}if(t!==0){e.words[e.length++]=t}return e};BN._prime=function prime(e){if(u[e])return u[e];var prime;if(e==="k256"){prime=new K256}else if(e==="p224"){prime=new P224}else if(e==="p192"){prime=new P192}else if(e==="p25519"){prime=new P25519}else{throw new Error("Unknown prime "+e)}u[e]=prime;return prime};function Red(e){if(typeof e==="string"){var t=BN._prime(e);this.m=t.p;this.prime=t}else{assert(e.gtn(1),"modulus must be greater than 1");this.m=e;this.prime=null}}Red.prototype._verify1=function _verify1(e){assert(e.negative===0,"red works only with positives");assert(e.red,"red works only with red numbers")};Red.prototype._verify2=function _verify2(e,t){assert((e.negative|t.negative)===0,"red works only with positives");assert(e.red&&e.red===t.red,"red works only with red numbers")};Red.prototype.imod=function imod(e){if(this.prime)return this.prime.ireduce(e)._forceRed(this);move(e,e.umod(this.m)._forceRed(this));return e};Red.prototype.neg=function neg(e){if(e.isZero()){return e.clone()}return this.m.sub(e)._forceRed(this)};Red.prototype.add=function add(e,t){this._verify2(e,t);var r=e.add(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r._forceRed(this)};Red.prototype.iadd=function iadd(e,t){this._verify2(e,t);var r=e.iadd(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r};Red.prototype.sub=function sub(e,t){this._verify2(e,t);var r=e.sub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r._forceRed(this)};Red.prototype.isub=function isub(e,t){this._verify2(e,t);var r=e.isub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r};Red.prototype.shl=function shl(e,t){this._verify1(e);return this.imod(e.ushln(t))};Red.prototype.imul=function imul(e,t){this._verify2(e,t);return this.imod(e.imul(t))};Red.prototype.mul=function mul(e,t){this._verify2(e,t);return this.imod(e.mul(t))};Red.prototype.isqr=function isqr(e){return this.imul(e,e.clone())};Red.prototype.sqr=function sqr(e){return this.mul(e,e)};Red.prototype.sqrt=function sqrt(e){if(e.isZero())return e.clone();var t=this.m.andln(3);assert(t%2===1);if(t===3){var r=this.m.add(new BN(1)).iushrn(2);return this.pow(e,r)}var i=this.m.subn(1);var n=0;while(!i.isZero()&&i.andln(1)===0){n++;i.iushrn(1)}assert(!i.isZero());var a=new BN(1).toRed(this);var s=a.redNeg();var o=this.m.subn(1).iushrn(1);var h=this.m.bitLength();h=new BN(2*h*h).toRed(this);while(this.pow(h,o).cmp(s)!==0){h.redIAdd(s)}var u=this.pow(h,i);var d=this.pow(e,i.addn(1).iushrn(1));var c=this.pow(e,i);var l=n;while(c.cmp(a)!==0){var p=c;for(var v=0;p.cmp(a)!==0;v++){p=p.redSqr()}assert(v<l);var b=this.pow(u,new BN(1).iushln(l-v-1));d=d.redMul(b);u=b.redSqr();c=c.redMul(u);l=v}return d};Red.prototype.invm=function invm(e){var t=e._invmp(this.m);if(t.negative!==0){t.negative=0;return this.imod(t).redNeg()}else{return this.imod(t)}};Red.prototype.pow=function pow(e,t){if(t.isZero())return new BN(1).toRed(this);if(t.cmpn(1)===0)return e.clone();var r=4;var i=new Array(1<<r);i[0]=new BN(1).toRed(this);i[1]=e;for(var n=2;n<i.length;n++){i[n]=this.mul(i[n-1],e)}var a=i[0];var s=0;var o=0;var h=t.bitLength()%26;if(h===0){h=26}for(n=t.length-1;n>=0;n--){var u=t.words[n];for(var d=h-1;d>=0;d--){var c=u>>d&1;if(a!==i[0]){a=this.sqr(a)}if(c===0&&s===0){o=0;continue}s<<=1;s|=c;o++;if(o!==r&&(n!==0||d!==0))continue;a=this.mul(a,i[s]);o=0;s=0}h=26}return a};Red.prototype.convertTo=function convertTo(e){var t=e.umod(this.m);return t===e?t.clone():t};Red.prototype.convertFrom=function convertFrom(e){var t=e.clone();t.red=null;return t};BN.mont=function mont(e){return new Mont(e)};function Mont(e){Red.call(this,e);this.shift=this.m.bitLength();if(this.shift%26!==0){this.shift+=26-this.shift%26}this.r=new BN(1).iushln(this.shift);this.r2=this.imod(this.r.sqr());this.rinv=this.r._invmp(this.m);this.minv=this.rinv.mul(this.r).isubn(1).div(this.m);this.minv=this.minv.umod(this.r);this.minv=this.r.sub(this.minv)}inherits(Mont,Red);Mont.prototype.convertTo=function convertTo(e){return this.imod(e.ushln(this.shift))};Mont.prototype.convertFrom=function convertFrom(e){var t=this.imod(e.mul(this.rinv));t.red=null;return t};Mont.prototype.imul=function imul(e,t){if(e.isZero()||t.isZero()){e.words[0]=0;e.length=1;return e}var r=e.imul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.mul=function mul(e,t){if(e.isZero()||t.isZero())return new BN(0)._forceRed(this);var r=e.mul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.invm=function invm(e){var t=this.imod(e._invmp(this.m).mul(this.r2));return t._forceRed(this)}})( false||e,this)},3500:function(e,t,r){var i;e.exports=function rand(e){if(!i)i=new Rand(null);return i.generate(e)};function Rand(e){this.rand=e}e.exports.Rand=Rand;Rand.prototype.generate=function generate(e){return this._rand(e)};Rand.prototype._rand=function _rand(e){if(this.rand.getBytes)return this.rand.getBytes(e);var t=new Uint8Array(e);for(var r=0;r<t.length;r++)t[r]=this.rand.getByte();return t};if(typeof self==="object"){if(self.crypto&&self.crypto.getRandomValues){Rand.prototype._rand=function _rand(e){var t=new Uint8Array(e);self.crypto.getRandomValues(t);return t}}else if(self.msCrypto&&self.msCrypto.getRandomValues){Rand.prototype._rand=function _rand(e){var t=new Uint8Array(e);self.msCrypto.getRandomValues(t);return t}}else if(typeof window==="object"){Rand.prototype._rand=function(){throw new Error("Not implemented yet")}}}else{try{var n=r(6113);if(typeof n.randomBytes!=="function")throw new Error("Not supported");Rand.prototype._rand=function _rand(e){return n.randomBytes(e)}}catch(e){}}},1387:function(e,t,r){var i=r(5055).Buffer;function asUInt32Array(e){if(!i.isBuffer(e))e=i.from(e);var t=e.length/4|0;var r=new Array(t);for(var n=0;n<t;n++){r[n]=e.readUInt32BE(n*4)}return r}function scrubVec(e){for(var t=0;t<e.length;e++){e[t]=0}}function cryptBlock(e,t,r,i,n){var a=r[0];var s=r[1];var o=r[2];var h=r[3];var u=e[0]^t[0];var d=e[1]^t[1];var c=e[2]^t[2];var l=e[3]^t[3];var p,v,b,m;var y=4;for(var g=1;g<n;g++){p=a[u>>>24]^s[d>>>16&255]^o[c>>>8&255]^h[l&255]^t[y++];v=a[d>>>24]^s[c>>>16&255]^o[l>>>8&255]^h[u&255]^t[y++];b=a[c>>>24]^s[l>>>16&255]^o[u>>>8&255]^h[d&255]^t[y++];m=a[l>>>24]^s[u>>>16&255]^o[d>>>8&255]^h[c&255]^t[y++];u=p;d=v;c=b;l=m}p=(i[u>>>24]<<24|i[d>>>16&255]<<16|i[c>>>8&255]<<8|i[l&255])^t[y++];v=(i[d>>>24]<<24|i[c>>>16&255]<<16|i[l>>>8&255]<<8|i[u&255])^t[y++];b=(i[c>>>24]<<24|i[l>>>16&255]<<16|i[u>>>8&255]<<8|i[d&255])^t[y++];m=(i[l>>>24]<<24|i[u>>>16&255]<<16|i[d>>>8&255]<<8|i[c&255])^t[y++];p=p>>>0;v=v>>>0;b=b>>>0;m=m>>>0;return[p,v,b,m]}var n=[0,1,2,4,8,16,32,64,128,27,54];var a=function(){var e=new Array(256);for(var t=0;t<256;t++){if(t<128){e[t]=t<<1}else{e[t]=t<<1^283}}var r=[];var i=[];var n=[[],[],[],[]];var a=[[],[],[],[]];var s=0;var o=0;for(var h=0;h<256;++h){var u=o^o<<1^o<<2^o<<3^o<<4;u=u>>>8^u&255^99;r[s]=u;i[u]=s;var d=e[s];var c=e[d];var l=e[c];var p=e[u]*257^u*16843008;n[0][s]=p<<24|p>>>8;n[1][s]=p<<16|p>>>16;n[2][s]=p<<8|p>>>24;n[3][s]=p;p=l*16843009^c*65537^d*257^s*16843008;a[0][u]=p<<24|p>>>8;a[1][u]=p<<16|p>>>16;a[2][u]=p<<8|p>>>24;a[3][u]=p;if(s===0){s=o=1}else{s=d^e[e[e[l^d]]];o^=e[e[o]]}}return{SBOX:r,INV_SBOX:i,SUB_MIX:n,INV_SUB_MIX:a}}();function AES(e){this._key=asUInt32Array(e);this._reset()}AES.blockSize=4*4;AES.keySize=256/8;AES.prototype.blockSize=AES.blockSize;AES.prototype.keySize=AES.keySize;AES.prototype._reset=function(){var e=this._key;var t=e.length;var r=t+6;var i=(r+1)*4;var s=[];for(var o=0;o<t;o++){s[o]=e[o]}for(o=t;o<i;o++){var h=s[o-1];if(o%t===0){h=h<<8|h>>>24;h=a.SBOX[h>>>24]<<24|a.SBOX[h>>>16&255]<<16|a.SBOX[h>>>8&255]<<8|a.SBOX[h&255];h^=n[o/t|0]<<24}else if(t>6&&o%t===4){h=a.SBOX[h>>>24]<<24|a.SBOX[h>>>16&255]<<16|a.SBOX[h>>>8&255]<<8|a.SBOX[h&255]}s[o]=s[o-t]^h}var u=[];for(var d=0;d<i;d++){var c=i-d;var l=s[c-(d%4?0:4)];if(d<4||c<=4){u[d]=l}else{u[d]=a.INV_SUB_MIX[0][a.SBOX[l>>>24]]^a.INV_SUB_MIX[1][a.SBOX[l>>>16&255]]^a.INV_SUB_MIX[2][a.SBOX[l>>>8&255]]^a.INV_SUB_MIX[3][a.SBOX[l&255]]}}this._nRounds=r;this._keySchedule=s;this._invKeySchedule=u};AES.prototype.encryptBlockRaw=function(e){e=asUInt32Array(e);return cryptBlock(e,this._keySchedule,a.SUB_MIX,a.SBOX,this._nRounds)};AES.prototype.encryptBlock=function(e){var t=this.encryptBlockRaw(e);var r=i.allocUnsafe(16);r.writeUInt32BE(t[0],0);r.writeUInt32BE(t[1],4);r.writeUInt32BE(t[2],8);r.writeUInt32BE(t[3],12);return r};AES.prototype.decryptBlock=function(e){e=asUInt32Array(e);var t=e[1];e[1]=e[3];e[3]=t;var r=cryptBlock(e,this._invKeySchedule,a.INV_SUB_MIX,a.INV_SBOX,this._nRounds);var n=i.allocUnsafe(16);n.writeUInt32BE(r[0],0);n.writeUInt32BE(r[3],4);n.writeUInt32BE(r[2],8);n.writeUInt32BE(r[1],12);return n};AES.prototype.scrub=function(){scrubVec(this._keySchedule);scrubVec(this._invKeySchedule);scrubVec(this._key)};e.exports.AES=AES},6624:function(e,t,r){var i=r(1387);var n=r(5055).Buffer;var a=r(1043);var s=r(3782);var o=r(7225);var h=r(4734);var u=r(598);function xorTest(e,t){var r=0;if(e.length!==t.length)r++;var i=Math.min(e.length,t.length);for(var n=0;n<i;++n){r+=e[n]^t[n]}return r}function calcIv(e,t,r){if(t.length===12){e._finID=n.concat([t,n.from([0,0,0,1])]);return n.concat([t,n.from([0,0,0,2])])}var i=new o(r);var a=t.length;var s=a%16;i.update(t);if(s){s=16-s;i.update(n.alloc(s,0))}i.update(n.alloc(8,0));var h=a*8;var d=n.alloc(8);d.writeUIntBE(h,0,8);i.update(d);e._finID=i.state;var c=n.from(e._finID);u(c);return c}function StreamCipher(e,t,r,s){a.call(this);var h=n.alloc(4,0);this._cipher=new i.AES(t);var u=this._cipher.encryptBlock(h);this._ghash=new o(u);r=calcIv(this,r,u);this._prev=n.from(r);this._cache=n.allocUnsafe(0);this._secCache=n.allocUnsafe(0);this._decrypt=s;this._alen=0;this._len=0;this._mode=e;this._authTag=null;this._called=false}s(StreamCipher,a);StreamCipher.prototype._update=function(e){if(!this._called&&this._alen){var t=16-this._alen%16;if(t<16){t=n.alloc(t,0);this._ghash.update(t)}}this._called=true;var r=this._mode.encrypt(this,e);if(this._decrypt){this._ghash.update(e)}else{this._ghash.update(r)}this._len+=e.length;return r};StreamCipher.prototype._final=function(){if(this._decrypt&&!this._authTag)throw new Error("Unsupported state or unable to authenticate data");var e=h(this._ghash.final(this._alen*8,this._len*8),this._cipher.encryptBlock(this._finID));if(this._decrypt&&xorTest(e,this._authTag))throw new Error("Unsupported state or unable to authenticate data");this._authTag=e;this._cipher.scrub()};StreamCipher.prototype.getAuthTag=function getAuthTag(){if(this._decrypt||!n.isBuffer(this._authTag))throw new Error("Attempting to get auth tag in unsupported state");return this._authTag};StreamCipher.prototype.setAuthTag=function setAuthTag(e){if(!this._decrypt)throw new Error("Attempting to set auth tag in unsupported state");this._authTag=e};StreamCipher.prototype.setAAD=function setAAD(e){if(this._called)throw new Error("Attempting to set AAD in unsupported state");this._ghash.update(e);this._alen+=e.length};e.exports=StreamCipher},6594:function(e,t,r){var i=r(2);var n=r(2598);var a=r(5866);function getCiphers(){return Object.keys(a)}t.createCipher=t.Cipher=i.createCipher;t.createCipheriv=t.Cipheriv=i.createCipheriv;t.createDecipher=t.Decipher=n.createDecipher;t.createDecipheriv=t.Decipheriv=n.createDecipheriv;t.listCiphers=t.getCiphers=getCiphers},2598:function(e,t,r){var i=r(6624);var n=r(5055).Buffer;var a=r(6370);var s=r(126);var o=r(1043);var h=r(1387);var u=r(8368);var d=r(3782);function Decipher(e,t,r){o.call(this);this._cache=new Splitter;this._last=void 0;this._cipher=new h.AES(t);this._prev=n.from(r);this._mode=e;this._autopadding=true}d(Decipher,o);Decipher.prototype._update=function(e){this._cache.add(e);var t;var r;var i=[];while(t=this._cache.get(this._autopadding)){r=this._mode.decrypt(this,t);i.push(r)}return n.concat(i)};Decipher.prototype._final=function(){var e=this._cache.flush();if(this._autopadding){return unpad(this._mode.decrypt(this,e))}else if(e){throw new Error("data not multiple of block length")}};Decipher.prototype.setAutoPadding=function(e){this._autopadding=!!e;return this};function Splitter(){this.cache=n.allocUnsafe(0)}Splitter.prototype.add=function(e){this.cache=n.concat([this.cache,e])};Splitter.prototype.get=function(e){var t;if(e){if(this.cache.length>16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);return t}}else{if(this.cache.length>=16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);return t}}return null};Splitter.prototype.flush=function(){if(this.cache.length)return this.cache};function unpad(e){var t=e[15];if(t<1||t>16){throw new Error("unable to decrypt data")}var r=-1;while(++r<t){if(e[r+(16-t)]!==t){throw new Error("unable to decrypt data")}}if(t===16)return;return e.slice(0,16-t)}function createDecipheriv(e,t,r){var o=a[e.toLowerCase()];if(!o)throw new TypeError("invalid suite type");if(typeof r==="string")r=n.from(r);if(o.mode!=="GCM"&&r.length!==o.iv)throw new TypeError("invalid iv length "+r.length);if(typeof t==="string")t=n.from(t);if(t.length!==o.key/8)throw new TypeError("invalid key length "+t.length);if(o.type==="stream"){return new s(o.module,t,r,true)}else if(o.type==="auth"){return new i(o.module,t,r,true)}return new Decipher(o.module,t,r)}function createDecipher(e,t){var r=a[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");var i=u(t,false,r.key,r.iv);return createDecipheriv(e,i.key,i.iv)}t.createDecipher=createDecipher;t.createDecipheriv=createDecipheriv},2:function(e,t,r){var i=r(6370);var n=r(6624);var a=r(5055).Buffer;var s=r(126);var o=r(1043);var h=r(1387);var u=r(8368);var d=r(3782);function Cipher(e,t,r){o.call(this);this._cache=new Splitter;this._cipher=new h.AES(t);this._prev=a.from(r);this._mode=e;this._autopadding=true}d(Cipher,o);Cipher.prototype._update=function(e){this._cache.add(e);var t;var r;var i=[];while(t=this._cache.get()){r=this._mode.encrypt(this,t);i.push(r)}return a.concat(i)};var c=a.alloc(16,16);Cipher.prototype._final=function(){var e=this._cache.flush();if(this._autopadding){e=this._mode.encrypt(this,e);this._cipher.scrub();return e}if(!e.equals(c)){this._cipher.scrub();throw new Error("data not multiple of block length")}};Cipher.prototype.setAutoPadding=function(e){this._autopadding=!!e;return this};function Splitter(){this.cache=a.allocUnsafe(0)}Splitter.prototype.add=function(e){this.cache=a.concat([this.cache,e])};Splitter.prototype.get=function(){if(this.cache.length>15){var e=this.cache.slice(0,16);this.cache=this.cache.slice(16);return e}return null};Splitter.prototype.flush=function(){var e=16-this.cache.length;var t=a.allocUnsafe(e);var r=-1;while(++r<e){t.writeUInt8(e,r)}return a.concat([this.cache,t])};function createCipheriv(e,t,r){var o=i[e.toLowerCase()];if(!o)throw new TypeError("invalid suite type");if(typeof t==="string")t=a.from(t);if(t.length!==o.key/8)throw new TypeError("invalid key length "+t.length);if(typeof r==="string")r=a.from(r);if(o.mode!=="GCM"&&r.length!==o.iv)throw new TypeError("invalid iv length "+r.length);if(o.type==="stream"){return new s(o.module,t,r)}else if(o.type==="auth"){return new n(o.module,t,r)}return new Cipher(o.module,t,r)}function createCipher(e,t){var r=i[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");var n=u(t,false,r.key,r.iv);return createCipheriv(e,n.key,n.iv)}t.createCipheriv=createCipheriv;t.createCipher=createCipher},7225:function(e,t,r){var i=r(5055).Buffer;var n=i.alloc(16,0);function toArray(e){return[e.readUInt32BE(0),e.readUInt32BE(4),e.readUInt32BE(8),e.readUInt32BE(12)]}function fromArray(e){var t=i.allocUnsafe(16);t.writeUInt32BE(e[0]>>>0,0);t.writeUInt32BE(e[1]>>>0,4);t.writeUInt32BE(e[2]>>>0,8);t.writeUInt32BE(e[3]>>>0,12);return t}function GHASH(e){this.h=e;this.state=i.alloc(16,0);this.cache=i.allocUnsafe(0)}GHASH.prototype.ghash=function(e){var t=-1;while(++t<e.length){this.state[t]^=e[t]}this._multiply()};GHASH.prototype._multiply=function(){var e=toArray(this.h);var t=[0,0,0,0];var r,i,n;var a=-1;while(++a<128){i=(this.state[~~(a/8)]&1<<7-a%8)!==0;if(i){t[0]^=e[0];t[1]^=e[1];t[2]^=e[2];t[3]^=e[3]}n=(e[3]&1)!==0;for(r=3;r>0;r--){e[r]=e[r]>>>1|(e[r-1]&1)<<31}e[0]=e[0]>>>1;if(n){e[0]=e[0]^225<<24}}this.state=fromArray(t)};GHASH.prototype.update=function(e){this.cache=i.concat([this.cache,e]);var t;while(this.cache.length>=16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);this.ghash(t)}};GHASH.prototype.final=function(e,t){if(this.cache.length){this.ghash(i.concat([this.cache,n],16))}this.ghash(fromArray([0,e,0,t]));return this.state};e.exports=GHASH},598:function(e){function incr32(e){var t=e.length;var r;while(t--){r=e.readUInt8(t);if(r===255){e.writeUInt8(0,t)}else{r++;e.writeUInt8(r,t);break}}}e.exports=incr32},9825:function(e,t,r){var i=r(4734);t.encrypt=function(e,t){var r=i(t,e._prev);e._prev=e._cipher.encryptBlock(r);return e._prev};t.decrypt=function(e,t){var r=e._prev;e._prev=t;var n=e._cipher.decryptBlock(t);return i(n,r)}},321:function(e,t,r){var i=r(5055).Buffer;var n=r(4734);function encryptStart(e,t,r){var a=t.length;var s=n(t,e._cache);e._cache=e._cache.slice(a);e._prev=i.concat([e._prev,r?t:s]);return s}t.encrypt=function(e,t,r){var n=i.allocUnsafe(0);var a;while(t.length){if(e._cache.length===0){e._cache=e._cipher.encryptBlock(e._prev);e._prev=i.allocUnsafe(0)}if(e._cache.length<=t.length){a=e._cache.length;n=i.concat([n,encryptStart(e,t.slice(0,a),r)]);t=t.slice(a)}else{n=i.concat([n,encryptStart(e,t,r)]);break}}return n}},3147:function(e,t,r){var i=r(5055).Buffer;function encryptByte(e,t,r){var i;var n=-1;var a=8;var s=0;var o,h;while(++n<a){i=e._cipher.encryptBlock(e._prev);o=t&1<<7-n?128:0;h=i[0]^o;s+=(h&128)>>n%8;e._prev=shiftIn(e._prev,r?o:h)}return s}function shiftIn(e,t){var r=e.length;var n=-1;var a=i.allocUnsafe(e.length);e=i.concat([e,i.from([t])]);while(++n<r){a[n]=e[n]<<1|e[n+1]>>7}return a}t.encrypt=function(e,t,r){var n=t.length;var a=i.allocUnsafe(n);var s=-1;while(++s<n){a[s]=encryptByte(e,t[s],r)}return a}},2430:function(e,t,r){var i=r(5055).Buffer;function encryptByte(e,t,r){var n=e._cipher.encryptBlock(e._prev);var a=n[0]^t;e._prev=i.concat([e._prev.slice(1),i.from([r?t:a])]);return a}t.encrypt=function(e,t,r){var n=t.length;var a=i.allocUnsafe(n);var s=-1;while(++s<n){a[s]=encryptByte(e,t[s],r)}return a}},3361:function(e,t,r){var i=r(4734);var n=r(5055).Buffer;var a=r(598);function getBlock(e){var t=e._cipher.encryptBlockRaw(e._prev);a(e._prev);return t}var s=16;t.encrypt=function(e,t){var r=Math.ceil(t.length/s);var a=e._cache.length;e._cache=n.concat([e._cache,n.allocUnsafe(r*s)]);for(var o=0;o<r;o++){var h=getBlock(e);var u=a+o*s;e._cache.writeUInt32BE(h[0],u+0);e._cache.writeUInt32BE(h[1],u+4);e._cache.writeUInt32BE(h[2],u+8);e._cache.writeUInt32BE(h[3],u+12)}var d=e._cache.slice(0,t.length);e._cache=e._cache.slice(t.length);return i(t,d)}},1590:function(e,t){t.encrypt=function(e,t){return e._cipher.encryptBlock(t)};t.decrypt=function(e,t){return e._cipher.decryptBlock(t)}},6370:function(e,t,r){var i={ECB:r(1590),CBC:r(9825),CFB:r(321),CFB8:r(2430),CFB1:r(3147),OFB:r(3412),CTR:r(3361),GCM:r(3361)};var n=r(5866);for(var a in n){n[a].module=i[n[a].mode]}e.exports=n},3412:function(e,t,r){var i=r(4734);function getBlock(e){e._prev=e._cipher.encryptBlock(e._prev);return e._prev}t.encrypt=function(e,t){while(e._cache.length<t.length){e._cache=Buffer.concat([e._cache,getBlock(e)])}var r=e._cache.slice(0,t.length);e._cache=e._cache.slice(t.length);return i(t,r)}},126:function(e,t,r){var i=r(1387);var n=r(5055).Buffer;var a=r(1043);var s=r(3782);function StreamCipher(e,t,r,s){a.call(this);this._cipher=new i.AES(t);this._prev=n.from(r);this._cache=n.allocUnsafe(0);this._secCache=n.allocUnsafe(0);this._decrypt=s;this._mode=e}s(StreamCipher,a);StreamCipher.prototype._update=function(e){return this._mode.encrypt(this,e,this._decrypt)};StreamCipher.prototype._final=function(){this._cipher.scrub()};e.exports=StreamCipher},8996:function(e,t,r){var i=r(5238);var n=r(6594);var a=r(6370);var s=r(6280);var o=r(8368);function createCipher(e,t){e=e.toLowerCase();var r,i;if(a[e]){r=a[e].key;i=a[e].iv}else if(s[e]){r=s[e].key*8;i=s[e].iv}else{throw new TypeError("invalid suite type")}var n=o(t,false,r,i);return createCipheriv(e,n.key,n.iv)}function createDecipher(e,t){e=e.toLowerCase();var r,i;if(a[e]){r=a[e].key;i=a[e].iv}else if(s[e]){r=s[e].key*8;i=s[e].iv}else{throw new TypeError("invalid suite type")}var n=o(t,false,r,i);return createDecipheriv(e,n.key,n.iv)}function createCipheriv(e,t,r){e=e.toLowerCase();if(a[e])return n.createCipheriv(e,t,r);if(s[e])return new i({key:t,iv:r,mode:e});throw new TypeError("invalid suite type")}function createDecipheriv(e,t,r){e=e.toLowerCase();if(a[e])return n.createDecipheriv(e,t,r);if(s[e])return new i({key:t,iv:r,mode:e,decrypt:true});throw new TypeError("invalid suite type")}function getCiphers(){return Object.keys(s).concat(n.getCiphers())}t.createCipher=t.Cipher=createCipher;t.createCipheriv=t.Cipheriv=createCipheriv;t.createDecipher=t.Decipher=createDecipher;t.createDecipheriv=t.Decipheriv=createDecipheriv;t.listCiphers=t.getCiphers=getCiphers},5238:function(e,t,r){var i=r(1043);var n=r(9536);var a=r(3782);var s=r(5055).Buffer;var o={"des-ede3-cbc":n.CBC.instantiate(n.EDE),"des-ede3":n.EDE,"des-ede-cbc":n.CBC.instantiate(n.EDE),"des-ede":n.EDE,"des-cbc":n.CBC.instantiate(n.DES),"des-ecb":n.DES};o.des=o["des-cbc"];o.des3=o["des-ede3-cbc"];e.exports=DES;a(DES,i);function DES(e){i.call(this);var t=e.mode.toLowerCase();var r=o[t];var n;if(e.decrypt){n="decrypt"}else{n="encrypt"}var a=e.key;if(!s.isBuffer(a)){a=s.from(a)}if(t==="des-ede"||t==="des-ede-cbc"){a=s.concat([a,a.slice(0,8)])}var h=e.iv;if(!s.isBuffer(h)){h=s.from(h)}this._des=r.create({key:a,iv:h,type:n})}DES.prototype._update=function(e){return s.from(this._des.update(e))};DES.prototype._final=function(){return s.from(this._des.final())}},6280:function(e,t){t["des-ecb"]={key:8,iv:0};t["des-cbc"]=t.des={key:8,iv:8};t["des-ede3-cbc"]=t.des3={key:24,iv:8};t["des-ede3"]={key:24,iv:0};t["des-ede-cbc"]={key:16,iv:8};t["des-ede"]={key:16,iv:0}},7166:function(e,t,r){var i=r(711);var n=r(7223);e.exports=crt;function blind(e){var t=getr(e);var r=t.toRed(i.mont(e.modulus)).redPow(new i(e.publicExponent)).fromRed();return{blinder:r,unblinder:t.invm(e.modulus)}}function crt(e,t){var r=blind(t);var n=t.modulus.byteLength();var a=i.mont(t.modulus);var s=new i(e).mul(r.blinder).umod(t.modulus);var o=s.toRed(i.mont(t.prime1));var h=s.toRed(i.mont(t.prime2));var u=t.coefficient;var d=t.prime1;var c=t.prime2;var l=o.redPow(t.exponent1);var p=h.redPow(t.exponent2);l=l.fromRed();p=p.fromRed();var v=l.isub(p).imul(u).umod(d);v.imul(c);p.iadd(v);return new Buffer(p.imul(r.unblinder).umod(t.modulus).toArray(false,n))}crt.getr=getr;function getr(e){var t=e.modulus.byteLength();var r=new i(n(t));while(r.cmp(e.modulus)>=0||!r.umod(e.prime1)||!r.umod(e.prime2)){r=new i(n(t))}return r}},9276:function(e,t,r){e.exports=r(2908)},4078:function(e,t,r){var i=r(5055).Buffer;var n=r(9739);var a=r(3726);var s=r(3782);var o=r(9807);var h=r(4013);var u=r(2908);Object.keys(u).forEach((function(e){u[e].id=i.from(u[e].id,"hex");u[e.toLowerCase()]=u[e]}));function Sign(e){a.Writable.call(this);var t=u[e];if(!t)throw new Error("Unknown message digest");this._hashType=t.hash;this._hash=n(t.hash);this._tag=t.id;this._signType=t.sign}s(Sign,a.Writable);Sign.prototype._write=function _write(e,t,r){this._hash.update(e);r()};Sign.prototype.update=function update(e,t){if(typeof e==="string")e=i.from(e,t);this._hash.update(e);return this};Sign.prototype.sign=function signMethod(e,t){this.end();var r=this._hash.digest();var i=o(r,e,this._hashType,this._signType,this._tag);return t?i.toString(t):i};function Verify(e){a.Writable.call(this);var t=u[e];if(!t)throw new Error("Unknown message digest");this._hash=n(t.hash);this._tag=t.id;this._signType=t.sign}s(Verify,a.Writable);Verify.prototype._write=function _write(e,t,r){this._hash.update(e);r()};Verify.prototype.update=function update(e,t){if(typeof e==="string")e=i.from(e,t);this._hash.update(e);return this};Verify.prototype.verify=function verifyMethod(e,t,r){if(typeof t==="string")t=i.from(t,r);this.end();var n=this._hash.digest();return h(t,n,e,this._signType,this._tag)};function createSign(e){return new Sign(e)}function createVerify(e){return new Verify(e)}e.exports={Sign:createSign,Verify:createVerify,createSign:createSign,createVerify:createVerify}},9807:function(e,t,r){var i=r(5055).Buffer;var n=r(4873);var a=r(7166);var s=r(949).ec;var o=r(1670);var h=r(9902);var u=r(9267);function sign(e,t,r,n,s){var o=h(t);if(o.curve){if(n!=="ecdsa"&&n!=="ecdsa/rsa")throw new Error("wrong private key type");return ecSign(e,o)}else if(o.type==="dsa"){if(n!=="dsa")throw new Error("wrong private key type");return dsaSign(e,o,r)}else{if(n!=="rsa"&&n!=="ecdsa/rsa")throw new Error("wrong private key type")}e=i.concat([s,e]);var u=o.modulus.byteLength();var d=[0,1];while(e.length+d.length+1<u)d.push(255);d.push(0);var c=-1;while(++c<e.length)d.push(e[c]);var l=a(d,o);return l}function ecSign(e,t){var r=u[t.curve.join(".")];if(!r)throw new Error("unknown curve "+t.curve.join("."));var n=new s(r);var a=n.keyFromPrivate(t.privateKey);var o=a.sign(e);return i.from(o.toDER())}function dsaSign(e,t,r){var i=t.params.priv_key;var n=t.params.p;var a=t.params.q;var s=t.params.g;var h=new o(0);var u;var d=bits2int(e,a).mod(a);var c=false;var l=getKey(i,a,e,r);while(c===false){u=makeKey(a,l,r);h=makeR(s,u,n,a);c=u.invm(a).imul(d.add(i.mul(h))).mod(a);if(c.cmpn(0)===0){c=false;h=new o(0)}}return toDER(h,c)}function toDER(e,t){e=e.toArray();t=t.toArray();if(e[0]&128)e=[0].concat(e);if(t[0]&128)t=[0].concat(t);var r=e.length+t.length+4;var n=[48,r,2,e.length];n=n.concat(e,[2,t.length],t);return i.from(n)}function getKey(e,t,r,a){e=i.from(e.toArray());if(e.length<t.byteLength()){var s=i.alloc(t.byteLength()-e.length);e=i.concat([s,e])}var o=r.length;var h=bits2octets(r,t);var u=i.alloc(o);u.fill(1);var d=i.alloc(o);d=n(a,d).update(u).update(i.from([0])).update(e).update(h).digest();u=n(a,d).update(u).digest();d=n(a,d).update(u).update(i.from([1])).update(e).update(h).digest();u=n(a,d).update(u).digest();return{k:d,v:u}}function bits2int(e,t){var r=new o(e);var i=(e.length<<3)-t.bitLength();if(i>0)r.ishrn(i);return r}function bits2octets(e,t){e=bits2int(e,t);e=e.mod(t);var r=i.from(e.toArray());if(r.length<t.byteLength()){var n=i.alloc(t.byteLength()-r.length);r=i.concat([n,r])}return r}function makeKey(e,t,r){var a;var s;do{a=i.alloc(0);while(a.length*8<e.bitLength()){t.v=n(r,t.k).update(t.v).digest();a=i.concat([a,t.v])}s=bits2int(a,e);t.k=n(r,t.k).update(t.v).update(i.from([0])).digest();t.v=n(r,t.k).update(t.v).digest()}while(s.cmp(e)!==-1);return s}function makeR(e,t,r,i){return e.toRed(o.mont(r)).redPow(t).fromRed().mod(i)}e.exports=sign;e.exports.getKey=getKey;e.exports.makeKey=makeKey},4013:function(e,t,r){var i=r(5055).Buffer;var n=r(1670);var a=r(949).ec;var s=r(9902);var o=r(9267);function verify(e,t,r,a,o){var h=s(r);if(h.type==="ec"){if(a!=="ecdsa"&&a!=="ecdsa/rsa")throw new Error("wrong public key type");return ecVerify(e,t,h)}else if(h.type==="dsa"){if(a!=="dsa")throw new Error("wrong public key type");return dsaVerify(e,t,h)}else{if(a!=="rsa"&&a!=="ecdsa/rsa")throw new Error("wrong public key type")}t=i.concat([o,t]);var u=h.modulus.byteLength();var d=[1];var c=0;while(t.length+d.length+2<u){d.push(255);c++}d.push(0);var l=-1;while(++l<t.length){d.push(t[l])}d=i.from(d);var p=n.mont(h.modulus);e=new n(e).toRed(p);e=e.redPow(new n(h.publicExponent));e=i.from(e.fromRed().toArray());var v=c<8?1:0;u=Math.min(e.length,d.length);if(e.length!==d.length)v=1;l=-1;while(++l<u)v|=e[l]^d[l];return v===0}function ecVerify(e,t,r){var i=o[r.data.algorithm.curve.join(".")];if(!i)throw new Error("unknown curve "+r.data.algorithm.curve.join("."));var n=new a(i);var s=r.data.subjectPrivateKey.data;return n.verify(t,e,s)}function dsaVerify(e,t,r){var i=r.data.p;var a=r.data.q;var o=r.data.g;var h=r.data.pub_key;var u=s.signature.decode(e,"der");var d=u.s;var c=u.r;checkValue(d,a);checkValue(c,a);var l=n.mont(i);var p=d.invm(a);var v=o.toRed(l).redPow(new n(t).mul(p).mod(a)).fromRed().mul(h.toRed(l).redPow(c.mul(p).mod(a)).fromRed()).mod(i).mod(a);return v.cmp(c)===0}function checkValue(e,t){if(e.cmpn(0)<=0)throw new Error("invalid sig");if(e.cmp(t)>=t)throw new Error("invalid sig")}e.exports=verify},4734:function(e){e.exports=function xor(e,t){var r=Math.min(e.length,t.length);var i=new Buffer(r);for(var n=0;n<r;++n){i[n]=e[n]^t[n]}return i}},1043:function(e,t,r){var i=r(5055).Buffer;var n=r(2781).Transform;var a=r(1576).StringDecoder;var s=r(3782);function CipherBase(e){n.call(this);this.hashMode=typeof e==="string";if(this.hashMode){this[e]=this._finalOrDigest}else{this.final=this._finalOrDigest}if(this._final){this.__final=this._final;this._final=null}this._decoder=null;this._encoding=null}s(CipherBase,n);CipherBase.prototype.update=function(e,t,r){if(typeof e==="string"){e=i.from(e,t)}var n=this._update(e);if(this.hashMode)return this;if(r){n=this._toString(n,r)}return n};CipherBase.prototype.setAutoPadding=function(){};CipherBase.prototype.getAuthTag=function(){throw new Error("trying to get auth tag in unsupported state")};CipherBase.prototype.setAuthTag=function(){throw new Error("trying to set auth tag in unsupported state")};CipherBase.prototype.setAAD=function(){throw new Error("trying to set aad in unsupported state")};CipherBase.prototype._transform=function(e,t,r){var i;try{if(this.hashMode){this._update(e)}else{this.push(this._update(e))}}catch(e){i=e}finally{r(i)}};CipherBase.prototype._flush=function(e){var t;try{this.push(this.__final())}catch(e){t=e}e(t)};CipherBase.prototype._finalOrDigest=function(e){var t=this.__final()||i.alloc(0);if(e){t=this._toString(t,e,true)}return t};CipherBase.prototype._toString=function(e,t,r){if(!this._decoder){this._decoder=new a(t);this._encoding=t}if(this._encoding!==t)throw new Error("can't switch encodings");var i=this._decoder.write(e);if(r){i+=this._decoder.end()}return i};e.exports=CipherBase},9942:function(e,t,r){var i=r(949);var n=r(711);e.exports=function createECDH(e){return new ECDH(e)};var a={secp256k1:{name:"secp256k1",byteLength:32},secp224r1:{name:"p224",byteLength:28},prime256v1:{name:"p256",byteLength:32},prime192v1:{name:"p192",byteLength:24},ed25519:{name:"ed25519",byteLength:32},secp384r1:{name:"p384",byteLength:48},secp521r1:{name:"p521",byteLength:66}};a.p224=a.secp224r1;a.p256=a.secp256r1=a.prime256v1;a.p192=a.secp192r1=a.prime192v1;a.p384=a.secp384r1;a.p521=a.secp521r1;function ECDH(e){this.curveType=a[e];if(!this.curveType){this.curveType={name:e}}this.curve=new i.ec(this.curveType.name);this.keys=void 0}ECDH.prototype.generateKeys=function(e,t){this.keys=this.curve.genKeyPair();return this.getPublicKey(e,t)};ECDH.prototype.computeSecret=function(e,t,r){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}var i=this.curve.keyFromPublic(e).getPublic();var n=i.mul(this.keys.getPrivate()).getX();return formatReturnValue(n,r,this.curveType.byteLength)};ECDH.prototype.getPublicKey=function(e,t){var r=this.keys.getPublic(t==="compressed",true);if(t==="hybrid"){if(r[r.length-1]%2){r[0]=7}else{r[0]=6}}return formatReturnValue(r,e)};ECDH.prototype.getPrivateKey=function(e){return formatReturnValue(this.keys.getPrivate(),e)};ECDH.prototype.setPublicKey=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this.keys._importPublic(e);return this};ECDH.prototype.setPrivateKey=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}var r=new n(e);r=r.toString(16);this.keys=this.curve.genKeyPair();this.keys._importPrivate(r);return this};function formatReturnValue(e,t,r){if(!Array.isArray(e)){e=e.toArray()}var i=new Buffer(e);if(r&&i.length<r){var n=new Buffer(r-i.length);n.fill(0);i=Buffer.concat([n,i])}if(!t){return i}else{return i.toString(t)}}},9739:function(e,t,r){"use strict";var i=r(3782);var n=r(3533);var a=r(3225);var s=r(4371);var o=r(1043);function Hash(e){o.call(this,"digest");this._hash=e}i(Hash,o);Hash.prototype._update=function(e){this._hash.update(e)};Hash.prototype._final=function(){return this._hash.digest()};e.exports=function createHash(e){e=e.toLowerCase();if(e==="md5")return new n;if(e==="rmd160"||e==="ripemd160")return new a;return new Hash(s(e))}},450:function(e,t,r){var i=r(3533);e.exports=function(e){return(new i).update(e).digest()}},4873:function(e,t,r){"use strict";var i=r(3782);var n=r(8119);var a=r(1043);var s=r(5055).Buffer;var o=r(450);var h=r(3225);var u=r(4371);var d=s.alloc(128);function Hmac(e,t){a.call(this,"digest");if(typeof t==="string"){t=s.from(t)}var r=e==="sha512"||e==="sha384"?128:64;this._alg=e;this._key=t;if(t.length>r){var i=e==="rmd160"?new h:u(e);t=i.update(t).digest()}else if(t.length<r){t=s.concat([t,d],r)}var n=this._ipad=s.allocUnsafe(r);var o=this._opad=s.allocUnsafe(r);for(var c=0;c<r;c++){n[c]=t[c]^54;o[c]=t[c]^92}this._hash=e==="rmd160"?new h:u(e);this._hash.update(n)}i(Hmac,a);Hmac.prototype._update=function(e){this._hash.update(e)};Hmac.prototype._final=function(){var e=this._hash.digest();var t=this._alg==="rmd160"?new h:u(this._alg);return t.update(this._opad).update(e).digest()};e.exports=function createHmac(e,t){e=e.toLowerCase();if(e==="rmd160"||e==="ripemd160"){return new Hmac("rmd160",t)}if(e==="md5"){return new n(o,t)}return new Hmac(e,t)}},8119:function(e,t,r){"use strict";var i=r(3782);var n=r(5055).Buffer;var a=r(1043);var s=n.alloc(128);var o=64;function Hmac(e,t){a.call(this,"digest");if(typeof t==="string"){t=n.from(t)}this._alg=e;this._key=t;if(t.length>o){t=e(t)}else if(t.length<o){t=n.concat([t,s],o)}var r=this._ipad=n.allocUnsafe(o);var i=this._opad=n.allocUnsafe(o);for(var h=0;h<o;h++){r[h]=t[h]^54;i[h]=t[h]^92}this._hash=[r]}i(Hmac,a);Hmac.prototype._update=function(e){this._hash.push(e)};Hmac.prototype._final=function(){var e=this._alg(n.concat(this._hash));return this._alg(n.concat([this._opad,e]))};e.exports=Hmac},9536:function(e,t,r){"use strict";t.utils=r(5334);t.Cipher=r(9876);t.DES=r(1016);t.CBC=r(8641);t.EDE=r(6159)},8641:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a={};function CBCState(e){i.equal(e.length,8,"Invalid IV length");this.iv=new Array(8);for(var t=0;t<this.iv.length;t++)this.iv[t]=e[t]}function instantiate(e){function CBC(t){e.call(this,t);this._cbcInit()}n(CBC,e);var t=Object.keys(a);for(var r=0;r<t.length;r++){var i=t[r];CBC.prototype[i]=a[i]}CBC.create=function create(e){return new CBC(e)};return CBC}t.instantiate=instantiate;a._cbcInit=function _cbcInit(){var e=new CBCState(this.options.iv);this._cbcState=e};a._update=function _update(e,t,r,i){var n=this._cbcState;var a=this.constructor.super_.prototype;var s=n.iv;if(this.type==="encrypt"){for(var o=0;o<this.blockSize;o++)s[o]^=e[t+o];a._update.call(this,s,0,r,i);for(var o=0;o<this.blockSize;o++)s[o]=r[i+o]}else{a._update.call(this,e,t,r,i);for(var o=0;o<this.blockSize;o++)r[i+o]^=s[o];for(var o=0;o<this.blockSize;o++)s[o]=e[t+o]}}},9876:function(e,t,r){"use strict";var i=r(3523);function Cipher(e){this.options=e;this.type=this.options.type;this.blockSize=8;this._init();this.buffer=new Array(this.blockSize);this.bufferOff=0}e.exports=Cipher;Cipher.prototype._init=function _init(){};Cipher.prototype.update=function update(e){if(e.length===0)return[];if(this.type==="decrypt")return this._updateDecrypt(e);else return this._updateEncrypt(e)};Cipher.prototype._buffer=function _buffer(e,t){var r=Math.min(this.buffer.length-this.bufferOff,e.length-t);for(var i=0;i<r;i++)this.buffer[this.bufferOff+i]=e[t+i];this.bufferOff+=r;return r};Cipher.prototype._flushBuffer=function _flushBuffer(e,t){this._update(this.buffer,0,e,t);this.bufferOff=0;return this.blockSize};Cipher.prototype._updateEncrypt=function _updateEncrypt(e){var t=0;var r=0;var i=(this.bufferOff+e.length)/this.blockSize|0;var n=new Array(i*this.blockSize);if(this.bufferOff!==0){t+=this._buffer(e,t);if(this.bufferOff===this.buffer.length)r+=this._flushBuffer(n,r)}var a=e.length-(e.length-t)%this.blockSize;for(;t<a;t+=this.blockSize){this._update(e,t,n,r);r+=this.blockSize}for(;t<e.length;t++,this.bufferOff++)this.buffer[this.bufferOff]=e[t];return n};Cipher.prototype._updateDecrypt=function _updateDecrypt(e){var t=0;var r=0;var i=Math.ceil((this.bufferOff+e.length)/this.blockSize)-1;var n=new Array(i*this.blockSize);for(;i>0;i--){t+=this._buffer(e,t);r+=this._flushBuffer(n,r)}t+=this._buffer(e,t);return n};Cipher.prototype.final=function final(e){var t;if(e)t=this.update(e);var r;if(this.type==="encrypt")r=this._finalEncrypt();else r=this._finalDecrypt();if(t)return t.concat(r);else return r};Cipher.prototype._pad=function _pad(e,t){if(t===0)return false;while(t<e.length)e[t++]=0;return true};Cipher.prototype._finalEncrypt=function _finalEncrypt(){if(!this._pad(this.buffer,this.bufferOff))return[];var e=new Array(this.blockSize);this._update(this.buffer,0,e,0);return e};Cipher.prototype._unpad=function _unpad(e){return e};Cipher.prototype._finalDecrypt=function _finalDecrypt(){i.equal(this.bufferOff,this.blockSize,"Not enough data to decrypt");var e=new Array(this.blockSize);this._flushBuffer(e,0);return this._unpad(e)}},1016:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a=r(5334);var s=r(9876);function DESState(){this.tmp=new Array(2);this.keys=null}function DES(e){s.call(this,e);var t=new DESState;this._desState=t;this.deriveKeys(t,e.key)}n(DES,s);e.exports=DES;DES.create=function create(e){return new DES(e)};var o=[1,1,2,2,2,2,2,2,1,2,2,2,2,2,2,1];DES.prototype.deriveKeys=function deriveKeys(e,t){e.keys=new Array(16*2);i.equal(t.length,this.blockSize,"Invalid key length");var r=a.readUInt32BE(t,0);var n=a.readUInt32BE(t,4);a.pc1(r,n,e.tmp,0);r=e.tmp[0];n=e.tmp[1];for(var s=0;s<e.keys.length;s+=2){var h=o[s>>>1];r=a.r28shl(r,h);n=a.r28shl(n,h);a.pc2(r,n,e.keys,s)}};DES.prototype._update=function _update(e,t,r,i){var n=this._desState;var s=a.readUInt32BE(e,t);var o=a.readUInt32BE(e,t+4);a.ip(s,o,n.tmp,0);s=n.tmp[0];o=n.tmp[1];if(this.type==="encrypt")this._encrypt(n,s,o,n.tmp,0);else this._decrypt(n,s,o,n.tmp,0);s=n.tmp[0];o=n.tmp[1];a.writeUInt32BE(r,s,i);a.writeUInt32BE(r,o,i+4)};DES.prototype._pad=function _pad(e,t){var r=e.length-t;for(var i=t;i<e.length;i++)e[i]=r;return true};DES.prototype._unpad=function _unpad(e){var t=e[e.length-1];for(var r=e.length-t;r<e.length;r++)i.equal(e[r],t);return e.slice(0,e.length-t)};DES.prototype._encrypt=function _encrypt(e,t,r,i,n){var s=t;var o=r;for(var h=0;h<e.keys.length;h+=2){var u=e.keys[h];var d=e.keys[h+1];a.expand(o,e.tmp,0);u^=e.tmp[0];d^=e.tmp[1];var c=a.substitute(u,d);var l=a.permute(c);var p=o;o=(s^l)>>>0;s=p}a.rip(o,s,i,n)};DES.prototype._decrypt=function _decrypt(e,t,r,i,n){var s=r;var o=t;for(var h=e.keys.length-2;h>=0;h-=2){var u=e.keys[h];var d=e.keys[h+1];a.expand(s,e.tmp,0);u^=e.tmp[0];d^=e.tmp[1];var c=a.substitute(u,d);var l=a.permute(c);var p=s;s=(o^l)>>>0;o=p}a.rip(s,o,i,n)}},6159:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a=r(9876);var s=r(1016);function EDEState(e,t){i.equal(t.length,24,"Invalid key length");var r=t.slice(0,8);var n=t.slice(8,16);var a=t.slice(16,24);if(e==="encrypt"){this.ciphers=[s.create({type:"encrypt",key:r}),s.create({type:"decrypt",key:n}),s.create({type:"encrypt",key:a})]}else{this.ciphers=[s.create({type:"decrypt",key:a}),s.create({type:"encrypt",key:n}),s.create({type:"decrypt",key:r})]}}function EDE(e){a.call(this,e);var t=new EDEState(this.type,this.options.key);this._edeState=t}n(EDE,a);e.exports=EDE;EDE.create=function create(e){return new EDE(e)};EDE.prototype._update=function _update(e,t,r,i){var n=this._edeState;n.ciphers[0]._update(e,t,r,i);n.ciphers[1]._update(r,i,r,i);n.ciphers[2]._update(r,i,r,i)};EDE.prototype._pad=s.prototype._pad;EDE.prototype._unpad=s.prototype._unpad},5334:function(e,t){"use strict";t.readUInt32BE=function readUInt32BE(e,t){var r=e[0+t]<<24|e[1+t]<<16|e[2+t]<<8|e[3+t];return r>>>0};t.writeUInt32BE=function writeUInt32BE(e,t,r){e[0+r]=t>>>24;e[1+r]=t>>>16&255;e[2+r]=t>>>8&255;e[3+r]=t&255};t.ip=function ip(e,t,r,i){var n=0;var a=0;for(var s=6;s>=0;s-=2){for(var o=0;o<=24;o+=8){n<<=1;n|=t>>>o+s&1}for(var o=0;o<=24;o+=8){n<<=1;n|=e>>>o+s&1}}for(var s=6;s>=0;s-=2){for(var o=1;o<=25;o+=8){a<<=1;a|=t>>>o+s&1}for(var o=1;o<=25;o+=8){a<<=1;a|=e>>>o+s&1}}r[i+0]=n>>>0;r[i+1]=a>>>0};t.rip=function rip(e,t,r,i){var n=0;var a=0;for(var s=0;s<4;s++){for(var o=24;o>=0;o-=8){n<<=1;n|=t>>>o+s&1;n<<=1;n|=e>>>o+s&1}}for(var s=4;s<8;s++){for(var o=24;o>=0;o-=8){a<<=1;a|=t>>>o+s&1;a<<=1;a|=e>>>o+s&1}}r[i+0]=n>>>0;r[i+1]=a>>>0};t.pc1=function pc1(e,t,r,i){var n=0;var a=0;for(var s=7;s>=5;s--){for(var o=0;o<=24;o+=8){n<<=1;n|=t>>o+s&1}for(var o=0;o<=24;o+=8){n<<=1;n|=e>>o+s&1}}for(var o=0;o<=24;o+=8){n<<=1;n|=t>>o+s&1}for(var s=1;s<=3;s++){for(var o=0;o<=24;o+=8){a<<=1;a|=t>>o+s&1}for(var o=0;o<=24;o+=8){a<<=1;a|=e>>o+s&1}}for(var o=0;o<=24;o+=8){a<<=1;a|=e>>o+s&1}r[i+0]=n>>>0;r[i+1]=a>>>0};t.r28shl=function r28shl(e,t){return e<<t&268435455|e>>>28-t};var r=[14,11,17,4,27,23,25,0,13,22,7,18,5,9,16,24,2,20,12,21,1,8,15,26,15,4,25,19,9,1,26,16,5,11,23,8,12,7,17,0,22,3,10,14,6,20,27,24];t.pc2=function pc2(e,t,i,n){var a=0;var s=0;var o=r.length>>>1;for(var h=0;h<o;h++){a<<=1;a|=e>>>r[h]&1}for(var h=o;h<r.length;h++){s<<=1;s|=t>>>r[h]&1}i[n+0]=a>>>0;i[n+1]=s>>>0};t.expand=function expand(e,t,r){var i=0;var n=0;i=(e&1)<<5|e>>>27;for(var a=23;a>=15;a-=4){i<<=6;i|=e>>>a&63}for(var a=11;a>=3;a-=4){n|=e>>>a&63;n<<=6}n|=(e&31)<<1|e>>>31;t[r+0]=i>>>0;t[r+1]=n>>>0};var i=[14,0,4,15,13,7,1,4,2,14,15,2,11,13,8,1,3,10,10,6,6,12,12,11,5,9,9,5,0,3,7,8,4,15,1,12,14,8,8,2,13,4,6,9,2,1,11,7,15,5,12,11,9,3,7,14,3,10,10,0,5,6,0,13,15,3,1,13,8,4,14,7,6,15,11,2,3,8,4,14,9,12,7,0,2,1,13,10,12,6,0,9,5,11,10,5,0,13,14,8,7,10,11,1,10,3,4,15,13,4,1,2,5,11,8,6,12,7,6,12,9,0,3,5,2,14,15,9,10,13,0,7,9,0,14,9,6,3,3,4,15,6,5,10,1,2,13,8,12,5,7,14,11,12,4,11,2,15,8,1,13,1,6,10,4,13,9,0,8,6,15,9,3,8,0,7,11,4,1,15,2,14,12,3,5,11,10,5,14,2,7,12,7,13,13,8,14,11,3,5,0,6,6,15,9,0,10,3,1,4,2,7,8,2,5,12,11,1,12,10,4,14,15,9,10,3,6,15,9,0,0,6,12,10,11,1,7,13,13,8,15,9,1,4,3,5,14,11,5,12,2,7,8,2,4,14,2,14,12,11,4,2,1,12,7,4,10,7,11,13,6,1,8,5,5,0,3,15,15,10,13,3,0,9,14,8,9,6,4,11,2,8,1,12,11,7,10,1,13,14,7,2,8,13,15,6,9,15,12,0,5,9,6,10,3,4,0,5,14,3,12,10,1,15,10,4,15,2,9,7,2,12,6,9,8,5,0,6,13,1,3,13,4,14,14,0,7,11,5,3,11,8,9,4,14,3,15,2,5,12,2,9,8,5,12,15,3,10,7,11,0,14,4,1,10,7,1,6,13,0,11,8,6,13,4,13,11,0,2,11,14,7,15,4,0,9,8,1,13,10,3,14,12,3,9,5,7,12,5,2,10,15,6,8,1,6,1,6,4,11,11,13,13,8,12,1,3,4,7,10,14,7,10,9,15,5,6,0,8,15,0,14,5,2,9,3,2,12,13,1,2,15,8,13,4,8,6,10,15,3,11,7,1,4,10,12,9,5,3,6,14,11,5,0,0,14,12,9,7,2,7,2,11,1,4,14,1,7,9,4,12,10,14,8,2,13,0,15,6,12,10,9,13,0,15,3,3,5,5,6,8,11];t.substitute=function substitute(e,t){var r=0;for(var n=0;n<4;n++){var a=e>>>18-n*6&63;var s=i[n*64+a];r<<=4;r|=s}for(var n=0;n<4;n++){var a=t>>>18-n*6&63;var s=i[4*64+n*64+a];r<<=4;r|=s}return r>>>0};var n=[16,25,12,11,3,20,4,15,31,17,9,6,27,14,1,22,30,24,8,18,0,5,29,23,13,19,2,26,10,21,28,7];t.permute=function permute(e){var t=0;for(var r=0;r<n.length;r++){t<<=1;t|=e>>>n[r]&1}return t>>>0};t.padSplit=function padSplit(e,t,r){var i=e.toString(2);while(i.length<t)i="0"+i;var n=[];for(var a=0;a<t;a+=r)n.push(i.slice(a,a+r));return n.join(" ")}},6587:function(e,t,r){var i=r(296);var n=r(7992);var a=r(373);function getDiffieHellman(e){var t=new Buffer(n[e].prime,"hex");var r=new Buffer(n[e].gen,"hex");return new a(t,r)}var s={binary:true,hex:true,base64:true};function createDiffieHellman(e,t,r,n){if(Buffer.isBuffer(t)||s[t]===undefined){return createDiffieHellman(e,"binary",t,r)}t=t||"binary";n=n||"binary";r=r||new Buffer([2]);if(!Buffer.isBuffer(r)){r=new Buffer(r,n)}if(typeof e==="number"){return new a(i(e,r),r,true)}if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}return new a(e,r,true)}t.DiffieHellmanGroup=t.createDiffieHellmanGroup=t.getDiffieHellman=getDiffieHellman;t.createDiffieHellman=t.DiffieHellman=createDiffieHellman},373:function(e,t,r){var i=r(711);var n=r(1354);var a=new n;var s=new i(24);var o=new i(11);var h=new i(10);var u=new i(3);var d=new i(7);var c=r(296);var l=r(7223);e.exports=DH;function setPublicKey(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this._pub=new i(e);return this}function setPrivateKey(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this._priv=new i(e);return this}var p={};function checkPrime(e,t){var r=t.toString("hex");var i=[r,e.toString(16)].join("_");if(i in p){return p[i]}var n=0;if(e.isEven()||!c.simpleSieve||!c.fermatTest(e)||!a.test(e)){n+=1;if(r==="02"||r==="05"){n+=8}else{n+=4}p[i]=n;return n}if(!a.test(e.shrn(1))){n+=2}var l;switch(r){case"02":if(e.mod(s).cmp(o)){n+=8}break;case"05":l=e.mod(h);if(l.cmp(u)&&l.cmp(d)){n+=8}break;default:n+=4}p[i]=n;return n}function DH(e,t,r){this.setGenerator(t);this.__prime=new i(e);this._prime=i.mont(this.__prime);this._primeLen=e.length;this._pub=undefined;this._priv=undefined;this._primeCode=undefined;if(r){this.setPublicKey=setPublicKey;this.setPrivateKey=setPrivateKey}else{this._primeCode=8}}Object.defineProperty(DH.prototype,"verifyError",{enumerable:true,get:function(){if(typeof this._primeCode!=="number"){this._primeCode=checkPrime(this.__prime,this.__gen)}return this._primeCode}});DH.prototype.generateKeys=function(){if(!this._priv){this._priv=new i(l(this._primeLen))}this._pub=this._gen.toRed(this._prime).redPow(this._priv).fromRed();return this.getPublicKey()};DH.prototype.computeSecret=function(e){e=new i(e);e=e.toRed(this._prime);var t=e.redPow(this._priv).fromRed();var r=new Buffer(t.toArray());var n=this.getPrime();if(r.length<n.length){var a=new Buffer(n.length-r.length);a.fill(0);r=Buffer.concat([a,r])}return r};DH.prototype.getPublicKey=function getPublicKey(e){return formatReturnValue(this._pub,e)};DH.prototype.getPrivateKey=function getPrivateKey(e){return formatReturnValue(this._priv,e)};DH.prototype.getPrime=function(e){return formatReturnValue(this.__prime,e)};DH.prototype.getGenerator=function(e){return formatReturnValue(this._gen,e)};DH.prototype.setGenerator=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this.__gen=e;this._gen=new i(e);return this};function formatReturnValue(e,t){var r=new Buffer(e.toArray());if(!t){return r}else{return r.toString(t)}}},296:function(e,t,r){var i=r(7223);e.exports=findPrime;findPrime.simpleSieve=simpleSieve;findPrime.fermatTest=fermatTest;var n=r(711);var a=new n(24);var s=r(1354);var o=new s;var h=new n(1);var u=new n(2);var d=new n(5);var c=new n(16);var l=new n(8);var p=new n(10);var v=new n(3);var b=new n(7);var m=new n(11);var y=new n(4);var g=new n(12);var _=null;function _getPrimes(){if(_!==null)return _;var e=1048576;var t=[];t[0]=2;for(var r=1,i=3;i<e;i+=2){var n=Math.ceil(Math.sqrt(i));for(var a=0;a<r&&t[a]<=n;a++)if(i%t[a]===0)break;if(r!==a&&t[a]<=n)continue;t[r++]=i}_=t;return t}function simpleSieve(e){var t=_getPrimes();for(var r=0;r<t.length;r++)if(e.modn(t[r])===0){if(e.cmpn(t[r])===0){return true}else{return false}}return true}function fermatTest(e){var t=n.mont(e);return u.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1)===0}function findPrime(e,t){if(e<16){if(t===2||t===5){return new n([140,123])}else{return new n([140,39])}}t=new n(t);var r,s;while(true){r=new n(i(Math.ceil(e/8)));while(r.bitLength()>e){r.ishrn(1)}if(r.isEven()){r.iadd(h)}if(!r.testn(1)){r.iadd(u)}if(!t.cmp(u)){while(r.mod(a).cmp(m)){r.iadd(y)}}else if(!t.cmp(d)){while(r.mod(p).cmp(v)){r.iadd(y)}}s=r.shrn(1);if(simpleSieve(s)&&simpleSieve(r)&&fermatTest(s)&&fermatTest(r)&&o.test(s)&&o.test(r)){return r}}}},949:function(e,t,r){"use strict";var i=t;i.version=r(2531).i8;i.utils=r(4401);i.rand=r(3500);i.curve=r(9359);i.curves=r(6226);i.ec=r(4088);i.eddsa=r(8511)},2727:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.getNAF;var s=n.getJSF;var o=n.assert;function BaseCurve(e,t){this.type=e;this.p=new i(t.p,16);this.red=t.prime?i.red(t.prime):i.mont(this.p);this.zero=new i(0).toRed(this.red);this.one=new i(1).toRed(this.red);this.two=new i(2).toRed(this.red);this.n=t.n&&new i(t.n,16);this.g=t.g&&this.pointFromJSON(t.g,t.gRed);this._wnafT1=new Array(4);this._wnafT2=new Array(4);this._wnafT3=new Array(4);this._wnafT4=new Array(4);this._bitLength=this.n?this.n.bitLength():0;var r=this.n&&this.p.div(this.n);if(!r||r.cmpn(100)>0){this.redN=null}else{this._maxwellTrick=true;this.redN=this.n.toRed(this.red)}}e.exports=BaseCurve;BaseCurve.prototype.point=function point(){throw new Error("Not implemented")};BaseCurve.prototype.validate=function validate(){throw new Error("Not implemented")};BaseCurve.prototype._fixedNafMul=function _fixedNafMul(e,t){o(e.precomputed);var r=e._getDoubles();var i=a(t,1,this._bitLength);var n=(1<<r.step+1)-(r.step%2===0?2:1);n/=3;var s=[];for(var h=0;h<i.length;h+=r.step){var u=0;for(var t=h+r.step-1;t>=h;t--)u=(u<<1)+i[t];s.push(u)}var d=this.jpoint(null,null,null);var c=this.jpoint(null,null,null);for(var l=n;l>0;l--){for(var h=0;h<s.length;h++){var u=s[h];if(u===l)c=c.mixedAdd(r.points[h]);else if(u===-l)c=c.mixedAdd(r.points[h].neg())}d=d.add(c)}return d.toP()};BaseCurve.prototype._wnafMul=function _wnafMul(e,t){var r=4;var i=e._getNAFPoints(r);r=i.wnd;var n=i.points;var s=a(t,r,this._bitLength);var h=this.jpoint(null,null,null);for(var u=s.length-1;u>=0;u--){for(var t=0;u>=0&&s[u]===0;u--)t++;if(u>=0)t++;h=h.dblp(t);if(u<0)break;var d=s[u];o(d!==0);if(e.type==="affine"){if(d>0)h=h.mixedAdd(n[d-1>>1]);else h=h.mixedAdd(n[-d-1>>1].neg())}else{if(d>0)h=h.add(n[d-1>>1]);else h=h.add(n[-d-1>>1].neg())}}return e.type==="affine"?h.toP():h};BaseCurve.prototype._wnafMulAdd=function _wnafMulAdd(e,t,r,i,n){var o=this._wnafT1;var h=this._wnafT2;var u=this._wnafT3;var d=0;for(var c=0;c<i;c++){var l=t[c];var p=l._getNAFPoints(e);o[c]=p.wnd;h[c]=p.points}for(var c=i-1;c>=1;c-=2){var v=c-1;var b=c;if(o[v]!==1||o[b]!==1){u[v]=a(r[v],o[v],this._bitLength);u[b]=a(r[b],o[b],this._bitLength);d=Math.max(u[v].length,d);d=Math.max(u[b].length,d);continue}var m=[t[v],null,null,t[b]];if(t[v].y.cmp(t[b].y)===0){m[1]=t[v].add(t[b]);m[2]=t[v].toJ().mixedAdd(t[b].neg())}else if(t[v].y.cmp(t[b].y.redNeg())===0){m[1]=t[v].toJ().mixedAdd(t[b]);m[2]=t[v].add(t[b].neg())}else{m[1]=t[v].toJ().mixedAdd(t[b]);m[2]=t[v].toJ().mixedAdd(t[b].neg())}var y=[-3,-1,-5,-7,0,7,5,1,3];var g=s(r[v],r[b]);d=Math.max(g[0].length,d);u[v]=new Array(d);u[b]=new Array(d);for(var _=0;_<d;_++){var w=g[0][_]|0;var M=g[1][_]|0;u[v][_]=y[(w+1)*3+(M+1)];u[b][_]=0;h[v]=m}}var B=this.jpoint(null,null,null);var E=this._wnafT4;for(var c=d;c>=0;c--){var k=0;while(c>=0){var A=true;for(var _=0;_<i;_++){E[_]=u[_][c]|0;if(E[_]!==0)A=false}if(!A)break;k++;c--}if(c>=0)k++;B=B.dblp(k);if(c<0)break;for(var _=0;_<i;_++){var N=E[_];var l;if(N===0)continue;else if(N>0)l=h[_][N-1>>1];else if(N<0)l=h[_][-N-1>>1].neg();if(l.type==="affine")B=B.mixedAdd(l);else B=B.add(l)}}for(var c=0;c<i;c++)h[c]=null;if(n)return B;else return B.toP()};function BasePoint(e,t){this.curve=e;this.type=t;this.precomputed=null}BaseCurve.BasePoint=BasePoint;BasePoint.prototype.eq=function eq(){throw new Error("Not implemented")};BasePoint.prototype.validate=function validate(){return this.curve.validate(this)};BaseCurve.prototype.decodePoint=function decodePoint(e,t){e=n.toArray(e,t);var r=this.p.byteLength();if((e[0]===4||e[0]===6||e[0]===7)&&e.length-1===2*r){if(e[0]===6)o(e[e.length-1]%2===0);else if(e[0]===7)o(e[e.length-1]%2===1);var i=this.point(e.slice(1,1+r),e.slice(1+r,1+2*r));return i}else if((e[0]===2||e[0]===3)&&e.length-1===r){return this.pointFromX(e.slice(1,1+r),e[0]===3)}throw new Error("Unknown point format")};BasePoint.prototype.encodeCompressed=function encodeCompressed(e){return this.encode(e,true)};BasePoint.prototype._encode=function _encode(e){var t=this.curve.p.byteLength();var r=this.getX().toArray("be",t);if(e)return[this.getY().isEven()?2:3].concat(r);return[4].concat(r,this.getY().toArray("be",t))};BasePoint.prototype.encode=function encode(e,t){return n.encode(this._encode(t),e)};BasePoint.prototype.precompute=function precompute(e){if(this.precomputed)return this;var t={doubles:null,naf:null,beta:null};t.naf=this._getNAFPoints(8);t.doubles=this._getDoubles(4,e);t.beta=this._getBeta();this.precomputed=t;return this};BasePoint.prototype._hasDoubles=function _hasDoubles(e){if(!this.precomputed)return false;var t=this.precomputed.doubles;if(!t)return false;return t.points.length>=Math.ceil((e.bitLength()+1)/t.step)};BasePoint.prototype._getDoubles=function _getDoubles(e,t){if(this.precomputed&&this.precomputed.doubles)return this.precomputed.doubles;var r=[this];var i=this;for(var n=0;n<t;n+=e){for(var a=0;a<e;a++)i=i.dbl();r.push(i)}return{step:e,points:r}};BasePoint.prototype._getNAFPoints=function _getNAFPoints(e){if(this.precomputed&&this.precomputed.naf)return this.precomputed.naf;var t=[this];var r=(1<<e)-1;var i=r===1?null:this.dbl();for(var n=1;n<r;n++)t[n]=t[n-1].add(i);return{wnd:e,points:t}};BasePoint.prototype._getBeta=function _getBeta(){return null};BasePoint.prototype.dblp=function dblp(e){var t=this;for(var r=0;r<e;r++)t=t.dbl();return t}},2705:function(e,t,r){"use strict";var i=r(4401);var n=r(711);var a=r(3782);var s=r(2727);var o=i.assert;function EdwardsCurve(e){this.twisted=(e.a|0)!==1;this.mOneA=this.twisted&&(e.a|0)===-1;this.extended=this.mOneA;s.call(this,"edwards",e);this.a=new n(e.a,16).umod(this.red.m);this.a=this.a.toRed(this.red);this.c=new n(e.c,16).toRed(this.red);this.c2=this.c.redSqr();this.d=new n(e.d,16).toRed(this.red);this.dd=this.d.redAdd(this.d);o(!this.twisted||this.c.fromRed().cmpn(1)===0);this.oneC=(e.c|0)===1}a(EdwardsCurve,s);e.exports=EdwardsCurve;EdwardsCurve.prototype._mulA=function _mulA(e){if(this.mOneA)return e.redNeg();else return this.a.redMul(e)};EdwardsCurve.prototype._mulC=function _mulC(e){if(this.oneC)return e;else return this.c.redMul(e)};EdwardsCurve.prototype.jpoint=function jpoint(e,t,r,i){return this.point(e,t,r,i)};EdwardsCurve.prototype.pointFromX=function pointFromX(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr();var i=this.c2.redSub(this.a.redMul(r));var a=this.one.redSub(this.c2.redMul(this.d).redMul(r));var s=i.redMul(a.redInvm());var o=s.redSqrt();if(o.redSqr().redSub(s).cmp(this.zero)!==0)throw new Error("invalid point");var h=o.fromRed().isOdd();if(t&&!h||!t&&h)o=o.redNeg();return this.point(e,o)};EdwardsCurve.prototype.pointFromY=function pointFromY(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr();var i=r.redSub(this.c2);var a=r.redMul(this.d).redMul(this.c2).redSub(this.a);var s=i.redMul(a.redInvm());if(s.cmp(this.zero)===0){if(t)throw new Error("invalid point");else return this.point(this.zero,e)}var o=s.redSqrt();if(o.redSqr().redSub(s).cmp(this.zero)!==0)throw new Error("invalid point");if(o.fromRed().isOdd()!==t)o=o.redNeg();return this.point(o,e)};EdwardsCurve.prototype.validate=function validate(e){if(e.isInfinity())return true;e.normalize();var t=e.x.redSqr();var r=e.y.redSqr();var i=t.redMul(this.a).redAdd(r);var n=this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));return i.cmp(n)===0};function Point(e,t,r,i,a){s.BasePoint.call(this,e,"projective");if(t===null&&r===null&&i===null){this.x=this.curve.zero;this.y=this.curve.one;this.z=this.curve.one;this.t=this.curve.zero;this.zOne=true}else{this.x=new n(t,16);this.y=new n(r,16);this.z=i?new n(i,16):this.curve.one;this.t=a&&new n(a,16);if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red);if(this.t&&!this.t.red)this.t=this.t.toRed(this.curve.red);this.zOne=this.z===this.curve.one;if(this.curve.extended&&!this.t){this.t=this.x.redMul(this.y);if(!this.zOne)this.t=this.t.redMul(this.z.redInvm())}}}a(Point,s.BasePoint);EdwardsCurve.prototype.pointFromJSON=function pointFromJSON(e){return Point.fromJSON(this,e)};EdwardsCurve.prototype.point=function point(e,t,r,i){return new Point(this,e,t,r,i)};Point.fromJSON=function fromJSON(e,t){return new Point(e,t[0],t[1],t[2])};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.x.cmpn(0)===0&&(this.y.cmp(this.z)===0||this.zOne&&this.y.cmp(this.curve.c)===0)};Point.prototype._extDbl=function _extDbl(){var e=this.x.redSqr();var t=this.y.redSqr();var r=this.z.redSqr();r=r.redIAdd(r);var i=this.curve._mulA(e);var n=this.x.redAdd(this.y).redSqr().redISub(e).redISub(t);var a=i.redAdd(t);var s=a.redSub(r);var o=i.redSub(t);var h=n.redMul(s);var u=a.redMul(o);var d=n.redMul(o);var c=s.redMul(a);return this.curve.point(h,u,c,d)};Point.prototype._projDbl=function _projDbl(){var e=this.x.redAdd(this.y).redSqr();var t=this.x.redSqr();var r=this.y.redSqr();var i;var n;var a;if(this.curve.twisted){var s=this.curve._mulA(t);var o=s.redAdd(r);if(this.zOne){i=e.redSub(t).redSub(r).redMul(o.redSub(this.curve.two));n=o.redMul(s.redSub(r));a=o.redSqr().redSub(o).redSub(o)}else{var h=this.z.redSqr();var u=o.redSub(h).redISub(h);i=e.redSub(t).redISub(r).redMul(u);n=o.redMul(s.redSub(r));a=o.redMul(u)}}else{var s=t.redAdd(r);var h=this.curve._mulC(this.z).redSqr();var u=s.redSub(h).redSub(h);i=this.curve._mulC(e.redISub(s)).redMul(u);n=this.curve._mulC(s).redMul(t.redISub(r));a=s.redMul(u)}return this.curve.point(i,n,a)};Point.prototype.dbl=function dbl(){if(this.isInfinity())return this;if(this.curve.extended)return this._extDbl();else return this._projDbl()};Point.prototype._extAdd=function _extAdd(e){var t=this.y.redSub(this.x).redMul(e.y.redSub(e.x));var r=this.y.redAdd(this.x).redMul(e.y.redAdd(e.x));var i=this.t.redMul(this.curve.dd).redMul(e.t);var n=this.z.redMul(e.z.redAdd(e.z));var a=r.redSub(t);var s=n.redSub(i);var o=n.redAdd(i);var h=r.redAdd(t);var u=a.redMul(s);var d=o.redMul(h);var c=a.redMul(h);var l=s.redMul(o);return this.curve.point(u,d,l,c)};Point.prototype._projAdd=function _projAdd(e){var t=this.z.redMul(e.z);var r=t.redSqr();var i=this.x.redMul(e.x);var n=this.y.redMul(e.y);var a=this.curve.d.redMul(i).redMul(n);var s=r.redSub(a);var o=r.redAdd(a);var h=this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(i).redISub(n);var u=t.redMul(s).redMul(h);var d;var c;if(this.curve.twisted){d=t.redMul(o).redMul(n.redSub(this.curve._mulA(i)));c=s.redMul(o)}else{d=t.redMul(o).redMul(n.redSub(i));c=this.curve._mulC(s).redMul(o)}return this.curve.point(u,d,c)};Point.prototype.add=function add(e){if(this.isInfinity())return e;if(e.isInfinity())return this;if(this.curve.extended)return this._extAdd(e);else return this._projAdd(e)};Point.prototype.mul=function mul(e){if(this._hasDoubles(e))return this.curve._fixedNafMul(this,e);else return this.curve._wnafMul(this,e)};Point.prototype.mulAdd=function mulAdd(e,t,r){return this.curve._wnafMulAdd(1,[this,t],[e,r],2,false)};Point.prototype.jmulAdd=function jmulAdd(e,t,r){return this.curve._wnafMulAdd(1,[this,t],[e,r],2,true)};Point.prototype.normalize=function normalize(){if(this.zOne)return this;var e=this.z.redInvm();this.x=this.x.redMul(e);this.y=this.y.redMul(e);if(this.t)this.t=this.t.redMul(e);this.z=this.curve.one;this.zOne=true;return this};Point.prototype.neg=function neg(){return this.curve.point(this.x.redNeg(),this.y,this.z,this.t&&this.t.redNeg())};Point.prototype.getX=function getX(){this.normalize();return this.x.fromRed()};Point.prototype.getY=function getY(){this.normalize();return this.y.fromRed()};Point.prototype.eq=function eq(e){return this===e||this.getX().cmp(e.getX())===0&&this.getY().cmp(e.getY())===0};Point.prototype.eqXToP=function eqXToP(e){var t=e.toRed(this.curve.red).redMul(this.z);if(this.x.cmp(t)===0)return true;var r=e.clone();var i=this.curve.redN.redMul(this.z);for(;;){r.iadd(this.curve.n);if(r.cmp(this.curve.p)>=0)return false;t.redIAdd(i);if(this.x.cmp(t)===0)return true}};Point.prototype.toP=Point.prototype.normalize;Point.prototype.mixedAdd=Point.prototype.add},9359:function(e,t,r){"use strict";var i=t;i.base=r(2727);i.short=r(4720);i.mont=r(6653);i.edwards=r(2705)},6653:function(e,t,r){"use strict";var i=r(711);var n=r(3782);var a=r(2727);var s=r(4401);function MontCurve(e){a.call(this,"mont",e);this.a=new i(e.a,16).toRed(this.red);this.b=new i(e.b,16).toRed(this.red);this.i4=new i(4).toRed(this.red).redInvm();this.two=new i(2).toRed(this.red);this.a24=this.i4.redMul(this.a.redAdd(this.two))}n(MontCurve,a);e.exports=MontCurve;MontCurve.prototype.validate=function validate(e){var t=e.normalize().x;var r=t.redSqr();var i=r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);var n=i.redSqrt();return n.redSqr().cmp(i)===0};function Point(e,t,r){a.BasePoint.call(this,e,"projective");if(t===null&&r===null){this.x=this.curve.one;this.z=this.curve.zero}else{this.x=new i(t,16);this.z=new i(r,16);if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red)}}n(Point,a.BasePoint);MontCurve.prototype.decodePoint=function decodePoint(e,t){return this.point(s.toArray(e,t),1)};MontCurve.prototype.point=function point(e,t){return new Point(this,e,t)};MontCurve.prototype.pointFromJSON=function pointFromJSON(e){return Point.fromJSON(this,e)};Point.prototype.precompute=function precompute(){};Point.prototype._encode=function _encode(){return this.getX().toArray("be",this.curve.p.byteLength())};Point.fromJSON=function fromJSON(e,t){return new Point(e,t[0],t[1]||e.one)};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.z.cmpn(0)===0};Point.prototype.dbl=function dbl(){var e=this.x.redAdd(this.z);var t=e.redSqr();var r=this.x.redSub(this.z);var i=r.redSqr();var n=t.redSub(i);var a=t.redMul(i);var s=n.redMul(i.redAdd(this.curve.a24.redMul(n)));return this.curve.point(a,s)};Point.prototype.add=function add(){throw new Error("Not supported on Montgomery curve")};Point.prototype.diffAdd=function diffAdd(e,t){var r=this.x.redAdd(this.z);var i=this.x.redSub(this.z);var n=e.x.redAdd(e.z);var a=e.x.redSub(e.z);var s=a.redMul(r);var o=n.redMul(i);var h=t.z.redMul(s.redAdd(o).redSqr());var u=t.x.redMul(s.redISub(o).redSqr());return this.curve.point(h,u)};Point.prototype.mul=function mul(e){var t=e.clone();var r=this;var i=this.curve.point(null,null);var n=this;for(var a=[];t.cmpn(0)!==0;t.iushrn(1))a.push(t.andln(1));for(var s=a.length-1;s>=0;s--){if(a[s]===0){r=r.diffAdd(i,n);i=i.dbl()}else{i=r.diffAdd(i,n);r=r.dbl()}}return i};Point.prototype.mulAdd=function mulAdd(){throw new Error("Not supported on Montgomery curve")};Point.prototype.jumlAdd=function jumlAdd(){throw new Error("Not supported on Montgomery curve")};Point.prototype.eq=function eq(e){return this.getX().cmp(e.getX())===0};Point.prototype.normalize=function normalize(){this.x=this.x.redMul(this.z.redInvm());this.z=this.curve.one;return this};Point.prototype.getX=function getX(){this.normalize();return this.x.fromRed()}},4720:function(e,t,r){"use strict";var i=r(4401);var n=r(711);var a=r(3782);var s=r(2727);var o=i.assert;function ShortCurve(e){s.call(this,"short",e);this.a=new n(e.a,16).toRed(this.red);this.b=new n(e.b,16).toRed(this.red);this.tinv=this.two.redInvm();this.zeroA=this.a.fromRed().cmpn(0)===0;this.threeA=this.a.fromRed().sub(this.p).cmpn(-3)===0;this.endo=this._getEndomorphism(e);this._endoWnafT1=new Array(4);this._endoWnafT2=new Array(4)}a(ShortCurve,s);e.exports=ShortCurve;ShortCurve.prototype._getEndomorphism=function _getEndomorphism(e){if(!this.zeroA||!this.g||!this.n||this.p.modn(3)!==1)return;var t;var r;if(e.beta){t=new n(e.beta,16).toRed(this.red)}else{var i=this._getEndoRoots(this.p);t=i[0].cmp(i[1])<0?i[0]:i[1];t=t.toRed(this.red)}if(e.lambda){r=new n(e.lambda,16)}else{var a=this._getEndoRoots(this.n);if(this.g.mul(a[0]).x.cmp(this.g.x.redMul(t))===0){r=a[0]}else{r=a[1];o(this.g.mul(r).x.cmp(this.g.x.redMul(t))===0)}}var s;if(e.basis){s=e.basis.map((function(e){return{a:new n(e.a,16),b:new n(e.b,16)}}))}else{s=this._getEndoBasis(r)}return{beta:t,lambda:r,basis:s}};ShortCurve.prototype._getEndoRoots=function _getEndoRoots(e){var t=e===this.p?this.red:n.mont(e);var r=new n(2).toRed(t).redInvm();var i=r.redNeg();var a=new n(3).toRed(t).redNeg().redSqrt().redMul(r);var s=i.redAdd(a).fromRed();var o=i.redSub(a).fromRed();return[s,o]};ShortCurve.prototype._getEndoBasis=function _getEndoBasis(e){var t=this.n.ushrn(Math.floor(this.n.bitLength()/2));var r=e;var i=this.n.clone();var a=new n(1);var s=new n(0);var o=new n(0);var h=new n(1);var u;var d;var c;var l;var p;var v;var b;var m=0;var y;var g;while(r.cmpn(0)!==0){var _=i.div(r);y=i.sub(_.mul(r));g=o.sub(_.mul(a));var w=h.sub(_.mul(s));if(!c&&y.cmp(t)<0){u=b.neg();d=a;c=y.neg();l=g}else if(c&&++m===2){break}b=y;i=r;r=y;o=a;a=g;h=s;s=w}p=y.neg();v=g;var M=c.sqr().add(l.sqr());var B=p.sqr().add(v.sqr());if(B.cmp(M)>=0){p=u;v=d}if(c.negative){c=c.neg();l=l.neg()}if(p.negative){p=p.neg();v=v.neg()}return[{a:c,b:l},{a:p,b:v}]};ShortCurve.prototype._endoSplit=function _endoSplit(e){var t=this.endo.basis;var r=t[0];var i=t[1];var n=i.b.mul(e).divRound(this.n);var a=r.b.neg().mul(e).divRound(this.n);var s=n.mul(r.a);var o=a.mul(i.a);var h=n.mul(r.b);var u=a.mul(i.b);var d=e.sub(s).sub(o);var c=h.add(u).neg();return{k1:d,k2:c}};ShortCurve.prototype.pointFromX=function pointFromX(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b);var i=r.redSqrt();if(i.redSqr().redSub(r).cmp(this.zero)!==0)throw new Error("invalid point");var a=i.fromRed().isOdd();if(t&&!a||!t&&a)i=i.redNeg();return this.point(e,i)};ShortCurve.prototype.validate=function validate(e){if(e.inf)return true;var t=e.x;var r=e.y;var i=this.a.redMul(t);var n=t.redSqr().redMul(t).redIAdd(i).redIAdd(this.b);return r.redSqr().redISub(n).cmpn(0)===0};ShortCurve.prototype._endoWnafMulAdd=function _endoWnafMulAdd(e,t,r){var i=this._endoWnafT1;var n=this._endoWnafT2;for(var a=0;a<e.length;a++){var s=this._endoSplit(t[a]);var o=e[a];var h=o._getBeta();if(s.k1.negative){s.k1.ineg();o=o.neg(true)}if(s.k2.negative){s.k2.ineg();h=h.neg(true)}i[a*2]=o;i[a*2+1]=h;n[a*2]=s.k1;n[a*2+1]=s.k2}var u=this._wnafMulAdd(1,i,n,a*2,r);for(var d=0;d<a*2;d++){i[d]=null;n[d]=null}return u};function Point(e,t,r,i){s.BasePoint.call(this,e,"affine");if(t===null&&r===null){this.x=null;this.y=null;this.inf=true}else{this.x=new n(t,16);this.y=new n(r,16);if(i){this.x.forceRed(this.curve.red);this.y.forceRed(this.curve.red)}if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);this.inf=false}}a(Point,s.BasePoint);ShortCurve.prototype.point=function point(e,t,r){return new Point(this,e,t,r)};ShortCurve.prototype.pointFromJSON=function pointFromJSON(e,t){return Point.fromJSON(this,e,t)};Point.prototype._getBeta=function _getBeta(){if(!this.curve.endo)return;var e=this.precomputed;if(e&&e.beta)return e.beta;var t=this.curve.point(this.x.redMul(this.curve.endo.beta),this.y);if(e){var r=this.curve;var endoMul=function(e){return r.point(e.x.redMul(r.endo.beta),e.y)};e.beta=t;t.precomputed={beta:null,naf:e.naf&&{wnd:e.naf.wnd,points:e.naf.points.map(endoMul)},doubles:e.doubles&&{step:e.doubles.step,points:e.doubles.points.map(endoMul)}}}return t};Point.prototype.toJSON=function toJSON(){if(!this.precomputed)return[this.x,this.y];return[this.x,this.y,this.precomputed&&{doubles:this.precomputed.doubles&&{step:this.precomputed.doubles.step,points:this.precomputed.doubles.points.slice(1)},naf:this.precomputed.naf&&{wnd:this.precomputed.naf.wnd,points:this.precomputed.naf.points.slice(1)}}]};Point.fromJSON=function fromJSON(e,t,r){if(typeof t==="string")t=JSON.parse(t);var i=e.point(t[0],t[1],r);if(!t[2])return i;function obj2point(t){return e.point(t[0],t[1],r)}var n=t[2];i.precomputed={beta:null,doubles:n.doubles&&{step:n.doubles.step,points:[i].concat(n.doubles.points.map(obj2point))},naf:n.naf&&{wnd:n.naf.wnd,points:[i].concat(n.naf.points.map(obj2point))}};return i};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.inf};Point.prototype.add=function add(e){if(this.inf)return e;if(e.inf)return this;if(this.eq(e))return this.dbl();if(this.neg().eq(e))return this.curve.point(null,null);if(this.x.cmp(e.x)===0)return this.curve.point(null,null);var t=this.y.redSub(e.y);if(t.cmpn(0)!==0)t=t.redMul(this.x.redSub(e.x).redInvm());var r=t.redSqr().redISub(this.x).redISub(e.x);var i=t.redMul(this.x.redSub(r)).redISub(this.y);return this.curve.point(r,i)};Point.prototype.dbl=function dbl(){if(this.inf)return this;var e=this.y.redAdd(this.y);if(e.cmpn(0)===0)return this.curve.point(null,null);var t=this.curve.a;var r=this.x.redSqr();var i=e.redInvm();var n=r.redAdd(r).redIAdd(r).redIAdd(t).redMul(i);var a=n.redSqr().redISub(this.x.redAdd(this.x));var s=n.redMul(this.x.redSub(a)).redISub(this.y);return this.curve.point(a,s)};Point.prototype.getX=function getX(){return this.x.fromRed()};Point.prototype.getY=function getY(){return this.y.fromRed()};Point.prototype.mul=function mul(e){e=new n(e,16);if(this.isInfinity())return this;else if(this._hasDoubles(e))return this.curve._fixedNafMul(this,e);else if(this.curve.endo)return this.curve._endoWnafMulAdd([this],[e]);else return this.curve._wnafMul(this,e)};Point.prototype.mulAdd=function mulAdd(e,t,r){var i=[this,t];var n=[e,r];if(this.curve.endo)return this.curve._endoWnafMulAdd(i,n);else return this.curve._wnafMulAdd(1,i,n,2)};Point.prototype.jmulAdd=function jmulAdd(e,t,r){var i=[this,t];var n=[e,r];if(this.curve.endo)return this.curve._endoWnafMulAdd(i,n,true);else return this.curve._wnafMulAdd(1,i,n,2,true)};Point.prototype.eq=function eq(e){return this===e||this.inf===e.inf&&(this.inf||this.x.cmp(e.x)===0&&this.y.cmp(e.y)===0)};Point.prototype.neg=function neg(e){if(this.inf)return this;var t=this.curve.point(this.x,this.y.redNeg());if(e&&this.precomputed){var r=this.precomputed;var negate=function(e){return e.neg()};t.precomputed={naf:r.naf&&{wnd:r.naf.wnd,points:r.naf.points.map(negate)},doubles:r.doubles&&{step:r.doubles.step,points:r.doubles.points.map(negate)}}}return t};Point.prototype.toJ=function toJ(){if(this.inf)return this.curve.jpoint(null,null,null);var e=this.curve.jpoint(this.x,this.y,this.curve.one);return e};function JPoint(e,t,r,i){s.BasePoint.call(this,e,"jacobian");if(t===null&&r===null&&i===null){this.x=this.curve.one;this.y=this.curve.one;this.z=new n(0)}else{this.x=new n(t,16);this.y=new n(r,16);this.z=new n(i,16)}if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red);this.zOne=this.z===this.curve.one}a(JPoint,s.BasePoint);ShortCurve.prototype.jpoint=function jpoint(e,t,r){return new JPoint(this,e,t,r)};JPoint.prototype.toP=function toP(){if(this.isInfinity())return this.curve.point(null,null);var e=this.z.redInvm();var t=e.redSqr();var r=this.x.redMul(t);var i=this.y.redMul(t).redMul(e);return this.curve.point(r,i)};JPoint.prototype.neg=function neg(){return this.curve.jpoint(this.x,this.y.redNeg(),this.z)};JPoint.prototype.add=function add(e){if(this.isInfinity())return e;if(e.isInfinity())return this;var t=e.z.redSqr();var r=this.z.redSqr();var i=this.x.redMul(t);var n=e.x.redMul(r);var a=this.y.redMul(t.redMul(e.z));var s=e.y.redMul(r.redMul(this.z));var o=i.redSub(n);var h=a.redSub(s);if(o.cmpn(0)===0){if(h.cmpn(0)!==0)return this.curve.jpoint(null,null,null);else return this.dbl()}var u=o.redSqr();var d=u.redMul(o);var c=i.redMul(u);var l=h.redSqr().redIAdd(d).redISub(c).redISub(c);var p=h.redMul(c.redISub(l)).redISub(a.redMul(d));var v=this.z.redMul(e.z).redMul(o);return this.curve.jpoint(l,p,v)};JPoint.prototype.mixedAdd=function mixedAdd(e){if(this.isInfinity())return e.toJ();if(e.isInfinity())return this;var t=this.z.redSqr();var r=this.x;var i=e.x.redMul(t);var n=this.y;var a=e.y.redMul(t).redMul(this.z);var s=r.redSub(i);var o=n.redSub(a);if(s.cmpn(0)===0){if(o.cmpn(0)!==0)return this.curve.jpoint(null,null,null);else return this.dbl()}var h=s.redSqr();var u=h.redMul(s);var d=r.redMul(h);var c=o.redSqr().redIAdd(u).redISub(d).redISub(d);var l=o.redMul(d.redISub(c)).redISub(n.redMul(u));var p=this.z.redMul(s);return this.curve.jpoint(c,l,p)};JPoint.prototype.dblp=function dblp(e){if(e===0)return this;if(this.isInfinity())return this;if(!e)return this.dbl();if(this.curve.zeroA||this.curve.threeA){var t=this;for(var r=0;r<e;r++)t=t.dbl();return t}var i=this.curve.a;var n=this.curve.tinv;var a=this.x;var s=this.y;var o=this.z;var h=o.redSqr().redSqr();var u=s.redAdd(s);for(var r=0;r<e;r++){var d=a.redSqr();var c=u.redSqr();var l=c.redSqr();var p=d.redAdd(d).redIAdd(d).redIAdd(i.redMul(h));var v=a.redMul(c);var b=p.redSqr().redISub(v.redAdd(v));var m=v.redISub(b);var y=p.redMul(m);y=y.redIAdd(y).redISub(l);var g=u.redMul(o);if(r+1<e)h=h.redMul(l);a=b;o=g;u=y}return this.curve.jpoint(a,u.redMul(n),o)};JPoint.prototype.dbl=function dbl(){if(this.isInfinity())return this;if(this.curve.zeroA)return this._zeroDbl();else if(this.curve.threeA)return this._threeDbl();else return this._dbl()};JPoint.prototype._zeroDbl=function _zeroDbl(){var e;var t;var r;if(this.zOne){var i=this.x.redSqr();var n=this.y.redSqr();var a=n.redSqr();var s=this.x.redAdd(n).redSqr().redISub(i).redISub(a);s=s.redIAdd(s);var o=i.redAdd(i).redIAdd(i);var h=o.redSqr().redISub(s).redISub(s);var u=a.redIAdd(a);u=u.redIAdd(u);u=u.redIAdd(u);e=h;t=o.redMul(s.redISub(h)).redISub(u);r=this.y.redAdd(this.y)}else{var d=this.x.redSqr();var c=this.y.redSqr();var l=c.redSqr();var p=this.x.redAdd(c).redSqr().redISub(d).redISub(l);p=p.redIAdd(p);var v=d.redAdd(d).redIAdd(d);var b=v.redSqr();var m=l.redIAdd(l);m=m.redIAdd(m);m=m.redIAdd(m);e=b.redISub(p).redISub(p);t=v.redMul(p.redISub(e)).redISub(m);r=this.y.redMul(this.z);r=r.redIAdd(r)}return this.curve.jpoint(e,t,r)};JPoint.prototype._threeDbl=function _threeDbl(){var e;var t;var r;if(this.zOne){var i=this.x.redSqr();var n=this.y.redSqr();var a=n.redSqr();var s=this.x.redAdd(n).redSqr().redISub(i).redISub(a);s=s.redIAdd(s);var o=i.redAdd(i).redIAdd(i).redIAdd(this.curve.a);var h=o.redSqr().redISub(s).redISub(s);e=h;var u=a.redIAdd(a);u=u.redIAdd(u);u=u.redIAdd(u);t=o.redMul(s.redISub(h)).redISub(u);r=this.y.redAdd(this.y)}else{var d=this.z.redSqr();var c=this.y.redSqr();var l=this.x.redMul(c);var p=this.x.redSub(d).redMul(this.x.redAdd(d));p=p.redAdd(p).redIAdd(p);var v=l.redIAdd(l);v=v.redIAdd(v);var b=v.redAdd(v);e=p.redSqr().redISub(b);r=this.y.redAdd(this.z).redSqr().redISub(c).redISub(d);var m=c.redSqr();m=m.redIAdd(m);m=m.redIAdd(m);m=m.redIAdd(m);t=p.redMul(v.redISub(e)).redISub(m)}return this.curve.jpoint(e,t,r)};JPoint.prototype._dbl=function _dbl(){var e=this.curve.a;var t=this.x;var r=this.y;var i=this.z;var n=i.redSqr().redSqr();var a=t.redSqr();var s=r.redSqr();var o=a.redAdd(a).redIAdd(a).redIAdd(e.redMul(n));var h=t.redAdd(t);h=h.redIAdd(h);var u=h.redMul(s);var d=o.redSqr().redISub(u.redAdd(u));var c=u.redISub(d);var l=s.redSqr();l=l.redIAdd(l);l=l.redIAdd(l);l=l.redIAdd(l);var p=o.redMul(c).redISub(l);var v=r.redAdd(r).redMul(i);return this.curve.jpoint(d,p,v)};JPoint.prototype.trpl=function trpl(){if(!this.curve.zeroA)return this.dbl().add(this);var e=this.x.redSqr();var t=this.y.redSqr();var r=this.z.redSqr();var i=t.redSqr();var n=e.redAdd(e).redIAdd(e);var a=n.redSqr();var s=this.x.redAdd(t).redSqr().redISub(e).redISub(i);s=s.redIAdd(s);s=s.redAdd(s).redIAdd(s);s=s.redISub(a);var o=s.redSqr();var h=i.redIAdd(i);h=h.redIAdd(h);h=h.redIAdd(h);h=h.redIAdd(h);var u=n.redIAdd(s).redSqr().redISub(a).redISub(o).redISub(h);var d=t.redMul(u);d=d.redIAdd(d);d=d.redIAdd(d);var c=this.x.redMul(o).redISub(d);c=c.redIAdd(c);c=c.redIAdd(c);var l=this.y.redMul(u.redMul(h.redISub(u)).redISub(s.redMul(o)));l=l.redIAdd(l);l=l.redIAdd(l);l=l.redIAdd(l);var p=this.z.redAdd(s).redSqr().redISub(r).redISub(o);return this.curve.jpoint(c,l,p)};JPoint.prototype.mul=function mul(e,t){e=new n(e,t);return this.curve._wnafMul(this,e)};JPoint.prototype.eq=function eq(e){if(e.type==="affine")return this.eq(e.toJ());if(this===e)return true;var t=this.z.redSqr();var r=e.z.redSqr();if(this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)!==0)return false;var i=t.redMul(this.z);var n=r.redMul(e.z);return this.y.redMul(n).redISub(e.y.redMul(i)).cmpn(0)===0};JPoint.prototype.eqXToP=function eqXToP(e){var t=this.z.redSqr();var r=e.toRed(this.curve.red).redMul(t);if(this.x.cmp(r)===0)return true;var i=e.clone();var n=this.curve.redN.redMul(t);for(;;){i.iadd(this.curve.n);if(i.cmp(this.curve.p)>=0)return false;r.redIAdd(n);if(this.x.cmp(r)===0)return true}};JPoint.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC JPoint Infinity>";return"<EC JPoint x: "+this.x.toString(16,2)+" y: "+this.y.toString(16,2)+" z: "+this.z.toString(16,2)+">"};JPoint.prototype.isInfinity=function isInfinity(){return this.z.cmpn(0)===0}},6226:function(e,t,r){"use strict";var i=t;var n=r(7028);var a=r(9359);var s=r(4401);var o=s.assert;function PresetCurve(e){if(e.type==="short")this.curve=new a.short(e);else if(e.type==="edwards")this.curve=new a.edwards(e);else this.curve=new a.mont(e);this.g=this.curve.g;this.n=this.curve.n;this.hash=e.hash;o(this.g.validate(),"Invalid curve");o(this.g.mul(this.n).isInfinity(),"Invalid curve, G*N != O")}i.PresetCurve=PresetCurve;function defineCurve(e,t){Object.defineProperty(i,e,{configurable:true,enumerable:true,get:function(){var r=new PresetCurve(t);Object.defineProperty(i,e,{configurable:true,enumerable:true,value:r});return r}})}defineCurve("p192",{type:"short",prime:"p192",p:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",a:"ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",b:"64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",n:"ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",hash:n.sha256,gRed:false,g:["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012","07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]});defineCurve("p224",{type:"short",prime:"p224",p:"ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",a:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",b:"b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",n:"ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",hash:n.sha256,gRed:false,g:["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21","bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]});defineCurve("p256",{type:"short",prime:null,p:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",a:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",b:"5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",n:"ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",hash:n.sha256,gRed:false,g:["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296","4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]});defineCurve("p384",{type:"short",prime:null,p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"fffffffe ffffffff 00000000 00000000 ffffffff",a:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"fffffffe ffffffff 00000000 00000000 fffffffc",b:"b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f "+"5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",n:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 "+"f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",hash:n.sha384,gRed:false,g:["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 "+"5502f25d bf55296c 3a545e38 72760ab7","3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 "+"0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]});defineCurve("p521",{type:"short",prime:null,p:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff",a:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff fffffffc",b:"00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b "+"99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd "+"3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",n:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 "+"f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",hash:n.sha512,gRed:false,g:["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 "+"053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 "+"a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66","00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 "+"579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 "+"3fad0761 353c7086 a272c240 88be9476 9fd16650"]});defineCurve("curve25519",{type:"mont",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"76d06",b:"1",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:n.sha256,gRed:false,g:["9"]});defineCurve("ed25519",{type:"edwards",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"-1",c:"1",d:"52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:n.sha256,gRed:false,g:["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a","6666666666666666666666666666666666666666666666666666666666666658"]});var h;try{h=r(9702)}catch(e){h=undefined}defineCurve("secp256k1",{type:"short",prime:"k256",p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",a:"0",b:"7",n:"ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",h:"1",hash:n.sha256,beta:"7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",lambda:"5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",basis:[{a:"3086d221a7d46bcde86c90e49284eb15",b:"-e4437ed6010e88286f547fa90abfe4c3"},{a:"114ca50f7a8e2f3f657c1108d9d44cfd8",b:"3086d221a7d46bcde86c90e49284eb15"}],gRed:false,g:["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798","483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",h]})},4088:function(e,t,r){"use strict";var i=r(711);var n=r(4910);var a=r(4401);var s=r(6226);var o=r(3500);var h=a.assert;var u=r(4724);var d=r(7526);function EC(e){if(!(this instanceof EC))return new EC(e);if(typeof e==="string"){h(s.hasOwnProperty(e),"Unknown curve "+e);e=s[e]}if(e instanceof s.PresetCurve)e={curve:e};this.curve=e.curve.curve;this.n=this.curve.n;this.nh=this.n.ushrn(1);this.g=this.curve.g;this.g=e.curve.g;this.g.precompute(e.curve.n.bitLength()+1);this.hash=e.hash||e.curve.hash}e.exports=EC;EC.prototype.keyPair=function keyPair(e){return new u(this,e)};EC.prototype.keyFromPrivate=function keyFromPrivate(e,t){return u.fromPrivate(this,e,t)};EC.prototype.keyFromPublic=function keyFromPublic(e,t){return u.fromPublic(this,e,t)};EC.prototype.genKeyPair=function genKeyPair(e){if(!e)e={};var t=new n({hash:this.hash,pers:e.pers,persEnc:e.persEnc||"utf8",entropy:e.entropy||o(this.hash.hmacStrength),entropyEnc:e.entropy&&e.entropyEnc||"utf8",nonce:this.n.toArray()});var r=this.n.byteLength();var a=this.n.sub(new i(2));do{var s=new i(t.generate(r));if(s.cmp(a)>0)continue;s.iaddn(1);return this.keyFromPrivate(s)}while(true)};EC.prototype._truncateToN=function truncateToN(e,t){var r=e.byteLength()*8-this.n.bitLength();if(r>0)e=e.ushrn(r);if(!t&&e.cmp(this.n)>=0)return e.sub(this.n);else return e};EC.prototype.sign=function sign(e,t,r,a){if(typeof r==="object"){a=r;r=null}if(!a)a={};t=this.keyFromPrivate(t,r);e=this._truncateToN(new i(e,16));var s=this.n.byteLength();var o=t.getPrivate().toArray("be",s);var h=e.toArray("be",s);var u=new n({hash:this.hash,entropy:o,nonce:h,pers:a.pers,persEnc:a.persEnc||"utf8"});var c=this.n.sub(new i(1));for(var l=0;true;l++){var p=a.k?a.k(l):new i(u.generate(this.n.byteLength()));p=this._truncateToN(p,true);if(p.cmpn(1)<=0||p.cmp(c)>=0)continue;var v=this.g.mul(p);if(v.isInfinity())continue;var b=v.getX();var m=b.umod(this.n);if(m.cmpn(0)===0)continue;var y=p.invm(this.n).mul(m.mul(t.getPrivate()).iadd(e));y=y.umod(this.n);if(y.cmpn(0)===0)continue;var g=(v.getY().isOdd()?1:0)|(b.cmp(m)!==0?2:0);if(a.canonical&&y.cmp(this.nh)>0){y=this.n.sub(y);g^=1}return new d({r:m,s:y,recoveryParam:g})}};EC.prototype.verify=function verify(e,t,r,n){e=this._truncateToN(new i(e,16));r=this.keyFromPublic(r,n);t=new d(t,"hex");var a=t.r;var s=t.s;if(a.cmpn(1)<0||a.cmp(this.n)>=0)return false;if(s.cmpn(1)<0||s.cmp(this.n)>=0)return false;var o=s.invm(this.n);var h=o.mul(e).umod(this.n);var u=o.mul(a).umod(this.n);if(!this.curve._maxwellTrick){var c=this.g.mulAdd(h,r.getPublic(),u);if(c.isInfinity())return false;return c.getX().umod(this.n).cmp(a)===0}var c=this.g.jmulAdd(h,r.getPublic(),u);if(c.isInfinity())return false;return c.eqXToP(a)};EC.prototype.recoverPubKey=function(e,t,r,n){h((3&r)===r,"The recovery param is more than two bits");t=new d(t,n);var a=this.n;var s=new i(e);var o=t.r;var u=t.s;var c=r&1;var l=r>>1;if(o.cmp(this.curve.p.umod(this.curve.n))>=0&&l)throw new Error("Unable to find sencond key candinate");if(l)o=this.curve.pointFromX(o.add(this.curve.n),c);else o=this.curve.pointFromX(o,c);var p=t.r.invm(a);var v=a.sub(s).mul(p).umod(a);var b=u.mul(p).umod(a);return this.g.mulAdd(v,o,b)};EC.prototype.getKeyRecoveryParam=function(e,t,r,i){t=new d(t,i);if(t.recoveryParam!==null)return t.recoveryParam;for(var n=0;n<4;n++){var a;try{a=this.recoverPubKey(e,t,n)}catch(e){continue}if(a.eq(r))return n}throw new Error("Unable to find valid recovery factor")}},4724:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;function KeyPair(e,t){this.ec=e;this.priv=null;this.pub=null;if(t.priv)this._importPrivate(t.priv,t.privEnc);if(t.pub)this._importPublic(t.pub,t.pubEnc)}e.exports=KeyPair;KeyPair.fromPublic=function fromPublic(e,t,r){if(t instanceof KeyPair)return t;return new KeyPair(e,{pub:t,pubEnc:r})};KeyPair.fromPrivate=function fromPrivate(e,t,r){if(t instanceof KeyPair)return t;return new KeyPair(e,{priv:t,privEnc:r})};KeyPair.prototype.validate=function validate(){var e=this.getPublic();if(e.isInfinity())return{result:false,reason:"Invalid public key"};if(!e.validate())return{result:false,reason:"Public key is not a point"};if(!e.mul(this.ec.curve.n).isInfinity())return{result:false,reason:"Public key * N != O"};return{result:true,reason:null}};KeyPair.prototype.getPublic=function getPublic(e,t){if(typeof e==="string"){t=e;e=null}if(!this.pub)this.pub=this.ec.g.mul(this.priv);if(!t)return this.pub;return this.pub.encode(t,e)};KeyPair.prototype.getPrivate=function getPrivate(e){if(e==="hex")return this.priv.toString(16,2);else return this.priv};KeyPair.prototype._importPrivate=function _importPrivate(e,t){this.priv=new i(e,t||16);this.priv=this.priv.umod(this.ec.curve.n)};KeyPair.prototype._importPublic=function _importPublic(e,t){if(e.x||e.y){if(this.ec.curve.type==="mont"){a(e.x,"Need x coordinate")}else if(this.ec.curve.type==="short"||this.ec.curve.type==="edwards"){a(e.x&&e.y,"Need both x and y coordinate")}this.pub=this.ec.curve.point(e.x,e.y);return}this.pub=this.ec.curve.decodePoint(e,t)};KeyPair.prototype.derive=function derive(e){return e.mul(this.priv).getX()};KeyPair.prototype.sign=function sign(e,t,r){return this.ec.sign(e,this,t,r)};KeyPair.prototype.verify=function verify(e,t){return this.ec.verify(e,t,this)};KeyPair.prototype.inspect=function inspect(){return"<Key priv: "+(this.priv&&this.priv.toString(16,2))+" pub: "+(this.pub&&this.pub.inspect())+" >"}},7526:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;function Signature(e,t){if(e instanceof Signature)return e;if(this._importDER(e,t))return;a(e.r&&e.s,"Signature without r or s");this.r=new i(e.r,16);this.s=new i(e.s,16);if(e.recoveryParam===undefined)this.recoveryParam=null;else this.recoveryParam=e.recoveryParam}e.exports=Signature;function Position(){this.place=0}function getLength(e,t){var r=e[t.place++];if(!(r&128)){return r}var i=r&15;if(i===0||i>4){return false}var n=0;for(var a=0,s=t.place;a<i;a++,s++){n<<=8;n|=e[s];n>>>=0}if(n<=127){return false}t.place=s;return n}function rmPadding(e){var t=0;var r=e.length-1;while(!e[t]&&!(e[t+1]&128)&&t<r){t++}if(t===0){return e}return e.slice(t)}Signature.prototype._importDER=function _importDER(e,t){e=n.toArray(e,t);var r=new Position;if(e[r.place++]!==48){return false}var a=getLength(e,r);if(a===false){return false}if(a+r.place!==e.length){return false}if(e[r.place++]!==2){return false}var s=getLength(e,r);if(s===false){return false}var o=e.slice(r.place,s+r.place);r.place+=s;if(e[r.place++]!==2){return false}var h=getLength(e,r);if(h===false){return false}if(e.length!==h+r.place){return false}var u=e.slice(r.place,h+r.place);if(o[0]===0){if(o[1]&128){o=o.slice(1)}else{return false}}if(u[0]===0){if(u[1]&128){u=u.slice(1)}else{return false}}this.r=new i(o);this.s=new i(u);this.recoveryParam=null;return true};function constructLength(e,t){if(t<128){e.push(t);return}var r=1+(Math.log(t)/Math.LN2>>>3);e.push(r|128);while(--r){e.push(t>>>(r<<3)&255)}e.push(t)}Signature.prototype.toDER=function toDER(e){var t=this.r.toArray();var r=this.s.toArray();if(t[0]&128)t=[0].concat(t);if(r[0]&128)r=[0].concat(r);t=rmPadding(t);r=rmPadding(r);while(!r[0]&&!(r[1]&128)){r=r.slice(1)}var i=[2];constructLength(i,t.length);i=i.concat(t);i.push(2);constructLength(i,r.length);var a=i.concat(r);var s=[48];constructLength(s,a.length);s=s.concat(a);return n.encode(s,e)}},8511:function(e,t,r){"use strict";var i=r(7028);var n=r(6226);var a=r(4401);var s=a.assert;var o=a.parseBytes;var h=r(9917);var u=r(9314);function EDDSA(e){s(e==="ed25519","only tested with ed25519 so far");if(!(this instanceof EDDSA))return new EDDSA(e);var e=n[e].curve;this.curve=e;this.g=e.g;this.g.precompute(e.n.bitLength()+1);this.pointClass=e.point().constructor;this.encodingLength=Math.ceil(e.n.bitLength()/8);this.hash=i.sha512}e.exports=EDDSA;EDDSA.prototype.sign=function sign(e,t){e=o(e);var r=this.keyFromSecret(t);var i=this.hashInt(r.messagePrefix(),e);var n=this.g.mul(i);var a=this.encodePoint(n);var s=this.hashInt(a,r.pubBytes(),e).mul(r.priv());var h=i.add(s).umod(this.curve.n);return this.makeSignature({R:n,S:h,Rencoded:a})};EDDSA.prototype.verify=function verify(e,t,r){e=o(e);t=this.makeSignature(t);var i=this.keyFromPublic(r);var n=this.hashInt(t.Rencoded(),i.pubBytes(),e);var a=this.g.mul(t.S());var s=t.R().add(i.pub().mul(n));return s.eq(a)};EDDSA.prototype.hashInt=function hashInt(){var e=this.hash();for(var t=0;t<arguments.length;t++)e.update(arguments[t]);return a.intFromLE(e.digest()).umod(this.curve.n)};EDDSA.prototype.keyFromPublic=function keyFromPublic(e){return h.fromPublic(this,e)};EDDSA.prototype.keyFromSecret=function keyFromSecret(e){return h.fromSecret(this,e)};EDDSA.prototype.makeSignature=function makeSignature(e){if(e instanceof u)return e;return new u(this,e)};EDDSA.prototype.encodePoint=function encodePoint(e){var t=e.getY().toArray("le",this.encodingLength);t[this.encodingLength-1]|=e.getX().isOdd()?128:0;return t};EDDSA.prototype.decodePoint=function decodePoint(e){e=a.parseBytes(e);var t=e.length-1;var r=e.slice(0,t).concat(e[t]&~128);var i=(e[t]&128)!==0;var n=a.intFromLE(r);return this.curve.pointFromY(n,i)};EDDSA.prototype.encodeInt=function encodeInt(e){return e.toArray("le",this.encodingLength)};EDDSA.prototype.decodeInt=function decodeInt(e){return a.intFromLE(e)};EDDSA.prototype.isPoint=function isPoint(e){return e instanceof this.pointClass}},9917:function(e,t,r){"use strict";var i=r(4401);var n=i.assert;var a=i.parseBytes;var s=i.cachedProperty;function KeyPair(e,t){this.eddsa=e;this._secret=a(t.secret);if(e.isPoint(t.pub))this._pub=t.pub;else this._pubBytes=a(t.pub)}KeyPair.fromPublic=function fromPublic(e,t){if(t instanceof KeyPair)return t;return new KeyPair(e,{pub:t})};KeyPair.fromSecret=function fromSecret(e,t){if(t instanceof KeyPair)return t;return new KeyPair(e,{secret:t})};KeyPair.prototype.secret=function secret(){return this._secret};s(KeyPair,"pubBytes",(function pubBytes(){return this.eddsa.encodePoint(this.pub())}));s(KeyPair,"pub",(function pub(){if(this._pubBytes)return this.eddsa.decodePoint(this._pubBytes);return this.eddsa.g.mul(this.priv())}));s(KeyPair,"privBytes",(function privBytes(){var e=this.eddsa;var t=this.hash();var r=e.encodingLength-1;var i=t.slice(0,e.encodingLength);i[0]&=248;i[r]&=127;i[r]|=64;return i}));s(KeyPair,"priv",(function priv(){return this.eddsa.decodeInt(this.privBytes())}));s(KeyPair,"hash",(function hash(){return this.eddsa.hash().update(this.secret()).digest()}));s(KeyPair,"messagePrefix",(function messagePrefix(){return this.hash().slice(this.eddsa.encodingLength)}));KeyPair.prototype.sign=function sign(e){n(this._secret,"KeyPair can only verify");return this.eddsa.sign(e,this)};KeyPair.prototype.verify=function verify(e,t){return this.eddsa.verify(e,t,this)};KeyPair.prototype.getSecret=function getSecret(e){n(this._secret,"KeyPair is public only");return i.encode(this.secret(),e)};KeyPair.prototype.getPublic=function getPublic(e){return i.encode(this.pubBytes(),e)};e.exports=KeyPair},9314:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;var s=n.cachedProperty;var o=n.parseBytes;function Signature(e,t){this.eddsa=e;if(typeof t!=="object")t=o(t);if(Array.isArray(t)){t={R:t.slice(0,e.encodingLength),S:t.slice(e.encodingLength)}}a(t.R&&t.S,"Signature without R or S");if(e.isPoint(t.R))this._R=t.R;if(t.S instanceof i)this._S=t.S;this._Rencoded=Array.isArray(t.R)?t.R:t.Rencoded;this._Sencoded=Array.isArray(t.S)?t.S:t.Sencoded}s(Signature,"S",(function S(){return this.eddsa.decodeInt(this.Sencoded())}));s(Signature,"R",(function R(){return this.eddsa.decodePoint(this.Rencoded())}));s(Signature,"Rencoded",(function Rencoded(){return this.eddsa.encodePoint(this.R())}));s(Signature,"Sencoded",(function Sencoded(){return this.eddsa.encodeInt(this.S())}));Signature.prototype.toBytes=function toBytes(){return this.Rencoded().concat(this.Sencoded())};Signature.prototype.toHex=function toHex(){return n.encode(this.toBytes(),"hex").toUpperCase()};e.exports=Signature},9702:function(e){e.exports={doubles:{step:4,points:[["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a","f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"],["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508","11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"],["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739","d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"],["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640","4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"],["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c","4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"],["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda","96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"],["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa","5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"],["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0","cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"],["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d","9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"],["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d","e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"],["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1","9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"],["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0","5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"],["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047","10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"],["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862","283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"],["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7","7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"],["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd","56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"],["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83","7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"],["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a","53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"],["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8","bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"],["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d","4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"],["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725","7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"],["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754","4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"],["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c","17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"],["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6","6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"],["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39","c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"],["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891","893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"],["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b","febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"],["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03","2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"],["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d","eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"],["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070","7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"],["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4","e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"],["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da","662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"],["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11","1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"],["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e","efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"],["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41","2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"],["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef","67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"],["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8","db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"],["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d","648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"],["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96","35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"],["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd","ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"],["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5","9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"],["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266","40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"],["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71","34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"],["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac","c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"],["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751","1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"],["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e","493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"],["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241","c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"],["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3","be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"],["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f","4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"],["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19","aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"],["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be","b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"],["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9","6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"],["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2","8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"],["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13","7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"],["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c","ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"],["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba","2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"],["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151","e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"],["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073","d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"],["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458","38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"],["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b","69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"],["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366","d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"],["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa","40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"],["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0","620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"],["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787","7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"],["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e","ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]},naf:{wnd:7,points:[["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9","388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"],["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4","d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"],["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc","6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"],["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe","cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"],["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb","d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"],["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8","ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"],["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e","581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"],["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34","4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"],["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c","85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"],["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5","321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"],["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f","2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"],["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714","73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"],["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729","a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"],["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db","2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"],["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4","e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"],["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5","b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"],["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479","2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"],["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d","80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"],["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f","1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"],["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb","d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"],["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9","eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"],["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963","758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"],["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74","958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"],["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530","e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"],["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b","5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"],["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247","cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"],["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1","cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"],["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120","4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"],["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435","91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"],["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18","673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"],["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8","59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"],["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb","3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"],["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f","55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"],["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143","efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"],["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba","e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"],["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45","f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"],["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a","744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"],["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e","c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"],["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8","e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"],["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c","30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"],["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519","e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"],["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab","100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"],["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca","ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"],["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf","8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"],["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610","68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"],["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4","f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"],["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c","d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"],["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940","edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"],["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980","a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"],["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3","66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"],["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf","9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"],["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63","4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"],["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448","fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"],["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf","5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"],["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5","8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"],["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6","8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"],["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5","5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"],["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99","f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"],["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51","f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"],["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5","42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"],["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5","204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"],["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997","4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"],["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881","73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"],["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5","39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"],["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66","d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"],["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726","ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"],["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede","6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"],["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94","60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"],["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31","3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"],["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51","b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"],["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252","ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"],["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5","cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"],["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b","6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"],["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4","322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"],["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f","6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"],["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889","2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"],["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246","b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"],["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984","998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"],["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a","b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"],["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030","bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"],["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197","6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"],["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593","c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"],["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef","21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"],["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38","60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"],["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a","49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"],["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111","5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"],["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502","7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"],["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea","be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"],["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26","8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"],["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986","39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"],["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e","62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"],["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4","25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"],["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda","ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"],["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859","cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"],["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f","f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"],["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c","6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"],["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942","fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"],["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a","1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"],["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80","5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"],["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d","438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"],["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1","cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"],["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63","c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"],["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352","6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"],["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193","ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"],["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00","9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"],["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58","ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"],["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7","d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"],["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8","c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"],["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e","67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"],["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d","cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"],["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b","299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"],["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f","f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"],["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6","462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"],["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297","62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"],["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a","7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"],["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c","ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"],["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52","4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"],["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb","bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"],["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065","bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"],["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917","603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"],["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9","cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"],["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3","553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"],["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57","712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"],["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66","ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"],["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8","9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"],["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721","9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"],["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180","4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]}}},4401:function(e,t,r){"use strict";var i=t;var n=r(711);var a=r(3523);var s=r(6545);i.assert=a;i.toArray=s.toArray;i.zero2=s.zero2;i.toHex=s.toHex;i.encode=s.encode;function getNAF(e,t,r){var i=new Array(Math.max(e.bitLength(),r)+1);i.fill(0);var n=1<<t+1;var a=e.clone();for(var s=0;s<i.length;s++){var o;var h=a.andln(n-1);if(a.isOdd()){if(h>(n>>1)-1)o=(n>>1)-h;else o=h;a.isubn(o)}else{o=0}i[s]=o;a.iushrn(1)}return i}i.getNAF=getNAF;function getJSF(e,t){var r=[[],[]];e=e.clone();t=t.clone();var i=0;var n=0;while(e.cmpn(-i)>0||t.cmpn(-n)>0){var a=e.andln(3)+i&3;var s=t.andln(3)+n&3;if(a===3)a=-1;if(s===3)s=-1;var o;if((a&1)===0){o=0}else{var h=e.andln(7)+i&7;if((h===3||h===5)&&s===2)o=-a;else o=a}r[0].push(o);var u;if((s&1)===0){u=0}else{var h=t.andln(7)+n&7;if((h===3||h===5)&&a===2)u=-s;else u=s}r[1].push(u);if(2*i===o+1)i=1-i;if(2*n===u+1)n=1-n;e.iushrn(1);t.iushrn(1)}return r}i.getJSF=getJSF;function cachedProperty(e,t,r){var i="_"+t;e.prototype[t]=function cachedProperty(){return this[i]!==undefined?this[i]:this[i]=r.call(this)}}i.cachedProperty=cachedProperty;function parseBytes(e){return typeof e==="string"?i.toArray(e,"hex"):e}i.parseBytes=parseBytes;function intFromLE(e){return new n(e,"hex","le")}i.intFromLE=intFromLE},8368:function(e,t,r){var i=r(5055).Buffer;var n=r(3533);function EVP_BytesToKey(e,t,r,a){if(!i.isBuffer(e))e=i.from(e,"binary");if(t){if(!i.isBuffer(t))t=i.from(t,"binary");if(t.length!==8)throw new RangeError("salt should be Buffer with 8 byte length")}var s=r/8;var o=i.alloc(s);var h=i.alloc(a||0);var u=i.alloc(0);while(s>0||a>0){var d=new n;d.update(u);d.update(e);if(t)d.update(t);u=d.digest();var c=0;if(s>0){var l=o.length-s;c=Math.min(s,u.length);u.copy(o,l,0,c);s-=c}if(c<u.length&&a>0){var p=h.length-a;var v=Math.min(a,u.length-c);u.copy(h,p,c,c+v);a-=v}}u.fill(0);return{key:o,iv:h}}e.exports=EVP_BytesToKey},9029:function(e,t,r){"use strict";var i=r(5055).Buffer;var n=r(3726).Transform;var a=r(3782);function throwIfNotStringOrBuffer(e,t){if(!i.isBuffer(e)&&typeof e!=="string"){throw new TypeError(t+" must be a string or a buffer")}}function HashBase(e){n.call(this);this._block=i.allocUnsafe(e);this._blockSize=e;this._blockOffset=0;this._length=[0,0,0,0];this._finalized=false}a(HashBase,n);HashBase.prototype._transform=function(e,t,r){var i=null;try{this.update(e,t)}catch(e){i=e}r(i)};HashBase.prototype._flush=function(e){var t=null;try{this.push(this.digest())}catch(e){t=e}e(t)};HashBase.prototype.update=function(e,t){throwIfNotStringOrBuffer(e,"Data");if(this._finalized)throw new Error("Digest already called");if(!i.isBuffer(e))e=i.from(e,t);var r=this._block;var n=0;while(this._blockOffset+e.length-n>=this._blockSize){for(var a=this._blockOffset;a<this._blockSize;)r[a++]=e[n++];this._update();this._blockOffset=0}while(n<e.length)r[this._blockOffset++]=e[n++];for(var s=0,o=e.length*8;o>0;++s){this._length[s]+=o;o=this._length[s]/4294967296|0;if(o>0)this._length[s]-=4294967296*o}return this};HashBase.prototype._update=function(){throw new Error("_update is not implemented")};HashBase.prototype.digest=function(e){if(this._finalized)throw new Error("Digest already called");this._finalized=true;var t=this._digest();if(e!==undefined)t=t.toString(e);this._block.fill(0);this._blockOffset=0;for(var r=0;r<4;++r)this._length[r]=0;return t};HashBase.prototype._digest=function(){throw new Error("_digest is not implemented")};e.exports=HashBase},7028:function(e,t,r){var i=t;i.utils=r(263);i.common=r(1330);i.sha=r(301);i.ripemd=r(3079);i.hmac=r(3092);i.sha1=i.sha.sha1;i.sha256=i.sha.sha256;i.sha224=i.sha.sha224;i.sha384=i.sha.sha384;i.sha512=i.sha.sha512;i.ripemd160=i.ripemd.ripemd160},1330:function(e,t,r){"use strict";var i=r(263);var n=r(3523);function BlockHash(){this.pending=null;this.pendingTotal=0;this.blockSize=this.constructor.blockSize;this.outSize=this.constructor.outSize;this.hmacStrength=this.constructor.hmacStrength;this.padLength=this.constructor.padLength/8;this.endian="big";this._delta8=this.blockSize/8;this._delta32=this.blockSize/32}t.BlockHash=BlockHash;BlockHash.prototype.update=function update(e,t){e=i.toArray(e,t);if(!this.pending)this.pending=e;else this.pending=this.pending.concat(e);this.pendingTotal+=e.length;if(this.pending.length>=this._delta8){e=this.pending;var r=e.length%this._delta8;this.pending=e.slice(e.length-r,e.length);if(this.pending.length===0)this.pending=null;e=i.join32(e,0,e.length-r,this.endian);for(var n=0;n<e.length;n+=this._delta32)this._update(e,n,n+this._delta32)}return this};BlockHash.prototype.digest=function digest(e){this.update(this._pad());n(this.pending===null);return this._digest(e)};BlockHash.prototype._pad=function pad(){var e=this.pendingTotal;var t=this._delta8;var r=t-(e+this.padLength)%t;var i=new Array(r+this.padLength);i[0]=128;for(var n=1;n<r;n++)i[n]=0;e<<=3;if(this.endian==="big"){for(var a=8;a<this.padLength;a++)i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=e>>>24&255;i[n++]=e>>>16&255;i[n++]=e>>>8&255;i[n++]=e&255}else{i[n++]=e&255;i[n++]=e>>>8&255;i[n++]=e>>>16&255;i[n++]=e>>>24&255;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;for(a=8;a<this.padLength;a++)i[n++]=0}return i}},3092:function(e,t,r){"use strict";var i=r(263);var n=r(3523);function Hmac(e,t,r){if(!(this instanceof Hmac))return new Hmac(e,t,r);this.Hash=e;this.blockSize=e.blockSize/8;this.outSize=e.outSize/8;this.inner=null;this.outer=null;this._init(i.toArray(t,r))}e.exports=Hmac;Hmac.prototype._init=function init(e){if(e.length>this.blockSize)e=(new this.Hash).update(e).digest();n(e.length<=this.blockSize);for(var t=e.length;t<this.blockSize;t++)e.push(0);for(t=0;t<e.length;t++)e[t]^=54;this.inner=(new this.Hash).update(e);for(t=0;t<e.length;t++)e[t]^=106;this.outer=(new this.Hash).update(e)};Hmac.prototype.update=function update(e,t){this.inner.update(e,t);return this};Hmac.prototype.digest=function digest(e){this.outer.update(this.inner.digest());return this.outer.digest(e)}},3079:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=i.rotl32;var s=i.sum32;var o=i.sum32_3;var h=i.sum32_4;var u=n.BlockHash;function RIPEMD160(){if(!(this instanceof RIPEMD160))return new RIPEMD160;u.call(this);this.h=[1732584193,4023233417,2562383102,271733878,3285377520];this.endian="little"}i.inherits(RIPEMD160,u);t.ripemd160=RIPEMD160;RIPEMD160.blockSize=512;RIPEMD160.outSize=160;RIPEMD160.hmacStrength=192;RIPEMD160.padLength=64;RIPEMD160.prototype._update=function update(e,t){var r=this.h[0];var i=this.h[1];var n=this.h[2];var u=this.h[3];var v=this.h[4];var b=r;var m=i;var y=n;var g=u;var _=v;for(var w=0;w<80;w++){var M=s(a(h(r,f(w,i,n,u),e[d[w]+t],K(w)),l[w]),v);r=v;v=u;u=a(n,10);n=i;i=M;M=s(a(h(b,f(79-w,m,y,g),e[c[w]+t],Kh(w)),p[w]),_);b=_;_=g;g=a(y,10);y=m;m=M}M=o(this.h[1],n,g);this.h[1]=o(this.h[2],u,_);this.h[2]=o(this.h[3],v,b);this.h[3]=o(this.h[4],r,m);this.h[4]=o(this.h[0],i,y);this.h[0]=M};RIPEMD160.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"little");else return i.split32(this.h,"little")};function f(e,t,r,i){if(e<=15)return t^r^i;else if(e<=31)return t&r|~t&i;else if(e<=47)return(t|~r)^i;else if(e<=63)return t&i|r&~i;else return t^(r|~i)}function K(e){if(e<=15)return 0;else if(e<=31)return 1518500249;else if(e<=47)return 1859775393;else if(e<=63)return 2400959708;else return 2840853838}function Kh(e){if(e<=15)return 1352829926;else if(e<=31)return 1548603684;else if(e<=47)return 1836072691;else if(e<=63)return 2053994217;else return 0}var d=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13];var c=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11];var l=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6];var p=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11]},301:function(e,t,r){"use strict";t.sha1=r(2742);t.sha224=r(7105);t.sha256=r(1525);t.sha384=r(9948);t.sha512=r(1319)},2742:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(2975);var s=i.rotl32;var o=i.sum32;var h=i.sum32_5;var u=a.ft_1;var d=n.BlockHash;var c=[1518500249,1859775393,2400959708,3395469782];function SHA1(){if(!(this instanceof SHA1))return new SHA1;d.call(this);this.h=[1732584193,4023233417,2562383102,271733878,3285377520];this.W=new Array(80)}i.inherits(SHA1,d);e.exports=SHA1;SHA1.blockSize=512;SHA1.outSize=160;SHA1.hmacStrength=80;SHA1.padLength=64;SHA1.prototype._update=function _update(e,t){var r=this.W;for(var i=0;i<16;i++)r[i]=e[t+i];for(;i<r.length;i++)r[i]=s(r[i-3]^r[i-8]^r[i-14]^r[i-16],1);var n=this.h[0];var a=this.h[1];var d=this.h[2];var l=this.h[3];var p=this.h[4];for(i=0;i<r.length;i++){var v=~~(i/20);var b=h(s(n,5),u(v,a,d,l),p,r[i],c[v]);p=l;l=d;d=s(a,30);a=n;n=b}this.h[0]=o(this.h[0],n);this.h[1]=o(this.h[1],a);this.h[2]=o(this.h[2],d);this.h[3]=o(this.h[3],l);this.h[4]=o(this.h[4],p)};SHA1.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")}},7105:function(e,t,r){"use strict";var i=r(263);var n=r(1525);function SHA224(){if(!(this instanceof SHA224))return new SHA224;n.call(this);this.h=[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428]}i.inherits(SHA224,n);e.exports=SHA224;SHA224.blockSize=512;SHA224.outSize=224;SHA224.hmacStrength=192;SHA224.padLength=64;SHA224.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h.slice(0,7),"big");else return i.split32(this.h.slice(0,7),"big")}},1525:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(2975);var s=r(3523);var o=i.sum32;var h=i.sum32_4;var u=i.sum32_5;var d=a.ch32;var c=a.maj32;var l=a.s0_256;var p=a.s1_256;var v=a.g0_256;var b=a.g1_256;var m=n.BlockHash;var y=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function SHA256(){if(!(this instanceof SHA256))return new SHA256;m.call(this);this.h=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];this.k=y;this.W=new Array(64)}i.inherits(SHA256,m);e.exports=SHA256;SHA256.blockSize=512;SHA256.outSize=256;SHA256.hmacStrength=192;SHA256.padLength=64;SHA256.prototype._update=function _update(e,t){var r=this.W;for(var i=0;i<16;i++)r[i]=e[t+i];for(;i<r.length;i++)r[i]=h(b(r[i-2]),r[i-7],v(r[i-15]),r[i-16]);var n=this.h[0];var a=this.h[1];var m=this.h[2];var y=this.h[3];var g=this.h[4];var _=this.h[5];var w=this.h[6];var M=this.h[7];s(this.k.length===r.length);for(i=0;i<r.length;i++){var B=u(M,p(g),d(g,_,w),this.k[i],r[i]);var E=o(l(n),c(n,a,m));M=w;w=_;_=g;g=o(y,B);y=m;m=a;a=n;n=o(B,E)}this.h[0]=o(this.h[0],n);this.h[1]=o(this.h[1],a);this.h[2]=o(this.h[2],m);this.h[3]=o(this.h[3],y);this.h[4]=o(this.h[4],g);this.h[5]=o(this.h[5],_);this.h[6]=o(this.h[6],w);this.h[7]=o(this.h[7],M)};SHA256.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")}},9948:function(e,t,r){"use strict";var i=r(263);var n=r(1319);function SHA384(){if(!(this instanceof SHA384))return new SHA384;n.call(this);this.h=[3418070365,3238371032,1654270250,914150663,2438529370,812702999,355462360,4144912697,1731405415,4290775857,2394180231,1750603025,3675008525,1694076839,1203062813,3204075428]}i.inherits(SHA384,n);e.exports=SHA384;SHA384.blockSize=1024;SHA384.outSize=384;SHA384.hmacStrength=192;SHA384.padLength=128;SHA384.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h.slice(0,12),"big");else return i.split32(this.h.slice(0,12),"big")}},1319:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(3523);var s=i.rotr64_hi;var o=i.rotr64_lo;var h=i.shr64_hi;var u=i.shr64_lo;var d=i.sum64;var c=i.sum64_hi;var l=i.sum64_lo;var p=i.sum64_4_hi;var v=i.sum64_4_lo;var b=i.sum64_5_hi;var m=i.sum64_5_lo;var y=n.BlockHash;var g=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];function SHA512(){if(!(this instanceof SHA512))return new SHA512;y.call(this);this.h=[1779033703,4089235720,3144134277,2227873595,1013904242,4271175723,2773480762,1595750129,1359893119,2917565137,2600822924,725511199,528734635,4215389547,1541459225,327033209];this.k=g;this.W=new Array(160)}i.inherits(SHA512,y);e.exports=SHA512;SHA512.blockSize=1024;SHA512.outSize=512;SHA512.hmacStrength=192;SHA512.padLength=128;SHA512.prototype._prepareBlock=function _prepareBlock(e,t){var r=this.W;for(var i=0;i<32;i++)r[i]=e[t+i];for(;i<r.length;i+=2){var n=g1_512_hi(r[i-4],r[i-3]);var a=g1_512_lo(r[i-4],r[i-3]);var s=r[i-14];var o=r[i-13];var h=g0_512_hi(r[i-30],r[i-29]);var u=g0_512_lo(r[i-30],r[i-29]);var d=r[i-32];var c=r[i-31];r[i]=p(n,a,s,o,h,u,d,c);r[i+1]=v(n,a,s,o,h,u,d,c)}};SHA512.prototype._update=function _update(e,t){this._prepareBlock(e,t);var r=this.W;var i=this.h[0];var n=this.h[1];var s=this.h[2];var o=this.h[3];var h=this.h[4];var u=this.h[5];var p=this.h[6];var v=this.h[7];var y=this.h[8];var g=this.h[9];var _=this.h[10];var w=this.h[11];var M=this.h[12];var B=this.h[13];var E=this.h[14];var k=this.h[15];a(this.k.length===r.length);for(var A=0;A<r.length;A+=2){var N=E;var P=k;var x=s1_512_hi(y,g);var I=s1_512_lo(y,g);var C=ch64_hi(y,g,_,w,M,B);var D=ch64_lo(y,g,_,w,M,B);var T=this.k[A];var j=this.k[A+1];var q=r[A];var O=r[A+1];var H=b(N,P,x,I,C,D,T,j,q,O);var L=m(N,P,x,I,C,D,T,j,q,O);N=s0_512_hi(i,n);P=s0_512_lo(i,n);x=maj64_hi(i,n,s,o,h,u);I=maj64_lo(i,n,s,o,h,u);var z=c(N,P,x,I);var F=l(N,P,x,I);E=M;k=B;M=_;B=w;_=y;w=g;y=c(p,v,H,L);g=l(v,v,H,L);p=h;v=u;h=s;u=o;s=i;o=n;i=c(H,L,z,F);n=l(H,L,z,F)}d(this.h,0,i,n);d(this.h,2,s,o);d(this.h,4,h,u);d(this.h,6,p,v);d(this.h,8,y,g);d(this.h,10,_,w);d(this.h,12,M,B);d(this.h,14,E,k)};SHA512.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")};function ch64_hi(e,t,r,i,n){var a=e&r^~e&n;if(a<0)a+=4294967296;return a}function ch64_lo(e,t,r,i,n,a){var s=t&i^~t&a;if(s<0)s+=4294967296;return s}function maj64_hi(e,t,r,i,n){var a=e&r^e&n^r&n;if(a<0)a+=4294967296;return a}function maj64_lo(e,t,r,i,n,a){var s=t&i^t&a^i&a;if(s<0)s+=4294967296;return s}function s0_512_hi(e,t){var r=s(e,t,28);var i=s(t,e,2);var n=s(t,e,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function s0_512_lo(e,t){var r=o(e,t,28);var i=o(t,e,2);var n=o(t,e,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function s1_512_hi(e,t){var r=s(e,t,14);var i=s(e,t,18);var n=s(t,e,9);var a=r^i^n;if(a<0)a+=4294967296;return a}function s1_512_lo(e,t){var r=o(e,t,14);var i=o(e,t,18);var n=o(t,e,9);var a=r^i^n;if(a<0)a+=4294967296;return a}function g0_512_hi(e,t){var r=s(e,t,1);var i=s(e,t,8);var n=h(e,t,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function g0_512_lo(e,t){var r=o(e,t,1);var i=o(e,t,8);var n=u(e,t,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function g1_512_hi(e,t){var r=s(e,t,19);var i=s(t,e,29);var n=h(e,t,6);var a=r^i^n;if(a<0)a+=4294967296;return a}function g1_512_lo(e,t){var r=o(e,t,19);var i=o(t,e,29);var n=u(e,t,6);var a=r^i^n;if(a<0)a+=4294967296;return a}},2975:function(e,t,r){"use strict";var i=r(263);var n=i.rotr32;function ft_1(e,t,r,i){if(e===0)return ch32(t,r,i);if(e===1||e===3)return p32(t,r,i);if(e===2)return maj32(t,r,i)}t.ft_1=ft_1;function ch32(e,t,r){return e&t^~e&r}t.ch32=ch32;function maj32(e,t,r){return e&t^e&r^t&r}t.maj32=maj32;function p32(e,t,r){return e^t^r}t.p32=p32;function s0_256(e){return n(e,2)^n(e,13)^n(e,22)}t.s0_256=s0_256;function s1_256(e){return n(e,6)^n(e,11)^n(e,25)}t.s1_256=s1_256;function g0_256(e){return n(e,7)^n(e,18)^e>>>3}t.g0_256=g0_256;function g1_256(e){return n(e,17)^n(e,19)^e>>>10}t.g1_256=g1_256},263:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);t.inherits=n;function isSurrogatePair(e,t){if((e.charCodeAt(t)&64512)!==55296){return false}if(t<0||t+1>=e.length){return false}return(e.charCodeAt(t+1)&64512)===56320}function toArray(e,t){if(Array.isArray(e))return e.slice();if(!e)return[];var r=[];if(typeof e==="string"){if(!t){var i=0;for(var n=0;n<e.length;n++){var a=e.charCodeAt(n);if(a<128){r[i++]=a}else if(a<2048){r[i++]=a>>6|192;r[i++]=a&63|128}else if(isSurrogatePair(e,n)){a=65536+((a&1023)<<10)+(e.charCodeAt(++n)&1023);r[i++]=a>>18|240;r[i++]=a>>12&63|128;r[i++]=a>>6&63|128;r[i++]=a&63|128}else{r[i++]=a>>12|224;r[i++]=a>>6&63|128;r[i++]=a&63|128}}}else if(t==="hex"){e=e.replace(/[^a-z0-9]+/gi,"");if(e.length%2!==0)e="0"+e;for(n=0;n<e.length;n+=2)r.push(parseInt(e[n]+e[n+1],16))}}else{for(n=0;n<e.length;n++)r[n]=e[n]|0}return r}t.toArray=toArray;function toHex(e){var t="";for(var r=0;r<e.length;r++)t+=zero2(e[r].toString(16));return t}t.toHex=toHex;function htonl(e){var t=e>>>24|e>>>8&65280|e<<8&16711680|(e&255)<<24;return t>>>0}t.htonl=htonl;function toHex32(e,t){var r="";for(var i=0;i<e.length;i++){var n=e[i];if(t==="little")n=htonl(n);r+=zero8(n.toString(16))}return r}t.toHex32=toHex32;function zero2(e){if(e.length===1)return"0"+e;else return e}t.zero2=zero2;function zero8(e){if(e.length===7)return"0"+e;else if(e.length===6)return"00"+e;else if(e.length===5)return"000"+e;else if(e.length===4)return"0000"+e;else if(e.length===3)return"00000"+e;else if(e.length===2)return"000000"+e;else if(e.length===1)return"0000000"+e;else return e}t.zero8=zero8;function join32(e,t,r,n){var a=r-t;i(a%4===0);var s=new Array(a/4);for(var o=0,h=t;o<s.length;o++,h+=4){var u;if(n==="big")u=e[h]<<24|e[h+1]<<16|e[h+2]<<8|e[h+3];else u=e[h+3]<<24|e[h+2]<<16|e[h+1]<<8|e[h];s[o]=u>>>0}return s}t.join32=join32;function split32(e,t){var r=new Array(e.length*4);for(var i=0,n=0;i<e.length;i++,n+=4){var a=e[i];if(t==="big"){r[n]=a>>>24;r[n+1]=a>>>16&255;r[n+2]=a>>>8&255;r[n+3]=a&255}else{r[n+3]=a>>>24;r[n+2]=a>>>16&255;r[n+1]=a>>>8&255;r[n]=a&255}}return r}t.split32=split32;function rotr32(e,t){return e>>>t|e<<32-t}t.rotr32=rotr32;function rotl32(e,t){return e<<t|e>>>32-t}t.rotl32=rotl32;function sum32(e,t){return e+t>>>0}t.sum32=sum32;function sum32_3(e,t,r){return e+t+r>>>0}t.sum32_3=sum32_3;function sum32_4(e,t,r,i){return e+t+r+i>>>0}t.sum32_4=sum32_4;function sum32_5(e,t,r,i,n){return e+t+r+i+n>>>0}t.sum32_5=sum32_5;function sum64(e,t,r,i){var n=e[t];var a=e[t+1];var s=i+a>>>0;var o=(s<i?1:0)+r+n;e[t]=o>>>0;e[t+1]=s}t.sum64=sum64;function sum64_hi(e,t,r,i){var n=t+i>>>0;var a=(n<t?1:0)+e+r;return a>>>0}t.sum64_hi=sum64_hi;function sum64_lo(e,t,r,i){var n=t+i;return n>>>0}t.sum64_lo=sum64_lo;function sum64_4_hi(e,t,r,i,n,a,s,o){var h=0;var u=t;u=u+i>>>0;h+=u<t?1:0;u=u+a>>>0;h+=u<a?1:0;u=u+o>>>0;h+=u<o?1:0;var d=e+r+n+s+h;return d>>>0}t.sum64_4_hi=sum64_4_hi;function sum64_4_lo(e,t,r,i,n,a,s,o){var h=t+i+a+o;return h>>>0}t.sum64_4_lo=sum64_4_lo;function sum64_5_hi(e,t,r,i,n,a,s,o,h,u){var d=0;var c=t;c=c+i>>>0;d+=c<t?1:0;c=c+a>>>0;d+=c<a?1:0;c=c+o>>>0;d+=c<o?1:0;c=c+u>>>0;d+=c<u?1:0;var l=e+r+n+s+h+d;return l>>>0}t.sum64_5_hi=sum64_5_hi;function sum64_5_lo(e,t,r,i,n,a,s,o,h,u){var d=t+i+a+o+u;return d>>>0}t.sum64_5_lo=sum64_5_lo;function rotr64_hi(e,t,r){var i=t<<32-r|e>>>r;return i>>>0}t.rotr64_hi=rotr64_hi;function rotr64_lo(e,t,r){var i=e<<32-r|t>>>r;return i>>>0}t.rotr64_lo=rotr64_lo;function shr64_hi(e,t,r){return e>>>r}t.shr64_hi=shr64_hi;function shr64_lo(e,t,r){var i=e<<32-r|t>>>r;return i>>>0}t.shr64_lo=shr64_lo},4910:function(e,t,r){"use strict";var i=r(7028);var n=r(6545);var a=r(3523);function HmacDRBG(e){if(!(this instanceof HmacDRBG))return new HmacDRBG(e);this.hash=e.hash;this.predResist=!!e.predResist;this.outLen=this.hash.outSize;this.minEntropy=e.minEntropy||this.hash.hmacStrength;this._reseed=null;this.reseedInterval=null;this.K=null;this.V=null;var t=n.toArray(e.entropy,e.entropyEnc||"hex");var r=n.toArray(e.nonce,e.nonceEnc||"hex");var i=n.toArray(e.pers,e.persEnc||"hex");a(t.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits");this._init(t,r,i)}e.exports=HmacDRBG;HmacDRBG.prototype._init=function init(e,t,r){var i=e.concat(t).concat(r);this.K=new Array(this.outLen/8);this.V=new Array(this.outLen/8);for(var n=0;n<this.V.length;n++){this.K[n]=0;this.V[n]=1}this._update(i);this._reseed=1;this.reseedInterval=281474976710656};HmacDRBG.prototype._hmac=function hmac(){return new i.hmac(this.hash,this.K)};HmacDRBG.prototype._update=function update(e){var t=this._hmac().update(this.V).update([0]);if(e)t=t.update(e);this.K=t.digest();this.V=this._hmac().update(this.V).digest();if(!e)return;this.K=this._hmac().update(this.V).update([1]).update(e).digest();this.V=this._hmac().update(this.V).digest()};HmacDRBG.prototype.reseed=function reseed(e,t,r,i){if(typeof t!=="string"){i=r;r=t;t=null}e=n.toArray(e,t);r=n.toArray(r,i);a(e.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits");this._update(e.concat(r||[]));this._reseed=1};HmacDRBG.prototype.generate=function generate(e,t,r,i){if(this._reseed>this.reseedInterval)throw new Error("Reseed is required");if(typeof t!=="string"){i=r;r=t;t=null}if(r){r=n.toArray(r,i||"hex");this._update(r)}var a=[];while(a.length<e){this.V=this._hmac().update(this.V).digest();a=a.concat(this.V)}var s=a.slice(0,e);this._update(r);this._reseed++;return n.encode(s,t)}},3782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},3533:function(e,t,r){"use strict";var i=r(3782);var n=r(9029);var a=r(5055).Buffer;var s=new Array(16);function MD5(){n.call(this,64);this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878}i(MD5,n);MD5.prototype._update=function(){var e=s;for(var t=0;t<16;++t)e[t]=this._block.readInt32LE(t*4);var r=this._a;var i=this._b;var n=this._c;var a=this._d;r=fnF(r,i,n,a,e[0],3614090360,7);a=fnF(a,r,i,n,e[1],3905402710,12);n=fnF(n,a,r,i,e[2],606105819,17);i=fnF(i,n,a,r,e[3],3250441966,22);r=fnF(r,i,n,a,e[4],4118548399,7);a=fnF(a,r,i,n,e[5],1200080426,12);n=fnF(n,a,r,i,e[6],2821735955,17);i=fnF(i,n,a,r,e[7],4249261313,22);r=fnF(r,i,n,a,e[8],1770035416,7);a=fnF(a,r,i,n,e[9],2336552879,12);n=fnF(n,a,r,i,e[10],4294925233,17);i=fnF(i,n,a,r,e[11],2304563134,22);r=fnF(r,i,n,a,e[12],1804603682,7);a=fnF(a,r,i,n,e[13],4254626195,12);n=fnF(n,a,r,i,e[14],2792965006,17);i=fnF(i,n,a,r,e[15],1236535329,22);r=fnG(r,i,n,a,e[1],4129170786,5);a=fnG(a,r,i,n,e[6],3225465664,9);n=fnG(n,a,r,i,e[11],643717713,14);i=fnG(i,n,a,r,e[0],3921069994,20);r=fnG(r,i,n,a,e[5],3593408605,5);a=fnG(a,r,i,n,e[10],38016083,9);n=fnG(n,a,r,i,e[15],3634488961,14);i=fnG(i,n,a,r,e[4],3889429448,20);r=fnG(r,i,n,a,e[9],568446438,5);a=fnG(a,r,i,n,e[14],3275163606,9);n=fnG(n,a,r,i,e[3],4107603335,14);i=fnG(i,n,a,r,e[8],1163531501,20);r=fnG(r,i,n,a,e[13],2850285829,5);a=fnG(a,r,i,n,e[2],4243563512,9);n=fnG(n,a,r,i,e[7],1735328473,14);i=fnG(i,n,a,r,e[12],2368359562,20);r=fnH(r,i,n,a,e[5],4294588738,4);a=fnH(a,r,i,n,e[8],2272392833,11);n=fnH(n,a,r,i,e[11],1839030562,16);i=fnH(i,n,a,r,e[14],4259657740,23);r=fnH(r,i,n,a,e[1],2763975236,4);a=fnH(a,r,i,n,e[4],1272893353,11);n=fnH(n,a,r,i,e[7],4139469664,16);i=fnH(i,n,a,r,e[10],3200236656,23);r=fnH(r,i,n,a,e[13],681279174,4);a=fnH(a,r,i,n,e[0],3936430074,11);n=fnH(n,a,r,i,e[3],3572445317,16);i=fnH(i,n,a,r,e[6],76029189,23);r=fnH(r,i,n,a,e[9],3654602809,4);a=fnH(a,r,i,n,e[12],3873151461,11);n=fnH(n,a,r,i,e[15],530742520,16);i=fnH(i,n,a,r,e[2],3299628645,23);r=fnI(r,i,n,a,e[0],4096336452,6);a=fnI(a,r,i,n,e[7],1126891415,10);n=fnI(n,a,r,i,e[14],2878612391,15);i=fnI(i,n,a,r,e[5],4237533241,21);r=fnI(r,i,n,a,e[12],1700485571,6);a=fnI(a,r,i,n,e[3],2399980690,10);n=fnI(n,a,r,i,e[10],4293915773,15);i=fnI(i,n,a,r,e[1],2240044497,21);r=fnI(r,i,n,a,e[8],1873313359,6);a=fnI(a,r,i,n,e[15],4264355552,10);n=fnI(n,a,r,i,e[6],2734768916,15);i=fnI(i,n,a,r,e[13],1309151649,21);r=fnI(r,i,n,a,e[4],4149444226,6);a=fnI(a,r,i,n,e[11],3174756917,10);n=fnI(n,a,r,i,e[2],718787259,15);i=fnI(i,n,a,r,e[9],3951481745,21);this._a=this._a+r|0;this._b=this._b+i|0;this._c=this._c+n|0;this._d=this._d+a|0};MD5.prototype._digest=function(){this._block[this._blockOffset++]=128;if(this._blockOffset>56){this._block.fill(0,this._blockOffset,64);this._update();this._blockOffset=0}this._block.fill(0,this._blockOffset,56);this._block.writeUInt32LE(this._length[0],56);this._block.writeUInt32LE(this._length[1],60);this._update();var e=a.allocUnsafe(16);e.writeInt32LE(this._a,0);e.writeInt32LE(this._b,4);e.writeInt32LE(this._c,8);e.writeInt32LE(this._d,12);return e};function rotl(e,t){return e<<t|e>>>32-t}function fnF(e,t,r,i,n,a,s){return rotl(e+(t&r|~t&i)+n+a|0,s)+t|0}function fnG(e,t,r,i,n,a,s){return rotl(e+(t&i|r&~i)+n+a|0,s)+t|0}function fnH(e,t,r,i,n,a,s){return rotl(e+(t^r^i)+n+a|0,s)+t|0}function fnI(e,t,r,i,n,a,s){return rotl(e+(r^(t|~i))+n+a|0,s)+t|0}e.exports=MD5},1354:function(e,t,r){var i=r(711);var n=r(3500);function MillerRabin(e){this.rand=e||new n.Rand}e.exports=MillerRabin;MillerRabin.create=function create(e){return new MillerRabin(e)};MillerRabin.prototype._randbelow=function _randbelow(e){var t=e.bitLength();var r=Math.ceil(t/8);do{var n=new i(this.rand.generate(r))}while(n.cmp(e)>=0);return n};MillerRabin.prototype._randrange=function _randrange(e,t){var r=t.sub(e);return e.add(this._randbelow(r))};MillerRabin.prototype.test=function test(e,t,r){var n=e.bitLength();var a=i.mont(e);var s=new i(1).toRed(a);if(!t)t=Math.max(1,n/48|0);var o=e.subn(1);for(var h=0;!o.testn(h);h++){}var u=e.shrn(h);var d=o.toRed(a);var c=true;for(;t>0;t--){var l=this._randrange(new i(2),o);if(r)r(l);var p=l.toRed(a).redPow(u);if(p.cmp(s)===0||p.cmp(d)===0)continue;for(var v=1;v<h;v++){p=p.redSqr();if(p.cmp(s)===0)return false;if(p.cmp(d)===0)break}if(v===h)return false}return c};MillerRabin.prototype.getDivisor=function getDivisor(e,t){var r=e.bitLength();var n=i.mont(e);var a=new i(1).toRed(n);if(!t)t=Math.max(1,r/48|0);var s=e.subn(1);for(var o=0;!s.testn(o);o++){}var h=e.shrn(o);var u=s.toRed(n);for(;t>0;t--){var d=this._randrange(new i(2),s);var c=e.gcd(d);if(c.cmpn(1)!==0)return c;var l=d.toRed(n).redPow(h);if(l.cmp(a)===0||l.cmp(u)===0)continue;for(var p=1;p<o;p++){l=l.redSqr();if(l.cmp(a)===0)return l.fromRed().subn(1).gcd(e);if(l.cmp(u)===0)break}if(p===o){l=l.redSqr();return l.fromRed().subn(1).gcd(e)}}return false}},3523:function(e){e.exports=assert;function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}assert.equal=function assertEqual(e,t,r){if(e!=t)throw new Error(r||"Assertion failed: "+e+" != "+t)}},6545:function(e,t){"use strict";var r=t;function toArray(e,t){if(Array.isArray(e))return e.slice();if(!e)return[];var r=[];if(typeof e!=="string"){for(var i=0;i<e.length;i++)r[i]=e[i]|0;return r}if(t==="hex"){e=e.replace(/[^a-z0-9]+/gi,"");if(e.length%2!==0)e="0"+e;for(var i=0;i<e.length;i+=2)r.push(parseInt(e[i]+e[i+1],16))}else{for(var i=0;i<e.length;i++){var n=e.charCodeAt(i);var a=n>>8;var s=n&255;if(a)r.push(a,s);else r.push(s)}}return r}r.toArray=toArray;function zero2(e){if(e.length===1)return"0"+e;else return e}r.zero2=zero2;function toHex(e){var t="";for(var r=0;r<e.length;r++)t+=zero2(e[r].toString(16));return t}r.toHex=toHex;r.encode=function encode(e,t){if(t==="hex")return toHex(e);else return e}},8687:function(e,t,r){"use strict";var i=r(7160);t.certificate=r(8782);var n=i.define("RSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("modulus").int(),this.key("publicExponent").int(),this.key("privateExponent").int(),this.key("prime1").int(),this.key("prime2").int(),this.key("exponent1").int(),this.key("exponent2").int(),this.key("coefficient").int())}));t.RSAPrivateKey=n;var a=i.define("RSAPublicKey",(function(){this.seq().obj(this.key("modulus").int(),this.key("publicExponent").int())}));t.RSAPublicKey=a;var s=i.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(o),this.key("subjectPublicKey").bitstr())}));t.PublicKey=s;var o=i.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("none").null_().optional(),this.key("curve").objid().optional(),this.key("params").seq().obj(this.key("p").int(),this.key("q").int(),this.key("g").int()).optional())}));var h=i.define("PrivateKeyInfo",(function(){this.seq().obj(this.key("version").int(),this.key("algorithm").use(o),this.key("subjectPrivateKey").octstr())}));t.PrivateKey=h;var u=i.define("EncryptedPrivateKeyInfo",(function(){this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(),this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(),this.key("kdeparams").seq().obj(this.key("salt").octstr(),this.key("iters").int())),this.key("cipher").seq().obj(this.key("algo").objid(),this.key("iv").octstr()))),this.key("subjectPrivateKey").octstr())}));t.EncryptedPrivateKey=u;var d=i.define("DSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("p").int(),this.key("q").int(),this.key("g").int(),this.key("pub_key").int(),this.key("priv_key").int())}));t.DSAPrivateKey=d;t.DSAparam=i.define("DSAparam",(function(){this.int()}));var c=i.define("ECPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("privateKey").octstr(),this.key("parameters").optional().explicit(0).use(l),this.key("publicKey").optional().explicit(1).bitstr())}));t.ECPrivateKey=c;var l=i.define("ECParameters",(function(){this.choice({namedCurve:this.objid()})}));t.signature=i.define("signature",(function(){this.seq().obj(this.key("r").int(),this.key("s").int())}))},8782:function(e,t,r){"use strict";var i=r(7160);var n=i.define("Time",(function(){this.choice({utcTime:this.utctime(),generalTime:this.gentime()})}));var a=i.define("AttributeTypeValue",(function(){this.seq().obj(this.key("type").objid(),this.key("value").any())}));var s=i.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("parameters").optional(),this.key("curve").objid().optional())}));var o=i.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(s),this.key("subjectPublicKey").bitstr())}));var h=i.define("RelativeDistinguishedName",(function(){this.setof(a)}));var u=i.define("RDNSequence",(function(){this.seqof(h)}));var d=i.define("Name",(function(){this.choice({rdnSequence:this.use(u)})}));var c=i.define("Validity",(function(){this.seq().obj(this.key("notBefore").use(n),this.key("notAfter").use(n))}));var l=i.define("Extension",(function(){this.seq().obj(this.key("extnID").objid(),this.key("critical").bool().def(false),this.key("extnValue").octstr())}));var p=i.define("TBSCertificate",(function(){this.seq().obj(this.key("version").explicit(0).int().optional(),this.key("serialNumber").int(),this.key("signature").use(s),this.key("issuer").use(d),this.key("validity").use(c),this.key("subject").use(d),this.key("subjectPublicKeyInfo").use(o),this.key("issuerUniqueID").implicit(1).bitstr().optional(),this.key("subjectUniqueID").implicit(2).bitstr().optional(),this.key("extensions").explicit(3).seqof(l).optional())}));var v=i.define("X509Certificate",(function(){this.seq().obj(this.key("tbsCertificate").use(p),this.key("signatureAlgorithm").use(s),this.key("signatureValue").bitstr())}));e.exports=v},6501:function(e,t,r){var i=/Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m;var n=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;var a=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m;var s=r(8368);var o=r(6594);var h=r(5055).Buffer;e.exports=function(e,t){var r=e.toString();var u=r.match(i);var d;if(!u){var c=r.match(a);d=new h(c[2].replace(/[\r\n]/g,""),"base64")}else{var l="aes"+u[1];var p=h.from(u[2],"hex");var v=h.from(u[3].replace(/[\r\n]/g,""),"base64");var b=s(t,p.slice(0,8),parseInt(u[1],10)).key;var m=[];var y=o.createDecipheriv(l,b,p);m.push(y.update(v));m.push(y.final());d=h.concat(m)}var g=r.match(n)[1];return{tag:g,data:d}}},9902:function(e,t,r){var i=r(8687);var n=r(2510);var a=r(6501);var s=r(6594);var o=r(4978);var h=r(5055).Buffer;e.exports=parseKeys;function parseKeys(e){var t;if(typeof e==="object"&&!h.isBuffer(e)){t=e.passphrase;e=e.key}if(typeof e==="string"){e=h.from(e)}var r=a(e,t);var n=r.tag;var s=r.data;var o,u;switch(n){case"CERTIFICATE":u=i.certificate.decode(s,"der").tbsCertificate.subjectPublicKeyInfo;case"PUBLIC KEY":if(!u){u=i.PublicKey.decode(s,"der")}o=u.algorithm.algorithm.join(".");switch(o){case"1.2.840.113549.1.1.1":return i.RSAPublicKey.decode(u.subjectPublicKey.data,"der");case"1.2.840.10045.2.1":u.subjectPrivateKey=u.subjectPublicKey;return{type:"ec",data:u};case"1.2.840.10040.4.1":u.algorithm.params.pub_key=i.DSAparam.decode(u.subjectPublicKey.data,"der");return{type:"dsa",data:u.algorithm.params};default:throw new Error("unknown key id "+o)}throw new Error("unknown key type "+n);case"ENCRYPTED PRIVATE KEY":s=i.EncryptedPrivateKey.decode(s,"der");s=decrypt(s,t);case"PRIVATE KEY":u=i.PrivateKey.decode(s,"der");o=u.algorithm.algorithm.join(".");switch(o){case"1.2.840.113549.1.1.1":return i.RSAPrivateKey.decode(u.subjectPrivateKey,"der");case"1.2.840.10045.2.1":return{curve:u.algorithm.curve,privateKey:i.ECPrivateKey.decode(u.subjectPrivateKey,"der").privateKey};case"1.2.840.10040.4.1":u.algorithm.params.priv_key=i.DSAparam.decode(u.subjectPrivateKey,"der");return{type:"dsa",params:u.algorithm.params};default:throw new Error("unknown key id "+o)}throw new Error("unknown key type "+n);case"RSA PUBLIC KEY":return i.RSAPublicKey.decode(s,"der");case"RSA PRIVATE KEY":return i.RSAPrivateKey.decode(s,"der");case"DSA PRIVATE KEY":return{type:"dsa",params:i.DSAPrivateKey.decode(s,"der")};case"EC PRIVATE KEY":s=i.ECPrivateKey.decode(s,"der");return{curve:s.parameters.value,privateKey:s.privateKey};default:throw new Error("unknown key type "+n)}}parseKeys.signature=i.signature;function decrypt(e,t){var r=e.algorithm.decrypt.kde.kdeparams.salt;var i=parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(),10);var a=n[e.algorithm.decrypt.cipher.algo.join(".")];var u=e.algorithm.decrypt.cipher.iv;var d=e.subjectPrivateKey;var c=parseInt(a.split("-")[1],10)/8;var l=o.pbkdf2Sync(t,r,i,c,"sha1");var p=s.createDecipheriv(a,l,u);var v=[];v.push(p.update(d));v.push(p.final());return h.concat(v)}},4978:function(e,t,r){var i=r(6113);var n=r(5349);var a=r(7007);var s=r(5407);function nativePBKDF2(e,t,r,o,h,u){n(r,o);e=s(e,a,"Password");t=s(t,a,"Salt");if(typeof h==="function"){u=h;h="sha1"}if(typeof u!=="function")throw new Error("No callback provided to pbkdf2");return i.pbkdf2(e,t,r,o,h,u)}function nativePBKDF2Sync(e,t,r,o,h){n(r,o);e=s(e,a,"Password");t=s(t,a,"Salt");h=h||"sha1";return i.pbkdf2Sync(e,t,r,o,h)}if(!i.pbkdf2Sync||i.pbkdf2Sync.toString().indexOf("keylen, digest")===-1){t.pbkdf2Sync=r(2127);t.pbkdf2=r(9601)}else{t.pbkdf2Sync=nativePBKDF2Sync;t.pbkdf2=nativePBKDF2}},9601:function(e,t,r){var i=r(5055).Buffer;var n=r(5349);var a=r(7007);var s=r(2127);var o=r(5407);var h;var u=__webpack_require__.g.crypto&&__webpack_require__.g.crypto.subtle;var d={sha:"SHA-1","sha-1":"SHA-1",sha1:"SHA-1",sha256:"SHA-256","sha-256":"SHA-256",sha384:"SHA-384","sha-384":"SHA-384","sha-512":"SHA-512",sha512:"SHA-512"};var c=[];function checkNative(e){if(__webpack_require__.g.process&&!__webpack_require__.g.process.browser){return Promise.resolve(false)}if(!u||!u.importKey||!u.deriveBits){return Promise.resolve(false)}if(c[e]!==undefined){return c[e]}h=h||i.alloc(8);var t=browserPbkdf2(h,h,10,128,e).then((function(){return true})).catch((function(){return false}));c[e]=t;return t}function browserPbkdf2(e,t,r,n,a){return u.importKey("raw",e,{name:"PBKDF2"},false,["deriveBits"]).then((function(e){return u.deriveBits({name:"PBKDF2",salt:t,iterations:r,hash:{name:a}},e,n<<3)})).then((function(e){return i.from(e)}))}function resolvePromise(e,t){e.then((function(e){process.nextTick((function(){t(null,e)}))}),(function(e){process.nextTick((function(){t(e)}))}))}e.exports=function(e,t,r,i,h,u){if(typeof h==="function"){u=h;h=undefined}h=h||"sha1";var c=d[h.toLowerCase()];if(!c||typeof __webpack_require__.g.Promise!=="function"){return process.nextTick((function(){var n;try{n=s(e,t,r,i,h)}catch(e){return u(e)}u(null,n)}))}n(r,i);e=o(e,a,"Password");t=o(t,a,"Salt");if(typeof u!=="function")throw new Error("No callback provided to pbkdf2");resolvePromise(checkNative(c).then((function(n){if(n)return browserPbkdf2(e,t,r,i,c);return s(e,t,r,i,h)})),u)}},7007:function(e){var t;if(true){t="utf-8"}else { var r; }e.exports=t},5349:function(e){var t=Math.pow(2,30)-1;e.exports=function(e,r){if(typeof e!=="number"){throw new TypeError("Iterations not a number")}if(e<0){throw new TypeError("Bad iterations")}if(typeof r!=="number"){throw new TypeError("Key length not a number")}if(r<0||r>t||r!==r){throw new TypeError("Bad key length")}}},2127:function(e,t,r){var i={md5:16,sha1:20,sha224:28,sha256:32,sha384:48,sha512:64,rmd160:20,ripemd160:20};var n=r(4873);var a=r(5055).Buffer;var s=r(5349);var o=r(7007);var h=r(5407);function pbkdf2(e,t,r,u,d){s(r,u);e=h(e,o,"Password");t=h(t,o,"Salt");d=d||"sha1";var c=a.allocUnsafe(u);var l=a.allocUnsafe(t.length+4);t.copy(l,0,0,t.length);var p=0;var v=i[d];var b=Math.ceil(u/v);for(var m=1;m<=b;m++){l.writeUInt32BE(m,t.length);var y=n(d,e).update(l).digest();var g=y;for(var _=1;_<r;_++){g=n(d,e).update(g).digest();for(var w=0;w<v;w++)y[w]^=g[w]}y.copy(c,p);p+=v}return c}e.exports=pbkdf2},5407:function(e,t,r){var i=r(5055).Buffer;e.exports=function(e,t,r){if(i.isBuffer(e)){return e}else if(typeof e==="string"){return i.from(e,t)}else if(ArrayBuffer.isView(e)){return i.from(e.buffer)}else{throw new TypeError(r+" must be a string, a Buffer, a typed array or a DataView")}}},9783:function(e,t,r){t.publicEncrypt=r(3995);t.privateDecrypt=r(4366);t.privateEncrypt=function privateEncrypt(e,r){return t.publicEncrypt(e,r,true)};t.publicDecrypt=function publicDecrypt(e,r){return t.privateDecrypt(e,r,true)}},5520:function(e,t,r){var i=r(9739);var n=r(5055).Buffer;e.exports=function(e,t){var r=n.alloc(0);var a=0;var s;while(r.length<t){s=i2ops(a++);r=n.concat([r,i("sha1").update(e).update(s).digest()])}return r.slice(0,t)};function i2ops(e){var t=n.allocUnsafe(4);t.writeUInt32BE(e,0);return t}},4366:function(e,t,r){var i=r(9902);var n=r(5520);var a=r(6386);var s=r(711);var o=r(7166);var h=r(9739);var u=r(1607);var d=r(5055).Buffer;e.exports=function privateDecrypt(e,t,r){var n;if(e.padding){n=e.padding}else if(r){n=1}else{n=4}var a=i(e);var h=a.modulus.byteLength();if(t.length>h||new s(t).cmp(a.modulus)>=0){throw new Error("decryption error")}var c;if(r){c=u(new s(t),a)}else{c=o(t,a)}var l=d.alloc(h-c.length);c=d.concat([l,c],h);if(n===4){return oaep(a,c)}else if(n===1){return pkcs1(a,c,r)}else if(n===3){return c}else{throw new Error("unknown padding")}};function oaep(e,t){var r=e.modulus.byteLength();var i=h("sha1").update(d.alloc(0)).digest();var s=i.length;if(t[0]!==0){throw new Error("decryption error")}var o=t.slice(1,s+1);var u=t.slice(s+1);var c=a(o,n(u,s));var l=a(u,n(c,r-s-1));if(compare(i,l.slice(0,s))){throw new Error("decryption error")}var p=s;while(l[p]===0){p++}if(l[p++]!==1){throw new Error("decryption error")}return l.slice(p)}function pkcs1(e,t,r){var i=t.slice(0,2);var n=2;var a=0;while(t[n++]!==0){if(n>=t.length){a++;break}}var s=t.slice(2,n-1);if(i.toString("hex")!=="0002"&&!r||i.toString("hex")!=="0001"&&r){a++}if(s.length<8){a++}if(a){throw new Error("decryption error")}return t.slice(n)}function compare(e,t){e=d.from(e);t=d.from(t);var r=0;var i=e.length;if(e.length!==t.length){r++;i=Math.min(e.length,t.length)}var n=-1;while(++n<i){r+=e[n]^t[n]}return r}},3995:function(e,t,r){var i=r(9902);var n=r(7223);var a=r(9739);var s=r(5520);var o=r(6386);var h=r(711);var u=r(1607);var d=r(7166);var c=r(5055).Buffer;e.exports=function publicEncrypt(e,t,r){var n;if(e.padding){n=e.padding}else if(r){n=1}else{n=4}var a=i(e);var s;if(n===4){s=oaep(a,t)}else if(n===1){s=pkcs1(a,t,r)}else if(n===3){s=new h(t);if(s.cmp(a.modulus)>=0){throw new Error("data too long for modulus")}}else{throw new Error("unknown padding")}if(r){return d(s,a)}else{return u(s,a)}};function oaep(e,t){var r=e.modulus.byteLength();var i=t.length;var u=a("sha1").update(c.alloc(0)).digest();var d=u.length;var l=2*d;if(i>r-l-2){throw new Error("message too long")}var p=c.alloc(r-i-l-2);var v=r-d-1;var b=n(d);var m=o(c.concat([u,p,c.alloc(1,1),t],v),s(b,v));var y=o(b,s(m,d));return new h(c.concat([c.alloc(1),y,m],r))}function pkcs1(e,t,r){var i=t.length;var n=e.modulus.byteLength();if(i>n-11){throw new Error("message too long")}var a;if(r){a=c.alloc(n-i-3,255)}else{a=nonZero(n-i-3)}return new h(c.concat([c.from([0,r?1:2]),a,c.alloc(1),t],n))}function nonZero(e){var t=c.allocUnsafe(e);var r=0;var i=n(e*2);var a=0;var s;while(r<e){if(a===i.length){i=n(e*2);a=0}s=i[a++];if(s){t[r++]=s}}return t}},1607:function(e,t,r){var i=r(711);var n=r(5055).Buffer;function withPublic(e,t){return n.from(e.toRed(i.mont(t.modulus)).redPow(new i(t.publicExponent)).fromRed().toArray())}e.exports=withPublic},6386:function(e){e.exports=function xor(e,t){var r=e.length;var i=-1;while(++i<r){e[i]^=t[i]}return e}},7223:function(e,t,r){"use strict";var i=65536;var n=4294967295;function oldBrowser(){throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11")}var a=r(5055).Buffer;var s=__webpack_require__.g.crypto||__webpack_require__.g.msCrypto;if(s&&s.getRandomValues){e.exports=randomBytes}else{e.exports=oldBrowser}function randomBytes(e,t){if(e>n)throw new RangeError("requested too many random bytes");var r=a.allocUnsafe(e);if(e>0){if(e>i){for(var o=0;o<e;o+=i){s.getRandomValues(r.slice(o,o+i))}}else{s.getRandomValues(r)}}if(typeof t==="function"){return process.nextTick((function(){t(null,r)}))}return r}},6445:function(e,t,r){"use strict";function oldBrowser(){throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11")}var i=r(5055);var n=r(7223);var a=i.Buffer;var s=i.kMaxLength;var o=__webpack_require__.g.crypto||__webpack_require__.g.msCrypto;var h=Math.pow(2,32)-1;function assertOffset(e,t){if(typeof e!=="number"||e!==e){throw new TypeError("offset must be a number")}if(e>h||e<0){throw new TypeError("offset must be a uint32")}if(e>s||e>t){throw new RangeError("offset out of range")}}function assertSize(e,t,r){if(typeof e!=="number"||e!==e){throw new TypeError("size must be a number")}if(e>h||e<0){throw new TypeError("size must be a uint32")}if(e+t>r||e>s){throw new RangeError("buffer too small")}}if(o&&o.getRandomValues||!true){t.randomFill=randomFill;t.randomFillSync=randomFillSync}else{t.randomFill=oldBrowser;t.randomFillSync=oldBrowser}function randomFill(e,t,r,i){if(!a.isBuffer(e)&&!(e instanceof __webpack_require__.g.Uint8Array)){throw new TypeError('"buf" argument must be a Buffer or Uint8Array')}if(typeof t==="function"){i=t;t=0;r=e.length}else if(typeof r==="function"){i=r;r=e.length-t}else if(typeof i!=="function"){throw new TypeError('"cb" argument must be a function')}assertOffset(t,e.length);assertSize(r,t,e.length);return actualFill(e,t,r,i)}function actualFill(e,t,r,i){if(true){var a=e.buffer;var s=new Uint8Array(a,t,r);o.getRandomValues(s);if(i){process.nextTick((function(){i(null,e)}));return}return e}if(i){n(r,(function(r,n){if(r){return i(r)}n.copy(e,t);i(null,e)}));return}var h=n(r);h.copy(e,t);return e}function randomFillSync(e,t,r){if(typeof t==="undefined"){t=0}if(!a.isBuffer(e)&&!(e instanceof __webpack_require__.g.Uint8Array)){throw new TypeError('"buf" argument must be a Buffer or Uint8Array')}assertOffset(t,e.length);if(r===undefined)r=e.length-t;assertSize(r,t,e.length);return actualFill(e,t,r)}},4646:function(e){"use strict";const t={};function createErrorType(e,r,i){if(!i){i=Error}function getMessage(e,t,i){if(typeof r==="string"){return r}else{return r(e,t,i)}}class NodeError extends i{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=i.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let i;if(typeof t==="string"&&startsWith(t,"not ")){i="must not be";t=t.replace(/^not /,"")}else{i="must be"}let n;if(endsWith(e," argument")){n=`The ${e} ${i} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";n=`The "${e}" ${r} ${i} ${oneOf(t,"type")}`}n+=`. Received type ${typeof r}`;return n}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},2403:function(e,t,r){"use strict";var i=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var n=r(1709);var a=r(7337);r(3782)(Duplex,n);{var s=i(a.prototype);for(var o=0;o<s.length;o++){var h=s[o];if(!Duplex.prototype[h])Duplex.prototype[h]=a.prototype[h]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);n.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},7889:function(e,t,r){"use strict";e.exports=PassThrough;var i=r(1170);r(3782)(PassThrough,i);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);i.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},1709:function(e,t,r){"use strict";e.exports=Readable;var i;Readable.ReadableState=ReadableState;var n=r(2361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var s=r(4678);var o=r(4300).Buffer;var h=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof h}var u=r(3837);var d;if(u&&u.debuglog){d=u.debuglog("stream")}else{d=function debug(){}}var c=r(4379);var l=r(7025);var p=r(6776),v=p.getHighWaterMark;var b=r(4646).q,m=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,g=b.ERR_METHOD_NOT_IMPLEMENTED,_=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var M;var B;r(3782)(Readable,s);var E=l.errorOrDestroy;var k=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,n){i=i||r(2403);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=v(this,e,"readableHighWaterMark",n);this.buffer=new c;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(3704).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){i=i||r(2403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof i;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}s.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=l.destroy;Readable.prototype._undestroy=l.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var i;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=o.from(e,t);t=""}i=true}}else{i=true}return readableAddChunk(this,e,t,false,i)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,i,n){d("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var s;if(!n)s=chunkInvalid(a,t);if(s){E(e,s)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==o.prototype){t=_uint8ArrayToBuffer(t)}if(i){if(a.endEmitted)E(e,new _);else addChunk(e,a,t,true)}else if(a.ended){E(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!i){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,i){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(i)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new m("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(3704).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var i=this._readableState.buffer.head;var n="";while(i!==null){n+=t.write(i.data);i=i.next}this._readableState.buffer.clear();if(n!=="")this._readableState.buffer.push(n);this._readableState.length=n.length;return this};var A=1073741824;function computeNewHighWaterMark(e){if(e>=A){e=A}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){d("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){d("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var i=t.needReadable;d("need readable",i);if(t.length===0||t.length-e<t.highWaterMark){i=true;d("length less than watermark",i)}if(t.ended||t.reading){i=false;d("reading or ended",i)}else if(i){d("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var n;if(e>0)n=fromList(e,t);else n=null;if(n===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(n!==null)this.emit("data",n);return n};function onEofChunk(e,t){d("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;d("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){d("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;d("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;d("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){E(this,new g("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var i=this._readableState;switch(i.pipesCount){case 0:i.pipes=e;break;case 1:i.pipes=[i.pipes,e];break;default:i.pipes.push(e);break}i.pipesCount+=1;d("pipe count=%d opts=%j",i.pipesCount,t);var n=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var s=n?onend:unpipe;if(i.endEmitted)process.nextTick(s);else r.once("end",s);e.on("unpipe",onunpipe);function onunpipe(e,t){d("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){d("onend");e.end()}var o=pipeOnDrain(r);e.on("drain",o);var h=false;function cleanup(){d("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",o);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);h=true;if(i.awaitDrain&&(!e._writableState||e._writableState.needDrain))o()}r.on("data",ondata);function ondata(t){d("ondata");var n=e.write(t);d("dest.write",n);if(n===false){if((i.pipesCount===1&&i.pipes===e||i.pipesCount>1&&indexOf(i.pipes,e)!==-1)&&!h){d("false write response, pause",i.awaitDrain);i.awaitDrain++}r.pause()}}function onerror(t){d("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)E(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){d("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){d("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!i.flowing){d("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;d("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var i=t.pipes;var n=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<n;a++){i[a].emit("unpipe",this,{hasUnpiped:false})}return this}var s=indexOf(t.pipes,e);if(s===-1)return this;t.pipes.splice(s,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=s.prototype.on.call(this,e,t);var i=this._readableState;if(e==="data"){i.readableListening=this.listenerCount("readable")>0;if(i.flowing!==false)this.resume()}else if(e==="readable"){if(!i.endEmitted&&!i.readableListening){i.readableListening=i.needReadable=true;i.flowing=false;i.emittedReadable=false;d("on readable",i.length,i.reading);if(i.length){emitReadable(this)}else if(!i.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=s.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=s.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){d("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){d("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){d("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){d("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){d("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;d("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var i=false;e.on("end",(function(){d("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(n){d("wrapped data");if(r.decoder)n=r.decoder.write(n);if(r.objectMode&&(n===null||n===undefined))return;else if(!r.objectMode&&(!n||!n.length))return;var a=t.push(n);if(!a){i=true;e.pause()}}));for(var n in e){if(this[n]===undefined&&typeof e[n]==="function"){this[n]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(n)}}for(var a=0;a<k.length;a++){e.on(k[a],this.emit.bind(this,k[a]))}this._read=function(t){d("wrapped _read",t);if(i){i=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(M===undefined){M=r(6871)}return M(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;d("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){d("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(B===undefined){B=r(9727)}return B(Readable,e,t)}}function indexOf(e,t){for(var r=0,i=e.length;r<i;r++){if(e[r]===t)return r}return-1}},1170:function(e,t,r){"use strict";e.exports=Transform;var i=r(4646).q,n=i.ERR_METHOD_NOT_IMPLEMENTED,a=i.ERR_MULTIPLE_CALLBACK,s=i.ERR_TRANSFORM_ALREADY_TRANSFORMING,o=i.ERR_TRANSFORM_WITH_LENGTH_0;var h=r(2403);r(3782)(Transform,h);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var i=r.writecb;if(i===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);i(e);var n=this._readableState;n.reading=false;if(n.needReadable||n.length<n.highWaterMark){this._read(n.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);h.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return h.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new n("_transform()"))};Transform.prototype._write=function(e,t,r){var i=this._transformState;i.writecb=r;i.writechunk=e;i.writeencoding=t;if(!i.transforming){var n=this._readableState;if(i.needTransform||n.needReadable||n.length<n.highWaterMark)this._read(n.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){h.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new o;if(e._transformState.transforming)throw new s;return e.push(null)}},7337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var i;Writable.WritableState=WritableState;var n={deprecate:r(6769)};var a=r(4678);var s=r(4300).Buffer;var o=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof o}var h=r(7025);var u=r(6776),d=u.getHighWaterMark;var c=r(4646).q,l=c.ERR_INVALID_ARG_TYPE,p=c.ERR_METHOD_NOT_IMPLEMENTED,v=c.ERR_MULTIPLE_CALLBACK,b=c.ERR_STREAM_CANNOT_PIPE,m=c.ERR_STREAM_DESTROYED,y=c.ERR_STREAM_NULL_VALUES,g=c.ERR_STREAM_WRITE_AFTER_END,_=c.ERR_UNKNOWN_ENCODING;var w=h.errorOrDestroy;r(3782)(Writable,a);function nop(){}function WritableState(e,t,n){i=i||r(2403);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=d(this,e,"writableHighWaterMark",n);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:n.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var M;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){M=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(M.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{M=function realHasInstance(e){return e instanceof this}}function Writable(e){i=i||r(2403);var t=this instanceof i;if(!t&&!M.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new g;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,i){var n;if(r===null){n=new y}else if(typeof r!=="string"&&!t.objectMode){n=new l("chunk",["string","Buffer"],r)}if(n){w(e,n);process.nextTick(i,n);return false}return true}Writable.prototype.write=function(e,t,r){var i=this._writableState;var n=false;var a=!i.objectMode&&_isUint8Array(e);if(a&&!s.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=i.defaultEncoding;if(typeof r!=="function")r=nop;if(i.ending)writeAfterEnd(this,r);else if(a||validChunk(this,i,e,r)){i.pendingcb++;n=writeOrBuffer(this,i,a,e,t,r)}return n};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new _(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=s.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,i,n,a){if(!r){var s=decodeChunk(t,i,n);if(i!==s){r=true;n="buffer";i=s}}var o=t.objectMode?1:i.length;t.length+=o;var h=t.length<t.highWaterMark;if(!h)t.needDrain=true;if(t.writing||t.corked){var u=t.lastBufferedRequest;t.lastBufferedRequest={chunk:i,encoding:n,isBuf:r,callback:a,next:null};if(u){u.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,o,i,n,a)}return h}function doWrite(e,t,r,i,n,a,s){t.writelen=i;t.writecb=s;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new m("write"));else if(r)e._writev(n,t.onwrite);else e._write(n,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,i,n){--t.pendingcb;if(r){process.nextTick(n,i);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,i)}else{n(i);e._writableState.errorEmitted=true;w(e,i);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var i=r.sync;var n=r.writecb;if(typeof n!=="function")throw new v;onwriteStateUpdate(r);if(t)onwriteError(e,r,i,t,n);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(i){process.nextTick(afterWrite,e,r,a,n)}else{afterWrite(e,r,a,n)}}}function afterWrite(e,t,r,i){if(!r)onwriteDrain(e,t);t.pendingcb--;i();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var i=t.bufferedRequestCount;var n=new Array(i);var a=t.corkedRequestsFree;a.entry=r;var s=0;var o=true;while(r){n[s]=r;if(!r.isBuf)o=false;r=r.next;s+=1}n.allBuffers=o;doWrite(e,t,true,t.length,n,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var h=r.chunk;var u=r.encoding;var d=r.callback;var c=t.objectMode?1:h.length;doWrite(e,t,false,c,h,u,d);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new p("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var i=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(i.corked){i.corked=1;this.uncork()}if(!i.ending)endWritable(this,i,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var i=e._readableState;if(!i||i.autoDestroy&&i.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var i=e.entry;e.entry=null;while(i){var n=i.callback;t.pendingcb--;n(r);i=i.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=h.destroy;Writable.prototype._undestroy=h.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},6871:function(e,t,r){"use strict";var i;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(9698);var a=Symbol("lastResolve");var s=Symbol("lastReject");var o=Symbol("error");var h=Symbol("ended");var u=Symbol("lastPromise");var d=Symbol("handlePromise");var c=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[c].read();if(r!==null){e[u]=null;e[a]=null;e[s]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,i){e.then((function(){if(t[h]){r(createIterResult(undefined,true));return}t[d](r,i)}),i)}}var l=Object.getPrototypeOf((function(){}));var p=Object.setPrototypeOf((i={get stream(){return this[c]},next:function next(){var e=this;var t=this[o];if(t!==null){return Promise.reject(t)}if(this[h]){return Promise.resolve(createIterResult(undefined,true))}if(this[c].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[o]){r(e[o])}else{t(createIterResult(undefined,true))}}))}))}var r=this[u];var i;if(r){i=new Promise(wrapForNext(r,this))}else{var n=this[c].read();if(n!==null){return Promise.resolve(createIterResult(n,false))}i=new Promise(this[d])}this[u]=i;return i}},_defineProperty(i,Symbol.asyncIterator,(function(){return this})),_defineProperty(i,"return",(function _return(){var e=this;return new Promise((function(t,r){e[c].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),i),l);var v=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(p,(t={},_defineProperty(t,c,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,h,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,d,{value:function value(e,t){var i=r[c].read();if(i){r[u]=null;r[a]=null;r[s]=null;e(createIterResult(i,false))}else{r[a]=e;r[s]=t}},writable:true}),t));r[u]=null;n(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[s];if(t!==null){r[u]=null;r[a]=null;r[s]=null;t(e)}r[o]=e;return}var i=r[a];if(i!==null){r[u]=null;r[a]=null;r[s]=null;i(createIterResult(undefined,true))}r[h]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=v},4379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var i=t[r];i.enumerable=i.enumerable||false;i.configurable=true;if("value"in i)i.writable=true;Object.defineProperty(e,i.key,i)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var i=r(4300),n=i.Buffer;var a=r(3837),s=a.inspect;var o=s&&s.custom||"inspect";function copyBuffer(e,t,r){n.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return n.alloc(0);var t=n.allocUnsafe(e>>>0);var r=this.head;var i=0;while(r){copyBuffer(r.data,t,i);i+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var i=t.data;e-=i.length;while(t=t.next){var n=t.data;var a=e>n.length?n.length:e;if(a===n.length)i+=n;else i+=n.slice(0,e);e-=a;if(e===0){if(a===n.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=n.slice(a)}break}++r}this.length-=r;return i}},{key:"_getBuffer",value:function _getBuffer(e){var t=n.allocUnsafe(e);var r=this.head;var i=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var s=e>a.length?a.length:e;a.copy(t,t.length-e,0,s);e-=s;if(e===0){if(s===a.length){++i;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(s)}break}++i}this.length-=i;return t}},{key:o,value:function value(e,t){return s(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},7025:function(e){"use strict";function destroy(e,t){var r=this;var i=this._readableState&&this._readableState.destroyed;var n=this._writableState&&this._writableState.destroyed;if(i||n){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var i=e._writableState;if(r&&r.autoDestroy||i&&i.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},9698:function(e,t,r){"use strict";var i=r(4646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,i=new Array(r),n=0;n<r;n++){i[n]=arguments[n]}e.apply(this,i)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var n=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var s=function onlegacyfinish(){if(!e.writable)h()};var o=e._writableState&&e._writableState.finished;var h=function onfinish(){a=false;o=true;if(!n)r.call(e)};var u=e._readableState&&e._readableState.endEmitted;var d=function onend(){n=false;u=true;if(!a)r.call(e)};var c=function onerror(t){r.call(e,t)};var l=function onclose(){var t;if(n&&!u){if(!e._readableState||!e._readableState.ended)t=new i;return r.call(e,t)}if(a&&!o){if(!e._writableState||!e._writableState.ended)t=new i;return r.call(e,t)}};var p=function onrequest(){e.req.on("finish",h)};if(isRequest(e)){e.on("complete",h);e.on("abort",l);if(e.req)p();else e.on("request",p)}else if(a&&!e._writableState){e.on("end",s);e.on("close",s)}e.on("end",d);e.on("finish",h);if(t.error!==false)e.on("error",c);e.on("close",l);return function(){e.removeListener("complete",h);e.removeListener("abort",l);e.removeListener("request",p);if(e.req)e.req.removeListener("finish",h);e.removeListener("end",s);e.removeListener("close",s);e.removeListener("finish",h);e.removeListener("end",d);e.removeListener("error",c);e.removeListener("close",l)}}e.exports=eos},9727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,i,n,a,s){try{var o=e[a](s);var h=o.value}catch(e){r(e);return}if(o.done){t(h)}else{Promise.resolve(h).then(i,n)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(i,n){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,i,n,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,i,n,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(4646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var n;if(t&&typeof t.next==="function"){n=t}else if(t&&t[Symbol.asyncIterator])n=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])n=t[Symbol.iterator]();else throw new i("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var s=false;a._read=function(){if(!s){s=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield n.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{s=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},8442:function(e,t,r){"use strict";var i;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var n=r(4646).q,a=n.ERR_MISSING_ARGS,s=n.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,n,a){a=once(a);var o=false;e.on("close",(function(){o=true}));if(i===undefined)i=r(9698);i(e,{readable:t,writable:n},(function(e){if(e)return a(e);o=true;a()}));var h=false;return function(t){if(o)return;if(h)return;h=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new s("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var i=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var n;var s=t.map((function(e,r){var a=r<t.length-1;var o=r>0;return destroyer(e,a,o,(function(e){if(!n)n=e;if(e)s.forEach(call);if(a)return;s.forEach(call);i(n)}))}));return t.reduce(pipe)}e.exports=pipeline},6776:function(e,t,r){"use strict";var i=r(4646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,n){var a=highWaterMarkFrom(t,n,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var s=n?r:"highWaterMark";throw new i(s,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},4678:function(e,t,r){e.exports=r(2781)},3726:function(e,t,r){var i=r(2781);if(process.env.READABLE_STREAM==="disable"&&i){e.exports=i.Readable;Object.assign(e.exports,i);e.exports.Stream=i}else{t=e.exports=r(1709);t.Stream=i||t;t.Readable=t;t.Writable=r(7337);t.Duplex=r(2403);t.Transform=r(1170);t.PassThrough=r(7889);t.finished=r(9698);t.pipeline=r(8442)}},3225:function(e,t,r){"use strict";var i=r(4300).Buffer;var n=r(3782);var a=r(9029);var s=new Array(16);var o=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13];var h=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11];var u=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6];var d=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11];var c=[0,1518500249,1859775393,2400959708,2840853838];var l=[1352829926,1548603684,1836072691,2053994217,0];function RIPEMD160(){a.call(this,64);this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520}n(RIPEMD160,a);RIPEMD160.prototype._update=function(){var e=s;for(var t=0;t<16;++t)e[t]=this._block.readInt32LE(t*4);var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var p=this._e|0;var v=this._a|0;var b=this._b|0;var m=this._c|0;var y=this._d|0;var g=this._e|0;for(var _=0;_<80;_+=1){var w;var M;if(_<16){w=fn1(r,i,n,a,p,e[o[_]],c[0],u[_]);M=fn5(v,b,m,y,g,e[h[_]],l[0],d[_])}else if(_<32){w=fn2(r,i,n,a,p,e[o[_]],c[1],u[_]);M=fn4(v,b,m,y,g,e[h[_]],l[1],d[_])}else if(_<48){w=fn3(r,i,n,a,p,e[o[_]],c[2],u[_]);M=fn3(v,b,m,y,g,e[h[_]],l[2],d[_])}else if(_<64){w=fn4(r,i,n,a,p,e[o[_]],c[3],u[_]);M=fn2(v,b,m,y,g,e[h[_]],l[3],d[_])}else{w=fn5(r,i,n,a,p,e[o[_]],c[4],u[_]);M=fn1(v,b,m,y,g,e[h[_]],l[4],d[_])}r=p;p=a;a=rotl(n,10);n=i;i=w;v=g;g=y;y=rotl(m,10);m=b;b=M}var B=this._b+n+y|0;this._b=this._c+a+g|0;this._c=this._d+p+v|0;this._d=this._e+r+b|0;this._e=this._a+i+m|0;this._a=B};RIPEMD160.prototype._digest=function(){this._block[this._blockOffset++]=128;if(this._blockOffset>56){this._block.fill(0,this._blockOffset,64);this._update();this._blockOffset=0}this._block.fill(0,this._blockOffset,56);this._block.writeUInt32LE(this._length[0],56);this._block.writeUInt32LE(this._length[1],60);this._update();var e=i.alloc?i.alloc(20):new i(20);e.writeInt32LE(this._a,0);e.writeInt32LE(this._b,4);e.writeInt32LE(this._c,8);e.writeInt32LE(this._d,12);e.writeInt32LE(this._e,16);return e};function rotl(e,t){return e<<t|e>>>32-t}function fn1(e,t,r,i,n,a,s,o){return rotl(e+(t^r^i)+a+s|0,o)+n|0}function fn2(e,t,r,i,n,a,s,o){return rotl(e+(t&r|~t&i)+a+s|0,o)+n|0}function fn3(e,t,r,i,n,a,s,o){return rotl(e+((t|~r)^i)+a+s|0,o)+n|0}function fn4(e,t,r,i,n,a,s,o){return rotl(e+(t&i|r&~i)+a+s|0,o)+n|0}function fn5(e,t,r,i,n,a,s,o){return rotl(e+(t^(r|~i))+a+s|0,o)+n|0}e.exports=RIPEMD160},5055:function(e,t,r){var i=r(4300);var n=i.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(n.from&&n.alloc&&n.allocUnsafe&&n.allocUnsafeSlow){e.exports=i}else{copyProps(i,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return n(e,t,r)}SafeBuffer.prototype=Object.create(n.prototype);copyProps(n,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return n(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var i=n(e);if(t!==undefined){if(typeof r==="string"){i.fill(t,r)}else{i.fill(t)}}else{i.fill(0)}return i};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i.SlowBuffer(e)}},2858:function(e,t,r){var i=r(5055).Buffer;function Hash(e,t){this._block=i.alloc(e);this._finalSize=t;this._blockSize=e;this._len=0}Hash.prototype.update=function(e,t){if(typeof e==="string"){t=t||"utf8";e=i.from(e,t)}var r=this._block;var n=this._blockSize;var a=e.length;var s=this._len;for(var o=0;o<a;){var h=s%n;var u=Math.min(a-o,n-h);for(var d=0;d<u;d++){r[h+d]=e[o+d]}s+=u;o+=u;if(s%n===0){this._update(r)}}this._len+=a;return this};Hash.prototype.digest=function(e){var t=this._len%this._blockSize;this._block[t]=128;this._block.fill(0,t+1);if(t>=this._finalSize){this._update(this._block);this._block.fill(0)}var r=this._len*8;if(r<=4294967295){this._block.writeUInt32BE(r,this._blockSize-4)}else{var i=(r&4294967295)>>>0;var n=(r-i)/4294967296;this._block.writeUInt32BE(n,this._blockSize-8);this._block.writeUInt32BE(i,this._blockSize-4)}this._update(this._block);var a=this._hash();return e?a.toString(e):a};Hash.prototype._update=function(){throw new Error("_update must be implemented by subclass")};e.exports=Hash},4371:function(e,t,r){var i=e.exports=function SHA(e){e=e.toLowerCase();var t=i[e];if(!t)throw new Error(e+" is not supported (we accept pull requests)");return new t};i.sha=r(4018);i.sha1=r(4179);i.sha224=r(532);i.sha256=r(1843);i.sha384=r(7455);i.sha512=r(9934)},4018:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1518500249,1859775393,2400959708|0,3395469782|0];var o=new Array(80);function Sha(){this.init();this._w=o;n.call(this,64,56)}i(Sha,n);Sha.prototype.init=function(){this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520;return this};function rotl5(e){return e<<5|e>>>27}function rotl30(e){return e<<30|e>>>2}function ft(e,t,r,i){if(e===0)return t&r|~t&i;if(e===2)return t&r|t&i|r&i;return t^r^i}Sha.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;for(var h=0;h<16;++h)t[h]=e.readInt32BE(h*4);for(;h<80;++h)t[h]=t[h-3]^t[h-8]^t[h-14]^t[h-16];for(var u=0;u<80;++u){var d=~~(u/20);var c=rotl5(r)+ft(d,i,n,a)+o+t[u]+s[d]|0;o=a;a=n;n=rotl30(i);i=r;r=c}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0};Sha.prototype._hash=function(){var e=a.allocUnsafe(20);e.writeInt32BE(this._a|0,0);e.writeInt32BE(this._b|0,4);e.writeInt32BE(this._c|0,8);e.writeInt32BE(this._d|0,12);e.writeInt32BE(this._e|0,16);return e};e.exports=Sha},4179:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1518500249,1859775393,2400959708|0,3395469782|0];var o=new Array(80);function Sha1(){this.init();this._w=o;n.call(this,64,56)}i(Sha1,n);Sha1.prototype.init=function(){this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520;return this};function rotl1(e){return e<<1|e>>>31}function rotl5(e){return e<<5|e>>>27}function rotl30(e){return e<<30|e>>>2}function ft(e,t,r,i){if(e===0)return t&r|~t&i;if(e===2)return t&r|t&i|r&i;return t^r^i}Sha1.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;for(var h=0;h<16;++h)t[h]=e.readInt32BE(h*4);for(;h<80;++h)t[h]=rotl1(t[h-3]^t[h-8]^t[h-14]^t[h-16]);for(var u=0;u<80;++u){var d=~~(u/20);var c=rotl5(r)+ft(d,i,n,a)+o+t[u]+s[d]|0;o=a;a=n;n=rotl30(i);i=r;r=c}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0};Sha1.prototype._hash=function(){var e=a.allocUnsafe(20);e.writeInt32BE(this._a|0,0);e.writeInt32BE(this._b|0,4);e.writeInt32BE(this._c|0,8);e.writeInt32BE(this._d|0,12);e.writeInt32BE(this._e|0,16);return e};e.exports=Sha1},532:function(e,t,r){var i=r(3782);var n=r(1843);var a=r(2858);var s=r(5055).Buffer;var o=new Array(64);function Sha224(){this.init();this._w=o;a.call(this,64,56)}i(Sha224,n);Sha224.prototype.init=function(){this._a=3238371032;this._b=914150663;this._c=812702999;this._d=4144912697;this._e=4290775857;this._f=1750603025;this._g=1694076839;this._h=3204075428;return this};Sha224.prototype._hash=function(){var e=s.allocUnsafe(28);e.writeInt32BE(this._a,0);e.writeInt32BE(this._b,4);e.writeInt32BE(this._c,8);e.writeInt32BE(this._d,12);e.writeInt32BE(this._e,16);e.writeInt32BE(this._f,20);e.writeInt32BE(this._g,24);return e};e.exports=Sha224},1843:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];var o=new Array(64);function Sha256(){this.init();this._w=o;n.call(this,64,56)}i(Sha256,n);Sha256.prototype.init=function(){this._a=1779033703;this._b=3144134277;this._c=1013904242;this._d=2773480762;this._e=1359893119;this._f=2600822924;this._g=528734635;this._h=1541459225;return this};function ch(e,t,r){return r^e&(t^r)}function maj(e,t,r){return e&t|r&(e|t)}function sigma0(e){return(e>>>2|e<<30)^(e>>>13|e<<19)^(e>>>22|e<<10)}function sigma1(e){return(e>>>6|e<<26)^(e>>>11|e<<21)^(e>>>25|e<<7)}function gamma0(e){return(e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3}function gamma1(e){return(e>>>17|e<<15)^(e>>>19|e<<13)^e>>>10}Sha256.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;var h=this._f|0;var u=this._g|0;var d=this._h|0;for(var c=0;c<16;++c)t[c]=e.readInt32BE(c*4);for(;c<64;++c)t[c]=gamma1(t[c-2])+t[c-7]+gamma0(t[c-15])+t[c-16]|0;for(var l=0;l<64;++l){var p=d+sigma1(o)+ch(o,h,u)+s[l]+t[l]|0;var v=sigma0(r)+maj(r,i,n)|0;d=u;u=h;h=o;o=a+p|0;a=n;n=i;i=r;r=p+v|0}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0;this._f=h+this._f|0;this._g=u+this._g|0;this._h=d+this._h|0};Sha256.prototype._hash=function(){var e=a.allocUnsafe(32);e.writeInt32BE(this._a,0);e.writeInt32BE(this._b,4);e.writeInt32BE(this._c,8);e.writeInt32BE(this._d,12);e.writeInt32BE(this._e,16);e.writeInt32BE(this._f,20);e.writeInt32BE(this._g,24);e.writeInt32BE(this._h,28);return e};e.exports=Sha256},7455:function(e,t,r){var i=r(3782);var n=r(9934);var a=r(2858);var s=r(5055).Buffer;var o=new Array(160);function Sha384(){this.init();this._w=o;a.call(this,128,112)}i(Sha384,n);Sha384.prototype.init=function(){this._ah=3418070365;this._bh=1654270250;this._ch=2438529370;this._dh=355462360;this._eh=1731405415;this._fh=2394180231;this._gh=3675008525;this._hh=1203062813;this._al=3238371032;this._bl=914150663;this._cl=812702999;this._dl=4144912697;this._el=4290775857;this._fl=1750603025;this._gl=1694076839;this._hl=3204075428;return this};Sha384.prototype._hash=function(){var e=s.allocUnsafe(48);function writeInt64BE(t,r,i){e.writeInt32BE(t,i);e.writeInt32BE(r,i+4)}writeInt64BE(this._ah,this._al,0);writeInt64BE(this._bh,this._bl,8);writeInt64BE(this._ch,this._cl,16);writeInt64BE(this._dh,this._dl,24);writeInt64BE(this._eh,this._el,32);writeInt64BE(this._fh,this._fl,40);return e};e.exports=Sha384},9934:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];var o=new Array(160);function Sha512(){this.init();this._w=o;n.call(this,128,112)}i(Sha512,n);Sha512.prototype.init=function(){this._ah=1779033703;this._bh=3144134277;this._ch=1013904242;this._dh=2773480762;this._eh=1359893119;this._fh=2600822924;this._gh=528734635;this._hh=1541459225;this._al=4089235720;this._bl=2227873595;this._cl=4271175723;this._dl=1595750129;this._el=2917565137;this._fl=725511199;this._gl=4215389547;this._hl=327033209;return this};function Ch(e,t,r){return r^e&(t^r)}function maj(e,t,r){return e&t|r&(e|t)}function sigma0(e,t){return(e>>>28|t<<4)^(t>>>2|e<<30)^(t>>>7|e<<25)}function sigma1(e,t){return(e>>>14|t<<18)^(e>>>18|t<<14)^(t>>>9|e<<23)}function Gamma0(e,t){return(e>>>1|t<<31)^(e>>>8|t<<24)^e>>>7}function Gamma0l(e,t){return(e>>>1|t<<31)^(e>>>8|t<<24)^(e>>>7|t<<25)}function Gamma1(e,t){return(e>>>19|t<<13)^(t>>>29|e<<3)^e>>>6}function Gamma1l(e,t){return(e>>>19|t<<13)^(t>>>29|e<<3)^(e>>>6|t<<26)}function getCarry(e,t){return e>>>0<t>>>0?1:0}Sha512.prototype._update=function(e){var t=this._w;var r=this._ah|0;var i=this._bh|0;var n=this._ch|0;var a=this._dh|0;var o=this._eh|0;var h=this._fh|0;var u=this._gh|0;var d=this._hh|0;var c=this._al|0;var l=this._bl|0;var p=this._cl|0;var v=this._dl|0;var b=this._el|0;var m=this._fl|0;var y=this._gl|0;var g=this._hl|0;for(var _=0;_<32;_+=2){t[_]=e.readInt32BE(_*4);t[_+1]=e.readInt32BE(_*4+4)}for(;_<160;_+=2){var w=t[_-15*2];var M=t[_-15*2+1];var B=Gamma0(w,M);var E=Gamma0l(M,w);w=t[_-2*2];M=t[_-2*2+1];var k=Gamma1(w,M);var A=Gamma1l(M,w);var N=t[_-7*2];var P=t[_-7*2+1];var x=t[_-16*2];var I=t[_-16*2+1];var C=E+P|0;var D=B+N+getCarry(C,E)|0;C=C+A|0;D=D+k+getCarry(C,A)|0;C=C+I|0;D=D+x+getCarry(C,I)|0;t[_]=D;t[_+1]=C}for(var T=0;T<160;T+=2){D=t[T];C=t[T+1];var j=maj(r,i,n);var q=maj(c,l,p);var O=sigma0(r,c);var H=sigma0(c,r);var L=sigma1(o,b);var z=sigma1(b,o);var F=s[T];var U=s[T+1];var W=Ch(o,h,u);var V=Ch(b,m,y);var G=g+z|0;var J=d+L+getCarry(G,g)|0;G=G+V|0;J=J+W+getCarry(G,V)|0;G=G+U|0;J=J+F+getCarry(G,U)|0;G=G+C|0;J=J+D+getCarry(G,C)|0;var Z=H+q|0;var X=O+j+getCarry(Z,H)|0;d=u;g=y;u=h;y=m;h=o;m=b;b=v+G|0;o=a+J+getCarry(b,v)|0;a=n;v=p;n=i;p=l;i=r;l=c;c=G+Z|0;r=J+X+getCarry(c,G)|0}this._al=this._al+c|0;this._bl=this._bl+l|0;this._cl=this._cl+p|0;this._dl=this._dl+v|0;this._el=this._el+b|0;this._fl=this._fl+m|0;this._gl=this._gl+y|0;this._hl=this._hl+g|0;this._ah=this._ah+r+getCarry(this._al,c)|0;this._bh=this._bh+i+getCarry(this._bl,l)|0;this._ch=this._ch+n+getCarry(this._cl,p)|0;this._dh=this._dh+a+getCarry(this._dl,v)|0;this._eh=this._eh+o+getCarry(this._el,b)|0;this._fh=this._fh+h+getCarry(this._fl,m)|0;this._gh=this._gh+u+getCarry(this._gl,y)|0;this._hh=this._hh+d+getCarry(this._hl,g)|0};Sha512.prototype._hash=function(){var e=a.allocUnsafe(64);function writeInt64BE(t,r,i){e.writeInt32BE(t,i);e.writeInt32BE(r,i+4)}writeInt64BE(this._ah,this._al,0);writeInt64BE(this._bh,this._bl,8);writeInt64BE(this._ch,this._cl,16);writeInt64BE(this._dh,this._dl,24);writeInt64BE(this._eh,this._el,32);writeInt64BE(this._fh,this._fl,40);writeInt64BE(this._gh,this._gl,48);writeInt64BE(this._hh,this._hl,56);return e};e.exports=Sha512},3704:function(e,t,r){"use strict";var i=r(5055).Buffer;var n=i.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(i.isEncoding===n||!n(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=i.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var i=t.length-1;if(i<r)return 0;var n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-1;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-2;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0){if(n===2)n=0;else e.lastNeed=n-3}return n}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var i=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,i);return e.toString("utf8",t,i)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var i=r.charCodeAt(r.length-1);if(i>=55296&&i<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},6769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},4300:function(e){"use strict";e.exports=__webpack_require__(48764)},6113:function(e){"use strict";e.exports=__webpack_require__(42474)},2361:function(e){"use strict";e.exports=__webpack_require__(25293)},2781:function(e){"use strict";e.exports=__webpack_require__(79681)},1576:function(e){"use strict";e.exports=__webpack_require__(32553)},3837:function(e){"use strict";e.exports=__webpack_require__(89539)},6144:function(e){"use strict";e.exports=__webpack_require__(51951)},5866:function(e){"use strict";e.exports=JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}')},2908:function(e){"use strict";e.exports=JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}')},9267:function(e){"use strict";e.exports=JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}')},7992:function(e){"use strict";e.exports=JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}')},2531:function(e){"use strict";e.exports={i8:"6.5.3"}},2510:function(e){"use strict";e.exports=JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}')}};var t={};function __nccwpck_require__(r){var i=t[r];if(i!==undefined){return i.exports}var n=t[r]={id:r,loaded:false,exports:{}};var a=true;try{e[r].call(n.exports,n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}n.loaded=true;return n.exports}!function(){__nccwpck_require__.nmd=function(e){e.paths=[];if(!e.children)e.children=[];return e}}();if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r={};!function(){"use strict";var e=r;e.randomBytes=e.rng=e.pseudoRandomBytes=e.prng=__nccwpck_require__(7223);e.createHash=e.Hash=__nccwpck_require__(9739);e.createHmac=e.Hmac=__nccwpck_require__(4873);var t=__nccwpck_require__(9276);var i=Object.keys(t);var n=["sha1","sha224","sha256","sha384","sha512","md5","rmd160"].concat(i);e.getHashes=function(){return n};var a=__nccwpck_require__(4978);e.pbkdf2=a.pbkdf2;e.pbkdf2Sync=a.pbkdf2Sync;var s=__nccwpck_require__(8996);e.Cipher=s.Cipher;e.createCipher=s.createCipher;e.Cipheriv=s.Cipheriv;e.createCipheriv=s.createCipheriv;e.Decipher=s.Decipher;e.createDecipher=s.createDecipher;e.Decipheriv=s.Decipheriv;e.createDecipheriv=s.createDecipheriv;e.getCiphers=s.getCiphers;e.listCiphers=s.listCiphers;var o=__nccwpck_require__(6587);e.DiffieHellmanGroup=o.DiffieHellmanGroup;e.createDiffieHellmanGroup=o.createDiffieHellmanGroup;e.getDiffieHellman=o.getDiffieHellman;e.createDiffieHellman=o.createDiffieHellman;e.DiffieHellman=o.DiffieHellman;var h=__nccwpck_require__(4078);e.createSign=h.createSign;e.Sign=h.Sign;e.createVerify=h.createVerify;e.Verify=h.Verify;e.createECDH=__nccwpck_require__(9942);var u=__nccwpck_require__(9783);e.publicEncrypt=u.publicEncrypt;e.privateEncrypt=u.privateEncrypt;e.publicDecrypt=u.publicDecrypt;e.privateDecrypt=u.privateDecrypt;var d=__nccwpck_require__(6445);e.randomFill=d.randomFill;e.randomFillSync=d.randomFillSync;e.createCredentials=function(){throw new Error(["sorry, createCredentials is not implemented yet","we accept pull requests","https://github.com/crypto-browserify/crypto-browserify"].join("\n"))};e.constants={DH_CHECK_P_NOT_SAFE_PRIME:2,DH_CHECK_P_NOT_PRIME:1,DH_UNABLE_TO_CHECK_GENERATOR:4,DH_NOT_SUITABLE_GENERATOR:8,NPN_ENABLED:1,ALPN_ENABLED:1,RSA_PKCS1_PADDING:1,RSA_SSLV23_PADDING:2,RSA_NO_PADDING:3,RSA_PKCS1_OAEP_PADDING:4,RSA_X931_PADDING:5,RSA_PKCS1_PSS_PADDING:6,POINT_CONVERSION_COMPRESSED:2,POINT_CONVERSION_UNCOMPRESSED:4,POINT_CONVERSION_HYBRID:6}}();module.exports=r})();

/***/ }),

/***/ 25293:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={864:function(e){var t=typeof Reflect==="object"?Reflect:null;var n=t&&typeof t.apply==="function"?t.apply:function ReflectApply(e,t,n){return Function.prototype.apply.call(e,t,n)};var r;if(t&&typeof t.ownKeys==="function"){r=t.ownKeys}else if(Object.getOwnPropertySymbols){r=function ReflectOwnKeys(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}}else{r=function ReflectOwnKeys(e){return Object.getOwnPropertyNames(e)}}function ProcessEmitWarning(e){if(console&&console.warn)console.warn(e)}var i=Number.isNaN||function NumberIsNaN(e){return e!==e};function EventEmitter(){EventEmitter.init.call(this)}e.exports=EventEmitter;e.exports.once=once;EventEmitter.EventEmitter=EventEmitter;EventEmitter.prototype._events=undefined;EventEmitter.prototype._eventsCount=0;EventEmitter.prototype._maxListeners=undefined;var s=10;function checkListener(e){if(typeof e!=="function"){throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof e)}}Object.defineProperty(EventEmitter,"defaultMaxListeners",{enumerable:true,get:function(){return s},set:function(e){if(typeof e!=="number"||e<0||i(e)){throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+e+".")}s=e}});EventEmitter.init=function(){if(this._events===undefined||this._events===Object.getPrototypeOf(this)._events){this._events=Object.create(null);this._eventsCount=0}this._maxListeners=this._maxListeners||undefined};EventEmitter.prototype.setMaxListeners=function setMaxListeners(e){if(typeof e!=="number"||e<0||i(e)){throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+e+".")}this._maxListeners=e;return this};function _getMaxListeners(e){if(e._maxListeners===undefined)return EventEmitter.defaultMaxListeners;return e._maxListeners}EventEmitter.prototype.getMaxListeners=function getMaxListeners(){return _getMaxListeners(this)};EventEmitter.prototype.emit=function emit(e){var t=[];for(var r=1;r<arguments.length;r++)t.push(arguments[r]);var i=e==="error";var s=this._events;if(s!==undefined)i=i&&s.error===undefined;else if(!i)return false;if(i){var o;if(t.length>0)o=t[0];if(o instanceof Error){throw o}var f=new Error("Unhandled error."+(o?" ("+o.message+")":""));f.context=o;throw f}var u=s[e];if(u===undefined)return false;if(typeof u==="function"){n(u,this,t)}else{var a=u.length;var c=arrayClone(u,a);for(var r=0;r<a;++r)n(c[r],this,t)}return true};function _addListener(e,t,n,r){var i;var s;var o;checkListener(n);s=e._events;if(s===undefined){s=e._events=Object.create(null);e._eventsCount=0}else{if(s.newListener!==undefined){e.emit("newListener",t,n.listener?n.listener:n);s=e._events}o=s[t]}if(o===undefined){o=s[t]=n;++e._eventsCount}else{if(typeof o==="function"){o=s[t]=r?[n,o]:[o,n]}else if(r){o.unshift(n)}else{o.push(n)}i=_getMaxListeners(e);if(i>0&&o.length>i&&!o.warned){o.warned=true;var f=new Error("Possible EventEmitter memory leak detected. "+o.length+" "+String(t)+" listeners "+"added. Use emitter.setMaxListeners() to "+"increase limit");f.name="MaxListenersExceededWarning";f.emitter=e;f.type=t;f.count=o.length;ProcessEmitWarning(f)}}return e}EventEmitter.prototype.addListener=function addListener(e,t){return _addListener(this,e,t,false)};EventEmitter.prototype.on=EventEmitter.prototype.addListener;EventEmitter.prototype.prependListener=function prependListener(e,t){return _addListener(this,e,t,true)};function onceWrapper(){if(!this.fired){this.target.removeListener(this.type,this.wrapFn);this.fired=true;if(arguments.length===0)return this.listener.call(this.target);return this.listener.apply(this.target,arguments)}}function _onceWrap(e,t,n){var r={fired:false,wrapFn:undefined,target:e,type:t,listener:n};var i=onceWrapper.bind(r);i.listener=n;r.wrapFn=i;return i}EventEmitter.prototype.once=function once(e,t){checkListener(t);this.on(e,_onceWrap(this,e,t));return this};EventEmitter.prototype.prependOnceListener=function prependOnceListener(e,t){checkListener(t);this.prependListener(e,_onceWrap(this,e,t));return this};EventEmitter.prototype.removeListener=function removeListener(e,t){var n,r,i,s,o;checkListener(t);r=this._events;if(r===undefined)return this;n=r[e];if(n===undefined)return this;if(n===t||n.listener===t){if(--this._eventsCount===0)this._events=Object.create(null);else{delete r[e];if(r.removeListener)this.emit("removeListener",e,n.listener||t)}}else if(typeof n!=="function"){i=-1;for(s=n.length-1;s>=0;s--){if(n[s]===t||n[s].listener===t){o=n[s].listener;i=s;break}}if(i<0)return this;if(i===0)n.shift();else{spliceOne(n,i)}if(n.length===1)r[e]=n[0];if(r.removeListener!==undefined)this.emit("removeListener",e,o||t)}return this};EventEmitter.prototype.off=EventEmitter.prototype.removeListener;EventEmitter.prototype.removeAllListeners=function removeAllListeners(e){var t,n,r;n=this._events;if(n===undefined)return this;if(n.removeListener===undefined){if(arguments.length===0){this._events=Object.create(null);this._eventsCount=0}else if(n[e]!==undefined){if(--this._eventsCount===0)this._events=Object.create(null);else delete n[e]}return this}if(arguments.length===0){var i=Object.keys(n);var s;for(r=0;r<i.length;++r){s=i[r];if(s==="removeListener")continue;this.removeAllListeners(s)}this.removeAllListeners("removeListener");this._events=Object.create(null);this._eventsCount=0;return this}t=n[e];if(typeof t==="function"){this.removeListener(e,t)}else if(t!==undefined){for(r=t.length-1;r>=0;r--){this.removeListener(e,t[r])}}return this};function _listeners(e,t,n){var r=e._events;if(r===undefined)return[];var i=r[t];if(i===undefined)return[];if(typeof i==="function")return n?[i.listener||i]:[i];return n?unwrapListeners(i):arrayClone(i,i.length)}EventEmitter.prototype.listeners=function listeners(e){return _listeners(this,e,true)};EventEmitter.prototype.rawListeners=function rawListeners(e){return _listeners(this,e,false)};EventEmitter.listenerCount=function(e,t){if(typeof e.listenerCount==="function"){return e.listenerCount(t)}else{return listenerCount.call(e,t)}};EventEmitter.prototype.listenerCount=listenerCount;function listenerCount(e){var t=this._events;if(t!==undefined){var n=t[e];if(typeof n==="function"){return 1}else if(n!==undefined){return n.length}}return 0}EventEmitter.prototype.eventNames=function eventNames(){return this._eventsCount>0?r(this._events):[]};function arrayClone(e,t){var n=new Array(t);for(var r=0;r<t;++r)n[r]=e[r];return n}function spliceOne(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop()}function unwrapListeners(e){var t=new Array(e.length);for(var n=0;n<t.length;++n){t[n]=e[n].listener||e[n]}return t}function once(e,t){return new Promise((function(n,r){function errorListener(n){e.removeListener(t,resolver);r(n)}function resolver(){if(typeof e.removeListener==="function"){e.removeListener("error",errorListener)}n([].slice.call(arguments))}eventTargetAgnosticAddListener(e,t,resolver,{once:true});if(t!=="error"){addErrorHandlerIfEventEmitter(e,errorListener,{once:true})}}))}function addErrorHandlerIfEventEmitter(e,t,n){if(typeof e.on==="function"){eventTargetAgnosticAddListener(e,"error",t,n)}}function eventTargetAgnosticAddListener(e,t,n,r){if(typeof e.on==="function"){if(r.once){e.once(t,n)}else{e.on(t,n)}}else if(typeof e.addEventListener==="function"){e.addEventListener(t,(function wrapListener(i){if(r.once){e.removeEventListener(t,wrapListener)}n(i)}))}else{throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type '+typeof e)}}}};var t={};function __nccwpck_require__(n){var r=t[n];if(r!==undefined){return r.exports}var i=t[n]={exports:{}};var s=true;try{e[n](i,i.exports,__nccwpck_require__);s=false}finally{if(s)delete t[n]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n=__nccwpck_require__(864);module.exports=n})();

/***/ }),

/***/ 15873:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RedButton":"RedButton_RedButton__l_R2k"};

/***/ }),

/***/ 76214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toggleController":"Toggle_toggleController__FBjaC","toggleContainer":"Toggle_toggleContainer__ErWT4","symbol":"Toggle_symbol__8Dnae","symbolblack":"Toggle_symbolblack__vk7pe","symbolAda":"Toggle_symbolAda__9u4ua","symbolAdablack":"Toggle_symbolAdablack__6KREs","toggle":"Toggle_toggle__xABDS","point":"Toggle_point___lV6g","active":"Toggle_active__eRQ0k","disabled":"Toggle_disabled__rehOB","transparent":"Toggle_transparent__F6n1j"};

/***/ }),

/***/ 53488:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoaderButton_loader__qmma2","l23":"LoaderButton_l23__dRgVU"};

/***/ }),

/***/ 57199:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sronly":"Drawer_sronly__sKELa","drawerContentWrapper":"Drawer_drawerContentWrapper__Wngzo"};

/***/ }),

/***/ 823:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ModalTemplate_overlay__8a2di","modal":"ModalTemplate_modal__DsKaH","modalContent":"ModalTemplate_modalContent__zNyTj","drawerContent":"ModalTemplate_drawerContent__8AhZz","closeButton":"ModalTemplate_closeButton__tRJot"};

/***/ }),

/***/ 55744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalTask_container__M2_C4","layout":"ModalTask_layout__hfCS4","title":"ModalTask_title__URI11","textarea":"ModalTask_textarea__0bR6b","txHashContainer":"ModalTask_txHashContainer__AkrkT","copied":"ModalTask_copied__pfAlK","copiedError":"ModalTask_copiedError__A1xIm","copiedText":"ModalTask_copiedText__gjH_F","transDiv":"ModalTask_transDiv__S4xZt","transText":"ModalTask_transText__nAFoo","status":"ModalTask_status__DG5p6","confirmed":"ModalTask_confirmed__U0D9E","error":"ModalTask_error__625xL","waiting":"ModalTask_waiting__INsB6","closeButton":"ModalTask_closeButton__C1InC"};

/***/ }),

/***/ 33562:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalTransaction_container__JB4fe","layout":"ModalTransaction_layout__fm5ui","title":"ModalTransaction_title___V_e_","textarea":"ModalTransaction_textarea__2QtPG","txHashContainer":"ModalTransaction_txHashContainer__059zC","copied":"ModalTransaction_copied__GzYyn","copiedError":"ModalTransaction_copiedError__Hozi_","copiedText":"ModalTransaction_copiedText__uABvE","transDiv":"ModalTransaction_transDiv__KtDzf","transText":"ModalTransaction_transText__mw79d","status":"ModalTransaction_status__NzYag","confirmed":"ModalTransaction_confirmed__aDwic","error":"ModalTransaction_error__hGS5O","waiting":"ModalTransaction_waiting___m0Cv","closeButton":"ModalTransaction_closeButton___dF5W"};

/***/ }),

/***/ 21955:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"WalletInformationModal_container__8D1OJ","layout":"WalletInformationModal_layout__shpFb","title":"WalletInformationModal_title__Nzq7Y","header":"WalletInformationModal_header__nDQeZ","headerIcon":"WalletInformationModal_headerIcon___TFyP","toogleIcon":"WalletInformationModal_toogleIcon__eJuXg","inputInformatiopn":"WalletInformationModal_inputInformatiopn__zqWD_","addressContainer":"WalletInformationModal_addressContainer__8F100","iconInput":"WalletInformationModal_iconInput__kCfkw","dataContainer":"WalletInformationModal_dataContainer__TTaHC","wallet_address":"WalletInformationModal_wallet_address__AlCmX","buttonDisconectContainer":"WalletInformationModal_buttonDisconectContainer__F_jWC"};

/***/ }),

/***/ 43544:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"WalletSelectorModal_container__6F_j5","layout":"WalletSelectorModal_layout__3DMB4","title":"WalletSelectorModal_title__dIlgS","toogleIcon":"WalletSelectorModal_toogleIcon__BI7y6","bodyModal":"WalletSelectorModal_bodyModal__6Wm9T","walletList":"WalletSelectorModal_walletList__C_PKX","walletItem":"WalletSelectorModal_walletItem__ApGUP","unAvailable":"WalletSelectorModal_unAvailable__6SnLe","walletIcon":"WalletSelectorModal_walletIcon__5umN3","walletLine":"WalletSelectorModal_walletLine__h_inV","walletName":"WalletSelectorModal_walletName__7Rilt"};

/***/ }),

/***/ 58187:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 93998:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 99067:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 79681:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(83454);
(function(){var e={782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},646:function(e){"use strict";const t={};function createErrorType(e,r,n){if(!n){n=Error}function getMessage(e,t,n){if(typeof r==="string"){return r}else{return r(e,t,n)}}class NodeError extends n{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=n.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let n;if(typeof t==="string"&&startsWith(t,"not ")){n="must not be";t=t.replace(/^not /,"")}else{n="must be"}let i;if(endsWith(e," argument")){i=`The ${e} ${n} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";i=`The "${e}" ${r} ${n} ${oneOf(t,"type")}`}i+=`. Received type ${typeof r}`;return i}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},403:function(e,t,r){"use strict";var n=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var i=r(709);var a=r(337);r(782)(Duplex,i);{var o=n(a.prototype);for(var s=0;s<o.length;s++){var f=o[s];if(!Duplex.prototype[f])Duplex.prototype[f]=a.prototype[f]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);i.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},889:function(e,t,r){"use strict";e.exports=PassThrough;var n=r(170);r(782)(PassThrough,n);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);n.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},709:function(e,t,r){"use strict";e.exports=Readable;var n;Readable.ReadableState=ReadableState;var i=r(361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var o=r(678);var s=r(300).Buffer;var f=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof f}var l=r(837);var u;if(l&&l.debuglog){u=l.debuglog("stream")}else{u=function debug(){}}var d=r(379);var c=r(25);var h=r(776),p=h.getHighWaterMark;var b=r(646).q,g=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,_=b.ERR_METHOD_NOT_IMPLEMENTED,v=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var m;var S;r(782)(Readable,o);var R=c.errorOrDestroy;var E=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=p(this,e,"readableHighWaterMark",i);this.buffer=new d;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(704).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){n=n||r(403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof n;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}o.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=c.destroy;Readable.prototype._undestroy=c.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var n;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=s.from(e,t);t=""}n=true}}else{n=true}return readableAddChunk(this,e,t,false,n)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,n,i){u("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var o;if(!i)o=chunkInvalid(a,t);if(o){R(e,o)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==s.prototype){t=_uint8ArrayToBuffer(t)}if(n){if(a.endEmitted)R(e,new v);else addChunk(e,a,t,true)}else if(a.ended){R(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!n){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,n){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(n)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new g("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(704).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var n=this._readableState.buffer.head;var i="";while(n!==null){i+=t.write(n.data);n=n.next}this._readableState.buffer.clear();if(i!=="")this._readableState.buffer.push(i);this._readableState.length=i.length;return this};var T=1073741824;function computeNewHighWaterMark(e){if(e>=T){e=T}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){u("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){u("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var n=t.needReadable;u("need readable",n);if(t.length===0||t.length-e<t.highWaterMark){n=true;u("length less than watermark",n)}if(t.ended||t.reading){n=false;u("reading or ended",n)}else if(n){u("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var i;if(e>0)i=fromList(e,t);else i=null;if(i===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(i!==null)this.emit("data",i);return i};function onEofChunk(e,t){u("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;u("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){u("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;u("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;u("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){R(this,new _("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var n=this._readableState;switch(n.pipesCount){case 0:n.pipes=e;break;case 1:n.pipes=[n.pipes,e];break;default:n.pipes.push(e);break}n.pipesCount+=1;u("pipe count=%d opts=%j",n.pipesCount,t);var i=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var o=i?onend:unpipe;if(n.endEmitted)process.nextTick(o);else r.once("end",o);e.on("unpipe",onunpipe);function onunpipe(e,t){u("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){u("onend");e.end()}var s=pipeOnDrain(r);e.on("drain",s);var f=false;function cleanup(){u("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",s);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);f=true;if(n.awaitDrain&&(!e._writableState||e._writableState.needDrain))s()}r.on("data",ondata);function ondata(t){u("ondata");var i=e.write(t);u("dest.write",i);if(i===false){if((n.pipesCount===1&&n.pipes===e||n.pipesCount>1&&indexOf(n.pipes,e)!==-1)&&!f){u("false write response, pause",n.awaitDrain);n.awaitDrain++}r.pause()}}function onerror(t){u("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)R(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){u("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){u("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!n.flowing){u("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;u("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var n=t.pipes;var i=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<i;a++){n[a].emit("unpipe",this,{hasUnpiped:false})}return this}var o=indexOf(t.pipes,e);if(o===-1)return this;t.pipes.splice(o,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);var n=this._readableState;if(e==="data"){n.readableListening=this.listenerCount("readable")>0;if(n.flowing!==false)this.resume()}else if(e==="readable"){if(!n.endEmitted&&!n.readableListening){n.readableListening=n.needReadable=true;n.flowing=false;n.emittedReadable=false;u("on readable",n.length,n.reading);if(n.length){emitReadable(this)}else if(!n.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=o.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=o.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){u("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){u("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){u("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){u("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){u("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;u("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var n=false;e.on("end",(function(){u("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(i){u("wrapped data");if(r.decoder)i=r.decoder.write(i);if(r.objectMode&&(i===null||i===undefined))return;else if(!r.objectMode&&(!i||!i.length))return;var a=t.push(i);if(!a){n=true;e.pause()}}));for(var i in e){if(this[i]===undefined&&typeof e[i]==="function"){this[i]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(i)}}for(var a=0;a<E.length;a++){e.on(E[a],this.emit.bind(this,E[a]))}this._read=function(t){u("wrapped _read",t);if(n){n=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(m===undefined){m=r(871)}return m(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;u("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){u("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(S===undefined){S=r(727)}return S(Readable,e,t)}}function indexOf(e,t){for(var r=0,n=e.length;r<n;r++){if(e[r]===t)return r}return-1}},170:function(e,t,r){"use strict";e.exports=Transform;var n=r(646).q,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0;var f=r(403);r(782)(Transform,f);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var n=r.writecb;if(n===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);n(e);var i=this._readableState;i.reading=false;if(i.needReadable||i.length<i.highWaterMark){this._read(i.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);f.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return f.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new i("_transform()"))};Transform.prototype._write=function(e,t,r){var n=this._transformState;n.writecb=r;n.writechunk=e;n.writeencoding=t;if(!n.transforming){var i=this._readableState;if(n.needTransform||i.needReadable||i.length<i.highWaterMark)this._read(i.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){f.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new s;if(e._transformState.transforming)throw new o;return e.push(null)}},337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var n;Writable.WritableState=WritableState;var i={deprecate:r(769)};var a=r(678);var o=r(300).Buffer;var s=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof s}var f=r(25);var l=r(776),u=l.getHighWaterMark;var d=r(646).q,c=d.ERR_INVALID_ARG_TYPE,h=d.ERR_METHOD_NOT_IMPLEMENTED,p=d.ERR_MULTIPLE_CALLBACK,b=d.ERR_STREAM_CANNOT_PIPE,g=d.ERR_STREAM_DESTROYED,y=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,v=d.ERR_UNKNOWN_ENCODING;var w=f.errorOrDestroy;r(782)(Writable,a);function nop(){}function WritableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=u(this,e,"writableHighWaterMark",i);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:i.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var m;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){m=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(m.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{m=function realHasInstance(e){return e instanceof this}}function Writable(e){n=n||r(403);var t=this instanceof n;if(!t&&!m.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new _;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,n){var i;if(r===null){i=new y}else if(typeof r!=="string"&&!t.objectMode){i=new c("chunk",["string","Buffer"],r)}if(i){w(e,i);process.nextTick(n,i);return false}return true}Writable.prototype.write=function(e,t,r){var n=this._writableState;var i=false;var a=!n.objectMode&&_isUint8Array(e);if(a&&!o.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=n.defaultEncoding;if(typeof r!=="function")r=nop;if(n.ending)writeAfterEnd(this,r);else if(a||validChunk(this,n,e,r)){n.pendingcb++;i=writeOrBuffer(this,n,a,e,t,r)}return i};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new v(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=o.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,n,i,a){if(!r){var o=decodeChunk(t,n,i);if(n!==o){r=true;i="buffer";n=o}}var s=t.objectMode?1:n.length;t.length+=s;var f=t.length<t.highWaterMark;if(!f)t.needDrain=true;if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null};if(l){l.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,s,n,i,a)}return f}function doWrite(e,t,r,n,i,a,o){t.writelen=n;t.writecb=o;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new g("write"));else if(r)e._writev(i,t.onwrite);else e._write(i,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,n,i){--t.pendingcb;if(r){process.nextTick(i,n);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,n)}else{i(n);e._writableState.errorEmitted=true;w(e,n);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var n=r.sync;var i=r.writecb;if(typeof i!=="function")throw new p;onwriteStateUpdate(r);if(t)onwriteError(e,r,n,t,i);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(n){process.nextTick(afterWrite,e,r,a,i)}else{afterWrite(e,r,a,i)}}}function afterWrite(e,t,r,n){if(!r)onwriteDrain(e,t);t.pendingcb--;n();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var n=t.bufferedRequestCount;var i=new Array(n);var a=t.corkedRequestsFree;a.entry=r;var o=0;var s=true;while(r){i[o]=r;if(!r.isBuf)s=false;r=r.next;o+=1}i.allBuffers=s;doWrite(e,t,true,t.length,i,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var f=r.chunk;var l=r.encoding;var u=r.callback;var d=t.objectMode?1:f.length;doWrite(e,t,false,d,f,l,u);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new h("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var n=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(n.corked){n.corked=1;this.uncork()}if(!n.ending)endWritable(this,n,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var n=e._readableState;if(!n||n.autoDestroy&&n.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var n=e.entry;e.entry=null;while(n){var i=n.callback;t.pendingcb--;i(r);n=n.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=f.destroy;Writable.prototype._undestroy=f.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},871:function(e,t,r){"use strict";var n;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(698);var a=Symbol("lastResolve");var o=Symbol("lastReject");var s=Symbol("error");var f=Symbol("ended");var l=Symbol("lastPromise");var u=Symbol("handlePromise");var d=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[d].read();if(r!==null){e[l]=null;e[a]=null;e[o]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,n){e.then((function(){if(t[f]){r(createIterResult(undefined,true));return}t[u](r,n)}),n)}}var c=Object.getPrototypeOf((function(){}));var h=Object.setPrototypeOf((n={get stream(){return this[d]},next:function next(){var e=this;var t=this[s];if(t!==null){return Promise.reject(t)}if(this[f]){return Promise.resolve(createIterResult(undefined,true))}if(this[d].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[s]){r(e[s])}else{t(createIterResult(undefined,true))}}))}))}var r=this[l];var n;if(r){n=new Promise(wrapForNext(r,this))}else{var i=this[d].read();if(i!==null){return Promise.resolve(createIterResult(i,false))}n=new Promise(this[u])}this[l]=n;return n}},_defineProperty(n,Symbol.asyncIterator,(function(){return this})),_defineProperty(n,"return",(function _return(){var e=this;return new Promise((function(t,r){e[d].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),n),c);var p=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(h,(t={},_defineProperty(t,d,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,f,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,u,{value:function value(e,t){var n=r[d].read();if(n){r[l]=null;r[a]=null;r[o]=null;e(createIterResult(n,false))}else{r[a]=e;r[o]=t}},writable:true}),t));r[l]=null;i(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[o];if(t!==null){r[l]=null;r[a]=null;r[o]=null;t(e)}r[s]=e;return}var n=r[a];if(n!==null){r[l]=null;r[a]=null;r[o]=null;n(createIterResult(undefined,true))}r[f]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=p},379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var n=r(300),i=n.Buffer;var a=r(837),o=a.inspect;var s=o&&o.custom||"inspect";function copyBuffer(e,t,r){i.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return i.alloc(0);var t=i.allocUnsafe(e>>>0);var r=this.head;var n=0;while(r){copyBuffer(r.data,t,n);n+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var n=t.data;e-=n.length;while(t=t.next){var i=t.data;var a=e>i.length?i.length:e;if(a===i.length)n+=i;else n+=i.slice(0,e);e-=a;if(e===0){if(a===i.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=i.slice(a)}break}++r}this.length-=r;return n}},{key:"_getBuffer",value:function _getBuffer(e){var t=i.allocUnsafe(e);var r=this.head;var n=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var o=e>a.length?a.length:e;a.copy(t,t.length-e,0,o);e-=o;if(e===0){if(o===a.length){++n;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(o)}break}++n}this.length-=n;return t}},{key:s,value:function value(e,t){return o(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},25:function(e){"use strict";function destroy(e,t){var r=this;var n=this._readableState&&this._readableState.destroyed;var i=this._writableState&&this._writableState.destroyed;if(n||i){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var n=e._writableState;if(r&&r.autoDestroy||n&&n.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},698:function(e,t,r){"use strict";var n=r(646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++){n[i]=arguments[i]}e.apply(this,n)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var i=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var o=function onlegacyfinish(){if(!e.writable)f()};var s=e._writableState&&e._writableState.finished;var f=function onfinish(){a=false;s=true;if(!i)r.call(e)};var l=e._readableState&&e._readableState.endEmitted;var u=function onend(){i=false;l=true;if(!a)r.call(e)};var d=function onerror(t){r.call(e,t)};var c=function onclose(){var t;if(i&&!l){if(!e._readableState||!e._readableState.ended)t=new n;return r.call(e,t)}if(a&&!s){if(!e._writableState||!e._writableState.ended)t=new n;return r.call(e,t)}};var h=function onrequest(){e.req.on("finish",f)};if(isRequest(e)){e.on("complete",f);e.on("abort",c);if(e.req)h();else e.on("request",h)}else if(a&&!e._writableState){e.on("end",o);e.on("close",o)}e.on("end",u);e.on("finish",f);if(t.error!==false)e.on("error",d);e.on("close",c);return function(){e.removeListener("complete",f);e.removeListener("abort",c);e.removeListener("request",h);if(e.req)e.req.removeListener("finish",f);e.removeListener("end",o);e.removeListener("close",o);e.removeListener("finish",f);e.removeListener("end",u);e.removeListener("error",d);e.removeListener("close",c)}}e.exports=eos},727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,n,i,a,o){try{var s=e[a](o);var f=s.value}catch(e){r(e);return}if(s.done){t(f)}else{Promise.resolve(f).then(n,i)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(n,i){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,n,i,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,n,i,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var i;if(t&&typeof t.next==="function"){i=t}else if(t&&t[Symbol.asyncIterator])i=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])i=t[Symbol.iterator]();else throw new n("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var o=false;a._read=function(){if(!o){o=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield i.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{o=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},442:function(e,t,r){"use strict";var n;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var i=r(646).q,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,i,a){a=once(a);var s=false;e.on("close",(function(){s=true}));if(n===undefined)n=r(698);n(e,{readable:t,writable:i},(function(e){if(e)return a(e);s=true;a()}));var f=false;return function(t){if(s)return;if(f)return;f=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new o("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var n=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var i;var o=t.map((function(e,r){var a=r<t.length-1;var s=r>0;return destroyer(e,a,s,(function(e){if(!i)i=e;if(e)o.forEach(call);if(a)return;o.forEach(call);n(i)}))}));return t.reduce(pipe)}e.exports=pipeline},776:function(e,t,r){"use strict";var n=r(646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,i){var a=highWaterMarkFrom(t,i,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var o=i?r:"highWaterMark";throw new n(o,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},678:function(e,t,r){e.exports=r(781)},55:function(e,t,r){var n=r(300);var i=n.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow){e.exports=n}else{copyProps(n,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return i(e,t,r)}SafeBuffer.prototype=Object.create(i.prototype);copyProps(i,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return i(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var n=i(e);if(t!==undefined){if(typeof r==="string"){n.fill(t,r)}else{n.fill(t)}}else{n.fill(0)}return n};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n.SlowBuffer(e)}},173:function(e,t,r){e.exports=Stream;var n=r(361).EventEmitter;var i=r(782);i(Stream,n);Stream.Readable=r(709);Stream.Writable=r(337);Stream.Duplex=r(403);Stream.Transform=r(170);Stream.PassThrough=r(889);Stream.finished=r(698);Stream.pipeline=r(442);Stream.Stream=Stream;function Stream(){n.call(this)}Stream.prototype.pipe=function(e,t){var r=this;function ondata(t){if(e.writable){if(false===e.write(t)&&r.pause){r.pause()}}}r.on("data",ondata);function ondrain(){if(r.readable&&r.resume){r.resume()}}e.on("drain",ondrain);if(!e._isStdio&&(!t||t.end!==false)){r.on("end",onend);r.on("close",onclose)}var i=false;function onend(){if(i)return;i=true;e.end()}function onclose(){if(i)return;i=true;if(typeof e.destroy==="function")e.destroy()}function onerror(e){cleanup();if(n.listenerCount(this,"error")===0){throw e}}r.on("error",onerror);e.on("error",onerror);function cleanup(){r.removeListener("data",ondata);e.removeListener("drain",ondrain);r.removeListener("end",onend);r.removeListener("close",onclose);r.removeListener("error",onerror);e.removeListener("error",onerror);r.removeListener("end",cleanup);r.removeListener("close",cleanup);e.removeListener("close",cleanup)}r.on("end",cleanup);r.on("close",cleanup);e.on("close",cleanup);e.emit("pipe",r);return e}},704:function(e,t,r){"use strict";var n=r(55).Buffer;var i=n.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(n.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=n.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var n=t.length-1;if(n<r)return 0;var i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-1;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-2;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0){if(i===2)i=0;else e.lastNeed=i-3}return i}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var n=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,n);return e.toString("utf8",t,n)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},300:function(e){"use strict";e.exports=__webpack_require__(48764)},361:function(e){"use strict";e.exports=__webpack_require__(25293)},781:function(e){"use strict";e.exports=(__webpack_require__(25293).EventEmitter)},837:function(e){"use strict";e.exports=__webpack_require__(89539)}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var a=true;try{e[r](i,i.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(173);module.exports=r})();

/***/ }),

/***/ 51951:
/***/ (function(module) {

var __dirname = "/";
(function(){var __webpack_modules__={950:function(__unused_webpack_module,exports){var indexOf=function(e,t){if(e.indexOf)return e.indexOf(t);else for(var r=0;r<e.length;r++){if(e[r]===t)return r}return-1};var Object_keys=function(e){if(Object.keys)return Object.keys(e);else{var t=[];for(var r in e)t.push(r);return t}};var forEach=function(e,t){if(e.forEach)return e.forEach(t);else for(var r=0;r<e.length;r++){t(e[r],r,e)}};var defineProp=function(){try{Object.defineProperty({},"_",{});return function(e,t,r){Object.defineProperty(e,t,{writable:true,enumerable:false,configurable:true,value:r})}}catch(e){return function(e,t,r){e[t]=r}}}();var globals=["Array","Boolean","Date","Error","EvalError","Function","Infinity","JSON","Math","NaN","Number","Object","RangeError","ReferenceError","RegExp","String","SyntaxError","TypeError","URIError","decodeURI","decodeURIComponent","encodeURI","encodeURIComponent","escape","eval","isFinite","isNaN","parseFloat","parseInt","undefined","unescape"];function Context(){}Context.prototype={};var Script=exports.Script=function NodeScript(e){if(!(this instanceof Script))return new Script(e);this.code=e};Script.prototype.runInContext=function(e){if(!(e instanceof Context)){throw new TypeError("needs a 'context' argument.")}var t=document.createElement("iframe");if(!t.style)t.style={};t.style.display="none";document.body.appendChild(t);var r=t.contentWindow;var n=r.eval,o=r.execScript;if(!n&&o){o.call(r,"null");n=r.eval}forEach(Object_keys(e),(function(t){r[t]=e[t]}));forEach(globals,(function(t){if(e[t]){r[t]=e[t]}}));var c=Object_keys(r);var i=n.call(r,this.code);forEach(Object_keys(r),(function(t){if(t in e||indexOf(c,t)===-1){e[t]=r[t]}}));forEach(globals,(function(t){if(!(t in e)){defineProp(e,t,r[t])}}));document.body.removeChild(t);return i};Script.prototype.runInThisContext=function(){return eval(this.code)};Script.prototype.runInNewContext=function(e){var t=Script.createContext(e);var r=this.runInContext(t);if(e){forEach(Object_keys(t),(function(r){e[r]=t[r]}))}return r};forEach(Object_keys(Script.prototype),(function(e){exports[e]=Script[e]=function(t){var r=Script(t);return r[e].apply(r,[].slice.call(arguments,1))}}));exports.isContext=function(e){return e instanceof Context};exports.createScript=function(e){return exports.Script(e)};exports.createContext=Script.createContext=function(e){var t=new Context;if(typeof e==="object"){forEach(Object_keys(e),(function(r){t[r]=e[r]}))}return t}}};if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var __webpack_exports__={};__webpack_modules__[950](0,__webpack_exports__);module.exports=__webpack_exports__})();

/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(28045)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 89908:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = [
	'Float16Array',
	'Float32Array',
	'Float64Array',
	'Int8Array',
	'Int16Array',
	'Int32Array',
	'Uint8Array',
	'Uint8ClampedArray',
	'Uint16Array',
	'Uint32Array',
	'BigInt64Array',
	'BigUint64Array'
];


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 55760:
/***/ (function(module) {

"use strict";
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */


function Cache(maxSize) {
  this._maxSize = maxSize
  this.clear()
}
Cache.prototype.clear = function () {
  this._size = 0
  this._values = Object.create(null)
}
Cache.prototype.get = function (key) {
  return this._values[key]
}
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear()
  if (!(key in this._values)) this._size++

  return (this._values[key] = value)
}

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512

var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE)

var config

module.exports = {
  Cache: Cache,

  split: split,

  normalizePath: normalizePath,

  setter: function (path) {
    var parts = normalizePath(path)

    return (
      setCache.get(path) ||
      setCache.set(path, function setter(obj, value) {
        var index = 0
        var len = parts.length
        var data = obj

        while (index < len - 1) {
          var part = parts[index]
          if (
            part === '__proto__' ||
            part === 'constructor' ||
            part === 'prototype'
          ) {
            return obj
          }

          data = data[parts[index++]]
        }
        data[parts[index]] = value
      })
    )
  },

  getter: function (path, safe) {
    var parts = normalizePath(path)
    return (
      getCache.get(path) ||
      getCache.set(path, function getter(data) {
        var index = 0,
          len = parts.length
        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]]
          else return
        }
        return data
      })
    )
  },

  join: function (segments) {
    return segments.reduce(function (path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg)
  },
}

function normalizePath(path) {
  return (
    pathCache.get(path) ||
    pathCache.set(
      path,
      split(path).map(function (part) {
        return part.replace(CLEAN_QUOTES_REGEX, '$2')
      })
    )
  )
}

function split(path) {
  return path.match(SPLIT_REGEX) || ['']
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket

  for (idx = 0; idx < len; idx++) {
    part = parts[idx]

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"'
      }

      isBracket = isQuoted(part)
      isArray = !isBracket && /^\d+$/.test(part)

      iter.call(thisArg, part, isBracket, isArray, idx, parts)
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}


/***/ }),

/***/ 46871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "polyfill": function() { return /* binding */ polyfill; }
/* harmony export */ });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 29983:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(73935);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(28747);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(57149);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(51112);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(46871);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (false) {}

exports["default"] = Modal;

/***/ }),

/***/ 28747:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(99685);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(88338);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(57149);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(32409);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(51112);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(89623);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(35063);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */
var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Remove classes.
      bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Add classes.
      bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  parentSelector: _propTypes2.default.func,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports["default"] = ModalPortal;
module.exports = exports["default"];

/***/ }),

/***/ 57149:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = __webpack_require__(42473);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(51112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (false) { var check; }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

/***/ }),

/***/ 35063:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;

var _portalOpenInstances = __webpack_require__(89623);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (false) {}
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),

/***/ 32409:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (false) { var _x, x, buffer, classes; }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),

/***/ 99685:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(37845);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (false) {}
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),

/***/ 89623:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {}
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {}
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports["default"] = portalOpenInstances;

/***/ }),

/***/ 51112:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = __webpack_require__(58875);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports["default"] = SafeHTMLElement;

/***/ }),

/***/ 88338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = scopeTab;

var _tabbable = __webpack_require__(37845);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),

/***/ 37845:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";

// match the whole word to prevent fuzzy searching
var tabbableNode = /^(input|select|textarea|button|object|iframe)$/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];

/***/ }),

/***/ 83253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _Modal = __webpack_require__(29983);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _Modal2.default;
module.exports = exports["default"];

/***/ }),

/***/ 1818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(t,n){ true?module.exports=n(__webpack_require__(67294)):0}(this,(function(t){return(()=>{"use strict";var n={359:n=>{n.exports=t}},e={};function i(t){var o=e[t];if(void 0!==o)return o.exports;var r=e[t]={exports:{}};return n[t](r,r.exports,i),r.exports}i.n=t=>{var n=t&&t.__esModule?()=>t.default:()=>t;return i.d(n,{a:n}),n},i.d=(t,n)=>{for(var e in n)i.o(n,e)&&!i.o(t,e)&&Object.defineProperty(t,e,{enumerable:!0,get:n[e]})},i.o=(t,n)=>Object.prototype.hasOwnProperty.call(t,n),i.r=t=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})};var o={};return(()=>{i.r(o),i.d(o,{ReactNotifications:()=>D,Store:()=>k});var t,n,e,r,a=i(359),c=i.n(a),s=!0,u=768,f=325,l="rnc__notification-item";!function(t){t.BOTTOM_LEFT="bottom-left",t.BOTTOM_RIGHT="bottom-right",t.BOTTOM_CENTER="bottom-center",t.TOP_LEFT="top-left",t.TOP_RIGHT="top-right",t.TOP_CENTER="top-center",t.CENTER="center",t.TOP_FULL="top-full",t.BOTTOM_FULL="bottom-full"}(t||(t={})),function(t){t.TOP="top",t.BOTTOM="bottom"}(n||(n={})),function(t){t.SUCCESS="success",t.DANGER="danger",t.INFO="info",t.DEFAULT="default",t.WARNING="warning"}(e||(e={})),function(t){t.TIMEOUT="timeout",t.CLICK="click",t.TOUCH="touch",t.MANUAL="manual"}(r||(r={}));var d=function(t){return null==t};function m(n){return n===t.BOTTOM_FULL||n===t.BOTTOM_LEFT||n===t.BOTTOM_RIGHT||n===t.BOTTOM_CENTER}function p(n){return n===t.TOP_FULL||n===t.TOP_LEFT||n===t.TOP_RIGHT||n===t.TOP_CENTER}function h(t){var n=t.type,i=t.content,o=t.userDefinedTypes,r=[l];if(i)return r;if(d(o))return function(t){switch(t){case e.DEFAULT:return[l,"rnc__notification-item--default"];case e.SUCCESS:return[l,"rnc__notification-item--success"];case e.DANGER:return[l,"rnc__notification-item--danger"];case e.WARNING:return[l,"rnc__notification-item--warning"];case e.INFO:return[l,"rnc__notification-item--info"];default:return[l]}}(n);var a=o.find((function(t){return t.name===n}));return r.concat(a.htmlClasses)}function y(t,n){var e=t.duration,i=t.timingFunction,o=t.delay;return"".concat(e,"ms ").concat(n," ").concat(i," ").concat(o,"ms")}function v(t){return t?(0|16*Math.random()).toString(16):"100000000000100000000000".replace(/1|0/g,v)}function b(t,n){var e=n.duration,i=n.timingFunction,o=n.delay,r=t||{};return d(r.duration)&&(r.duration=e),d(r.timingFunction)&&(r.timingFunction=i),d(r.delay)&&(r.delay=o),r}function E(t,n,i){var o=t,r=o.id,a=o.type,c=o.insert,s=o.content,u=o.container,f=o.animationIn,l=o.animationOut,m=o.slidingEnter,p=o.slidingExit,h=o.touchRevert,y=o.touchSlidingExit,E=o.dismiss,g=o.width,O=o.onRemoval;o.id=r||v(),o.type=s?null:a.toLowerCase(),n&&!s&&(o.userDefinedTypes=function(t,n){var i=t.content,o=t.type;if(!i&&o!==e.SUCCESS&&o!==e.DANGER&&o!==e.INFO&&o!==e.DEFAULT&&o!==e.WARNING&&n)return n}(o,n)),o.width=d(g)?i:g,o.container=u.toLowerCase(),o.insert=(c||"top").toLowerCase(),o.dismiss=function(t){var n=t,e={duration:0,click:!0,touch:!0,onScreen:!1,pauseOnHover:!1,waitForAnimation:!1,showIcon:!1};return n?(Object.keys(e).forEach((function(t){d(n[t])&&(n[t]=e[t])})),n):e}(E),o.animationIn=f||[],o.animationOut=l||[],o.onRemoval=O||function(){};var T=function(t,n,e){return{duration:t,timingFunction:n,delay:e}};o.slidingEnter=b(m,T(600,"linear",0)),o.slidingExit=b(p,T(600,"linear",0)),o.touchRevert=b(h,T(600,"linear",0));var _=y||{},S=_.swipe||{},N=_.fade||{};return o.touchSlidingExit=_,o.touchSlidingExit.swipe=b(S,T(600,"linear",0)),o.touchSlidingExit.fade=b(N,T(300,"linear",0)),o}function g(t,n){for(var e=0;e<n.length;e++){var i=n[e];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var O=function(){function t(n,e){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,t),this.callback=n,this.remaining=e,this.resume()}var n,e,i;return n=t,(e=[{key:"pause",value:function(){clearTimeout(this.timerId),this.remaining-=Date.now()-this.start}},{key:"resume",value:function(){this.start=Date.now(),clearTimeout(this.timerId),this.timerId=setTimeout(this.callback,this.remaining)}},{key:"clear",value:function(){clearTimeout(this.timerId)}}])&&g(n.prototype,e),i&&g(n,i),Object.defineProperty(n,"prototype",{writable:!1}),t}();function T(t){return T="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},T(t)}function _(t){return function(t){if(Array.isArray(t))return S(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||function(t,n){if(!t)return;if("string"==typeof t)return S(t,n);var e=Object.prototype.toString.call(t).slice(8,-1);"Object"===e&&t.constructor&&(e=t.constructor.name);if("Map"===e||"Set"===e)return Array.from(t);if("Arguments"===e||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))return S(t,n)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function S(t,n){(null==n||n>t.length)&&(n=t.length);for(var e=0,i=new Array(n);e<n;e++)i[e]=t[e];return i}function N(t,n){for(var e=0;e<n.length;e++){var i=n[e];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function w(t,n){return w=Object.setPrototypeOf||function(t,n){return t.__proto__=n,t},w(t,n)}function R(t){var n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var e,i=j(t);if(n){var o=j(this).constructor;e=Reflect.construct(i,arguments,o)}else e=i.apply(this,arguments);return C(this,e)}}function C(t,n){if(n&&("object"===T(n)||"function"==typeof n))return n;if(void 0!==n)throw new TypeError("Derived constructors may only return object or undefined");return function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t)}function j(t){return j=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},j(t)}var M=function(e){!function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),n&&w(t,n)}(u,e);var i,o,a,s=R(u);function u(t){var n;!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,u),(n=s.call(this,t)).onClick=function(){var t=n.props.notification.dismiss;(t.click||t.showIcon)&&n.removeNotification(r.CLICK)},n.onTouchStart=function(t){var e=t.touches[0].pageX;n.setState((function(t){var n=t.parentStyle;return{startX:e,currentX:e,parentStyle:Object.assign(Object.assign({},n),{position:"relative"})}}))},n.onTouchMove=function(t){var e=t.touches[0].pageX,i=n.state.startX,o=n.props,a=o.toggleRemoval,c=o.notification,s=c.id,u=c.onRemoval,f=c.slidingExit,l=c.touchSlidingExit,d=l.swipe,m=l.fade,p=e-i,h=n.rootElementRef.current.offsetWidth,v=window.innerWidth+h,b="".concat(e-i>=0?v:-v,"px");if(function(t,n){return Math.abs(t)>=.4*n}(p,h)){var E=y(d,"left"),g=y(m,"opacity"),O=function(){a(s,(function(){return u(s,r.TOUCH)}))};return n.setState((function(t){var e=t.parentStyle;return{touchEnabled:!1,parentStyle:Object.assign(Object.assign({},e),{left:b,opacity:0,transition:"".concat(E,", ").concat(g)}),onTransitionEnd:function(){n.setState((function(t){var n=t.parentStyle;return{parentStyle:Object.assign(Object.assign({},n),{height:"0px",overflow:"hidden",transition:y(f,"height")}),onTransitionEnd:O}}))}}}))}return n.setState((function(t){var n=t.parentStyle;return{currentX:e,parentStyle:Object.assign(Object.assign({},n),{left:"".concat(0+p,"px")})}}))},n.onTouchEnd=function(){var t=n.props.notification.touchRevert;n.setState((function(n){var e=n.parentStyle;return{parentStyle:Object.assign(Object.assign({},e),{left:0,transition:y(t,"left")})}}))},n.onMouseEnter=function(){n.timer?n.timer.pause():n.setState({animationPlayState:"paused"})},n.onMouseLeave=function(){n.timer?n.timer.resume():n.setState({animationPlayState:"running"})},n.rootElementRef=c().createRef();var e=t.defaultNotificationWidth,i=t.notification,o=t.isMobile,a=i.width;return n.state={parentStyle:{height:"0px",overflow:"hidden",width:"".concat(a||e,"px")},htmlClassList:h(i),animationPlayState:"running",touchEnabled:!0},o&&(n.state.parentStyle.width="100%"),n}return i=u,(o=[{key:"componentWillUnmount",value:function(){this.timer&&this.timer.clear()}},{key:"componentDidMount",value:function(){var e=this,i=this.props,o=i.notification,a=i.notificationsCount,c=o.dismiss,s=c.duration,u=c.onScreen,f=function(e,i){return!(i<=1)&&i>1&&(e.insert===n.TOP&&p(e.container)||e.insert===n.BOTTOM&&m(e.container)||e.container===t.CENTER)}(o,a),l=this.rootElementRef.current.scrollHeight,d=function(){!s||u||e.timer||(e.timer=new O((function(){return e.removeNotification(r.TIMEOUT)}),s))};this.setState((function(t){return{parentStyle:{width:t.parentStyle.width,height:"".concat(l,"px"),transition:f?y(o.slidingEnter,"height"):"10ms height"},onTransitionEnd:d}}),(function(){requestAnimationFrame((function(){e.setState((function(t){return{htmlClassList:[].concat(_(o.animationIn),_(t.htmlClassList))}}))}))}))}},{key:"componentDidUpdate",value:function(t){if(this.props.hasBeenRemoved&&!t.hasBeenRemoved&&this.removeNotification(r.MANUAL),t!==this.props&&!this.props.hasBeenRemoved){var n=this.props.notification.container,e=this.rootElementRef.current.children[0].scrollHeight;this.setState((function(t){var i=t.parentStyle;return{parentStyle:Object.assign(Object.assign({},i),{height:"".concat(e+(n.endsWith("full")?0:15),"px")})}}))}}},{key:"removeNotification",value:function(t){var n=this,e=this.props,i=e.notification,o=e.toggleRemoval,r=i.id,a=i.onRemoval,c=i.dismiss.waitForAnimation,s=[].concat(_(i.animationOut),_(h(i))),u=function(){return o(r,(function(){return a(r,t)}))},f={height:"0px",overflow:"hidden",transition:y(i.slidingExit,"height")};return c?this.setState((function(t){var e=t.parentStyle.width;return{htmlClassList:s,onAnimationEnd:function(){n.setState({parentStyle:Object.assign({width:e},f),onTransitionEnd:u})}}})):this.setState((function(t){var n=t.parentStyle.width;return{parentStyle:Object.assign({width:n},f),onTransitionEnd:u,htmlClassList:s}}))}},{key:"renderTimer",value:function(){var t=this,n=this.props.notification.dismiss,e=n.duration,i=n.onScreen,o=this.state.animationPlayState;if(e&&i){var a={animationName:"timer",animationDuration:"".concat(e,"ms"),animationTimingFunction:"linear",animationFillMode:"forwards",animationDelay:"0",animationPlayState:o};return c().createElement("div",{className:"rnc__notification-timer"},c().createElement("div",{className:"rnc__notification-timer-filler",onAnimationEnd:function(){return t.removeNotification(r.TIMEOUT)},style:a}))}}},{key:"renderCustomContent",value:function(){var t=this.state.htmlClassList,n=this.props.notification,e=n.id,i=n.content,o=n.dismiss,r=o.duration,a=o.pauseOnHover,s=r>0&&a;return c().createElement("div",{className:"".concat(_(t).join(" ")),onMouseEnter:s?this.onMouseEnter:null,onMouseLeave:s?this.onMouseLeave:null},c().isValidElement(i)?i:c().createElement(i,Object.assign({},{id:e,notificationConfig:Object.assign({},this.props.notification)})))}},{key:"renderNotification",value:function(){var t=this.props.notification,n=t.title,e=t.message,i=t.dismiss,o=i.showIcon,r=i.duration,a=i.pauseOnHover,s=this.state.htmlClassList,u=r>0&&a;return c().createElement("div",{className:"".concat(_(s).join(" ")),onMouseEnter:u?this.onMouseEnter:null,onMouseLeave:u?this.onMouseLeave:null},c().createElement("div",{className:"rnc__notification-content"},o&&c().createElement("div",{className:"rnc__notification-close-mark",onClick:this.onClick}),n&&c().createElement("div",{className:"rnc__notification-title"},n),c().createElement("div",{className:"rnc__notification-message"},e),this.renderTimer()))}},{key:"render",value:function(){var t=this.props.notification,n=t.content,e=t.dismiss.click,i=this.state,o=i.parentStyle,r=i.onAnimationEnd,a=i.onTransitionEnd,s=i.touchEnabled;return c().createElement("div",{ref:this.rootElementRef,onClick:e?this.onClick:null,style:o,className:"rnc__notification",onAnimationEnd:r,onTransitionEnd:a,onTouchStart:s?this.onTouchStart:null,onTouchMove:s?this.onTouchMove:null,onTouchEnd:s?this.onTouchEnd:null},n?this.renderCustomContent():this.renderNotification())}}])&&N(i.prototype,o),a&&N(i,a),Object.defineProperty(i,"prototype",{writable:!1}),u}(c().Component);function L(t,n){for(var e=0;e<n.length;e++){var i=n[e];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}const k=new(function(){function t(){var n=this;!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,t),this.incrementCounter=function(){return n.counter+=1},this.getCounter=function(){return n.counter},this.counter=0,this.add=null}var n,e,i;return n=t,(e=[{key:"addNotification",value:function(t){this.incrementCounter();var n=E(t,this.types,this.defaultNotificationWidth);return this.add(n)}},{key:"register",value:function(t){var n=t.addNotification,e=t.removeNotification,i=t.removeAllNotifications,o=t.types,r=t.defaultNotificationWidth;this.add=n,this.removeNotification=e,this.removeAllNotifications=i,this.defaultNotificationWidth=r,this.types=o}}])&&L(n.prototype,e),i&&L(n,i),Object.defineProperty(n,"prototype",{writable:!1}),t}());function P(t){return P="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},P(t)}function A(t){return function(t){if(Array.isArray(t))return I(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||function(t,n){if(!t)return;if("string"==typeof t)return I(t,n);var e=Object.prototype.toString.call(t).slice(8,-1);"Object"===e&&t.constructor&&(e=t.constructor.name);if("Map"===e||"Set"===e)return Array.from(t);if("Arguments"===e||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))return I(t,n)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function I(t,n){(null==n||n>t.length)&&(n=t.length);for(var e=0,i=new Array(n);e<n;e++)i[e]=t[e];return i}function x(t,n){for(var e=0;e<n.length;e++){var i=n[e];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function F(t,n){return F=Object.setPrototypeOf||function(t,n){return t.__proto__=n,t},F(t,n)}function B(t){var n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var e,i=W(t);if(n){var o=W(this).constructor;e=Reflect.construct(i,arguments,o)}else e=i.apply(this,arguments);return U(this,e)}}function U(t,n){if(n&&("object"===P(n)||"function"==typeof n))return n;if(void 0!==n)throw new TypeError("Derived constructors may only return object or undefined");return function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t)}function W(t){return W=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},W(t)}var D=function(n){!function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),n&&F(t,n)}(a,n);var e,i,o,r=B(a);function a(t){var n;return function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,a),(n=r.call(this,t)).handleResize=function(){n.setState({windowWidth:window.innerWidth})},n.add=function(t){return n.setState((function(n){var e=A(n.notifications),i=e.findIndex((function(n){return n.id===t.id}));return i>-1?(e[i]=t,{notifications:e}):{notifications:"top"===t.insert?[t].concat(A(e)):[].concat(A(e),[t])}})),t.id},n.remove=function(t){n.setState((function(n){return{notifications:n.notifications.map((function(n){return n.id===t&&(n.hasBeenRemoved=!0),n}))}}))},n.removeAllNotifications=function(){n.setState({notifications:n.state.notifications.map((function(t){return Object.assign(Object.assign({},t),{hasBeenRemoved:!0})}))})},n.toggleRemoval=function(t,e){n.setState((function(n){return{notifications:n.notifications.filter((function(n){return n.id!==t}))}}),e)},n.state={isMobile:d(t.isMobile)?s:t.isMobile,breakpoint:d(t.breakpoint)?u:t.breakpoint,notifications:[],windowWidth:void 0},n}return e=a,(i=[{key:"componentDidMount",value:function(){var t=this.props,n=t.types,e=t.defaultNotificationWidth;k.register({addNotification:this.add,removeNotification:this.remove,removeAllNotifications:this.removeAllNotifications,defaultNotificationWidth:e||f,types:n}),this.setState({windowWidth:window.innerWidth}),window.addEventListener("resize",this.handleResize)}},{key:"componentWillUnmount",value:function(){window.removeEventListener("resize",this.handleResize)}},{key:"renderNotifications",value:function(t,n){var e=this;return t.map((function(i){return c().createElement(M,{id:i.id,key:i.id,isMobile:n,defaultNotificationWidth:e.props.defaultNotificationWidth,notification:i,toggleRemoval:e.toggleRemoval,notificationsCount:t.length,hasBeenRemoved:i.hasBeenRemoved})}))}},{key:"renderMobileNotifications",value:function(n){var e=n.className,i=n.id,o=function(n){var e=[],i=[];return n.forEach((function(n){var o=n.container,r=t.CENTER;p(o)||o===r?e.push(n):m(o)&&i.push(n)})),{top:e,bottom:i}}(this.state.notifications),r=this.renderNotifications(o.top,!0),a=this.renderNotifications(o.bottom,!0);return c().createElement("div",{id:i,key:"mobile",className:"rnc__base ".concat(e||"")},c().createElement("div",{className:"rnc__notification-container--mobile-top"},r),c().createElement("div",{className:"rnc__notification-container--mobile-bottom"},a))}},{key:"renderScreenNotifications",value:function(n){var e=n.className,i=n.id,o=function(n){var e=[],i=[],o=[],r=[],a=[],c=[],s=[],u=[],f=[];return n.forEach((function(n){var l=n.container;l===t.TOP_FULL?u.push(n):l===t.BOTTOM_FULL?f.push(n):l===t.TOP_LEFT?e.push(n):l===t.TOP_RIGHT?i.push(n):l===t.TOP_CENTER?o.push(n):l===t.BOTTOM_LEFT?r.push(n):l===t.BOTTOM_RIGHT?a.push(n):l===t.BOTTOM_CENTER?c.push(n):l===t.CENTER&&s.push(n)})),{topFull:u,bottomFull:f,topLeft:e,topRight:i,topCenter:o,bottomLeft:r,bottomRight:a,bottomCenter:c,center:s}}(this.state.notifications),r=this.renderNotifications(o.topFull,!1),a=this.renderNotifications(o.bottomFull,!1),s=this.renderNotifications(o.topLeft,!1),u=this.renderNotifications(o.topRight,!1),f=this.renderNotifications(o.topCenter,!1),l=this.renderNotifications(o.bottomLeft,!1),d=this.renderNotifications(o.bottomRight,!1),m=this.renderNotifications(o.bottomCenter,!1),p=this.renderNotifications(o.center,!1);return c().createElement("div",{id:i,key:"screen",className:"rnc__base ".concat(e||"")},c().createElement("div",{className:"rnc__notification-container--top-full"},r),c().createElement("div",{className:"rnc__notification-container--bottom-full"},a),c().createElement("div",{className:"rnc__notification-container--top-left"},s),c().createElement("div",{className:"rnc__notification-container--top-right"},u),c().createElement("div",{className:"rnc__notification-container--bottom-left"},l),c().createElement("div",{className:"rnc__notification-container--bottom-right"},d),c().createElement("div",{className:"rnc__notification-container--top-center"},f),c().createElement("div",{className:"rnc__notification-container--center"},c().createElement("div",{className:"rnc__util--flex-center"},p)),c().createElement("div",{className:"rnc__notification-container--bottom-center"},m))}},{key:"render",value:function(){var t=this.props.isMobile,n=this.state,e=n.windowWidth,i=n.breakpoint;return t&&e<=i?this.renderMobileNotifications(this.props):this.renderScreenNotifications(this.props)}}])&&x(e.prototype,i),o&&x(e,o),Object.defineProperty(e,"prototype",{writable:!1}),a}(c().Component)})(),o})()}));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 28660:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Reflect;
(function (Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function (factory) {
        var root = typeof __webpack_require__.g === "object" ? __webpack_require__.g :
            typeof self === "object" ? self :
                typeof this === "object" ? this :
                    Function("return this;")();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect === "undefined") {
            root.Reflect = Reflect;
        }
        else {
            exporter = makeExporter(root.Reflect, exporter);
        }
        factory(exporter);
        function makeExporter(target, previous) {
            return function (key, value) {
                if (typeof target[key] !== "function") {
                    Object.defineProperty(target, key, { configurable: true, writable: true, value: value });
                }
                if (previous)
                    previous(key, value);
            };
        }
    })(function (exporter) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = { __proto__: [] } instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate
                ? function () { return MakeDictionary(Object.create(null)); }
                : supportsProto
                    ? function () { return MakeDictionary({ __proto__: null }); }
                    : function () { return MakeDictionary({}); },
            has: downLevel
                ? function (map, key) { return hasOwn.call(map, key); }
                : function (map, key) { return key in map; },
            get: downLevel
                ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
                : function (map, key) { return map[key]; },
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var usePolyfill = typeof process === "object" && process["env" + ""] && process["env" + ""]["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";
        var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        // [[Metadata]] internal slot
        // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
        var Metadata = new _WeakMap();
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */
        function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
                    throw new TypeError();
                if (IsNull(attributes))
                    attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            }
            else {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsConstructor(target))
                    throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */
        function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
                    throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */
        function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */
        function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */
        function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            if (!metadataMap.delete(metadataKey))
                return false;
            if (metadataMap.size > 0)
                return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0)
                return true;
            Metadata.delete(target);
            return true;
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated))
                        throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated))
                        throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);
            if (IsUndefined(targetMetadata)) {
                if (!Create)
                    return undefined;
                targetMetadata = new _Map();
                Metadata.set(O, targetMetadata);
            }
            var metadataMap = targetMetadata.get(P);
            if (IsUndefined(metadataMap)) {
                if (!Create)
                    return undefined;
                metadataMap = new _Map();
                targetMetadata.set(P, metadataMap);
            }
            return metadataMap;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            return ToBoolean(metadataMap.has(MetadataKey));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return undefined;
            return metadataMap.get(MetadataKey);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
            metadataMap.set(MetadataKey, MetadataValue);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null)
                return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0)
                return ownKeys;
            if (ownKeys.length <= 0)
                return parentKeys;
            var set = new _Set();
            var keys = [];
            for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;
            while (true) {
                var next = IteratorStep(iterator);
                if (!next) {
                    keys.length = k;
                    return keys;
                }
                var nextValue = IteratorValue(next);
                try {
                    keys[k] = nextValue;
                }
                catch (e) {
                    try {
                        IteratorClose(iterator);
                    }
                    finally {
                        throw e;
                    }
                }
                k++;
            }
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null)
                return 1 /* Null */;
            switch (typeof x) {
                case "undefined": return 0 /* Undefined */;
                case "boolean": return 2 /* Boolean */;
                case "string": return 3 /* String */;
                case "symbol": return 4 /* Symbol */;
                case "number": return 5 /* Number */;
                case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
                default: return 6 /* Object */;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch (Type(input)) {
                case 0 /* Undefined */: return input;
                case 1 /* Null */: return input;
                case 2 /* Boolean */: return input;
                case 3 /* String */: return input;
                case 4 /* Symbol */: return input;
                case 5 /* Number */: return input;
            }
            var hint = PreferredType === 3 /* String */ ? "string" : PreferredType === 5 /* Number */ ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result))
                    throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */);
            if (IsSymbol(key))
                return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray
                ? Array.isArray(argument)
                : argument instanceof Object
                    ? argument instanceof Array
                    : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch (Type(argument)) {
                case 3 /* String */: return true;
                case 4 /* Symbol */: return true;
                default: return false;
            }
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null)
                return undefined;
            if (!IsCallable(func))
                throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method))
                throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator))
                throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f)
                f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype)
                return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype)
                return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype)
                return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function")
                return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O)
                return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = /** @class */ (function () {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function () { return this; };
                MapIterator.prototype[iteratorSymbol] = function () { return this; };
                MapIterator.prototype.next = function () {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        }
                        else {
                            this._index++;
                        }
                        return { value: result, done: false };
                    }
                    return { value: undefined, done: true };
                };
                MapIterator.prototype.throw = function (error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function (value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return { value: value, done: true };
                };
                return MapIterator;
            }());
            return /** @class */ (function () {
                function Map() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map.prototype, "size", {
                    get: function () { return this._keys.length; },
                    enumerable: true,
                    configurable: true
                });
                Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
                Map.prototype.get = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map.prototype.set = function (key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map.prototype.delete = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for (var i = index + 1; i < size; i++) {
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (key === this._cacheKey) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map.prototype.clear = function () {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map.prototype.keys = function () { return new MapIterator(this._keys, this._values, getKey); };
                Map.prototype.values = function () { return new MapIterator(this._keys, this._values, getValue); };
                Map.prototype.entries = function () { return new MapIterator(this._keys, this._values, getEntry); };
                Map.prototype["@@iterator"] = function () { return this.entries(); };
                Map.prototype[iteratorSymbol] = function () { return this.entries(); };
                Map.prototype._find = function (key, insert) {
                    if (this._cacheKey !== key) {
                        this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                    }
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map;
            }());
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [key, value];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            return /** @class */ (function () {
                function Set() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set.prototype, "size", {
                    get: function () { return this._map.size; },
                    enumerable: true,
                    configurable: true
                });
                Set.prototype.has = function (value) { return this._map.has(value); };
                Set.prototype.add = function (value) { return this._map.set(value, value), this; };
                Set.prototype.delete = function (value) { return this._map.delete(value); };
                Set.prototype.clear = function () { this._map.clear(); };
                Set.prototype.keys = function () { return this._map.keys(); };
                Set.prototype.values = function () { return this._map.values(); };
                Set.prototype.entries = function () { return this._map.entries(); };
                Set.prototype["@@iterator"] = function () { return this.keys(); };
                Set.prototype[iteratorSymbol] = function () { return this.keys(); };
                return Set;
            }());
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return /** @class */ (function () {
                function WeakMap() {
                    this._key = CreateUniqueKey();
                }
                WeakMap.prototype.has = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap.prototype.get = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap.prototype.set = function (target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap.prototype.delete = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap.prototype.clear = function () {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap;
            }());
            function CreateUniqueKey() {
                var key;
                do
                    key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create)
                        return undefined;
                    Object.defineProperty(target, rootKey, { value: HashMap.create() });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for (var i = 0; i < size; ++i)
                    buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined")
                        return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined")
                        return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for (var offset = 0; offset < UUID_SIZE; ++offset) {
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8)
                        result += "-";
                    if (byte < 16)
                        result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})(Reflect || (Reflect = {}));


/***/ }),

/***/ 89509:
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(48764)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 79246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(17379);
var isRegex = __webpack_require__(98420);

var $exec = callBound('RegExp.prototype.exec');
var $TypeError = __webpack_require__(14453);

/** @type {import('.')} */
module.exports = function regexTester(regex) {
	if (!isRegex(regex)) {
		throw new $TypeError('`regex` must be a RegExp');
	}
	return function test(s) {
		return $exec(regex, s) !== null;
	};
};


/***/ }),

/***/ 67771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var define = __webpack_require__(12296);
var hasDescriptors = __webpack_require__(31044)();
var gOPD = __webpack_require__(27296);

var $TypeError = __webpack_require__(14453);
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};


/***/ }),

/***/ 32553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(89509).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 59885:
/***/ (function(module) {

const reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g

const words = (str) => str.match(reWords) || []

const upperFirst = (str) => str[0].toUpperCase() + str.slice(1)

const join = (str, d) => words(str).join(d).toLowerCase()

const camelCase = (str) =>
  words(str).reduce(
    (acc, next) =>
      `${acc}${
        !acc
          ? next.toLowerCase()
          : next[0].toUpperCase() + next.slice(1).toLowerCase()
      }`,
    '',
  )

const pascalCase = (str) => upperFirst(camelCase(str))

const snakeCase = (str) => join(str, '_')

const kebabCase = (str) => join(str, '-')

const sentenceCase = (str) => upperFirst(join(str, ' '))

const titleCase = (str) => words(str).map(upperFirst).join(' ')

module.exports = {
  words,
  upperFirst,
  camelCase,
  pascalCase,
  snakeCase,
  kebabCase,
  sentenceCase,
  titleCase,
}


/***/ }),

/***/ 94633:
/***/ (function(module) {


/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

module.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
}

module.exports.array = toposort

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes)

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  })

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set())
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep
      try {
        nodeRep = ", node was:" + JSON.stringify(node)
      } catch(e) {
        nodeRep = ""
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true

    var outgoing = outgoingEdges.get(node) || new Set()
    outgoing = Array.from(outgoing)

    if (i = outgoing.length) {
      predecessors.add(node)
      do {
        var child = outgoing[--i]
        visit(child, nodesHash.get(child), predecessors)
      } while (i)
      predecessors.delete(node)
    }

    sorted[--cursor] = node
  }
}

function uniqueNodes(arr){
  var res = new Set()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    res.add(edge[0])
    res.add(edge[1])
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    if (!edges.has(edge[0])) edges.set(edge[0], new Set())
    if (!edges.has(edge[1])) edges.set(edge[1], new Set())
    edges.get(edge[0]).add(edge[1])
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i)
  }
  return res
}


/***/ }),

/***/ 83:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useState = React.useState,
  useEffect = React.useEffect,
  useLayoutEffect = React.useLayoutEffect,
  useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
  var value = getSnapshot(),
    _useState = useState({ inst: { value: value, getSnapshot: getSnapshot } }),
    inst = _useState[0].inst,
    forceUpdate = _useState[1];
  useLayoutEffect(
    function () {
      inst.value = value;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
    },
    [subscribe, value, getSnapshot]
  );
  useEffect(
    function () {
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      return subscribe(function () {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      });
    },
    [subscribe]
  );
  useDebugValue(value);
  return value;
}
function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  inst = inst.value;
  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(inst, nextValue);
  } catch (error) {
    return !0;
  }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
  return getSnapshot();
}
var shim =
  "undefined" === typeof window ||
  "undefined" === typeof window.document ||
  "undefined" === typeof window.document.createElement
    ? useSyncExternalStore$1
    : useSyncExternalStore$2;
exports.useSyncExternalStore =
  void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;


/***/ }),

/***/ 26251:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294),
  shim = __webpack_require__(61688);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useSyncExternalStore = shim.useSyncExternalStore,
  useRef = React.useRef,
  useEffect = React.useEffect,
  useMemo = React.useMemo,
  useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function (
  subscribe,
  getSnapshot,
  getServerSnapshot,
  selector,
  isEqual
) {
  var instRef = useRef(null);
  if (null === instRef.current) {
    var inst = { hasValue: !1, value: null };
    instRef.current = inst;
  } else inst = instRef.current;
  instRef = useMemo(
    function () {
      function memoizedSelector(nextSnapshot) {
        if (!hasMemo) {
          hasMemo = !0;
          memoizedSnapshot = nextSnapshot;
          nextSnapshot = selector(nextSnapshot);
          if (void 0 !== isEqual && inst.hasValue) {
            var currentSelection = inst.value;
            if (isEqual(currentSelection, nextSnapshot))
              return (memoizedSelection = currentSelection);
          }
          return (memoizedSelection = nextSnapshot);
        }
        currentSelection = memoizedSelection;
        if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
        var nextSelection = selector(nextSnapshot);
        if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
          return (memoizedSnapshot = nextSnapshot), currentSelection;
        memoizedSnapshot = nextSnapshot;
        return (memoizedSelection = nextSelection);
      }
      var hasMemo = !1,
        memoizedSnapshot,
        memoizedSelection,
        maybeGetServerSnapshot =
          void 0 === getServerSnapshot ? null : getServerSnapshot;
      return [
        function () {
          return memoizedSelector(getSnapshot());
        },
        null === maybeGetServerSnapshot
          ? void 0
          : function () {
              return memoizedSelector(maybeGetServerSnapshot());
            }
      ];
    },
    [getSnapshot, getServerSnapshot, selector, isEqual]
  );
  var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
  useEffect(
    function () {
      inst.hasValue = !0;
      inst.value = value;
    },
    [value]
  );
  useDebugValue(value);
  return value;
};


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(83);
} else {}


/***/ }),

/***/ 52798:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(26251);
} else {}


/***/ }),

/***/ 20384:
/***/ (function(module) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 55955:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9



var isArgumentsObject = __webpack_require__(82584);
var isGeneratorFunction = __webpack_require__(48662);
var whichTypedArray = __webpack_require__(86430);
var isTypedArray = __webpack_require__(85692);

function uncurryThis(f) {
  return f.call.bind(f);
}

var BigIntSupported = typeof BigInt !== 'undefined';
var SymbolSupported = typeof Symbol !== 'undefined';

var ObjectToString = uncurryThis(Object.prototype.toString);

var numberValue = uncurryThis(Number.prototype.valueOf);
var stringValue = uncurryThis(String.prototype.valueOf);
var booleanValue = uncurryThis(Boolean.prototype.valueOf);

if (BigIntSupported) {
  var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
}

if (SymbolSupported) {
  var symbolValue = uncurryThis(Symbol.prototype.valueOf);
}

function checkBoxedPrimitive(value, prototypeValueOf) {
  if (typeof value !== 'object') {
    return false;
  }
  try {
    prototypeValueOf(value);
    return true;
  } catch(e) {
    return false;
  }
}

exports.isArgumentsObject = isArgumentsObject;
exports.isGeneratorFunction = isGeneratorFunction;
exports.isTypedArray = isTypedArray;

// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function isPromise(input) {
	return (
		(
			typeof Promise !== 'undefined' &&
			input instanceof Promise
		) ||
		(
			input !== null &&
			typeof input === 'object' &&
			typeof input.then === 'function' &&
			typeof input.catch === 'function'
		)
	);
}
exports.isPromise = isPromise;

function isArrayBufferView(value) {
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    return ArrayBuffer.isView(value);
  }

  return (
    isTypedArray(value) ||
    isDataView(value)
  );
}
exports.isArrayBufferView = isArrayBufferView;


function isUint8Array(value) {
  return whichTypedArray(value) === 'Uint8Array';
}
exports.isUint8Array = isUint8Array;

function isUint8ClampedArray(value) {
  return whichTypedArray(value) === 'Uint8ClampedArray';
}
exports.isUint8ClampedArray = isUint8ClampedArray;

function isUint16Array(value) {
  return whichTypedArray(value) === 'Uint16Array';
}
exports.isUint16Array = isUint16Array;

function isUint32Array(value) {
  return whichTypedArray(value) === 'Uint32Array';
}
exports.isUint32Array = isUint32Array;

function isInt8Array(value) {
  return whichTypedArray(value) === 'Int8Array';
}
exports.isInt8Array = isInt8Array;

function isInt16Array(value) {
  return whichTypedArray(value) === 'Int16Array';
}
exports.isInt16Array = isInt16Array;

function isInt32Array(value) {
  return whichTypedArray(value) === 'Int32Array';
}
exports.isInt32Array = isInt32Array;

function isFloat32Array(value) {
  return whichTypedArray(value) === 'Float32Array';
}
exports.isFloat32Array = isFloat32Array;

function isFloat64Array(value) {
  return whichTypedArray(value) === 'Float64Array';
}
exports.isFloat64Array = isFloat64Array;

function isBigInt64Array(value) {
  return whichTypedArray(value) === 'BigInt64Array';
}
exports.isBigInt64Array = isBigInt64Array;

function isBigUint64Array(value) {
  return whichTypedArray(value) === 'BigUint64Array';
}
exports.isBigUint64Array = isBigUint64Array;

function isMapToString(value) {
  return ObjectToString(value) === '[object Map]';
}
isMapToString.working = (
  typeof Map !== 'undefined' &&
  isMapToString(new Map())
);

function isMap(value) {
  if (typeof Map === 'undefined') {
    return false;
  }

  return isMapToString.working
    ? isMapToString(value)
    : value instanceof Map;
}
exports.isMap = isMap;

function isSetToString(value) {
  return ObjectToString(value) === '[object Set]';
}
isSetToString.working = (
  typeof Set !== 'undefined' &&
  isSetToString(new Set())
);
function isSet(value) {
  if (typeof Set === 'undefined') {
    return false;
  }

  return isSetToString.working
    ? isSetToString(value)
    : value instanceof Set;
}
exports.isSet = isSet;

function isWeakMapToString(value) {
  return ObjectToString(value) === '[object WeakMap]';
}
isWeakMapToString.working = (
  typeof WeakMap !== 'undefined' &&
  isWeakMapToString(new WeakMap())
);
function isWeakMap(value) {
  if (typeof WeakMap === 'undefined') {
    return false;
  }

  return isWeakMapToString.working
    ? isWeakMapToString(value)
    : value instanceof WeakMap;
}
exports.isWeakMap = isWeakMap;

function isWeakSetToString(value) {
  return ObjectToString(value) === '[object WeakSet]';
}
isWeakSetToString.working = (
  typeof WeakSet !== 'undefined' &&
  isWeakSetToString(new WeakSet())
);
function isWeakSet(value) {
  return isWeakSetToString(value);
}
exports.isWeakSet = isWeakSet;

function isArrayBufferToString(value) {
  return ObjectToString(value) === '[object ArrayBuffer]';
}
isArrayBufferToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  isArrayBufferToString(new ArrayBuffer())
);
function isArrayBuffer(value) {
  if (typeof ArrayBuffer === 'undefined') {
    return false;
  }

  return isArrayBufferToString.working
    ? isArrayBufferToString(value)
    : value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;

function isDataViewToString(value) {
  return ObjectToString(value) === '[object DataView]';
}
isDataViewToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  typeof DataView !== 'undefined' &&
  isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1))
);
function isDataView(value) {
  if (typeof DataView === 'undefined') {
    return false;
  }

  return isDataViewToString.working
    ? isDataViewToString(value)
    : value instanceof DataView;
}
exports.isDataView = isDataView;

// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function isSharedArrayBufferToString(value) {
  return ObjectToString(value) === '[object SharedArrayBuffer]';
}
function isSharedArrayBuffer(value) {
  if (typeof SharedArrayBufferCopy === 'undefined') {
    return false;
  }

  if (typeof isSharedArrayBufferToString.working === 'undefined') {
    isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
  }

  return isSharedArrayBufferToString.working
    ? isSharedArrayBufferToString(value)
    : value instanceof SharedArrayBufferCopy;
}
exports.isSharedArrayBuffer = isSharedArrayBuffer;

function isAsyncFunction(value) {
  return ObjectToString(value) === '[object AsyncFunction]';
}
exports.isAsyncFunction = isAsyncFunction;

function isMapIterator(value) {
  return ObjectToString(value) === '[object Map Iterator]';
}
exports.isMapIterator = isMapIterator;

function isSetIterator(value) {
  return ObjectToString(value) === '[object Set Iterator]';
}
exports.isSetIterator = isSetIterator;

function isGeneratorObject(value) {
  return ObjectToString(value) === '[object Generator]';
}
exports.isGeneratorObject = isGeneratorObject;

function isWebAssemblyCompiledModule(value) {
  return ObjectToString(value) === '[object WebAssembly.Module]';
}
exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;

function isNumberObject(value) {
  return checkBoxedPrimitive(value, numberValue);
}
exports.isNumberObject = isNumberObject;

function isStringObject(value) {
  return checkBoxedPrimitive(value, stringValue);
}
exports.isStringObject = isStringObject;

function isBooleanObject(value) {
  return checkBoxedPrimitive(value, booleanValue);
}
exports.isBooleanObject = isBooleanObject;

function isBigIntObject(value) {
  return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
}
exports.isBigIntObject = isBigIntObject;

function isSymbolObject(value) {
  return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
}
exports.isSymbolObject = isSymbolObject;

function isBoxedPrimitive(value) {
  return (
    isNumberObject(value) ||
    isStringObject(value) ||
    isBooleanObject(value) ||
    isBigIntObject(value) ||
    isSymbolObject(value)
  );
}
exports.isBoxedPrimitive = isBoxedPrimitive;

function isAnyArrayBuffer(value) {
  return typeof Uint8Array !== 'undefined' && (
    isArrayBuffer(value) ||
    isSharedArrayBuffer(value)
  );
}
exports.isAnyArrayBuffer = isAnyArrayBuffer;

['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach(function(method) {
  Object.defineProperty(exports, method, {
    enumerable: false,
    value: function() {
      throw new Error(method + ' is not supported in userland');
    }
  });
});


/***/ }),

/***/ 89539:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnvRegex = /^$/;

if (process.env.NODE_DEBUG) {
  var debugEnv = process.env.NODE_DEBUG;
  debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
    .replace(/\*/g, '.*')
    .replace(/,/g, '$|^')
    .toUpperCase();
  debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
}
exports.debuglog = function(set) {
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (debugEnvRegex.test(set)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').slice(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.slice(1, -1);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
exports.types = __webpack_require__(55955);

function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
exports.types.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;
exports.types.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;
exports.types.isNativeError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(20384);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(35717);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb.bind(null, null, ret)) },
            function(rej) { process.nextTick(callbackifyOnRejected.bind(null, rej, cb)) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;


/***/ }),

/***/ 42473:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 86430:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var forEach = __webpack_require__(94029);
var availableTypedArrays = __webpack_require__(63083);
var callBind = __webpack_require__(55559);
var callBound = __webpack_require__(17379);
var gOPD = __webpack_require__(27296);
var getProto = __webpack_require__(81618);

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(96410)();

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound('String.prototype.slice');

/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */
var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};

/** @typedef {import('./types').Getter} Getter */
/** @type {import('./types').Cache} */
var cache = { __proto__: null };
if (hasToStringTag && gOPD && getProto) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr && getProto) {
			var proto = getProto(arr);
			// @ts-expect-error TS won't narrow inside a closure
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor && proto) {
				var superProto = getProto(proto);
				// @ts-expect-error TS won't narrow inside a closure
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			// @ts-expect-error TODO: fix
			cache['$' + typedArray] = callBind(descriptor.get);
		}
	});
} else {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		var fn = arr.slice || arr.set;
		if (fn) {
			cache[
				/** @type {`$${import('.').TypedArrayName}`} */ ('$' + typedArray)
			] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ (
				// @ts-expect-error TODO FIXME
				callBind(fn)
			);
		}
	});
}

/** @type {(value: object) => false | import('.').TypedArrayName} */
var tryTypedArrays = function tryAllTypedArrays(value) {
	/** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
	forEach(
		/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ (cache),
		/** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
		function (getter, typedArray) {
			if (!found) {
				try {
					// @ts-expect-error a throw is fine here
					if ('$' + getter(value) === typedArray) {
						found = /** @type {import('.').TypedArrayName} */ ($slice(typedArray, 1));
					}
				} catch (e) { /**/ }
			}
		}
	);
	return found;
};

/** @type {(value: object) => false | import('.').TypedArrayName} */
var trySlices = function tryAllSlices(value) {
	/** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
	forEach(
		/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */(cache),
		/** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function (getter, name) {
			if (!found) {
				try {
					// @ts-expect-error a throw is fine here
					getter(value);
					found = /** @type {import('.').TypedArrayName} */ ($slice(name, 1));
				} catch (e) { /**/ }
			}
		}
	);
	return found;
};

/** @type {import('.')} */
module.exports = function whichTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag) {
		/** @type {string} */
		var tag = $slice($toString(value), 8, -1);
		if ($indexOf(typedArrays, tag) > -1) {
			return tag;
		}
		if (tag !== 'Object') {
			return false;
		}
		// node < 0.6 hits here on real Typed Arrays
		return trySlices(value);
	}
	if (!gOPD) { return null; } // unknown engine
	return tryTypedArrays(value);
};


/***/ }),

/***/ 43973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/copy.ba302d61.svg";

/***/ }),

/***/ 32253:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/eternl.6e0589ea.png";

/***/ }),

/***/ 68778:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/lace.7406ecd0.png";

/***/ }),

/***/ 76555:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/nami.8347bcf6.png";

/***/ }),

/***/ 5810:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/nufi.7cb0d8c6.png";

/***/ }),

/***/ 48931:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/typhon.a8546462.png";

/***/ }),

/***/ 33824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/vespr.53553cef.png";

/***/ }),

/***/ 9884:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "static/media/yoroi.1bd254d1.png";

/***/ }),

/***/ 73897:
/***/ (function(module) {

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 85372:
/***/ (function(module) {

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 66115:
/***/ (function(module) {

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 17156:
/***/ (function(module) {

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 56690:
/***/ (function(module) {

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 3515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isNativeReflectConstruct = __webpack_require__(69617);
var setPrototypeOf = __webpack_require__(6015);
function _construct(t, e, r) {
  if (isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && setPrototypeOf(p, r.prototype), p;
}
module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 89728:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(64062);
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 38416:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(64062);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 73808:
/***/ (function(module) {

function _getPrototypeOf(t) {
  return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 61655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(6015);
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 64836:
/***/ (function(module) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 46035:
/***/ (function(module) {

function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 69617:
/***/ (function(module) {

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 68872:
/***/ (function(module) {

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 12218:
/***/ (function(module) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 94993:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(18698)["default"]);
var assertThisInitialized = __webpack_require__(66115);
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 17061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(18698)["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return r;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    r = {},
    e = Object.prototype,
    n = e.hasOwnProperty,
    o = "function" == typeof Symbol ? Symbol : {},
    i = o.iterator || "@@iterator",
    a = o.asyncIterator || "@@asyncIterator",
    u = o.toStringTag || "@@toStringTag";
  function c(t, r, e, n) {
    return Object.defineProperty(t, r, {
      value: e,
      enumerable: !n,
      configurable: !n,
      writable: !n
    });
  }
  try {
    c({}, "");
  } catch (t) {
    c = function c(t, r, e) {
      return t[r] = e;
    };
  }
  function h(r, e, n, o) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype);
    return c(a, "_invoke", function (r, e, n) {
      var o = 1;
      return function (i, a) {
        if (3 === o) throw Error("Generator is already running");
        if (4 === o) {
          if ("throw" === i) throw a;
          return {
            value: t,
            done: !0
          };
        }
        for (n.method = i, n.arg = a;;) {
          var u = n.delegate;
          if (u) {
            var c = d(u, n);
            if (c) {
              if (c === f) continue;
              return c;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
            if (1 === o) throw o = 4, n.arg;
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          o = 3;
          var h = s(r, e, n);
          if ("normal" === h.type) {
            if (o = n.done ? 4 : 2, h.arg === f) continue;
            return {
              value: h.arg,
              done: n.done
            };
          }
          "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg);
        }
      };
    }(r, n, new Context(o || [])), !0), a;
  }
  function s(t, r, e) {
    try {
      return {
        type: "normal",
        arg: t.call(r, e)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  r.wrap = h;
  var f = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var l = {};
  c(l, i, function () {
    return this;
  });
  var p = Object.getPrototypeOf,
    y = p && p(p(x([])));
  y && y !== e && n.call(y, i) && (l = y);
  var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l);
  function g(t) {
    ["next", "throw", "return"].forEach(function (r) {
      c(t, r, function (t) {
        return this._invoke(r, t);
      });
    });
  }
  function AsyncIterator(t, r) {
    function e(o, i, a, u) {
      var c = s(t[o], t, i);
      if ("throw" !== c.type) {
        var h = c.arg,
          f = h.value;
        return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) {
          e("next", t, a, u);
        }, function (t) {
          e("throw", t, a, u);
        }) : r.resolve(f).then(function (t) {
          h.value = t, a(h);
        }, function (t) {
          return e("throw", t, a, u);
        });
      }
      u(c.arg);
    }
    var o;
    c(this, "_invoke", function (t, n) {
      function i() {
        return new r(function (r, o) {
          e(t, n, r, o);
        });
      }
      return o = o ? o.then(i, i) : i();
    }, !0);
  }
  function d(r, e) {
    var n = e.method,
      o = r.i[n];
    if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f;
    var i = s(o, r.i, e.arg);
    if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f;
    var a = i.arg;
    return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
  }
  function w(t) {
    this.tryEntries.push(t);
  }
  function m(r) {
    var e = r[4] || {};
    e.type = "normal", e.arg = t, r[4] = e;
  }
  function Context(t) {
    this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0);
  }
  function x(r) {
    if (null != r) {
      var e = r[i];
      if (e) return e.call(r);
      if ("function" == typeof r.next) return r;
      if (!isNaN(r.length)) {
        var o = -1,
          a = function e() {
            for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e;
            return e.value = t, e.done = !0, e;
          };
        return a.next = a;
      }
    }
    throw new TypeError(_typeof(r) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) {
    var r = "function" == typeof t && t.constructor;
    return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name));
  }, r.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t;
  }, r.awrap = function (t) {
    return {
      __await: t
    };
  }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () {
    return this;
  }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(h(t, e, n, o), i);
    return r.isGeneratorFunction(e) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, g(v), c(v, u, "Generator"), c(v, i, function () {
    return this;
  }), c(v, "toString", function () {
    return "[object Generator]";
  }), r.keys = function (t) {
    var r = Object(t),
      e = [];
    for (var n in r) e.unshift(n);
    return function t() {
      for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t;
      return t.done = !0, t;
    };
  }, r.values = x, Context.prototype = {
    constructor: Context,
    reset: function reset(r) {
      if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0][4];
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(r) {
      if (this.done) throw r;
      var e = this;
      function n(t) {
        a.type = "throw", a.arg = r, e.next = t;
      }
      for (var o = e.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i[4],
          u = this.prev,
          c = i[1],
          h = i[2];
        if (-1 === i[0]) return n("end"), !1;
        if (!c && !h) throw Error("try statement without catch or finally");
        if (null != i[0] && i[0] <= u) {
          if (u < c) return this.method = "next", this.arg = t, n(c), !0;
          if (u < h) return n(h), !1;
        }
      }
    },
    abrupt: function abrupt(t, r) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var n = this.tryEntries[e];
        if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) {
          var o = n;
          break;
        }
      }
      o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null);
      var i = o ? o[4] : {};
      return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i);
    },
    complete: function complete(t, r) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f;
    },
    finish: function finish(t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var e = this.tryEntries[r];
        if (e[2] === t) return this.complete(e[4], e[3]), m(e), f;
      }
    },
    "catch": function _catch(t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var e = this.tryEntries[r];
        if (e[0] === t) {
          var n = e[4];
          if ("throw" === n.type) {
            var o = n.arg;
            m(e);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(r, e, n) {
      return this.delegate = {
        i: x(r),
        r: e,
        n: n
      }, "next" === this.method && (this.arg = t), f;
    }
  }, r;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 6015:
/***/ (function(module) {

function _setPrototypeOf(t, e) {
  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 27424:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(85372);
var iterableToArrayLimit = __webpack_require__(68872);
var unsupportedIterableToArray = __webpack_require__(86116);
var nonIterableRest = __webpack_require__(12218);
function _slicedToArray(r, e) {
  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 95036:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(18698)["default"]);
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 64062:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(18698)["default"]);
var toPrimitive = __webpack_require__(95036);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 18698:
/***/ (function(module) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 86116:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(73897);
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
  }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 33496:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(73808);
var setPrototypeOf = __webpack_require__(6015);
var isNativeFunction = __webpack_require__(46035);
var construct = __webpack_require__(3515);
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return module.exports = _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return construct(t, arguments, getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), setPrototypeOf(Wrapper, t);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _wrapNativeSuper(t);
}
module.exports = _wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 64687:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(17061)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 76743:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bigintToBuffer = exports.bigintFromBuffer = exports.bigintFromBufferLE = exports.log2 = exports.min = exports.max = exports.random = exports.abs = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var assert_1 = __webpack_require__(30688);
/**
 * same as ```Math.abs``` but for bigints
 */
function abs(n) {
    return n < BigInt(0) ? -n : n;
}
exports.abs = abs;
/**
 * @returns {bigint} a ```bigint``` between ```0``` and ```Number.MAX_SAFE_INTEGER``` so that is safe to convert to Number for whatever reason
 */
function random() {
    return BigInt(Math.round(Math.random() * Number.MAX_SAFE_INTEGER));
}
exports.random = random;
function max() {
    var nums = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nums[_i] = arguments[_i];
    }
    return nums.reduce(function (a, b) { return a > b ? a : b; });
}
exports.max = max;
function min() {
    var nums = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nums[_i] = arguments[_i];
    }
    return nums.reduce(function (a, b) { return a < b ? a : b; });
}
exports.min = min;
function log2(num) {
    if (num === BigInt(0))
        return BigInt(0);
    if (num < BigInt(0))
        return -log2(abs(num));
    var n = BigInt(num);
    var result = BigInt(0);
    while (n >>= BigInt(1))
        result++;
    return result;
}
exports.log2 = log2;
/**
 * uses the bytes of the buffer to construct a BigInteger
 * > **IMPORTANT** the bytes are considered in Little Endian order; use ```bigintFromBuffer``` for Big Endian
 */
function bigintFromBufferLE(buffer) {
    return bigintFromBuffer(
    // need to copy so that it doesn't reverses the original buffer
    Uint8Array.from(buffer)
        .reverse());
}
exports.bigintFromBufferLE = bigintFromBufferLE;
/**
 * converts a Uint8Array to a ```bigint```
 * Big-Endian default
 */
function bigintFromBuffer(buffer) {
    (0, assert_1.assert)((0, uint8array_utils_1.isUint8Array)(buffer), "expected buffer as input, while constructing a bigint instance using bigintFromBufferBE");
    var hexBuff = (0, uint8array_utils_1.toHex)(buffer);
    if (hexBuff.length === 0) {
        return BigInt(0);
    }
    return BigInt("0x".concat(hexBuff));
}
exports.bigintFromBuffer = bigintFromBuffer;
/**
 * converts a ```bigint``` to a ```Uint8Array``` of length ```nBytes``` given as second argument
 *
 * if ```nBytes``` is not specified the Uint8Array takes only the bytes needed
 * @param bigint
 * @param nBytes
 * @returns
 */
function bigintToBuffer(bigint, nBytes) {
    if (nBytes === void 0) { nBytes = undefined; }
    (0, assert_1.assert)(bigint >= BigInt(0), "cannot convert negative bigint to buffer");
    if (bigint == BigInt(0)) {
        if (nBytes === undefined) {
            return Uint8Array.from([]);
        }
        return new Uint8Array(nBytes);
    }
    var buffHexString = bigint.toString(16);
    buffHexString = buffHexString.length % 2 === 0 ? buffHexString : '0' + buffHexString;
    if (nBytes !== undefined) {
        (0, assert_1.assert)(Math.round(Math.abs(nBytes)) === nBytes, "cannot construct a buffer of length " + nBytes + ", while using bigintToBufferOfNBytesBE");
        // pads with zeroes so that the final length is of nBytes*2 (2 hex digits per byte)
        // String.prototype.padStart docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
        buffHexString = buffHexString.padStart(nBytes * 2, "00");
        if (buffHexString.length > nBytes * 2) {
            console.warn("required buffer size is smaller than the one used effectively by the given bigint, truncating the initial bytes as overflow");
            buffHexString = buffHexString.slice(buffHexString.length - (nBytes * 2));
        }
    }
    return (0, uint8array_utils_1.fromHex)(buffHexString);
}
exports.bigintToBuffer = bigintToBuffer;


/***/ }),

/***/ 30688:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assert = void 0;
function assert(condition, errorMessage, addInfos) {
    var args = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args[_i - 3] = arguments[_i];
    }
    if (condition)
        return;
    args.length > 0 && console.error.apply(console, __spreadArray([], __read(args), false));
    addInfos && console.error(addInfos);
    if (errorMessage instanceof Error) {
        throw errorMessage;
    }
    ;
    throw new Error(errorMessage);
}
exports.assert = assert;


/***/ }),

/***/ 79512:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.unsafeForceUInt = exports.forceBigUInt = exports.canBeUInteger = void 0;
function canBeUInteger(something) {
    return ((typeof something === "bigint" && something >= BigInt(0)) ||
        (typeof something === "number" && something === Math.round(Math.abs(something))));
}
exports.canBeUInteger = canBeUInteger;
function forceBigUInt(toForce) {
    if (!canBeUInteger(toForce)) {
        // console.error( toForce );
        throw new Error("trying to convert an integer to an unsigned Integer, the number was negative");
    }
    return BigInt(toForce);
}
exports.forceBigUInt = forceBigUInt;
;
function unsafeForceUInt(toForce) {
    if (!canBeUInteger(toForce)) {
        // console.error( toForce );
        throw new Error("trying to convert an integer to an unsigned Integer, the number was negative");
    }
    return Number(toForce);
}
exports.unsafeForceUInt = unsafeForceUInt;


/***/ }),

/***/ 20847:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BitStreamIterator = exports.BitStream = exports.forceInByteOffset = exports.isInByteOffset = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var stuff_1 = __webpack_require__(70866);
var assert_1 = __webpack_require__(35086);
var BigIntUtils_1 = __importDefault(__webpack_require__(27081));
var isBinary_1 = __webpack_require__(26578);
function isInByteOffset(offset) {
    return (offset === 0 ||
        offset === 1 ||
        offset === 2 ||
        offset === 3 ||
        offset === 4 ||
        offset === 5 ||
        offset === 6 ||
        offset === 7);
}
exports.isInByteOffset = isInByteOffset;
function forceInByteOffset(offset) {
    return (Math.round(Math.abs(offset)) % 8);
}
exports.forceInByteOffset = forceInByteOffset;
var BitStream = /** @class */ (function () {
    function BitStream(bytes, nInitialZeroes) {
        if (nInitialZeroes === void 0) { nInitialZeroes = 0; }
        var _this = this;
        /**
         * allows to use ```BitStream```s in ```for..of``` loops
         *
         * e.g.:
         * ```ts
         * for( let bit of bitStream )
         * {
         *    // ```bit``` si an object of type ```Bit```
         * }
         * ```
         */
        this[_a] = function () { return new BitStreamIterator(_this); };
        // case empty BitStream
        // aka. new BitStream() || new BitStream( undefined )
        if (bytes === undefined) {
            this._bits = BigInt(-1);
            this._nInitialZeroes = 0;
            return;
        }
        // nInitialZeroes has to be an integer
        (0, assert_1.assert)(Math.round(Math.abs(nInitialZeroes)) === nInitialZeroes, "invalid numebr of nInitialZeroes passed, expected non-negative integer, got: " + nInitialZeroes.toString());
        // construct form bigint
        if (typeof bytes == "bigint") {
            this._nInitialZeroes = nInitialZeroes;
            // silently adapts the input if negative in produciton
            this._bits = BigIntUtils_1.default.abs(bytes);
            return;
        }
        // construct form Uint8Array
        // assert got Uint8Array instance as input
        (0, assert_1.assert)((0, uint8array_utils_1.isUint8Array)(bytes), "expected a Uint8Array instance", {
            got: bytes,
            nativeType: typeof bytes
        });
        if (bytes.length === 0) {
            this._bits = BigInt(-1);
            this._nInitialZeroes = 0;
            return;
        }
        var nZeroesAsEndPadding = forceInByteOffset(nInitialZeroes);
        var firstNonZeroByte = 0;
        var allZeroesBytes = 0;
        while (allZeroesBytes < bytes.length) {
            firstNonZeroByte = (0, uint8array_utils_1.readUint8)(bytes, allZeroesBytes);
            if (firstNonZeroByte > 0)
                break;
            allZeroesBytes++;
        }
        if (allZeroesBytes === bytes.length) {
            this._bits = BigInt(-1);
            this._nInitialZeroes = 8 * allZeroesBytes;
            return;
        }
        this._nInitialZeroes = (8 * allZeroesBytes) + (8 - (0, stuff_1.getNOfUsedBits)(BigInt(firstNonZeroByte)));
        (0, assert_1.assert)(this._nInitialZeroes >= 0, "this._nInitialZeroes was setted badly in a BitStream creation using a Uint8Array as input.");
        this._bits = BigIntUtils_1.default.fromBuffer(bytes);
        if (nZeroesAsEndPadding !== 0) {
            this._bits = this.bits << BigInt(nZeroesAsEndPadding);
        }
    }
    BitStream.isStrictInstance = function (value) {
        return Object.getPrototypeOf(value) === BitStream.prototype;
    };
    Object.defineProperty(BitStream.prototype, "bits", {
        /**
         * **IMPORTANT**
         *
         * this property returns the raw bigint stored in the instance
         *
         * this means that if the instance represents an empty ```BitStream``` ,
         * or one composed by an undefinite series of zeroes, you'll likely get an different result than the expected one
         *
         * for a more appropriate result you should use the ```asBigInt``` method
         *
         * example:
         * ```ts
         * const myBitStream = new BitStream();
         *
         * myBitStream.bits // -> -1n
         * myBitStream.asBigInt().bigint // -> 0n
         *
         * ```
         *
         */
        get: function () {
            return this._bits;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitStream.prototype, "nInitialZeroes", {
        get: function () {
            return this._nInitialZeroes;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitStream.prototype, "length", {
        get: function () {
            if (this.isEmpty())
                return 0;
            return this._nInitialZeroes + (0, stuff_1.getNOfUsedBits)(this._bits);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitStream.prototype, "lengthInBytes", {
        get: function () {
            return BitStream.getMinBytesForLength(this.length);
        },
        enumerable: false,
        configurable: true
    });
    BitStream.prototype.isEmpty = function () {
        return this._bits < BigInt(0) && this.nInitialZeroes <= 0;
    };
    BitStream.prototype.isAllZeroes = function () {
        return this._bits <= BigInt(0) && this.nInitialZeroes >= 0;
    };
    BitStream.fromBinStr = function (binStr) {
        (0, assert_1.assert)((0, isBinary_1.isBinary)(binStr), "expected an instance of the 'BinsryString' class; got: " + binStr.toString());
        var firstOneAt = binStr.indexOf('1');
        if (firstOneAt < 0) // case all zeroes
         {
            return new BitStream(BigInt(0), binStr.length);
        }
        return new BitStream(BigInt("0b".concat(binStr.slice(firstOneAt))), firstOneAt);
    };
    BitStream.prototype.toBinStr = function () {
        var _b = this.asBigInt(), bigint = _b.bigint, nInitialZeroes = _b.nInitialZeroes;
        return "0".repeat(nInitialZeroes) + bigint.toString(2);
    };
    BitStream.getMinBytesForLength = function (length) {
        length = Math.round(Math.abs(length));
        // even one bit requires a new byte,
        // that's why ceil
        return Math.ceil(length / 8);
    };
    BitStream.prototype.getNBitsMissingToByte = function () {
        var lengthMod8 = this.length % 8;
        if (lengthMod8 === 0)
            return 0; // would have returned 8 (8 - 0) otherwise
        return (8 - lengthMod8);
    };
    BitStream.prototype.at = function (index) {
        if (index >= this.length || index < 0)
            throw RangeError("cannot access bit at index " + index.toString());
        if (index < this.nInitialZeroes)
            return 0;
        index = Math.round(index);
        return (Boolean(this.bits & BigInt(1 << (this.length - index - 1)))) ? 1 : 0;
    };
    /**
     *
     * @returns {object}
     *      with a @property {Uint8Array} bigint containing the bigint
     *      and a @property {InByteOffset} nInitialZeroes
     *      containing a non-negative integer
     *      indicating how many (non-tracked in the bigint) zeroes are present in the ```BitStream```
     */
    BitStream.prototype.asBigInt = function () {
        if (this.isEmpty())
            return {
                bigint: BigInt(0),
                nInitialZeroes: 0
            };
        if (this.isAllZeroes())
            return {
                bigint: BigInt(0),
                nInitialZeroes: this.nInitialZeroes
            };
        return {
            bigint: this.bits,
            nInitialZeroes: this.nInitialZeroes
        };
    };
    /**
     *
     * @returns {object}
     *      with a @property {Uint8Array} buffer containing the buffer
     *      and a @property {InByteOffset} nZeroesAsEndPadding
     *      containing a number between 7 and 1 both included,
     *      indicating how many of the end bits should be ignored
     */
    BitStream.prototype.toBuffer = function () {
        if (this.isEmpty())
            return {
                buffer: Uint8Array.from([]),
                nZeroesAsEndPadding: 0
            };
        if (this.isAllZeroes())
            return {
                buffer: this.nInitialZeroes <= 0 ? Uint8Array.from([]) : (0, uint8array_utils_1.fromHex)("00".repeat(Math.ceil(this.nInitialZeroes / 8))),
                nZeroesAsEndPadding: this._nInitialZeroes % 8 === 0 ?
                    0 :
                    (8 - forceInByteOffset(this._nInitialZeroes))
            };
        // we don't want to modify our own bits
        var bits = this.bits;
        // Array is provided with usefull operation
        // unshift
        // push
        // at the moment doesnt contain any initial zero
        var bitsArr = Array.from(BigIntUtils_1.default.toBuffer(bits));
        var firstNonZeroByte = bitsArr[0];
        // add whole bytes of zeroes at the beginning if needed
        if (this.nInitialZeroes >= 8) {
            bitsArr.unshift.apply(bitsArr, __spreadArray([], __read(Array(
            // number of whole bytes as zeroes
            Math.floor(this.nInitialZeroes / 8)).fill(0)), false));
        }
        if (firstNonZeroByte === undefined) {
            console.error(firstNonZeroByte);
            console.log("toBuffer called on: ", this);
            console.log("this.isEmpty(): ".concat(this.isEmpty()), "this.isAllZeroes(): ".concat(this.isAllZeroes()));
        }
        // remaining zeroes bits
        var supposedInByteInitialZeroes = (this.nInitialZeroes % 8);
        var effectiveInByteInitialZeroes = (8 - (0, stuff_1.getNOfUsedBits)(BigInt(firstNonZeroByte !== null && firstNonZeroByte !== void 0 ? firstNonZeroByte : 0)));
        (0, assert_1.assert)((effectiveInByteInitialZeroes >= 0 && effectiveInByteInitialZeroes <= 7) &&
            Math.round(effectiveInByteInitialZeroes) == effectiveInByteInitialZeroes, "unexpected numebr of effectiveInByteInitialZeroes; should be 'InByteOffset'; got: " + effectiveInByteInitialZeroes.toString());
        if (
        // no bits (whole bytes only)
        // supposedInByteInitialZeroes === 0  ||
        // supposedInByteInitialZeroes already tracked
        supposedInByteInitialZeroes === effectiveInByteInitialZeroes) {
            return {
                buffer: Uint8Array.from(bitsArr),
                nZeroesAsEndPadding: 0
            };
        }
        /*
        
        example:
        if( 5 < 7 ) means
        the first (non-zero) byte is like `0b0000_0111`
        whereas it should be              `0b0000_0001`

        if that's the case we shift right by 2 ( 7 - 5 )
        */
        if (effectiveInByteInitialZeroes < supposedInByteInitialZeroes) {
            // shiftr carrying the bits
            var shiftBy_1 = supposedInByteInitialZeroes - effectiveInByteInitialZeroes;
            var lostBits = 0;
            var prevLostBits = 0;
            for (var i = 
            //skip the bytes manually setted to zero before (line 245)
            Math.floor(this.nInitialZeroes / 8); i < bitsArr.length; i++) {
                prevLostBits = Number((0, stuff_1.getNLastBits)(BigInt(bitsArr[i]), BigInt(shiftBy_1)));
                bitsArr[i] = (bitsArr[i] >>> shiftBy_1) | lostBits;
                lostBits = prevLostBits
                    // prepares lostBits to be used in the biwise or
                    << (8 - shiftBy_1);
            }
            // add one final byte containing bits tha would have be lost
            bitsArr.push(lostBits);
            return {
                buffer: Uint8Array.from(bitsArr),
                nZeroesAsEndPadding: (8 - shiftBy_1)
            };
        }
        /*
        otherwhise it means
        effectiveInByteInitialZeroes > supposedInByteInitialZeroes

        so the situation is like:

        first (non-zero) byte `0b0000_0001`
        whereas it should be  `0b0000_0111`

        so we are supposed to shif left by "effectiveInByteInitialZeroes - supposedInByteInitialZeroes" (in this case 2)
        */
        var shiftBy = effectiveInByteInitialZeroes - supposedInByteInitialZeroes;
        /**
         * this is quick and dirty, we are basically re-doin what did before
         * @fixme should be moved above to remove code duplication
         */
        var shiftedlBitsArr = Array.from(
        // let bigint do the dirty work
        BigIntUtils_1.default.toBuffer(bits << BigInt(shiftBy)));
        // add whole bytes of zeroes at the beginning if needed
        if (this.nInitialZeroes >= 8) {
            shiftedlBitsArr.unshift.apply(shiftedlBitsArr, __spreadArray([], __read(Array(
            // number of whole bytes as zeroes
            Math.floor(this.nInitialZeroes / 8)).fill(0)), false));
        }
        return {
            buffer: Uint8Array.from(shiftedlBitsArr),
            nZeroesAsEndPadding: shiftBy
        };
    };
    /**
     * @param byOffset number of bits to move to
     * @returns {bigint} lost bits as big integer
     */
    BitStream.prototype.shiftr = function (byOffset) {
        var lostBits = (0, stuff_1.getNLastBits)(this._bits, byOffset);
        this._bits = this.bits >> byOffset;
        return lostBits;
    };
    BitStream.prototype.shiftl = function (byOffset) {
        this._bits = this.bits << byOffset;
    };
    BitStream.prototype.append = function (other) {
        if (other.isEmpty()) {
            return;
        }
        if (this.isEmpty()) {
            this._bits = other.bits;
            this._nInitialZeroes = other.nInitialZeroes;
            return;
        }
        if (this.isAllZeroes()) {
            this._bits = other.bits;
            this._nInitialZeroes = this._nInitialZeroes + other.nInitialZeroes;
            return;
        }
        if (other.isAllZeroes()) {
            this._bits = this._bits << BigInt(other.nInitialZeroes);
            return;
        }
        // make some space
        this._bits = this.bits << BigInt(other.length);
        // other.length keeps track also of possible initial zeroes
        // so those have been added when shifting
        this._bits = this.bits | other.bits;
    };
    BitStream.prototype.clone = function () {
        if (this.isEmpty())
            return new BitStream();
        return new BitStream(this.bits, this.nInitialZeroes);
    };
    BitStream.concat = function (a, b) {
        var bitStream = a.clone();
        // .append's argument is readonly
        bitStream.append(b);
        return bitStream;
    };
    // -------------------------------------------------------------------------------------------------------------------------- //
    // ------------------------------------------------------- Operations ------------------------------------------------------- //
    // -------------------------------------------------------------------------------------------------------------------------- //
    BitStream.eq = function (a, b) {
        // if same object (same reference) return true
        // Ω(1) // Omega(1)
        if (a === b)
            return true;
        return (a.nInitialZeroes === b.nInitialZeroes &&
            a.bits === b.bits);
    };
    return BitStream;
}());
exports.BitStream = BitStream;
_a = Symbol.iterator;
var BitStreamIterator = /** @class */ (function () {
    function BitStreamIterator(bitStream) {
        if (bitStream.length === 0) {
            this._bitStreamBuff = Uint8Array.from([]);
            this._nZeroesAsPadding = 0;
            this._currByteIndex = 0;
            this._currByte = 0;
            this._currBitIndex = 0;
            this._isDone = function () { return true; };
            return;
        }
        var _b = bitStream.toBuffer(), buffer = _b.buffer, nZeroesAsEndPadding = _b.nZeroesAsEndPadding;
        this._bitStreamBuff = buffer;
        this._nZeroesAsPadding = nZeroesAsEndPadding;
        this._currByteIndex = 0;
        this._currByte = (0, uint8array_utils_1.readUint8)(this._bitStreamBuff, this._currByteIndex);
        this._currBitIndex = 0;
        this._updateByte = this._updateByte.bind(this);
        this._isDone = this._isDone.bind(this);
    }
    BitStreamIterator.prototype.next = function () {
        if (this._isDone())
            return { done: true, value: 0 };
        /*
        Debug.ignore.log(
            `currByte: ${this._currByte.toString(2).padStart( 8 , '0' )}`,
            `\nmask    : ${( 0b1 << ( 7 - this._currBitIndex ) ).toString(2).padStart( 8 , '0' )}`,
            `\nresult  : ${(
                this._currByte &
                ( 0b1 << ( 7 - this._currBitIndex ) )
            ).toString(2).padStart( 8 , '0' )}`
        )
        //*/
        // get value
        var value = Boolean(this._currByte &
            (1 << (7 - this._currBitIndex))) ? 1 : 0;
        // perform update for next call
        this._currBitIndex++;
        if (this._currBitIndex >= 8) {
            this._currBitIndex = 0;
            this._updateByte();
        }
        // yeilds value
        return {
            value: value,
            done: false
        };
    };
    BitStreamIterator.prototype._updateByte = function () {
        this._currByteIndex++;
        if (this._currByteIndex < this._bitStreamBuff.length) {
            this._currByte = (0, uint8array_utils_1.readUint8)(this._bitStreamBuff, this._currByteIndex);
        }
    };
    BitStreamIterator.prototype._isDone = function () {
        return ((this._currByteIndex >= this._bitStreamBuff.length) ||
            ((this._currByteIndex === this._bitStreamBuff.length - 1) &&
                (this._currBitIndex === (8 - this._nZeroesAsPadding))));
    };
    return BitStreamIterator;
}());
exports.BitStreamIterator = BitStreamIterator;


/***/ }),

/***/ 85840:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(20847), exports);


/***/ }),

/***/ 27081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var uint8array_utils_1 = __webpack_require__(44948);
var assert_1 = __webpack_require__(35086);
/**
 * @static
 */
var BigIntUtils = /** @class */ (function () {
    function BigIntUtils() {
    }
    ;
    /**
     * same as ```Math.abs``` but for bigints
     */
    BigIntUtils.abs = function (n) {
        return n < BigInt(0) ? -n : n;
    };
    /**
     * @returns {bigint} a ```bigint``` between ```0``` and ```Number.MAX_SAFE_INTEGER``` so that is safe to convert to Number for whatever reason
     */
    BigIntUtils.random = function () {
        return BigInt(Math.round(Math.random() * Number.MAX_SAFE_INTEGER));
    };
    BigIntUtils.max = function () {
        var nums = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nums[_i] = arguments[_i];
        }
        return nums.reduce(function (a, b) { return a > b ? a : b; });
    };
    BigIntUtils.min = function () {
        var nums = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nums[_i] = arguments[_i];
        }
        return nums.reduce(function (a, b) { return a < b ? a : b; });
    };
    BigIntUtils.log2 = function (num) {
        if (num === BigInt(0))
            return BigInt(0);
        if (num < BigInt(0))
            return -BigIntUtils.log2(BigIntUtils.abs(num));
        var n = BigInt(num);
        var result = BigInt(0);
        while (n >>= BigInt(1))
            result++;
        return result;
    };
    /**
     * uses the bytes of the buffer to construct a BigInteger
     * > **IMPORTANT** the bytes are considered in Little Endian order; use ```BigIntUtils.fromBuffer``` for Big Endian
     */
    BigIntUtils.fromBufferLE = function (buffer) {
        return BigIntUtils.fromBuffer(
        // need to copy so that it doesn't reverses the original buffer
        Uint8Array.from(buffer)
            .reverse());
    };
    /**
     * converts a Uint8Array to a ```bigint```
     * Big-Endian default
     */
    BigIntUtils.fromBuffer = function (buffer) {
        (0, assert_1.assert)((0, uint8array_utils_1.isUint8Array)(buffer), "expected buffer as input, while constructing a bigint instance using BigIntUtils.fromBufferBE");
        var hexBuff = (0, uint8array_utils_1.toHex)(buffer);
        if (hexBuff.length === 0) {
            return BigInt(0);
        }
        return BigInt("0x".concat(hexBuff));
    };
    /**
     * converts a ```bigint``` to a ```Uint8Array``` of length ```nBytes``` given as second argument
     *
     * if ```nBytes``` is not specified the Uint8Array takes only the bytes needed
     * @param bigint
     * @param nBytes
     * @returns
     */
    BigIntUtils.toBuffer = function (bigint, nBytes) {
        if (nBytes === void 0) { nBytes = undefined; }
        (0, assert_1.assert)(bigint >= BigInt(0), "cannot convert negative bigint to buffer");
        if (bigint == BigInt(0)) {
            if (nBytes === undefined) {
                return Uint8Array.from([]);
            }
            return new Uint8Array(nBytes);
        }
        var buffHexString = bigint.toString(16);
        buffHexString = buffHexString.length % 2 === 0 ? buffHexString : '0' + buffHexString;
        if (nBytes !== undefined) {
            (0, assert_1.assert)(Math.round(Math.abs(nBytes)) === nBytes, "cannot construct a buffer of length " + nBytes + ", while using BigIntUtils.toBufferOfNBytesBE");
            // pads with zeroes so that the final length is of nBytes*2 (2 hex digits per byte)
            // String.prototype.padStart docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
            buffHexString = buffHexString.padStart(nBytes * 2, "00");
            if (buffHexString.length > nBytes * 2) {
                console.warn("required buffer size is smaller than the one used effectively by the given bigint, truncating the initial bytes as overflow");
                buffHexString = buffHexString.slice(buffHexString.length - (nBytes * 2));
            }
        }
        return (0, uint8array_utils_1.fromHex)(buffHexString);
    };
    return BigIntUtils;
}());
exports["default"] = BigIntUtils;


/***/ }),

/***/ 35086:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assert = void 0;
function assert(condition, errorMessage, addInfos) {
    var args = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args[_i - 3] = arguments[_i];
    }
    if (condition)
        return;
    args.length > 0 && console.error.apply(console, __spreadArray([], __read(args), false));
    addInfos && console.error(addInfos);
    if (errorMessage instanceof Error) {
        throw errorMessage;
    }
    ;
    throw new Error(errorMessage);
}
exports.assert = assert;


/***/ }),

/***/ 26578:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isBinary = void 0;
function isBinary(str) {
    if (typeof str !== "string")
        return false;
    for (var i = 0; i < str.length; i++) {
        var ch = str[i];
        if (!(ch === "0" || ch === "1"))
            return false;
    }
    return true;
}
exports.isBinary = isBinary;


/***/ }),

/***/ 70866:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.minBytesRequired = exports.getNOfUsedBits = exports.getNLastBits = exports.getNLastBitsInt = exports.andMaskOfLength = exports.andMaskOfLengthInt = exports.getFirstByte = void 0;
var assert_1 = __webpack_require__(35086);
/**
 * @deprecated not sure it has ever made sense to have it
 * @returns a number in range ```[ 0 , 255 ]``` ( ```[ 0b0000_0000, 0b1111_1111 ]``` ) based on the first byte
 */
function getFirstByte(bits) {
    return Number("0x".concat(bits.toString(16).slice(0, 2)));
}
exports.getFirstByte = getFirstByte;
/**
 * @deprecated use ```andMaskOfLength``` instead
 */
function andMaskOfLengthInt(n) {
    n = Math.round(Math.abs(n));
    // operatons used are valid on singed number
    if (n >= 30) {
        return andMaskOfLength(BigInt(n));
    }
    return BigInt((1 << n) - 1);
}
exports.andMaskOfLengthInt = andMaskOfLengthInt;
/**
 * returns a ```bigint``` of that as the last ```n``` bits setted to ones;
 *
 * example
 * ```ts
 * getMaskOfLength( 7 ) === Bigint( 0b0111_1111 ); // true
 * ```
 */
function andMaskOfLength(n) {
    return BigInt((BigInt(1)
        << n)
        - BigInt(1));
}
exports.andMaskOfLength = andMaskOfLength;
/**
 * @deprecated use ```getNLastBits``` instead
 */
function getNLastBitsInt(fromNuber, nBits) {
    (0, assert_1.assert)(typeof fromNuber === "number" && typeof nBits === "number", "can use getNLastBitsInt on number instances only");
    return Number(BigInt(fromNuber)
        &
            andMaskOfLength(BigInt(nBits)));
}
exports.getNLastBitsInt = getNLastBitsInt;
function getNLastBits(fromNuber, nBits) {
    return (fromNuber & andMaskOfLength(nBits));
}
exports.getNLastBits = getNLastBits;
/**
 * @returns the number of bits from the first setted to ```1``` on the left up until the end
 */
function getNOfUsedBits(bits) {
    if (bits === BigInt(0))
        return 0;
    return bits.toString(2).length;
}
exports.getNOfUsedBits = getNOfUsedBits;
function minBytesRequired(bigint) {
    if (bigint < BigInt(0))
        throw new Error("minBytesRequired works for positives integers only");
    var fullByteOnes = BigInt(255);
    var mask = fullByteOnes;
    var bytesRequired = 1;
    while (bigint !== (bigint & mask)) {
        mask = (mask << BigInt(8)) | fullByteOnes;
        bytesRequired++;
    }
    return bytesRequired;
}
exports.minBytesRequired = minBytesRequired;


/***/ }),

/***/ 86152:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ByteString = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
function isHex(anyString) {
    // always think in javasript
    if (typeof anyString !== "string")
        return false;
    var str = anyString.toLowerCase();
    var validHex = "987654321abcdef0";
    for (var i = 0; i < str.length; i++) {
        if (!validHex.includes(str[i]))
            return false;
    }
    // if false has not been returned yet, then it must be a valid hex
    return true;
}
function assert(condition, errorMessage, addInfos) {
    var args = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args[_i - 3] = arguments[_i];
    }
    if (condition)
        return;
    args.length > 0 && console.error.apply(console, __spreadArray([], __read(args), false));
    addInfos && console.error(addInfos);
    if (errorMessage instanceof Error) {
        throw errorMessage;
    }
    ;
    throw new Error(errorMessage);
}
var ByteString = /** @class */ (function () {
    function ByteString(bs) {
        if (typeof bs === "string") {
            // remove spaces
            bs = bs.trim().split(" ").join("");
            assert(isHex(bs), "invalid hex input while constructing a ByteString: " + bs);
            // even length
            bs = (0, uint8array_utils_1.fromHex)((bs.length % 2) === 1 ? "0" + bs : bs);
        }
        if (!(bs instanceof Uint8Array))
            bs = bs.toBuffer();
        assert((0, uint8array_utils_1.isUint8Array)(bs), "invalid Uint8Array input while constructing a ByteString");
        this._bytes = bs;
    }
    ByteString.isStrictInstance = function (bs) {
        return Object.getPrototypeOf(bs) === ByteString.prototype;
    };
    Object.defineProperty(ByteString.prototype, "asString", {
        /**
         * @deprecated use `toString()` instead
         */
        get: function () {
            return (0, uint8array_utils_1.toHex)(this._bytes);
        },
        enumerable: false,
        configurable: true
    });
    ByteString.prototype.toString = function () {
        return (0, uint8array_utils_1.toHex)(this._bytes);
    };
    Object.defineProperty(ByteString.prototype, "asBytes", {
        /**
         * @deprecated use `toBuffer()` instead
         */
        get: function () {
            return this._bytes.slice();
        },
        enumerable: false,
        configurable: true
    });
    ByteString.prototype.toBuffer = function () {
        return this._bytes.slice();
    };
    ByteString.prototype.clone = function () {
        return new ByteString(this._bytes.slice());
    };
    ByteString.fromAscii = function (asciiStr) {
        return new ByteString((0, uint8array_utils_1.fromAscii)(asciiStr));
    };
    ByteString.toAscii = function (bStr) {
        return (0, uint8array_utils_1.toAscii)(bStr.toBuffer());
    };
    ByteString.isValidHexValue = function (str) {
        return (isHex(str) &&
            str.length % 2 === 0);
    };
    return ByteString;
}());
exports.ByteString = ByteString;


/***/ }),

/***/ 93002:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.canBeCborString = exports.forceCborString = void 0;
var bytestring_1 = __webpack_require__(86152);
var CborString_1 = __webpack_require__(21794);
function forceCborString(cStr) {
    return new CborString_1.CborString(cStr instanceof bytestring_1.ByteString ? cStr.toBuffer() : cStr);
}
exports.forceCborString = forceCborString;
function canBeCborString(stuff) {
    return (typeof stuff === "string" ||
        stuff instanceof Uint8Array ||
        stuff instanceof bytestring_1.ByteString);
}
exports.canBeCborString = canBeCborString;


/***/ }),

/***/ 12992:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CborConstants = exports.isUInt8MajorType = exports.UInt8MajorType = exports.isMajorTypeTag = exports.MajorType = void 0;
var MajorType;
(function (MajorType) {
    MajorType[MajorType["unsigned"] = 0] = "unsigned";
    MajorType[MajorType["negative"] = 1] = "negative";
    MajorType[MajorType["bytes"] = 2] = "bytes";
    MajorType[MajorType["text"] = 3] = "text";
    MajorType[MajorType["array"] = 4] = "array";
    MajorType[MajorType["map"] = 5] = "map";
    MajorType[MajorType["tag"] = 6] = "tag";
    MajorType[MajorType["float_or_simple"] = 7] = "float_or_simple"; // 111x_xxxx // 
})(MajorType = exports.MajorType || (exports.MajorType = {}));
;
Object.freeze(MajorType);
function isMajorTypeTag(majorTag) {
    return (majorTag >= 0 && majorTag <= 7 &&
        majorTag === Math.round(majorTag));
}
exports.isMajorTypeTag = isMajorTypeTag;
var UInt8MajorType;
(function (UInt8MajorType) {
    UInt8MajorType[UInt8MajorType["unsigned"] = 0] = "unsigned";
    UInt8MajorType[UInt8MajorType["negative"] = 32] = "negative";
    UInt8MajorType[UInt8MajorType["bytes"] = 64] = "bytes";
    UInt8MajorType[UInt8MajorType["text"] = 96] = "text";
    UInt8MajorType[UInt8MajorType["array"] = 128] = "array";
    UInt8MajorType[UInt8MajorType["map"] = 160] = "map";
    UInt8MajorType[UInt8MajorType["tag"] = 192] = "tag";
    UInt8MajorType[UInt8MajorType["float_or_simple"] = 224] = "float_or_simple";
})(UInt8MajorType = exports.UInt8MajorType || (exports.UInt8MajorType = {}));
Object.freeze(UInt8MajorType);
function isUInt8MajorType(byte) {
    return ((byte & 224) === byte &&
        isMajorTypeTag(byte >> 5));
}
exports.isUInt8MajorType = isUInt8MajorType;
/**
 * @static
 */
var AddInfos = /** @class */ (function () {
    function AddInfos() {
    }
    AddInfos.Length = Object.freeze({
        expect_uint8: 24,
        expect_uint16: 25,
        expect_uint32: 26,
        expect_uint64: 27,
        make_infinite: 31
    });
    AddInfos.Tag = {
        utf8_string: 0 | 0,
        epoch_datetime: 1 | 0,
        positive_bignum: 2 | 0,
        negative_bignum: 3 | 0,
        decimal_frac_array: 4 | 0,
        bigfloat: 5 | 0,
        expect_base64_url: 21 | 0,
        expect_base64: 22 | 0,
        expect_base16: 23 | 0,
        sub_cbor: 24 | 0,
        uri: 32 | 0,
        base64_url: 33 | 0,
        base64: 34 | 0,
        regexp: 35 | 0,
        MIME: 36 | 0,
        self_cbor: 55799 | 0
    };
    AddInfos.Major7 = Object.freeze({
        false: 20,
        true: 21,
        null: 22,
        undefined: 23,
        simple_byte: 24,
        float_half: 25,
        float_single: 26,
        float_double: 27,
        infinite_break: 31
    });
    return AddInfos;
}());
/**
 * @static
 */
var CborConstants = /** @class */ (function () {
    function CborConstants() {
    }
    ;
    CborConstants.MajorTypeMask = 224;
    CborConstants.AdditionalInfosMask = 31;
    CborConstants.AddInfos = AddInfos;
    CborConstants.MajorType = Object.freeze({
        unsigned: 0,
        negative: 1,
        bytes: 2,
        text: 3,
        array: 4,
        map: 5,
        tag: 6,
        float_or_simple: 7 // 111x_xxxx // 
    });
    CborConstants.UInt8MajorType = Object.freeze({
        unsigned: 0,
        negative: 32,
        bytes: 64,
        text: 96,
        array: 128,
        map: 160,
        tag: 192,
        float_or_simple: 224
    });
    CborConstants.infinite_break = 255; // 0xff // 255
    return CborConstants;
}());
exports.CborConstants = CborConstants;


/***/ }),

/***/ 86934:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Cbor = exports.defaultParseOptions = void 0;
var CborString_1 = __webpack_require__(21794);
var CborObj_1 = __webpack_require__(85579);
var Constants_1 = __webpack_require__(12992);
var CborBytes_1 = __webpack_require__(77665);
var CborText_1 = __webpack_require__(92905);
var CborArray_1 = __webpack_require__(34427);
var CborMap_1 = __webpack_require__(80368);
var CborTag_1 = __webpack_require__(41154);
var CborSimple_1 = __webpack_require__(81853);
var CborUInt_1 = __webpack_require__(24850);
var CborNegInt_1 = __webpack_require__(78581);
var uint8array_utils_1 = __webpack_require__(44948);
var BaseCborError_1 = __webpack_require__(66143);
var assert_1 = __webpack_require__(32159);
var LazyCborArray_1 = __webpack_require__(26798);
var LazyCborMap_1 = __webpack_require__(61203);
var LazyCborTag_1 = __webpack_require__(7122);
var errors_1 = __webpack_require__(13020);
var max_1 = __webpack_require__(34625);
var SubCborRef_1 = __webpack_require__(15205);
var overwriteSubCborRefBytes_1 = __webpack_require__(37286);
/**
 * @private to the module; not needed elsewhere
 */
var CborEncoding = /** @class */ (function () {
    function CborEncoding() {
        this._buff = new Uint8Array(256); // (1 << 8) bytes, 1/4 kB
        this._len = 0;
    }
    Object.defineProperty(CborEncoding.prototype, "bytes", {
        get: function () {
            return Uint8Array.prototype.slice.call(this._buff, 0, this._len);
            // this._buff.slice( 0, this._len );
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CborEncoding.prototype, "length", {
        get: function () {
            return this._len;
        },
        enumerable: false,
        configurable: true
    });
    CborEncoding.prototype._prepareAppendOfByteLength = function (l) {
        var requiredLen = this._len + l;
        var newBuffLen = this._buff.byteLength;
        // expand the Uint8Array if needed
        while (newBuffLen < requiredLen) {
            newBuffLen = newBuffLen << 1; // old length * 2
        }
        // copies the old Uint8Array if expanded
        if (newBuffLen !== this._buff.byteLength) {
            var newBuff = new Uint8Array(newBuffLen);
            for (var i = 0; i < this._len; i++) {
                (0, uint8array_utils_1.writeUInt8)(newBuff, (0, uint8array_utils_1.readUInt8)(this._buff, i), i);
            }
            this._buff = newBuff;
        }
    };
    CborEncoding.prototype._commitAppendOfByteLength = function (l) {
        this._len += l;
    };
    CborEncoding.prototype.appendRawBytes = function (bytes) {
        this._prepareAppendOfByteLength(bytes.length);
        this._buff.set(bytes, this._len);
        this._commitAppendOfByteLength(bytes.length);
    };
    CborEncoding.prototype.appendUInt8 = function (uint8) {
        (0, assert_1.assert)(uint8 >= 0 && uint8 <= 255 &&
            uint8 === Math.round(uint8), "expected a byte; got: " + uint8);
        this._prepareAppendOfByteLength(1);
        (0, uint8array_utils_1.writeUInt8)(this._buff, uint8, this._len);
        this._commitAppendOfByteLength(1);
    };
    CborEncoding.prototype.appendUInt16 = function (uint16) {
        (0, assert_1.assert)(uint16 >= 0 && uint16 <= 65535 &&
            uint16 === Math.round(uint16), "expected two bytes; got: " + uint16);
        this._prepareAppendOfByteLength(2);
        (0, uint8array_utils_1.writeUInt16BE)(this._buff, uint16, this._len);
        this._commitAppendOfByteLength(2);
    };
    CborEncoding.prototype.appendUInt32 = function (uint32) {
        (0, assert_1.assert)(uint32 >= 0 && uint32 <= 4294967295 &&
            uint32 === Math.round(uint32), "expected 4 bytes; got: " + uint32);
        this._prepareAppendOfByteLength(4);
        (0, uint8array_utils_1.writeUInt32BE)(this._buff, uint32, this._len);
        this._commitAppendOfByteLength(4);
    };
    CborEncoding.prototype.appendUInt64 = function (uint64) {
        (0, assert_1.assert)(typeof uint64 === "bigint" &&
            uint64 >= BigInt(0) && uint64 <= BigInt("0b" + "11111111".repeat(8)), "expected 8 bytes; got: " + uint64);
        this._prepareAppendOfByteLength(8);
        (0, uint8array_utils_1.writeBigUInt64BE)(this._buff, uint64, this._len);
        this._commitAppendOfByteLength(8);
    };
    CborEncoding.prototype.appendFloat64 = function (float64) {
        (0, assert_1.assert)(typeof float64 === "number", "expected 8 bytes; got: " + float64);
        this._prepareAppendOfByteLength(8);
        (0, uint8array_utils_1.writeFloat64BE)(this._buff, float64, this._len);
        this._commitAppendOfByteLength(8);
    };
    CborEncoding.prototype.appendTypeAndLength = function (cborType, length, addInfos) {
        (0, assert_1.assert)((0, Constants_1.isMajorTypeTag)(cborType), "passed tag is not a valid major cbor type");
        (0, assert_1.assert)((typeof length === "number" || typeof length === "bigint") &&
            length >= 0, "invalid length");
        if (length > max_1.MAX_4_BYTES || addInfos === 27) {
            if (typeof length === "number")
                length = BigInt(length);
            this.appendUInt8((cborType << 5) | 27 /*expect_uint64*/);
            this.appendUInt64(length);
            return;
        }
        if (typeof length === "bigint")
            length = Number(length);
        var specifcAddInfos = typeof addInfos === "number" && addInfos >= 24 && addInfos <= 27;
        if (length < 24 &&
            !specifcAddInfos // use the specified addInfos if any
        ) {
            this.appendUInt8((cborType << 5) | length);
        }
        else if (length < max_1.OVERFLOW_1_BYTE &&
            (!specifcAddInfos ||
                addInfos === 24)) {
            this.appendUInt8((cborType << 5) | 24);
            this.appendUInt8(length);
        }
        else if (length < max_1.OVERFLOW_2_BYTES &&
            (!specifcAddInfos ||
                addInfos === 25)) {
            this.appendUInt8((cborType << 5) | 25);
            this.appendUInt16(length);
        }
        else /*
        if (
            length < 0x100000000 &&
            (
                !specifcAddInfos ||
                addInfos === 26
            )
        ) //*/ {
            this.appendUInt8((cborType << 5) | 26);
            this.appendUInt32(length);
        }
    };
    CborEncoding.prototype.appendCborObjEncoding = function (cObj) {
        (0, assert_1.assert)((0, CborObj_1.isCborObj)(cObj), "expected 'CborObj' strict instance; got: " + cObj);
        var startOffset = this.length;
        if (cObj instanceof CborUInt_1.CborUInt) {
            (0, assert_1.assert)(cObj.num >= BigInt(0), "encoding invalid unsigned integer as CBOR");
            // https://www.rfc-editor.org/rfc/rfc8949.html#name-bignums
            if (cObj.bigNumEncoding instanceof CborBytes_1.CborBytes) {
                this.appendCborObjEncoding(new CborTag_1.CborTag(2, cObj.bigNumEncoding));
                return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                    _bytes: this._buff,
                    start: startOffset,
                    end: this.length
                });
            }
            var n = cObj.num;
            // https://www.rfc-editor.org/rfc/rfc8949.html#name-bignums
            if (n > max_1.maxBigInt) {
                console.dir(cObj, { depth: Infinity });
                console.warn("big positive int encountered but `bigNumEncoding` is not set; " +
                    "you should see the value causing this problem in the console; " +
                    "please report this issue at https://github.com/HarmonicLabs/cbor/issues");
                this.appendCborObjEncoding(CborUInt_1.CborUInt.bigNum(n));
                return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                    _bytes: this._buff,
                    start: startOffset,
                    end: this.length
                });
            }
            // else
            this.appendTypeAndLength(Constants_1.MajorType.unsigned, cObj.num, cObj.addInfos);
            return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                _bytes: this._buff,
                start: startOffset,
                end: this.length
            });
        }
        if (cObj instanceof CborNegInt_1.CborNegInt) {
            (0, assert_1.assert)(cObj.num < BigInt(0), "encoding invalid negative integer as CBOR");
            if (cObj.bigNumEncoding instanceof CborBytes_1.CborBytes) {
                this.appendCborObjEncoding(new CborTag_1.CborTag(3, cObj.bigNumEncoding));
                return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                    _bytes: this._buff,
                    start: startOffset,
                    end: this.length
                });
            }
            var n = cObj.num;
            // https://www.rfc-editor.org/rfc/rfc8949.html#name-bignums
            if (n < max_1.minBigInt) {
                console.dir(cObj, { depth: Infinity });
                console.warn("big negative int encountered but `bigNumEncoding` is not set; " +
                    "you should see the value causing this problem in the console; " +
                    "please report this issue at https://github.com/HarmonicLabs/cbor/issues");
                this.appendCborObjEncoding(CborNegInt_1.CborNegInt.bigNum(n));
                return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                    _bytes: this._buff,
                    start: startOffset,
                    end: this.length
                });
            }
            // else
            this.appendTypeAndLength(Constants_1.MajorType.negative, -(n + BigInt(1)), cObj.addInfos);
            return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                _bytes: this._buff,
                start: startOffset,
                end: this.length
            });
        }
        if (cObj instanceof CborBytes_1.CborBytes) {
            // if( cObj.isDefiniteLength )
            if (cObj.chunks instanceof Uint8Array) {
                var bs = cObj.chunks;
                this.appendTypeAndLength(Constants_1.MajorType.bytes, bs.length, cObj.addInfos);
                this.appendRawBytes(bs);
                return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                    _bytes: this._buff,
                    start: startOffset,
                    end: this.length
                });
            }
            else {
                var chunks = cObj.chunks;
                var nChunks = chunks.length;
                this.appendUInt8((Constants_1.MajorType.bytes << 5) | 31);
                for (var i = 0; i < nChunks; i++) {
                    this.appendCborObjEncoding(chunks[i]);
                }
                this.appendUInt8(255); // break
                return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                    _bytes: this._buff,
                    start: startOffset,
                    end: this.length
                });
            }
        }
        if (cObj instanceof CborText_1.CborText) {
            // if( cObj.isDefiniteLength )
            if (typeof cObj.chunks === "string") {
                var bs = (0, uint8array_utils_1.fromUtf8)(cObj.text);
                this.appendTypeAndLength(Constants_1.MajorType.text, bs.length, cObj.addInfos);
                this.appendRawBytes(bs);
                return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                    _bytes: this._buff,
                    start: startOffset,
                    end: this.length
                });
            }
            else {
                var chunks = cObj.chunks;
                var nChunks = chunks.length;
                this.appendUInt8((Constants_1.MajorType.text << 5) | 31);
                for (var i = 0; i < nChunks; i++) {
                    this.appendCborObjEncoding(chunks[i]);
                }
                this.appendUInt8(255); // break
                return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                    _bytes: this._buff,
                    start: startOffset,
                    end: this.length
                });
            }
            return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                _bytes: this._buff,
                start: startOffset,
                end: this.length
            });
        }
        if (cObj instanceof CborArray_1.CborArray) {
            var arr = cObj.array;
            var arrLen = arr.length;
            if (cObj.indefinite)
                this.appendUInt8(0x9f);
            else
                this.appendTypeAndLength(Constants_1.MajorType.array, arrLen, cObj.addInfos);
            for (var i = 0; i < arrLen; i++) {
                this.appendCborObjEncoding(arr[i]);
            }
            if (cObj.indefinite)
                this.appendUInt8(0xff);
            return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                _bytes: this._buff,
                start: startOffset,
                end: this.length
            });
        }
        if (cObj instanceof CborMap_1.CborMap) {
            var map = cObj.map;
            if (cObj.indefinite)
                this.appendUInt8(0xbf);
            else
                this.appendTypeAndLength(Constants_1.MajorType.map, map.length, cObj.addInfos);
            for (var i = 0; i < map.length; i++) {
                this.appendCborObjEncoding(map[i].k);
                this.appendCborObjEncoding(map[i].v);
            }
            if (cObj.indefinite)
                this.appendUInt8(0xff);
            return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                _bytes: this._buff,
                start: startOffset,
                end: this.length
            });
        }
        if (cObj instanceof CborTag_1.CborTag) {
            this.appendTypeAndLength(Constants_1.MajorType.tag, cObj.tag);
            this.appendCborObjEncoding(cObj.data);
            return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                _bytes: this._buff,
                start: startOffset,
                end: this.length
            });
        }
        if (cObj instanceof CborSimple_1.CborSimple) {
            var simpValue = cObj.simple;
            if (simpValue === false) {
                this.appendUInt8(0xf4); // major type 6 (tag) | 20
                return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                    _bytes: this._buff,
                    start: startOffset,
                    end: this.length
                });
            }
            if (simpValue === true) {
                this.appendUInt8(0xf5); // major type 6 (tag) | 21
                return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                    _bytes: this._buff,
                    start: startOffset,
                    end: this.length
                });
            }
            if (simpValue === null) {
                this.appendUInt8(0xf6); // major type 6 (tag) | 22
                return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                    _bytes: this._buff,
                    start: startOffset,
                    end: this.length
                });
            }
            if (simpValue === undefined) {
                this.appendUInt8(0xf7); // major type 6 (tag) | 23
                return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                    _bytes: this._buff,
                    start: startOffset,
                    end: this.length
                });
            }
            if (cObj.numAs === "simple" &&
                simpValue >= 0 && simpValue <= 255 &&
                simpValue === Math.round(simpValue)) {
                this.appendTypeAndLength(Constants_1.MajorType.float_or_simple, simpValue);
                return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                    _bytes: this._buff,
                    start: startOffset,
                    end: this.length
                });
            }
            this.appendUInt8(0xfb); // (MajorType.float_or_simple << 5) | 27 (double precidison float)
            this.appendFloat64(simpValue);
            return cObj.subCborRef = new SubCborRef_1.SubCborRef({
                _bytes: this._buff,
                start: startOffset,
                end: this.length
            });
        }
        throw new BaseCborError_1.BaseCborError("'CborEncoding.appendCborObjEncoding' did not match any possible 'CborObj'");
    };
    return CborEncoding;
}());
exports.defaultParseOptions = Object.freeze({ keepRef: true });
/**
 * static class that allows CBOR encoding and decoding
 *
 * >**_NOTE:_** some tags that are not defined in the proper CBOR specification are automaticaly treated as PlutusData
 */
var Cbor = /** @class */ (function () {
    function Cbor() {
    }
    ; // static class, working as namespace
    Cbor.encode = function (cborObj) {
        var encoded = new CborEncoding();
        encoded.appendCborObjEncoding(cborObj);
        // .bytes is a getter, call once
        var bytes = encoded.bytes;
        // point the sub cbor refs to the final bytes
        // (forget intermediate results)
        (0, overwriteSubCborRefBytes_1.overwriteSubCborRefBytes)(cborObj, bytes);
        return new CborString_1.CborString(bytes);
    };
    Cbor.parse = function (cbor, parseOpts) {
        if (parseOpts === void 0) { parseOpts = exports.defaultParseOptions; }
        return Cbor.parseWithOffset(cbor, parseOpts).parsed;
    };
    Cbor.parseWithOffset = function (cbor, parseOpts) {
        var _a;
        if (parseOpts === void 0) { parseOpts = exports.defaultParseOptions; }
        if (typeof cbor === "string")
            cbor = (0, uint8array_utils_1.fromHex)(cbor);
        (0, assert_1.assert)((cbor instanceof Uint8Array) || cbor instanceof CborString_1.CborString, "in 'Cbor.parse' expected an instance of 'CborString' or a 'Uint8Array' as input; got: " + cbor);
        var bytes = cbor instanceof CborString_1.CborString ?
            cbor.toBuffer() :
            cbor;
        var keepRef = Boolean((_a = parseOpts.keepRef) !== null && _a !== void 0 ? _a : exports.defaultParseOptions.keepRef);
        /**
         * number of bytes red
         * */
        var offset = 0;
        var getSubCborRef = (keepRef ?
            function (startOffset) { return new SubCborRef_1.SubCborRef({
                _bytes: bytes,
                start: startOffset,
                end: offset
            }); }
            : function (_) { return undefined; });
        function incrementOffsetBy(l) {
            offset += l;
        }
        function getBytesOfLength(l) {
            if (bytes.length < offset + l)
                throw new errors_1.CborParseError("not enoug bytes; missing at least " +
                    ((offset + l) - bytes.length) + " bytes");
            incrementOffsetBy(l);
            return bytes.slice(offset - l, // offset has been incremented prior reading
            offset);
        }
        function getUInt8() {
            incrementOffsetBy(1);
            return (0, uint8array_utils_1.readUInt8)(bytes, offset - 1 // offset has been incremented prior reading
            );
        }
        ;
        function getUInt16() {
            incrementOffsetBy(2);
            return (0, uint8array_utils_1.readUInt16BE)(bytes, offset - 2 // offset has been incremented prior reading
            );
        }
        ;
        function getUInt32() {
            incrementOffsetBy(4);
            return (0, uint8array_utils_1.readUInt32BE)(bytes, offset - 4 // offset has been incremented prior reading
            );
        }
        ;
        function getUInt64() {
            incrementOffsetBy(8);
            return (0, uint8array_utils_1.readBigUInt64BE)(bytes, offset - 8 // offset has been incremented prior reading
            );
        }
        ;
        function getFloat16() {
            // increments the offset here
            var floatBits = getUInt16();
            var tempArrayBuffer = new ArrayBuffer(4);
            var tempDataView = new DataView(tempArrayBuffer);
            var sign = floatBits & 32768;
            var exponent = floatBits & 31744;
            var fraction = floatBits & 1023;
            if (exponent === 0x7c00)
                exponent = 0xff << 10;
            else if (exponent !== 0)
                exponent += (127 - 15) << 10;
            else if (fraction !== 0)
                return new CborSimple_1.CborSimple((sign !== 0 ? -1 : 1) * fraction * 5.960464477539063e-8, "float");
            tempDataView.setUint32(0, sign << 16 | exponent << 13 | fraction << 13);
            return new CborSimple_1.CborSimple(tempDataView.getFloat32(0), "float");
        }
        function getFloat32() {
            incrementOffsetBy(4);
            return new CborSimple_1.CborSimple((0, uint8array_utils_1.readFloat32BE)(bytes, offset - 4 // offset has been incremented prior reading
            ), "float");
        }
        function getFloat64() {
            incrementOffsetBy(8);
            return new CborSimple_1.CborSimple((0, uint8array_utils_1.readFloat64BE)(bytes, offset - 8 // offset has been incremented prior reading
            ), "float");
        }
        /**
         *  if the next byte is a break, it increments the offset and returns true
         *  otherwise returns false without side effects
         */
        function skipBreak() {
            if ((0, uint8array_utils_1.readUInt8)(bytes, offset) !== 0xff)
                return false;
            incrementOffsetBy(1);
            return true;
        }
        /*
        function skipBreak(): boolean
        {
            const isBreak = readUInt8( bytes, offset ) === 0xff;
            if( isBreak ) incrementOffsetBy( 1 );
            return isBreak;
        }
        */
        function getLength(addInfos) {
            if (addInfos < 24)
                return BigInt(addInfos);
            if (addInfos === 24)
                return BigInt(getUInt8());
            if (addInfos === 25)
                return BigInt(getUInt16());
            if (addInfos === 26)
                return BigInt(getUInt32());
            if (addInfos === 27)
                return getUInt64();
            if (addInfos === 31)
                return BigInt(-1); // indefinite length element follows
            throw new BaseCborError_1.BaseCborError("Invalid length encoding while parsing CBOR");
        }
        /*
        function getIndefiniteElemLengthOfType( majorType: MajorType ): bigint
        {
            const headerByte = getUInt8();

            if( headerByte === 0xff ) // break indefinite
                return BigInt( -1 );
            
            const elemLength = getLength( headerByte & 0b000_11111 );

            if( elemLength <  0 || (headerByte >> 5 !== majorType ) )
                throw new BaseCborError( "unexpected nested indefinite length element" );

            return elemLength;
        }
        //*/
        function getTextOfLength(l) {
            // increments offset while getting the bytes
            return (0, uint8array_utils_1.toUtf8)(getBytesOfLength(l));
        }
        function parseCborObj() {
            var startOffset = offset;
            var headerByte = getUInt8();
            var major = headerByte >> 5;
            var addInfos = headerByte & 31;
            if (major === Constants_1.MajorType.float_or_simple) {
                if (addInfos === 25)
                    return getFloat16();
                if (addInfos === 26)
                    return getFloat32();
                if (addInfos === 27)
                    return getFloat64();
            }
            var length = getLength(addInfos);
            if (length < 0 &&
                (major < 2 || major > 6)) {
                throw new BaseCborError_1.BaseCborError("unexpected indefinite length element while parsing CBOR");
            }
            switch (major) {
                case Constants_1.MajorType.unsigned: {
                    return new CborUInt_1.CborUInt(length, addInfos, undefined, // bigNumEncoding
                    getSubCborRef(startOffset));
                }
                case Constants_1.MajorType.negative: {
                    return new CborNegInt_1.CborNegInt(-BigInt(1) - length, addInfos, undefined, // bigNumEncoding
                    getSubCborRef(startOffset));
                }
                case Constants_1.MajorType.bytes: {
                    // data in UPLC v1.*.* serializes as indefinite length
                    // indefinie length
                    if (length < 0) {
                        var chunks = [];
                        var elem = void 0;
                        while (!skipBreak()) {
                            elem = parseCborObj();
                            if (!(elem instanceof CborBytes_1.CborBytes)) {
                                throw new BaseCborError_1.BaseCborError("unexpected indefinite length element while parsing indefinite length bytes");
                            }
                            chunks.push(elem);
                        }
                        return new CborBytes_1.CborBytes(chunks, addInfos, getSubCborRef(startOffset));
                    }
                    // definite length
                    return new CborBytes_1.CborBytes(getBytesOfLength(Number(length)), addInfos, getSubCborRef(startOffset));
                }
                case Constants_1.MajorType.text: {
                    if (length < 0) // indefinite length
                     {
                        var chunks = [];
                        var elem = void 0;
                        while (!skipBreak()) {
                            elem = parseCborObj();
                            if (!(elem instanceof CborText_1.CborText)) {
                                console.dir(elem, { depth: Infinity });
                                throw new BaseCborError_1.BaseCborError("unexpected indefinite length element while parsing indefinite length text");
                            }
                            chunks.push(elem);
                        }
                        return new CborText_1.CborText(chunks, addInfos, getSubCborRef(startOffset));
                    }
                    return new CborText_1.CborText(getTextOfLength(Number(length)), addInfos, getSubCborRef(startOffset));
                }
                case Constants_1.MajorType.array: {
                    var arrOfCbors = void 0;
                    if (length < 0) {
                        arrOfCbors = [];
                        while (!skipBreak()) {
                            arrOfCbors.push(parseCborObj());
                        }
                    }
                    else {
                        arrOfCbors = new Array(Number(length));
                        for (var i = 0; i < length; i++) {
                            arrOfCbors[i] = parseCborObj();
                        }
                    }
                    return new CborArray_1.CborArray(arrOfCbors, { indefinite: length < 0, addInfos: addInfos }, getSubCborRef(startOffset));
                }
                case Constants_1.MajorType.map: {
                    var entries = void 0;
                    if (length < 0) {
                        entries = [];
                        while (!skipBreak()) {
                            entries.push({
                                k: parseCborObj(),
                                v: parseCborObj()
                            });
                        }
                    }
                    else {
                        entries = new Array(Number(length));
                        for (var i = 0; i < length; i++) {
                            entries[i] = {
                                k: parseCborObj(),
                                v: parseCborObj()
                            };
                        }
                    }
                    return new CborMap_1.CborMap(entries, { indefinite: length < 0, addInfos: addInfos }, getSubCborRef(startOffset));
                }
                case Constants_1.MajorType.tag: {
                    var l = Number(length);
                    var data = parseCborObj();
                    // https://www.rfc-editor.org/rfc/rfc8949.html#name-bignums
                    if (l === 2 && data instanceof CborBytes_1.CborBytes) {
                        return CborUInt_1.CborUInt.bigNum(data, getSubCborRef(startOffset));
                    }
                    // https://www.rfc-editor.org/rfc/rfc8949.html#name-bignums
                    else if (l === 3 && data instanceof CborBytes_1.CborBytes) {
                        return CborNegInt_1.CborNegInt.bigNum(data, getSubCborRef(startOffset));
                    }
                    // else just tag
                    return new CborTag_1.CborTag(l, data);
                }
                case Constants_1.MajorType.float_or_simple: {
                    var nLen = Number(length);
                    var subCborRef = getSubCborRef(startOffset);
                    if (nLen === 20)
                        return new CborSimple_1.CborSimple(false, undefined, subCborRef); // 0xf4
                    if (nLen === 21)
                        return new CborSimple_1.CborSimple(true, undefined, subCborRef); // 0xf5
                    if (nLen === 22)
                        return new CborSimple_1.CborSimple(null, undefined, subCborRef); // 0xf6
                    if (nLen === 23)
                        return new CborSimple_1.CborSimple(undefined, undefined, subCborRef); // 0xf7
                    // floats handled at the beginning of the function
                    // since length isn't required
                    throw new BaseCborError_1.BaseCborError("unrecognized simple value");
                }
                default:
                    throw new BaseCborError_1.BaseCborError("unrecognized majorType: " + major);
            }
        }
        return { parsed: parseCborObj(), offset: offset };
    };
    Cbor.parseLazy = function (cbor) {
        return Cbor.parseLazyWithOffset(cbor).parsed;
    };
    Cbor.parseLazyWithOffset = function (cbor) {
        if (typeof cbor === "string")
            cbor = (0, uint8array_utils_1.fromHex)(cbor);
        (0, assert_1.assert)((cbor instanceof Uint8Array) || CborString_1.CborString.isStrictInstance(cbor), "in 'Cbor.parse' expected an instance of 'CborString' or a 'Uint8Array' as input; got: " + cbor);
        var bytes = cbor instanceof CborString_1.CborString ?
            cbor.toBuffer() :
            cbor;
        /**
         * number of bytes red
         * */
        var offset = 0;
        function incrementOffsetBy(l) {
            offset += l;
        }
        function getBytesOfLength(l) {
            if (bytes.length < offset + l)
                throw new errors_1.CborParseError("not enoug bytes; missing at least " +
                    ((offset + l) - bytes.length) + " bytes");
            incrementOffsetBy(l);
            return bytes.slice(offset - l, // offset has been incremented prior reading
            offset);
        }
        function getUInt8() {
            incrementOffsetBy(1);
            return (0, uint8array_utils_1.readUInt8)(bytes, offset - 1 // offset has been incremented prior reading
            );
        }
        ;
        function getUInt16() {
            incrementOffsetBy(2);
            return (0, uint8array_utils_1.readUInt16BE)(bytes, offset - 2 // offset has been incremented prior reading
            );
        }
        ;
        function getUInt32() {
            incrementOffsetBy(4);
            return (0, uint8array_utils_1.readUInt32BE)(bytes, offset - 4 // offset has been incremented prior reading
            );
        }
        ;
        function getUInt64() {
            incrementOffsetBy(8);
            return (0, uint8array_utils_1.readBigUInt64BE)(bytes, offset - 8 // offset has been incremented prior reading
            );
        }
        ;
        function getFloat16() {
            // increments the offset here
            var floatBits = getUInt16();
            var tempArrayBuffer = new ArrayBuffer(4);
            var tempDataView = new DataView(tempArrayBuffer);
            var sign = floatBits & 32768;
            var exponent = floatBits & 31744;
            var fraction = floatBits & 1023;
            if (exponent === 0x7c00)
                exponent = 0xff << 10;
            else if (exponent !== 0)
                exponent += (127 - 15) << 10;
            else if (fraction !== 0)
                return new CborSimple_1.CborSimple((sign !== 0 ? -1 : 1) * fraction * 5.960464477539063e-8, "float");
            tempDataView.setUint32(0, sign << 16 | exponent << 13 | fraction << 13);
            return new CborSimple_1.CborSimple(tempDataView.getFloat32(0), "float");
        }
        function getFloat32() {
            incrementOffsetBy(4);
            return new CborSimple_1.CborSimple((0, uint8array_utils_1.readFloat32BE)(bytes, offset - 4 // offset has been incremented prior reading
            ), "float");
        }
        function getFloat64() {
            incrementOffsetBy(8);
            return new CborSimple_1.CborSimple((0, uint8array_utils_1.readFloat64BE)(bytes, offset - 8 // offset has been incremented prior reading
            ), "float");
        }
        function skipBreak() {
            if ((0, uint8array_utils_1.readUInt8)(bytes, offset) !== 0xff)
                return false;
            incrementOffsetBy(1);
            return true;
        }
        function getLength(addInfos) {
            if (addInfos < 24)
                return BigInt(addInfos);
            if (addInfos === 24)
                return BigInt(getUInt8());
            if (addInfos === 25)
                return BigInt(getUInt16());
            if (addInfos === 26)
                return BigInt(getUInt32());
            if (addInfos === 27)
                return getUInt64();
            if (addInfos === 31)
                return BigInt(-1); // indefinite length element follows
            throw new BaseCborError_1.BaseCborError("Invalid length encoding while parsing CBOR");
        }
        function getIndefiniteElemLengthOfType(majorType) {
            var headerByte = getUInt8();
            if (headerByte === 0xff) // break indefinite
                return BigInt(-1);
            var elemLength = getLength(headerByte & 31);
            if (elemLength < 0 || (headerByte >> 5 !== majorType))
                throw new BaseCborError_1.BaseCborError("unexpected nested indefinite length element");
            return elemLength;
        }
        function getTextOfLength(l) {
            // increments offset while getting the bytes
            return (0, uint8array_utils_1.toUtf8)(getBytesOfLength(l));
        }
        function getNextElemBytes() {
            var elemStart = offset;
            var headerByte = getUInt8();
            var major = headerByte >> 5;
            var addInfos = headerByte & 31;
            if (major === Constants_1.MajorType.float_or_simple) {
                if (addInfos === 25)
                    return bytes.slice(elemStart, elemStart + 2);
                if (addInfos === 26)
                    return bytes.slice(elemStart, elemStart + 3);
                if (addInfos === 27)
                    return bytes.slice(elemStart, elemStart + 5);
            }
            var preLenOffset = offset;
            var length = getLength(addInfos);
            var postLenOffset = offset;
            if (length < 0 &&
                (major < 2 || major > 6)) {
                throw new BaseCborError_1.BaseCborError("unexpected indefinite length element while parsing CBOR");
            }
            switch (major) {
                case Constants_1.MajorType.unsigned: return bytes.slice(elemStart, postLenOffset);
                case Constants_1.MajorType.negative: return bytes.slice(elemStart, postLenOffset);
                case Constants_1.MajorType.bytes:
                    if (length < 0) // data in UPLC v1.*.* serializes as indefinite length
                     {
                        var elementLength = void 0;
                        while ((elementLength = getIndefiniteElemLengthOfType(major)) >= 0) {
                            // this operation is done when calling
                            // `getBytesOfLength( Number( elementLength )`
                            /// in the non-lazy verision
                            incrementOffsetBy(Number(elementLength));
                        }
                        return bytes.slice(elemStart, offset);
                    }
                    // definite length
                    // void getBytesOfLength( Number( length ) )
                    incrementOffsetBy(Number(length)); // this is the only part we need of the above function
                    return bytes.slice(elemStart, offset);
                case Constants_1.MajorType.text:
                    if (length < 0) // indefinite length
                     {
                        var str = "";
                        var l = 0;
                        while ((l = Number(getIndefiniteElemLengthOfType(Constants_1.MajorType.text))) >= 0) {
                            // str += getTextOfLength( l );
                            incrementOffsetBy(l);
                        }
                        return bytes.slice(elemStart, offset);
                    }
                    // void getTextOfLength( Number( length ) );
                    incrementOffsetBy(Number(length)); // this is the only part we need of the above function
                    return bytes.slice(elemStart, offset);
                case Constants_1.MajorType.array:
                    if (length < 0) {
                        while (!skipBreak()) {
                            void getNextElemBytes();
                        }
                    }
                    else {
                        for (var i = 0; i < length; i++) {
                            void getNextElemBytes();
                        }
                    }
                    return bytes.slice(elemStart, offset);
                case Constants_1.MajorType.map:
                    if (length < 0) {
                        while (!skipBreak()) {
                            void getNextElemBytes();
                            void getNextElemBytes();
                        }
                    }
                    else {
                        for (var i = 0; i < length; i++) {
                            void getNextElemBytes();
                            void getNextElemBytes();
                        }
                    }
                    return bytes.slice(elemStart, offset);
                case Constants_1.MajorType.tag:
                    void getNextElemBytes();
                    return bytes.slice(elemStart, offset);
                case Constants_1.MajorType.float_or_simple:
                    var nLen = Number(length);
                    if (nLen === 20)
                        return bytes.slice(elemStart, offset); // 0xf4
                    if (nLen === 21)
                        return bytes.slice(elemStart, offset); // 0xf5
                    if (nLen === 22)
                        return bytes.slice(elemStart, offset); // 0xf6
                    if (nLen === 23)
                        return bytes.slice(elemStart, offset); // 0xf7
                    // floats handled at the beginning of the function
                    // since length isn't required
                    throw new BaseCborError_1.BaseCborError("unrecognized simple value");
                default:
                    throw new BaseCborError_1.BaseCborError("unrecognized majorType: " + major);
            }
        }
        function parseCborObj() {
            var headerByte = getUInt8();
            var major = headerByte >> 5;
            var addInfos = headerByte & 31;
            if (major === Constants_1.MajorType.float_or_simple) {
                if (addInfos === 25)
                    return getFloat16();
                if (addInfos === 26)
                    return getFloat32();
                if (addInfos === 27)
                    return getFloat64();
            }
            var length = getLength(addInfos);
            if (length < 0 &&
                (major < 2 || major > 6)) {
                throw new BaseCborError_1.BaseCborError("unexpected indefinite length element while parsing CBOR");
            }
            switch (major) {
                case Constants_1.MajorType.unsigned: return new CborUInt_1.CborUInt(length, addInfos);
                case Constants_1.MajorType.negative: {
                    return new CborNegInt_1.CborNegInt(-BigInt(1) - length, addInfos);
                }
                case Constants_1.MajorType.bytes: {
                    // data in UPLC v1.*.* serializes as indefinite length
                    // indefinie length
                    if (length < 0) {
                        var chunks = [];
                        var elem = void 0;
                        while (!skipBreak()) {
                            elem = parseCborObj();
                            if (!(elem instanceof CborBytes_1.CborBytes)) {
                                throw new BaseCborError_1.BaseCborError("unexpected indefinite length element while parsing indefinite length bytes");
                            }
                            chunks.push(elem);
                        }
                        return new CborBytes_1.CborBytes(chunks, addInfos);
                    }
                    // definite length
                    return new CborBytes_1.CborBytes(getBytesOfLength(Number(length)), addInfos);
                }
                case Constants_1.MajorType.text: {
                    if (length < 0) // indefinite length
                     {
                        var chunks = [];
                        var elem = void 0;
                        while (!skipBreak()) {
                            elem = parseCborObj();
                            if (!(elem instanceof CborText_1.CborText)) {
                                console.dir(elem, { depth: Infinity });
                                throw new BaseCborError_1.BaseCborError("unexpected indefinite length element while parsing indefinite length text");
                            }
                            chunks.push(elem);
                        }
                        return new CborText_1.CborText(chunks, addInfos);
                    }
                    return new CborText_1.CborText(getTextOfLength(Number(length)), addInfos);
                }
                case Constants_1.MajorType.array: {
                    if (length < 0) {
                        var arr = [];
                        while (!skipBreak()) {
                            arr.push(getNextElemBytes());
                        }
                        return new LazyCborArray_1.LazyCborArray(arr, { indefinite: true, addInfos: addInfos });
                    }
                    else {
                        var arr = new Array(Number(length));
                        for (var i = 0; i < length; i++) {
                            arr[i] = getNextElemBytes();
                        }
                        return new LazyCborArray_1.LazyCborArray(arr, { indefinite: false, addInfos: addInfos });
                    }
                }
                case Constants_1.MajorType.map: {
                    if (length < 0) {
                        var entries = [];
                        while (!skipBreak()) {
                            entries.push({
                                k: getNextElemBytes(),
                                v: getNextElemBytes()
                            });
                        }
                        return new LazyCborMap_1.LazyCborMap(entries, { indefinite: true, addInfos: addInfos });
                    }
                    else {
                        var entries = new Array(Number(length));
                        for (var i = 0; i < length; i++) {
                            entries[i] = {
                                k: getNextElemBytes(),
                                v: getNextElemBytes()
                            };
                        }
                        return new LazyCborMap_1.LazyCborMap(entries, { indefinite: true, addInfos: addInfos });
                    }
                }
                case Constants_1.MajorType.tag:
                    return new LazyCborTag_1.LazyCborTag(Number(length), parseCborObj());
                case Constants_1.MajorType.float_or_simple:
                    var nLen = Number(length);
                    if (nLen === 20)
                        return new CborSimple_1.CborSimple(false); // 0xf4
                    if (nLen === 21)
                        return new CborSimple_1.CborSimple(true); // 0xf5
                    if (nLen === 22)
                        return new CborSimple_1.CborSimple(null); // 0xf6
                    if (nLen === 23)
                        return new CborSimple_1.CborSimple(undefined); // 0xf7
                    // floats handled at the beginning of the function
                    // since length isn't required
                    throw new BaseCborError_1.BaseCborError("unrecognized simple value");
                default:
                    throw new BaseCborError_1.BaseCborError("unrecognized majorType: " + major);
            }
        }
        return { parsed: parseCborObj(), offset: offset };
    };
    return Cbor;
}());
exports.Cbor = Cbor;


/***/ }),

/***/ 37286:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.overwriteSubCborRefBytes = void 0;
var CborObj_1 = __webpack_require__(85579);
var SubCborRef_1 = __webpack_require__(15205);
function overwriteSubCborRefBytes(cObj, bytes) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    if (!(cObj.subCborRef instanceof SubCborRef_1.SubCborRef))
        return;
    if (cObj instanceof CborObj_1.CborText &&
        typeof cObj.chunks !== "string") {
        try {
            for (var _e = __values(cObj.chunks), _f = _e.next(); !_f.done; _f = _e.next()) {
                var chunk = _f.value;
                overwriteSubCborRefBytes(chunk, bytes);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    if (cObj instanceof CborObj_1.CborBytes &&
        !(cObj.chunks instanceof Uint8Array)) {
        try {
            for (var _g = __values(cObj.chunks), _h = _g.next(); !_h.done; _h = _g.next()) {
                var chunk = _h.value;
                overwriteSubCborRefBytes(chunk, bytes);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    if (cObj instanceof CborObj_1.CborTag) {
        overwriteSubCborRefBytes(cObj.data, bytes);
    }
    if ((cObj instanceof CborObj_1.CborUInt || cObj instanceof CborObj_1.CborNegInt) &&
        cObj.bigNumEncoding instanceof CborObj_1.CborBytes) {
        overwriteSubCborRefBytes(cObj.bigNumEncoding, bytes);
    }
    if (cObj instanceof CborObj_1.CborMap) {
        try {
            for (var _j = __values(cObj.map), _k = _j.next(); !_k.done; _k = _j.next()) {
                var _l = _k.value, k = _l.k, v = _l.v;
                overwriteSubCborRefBytes(k, bytes);
                overwriteSubCborRefBytes(v, bytes);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            }
            finally { if (e_3) throw e_3.error; }
        }
    }
    if (cObj instanceof CborObj_1.CborArray) {
        try {
            for (var _m = __values(cObj.array), _o = _m.next(); !_o.done; _o = _m.next()) {
                var elem = _o.value;
                overwriteSubCborRefBytes(elem, bytes);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
            }
            finally { if (e_4) throw e_4.error; }
        }
    }
    cObj.subCborRef._bytes = bytes;
}
exports.overwriteSubCborRefBytes = overwriteSubCborRefBytes;


/***/ }),

/***/ 34427:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CborArray = exports.isRawCborArray = void 0;
var CborObj_1 = __webpack_require__(53429);
var assert_1 = __webpack_require__(32159);
var headerFollowingToAddInfos_1 = __webpack_require__(28328);
function isRawCborArray(arr) {
    if (typeof arr !== "object")
        return false;
    var keys = Object.keys(arr);
    return (keys.includes("array") &&
        Array.isArray(arr.array) &&
        arr.array.every(CborObj_1.isRawCborObj));
}
exports.isRawCborArray = isRawCborArray;
var defaultOpts = Object.freeze({
    indefinite: false,
    addInfos: 0
});
var CborArray = /** @class */ (function () {
    function CborArray(array, options, subCborRef) {
        var _a;
        this.subCborRef = subCborRef;
        (0, assert_1.assert)(Array.isArray(array) &&
            array.every(CborObj_1.isCborObj), "in 'CborArray' constructor: invalid input; got: " + array);
        var indefinite = (options === null || options === void 0 ? void 0 : options.indefinite) === true ? true : defaultOpts.indefinite;
        this.addInfos = (_a = options === null || options === void 0 ? void 0 : options.addInfos) !== null && _a !== void 0 ? _a : (0, headerFollowingToAddInfos_1.headerFollowingToAddInfos)(array.length);
        this.array = array;
        this.indefinite = indefinite === true;
    }
    CborArray.prototype.toRawObj = function () {
        return {
            array: this.array.map(function (cborObj) { return cborObj.toRawObj(); }),
            options: this.indefinite === true ? {
                indefinite: this.indefinite
            } : undefined
        };
    };
    CborArray.prototype.clone = function () {
        var _a;
        return new CborArray(this.array.map(function (elem) { return elem.clone(); }), { indefinite: this.indefinite, addInfos: this.addInfos }, (_a = this.subCborRef) === null || _a === void 0 ? void 0 : _a.clone());
    };
    return CborArray;
}());
exports.CborArray = CborArray;


/***/ }),

/***/ 77665:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CborBytes = exports.isRawCborBytes = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var headerFollowingToAddInfos_1 = __webpack_require__(28328);
function isRawCborBytes(b) {
    if (typeof b !== "object" || b === null)
        return false;
    var keys = Object.keys(b);
    return (keys.includes("bytes") &&
        (0, uint8array_utils_1.isUint8Array)(b.bytes));
}
exports.isRawCborBytes = isRawCborBytes;
var CborBytes = /** @class */ (function () {
    function CborBytes(bytes, addInfos, subCborRef) {
        this.subCborRef = subCborRef;
        this.chunks = bytes;
        this.addInfos = addInfos !== null && addInfos !== void 0 ? addInfos : (0, headerFollowingToAddInfos_1.headerFollowingToAddInfos)(this.bytes.length);
    }
    Object.defineProperty(CborBytes.prototype, "buffer", {
        /** @deprecated use `bytes` instead */
        get: function () { return this.bytes; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CborBytes.prototype, "bytes", {
        /**
         * concatenates all the chunks
         * returns
         **/
        get: function () {
            if (this.chunks instanceof Uint8Array)
                return Uint8Array.prototype.slice.call(this.chunks);
            return uint8array_utils_1.concatUint8Array.apply(void 0, __spreadArray([], __read(this.chunks.map(function (ch) { return ch.bytes; })), false));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CborBytes.prototype, "isDefiniteLength", {
        get: function () {
            return this.chunks instanceof Uint8Array;
        },
        enumerable: false,
        configurable: true
    });
    CborBytes.prototype.toRawObj = function () {
        return {
            bytes: Uint8Array.prototype.slice.call(this.bytes)
        };
    };
    CborBytes.prototype.clone = function () {
        var _a;
        return new CborBytes(this.chunks instanceof Uint8Array ? this.chunks : this.chunks.map(function (ch) { return ch.clone(); }), this.addInfos, (_a = this.subCborRef) === null || _a === void 0 ? void 0 : _a.clone());
    };
    return CborBytes;
}());
exports.CborBytes = CborBytes;


/***/ }),

/***/ 80368:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CborMap = exports.isRawCborMap = void 0;
var obj_utils_1 = __webpack_require__(37426);
var _1 = __webpack_require__(85579);
var headerFollowingToAddInfos_1 = __webpack_require__(28328);
var assert_1 = __webpack_require__(32159);
var defaultOpts = Object.freeze({
    indefinite: false,
    addInfos: undefined
});
function isRawCborMap(m) {
    if (typeof m !== "object" || m === null)
        return false;
    var keys = Object.keys(m);
    return (keys.includes("map") &&
        Array.isArray(m.map) &&
        m.map.every(function (entry) {
            if (typeof entry !== "object" || entry === null)
                return false;
            var entryKeys = Object.keys(entry);
            return (entryKeys.includes("k") &&
                (0, _1.isRawCborObj)(entry.k) &&
                entryKeys.includes("v") &&
                (0, _1.isRawCborObj)(entry.v));
        }));
}
exports.isRawCborMap = isRawCborMap;
var CborMap = /** @class */ (function () {
    function CborMap(map, options, subCborRef) {
        var _a;
        this.subCborRef = subCborRef;
        (0, assert_1.assert)(Array.isArray(map) &&
            map.every(function (entry) { return ((0, obj_utils_1.isObject)(entry) &&
                (0, _1.isCborObj)(entry.k) &&
                (0, _1.isCborObj)(entry.v)); }), "in 'CborMap' constructor: invalid input; got: " + map);
        var indefinite = (options === null || options === void 0 ? void 0 : options.indefinite) === true ? true : defaultOpts.indefinite;
        this.addInfos = (_a = options === null || options === void 0 ? void 0 : options.addInfos) !== null && _a !== void 0 ? _a : (0, headerFollowingToAddInfos_1.headerFollowingToAddInfos)(map.length);
        this.map = map;
        this.indefinite = indefinite === true;
    }
    CborMap.prototype.toRawObj = function () {
        return {
            map: this.map.map(function (entry) {
                return {
                    k: entry.k.toRawObj(),
                    v: entry.v.toRawObj()
                };
            }),
            options: {
                indefinite: this.indefinite
            }
        };
    };
    CborMap.prototype.clone = function () {
        var _a;
        return new CborMap(this.map.map(function (entry) { return ({
            k: entry.k.clone(),
            v: entry.v.clone()
        }); }), { indefinite: this.indefinite, addInfos: this.addInfos }, (_a = this.subCborRef) === null || _a === void 0 ? void 0 : _a.clone());
    };
    return CborMap;
}());
exports.CborMap = CborMap;


/***/ }),

/***/ 78581:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CborNegInt = exports.isRawCborNegative = void 0;
var assert_1 = __webpack_require__(32159);
var CborBytes_1 = __webpack_require__(77665);
var uint8array_utils_1 = __webpack_require__(44948);
var max_1 = __webpack_require__(34625);
var headerFollowingToAddInfos_1 = __webpack_require__(28328);
function isRawCborNegative(neg) {
    if (typeof neg !== "object" || neg === null)
        return false;
    var keys = Object.keys(neg);
    return (keys.includes("neg") &&
        typeof neg.neg === "bigint" &&
        neg.neg < 0);
}
exports.isRawCborNegative = isRawCborNegative;
var CborNegInt = /** @class */ (function () {
    function CborNegInt(neg, addInfos, bigNumEncoding, subCborRef) {
        this.subCborRef = subCborRef;
        if (typeof neg === "number")
            neg = BigInt(neg);
        this.num = neg;
        this.addInfos = addInfos !== null && addInfos !== void 0 ? addInfos : (0, headerFollowingToAddInfos_1.headerFollowingToAddInfos)(neg);
        // this.followingHeaderBytes = followingHeaderBytes;
        if (bigNumEncoding instanceof CborBytes_1.CborBytes)
            this.bigNumEncoding = bigNumEncoding;
        else
            this.bigNumEncoding = undefined;
    }
    Object.defineProperty(CborNegInt.prototype, "num", {
        get: function () {
            if (this.bigNumEncoding instanceof CborBytes_1.CborBytes) {
                this._num = -(BigInt("0x" +
                    (0, uint8array_utils_1.toHex)(this.bigNumEncoding.bytes)) + BigInt(1));
            }
            return this._num;
        },
        set: function (neg) {
            (0, assert_1.assert)(neg < 0, "neg CBOR numbers must be less than 0; got: " + neg);
            neg = BigInt(neg);
            // https://www.rfc-editor.org/rfc/rfc8949.html#name-bignums
            if (neg < max_1.minBigInt) {
                neg = BigInt(-1) - BigInt(neg);
                var hex = neg.toString(16);
                if ((hex.length % 2) === 1)
                    hex = "0" + hex;
                this.bigNumEncoding = new CborBytes_1.CborBytes((0, uint8array_utils_1.fromHex)(hex));
            }
            this._num = BigInt(neg);
        },
        enumerable: false,
        configurable: true
    });
    CborNegInt.prototype.isBigNum = function () {
        return this.bigNumEncoding instanceof CborBytes_1.CborBytes;
    };
    CborNegInt.bigNum = function (encoding, subCborRef) {
        if (typeof encoding === "number")
            encoding = BigInt(encoding);
        if (typeof encoding === "bigint" && encoding >= 0)
            encoding = -encoding; // ensure negative number
        var n = undefined;
        if (!(encoding instanceof CborBytes_1.CborBytes)) {
            n = encoding; // remember negative number
            encoding = BigInt(-1) - BigInt(encoding); // translate to positive so we can encode as bytes
            var hex = encoding.toString(16); // hex
            if ((hex.length % 2) === 1)
                hex = "0" + hex; // even length
            encoding = new CborBytes_1.CborBytes((0, uint8array_utils_1.fromHex)(hex)); // bytes
        }
        else {
            n = BigInt(-1) - BigInt("0x" + (0, uint8array_utils_1.toHex)(encoding.bytes));
        } // was bytes
        return new CborNegInt(n, 0, encoding, subCborRef);
    };
    CborNegInt.prototype.toRawObj = function () {
        return {
            neg: this.num
        };
    };
    CborNegInt.prototype.clone = function () {
        var _a, _b;
        return new CborNegInt(this.num, this.addInfos, (_a = this.bigNumEncoding) === null || _a === void 0 ? void 0 : _a.clone(), (_b = this.subCborRef) === null || _b === void 0 ? void 0 : _b.clone());
    };
    return CborNegInt;
}());
exports.CborNegInt = CborNegInt;


/***/ }),

/***/ 53429:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
Intermediate data type that allows an easier conversion from (and to) CBOR to (and from) JSON serializables objects
*/
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cborObjFromRaw = exports.isRawCborObj = exports.isCborObj = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var CborArray_1 = __webpack_require__(34427);
var CborBytes_1 = __webpack_require__(77665);
var CborMap_1 = __webpack_require__(80368);
var CborNegInt_1 = __webpack_require__(78581);
var CborSimple_1 = __webpack_require__(81853);
var CborTag_1 = __webpack_require__(41154);
var CborText_1 = __webpack_require__(92905);
var CborUInt_1 = __webpack_require__(24850);
var errors_1 = __webpack_require__(13020);
var assert_1 = __webpack_require__(32159);
function isCborObj(cborObj) {
    return (cborObj instanceof CborNegInt_1.CborNegInt ||
        cborObj instanceof CborUInt_1.CborUInt ||
        cborObj instanceof CborBytes_1.CborBytes ||
        cborObj instanceof CborText_1.CborText ||
        cborObj instanceof CborArray_1.CborArray ||
        cborObj instanceof CborMap_1.CborMap ||
        cborObj instanceof CborTag_1.CborTag ||
        cborObj instanceof CborSimple_1.CborSimple);
}
exports.isCborObj = isCborObj;
function isRawCborObj(rawCborObj) {
    if (typeof rawCborObj !== "object" || rawCborObj === null || Array.isArray(rawCborObj))
        return false;
    var keys = Object.keys(rawCborObj);
    if (keys.length <= 0)
        return false;
    if (keys.includes("array")) {
        return Array.isArray(rawCborObj.array) &&
            rawCborObj.array.every(isRawCborObj);
    }
    if (keys.includes("map")) {
        return Array.isArray(rawCborObj.map) &&
            rawCborObj.map.every(function (entry) { return isRawCborObj(entry.k) && isRawCborObj(entry.v); });
    }
    if (keys.includes("tag")) {
        return keys.includes("data") &&
            isRawCborObj(rawCborObj.data);
    }
    var includes = function (k) { return keys.includes(k); };
    return ((includes("neg") &&
        typeof rawCborObj.neg === "bigint" &&
        rawCborObj.neg < 0) ||
        (includes("uint") &&
            typeof rawCborObj.uint === "bigint" &&
            rawCborObj.uint >= 0) ||
        (includes("bytes") && (0, uint8array_utils_1.isUint8Array)(rawCborObj.bytes)) ||
        (includes("text") && typeof rawCborObj.text === "string") ||
        (includes("simple") && (0, CborSimple_1.isSimpleCborValue)(rawCborObj.simple)));
}
exports.isRawCborObj = isRawCborObj;
function cborObjFromRaw(_rawCborObj) {
    (0, assert_1.assert)(isRawCborObj(_rawCborObj), "expected a vaild 'RawCborObj' as input; got: " + Object.keys(_rawCborObj));
    function _cborObjFromRaw(rawCborObj) {
        if ((0, CborNegInt_1.isRawCborNegative)(rawCborObj))
            return new CborNegInt_1.CborNegInt(rawCborObj.neg);
        if ((0, CborUInt_1.isRawCborUnsigned)(rawCborObj))
            return new CborUInt_1.CborUInt(rawCborObj.uint);
        if ((0, CborBytes_1.isRawCborBytes)(rawCborObj))
            return new CborBytes_1.CborBytes(rawCborObj.bytes);
        if ((0, CborText_1.isRawCborText)(rawCborObj))
            return new CborText_1.CborText(rawCborObj.text);
        if ((0, CborArray_1.isRawCborArray)(rawCborObj))
            return new CborArray_1.CborArray(rawCborObj.array
                .map(_cborObjFromRaw), rawCborObj.options);
        if ((0, CborMap_1.isRawCborMap)(rawCborObj))
            return new CborMap_1.CborMap(rawCborObj.map
                .map(function (entry) {
                return {
                    k: _cborObjFromRaw(entry.k),
                    v: _cborObjFromRaw(entry.v)
                };
            }), rawCborObj.options);
        if ((0, CborTag_1.isRawCborTag)(rawCborObj))
            return new CborTag_1.CborTag(rawCborObj.tag, _cborObjFromRaw(rawCborObj.data));
        if ((0, CborSimple_1.isRawCborSimple)(rawCborObj))
            return new CborSimple_1.CborSimple(rawCborObj.simple);
        throw new errors_1.BaseCborError("'cborObjFromRaw' did not match any possible 'RawCborObj'");
    }
    return _cborObjFromRaw(_rawCborObj);
}
exports.cborObjFromRaw = cborObjFromRaw;


/***/ }),

/***/ 81853:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CborSimple = exports.isRawCborSimple = exports.isSimpleCborValue = void 0;
var obj_utils_1 = __webpack_require__(37426);
var assert_1 = __webpack_require__(32159);
function isSimpleCborValue(v) {
    var t = typeof v;
    return (v === null ||
        t === "boolean" ||
        t === "undefined" ||
        t === "number");
}
exports.isSimpleCborValue = isSimpleCborValue;
function isRawCborSimple(s) {
    if (typeof s !== "object" || s === null)
        return false;
    var keys = Object.keys(s);
    return (keys.includes("simple") &&
        isSimpleCborValue(s.simple));
}
exports.isRawCborSimple = isRawCborSimple;
var CborSimple = /** @class */ (function () {
    function CborSimple(simple, interpretNumAs, subCborRef) {
        this.subCborRef = subCborRef;
        if (interpretNumAs === undefined &&
            typeof simple === "number" &&
            simple >= 0 && simple <= 255 &&
            simple === Math.round(simple))
            interpretNumAs = "simple";
        if (interpretNumAs === undefined)
            interpretNumAs = "float";
        if (interpretNumAs === "simple") {
            (0, assert_1.assert)(typeof simple === "number" &&
                simple >= 0 && simple <= 255 &&
                simple === Math.round(simple), "invalid simple value");
        }
        (0, assert_1.assert)(isSimpleCborValue(simple), "invalid cbor simple value; received: " + simple);
        (0, obj_utils_1.defineReadOnlyProperty)(this, "simple", simple);
        (0, obj_utils_1.defineReadOnlyProperty)(this, "numAs", interpretNumAs);
    }
    CborSimple.prototype.toRawObj = function () {
        return {
            simple: this.simple
        };
    };
    CborSimple.prototype.clone = function () {
        var _a;
        return new CborSimple(this.simple, this.numAs, (_a = this.subCborRef) === null || _a === void 0 ? void 0 : _a.clone());
    };
    Object.defineProperty(CborSimple, "null", {
        get: function () {
            return new CborSimple(null);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CborSimple, "true", {
        get: function () {
            return new CborSimple(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CborSimple, "false", {
        get: function () {
            return new CborSimple(false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CborSimple, "undefined", {
        get: function () {
            return new CborSimple(undefined);
        },
        enumerable: false,
        configurable: true
    });
    CborSimple.simpleNumber = function (n) {
        if (typeof n !== "number")
            n = 0;
        return new CborSimple(n, "simple");
    };
    CborSimple.float = function (n) {
        if (typeof n !== "number")
            n = 0;
        return new CborSimple(n, "float");
    };
    return CborSimple;
}());
exports.CborSimple = CborSimple;


/***/ }),

/***/ 41154:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CborTag = exports.isRawCborTag = void 0;
var obj_utils_1 = __webpack_require__(37426);
var assert_1 = __webpack_require__(32159);
var ints_1 = __webpack_require__(10825);
var CborObj_1 = __webpack_require__(53429);
function isRawCborTag(t) {
    if (typeof t !== "object" || t === null)
        return false;
    var keys = Object.keys(t);
    return (keys.includes("tag") &&
        keys.includes("data") &&
        (0, ints_1.canBeUInteger)(t.tag) &&
        (0, CborObj_1.isRawCborObj)(t.data));
}
exports.isRawCborTag = isRawCborTag;
var CborTag = /** @class */ (function () {
    function CborTag(tag, data, subCborRef) {
        this.subCborRef = subCborRef;
        if (typeof tag === "number")
            tag = BigInt(tag);
        (0, assert_1.assert)(typeof tag === "bigint" &&
            (0, CborObj_1.isCborObj)(data), "using direct value constructor; either 'tag' is not a number or 'data' is missing");
        (0, obj_utils_1.defineReadOnlyProperty)(this, "tag", tag);
        (0, obj_utils_1.defineReadOnlyProperty)(this, "data", data);
    }
    CborTag.prototype.toRawObj = function () {
        return {
            tag: this.tag,
            data: this.data.toRawObj(),
        };
    };
    CborTag.prototype.clone = function () {
        var _a;
        return new CborTag(this.tag, this.data.clone(), (_a = this.subCborRef) === null || _a === void 0 ? void 0 : _a.clone());
    };
    return CborTag;
}());
exports.CborTag = CborTag;


/***/ }),

/***/ 92905:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CborText = exports.isRawCborText = void 0;
var headerFollowingToAddInfos_1 = __webpack_require__(28328);
function isRawCborText(t) {
    if (typeof t !== "object" || t === null)
        return false;
    var keys = Object.keys(t);
    return (keys.includes("text") &&
        typeof t.text === "string");
}
exports.isRawCborText = isRawCborText;
var CborText = /** @class */ (function () {
    function CborText(text, addInfos, subCborRef) {
        this.subCborRef = subCborRef;
        this.chunks = text;
        this.addInfos = addInfos !== null && addInfos !== void 0 ? addInfos : (0, headerFollowingToAddInfos_1.headerFollowingToAddInfos)(text.length);
    }
    Object.defineProperty(CborText.prototype, "text", {
        get: function () {
            if (typeof this.chunks === "string")
                return this.chunks;
            return this.chunks.reduce(function (accum, chunk) { return accum + chunk.text; }, "");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CborText.prototype, "isDefiniteLength", {
        get: function () {
            return typeof this.chunks === "string";
        },
        enumerable: false,
        configurable: true
    });
    CborText.prototype.toRawObj = function () {
        return {
            text: this.text
        };
    };
    CborText.prototype.clone = function () {
        var _a;
        return new CborText(typeof this.chunks === "string" ? this.chunks : this.chunks.map(function (chunk) { return chunk.clone(); }), this.addInfos, (_a = this.subCborRef) === null || _a === void 0 ? void 0 : _a.clone());
    };
    return CborText;
}());
exports.CborText = CborText;


/***/ }),

/***/ 24850:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CborUInt = exports.isRawCborUnsigned = void 0;
var assert_1 = __webpack_require__(32159);
var CborBytes_1 = __webpack_require__(77665);
var uint8array_utils_1 = __webpack_require__(44948);
var max_1 = __webpack_require__(34625);
var headerFollowingToAddInfos_1 = __webpack_require__(28328);
function isRawCborUnsigned(unsign) {
    if (typeof unsign !== "object" || unsign === null)
        return false;
    var keys = Object.keys(unsign);
    return (keys.includes("uint") &&
        typeof unsign.uint === "bigint" &&
        unsign.uint >= 0);
}
exports.isRawCborUnsigned = isRawCborUnsigned;
var CborUInt = /** @class */ (function () {
    function CborUInt(uint, addInfos, bigNumEncoding, subCborRef) {
        this.subCborRef = subCborRef;
        this.num = uint;
        this.addInfos = addInfos !== null && addInfos !== void 0 ? addInfos : (0, headerFollowingToAddInfos_1.headerFollowingToAddInfos)(uint);
        if (bigNumEncoding instanceof CborBytes_1.CborBytes)
            this.bigNumEncoding = bigNumEncoding;
        else
            this.bigNumEncoding = undefined;
    }
    Object.defineProperty(CborUInt.prototype, "num", {
        get: function () {
            if (this.bigNumEncoding instanceof CborBytes_1.CborBytes) {
                this._num = BigInt("0x" +
                    (0, uint8array_utils_1.toHex)(this.bigNumEncoding.bytes));
            }
            return this._num;
        },
        set: function (uint) {
            (0, assert_1.assert)(uint >= BigInt(0), "uint CBOR numbers must be greater or equal 0; got: " + uint);
            uint = BigInt(uint);
            if (uint > max_1.maxBigInt) {
                var hex = uint.toString(16);
                if ((hex.length % 2) === 1)
                    hex = "0" + hex;
                this.bigNumEncoding = new CborBytes_1.CborBytes((0, uint8array_utils_1.fromHex)(hex));
            }
            this._num = uint;
        },
        enumerable: false,
        configurable: true
    });
    CborUInt.prototype.isBigNum = function () {
        return this.bigNumEncoding instanceof CborBytes_1.CborBytes;
    };
    CborUInt.bigNum = function (encoding, subCborRef) {
        var n = undefined;
        if (!(encoding instanceof CborBytes_1.CborBytes)) {
            encoding = BigInt(encoding);
            n = encoding;
            var hex = encoding.toString(16);
            if ((hex.length % 2) === 1)
                hex = "0" + hex;
            encoding = new CborBytes_1.CborBytes((0, uint8array_utils_1.fromHex)(hex));
        }
        else {
            n = BigInt("0x" + (0, uint8array_utils_1.toHex)(encoding.bytes));
        }
        return new CborUInt(n, 0, encoding, subCborRef);
    };
    CborUInt.prototype.toRawObj = function () {
        return {
            uint: this.num
        };
    };
    CborUInt.prototype.clone = function () {
        var _a, _b;
        return new CborUInt(this.num, this.addInfos, (_a = this.bigNumEncoding) === null || _a === void 0 ? void 0 : _a.clone(), (_b = this.subCborRef) === null || _b === void 0 ? void 0 : _b.clone());
    };
    return CborUInt;
}());
exports.CborUInt = CborUInt;


/***/ }),

/***/ 85579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(34427), exports);
__exportStar(__webpack_require__(77665), exports);
__exportStar(__webpack_require__(80368), exports);
__exportStar(__webpack_require__(78581), exports);
__exportStar(__webpack_require__(81853), exports);
__exportStar(__webpack_require__(41154), exports);
__exportStar(__webpack_require__(92905), exports);
__exportStar(__webpack_require__(24850), exports);
__exportStar(__webpack_require__(49369), exports);
__exportStar(__webpack_require__(53429), exports);


/***/ }),

/***/ 10844:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 49369:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(10844), exports);


/***/ }),

/***/ 21794:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CborString = void 0;
var Cbor_1 = __webpack_require__(86934);
var bytestring_1 = __webpack_require__(86152);
var CborString = /** @class */ (function (_super) {
    __extends(CborString, _super);
    function CborString(cbor) {
        if (typeof cbor === "string") {
            cbor = cbor.split(" ").join("");
            // hex string length has to be even
            cbor = (cbor.length % 2) ? "0" + cbor : cbor;
        }
        return _super.call(this, cbor) || this;
    }
    CborString.isStrictInstance = function (cborStr) {
        return (cborStr !== undefined && cborStr !== null) && cborStr instanceof CborString;
    };
    CborString.fromCborObj = function (jsonCbor) {
        return Cbor_1.Cbor.encode(jsonCbor);
    };
    CborString.prototype.toCborObj = function () {
        return Cbor_1.Cbor.parse(this);
    };
    return CborString;
}(bytestring_1.ByteString));
exports.CborString = CborString;


/***/ }),

/***/ 26798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LazyCborArray = void 0;
var assert_1 = __webpack_require__(32159);
var defaultOpts = Object.freeze({
    indefinite: false,
    addInfos: 0
});
var LazyCborArray = /** @class */ (function () {
    function LazyCborArray(array, options) {
        (0, assert_1.assert)(Array.isArray(array) &&
            array.every(function (elem) { return elem instanceof Uint8Array; }), "in 'LazyCborArray' constructor: invalid input; got: " + array);
        var indefinite = __assign(__assign({}, defaultOpts), options).indefinite;
        var _array = array;
        Object.defineProperties(this, {
            array: {
                get: function () { return _array; },
                set: function (arr) {
                    if (Array.isArray(arr) &&
                        arr.every(function (elem) { return elem instanceof Uint8Array; })) {
                        _array = arr;
                    }
                },
                enumerable: true,
                configurable: false
            },
            indefinite: {
                value: indefinite,
                writable: false,
                enumerable: true,
                configurable: false
            }
        });
    }
    LazyCborArray.prototype.clone = function () {
        return new LazyCborArray(this.array.map(function (elem) { return Uint8Array.prototype.slice.call(elem); }), { indefinite: this.indefinite });
    };
    return LazyCborArray;
}());
exports.LazyCborArray = LazyCborArray;


/***/ }),

/***/ 61203:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LazyCborMap = exports.isLazyCborMapEntry = void 0;
var obj_utils_1 = __webpack_require__(37426);
var assert_1 = __webpack_require__(32159);
var defaultOpts = Object.freeze({
    indefinite: false,
    addInfos: undefined
});
function isLazyCborMapEntry(thing) {
    return (0, obj_utils_1.isObject)(thing) && ((0, obj_utils_1.hasOwn)(thing, "k") && thing.k instanceof Uint8Array &&
        (0, obj_utils_1.hasOwn)(thing, "v") && thing.v instanceof Uint8Array);
}
exports.isLazyCborMapEntry = isLazyCborMapEntry;
var LazyCborMap = /** @class */ (function () {
    function LazyCborMap(map, options) {
        (0, assert_1.assert)(Array.isArray(map) &&
            map.every(isLazyCborMapEntry), "in 'LazyCborMap' constructor: invalid input; got: " + map);
        var indefinite = __assign(__assign({}, defaultOpts), options).indefinite;
        var _map = map;
        Object.defineProperties(this, {
            array: {
                get: function () { return _map; },
                set: function (newMap) {
                    if (Array.isArray(newMap) &&
                        newMap.every(isLazyCborMapEntry)) {
                        _map = newMap;
                    }
                },
                enumerable: true,
                configurable: false
            },
            indefinite: {
                value: indefinite,
                writable: false,
                enumerable: true,
                configurable: false
            }
        });
    }
    LazyCborMap.prototype.clone = function () {
        return new LazyCborMap(this.map.map(function (_a) {
            var k = _a.k, v = _a.v;
            return ({
                k: Uint8Array.prototype.slice.call(k),
                v: Uint8Array.prototype.slice.call(v),
            });
        }), { indefinite: this.indefinite });
    };
    return LazyCborMap;
}());
exports.LazyCborMap = LazyCborMap;


/***/ }),

/***/ 45593:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isLazyCborObj = void 0;
var CborObj_1 = __webpack_require__(85579);
var LazyCborArray_1 = __webpack_require__(26798);
var LazyCborMap_1 = __webpack_require__(61203);
var LazyCborTag_1 = __webpack_require__(7122);
function isLazyCborObj(cborObj) {
    return (cborObj instanceof CborObj_1.CborNegInt ||
        cborObj instanceof CborObj_1.CborUInt ||
        cborObj instanceof CborObj_1.CborBytes ||
        cborObj instanceof CborObj_1.CborText ||
        cborObj instanceof LazyCborArray_1.LazyCborArray ||
        cborObj instanceof LazyCborMap_1.LazyCborMap ||
        cborObj instanceof LazyCborTag_1.LazyCborTag ||
        cborObj instanceof CborObj_1.CborSimple);
}
exports.isLazyCborObj = isLazyCborObj;


/***/ }),

/***/ 7122:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LazyCborTag = void 0;
var assert_1 = __webpack_require__(32159);
var LazyCborObj_1 = __webpack_require__(45593);
var LazyCborTag = /** @class */ (function () {
    function LazyCborTag(tag, data) {
        if (typeof tag === "number") {
            tag = BigInt(tag);
        }
        (0, assert_1.assert)(typeof tag === "bigint" &&
            (0, LazyCborObj_1.isLazyCborObj)(data), "using direct value constructor; either 'tag' is not a number or 'data' is not 'LazyCborObj'");
        var _tag = tag;
        var _data = data;
        Object.defineProperties(this, {
            tag: {
                get: function () { return _tag; },
                set: function (val) {
                    if (typeof tag === "number")
                        tag = BigInt(tag);
                    if (typeof tag === "bigint") {
                        _tag = tag;
                    }
                },
                enumerable: true,
                configurable: false
            },
            data: {
                get: function () { return _data; },
                set: function (val) {
                    if ((0, LazyCborObj_1.isLazyCborObj)(val)) {
                        _data = val;
                    }
                },
                enumerable: true,
                configurable: false
            }
        });
    }
    LazyCborTag.prototype.clone = function () {
        return new LazyCborTag(this.tag, this.data.clone());
    };
    return LazyCborTag;
}());
exports.LazyCborTag = LazyCborTag;


/***/ }),

/***/ 61783:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(26798), exports);
__exportStar(__webpack_require__(61203), exports);
__exportStar(__webpack_require__(45593), exports);
__exportStar(__webpack_require__(7122), exports);


/***/ }),

/***/ 15205:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SubCborRef = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var CborString_1 = __webpack_require__(21794);
var SubCborRef = /** @class */ (function (_super) {
    __extends(SubCborRef, _super);
    function SubCborRef(_a) {
        var _bytes = _a._bytes, start = _a.start, end = _a.end;
        var _this = _super.call(this, _bytes) || this;
        // super might have cloned `_bytes`, but in `SubCborRef` we want to keep the reference
        _this._bytes = _bytes;
        _this.start = start;
        _this.end = end;
        return _this;
    }
    SubCborRef.prototype.toString = function () {
        return (0, uint8array_utils_1.toHex)(this.toBuffer());
    };
    SubCborRef.prototype.toBuffer = function () {
        return Uint8Array.prototype.slice.call(this._bytes, this.start, this.end);
    };
    SubCborRef.prototype.clone = function () {
        return new SubCborRef({
            _bytes: this._bytes,
            start: this.start,
            end: this.end
        });
    };
    return SubCborRef;
}(CborString_1.CborString));
exports.SubCborRef = SubCborRef;


/***/ }),

/***/ 34625:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MAX_1_BYTE = exports.OVERFLOW_4_BYTES = exports.OVERFLOW_2_BYTES = exports.OVERFLOW_1_BYTE = exports.MAX_4_BYTES = exports.maxBigInt = exports.minBigInt = void 0;
/** Lowest value that can be encoded directly as (negative) integer */
exports.minBigInt = BigInt("-18446744073709551616"); // -(2n ** 64n)
/** Highest value that can be encoded directly as (positive) integer */
exports.maxBigInt = BigInt("18446744073709551615"); // (2n ** 64n) - 1n
exports.MAX_4_BYTES = 4294967295;
exports.OVERFLOW_1_BYTE = 0x100;
exports.OVERFLOW_2_BYTES = 0x10000;
exports.OVERFLOW_4_BYTES = 0x100000000;
exports.MAX_1_BYTE = 255;


/***/ }),

/***/ 62778:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CborParseError = void 0;
var _1 = __webpack_require__(66143);
var CborParseError = /** @class */ (function (_super) {
    __extends(CborParseError, _super);
    function CborParseError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CborParseError;
}(_1.BaseCborError));
exports.CborParseError = CborParseError;
;


/***/ }),

/***/ 66143:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BaseCborError = void 0;
var BaseCborError = /** @class */ (function (_super) {
    __extends(BaseCborError, _super);
    function BaseCborError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseCborError;
}(Error));
exports.BaseCborError = BaseCborError;
;


/***/ }),

/***/ 13020:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(66143), exports);
__exportStar(__webpack_require__(62778), exports);


/***/ }),

/***/ 93635:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CborPositiveRational = void 0;
var obj_utils_1 = __webpack_require__(37426);
var CborArray_1 = __webpack_require__(34427);
var CborTag_1 = __webpack_require__(41154);
var CborUInt_1 = __webpack_require__(24850);
var ints_1 = __webpack_require__(10825);
var CborPositiveRational = /** @class */ (function (_super) {
    __extends(CborPositiveRational, _super);
    function CborPositiveRational(num, den) {
        var _this = this;
        var _num = (0, ints_1.forceBigUInt)(num);
        var _den = (0, ints_1.forceBigUInt)(den);
        _this = _super.call(this, 30, new CborArray_1.CborArray([
            new CborUInt_1.CborUInt(_num),
            new CborUInt_1.CborUInt(_den)
        ])) || this;
        (0, obj_utils_1.defineReadOnlyProperty)(_this, "num", _num);
        (0, obj_utils_1.defineReadOnlyProperty)(_this, "den", _den);
        return _this;
    }
    CborPositiveRational.fromCborObjOrUndef = function (cObj) {
        return ((cObj instanceof CborTag_1.CborTag &&
            cObj.data instanceof CborArray_1.CborArray &&
            cObj.data.array[0] instanceof CborUInt_1.CborUInt &&
            cObj.data.array[1] instanceof CborUInt_1.CborUInt) ?
            new CborPositiveRational(cObj.data.array[0].num, cObj.data.array[1].num)
            : undefined);
    };
    CborPositiveRational.fromNumber = function (n) {
        var _a = __read(n.toString().split("."), 2), a = _a[0], b = _a[1];
        /**
         * b might be undefinded (eg. whole numbers)
         * @since patch 1.1.2
        **/
        if (!(typeof b === "string")) {
            return new CborPositiveRational(Number(a), 1);
        }
        return new CborPositiveRational(
        // `a + b` is string concatenation
        Number(a + b), Number("1e".concat(b.length)));
    };
    CborPositiveRational.prototype.toNumber = function () {
        return Number(this.num) / Number(this.den);
    };
    CborPositiveRational.prototype.valueOf = function () {
        return this.toNumber();
    };
    return CborPositiveRational;
}(CborTag_1.CborTag));
exports.CborPositiveRational = CborPositiveRational;


/***/ }),

/***/ 7123:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(93635), exports);
__exportStar(__webpack_require__(98620), exports);


/***/ }),

/***/ 98620:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.readCborTypeAndLength = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var Constants_1 = __webpack_require__(12992);
function readCborTypeAndLength(bytes) {
    if (bytes.length < 1)
        return undefined;
    var headerByte = bytes[0];
    var major = headerByte >> 5;
    var addInfos = headerByte & 31;
    if (major === Constants_1.MajorType.float_or_simple) {
        if (addInfos === 25) {
            var float = getFloat16(bytes);
            if (float === undefined)
                return undefined;
            return {
                type: major,
                length: float
            };
        }
        if (addInfos === 26) {
            var float = getFloat32(bytes);
            if (float === undefined)
                return undefined;
            return {
                type: major,
                length: float
            };
        }
        if (addInfos === 27) {
            var float = getFloat64(bytes);
            if (float === undefined)
                return undefined;
            return {
                type: major,
                length: float
            };
        }
        return {
            type: major,
            length: addInfos
        };
    }
    var length = getLength(addInfos, bytes);
    if (typeof length !== "bigint")
        return undefined;
    if (length < 0)
        return {
            type: major,
            length: undefined // indefinite length
        };
    else
        return {
            type: major,
            length: length
        };
    // if( length < 0 &&
    //     ( major < 2 || major > 6 )
    // )
    // {
    //     throw new BaseCborError( "unexpected indefinite length element while parsing CBOR" );
    // }
}
exports.readCborTypeAndLength = readCborTypeAndLength;
function getLength(addInfos, bytes) {
    if (addInfos < 24)
        return BigInt(addInfos);
    if (addInfos === 24) {
        if (bytes.length < 2)
            return undefined;
        return BigInt((0, uint8array_utils_1.readUint8)(bytes, 1));
    }
    if (addInfos === 25) {
        if (bytes.length < 3)
            return undefined;
        return BigInt((0, uint8array_utils_1.readUint16BE)(bytes, 1));
    }
    if (addInfos === 26) {
        if (bytes.length < 5)
            return undefined;
        return BigInt((0, uint8array_utils_1.readUint32BE)(bytes, 1));
    }
    if (addInfos === 27) {
        if (bytes.length < 9)
            return undefined;
        return BigInt((0, uint8array_utils_1.readBigUInt64BE)(bytes, 1));
    }
    if (addInfos === 31)
        return BigInt(-1); // indefinite length element follows
    // throw new BaseCborError( "Invalid length encoding while parsing CBOR" );
    return undefined;
}
function getFloat16(bytes) {
    if (bytes.length < 3)
        return undefined;
    // increments the offset here
    var floatBits = (0, uint8array_utils_1.readUint16BE)(bytes, 1);
    var tempArrayBuffer = new ArrayBuffer(4);
    var tempDataView = new DataView(tempArrayBuffer);
    var sign = floatBits & 32768;
    var exponent = floatBits & 31744;
    var fraction = floatBits & 1023;
    if (exponent === 0x7c00)
        exponent = 0xff << 10;
    else if (exponent !== 0)
        exponent += (127 - 15) << 10;
    else if (fraction !== 0)
        return (sign !== 0 ? -1 : 1) * fraction * 5.960464477539063e-8;
    tempDataView.setUint32(0, sign << 16 | exponent << 13 | fraction << 13);
    return tempDataView.getFloat32(0);
}
function getFloat32(bytes) {
    if (bytes.length < 5)
        return undefined;
    return (0, uint8array_utils_1.readFloat32BE)(bytes, 1);
}
function getFloat64(bytes) {
    if (bytes.length < 9)
        return undefined;
    return (0, uint8array_utils_1.readFloat64BE)(bytes, 1);
}


/***/ }),

/***/ 79236:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(86934), exports);
__exportStar(__webpack_require__(93002), exports);
__exportStar(__webpack_require__(85579), exports);
__exportStar(__webpack_require__(61783), exports);
__exportStar(__webpack_require__(21794), exports);
__exportStar(__webpack_require__(13020), exports);
__exportStar(__webpack_require__(7123), exports);
__exportStar(__webpack_require__(74258), exports);
__exportStar(__webpack_require__(15205), exports);


/***/ }),

/***/ 9940:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 74258:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(9940), exports);


/***/ }),

/***/ 32159:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assert = void 0;
function assert(condition, errorMessage, addInfos) {
    var args = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args[_i - 3] = arguments[_i];
    }
    if (condition)
        return;
    args.length > 0 && console.error.apply(console, __spreadArray([], __read(args), false));
    addInfos && console.error(addInfos);
    if (errorMessage instanceof Error) {
        throw errorMessage;
    }
    ;
    throw new Error(errorMessage);
}
exports.assert = assert;


/***/ }),

/***/ 28328:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.headerFollowingToAddInfos = void 0;
var max_1 = __webpack_require__(34625);
/**
 *
 * @param {number} following : number immediately following the header
 * usually the payload length, or the number itself for uints and negInts
 *
 * @returns {number} a 5 bit unsigned integer that best represents the number of bytes
 */
function headerFollowingToAddInfos(following) {
    if (following < 0)
        return headerFollowingToAddInfos(-following);
    if (following > max_1.MAX_4_BYTES)
        return 27;
    if (following < 24)
        return Number(following);
    if (following < max_1.OVERFLOW_1_BYTE)
        return 24;
    if (following < max_1.OVERFLOW_2_BYTES)
        return 25;
    if (following < max_1.OVERFLOW_4_BYTES)
        return 26;
    return 27;
}
exports.headerFollowingToAddInfos = headerFollowingToAddInfos;


/***/ }),

/***/ 10825:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.unsafeForceUInt = exports.forceBigUInt = exports.canBeUInteger = void 0;
function canBeUInteger(something) {
    return ((typeof something === "bigint" && something >= BigInt(0)) ||
        (typeof something === "number" && something === Math.round(Math.abs(something))));
}
exports.canBeUInteger = canBeUInteger;
function forceBigUInt(toForce) {
    if (!canBeUInteger(toForce)) {
        // console.error( toForce );
        throw new Error("trying to convert an integer to an unsigned Integer, the number was negative");
    }
    return BigInt(toForce);
}
exports.forceBigUInt = forceBigUInt;
;
function unsafeForceUInt(toForce) {
    if (!canBeUInteger(toForce)) {
        // console.error( toForce );
        throw new Error("trying to convert an integer to an unsigned Integer, the number was negative");
    }
    return Number(toForce);
}
exports.unsafeForceUInt = unsafeForceUInt;


/***/ }),

/***/ 37209:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeBech32 = exports.isBech32 = exports.encodeBech32 = exports.getBech32Checksum = exports.getBech32Polymod = exports.expandBech32HumanReadablePart = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var types_1 = __webpack_require__(80247);
var base32_1 = __webpack_require__(88979);
var assert_1 = __webpack_require__(97610);
/**
 * Expand human readable prefix of the bech32 encoding so it can be used in the checkSum
 */
function expandBech32HumanReadablePart(hrp) {
    var e_1, _a, e_2, _b;
    var bytes = [];
    try {
        for (var hrp_1 = __values(hrp), hrp_1_1 = hrp_1.next(); !hrp_1_1.done; hrp_1_1 = hrp_1.next()) {
            var c = hrp_1_1.value;
            bytes.push(c.charCodeAt(0) >> 5);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (hrp_1_1 && !hrp_1_1.done && (_a = hrp_1.return)) _a.call(hrp_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    bytes.push(0);
    try {
        for (var hrp_2 = __values(hrp), hrp_2_1 = hrp_2.next(); !hrp_2_1.done; hrp_2_1 = hrp_2.next()) {
            var c = hrp_2_1.value;
            bytes.push(c.charCodeAt(0) & 31);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (hrp_2_1 && !hrp_2_1.done && (_b = hrp_2.return)) _b.call(hrp_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return bytes;
}
exports.expandBech32HumanReadablePart = expandBech32HumanReadablePart;
var BECH32_POLYMOD_GEN = Object.freeze([0x3b6a57b2, 0x26508e6d, 0x1ea119fa, 0x3d4233dd, 0x2a1462b3]);
/**
 * Used as part of the bech32 checksum.
 */
function getBech32Polymod(bytes) {
    var e_3, _a;
    var checksum = 1;
    try {
        for (var bytes_1 = __values(bytes), bytes_1_1 = bytes_1.next(); !bytes_1_1.done; bytes_1_1 = bytes_1.next()) {
            var byte_1 = bytes_1_1.value;
            var c = (checksum >> 25);
            checksum = (checksum & 0x1fffffff) << 5 ^ byte_1;
            for (var i = 0; i < 5; i++) {
                if (((c >> i) & 1) != 0) {
                    checksum ^= BECH32_POLYMOD_GEN[i];
                }
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (bytes_1_1 && !bytes_1_1.done && (_a = bytes_1.return)) _a.call(bytes_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return checksum;
}
exports.getBech32Polymod = getBech32Polymod;
/**
 * Generate the bech32 checksum
 */
function getBech32Checksum(humanReadablePart, data) {
    var checksum = getBech32Polymod(expandBech32HumanReadablePart(humanReadablePart)
        .concat(data)
        .concat([0, 0, 0, 0, 0, 0])) ^ 1;
    var chkSum = [];
    for (var i = 0; i < 6; i++) {
        chkSum.push((checksum >> 5 * (5 - i)) & 31);
    }
    return chkSum;
}
exports.getBech32Checksum = getBech32Checksum;
/**
 * Creates a bech32 checksummed string (used to represent Cardano addresses)
 * @example
 * encodeBech32("foo", textToBytes("foobar")) => "foo1vehk7cnpwgry9h96"
 * @example
 * encodeBech32("addr_test", hexToBytes("70a9508f015cfbcffc3d88ac4c1c934b5b82d2bb281d464672f6c49539")) => "addr_test1wz54prcptnaullpa3zkyc8ynfddc954m9qw5v3nj7mzf2wggs2uld"
 * @param {byte[]} data - uint8 0 - 256
 */
function encodeBech32(humanReadablePart, data) {
    (0, assert_1.assert)(humanReadablePart.length > 0, "human-readable-part must have non-zero length");
    var _data = (0, types_1.buffToUint5Arr)((0, uint8array_utils_1.isUint8Array)(data) ? data : new Uint8Array(data));
    return humanReadablePart + "1" +
        _data.concat(getBech32Checksum(humanReadablePart, _data)).map(function (val) { return base32_1.BECH32_BASE32_ALPHABET[val]; }).join("");
}
exports.encodeBech32 = encodeBech32;
/**
 * Verify a bech32 checksum
 * @example
 * isBech32("foo1vehk7cnpwgry9h96") => true
 * @example
 * isBech32("foo1vehk7cnpwgry9h97") => false
 * @example
 * isBech32("a12uel5l") => true
 * @example
 * isBech32("mm1crxm3i") => false
 * @example
 * isBech32("A1G7SGD8") => false
 * @example
 * isBech32("abcdef1qpzry9x8gf2tvdw0s3jn54khce6mua7lmqqqxw") => true
 * @example
 * isBech32("?1ezyfcl") => true
 * @example
 * isBech32("addr_test1wz54prcptnaullpa3zkyc8ynfddc954m9qw5v3nj7mzf2wggs2uld") => true
 * @param {string} addr
 * @returns {boolean}
 */
function isBech32(addr) {
    var e_4, _a;
    var i = addr.indexOf("1");
    if (i == -1 || i == 0) {
        return false;
    }
    var hrp = addr.slice(0, i);
    addr = addr.slice(i + 1);
    var data = [];
    try {
        for (var addr_1 = __values(addr), addr_1_1 = addr_1.next(); !addr_1_1.done; addr_1_1 = addr_1.next()) {
            var ch = addr_1_1.value;
            var j = base32_1.BECH32_BASE32_ALPHABET.indexOf(ch);
            if (j == -1) {
                return false;
            }
            data.push(j);
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (addr_1_1 && !addr_1_1.done && (_a = addr_1.return)) _a.call(addr_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
    var chkSumA = data.slice(data.length - 6);
    var chkSumB = getBech32Checksum(hrp, data.slice(0, data.length - 6));
    for (var i_1 = 0; i_1 < 6; i_1++) {
        if (chkSumA[i_1] != chkSumB[i_1]) {
            return false;
        }
    }
    return true;
}
exports.isBech32 = isBech32;
/**
 * Decomposes a bech32 checksummed string (i.e. Cardano address), and returns the human readable part and the original bytes
 * Throws an error if checksum is invalid.
 * @example
 * bytesToHex(decodeBech32("addr_test1wz54prcptnaullpa3zkyc8ynfddc954m9qw5v3nj7mzf2wggs2uld")[1]) => "70a9508f015cfbcffc3d88ac4c1c934b5b82d2bb281d464672f6c49539"
 * @param {string} addr
 * @returns {[humanReadablePart: string, bytes: byte[]]}
 */
function decodeBech32(addr) {
    (0, assert_1.assert)(isBech32(addr), "invalid bech32 addr");
    var i = addr.indexOf("1");
    (0, assert_1.assert)(i != -1, "bech32 address missing the '1' separator");
    var hrp = addr.slice(0, i);
    addr = addr.slice(i + 1);
    var data = (0, base32_1.decodeBase32Bech32)(addr.slice(0, addr.length - 6));
    return [hrp, Array.from(data)];
}
exports.decodeBech32 = decodeBech32;


/***/ }),

/***/ 27092:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.blake2b_512 = exports.blake2b_256 = exports.blake2b_224 = exports.blake2b_128 = exports.blake2b = void 0;
/**
 * 64-bit unsigned addition
 * Sets v[a,a+1] += v[b,b+1]
 * v should be a Uint32Array
 */
function ADD64AA(v, a, b) {
    var o0 = v[a] + v[b];
    var o1 = v[a + 1] + v[b + 1];
    if (o0 >= 0x100000000) {
        o1++;
    }
    v[a] = o0;
    v[a + 1] = o1;
}
// 64-bit unsigned addition
// Sets v[a,a+1] += b
// b0 is the low 32 bits of b, b1 represents the high 32 bits
function ADD64AC(v, a, b0, b1) {
    var o0 = v[a] + b0;
    if (b0 < 0) {
        o0 += 0x100000000;
    }
    var o1 = v[a + 1] + b1;
    if (o0 >= 0x100000000) {
        o1++;
    }
    v[a] = o0;
    v[a + 1] = o1;
}
// Little-endian byte access
function B2B_GET32(arr, i) {
    return arr[i] ^ (arr[i + 1] << 8) ^ (arr[i + 2] << 16) ^ (arr[i + 3] << 24);
}
// G Mixing function
// The ROTRs are inlined for speed
function B2B_G(a, b, c, d, ix, iy) {
    var x0 = m[ix];
    var x1 = m[ix + 1];
    var y0 = m[iy];
    var y1 = m[iy + 1];
    ADD64AA(v, a, b); // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
    ADD64AC(v, a, x0, x1); // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
    var xor0 = v[d] ^ v[a];
    var xor1 = v[d + 1] ^ v[a + 1];
    v[d] = xor1;
    v[d + 1] = xor0;
    ADD64AA(v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
    xor0 = v[b] ^ v[c];
    xor1 = v[b + 1] ^ v[c + 1];
    v[b] = (xor0 >>> 24) ^ (xor1 << 8);
    v[b + 1] = (xor1 >>> 24) ^ (xor0 << 8);
    ADD64AA(v, a, b);
    ADD64AC(v, a, y0, y1);
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
    xor0 = v[d] ^ v[a];
    xor1 = v[d + 1] ^ v[a + 1];
    v[d] = (xor0 >>> 16) ^ (xor1 << 16);
    v[d + 1] = (xor1 >>> 16) ^ (xor0 << 16);
    ADD64AA(v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
    xor0 = v[b] ^ v[c];
    xor1 = v[b + 1] ^ v[c + 1];
    v[b] = (xor1 >>> 31) ^ (xor0 << 1);
    v[b + 1] = (xor0 >>> 31) ^ (xor1 << 1);
}
// Initialization Vector
var BLAKE2B_IV32 = new Uint32Array([
    0xf3bcc908, 0x6a09e667, 0x84caa73b, 0xbb67ae85, 0xfe94f82b, 0x3c6ef372,
    0x5f1d36f1, 0xa54ff53a, 0xade682d1, 0x510e527f, 0x2b3e6c1f, 0x9b05688c,
    0xfb41bd6b, 0x1f83d9ab, 0x137e2179, 0x5be0cd19
]);
var SIGMA8 = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13,
    6, 1, 12, 0, 2, 11, 7, 5, 3, 11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1,
    9, 4, 7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8, 9, 0, 5, 7, 2, 4,
    10, 15, 14, 1, 11, 12, 6, 8, 3, 13, 2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5,
    15, 14, 1, 9, 12, 5, 1, 15, 14, 13, 4, 10, 0, 7, 6, 3, 9, 2, 8, 11, 13, 11, 7,
    14, 12, 1, 3, 9, 5, 0, 15, 4, 8, 6, 2, 10, 6, 15, 14, 9, 11, 3, 0, 8, 12, 2,
    13, 7, 1, 4, 10, 5, 10, 2, 8, 4, 7, 6, 1, 5, 15, 11, 9, 14, 3, 12, 13, 0, 0,
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6,
    1, 12, 0, 2, 11, 7, 5, 3
];
// These are offsets into a uint64 buffer.
// Multiply them all by 2 to make them offsets into a uint32 buffer,
// because this is Javascript and we don't have uint64s
var SIGMA82 = new Uint8Array(SIGMA8.map(function (x) {
    return x * 2;
}));
// Compression function. 'last' flag indicates last block.
// Note we're representing 16 uint64s as 32 uint32s
var v = new Uint32Array(32);
var m = new Uint32Array(32);
function blake2bCompress(ctx, last) {
    var i = 0;
    // init work variables
    for (i = 0; i < 16; i++) {
        v[i] = ctx.h[i];
        v[i + 16] = BLAKE2B_IV32[i];
    }
    // low 64 bits of offset
    v[24] = v[24] ^ ctx.t;
    v[25] = v[25] ^ (ctx.t / 0x100000000);
    // high 64 bits not supported, offset may not be higher than 2**53-1
    // last block flag set ?
    if (last) {
        v[28] = ~v[28];
        v[29] = ~v[29];
    }
    // get little-endian words
    for (i = 0; i < 32; i++) {
        m[i] = B2B_GET32(ctx.b, 4 * i);
    }
    // twelve rounds of mixing
    // uncomment the DebugPrint calls to log the computation
    // and match the RFC sample documentation
    // util.debugPrint('          m[16]', m, 64)
    for (i = 0; i < 12; i++) {
        // util.debugPrint('   (i=' + (i < 10 ? ' ' : '') + i + ') v[16]', v, 64)
        B2B_G(0, 8, 16, 24, SIGMA82[i * 16 + 0], SIGMA82[i * 16 + 1]);
        B2B_G(2, 10, 18, 26, SIGMA82[i * 16 + 2], SIGMA82[i * 16 + 3]);
        B2B_G(4, 12, 20, 28, SIGMA82[i * 16 + 4], SIGMA82[i * 16 + 5]);
        B2B_G(6, 14, 22, 30, SIGMA82[i * 16 + 6], SIGMA82[i * 16 + 7]);
        B2B_G(0, 10, 20, 30, SIGMA82[i * 16 + 8], SIGMA82[i * 16 + 9]);
        B2B_G(2, 12, 22, 24, SIGMA82[i * 16 + 10], SIGMA82[i * 16 + 11]);
        B2B_G(4, 14, 16, 26, SIGMA82[i * 16 + 12], SIGMA82[i * 16 + 13]);
        B2B_G(6, 8, 18, 28, SIGMA82[i * 16 + 14], SIGMA82[i * 16 + 15]);
    }
    // util.debugPrint('   (i=12) v[16]', v, 64)
    for (i = 0; i < 16; i++) {
        ctx.h[i] = ctx.h[i] ^ v[i] ^ v[i + 16];
    }
    // util.debugPrint('h[8]', ctx.h, 64)
}
/** reusable parameterBlock */
var parameterBlock = new Uint8Array(64).fill(0);
function blake2bInit(digestSize) {
    // state, 'param block'
    var ctx = {
        b: new Uint8Array(128),
        h: new Uint32Array(16),
        t: 0,
        c: 0,
        digestSize: digestSize // output length in bytes
    };
    // initialize parameterBlock before usage
    parameterBlock.fill(0);
    parameterBlock[0] = digestSize;
    parameterBlock[2] = 1; // fanout
    parameterBlock[3] = 1; // depth
    // initialize hash state
    for (var i = 0; i < 16; i++) {
        ctx.h[i] = BLAKE2B_IV32[i] ^ B2B_GET32(parameterBlock, i * 4);
    }
    return ctx;
}
// Updates a BLAKE2b streaming hash
// Requires hash context and Uint8Array (byte array)
function blake2bUpdate(ctx, input) {
    for (var i = 0; i < input.length; i++) {
        if (ctx.c === 128) {
            // buffer full ?
            ctx.t += ctx.c; // add counters
            blake2bCompress(ctx, false); // compress (not last)
            ctx.c = 0; // counter to zero
        }
        ctx.b[ctx.c++] = input[i];
    }
}
// Completes a BLAKE2b streaming hash
// Returns a Uint8Array containing the message digest
function blake2bFinal(ctx) {
    ctx.t += ctx.c; // mark last block offset
    while (ctx.c < 128) {
        // fill up with zeros
        ctx.b[ctx.c++] = 0;
    }
    blake2bCompress(ctx, true); // final block flag = 1
    // little endian convert and store
    var out = new Uint8Array(ctx.digestSize);
    for (var i = 0; i < ctx.digestSize; i++) {
        out[i] = ctx.h[i >> 2] >> (8 * (i & 3));
    }
    return out;
}
function blake2b(data, digestSize) {
    if (digestSize === void 0) { digestSize = 32; }
    data = new Uint8Array(data);
    var ctx = blake2bInit(digestSize);
    blake2bUpdate(ctx, data);
    return blake2bFinal(ctx);
}
exports.blake2b = blake2b;
function blake2b_128(data) {
    return blake2b(data, 16);
}
exports.blake2b_128 = blake2b_128;
function blake2b_224(data) {
    return blake2b(data, 28);
}
exports.blake2b_224 = blake2b_224;
function blake2b_256(data) {
    return blake2b(data, 32);
}
exports.blake2b_256 = blake2b_256;
function blake2b_512(data) {
    return blake2b(data, 64);
}
exports.blake2b_512 = blake2b_512;


/***/ }),

/***/ 48339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isFp6 = exports.isBlsResult = exports.bls12_381_finalVerify = exports.bls12_381_eqMlResult = exports.bls12_381_mulMlResult = exports.bls12_381_millerLoop = exports.bls12_381_G2_uncompress = exports.bls12_381_G2_compress = exports.bls12_381_G2_hashToGroup = exports.bls12_381_G2_equal = exports.bls12_381_G2_scalarMul = exports.bls12_381_G2_neg = exports.bls12_381_G2_add = exports.bls12_381_G1_uncompress = exports.bls12_381_G1_compress = exports.bls12_381_G1_hashToGroup = exports.bls12_381_G1_equal = exports.bls12_381_G1_scalarMul = exports.bls12_381_G1_neg = exports.bls12_381_G1_add = exports.isFp2 = exports.isBlsG2 = exports.isBlsG1 = exports.BlsG2 = exports.BlsG1 = void 0;
var noble_1 = __webpack_require__(59954);
var hash_to_curve_1 = __webpack_require__(50288);
var utils_1 = __webpack_require__(92035);
var sha256_1 = __webpack_require__(7902);
exports.BlsG1 = noble_1.bls12_381.G1.ProjectivePoint;
exports.BlsG2 = noble_1.bls12_381.G2.ProjectivePoint;
function isBlsG1(stuff) {
    return stuff instanceof exports.BlsG1 && (typeof stuff.px === "bigint" &&
        typeof stuff.py === "bigint" &&
        typeof stuff.pz === "bigint");
}
exports.isBlsG1 = isBlsG1;
function isBlsG2(stuff) {
    return stuff instanceof exports.BlsG2 && (isFp2(stuff.px) &&
        isFp2(stuff.py) &&
        isFp2(stuff.pz));
}
exports.isBlsG2 = isBlsG2;
function isFp2(stuff) {
    return typeof stuff === "object" && (stuff !== null && !Array.isArray(stuff) &&
        typeof stuff.c0 === "bigint" &&
        typeof stuff.c1 === "bigint");
}
exports.isFp2 = isFp2;
var curveOrder = BigInt("52435875175126190479447740508185965837690552500527637822603658699938581184513");
var htfDefaults = Object.freeze({
    // DST: a domain separation tag
    // defined in section 2.2.5
    // Use utils.getDSTLabel(), utils.setDSTLabel(value)
    DST: "",
    encodeDST: "",
    // p: the characteristic of F
    //    where F is a finite field of characteristic p and order q = p^m
    p: noble_1.Fp.ORDER,
    // m: the extension degree of F, m >= 1
    //     where F is a finite field of characteristic p and order q = p^m
    m: 2,
    // k: the target security level for the suite in bits
    // defined in section 5.1
    k: 128,
    // option to use a message that has already been processed by
    // expand_message_xmd
    expand: 'xmd',
    // Hash functions for: expand_message_xmd is appropriate for use with a
    // wide range of hash functions, including SHA-2, SHA-3, BLAKE2, and others.
    // BBS+ uses blake2: https://github.com/hyperledger/aries-framework-go/issues/2247
    hash: sha256_1.sha256,
});
var G2_Hasher = (0, hash_to_curve_1.createHasher)(exports.BlsG2, noble_1.G2_mapToCurve, __assign({}, htfDefaults));
var G1_Hasher = (0, hash_to_curve_1.createHasher)(exports.BlsG1, noble_1.G1_mapToCurve, __assign(__assign({}, htfDefaults), { m: 1, DST: 'BLS_SIG_BLS12381G1_XMD:SHA-256_SSWU_RO_NUL_' }));
function bls12_381_G1_add(a, b) {
    // if( bls12_381_G1_equal( a, BlsG1.ZERO ) ) return b;
    // if( bls12_381_G1_equal( b, BlsG1.ZERO ) ) return a;
    return a.add(b);
}
exports.bls12_381_G1_add = bls12_381_G1_add;
function bls12_381_G1_neg(elem) {
    return elem.negate();
}
exports.bls12_381_G1_neg = bls12_381_G1_neg;
function bls12_381_G1_scalarMul(n, g1) {
    if (n < 0)
        return bls12_381_G1_scalarMul(-n, bls12_381_G1_neg(g1));
    n = BigInt(n);
    if (n >= curveOrder)
        n = n % curveOrder;
    if (n === BigInt(0))
        return exports.BlsG1.ZERO;
    return g1.multiply(n);
}
exports.bls12_381_G1_scalarMul = bls12_381_G1_scalarMul;
function bls12_381_G1_equal(a, b) {
    return a.equals(b);
}
exports.bls12_381_G1_equal = bls12_381_G1_equal;
function bls12_381_G1_hashToGroup(a, b) {
    // noble-curves can handle that but the plutus-machine doesn't
    // so we artificially throw an error here
    if (b.length > 255)
        throw new Error("DST length can not be greater than 255");
    return exports.BlsG1.fromAffine(G1_Hasher.hashToCurve(a, { DST: b })
        .toAffine());
}
exports.bls12_381_G1_hashToGroup = bls12_381_G1_hashToGroup;
function bls12_381_G1_compress(elem) {
    return elem.toRawBytes();
}
exports.bls12_381_G1_compress = bls12_381_G1_compress;
function bls12_381_G1_uncompress(compressed) {
    var _a = (0, noble_1.parseMask)(compressed), compressed_bit = _a.compressed, infinity = _a.infinity, sort = _a.sort, value = _a.value;
    // point zero edge case
    if (compressed_bit &&
        infinity &&
        sort &&
        value.every(function (n) { return n === 0; }))
        throw new Error("sign bit set on pont ZERO, we don't like it");
    // not compressed bytes would be totally fine for the library but we artificially fail here
    // https://github.com/IntersectMBO/plutus/blob/master/plutus-conformance/test-cases/uplc/evaluation/builtin/semantics/bls12_381_G1_uncompress/on-curve-serialised-not-compressed/on-curve-serialised-not-compressed.uplc
    if (!compressed_bit)
        throw new Error("uncompress only works with compressed byets");
    return exports.BlsG1.fromHex(compressed);
}
exports.bls12_381_G1_uncompress = bls12_381_G1_uncompress;
function bls12_381_G2_add(a, b) {
    // if( bls12_381_G2_equal( a, BlsG2.ZERO ) ) return b;
    // if( bls12_381_G2_equal( b, BlsG2.ZERO ) ) return a;
    return a.add(b);
}
exports.bls12_381_G2_add = bls12_381_G2_add;
function bls12_381_G2_neg(elem) {
    return elem.negate();
}
exports.bls12_381_G2_neg = bls12_381_G2_neg;
function bls12_381_G2_scalarMul(n, g2) {
    if (n < 0)
        return bls12_381_G2_scalarMul(-n, bls12_381_G2_neg(g2));
    n = BigInt(n);
    if (n >= curveOrder)
        n = n % curveOrder;
    if (n === BigInt(0))
        return exports.BlsG2.ZERO;
    return g2.multiply(BigInt(n));
}
exports.bls12_381_G2_scalarMul = bls12_381_G2_scalarMul;
function bls12_381_G2_equal(a, b) {
    return a.equals(b);
}
exports.bls12_381_G2_equal = bls12_381_G2_equal;
function bls12_381_G2_hashToGroup(a, b) {
    // noble-curves can handle that but the plutus-machine doesn't
    // so we artificially throw an error here
    if (b.length > 255)
        throw new Error("DST length can not be greater than 255");
    return exports.BlsG2.fromAffine(G2_Hasher.hashToCurve(a, { DST: b })
        .toAffine());
}
exports.bls12_381_G2_hashToGroup = bls12_381_G2_hashToGroup;
function bls12_381_G2_compress(elem) {
    return elem.toRawBytes();
}
exports.bls12_381_G2_compress = bls12_381_G2_compress;
function bls12_381_G2_uncompress(compressed) {
    var compressed_bit = (0, noble_1.parseMask)(compressed).compressed;
    // not compressed bytes would be totally fine for the library but we artificially fail here
    // https://github.com/IntersectMBO/plutus/blob/master/plutus-conformance/test-cases/uplc/evaluation/builtin/semantics/bls12_381_G2_uncompress/on-curve-serialised-not-compressed/on-curve-serialised-not-compressed.uplc
    if (!compressed_bit)
        throw new Error("uncompress only works with compressed byets");
    return exports.BlsG2.fromHex(compressed);
}
exports.bls12_381_G2_uncompress = bls12_381_G2_uncompress;
function bls12_381_millerLoop(g1, g2) {
    var _a = g1.toAffine(), x = _a.x, y = _a.y;
    return millerLoop(pairingPrecomputes(g2), [x, y]);
}
exports.bls12_381_millerLoop = bls12_381_millerLoop;
function bls12_381_mulMlResult(a, b) {
    return (0, noble_1.Fp12Multiply)(a, b);
}
exports.bls12_381_mulMlResult = bls12_381_mulMlResult;
exports.bls12_381_eqMlResult = noble_1.Fp12_eql;
function bls12_381_finalVerify(a, b) {
    // blst implementation https://github.com/supranational/blst/blob/0d46eefa45fc1e57aceb42bba0e84eab3a7a9725/src/aggregate.c#L506
    var GT = (0, noble_1.Fp12_conjugate)(a);
    GT = (0, noble_1.Fp12Multiply)(GT, b);
    GT = (0, noble_1.Fp12_finalExponentiate)(GT);
    return (0, noble_1.Fp12_eql)(GT, noble_1.Fp12_ONE);
}
exports.bls12_381_finalVerify = bls12_381_finalVerify;
// The BLS parameter x for BLS12-381
var BLS_X = BigInt('0xd201000000010000');
var BLS_X_LEN = (0, utils_1.bitLen)(BLS_X);
var _2n = BigInt(2), _3n = BigInt(3);
// Pre-compute coefficients for sparse multiplication
// Point addition and point double calculations is reused for coefficients
function calcPairingPrecomputes(p) {
    var x = p.x, y = p.y;
    // prettier-ignore
    var Qx = x, Qy = y, Qz = noble_1.Fp2.ONE;
    // prettier-ignore
    var Rx = Qx, Ry = Qy, Rz = Qz;
    var ell_coeff = [];
    for (var i = BLS_X_LEN - 2; i >= 0; i--) {
        // Double
        var t0 = noble_1.Fp2.sqr(Ry); // Ry²
        var t1 = noble_1.Fp2.sqr(Rz); // Rz²
        var t2 = noble_1.Fp2.multiplyByB(noble_1.Fp2.mul(t1, _3n)); // 3 * T1 * B
        var t3 = noble_1.Fp2.mul(t2, _3n); // 3 * T2
        var t4 = noble_1.Fp2.sub(noble_1.Fp2.sub(noble_1.Fp2.sqr(noble_1.Fp2.add(Ry, Rz)), t1), t0); // (Ry + Rz)² - T1 - T0
        ell_coeff.push([
            noble_1.Fp2.sub(t2, t0),
            noble_1.Fp2.mul(noble_1.Fp2.sqr(Rx), _3n),
            noble_1.Fp2.neg(t4), // -T4
        ]);
        Rx = noble_1.Fp2.div(noble_1.Fp2.mul(noble_1.Fp2.mul(noble_1.Fp2.sub(t0, t3), Rx), Ry), _2n); // ((T0 - T3) * Rx * Ry) / 2
        Ry = noble_1.Fp2.sub(noble_1.Fp2.sqr(noble_1.Fp2.div(noble_1.Fp2.add(t0, t3), _2n)), noble_1.Fp2.mul(noble_1.Fp2.sqr(t2), _3n)); // ((T0 + T3) / 2)² - 3 * T2²
        Rz = noble_1.Fp2.mul(t0, t4); // T0 * T4
        if ((0, utils_1.bitGet)(BLS_X /*CURVE.params.x*/, i)) {
            // Addition
            var t0_1 = noble_1.Fp2.sub(Ry, noble_1.Fp2.mul(Qy, Rz)); // Ry - Qy * Rz
            var t1_1 = noble_1.Fp2.sub(Rx, noble_1.Fp2.mul(Qx, Rz)); // Rx - Qx * Rz
            ell_coeff.push([
                noble_1.Fp2.sub(noble_1.Fp2.mul(t0_1, Qx), noble_1.Fp2.mul(t1_1, Qy)),
                noble_1.Fp2.neg(t0_1),
                t1_1, // T1
            ]);
            var t2_1 = noble_1.Fp2.sqr(t1_1); // T1²
            var t3_1 = noble_1.Fp2.mul(t2_1, t1_1); // T2 * T1
            var t4_1 = noble_1.Fp2.mul(t2_1, Rx); // T2 * Rx
            var t5 = noble_1.Fp2.add(noble_1.Fp2.sub(t3_1, noble_1.Fp2.mul(t4_1, _2n)), noble_1.Fp2.mul(noble_1.Fp2.sqr(t0_1), Rz)); // T3 - 2 * T4 + T0² * Rz
            Rx = noble_1.Fp2.mul(t1_1, t5); // T1 * T5
            Ry = noble_1.Fp2.sub(noble_1.Fp2.mul(noble_1.Fp2.sub(t4_1, t5), t0_1), noble_1.Fp2.mul(t3_1, Ry)); // (T4 - T5) * T0 - T3 * Ry
            Rz = noble_1.Fp2.mul(Rz, t3_1); // Rz * T3
        }
    }
    return ell_coeff;
}
function pairingPrecomputes(point) {
    var p = point;
    if (p._PPRECOMPUTES)
        return p._PPRECOMPUTES;
    p._PPRECOMPUTES = calcPairingPrecomputes(point.toAffine());
    return p._PPRECOMPUTES;
}
function millerLoop(ell, g1) {
    var x = BLS_X;
    var Px = g1[0];
    var Py = g1[1];
    var f12 = noble_1.Fp12.ONE;
    for (var j = 0, i = BLS_X_LEN - 2; i >= 0; i--, j++) {
        var E = ell[j];
        f12 = noble_1.Fp12.multiplyBy014(f12, E[0], noble_1.Fp2.mul(E[1], Px), noble_1.Fp2.mul(E[2], Py));
        if ((0, utils_1.bitGet)(x, i)) {
            j += 1;
            var F = ell[j];
            f12 = noble_1.Fp12.multiplyBy014(f12, F[0], noble_1.Fp2.mul(F[1], Px), noble_1.Fp2.mul(F[2], Py));
        }
        if (i !== 0)
            f12 = noble_1.Fp12.sqr(f12);
    }
    return noble_1.Fp12.conjugate(f12);
}
function isBlsResult(stuff) {
    return typeof stuff === "object" && (stuff !== null && !Array.isArray(stuff) &&
        isFp6(stuff.c0) &&
        isFp6(stuff.c1));
}
exports.isBlsResult = isBlsResult;
function isFp6(stuff) {
    return typeof stuff === "object" && (stuff !== null && !Array.isArray(stuff) &&
        isFp2(stuff.c0) &&
        isFp2(stuff.c1) &&
        isFp2(stuff.c2));
}
exports.isFp6 = isFp6;


/***/ }),

/***/ 23985:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.verifyEd25519Signature = exports.verifyEd25519Signature_sync = exports.getEd25519Signature = exports.getEd25519Signature_sync = exports.signExtendedEd25519 = exports.signExtendedEd25519_sync = exports.signEd25519 = exports.signEd25519_sync = exports.extendedToPublic = exports.deriveEd25519PublicKey = exports.deriveEd25519PublicKey_sync = exports.getExtendedEd25519PrivateKey = exports.getExtendedEd25519PrivateKey_sync = exports.getExtendEd25519PrivateKeyComponents_sync = exports.getExtendEd25519PrivateKeyComponentsAsBytes_sync = exports.scalarMultBase = exports.scalarToBytes = exports.scalarFromBytes = exports.pointFromBytes = exports.bigpointToUint8Array = exports.encodeInt = exports.scalarMul = exports.addPointsEdwards = exports.ed25519bigint = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var sha2_512_1 = __webpack_require__(1824);
var types_1 = __webpack_require__(80247);
var positiveMod_1 = __webpack_require__(60011);
var bigintToBuffer_1 = __webpack_require__(35653);
var hasGlobalWebCrypto_1 = __webpack_require__(69631);
// "Ed25519" does not seem to have great support yet
var __hasNativeSupport =  false && (0);
var NATIVE_ALGO_NAME = "Ed25519";
var NATIVE_ALGO = Object.freeze({ name: NATIVE_ALGO_NAME });
var importKey = __hasNativeSupport ?
    globalThis.crypto.subtle.importKey.bind(globalThis.crypto.subtle) :
    function () { return Promise.resolve(new ArrayBuffer(0)); };
function getNativePrivateKey(bytes) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // ensure 64 bytes
                    if (bytes.length === 32)
                        bytes = getExtendedEd25519PrivateKey_sync(bytes);
                    return [4 /*yield*/, importKey("raw", bytes, NATIVE_ALGO, false, ["sign", "deriveKey"])];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function getNativePublicKey(bytes) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, importKey("raw", bytes, NATIVE_ALGO, false, ["verify"])];
        });
    });
}
function nativeEd25519Sign(privateKey, data) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, ensureNativeSupport()];
                case 1:
                    if (!(_e.sent()))
                        return [2 /*return*/, getEd25519Signature_sync(privateKey, data)];
                    _a = Uint8Array.bind;
                    _c = (_b = globalThis.crypto.subtle).sign;
                    _d = [NATIVE_ALGO_NAME];
                    return [4 /*yield*/, getNativePrivateKey(privateKey)];
                case 2: return [4 /*yield*/, _c.apply(_b, _d.concat([_e.sent(), data]))];
                case 3: return [2 /*return*/, new (_a.apply(Uint8Array, [void 0, _e.sent()]))()];
            }
        });
    });
}
var ED25519_ORDER = BigInt('57896044618658097711785492504343953926634992332820282019728792003956564819949');
function ed25519bigint(n) {
    return (0, positiveMod_1.positiveMod)(n, ED25519_ORDER);
}
exports.ed25519bigint = ed25519bigint;
function toArrayBuffer(bytes) {
    if (bytes instanceof ArrayBuffer)
        return bytes;
    var buffer = new ArrayBuffer(bytes.length);
    var view = new Uint8Array(buffer);
    view.set(bytes);
    return buffer;
}
function nativeEd25519Verify(publicKey, signature, data) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, ensureNativeSupport()];
                case 1:
                    if (!(_d.sent()))
                        return [2 /*return*/, verifyEd25519Signature_sync(signature, data, publicKey)];
                    _b = (_a = globalThis.crypto.subtle).verify;
                    _c = [NATIVE_ALGO_NAME];
                    return [4 /*yield*/, getNativePublicKey(publicKey)];
                case 2: return [2 /*return*/, _b.apply(_a, _c.concat([_d.sent(), toArrayBuffer(signature),
                        toArrayBuffer(data)]))];
            }
        });
    });
}
function _test(privateKey, publicKey, data, uint8ArrayEq) {
    return __awaiter(this, void 0, void 0, function () {
        var privBytes, _a, pubBytes, _b, nativeSignResult, nativeVerifyResult, mySignResult, myVerifyResult, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, , 6]);
                    _a = Uint8Array.bind;
                    return [4 /*yield*/, globalThis.crypto.subtle.exportKey("raw", privateKey)];
                case 1:
                    privBytes = new (_a.apply(Uint8Array, [void 0, _d.sent()]))();
                    _b = Uint8Array.bind;
                    return [4 /*yield*/, globalThis.crypto.subtle.exportKey("raw", publicKey)];
                case 2:
                    pubBytes = new (_b.apply(Uint8Array, [void 0, _d.sent()]))();
                    return [4 /*yield*/, nativeEd25519Sign(privBytes, data)];
                case 3:
                    nativeSignResult = _d.sent();
                    return [4 /*yield*/, nativeEd25519Verify(pubBytes, nativeSignResult, data)];
                case 4:
                    nativeVerifyResult = _d.sent();
                    mySignResult = getEd25519Signature_sync(data, privBytes);
                    myVerifyResult = verifyEd25519Signature_sync(mySignResult, data, pubBytes);
                    __hasNativeSupport = (__hasNativeSupport &&
                        uint8ArrayEq(nativeSignResult, mySignResult) &&
                        nativeVerifyResult === myVerifyResult);
                    return [3 /*break*/, 6];
                case 5:
                    _c = _d.sent();
                    __hasNativeSupport = false;
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
}
var _support_was_tested = false;
function _test_support() {
    return __awaiter(this, void 0, void 0, function () {
        var _keyPair /* { privateKey, publicKey } */, extendedPrivate, cryptoPrivate, repeatArr, eqU8Arr, bench, sum, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (_support_was_tested || !__hasNativeSupport)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, globalThis.crypto.subtle.generateKey(NATIVE_ALGO, true, ["sign", "verify"])];
                case 2:
                    _keyPair = (_b.sent());
                    extendedPrivate = new Uint8Array(64);
                    globalThis.crypto.getRandomValues(extendedPrivate);
                    return [4 /*yield*/, getNativePrivateKey(extendedPrivate)];
                case 3:
                    cryptoPrivate = _b.sent();
                    repeatArr = function (arr, n) {
                        for (var i = 0; i < n; i++)
                            arr = arr.concat.apply(arr, __spreadArray([], __read(arr), false));
                        return arr;
                    };
                    eqU8Arr = function (a, b) {
                        if (!(a instanceof Uint8Array) || !(b instanceof Uint8Array))
                            return false;
                        if (a.length !== b.length)
                            return false;
                        for (var i = 0; i < a.length; i++)
                            if (a[i] !== b[i])
                                return false;
                        return true;
                    };
                    return [4 /*yield*/, Promise.all(
                        // repeatArr(
                        //     [
                        //         new Uint8Array( 0 ),
                        //         new Uint8Array( 10 ),
                        //         new Uint8Array([ 0xde, 0xad, 0xbe, 0xef ]),
                        // 
                        //         new Uint8Array( repeatArr([0xaa], 20 ) ),
                        //         new Uint8Array( repeatArr([0xbb], 20 ) ),
                        //         new Uint8Array( repeatArr([0xcc], 20 ) ),
                        //         new Uint8Array( repeatArr([0xdd], 20 ) ),
                        //         new Uint8Array( repeatArr([0xee], 20 ) ),
                        //         new Uint8Array( repeatArr([0xff], 20 ) ),
                        // 
                        //         new Uint8Array( repeatArr([0xaa, 0xbb], 33 ) ),
                        //         new Uint8Array( repeatArr([0xbb, 0xcc], 33 ) ),
                        //         new Uint8Array( repeatArr([0xcc, 0xdd], 33 ) ),
                        //         new Uint8Array( repeatArr([0xdd, 0xee], 33 ) ),
                        //         new Uint8Array( repeatArr([0xee, 0xff], 33 ) ),
                        //         new Uint8Array( repeatArr([0xff, 0x00], 33 ) ),
                        // 
                        //         new Uint8Array( repeatArr([ 0xde, 0xad, 0xbe, 0xef ], 30 ) ),
                        //     ],
                        //     10
                        // )
                        // .map( data => _test( privateKey, publicKey, data, uint8ArrayEq ) )
                        [])];
                case 4:
                    bench = _b.sent();
                    if (!__hasNativeSupport)
                        return [2 /*return*/];
                    sum = bench.reduce(function (acc, _a) {
                        var _b = __read(_a, 2), native = _b[0], js = _b[1];
                        acc[0] += native;
                        acc[1] += js;
                        return acc;
                    }, [0, 0]);
                    __hasNativeSupport = __hasNativeSupport && sum[0] < sum[1];
                    return [3 /*break*/, 6];
                case 5:
                    _a = _b.sent();
                    __hasNativeSupport = false;
                    _support_was_tested = true;
                    return [3 /*break*/, 6];
                case 6:
                    _support_was_tested = true;
                    return [2 /*return*/];
            }
        });
    });
}
if (__hasNativeSupport) {
    _test_support();
}
else {
    _support_was_tested = true;
}
/**
 * There are cases where `globalThis.crypto.subtle` is fully defined
 * but the algorithm `Ed25519` is NOT SUPPORTED.
 *
 * unfortunately, there is NO WAY to check this syncronously.
 */
function ensureNativeSupport() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!__hasNativeSupport)
                        return [2 /*return*/, false];
                    return [4 /*yield*/, _test_support()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, __hasNativeSupport];
            }
        });
    });
}
var Q = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"); // ipowi(255) - 19
var Q38 = BigInt("7237005577332262213973186563042994240829374041602535252466099000494570602494"); // (Q + 3)/8
var CURVE_ORDER = BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"); // ipow2(252) + 27742317777372353535851937790883648493;
var D = -BigInt("4513249062541557337682894930092624173785641285191125241628941591882900924598840740"); // -121665 * invert(121666);
var I = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752"); // expMod(BigInt( 2 ), (Q - BigInt( 1 ))/4, Q);
var BASE = Object.freeze([
    BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
    BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960") // (4*invert(5)) % Q
]);
/**
 *
 * @param {bigint} b
 * @param {bigint} e
 * @param {bigint} m
 * @returns {bigint}
 */
function expMod(b, e, m) {
    if (e == BigInt(0)) {
        return BigInt(1);
    }
    else {
        var t = expMod(b, e / BigInt(2), m);
        t = (t * t) % m;
        if ((e % BigInt(2)) !== BigInt(0)) {
            t = (0, positiveMod_1.positiveMod)(t * b, m);
        }
        return t;
    }
}
function invert(n) {
    var a = (0, positiveMod_1.positiveMod)(n, Q);
    var b = Q;
    var x = BigInt(0);
    var y = BigInt(1);
    var u = BigInt(1);
    var v = BigInt(0);
    while (a !== BigInt(0)) {
        var q = b / a;
        var r = b % a;
        var m = x - u * q;
        var n_1 = y - v * q;
        b = a;
        a = r;
        x = u;
        y = v;
        u = m;
        v = n_1;
    }
    return (0, positiveMod_1.positiveMod)(x, Q);
}
/**
 * @param {bigint} y
 * @returns {bigint}
 */
function recoverX(y) {
    var yy = y * y;
    var xx = (yy - BigInt(1)) * invert(D * yy + BigInt(1));
    var x = expMod(xx, Q38, Q);
    if (((x * x - xx) % Q) !== BigInt(0)) {
        x = (x * I) % Q;
    }
    if ((x % BigInt(2)) !== BigInt(0)) {
        x = Q - x;
    }
    return x;
}
/**
 * Curve point 'addition'
 * Note: this is probably the bottleneck of this Ed25519 implementation
 */
function addPointsEdwards(a, b) {
    var x1 = a[0];
    var y1 = a[1];
    var x2 = b[0];
    var y2 = b[1];
    var dxxyy = D * x1 * x2 * y1 * y2;
    var x3 = (x1 * y2 + x2 * y1) * invert(BigInt(1) + dxxyy);
    var y3 = (y1 * y2 + x1 * x2) * invert(BigInt(1) - dxxyy);
    return [(0, positiveMod_1.positiveMod)(x3, Q), (0, positiveMod_1.positiveMod)(y3, Q)];
}
exports.addPointsEdwards = addPointsEdwards;
function scalarMul(point, n) {
    if (n === BigInt(0)) {
        return [BigInt(0), BigInt(1)];
    }
    else {
        var sum = scalarMul(point, n / BigInt(2));
        sum = addPointsEdwards(sum, sum);
        if ((n % BigInt(2)) !== BigInt(0)) {
            sum = addPointsEdwards(sum, point);
        }
        return sum;
    }
}
exports.scalarMul = scalarMul;
/**
 * Curve point 'multiplication'
 */
function encodeInt(y) {
    return (0, bigintToBuffer_1.bigintToBuffer)(y, 32).reverse();
}
exports.encodeInt = encodeInt;
function decodeInt(s) {
    return BigInt("0x" + (0, types_1.byteArrToHex)(s.reverse()));
}
function bigpointToByteArray(point) {
    var _a = __read(point, 2), x = _a[0], y = _a[1];
    var bytes = encodeInt(y);
    // last bit is determined by x
    bytes[31] = ((bytes[31] & 255) | (Number(x & BigInt(1)) * 128));
    return bytes;
}
function bigpointToUint8Array(point) {
    return new Uint8Array(bigpointToByteArray(point));
}
exports.bigpointToUint8Array = bigpointToUint8Array;
function getBit(bytes, i) {
    return ((bytes[Math.floor(i / 8)] >> i % 8) & 1);
}
function isOnCurve(point) {
    var x = point[0];
    var y = point[1];
    var xx = x * x;
    var yy = y * y;
    return (-xx + yy - BigInt(1) - D * xx * yy) % Q == BigInt(0);
}
function pointFromBytes(s) {
    if (!(s instanceof Uint8Array))
        s = forceUint8Array(s);
    // assert(s.length === 32, "point must have length of 32; point length:" + s.length);
    var bytes = s.slice(0, 32);
    bytes[31] = (bytes[31] & 127);
    var y = decodeInt(bytes);
    var x = recoverX(y);
    if (Number(x & BigInt(1)) !== getBit(s, 255)) {
        x = Q - x;
    }
    var point = [x, y];
    if (!isOnCurve(point))
        throw new Error("point isn't on curve");
    return point;
}
exports.pointFromBytes = pointFromBytes;
var ipow2_253 = BigInt("28948022309329048855892746252171976963317496166410141009864396001978282409984"); // ipow2(253)
function scalarFromBytes(h) {
    var bytes = h.slice(0, 32);
    bytes[0] = (bytes[0] & 248);
    bytes[31] = (bytes[31] & 63);
    return ipow2_253 + BigInt("0x" + (0, types_1.byteArrToHex)(bytes.reverse()));
}
exports.scalarFromBytes = scalarFromBytes;
function scalarToBytes(s) {
    s = (0, positiveMod_1.positiveMod)(s, CURVE_ORDER);
    var bytes = encodeInt(s);
    bytes.reverse();
    return bytes;
}
exports.scalarToBytes = scalarToBytes;
function ihash(m) {
    return decodeInt((0, sha2_512_1.sha2_512_sync)(m));
}
function forceUint8Array(stuff) {
    if (stuff instanceof Uint8Array)
        return stuff;
    if (stuff instanceof ArrayBuffer)
        return new Uint8Array(stuff);
    if (typeof stuff === "string")
        return (0, uint8array_utils_1.fromHex)(stuff);
    return new Uint8Array(stuff);
}
function scalarMultBase(scalar) {
    return scalarMul(BASE, scalar);
}
exports.scalarMultBase = scalarMultBase;
////////////////////////////////////////////////////////////////////////////////////////////////////////// 
//------------------------------------------------------------------------------------------------------// 
//------------------------------------------- key management -------------------------------------------// 
//------------------------------------------- and derivation -------------------------------------------// 
//------------------------------------------------------------------------------------------------------// 
////////////////////////////////////////////////////////////////////////////////////////////////////////// 
function getExtendEd25519PrivateKeyComponentsAsBytes_sync(privateKey) {
    var extended = (0, sha2_512_1.sha2_512_sync)(privateKey);
    return [extended.slice(0, 32), extended.slice(32, 64)];
}
exports.getExtendEd25519PrivateKeyComponentsAsBytes_sync = getExtendEd25519PrivateKeyComponentsAsBytes_sync;
function getExtendEd25519PrivateKeyComponents_sync(privateKey) {
    var _a = __read(getExtendEd25519PrivateKeyComponentsAsBytes_sync(privateKey), 2), a_bytes = _a[0], extension = _a[1];
    return [scalarFromBytes(a_bytes), extension];
}
exports.getExtendEd25519PrivateKeyComponents_sync = getExtendEd25519PrivateKeyComponents_sync;
function getExtendedEd25519PrivateKey_sync(privateKey) {
    privateKey = Uint8Array.prototype.slice.call(forceUint8Array(privateKey), 0, 32);
    var extended = (0, sha2_512_1.sha2_512_sync)(privateKey);
    extended.set(privateKey, 0);
    return extended;
}
exports.getExtendedEd25519PrivateKey_sync = getExtendedEd25519PrivateKey_sync;
function getExtendedEd25519PrivateKey(privateKey) {
    return __awaiter(this, void 0, void 0, function () {
        var extended;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // here `__hasNativeSupport` instead of `await ensureNativeSupport()` is fine
                    // because we want to use `sha2_512`, wich implies different tests than the ones
                    // used in `ensureNativeSupport`; `__hasNativeSupport` at least tell us if there is a `crypto` global at all 
                    if (!__hasNativeSupport)
                        return [2 /*return*/, getExtendedEd25519PrivateKey_sync(privateKey)];
                    privateKey = Uint8Array.prototype.slice.call(forceUint8Array(privateKey), 0, 32);
                    return [4 /*yield*/, (0, sha2_512_1.sha2_512)(privateKey)];
                case 1:
                    extended = _a.sent();
                    extended.set(privateKey, 0);
                    return [2 /*return*/, extended];
            }
        });
    });
}
exports.getExtendedEd25519PrivateKey = getExtendedEd25519PrivateKey;
function deriveEd25519PublicKey_sync(privateKey) {
    var extended = (0, sha2_512_1.sha2_512_sync)(privateKey);
    var a = scalarFromBytes(extended);
    var A = scalarMul(BASE, a);
    return bigpointToByteArray(A);
}
exports.deriveEd25519PublicKey_sync = deriveEd25519PublicKey_sync;
function wrapped_deriveEd25519PublicKey_sync(privateKey) {
    return Promise.resolve(deriveEd25519PublicKey_sync(privateKey));
}
function deriveEd25519PublicKey_async(privateKey) {
    return __awaiter(this, void 0, void 0, function () {
        var extended, a, A;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!__hasNativeSupport)
                        return [2 /*return*/, deriveEd25519PublicKey_sync(privateKey)];
                    return [4 /*yield*/, (0, sha2_512_1.sha2_512)(privateKey)];
                case 1:
                    extended = _a.sent();
                    a = scalarFromBytes(extended);
                    A = scalarMul(BASE, a);
                    return [2 /*return*/, bigpointToByteArray(A)];
            }
        });
    });
}
exports.deriveEd25519PublicKey = __hasNativeSupport ? deriveEd25519PublicKey_async : wrapped_deriveEd25519PublicKey_sync;
function extendedToPublic(extended) {
    extended = forceUint8Array(extended);
    var a = scalarFromBytes(extended);
    var A = scalarMul(BASE, a);
    return new Uint8Array(bigpointToByteArray(A));
}
exports.extendedToPublic = extendedToPublic;
/** sign a message with a (32 bytes) private key */
function signEd25519_sync(message, privateKey) {
    message = forceUint8Array(message);
    privateKey = forceUint8Array(privateKey);
    var extendedKey = privateKey.length === 64 ?
        privateKey :
        (0, sha2_512_1.sha2_512_sync)(privateKey);
    return signExtendedEd25519_sync(message, extendedKey);
}
exports.signEd25519_sync = signEd25519_sync;
/** sign a message with a (32 bytes) private key */
function signEd25519(message, privateKey) {
    return __awaiter(this, void 0, void 0, function () {
        var extended, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    privateKey = forceUint8Array(privateKey);
                    if (!(privateKey.length === 64)) return [3 /*break*/, 1];
                    _a = privateKey;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, (0, sha2_512_1.sha2_512)(privateKey)];
                case 2:
                    _a = _b.sent();
                    _b.label = 3;
                case 3:
                    extended = _a;
                    return [4 /*yield*/, (0, exports.signExtendedEd25519)(message, extended)];
                case 4: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
exports.signEd25519 = signEd25519;
/** sign a message with a (64 bytes) private key */
function signExtendedEd25519_sync(_message, _extendedKey) {
    var _a;
    var message = forceUint8Array(_message);
    var privateKeyHash = forceUint8Array(_extendedKey);
    if (privateKeyHash.length !== 64)
        throw new Error('signExtendedEd25519_sync:: extended key must have length 64');
    var a = scalarFromBytes(privateKeyHash);
    // for convenience getulate publicKey here:
    var publicKey = bigpointToByteArray(scalarMul(BASE, a));
    var r = ihash((0, uint8array_utils_1.concatUint8Array)(privateKeyHash.slice(32, 64), forceUint8Array(message)));
    var R = scalarMul(BASE, r);
    var S = (0, positiveMod_1.positiveMod)(r +
        ihash((0, uint8array_utils_1.concatUint8Array)(bigpointToByteArray(R), publicKey, forceUint8Array(message))) * a, CURVE_ORDER);
    var pubKey = publicKey;
    var signature = (0, uint8array_utils_1.concatUint8Array)(bigpointToByteArray(R), encodeInt(S));
    return _a = {
            0: pubKey,
            1: signature,
            length: 2
        },
        _a[Symbol.iterator] = function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, pubKey];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, signature];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        },
        _a.pubKey = pubKey,
        _a.signature = signature,
        _a;
}
exports.signExtendedEd25519_sync = signExtendedEd25519_sync;
function wrapped_signExtendedEd25519_sync(message, extendedKey) {
    return Promise.resolve(signExtendedEd25519_sync(message, extendedKey));
}
/** sign a message with a (64 bytes) private key */
function nativeExtendedSignEd25519(_message, _extendedKey) {
    return __awaiter(this, void 0, void 0, function () {
        var message, privateKeyHash, a, pubKey, signature;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ensureNativeSupport()];
                case 1:
                    if (!(_b.sent()))
                        return [2 /*return*/, signExtendedEd25519_sync(_message, _extendedKey)];
                    message = forceUint8Array(_message);
                    privateKeyHash = forceUint8Array(_extendedKey);
                    if (privateKeyHash.length !== 64)
                        throw new Error('nativeExtendedSignEd25519:: extended key must have length 64');
                    a = scalarFromBytes(privateKeyHash);
                    pubKey = bigpointToByteArray(scalarMul(BASE, a));
                    return [4 /*yield*/, nativeEd25519Sign(privateKeyHash, message)];
                case 2:
                    signature = _b.sent();
                    return [2 /*return*/, (_a = {
                                0: pubKey,
                                1: signature,
                                length: 2
                            },
                            _a[Symbol.iterator] = function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, pubKey];
                                        case 1:
                                            _a.sent();
                                            return [4 /*yield*/, signature];
                                        case 2:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            },
                            _a.pubKey = pubKey,
                            _a.signature = signature,
                            _a)];
            }
        });
    });
}
/** sign a message with a (64 bytes) private key */
exports.signExtendedEd25519 = __hasNativeSupport ? nativeExtendedSignEd25519 : wrapped_signExtendedEd25519_sync;
/** sign a message with a (32 bytes) private key */
function getEd25519Signature_sync(message, privateKey) {
    return signEd25519_sync(message, privateKey).signature;
}
exports.getEd25519Signature_sync = getEd25519Signature_sync;
function wrapped_getEd25519Signature_sync(message, privateKey) {
    return Promise.resolve(getEd25519Signature_sync(message, privateKey));
}
/** sign a message with a (32 bytes) private key */
exports.getEd25519Signature = __hasNativeSupport ? nativeEd25519Sign : wrapped_getEd25519Signature_sync;
///////////////////////////////////////////////////////////////////////////////////////////////////// 
//-------------------------------------------------------------------------------------------------// 
//------------------------------------------- verifying -------------------------------------------// 
//-------------------------------------------------------------------------------------------------// 
/////////////////////////////////////////////////////////////////////////////////////////////////////
function verifyEd25519Signature_sync(_signature, _message, _publicKey) {
    var signature = forceUint8Array(_signature);
    var message = forceUint8Array(_message);
    var publicKey = forceUint8Array(_publicKey);
    if (signature.length !== 64 || publicKey.length !== 32) {
        throw new Error("unexpected signature length ".concat(signature.length));
    }
    var R_bytes = forceUint8Array(signature).slice(0, 32);
    var R = pointFromBytes(R_bytes);
    var A = pointFromBytes(forceUint8Array(publicKey));
    var S = decodeInt(forceUint8Array(signature).slice(32, 64));
    var h = ihash((0, uint8array_utils_1.concatUint8Array)(R_bytes, publicKey, message));
    var left = scalarMul(BASE, S);
    var right = addPointsEdwards(R, scalarMul(A, h));
    return (left[0] == right[0]) && (left[1] == right[1]);
}
exports.verifyEd25519Signature_sync = verifyEd25519Signature_sync;
function wrapped_verifyEd25519Signature_sync(signature, message, publicKey) {
    return Promise.resolve(verifyEd25519Signature_sync(signature, message, publicKey));
}
exports.verifyEd25519Signature = __hasNativeSupport ? nativeEd25519Verify : wrapped_verifyEd25519Signature_sync;


/***/ }),

/***/ 69631:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hasGlobalWebCrypto = void 0;
var hasGlobalThis = true;
try {
    hasGlobalThis = typeof globalThis !== "undefined";
}
catch (_a) {
    hasGlobalThis = false;
}
var _hasGlobalWebCrypto = hasGlobalThis;
if (hasGlobalThis) {
    try {
        _hasGlobalWebCrypto = (typeof globalThis.crypto !== "undefined" &&
            typeof globalThis.crypto.subtle !== "undefined");
    }
    catch (_b) {
        _hasGlobalWebCrypto = false;
    }
}
exports.hasGlobalWebCrypto = _hasGlobalWebCrypto;


/***/ }),

/***/ 24561:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hmacSHA512 = void 0;
var hmac_1 = __webpack_require__(59709);
var sha512_1 = __webpack_require__(17508);
/**
 * here because we need it in `@harmoniclabs/bip32_ed25519`
 *
 * and in particular, because it is a dependency of `pbkdf2` (which could also be calculated using native webcrypto)
 */
function hmacSHA512(key, data) {
    return new Uint8Array((0, hmac_1.hmac)(sha512_1.sha512, key, data));
}
exports.hmacSHA512 = hmacSHA512;


/***/ }),

/***/ 15251:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(37209), exports);
__exportStar(__webpack_require__(27092), exports);
__exportStar(__webpack_require__(48339), exports);
__exportStar(__webpack_require__(23985), exports);
__exportStar(__webpack_require__(24561), exports);
__exportStar(__webpack_require__(98413), exports);
__exportStar(__webpack_require__(29558), exports);
__exportStar(__webpack_require__(83610), exports);
__exportStar(__webpack_require__(1824), exports);
__exportStar(__webpack_require__(57753), exports);
__exportStar(__webpack_require__(80247), exports);
__exportStar(__webpack_require__(16566), exports);
__exportStar(__webpack_require__(28243), exports);
__exportStar(__webpack_require__(34183), exports);


/***/ }),

/***/ 98413:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.keccak_512 = exports.keccak_384 = exports.keccak_224 = exports.keccak_256 = void 0;
var noble = __importStar(__webpack_require__(73117));
function keccak_256(msg) {
    return noble.keccak_256(msg);
}
exports.keccak_256 = keccak_256;
function keccak_224(msg) {
    return noble.keccak_224(msg);
}
exports.keccak_224 = keccak_224;
function keccak_384(msg) {
    return noble.keccak_384(msg);
}
exports.keccak_384 = keccak_384;
function keccak_512(msg) {
    return noble.keccak_512(msg);
}
exports.keccak_512 = keccak_512;


/***/ }),

/***/ 2098:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.output = exports.exists = exports.hash = exports.bytes = exports.bool = exports.number = exports.isBytes = void 0;
function number(n) {
    if (!Number.isSafeInteger(n) || n < 0)
        throw new Error("positive integer expected, not ".concat(n));
}
exports.number = number;
function bool(b) {
    if (typeof b !== 'boolean')
        throw new Error("boolean expected, not ".concat(b));
}
exports.bool = bool;
// copied from utils
function isBytes(a) {
    return (a instanceof Uint8Array ||
        (a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array'));
}
exports.isBytes = isBytes;
function bytes(b) {
    var lengths = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        lengths[_i - 1] = arguments[_i];
    }
    if (!isBytes(b))
        throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length))
        throw new Error("Uint8Array expected of length ".concat(lengths, ", not of length=").concat(b.length));
}
exports.bytes = bytes;
function hash(hash) {
    if (typeof hash !== 'function' || typeof hash.create !== 'function')
        throw new Error('Hash should be wrapped by utils.wrapConstructor');
    number(hash.outputLen);
    number(hash.blockLen);
}
exports.hash = hash;
function exists(instance, checkFinished) {
    if (checkFinished === void 0) { checkFinished = true; }
    if (instance.destroyed)
        throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished)
        throw new Error('Hash#digest() has already been called');
}
exports.exists = exists;
function output(out, instance) {
    bytes(out);
    var min = instance.outputLen;
    if (out.length < min) {
        throw new Error("digestInto() expects output buffer of length at least ".concat(min));
    }
}
exports.output = output;
var assert = { number: number, bool: bool, bytes: bytes, hash: hash, exists: exists, output: output };
exports["default"] = assert;


/***/ }),

/***/ 37962:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HashMD = exports.Maj = exports.Chi = void 0;
var _assert_1 = __webpack_require__(2098);
var utils_1 = __webpack_require__(74599);
// Polyfill for Safari 14
function setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function')
        return view.setBigUint64(byteOffset, value, isLE);
    var _32n = BigInt(32);
    var _u32_max = BigInt(0xffffffff);
    var wh = Number((value >> _32n) & _u32_max);
    var wl = Number(value & _u32_max);
    var h = isLE ? 4 : 0;
    var l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Choice: a ? b : c
var Chi = function (a, b, c) { return (a & b) ^ (~a & c); };
exports.Chi = Chi;
// Majority function, true if any two inpust is true
var Maj = function (a, b, c) { return (a & b) ^ (a & c) ^ (b & c); };
exports.Maj = Maj;
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */
var HashMD = /** @class */ (function (_super) {
    __extends(HashMD, _super);
    function HashMD(blockLen, outputLen, padOffset, isLE) {
        var _this = _super.call(this) || this;
        _this.blockLen = blockLen;
        _this.outputLen = outputLen;
        _this.padOffset = padOffset;
        _this.isLE = isLE;
        _this.finished = false;
        _this.length = 0;
        _this.pos = 0;
        _this.destroyed = false;
        _this.buffer = new Uint8Array(blockLen);
        _this.view = (0, utils_1.createView)(_this.buffer);
        return _this;
    }
    HashMD.prototype.update = function (data) {
        (0, _assert_1.exists)(this);
        var _a = this, view = _a.view, buffer = _a.buffer, blockLen = _a.blockLen;
        data = (0, utils_1.toBytes)(data);
        var len = data.length;
        for (var pos = 0; pos < len;) {
            var take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                var dataView = (0, utils_1.createView)(data);
                for (; blockLen <= len - pos; pos += blockLen)
                    this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    };
    HashMD.prototype.digestInto = function (out) {
        (0, _assert_1.exists)(this);
        (0, _assert_1.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        var _a = this, buffer = _a.buffer, view = _a.view, blockLen = _a.blockLen, isLE = _a.isLE;
        var pos = this.pos;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for (var i = pos; i < blockLen; i++)
            buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        var oview = (0, utils_1.createView)(out);
        var len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4)
            throw new Error('_sha2: outputLen should be aligned to 32bit');
        var outLen = len / 4;
        var state = this.get();
        if (outLen > state.length)
            throw new Error('_sha2: outputLen bigger than state');
        for (var i = 0; i < outLen; i++)
            oview.setUint32(4 * i, state[i], isLE);
    };
    HashMD.prototype.digest = function () {
        var _a = this, buffer = _a.buffer, outputLen = _a.outputLen;
        this.digestInto(buffer);
        var res = Uint8Array.prototype.slice.call(buffer, 0, outputLen);
        this.destroy();
        return res;
    };
    HashMD.prototype._cloneInto = function (to) {
        to || (to = new this.constructor());
        to.set.apply(to, __spreadArray([], __read(this.get()), false));
        var _a = this, blockLen = _a.blockLen, buffer = _a.buffer, length = _a.length, finished = _a.finished, destroyed = _a.destroyed, pos = _a.pos;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen)
            to.buffer.set(buffer);
        return to;
    };
    return HashMD;
}(utils_1.Hash));
exports.HashMD = HashMD;


/***/ }),

/***/ 2629:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createCurve = exports.getHash = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
var hmac_1 = __webpack_require__(59709);
var utils_1 = __webpack_require__(74599);
var weierstrass_1 = __webpack_require__(76326);
// connects noble-curves to noble-hashes
function getHash(hash) {
    return {
        hash: hash,
        hmac: function (key) {
            var msgs = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                msgs[_i - 1] = arguments[_i];
            }
            return (0, hmac_1.hmac)(hash, key, utils_1.concatBytes.apply(void 0, __spreadArray([], __read(msgs), false)));
        },
        randomBytes: utils_1.randomBytes,
    };
}
exports.getHash = getHash;
function createCurve(curveDef, defHash) {
    var create = function (hash) { return (0, weierstrass_1.weierstrass)(__assign(__assign({}, curveDef), getHash(hash))); };
    return Object.freeze(__assign(__assign({}, create(defHash)), { create: create }));
}
exports.createCurve = createCurve;


/***/ }),

/***/ 90310:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.add5H = exports.add5L = exports.add4H = exports.add4L = exports.add3H = exports.add3L = exports.add = exports.rotlBL = exports.rotlBH = exports.rotlSL = exports.rotlSH = exports.rotr32L = exports.rotr32H = exports.rotrBL = exports.rotrBH = exports.rotrSL = exports.rotrSH = exports.shrSL = exports.shrSH = exports.toBig = exports.split = exports.fromBig = void 0;
/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-hashes/blob/6ae82e75d4c354d53a488e95b1bfe9cba90bd6ff/src/_u64.ts#L1

it was modified and adapted to this repository to re-use already defined stuff

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var U32_MASK64 = /* @__PURE__ */ BigInt(Math.pow(2, 32) - 1);
var _32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function fromBig(n, le) {
    if (le === void 0) { le = false; }
    if (le)
        return { h: Number(n & U32_MASK64), l: Number((n >> _32n) & U32_MASK64) };
    return { h: Number((n >> _32n) & U32_MASK64) | 0, l: Number(n & U32_MASK64) | 0 };
}
exports.fromBig = fromBig;
function split(lst, le) {
    var _a;
    if (le === void 0) { le = false; }
    var Ah = new Uint32Array(lst.length);
    var Al = new Uint32Array(lst.length);
    for (var i = 0; i < lst.length; i++) {
        var _b = fromBig(lst[i], le), h = _b.h, l = _b.l;
        _a = __read([h, l], 2), Ah[i] = _a[0], Al[i] = _a[1];
    }
    return [Ah, Al];
}
exports.split = split;
var toBig = function (h, l) { return (BigInt(h >>> 0) << _32n) | BigInt(l >>> 0); };
exports.toBig = toBig;
// for Shift in [0, 32)
var shrSH = function (h, _l, s) { return h >>> s; };
exports.shrSH = shrSH;
var shrSL = function (h, l, s) { return (h << (32 - s)) | (l >>> s); };
exports.shrSL = shrSL;
// Right rotate for Shift in [1, 32)
var rotrSH = function (h, l, s) { return (h >>> s) | (l << (32 - s)); };
exports.rotrSH = rotrSH;
var rotrSL = function (h, l, s) { return (h << (32 - s)) | (l >>> s); };
exports.rotrSL = rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
var rotrBH = function (h, l, s) { return (h << (64 - s)) | (l >>> (s - 32)); };
exports.rotrBH = rotrBH;
var rotrBL = function (h, l, s) { return (h >>> (s - 32)) | (l << (64 - s)); };
exports.rotrBL = rotrBL;
// Right rotate for shift===32 (just swaps l&h)
var rotr32H = function (_h, l) { return l; };
exports.rotr32H = rotr32H;
var rotr32L = function (h, _l) { return h; };
exports.rotr32L = rotr32L;
// Left rotate for Shift in [1, 32)
var rotlSH = function (h, l, s) { return (h << s) | (l >>> (32 - s)); };
exports.rotlSH = rotlSH;
var rotlSL = function (h, l, s) { return (l << s) | (h >>> (32 - s)); };
exports.rotlSL = rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
var rotlBH = function (h, l, s) { return (l << (s - 32)) | (h >>> (64 - s)); };
exports.rotlBH = rotlBH;
var rotlBL = function (h, l, s) { return (h << (s - 32)) | (l >>> (64 - s)); };
exports.rotlBL = rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function add(Ah, Al, Bh, Bl) {
    var l = (Al >>> 0) + (Bl >>> 0);
    return { h: (Ah + Bh + ((l / Math.pow(2, 32)) | 0)) | 0, l: l | 0 };
}
exports.add = add;
// Addition with more than 2 elements
var add3L = function (Al, Bl, Cl) { return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0); };
exports.add3L = add3L;
var add3H = function (low, Ah, Bh, Ch) {
    return (Ah + Bh + Ch + ((low / Math.pow(2, 32)) | 0)) | 0;
};
exports.add3H = add3H;
var add4L = function (Al, Bl, Cl, Dl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
};
exports.add4L = add4L;
var add4H = function (low, Ah, Bh, Ch, Dh) {
    return (Ah + Bh + Ch + Dh + ((low / Math.pow(2, 32)) | 0)) | 0;
};
exports.add4H = add4H;
var add5L = function (Al, Bl, Cl, Dl, El) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
};
exports.add5L = add5L;
var add5H = function (low, Ah, Bh, Ch, Dh, Eh) {
    return (Ah + Bh + Ch + Dh + Eh + ((low / Math.pow(2, 32)) | 0)) | 0;
};
exports.add5H = add5H;


/***/ }),

/***/ 52682:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/abstract/bls.ts#

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bls = void 0;
var modular_1 = __webpack_require__(99764);
var utils_1 = __webpack_require__(92035);
// prettier-ignore
var hash_to_curve_1 = __webpack_require__(50288);
var weierstrass_1 = __webpack_require__(76326);
// prettier-ignore
var _2n = BigInt(2), _3n = BigInt(3);
function bls(CURVE) {
    // Fields are specific for curve, so for now we'll need to pass them with opts
    var _a = CURVE.fields, Fp = _a.Fp, Fr = _a.Fr, Fp2 = _a.Fp2, Fp6 = _a.Fp6, Fp12 = _a.Fp12;
    var BLS_X_LEN = (0, utils_1.bitLen)(CURVE.params.x);
    // Pre-compute coefficients for sparse multiplication
    // Point addition and point double calculations is reused for coefficients
    function calcPairingPrecomputes(p) {
        var x = p.x, y = p.y;
        // prettier-ignore
        var Qx = x, Qy = y, Qz = Fp2.ONE;
        // prettier-ignore
        var Rx = Qx, Ry = Qy, Rz = Qz;
        var ell_coeff = [];
        for (var i = BLS_X_LEN - 2; i >= 0; i--) {
            // Double
            var t0 = Fp2.sqr(Ry); // Ry²
            var t1 = Fp2.sqr(Rz); // Rz²
            var t2 = Fp2.multiplyByB(Fp2.mul(t1, _3n)); // 3 * T1 * B
            var t3 = Fp2.mul(t2, _3n); // 3 * T2
            var t4 = Fp2.sub(Fp2.sub(Fp2.sqr(Fp2.add(Ry, Rz)), t1), t0); // (Ry + Rz)² - T1 - T0
            ell_coeff.push([
                Fp2.sub(t2, t0),
                Fp2.mul(Fp2.sqr(Rx), _3n),
                Fp2.neg(t4), // -T4
            ]);
            Rx = Fp2.div(Fp2.mul(Fp2.mul(Fp2.sub(t0, t3), Rx), Ry), _2n); // ((T0 - T3) * Rx * Ry) / 2
            Ry = Fp2.sub(Fp2.sqr(Fp2.div(Fp2.add(t0, t3), _2n)), Fp2.mul(Fp2.sqr(t2), _3n)); // ((T0 + T3) / 2)² - 3 * T2²
            Rz = Fp2.mul(t0, t4); // T0 * T4
            if ((0, utils_1.bitGet)(CURVE.params.x, i)) {
                // Addition
                var t0_1 = Fp2.sub(Ry, Fp2.mul(Qy, Rz)); // Ry - Qy * Rz
                var t1_1 = Fp2.sub(Rx, Fp2.mul(Qx, Rz)); // Rx - Qx * Rz
                ell_coeff.push([
                    Fp2.sub(Fp2.mul(t0_1, Qx), Fp2.mul(t1_1, Qy)),
                    Fp2.neg(t0_1),
                    t1_1, // T1
                ]);
                var t2_1 = Fp2.sqr(t1_1); // T1²
                var t3_1 = Fp2.mul(t2_1, t1_1); // T2 * T1
                var t4_1 = Fp2.mul(t2_1, Rx); // T2 * Rx
                var t5 = Fp2.add(Fp2.sub(t3_1, Fp2.mul(t4_1, _2n)), Fp2.mul(Fp2.sqr(t0_1), Rz)); // T3 - 2 * T4 + T0² * Rz
                Rx = Fp2.mul(t1_1, t5); // T1 * T5
                Ry = Fp2.sub(Fp2.mul(Fp2.sub(t4_1, t5), t0_1), Fp2.mul(t3_1, Ry)); // (T4 - T5) * T0 - T3 * Ry
                Rz = Fp2.mul(Rz, t3_1); // Rz * T3
            }
        }
        return ell_coeff;
    }
    function millerLoop(ell, g1) {
        var x = CURVE.params.x;
        var Px = g1[0];
        var Py = g1[1];
        var f12 = Fp12.ONE;
        for (var j = 0, i = BLS_X_LEN - 2; i >= 0; i--, j++) {
            var E = ell[j];
            f12 = Fp12.multiplyBy014(f12, E[0], Fp2.mul(E[1], Px), Fp2.mul(E[2], Py));
            if ((0, utils_1.bitGet)(x, i)) {
                j += 1;
                var F = ell[j];
                f12 = Fp12.multiplyBy014(f12, F[0], Fp2.mul(F[1], Px), Fp2.mul(F[2], Py));
            }
            if (i !== 0)
                f12 = Fp12.sqr(f12);
        }
        return Fp12.conjugate(f12);
    }
    var utils = {
        randomPrivateKey: function () {
            var length = (0, modular_1.getMinHashLength)(Fr.ORDER);
            return (0, modular_1.mapHashToField)(CURVE.randomBytes(length), Fr.ORDER);
        },
        calcPairingPrecomputes: calcPairingPrecomputes,
    };
    // Point on G1 curve: (x, y)
    var G1_ = (0, weierstrass_1.weierstrassPoints)(__assign({ n: Fr.ORDER }, CURVE.G1));
    var G1 = Object.assign(G1_, (0, hash_to_curve_1.createHasher)(G1_.ProjectivePoint, CURVE.G1.mapToCurve, __assign(__assign({}, CURVE.htfDefaults), CURVE.G1.htfDefaults)));
    function pairingPrecomputes(point) {
        var p = point;
        if (p._PPRECOMPUTES)
            return p._PPRECOMPUTES;
        p._PPRECOMPUTES = calcPairingPrecomputes(point.toAffine());
        return p._PPRECOMPUTES;
    }
    // TODO: export
    // function clearPairingPrecomputes(point: G2) {
    //   const p = point as G2 & withPairingPrecomputes;
    //   p._PPRECOMPUTES = undefined;
    // }
    // Point on G2 curve (complex numbers): (x₁, x₂+i), (y₁, y₂+i)
    var G2_ = (0, weierstrass_1.weierstrassPoints)(__assign({ n: Fr.ORDER }, CURVE.G2));
    var G2 = Object.assign(G2_, (0, hash_to_curve_1.createHasher)(G2_.ProjectivePoint, CURVE.G2.mapToCurve, __assign(__assign({}, CURVE.htfDefaults), CURVE.G2.htfDefaults)));
    var ShortSignature = CURVE.G1.ShortSignature;
    var Signature = CURVE.G2.Signature;
    // Calculates bilinear pairing
    function pairing(Q, P, withFinalExponent) {
        if (withFinalExponent === void 0) { withFinalExponent = true; }
        if (Q.equals(G1.ProjectivePoint.ZERO) || P.equals(G2.ProjectivePoint.ZERO))
            throw new Error('pairing is not available for ZERO point');
        Q.assertValidity();
        P.assertValidity();
        // Performance: 9ms for millerLoop and ~14ms for exp.
        var Qa = Q.toAffine();
        var looped = millerLoop(pairingPrecomputes(P), [Qa.x, Qa.y]);
        return withFinalExponent ? Fp12.finalExponentiate(looped) : looped;
    }
    function normP1(point) {
        return point instanceof G1.ProjectivePoint ? point : G1.ProjectivePoint.fromHex(point);
    }
    function normP1Hash(point, htfOpts) {
        return point instanceof G1.ProjectivePoint
            ? point
            : G1.hashToCurve((0, utils_1.ensureBytes)('point', point), htfOpts);
    }
    function normP2(point) {
        return point instanceof G2.ProjectivePoint ? point : Signature.fromHex(point);
    }
    function normP2Hash(point, htfOpts) {
        return point instanceof G2.ProjectivePoint
            ? point
            : G2.hashToCurve((0, utils_1.ensureBytes)('point', point), htfOpts);
    }
    // Multiplies generator (G1) by private key.
    // P = pk x G
    function getPublicKey(privateKey) {
        return G1.ProjectivePoint.fromPrivateKey(privateKey).toRawBytes(true);
    }
    // Multiplies generator (G2) by private key.
    // P = pk x G
    function getPublicKeyForShortSignatures(privateKey) {
        return G2.ProjectivePoint.fromPrivateKey(privateKey).toRawBytes(true);
    }
    function sign(message, privateKey, htfOpts) {
        var msgPoint = normP2Hash(message, htfOpts);
        msgPoint.assertValidity();
        var sigPoint = msgPoint.multiply(G1.normPrivateKeyToScalar(privateKey));
        if (message instanceof G2.ProjectivePoint)
            return sigPoint;
        return Signature.toRawBytes(sigPoint);
    }
    function signShortSignature(message, privateKey, htfOpts) {
        var msgPoint = normP1Hash(message, htfOpts);
        msgPoint.assertValidity();
        var sigPoint = msgPoint.multiply(G1.normPrivateKeyToScalar(privateKey));
        if (message instanceof G1.ProjectivePoint)
            return sigPoint;
        return ShortSignature.toRawBytes(sigPoint);
    }
    // Checks if pairing of public key & hash is equal to pairing of generator & signature.
    // e(P, H(m)) == e(G, S)
    function verify(signature, message, publicKey, htfOpts) {
        var P = normP1(publicKey);
        var Hm = normP2Hash(message, htfOpts);
        var G = G1.ProjectivePoint.BASE;
        var S = normP2(signature);
        // Instead of doing 2 exponentiations, we use property of billinear maps
        // and do one exp after multiplying 2 points.
        var ePHm = pairing(P.negate(), Hm, false);
        var eGS = pairing(G, S, false);
        var exp = Fp12.finalExponentiate(Fp12.mul(eGS, ePHm));
        return Fp12.eql(exp, Fp12.ONE);
    }
    // Checks if pairing of public key & hash is equal to pairing of generator & signature.
    // e(S, G) == e(H(m), P)
    function verifyShortSignature(signature, message, publicKey, htfOpts) {
        var P = normP2(publicKey);
        var Hm = normP1Hash(message, htfOpts);
        var G = G2.ProjectivePoint.BASE;
        var S = normP1(signature);
        // Instead of doing 2 exponentiations, we use property of billinear maps
        // and do one exp after multiplying 2 points.
        var eHmP = pairing(Hm, P, false);
        var eSG = pairing(S, G.negate(), false);
        var exp = Fp12.finalExponentiate(Fp12.mul(eSG, eHmP));
        return Fp12.eql(exp, Fp12.ONE);
    }
    function aggregatePublicKeys(publicKeys) {
        if (!publicKeys.length)
            throw new Error('Expected non-empty array');
        var agg = publicKeys.map(normP1).reduce(function (sum, p) { return sum.add(p); }, G1.ProjectivePoint.ZERO);
        var aggAffine = agg; //.toAffine();
        if (publicKeys[0] instanceof G1.ProjectivePoint) {
            aggAffine.assertValidity();
            return aggAffine;
        }
        // toRawBytes ensures point validity
        return aggAffine.toRawBytes(true);
    }
    function aggregateSignatures(signatures) {
        if (!signatures.length)
            throw new Error('Expected non-empty array');
        var agg = signatures.map(normP2).reduce(function (sum, s) { return sum.add(s); }, G2.ProjectivePoint.ZERO);
        var aggAffine = agg; //.toAffine();
        if (signatures[0] instanceof G2.ProjectivePoint) {
            aggAffine.assertValidity();
            return aggAffine;
        }
        return Signature.toRawBytes(aggAffine);
    }
    function aggregateShortSignatures(signatures) {
        if (!signatures.length)
            throw new Error('Expected non-empty array');
        var agg = signatures.map(normP1).reduce(function (sum, s) { return sum.add(s); }, G1.ProjectivePoint.ZERO);
        var aggAffine = agg; //.toAffine();
        if (signatures[0] instanceof G1.ProjectivePoint) {
            aggAffine.assertValidity();
            return aggAffine;
        }
        return ShortSignature.toRawBytes(aggAffine);
    }
    // https://ethresear.ch/t/fast-verification-of-multiple-bls-signatures/5407
    // e(G, S) = e(G, SUM(n)(Si)) = MUL(n)(e(G, Si))
    function verifyBatch(signature, messages, publicKeys, htfOpts) {
        // @ts-ignore
        // console.log('verifyBatch', bytesToHex(signature as any), messages, publicKeys.map(bytesToHex));
        var e_1, _a;
        if (!messages.length)
            throw new Error('Expected non-empty messages array');
        if (publicKeys.length !== messages.length)
            throw new Error('Pubkey count should equal msg count');
        var sig = normP2(signature);
        var nMessages = messages.map(function (i) { return normP2Hash(i, htfOpts); });
        var nPublicKeys = publicKeys.map(normP1);
        try {
            var paired = [];
            var _loop_1 = function (message) {
                var groupPublicKey = nMessages.reduce(function (groupPublicKey, subMessage, i) {
                    return subMessage === message ? groupPublicKey.add(nPublicKeys[i]) : groupPublicKey;
                }, G1.ProjectivePoint.ZERO);
                // const msg = message instanceof PointG2 ? message : await PointG2.hashToCurve(message);
                // Possible to batch pairing for same msg with different groupPublicKey here
                paired.push(pairing(groupPublicKey, message, false));
            };
            try {
                for (var _b = __values(new Set(nMessages)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var message = _c.value;
                    _loop_1(message);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            paired.push(pairing(G1.ProjectivePoint.BASE.negate(), sig, false));
            var product = paired.reduce(function (a, b) { return Fp12.mul(a, b); }, Fp12.ONE);
            var exp = Fp12.finalExponentiate(product);
            return Fp12.eql(exp, Fp12.ONE);
        }
        catch (_d) {
            return false;
        }
    }
    G1.ProjectivePoint.BASE._setWindowSize(4);
    return {
        getPublicKey: getPublicKey,
        getPublicKeyForShortSignatures: getPublicKeyForShortSignatures,
        sign: sign,
        signShortSignature: signShortSignature,
        verify: verify,
        verifyBatch: verifyBatch,
        verifyShortSignature: verifyShortSignature,
        aggregatePublicKeys: aggregatePublicKeys,
        aggregateSignatures: aggregateSignatures,
        aggregateShortSignatures: aggregateShortSignatures,
        millerLoop: millerLoop,
        pairing: pairing,
        G1: G1,
        G2: G2,
        Signature: Signature,
        ShortSignature: ShortSignature,
        fields: {
            Fr: Fr,
            Fp: Fp,
            Fp2: Fp2,
            Fp6: Fp6,
            Fp12: Fp12,
        },
        params: {
            x: CURVE.params.x,
            r: CURVE.params.r,
            G1b: CURVE.G1.b,
            G2b: CURVE.G2.b,
        },
        utils: utils,
    };
}
exports.bls = bls;


/***/ }),

/***/ 14939:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/abstract/curve.ts

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pippenger = exports.validateBasic = exports.wNAF = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// Abelian group utilities
var modular_1 = __webpack_require__(99764);
var utils_1 = __webpack_require__(92035);
var _0n = BigInt(0);
var _1n = BigInt(1);
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes
var pointPrecomputes = new WeakMap();
var pointWindowSizes = new WeakMap(); // This allows use make points immutable (nothing changes inside)
function getW(P) {
    return pointWindowSizes.get(P) || 1;
}
function constTimeNegate(condition, item) {
    var neg = item.negate();
    return condition ? neg : item;
}
function validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits)
        throw new Error('invalid window size, expected [1..' + bits + '], got W=' + W);
}
function calcWOpts(W, bits) {
    validateW(W, bits);
    var windows = Math.ceil(bits / W) + 1; // +1, because
    var windowSize = Math.pow(2, (W - 1)); // -1 because we skip zero
    return { windows: windows, windowSize: windowSize };
}
/**
 * Elliptic curve multiplication of Point by scalar. Fragile.
 * Scalars should always be less than curve order: this should be checked inside of a curve itself.
 * Creates precomputation tables for fast multiplication:
 * - private scalar is split by fixed size windows of W bits
 * - every window point is collected from window's table & added to accumulator
 * - since windows are different, same point inside tables won't be accessed more than once per calc
 * - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
 * - +1 window is neccessary for wNAF
 * - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
 *
 * @todo Research returning 2d JS array of windows, instead of a single window.
 * This would allow windows to be in different memory locations
 */
function wNAF(c, bits) {
    return {
        constTimeNegate: constTimeNegate,
        hasPrecomputes: function (elm) {
            return getW(elm) !== 1;
        },
        // non-const time multiplication ladder
        unsafeLadder: function (elm, n, p) {
            if (p === void 0) { p = c.ZERO; }
            var d = elm;
            while (n > _0n) {
                if (n & _1n)
                    p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @param elm Point instance
         * @param W window size
         * @returns precomputed point tables flattened to a single array
         */
        precomputeWindow: function (elm, W) {
            var _a = calcWOpts(W, bits), windows = _a.windows, windowSize = _a.windowSize;
            var points = [];
            var p = elm;
            var base = p;
            for (var window_1 = 0; window_1 < windows; window_1++) {
                base = p;
                points.push(base);
                // =1, because we skip zero
                for (var i = 1; i < windowSize; i++) {
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */
        wNAF: function (W, precomputes, n) {
            n = BigInt(n);
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            var _a = calcWOpts(W, bits), windows = _a.windows, windowSize = _a.windowSize;
            var p = c.ZERO;
            var f = c.BASE;
            var mask = BigInt(Math.pow(2, W) - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            var maxNumber = Math.pow(2, W);
            var shiftBy = BigInt(W);
            for (var window_2 = 0; window_2 < windows; window_2++) {
                var offset = window_2 * windowSize;
                // Extract W bits.
                var wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                var offset1 = offset;
                var offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                var cond1 = window_2 % 2 !== 0;
                var cond2 = wbits < 0;
                if (wbits === 0) {
                    // The most important part for const-time getPublicKey
                    f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                }
                else {
                    p = p.add(constTimeNegate(cond2, precomputes[offset2]));
                }
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return { p: p, f: f };
        },
        /**
         * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @param acc accumulator point to add result of multiplication
         * @returns point
         */
        wNAFUnsafe: function (W, precomputes, n, acc) {
            if (acc === void 0) { acc = c.ZERO; }
            var _a = calcWOpts(W, bits), windows = _a.windows, windowSize = _a.windowSize;
            var mask = BigInt(Math.pow(2, W) - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            var maxNumber = Math.pow(2, W);
            var shiftBy = BigInt(W);
            for (var window_3 = 0; window_3 < windows; window_3++) {
                var offset = window_3 * windowSize;
                if (n === _0n)
                    break; // No need to go over empty scalar
                // Extract W bits.
                var wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                if (wbits === 0)
                    continue;
                var curr = precomputes[offset + Math.abs(wbits) - 1]; // -1 because we skip zero
                if (wbits < 0)
                    curr = curr.negate();
                // NOTE: by re-using acc, we can save a lot of additions in case of MSM
                acc = acc.add(curr);
            }
            return acc;
        },
        getPrecomputes: function (W, P, transform) {
            // Calculate precomputes on a first run, reuse them after
            var comp = pointPrecomputes.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1)
                    pointPrecomputes.set(P, transform(comp));
            }
            return comp;
        },
        wNAFCached: function (P, n, transform) {
            var W = getW(P);
            return this.wNAF(W, this.getPrecomputes(W, P, transform), n);
        },
        wNAFCachedUnsafe: function (P, n, transform, prev) {
            var W = getW(P);
            if (W === 1)
                return this.unsafeLadder(P, n, prev); // For W=1 ladder is ~x2 faster
            return this.wNAFUnsafe(W, this.getPrecomputes(W, P, transform), n, prev);
        },
        // We calculate precomputes for elliptic curve point multiplication
        // using windowed method. This specifies window size and
        // stores precomputed values. Usually only base point would be precomputed.
        setWindowSize: function (P, W) {
            validateW(W, bits);
            pointWindowSizes.set(P, W);
            pointPrecomputes.delete(P);
        },
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, modular_1.validateField)(curve.Fp);
    (0, utils_1.validateObject)(curve, {
        n: 'bigint',
        h: 'bigint',
        Gx: 'field',
        Gy: 'field',
    }, {
        nBitLength: 'isSafeInteger',
        nByteLength: 'isSafeInteger',
    });
    // Set defaults
    return Object.freeze(__assign(__assign(__assign({}, (0, modular_1.nLength)(curve.n, curve.nBitLength)), curve), { p: curve.Fp.ORDER }));
}
exports.validateBasic = validateBasic;
function validateMSMPoints(points, c) {
    if (!Array.isArray(points))
        throw new Error('array expected');
    points.forEach(function (p, i) {
        if (!(p instanceof c))
            throw new Error('invalid point at index ' + i);
    });
}
function validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars))
        throw new Error('array of scalars expected');
    scalars.forEach(function (s, i) {
        if (!field.isValid(s))
            throw new Error('invalid scalar at index ' + i);
    });
}
/**
 * Pippenger algorithm for multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * 30x faster vs naive addition on L=4096, 10x faster with precomputes.
 * For N=254bit, L=1, it does: 1024 ADD + 254 DBL. For L=5: 1536 ADD + 254 DBL.
 * Algorithmically constant-time (for same L), even when 1 point + scalar, or when scalar = 0.
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @param scalars array of L scalars (aka private keys / bigints)
 */
function pippenger(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    validateMSMPoints(points, c);
    validateMSMScalars(scalars, fieldN);
    if (points.length !== scalars.length)
        throw new Error('arrays of points and scalars must have equal length');
    var zero = c.ZERO;
    var wbits = (0, utils_1.bitLen)(BigInt(points.length));
    var windowSize = wbits > 12 ? wbits - 3 : wbits > 4 ? wbits - 2 : wbits ? 2 : 1; // in bits
    var MASK = (1 << windowSize) - 1;
    var buckets = new Array(MASK + 1).fill(zero); // +1 for zero array
    var lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    var sum = zero;
    for (var i = lastBits; i >= 0; i -= windowSize) {
        buckets.fill(zero);
        for (var j = 0; j < scalars.length; j++) {
            var scalar = scalars[j];
            var wbits_1 = Number((scalar >> BigInt(i)) & BigInt(MASK));
            buckets[wbits_1] = buckets[wbits_1].add(points[j]);
        }
        var resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for (var j = buckets.length - 1, sumI = zero; j > 0; j--) {
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0)
            for (var j = 0; j < windowSize; j++)
                sum = sum.double();
    }
    return sum;
}
exports.pippenger = pippenger;


/***/ }),

/***/ 50288:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/abstract/hash-to-curve.ts

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createHasher = exports.isogenyMap = exports.hash_to_field = exports.expand_message_xof = exports.expand_message_xmd = void 0;
var modular_1 = __webpack_require__(99764);
var utils_1 = __webpack_require__(92035);
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
var os2ip = utils_1.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function i2osp(value, length) {
    if (value < 0 || value >= 1 << (8 * length)) {
        throw new Error("bad I2OSP call: value=".concat(value, " length=").concat(length));
    }
    var res = Array.from({ length: length }).fill(0);
    for (var i = length - 1; i >= 0; i--) {
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function strxor(a, b) {
    var arr = new Uint8Array(a.length);
    for (var i = 0; i < a.length; i++) {
        arr[i] = a[i] ^ b[i];
    }
    return arr;
}
function anum(item) {
    if (!Number.isSafeInteger(item))
        throw new Error('number expected');
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function expand_message_xmd(msg, DST, lenInBytes, H) {
    (0, utils_1.abytes)(msg);
    (0, utils_1.abytes)(DST);
    anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255)
        DST = H((0, utils_1.concatBytes)((0, utils_1.utf8ToBytes)('H2C-OVERSIZE-DST-'), DST));
    var b_in_bytes = H.outputLen, r_in_bytes = H.blockLen;
    var ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255)
        throw new Error('Invalid xmd length');
    var DST_prime = (0, utils_1.concatBytes)(DST, i2osp(DST.length, 1));
    var Z_pad = i2osp(0, r_in_bytes);
    var l_i_b_str = i2osp(lenInBytes, 2); // len_in_bytes_str
    var b = new Array(ell);
    var b_0 = H((0, utils_1.concatBytes)(Z_pad, msg, l_i_b_str, i2osp(0, 1), DST_prime));
    b[0] = H((0, utils_1.concatBytes)(b_0, i2osp(1, 1), DST_prime));
    for (var i = 1; i <= ell; i++) {
        var args = [strxor(b_0, b[i - 1]), i2osp(i + 1, 1), DST_prime];
        b[i] = H(utils_1.concatBytes.apply(void 0, __spreadArray([], __read(args), false)));
    }
    var pseudo_random_bytes = utils_1.concatBytes.apply(void 0, __spreadArray([], __read(b), false));
    return pseudo_random_bytes.slice(0, lenInBytes);
}
exports.expand_message_xmd = expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function expand_message_xof(msg, DST, lenInBytes, k, H) {
    (0, utils_1.abytes)(msg);
    (0, utils_1.abytes)(DST);
    anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        var dkLen = Math.ceil((2 * k) / 8);
        DST = H.create({ dkLen: dkLen }).update((0, utils_1.utf8ToBytes)('H2C-OVERSIZE-DST-')).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255)
        throw new Error('expand_message_xof: invalid lenInBytes');
    return (H.create({ dkLen: lenInBytes })
        .update(msg)
        .update(i2osp(lenInBytes, 2))
        // 2. DST_prime = DST || I2OSP(len(DST), 1)
        .update(DST)
        .update(i2osp(DST.length, 1))
        .digest());
}
exports.expand_message_xof = expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */
function hash_to_field(msg, count, options) {
    (0, utils_1.validateObject)(options, {
        DST: 'stringOrUint8Array',
        p: 'bigint',
        m: 'isSafeInteger',
        k: 'isSafeInteger',
        hash: 'hash',
    });
    var p = options.p, k = options.k, m = options.m, hash = options.hash, expand = options.expand, _DST = options.DST;
    (0, utils_1.abytes)(msg);
    anum(count);
    var DST = typeof _DST === 'string' ? (0, utils_1.utf8ToBytes)(_DST) : _DST;
    var log2p = p.toString(2).length;
    var L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    var len_in_bytes = count * m * L;
    var prb; // pseudo_random_bytes
    if (expand === 'xmd') {
        prb = expand_message_xmd(msg, DST, len_in_bytes, hash);
    }
    else if (expand === 'xof') {
        prb = expand_message_xof(msg, DST, len_in_bytes, k, hash);
    }
    else if (expand === '_internal_pass') {
        // for internal tests only
        prb = msg;
    }
    else {
        throw new Error('expand must be "xmd" or "xof"');
    }
    var u = new Array(count);
    for (var i = 0; i < count; i++) {
        var e = new Array(m);
        for (var j = 0; j < m; j++) {
            var elm_offset = L * (j + i * m);
            var tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, modular_1.mod)(os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
exports.hash_to_field = hash_to_field;
function isogenyMap(field, map) {
    // Make same order as in spec
    var COEFF = map.map(function (i) { return Array.from(i).reverse(); });
    return function (x, y) {
        var _a = __read(COEFF.map(function (val) {
            return val.reduce(function (acc, i) { return field.add(field.mul(acc, x), i); });
        }), 4), xNum = _a[0], xDen = _a[1], yNum = _a[2], yDen = _a[3];
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return { x: x, y: y };
    };
}
exports.isogenyMap = isogenyMap;
function createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== 'function')
        throw new Error('mapToCurve() must be defined');
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve: function (msg, options) {
            var u = hash_to_field(msg, 2, __assign(__assign(__assign({}, def), { DST: def.DST }), options));
            var u0 = Point.fromAffine(mapToCurve(u[0]));
            var u1 = Point.fromAffine(mapToCurve(u[1]));
            var P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve: function (msg, options) {
            var u = hash_to_field(msg, 1, __assign(__assign(__assign({}, def), { DST: def.encodeDST }), options));
            var P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        },
    };
}
exports.createHasher = createHasher;


/***/ }),

/***/ 99764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/abstract/modular.ts

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapHashToField = exports.getMinHashLength = exports.getFieldBytesLength = exports.hashToPrivateScalar = exports.FpSqrtEven = exports.FpSqrtOdd = exports.Field = exports.nLength = exports.FpIsSquare = exports.FpDiv = exports.FpInvertBatch = exports.FpPow = exports.validateField = exports.isNegativeLE = exports.FpSqrt = exports.tonelliShanks = exports.invert = exports.pow2 = exports.pow = exports.mod = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// Utilities for modular arithmetics and finite fields
var utils_1 = __webpack_require__(92035);
// prettier-ignore
var _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3);
// prettier-ignore
var _4n = BigInt(4), _5n = BigInt(5), _8n = BigInt(8);
// prettier-ignore
var _9n = BigInt(9), _16n = BigInt(16);
// Calculates a modulo b
function mod(a, b) {
    var result = a % b;
    return result >= _0n ? result : b + result;
}
exports.mod = mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */
// TODO: use field version && remove
function pow(num, power, modulo) {
    if (modulo <= _0n || power < _0n)
        throw new Error('Expected power/modulo > 0');
    if (modulo === _1n)
        return _0n;
    var res = _1n;
    while (power > _0n) {
        if (power & _1n)
            res = (res * num) % modulo;
        num = (num * num) % modulo;
        power >>= _1n;
    }
    return res;
}
exports.pow = pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function pow2(x, power, modulo) {
    var res = x;
    while (power-- > _0n) {
        res *= res;
        res %= modulo;
    }
    return res;
}
exports.pow2 = pow2;
// Inverses number over modulo
function invert(number, modulo) {
    if (number === _0n || modulo <= _0n) {
        throw new Error("invert: expected positive integers, got n=".concat(number, " mod=").concat(modulo));
    }
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    var a = mod(number, modulo);
    var b = modulo;
    // prettier-ignore
    var x = _0n, y = _1n, u = _1n, v = _0n;
    while (a !== _0n) {
        // JIT applies optimization if those two lines follow each other
        var q = b / a;
        var r = b % a;
        var m = x - u * q;
        var n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    var gcd = b;
    if (gcd !== _1n)
        throw new Error('invert: does not exist');
    return mod(x, modulo);
}
exports.invert = invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */
function tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    var legendreC = (P - _1n) / _2n;
    var Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for (Q = P - _1n, S = 0; Q % _2n === _0n; Q /= _2n, S++)
        ;
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for (Z = _2n; Z < P && pow(Z, legendreC, P) !== P - _1n; Z++)
        ;
    // Fast-path
    if (S === 1) {
        var p1div4_1 = (P + _1n) / _4n;
        return function tonelliFast(Fp, n) {
            var root = Fp.pow(n, p1div4_1);
            if (!Fp.eql(Fp.sqr(root), n))
                throw new Error('Cannot find square root');
            return root;
        };
    }
    // Slow-path
    var Q1div2 = (Q + _1n) / _2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE))
            throw new Error('Cannot find square root');
        var r = S;
        // TODO: will fail at Fp2/etc
        var g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        var x = Fp.pow(n, Q1div2); // first guess at the square root
        var b = Fp.pow(n, Q); // first guess at the fudge factor
        while (!Fp.eql(b, Fp.ONE)) {
            if (Fp.eql(b, Fp.ZERO))
                return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            var m = 1;
            for (var t2 = Fp.sqr(b); m < r; m++) {
                if (Fp.eql(t2, Fp.ONE))
                    break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            var ge = Fp.pow(g, _1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
exports.tonelliShanks = tonelliShanks;
function FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % _4n === _3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        var p1div4_2 = (P + _1n) / _4n;
        return function sqrt3mod4(Fp, n) {
            var root = Fp.pow(n, p1div4_2);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n))
                throw new Error('Cannot find square root');
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % _8n === _5n) {
        var c1_1 = (P - _5n) / _8n;
        return function sqrt5mod8(Fp, n) {
            var n2 = Fp.mul(n, _2n);
            var v = Fp.pow(n2, c1_1);
            var nv = Fp.mul(n, v);
            var i = Fp.mul(Fp.mul(nv, _2n), v);
            var root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n))
                throw new Error('Cannot find square root');
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    if (P % _16n === _9n) {
        // NOTE: tonelli is too slow for bls-Fp2 calculations even on start
        // Means we cannot use sqrt for constants at all!
        //
        // const c1 = Fp.sqrt(Fp.negate(Fp.ONE)); //  1. c1 = sqrt(-1) in F, i.e., (c1^2) == -1 in F
        // const c2 = Fp.sqrt(c1);                //  2. c2 = sqrt(c1) in F, i.e., (c2^2) == c1 in F
        // const c3 = Fp.sqrt(Fp.negate(c1));     //  3. c3 = sqrt(-c1) in F, i.e., (c3^2) == -c1 in F
        // const c4 = (P + _7n) / _16n;           //  4. c4 = (q + 7) / 16        # Integer arithmetic
        // sqrt = (x) => {
        //   let tv1 = Fp.pow(x, c4);             //  1. tv1 = x^c4
        //   let tv2 = Fp.mul(c1, tv1);           //  2. tv2 = c1 * tv1
        //   const tv3 = Fp.mul(c2, tv1);         //  3. tv3 = c2 * tv1
        //   let tv4 = Fp.mul(c3, tv1);           //  4. tv4 = c3 * tv1
        //   const e1 = Fp.equals(Fp.square(tv2), x); //  5.  e1 = (tv2^2) == x
        //   const e2 = Fp.equals(Fp.square(tv3), x); //  6.  e2 = (tv3^2) == x
        //   tv1 = Fp.cmov(tv1, tv2, e1); //  7. tv1 = CMOV(tv1, tv2, e1)  # Select tv2 if (tv2^2) == x
        //   tv2 = Fp.cmov(tv4, tv3, e2); //  8. tv2 = CMOV(tv4, tv3, e2)  # Select tv3 if (tv3^2) == x
        //   const e3 = Fp.equals(Fp.square(tv2), x); //  9.  e3 = (tv2^2) == x
        //   return Fp.cmov(tv1, tv2, e3); //  10.  z = CMOV(tv1, tv2, e3)  # Select the sqrt from tv1 and tv2
        // }
    }
    // Other cases: Tonelli-Shanks algorithm
    return tonelliShanks(P);
}
exports.FpSqrt = FpSqrt;
// Little-endian check for first LE bit (last BE bit);
var isNegativeLE = function (num, modulo) { return (mod(num, modulo) & _1n) === _1n; };
exports.isNegativeLE = isNegativeLE;
// prettier-ignore
var FIELD_FIELDS = [
    'create', 'isValid', 'is0', 'neg', 'inv', 'sqrt', 'sqr',
    'eql', 'add', 'sub', 'mul', 'pow', 'div',
    'addN', 'subN', 'mulN', 'sqrN'
];
function validateField(field) {
    var initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'isSafeInteger',
        BITS: 'isSafeInteger',
    };
    var opts = FIELD_FIELDS.reduce(function (map, val) {
        map[val] = 'function';
        return map;
    }, initial);
    return (0, utils_1.validateObject)(field, opts);
}
exports.validateField = validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */
function FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < _0n)
        throw new Error('Expected power > 0');
    if (power === _0n)
        return f.ONE;
    if (power === _1n)
        return num;
    var p = f.ONE;
    var d = num;
    while (power > _0n) {
        if (power & _1n)
            p = f.mul(p, d);
        d = f.sqr(d);
        power >>= _1n;
    }
    return p;
}
exports.FpPow = FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */
function FpInvertBatch(f, nums) {
    var tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    var lastMultiplied = nums.reduce(function (acc, num, i) {
        if (f.is0(num))
            return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    var inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight(function (acc, num, i) {
        if (f.is0(num))
            return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
exports.FpInvertBatch = FpInvertBatch;
function FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === 'bigint' ? invert(rhs, f.ORDER) : f.inv(rhs));
}
exports.FpDiv = FpDiv;
// This function returns True whenever the value x is a square in the field F.
function FpIsSquare(f) {
    var legendreConst = (f.ORDER - _1n) / _2n; // Integer arithmetic
    return function (x) {
        var p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
exports.FpIsSquare = FpIsSquare;
// CURVE.n lengths
function nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    var _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    var nByteLength = Math.ceil(_nBitLength / 8);
    return { nBitLength: _nBitLength, nByteLength: nByteLength };
}
exports.nLength = nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */
function Field(ORDER, bitLen, isLE, redef) {
    if (isLE === void 0) { isLE = false; }
    if (redef === void 0) { redef = {}; }
    if (ORDER <= _0n)
        throw new Error("Expected Field ORDER > 0, got ".concat(ORDER));
    var _a = nLength(ORDER, bitLen), BITS = _a.nBitLength, BYTES = _a.nByteLength;
    if (BYTES > 2048)
        throw new Error('Field lengths over 2048 bytes are not supported');
    var sqrtP = FpSqrt(ORDER);
    var f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, utils_1.bitMask)(BITS),
        ZERO: _0n,
        ONE: _1n,
        create: function (num) { return mod(num, ORDER); },
        isValid: function (num) {
            if (typeof num !== 'bigint')
                throw new Error("Invalid field element: expected bigint, got ".concat(typeof num));
            return _0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: function (num) { return num === _0n; },
        isOdd: function (num) { return (num & _1n) === _1n; },
        neg: function (num) { return mod(-num, ORDER); },
        eql: function (lhs, rhs) { return lhs === rhs; },
        sqr: function (num) { return mod(num * num, ORDER); },
        add: function (lhs, rhs) { return mod(lhs + rhs, ORDER); },
        sub: function (lhs, rhs) { return mod(lhs - rhs, ORDER); },
        mul: function (lhs, rhs) { return mod(lhs * rhs, ORDER); },
        pow: function (num, power) { return FpPow(f, num, power); },
        div: function (lhs, rhs) { return mod(lhs * invert(rhs, ORDER), ORDER); },
        // Same as above, but doesn't normalize
        sqrN: function (num) { return num * num; },
        addN: function (lhs, rhs) { return lhs + rhs; },
        subN: function (lhs, rhs) { return lhs - rhs; },
        mulN: function (lhs, rhs) { return lhs * rhs; },
        inv: function (num) { return invert(num, ORDER); },
        sqrt: redef.sqrt || (function (n) { return sqrtP(f, n); }),
        invertBatch: function (lst) { return FpInvertBatch(f, lst); },
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: function (a, b, c) { return (c ? b : a); },
        toBytes: function (num) { return (isLE ? (0, utils_1.numberToBytesLE)(num, BYTES) : (0, utils_1.numberToBytesBE)(num, BYTES)); },
        fromBytes: function (bytes) {
            if (bytes.length !== BYTES)
                throw new Error("Fp.fromBytes: expected ".concat(BYTES, ", got ").concat(bytes.length));
            return isLE ? (0, utils_1.bytesToNumberLE)(bytes) : (0, utils_1.bytesToNumberBE)(bytes);
        },
    });
    return Object.freeze(f);
}
exports.Field = Field;
function FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd)
        throw new Error("Field doesn't have isOdd");
    var root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
exports.FpSqrtOdd = FpSqrtOdd;
function FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd)
        throw new Error("Field doesn't have isOdd");
    var root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
exports.FpSqrtEven = FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */
function hashToPrivateScalar(hash, groupOrder, isLE) {
    if (isLE === void 0) { isLE = false; }
    hash = (0, utils_1.ensureBytes)('privateHash', hash);
    var hashLen = hash.length;
    var minLen = nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024)
        throw new Error("hashToPrivateScalar: expected ".concat(minLen, "-1024 bytes of input, got ").concat(hashLen));
    var num = isLE ? (0, utils_1.bytesToNumberLE)(hash) : (0, utils_1.bytesToNumberBE)(hash);
    return mod(num, groupOrder - _1n) + _1n;
}
exports.hashToPrivateScalar = hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */
function getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== 'bigint')
        throw new Error('field order must be bigint');
    var bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
exports.getFieldBytesLength = getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */
function getMinHashLength(fieldOrder) {
    var length = getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
exports.getMinHashLength = getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */
function mapHashToField(key, fieldOrder, isLE) {
    if (isLE === void 0) { isLE = false; }
    var len = key.length;
    var fieldLen = getFieldBytesLength(fieldOrder);
    var minLen = getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024)
        throw new Error("expected ".concat(minLen, "-1024 bytes of input, got ").concat(len));
    var num = isLE ? (0, utils_1.bytesToNumberBE)(key) : (0, utils_1.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    var reduced = mod(num, fieldOrder - _1n) + _1n;
    return isLE ? (0, utils_1.numberToBytesLE)(reduced, fieldLen) : (0, utils_1.numberToBytesBE)(reduced, fieldLen);
}
exports.mapHashToField = mapHashToField;


/***/ }),

/***/ 92035:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/abstract/utils.ts

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.aInRange = exports.inRange = exports.isBytes = exports.abool = exports.memoized = exports.validateObject = exports.createHmacDrbg = exports.bitMask = exports.bitSet = exports.bitGet = exports.bitLen = exports.utf8ToBytes = exports.equalBytes = exports.concatBytes = exports.ensureBytes = exports.numberToVarBytesBE = exports.numberToBytesLE = exports.numberToBytesBE = exports.bytesToNumberLE = exports.bytesToNumberBE = exports.hexToBytes = exports.hexToNumber = exports.numberToHexUnpadded = exports.bytesToHex = exports.abytes = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
var _0n = BigInt(0);
var _1n = BigInt(1);
var _2n = BigInt(2);
function abytes(item) {
    if (!isBytes(item))
        throw new Error('Uint8Array expected');
}
exports.abytes = abytes;
// Array where index 0xf0 (240) is mapped to string 'f0'
var hexes = /* @__PURE__ */ Array.from({ length: 256 }, function (_, i) {
    return i.toString(16).padStart(2, '0');
});
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */
function bytesToHex(bytes) {
    abytes(bytes);
    // pre-caching improves the speed 6x
    var hex = '';
    for (var i = 0; i < bytes.length; i++) {
        hex += hexes[bytes[i]];
    }
    return hex;
}
exports.bytesToHex = bytesToHex;
function numberToHexUnpadded(num) {
    var hex = num.toString(16);
    return hex.length & 1 ? "0".concat(hex) : hex;
}
exports.numberToHexUnpadded = numberToHexUnpadded;
function hexToNumber(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    // Big Endian
    return BigInt(hex === '' ? '0' : "0x".concat(hex));
}
exports.hexToNumber = hexToNumber;
// We use optimized technique to convert hex string to byte array
var asciis = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9)
        return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F)
        return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f)
        return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */
function hexToBytes(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    var hl = hex.length;
    var al = hl / 2;
    if (hl % 2)
        throw new Error('padded hex string expected, got unpadded hex of length ' + hl);
    var array = new Uint8Array(al);
    for (var ai = 0, hi = 0; ai < al; ai++, hi += 2) {
        var n1 = asciiToBase16(hex.charCodeAt(hi));
        var n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            var char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// BE: Big Endian, LE: Little Endian
function bytesToNumberBE(bytes) {
    return hexToNumber(bytesToHex(bytes));
}
exports.bytesToNumberBE = bytesToNumberBE;
function bytesToNumberLE(bytes) {
    abytes(bytes);
    return hexToNumber(bytesToHex(Uint8Array.from(bytes).reverse()));
}
exports.bytesToNumberLE = bytesToNumberLE;
function numberToBytesBE(n, len) {
    return hexToBytes(n.toString(16).padStart(len * 2, '0'));
}
exports.numberToBytesBE = numberToBytesBE;
function numberToBytesLE(n, len) {
    return numberToBytesBE(n, len).reverse();
}
exports.numberToBytesLE = numberToBytesLE;
// Unpadded, rarely used
function numberToVarBytesBE(n) {
    return hexToBytes(numberToHexUnpadded(n));
}
exports.numberToVarBytesBE = numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */
function ensureBytes(title, hex, expectedLength) {
    var res;
    if (typeof hex === 'string') {
        try {
            res = hexToBytes(hex);
        }
        catch (e) {
            throw new Error("".concat(title, " must be valid hex string, got \"").concat(hex, "\". Cause: ").concat(e));
        }
    }
    else if (isBytes(hex)) {
        // Uint8Array.from() instead of hash.slice() because node Buffer
        // is instance of Uint8Array, and its slice() creates **mutable** copy
        res = Uint8Array.from(hex);
    }
    else {
        throw new Error("".concat(title, " must be hex string or Uint8Array"));
    }
    var len = res.length;
    if (typeof expectedLength === 'number' && len !== expectedLength)
        throw new Error("".concat(title, " expected ").concat(expectedLength, " bytes, got ").concat(len));
    return res;
}
exports.ensureBytes = ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */
function concatBytes() {
    var arrays = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arrays[_i] = arguments[_i];
    }
    var sum = 0;
    for (var i = 0; i < arrays.length; i++) {
        var a = arrays[i];
        abytes(a);
        sum += a.length;
    }
    var res = new Uint8Array(sum);
    for (var i = 0, pad = 0; i < arrays.length; i++) {
        var a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
exports.concatBytes = concatBytes;
// Compares 2 u8a-s in kinda constant time
function equalBytes(a, b) {
    if (a.length !== b.length)
        return false;
    var diff = 0;
    for (var i = 0; i < a.length; i++)
        diff |= a[i] ^ b[i];
    return diff === 0;
}
exports.equalBytes = equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */
function utf8ToBytes(str) {
    if (typeof str !== 'string')
        throw new Error("utf8ToBytes expected string, got ".concat(typeof str));
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
exports.utf8ToBytes = utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */
function bitLen(n) {
    var len;
    for (len = 0; n > _0n; n >>= _1n, len += 1)
        ;
    return len;
}
exports.bitLen = bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */
function bitGet(n, pos) {
    return (n >> BigInt(pos)) & _1n;
}
exports.bitGet = bitGet;
/**
 * Sets single bit at position.
 */
function bitSet(n, pos, value) {
    return n | ((value ? _1n : _0n) << BigInt(pos));
}
exports.bitSet = bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */
var bitMask = function (n) { return (_2n << BigInt(n - 1)) - _1n; };
exports.bitMask = bitMask;
// DRBG
var u8n = function (data) { return new Uint8Array(data); }; // creates Uint8Array
var u8fr = function (arr) { return Uint8Array.from(arr); }; // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */
function createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2)
        throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2)
        throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function')
        throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    var v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    var k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    var i = 0; // Iterations counter, will throw when over 1000
    var reset = function () {
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    var h = function () {
        var b = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            b[_i] = arguments[_i];
        }
        return hmacFn.apply(void 0, __spreadArray([k, v], __read(b), false));
    }; // hmac(k)(v, ...values)
    var reseed = function (seed) {
        if (seed === void 0) { seed = u8n(); }
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8fr([0x00]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0)
            return;
        k = h(u8fr([0x01]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    var gen = function () {
        // HMAC-DRBG generate() function
        if (i++ >= 1000)
            throw new Error('drbg: tried 1000 values');
        var len = 0;
        var out = [];
        while (len < qByteLen) {
            v = h();
            var sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return concatBytes.apply(void 0, __spreadArray([], __read(out), false));
    };
    var genUntil = function (seed, pred) {
        reset();
        reseed(seed); // Steps D-G
        var res = undefined; // Step H: grind until k is in [1..n-1]
        while (!(res = pred(gen())))
            reseed();
        reset();
        return res;
    };
    return genUntil;
}
exports.createHmacDrbg = createHmacDrbg;
// Validating curves and fields
var validatorFns = {
    bigint: function (val) { return typeof val === 'bigint'; },
    function: function (val) { return typeof val === 'function'; },
    boolean: function (val) { return typeof val === 'boolean'; },
    string: function (val) { return typeof val === 'string'; },
    stringOrUint8Array: function (val) { return typeof val === 'string' || isBytes(val); },
    isSafeInteger: function (val) { return Number.isSafeInteger(val); },
    array: function (val) { return Array.isArray(val); },
    field: function (val, object) { return object.Fp.isValid(val); },
    hash: function (val) { return typeof val === 'function' && Number.isSafeInteger(val.outputLen); },
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function validateObject(object, validators, optValidators) {
    var e_1, _b, e_2, _c;
    if (optValidators === void 0) { optValidators = {}; }
    var checkField = function (fieldName, type, isOptional) {
        var checkVal = validatorFns[type];
        if (typeof checkVal !== 'function')
            throw new Error("Invalid validator \"".concat(type, "\", expected function"));
        var val = object[fieldName];
        if (isOptional && val === undefined)
            return;
        if (!checkVal(val, object)) {
            throw new Error("Invalid param ".concat(String(fieldName), "=").concat(val, " (").concat(typeof val, "), expected ").concat(type));
        }
    };
    try {
        for (var _d = __values(Object.entries(validators)), _e = _d.next(); !_e.done; _e = _d.next()) {
            var _g = __read(_e.value, 2), fieldName = _g[0], type = _g[1];
            checkField(fieldName, type, false);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var _h = __values(Object.entries(optValidators)), _j = _h.next(); !_j.done; _j = _h.next()) {
            var _k = __read(_j.value, 2), fieldName = _k[0], type = _k[1];
            checkField(fieldName, type, true);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return object;
}
exports.validateObject = validateObject;
// validate type tests
// const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
// const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
// // Should fail type-check
// const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
// const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
// const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
// const z4 = validateObject(o, { a: 'boolean', z: 'bug' });
/**
 * Memoizes (caches) computation result.
 * Uses WeakMap: the value is going auto-cleaned by GC after last reference is removed.
 */
function memoized(fn) {
    var map = new WeakMap();
    return function (arg) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var val = map.get(arg);
        if (val !== undefined)
            return val;
        var computed = fn.apply(void 0, __spreadArray([arg], __read(args), false));
        map.set(arg, computed);
        return computed;
    };
}
exports.memoized = memoized;
function abool(title, value) {
    if (typeof value !== 'boolean')
        throw new Error(title + ' boolean expected, got ' + value);
}
exports.abool = abool;
function isBytes(a) {
    return a instanceof Uint8Array || (ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array');
}
exports.isBytes = isBytes;
var isPosBig = function (n) { return typeof n === 'bigint' && _0n <= n; };
function inRange(n, min, max) {
    return isPosBig(n) && isPosBig(min) && isPosBig(max) && min <= n && n < max;
}
exports.inRange = inRange;
/**
* Asserts min <= n < max. NOTE: It's < max and not <= max.
* @example
* aInRange('x', x, 1n, 256n); // would assume x is in (1n..255n)
*/
function aInRange(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!inRange(n, min, max))
        throw new Error('expected valid ' + title + ': ' + min + ' <= n < ' + max + ', got ' + n);
}
exports.aInRange = aInRange;


/***/ }),

/***/ 75387:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/bls12-381.ts#L1

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bls12_381 = exports.G2_mapToCurve = exports.G1_mapToCurve = exports.G1_formBytes = exports.parseMask = exports.Fp12 = exports.Fp12_ONE = exports.Fp12_eql = exports.Fp12_conjugate = exports.Fp12_finalExponentiate = exports.Fp12Multiply = exports.Fp2 = exports.Fp = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// bls12-381 is pairing-friendly Barreto-Lynn-Scott elliptic curve construction allowing to:
// - Construct zk-SNARKs at the 120-bit security
// - Efficiently verify N aggregate signatures with 1 pairing and N ec additions:
//   the Boneh-Lynn-Shacham signature scheme is orders of magnitude more efficient than Schnorr
//
// ### Summary
// 1. BLS Relies on Bilinear Pairing (expensive)
// 2. Private Keys: 32 bytes
// 3. Public Keys: 48 bytes: 381 bit affine x coordinate, encoded into 48 big-endian bytes.
// 4. Signatures: 96 bytes: two 381 bit integers (affine x coordinate), encoded into two 48 big-endian byte arrays.
//     - The signature is a point on the G2 subgroup, which is defined over a finite field
//     with elements twice as big as the G1 curve (G2 is over Fp2 rather than Fp. Fp2 is analogous to the complex numbers).
// 5. The 12 stands for the Embedding degree.
//
// ### Formulas
// - `P = pk x G` - public keys
// - `S = pk x H(m)` - signing
// - `e(P, H(m)) == e(G, S)` - verification using pairings
// - `e(G, S) = e(G, SUM(n)(Si)) = MUL(n)(e(G, Si))` - signature aggregation
//
// ### Compatibility and notes
// 1. It is compatible with Algorand, Chia, Dfinity, Ethereum, Filecoin, ZEC
//    Filecoin uses little endian byte arrays for private keys - make sure to reverse byte order.
// 2. Some projects use G2 for public keys and G1 for signatures. It's called "short signature"
// 3. Curve security level is about 120 bits as per Barbulescu-Duquesne 2017
//    https://hal.science/hal-01534101/file/main.pdf
// 4. Compatible with specs:
// [cfrg-pairing-friendly-curves-11](https://tools.ietf.org/html/draft-irtf-cfrg-pairing-friendly-curves-11),
// [cfrg-bls-signature-05](https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-bls-signature-05),
// [RFC 9380](https://www.rfc-editor.org/rfc/rfc9380).
var bls_1 = __webpack_require__(52682);
var mod = __importStar(__webpack_require__(99764));
var utils_1 = __webpack_require__(92035);
// Types
var weierstrass_1 = __webpack_require__(76326);
var hash_to_curve_1 = __webpack_require__(50288);
var sha256_1 = __webpack_require__(7902);
var utils_2 = __webpack_require__(74599);
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
var _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3), _4n = BigInt(4);
// prettier-ignore
var _8n = BigInt(8), _16n = BigInt(16);
// CURVE FIELDS
// Finite field over p.
var Fp_raw = BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab');
exports.Fp = mod.Field(Fp_raw);
// Finite field over r.
// This particular field is not used anywhere in bls12-381, but it is still useful.
var Fr = mod.Field(BigInt('0x73eda753299d7d483339d80809a1d80553bda402fffe5bfeffffffff00000001'));
var Fp2Add = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1;
    var r0 = _b.c0, r1 = _b.c1;
    return ({
        c0: exports.Fp.add(c0, r0),
        c1: exports.Fp.add(c1, r1),
    });
};
var Fp2Subtract = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1;
    var r0 = _b.c0, r1 = _b.c1;
    return ({
        c0: exports.Fp.sub(c0, r0),
        c1: exports.Fp.sub(c1, r1),
    });
};
var Fp2Multiply = function (_a, rhs) {
    var c0 = _a.c0, c1 = _a.c1;
    if (typeof rhs === 'bigint')
        return { c0: exports.Fp.mul(c0, rhs), c1: exports.Fp.mul(c1, rhs) };
    // (a+bi)(c+di) = (ac−bd) + (ad+bc)i
    var r0 = rhs.c0, r1 = rhs.c1;
    var t1 = exports.Fp.mul(c0, r0); // c0 * o0
    var t2 = exports.Fp.mul(c1, r1); // c1 * o1
    // (T1 - T2) + ((c0 + c1) * (r0 + r1) - (T1 + T2))*i
    var o0 = exports.Fp.sub(t1, t2);
    var o1 = exports.Fp.sub(exports.Fp.mul(exports.Fp.add(c0, c1), exports.Fp.add(r0, r1)), exports.Fp.add(t1, t2));
    return { c0: o0, c1: o1 };
};
var Fp2Square = function (_a) {
    var c0 = _a.c0, c1 = _a.c1;
    var a = exports.Fp.add(c0, c1);
    var b = exports.Fp.sub(c0, c1);
    var c = exports.Fp.add(c0, c0);
    return { c0: exports.Fp.mul(a, b), c1: exports.Fp.mul(c, c1) };
};
// G2 is the order-q subgroup of E2(Fp²) : y² = x³+4(1+√−1),
// where Fp2 is Fp[√−1]/(x2+1). #E2(Fp2 ) = h2q, where
// G² - 1
// h2q
// NOTE: ORDER was wrong!
var FP2_ORDER = Fp_raw * Fp_raw;
exports.Fp2 = {
    ORDER: FP2_ORDER,
    BITS: (0, utils_1.bitLen)(FP2_ORDER),
    BYTES: Math.ceil((0, utils_1.bitLen)(FP2_ORDER) / 8),
    MASK: (0, utils_1.bitMask)((0, utils_1.bitLen)(FP2_ORDER)),
    ZERO: { c0: exports.Fp.ZERO, c1: exports.Fp.ZERO },
    ONE: { c0: exports.Fp.ONE, c1: exports.Fp.ZERO },
    create: function (num) { return num; },
    isValid: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return typeof c0 === 'bigint' && typeof c1 === 'bigint';
    },
    is0: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return exports.Fp.is0(c0) && exports.Fp.is0(c1);
    },
    eql: function (_a, _b) {
        var c0 = _a.c0, c1 = _a.c1;
        var r0 = _b.c0, r1 = _b.c1;
        return exports.Fp.eql(c0, r0) && exports.Fp.eql(c1, r1);
    },
    neg: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return ({ c0: exports.Fp.neg(c0), c1: exports.Fp.neg(c1) });
    },
    pow: function (num, power) { return mod.FpPow(exports.Fp2, num, power); },
    invertBatch: function (nums) { return mod.FpInvertBatch(exports.Fp2, nums); },
    // Normalized
    add: Fp2Add,
    sub: Fp2Subtract,
    mul: Fp2Multiply,
    sqr: Fp2Square,
    // NonNormalized stuff
    addN: Fp2Add,
    subN: Fp2Subtract,
    mulN: Fp2Multiply,
    sqrN: Fp2Square,
    // Why inversion for bigint inside Fp instead of Fp2? it is even used in that context?
    div: function (lhs, rhs) { return exports.Fp2.mul(lhs, typeof rhs === 'bigint' ? exports.Fp.inv(exports.Fp.create(rhs)) : exports.Fp2.inv(rhs)); },
    inv: function (_a) {
        var a = _a.c0, b = _a.c1;
        // We wish to find the multiplicative inverse of a nonzero
        // element a + bu in Fp2. We leverage an identity
        //
        // (a + bu)(a - bu) = a² + b²
        //
        // which holds because u² = -1. This can be rewritten as
        //
        // (a + bu)(a - bu)/(a² + b²) = 1
        //
        // because a² + b² = 0 has no nonzero solutions for (a, b).
        // This gives that (a - bu)/(a² + b²) is the inverse
        // of (a + bu). Importantly, this can be computing using
        // only a single inversion in Fp.
        var factor = exports.Fp.inv(exports.Fp.create(a * a + b * b));
        return { c0: exports.Fp.mul(factor, exports.Fp.create(a)), c1: exports.Fp.mul(factor, exports.Fp.create(-b)) };
    },
    sqrt: function (num) {
        if (exports.Fp2.eql(num, exports.Fp2.ZERO))
            return exports.Fp2.ZERO; // Algo doesn't handles this case
        // TODO: Optimize this line. It's extremely slow.
        // Speeding this up would boost aggregateSignatures.
        // https://eprint.iacr.org/2012/685.pdf applicable?
        // https://github.com/zkcrypto/bls12_381/blob/080eaa74ec0e394377caa1ba302c8c121df08b07/src/fp2.rs#L250
        // https://github.com/supranational/blst/blob/aae0c7d70b799ac269ff5edf29d8191dbd357876/src/exp2.c#L1
        // Inspired by https://github.com/dalek-cryptography/curve25519-dalek/blob/17698df9d4c834204f83a3574143abacb4fc81a5/src/field.rs#L99
        var candidateSqrt = exports.Fp2.pow(num, (exports.Fp2.ORDER + _8n) / _16n);
        var check = exports.Fp2.div(exports.Fp2.sqr(candidateSqrt), num); // candidateSqrt.square().div(this);
        var R = FP2_ROOTS_OF_UNITY;
        var divisor = [R[0], R[2], R[4], R[6]].find(function (r) { return exports.Fp2.eql(r, check); });
        if (!divisor)
            throw new Error('No root');
        var index = R.indexOf(divisor);
        var root = R[index / 2];
        if (!root)
            throw new Error('Invalid root');
        var x1 = exports.Fp2.div(candidateSqrt, root);
        var x2 = exports.Fp2.neg(x1);
        var _a = exports.Fp2.reim(x1), re1 = _a.re, im1 = _a.im;
        var _b = exports.Fp2.reim(x2), re2 = _b.re, im2 = _b.im;
        if (im1 > im2 || (im1 === im2 && re1 > re2))
            return x1;
        return x2;
    },
    // Same as sgn0_m_eq_2 in RFC 9380
    isOdd: function (x) {
        var _a = exports.Fp2.reim(x), x0 = _a.re, x1 = _a.im;
        var sign_0 = x0 % _2n;
        var zero_0 = x0 === _0n;
        var sign_1 = x1 % _2n;
        return BigInt(sign_0 || (zero_0 && sign_1)) == _1n;
    },
    // Bytes util
    fromBytes: function (b) {
        if (b.length !== exports.Fp2.BYTES)
            throw new Error("fromBytes wrong length=".concat(b.length));
        return { c0: exports.Fp.fromBytes(b.subarray(0, exports.Fp.BYTES)), c1: exports.Fp.fromBytes(b.subarray(exports.Fp.BYTES)) };
    },
    toBytes: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return (0, utils_1.concatBytes)(exports.Fp.toBytes(c0), exports.Fp.toBytes(c1));
    },
    cmov: function (_a, _b, c) {
        var c0 = _a.c0, c1 = _a.c1;
        var r0 = _b.c0, r1 = _b.c1;
        return ({
            c0: exports.Fp.cmov(c0, r0, c),
            c1: exports.Fp.cmov(c1, r1, c),
        });
    },
    // Specific utils
    // toString() {
    //   return `Fp2(${this.c0} + ${this.c1}×i)`;
    // }
    reim: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return ({ re: c0, im: c1 });
    },
    // multiply by u + 1
    mulByNonresidue: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return ({ c0: exports.Fp.sub(c0, c1), c1: exports.Fp.add(c0, c1) });
    },
    multiplyByB: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        var t0 = exports.Fp.mul(c0, _4n); // 4 * c0
        var t1 = exports.Fp.mul(c1, _4n); // 4 * c1
        // (T0-T1) + (T0+T1)*i
        return { c0: exports.Fp.sub(t0, t1), c1: exports.Fp.add(t0, t1) };
    },
    fromBigTuple: function (tuple) {
        if (tuple.length !== 2)
            throw new Error('Invalid tuple');
        var fps = tuple.map(function (n) { return exports.Fp.create(n); });
        return { c0: fps[0], c1: fps[1] };
    },
    frobeniusMap: function (_a, power) {
        var c0 = _a.c0, c1 = _a.c1;
        return ({
            c0: c0,
            c1: exports.Fp.mul(c1, FP2_FROBENIUS_COEFFICIENTS[power % 2]),
        });
    },
};
// Finite extension field over irreducible polynominal.
// Fp(u) / (u² - β) where β = -1
var FP2_FROBENIUS_COEFFICIENTS = [
    BigInt('0x1'),
    BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaaa'),
].map(function (item) { return exports.Fp.create(item); });
// For Fp2 roots of unity.
var rv1 = BigInt('0x6af0e0437ff400b6831e36d6bd17ffe48395dabc2d3435e77f76e17009241c5ee67992f72ec05f4c81084fbede3cc09');
// const ev1 =
//   BigInt('0x699be3b8c6870965e5bf892ad5d2cc7b0e85a117402dfd83b7f4a947e02d978498255a2aaec0ac627b5afbdf1bf1c90');
// const ev2 =
//   BigInt('0x8157cd83046453f5dd0972b6e3949e4288020b5b8a9cc99ca07e27089a2ce2436d965026adad3ef7baba37f2183e9b5');
// const ev3 =
//   BigInt('0xab1c2ffdd6c253ca155231eb3e71ba044fd562f6f72bc5bad5ec46a0b7a3b0247cf08ce6c6317f40edbc653a72dee17');
// const ev4 =
//   BigInt('0xaa404866706722864480885d68ad0ccac1967c7544b447873cc37e0181271e006df72162a3d3e0287bf597fbf7f8fc1');
// Eighth roots of unity, used for computing square roots in Fp2.
// To verify or re-calculate:
// Array(8).fill(new Fp2([1n, 1n])).map((fp2, k) => fp2.pow(Fp2.ORDER * BigInt(k) / 8n))
var FP2_ROOTS_OF_UNITY = [
    [_1n, _0n],
    [rv1, -rv1],
    [_0n, _1n],
    [rv1, rv1],
    [-_1n, _0n],
    [-rv1, rv1],
    [_0n, -_1n],
    [-rv1, -rv1],
].map(function (pair) { return exports.Fp2.fromBigTuple(pair); });
var Fp6Add = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
    var r0 = _b.c0, r1 = _b.c1, r2 = _b.c2;
    return ({
        c0: exports.Fp2.add(c0, r0),
        c1: exports.Fp2.add(c1, r1),
        c2: exports.Fp2.add(c2, r2),
    });
};
var Fp6Subtract = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
    var r0 = _b.c0, r1 = _b.c1, r2 = _b.c2;
    return ({
        c0: exports.Fp2.sub(c0, r0),
        c1: exports.Fp2.sub(c1, r1),
        c2: exports.Fp2.sub(c2, r2),
    });
};
var Fp6Multiply = function (_a, rhs) {
    var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
    if (typeof rhs === 'bigint') {
        return {
            c0: exports.Fp2.mul(c0, rhs),
            c1: exports.Fp2.mul(c1, rhs),
            c2: exports.Fp2.mul(c2, rhs),
        };
    }
    var r0 = rhs.c0, r1 = rhs.c1, r2 = rhs.c2;
    var t0 = exports.Fp2.mul(c0, r0); // c0 * o0
    var t1 = exports.Fp2.mul(c1, r1); // c1 * o1
    var t2 = exports.Fp2.mul(c2, r2); // c2 * o2
    return {
        // t0 + (c1 + c2) * (r1 * r2) - (T1 + T2) * (u + 1)
        c0: exports.Fp2.add(t0, exports.Fp2.mulByNonresidue(exports.Fp2.sub(exports.Fp2.mul(exports.Fp2.add(c1, c2), exports.Fp2.add(r1, r2)), exports.Fp2.add(t1, t2)))),
        // (c0 + c1) * (r0 + r1) - (T0 + T1) + T2 * (u + 1)
        c1: exports.Fp2.add(exports.Fp2.sub(exports.Fp2.mul(exports.Fp2.add(c0, c1), exports.Fp2.add(r0, r1)), exports.Fp2.add(t0, t1)), exports.Fp2.mulByNonresidue(t2)),
        // T1 + (c0 + c2) * (r0 + r2) - T0 + T2
        c2: exports.Fp2.sub(exports.Fp2.add(t1, exports.Fp2.mul(exports.Fp2.add(c0, c2), exports.Fp2.add(r0, r2))), exports.Fp2.add(t0, t2)),
    };
};
var Fp6Square = function (_a) {
    var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
    var t0 = exports.Fp2.sqr(c0); // c0²
    var t1 = exports.Fp2.mul(exports.Fp2.mul(c0, c1), _2n); // 2 * c0 * c1
    var t3 = exports.Fp2.mul(exports.Fp2.mul(c1, c2), _2n); // 2 * c1 * c2
    var t4 = exports.Fp2.sqr(c2); // c2²
    return {
        c0: exports.Fp2.add(exports.Fp2.mulByNonresidue(t3), t0),
        c1: exports.Fp2.add(exports.Fp2.mulByNonresidue(t4), t1),
        // T1 + (c0 - c1 + c2)² + T3 - T0 - T4
        c2: exports.Fp2.sub(exports.Fp2.sub(exports.Fp2.add(exports.Fp2.add(t1, exports.Fp2.sqr(exports.Fp2.add(exports.Fp2.sub(c0, c1), c2))), t3), t0), t4),
    };
};
var Fp6 = {
    ORDER: exports.Fp2.ORDER,
    BITS: 3 * exports.Fp2.BITS,
    BYTES: 3 * exports.Fp2.BYTES,
    MASK: (0, utils_1.bitMask)(3 * exports.Fp2.BITS),
    ZERO: { c0: exports.Fp2.ZERO, c1: exports.Fp2.ZERO, c2: exports.Fp2.ZERO },
    ONE: { c0: exports.Fp2.ONE, c1: exports.Fp2.ZERO, c2: exports.Fp2.ZERO },
    create: function (num) { return num; },
    isValid: function (_a) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return exports.Fp2.isValid(c0) && exports.Fp2.isValid(c1) && exports.Fp2.isValid(c2);
    },
    is0: function (_a) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return exports.Fp2.is0(c0) && exports.Fp2.is0(c1) && exports.Fp2.is0(c2);
    },
    neg: function (_a) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return ({ c0: exports.Fp2.neg(c0), c1: exports.Fp2.neg(c1), c2: exports.Fp2.neg(c2) });
    },
    eql: function (_a, _b) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        var r0 = _b.c0, r1 = _b.c1, r2 = _b.c2;
        return exports.Fp2.eql(c0, r0) && exports.Fp2.eql(c1, r1) && exports.Fp2.eql(c2, r2);
    },
    sqrt: function () {
        throw new Error('Not implemented');
    },
    // Do we need division by bigint at all? Should be done via order:
    div: function (lhs, rhs) { return Fp6.mul(lhs, typeof rhs === 'bigint' ? exports.Fp.inv(exports.Fp.create(rhs)) : Fp6.inv(rhs)); },
    pow: function (num, power) { return mod.FpPow(Fp6, num, power); },
    invertBatch: function (nums) { return mod.FpInvertBatch(Fp6, nums); },
    // Normalized
    add: Fp6Add,
    sub: Fp6Subtract,
    mul: Fp6Multiply,
    sqr: Fp6Square,
    // NonNormalized stuff
    addN: Fp6Add,
    subN: Fp6Subtract,
    mulN: Fp6Multiply,
    sqrN: Fp6Square,
    inv: function (_a) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        var t0 = exports.Fp2.sub(exports.Fp2.sqr(c0), exports.Fp2.mulByNonresidue(exports.Fp2.mul(c2, c1))); // c0² - c2 * c1 * (u + 1)
        var t1 = exports.Fp2.sub(exports.Fp2.mulByNonresidue(exports.Fp2.sqr(c2)), exports.Fp2.mul(c0, c1)); // c2² * (u + 1) - c0 * c1
        var t2 = exports.Fp2.sub(exports.Fp2.sqr(c1), exports.Fp2.mul(c0, c2)); // c1² - c0 * c2
        // 1/(((c2 * T1 + c1 * T2) * v) + c0 * T0)
        var t4 = exports.Fp2.inv(exports.Fp2.add(exports.Fp2.mulByNonresidue(exports.Fp2.add(exports.Fp2.mul(c2, t1), exports.Fp2.mul(c1, t2))), exports.Fp2.mul(c0, t0)));
        return { c0: exports.Fp2.mul(t4, t0), c1: exports.Fp2.mul(t4, t1), c2: exports.Fp2.mul(t4, t2) };
    },
    // Bytes utils
    fromBytes: function (b) {
        if (b.length !== Fp6.BYTES)
            throw new Error("fromBytes wrong length=".concat(b.length));
        return {
            c0: exports.Fp2.fromBytes(b.subarray(0, exports.Fp2.BYTES)),
            c1: exports.Fp2.fromBytes(b.subarray(exports.Fp2.BYTES, 2 * exports.Fp2.BYTES)),
            c2: exports.Fp2.fromBytes(b.subarray(2 * exports.Fp2.BYTES)),
        };
    },
    toBytes: function (_a) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return (0, utils_1.concatBytes)(exports.Fp2.toBytes(c0), exports.Fp2.toBytes(c1), exports.Fp2.toBytes(c2));
    },
    cmov: function (_a, _b, c) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        var r0 = _b.c0, r1 = _b.c1, r2 = _b.c2;
        return ({
            c0: exports.Fp2.cmov(c0, r0, c),
            c1: exports.Fp2.cmov(c1, r1, c),
            c2: exports.Fp2.cmov(c2, r2, c),
        });
    },
    // Utils
    //   fromTriple(triple: [Fp2, Fp2, Fp2]) {
    //     return new Fp6(...triple);
    //   }
    //   toString() {
    //     return `Fp6(${this.c0} + ${this.c1} * v, ${this.c2} * v^2)`;
    //   }
    fromBigSix: function (t) {
        if (!Array.isArray(t) || t.length !== 6)
            throw new Error('Invalid Fp6 usage');
        return {
            c0: exports.Fp2.fromBigTuple(t.slice(0, 2)),
            c1: exports.Fp2.fromBigTuple(t.slice(2, 4)),
            c2: exports.Fp2.fromBigTuple(t.slice(4, 6)),
        };
    },
    frobeniusMap: function (_a, power) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return ({
            c0: exports.Fp2.frobeniusMap(c0, power),
            c1: exports.Fp2.mul(exports.Fp2.frobeniusMap(c1, power), FP6_FROBENIUS_COEFFICIENTS_1[power % 6]),
            c2: exports.Fp2.mul(exports.Fp2.frobeniusMap(c2, power), FP6_FROBENIUS_COEFFICIENTS_2[power % 6]),
        });
    },
    mulByNonresidue: function (_a) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return ({ c0: exports.Fp2.mulByNonresidue(c2), c1: c0, c2: c1 });
    },
    // Sparse multiplication
    multiplyBy1: function (_a, b1) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return ({
            c0: exports.Fp2.mulByNonresidue(exports.Fp2.mul(c2, b1)),
            c1: exports.Fp2.mul(c0, b1),
            c2: exports.Fp2.mul(c1, b1),
        });
    },
    // Sparse multiplication
    multiplyBy01: function (_a, b0, b1) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        var t0 = exports.Fp2.mul(c0, b0); // c0 * b0
        var t1 = exports.Fp2.mul(c1, b1); // c1 * b1
        return {
            // ((c1 + c2) * b1 - T1) * (u + 1) + T0
            c0: exports.Fp2.add(exports.Fp2.mulByNonresidue(exports.Fp2.sub(exports.Fp2.mul(exports.Fp2.add(c1, c2), b1), t1)), t0),
            // (b0 + b1) * (c0 + c1) - T0 - T1
            c1: exports.Fp2.sub(exports.Fp2.sub(exports.Fp2.mul(exports.Fp2.add(b0, b1), exports.Fp2.add(c0, c1)), t0), t1),
            // (c0 + c2) * b0 - T0 + T1
            c2: exports.Fp2.add(exports.Fp2.sub(exports.Fp2.mul(exports.Fp2.add(c0, c2), b0), t0), t1),
        };
    },
    multiplyByFp2: function (_a, rhs) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return ({
            c0: exports.Fp2.mul(c0, rhs),
            c1: exports.Fp2.mul(c1, rhs),
            c2: exports.Fp2.mul(c2, rhs),
        });
    },
};
var FP6_FROBENIUS_COEFFICIENTS_1 = [
    [BigInt('0x1'), BigInt('0x0')],
    [
        BigInt('0x0'),
        BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac'),
    ],
    [
        BigInt('0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe'),
        BigInt('0x0'),
    ],
    [BigInt('0x0'), BigInt('0x1')],
    [
        BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x0'),
        BigInt('0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe'),
    ],
].map(function (pair) { return exports.Fp2.fromBigTuple(pair); });
var FP6_FROBENIUS_COEFFICIENTS_2 = [
    [BigInt('0x1'), BigInt('0x0')],
    [
        BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaad'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaaa'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffeffff'),
        BigInt('0x0'),
    ],
].map(function (pair) { return exports.Fp2.fromBigTuple(pair); });
// The BLS parameter x for BLS12-381
var BLS_X = BigInt('0xd201000000010000');
var BLS_X_LEN = (0, utils_1.bitLen)(BLS_X);
var Fp12Add = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1;
    var r0 = _b.c0, r1 = _b.c1;
    return ({
        c0: Fp6.add(c0, r0),
        c1: Fp6.add(c1, r1),
    });
};
var Fp12Subtract = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1;
    var r0 = _b.c0, r1 = _b.c1;
    return ({
        c0: Fp6.sub(c0, r0),
        c1: Fp6.sub(c1, r1),
    });
};
var Fp12Multiply = function (_a, rhs) {
    var c0 = _a.c0, c1 = _a.c1;
    if (typeof rhs === 'bigint')
        return { c0: Fp6.mul(c0, rhs), c1: Fp6.mul(c1, rhs) };
    var r0 = rhs.c0, r1 = rhs.c1;
    var t1 = Fp6.mul(c0, r0); // c0 * r0
    var t2 = Fp6.mul(c1, r1); // c1 * r1
    return {
        c0: Fp6.add(t1, Fp6.mulByNonresidue(t2)),
        // (c0 + c1) * (r0 + r1) - (T1 + T2)
        c1: Fp6.sub(Fp6.mul(Fp6.add(c0, c1), Fp6.add(r0, r1)), Fp6.add(t1, t2)),
    };
};
exports.Fp12Multiply = Fp12Multiply;
var Fp12Square = function (_a) {
    var c0 = _a.c0, c1 = _a.c1;
    var ab = Fp6.mul(c0, c1); // c0 * c1
    return {
        // (c1 * v + c0) * (c0 + c1) - AB - AB * v
        c0: Fp6.sub(Fp6.sub(Fp6.mul(Fp6.add(Fp6.mulByNonresidue(c1), c0), Fp6.add(c0, c1)), ab), Fp6.mulByNonresidue(ab)),
        c1: Fp6.add(ab, ab),
    }; // AB + AB
};
function Fp4Square(a, b) {
    var a2 = exports.Fp2.sqr(a);
    var b2 = exports.Fp2.sqr(b);
    return {
        first: exports.Fp2.add(exports.Fp2.mulByNonresidue(b2), a2),
        second: exports.Fp2.sub(exports.Fp2.sub(exports.Fp2.sqr(exports.Fp2.add(a, b)), a2), b2), // (a + b)² - a² - b²
    };
}
var Fp12_finalExponentiate = function (num) {
    var x = BLS_X;
    // this^(q⁶) / this
    var t0 = exports.Fp12.div(exports.Fp12.frobeniusMap(num, 6), num);
    // t0^(q²) * t0
    var t1 = exports.Fp12.mul(exports.Fp12.frobeniusMap(t0, 2), t0);
    var t2 = exports.Fp12.conjugate(exports.Fp12._cyclotomicExp(t1, x));
    var t3 = exports.Fp12.mul(exports.Fp12.conjugate(exports.Fp12._cyclotomicSquare(t1)), t2);
    var t4 = exports.Fp12.conjugate(exports.Fp12._cyclotomicExp(t3, x));
    var t5 = exports.Fp12.conjugate(exports.Fp12._cyclotomicExp(t4, x));
    var t6 = exports.Fp12.mul(exports.Fp12.conjugate(exports.Fp12._cyclotomicExp(t5, x)), exports.Fp12._cyclotomicSquare(t2));
    var t7 = exports.Fp12.conjugate(exports.Fp12._cyclotomicExp(t6, x));
    var t2_t5_pow_q2 = exports.Fp12.frobeniusMap(exports.Fp12.mul(t2, t5), 2);
    var t4_t1_pow_q3 = exports.Fp12.frobeniusMap(exports.Fp12.mul(t4, t1), 3);
    var t6_t1c_pow_q1 = exports.Fp12.frobeniusMap(exports.Fp12.mul(t6, exports.Fp12.conjugate(t1)), 1);
    var t7_t3c_t1 = exports.Fp12.mul(exports.Fp12.mul(t7, exports.Fp12.conjugate(t3)), t1);
    // (t2 * t5)^(q²) * (t4 * t1)^(q³) * (t6 * t1.conj)^(q^1) * t7 * t3.conj * t1
    return exports.Fp12.mul(exports.Fp12.mul(exports.Fp12.mul(t2_t5_pow_q2, t4_t1_pow_q3), t6_t1c_pow_q1), t7_t3c_t1);
};
exports.Fp12_finalExponentiate = Fp12_finalExponentiate;
var Fp12_conjugate = function (_a) {
    var c0 = _a.c0, c1 = _a.c1;
    return ({ c0: c0, c1: Fp6.neg(c1) });
};
exports.Fp12_conjugate = Fp12_conjugate;
var Fp12_eql = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1;
    var r0 = _b.c0, r1 = _b.c1;
    return Fp6.eql(c0, r0) && Fp6.eql(c1, r1);
};
exports.Fp12_eql = Fp12_eql;
exports.Fp12_ONE = { c0: Fp6.ONE, c1: Fp6.ZERO };
exports.Fp12 = {
    ORDER: exports.Fp2.ORDER,
    BITS: 2 * exports.Fp2.BITS,
    BYTES: 2 * exports.Fp2.BYTES,
    MASK: (0, utils_1.bitMask)(2 * exports.Fp2.BITS),
    ZERO: { c0: Fp6.ZERO, c1: Fp6.ZERO },
    ONE: { c0: Fp6.ONE, c1: Fp6.ZERO },
    create: function (num) { return num; },
    isValid: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return Fp6.isValid(c0) && Fp6.isValid(c1);
    },
    is0: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return Fp6.is0(c0) && Fp6.is0(c1);
    },
    neg: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return ({ c0: Fp6.neg(c0), c1: Fp6.neg(c1) });
    },
    eql: exports.Fp12_eql,
    sqrt: function () {
        throw new Error('Not implemented');
    },
    inv: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        var t = Fp6.inv(Fp6.sub(Fp6.sqr(c0), Fp6.mulByNonresidue(Fp6.sqr(c1)))); // 1 / (c0² - c1² * v)
        return { c0: Fp6.mul(c0, t), c1: Fp6.neg(Fp6.mul(c1, t)) }; // ((C0 * T) * T) + (-C1 * T) * w
    },
    div: function (lhs, rhs) {
        return exports.Fp12.mul(lhs, typeof rhs === 'bigint' ? exports.Fp.inv(exports.Fp.create(rhs)) : exports.Fp12.inv(rhs));
    },
    pow: function (num, power) { return mod.FpPow(exports.Fp12, num, power); },
    invertBatch: function (nums) { return mod.FpInvertBatch(exports.Fp12, nums); },
    // Normalized
    add: Fp12Add,
    sub: Fp12Subtract,
    mul: exports.Fp12Multiply,
    sqr: Fp12Square,
    // NonNormalized stuff
    addN: Fp12Add,
    subN: Fp12Subtract,
    mulN: exports.Fp12Multiply,
    sqrN: Fp12Square,
    // Bytes utils
    fromBytes: function (b) {
        if (b.length !== exports.Fp12.BYTES)
            throw new Error("fromBytes wrong length=".concat(b.length));
        return {
            c0: Fp6.fromBytes(b.subarray(0, Fp6.BYTES)),
            c1: Fp6.fromBytes(b.subarray(Fp6.BYTES)),
        };
    },
    toBytes: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return (0, utils_1.concatBytes)(Fp6.toBytes(c0), Fp6.toBytes(c1));
    },
    cmov: function (_a, _b, c) {
        var c0 = _a.c0, c1 = _a.c1;
        var r0 = _b.c0, r1 = _b.c1;
        return ({
            c0: Fp6.cmov(c0, r0, c),
            c1: Fp6.cmov(c1, r1, c),
        });
    },
    // Utils
    // toString() {
    //   return `Fp12(${this.c0} + ${this.c1} * w)`;
    // },
    // fromTuple(c: [Fp6, Fp6]) {
    //   return new Fp12(...c);
    // }
    fromBigTwelve: function (t) { return ({
        c0: Fp6.fromBigSix(t.slice(0, 6)),
        c1: Fp6.fromBigSix(t.slice(6, 12)),
    }); },
    // Raises to q**i -th power
    frobeniusMap: function (lhs, power) {
        var r0 = Fp6.frobeniusMap(lhs.c0, power);
        var _a = Fp6.frobeniusMap(lhs.c1, power), c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        var coeff = FP12_FROBENIUS_COEFFICIENTS[power % 12];
        return {
            c0: r0,
            c1: Fp6.create({
                c0: exports.Fp2.mul(c0, coeff),
                c1: exports.Fp2.mul(c1, coeff),
                c2: exports.Fp2.mul(c2, coeff),
            }),
        };
    },
    // Sparse multiplication
    multiplyBy014: function (_a, o0, o1, o4) {
        var c0 = _a.c0, c1 = _a.c1;
        var t0 = Fp6.multiplyBy01(c0, o0, o1);
        var t1 = Fp6.multiplyBy1(c1, o4);
        return {
            c0: Fp6.add(Fp6.mulByNonresidue(t1), t0),
            // (c1 + c0) * [o0, o1+o4] - T0 - T1
            c1: Fp6.sub(Fp6.sub(Fp6.multiplyBy01(Fp6.add(c1, c0), o0, exports.Fp2.add(o1, o4)), t0), t1),
        };
    },
    multiplyByFp2: function (_a, rhs) {
        var c0 = _a.c0, c1 = _a.c1;
        return ({
            c0: Fp6.multiplyByFp2(c0, rhs),
            c1: Fp6.multiplyByFp2(c1, rhs),
        });
    },
    conjugate: exports.Fp12_conjugate,
    // A cyclotomic group is a subgroup of Fp^n defined by
    //   GΦₙ(p) = {α ∈ Fpⁿ : α^Φₙ(p) = 1}
    // The result of any pairing is in a cyclotomic subgroup
    // https://eprint.iacr.org/2009/565.pdf
    _cyclotomicSquare: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        var c0c0 = c0.c0, c0c1 = c0.c1, c0c2 = c0.c2;
        var c1c0 = c1.c0, c1c1 = c1.c1, c1c2 = c1.c2;
        var _b = Fp4Square(c0c0, c1c1), t3 = _b.first, t4 = _b.second;
        var _d = Fp4Square(c1c0, c0c2), t5 = _d.first, t6 = _d.second;
        var _e = Fp4Square(c0c1, c1c2), t7 = _e.first, t8 = _e.second;
        var t9 = exports.Fp2.mulByNonresidue(t8); // T8 * (u + 1)
        return {
            c0: Fp6.create({
                c0: exports.Fp2.add(exports.Fp2.mul(exports.Fp2.sub(t3, c0c0), _2n), t3),
                c1: exports.Fp2.add(exports.Fp2.mul(exports.Fp2.sub(t5, c0c1), _2n), t5),
                c2: exports.Fp2.add(exports.Fp2.mul(exports.Fp2.sub(t7, c0c2), _2n), t7),
            }),
            c1: Fp6.create({
                c0: exports.Fp2.add(exports.Fp2.mul(exports.Fp2.add(t9, c1c0), _2n), t9),
                c1: exports.Fp2.add(exports.Fp2.mul(exports.Fp2.add(t4, c1c1), _2n), t4),
                c2: exports.Fp2.add(exports.Fp2.mul(exports.Fp2.add(t6, c1c2), _2n), t6),
            }),
        }; // 2 * (T6 + c1c2) + T6
    },
    _cyclotomicExp: function (num, n) {
        var z = exports.Fp12.ONE;
        for (var i = BLS_X_LEN - 1; i >= 0; i--) {
            z = exports.Fp12._cyclotomicSquare(z);
            if ((0, utils_1.bitGet)(n, i))
                z = exports.Fp12.mul(z, num);
        }
        return z;
    },
    // https://eprint.iacr.org/2010/354.pdf
    // https://eprint.iacr.org/2009/565.pdf
    finalExponentiate: exports.Fp12_finalExponentiate,
};
var FP12_FROBENIUS_COEFFICIENTS = [
    [BigInt('0x1'), BigInt('0x0')],
    [
        BigInt('0x1904d3bf02bb0667c231beb4202c0d1f0fd603fd3cbd5f4f7b2443d784bab9c4f67ea53d63e7813d8d0775ed92235fb8'),
        BigInt('0x00fc3e2b36c4e03288e9e902231f9fb854a14787b6c7b36fec0c8ec971f63c5f282d5ac14d6c7ec22cf78a126ddc4af3'),
    ],
    [
        BigInt('0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffeffff'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x135203e60180a68ee2e9c448d77a2cd91c3dedd930b1cf60ef396489f61eb45e304466cf3e67fa0af1ee7b04121bdea2'),
        BigInt('0x06af0e0437ff400b6831e36d6bd17ffe48395dabc2d3435e77f76e17009241c5ee67992f72ec05f4c81084fbede3cc09'),
    ],
    [
        BigInt('0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x144e4211384586c16bd3ad4afa99cc9170df3560e77982d0db45f3536814f0bd5871c1908bd478cd1ee605167ff82995'),
        BigInt('0x05b2cfd9013a5fd8df47fa6b48b1e045f39816240c0b8fee8beadf4d8e9c0566c63a3e6e257f87329b18fae980078116'),
    ],
    [
        BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaaa'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x00fc3e2b36c4e03288e9e902231f9fb854a14787b6c7b36fec0c8ec971f63c5f282d5ac14d6c7ec22cf78a126ddc4af3'),
        BigInt('0x1904d3bf02bb0667c231beb4202c0d1f0fd603fd3cbd5f4f7b2443d784bab9c4f67ea53d63e7813d8d0775ed92235fb8'),
    ],
    [
        BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x06af0e0437ff400b6831e36d6bd17ffe48395dabc2d3435e77f76e17009241c5ee67992f72ec05f4c81084fbede3cc09'),
        BigInt('0x135203e60180a68ee2e9c448d77a2cd91c3dedd930b1cf60ef396489f61eb45e304466cf3e67fa0af1ee7b04121bdea2'),
    ],
    [
        BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaad'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x05b2cfd9013a5fd8df47fa6b48b1e045f39816240c0b8fee8beadf4d8e9c0566c63a3e6e257f87329b18fae980078116'),
        BigInt('0x144e4211384586c16bd3ad4afa99cc9170df3560e77982d0db45f3536814f0bd5871c1908bd478cd1ee605167ff82995'),
    ],
].map(function (n) { return exports.Fp2.fromBigTuple(n); });
// END OF CURVE FIELDS
// HashToCurve
// 3-isogeny map from E' to E https://www.rfc-editor.org/rfc/rfc9380#appendix-E.3
var isogenyMapG2 = (0, hash_to_curve_1.isogenyMap)(exports.Fp2, [
    // xNum
    [
        [
            '0x5c759507e8e333ebb5b7a9a47d7ed8532c52d39fd3a042a88b58423c50ae15d5c2638e343d9c71c6238aaaaaaaa97d6',
            '0x5c759507e8e333ebb5b7a9a47d7ed8532c52d39fd3a042a88b58423c50ae15d5c2638e343d9c71c6238aaaaaaaa97d6',
        ],
        [
            '0x0',
            '0x11560bf17baa99bc32126fced787c88f984f87adf7ae0c7f9a208c6b4f20a4181472aaa9cb8d555526a9ffffffffc71a',
        ],
        [
            '0x11560bf17baa99bc32126fced787c88f984f87adf7ae0c7f9a208c6b4f20a4181472aaa9cb8d555526a9ffffffffc71e',
            '0x8ab05f8bdd54cde190937e76bc3e447cc27c3d6fbd7063fcd104635a790520c0a395554e5c6aaaa9354ffffffffe38d',
        ],
        [
            '0x171d6541fa38ccfaed6dea691f5fb614cb14b4e7f4e810aa22d6108f142b85757098e38d0f671c7188e2aaaaaaaa5ed1',
            '0x0',
        ],
    ],
    // xDen
    [
        [
            '0x0',
            '0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaa63',
        ],
        [
            '0xc',
            '0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaa9f',
        ],
        ['0x1', '0x0'], // LAST 1
    ],
    // yNum
    [
        [
            '0x1530477c7ab4113b59a4c18b076d11930f7da5d4a07f649bf54439d87d27e500fc8c25ebf8c92f6812cfc71c71c6d706',
            '0x1530477c7ab4113b59a4c18b076d11930f7da5d4a07f649bf54439d87d27e500fc8c25ebf8c92f6812cfc71c71c6d706',
        ],
        [
            '0x0',
            '0x5c759507e8e333ebb5b7a9a47d7ed8532c52d39fd3a042a88b58423c50ae15d5c2638e343d9c71c6238aaaaaaaa97be',
        ],
        [
            '0x11560bf17baa99bc32126fced787c88f984f87adf7ae0c7f9a208c6b4f20a4181472aaa9cb8d555526a9ffffffffc71c',
            '0x8ab05f8bdd54cde190937e76bc3e447cc27c3d6fbd7063fcd104635a790520c0a395554e5c6aaaa9354ffffffffe38f',
        ],
        [
            '0x124c9ad43b6cf79bfbf7043de3811ad0761b0f37a1e26286b0e977c69aa274524e79097a56dc4bd9e1b371c71c718b10',
            '0x0',
        ],
    ],
    // yDen
    [
        [
            '0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffa8fb',
            '0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffa8fb',
        ],
        [
            '0x0',
            '0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffa9d3',
        ],
        [
            '0x12',
            '0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaa99',
        ],
        ['0x1', '0x0'], // LAST 1
    ],
].map(function (i) { return i.map(function (pair) { return exports.Fp2.fromBigTuple(pair.map(BigInt)); }); }));
// 11-isogeny map from E' to E
var isogenyMapG1 = (0, hash_to_curve_1.isogenyMap)(exports.Fp, [
    // xNum
    [
        '0x11a05f2b1e833340b809101dd99815856b303e88a2d7005ff2627b56cdb4e2c85610c2d5f2e62d6eaeac1662734649b7',
        '0x17294ed3e943ab2f0588bab22147a81c7c17e75b2f6a8417f565e33c70d1e86b4838f2a6f318c356e834eef1b3cb83bb',
        '0xd54005db97678ec1d1048c5d10a9a1bce032473295983e56878e501ec68e25c958c3e3d2a09729fe0179f9dac9edcb0',
        '0x1778e7166fcc6db74e0609d307e55412d7f5e4656a8dbf25f1b33289f1b330835336e25ce3107193c5b388641d9b6861',
        '0xe99726a3199f4436642b4b3e4118e5499db995a1257fb3f086eeb65982fac18985a286f301e77c451154ce9ac8895d9',
        '0x1630c3250d7313ff01d1201bf7a74ab5db3cb17dd952799b9ed3ab9097e68f90a0870d2dcae73d19cd13c1c66f652983',
        '0xd6ed6553fe44d296a3726c38ae652bfb11586264f0f8ce19008e218f9c86b2a8da25128c1052ecaddd7f225a139ed84',
        '0x17b81e7701abdbe2e8743884d1117e53356de5ab275b4db1a682c62ef0f2753339b7c8f8c8f475af9ccb5618e3f0c88e',
        '0x80d3cf1f9a78fc47b90b33563be990dc43b756ce79f5574a2c596c928c5d1de4fa295f296b74e956d71986a8497e317',
        '0x169b1f8e1bcfa7c42e0c37515d138f22dd2ecb803a0c5c99676314baf4bb1b7fa3190b2edc0327797f241067be390c9e',
        '0x10321da079ce07e272d8ec09d2565b0dfa7dccdde6787f96d50af36003b14866f69b771f8c285decca67df3f1605fb7b',
        '0x6e08c248e260e70bd1e962381edee3d31d79d7e22c837bc23c0bf1bc24c6b68c24b1b80b64d391fa9c8ba2e8ba2d229',
    ],
    // xDen
    [
        '0x8ca8d548cff19ae18b2e62f4bd3fa6f01d5ef4ba35b48ba9c9588617fc8ac62b558d681be343df8993cf9fa40d21b1c',
        '0x12561a5deb559c4348b4711298e536367041e8ca0cf0800c0126c2588c48bf5713daa8846cb026e9e5c8276ec82b3bff',
        '0xb2962fe57a3225e8137e629bff2991f6f89416f5a718cd1fca64e00b11aceacd6a3d0967c94fedcfcc239ba5cb83e19',
        '0x3425581a58ae2fec83aafef7c40eb545b08243f16b1655154cca8abc28d6fd04976d5243eecf5c4130de8938dc62cd8',
        '0x13a8e162022914a80a6f1d5f43e7a07dffdfc759a12062bb8d6b44e833b306da9bd29ba81f35781d539d395b3532a21e',
        '0xe7355f8e4e667b955390f7f0506c6e9395735e9ce9cad4d0a43bcef24b8982f7400d24bc4228f11c02df9a29f6304a5',
        '0x772caacf16936190f3e0c63e0596721570f5799af53a1894e2e073062aede9cea73b3538f0de06cec2574496ee84a3a',
        '0x14a7ac2a9d64a8b230b3f5b074cf01996e7f63c21bca68a81996e1cdf9822c580fa5b9489d11e2d311f7d99bbdcc5a5e',
        '0xa10ecf6ada54f825e920b3dafc7a3cce07f8d1d7161366b74100da67f39883503826692abba43704776ec3a79a1d641',
        '0x95fc13ab9e92ad4476d6e3eb3a56680f682b4ee96f7d03776df533978f31c1593174e4b4b7865002d6384d168ecdd0a',
        '0x000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001', // LAST 1
    ],
    // yNum
    [
        '0x90d97c81ba24ee0259d1f094980dcfa11ad138e48a869522b52af6c956543d3cd0c7aee9b3ba3c2be9845719707bb33',
        '0x134996a104ee5811d51036d776fb46831223e96c254f383d0f906343eb67ad34d6c56711962fa8bfe097e75a2e41c696',
        '0xcc786baa966e66f4a384c86a3b49942552e2d658a31ce2c344be4b91400da7d26d521628b00523b8dfe240c72de1f6',
        '0x1f86376e8981c217898751ad8746757d42aa7b90eeb791c09e4a3ec03251cf9de405aba9ec61deca6355c77b0e5f4cb',
        '0x8cc03fdefe0ff135caf4fe2a21529c4195536fbe3ce50b879833fd221351adc2ee7f8dc099040a841b6daecf2e8fedb',
        '0x16603fca40634b6a2211e11db8f0a6a074a7d0d4afadb7bd76505c3d3ad5544e203f6326c95a807299b23ab13633a5f0',
        '0x4ab0b9bcfac1bbcb2c977d027796b3ce75bb8ca2be184cb5231413c4d634f3747a87ac2460f415ec961f8855fe9d6f2',
        '0x987c8d5333ab86fde9926bd2ca6c674170a05bfe3bdd81ffd038da6c26c842642f64550fedfe935a15e4ca31870fb29',
        '0x9fc4018bd96684be88c9e221e4da1bb8f3abd16679dc26c1e8b6e6a1f20cabe69d65201c78607a360370e577bdba587',
        '0xe1bba7a1186bdb5223abde7ada14a23c42a0ca7915af6fe06985e7ed1e4d43b9b3f7055dd4eba6f2bafaaebca731c30',
        '0x19713e47937cd1be0dfd0b8f1d43fb93cd2fcbcb6caf493fd1183e416389e61031bf3a5cce3fbafce813711ad011c132',
        '0x18b46a908f36f6deb918c143fed2edcc523559b8aaf0c2462e6bfe7f911f643249d9cdf41b44d606ce07c8a4d0074d8e',
        '0xb182cac101b9399d155096004f53f447aa7b12a3426b08ec02710e807b4633f06c851c1919211f20d4c04f00b971ef8',
        '0x245a394ad1eca9b72fc00ae7be315dc757b3b080d4c158013e6632d3c40659cc6cf90ad1c232a6442d9d3f5db980133',
        '0x5c129645e44cf1102a159f748c4a3fc5e673d81d7e86568d9ab0f5d396a7ce46ba1049b6579afb7866b1e715475224b',
        '0x15e6be4e990f03ce4ea50b3b42df2eb5cb181d8f84965a3957add4fa95af01b2b665027efec01c7704b456be69c8b604',
    ],
    // yDen
    [
        '0x16112c4c3a9c98b252181140fad0eae9601a6de578980be6eec3232b5be72e7a07f3688ef60c206d01479253b03663c1',
        '0x1962d75c2381201e1a0cbd6c43c348b885c84ff731c4d59ca4a10356f453e01f78a4260763529e3532f6102c2e49a03d',
        '0x58df3306640da276faaae7d6e8eb15778c4855551ae7f310c35a5dd279cd2eca6757cd636f96f891e2538b53dbf67f2',
        '0x16b7d288798e5395f20d23bf89edb4d1d115c5dbddbcd30e123da489e726af41727364f2c28297ada8d26d98445f5416',
        '0xbe0e079545f43e4b00cc912f8228ddcc6d19c9f0f69bbb0542eda0fc9dec916a20b15dc0fd2ededda39142311a5001d',
        '0x8d9e5297186db2d9fb266eaac783182b70152c65550d881c5ecd87b6f0f5a6449f38db9dfa9cce202c6477faaf9b7ac',
        '0x166007c08a99db2fc3ba8734ace9824b5eecfdfa8d0cf8ef5dd365bc400a0051d5fa9c01a58b1fb93d1a1399126a775c',
        '0x16a3ef08be3ea7ea03bcddfabba6ff6ee5a4375efa1f4fd7feb34fd206357132b920f5b00801dee460ee415a15812ed9',
        '0x1866c8ed336c61231a1be54fd1d74cc4f9fb0ce4c6af5920abc5750c4bf39b4852cfe2f7bb9248836b233d9d55535d4a',
        '0x167a55cda70a6e1cea820597d94a84903216f763e13d87bb5308592e7ea7d4fbc7385ea3d529b35e346ef48bb8913f55',
        '0x4d2f259eea405bd48f010a01ad2911d9c6dd039bb61a6290e591b36e636a5c871a5c29f4f83060400f8b49cba8f6aa8',
        '0xaccbb67481d033ff5852c1e48c50c477f94ff8aefce42d28c0f9a88cea7913516f968986f7ebbea9684b529e2561092',
        '0xad6b9514c767fe3c3613144b45f1496543346d98adf02267d5ceef9a00d9b8693000763e3b90ac11e99b138573345cc',
        '0x2660400eb2e4f3b628bdd0d53cd76f2bf565b94e72927c1cb748df27942480e420517bd8714cc80d1fadc1326ed06f7',
        '0xe0fa1d816ddc03e6b24255e0d7819c171c40f65e273b853324efcd6356caa205ca2f570f13497804415473a1d634b8f',
        '0x000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001', // LAST 1
    ],
].map(function (i) { return i.map(function (j) { return BigInt(j); }); }));
// SWU Map - Fp2 to G2': y² = x³ + 240i * x + 1012 + 1012i
var G2_SWU = (0, weierstrass_1.mapToCurveSimpleSWU)(exports.Fp2, {
    A: exports.Fp2.create({ c0: exports.Fp.create(_0n), c1: exports.Fp.create(BigInt(240)) }),
    B: exports.Fp2.create({ c0: exports.Fp.create(BigInt(1012)), c1: exports.Fp.create(BigInt(1012)) }),
    Z: exports.Fp2.create({ c0: exports.Fp.create(BigInt(-2)), c1: exports.Fp.create(BigInt(-1)) }), // Z: -(2 + I)
});
// Optimized SWU Map - Fp to G1
var G1_SWU = (0, weierstrass_1.mapToCurveSimpleSWU)(exports.Fp, {
    A: exports.Fp.create(BigInt('0x144698a3b8e9433d693a02c96d4982b0ea985383ee66a8d8e8981aefd881ac98936f8da0e0f97f5cf428082d584c1d')),
    B: exports.Fp.create(BigInt('0x12e2908d11688030018b12e8753eee3b2016c1f0f24f4070a0b9c14fcef35ef55a23215a316ceaa5d1cc48e98e172be0')),
    Z: exports.Fp.create(BigInt(11)),
});
// Endomorphisms (for fast cofactor clearing)
// Ψ(P) endomorphism
var ut_root = Fp6.create({ c0: exports.Fp2.ZERO, c1: exports.Fp2.ONE, c2: exports.Fp2.ZERO });
var wsq = exports.Fp12.create({ c0: ut_root, c1: Fp6.ZERO });
var wcu = exports.Fp12.create({ c0: Fp6.ZERO, c1: ut_root });
var _a = __read(exports.Fp12.invertBatch([wsq, wcu]), 2), wsq_inv = _a[0], wcu_inv = _a[1];
function psi(x, y) {
    // Untwist Fp2->Fp12 && frobenius(1) && twist back
    var x2 = exports.Fp12.mul(exports.Fp12.frobeniusMap(exports.Fp12.multiplyByFp2(wsq_inv, x), 1), wsq).c0.c0;
    var y2 = exports.Fp12.mul(exports.Fp12.frobeniusMap(exports.Fp12.multiplyByFp2(wcu_inv, y), 1), wcu).c0.c0;
    return [x2, y2];
}
// Ψ endomorphism
function G2psi(c, P) {
    var affine = P.toAffine();
    var p = psi(affine.x, affine.y);
    return new c(p[0], p[1], exports.Fp2.ONE);
}
// Ψ²(P) endomorphism
// 1 / F2(2)^((p-1)/3) in GF(p²)
var PSI2_C1 = BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac');
function psi2(x, y) {
    return [exports.Fp2.mul(x, PSI2_C1), exports.Fp2.neg(y)];
}
function G2psi2(c, P) {
    var affine = P.toAffine();
    var p = psi2(affine.x, affine.y);
    return new c(p[0], p[1], exports.Fp2.ONE);
}
// Default hash_to_field options are for hash to G2.
//
// Parameter definitions are in section 5.3 of the spec unless otherwise noted.
// Parameter values come from section 8.8.2 of the spec.
// https://www.rfc-editor.org/rfc/rfc9380#section-8.8.2
//
// Base field F is GF(p^m)
// p = 0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab
// m = 2 (or 1 for G1 see section 8.8.1)
// k = 128
var htfDefaults = Object.freeze({
    // DST: a domain separation tag
    // defined in section 2.2.5
    // Use utils.getDSTLabel(), utils.setDSTLabel(value)
    DST: "",
    encodeDST: "",
    // p: the characteristic of F
    //    where F is a finite field of characteristic p and order q = p^m
    p: exports.Fp.ORDER,
    // m: the extension degree of F, m >= 1
    //     where F is a finite field of characteristic p and order q = p^m
    m: 2,
    // k: the target security level for the suite in bits
    // defined in section 5.1
    k: 128,
    // option to use a message that has already been processed by
    // expand_message_xmd
    expand: 'xmd',
    // Hash functions for: expand_message_xmd is appropriate for use with a
    // wide range of hash functions, including SHA-2, SHA-3, BLAKE2, and others.
    // BBS+ uses blake2: https://github.com/hyperledger/aries-framework-go/issues/2247
    hash: sha256_1.sha256,
});
// Encoding utils
// Point on G1 curve: (x, y)
// Compressed point of infinity
var COMPRESSED_ZERO = setMask(exports.Fp.toBytes(_0n), { infinity: true, compressed: true }); // set compressed & point-at-infinity bits
function parseMask(bytes) {
    // Copy, so we can remove mask data. It will be removed also later, when Fp.create will call modulo.
    bytes = bytes.slice();
    var mask = bytes[0] & 224;
    var compressed = !!((mask >> 7) & 1); // compression bit (0b1000_0000)
    var infinity = !!((mask >> 6) & 1); // point at infinity bit (0b0100_0000)
    var sort = !!((mask >> 5) & 1); // sort bit (0b0010_0000)
    bytes[0] &= 31; // clear mask (zero first 3 bits)
    return { compressed: compressed, infinity: infinity, sort: sort, value: bytes };
}
exports.parseMask = parseMask;
function setMask(bytes, mask) {
    if (bytes[0] & 224)
        throw new Error('setMask: non-empty mask');
    if (mask.compressed)
        bytes[0] |= 128;
    if (mask.infinity)
        bytes[0] |= 64;
    if (mask.sort)
        bytes[0] |= 32;
    return bytes;
}
function signatureG1ToRawBytes(point) {
    point.assertValidity();
    var isZero = point.equals(exports.bls12_381.G1.ProjectivePoint.ZERO);
    var _a = point.toAffine(), x = _a.x, y = _a.y;
    if (isZero)
        return COMPRESSED_ZERO.slice();
    var P = exports.Fp.ORDER;
    var sort = Boolean((y * _2n) / P);
    return setMask((0, utils_1.numberToBytesBE)(x, exports.Fp.BYTES), { compressed: true, sort: sort });
}
function signatureG2ToRawBytes(point) {
    // NOTE: by some reasons it was missed in bls12-381, looks like bug
    point.assertValidity();
    var len = exports.Fp.BYTES;
    if (point.equals(exports.bls12_381.G2.ProjectivePoint.ZERO))
        return (0, utils_1.concatBytes)(COMPRESSED_ZERO, (0, utils_1.numberToBytesBE)(_0n, len));
    var _a = point.toAffine(), x = _a.x, y = _a.y;
    var _b = exports.Fp2.reim(x), x0 = _b.re, x1 = _b.im;
    var _d = exports.Fp2.reim(y), y0 = _d.re, y1 = _d.im;
    var tmp = y1 > _0n ? y1 * _2n : y0 * _2n;
    var sort = Boolean((tmp / exports.Fp.ORDER) & _1n);
    var z2 = x0;
    return (0, utils_1.concatBytes)(setMask((0, utils_1.numberToBytesBE)(x1, len), { sort: sort, compressed: true }), (0, utils_1.numberToBytesBE)(z2, len));
}
var G1_formBytes = function (bytes) {
    var _a = parseMask(bytes), compressed = _a.compressed, infinity = _a.infinity, sort = _a.sort, value = _a.value;
    if (value.length === 48 && compressed) {
        // TODO: Fp.bytes
        var P = exports.Fp.ORDER;
        var compressedValue = (0, utils_1.bytesToNumberBE)(value);
        // Zero
        var x = exports.Fp.create(compressedValue & exports.Fp.MASK);
        if (infinity) {
            if (x !== _0n)
                throw new Error('G1: non-empty compressed point at infinity');
            return { x: _0n, y: _0n };
        }
        var right = exports.Fp.add(exports.Fp.pow(x, _3n), exports.Fp.create(exports.bls12_381.params.G1b)); // y² = x³ + b
        var y = exports.Fp.sqrt(right);
        if (!y)
            throw new Error('Invalid compressed G1 point');
        if ((y * _2n) / P !== BigInt(sort))
            y = exports.Fp.neg(y);
        return { x: exports.Fp.create(x), y: exports.Fp.create(y) };
    }
    else if (value.length === 96 && !compressed) {
        // Check if the infinity flag is set
        var x = (0, utils_1.bytesToNumberBE)(value.subarray(0, exports.Fp.BYTES));
        var y = (0, utils_1.bytesToNumberBE)(value.subarray(exports.Fp.BYTES));
        if (infinity) {
            if (x !== _0n || y !== _0n)
                throw new Error('G1: non-empty point at infinity');
            return exports.bls12_381.G1.ProjectivePoint.ZERO.toAffine();
        }
        return { x: exports.Fp.create(x), y: exports.Fp.create(y) };
    }
    else {
        throw new Error('Invalid point G1, expected 48/96 bytes');
    }
};
exports.G1_formBytes = G1_formBytes;
var G1_mapToCurve = function (scalars) {
    var _a = G1_SWU(exports.Fp.create(scalars[0])), x = _a.x, y = _a.y;
    return isogenyMapG1(x, y);
};
exports.G1_mapToCurve = G1_mapToCurve;
var G2_mapToCurve = function (scalars) {
    var _a = G2_SWU(exports.Fp2.fromBigTuple(scalars)), x = _a.x, y = _a.y;
    return isogenyMapG2(x, y);
};
exports.G2_mapToCurve = G2_mapToCurve;
// To verify curve parameters, see pairing-friendly-curves spec:
// https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-pairing-friendly-curves-11
// Basic math is done over finite fields over p.
// More complicated math is done over polynominal extension fields.
// To simplify calculations in Fp12, we construct extension tower:
// Fp₁₂ = Fp₆² => Fp₂³
// Fp(u) / (u² - β) where β = -1
// Fp₂(v) / (v³ - ξ) where ξ = u + 1
// Fp₆(w) / (w² - γ) where γ = v
// Here goes constants && point encoding format
exports.bls12_381 = (0, bls_1.bls)({
    // Fields
    fields: {
        Fp: exports.Fp,
        Fp2: exports.Fp2,
        Fp6: Fp6,
        Fp12: exports.Fp12,
        Fr: Fr,
    },
    // G1 is the order-q subgroup of E1(Fp) : y² = x³ + 4, #E1(Fp) = h1q, where
    // characteristic; z + (z⁴ - z² + 1)(z - 1)²/3
    G1: {
        Fp: exports.Fp,
        // cofactor; (z - 1)²/3
        h: BigInt('0x396c8c005555e1568c00aaab0000aaab'),
        // generator's coordinates
        // x = 3685416753713387016781088315183077757961620795782546409894578378688607592378376318836054947676345821548104185464507
        // y = 1339506544944476473020471379941921221584933875938349620426543736416511423956333506472724655353366534992391756441569
        Gx: BigInt('0x17f1d3a73197d7942695638c4fa9ac0fc3688c4f9774b905a14e3a3f171bac586c55e83ff97a1aeffb3af00adb22c6bb'),
        Gy: BigInt('0x08b3f481e3aaa0f1a09e30ed741d8ae4fcf5e095d5d00af600db18cb2c04b3edd03cc744a2888ae40caa232946c5e7e1'),
        a: exports.Fp.ZERO,
        b: _4n,
        htfDefaults: __assign(__assign({}, htfDefaults), { m: 1, DST: 'BLS_SIG_BLS12381G1_XMD:SHA-256_SSWU_RO_NUL_' }),
        wrapPrivateKey: true,
        allowInfinityPoint: true,
        // Checks is the point resides in prime-order subgroup.
        // point.isTorsionFree() should return true for valid points
        // It returns false for shitty points.
        // https://eprint.iacr.org/2021/1130.pdf
        isTorsionFree: function (c, point) {
            // φ endomorphism
            var cubicRootOfUnityModP = BigInt('0x5f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe');
            var phi = new c(exports.Fp.mul(point.px, cubicRootOfUnityModP), point.py, point.pz);
            // todo: unroll
            var xP = point.multiplyUnsafe(exports.bls12_381.params.x).negate(); // [x]P
            var u2P = xP.multiplyUnsafe(exports.bls12_381.params.x); // [u2]P
            return u2P.equals(phi);
            // https://eprint.iacr.org/2019/814.pdf
            // (z² − 1)/3
            // const c1 = BigInt('0x396c8c005555e1560000000055555555');
            // const P = this;
            // const S = P.sigma();
            // const Q = S.double();
            // const S2 = S.sigma();
            // // [(z² − 1)/3](2σ(P) − P − σ²(P)) − σ²(P) = O
            // const left = Q.subtract(P).subtract(S2).multiplyUnsafe(c1);
            // const C = left.subtract(S2);
            // return C.isZero();
        },
        // Clear cofactor of G1
        // https://eprint.iacr.org/2019/403
        clearCofactor: function (_c, point) {
            // return this.multiplyUnsafe(CURVE.h);
            return point.multiplyUnsafe(exports.bls12_381.params.x).add(point); // x*P + P
        },
        mapToCurve: exports.G1_mapToCurve,
        fromBytes: exports.G1_formBytes,
        toBytes: function (c, point, isCompressed) {
            var isZero = point.equals(c.ZERO);
            var _a = point.toAffine(), x = _a.x, y = _a.y;
            if (isCompressed) {
                if (isZero)
                    return COMPRESSED_ZERO.slice();
                var P = exports.Fp.ORDER;
                var sort = Boolean((y * _2n) / P);
                return setMask((0, utils_1.numberToBytesBE)(x, exports.Fp.BYTES), { compressed: true, sort: sort });
            }
            else {
                if (isZero) {
                    // 2x PUBLIC_KEY_LENGTH
                    var x_2 = (0, utils_1.concatBytes)(new Uint8Array([0x40]), new Uint8Array(2 * exports.Fp.BYTES - 1));
                    return x_2;
                }
                else {
                    return (0, utils_1.concatBytes)((0, utils_1.numberToBytesBE)(x, exports.Fp.BYTES), (0, utils_1.numberToBytesBE)(y, exports.Fp.BYTES));
                }
            }
        },
        ShortSignature: {
            fromHex: function (hex) {
                var _a = parseMask((0, utils_1.ensureBytes)('signatureHex', hex, 48)), infinity = _a.infinity, sort = _a.sort, value = _a.value;
                var P = exports.Fp.ORDER;
                var compressedValue = (0, utils_1.bytesToNumberBE)(value);
                // Zero
                if (infinity)
                    return exports.bls12_381.G1.ProjectivePoint.ZERO;
                var x = exports.Fp.create(compressedValue & exports.Fp.MASK);
                var right = exports.Fp.add(exports.Fp.pow(x, _3n), exports.Fp.create(exports.bls12_381.params.G1b)); // y² = x³ + b
                var y = exports.Fp.sqrt(right);
                if (!y)
                    throw new Error('Invalid compressed G1 point');
                var aflag = BigInt(sort);
                if ((y * _2n) / P !== aflag)
                    y = exports.Fp.neg(y);
                var point = exports.bls12_381.G1.ProjectivePoint.fromAffine({ x: x, y: y });
                point.assertValidity();
                return point;
            },
            toRawBytes: function (point) {
                return signatureG1ToRawBytes(point);
            },
            toHex: function (point) {
                return (0, utils_1.bytesToHex)(signatureG1ToRawBytes(point));
            },
        },
    },
    // G2 is the order-q subgroup of E2(Fp²) : y² = x³+4(1+√−1),
    // where Fp2 is Fp[√−1]/(x2+1). #E2(Fp2 ) = h2q, where
    // G² - 1
    // h2q
    G2: {
        Fp: exports.Fp2,
        // cofactor
        h: BigInt('0x5d543a95414e7f1091d50792876a202cd91de4547085abaa68a205b2e5a7ddfa628f1cb4d9e82ef21537e293a6691ae1616ec6e786f0c70cf1c38e31c7238e5'),
        Gx: exports.Fp2.fromBigTuple([
            BigInt('0x024aa2b2f08f0a91260805272dc51051c6e47ad4fa403b02b4510b647ae3d1770bac0326a805bbefd48056c8c121bdb8'),
            BigInt('0x13e02b6052719f607dacd3a088274f65596bd0d09920b61ab5da61bbdc7f5049334cf11213945d57e5ac7d055d042b7e'),
        ]),
        // y =
        // 927553665492332455747201965776037880757740193453592970025027978793976877002675564980949289727957565575433344219582,
        // 1985150602287291935568054521177171638300868978215655730859378665066344726373823718423869104263333984641494340347905
        Gy: exports.Fp2.fromBigTuple([
            BigInt('0x0ce5d527727d6e118cc9cdc6da2e351aadfd9baa8cbdd3a76d429a695160d12c923ac9cc3baca289e193548608b82801'),
            BigInt('0x0606c4a02ea734cc32acd2b02bc28b99cb3e287e85a763af267492ab572e99ab3f370d275cec1da1aaa9075ff05f79be'),
        ]),
        a: exports.Fp2.ZERO,
        b: exports.Fp2.fromBigTuple([_4n, _4n]),
        hEff: BigInt('0xbc69f08f2ee75b3584c6a0ea91b352888e2a8e9145ad7689986ff031508ffe1329c2f178731db956d82bf015d1212b02ec0ec69d7477c1ae954cbc06689f6a359894c0adebbf6b4e8020005aaa95551'),
        htfDefaults: __assign({}, htfDefaults),
        wrapPrivateKey: true,
        allowInfinityPoint: true,
        mapToCurve: exports.G2_mapToCurve,
        // Checks is the point resides in prime-order subgroup.
        // point.isTorsionFree() should return true for valid points
        // It returns false for shitty points.
        // https://eprint.iacr.org/2021/1130.pdf
        isTorsionFree: function (c, P) {
            return P.multiplyUnsafe(exports.bls12_381.params.x).negate().equals(G2psi(c, P)); // ψ(P) == [u](P)
            // Older version: https://eprint.iacr.org/2019/814.pdf
            // Ψ²(P) => Ψ³(P) => [z]Ψ³(P) where z = -x => [z]Ψ³(P) - Ψ²(P) + P == O
            // return P.psi2().psi().mulNegX().subtract(psi2).add(P).isZero();
        },
        // Maps the point into the prime-order subgroup G2.
        // clear_cofactor_bls12381_g2 from cfrg-hash-to-curve-11
        // https://eprint.iacr.org/2017/419.pdf
        // prettier-ignore
        clearCofactor: function (c, P) {
            var x = exports.bls12_381.params.x;
            var t1 = P.multiplyUnsafe(x).negate(); // [-x]P
            var t2 = G2psi(c, P); // Ψ(P)
            var t3 = P.double(); // 2P
            t3 = G2psi2(c, t3); // Ψ²(2P)
            t3 = t3.subtract(t2); // Ψ²(2P) - Ψ(P)
            t2 = t1.add(t2); // [-x]P + Ψ(P)
            t2 = t2.multiplyUnsafe(x).negate(); // [x²]P - [x]Ψ(P)
            t3 = t3.add(t2); // Ψ²(2P) - Ψ(P) + [x²]P - [x]Ψ(P)
            t3 = t3.subtract(t1); // Ψ²(2P) - Ψ(P) + [x²]P - [x]Ψ(P) + [x]P
            var Q = t3.subtract(P); // Ψ²(2P) - Ψ(P) + [x²]P - [x]Ψ(P) + [x]P - 1P
            return Q; // [x²-x-1]P + [x-1]Ψ(P) + Ψ²(2P)
        },
        fromBytes: function (bytes) {
            var _a = parseMask(bytes), compressed = _a.compressed, infinity = _a.infinity, sort = _a.sort, value = _a.value;
            if ((!compressed && !infinity && sort) || // 00100000
                (!compressed && infinity && sort) || // 01100000
                (sort && infinity && compressed) // 11100000
            ) {
                throw new Error('Invalid encoding flag: ' + (bytes[0] & 224));
            }
            var L = exports.Fp.BYTES;
            var slc = function (b, from, to) { return (0, utils_1.bytesToNumberBE)(b.slice(from, to)); };
            if (value.length === 96 && compressed) {
                var b = exports.bls12_381.params.G2b;
                var P = exports.Fp.ORDER;
                if (infinity) {
                    // check that all bytes are 0
                    if (value.reduce(function (p, c) { return (p !== 0 ? c + 1 : c); }, 0) > 0) {
                        throw new Error('Invalid compressed G2 point');
                    }
                    return { x: exports.Fp2.ZERO, y: exports.Fp2.ZERO };
                }
                var x_1 = slc(value, 0, L);
                var x_0 = slc(value, L, 2 * L);
                var x = exports.Fp2.create({ c0: exports.Fp.create(x_0), c1: exports.Fp.create(x_1) });
                var right = exports.Fp2.add(exports.Fp2.pow(x, _3n), b); // y² = x³ + 4 * (u+1) = x³ + b
                var y = exports.Fp2.sqrt(right);
                var Y_bit = y.c1 === _0n ? (y.c0 * _2n) / P : (y.c1 * _2n) / P ? _1n : _0n;
                y = sort && Y_bit > 0 ? y : exports.Fp2.neg(y);
                return { x: x, y: y };
            }
            else if (value.length === 192 && !compressed) {
                if (infinity) {
                    if (value.reduce(function (p, c) { return (p !== 0 ? c + 1 : c); }, 0) > 0) {
                        throw new Error('Invalid uncompressed G2 point');
                    }
                    return { x: exports.Fp2.ZERO, y: exports.Fp2.ZERO };
                }
                var x1 = slc(value, 0, L);
                var x0 = slc(value, L, 2 * L);
                var y1 = slc(value, 2 * L, 3 * L);
                var y0 = slc(value, 3 * L, 4 * L);
                return { x: exports.Fp2.fromBigTuple([x0, x1]), y: exports.Fp2.fromBigTuple([y0, y1]) };
            }
            else {
                throw new Error('Invalid point G2, expected 96/192 bytes');
            }
        },
        toBytes: function (c, point, isCompressed) {
            var len = exports.Fp.BYTES, P = exports.Fp.ORDER;
            var isZero = point.equals(c.ZERO);
            var _a = point.toAffine(), x = _a.x, y = _a.y;
            if (isCompressed) {
                if (isZero)
                    return (0, utils_1.concatBytes)(COMPRESSED_ZERO, (0, utils_1.numberToBytesBE)(_0n, len));
                var flag = Boolean(y.c1 === _0n ? (y.c0 * _2n) / P : (y.c1 * _2n) / P);
                return (0, utils_1.concatBytes)(setMask((0, utils_1.numberToBytesBE)(x.c1, len), { compressed: true, sort: flag }), (0, utils_1.numberToBytesBE)(x.c0, len));
            }
            else {
                if (isZero)
                    return (0, utils_1.concatBytes)(new Uint8Array([0x40]), new Uint8Array(4 * len - 1)); // bytes[0] |= 1 << 6;
                var _b = exports.Fp2.reim(x), x0 = _b.re, x1 = _b.im;
                var _d = exports.Fp2.reim(y), y0 = _d.re, y1 = _d.im;
                return (0, utils_1.concatBytes)((0, utils_1.numberToBytesBE)(x1, len), (0, utils_1.numberToBytesBE)(x0, len), (0, utils_1.numberToBytesBE)(y1, len), (0, utils_1.numberToBytesBE)(y0, len));
            }
        },
        Signature: {
            // TODO: Optimize, it's very slow because of sqrt.
            fromHex: function (hex) {
                var _a = parseMask((0, utils_1.ensureBytes)('signatureHex', hex)), infinity = _a.infinity, sort = _a.sort, value = _a.value;
                var P = exports.Fp.ORDER;
                var half = hex.length / 2;
                if (half !== 48 && half !== 96)
                    throw new Error('Invalid compressed signature length, must be 96 or 192');
                var z1 = (0, utils_1.bytesToNumberBE)(value.slice(0, half));
                var z2 = (0, utils_1.bytesToNumberBE)(value.slice(half));
                // Indicates the infinity point
                if (infinity)
                    return exports.bls12_381.G2.ProjectivePoint.ZERO;
                var x1 = exports.Fp.create(z1 & exports.Fp.MASK);
                var x2 = exports.Fp.create(z2);
                var x = exports.Fp2.create({ c0: x2, c1: x1 });
                var y2 = exports.Fp2.add(exports.Fp2.pow(x, _3n), exports.bls12_381.params.G2b); // y² = x³ + 4
                // The slow part
                var y = exports.Fp2.sqrt(y2);
                if (!y)
                    throw new Error('Failed to find a square root');
                // Choose the y whose leftmost bit of the imaginary part is equal to the a_flag1
                // If y1 happens to be zero, then use the bit of y0
                var _b = exports.Fp2.reim(y), y0 = _b.re, y1 = _b.im;
                var aflag1 = BigInt(sort);
                var isGreater = y1 > _0n && (y1 * _2n) / P !== aflag1;
                var isZero = y1 === _0n && (y0 * _2n) / P !== aflag1;
                if (isGreater || isZero)
                    y = exports.Fp2.neg(y);
                var point = exports.bls12_381.G2.ProjectivePoint.fromAffine({ x: x, y: y });
                point.assertValidity();
                return point;
            },
            toRawBytes: function (point) {
                return signatureG2ToRawBytes(point);
            },
            toHex: function (point) {
                return (0, utils_1.bytesToHex)(signatureG2ToRawBytes(point));
            },
        },
    },
    params: {
        x: BLS_X,
        r: Fr.ORDER, // order; z⁴ − z² + 1; CURVE.n from other curves
    },
    htfDefaults: htfDefaults,
    hash: sha256_1.sha256,
    randomBytes: utils_2.randomBytes
});


/***/ }),

/***/ 86036:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.crypto = void 0;
exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;


/***/ }),

/***/ 72213:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateBasic = exports.wNAF = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// Abelian group utilities
var modular_1 = __webpack_require__(79467);
var utils_1 = __webpack_require__(89632);
var _0n = BigInt(0);
var _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    var constTimeNegate = function (condition, item) {
        var neg = item.negate();
        return condition ? neg : item;
    };
    var opts = function (W) {
        var windows = Math.ceil(bits / W) + 1; // +1, because
        var windowSize = Math.pow(2, (W - 1)); // -1 because we skip zero
        return { windows: windows, windowSize: windowSize };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder: function (elm, n) {
            var p = c.ZERO;
            var d = elm;
            while (n > _0n) {
                if (n & _1n)
                    p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */
        precomputeWindow: function (elm, W) {
            var _a = opts(W), windows = _a.windows, windowSize = _a.windowSize;
            var points = [];
            var p = elm;
            var base = p;
            for (var window_1 = 0; window_1 < windows; window_1++) {
                base = p;
                points.push(base);
                // =1, because we skip zero
                for (var i = 1; i < windowSize; i++) {
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */
        wNAF: function (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            var _a = opts(W), windows = _a.windows, windowSize = _a.windowSize;
            var p = c.ZERO;
            var f = c.BASE;
            var mask = BigInt(Math.pow(2, W) - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            var maxNumber = Math.pow(2, W);
            var shiftBy = BigInt(W);
            for (var window_2 = 0; window_2 < windows; window_2++) {
                var offset = window_2 * windowSize;
                // Extract W bits.
                var wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                var offset1 = offset;
                var offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                var cond1 = window_2 % 2 !== 0;
                var cond2 = wbits < 0;
                if (wbits === 0) {
                    // The most important part for const-time getPublicKey
                    f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                }
                else {
                    p = p.add(constTimeNegate(cond2, precomputes[offset2]));
                }
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return { p: p, f: f };
        },
        wNAFCached: function (P, precomputesMap, n, transform) {
            // @ts-ignore
            var W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            var comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) {
                    precomputesMap.set(P, transform(comp));
                }
            }
            return this.wNAF(W, comp, n);
        },
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, modular_1.validateField)(curve.Fp);
    (0, utils_1.validateObject)(curve, {
        n: 'bigint',
        h: 'bigint',
        Gx: 'field',
        Gy: 'field',
    }, {
        nBitLength: 'isSafeInteger',
        nByteLength: 'isSafeInteger',
    });
    // Set defaults
    return Object.freeze(__assign(__assign(__assign({}, (0, modular_1.nLength)(curve.n, curve.nBitLength)), curve), { p: curve.Fp.ORDER }));
}
exports.validateBasic = validateBasic;


/***/ }),

/***/ 79467:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapHashToField = exports.getMinHashLength = exports.getFieldBytesLength = exports.hashToPrivateScalar = exports.FpSqrtEven = exports.FpSqrtOdd = exports.Field = exports.nLength = exports.FpIsSquare = exports.FpDiv = exports.FpInvertBatch = exports.FpPow = exports.validateField = exports.isNegativeLE = exports.FpSqrt = exports.tonelliShanks = exports.invert = exports.pow2 = exports.pow = exports.mod = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// Utilities for modular arithmetics and finite fields
var utils_1 = __webpack_require__(89632);
// prettier-ignore
var _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3);
// prettier-ignore
var _4n = BigInt(4), _5n = BigInt(5), _8n = BigInt(8);
// prettier-ignore
var _9n = BigInt(9), _16n = BigInt(16);
// Calculates a modulo b
function mod(a, b) {
    var result = a % b;
    return result >= _0n ? result : b + result;
}
exports.mod = mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */
// TODO: use field version && remove
function pow(num, power, modulo) {
    if (modulo <= _0n || power < _0n)
        throw new Error('Expected power/modulo > 0');
    if (modulo === _1n)
        return _0n;
    var res = _1n;
    while (power > _0n) {
        if (power & _1n)
            res = (res * num) % modulo;
        num = (num * num) % modulo;
        power >>= _1n;
    }
    return res;
}
exports.pow = pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function pow2(x, power, modulo) {
    var res = x;
    while (power-- > _0n) {
        res *= res;
        res %= modulo;
    }
    return res;
}
exports.pow2 = pow2;
// Inverses number over modulo
function invert(number, modulo) {
    if (number === _0n || modulo <= _0n) {
        throw new Error("invert: expected positive integers, got n=".concat(number, " mod=").concat(modulo));
    }
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    var a = mod(number, modulo);
    var b = modulo;
    // prettier-ignore
    var x = _0n, y = _1n, u = _1n, v = _0n;
    while (a !== _0n) {
        // JIT applies optimization if those two lines follow each other
        var q = b / a;
        var r = b % a;
        var m = x - u * q;
        var n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    var gcd = b;
    if (gcd !== _1n)
        throw new Error('invert: does not exist');
    return mod(x, modulo);
}
exports.invert = invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */
function tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    var legendreC = (P - _1n) / _2n;
    var Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for (Q = P - _1n, S = 0; Q % _2n === _0n; Q /= _2n, S++)
        ;
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for (Z = _2n; Z < P && pow(Z, legendreC, P) !== P - _1n; Z++)
        ;
    // Fast-path
    if (S === 1) {
        var p1div4_1 = (P + _1n) / _4n;
        return function tonelliFast(Fp, n) {
            var root = Fp.pow(n, p1div4_1);
            if (!Fp.eql(Fp.sqr(root), n))
                throw new Error('Cannot find square root');
            return root;
        };
    }
    // Slow-path
    var Q1div2 = (Q + _1n) / _2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE))
            throw new Error('Cannot find square root');
        var r = S;
        // TODO: will fail at Fp2/etc
        var g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        var x = Fp.pow(n, Q1div2); // first guess at the square root
        var b = Fp.pow(n, Q); // first guess at the fudge factor
        while (!Fp.eql(b, Fp.ONE)) {
            if (Fp.eql(b, Fp.ZERO))
                return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            var m = 1;
            for (var t2 = Fp.sqr(b); m < r; m++) {
                if (Fp.eql(t2, Fp.ONE))
                    break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            var ge = Fp.pow(g, _1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
exports.tonelliShanks = tonelliShanks;
function FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % _4n === _3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        var p1div4_2 = (P + _1n) / _4n;
        return function sqrt3mod4(Fp, n) {
            var root = Fp.pow(n, p1div4_2);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n))
                throw new Error('Cannot find square root');
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % _8n === _5n) {
        var c1_1 = (P - _5n) / _8n;
        return function sqrt5mod8(Fp, n) {
            var n2 = Fp.mul(n, _2n);
            var v = Fp.pow(n2, c1_1);
            var nv = Fp.mul(n, v);
            var i = Fp.mul(Fp.mul(nv, _2n), v);
            var root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n))
                throw new Error('Cannot find square root');
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    if (P % _16n === _9n) {
        // NOTE: tonelli is too slow for bls-Fp2 calculations even on start
        // Means we cannot use sqrt for constants at all!
        //
        // const c1 = Fp.sqrt(Fp.negate(Fp.ONE)); //  1. c1 = sqrt(-1) in F, i.e., (c1^2) == -1 in F
        // const c2 = Fp.sqrt(c1);                //  2. c2 = sqrt(c1) in F, i.e., (c2^2) == c1 in F
        // const c3 = Fp.sqrt(Fp.negate(c1));     //  3. c3 = sqrt(-c1) in F, i.e., (c3^2) == -c1 in F
        // const c4 = (P + _7n) / _16n;           //  4. c4 = (q + 7) / 16        # Integer arithmetic
        // sqrt = (x) => {
        //   let tv1 = Fp.pow(x, c4);             //  1. tv1 = x^c4
        //   let tv2 = Fp.mul(c1, tv1);           //  2. tv2 = c1 * tv1
        //   const tv3 = Fp.mul(c2, tv1);         //  3. tv3 = c2 * tv1
        //   let tv4 = Fp.mul(c3, tv1);           //  4. tv4 = c3 * tv1
        //   const e1 = Fp.equals(Fp.square(tv2), x); //  5.  e1 = (tv2^2) == x
        //   const e2 = Fp.equals(Fp.square(tv3), x); //  6.  e2 = (tv3^2) == x
        //   tv1 = Fp.cmov(tv1, tv2, e1); //  7. tv1 = CMOV(tv1, tv2, e1)  # Select tv2 if (tv2^2) == x
        //   tv2 = Fp.cmov(tv4, tv3, e2); //  8. tv2 = CMOV(tv4, tv3, e2)  # Select tv3 if (tv3^2) == x
        //   const e3 = Fp.equals(Fp.square(tv2), x); //  9.  e3 = (tv2^2) == x
        //   return Fp.cmov(tv1, tv2, e3); //  10.  z = CMOV(tv1, tv2, e3)  # Select the sqrt from tv1 and tv2
        // }
    }
    // Other cases: Tonelli-Shanks algorithm
    return tonelliShanks(P);
}
exports.FpSqrt = FpSqrt;
// Little-endian check for first LE bit (last BE bit);
var isNegativeLE = function (num, modulo) { return (mod(num, modulo) & _1n) === _1n; };
exports.isNegativeLE = isNegativeLE;
// prettier-ignore
var FIELD_FIELDS = [
    'create', 'isValid', 'is0', 'neg', 'inv', 'sqrt', 'sqr',
    'eql', 'add', 'sub', 'mul', 'pow', 'div',
    'addN', 'subN', 'mulN', 'sqrN'
];
function validateField(field) {
    var initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'isSafeInteger',
        BITS: 'isSafeInteger',
    };
    var opts = FIELD_FIELDS.reduce(function (map, val) {
        map[val] = 'function';
        return map;
    }, initial);
    return (0, utils_1.validateObject)(field, opts);
}
exports.validateField = validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */
function FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < _0n)
        throw new Error('Expected power > 0');
    if (power === _0n)
        return f.ONE;
    if (power === _1n)
        return num;
    var p = f.ONE;
    var d = num;
    while (power > _0n) {
        if (power & _1n)
            p = f.mul(p, d);
        d = f.sqr(d);
        power >>= _1n;
    }
    return p;
}
exports.FpPow = FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */
function FpInvertBatch(f, nums) {
    var tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    var lastMultiplied = nums.reduce(function (acc, num, i) {
        if (f.is0(num))
            return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    var inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight(function (acc, num, i) {
        if (f.is0(num))
            return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
exports.FpInvertBatch = FpInvertBatch;
function FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === 'bigint' ? invert(rhs, f.ORDER) : f.inv(rhs));
}
exports.FpDiv = FpDiv;
// This function returns True whenever the value x is a square in the field F.
function FpIsSquare(f) {
    var legendreConst = (f.ORDER - _1n) / _2n; // Integer arithmetic
    return function (x) {
        var p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
exports.FpIsSquare = FpIsSquare;
// CURVE.n lengths
function nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    var _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    var nByteLength = Math.ceil(_nBitLength / 8);
    return { nBitLength: _nBitLength, nByteLength: nByteLength };
}
exports.nLength = nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */
function Field(ORDER, bitLen, isLE, redef) {
    if (isLE === void 0) { isLE = false; }
    if (redef === void 0) { redef = {}; }
    if (ORDER <= _0n)
        throw new Error("Expected Field ORDER > 0, got ".concat(ORDER));
    var _a = nLength(ORDER, bitLen), BITS = _a.nBitLength, BYTES = _a.nByteLength;
    if (BYTES > 2048)
        throw new Error('Field lengths over 2048 bytes are not supported');
    var sqrtP = FpSqrt(ORDER);
    var f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, utils_1.bitMask)(BITS),
        ZERO: _0n,
        ONE: _1n,
        create: function (num) { return mod(num, ORDER); },
        isValid: function (num) {
            if (typeof num !== 'bigint')
                throw new Error("Invalid field element: expected bigint, got ".concat(typeof num));
            return _0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: function (num) { return num === _0n; },
        isOdd: function (num) { return (num & _1n) === _1n; },
        neg: function (num) { return mod(-num, ORDER); },
        eql: function (lhs, rhs) { return lhs === rhs; },
        sqr: function (num) { return mod(num * num, ORDER); },
        add: function (lhs, rhs) { return mod(lhs + rhs, ORDER); },
        sub: function (lhs, rhs) { return mod(lhs - rhs, ORDER); },
        mul: function (lhs, rhs) { return mod(lhs * rhs, ORDER); },
        pow: function (num, power) { return FpPow(f, num, power); },
        div: function (lhs, rhs) { return mod(lhs * invert(rhs, ORDER), ORDER); },
        // Same as above, but doesn't normalize
        sqrN: function (num) { return num * num; },
        addN: function (lhs, rhs) { return lhs + rhs; },
        subN: function (lhs, rhs) { return lhs - rhs; },
        mulN: function (lhs, rhs) { return lhs * rhs; },
        inv: function (num) { return invert(num, ORDER); },
        sqrt: redef.sqrt || (function (n) { return sqrtP(f, n); }),
        invertBatch: function (lst) { return FpInvertBatch(f, lst); },
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: function (a, b, c) { return (c ? b : a); },
        toBytes: function (num) { return (isLE ? (0, utils_1.numberToBytesLE)(num, BYTES) : (0, utils_1.numberToBytesBE)(num, BYTES)); },
        fromBytes: function (bytes) {
            if (bytes.length !== BYTES)
                throw new Error("Fp.fromBytes: expected ".concat(BYTES, ", got ").concat(bytes.length));
            return isLE ? (0, utils_1.bytesToNumberLE)(bytes) : (0, utils_1.bytesToNumberBE)(bytes);
        },
    });
    return Object.freeze(f);
}
exports.Field = Field;
function FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd)
        throw new Error("Field doesn't have isOdd");
    var root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
exports.FpSqrtOdd = FpSqrtOdd;
function FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd)
        throw new Error("Field doesn't have isOdd");
    var root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
exports.FpSqrtEven = FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */
function hashToPrivateScalar(hash, groupOrder, isLE) {
    if (isLE === void 0) { isLE = false; }
    hash = (0, utils_1.ensureBytes)('privateHash', hash);
    var hashLen = hash.length;
    var minLen = nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024)
        throw new Error("hashToPrivateScalar: expected ".concat(minLen, "-1024 bytes of input, got ").concat(hashLen));
    var num = isLE ? (0, utils_1.bytesToNumberLE)(hash) : (0, utils_1.bytesToNumberBE)(hash);
    return mod(num, groupOrder - _1n) + _1n;
}
exports.hashToPrivateScalar = hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */
function getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== 'bigint')
        throw new Error('field order must be bigint');
    var bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
exports.getFieldBytesLength = getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */
function getMinHashLength(fieldOrder) {
    var length = getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
exports.getMinHashLength = getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */
function mapHashToField(key, fieldOrder, isLE) {
    if (isLE === void 0) { isLE = false; }
    var len = key.length;
    var fieldLen = getFieldBytesLength(fieldOrder);
    var minLen = getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024)
        throw new Error("expected ".concat(minLen, "-1024 bytes of input, got ").concat(len));
    var num = isLE ? (0, utils_1.bytesToNumberBE)(key) : (0, utils_1.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    var reduced = mod(num, fieldOrder - _1n) + _1n;
    return isLE ? (0, utils_1.numberToBytesLE)(reduced, fieldLen) : (0, utils_1.numberToBytesBE)(reduced, fieldLen);
}
exports.mapHashToField = mapHashToField;


/***/ }),

/***/ 89632:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateObject = exports.createHmacDrbg = exports.bitMask = exports.bitSet = exports.bitGet = exports.bitLen = exports.utf8ToBytes = exports.equalBytes = exports.concatBytes = exports.ensureBytes = exports.numberToVarBytesBE = exports.numberToBytesLE = exports.numberToBytesBE = exports.bytesToNumberLE = exports.bytesToNumberBE = exports.hexToBytes = exports.hexToNumber = exports.numberToHexUnpadded = exports.bytesToHex = exports.abytes = exports.isBytes = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
var _0n = BigInt(0);
var _1n = BigInt(1);
var _2n = BigInt(2);
function isBytes(a) {
    return (a instanceof Uint8Array ||
        (a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array'));
}
exports.isBytes = isBytes;
function abytes(item) {
    if (!isBytes(item))
        throw new Error('Uint8Array expected');
}
exports.abytes = abytes;
// Array where index 0xf0 (240) is mapped to string 'f0'
var hexes = /* @__PURE__ */ Array.from({ length: 256 }, function (_, i) {
    return i.toString(16).padStart(2, '0');
});
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */
function bytesToHex(bytes) {
    abytes(bytes);
    // pre-caching improves the speed 6x
    var hex = '';
    for (var i = 0; i < bytes.length; i++) {
        hex += hexes[bytes[i]];
    }
    return hex;
}
exports.bytesToHex = bytesToHex;
function numberToHexUnpadded(num) {
    var hex = num.toString(16);
    return hex.length & 1 ? "0".concat(hex) : hex;
}
exports.numberToHexUnpadded = numberToHexUnpadded;
function hexToNumber(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    // Big Endian
    return BigInt(hex === '' ? '0' : "0x".concat(hex));
}
exports.hexToNumber = hexToNumber;
// We use optimized technique to convert hex string to byte array
var asciis = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9)
        return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F)
        return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f)
        return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */
function hexToBytes(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    var hl = hex.length;
    var al = hl / 2;
    if (hl % 2)
        throw new Error('padded hex string expected, got unpadded hex of length ' + hl);
    var array = new Uint8Array(al);
    for (var ai = 0, hi = 0; ai < al; ai++, hi += 2) {
        var n1 = asciiToBase16(hex.charCodeAt(hi));
        var n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            var char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// BE: Big Endian, LE: Little Endian
function bytesToNumberBE(bytes) {
    return hexToNumber(bytesToHex(bytes));
}
exports.bytesToNumberBE = bytesToNumberBE;
function bytesToNumberLE(bytes) {
    abytes(bytes);
    return hexToNumber(bytesToHex(Uint8Array.from(bytes).reverse()));
}
exports.bytesToNumberLE = bytesToNumberLE;
function numberToBytesBE(n, len) {
    return hexToBytes(n.toString(16).padStart(len * 2, '0'));
}
exports.numberToBytesBE = numberToBytesBE;
function numberToBytesLE(n, len) {
    return numberToBytesBE(n, len).reverse();
}
exports.numberToBytesLE = numberToBytesLE;
// Unpadded, rarely used
function numberToVarBytesBE(n) {
    return hexToBytes(numberToHexUnpadded(n));
}
exports.numberToVarBytesBE = numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */
function ensureBytes(title, hex, expectedLength) {
    var res;
    if (typeof hex === 'string') {
        try {
            res = hexToBytes(hex);
        }
        catch (e) {
            throw new Error("".concat(title, " must be valid hex string, got \"").concat(hex, "\". Cause: ").concat(e));
        }
    }
    else if (isBytes(hex)) {
        // Uint8Array.from() instead of hash.slice() because node Buffer
        // is instance of Uint8Array, and its slice() creates **mutable** copy
        res = Uint8Array.from(hex);
    }
    else {
        throw new Error("".concat(title, " must be hex string or Uint8Array"));
    }
    var len = res.length;
    if (typeof expectedLength === 'number' && len !== expectedLength)
        throw new Error("".concat(title, " expected ").concat(expectedLength, " bytes, got ").concat(len));
    return res;
}
exports.ensureBytes = ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */
function concatBytes() {
    var arrays = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arrays[_i] = arguments[_i];
    }
    var sum = 0;
    for (var i = 0; i < arrays.length; i++) {
        var a = arrays[i];
        abytes(a);
        sum += a.length;
    }
    var res = new Uint8Array(sum);
    for (var i = 0, pad = 0; i < arrays.length; i++) {
        var a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
exports.concatBytes = concatBytes;
// Compares 2 u8a-s in kinda constant time
function equalBytes(a, b) {
    if (a.length !== b.length)
        return false;
    var diff = 0;
    for (var i = 0; i < a.length; i++)
        diff |= a[i] ^ b[i];
    return diff === 0;
}
exports.equalBytes = equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */
function utf8ToBytes(str) {
    if (typeof str !== 'string')
        throw new Error("utf8ToBytes expected string, got ".concat(typeof str));
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
exports.utf8ToBytes = utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */
function bitLen(n) {
    var len;
    for (len = 0; n > _0n; n >>= _1n, len += 1)
        ;
    return len;
}
exports.bitLen = bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */
function bitGet(n, pos) {
    return (n >> BigInt(pos)) & _1n;
}
exports.bitGet = bitGet;
/**
 * Sets single bit at position.
 */
function bitSet(n, pos, value) {
    return n | ((value ? _1n : _0n) << BigInt(pos));
}
exports.bitSet = bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */
var bitMask = function (n) { return (_2n << BigInt(n - 1)) - _1n; };
exports.bitMask = bitMask;
// DRBG
var u8n = function (data) { return new Uint8Array(data); }; // creates Uint8Array
var u8fr = function (arr) { return Uint8Array.from(arr); }; // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */
function createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2)
        throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2)
        throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function')
        throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    var v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    var k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    var i = 0; // Iterations counter, will throw when over 1000
    var reset = function () {
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    var h = function () {
        var b = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            b[_i] = arguments[_i];
        }
        return hmacFn.apply(void 0, __spreadArray([k, v], __read(b), false));
    }; // hmac(k)(v, ...values)
    var reseed = function (seed) {
        if (seed === void 0) { seed = u8n(); }
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8fr([0x00]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0)
            return;
        k = h(u8fr([0x01]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    var gen = function () {
        // HMAC-DRBG generate() function
        if (i++ >= 1000)
            throw new Error('drbg: tried 1000 values');
        var len = 0;
        var out = [];
        while (len < qByteLen) {
            v = h();
            var sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return concatBytes.apply(void 0, __spreadArray([], __read(out), false));
    };
    var genUntil = function (seed, pred) {
        reset();
        reseed(seed); // Steps D-G
        var res = undefined; // Step H: grind until k is in [1..n-1]
        while (!(res = pred(gen())))
            reseed();
        reset();
        return res;
    };
    return genUntil;
}
exports.createHmacDrbg = createHmacDrbg;
// Validating curves and fields
var validatorFns = {
    bigint: function (val) { return typeof val === 'bigint'; },
    function: function (val) { return typeof val === 'function'; },
    boolean: function (val) { return typeof val === 'boolean'; },
    string: function (val) { return typeof val === 'string'; },
    stringOrUint8Array: function (val) { return typeof val === 'string' || isBytes(val); },
    isSafeInteger: function (val) { return Number.isSafeInteger(val); },
    array: function (val) { return Array.isArray(val); },
    field: function (val, object) { return object.Fp.isValid(val); },
    hash: function (val) { return typeof val === 'function' && Number.isSafeInteger(val.outputLen); },
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function validateObject(object, validators, optValidators) {
    var e_1, _b, e_2, _c;
    if (optValidators === void 0) { optValidators = {}; }
    var checkField = function (fieldName, type, isOptional) {
        var checkVal = validatorFns[type];
        if (typeof checkVal !== 'function')
            throw new Error("Invalid validator \"".concat(type, "\", expected function"));
        var val = object[fieldName];
        if (isOptional && val === undefined)
            return;
        if (!checkVal(val, object)) {
            throw new Error("Invalid param ".concat(String(fieldName), "=").concat(val, " (").concat(typeof val, "), expected ").concat(type));
        }
    };
    try {
        for (var _d = __values(Object.entries(validators)), _e = _d.next(); !_e.done; _e = _d.next()) {
            var _g = __read(_e.value, 2), fieldName = _g[0], type = _g[1];
            checkField(fieldName, type, false);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var _h = __values(Object.entries(optValidators)), _j = _h.next(); !_j.done; _j = _h.next()) {
            var _k = __read(_j.value, 2), fieldName = _k[0], type = _k[1];
            checkField(fieldName, type, true);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return object;
}
exports.validateObject = validateObject;
// validate type tests
// const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
// const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
// // Should fail type-check
// const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
// const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
// const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
// const z4 = validateObject(o, { a: 'boolean', z: 'bug' });


/***/ }),

/***/ 76326:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/abstract/weierstrass.ts

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfigon`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapToCurveSimpleSWU = exports.SWUFpSqrtRatio = exports.weierstrass = exports.weierstrassPoints = exports.DER = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// Short Weierstrass curve. The formula is: y² = x³ + ax + b
var mod = __importStar(__webpack_require__(99764));
var ut = __importStar(__webpack_require__(92035));
var utils_1 = __webpack_require__(92035);
var curve_1 = __webpack_require__(14939);
var curve_2 = __webpack_require__(72213);
function validatePointOpts(curve) {
    var opts = (0, curve_1.validateBasic)(curve);
    ut.validateObject(opts, {
        a: 'field',
        b: 'field',
    }, {
        allowedPrivateKeyLengths: 'array',
        wrapPrivateKey: 'boolean',
        isTorsionFree: 'function',
        clearCofactor: 'function',
        allowInfinityPoint: 'boolean',
        fromBytes: 'function',
        toBytes: 'function',
    });
    var endo = opts.endo, Fp = opts.Fp, a = opts.a;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) {
            throw new Error('Endomorphism can only be defined for Koblitz curves that have a=0');
        }
        if (typeof endo !== 'object' ||
            typeof endo.beta !== 'bigint' ||
            typeof endo.splitScalar !== 'function') {
            throw new Error('Expected endomorphism with beta: bigint and splitScalar: function');
        }
    }
    return Object.freeze(__assign({}, opts));
}
// ASN.1 DER encoding utilities
var b2n = ut.bytesToNumberBE, h2b = ut.hexToBytes;
exports.DER = {
    // asn.1 DER encoding utils
    Err: /** @class */ (function (_super) {
        __extends(DERErr, _super);
        function DERErr(m) {
            if (m === void 0) { m = ''; }
            return _super.call(this, m) || this;
        }
        return DERErr;
    }(Error)),
    _parseInt: function (data) {
        var E = exports.DER.Err;
        if (data.length < 2 || data[0] !== 0x02)
            throw new E('Invalid signature integer tag');
        var len = data[1];
        var res = data.subarray(2, len + 2);
        if (!len || res.length !== len)
            throw new E('Invalid signature integer: wrong length');
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128)
            throw new E('Invalid signature integer: negative');
        if (res[0] === 0x00 && !(res[1] & 128))
            throw new E('Invalid signature integer: unnecessary leading zero');
        return { d: b2n(res), l: data.subarray(len + 2) }; // d is data, l is left
    },
    toSig: function (hex) {
        // parse DER signature
        var E = exports.DER.Err;
        var data = typeof hex === 'string' ? h2b(hex) : hex;
        ut.abytes(data);
        var l = data.length;
        if (l < 2 || data[0] != 0x30)
            throw new E('Invalid signature tag');
        if (data[1] !== l - 2)
            throw new E('Invalid signature: incorrect length');
        var _a = exports.DER._parseInt(data.subarray(2)), r = _a.d, sBytes = _a.l;
        var _b = exports.DER._parseInt(sBytes), s = _b.d, rBytesLeft = _b.l;
        if (rBytesLeft.length)
            throw new E('Invalid signature: left bytes after parsing');
        return { r: r, s: s };
    },
    hexFromSig: function (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        var slice = function (s) { return (Number.parseInt(s[0], 16) & 8 ? '00' + s : s); };
        var h = function (num) {
            var hex = num.toString(16);
            return hex.length & 1 ? "0".concat(hex) : hex;
        };
        var s = slice(h(sig.s));
        var r = slice(h(sig.r));
        var shl = s.length / 2;
        var rhl = r.length / 2;
        var sl = h(shl);
        var rl = h(rhl);
        return "30".concat(h(rhl + shl + 4), "02").concat(rl).concat(r, "02").concat(sl).concat(s);
    },
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
var _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3), _4n = BigInt(4);
function weierstrassPoints(opts) {
    var CURVE = validatePointOpts(opts);
    var Fp = CURVE.Fp; // All curves has same field / group length as for now, but they can differ
    var toBytes = CURVE.toBytes ||
        (function (_c, point, _isCompressed) {
            var a = point.toAffine();
            return ut.concatBytes(Uint8Array.from([0x04]), Fp.toBytes(a.x), Fp.toBytes(a.y));
        });
    var fromBytes = CURVE.fromBytes ||
        (function (bytes) {
            // const head = bytes[0];
            var tail = bytes.subarray(1);
            // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
            var x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
            var y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
            return { x: x, y: y };
        });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */
    function weierstrassEquation(x) {
        var a = CURVE.a, b = CURVE.b;
        var x2 = Fp.sqr(x); // x * x
        var x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx)))
        throw new Error('bad generator point: equation left != right');
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === 'bigint' && _0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num))
            throw new Error('Expected valid bigint: 0 < bigint < curve.n');
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        var lengths = CURVE.allowedPrivateKeyLengths, nByteLength = CURVE.nByteLength, wrapPrivateKey = CURVE.wrapPrivateKey, n = CURVE.n;
        if (lengths && typeof key !== 'bigint') {
            if (ut.isBytes(key))
                key = ut.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== 'string' || !lengths.includes(key.length))
                throw new Error('Invalid key');
            key = key.padStart(nByteLength * 2, '0');
        }
        var num;
        try {
            num =
                typeof key === 'bigint'
                    ? key
                    : ut.bytesToNumberBE((0, utils_1.ensureBytes)('private key', key, nByteLength));
        }
        catch (error) {
            throw new Error("private key must be ".concat(nByteLength, " bytes, hex or bigint, not ").concat(typeof key));
        }
        if (wrapPrivateKey)
            num = mod.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    var pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point))
            throw new Error('ProjectivePoint expected');
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */
    var Point = /** @class */ (function () {
        function Point(px, py, pz) {
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px))
                throw new Error('x required');
            if (py == null || !Fp.isValid(py))
                throw new Error('y required');
            if (pz == null || !Fp.isValid(pz))
                throw new Error('z required');
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        Point.fromAffine = function (p) {
            var _a = p || {}, x = _a.x, y = _a.y;
            if (!p || !Fp.isValid(x) || !Fp.isValid(y))
                throw new Error('invalid affine point');
            if (p instanceof Point)
                throw new Error('projective point not allowed');
            var is0 = function (i) { return Fp.eql(i, Fp.ZERO); };
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y))
                return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        };
        Object.defineProperty(Point.prototype, "x", {
            get: function () {
                return this.toAffine().x;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Point.prototype, "y", {
            get: function () {
                return this.toAffine().y;
            },
            enumerable: false,
            configurable: true
        });
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */
        Point.normalizeZ = function (points) {
            var toInv = Fp.invertBatch(points.map(function (p) { return p.pz; }));
            return points.map(function (p, i) { return p.toAffine(toInv[i]); }).map(Point.fromAffine);
        };
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */
        Point.fromHex = function (hex) {
            var P = Point.fromAffine(fromBytes((0, utils_1.ensureBytes)('pointHex', hex)));
            P.assertValidity();
            return P;
        };
        // Multiplies generator point by privateKey.
        Point.fromPrivateKey = function (privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        };
        // "Private method", don't use it directly
        Point.prototype._setWindowSize = function (windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        };
        // A point on curve is valid if it conforms to equation.
        Point.prototype.assertValidity = function () {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py))
                    return;
                throw new Error('bad point: ZERO');
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            var _a = this.toAffine(), x = _a.x, y = _a.y;
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y))
                throw new Error('bad point: x or y not FE');
            var left = Fp.sqr(y); // y²
            var right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right))
                throw new Error('bad point: equation left != right');
            if (!this.isTorsionFree())
                throw new Error('bad point: not in prime-order subgroup');
        };
        Point.prototype.hasEvenY = function () {
            var y = this.toAffine().y;
            if (Fp.isOdd)
                return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        };
        /**
         * Compare one point to another.
         */
        Point.prototype.equals = function (other) {
            assertPrjPoint(other);
            var _a = this, X1 = _a.px, Y1 = _a.py, Z1 = _a.pz;
            var X2 = other.px, Y2 = other.py, Z2 = other.pz;
            var U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            var U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        };
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */
        Point.prototype.negate = function () {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        };
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        Point.prototype.double = function () {
            var a = CURVE.a, b = CURVE.b;
            var b3 = Fp.mul(b, _3n);
            var _a = this, X1 = _a.px, Y1 = _a.py, Z1 = _a.pz;
            var X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            var t0 = Fp.mul(X1, X1); // step 1
            var t1 = Fp.mul(Y1, Y1);
            var t2 = Fp.mul(Z1, Z1);
            var t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        };
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        Point.prototype.add = function (other) {
            assertPrjPoint(other);
            var _a = this, X1 = _a.px, Y1 = _a.py, Z1 = _a.pz;
            var X2 = other.px, Y2 = other.py, Z2 = other.pz;
            var X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            var a = CURVE.a;
            var b3 = Fp.mul(CURVE.b, _3n);
            var t0 = Fp.mul(X1, X2); // step 1
            var t1 = Fp.mul(Y1, Y2);
            var t2 = Fp.mul(Z1, Z2);
            var t3 = Fp.add(X1, Y1);
            var t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            var t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        };
        Point.prototype.subtract = function (other) {
            return this.add(other.negate());
        };
        Point.prototype.is0 = function () {
            return this.equals(Point.ZERO);
        };
        Point.prototype.wNAF = function (n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, function (comp) {
                var toInv = Fp.invertBatch(comp.map(function (p) { return p.pz; }));
                return comp.map(function (p, i) { return p.toAffine(toInv[i]); }).map(Point.fromAffine);
            });
        };
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */
        Point.prototype.multiplyUnsafe = function (n) {
            var I = Point.ZERO;
            if (n === _0n)
                return I;
            assertGE(n); // Will throw on 0
            if (n === _1n)
                return this;
            var endo = CURVE.endo;
            if (!endo)
                return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            var _a = endo.splitScalar(n), k1neg = _a.k1neg, k1 = _a.k1, k2neg = _a.k2neg, k2 = _a.k2;
            var k1p = I;
            var k2p = I;
            var d = this;
            while (k1 > _0n || k2 > _0n) {
                if (k1 & _1n)
                    k1p = k1p.add(d);
                if (k2 & _1n)
                    k2p = k2p.add(d);
                d = d.double();
                k1 >>= _1n;
                k2 >>= _1n;
            }
            if (k1neg)
                k1p = k1p.negate();
            if (k2neg)
                k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        };
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */
        Point.prototype.multiply = function (scalar) {
            assertGE(scalar);
            var n = BigInt(scalar);
            var point, fake; // Fake point is used to const-time mult
            var endo = CURVE.endo;
            if (endo) {
                var _a = endo.splitScalar(n), k1neg = _a.k1neg, k1 = _a.k1, k2neg = _a.k2neg, k2 = _a.k2;
                var _b = this.wNAF(k1), k1p = _b.p, f1p = _b.f;
                var _d = this.wNAF(k2), k2p = _d.p, f2p = _d.f;
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            }
            else {
                var _e = this.wNAF(n), p = _e.p, f = _e.f;
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([point, fake])[0];
        };
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */
        Point.prototype.multiplyAndAddUnsafe = function (Q, a, b) {
            var G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            var mul = function (P, a // Select faster multiply() method
            ) { return (a === _0n || a === _1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a)); };
            var sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        };
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        Point.prototype.toAffine = function (iz) {
            var _a = this, x = _a.px, y = _a.py, z = _a.pz;
            var is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null)
                iz = is0 ? Fp.ONE : Fp.inv(z);
            var ax = Fp.mul(x, iz);
            var ay = Fp.mul(y, iz);
            var zz = Fp.mul(z, iz);
            if (is0)
                return { x: Fp.ZERO, y: Fp.ZERO };
            if (!Fp.eql(zz, Fp.ONE))
                throw new Error('invZ was invalid');
            return { x: ax, y: ay };
        };
        Point.prototype.isTorsionFree = function () {
            var cofactor = CURVE.h, isTorsionFree = CURVE.isTorsionFree;
            if (cofactor === _1n)
                return true; // No subgroups, always torsion-free
            if (isTorsionFree)
                return isTorsionFree(Point, this);
            throw new Error('isTorsionFree() has not been declared for the elliptic curve');
        };
        Point.prototype.clearCofactor = function () {
            var cofactor = CURVE.h, clearCofactor = CURVE.clearCofactor;
            if (cofactor === _1n)
                return this; // Fast-path
            if (clearCofactor)
                return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        };
        Point.prototype.toRawBytes = function (isCompressed) {
            if (isCompressed === void 0) { isCompressed = true; }
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        };
        Point.prototype.toHex = function (isCompressed) {
            if (isCompressed === void 0) { isCompressed = true; }
            return ut.bytesToHex(this.toRawBytes(isCompressed));
        };
        Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
        Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
        return Point;
    }());
    var _bits = CURVE.nBitLength;
    var wnaf = (0, curve_2.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder,
    };
}
exports.weierstrassPoints = weierstrassPoints;
function validateOpts(curve) {
    var opts = (0, curve_1.validateBasic)(curve);
    ut.validateObject(opts, {
        hash: 'hash',
        hmac: 'function',
        randomBytes: 'function',
    }, {
        bits2int: 'function',
        bits2int_modN: 'function',
        lowS: 'boolean',
    });
    return Object.freeze(__assign({ lowS: true }, opts));
}
function weierstrass(curveDef) {
    var CURVE = validateOpts(curveDef);
    var Fp = CURVE.Fp, CURVE_ORDER = CURVE.n;
    var compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    var uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return _0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return mod.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return mod.invert(a, CURVE_ORDER);
    }
    var _a = weierstrassPoints(__assign(__assign({}, CURVE), { toBytes: function (_c, point, isCompressed) {
            var a = point.toAffine();
            var x = Fp.toBytes(a.x);
            var cat = ut.concatBytes;
            if (isCompressed) {
                return cat(Uint8Array.from([point.hasEvenY() ? 0x02 : 0x03]), x);
            }
            else {
                return cat(Uint8Array.from([0x04]), x, Fp.toBytes(a.y));
            }
        }, fromBytes: function (bytes) {
            var len = bytes.length;
            var head = bytes[0];
            var tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                var x = ut.bytesToNumberBE(tail);
                if (!isValidFieldElement(x))
                    throw new Error('Point is not on curve');
                var y2 = weierstrassEquation(x); // y² = x³ + ax + b
                var y = void 0;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                }
                catch (sqrtError) {
                    var suffix = sqrtError instanceof Error ? ': ' + sqrtError.message : '';
                    throw new Error('Point is not on curve' + suffix);
                }
                var isYOdd = (y & _1n) === _1n;
                // ECDSA
                var isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd)
                    y = Fp.neg(y);
                return { x: x, y: y };
            }
            else if (len === uncompressedLen && head === 0x04) {
                var x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                var y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return { x: x, y: y };
            }
            else {
                throw new Error("Point of length ".concat(len, " was invalid. Expected ").concat(compressedLen, " compressed bytes or ").concat(uncompressedLen, " uncompressed bytes"));
            }
        } })), Point = _a.ProjectivePoint, normPrivateKeyToScalar = _a.normPrivateKeyToScalar, weierstrassEquation = _a.weierstrassEquation, isWithinCurveOrder = _a.isWithinCurveOrder;
    var numToNByteStr = function (num) {
        return ut.bytesToHex(ut.numberToBytesBE(num, CURVE.nByteLength));
    };
    function isBiggerThanHalfOrder(number) {
        var HALF = CURVE_ORDER >> _1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    var slcNum = function (b, from, to) { return ut.bytesToNumberBE(b.slice(from, to)); };
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */
    var Signature = /** @class */ (function () {
        function Signature(r, s, recovery) {
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        Signature.fromCompact = function (hex) {
            var l = CURVE.nByteLength;
            hex = (0, utils_1.ensureBytes)('compactSignature', hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        };
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        Signature.fromDER = function (hex) {
            var _a = exports.DER.toSig((0, utils_1.ensureBytes)('DER', hex)), r = _a.r, s = _a.s;
            return new Signature(r, s);
        };
        Signature.prototype.assertValidity = function () {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r))
                throw new Error('r must be 0 < r < CURVE.n');
            if (!isWithinCurveOrder(this.s))
                throw new Error('s must be 0 < s < CURVE.n');
        };
        Signature.prototype.addRecoveryBit = function (recovery) {
            return new Signature(this.r, this.s, recovery);
        };
        Signature.prototype.recoverPublicKey = function (msgHash) {
            var _a = this, r = _a.r, s = _a.s, rec = _a.recovery;
            var h = bits2int_modN((0, utils_1.ensureBytes)('msgHash', msgHash)); // Truncate hash
            if (rec == null || ![0, 1, 2, 3].includes(rec))
                throw new Error('recovery id invalid');
            var radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER)
                throw new Error('recovery id 2 or 3 invalid');
            var prefix = (rec & 1) === 0 ? '02' : '03';
            var R = Point.fromHex(prefix + numToNByteStr(radj));
            var ir = invN(radj); // r^-1
            var u1 = modN(-h * ir); // -hr^-1
            var u2 = modN(s * ir); // sr^-1
            var Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q)
                throw new Error('point at infinify'); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        };
        // Signatures should be low-s, to prevent malleability.
        Signature.prototype.hasHighS = function () {
            return isBiggerThanHalfOrder(this.s);
        };
        Signature.prototype.normalizeS = function () {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        };
        // DER-encoded
        Signature.prototype.toDERRawBytes = function () {
            return ut.hexToBytes(this.toDERHex());
        };
        Signature.prototype.toDERHex = function () {
            return exports.DER.hexFromSig({ r: this.r, s: this.s });
        };
        // padded bytes of r, then padded bytes of s
        Signature.prototype.toCompactRawBytes = function () {
            return ut.hexToBytes(this.toCompactHex());
        };
        Signature.prototype.toCompactHex = function () {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        };
        return Signature;
    }());
    var utils = {
        isValidPrivateKey: function (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            }
            catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */
        randomPrivateKey: function () {
            var length = mod.getMinHashLength(CURVE.n);
            return mod.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */
        precompute: function (windowSize, point) {
            if (windowSize === void 0) { windowSize = 8; }
            if (point === void 0) { point = Point.BASE; }
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        },
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */
    function getPublicKey(privateKey, isCompressed) {
        if (isCompressed === void 0) { isCompressed = true; }
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */
    function isProbPub(item) {
        var arr = ut.isBytes(item);
        var str = typeof item === 'string';
        var len = (arr || str) && item.length;
        if (arr)
            return len === compressedLen || len === uncompressedLen;
        if (str)
            return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point)
            return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */
    function getSharedSecret(privateA, publicB, isCompressed) {
        if (isCompressed === void 0) { isCompressed = true; }
        if (isProbPub(privateA))
            throw new Error('first arg must be private key');
        if (!isProbPub(publicB))
            throw new Error('second arg must be public key');
        var b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    var bits2int = CURVE.bits2int ||
        function (bytes) {
            // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
            // for some cases, since bytes.length * 8 is not actual bitLength.
            var num = ut.bytesToNumberBE(bytes); // check for == u8 done here
            var delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
            return delta > 0 ? num >> BigInt(delta) : num;
        };
    var bits2int_modN = CURVE.bits2int_modN ||
        function (bytes) {
            return modN(bits2int(bytes)); // can't use bytesToNumberBE here
        };
    // NOTE: pads output with zero as per spec
    var ORDER_MASK = ut.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */
    function int2octets(num) {
        if (typeof num !== 'bigint')
            throw new Error('bigint expected');
        if (!(_0n <= num && num < ORDER_MASK))
            throw new Error("bigint expected < 2^".concat(CURVE.nBitLength));
        // works with order, can have different size than numToField!
        return ut.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts) {
        if (opts === void 0) { opts = defaultSigOpts; }
        if (['recovered', 'canonical'].some(function (k) { return k in opts; }))
            throw new Error('sign() legacy options not supported');
        var hash = CURVE.hash, randomBytes = CURVE.randomBytes;
        var lowS = opts.lowS, prehash = opts.prehash, ent = opts.extraEntropy; // generates low-s sigs by default
        if (lowS == null)
            lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, utils_1.ensureBytes)('msgHash', msgHash);
        if (prehash)
            msgHash = (0, utils_1.ensureBytes)('prehashed msgHash', hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        var h1int = bits2int_modN(msgHash);
        var d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        var seedArgs = [int2octets(d), int2octets(h1int)];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            var e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, utils_1.ensureBytes)('extraEntropy', e)); // check for being bytes
        }
        var seed = ut.concatBytes.apply(ut, __spreadArray([], __read(seedArgs), false)); // Step D of RFC6979 3.2
        var m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            var k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k))
                return; // Important: all mod() calls here must be done over N
            var ik = invN(k); // k^-1 mod n
            var q = Point.BASE.multiply(k).toAffine(); // q = Gk
            var r = modN(q.x); // r = q.x mod n
            if (r === _0n)
                return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            var s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === _0n)
                return;
            var recovery = (q.x === r ? 0 : 2) | Number(q.y & _1n); // recovery bit (2 or 3, when q.x > n)
            var normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return { seed: seed, k2sig: k2sig };
    }
    var defaultSigOpts = { lowS: CURVE.lowS, prehash: false };
    var defaultVerOpts = { lowS: CURVE.lowS, prehash: false };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */
    function sign(msgHash, privKey, opts) {
        if (opts === void 0) { opts = defaultSigOpts; }
        var _a = prepSig(msgHash, privKey, opts), seed = _a.seed, k2sig = _a.k2sig; // Steps A, D of RFC6979 3.2.
        var C = CURVE;
        var drbg = ut.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */
    function verify(signature, msgHash, publicKey, opts) {
        var _a;
        if (opts === void 0) { opts = defaultVerOpts; }
        var sg = signature;
        msgHash = (0, utils_1.ensureBytes)('msgHash', msgHash);
        publicKey = (0, utils_1.ensureBytes)('publicKey', publicKey);
        if ('strict' in opts)
            throw new Error('options.strict was renamed to lowS');
        var lowS = opts.lowS, prehash = opts.prehash;
        var _sig = undefined;
        var P;
        try {
            if (typeof sg === 'string' || ut.isBytes(sg)) {
                // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
                // Since DER can also be 2*nByteLength bytes, we check for it first.
                try {
                    _sig = Signature.fromDER(sg);
                }
                catch (derError) {
                    if (!(derError instanceof exports.DER.Err))
                        throw derError;
                    _sig = Signature.fromCompact(sg);
                }
            }
            else if (typeof sg === 'object' && typeof sg.r === 'bigint' && typeof sg.s === 'bigint') {
                var r_1 = sg.r, s_1 = sg.s;
                _sig = new Signature(r_1, s_1);
            }
            else {
                throw new Error('PARSE');
            }
            P = Point.fromHex(publicKey);
        }
        catch (error) {
            if (error.message === 'PARSE')
                throw new Error("signature must be Signature instance, Uint8Array or hex string");
            return false;
        }
        if (lowS && _sig.hasHighS())
            return false;
        if (prehash)
            msgHash = CURVE.hash(msgHash);
        var r = _sig.r, s = _sig.s;
        var h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        var is = invN(s); // s^-1
        var u1 = modN(h * is); // u1 = hs^-1 mod n
        var u2 = modN(r * is); // u2 = rs^-1 mod n
        var R = (_a = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)) === null || _a === void 0 ? void 0 : _a.toAffine(); // R = u1⋅G + u2⋅P
        if (!R)
            return false;
        var v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils,
    };
}
exports.weierstrass = weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */
function SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    var q = Fp.ORDER;
    var l = _0n;
    for (var o = q - _1n; o % _2n === _0n; o /= _2n)
        l += _1n;
    var c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    var _2n_pow_c1_1 = _2n << (c1 - _1n - _1n);
    var _2n_pow_c1 = _2n_pow_c1_1 * _2n;
    var c2 = (q - _1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    var c3 = (c2 - _1n) / _2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    var c4 = _2n_pow_c1 - _1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    var c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    var c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    var c7 = Fp.pow(Z, (c2 + _1n) / _2n); // 7. c7 = Z^((c2 + 1) / 2)
    var sqrtRatio = function (u, v) {
        var tv1 = c6; // 1. tv1 = c6
        var tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        var tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        var tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        var tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        var isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for (var i = c1; i > _1n; i--) {
            var tv5_1 = i - _2n; // 18.    tv5 = i - 2
            tv5_1 = _2n << (tv5_1 - _1n); // 19.    tv5 = 2^tv5
            var tvv5 = Fp.pow(tv4, tv5_1); // 20.    tv5 = tv4^tv5
            var e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return { isValid: isQR, value: tv3 };
    };
    if (Fp.ORDER % _4n === _3n) {
        // sqrt_ratio_3mod4(u, v)
        var c1_1 = (Fp.ORDER - _3n) / _4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        var c2_1 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = function (u, v) {
            var tv1 = Fp.sqr(v); // 1. tv1 = v^2
            var tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            var y1 = Fp.pow(tv1, c1_1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            var y2 = Fp.mul(y1, c2_1); // 6. y2 = y1 * c2
            var tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            var isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            var y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return { isValid: isQR, value: y }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
exports.SWUFpSqrtRatio = SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */
function mapToCurveSimpleSWU(Fp, opts) {
    mod.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z))
        throw new Error('mapToCurveSimpleSWU: invalid opts');
    var sqrtRatio = SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd)
        throw new Error('Fp.isOdd is not implemented!');
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return function (u) {
        // prettier-ignore
        var tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        var _a = sqrtRatio(tv2, tv6), isValid = _a.isValid, value = _a.value; // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        var e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return { x: x, y: y };
    };
}
exports.mapToCurveSimpleSWU = mapToCurveSimpleSWU;


/***/ }),

/***/ 59709:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hmac = exports.HMAC = void 0;
var _assert_1 = __webpack_require__(2098);
var utils_1 = __webpack_require__(74599);
// HMAC (RFC 2104)
var HMAC = /** @class */ (function (_super) {
    __extends(HMAC, _super);
    function HMAC(hash, _key) {
        var _this = _super.call(this) || this;
        _this.finished = false;
        _this.destroyed = false;
        (0, _assert_1.hash)(hash);
        var key = (0, utils_1.toBytes)(_key);
        _this.iHash = hash.create();
        if (typeof _this.iHash.update !== 'function')
            throw new Error('Expected instance of class which extends utils.Hash');
        _this.blockLen = _this.iHash.blockLen;
        _this.outputLen = _this.iHash.outputLen;
        var blockLen = _this.blockLen;
        var pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for (var i = 0; i < pad.length; i++)
            pad[i] ^= 0x36;
        _this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        _this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for (var i = 0; i < pad.length; i++)
            pad[i] ^= 0x36 ^ 0x5c;
        _this.oHash.update(pad);
        pad.fill(0);
        return _this;
    }
    HMAC.prototype.update = function (buf) {
        (0, _assert_1.exists)(this);
        this.iHash.update(buf);
        return this;
    };
    HMAC.prototype.digestInto = function (out) {
        (0, _assert_1.exists)(this);
        (0, _assert_1.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    };
    HMAC.prototype.digest = function () {
        var out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    };
    HMAC.prototype._cloneInto = function (to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        var _a = this, oHash = _a.oHash, iHash = _a.iHash, finished = _a.finished, destroyed = _a.destroyed, blockLen = _a.blockLen, outputLen = _a.outputLen;
        to = to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    };
    HMAC.prototype.destroy = function () {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    };
    return HMAC;
}(utils_1.Hash));
exports.HMAC = HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */
var hmac = function (hash, key, message) {
    return new HMAC(hash, key).update(message).digest();
};
exports.hmac = hmac;
exports.hmac.create = function (hash, key) { return new HMAC(hash, key); };


/***/ }),

/***/ 59954:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(73117), exports);
__exportStar(__webpack_require__(75387), exports);
// DO NOT export "./_u64";
// DO NOT export "./utils";


/***/ }),

/***/ 73117:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.keccak_512 = exports.keccak_384 = exports.keccak_256 = exports.keccak_224 = exports.Keccak = exports.keccakP = void 0;
/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-hashes/blob/6ae82e75d4c354d53a488e95b1bfe9cba90bd6ff/src/sha3.ts#L1

it was modified and adapted to this repository to re-use already defined stuff

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var _u64_1 = __webpack_require__(90310);
var utils_1 = __webpack_require__(74599);
var assert_1 = __webpack_require__(97610);
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
var SHA3_PI = [];
var SHA3_ROTL = [];
var _SHA3_IOTA = [];
var _0n = /** @__PURE__ */ BigInt(0);
var _1n = /** @__PURE__ */ BigInt(1);
var _2n = /** @__PURE__ */ BigInt(2);
var _7n = /** @__PURE__ */ BigInt(7);
var _256n = /** @__PURE__ */ BigInt(256);
var _0x71n = /** @__PURE__ */ BigInt(0x71);
for (var round = 0, R = _1n, x = 1, y = 0; round < 24; round++) {
    // Pi
    _a = __read([y, (2 * x + 3 * y) % 5], 2), x = _a[0], y = _a[1];
    SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    SHA3_ROTL.push((((round + 1) * (round + 2)) / 2) % 64);
    // Iota
    var t = _0n;
    for (var j = 0; j < 7; j++) {
        R = ((R << _1n) ^ ((R >> _7n) * _0x71n)) % _256n;
        if (R & _2n)
            t ^= _1n << ((_1n << /** @__PURE__ */ BigInt(j)) - _1n);
    }
    _SHA3_IOTA.push(t);
}
var _b = __read(/** @__PURE__ */ (0, _u64_1.split)(_SHA3_IOTA, true), 2), SHA3_IOTA_H = _b[0], SHA3_IOTA_L = _b[1];
// Left rotation (without 0, 32, 64)
var rotlH = function (h, l, s) { return (s > 32 ? (0, _u64_1.rotlBH)(h, l, s) : (0, _u64_1.rotlSH)(h, l, s)); };
var rotlL = function (h, l, s) { return (s > 32 ? (0, _u64_1.rotlBL)(h, l, s) : (0, _u64_1.rotlSL)(h, l, s)); };
// Same as keccakf1600, but allows to skip some rounds
function keccakP(s, rounds) {
    if (rounds === void 0) { rounds = 24; }
    var B = new Uint32Array(5 * 2);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for (var round = 24 - rounds; round < 24; round++) {
        // Theta θ
        for (var x = 0; x < 10; x++)
            B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for (var x = 0; x < 10; x += 2) {
            var idx1 = (x + 8) % 10;
            var idx0 = (x + 2) % 10;
            var B0 = B[idx0];
            var B1 = B[idx0 + 1];
            var Th = rotlH(B0, B1, 1) ^ B[idx1];
            var Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for (var y = 0; y < 50; y += 10) {
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        var curH = s[2];
        var curL = s[3];
        for (var t = 0; t < 24; t++) {
            var shift = SHA3_ROTL[t];
            var Th = rotlH(curH, curL, shift);
            var Tl = rotlL(curH, curL, shift);
            var PI = SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for (var y = 0; y < 50; y += 10) {
            for (var x = 0; x < 10; x++)
                B[x] = s[y + x];
            for (var x = 0; x < 10; x++)
                s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= SHA3_IOTA_H[round];
        s[1] ^= SHA3_IOTA_L[round];
    }
    B.fill(0);
}
exports.keccakP = keccakP;
var Keccak = /** @class */ (function (_super) {
    __extends(Keccak, _super);
    // NOTE: we accept arguments in bytes instead of bits here.
    function Keccak(blockLen, suffix, outputLen, enableXOF, rounds) {
        if (enableXOF === void 0) { enableXOF = false; }
        if (rounds === void 0) { rounds = 24; }
        var _this = _super.call(this) || this;
        _this.blockLen = blockLen;
        _this.suffix = suffix;
        _this.outputLen = outputLen;
        _this.enableXOF = enableXOF;
        _this.rounds = rounds;
        _this.pos = 0;
        _this.posOut = 0;
        _this.finished = false;
        _this.destroyed = false;
        // Can be passed from user as dkLen
        (0, assert_1.assertPostiveInteger)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= _this.blockLen || _this.blockLen >= 200)
            throw new Error('Sha3 supports only keccak-f1600 function');
        _this.state = new Uint8Array(200);
        _this.state32 = (0, utils_1.u32)(_this.state);
        return _this;
    }
    Keccak.prototype.keccak = function () {
        if (!utils_1.isLE)
            (0, utils_1.byteSwap32)(this.state32);
        keccakP(this.state32, this.rounds);
        if (!utils_1.isLE)
            (0, utils_1.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    };
    Keccak.prototype.update = function (data) {
        this.assertExists();
        var _a = this, blockLen = _a.blockLen, state = _a.state;
        data = (0, utils_1.toBytes)(data);
        var len = data.length;
        for (var pos = 0; pos < len;) {
            var take = Math.min(blockLen - this.pos, len - pos);
            for (var i = 0; i < take; i++)
                state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen)
                this.keccak();
        }
        return this;
    };
    Keccak.prototype.finish = function () {
        if (this.finished)
            return;
        this.finished = true;
        var _a = this, state = _a.state, suffix = _a.suffix, pos = _a.pos, blockLen = _a.blockLen;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1)
            this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    };
    Keccak.prototype.writeInto = function (out) {
        this.assertExists(false);
        if (!(out instanceof Uint8Array))
            throw new Error("Uint8Array expected");
        this.finish();
        var bufferOut = this.state;
        var blockLen = this.blockLen;
        for (var pos = 0, len = out.length; pos < len;) {
            if (this.posOut >= blockLen)
                this.keccak();
            var take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    };
    Keccak.prototype.xofInto = function (out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF)
            throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    };
    Keccak.prototype.xof = function (bytes) {
        (0, assert_1.assertPostiveInteger)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    };
    Keccak.prototype.digestInto = function (out) {
        // output(out, this);
        if (!(out instanceof Uint8Array))
            throw new Error("Uint8Array expected");
        var min = this.outputLen;
        if (out.length < min)
            throw new Error("digestInto() expects output buffer of length at least ".concat(min));
        if (this.finished)
            throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    };
    Keccak.prototype.digest = function () {
        return this.digestInto(new Uint8Array(this.outputLen));
    };
    Keccak.prototype.destroy = function () {
        this.destroyed = true;
        this.state.fill(0);
    };
    Keccak.prototype._cloneInto = function (to) {
        var _a = this, blockLen = _a.blockLen, suffix = _a.suffix, outputLen = _a.outputLen, rounds = _a.rounds, enableXOF = _a.enableXOF;
        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    };
    Keccak.prototype.assertExists = function (checkFinished) {
        if (checkFinished === void 0) { checkFinished = true; }
        if (this.destroyed)
            throw new Error('Hash instance has been destroyed');
        if (checkFinished && this.finished)
            throw new Error('Hash#digest() has already been called');
    };
    return Keccak;
}(utils_1.Hash));
exports.Keccak = Keccak;
var gen = function (suffix, blockLen, outputLen) {
    return (0, utils_1.wrapConstructor)(function () { return new Keccak(blockLen, suffix, outputLen); });
};
// export const sha3_224 = /** @__PURE__ */ gen(0x06, 144, 224 / 8);
// /**
//  * SHA3-256 hash function
//  * @param message - that would be hashed
//  */
// export const sha3_256 = /** @__PURE__ */ gen(0x06, 136, 256 / 8);
// export const sha3_384 = /** @__PURE__ */ gen(0x06, 104, 384 / 8);
// export const sha3_512 = /** @__PURE__ */ gen(0x06, 72, 512 / 8);
exports.keccak_224 = gen(0x01, 144, 224 / 8);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */
exports.keccak_256 = gen(0x01, 136, 256 / 8);
exports.keccak_384 = gen(0x01, 104, 384 / 8);
exports.keccak_512 = gen(0x01, 72, 512 / 8);
// const genShake = (suffix: number, blockLen: number, outputLen: number) =>
//   wrapXOFConstructorWithOpts<HashXOF<Keccak>, ShakeOpts>(
//     (opts: ShakeOpts = {}) =>
//       new Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true)
//   );
// 
// export const shake128 = /** @__PURE__ */ genShake(0x1f, 168, 128 / 8);
// export const shake256 = /** @__PURE__ */ genShake(0x1f, 136, 256 / 8);


/***/ }),

/***/ 20258:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var e_1, _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RIPEMD160 = void 0;
/**
 * RIPEMD-160 legacy hash function.
 * https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
 * https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
 * @module
 */
var _md_1 = __webpack_require__(37962);
var utils_1 = __webpack_require__(74599);
var Rho = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]);
var Id = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map(function (_, i) { return i; }));
var Pi = /* @__PURE__ */ Id.map(function (i) { return (9 * i + 5) % 16; });
var idxL = [Id];
var idxR = [Pi];
for (var i = 0; i < 4; i++)
    try {
        for (var _b = (e_1 = void 0, __values([idxL, idxR])), _c = _b.next(); !_c.done; _c = _b.next()) {
            var j = _c.value;
            j.push(j[i].map(function (k) { return Rho[k]; }));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
var shifts = /* @__PURE__ */ [
    [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
    [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
    [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
    [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
    [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5],
].map(function (i) { return new Uint8Array(i); });
var shiftsL = /* @__PURE__ */ idxL.map(function (idx, i) { return idx.map(function (j) { return shifts[i][j]; }); });
var shiftsR = /* @__PURE__ */ idxR.map(function (idx, i) { return idx.map(function (j) { return shifts[i][j]; }); });
var Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e,
]);
var Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000,
]);
// It's called f() in spec.
function f(group, x, y, z) {
    if (group === 0)
        return x ^ y ^ z;
    else if (group === 1)
        return (x & y) | (~x & z);
    else if (group === 2)
        return (x | ~y) ^ z;
    else if (group === 3)
        return (x & z) | (y & ~z);
    else
        return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
var R_BUF = /* @__PURE__ */ new Uint32Array(16);
var RIPEMD160 = /** @class */ (function (_super) {
    __extends(RIPEMD160, _super);
    function RIPEMD160() {
        var _this = _super.call(this, 64, 20, 8, true) || this;
        _this.h0 = 0x67452301 | 0;
        _this.h1 = 0xefcdab89 | 0;
        _this.h2 = 0x98badcfe | 0;
        _this.h3 = 0x10325476 | 0;
        _this.h4 = 0xc3d2e1f0 | 0;
        return _this;
    }
    RIPEMD160.prototype.get = function () {
        var _a = this, h0 = _a.h0, h1 = _a.h1, h2 = _a.h2, h3 = _a.h3, h4 = _a.h4;
        return [h0, h1, h2, h3, h4];
    };
    RIPEMD160.prototype.set = function (h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    };
    RIPEMD160.prototype.process = function (view, offset) {
        for (var i = 0; i < 16; i++, offset += 4)
            R_BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        var al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for (var group = 0; group < 5; group++) {
            var rGroup = 4 - group;
            var hbl = Kl[group], hbr = Kr[group]; // prettier-ignore
            var rl = idxL[group], rr = idxR[group]; // prettier-ignore
            var sl = shiftsL[group], sr = shiftsR[group]; // prettier-ignore
            for (var i = 0; i < 16; i++) {
                var tl = ((0, utils_1.rotl)(al + f(group, bl, cl, dl) + R_BUF[rl[i]] + hbl, sl[i]) + el) | 0;
                al = el, el = dl, dl = (0, utils_1.rotl)(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for (var i = 0; i < 16; i++) {
                var tr = ((0, utils_1.rotl)(ar + f(rGroup, br, cr, dr) + R_BUF[rr[i]] + hbr, sr[i]) + er) | 0;
                ar = er, er = dr, dr = (0, utils_1.rotl)(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set((this.h1 + cl + dr) | 0, (this.h2 + dl + er) | 0, (this.h3 + el + ar) | 0, (this.h4 + al + br) | 0, (this.h0 + bl + cr) | 0);
    };
    RIPEMD160.prototype.roundClean = function () {
        R_BUF.fill(0);
    };
    RIPEMD160.prototype.destroy = function () {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    };
    return RIPEMD160;
}(_md_1.HashMD));
exports.RIPEMD160 = RIPEMD160;
/** RIPEMD-160 - a legacy hash function from 1990s. */
var _ripemd160 = /* @__PURE__ */ (0, utils_1.wrapConstructor)(function () { return new RIPEMD160(); });


/***/ }),

/***/ 6978:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.verifySecp256k1 = exports.signSecp256k1 = exports.encodeToCurve = exports.hashToCurve = exports.schnorr = exports.verifySchnorr = exports.signSchnorr = exports.Secp256k1Point = exports.secp256k1PointToBytes = exports.secp256k1 = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
var sha256_1 = __webpack_require__(7902);
var utils_1 = __webpack_require__(74599);
var modular_1 = __webpack_require__(99764);
var weierstrass_1 = __webpack_require__(76326);
var utils_2 = __webpack_require__(92035);
var hash_to_curve_1 = __webpack_require__(50288);
var _shortw_utils_1 = __webpack_require__(2629);
var secp256k1P = BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f');
var secp256k1N = BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141');
var _1n = BigInt(1);
var _2n = BigInt(2);
var divNearest = function (a, b) { return (a + b / _2n) / b; };
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */
function sqrtMod(y) {
    var P = secp256k1P;
    var _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    var _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    var b2 = (y * y * y) % P; // x^3, 11
    var b3 = (b2 * b2 * y) % P; // x^7
    var b6 = ((0, modular_1.pow2)(b3, _3n, P) * b3) % P;
    var b9 = ((0, modular_1.pow2)(b6, _3n, P) * b3) % P;
    var b11 = ((0, modular_1.pow2)(b9, _2n, P) * b2) % P;
    var b22 = ((0, modular_1.pow2)(b11, _11n, P) * b11) % P;
    var b44 = ((0, modular_1.pow2)(b22, _22n, P) * b22) % P;
    var b88 = ((0, modular_1.pow2)(b44, _44n, P) * b44) % P;
    var b176 = ((0, modular_1.pow2)(b88, _88n, P) * b88) % P;
    var b220 = ((0, modular_1.pow2)(b176, _44n, P) * b44) % P;
    var b223 = ((0, modular_1.pow2)(b220, _3n, P) * b3) % P;
    var t1 = ((0, modular_1.pow2)(b223, _23n, P) * b22) % P;
    var t2 = ((0, modular_1.pow2)(t1, _6n, P) * b2) % P;
    var root = (0, modular_1.pow2)(t2, _2n, P);
    if (!Fp.eql(Fp.sqr(root), y))
        throw new Error('Cannot find square root');
    return root;
}
var Fp = (0, modular_1.Field)(secp256k1P, undefined, undefined, { sqrt: sqrtMod });
exports.secp256k1 = (0, _shortw_utils_1.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: Fp,
    n: secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt('55066263022277343669578718895168534326250603453777594175500187360389116729240'),
    Gy: BigInt('32670510020758816978083085130507043184471273380659243275938904335757337482424'),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */
    endo: {
        beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
        splitScalar: function (k) {
            var n = secp256k1N;
            var a1 = BigInt('0x3086d221a7d46bcde86c90e49284eb15');
            var b1 = -_1n * BigInt('0xe4437ed6010e88286f547fa90abfe4c3');
            var a2 = BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8');
            var b2 = a1;
            var POW_2_128 = BigInt('0x100000000000000000000000000000000'); // (2n**128n).toString(16)
            var c1 = divNearest(b2 * k, n);
            var c2 = divNearest(-b1 * k, n);
            var k1 = (0, modular_1.mod)(k - c1 * a1 - c2 * a2, n);
            var k2 = (0, modular_1.mod)(-c1 * b1 - c2 * b2, n);
            var k1neg = k1 > POW_2_128;
            var k2neg = k2 > POW_2_128;
            if (k1neg)
                k1 = n - k1;
            if (k2neg)
                k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) {
                throw new Error('splitScalar: Endomorphism failed, k=' + k);
            }
            return { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 };
        },
    },
}, sha256_1.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
var _0n = BigInt(0);
var fe = function (x) { return typeof x === 'bigint' && _0n < x && x < secp256k1P; };
var ge = function (x) { return typeof x === 'bigint' && _0n < x && x < secp256k1N; };
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */
var TAGGED_HASH_PREFIXES = {};
function taggedHash(tag) {
    var messages = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        messages[_i - 1] = arguments[_i];
    }
    var tagP = TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        var tagH = (0, sha256_1.sha256)(Uint8Array.from(tag, function (c) { return c.charCodeAt(0); }));
        tagP = (0, utils_2.concatBytes)(tagH, tagH);
        TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, sha256_1.sha256)(utils_2.concatBytes.apply(void 0, __spreadArray([tagP], __read(messages), false)));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
var pointToBytes = function (point) { return point.toRawBytes(true).slice(1); };
exports.secp256k1PointToBytes = pointToBytes;
var numTo32b = function (n) { return (0, utils_2.numberToBytesBE)(n, 32); };
var modP = function (x) { return (0, modular_1.mod)(x, secp256k1P); };
var modN = function (x) { return (0, modular_1.mod)(x, secp256k1N); };
var Point = exports.secp256k1.ProjectivePoint;
exports.Secp256k1Point = exports.secp256k1.ProjectivePoint;
var GmulAdd = function (Q, a, b) {
    return Point.BASE.multiplyAndAddUnsafe(Q, a, b);
};
// Calculate point, scalar and bytes
function schnorrGetExtPubKey(priv) {
    var d_ = exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    var p = Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    var scalar = p.hasEvenY() ? d_ : modN(-d_);
    return { scalar: scalar, bytes: pointToBytes(p) };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */
function lift_x(x) {
    if (!fe(x))
        throw new Error('bad x: need 0 < x < p'); // Fail if x ≥ p.
    var xx = modP(x * x);
    var c = modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    var y = sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % _2n !== _0n)
        y = modP(-y); // Return the unique point P such that x(P) = x and
    var p = new Point(x, y, _1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */
function challenge() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return modN((0, utils_2.bytesToNumberBE)(taggedHash.apply(void 0, __spreadArray(['BIP0340/challenge'], __read(args), false))));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */
function schnorrGetPublicKey(privateKey) {
    return schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */
function schnorrSign(message, privateKey, auxRand) {
    if (auxRand === void 0) { auxRand = (0, utils_1.randomBytes)(32); }
    var m = (0, utils_2.ensureBytes)('message', message);
    var _a = schnorrGetExtPubKey(privateKey), px = _a.bytes, d = _a.scalar; // checks for isWithinCurveOrder
    var a = (0, utils_2.ensureBytes)('auxRand', auxRand, 32); // Auxiliary random data a: a 32-byte array
    var t = numTo32b(d ^ (0, utils_2.bytesToNumberBE)(taggedHash('BIP0340/aux', a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    var rand = taggedHash('BIP0340/nonce', t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    var k_ = modN((0, utils_2.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === _0n)
        throw new Error('sign failed: k is zero'); // Fail if k' = 0.
    var _b = schnorrGetExtPubKey(k_), rx = _b.bytes, k = _b.scalar; // Let R = k'⋅G.
    var e = challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    var sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set(numTo32b(modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!schnorrVerify(sig, m, px))
        throw new Error('sign: Invalid signature produced');
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */
function schnorrVerify(signature, message, publicKey) {
    var sig = (0, utils_2.ensureBytes)('signature', signature, 64);
    var m = (0, utils_2.ensureBytes)('message', message);
    var pub = (0, utils_2.ensureBytes)('publicKey', publicKey, 32);
    try {
        var P = lift_x((0, utils_2.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        var r = (0, utils_2.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!fe(r))
            return false;
        var s = (0, utils_2.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!ge(s))
            return false;
        var e = challenge(numTo32b(r), pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        var R = GmulAdd(P, s, modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r)
            return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    }
    catch (error) {
        return false;
    }
}
exports.signSchnorr = schnorrSign;
exports.verifySchnorr = schnorrVerify;
exports.schnorr = (function () { return ({
    getPublicKey: schnorrGetPublicKey,
    sign: schnorrSign,
    verify: schnorrVerify,
    utils: {
        randomPrivateKey: exports.secp256k1.utils.randomPrivateKey,
        lift_x: lift_x,
        pointToBytes: pointToBytes,
        numberToBytesBE: utils_2.numberToBytesBE,
        bytesToNumberBE: utils_2.bytesToNumberBE,
        taggedHash: taggedHash,
        mod: modular_1.mod,
    },
}); })();
var isoMap = /* @__PURE__ */ (function () {
    return (0, hash_to_curve_1.isogenyMap)(Fp, [
        // xNum
        [
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7',
            '0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581',
            '0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262',
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c',
        ],
        // xDen
        [
            '0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b',
            '0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14',
            '0x0000000000000000000000000000000000000000000000000000000000000001', // LAST 1
        ],
        // yNum
        [
            '0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c',
            '0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3',
            '0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931',
            '0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84',
        ],
        // yDen
        [
            '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b',
            '0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573',
            '0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f',
            '0x0000000000000000000000000000000000000000000000000000000000000001', // LAST 1
        ],
    ].map(function (i) { return i.map(function (j) { return BigInt(j); }); }));
})();
var mapSWU = /* @__PURE__ */ (function () {
    return (0, weierstrass_1.mapToCurveSimpleSWU)(Fp, {
        A: BigInt('0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533'),
        B: BigInt('1771'),
        Z: Fp.create(BigInt('-11')),
    });
})();
var htf = /* @__PURE__ */ (function () {
    return (0, hash_to_curve_1.createHasher)(exports.secp256k1.ProjectivePoint, function (scalars) {
        var _a = mapSWU(Fp.create(scalars[0])), x = _a.x, y = _a.y;
        return isoMap(x, y);
    }, {
        DST: 'secp256k1_XMD:SHA-256_SSWU_RO_',
        encodeDST: 'secp256k1_XMD:SHA-256_SSWU_NU_',
        p: Fp.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: sha256_1.sha256,
    });
})();
exports.hashToCurve = (function () { return htf.hashToCurve; })();
exports.encodeToCurve = (function () { return htf.encodeToCurve; })();
function signSecp256k1(data, privateKey, extraEntropy) {
    return exports.secp256k1.sign(data, privateKey, { extraEntropy: extraEntropy }).toCompactRawBytes();
}
exports.signSecp256k1 = signSecp256k1;
var myDefaultVerOpts = { lowS: true, prehash: false };
function verifySecp256k1(sig, msgHash, pubKey) {
    return exports.secp256k1.verify(sig, msgHash, pubKey, myDefaultVerOpts);
}
exports.verifySecp256k1 = verifySecp256k1;


/***/ }),

/***/ 7902:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha224 = exports.sha256 = void 0;
var _md_1 = __webpack_require__(37962);
var utils_1 = __webpack_require__(74599);
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
var SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
var SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
var SHA256_W = /* @__PURE__ */ new Uint32Array(64);
var SHA256 = /** @class */ (function (_super) {
    __extends(SHA256, _super);
    function SHA256() {
        var _this = _super.call(this, 64, 32, 8, false) || this;
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        _this.A = SHA256_IV[0] | 0;
        _this.B = SHA256_IV[1] | 0;
        _this.C = SHA256_IV[2] | 0;
        _this.D = SHA256_IV[3] | 0;
        _this.E = SHA256_IV[4] | 0;
        _this.F = SHA256_IV[5] | 0;
        _this.G = SHA256_IV[6] | 0;
        _this.H = SHA256_IV[7] | 0;
        return _this;
    }
    SHA256.prototype.get = function () {
        var _a = this, A = _a.A, B = _a.B, C = _a.C, D = _a.D, E = _a.E, F = _a.F, G = _a.G, H = _a.H;
        return [A, B, C, D, E, F, G, H];
    };
    // prettier-ignore
    SHA256.prototype.set = function (A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    };
    SHA256.prototype.process = function (view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for (var i = 0; i < 16; i++, offset += 4)
            SHA256_W[i] = view.getUint32(offset, false);
        for (var i = 16; i < 64; i++) {
            var W15 = SHA256_W[i - 15];
            var W2 = SHA256_W[i - 2];
            var s0 = (0, utils_1.rotr)(W15, 7) ^ (0, utils_1.rotr)(W15, 18) ^ (W15 >>> 3);
            var s1 = (0, utils_1.rotr)(W2, 17) ^ (0, utils_1.rotr)(W2, 19) ^ (W2 >>> 10);
            SHA256_W[i] = (s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16]) | 0;
        }
        // Compression function main loop, 64 rounds
        var _a = this, A = _a.A, B = _a.B, C = _a.C, D = _a.D, E = _a.E, F = _a.F, G = _a.G, H = _a.H;
        for (var i = 0; i < 64; i++) {
            var sigma1 = (0, utils_1.rotr)(E, 6) ^ (0, utils_1.rotr)(E, 11) ^ (0, utils_1.rotr)(E, 25);
            var T1 = (H + sigma1 + (0, _md_1.Chi)(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            var sigma0 = (0, utils_1.rotr)(A, 2) ^ (0, utils_1.rotr)(A, 13) ^ (0, utils_1.rotr)(A, 22);
            var T2 = (sigma0 + (0, _md_1.Maj)(A, B, C)) | 0;
            H = G;
            G = F;
            F = E;
            E = (D + T1) | 0;
            D = C;
            C = B;
            B = A;
            A = (T1 + T2) | 0;
        }
        // Add the compressed chunk to the current hash value
        A = (A + this.A) | 0;
        B = (B + this.B) | 0;
        C = (C + this.C) | 0;
        D = (D + this.D) | 0;
        E = (E + this.E) | 0;
        F = (F + this.F) | 0;
        G = (G + this.G) | 0;
        H = (H + this.H) | 0;
        this.set(A, B, C, D, E, F, G, H);
    };
    SHA256.prototype.roundClean = function () {
        SHA256_W.fill(0);
    };
    SHA256.prototype.destroy = function () {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    };
    return SHA256;
}(_md_1.HashMD));
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
var SHA224 = /** @class */ (function (_super) {
    __extends(SHA224, _super);
    function SHA224() {
        var _this = _super.call(this) || this;
        _this.A = 0xc1059ed8 | 0;
        _this.B = 0x367cd507 | 0;
        _this.C = 0x3070dd17 | 0;
        _this.D = 0xf70e5939 | 0;
        _this.E = 0xffc00b31 | 0;
        _this.F = 0x68581511 | 0;
        _this.G = 0x64f98fa7 | 0;
        _this.H = 0xbefa4fa4 | 0;
        _this.outputLen = 28;
        return _this;
    }
    return SHA224;
}(SHA256));
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */
exports.sha256 = (0, utils_1.wrapConstructor)(function () { return new SHA256(); });
exports.sha224 = (0, utils_1.wrapConstructor)(function () { return new SHA224(); });


/***/ }),

/***/ 17508:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha384 = exports.sha512_256 = exports.sha512_224 = exports.sha512 = exports.SHA512 = void 0;
var _md_1 = __webpack_require__(37962);
var u64 = __importStar(__webpack_require__(90310));
var utils_1 = __webpack_require__(74599);
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
var _a = __read(/* @__PURE__ */ (function () { return u64.split([
    '0x428a2f98d728ae22', '0x7137449123ef65cd', '0xb5c0fbcfec4d3b2f', '0xe9b5dba58189dbbc',
    '0x3956c25bf348b538', '0x59f111f1b605d019', '0x923f82a4af194f9b', '0xab1c5ed5da6d8118',
    '0xd807aa98a3030242', '0x12835b0145706fbe', '0x243185be4ee4b28c', '0x550c7dc3d5ffb4e2',
    '0x72be5d74f27b896f', '0x80deb1fe3b1696b1', '0x9bdc06a725c71235', '0xc19bf174cf692694',
    '0xe49b69c19ef14ad2', '0xefbe4786384f25e3', '0x0fc19dc68b8cd5b5', '0x240ca1cc77ac9c65',
    '0x2de92c6f592b0275', '0x4a7484aa6ea6e483', '0x5cb0a9dcbd41fbd4', '0x76f988da831153b5',
    '0x983e5152ee66dfab', '0xa831c66d2db43210', '0xb00327c898fb213f', '0xbf597fc7beef0ee4',
    '0xc6e00bf33da88fc2', '0xd5a79147930aa725', '0x06ca6351e003826f', '0x142929670a0e6e70',
    '0x27b70a8546d22ffc', '0x2e1b21385c26c926', '0x4d2c6dfc5ac42aed', '0x53380d139d95b3df',
    '0x650a73548baf63de', '0x766a0abb3c77b2a8', '0x81c2c92e47edaee6', '0x92722c851482353b',
    '0xa2bfe8a14cf10364', '0xa81a664bbc423001', '0xc24b8b70d0f89791', '0xc76c51a30654be30',
    '0xd192e819d6ef5218', '0xd69906245565a910', '0xf40e35855771202a', '0x106aa07032bbd1b8',
    '0x19a4c116b8d2d0c8', '0x1e376c085141ab53', '0x2748774cdf8eeb99', '0x34b0bcb5e19b48a8',
    '0x391c0cb3c5c95a63', '0x4ed8aa4ae3418acb', '0x5b9cca4f7763e373', '0x682e6ff3d6b2b8a3',
    '0x748f82ee5defb2fc', '0x78a5636f43172f60', '0x84c87814a1f0ab72', '0x8cc702081a6439ec',
    '0x90befffa23631e28', '0xa4506cebde82bde9', '0xbef9a3f7b2c67915', '0xc67178f2e372532b',
    '0xca273eceea26619c', '0xd186b8c721c0c207', '0xeada7dd6cde0eb1e', '0xf57d4f7fee6ed178',
    '0x06f067aa72176fba', '0x0a637dc5a2c898a6', '0x113f9804bef90dae', '0x1b710b35131c471b',
    '0x28db77f523047d84', '0x32caab7b40c72493', '0x3c9ebe0a15c9bebc', '0x431d67c49c100d4c',
    '0x4cc5d4becb3e42b6', '0x597f299cfc657e2a', '0x5fcb6fab3ad6faec', '0x6c44198c4a475817'
].map(function (n) { return BigInt(n); })); })(), 2), SHA512_Kh = _a[0], SHA512_Kl = _a[1];
// Temporary buffer, not used to store anything between runs
var SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
var SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
var SHA512 = /** @class */ (function (_super) {
    __extends(SHA512, _super);
    function SHA512() {
        var _this = _super.call(this, 128, 64, 16, false) || this;
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 0x6a09e667 | 0;
        _this.Al = 0xf3bcc908 | 0;
        _this.Bh = 0xbb67ae85 | 0;
        _this.Bl = 0x84caa73b | 0;
        _this.Ch = 0x3c6ef372 | 0;
        _this.Cl = 0xfe94f82b | 0;
        _this.Dh = 0xa54ff53a | 0;
        _this.Dl = 0x5f1d36f1 | 0;
        _this.Eh = 0x510e527f | 0;
        _this.El = 0xade682d1 | 0;
        _this.Fh = 0x9b05688c | 0;
        _this.Fl = 0x2b3e6c1f | 0;
        _this.Gh = 0x1f83d9ab | 0;
        _this.Gl = 0xfb41bd6b | 0;
        _this.Hh = 0x5be0cd19 | 0;
        _this.Hl = 0x137e2179 | 0;
        return _this;
    }
    // prettier-ignore
    SHA512.prototype.get = function () {
        var _a = this, Ah = _a.Ah, Al = _a.Al, Bh = _a.Bh, Bl = _a.Bl, Ch = _a.Ch, Cl = _a.Cl, Dh = _a.Dh, Dl = _a.Dl, Eh = _a.Eh, El = _a.El, Fh = _a.Fh, Fl = _a.Fl, Gh = _a.Gh, Gl = _a.Gl, Hh = _a.Hh, Hl = _a.Hl;
        return [Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl];
    };
    // prettier-ignore
    SHA512.prototype.set = function (Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    };
    SHA512.prototype.process = function (view, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for (var i = 0; i < 16; i++, offset += 4) {
            SHA512_W_H[i] = view.getUint32(offset);
            SHA512_W_L[i] = view.getUint32((offset += 4));
        }
        for (var i = 16; i < 80; i++) {
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            var W15h = SHA512_W_H[i - 15] | 0;
            var W15l = SHA512_W_L[i - 15] | 0;
            var s0h = u64.rotrSH(W15h, W15l, 1) ^ u64.rotrSH(W15h, W15l, 8) ^ u64.shrSH(W15h, W15l, 7);
            var s0l = u64.rotrSL(W15h, W15l, 1) ^ u64.rotrSL(W15h, W15l, 8) ^ u64.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            var W2h = SHA512_W_H[i - 2] | 0;
            var W2l = SHA512_W_L[i - 2] | 0;
            var s1h = u64.rotrSH(W2h, W2l, 19) ^ u64.rotrBH(W2h, W2l, 61) ^ u64.shrSH(W2h, W2l, 6);
            var s1l = u64.rotrSL(W2h, W2l, 19) ^ u64.rotrBL(W2h, W2l, 61) ^ u64.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            var SUMl = u64.add4L(s0l, s1l, SHA512_W_L[i - 7], SHA512_W_L[i - 16]);
            var SUMh = u64.add4H(SUMl, s0h, s1h, SHA512_W_H[i - 7], SHA512_W_H[i - 16]);
            SHA512_W_H[i] = SUMh | 0;
            SHA512_W_L[i] = SUMl | 0;
        }
        var _k = this, Ah = _k.Ah, Al = _k.Al, Bh = _k.Bh, Bl = _k.Bl, Ch = _k.Ch, Cl = _k.Cl, Dh = _k.Dh, Dl = _k.Dl, Eh = _k.Eh, El = _k.El, Fh = _k.Fh, Fl = _k.Fl, Gh = _k.Gh, Gl = _k.Gl, Hh = _k.Hh, Hl = _k.Hl;
        // Compression function main loop, 80 rounds
        for (var i = 0; i < 80; i++) {
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            var sigma1h = u64.rotrSH(Eh, El, 14) ^ u64.rotrSH(Eh, El, 18) ^ u64.rotrBH(Eh, El, 41);
            var sigma1l = u64.rotrSL(Eh, El, 14) ^ u64.rotrSL(Eh, El, 18) ^ u64.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            var CHIh = (Eh & Fh) ^ (~Eh & Gh);
            var CHIl = (El & Fl) ^ (~El & Gl);
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            var T1ll = u64.add5L(Hl, sigma1l, CHIl, SHA512_Kl[i], SHA512_W_L[i]);
            var T1h = u64.add5H(T1ll, Hh, sigma1h, CHIh, SHA512_Kh[i], SHA512_W_H[i]);
            var T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            var sigma0h = u64.rotrSH(Ah, Al, 28) ^ u64.rotrBH(Ah, Al, 34) ^ u64.rotrBH(Ah, Al, 39);
            var sigma0l = u64.rotrSL(Ah, Al, 28) ^ u64.rotrBL(Ah, Al, 34) ^ u64.rotrBL(Ah, Al, 39);
            var MAJh = (Ah & Bh) ^ (Ah & Ch) ^ (Bh & Ch);
            var MAJl = (Al & Bl) ^ (Al & Cl) ^ (Bl & Cl);
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            (_a = u64.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0), Eh = _a.h, El = _a.l);
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            var All = u64.add3L(T1l, sigma0l, MAJl);
            Ah = u64.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        (_b = u64.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0), Ah = _b.h, Al = _b.l);
        (_c = u64.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0), Bh = _c.h, Bl = _c.l);
        (_d = u64.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0), Ch = _d.h, Cl = _d.l);
        (_e = u64.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0), Dh = _e.h, Dl = _e.l);
        (_f = u64.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0), Eh = _f.h, El = _f.l);
        (_g = u64.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0), Fh = _g.h, Fl = _g.l);
        (_h = u64.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0), Gh = _h.h, Gl = _h.l);
        (_j = u64.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0), Hh = _j.h, Hl = _j.l);
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    };
    SHA512.prototype.roundClean = function () {
        SHA512_W_H.fill(0);
        SHA512_W_L.fill(0);
    };
    SHA512.prototype.destroy = function () {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    };
    return SHA512;
}(_md_1.HashMD));
exports.SHA512 = SHA512;
var SHA512_224 = /** @class */ (function (_super) {
    __extends(SHA512_224, _super);
    function SHA512_224() {
        var _this = _super.call(this) || this;
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 0x8c3d37c8 | 0;
        _this.Al = 0x19544da2 | 0;
        _this.Bh = 0x73e19966 | 0;
        _this.Bl = 0x89dcd4d6 | 0;
        _this.Ch = 0x1dfab7ae | 0;
        _this.Cl = 0x32ff9c82 | 0;
        _this.Dh = 0x679dd514 | 0;
        _this.Dl = 0x582f9fcf | 0;
        _this.Eh = 0x0f6d2b69 | 0;
        _this.El = 0x7bd44da8 | 0;
        _this.Fh = 0x77e36f73 | 0;
        _this.Fl = 0x04c48942 | 0;
        _this.Gh = 0x3f9d85a8 | 0;
        _this.Gl = 0x6a1d36c8 | 0;
        _this.Hh = 0x1112e6ad | 0;
        _this.Hl = 0x91d692a1 | 0;
        _this.outputLen = 28;
        return _this;
    }
    return SHA512_224;
}(SHA512));
var SHA512_256 = /** @class */ (function (_super) {
    __extends(SHA512_256, _super);
    function SHA512_256() {
        var _this = _super.call(this) || this;
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 0x22312194 | 0;
        _this.Al = 0xfc2bf72c | 0;
        _this.Bh = 0x9f555fa3 | 0;
        _this.Bl = 0xc84c64c2 | 0;
        _this.Ch = 0x2393b86b | 0;
        _this.Cl = 0x6f53b151 | 0;
        _this.Dh = 0x96387719 | 0;
        _this.Dl = 0x5940eabd | 0;
        _this.Eh = 0x96283ee2 | 0;
        _this.El = 0xa88effe3 | 0;
        _this.Fh = 0xbe5e1e25 | 0;
        _this.Fl = 0x53863992 | 0;
        _this.Gh = 0x2b0199fc | 0;
        _this.Gl = 0x2c85b8aa | 0;
        _this.Hh = 0x0eb72ddc | 0;
        _this.Hl = 0x81c52ca2 | 0;
        _this.outputLen = 32;
        return _this;
    }
    return SHA512_256;
}(SHA512));
var SHA384 = /** @class */ (function (_super) {
    __extends(SHA384, _super);
    function SHA384() {
        var _this = _super.call(this) || this;
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 0xcbbb9d5d | 0;
        _this.Al = 0xc1059ed8 | 0;
        _this.Bh = 0x629a292a | 0;
        _this.Bl = 0x367cd507 | 0;
        _this.Ch = 0x9159015a | 0;
        _this.Cl = 0x3070dd17 | 0;
        _this.Dh = 0x152fecd8 | 0;
        _this.Dl = 0xf70e5939 | 0;
        _this.Eh = 0x67332667 | 0;
        _this.El = 0xffc00b31 | 0;
        _this.Fh = 0x8eb44a87 | 0;
        _this.Fl = 0x68581511 | 0;
        _this.Gh = 0xdb0c2e0d | 0;
        _this.Gl = 0x64f98fa7 | 0;
        _this.Hh = 0x47b5481d | 0;
        _this.Hl = 0xbefa4fa4 | 0;
        _this.outputLen = 48;
        return _this;
    }
    return SHA384;
}(SHA512));
exports.sha512 = (0, utils_1.wrapConstructor)(function () { return new SHA512(); });
exports.sha512_224 = (0, utils_1.wrapConstructor)(function () { return new SHA512_224(); });
exports.sha512_256 = (0, utils_1.wrapConstructor)(function () { return new SHA512_256(); });
exports.sha384 = (0, utils_1.wrapConstructor)(function () { return new SHA384(); });


/***/ }),

/***/ 74599:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-hashes/blob/6ae82e75d4c354d53a488e95b1bfe9cba90bd6ff/src/utils.ts#L1

it was modified and adapted to this repository to re-use already defined stuff

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.randomBytes = exports.wrapXOFConstructorWithOpts = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.checkOpts = exports.Hash = exports.concatBytes = exports.toBytes = exports.asyncLoop = exports.nextTick = exports.hexToBytes = exports.bytesToHex = exports.byteSwap32 = exports.byteSwapIfBE = exports.byteSwap = exports.isLE = exports.rotl = exports.rotr = exports.createView = exports.u32 = exports.u8 = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var assert_1 = __webpack_require__(97610);
var crypto_1 = __webpack_require__(86036);
// Cast array to different type
var u8 = function (arr) { return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength); };
exports.u8 = u8;
var u32 = function (arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
};
exports.u32 = u32;
// Cast array to view
var createView = function (arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
};
exports.createView = createView;
// The rotate right (circular right shift) operation for uint32
var rotr = function (word, shift) { return (word << (32 - shift)) | (word >>> shift); };
exports.rotr = rotr;
// The rotate left (circular left shift) operation for uint32
var rotl = function (word, shift) {
    return (word << shift) | ((word >>> (32 - shift)) >>> 0);
};
exports.rotl = rotl;
exports.isLE = new Uint8Array(new Uint32Array([0x11223344]).buffer)[0] === 0x44;
// The byte swap operation for uint32
var byteSwap = function (word) {
    return ((word << 24) & 0xff000000) |
        ((word << 8) & 0xff0000) |
        ((word >>> 8) & 0xff00) |
        ((word >>> 24) & 0xff);
};
exports.byteSwap = byteSwap;
// Conditionally byte swap if on a big-endian platform
exports.byteSwapIfBE = exports.isLE ? function (n) { return n; } : function (n) { return (0, exports.byteSwap)(n); };
// In place byte swap for Uint32Array
function byteSwap32(arr) {
    for (var i = 0; i < arr.length; i++) {
        arr[i] = (0, exports.byteSwap)(arr[i]);
    }
}
exports.byteSwap32 = byteSwap32;
// Array where index 0xf0 (240) is mapped to string 'f0'
var hexes = /* @__PURE__ */ Array.from({ length: 256 }, function (_, i) {
    return i.toString(16).padStart(2, '0');
});
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */
function bytesToHex(bytes) {
    (0, assert_1.assertBytes)(bytes);
    // pre-caching improves the speed 6x
    var hex = '';
    for (var i = 0; i < bytes.length; i++) {
        hex += hexes[bytes[i]];
    }
    return hex;
}
exports.bytesToHex = bytesToHex;
// We use optimized technique to convert hex string to byte array
var asciis = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9)
        return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F)
        return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f)
        return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */
function hexToBytes(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    var hl = hex.length;
    var al = hl / 2;
    if (hl % 2)
        throw new Error('padded hex string expected, got unpadded hex of length ' + hl);
    var array = new Uint8Array(al);
    for (var ai = 0, hi = 0; ai < al; ai++, hi += 2) {
        var n1 = asciiToBase16(hex.charCodeAt(hi));
        var n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            var char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
var nextTick = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_b) {
    return [2 /*return*/];
}); }); };
exports.nextTick = nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
function asyncLoop(iters, tick, cb) {
    return __awaiter(this, void 0, void 0, function () {
        var ts, i, diff;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ts = Date.now();
                    i = 0;
                    _b.label = 1;
                case 1:
                    if (!(i < iters)) return [3 /*break*/, 4];
                    cb(i);
                    diff = Date.now() - ts;
                    if (diff >= 0 && diff < tick)
                        return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, exports.nextTick)()];
                case 2:
                    _b.sent();
                    ts += diff;
                    _b.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.asyncLoop = asyncLoop;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */
function toBytes(data) {
    if (typeof data === 'string')
        data = (0, uint8array_utils_1.fromUtf8)(data);
    (0, assert_1.assertBytes)(data);
    return data;
}
exports.toBytes = toBytes;
/**
 * Copies several Uint8Arrays into one.
 */
function concatBytes() {
    var arrays = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arrays[_i] = arguments[_i];
    }
    var sum = 0;
    for (var i = 0; i < arrays.length; i++) {
        var a = arrays[i];
        (0, assert_1.assertBytes)(a);
        sum += a.length;
    }
    var res = new Uint8Array(sum);
    for (var i = 0, pad = 0; i < arrays.length; i++) {
        var a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
exports.concatBytes = concatBytes;
// For runtime check if class implements interface
var Hash = /** @class */ (function () {
    function Hash() {
    }
    // Safe version that clones internal state
    Hash.prototype.clone = function () {
        return this._cloneInto();
    };
    return Hash;
}());
exports.Hash = Hash;
var toStr = {}.toString;
function checkOpts(defaults, opts) {
    if (opts !== undefined && toStr.call(opts) !== '[object Object]')
        throw new Error('Options should be object or undefined');
    var merged = Object.assign(defaults, opts);
    return merged;
}
exports.checkOpts = checkOpts;
function wrapConstructor(hashCons) {
    var hashC = function (msg) { return hashCons().update(toBytes(msg)).digest(); };
    var tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function () { return hashCons(); };
    return hashC;
}
exports.wrapConstructor = wrapConstructor;
function wrapConstructorWithOpts(hashCons) {
    var hashC = function (msg, opts) { return hashCons(opts).update(toBytes(msg)).digest(); };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function (opts) { return hashCons(opts); };
    return hashC;
}
exports.wrapConstructorWithOpts = wrapConstructorWithOpts;
function wrapXOFConstructorWithOpts(hashCons) {
    var hashC = function (msg, opts) { return hashCons(opts).update(toBytes(msg)).digest(); };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function (opts) { return hashCons(opts); };
    return hashC;
}
exports.wrapXOFConstructorWithOpts = wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */
function randomBytes(bytesLength) {
    if (bytesLength === void 0) { bytesLength = 32; }
    if (crypto_1.crypto && typeof crypto_1.crypto.getRandomValues === 'function') {
        return crypto_1.crypto.getRandomValues(new Uint8Array(bytesLength));
    }
    var bytes = new Uint8Array(bytesLength);
    for (var i = 0; i < bytesLength; i++) {
        bytes[i] = Math.floor(Math.random() * 256);
    }
    return bytes;
}
exports.randomBytes = randomBytes;


/***/ }),

/***/ 34183:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ripemd160 = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var ripemd_160_1 = __webpack_require__(20258);
function ripemd160(input) {
    if (typeof input === "string") {
        if (input.startsWith("0x"))
            input = (0, uint8array_utils_1.fromHex)(input.toLowerCase().slice(2));
        else if (isHex(input))
            input = (0, uint8array_utils_1.fromHex)(input.toLowerCase());
        else
            input = (0, uint8array_utils_1.fromUtf8)(input);
    }
    if (!(input instanceof Uint8Array))
        input = new Uint8Array(input);
    // throw new Error("ripemd160: input must be Uint8Array or string");
    return new ripemd_160_1.RIPEMD160().update(input).digest();
}
exports.ripemd160 = ripemd160;
function isHex(str) {
    return /^[0-9A-Fa-f]*$/.test(str);
}


/***/ }),

/***/ 46732:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.negate_scalar = exports.pack_unpacked_scalar = exports.unpacked_scalar_from_bytes_wide = exports.unpack_scalar = exports.add_scalars = exports.mul_scalars = exports.scalar_from_bytes_mod_order_wide = exports.scalar_from_u64 = exports.ProjectivePoint = exports.CompletedPoint = exports.decompressCompressedEdwardsY = exports.LookupTableProjectiveNielsPoint = exports.ProjectiveNielsPoint = exports.ED25519_BASEPOINT_POINT = exports.EdwardsPoint = exports.MontgomeryPoint = exports.FieldElem51 = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
function load8(bytes, offset) {
    var dataView = bytes instanceof DataView ? bytes : new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    return dataView.getBigUint64(offset, true);
}
var _0n = BigInt(0);
var _1n = BigInt(1);
var _51n = BigInt(51);
var _52n = BigInt(52);
var _64n = BigInt(64);
var LOW_51_BIT_MASK = (_1n << _51n) - _1n;
var LOW_52_BIT_MASK = (_1n << _52n) - _1n;
var LOW_64_BIT_MASK = (_1n << _64n) - _1n;
function innerConditionalAssign(self, other, choice) {
    // if choice = 0, mask = (-0) = 0000...0000
    // if choice = 1, mask = (-1) = 1111...1111
    // return self ^ ( choice ? ( self ^ other ) : _0n );
    // const mask = choice ? (_1n << _64n) - _1n : _0n;
    // return self ^ ( mask & ( self ^ other ) );
    return choice ? other : self;
}
var FieldElem51 = /** @class */ (function () {
    function FieldElem51(bytes) {
        this.bytes = bytes;
    }
    FieldElem51.zero = function () {
        return new FieldElem51(new BigUint64Array([
            _0n,
            _0n,
            _0n,
            _0n,
            _0n
        ]));
    };
    FieldElem51.one = function () {
        return new FieldElem51(new BigUint64Array([
            _1n,
            _0n,
            _0n,
            _0n,
            _0n,
        ]));
    };
    /*
    /// Construct -1.
    pub fn minus_one() -> FieldElem51 {
        FieldElem51([2251799813685228, 2251799813685247, 2251799813685247, 2251799813685247, 2251799813685247])
    }
    */
    FieldElem51.minus_one = function () {
        return new FieldElem51(new BigUint64Array([
            BigInt("2251799813685228"),
            BigInt("2251799813685247"),
            BigInt("2251799813685247"),
            BigInt("2251799813685247"),
            BigInt("2251799813685247"),
        ]));
    };
    Object.defineProperty(FieldElem51, "EDWARDS_D", {
        get: function () {
            return new FieldElem51(new BigUint64Array([
                BigInt("929955233495203"),
                BigInt("466365720129213"),
                BigInt("1662059464998953"),
                BigInt("2033849074728123"),
                BigInt("1442794654840575"),
            ]));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FieldElem51, "EDWARDS_D2", {
        get: function () {
            return new FieldElem51(new BigUint64Array([
                BigInt("1859910466990425"),
                BigInt("932731440258426"),
                BigInt("1072319116312658"),
                BigInt("1815898335770999"),
                BigInt("633789495995903"),
            ]));
        },
        enumerable: false,
        configurable: true
    });
    FieldElem51.fromBytes = function (bytes) {
        var dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        return new FieldElem51(new BigUint64Array([
            load8(dataView, 0) & LOW_51_BIT_MASK,
            (load8(dataView, 6) >> BigInt(3)) & LOW_51_BIT_MASK,
            (load8(dataView, 12) >> BigInt(6)) & LOW_51_BIT_MASK,
            (load8(dataView, 19) >> BigInt(1)) & LOW_51_BIT_MASK,
            (load8(dataView, 24) >> BigInt(12)) & LOW_51_BIT_MASK,
        ]));
    };
    /*
    #[allow(unused)]
    pub(crate) fn elligator_encode(r_0: &FieldElement) -> MontgomeryPoint {
        let one = FieldElement::one();
        let d_1 = &one + &r_0.square2(); / * 2r^2 * /
    
        let d = &MONTGOMERY_A_NEG * &(d_1.invert()); // * A/(1+2r^2) * /
    
        let d_sq = &d.square();
        let au = &MONTGOMERY_A * &d;
    
        let inner = &(d_sq + &au) + &one;
        let eps = &d * &inner; // * eps = d^3 + Ad^2 + d * /
    
        let (eps_is_sq, _eps) = FieldElement::sqrt_ratio_i(&eps, &one);
    
        let zero = FieldElement::zero();
        let Atemp = FieldElement::conditional_select(&MONTGOMERY_A, &zero, eps_is_sq); /* 0, or A if nonsquare* /
        let mut u = &d + &Atemp; /* d, or d+A if nonsquare * /
        u.conditional_negate(!eps_is_sq); /* d, or -d-A if nonsquare * /
    
        MontgomeryPoint(u.to_bytes())
    }
    */
    FieldElem51.elligator_encode = function (r_0) {
        var one = FieldElem51.one();
        var d_1 = one.add(r_0.square2());
        // const d = d_1.invert().mul( FieldElem51.fromBytes( new Uint8Array( 32 ) ) );
        var d = FieldElem51.MONTGOMERY_A_NEG.mul(d_1.invert());
        var MONTGOMERY_A = FieldElem51.MONTGOMERY_A;
        var d_sq = d.square();
        var au = MONTGOMERY_A.mul(d);
        var inner = d_sq.add(au).add(one);
        var eps = d.mul(inner);
        var _a = __read(FieldElem51.sqrt_ratio_i(eps, one), 2), eps_is_sq = _a[0], _eps = _a[1];
        var zero = FieldElem51.zero();
        // let Atemp = FieldElement::conditional_select(&MONTGOMERY_A, &zero, eps_is_sq); /* 0, or A if nonsquare*/
        var Atemp = FieldElem51.conditional_select(MONTGOMERY_A, zero, eps_is_sq);
        var u = d.add(Atemp);
        u.conditional_negate(!eps_is_sq);
        return new MontgomeryPoint(u.toBytes());
    };
    FieldElem51.elligator_encode_var_time = function (r_0) {
        var one = FieldElem51.one();
        var d_1 = one.add(r_0.square2());
        // const d = d_1.invert().mul( FieldElem51.fromBytes( new Uint8Array( 32 ) ) );
        var d = FieldElem51.MONTGOMERY_A_NEG.mul(d_1.invert());
        var MONTGOMERY_A = FieldElem51.MONTGOMERY_A;
        var d_sq = d.square();
        var au = MONTGOMERY_A.mul(d);
        var inner = d_sq.add(au).add(one);
        var eps = d.mul(inner);
        var _a = __read(FieldElem51.sqrt_ratio_i(eps, one), 2), eps_is_sq = _a[0], _eps = _a[1];
        var zero = FieldElem51.zero();
        // let Atemp = FieldElement::conditional_select(&MONTGOMERY_A, &zero, eps_is_sq); /* 0, or A if nonsquare*/
        var Atemp = FieldElem51.conditional_select(MONTGOMERY_A, zero, eps_is_sq);
        var u = d.add(Atemp);
        u.conditional_negate(!eps_is_sq);
        return new MontgomeryPoint(u.toBytes());
    };
    /*
    fn conditional_select(
        a: &FieldElement51,
        b: &FieldElement51,
        choice: Choice,
    ) -> FieldElement51 {
        FieldElement51([
            u64::conditional_select(&a.0[0], &b.0[0], choice),
            u64::conditional_select(&a.0[1], &b.0[1], choice),
            u64::conditional_select(&a.0[2], &b.0[2], choice),
            u64::conditional_select(&a.0[3], &b.0[3], choice),
            u64::conditional_select(&a.0[4], &b.0[4], choice),
        ])
    }
        // u64::conditional_select(&a.0[0], &b.0[0], choice),
        #[inline]
            fn conditional_select(a: &Self, b: &Self, choice: Choice) -> Self {
                // if choice = 0, mask = (-0) = 0000...0000
                // if choice = 1, mask = (-1) = 1111...1111
                let mask = -(choice.unwrap_u8() as to_signed_int!($t)) as $t;
                a ^ (mask & (a ^ b))
            }
    */
    FieldElem51.conditional_select = function (a, b, choice) {
        var mask = choice ? LOW_64_BIT_MASK : _0n;
        var a_bytes = a.bytes;
        var b_bytes = b.bytes;
        return new FieldElem51(new BigUint64Array([
            a_bytes[0] ^ (mask & (a_bytes[0] ^ b_bytes[0])),
            a_bytes[1] ^ (mask & (a_bytes[1] ^ b_bytes[1])),
            a_bytes[2] ^ (mask & (a_bytes[2] ^ b_bytes[2])),
            a_bytes[3] ^ (mask & (a_bytes[3] ^ b_bytes[3])),
            a_bytes[4] ^ (mask & (a_bytes[4] ^ b_bytes[4])),
        ]));
    };
    Object.defineProperty(FieldElem51, "MONTGOMERY_A_NEG", {
        get: function () {
            return new FieldElem51(new BigUint64Array([
                BigInt("2251799813198567"),
                BigInt("2251799813685247"),
                BigInt("2251799813685247"),
                BigInt("2251799813685247"),
                BigInt("2251799813685247"),
            ]));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FieldElem51, "MONTGOMERY_A", {
        get: function () {
            return new FieldElem51(new BigUint64Array([
                BigInt("486662"),
                _0n,
                _0n,
                _0n,
                _0n,
            ]));
        },
        enumerable: false,
        configurable: true
    });
    FieldElem51.prototype.pow2k = function (k) {
        /*
        pub fn pow2k(&self, mut k: u32) -> FieldElem51 {

        debug_assert!( k > 0 );

        /// Multiply two 64-bit integers with 128 bits of output.
        #[inline(always)]
        fn m(x: u64, y: u64) -> u128 { (x as u128) * (y as u128) }

        let mut a: [u64; 5] = self.0;

        loop {
            // Precondition: assume input limbs a[i] are bounded as
            //
            // a[i] < 2^(51 + b)
            //
            // where b is a real parameter measuring the "bit excess" of the limbs.

            // Precomputation: 64-bit multiply by 19.
            //
            // This fits into a u64 whenever 51 + b + lg(19) < 64.
            //
            // Since 51 + b + lg(19) < 51 + 4.25 + b
            //                       = 55.25 + b,
            // this fits if b < 8.75.
            let a3_19 = 19 * a[3];
            let a4_19 = 19 * a[4];

            // Multiply to get 128-bit coefficients of output.
            //
            // The 128-bit multiplications by 2 turn into 1 slr + 1 slrd each,
            // which doesn't seem any better or worse than doing them as precomputations
            // on the 64-bit inputs.
            let     c0: u128 = m(a[0],  a[0]) + 2*( m(a[1], a4_19) + m(a[2], a3_19) );
            let mut c1: u128 = m(a[3], a3_19) + 2*( m(a[0],  a[1]) + m(a[2], a4_19) );
            let mut c2: u128 = m(a[1],  a[1]) + 2*( m(a[0],  a[2]) + m(a[4], a3_19) );
            let mut c3: u128 = m(a[4], a4_19) + 2*( m(a[0],  a[3]) + m(a[1],  a[2]) );
            let mut c4: u128 = m(a[2],  a[2]) + 2*( m(a[0],  a[4]) + m(a[1],  a[3]) );

            // Same bound as in multiply:
            //    c[i] < 2^(102 + 2*b) * (1+i + (4-i)*19)
            //         < 2^(102 + lg(1 + 4*19) + 2*b)
            //         < 2^(108.27 + 2*b)
            //
            // The carry (c[i] >> 51) fits into a u64 when
            //    108.27 + 2*b - 51 < 64
            //    2*b < 6.73
            //    b < 3.365.
            //
            // So we require b < 3 to ensure this fits.
            debug_assert!(a[0] < (1 << 54));
            debug_assert!(a[1] < (1 << 54));
            debug_assert!(a[2] < (1 << 54));
            debug_assert!(a[3] < (1 << 54));
            debug_assert!(a[4] < (1 << 54));

            const LOW_51_BIT_MASK: u64 = (1u64 << 51) - 1;

            // Casting to u64 and back tells the compiler that the carry is bounded by 2^64, so
            // that the addition is a u128 + u64 rather than u128 + u128.
            c1 += ((c0 >> 51) as u64) as u128;
            a[0] = (c0 as u64) & LOW_51_BIT_MASK;

            c2 += ((c1 >> 51) as u64) as u128;
            a[1] = (c1 as u64) & LOW_51_BIT_MASK;

            c3 += ((c2 >> 51) as u64) as u128;
            a[2] = (c2 as u64) & LOW_51_BIT_MASK;

            c4 += ((c3 >> 51) as u64) as u128;
            a[3] = (c3 as u64) & LOW_51_BIT_MASK;

            let carry: u64 = (c4 >> 51) as u64;
            a[4] = (c4 as u64) & LOW_51_BIT_MASK;

            // To see that this does not overflow, we need a[0] + carry * 19 < 2^64.
            //
            // c4 < a2^2 + 2*a0*a4 + 2*a1*a3 + (carry from c3)
            //    < 2^(102 + 2*b + lg(5)) + 2^64.
            //
            // When b < 3 we get
            //
            // c4 < 2^110.33  so that carry < 2^59.33
            //
            // so that
            //
            // a[0] + carry * 19 < 2^51 + 19 * 2^59.33 < 2^63.58
            //
            // and there is no overflow.
            a[0] = a[0] + carry * 19;

            // Now a[1] < 2^51 + 2^(64 -51) = 2^51 + 2^13 < 2^(51 + epsilon).
            a[1] += a[0] >> 51;
            a[0] &= LOW_51_BIT_MASK;

            // Now all a[i] < 2^(51 + epsilon) and a = self^(2^k).

            k = k - 1;
            if k == 0 {
                break;
            }
        }

        FieldElem51(a)
    }
        */
        k = Math.abs(k);
        var a = this.bytes.slice();
        while (true) {
            var a3_19 = BigInt(19) * a[3];
            var a4_19 = BigInt(19) * a[4];
            var c0 = (a[0] * a[0]) + BigInt(2) * ((a[1] * a4_19) + (a[2] * a3_19));
            var c1 = (a[3] * a3_19) + BigInt(2) * ((a[0] * a[1]) + (a[2] * a4_19));
            var c2 = (a[1] * a[1]) + BigInt(2) * ((a[0] * a[2]) + (a[4] * a3_19));
            var c3 = (a[4] * a4_19) + BigInt(2) * ((a[0] * a[3]) + (a[1] * a[2]));
            var c4 = (a[2] * a[2]) + BigInt(2) * ((a[0] * a[4]) + (a[1] * a[3]));
            c1 += (c0 >> _51n);
            a[0] = c0 & LOW_51_BIT_MASK;
            c2 += (c1 >> _51n);
            a[1] = c1 & LOW_51_BIT_MASK;
            c3 += (c2 >> _51n);
            a[2] = c2 & LOW_51_BIT_MASK;
            c4 += (c3 >> _51n);
            a[3] = c3 & LOW_51_BIT_MASK;
            var carry = (c4 >> _51n);
            a[4] = c4 & LOW_51_BIT_MASK;
            a[0] = a[0] + carry * BigInt(19);
            a[1] += a[0] >> _51n;
            a[0] &= LOW_51_BIT_MASK;
            k = k - 1;
            if (k === 0)
                break;
        }
        return new FieldElem51(a);
    };
    FieldElem51.prototype.square2 = function () {
        var square = this.pow2k(1);
        // for i in 0..5 {
        //     square.0[i] *= 2;
        // }
        for (var i = 0; i < 5; i++) {
            square.bytes[i] *= BigInt(2);
        }
        return square;
    };
    /*
    fn add_assign(&mut self, _rhs: &'b FieldElem51) {
        for i in 0..5 {
            self.0[i] += _rhs.0[i];
        }
    }
    add(self, _rhs: &'b FieldElem51) -> FieldElem51 {
        let mut output = *self;
        output += _rhs;
        output
    }
    */
    FieldElem51.prototype.add = function (_rhs) {
        var output = this.bytes.slice();
        for (var i = 0; i < 5; i++) {
            output[i] += _rhs.bytes[i];
        }
        return new FieldElem51(output);
    };
    /*
    /// Given 64-bit input limbs, reduce to enforce the bound 2^(51 + epsilon).
    #[inline(always)]
    fn reduce(mut limbs: [u64; 5]) -> FieldElem51 {
        const LOW_51_BIT_MASK: u64 = (1u64 << 51) - 1;

        // Since the input limbs are bounded by 2^64, the biggest
        // carry-out is bounded by 2^13.
        //
        // The biggest carry-in is c4 * 19, resulting in
        //
        // 2^51 + 19*2^13 < 2^51.0000000001
        //
        // Because we don't need to canonicalize, only to reduce the
        // limb sizes, it's OK to do a "weak reduction", where we
        // compute the carry-outs in parallel.

        let c0 = limbs[0] >> 51;
        let c1 = limbs[1] >> 51;
        let c2 = limbs[2] >> 51;
        let c3 = limbs[3] >> 51;
        let c4 = limbs[4] >> 51;

        limbs[0] &= LOW_51_BIT_MASK;
        limbs[1] &= LOW_51_BIT_MASK;
        limbs[2] &= LOW_51_BIT_MASK;
        limbs[3] &= LOW_51_BIT_MASK;
        limbs[4] &= LOW_51_BIT_MASK;

        limbs[0] += c4 * 19;
        limbs[1] += c0;
        limbs[2] += c1;
        limbs[3] += c2;
        limbs[4] += c3;

        FieldElem51(limbs)
    }
    */
    FieldElem51.reduce = function (limbs) {
        var c0 = limbs[0] >> _51n;
        var c1 = limbs[1] >> _51n;
        var c2 = limbs[2] >> _51n;
        var c3 = limbs[3] >> _51n;
        var c4 = limbs[4] >> _51n;
        limbs[0] &= LOW_51_BIT_MASK;
        limbs[1] &= LOW_51_BIT_MASK;
        limbs[2] &= LOW_51_BIT_MASK;
        limbs[3] &= LOW_51_BIT_MASK;
        limbs[4] &= LOW_51_BIT_MASK;
        limbs[0] += c4 * BigInt(19);
        limbs[1] += c0;
        limbs[2] += c1;
        limbs[3] += c2;
        limbs[4] += c3;
        return new FieldElem51(limbs);
    };
    /*
    fn sub_assign(&mut self, _rhs: &'b FieldElem51) {
        let result = (self as &FieldElem51) - _rhs;
        self.0 = result.0;
    }
    type Output = FieldElem51;
    fn sub(self, _rhs: &'b FieldElem51) -> FieldElem51 {
        // To avoid underflow, first add a multiple of p.
        // Choose 16*p = p << 4 to be larger than 54-bit _rhs.
        //
        // If we could statically track the bitlengths of the limbs
        // of every FieldElem51, we could choose a multiple of p
        // just bigger than _rhs and avoid having to do a reduction.
        //
        // Since we don't yet have type-level integers to do this, we
        // have to add an explicit reduction call here.
        FieldElem51::reduce([
            (self.0[0] + 36028797018963664u64) - _rhs.0[0],
            (self.0[1] + 36028797018963952u64) - _rhs.0[1],
            (self.0[2] + 36028797018963952u64) - _rhs.0[2],
            (self.0[3] + 36028797018963952u64) - _rhs.0[3],
            (self.0[4] + 36028797018963952u64) - _rhs.0[4],
        ])
    }
    */
    FieldElem51.prototype.sub = function (_rhs) {
        return FieldElem51.reduce(new BigUint64Array([
            (this.bytes[0] + BigInt("36028797018963664")) - _rhs.bytes[0],
            (this.bytes[1] + BigInt("36028797018963952")) - _rhs.bytes[1],
            (this.bytes[2] + BigInt("36028797018963952")) - _rhs.bytes[2],
            (this.bytes[3] + BigInt("36028797018963952")) - _rhs.bytes[3],
            (this.bytes[4] + BigInt("36028797018963952")) - _rhs.bytes[4],
        ]));
    };
    /*
    fn mul_assign(&mut self, _rhs: &'b FieldElem51) {
        let result = (self as &FieldElem51) * _rhs;
        self.0 = result.0;
    }
    type Output = FieldElem51;
    fn mul(self, _rhs: &'b FieldElem51) -> FieldElem51 {
        /// Helper function to multiply two 64-bit integers with 128
        /// bits of output.
        #[inline(always)]
        fn m(x: u64, y: u64) -> u128 { (x as u128) * (y as u128) }

        // Alias self, _rhs for more readable formulas
        let a: &[u64; 5] = &self.0;
        let b: &[u64; 5] = &_rhs.0;

        // Precondition: assume input limbs a[i], b[i] are bounded as
        //
        // a[i], b[i] < 2^(51 + b)
        //
        // where b is a real parameter measuring the "bit excess" of the limbs.

        // 64-bit precomputations to avoid 128-bit multiplications.
        //
        // This fits into a u64 whenever 51 + b + lg(19) < 64.
        //
        // Since 51 + b + lg(19) < 51 + 4.25 + b
        //                       = 55.25 + b,
        // this fits if b < 8.75.
        let b1_19 = b[1] * 19;
        let b2_19 = b[2] * 19;
        let b3_19 = b[3] * 19;
        let b4_19 = b[4] * 19;

        // Multiply to get 128-bit coefficients of output
        let     c0: u128 = m(a[0],b[0]) + m(a[4],b1_19) + m(a[3],b2_19) + m(a[2],b3_19) + m(a[1],b4_19);
        let mut c1: u128 = m(a[1],b[0]) + m(a[0],b[1])  + m(a[4],b2_19) + m(a[3],b3_19) + m(a[2],b4_19);
        let mut c2: u128 = m(a[2],b[0]) + m(a[1],b[1])  + m(a[0],b[2])  + m(a[4],b3_19) + m(a[3],b4_19);
        let mut c3: u128 = m(a[3],b[0]) + m(a[2],b[1])  + m(a[1],b[2])  + m(a[0],b[3])  + m(a[4],b4_19);
        let mut c4: u128 = m(a[4],b[0]) + m(a[3],b[1])  + m(a[2],b[2])  + m(a[1],b[3])  + m(a[0],b[4]);

        // How big are the c[i]? We have
        //
        //    c[i] < 2^(102 + 2*b) * (1+i + (4-i)*19)
        //         < 2^(102 + lg(1 + 4*19) + 2*b)
        //         < 2^(108.27 + 2*b)
        //
        // The carry (c[i] >> 51) fits into a u64 when
        //    108.27 + 2*b - 51 < 64
        //    2*b < 6.73
        //    b < 3.365.
        //
        // So we require b < 3 to ensure this fits.
        debug_assert!(a[0] < (1 << 54)); debug_assert!(b[0] < (1 << 54));
        debug_assert!(a[1] < (1 << 54)); debug_assert!(b[1] < (1 << 54));
        debug_assert!(a[2] < (1 << 54)); debug_assert!(b[2] < (1 << 54));
        debug_assert!(a[3] < (1 << 54)); debug_assert!(b[3] < (1 << 54));
        debug_assert!(a[4] < (1 << 54)); debug_assert!(b[4] < (1 << 54));

        // Casting to u64 and back tells the compiler that the carry is
        // bounded by 2^64, so that the addition is a u128 + u64 rather
        // than u128 + u128.

        const LOW_51_BIT_MASK: u64 = (1u64 << 51) - 1;
        let mut out = [0u64; 5];

        c1 += ((c0 >> 51) as u64) as u128;
        out[0] = (c0 as u64) & LOW_51_BIT_MASK;

        c2 += ((c1 >> 51) as u64) as u128;
        out[1] = (c1 as u64) & LOW_51_BIT_MASK;

        c3 += ((c2 >> 51) as u64) as u128;
        out[2] = (c2 as u64) & LOW_51_BIT_MASK;

        c4 += ((c3 >> 51) as u64) as u128;
        out[3] = (c3 as u64) & LOW_51_BIT_MASK;

        let carry: u64 = (c4 >> 51) as u64;
        out[4] = (c4 as u64) & LOW_51_BIT_MASK;

        // To see that this does not overflow, we need out[0] + carry * 19 < 2^64.
        //
        // c4 < a0*b4 + a1*b3 + a2*b2 + a3*b1 + a4*b0 + (carry from c3)
        //    < 5*(2^(51 + b) * 2^(51 + b)) + (carry from c3)
        //    < 2^(102 + 2*b + lg(5)) + 2^64.
        //
        // When b < 3 we get
        //
        // c4 < 2^110.33  so that carry < 2^59.33
        //
        // so that
        //
        // out[0] + carry * 19 < 2^51 + 19 * 2^59.33 < 2^63.58
        //
        // and there is no overflow.
        out[0] = out[0] + carry * 19;

        // Now out[1] < 2^51 + 2^(64 -51) = 2^51 + 2^13 < 2^(51 + epsilon).
        out[1] += out[0] >> 51;
        out[0] &= LOW_51_BIT_MASK;

        // Now out[i] < 2^(51 + epsilon) for all i.
        FieldElem51(out)
    }
    */
    FieldElem51.prototype.mul = function (_rhs) {
        var a = this.bytes.slice();
        var b = _rhs.bytes.slice();
        var b1_19 = b[1] * BigInt(19);
        var b2_19 = b[2] * BigInt(19);
        var b3_19 = b[3] * BigInt(19);
        var b4_19 = b[4] * BigInt(19);
        var c0 = (a[0] * b[0]) + (a[4] * b1_19) + (a[3] * b2_19) + (a[2] * b3_19) + (a[1] * b4_19);
        var c1 = (a[1] * b[0]) + (a[0] * b[1]) + (a[4] * b2_19) + (a[3] * b3_19) + (a[2] * b4_19);
        var c2 = (a[2] * b[0]) + (a[1] * b[1]) + (a[0] * b[2]) + (a[4] * b3_19) + (a[3] * b4_19);
        var c3 = (a[3] * b[0]) + (a[2] * b[1]) + (a[1] * b[2]) + (a[0] * b[3]) + (a[4] * b4_19);
        var c4 = (a[4] * b[0]) + (a[3] * b[1]) + (a[2] * b[2]) + (a[1] * b[3]) + (a[0] * b[4]);
        var out = new BigUint64Array(5);
        c1 += (c0 >> _51n);
        out[0] = c0 & LOW_51_BIT_MASK;
        c2 += (c1 >> _51n);
        out[1] = c1 & LOW_51_BIT_MASK;
        c3 += (c2 >> _51n);
        out[2] = c2 & LOW_51_BIT_MASK;
        c4 += (c3 >> _51n);
        out[3] = c3 & LOW_51_BIT_MASK;
        var carry = (c4 >> _51n);
        out[4] = c4 & LOW_51_BIT_MASK;
        out[0] = out[0] + carry * BigInt(19);
        out[1] += out[0] >> _51n;
        out[0] &= LOW_51_BIT_MASK;
        return new FieldElem51(out);
    };
    /*
    pub fn invert(&self) -> FieldElement {
        // The bits of p-2 = 2^255 -19 -2 are 11010111111...11.
        //
        //                                 nonzero bits of exponent
        let (t19, t3) = self.pow22501();   // t19: 249..0 ; t3: 3,1,0
        let t20 = t19.pow2k(5);            // 254..5
        let t21 = &t20 * &t3;              // 254..5,3,1,0

        t21
    }
    */
    FieldElem51.prototype.invert = function () {
        var _a = __read(this.pow22501(), 2), t19 = _a[0], t3 = _a[1];
        var t20 = t19.pow2k(5);
        var t21 = t20.mul(t3);
        return t21;
    };
    /*
    /// Compute (self^(2^250-1), self^11), used as a helper function
    /// within invert() and pow22523().
    fn pow22501(&self) -> (FieldElement, FieldElement) {
        // Instead of managing which temporary variables are used
        // for what, we define as many as we need and leave stack
        // allocation to the compiler
        //
        // Each temporary variable t_i is of the form (self)^e_i.
        // Squaring t_i corresponds to multiplying e_i by 2,
        // so the pow2k function shifts e_i left by k places.
        // Multiplying t_i and t_j corresponds to adding e_i + e_j.
        //
        // Temporary t_i                      Nonzero bits of e_i
        //
        let t0  = self.square();           // 1         e_0 = 2^1
        let t1  = t0.square().square();    // 3         e_1 = 2^3
        let t2  = self * &t1;              // 3,0       e_2 = 2^3 + 2^0
        let t3  = &t0 * &t2;               // 3,1,0
        let t4  = t3.square();             // 4,2,1
        let t5  = &t2 * &t4;               // 4,3,2,1,0
        let t6  = t5.pow2k(5);             // 9,8,7,6,5
        let t7  = &t6 * &t5;               // 9,8,7,6,5,4,3,2,1,0
        let t8  = t7.pow2k(10);            // 19..10
        let t9  = &t8 * &t7;               // 19..0
        let t10 = t9.pow2k(20);            // 39..20
        let t11 = &t10 * &t9;              // 39..0
        let t12 = t11.pow2k(10);           // 49..10
        let t13 = &t12 * &t7;              // 49..0
        let t14 = t13.pow2k(50);           // 99..50
        let t15 = &t14 * &t13;             // 99..0
        let t16 = t15.pow2k(100);          // 199..100
        let t17 = &t16 * &t15;             // 199..0
        let t18 = t17.pow2k(50);           // 249..50
        let t19 = &t18 * &t13;             // 249..0

        (t19, t3)
    }
    */
    FieldElem51.prototype.pow22501 = function () {
        var t0 = this.square();
        var t1 = t0.square().square();
        var t2 = this.mul(t1);
        var t3 = t0.mul(t2);
        var t4 = t3.square();
        var t5 = t2.mul(t4);
        var t6 = t5.pow2k(5);
        var t7 = t6.mul(t5);
        var t8 = t7.pow2k(10);
        var t9 = t8.mul(t7);
        var t10 = t9.pow2k(20);
        var t11 = t10.mul(t9);
        var t12 = t11.pow2k(10);
        var t13 = t12.mul(t7);
        var t14 = t13.pow2k(50);
        var t15 = t14.mul(t13);
        var t16 = t15.pow2k(100);
        var t17 = t16.mul(t15);
        var t18 = t17.pow2k(50);
        var t19 = t18.mul(t13);
        return [t19, t3];
    };
    /*
    pub fn square(&self) -> FieldElem51 {
        self.pow2k(1)
    }
    */
    FieldElem51.prototype.square = function () {
        return this.pow2k(1);
    };
    /*
    /// Given `FieldElements` `u` and `v`, compute either `sqrt(u/v)`
    /// or `sqrt(i*u/v)` in constant time.
    ///
    /// This function always returns the nonnegative square root.
    ///
    /// # Return
    ///
    /// - `(Choice(1), +sqrt(u/v))  ` if `v` is nonzero and `u/v` is square;
    /// - `(Choice(1), zero)        ` if `u` is zero;
    /// - `(Choice(0), zero)        ` if `v` is zero and `u` is nonzero;
    /// - `(Choice(0), +sqrt(i*u/v))` if `u/v` is nonsquare (so `i*u/v` is square).
    ///
    pub fn sqrt_ratio_i(u: &FieldElement, v: &FieldElement) -> (Choice, FieldElement) {
        // Using the same trick as in ed25519 decoding, we merge the
        // inversion, the square root, and the square test as follows.
        //
        // To compute sqrt(α), we can compute β = α^((p+3)/8).
        // Then β^2 = ±α, so multiplying β by sqrt(-1) if necessary
        // gives sqrt(α).
        //
        // To compute 1/sqrt(α), we observe that
        //    1/β = α^(p-1 - (p+3)/8) = α^((7p-11)/8)
        //                            = α^3 * (α^7)^((p-5)/8).
        //
        // We can therefore compute sqrt(u/v) = sqrt(u)/sqrt(v)
        // by first computing
        //    r = u^((p+3)/8) v^(p-1-(p+3)/8)
        //      = u u^((p-5)/8) v^3 (v^7)^((p-5)/8)
        //      = (uv^3) (uv^7)^((p-5)/8).
        //
        // If v is nonzero and u/v is square, then r^2 = ±u/v,
        //                                     so vr^2 = ±u.
        // If vr^2 =  u, then sqrt(u/v) = r.
        // If vr^2 = -u, then sqrt(u/v) = r*sqrt(-1).
        //
        // If v is zero, r is also zero.

        let v3 = &v.square()  * v;
        let v7 = &v3.square() * v;
        let mut r = &(u * &v3) * &(u * &v7).pow_p58();
        let check = v * &r.square();

        let i = &constants::SQRT_M1;

        let correct_sign_sqrt   = check.ct_eq(        u);
        let flipped_sign_sqrt   = check.ct_eq(     &(-u));
        let flipped_sign_sqrt_i = check.ct_eq(&(&(-u)*i));

        let r_prime = &constants::SQRT_M1 * &r;
        r.conditional_assign(&r_prime, flipped_sign_sqrt | flipped_sign_sqrt_i);

        // Choose the nonnegative square root.
        let r_is_negative = r.is_negative();
        r.conditional_negate(r_is_negative);

        let was_nonzero_square = correct_sign_sqrt | flipped_sign_sqrt;

        (was_nonzero_square, r)
    }
    */
    FieldElem51.sqrt_ratio_i = function (u, v) {
        var v3 = v.square().mul(v);
        var v7 = v3.square().mul(v);
        var r = u.mul(v3).mul(u.mul(v7).pow_p58());
        var check = v.mul(r.square());
        var i = FieldElem51.SQRT_M1;
        var correct_sign_sqrt = check.ct_eq(u);
        var flipped_sign_sqrt = check.ct_eq(u.neg());
        var flipped_sign_sqrt_i = check.ct_eq(u.neg().mul(i));
        var r_prime = i.mul(r);
        r.conditional_assign(r_prime, flipped_sign_sqrt || flipped_sign_sqrt_i);
        // let r_is_negative = r.is_negative();
        r.conditional_negate(r.is_negative());
        var was_nonzero_square = correct_sign_sqrt || flipped_sign_sqrt;
        // `flipped_sign_sqrt_i` WAS NOT HERE IN THE ORIGINAL CODE
        // but otherwise I get the "Montgomery conversion to Edwards point in Elligator failed" error
        // || flipped_sign_sqrt_i;
        return [was_nonzero_square, r];
    };
    /*
    pub fn is_negative(&self) -> Choice {
        let bytes = self.to_bytes();
        (bytes[0] & 1).into()
    }
    */
    FieldElem51.prototype.is_negative = function () {
        return (this.toBytes()[0] & 1) === 1;
    };
    /*
    fn conditional_negate(&mut self, choice: Choice) {
        // Need to cast to eliminate mutability
        let self_neg: T = -(self as &T);
        self.conditional_assign(&self_neg, choice);
    }
    */
    FieldElem51.prototype.conditional_negate = function (choice) {
        var self_neg = this.neg();
        return this.conditional_assign(self_neg, choice);
        // the above should have been the proper implementation
        // however it was NOT negating for some reason
        // this implementation should be equivalent to the intended implementation
        // with the exception that it is not constant
        // const self_neg = this.neg();
        // if( choice ) (this as any).bytes = self_neg.bytes;
    };
    /*
    // `Choice` is just a `boolean` in a `u8`
    fn conditional_assign(&mut self, other: &FieldElem51, choice: Choice) {
        inner_conditional_assign( self.0[0], (&other.0[0], choice));
        inner_conditional_assign( self.0[1], (&other.0[1], choice));
        inner_conditional_assign( self.0[2], (&other.0[2], choice));
        inner_conditional_assign( self.0[3], (&other.0[3], choice));
        inner_conditional_assign( self.0[4], (&other.0[4], choice));
    }
    #[inline]
    fn inner_conditional_assign(&mut self, other: &Self, choice: Choice) {
        // if choice = 0, mask = (-0) = 0000...0000
        // if choice = 1, mask = (-1) = 1111...1111
        let mask = -(choice.unwrap_u8() as to_signed_int!($t)) as $t;
        *self ^= mask & (*self ^ *other);
    }
    */
    FieldElem51.prototype.conditional_assign = function (other, choice) {
        this.bytes[0] = innerConditionalAssign(this.bytes[0], other.bytes[0], choice);
        this.bytes[1] = innerConditionalAssign(this.bytes[1], other.bytes[1], choice);
        this.bytes[2] = innerConditionalAssign(this.bytes[2], other.bytes[2], choice);
        this.bytes[3] = innerConditionalAssign(this.bytes[3], other.bytes[3], choice);
        this.bytes[4] = innerConditionalAssign(this.bytes[4], other.bytes[4], choice);
        // the above was giving problems
        // I'm not sure this is constant time
        // but it should at least be close to it
        // if( choice ) (this as any).bytes = other.bytes.slice();
        // else (this as any).bytes = this.bytes.slice();
        // return this;
    };
    FieldElem51.prototype.clone = function () {
        return new FieldElem51(this.bytes.slice());
    };
    /*
    fn neg(self) -> FieldElem51 {
        let mut output = *self;
        output.negate();
        output
    }
    */
    FieldElem51.prototype.neg = function () {
        var output = this.clone();
        return output.negate();
    };
    /*
    pub fn negate(&mut self) {
        // See commentary in the Sub impl
        let neg = FieldElem51::reduce([
            36028797018963664u64 - self.0[0],
            36028797018963952u64 - self.0[1],
            36028797018963952u64 - self.0[2],
            36028797018963952u64 - self.0[3],
            36028797018963952u64 - self.0[4],
        ]);
        self.0 = neg.0;
    }
    */
    FieldElem51.prototype.negate = function () {
        return FieldElem51.reduce(new BigUint64Array([
            BigInt("36028797018963664") - this.bytes[0],
            BigInt("36028797018963952") - this.bytes[1],
            BigInt("36028797018963952") - this.bytes[2],
            BigInt("36028797018963952") - this.bytes[3],
            BigInt("36028797018963952") - this.bytes[4],
        ]));
    };
    /*
    /// Test equality between two `FieldElement`s.  Since the
    /// internal representation is not canonical, the field elements
    /// are normalized to wire format before comparison.
    fn ct_eq(&self, other: &FieldElement) -> Choice {
        self.to_bytes().ct_eq(&other.to_bytes())
    }
    */
    FieldElem51.prototype.ct_eq = function (other) {
        return (0, uint8array_utils_1.uint8ArrayEq)(this.toBytes(), other.toBytes());
    };
    Object.defineProperty(FieldElem51, "SQRT_M1", {
        get: function () {
            return new FieldElem51(new BigUint64Array([
                BigInt("1718705420411056"),
                BigInt("234908883556509"),
                BigInt("2233514472574048"),
                BigInt("2117202627021982"),
                BigInt("765476049583133"),
            ]));
        },
        enumerable: false,
        configurable: true
    });
    /*
    /// Raise this field element to the power (p-5)/8 = 2^252 -3.
    fn pow_p58(&self) -> FieldElement {
        // The bits of (p-5)/8 are 101111.....11.
        //
        //                                 nonzero bits of exponent
        let (t19, _) = self.pow22501();    // 249..0
        let t20 = t19.pow2k(2);            // 251..2
        let t21 = self * &t20;             // 251..2,0

        t21
    }
    */
    FieldElem51.prototype.pow_p58 = function () {
        var _a = __read(this.pow22501(), 2), t19 = _a[0], _ = _a[1];
        var t20 = t19.pow2k(2);
        var t21 = this.mul(t20);
        return t21;
    };
    /*
    // Serialize this `FieldElem51` to a 32-byte array.  The
    /// encoding is canonical.
    pub fn to_bytes(&self) -> [u8; 32] {
        // Let h = limbs[0] + limbs[1]*2^51 + ... + limbs[4]*2^204.
        //
        // Write h = pq + r with 0 <= r < p.
        //
        // We want to compute r = h mod p.
        //
        // If h < 2*p = 2^256 - 38,
        // then q = 0 or 1,
        //
        // with q = 0 when h < p
        //  and q = 1 when h >= p.
        //
        // Notice that h >= p <==> h + 19 >= p + 19 <==> h + 19 >= 2^255.
        // Therefore q can be computed as the carry bit of h + 19.

        // First, reduce the limbs to ensure h < 2*p.
        let mut limbs = FieldElem51::reduce(self.0).0;

        let mut q = (limbs[0] + 19) >> 51;
        q = (limbs[1] + q) >> 51;
        q = (limbs[2] + q) >> 51;
        q = (limbs[3] + q) >> 51;
        q = (limbs[4] + q) >> 51;

        // Now we can compute r as r = h - pq = r - (2^255-19)q = r + 19q - 2^255q

        limbs[0] += 19*q;

        // Now carry the result to compute r + 19q ...
        let low_51_bit_mask = (1u64 << 51) - 1;
        limbs[1] +=  limbs[0] >> 51;
        limbs[0] = limbs[0] & low_51_bit_mask;
        limbs[2] +=  limbs[1] >> 51;
        limbs[1] = limbs[1] & low_51_bit_mask;
        limbs[3] +=  limbs[2] >> 51;
        limbs[2] = limbs[2] & low_51_bit_mask;
        limbs[4] +=  limbs[3] >> 51;
        limbs[3] = limbs[3] & low_51_bit_mask;
        // ... but instead of carrying (limbs[4] >> 51) = 2^255q
        // into another limb, discard it, subtracting the value
        limbs[4] = limbs[4] & low_51_bit_mask;

        // Now arrange the bits of the limbs.
        let mut s = [0u8;32];
        s[ 0] =   limbs[0]        as u8;
        s[ 1] =  (limbs[0] >>  8) as u8;
        s[ 2] =  (limbs[0] >> 16) as u8;
        s[ 3] =  (limbs[0] >> 24) as u8;
        s[ 4] =  (limbs[0] >> 32) as u8;
        s[ 5] =  (limbs[0] >> 40) as u8;
        s[ 6] = ((limbs[0] >> 48) | (limbs[1] << 3)) as u8;
        s[ 7] =  (limbs[1] >>  5) as u8;
        s[ 8] =  (limbs[1] >> 13) as u8;
        s[ 9] =  (limbs[1] >> 21) as u8;
        s[10] =  (limbs[1] >> 29) as u8;
        s[11] =  (limbs[1] >> 37) as u8;
        s[12] = ((limbs[1] >> 45) | (limbs[2] << 6)) as u8;
        s[13] =  (limbs[2] >>  2) as u8;
        s[14] =  (limbs[2] >> 10) as u8;
        s[15] =  (limbs[2] >> 18) as u8;
        s[16] =  (limbs[2] >> 26) as u8;
        s[17] =  (limbs[2] >> 34) as u8;
        s[18] =  (limbs[2] >> 42) as u8;
        s[19] = ((limbs[2] >> 50) | (limbs[3] << 1)) as u8;
        s[20] =  (limbs[3] >>  7) as u8;
        s[21] =  (limbs[3] >> 15) as u8;
        s[22] =  (limbs[3] >> 23) as u8;
        s[23] =  (limbs[3] >> 31) as u8;
        s[24] =  (limbs[3] >> 39) as u8;
        s[25] = ((limbs[3] >> 47) | (limbs[4] << 4)) as u8;
        s[26] =  (limbs[4] >>  4) as u8;
        s[27] =  (limbs[4] >> 12) as u8;
        s[28] =  (limbs[4] >> 20) as u8;
        s[29] =  (limbs[4] >> 28) as u8;
        s[30] =  (limbs[4] >> 36) as u8;
        s[31] =  (limbs[4] >> 44) as u8;

        // High bit should be zero.
        debug_assert!((s[31] & 0b1000_0000u8) == 0u8);

        s
    }
    */
    FieldElem51.prototype.toBytes = function () {
        var limbs = FieldElem51.reduce(this.bytes).bytes.slice();
        var q = (limbs[0] + BigInt(19)) >> _51n;
        q = (limbs[1] + q) >> _51n;
        q = (limbs[2] + q) >> _51n;
        q = (limbs[3] + q) >> _51n;
        q = (limbs[4] + q) >> _51n;
        limbs[0] += BigInt(19) * q;
        limbs[1] += limbs[0] >> _51n;
        limbs[0] &= LOW_51_BIT_MASK;
        limbs[2] += limbs[1] >> _51n;
        limbs[1] &= LOW_51_BIT_MASK;
        limbs[3] += limbs[2] >> _51n;
        limbs[2] &= LOW_51_BIT_MASK;
        limbs[4] += limbs[3] >> _51n;
        limbs[3] &= LOW_51_BIT_MASK;
        limbs[4] &= LOW_51_BIT_MASK;
        var s = new Uint8Array(32);
        // DO NOT TRY TO DO SMART THINGS
        //
        // DO NOT USE `DataView` OR OTHER BULLSHIT
        // 
        // THIS IS THE CODE AND THIS WE KEEP
        // IT MIGHT SEEM IT IS JUST SHIFITNG THE BITS TO ALLIGN TO THE BYTES
        // !!! BUT IT IS NOT !!!
        // SOME ELEMENTS ARE SHIFTED BY STRANGE NUMBERS
        s[0] = Number(limbs[0] & BigInt(0xff));
        s[1] = Number((limbs[0] >> BigInt(8)) & BigInt(0xff));
        s[2] = Number((limbs[0] >> BigInt(16)) & BigInt(0xff));
        s[3] = Number((limbs[0] >> BigInt(24)) & BigInt(0xff));
        s[4] = Number((limbs[0] >> BigInt(32)) & BigInt(0xff));
        s[5] = Number((limbs[0] >> BigInt(40)) & BigInt(0xff));
        s[6] = Number((limbs[0] >> BigInt(48)) | (limbs[1] << BigInt(3)) & BigInt(0xff));
        s[7] = Number((limbs[1] >> BigInt(5)) & BigInt(0xff));
        s[8] = Number((limbs[1] >> BigInt(13)) & BigInt(0xff));
        s[9] = Number((limbs[1] >> BigInt(21)) & BigInt(0xff));
        s[10] = Number((limbs[1] >> BigInt(29)) & BigInt(0xff));
        s[11] = Number((limbs[1] >> BigInt(37)) & BigInt(0xff));
        s[12] = Number((limbs[1] >> BigInt(45)) | (limbs[2] << BigInt(6)) & BigInt(0xff));
        s[13] = Number((limbs[2] >> BigInt(2)) & BigInt(0xff));
        s[14] = Number((limbs[2] >> BigInt(10)) & BigInt(0xff));
        s[15] = Number((limbs[2] >> BigInt(18)) & BigInt(0xff));
        s[16] = Number((limbs[2] >> BigInt(26)) & BigInt(0xff));
        s[17] = Number((limbs[2] >> BigInt(34)) & BigInt(0xff));
        s[18] = Number((limbs[2] >> BigInt(42)) & BigInt(0xff));
        s[19] = Number((limbs[2] >> BigInt(50)) | (limbs[3] << _1n) & BigInt(0xff));
        s[20] = Number((limbs[3] >> BigInt(7)) & BigInt(0xff));
        s[21] = Number((limbs[3] >> BigInt(15)) & BigInt(0xff));
        s[22] = Number((limbs[3] >> BigInt(23)) & BigInt(0xff));
        s[23] = Number((limbs[3] >> BigInt(31)) & BigInt(0xff));
        s[24] = Number((limbs[3] >> BigInt(39)) & BigInt(0xff));
        s[25] = Number((limbs[3] >> BigInt(47)) | (limbs[4] << BigInt(4)) & BigInt(0xff));
        s[26] = Number((limbs[4] >> BigInt(4)) & BigInt(0xff));
        s[27] = Number((limbs[4] >> BigInt(12)) & BigInt(0xff));
        s[28] = Number((limbs[4] >> BigInt(20)) & BigInt(0xff));
        s[29] = Number((limbs[4] >> BigInt(28)) & BigInt(0xff));
        s[30] = Number((limbs[4] >> BigInt(36)) & BigInt(0xff));
        s[31] = Number((limbs[4] >> BigInt(44)) & BigInt(0xff));
        return s;
    };
    return FieldElem51;
}());
exports.FieldElem51 = FieldElem51;
var MontgomeryPoint = /** @class */ (function () {
    function MontgomeryPoint(bytes) {
        this.bytes = bytes;
    }
    /*
    pub fn to_edwards(&self, sign: u8) -> Option<EdwardsPoint> {
        // To decompress the Montgomery u coordinate to an
        // `EdwardsPoint`, we apply the birational map to obtain the
        // Edwards y coordinate, then do Edwards decompression.
        //
        // The birational map is y = (u-1)/(u+1).
        //
        // The exceptional points are the zeros of the denominator,
        // i.e., u = -1.
        //
        // But when u = -1, v^2 = u*(u^2+486662*u+1) = 486660.
        //
        // Since this is nonsquare mod p, u = -1 corresponds to a point
        // on the twist, not the curve, so we can reject it early.

        let u = FieldElement::from_bytes(&self.0);

        if u == FieldElement::minus_one() { return None; }

        let one = FieldElement::one();

        let y = &(&u - &one) * &(&u + &one).invert();

        let mut y_bytes = y.to_bytes();
        y_bytes[31] ^= sign << 7;

        CompressedEdwardsY(y_bytes).decompress()
    }
    */
    MontgomeryPoint.prototype.to_edwards = function (sign_bit) {
        var u = FieldElem51.fromBytes(this.bytes);
        if (u.ct_eq(FieldElem51.minus_one()))
            return undefined;
        var one = FieldElem51.one();
        var y = u.sub(one).mul(u.add(one).invert());
        var y_bytes = y.toBytes();
        y_bytes[31] ^= sign_bit << 7;
        return decompressCompressedEdwardsY(y_bytes);
    };
    return MontgomeryPoint;
}());
exports.MontgomeryPoint = MontgomeryPoint;
/*
fn optional_multiscalar_mul<I, J>(scalars: I, points: J) -> Option<EdwardsPoint>
    where
        I: IntoIterator,
        I::Item: Borrow<Scalar>,
        J: IntoIterator<Item = Option<EdwardsPoint>>,
    {
        use backend::serial::curve_models::{CompletedPoint, ProjectiveNielsPoint, ProjectivePoint};
        use window::NafLookupTable5;
        use traits::Identity;

        let nafs: Vec<_> = scalars
            .into_iter()
            .map(|c| c.borrow().non_adjacent_form(5))
            .collect();

        let lookup_tables = points
            .into_iter()
            .map(|P_opt| P_opt.map(|P| NafLookupTable5::<ProjectiveNielsPoint>::from(&P)))
            .collect::<Option<Vec<_>>>()?;

        let mut r = ProjectivePoint::identity();

        for i in (0..256).rev() {
            let mut t: CompletedPoint = r.double();

            for (naf, lookup_table) in nafs.iter().zip(lookup_tables.iter()) {
                if naf[i] > 0 {
                    t = &t.to_extended() + &lookup_table.select(naf[i] as usize);
                } else if naf[i] < 0 {
                    t = &t.to_extended() - &lookup_table.select(-naf[i] as usize);
                }
            }

            r = t.to_projective();
        }

        Some(r.to_extended())
    }
*/
function straus_optional_multiscalar_mul(scalars, points) {
    var nafs = scalars.map(function (s) { return scalar_non_adjacent_form(s, 5); });
    var lookupTables = points.map(function (p) { return NafLookupTable.fromEdwardsPoint(p); });
    var r = ProjectivePoint.IDENTITY;
    for (var i = 255; i >= 0; i--) {
        var t = r.double();
        for (var j = 0; j < nafs.length; j++) {
            var naf = nafs[j];
            var lookupTable = lookupTables[j];
            if (naf[i] > 0)
                t = t.toExtended().addProjectiveNiels(lookupTable.select(naf[i]));
            else if (naf[i] < 0)
                t = t.toExtended().subProjectiveNiels(lookupTable.select(-naf[i]));
            r = t.toProjective();
        }
        r = t.toProjective();
    }
    return r.toExtended();
}
/*
fn optional_multiscalar_mul<I, J>(scalars: I, points: J) -> Option<EdwardsPoint>
    where
        I: IntoIterator,
        I::Item: Borrow<Scalar>,
        J: IntoIterator<Item = Option<EdwardsPoint>>,
    {
        use traits::Identity;

        let mut scalars = scalars.into_iter();
        let size = scalars.by_ref().size_hint().0;

        // Digit width in bits. As digit width grows,
        // number of point additions goes down, but amount of
        // buckets and bucket additions grows exponentially.
        let w = if size < 500 {
            6
        } else if size < 800 {
            7
        } else {
            8
        };

        let max_digit: usize = 1 << w;
        let digits_count: usize = Scalar::to_radix_2w_size_hint(w);
        let buckets_count: usize = max_digit / 2; // digits are signed+centered hence 2^w/2, excluding 0-th bucket

        // Collect optimized scalars and points in buffers for repeated access
        // (scanning the whole set per digit position).
        let scalars = scalars
            .map(|s| s.borrow().to_radix_2w(w));

        let points = points
            .into_iter()
            .map(|p| p.map(|P| P.to_projective_niels()));

        let scalars_points = scalars
            .zip(points)
            .map(|(s, maybe_p)| maybe_p.map(|p| (s, p)))
            .collect::<Option<Vec<_>>>()?;

        // Prepare 2^w/2 buckets.
        // buckets[i] corresponds to a multiplication factor (i+1).
        let mut buckets: Vec<_> = (0..buckets_count)
            .map(|_| EdwardsPoint::identity())
            .collect();

        let mut columns = (0..digits_count).rev().map(|digit_index| {
            // Clear the buckets when processing another digit.
            for i in 0..buckets_count {
                buckets[i] = EdwardsPoint::identity();
            }

            // Iterate over pairs of (point, scalar)
            // and add/sub the point to the corresponding bucket.
            // Note: if we add support for precomputed lookup tables,
            // we'll be adding/subtracting point premultiplied by `digits[i]` to buckets[0].
            for (digits, pt) in scalars_points.iter() {
                // Widen digit so that we don't run into edge cases when w=8.
                let digit = digits[digit_index] as i16;
                if digit > 0 {
                    let b = (digit - 1) as usize;
                    buckets[b] = (&buckets[b] + pt).to_extended();
                } else if digit < 0 {
                    let b = (-digit - 1) as usize;
                    buckets[b] = (&buckets[b] - pt).to_extended();
                }
            }

            // Add the buckets applying the multiplication factor to each bucket.
            // The most efficient way to do that is to have a single sum with two running sums:
            // an intermediate sum from last bucket to the first, and a sum of intermediate sums.
            //
            // For example, to add buckets 1*A, 2*B, 3*C we need to add these points:
            //   C
            //   C B
            //   C B A   Sum = C + (C+B) + (C+B+A)
            let mut buckets_intermediate_sum = buckets[buckets_count - 1];
            let mut buckets_sum = buckets[buckets_count - 1];
            for i in (0..(buckets_count - 1)).rev() {
                buckets_intermediate_sum += buckets[i];
                buckets_sum += buckets_intermediate_sum;
            }

            buckets_sum
        });

        // Take the high column as an initial value to avoid wasting time doubling the identity element in `fold()`.
        // `unwrap()` always succeeds because we know we have more than zero digits.
        let hi_column = columns.next().unwrap();

        Some(
            columns
                .fold(hi_column, |total, p| total.mul_by_pow_2(w as u32) + p),
        )
    }
}
*/
function pippenger_optional_multiscalar_mul(scalars, points) {
    var size = scalars.length;
    var w = size < 500 ? 6 : size < 800 ? 7 : 8;
    var max_digit = 1 << w;
    var digits_count = scalar_to_radix_2w_size_hint(w);
    var buckets_count = (max_digit / 2) >>> 0;
    var scalras_digits = scalars.map(function (s) { return scalar_to_radix_2w(s, w); });
    var points_proj = points.map(function (p) { return p.toProjectiveNiels(); });
    // zipped
    var scalars_points = scalras_digits.map(function (s, i) { return [s, points_proj[i]]; });
    // all elems will be replaced in `columns` loop, just a temp value
    var buckets = new Array(buckets_count).fill(EdwardsPoint.IDENTITY);
    var columns = new Array(buckets_count).fill(0).map(function () { return EdwardsPoint.IDENTITY; });
    for (var i = digits_count - 1; i >= 0; i--) {
        for (var j = 0; j < buckets_count; j++)
            buckets[j] = EdwardsPoint.IDENTITY;
        for (var j = 0; j < scalars_points.length; j++) {
            var _a = __read(scalars_points[j], 2), digits = _a[0], pt = _a[1];
            var digit = digits[i];
            if (digit > 0) {
                var b = digit - 1;
                buckets[b] = buckets[b].addProjectiveNiels(pt).toExtended();
            }
            else if (digit < 0) {
                var b = -digit - 1;
                buckets[b] = buckets[b].subProjectiveNiels(pt).toExtended();
            }
        }
        var buckets_intermediate_sum = buckets[buckets_count - 1];
        var buckets_sum = buckets[buckets_count - 1];
        for (var j = buckets_count - 2; j >= 0; j--) {
            buckets_intermediate_sum = buckets_intermediate_sum.add(buckets[j]);
            buckets_sum = buckets_sum.add(buckets_intermediate_sum);
        }
        columns[i] = buckets_sum;
    }
    // const hi_column = columns[ columns.length - 1 ];
    return columns.reduce(function (total, p) { return total.mulByPow2(w).add(p); });
}
function scalar_to_radix_2w_size_hint(w) {
    return (((256 + w - 1) / w) >>> 0) + (w >= 8 ? 1 : 0);
}
/*
pub(crate) fn to_radix_2w(&self, w: usize) -> [i8; 64] {
        debug_assert!(w >= 4);
        debug_assert!(w <= 8);

        if w == 4 {
            return self.to_radix_16();
        }

        use byteorder::{ByteOrder, LittleEndian};

        // Scalar formatted as four `u64`s with carry bit packed into the highest bit.
        let mut scalar64x4 = [0u64; 4];
        LittleEndian::read_u64_into(&self.bytes, &mut scalar64x4[0..4]);

        let radix: u64 = 1 << w;
        let window_mask: u64 = radix - 1;

        let mut carry = 0u64;
        let mut digits = [0i8; 64];
        let digits_count = (256 + w - 1)/w as usize;
        for i in 0..digits_count {
            // Construct a buffer of bits of the scalar, starting at `bit_offset`.
            let bit_offset = i*w;
            let u64_idx = bit_offset / 64;
            let bit_idx = bit_offset % 64;

            // Read the bits from the scalar
            let bit_buf: u64;
            if bit_idx < 64 - w  || u64_idx == 3 {
                // This window's bits are contained in a single u64,
                // or it's the last u64 anyway.
                bit_buf = scalar64x4[u64_idx] >> bit_idx;
            } else {
                // Combine the current u64's bits with the bits from the next u64
                bit_buf = (scalar64x4[u64_idx] >> bit_idx) | (scalar64x4[1+u64_idx] << (64 - bit_idx));
            }

            // Read the actual coefficient value from the window
            let coef = carry + (bit_buf & window_mask); // coef = [0, 2^r)

             // Recenter coefficients from [0,2^w) to [-2^w/2, 2^w/2)
            carry = (coef + (radix/2) as u64) >> w;
            digits[i] = ((coef as i64) - (carry << w) as i64) as i8;
        }

        // When w < 8, we can fold the final carry onto the last digit d,
        // because d < 2^w/2 so d + carry*2^w = d + 1*2^w < 2^(w+1) < 2^8.
        //
        // When w = 8, we can't fit carry*2^w into an i8.  This should
        // not happen anyways, because the final carry will be 0 for
        // reduced scalars, but the Scalar invariant allows 255-bit scalars.
        // To handle this, we expand the size_hint by 1 when w=8,
        // and accumulate the final carry onto another digit.
        match w {
            8 => digits[digits_count] += carry as i8,
            _ => digits[digits_count-1] += (carry << w) as i8,
        }

        digits
    }
*/
function scalar_to_radix_2w(scalar, w) {
    if (w === 4)
        return scalar_to_radix_16(scalar);
    var scalar64x4 = new BigUint64Array(4);
    read_u64_into_LE(scalar, scalar64x4);
    var radix = BigInt(1 << w);
    var window_mask = radix - _1n;
    var carry = _0n;
    var digits = new Int8Array(64);
    var u8digits = new Uint8Array(digits.buffer);
    var digits_count = (((256 + w - 1) / w) >>> 0);
    for (var i = 0; i < digits_count; i++) {
        var bit_offset = i * w;
        var u64_idx = (bit_offset / 64) >>> 0;
        var bit_idx = BigInt(bit_offset % 64);
        var bit_buf = void 0;
        if (bit_idx < 64 - w || u64_idx === 3)
            bit_buf = scalar64x4[u64_idx] >> bit_idx;
        else
            bit_buf = (scalar64x4[u64_idx] >> bit_idx) | ((scalar64x4[1 + u64_idx] << (_64n - bit_idx)) & LOW_64_BIT_MASK);
        var coef = (carry + (bit_buf & window_mask) & LOW_64_BIT_MASK);
        carry = ((coef + (radix >> _1n)) / radix) & LOW_64_BIT_MASK;
        u8digits[i] = Number((coef - (carry * radix))) & 0xff;
    }
    if (w === 8)
        u8digits[digits_count] = (u8digits[digits_count] + Number(carry)) & 0xff;
    else
        u8digits[digits_count - 1] = (u8digits[digits_count - 1] + (Number(carry) << w)) & 0xff;
    return digits;
}
var EdwardsPoint = /** @class */ (function () {
    function EdwardsPoint(X, Y, Z, T) {
        this.X = X;
        this.Y = Y;
        this.Z = Z;
        this.T = T;
    }
    /*
    /// Compute \\([2\^k] P \\) by successive doublings. Requires \\( k > 0 \\).
    pub(crate) fn mul_by_pow_2(&self, k: u32) -> EdwardsPoint {
        debug_assert!( k > 0 );
        let mut r: CompletedPoint;
        let mut s = self.to_projective();
        for _ in 0..(k-1) {
            r = s.double(); s = r.to_projective();
        }
        // Unroll last iteration so we can go directly to_extended()
        s.double().to_extended()
    }
    */
    EdwardsPoint.prototype.mulByPow2 = function (k) {
        if (k <= 0)
            throw new Error("k must be > 0");
        var r;
        var s = this.toProjective();
        for (var i = 0; i < k - 1; i++) {
            r = s.double();
            s = r.toProjective();
        }
        return s.double().toExtended();
    };
    EdwardsPoint.prototype.equals = function (other) {
        return this.X.ct_eq(other.X)
            && this.Y.ct_eq(other.Y)
            && this.Z.ct_eq(other.Z)
            && this.T.ct_eq(other.T);
    };
    Object.defineProperty(EdwardsPoint, "DOUBLE_BASE_COMPRESSED", {
        get: function () {
            return new Uint8Array([0xc9, 0xa3, 0xf8, 0x6a, 0xae, 0x46, 0x5f, 0xe,
                0x56, 0x51, 0x38, 0x64, 0x51, 0x0f, 0x39, 0x97,
                0x56, 0x1f, 0xa2, 0xc9, 0xe8, 0x5e, 0xa2, 0x1d,
                0xc2, 0x29, 0x23, 0x09, 0xf3, 0xcd, 0x60, 0x22]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EdwardsPoint, "BASEPOINT_ED25519_COMPRESSED", {
        get: function () {
            return new Uint8Array([0x58, 0x66, 0x66, 0x66, 0x66, 0x66, 0x66, 0x66,
                0x66, 0x66, 0x66, 0x66, 0x66, 0x66, 0x66, 0x66,
                0x66, 0x66, 0x66, 0x66, 0x66, 0x66, 0x66, 0x66,
                0x66, 0x66, 0x66, 0x66, 0x66, 0x66, 0x66, 0x66]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EdwardsPoint, "BASEPOINT_ED25519", {
        get: function () {
            return new EdwardsPoint(new FieldElem51(new BigUint64Array([
                BigInt("1738742601995546"),
                BigInt("1146398526822698"),
                BigInt("2070867633025821"),
                BigInt("562264141797630"),
                BigInt("587772402128613"),
            ])), new FieldElem51(new BigUint64Array([
                BigInt("1801439850948184"),
                BigInt("1351079888211148"),
                BigInt("450359962737049"),
                BigInt("900719925474099"),
                BigInt("1801439850948198"),
            ])), new FieldElem51(new BigUint64Array([
                BigInt("1"),
                BigInt("0"),
                BigInt("0"),
                BigInt("0"),
                BigInt("0")
            ])), new FieldElem51(new BigUint64Array([
                BigInt("1841354044333475"),
                BigInt("16398895984059"),
                BigInt("755974180946558"),
                BigInt("900171276175154"),
                BigInt("1821297809914039"),
            ])));
        },
        enumerable: false,
        configurable: true
    });
    EdwardsPoint.prototype.is_valid = function () {
        var on_curve = this.toProjective().is_valid();
        var on_ceger_image = this.X.mul(this.Y).ct_eq(this.Z.mul(this.T));
        return on_curve && on_ceger_image;
    };
    /*
    fn optional_multiscalar_mul<I, J>(scalars: I, points: J) -> Option<EdwardsPoint>
    where
        I: IntoIterator,
        I::Item: Borrow<Scalar>,
        J: IntoIterator<Item = Option<EdwardsPoint>>,
    {
        // Sanity-check lengths of input iterators
        let mut scalars = scalars.into_iter();
        let mut points = points.into_iter();

        // Lower and upper bounds on iterators
        let (s_lo, s_hi) = scalars.by_ref().size_hint();
        let (p_lo, p_hi) = points.by_ref().size_hint();

        // They should all be equal
        assert_eq!(s_lo, p_lo);
        assert_eq!(s_hi, Some(s_lo));
        assert_eq!(p_hi, Some(p_lo));

        // Now we know there's a single size.
        // Use this as the hint to decide which algorithm to use.
        let size = s_lo;

        if size < 190 {
            scalar_mul::straus::Straus::optional_multiscalar_mul(scalars, points)
        } else {
            scalar_mul::pippenger::Pippenger::optional_multiscalar_mul(scalars, points)
        }
    }
    */
    EdwardsPoint.vartime_multiscalar_mul = function (scalars, points) {
        return straus_optional_multiscalar_mul(scalars, points);
        // pippenger impl is wrong
        // if( scalars.length < 190 )
        //     return straus_optional_multiscalar_mul( scalars, points );
        // else
        //     return pippenger_optional_multiscalar_mul( scalars, points );
    };
    EdwardsPoint.prototype.double = function () {
        return this.toProjective().double().toExtended();
    };
    /*
/// Compute \\(aA + bB\\) in variable time, where \\(B\\) is the Ed25519 basepoint.
pub fn mul(a: &Scalar, A: &EdwardsPoint, b: &Scalar) -> EdwardsPoint {
    let a_naf = a.non_adjacent_form(5);
    let b_naf = b.non_adjacent_form(8);

    // Find starting index
    let mut i: usize = 255;
    for j in (0..256).rev() {
        i = j;
        if a_naf[i] != 0 || b_naf[i] != 0 {
            break;
        }
    }

    let table_A = NafLookupTable::<ProjectiveNielsPoint>::from(A);
    let table_B = &constants::AFFINE_ODD_MULTIPLES_OF_BASEPOINT;

    let mut r = ProjectivePoint::identity();
    loop {
        let mut t = r.double();

        if a_naf[i] > 0 {
            t = &t.to_extended() + &table_A.select(a_naf[i] as usize);
        } else if a_naf[i] < 0 {
            t = &t.to_extended() - &table_A.select(-a_naf[i] as usize);
        }

        if b_naf[i] > 0 {
            t = &t.to_extended() + &table_B.select(b_naf[i] as usize);
        } else if b_naf[i] < 0 {
            t = &t.to_extended() - &table_B.select(-b_naf[i] as usize);
        }

        r = t.to_projective();

        if i == 0 {
            break;
        }
        i -= 1;
    }

    r.to_extended()
}
    */
    EdwardsPoint.vartime_double_scalar_mul_basepoint = function (neg_challenge, pk, response) {
        var a_naf = scalar_non_adjacent_form(neg_challenge, 5);
        var b_naf = scalar_non_adjacent_form(response, 8);
        var i = 255;
        for (var j = 255; j >= 0; j--) {
            i = j;
            if (a_naf[i] !== 0 || b_naf[i] !== 0) {
                break;
            }
        }
        ;
        var table_A = NafLookupTable.fromEdwardsPoint(pk);
        var table_B = AFFINE_ODD_MULTIPLES_OF_BASEPOINT;
        var r = ProjectivePoint.IDENTITY;
        while (true) {
            var t = r.double();
            if (a_naf[i] > 0)
                t = t.toExtended().addProjectiveNiels(table_A.select(a_naf[i]));
            else if (a_naf[i] < 0)
                t = t.toExtended().subProjectiveNiels(table_A.select(-a_naf[i]));
            if (b_naf[i] > 0)
                t = t.toExtended().addAffineNielsPoint(table_B.select(b_naf[i]));
            else if (b_naf[i] < 0)
                t = t.toExtended().subAffineNielsPoint(table_B.select(-b_naf[i]));
            r = t.toProjective();
            if (i === 0)
                break;
            i--;
        }
        return r.toExtended();
    };
    EdwardsPoint.prototype.ct_eq = function (other) {
        return (0, uint8array_utils_1.uint8ArrayEq)(this.compress(), other.compress());
    };
    EdwardsPoint.decompress = function (compressed) {
        return decompressCompressedEdwardsY(compressed);
    };
    EdwardsPoint.uncompress = function (compressed) {
        return decompressCompressedEdwardsY(compressed);
    };
    /*
    pub fn is_small_order(&self) -> bool {
        self.mul_by_cofactor().is_identity()
    }
    */
    EdwardsPoint.prototype.is_small_order = function () {
        return this.mul_by_cofactor().is_identity();
    };
    /*
    fn is_identity(&self) -> bool {
        self.ct_eq(&T::identity()).unwrap_u8() == 1u8
    }
    */
    EdwardsPoint.prototype.is_identity = function () {
        return this.ct_eq(EdwardsPoint.IDENTITY);
    };
    EdwardsPoint.prototype.clone = function () {
        return new EdwardsPoint(this.X.clone(), this.Y.clone(), this.Z.clone(), this.T.clone());
    };
    Object.defineProperty(EdwardsPoint, "IDENTITY", {
        get: function () {
            return new EdwardsPoint(FieldElem51.zero(), FieldElem51.one(), FieldElem51.one(), FieldElem51.zero());
        },
        enumerable: false,
        configurable: true
    });
    /*
    fn add(self, other: &'b EdwardsPoint) -> EdwardsPoint {
        (self + &other.to_projective_niels()).to_extended()
    }
    */
    EdwardsPoint.prototype.add = function (other) {
        return this.addProjectiveNiels(other.toProjectiveNiels()).toExtended();
    };
    /*
    fn add(self, other: &'b ProjectiveNielsPoint) -> CompletedPoint {
        let Y_plus_X  = &self.Y + &self.X;
        let Y_minus_X = &self.Y - &self.X;
        let PP = &Y_plus_X  * &other.Y_plus_X;
        let MM = &Y_minus_X * &other.Y_minus_X;
        let TT2d = &self.T * &other.T2d;
        let ZZ   = &self.Z * &other.Z;
        let ZZ2  = &ZZ + &ZZ;

        CompletedPoint{
            X: &PP - &MM,
            Y: &PP + &MM,
            Z: &ZZ2 + &TT2d,
            T: &ZZ2 - &TT2d
        }
    }
    */
    EdwardsPoint.prototype.addProjectiveNiels = function (other) {
        var Y_plus_X = this.Y.add(this.X);
        var Y_minus_X = this.Y.sub(this.X);
        var PP = Y_plus_X.mul(other.Y_plus_X);
        var MM = Y_minus_X.mul(other.Y_minus_X);
        var TT2d = this.T.mul(other.T2d);
        var ZZ = this.Z.mul(other.Z);
        var ZZ2 = ZZ.add(ZZ);
        return new CompletedPoint(PP.sub(MM), PP.add(MM), ZZ2.add(TT2d), ZZ2.sub(TT2d));
    };
    /*
    fn sub(self, other: &'b ProjectiveNielsPoint) -> CompletedPoint {
        let Y_plus_X  = &self.Y + &self.X;
        let Y_minus_X = &self.Y - &self.X;
        let PM = &Y_plus_X * &other.Y_minus_X;
        let MP = &Y_minus_X  * &other.Y_plus_X;
        let TT2d = &self.T * &other.T2d;
        let ZZ   = &self.Z * &other.Z;
        let ZZ2  = &ZZ + &ZZ;

        CompletedPoint{
            X: &PM - &MP,
            Y: &PM + &MP,
            Z: &ZZ2 - &TT2d,
            T: &ZZ2 + &TT2d
        }
    }
    */
    EdwardsPoint.prototype.subProjectiveNiels = function (other) {
        var Y_plus_X = this.Y.add(this.X);
        var Y_minus_X = this.Y.sub(this.X);
        var PM = Y_plus_X.mul(other.Y_minus_X);
        var MP = Y_minus_X.mul(other.Y_plus_X);
        var TT2d = this.T.mul(other.T2d);
        var ZZ = this.Z.mul(other.Z);
        var ZZ2 = ZZ.add(ZZ);
        return new CompletedPoint(PM.sub(MP), PM.add(MP), ZZ2.sub(TT2d), ZZ2.add(TT2d));
    };
    /*
    fn add(self, other: &'b AffineNielsPoint) -> CompletedPoint {
        let Y_plus_X  = &self.Y + &self.X;
        let Y_minus_X = &self.Y - &self.X;
        let PP        = &Y_plus_X  * &other.y_plus_x;
        let MM        = &Y_minus_X * &other.y_minus_x;
        let Txy2d     = &self.T * &other.xy2d;
        let Z2        = &self.Z + &self.Z;

        CompletedPoint{
            X: &PP - &MM,
            Y: &PP + &MM,
            Z: &Z2 + &Txy2d,
            T: &Z2 - &Txy2d
        }
    }
    */
    EdwardsPoint.prototype.addAffineNielsPoint = function (other) {
        var Y_plus_X = this.Y.add(this.X);
        var Y_minus_X = this.Y.sub(this.X);
        var PP = Y_plus_X.mul(other.y_plus_x);
        var MM = Y_minus_X.mul(other.y_minus_x);
        var Txy2d = this.T.mul(other.xy2d);
        var Z2 = this.Z.add(this.Z);
        return new CompletedPoint(PP.sub(MM), PP.add(MM), Z2.add(Txy2d), Z2.sub(Txy2d));
    };
    /*
    fn sub(self, other: &'b AffineNielsPoint) -> CompletedPoint {
        let Y_plus_X  = &self.Y + &self.X;
        let Y_minus_X = &self.Y - &self.X;
        let PM        = &Y_plus_X  * &other.y_minus_x;
        let MP        = &Y_minus_X * &other.y_plus_x;
        let Txy2d     = &self.T * &other.xy2d;
        let Z2        = &self.Z + &self.Z;

        CompletedPoint{
            X: &PM - &MP,
            Y: &PM + &MP,
            Z: &Z2 - &Txy2d,
            T: &Z2 + &Txy2d
        }
    }
    */
    EdwardsPoint.prototype.subAffineNielsPoint = function (other) {
        var Y_plus_X = this.Y.add(this.X);
        var Y_minus_X = this.Y.sub(this.X);
        var PM = Y_plus_X.mul(other.y_minus_x);
        var MP = Y_minus_X.mul(other.y_plus_x);
        var Txy2d = this.T.mul(other.xy2d);
        var Z2 = this.Z.add(this.Z);
        return new CompletedPoint(PM.sub(MP), PM.add(MP), Z2.sub(Txy2d), Z2.add(Txy2d));
    };
    /*
    /// Convert to a ProjectiveNielsPoint
    pub(crate) fn to_projective_niels(&self) -> ProjectiveNielsPoint {
        ProjectiveNielsPoint{
            Y_plus_X:  &self.Y + &self.X,
            Y_minus_X: &self.Y - &self.X,
            Z:          self.Z,
            T2d:       &self.T * &constants::EDWARDS_D2,
        }
    }
    */
    EdwardsPoint.prototype.toProjectiveNiels = function () {
        return new ProjectiveNielsPoint(this.Y.add(this.X), this.Y.sub(this.X), this.Z, this.T.mul(FieldElem51.EDWARDS_D2));
    };
    /*
    /// Multiply by the cofactor: return \\([8]P\\).
    pub fn mul_by_cofactor(&self) -> EdwardsPoint {
        self.mul_by_pow_2(3)
    }
    */
    EdwardsPoint.prototype.mul_by_cofactor = function () {
        return this.mul_by_pow_2(3);
    };
    /*
    /// Compress this point to `CompressedEdwardsY` format.
    pub fn compress(&self) -> CompressedEdwardsY {
        let recip = self.Z.invert();
        let x = &self.X * &recip;
        let y = &self.Y * &recip;
        let mut s: [u8; 32];

        s = y.to_bytes();
        s[31] ^= x.is_negative().unwrap_u8() << 7;
        CompressedEdwardsY(s)
    }
    */
    EdwardsPoint.prototype.compress = function () {
        var recip = this.Z.invert();
        var x = this.X.mul(recip);
        var y = this.Y.mul(recip);
        var s = y.toBytes();
        var bit = x.is_negative() ? 1 : 0;
        s[31] ^= bit << 7;
        return s;
    };
    EdwardsPoint.prototype.compressed_is_negative = function () {
        var recip = this.Z.invert();
        var x = this.X.mul(recip);
        return x.is_negative();
    };
    /*
    /// Compute \\([2\^k] P \\) by successive doublings. Requires \\( k > 0 \\).
    pub(crate) fn mul_by_pow_2(&self, k: u32) -> EdwardsPoint {
        debug_assert!( k > 0 );
        let mut r: CompletedPoint;
        let mut s = self.to_projective();
        for _ in 0..(k-1) {
            r = s.double(); s = r.to_projective();
        }
        // Unroll last iteration so we can go directly to_extended()
        s.double().to_extended()
    }
    */
    EdwardsPoint.prototype.mul_by_pow_2 = function (k) {
        if (k <= 0)
            throw new Error("mul_by_pow_2 :: k must be greater than 0");
        var r;
        var s = this.toProjective();
        for (var i = 0; i < k - 1; i++) {
            r = s.double();
            s = r.toProjective();
        }
        return s.double().toExtended();
    };
    /*
    /// Convert the representation of this point from extended
    /// coordinates to projective coordinates.
    ///
    /// Free.
    pub(crate) fn to_projective(&self) -> ProjectivePoint {
        ProjectivePoint{
            X: self.X,
            Y: self.Y,
            Z: self.Z,
        }
    }
    */
    EdwardsPoint.prototype.toProjective = function () {
        return new ProjectivePoint(this.X, this.Y, this.Z);
    };
    /*
    /// Perform constant-time, variable-base scalar multiplication.
    pub(crate) fn mul(point: &EdwardsPoint, scalar: &Scalar) -> EdwardsPoint {
        // Construct a lookup table of [P,2P,3P,4P,5P,6P,7P,8P]
        let lookup_table = LookupTable::<ProjectiveNielsPoint>::from(point);
        // Setting s = scalar, compute
        //
        //    s = s_0 + s_1*16^1 + ... + s_63*16^63,
        //
        // with `-8 ≤ s_i < 8` for `0 ≤ i < 63` and `-8 ≤ s_63 ≤ 8`.
        let scalar_digits = scalar.to_radix_16();
        // Compute s*P as
        //
        //    s*P = P*(s_0 +   s_1*16^1 +   s_2*16^2 + ... +   s_63*16^63)
        //    s*P =  P*s_0 + P*s_1*16^1 + P*s_2*16^2 + ... + P*s_63*16^63
        //    s*P = P*s_0 + 16*(P*s_1 + 16*(P*s_2 + 16*( ... + P*s_63)...))
        //
        // We sum right-to-left.

        // Unwrap first loop iteration to save computing 16*identity
        let mut tmp2;
        let mut tmp3 = EdwardsPoint::identity();
        let mut tmp1 = &tmp3 + &lookup_table.select(scalar_digits[63]);
        // Now tmp1 = s_63*P in P1xP1 coords
        for i in (0..63).rev() {
            tmp2 = tmp1.to_projective(); // tmp2 =    (prev) in P2 coords
            tmp1 = tmp2.double();        // tmp1 =  2*(prev) in P1xP1 coords
            tmp2 = tmp1.to_projective(); // tmp2 =  2*(prev) in P2 coords
            tmp1 = tmp2.double();        // tmp1 =  4*(prev) in P1xP1 coords
            tmp2 = tmp1.to_projective(); // tmp2 =  4*(prev) in P2 coords
            tmp1 = tmp2.double();        // tmp1 =  8*(prev) in P1xP1 coords
            tmp2 = tmp1.to_projective(); // tmp2 =  8*(prev) in P2 coords
            tmp1 = tmp2.double();        // tmp1 = 16*(prev) in P1xP1 coords
            tmp3 = tmp1.to_extended();   // tmp3 = 16*(prev) in P3 coords
            tmp1 = &tmp3 + &lookup_table.select(scalar_digits[i]);
            // Now tmp1 = s_i*P + 16*(prev) in P1xP1 coords
        }
        tmp1.to_extended()
    }
    */
    /*
    */
    EdwardsPoint.prototype.scalarMul = function (scalar) {
        var lookup_table = ProjectiveNielsPoint.tableFromEdwardPoint(this);
        var scalar_digits = scalar_to_radix_16(scalar);
        var tmp2 = ProjectivePoint.IDENTITY;
        var tmp3 = EdwardsPoint.IDENTITY;
        var tmp1 = tmp3.addProjectiveNiels(lookup_table.select(scalar_digits[63]));
        for (var i = 62; i >= 0; i--) {
            tmp2 = tmp1.toProjective();
            tmp1 = tmp2.double();
            tmp2 = tmp1.toProjective();
            tmp1 = tmp2.double();
            tmp2 = tmp1.toProjective();
            tmp1 = tmp2.double();
            tmp2 = tmp1.toProjective();
            tmp1 = tmp2.double();
            tmp3 = tmp1.toExtended();
            tmp1 = tmp3.addProjectiveNiels(lookup_table.select(scalar_digits[i]));
        }
        return tmp1.toExtended();
    };
    return EdwardsPoint;
}());
exports.EdwardsPoint = EdwardsPoint;
var NafLookupTable = /** @class */ (function () {
    function NafLookupTable(points) {
        this.points = points;
    }
    /*
    /// Given public, odd \\( x \\) with \\( 0 < x < 2^4 \\), return \\(xA\\).
    pub fn select(&self, x: usize) -> T {
        debug_assert_eq!(x & 1, 1);
        debug_assert!(x < 16););

        self.0[x / 2]
    }
    */
    NafLookupTable.prototype.select = function (i) {
        // debug_assert_eq(x & 1, 1);
        // debug_assert(x < 16););
        return this.points[(i / 2) >>> 0];
    };
    /*
    fn from(A: &'a EdwardsPoint) -> Self {
        let mut Ai: [ProjectiveNielsPoint; 8] = [A.to_projective_niels(); 8];
        let A2 = A.double();
        for i in 0..7 {
            Ai[i + 1] = (&A2 + &Ai[i]).to_extended().to_projective_niels();
        }
        // Now Ai = [A, 3A, 5A, 7A, 9A, 11A, 13A, 15A]
        NafLookupTable(Ai)
    }
    */
    NafLookupTable.fromEdwardsPoint = function (point) {
        var Ai = new Array(8).fill(0).map(function (_) { return point.toProjectiveNiels(); });
        var A2 = point.double();
        for (var i = 0; i < 7; i++) {
            Ai[i + 1] = A2.addProjectiveNiels(Ai[i]).toExtended().toProjectiveNiels();
        }
        // Now Ai = [A, 3A, 5A, 7A, 9A, 11A, 13A, 15A]
        return new NafLookupTable(Ai);
    };
    return NafLookupTable;
}());
var AffineNielsPoint = /** @class */ (function () {
    function AffineNielsPoint(y_plus_x, y_minus_x, xy2d) {
        this.y_plus_x = y_plus_x;
        this.y_minus_x = y_minus_x;
        this.xy2d = xy2d;
    }
    return AffineNielsPoint;
}());
exports.ED25519_BASEPOINT_POINT = new EdwardsPoint(new FieldElem51(new BigUint64Array([
    BigInt("1738742601995546"),
    BigInt("1146398526822698"),
    BigInt("2070867633025821"),
    BigInt("562264141797630"),
    BigInt("587772402128613"),
])), new FieldElem51(new BigUint64Array([
    BigInt("1801439850948184"),
    BigInt("1351079888211148"),
    BigInt("450359962737049"),
    BigInt("900719925474099"),
    BigInt("1801439850948198"),
])), new FieldElem51(new BigUint64Array([
    BigInt("1"),
    BigInt("0"),
    BigInt("0"),
    BigInt("0"),
    BigInt("0")
])), new FieldElem51(new BigUint64Array([
    BigInt("1841354044333475"),
    BigInt("16398895984059"),
    BigInt("755974180946558"),
    BigInt("900171276175154"),
    BigInt("1821297809914039"),
])));
/*
pub struct ProjectiveNielsPoint {
    pub Y_plus_X:  FieldElement,
    pub Y_minus_X: FieldElement,
    pub Z:         FieldElement,
    pub T2d:       FieldElement,
}

*/
var ProjectiveNielsPoint = /** @class */ (function () {
    function ProjectiveNielsPoint(Y_plus_X, Y_minus_X, Z, T2d) {
        this.Y_plus_X = Y_plus_X;
        this.Y_minus_X = Y_minus_X;
        this.Z = Z;
        this.T2d = T2d;
    }
    ProjectiveNielsPoint.prototype.clone = function () {
        return new ProjectiveNielsPoint(this.Y_plus_X.clone(), this.Y_minus_X.clone(), this.Z.clone(), this.T2d.clone());
    };
    /** not really, but useful to debug */
    ProjectiveNielsPoint.prototype.compress = function () {
        return EdwardsPoint.IDENTITY
            .addProjectiveNiels(this)
            .toExtended()
            .compress();
    };
    ProjectiveNielsPoint.prototype.compressed_is_negative = function () {
        return EdwardsPoint.IDENTITY
            .addProjectiveNiels(this)
            .toExtended()
            .compressed_is_negative();
    };
    ProjectiveNielsPoint.identity = function () {
        return new ProjectiveNielsPoint(FieldElem51.one(), FieldElem51.one(), FieldElem51.one(), FieldElem51.zero());
    };
    /**
     * # WARNING
     *
     * **I FOUND NO IMPLEMENTATION** (Thanks generics)
     *
     * I am ASSUMING this is what is meant to happen
     *
     */
    ProjectiveNielsPoint.prototype.conditional_negate = function (choice) {
        // this.Y_plus_X.conditional_negate( choice );
        // this.Y_minus_X.conditional_negate( choice );
        // this.Z.conditional_negate( choice );
        // this.T2d.conditional_negate( choice );
        // ??? WTF ???
        // ??? not even this works ???
        // ??? WHY ???
        // 
        // if( choice )
        // {
        //     (this as any).Y_plus_X = this.Y_plus_X.neg();
        //     (this as any).Y_minus_X = this.Y_minus_X.neg();
        //     (this as any).Z = this.Z.neg();
        //     (this as any).T2d = this.T2d.neg();
        // }
        if (choice) {
            var neg = this.neg();
            this.Y_plus_X = neg.Y_plus_X;
            this.Y_minus_X = neg.Y_minus_X;
            this.Z = neg.Z;
            this.T2d = neg.T2d;
        }
    };
    /**
     *
     * I HAD TO FUCKING REVERSE ENGENEER THIS SHIT
     *
     * WHO THE FUCK TOUGHT MACROS WERE A GOOD IDEA IN RUST?
     */
    ProjectiveNielsPoint.prototype.neg = function () {
        return new ProjectiveNielsPoint(
        // swap places minus and plus
        this.Y_minus_X.clone(), this.Y_plus_X.clone(), 
        // same Z
        this.Z.clone(), 
        // negate T2d
        this.T2d.neg());
    };
    /*
    fn conditional_assign(&mut self, other: &Self, choice: Choice) {
        self.Y_plus_X.conditional_assign(&other.Y_plus_X, choice);
        self.Y_minus_X.conditional_assign(&other.Y_minus_X, choice);
        self.Z.conditional_assign(&other.Z, choice);
        self.T2d.conditional_assign(&other.T2d, choice);
    }
    */
    ProjectiveNielsPoint.prototype.conditional_assign = function (other, choice) {
        this.Y_plus_X.conditional_assign(other.Y_plus_X, choice);
        this.Y_minus_X.conditional_assign(other.Y_minus_X, choice);
        this.Z.conditional_assign(other.Z, choice);
        this.T2d.conditional_assign(other.T2d, choice);
    };
    /*
    fn from(P: &'a EdwardsPoint) -> Self {
        let mut points = [P.to_projective_niels(); $size];
        for j in $conv_range {
            points[j + 1] = (P + &points[j]).to_extended().to_projective_niels();
        }
        $name(points)
    }
    */
    ProjectiveNielsPoint.tableFromEdwardPoint = function (point) {
        var points = new Array(LookupTableProjectiveNielsPoint.SIZE).fill(0).map(function (_) { return point.toProjectiveNiels(); });
        for (var j = 0; j < LookupTableProjectiveNielsPoint.CONVERSION_RANGE_MAX; j++) {
            points[j + 1] = point.addProjectiveNiels(points[j]).toExtended().toProjectiveNiels();
        }
        return new LookupTableProjectiveNielsPoint(points);
    };
    return ProjectiveNielsPoint;
}());
exports.ProjectiveNielsPoint = ProjectiveNielsPoint;
/*
impl_lookup_table! {
    Name = LookupTable,
    Size = 8,
    SizeNeg = -8,
    SizeRange = 1 .. 9,
    ConversionRange = 0 .. 7
} // radix-16
*/
var LookupTableProjectiveNielsPoint = /** @class */ (function () {
    function LookupTableProjectiveNielsPoint(points) {
        this.points = points;
    }
    /*
    /// Given \\(-8 \leq x \leq 8\\), return \\(xP\\) in constant time.
    pub fn select(&self, x: i8) -> T {
        debug_assert!(x >= $neg);
        debug_assert!(x as i16 <= $size as i16); // XXX We have to convert to i16s here for the radix-256 case.. this is wrong.

        // Compute xabs = |x|
        let xmask = x  as i16 >> 7;
        let xabs = (x as i16 + xmask) ^ xmask;

        // Set t = 0 * P = identity
        let mut t = T::identity();
        for j in $range {
            // Copy `points[j-1] == j*P` onto `t` in constant time if `|x| == j`.
            let c = (xabs as u16).ct_eq(&(j as u16));
            t.conditional_assign(&self.0[j - 1], c);
        }
        // Now t == |x| * P.

        let neg_mask = Choice::from((xmask & 1) as u8);
        t.conditional_negate(neg_mask);
        // Now t == x * P.

        t
    }
    */
    LookupTableProjectiveNielsPoint.prototype.select = function (pos) {
        var view = new DataView(new ArrayBuffer(2));
        view.setUint16(0, pos & 0xffff, false);
        var posI16 = view.getInt16(0, false);
        // const posU16 = view.getUint16( 0, false );
        var xmask = posI16 >> 7;
        var xabs = (posI16 + xmask) ^ xmask;
        var t = ProjectiveNielsPoint.identity();
        for (var j = LookupTableProjectiveNielsPoint.SIZE_RANGE_MIN; j <= LookupTableProjectiveNielsPoint.SIZE_RANGE_MAX; j++) {
            var c = xabs === j;
            t.conditional_assign(this.points[j - 1].clone(), c);
        }
        var neg_mask = xmask & 1;
        t.conditional_negate(neg_mask === 1);
        return t;
    };
    LookupTableProjectiveNielsPoint.SIZE = 8;
    LookupTableProjectiveNielsPoint.SIZE_NEG = -8;
    LookupTableProjectiveNielsPoint.SIZE_RANGE = [1, 2, 3, 4, 5, 6, 7, 8];
    LookupTableProjectiveNielsPoint.SIZE_RANGE_MIN = 1;
    LookupTableProjectiveNielsPoint.SIZE_RANGE_MAX = 8;
    LookupTableProjectiveNielsPoint.CONVERSION_RANGE = [0, 1, 2, 3, 4, 5, 6, 7];
    LookupTableProjectiveNielsPoint.CONVERSION_RANGE_MAX = 7;
    return LookupTableProjectiveNielsPoint;
}());
exports.LookupTableProjectiveNielsPoint = LookupTableProjectiveNielsPoint;
/*
pub(crate) fn to_radix_16(&self) -> [i8; 64] {
    debug_assert!(self[31] <= 127);
    let mut output = [0i8; 64];

    // Step 1: change radix.
    // Convert from radix 256 (bytes) to radix 16 (nibbles)
    #[inline(always)]
    fn bot_half(x: u8) -> u8 { (x >> 0) & 15 }
    #[inline(always)]
    fn top_half(x: u8) -> u8 { (x >> 4) & 15 }

    for i in 0..32 {
        output[2*i  ] = bot_half(self[i]) as i8;
        output[2*i+1] = top_half(self[i]) as i8;
    }
    // Precondition note: since self[31] <= 127, output[63] <= 7

    // Step 2: recenter coefficients from [0,16) to [-8,8)
    for i in 0..63 {
        let carry    = (output[i] + 8) >> 4;
        output[i  ] -= carry << 4;
        output[i+1] += carry;
    }
    // Precondition note: output[63] is not recentered.  It
    // increases by carry <= 1.  Thus output[63] <= 8.

    output
}
*/
function scalar_to_radix_16(scalar) {
    var output = new Int8Array(64);
    var u8 = new Uint8Array(output.buffer);
    for (var i = 0; i < 32; i++) {
        u8[2 * i] = (scalar[i] >> 0) & 15;
        u8[2 * i + 1] = (scalar[i] >> 4) & 15;
    }
    for (var i = 0; i < 63; i++) {
        var carry = (output[i] + 8) >> 4;
        u8[i] -= (carry << 4) & 0xff;
        u8[i + 1] += (carry) & 0xff;
    }
    return output;
}
/*
/// Attempt to decompress to an `EdwardsPoint`.
///
/// Returns `None` if the input is not the \\(y\\)-coordinate of a
/// curve point.
pub fn decompress( bytes: [u8] ) -> Option<EdwardsPoint> {
    let Y = FieldElement::from_bytes( bytes );
    let Z = FieldElement::one();
    let YY = Y.square();
    let u = &YY - &Z;                            // u =  y²-1
    let v = &(&YY * &constants::EDWARDS_D) + &Z; // v = dy²+1
    let (is_valid_y_coord, mut X) = FieldElement::sqrt_ratio_i(&u, &v);

    if is_valid_y_coord.unwrap_u8() != 1u8 { return None; }

        // FieldElement::sqrt_ratio_i always returns the nonnegative square root,
        // so we negate according to the supplied sign bit.
    let compressed_sign_bit = Choice::from(self.as_bytes()[31] >> 7);
    X.conditional_negate(compressed_sign_bit);

    Some(EdwardsPoint{ X, Y, Z, T: &X * &Y })
}
*/
function decompressCompressedEdwardsY(bytes) {
    var Y = FieldElem51.fromBytes(bytes);
    var Z = FieldElem51.one();
    var YY = Y.square();
    var u = YY.sub(Z);
    var v = YY.mul(FieldElem51.EDWARDS_D).add(Z);
    var _a = __read(FieldElem51.sqrt_ratio_i(u, v), 2), is_valid_y_coord = _a[0], X = _a[1];
    if (is_valid_y_coord !== true)
        return undefined;
    var compressed_sign_bit = (bytes[31] >> 7) & 1;
    X.conditional_negate(compressed_sign_bit === 1);
    return new EdwardsPoint(X, Y, Z, X.mul(Y));
}
exports.decompressCompressedEdwardsY = decompressCompressedEdwardsY;
var CompletedPoint = /** @class */ (function () {
    function CompletedPoint(X, Y, Z, T) {
        this.X = X;
        this.Y = Y;
        this.Z = Z;
        this.T = T;
    }
    CompletedPoint.prototype.clone = function () {
        return new CompletedPoint(this.X.clone(), this.Y.clone(), this.Z.clone(), this.T.clone());
    };
    /*
    pub fn to_projective(&self) -> ProjectivePoint {
        ProjectivePoint {
            X: &self.X * &self.T,
            Y: &self.Y * &self.Z,
            Z: &self.Z * &self.T,
        }
    }
    */
    CompletedPoint.prototype.toProjective = function () {
        return new ProjectivePoint(this.X.mul(this.T), this.Y.mul(this.Z), this.Z.mul(this.T));
    };
    /*
    pub fn to_extended(&self) -> EdwardsPoint {
        EdwardsPoint {
            X: &self.X * &self.T,
            Y: &self.Y * &self.Z,
            Z: &self.Z * &self.T,
            T: &self.X * &self.Y,
        }
    }
    */
    CompletedPoint.prototype.toExtended = function () {
        return new EdwardsPoint(this.X.mul(this.T), this.Y.mul(this.Z), this.Z.mul(this.T), this.X.mul(this.Y));
    };
    return CompletedPoint;
}());
exports.CompletedPoint = CompletedPoint;
var ProjectivePoint = /** @class */ (function () {
    function ProjectivePoint(X, Y, Z) {
        this.X = X;
        this.Y = Y;
        this.Z = Z;
    }
    /*
    fn is_valid(&self) -> bool {
        // Curve equation is    -x^2 + y^2 = 1 + d*x^2*y^2,
        // homogenized as (-X^2 + Y^2)*Z^2 = Z^4 + d*X^2*Y^2
        let XX = self.X.square();
        let YY = self.Y.square();
        let ZZ = self.Z.square();
        let ZZZZ = ZZ.square();
        let lhs = &(&YY - &XX) * &ZZ;
        let rhs = &ZZZZ + &(&constants::EDWARDS_D * &(&XX * &YY));

        lhs == rhs
    }
    */
    ProjectivePoint.prototype.is_valid = function () {
        var XX = this.X.square();
        var YY = this.Y.square();
        var ZZ = this.Z.square();
        var ZZZZ = ZZ.square();
        var lhs = YY.sub(XX).mul(ZZ);
        var rhs = ZZZZ.add(FieldElem51.EDWARDS_D.mul(XX.mul(YY)));
        return lhs.ct_eq(rhs);
    };
    ProjectivePoint.prototype.clone = function () {
        return new ProjectivePoint(this.X.clone(), this.Y.clone(), this.Z.clone());
    };
    /*
    pub fn to_extended(&self) -> EdwardsPoint {
        EdwardsPoint {
            X: &self.X * &self.Z,
            Y: &self.Y * &self.Z,
            Z: self.Z.square(),
            T: &self.X * &self.Y,
        }
    }
    */
    ProjectivePoint.prototype.toExtended = function () {
        return new EdwardsPoint(this.X.mul(this.Z), this.Y.mul(this.Z), this.Z.square(), this.X.mul(this.Y));
    };
    Object.defineProperty(ProjectivePoint, "IDENTITY", {
        get: function () {
            return new ProjectivePoint(FieldElem51.zero(), FieldElem51.one(), FieldElem51.one());
        },
        enumerable: false,
        configurable: true
    });
    /*
    /// Double this point: return self + self
    pub fn double(&self) -> CompletedPoint { // Double()
        let XX          = self.X.square();
        let YY          = self.Y.square();
        let ZZ2         = self.Z.square2();
        let X_plus_Y    = &self.X + &self.Y;
        let X_plus_Y_sq = X_plus_Y.square();
        let YY_plus_XX  = &YY + &XX;
        let YY_minus_XX = &YY - &XX;

        CompletedPoint{
            X: &X_plus_Y_sq - &YY_plus_XX,
            Y: YY_plus_XX,
            Z: YY_minus_XX,
            T: &ZZ2 - &YY_minus_XX
        }
    }
    */
    ProjectivePoint.prototype.double = function () {
        var XX = this.X.square();
        var YY = this.Y.square();
        var ZZ2 = this.Z.square2();
        var X_plus_Y = this.X.add(this.Y);
        var X_plus_Y_sq = X_plus_Y.square();
        var YY_plus_XX = YY.add(XX);
        var YY_minus_XX = YY.sub(XX);
        return new CompletedPoint(X_plus_Y_sq.sub(YY_plus_XX), YY_plus_XX, YY_minus_XX, ZZ2.sub(YY_minus_XX));
    };
    return ProjectivePoint;
}());
exports.ProjectivePoint = ProjectivePoint;
/*
#[inline]
    fn write_u64(buf: &mut [u8], n: u64) {
        buf[..8].copy_from_slice(&n.to_le_bytes());
    }
fn from(x: u64) -> Scalar {
        use byteorder::{ByteOrder, LittleEndian};
        let mut s_bytes = [0u8; 32];
        LittleEndian::write_u64(&mut s_bytes, x);
        Scalar{ bytes: s_bytes }
    }
*/
function scalar_from_u64(n) {
    n = BigInt(n);
    var s_bytes = new Uint8Array(32);
    var view = new DataView(s_bytes.buffer);
    view.setBigUint64(0, n, true);
    return s_bytes;
}
exports.scalar_from_u64 = scalar_from_u64;
function scalar_from_bytes_mod_order_wide(input) {
    // UnpackedScalar::from_bytes_wide(input).pack()
    return pack_unpacked_scalar(unpacked_scalar_from_bytes_wide(input));
}
exports.scalar_from_bytes_mod_order_wide = scalar_from_bytes_mod_order_wide;
function mul_scalars(a, b) {
    return pack_unpacked_scalar(mul_unpacked_scalars(unpacked_scalar_from_bytes(a), unpacked_scalar_from_bytes(b)));
}
exports.mul_scalars = mul_scalars;
/*
type Output = Scalar;
    #[allow(non_snake_case)]
    fn add(self, _rhs: &'b Scalar) -> Scalar {
        // The UnpackedScalar::add function produces reduced outputs
        // if the inputs are reduced.  However, these inputs may not
        // be reduced -- they might come from Scalar::from_bits.  So
        // after computing the sum, we explicitly reduce it mod l
        // before repacking.
        let sum = UnpackedScalar::add(&self.unpack(), &_rhs.unpack());
        let sum_R = UnpackedScalar::mul_internal(&sum, &constants::R);
        let sum_mod_l = UnpackedScalar::montgomery_reduce(&sum_R);
        sum_mod_l.pack()
    }
*/
function add_scalars(a, b) {
    var sum = unpacked_scalar_add(unpacked_scalar_from_bytes(a), unpacked_scalar_from_bytes(b));
    var sum_R = scalar_mul_internal(sum, SCALAR_R);
    var sum_mod_l = scalar_montgomery_reduce(sum_R);
    return pack_unpacked_scalar(sum_mod_l);
}
exports.add_scalars = add_scalars;
/*
// Compute `a + b` (mod l)
    pub fn add(a: &Scalar52, b: &Scalar52) -> Scalar52 {
        let mut sum = Scalar52::zero();
        let mask = (1u64 << 52) - 1;

        // a + b
        let mut carry: u64 = 0;
        for i in 0..5 {
            carry = a[i] + b[i] + (carry >> 52);
            sum[i] = carry & mask;
        }

        // subtract l if the sum is >= l
        Scalar52::sub(&sum, &constants::L)
    }
*/
function unpacked_scalar_add(a, b) {
    var sum = SCALAR_0.slice();
    var mask = LOW_52_BIT_MASK;
    var carry = _0n;
    for (var i = 0; i < 5; i++) {
        carry = a[i] + b[i] + (carry >> _52n);
        sum[i] = carry & mask;
    }
    return scalar_sub(sum, SCALAR_L);
}
/*
/// Unpack a 32 byte / 256 bit scalar into 5 52-bit limbs.
    pub fn from_bytes(bytes: &[u8; 32]) -> Scalar52 {
        let mut words = [0u64; 4];
        for i in 0..4 {
            for j in 0..8 {
                words[i] |= (bytes[(i * 8) + j] as u64) << (j * 8);
            }
        }

        let mask = (1u64 << 52) - 1;
        let top_mask = (1u64 << 48) - 1;
        let mut s = Scalar52::zero();

        s[ 0] =   words[0]                            & mask;
        s[ 1] = ((words[0] >> 52) | (words[1] << 12)) & mask;
        s[ 2] = ((words[1] >> 40) | (words[2] << 24)) & mask;
        s[ 3] = ((words[2] >> 28) | (words[3] << 36)) & mask;
        s[ 4] =  (words[3] >> 16)                     & top_mask;

        s
    }
*/
function unpacked_scalar_from_bytes(input) {
    var words = new BigUint64Array(4);
    for (var i = 0; i < 4; i++) {
        for (var j = 0; j < 8; j++) {
            words[i] |= BigInt(input[(i * 8) + j]) << BigInt(j * 8);
        }
    }
    var mask = LOW_52_BIT_MASK;
    var top_mask = (_1n << BigInt(48)) - _1n;
    var s = SCALAR_0.slice();
    s[0] = words[0] & mask;
    s[1] = ((words[0] >> _52n) | (words[1] << BigInt(12))) & mask;
    s[2] = ((words[1] >> BigInt(40)) | (words[2] << BigInt(24))) & mask;
    s[3] = ((words[2] >> BigInt(28)) | (words[3] << BigInt(36))) & mask;
    s[4] = (words[3] >> BigInt(16)) & top_mask;
    return s;
}
exports.unpack_scalar = unpacked_scalar_from_bytes;
/*
#[inline(never)]
    pub fn mul(a: &Scalar52, b: &Scalar52) -> Scalar52 {
        let ab = Scalar52::montgomery_reduce(&Scalar52::mul_internal(a, b));
        Scalar52::montgomery_reduce(&Scalar52::mul_internal(&ab, &constants::RR))
    }
*/
function mul_unpacked_scalars(a, b) {
    var ab = scalar_montgomery_reduce(scalar_mul_internal(a, b));
    return scalar_montgomery_reduce(scalar_mul_internal(ab, SCALAR_RR));
}
/*
pub struct Scalar52(pub [u64; 5]);

    /// Reduce a 64 byte / 512 bit scalar mod l
    pub fn from_bytes_wide(bytes: &[u8; 64]) -> Scalar52 {
        let mut words = [0u64; 8];
        for i in 0..8 {
            for j in 0..8 {
                words[i] |= (bytes[(i * 8) + j] as u64) << (j * 8);
            }
        }

        let mask = (1u64 << 52) - 1;
        let mut lo = Scalar52::zero();
        let mut hi = Scalar52::zero();

        lo[0] =   words[ 0]                             & mask;
        lo[1] = ((words[ 0] >> 52) | (words[ 1] << 12)) & mask;
        lo[2] = ((words[ 1] >> 40) | (words[ 2] << 24)) & mask;
        lo[3] = ((words[ 2] >> 28) | (words[ 3] << 36)) & mask;
        lo[4] = ((words[ 3] >> 16) | (words[ 4] << 48)) & mask;
        hi[0] =  (words[ 4] >>  4)                      & mask;
        hi[1] = ((words[ 4] >> 56) | (words[ 5] <<  8)) & mask;
        hi[2] = ((words[ 5] >> 44) | (words[ 6] << 20)) & mask;
        hi[3] = ((words[ 6] >> 32) | (words[ 7] << 32)) & mask;
        hi[4] =   words[ 7] >> 20                             ;

        lo = Scalar52::montgomery_mul(&lo, &constants::R);  // (lo * R) / R = lo
        hi = Scalar52::montgomery_mul(&hi, &constants::RR); // (hi * R^2) / R = hi * R

        Scalar52::add(&hi, &lo)
    }

*/
function unpacked_scalar_from_bytes_wide(input) {
    // UnpackedScalar::from_bytes_wide(input)
    var words = new BigUint64Array(8);
    for (var i = 0; i < 8; i++) {
        for (var j = 0; j < 8; j++) {
            words[i] |= BigInt(input[(i * 8) + j]) << BigInt((j * 8));
        }
    }
    var mask = LOW_52_BIT_MASK;
    var lo = new BigUint64Array(5);
    var hi = new BigUint64Array(5);
    lo[0] = words[0] & mask;
    lo[1] = ((words[0] >> _52n) | (words[1] << BigInt(12))) & mask;
    lo[2] = ((words[1] >> BigInt(40)) | (words[2] << BigInt(24))) & mask;
    lo[3] = ((words[2] >> BigInt(28)) | (words[3] << BigInt(36))) & mask;
    lo[4] = ((words[3] >> BigInt(16)) | (words[4] << BigInt(48))) & mask;
    hi[0] = (words[4] >> BigInt(4)) & mask;
    hi[1] = ((words[4] >> BigInt(56)) | (words[5] << BigInt(8))) & mask;
    hi[2] = ((words[5] >> BigInt(44)) | (words[6] << BigInt(20))) & mask;
    hi[3] = ((words[6] >> BigInt(32)) | (words[7] << BigInt(32))) & mask;
    hi[4] = words[7] >> BigInt(20);
    lo = scalar_montgomery_mul(lo, SCALAR_R);
    hi = scalar_montgomery_mul(hi, SCALAR_RR);
    return scalar_52_add(hi, lo);
}
exports.unpacked_scalar_from_bytes_wide = unpacked_scalar_from_bytes_wide;
var SCALAR_R = new BigUint64Array([
    BigInt("0x000f48bd6721e6ed"),
    BigInt("0x0003bab5ac67e45a"),
    BigInt("0x000fffffeb35e51b"),
    BigInt("0x000fffffffffffff"),
    BigInt("0x00000fffffffffff"),
]);
var SCALAR_RR = new BigUint64Array([
    BigInt("0x0009d265e952d13b"),
    BigInt("0x000d63c715bea69f"),
    BigInt("0x0005be65cb687604"),
    BigInt("0x0003dceec73d217f"),
    BigInt("0x000009411b7c309a"),
]);
/*
/// Compute `a + b` (mod l)
    pub fn add(a: &Scalar52, b: &Scalar52) -> Scalar52 {
        let mut sum = Scalar52::zero();
        let mask = (1u64 << 52) - 1;

        // a + b
        let mut carry: u64 = 0;
        for i in 0..5 {
            carry = a[i] + b[i] + (carry >> 52);
            sum[i] = carry & mask;
        }

        // subtract l if the sum is >= l
        Scalar52::sub(&sum, &constants::L)
    }
*/
function scalar_52_add(a, b) {
    var sum = SCALAR_0.slice();
    var mask = LOW_52_BIT_MASK;
    var carry = _0n;
    for (var i = 0; i < 5; i++) {
        carry = a[i] + b[i] + (carry >> _52n);
        sum[i] = carry & mask;
    }
    return scalar_sub(sum, SCALAR_L);
}
function scalar_montgomery_mul(a, b) {
    return scalar_montgomery_reduce(scalar_mul_internal(a, b));
}
/*
// Compute `limbs/R` (mod l), where R is the Montgomery modulus 2^260
    #[inline(always)]
    pub (crate) fn montgomery_reduce(limbs: &[u128; 9]) -> Scalar52 {

        #[inline(always)]
        fn part1(sum: u128) -> (u128, u64) {
            let p = (sum as u64).wrapping_mul(constants::LFACTOR) & ((1u64 << 52) - 1);
            ((sum + m(p,constants::L[0])) >> 52, p)
        }

        #[inline(always)]
        fn part2(sum: u128) -> (u128, u64) {
            let w = (sum as u64) & ((1u64 << 52) - 1);
            (sum >> 52, w)
        }

        // note: l[3] is zero, so its multiples can be skipped
        let l = &constants::L;

        // the first half computes the Montgomery adjustment factor n, and begins adding n*l to make limbs divisible by R
        let (carry, n0) = part1(        limbs[0]);
        let (carry, n1) = part1(carry + limbs[1] + m(n0,l[1]));
        let (carry, n2) = part1(carry + limbs[2] + m(n0,l[2]) + m(n1,l[1]));
        let (carry, n3) = part1(carry + limbs[3]              + m(n1,l[2]) + m(n2,l[1]));
        let (carry, n4) = part1(carry + limbs[4] + m(n0,l[4])              + m(n2,l[2]) + m(n3,l[1]));

        // limbs is divisible by R now, so we can divide by R by simply storing the upper half as the result
        let (carry, r0) = part2(carry + limbs[5]              + m(n1,l[4])              + m(n3,l[2]) + m(n4,l[1]));
        let (carry, r1) = part2(carry + limbs[6]                           + m(n2,l[4])              + m(n4,l[2]));
        let (carry, r2) = part2(carry + limbs[7]                                        + m(n3,l[4])             );
        let (carry, r3) = part2(carry + limbs[8]                                                     + m(n4,l[4]));
        let         r4 = carry as u64;

        // result may be >= l, so attempt to subtract l
        Scalar52::sub(&Scalar52([r0,r1,r2,r3,r4]), l)
    }

*/
function scalar_montgomery_reduce(limbs) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var l = SCALAR_L.slice();
    var carry, n0, n1, n2, n3, n4, r0, r1, r2, r3, r4;
    _a = __read(smr_part1(limbs[0]), 2), carry = _a[0], n0 = _a[1];
    _b = __read(smr_part1(carry + limbs[1] + (n0 * l[1])), 2), carry = _b[0], n1 = _b[1];
    _c = __read(smr_part1(carry + limbs[2] + (n0 * l[2]) + (n1 * l[1])), 2), carry = _c[0], n2 = _c[1];
    _d = __read(smr_part1(carry + limbs[3] + (n1 * l[2]) + (n2 * l[1])), 2), carry = _d[0], n3 = _d[1];
    _e = __read(smr_part1(carry + limbs[4] + (n0 * l[4]) + (n2 * l[2]) + (n3 * l[1])), 2), carry = _e[0], n4 = _e[1];
    _f = __read(smr_part2(carry + limbs[5] + (n1 * l[4]) + (n3 * l[2]) + (n4 * l[1])), 2), carry = _f[0], r0 = _f[1];
    _g = __read(smr_part2(carry + limbs[6] + (n2 * l[4]) + (n4 * l[2])), 2), carry = _g[0], r1 = _g[1];
    _h = __read(smr_part2(carry + limbs[7] + (n3 * l[4])), 2), carry = _h[0], r2 = _h[1];
    _j = __read(smr_part2(carry + limbs[8] + (n4 * l[4])), 2), carry = _j[0], r3 = _j[1];
    r4 = carry & LOW_64_BIT_MASK;
    return scalar_sub(new BigUint64Array([r0, r1, r2, r3, r4]), l);
}
function smr_part1(sum) {
    var p = rust_u64_wrapping_mul(sum, LFACTOR) & LOW_52_BIT_MASK;
    return [
        (sum + (p * SCALAR_L[0])) >> _52n,
        p
    ];
}
function smr_part2(sum) {
    var w = sum & LOW_52_BIT_MASK;
    return [
        sum >> _52n,
        w
    ];
}
var U64_PLUS_ONE = _1n << _64n;
function rust_u64_wrapping_mul(a, b) {
    // Convert inputs to BigInt and perform multiplication
    return (a * b) % U64_PLUS_ONE;
}
/*
/// Compute `a - b` (mod l)
    pub fn sub(a: &Scalar52, b: &Scalar52) -> Scalar52 {
        let mut difference = Scalar52::zero();
        let mask = (1u64 << 52) - 1;

        // a - b
        let mut borrow: u64 = 0;
        for i in 0..5 {
            borrow = a[i].wrapping_sub(b[i] + (borrow >> 63));
            difference[i] = borrow & mask;
        }

        // conditionally add l if the difference is negative
        let underflow_mask = ((borrow >> 63) ^ 1).wrapping_sub(1);
        let mut carry: u64 = 0;
        for i in 0..5 {
            carry = (carry >> 52) + difference[i] + (constants::L[i] & underflow_mask);
            difference[i] = carry & mask;
        }

        difference
    }
*/
function scalar_sub(a, b) {
    var difference = SCALAR_0.slice();
    var mask = LOW_52_BIT_MASK;
    var borrow = _0n;
    for (var i = 0; i < 5; i++) {
        borrow = rust_u64_wrapping_sub(a[i], (b[i] + (borrow >> BigInt(63))));
        difference[i] = borrow & mask;
    }
    // conditionally add l if the difference is negative
    var underflow_mask = rust_u64_wrapping_sub((borrow >> BigInt(63)) ^ _1n, _1n);
    var carry = _0n;
    for (var i = 0; i < 5; i++) {
        carry = (carry >> _52n) + difference[i] + (SCALAR_L[i] & underflow_mask);
        difference[i] = carry & mask;
    }
    return difference;
}
/**
 * ```rs
 * pub const fn wrapping_sub_signed(self, rhs: i64) -> u64
 * ```
*/
function rust_u64_wrapping_sub(self, rhs) {
    var U64_MAX = LOW_64_BIT_MASK; // 2^64 - 1, max value of u64
    // Convert inputs to BigInt
    var result = BigInt(self) - BigInt(rhs);
    // Wrap around if out of bounds
    if (result < _0n) {
        result += U64_MAX + _1n; // Wrap from negative to upper bound
    }
    else if (result > U64_MAX) {
        result %= U64_MAX + _1n; // Wrap around on overflow
    }
    return result;
}
var SCALAR_0 = new BigUint64Array(5).fill(_0n);
var SCALAR_L = new BigUint64Array([
    BigInt("0x0002631a5cf5d3ed"),
    BigInt("0x000dea2f79cd6581"),
    BigInt("0x000000000014def9"),
    BigInt("0x0000000000000000"),
    BigInt("0x0000100000000000"),
]);
var LFACTOR = BigInt("0x51da312547e1b");
/*
#[inline(always)]
fn m(x: u64, y: u64) -> u128 {
    (x as u128) * (y as u128)
}
/// Compute `a * b`
    #[inline(always)]
    pub (crate) fn mul_internal(a: &Scalar52, b: &Scalar52) -> [u128; 9] {
        let mut z = [0u128; 9];

        z[0] = m(a[0],b[0]);
        z[1] = m(a[0],b[1]) + m(a[1],b[0]);
        z[2] = m(a[0],b[2]) + m(a[1],b[1]) + m(a[2],b[0]);
        z[3] = m(a[0],b[3]) + m(a[1],b[2]) + m(a[2],b[1]) + m(a[3],b[0]);
        z[4] = m(a[0],b[4]) + m(a[1],b[3]) + m(a[2],b[2]) + m(a[3],b[1]) + m(a[4],b[0]);
        z[5] =                m(a[1],b[4]) + m(a[2],b[3]) + m(a[3],b[2]) + m(a[4],b[1]);
        z[6] =                               m(a[2],b[4]) + m(a[3],b[3]) + m(a[4],b[2]);
        z[7] =                                              m(a[3],b[4]) + m(a[4],b[3]);
        z[8] =                                                             m(a[4],b[4]);

        z
    }
*/
function scalar_mul_internal(a, b) {
    var z = new Array(9);
    z[0] = a[0] * b[0];
    z[1] = a[0] * b[1] + a[1] * b[0];
    z[2] = a[0] * b[2] + a[1] * b[1] + a[2] * b[0];
    z[3] = a[0] * b[3] + a[1] * b[2] + a[2] * b[1] + a[3] * b[0];
    z[4] = a[0] * b[4] + a[1] * b[3] + a[2] * b[2] + a[3] * b[1] + a[4] * b[0];
    z[5] = a[1] * b[4] + a[2] * b[3] + a[3] * b[2] + a[4] * b[1];
    z[6] = a[2] * b[4] + a[3] * b[3] + a[4] * b[2];
    z[7] = a[3] * b[4] + a[4] * b[3];
    z[8] = a[4] * b[4];
    return z;
}
/*
 /// Pack the limbs of this `Scalar52` into 32 bytes
    pub fn to_bytes(&self) -> [u8; 32] {
        let mut s = [0u8; 32];

        s[0]  =  (self.0[ 0] >>  0)                      as u8;
        s[1]  =  (self.0[ 0] >>  8)                      as u8;
        s[2]  =  (self.0[ 0] >> 16)                      as u8;
        s[3]  =  (self.0[ 0] >> 24)                      as u8;
        s[4]  =  (self.0[ 0] >> 32)                      as u8;
        s[5]  =  (self.0[ 0] >> 40)                      as u8;
        s[6]  = ((self.0[ 0] >> 48) | (self.0[ 1] << 4)) as u8;
        s[7]  =  (self.0[ 1] >>  4)                      as u8;
        s[8]  =  (self.0[ 1] >> 12)                      as u8;
        s[9]  =  (self.0[ 1] >> 20)                      as u8;
        s[10] =  (self.0[ 1] >> 28)                      as u8;
        s[11] =  (self.0[ 1] >> 36)                      as u8;
        s[12] =  (self.0[ 1] >> 44)                      as u8;
        s[13] =  (self.0[ 2] >>  0)                      as u8;
        s[14] =  (self.0[ 2] >>  8)                      as u8;
        s[15] =  (self.0[ 2] >> 16)                      as u8;
        s[16] =  (self.0[ 2] >> 24)                      as u8;
        s[17] =  (self.0[ 2] >> 32)                      as u8;
        s[18] =  (self.0[ 2] >> 40)                      as u8;
        s[19] = ((self.0[ 2] >> 48) | (self.0[ 3] << 4)) as u8;
        s[20] =  (self.0[ 3] >>  4)                      as u8;
        s[21] =  (self.0[ 3] >> 12)                      as u8;
        s[22] =  (self.0[ 3] >> 20)                      as u8;
        s[23] =  (self.0[ 3] >> 28)                      as u8;
        s[24] =  (self.0[ 3] >> 36)                      as u8;
        s[25] =  (self.0[ 3] >> 44)                      as u8;
        s[26] =  (self.0[ 4] >>  0)                      as u8;
        s[27] =  (self.0[ 4] >>  8)                      as u8;
        s[28] =  (self.0[ 4] >> 16)                      as u8;
        s[29] =  (self.0[ 4] >> 24)                      as u8;
        s[30] =  (self.0[ 4] >> 32)                      as u8;
        s[31] =  (self.0[ 4] >> 40)                      as u8;

        s
    }
*/
function pack_unpacked_scalar(input) {
    var s = new Uint8Array(32);
    var u8mask = BigInt(0xff);
    s[0] = Number((input[0] >> _0n) & u8mask);
    s[1] = Number((input[0] >> BigInt(8)) & u8mask);
    s[2] = Number((input[0] >> BigInt(16)) & u8mask);
    s[3] = Number((input[0] >> BigInt(24)) & u8mask);
    s[4] = Number((input[0] >> BigInt(32)) & u8mask);
    s[5] = Number((input[0] >> BigInt(40)) & u8mask);
    s[6] = Number(((input[0] >> BigInt(48)) | (input[1] << BigInt(4))) & u8mask);
    s[7] = Number((input[1] >> BigInt(4)) & u8mask);
    s[8] = Number((input[1] >> BigInt(12)) & u8mask);
    s[9] = Number((input[1] >> BigInt(20)) & u8mask);
    s[10] = Number((input[1] >> BigInt(28)) & u8mask);
    s[11] = Number((input[1] >> BigInt(36)) & u8mask);
    s[12] = Number((input[1] >> BigInt(44)) & u8mask);
    s[13] = Number((input[2] >> _0n) & u8mask);
    s[14] = Number((input[2] >> BigInt(8)) & u8mask);
    s[15] = Number((input[2] >> BigInt(16)) & u8mask);
    s[16] = Number((input[2] >> BigInt(24)) & u8mask);
    s[17] = Number((input[2] >> BigInt(32)) & u8mask);
    s[18] = Number((input[2] >> BigInt(40)) & u8mask);
    s[19] = Number(((input[2] >> BigInt(48)) | (input[3] << BigInt(4))) & u8mask);
    s[20] = Number((input[3] >> BigInt(4)) & u8mask);
    s[21] = Number((input[3] >> BigInt(12)) & u8mask);
    s[22] = Number((input[3] >> BigInt(20)) & u8mask);
    s[23] = Number((input[3] >> BigInt(28)) & u8mask);
    s[24] = Number((input[3] >> BigInt(36)) & u8mask);
    s[25] = Number((input[3] >> BigInt(44)) & u8mask);
    s[26] = Number((input[4] >> _0n) & u8mask);
    s[27] = Number((input[4] >> BigInt(8)) & u8mask);
    s[28] = Number((input[4] >> BigInt(16)) & u8mask);
    s[29] = Number((input[4] >> BigInt(24)) & u8mask);
    s[30] = Number((input[4] >> BigInt(32)) & u8mask);
    s[31] = Number((input[4] >> BigInt(40)) & u8mask);
    return s;
}
exports.pack_unpacked_scalar = pack_unpacked_scalar;
/*
#[allow(non_snake_case)]
    fn neg(self) -> Scalar {
        let self_R = UnpackedScalar::mul_internal(&self.unpack(), &constants::R);
        let self_mod_l = UnpackedScalar::montgomery_reduce(&self_R);
        UnpackedScalar::sub(&UnpackedScalar::zero(), &self_mod_l).pack()
    }
}
*/
function negate_scalar(scalar) {
    var self_R = scalar_mul_internal(unpacked_scalar_from_bytes(scalar), SCALAR_R);
    var self_mod_l = scalar_montgomery_reduce(self_R);
    return pack_unpacked_scalar(scalar_sub(SCALAR_0, self_mod_l));
}
exports.negate_scalar = negate_scalar;
/*
pub(crate) fn non_adjacent_form(&self, w: usize) -> [i8; 256] {
        // required by the NAF definition
        debug_assert!( w >= 2 );
        // required so that the NAF digits fit in i8
        debug_assert!( w <= 8 );

        use byteorder::{ByteOrder, LittleEndian};

        let mut naf = [0i8; 256];

        let mut x_u64 = [0u64; 5];
        LittleEndian::read_u64_into(&self.bytes, &mut x_u64[0..4]);

        let width = 1 << w;
        let window_mask = width - 1;

        let mut pos = 0;
        let mut carry = 0;
        while pos < 256 {
            // Construct a buffer of bits of the scalar, starting at bit `pos`
            let u64_idx = pos / 64;
            let bit_idx = pos % 64;
            let bit_buf: u64;
            if bit_idx < 64 - w {
                // This window's bits are contained in a single u64
                bit_buf = x_u64[u64_idx] >> bit_idx;
            } else {
                // Combine the current u64's bits with the bits from the next u64
                bit_buf = (x_u64[u64_idx] >> bit_idx) | (x_u64[1+u64_idx] << (64 - bit_idx));
            }

            // Add the carry into the current window
            let window = carry + (bit_buf & window_mask);

            if window & 1 == 0 {
                // If the window value is even, preserve the carry and continue.
                // Why is the carry preserved?
                // If carry == 0 and window & 1 == 0, then the next carry should be 0
                // If carry == 1 and window & 1 == 0, then bit_buf & 1 == 1 so the next carry should be 1
                pos += 1;
                continue;
            }

            if window < width/2 {
                carry = 0;
                naf[pos] = window as i8;
            } else {
                carry = 1;
                naf[pos] = (window as i8).wrapping_sub(width as i8);
            }

            pos += w;
        }

        naf
    }
*/
function scalar_non_adjacent_form(scalar, w) {
    // required by the NAF definition
    if (w < 2)
        throw new Error("w must be >= 2");
    // required so that the NAF digits fit in i8
    if (w > 8)
        throw new Error("w must be <= 8");
    var naf = new Int8Array(256);
    var naf_u8 = new Uint8Array(naf.buffer);
    var x_u64 = new BigUint64Array(5);
    // LittleEndian::read_u64_into(&self.bytes, &mut x_u64[0..4]);
    read_u64_into_LE(scalar, x_u64, 4);
    var width = _1n << BigInt(w);
    var window_mask = width - _1n;
    var pos = 0;
    var carry = _0n;
    while (pos < 256) {
        var u64_idx = (pos / 64) >>> 0;
        var bit_idx = pos % 64;
        var bit_buf = void 0;
        if (bit_idx < 64 - w)
            bit_buf = x_u64[u64_idx] >> BigInt(bit_idx);
        else
            bit_buf = (x_u64[u64_idx] >> BigInt(bit_idx)) | (x_u64[1 + u64_idx] << BigInt(64 - bit_idx));
        var window_1 = carry + (bit_buf & window_mask);
        if ((window_1 & _1n) === _0n) {
            // If the window value is even, preserve the carry and continue.
            // Why is the carry preserved?
            // If carry == 0 and window & 1 == 0, then the next carry should be 0
            // If carry == 1 and window & 1 == 0, then bit_buf & 1 == 1 so the next carry should be 1
            pos += 1;
            continue;
        }
        if (window_1 < (width / BigInt(2))) {
            carry = _0n;
            naf_u8[pos] = Number(window_1) & 0xff;
        }
        else {
            carry = _1n;
            naf_u8[pos] = (Number(window_1) - Number(width)) & 0xff;
        }
        pos += w;
    }
    return naf;
}
function read_u64_into_LE(src, dst, dst_len) {
    if (dst_len === void 0) { dst_len = (Math.min(dst.length * 8, src.length) / 8) >>> 0; }
    if (src.length > dst.length * 8) {
        throw new Error("Source and destination size mismatch");
    }
    var srcView = new DataView(src.buffer, src.byteOffset, src.byteLength);
    var dstView = new DataView(dst.buffer, dst.byteOffset, dst.byteLength);
    for (var i = 0; i < dst_len; i++) {
        dstView.setBigUint64(i * 8, srcView.getBigUint64(i * 8, true), true);
    }
}
var AFFINE_ODD_MULTIPLES_OF_BASEPOINT = new NafLookupTable([
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3540182452943730"),
        BigInt("2497478415033846"),
        BigInt("2521227595762870"),
        BigInt("1462984067271729"),
        BigInt("2389212253076811"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("62697248952638"),
        BigInt("204681361388450"),
        BigInt("631292143396476"),
        BigInt("338455783676468"),
        BigInt("1213667448819585"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("301289933810280"),
        BigInt("1259582250014073"),
        BigInt("1422107436869536"),
        BigInt("796239922652654"),
        BigInt("1953934009299142"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1601611775252272"),
        BigInt("1720807796594148"),
        BigInt("1132070835939856"),
        BigInt("3512254832574799"),
        BigInt("2147779492816910"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("316559037616741"),
        BigInt("2177824224946892"),
        BigInt("1459442586438991"),
        BigInt("1461528397712656"),
        BigInt("751590696113597"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1850748884277385"),
        BigInt("1200145853858453"),
        BigInt("1068094770532492"),
        BigInt("672251375690438"),
        BigInt("1586055907191707"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("769950342298400"),
        BigInt("2384754244604994"),
        BigInt("3095885746880802"),
        BigInt("3225892188161580"),
        BigInt("2977876099231263"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("425251763115706"),
        BigInt("608463272472562"),
        BigInt("442562545713235"),
        BigInt("837766094556764"),
        BigInt("374555092627893"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1086255230780037"),
        BigInt("274979815921559"),
        BigInt("1960002765731872"),
        BigInt("929474102396301"),
        BigInt("1190409889297339"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2916800678241215"),
        BigInt("2065379846933858"),
        BigInt("2622030924071124"),
        BigInt("2602788184473875"),
        BigInt("1233371373142984"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("2019367628972465"),
        BigInt("676711900706637"),
        BigInt("110710997811333"),
        BigInt("1108646842542025"),
        BigInt("517791959672113"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("965130719900578"),
        BigInt("247011430587952"),
        BigInt("526356006571389"),
        BigInt("91986625355052"),
        BigInt("2157223321444601"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1802695059464988"),
        BigInt("1664899123557221"),
        BigInt("2845359304426105"),
        BigInt("2160434469266658"),
        BigInt("3179370264440279"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1725674970513508"),
        BigInt("1933645953859181"),
        BigInt("1542344539275782"),
        BigInt("1767788773573747"),
        BigInt("1297447965928905"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1381809363726107"),
        BigInt("1430341051343062"),
        BigInt("2061843536018959"),
        BigInt("1551778050872521"),
        BigInt("2036394857967624"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("4222693909998302"),
        BigInt("2779866139518454"),
        BigInt("1619374932191226"),
        BigInt("2207306624415883"),
        BigInt("1169170329061080"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("2070390218572616"),
        BigInt("1458919061857835"),
        BigInt("624171843017421"),
        BigInt("1055332792707765"),
        BigInt("433987520732508"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("893653801273833"),
        BigInt("1168026499324677"),
        BigInt("1242553501121234"),
        BigInt("1306366254304474"),
        BigInt("1086752658510815"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2465253816303469"),
        BigInt("3191571337672685"),
        BigInt("1159882208056013"),
        BigInt("2569188183312765"),
        BigInt("621213314200686"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1971678598905747"),
        BigInt("338026507889165"),
        BigInt("762398079972271"),
        BigInt("655096486107477"),
        BigInt("42299032696322"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("177130678690680"),
        BigInt("1754759263300204"),
        BigInt("1864311296286618"),
        BigInt("1180675631479880"),
        BigInt("1292726903152791"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1913163449625248"),
        BigInt("2712579013977241"),
        BigInt("2193883288642313"),
        BigInt("1008900146920800"),
        BigInt("1721983679009502"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1070401523076875"),
        BigInt("1272492007800961"),
        BigInt("1910153608563310"),
        BigInt("2075579521696771"),
        BigInt("1191169788841221"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("692896803108118"),
        BigInt("500174642072499"),
        BigInt("2068223309439677"),
        BigInt("1162190621851337"),
        BigInt("1426986007309901"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1819621230288238"),
        BigInt("2735700366193240"),
        BigInt("1755134670739586"),
        BigInt("3080648199451191"),
        BigInt("4172807995775876"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("992069868904071"),
        BigInt("799011518185730"),
        BigInt("1777586403832768"),
        BigInt("1134820506145684"),
        BigInt("1999461475558530"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("425204543703124"),
        BigInt("2040469794090382"),
        BigInt("1651690622153809"),
        BigInt("1500530168597569"),
        BigInt("1253908377065966"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2105824306960939"),
        BigInt("1387520302709358"),
        BigInt("3633176580451016"),
        BigInt("2211816663841753"),
        BigInt("1629085891776489"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1485201376284999"),
        BigInt("1022406647424656"),
        BigInt("504181009209019"),
        BigInt("962621520820995"),
        BigInt("590876713147230"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("265873406365287"),
        BigInt("1192742653492898"),
        BigInt("88553098803050"),
        BigInt("525037770869640"),
        BigInt("1266933811251234"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3552316659826612"),
        BigInt("1254279525791875"),
        BigInt("1609927932077699"),
        BigInt("3578654071679972"),
        BigInt("3750681296069893"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("37186803519861"),
        BigInt("1404297334376301"),
        BigInt("578519728836650"),
        BigInt("1740727951192592"),
        BigInt("2095534282477028"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("833234263154399"),
        BigInt("2023862470013762"),
        BigInt("1854137933982069"),
        BigInt("853924318090959"),
        BigInt("1589812702805850"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3679150557957763"),
        BigInt("1319179453661745"),
        BigInt("497496853611112"),
        BigInt("2665464286942351"),
        BigInt("1208137952365560"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1654513078530905"),
        BigInt("907489875842908"),
        BigInt("126098711296368"),
        BigInt("1726320004173677"),
        BigInt("28269495058173"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("114436686957443"),
        BigInt("532739313025996"),
        BigInt("115428841215897"),
        BigInt("2191499400074366"),
        BigInt("370280402676434"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1111146849833253"),
        BigInt("2016430049079759"),
        BigInt("1860522747477948"),
        BigInt("3537164738290194"),
        BigInt("4137142824844184"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("429069864577128"),
        BigInt("975327637149449"),
        BigInt("237881983565075"),
        BigInt("1654761232378630"),
        BigInt("2122527599091807"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("2093793463548278"),
        BigInt("754827233241879"),
        BigInt("1420389751719629"),
        BigInt("1829952782588138"),
        BigInt("2011865756773717"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("676293365438898"),
        BigInt("2850296017886344"),
        BigInt("1205350322490195"),
        BigInt("2763699392265669"),
        BigInt("2133931188538142"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("48340340349120"),
        BigInt("1299261101494832"),
        BigInt("1137329686775218"),
        BigInt("1534848106674340"),
        BigInt("1351662218216799"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1904520614137939"),
        BigInt("1590301001714014"),
        BigInt("215781420985270"),
        BigInt("2043534301034629"),
        BigInt("1970888949300424"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2365217962409710"),
        BigInt("2061307169694064"),
        BigInt("1887478590157603"),
        BigInt("2169639621284316"),
        BigInt("2373810867477200"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1020052624656948"),
        BigInt("1260412094216707"),
        BigInt("366721640607121"),
        BigInt("585331442306596"),
        BigInt("345876457758061"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("975390299880933"),
        BigInt("1066555195234642"),
        BigInt("12651997758352"),
        BigInt("1184252205433068"),
        BigInt("1058378155074223"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1431537716602643"),
        BigInt("2024827957433813"),
        BigInt("3746434518400495"),
        BigInt("1087794891033550"),
        BigInt("2156817571680455"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("929288033346881"),
        BigInt("255179964546973"),
        BigInt("711057989588035"),
        BigInt("208899572612840"),
        BigInt("185348357387383"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("823689746424808"),
        BigInt("47266130989546"),
        BigInt("209403309368097"),
        BigInt("1100966895202707"),
        BigInt("710792075292719"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2311213117823762"),
        BigInt("3296668540922318"),
        BigInt("2004276520649823"),
        BigInt("1861500579441125"),
        BigInt("3148029033359833"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1563693677475261"),
        BigInt("1843782073741194"),
        BigInt("1950700654453170"),
        BigInt("911540858113949"),
        BigInt("2085151496302359"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1427880892005482"),
        BigInt("106216431121745"),
        BigInt("42608394782284"),
        BigInt("1217295886989793"),
        BigInt("1514235272796882"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3544335535746750"),
        BigInt("2367994491347456"),
        BigInt("2567261456502612"),
        BigInt("1854058085060971"),
        BigInt("2263545563461076"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("787426011300053"),
        BigInt("2105981035769060"),
        BigInt("1130476291127206"),
        BigInt("1748659348100075"),
        BigInt("53470983013756"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("553548273865386"),
        BigInt("5927805718390"),
        BigInt("65184587381926"),
        BigInt("633576679686953"),
        BigInt("576048559439973"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("993787326657446"),
        BigInt("3868807161609258"),
        BigInt("1615796046728943"),
        BigInt("2514644292681953"),
        BigInt("2059021068660907"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("251010270518880"),
        BigInt("1681684095763484"),
        BigInt("1521949356387564"),
        BigInt("431593457045116"),
        BigInt("1855308922422910"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("618490909691959"),
        BigInt("1257497595618257"),
        BigInt("202952467594088"),
        BigInt("35577762721238"),
        BigInt("1494883566841973"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1673474571932262"),
        BigInt("2409784519770613"),
        BigInt("2636095316260487"),
        BigInt("2761112584601925"),
        BigInt("3333713288149876"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1600640202645197"),
        BigInt("1019569075331823"),
        BigInt("1041916487915822"),
        BigInt("1680448171313267"),
        BigInt("2126903137527901"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("894964745143659"),
        BigInt("106116880092678"),
        BigInt("1009869382959477"),
        BigInt("317866368542032"),
        BigInt("1986983122763912"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1765281781276487"),
        BigInt("2863247187455184"),
        BigInt("2589075472439062"),
        BigInt("1386435905543054"),
        BigInt("2182338478845320"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1144730936996693"),
        BigInt("2213315231278180"),
        BigInt("1489676672185125"),
        BigInt("665039429138074"),
        BigInt("1131283313040268"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("2004734176670602"),
        BigInt("1738311085075235"),
        BigInt("418866995976618"),
        BigInt("1050782508034394"),
        BigInt("577747313404652"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2185209688340293"),
        BigInt("1309276076461009"),
        BigInt("2514740038571278"),
        BigInt("3994889904012999"),
        BigInt("3018098826231021"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1405936970888515"),
        BigInt("1754621155316654"),
        BigInt("1211862168554999"),
        BigInt("1813045702919083"),
        BigInt("997853418197172"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("82037622045021"),
        BigInt("1646398333621944"),
        BigInt("613095452763466"),
        BigInt("1312329542583705"),
        BigInt("81014679202721"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2389287991277873"),
        BigInt("403851022333257"),
        BigInt("1597473361477193"),
        BigInt("2953351602509212"),
        BigInt("2135174663049062"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1826548187201150"),
        BigInt("302299893734126"),
        BigInt("1475477168615781"),
        BigInt("842617616347376"),
        BigInt("1438600873676130"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("663049852468609"),
        BigInt("1649295727846569"),
        BigInt("1048009692742781"),
        BigInt("628866177992421"),
        BigInt("1914360327429204"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1795645928096646"),
        BigInt("306878154408959"),
        BigInt("2924901319092394"),
        BigInt("2801261341654799"),
        BigInt("1653782432983523"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("2077597317438627"),
        BigInt("212642017882064"),
        BigInt("674844477518888"),
        BigInt("875487498687554"),
        BigInt("2060550250171182"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1420448018683809"),
        BigInt("1032663994771382"),
        BigInt("1341927003385267"),
        BigInt("1340360916546159"),
        BigInt("1988547473895228"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1082660122598844"),
        BigInt("2545055705583789"),
        BigInt("3888919679589007"),
        BigInt("1670283344995811"),
        BigInt("3403239134794618"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("90430593339788"),
        BigInt("1838338032241275"),
        BigInt("571293238480915"),
        BigInt("1639938867416883"),
        BigInt("257378872001111"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1528535658865034"),
        BigInt("1516636853043960"),
        BigInt("787000569996728"),
        BigInt("1464531394704506"),
        BigInt("1684822625133795"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("811329918113934"),
        BigInt("2783463529007378"),
        BigInt("1769095754634835"),
        BigInt("2970819621866866"),
        BigInt("881037178164325"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1784566501964517"),
        BigInt("433890943689325"),
        BigInt("1186055625589419"),
        BigInt("1496077405487512"),
        BigInt("1731807117886548"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("424909811816304"),
        BigInt("1355993963741797"),
        BigInt("409606483251841"),
        BigInt("455665350637068"),
        BigInt("1617009023642808"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2478728492077816"),
        BigInt("2780289048655501"),
        BigInt("2328687177473769"),
        BigInt("4107341333582032"),
        BigInt("1316147724308250"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1617420574301156"),
        BigInt("1741273341070467"),
        BigInt("667135503486508"),
        BigInt("2100436564640123"),
        BigInt("1032223920000865"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1753947659404033"),
        BigInt("247279202390193"),
        BigInt("1819288880178945"),
        BigInt("737334285670249"),
        BigInt("1037873664856104"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1762568490530034"),
        BigInt("673742465299012"),
        BigInt("2054571050635888"),
        BigInt("2040165159255111"),
        BigInt("3040123733327257"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1627187989987422"),
        BigInt("1686331580821752"),
        BigInt("1309895873498183"),
        BigInt("719718719104086"),
        BigInt("300063199808722"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("238176707016164"),
        BigInt("1440454788877048"),
        BigInt("203336037573144"),
        BigInt("1437789888677072"),
        BigInt("101522256664211"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1895216760098480"),
        BigInt("1934324337975022"),
        BigInt("3677350688973167"),
        BigInt("2536415965456176"),
        BigInt("714678003308640"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("508185358728815"),
        BigInt("1691320535341855"),
        BigInt("2168887448239256"),
        BigInt("1035124393070661"),
        BigInt("1936603999698584"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("390562831571647"),
        BigInt("1390223890708972"),
        BigInt("1383183990676371"),
        BigInt("435998174196410"),
        BigInt("1882086414390730"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3747620842612921"),
        BigInt("2081794785291195"),
        BigInt("3284594056262745"),
        BigInt("2090090346797895"),
        BigInt("2581692978935809"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("244144781251265"),
        BigInt("1290834426417077"),
        BigInt("1888701171101942"),
        BigInt("1233922456644870"),
        BigInt("241117402207491"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1266169390045455"),
        BigInt("1148042013187970"),
        BigInt("878921907853942"),
        BigInt("1815738019658093"),
        BigInt("908920199341621"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2521768507305118"),
        BigInt("953557056811112"),
        BigInt("2015863732865770"),
        BigInt("1358382511861315"),
        BigInt("2835421647899992"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("2239837206240498"),
        BigInt("330928973149665"),
        BigInt("422268062913642"),
        BigInt("1481280019493032"),
        BigInt("619879520439841"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1360166735366017"),
        BigInt("1770556573948510"),
        BigInt("1395061284191031"),
        BigInt("1814003148068126"),
        BigInt("522781147076884"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2611794802645686"),
        BigInt("707234844948070"),
        BigInt("1314059396506491"),
        BigInt("2919250341703934"),
        BigInt("2161831667832785"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("934831784182383"),
        BigInt("433734253968318"),
        BigInt("1660867106725771"),
        BigInt("1968393082772831"),
        BigInt("873946300968490"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("26306827827554"),
        BigInt("430884999378685"),
        BigInt("1504310424376419"),
        BigInt("1761358720837522"),
        BigInt("542195685418530"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1762131062631725"),
        BigInt("3123952634417535"),
        BigInt("3619918390837537"),
        BigInt("2909990877347294"),
        BigInt("1411594230004385"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("538272372224622"),
        BigInt("1425714779586199"),
        BigInt("588313661410172"),
        BigInt("1497062084392578"),
        BigInt("1602174047128512"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("907490361939255"),
        BigInt("1963620338391363"),
        BigInt("626927432296975"),
        BigInt("1250748516081414"),
        BigInt("959901171882527"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1335066153744413"),
        BigInt("2887804660779657"),
        BigInt("2653073855954038"),
        BigInt("2765226981667422"),
        BigInt("938831784476763"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("296699434737224"),
        BigInt("2047543711075683"),
        BigInt("2076451038937139"),
        BigInt("227783599906901"),
        BigInt("1602062110967627"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1574834773194203"),
        BigInt("1384279952062839"),
        BigInt("393652417255803"),
        BigInt("2166968242848859"),
        BigInt("1552890441390820"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1619646774410947"),
        BigInt("1576090644023562"),
        BigInt("3035228391320965"),
        BigInt("1735328519940543"),
        BigInt("2355324535937066"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1024074573633446"),
        BigInt("957088456885874"),
        BigInt("1690425531356997"),
        BigInt("2102187380180052"),
        BigInt("1082544623222033"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1871906170635853"),
        BigInt("1719383891167200"),
        BigInt("1584032250247862"),
        BigInt("823764804192117"),
        BigInt("2244048510084261"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("642147846489775"),
        BigInt("3334304977145699"),
        BigInt("305205716788147"),
        BigInt("2589176626729533"),
        BigInt("2224680511484174"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1734162377166545"),
        BigInt("260713621840346"),
        BigInt("157174591942595"),
        BigInt("952544272517991"),
        BigInt("222818702471733"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1213115494182947"),
        BigInt("286778704335711"),
        BigInt("2130189536016490"),
        BigInt("308349182281342"),
        BigInt("1217623948685491"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3360052266973635"),
        BigInt("1843486583624091"),
        BigInt("1561693837124349"),
        BigInt("1084041964025479"),
        BigInt("1866270922024009"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("460705465481210"),
        BigInt("1968151453817859"),
        BigInt("497005926994844"),
        BigInt("625618055866751"),
        BigInt("2176893440866887"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1655800250476757"),
        BigInt("2036588542300609"),
        BigInt("666447448675243"),
        BigInt("1615721995750683"),
        BigInt("1508669225186765"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2245948203759141"),
        BigInt("1058306669699396"),
        BigInt("1452898014240582"),
        BigInt("3961024141962768"),
        BigInt("1633235287338608"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("986647273684279"),
        BigInt("1507266907811370"),
        BigInt("1260572633649005"),
        BigInt("2071672342077446"),
        BigInt("695976026010857"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1312356620823495"),
        BigInt("1635278548098567"),
        BigInt("901946076841033"),
        BigInt("585120475533168"),
        BigInt("1240667113237384"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2313723935779695"),
        BigInt("1506054666773895"),
        BigInt("996040223525031"),
        BigInt("636592914999692"),
        BigInt("1497801917020297"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("292042016419794"),
        BigInt("1158932298133044"),
        BigInt("2062611870323738"),
        BigInt("1946058478962569"),
        BigInt("1749165808126286"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("654683942212830"),
        BigInt("1526897351349087"),
        BigInt("2006818439922838"),
        BigInt("2194919327350361"),
        BigInt("1451960776874416"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3015041017808905"),
        BigInt("2951823141773809"),
        BigInt("2584865668253675"),
        BigInt("2508192032998563"),
        BigInt("2582137700042019"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1628123495344283"),
        BigInt("2072923641214546"),
        BigInt("1647225812023982"),
        BigInt("855655925244679"),
        BigInt("1758126430071140"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1615895096489599"),
        BigInt("275295258643784"),
        BigInt("937665541219916"),
        BigInt("1313496726746346"),
        BigInt("1186468946422626"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1603070202850694"),
        BigInt("2072127623773242"),
        BigInt("1692648737212158"),
        BigInt("2493373404187852"),
        BigInt("1248948672117105"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("11167836031898"),
        BigInt("596565174397990"),
        BigInt("2196351068723859"),
        BigInt("314744641791907"),
        BigInt("1102014997250781"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1409047922401191"),
        BigInt("69960384467966"),
        BigInt("688103515547600"),
        BigInt("1309746102488044"),
        BigInt("150292892873778"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1986083055103168"),
        BigInt("691715819340300"),
        BigInt("1361811659746933"),
        BigInt("3459052030333434"),
        BigInt("1063594696046061"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1201987338414749"),
        BigInt("2198784582460616"),
        BigInt("1203335513981498"),
        BigInt("489243077045066"),
        BigInt("2205278143582433"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("2034744376624534"),
        BigInt("2077387101466387"),
        BigInt("148448542974969"),
        BigInt("1502697574577258"),
        BigInt("473186584705655"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("472016956315960"),
        BigInt("720786972252993"),
        BigInt("2840633661190043"),
        BigInt("3150798753357827"),
        BigInt("2816563335499153"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("253464247569755"),
        BigInt("168314237403057"),
        BigInt("511780806170295"),
        BigInt("1058862316549135"),
        BigInt("1646858476817137"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("595092995922219"),
        BigInt("1491311840717691"),
        BigInt("291581784452778"),
        BigInt("1569186646367854"),
        BigInt("1031385061400544"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3483137021572755"),
        BigInt("1526955102024322"),
        BigInt("2778006642704458"),
        BigInt("457549634924205"),
        BigInt("1097420237736736"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1246991699537710"),
        BigInt("81367319519439"),
        BigInt("530844036072196"),
        BigInt("163656863755855"),
        BigInt("1950742455979290"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("191532664076407"),
        BigInt("539378506082089"),
        BigInt("1021612562876554"),
        BigInt("1026603384732632"),
        BigInt("1773368780410653"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("4144620731387879"),
        BigInt("590179521333342"),
        BigInt("4034023318016108"),
        BigInt("2255745030335426"),
        BigInt("2699746851701250"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("2206599697359952"),
        BigInt("553895797384417"),
        BigInt("181689161933786"),
        BigInt("1153123447919104"),
        BigInt("778568064152659"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1706307000059211"),
        BigInt("1885601289314487"),
        BigInt("889758608505788"),
        BigInt("550131729999853"),
        BigInt("1006862664714268"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3210197754285058"),
        BigInt("2048500453422630"),
        BigInt("3403309827888207"),
        BigInt("927154428508963"),
        BigInt("4199813798872019"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("992058915374933"),
        BigInt("476120535358775"),
        BigInt("1973648780784340"),
        BigInt("2025282643598818"),
        BigInt("2182318983793230"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1343440812005821"),
        BigInt("1316045839091795"),
        BigInt("1884951299078063"),
        BigInt("1765919609219175"),
        BigInt("2197567554627988"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3129247779382818"),
        BigInt("4415026969054274"),
        BigInt("1900265885969643"),
        BigInt("1528796215447059"),
        BigInt("2172730393748688"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1773355092297603"),
        BigInt("64654329538271"),
        BigInt("1332124041660957"),
        BigInt("748492100858001"),
        BigInt("895500006200535"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("2000840647851980"),
        BigInt("546565968824914"),
        BigInt("420633283457524"),
        BigInt("195470736374507"),
        BigInt("1958689297569520"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("743138980705446"),
        BigInt("3411117504637167"),
        BigInt("2591389959690621"),
        BigInt("2380042066577202"),
        BigInt("3022267940115114"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("165947002229363"),
        BigInt("115186103724967"),
        BigInt("1068573292121517"),
        BigInt("1842565776920938"),
        BigInt("1969395681111987"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("553322266190633"),
        BigInt("234265665613185"),
        BigInt("484544650202821"),
        BigInt("1238773526575826"),
        BigInt("2017991917953668"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2581954631514051"),
        BigInt("1245093644265357"),
        BigInt("3537016673825374"),
        BigInt("1834216551713857"),
        BigInt("923978372152807"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1855378315339552"),
        BigInt("890045579230758"),
        BigInt("1764718173975590"),
        BigInt("197904186055854"),
        BigInt("1718129022310327"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1278162928734862"),
        BigInt("1894118254109862"),
        BigInt("987503995465517"),
        BigInt("177406744098996"),
        BigInt("781538103127693"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1996603431230215"),
        BigInt("1191888797552937"),
        BigInt("1207440075928499"),
        BigInt("2765853449051137"),
        BigInt("2525314961343288"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("808903879370889"),
        BigInt("990820108751280"),
        BigInt("1084429472258867"),
        BigInt("1078562781312589"),
        BigInt("254514692695625"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("615855140068469"),
        BigInt("586046731175395"),
        BigInt("693470779212674"),
        BigInt("1964537100203868"),
        BigInt("1350330550265229"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3344544372023708"),
        BigInt("720386671449874"),
        BigInt("2480841360702110"),
        BigInt("2036034126860286"),
        BigInt("2015744690201389"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1337446193390478"),
        BigInt("1984110761311871"),
        BigInt("746489405020285"),
        BigInt("407347127604128"),
        BigInt("1740475330360596"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("140840424783613"),
        BigInt("1063284623568331"),
        BigInt("1136446106453878"),
        BigInt("372042229029799"),
        BigInt("442607248430694"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2330781679120937"),
        BigInt("376801425148230"),
        BigInt("2032603686676107"),
        BigInt("1488926293635130"),
        BigInt("1317278311532959"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1290116731380016"),
        BigInt("2166899563471713"),
        BigInt("831997001838078"),
        BigInt("870954980505220"),
        BigInt("2108537278055823"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1912719171026343"),
        BigInt("846194720551034"),
        BigInt("2043988124740726"),
        BigInt("993234269653961"),
        BigInt("421229796383281"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2651184584992902"),
        BigInt("2775702557638963"),
        BigInt("2539786009779572"),
        BigInt("2575974880015305"),
        BigInt("2122619079836732"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1154054290132562"),
        BigInt("931753998725577"),
        BigInt("1647742001778052"),
        BigInt("865765466488226"),
        BigInt("1083816107290025"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("986341121095108"),
        BigInt("1522330369638573"),
        BigInt("1990880546211047"),
        BigInt("501525962272123"),
        BigInt("198539304862139"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1496414019192687"),
        BigInt("3991034436173951"),
        BigInt("3380311659062196"),
        BigInt("2854747485359158"),
        BigInt("3346958036643152"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("805612068303425"),
        BigInt("1891790027761335"),
        BigInt("1587008567571549"),
        BigInt("722120737390201"),
        BigInt("378156757163816"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1588994517921951"),
        BigInt("977362751042302"),
        BigInt("1329302387067714"),
        BigInt("2069348224564088"),
        BigInt("1586007159625211"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2490539421551682"),
        BigInt("1985699850375015"),
        BigInt("2331762317128172"),
        BigInt("4145097393776678"),
        BigInt("2521049460190674"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("615817553313996"),
        BigInt("2245962768078178"),
        BigInt("482564324326173"),
        BigInt("2101336843140780"),
        BigInt("1240914880829407"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1438242482238189"),
        BigInt("874267817785463"),
        BigInt("1620810389770625"),
        BigInt("866155221338671"),
        BigInt("1040426546798301"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("2403083624110300"),
        BigInt("2548561409802975"),
        BigInt("2492699136535911"),
        BigInt("2358289519456539"),
        BigInt("3203964320363148"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1913986535403097"),
        BigInt("1977163223054199"),
        BigInt("1972905914623196"),
        BigInt("1650122133472502"),
        BigInt("1905849310819035"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("858174816360838"),
        BigInt("614595356564037"),
        BigInt("1099584959044836"),
        BigInt("636998087084906"),
        BigInt("1070393269058348"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3666695924830668"),
        BigInt("3585640662737501"),
        BigInt("2372994528684236"),
        BigInt("2628565977288995"),
        BigInt("3482812783469694"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1994161359147952"),
        BigInt("2198039369802658"),
        BigInt("62790022842537"),
        BigInt("1522306785848169"),
        BigInt("951223194802833"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("852296621440717"),
        BigInt("431889737774209"),
        BigInt("370755457746189"),
        BigInt("437604073958073"),
        BigInt("627857326892757"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1794955764684156"),
        BigInt("2586904290013612"),
        BigInt("1322647643615887"),
        BigInt("856117964085888"),
        BigInt("2652432778663153"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("933592377399646"),
        BigInt("78031722952813"),
        BigInt("926049890685253"),
        BigInt("1471649501316246"),
        BigInt("33789909190376"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1479319468832059"),
        BigInt("203906207621608"),
        BigInt("659828362330083"),
        BigInt("44358398435755"),
        BigInt("1273573524210803"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1592342143350813"),
        BigInt("3227219208247713"),
        BigInt("2345240352078765"),
        BigInt("2577750109932929"),
        BigInt("2933512841197243"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("2184946892642995"),
        BigInt("1517382324576002"),
        BigInt("1557940277419806"),
        BigInt("2170635134813213"),
        BigInt("747314658627002"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1823193620577742"),
        BigInt("1135817878516419"),
        BigInt("1731253819308581"),
        BigInt("1031652967267804"),
        BigInt("2123506616999453"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1346190246005805"),
        BigInt("2052692552023851"),
        BigInt("1718128041785940"),
        BigInt("2491557332978474"),
        BigInt("3474370880388305"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("424776012994573"),
        BigInt("281050757243423"),
        BigInt("626466040846420"),
        BigInt("990194703866532"),
        BigInt("38571969885982"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("192408346595466"),
        BigInt("1054889725292349"),
        BigInt("584097975693004"),
        BigInt("1447909807397749"),
        BigInt("2134645004369136"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3169895788615063"),
        BigInt("3503097743181446"),
        BigInt("601598510029975"),
        BigInt("1422812237223371"),
        BigInt("2121009661378329"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1603348391996783"),
        BigInt("2066143816131699"),
        BigInt("1789627290363958"),
        BigInt("2145705961178118"),
        BigInt("1985578641438222"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("352633958653380"),
        BigInt("856927627345554"),
        BigInt("793925083122702"),
        BigInt("93551575767286"),
        BigInt("1222010153634215"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1756866499986349"),
        BigInt("911731956999969"),
        BigInt("2707505543214075"),
        BigInt("4006920335263786"),
        BigInt("822501008147910"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1094036422864347"),
        BigInt("1897208881572508"),
        BigInt("1503607738246960"),
        BigInt("1901060196071406"),
        BigInt("294068411105729"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("587776484399576"),
        BigInt("1116861711228807"),
        BigInt("343398777436088"),
        BigInt("936544065763093"),
        BigInt("1643746750211060"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("3477749685790410"),
        BigInt("267997399528836"),
        BigInt("2953780922004404"),
        BigInt("3252368924080907"),
        BigInt("3787792887348381"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("2042368155872443"),
        BigInt("41662387210459"),
        BigInt("1676313264498480"),
        BigInt("1333968523426810"),
        BigInt("1765708383352310"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1453394896690938"),
        BigInt("1585795827439909"),
        BigInt("1469309456804303"),
        BigInt("1294645324464404"),
        BigInt("2042954198665899"),
    ]))),
    new AffineNielsPoint(new FieldElem51(new BigUint64Array([
        BigInt("1810069207599881"),
        BigInt("1358344669503239"),
        BigInt("1989371257548167"),
        BigInt("2316270051121225"),
        BigInt("3019675451276507"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1866114438287676"),
        BigInt("1663420339568364"),
        BigInt("1437691317033088"),
        BigInt("538298302628038"),
        BigInt("1212711449614363"),
    ])), new FieldElem51(new BigUint64Array([
        BigInt("1769235035677897"),
        BigInt("1562012115317882"),
        BigInt("31277513664750"),
        BigInt("536198657928416"),
        BigInt("1976134212537183"),
    ]))),
]);


/***/ }),

/***/ 54334:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.scalar_from_bits_inplace = exports.vrf_ed25519_sha512_ell2_compute_challenge = exports.vrf_ed25519_sha512_ell2_nonce_generation = exports.scalar_hash_from_bytes = exports.vrf_ed25519_sha512_ell2_hash_to_curve = exports.edwards_hash_from_bytes = exports.proof_to_hash = exports.vrf_ed25519_sha512_ell2_verify_proof = exports.vrf_ed25519_sha512_ell2_generate_proof = exports.adjust_scalar_bits = exports.extend_secret_key = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var sha2_512_1 = __webpack_require__(1824);
var curves_1 = __webpack_require__(46732);
/**
4.4. RSA-FDH-VRF Ciphersuites

This document defines RSA-FDH-VRF-SHA256 as follows:

suite_string = 0x01.
The hash function Hash is SHA-256 as specified in [RFC6234], with hLen = 32.
MGF_salt = I2OSP(k, 4) || I2OSP(n, k).

This document defines RSA-FDH-VRF-SHA384 as follows:

suite_string = 0x02.
The hash function Hash is SHA-384 as specified in [RFC6234], with hLen = 48.
MGF_salt = I2OSP(k, 4) || I2OSP(n, k).

This document defines RSA-FDH-VRF-SHA512 as follows:

suite_string = 0x03.
The hash function Hash is SHA-512 as specified in [RFC6234], with hLen = 64.
MGF_salt = I2OSP(k, 4) || I2OSP(n, k).

 */
var SUITE = 0x04;
var ONE = 0x01;
var TWO = 0x02;
/*
pub fn extend(&self) -> (Scalar, [u8; 32]) {
    let mut h: Sha512 = Sha512::new();
    let mut extended = [0u8; 64];
    let mut secret_key_bytes = [0u8; 32];
    let mut extension = [0u8; 32];

    h.update(self.as_bytes());
    extended.copy_from_slice(&h.finalize().as_slice()[..64]);

    secret_key_bytes.copy_from_slice(&extended[..32]);
    extension.copy_from_slice(&extended[32..]);

    secret_key_bytes[0] &= 248;
    secret_key_bytes[31] &= 127;
    secret_key_bytes[31] |= 64;

    (Scalar::from_bits(secret_key_bytes), extension)
}
*/
function extend_secret_key(secret_key) {
    var extended = (0, sha2_512_1.sha2_512_sync)(secret_key);
    var secret_key_bytes = extended.slice(0, 32);
    var extension = extended.slice(32, 64);
    secret_key_bytes[0] &= 248;
    secret_key_bytes[31] &= 127;
    secret_key_bytes[31] |= 64;
    adjust_scalar_bits(secret_key_bytes);
    return [secret_key_bytes, extension];
}
exports.extend_secret_key = extend_secret_key;
function adjust_scalar_bits(bytes) {
    bytes[31] &= 127;
}
exports.adjust_scalar_bits = adjust_scalar_bits;
function vrf_ed25519_sha512_ell2_generate_proof(secret_key, public_key, alpha_string) {
    var _a = __read(extend_secret_key(secret_key), 2), secret_scalar = _a[0], secret_extension = _a[1];
    var h = vrf_ed25519_sha512_ell2_hash_to_curve(public_key, alpha_string);
    var compressed_h = h.compress();
    var gamma = h.scalarMul(secret_scalar);
    var compressed_gamma = gamma.compress();
    var k = vrf_ed25519_sha512_ell2_nonce_generation(secret_extension, compressed_h);
    var compressed_announcement_base = curves_1.ED25519_BASEPOINT_POINT.scalarMul(k).compress();
    var compressed_announcement_h = h.scalarMul(k).compress();
    // Self::compute_challenge(&compressed_h, &gamma, &announcement_base, &announcement_h);
    var challenge = vrf_ed25519_sha512_ell2_compute_challenge(compressed_h, compressed_gamma, compressed_announcement_base, compressed_announcement_h);
    var response = (0, curves_1.add_scalars)(k, (0, curves_1.mul_scalars)(challenge, secret_scalar));
    return {
        gamma: gamma,
        challenge: challenge,
        response: response
    };
}
exports.vrf_ed25519_sha512_ell2_generate_proof = vrf_ed25519_sha512_ell2_generate_proof;
/*
/// Verify VRF function, following the 03 specification.
    pub fn verify(
        &self,
        public_key: &PublicKey03,
        alpha_string: &[u8],
    ) -> Result<[u8; OUTPUT_SIZE], VrfError> {
        let h = Self::hash_to_curve(public_key, alpha_string);
        let compressed_h = h.compress();

        let decompressed_pk = public_key
            .0
            .decompress()
            .ok_or(VrfError::DecompressionFailed)?;

        if decompressed_pk.is_small_order() {
            return Err(VrfError::PkSmallOrder);
        }

        let U = EdwardsPoint::vartime_double_scalar_mul_basepoint(
            &self.challenge.neg(),
            &decompressed_pk,
            &self.response,
        );
        let V = EdwardsPoint::vartime_multiscalar_mul(
            iter::once(self.response).chain(iter::once(self.challenge.neg())),
            iter::once(h).chain(iter::once(self.gamma)),
        );

        // Now we compute the challenge
        let challenge = Self::compute_challenge(&compressed_h, &self.gamma, &U, &V);

        if challenge.to_bytes()[..16] == self.challenge.to_bytes()[..16] {
            Ok(self.proof_to_hash())
        } else {
            Err(VrfError::VerificationFailed)
        }
    }
*/
function vrf_ed25519_sha512_ell2_verify_proof(public_key, alpha_string, proof) {
    var h = vrf_ed25519_sha512_ell2_hash_to_curve(public_key, alpha_string);
    var compressed_h = h.compress();
    var decompressed_pk = (0, curves_1.decompressCompressedEdwardsY)(public_key); // pointFromBytes( public_key );
    if (!decompressed_pk || decompressed_pk.is_small_order())
        return false;
    // Scalar
    var proof_challenge = proof.challenge;
    var U = curves_1.EdwardsPoint.vartime_double_scalar_mul_basepoint((0, curves_1.negate_scalar)(proof_challenge), decompressed_pk, proof.response);
    var gamma = proof.gamma;
    /*
    let V = EdwardsPoint::vartime_multiscalar_mul(
            iter::once(self.response).chain(iter::once(self.challenge.neg())),
            iter::once(h).chain(iter::once(self.gamma)),
        );
    */
    var V = curves_1.EdwardsPoint.vartime_multiscalar_mul([proof.response, (0, curves_1.negate_scalar)(proof_challenge)], [h, gamma]);
    var computed_challenge = vrf_ed25519_sha512_ell2_compute_challenge(compressed_h, proof.gamma.compress(), U.compress(), V.compress());
    return (0, uint8array_utils_1.uint8ArrayEq)(computed_challenge.slice(0, 16), proof_challenge.slice(0, 16));
}
exports.vrf_ed25519_sha512_ell2_verify_proof = vrf_ed25519_sha512_ell2_verify_proof;
/*
/// `proof_to_hash` function, following the 03 specification. This computes the output of the VRF
    /// function. In particular, this function computes
    /// SHA512(SUITE || THREE || Gamma)
    pub fn proof_to_hash(&self) -> [u8; OUTPUT_SIZE] {
        let mut output = [0u8; OUTPUT_SIZE];
        let gamma_cofac = self.gamma.mul_by_cofactor();
        let mut hash = Sha512::new();
        hash.update(SUITE);
        hash.update(THREE);
        hash.update(gamma_cofac.compress().as_bytes());

        output.copy_from_slice(hash.finalize().as_slice());
        output
    }

*/
function proof_to_hash(proof) {
    var gamma_cofac = proof.gamma.mul_by_cofactor();
    var hashInput = new Uint8Array(2 + gamma_cofac.compress().length);
    hashInput[0] = SUITE;
    hashInput[1] = 0x03;
    hashInput.set(gamma_cofac.compress(), 2);
    return (0, sha2_512_1.sha2_512_sync)(hashInput);
}
exports.proof_to_hash = proof_to_hash;
/*
export function vrfProofToBytesProof( proof: IVrfProof03 )
{
    return {
        gamma: bigpointToUint8Array( proof.gamma ),
        challange: encodeInt( proof.challange ),
        response: encodeInt( proof.response ),
    }
}
//*/
function edwards_hash_from_bytes(bytes) {
    var hash = (0, sha2_512_1.sha2_512_sync)(bytes);
    var res = hash.slice(0, 32);
    /*
        //////////////////////////////////////////////////////////////////////////////////////
        //// We need to be compatible with the third version of the VRF standard, which   ////
        //// always unsets the sign bit. Given the visibility of the functions used to    ////
        //// compute the ristretto mapping, we need to fork the original repo, to unset   ////
        //// bit in this function. This fork should never be used, unless one needs to be ////
        //// compatible with the version 3 of the VRF standard.                           ////
        //// https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-vrf-03#section-5.4.1.2 ////
        //// The goal is to be always a single commit ahead of version 3.2.0, and this    ////
        //// single commit only changes the following line, and a disclaimer in the       ////
        //// README.                                                                      ////
        //////////////////////////////////////////////////////////////////////////////////////
        let sign_bit = 0;

        let fe = FieldElement::from_bytes(&res);

        let M1 = crate::montgomery::elligator_encode(&fe);
        let E1_opt = M1.to_edwards(sign_bit);

        E1_opt
            .expect("Montgomery conversion to Edwards point in Elligator failed")
            .mul_by_cofactor()
    */
    var sign_bit = 0;
    var fe = curves_1.FieldElem51.fromBytes(res);
    var M1 = curves_1.FieldElem51.elligator_encode(fe);
    var E1_opt = M1.to_edwards(sign_bit);
    if (!E1_opt) {
        throw new Error("Montgomery conversion to Edwards point in Elligator failed");
    }
    return E1_opt.mul_by_cofactor();
}
exports.edwards_hash_from_bytes = edwards_hash_from_bytes;
function vrf_ed25519_sha512_ell2_hash_to_curve(public_key, alpha_string) {
    var input = new Uint8Array(2 + public_key.length + alpha_string.length);
    input[0] = SUITE;
    input[1] = ONE;
    input.set(public_key, 2);
    input.set(alpha_string, 2 + public_key.length);
    return edwards_hash_from_bytes(input); // sha2_512_sync(input);
}
exports.vrf_ed25519_sha512_ell2_hash_to_curve = vrf_ed25519_sha512_ell2_hash_to_curve;
function scalar_hash_from_bytes(input) {
    return (0, curves_1.scalar_from_bytes_mod_order_wide)((0, sha2_512_1.sha2_512_sync)(input));
}
exports.scalar_hash_from_bytes = scalar_hash_from_bytes;
function vrf_ed25519_sha512_ell2_nonce_generation(secret_extension, compressed_h) {
    var input = new Uint8Array(64);
    input.set(secret_extension, 0);
    input.set(compressed_h, 32);
    //return pointFromBytes(sha2_512_sync(input))
    return scalar_hash_from_bytes(input);
}
exports.vrf_ed25519_sha512_ell2_nonce_generation = vrf_ed25519_sha512_ell2_nonce_generation;
/*
/// Hash points function, following the 03 specification.
    fn compute_challenge(
        compressed_h: &CompressedEdwardsY,
        gamma: &EdwardsPoint,
        announcement_1: &EdwardsPoint,
        announcement_2: &EdwardsPoint,
    ) -> Scalar {
        // we use a scalar of 16 bytes (instead of 32), but store it in 32 bits, as that is what
        // `Scalar::from_bits()` expects.
        let mut scalar_bytes = [0u8; 32];
        let mut challenge_hash = Sha512::new();
        challenge_hash.update(SUITE);
        challenge_hash.update(TWO);
        challenge_hash.update(compressed_h.to_bytes());
        challenge_hash.update(gamma.compress().as_bytes());
        challenge_hash.update(announcement_1.compress().as_bytes());
        challenge_hash.update(announcement_2.compress().as_bytes());

        scalar_bytes[..16].copy_from_slice(&challenge_hash.finalize().as_slice()[..16]);

        Scalar::from_bits(scalar_bytes)
    }
* /
export function vrf_ed25519_sha512_ell2_challenge_generation(
    H: Uint8Array,
    gamma: Uint8Array,
    announcement_1: Uint8Array,
    announcement_2: Uint8Array,
): Uint8Array
{
    // const input = new Uint8Array( 2 + H.length + gamma.length + announcement_1.length + announcement_2.length );
    // input[0] = SUITE;
    // input[1] = TWO;
    // input.set( H, 2 );
    // input.set( gamma, 2 + H.length );
    // input.set( announcement_1, 2 + H.length + gamma.length );
    // input.set( announcement_2, 2 + H.length + gamma.length + announcement_1.length );
    // return sha2_512_sync(input).slice(0,16);
}
//*/
function vrf_ed25519_sha512_ell2_compute_challenge(compressed_h, compressed_gamma, compressed_announcement_1, compressed_announcement_2) {
    var scalar_bytes = new Uint8Array(32);
    var hash_input = new Uint8Array(2 +
        compressed_h.length +
        compressed_gamma.length +
        compressed_announcement_1.length +
        compressed_announcement_2.length);
    hash_input[0] = SUITE;
    hash_input[1] = TWO;
    hash_input.set(compressed_h, 2);
    hash_input.set(compressed_gamma, 2 + compressed_h.length);
    hash_input.set(compressed_announcement_1, 2 + compressed_h.length + compressed_gamma.length);
    hash_input.set(compressed_announcement_2, 2 + compressed_h.length + compressed_gamma.length + compressed_announcement_1.length);
    var hash = (0, sha2_512_1.sha2_512_sync)(hash_input);
    scalar_bytes.set(hash.slice(0, 16), 0);
    scalar_from_bits_inplace(scalar_bytes);
    return scalar_bytes;
}
exports.vrf_ed25519_sha512_ell2_compute_challenge = vrf_ed25519_sha512_ell2_compute_challenge;
/*
// Construct a `Scalar` from the low 255 bits of a 256-bit integer.
    ///
    /// This function is intended for applications like X25519 which
    /// require specific bit-patterns when performing scalar
    /// multiplication.
    pub const fn from_bits(bytes: [u8; 32]) -> Scalar {
        let mut s = Scalar{bytes};
        // Ensure that s < 2^255 by masking the high bit
        s.bytes[31] &= 0b0111_1111;

        s
    }
*/
function scalar_from_bits_inplace(bytes) {
    bytes[31] &= 127;
}
exports.scalar_from_bits_inplace = scalar_from_bits_inplace;
/**
 * https://datatracker.ietf.org/doc/html/rfc9381#section-5.1
 *
 * test cases:
 * https://datatracker.ietf.org/doc/html/rfc9381#name-ecvrf-edwards25519-sha512-e
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-vrf-03#appendix-A.4
 *
 * /// Generate a new VRF proof following the 03 standard. It proceeds as follows:
 * /// - Extend the secret key, into a `secret_scalar` and the `secret_extension`
 * /// - Evaluate `hash_to_curve` over PK || alpha_string to get `H`
 * /// - Compute `Gamma = secret_scalar *  H`
 * /// - Generate a proof of discrete logarithm equality between `PK` and `Gamma` with
 * ///   bases `generator` and `H` respectively.
 *
 * /
export function vrf_ed25519_sha512_ell2_prove(sk: Uint8Array, alpha: Uint8Array): IVrfProof03
{
    /// - Extend the secret key, into a `secret_scalar` and the `secret_extension`
    const [ scalar, extension ] = getExtendEd25519PrivateKeyComponents_sync( sk );
    // 1. Use SK to derive the VRF secret scalar x and the VRF public key Y = x*B
    /// - Evaluate `hash_to_curve` over PK || alpha_string to get `H`
    const pk = new Uint8Array( deriveEd25519PublicKey_sync( sk ) );
    const H = vrf_ed25519_sha512_ell2_hash_to_curve( pk, alpha );
    
    const H_point = pointFromBytes( H );
    const gamma = scalarMul( H_point, scalar );
    const compressed_gamma = bigpointToUint8Array( gamma );
    const k = vrf_ed25519_sha512_ell2_nonce_generation( extension, H );
    const announcement_1 = bigpointToUint8Array( scalarMultBase( k ) );
    const announcement_2 = bigpointToUint8Array( scalarMul( H_point, k ) );
    const challange = scalarFromBytes(
        vrf_ed25519_sha512_ell2_challenge_generation( H, compressed_gamma, announcement_1, announcement_2 )
    );
    const response = k + challange * scalar;
    return {
        gamma,
        challange,
        response
    };
}
//*/ 


/***/ }),

/***/ 66222:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.scalar_from_bits_inplace = exports.vrf10_ed25519_sha512_ell2_compute_challenge = exports.vrf10_ed25519_sha512_ell2_nonce_generation = exports.scalar_hash_from_bytes = exports.vrf10_ed25519_sha512_ell2_hash_to_curve = exports.edwards_hash_from_bytes = exports.vrf10_proof_to_hash = exports.vrf10_ed25519_sha512_ell2_verify_proof = exports.vrf10_ed25519_sha512_ell2_generate_proof = exports.adjust_scalar_bits = exports.extend_secret_key = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var sha2_512_1 = __webpack_require__(1824);
var curves_1 = __webpack_require__(46732);
/**
4.4. RSA-FDH-VRF Ciphersuites

This document defines RSA-FDH-VRF-SHA256 as follows:

suite_string = 0x01.
The hash function Hash is SHA-256 as specified in [RFC6234], with hLen = 32.
MGF_salt = I2OSP(k, 4) || I2OSP(n, k).

This document defines RSA-FDH-VRF-SHA384 as follows:

suite_string = 0x02.
The hash function Hash is SHA-384 as specified in [RFC6234], with hLen = 48.
MGF_salt = I2OSP(k, 4) || I2OSP(n, k).

This document defines RSA-FDH-VRF-SHA512 as follows:

suite_string = 0x10.
The hash function Hash is SHA-512 as specified in [RFC6234], with hLen = 64.
MGF_salt = I2OSP(k, 4) || I2OSP(n, k).

 */
var SUITE = 0x04;
/*
/// Temporary SUITE identifier, as TAI uses 0x03
pub const SUITE_TEMP: &[u8] = &[0x03];
*/
var SUITE_TEMP = 0x03;
var ONE = 0x01;
var TWO = 0x02;
/*
pub fn extend(&self) -> (Scalar, [u8; 32]) {
    let mut h: Sha512 = Sha512::new();
    let mut extended = [0u8; 64];
    let mut secret_key_bytes = [0u8; 32];
    let mut extension = [0u8; 32];

    h.update(self.as_bytes());
    extended.copy_from_slice(&h.finalize().as_slice()[..64]);

    secret_key_bytes.copy_from_slice(&extended[..32]);
    extension.copy_from_slice(&extended[32..]);

    secret_key_bytes[0] &= 248;
    secret_key_bytes[31] &= 127;
    secret_key_bytes[31] |= 64;

    (Scalar::from_bits(secret_key_bytes), extension)
}
*/
function extend_secret_key(secret_key) {
    var extended = (0, sha2_512_1.sha2_512_sync)(secret_key);
    var secret_key_bytes = extended.slice(0, 32);
    var extension = extended.slice(32, 64);
    secret_key_bytes[0] &= 248;
    secret_key_bytes[31] &= 127;
    secret_key_bytes[31] |= 64;
    adjust_scalar_bits(secret_key_bytes);
    return [secret_key_bytes, extension];
}
exports.extend_secret_key = extend_secret_key;
function adjust_scalar_bits(bytes) {
    bytes[31] &= 127;
}
exports.adjust_scalar_bits = adjust_scalar_bits;
function vrf10_ed25519_sha512_ell2_generate_proof(secret_key, public_key, alpha_string) {
    var _a = __read(extend_secret_key(secret_key), 2), secret_scalar = _a[0], secret_extension = _a[1];
    var h = vrf10_ed25519_sha512_ell2_hash_to_curve(public_key, alpha_string);
    var compressed_h = h.compress();
    var gamma = h.scalarMul(secret_scalar);
    var compressed_gamma = gamma.compress();
    var k = vrf10_ed25519_sha512_ell2_nonce_generation(secret_extension, compressed_h);
    var compressed_announcement_base = curves_1.ED25519_BASEPOINT_POINT.scalarMul(k).compress();
    var compressed_announcement_h = h.scalarMul(k).compress();
    // Self::compute_challenge(&compressed_h, &gamma, &announcement_base, &announcement_h);
    var challenge = vrf10_ed25519_sha512_ell2_compute_challenge(compressed_h, compressed_gamma, compressed_announcement_base, compressed_announcement_h);
    var response = (0, curves_1.add_scalars)(k, (0, curves_1.mul_scalars)(challenge, secret_scalar));
    return {
        gamma: gamma,
        challenge: challenge,
        response: response
    };
}
exports.vrf10_ed25519_sha512_ell2_generate_proof = vrf10_ed25519_sha512_ell2_generate_proof;
/*
/// Verify VRF function, following the 10 specification.
    pub fn verify(
        &self,
        public_key: &PublicKey10,
        alpha_string: &[u8],
    ) -> Result<[u8; OUTPUT_SIZE], VrfError> {
        let h = Self::hash_to_curve(public_key, alpha_string);
        let compressed_h = h.compress();

        let decompressed_pk = public_key
            .0
            .decompress()
            .ok_or(VrfError::DecompressionFailed)?;

        if decompressed_pk.is_small_order() {
            return Err(VrfError::PkSmallOrder);
        }

        let U = EdwardsPoint::vartime_double_scalar_mul_basepoint(
            &self.challenge.neg(),
            &decompressed_pk,
            &self.response,
        );
        let V = EdwardsPoint::vartime_multiscalar_mul(
            iter::once(self.response).chain(iter::once(self.challenge.neg())),
            iter::once(h).chain(iter::once(self.gamma)),
        );

        // Now we compute the challenge
        let challenge = Self::compute_challenge(&compressed_h, &self.gamma, &U, &V);

        if challenge.to_bytes()[..16] == self.challenge.to_bytes()[..16] {
            Ok(self.proof_to_hash())
        } else {
            Err(VrfError::VerificationFailed)
        }
    }
*/
function vrf10_ed25519_sha512_ell2_verify_proof(public_key, alpha_string, proof) {
    var h = vrf10_ed25519_sha512_ell2_hash_to_curve(public_key, alpha_string);
    var compressed_h = h.compress();
    var decompressed_pk = (0, curves_1.decompressCompressedEdwardsY)(public_key); // pointFromBytes( public_key );
    if (!decompressed_pk || decompressed_pk.is_small_order())
        return false;
    // Scalar
    var proof_challenge = proof.challenge;
    var gamma = proof.gamma;
    var U = curves_1.EdwardsPoint.vartime_double_scalar_mul_basepoint((0, curves_1.negate_scalar)(proof_challenge), decompressed_pk, proof.response);
    /*
    let V = EdwardsPoint::vartime_multiscalar_mul(
            iter::once(self.response).chain(iter::once(self.challenge.neg())),
            iter::once(h).chain(iter::once(self.gamma)),
        );
    */
    var V = curves_1.EdwardsPoint.vartime_multiscalar_mul([proof.response, (0, curves_1.negate_scalar)(proof_challenge)], [h, gamma]);
    var computed_challenge = vrf10_ed25519_sha512_ell2_compute_challenge(compressed_h, proof.gamma.compress(), U.compress(), V.compress());
    return (0, uint8array_utils_1.uint8ArrayEq)(computed_challenge.slice(0, 16), proof_challenge.slice(0, 16));
}
exports.vrf10_ed25519_sha512_ell2_verify_proof = vrf10_ed25519_sha512_ell2_verify_proof;
/*
/// `proof_to_hash` function, following the 10 specification. This computes the output of the VRF
    /// function. In particular, this function computes
    /// SHA512(SUITE || THREE || Gamma || ZERO)
    fn proof_to_hash(&self) -> [u8; OUTPUT_SIZE] {
        let mut output = [0u8; OUTPUT_SIZE];
        let gamma_cofac = self.gamma.mul_by_cofactor();
        let mut hash = Sha512::new();
        hash.update(SUITE_TEMP);
        hash.update(THREE);
        hash.update(gamma_cofac.compress().as_bytes());
        hash.update(ZERO);

        output.copy_from_slice(hash.finalize().as_slice());
        output
    }
*/
function vrf10_proof_to_hash(proof) {
    var compressed_gamma_cofac = proof.gamma.mul_by_cofactor().compress();
    var hashInput = new Uint8Array(3 + compressed_gamma_cofac.length);
    hashInput[0] = SUITE_TEMP;
    hashInput[1] = 0x03;
    hashInput.set(compressed_gamma_cofac, 2);
    hashInput[2 + compressed_gamma_cofac.length] = 0;
    return (0, sha2_512_1.sha2_512_sync)(hashInput);
}
exports.vrf10_proof_to_hash = vrf10_proof_to_hash;
/*
export function vrfProofToBytesProof( proof: IVrfProof10 )
{
    return {
        gamma: bigpointToUint8Array( proof.gamma ),
        challange: encodeInt( proof.challange ),
        response: encodeInt( proof.response ),
    }
}
//*/
function edwards_hash_from_bytes(bytes) {
    var hash = (0, sha2_512_1.sha2_512_sync)(bytes);
    var res = hash.slice(0, 32);
    /*
        //////////////////////////////////////////////////////////////////////////////////////
        //// We need to be compatible with the third version of the VRF standard, which   ////
        //// always unsets the sign bit. Given the visibility of the functions used to    ////
        //// compute the ristretto mapping, we need to fork the original repo, to unset   ////
        //// bit in this function. This fork should never be used, unless one needs to be ////
        //// compatible with the version 3 of the VRF standard.                           ////
        //// https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-vrf-10#section-5.4.1.2 ////
        //// The goal is to be always a single commit ahead of version 3.2.0, and this    ////
        //// single commit only changes the following line, and a disclaimer in the       ////
        //// README.                                                                      ////
        //////////////////////////////////////////////////////////////////////////////////////
        let sign_bit = 0;

        let fe = FieldElement::from_bytes(&res);

        let M1 = crate::montgomery::elligator_encode(&fe);
        let E1_opt = M1.to_edwards(sign_bit);

        E1_opt
            .expect("Montgomery conversion to Edwards point in Elligator failed")
            .mul_by_cofactor()
    */
    var sign_bit = 0;
    var fe = curves_1.FieldElem51.fromBytes(res);
    var M1 = curves_1.FieldElem51.elligator_encode(fe);
    var E1_opt = M1.to_edwards(sign_bit);
    if (!E1_opt) {
        throw new Error("Montgomery conversion to Edwards point in Elligator failed");
    }
    return E1_opt.mul_by_cofactor();
}
exports.edwards_hash_from_bytes = edwards_hash_from_bytes;
/*
/// Computing the `hash_to_curve` using try and increment. In order to make the
    /// function always terminate, we bound  the number of tries to 64. If the try
    /// 64 fails, which happens with probability around 1/2^64, we compute the
    /// Elligator mapping. This diverges from the standard: the latter describes
    /// the function with an infinite loop. To avoid infinite loops or possibly
    /// non-terminating functions, we adopt this modification.
    /// This function is temporary, until `curve25519` provides a `hash_to_curve` as
    /// presented in the standard. Depends on
    /// [this pr](https://github.com/dalek-cryptography/curve25519-dalek/pull/377). The
    /// goal of providing this temporary function, is to ensure that the rest of the
    /// implementation is valid with respect to the standard, by using their test-vectors.
    pub(crate) fn hash_to_curve(public_key: &PublicKey10, alpha_string: &[u8]) -> EdwardsPoint {
        let mut counter = 0u8;
        let mut hash_input = Vec::with_capacity(4 + PUBLIC_KEY_SIZE + alpha_string.len());
        hash_input.extend_from_slice(SUITE_TEMP);
        hash_input.extend_from_slice(ONE);
        hash_input.extend_from_slice(public_key.as_bytes());
        hash_input.extend_from_slice(alpha_string);
        hash_input.extend_from_slice(&counter.to_be_bytes());
        hash_input.extend_from_slice(ZERO);

        while counter < 64 {
            hash_input[2 + PUBLIC_KEY_SIZE + alpha_string.len()] = counter.to_be_bytes()[0];
            if let Some(result) =
                CompressedEdwardsY::from_slice(&Sha512::digest(&hash_input)[..32]).decompress()
            {
                return result.mul_by_cofactor();
            };

            counter += 1;
        }

        EdwardsPoint::hash_from_bytes::<Sha512>(&hash_input)
    }
*/
/**
 * Computing the `hash_to_curve` using try and increment. In order to make the
 * function always terminate, we bound  the number of tries to 64. If the try
 * 64 fails, which happens with probability around 1/2^64, we compute the
 * Elligator mapping. This diverges from the standard: the latter describes
 * the function with an infinite loop. To avoid infinite loops or possibly
 * non-terminating functions, we adopt this modification.
 * This function is temporary, until `curve25519` provides a `hash_to_curve` as
 * presented in the standard. Depends on
 * [this pr](https://github.com/dalek-cryptography/curve25519-dalek/pull/377). The
 * goal of providing this temporary function, is to ensure that the rest of the
 * implementation is valid with respect to the standard, by using their test-vectors.
**/
function vrf10_ed25519_sha512_ell2_hash_to_curve(public_key, alpha_string) {
    var counter_u8 = 0;
    var input = new Uint8Array(4 + 32 + alpha_string.length);
    input[0] = SUITE_TEMP;
    input[1] = ONE;
    input.set(public_key.slice(0, 32), 2);
    input.set(alpha_string, 34);
    input[34 + alpha_string.length] = counter_u8;
    input[35 + alpha_string.length] = 0;
    while (counter_u8 < 64) {
        input[34 + alpha_string.length] = counter_u8;
        var result = (0, curves_1.decompressCompressedEdwardsY)((0, sha2_512_1.sha2_512_sync)(input).slice(0, 32));
        if (result)
            return result.mul_by_cofactor();
        ++counter_u8;
    }
    return edwards_hash_from_bytes(input); // sha2_512_sync(input);
}
exports.vrf10_ed25519_sha512_ell2_hash_to_curve = vrf10_ed25519_sha512_ell2_hash_to_curve;
function scalar_hash_from_bytes(input) {
    return (0, curves_1.scalar_from_bytes_mod_order_wide)((0, sha2_512_1.sha2_512_sync)(input));
}
exports.scalar_hash_from_bytes = scalar_hash_from_bytes;
function vrf10_ed25519_sha512_ell2_nonce_generation(secret_extension, compressed_h) {
    var input = new Uint8Array(64);
    input.set(secret_extension.slice(0, 32), 0);
    input.set(compressed_h.slice(0, 32), 32);
    //return pointFromBytes(sha2_512_sync(input))
    return scalar_hash_from_bytes(input);
}
exports.vrf10_ed25519_sha512_ell2_nonce_generation = vrf10_ed25519_sha512_ell2_nonce_generation;
/*
/// Hash points function, following the 10 specification.
    fn compute_challenge(
        compressed_h: &CompressedEdwardsY,
        gamma: &EdwardsPoint,
        announcement_1: &EdwardsPoint,
        announcement_2: &EdwardsPoint,
    ) -> Scalar {
        // we use a scalar of 16 bytes (instead of 32), but store it in 32 bits, as that is what
        // `Scalar::from_bits()` expects.
        let mut scalar_bytes = [0u8; 32];
        let mut challenge_hash = Sha512::new();
        challenge_hash.update(SUITE);
        challenge_hash.update(TWO);
        challenge_hash.update(compressed_h.to_bytes());
        challenge_hash.update(gamma.compress().as_bytes());
        challenge_hash.update(announcement_1.compress().as_bytes());
        challenge_hash.update(announcement_2.compress().as_bytes());

        scalar_bytes[..16].copy_from_slice(&challenge_hash.finalize().as_slice()[..16]);

        Scalar::from_bits(scalar_bytes)
    }
* /
export function vrf_ed25519_sha512_ell2_challenge_generation(
    H: Uint8Array,
    gamma: Uint8Array,
    announcement_1: Uint8Array,
    announcement_2: Uint8Array,
): Uint8Array
{
    // const input = new Uint8Array( 2 + H.length + gamma.length + announcement_1.length + announcement_2.length );
    // input[0] = SUITE;
    // input[1] = TWO;
    // input.set( H, 2 );
    // input.set( gamma, 2 + H.length );
    // input.set( announcement_1, 2 + H.length + gamma.length );
    // input.set( announcement_2, 2 + H.length + gamma.length + announcement_1.length );
    // return sha2_512_sync(input).slice(0,16);
}
//*/
/*
/// Hash points function, following the 10 specification.
    pub(crate) fn compute_challenge(
        compressed_h: &CompressedEdwardsY,
        gamma: &EdwardsPoint,
        announcement_1: &EdwardsPoint,
        announcement_2: &EdwardsPoint,
    ) -> Scalar {
        // we use a scalar of 16 bytes (instead of 32), but store it in 32 bits, as that is what
        // `Scalar::from_bits()` expects.
        let mut scalar_bytes = [0u8; 32];
        let mut challenge_hash = Sha512::new();
        challenge_hash.update(SUITE_TEMP);
        challenge_hash.update(TWO);
        challenge_hash.update(compressed_h.to_bytes());
        challenge_hash.update(gamma.compress().as_bytes());
        challenge_hash.update(announcement_1.compress().as_bytes());
        challenge_hash.update(announcement_2.compress().as_bytes());
        challenge_hash.update(ZERO);

        scalar_bytes[..16].copy_from_slice(&challenge_hash.finalize().as_slice()[..16]);

        Scalar::from_bits(scalar_bytes)
    }
*/
function vrf10_ed25519_sha512_ell2_compute_challenge(compressed_h, compressed_gamma, compressed_announcement_1, compressed_announcement_2) {
    var scalar_bytes = new Uint8Array(32);
    var hash_input = new Uint8Array(3 +
        compressed_h.length +
        compressed_gamma.length +
        compressed_announcement_1.length +
        compressed_announcement_2.length);
    hash_input[0] = SUITE_TEMP;
    hash_input[1] = TWO;
    var len = 2;
    hash_input.set(compressed_h, len);
    len += compressed_h.length;
    hash_input.set(compressed_gamma, len);
    len += compressed_gamma.length;
    hash_input.set(compressed_announcement_1, len);
    len += compressed_announcement_1.length;
    hash_input.set(compressed_announcement_2, len);
    hash_input[len + compressed_announcement_2.length] = 0;
    var hash = (0, sha2_512_1.sha2_512_sync)(hash_input);
    scalar_bytes.set(hash.slice(0, 16), 0);
    scalar_from_bits_inplace(scalar_bytes);
    return scalar_bytes;
}
exports.vrf10_ed25519_sha512_ell2_compute_challenge = vrf10_ed25519_sha512_ell2_compute_challenge;
/*
// Construct a `Scalar` from the low 255 bits of a 256-bit integer.
    ///
    /// This function is intended for applications like X25519 which
    /// require specific bit-patterns when performing scalar
    /// multiplication.
    pub const fn from_bits(bytes: [u8; 32]) -> Scalar {
        let mut s = Scalar{bytes};
        // Ensure that s < 2^255 by masking the high bit
        s.bytes[31] &= 0b0111_1111;

        s
    }
*/
function scalar_from_bits_inplace(bytes) {
    bytes[31] &= 127;
}
exports.scalar_from_bits_inplace = scalar_from_bits_inplace;
/**
 * https://datatracker.ietf.org/doc/html/rfc9381#section-5.1
 *
 * test cases:
 * https://datatracker.ietf.org/doc/html/rfc9381#name-ecvrf-edwards25519-sha512-e
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-vrf-10#appendix-A.4
 *
 * /// Generate a new VRF proof following the 10 standard. It proceeds as follows:
 * /// - Extend the secret key, into a `secret_scalar` and the `secret_extension`
 * /// - Evaluate `hash_to_curve` over PK || alpha_string to get `H`
 * /// - Compute `Gamma = secret_scalar *  H`
 * /// - Generate a proof of discrete logarithm equality between `PK` and `Gamma` with
 * ///   bases `generator` and `H` respectively.
 *
 * /
export function vrf_ed25519_sha512_ell2_prove(sk: Uint8Array, alpha: Uint8Array): IVrfProof10
{
    /// - Extend the secret key, into a `secret_scalar` and the `secret_extension`
    const [ scalar, extension ] = getExtendEd25519PrivateKeyComponents_sync( sk );
    // 1. Use SK to derive the VRF secret scalar x and the VRF public key Y = x*B
    /// - Evaluate `hash_to_curve` over PK || alpha_string to get `H`
    const pk = new Uint8Array( deriveEd25519PublicKey_sync( sk ) );
    const H = vrf_ed25519_sha512_ell2_hash_to_curve( pk, alpha );
    
    const H_point = pointFromBytes( H );
    const gamma = scalarMul( H_point, scalar );
    const compressed_gamma = bigpointToUint8Array( gamma );
    const k = vrf_ed25519_sha512_ell2_nonce_generation( extension, H );
    const announcement_1 = bigpointToUint8Array( scalarMultBase( k ) );
    const announcement_2 = bigpointToUint8Array( scalarMul( H_point, k ) );
    const challange = scalarFromBytes(
        vrf_ed25519_sha512_ell2_challenge_generation( H, compressed_gamma, announcement_1, announcement_2 )
    );
    const response = k + challange * scalar;
    return {
        gamma,
        challange,
        response
    };
}
//*/ 


/***/ }),

/***/ 89351:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.vrf10_batch_ed25519_sha512_ell2_verify_proof = exports.vrf10_batch_ed25519_sha512_ell2_generate_proof = exports.vrf10_batch_ed25519_sha512_ell2_proof_to_hash = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var sha2_512_1 = __webpack_require__(1824);
var curves_1 = __webpack_require__(46732);
var vrf10_1 = __webpack_require__(66222);
/**
4.4. RSA-FDH-VRF Ciphersuites

This document defines RSA-FDH-VRF-SHA256 as follows:

suite_string = 0x01.
The hash function Hash is SHA-256 as specified in [RFC6234], with hLen = 32.
MGF_salt = I2OSP(k, 4) || I2OSP(n, k).

This document defines RSA-FDH-VRF-SHA384 as follows:

suite_string = 0x02.
The hash function Hash is SHA-384 as specified in [RFC6234], with hLen = 48.
MGF_salt = I2OSP(k, 4) || I2OSP(n, k).

This document defines RSA-FDH-VRF-SHA512 as follows:

suite_string = 0x10.
The hash function Hash is SHA-512 as specified in [RFC6234], with hLen = 64.
MGF_salt = I2OSP(k, 4) || I2OSP(n, k).

 */
var SUITE = 0x04;
/*
/// Temporary SUITE identifier, as TAI uses 0x03
pub const SUITE_TEMP: &[u8] = &[0x03];
*/
var SUITE_TEMP = 0x03;
var ONE = 0x01;
var TWO = 0x02;
var THREE = 0x03;
function vrf10_batch_ed25519_sha512_ell2_proof_to_hash(proof) {
    var compressed_gamma_cofac = proof.gamma.mul_by_cofactor().compress();
    var input = new Uint8Array(3 + compressed_gamma_cofac.length);
    input[0] = SUITE_TEMP;
    input[1] = THREE;
    input.set(compressed_gamma_cofac, 2);
    input[2 + compressed_gamma_cofac.length] = 0;
    return (0, sha2_512_1.sha2_512_sync)(input);
}
exports.vrf10_batch_ed25519_sha512_ell2_proof_to_hash = vrf10_batch_ed25519_sha512_ell2_proof_to_hash;
function vrf10_batch_ed25519_sha512_ell2_generate_proof(secret_key, public_key, alpha_string) {
    var _a = __read((0, vrf10_1.extend_secret_key)(secret_key), 2), secret_scalar = _a[0], secret_extension = _a[1];
    var h = (0, vrf10_1.vrf10_ed25519_sha512_ell2_hash_to_curve)(public_key, alpha_string);
    var compressed_h = h.compress();
    var gamma = h.scalarMul(secret_scalar);
    var compressed_gamma = gamma.compress();
    var k = (0, vrf10_1.vrf10_ed25519_sha512_ell2_nonce_generation)(secret_extension, compressed_h);
    var announcement_base = curves_1.ED25519_BASEPOINT_POINT.scalarMul(k);
    var compressed_announcement_base = announcement_base.compress();
    var announcement_h = h.scalarMul(k);
    var compressed_announcement_h = announcement_h.compress();
    // Self::compute_challenge(&compressed_h, &gamma, &announcement_base, &announcement_h);
    var challenge = (0, vrf10_1.vrf10_ed25519_sha512_ell2_compute_challenge)(compressed_h, compressed_gamma, compressed_announcement_base, compressed_announcement_h);
    var response = (0, curves_1.add_scalars)(k, (0, curves_1.mul_scalars)(challenge, secret_scalar));
    return {
        gamma: gamma,
        u_point: announcement_base,
        v_point: announcement_h,
        response: response
    };
}
exports.vrf10_batch_ed25519_sha512_ell2_generate_proof = vrf10_batch_ed25519_sha512_ell2_generate_proof;
function vrf10_batch_ed25519_sha512_ell2_verify_proof(public_key, alpha_string, proof) {
    var h = (0, vrf10_1.vrf10_ed25519_sha512_ell2_hash_to_curve)(public_key, alpha_string);
    var compressed_h = h.compress();
    var decompressed_pk = (0, curves_1.decompressCompressedEdwardsY)(public_key); // pointFromBytes( public_key );
    if (!decompressed_pk || decompressed_pk.is_small_order())
        return false;
    var gamma = proof.gamma;
    var compressed_gamma = gamma.compress();
    var compressed_announcement_base = proof.u_point.compress();
    var compressed_announcement_h = proof.v_point.compress();
    // Scalar
    var proof_challenge = (0, vrf10_1.vrf10_ed25519_sha512_ell2_compute_challenge)(compressed_h, compressed_gamma, compressed_announcement_base, compressed_announcement_h);
    var U = curves_1.EdwardsPoint.vartime_double_scalar_mul_basepoint((0, curves_1.negate_scalar)(proof_challenge), decompressed_pk, proof.response);
    /*
    let V = EdwardsPoint::vartime_multiscalar_mul(
            iter::once(self.response).chain(iter::once(self.challenge.neg())),
            iter::once(h).chain(iter::once(self.gamma)),
        );
    */
    var V = curves_1.EdwardsPoint.vartime_multiscalar_mul([proof.response, (0, curves_1.negate_scalar)(proof_challenge)], [h, gamma]);
    // const computed_challenge = vrf10_ed25519_sha512_ell2_compute_challenge(
    //     compressed_h,
    //     proof.gamma.compress(),
    //     U.compress(),
    //     V.compress()
    // );
    return ((0, uint8array_utils_1.uint8ArrayEq)(U.compress(), compressed_announcement_base) &&
        (0, uint8array_utils_1.uint8ArrayEq)(V.compress(), compressed_announcement_h));
}
exports.vrf10_batch_ed25519_sha512_ell2_verify_proof = vrf10_batch_ed25519_sha512_ell2_verify_proof;
/*
/// `proof_to_hash` function, following the 10 specification. This computes the output of the VRF
    /// function. In particular, this function computes
    /// SHA512(SUITE || THREE || Gamma || ZERO)
    fn proof_to_hash(&self) -> [u8; OUTPUT_SIZE] {
        let mut output = [0u8; OUTPUT_SIZE];
        let gamma_cofac = self.gamma.mul_by_cofactor();
        let mut hash = Sha512::new();
        hash.update(SUITE_TEMP);
        hash.update(THREE);
        hash.update(gamma_cofac.compress().as_bytes());
        hash.update(ZERO);

        output.copy_from_slice(hash.finalize().as_slice());
        output
    }
*/
function vrf10_proof_to_hash(proof) {
    var compressed_gamma_cofac = proof.gamma.mul_by_cofactor().compress();
    var hashInput = new Uint8Array(3 + compressed_gamma_cofac.length);
    hashInput[0] = SUITE_TEMP;
    hashInput[1] = 0x03;
    hashInput.set(compressed_gamma_cofac, 2);
    hashInput[2 + compressed_gamma_cofac.length] = 0;
    return (0, sha2_512_1.sha2_512_sync)(hashInput);
}
/*
function vrfProofToBytesProof( proof: IVrfBatchProof10 )
{
    return {
        gamma: bigpointToUint8Array( proof.gamma ),
        challange: encodeInt( proof.challange ),
        response: encodeInt( proof.response ),
    }
}
//*/
function edwards_hash_from_bytes(bytes) {
    var hash = (0, sha2_512_1.sha2_512_sync)(bytes);
    var res = hash.slice(0, 32);
    /*
        //////////////////////////////////////////////////////////////////////////////////////
        //// We need to be compatible with the third version of the VRF standard, which   ////
        //// always unsets the sign bit. Given the visibility of the functions used to    ////
        //// compute the ristretto mapping, we need to fork the original repo, to unset   ////
        //// bit in this function. This fork should never be used, unless one needs to be ////
        //// compatible with the version 3 of the VRF standard.                           ////
        //// https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-vrf-10#section-5.4.1.2 ////
        //// The goal is to be always a single commit ahead of version 3.2.0, and this    ////
        //// single commit only changes the following line, and a disclaimer in the       ////
        //// README.                                                                      ////
        //////////////////////////////////////////////////////////////////////////////////////
        let sign_bit = 0;

        let fe = FieldElement::from_bytes(&res);

        let M1 = crate::montgomery::elligator_encode(&fe);
        let E1_opt = M1.to_edwards(sign_bit);

        E1_opt
            .expect("Montgomery conversion to Edwards point in Elligator failed")
            .mul_by_cofactor()
    */
    var sign_bit = 0;
    var fe = curves_1.FieldElem51.fromBytes(res);
    var M1 = curves_1.FieldElem51.elligator_encode(fe);
    var E1_opt = M1.to_edwards(sign_bit);
    if (!E1_opt) {
        throw new Error("Montgomery conversion to Edwards point in Elligator failed");
    }
    return E1_opt.mul_by_cofactor();
}
/*
// Construct a `Scalar` from the low 255 bits of a 256-bit integer.
    ///
    /// This function is intended for applications like X25519 which
    /// require specific bit-patterns when performing scalar
    /// multiplication.
    pub const fn from_bits(bytes: [u8; 32]) -> Scalar {
        let mut s = Scalar{bytes};
        // Ensure that s < 2^255 by masking the high bit
        s.bytes[31] &= 0b0111_1111;

        s
    }
*/
function scalar_from_bits_inplace(bytes) {
    bytes[31] &= 127;
}
/**
 * https://datatracker.ietf.org/doc/html/rfc9381#section-5.1
 *
 * test cases:
 * https://datatracker.ietf.org/doc/html/rfc9381#name-ecvrf-edwards25519-sha512-e
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-vrf-10#appendix-A.4
 *
 * /// Generate a new VRF proof following the 10 standard. It proceeds as follows:
 * /// - Extend the secret key, into a `secret_scalar` and the `secret_extension`
 * /// - Evaluate `hash_to_curve` over PK || alpha_string to get `H`
 * /// - Compute `Gamma = secret_scalar *  H`
 * /// - Generate a proof of discrete logarithm equality between `PK` and `Gamma` with
 * ///   bases `generator` and `H` respectively.
 *
 * /
function vrf_ed25519_sha512_ell2_prove(sk: Uint8Array, alpha: Uint8Array): IVrfBatchProof10
{
    /// - Extend the secret key, into a `secret_scalar` and the `secret_extension`
    const [ scalar, extension ] = getExtendEd25519PrivateKeyComponents_sync( sk );
    // 1. Use SK to derive the VRF secret scalar x and the VRF public key Y = x*B
    /// - Evaluate `hash_to_curve` over PK || alpha_string to get `H`
    const pk = new Uint8Array( deriveEd25519PublicKey_sync( sk ) );
    const H = vrf_ed25519_sha512_ell2_hash_to_curve( pk, alpha );
    
    const H_point = pointFromBytes( H );
    const gamma = scalarMul( H_point, scalar );
    const compressed_gamma = bigpointToUint8Array( gamma );
    const k = vrf_ed25519_sha512_ell2_nonce_generation( extension, H );
    const announcement_1 = bigpointToUint8Array( scalarMultBase( k ) );
    const announcement_2 = bigpointToUint8Array( scalarMul( H_point, k ) );
    const challange = scalarFromBytes(
        vrf_ed25519_sha512_ell2_challenge_generation( H, compressed_gamma, announcement_1, announcement_2 )
    );
    const response = k + challange * scalar;
    return {
        gamma,
        challange,
        response
    };
}
//*/ 


/***/ }),

/***/ 29558:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.verifySchnorrSecp256k1Signature = exports.verifyEcdsaSecp256k1Signature = void 0;
var secp256k1_1 = __webpack_require__(6978);
function verifyEcdsaSecp256k1Signature(vk, // 33 bytes
messageHash, // 32 bytes
signature) {
    if (!(vk instanceof Uint8Array &&
        messageHash instanceof Uint8Array &&
        signature instanceof Uint8Array &&
        vk.length === 33 &&
        messageHash.length === 32 &&
        signature.length === 64))
        throw new TypeError("invalid arguments passed to 'verifyEcdsaSecp256k1Signature'");
    var vkHead = vk[0];
    if (!(vkHead === 0x02 ||
        vkHead === 0x03))
        throw new Error("plutus-machine only supports compressed public keys for 'verifyEcdsaSecp256k1Signature'");
    return (0, secp256k1_1.verifySecp256k1)(signature, messageHash, vk);
}
exports.verifyEcdsaSecp256k1Signature = verifyEcdsaSecp256k1Signature;
function verifySchnorrSecp256k1Signature(pubKey, messageHash, signature) {
    if (!(pubKey instanceof Uint8Array &&
        messageHash instanceof Uint8Array &&
        signature instanceof Uint8Array &&
        pubKey.length === 32 &&
        signature.length === 64))
        throw new TypeError("invalid arguments passed to 'verifyEcdsaSecp256k1Signature'");
    // signature 64
    // pubKey 32
    return (0, secp256k1_1.verifySchnorr)(signature, messageHash, pubKey);
}
exports.verifySchnorrSecp256k1Signature = verifySchnorrSecp256k1Signature;


/***/ }),

/***/ 83610:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hasNativeSha2_256 = exports.sha2_256 = exports.sha2_256_sync = void 0;
var rotr32_1 = __webpack_require__(21213);
var hasGlobalWebCrypto_1 = __webpack_require__(69631);
var __hasNativeSupport = hasGlobalWebCrypto_1.hasGlobalWebCrypto && typeof globalThis.crypto.subtle.digest === "function";
var NATIVE_ALGO = "SHA-256";
var digest = __hasNativeSupport ?
    globalThis.crypto.subtle.digest.bind(globalThis.crypto.subtle) :
    function () { return Promise.resolve(new ArrayBuffer(0)); };
function _test_nativeSha2_256(data) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = Uint8Array.bind;
                    return [4 /*yield*/, digest(NATIVE_ALGO, data)];
                case 1: 
                // await ensureNativeSupport();
                // if( !__hasNativeSupport ) return sha2_256_sync( data );
                return [2 /*return*/, new (_a.apply(Uint8Array, [void 0, _b.sent()]))()];
            }
        });
    });
}
function nativeSha2_256(data) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ensureNativeSupport()];
                case 1:
                    _b.sent();
                    if (!__hasNativeSupport)
                        return [2 /*return*/, sha2_256_sync(data)];
                    _a = Uint8Array.bind;
                    return [4 /*yield*/, digest(NATIVE_ALGO, data)];
                case 2: return [2 /*return*/, new (_a.apply(Uint8Array, [void 0, _b.sent()]))()];
            }
        });
    });
}
function _test(data, uint8ArrayEq) {
    return __awaiter(this, void 0, void 0, function () {
        var start, end, nativeRestult, _a, nativeTime, result, jsTime, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!__hasNativeSupport)
                        return [2 /*return*/, [50, 1]];
                    start = 0;
                    end = 0;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    start = performance.now();
                    _a = Uint8Array.bind;
                    return [4 /*yield*/, _test_nativeSha2_256(data)];
                case 2:
                    nativeRestult = new (_a.apply(Uint8Array, [void 0, _c.sent()]))();
                    end = performance.now();
                    nativeTime = end - start;
                    start = performance.now();
                    result = sha2_256_sync(data);
                    end = performance.now();
                    jsTime = end - start;
                    __hasNativeSupport = __hasNativeSupport && uint8ArrayEq(nativeRestult, result);
                    return [2 /*return*/, [nativeTime, jsTime]];
                case 3:
                    _b = _c.sent();
                    __hasNativeSupport = false;
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, [50, 1]];
            }
        });
    });
}
var _support_was_tested = false;
function _test_support() {
    return __awaiter(this, void 0, void 0, function () {
        var repeatArr, eqU8Arr_1, bench, sum, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (_support_was_tested || !__hasNativeSupport)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    repeatArr = function (arr, n) {
                        for (var i = 0; i < n; i++)
                            arr = arr.concat.apply(arr, __spreadArray([], __read(arr), false));
                        return arr;
                    };
                    eqU8Arr_1 = function (a, b) {
                        if (!(a instanceof Uint8Array) || !(b instanceof Uint8Array))
                            return false;
                        if (a.length !== b.length)
                            return false;
                        for (var i = 0; i < a.length; i++)
                            if (a[i] !== b[i])
                                return false;
                        return true;
                    };
                    return [4 /*yield*/, Promise.all(repeatArr([
                            new Uint8Array(0),
                            new Uint8Array(10),
                            new Uint8Array([0xde, 0xad, 0xbe, 0xef]),
                            new Uint8Array(repeatArr([0xaa], 20)),
                            new Uint8Array(repeatArr([0xbb], 20)),
                            new Uint8Array(repeatArr([0xcc], 20)),
                            new Uint8Array(repeatArr([0xdd], 20)),
                            new Uint8Array(repeatArr([0xee], 20)),
                            new Uint8Array(repeatArr([0xff], 20)),
                            new Uint8Array(repeatArr([0xaa, 0xbb], 33)),
                            new Uint8Array(repeatArr([0xbb, 0xcc], 33)),
                            new Uint8Array(repeatArr([0xcc, 0xdd], 33)),
                            new Uint8Array(repeatArr([0xdd, 0xee], 33)),
                            new Uint8Array(repeatArr([0xee, 0xff], 33)),
                            new Uint8Array(repeatArr([0xff, 0x00], 33)),
                            new Uint8Array(repeatArr([0xde, 0xad, 0xbe, 0xef], 30)),
                        ], 10)
                            .map(function (data) { return _test(data, eqU8Arr_1); }))];
                case 2:
                    bench = _b.sent();
                    if (!__hasNativeSupport)
                        return [2 /*return*/];
                    sum = bench.reduce(function (acc, _a) {
                        var _b = __read(_a, 2), native = _b[0], js = _b[1];
                        acc[0] += native;
                        acc[1] += js;
                        return acc;
                    }, [0, 0]);
                    __hasNativeSupport = __hasNativeSupport && sum[0] < sum[1];
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    __hasNativeSupport = false;
                    _support_was_tested = true;
                    return [3 /*break*/, 4];
                case 4:
                    _support_was_tested = true;
                    return [2 /*return*/];
            }
        });
    });
}
if (__hasNativeSupport) {
    _test_support();
}
else {
    _support_was_tested = true;
}
/**
 * There are cases where `globalThis.crypto.subtle` is fully defined
 * but the algorithm `Ed25519` is NOT SUPPORTED.
 *
 * unfortunately, there is NO WAY to check this syncronously.
 */
function ensureNativeSupport() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!__hasNativeSupport)
                        return [2 /*return*/, false];
                    return [4 /*yield*/, _test_support()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, __hasNativeSupport];
            }
        });
    });
}
/**
 * Pad a bytearray so its size is a multiple of 64 (512 bits).
 * Internal method.
 */
function pad(src) {
    var nBits = src.length * 8;
    var finalLen = src.length;
    // dst = src.slice();
    // dst.push(0x80);
    finalLen++;
    var nZeroes = (64 - (src.length + 1) % 64) - 8;
    if (nZeroes < 0) {
        nZeroes += 64;
    }
    // for (let i = 0; i < nZeroes; i++) {
    //     dst.push(0);
    // }
    finalLen += nZeroes;
    // assume nBits fits in 32 bits
    // dst.push(0);
    // dst.push(0);
    // dst.push(0);
    // dst.push(0);
    // dst.push( ((nBits >> 24) & 0xff) as byte);
    // dst.push( ((nBits >> 16) & 0xff) as byte);
    // dst.push( ((nBits >> 8)  & 0xff) as byte);
    // dst.push( ((nBits >> 0)  & 0xff) as byte);
    finalLen += 8;
    var dst = new Uint8Array(finalLen);
    dst.set(src);
    dst[src.length] = 0x80;
    dst[finalLen - 4] = (nBits >>> 24) & 0xff;
    dst[finalLen - 3] = (nBits >>> 16) & 0xff;
    dst[finalLen - 2] = (nBits >>> 8) & 0xff;
    dst[finalLen - 1] = nBits & 0xff;
    return dst;
}
var k = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
    0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
    0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
    0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
    0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
    0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
    0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
    0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
    0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2,
];
function sigma0(x) {
    return (0, rotr32_1.rotr32)(x, 7) ^ (0, rotr32_1.rotr32)(x, 18) ^ (x >>> 3);
}
function sigma1(x) {
    return (0, rotr32_1.rotr32)(x, 17) ^ (0, rotr32_1.rotr32)(x, 19) ^ (x >>> 10);
}
var initialHash = new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19,
]);
/**
 * getulates sha2-256 (32bytes) hash of a list of uint8 numbers.
 * Result is also a list of uint8 number.
 * @example
 * bytesToHex(sha2_256([0x61, 0x62, 0x63])) => "ba7816bf8f01cfea414140de5dae2223b00361a396177a9cb410ff61f20015ad"
 * @example
 * sha2_256(textToBytes("Hello, World!")) => [223, 253, 96, 33, 187, 43, 213, 176, 175, 103, 98, 144, 128, 158, 195, 165, 49, 145, 221, 129, 199, 247, 10, 75, 40, 104, 138, 54, 33, 130, 152, 111]
 * @param {uint5[]} bytes - list of uint8 numbers
 * @returns {number[]} - list of uint8 numbers
 */
function sha2_256_sync(_bytes) {
    if (!(_bytes instanceof Uint8Array))
        _bytes = new Uint8Array(_bytes);
    if (_bytes instanceof ArrayBuffer)
        _bytes = new Uint8Array(_bytes);
    /**
     * Initial hash (updated during compression phase)
     */
    var hash = initialHash.slice();
    var bytes = pad(_bytes);
    // break message in successive 64 byte chunks
    for (var chunkStart = 0; chunkStart < bytes.length; chunkStart += 64) {
        var chunk = Uint8Array.prototype.slice.call(bytes, chunkStart, chunkStart + 64);
        // bytes.slice(chunkStart, chunkStart + 64);
        var w = new Int32Array(64); // (new Array(64)).fill(0); // array of 32 bit numbers!
        // copy chunk into first 16 positions of w
        for (var i = 0; i < 16; i++) {
            w[i] = (chunk[i * 4 + 0] << 24) |
                (chunk[i * 4 + 1] << 16) |
                (chunk[i * 4 + 2] << 8) |
                (chunk[i * 4 + 3]);
        }
        // this DOES NOT WORK
        // w.set( new Int32Array( chunk.buffer, chunk.byteOffset, 16 ) );
        // extends the first 16 positions into the remaining 48 positions
        for (var i = 16; i < 64; i++) {
            w[i] = (w[i - 16] + sigma0(w[i - 15]) + w[i - 7] + sigma1(w[i - 2])) | 0;
        }
        // intialize working variables to current hash value
        var a = hash[0];
        var b = hash[1];
        var c = hash[2];
        var d = hash[3];
        var e = hash[4];
        var f = hash[5];
        var g = hash[6];
        var h = hash[7];
        // compression function main loop
        for (var i = 0; i < 64; i++) {
            var S1 = (0, rotr32_1.rotr32)(e, 6) ^ (0, rotr32_1.rotr32)(e, 11) ^ (0, rotr32_1.rotr32)(e, 25);
            var ch = (e & f) ^ ((~e) & g);
            var temp1 = (h + S1 + ch + k[i] + w[i]) | 0;
            var S0 = (0, rotr32_1.rotr32)(a, 2) ^ (0, rotr32_1.rotr32)(a, 13) ^ (0, rotr32_1.rotr32)(a, 22);
            var maj = (a & b) ^ (a & c) ^ (b & c);
            var temp2 = (S0 + maj) | 0;
            h = g;
            g = f;
            f = e;
            e = (d + temp1) | 0;
            d = c;
            c = b;
            b = a;
            a = (temp1 + temp2) | 0;
        }
        // update the hash
        hash[0] = (hash[0] + a) | 0;
        hash[1] = (hash[1] + b) | 0;
        hash[2] = (hash[2] + c) | 0;
        hash[3] = (hash[3] + d) | 0;
        hash[4] = (hash[4] + e) | 0;
        hash[5] = (hash[5] + f) | 0;
        hash[6] = (hash[6] + g) | 0;
        hash[7] = (hash[7] + h) | 0;
    }
    // produce the final digest of uint8 numbers
    var result = new Uint8Array(32);
    for (var i = 0; i < 8; i++) {
        var item = hash[i];
        // result.push( ((item >> 24) & 0xff) as byte );
        // result.push( ((item >> 16) & 0xff) as byte );
        // result.push( ((item >>  8) & 0xff) as byte );
        // result.push( ((item >>  0) & 0xff) as byte );
        var i4 = i * 4;
        result[i4] = (item >>> 24) & 0xff;
        result[i4 + 1] = (item >>> 16) & 0xff;
        result[i4 + 2] = (item >>> 8) & 0xff;
        result[i4 + 3] = (item) & 0xff;
    }
    return result;
}
exports.sha2_256_sync = sha2_256_sync;
function wrapped_sha2_256_sync(data) {
    return Promise.resolve(sha2_256_sync(data));
}
exports.sha2_256 = __hasNativeSupport ? nativeSha2_256 : wrapped_sha2_256_sync;
exports.hasNativeSha2_256 = exports.sha2_256 === nativeSha2_256;


/***/ }),

/***/ 1824:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha2_512 = exports.sha2_512_sync = void 0;
var hasGlobalWebCrypto_1 = __webpack_require__(69631);
var sha512_1 = __webpack_require__(17508);
var __hasNativeSupport = hasGlobalWebCrypto_1.hasGlobalWebCrypto && typeof globalThis.crypto.subtle.digest === "function";
var NATIVE_ALGO = "SHA-512";
var digest = __hasNativeSupport ?
    globalThis.crypto.subtle.digest.bind(globalThis.crypto.subtle) :
    function () { return Promise.resolve(new ArrayBuffer(0)); };
function _test_nativeSha2_512(data) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = Uint8Array.bind;
                    return [4 /*yield*/, digest(NATIVE_ALGO, data)];
                case 1: 
                // await ensureNativeSupport();
                // if( !__hasNativeSupport ) return sha2_512_sync( data );
                return [2 /*return*/, new (_a.apply(Uint8Array, [void 0, _b.sent()]))()];
            }
        });
    });
}
function nativeSha2_512(data) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ensureNativeSupport()];
                case 1:
                    _b.sent();
                    if (!__hasNativeSupport)
                        return [2 /*return*/, sha2_512_sync(data)];
                    _a = Uint8Array.bind;
                    return [4 /*yield*/, digest(NATIVE_ALGO, data)];
                case 2: return [2 /*return*/, new (_a.apply(Uint8Array, [void 0, _b.sent()]))()];
            }
        });
    });
}
function _test(data, uint8ArrayEq) {
    return __awaiter(this, void 0, void 0, function () {
        var start, end, nativeResult, _a, nativeTime, result, jsTime, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!__hasNativeSupport)
                        return [2 /*return*/, [50, 1]];
                    start = 0;
                    end = 0;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    start = performance.now();
                    _a = Uint8Array.bind;
                    return [4 /*yield*/, _test_nativeSha2_512(data)];
                case 2:
                    nativeResult = new (_a.apply(Uint8Array, [void 0, _c.sent()]))();
                    end = performance.now();
                    nativeTime = end - start;
                    start = performance.now();
                    result = sha2_512_sync(data);
                    end = performance.now();
                    jsTime = end - start;
                    __hasNativeSupport = __hasNativeSupport && uint8ArrayEq(nativeResult, result);
                    return [2 /*return*/, [nativeTime, jsTime]];
                case 3:
                    _b = _c.sent();
                    __hasNativeSupport = false;
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, [50, 1]];
            }
        });
    });
}
var _support_was_tested = false;
function _test_support() {
    return __awaiter(this, void 0, void 0, function () {
        var repeatArr, eqU8Arr_1, bench, sum, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (_support_was_tested || !__hasNativeSupport)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    repeatArr = function (arr, n) {
                        for (var i = 0; i < n; i++)
                            arr = arr.concat.apply(arr, __spreadArray([], __read(arr), false));
                        return arr;
                    };
                    eqU8Arr_1 = function (a, b) {
                        if (!(a instanceof Uint8Array) || !(b instanceof Uint8Array))
                            return false;
                        if (a.length !== b.length)
                            return false;
                        for (var i = 0; i < a.length; i++)
                            if (a[i] !== b[i])
                                return false;
                        return true;
                    };
                    return [4 /*yield*/, Promise.all(repeatArr([
                            new Uint8Array(0),
                            new Uint8Array(10),
                            new Uint8Array([0xde, 0xad, 0xbe, 0xef]),
                            new Uint8Array(repeatArr([0xaa], 20)),
                            new Uint8Array(repeatArr([0xbb], 20)),
                            new Uint8Array(repeatArr([0xcc], 20)),
                            new Uint8Array(repeatArr([0xdd], 20)),
                            new Uint8Array(repeatArr([0xee], 20)),
                            new Uint8Array(repeatArr([0xff], 20)),
                            new Uint8Array(repeatArr([0xaa, 0xbb], 33)),
                            new Uint8Array(repeatArr([0xbb, 0xcc], 33)),
                            new Uint8Array(repeatArr([0xcc, 0xdd], 33)),
                            new Uint8Array(repeatArr([0xdd, 0xee], 33)),
                            new Uint8Array(repeatArr([0xee, 0xff], 33)),
                            new Uint8Array(repeatArr([0xff, 0x00], 33)),
                            new Uint8Array(repeatArr([0xde, 0xad, 0xbe, 0xef], 30)),
                        ], 10).map(function (data) { return _test(data, eqU8Arr_1); }))];
                case 2:
                    bench = _b.sent();
                    if (!__hasNativeSupport)
                        return [2 /*return*/];
                    sum = bench.reduce(function (acc, _a) {
                        var _b = __read(_a, 2), native = _b[0], js = _b[1];
                        acc[0] += native;
                        acc[1] += js;
                        return acc;
                    }, [0, 0]);
                    __hasNativeSupport = __hasNativeSupport && sum[0] < sum[1];
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    __hasNativeSupport = false;
                    return [3 /*break*/, 4];
                case 4:
                    _support_was_tested = true;
                    return [2 /*return*/];
            }
        });
    });
}
if (__hasNativeSupport) {
    _test_support();
}
else {
    _support_was_tested = true;
}
/**
 * There are cases where `globalThis.crypto.subtle` is fully defined
 * but the algorithm `Ed25519` is NOT SUPPORTED.
 *
 * unfortunately, there is NO WAY to check this syncronously.
 */
function ensureNativeSupport() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!__hasNativeSupport)
                        return [2 /*return*/, false];
                    return [4 /*yield*/, _test_support()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, __hasNativeSupport];
            }
        });
    });
}
/**
 * getulates sha2-512 (64bytes) hash of a list of uint8 numbers.
 * Result is also a list of uint8 number.
 * @example
 * bytesToHex(sha2_512_sync([0x61, 0x62, 0x63])) => "ddaf35a193617abacc417349ae20413112e6fa4e89a97ea20a9eeee64b55d39a2192992a274fc1a836ba3c23a3feebbd454d4423643ce80e2a9ac94fa54ca49f"
 * @example
 * bytesToHex(sha2_512_sync([])) => "cf83e1357eefb8bdf1542850d66d8007d620e4050b5715dc83f4a921d36ce9ce47d0d13c5d85f2b0ff8318d2877eec2f63b931bd47417a81a538327af927da3e"
 * @param {number[]} bytes - list of uint8 numbers
 * @returns {number[]} - list of uint8 numbers
 */
function sha2_512_sync(bytes) {
    if (!(bytes instanceof Uint8Array))
        bytes = new Uint8Array(bytes);
    if (bytes instanceof ArrayBuffer)
        bytes = new Uint8Array(bytes);
    return (0, sha512_1.sha512)(bytes);
}
exports.sha2_512_sync = sha2_512_sync;
function wrapped_sha2_512_sync(bytes) {
    return Promise.resolve(sha2_512_sync(bytes));
}
exports.sha2_512 = __hasNativeSupport ? nativeSha2_512 : wrapped_sha2_512_sync;


/***/ }),

/***/ 57753:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha3 = void 0;
var types_1 = __webpack_require__(80247);
var types_2 = __webpack_require__(80247);
var uint8array_utils_1 = __webpack_require__(44948);
var assert_1 = __webpack_require__(97610);
/**
 * state width (1600 bits, )
 */
var WIDTH = 200;
/**
 * rate (1088 bits, 136 bytes)
 */
var RATE = 136;
/**
 * capacity
 */
var CAP = WIDTH - RATE;
/**
 * Apply 1000...1 padding until size is multiple of r.
 * If already multiple of r then add a whole block of padding.
 * @param {number[]} src - list of uint8 numbers
 * @returns {number[]} - list of uint8 numbers
 */
function pad(src) {
    var dst = src.slice();
    var nZeroes = RATE - 2 - (dst.length % RATE);
    if (nZeroes < -1) {
        nZeroes += RATE - 2;
    }
    if (nZeroes == -1) {
        dst.push(0x86);
    }
    else {
        dst.push(0x06);
        for (var i = 0; i < nZeroes; i++) {
            dst.push(0);
        }
        dst.push(0x80);
    }
    (0, assert_1.assert)((dst.length % RATE) === 0, "wrong destination length");
    return dst;
}
/**
 * 24 numbers used in the sha3 permute function
 */
var OFFSETS = Object.freeze([6, 12, 18, 24, 3, 9, 10, 16, 22, 1, 7, 13, 19, 20, 4, 5, 11, 17, 23, 2, 8, 14, 15, 21]);
/**
 * 24 numbers used in the sha3 permute function
 */
var SHIFTS = Object.freeze([-12, -11, 21, 14, 28, 20, 3, -13, -29, 1, 6, 25, 8, 18, 27, -4, 10, 15, -24, -30, -23, -7, -9, 2]);
/**
 * Round constants used in the sha3 permute function
 */
var RC = Object.freeze([
    (0, types_2.uint64)("0x0000000000000001"),
    (0, types_2.uint64)("0x0000000000008082"),
    (0, types_2.uint64)("0x800000000000808a"),
    (0, types_2.uint64)("0x8000000080008000"),
    (0, types_2.uint64)("0x000000000000808b"),
    (0, types_2.uint64)("0x0000000080000001"),
    (0, types_2.uint64)("0x8000000080008081"),
    (0, types_2.uint64)("0x8000000000008009"),
    (0, types_2.uint64)("0x000000000000008a"),
    (0, types_2.uint64)("0x0000000000000088"),
    (0, types_2.uint64)("0x0000000080008009"),
    (0, types_2.uint64)("0x000000008000000a"),
    (0, types_2.uint64)("0x000000008000808b"),
    (0, types_2.uint64)("0x800000000000008b"),
    (0, types_2.uint64)("0x8000000000008089"),
    (0, types_2.uint64)("0x8000000000008003"),
    (0, types_2.uint64)("0x8000000000008002"),
    (0, types_2.uint64)("0x8000000000000080"),
    (0, types_2.uint64)("0x000000000000800a"),
    (0, types_2.uint64)("0x800000008000000a"),
    (0, types_2.uint64)("0x8000000080008081"),
    (0, types_2.uint64)("0x8000000000008080"),
    (0, types_2.uint64)("0x0000000080000001"),
    (0, types_2.uint64)("0x8000000080008008"),
]);
function permute(s) {
    var c = new Array(5);
    var b = new Array(25);
    for (var round = 0; round < 24; round++) {
        for (var i = 0; i < 5; i++) {
            c[i] = (0, types_2.uint64)((((s[i] ^ s[i + 5]) ^ s[i + 10]) ^ s[i + 15]) ^ s[i + 20]);
        }
        for (var i = 0; i < 5; i++) {
            var tmp = (0, types_2.uint64)(c[(i + 4) % 5] ^ (0, types_2.uint64Rotr)(c[(i + 1) % 5], 63));
            for (var j = 0; j < 5; j++) {
                s[i + 5 * j] = (0, types_2.uint64)(s[i + 5 * j] ^ tmp);
            }
        }
        b[0] = s[0];
        for (var i = 1; i < 25; i++) {
            var offset = OFFSETS[i - 1];
            var left = Math.abs(SHIFTS[i - 1]);
            var right = (32 - left);
            if (SHIFTS[i - 1] < 0) {
                b[i] = (0, types_2.uint64Rotr)(s[offset], right);
            }
            else {
                b[i] = (0, types_2.uint64Rotr)(s[offset], (right + 32));
            }
        }
        for (var i = 0; i < 5; i++) {
            for (var j = 0; j < 5; j++) {
                s[i * 5 + j] = (0, types_2.uint64)(b[i * 5 + j] ^ ((~b[i * 5 + (j + 1) % 5]) & b[i * 5 + (j + 2) % 5]));
            }
        }
        s[0] = (s[0] ^ RC[round]);
    }
}
/**
 * getulates sha3-256 (32bytes) hash of a list of uint8 numbers.
 * Result is also a list of uint8 number.
 * Sha3 only bit-wise operations, so 64-bit operations can easily be replicated using 2 32-bit operations instead
 * @example
 * bytesToHex(sha3(textToBytes("abc"))) => "3a985da74fe225b2045c172d6bd390bd855f086e3e9d525b46bfe24511431532"
 * @example
 * bytesToHex(sha3((new Array(136)).fill(1))) => "b36dc2167c4d9dda1a58b87046c8d76a6359afe3612c4de8a38857e09117b2db"
 * @example
 * bytesToHex(sha3((new Array(135)).fill(2))) => "5bdf5d815d29a9d7161c66520efc17c2edd7898f2b99a029e8d2e4ff153407f4"
 * @example
 * bytesToHex(sha3((new Array(134)).fill(3))) => "8e6575663dfb75a88f94a32c5b363c410278b65020734560d968aadd6896a621"
 * @example
 * bytesToHex(sha3((new Array(137)).fill(4))) => "f10b39c3e455006aa42120b9751faa0f35c821211c9d086beb28bf3c4134c6c6"
 */
function sha3(bytes) {
    if ((0, uint8array_utils_1.isUint8Array)(bytes)) {
        bytes = (0, types_1.buffToByteArr)(bytes);
    }
    bytes = pad(bytes);
    // initialize the state
    var state = (new Array(WIDTH / 8)).fill((0, types_2.uint64)(0));
    for (var chunkStart = 0; chunkStart < bytes.length; chunkStart += RATE) {
        // extend the chunk to become length WIDTH
        var chunk = bytes.slice(chunkStart, chunkStart + RATE).concat((new Array(CAP)).fill(0));
        // element-wise xor with 'state'
        for (var i = 0; i < WIDTH; i += 8) {
            state[i / 8] = (0, types_2.uint64)(state[i / 8] ^
                (0, types_2.uint64)("0x" + (0, types_2.byteArrToHex)(chunk.slice(i, i + 8).reverse())));
            // beware: a uint32 is stored as little endian, but a pair of uint32s that form a uin64 are stored in big endian format!
            //state[i/4] ^= (chunk[i] << 0) | (chunk[i+1] << 8) | (chunk[i+2] << 16) | (chunk[i+3] << 24);
        }
        // apply block permutations
        permute(state);
    }
    var hash = [];
    for (var i = 0; i < 4; i++) {
        hash.push.apply(hash, __spreadArray([], __read((0, types_2.uint64ToBytesLE)(state[i])), false));
    }
    return hash;
}
exports.sha3 = sha3;


/***/ }),

/***/ 80247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.uint64Rotr = exports.uint64ToBytesBE = exports.uint64ToBytesLE = exports.isUint64 = exports.forceUint64 = exports.uint64 = exports.buffToUint5Arr = exports.byteArrToBin = exports.byteArrToHex = exports.buffToByteArr = exports.isByteArr = exports.isByte = exports.byte = exports.isUint6 = exports.isUint5 = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var assert_1 = __webpack_require__(97610);
function isUint5(n) {
    return (typeof n === "number" &&
        n >= 0 && n <= 31 &&
        n === Math.round(n));
}
exports.isUint5 = isUint5;
function isUint6(n) {
    return (typeof n === "number" &&
        n >= 0 && n <= 63 &&
        n === Math.round(n));
}
exports.isUint6 = isUint6;
function byte(bint) {
    return (Number(bint) & 0xff);
}
exports.byte = byte;
function isByte(n) {
    return (typeof n === "number" &&
        n >= 0 && n <= 255 &&
        n === Math.round(n));
}
exports.isByte = isByte;
function isByteArr(something) {
    return (Array.isArray(something) &&
        something.every(isByte));
}
exports.isByteArr = isByteArr;
function buffToByteArr(buff) {
    if (!(0, uint8array_utils_1.isUint8Array)(buff)) {
        if (isByteArr(buff))
            return buff.slice();
        throw new Error("can't convert non-buffer to byte array");
    }
    return Array.from(buff);
}
exports.buffToByteArr = buffToByteArr;
function byteArrToHex(bytes) {
    if (bytes instanceof Uint8Array)
        bytes = Array.from(bytes);
    return bytes.reduce(function (acc, val) { return acc + val.toString(16).slice(0, 2).padStart(2, '0'); }, '');
}
exports.byteArrToHex = byteArrToHex;
function byteArrToBin(bytes) {
    return bytes.reduce(function (acc, val) { return acc + val.toString(2).slice(0, 8).padStart(8, '0'); }, '');
}
exports.byteArrToBin = byteArrToBin;
/**
 * Internal method
 *
 * `bytes` is **padded at the end** to be a multiple of 5
 */
function buffToUint5Arr(bytes) {
    var result = [];
    var bits = (0, uint8array_utils_1.isUint8Array)(bytes) ?
        Array.from(bytes).reduce(function (acc, n) { return acc + n.toString(2).padStart(8, '0'); }, "") :
        (isByteArr(bytes) ?
            byteArrToBin(bytes) :
            undefined);
    if (bits === undefined) {
        throw new Error("invalid input to convert ot uint5 array");
    }
    var mod5Len = bits.length % 5;
    if (mod5Len !== 0) {
        bits = bits.padEnd(bits.length + (5 - mod5Len), '0');
    }
    bits = bits.split('');
    for (var i = 0; i < bits.length;) {
        result.push(Number("0b".concat(bits[i++]).concat(bits[i++]).concat(bits[i++]).concat(bits[i++]).concat(bits[i++])));
    }
    return result;
}
exports.buffToUint5Arr = buffToUint5Arr;
function uint64(n) {
    var _n = BigInt(n);
    if (!isUint64(_n))
        throw new Error("can't convert " + n + " to uint64");
    return _n;
}
exports.uint64 = uint64;
function forceUint64(n) {
    return (BigInt(n) & BigInt("0x" + "ff".repeat(8)));
}
exports.forceUint64 = forceUint64;
function isUint64(n) {
    return (typeof n === "bigint" &&
        n >= BigInt(0) &&
        n < BigInt("0x1" + "00".repeat(8)) // n < (1 << 64)
    );
}
exports.isUint64 = isUint64;
function uint64ToBytesLE(uint) {
    return [
        byte(BigInt("0x00000000000000ff") & uint),
        byte((BigInt("0x000000000000ff00") & uint) >> BigInt(8)),
        byte((BigInt("0x0000000000ff0000") & uint) >> BigInt(16)),
        byte((BigInt("0x00000000ff000000") & uint) >> BigInt(24)),
        byte((BigInt("0x000000ff00000000") & uint) >> BigInt(32)),
        byte((BigInt("0x0000ff0000000000") & uint) >> BigInt(40)),
        byte((BigInt("0x00ff000000000000") & uint) >> BigInt(48)),
        byte((BigInt("0xff00000000000000") & uint) >> BigInt(56)),
    ];
}
exports.uint64ToBytesLE = uint64ToBytesLE;
function uint64ToBytesBE(uint) {
    return uint64ToBytesLE(uint).reverse();
}
exports.uint64ToBytesBE = uint64ToBytesBE;
function uint64Rotr(a, b) {
    (0, assert_1.assert)(isUint64(a) && isUint6(b), "invalid args for 'uint64And'");
    if (b === 0)
        return a;
    var n = BigInt(b);
    return forceUint64(forceUint64(a >> n) | forceUint64(a << (BigInt(64) - n)));
}
exports.uint64Rotr = uint64Rotr;


/***/ }),

/***/ 97610:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assertBytes = exports.assertPostiveInteger = exports.assert = void 0;
function assert(condition, errorMessage, addInfos) {
    var args = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args[_i - 3] = arguments[_i];
    }
    if (condition)
        return;
    args.length > 0 && console.error.apply(console, __spreadArray([], __read(args), false));
    addInfos && console.error(addInfos);
    if (errorMessage instanceof Error) {
        throw errorMessage;
    }
    ;
    throw new Error(errorMessage);
}
exports.assert = assert;
// keccak asserts
function assertPostiveInteger(n) {
    if (!Number.isSafeInteger(n) || n < 0)
        throw new Error("positive integer expected, not ".concat(n));
}
exports.assertPostiveInteger = assertPostiveInteger;
function assertBytes(stuff) {
    if (!(stuff instanceof Uint8Array))
        throw new Error("Uint8Array expected");
}
exports.assertBytes = assertBytes;


/***/ }),

/***/ 88979:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeBase32Bech32 = exports.decodeBase32rfc4648 = exports.encodeBase32rfc4648 = exports.BECH32_BASE32_ALPHABET = exports.rfc4648_ALPHABET = void 0;
var types_1 = __webpack_require__(80247);
var bitstream_1 = __webpack_require__(85840);
exports.rfc4648_ALPHABET = Object.freeze([
    'a', 'b', 'c', 'd', 'e', 'f', 'g',
    'h', 'i', 'j', 'k', 'l', 'm', 'n',
    'o', 'p', 'q', 'r', 's', 't', 'u',
    'v', 'w', 'x', 'y', 'z', '2', '3',
    '4', '5', '6', '7'
]);
exports.BECH32_BASE32_ALPHABET = Object.freeze([
    'q', 'p', 'z', 'r', 'y', '9', 'x',
    '8', 'g', 'f', '2', 't', 'v', 'd',
    'w', '0', 's', '3', 'j', 'n', '5',
    '4', 'k', 'h', 'c', 'e', '6', 'm',
    'u', 'a', '7', 'l'
]);
function encodeBase32rfc4648(bytes) {
    return (0, types_1.buffToUint5Arr)(bytes).map(function (c) { return exports.rfc4648_ALPHABET[c]; }).join("");
}
exports.encodeBase32rfc4648 = encodeBase32rfc4648;
function decodeBase32(base32Str, alpabeth) {
    if (!Array.from(base32Str).every(function (ch) { return alpabeth.includes(ch); }))
        throw new Error("can't decode base32 a string that is not in base32 (rfc 4648); string was: " + base32Str);
    var len = base32Str.length;
    var bits = '';
    for (var i = 0; i < len - 1; i++) {
        var num_1 = alpabeth.indexOf(base32Str[i].toLowerCase());
        bits += num_1.toString(2).padStart(5, '0');
    }
    // last, make sure we align to byte
    var nCut = len * 5 - 8 * Math.floor(len * 5 / 8);
    var num = alpabeth.indexOf(base32Str[len - 1].toLowerCase());
    var lastbits = num.toString(2).padStart(5, '0');
    bits += lastbits.slice(0, 5 - nCut);
    return bitstream_1.BitStream.fromBinStr(bits).toBuffer().buffer;
}
function decodeBase32rfc4648(base32Str) {
    return decodeBase32(base32Str, exports.rfc4648_ALPHABET);
}
exports.decodeBase32rfc4648 = decodeBase32rfc4648;
function decodeBase32Bech32(base32Str) {
    return decodeBase32(base32Str, exports.BECH32_BASE32_ALPHABET);
}
exports.decodeBase32Bech32 = decodeBase32Bech32;


/***/ }),

/***/ 35653:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bigintToBuffer = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
function bigintToBuffer(bigint, nBytes) {
    if (nBytes === void 0) { nBytes = undefined; }
    if (bigint < BigInt(0))
        throw new Error("cannot convert negative bigint to buffer");
    if (typeof nBytes !== "number")
        nBytes = undefined;
    if (bigint === BigInt(0)) {
        if (nBytes === undefined)
            nBytes = 0;
        return new Uint8Array(nBytes);
    }
    var buffHexString = bigint.toString(16);
    buffHexString = buffHexString.length % 2 === 0 ? buffHexString : '0' + buffHexString;
    if (typeof nBytes === "number") {
        nBytes = Math.round(Math.abs(nBytes));
        buffHexString = buffHexString.padStart(nBytes * 2, "00");
        if (buffHexString.length > nBytes * 2)
            // only keep the last nBytes
            buffHexString = buffHexString.slice(buffHexString.length - (nBytes * 2));
    }
    return (0, uint8array_utils_1.fromHex)(buffHexString);
}
exports.bigintToBuffer = bigintToBuffer;


/***/ }),

/***/ 39578:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRandomValues = void 0;
var hasGlobalWebCrypto_1 = __webpack_require__(69631);
function _getRandomValues(buff) {
    for (var i = 0; i < buff.length; i++) {
        buff[i] = (Math.random() * 256) >>> 0;
    }
    return buff;
}
/** [MDN Reference](https://developer.mozilla.org/docs/Web/API/Crypto/getRandomValues) */
exports.getRandomValues = hasGlobalWebCrypto_1.hasGlobalWebCrypto ? globalThis.crypto.getRandomValues.bind(globalThis.crypto) : _getRandomValues;


/***/ }),

/***/ 16566:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(88979), exports);
__exportStar(__webpack_require__(60011), exports);
__exportStar(__webpack_require__(21213), exports);


/***/ }),

/***/ 60011:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.positiveMod = void 0;
var _0n = BigInt(0);
function positiveMod(x, n) {
    n = typeof n === "bigint" ? n : BigInt(n);
    x = typeof x === "bigint" ? x : BigInt(x);
    var res = x % n;
    return res < _0n ? res + n : res;
}
exports.positiveMod = positiveMod;


/***/ }),

/***/ 21213:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.rotr32 = void 0;
function rotr32(x, by) {
    return (x >>> by) | (x << (32 - by)) | 0;
}
exports.rotr32 = rotr32;


/***/ }),

/***/ 28243:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.VrfBatchVerifier = exports.VrfBatchProof10 = exports.VrfProof10 = exports.derive_vrf10_public_key = exports.VrfProof03 = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var curves_1 = __webpack_require__(46732);
var vrf03_1 = __webpack_require__(54334);
var vrf10_1 = __webpack_require__(66222);
var vrf10_batch_1 = __webpack_require__(89351);
var getRandomValues_1 = __webpack_require__(39578);
var VrfProof03 = /** @class */ (function () {
    function VrfProof03(_a) {
        var gamma = _a.gamma, challenge = _a.challenge, response = _a.response;
        this.gamma = gamma;
        this.challenge = challenge;
        this.response = response;
    }
    VrfProof03.prototype.toHash = function () {
        return (0, vrf03_1.proof_to_hash)(this);
    };
    VrfProof03.generate = function (secret_key, public_key, alpha_string) {
        return new VrfProof03((0, vrf03_1.vrf_ed25519_sha512_ell2_generate_proof)(secret_key, public_key, alpha_string));
    };
    VrfProof03.verify = function (public_key, alpha_string, proof) {
        return (0, vrf03_1.vrf_ed25519_sha512_ell2_verify_proof)(public_key, alpha_string, proof);
    };
    VrfProof03.prototype.verify = function (public_key, alpha_string) {
        return (0, vrf03_1.vrf_ed25519_sha512_ell2_verify_proof)(public_key, alpha_string, this);
    };
    /*
    pub fn to_bytes(&self) -> [u8; PROOF_SIZE] {
        let mut proof = [0u8; PROOF_SIZE];
        proof[..32].copy_from_slice(self.gamma.compress().as_bytes());
        proof[32..48].copy_from_slice(&self.challenge.to_bytes()[..16]);
        proof[48..].copy_from_slice(self.response.as_bytes());

        proof
    }
    */
    VrfProof03.prototype.toBytes = function () {
        var output = new Uint8Array(80);
        output.set(this.gamma.compress(), 0);
        output.set(this.challenge.slice(0, 16), 32);
        output.set(this.response, 48);
        return output;
    };
    VrfProof03.fromBytes = function (bytes) {
        var gamma = curves_1.EdwardsPoint.decompress(Uint8Array.prototype.slice.call(bytes, 0, 32));
        if (!gamma)
            throw new Error("Invalid gamma point");
        var challenge = new Uint8Array(32);
        challenge.set(Uint8Array.prototype.slice.call(bytes, 32, 48), 0);
        var response = Uint8Array.prototype.slice.call(bytes, 48, 80);
        return new VrfProof03({
            gamma: gamma,
            challenge: challenge,
            response: response
        });
    };
    return VrfProof03;
}());
exports.VrfProof03 = VrfProof03;
function derive_vrf10_public_key(secret_key) {
    return curves_1.EdwardsPoint.BASEPOINT_ED25519.scalarMul((0, vrf10_1.extend_secret_key)(secret_key)[0]).compress();
}
exports.derive_vrf10_public_key = derive_vrf10_public_key;
var VrfProof10 = /** @class */ (function () {
    function VrfProof10(_a) {
        var gamma = _a.gamma, challenge = _a.challenge, response = _a.response;
        this.gamma = gamma;
        this.challenge = challenge;
        this.response = response;
    }
    VrfProof10.prototype.toHash = function () {
        return (0, vrf10_1.vrf10_proof_to_hash)(this);
    };
    VrfProof10.generate = function (secret_key, public_key, alpha_string) {
        return new VrfProof10((0, vrf10_1.vrf10_ed25519_sha512_ell2_generate_proof)(secret_key, public_key, alpha_string));
    };
    VrfProof10.verify = function (public_key, alpha_string, proof) {
        return (0, vrf10_1.vrf10_ed25519_sha512_ell2_verify_proof)(public_key, alpha_string, proof);
    };
    VrfProof10.prototype.verify = function (public_key, alpha_string) {
        return (0, vrf10_1.vrf10_ed25519_sha512_ell2_verify_proof)(public_key, alpha_string, this);
    };
    /*
    pub fn to_bytes(&self) -> [u8; PROOF_SIZE] {
        let mut proof = [0u8; PROOF_SIZE];
        proof[..32].copy_from_slice(self.gamma.compress().as_bytes());
        proof[32..48].copy_from_slice(&self.challenge.to_bytes()[..16]);
        proof[48..].copy_from_slice(self.response.as_bytes());

        proof
    }
    */
    VrfProof10.prototype.toBytes = function () {
        var output = new Uint8Array(80);
        output.set(this.gamma.compress(), 0);
        output.set(this.challenge.slice(0, 16), 32);
        output.set(this.response, 48);
        return output;
    };
    VrfProof10.fromBytes = function (bytes) {
        var gamma = curves_1.EdwardsPoint.decompress(Uint8Array.prototype.slice.call(bytes, 0, 32));
        if (!gamma)
            throw new Error("Invalid gamma point");
        var challenge = new Uint8Array(32);
        challenge.set(Uint8Array.prototype.slice.call(bytes, 32, 48), 0);
        var response = Uint8Array.prototype.slice.call(bytes, 48, 80);
        return new VrfProof10({
            gamma: gamma,
            challenge: challenge,
            response: response
        });
    };
    return VrfProof10;
}());
exports.VrfProof10 = VrfProof10;
var VrfBatchProof10 = /** @class */ (function () {
    function VrfBatchProof10(_a) {
        var gamma = _a.gamma, u_point = _a.u_point, v_point = _a.v_point, response = _a.response;
        this.gamma = gamma;
        this.u_point = u_point;
        this.v_point = v_point;
        this.response = response;
    }
    VrfBatchProof10.prototype.toHash = function () {
        return (0, vrf10_batch_1.vrf10_batch_ed25519_sha512_ell2_proof_to_hash)(this);
    };
    VrfBatchProof10.generate = function (secret_key, public_key, alpha_string) {
        return new VrfBatchProof10((0, vrf10_batch_1.vrf10_batch_ed25519_sha512_ell2_generate_proof)(secret_key, public_key, alpha_string));
    };
    VrfBatchProof10.verify = function (public_key, alpha_string, proof) {
        return (0, vrf10_batch_1.vrf10_batch_ed25519_sha512_ell2_verify_proof)(public_key, alpha_string, proof);
    };
    VrfBatchProof10.prototype.verify = function (public_key, alpha_string) {
        return (0, vrf10_batch_1.vrf10_batch_ed25519_sha512_ell2_verify_proof)(public_key, alpha_string, this);
    };
    /*
    pub fn to_bytes(&self) -> [u8; PROOF_SIZE] {
        let mut proof = [0u8; PROOF_SIZE];
        proof[..32].copy_from_slice(self.gamma.compress().as_bytes());
        proof[32..48].copy_from_slice(&self.challenge.to_bytes()[..16]);
        proof[48..].copy_from_slice(self.response.as_bytes());

        proof
    }
    */
    VrfBatchProof10.prototype.toBytes = function () {
        var output = new Uint8Array(128);
        output.set(this.gamma.compress(), 0);
        output.set(this.u_point.compress(), 32);
        output.set(this.v_point.compress(), 64);
        output.set(this.response, 96);
        return output;
    };
    VrfBatchProof10.fromBytes = function (bytes) {
        var gamma = curves_1.EdwardsPoint.decompress(Uint8Array.prototype.slice.call(bytes, 0, 32));
        if (!gamma)
            throw new Error("Invalid gamma point");
        var u_point = curves_1.EdwardsPoint.decompress(Uint8Array.prototype.slice.call(bytes, 32, 64));
        if (!u_point)
            throw new Error("Invalid u_point point");
        var v_point = curves_1.EdwardsPoint.decompress(Uint8Array.prototype.slice.call(bytes, 64, 96));
        if (!v_point)
            throw new Error("Invalid v_point point");
        var response = Uint8Array.prototype.slice.call(bytes, 96, 128);
        return new VrfBatchProof10({
            gamma: gamma,
            u_point: u_point,
            v_point: v_point,
            response: response
        });
    };
    return VrfBatchProof10;
}());
exports.VrfBatchProof10 = VrfBatchProof10;
function gen_u128_bytes() {
    var buff = new Uint8Array(16);
    (0, getRandomValues_1.getRandomValues)(buff);
    return buff;
}
function gen_u128() {
    return BigInt("0x" +
        (0, uint8array_utils_1.toHex)(gen_u128_bytes()));
}
/** for some reason, from 38 elems up it fails */
var MAX_BATCH_SIZE = 37;
var VrfBatchVerifier = /** @class */ (function () {
    function VrfBatchVerifier(size) {
        this.size = size;
        this._currLen = 0;
        this.proof_scalars = new Array(size);
        this.pks = new Array(size);
        this.us = new Array(size);
        this.hs = new Array(size);
        this.gammas = new Array(size);
        this.vs = new Array(size);
        this._currLen = 0;
    }
    VrfBatchVerifier.prototype.insert = function (item) {
        if (this._currLen >= this.size)
            throw new Error("BatchVerifier is full");
        var output = item.proof.toHash();
        var decompressed_pk = curves_1.EdwardsPoint.decompress(item.public_key);
        if (!decompressed_pk || decompressed_pk.is_small_order())
            throw new Error("Invalid public key");
        var h = (0, vrf10_1.vrf10_ed25519_sha512_ell2_hash_to_curve)(item.public_key, item.alpha);
        var compressed_h = h.compress();
        var gamma = item.proof.gamma;
        var compressed_gamma = gamma.compress();
        var u = item.proof.u_point;
        var compressed_u = u.compress();
        var v = item.proof.v_point;
        var compressed_v = v.compress();
        this.proof_scalars[this._currLen] = [
            (0, vrf10_1.vrf10_ed25519_sha512_ell2_compute_challenge)(compressed_h, compressed_gamma, compressed_u, compressed_v),
            item.proof.response
        ];
        this.pks[this._currLen] = decompressed_pk;
        this.us[this._currLen] = u;
        this.hs[this._currLen] = h;
        this.gammas[this._currLen] = gamma;
        this.vs[this._currLen] = v;
        this._currLen++;
    };
    VrfBatchVerifier.prototype.verify = function () {
        var size = this._currLen;
        var b_coeff = scalar_zero();
        /** array of scalars */
        var lchalls = new Array(size);
        /** array of scalars */
        var rchalls = new Array(size);
        /** array of scalars */
        var ls = new Array(size);
        /** array of scalars */
        var rs = new Array(size);
        /** array of scalars */
        var rresponses = new Array(size);
        for (var i = 0; i < size; i++) {
            var _a = __read(this.proof_scalars[i], 2), challenge = _a[0], response = _a[1];
            var li = new Uint8Array(32);
            li.set(gen_u128_bytes(), 0);
            var ri = new Uint8Array(32);
            ri.set(gen_u128_bytes(), 0);
            b_coeff = (0, curves_1.add_scalars)(b_coeff, (0, curves_1.mul_scalars)(li, response));
            lchalls[i] = (0, curves_1.mul_scalars)(li, challenge);
            ls[i] = li;
            rresponses[i] = (0, curves_1.mul_scalars)(ri, (0, curves_1.negate_scalar)(response));
            rchalls[i] = (0, curves_1.mul_scalars)(ri, challenge);
            rs[i] = ri;
        }
        var result = curves_1.EdwardsPoint.vartime_multiscalar_mul([(0, curves_1.negate_scalar)(b_coeff)]
            .concat(lchalls)
            .concat(ls)
            .concat(rresponses)
            .concat(rchalls)
            .concat(rs), [curves_1.EdwardsPoint.BASEPOINT_ED25519]
            .concat(this.pks)
            .concat(this.us)
            .concat(this.hs)
            .concat(this.gammas)
            .concat(this.vs));
        return result.is_identity();
    };
    return VrfBatchVerifier;
}());
exports.VrfBatchVerifier = VrfBatchVerifier;
function scalar_zero() {
    return new Uint8Array(32);
}


/***/ }),

/***/ 37426:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defineNormalProperty = exports.defineFixedDeletableProperty = exports.defineHiddenNormalProperty = exports.defineDeletableDescriptor = exports.defineNonDeletableNormalProperty = exports.defineReadOnlyProperty = exports.defineWritableHiddenProperty = exports.defineGetterOnlyProperty = exports.defineReadOnlyHiddenProperty = exports.definePropertyIfNotPresent = exports.defineProperty = exports.freezeAll = exports.deepClone = exports.jsonClone = exports.deepEqual = exports.isSerializable = exports.hasOwn = exports.has_n_determined_keys = exports.containsKeys = exports.hasNkeys = exports.hasUniqueKey = exports.isObject = exports.isNotArray = void 0;
function isNotArray(obj) {
    return !Array.isArray(obj);
}
exports.isNotArray = isNotArray;
function isObject(obj) {
    return (typeof obj === "object" &&
        isNotArray(obj) &&
        obj !== null &&
        obj !== undefined // useless since "typeof" would have returned "undefined", but better safe than sorry :P
    );
}
exports.isObject = isObject;
function hasUniqueKey(obj, key) {
    if (key === void 0) { key = undefined; }
    var keys = Object.keys(obj);
    return (keys.length === 1 &&
        (typeof key !== "undefined" ? keys[0] === key : true));
}
exports.hasUniqueKey = hasUniqueKey;
function hasNkeys(obj, n) {
    return (isObject(obj) &&
        Object.keys(obj).length === n);
}
exports.hasNkeys = hasNkeys;
function containsKeys(obj) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    var oKeys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
        if (!oKeys.includes(keys[i]))
            return false;
    }
    return true;
}
exports.containsKeys = containsKeys;
function has_n_determined_keys(obj, n) {
    var keys = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        keys[_i - 2] = arguments[_i];
    }
    return (hasNkeys(obj, n) &&
        keys.length === n && containsKeys.apply(void 0, __spreadArray([obj], __read(keys), false)));
}
exports.has_n_determined_keys = has_n_determined_keys;
exports.hasOwn = (_b = ((_a = Object.hasOwn) !== null && _a !== void 0 ? _a : Object.prototype.hasOwnProperty.call)) !== null && _b !== void 0 ? _b : containsKeys;
function isSerializable(obj) {
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
        var value = obj[keys[i]];
        if (typeof value === "number" ||
            typeof value === "bigint" ||
            typeof value === "boolean" ||
            typeof value === "string" ||
            typeof value === "undefined")
            continue; // this single value is true, don't know the others
        else {
            if (Array.isArray(value)) {
                for (var i_1 = 0; i_1 < value.length; i_1++) {
                    // all array elements must be serilalizable to
                    // equivalent to AND all elments
                    if (!isSerializable(value[i_1]))
                        return false;
                }
            }
            else if (typeof value === "object") {
                if (!isSerializable(value))
                    continue; // this single value is true, don't know the others
                else
                    return false;
            }
            else if (typeof value === "function")
                return false;
        }
    }
    return true;
}
exports.isSerializable = isSerializable;
function deepEqual(a, b) {
    if (typeof a !== typeof b) {
        return false;
    }
    /*
    covers:
    - nuber
    - strings
    - boolean
    - functions only if are the same object
    ( unfortunately, proving deep function equality is not possible (yet) )
    */
    if (a === b) {
        return true;
    }
    if (Array.isArray(a)) {
        if (Array.isArray(b)) {
            if (a.length !== b.length)
                return false;
            for (var i = 0; i < a.length; i++) {
                if (!deepEqual(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        }
        else // a and b are not both arrays
         {
            return false;
        }
    }
    else if (Array.isArray(b))
        return false; // a is an array indeed
    // type equality checked before, no need to re-check
    if (typeof a === "object") {
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== aKeys.length) {
            return false;
        }
        // {} === {} -> true
        if (aKeys.length === 0 && bKeys.length === 0) {
            return true;
        }
        for (var i = 0; i < aKeys.length; i++) {
            var foundThis_a = false;
            for (var j = 0; j < bKeys.length; j++) {
                if (aKeys[i] === bKeys[j]) {
                    foundThis_a = true;
                    break;
                }
            }
            if (foundThis_a) {
                if (deepEqual(a[aKeys[i]], b[aKeys[i]])) {
                    if (i === (aKeys.length - 1)) {
                        return true;
                    }
                    continue;
                }
                else
                    return false;
            }
            else {
                return false;
            }
        }
    }
    return false;
}
exports.deepEqual = deepEqual;
function jsonClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
exports.jsonClone = jsonClone;
function deepClone(obj) {
    var clone;
    //@ts-ignore
    if (typeof obj === "function")
        return cloneFunc(obj);
    if (typeof obj === "object") {
        if (Array.isArray(obj)) {
            clone = [];
            for (var i = 0; i < obj.length; i++) {
                clone[i] = deepClone(obj[i]);
            }
            return clone;
        }
        var objKeys = Object.keys(obj);
        for (var i = 0; i < objKeys.length; i++) {
            clone[objKeys[i]] = deepClone(obj[objKeys[i]]);
        }
        return clone;
    }
    // number
    // string
    // boolean
    return obj;
}
exports.deepClone = deepClone;
function freezeAll(something) {
    if (typeof something === "object" && something !== null) {
        var ks = Object.keys(something);
        for (var i = 0; i < ks.length; i++) {
            freezeAll(something[ks[i]]);
        }
    }
    return Object.freeze(something);
}
exports.freezeAll = freezeAll;
var writableProperty = 1;
var enumerableProperty = 2;
var configurableProperty = 4;
/*
https://stackoverflow.com/questions/52204566/typescript-add-dynamically-named-property-to-return-type

declare function addKeyValue2<T extends {}, K extends keyof any, V>(obj: T, key: K, value: V):
    { [P in keyof (T & Record<K, any>)]: P extends K ? V : P extends keyof T ? T[P] : never }
*/
/**
 *
 * @param obj {object} to define the property on
 * @param name {PropertyKey} name of the property
 * @param value {any} value of the property
 * @param accessLevel writable / enumerable / configurable
 *
 * enumerable   = 0b010, if ```false``` is not showed
 * configurable = 0b100, if ```false``` cannot be deleted or changed
 *
 * 0 -> none // hidden object-specific descriptor
 *
 * 1 -> writable only // hidden, modifiable, non deletable
 *
 * 2 -> enumerable only // showed object-specific descriptor
 *
 * 3 -> writable AND enumerable // non deletable
 *
 * 4 -> configurable only // hidden object-specific deleteable descriptor
 *
 * 5 -> configurable AND writable // hidden, modifiable, deletable
 *
 * 6 -> configurable AND enumerable // showed, non modifiable, deletable
 *
 * 7 -> all // showed, modifiable, deletable
 *
 */
function defineProperty(obj, name, value, accessLevel) {
    if (accessLevel === void 0) { accessLevel = 0; }
    return Object.defineProperty(obj, name, {
        value: value,
        writable: (accessLevel & writableProperty) === writableProperty,
        enumerable: (accessLevel & enumerableProperty) === enumerableProperty,
        configurable: (accessLevel & configurableProperty) === configurableProperty,
    });
}
exports.defineProperty = defineProperty;
function definePropertyIfNotPresent(obj, name, descriptor) {
    if ((0, exports.hasOwn)(obj, name))
        return obj;
    return Object.defineProperty(obj, name, descriptor);
}
exports.definePropertyIfNotPresent = definePropertyIfNotPresent;
function defineReadOnlyHiddenProperty(obj, name, value) {
    return defineProperty(obj, name, value, 0);
}
exports.defineReadOnlyHiddenProperty = defineReadOnlyHiddenProperty;
function defineGetterOnlyProperty(obj, name, valueGetter) {
    return definePropertyIfNotPresent(obj, name, {
        get: valueGetter,
        set: function () { },
        configurable: false,
        enumerable: true
    });
}
exports.defineGetterOnlyProperty = defineGetterOnlyProperty;
function defineWritableHiddenProperty(obj, name, value) {
    return defineProperty(obj, name, value, 1);
}
exports.defineWritableHiddenProperty = defineWritableHiddenProperty;
/**
 * 2 -> enumerable only
 *
 * property is showed and can be accessed trough indexing
 *
 * cannot be modified
 *
 * cannot be deleted
 */
function defineReadOnlyProperty(obj, name, value) {
    var _a;
    if ((0, exports.hasOwn)(obj, name) && // if the object has already a property with the same name
        (!((_a = Object.getOwnPropertyDescriptor(obj, name)) === null || _a === void 0 ? void 0 : _a.writable)) // and it cannot be overridden
    )
        return obj; // return that object;
    return defineProperty(obj, name, value, 2);
}
exports.defineReadOnlyProperty = defineReadOnlyProperty;
function defineNonDeletableNormalProperty(obj, name, value) {
    var _a;
    if ((0, exports.hasOwn)(obj, name) && // if the object has already a property with the same name
        (!((_a = Object.getOwnPropertyDescriptor(obj, name)) === null || _a === void 0 ? void 0 : _a.writable)) // and it cannot be overridden
    )
        return obj; // return that object;
    return defineProperty(obj, name, value, 3);
}
exports.defineNonDeletableNormalProperty = defineNonDeletableNormalProperty;
function defineDeletableDescriptor(obj, name, value) {
    return defineProperty(obj, name, value, 4);
}
exports.defineDeletableDescriptor = defineDeletableDescriptor;
function defineHiddenNormalProperty(obj, name, value) {
    return defineProperty(obj, name, value, 5);
}
exports.defineHiddenNormalProperty = defineHiddenNormalProperty;
function defineFixedDeletableProperty(obj, name, value) {
    return defineProperty(obj, name, value, 6);
}
exports.defineFixedDeletableProperty = defineFixedDeletableProperty;
function defineNormalProperty(obj, name, value) {
    return defineProperty(obj, name, value, 7);
}
exports.defineNormalProperty = defineNormalProperty;
function cloneFunc(func) {
    var cloneObj = func;
    //@ts-ignore
    if (func.__isClone) {
        //@ts-ignore
        cloneObj = func.__clonedFrom;
    }
    //@ts-ignore
    var temp = function () { return cloneObj.apply(this, arguments); };
    for (var key in func) {
        //@ts-ignore
        temp[key] = func[key];
    }
    //@ts-ignore
    temp.__isClone = true;
    //@ts-ignore
    temp.__clonedFrom = cloneObj;
    return temp;
}
;


/***/ }),

/***/ 53307:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Pair = void 0;
var Pair = /** @class */ (function () {
    function Pair(a, b) {
        this.fst = a;
        this.snd = b;
    }
    Object.defineProperty(Pair.prototype, Symbol.toStringTag, {
        get: function () {
            return "Pair( ".concat(this.fst, ", ").concat(this.snd, " )");
        },
        enumerable: false,
        configurable: true
    });
    Pair.isStrictInstance = function (any) {
        if (any === undefined || any === null)
            return false;
        return Object.getPrototypeOf(any) === Pair.prototype;
    };
    Pair.prototype.asObj = function () {
        return {
            fst: this.fst,
            snd: this.snd
        };
    };
    return Pair;
}());
exports.Pair = Pair;


/***/ }),

/***/ 50615:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.dataFromJson = exports.cloneData = exports.eqData = exports.isData = void 0;
var DataB_1 = __webpack_require__(39954);
var DataConstr_1 = __webpack_require__(65612);
var DataI_1 = __webpack_require__(89446);
var DataList_1 = __webpack_require__(16429);
var DataMap_1 = __webpack_require__(87320);
var DataPair_1 = __webpack_require__(76021);
function isSomething(something) {
    return something !== null && something !== undefined;
}
function isData(something) {
    if (!isSomething(something))
        return false;
    var proto = Object.getPrototypeOf(something);
    return (proto === DataConstr_1.DataConstr.prototype ||
        proto === DataMap_1.DataMap.prototype ||
        proto === DataList_1.DataList.prototype ||
        proto === DataI_1.DataI.prototype ||
        proto === DataB_1.DataB.prototype);
}
exports.isData = isData;
function eqData(a, b) {
    if (!(isSomething(a) &&
        isSomething(b)))
        return false;
    var aProto = Object.getPrototypeOf(a);
    var bProto = Object.getPrototypeOf(b);
    if (aProto !== bProto)
        return false;
    if (aProto === DataConstr_1.DataConstr.prototype) {
        try {
            return (a.constr === b.constr &&
                a.fields.length === b.fields.length &&
                a.fields.every(function (aField, idx) { return eqData(aField, b.fields[idx]); }));
        }
        catch (e) {
            return false;
        }
    }
    if (aProto === DataMap_1.DataMap.prototype) {
        var aMap = a.map;
        var bMap_1 = b.map;
        return (aMap.length === bMap_1.length &&
            aMap.every(function (entry, idx) {
                var bEntry = bMap_1[idx];
                return (eqData(entry.fst, bEntry.fst) &&
                    eqData(entry.snd, bEntry.snd));
            }));
    }
    if (aProto === DataList_1.DataList.prototype) {
        return (a.list.every(function (elem, idx) { return eqData(elem, b.list[idx]); }));
    }
    if (aProto === DataI_1.DataI.prototype) {
        return (a.int === b.int);
    }
    if (aProto === DataB_1.DataB.prototype) {
        return (a.bytes.toString() === b.bytes.toString());
    }
    return false;
}
exports.eqData = eqData;
function cloneData(data) {
    if (!isData(data))
        throw new Error("invalid data while cloning");
    return data.clone();
}
exports.cloneData = cloneData;
/**
 * all data instances (from any version) will have a `toJson` method
 * this function will get back the data of this version if needed
**/
function dataFromJson(json) {
    if (typeof json !== "object")
        throw new TypeError("unexpected input");
    var keys = Object.keys(json);
    if (keys.length <= 0)
        throw new TypeError("unexpected input");
    var k = keys[0];
    if (k === "int")
        return new DataI_1.DataI(json[k]);
    if (k === "bytes")
        return new DataB_1.DataB(json[k]);
    if (k === "list")
        return new DataList_1.DataList(json[k].map(dataFromJson));
    if (k === "map") {
        var jsonMap = json[k];
        return new DataMap_1.DataMap(jsonMap.map(function (_a) {
            var k = _a.k, v = _a.v;
            return new DataPair_1.DataPair(dataFromJson(k), dataFromJson(v));
        }));
    }
    if (keys.includes("constr"))
        return new DataConstr_1.DataConstr(json.constr, json.fields.map(dataFromJson));
    throw new Error("unknown json format");
}
exports.dataFromJson = dataFromJson;


/***/ }),

/***/ 39954:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DataB = void 0;
var bytestring_1 = __webpack_require__(86152);
var roDescr_1 = __webpack_require__(37391);
var DataB = /** @class */ (function () {
    function DataB(B) {
        if (!(B instanceof bytestring_1.ByteString))
            B = new bytestring_1.ByteString(B);
        var _bytes = B.clone();
        Object.defineProperties(this, {
            bytes: __assign({ value: _bytes }, roDescr_1.roDescr)
        });
    }
    DataB.prototype.clone = function () {
        // the constructor clones the bytes
        return new DataB(this.bytes);
    };
    DataB.prototype.toJson = function () {
        return { bytes: this.bytes.toString() };
    };
    DataB.prototype.toString = function () {
        return "B #".concat(this.bytes.toString());
    };
    return DataB;
}());
exports.DataB = DataB;


/***/ }),

/***/ 65612:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cborTagToConstrNumber = exports.constrNumberToCborTag = exports.DataConstr = void 0;
var biguint_1 = __webpack_require__(79512);
var Data_1 = __webpack_require__(50615);
var assert_1 = __webpack_require__(34380);
var roDescr_1 = __webpack_require__(37391);
var DataConstr = /** @class */ (function () {
    function DataConstr(constr, fields) {
        (0, assert_1.assert)(Array.isArray(fields) && fields.every(Data_1.isData), "invalid fields passed to constructor");
        Object.defineProperties(this, {
            constr: __assign({ value: (0, biguint_1.forceBigUInt)(constr) }, roDescr_1.roDescr),
            fields: __assign({ value: fields }, roDescr_1.roDescr)
        });
    }
    DataConstr.prototype.clone = function () {
        return new DataConstr(this.constr, this.fields.map(function (dataElem) { return dataElem.clone(); }));
    };
    DataConstr.prototype.toJson = function () {
        return {
            constr: Number(this.constr),
            fields: this.fields.map(function (f) { return f.toJson(); })
        };
    };
    DataConstr.prototype.toString = function () {
        return "Constr ".concat(this.constr.toString(), " [").concat(this.fields.map(function (data) { return data.toString(); }).join(","), "]");
    };
    return DataConstr;
}());
exports.DataConstr = DataConstr;
/**
 * Note [CBOR alternative tags]
 *
 * We've proposed to add additional tags to the CBOR standard to cover (essentially) sum types.
 * This is exactly what we need to encode the 'Constr' constructor of 'Data' in an unambiguous way.
 * The tags aren't *quite* accepted yet, but they're clearly going to accept so we might as well
 * start using them.
 * The scheme is:
 * - Alternatives 0-6 -> tags 121-127, followed by the arguments in a list
 * - Alternatives 7-127 -> tags 1280-1400, followed by the arguments in a list
 * - Any alternatives, including those that don't fit in the above -> tag 102 followed by a list containing
 * an unsigned integer for the actual alternative, and then the arguments in a (nested!) list.
 */
function constrNumberToCborTag(uint) {
    if (uint < BigInt(0)) {
        throw new Error("an unsinged integer was negative; while constructing a CborTag from a DataConstr; tag: " + uint);
    }
    if (uint < BigInt(7)) {
        return uint + BigInt(121);
    }
    if (uint < BigInt(128)) {
        // ( 1280 - 7 ) + uint
        return (BigInt(1273) + uint);
    }
    return BigInt(102);
}
exports.constrNumberToCborTag = constrNumberToCborTag;
/**
 * the case ```tag === 102``` should be handled outside the funciton
 *
 * returns a negative number in case of unrecognized alternative
 */
function cborTagToConstrNumber(tag) {
    // should never happen being tag unsigned
    // ignores the tag if that's the case
    // negative numbers are returned also in case of unrecognized alternative
    if (tag < 0)
        return tag;
    if (121 <= tag && tag <= 127)
        return tag - BigInt(121);
    if (1280 <= tag && tag <= 1400)
        return tag - BigInt(1273);
    if (tag === BigInt(102))
        return tag;
    // unrecognized alternative
    return BigInt(-1);
}
exports.cborTagToConstrNumber = cborTagToConstrNumber;


/***/ }),

/***/ 89446:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DataI = void 0;
var roDescr_1 = __webpack_require__(37391);
var DataI = /** @class */ (function () {
    function DataI(I) {
        if (I === void 0) { I = 0; }
        I = BigInt(I);
        Object.defineProperties(this, {
            int: __assign({ value: I }, roDescr_1.roDescr)
        });
    }
    DataI.prototype.clone = function () {
        return new DataI(this.int);
    };
    DataI.prototype.toJson = function () {
        return { int: this.int.toString() };
    };
    DataI.prototype.toString = function () {
        return "I ".concat(this.int.toString());
    };
    return DataI;
}());
exports.DataI = DataI;


/***/ }),

/***/ 16429:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DataList = void 0;
var Data_1 = __webpack_require__(50615);
var assert_1 = __webpack_require__(34380);
var roDescr_1 = __webpack_require__(37391);
var DataList = /** @class */ (function () {
    function DataList(list) {
        (0, assert_1.assert)(Array.isArray(list) &&
            list.every(Data_1.isData), "invalid list passed to constructor");
        Object.defineProperties(this, {
            list: __assign({ value: list }, roDescr_1.roDescr)
        });
    }
    DataList.prototype.clone = function () {
        return new DataList(this.list.map(function (dataElem) { return dataElem.clone(); }));
    };
    DataList.prototype.toJson = function () {
        return {
            list: this.list.map(function (elem) { return elem.toJson(); })
        };
    };
    DataList.prototype.toString = function () {
        return "List [".concat(this.list.map(function (data) { return data.toString(); }).join(","), "]");
    };
    return DataList;
}());
exports.DataList = DataList;


/***/ }),

/***/ 87320:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DataMap = void 0;
var Data_1 = __webpack_require__(50615);
var DataPair_1 = __webpack_require__(76021);
var assert_1 = __webpack_require__(34380);
var roDescr_1 = __webpack_require__(37391);
var DataMap = /** @class */ (function () {
    function DataMap(map) {
        (0, assert_1.assert)(Array.isArray(map) &&
            map.every(function (entry) {
                return entry instanceof DataPair_1.DataPair &&
                    (0, Data_1.isData)(entry.fst) && (0, Data_1.isData)(entry.snd);
            }), "invalid map passed to 'DataPair' constructor");
        Object.defineProperties(this, {
            map: __assign({ value: map }, roDescr_1.roDescr)
        });
    }
    DataMap.prototype.clone = function () {
        return new DataMap(this.map.map(function (pair) { return pair.clone(); }));
    };
    DataMap.prototype.toJson = function () {
        return {
            map: this.map.map(function (_a) {
                var fst = _a.fst, snd = _a.snd;
                return ({
                    k: fst.toJson(),
                    v: snd.toJson()
                });
            })
        };
    };
    DataMap.prototype.toString = function () {
        return "Map [".concat(this.map.map(function (dataPair) { return dataPair.toString(); }).join(","), "]");
    };
    return DataMap;
}());
exports.DataMap = DataMap;


/***/ }),

/***/ 76021:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DataPair = void 0;
var Data_1 = __webpack_require__(50615);
var assert_1 = __webpack_require__(34380);
var roDescr_1 = __webpack_require__(37391);
var DataPair = /** @class */ (function () {
    function DataPair(fst, snd) {
        (0, assert_1.assert)((0, Data_1.isData)(fst) && (0, Data_1.isData)(snd), "invalid Data passed to 'DataPair' constructor; fst: ".concat(fst, "; snd: ").concat(snd));
        Object.defineProperties(this, {
            fst: __assign({ value: fst }, roDescr_1.roDescr),
            snd: __assign({ value: snd }, roDescr_1.roDescr),
        });
    }
    DataPair.prototype.clone = function () {
        return new DataPair(this.fst, this.snd);
    };
    DataPair.prototype.toString = function () {
        return "(".concat(this.fst.toString(), ",").concat(this.snd.toString(), ")");
    };
    return DataPair;
}());
exports.DataPair = DataPair;


/***/ }),

/***/ 51406:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.dataFromCbor = exports.dataFromCborObj = void 0;
var cbor_1 = __webpack_require__(79236);
var DataB_1 = __webpack_require__(39954);
var DataConstr_1 = __webpack_require__(65612);
var DataI_1 = __webpack_require__(89446);
var DataList_1 = __webpack_require__(16429);
var DataMap_1 = __webpack_require__(87320);
var DataPair_1 = __webpack_require__(76021);
var assert_1 = __webpack_require__(34380);
function dataFromCborObj(cborObj) {
    (0, assert_1.assert)((0, cbor_1.isCborObj)(cborObj), "Invalid cborObj to convert to Data");
    if (cborObj instanceof cbor_1.CborUInt ||
        cborObj instanceof cbor_1.CborNegInt) {
        return new DataI_1.DataI(cborObj.num);
    }
    if (cborObj instanceof cbor_1.CborBytes) {
        // if indefinite length (> 64)
        // `bytes` property already concats the chunks for us 
        return new DataB_1.DataB(cborObj.bytes);
    }
    if (cborObj instanceof cbor_1.CborArray) {
        return new DataList_1.DataList(cborObj.array.map(function (cObj) { return dataFromCborObj(cObj); }));
    }
    if (cborObj instanceof cbor_1.CborMap) {
        return new DataMap_1.DataMap(cborObj.map.map(function (entry) {
            return new DataPair_1.DataPair(dataFromCborObj(entry.k), dataFromCborObj(entry.v));
        }));
    }
    if (cborObj instanceof cbor_1.CborTag) {
        var tag = (0, DataConstr_1.cborTagToConstrNumber)(cborObj.tag);
        var data = cborObj.data;
        if (
        // any unrecognized tag
        tag < BigInt(0)
            || !(data instanceof cbor_1.CborArray)) {
            // ignore the tag and and treats the object as if it were normal CBOR
            return dataFromCborObj(data);
        }
        if (tag === BigInt(102)
            // DO NOT REMOVE
            // THIS IS A FIX TO A EDGE CASE
            // `cborTagToConstrNumber` will return 102 for cbor tag 1375 ( which is a DataConstr tag 102 )
            && cborObj.tag !== BigInt(1375)) {
            var dataArr = data.array;
            if (!(dataArr.length === 2 &&
                dataArr[0] instanceof cbor_1.CborUInt &&
                dataArr[1] instanceof cbor_1.CborArray))
                throw new Error("invalid fileds for cbor tag 102 while constructing DataConstr");
            return new DataConstr_1.DataConstr(dataArr[0].num, dataArr[1].array.map(dataFromCborObj));
        }
        return new DataConstr_1.DataConstr(tag, data.array.map(dataFromCborObj));
    }
    // CborText and CborSimple not supported
    throw new Error("invalid CBOR major type for Data");
}
exports.dataFromCborObj = dataFromCborObj;
function dataFromCbor(cbor) {
    return dataFromCborObj(cbor_1.Cbor.parse((0, cbor_1.forceCborString)(cbor)));
}
exports.dataFromCbor = dataFromCbor;


/***/ }),

/***/ 14834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.dataFromString = exports.dataFromStringWithOffset = void 0;
var DataB_1 = __webpack_require__(39954);
var DataConstr_1 = __webpack_require__(65612);
var DataI_1 = __webpack_require__(89446);
var DataList_1 = __webpack_require__(16429);
var DataPair_1 = __webpack_require__(76021);
var DataMap_1 = __webpack_require__(87320);
// | [`I ${bigint}` ]
// | [`B #${string}`];
function formatStringByBrackets(str) {
    var openBracketIdx = str.indexOf("[");
    var bIdx = str.indexOf("B");
    var iIdx = str.indexOf("I");
    if (
    // there is no open bracket
    openBracketIdx < 0 ||
        ( // or
        // we have an open bracket
        // and B is also present
        bIdx >= 0 ?
            // and B is before the open bracket
            bIdx < openBracketIdx :
            (
            // or I is also present
            iIdx >= 0 ?
                // and I is before
                iIdx < openBracketIdx :
                // else open bracket comes first
                false))) {
        var intMatch = str
            // I\s+             -> "I" followed by one or more space
            // \+?\-?           -> may or may nost start with "+" or "-"
            // (?<!\.)          -> MUST NOT have dots before
            // (?<!(#|x)\d*)    -> MUST NOT have before "#" or "x" with 0 or more digits (escluded bls elements and bytestrings)
            // \d+              -> one or more digits
            // (?!(\.|x))       -> MUST NOT have dots after or "x" (x excludes "0x" which are bls elems)
            .match(/I\s+\+?\-?(?<!\.)(?<!(#|x)\d*)\d+(?!(\.|x))/);
        var bsMatch = str.match(/B\s*#[0-9a-fA-F]*/);
        if (!bsMatch && !intMatch)
            throw new Error("expected Data I or B; found none");
        var match = bsMatch && intMatch ?
            (str.indexOf(bsMatch[0]) < str.indexOf(intMatch[0]) ?
                bsMatch :
                intMatch) :
            (!bsMatch ? intMatch : bsMatch);
        if (!match)
            throw new Error("expected Data I or B; found none");
        var formattedStr = match[0];
        return {
            formatted: [formattedStr],
            offset: str.indexOf(formattedStr) + formattedStr.length
        }; // I or B
    }
    var start = str.slice(0, openBracketIdx).trim();
    var prev = openBracketIdx + 1;
    var i = prev;
    var ch = "";
    var nOpen = 0;
    var isMap = /^\(?(\s*)?Map/.test(str);
    var insidePair = false;
    var pairK = undefined;
    var rest = [];
    while (true) {
        ch = str[i];
        switch (ch) {
            case "[": {
                nOpen++;
                break;
            }
            case "]": {
                if (nOpen === 0) {
                    var elem = str.substring(prev, i).trim();
                    if (elem !== "")
                        rest.push([elem]);
                    return {
                        formatted: [start, rest],
                        offset: i + 1
                    };
                }
                else
                    nOpen--;
                break;
            }
            case ",": {
                if (nOpen === 0) {
                    if (!isMap) {
                        rest.push(formatStringByBrackets(str.substring(prev, i)).formatted);
                        prev = i + 1;
                    }
                    else {
                        if (insidePair) {
                            if (str[prev] === ",")
                                prev++;
                            if (str[prev] === "(")
                                prev++;
                            pairK = formatStringByBrackets(str.substring(prev, i)).formatted;
                            prev = i + 1;
                        }
                        else
                            break;
                    }
                }
                break;
            }
            case "(": {
                if (nOpen === 0)
                    insidePair = true;
                break;
            }
            case ")": {
                if (nOpen === 0) {
                    var v = formatStringByBrackets(str.substring(prev, i)).formatted;
                    prev = i + 1;
                    rest.push({ k: pairK, v: v });
                    pairK = undefined;
                    insidePair = false;
                }
                break;
            }
            default: break;
        }
        i++;
    }
}
/**
 * parses the result of `data.toString()`
 *
 * @param {string} str data
 *
 * @returns and object with the parsed data and the length of the string used as `offset`
 */
function dataFromStringWithOffset(str) {
    var _a = formatStringByBrackets(str), words = _a.formatted, offset = _a.offset;
    return { data: parseWords(words), offset: offset };
}
exports.dataFromStringWithOffset = dataFromStringWithOffset;
/**
 * parses the result of `data.toString()`
 *
 * @param {string} str data
 */
function dataFromString(str) {
    return dataFromStringWithOffset(str).data;
}
exports.dataFromString = dataFromString;
function parseWords(words) {
    var start = words[0];
    while (start.startsWith("("))
        start = start.slice(1);
    if (/^\(?(\s*)?Constr/.test(start)) {
        var _a = __read(start.split(" "), 2), _ = _a[0], idxStr = _a[1];
        var idx = BigInt(idxStr);
        if (Array.isArray(words[1])) {
            var fields = words[1].map(parseWords);
            return new DataConstr_1.DataConstr(idx, fields);
        }
        else
            return dataFromString(words[0]);
    }
    if (/^\(?(\s*)?Map/.test(start)) {
        if (Array.isArray(words[1])) {
            var pairs = words[1];
            return new DataMap_1.DataMap(pairs.map(function (_a) {
                var k = _a.k, v = _a.v;
                return new DataPair_1.DataPair(parseWords(k), parseWords(v));
            }));
        }
        else
            return dataFromString(words[0]);
    }
    if (/^\(?(\s*)?List/.test(start)) {
        if (Array.isArray(words[1])) {
            return new DataList_1.DataList(words[1].map(parseWords));
        }
        else
            return dataFromString(words[0]);
    }
    if (start[0] === "I") {
        var _b = __read(start.split(" "), 2), _ = _b[0], valStr = _b[1];
        return new DataI_1.DataI(BigInt(valStr));
    }
    if (start[0] === "B") {
        var _c = __read(start.split("#"), 2), _ = _c[0], valueStr = _c[1];
        return new DataB_1.DataB(valueStr);
    }
    throw new Error("invalid string to parse Data; " + JSON.stringify(words));
}


/***/ }),

/***/ 83414:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hashData = void 0;
var crypto_1 = __webpack_require__(53450);
var Data_1 = __webpack_require__(50615);
var toCbor_1 = __webpack_require__(34279);
function hashData(data) {
    if (!(0, Data_1.isData)(data))
        throw new Error("hashData only works with Data");
    return (0, crypto_1.blake2b_256)((0, toCbor_1.dataToCbor)(data).toBuffer());
}
exports.hashData = hashData;


/***/ }),

/***/ 34635:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(50615), exports);
__exportStar(__webpack_require__(39954), exports);
__exportStar(__webpack_require__(65612), exports);
__exportStar(__webpack_require__(89446), exports);
__exportStar(__webpack_require__(16429), exports);
__exportStar(__webpack_require__(87320), exports);
__exportStar(__webpack_require__(76021), exports);
__exportStar(__webpack_require__(51406), exports);
__exportStar(__webpack_require__(14834), exports);
__exportStar(__webpack_require__(34279), exports);
__exportStar(__webpack_require__(83414), exports);
__exportStar(__webpack_require__(33098), exports);


/***/ }),

/***/ 34279:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.dataToCbor = exports.dataToCborObj = void 0;
var Data_1 = __webpack_require__(50615);
var DataConstr_1 = __webpack_require__(65612);
var DataMap_1 = __webpack_require__(87320);
var DataList_1 = __webpack_require__(16429);
var DataI_1 = __webpack_require__(89446);
var DataB_1 = __webpack_require__(39954);
var cbor_1 = __webpack_require__(79236);
var assert_1 = __webpack_require__(34380);
var uint8array_utils_1 = __webpack_require__(44948);
var minBigInt = BigInt("-18446744073709551616"); // -(2n ** 64n)
var maxBigInt = BigInt("18446744073709551615"); // (2n ** 64n) - 1n
function dataToCborObj(data) {
    (0, assert_1.assert)((0, Data_1.isData)(data), "Invalid data; cannot convert to CBOR");
    if (data instanceof DataConstr_1.DataConstr) {
        var constrNum = data.constr;
        var tag = (0, DataConstr_1.constrNumberToCborTag)(constrNum);
        var fields = new cbor_1.CborArray(data.fields.map(dataToCborObj), {
            indefinite: data.fields.length > 0
        });
        if (Number(tag) === 102) {
            /*
            Any alternatives, including those that don't fit in the above
            
            -> tag 102 followed by a list containing
                an unsigned integer for the actual alternative,
                and then the arguments in a (nested!) list.
            */
            fields = new cbor_1.CborArray([
                new cbor_1.CborUInt(constrNum),
                fields
            ]);
        }
        return new cbor_1.CborTag(tag, fields);
    }
    if (data instanceof DataMap_1.DataMap) {
        return new cbor_1.CborMap(data.map.map(function (pair) {
            return {
                k: dataToCborObj(pair.fst),
                v: dataToCborObj(pair.snd)
            };
        }), {
            indefinite: data.map.length > 0
        });
    }
    if (data instanceof DataList_1.DataList) {
        return new cbor_1.CborArray(data.list.map(dataToCborObj), {
            indefinite: data.list.length > 0
        });
    }
    if (data instanceof DataI_1.DataI) {
        var n = data.int;
        return (n < 0 ?
            new cbor_1.CborNegInt(n) :
            new cbor_1.CborUInt(n));
    }
    if (data instanceof DataB_1.DataB) {
        var bytes = data.bytes.toBuffer();
        // definite length only if length <= 64
        if (bytes.length <= 64)
            return new cbor_1.CborBytes(bytes);
        var ptr = 64;
        var fst = Uint8Array.prototype.slice.call(bytes, 0, ptr);
        var chunks = [];
        var chunkSize = 0;
        var chunkEnd = 0;
        while (ptr < bytes.length) {
            chunkSize = Math.min(64, bytes.length - ptr);
            chunkEnd = ptr + chunkSize;
            chunks.push(Uint8Array.prototype.slice.call(bytes, ptr, chunkEnd));
            ptr = chunkEnd;
        }
        // indefinite length bytes
        return new cbor_1.CborBytes(fst, chunks);
    }
    throw new Error("'dataToCborObj' did not match any possible Data constructor");
}
exports.dataToCborObj = dataToCborObj;
function dataToCbor(data) {
    return cbor_1.Cbor.encode(dataToCborObj(data));
}
exports.dataToCbor = dataToCbor;
function positiveIntegerToBytes(n) {
    var hex = n.toString(16);
    return (0, uint8array_utils_1.fromHex)((hex.length % 2) === 0 ? hex : "0" + hex);
}


/***/ }),

/***/ 33098:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 34380:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assert = void 0;
function assert(condition, errorMessage, addInfos) {
    var args = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args[_i - 3] = arguments[_i];
    }
    if (condition)
        return;
    args.length > 0 && console.error.apply(console, __spreadArray([], __read(args), false));
    addInfos && console.error(addInfos);
    if (errorMessage instanceof Error) {
        throw errorMessage;
    }
    ;
    throw new Error(errorMessage);
}
exports.assert = assert;


/***/ }),

/***/ 37391:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.roDescr = void 0;
exports.roDescr = Object.freeze({
    writable: false,
    enumerable: true,
    configurable: false
});


/***/ }),

/***/ 55638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeBech32 = exports.isBech32 = exports.encodeBech32 = exports.getBech32Checksum = exports.getBech32Polymod = exports.expandBech32HumanReadablePart = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var types_1 = __webpack_require__(62339);
var base32_1 = __webpack_require__(81721);
var assert_1 = __webpack_require__(24055);
/**
 * Expand human readable prefix of the bech32 encoding so it can be used in the checkSum
 */
function expandBech32HumanReadablePart(hrp) {
    var e_1, _a, e_2, _b;
    var bytes = [];
    try {
        for (var hrp_1 = __values(hrp), hrp_1_1 = hrp_1.next(); !hrp_1_1.done; hrp_1_1 = hrp_1.next()) {
            var c = hrp_1_1.value;
            bytes.push(c.charCodeAt(0) >> 5);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (hrp_1_1 && !hrp_1_1.done && (_a = hrp_1.return)) _a.call(hrp_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    bytes.push(0);
    try {
        for (var hrp_2 = __values(hrp), hrp_2_1 = hrp_2.next(); !hrp_2_1.done; hrp_2_1 = hrp_2.next()) {
            var c = hrp_2_1.value;
            bytes.push(c.charCodeAt(0) & 31);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (hrp_2_1 && !hrp_2_1.done && (_b = hrp_2.return)) _b.call(hrp_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return bytes;
}
exports.expandBech32HumanReadablePart = expandBech32HumanReadablePart;
var BECH32_POLYMOD_GEN = Object.freeze([0x3b6a57b2, 0x26508e6d, 0x1ea119fa, 0x3d4233dd, 0x2a1462b3]);
/**
 * Used as part of the bech32 checksum.
 */
function getBech32Polymod(bytes) {
    var e_3, _a;
    var checksum = 1;
    try {
        for (var bytes_1 = __values(bytes), bytes_1_1 = bytes_1.next(); !bytes_1_1.done; bytes_1_1 = bytes_1.next()) {
            var byte_1 = bytes_1_1.value;
            var c = (checksum >> 25);
            checksum = (checksum & 0x1fffffff) << 5 ^ byte_1;
            for (var i = 0; i < 5; i++) {
                if (((c >> i) & 1) != 0) {
                    checksum ^= BECH32_POLYMOD_GEN[i];
                }
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (bytes_1_1 && !bytes_1_1.done && (_a = bytes_1.return)) _a.call(bytes_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return checksum;
}
exports.getBech32Polymod = getBech32Polymod;
/**
 * Generate the bech32 checksum
 */
function getBech32Checksum(humanReadablePart, data) {
    var checksum = getBech32Polymod(expandBech32HumanReadablePart(humanReadablePart)
        .concat(data)
        .concat([0, 0, 0, 0, 0, 0])) ^ 1;
    var chkSum = [];
    for (var i = 0; i < 6; i++) {
        chkSum.push((checksum >> 5 * (5 - i)) & 31);
    }
    return chkSum;
}
exports.getBech32Checksum = getBech32Checksum;
/**
 * Creates a bech32 checksummed string (used to represent Cardano addresses)
 * @example
 * encodeBech32("foo", textToBytes("foobar")) => "foo1vehk7cnpwgry9h96"
 * @example
 * encodeBech32("addr_test", hexToBytes("70a9508f015cfbcffc3d88ac4c1c934b5b82d2bb281d464672f6c49539")) => "addr_test1wz54prcptnaullpa3zkyc8ynfddc954m9qw5v3nj7mzf2wggs2uld"
 * @param {byte[]} data - uint8 0 - 256
 */
function encodeBech32(humanReadablePart, data) {
    (0, assert_1.assert)(humanReadablePart.length > 0, "human-readable-part must have non-zero length");
    var _data = (0, types_1.buffToUint5Arr)((0, uint8array_utils_1.isUint8Array)(data) ? data : new Uint8Array(data));
    return humanReadablePart + "1" +
        _data.concat(getBech32Checksum(humanReadablePart, _data)).map(function (val) { return base32_1.BECH32_BASE32_ALPHABET[val]; }).join("");
}
exports.encodeBech32 = encodeBech32;
/**
 * Verify a bech32 checksum
 * @example
 * isBech32("foo1vehk7cnpwgry9h96") => true
 * @example
 * isBech32("foo1vehk7cnpwgry9h97") => false
 * @example
 * isBech32("a12uel5l") => true
 * @example
 * isBech32("mm1crxm3i") => false
 * @example
 * isBech32("A1G7SGD8") => false
 * @example
 * isBech32("abcdef1qpzry9x8gf2tvdw0s3jn54khce6mua7lmqqqxw") => true
 * @example
 * isBech32("?1ezyfcl") => true
 * @example
 * isBech32("addr_test1wz54prcptnaullpa3zkyc8ynfddc954m9qw5v3nj7mzf2wggs2uld") => true
 * @param {string} addr
 * @returns {boolean}
 */
function isBech32(addr) {
    var e_4, _a;
    var i = addr.indexOf("1");
    if (i == -1 || i == 0) {
        return false;
    }
    var hrp = addr.slice(0, i);
    addr = addr.slice(i + 1);
    var data = [];
    try {
        for (var addr_1 = __values(addr), addr_1_1 = addr_1.next(); !addr_1_1.done; addr_1_1 = addr_1.next()) {
            var ch = addr_1_1.value;
            var j = base32_1.BECH32_BASE32_ALPHABET.indexOf(ch);
            if (j == -1) {
                return false;
            }
            data.push(j);
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (addr_1_1 && !addr_1_1.done && (_a = addr_1.return)) _a.call(addr_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
    var chkSumA = data.slice(data.length - 6);
    var chkSumB = getBech32Checksum(hrp, data.slice(0, data.length - 6));
    for (var i_1 = 0; i_1 < 6; i_1++) {
        if (chkSumA[i_1] != chkSumB[i_1]) {
            return false;
        }
    }
    return true;
}
exports.isBech32 = isBech32;
/**
 * Decomposes a bech32 checksummed string (i.e. Cardano address), and returns the human readable part and the original bytes
 * Throws an error if checksum is invalid.
 * @example
 * bytesToHex(decodeBech32("addr_test1wz54prcptnaullpa3zkyc8ynfddc954m9qw5v3nj7mzf2wggs2uld")[1]) => "70a9508f015cfbcffc3d88ac4c1c934b5b82d2bb281d464672f6c49539"
 * @param {string} addr
 * @returns {[humanReadablePart: string, bytes: byte[]]}
 */
function decodeBech32(addr) {
    (0, assert_1.assert)(isBech32(addr), "invalid bech32 addr");
    var i = addr.indexOf("1");
    (0, assert_1.assert)(i != -1, "bech32 address missing the '1' separator");
    var hrp = addr.slice(0, i);
    addr = addr.slice(i + 1);
    var data = (0, base32_1.decodeBase32Bech32)(addr.slice(0, addr.length - 6));
    return [hrp, Array.from(data)];
}
exports.decodeBech32 = decodeBech32;


/***/ }),

/***/ 76427:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.blake2b_512 = exports.blake2b_256 = exports.blake2b_224 = exports.blake2b_128 = exports.blake2b = void 0;
/**
 * 64-bit unsigned addition
 * Sets v[a,a+1] += v[b,b+1]
 * v should be a Uint32Array
 */
function ADD64AA(v, a, b) {
    var o0 = v[a] + v[b];
    var o1 = v[a + 1] + v[b + 1];
    if (o0 >= 0x100000000) {
        o1++;
    }
    v[a] = o0;
    v[a + 1] = o1;
}
// 64-bit unsigned addition
// Sets v[a,a+1] += b
// b0 is the low 32 bits of b, b1 represents the high 32 bits
function ADD64AC(v, a, b0, b1) {
    var o0 = v[a] + b0;
    if (b0 < 0) {
        o0 += 0x100000000;
    }
    var o1 = v[a + 1] + b1;
    if (o0 >= 0x100000000) {
        o1++;
    }
    v[a] = o0;
    v[a + 1] = o1;
}
// Little-endian byte access
function B2B_GET32(arr, i) {
    return arr[i] ^ (arr[i + 1] << 8) ^ (arr[i + 2] << 16) ^ (arr[i + 3] << 24);
}
// G Mixing function
// The ROTRs are inlined for speed
function B2B_G(a, b, c, d, ix, iy) {
    var x0 = m[ix];
    var x1 = m[ix + 1];
    var y0 = m[iy];
    var y1 = m[iy + 1];
    ADD64AA(v, a, b); // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
    ADD64AC(v, a, x0, x1); // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
    var xor0 = v[d] ^ v[a];
    var xor1 = v[d + 1] ^ v[a + 1];
    v[d] = xor1;
    v[d + 1] = xor0;
    ADD64AA(v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
    xor0 = v[b] ^ v[c];
    xor1 = v[b + 1] ^ v[c + 1];
    v[b] = (xor0 >>> 24) ^ (xor1 << 8);
    v[b + 1] = (xor1 >>> 24) ^ (xor0 << 8);
    ADD64AA(v, a, b);
    ADD64AC(v, a, y0, y1);
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
    xor0 = v[d] ^ v[a];
    xor1 = v[d + 1] ^ v[a + 1];
    v[d] = (xor0 >>> 16) ^ (xor1 << 16);
    v[d + 1] = (xor1 >>> 16) ^ (xor0 << 16);
    ADD64AA(v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
    xor0 = v[b] ^ v[c];
    xor1 = v[b + 1] ^ v[c + 1];
    v[b] = (xor1 >>> 31) ^ (xor0 << 1);
    v[b + 1] = (xor0 >>> 31) ^ (xor1 << 1);
}
// Initialization Vector
var BLAKE2B_IV32 = new Uint32Array([
    0xf3bcc908, 0x6a09e667, 0x84caa73b, 0xbb67ae85, 0xfe94f82b, 0x3c6ef372,
    0x5f1d36f1, 0xa54ff53a, 0xade682d1, 0x510e527f, 0x2b3e6c1f, 0x9b05688c,
    0xfb41bd6b, 0x1f83d9ab, 0x137e2179, 0x5be0cd19
]);
var SIGMA8 = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13,
    6, 1, 12, 0, 2, 11, 7, 5, 3, 11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1,
    9, 4, 7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8, 9, 0, 5, 7, 2, 4,
    10, 15, 14, 1, 11, 12, 6, 8, 3, 13, 2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5,
    15, 14, 1, 9, 12, 5, 1, 15, 14, 13, 4, 10, 0, 7, 6, 3, 9, 2, 8, 11, 13, 11, 7,
    14, 12, 1, 3, 9, 5, 0, 15, 4, 8, 6, 2, 10, 6, 15, 14, 9, 11, 3, 0, 8, 12, 2,
    13, 7, 1, 4, 10, 5, 10, 2, 8, 4, 7, 6, 1, 5, 15, 11, 9, 14, 3, 12, 13, 0, 0,
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6,
    1, 12, 0, 2, 11, 7, 5, 3
];
// These are offsets into a uint64 buffer.
// Multiply them all by 2 to make them offsets into a uint32 buffer,
// because this is Javascript and we don't have uint64s
var SIGMA82 = new Uint8Array(SIGMA8.map(function (x) {
    return x * 2;
}));
// Compression function. 'last' flag indicates last block.
// Note we're representing 16 uint64s as 32 uint32s
var v = new Uint32Array(32);
var m = new Uint32Array(32);
function blake2bCompress(ctx, last) {
    var i = 0;
    // init work variables
    for (i = 0; i < 16; i++) {
        v[i] = ctx.h[i];
        v[i + 16] = BLAKE2B_IV32[i];
    }
    // low 64 bits of offset
    v[24] = v[24] ^ ctx.t;
    v[25] = v[25] ^ (ctx.t / 0x100000000);
    // high 64 bits not supported, offset may not be higher than 2**53-1
    // last block flag set ?
    if (last) {
        v[28] = ~v[28];
        v[29] = ~v[29];
    }
    // get little-endian words
    for (i = 0; i < 32; i++) {
        m[i] = B2B_GET32(ctx.b, 4 * i);
    }
    // twelve rounds of mixing
    // uncomment the DebugPrint calls to log the computation
    // and match the RFC sample documentation
    // util.debugPrint('          m[16]', m, 64)
    for (i = 0; i < 12; i++) {
        // util.debugPrint('   (i=' + (i < 10 ? ' ' : '') + i + ') v[16]', v, 64)
        B2B_G(0, 8, 16, 24, SIGMA82[i * 16 + 0], SIGMA82[i * 16 + 1]);
        B2B_G(2, 10, 18, 26, SIGMA82[i * 16 + 2], SIGMA82[i * 16 + 3]);
        B2B_G(4, 12, 20, 28, SIGMA82[i * 16 + 4], SIGMA82[i * 16 + 5]);
        B2B_G(6, 14, 22, 30, SIGMA82[i * 16 + 6], SIGMA82[i * 16 + 7]);
        B2B_G(0, 10, 20, 30, SIGMA82[i * 16 + 8], SIGMA82[i * 16 + 9]);
        B2B_G(2, 12, 22, 24, SIGMA82[i * 16 + 10], SIGMA82[i * 16 + 11]);
        B2B_G(4, 14, 16, 26, SIGMA82[i * 16 + 12], SIGMA82[i * 16 + 13]);
        B2B_G(6, 8, 18, 28, SIGMA82[i * 16 + 14], SIGMA82[i * 16 + 15]);
    }
    // util.debugPrint('   (i=12) v[16]', v, 64)
    for (i = 0; i < 16; i++) {
        ctx.h[i] = ctx.h[i] ^ v[i] ^ v[i + 16];
    }
    // util.debugPrint('h[8]', ctx.h, 64)
}
/** reusable parameterBlock */
var parameterBlock = new Uint8Array(64).fill(0);
function blake2bInit(digestSize) {
    // state, 'param block'
    var ctx = {
        b: new Uint8Array(128),
        h: new Uint32Array(16),
        t: 0,
        c: 0,
        digestSize: digestSize // output length in bytes
    };
    // initialize parameterBlock before usage
    parameterBlock.fill(0);
    parameterBlock[0] = digestSize;
    parameterBlock[2] = 1; // fanout
    parameterBlock[3] = 1; // depth
    // initialize hash state
    for (var i = 0; i < 16; i++) {
        ctx.h[i] = BLAKE2B_IV32[i] ^ B2B_GET32(parameterBlock, i * 4);
    }
    return ctx;
}
// Updates a BLAKE2b streaming hash
// Requires hash context and Uint8Array (byte array)
function blake2bUpdate(ctx, input) {
    for (var i = 0; i < input.length; i++) {
        if (ctx.c === 128) {
            // buffer full ?
            ctx.t += ctx.c; // add counters
            blake2bCompress(ctx, false); // compress (not last)
            ctx.c = 0; // counter to zero
        }
        ctx.b[ctx.c++] = input[i];
    }
}
// Completes a BLAKE2b streaming hash
// Returns a Uint8Array containing the message digest
function blake2bFinal(ctx) {
    ctx.t += ctx.c; // mark last block offset
    while (ctx.c < 128) {
        // fill up with zeros
        ctx.b[ctx.c++] = 0;
    }
    blake2bCompress(ctx, true); // final block flag = 1
    // little endian convert and store
    var out = new Uint8Array(ctx.digestSize);
    for (var i = 0; i < ctx.digestSize; i++) {
        out[i] = ctx.h[i >> 2] >> (8 * (i & 3));
    }
    return out;
}
function blake2b(data, digestSize) {
    if (digestSize === void 0) { digestSize = 32; }
    data = new Uint8Array(data);
    var ctx = blake2bInit(digestSize);
    blake2bUpdate(ctx, data);
    return blake2bFinal(ctx);
}
exports.blake2b = blake2b;
function blake2b_128(data) {
    return blake2b(data, 16);
}
exports.blake2b_128 = blake2b_128;
function blake2b_224(data) {
    return blake2b(data, 28);
}
exports.blake2b_224 = blake2b_224;
function blake2b_256(data) {
    return blake2b(data, 32);
}
exports.blake2b_256 = blake2b_256;
function blake2b_512(data) {
    return blake2b(data, 64);
}
exports.blake2b_512 = blake2b_512;


/***/ }),

/***/ 67932:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isFp6 = exports.isBlsResult = exports.bls12_381_finalVerify = exports.bls12_381_eqMlResult = exports.bls12_381_mulMlResult = exports.bls12_381_millerLoop = exports.bls12_381_G2_uncompress = exports.bls12_381_G2_compress = exports.bls12_381_G2_hashToGroup = exports.bls12_381_G2_equal = exports.bls12_381_G2_scalarMul = exports.bls12_381_G2_neg = exports.bls12_381_G2_add = exports.bls12_381_G1_uncompress = exports.bls12_381_G1_compress = exports.bls12_381_G1_hashToGroup = exports.bls12_381_G1_equal = exports.bls12_381_G1_scalarMul = exports.bls12_381_G1_neg = exports.bls12_381_G1_add = exports.isFp2 = exports.isBlsG2 = exports.isBlsG1 = exports.BlsG2 = exports.BlsG1 = void 0;
var noble_1 = __webpack_require__(3691);
var hash_to_curve_1 = __webpack_require__(41721);
var utils_1 = __webpack_require__(52993);
var sha256_1 = __webpack_require__(68748);
exports.BlsG1 = noble_1.bls12_381.G1.ProjectivePoint;
exports.BlsG2 = noble_1.bls12_381.G2.ProjectivePoint;
function isBlsG1(stuff) {
    return stuff instanceof exports.BlsG1 && (typeof stuff.px === "bigint" &&
        typeof stuff.py === "bigint" &&
        typeof stuff.pz === "bigint");
}
exports.isBlsG1 = isBlsG1;
function isBlsG2(stuff) {
    return stuff instanceof exports.BlsG2 && (isFp2(stuff.px) &&
        isFp2(stuff.py) &&
        isFp2(stuff.pz));
}
exports.isBlsG2 = isBlsG2;
function isFp2(stuff) {
    return typeof stuff === "object" && (stuff !== null && !Array.isArray(stuff) &&
        typeof stuff.c0 === "bigint" &&
        typeof stuff.c1 === "bigint");
}
exports.isFp2 = isFp2;
var curveOrder = BigInt("52435875175126190479447740508185965837690552500527637822603658699938581184513");
var htfDefaults = Object.freeze({
    // DST: a domain separation tag
    // defined in section 2.2.5
    // Use utils.getDSTLabel(), utils.setDSTLabel(value)
    DST: "",
    encodeDST: "",
    // p: the characteristic of F
    //    where F is a finite field of characteristic p and order q = p^m
    p: noble_1.Fp.ORDER,
    // m: the extension degree of F, m >= 1
    //     where F is a finite field of characteristic p and order q = p^m
    m: 2,
    // k: the target security level for the suite in bits
    // defined in section 5.1
    k: 128,
    // option to use a message that has already been processed by
    // expand_message_xmd
    expand: 'xmd',
    // Hash functions for: expand_message_xmd is appropriate for use with a
    // wide range of hash functions, including SHA-2, SHA-3, BLAKE2, and others.
    // BBS+ uses blake2: https://github.com/hyperledger/aries-framework-go/issues/2247
    hash: sha256_1.sha256,
});
var G2_Hasher = (0, hash_to_curve_1.createHasher)(exports.BlsG2, noble_1.G2_mapToCurve, __assign({}, htfDefaults));
var G1_Hasher = (0, hash_to_curve_1.createHasher)(exports.BlsG1, noble_1.G1_mapToCurve, __assign(__assign({}, htfDefaults), { m: 1, DST: 'BLS_SIG_BLS12381G1_XMD:SHA-256_SSWU_RO_NUL_' }));
function bls12_381_G1_add(a, b) {
    // if( bls12_381_G1_equal( a, BlsG1.ZERO ) ) return b;
    // if( bls12_381_G1_equal( b, BlsG1.ZERO ) ) return a;
    return a.add(b);
}
exports.bls12_381_G1_add = bls12_381_G1_add;
function bls12_381_G1_neg(elem) {
    return elem.negate();
}
exports.bls12_381_G1_neg = bls12_381_G1_neg;
function bls12_381_G1_scalarMul(n, g1) {
    if (n < 0)
        return bls12_381_G1_scalarMul(-n, bls12_381_G1_neg(g1));
    n = BigInt(n);
    if (n >= curveOrder)
        n = n % curveOrder;
    if (n === BigInt(0))
        return exports.BlsG1.ZERO;
    return g1.multiply(n);
}
exports.bls12_381_G1_scalarMul = bls12_381_G1_scalarMul;
function bls12_381_G1_equal(a, b) {
    return a.equals(b);
}
exports.bls12_381_G1_equal = bls12_381_G1_equal;
function bls12_381_G1_hashToGroup(a, b) {
    // noble-curves can handle that but the plutus-machine doesn't
    // so we artificially throw an error here
    if (b.length > 255)
        throw new Error("DST length can not be greater than 255");
    return exports.BlsG1.fromAffine(G1_Hasher.hashToCurve(a, { DST: b })
        .toAffine());
}
exports.bls12_381_G1_hashToGroup = bls12_381_G1_hashToGroup;
function bls12_381_G1_compress(elem) {
    return elem.toRawBytes();
}
exports.bls12_381_G1_compress = bls12_381_G1_compress;
function bls12_381_G1_uncompress(compressed) {
    var _a = (0, noble_1.parseMask)(compressed), compressed_bit = _a.compressed, infinity = _a.infinity, sort = _a.sort, value = _a.value;
    // point zero edge case
    if (compressed_bit &&
        infinity &&
        sort &&
        value.every(function (n) { return n === 0; }))
        throw new Error("sign bit set on pont ZERO, we don't like it");
    // not compressed bytes would be totally fine for the library but we artificially fail here
    // https://github.com/IntersectMBO/plutus/blob/master/plutus-conformance/test-cases/uplc/evaluation/builtin/semantics/bls12_381_G1_uncompress/on-curve-serialised-not-compressed/on-curve-serialised-not-compressed.uplc
    if (!compressed_bit)
        throw new Error("uncompress only works with compressed byets");
    return exports.BlsG1.fromHex(compressed);
}
exports.bls12_381_G1_uncompress = bls12_381_G1_uncompress;
function bls12_381_G2_add(a, b) {
    // if( bls12_381_G2_equal( a, BlsG2.ZERO ) ) return b;
    // if( bls12_381_G2_equal( b, BlsG2.ZERO ) ) return a;
    return a.add(b);
}
exports.bls12_381_G2_add = bls12_381_G2_add;
function bls12_381_G2_neg(elem) {
    return elem.negate();
}
exports.bls12_381_G2_neg = bls12_381_G2_neg;
function bls12_381_G2_scalarMul(n, g2) {
    if (n < 0)
        return bls12_381_G2_scalarMul(-n, bls12_381_G2_neg(g2));
    n = BigInt(n);
    if (n >= curveOrder)
        n = n % curveOrder;
    if (n === BigInt(0))
        return exports.BlsG2.ZERO;
    return g2.multiply(BigInt(n));
}
exports.bls12_381_G2_scalarMul = bls12_381_G2_scalarMul;
function bls12_381_G2_equal(a, b) {
    return a.equals(b);
}
exports.bls12_381_G2_equal = bls12_381_G2_equal;
function bls12_381_G2_hashToGroup(a, b) {
    // noble-curves can handle that but the plutus-machine doesn't
    // so we artificially throw an error here
    if (b.length > 255)
        throw new Error("DST length can not be greater than 255");
    return exports.BlsG2.fromAffine(G2_Hasher.hashToCurve(a, { DST: b })
        .toAffine());
}
exports.bls12_381_G2_hashToGroup = bls12_381_G2_hashToGroup;
function bls12_381_G2_compress(elem) {
    return elem.toRawBytes();
}
exports.bls12_381_G2_compress = bls12_381_G2_compress;
function bls12_381_G2_uncompress(compressed) {
    var compressed_bit = (0, noble_1.parseMask)(compressed).compressed;
    // not compressed bytes would be totally fine for the library but we artificially fail here
    // https://github.com/IntersectMBO/plutus/blob/master/plutus-conformance/test-cases/uplc/evaluation/builtin/semantics/bls12_381_G2_uncompress/on-curve-serialised-not-compressed/on-curve-serialised-not-compressed.uplc
    if (!compressed_bit)
        throw new Error("uncompress only works with compressed byets");
    return exports.BlsG2.fromHex(compressed);
}
exports.bls12_381_G2_uncompress = bls12_381_G2_uncompress;
function bls12_381_millerLoop(g1, g2) {
    var _a = g1.toAffine(), x = _a.x, y = _a.y;
    return millerLoop(pairingPrecomputes(g2), [x, y]);
}
exports.bls12_381_millerLoop = bls12_381_millerLoop;
function bls12_381_mulMlResult(a, b) {
    return (0, noble_1.Fp12Multiply)(a, b);
}
exports.bls12_381_mulMlResult = bls12_381_mulMlResult;
exports.bls12_381_eqMlResult = noble_1.Fp12_eql;
function bls12_381_finalVerify(a, b) {
    // blst implementation https://github.com/supranational/blst/blob/0d46eefa45fc1e57aceb42bba0e84eab3a7a9725/src/aggregate.c#L506
    var GT = (0, noble_1.Fp12_conjugate)(a);
    GT = (0, noble_1.Fp12Multiply)(GT, b);
    GT = (0, noble_1.Fp12_finalExponentiate)(GT);
    return (0, noble_1.Fp12_eql)(GT, noble_1.Fp12_ONE);
}
exports.bls12_381_finalVerify = bls12_381_finalVerify;
// The BLS parameter x for BLS12-381
var BLS_X = BigInt('0xd201000000010000');
var BLS_X_LEN = (0, utils_1.bitLen)(BLS_X);
var _2n = BigInt(2), _3n = BigInt(3);
// Pre-compute coefficients for sparse multiplication
// Point addition and point double calculations is reused for coefficients
function calcPairingPrecomputes(p) {
    var x = p.x, y = p.y;
    // prettier-ignore
    var Qx = x, Qy = y, Qz = noble_1.Fp2.ONE;
    // prettier-ignore
    var Rx = Qx, Ry = Qy, Rz = Qz;
    var ell_coeff = [];
    for (var i = BLS_X_LEN - 2; i >= 0; i--) {
        // Double
        var t0 = noble_1.Fp2.sqr(Ry); // Ry²
        var t1 = noble_1.Fp2.sqr(Rz); // Rz²
        var t2 = noble_1.Fp2.multiplyByB(noble_1.Fp2.mul(t1, _3n)); // 3 * T1 * B
        var t3 = noble_1.Fp2.mul(t2, _3n); // 3 * T2
        var t4 = noble_1.Fp2.sub(noble_1.Fp2.sub(noble_1.Fp2.sqr(noble_1.Fp2.add(Ry, Rz)), t1), t0); // (Ry + Rz)² - T1 - T0
        ell_coeff.push([
            noble_1.Fp2.sub(t2, t0),
            noble_1.Fp2.mul(noble_1.Fp2.sqr(Rx), _3n),
            noble_1.Fp2.neg(t4), // -T4
        ]);
        Rx = noble_1.Fp2.div(noble_1.Fp2.mul(noble_1.Fp2.mul(noble_1.Fp2.sub(t0, t3), Rx), Ry), _2n); // ((T0 - T3) * Rx * Ry) / 2
        Ry = noble_1.Fp2.sub(noble_1.Fp2.sqr(noble_1.Fp2.div(noble_1.Fp2.add(t0, t3), _2n)), noble_1.Fp2.mul(noble_1.Fp2.sqr(t2), _3n)); // ((T0 + T3) / 2)² - 3 * T2²
        Rz = noble_1.Fp2.mul(t0, t4); // T0 * T4
        if ((0, utils_1.bitGet)(BLS_X /*CURVE.params.x*/, i)) {
            // Addition
            var t0_1 = noble_1.Fp2.sub(Ry, noble_1.Fp2.mul(Qy, Rz)); // Ry - Qy * Rz
            var t1_1 = noble_1.Fp2.sub(Rx, noble_1.Fp2.mul(Qx, Rz)); // Rx - Qx * Rz
            ell_coeff.push([
                noble_1.Fp2.sub(noble_1.Fp2.mul(t0_1, Qx), noble_1.Fp2.mul(t1_1, Qy)),
                noble_1.Fp2.neg(t0_1),
                t1_1, // T1
            ]);
            var t2_1 = noble_1.Fp2.sqr(t1_1); // T1²
            var t3_1 = noble_1.Fp2.mul(t2_1, t1_1); // T2 * T1
            var t4_1 = noble_1.Fp2.mul(t2_1, Rx); // T2 * Rx
            var t5 = noble_1.Fp2.add(noble_1.Fp2.sub(t3_1, noble_1.Fp2.mul(t4_1, _2n)), noble_1.Fp2.mul(noble_1.Fp2.sqr(t0_1), Rz)); // T3 - 2 * T4 + T0² * Rz
            Rx = noble_1.Fp2.mul(t1_1, t5); // T1 * T5
            Ry = noble_1.Fp2.sub(noble_1.Fp2.mul(noble_1.Fp2.sub(t4_1, t5), t0_1), noble_1.Fp2.mul(t3_1, Ry)); // (T4 - T5) * T0 - T3 * Ry
            Rz = noble_1.Fp2.mul(Rz, t3_1); // Rz * T3
        }
    }
    return ell_coeff;
}
function pairingPrecomputes(point) {
    var p = point;
    if (p._PPRECOMPUTES)
        return p._PPRECOMPUTES;
    p._PPRECOMPUTES = calcPairingPrecomputes(point.toAffine());
    return p._PPRECOMPUTES;
}
function millerLoop(ell, g1) {
    var x = BLS_X;
    var Px = g1[0];
    var Py = g1[1];
    var f12 = noble_1.Fp12.ONE;
    for (var j = 0, i = BLS_X_LEN - 2; i >= 0; i--, j++) {
        var E = ell[j];
        f12 = noble_1.Fp12.multiplyBy014(f12, E[0], noble_1.Fp2.mul(E[1], Px), noble_1.Fp2.mul(E[2], Py));
        if ((0, utils_1.bitGet)(x, i)) {
            j += 1;
            var F = ell[j];
            f12 = noble_1.Fp12.multiplyBy014(f12, F[0], noble_1.Fp2.mul(F[1], Px), noble_1.Fp2.mul(F[2], Py));
        }
        if (i !== 0)
            f12 = noble_1.Fp12.sqr(f12);
    }
    return noble_1.Fp12.conjugate(f12);
}
function isBlsResult(stuff) {
    return typeof stuff === "object" && (stuff !== null && !Array.isArray(stuff) &&
        isFp6(stuff.c0) &&
        isFp6(stuff.c1));
}
exports.isBlsResult = isBlsResult;
function isFp6(stuff) {
    return typeof stuff === "object" && (stuff !== null && !Array.isArray(stuff) &&
        isFp2(stuff.c0) &&
        isFp2(stuff.c1) &&
        isFp2(stuff.c2));
}
exports.isFp6 = isFp6;


/***/ }),

/***/ 58754:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ed25519bigint = exports.verifyEd25519Signature = exports.getEd25519Signature = exports.signExtendedEd25519 = exports.signEd25519 = exports.extendedToPublic = exports.deriveEd25519PublicKey = exports.extendEd25519PrivateKey = exports.scalarMultBase = exports.scalarFromBytes = exports.pointFromBytes = exports.bigpointToUint8Array = exports.encodeInt = exports.scalarMul = exports.addPointsEdwards = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var sha2_512_1 = __webpack_require__(45802);
var types_1 = __webpack_require__(62339);
var positiveMod_1 = __webpack_require__(73626);
var assert_1 = __webpack_require__(24055);
var bigintToBuffer_1 = __webpack_require__(51679);
var Q = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"); // ipowi(255) - 19
var Q38 = BigInt("7237005577332262213973186563042994240829374041602535252466099000494570602494"); // (Q + 3)/8
var CURVE_ORDER = BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"); // ipow2(252) + 27742317777372353535851937790883648493;
var D = -BigInt("4513249062541557337682894930092624173785641285191125241628941591882900924598840740"); // -121665 * invert(121666);
var I = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752"); // expMod(BigInt( 2 ), (Q - BigInt( 1 ))/4, Q);
var BASE = Object.freeze([
    BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
    BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960") // (4*invert(5)) % Q
]);
/**
 *
 * @param {bigint} b
 * @param {bigint} e
 * @param {bigint} m
 * @returns {bigint}
 */
function expMod(b, e, m) {
    if (e == BigInt(0)) {
        return BigInt(1);
    }
    else {
        var t = expMod(b, e / BigInt(2), m);
        t = (t * t) % m;
        if ((e % BigInt(2)) != BigInt(0)) {
            t = (0, positiveMod_1.positiveMod)(t * b, m);
        }
        return t;
    }
}
function invert(n) {
    var a = (0, positiveMod_1.positiveMod)(n, Q);
    var b = Q;
    var x = BigInt(0);
    var y = BigInt(1);
    var u = BigInt(1);
    var v = BigInt(0);
    while (a !== BigInt(0)) {
        var q = b / a;
        var r = b % a;
        var m = x - u * q;
        var n_1 = y - v * q;
        b = a;
        a = r;
        x = u;
        y = v;
        u = m;
        v = n_1;
    }
    return (0, positiveMod_1.positiveMod)(x, Q);
}
/**
 * @param {bigint} y
 * @returns {bigint}
 */
function recoverX(y) {
    var yy = y * y;
    var xx = (yy - BigInt(1)) * invert(D * yy + BigInt(1));
    var x = expMod(xx, Q38, Q);
    if (((x * x - xx) % Q) !== BigInt(0)) {
        x = (x * I) % Q;
    }
    if ((x % BigInt(2)) !== BigInt(0)) {
        x = Q - x;
    }
    return x;
}
/**
 * Curve point 'addition'
 * Note: this is probably the bottleneck of this Ed25519 implementation
 */
function addPointsEdwards(a, b) {
    var x1 = a[0];
    var y1 = a[1];
    var x2 = b[0];
    var y2 = b[1];
    var dxxyy = D * x1 * x2 * y1 * y2;
    var x3 = (x1 * y2 + x2 * y1) * invert(BigInt(1) + dxxyy);
    var y3 = (y1 * y2 + x1 * x2) * invert(BigInt(1) - dxxyy);
    return [(0, positiveMod_1.positiveMod)(x3, Q), (0, positiveMod_1.positiveMod)(y3, Q)];
}
exports.addPointsEdwards = addPointsEdwards;
function scalarMul(point, n) {
    if (n === BigInt(0)) {
        return [BigInt(0), BigInt(1)];
    }
    else {
        var sum = scalarMul(point, n / BigInt(2));
        sum = addPointsEdwards(sum, sum);
        if ((n % BigInt(2)) !== BigInt(0)) {
            sum = addPointsEdwards(sum, point);
        }
        return sum;
    }
}
exports.scalarMul = scalarMul;
/**
 * Curve point 'multiplication'
 */
function encodeInt(y) {
    var bytes = Array.from((0, bigintToBuffer_1.bigintToBuffer)(y)).reverse();
    while (bytes.length < 32) {
        bytes.push(0);
    }
    return bytes;
}
exports.encodeInt = encodeInt;
function decodeInt(s) {
    return BigInt("0x" + (0, types_1.byteArrToHex)(s.reverse()));
}
function bigpointToByteArray(point) {
    var _a = __read(point, 2), x = _a[0], y = _a[1];
    var bytes = encodeInt(y);
    // last bit is determined by x
    bytes[31] = ((bytes[31] & 255) | (Number(x & BigInt(1)) * 128));
    return bytes;
}
function bigpointToUint8Array(point) {
    return new Uint8Array(bigpointToByteArray(point));
}
exports.bigpointToUint8Array = bigpointToUint8Array;
function getBit(bytes, i) {
    return ((bytes[Math.floor(i / 8)] >> i % 8) & 1);
}
function isOnCurve(point) {
    var x = point[0];
    var y = point[1];
    var xx = x * x;
    var yy = y * y;
    return (-xx + yy - BigInt(1) - D * xx * yy) % Q == BigInt(0);
}
function pointFromBytes(s) {
    if (s instanceof Uint8Array)
        s = asBytes(s);
    (0, assert_1.assert)(s.length == 32, "point must have length of 32");
    var bytes = s.slice();
    bytes[31] = (bytes[31] & 127);
    var y = decodeInt(bytes);
    var x = recoverX(y);
    if (Number(x & BigInt(1)) != getBit(s, 255)) {
        x = Q - x;
    }
    var point = [x, y];
    if (!isOnCurve(point)) {
        throw new Error("point isn't on curve");
    }
    return point;
}
exports.pointFromBytes = pointFromBytes;
var ipow2_253 = BigInt("28948022309329048855892746252171976963317496166410141009864396001978282409984"); // ipow2(253)
function scalarFromBytes(h) {
    var bytes = h.slice(0, 32);
    bytes[0] = (bytes[0] & 248);
    bytes[31] = (bytes[31] & 63);
    return ipow2_253 + BigInt("0x" + (0, types_1.byteArrToHex)(bytes.reverse()));
}
exports.scalarFromBytes = scalarFromBytes;
function ihash(m) {
    return decodeInt((0, sha2_512_1.sha2_512)(m));
}
function forceUint8Array(stuff) {
    if (typeof stuff === "string")
        return (0, uint8array_utils_1.fromHex)(stuff);
    return (0, uint8array_utils_1.isUint8Array)(stuff) ? stuff : new Uint8Array(stuff);
}
function scalarMultBase(scalar) {
    return scalarMul(BASE, scalar);
}
exports.scalarMultBase = scalarMultBase;
function extendEd25519PrivateKey(privateKey) {
    var extended = (0, sha2_512_1.sha2_512)(privateKey);
    var extension = extended.slice(32, 64);
    var a = scalarFromBytes(extended.slice(0, 32));
    return [a, extension];
}
exports.extendEd25519PrivateKey = extendEd25519PrivateKey;
function deriveEd25519PublicKey(privateKey) {
    var extended = (0, sha2_512_1.sha2_512)(privateKey);
    var a = scalarFromBytes(extended);
    var A = scalarMul(BASE, a);
    return bigpointToByteArray(A);
}
exports.deriveEd25519PublicKey = deriveEd25519PublicKey;
function extendedToPublic(extended) {
    if (extended instanceof Uint8Array)
        extended = Array.from(extended);
    var a = scalarFromBytes(extended);
    var A = scalarMul(BASE, a);
    return new Uint8Array(bigpointToByteArray(A));
}
exports.extendedToPublic = extendedToPublic;
function asBytes(stuff) {
    if (typeof stuff === "string")
        return asBytes((0, uint8array_utils_1.fromHex)(stuff));
    return Array.from(stuff);
}
function signEd25519(message, privateKey) {
    message = forceUint8Array(message);
    privateKey = forceUint8Array(privateKey);
    return signExtendedEd25519(message, (0, sha2_512_1.sha2_512)(asBytes(privateKey)));
}
exports.signEd25519 = signEd25519;
function signExtendedEd25519(message, extendedKey) {
    var _a;
    message = forceUint8Array(message);
    extendedKey = forceUint8Array(extendedKey);
    if (extendedKey.length !== 64)
        throw new Error('signExtendedEd25519:: extended key must have length 64');
    var privateKeyHash = asBytes(extendedKey);
    var a = scalarFromBytes(privateKeyHash);
    // for convenience getulate publicKey here:
    var publicKey = bigpointToByteArray(scalarMul(BASE, a));
    var r = ihash(privateKeyHash.slice(32, 64).concat(asBytes(message)));
    var R = scalarMul(BASE, r);
    var S = (0, positiveMod_1.positiveMod)(r + ihash(bigpointToByteArray(R).concat(publicKey).concat(asBytes(message))) * a, CURVE_ORDER);
    var pubKey = new Uint8Array(publicKey);
    var signature = new Uint8Array(bigpointToByteArray(R).concat(encodeInt(S)));
    return _a = {
            0: pubKey,
            1: signature,
            length: 2
        },
        _a[Symbol.iterator] = function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, pubKey];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, signature];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        },
        _a.pubKey = pubKey,
        _a.signature = signature,
        _a;
}
exports.signExtendedEd25519 = signExtendedEd25519;
function getEd25519Signature(message, privateKey) {
    return signEd25519(message, privateKey).signature;
}
exports.getEd25519Signature = getEd25519Signature;
function verifyEd25519Signature(signature, message, publicKey) {
    if (signature.length !== 64 || publicKey.length != 32) {
        throw new Error("unexpected signature length ".concat(signature.length));
    }
    if ((0, uint8array_utils_1.isUint8Array)(signature)) {
        signature = (0, types_1.buffToByteArr)(signature);
    }
    if ((0, uint8array_utils_1.isUint8Array)(message)) {
        message = (0, types_1.buffToByteArr)(message);
    }
    if ((0, uint8array_utils_1.isUint8Array)(publicKey)) {
        publicKey = (0, types_1.buffToByteArr)(publicKey);
    }
    var R = pointFromBytes(asBytes(signature).slice(0, 32));
    var A = pointFromBytes(asBytes(publicKey));
    var S = decodeInt(asBytes(signature).slice(32, 64));
    var h = ihash(asBytes(signature).slice(0, 32).concat(asBytes(publicKey)).concat(asBytes(message)));
    var left = scalarMul(BASE, S);
    var right = addPointsEdwards(R, scalarMul(A, h));
    return (left[0] == right[0]) && (left[1] == right[1]);
}
exports.verifyEd25519Signature = verifyEd25519Signature;
var _0n = BigInt(0);
var ED25519_ORDER = BigInt('57896044618658097711785492504343953926634992332820282019728792003956564819949');
function mod(a, b) {
    var result = a % b;
    return result >= _0n ? result : b + result;
}
function ed25519bigint(n) {
    return mod(n, ED25519_ORDER);
}
exports.ed25519bigint = ed25519bigint;


/***/ }),

/***/ 9624:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hmacSHA512 = void 0;
var hmac_1 = __webpack_require__(8419);
var sha512_1 = __webpack_require__(3944);
function hmacSHA512(key, data) {
    return new Uint8Array((0, hmac_1.hmac)(sha512_1.sha512, key, data));
}
exports.hmacSHA512 = hmacSHA512;


/***/ }),

/***/ 53450:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(55638), exports);
__exportStar(__webpack_require__(76427), exports);
__exportStar(__webpack_require__(67932), exports);
__exportStar(__webpack_require__(58754), exports);
__exportStar(__webpack_require__(9624), exports);
__exportStar(__webpack_require__(58245), exports);
__exportStar(__webpack_require__(67426), exports);
__exportStar(__webpack_require__(59777), exports);
__exportStar(__webpack_require__(45802), exports);
__exportStar(__webpack_require__(20130), exports);
__exportStar(__webpack_require__(62339), exports);
__exportStar(__webpack_require__(63390), exports);
__exportStar(__webpack_require__(22431), exports);
__exportStar(__webpack_require__(8891), exports);


/***/ }),

/***/ 58245:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.keccak_512 = exports.keccak_384 = exports.keccak_224 = exports.keccak_256 = void 0;
var noble = __importStar(__webpack_require__(8879));
function keccak_256(msg) {
    return noble.keccak_256(msg);
}
exports.keccak_256 = keccak_256;
function keccak_224(msg) {
    return noble.keccak_224(msg);
}
exports.keccak_224 = keccak_224;
function keccak_384(msg) {
    return noble.keccak_384(msg);
}
exports.keccak_384 = keccak_384;
function keccak_512(msg) {
    return noble.keccak_512(msg);
}
exports.keccak_512 = keccak_512;


/***/ }),

/***/ 48117:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.output = exports.exists = exports.hash = exports.bytes = exports.bool = exports.number = exports.isBytes = void 0;
function number(n) {
    if (!Number.isSafeInteger(n) || n < 0)
        throw new Error("positive integer expected, not ".concat(n));
}
exports.number = number;
function bool(b) {
    if (typeof b !== 'boolean')
        throw new Error("boolean expected, not ".concat(b));
}
exports.bool = bool;
// copied from utils
function isBytes(a) {
    return (a instanceof Uint8Array ||
        (a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array'));
}
exports.isBytes = isBytes;
function bytes(b) {
    var lengths = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        lengths[_i - 1] = arguments[_i];
    }
    if (!isBytes(b))
        throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length))
        throw new Error("Uint8Array expected of length ".concat(lengths, ", not of length=").concat(b.length));
}
exports.bytes = bytes;
function hash(hash) {
    if (typeof hash !== 'function' || typeof hash.create !== 'function')
        throw new Error('Hash should be wrapped by utils.wrapConstructor');
    number(hash.outputLen);
    number(hash.blockLen);
}
exports.hash = hash;
function exists(instance, checkFinished) {
    if (checkFinished === void 0) { checkFinished = true; }
    if (instance.destroyed)
        throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished)
        throw new Error('Hash#digest() has already been called');
}
exports.exists = exists;
function output(out, instance) {
    bytes(out);
    var min = instance.outputLen;
    if (out.length < min) {
        throw new Error("digestInto() expects output buffer of length at least ".concat(min));
    }
}
exports.output = output;
var assert = { number: number, bool: bool, bytes: bytes, hash: hash, exists: exists, output: output };
exports["default"] = assert;


/***/ }),

/***/ 7946:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HashMD = exports.Maj = exports.Chi = void 0;
var _assert_1 = __webpack_require__(48117);
var utils_1 = __webpack_require__(88627);
// Polyfill for Safari 14
function setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function')
        return view.setBigUint64(byteOffset, value, isLE);
    var _32n = BigInt(32);
    var _u32_max = BigInt(0xffffffff);
    var wh = Number((value >> _32n) & _u32_max);
    var wl = Number(value & _u32_max);
    var h = isLE ? 4 : 0;
    var l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Choice: a ? b : c
var Chi = function (a, b, c) { return (a & b) ^ (~a & c); };
exports.Chi = Chi;
// Majority function, true if any two inpust is true
var Maj = function (a, b, c) { return (a & b) ^ (a & c) ^ (b & c); };
exports.Maj = Maj;
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */
var HashMD = /** @class */ (function (_super) {
    __extends(HashMD, _super);
    function HashMD(blockLen, outputLen, padOffset, isLE) {
        var _this = _super.call(this) || this;
        _this.blockLen = blockLen;
        _this.outputLen = outputLen;
        _this.padOffset = padOffset;
        _this.isLE = isLE;
        _this.finished = false;
        _this.length = 0;
        _this.pos = 0;
        _this.destroyed = false;
        _this.buffer = new Uint8Array(blockLen);
        _this.view = (0, utils_1.createView)(_this.buffer);
        return _this;
    }
    HashMD.prototype.update = function (data) {
        (0, _assert_1.exists)(this);
        var _a = this, view = _a.view, buffer = _a.buffer, blockLen = _a.blockLen;
        data = (0, utils_1.toBytes)(data);
        var len = data.length;
        for (var pos = 0; pos < len;) {
            var take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                var dataView = (0, utils_1.createView)(data);
                for (; blockLen <= len - pos; pos += blockLen)
                    this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    };
    HashMD.prototype.digestInto = function (out) {
        (0, _assert_1.exists)(this);
        (0, _assert_1.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        var _a = this, buffer = _a.buffer, view = _a.view, blockLen = _a.blockLen, isLE = _a.isLE;
        var pos = this.pos;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for (var i = pos; i < blockLen; i++)
            buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        var oview = (0, utils_1.createView)(out);
        var len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4)
            throw new Error('_sha2: outputLen should be aligned to 32bit');
        var outLen = len / 4;
        var state = this.get();
        if (outLen > state.length)
            throw new Error('_sha2: outputLen bigger than state');
        for (var i = 0; i < outLen; i++)
            oview.setUint32(4 * i, state[i], isLE);
    };
    HashMD.prototype.digest = function () {
        var _a = this, buffer = _a.buffer, outputLen = _a.outputLen;
        this.digestInto(buffer);
        var res = Uint8Array.prototype.slice.call(buffer, 0, outputLen);
        this.destroy();
        return res;
    };
    HashMD.prototype._cloneInto = function (to) {
        to || (to = new this.constructor());
        to.set.apply(to, __spreadArray([], __read(this.get()), false));
        var _a = this, blockLen = _a.blockLen, buffer = _a.buffer, length = _a.length, finished = _a.finished, destroyed = _a.destroyed, pos = _a.pos;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen)
            to.buffer.set(buffer);
        return to;
    };
    return HashMD;
}(utils_1.Hash));
exports.HashMD = HashMD;


/***/ }),

/***/ 18523:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createCurve = exports.getHash = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
var hmac_1 = __webpack_require__(8419);
var utils_1 = __webpack_require__(88627);
var weierstrass_1 = __webpack_require__(31637);
// connects noble-curves to noble-hashes
function getHash(hash) {
    return {
        hash: hash,
        hmac: function (key) {
            var msgs = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                msgs[_i - 1] = arguments[_i];
            }
            return (0, hmac_1.hmac)(hash, key, utils_1.concatBytes.apply(void 0, __spreadArray([], __read(msgs), false)));
        },
        randomBytes: utils_1.randomBytes,
    };
}
exports.getHash = getHash;
function createCurve(curveDef, defHash) {
    var create = function (hash) { return (0, weierstrass_1.weierstrass)(__assign(__assign({}, curveDef), getHash(hash))); };
    return Object.freeze(__assign(__assign({}, create(defHash)), { create: create }));
}
exports.createCurve = createCurve;


/***/ }),

/***/ 20204:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.add5H = exports.add5L = exports.add4H = exports.add4L = exports.add3H = exports.add3L = exports.add = exports.rotlBL = exports.rotlBH = exports.rotlSL = exports.rotlSH = exports.rotr32L = exports.rotr32H = exports.rotrBL = exports.rotrBH = exports.rotrSL = exports.rotrSH = exports.shrSL = exports.shrSH = exports.toBig = exports.split = exports.fromBig = void 0;
/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-hashes/blob/6ae82e75d4c354d53a488e95b1bfe9cba90bd6ff/src/_u64.ts#L1

it was modified and adapted to this repository to re-use already defined stuff

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var U32_MASK64 = /* @__PURE__ */ BigInt(Math.pow(2, 32) - 1);
var _32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function fromBig(n, le) {
    if (le === void 0) { le = false; }
    if (le)
        return { h: Number(n & U32_MASK64), l: Number((n >> _32n) & U32_MASK64) };
    return { h: Number((n >> _32n) & U32_MASK64) | 0, l: Number(n & U32_MASK64) | 0 };
}
exports.fromBig = fromBig;
function split(lst, le) {
    var _a;
    if (le === void 0) { le = false; }
    var Ah = new Uint32Array(lst.length);
    var Al = new Uint32Array(lst.length);
    for (var i = 0; i < lst.length; i++) {
        var _b = fromBig(lst[i], le), h = _b.h, l = _b.l;
        _a = __read([h, l], 2), Ah[i] = _a[0], Al[i] = _a[1];
    }
    return [Ah, Al];
}
exports.split = split;
var toBig = function (h, l) { return (BigInt(h >>> 0) << _32n) | BigInt(l >>> 0); };
exports.toBig = toBig;
// for Shift in [0, 32)
var shrSH = function (h, _l, s) { return h >>> s; };
exports.shrSH = shrSH;
var shrSL = function (h, l, s) { return (h << (32 - s)) | (l >>> s); };
exports.shrSL = shrSL;
// Right rotate for Shift in [1, 32)
var rotrSH = function (h, l, s) { return (h >>> s) | (l << (32 - s)); };
exports.rotrSH = rotrSH;
var rotrSL = function (h, l, s) { return (h << (32 - s)) | (l >>> s); };
exports.rotrSL = rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
var rotrBH = function (h, l, s) { return (h << (64 - s)) | (l >>> (s - 32)); };
exports.rotrBH = rotrBH;
var rotrBL = function (h, l, s) { return (h >>> (s - 32)) | (l << (64 - s)); };
exports.rotrBL = rotrBL;
// Right rotate for shift===32 (just swaps l&h)
var rotr32H = function (_h, l) { return l; };
exports.rotr32H = rotr32H;
var rotr32L = function (h, _l) { return h; };
exports.rotr32L = rotr32L;
// Left rotate for Shift in [1, 32)
var rotlSH = function (h, l, s) { return (h << s) | (l >>> (32 - s)); };
exports.rotlSH = rotlSH;
var rotlSL = function (h, l, s) { return (l << s) | (h >>> (32 - s)); };
exports.rotlSL = rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
var rotlBH = function (h, l, s) { return (l << (s - 32)) | (h >>> (64 - s)); };
exports.rotlBH = rotlBH;
var rotlBL = function (h, l, s) { return (h << (s - 32)) | (l >>> (64 - s)); };
exports.rotlBL = rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function add(Ah, Al, Bh, Bl) {
    var l = (Al >>> 0) + (Bl >>> 0);
    return { h: (Ah + Bh + ((l / Math.pow(2, 32)) | 0)) | 0, l: l | 0 };
}
exports.add = add;
// Addition with more than 2 elements
var add3L = function (Al, Bl, Cl) { return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0); };
exports.add3L = add3L;
var add3H = function (low, Ah, Bh, Ch) {
    return (Ah + Bh + Ch + ((low / Math.pow(2, 32)) | 0)) | 0;
};
exports.add3H = add3H;
var add4L = function (Al, Bl, Cl, Dl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
};
exports.add4L = add4L;
var add4H = function (low, Ah, Bh, Ch, Dh) {
    return (Ah + Bh + Ch + Dh + ((low / Math.pow(2, 32)) | 0)) | 0;
};
exports.add4H = add4H;
var add5L = function (Al, Bl, Cl, Dl, El) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
};
exports.add5L = add5L;
var add5H = function (low, Ah, Bh, Ch, Dh, Eh) {
    return (Ah + Bh + Ch + Dh + Eh + ((low / Math.pow(2, 32)) | 0)) | 0;
};
exports.add5H = add5H;


/***/ }),

/***/ 98033:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/abstract/bls.ts#

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bls = void 0;
var modular_1 = __webpack_require__(83827);
var utils_1 = __webpack_require__(52993);
// prettier-ignore
var hash_to_curve_1 = __webpack_require__(41721);
var weierstrass_1 = __webpack_require__(31637);
// prettier-ignore
var _2n = BigInt(2), _3n = BigInt(3);
function bls(CURVE) {
    // Fields are specific for curve, so for now we'll need to pass them with opts
    var _a = CURVE.fields, Fp = _a.Fp, Fr = _a.Fr, Fp2 = _a.Fp2, Fp6 = _a.Fp6, Fp12 = _a.Fp12;
    var BLS_X_LEN = (0, utils_1.bitLen)(CURVE.params.x);
    // Pre-compute coefficients for sparse multiplication
    // Point addition and point double calculations is reused for coefficients
    function calcPairingPrecomputes(p) {
        var x = p.x, y = p.y;
        // prettier-ignore
        var Qx = x, Qy = y, Qz = Fp2.ONE;
        // prettier-ignore
        var Rx = Qx, Ry = Qy, Rz = Qz;
        var ell_coeff = [];
        for (var i = BLS_X_LEN - 2; i >= 0; i--) {
            // Double
            var t0 = Fp2.sqr(Ry); // Ry²
            var t1 = Fp2.sqr(Rz); // Rz²
            var t2 = Fp2.multiplyByB(Fp2.mul(t1, _3n)); // 3 * T1 * B
            var t3 = Fp2.mul(t2, _3n); // 3 * T2
            var t4 = Fp2.sub(Fp2.sub(Fp2.sqr(Fp2.add(Ry, Rz)), t1), t0); // (Ry + Rz)² - T1 - T0
            ell_coeff.push([
                Fp2.sub(t2, t0),
                Fp2.mul(Fp2.sqr(Rx), _3n),
                Fp2.neg(t4), // -T4
            ]);
            Rx = Fp2.div(Fp2.mul(Fp2.mul(Fp2.sub(t0, t3), Rx), Ry), _2n); // ((T0 - T3) * Rx * Ry) / 2
            Ry = Fp2.sub(Fp2.sqr(Fp2.div(Fp2.add(t0, t3), _2n)), Fp2.mul(Fp2.sqr(t2), _3n)); // ((T0 + T3) / 2)² - 3 * T2²
            Rz = Fp2.mul(t0, t4); // T0 * T4
            if ((0, utils_1.bitGet)(CURVE.params.x, i)) {
                // Addition
                var t0_1 = Fp2.sub(Ry, Fp2.mul(Qy, Rz)); // Ry - Qy * Rz
                var t1_1 = Fp2.sub(Rx, Fp2.mul(Qx, Rz)); // Rx - Qx * Rz
                ell_coeff.push([
                    Fp2.sub(Fp2.mul(t0_1, Qx), Fp2.mul(t1_1, Qy)),
                    Fp2.neg(t0_1),
                    t1_1, // T1
                ]);
                var t2_1 = Fp2.sqr(t1_1); // T1²
                var t3_1 = Fp2.mul(t2_1, t1_1); // T2 * T1
                var t4_1 = Fp2.mul(t2_1, Rx); // T2 * Rx
                var t5 = Fp2.add(Fp2.sub(t3_1, Fp2.mul(t4_1, _2n)), Fp2.mul(Fp2.sqr(t0_1), Rz)); // T3 - 2 * T4 + T0² * Rz
                Rx = Fp2.mul(t1_1, t5); // T1 * T5
                Ry = Fp2.sub(Fp2.mul(Fp2.sub(t4_1, t5), t0_1), Fp2.mul(t3_1, Ry)); // (T4 - T5) * T0 - T3 * Ry
                Rz = Fp2.mul(Rz, t3_1); // Rz * T3
            }
        }
        return ell_coeff;
    }
    function millerLoop(ell, g1) {
        var x = CURVE.params.x;
        var Px = g1[0];
        var Py = g1[1];
        var f12 = Fp12.ONE;
        for (var j = 0, i = BLS_X_LEN - 2; i >= 0; i--, j++) {
            var E = ell[j];
            f12 = Fp12.multiplyBy014(f12, E[0], Fp2.mul(E[1], Px), Fp2.mul(E[2], Py));
            if ((0, utils_1.bitGet)(x, i)) {
                j += 1;
                var F = ell[j];
                f12 = Fp12.multiplyBy014(f12, F[0], Fp2.mul(F[1], Px), Fp2.mul(F[2], Py));
            }
            if (i !== 0)
                f12 = Fp12.sqr(f12);
        }
        return Fp12.conjugate(f12);
    }
    var utils = {
        randomPrivateKey: function () {
            var length = (0, modular_1.getMinHashLength)(Fr.ORDER);
            return (0, modular_1.mapHashToField)(CURVE.randomBytes(length), Fr.ORDER);
        },
        calcPairingPrecomputes: calcPairingPrecomputes,
    };
    // Point on G1 curve: (x, y)
    var G1_ = (0, weierstrass_1.weierstrassPoints)(__assign({ n: Fr.ORDER }, CURVE.G1));
    var G1 = Object.assign(G1_, (0, hash_to_curve_1.createHasher)(G1_.ProjectivePoint, CURVE.G1.mapToCurve, __assign(__assign({}, CURVE.htfDefaults), CURVE.G1.htfDefaults)));
    function pairingPrecomputes(point) {
        var p = point;
        if (p._PPRECOMPUTES)
            return p._PPRECOMPUTES;
        p._PPRECOMPUTES = calcPairingPrecomputes(point.toAffine());
        return p._PPRECOMPUTES;
    }
    // TODO: export
    // function clearPairingPrecomputes(point: G2) {
    //   const p = point as G2 & withPairingPrecomputes;
    //   p._PPRECOMPUTES = undefined;
    // }
    // Point on G2 curve (complex numbers): (x₁, x₂+i), (y₁, y₂+i)
    var G2_ = (0, weierstrass_1.weierstrassPoints)(__assign({ n: Fr.ORDER }, CURVE.G2));
    var G2 = Object.assign(G2_, (0, hash_to_curve_1.createHasher)(G2_.ProjectivePoint, CURVE.G2.mapToCurve, __assign(__assign({}, CURVE.htfDefaults), CURVE.G2.htfDefaults)));
    var ShortSignature = CURVE.G1.ShortSignature;
    var Signature = CURVE.G2.Signature;
    // Calculates bilinear pairing
    function pairing(Q, P, withFinalExponent) {
        if (withFinalExponent === void 0) { withFinalExponent = true; }
        if (Q.equals(G1.ProjectivePoint.ZERO) || P.equals(G2.ProjectivePoint.ZERO))
            throw new Error('pairing is not available for ZERO point');
        Q.assertValidity();
        P.assertValidity();
        // Performance: 9ms for millerLoop and ~14ms for exp.
        var Qa = Q.toAffine();
        var looped = millerLoop(pairingPrecomputes(P), [Qa.x, Qa.y]);
        return withFinalExponent ? Fp12.finalExponentiate(looped) : looped;
    }
    function normP1(point) {
        return point instanceof G1.ProjectivePoint ? point : G1.ProjectivePoint.fromHex(point);
    }
    function normP1Hash(point, htfOpts) {
        return point instanceof G1.ProjectivePoint
            ? point
            : G1.hashToCurve((0, utils_1.ensureBytes)('point', point), htfOpts);
    }
    function normP2(point) {
        return point instanceof G2.ProjectivePoint ? point : Signature.fromHex(point);
    }
    function normP2Hash(point, htfOpts) {
        return point instanceof G2.ProjectivePoint
            ? point
            : G2.hashToCurve((0, utils_1.ensureBytes)('point', point), htfOpts);
    }
    // Multiplies generator (G1) by private key.
    // P = pk x G
    function getPublicKey(privateKey) {
        return G1.ProjectivePoint.fromPrivateKey(privateKey).toRawBytes(true);
    }
    // Multiplies generator (G2) by private key.
    // P = pk x G
    function getPublicKeyForShortSignatures(privateKey) {
        return G2.ProjectivePoint.fromPrivateKey(privateKey).toRawBytes(true);
    }
    function sign(message, privateKey, htfOpts) {
        var msgPoint = normP2Hash(message, htfOpts);
        msgPoint.assertValidity();
        var sigPoint = msgPoint.multiply(G1.normPrivateKeyToScalar(privateKey));
        if (message instanceof G2.ProjectivePoint)
            return sigPoint;
        return Signature.toRawBytes(sigPoint);
    }
    function signShortSignature(message, privateKey, htfOpts) {
        var msgPoint = normP1Hash(message, htfOpts);
        msgPoint.assertValidity();
        var sigPoint = msgPoint.multiply(G1.normPrivateKeyToScalar(privateKey));
        if (message instanceof G1.ProjectivePoint)
            return sigPoint;
        return ShortSignature.toRawBytes(sigPoint);
    }
    // Checks if pairing of public key & hash is equal to pairing of generator & signature.
    // e(P, H(m)) == e(G, S)
    function verify(signature, message, publicKey, htfOpts) {
        var P = normP1(publicKey);
        var Hm = normP2Hash(message, htfOpts);
        var G = G1.ProjectivePoint.BASE;
        var S = normP2(signature);
        // Instead of doing 2 exponentiations, we use property of billinear maps
        // and do one exp after multiplying 2 points.
        var ePHm = pairing(P.negate(), Hm, false);
        var eGS = pairing(G, S, false);
        var exp = Fp12.finalExponentiate(Fp12.mul(eGS, ePHm));
        return Fp12.eql(exp, Fp12.ONE);
    }
    // Checks if pairing of public key & hash is equal to pairing of generator & signature.
    // e(S, G) == e(H(m), P)
    function verifyShortSignature(signature, message, publicKey, htfOpts) {
        var P = normP2(publicKey);
        var Hm = normP1Hash(message, htfOpts);
        var G = G2.ProjectivePoint.BASE;
        var S = normP1(signature);
        // Instead of doing 2 exponentiations, we use property of billinear maps
        // and do one exp after multiplying 2 points.
        var eHmP = pairing(Hm, P, false);
        var eSG = pairing(S, G.negate(), false);
        var exp = Fp12.finalExponentiate(Fp12.mul(eSG, eHmP));
        return Fp12.eql(exp, Fp12.ONE);
    }
    function aggregatePublicKeys(publicKeys) {
        if (!publicKeys.length)
            throw new Error('Expected non-empty array');
        var agg = publicKeys.map(normP1).reduce(function (sum, p) { return sum.add(p); }, G1.ProjectivePoint.ZERO);
        var aggAffine = agg; //.toAffine();
        if (publicKeys[0] instanceof G1.ProjectivePoint) {
            aggAffine.assertValidity();
            return aggAffine;
        }
        // toRawBytes ensures point validity
        return aggAffine.toRawBytes(true);
    }
    function aggregateSignatures(signatures) {
        if (!signatures.length)
            throw new Error('Expected non-empty array');
        var agg = signatures.map(normP2).reduce(function (sum, s) { return sum.add(s); }, G2.ProjectivePoint.ZERO);
        var aggAffine = agg; //.toAffine();
        if (signatures[0] instanceof G2.ProjectivePoint) {
            aggAffine.assertValidity();
            return aggAffine;
        }
        return Signature.toRawBytes(aggAffine);
    }
    function aggregateShortSignatures(signatures) {
        if (!signatures.length)
            throw new Error('Expected non-empty array');
        var agg = signatures.map(normP1).reduce(function (sum, s) { return sum.add(s); }, G1.ProjectivePoint.ZERO);
        var aggAffine = agg; //.toAffine();
        if (signatures[0] instanceof G1.ProjectivePoint) {
            aggAffine.assertValidity();
            return aggAffine;
        }
        return ShortSignature.toRawBytes(aggAffine);
    }
    // https://ethresear.ch/t/fast-verification-of-multiple-bls-signatures/5407
    // e(G, S) = e(G, SUM(n)(Si)) = MUL(n)(e(G, Si))
    function verifyBatch(signature, messages, publicKeys, htfOpts) {
        // @ts-ignore
        // console.log('verifyBatch', bytesToHex(signature as any), messages, publicKeys.map(bytesToHex));
        var e_1, _a;
        if (!messages.length)
            throw new Error('Expected non-empty messages array');
        if (publicKeys.length !== messages.length)
            throw new Error('Pubkey count should equal msg count');
        var sig = normP2(signature);
        var nMessages = messages.map(function (i) { return normP2Hash(i, htfOpts); });
        var nPublicKeys = publicKeys.map(normP1);
        try {
            var paired = [];
            var _loop_1 = function (message) {
                var groupPublicKey = nMessages.reduce(function (groupPublicKey, subMessage, i) {
                    return subMessage === message ? groupPublicKey.add(nPublicKeys[i]) : groupPublicKey;
                }, G1.ProjectivePoint.ZERO);
                // const msg = message instanceof PointG2 ? message : await PointG2.hashToCurve(message);
                // Possible to batch pairing for same msg with different groupPublicKey here
                paired.push(pairing(groupPublicKey, message, false));
            };
            try {
                for (var _b = __values(new Set(nMessages)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var message = _c.value;
                    _loop_1(message);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            paired.push(pairing(G1.ProjectivePoint.BASE.negate(), sig, false));
            var product = paired.reduce(function (a, b) { return Fp12.mul(a, b); }, Fp12.ONE);
            var exp = Fp12.finalExponentiate(product);
            return Fp12.eql(exp, Fp12.ONE);
        }
        catch (_d) {
            return false;
        }
    }
    G1.ProjectivePoint.BASE._setWindowSize(4);
    return {
        getPublicKey: getPublicKey,
        getPublicKeyForShortSignatures: getPublicKeyForShortSignatures,
        sign: sign,
        signShortSignature: signShortSignature,
        verify: verify,
        verifyBatch: verifyBatch,
        verifyShortSignature: verifyShortSignature,
        aggregatePublicKeys: aggregatePublicKeys,
        aggregateSignatures: aggregateSignatures,
        aggregateShortSignatures: aggregateShortSignatures,
        millerLoop: millerLoop,
        pairing: pairing,
        G1: G1,
        G2: G2,
        Signature: Signature,
        ShortSignature: ShortSignature,
        fields: {
            Fr: Fr,
            Fp: Fp,
            Fp2: Fp2,
            Fp6: Fp6,
            Fp12: Fp12,
        },
        params: {
            x: CURVE.params.x,
            r: CURVE.params.r,
            G1b: CURVE.G1.b,
            G2b: CURVE.G2.b,
        },
        utils: utils,
    };
}
exports.bls = bls;


/***/ }),

/***/ 1290:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/abstract/curve.ts

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateBasic = exports.wNAF = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// Abelian group utilities
var modular_1 = __webpack_require__(83827);
var utils_1 = __webpack_require__(52993);
var _0n = BigInt(0);
var _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    var constTimeNegate = function (condition, item) {
        var neg = item.negate();
        return condition ? neg : item;
    };
    var opts = function (W) {
        var windows = Math.ceil(bits / W) + 1; // +1, because
        var windowSize = Math.pow(2, (W - 1)); // -1 because we skip zero
        return { windows: windows, windowSize: windowSize };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder: function (elm, n) {
            var p = c.ZERO;
            var d = elm;
            while (n > _0n) {
                if (n & _1n)
                    p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */
        precomputeWindow: function (elm, W) {
            var _a = opts(W), windows = _a.windows, windowSize = _a.windowSize;
            var points = [];
            var p = elm;
            var base = p;
            for (var window_1 = 0; window_1 < windows; window_1++) {
                base = p;
                points.push(base);
                // =1, because we skip zero
                for (var i = 1; i < windowSize; i++) {
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */
        wNAF: function (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            var _a = opts(W), windows = _a.windows, windowSize = _a.windowSize;
            var p = c.ZERO;
            var f = c.BASE;
            var mask = BigInt(Math.pow(2, W) - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            var maxNumber = Math.pow(2, W);
            var shiftBy = BigInt(W);
            for (var window_2 = 0; window_2 < windows; window_2++) {
                var offset = window_2 * windowSize;
                // Extract W bits.
                var wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                var offset1 = offset;
                var offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                var cond1 = window_2 % 2 !== 0;
                var cond2 = wbits < 0;
                if (wbits === 0) {
                    // The most important part for const-time getPublicKey
                    f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                }
                else {
                    p = p.add(constTimeNegate(cond2, precomputes[offset2]));
                }
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return { p: p, f: f };
        },
        wNAFCached: function (P, precomputesMap, n, transform) {
            // @ts-ignore
            var W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            var comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) {
                    precomputesMap.set(P, transform(comp));
                }
            }
            return this.wNAF(W, comp, n);
        },
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, modular_1.validateField)(curve.Fp);
    (0, utils_1.validateObject)(curve, {
        n: 'bigint',
        h: 'bigint',
        Gx: 'field',
        Gy: 'field',
    }, {
        nBitLength: 'isSafeInteger',
        nByteLength: 'isSafeInteger',
    });
    // Set defaults
    return Object.freeze(__assign(__assign(__assign({}, (0, modular_1.nLength)(curve.n, curve.nBitLength)), curve), { p: curve.Fp.ORDER }));
}
exports.validateBasic = validateBasic;


/***/ }),

/***/ 41721:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/abstract/hash-to-curve.ts

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createHasher = exports.isogenyMap = exports.hash_to_field = exports.expand_message_xof = exports.expand_message_xmd = void 0;
var modular_1 = __webpack_require__(83827);
var utils_1 = __webpack_require__(52993);
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
var os2ip = utils_1.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function i2osp(value, length) {
    if (value < 0 || value >= 1 << (8 * length)) {
        throw new Error("bad I2OSP call: value=".concat(value, " length=").concat(length));
    }
    var res = Array.from({ length: length }).fill(0);
    for (var i = length - 1; i >= 0; i--) {
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function strxor(a, b) {
    var arr = new Uint8Array(a.length);
    for (var i = 0; i < a.length; i++) {
        arr[i] = a[i] ^ b[i];
    }
    return arr;
}
function anum(item) {
    if (!Number.isSafeInteger(item))
        throw new Error('number expected');
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function expand_message_xmd(msg, DST, lenInBytes, H) {
    (0, utils_1.abytes)(msg);
    (0, utils_1.abytes)(DST);
    anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255)
        DST = H((0, utils_1.concatBytes)((0, utils_1.utf8ToBytes)('H2C-OVERSIZE-DST-'), DST));
    var b_in_bytes = H.outputLen, r_in_bytes = H.blockLen;
    var ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255)
        throw new Error('Invalid xmd length');
    var DST_prime = (0, utils_1.concatBytes)(DST, i2osp(DST.length, 1));
    var Z_pad = i2osp(0, r_in_bytes);
    var l_i_b_str = i2osp(lenInBytes, 2); // len_in_bytes_str
    var b = new Array(ell);
    var b_0 = H((0, utils_1.concatBytes)(Z_pad, msg, l_i_b_str, i2osp(0, 1), DST_prime));
    b[0] = H((0, utils_1.concatBytes)(b_0, i2osp(1, 1), DST_prime));
    for (var i = 1; i <= ell; i++) {
        var args = [strxor(b_0, b[i - 1]), i2osp(i + 1, 1), DST_prime];
        b[i] = H(utils_1.concatBytes.apply(void 0, __spreadArray([], __read(args), false)));
    }
    var pseudo_random_bytes = utils_1.concatBytes.apply(void 0, __spreadArray([], __read(b), false));
    return pseudo_random_bytes.slice(0, lenInBytes);
}
exports.expand_message_xmd = expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function expand_message_xof(msg, DST, lenInBytes, k, H) {
    (0, utils_1.abytes)(msg);
    (0, utils_1.abytes)(DST);
    anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        var dkLen = Math.ceil((2 * k) / 8);
        DST = H.create({ dkLen: dkLen }).update((0, utils_1.utf8ToBytes)('H2C-OVERSIZE-DST-')).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255)
        throw new Error('expand_message_xof: invalid lenInBytes');
    return (H.create({ dkLen: lenInBytes })
        .update(msg)
        .update(i2osp(lenInBytes, 2))
        // 2. DST_prime = DST || I2OSP(len(DST), 1)
        .update(DST)
        .update(i2osp(DST.length, 1))
        .digest());
}
exports.expand_message_xof = expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */
function hash_to_field(msg, count, options) {
    (0, utils_1.validateObject)(options, {
        DST: 'stringOrUint8Array',
        p: 'bigint',
        m: 'isSafeInteger',
        k: 'isSafeInteger',
        hash: 'hash',
    });
    var p = options.p, k = options.k, m = options.m, hash = options.hash, expand = options.expand, _DST = options.DST;
    (0, utils_1.abytes)(msg);
    anum(count);
    var DST = typeof _DST === 'string' ? (0, utils_1.utf8ToBytes)(_DST) : _DST;
    var log2p = p.toString(2).length;
    var L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    var len_in_bytes = count * m * L;
    var prb; // pseudo_random_bytes
    if (expand === 'xmd') {
        prb = expand_message_xmd(msg, DST, len_in_bytes, hash);
    }
    else if (expand === 'xof') {
        prb = expand_message_xof(msg, DST, len_in_bytes, k, hash);
    }
    else if (expand === '_internal_pass') {
        // for internal tests only
        prb = msg;
    }
    else {
        throw new Error('expand must be "xmd" or "xof"');
    }
    var u = new Array(count);
    for (var i = 0; i < count; i++) {
        var e = new Array(m);
        for (var j = 0; j < m; j++) {
            var elm_offset = L * (j + i * m);
            var tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, modular_1.mod)(os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
exports.hash_to_field = hash_to_field;
function isogenyMap(field, map) {
    // Make same order as in spec
    var COEFF = map.map(function (i) { return Array.from(i).reverse(); });
    return function (x, y) {
        var _a = __read(COEFF.map(function (val) {
            return val.reduce(function (acc, i) { return field.add(field.mul(acc, x), i); });
        }), 4), xNum = _a[0], xDen = _a[1], yNum = _a[2], yDen = _a[3];
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return { x: x, y: y };
    };
}
exports.isogenyMap = isogenyMap;
function createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== 'function')
        throw new Error('mapToCurve() must be defined');
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve: function (msg, options) {
            var u = hash_to_field(msg, 2, __assign(__assign(__assign({}, def), { DST: def.DST }), options));
            var u0 = Point.fromAffine(mapToCurve(u[0]));
            var u1 = Point.fromAffine(mapToCurve(u[1]));
            var P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve: function (msg, options) {
            var u = hash_to_field(msg, 1, __assign(__assign(__assign({}, def), { DST: def.encodeDST }), options));
            var P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        },
    };
}
exports.createHasher = createHasher;


/***/ }),

/***/ 83827:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/abstract/modular.ts

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapHashToField = exports.getMinHashLength = exports.getFieldBytesLength = exports.hashToPrivateScalar = exports.FpSqrtEven = exports.FpSqrtOdd = exports.Field = exports.nLength = exports.FpIsSquare = exports.FpDiv = exports.FpInvertBatch = exports.FpPow = exports.validateField = exports.isNegativeLE = exports.FpSqrt = exports.tonelliShanks = exports.invert = exports.pow2 = exports.pow = exports.mod = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// Utilities for modular arithmetics and finite fields
var utils_1 = __webpack_require__(52993);
// prettier-ignore
var _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3);
// prettier-ignore
var _4n = BigInt(4), _5n = BigInt(5), _8n = BigInt(8);
// prettier-ignore
var _9n = BigInt(9), _16n = BigInt(16);
// Calculates a modulo b
function mod(a, b) {
    var result = a % b;
    return result >= _0n ? result : b + result;
}
exports.mod = mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */
// TODO: use field version && remove
function pow(num, power, modulo) {
    if (modulo <= _0n || power < _0n)
        throw new Error('Expected power/modulo > 0');
    if (modulo === _1n)
        return _0n;
    var res = _1n;
    while (power > _0n) {
        if (power & _1n)
            res = (res * num) % modulo;
        num = (num * num) % modulo;
        power >>= _1n;
    }
    return res;
}
exports.pow = pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function pow2(x, power, modulo) {
    var res = x;
    while (power-- > _0n) {
        res *= res;
        res %= modulo;
    }
    return res;
}
exports.pow2 = pow2;
// Inverses number over modulo
function invert(number, modulo) {
    if (number === _0n || modulo <= _0n) {
        throw new Error("invert: expected positive integers, got n=".concat(number, " mod=").concat(modulo));
    }
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    var a = mod(number, modulo);
    var b = modulo;
    // prettier-ignore
    var x = _0n, y = _1n, u = _1n, v = _0n;
    while (a !== _0n) {
        // JIT applies optimization if those two lines follow each other
        var q = b / a;
        var r = b % a;
        var m = x - u * q;
        var n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    var gcd = b;
    if (gcd !== _1n)
        throw new Error('invert: does not exist');
    return mod(x, modulo);
}
exports.invert = invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */
function tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    var legendreC = (P - _1n) / _2n;
    var Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for (Q = P - _1n, S = 0; Q % _2n === _0n; Q /= _2n, S++)
        ;
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for (Z = _2n; Z < P && pow(Z, legendreC, P) !== P - _1n; Z++)
        ;
    // Fast-path
    if (S === 1) {
        var p1div4_1 = (P + _1n) / _4n;
        return function tonelliFast(Fp, n) {
            var root = Fp.pow(n, p1div4_1);
            if (!Fp.eql(Fp.sqr(root), n))
                throw new Error('Cannot find square root');
            return root;
        };
    }
    // Slow-path
    var Q1div2 = (Q + _1n) / _2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE))
            throw new Error('Cannot find square root');
        var r = S;
        // TODO: will fail at Fp2/etc
        var g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        var x = Fp.pow(n, Q1div2); // first guess at the square root
        var b = Fp.pow(n, Q); // first guess at the fudge factor
        while (!Fp.eql(b, Fp.ONE)) {
            if (Fp.eql(b, Fp.ZERO))
                return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            var m = 1;
            for (var t2 = Fp.sqr(b); m < r; m++) {
                if (Fp.eql(t2, Fp.ONE))
                    break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            var ge = Fp.pow(g, _1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
exports.tonelliShanks = tonelliShanks;
function FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % _4n === _3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        var p1div4_2 = (P + _1n) / _4n;
        return function sqrt3mod4(Fp, n) {
            var root = Fp.pow(n, p1div4_2);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n))
                throw new Error('Cannot find square root');
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % _8n === _5n) {
        var c1_1 = (P - _5n) / _8n;
        return function sqrt5mod8(Fp, n) {
            var n2 = Fp.mul(n, _2n);
            var v = Fp.pow(n2, c1_1);
            var nv = Fp.mul(n, v);
            var i = Fp.mul(Fp.mul(nv, _2n), v);
            var root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n))
                throw new Error('Cannot find square root');
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    if (P % _16n === _9n) {
        // NOTE: tonelli is too slow for bls-Fp2 calculations even on start
        // Means we cannot use sqrt for constants at all!
        //
        // const c1 = Fp.sqrt(Fp.negate(Fp.ONE)); //  1. c1 = sqrt(-1) in F, i.e., (c1^2) == -1 in F
        // const c2 = Fp.sqrt(c1);                //  2. c2 = sqrt(c1) in F, i.e., (c2^2) == c1 in F
        // const c3 = Fp.sqrt(Fp.negate(c1));     //  3. c3 = sqrt(-c1) in F, i.e., (c3^2) == -c1 in F
        // const c4 = (P + _7n) / _16n;           //  4. c4 = (q + 7) / 16        # Integer arithmetic
        // sqrt = (x) => {
        //   let tv1 = Fp.pow(x, c4);             //  1. tv1 = x^c4
        //   let tv2 = Fp.mul(c1, tv1);           //  2. tv2 = c1 * tv1
        //   const tv3 = Fp.mul(c2, tv1);         //  3. tv3 = c2 * tv1
        //   let tv4 = Fp.mul(c3, tv1);           //  4. tv4 = c3 * tv1
        //   const e1 = Fp.equals(Fp.square(tv2), x); //  5.  e1 = (tv2^2) == x
        //   const e2 = Fp.equals(Fp.square(tv3), x); //  6.  e2 = (tv3^2) == x
        //   tv1 = Fp.cmov(tv1, tv2, e1); //  7. tv1 = CMOV(tv1, tv2, e1)  # Select tv2 if (tv2^2) == x
        //   tv2 = Fp.cmov(tv4, tv3, e2); //  8. tv2 = CMOV(tv4, tv3, e2)  # Select tv3 if (tv3^2) == x
        //   const e3 = Fp.equals(Fp.square(tv2), x); //  9.  e3 = (tv2^2) == x
        //   return Fp.cmov(tv1, tv2, e3); //  10.  z = CMOV(tv1, tv2, e3)  # Select the sqrt from tv1 and tv2
        // }
    }
    // Other cases: Tonelli-Shanks algorithm
    return tonelliShanks(P);
}
exports.FpSqrt = FpSqrt;
// Little-endian check for first LE bit (last BE bit);
var isNegativeLE = function (num, modulo) { return (mod(num, modulo) & _1n) === _1n; };
exports.isNegativeLE = isNegativeLE;
// prettier-ignore
var FIELD_FIELDS = [
    'create', 'isValid', 'is0', 'neg', 'inv', 'sqrt', 'sqr',
    'eql', 'add', 'sub', 'mul', 'pow', 'div',
    'addN', 'subN', 'mulN', 'sqrN'
];
function validateField(field) {
    var initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'isSafeInteger',
        BITS: 'isSafeInteger',
    };
    var opts = FIELD_FIELDS.reduce(function (map, val) {
        map[val] = 'function';
        return map;
    }, initial);
    return (0, utils_1.validateObject)(field, opts);
}
exports.validateField = validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */
function FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < _0n)
        throw new Error('Expected power > 0');
    if (power === _0n)
        return f.ONE;
    if (power === _1n)
        return num;
    var p = f.ONE;
    var d = num;
    while (power > _0n) {
        if (power & _1n)
            p = f.mul(p, d);
        d = f.sqr(d);
        power >>= _1n;
    }
    return p;
}
exports.FpPow = FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */
function FpInvertBatch(f, nums) {
    var tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    var lastMultiplied = nums.reduce(function (acc, num, i) {
        if (f.is0(num))
            return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    var inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight(function (acc, num, i) {
        if (f.is0(num))
            return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
exports.FpInvertBatch = FpInvertBatch;
function FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === 'bigint' ? invert(rhs, f.ORDER) : f.inv(rhs));
}
exports.FpDiv = FpDiv;
// This function returns True whenever the value x is a square in the field F.
function FpIsSquare(f) {
    var legendreConst = (f.ORDER - _1n) / _2n; // Integer arithmetic
    return function (x) {
        var p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
exports.FpIsSquare = FpIsSquare;
// CURVE.n lengths
function nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    var _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    var nByteLength = Math.ceil(_nBitLength / 8);
    return { nBitLength: _nBitLength, nByteLength: nByteLength };
}
exports.nLength = nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */
function Field(ORDER, bitLen, isLE, redef) {
    if (isLE === void 0) { isLE = false; }
    if (redef === void 0) { redef = {}; }
    if (ORDER <= _0n)
        throw new Error("Expected Field ORDER > 0, got ".concat(ORDER));
    var _a = nLength(ORDER, bitLen), BITS = _a.nBitLength, BYTES = _a.nByteLength;
    if (BYTES > 2048)
        throw new Error('Field lengths over 2048 bytes are not supported');
    var sqrtP = FpSqrt(ORDER);
    var f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, utils_1.bitMask)(BITS),
        ZERO: _0n,
        ONE: _1n,
        create: function (num) { return mod(num, ORDER); },
        isValid: function (num) {
            if (typeof num !== 'bigint')
                throw new Error("Invalid field element: expected bigint, got ".concat(typeof num));
            return _0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: function (num) { return num === _0n; },
        isOdd: function (num) { return (num & _1n) === _1n; },
        neg: function (num) { return mod(-num, ORDER); },
        eql: function (lhs, rhs) { return lhs === rhs; },
        sqr: function (num) { return mod(num * num, ORDER); },
        add: function (lhs, rhs) { return mod(lhs + rhs, ORDER); },
        sub: function (lhs, rhs) { return mod(lhs - rhs, ORDER); },
        mul: function (lhs, rhs) { return mod(lhs * rhs, ORDER); },
        pow: function (num, power) { return FpPow(f, num, power); },
        div: function (lhs, rhs) { return mod(lhs * invert(rhs, ORDER), ORDER); },
        // Same as above, but doesn't normalize
        sqrN: function (num) { return num * num; },
        addN: function (lhs, rhs) { return lhs + rhs; },
        subN: function (lhs, rhs) { return lhs - rhs; },
        mulN: function (lhs, rhs) { return lhs * rhs; },
        inv: function (num) { return invert(num, ORDER); },
        sqrt: redef.sqrt || (function (n) { return sqrtP(f, n); }),
        invertBatch: function (lst) { return FpInvertBatch(f, lst); },
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: function (a, b, c) { return (c ? b : a); },
        toBytes: function (num) { return (isLE ? (0, utils_1.numberToBytesLE)(num, BYTES) : (0, utils_1.numberToBytesBE)(num, BYTES)); },
        fromBytes: function (bytes) {
            if (bytes.length !== BYTES)
                throw new Error("Fp.fromBytes: expected ".concat(BYTES, ", got ").concat(bytes.length));
            return isLE ? (0, utils_1.bytesToNumberLE)(bytes) : (0, utils_1.bytesToNumberBE)(bytes);
        },
    });
    return Object.freeze(f);
}
exports.Field = Field;
function FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd)
        throw new Error("Field doesn't have isOdd");
    var root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
exports.FpSqrtOdd = FpSqrtOdd;
function FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd)
        throw new Error("Field doesn't have isOdd");
    var root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
exports.FpSqrtEven = FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */
function hashToPrivateScalar(hash, groupOrder, isLE) {
    if (isLE === void 0) { isLE = false; }
    hash = (0, utils_1.ensureBytes)('privateHash', hash);
    var hashLen = hash.length;
    var minLen = nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024)
        throw new Error("hashToPrivateScalar: expected ".concat(minLen, "-1024 bytes of input, got ").concat(hashLen));
    var num = isLE ? (0, utils_1.bytesToNumberLE)(hash) : (0, utils_1.bytesToNumberBE)(hash);
    return mod(num, groupOrder - _1n) + _1n;
}
exports.hashToPrivateScalar = hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */
function getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== 'bigint')
        throw new Error('field order must be bigint');
    var bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
exports.getFieldBytesLength = getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */
function getMinHashLength(fieldOrder) {
    var length = getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
exports.getMinHashLength = getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */
function mapHashToField(key, fieldOrder, isLE) {
    if (isLE === void 0) { isLE = false; }
    var len = key.length;
    var fieldLen = getFieldBytesLength(fieldOrder);
    var minLen = getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024)
        throw new Error("expected ".concat(minLen, "-1024 bytes of input, got ").concat(len));
    var num = isLE ? (0, utils_1.bytesToNumberBE)(key) : (0, utils_1.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    var reduced = mod(num, fieldOrder - _1n) + _1n;
    return isLE ? (0, utils_1.numberToBytesLE)(reduced, fieldLen) : (0, utils_1.numberToBytesBE)(reduced, fieldLen);
}
exports.mapHashToField = mapHashToField;


/***/ }),

/***/ 52993:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/abstract/utils.ts

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateObject = exports.createHmacDrbg = exports.bitMask = exports.bitSet = exports.bitGet = exports.bitLen = exports.utf8ToBytes = exports.equalBytes = exports.concatBytes = exports.ensureBytes = exports.numberToVarBytesBE = exports.numberToBytesLE = exports.numberToBytesBE = exports.bytesToNumberLE = exports.bytesToNumberBE = exports.hexToBytes = exports.hexToNumber = exports.numberToHexUnpadded = exports.bytesToHex = exports.abytes = exports.isBytes = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
var _0n = BigInt(0);
var _1n = BigInt(1);
var _2n = BigInt(2);
function isBytes(a) {
    return (a instanceof Uint8Array ||
        (a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array'));
}
exports.isBytes = isBytes;
function abytes(item) {
    if (!isBytes(item))
        throw new Error('Uint8Array expected');
}
exports.abytes = abytes;
// Array where index 0xf0 (240) is mapped to string 'f0'
var hexes = /* @__PURE__ */ Array.from({ length: 256 }, function (_, i) {
    return i.toString(16).padStart(2, '0');
});
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */
function bytesToHex(bytes) {
    abytes(bytes);
    // pre-caching improves the speed 6x
    var hex = '';
    for (var i = 0; i < bytes.length; i++) {
        hex += hexes[bytes[i]];
    }
    return hex;
}
exports.bytesToHex = bytesToHex;
function numberToHexUnpadded(num) {
    var hex = num.toString(16);
    return hex.length & 1 ? "0".concat(hex) : hex;
}
exports.numberToHexUnpadded = numberToHexUnpadded;
function hexToNumber(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    // Big Endian
    return BigInt(hex === '' ? '0' : "0x".concat(hex));
}
exports.hexToNumber = hexToNumber;
// We use optimized technique to convert hex string to byte array
var asciis = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9)
        return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F)
        return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f)
        return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */
function hexToBytes(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    var hl = hex.length;
    var al = hl / 2;
    if (hl % 2)
        throw new Error('padded hex string expected, got unpadded hex of length ' + hl);
    var array = new Uint8Array(al);
    for (var ai = 0, hi = 0; ai < al; ai++, hi += 2) {
        var n1 = asciiToBase16(hex.charCodeAt(hi));
        var n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            var char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// BE: Big Endian, LE: Little Endian
function bytesToNumberBE(bytes) {
    return hexToNumber(bytesToHex(bytes));
}
exports.bytesToNumberBE = bytesToNumberBE;
function bytesToNumberLE(bytes) {
    abytes(bytes);
    return hexToNumber(bytesToHex(Uint8Array.from(bytes).reverse()));
}
exports.bytesToNumberLE = bytesToNumberLE;
function numberToBytesBE(n, len) {
    return hexToBytes(n.toString(16).padStart(len * 2, '0'));
}
exports.numberToBytesBE = numberToBytesBE;
function numberToBytesLE(n, len) {
    return numberToBytesBE(n, len).reverse();
}
exports.numberToBytesLE = numberToBytesLE;
// Unpadded, rarely used
function numberToVarBytesBE(n) {
    return hexToBytes(numberToHexUnpadded(n));
}
exports.numberToVarBytesBE = numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */
function ensureBytes(title, hex, expectedLength) {
    var res;
    if (typeof hex === 'string') {
        try {
            res = hexToBytes(hex);
        }
        catch (e) {
            throw new Error("".concat(title, " must be valid hex string, got \"").concat(hex, "\". Cause: ").concat(e));
        }
    }
    else if (isBytes(hex)) {
        // Uint8Array.from() instead of hash.slice() because node Buffer
        // is instance of Uint8Array, and its slice() creates **mutable** copy
        res = Uint8Array.from(hex);
    }
    else {
        throw new Error("".concat(title, " must be hex string or Uint8Array"));
    }
    var len = res.length;
    if (typeof expectedLength === 'number' && len !== expectedLength)
        throw new Error("".concat(title, " expected ").concat(expectedLength, " bytes, got ").concat(len));
    return res;
}
exports.ensureBytes = ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */
function concatBytes() {
    var arrays = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arrays[_i] = arguments[_i];
    }
    var sum = 0;
    for (var i = 0; i < arrays.length; i++) {
        var a = arrays[i];
        abytes(a);
        sum += a.length;
    }
    var res = new Uint8Array(sum);
    for (var i = 0, pad = 0; i < arrays.length; i++) {
        var a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
exports.concatBytes = concatBytes;
// Compares 2 u8a-s in kinda constant time
function equalBytes(a, b) {
    if (a.length !== b.length)
        return false;
    var diff = 0;
    for (var i = 0; i < a.length; i++)
        diff |= a[i] ^ b[i];
    return diff === 0;
}
exports.equalBytes = equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */
function utf8ToBytes(str) {
    if (typeof str !== 'string')
        throw new Error("utf8ToBytes expected string, got ".concat(typeof str));
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
exports.utf8ToBytes = utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */
function bitLen(n) {
    var len;
    for (len = 0; n > _0n; n >>= _1n, len += 1)
        ;
    return len;
}
exports.bitLen = bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */
function bitGet(n, pos) {
    return (n >> BigInt(pos)) & _1n;
}
exports.bitGet = bitGet;
/**
 * Sets single bit at position.
 */
function bitSet(n, pos, value) {
    return n | ((value ? _1n : _0n) << BigInt(pos));
}
exports.bitSet = bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */
var bitMask = function (n) { return (_2n << BigInt(n - 1)) - _1n; };
exports.bitMask = bitMask;
// DRBG
var u8n = function (data) { return new Uint8Array(data); }; // creates Uint8Array
var u8fr = function (arr) { return Uint8Array.from(arr); }; // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */
function createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2)
        throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2)
        throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function')
        throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    var v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    var k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    var i = 0; // Iterations counter, will throw when over 1000
    var reset = function () {
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    var h = function () {
        var b = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            b[_i] = arguments[_i];
        }
        return hmacFn.apply(void 0, __spreadArray([k, v], __read(b), false));
    }; // hmac(k)(v, ...values)
    var reseed = function (seed) {
        if (seed === void 0) { seed = u8n(); }
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8fr([0x00]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0)
            return;
        k = h(u8fr([0x01]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    var gen = function () {
        // HMAC-DRBG generate() function
        if (i++ >= 1000)
            throw new Error('drbg: tried 1000 values');
        var len = 0;
        var out = [];
        while (len < qByteLen) {
            v = h();
            var sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return concatBytes.apply(void 0, __spreadArray([], __read(out), false));
    };
    var genUntil = function (seed, pred) {
        reset();
        reseed(seed); // Steps D-G
        var res = undefined; // Step H: grind until k is in [1..n-1]
        while (!(res = pred(gen())))
            reseed();
        reset();
        return res;
    };
    return genUntil;
}
exports.createHmacDrbg = createHmacDrbg;
// Validating curves and fields
var validatorFns = {
    bigint: function (val) { return typeof val === 'bigint'; },
    function: function (val) { return typeof val === 'function'; },
    boolean: function (val) { return typeof val === 'boolean'; },
    string: function (val) { return typeof val === 'string'; },
    stringOrUint8Array: function (val) { return typeof val === 'string' || isBytes(val); },
    isSafeInteger: function (val) { return Number.isSafeInteger(val); },
    array: function (val) { return Array.isArray(val); },
    field: function (val, object) { return object.Fp.isValid(val); },
    hash: function (val) { return typeof val === 'function' && Number.isSafeInteger(val.outputLen); },
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function validateObject(object, validators, optValidators) {
    var e_1, _b, e_2, _c;
    if (optValidators === void 0) { optValidators = {}; }
    var checkField = function (fieldName, type, isOptional) {
        var checkVal = validatorFns[type];
        if (typeof checkVal !== 'function')
            throw new Error("Invalid validator \"".concat(type, "\", expected function"));
        var val = object[fieldName];
        if (isOptional && val === undefined)
            return;
        if (!checkVal(val, object)) {
            throw new Error("Invalid param ".concat(String(fieldName), "=").concat(val, " (").concat(typeof val, "), expected ").concat(type));
        }
    };
    try {
        for (var _d = __values(Object.entries(validators)), _e = _d.next(); !_e.done; _e = _d.next()) {
            var _g = __read(_e.value, 2), fieldName = _g[0], type = _g[1];
            checkField(fieldName, type, false);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var _h = __values(Object.entries(optValidators)), _j = _h.next(); !_j.done; _j = _h.next()) {
            var _k = __read(_j.value, 2), fieldName = _k[0], type = _k[1];
            checkField(fieldName, type, true);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return object;
}
exports.validateObject = validateObject;
// validate type tests
// const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
// const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
// // Should fail type-check
// const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
// const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
// const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
// const z4 = validateObject(o, { a: 'boolean', z: 'bug' });


/***/ }),

/***/ 31637:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/abstract/weierstrass.ts

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapToCurveSimpleSWU = exports.SWUFpSqrtRatio = exports.weierstrass = exports.weierstrassPoints = exports.DER = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// Short Weierstrass curve. The formula is: y² = x³ + ax + b
var mod = __importStar(__webpack_require__(83827));
var ut = __importStar(__webpack_require__(52993));
var utils_1 = __webpack_require__(52993);
var curve_1 = __webpack_require__(1290);
function validatePointOpts(curve) {
    var opts = (0, curve_1.validateBasic)(curve);
    ut.validateObject(opts, {
        a: 'field',
        b: 'field',
    }, {
        allowedPrivateKeyLengths: 'array',
        wrapPrivateKey: 'boolean',
        isTorsionFree: 'function',
        clearCofactor: 'function',
        allowInfinityPoint: 'boolean',
        fromBytes: 'function',
        toBytes: 'function',
    });
    var endo = opts.endo, Fp = opts.Fp, a = opts.a;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) {
            throw new Error('Endomorphism can only be defined for Koblitz curves that have a=0');
        }
        if (typeof endo !== 'object' ||
            typeof endo.beta !== 'bigint' ||
            typeof endo.splitScalar !== 'function') {
            throw new Error('Expected endomorphism with beta: bigint and splitScalar: function');
        }
    }
    return Object.freeze(__assign({}, opts));
}
// ASN.1 DER encoding utilities
var b2n = ut.bytesToNumberBE, h2b = ut.hexToBytes;
exports.DER = {
    // asn.1 DER encoding utils
    Err: /** @class */ (function (_super) {
        __extends(DERErr, _super);
        function DERErr(m) {
            if (m === void 0) { m = ''; }
            return _super.call(this, m) || this;
        }
        return DERErr;
    }(Error)),
    _parseInt: function (data) {
        var E = exports.DER.Err;
        if (data.length < 2 || data[0] !== 0x02)
            throw new E('Invalid signature integer tag');
        var len = data[1];
        var res = data.subarray(2, len + 2);
        if (!len || res.length !== len)
            throw new E('Invalid signature integer: wrong length');
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128)
            throw new E('Invalid signature integer: negative');
        if (res[0] === 0x00 && !(res[1] & 128))
            throw new E('Invalid signature integer: unnecessary leading zero');
        return { d: b2n(res), l: data.subarray(len + 2) }; // d is data, l is left
    },
    toSig: function (hex) {
        // parse DER signature
        var E = exports.DER.Err;
        var data = typeof hex === 'string' ? h2b(hex) : hex;
        ut.abytes(data);
        var l = data.length;
        if (l < 2 || data[0] != 0x30)
            throw new E('Invalid signature tag');
        if (data[1] !== l - 2)
            throw new E('Invalid signature: incorrect length');
        var _a = exports.DER._parseInt(data.subarray(2)), r = _a.d, sBytes = _a.l;
        var _b = exports.DER._parseInt(sBytes), s = _b.d, rBytesLeft = _b.l;
        if (rBytesLeft.length)
            throw new E('Invalid signature: left bytes after parsing');
        return { r: r, s: s };
    },
    hexFromSig: function (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        var slice = function (s) { return (Number.parseInt(s[0], 16) & 8 ? '00' + s : s); };
        var h = function (num) {
            var hex = num.toString(16);
            return hex.length & 1 ? "0".concat(hex) : hex;
        };
        var s = slice(h(sig.s));
        var r = slice(h(sig.r));
        var shl = s.length / 2;
        var rhl = r.length / 2;
        var sl = h(shl);
        var rl = h(rhl);
        return "30".concat(h(rhl + shl + 4), "02").concat(rl).concat(r, "02").concat(sl).concat(s);
    },
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
var _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3), _4n = BigInt(4);
function weierstrassPoints(opts) {
    var CURVE = validatePointOpts(opts);
    var Fp = CURVE.Fp; // All curves has same field / group length as for now, but they can differ
    var toBytes = CURVE.toBytes ||
        (function (_c, point, _isCompressed) {
            var a = point.toAffine();
            return ut.concatBytes(Uint8Array.from([0x04]), Fp.toBytes(a.x), Fp.toBytes(a.y));
        });
    var fromBytes = CURVE.fromBytes ||
        (function (bytes) {
            // const head = bytes[0];
            var tail = bytes.subarray(1);
            // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
            var x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
            var y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
            return { x: x, y: y };
        });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */
    function weierstrassEquation(x) {
        var a = CURVE.a, b = CURVE.b;
        var x2 = Fp.sqr(x); // x * x
        var x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx)))
        throw new Error('bad generator point: equation left != right');
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === 'bigint' && _0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num))
            throw new Error('Expected valid bigint: 0 < bigint < curve.n');
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        var lengths = CURVE.allowedPrivateKeyLengths, nByteLength = CURVE.nByteLength, wrapPrivateKey = CURVE.wrapPrivateKey, n = CURVE.n;
        if (lengths && typeof key !== 'bigint') {
            if (ut.isBytes(key))
                key = ut.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== 'string' || !lengths.includes(key.length))
                throw new Error('Invalid key');
            key = key.padStart(nByteLength * 2, '0');
        }
        var num;
        try {
            num =
                typeof key === 'bigint'
                    ? key
                    : ut.bytesToNumberBE((0, utils_1.ensureBytes)('private key', key, nByteLength));
        }
        catch (error) {
            throw new Error("private key must be ".concat(nByteLength, " bytes, hex or bigint, not ").concat(typeof key));
        }
        if (wrapPrivateKey)
            num = mod.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    var pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point))
            throw new Error('ProjectivePoint expected');
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */
    var Point = /** @class */ (function () {
        function Point(px, py, pz) {
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px))
                throw new Error('x required');
            if (py == null || !Fp.isValid(py))
                throw new Error('y required');
            if (pz == null || !Fp.isValid(pz))
                throw new Error('z required');
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        Point.fromAffine = function (p) {
            var _a = p || {}, x = _a.x, y = _a.y;
            if (!p || !Fp.isValid(x) || !Fp.isValid(y))
                throw new Error('invalid affine point');
            if (p instanceof Point)
                throw new Error('projective point not allowed');
            var is0 = function (i) { return Fp.eql(i, Fp.ZERO); };
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y))
                return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        };
        Object.defineProperty(Point.prototype, "x", {
            get: function () {
                return this.toAffine().x;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Point.prototype, "y", {
            get: function () {
                return this.toAffine().y;
            },
            enumerable: false,
            configurable: true
        });
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */
        Point.normalizeZ = function (points) {
            var toInv = Fp.invertBatch(points.map(function (p) { return p.pz; }));
            return points.map(function (p, i) { return p.toAffine(toInv[i]); }).map(Point.fromAffine);
        };
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */
        Point.fromHex = function (hex) {
            var P = Point.fromAffine(fromBytes((0, utils_1.ensureBytes)('pointHex', hex)));
            P.assertValidity();
            return P;
        };
        // Multiplies generator point by privateKey.
        Point.fromPrivateKey = function (privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        };
        // "Private method", don't use it directly
        Point.prototype._setWindowSize = function (windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        };
        // A point on curve is valid if it conforms to equation.
        Point.prototype.assertValidity = function () {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py))
                    return;
                throw new Error('bad point: ZERO');
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            var _a = this.toAffine(), x = _a.x, y = _a.y;
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y))
                throw new Error('bad point: x or y not FE');
            var left = Fp.sqr(y); // y²
            var right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right))
                throw new Error('bad point: equation left != right');
            if (!this.isTorsionFree())
                throw new Error('bad point: not in prime-order subgroup');
        };
        Point.prototype.hasEvenY = function () {
            var y = this.toAffine().y;
            if (Fp.isOdd)
                return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        };
        /**
         * Compare one point to another.
         */
        Point.prototype.equals = function (other) {
            assertPrjPoint(other);
            var _a = this, X1 = _a.px, Y1 = _a.py, Z1 = _a.pz;
            var X2 = other.px, Y2 = other.py, Z2 = other.pz;
            var U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            var U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        };
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */
        Point.prototype.negate = function () {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        };
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        Point.prototype.double = function () {
            var a = CURVE.a, b = CURVE.b;
            var b3 = Fp.mul(b, _3n);
            var _a = this, X1 = _a.px, Y1 = _a.py, Z1 = _a.pz;
            var X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            var t0 = Fp.mul(X1, X1); // step 1
            var t1 = Fp.mul(Y1, Y1);
            var t2 = Fp.mul(Z1, Z1);
            var t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        };
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        Point.prototype.add = function (other) {
            assertPrjPoint(other);
            var _a = this, X1 = _a.px, Y1 = _a.py, Z1 = _a.pz;
            var X2 = other.px, Y2 = other.py, Z2 = other.pz;
            var X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            var a = CURVE.a;
            var b3 = Fp.mul(CURVE.b, _3n);
            var t0 = Fp.mul(X1, X2); // step 1
            var t1 = Fp.mul(Y1, Y2);
            var t2 = Fp.mul(Z1, Z2);
            var t3 = Fp.add(X1, Y1);
            var t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            var t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        };
        Point.prototype.subtract = function (other) {
            return this.add(other.negate());
        };
        Point.prototype.is0 = function () {
            return this.equals(Point.ZERO);
        };
        Point.prototype.wNAF = function (n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, function (comp) {
                var toInv = Fp.invertBatch(comp.map(function (p) { return p.pz; }));
                return comp.map(function (p, i) { return p.toAffine(toInv[i]); }).map(Point.fromAffine);
            });
        };
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */
        Point.prototype.multiplyUnsafe = function (n) {
            var I = Point.ZERO;
            if (n === _0n)
                return I;
            assertGE(n); // Will throw on 0
            if (n === _1n)
                return this;
            var endo = CURVE.endo;
            if (!endo)
                return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            var _a = endo.splitScalar(n), k1neg = _a.k1neg, k1 = _a.k1, k2neg = _a.k2neg, k2 = _a.k2;
            var k1p = I;
            var k2p = I;
            var d = this;
            while (k1 > _0n || k2 > _0n) {
                if (k1 & _1n)
                    k1p = k1p.add(d);
                if (k2 & _1n)
                    k2p = k2p.add(d);
                d = d.double();
                k1 >>= _1n;
                k2 >>= _1n;
            }
            if (k1neg)
                k1p = k1p.negate();
            if (k2neg)
                k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        };
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */
        Point.prototype.multiply = function (scalar) {
            assertGE(scalar);
            var n = scalar;
            var point, fake; // Fake point is used to const-time mult
            var endo = CURVE.endo;
            if (endo) {
                var _a = endo.splitScalar(n), k1neg = _a.k1neg, k1 = _a.k1, k2neg = _a.k2neg, k2 = _a.k2;
                var _b = this.wNAF(k1), k1p = _b.p, f1p = _b.f;
                var _d = this.wNAF(k2), k2p = _d.p, f2p = _d.f;
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            }
            else {
                var _e = this.wNAF(n), p = _e.p, f = _e.f;
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([point, fake])[0];
        };
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */
        Point.prototype.multiplyAndAddUnsafe = function (Q, a, b) {
            var G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            var mul = function (P, a // Select faster multiply() method
            ) { return (a === _0n || a === _1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a)); };
            var sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        };
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        Point.prototype.toAffine = function (iz) {
            var _a = this, x = _a.px, y = _a.py, z = _a.pz;
            var is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null)
                iz = is0 ? Fp.ONE : Fp.inv(z);
            var ax = Fp.mul(x, iz);
            var ay = Fp.mul(y, iz);
            var zz = Fp.mul(z, iz);
            if (is0)
                return { x: Fp.ZERO, y: Fp.ZERO };
            if (!Fp.eql(zz, Fp.ONE))
                throw new Error('invZ was invalid');
            return { x: ax, y: ay };
        };
        Point.prototype.isTorsionFree = function () {
            var cofactor = CURVE.h, isTorsionFree = CURVE.isTorsionFree;
            if (cofactor === _1n)
                return true; // No subgroups, always torsion-free
            if (isTorsionFree)
                return isTorsionFree(Point, this);
            throw new Error('isTorsionFree() has not been declared for the elliptic curve');
        };
        Point.prototype.clearCofactor = function () {
            var cofactor = CURVE.h, clearCofactor = CURVE.clearCofactor;
            if (cofactor === _1n)
                return this; // Fast-path
            if (clearCofactor)
                return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        };
        Point.prototype.toRawBytes = function (isCompressed) {
            if (isCompressed === void 0) { isCompressed = true; }
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        };
        Point.prototype.toHex = function (isCompressed) {
            if (isCompressed === void 0) { isCompressed = true; }
            return ut.bytesToHex(this.toRawBytes(isCompressed));
        };
        Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
        Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
        return Point;
    }());
    var _bits = CURVE.nBitLength;
    var wnaf = (0, curve_1.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder,
    };
}
exports.weierstrassPoints = weierstrassPoints;
function validateOpts(curve) {
    var opts = (0, curve_1.validateBasic)(curve);
    ut.validateObject(opts, {
        hash: 'hash',
        hmac: 'function',
        randomBytes: 'function',
    }, {
        bits2int: 'function',
        bits2int_modN: 'function',
        lowS: 'boolean',
    });
    return Object.freeze(__assign({ lowS: true }, opts));
}
function weierstrass(curveDef) {
    var CURVE = validateOpts(curveDef);
    var Fp = CURVE.Fp, CURVE_ORDER = CURVE.n;
    var compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    var uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return _0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return mod.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return mod.invert(a, CURVE_ORDER);
    }
    var _a = weierstrassPoints(__assign(__assign({}, CURVE), { toBytes: function (_c, point, isCompressed) {
            var a = point.toAffine();
            var x = Fp.toBytes(a.x);
            var cat = ut.concatBytes;
            if (isCompressed) {
                return cat(Uint8Array.from([point.hasEvenY() ? 0x02 : 0x03]), x);
            }
            else {
                return cat(Uint8Array.from([0x04]), x, Fp.toBytes(a.y));
            }
        }, fromBytes: function (bytes) {
            var len = bytes.length;
            var head = bytes[0];
            var tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                var x = ut.bytesToNumberBE(tail);
                if (!isValidFieldElement(x))
                    throw new Error('Point is not on curve');
                var y2 = weierstrassEquation(x); // y² = x³ + ax + b
                var y = void 0;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                }
                catch (sqrtError) {
                    var suffix = sqrtError instanceof Error ? ': ' + sqrtError.message : '';
                    throw new Error('Point is not on curve' + suffix);
                }
                var isYOdd = (y & _1n) === _1n;
                // ECDSA
                var isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd)
                    y = Fp.neg(y);
                return { x: x, y: y };
            }
            else if (len === uncompressedLen && head === 0x04) {
                var x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                var y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return { x: x, y: y };
            }
            else {
                throw new Error("Point of length ".concat(len, " was invalid. Expected ").concat(compressedLen, " compressed bytes or ").concat(uncompressedLen, " uncompressed bytes"));
            }
        } })), Point = _a.ProjectivePoint, normPrivateKeyToScalar = _a.normPrivateKeyToScalar, weierstrassEquation = _a.weierstrassEquation, isWithinCurveOrder = _a.isWithinCurveOrder;
    var numToNByteStr = function (num) {
        return ut.bytesToHex(ut.numberToBytesBE(num, CURVE.nByteLength));
    };
    function isBiggerThanHalfOrder(number) {
        var HALF = CURVE_ORDER >> _1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    var slcNum = function (b, from, to) { return ut.bytesToNumberBE(b.slice(from, to)); };
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */
    var Signature = /** @class */ (function () {
        function Signature(r, s, recovery) {
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        Signature.fromCompact = function (hex) {
            var l = CURVE.nByteLength;
            hex = (0, utils_1.ensureBytes)('compactSignature', hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        };
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        Signature.fromDER = function (hex) {
            var _a = exports.DER.toSig((0, utils_1.ensureBytes)('DER', hex)), r = _a.r, s = _a.s;
            return new Signature(r, s);
        };
        Signature.prototype.assertValidity = function () {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r))
                throw new Error('r must be 0 < r < CURVE.n');
            if (!isWithinCurveOrder(this.s))
                throw new Error('s must be 0 < s < CURVE.n');
        };
        Signature.prototype.addRecoveryBit = function (recovery) {
            return new Signature(this.r, this.s, recovery);
        };
        Signature.prototype.recoverPublicKey = function (msgHash) {
            var _a = this, r = _a.r, s = _a.s, rec = _a.recovery;
            var h = bits2int_modN((0, utils_1.ensureBytes)('msgHash', msgHash)); // Truncate hash
            if (rec == null || ![0, 1, 2, 3].includes(rec))
                throw new Error('recovery id invalid');
            var radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER)
                throw new Error('recovery id 2 or 3 invalid');
            var prefix = (rec & 1) === 0 ? '02' : '03';
            var R = Point.fromHex(prefix + numToNByteStr(radj));
            var ir = invN(radj); // r^-1
            var u1 = modN(-h * ir); // -hr^-1
            var u2 = modN(s * ir); // sr^-1
            var Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q)
                throw new Error('point at infinify'); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        };
        // Signatures should be low-s, to prevent malleability.
        Signature.prototype.hasHighS = function () {
            return isBiggerThanHalfOrder(this.s);
        };
        Signature.prototype.normalizeS = function () {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        };
        // DER-encoded
        Signature.prototype.toDERRawBytes = function () {
            return ut.hexToBytes(this.toDERHex());
        };
        Signature.prototype.toDERHex = function () {
            return exports.DER.hexFromSig({ r: this.r, s: this.s });
        };
        // padded bytes of r, then padded bytes of s
        Signature.prototype.toCompactRawBytes = function () {
            return ut.hexToBytes(this.toCompactHex());
        };
        Signature.prototype.toCompactHex = function () {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        };
        return Signature;
    }());
    var utils = {
        isValidPrivateKey: function (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            }
            catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */
        randomPrivateKey: function () {
            var length = mod.getMinHashLength(CURVE.n);
            return mod.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */
        precompute: function (windowSize, point) {
            if (windowSize === void 0) { windowSize = 8; }
            if (point === void 0) { point = Point.BASE; }
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        },
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */
    function getPublicKey(privateKey, isCompressed) {
        if (isCompressed === void 0) { isCompressed = true; }
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */
    function isProbPub(item) {
        var arr = ut.isBytes(item);
        var str = typeof item === 'string';
        var len = (arr || str) && item.length;
        if (arr)
            return len === compressedLen || len === uncompressedLen;
        if (str)
            return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point)
            return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */
    function getSharedSecret(privateA, publicB, isCompressed) {
        if (isCompressed === void 0) { isCompressed = true; }
        if (isProbPub(privateA))
            throw new Error('first arg must be private key');
        if (!isProbPub(publicB))
            throw new Error('second arg must be public key');
        var b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    var bits2int = CURVE.bits2int ||
        function (bytes) {
            // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
            // for some cases, since bytes.length * 8 is not actual bitLength.
            var num = ut.bytesToNumberBE(bytes); // check for == u8 done here
            var delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
            return delta > 0 ? num >> BigInt(delta) : num;
        };
    var bits2int_modN = CURVE.bits2int_modN ||
        function (bytes) {
            return modN(bits2int(bytes)); // can't use bytesToNumberBE here
        };
    // NOTE: pads output with zero as per spec
    var ORDER_MASK = ut.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */
    function int2octets(num) {
        if (typeof num !== 'bigint')
            throw new Error('bigint expected');
        if (!(_0n <= num && num < ORDER_MASK))
            throw new Error("bigint expected < 2^".concat(CURVE.nBitLength));
        // works with order, can have different size than numToField!
        return ut.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts) {
        if (opts === void 0) { opts = defaultSigOpts; }
        if (['recovered', 'canonical'].some(function (k) { return k in opts; }))
            throw new Error('sign() legacy options not supported');
        var hash = CURVE.hash, randomBytes = CURVE.randomBytes;
        var lowS = opts.lowS, prehash = opts.prehash, ent = opts.extraEntropy; // generates low-s sigs by default
        if (lowS == null)
            lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, utils_1.ensureBytes)('msgHash', msgHash);
        if (prehash)
            msgHash = (0, utils_1.ensureBytes)('prehashed msgHash', hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        var h1int = bits2int_modN(msgHash);
        var d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        var seedArgs = [int2octets(d), int2octets(h1int)];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            var e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, utils_1.ensureBytes)('extraEntropy', e)); // check for being bytes
        }
        var seed = ut.concatBytes.apply(ut, __spreadArray([], __read(seedArgs), false)); // Step D of RFC6979 3.2
        var m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            var k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k))
                return; // Important: all mod() calls here must be done over N
            var ik = invN(k); // k^-1 mod n
            var q = Point.BASE.multiply(k).toAffine(); // q = Gk
            var r = modN(q.x); // r = q.x mod n
            if (r === _0n)
                return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            var s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === _0n)
                return;
            var recovery = (q.x === r ? 0 : 2) | Number(q.y & _1n); // recovery bit (2 or 3, when q.x > n)
            var normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return { seed: seed, k2sig: k2sig };
    }
    var defaultSigOpts = { lowS: CURVE.lowS, prehash: false };
    var defaultVerOpts = { lowS: CURVE.lowS, prehash: false };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */
    function sign(msgHash, privKey, opts) {
        if (opts === void 0) { opts = defaultSigOpts; }
        var _a = prepSig(msgHash, privKey, opts), seed = _a.seed, k2sig = _a.k2sig; // Steps A, D of RFC6979 3.2.
        var C = CURVE;
        var drbg = ut.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */
    function verify(signature, msgHash, publicKey, opts) {
        var _a;
        if (opts === void 0) { opts = defaultVerOpts; }
        var sg = signature;
        msgHash = (0, utils_1.ensureBytes)('msgHash', msgHash);
        publicKey = (0, utils_1.ensureBytes)('publicKey', publicKey);
        if ('strict' in opts)
            throw new Error('options.strict was renamed to lowS');
        var lowS = opts.lowS, prehash = opts.prehash;
        var _sig = undefined;
        var P;
        try {
            if (typeof sg === 'string' || ut.isBytes(sg)) {
                // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
                // Since DER can also be 2*nByteLength bytes, we check for it first.
                try {
                    _sig = Signature.fromDER(sg);
                }
                catch (derError) {
                    if (!(derError instanceof exports.DER.Err))
                        throw derError;
                    _sig = Signature.fromCompact(sg);
                }
            }
            else if (typeof sg === 'object' && typeof sg.r === 'bigint' && typeof sg.s === 'bigint') {
                var r_1 = sg.r, s_1 = sg.s;
                _sig = new Signature(r_1, s_1);
            }
            else {
                throw new Error('PARSE');
            }
            P = Point.fromHex(publicKey);
        }
        catch (error) {
            if (error.message === 'PARSE')
                throw new Error("signature must be Signature instance, Uint8Array or hex string");
            return false;
        }
        if (lowS && _sig.hasHighS())
            return false;
        if (prehash)
            msgHash = CURVE.hash(msgHash);
        var r = _sig.r, s = _sig.s;
        var h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        var is = invN(s); // s^-1
        var u1 = modN(h * is); // u1 = hs^-1 mod n
        var u2 = modN(r * is); // u2 = rs^-1 mod n
        var R = (_a = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)) === null || _a === void 0 ? void 0 : _a.toAffine(); // R = u1⋅G + u2⋅P
        if (!R)
            return false;
        var v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils,
    };
}
exports.weierstrass = weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */
function SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    var q = Fp.ORDER;
    var l = _0n;
    for (var o = q - _1n; o % _2n === _0n; o /= _2n)
        l += _1n;
    var c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    var _2n_pow_c1_1 = _2n << (c1 - _1n - _1n);
    var _2n_pow_c1 = _2n_pow_c1_1 * _2n;
    var c2 = (q - _1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    var c3 = (c2 - _1n) / _2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    var c4 = _2n_pow_c1 - _1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    var c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    var c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    var c7 = Fp.pow(Z, (c2 + _1n) / _2n); // 7. c7 = Z^((c2 + 1) / 2)
    var sqrtRatio = function (u, v) {
        var tv1 = c6; // 1. tv1 = c6
        var tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        var tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        var tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        var tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        var isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for (var i = c1; i > _1n; i--) {
            var tv5_1 = i - _2n; // 18.    tv5 = i - 2
            tv5_1 = _2n << (tv5_1 - _1n); // 19.    tv5 = 2^tv5
            var tvv5 = Fp.pow(tv4, tv5_1); // 20.    tv5 = tv4^tv5
            var e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return { isValid: isQR, value: tv3 };
    };
    if (Fp.ORDER % _4n === _3n) {
        // sqrt_ratio_3mod4(u, v)
        var c1_1 = (Fp.ORDER - _3n) / _4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        var c2_1 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = function (u, v) {
            var tv1 = Fp.sqr(v); // 1. tv1 = v^2
            var tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            var y1 = Fp.pow(tv1, c1_1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            var y2 = Fp.mul(y1, c2_1); // 6. y2 = y1 * c2
            var tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            var isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            var y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return { isValid: isQR, value: y }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
exports.SWUFpSqrtRatio = SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */
function mapToCurveSimpleSWU(Fp, opts) {
    mod.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z))
        throw new Error('mapToCurveSimpleSWU: invalid opts');
    var sqrtRatio = SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd)
        throw new Error('Fp.isOdd is not implemented!');
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return function (u) {
        // prettier-ignore
        var tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        var _a = sqrtRatio(tv2, tv6), isValid = _a.isValid, value = _a.value; // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        var e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return { x: x, y: y };
    };
}
exports.mapToCurveSimpleSWU = mapToCurveSimpleSWU;


/***/ }),

/***/ 69345:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-curves/blob/38a4ca1e6b0a80c60b11bbb6b3d71e3bfabd5bbb/src/bls12-381.ts#L1

it was modified and adapted to this repository

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bls12_381 = exports.G2_mapToCurve = exports.G1_mapToCurve = exports.G1_formBytes = exports.parseMask = exports.Fp12 = exports.Fp12_ONE = exports.Fp12_eql = exports.Fp12_conjugate = exports.Fp12_finalExponentiate = exports.Fp12Multiply = exports.Fp2 = exports.Fp = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// bls12-381 is pairing-friendly Barreto-Lynn-Scott elliptic curve construction allowing to:
// - Construct zk-SNARKs at the 120-bit security
// - Efficiently verify N aggregate signatures with 1 pairing and N ec additions:
//   the Boneh-Lynn-Shacham signature scheme is orders of magnitude more efficient than Schnorr
//
// ### Summary
// 1. BLS Relies on Bilinear Pairing (expensive)
// 2. Private Keys: 32 bytes
// 3. Public Keys: 48 bytes: 381 bit affine x coordinate, encoded into 48 big-endian bytes.
// 4. Signatures: 96 bytes: two 381 bit integers (affine x coordinate), encoded into two 48 big-endian byte arrays.
//     - The signature is a point on the G2 subgroup, which is defined over a finite field
//     with elements twice as big as the G1 curve (G2 is over Fp2 rather than Fp. Fp2 is analogous to the complex numbers).
// 5. The 12 stands for the Embedding degree.
//
// ### Formulas
// - `P = pk x G` - public keys
// - `S = pk x H(m)` - signing
// - `e(P, H(m)) == e(G, S)` - verification using pairings
// - `e(G, S) = e(G, SUM(n)(Si)) = MUL(n)(e(G, Si))` - signature aggregation
//
// ### Compatibility and notes
// 1. It is compatible with Algorand, Chia, Dfinity, Ethereum, Filecoin, ZEC
//    Filecoin uses little endian byte arrays for private keys - make sure to reverse byte order.
// 2. Some projects use G2 for public keys and G1 for signatures. It's called "short signature"
// 3. Curve security level is about 120 bits as per Barbulescu-Duquesne 2017
//    https://hal.science/hal-01534101/file/main.pdf
// 4. Compatible with specs:
// [cfrg-pairing-friendly-curves-11](https://tools.ietf.org/html/draft-irtf-cfrg-pairing-friendly-curves-11),
// [cfrg-bls-signature-05](https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-bls-signature-05),
// [RFC 9380](https://www.rfc-editor.org/rfc/rfc9380).
var bls_1 = __webpack_require__(98033);
var mod = __importStar(__webpack_require__(83827));
var utils_1 = __webpack_require__(52993);
// Types
var weierstrass_1 = __webpack_require__(31637);
var hash_to_curve_1 = __webpack_require__(41721);
var sha256_1 = __webpack_require__(68748);
var utils_2 = __webpack_require__(88627);
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
var _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3), _4n = BigInt(4);
// prettier-ignore
var _8n = BigInt(8), _16n = BigInt(16);
// CURVE FIELDS
// Finite field over p.
var Fp_raw = BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab');
exports.Fp = mod.Field(Fp_raw);
// Finite field over r.
// This particular field is not used anywhere in bls12-381, but it is still useful.
var Fr = mod.Field(BigInt('0x73eda753299d7d483339d80809a1d80553bda402fffe5bfeffffffff00000001'));
var Fp2Add = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1;
    var r0 = _b.c0, r1 = _b.c1;
    return ({
        c0: exports.Fp.add(c0, r0),
        c1: exports.Fp.add(c1, r1),
    });
};
var Fp2Subtract = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1;
    var r0 = _b.c0, r1 = _b.c1;
    return ({
        c0: exports.Fp.sub(c0, r0),
        c1: exports.Fp.sub(c1, r1),
    });
};
var Fp2Multiply = function (_a, rhs) {
    var c0 = _a.c0, c1 = _a.c1;
    if (typeof rhs === 'bigint')
        return { c0: exports.Fp.mul(c0, rhs), c1: exports.Fp.mul(c1, rhs) };
    // (a+bi)(c+di) = (ac−bd) + (ad+bc)i
    var r0 = rhs.c0, r1 = rhs.c1;
    var t1 = exports.Fp.mul(c0, r0); // c0 * o0
    var t2 = exports.Fp.mul(c1, r1); // c1 * o1
    // (T1 - T2) + ((c0 + c1) * (r0 + r1) - (T1 + T2))*i
    var o0 = exports.Fp.sub(t1, t2);
    var o1 = exports.Fp.sub(exports.Fp.mul(exports.Fp.add(c0, c1), exports.Fp.add(r0, r1)), exports.Fp.add(t1, t2));
    return { c0: o0, c1: o1 };
};
var Fp2Square = function (_a) {
    var c0 = _a.c0, c1 = _a.c1;
    var a = exports.Fp.add(c0, c1);
    var b = exports.Fp.sub(c0, c1);
    var c = exports.Fp.add(c0, c0);
    return { c0: exports.Fp.mul(a, b), c1: exports.Fp.mul(c, c1) };
};
// G2 is the order-q subgroup of E2(Fp²) : y² = x³+4(1+√−1),
// where Fp2 is Fp[√−1]/(x2+1). #E2(Fp2 ) = h2q, where
// G² - 1
// h2q
// NOTE: ORDER was wrong!
var FP2_ORDER = Fp_raw * Fp_raw;
exports.Fp2 = {
    ORDER: FP2_ORDER,
    BITS: (0, utils_1.bitLen)(FP2_ORDER),
    BYTES: Math.ceil((0, utils_1.bitLen)(FP2_ORDER) / 8),
    MASK: (0, utils_1.bitMask)((0, utils_1.bitLen)(FP2_ORDER)),
    ZERO: { c0: exports.Fp.ZERO, c1: exports.Fp.ZERO },
    ONE: { c0: exports.Fp.ONE, c1: exports.Fp.ZERO },
    create: function (num) { return num; },
    isValid: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return typeof c0 === 'bigint' && typeof c1 === 'bigint';
    },
    is0: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return exports.Fp.is0(c0) && exports.Fp.is0(c1);
    },
    eql: function (_a, _b) {
        var c0 = _a.c0, c1 = _a.c1;
        var r0 = _b.c0, r1 = _b.c1;
        return exports.Fp.eql(c0, r0) && exports.Fp.eql(c1, r1);
    },
    neg: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return ({ c0: exports.Fp.neg(c0), c1: exports.Fp.neg(c1) });
    },
    pow: function (num, power) { return mod.FpPow(exports.Fp2, num, power); },
    invertBatch: function (nums) { return mod.FpInvertBatch(exports.Fp2, nums); },
    // Normalized
    add: Fp2Add,
    sub: Fp2Subtract,
    mul: Fp2Multiply,
    sqr: Fp2Square,
    // NonNormalized stuff
    addN: Fp2Add,
    subN: Fp2Subtract,
    mulN: Fp2Multiply,
    sqrN: Fp2Square,
    // Why inversion for bigint inside Fp instead of Fp2? it is even used in that context?
    div: function (lhs, rhs) { return exports.Fp2.mul(lhs, typeof rhs === 'bigint' ? exports.Fp.inv(exports.Fp.create(rhs)) : exports.Fp2.inv(rhs)); },
    inv: function (_a) {
        var a = _a.c0, b = _a.c1;
        // We wish to find the multiplicative inverse of a nonzero
        // element a + bu in Fp2. We leverage an identity
        //
        // (a + bu)(a - bu) = a² + b²
        //
        // which holds because u² = -1. This can be rewritten as
        //
        // (a + bu)(a - bu)/(a² + b²) = 1
        //
        // because a² + b² = 0 has no nonzero solutions for (a, b).
        // This gives that (a - bu)/(a² + b²) is the inverse
        // of (a + bu). Importantly, this can be computing using
        // only a single inversion in Fp.
        var factor = exports.Fp.inv(exports.Fp.create(a * a + b * b));
        return { c0: exports.Fp.mul(factor, exports.Fp.create(a)), c1: exports.Fp.mul(factor, exports.Fp.create(-b)) };
    },
    sqrt: function (num) {
        if (exports.Fp2.eql(num, exports.Fp2.ZERO))
            return exports.Fp2.ZERO; // Algo doesn't handles this case
        // TODO: Optimize this line. It's extremely slow.
        // Speeding this up would boost aggregateSignatures.
        // https://eprint.iacr.org/2012/685.pdf applicable?
        // https://github.com/zkcrypto/bls12_381/blob/080eaa74ec0e394377caa1ba302c8c121df08b07/src/fp2.rs#L250
        // https://github.com/supranational/blst/blob/aae0c7d70b799ac269ff5edf29d8191dbd357876/src/exp2.c#L1
        // Inspired by https://github.com/dalek-cryptography/curve25519-dalek/blob/17698df9d4c834204f83a3574143abacb4fc81a5/src/field.rs#L99
        var candidateSqrt = exports.Fp2.pow(num, (exports.Fp2.ORDER + _8n) / _16n);
        var check = exports.Fp2.div(exports.Fp2.sqr(candidateSqrt), num); // candidateSqrt.square().div(this);
        var R = FP2_ROOTS_OF_UNITY;
        var divisor = [R[0], R[2], R[4], R[6]].find(function (r) { return exports.Fp2.eql(r, check); });
        if (!divisor)
            throw new Error('No root');
        var index = R.indexOf(divisor);
        var root = R[index / 2];
        if (!root)
            throw new Error('Invalid root');
        var x1 = exports.Fp2.div(candidateSqrt, root);
        var x2 = exports.Fp2.neg(x1);
        var _a = exports.Fp2.reim(x1), re1 = _a.re, im1 = _a.im;
        var _b = exports.Fp2.reim(x2), re2 = _b.re, im2 = _b.im;
        if (im1 > im2 || (im1 === im2 && re1 > re2))
            return x1;
        return x2;
    },
    // Same as sgn0_m_eq_2 in RFC 9380
    isOdd: function (x) {
        var _a = exports.Fp2.reim(x), x0 = _a.re, x1 = _a.im;
        var sign_0 = x0 % _2n;
        var zero_0 = x0 === _0n;
        var sign_1 = x1 % _2n;
        return BigInt(sign_0 || (zero_0 && sign_1)) == _1n;
    },
    // Bytes util
    fromBytes: function (b) {
        if (b.length !== exports.Fp2.BYTES)
            throw new Error("fromBytes wrong length=".concat(b.length));
        return { c0: exports.Fp.fromBytes(b.subarray(0, exports.Fp.BYTES)), c1: exports.Fp.fromBytes(b.subarray(exports.Fp.BYTES)) };
    },
    toBytes: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return (0, utils_1.concatBytes)(exports.Fp.toBytes(c0), exports.Fp.toBytes(c1));
    },
    cmov: function (_a, _b, c) {
        var c0 = _a.c0, c1 = _a.c1;
        var r0 = _b.c0, r1 = _b.c1;
        return ({
            c0: exports.Fp.cmov(c0, r0, c),
            c1: exports.Fp.cmov(c1, r1, c),
        });
    },
    // Specific utils
    // toString() {
    //   return `Fp2(${this.c0} + ${this.c1}×i)`;
    // }
    reim: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return ({ re: c0, im: c1 });
    },
    // multiply by u + 1
    mulByNonresidue: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return ({ c0: exports.Fp.sub(c0, c1), c1: exports.Fp.add(c0, c1) });
    },
    multiplyByB: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        var t0 = exports.Fp.mul(c0, _4n); // 4 * c0
        var t1 = exports.Fp.mul(c1, _4n); // 4 * c1
        // (T0-T1) + (T0+T1)*i
        return { c0: exports.Fp.sub(t0, t1), c1: exports.Fp.add(t0, t1) };
    },
    fromBigTuple: function (tuple) {
        if (tuple.length !== 2)
            throw new Error('Invalid tuple');
        var fps = tuple.map(function (n) { return exports.Fp.create(n); });
        return { c0: fps[0], c1: fps[1] };
    },
    frobeniusMap: function (_a, power) {
        var c0 = _a.c0, c1 = _a.c1;
        return ({
            c0: c0,
            c1: exports.Fp.mul(c1, FP2_FROBENIUS_COEFFICIENTS[power % 2]),
        });
    },
};
// Finite extension field over irreducible polynominal.
// Fp(u) / (u² - β) where β = -1
var FP2_FROBENIUS_COEFFICIENTS = [
    BigInt('0x1'),
    BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaaa'),
].map(function (item) { return exports.Fp.create(item); });
// For Fp2 roots of unity.
var rv1 = BigInt('0x6af0e0437ff400b6831e36d6bd17ffe48395dabc2d3435e77f76e17009241c5ee67992f72ec05f4c81084fbede3cc09');
// const ev1 =
//   BigInt('0x699be3b8c6870965e5bf892ad5d2cc7b0e85a117402dfd83b7f4a947e02d978498255a2aaec0ac627b5afbdf1bf1c90');
// const ev2 =
//   BigInt('0x8157cd83046453f5dd0972b6e3949e4288020b5b8a9cc99ca07e27089a2ce2436d965026adad3ef7baba37f2183e9b5');
// const ev3 =
//   BigInt('0xab1c2ffdd6c253ca155231eb3e71ba044fd562f6f72bc5bad5ec46a0b7a3b0247cf08ce6c6317f40edbc653a72dee17');
// const ev4 =
//   BigInt('0xaa404866706722864480885d68ad0ccac1967c7544b447873cc37e0181271e006df72162a3d3e0287bf597fbf7f8fc1');
// Eighth roots of unity, used for computing square roots in Fp2.
// To verify or re-calculate:
// Array(8).fill(new Fp2([1n, 1n])).map((fp2, k) => fp2.pow(Fp2.ORDER * BigInt(k) / 8n))
var FP2_ROOTS_OF_UNITY = [
    [_1n, _0n],
    [rv1, -rv1],
    [_0n, _1n],
    [rv1, rv1],
    [-_1n, _0n],
    [-rv1, rv1],
    [_0n, -_1n],
    [-rv1, -rv1],
].map(function (pair) { return exports.Fp2.fromBigTuple(pair); });
var Fp6Add = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
    var r0 = _b.c0, r1 = _b.c1, r2 = _b.c2;
    return ({
        c0: exports.Fp2.add(c0, r0),
        c1: exports.Fp2.add(c1, r1),
        c2: exports.Fp2.add(c2, r2),
    });
};
var Fp6Subtract = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
    var r0 = _b.c0, r1 = _b.c1, r2 = _b.c2;
    return ({
        c0: exports.Fp2.sub(c0, r0),
        c1: exports.Fp2.sub(c1, r1),
        c2: exports.Fp2.sub(c2, r2),
    });
};
var Fp6Multiply = function (_a, rhs) {
    var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
    if (typeof rhs === 'bigint') {
        return {
            c0: exports.Fp2.mul(c0, rhs),
            c1: exports.Fp2.mul(c1, rhs),
            c2: exports.Fp2.mul(c2, rhs),
        };
    }
    var r0 = rhs.c0, r1 = rhs.c1, r2 = rhs.c2;
    var t0 = exports.Fp2.mul(c0, r0); // c0 * o0
    var t1 = exports.Fp2.mul(c1, r1); // c1 * o1
    var t2 = exports.Fp2.mul(c2, r2); // c2 * o2
    return {
        // t0 + (c1 + c2) * (r1 * r2) - (T1 + T2) * (u + 1)
        c0: exports.Fp2.add(t0, exports.Fp2.mulByNonresidue(exports.Fp2.sub(exports.Fp2.mul(exports.Fp2.add(c1, c2), exports.Fp2.add(r1, r2)), exports.Fp2.add(t1, t2)))),
        // (c0 + c1) * (r0 + r1) - (T0 + T1) + T2 * (u + 1)
        c1: exports.Fp2.add(exports.Fp2.sub(exports.Fp2.mul(exports.Fp2.add(c0, c1), exports.Fp2.add(r0, r1)), exports.Fp2.add(t0, t1)), exports.Fp2.mulByNonresidue(t2)),
        // T1 + (c0 + c2) * (r0 + r2) - T0 + T2
        c2: exports.Fp2.sub(exports.Fp2.add(t1, exports.Fp2.mul(exports.Fp2.add(c0, c2), exports.Fp2.add(r0, r2))), exports.Fp2.add(t0, t2)),
    };
};
var Fp6Square = function (_a) {
    var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
    var t0 = exports.Fp2.sqr(c0); // c0²
    var t1 = exports.Fp2.mul(exports.Fp2.mul(c0, c1), _2n); // 2 * c0 * c1
    var t3 = exports.Fp2.mul(exports.Fp2.mul(c1, c2), _2n); // 2 * c1 * c2
    var t4 = exports.Fp2.sqr(c2); // c2²
    return {
        c0: exports.Fp2.add(exports.Fp2.mulByNonresidue(t3), t0),
        c1: exports.Fp2.add(exports.Fp2.mulByNonresidue(t4), t1),
        // T1 + (c0 - c1 + c2)² + T3 - T0 - T4
        c2: exports.Fp2.sub(exports.Fp2.sub(exports.Fp2.add(exports.Fp2.add(t1, exports.Fp2.sqr(exports.Fp2.add(exports.Fp2.sub(c0, c1), c2))), t3), t0), t4),
    };
};
var Fp6 = {
    ORDER: exports.Fp2.ORDER,
    BITS: 3 * exports.Fp2.BITS,
    BYTES: 3 * exports.Fp2.BYTES,
    MASK: (0, utils_1.bitMask)(3 * exports.Fp2.BITS),
    ZERO: { c0: exports.Fp2.ZERO, c1: exports.Fp2.ZERO, c2: exports.Fp2.ZERO },
    ONE: { c0: exports.Fp2.ONE, c1: exports.Fp2.ZERO, c2: exports.Fp2.ZERO },
    create: function (num) { return num; },
    isValid: function (_a) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return exports.Fp2.isValid(c0) && exports.Fp2.isValid(c1) && exports.Fp2.isValid(c2);
    },
    is0: function (_a) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return exports.Fp2.is0(c0) && exports.Fp2.is0(c1) && exports.Fp2.is0(c2);
    },
    neg: function (_a) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return ({ c0: exports.Fp2.neg(c0), c1: exports.Fp2.neg(c1), c2: exports.Fp2.neg(c2) });
    },
    eql: function (_a, _b) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        var r0 = _b.c0, r1 = _b.c1, r2 = _b.c2;
        return exports.Fp2.eql(c0, r0) && exports.Fp2.eql(c1, r1) && exports.Fp2.eql(c2, r2);
    },
    sqrt: function () {
        throw new Error('Not implemented');
    },
    // Do we need division by bigint at all? Should be done via order:
    div: function (lhs, rhs) { return Fp6.mul(lhs, typeof rhs === 'bigint' ? exports.Fp.inv(exports.Fp.create(rhs)) : Fp6.inv(rhs)); },
    pow: function (num, power) { return mod.FpPow(Fp6, num, power); },
    invertBatch: function (nums) { return mod.FpInvertBatch(Fp6, nums); },
    // Normalized
    add: Fp6Add,
    sub: Fp6Subtract,
    mul: Fp6Multiply,
    sqr: Fp6Square,
    // NonNormalized stuff
    addN: Fp6Add,
    subN: Fp6Subtract,
    mulN: Fp6Multiply,
    sqrN: Fp6Square,
    inv: function (_a) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        var t0 = exports.Fp2.sub(exports.Fp2.sqr(c0), exports.Fp2.mulByNonresidue(exports.Fp2.mul(c2, c1))); // c0² - c2 * c1 * (u + 1)
        var t1 = exports.Fp2.sub(exports.Fp2.mulByNonresidue(exports.Fp2.sqr(c2)), exports.Fp2.mul(c0, c1)); // c2² * (u + 1) - c0 * c1
        var t2 = exports.Fp2.sub(exports.Fp2.sqr(c1), exports.Fp2.mul(c0, c2)); // c1² - c0 * c2
        // 1/(((c2 * T1 + c1 * T2) * v) + c0 * T0)
        var t4 = exports.Fp2.inv(exports.Fp2.add(exports.Fp2.mulByNonresidue(exports.Fp2.add(exports.Fp2.mul(c2, t1), exports.Fp2.mul(c1, t2))), exports.Fp2.mul(c0, t0)));
        return { c0: exports.Fp2.mul(t4, t0), c1: exports.Fp2.mul(t4, t1), c2: exports.Fp2.mul(t4, t2) };
    },
    // Bytes utils
    fromBytes: function (b) {
        if (b.length !== Fp6.BYTES)
            throw new Error("fromBytes wrong length=".concat(b.length));
        return {
            c0: exports.Fp2.fromBytes(b.subarray(0, exports.Fp2.BYTES)),
            c1: exports.Fp2.fromBytes(b.subarray(exports.Fp2.BYTES, 2 * exports.Fp2.BYTES)),
            c2: exports.Fp2.fromBytes(b.subarray(2 * exports.Fp2.BYTES)),
        };
    },
    toBytes: function (_a) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return (0, utils_1.concatBytes)(exports.Fp2.toBytes(c0), exports.Fp2.toBytes(c1), exports.Fp2.toBytes(c2));
    },
    cmov: function (_a, _b, c) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        var r0 = _b.c0, r1 = _b.c1, r2 = _b.c2;
        return ({
            c0: exports.Fp2.cmov(c0, r0, c),
            c1: exports.Fp2.cmov(c1, r1, c),
            c2: exports.Fp2.cmov(c2, r2, c),
        });
    },
    // Utils
    //   fromTriple(triple: [Fp2, Fp2, Fp2]) {
    //     return new Fp6(...triple);
    //   }
    //   toString() {
    //     return `Fp6(${this.c0} + ${this.c1} * v, ${this.c2} * v^2)`;
    //   }
    fromBigSix: function (t) {
        if (!Array.isArray(t) || t.length !== 6)
            throw new Error('Invalid Fp6 usage');
        return {
            c0: exports.Fp2.fromBigTuple(t.slice(0, 2)),
            c1: exports.Fp2.fromBigTuple(t.slice(2, 4)),
            c2: exports.Fp2.fromBigTuple(t.slice(4, 6)),
        };
    },
    frobeniusMap: function (_a, power) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return ({
            c0: exports.Fp2.frobeniusMap(c0, power),
            c1: exports.Fp2.mul(exports.Fp2.frobeniusMap(c1, power), FP6_FROBENIUS_COEFFICIENTS_1[power % 6]),
            c2: exports.Fp2.mul(exports.Fp2.frobeniusMap(c2, power), FP6_FROBENIUS_COEFFICIENTS_2[power % 6]),
        });
    },
    mulByNonresidue: function (_a) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return ({ c0: exports.Fp2.mulByNonresidue(c2), c1: c0, c2: c1 });
    },
    // Sparse multiplication
    multiplyBy1: function (_a, b1) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return ({
            c0: exports.Fp2.mulByNonresidue(exports.Fp2.mul(c2, b1)),
            c1: exports.Fp2.mul(c0, b1),
            c2: exports.Fp2.mul(c1, b1),
        });
    },
    // Sparse multiplication
    multiplyBy01: function (_a, b0, b1) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        var t0 = exports.Fp2.mul(c0, b0); // c0 * b0
        var t1 = exports.Fp2.mul(c1, b1); // c1 * b1
        return {
            // ((c1 + c2) * b1 - T1) * (u + 1) + T0
            c0: exports.Fp2.add(exports.Fp2.mulByNonresidue(exports.Fp2.sub(exports.Fp2.mul(exports.Fp2.add(c1, c2), b1), t1)), t0),
            // (b0 + b1) * (c0 + c1) - T0 - T1
            c1: exports.Fp2.sub(exports.Fp2.sub(exports.Fp2.mul(exports.Fp2.add(b0, b1), exports.Fp2.add(c0, c1)), t0), t1),
            // (c0 + c2) * b0 - T0 + T1
            c2: exports.Fp2.add(exports.Fp2.sub(exports.Fp2.mul(exports.Fp2.add(c0, c2), b0), t0), t1),
        };
    },
    multiplyByFp2: function (_a, rhs) {
        var c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        return ({
            c0: exports.Fp2.mul(c0, rhs),
            c1: exports.Fp2.mul(c1, rhs),
            c2: exports.Fp2.mul(c2, rhs),
        });
    },
};
var FP6_FROBENIUS_COEFFICIENTS_1 = [
    [BigInt('0x1'), BigInt('0x0')],
    [
        BigInt('0x0'),
        BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac'),
    ],
    [
        BigInt('0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe'),
        BigInt('0x0'),
    ],
    [BigInt('0x0'), BigInt('0x1')],
    [
        BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x0'),
        BigInt('0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe'),
    ],
].map(function (pair) { return exports.Fp2.fromBigTuple(pair); });
var FP6_FROBENIUS_COEFFICIENTS_2 = [
    [BigInt('0x1'), BigInt('0x0')],
    [
        BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaad'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaaa'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffeffff'),
        BigInt('0x0'),
    ],
].map(function (pair) { return exports.Fp2.fromBigTuple(pair); });
// The BLS parameter x for BLS12-381
var BLS_X = BigInt('0xd201000000010000');
var BLS_X_LEN = (0, utils_1.bitLen)(BLS_X);
var Fp12Add = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1;
    var r0 = _b.c0, r1 = _b.c1;
    return ({
        c0: Fp6.add(c0, r0),
        c1: Fp6.add(c1, r1),
    });
};
var Fp12Subtract = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1;
    var r0 = _b.c0, r1 = _b.c1;
    return ({
        c0: Fp6.sub(c0, r0),
        c1: Fp6.sub(c1, r1),
    });
};
var Fp12Multiply = function (_a, rhs) {
    var c0 = _a.c0, c1 = _a.c1;
    if (typeof rhs === 'bigint')
        return { c0: Fp6.mul(c0, rhs), c1: Fp6.mul(c1, rhs) };
    var r0 = rhs.c0, r1 = rhs.c1;
    var t1 = Fp6.mul(c0, r0); // c0 * r0
    var t2 = Fp6.mul(c1, r1); // c1 * r1
    return {
        c0: Fp6.add(t1, Fp6.mulByNonresidue(t2)),
        // (c0 + c1) * (r0 + r1) - (T1 + T2)
        c1: Fp6.sub(Fp6.mul(Fp6.add(c0, c1), Fp6.add(r0, r1)), Fp6.add(t1, t2)),
    };
};
exports.Fp12Multiply = Fp12Multiply;
var Fp12Square = function (_a) {
    var c0 = _a.c0, c1 = _a.c1;
    var ab = Fp6.mul(c0, c1); // c0 * c1
    return {
        // (c1 * v + c0) * (c0 + c1) - AB - AB * v
        c0: Fp6.sub(Fp6.sub(Fp6.mul(Fp6.add(Fp6.mulByNonresidue(c1), c0), Fp6.add(c0, c1)), ab), Fp6.mulByNonresidue(ab)),
        c1: Fp6.add(ab, ab),
    }; // AB + AB
};
function Fp4Square(a, b) {
    var a2 = exports.Fp2.sqr(a);
    var b2 = exports.Fp2.sqr(b);
    return {
        first: exports.Fp2.add(exports.Fp2.mulByNonresidue(b2), a2),
        second: exports.Fp2.sub(exports.Fp2.sub(exports.Fp2.sqr(exports.Fp2.add(a, b)), a2), b2), // (a + b)² - a² - b²
    };
}
var Fp12_finalExponentiate = function (num) {
    var x = BLS_X;
    // this^(q⁶) / this
    var t0 = exports.Fp12.div(exports.Fp12.frobeniusMap(num, 6), num);
    // t0^(q²) * t0
    var t1 = exports.Fp12.mul(exports.Fp12.frobeniusMap(t0, 2), t0);
    var t2 = exports.Fp12.conjugate(exports.Fp12._cyclotomicExp(t1, x));
    var t3 = exports.Fp12.mul(exports.Fp12.conjugate(exports.Fp12._cyclotomicSquare(t1)), t2);
    var t4 = exports.Fp12.conjugate(exports.Fp12._cyclotomicExp(t3, x));
    var t5 = exports.Fp12.conjugate(exports.Fp12._cyclotomicExp(t4, x));
    var t6 = exports.Fp12.mul(exports.Fp12.conjugate(exports.Fp12._cyclotomicExp(t5, x)), exports.Fp12._cyclotomicSquare(t2));
    var t7 = exports.Fp12.conjugate(exports.Fp12._cyclotomicExp(t6, x));
    var t2_t5_pow_q2 = exports.Fp12.frobeniusMap(exports.Fp12.mul(t2, t5), 2);
    var t4_t1_pow_q3 = exports.Fp12.frobeniusMap(exports.Fp12.mul(t4, t1), 3);
    var t6_t1c_pow_q1 = exports.Fp12.frobeniusMap(exports.Fp12.mul(t6, exports.Fp12.conjugate(t1)), 1);
    var t7_t3c_t1 = exports.Fp12.mul(exports.Fp12.mul(t7, exports.Fp12.conjugate(t3)), t1);
    // (t2 * t5)^(q²) * (t4 * t1)^(q³) * (t6 * t1.conj)^(q^1) * t7 * t3.conj * t1
    return exports.Fp12.mul(exports.Fp12.mul(exports.Fp12.mul(t2_t5_pow_q2, t4_t1_pow_q3), t6_t1c_pow_q1), t7_t3c_t1);
};
exports.Fp12_finalExponentiate = Fp12_finalExponentiate;
var Fp12_conjugate = function (_a) {
    var c0 = _a.c0, c1 = _a.c1;
    return ({ c0: c0, c1: Fp6.neg(c1) });
};
exports.Fp12_conjugate = Fp12_conjugate;
var Fp12_eql = function (_a, _b) {
    var c0 = _a.c0, c1 = _a.c1;
    var r0 = _b.c0, r1 = _b.c1;
    return Fp6.eql(c0, r0) && Fp6.eql(c1, r1);
};
exports.Fp12_eql = Fp12_eql;
exports.Fp12_ONE = { c0: Fp6.ONE, c1: Fp6.ZERO };
exports.Fp12 = {
    ORDER: exports.Fp2.ORDER,
    BITS: 2 * exports.Fp2.BITS,
    BYTES: 2 * exports.Fp2.BYTES,
    MASK: (0, utils_1.bitMask)(2 * exports.Fp2.BITS),
    ZERO: { c0: Fp6.ZERO, c1: Fp6.ZERO },
    ONE: { c0: Fp6.ONE, c1: Fp6.ZERO },
    create: function (num) { return num; },
    isValid: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return Fp6.isValid(c0) && Fp6.isValid(c1);
    },
    is0: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return Fp6.is0(c0) && Fp6.is0(c1);
    },
    neg: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return ({ c0: Fp6.neg(c0), c1: Fp6.neg(c1) });
    },
    eql: exports.Fp12_eql,
    sqrt: function () {
        throw new Error('Not implemented');
    },
    inv: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        var t = Fp6.inv(Fp6.sub(Fp6.sqr(c0), Fp6.mulByNonresidue(Fp6.sqr(c1)))); // 1 / (c0² - c1² * v)
        return { c0: Fp6.mul(c0, t), c1: Fp6.neg(Fp6.mul(c1, t)) }; // ((C0 * T) * T) + (-C1 * T) * w
    },
    div: function (lhs, rhs) {
        return exports.Fp12.mul(lhs, typeof rhs === 'bigint' ? exports.Fp.inv(exports.Fp.create(rhs)) : exports.Fp12.inv(rhs));
    },
    pow: function (num, power) { return mod.FpPow(exports.Fp12, num, power); },
    invertBatch: function (nums) { return mod.FpInvertBatch(exports.Fp12, nums); },
    // Normalized
    add: Fp12Add,
    sub: Fp12Subtract,
    mul: exports.Fp12Multiply,
    sqr: Fp12Square,
    // NonNormalized stuff
    addN: Fp12Add,
    subN: Fp12Subtract,
    mulN: exports.Fp12Multiply,
    sqrN: Fp12Square,
    // Bytes utils
    fromBytes: function (b) {
        if (b.length !== exports.Fp12.BYTES)
            throw new Error("fromBytes wrong length=".concat(b.length));
        return {
            c0: Fp6.fromBytes(b.subarray(0, Fp6.BYTES)),
            c1: Fp6.fromBytes(b.subarray(Fp6.BYTES)),
        };
    },
    toBytes: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        return (0, utils_1.concatBytes)(Fp6.toBytes(c0), Fp6.toBytes(c1));
    },
    cmov: function (_a, _b, c) {
        var c0 = _a.c0, c1 = _a.c1;
        var r0 = _b.c0, r1 = _b.c1;
        return ({
            c0: Fp6.cmov(c0, r0, c),
            c1: Fp6.cmov(c1, r1, c),
        });
    },
    // Utils
    // toString() {
    //   return `Fp12(${this.c0} + ${this.c1} * w)`;
    // },
    // fromTuple(c: [Fp6, Fp6]) {
    //   return new Fp12(...c);
    // }
    fromBigTwelve: function (t) { return ({
        c0: Fp6.fromBigSix(t.slice(0, 6)),
        c1: Fp6.fromBigSix(t.slice(6, 12)),
    }); },
    // Raises to q**i -th power
    frobeniusMap: function (lhs, power) {
        var r0 = Fp6.frobeniusMap(lhs.c0, power);
        var _a = Fp6.frobeniusMap(lhs.c1, power), c0 = _a.c0, c1 = _a.c1, c2 = _a.c2;
        var coeff = FP12_FROBENIUS_COEFFICIENTS[power % 12];
        return {
            c0: r0,
            c1: Fp6.create({
                c0: exports.Fp2.mul(c0, coeff),
                c1: exports.Fp2.mul(c1, coeff),
                c2: exports.Fp2.mul(c2, coeff),
            }),
        };
    },
    // Sparse multiplication
    multiplyBy014: function (_a, o0, o1, o4) {
        var c0 = _a.c0, c1 = _a.c1;
        var t0 = Fp6.multiplyBy01(c0, o0, o1);
        var t1 = Fp6.multiplyBy1(c1, o4);
        return {
            c0: Fp6.add(Fp6.mulByNonresidue(t1), t0),
            // (c1 + c0) * [o0, o1+o4] - T0 - T1
            c1: Fp6.sub(Fp6.sub(Fp6.multiplyBy01(Fp6.add(c1, c0), o0, exports.Fp2.add(o1, o4)), t0), t1),
        };
    },
    multiplyByFp2: function (_a, rhs) {
        var c0 = _a.c0, c1 = _a.c1;
        return ({
            c0: Fp6.multiplyByFp2(c0, rhs),
            c1: Fp6.multiplyByFp2(c1, rhs),
        });
    },
    conjugate: exports.Fp12_conjugate,
    // A cyclotomic group is a subgroup of Fp^n defined by
    //   GΦₙ(p) = {α ∈ Fpⁿ : α^Φₙ(p) = 1}
    // The result of any pairing is in a cyclotomic subgroup
    // https://eprint.iacr.org/2009/565.pdf
    _cyclotomicSquare: function (_a) {
        var c0 = _a.c0, c1 = _a.c1;
        var c0c0 = c0.c0, c0c1 = c0.c1, c0c2 = c0.c2;
        var c1c0 = c1.c0, c1c1 = c1.c1, c1c2 = c1.c2;
        var _b = Fp4Square(c0c0, c1c1), t3 = _b.first, t4 = _b.second;
        var _d = Fp4Square(c1c0, c0c2), t5 = _d.first, t6 = _d.second;
        var _e = Fp4Square(c0c1, c1c2), t7 = _e.first, t8 = _e.second;
        var t9 = exports.Fp2.mulByNonresidue(t8); // T8 * (u + 1)
        return {
            c0: Fp6.create({
                c0: exports.Fp2.add(exports.Fp2.mul(exports.Fp2.sub(t3, c0c0), _2n), t3),
                c1: exports.Fp2.add(exports.Fp2.mul(exports.Fp2.sub(t5, c0c1), _2n), t5),
                c2: exports.Fp2.add(exports.Fp2.mul(exports.Fp2.sub(t7, c0c2), _2n), t7),
            }),
            c1: Fp6.create({
                c0: exports.Fp2.add(exports.Fp2.mul(exports.Fp2.add(t9, c1c0), _2n), t9),
                c1: exports.Fp2.add(exports.Fp2.mul(exports.Fp2.add(t4, c1c1), _2n), t4),
                c2: exports.Fp2.add(exports.Fp2.mul(exports.Fp2.add(t6, c1c2), _2n), t6),
            }),
        }; // 2 * (T6 + c1c2) + T6
    },
    _cyclotomicExp: function (num, n) {
        var z = exports.Fp12.ONE;
        for (var i = BLS_X_LEN - 1; i >= 0; i--) {
            z = exports.Fp12._cyclotomicSquare(z);
            if ((0, utils_1.bitGet)(n, i))
                z = exports.Fp12.mul(z, num);
        }
        return z;
    },
    // https://eprint.iacr.org/2010/354.pdf
    // https://eprint.iacr.org/2009/565.pdf
    finalExponentiate: exports.Fp12_finalExponentiate,
};
var FP12_FROBENIUS_COEFFICIENTS = [
    [BigInt('0x1'), BigInt('0x0')],
    [
        BigInt('0x1904d3bf02bb0667c231beb4202c0d1f0fd603fd3cbd5f4f7b2443d784bab9c4f67ea53d63e7813d8d0775ed92235fb8'),
        BigInt('0x00fc3e2b36c4e03288e9e902231f9fb854a14787b6c7b36fec0c8ec971f63c5f282d5ac14d6c7ec22cf78a126ddc4af3'),
    ],
    [
        BigInt('0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffeffff'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x135203e60180a68ee2e9c448d77a2cd91c3dedd930b1cf60ef396489f61eb45e304466cf3e67fa0af1ee7b04121bdea2'),
        BigInt('0x06af0e0437ff400b6831e36d6bd17ffe48395dabc2d3435e77f76e17009241c5ee67992f72ec05f4c81084fbede3cc09'),
    ],
    [
        BigInt('0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x144e4211384586c16bd3ad4afa99cc9170df3560e77982d0db45f3536814f0bd5871c1908bd478cd1ee605167ff82995'),
        BigInt('0x05b2cfd9013a5fd8df47fa6b48b1e045f39816240c0b8fee8beadf4d8e9c0566c63a3e6e257f87329b18fae980078116'),
    ],
    [
        BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaaa'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x00fc3e2b36c4e03288e9e902231f9fb854a14787b6c7b36fec0c8ec971f63c5f282d5ac14d6c7ec22cf78a126ddc4af3'),
        BigInt('0x1904d3bf02bb0667c231beb4202c0d1f0fd603fd3cbd5f4f7b2443d784bab9c4f67ea53d63e7813d8d0775ed92235fb8'),
    ],
    [
        BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x06af0e0437ff400b6831e36d6bd17ffe48395dabc2d3435e77f76e17009241c5ee67992f72ec05f4c81084fbede3cc09'),
        BigInt('0x135203e60180a68ee2e9c448d77a2cd91c3dedd930b1cf60ef396489f61eb45e304466cf3e67fa0af1ee7b04121bdea2'),
    ],
    [
        BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaad'),
        BigInt('0x0'),
    ],
    [
        BigInt('0x05b2cfd9013a5fd8df47fa6b48b1e045f39816240c0b8fee8beadf4d8e9c0566c63a3e6e257f87329b18fae980078116'),
        BigInt('0x144e4211384586c16bd3ad4afa99cc9170df3560e77982d0db45f3536814f0bd5871c1908bd478cd1ee605167ff82995'),
    ],
].map(function (n) { return exports.Fp2.fromBigTuple(n); });
// END OF CURVE FIELDS
// HashToCurve
// 3-isogeny map from E' to E https://www.rfc-editor.org/rfc/rfc9380#appendix-E.3
var isogenyMapG2 = (0, hash_to_curve_1.isogenyMap)(exports.Fp2, [
    // xNum
    [
        [
            '0x5c759507e8e333ebb5b7a9a47d7ed8532c52d39fd3a042a88b58423c50ae15d5c2638e343d9c71c6238aaaaaaaa97d6',
            '0x5c759507e8e333ebb5b7a9a47d7ed8532c52d39fd3a042a88b58423c50ae15d5c2638e343d9c71c6238aaaaaaaa97d6',
        ],
        [
            '0x0',
            '0x11560bf17baa99bc32126fced787c88f984f87adf7ae0c7f9a208c6b4f20a4181472aaa9cb8d555526a9ffffffffc71a',
        ],
        [
            '0x11560bf17baa99bc32126fced787c88f984f87adf7ae0c7f9a208c6b4f20a4181472aaa9cb8d555526a9ffffffffc71e',
            '0x8ab05f8bdd54cde190937e76bc3e447cc27c3d6fbd7063fcd104635a790520c0a395554e5c6aaaa9354ffffffffe38d',
        ],
        [
            '0x171d6541fa38ccfaed6dea691f5fb614cb14b4e7f4e810aa22d6108f142b85757098e38d0f671c7188e2aaaaaaaa5ed1',
            '0x0',
        ],
    ],
    // xDen
    [
        [
            '0x0',
            '0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaa63',
        ],
        [
            '0xc',
            '0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaa9f',
        ],
        ['0x1', '0x0'], // LAST 1
    ],
    // yNum
    [
        [
            '0x1530477c7ab4113b59a4c18b076d11930f7da5d4a07f649bf54439d87d27e500fc8c25ebf8c92f6812cfc71c71c6d706',
            '0x1530477c7ab4113b59a4c18b076d11930f7da5d4a07f649bf54439d87d27e500fc8c25ebf8c92f6812cfc71c71c6d706',
        ],
        [
            '0x0',
            '0x5c759507e8e333ebb5b7a9a47d7ed8532c52d39fd3a042a88b58423c50ae15d5c2638e343d9c71c6238aaaaaaaa97be',
        ],
        [
            '0x11560bf17baa99bc32126fced787c88f984f87adf7ae0c7f9a208c6b4f20a4181472aaa9cb8d555526a9ffffffffc71c',
            '0x8ab05f8bdd54cde190937e76bc3e447cc27c3d6fbd7063fcd104635a790520c0a395554e5c6aaaa9354ffffffffe38f',
        ],
        [
            '0x124c9ad43b6cf79bfbf7043de3811ad0761b0f37a1e26286b0e977c69aa274524e79097a56dc4bd9e1b371c71c718b10',
            '0x0',
        ],
    ],
    // yDen
    [
        [
            '0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffa8fb',
            '0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffa8fb',
        ],
        [
            '0x0',
            '0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffa9d3',
        ],
        [
            '0x12',
            '0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaa99',
        ],
        ['0x1', '0x0'], // LAST 1
    ],
].map(function (i) { return i.map(function (pair) { return exports.Fp2.fromBigTuple(pair.map(BigInt)); }); }));
// 11-isogeny map from E' to E
var isogenyMapG1 = (0, hash_to_curve_1.isogenyMap)(exports.Fp, [
    // xNum
    [
        '0x11a05f2b1e833340b809101dd99815856b303e88a2d7005ff2627b56cdb4e2c85610c2d5f2e62d6eaeac1662734649b7',
        '0x17294ed3e943ab2f0588bab22147a81c7c17e75b2f6a8417f565e33c70d1e86b4838f2a6f318c356e834eef1b3cb83bb',
        '0xd54005db97678ec1d1048c5d10a9a1bce032473295983e56878e501ec68e25c958c3e3d2a09729fe0179f9dac9edcb0',
        '0x1778e7166fcc6db74e0609d307e55412d7f5e4656a8dbf25f1b33289f1b330835336e25ce3107193c5b388641d9b6861',
        '0xe99726a3199f4436642b4b3e4118e5499db995a1257fb3f086eeb65982fac18985a286f301e77c451154ce9ac8895d9',
        '0x1630c3250d7313ff01d1201bf7a74ab5db3cb17dd952799b9ed3ab9097e68f90a0870d2dcae73d19cd13c1c66f652983',
        '0xd6ed6553fe44d296a3726c38ae652bfb11586264f0f8ce19008e218f9c86b2a8da25128c1052ecaddd7f225a139ed84',
        '0x17b81e7701abdbe2e8743884d1117e53356de5ab275b4db1a682c62ef0f2753339b7c8f8c8f475af9ccb5618e3f0c88e',
        '0x80d3cf1f9a78fc47b90b33563be990dc43b756ce79f5574a2c596c928c5d1de4fa295f296b74e956d71986a8497e317',
        '0x169b1f8e1bcfa7c42e0c37515d138f22dd2ecb803a0c5c99676314baf4bb1b7fa3190b2edc0327797f241067be390c9e',
        '0x10321da079ce07e272d8ec09d2565b0dfa7dccdde6787f96d50af36003b14866f69b771f8c285decca67df3f1605fb7b',
        '0x6e08c248e260e70bd1e962381edee3d31d79d7e22c837bc23c0bf1bc24c6b68c24b1b80b64d391fa9c8ba2e8ba2d229',
    ],
    // xDen
    [
        '0x8ca8d548cff19ae18b2e62f4bd3fa6f01d5ef4ba35b48ba9c9588617fc8ac62b558d681be343df8993cf9fa40d21b1c',
        '0x12561a5deb559c4348b4711298e536367041e8ca0cf0800c0126c2588c48bf5713daa8846cb026e9e5c8276ec82b3bff',
        '0xb2962fe57a3225e8137e629bff2991f6f89416f5a718cd1fca64e00b11aceacd6a3d0967c94fedcfcc239ba5cb83e19',
        '0x3425581a58ae2fec83aafef7c40eb545b08243f16b1655154cca8abc28d6fd04976d5243eecf5c4130de8938dc62cd8',
        '0x13a8e162022914a80a6f1d5f43e7a07dffdfc759a12062bb8d6b44e833b306da9bd29ba81f35781d539d395b3532a21e',
        '0xe7355f8e4e667b955390f7f0506c6e9395735e9ce9cad4d0a43bcef24b8982f7400d24bc4228f11c02df9a29f6304a5',
        '0x772caacf16936190f3e0c63e0596721570f5799af53a1894e2e073062aede9cea73b3538f0de06cec2574496ee84a3a',
        '0x14a7ac2a9d64a8b230b3f5b074cf01996e7f63c21bca68a81996e1cdf9822c580fa5b9489d11e2d311f7d99bbdcc5a5e',
        '0xa10ecf6ada54f825e920b3dafc7a3cce07f8d1d7161366b74100da67f39883503826692abba43704776ec3a79a1d641',
        '0x95fc13ab9e92ad4476d6e3eb3a56680f682b4ee96f7d03776df533978f31c1593174e4b4b7865002d6384d168ecdd0a',
        '0x000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001', // LAST 1
    ],
    // yNum
    [
        '0x90d97c81ba24ee0259d1f094980dcfa11ad138e48a869522b52af6c956543d3cd0c7aee9b3ba3c2be9845719707bb33',
        '0x134996a104ee5811d51036d776fb46831223e96c254f383d0f906343eb67ad34d6c56711962fa8bfe097e75a2e41c696',
        '0xcc786baa966e66f4a384c86a3b49942552e2d658a31ce2c344be4b91400da7d26d521628b00523b8dfe240c72de1f6',
        '0x1f86376e8981c217898751ad8746757d42aa7b90eeb791c09e4a3ec03251cf9de405aba9ec61deca6355c77b0e5f4cb',
        '0x8cc03fdefe0ff135caf4fe2a21529c4195536fbe3ce50b879833fd221351adc2ee7f8dc099040a841b6daecf2e8fedb',
        '0x16603fca40634b6a2211e11db8f0a6a074a7d0d4afadb7bd76505c3d3ad5544e203f6326c95a807299b23ab13633a5f0',
        '0x4ab0b9bcfac1bbcb2c977d027796b3ce75bb8ca2be184cb5231413c4d634f3747a87ac2460f415ec961f8855fe9d6f2',
        '0x987c8d5333ab86fde9926bd2ca6c674170a05bfe3bdd81ffd038da6c26c842642f64550fedfe935a15e4ca31870fb29',
        '0x9fc4018bd96684be88c9e221e4da1bb8f3abd16679dc26c1e8b6e6a1f20cabe69d65201c78607a360370e577bdba587',
        '0xe1bba7a1186bdb5223abde7ada14a23c42a0ca7915af6fe06985e7ed1e4d43b9b3f7055dd4eba6f2bafaaebca731c30',
        '0x19713e47937cd1be0dfd0b8f1d43fb93cd2fcbcb6caf493fd1183e416389e61031bf3a5cce3fbafce813711ad011c132',
        '0x18b46a908f36f6deb918c143fed2edcc523559b8aaf0c2462e6bfe7f911f643249d9cdf41b44d606ce07c8a4d0074d8e',
        '0xb182cac101b9399d155096004f53f447aa7b12a3426b08ec02710e807b4633f06c851c1919211f20d4c04f00b971ef8',
        '0x245a394ad1eca9b72fc00ae7be315dc757b3b080d4c158013e6632d3c40659cc6cf90ad1c232a6442d9d3f5db980133',
        '0x5c129645e44cf1102a159f748c4a3fc5e673d81d7e86568d9ab0f5d396a7ce46ba1049b6579afb7866b1e715475224b',
        '0x15e6be4e990f03ce4ea50b3b42df2eb5cb181d8f84965a3957add4fa95af01b2b665027efec01c7704b456be69c8b604',
    ],
    // yDen
    [
        '0x16112c4c3a9c98b252181140fad0eae9601a6de578980be6eec3232b5be72e7a07f3688ef60c206d01479253b03663c1',
        '0x1962d75c2381201e1a0cbd6c43c348b885c84ff731c4d59ca4a10356f453e01f78a4260763529e3532f6102c2e49a03d',
        '0x58df3306640da276faaae7d6e8eb15778c4855551ae7f310c35a5dd279cd2eca6757cd636f96f891e2538b53dbf67f2',
        '0x16b7d288798e5395f20d23bf89edb4d1d115c5dbddbcd30e123da489e726af41727364f2c28297ada8d26d98445f5416',
        '0xbe0e079545f43e4b00cc912f8228ddcc6d19c9f0f69bbb0542eda0fc9dec916a20b15dc0fd2ededda39142311a5001d',
        '0x8d9e5297186db2d9fb266eaac783182b70152c65550d881c5ecd87b6f0f5a6449f38db9dfa9cce202c6477faaf9b7ac',
        '0x166007c08a99db2fc3ba8734ace9824b5eecfdfa8d0cf8ef5dd365bc400a0051d5fa9c01a58b1fb93d1a1399126a775c',
        '0x16a3ef08be3ea7ea03bcddfabba6ff6ee5a4375efa1f4fd7feb34fd206357132b920f5b00801dee460ee415a15812ed9',
        '0x1866c8ed336c61231a1be54fd1d74cc4f9fb0ce4c6af5920abc5750c4bf39b4852cfe2f7bb9248836b233d9d55535d4a',
        '0x167a55cda70a6e1cea820597d94a84903216f763e13d87bb5308592e7ea7d4fbc7385ea3d529b35e346ef48bb8913f55',
        '0x4d2f259eea405bd48f010a01ad2911d9c6dd039bb61a6290e591b36e636a5c871a5c29f4f83060400f8b49cba8f6aa8',
        '0xaccbb67481d033ff5852c1e48c50c477f94ff8aefce42d28c0f9a88cea7913516f968986f7ebbea9684b529e2561092',
        '0xad6b9514c767fe3c3613144b45f1496543346d98adf02267d5ceef9a00d9b8693000763e3b90ac11e99b138573345cc',
        '0x2660400eb2e4f3b628bdd0d53cd76f2bf565b94e72927c1cb748df27942480e420517bd8714cc80d1fadc1326ed06f7',
        '0xe0fa1d816ddc03e6b24255e0d7819c171c40f65e273b853324efcd6356caa205ca2f570f13497804415473a1d634b8f',
        '0x000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001', // LAST 1
    ],
].map(function (i) { return i.map(function (j) { return BigInt(j); }); }));
// SWU Map - Fp2 to G2': y² = x³ + 240i * x + 1012 + 1012i
var G2_SWU = (0, weierstrass_1.mapToCurveSimpleSWU)(exports.Fp2, {
    A: exports.Fp2.create({ c0: exports.Fp.create(_0n), c1: exports.Fp.create(BigInt(240)) }),
    B: exports.Fp2.create({ c0: exports.Fp.create(BigInt(1012)), c1: exports.Fp.create(BigInt(1012)) }),
    Z: exports.Fp2.create({ c0: exports.Fp.create(BigInt(-2)), c1: exports.Fp.create(BigInt(-1)) }), // Z: -(2 + I)
});
// Optimized SWU Map - Fp to G1
var G1_SWU = (0, weierstrass_1.mapToCurveSimpleSWU)(exports.Fp, {
    A: exports.Fp.create(BigInt('0x144698a3b8e9433d693a02c96d4982b0ea985383ee66a8d8e8981aefd881ac98936f8da0e0f97f5cf428082d584c1d')),
    B: exports.Fp.create(BigInt('0x12e2908d11688030018b12e8753eee3b2016c1f0f24f4070a0b9c14fcef35ef55a23215a316ceaa5d1cc48e98e172be0')),
    Z: exports.Fp.create(BigInt(11)),
});
// Endomorphisms (for fast cofactor clearing)
// Ψ(P) endomorphism
var ut_root = Fp6.create({ c0: exports.Fp2.ZERO, c1: exports.Fp2.ONE, c2: exports.Fp2.ZERO });
var wsq = exports.Fp12.create({ c0: ut_root, c1: Fp6.ZERO });
var wcu = exports.Fp12.create({ c0: Fp6.ZERO, c1: ut_root });
var _a = __read(exports.Fp12.invertBatch([wsq, wcu]), 2), wsq_inv = _a[0], wcu_inv = _a[1];
function psi(x, y) {
    // Untwist Fp2->Fp12 && frobenius(1) && twist back
    var x2 = exports.Fp12.mul(exports.Fp12.frobeniusMap(exports.Fp12.multiplyByFp2(wsq_inv, x), 1), wsq).c0.c0;
    var y2 = exports.Fp12.mul(exports.Fp12.frobeniusMap(exports.Fp12.multiplyByFp2(wcu_inv, y), 1), wcu).c0.c0;
    return [x2, y2];
}
// Ψ endomorphism
function G2psi(c, P) {
    var affine = P.toAffine();
    var p = psi(affine.x, affine.y);
    return new c(p[0], p[1], exports.Fp2.ONE);
}
// Ψ²(P) endomorphism
// 1 / F2(2)^((p-1)/3) in GF(p²)
var PSI2_C1 = BigInt('0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac');
function psi2(x, y) {
    return [exports.Fp2.mul(x, PSI2_C1), exports.Fp2.neg(y)];
}
function G2psi2(c, P) {
    var affine = P.toAffine();
    var p = psi2(affine.x, affine.y);
    return new c(p[0], p[1], exports.Fp2.ONE);
}
// Default hash_to_field options are for hash to G2.
//
// Parameter definitions are in section 5.3 of the spec unless otherwise noted.
// Parameter values come from section 8.8.2 of the spec.
// https://www.rfc-editor.org/rfc/rfc9380#section-8.8.2
//
// Base field F is GF(p^m)
// p = 0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab
// m = 2 (or 1 for G1 see section 8.8.1)
// k = 128
var htfDefaults = Object.freeze({
    // DST: a domain separation tag
    // defined in section 2.2.5
    // Use utils.getDSTLabel(), utils.setDSTLabel(value)
    DST: "",
    encodeDST: "",
    // p: the characteristic of F
    //    where F is a finite field of characteristic p and order q = p^m
    p: exports.Fp.ORDER,
    // m: the extension degree of F, m >= 1
    //     where F is a finite field of characteristic p and order q = p^m
    m: 2,
    // k: the target security level for the suite in bits
    // defined in section 5.1
    k: 128,
    // option to use a message that has already been processed by
    // expand_message_xmd
    expand: 'xmd',
    // Hash functions for: expand_message_xmd is appropriate for use with a
    // wide range of hash functions, including SHA-2, SHA-3, BLAKE2, and others.
    // BBS+ uses blake2: https://github.com/hyperledger/aries-framework-go/issues/2247
    hash: sha256_1.sha256,
});
// Encoding utils
// Point on G1 curve: (x, y)
// Compressed point of infinity
var COMPRESSED_ZERO = setMask(exports.Fp.toBytes(_0n), { infinity: true, compressed: true }); // set compressed & point-at-infinity bits
function parseMask(bytes) {
    // Copy, so we can remove mask data. It will be removed also later, when Fp.create will call modulo.
    bytes = bytes.slice();
    var mask = bytes[0] & 224;
    var compressed = !!((mask >> 7) & 1); // compression bit (0b1000_0000)
    var infinity = !!((mask >> 6) & 1); // point at infinity bit (0b0100_0000)
    var sort = !!((mask >> 5) & 1); // sort bit (0b0010_0000)
    bytes[0] &= 31; // clear mask (zero first 3 bits)
    return { compressed: compressed, infinity: infinity, sort: sort, value: bytes };
}
exports.parseMask = parseMask;
function setMask(bytes, mask) {
    if (bytes[0] & 224)
        throw new Error('setMask: non-empty mask');
    if (mask.compressed)
        bytes[0] |= 128;
    if (mask.infinity)
        bytes[0] |= 64;
    if (mask.sort)
        bytes[0] |= 32;
    return bytes;
}
function signatureG1ToRawBytes(point) {
    point.assertValidity();
    var isZero = point.equals(exports.bls12_381.G1.ProjectivePoint.ZERO);
    var _a = point.toAffine(), x = _a.x, y = _a.y;
    if (isZero)
        return COMPRESSED_ZERO.slice();
    var P = exports.Fp.ORDER;
    var sort = Boolean((y * _2n) / P);
    return setMask((0, utils_1.numberToBytesBE)(x, exports.Fp.BYTES), { compressed: true, sort: sort });
}
function signatureG2ToRawBytes(point) {
    // NOTE: by some reasons it was missed in bls12-381, looks like bug
    point.assertValidity();
    var len = exports.Fp.BYTES;
    if (point.equals(exports.bls12_381.G2.ProjectivePoint.ZERO))
        return (0, utils_1.concatBytes)(COMPRESSED_ZERO, (0, utils_1.numberToBytesBE)(_0n, len));
    var _a = point.toAffine(), x = _a.x, y = _a.y;
    var _b = exports.Fp2.reim(x), x0 = _b.re, x1 = _b.im;
    var _d = exports.Fp2.reim(y), y0 = _d.re, y1 = _d.im;
    var tmp = y1 > _0n ? y1 * _2n : y0 * _2n;
    var sort = Boolean((tmp / exports.Fp.ORDER) & _1n);
    var z2 = x0;
    return (0, utils_1.concatBytes)(setMask((0, utils_1.numberToBytesBE)(x1, len), { sort: sort, compressed: true }), (0, utils_1.numberToBytesBE)(z2, len));
}
var G1_formBytes = function (bytes) {
    var _a = parseMask(bytes), compressed = _a.compressed, infinity = _a.infinity, sort = _a.sort, value = _a.value;
    if (value.length === 48 && compressed) {
        // TODO: Fp.bytes
        var P = exports.Fp.ORDER;
        var compressedValue = (0, utils_1.bytesToNumberBE)(value);
        // Zero
        var x = exports.Fp.create(compressedValue & exports.Fp.MASK);
        if (infinity) {
            if (x !== _0n)
                throw new Error('G1: non-empty compressed point at infinity');
            return { x: _0n, y: _0n };
        }
        var right = exports.Fp.add(exports.Fp.pow(x, _3n), exports.Fp.create(exports.bls12_381.params.G1b)); // y² = x³ + b
        var y = exports.Fp.sqrt(right);
        if (!y)
            throw new Error('Invalid compressed G1 point');
        if ((y * _2n) / P !== BigInt(sort))
            y = exports.Fp.neg(y);
        return { x: exports.Fp.create(x), y: exports.Fp.create(y) };
    }
    else if (value.length === 96 && !compressed) {
        // Check if the infinity flag is set
        var x = (0, utils_1.bytesToNumberBE)(value.subarray(0, exports.Fp.BYTES));
        var y = (0, utils_1.bytesToNumberBE)(value.subarray(exports.Fp.BYTES));
        if (infinity) {
            if (x !== _0n || y !== _0n)
                throw new Error('G1: non-empty point at infinity');
            return exports.bls12_381.G1.ProjectivePoint.ZERO.toAffine();
        }
        return { x: exports.Fp.create(x), y: exports.Fp.create(y) };
    }
    else {
        throw new Error('Invalid point G1, expected 48/96 bytes');
    }
};
exports.G1_formBytes = G1_formBytes;
var G1_mapToCurve = function (scalars) {
    var _a = G1_SWU(exports.Fp.create(scalars[0])), x = _a.x, y = _a.y;
    return isogenyMapG1(x, y);
};
exports.G1_mapToCurve = G1_mapToCurve;
var G2_mapToCurve = function (scalars) {
    var _a = G2_SWU(exports.Fp2.fromBigTuple(scalars)), x = _a.x, y = _a.y;
    return isogenyMapG2(x, y);
};
exports.G2_mapToCurve = G2_mapToCurve;
// To verify curve parameters, see pairing-friendly-curves spec:
// https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-pairing-friendly-curves-11
// Basic math is done over finite fields over p.
// More complicated math is done over polynominal extension fields.
// To simplify calculations in Fp12, we construct extension tower:
// Fp₁₂ = Fp₆² => Fp₂³
// Fp(u) / (u² - β) where β = -1
// Fp₂(v) / (v³ - ξ) where ξ = u + 1
// Fp₆(w) / (w² - γ) where γ = v
// Here goes constants && point encoding format
exports.bls12_381 = (0, bls_1.bls)({
    // Fields
    fields: {
        Fp: exports.Fp,
        Fp2: exports.Fp2,
        Fp6: Fp6,
        Fp12: exports.Fp12,
        Fr: Fr,
    },
    // G1 is the order-q subgroup of E1(Fp) : y² = x³ + 4, #E1(Fp) = h1q, where
    // characteristic; z + (z⁴ - z² + 1)(z - 1)²/3
    G1: {
        Fp: exports.Fp,
        // cofactor; (z - 1)²/3
        h: BigInt('0x396c8c005555e1568c00aaab0000aaab'),
        // generator's coordinates
        // x = 3685416753713387016781088315183077757961620795782546409894578378688607592378376318836054947676345821548104185464507
        // y = 1339506544944476473020471379941921221584933875938349620426543736416511423956333506472724655353366534992391756441569
        Gx: BigInt('0x17f1d3a73197d7942695638c4fa9ac0fc3688c4f9774b905a14e3a3f171bac586c55e83ff97a1aeffb3af00adb22c6bb'),
        Gy: BigInt('0x08b3f481e3aaa0f1a09e30ed741d8ae4fcf5e095d5d00af600db18cb2c04b3edd03cc744a2888ae40caa232946c5e7e1'),
        a: exports.Fp.ZERO,
        b: _4n,
        htfDefaults: __assign(__assign({}, htfDefaults), { m: 1, DST: 'BLS_SIG_BLS12381G1_XMD:SHA-256_SSWU_RO_NUL_' }),
        wrapPrivateKey: true,
        allowInfinityPoint: true,
        // Checks is the point resides in prime-order subgroup.
        // point.isTorsionFree() should return true for valid points
        // It returns false for shitty points.
        // https://eprint.iacr.org/2021/1130.pdf
        isTorsionFree: function (c, point) {
            // φ endomorphism
            var cubicRootOfUnityModP = BigInt('0x5f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe');
            var phi = new c(exports.Fp.mul(point.px, cubicRootOfUnityModP), point.py, point.pz);
            // todo: unroll
            var xP = point.multiplyUnsafe(exports.bls12_381.params.x).negate(); // [x]P
            var u2P = xP.multiplyUnsafe(exports.bls12_381.params.x); // [u2]P
            return u2P.equals(phi);
            // https://eprint.iacr.org/2019/814.pdf
            // (z² − 1)/3
            // const c1 = BigInt('0x396c8c005555e1560000000055555555');
            // const P = this;
            // const S = P.sigma();
            // const Q = S.double();
            // const S2 = S.sigma();
            // // [(z² − 1)/3](2σ(P) − P − σ²(P)) − σ²(P) = O
            // const left = Q.subtract(P).subtract(S2).multiplyUnsafe(c1);
            // const C = left.subtract(S2);
            // return C.isZero();
        },
        // Clear cofactor of G1
        // https://eprint.iacr.org/2019/403
        clearCofactor: function (_c, point) {
            // return this.multiplyUnsafe(CURVE.h);
            return point.multiplyUnsafe(exports.bls12_381.params.x).add(point); // x*P + P
        },
        mapToCurve: exports.G1_mapToCurve,
        fromBytes: exports.G1_formBytes,
        toBytes: function (c, point, isCompressed) {
            var isZero = point.equals(c.ZERO);
            var _a = point.toAffine(), x = _a.x, y = _a.y;
            if (isCompressed) {
                if (isZero)
                    return COMPRESSED_ZERO.slice();
                var P = exports.Fp.ORDER;
                var sort = Boolean((y * _2n) / P);
                return setMask((0, utils_1.numberToBytesBE)(x, exports.Fp.BYTES), { compressed: true, sort: sort });
            }
            else {
                if (isZero) {
                    // 2x PUBLIC_KEY_LENGTH
                    var x_2 = (0, utils_1.concatBytes)(new Uint8Array([0x40]), new Uint8Array(2 * exports.Fp.BYTES - 1));
                    return x_2;
                }
                else {
                    return (0, utils_1.concatBytes)((0, utils_1.numberToBytesBE)(x, exports.Fp.BYTES), (0, utils_1.numberToBytesBE)(y, exports.Fp.BYTES));
                }
            }
        },
        ShortSignature: {
            fromHex: function (hex) {
                var _a = parseMask((0, utils_1.ensureBytes)('signatureHex', hex, 48)), infinity = _a.infinity, sort = _a.sort, value = _a.value;
                var P = exports.Fp.ORDER;
                var compressedValue = (0, utils_1.bytesToNumberBE)(value);
                // Zero
                if (infinity)
                    return exports.bls12_381.G1.ProjectivePoint.ZERO;
                var x = exports.Fp.create(compressedValue & exports.Fp.MASK);
                var right = exports.Fp.add(exports.Fp.pow(x, _3n), exports.Fp.create(exports.bls12_381.params.G1b)); // y² = x³ + b
                var y = exports.Fp.sqrt(right);
                if (!y)
                    throw new Error('Invalid compressed G1 point');
                var aflag = BigInt(sort);
                if ((y * _2n) / P !== aflag)
                    y = exports.Fp.neg(y);
                var point = exports.bls12_381.G1.ProjectivePoint.fromAffine({ x: x, y: y });
                point.assertValidity();
                return point;
            },
            toRawBytes: function (point) {
                return signatureG1ToRawBytes(point);
            },
            toHex: function (point) {
                return (0, utils_1.bytesToHex)(signatureG1ToRawBytes(point));
            },
        },
    },
    // G2 is the order-q subgroup of E2(Fp²) : y² = x³+4(1+√−1),
    // where Fp2 is Fp[√−1]/(x2+1). #E2(Fp2 ) = h2q, where
    // G² - 1
    // h2q
    G2: {
        Fp: exports.Fp2,
        // cofactor
        h: BigInt('0x5d543a95414e7f1091d50792876a202cd91de4547085abaa68a205b2e5a7ddfa628f1cb4d9e82ef21537e293a6691ae1616ec6e786f0c70cf1c38e31c7238e5'),
        Gx: exports.Fp2.fromBigTuple([
            BigInt('0x024aa2b2f08f0a91260805272dc51051c6e47ad4fa403b02b4510b647ae3d1770bac0326a805bbefd48056c8c121bdb8'),
            BigInt('0x13e02b6052719f607dacd3a088274f65596bd0d09920b61ab5da61bbdc7f5049334cf11213945d57e5ac7d055d042b7e'),
        ]),
        // y =
        // 927553665492332455747201965776037880757740193453592970025027978793976877002675564980949289727957565575433344219582,
        // 1985150602287291935568054521177171638300868978215655730859378665066344726373823718423869104263333984641494340347905
        Gy: exports.Fp2.fromBigTuple([
            BigInt('0x0ce5d527727d6e118cc9cdc6da2e351aadfd9baa8cbdd3a76d429a695160d12c923ac9cc3baca289e193548608b82801'),
            BigInt('0x0606c4a02ea734cc32acd2b02bc28b99cb3e287e85a763af267492ab572e99ab3f370d275cec1da1aaa9075ff05f79be'),
        ]),
        a: exports.Fp2.ZERO,
        b: exports.Fp2.fromBigTuple([_4n, _4n]),
        hEff: BigInt('0xbc69f08f2ee75b3584c6a0ea91b352888e2a8e9145ad7689986ff031508ffe1329c2f178731db956d82bf015d1212b02ec0ec69d7477c1ae954cbc06689f6a359894c0adebbf6b4e8020005aaa95551'),
        htfDefaults: __assign({}, htfDefaults),
        wrapPrivateKey: true,
        allowInfinityPoint: true,
        mapToCurve: exports.G2_mapToCurve,
        // Checks is the point resides in prime-order subgroup.
        // point.isTorsionFree() should return true for valid points
        // It returns false for shitty points.
        // https://eprint.iacr.org/2021/1130.pdf
        isTorsionFree: function (c, P) {
            return P.multiplyUnsafe(exports.bls12_381.params.x).negate().equals(G2psi(c, P)); // ψ(P) == [u](P)
            // Older version: https://eprint.iacr.org/2019/814.pdf
            // Ψ²(P) => Ψ³(P) => [z]Ψ³(P) where z = -x => [z]Ψ³(P) - Ψ²(P) + P == O
            // return P.psi2().psi().mulNegX().subtract(psi2).add(P).isZero();
        },
        // Maps the point into the prime-order subgroup G2.
        // clear_cofactor_bls12381_g2 from cfrg-hash-to-curve-11
        // https://eprint.iacr.org/2017/419.pdf
        // prettier-ignore
        clearCofactor: function (c, P) {
            var x = exports.bls12_381.params.x;
            var t1 = P.multiplyUnsafe(x).negate(); // [-x]P
            var t2 = G2psi(c, P); // Ψ(P)
            var t3 = P.double(); // 2P
            t3 = G2psi2(c, t3); // Ψ²(2P)
            t3 = t3.subtract(t2); // Ψ²(2P) - Ψ(P)
            t2 = t1.add(t2); // [-x]P + Ψ(P)
            t2 = t2.multiplyUnsafe(x).negate(); // [x²]P - [x]Ψ(P)
            t3 = t3.add(t2); // Ψ²(2P) - Ψ(P) + [x²]P - [x]Ψ(P)
            t3 = t3.subtract(t1); // Ψ²(2P) - Ψ(P) + [x²]P - [x]Ψ(P) + [x]P
            var Q = t3.subtract(P); // Ψ²(2P) - Ψ(P) + [x²]P - [x]Ψ(P) + [x]P - 1P
            return Q; // [x²-x-1]P + [x-1]Ψ(P) + Ψ²(2P)
        },
        fromBytes: function (bytes) {
            var _a = parseMask(bytes), compressed = _a.compressed, infinity = _a.infinity, sort = _a.sort, value = _a.value;
            if ((!compressed && !infinity && sort) || // 00100000
                (!compressed && infinity && sort) || // 01100000
                (sort && infinity && compressed) // 11100000
            ) {
                throw new Error('Invalid encoding flag: ' + (bytes[0] & 224));
            }
            var L = exports.Fp.BYTES;
            var slc = function (b, from, to) { return (0, utils_1.bytesToNumberBE)(b.slice(from, to)); };
            if (value.length === 96 && compressed) {
                var b = exports.bls12_381.params.G2b;
                var P = exports.Fp.ORDER;
                if (infinity) {
                    // check that all bytes are 0
                    if (value.reduce(function (p, c) { return (p !== 0 ? c + 1 : c); }, 0) > 0) {
                        throw new Error('Invalid compressed G2 point');
                    }
                    return { x: exports.Fp2.ZERO, y: exports.Fp2.ZERO };
                }
                var x_1 = slc(value, 0, L);
                var x_0 = slc(value, L, 2 * L);
                var x = exports.Fp2.create({ c0: exports.Fp.create(x_0), c1: exports.Fp.create(x_1) });
                var right = exports.Fp2.add(exports.Fp2.pow(x, _3n), b); // y² = x³ + 4 * (u+1) = x³ + b
                var y = exports.Fp2.sqrt(right);
                var Y_bit = y.c1 === _0n ? (y.c0 * _2n) / P : (y.c1 * _2n) / P ? _1n : _0n;
                y = sort && Y_bit > 0 ? y : exports.Fp2.neg(y);
                return { x: x, y: y };
            }
            else if (value.length === 192 && !compressed) {
                if (infinity) {
                    if (value.reduce(function (p, c) { return (p !== 0 ? c + 1 : c); }, 0) > 0) {
                        throw new Error('Invalid uncompressed G2 point');
                    }
                    return { x: exports.Fp2.ZERO, y: exports.Fp2.ZERO };
                }
                var x1 = slc(value, 0, L);
                var x0 = slc(value, L, 2 * L);
                var y1 = slc(value, 2 * L, 3 * L);
                var y0 = slc(value, 3 * L, 4 * L);
                return { x: exports.Fp2.fromBigTuple([x0, x1]), y: exports.Fp2.fromBigTuple([y0, y1]) };
            }
            else {
                throw new Error('Invalid point G2, expected 96/192 bytes');
            }
        },
        toBytes: function (c, point, isCompressed) {
            var len = exports.Fp.BYTES, P = exports.Fp.ORDER;
            var isZero = point.equals(c.ZERO);
            var _a = point.toAffine(), x = _a.x, y = _a.y;
            if (isCompressed) {
                if (isZero)
                    return (0, utils_1.concatBytes)(COMPRESSED_ZERO, (0, utils_1.numberToBytesBE)(_0n, len));
                var flag = Boolean(y.c1 === _0n ? (y.c0 * _2n) / P : (y.c1 * _2n) / P);
                return (0, utils_1.concatBytes)(setMask((0, utils_1.numberToBytesBE)(x.c1, len), { compressed: true, sort: flag }), (0, utils_1.numberToBytesBE)(x.c0, len));
            }
            else {
                if (isZero)
                    return (0, utils_1.concatBytes)(new Uint8Array([0x40]), new Uint8Array(4 * len - 1)); // bytes[0] |= 1 << 6;
                var _b = exports.Fp2.reim(x), x0 = _b.re, x1 = _b.im;
                var _d = exports.Fp2.reim(y), y0 = _d.re, y1 = _d.im;
                return (0, utils_1.concatBytes)((0, utils_1.numberToBytesBE)(x1, len), (0, utils_1.numberToBytesBE)(x0, len), (0, utils_1.numberToBytesBE)(y1, len), (0, utils_1.numberToBytesBE)(y0, len));
            }
        },
        Signature: {
            // TODO: Optimize, it's very slow because of sqrt.
            fromHex: function (hex) {
                var _a = parseMask((0, utils_1.ensureBytes)('signatureHex', hex)), infinity = _a.infinity, sort = _a.sort, value = _a.value;
                var P = exports.Fp.ORDER;
                var half = hex.length / 2;
                if (half !== 48 && half !== 96)
                    throw new Error('Invalid compressed signature length, must be 96 or 192');
                var z1 = (0, utils_1.bytesToNumberBE)(value.slice(0, half));
                var z2 = (0, utils_1.bytesToNumberBE)(value.slice(half));
                // Indicates the infinity point
                if (infinity)
                    return exports.bls12_381.G2.ProjectivePoint.ZERO;
                var x1 = exports.Fp.create(z1 & exports.Fp.MASK);
                var x2 = exports.Fp.create(z2);
                var x = exports.Fp2.create({ c0: x2, c1: x1 });
                var y2 = exports.Fp2.add(exports.Fp2.pow(x, _3n), exports.bls12_381.params.G2b); // y² = x³ + 4
                // The slow part
                var y = exports.Fp2.sqrt(y2);
                if (!y)
                    throw new Error('Failed to find a square root');
                // Choose the y whose leftmost bit of the imaginary part is equal to the a_flag1
                // If y1 happens to be zero, then use the bit of y0
                var _b = exports.Fp2.reim(y), y0 = _b.re, y1 = _b.im;
                var aflag1 = BigInt(sort);
                var isGreater = y1 > _0n && (y1 * _2n) / P !== aflag1;
                var isZero = y1 === _0n && (y0 * _2n) / P !== aflag1;
                if (isGreater || isZero)
                    y = exports.Fp2.neg(y);
                var point = exports.bls12_381.G2.ProjectivePoint.fromAffine({ x: x, y: y });
                point.assertValidity();
                return point;
            },
            toRawBytes: function (point) {
                return signatureG2ToRawBytes(point);
            },
            toHex: function (point) {
                return (0, utils_1.bytesToHex)(signatureG2ToRawBytes(point));
            },
        },
    },
    params: {
        x: BLS_X,
        r: Fr.ORDER, // order; z⁴ − z² + 1; CURVE.n from other curves
    },
    htfDefaults: htfDefaults,
    hash: sha256_1.sha256,
    randomBytes: utils_2.randomBytes
});


/***/ }),

/***/ 26518:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.crypto = void 0;
exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;


/***/ }),

/***/ 8419:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hmac = exports.HMAC = void 0;
var _assert_1 = __webpack_require__(48117);
var utils_1 = __webpack_require__(88627);
// HMAC (RFC 2104)
var HMAC = /** @class */ (function (_super) {
    __extends(HMAC, _super);
    function HMAC(hash, _key) {
        var _this = _super.call(this) || this;
        _this.finished = false;
        _this.destroyed = false;
        (0, _assert_1.hash)(hash);
        var key = (0, utils_1.toBytes)(_key);
        _this.iHash = hash.create();
        if (typeof _this.iHash.update !== 'function')
            throw new Error('Expected instance of class which extends utils.Hash');
        _this.blockLen = _this.iHash.blockLen;
        _this.outputLen = _this.iHash.outputLen;
        var blockLen = _this.blockLen;
        var pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for (var i = 0; i < pad.length; i++)
            pad[i] ^= 0x36;
        _this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        _this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for (var i = 0; i < pad.length; i++)
            pad[i] ^= 0x36 ^ 0x5c;
        _this.oHash.update(pad);
        pad.fill(0);
        return _this;
    }
    HMAC.prototype.update = function (buf) {
        (0, _assert_1.exists)(this);
        this.iHash.update(buf);
        return this;
    };
    HMAC.prototype.digestInto = function (out) {
        (0, _assert_1.exists)(this);
        (0, _assert_1.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    };
    HMAC.prototype.digest = function () {
        var out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    };
    HMAC.prototype._cloneInto = function (to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        var _a = this, oHash = _a.oHash, iHash = _a.iHash, finished = _a.finished, destroyed = _a.destroyed, blockLen = _a.blockLen, outputLen = _a.outputLen;
        to = to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    };
    HMAC.prototype.destroy = function () {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    };
    return HMAC;
}(utils_1.Hash));
exports.HMAC = HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */
var hmac = function (hash, key, message) {
    return new HMAC(hash, key).update(message).digest();
};
exports.hmac = hmac;
exports.hmac.create = function (hash, key) { return new HMAC(hash, key); };


/***/ }),

/***/ 3691:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(8879), exports);
__exportStar(__webpack_require__(69345), exports);
// DO NOT export "./_u64";
// DO NOT export "./utils";


/***/ }),

/***/ 8879:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.keccak_512 = exports.keccak_384 = exports.keccak_256 = exports.keccak_224 = exports.Keccak = exports.keccakP = void 0;
/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-hashes/blob/6ae82e75d4c354d53a488e95b1bfe9cba90bd6ff/src/sha3.ts#L1

it was modified and adapted to this repository to re-use already defined stuff

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
var _u64_1 = __webpack_require__(20204);
var utils_1 = __webpack_require__(88627);
var assert_1 = __webpack_require__(24055);
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
var SHA3_PI = [];
var SHA3_ROTL = [];
var _SHA3_IOTA = [];
var _0n = /** @__PURE__ */ BigInt(0);
var _1n = /** @__PURE__ */ BigInt(1);
var _2n = /** @__PURE__ */ BigInt(2);
var _7n = /** @__PURE__ */ BigInt(7);
var _256n = /** @__PURE__ */ BigInt(256);
var _0x71n = /** @__PURE__ */ BigInt(0x71);
for (var round = 0, R = _1n, x = 1, y = 0; round < 24; round++) {
    // Pi
    _a = __read([y, (2 * x + 3 * y) % 5], 2), x = _a[0], y = _a[1];
    SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    SHA3_ROTL.push((((round + 1) * (round + 2)) / 2) % 64);
    // Iota
    var t = _0n;
    for (var j = 0; j < 7; j++) {
        R = ((R << _1n) ^ ((R >> _7n) * _0x71n)) % _256n;
        if (R & _2n)
            t ^= _1n << ((_1n << /** @__PURE__ */ BigInt(j)) - _1n);
    }
    _SHA3_IOTA.push(t);
}
var _b = __read(/** @__PURE__ */ (0, _u64_1.split)(_SHA3_IOTA, true), 2), SHA3_IOTA_H = _b[0], SHA3_IOTA_L = _b[1];
// Left rotation (without 0, 32, 64)
var rotlH = function (h, l, s) { return (s > 32 ? (0, _u64_1.rotlBH)(h, l, s) : (0, _u64_1.rotlSH)(h, l, s)); };
var rotlL = function (h, l, s) { return (s > 32 ? (0, _u64_1.rotlBL)(h, l, s) : (0, _u64_1.rotlSL)(h, l, s)); };
// Same as keccakf1600, but allows to skip some rounds
function keccakP(s, rounds) {
    if (rounds === void 0) { rounds = 24; }
    var B = new Uint32Array(5 * 2);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for (var round = 24 - rounds; round < 24; round++) {
        // Theta θ
        for (var x = 0; x < 10; x++)
            B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for (var x = 0; x < 10; x += 2) {
            var idx1 = (x + 8) % 10;
            var idx0 = (x + 2) % 10;
            var B0 = B[idx0];
            var B1 = B[idx0 + 1];
            var Th = rotlH(B0, B1, 1) ^ B[idx1];
            var Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for (var y = 0; y < 50; y += 10) {
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        var curH = s[2];
        var curL = s[3];
        for (var t = 0; t < 24; t++) {
            var shift = SHA3_ROTL[t];
            var Th = rotlH(curH, curL, shift);
            var Tl = rotlL(curH, curL, shift);
            var PI = SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for (var y = 0; y < 50; y += 10) {
            for (var x = 0; x < 10; x++)
                B[x] = s[y + x];
            for (var x = 0; x < 10; x++)
                s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= SHA3_IOTA_H[round];
        s[1] ^= SHA3_IOTA_L[round];
    }
    B.fill(0);
}
exports.keccakP = keccakP;
var Keccak = /** @class */ (function (_super) {
    __extends(Keccak, _super);
    // NOTE: we accept arguments in bytes instead of bits here.
    function Keccak(blockLen, suffix, outputLen, enableXOF, rounds) {
        if (enableXOF === void 0) { enableXOF = false; }
        if (rounds === void 0) { rounds = 24; }
        var _this = _super.call(this) || this;
        _this.blockLen = blockLen;
        _this.suffix = suffix;
        _this.outputLen = outputLen;
        _this.enableXOF = enableXOF;
        _this.rounds = rounds;
        _this.pos = 0;
        _this.posOut = 0;
        _this.finished = false;
        _this.destroyed = false;
        // Can be passed from user as dkLen
        (0, assert_1.assertPostiveInteger)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= _this.blockLen || _this.blockLen >= 200)
            throw new Error('Sha3 supports only keccak-f1600 function');
        _this.state = new Uint8Array(200);
        _this.state32 = (0, utils_1.u32)(_this.state);
        return _this;
    }
    Keccak.prototype.keccak = function () {
        if (!utils_1.isLE)
            (0, utils_1.byteSwap32)(this.state32);
        keccakP(this.state32, this.rounds);
        if (!utils_1.isLE)
            (0, utils_1.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    };
    Keccak.prototype.update = function (data) {
        this.assertExists();
        var _a = this, blockLen = _a.blockLen, state = _a.state;
        data = (0, utils_1.toBytes)(data);
        var len = data.length;
        for (var pos = 0; pos < len;) {
            var take = Math.min(blockLen - this.pos, len - pos);
            for (var i = 0; i < take; i++)
                state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen)
                this.keccak();
        }
        return this;
    };
    Keccak.prototype.finish = function () {
        if (this.finished)
            return;
        this.finished = true;
        var _a = this, state = _a.state, suffix = _a.suffix, pos = _a.pos, blockLen = _a.blockLen;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1)
            this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    };
    Keccak.prototype.writeInto = function (out) {
        this.assertExists(false);
        if (!(out instanceof Uint8Array))
            throw new Error("Uint8Array expected");
        this.finish();
        var bufferOut = this.state;
        var blockLen = this.blockLen;
        for (var pos = 0, len = out.length; pos < len;) {
            if (this.posOut >= blockLen)
                this.keccak();
            var take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    };
    Keccak.prototype.xofInto = function (out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF)
            throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    };
    Keccak.prototype.xof = function (bytes) {
        (0, assert_1.assertPostiveInteger)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    };
    Keccak.prototype.digestInto = function (out) {
        // output(out, this);
        if (!(out instanceof Uint8Array))
            throw new Error("Uint8Array expected");
        var min = this.outputLen;
        if (out.length < min)
            throw new Error("digestInto() expects output buffer of length at least ".concat(min));
        if (this.finished)
            throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    };
    Keccak.prototype.digest = function () {
        return this.digestInto(new Uint8Array(this.outputLen));
    };
    Keccak.prototype.destroy = function () {
        this.destroyed = true;
        this.state.fill(0);
    };
    Keccak.prototype._cloneInto = function (to) {
        var _a = this, blockLen = _a.blockLen, suffix = _a.suffix, outputLen = _a.outputLen, rounds = _a.rounds, enableXOF = _a.enableXOF;
        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    };
    Keccak.prototype.assertExists = function (checkFinished) {
        if (checkFinished === void 0) { checkFinished = true; }
        if (this.destroyed)
            throw new Error('Hash instance has been destroyed');
        if (checkFinished && this.finished)
            throw new Error('Hash#digest() has already been called');
    };
    return Keccak;
}(utils_1.Hash));
exports.Keccak = Keccak;
var gen = function (suffix, blockLen, outputLen) {
    return (0, utils_1.wrapConstructor)(function () { return new Keccak(blockLen, suffix, outputLen); });
};
// export const sha3_224 = /** @__PURE__ */ gen(0x06, 144, 224 / 8);
// /**
//  * SHA3-256 hash function
//  * @param message - that would be hashed
//  */
// export const sha3_256 = /** @__PURE__ */ gen(0x06, 136, 256 / 8);
// export const sha3_384 = /** @__PURE__ */ gen(0x06, 104, 384 / 8);
// export const sha3_512 = /** @__PURE__ */ gen(0x06, 72, 512 / 8);
exports.keccak_224 = gen(0x01, 144, 224 / 8);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */
exports.keccak_256 = gen(0x01, 136, 256 / 8);
exports.keccak_384 = gen(0x01, 104, 384 / 8);
exports.keccak_512 = gen(0x01, 72, 512 / 8);
// const genShake = (suffix: number, blockLen: number, outputLen: number) =>
//   wrapXOFConstructorWithOpts<HashXOF<Keccak>, ShakeOpts>(
//     (opts: ShakeOpts = {}) =>
//       new Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true)
//   );
// 
// export const shake128 = /** @__PURE__ */ genShake(0x1f, 168, 128 / 8);
// export const shake256 = /** @__PURE__ */ genShake(0x1f, 136, 256 / 8);


/***/ }),

/***/ 91405:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var e_1, _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RIPEMD160 = void 0;
/**
 * RIPEMD-160 legacy hash function.
 * https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
 * https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
 * @module
 */
var _md_1 = __webpack_require__(7946);
var utils_1 = __webpack_require__(88627);
var Rho = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]);
var Id = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map(function (_, i) { return i; }));
var Pi = /* @__PURE__ */ Id.map(function (i) { return (9 * i + 5) % 16; });
var idxL = [Id];
var idxR = [Pi];
for (var i = 0; i < 4; i++)
    try {
        for (var _b = (e_1 = void 0, __values([idxL, idxR])), _c = _b.next(); !_c.done; _c = _b.next()) {
            var j = _c.value;
            j.push(j[i].map(function (k) { return Rho[k]; }));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
var shifts = /* @__PURE__ */ [
    [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
    [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
    [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
    [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
    [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5],
].map(function (i) { return new Uint8Array(i); });
var shiftsL = /* @__PURE__ */ idxL.map(function (idx, i) { return idx.map(function (j) { return shifts[i][j]; }); });
var shiftsR = /* @__PURE__ */ idxR.map(function (idx, i) { return idx.map(function (j) { return shifts[i][j]; }); });
var Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e,
]);
var Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000,
]);
// It's called f() in spec.
function f(group, x, y, z) {
    if (group === 0)
        return x ^ y ^ z;
    else if (group === 1)
        return (x & y) | (~x & z);
    else if (group === 2)
        return (x | ~y) ^ z;
    else if (group === 3)
        return (x & z) | (y & ~z);
    else
        return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
var R_BUF = /* @__PURE__ */ new Uint32Array(16);
var RIPEMD160 = /** @class */ (function (_super) {
    __extends(RIPEMD160, _super);
    function RIPEMD160() {
        var _this = _super.call(this, 64, 20, 8, true) || this;
        _this.h0 = 0x67452301 | 0;
        _this.h1 = 0xefcdab89 | 0;
        _this.h2 = 0x98badcfe | 0;
        _this.h3 = 0x10325476 | 0;
        _this.h4 = 0xc3d2e1f0 | 0;
        return _this;
    }
    RIPEMD160.prototype.get = function () {
        var _a = this, h0 = _a.h0, h1 = _a.h1, h2 = _a.h2, h3 = _a.h3, h4 = _a.h4;
        return [h0, h1, h2, h3, h4];
    };
    RIPEMD160.prototype.set = function (h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    };
    RIPEMD160.prototype.process = function (view, offset) {
        for (var i = 0; i < 16; i++, offset += 4)
            R_BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        var al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for (var group = 0; group < 5; group++) {
            var rGroup = 4 - group;
            var hbl = Kl[group], hbr = Kr[group]; // prettier-ignore
            var rl = idxL[group], rr = idxR[group]; // prettier-ignore
            var sl = shiftsL[group], sr = shiftsR[group]; // prettier-ignore
            for (var i = 0; i < 16; i++) {
                var tl = ((0, utils_1.rotl)(al + f(group, bl, cl, dl) + R_BUF[rl[i]] + hbl, sl[i]) + el) | 0;
                al = el, el = dl, dl = (0, utils_1.rotl)(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for (var i = 0; i < 16; i++) {
                var tr = ((0, utils_1.rotl)(ar + f(rGroup, br, cr, dr) + R_BUF[rr[i]] + hbr, sr[i]) + er) | 0;
                ar = er, er = dr, dr = (0, utils_1.rotl)(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set((this.h1 + cl + dr) | 0, (this.h2 + dl + er) | 0, (this.h3 + el + ar) | 0, (this.h4 + al + br) | 0, (this.h0 + bl + cr) | 0);
    };
    RIPEMD160.prototype.roundClean = function () {
        R_BUF.fill(0);
    };
    RIPEMD160.prototype.destroy = function () {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    };
    return RIPEMD160;
}(_md_1.HashMD));
exports.RIPEMD160 = RIPEMD160;
/** RIPEMD-160 - a legacy hash function from 1990s. */
var _ripemd160 = /* @__PURE__ */ (0, utils_1.wrapConstructor)(function () { return new RIPEMD160(); });


/***/ }),

/***/ 24867:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.verifySecp256k1 = exports.signSecp256k1 = exports.encodeToCurve = exports.hashToCurve = exports.schnorr = exports.verifySchnorr = exports.signSchnorr = exports.Secp256k1Point = exports.secp256k1PointToBytes = exports.secp256k1 = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
var sha256_1 = __webpack_require__(68748);
var utils_1 = __webpack_require__(88627);
var modular_1 = __webpack_require__(83827);
var weierstrass_1 = __webpack_require__(31637);
var utils_2 = __webpack_require__(52993);
var hash_to_curve_1 = __webpack_require__(41721);
var _shortw_utils_1 = __webpack_require__(18523);
var secp256k1P = BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f');
var secp256k1N = BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141');
var _1n = BigInt(1);
var _2n = BigInt(2);
var divNearest = function (a, b) { return (a + b / _2n) / b; };
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */
function sqrtMod(y) {
    var P = secp256k1P;
    var _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    var _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    var b2 = (y * y * y) % P; // x^3, 11
    var b3 = (b2 * b2 * y) % P; // x^7
    var b6 = ((0, modular_1.pow2)(b3, _3n, P) * b3) % P;
    var b9 = ((0, modular_1.pow2)(b6, _3n, P) * b3) % P;
    var b11 = ((0, modular_1.pow2)(b9, _2n, P) * b2) % P;
    var b22 = ((0, modular_1.pow2)(b11, _11n, P) * b11) % P;
    var b44 = ((0, modular_1.pow2)(b22, _22n, P) * b22) % P;
    var b88 = ((0, modular_1.pow2)(b44, _44n, P) * b44) % P;
    var b176 = ((0, modular_1.pow2)(b88, _88n, P) * b88) % P;
    var b220 = ((0, modular_1.pow2)(b176, _44n, P) * b44) % P;
    var b223 = ((0, modular_1.pow2)(b220, _3n, P) * b3) % P;
    var t1 = ((0, modular_1.pow2)(b223, _23n, P) * b22) % P;
    var t2 = ((0, modular_1.pow2)(t1, _6n, P) * b2) % P;
    var root = (0, modular_1.pow2)(t2, _2n, P);
    if (!Fp.eql(Fp.sqr(root), y))
        throw new Error('Cannot find square root');
    return root;
}
var Fp = (0, modular_1.Field)(secp256k1P, undefined, undefined, { sqrt: sqrtMod });
exports.secp256k1 = (0, _shortw_utils_1.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: Fp,
    n: secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt('55066263022277343669578718895168534326250603453777594175500187360389116729240'),
    Gy: BigInt('32670510020758816978083085130507043184471273380659243275938904335757337482424'),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */
    endo: {
        beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
        splitScalar: function (k) {
            var n = secp256k1N;
            var a1 = BigInt('0x3086d221a7d46bcde86c90e49284eb15');
            var b1 = -_1n * BigInt('0xe4437ed6010e88286f547fa90abfe4c3');
            var a2 = BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8');
            var b2 = a1;
            var POW_2_128 = BigInt('0x100000000000000000000000000000000'); // (2n**128n).toString(16)
            var c1 = divNearest(b2 * k, n);
            var c2 = divNearest(-b1 * k, n);
            var k1 = (0, modular_1.mod)(k - c1 * a1 - c2 * a2, n);
            var k2 = (0, modular_1.mod)(-c1 * b1 - c2 * b2, n);
            var k1neg = k1 > POW_2_128;
            var k2neg = k2 > POW_2_128;
            if (k1neg)
                k1 = n - k1;
            if (k2neg)
                k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) {
                throw new Error('splitScalar: Endomorphism failed, k=' + k);
            }
            return { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 };
        },
    },
}, sha256_1.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
var _0n = BigInt(0);
var fe = function (x) { return typeof x === 'bigint' && _0n < x && x < secp256k1P; };
var ge = function (x) { return typeof x === 'bigint' && _0n < x && x < secp256k1N; };
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */
var TAGGED_HASH_PREFIXES = {};
function taggedHash(tag) {
    var messages = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        messages[_i - 1] = arguments[_i];
    }
    var tagP = TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        var tagH = (0, sha256_1.sha256)(Uint8Array.from(tag, function (c) { return c.charCodeAt(0); }));
        tagP = (0, utils_2.concatBytes)(tagH, tagH);
        TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, sha256_1.sha256)(utils_2.concatBytes.apply(void 0, __spreadArray([tagP], __read(messages), false)));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
var pointToBytes = function (point) { return point.toRawBytes(true).slice(1); };
exports.secp256k1PointToBytes = pointToBytes;
var numTo32b = function (n) { return (0, utils_2.numberToBytesBE)(n, 32); };
var modP = function (x) { return (0, modular_1.mod)(x, secp256k1P); };
var modN = function (x) { return (0, modular_1.mod)(x, secp256k1N); };
var Point = exports.secp256k1.ProjectivePoint;
exports.Secp256k1Point = exports.secp256k1.ProjectivePoint;
var GmulAdd = function (Q, a, b) {
    return Point.BASE.multiplyAndAddUnsafe(Q, a, b);
};
// Calculate point, scalar and bytes
function schnorrGetExtPubKey(priv) {
    var d_ = exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    var p = Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    var scalar = p.hasEvenY() ? d_ : modN(-d_);
    return { scalar: scalar, bytes: pointToBytes(p) };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */
function lift_x(x) {
    if (!fe(x))
        throw new Error('bad x: need 0 < x < p'); // Fail if x ≥ p.
    var xx = modP(x * x);
    var c = modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    var y = sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % _2n !== _0n)
        y = modP(-y); // Return the unique point P such that x(P) = x and
    var p = new Point(x, y, _1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */
function challenge() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return modN((0, utils_2.bytesToNumberBE)(taggedHash.apply(void 0, __spreadArray(['BIP0340/challenge'], __read(args), false))));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */
function schnorrGetPublicKey(privateKey) {
    return schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */
function schnorrSign(message, privateKey, auxRand) {
    if (auxRand === void 0) { auxRand = (0, utils_1.randomBytes)(32); }
    var m = (0, utils_2.ensureBytes)('message', message);
    var _a = schnorrGetExtPubKey(privateKey), px = _a.bytes, d = _a.scalar; // checks for isWithinCurveOrder
    var a = (0, utils_2.ensureBytes)('auxRand', auxRand, 32); // Auxiliary random data a: a 32-byte array
    var t = numTo32b(d ^ (0, utils_2.bytesToNumberBE)(taggedHash('BIP0340/aux', a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    var rand = taggedHash('BIP0340/nonce', t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    var k_ = modN((0, utils_2.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === _0n)
        throw new Error('sign failed: k is zero'); // Fail if k' = 0.
    var _b = schnorrGetExtPubKey(k_), rx = _b.bytes, k = _b.scalar; // Let R = k'⋅G.
    var e = challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    var sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set(numTo32b(modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!schnorrVerify(sig, m, px))
        throw new Error('sign: Invalid signature produced');
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */
function schnorrVerify(signature, message, publicKey) {
    var sig = (0, utils_2.ensureBytes)('signature', signature, 64);
    var m = (0, utils_2.ensureBytes)('message', message);
    var pub = (0, utils_2.ensureBytes)('publicKey', publicKey, 32);
    try {
        var P = lift_x((0, utils_2.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        var r = (0, utils_2.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!fe(r))
            return false;
        var s = (0, utils_2.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!ge(s))
            return false;
        var e = challenge(numTo32b(r), pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        var R = GmulAdd(P, s, modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r)
            return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    }
    catch (error) {
        return false;
    }
}
exports.signSchnorr = schnorrSign;
exports.verifySchnorr = schnorrVerify;
exports.schnorr = (function () { return ({
    getPublicKey: schnorrGetPublicKey,
    sign: schnorrSign,
    verify: schnorrVerify,
    utils: {
        randomPrivateKey: exports.secp256k1.utils.randomPrivateKey,
        lift_x: lift_x,
        pointToBytes: pointToBytes,
        numberToBytesBE: utils_2.numberToBytesBE,
        bytesToNumberBE: utils_2.bytesToNumberBE,
        taggedHash: taggedHash,
        mod: modular_1.mod,
    },
}); })();
var isoMap = /* @__PURE__ */ (function () {
    return (0, hash_to_curve_1.isogenyMap)(Fp, [
        // xNum
        [
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7',
            '0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581',
            '0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262',
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c',
        ],
        // xDen
        [
            '0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b',
            '0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14',
            '0x0000000000000000000000000000000000000000000000000000000000000001', // LAST 1
        ],
        // yNum
        [
            '0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c',
            '0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3',
            '0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931',
            '0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84',
        ],
        // yDen
        [
            '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b',
            '0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573',
            '0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f',
            '0x0000000000000000000000000000000000000000000000000000000000000001', // LAST 1
        ],
    ].map(function (i) { return i.map(function (j) { return BigInt(j); }); }));
})();
var mapSWU = /* @__PURE__ */ (function () {
    return (0, weierstrass_1.mapToCurveSimpleSWU)(Fp, {
        A: BigInt('0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533'),
        B: BigInt('1771'),
        Z: Fp.create(BigInt('-11')),
    });
})();
var htf = /* @__PURE__ */ (function () {
    return (0, hash_to_curve_1.createHasher)(exports.secp256k1.ProjectivePoint, function (scalars) {
        var _a = mapSWU(Fp.create(scalars[0])), x = _a.x, y = _a.y;
        return isoMap(x, y);
    }, {
        DST: 'secp256k1_XMD:SHA-256_SSWU_RO_',
        encodeDST: 'secp256k1_XMD:SHA-256_SSWU_NU_',
        p: Fp.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: sha256_1.sha256,
    });
})();
exports.hashToCurve = (function () { return htf.hashToCurve; })();
exports.encodeToCurve = (function () { return htf.encodeToCurve; })();
function signSecp256k1(data, privateKey, extraEntropy) {
    return exports.secp256k1.sign(data, privateKey, { extraEntropy: extraEntropy }).toCompactRawBytes();
}
exports.signSecp256k1 = signSecp256k1;
var myDefaultVerOpts = { lowS: true, prehash: false };
function verifySecp256k1(sig, msgHash, pubKey) {
    return exports.secp256k1.verify(sig, msgHash, pubKey, myDefaultVerOpts);
}
exports.verifySecp256k1 = verifySecp256k1;


/***/ }),

/***/ 68748:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha224 = exports.sha256 = void 0;
var _md_1 = __webpack_require__(7946);
var utils_1 = __webpack_require__(88627);
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
var SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
var SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
var SHA256_W = /* @__PURE__ */ new Uint32Array(64);
var SHA256 = /** @class */ (function (_super) {
    __extends(SHA256, _super);
    function SHA256() {
        var _this = _super.call(this, 64, 32, 8, false) || this;
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        _this.A = SHA256_IV[0] | 0;
        _this.B = SHA256_IV[1] | 0;
        _this.C = SHA256_IV[2] | 0;
        _this.D = SHA256_IV[3] | 0;
        _this.E = SHA256_IV[4] | 0;
        _this.F = SHA256_IV[5] | 0;
        _this.G = SHA256_IV[6] | 0;
        _this.H = SHA256_IV[7] | 0;
        return _this;
    }
    SHA256.prototype.get = function () {
        var _a = this, A = _a.A, B = _a.B, C = _a.C, D = _a.D, E = _a.E, F = _a.F, G = _a.G, H = _a.H;
        return [A, B, C, D, E, F, G, H];
    };
    // prettier-ignore
    SHA256.prototype.set = function (A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    };
    SHA256.prototype.process = function (view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for (var i = 0; i < 16; i++, offset += 4)
            SHA256_W[i] = view.getUint32(offset, false);
        for (var i = 16; i < 64; i++) {
            var W15 = SHA256_W[i - 15];
            var W2 = SHA256_W[i - 2];
            var s0 = (0, utils_1.rotr)(W15, 7) ^ (0, utils_1.rotr)(W15, 18) ^ (W15 >>> 3);
            var s1 = (0, utils_1.rotr)(W2, 17) ^ (0, utils_1.rotr)(W2, 19) ^ (W2 >>> 10);
            SHA256_W[i] = (s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16]) | 0;
        }
        // Compression function main loop, 64 rounds
        var _a = this, A = _a.A, B = _a.B, C = _a.C, D = _a.D, E = _a.E, F = _a.F, G = _a.G, H = _a.H;
        for (var i = 0; i < 64; i++) {
            var sigma1 = (0, utils_1.rotr)(E, 6) ^ (0, utils_1.rotr)(E, 11) ^ (0, utils_1.rotr)(E, 25);
            var T1 = (H + sigma1 + (0, _md_1.Chi)(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            var sigma0 = (0, utils_1.rotr)(A, 2) ^ (0, utils_1.rotr)(A, 13) ^ (0, utils_1.rotr)(A, 22);
            var T2 = (sigma0 + (0, _md_1.Maj)(A, B, C)) | 0;
            H = G;
            G = F;
            F = E;
            E = (D + T1) | 0;
            D = C;
            C = B;
            B = A;
            A = (T1 + T2) | 0;
        }
        // Add the compressed chunk to the current hash value
        A = (A + this.A) | 0;
        B = (B + this.B) | 0;
        C = (C + this.C) | 0;
        D = (D + this.D) | 0;
        E = (E + this.E) | 0;
        F = (F + this.F) | 0;
        G = (G + this.G) | 0;
        H = (H + this.H) | 0;
        this.set(A, B, C, D, E, F, G, H);
    };
    SHA256.prototype.roundClean = function () {
        SHA256_W.fill(0);
    };
    SHA256.prototype.destroy = function () {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    };
    return SHA256;
}(_md_1.HashMD));
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
var SHA224 = /** @class */ (function (_super) {
    __extends(SHA224, _super);
    function SHA224() {
        var _this = _super.call(this) || this;
        _this.A = 0xc1059ed8 | 0;
        _this.B = 0x367cd507 | 0;
        _this.C = 0x3070dd17 | 0;
        _this.D = 0xf70e5939 | 0;
        _this.E = 0xffc00b31 | 0;
        _this.F = 0x68581511 | 0;
        _this.G = 0x64f98fa7 | 0;
        _this.H = 0xbefa4fa4 | 0;
        _this.outputLen = 28;
        return _this;
    }
    return SHA224;
}(SHA256));
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */
exports.sha256 = (0, utils_1.wrapConstructor)(function () { return new SHA256(); });
exports.sha224 = (0, utils_1.wrapConstructor)(function () { return new SHA224(); });


/***/ }),

/***/ 3944:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha384 = exports.sha512_256 = exports.sha512_224 = exports.sha512 = exports.SHA512 = void 0;
var _md_1 = __webpack_require__(7946);
var u64 = __importStar(__webpack_require__(20204));
var utils_1 = __webpack_require__(88627);
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
var _a = __read(/* @__PURE__ */ (function () { return u64.split([
    '0x428a2f98d728ae22', '0x7137449123ef65cd', '0xb5c0fbcfec4d3b2f', '0xe9b5dba58189dbbc',
    '0x3956c25bf348b538', '0x59f111f1b605d019', '0x923f82a4af194f9b', '0xab1c5ed5da6d8118',
    '0xd807aa98a3030242', '0x12835b0145706fbe', '0x243185be4ee4b28c', '0x550c7dc3d5ffb4e2',
    '0x72be5d74f27b896f', '0x80deb1fe3b1696b1', '0x9bdc06a725c71235', '0xc19bf174cf692694',
    '0xe49b69c19ef14ad2', '0xefbe4786384f25e3', '0x0fc19dc68b8cd5b5', '0x240ca1cc77ac9c65',
    '0x2de92c6f592b0275', '0x4a7484aa6ea6e483', '0x5cb0a9dcbd41fbd4', '0x76f988da831153b5',
    '0x983e5152ee66dfab', '0xa831c66d2db43210', '0xb00327c898fb213f', '0xbf597fc7beef0ee4',
    '0xc6e00bf33da88fc2', '0xd5a79147930aa725', '0x06ca6351e003826f', '0x142929670a0e6e70',
    '0x27b70a8546d22ffc', '0x2e1b21385c26c926', '0x4d2c6dfc5ac42aed', '0x53380d139d95b3df',
    '0x650a73548baf63de', '0x766a0abb3c77b2a8', '0x81c2c92e47edaee6', '0x92722c851482353b',
    '0xa2bfe8a14cf10364', '0xa81a664bbc423001', '0xc24b8b70d0f89791', '0xc76c51a30654be30',
    '0xd192e819d6ef5218', '0xd69906245565a910', '0xf40e35855771202a', '0x106aa07032bbd1b8',
    '0x19a4c116b8d2d0c8', '0x1e376c085141ab53', '0x2748774cdf8eeb99', '0x34b0bcb5e19b48a8',
    '0x391c0cb3c5c95a63', '0x4ed8aa4ae3418acb', '0x5b9cca4f7763e373', '0x682e6ff3d6b2b8a3',
    '0x748f82ee5defb2fc', '0x78a5636f43172f60', '0x84c87814a1f0ab72', '0x8cc702081a6439ec',
    '0x90befffa23631e28', '0xa4506cebde82bde9', '0xbef9a3f7b2c67915', '0xc67178f2e372532b',
    '0xca273eceea26619c', '0xd186b8c721c0c207', '0xeada7dd6cde0eb1e', '0xf57d4f7fee6ed178',
    '0x06f067aa72176fba', '0x0a637dc5a2c898a6', '0x113f9804bef90dae', '0x1b710b35131c471b',
    '0x28db77f523047d84', '0x32caab7b40c72493', '0x3c9ebe0a15c9bebc', '0x431d67c49c100d4c',
    '0x4cc5d4becb3e42b6', '0x597f299cfc657e2a', '0x5fcb6fab3ad6faec', '0x6c44198c4a475817'
].map(function (n) { return BigInt(n); })); })(), 2), SHA512_Kh = _a[0], SHA512_Kl = _a[1];
// Temporary buffer, not used to store anything between runs
var SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
var SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
var SHA512 = /** @class */ (function (_super) {
    __extends(SHA512, _super);
    function SHA512() {
        var _this = _super.call(this, 128, 64, 16, false) || this;
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 0x6a09e667 | 0;
        _this.Al = 0xf3bcc908 | 0;
        _this.Bh = 0xbb67ae85 | 0;
        _this.Bl = 0x84caa73b | 0;
        _this.Ch = 0x3c6ef372 | 0;
        _this.Cl = 0xfe94f82b | 0;
        _this.Dh = 0xa54ff53a | 0;
        _this.Dl = 0x5f1d36f1 | 0;
        _this.Eh = 0x510e527f | 0;
        _this.El = 0xade682d1 | 0;
        _this.Fh = 0x9b05688c | 0;
        _this.Fl = 0x2b3e6c1f | 0;
        _this.Gh = 0x1f83d9ab | 0;
        _this.Gl = 0xfb41bd6b | 0;
        _this.Hh = 0x5be0cd19 | 0;
        _this.Hl = 0x137e2179 | 0;
        return _this;
    }
    // prettier-ignore
    SHA512.prototype.get = function () {
        var _a = this, Ah = _a.Ah, Al = _a.Al, Bh = _a.Bh, Bl = _a.Bl, Ch = _a.Ch, Cl = _a.Cl, Dh = _a.Dh, Dl = _a.Dl, Eh = _a.Eh, El = _a.El, Fh = _a.Fh, Fl = _a.Fl, Gh = _a.Gh, Gl = _a.Gl, Hh = _a.Hh, Hl = _a.Hl;
        return [Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl];
    };
    // prettier-ignore
    SHA512.prototype.set = function (Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    };
    SHA512.prototype.process = function (view, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for (var i = 0; i < 16; i++, offset += 4) {
            SHA512_W_H[i] = view.getUint32(offset);
            SHA512_W_L[i] = view.getUint32((offset += 4));
        }
        for (var i = 16; i < 80; i++) {
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            var W15h = SHA512_W_H[i - 15] | 0;
            var W15l = SHA512_W_L[i - 15] | 0;
            var s0h = u64.rotrSH(W15h, W15l, 1) ^ u64.rotrSH(W15h, W15l, 8) ^ u64.shrSH(W15h, W15l, 7);
            var s0l = u64.rotrSL(W15h, W15l, 1) ^ u64.rotrSL(W15h, W15l, 8) ^ u64.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            var W2h = SHA512_W_H[i - 2] | 0;
            var W2l = SHA512_W_L[i - 2] | 0;
            var s1h = u64.rotrSH(W2h, W2l, 19) ^ u64.rotrBH(W2h, W2l, 61) ^ u64.shrSH(W2h, W2l, 6);
            var s1l = u64.rotrSL(W2h, W2l, 19) ^ u64.rotrBL(W2h, W2l, 61) ^ u64.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            var SUMl = u64.add4L(s0l, s1l, SHA512_W_L[i - 7], SHA512_W_L[i - 16]);
            var SUMh = u64.add4H(SUMl, s0h, s1h, SHA512_W_H[i - 7], SHA512_W_H[i - 16]);
            SHA512_W_H[i] = SUMh | 0;
            SHA512_W_L[i] = SUMl | 0;
        }
        var _k = this, Ah = _k.Ah, Al = _k.Al, Bh = _k.Bh, Bl = _k.Bl, Ch = _k.Ch, Cl = _k.Cl, Dh = _k.Dh, Dl = _k.Dl, Eh = _k.Eh, El = _k.El, Fh = _k.Fh, Fl = _k.Fl, Gh = _k.Gh, Gl = _k.Gl, Hh = _k.Hh, Hl = _k.Hl;
        // Compression function main loop, 80 rounds
        for (var i = 0; i < 80; i++) {
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            var sigma1h = u64.rotrSH(Eh, El, 14) ^ u64.rotrSH(Eh, El, 18) ^ u64.rotrBH(Eh, El, 41);
            var sigma1l = u64.rotrSL(Eh, El, 14) ^ u64.rotrSL(Eh, El, 18) ^ u64.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            var CHIh = (Eh & Fh) ^ (~Eh & Gh);
            var CHIl = (El & Fl) ^ (~El & Gl);
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            var T1ll = u64.add5L(Hl, sigma1l, CHIl, SHA512_Kl[i], SHA512_W_L[i]);
            var T1h = u64.add5H(T1ll, Hh, sigma1h, CHIh, SHA512_Kh[i], SHA512_W_H[i]);
            var T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            var sigma0h = u64.rotrSH(Ah, Al, 28) ^ u64.rotrBH(Ah, Al, 34) ^ u64.rotrBH(Ah, Al, 39);
            var sigma0l = u64.rotrSL(Ah, Al, 28) ^ u64.rotrBL(Ah, Al, 34) ^ u64.rotrBL(Ah, Al, 39);
            var MAJh = (Ah & Bh) ^ (Ah & Ch) ^ (Bh & Ch);
            var MAJl = (Al & Bl) ^ (Al & Cl) ^ (Bl & Cl);
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            (_a = u64.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0), Eh = _a.h, El = _a.l);
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            var All = u64.add3L(T1l, sigma0l, MAJl);
            Ah = u64.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        (_b = u64.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0), Ah = _b.h, Al = _b.l);
        (_c = u64.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0), Bh = _c.h, Bl = _c.l);
        (_d = u64.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0), Ch = _d.h, Cl = _d.l);
        (_e = u64.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0), Dh = _e.h, Dl = _e.l);
        (_f = u64.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0), Eh = _f.h, El = _f.l);
        (_g = u64.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0), Fh = _g.h, Fl = _g.l);
        (_h = u64.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0), Gh = _h.h, Gl = _h.l);
        (_j = u64.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0), Hh = _j.h, Hl = _j.l);
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    };
    SHA512.prototype.roundClean = function () {
        SHA512_W_H.fill(0);
        SHA512_W_L.fill(0);
    };
    SHA512.prototype.destroy = function () {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    };
    return SHA512;
}(_md_1.HashMD));
exports.SHA512 = SHA512;
var SHA512_224 = /** @class */ (function (_super) {
    __extends(SHA512_224, _super);
    function SHA512_224() {
        var _this = _super.call(this) || this;
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 0x8c3d37c8 | 0;
        _this.Al = 0x19544da2 | 0;
        _this.Bh = 0x73e19966 | 0;
        _this.Bl = 0x89dcd4d6 | 0;
        _this.Ch = 0x1dfab7ae | 0;
        _this.Cl = 0x32ff9c82 | 0;
        _this.Dh = 0x679dd514 | 0;
        _this.Dl = 0x582f9fcf | 0;
        _this.Eh = 0x0f6d2b69 | 0;
        _this.El = 0x7bd44da8 | 0;
        _this.Fh = 0x77e36f73 | 0;
        _this.Fl = 0x04c48942 | 0;
        _this.Gh = 0x3f9d85a8 | 0;
        _this.Gl = 0x6a1d36c8 | 0;
        _this.Hh = 0x1112e6ad | 0;
        _this.Hl = 0x91d692a1 | 0;
        _this.outputLen = 28;
        return _this;
    }
    return SHA512_224;
}(SHA512));
var SHA512_256 = /** @class */ (function (_super) {
    __extends(SHA512_256, _super);
    function SHA512_256() {
        var _this = _super.call(this) || this;
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 0x22312194 | 0;
        _this.Al = 0xfc2bf72c | 0;
        _this.Bh = 0x9f555fa3 | 0;
        _this.Bl = 0xc84c64c2 | 0;
        _this.Ch = 0x2393b86b | 0;
        _this.Cl = 0x6f53b151 | 0;
        _this.Dh = 0x96387719 | 0;
        _this.Dl = 0x5940eabd | 0;
        _this.Eh = 0x96283ee2 | 0;
        _this.El = 0xa88effe3 | 0;
        _this.Fh = 0xbe5e1e25 | 0;
        _this.Fl = 0x53863992 | 0;
        _this.Gh = 0x2b0199fc | 0;
        _this.Gl = 0x2c85b8aa | 0;
        _this.Hh = 0x0eb72ddc | 0;
        _this.Hl = 0x81c52ca2 | 0;
        _this.outputLen = 32;
        return _this;
    }
    return SHA512_256;
}(SHA512));
var SHA384 = /** @class */ (function (_super) {
    __extends(SHA384, _super);
    function SHA384() {
        var _this = _super.call(this) || this;
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 0xcbbb9d5d | 0;
        _this.Al = 0xc1059ed8 | 0;
        _this.Bh = 0x629a292a | 0;
        _this.Bl = 0x367cd507 | 0;
        _this.Ch = 0x9159015a | 0;
        _this.Cl = 0x3070dd17 | 0;
        _this.Dh = 0x152fecd8 | 0;
        _this.Dl = 0xf70e5939 | 0;
        _this.Eh = 0x67332667 | 0;
        _this.El = 0xffc00b31 | 0;
        _this.Fh = 0x8eb44a87 | 0;
        _this.Fl = 0x68581511 | 0;
        _this.Gh = 0xdb0c2e0d | 0;
        _this.Gl = 0x64f98fa7 | 0;
        _this.Hh = 0x47b5481d | 0;
        _this.Hl = 0xbefa4fa4 | 0;
        _this.outputLen = 48;
        return _this;
    }
    return SHA384;
}(SHA512));
exports.sha512 = (0, utils_1.wrapConstructor)(function () { return new SHA512(); });
exports.sha512_224 = (0, utils_1.wrapConstructor)(function () { return new SHA512_224(); });
exports.sha512_256 = (0, utils_1.wrapConstructor)(function () { return new SHA512_256(); });
exports.sha384 = (0, utils_1.wrapConstructor)(function () { return new SHA384(); });


/***/ }),

/***/ 88627:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/*
THIS IMPLEMENTATION WAS TAKEN FROM `@noble/hashes`

original source: https://github.com/paulmillr/noble-hashes/blob/6ae82e75d4c354d53a488e95b1bfe9cba90bd6ff/src/utils.ts#L1

it was modified and adapted to this repository to re-use already defined stuff

the main reason for copying over and not using as dependency is because of different target in the `tsconfig.json`

`@noble/hashes` targets es2020, which tends to cause problems with some other (older) packages sometimes

this repo targets ES5+
*/
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.randomBytes = exports.wrapXOFConstructorWithOpts = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.checkOpts = exports.Hash = exports.concatBytes = exports.toBytes = exports.asyncLoop = exports.nextTick = exports.hexToBytes = exports.bytesToHex = exports.byteSwap32 = exports.byteSwapIfBE = exports.byteSwap = exports.isLE = exports.rotl = exports.rotr = exports.createView = exports.u32 = exports.u8 = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var assert_1 = __webpack_require__(24055);
var crypto_1 = __webpack_require__(26518);
// Cast array to different type
var u8 = function (arr) { return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength); };
exports.u8 = u8;
var u32 = function (arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
};
exports.u32 = u32;
// Cast array to view
var createView = function (arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
};
exports.createView = createView;
// The rotate right (circular right shift) operation for uint32
var rotr = function (word, shift) { return (word << (32 - shift)) | (word >>> shift); };
exports.rotr = rotr;
// The rotate left (circular left shift) operation for uint32
var rotl = function (word, shift) {
    return (word << shift) | ((word >>> (32 - shift)) >>> 0);
};
exports.rotl = rotl;
exports.isLE = new Uint8Array(new Uint32Array([0x11223344]).buffer)[0] === 0x44;
// The byte swap operation for uint32
var byteSwap = function (word) {
    return ((word << 24) & 0xff000000) |
        ((word << 8) & 0xff0000) |
        ((word >>> 8) & 0xff00) |
        ((word >>> 24) & 0xff);
};
exports.byteSwap = byteSwap;
// Conditionally byte swap if on a big-endian platform
exports.byteSwapIfBE = exports.isLE ? function (n) { return n; } : function (n) { return (0, exports.byteSwap)(n); };
// In place byte swap for Uint32Array
function byteSwap32(arr) {
    for (var i = 0; i < arr.length; i++) {
        arr[i] = (0, exports.byteSwap)(arr[i]);
    }
}
exports.byteSwap32 = byteSwap32;
// Array where index 0xf0 (240) is mapped to string 'f0'
var hexes = /* @__PURE__ */ Array.from({ length: 256 }, function (_, i) {
    return i.toString(16).padStart(2, '0');
});
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */
function bytesToHex(bytes) {
    (0, assert_1.assertBytes)(bytes);
    // pre-caching improves the speed 6x
    var hex = '';
    for (var i = 0; i < bytes.length; i++) {
        hex += hexes[bytes[i]];
    }
    return hex;
}
exports.bytesToHex = bytesToHex;
// We use optimized technique to convert hex string to byte array
var asciis = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9)
        return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F)
        return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f)
        return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */
function hexToBytes(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    var hl = hex.length;
    var al = hl / 2;
    if (hl % 2)
        throw new Error('padded hex string expected, got unpadded hex of length ' + hl);
    var array = new Uint8Array(al);
    for (var ai = 0, hi = 0; ai < al; ai++, hi += 2) {
        var n1 = asciiToBase16(hex.charCodeAt(hi));
        var n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            var char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
var nextTick = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_b) {
    return [2 /*return*/];
}); }); };
exports.nextTick = nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
function asyncLoop(iters, tick, cb) {
    return __awaiter(this, void 0, void 0, function () {
        var ts, i, diff;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ts = Date.now();
                    i = 0;
                    _b.label = 1;
                case 1:
                    if (!(i < iters)) return [3 /*break*/, 4];
                    cb(i);
                    diff = Date.now() - ts;
                    if (diff >= 0 && diff < tick)
                        return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, exports.nextTick)()];
                case 2:
                    _b.sent();
                    ts += diff;
                    _b.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.asyncLoop = asyncLoop;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */
function toBytes(data) {
    if (typeof data === 'string')
        data = (0, uint8array_utils_1.fromUtf8)(data);
    (0, assert_1.assertBytes)(data);
    return data;
}
exports.toBytes = toBytes;
/**
 * Copies several Uint8Arrays into one.
 */
function concatBytes() {
    var arrays = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arrays[_i] = arguments[_i];
    }
    var sum = 0;
    for (var i = 0; i < arrays.length; i++) {
        var a = arrays[i];
        (0, assert_1.assertBytes)(a);
        sum += a.length;
    }
    var res = new Uint8Array(sum);
    for (var i = 0, pad = 0; i < arrays.length; i++) {
        var a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
exports.concatBytes = concatBytes;
// For runtime check if class implements interface
var Hash = /** @class */ (function () {
    function Hash() {
    }
    // Safe version that clones internal state
    Hash.prototype.clone = function () {
        return this._cloneInto();
    };
    return Hash;
}());
exports.Hash = Hash;
var toStr = {}.toString;
function checkOpts(defaults, opts) {
    if (opts !== undefined && toStr.call(opts) !== '[object Object]')
        throw new Error('Options should be object or undefined');
    var merged = Object.assign(defaults, opts);
    return merged;
}
exports.checkOpts = checkOpts;
function wrapConstructor(hashCons) {
    var hashC = function (msg) { return hashCons().update(toBytes(msg)).digest(); };
    var tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function () { return hashCons(); };
    return hashC;
}
exports.wrapConstructor = wrapConstructor;
function wrapConstructorWithOpts(hashCons) {
    var hashC = function (msg, opts) { return hashCons(opts).update(toBytes(msg)).digest(); };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function (opts) { return hashCons(opts); };
    return hashC;
}
exports.wrapConstructorWithOpts = wrapConstructorWithOpts;
function wrapXOFConstructorWithOpts(hashCons) {
    var hashC = function (msg, opts) { return hashCons(opts).update(toBytes(msg)).digest(); };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function (opts) { return hashCons(opts); };
    return hashC;
}
exports.wrapXOFConstructorWithOpts = wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */
function randomBytes(bytesLength) {
    if (bytesLength === void 0) { bytesLength = 32; }
    if (crypto_1.crypto && typeof crypto_1.crypto.getRandomValues === 'function') {
        return crypto_1.crypto.getRandomValues(new Uint8Array(bytesLength));
    }
    throw new Error('crypto.getRandomValues must be defined');
}
exports.randomBytes = randomBytes;


/***/ }),

/***/ 8891:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ripemd160 = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var ripemd_160_1 = __webpack_require__(91405);
function ripemd160(input) {
    if (typeof input === "string") {
        if (input.startsWith("0x"))
            input = (0, uint8array_utils_1.fromHex)(input.toLowerCase().slice(2));
        else if (isHex(input))
            input = (0, uint8array_utils_1.fromHex)(input.toLowerCase());
        else
            input = (0, uint8array_utils_1.fromUtf8)(input);
    }
    if (!(input instanceof Uint8Array))
        throw new Error("ripemd160: input must be Uint8Array or string");
    return new ripemd_160_1.RIPEMD160().update(input).digest();
}
exports.ripemd160 = ripemd160;
function isHex(str) {
    return /^[0-9A-Fa-f]*$/.test(str);
}


/***/ }),

/***/ 67426:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.verifySchnorrSecp256k1Signature = exports.verifyEcdsaSecp256k1Signature = void 0;
var secp256k1_1 = __webpack_require__(24867);
function verifyEcdsaSecp256k1Signature(vk, // 33 bytes
messageHash, // 32 bytes
signature) {
    if (!(vk instanceof Uint8Array &&
        messageHash instanceof Uint8Array &&
        signature instanceof Uint8Array &&
        vk.length === 33 &&
        messageHash.length === 32 &&
        signature.length === 64))
        throw new TypeError("invalid arguments passed to 'verifyEcdsaSecp256k1Signature'");
    var vkHead = vk[0];
    if (!(vkHead === 0x02 ||
        vkHead === 0x03))
        throw new Error("plutus-machine only supports compressed public keys for 'verifyEcdsaSecp256k1Signature'");
    return (0, secp256k1_1.verifySecp256k1)(signature, messageHash, vk);
}
exports.verifyEcdsaSecp256k1Signature = verifyEcdsaSecp256k1Signature;
function verifySchnorrSecp256k1Signature(pubKey, messageHash, signature) {
    if (!(pubKey instanceof Uint8Array &&
        messageHash instanceof Uint8Array &&
        signature instanceof Uint8Array &&
        pubKey.length === 32 &&
        signature.length === 64))
        throw new TypeError("invalid arguments passed to 'verifyEcdsaSecp256k1Signature'");
    // signature 64
    // pubKey 32
    return (0, secp256k1_1.verifySchnorr)(signature, messageHash, pubKey);
}
exports.verifySchnorrSecp256k1Signature = verifySchnorrSecp256k1Signature;


/***/ }),

/***/ 59777:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha2_256 = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var types_1 = __webpack_require__(62339);
var rotr32_1 = __webpack_require__(85775);
/**
     * Pad a bytearray so its size is a multiple of 64 (512 bits).
     * Internal method.
     */
function pad(src) {
    var nBits = src.length * 8;
    var dst = src.slice();
    dst.push(0x80);
    var nZeroes = (64 - dst.length % 64) - 8;
    if (nZeroes < 0) {
        nZeroes += 64;
    }
    for (var i = 0; i < nZeroes; i++) {
        dst.push(0);
    }
    // assume nBits fits in 32 bits
    dst.push(0);
    dst.push(0);
    dst.push(0);
    dst.push(0);
    dst.push(((nBits >> 24) & 0xff));
    dst.push(((nBits >> 16) & 0xff));
    dst.push(((nBits >> 8) & 0xff));
    dst.push(((nBits >> 0) & 0xff));
    return dst;
}
var k = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
    0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
    0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
    0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
    0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
    0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
    0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
    0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
    0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2,
];
function sigma0(x) {
    return (0, rotr32_1.rotr32)(x, 7) ^ (0, rotr32_1.rotr32)(x, 18) ^ (x >>> 3);
}
function sigma1(x) {
    return (0, rotr32_1.rotr32)(x, 17) ^ (0, rotr32_1.rotr32)(x, 19) ^ (x >>> 10);
}
/**
 * getulates sha2-256 (32bytes) hash of a list of uint8 numbers.
 * Result is also a list of uint8 number.
 * @example
 * bytesToHex(sha2_256([0x61, 0x62, 0x63])) => "ba7816bf8f01cfea414140de5dae2223b00361a396177a9cb410ff61f20015ad"
 * @example
 * sha2_256(textToBytes("Hello, World!")) => [223, 253, 96, 33, 187, 43, 213, 176, 175, 103, 98, 144, 128, 158, 195, 165, 49, 145, 221, 129, 199, 247, 10, 75, 40, 104, 138, 54, 33, 130, 152, 111]
 * @param {uint5[]} bytes - list of uint8 numbers
 * @returns {number[]} - list of uint8 numbers
 */
function sha2_256(bytes) {
    if ((0, uint8array_utils_1.isUint8Array)(bytes)) {
        bytes = (0, types_1.buffToByteArr)(bytes);
    }
    /**
     * Initial hash (updated during compression phase)
     */
    var hash = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19,
    ];
    bytes = pad(bytes);
    // break message in successive 64 byte chunks
    for (var chunkStart = 0; chunkStart < bytes.length; chunkStart += 64) {
        var chunk = bytes.slice(chunkStart, chunkStart + 64);
        var w = (new Array(64)).fill(0); // array of 32 bit numbers!
        // copy chunk into first 16 positions of w
        for (var i = 0; i < 16; i++) {
            w[i] = (chunk[i * 4 + 0] << 24) |
                (chunk[i * 4 + 1] << 16) |
                (chunk[i * 4 + 2] << 8) |
                (chunk[i * 4 + 3]);
        }
        // extends the first 16 positions into the remaining 48 positions
        for (var i = 16; i < 64; i++) {
            w[i] = (w[i - 16] + sigma0(w[i - 15]) + w[i - 7] + sigma1(w[i - 2])) | 0;
        }
        // intialize working variables to current hash value
        var a = hash[0];
        var b = hash[1];
        var c = hash[2];
        var d = hash[3];
        var e = hash[4];
        var f = hash[5];
        var g = hash[6];
        var h = hash[7];
        // compression function main loop
        for (var i = 0; i < 64; i++) {
            var S1 = (0, rotr32_1.rotr32)(e, 6) ^ (0, rotr32_1.rotr32)(e, 11) ^ (0, rotr32_1.rotr32)(e, 25);
            var ch = (e & f) ^ ((~e) & g);
            var temp1 = (h + S1 + ch + k[i] + w[i]) | 0;
            var S0 = (0, rotr32_1.rotr32)(a, 2) ^ (0, rotr32_1.rotr32)(a, 13) ^ (0, rotr32_1.rotr32)(a, 22);
            var maj = (a & b) ^ (a & c) ^ (b & c);
            var temp2 = (S0 + maj) | 0;
            h = g;
            g = f;
            f = e;
            e = (d + temp1) | 0;
            d = c;
            c = b;
            b = a;
            a = (temp1 + temp2) | 0;
        }
        // update the hash
        hash[0] = (hash[0] + a) | 0;
        hash[1] = (hash[1] + b) | 0;
        hash[2] = (hash[2] + c) | 0;
        hash[3] = (hash[3] + d) | 0;
        hash[4] = (hash[4] + e) | 0;
        hash[5] = (hash[5] + f) | 0;
        hash[6] = (hash[6] + g) | 0;
        hash[7] = (hash[7] + h) | 0;
    }
    // produce the final digest of uint8 numbers
    var result = [];
    for (var i = 0; i < 8; i++) {
        var item = hash[i];
        result.push(((item >> 24) & 0xff));
        result.push(((item >> 16) & 0xff));
        result.push(((item >> 8) & 0xff));
        result.push(((item >> 0) & 0xff));
    }
    return new Uint8Array(result);
}
exports.sha2_256 = sha2_256;


/***/ }),

/***/ 45802:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha2_512 = exports._sha2_512_pad = void 0;
var types_1 = __webpack_require__(62339);
/**
 * Pad a bytearray so its size is a multiple of 128 (1024 bits).
 * Internal method.
 */
function _sha2_512_pad(src) {
    var nBits = src.length * 8;
    // clone
    var dst = src.slice();
    dst.push(0x80);
    var nZeroes = (128 - dst.length % 128) - 8;
    if (nZeroes < 0) {
        nZeroes += 128;
    }
    for (var i = 0; i < nZeroes; i++) {
        dst.push(0);
    }
    // assume nBits fits in 32 bits
    dst.push(0);
    dst.push(0);
    dst.push(0);
    dst.push(0);
    dst.push(((nBits >> 24) & 0xff));
    dst.push(((nBits >> 16) & 0xff));
    dst.push(((nBits >> 8) & 0xff));
    dst.push(((nBits >> 0) & 0xff));
    return dst;
}
exports._sha2_512_pad = _sha2_512_pad;
var _sha2_512_k = Object.freeze([
    (0, types_1.uint64)("0x428a2f98d728ae22"), (0, types_1.uint64)("0x7137449123ef65cd"),
    (0, types_1.uint64)("0xb5c0fbcfec4d3b2f"), (0, types_1.uint64)("0xe9b5dba58189dbbc"),
    (0, types_1.uint64)("0x3956c25bf348b538"), (0, types_1.uint64)("0x59f111f1b605d019"),
    (0, types_1.uint64)("0x923f82a4af194f9b"), (0, types_1.uint64)("0xab1c5ed5da6d8118"),
    (0, types_1.uint64)("0xd807aa98a3030242"), (0, types_1.uint64)("0x12835b0145706fbe"),
    (0, types_1.uint64)("0x243185be4ee4b28c"), (0, types_1.uint64)("0x550c7dc3d5ffb4e2"),
    (0, types_1.uint64)("0x72be5d74f27b896f"), (0, types_1.uint64)("0x80deb1fe3b1696b1"),
    (0, types_1.uint64)("0x9bdc06a725c71235"), (0, types_1.uint64)("0xc19bf174cf692694"),
    (0, types_1.uint64)("0xe49b69c19ef14ad2"), (0, types_1.uint64)("0xefbe4786384f25e3"),
    (0, types_1.uint64)("0x0fc19dc68b8cd5b5"), (0, types_1.uint64)("0x240ca1cc77ac9c65"),
    (0, types_1.uint64)("0x2de92c6f592b0275"), (0, types_1.uint64)("0x4a7484aa6ea6e483"),
    (0, types_1.uint64)("0x5cb0a9dcbd41fbd4"), (0, types_1.uint64)("0x76f988da831153b5"),
    (0, types_1.uint64)("0x983e5152ee66dfab"), (0, types_1.uint64)("0xa831c66d2db43210"),
    (0, types_1.uint64)("0xb00327c898fb213f"), (0, types_1.uint64)("0xbf597fc7beef0ee4"),
    (0, types_1.uint64)("0xc6e00bf33da88fc2"), (0, types_1.uint64)("0xd5a79147930aa725"),
    (0, types_1.uint64)("0x06ca6351e003826f"), (0, types_1.uint64)("0x142929670a0e6e70"),
    (0, types_1.uint64)("0x27b70a8546d22ffc"), (0, types_1.uint64)("0x2e1b21385c26c926"),
    (0, types_1.uint64)("0x4d2c6dfc5ac42aed"), (0, types_1.uint64)("0x53380d139d95b3df"),
    (0, types_1.uint64)("0x650a73548baf63de"), (0, types_1.uint64)("0x766a0abb3c77b2a8"),
    (0, types_1.uint64)("0x81c2c92e47edaee6"), (0, types_1.uint64)("0x92722c851482353b"),
    (0, types_1.uint64)("0xa2bfe8a14cf10364"), (0, types_1.uint64)("0xa81a664bbc423001"),
    (0, types_1.uint64)("0xc24b8b70d0f89791"), (0, types_1.uint64)("0xc76c51a30654be30"),
    (0, types_1.uint64)("0xd192e819d6ef5218"), (0, types_1.uint64)("0xd69906245565a910"),
    (0, types_1.uint64)("0xf40e35855771202a"), (0, types_1.uint64)("0x106aa07032bbd1b8"),
    (0, types_1.uint64)("0x19a4c116b8d2d0c8"), (0, types_1.uint64)("0x1e376c085141ab53"),
    (0, types_1.uint64)("0x2748774cdf8eeb99"), (0, types_1.uint64)("0x34b0bcb5e19b48a8"),
    (0, types_1.uint64)("0x391c0cb3c5c95a63"), (0, types_1.uint64)("0x4ed8aa4ae3418acb"),
    (0, types_1.uint64)("0x5b9cca4f7763e373"), (0, types_1.uint64)("0x682e6ff3d6b2b8a3"),
    (0, types_1.uint64)("0x748f82ee5defb2fc"), (0, types_1.uint64)("0x78a5636f43172f60"),
    (0, types_1.uint64)("0x84c87814a1f0ab72"), (0, types_1.uint64)("0x8cc702081a6439ec"),
    (0, types_1.uint64)("0x90befffa23631e28"), (0, types_1.uint64)("0xa4506cebde82bde9"),
    (0, types_1.uint64)("0xbef9a3f7b2c67915"), (0, types_1.uint64)("0xc67178f2e372532b"),
    (0, types_1.uint64)("0xca273eceea26619c"), (0, types_1.uint64)("0xd186b8c721c0c207"),
    (0, types_1.uint64)("0xeada7dd6cde0eb1e"), (0, types_1.uint64)("0xf57d4f7fee6ed178"),
    (0, types_1.uint64)("0x06f067aa72176fba"), (0, types_1.uint64)("0x0a637dc5a2c898a6"),
    (0, types_1.uint64)("0x113f9804bef90dae"), (0, types_1.uint64)("0x1b710b35131c471b"),
    (0, types_1.uint64)("0x28db77f523047d84"), (0, types_1.uint64)("0x32caab7b40c72493"),
    (0, types_1.uint64)("0x3c9ebe0a15c9bebc"), (0, types_1.uint64)("0x431d67c49c100d4c"),
    (0, types_1.uint64)("0x4cc5d4becb3e42b6"), (0, types_1.uint64)("0x597f299cfc657e2a"),
    (0, types_1.uint64)("0x5fcb6fab3ad6faec"), (0, types_1.uint64)("0x6c44198c4a475817"),
]);
/**
 * getulates sha2-512 (64bytes) hash of a list of uint8 numbers.
 * Result is also a list of uint8 number.
 * @example
 * bytesToHex(sha2_512([0x61, 0x62, 0x63])) => "ddaf35a193617abacc417349ae20413112e6fa4e89a97ea20a9eeee64b55d39a2192992a274fc1a836ba3c23a3feebbd454d4423643ce80e2a9ac94fa54ca49f"
 * @example
 * bytesToHex(sha2_512([])) => "cf83e1357eefb8bdf1542850d66d8007d620e4050b5715dc83f4a921d36ce9ce47d0d13c5d85f2b0ff8318d2877eec2f63b931bd47417a81a538327af927da3e"
 * @param {number[]} bytes - list of uint8 numbers
 * @returns {number[]} - list of uint8 numbers
 */
function sha2_512(bytes) {
    if (bytes instanceof Uint8Array)
        bytes = Array.from(bytes);
    // initial has; updated later
    var hash = [
        (0, types_1.uint64)("0x6a09e667f3bcc908"),
        (0, types_1.uint64)("0xbb67ae8584caa73b"),
        (0, types_1.uint64)("0x3c6ef372fe94f82b"),
        (0, types_1.uint64)("0xa54ff53a5f1d36f1"),
        (0, types_1.uint64)("0x510e527fade682d1"),
        (0, types_1.uint64)("0x9b05688c2b3e6c1f"),
        (0, types_1.uint64)("0x1f83d9abfb41bd6b"),
        (0, types_1.uint64)("0x5be0cd19137e2179"),
    ];
    function sigma0(x) {
        return (0, types_1.forceUint64)(((0, types_1.uint64Rotr)(x, 1) ^ (0, types_1.uint64Rotr)(x, 8)) ^ (x >> BigInt(7)));
    }
    function sigma1(x) {
        return (0, types_1.forceUint64)(((0, types_1.uint64Rotr)(x, 19) ^ (0, types_1.uint64Rotr)(x, 61)) ^ (x >> BigInt(6)));
    }
    bytes = _sha2_512_pad(bytes);
    // break message in successive 64 byte chunks
    for (var chunkStart = 0; chunkStart < bytes.length; chunkStart += 128) {
        var chunk = bytes.slice(chunkStart, chunkStart + 128);
        var w = (new Array(80)).fill(BigInt(0)); // array of 32 bit numbers!
        // copy chunk into first 16 hi/lo positions of w (i.e. into first 32 uint32 positions)
        for (var i = 0; i < 16; i++) {
            w[i] = (0, types_1.uint64)("0x" + (0, types_1.byteArrToHex)(chunk.slice(i * 8, i * 8 + 8)));
        }
        // extends the first 16 positions into the remaining 80 positions
        for (var i = 16; i < 80; i++) {
            w[i] = (0, types_1.forceUint64)(sigma1(w[i - 2]) + w[i - 7] + sigma0(w[i - 15]) + w[i - 16]);
        }
        // intialize working variables to current hash value
        var a = hash[0];
        var b = hash[1];
        var c = hash[2];
        var d = hash[3];
        var e = hash[4];
        var f = hash[5];
        var g = hash[6];
        var h = hash[7];
        // compression function main loop
        for (var i = 0; i < 80; i++) {
            var S1 = (((0, types_1.uint64Rotr)(e, 14) ^ (0, types_1.uint64Rotr)(e, 18)) ^ (0, types_1.uint64Rotr)(e, 41));
            var ch = ((e & f) ^ ((~e) & g));
            var temp1 = (0, types_1.forceUint64)(h + S1 + ch + _sha2_512_k[i] + w[i]);
            var S0 = ((0, types_1.uint64Rotr)(a, 28) ^ (0, types_1.uint64Rotr)(a, 34)) ^ ((0, types_1.uint64Rotr)(a, 39));
            var maj = (((a & b) ^ (a & c)) ^ (b & (c)));
            var temp2 = (0, types_1.forceUint64)(S0 + maj);
            h = g;
            g = f;
            f = e;
            e = (0, types_1.forceUint64)(d + temp1);
            d = c;
            c = b;
            b = a;
            a = (0, types_1.forceUint64)(temp1 + temp2);
        }
        // update the hash
        hash[0] = (0, types_1.forceUint64)(hash[0] + a);
        hash[1] = (0, types_1.forceUint64)(hash[1] + b);
        hash[2] = (0, types_1.forceUint64)(hash[2] + c);
        hash[3] = (0, types_1.forceUint64)(hash[3] + d);
        hash[4] = (0, types_1.forceUint64)(hash[4] + e);
        hash[5] = (0, types_1.forceUint64)(hash[5] + f);
        hash[6] = (0, types_1.forceUint64)(hash[6] + g);
        hash[7] = (0, types_1.forceUint64)(hash[7] + h);
    }
    // produce the final digest of uint8 numbers
    var result = [];
    for (var i = 0; i < 8; i++) {
        result.push.apply(result, __spreadArray([], __read((0, types_1.uint64ToBytesBE)(hash[i])), false));
    }
    return new Uint8Array(result);
}
exports.sha2_512 = sha2_512;


/***/ }),

/***/ 20130:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sha3 = void 0;
var types_1 = __webpack_require__(62339);
var types_2 = __webpack_require__(62339);
var uint8array_utils_1 = __webpack_require__(44948);
var assert_1 = __webpack_require__(24055);
/**
 * state width (1600 bits, )
 */
var WIDTH = 200;
/**
 * rate (1088 bits, 136 bytes)
 */
var RATE = 136;
/**
 * capacity
 */
var CAP = WIDTH - RATE;
/**
 * Apply 1000...1 padding until size is multiple of r.
 * If already multiple of r then add a whole block of padding.
 * @param {number[]} src - list of uint8 numbers
 * @returns {number[]} - list of uint8 numbers
 */
function pad(src) {
    var dst = src.slice();
    var nZeroes = RATE - 2 - (dst.length % RATE);
    if (nZeroes < -1) {
        nZeroes += RATE - 2;
    }
    if (nZeroes == -1) {
        dst.push(0x86);
    }
    else {
        dst.push(0x06);
        for (var i = 0; i < nZeroes; i++) {
            dst.push(0);
        }
        dst.push(0x80);
    }
    (0, assert_1.assert)((dst.length % RATE) === 0, "wrong destination length");
    return dst;
}
/**
 * 24 numbers used in the sha3 permute function
 */
var OFFSETS = Object.freeze([6, 12, 18, 24, 3, 9, 10, 16, 22, 1, 7, 13, 19, 20, 4, 5, 11, 17, 23, 2, 8, 14, 15, 21]);
/**
 * 24 numbers used in the sha3 permute function
 */
var SHIFTS = Object.freeze([-12, -11, 21, 14, 28, 20, 3, -13, -29, 1, 6, 25, 8, 18, 27, -4, 10, 15, -24, -30, -23, -7, -9, 2]);
/**
 * Round constants used in the sha3 permute function
 */
var RC = Object.freeze([
    (0, types_2.uint64)("0x0000000000000001"),
    (0, types_2.uint64)("0x0000000000008082"),
    (0, types_2.uint64)("0x800000000000808a"),
    (0, types_2.uint64)("0x8000000080008000"),
    (0, types_2.uint64)("0x000000000000808b"),
    (0, types_2.uint64)("0x0000000080000001"),
    (0, types_2.uint64)("0x8000000080008081"),
    (0, types_2.uint64)("0x8000000000008009"),
    (0, types_2.uint64)("0x000000000000008a"),
    (0, types_2.uint64)("0x0000000000000088"),
    (0, types_2.uint64)("0x0000000080008009"),
    (0, types_2.uint64)("0x000000008000000a"),
    (0, types_2.uint64)("0x000000008000808b"),
    (0, types_2.uint64)("0x800000000000008b"),
    (0, types_2.uint64)("0x8000000000008089"),
    (0, types_2.uint64)("0x8000000000008003"),
    (0, types_2.uint64)("0x8000000000008002"),
    (0, types_2.uint64)("0x8000000000000080"),
    (0, types_2.uint64)("0x000000000000800a"),
    (0, types_2.uint64)("0x800000008000000a"),
    (0, types_2.uint64)("0x8000000080008081"),
    (0, types_2.uint64)("0x8000000000008080"),
    (0, types_2.uint64)("0x0000000080000001"),
    (0, types_2.uint64)("0x8000000080008008"),
]);
function permute(s) {
    var c = new Array(5);
    var b = new Array(25);
    for (var round = 0; round < 24; round++) {
        for (var i = 0; i < 5; i++) {
            c[i] = (0, types_2.uint64)((((s[i] ^ s[i + 5]) ^ s[i + 10]) ^ s[i + 15]) ^ s[i + 20]);
        }
        for (var i = 0; i < 5; i++) {
            var tmp = (0, types_2.uint64)(c[(i + 4) % 5] ^ (0, types_2.uint64Rotr)(c[(i + 1) % 5], 63));
            for (var j = 0; j < 5; j++) {
                s[i + 5 * j] = (0, types_2.uint64)(s[i + 5 * j] ^ tmp);
            }
        }
        b[0] = s[0];
        for (var i = 1; i < 25; i++) {
            var offset = OFFSETS[i - 1];
            var left = Math.abs(SHIFTS[i - 1]);
            var right = (32 - left);
            if (SHIFTS[i - 1] < 0) {
                b[i] = (0, types_2.uint64Rotr)(s[offset], right);
            }
            else {
                b[i] = (0, types_2.uint64Rotr)(s[offset], (right + 32));
            }
        }
        for (var i = 0; i < 5; i++) {
            for (var j = 0; j < 5; j++) {
                s[i * 5 + j] = (0, types_2.uint64)(b[i * 5 + j] ^ ((~b[i * 5 + (j + 1) % 5]) & b[i * 5 + (j + 2) % 5]));
            }
        }
        s[0] = (s[0] ^ RC[round]);
    }
}
/**
 * getulates sha3-256 (32bytes) hash of a list of uint8 numbers.
 * Result is also a list of uint8 number.
 * Sha3 only bit-wise operations, so 64-bit operations can easily be replicated using 2 32-bit operations instead
 * @example
 * bytesToHex(sha3(textToBytes("abc"))) => "3a985da74fe225b2045c172d6bd390bd855f086e3e9d525b46bfe24511431532"
 * @example
 * bytesToHex(sha3((new Array(136)).fill(1))) => "b36dc2167c4d9dda1a58b87046c8d76a6359afe3612c4de8a38857e09117b2db"
 * @example
 * bytesToHex(sha3((new Array(135)).fill(2))) => "5bdf5d815d29a9d7161c66520efc17c2edd7898f2b99a029e8d2e4ff153407f4"
 * @example
 * bytesToHex(sha3((new Array(134)).fill(3))) => "8e6575663dfb75a88f94a32c5b363c410278b65020734560d968aadd6896a621"
 * @example
 * bytesToHex(sha3((new Array(137)).fill(4))) => "f10b39c3e455006aa42120b9751faa0f35c821211c9d086beb28bf3c4134c6c6"
 */
function sha3(bytes) {
    if ((0, uint8array_utils_1.isUint8Array)(bytes)) {
        bytes = (0, types_1.buffToByteArr)(bytes);
    }
    bytes = pad(bytes);
    // initialize the state
    var state = (new Array(WIDTH / 8)).fill((0, types_2.uint64)(0));
    for (var chunkStart = 0; chunkStart < bytes.length; chunkStart += RATE) {
        // extend the chunk to become length WIDTH
        var chunk = bytes.slice(chunkStart, chunkStart + RATE).concat((new Array(CAP)).fill(0));
        // element-wise xor with 'state'
        for (var i = 0; i < WIDTH; i += 8) {
            state[i / 8] = (0, types_2.uint64)(state[i / 8] ^
                (0, types_2.uint64)("0x" + (0, types_2.byteArrToHex)(chunk.slice(i, i + 8).reverse())));
            // beware: a uint32 is stored as little endian, but a pair of uint32s that form a uin64 are stored in big endian format!
            //state[i/4] ^= (chunk[i] << 0) | (chunk[i+1] << 8) | (chunk[i+2] << 16) | (chunk[i+3] << 24);
        }
        // apply block permutations
        permute(state);
    }
    var hash = [];
    for (var i = 0; i < 4; i++) {
        hash.push.apply(hash, __spreadArray([], __read((0, types_2.uint64ToBytesLE)(state[i])), false));
    }
    return hash;
}
exports.sha3 = sha3;


/***/ }),

/***/ 62339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.uint64Rotr = exports.uint64ToBytesBE = exports.uint64ToBytesLE = exports.isUint64 = exports.forceUint64 = exports.uint64 = exports.buffToUint5Arr = exports.byteArrToBin = exports.byteArrToHex = exports.buffToByteArr = exports.isByteArr = exports.isByte = exports.byte = exports.isUint6 = exports.isUint5 = void 0;
var uint8array_utils_1 = __webpack_require__(44948);
var assert_1 = __webpack_require__(24055);
function isUint5(n) {
    return (typeof n === "number" &&
        n >= 0 && n <= 31 &&
        n === Math.round(n));
}
exports.isUint5 = isUint5;
function isUint6(n) {
    return (typeof n === "number" &&
        n >= 0 && n <= 63 &&
        n === Math.round(n));
}
exports.isUint6 = isUint6;
function byte(bint) {
    return (Number(bint) & 0xff);
}
exports.byte = byte;
function isByte(n) {
    return (typeof n === "number" &&
        n >= 0 && n <= 255 &&
        n === Math.round(n));
}
exports.isByte = isByte;
function isByteArr(something) {
    return (Array.isArray(something) &&
        something.every(isByte));
}
exports.isByteArr = isByteArr;
function buffToByteArr(buff) {
    if (!(0, uint8array_utils_1.isUint8Array)(buff)) {
        if (isByteArr(buff))
            return buff.slice();
        throw new Error("can't convert non-buffer to byte array");
    }
    return Array.from(buff);
}
exports.buffToByteArr = buffToByteArr;
function byteArrToHex(bytes) {
    if (bytes instanceof Uint8Array)
        bytes = Array.from(bytes);
    return bytes.reduce(function (acc, val) { return acc + val.toString(16).slice(0, 2).padStart(2, '0'); }, '');
}
exports.byteArrToHex = byteArrToHex;
function byteArrToBin(bytes) {
    return bytes.reduce(function (acc, val) { return acc + val.toString(2).slice(0, 8).padStart(8, '0'); }, '');
}
exports.byteArrToBin = byteArrToBin;
/**
 * Internal method
 *
 * `bytes` is **padded at the end** to be a multiple of 5
 */
function buffToUint5Arr(bytes) {
    var result = [];
    var bits = (0, uint8array_utils_1.isUint8Array)(bytes) ?
        Array.from(bytes).reduce(function (acc, n) { return acc + n.toString(2).padStart(8, '0'); }, "") :
        (isByteArr(bytes) ?
            byteArrToBin(bytes) :
            undefined);
    if (bits === undefined) {
        throw new Error("invalid input to convert ot uint5 array");
    }
    var mod5Len = bits.length % 5;
    if (mod5Len !== 0) {
        bits = bits.padEnd(bits.length + (5 - mod5Len), '0');
    }
    bits = bits.split('');
    for (var i = 0; i < bits.length;) {
        result.push(Number("0b".concat(bits[i++]).concat(bits[i++]).concat(bits[i++]).concat(bits[i++]).concat(bits[i++])));
    }
    return result;
}
exports.buffToUint5Arr = buffToUint5Arr;
function uint64(n) {
    var _n = BigInt(n);
    if (!isUint64(_n))
        throw new Error("can't convert " + n + " to uint64");
    return _n;
}
exports.uint64 = uint64;
function forceUint64(n) {
    return (BigInt(n) & BigInt("0x" + "ff".repeat(8)));
}
exports.forceUint64 = forceUint64;
function isUint64(n) {
    return (typeof n === "bigint" &&
        n >= BigInt(0) &&
        n < BigInt("0x1" + "00".repeat(8)) // n < (1 << 64)
    );
}
exports.isUint64 = isUint64;
function uint64ToBytesLE(uint) {
    return [
        byte(BigInt("0x00000000000000ff") & uint),
        byte((BigInt("0x000000000000ff00") & uint) >> BigInt(8)),
        byte((BigInt("0x0000000000ff0000") & uint) >> BigInt(16)),
        byte((BigInt("0x00000000ff000000") & uint) >> BigInt(24)),
        byte((BigInt("0x000000ff00000000") & uint) >> BigInt(32)),
        byte((BigInt("0x0000ff0000000000") & uint) >> BigInt(40)),
        byte((BigInt("0x00ff000000000000") & uint) >> BigInt(48)),
        byte((BigInt("0xff00000000000000") & uint) >> BigInt(56)),
    ];
}
exports.uint64ToBytesLE = uint64ToBytesLE;
function uint64ToBytesBE(uint) {
    return uint64ToBytesLE(uint).reverse();
}
exports.uint64ToBytesBE = uint64ToBytesBE;
function uint64Rotr(a, b) {
    (0, assert_1.assert)(isUint64(a) && isUint6(b), "invalid args for 'uint64And'");
    if (b === 0)
        return a;
    var n = BigInt(b);
    return forceUint64(forceUint64(a >> n) | forceUint64(a << (BigInt(64) - n)));
}
exports.uint64Rotr = uint64Rotr;


/***/ }),

/***/ 24055:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assertBytes = exports.assertPostiveInteger = exports.assert = void 0;
function assert(condition, errorMessage, addInfos) {
    var args = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args[_i - 3] = arguments[_i];
    }
    if (condition)
        return;
    args.length > 0 && console.error.apply(console, __spreadArray([], __read(args), false));
    addInfos && console.error(addInfos);
    if (errorMessage instanceof Error) {
        throw errorMessage;
    }
    ;
    throw new Error(errorMessage);
}
exports.assert = assert;
// keccak asserts
function assertPostiveInteger(n) {
    if (!Number.isSafeInteger(n) || n < 0)
        throw new Error("positive integer expected, not ".concat(n));
}
exports.assertPostiveInteger = assertPostiveInteger;
function assertBytes(stuff) {
    if (!(stuff instanceof Uint8Array))
        throw new Error("Uint8Array expected");
}
exports.assertBytes = assertBytes;


/***/ }),

/***/ 81721:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeBase32Bech32 = exports.decodeBase32rfc4648 = exports.encodeBase32rfc4648 = exports.BECH32_BASE32_ALPHABET = exports.rfc4648_ALPHABET = void 0;
var types_1 = __webpack_require__(62339);
var bitstream_1 = __webpack_require__(85840);
exports.rfc4648_ALPHABET = Object.freeze([
    'a', 'b', 'c', 'd', 'e', 'f', 'g',
    'h', 'i', 'j', 'k', 'l', 'm', 'n',
    'o', 'p', 'q', 'r', 's', 't', 'u',
    'v', 'w', 'x', 'y', 'z', '2', '3',
    '4', '5', '6', '7'
]);
exports.BECH32_BASE32_ALPHABET = Object.freeze([
    'q', 'p', 'z', 'r', 'y', '9', 'x',
    '8', 'g', 'f', '2', 't', 'v', 'd',
    'w', '0', 's', '3', 'j', 'n', '5',
    '4', 'k', 'h', 'c', 'e', '6', 'm',
    'u', 'a', '7', 'l'
]);
function encodeBase32rfc4648(bytes) {
    return (0, types_1.buffToUint5Arr)(bytes).map(function (c) { return exports.rfc4648_ALPHABET[c]; }).join("");
}
exports.encodeBase32rfc4648 = encodeBase32rfc4648;
function decodeBase32(base32Str, alpabeth) {
    if (!Array.from(base32Str).every(function (ch) { return alpabeth.includes(ch); }))
        throw new Error("can't decode base32 a string that is not in base32 (rfc 4648); string was: " + base32Str);
    var len = base32Str.length;
    var bits = '';
    for (var i = 0; i < len - 1; i++) {
        var num_1 = alpabeth.indexOf(base32Str[i].toLowerCase());
        bits += num_1.toString(2).padStart(5, '0');
    }
    // last, make sure we align to byte
    var nCut = len * 5 - 8 * Math.floor(len * 5 / 8);
    var num = alpabeth.indexOf(base32Str[len - 1].toLowerCase());
    var lastbits = num.toString(2).padStart(5, '0');
    bits += lastbits.slice(0, 5 - nCut);
    return bitstream_1.BitStream.fromBinStr(bits).toBuffer().buffer;
}
function decodeBase32rfc4648(base32Str) {
    return decodeBase32(base32Str, exports.rfc4648_ALPHABET);
}
exports.decodeBase32rfc4648 = decodeBase32rfc4648;
function decodeBase32Bech32(base32Str) {
    return decodeBase32(base32Str, exports.BECH32_BASE32_ALPHABET);
}
exports.decodeBase32Bech32 = decodeBase32Bech32;


/***/ }),

/***/ 51679:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.bigintToBuffer = void 0;
var assert_1 = __webpack_require__(24055);
var uint8array_utils_1 = __webpack_require__(44948);
function bigintToBuffer(bigint, nBytes) {
    if (nBytes === void 0) { nBytes = undefined; }
    (0, assert_1.assert)(bigint >= BigInt(0), "cannot convert negative bigint to buffer");
    if (bigint == BigInt(0)) {
        if (nBytes === undefined) {
            return Uint8Array.from([]);
        }
        return new Uint8Array(nBytes);
    }
    var buffHexString = bigint.toString(16);
    buffHexString = buffHexString.length % 2 === 0 ? buffHexString : '0' + buffHexString;
    if (nBytes !== undefined) {
        (0, assert_1.assert)(Math.round(Math.abs(nBytes)) === nBytes, "cannot construct a buffer of length " + nBytes + ", while using BigIntUtils.toBufferOfNBytesBE");
        // pads with zeroes so that the final length is of nBytes*2 (2 hex digits per byte)
        // String.prototype.padStart docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
        buffHexString = buffHexString.padStart(nBytes * 2, "00");
        if (buffHexString.length > nBytes * 2) {
            console.warn("required buffer size is smaller than the one used effectively by the given bigint, truncating the initial bytes as overflow");
            buffHexString = buffHexString.slice(buffHexString.length - (nBytes * 2));
        }
    }
    return (0, uint8array_utils_1.fromHex)(buffHexString);
}
exports.bigintToBuffer = bigintToBuffer;


/***/ }),

/***/ 63390:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(81721), exports);
__exportStar(__webpack_require__(73626), exports);
__exportStar(__webpack_require__(85775), exports);


/***/ }),

/***/ 73626:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.positiveMod = void 0;
function positiveMod(x, n) {
    var _n = BigInt(n);
    var res = BigInt(x) % _n;
    return res < BigInt(0) ? res + _n : res;
}
exports.positiveMod = positiveMod;


/***/ }),

/***/ 85775:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.rotr32 = void 0;
function rotr32(x, by) {
    return (x >>> by) | (x << (32 - by)) | 0;
}
exports.rotr32 = rotr32;


/***/ }),

/***/ 22431:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.vrf_ed25519_sha512_ell2_challenge_generation = exports.vrf_ed25519_sha512_ell2_nonce_generation = exports.vrf_ed25519_sha512_ell2_hash_to_curve = exports.vrf_ed25519_sha512_ell2_prove = void 0;
var ed25519_1 = __webpack_require__(58754);
var sha2_512_1 = __webpack_require__(45802);
/**
4.4. RSA-FDH-VRF Ciphersuites

This document defines RSA-FDH-VRF-SHA256 as follows:

suite_string = 0x01.
The hash function Hash is SHA-256 as specified in [RFC6234], with hLen = 32.
MGF_salt = I2OSP(k, 4) || I2OSP(n, k).

This document defines RSA-FDH-VRF-SHA384 as follows:

suite_string = 0x02.
The hash function Hash is SHA-384 as specified in [RFC6234], with hLen = 48.
MGF_salt = I2OSP(k, 4) || I2OSP(n, k).

This document defines RSA-FDH-VRF-SHA512 as follows:

suite_string = 0x03.
The hash function Hash is SHA-512 as specified in [RFC6234], with hLen = 64.
MGF_salt = I2OSP(k, 4) || I2OSP(n, k).

 */
var SUITE = 0x03;
var ONE = 0x01;
var TWO = 0x02;
/**
 * https://datatracker.ietf.org/doc/html/rfc9381#section-5.1
 */
function vrf_ed25519_sha512_ell2_prove(sk, alpha) {
    var _a = __read((0, ed25519_1.extendEd25519PrivateKey)(sk), 2), scalar = _a[0], extension = _a[1];
    // 1. Use SK to derive the VRF secret scalar x and the VRF public key Y = x*B
    var pk = new Uint8Array((0, ed25519_1.deriveEd25519PublicKey)(Array.from(sk)));
    var H = vrf_ed25519_sha512_ell2_hash_to_curve(pk, alpha);
    var H_point = (0, ed25519_1.pointFromBytes)(H);
    var gamma = (0, ed25519_1.scalarMul)(H_point, scalar);
    var compressed_gamma = (0, ed25519_1.bigpointToUint8Array)(gamma);
    var k = vrf_ed25519_sha512_ell2_nonce_generation(extension, H);
    var announcement_1 = (0, ed25519_1.bigpointToUint8Array)((0, ed25519_1.scalarMultBase)(k));
    var announcement_2 = (0, ed25519_1.bigpointToUint8Array)((0, ed25519_1.scalarMul)(H_point, k));
    var challange = (0, ed25519_1.scalarFromBytes)(vrf_ed25519_sha512_ell2_challenge_generation(H, compressed_gamma, announcement_1, announcement_2));
    var response = k + challange * scalar;
    return {
        gamma: gamma,
        challange: challange,
        response: response
    };
}
exports.vrf_ed25519_sha512_ell2_prove = vrf_ed25519_sha512_ell2_prove;
function vrf_ed25519_sha512_ell2_hash_to_curve(public_key, alpha_string) {
    var input = new Uint8Array(2 + public_key.length + alpha_string.length);
    input[0] = SUITE;
    input[1] = ONE;
    input.set(public_key, 2);
    input.set(alpha_string, 2 + public_key.length);
    //return pointFromBytes(sha2_512(input))
    return (0, sha2_512_1.sha2_512)(input);
}
exports.vrf_ed25519_sha512_ell2_hash_to_curve = vrf_ed25519_sha512_ell2_hash_to_curve;
function vrf_ed25519_sha512_ell2_nonce_generation(secret_extension, H) {
    var input = new Uint8Array(64);
    input.set(secret_extension, 0);
    input.set(H, 32);
    //return pointFromBytes(sha2_512(input))
    return (0, ed25519_1.scalarFromBytes)((0, sha2_512_1.sha2_512)(input));
}
exports.vrf_ed25519_sha512_ell2_nonce_generation = vrf_ed25519_sha512_ell2_nonce_generation;
function vrf_ed25519_sha512_ell2_challenge_generation(H, gamma, announcement_1, announcement_2) {
    var input = new Uint8Array(2 + H.length + gamma.length + announcement_1.length + announcement_2.length);
    input[0] = SUITE;
    input[1] = TWO;
    input.set(H, 2);
    input.set(gamma, 2 + H.length);
    input.set(announcement_1, 2 + H.length + gamma.length);
    input.set(announcement_2, 2 + H.length + gamma.length + announcement_1.length);
    return (0, sha2_512_1.sha2_512)(input).slice(0, 16);
}
exports.vrf_ed25519_sha512_ell2_challenge_generation = vrf_ed25519_sha512_ell2_challenge_generation;


/***/ }),

/***/ 33558:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseUPLC = exports.UPLCDecoder = void 0;
var UPLCProgram_1 = __webpack_require__(62830);
var UPLCVersion_1 = __webpack_require__(76844);
var UPLCTerm_1 = __webpack_require__(14740);
var Application_1 = __webpack_require__(80271);
var Builtin_1 = __webpack_require__(69537);
var UPLCBuiltinTag_1 = __webpack_require__(31110);
var Delay_1 = __webpack_require__(93974);
var ErrorUPLC_1 = __webpack_require__(54915);
var Force_1 = __webpack_require__(66064);
var Lambda_1 = __webpack_require__(51644);
var UPLCVar_1 = __webpack_require__(79369);
var UPLCConst_1 = __webpack_require__(46698);
var ConstType_1 = __webpack_require__(89020);
var uint8array_utils_1 = __webpack_require__(44948);
var bytestring_1 = __webpack_require__(86152);
var cbor_1 = __webpack_require__(79236);
var UPLCFlatUtils_1 = __importDefault(__webpack_require__(29149));
var bigint_utils_1 = __webpack_require__(76743);
var plutus_data_1 = __webpack_require__(34635);
var pair_1 = __webpack_require__(53307);
var UPLCTermTag_1 = __webpack_require__(73450);
var Constr_1 = __webpack_require__(66240);
var Case_1 = __webpack_require__(49629);
function isSerializedScriptFormat(str) {
    return (typeof str === "string" &&
        (str === "flat" ||
            str === "cbor"));
}
var UPLCDecoder = /** @class */ (function () {
    function UPLCDecoder() {
    }
    UPLCDecoder.parse = function (serializedScript, format, debugLogs) {
        if (format === void 0) { format = "cbor"; }
        if (debugLogs === void 0) { debugLogs = false; }
        if (!isSerializedScriptFormat(format)) {
            throw new Error("unknown format: " + format.toString());
        }
        if (format === "cbor") {
            var shouldTryParseCbor = true;
            var tmp = undefined;
            while (shouldTryParseCbor) {
                try {
                    tmp = cbor_1.Cbor.parse(serializedScript);
                }
                catch (_a) {
                    shouldTryParseCbor = false;
                }
                if (!(tmp instanceof cbor_1.CborBytes)) {
                    shouldTryParseCbor = false;
                }
                else {
                    serializedScript = tmp.buffer;
                }
            }
            format = "flat";
        }
        // -------------------------- ctx steup -------------------------- //
        var currPtr = 0;
        var nBytes = serializedScript.length;
        var scriptBits = "0000000" + (0, bigint_utils_1.bigintFromBuffer)(serializedScript).toString(2);
        /**
         * dependencies:
         * - currPtr
         * - nBytes
         * - serializedScript
         */
        var version = new UPLCVersion_1.UPLCVersion(readUInt(), readUInt(), readUInt());
        var isV3Friendly = version.isV3Friendly();
        var currDbn = 0;
        function incrementPtrBy(n) {
            currPtr += n;
        }
        function logState(forced) {
            if (forced === void 0) { forced = false; }
            if (forced || debugLogs) {
                console.log("UPLCDecoder state: " + JSON.stringify({
                    currPtr: currPtr,
                    bits: "..." + scriptBits.slice(currPtr - 16, currPtr + 16) + "...",
                    "ptr ": ' '.repeat(19) + '^',
                    currentByteIndex: currByteIndex(),
                    partialUPLC: partialUPLC
                }, undefined, 2));
            }
        }
        // --------------------------------------------------------------- //
        // ------------------------------ partial UPLC stuff ------------------------------ //
        var vars = "abcdefghilmopqrstuvzwxyjkABCDEFGHILJMNOPQRSTUVZWXYJK".split('');
        var partialUPLC = "";
        // -------------------------------------------------------------------------------- //
        /**
         * dependencies:
         * - currPtr
         * - nBytes
         */
        function currByteIndex() {
            var idx = Math.floor(currPtr / 8);
            if (idx >= nBytes)
                throw new Error("pointer out of bound; ptr: " + currPtr + "; n bits: " + nBytes * 8);
            return idx;
        }
        /**
         * dependencies:
         * - currPtr
         * - nBytes
         * - serializedScript
         */
        function currByte() {
            var byte = serializedScript.at(currByteIndex());
            if (byte === undefined)
                throw new Error("pointer out of bound; ptr: " + currPtr + "; n bits: " + nBytes * 8);
            return byte;
        }
        function getByteMask(nBits) {
            var mask = 0;
            for (var _nBits = Math.round(Math.abs(nBits)); _nBits > 0; _nBits--) {
                mask = (mask << 1) + 1;
            }
            return mask;
        }
        function nthBitOfByte(nth, byte) {
            switch (nth) {
                case 0: return ((byte & 128) >> 7);
                case 1: return ((byte & 64) >> 6);
                case 2: return ((byte & 32) >> 5);
                case 3: return ((byte & 16) >> 4);
                case 4: return ((byte & 8) >> 3);
                case 5: return ((byte & 4) >> 2);
                case 6: return ((byte & 2) >> 1);
                case 7: return (byte & 1);
                default: throw new Error("can't access bit n: " + nth);
            }
        }
        /**
         * dependencies:
         * - currPtr
         * - nBytes
         * - serializedScript
         */
        function readNBits(n) {
            if (n <= 0)
                return BigInt(0);
            var currB = currByte();
            var inBytePtr = currPtr % 8;
            if (n === 1) {
                incrementPtrBy(1);
                return BigInt(nthBitOfByte(inBytePtr, currB));
            }
            var missingBitsToByte = 8 - inBytePtr;
            var shift = missingBitsToByte - n;
            if (n <= missingBitsToByte) {
                incrementPtrBy(n);
                return BigInt((currB & (getByteMask(n) << shift)) >> shift);
            }
            incrementPtrBy(missingBitsToByte);
            var result = BigInt(currB & getByteMask(missingBitsToByte));
            var missingBitsToRead = n - missingBitsToByte;
            var nWholeBytes = 0;
            for (; (nWholeBytes + 1) * 8 < missingBitsToRead; nWholeBytes++) {
                result = (result << BigInt(8)) & BigInt(currByte());
                incrementPtrBy(8);
            }
            missingBitsToRead = missingBitsToRead - (nWholeBytes * 8);
            if (missingBitsToRead === 0)
                return result;
            return (result << BigInt(missingBitsToRead)) | readNBits(missingBitsToRead);
        }
        function readPadding() {
            while (Number(readNBits(1)) !== 1) { }
            if ((currPtr % 8) !== 0)
                throw new Error("padding was not alligned to byte; currPtr was: " + currPtr + "; currPtr % 8: " + currPtr % 8);
        }
        /**
         * dependencies:
         * - currPtr
         * - nBytes
         * - serializedScript
         */
        function readUInt() {
            var n = BigInt(0);
            var wasLast = true;
            var nRed = 0;
            do {
                var red = readNBits(8);
                wasLast = (red & BigInt(128)) === BigInt(0);
                n = n | (red & BigInt(127)) << BigInt(nRed * 7);
                nRed++;
            } while (!wasLast);
            return n;
        }
        ;
        function readSignedInt() {
            return UPLCFlatUtils_1.default.unzigzagBigint(readUInt());
        }
        function readTerm() {
            var _a;
            // console.log( "left to read: " + serializedScript.subarray( currByteIndex() ).toString("hex") );
            logState();
            var tag = Number(readNBits(4));
            switch (tag) {
                // serialised debruijn starts form 1;
                // plu-ts debruijn starts from 0
                case UPLCTermTag_1.UPLCTermTag.Var:
                    var _dbn = readUInt();
                    var dbn = Number(_dbn);
                    var idx = currDbn - (dbn - 1);
                    partialUPLC += (_a = vars[idx]) !== null && _a !== void 0 ? _a : "(".concat(idx.toString(), ")");
                    return new UPLCVar_1.UPLCVar(_dbn - BigInt(1));
                case UPLCTermTag_1.UPLCTermTag.Delay:
                    partialUPLC += "(delay ";
                    var delayed = readTerm();
                    partialUPLC += ")";
                    return new Delay_1.Delay(delayed);
                case UPLCTermTag_1.UPLCTermTag.Lambda:
                    partialUPLC += "(lam " + vars[currDbn] + ' ';
                    currDbn++;
                    var lamBody = readTerm();
                    currDbn--;
                    partialUPLC += ")";
                    return new Lambda_1.Lambda(lamBody);
                case UPLCTermTag_1.UPLCTermTag.Application:
                    partialUPLC += '[';
                    var appFn = readTerm();
                    partialUPLC += ' ';
                    var appArg = readTerm();
                    partialUPLC += ']';
                    return new Application_1.Application(appFn, appArg);
                case UPLCTermTag_1.UPLCTermTag.Const: return readConst();
                case UPLCTermTag_1.UPLCTermTag.Force:
                    partialUPLC += "(force ";
                    var forced = readTerm();
                    partialUPLC += ')';
                    if (forced instanceof Builtin_1.Builtin)
                        return forced;
                    if (forced instanceof Force_1.Force && forced.termToForce instanceof Builtin_1.Builtin)
                        return forced.termToForce;
                    return new Force_1.Force(forced);
                case UPLCTermTag_1.UPLCTermTag.Error:
                    partialUPLC += "(error)";
                    return new ErrorUPLC_1.ErrorUPLC(
                    //    "error got from deserialization;",
                    //    {
                    //        debruijnLevel: currDbn,
                    //        byteIndex: currByteIndex(),
                    //        bitIndex: currPtr
                    //    }
                    );
                case UPLCTermTag_1.UPLCTermTag.Builtin:
                    var bn_tag = Number(readNBits(7));
                    partialUPLC += "(builtin ".concat((0, UPLCBuiltinTag_1.builtinTagToString)(bn_tag), ")");
                    return new Builtin_1.Builtin(bn_tag);
                case UPLCTermTag_1.UPLCTermTag.Constr:
                    {
                        if (!isV3Friendly)
                            throw new Error("found 'constr' node in uplc version " + version.toString() +
                                "; lowest supported version is 1.1.0");
                        return new Constr_1.Constr(readUInt(), readTermList());
                    }
                    ;
                case UPLCTermTag_1.UPLCTermTag.Case:
                    {
                        if (!isV3Friendly)
                            throw new Error("found 'case' node in uplc version " + version.toString() +
                                "; lowest supported version is 1.1.0");
                        return new Case_1.Case(readTerm(), readTermList());
                    }
                    ;
                default: throw new Error("unknown tag: " + tag + "; partialUPLC == " + partialUPLC);
            }
        }
        function readTermList() {
            var list = [];
            for (var head = Number(readNBits(1)); head !== 0; head = Number(readNBits(1))) {
                list.push(readTerm());
            }
            return list;
        }
        function readConst() {
            logState();
            var constTy = readConstTy();
            if ((0, ConstType_1.constTypeEq)(constTy, ConstType_1.constT.bls12_381_G1_element) ||
                (0, ConstType_1.constTypeEq)(constTy, ConstType_1.constT.bls12_381_G2_element) ||
                (0, ConstType_1.constTypeEq)(constTy, ConstType_1.constT.bls12_381_MlResult))
                throw new Error("bls constants are not supported in serialized UPLC");
            var val = readConstValueOfType(constTy);
            partialUPLC += "( con ".concat((0, UPLCTerm_1.showConstType)(constTy), " ").concat((0, UPLCTerm_1.showUPLCConstValue)(val), " )");
            return new UPLCConst_1.UPLCConst(constTy, val);
        }
        function readConstTy() {
            var head = Number(readNBits(1));
            if (head === 0)
                throw new Error("empty const type");
            var tyTag;
            var type = [];
            do {
                tyTag = Number(readNBits(4));
                head = Number(readNBits(1));
                if (tyTag === 7)
                    continue;
                type.push(tyTag);
            } while (head !== 0);
            if (!(type.length > 0 &&
                (0, ConstType_1.isWellFormedConstType)(type)))
                throw new Error("invalid constant type");
            return type;
        }
        function readConstValueOfType(t) {
            if ((0, ConstType_1.constTypeEq)(t, ConstType_1.constT.int)) {
                return readSignedInt();
            }
            if ((0, ConstType_1.constTypeEq)(t, ConstType_1.constT.byteStr)) {
                readPadding();
                var hexChunks = [];
                var chunkLen = 1;
                while (chunkLen !== 0) {
                    chunkLen = Number(readNBits(8));
                    for (var i = 0; i < chunkLen; i++) {
                        hexChunks.push(readNBits(8).toString(16).padStart(2, '0'));
                    }
                }
                return new bytestring_1.ByteString((0, uint8array_utils_1.fromHex)(hexChunks.join("")));
            }
            if ((0, ConstType_1.constTypeEq)(t, ConstType_1.constT.str)) {
                return (0, uint8array_utils_1.toUtf8)(readConstValueOfType(ConstType_1.constT.byteStr).toBuffer());
            }
            if ((0, ConstType_1.constTypeEq)(t, ConstType_1.constT.data)) {
                var bytes = readConstValueOfType(ConstType_1.constT.byteStr).toBuffer();
                return (0, plutus_data_1.dataFromCbor)(bytes);
            }
            if ((0, ConstType_1.constTypeEq)(t, ConstType_1.constT.bool))
                return (Number(readNBits(1)) === 1);
            if ((0, ConstType_1.constTypeEq)(t, ConstType_1.constT.unit))
                return undefined;
            if (t[0] === ConstType_1.ConstTyTag.list) {
                var tyArg = ConstType_1.constListTypeUtils.getTypeArgument(t);
                var list = [];
                for (var head = Number(readNBits(1)); head !== 0; head = Number(readNBits(1))) {
                    list.push(readConstValueOfType(tyArg));
                }
                return list;
            }
            if (t[0] === ConstType_1.ConstTyTag.pair) {
                return new pair_1.Pair(readConstValueOfType(ConstType_1.constPairTypeUtils.getFirstTypeArgument(t)), readConstValueOfType(ConstType_1.constPairTypeUtils.getSecondTypeArgument(t)));
            }
            ;
            throw new Error("'readConstValueOfType': no constant type matched");
        }
        return new UPLCProgram_1.UPLCProgram(version, readTerm());
    };
    return UPLCDecoder;
}());
exports.UPLCDecoder = UPLCDecoder;
function parseUPLC(serializedScript, format, debugLogs) {
    if (format === void 0) { format = "cbor"; }
    if (debugLogs === void 0) { debugLogs = false; }
    return UPLCDecoder.parse(serializedScript, format, debugLogs);
}
exports.parseUPLC = parseUPLC;


/***/ }),

/***/ 83549:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UPLCSerializationContex = void 0;
var UPLCVersion_1 = __webpack_require__(76844);
function isV3Friendly(ctx) {
    // ^1.1.0 || >= 2.*.*
    return ctx.version.major === BigInt(1) ?
        ctx.version.minor >= 1 :
        ctx.version.major > 1;
}
var UPLCSerializationContex = /** @class */ (function () {
    function UPLCSerializationContex(rawCtx) {
        this._rawCtx = __assign({ currLength: 0, version: {
                major: BigInt(1),
                minor: BigInt(1),
                patch: BigInt(0)
            } }, rawCtx);
        this._is_v3_friendly = isV3Friendly(this._rawCtx);
    }
    Object.defineProperty(UPLCSerializationContex.prototype, "is_v3_friendly", {
        get: function () {
            return this._is_v3_friendly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UPLCSerializationContex.prototype, "currLength", {
        get: function () {
            return this._rawCtx.currLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UPLCSerializationContex.prototype, "version", {
        get: function () {
            return new UPLCVersion_1.UPLCVersion(this._rawCtx.version.major, this._rawCtx.version.minor, this._rawCtx.version.patch);
        },
        enumerable: false,
        configurable: true
    });
    UPLCSerializationContex.prototype.updateVersion = function (uplcVersion) {
        this._rawCtx.version = {
            major: uplcVersion.major,
            minor: uplcVersion.minor,
            patch: uplcVersion.patch,
        };
        this._is_v3_friendly = isV3Friendly(this._rawCtx);
    };
    UPLCSerializationContex.prototype.incrementLengthBy = function (n) {
        this._rawCtx.currLength = this._rawCtx.currLength + n;
    };
    return UPLCSerializationContex;
}());
exports.UPLCSerializationContex = UPLCSerializationContex;


/***/ }),

/***/ 66129:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.encodeUPLC = exports.compileUPLC = exports.UPLCEncoder = exports.defaultUPLCEncoderOptions = exports.serializeBuiltin = void 0;
var ConstType_1 = __webpack_require__(89020);
var ConstValue_1 = __webpack_require__(54631);
var UPLCBuiltinTag_1 = __webpack_require__(31110);
var UPLCTerm_1 = __webpack_require__(14740);
var Application_1 = __webpack_require__(80271);
var Builtin_1 = __webpack_require__(69537);
var UPLCConst_1 = __webpack_require__(46698);
var Delay_1 = __webpack_require__(93974);
var ErrorUPLC_1 = __webpack_require__(54915);
var Force_1 = __webpack_require__(66064);
var Lambda_1 = __webpack_require__(51644);
var UPLCVar_1 = __webpack_require__(79369);
var UPLCSerializationContext_1 = __webpack_require__(83549);
var uint8array_utils_1 = __webpack_require__(44948);
var bitstream_1 = __webpack_require__(85840);
var bytestring_1 = __webpack_require__(86152);
var cbor_1 = __webpack_require__(79236);
var pair_1 = __webpack_require__(53307);
var plutus_data_1 = __webpack_require__(34635);
var UPLCFlatUtils_1 = __importDefault(__webpack_require__(29149));
var assert_1 = __webpack_require__(63952);
var Constr_1 = __webpack_require__(66240);
var Case_1 = __webpack_require__(49629);
var crypto_1 = __webpack_require__(15251);
/*
 * --------------------------- [encode vs serialize methods] ---------------------------
 *
 *  in the ```UPLCEncoder``` class are present various methods of which name starts with "encode" or "serialize"
 *  directly followed by the type of the expected argument.
 *
 *  all the "serialize" functions are **PURE**; meaning given the expected input those will return the output without executing side-effects;
 *
 *  all the "encode" methods have the side effect to update the context before and always return the equivalent of the "serialize" counterpart;
 *
 *  for this reason, when it is common the pattern
 *  ```ts
 *  encode( uplcObj: UPLC ): BitStream
 *  {
 *      const serialized = serilize( uplcObj );
 *      this._ctx.incrementLengthBy( serialized.length );
 *      return serialized;
 *  }
 *  ```
*/
function serializeUInt(uint) {
    return UPLCFlatUtils_1.default.encodeBigIntAsVariableLengthBitStream(BigInt(uint));
}
function serializeInt(int) {
    (0, assert_1.assert)(typeof int === "number" || typeof int === "bigint", "'serializeInt' only works for Signed Integer; " +
        "try using int.toSigned() if you are using a derived class; inpout was: " + int);
    int = typeof int === "number" ? BigInt(int) : int;
    return serializeUInt(UPLCFlatUtils_1.default.zigzagBigint(int));
}
function serializeVersion(version) {
    var result = serializeUInt(version.major);
    result.append(serializeUInt(version.minor));
    result.append(serializeUInt(version.patch));
    return result;
}
function serializeUPLCVar(uplcVar) {
    var result = UPLCVar_1.UPLCVar.UPLCTag;
    result.append(serializeUInt(
    // no idea why deBruijn indicies start form 1...s
    // can devs do something?
    uplcVar.deBruijn + BigInt(1)));
    return result;
}
function serializeConstType(type) {
    (0, assert_1.assert)((0, ConstType_1.isWellFormedConstType)(type), "cannot serialize an UPLC constant type if it is not well formed");
    /**
     *
     * Source: plutus-core-specification-june2022.pdf; section D.3.3; page 31
     *
     *  We define the encoder and decoder for types by combining 𝖾 𝗍𝗒𝗉𝖾 and 𝖽 𝗍𝗒𝗉𝖾 with 𝖤
     *  and decoder for lists of four-bit integers (see Section D.2).
     *
     * Section D.2 ( D.2.2 )
     *
     * Suppose that we have a set 𝑋 for which we have defined an encoder 𝖤 𝑋 and a decoder 𝖣 𝑋 ; we define an
⃖⃗     * 𝑋 which encodes lists of elements of 𝑋 by emitting the encodings of the elements of the list,
     * encoder 𝖤
     * **each preceded by a 𝟷 bit, then emitting a 𝟶 bit to mark the end of the list.**
     *
     */
    function _serializeConstTyTagToUPLCBinaryString(typeTag) {
        if (typeTag === ConstType_1.ConstTyTag.list) {
            return ("1" + "0111" + // cons + (7).toString(2).padStart( 4, '0' ) // type application
                "1" + "0101" // cons + (5).toString(2).padStart( 4, '0' ) // list
            // "0"                        // nil // not needed (well formed) types do expects other tags after list
            );
        }
        else if (typeTag === ConstType_1.ConstTyTag.pair) {
            return ("1" + "0111" + // cons + (7).toString(2).padStart( 4, '0' ) // type application
                "1" + "0111" + // cons + (7).toString(2).padStart( 4, '0' ) // type application
                "1" + "0110" // cons + (5).toString(2).padStart( 4, '0' ) // pair
            // "0"            // nil // not needed (well formed) types do expects other tags after pairs
            );
        }
        else if (typeTag === ConstType_1.ConstTyTag.bls12_381_G1_element ||
            typeTag === ConstType_1.ConstTyTag.bls12_381_G2_element ||
            typeTag === ConstType_1.ConstTyTag.bls12_381_MlResult)
            throw new Error("bls constants are not allowed in serialized UPLC");
        else {
            return ("1" + typeTag.toString(2).padStart(4, '0'));
        }
    }
    return bitstream_1.BitStream.fromBinStr(type.map(_serializeConstTyTagToUPLCBinaryString).join('') + "0");
}
/**
 * exported for testing purposes
 */
function serializeBuiltin(bn) {
    (0, assert_1.assert)((0, UPLCBuiltinTag_1.isUPLCBuiltinTag)(bn.tag), "while serializing a Builtin 'bn.tag' is not a valid builtin tag: bn.tag: " + bn.tag);
    var nRequiredForces = (0, UPLCBuiltinTag_1.getNRequiredForces)(bn.tag);
    var result = nRequiredForces === 0 ? new bitstream_1.BitStream(undefined) :
        bitstream_1.BitStream.fromBinStr("0101".repeat(nRequiredForces) // "force" tag repeated as necessary
        );
    result.append(Builtin_1.Builtin.UPLCTag);
    result.append(bitstream_1.BitStream.fromBinStr(bn.tag.toString(2).padStart(7, '0') // builtin tag takes 7 bits
    ));
    return result;
}
exports.serializeBuiltin = serializeBuiltin;
exports.defaultUPLCEncoderOptions = Object.freeze({
    trivialOptimization: false
});
// ------------------------------------------------------------------------------------------------------------------- //
// --------------------------------------------------- UPLCEncoder --------------------------------------------------- //
// ------------------------------------------------------------------------------------------------------------------- //
var UPLCEncoder = /** @class */ (function () {
    function UPLCEncoder(options) {
        if (options === void 0) { options = exports.defaultUPLCEncoderOptions; }
        this._ctx = new UPLCSerializationContext_1.UPLCSerializationContex({
            currLength: 0
        });
        this._options = options;
    }
    UPLCEncoder.prototype.compile = function (program, options) {
        if (options === void 0) { options = exports.defaultUPLCEncoderOptions; }
        this._options = __assign(__assign(__assign({}, this._options), exports.defaultUPLCEncoderOptions), options);
        var v = program.version;
        this._ctx.updateVersion(v);
        var uplc = program.body;
        if (!(0, UPLCTerm_1.isPureUPLCTerm)(uplc)) {
            throw new Error("'replaceHoisteTerm' did not return an 'UPLCTerm'");
        }
        // might modify version if necessary
        var encodedProgram = this.encodeTerm(uplc);
        // version is always byte-alligned
        var result = this.encodeVersion(this._ctx.version);
        result.append(encodedProgram);
        UPLCFlatUtils_1.default.padToByte(result);
        return result;
    };
    UPLCEncoder.compile = function (program, options) {
        if (options === void 0) { options = exports.defaultUPLCEncoderOptions; }
        return (new UPLCEncoder(options)).compile(program, options);
    };
    /** always byte-alligned */
    UPLCEncoder.prototype.encodeVersion = function (version) {
        var serialized = serializeVersion(version);
        this._ctx.incrementLengthBy(serialized.length);
        return serialized;
    };
    /** might modify version if necessary */
    UPLCEncoder.prototype.encodeTerm = function (term) {
        if (term instanceof UPLCVar_1.UPLCVar)
            return this.encodeUPLCVar(term);
        if (term instanceof Delay_1.Delay)
            return this.encodeDelayTerm(term);
        if (term instanceof Lambda_1.Lambda)
            return this.encodeLambdaTerm(term);
        if (term instanceof Application_1.Application)
            return this.encodeApplicationTerm(term);
        if (term instanceof UPLCConst_1.UPLCConst)
            return this.encodeConstTerm(term);
        if (term instanceof Force_1.Force)
            return this.encodeForceTerm(term);
        if (term instanceof ErrorUPLC_1.ErrorUPLC)
            return this.encodeUPLCError(term);
        if (term instanceof Builtin_1.Builtin)
            return this.encodeBuiltin(term);
        if (term instanceof Constr_1.Constr)
            return this.encodeConstr(term);
        if (term instanceof Case_1.Case)
            return this.encodeCase(term);
        throw new Error("'UPLCEncoder.encodeTerm' did not match any 'PureUPLCTerm'");
    };
    UPLCEncoder.prototype.encodeUPLCVar = function (uplcVar) {
        var serialized = serializeUPLCVar(uplcVar);
        this._ctx.incrementLengthBy(serialized.length);
        return serialized;
    };
    UPLCEncoder.prototype.encodeDelayTerm = function (delayed) {
        var result = Delay_1.Delay.UPLCTag;
        this._ctx.incrementLengthBy(result.length);
        result.append(this.encodeTerm(delayed.delayedTerm));
        return result;
    };
    UPLCEncoder.prototype.encodeLambdaTerm = function (lam) {
        var result = Lambda_1.Lambda.UPLCTag;
        this._ctx.incrementLengthBy(result.length);
        /*
        only the body of the lambda is encoded since the new variable is implicit
        this is not referencied in any current specification but it is present in the `plutus` source code:

        Here is where they called encode with the binder while encoding a Lambda Term

        https://github.com/input-output-hk/plutus/blob/c8d4364d0e639fef4d5b93f7d6c0912d992b54f9/plutus-core/untyped-plutus-core/src/UntypedPlutusCore/Core/Instance/Flat.hs#L110


        Here is where binder is defined

        https://github.com/input-output-hk/plutus/blob/c8d4364d0e639fef4d5b93f7d6c0912d992b54f9/plutus-core/plutus-core/src/PlutusCore/Core/Type.hs#L228


        And (most importantly) where flat encoding for binder is derived

        https://github.com/input-output-hk/plutus/blob/c8d4364d0e639fef4d5b93f7d6c0912d992b54f9/plutus-core/plutus-core/src/PlutusCore/Flat.hs#L354
        */
        result.append(this.encodeTerm(lam.body));
        return result;
    };
    UPLCEncoder.prototype.encodeApplicationTerm = function (app) {
        // if can use case/constr terms
        if ((this._options.trivialOptimization === true) &&
            this._ctx.is_v3_friendly) {
            var args = [];
            var term = app;
            while (term instanceof Application_1.Application) {
                // prepend element to keep same order
                args.unshift(term.argTerm);
                term = term.funcTerm;
            }
            // and we have more than 2 consecutive applications
            if (args.length > 2) {
                // use case and constr so that it costs
                // as much as only 2 applications
                return this.encodeCase(new Case_1.Case(new Constr_1.Constr(BigInt(0), args), 
                // only one continutation; the last func term
                // (the one that expects the arguments)
                [term]));
            }
            // else continue with normal application encoding
        }
        // normal application encoding
        // always used in v1 and v2
        var result = Application_1.Application.UPLCTag;
        this._ctx.incrementLengthBy(result.length);
        result.append(this.encodeTerm(app.funcTerm));
        result.append(this.encodeTerm(app.argTerm));
        return result;
    };
    UPLCEncoder.prototype.encodeConstTerm = function (uplcConst) {
        // 4 bits
        var result = UPLCConst_1.UPLCConst.UPLCTag;
        result.append(
        // ((1 + 4) * nTypes) bits
        // 1 bit for the closing 0
        serializeConstType(uplcConst.type));
        // tag and type where both context indipendent
        this._ctx.incrementLengthBy(result.length);
        result.append(this.encodeConstValue(uplcConst.value));
        return result;
    };
    UPLCEncoder.prototype.encodeConstValue = function (value) {
        (0, assert_1.assert)((0, ConstValue_1.isConstValue)(value), "a 'ConstValue' instance was expected; got" + value);
        if ((0, crypto_1.isBlsG1)(value) ||
            (0, crypto_1.isBlsG2)(value) ||
            (0, crypto_1.isBlsResult)(value))
            throw new Error("bls constants are not allowed in serialized UPLC");
        if (value === undefined)
            return new bitstream_1.BitStream();
        if ((0, ConstValue_1.isConstValueInt)(value)) {
            var _i = serializeInt(value);
            // ints are always serialized in chunks of 8 bits
            // this should be irrelevant but still good to have
            this._ctx.incrementLengthBy(_i.length);
            return _i;
        }
        if (value instanceof bytestring_1.ByteString &&
            (bytestring_1.ByteString.isStrictInstance(value))) {
            // padding is added based on context
            return this.encodeConstValueByteString(value);
        }
        if (typeof value === "string") {
            /*
            Section D.2.6 Strings (page 28)
    
            We have defined values of the string type to be sequences of Unicode characters. As mentioned earlier
            we do not specify any particular internal representation of Unicode characters, but for serialisation we use
            the UTF-8 representation to convert between strings and bytestrings
            
            **and then use the bytestring encoder and decoder**:
            */
            return this.encodeConstValue(new bytestring_1.ByteString((0, uint8array_utils_1.fromUtf8)(value)));
        }
        if (typeof value === "boolean") {
            var _b = bitstream_1.BitStream.fromBinStr(value === true ? "1" : "0");
            this._ctx.incrementLengthBy(_b.length);
            return _b;
        }
        if ((0, ConstValue_1.isConstValueList)(value)) {
            var result = new bitstream_1.BitStream();
            /*
            operations on bigints (BitStream underlying type) are O(n)
            appending first to this BitStream and then to the effective result
            should give us some performace improvements
            */
            var listElem = void 0;
            for (var i = 0; i < value.length; i++) {
                // cons
                listElem = bitstream_1.BitStream.fromBinStr("1");
                this._ctx.incrementLengthBy(1);
                // set list element
                listElem.append(this.encodeConstValue(value[i]));
                // append element
                // length already updated since using an "encode" function
                result.append(listElem);
            }
            // nil
            result.append(bitstream_1.BitStream.fromBinStr("0"));
            this._ctx.incrementLengthBy(1);
            return result;
        }
        if (value instanceof pair_1.Pair) {
            var result = this.encodeConstValue(value.fst);
            result.append(this.encodeConstValue(value.snd));
            return result;
        }
        if (value instanceof cbor_1.CborString) {
            value = (0, plutus_data_1.dataFromCbor)(value);
        }
        if ((0, plutus_data_1.isData)(value)) {
            return this.encodeConstValueData(value);
        }
        throw new Error("'this.encodeConstValue' did not matched any 'ConstValue' possible type; input was: " + value);
    };
    /**
     * ### Section D.3.5
     * The ```data``` type
     *
     * The 𝚍𝚊𝚝𝚊 type is encoded by converting to a bytestring using the CBOR encoding described in Note 1 of
     * Appendix B.2 and then using 𝖤 𝕌 ∗ . The decoding process is the opposite of this: a bytestring is obtained
     * using 𝖣 𝕌 ∗ and this is then decoded from CBOR to obtain a 𝚍𝚊𝚝𝚊 object.
     *
     * ### Section B.2
     *
     * **Note 1.** Serialising 𝚍𝚊𝚝𝚊 objects. The ```serialiseData``` function takes a 𝚍𝚊𝚝𝚊 object and converts it
     * into a CBOR (Bormann and Hoffman [2020]) object. The encoding is based on the Haskell Data type
     * described in Section A.1. A detailed description of the encoding will appear here at a later date, but for
     * the time being see the Haskell code in
     * [plutus-core/plutus-core/src/PlutusCore/Data.hs](https://github.com/input-output-hk/plutus/blob/master/plutus-core/plutus-core/src/PlutusCore/Data.hs)
     * ([```encodeData``` line](https://github.com/input-output-hk/plutus/blob/9ef6a65067893b4f9099215ff7947da00c5cd7ac/plutus-core/plutus-core/src/PlutusCore/Data.hs#L139))
     * in the Plutus GitHub repository IOHK [2019] for a definitive implementation.
     *
     * from the `encodeData` source:
     *
     * {- Note [The 64-byte limit]
     *    We impose a 64-byte *on-the-wire* limit on the leaves of a serialized 'Data'. This prevents people from inserting
     *    Mickey Mouse entire.
     *
     *    The simplest way of doing this is to check during deserialization that we never deserialize something that uses
     *    more than 64-bytes, and this is largely what we do. Then it's the user's problem to not produce something too big.
     *
     *    But this is quite inconvenient, so see Note [Evading the 64-byte limit] for how we get around this.
     * -}
     * {- Note [Evading the 64-byte limit]
     *  Implementing Note [The 64-byte limit] naively would be quite annoying:
     *  - Users would be responsible for not creating Data values with leaves that were too big.
     *  - If a script *required* such a thing (e.g. a counter that somehow got above 64 bytes), then the user is totally
     *  stuck: the script demands something they cannot represent.
     *
     *  This is unpleasant and introduces limits. Probably limits that nobody will hit, but it's nicer to just not have them.
     *  And it turns out that we can evade the problem with some clever encoding.
     *
     *  The fundamental
     *  trick is that an *indefinite-length* CBOR bytestring is just as obfuscated as a list of bytestrings,
     *  since it consists of a list of definite-length chunks, and each definite-length chunk must be *tagged* (at least with the size).
     *  So we get a sequence like:
     *
     *  <list start>
     *  <chunk length metadata>
     *  <chunk>
     *  <chunk length metadata>
     *  ...
     *  <list end>
     *
     *  The chunk length metadata has a prescribed format, such that it's difficult to manipulate it so that it
     *  matches your "desired" data.
     *  So this effectively breaks up the bytestring in much the same way as a list of <64 byte bytestrings.
     *
     *  So that solves the problem for bytestrings on the encoding side:
     *  - if they are <=64 bytes, we can just encode them as a normal bytestring
     *  - if they are >64 bytes, we encode them as indefinite-length bytestrings with 64-byte chunks
     *
     *  On the decoding side, we need to check when we decode that we never decode a definite-length
     *  bytestring of >64 bytes. That covers our two cases:
     *  - Short definite-length bytestrings are fine
     *  - Long indefinite-length bytestrings are just made of short definite-length bytestings.
     *
     *   *  Unfortunately this all means that we have to write our own encoders/decoders so we can produce
     *   *  chunks of the right size and check the sizes when we decode, but that's okay. Users need to do the same
     *   *  thing: anyone encoding `Data` with their own encoders who doesn't split up big bytestrings in this way
     *   *  will get failures when we decode them.
     *
     *  For integers, we have two cases. Small integers (<=64bits) can be encoded normally. Big integers are already
     *  encoded *with a byte string*. The spec allows this to be an indefinite-length bytestring (although cborg doesn't
     *  like it), so we can reuse our trick. Again, we need to write some manual encoders/decoders.
     *  -}
     */
    UPLCEncoder.prototype.encodeConstValueData = function (data) {
        var cborBytes = (0, plutus_data_1.dataToCbor)(data).toBuffer();
        /*
        **NOTE**

        large data encoding

        Before we thought this was only an UPLC serialization problem;
        and that the UPLC builtin `serialiseData` would have just resulted
        in a normal CBOR bytestring, no matter the length.

        section 4.3.2 (Note 1) is instead clear that the above was not the case
        and that the `serialiseData` is subject to the same serialization with
        hard coded limit on bytestrings length

        `dataToCbor` was fixed accordingly since `@harmoniclabs/plutus-data@^1.2.0`
        so we can rely on that function both in UPLC serialization
        and on-chain builtin `serialiseData` execution
        */
        return this.encodeConstValueByteString(new bytestring_1.ByteString(cborBytes));
    };
    /**
     * latest specification (**_section D.2.5 Bytestrings; page 27_**)
     * specifies how bytestrings are byte-alligned before and the first byte indicates the length
     *
     * **this function takes care of the length AND padding**
     *
     */
    UPLCEncoder.prototype.encodeConstValueByteString = function (bs) {
        var missingBytes = bs.toString();
        var hexChunks = [];
        while ((missingBytes.length / 2) > 255) {
            hexChunks.push("ff" + missingBytes.slice(0, 255 * 2));
            missingBytes = missingBytes.slice(255 * 2);
        }
        if (missingBytes.length !== 0) {
            hexChunks.push((missingBytes.length / 2).toString(16).padStart(2, '0') +
                missingBytes);
        }
        // end chunk
        hexChunks.push("00");
        var nPadBits = 8 - (this._ctx.currLength % 8);
        // add initial padding as needed by context
        var result = bitstream_1.BitStream.fromBinStr("1".padStart(nPadBits, '0'));
        // append chunks
        result.append(new bitstream_1.BitStream((0, uint8array_utils_1.fromHex)(hexChunks.join('')), 0));
        this._ctx.incrementLengthBy(result.length);
        return result;
    };
    UPLCEncoder.prototype.encodeForceTerm = function (force) {
        if ((this._options.trivialOptimization === true) &&
            force.termToForce instanceof Delay_1.Delay) {
            // cancels direct delays
            return this.encodeTerm(force.termToForce.delayedTerm);
        }
        var result = Force_1.Force.UPLCTag;
        this._ctx.incrementLengthBy(result.length);
        result.append(this.encodeTerm(force.termToForce));
        return result;
    };
    UPLCEncoder.prototype.encodeUPLCError = function (_term) {
        var errTag = ErrorUPLC_1.ErrorUPLC.UPLCTag;
        this._ctx.incrementLengthBy(errTag.length);
        return errTag.clone();
    };
    UPLCEncoder.prototype.encodeBuiltin = function (bn) {
        var result = serializeBuiltin(bn);
        this._ctx.incrementLengthBy(result.length);
        return result;
    };
    UPLCEncoder.prototype.encodeConstr = function (constr) {
        if (!this._ctx.is_v3_friendly)
            throw new Error("'Constr' term found using UPLC version " +
                this._ctx.version.toString() +
                "; maybe you wanted to use version 1.1.0 or higher?");
        var result = Constr_1.Constr.UPLCTag;
        result.append(serializeUInt(constr.index));
        this._ctx.incrementLengthBy(result.length);
        result.append(this.encodeTermList(constr.terms));
        return result;
    };
    UPLCEncoder.prototype.encodeCase = function (caseTerm) {
        if (!this._ctx.is_v3_friendly)
            throw new Error("'Case' term found using UPLC version " +
                this._ctx.version.toString() +
                "; maybe you wanted to use version 1.1.0 or higher?");
        var result = Case_1.Case.UPLCTag;
        this._ctx.incrementLengthBy(result.length);
        result.append(this.encodeTerm(caseTerm.constrTerm));
        result.append(this.encodeTermList(caseTerm.continuations));
        return result;
    };
    UPLCEncoder.prototype.encodeTermList = function (list) {
        var _this = this;
        if (list.length === 0) {
            this._ctx.incrementLengthBy(1);
            return bitstream_1.BitStream.fromBinStr("0");
        }
        ;
        var ctx = this._ctx;
        var result = list
            .reduce(function (accum, elem) {
            var result = bitstream_1.BitStream.fromBinStr("1");
            // increment BEFORE `this.encodeTerm`
            ctx.incrementLengthBy(1);
            result.append(_this.encodeTerm(elem));
            accum.append(result);
            return accum;
        }, new bitstream_1.BitStream(undefined));
        ctx.incrementLengthBy(1);
        result.append(bitstream_1.BitStream.fromBinStr("0"));
        return result;
    };
    return UPLCEncoder;
}());
exports.UPLCEncoder = UPLCEncoder;
function compileUPLC(program, options) {
    if (options === void 0) { options = exports.defaultUPLCEncoderOptions; }
    return (new UPLCEncoder(options)).compile(program, options);
}
exports.compileUPLC = compileUPLC;
/**
 * alias for `compileUPLC`
 */
exports.encodeUPLC = compileUPLC;


/***/ }),

/***/ 62830:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UPLCProgram = void 0;
var UPLCVersion_1 = __webpack_require__(76844);
var UPLCProgram = /** @class */ (function () {
    function UPLCProgram(version, body) {
        if (Array.isArray(version)) {
            this._version = new (UPLCVersion_1.UPLCVersion.bind.apply(UPLCVersion_1.UPLCVersion, __spreadArray([void 0], __read(version), false)))();
        }
        else {
            this._version = version;
        }
        this._body = body;
    }
    Object.defineProperty(UPLCProgram.prototype, "version", {
        get: function () { return this._version; },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(UPLCProgram.prototype, "body", {
        get: function () { return this._body; },
        enumerable: false,
        configurable: true
    });
    ;
    return UPLCProgram;
}());
exports.UPLCProgram = UPLCProgram;


/***/ }),

/***/ 76844:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultUplcVersion = exports.UPLCVersion = void 0;
var ints_1 = __webpack_require__(25301);
var UPLCVersion = /** @class */ (function () {
    function UPLCVersion(major, minor, patch) {
        this._major = (0, ints_1.forceBigUInt)(major);
        this._minor = (0, ints_1.forceBigUInt)(minor);
        this._patch = (0, ints_1.forceBigUInt)(patch);
    }
    Object.defineProperty(UPLCVersion.prototype, "major", {
        get: function () { return this._major; },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(UPLCVersion.prototype, "minor", {
        get: function () { return this._minor; },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(UPLCVersion.prototype, "patch", {
        get: function () { return this._patch; },
        enumerable: false,
        configurable: true
    });
    ;
    UPLCVersion.prototype.isV3Friendly = function () {
        // ^1.1.0 || >= 2.*.*
        return this.major === BigInt(1) ?
            this.minor >= 1 :
            this.major >= 2;
    };
    UPLCVersion.prototype.toString = function () {
        return "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch);
    };
    UPLCVersion.fromString = function (str) {
        var _a = __read(str.split("."), 3), a = _a[0], b = _a[1], c = _a[2];
        return new UPLCVersion(BigInt(a), BigInt(b), BigInt(c));
    };
    return UPLCVersion;
}());
exports.UPLCVersion = UPLCVersion;
exports.defaultUplcVersion = new UPLCVersion(1, 1, 0);


/***/ }),

/***/ 48017:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(62830), exports);
__exportStar(__webpack_require__(76844), exports);


/***/ }),

/***/ 14740:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.eqUPLCTerm = exports.getUPLCVarRefsInTerm = exports.hasMultipleRefsInTerm = exports.hasAnyRefsInTerm = exports.prettyUPLC = exports.showUPLC = exports.showConstType = exports.showUPLCConstValue = exports.isClosedTerm = exports.isPureUPLCTerm = exports.isUPLCTerm = void 0;
var UPLCVar_1 = __webpack_require__(79369);
var Delay_1 = __webpack_require__(93974);
var Lambda_1 = __webpack_require__(51644);
var Application_1 = __webpack_require__(80271);
var UPLCConst_1 = __webpack_require__(46698);
var Force_1 = __webpack_require__(66064);
var ErrorUPLC_1 = __webpack_require__(54915);
var Builtin_1 = __webpack_require__(69537);
var ConstType_1 = __webpack_require__(89020);
var UPLCBuiltinTag_1 = __webpack_require__(31110);
var ConstValue_1 = __webpack_require__(54631);
var bytestring_1 = __webpack_require__(86152);
var pair_1 = __webpack_require__(53307);
var plutus_data_1 = __webpack_require__(34635);
var assert_1 = __webpack_require__(63952);
var Constr_1 = __webpack_require__(66240);
var Case_1 = __webpack_require__(49629);
var crypto_1 = __webpack_require__(15251);
var uint8array_utils_1 = __webpack_require__(44948);
/**
 * **_O(1)_**
 * @param {UPLCTerm} t ```UPLCTerm``` to check
 * @returns {boolean} ```true``` if the argument is instance of any of the ```UPLCTerm``` constructors, ```false``` otherwise
 */
function isUPLCTerm(t) {
    // only strict instances
    return (t instanceof UPLCVar_1.UPLCVar ||
        t instanceof Delay_1.Delay ||
        t instanceof Lambda_1.Lambda ||
        t instanceof Application_1.Application ||
        t instanceof UPLCConst_1.UPLCConst ||
        t instanceof Force_1.Force ||
        t instanceof ErrorUPLC_1.ErrorUPLC ||
        t instanceof Builtin_1.Builtin ||
        t instanceof Constr_1.Constr ||
        t instanceof Case_1.Case);
}
exports.isUPLCTerm = isUPLCTerm;
/**
 * **_O(n)_**
 * @param {UPLCTerm} t ```UPLCTerm``` to check
 * @returns {boolean} ```true``` if the AST contains only plutus-core terms, ```false``` otherwise
 */
function isPureUPLCTerm(t) {
    if (!isUPLCTerm(t))
        return false;
    if (t instanceof UPLCVar_1.UPLCVar)
        return true;
    if (t instanceof Delay_1.Delay)
        return isPureUPLCTerm(t.delayedTerm);
    if (t instanceof Lambda_1.Lambda)
        return isPureUPLCTerm(t.body);
    if (t instanceof Application_1.Application)
        return (isPureUPLCTerm(t.argTerm) && isPureUPLCTerm(t.funcTerm));
    if (t instanceof UPLCConst_1.UPLCConst)
        return true;
    if (t instanceof Force_1.Force)
        return isPureUPLCTerm(t.termToForce);
    if (t instanceof ErrorUPLC_1.ErrorUPLC)
        return true;
    if (t instanceof Builtin_1.Builtin)
        return true;
    if (t instanceof Constr_1.Constr)
        return t.terms.every(isPureUPLCTerm);
    if (t instanceof Case_1.Case)
        return isPureUPLCTerm(t.constrTerm) && t.continuations.every(isPureUPLCTerm);
    return false;
}
exports.isPureUPLCTerm = isPureUPLCTerm;
function _isClosedTerm(maxDeBruijn, t) {
    (0, assert_1.assert)(isUPLCTerm(t), "'isClosedTerm' functions only works on **raw** UPLCTerms");
    if (t instanceof UPLCVar_1.UPLCVar)
        // deBruijn variables are 0 indexed (as arrays)
        return maxDeBruijn > t.deBruijn;
    else if (t instanceof Delay_1.Delay)
        return _isClosedTerm(maxDeBruijn, t.delayedTerm);
    else if (t instanceof Lambda_1.Lambda)
        // increment max debruijn
        return _isClosedTerm(maxDeBruijn + BigInt(1), t.body);
    else if (t instanceof Application_1.Application)
        return _isClosedTerm(maxDeBruijn, t.funcTerm) && _isClosedTerm(maxDeBruijn, t.argTerm);
    else if (t instanceof UPLCConst_1.UPLCConst)
        // `UPLCConst` has no variables in it, ence always closed
        return true;
    else if (t instanceof Force_1.Force)
        return _isClosedTerm(maxDeBruijn, t.termToForce);
    else if (t instanceof ErrorUPLC_1.ErrorUPLC)
        // `ErrorUPLC` has no variables in it, ence always closed
        return true;
    else if (t instanceof Builtin_1.Builtin)
        // builtin per-se is just the function (ence a valid value),
        // arguments are passed using the `Apply` Term
        // so it is the `t instanceof Apply` case job
        // to be sure the arguments are closed
        return true;
    else if (t instanceof Constr_1.Constr)
        return t.terms.every(function (term) { return _isClosedTerm(maxDeBruijn, term); });
    else if (t instanceof Case_1.Case)
        return (_isClosedTerm(maxDeBruijn, t.constrTerm) &&
            t.continuations.every(function (term) { return _isClosedTerm(maxDeBruijn, term); }));
    else
        throw new Error("unexpected execution flow in 'isClodeTerm'; all possibilieties should have already been handled; input term is: " + t.toString());
}
function isClosedTerm(term) {
    return _isClosedTerm(BigInt(0), term);
}
exports.isClosedTerm = isClosedTerm;
function showUPLCConstValue(v) {
    if (v === undefined)
        return "()";
    if ((0, ConstValue_1.isConstValueInt)(v))
        return v.toString();
    if (typeof v === "string")
        return "\"".concat(v, "\"");
    if (typeof v === "boolean")
        return v ? "True" : "False";
    if (v instanceof bytestring_1.ByteString)
        return "#" + v.toString();
    if ((0, plutus_data_1.isData)(v))
        return v.toString();
    if ((0, crypto_1.isBlsG1)(v))
        return "0x".concat((0, uint8array_utils_1.toHex)((0, crypto_1.bls12_381_G1_compress)(v)));
    if ((0, crypto_1.isBlsG2)(v))
        return "0x".concat((0, uint8array_utils_1.toHex)((0, crypto_1.bls12_381_G2_compress)(v)));
    if ((0, crypto_1.isBlsResult)(v))
        return JSON.stringify(v, function (k, v) { return typeof v === "bigint" ? v.toString() : v; });
    if (Array.isArray(v))
        return "[" + v.map(showUPLCConstValue).join(',') + "]";
    if (v instanceof pair_1.Pair)
        return "(".concat(showUPLCConstValue(v.fst), ",").concat(showUPLCConstValue(v.snd), ")");
    throw new Error("'showUPLCConstValue' did not matched any possible constant value");
}
exports.showUPLCConstValue = showUPLCConstValue;
function showConstType(t) {
    if (t[0] === ConstType_1.ConstTyTag.list) {
        return "(list ".concat(showConstType(ConstType_1.constListTypeUtils.getTypeArgument(t)), ")");
    }
    if (t[0] === ConstType_1.ConstTyTag.pair) {
        return "(pair ".concat(showConstType(ConstType_1.constPairTypeUtils.getFirstTypeArgument(t)), " ").concat(showConstType(ConstType_1.constPairTypeUtils.getSecondTypeArgument(t)), ")");
    }
    return (0, ConstType_1.constTypeToStirng)(t);
}
exports.showConstType = showConstType;
var vars = "abcdefghilmopqrstuvzwxyjkABCDEFGHILJMNOPQRSTUVZWXYJK".split('');
function getVarNameForDbn(dbn) {
    if (dbn < 0)
        return "(".concat(dbn, ")");
    if (dbn < vars.length)
        return vars[dbn];
    return vars[Math.floor(dbn / vars.length)] + getVarNameForDbn(dbn - vars.length);
}
function _showUPLC(t, dbn) {
    if (t instanceof UPLCVar_1.UPLCVar) {
        return getVarNameForDbn(dbn - 1 - Number(t.deBruijn));
    }
    if (t instanceof Delay_1.Delay)
        return "(delay ".concat(_showUPLC(t.delayedTerm, dbn), ")");
    if (t instanceof Lambda_1.Lambda) {
        return "(lam ".concat(getVarNameForDbn(dbn), " ").concat(_showUPLC(t.body, dbn + 1), ")");
    }
    if (t instanceof Application_1.Application)
        return "[".concat(_showUPLC(t.funcTerm, dbn), " ").concat(_showUPLC(t.argTerm, dbn), "]");
    if (t instanceof UPLCConst_1.UPLCConst)
        return "(con ".concat(showConstType(t.type), " ").concat(showUPLCConstValue(t.value), ")");
    if (t instanceof Force_1.Force)
        return "(force ".concat(_showUPLC(t.termToForce, dbn), ")");
    if (t instanceof ErrorUPLC_1.ErrorUPLC)
        return "(error)";
    if (t instanceof Builtin_1.Builtin) {
        var nForces = (0, UPLCBuiltinTag_1.getNRequiredForces)(t.tag);
        return "(force ".repeat(nForces) + "(builtin ".concat((0, UPLCBuiltinTag_1.builtinTagToString)(t.tag), ")") + ')'.repeat(nForces);
    }
    if (t instanceof Constr_1.Constr) {
        return "(constr " + t.index.toString() + " " + t.terms.map(function (term) { return _showUPLC(term, dbn); }).join(" ") + ")";
    }
    if (t instanceof Case_1.Case) {
        return "(case " + _showUPLC(t.constrTerm, dbn) + " " + t.continuations.map(function (term) { return _showUPLC(term, dbn); }).join(" ") + ")";
    }
    return "";
}
function showUPLC(term) {
    return _showUPLC(term, 0);
}
exports.showUPLC = showUPLC;
function prettyUPLC(term, _indent) {
    if (_indent === void 0) { _indent = 2; }
    if (!Number.isSafeInteger(_indent) || _indent < 1)
        return showUPLC(term);
    var indentStr = " ".repeat(_indent);
    function getVarNameForDbn(dbn) {
        if (dbn < 0)
            return "(".concat(dbn, ")");
        if (dbn < vars.length)
            return vars[dbn];
        return vars[Math.floor(dbn / vars.length)] + getVarNameForDbn(dbn - vars.length);
    }
    function _prettyUPLC(t, dbn, depth) {
        var indent = "\n".concat(indentStr.repeat(depth));
        if (t instanceof UPLCVar_1.UPLCVar) {
            return indent + getVarNameForDbn(dbn - 1 - Number(t.deBruijn));
        }
        if (t instanceof Delay_1.Delay)
            return "".concat(indent, "(delay ").concat(_prettyUPLC(t.delayedTerm, dbn, depth + 1)).concat(indent, ")");
        if (t instanceof Lambda_1.Lambda) {
            return "".concat(indent, "(lam ").concat(getVarNameForDbn(dbn), " ").concat(_prettyUPLC(t.body, dbn + 1, depth + 1)).concat(indent, ")");
        }
        if (t instanceof Application_1.Application)
            return "".concat(indent, "[").concat(_prettyUPLC(t.funcTerm, dbn, depth + 1), " ").concat(_prettyUPLC(t.argTerm, dbn, depth + 1)).concat(indent, "]");
        if (t instanceof UPLCConst_1.UPLCConst)
            return "".concat(indent, "(con ").concat(showConstType(t.type), " ").concat(showUPLCConstValue(t.value), ")");
        if (t instanceof Force_1.Force)
            return "".concat(indent, "(force ").concat(_prettyUPLC(t.termToForce, dbn, depth + 1)).concat(indent, ")");
        if (t instanceof ErrorUPLC_1.ErrorUPLC)
            return "(error)";
        if (t instanceof Builtin_1.Builtin) {
            var nForces = (0, UPLCBuiltinTag_1.getNRequiredForces)(t.tag);
            return indent + "(force ".repeat(nForces) + "(builtin ".concat((0, UPLCBuiltinTag_1.builtinTagToString)(t.tag), ")") + ')'.repeat(nForces);
        }
        if (t instanceof Constr_1.Constr) {
            if (t.terms.length === 0)
                return indent + "(constr " + t.index.toString() + ")";
            var nextIndent = indent + indentStr;
            return indent + "(constr " + t.index.toString() +
                nextIndent + "[" + t.terms.map(function (term) { return _prettyUPLC(term, dbn, depth + 2); }).join(",\n") +
                nextIndent + "]" +
                indent + ")";
        }
        if (t instanceof Case_1.Case) {
            var nextIndent = indent + indentStr;
            return indent + "(case" +
                _prettyUPLC(t.constrTerm, dbn, depth + 1) +
                nextIndent + "[" +
                t.continuations.map(function (term) { return _prettyUPLC(term, dbn, depth + 2); }).join(",\n") +
                nextIndent + "]\n" +
                indent + ")";
        }
        return "";
    }
    return _prettyUPLC(term, 0, 0);
}
exports.prettyUPLC = prettyUPLC;
/**
 *
 * @param {number | bigint} varDeBruijn ```number | bigint```; debruijn level (at the term level) of the variable to search for
 * @param {UPLCTerm} t ```UPLCTerm``` to search in
 * @returns {boolean} ```true``` if the variable has **at least** 1 or more references; ```false``` otherwise
 */
function hasAnyRefsInTerm(varDeBruijn, t) {
    (0, assert_1.assert)(isUPLCTerm(t), "'getUPLCVarRefsInTerm' expects an UPLCTerms");
    var dbn = BigInt(varDeBruijn);
    if (t instanceof UPLCVar_1.UPLCVar)
        return t.deBruijn === dbn;
    if (t instanceof Delay_1.Delay)
        return hasAnyRefsInTerm(dbn, t.delayedTerm);
    if (t instanceof Lambda_1.Lambda)
        return hasAnyRefsInTerm(dbn + BigInt(1), t.body);
    if (t instanceof Application_1.Application)
        return hasAnyRefsInTerm(dbn, t.funcTerm) || hasAnyRefsInTerm(dbn, t.argTerm);
    if (t instanceof UPLCConst_1.UPLCConst)
        return false;
    if (t instanceof Force_1.Force)
        return hasAnyRefsInTerm(dbn, t.termToForce);
    if (t instanceof ErrorUPLC_1.ErrorUPLC)
        return false;
    if (t instanceof Builtin_1.Builtin)
        return false;
    if (t instanceof Constr_1.Constr)
        return t.terms.some(function (term) { return hasAnyRefsInTerm(dbn, term); });
    if (t instanceof Case_1.Case)
        return hasAnyRefsInTerm(dbn, t.constrTerm) || t.continuations.some(function (term) { return hasAnyRefsInTerm(dbn, term); });
    throw new Error("'hasAnyRefsInTerm' did not matched any possible 'UPLCTerm' constructor");
}
exports.hasAnyRefsInTerm = hasAnyRefsInTerm;
/**
 *
 * @param {number | bigint} varDeBruijn ```number | bigint```; debruijn level (at the term level) of the variable to search for
 * @param {UPLCTerm} term ```UPLCTerm``` to search in
 * @returns {boolean} ```true``` if the variable has 2 or more references; ```false``` otherwise
 */
function hasMultipleRefsInTerm(varDeBruijn, t) {
    (0, assert_1.assert)(isUPLCTerm(t), "'getUPLCVarRefsInTerm' expects an UPLCTerms");
    var dbn = BigInt(varDeBruijn);
    if (t instanceof UPLCVar_1.UPLCVar)
        return false; // single ref; case of multple refs is handled in 'Application' using 'hasAnyRefsInTerm'
    if (t instanceof Delay_1.Delay)
        return hasMultipleRefsInTerm(dbn, t.delayedTerm);
    if (t instanceof Lambda_1.Lambda)
        return hasMultipleRefsInTerm(dbn + BigInt(1), t.body);
    if (t instanceof Application_1.Application)
        return ((hasAnyRefsInTerm(dbn, t.funcTerm) && hasAnyRefsInTerm(dbn, t.argTerm)) || // referenced at least once in both terms
            hasMultipleRefsInTerm(dbn, t.funcTerm) || // referenced multiple times in func 
            hasMultipleRefsInTerm(dbn, t.argTerm) // referenced multiple times in arg
        );
    if (t instanceof UPLCConst_1.UPLCConst)
        return false;
    if (t instanceof Force_1.Force)
        return hasMultipleRefsInTerm(dbn, t.termToForce);
    if (t instanceof ErrorUPLC_1.ErrorUPLC)
        return false;
    if (t instanceof Builtin_1.Builtin)
        return false;
    if (t instanceof Constr_1.Constr)
        return termArrayHasManyRefs(dbn, t.terms);
    if (t instanceof Case_1.Case) {
        return ((hasAnyRefsInTerm(dbn, t.constrTerm) &&
            t.continuations.some(function (term) { return hasAnyRefsInTerm(dbn, term); })) ||
            hasMultipleRefsInTerm(dbn, t.constrTerm) ||
            termArrayHasManyRefs(dbn, t.continuations));
    }
    throw new Error("getUPLCVarRefsInTerm did not matched any possible 'UPLCTerm' constructor");
}
exports.hasMultipleRefsInTerm = hasMultipleRefsInTerm;
function termArrayHasManyRefs(dbn, terms) {
    var idx = terms.findIndex(function (term) { return hasAnyRefsInTerm(dbn, term); });
    if (idx < 0)
        return false; // no refs at all;
    return (terms.slice(idx + 1).some(function (term) { return hasAnyRefsInTerm(dbn, term); }) ||
        terms.some(function (term) { return hasMultipleRefsInTerm(dbn, term); }));
}
/**
 *
 * @param {number | bigint} varDeBruijn ```number | bigint```; debruijn level (at the term level) of the variable to search for
 * @param {UPLCTerm} term ```UPLCTerm``` to search in
 * @returns {number} number of references to the variable
 */
function getUPLCVarRefsInTerm(term, varDeBruijn) {
    if (varDeBruijn === void 0) { varDeBruijn = 0; }
    return _getUPLCVarRefsInTerm(BigInt(varDeBruijn), term, 0);
}
exports.getUPLCVarRefsInTerm = getUPLCVarRefsInTerm;
function _getUPLCVarRefsInTerm(dbn, t, countedUntilNow) {
    (0, assert_1.assert)(isUPLCTerm(t), "'getUPLCVarRefsInTerm' expects an UPLCTerms");
    if (t instanceof UPLCVar_1.UPLCVar)
        return countedUntilNow + (t.deBruijn === dbn ? 1 : 0);
    if (t instanceof Delay_1.Delay)
        return _getUPLCVarRefsInTerm(dbn, t.delayedTerm, countedUntilNow);
    if (t instanceof Lambda_1.Lambda)
        return _getUPLCVarRefsInTerm(dbn + BigInt(1), t.body, countedUntilNow);
    if (t instanceof Application_1.Application)
        return _getUPLCVarRefsInTerm(dbn, t.funcTerm, countedUntilNow) + _getUPLCVarRefsInTerm(dbn, t.argTerm, countedUntilNow);
    if (t instanceof UPLCConst_1.UPLCConst)
        return countedUntilNow;
    if (t instanceof Force_1.Force)
        return _getUPLCVarRefsInTerm(dbn, t.termToForce, countedUntilNow);
    if (t instanceof ErrorUPLC_1.ErrorUPLC)
        return countedUntilNow;
    if (t instanceof Builtin_1.Builtin)
        return countedUntilNow;
    if (t instanceof Constr_1.Constr)
        return t.terms.reduce(function (tot, term) { return _getUPLCVarRefsInTerm(dbn, term, tot); }, countedUntilNow);
    if (t instanceof Case_1.Case)
        return t.continuations.reduce(function (tot, term) { return _getUPLCVarRefsInTerm(dbn, term, tot); }, _getUPLCVarRefsInTerm(dbn, t.constrTerm, countedUntilNow));
    throw new Error("getUPLCVarRefsInTerm did not matched any possible 'UPLCTerm' constructor");
}
// type UPLCTerm = UPLCVar | Delay | Lambda | Application | UPLCConst | Force | ErrorUPLC | Builtin | Constr | Case;
function eqUPLCTerm(a, b) {
    if (a instanceof ErrorUPLC_1.ErrorUPLC)
        return b instanceof ErrorUPLC_1.ErrorUPLC;
    if (a instanceof UPLCVar_1.UPLCVar && b instanceof UPLCVar_1.UPLCVar)
        return a.deBruijn === b.deBruijn;
    if (a instanceof Delay_1.Delay && b instanceof Delay_1.Delay)
        return eqUPLCTerm(a.delayedTerm, b.delayedTerm);
    if (a instanceof Lambda_1.Lambda && b instanceof Lambda_1.Lambda)
        return eqUPLCTerm(a.body, b.body);
    if (a instanceof Application_1.Application && b instanceof Application_1.Application)
        return (eqUPLCTerm(a.argTerm, b.argTerm) &&
            eqUPLCTerm(a.funcTerm, b.funcTerm));
    if (a instanceof UPLCConst_1.UPLCConst && b instanceof UPLCConst_1.UPLCConst)
        return ((0, ConstType_1.constTypeEq)(a.type, b.type) &&
            (0, ConstValue_1.canConstValueBeOfConstType)(a.value, a.type) &&
            (0, ConstValue_1.canConstValueBeOfConstType)(b.value, b.type) &&
            (function () {
                try {
                    return (0, ConstValue_1.eqConstValue)(a.value, b.value);
                }
                catch (e) {
                    if (e instanceof RangeError)
                        return false;
                    throw e;
                }
            })());
    if (a instanceof Force_1.Force && b instanceof Force_1.Force)
        return eqUPLCTerm(a.termToForce, b.termToForce);
    if (a instanceof Builtin_1.Builtin && b instanceof Builtin_1.Builtin)
        return a.tag === b.tag;
    if (a instanceof Constr_1.Constr && b instanceof Constr_1.Constr)
        return (a.index === b.index &&
            a.terms.length === b.terms.length &&
            a.terms.every(function (t, i) { return eqUPLCTerm(t, b.terms[i]); }));
    if (a instanceof Case_1.Case && b instanceof Case_1.Case)
        return (eqUPLCTerm(a.constrTerm, b.constrTerm) &&
            a.continuations.length === b.continuations.length &&
            a.continuations.every(function (t, i) { return eqUPLCTerm(t, b.continuations[i]); }));
    return false;
}
exports.eqUPLCTerm = eqUPLCTerm;


/***/ }),

/***/ 73450:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UPLCTermTag = void 0;
var UPLCTermTag;
(function (UPLCTermTag) {
    UPLCTermTag[UPLCTermTag["Var"] = 0] = "Var";
    UPLCTermTag[UPLCTermTag["Delay"] = 1] = "Delay";
    UPLCTermTag[UPLCTermTag["Lambda"] = 2] = "Lambda";
    UPLCTermTag[UPLCTermTag["Application"] = 3] = "Application";
    UPLCTermTag[UPLCTermTag["Const"] = 4] = "Const";
    UPLCTermTag[UPLCTermTag["Force"] = 5] = "Force";
    UPLCTermTag[UPLCTermTag["Error"] = 6] = "Error";
    UPLCTermTag[UPLCTermTag["Builtin"] = 7] = "Builtin";
    UPLCTermTag[UPLCTermTag["Constr"] = 8] = "Constr";
    UPLCTermTag[UPLCTermTag["Case"] = 9] = "Case";
})(UPLCTermTag = exports.UPLCTermTag || (exports.UPLCTermTag = {}));
Object.freeze(UPLCTermTag);


/***/ }),

/***/ 57784:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(14740), exports);
__exportStar(__webpack_require__(72209), exports);


/***/ }),

/***/ 72209:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getOffsetToNextClosingBracket = exports.parseUPLCText = exports.parseConstType = exports.parseConstValueOfType = exports._parseUPLCText = void 0;
var bytestring_1 = __webpack_require__(86152);
var UPLCTerms_1 = __webpack_require__(39068);
var plutus_data_1 = __webpack_require__(34635);
var pair_1 = __webpack_require__(53307);
var crypto_1 = __webpack_require__(15251);
var uint8array_utils_1 = __webpack_require__(44948);
var indexOfNextCommaOutsideParentesis_1 = __webpack_require__(64990);
var indexOfNextUnmatchedParentesis_1 = __webpack_require__(74486);
var getTextBetweenMatchingQuotes_1 = __webpack_require__(12776);
var indexOfMany_1 = __webpack_require__(89815);
var UPLCProgram_1 = __webpack_require__(48017);
function _parseUPLCText(str, env, dbn, version) {
    // clone (other branches migh modify vars dbns)
    env = __assign({}, env);
    var offset = 0;
    var sliceTrimIncr = function (n) {
        if (n === void 0) { n = 0; }
        var tmp = str.length;
        str = str.slice(n).trimStart();
        offset += tmp - str.length;
    };
    var throwIllFormed = function () {
        // console.error( str );
        throw new Error("ill formed uplc text");
    };
    var getNextWord = function (s) {
        if (s === void 0) { s = str; }
        var fstSpaceIdx = s.search(/\s/);
        if (fstSpaceIdx < 0)
            fstSpaceIdx = str.length - 1;
        var varName = s.slice(0, fstSpaceIdx).trim();
        while (varName.endsWith(")") ||
            varName.endsWith("]") ||
            varName.endsWith(" ") ||
            varName.endsWith("\n")) {
            varName = varName.slice(0, varName.length - 1);
        }
        return varName;
    };
    sliceTrimIncr(0);
    var ch = str[0];
    // drop the opening bracket;
    if (ch === "[") {
        sliceTrimIncr(1);
        offset += getOffsetToNextClosingBracket(str, "[", "]");
        var fn = _parseUPLCText(str, env, dbn, version);
        str = str.slice(fn.offset + 1);
        var arg = _parseUPLCText(str, env, dbn, version);
        return {
            term: new UPLCTerms_1.Application(fn.term, arg.term),
            offset: offset
        };
    }
    if (ch === "(") {
        sliceTrimIncr(1);
        if (str.startsWith("error")) {
            offset += getOffsetToNextClosingBracket(str, "(", ")");
            return {
                term: new UPLCTerms_1.ErrorUPLC(),
                offset: offset
            };
        }
        if (str.startsWith("delay")) {
            offset += getOffsetToNextClosingBracket(str, "(", ")");
            return {
                term: new UPLCTerms_1.Delay(_parseUPLCText(str.slice(5), env, dbn, version).term),
                offset: offset
            };
        }
        if (str.startsWith("force")) {
            offset += getOffsetToNextClosingBracket(str, "(", ")");
            var directChild = _parseUPLCText(str.slice(5), env, dbn, version).term;
            if (directChild instanceof UPLCTerms_1.Builtin &&
                (0, UPLCTerms_1.getNRequiredForces)(directChild.tag) === 1)
                return {
                    term: directChild,
                    offset: offset
                };
            if (directChild instanceof UPLCTerms_1.Force &&
                directChild.termToForce instanceof UPLCTerms_1.Builtin &&
                (0, UPLCTerms_1.getNRequiredForces)(directChild.termToForce.tag) === 2)
                return {
                    term: directChild.termToForce,
                    offset: offset
                };
            return {
                term: new UPLCTerms_1.Force(directChild),
                offset: offset
            };
        }
        if (str.startsWith("builtin")) {
            offset += getOffsetToNextClosingBracket(str, "(", ")");
            str = str.slice(7).trimStart();
            return {
                term: new UPLCTerms_1.Builtin((0, UPLCTerms_1.builtinTagFromString)(getNextWord())),
                offset: offset
            };
        }
        if (str.startsWith("lam")) {
            offset += getOffsetToNextClosingBracket(str, "(", ")");
            str = str.slice(3).trimStart();
            var varName_1 = getNextWord();
            str = str.slice(varName_1.length).trimStart();
            env[varName_1] = dbn;
            return {
                term: new UPLCTerms_1.Lambda(_parseUPLCText(str, env, dbn + 1, version).term),
                offset: offset
            };
        }
        if (str.startsWith("case")) {
            if (!version.isV3Friendly())
                throw new Error("case uplc node found on program version: " + version.toString());
            sliceTrimIncr(4);
            var closeIdx = (0, indexOfNextUnmatchedParentesis_1.indexOfNextUnmatchedParentesis)(str);
            str = str.slice(0, closeIdx).trim();
            var terms = [];
            while (str.length > 0) {
                var _a = _parseUPLCText(str, env, dbn, version), term = _a.term, offset_1 = _a.offset;
                terms.push(term);
                str = str.slice(offset_1).trim();
            }
            if (terms.length < 1)
                throw new Error("ill formed uplc, missing constr term on case");
            return {
                term: new UPLCTerms_1.Case(terms.shift(), terms),
                offset: offset + closeIdx + 1
            };
        }
        // "constr" MUST BE before "con"
        if (str.startsWith("constr")) {
            if (!version.isV3Friendly())
                throw new Error("case uplc node found on program version: " + version.toString());
            sliceTrimIncr(6);
            var closeIdx = (0, indexOfNextUnmatchedParentesis_1.indexOfNextUnmatchedParentesis)(str);
            str = str.slice(0, closeIdx);
            var _b = parseConstValueOfType(str, UPLCTerms_1.constT.int), idx = _b.value, idxOffset = _b.offset;
            str = str.slice(idxOffset);
            if (typeof idx !== "bigint")
                throw new Error("ill formed uplc; constr expects u64 index");
            var terms = [];
            str = str.trim();
            while (str.length > 0) {
                var _c = _parseUPLCText(str, env, dbn, version), term = _c.term, offset_2 = _c.offset;
                terms.push(term);
                str = str.slice(offset_2).trim();
            }
            return {
                term: new UPLCTerms_1.Constr(idx, terms),
                offset: offset + closeIdx + 1
            };
        }
        if (str.startsWith("con")) {
            offset += getOffsetToNextClosingBracket(str, "(", ")");
            str = str.slice(3).trimStart();
            var t = parseConstType(str);
            str = str.slice(t.offset).trimStart();
            var v = parseConstValueOfType(str, t.type);
            str = str.slice(v.offset).trimStart();
            return {
                term: new UPLCTerms_1.UPLCConst(t.type, v.value),
                offset: offset
            };
        }
    }
    // else var
    offset--;
    var varName = getNextWord();
    offset += varName.length;
    if (varName.startsWith("-")) { // out of bound var
        return {
            term: new UPLCTerms_1.UPLCVar(dbn + parseInt(varName.slice(1)) - 1),
            offset: offset
        };
    }
    var varDbn = env[varName];
    if (varDbn === undefined) {
        // console.log( env, `"${varName}"`, Object.keys( env )[0] === varName )
        // throwIllFormed();
        throw new Error("unbound variable found");
    }
    return {
        term: new UPLCTerms_1.UPLCVar(dbn - 1 - varDbn),
        offset: offset
    };
}
exports._parseUPLCText = _parseUPLCText;
var hexChars = Array.from("0123456789abcdef");
function isHexChar(ch) {
    return hexChars.includes(ch[0].toLowerCase());
}
function isLowestNonNegative(a, b) {
    return a >= 0 && (b < 0 || a < b);
}
function parseConstValueOfType(str, t) {
    var offset = 0;
    var sliceTrimIncr = function (n) {
        if (n === void 0) { n = 0; }
        var tmp = str.length;
        str = str.slice(n).trimStart();
        offset += tmp - str.length;
    };
    sliceTrimIncr(0);
    if ((0, UPLCTerms_1.constTypeEq)(t, UPLCTerms_1.constT.unit)) {
        sliceTrimIncr(str.indexOf("()") + 2);
        return {
            value: undefined,
            offset: offset
        };
    }
    if ((0, UPLCTerms_1.constTypeEq)(t, UPLCTerms_1.constT.int)) {
        var closeIndex = str.indexOf(")");
        var regExpRes = str
            .slice(0, closeIndex < 0 ? undefined : closeIndex)
            // \+?\-?           -> may or may nost start with "+" or "-"
            // (?<!\.)          -> MUST NOT have dots before
            // (?<!(#|x)\d*)    -> MUST NOT have before "#" or "x" with 0 or more digits (escluded bls elements and bytestrings)
            // \d+              -> one or more digits
            // (?!(\.|x))       -> MUST NOT have dots after or "x" (x excludes "0x" which are bls elems)
            .match(/\+?\-?(?<!\.)(?<!(#|x)\d*)\d+(?!(\.|x))/);
        if (regExpRes === null)
            throw new Error("could not find integer for constant uplc");
        var nStr = regExpRes[0];
        var value = BigInt(nStr);
        sliceTrimIncr(str.indexOf(nStr) + nStr.length);
        return {
            value: value,
            offset: offset
        };
    }
    if ((0, UPLCTerms_1.constTypeEq)(t, UPLCTerms_1.constT.str)) {
        var quoteIdx = str.indexOf('"');
        if (!/^\s*$/.test(str.slice(0, quoteIdx)))
            throw new Error("ill formed uplc");
        sliceTrimIncr(quoteIdx);
        var value = (0, getTextBetweenMatchingQuotes_1.getTextBetweenMatchingQuotes)(str);
        if (typeof value !== "string")
            throw new Error("missing constant string value");
        sliceTrimIncr(value.length + 2);
        return {
            value: value,
            offset: offset
        };
    }
    if ((0, UPLCTerms_1.constTypeEq)(t, UPLCTerms_1.constT.bool)) {
        var trueIdx = str.indexOf("True");
        var falseIdx = str.indexOf("False");
        if (trueIdx < 0 && falseIdx < 0)
            throw new Error("expected boolean value; found none");
        var isTrue = isLowestNonNegative(trueIdx, falseIdx);
        if (isTrue) {
            sliceTrimIncr(trueIdx + 4);
            return {
                value: true,
                offset: offset
            };
        }
        else {
            sliceTrimIncr(falseIdx + 5);
            return {
                value: false,
                offset: offset
            };
        }
    }
    if ((0, UPLCTerms_1.constTypeEq)(t, UPLCTerms_1.constT.byteStr)) {
        sliceTrimIncr(str.indexOf("#") + 1);
        var i = 0;
        while (i < str.length && isHexChar(str[i++]))
            ;
        !isHexChar(str[i - 1]) && i--;
        var hex = str.slice(0, i);
        // we can handle it but plutus conformance doesn't allow it
        if (hex.length % 2 === 1) {
            throw new Error("invalid bytestring value: received: " + hex);
        }
        sliceTrimIncr(i);
        return {
            value: new bytestring_1.ByteString(hex),
            offset: offset
        };
    }
    if ((0, UPLCTerms_1.constTypeEq)(t, UPLCTerms_1.constT.data)) {
        sliceTrimIncr(0);
        var _a = (0, plutus_data_1.dataFromStringWithOffset)(str), data = _a.data, dataOffset = _a.offset;
        offset += dataOffset;
        return {
            value: data,
            offset: offset
        };
    }
    if ((0, UPLCTerms_1.constTypeEq)(t, UPLCTerms_1.constT.bls12_381_G1_element)) {
        var original = str;
        str = str.slice(0, str.indexOf(")") + 1).trimStart();
        offset += (original.length - original.indexOf(str)) + 2 /*0x*/ + 96;
        var match = str.match(/^0x[0-9a-fA-F]{96}(?![0-9a-fA-F]+)/); // 48 bytes; 96 hex chars
        if (!match)
            throw new Error("missing bls g1 compressed elem");
        var value = (0, crypto_1.bls12_381_G1_uncompress)((0, uint8array_utils_1.fromHex)(match[0].slice(2)));
        return { value: value, offset: offset };
    }
    if ((0, UPLCTerms_1.constTypeEq)(t, UPLCTerms_1.constT.bls12_381_G2_element)) {
        var original = str;
        str = str.slice(0, str.indexOf(")") + 1).trimStart();
        offset += (original.length - original.indexOf(str)) + 2 /*0x*/ + 192;
        var match = str.match(/^0x[0-9a-fA-F]{192}(?![0-9a-fA-F]+)/); // 96 bytes; 192 hex chars
        if (!match)
            throw new Error("missing bls g2 compressed elem");
        var value = (0, crypto_1.bls12_381_G2_uncompress)((0, uint8array_utils_1.fromHex)(match[0].slice(2)));
        return { value: value, offset: offset };
    }
    if ((0, UPLCTerms_1.constTypeEq)(t, UPLCTerms_1.constT.bls12_381_MlResult)) {
        throw new Error("bls12_381_MlResult const type not supported");
    }
    if (t[0] === UPLCTerms_1.ConstTyTag.pair) {
        sliceTrimIncr(str.indexOf("(") + 1);
        var commaIdx = (0, indexOfNextCommaOutsideParentesis_1.indexOfNextCommaOutsideParentesis)(str);
        var fst = parseConstValueOfType(str.slice(0, commaIdx), UPLCTerms_1.constPairTypeUtils.getFirstTypeArgument(t));
        sliceTrimIncr(commaIdx + 1);
        var closeIdx = (0, indexOfNextUnmatchedParentesis_1.indexOfNextUnmatchedParentesis)(str);
        var snd = parseConstValueOfType(str.slice(0, closeIdx), UPLCTerms_1.constPairTypeUtils.getSecondTypeArgument(t));
        sliceTrimIncr(closeIdx + 1);
        return {
            value: new pair_1.Pair(fst.value, snd.value),
            offset: offset
        };
    }
    if (t[0] === UPLCTerms_1.ConstTyTag.list) {
        sliceTrimIncr(str.indexOf("[") + 1);
        var elemsT = UPLCTerms_1.constListTypeUtils.getTypeArgument(t);
        var elems = [];
        while (!str.startsWith("]")) {
            var elem = parseConstValueOfType(str, elemsT);
            sliceTrimIncr(elem.offset);
            sliceTrimIncr(str.indexOf(",") + 1);
            elems.push(elem.value);
        }
        return {
            value: elems,
            offset: offset
        };
    }
    throw new Error("unknown const type");
}
exports.parseConstValueOfType = parseConstValueOfType;
function parseConstType(str) {
    var offset = 0;
    var sliceTrimIncr = function (n) {
        if (n === void 0) { n = 0; }
        var tmp = str.length;
        str = str.slice(n).trimStart();
        offset += tmp - str.length;
    };
    sliceTrimIncr(0);
    if (str.startsWith("integer")) {
        sliceTrimIncr(7);
        return {
            type: UPLCTerms_1.constT.int,
            offset: offset
        };
    }
    if (str.startsWith("bytestring")) {
        sliceTrimIncr(10);
        return {
            type: UPLCTerms_1.constT.byteStr,
            offset: offset
        };
    }
    if (str.startsWith("string")) {
        sliceTrimIncr(6);
        return {
            type: UPLCTerms_1.constT.str,
            offset: offset
        };
    }
    if (str.startsWith("unit")) {
        sliceTrimIncr(4);
        return {
            type: UPLCTerms_1.constT.unit,
            offset: offset
        };
    }
    if (str.startsWith("bool")) {
        if (str.startsWith("boolean"))
            sliceTrimIncr(7);
        else
            sliceTrimIncr(4);
        return {
            type: UPLCTerms_1.constT.bool,
            offset: offset
        };
    }
    if (str.startsWith("data")) {
        sliceTrimIncr(4);
        return {
            type: UPLCTerms_1.constT.data,
            offset: offset
        };
    }
    if (str.startsWith("bls12_381_G1_element")) {
        sliceTrimIncr("bls12_381_G1_element".length);
        return {
            type: UPLCTerms_1.constT.bls12_381_G1_element,
            offset: offset
        };
    }
    if (str.startsWith("bls12_381_G2_element")) {
        sliceTrimIncr("bls12_381_G2_element".length);
        return {
            type: UPLCTerms_1.constT.bls12_381_G2_element,
            offset: offset
        };
    }
    if (str.startsWith("bls12_381_MlResult"))
        throw new Error("bls12_381_MlResult const not supported in textual UPLC");
    if (str.startsWith("(")) {
        sliceTrimIncr(1);
        var listIdx = str.indexOf("list");
        var pairIdx = str.indexOf("pair");
        if (listIdx < 0 && pairIdx < 0)
            throw new Error("invalid constant type; expected list or pair");
        var isList = isLowestNonNegative(listIdx, pairIdx);
        var isPair = isLowestNonNegative(pairIdx, listIdx);
        if (isList) {
            sliceTrimIncr(listIdx + 4);
            var elems = parseConstType(str);
            sliceTrimIncr(elems.offset);
            while (!str.startsWith(")"))
                sliceTrimIncr(1);
            sliceTrimIncr(1);
            return {
                type: UPLCTerms_1.constT.listOf(elems.type),
                offset: offset
            };
        }
        else if (isPair) {
            sliceTrimIncr(pairIdx + 4);
            var fst = parseConstType(str);
            sliceTrimIncr(fst.offset);
            while (str.startsWith(" ") ||
                str.startsWith("\n"))
                sliceTrimIncr(1);
            var snd = parseConstType(str);
            sliceTrimIncr(snd.offset);
            while (!str.startsWith(")"))
                sliceTrimIncr(1);
            sliceTrimIncr(1);
            return {
                type: UPLCTerms_1.constT.pairOf(fst.type, snd.type),
                offset: offset
            };
        }
        else {
            console.log(str, listIdx, pairIdx);
            throw new Error("invalid constant type; missing list or pair");
        }
    }
    throw new Error("unknown UPLC const type; src: " + str);
}
exports.parseConstType = parseConstType;
function parseUPLCText(str, version) {
    if (version === void 0) { version = UPLCProgram_1.defaultUplcVersion; }
    str = str.trim();
    if (str.startsWith("(program")) {
        str = str.slice(8, str.lastIndexOf(")")).trim();
        var verStr = str.match(/^\d+\.\d+\.\d+(?!\.)/);
        if (!verStr)
            throw new Error("uplc program without version");
        version = UPLCProgram_1.UPLCVersion.fromString(verStr[0]);
        str = str.slice((0, indexOfMany_1.indexOfMany)(str, "(", "["));
    }
    version = version instanceof UPLCProgram_1.UPLCVersion ? version : UPLCProgram_1.defaultUplcVersion;
    return _parseUPLCText(str, {}, 0, version).term;
}
exports.parseUPLCText = parseUPLCText;
/**
 *
 * @param {string} str string removed of the first opening bracket
 * @example
 * ```ts
 * const str = "( hello )";
 * const expectedInput = str.slice(1); // " hello )";
 * const offset = getOffsetToNextClosingBracket( expectedInput ); // 8
 * ```
 * @returns
 */
function getOffsetToNextClosingBracket(str, openCh, closeCh) {
    if (openCh === void 0) { openCh = "("; }
    if (closeCh === void 0) { closeCh = ")"; }
    var nBrackets = 1;
    var offset = 0;
    var ch = '';
    while (nBrackets > 0) {
        ch = str[offset++];
        if (ch === openCh) {
            nBrackets++;
            continue;
        }
        if (ch === closeCh) {
            nBrackets--;
            continue;
        }
    }
    return offset;
}
exports.getOffsetToNextClosingBracket = getOffsetToNextClosingBracket;
// we have `dataFromString` from "@harmoniclabs/plutus-data"
// but no way to reliably retreive the offset
// seo
function myDataFromStringWithOffset(str) {
    var original = str;
    var openIdx = str.indexOf("(");
    if (openIdx < 0)
        throw new Error("missign opening wrapping parentesis for data");
    str = str.slice(openIdx + 1);
    var offset = original.length - str.length;
    var closeIdx = (0, indexOfNextUnmatchedParentesis_1.indexOfNextUnmatchedParentesis)(str);
    if (closeIdx < 0)
        throw new Error("missign closing wrapping parentesis for data");
    offset += closeIdx + 1;
    return {
        data: (0, plutus_data_1.dataFromString)(str.slice(0, closeIdx).trim()),
        offset: offset
    };
}


/***/ }),

/***/ 80271:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Application = exports.isUPLCApplicationBody = void 0;
var UPLCVar_1 = __webpack_require__(79369);
var Lambda_1 = __webpack_require__(51644);
var Builtin_1 = __webpack_require__(69537);
var Force_1 = __webpack_require__(66064);
var bitstream_1 = __webpack_require__(85840);
function isUPLCApplicationBody(uplc) {
    var proto = Object.getPrototypeOf(uplc);
    // only strict instances
    return (proto === UPLCVar_1.UPLCVar.prototype ||
        proto === Lambda_1.Lambda.prototype ||
        proto === Application.prototype ||
        proto === Force_1.Force.prototype ||
        proto === Builtin_1.Builtin.prototype);
}
exports.isUPLCApplicationBody = isUPLCApplicationBody;
var Application = /** @class */ (function () {
    function Application(func, arg) {
        this.funcTerm = func;
        this.argTerm = arg;
    }
    Object.defineProperty(Application, "UPLCTag", {
        get: function () {
            return bitstream_1.BitStream.fromBinStr("0011");
        },
        enumerable: false,
        configurable: true
    });
    Application.prototype.clone = function () {
        return new Application(this.funcTerm.clone(), this.argTerm.clone());
    };
    return Application;
}());
exports.Application = Application;


/***/ }),

/***/ 69537:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Builtin = void 0;
/**
 * # 5 Built in types, functions, and values
 *
 * Plutus Core comes with a predefined set of built-in types and functions which will be useful
 * for blockchain applications.
 *
 * The set of built-ins is fixed, although in future we may provide a
 * framework to allow customisation for specialised blockchains.
 *
 * There are four basic types: unit, bool, integer, and bytestring (and strings only for debugging purposes)
 *
 * These types are given in Figure 13:
 *
 * for example (con integer) is the type of signed integers.
 *
 * We provide standard arithmetic and comparison operations for integers and a number of list-like functions for bytestrings.
 *
 * The details are given in Figure 14, using a number of abbreviations given in Figure 12.
 *
 * Note the following:
 *
 *  •   Some of the entries in Figure 14 contain success conditions. If a success condition is violated
 *      then the function immediately returns (error).
 *
 *  •   Every built-in function returns either a value or the term (error).
 *
 *  •   The ifThenElse operation is polymorphic and must be instantiated with the type of its
 *      branches before being applied: see the example below.
 *
 *  •   We provide two versions of the division and remainder operations for integers. These differ
 *      in their treatment of negative arguments.
 */
var bitstream_1 = __webpack_require__(85840);
var UPLCBuiltinTag_1 = __webpack_require__(31110);
var assert_1 = __webpack_require__(63952);
var Builtin = /** @class */ (function () {
    function Builtin(tag) {
        (0, assert_1.assert)((0, UPLCBuiltinTag_1.isUPLCBuiltinTag)(tag), "cannot instatinitate a 'Builtin' using tag: " + tag.toString());
        this._tag = tag;
    }
    Object.defineProperty(Builtin, "UPLCTag", {
        get: function () {
            return bitstream_1.BitStream.fromBinStr("0111");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin.prototype, "tag", {
        get: function () {
            return this._tag;
        },
        enumerable: false,
        configurable: true
    });
    Builtin.prototype.clone = function () {
        return new Builtin(this.tag);
    };
    Object.defineProperty(Builtin, "addInteger", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.addInteger); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "subtractInteger", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.subtractInteger); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "multiplyInteger", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.multiplyInteger); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "divideInteger", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.divideInteger); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "quotientInteger", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.quotientInteger); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "remainderInteger", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.remainderInteger); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "modInteger", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.modInteger); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "equalsInteger", {
        // integers comparison operaitons
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.equalsInteger); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "lessThanInteger", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.lessThanInteger); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "lessThanEqualInteger", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.lessThanEqualInteger); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "appendByteString", {
        // bytestring operations
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.appendByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "consByteString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.consByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "sliceByteString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.sliceByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "lengthOfByteString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.lengthOfByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "indexByteString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.indexByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "equalsByteString", {
        // bytestring comparison operations
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.equalsByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "lessThanByteString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.lessThanByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "lessThanEqualsByteString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.lessThanEqualsByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "sha2_256", {
        // hashes
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.sha2_256); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "sha3_256", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.sha3_256); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "blake2b_256", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.blake2b_256); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "verifyEd25519Signature", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.verifyEd25519Signature); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "appendString", {
        // string operations
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.appendString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "equalsString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.equalsString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "encodeUtf8", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.encodeUtf8); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "decodeUtf8", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.decodeUtf8); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "ifThenElse", {
        // control flow
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.ifThenElse); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "chooseUnit", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.chooseUnit); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "trace", {
        // tracing
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.trace); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "fstPair", {
        // data
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.fstPair); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "sndPair", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.sndPair); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "chooseList", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.chooseList); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "mkCons", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.mkCons); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "headList", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.headList); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "tailList", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.tailList); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "nullList", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.nullList); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "chooseData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.chooseData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "constrData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.constrData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "mapData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.mapData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "listData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.listData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "iData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.iData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "unConstrData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.unConstrData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "unMapData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.unMapData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "unListData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.unListData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "unIData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.unIData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "unBData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.unBData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "equalsData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.equalsData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "mkPairData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.mkPairData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "mkNilData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.mkNilData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "mkNilPairData", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.mkNilPairData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "serialiseData", {
        // Vasil (Plutus V2: Builtin)
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.serialiseData); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "verifyEcdsaSecp256k1Signature", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.verifyEcdsaSecp256k1Signature); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "verifySchnorrSecp256k1Signature", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.verifySchnorrSecp256k1Signature); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G1_add", {
        // PlutusV3
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G1_add); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G1_neg", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G1_neg); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G1_scalarMul", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G1_scalarMul); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G1_equal", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G1_equal); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G1_hashToGroup", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G1_hashToGroup); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G1_compress", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G1_compress); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G1_uncompress", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G1_uncompress); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G2_add", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G2_add); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G2_neg", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G2_neg); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G2_scalarMul", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G2_scalarMul); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G2_equal", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G2_equal); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G2_hashToGroup", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G2_hashToGroup); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G2_compress", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G2_compress); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_G2_uncompress", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_G2_uncompress); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_millerLoop", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_millerLoop); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_mulMlResult", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_mulMlResult); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "bls12_381_finalVerify", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.bls12_381_finalVerify); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "keccak_256", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.keccak_256); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "blake2b_224", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.blake2b_224); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "integerToByteString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.integerToByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "byteStringToInteger", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.byteStringToInteger); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "andByteString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.andByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "orByteString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.orByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "xorByteString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.xorByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "complementByteString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.complementByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "readBit", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.readBit); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "writeBits", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.writeBits); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "replicateByte", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.replicateByte); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "shiftByteString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.shiftByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "rotateByteString", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.rotateByteString); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "countSetBits", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.countSetBits); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "findFirstSetBit", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.findFirstSetBit); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builtin, "ripemd_160", {
        get: function () { return new Builtin(UPLCBuiltinTag_1.UPLCBuiltinTag.ripemd_160); },
        enumerable: false,
        configurable: true
    });
    return Builtin;
}());
exports.Builtin = Builtin;


/***/ }),

/***/ 31110:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.builtinTagFromString = exports.builtinTagToString = exports.isV2Supported = exports.isV1Supported = exports.getNRequiredForces = exports.isUPLCBuiltinTag = exports.UPLCBuiltinTag = void 0;
var assert_1 = __webpack_require__(63952);
/**
 * to encode as 7-bits
 */
var UPLCBuiltinTag;
(function (UPLCBuiltinTag) {
    // integers monoidal operations
    UPLCBuiltinTag[UPLCBuiltinTag["addInteger"] = 0] = "addInteger";
    UPLCBuiltinTag[UPLCBuiltinTag["subtractInteger"] = 1] = "subtractInteger";
    UPLCBuiltinTag[UPLCBuiltinTag["multiplyInteger"] = 2] = "multiplyInteger";
    UPLCBuiltinTag[UPLCBuiltinTag["divideInteger"] = 3] = "divideInteger";
    UPLCBuiltinTag[UPLCBuiltinTag["quotientInteger"] = 4] = "quotientInteger";
    UPLCBuiltinTag[UPLCBuiltinTag["remainderInteger"] = 5] = "remainderInteger";
    UPLCBuiltinTag[UPLCBuiltinTag["modInteger"] = 6] = "modInteger";
    // integers comparison operaitons
    UPLCBuiltinTag[UPLCBuiltinTag["equalsInteger"] = 7] = "equalsInteger";
    UPLCBuiltinTag[UPLCBuiltinTag["lessThanInteger"] = 8] = "lessThanInteger";
    UPLCBuiltinTag[UPLCBuiltinTag["lessThanEqualInteger"] = 9] = "lessThanEqualInteger";
    // bytestring operations
    UPLCBuiltinTag[UPLCBuiltinTag["appendByteString"] = 10] = "appendByteString";
    UPLCBuiltinTag[UPLCBuiltinTag["consByteString"] = 11] = "consByteString";
    UPLCBuiltinTag[UPLCBuiltinTag["sliceByteString"] = 12] = "sliceByteString";
    UPLCBuiltinTag[UPLCBuiltinTag["lengthOfByteString"] = 13] = "lengthOfByteString";
    UPLCBuiltinTag[UPLCBuiltinTag["indexByteString"] = 14] = "indexByteString";
    // bytestring comparison operations
    UPLCBuiltinTag[UPLCBuiltinTag["equalsByteString"] = 15] = "equalsByteString";
    UPLCBuiltinTag[UPLCBuiltinTag["lessThanByteString"] = 16] = "lessThanByteString";
    UPLCBuiltinTag[UPLCBuiltinTag["lessThanEqualsByteString"] = 17] = "lessThanEqualsByteString";
    // hashes
    UPLCBuiltinTag[UPLCBuiltinTag["sha2_256"] = 18] = "sha2_256";
    UPLCBuiltinTag[UPLCBuiltinTag["sha3_256"] = 19] = "sha3_256";
    UPLCBuiltinTag[UPLCBuiltinTag["blake2b_256"] = 20] = "blake2b_256";
    UPLCBuiltinTag[UPLCBuiltinTag["verifyEd25519Signature"] = 21] = "verifyEd25519Signature";
    // string operations
    UPLCBuiltinTag[UPLCBuiltinTag["appendString"] = 22] = "appendString";
    UPLCBuiltinTag[UPLCBuiltinTag["equalsString"] = 23] = "equalsString";
    UPLCBuiltinTag[UPLCBuiltinTag["encodeUtf8"] = 24] = "encodeUtf8";
    UPLCBuiltinTag[UPLCBuiltinTag["decodeUtf8"] = 25] = "decodeUtf8";
    // control flow
    UPLCBuiltinTag[UPLCBuiltinTag["ifThenElse"] = 26] = "ifThenElse";
    UPLCBuiltinTag[UPLCBuiltinTag["chooseUnit"] = 27] = "chooseUnit";
    // tracing
    UPLCBuiltinTag[UPLCBuiltinTag["trace"] = 28] = "trace";
    // data
    UPLCBuiltinTag[UPLCBuiltinTag["fstPair"] = 29] = "fstPair";
    UPLCBuiltinTag[UPLCBuiltinTag["sndPair"] = 30] = "sndPair";
    UPLCBuiltinTag[UPLCBuiltinTag["chooseList"] = 31] = "chooseList";
    UPLCBuiltinTag[UPLCBuiltinTag["mkCons"] = 32] = "mkCons";
    UPLCBuiltinTag[UPLCBuiltinTag["headList"] = 33] = "headList";
    UPLCBuiltinTag[UPLCBuiltinTag["tailList"] = 34] = "tailList";
    UPLCBuiltinTag[UPLCBuiltinTag["nullList"] = 35] = "nullList";
    UPLCBuiltinTag[UPLCBuiltinTag["chooseData"] = 36] = "chooseData";
    UPLCBuiltinTag[UPLCBuiltinTag["constrData"] = 37] = "constrData";
    UPLCBuiltinTag[UPLCBuiltinTag["mapData"] = 38] = "mapData";
    UPLCBuiltinTag[UPLCBuiltinTag["listData"] = 39] = "listData";
    UPLCBuiltinTag[UPLCBuiltinTag["iData"] = 40] = "iData";
    UPLCBuiltinTag[UPLCBuiltinTag["bData"] = 41] = "bData";
    UPLCBuiltinTag[UPLCBuiltinTag["unConstrData"] = 42] = "unConstrData";
    UPLCBuiltinTag[UPLCBuiltinTag["unMapData"] = 43] = "unMapData";
    UPLCBuiltinTag[UPLCBuiltinTag["unListData"] = 44] = "unListData";
    UPLCBuiltinTag[UPLCBuiltinTag["unIData"] = 45] = "unIData";
    UPLCBuiltinTag[UPLCBuiltinTag["unBData"] = 46] = "unBData";
    UPLCBuiltinTag[UPLCBuiltinTag["equalsData"] = 47] = "equalsData";
    UPLCBuiltinTag[UPLCBuiltinTag["mkPairData"] = 48] = "mkPairData";
    UPLCBuiltinTag[UPLCBuiltinTag["mkNilData"] = 49] = "mkNilData";
    UPLCBuiltinTag[UPLCBuiltinTag["mkNilPairData"] = 50] = "mkNilPairData";
    // Vasil (Plutus V2)
    UPLCBuiltinTag[UPLCBuiltinTag["serialiseData"] = 51] = "serialiseData";
    UPLCBuiltinTag[UPLCBuiltinTag["verifyEcdsaSecp256k1Signature"] = 52] = "verifyEcdsaSecp256k1Signature";
    UPLCBuiltinTag[UPLCBuiltinTag["verifySchnorrSecp256k1Signature"] = 53] = "verifySchnorrSecp256k1Signature";
    // Plutus V3
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G1_add"] = 54] = "bls12_381_G1_add";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G1_neg"] = 55] = "bls12_381_G1_neg";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G1_scalarMul"] = 56] = "bls12_381_G1_scalarMul";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G1_equal"] = 57] = "bls12_381_G1_equal";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G1_hashToGroup"] = 58] = "bls12_381_G1_hashToGroup";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G1_compress"] = 59] = "bls12_381_G1_compress";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G1_uncompress"] = 60] = "bls12_381_G1_uncompress";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G2_add"] = 61] = "bls12_381_G2_add";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G2_neg"] = 62] = "bls12_381_G2_neg";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G2_scalarMul"] = 63] = "bls12_381_G2_scalarMul";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G2_equal"] = 64] = "bls12_381_G2_equal";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G2_hashToGroup"] = 65] = "bls12_381_G2_hashToGroup";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G2_compress"] = 66] = "bls12_381_G2_compress";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_G2_uncompress"] = 67] = "bls12_381_G2_uncompress";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_millerLoop"] = 68] = "bls12_381_millerLoop";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_mulMlResult"] = 69] = "bls12_381_mulMlResult";
    UPLCBuiltinTag[UPLCBuiltinTag["bls12_381_finalVerify"] = 70] = "bls12_381_finalVerify";
    UPLCBuiltinTag[UPLCBuiltinTag["keccak_256"] = 71] = "keccak_256";
    UPLCBuiltinTag[UPLCBuiltinTag["blake2b_224"] = 72] = "blake2b_224";
    // bitwise
    UPLCBuiltinTag[UPLCBuiltinTag["integerToByteString"] = 73] = "integerToByteString";
    UPLCBuiltinTag[UPLCBuiltinTag["byteStringToInteger"] = 74] = "byteStringToInteger";
    // plomin (batch 5)
    UPLCBuiltinTag[UPLCBuiltinTag["andByteString"] = 75] = "andByteString";
    UPLCBuiltinTag[UPLCBuiltinTag["orByteString"] = 76] = "orByteString";
    UPLCBuiltinTag[UPLCBuiltinTag["xorByteString"] = 77] = "xorByteString";
    UPLCBuiltinTag[UPLCBuiltinTag["complementByteString"] = 78] = "complementByteString";
    UPLCBuiltinTag[UPLCBuiltinTag["readBit"] = 79] = "readBit";
    UPLCBuiltinTag[UPLCBuiltinTag["writeBits"] = 80] = "writeBits";
    UPLCBuiltinTag[UPLCBuiltinTag["replicateByte"] = 81] = "replicateByte";
    UPLCBuiltinTag[UPLCBuiltinTag["shiftByteString"] = 82] = "shiftByteString";
    UPLCBuiltinTag[UPLCBuiltinTag["rotateByteString"] = 83] = "rotateByteString";
    UPLCBuiltinTag[UPLCBuiltinTag["countSetBits"] = 84] = "countSetBits";
    UPLCBuiltinTag[UPLCBuiltinTag["findFirstSetBit"] = 85] = "findFirstSetBit";
    UPLCBuiltinTag[UPLCBuiltinTag["ripemd_160"] = 86] = "ripemd_160";
})(UPLCBuiltinTag = exports.UPLCBuiltinTag || (exports.UPLCBuiltinTag = {}));
Object.freeze(UPLCBuiltinTag);
function isNonNegativeInt(n) {
    return (n >>> 0) === n;
}
var highestTag = Object.values(UPLCBuiltinTag)
    .reduce(function (max, tag) {
    return isNonNegativeInt(tag) ?
        (tag > max ? tag : max)
        : max;
}, 0);
function isUPLCBuiltinTag(tag) {
    return (isNonNegativeInt(tag) // tag is a non-negative integer
        &&
            tag <= highestTag);
}
exports.isUPLCBuiltinTag = isUPLCBuiltinTag;
function getNRequiredForces(tag) {
    (0, assert_1.assert)(isUPLCBuiltinTag(tag), "in getNRequiredForces; the function is specific for UPLCBuiltinTags; input was: ".concat(tag));
    // tags that do have one type parameter; 1 force
    if (tag === UPLCBuiltinTag.ifThenElse ||
        tag === UPLCBuiltinTag.chooseUnit ||
        tag === UPLCBuiltinTag.trace ||
        tag === UPLCBuiltinTag.mkCons ||
        tag === UPLCBuiltinTag.headList ||
        tag === UPLCBuiltinTag.tailList ||
        tag === UPLCBuiltinTag.nullList ||
        tag === UPLCBuiltinTag.chooseData) {
        return 1;
    }
    // tags that do have two types paramters; two forces
    if (tag === UPLCBuiltinTag.fstPair ||
        tag === UPLCBuiltinTag.sndPair ||
        tag === UPLCBuiltinTag.chooseList) {
        return 2;
    }
    // tags from 0 to 25 and from 37 to 53 are all fixed in type; no forces requred
    if (tag <= 25 ||
        // all fixed type after constrData 
        tag >= UPLCBuiltinTag.constrData) {
        return 0;
    }
    throw new Error("'getNRequiredForces' did not match any tag; the input was: " + tag);
}
exports.getNRequiredForces = getNRequiredForces;
function isV1Supported(tag) {
    return (isUPLCBuiltinTag(tag) &&
        tag <= 50);
}
exports.isV1Supported = isV1Supported;
function isV2Supported(tag) {
    return (isUPLCBuiltinTag(tag));
}
exports.isV2Supported = isV2Supported;
function builtinTagToString(tag) {
    switch (tag) {
        case UPLCBuiltinTag.addInteger: return "addInteger";
        case UPLCBuiltinTag.subtractInteger: return "subtractInteger";
        case UPLCBuiltinTag.multiplyInteger: return "multiplyInteger";
        case UPLCBuiltinTag.divideInteger: return "divideInteger";
        case UPLCBuiltinTag.quotientInteger: return "quotientInteger";
        case UPLCBuiltinTag.remainderInteger: return "remainderInteger";
        case UPLCBuiltinTag.modInteger: return "modInteger";
        case UPLCBuiltinTag.equalsInteger: return "equalsInteger";
        case UPLCBuiltinTag.lessThanInteger: return "lessThanInteger";
        case UPLCBuiltinTag.lessThanEqualInteger: return "lessThanEqualsInteger";
        case UPLCBuiltinTag.appendByteString: return "appendByteString";
        case UPLCBuiltinTag.consByteString: return "consByteString";
        case UPLCBuiltinTag.sliceByteString: return "sliceByteString";
        case UPLCBuiltinTag.lengthOfByteString: return "lengthOfByteString";
        case UPLCBuiltinTag.indexByteString: return "indexByteString";
        case UPLCBuiltinTag.equalsByteString: return "equalsByteString";
        case UPLCBuiltinTag.lessThanByteString: return "lessThanByteString";
        case UPLCBuiltinTag.lessThanEqualsByteString: return "lessThanEqualsByteString";
        case UPLCBuiltinTag.sha2_256: return "sha2_256";
        case UPLCBuiltinTag.sha3_256: return "sha3_256";
        case UPLCBuiltinTag.blake2b_256: return "blake2b_256";
        case UPLCBuiltinTag.verifyEd25519Signature: return "verifyEd25519Signature";
        case UPLCBuiltinTag.appendString: return "appendString";
        case UPLCBuiltinTag.equalsString: return "equalsString";
        case UPLCBuiltinTag.encodeUtf8: return "encodeUtf8";
        case UPLCBuiltinTag.decodeUtf8: return "decodeUtf8";
        case UPLCBuiltinTag.ifThenElse: return "ifThenElse";
        case UPLCBuiltinTag.chooseUnit: return "chooseUnit";
        case UPLCBuiltinTag.trace: return "trace";
        case UPLCBuiltinTag.fstPair: return "fstPair";
        case UPLCBuiltinTag.sndPair: return "sndPair";
        case UPLCBuiltinTag.chooseList: return "chooseList";
        case UPLCBuiltinTag.mkCons: return "mkCons";
        case UPLCBuiltinTag.headList: return "headList";
        case UPLCBuiltinTag.tailList: return "tailList";
        case UPLCBuiltinTag.nullList: return "nullList";
        case UPLCBuiltinTag.chooseData: return "chooseData";
        case UPLCBuiltinTag.constrData: return "constrData";
        case UPLCBuiltinTag.mapData: return "mapData";
        case UPLCBuiltinTag.listData: return "listData";
        case UPLCBuiltinTag.iData: return "iData";
        case UPLCBuiltinTag.bData: return "bData";
        case UPLCBuiltinTag.unConstrData: return "unConstrData";
        case UPLCBuiltinTag.unMapData: return "unMapData";
        case UPLCBuiltinTag.unListData: return "unListData";
        case UPLCBuiltinTag.unIData: return "unIData";
        case UPLCBuiltinTag.unBData: return "unBData";
        case UPLCBuiltinTag.equalsData: return "equalsData";
        case UPLCBuiltinTag.mkPairData: return "mkPairData";
        case UPLCBuiltinTag.mkNilData: return "mkNilData";
        case UPLCBuiltinTag.mkNilPairData: return "mkNilPairData";
        case UPLCBuiltinTag.serialiseData: return "serialiseData";
        case UPLCBuiltinTag.verifyEcdsaSecp256k1Signature: return "verifyEcdsaSecp256k1Signature";
        case UPLCBuiltinTag.verifySchnorrSecp256k1Signature: return "verifySchnorrSecp256k1Signature";
        case UPLCBuiltinTag.bls12_381_G1_add: return "bls12_381_G1_add";
        case UPLCBuiltinTag.bls12_381_G1_neg: return "bls12_381_G1_neg";
        case UPLCBuiltinTag.bls12_381_G1_scalarMul: return "bls12_381_G1_scalarMul";
        case UPLCBuiltinTag.bls12_381_G1_equal: return "bls12_381_G1_equal";
        case UPLCBuiltinTag.bls12_381_G1_hashToGroup: return "bls12_381_G1_hashToGroup";
        case UPLCBuiltinTag.bls12_381_G1_compress: return "bls12_381_G1_compress";
        case UPLCBuiltinTag.bls12_381_G1_uncompress: return "bls12_381_G1_uncompress";
        case UPLCBuiltinTag.bls12_381_G2_add: return "bls12_381_G2_add";
        case UPLCBuiltinTag.bls12_381_G2_neg: return "bls12_381_G2_neg";
        case UPLCBuiltinTag.bls12_381_G2_scalarMul: return "bls12_381_G2_scalarMul";
        case UPLCBuiltinTag.bls12_381_G2_equal: return "bls12_381_G2_equal";
        case UPLCBuiltinTag.bls12_381_G2_hashToGroup: return "bls12_381_G2_hashToGroup";
        case UPLCBuiltinTag.bls12_381_G2_compress: return "bls12_381_G2_compress";
        case UPLCBuiltinTag.bls12_381_G2_uncompress: return "bls12_381_G2_uncompress";
        case UPLCBuiltinTag.bls12_381_millerLoop: return "bls12_381_millerLoop";
        case UPLCBuiltinTag.bls12_381_mulMlResult: return "bls12_381_mulMlResult";
        case UPLCBuiltinTag.bls12_381_finalVerify: return "bls12_381_finalVerify";
        case UPLCBuiltinTag.keccak_256: return "keccak_256";
        case UPLCBuiltinTag.blake2b_224: return "blake2b_224";
        case UPLCBuiltinTag.integerToByteString: return "integerToByteString";
        case UPLCBuiltinTag.byteStringToInteger: return "byteStringToInteger";
        case UPLCBuiltinTag.andByteString: return "andByteString";
        case UPLCBuiltinTag.orByteString: return "orByteString";
        case UPLCBuiltinTag.xorByteString: return "xorByteString";
        case UPLCBuiltinTag.complementByteString: return "complementByteString";
        case UPLCBuiltinTag.readBit: return "readBit";
        case UPLCBuiltinTag.writeBits: return "writeBits";
        case UPLCBuiltinTag.replicateByte: return "replicateByte";
        case UPLCBuiltinTag.shiftByteString: return "shiftByteString";
        case UPLCBuiltinTag.rotateByteString: return "rotateByteString";
        case UPLCBuiltinTag.countSetBits: return "countSetBits";
        case UPLCBuiltinTag.findFirstSetBit: return "findFirstSetBit";
        case UPLCBuiltinTag.ripemd_160: return "ripemd_160";
        default:
            // tag; // check that is of type 'never'
            return "";
    }
}
exports.builtinTagToString = builtinTagToString;
function builtinTagFromString(tag) {
    switch (tag.trim()) {
        case "addInteger": return UPLCBuiltinTag.addInteger;
        case "subtractInteger": return UPLCBuiltinTag.subtractInteger;
        case "multiplyInteger": return UPLCBuiltinTag.multiplyInteger;
        case "divideInteger": return UPLCBuiltinTag.divideInteger;
        case "quotientInteger": return UPLCBuiltinTag.quotientInteger;
        case "remainderInteger": return UPLCBuiltinTag.remainderInteger;
        case "modInteger": return UPLCBuiltinTag.modInteger;
        case "equalsInteger": return UPLCBuiltinTag.equalsInteger;
        case "lessThanInteger": return UPLCBuiltinTag.lessThanInteger;
        case "lessThanEqualInteger": return UPLCBuiltinTag.lessThanEqualInteger;
        case "lessThanEqualsInteger": return UPLCBuiltinTag.lessThanEqualInteger;
        case "appendByteString": return UPLCBuiltinTag.appendByteString;
        case "consByteString": return UPLCBuiltinTag.consByteString;
        case "sliceByteString": return UPLCBuiltinTag.sliceByteString;
        case "lengthOfByteString": return UPLCBuiltinTag.lengthOfByteString;
        case "indexByteString": return UPLCBuiltinTag.indexByteString;
        case "equalsByteString": return UPLCBuiltinTag.equalsByteString;
        case "lessThanByteString": return UPLCBuiltinTag.lessThanByteString;
        case "lessThanEqualsByteString": return UPLCBuiltinTag.lessThanEqualsByteString;
        case "sha2_256": return UPLCBuiltinTag.sha2_256;
        case "sha3_256": return UPLCBuiltinTag.sha3_256;
        case "blake2b_256": return UPLCBuiltinTag.blake2b_256;
        case "verifyEd25519Signature": return UPLCBuiltinTag.verifyEd25519Signature;
        case "appendString": return UPLCBuiltinTag.appendString;
        case "equalsString": return UPLCBuiltinTag.equalsString;
        case "encodeUtf8": return UPLCBuiltinTag.encodeUtf8;
        case "decodeUtf8": return UPLCBuiltinTag.decodeUtf8;
        case "ifThenElse": return UPLCBuiltinTag.ifThenElse;
        case "chooseUnit": return UPLCBuiltinTag.chooseUnit;
        case "trace": return UPLCBuiltinTag.trace;
        case "fstPair": return UPLCBuiltinTag.fstPair;
        case "sndPair": return UPLCBuiltinTag.sndPair;
        case "chooseList": return UPLCBuiltinTag.chooseList;
        case "mkCons": return UPLCBuiltinTag.mkCons;
        case "headList": return UPLCBuiltinTag.headList;
        case "tailList": return UPLCBuiltinTag.tailList;
        case "nullList": return UPLCBuiltinTag.nullList;
        case "chooseData": return UPLCBuiltinTag.chooseData;
        case "constrData": return UPLCBuiltinTag.constrData;
        case "mapData": return UPLCBuiltinTag.mapData;
        case "listData": return UPLCBuiltinTag.listData;
        case "iData": return UPLCBuiltinTag.iData;
        case "bData": return UPLCBuiltinTag.bData;
        case "unConstrData": return UPLCBuiltinTag.unConstrData;
        case "unMapData": return UPLCBuiltinTag.unMapData;
        case "unListData": return UPLCBuiltinTag.unListData;
        case "unIData": return UPLCBuiltinTag.unIData;
        case "unBData": return UPLCBuiltinTag.unBData;
        case "equalsData": return UPLCBuiltinTag.equalsData;
        case "mkPairData": return UPLCBuiltinTag.mkPairData;
        case "mkNilData": return UPLCBuiltinTag.mkNilData;
        case "mkNilPairData": return UPLCBuiltinTag.mkNilPairData;
        case "serialiseData": return UPLCBuiltinTag.serialiseData;
        case "verifyEcdsaSecp256k1Signature": return UPLCBuiltinTag.verifyEcdsaSecp256k1Signature;
        case "verifySchnorrSecp256k1Signature": return UPLCBuiltinTag.verifySchnorrSecp256k1Signature;
        case "bls12_381_G1_add": return UPLCBuiltinTag.bls12_381_G1_add;
        case "bls12_381_G1_neg": return UPLCBuiltinTag.bls12_381_G1_neg;
        case "bls12_381_G1_scalarMul": return UPLCBuiltinTag.bls12_381_G1_scalarMul;
        case "bls12_381_G1_equal": return UPLCBuiltinTag.bls12_381_G1_equal;
        case "bls12_381_G1_hashToGroup": return UPLCBuiltinTag.bls12_381_G1_hashToGroup;
        case "bls12_381_G1_compress": return UPLCBuiltinTag.bls12_381_G1_compress;
        case "bls12_381_G1_uncompress": return UPLCBuiltinTag.bls12_381_G1_uncompress;
        case "bls12_381_G2_add": return UPLCBuiltinTag.bls12_381_G2_add;
        case "bls12_381_G2_neg": return UPLCBuiltinTag.bls12_381_G2_neg;
        case "bls12_381_G2_scalarMul": return UPLCBuiltinTag.bls12_381_G2_scalarMul;
        case "bls12_381_G2_equal": return UPLCBuiltinTag.bls12_381_G2_equal;
        case "bls12_381_G2_hashToGroup": return UPLCBuiltinTag.bls12_381_G2_hashToGroup;
        case "bls12_381_G2_compress": return UPLCBuiltinTag.bls12_381_G2_compress;
        case "bls12_381_G2_uncompress": return UPLCBuiltinTag.bls12_381_G2_uncompress;
        case "bls12_381_millerLoop": return UPLCBuiltinTag.bls12_381_millerLoop;
        case "bls12_381_mulMlResult": return UPLCBuiltinTag.bls12_381_mulMlResult;
        case "bls12_381_finalVerify": return UPLCBuiltinTag.bls12_381_finalVerify;
        case "keccak_256": return UPLCBuiltinTag.keccak_256;
        case "blake2b_224": return UPLCBuiltinTag.blake2b_224;
        case "integerToByteString": return UPLCBuiltinTag.integerToByteString;
        case "byteStringToInteger": return UPLCBuiltinTag.byteStringToInteger;
        case "andByteString": return UPLCBuiltinTag.andByteString;
        case "orByteString": return UPLCBuiltinTag.orByteString;
        case "xorByteString": return UPLCBuiltinTag.xorByteString;
        case "complementByteString": return UPLCBuiltinTag.complementByteString;
        case "readBit": return UPLCBuiltinTag.readBit;
        case "writeBits": return UPLCBuiltinTag.writeBits;
        case "replicateByte": return UPLCBuiltinTag.replicateByte;
        case "shiftByteString": return UPLCBuiltinTag.shiftByteString;
        case "rotateByteString": return UPLCBuiltinTag.rotateByteString;
        case "countSetBits": return UPLCBuiltinTag.countSetBits;
        case "findFirstSetBit": return UPLCBuiltinTag.findFirstSetBit;
        case "ripemd_160": return UPLCBuiltinTag.ripemd_160;
        default:
            // tag; // check that is of type 'never'
            throw new Error("unknow builtin: " + tag);
    }
}
exports.builtinTagFromString = builtinTagFromString;


/***/ }),

/***/ 54696:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(69537), exports);
__exportStar(__webpack_require__(31110), exports);


/***/ }),

/***/ 49629:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Case = void 0;
var bitstream_1 = __webpack_require__(85840);
var Case = /** @class */ (function () {
    function Case(constrTerm, continuations) {
        this.constrTerm = constrTerm;
        this.continuations = continuations;
    }
    Object.defineProperty(Case, "UPLCTag", {
        get: function () {
            return bitstream_1.BitStream.fromBinStr("1001");
        },
        enumerable: false,
        configurable: true
    });
    Case.prototype.clone = function () {
        return new Case(this.constrTerm.clone(), this.continuations.map(function (term) { return term.clone(); }));
    };
    return Case;
}());
exports.Case = Case;


/***/ }),

/***/ 66240:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Constr = void 0;
var bitstream_1 = __webpack_require__(85840);
var Constr = /** @class */ (function () {
    function Constr(index, terms) {
        this.index = BigInt(index);
        this.terms = terms;
    }
    Object.defineProperty(Constr, "UPLCTag", {
        get: function () {
            return bitstream_1.BitStream.fromBinStr("1000");
        },
        enumerable: false,
        configurable: true
    });
    Constr.prototype.clone = function () {
        return new Constr(this.index, this.terms.map(function (term) { return term.clone(); }));
    };
    return Constr;
}());
exports.Constr = Constr;


/***/ }),

/***/ 93974:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Delay = void 0;
var bitstream_1 = __webpack_require__(85840);
var Delay = /** @class */ (function () {
    function Delay(toDelay) {
        this.delayedTerm = toDelay;
    }
    Object.defineProperty(Delay, "UPLCTag", {
        get: function () {
            return bitstream_1.BitStream.fromBinStr("0001");
        },
        enumerable: false,
        configurable: true
    });
    Delay.prototype.clone = function () {
        return new Delay(this.delayedTerm.clone());
    };
    return Delay;
}());
exports.Delay = Delay;


/***/ }),

/***/ 54915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ErrorUPLC = void 0;
var bitstream_1 = __webpack_require__(85840);
var ErrorUPLC = /** @class */ (function () {
    function ErrorUPLC(msg, addInfos) {
        this.msg = msg;
        this.addInfos = addInfos;
    }
    Object.defineProperty(ErrorUPLC, "UPLCTag", {
        get: function () {
            return bitstream_1.BitStream.fromBinStr("0110");
        },
        enumerable: false,
        configurable: true
    });
    ;
    ErrorUPLC.prototype.clone = function () {
        return new ErrorUPLC(this.msg, this.addInfos);
    };
    return ErrorUPLC;
}());
exports.ErrorUPLC = ErrorUPLC;


/***/ }),

/***/ 66064:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isUPLCForce = exports.Force = exports.isForceableTerm = void 0;
var UPLCTerm_1 = __webpack_require__(14740);
var Delay_1 = __webpack_require__(93974);
var UPLCVar_1 = __webpack_require__(79369);
var Lambda_1 = __webpack_require__(51644);
var Application_1 = __webpack_require__(80271);
var UPLCConst_1 = __webpack_require__(46698);
var ErrorUPLC_1 = __webpack_require__(54915);
var Builtin_1 = __webpack_require__(69537);
var bitstream_1 = __webpack_require__(85840);
function isForceableTerm(term) {
    if (!(0, UPLCTerm_1.isUPLCTerm)(term))
        return false;
    if (term instanceof UPLCVar_1.UPLCVar)
        return true;
    if (term instanceof Delay_1.Delay)
        return true;
    if (term instanceof Lambda_1.Lambda)
        return false;
    // needs evaluation
    if (term instanceof Application_1.Application)
        return true;
    if (term instanceof UPLCConst_1.UPLCConst)
        return false;
    // needs evaluation
    if (term instanceof Force)
        return true;
    if (term instanceof ErrorUPLC_1.ErrorUPLC)
        return false;
    // builtins that do require forces are handled in UPLC compilation
    // applied builtins are handled in the Applicaiton case
    if (term instanceof Builtin_1.Builtin)
        return false;
    return false;
}
exports.isForceableTerm = isForceableTerm;
var Force = /** @class */ (function () {
    function Force(term) {
        //JsRuntime.assert(
        //    isForceableTerm( term ),
        //    "while constructing 'Force'; UPLCTerm is not Forceable"
        //);
        this.termToForce = term;
    }
    Object.defineProperty(Force, "UPLCTag", {
        get: function () {
            return bitstream_1.BitStream.fromBinStr("0101");
        },
        enumerable: false,
        configurable: true
    });
    Force.prototype.clone = function () {
        return new Force(this.termToForce.clone());
    };
    return Force;
}());
exports.Force = Force;
function isUPLCForce(any) {
    return Object.getPrototypeOf(any) === Force.prototype;
}
exports.isUPLCForce = isUPLCForce;


/***/ }),

/***/ 51644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Lambda = void 0;
var bitstream_1 = __webpack_require__(85840);
var Lambda = /** @class */ (function () {
    function Lambda(body) {
        this.body = body;
    }
    Object.defineProperty(Lambda, "UPLCTag", {
        get: function () {
            return bitstream_1.BitStream.fromBinStr("0010");
        },
        enumerable: false,
        configurable: true
    });
    Lambda.prototype.clone = function () {
        return new Lambda(this.body.clone());
    };
    return Lambda;
}());
exports.Lambda = Lambda;


/***/ }),

/***/ 89020:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.constPairTypeUtils = exports.constListTypeUtils = exports.constTypeToStirng = exports.constTypeTagToStirng = exports.isConstTypeTag = exports.constT = exports.constTypeEq = exports.isWellFormedConstType = exports.ConstTyTag = void 0;
var assert_1 = __webpack_require__(63952);
var ConstTyTag;
(function (ConstTyTag) {
    ConstTyTag[ConstTyTag["int"] = 0] = "int";
    ConstTyTag[ConstTyTag["byteStr"] = 1] = "byteStr";
    ConstTyTag[ConstTyTag["str"] = 2] = "str";
    ConstTyTag[ConstTyTag["unit"] = 3] = "unit";
    ConstTyTag[ConstTyTag["bool"] = 4] = "bool";
    ConstTyTag[ConstTyTag["list"] = 5] = "list";
    ConstTyTag[ConstTyTag["pair"] = 6] = "pair";
    // tyApp = 7, // only used internally for types like list and pair
    ConstTyTag[ConstTyTag["data"] = 8] = "data";
    /** NEVER ENCODED; still needed for plutus-machine values */
    ConstTyTag[ConstTyTag["bls12_381_G1_element"] = 9] = "bls12_381_G1_element";
    ConstTyTag[ConstTyTag["bls12_381_G2_element"] = 10] = "bls12_381_G2_element";
    ConstTyTag[ConstTyTag["bls12_381_MlResult"] = 11] = "bls12_381_MlResult";
})(ConstTyTag = exports.ConstTyTag || (exports.ConstTyTag = {}));
function isWellFormedConstType(type /*ConstType | ConstTyTag[]*/) {
    if (!Array.isArray(type))
        return false;
    if (type.length === 0)
        return false;
    if (!type.every(isConstTypeTag))
        return false;
    if (type[0] !== ConstTyTag.list &&
        type[0] !== ConstTyTag.pair)
        return (type.length === 1);
    // keeps track of the missing terms to provide as argument
    // well formed types from this point must start with either 'ConstTyTag.list' of 'ConstTyTag.pair'
    // in any case the stack must count that tag as top level
    var stack = [1];
    if (type[0] !== ConstTyTag.list &&
        type[0] !== ConstTyTag.pair) {
        // returning false anyway, type has too many arguments, not well-formed
        return false;
    }
    function topStackMinusOne() {
        (0, assert_1.assert)(stack.length > 0, new Error("while calling 'topStackMinusOne' in 'ConstEmptyList._isWellFormedListType'; stack was empty"));
        var missingTyArgsToProvide = stack[stack.length - 1] - 1;
        if (missingTyArgsToProvide < 0) {
            throw new Error("while checking for type correctness in empty constant list; stack element was less than 0");
        }
        stack[stack.length - 1] = missingTyArgsToProvide;
    }
    for (var i = 0; i < type.length; i++) {
        var ty = type[i];
        if (ty === ConstTyTag.list) {
            if (!((i + 1) < type.length))
                return false;
            topStackMinusOne();
            stack.push(1); // add new layer
        }
        else if (ty === ConstTyTag.pair) {
            if (!((i + 2) < type.length))
                return false;
            topStackMinusOne();
            stack.push(2); // add new layer for pair
        }
        else {
            topStackMinusOne(); // got an argument
        }
        // clear fulfilled layers
        while (stack.length > 0 &&
            stack[stack.length - 1] === 0) {
            stack.pop(); // clear layer
        }
        if ( // if
        stack.length === 0 && // stack is empty
            i !== (type.length - 1) // and we are not at the end of the type
        ) {
            return false; // addtional types provided
        }
        if ( // if
        i === (type.length - 1) && // we are at the end of the type
            stack.length !== 0 // and the stack expects some more arguments
        ) {
            return false; // missing some arguments
        }
    }
    return true;
}
exports.isWellFormedConstType = isWellFormedConstType;
/**
 * **does NOT require the types to be well-formed**
 *
 * merly checks to have the same tags at the same place
 */
function constTypeEq(a, b) {
    if (a.length !== b.length)
        return false;
    return a.every(function (tyTag, i) { return tyTag === b[i]; });
}
exports.constTypeEq = constTypeEq;
/**
 * well formed types
 */
exports.constT = Object.freeze({
    int: Object.freeze([ConstTyTag.int]),
    byteStr: Object.freeze([ConstTyTag.byteStr]),
    str: Object.freeze([ConstTyTag.str]),
    unit: Object.freeze([ConstTyTag.unit]),
    bool: Object.freeze([ConstTyTag.bool]),
    listOf: function (tyArg) {
        (0, assert_1.assert)(isWellFormedConstType(tyArg), "provided argument to 'constT.listOf' should be a well formed type, try using types exposed by  the 'constT' object itself");
        return Object.freeze(__spreadArray([ConstTyTag.list], __read(tyArg), false));
    },
    pairOf: function (tyArg1, tyArg2) {
        (0, assert_1.assert)(isWellFormedConstType(tyArg1) && isWellFormedConstType(tyArg2), "provided argument to 'constT.pairOf' should be a well formed type, try using types exposed by  the 'constT' object itself");
        return Object.freeze(__spreadArray(__spreadArray([ConstTyTag.pair], __read(tyArg1), false), __read(tyArg2), false));
    },
    data: Object.freeze([ConstTyTag.data]),
    bls12_381_G1_element: Object.freeze([ConstTyTag.bls12_381_G1_element]),
    bls12_381_G2_element: Object.freeze([ConstTyTag.bls12_381_G2_element]),
    bls12_381_MlResult: Object.freeze([ConstTyTag.bls12_381_MlResult])
});
function isConstTypeTag(constTy) {
    constTy = constTy;
    return (constTy === ConstTyTag.int ||
        constTy === ConstTyTag.byteStr ||
        constTy === ConstTyTag.str ||
        constTy === ConstTyTag.unit ||
        constTy === ConstTyTag.bool ||
        constTy === ConstTyTag.list ||
        constTy === ConstTyTag.pair ||
        // (constTyTag as number) === 7   || // uncomment if tyApp should be considered
        constTy === ConstTyTag.data ||
        constTy === ConstTyTag.bls12_381_G1_element ||
        constTy === ConstTyTag.bls12_381_G2_element ||
        constTy === ConstTyTag.bls12_381_MlResult);
}
exports.isConstTypeTag = isConstTypeTag;
function constTypeTagToStirng(ty) {
    switch (ty) {
        case ConstTyTag.int: return "integer";
        case ConstTyTag.byteStr: return "bytestring";
        case ConstTyTag.str: return "string";
        case ConstTyTag.unit: return "unit";
        case ConstTyTag.bool: return "boolean";
        case ConstTyTag.list: return "list";
        case ConstTyTag.pair: return "pair";
        case ConstTyTag.data: return "data";
        case ConstTyTag.bls12_381_G1_element: return "bls12_381_G1_element";
        case ConstTyTag.bls12_381_G2_element: return "bls12_381_G2_element";
        case ConstTyTag.bls12_381_MlResult: return "bls12_381_MlResult";
        default:
            throw new Error("'constTypeTAgToStirng' is supposed to have a member of the 'ConstTy' enum as input but got: " + ty);
    }
}
exports.constTypeTagToStirng = constTypeTagToStirng;
function constTypeToStirng(ty) {
    return ty.map(constTypeTagToStirng).join(' ');
}
exports.constTypeToStirng = constTypeToStirng;
// -------------------------------------------------- ConstListType Utils -------------------------------------------------- //
function getConstListTypeArgument(listTy) {
    (0, assert_1.assert)(listTy.length > 0 && listTy[0] === ConstTyTag.list && isWellFormedConstType(listTy), "in 'constListTypeUtils.getTypeArgument', input type was not a valid list type");
    return listTy.slice(1);
}
;
function getNonWellFormedConstListTypeArgument(listTy) {
    (0, assert_1.assert)(listTy.length > 0 && listTy[0] === ConstTyTag.list, "in 'constListTypeUtils.getTypeArgument', input type was not a valid list type");
    var rawArg = listTy.slice(1);
    if (rawArg.length === 0)
        return undefined;
    if (isWellFormedConstType(rawArg))
        return rawArg;
    if (rawArg[0] !== ConstTyTag.list &&
        rawArg[0] !== ConstTyTag.pair) {
        return [rawArg[0]];
    }
    if (rawArg[0] === ConstTyTag.list) {
        var tyArgOfList = getNonWellFormedConstListTypeArgument(rawArg);
        if (tyArgOfList === undefined)
            return undefined;
        return __spreadArray([ConstTyTag.list], __read(tyArgOfList), false);
    }
    if (rawArg[0] === ConstTyTag.pair) {
        var firstArg = getNonWellFormedConstPairFirstTypeArgument(rawArg);
        if (firstArg === undefined) {
            return undefined;
        }
        var secondArg = getNonWellFormedConstPairSecondTypeArgument(rawArg);
        if (secondArg === undefined) {
            return undefined;
        }
        return exports.constT.pairOf(firstArg, secondArg);
    }
}
exports.constListTypeUtils = Object.freeze({
    getTypeArgument: getConstListTypeArgument,
    nonWellFormed: Object.freeze({
        /**
         *
         * @param listTy
         * @returns
         *      ```undefined``` only if the type argument was not complete
         *      returns the sliced type argument if too many where provided
         *      same of ```constListTypeUtils.getTypeArgument``` if the type argument was well formed
         */
        getNonWellFormedTypeArgument: getNonWellFormedConstListTypeArgument,
    }),
});
// -------------------------------------------------- ConstPairType Utils -------------------------------------------------- //
function getConstPairFirstTypeArgument(pairTy) {
    (0, assert_1.assert)(pairTy.length > 0 && pairTy[0] === ConstTyTag.pair && isWellFormedConstType(pairTy), "in 'constPairTypeUtils.getFirstTypeArgument', input type was not a valid pair type");
    var rawArg = pairTy.slice(1);
    if (rawArg.length === 0) {
        throw new Error("'pairTy' was supposed to be well formed but is missing arguments for 'ConstTyTag.pair'");
    }
    if (rawArg[0] !== ConstTyTag.list &&
        rawArg[0] !== ConstTyTag.pair) {
        // argument takes no more arguments
        return [pairTy[1]];
    }
    if (rawArg[0] === ConstTyTag.list) {
        // non well formed in order to ignore the second argument
        var listTyArg = getNonWellFormedConstListTypeArgument(rawArg);
        if (listTyArg === undefined) {
            throw new Error("in 'getConstPairFirstTypeArgument' (exported as 'constPairTypeUtils.getFirstTypeArgument'); " +
                "'listTyArg' was expected to be a well formed type but was missing some arguments to be well formed; " +
                "this case sould have trown while checking for the 'pairTy' to be well formed");
        }
        return __spreadArray([ConstTyTag.list], __read(listTyArg), false);
    }
    if (rawArg[0] === ConstTyTag.pair) {
        var firstArg = getNonWellFormedConstPairFirstTypeArgument(rawArg);
        if (firstArg === undefined) {
            throw new Error("in 'getConstPairFirstTypeArgument'; " +
                "'firstArg' was expected to be a well formed type but was missing some arguments to be well formed; " +
                "this case sould have trown while checking for the 'pairTy' to be well formed");
        }
        var secondArg = getNonWellFormedConstPairSecondTypeArgument(rawArg);
        if (secondArg === undefined) {
            throw new Error("in 'getConstPairFirstTypeArgument'; " +
                "'secondArg' was expected to be a well formed type but was missing some arguments to be well formed; " +
                "this case sould have trown while checking for the 'pairTy' to be well formed");
        }
        return exports.constT.pairOf(firstArg, secondArg);
    }
    throw new Error("unexpected execution flow; 'getConstPairFirstTypeArgument' did not match any `ConstTyTag` as first argument");
}
function getConstPairSecondTypeArgument(pairTy) {
    /*
    assert(
        pairTy.length > 0 && pairTy[0] === ConstTyTag.pair && isWellFormedConstType( pairTy ),
        "in 'constPairTypeUtils.getFirstTypeArgument', input type was not a valid pair type"
    );*/ // made in the 'getConstPairFirstTypeArgument'call
    // if pairTy is not well formed throws
    // if doesn't throw is well formed
    // if it is well formed the sliced part is the well formed type
    return pairTy.slice(1 + getConstPairFirstTypeArgument(pairTy).length);
}
function getNonWellFormedConstPairFirstTypeArgument(pairTy) {
    (0, assert_1.assert)(pairTy.length > 0 && pairTy[0] === ConstTyTag.pair, "in 'constPairTypeUtils.getFirstTypeArgument', input type was not a valid pair type");
    var rawArg = pairTy.slice(1);
    // at least two tags mus follow in order to be fulfilled
    if (rawArg.length < 2) {
        return undefined;
    }
    if (rawArg[0] !== ConstTyTag.list &&
        rawArg[0] !== ConstTyTag.pair) {
        // argument takes no more arguments
        return [pairTy[1]];
    }
    if (rawArg[0] === ConstTyTag.list) {
        // non well formed in order to ignore the second argument
        var listTyArg = getNonWellFormedConstListTypeArgument(rawArg);
        if (listTyArg === undefined)
            return undefined;
        return __spreadArray([ConstTyTag.list], __read(listTyArg), false);
    }
    if (rawArg[0] === ConstTyTag.pair) {
        var firstArg = getNonWellFormedConstPairFirstTypeArgument(rawArg);
        if (firstArg === undefined) {
            return undefined;
        }
        var secondArg = getNonWellFormedConstPairSecondTypeArgument(rawArg);
        if (secondArg === undefined) {
            return undefined;
        }
        return exports.constT.pairOf(firstArg, secondArg);
    }
    throw new Error("unexpected execution flow; 'getNonWellFormedConstPairFirstTypeArgument' did not match any `ConstTyTag` as first argument");
}
function getNonWellFormedConstPairSecondTypeArgument(pairTy) {
    /*
    assert(
        pairTy.length > 0 && pairTy[0] === ConstTyTag.pair,
        "in 'constPairTypeUtils.getFirstTypeArgument', input type was not a valid pair type"
    );
    */ // made in the 'getNonWellFormedConstPairFirstTypeArgument' call
    var pairFirstTyArg = getNonWellFormedConstPairFirstTypeArgument(pairTy);
    if (pairFirstTyArg === undefined)
        return undefined;
    var rawSecondArg = pairTy.slice(1 + pairFirstTyArg.length);
    if (rawSecondArg.length === 0)
        return undefined;
    if (rawSecondArg[0] !== ConstTyTag.list &&
        rawSecondArg[0] !== ConstTyTag.pair) {
        // argument takes no more arguments
        return [rawSecondArg[0]];
    }
    if (rawSecondArg[0] === ConstTyTag.list) {
        // non well formed in order to ignore the second argument
        var listTyArg = getNonWellFormedConstListTypeArgument(rawSecondArg);
        if (listTyArg === undefined)
            return undefined;
        return __spreadArray([ConstTyTag.list], __read(listTyArg), false);
    }
    if (rawSecondArg[0] === ConstTyTag.pair) {
        var firstArg = getNonWellFormedConstPairFirstTypeArgument(rawSecondArg);
        if (firstArg === undefined) {
            return undefined;
        }
        var secondArg = getNonWellFormedConstPairSecondTypeArgument(rawSecondArg);
        if (secondArg === undefined) {
            return undefined;
        }
        return exports.constT.pairOf(firstArg, secondArg);
    }
    throw new Error("unexpected execution flow; 'getNonWellFormedConstPairFirstTypeArgument' did not match any `ConstTyTag` as first argument");
}
exports.constPairTypeUtils = Object.freeze({
    getFirstTypeArgument: getConstPairFirstTypeArgument,
    getSecondTypeArgument: getConstPairSecondTypeArgument,
    nonWellFormed: Object.freeze({
        /**
         *
         * @param listTy
         * @returns
         *      ```undefined``` only if the type argument was not complete
         *      returns the sliced type argument if too many where provided
         *      same of ```constPairTypeUtils.getFirstTypeArgument``` if the type argument was well formed
         */
        getFirstTypeArgument: getNonWellFormedConstPairFirstTypeArgument,
        /**
         *
         * @param listTy
         * @returns
         *      ```undefined``` only if the type argument was not complete
         *      returns the sliced type argument if too many where provided
         *      same of ```constPairTypeUtils.getSecondTypeArgument``` if the type argument was well formed
         */
        getSecondTypeArgument: getNonWellFormedConstPairSecondTypeArgument
    }),
});


/***/ }),

/***/ 54631:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isConstValueList = exports.canConstValueBeOfConstType = exports.inferConstTypeFromConstValueOrDefault = exports.inferConstTypeFromConstValue = exports.eqConstValue = exports.isConstValue = exports.isConstValueInt = void 0;
var bytestring_1 = __webpack_require__(86152);
var pair_1 = __webpack_require__(53307);
var plutus_data_1 = __webpack_require__(34635);
var ConstType_1 = __webpack_require__(89020);
var uint8array_utils_1 = __webpack_require__(44948);
var assert_1 = __webpack_require__(63952);
var crypto_1 = __webpack_require__(15251);
function isConstValueInt(n) {
    return (typeof n === "bigint" ||
        (typeof n === "number" && Number.isSafeInteger(n)));
}
exports.isConstValueInt = isConstValueInt;
function isConstValue(value) {
    return (value === undefined ||
        isConstValueInt(value) ||
        (value instanceof bytestring_1.ByteString && bytestring_1.ByteString.isStrictInstance(value)) ||
        typeof value === "string" ||
        typeof value === "boolean" ||
        isConstValueList(value) ||
        (pair_1.Pair.isStrictInstance(value) &&
            isConstValue(value.fst) && isConstValue(value.snd)) ||
        (0, plutus_data_1.isData)(value) ||
        (0, crypto_1.isBlsG1)(value) ||
        (0, crypto_1.isBlsG2)(value) ||
        (0, crypto_1.isBlsResult)(value));
}
exports.isConstValue = isConstValue;
function eqConstValue(a, b) {
    if (a === undefined)
        return b === undefined;
    if (!(isConstValue(a) ||
        isConstValue(b)))
        return false;
    if ((typeof a === "number" || typeof a == "bigint"))
        return ((typeof b === "number" || typeof b == "bigint") &&
            BigInt(a) === BigInt(b));
    if (a instanceof bytestring_1.ByteString)
        return (b instanceof bytestring_1.ByteString &&
            (0, uint8array_utils_1.uint8ArrayEq)(a.toBuffer(), b.toBuffer()));
    if (typeof a === "string")
        return (typeof b === "string" &&
            a === b);
    if (typeof a === "boolean")
        return (typeof b === "boolean" &&
            (a === b));
    if ((0, crypto_1.isBlsG1)(a))
        return (0, crypto_1.isBlsG1)(b) && (0, crypto_1.bls12_381_G1_equal)(a, b);
    if ((0, crypto_1.isBlsG2)(a))
        return (0, crypto_1.isBlsG2)(b) && (0, crypto_1.bls12_381_G2_equal)(a, b);
    if ((0, crypto_1.isBlsResult)(a))
        return (0, crypto_1.isBlsResult)(b) && (0, crypto_1.bls12_381_eqMlResult)(a, b);
    if ((0, plutus_data_1.isData)(a))
        return ((0, plutus_data_1.isData)(b) && (0, plutus_data_1.eqData)(a, b));
    if (a instanceof pair_1.Pair)
        return (b instanceof pair_1.Pair &&
            eqConstValue(a.fst, b.fst) &&
            eqConstValue(a.snd, b.snd));
    if (Array.isArray(a))
        return (Array.isArray(b) &&
            a.length === b.length &&
            a.every(function (v, i) { return eqConstValue(v, b[i]); }));
    return false;
}
exports.eqConstValue = eqConstValue;
// mutually recursive on arrays (list values)
// inferConstTypeFromConstValue -> isConstValue -> isConstValueList (on list element) -> inferConstTypeFromConstValue
/**
 *
 * @param val
 * @returns the type of the ```ConstValue``` input ```undefined``` if it is not possible to infer the type ( eg. [] :: list ? )
 */
function inferConstTypeFromConstValue(val) {
    (0, assert_1.assert)(isConstValue(val), "'inferConstTypeFromConstValue' expects a valid 'ConstValue' type, input was: " + val);
    if (val === undefined)
        return ConstType_1.constT.unit;
    if (isConstValueInt(val))
        return ConstType_1.constT.int;
    if (val instanceof bytestring_1.ByteString && bytestring_1.ByteString.isStrictInstance(val))
        return ConstType_1.constT.byteStr;
    if (typeof val === "string")
        return ConstType_1.constT.str;
    if (typeof val === "boolean")
        return ConstType_1.constT.bool;
    if ((0, crypto_1.isBlsG1)(val))
        return ConstType_1.constT.bls12_381_G1_element;
    if ((0, crypto_1.isBlsG2)(val))
        return ConstType_1.constT.bls12_381_G2_element;
    if ((0, crypto_1.isBlsResult)(val))
        return ConstType_1.constT.bls12_381_MlResult;
    if (Array.isArray(val)) {
        if (val.length === 0)
            return undefined;
        var firstElemTy_1 = undefined;
        for (var i = 0; i < val.length && firstElemTy_1 === undefined; i++) {
            firstElemTy_1 = inferConstTypeFromConstValue(val[i]);
        }
        if (firstElemTy_1 === undefined)
            return undefined;
        (0, assert_1.assert)(val.every(function (listElem) { return canConstValueBeOfConstType(listElem, firstElemTy_1); }), "'inferConstTypeFromConstValue': incongruent elements of constant list");
        return ConstType_1.constT.listOf(firstElemTy_1);
    }
    if (val instanceof pair_1.Pair && pair_1.Pair.isStrictInstance(val)) {
        var fstTy = inferConstTypeFromConstValue(val.fst);
        if (fstTy === undefined)
            return undefined;
        var sndTy = inferConstTypeFromConstValue(val.snd);
        if (sndTy === undefined)
            return undefined;
        return ConstType_1.constT.pairOf(fstTy, sndTy);
    }
    if ((0, plutus_data_1.isData)(val))
        return ConstType_1.constT.data;
    throw new Error("'inferConstTypeFromConstValue' did not match any possible value");
}
exports.inferConstTypeFromConstValue = inferConstTypeFromConstValue;
/**
 * same as ```inferConstTypeFromConstValue``` but with a default Type if it is not possible to infer
 */
function inferConstTypeFromConstValueOrDefault(value, defaultTy) {
    var _a;
    var inferredTy = inferConstTypeFromConstValue(value);
    if (inferredTy !== undefined) {
        return inferredTy;
    }
    // it was not possible to infer the value;
    // assert the provided default can actually have values
    (0, assert_1.assert)((0, ConstType_1.isWellFormedConstType)(defaultTy), "the provided 'defaultTy' is not a well formed constant type; try using the exported 'constT' object to be sure it is well formed");
    // assert the default type is ok for the provided value
    (0, assert_1.assert)(canConstValueBeOfConstType(value, defaultTy), "the provided default ConstType is not adeguate for the provided ConstValue, given inputs: [ " +
        ((_a = value === null || value === void 0 ? void 0 : value.toString()) !== null && _a !== void 0 ? _a : "undefined") + " , " +
        (0, ConstType_1.constTypeToStirng)(defaultTy) + " ]");
    return defaultTy;
}
exports.inferConstTypeFromConstValueOrDefault = inferConstTypeFromConstValueOrDefault;
function canConstValueBeOfConstType(val, ty) {
    if (!(0, ConstType_1.isWellFormedConstType)(ty))
        return false;
    if ((0, ConstType_1.constTypeEq)(ty, ConstType_1.constT.unit))
        return val === undefined;
    if ((0, ConstType_1.constTypeEq)(ty, ConstType_1.constT.bool))
        return typeof val === "boolean";
    if ((0, ConstType_1.constTypeEq)(ty, ConstType_1.constT.byteStr))
        return (val instanceof bytestring_1.ByteString && bytestring_1.ByteString.isStrictInstance(val));
    if ((0, ConstType_1.constTypeEq)(ty, ConstType_1.constT.data))
        return val === undefined ? false : (0, plutus_data_1.isData)(val);
    if ((0, ConstType_1.constTypeEq)(ty, ConstType_1.constT.int))
        return isConstValueInt(val);
    if ((0, ConstType_1.constTypeEq)(ty, ConstType_1.constT.str))
        return typeof val === "string";
    if ((0, ConstType_1.constTypeEq)(ty, ConstType_1.constT.bls12_381_G1_element))
        return (0, crypto_1.isBlsG1)(val);
    if ((0, ConstType_1.constTypeEq)(ty, ConstType_1.constT.bls12_381_G2_element))
        return (0, crypto_1.isBlsG2)(val);
    if ((0, ConstType_1.constTypeEq)(ty, ConstType_1.constT.bls12_381_MlResult))
        return (0, crypto_1.isBlsResult)(val);
    if (ty[0] === ConstType_1.ConstTyTag.list)
        return (Array.isArray(val) &&
            val.every(function (valueElement) {
                return canConstValueBeOfConstType(valueElement, ConstType_1.constListTypeUtils.getTypeArgument(ty));
            }));
    if (ty[0] === ConstType_1.ConstTyTag.pair)
        return (val instanceof pair_1.Pair && pair_1.Pair.isStrictInstance(val) &&
            canConstValueBeOfConstType(val.fst, ConstType_1.constPairTypeUtils.getFirstTypeArgument(ty)) &&
            canConstValueBeOfConstType(val.snd, ConstType_1.constPairTypeUtils.getSecondTypeArgument(ty)));
    throw new Error("'canConstValueBeOfConstType' did not match any type tag");
}
exports.canConstValueBeOfConstType = canConstValueBeOfConstType;
function isConstValueList(val) {
    if (!Array.isArray(val))
        return false;
    // [] is a valid value for any list type
    if (val.length === 0)
        return true;
    var firstElemTy = undefined;
    for (var i = 0; i < val.length && firstElemTy === undefined; i++) {
        firstElemTy = inferConstTypeFromConstValue(val[i]);
    }
    function isArrayOfEmptyArray(arr) {
        if (!Array.isArray(arr))
            return false;
        return arr.every(function (elem) { return Array.isArray(elem) && elem.length === 0 || isArrayOfEmptyArray(elem); });
    }
    if (firstElemTy === undefined) {
        return isArrayOfEmptyArray(val);
    }
    return val.every(function (listElem) { return canConstValueBeOfConstType(listElem, firstElemTy); });
}
exports.isConstValueList = isConstValueList;


/***/ }),

/***/ 46698:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UPLCConst = void 0;
var bitstream_1 = __webpack_require__(85840);
var pair_1 = __webpack_require__(53307);
var ConstType_1 = __webpack_require__(89020);
var ConstValue_1 = __webpack_require__(54631);
var assert_1 = __webpack_require__(63952);
var UPLCConst = /** @class */ (function () {
    function UPLCConst(typeTag, value) {
        (0, assert_1.assert)((0, ConstType_1.isWellFormedConstType)(typeTag), "trying to construct an UPLC constant with an invalid type; input type: " + (0, ConstType_1.constTypeToStirng)(typeTag));
        (0, assert_1.assert)((0, ConstValue_1.canConstValueBeOfConstType)(value, typeTag), "trying to construct an UPLC constant with an invalid value for type \"".concat((0, ConstType_1.constTypeToStirng)(typeTag), "\";\n             input value was: ").concat(value));
        if ((0, ConstType_1.constTypeEq)(typeTag, ConstType_1.constT.int))
            value = BigInt(value);
        if ((0, ConstType_1.constTypeEq)(typeTag, ConstType_1.constT.listOf(ConstType_1.constT.int)))
            value = value.map(function (n) { return BigInt(n); });
        if (typeTag[0] === ConstType_1.ConstTyTag.pair) {
            if ((0, ConstType_1.constTypeEq)(ConstType_1.constPairTypeUtils.getFirstTypeArgument(typeTag), ConstType_1.constT.int))
                value.fst = BigInt(value.fst);
            if ((0, ConstType_1.constTypeEq)(ConstType_1.constPairTypeUtils.getSecondTypeArgument(typeTag), ConstType_1.constT.int))
                value.snd = BigInt(value.snd);
        }
        this._type = typeTag;
        this._value = value;
    }
    Object.defineProperty(UPLCConst, "UPLCTag", {
        get: function () {
            return bitstream_1.BitStream.fromBinStr("0100");
        },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(UPLCConst.prototype, "type", {
        get: function () {
            // clone
            return this._type.map(function (tag) { return tag; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UPLCConst.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    UPLCConst.prototype.clone = function () {
        return new UPLCConst(this.type, this.value);
    };
    UPLCConst.int = function (int) {
        int = BigInt(int);
        return new UPLCConst(ConstType_1.constT.int, int);
    };
    UPLCConst.byteString = function (bs) {
        return new UPLCConst(ConstType_1.constT.byteStr, bs);
    };
    UPLCConst.str = function (str) {
        return new UPLCConst(ConstType_1.constT.str, str);
    };
    Object.defineProperty(UPLCConst, "unit", {
        get: function () {
            return new UPLCConst(ConstType_1.constT.unit, undefined);
        },
        enumerable: false,
        configurable: true
    });
    UPLCConst.bool = function (bool) {
        return new UPLCConst(ConstType_1.constT.bool, bool);
    };
    UPLCConst.listOf = function (typeArg) {
        return function (values) {
            return new UPLCConst(ConstType_1.constT.listOf(typeArg), values);
        };
    };
    UPLCConst.pairOf = function (typeArgFirst, typeArgSecond) {
        return function (first, second) {
            return new UPLCConst(ConstType_1.constT.pairOf(typeArgFirst, typeArgSecond), new pair_1.Pair(first, second));
        };
    };
    UPLCConst.data = function (data) {
        return new UPLCConst(ConstType_1.constT.data, data);
    };
    UPLCConst.bls12_381_G1_element = function (g1) {
        return new UPLCConst(ConstType_1.constT.bls12_381_G1_element, g1);
    };
    UPLCConst.bls12_381_G2_element = function (g2) {
        return new UPLCConst(ConstType_1.constT.bls12_381_G2_element, g2);
    };
    UPLCConst.bls12_381_MlResult = function (mlResult) {
        return new UPLCConst(ConstType_1.constT.bls12_381_MlResult, mlResult);
    };
    return UPLCConst;
}());
exports.UPLCConst = UPLCConst;


/***/ }),

/***/ 77838:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(46698), exports);
__exportStar(__webpack_require__(89020), exports);
__exportStar(__webpack_require__(54631), exports);


/***/ }),

/***/ 79369:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UPLCVar = void 0;
var bitstream_1 = __webpack_require__(85840);
var ints_1 = __webpack_require__(25301);
var assert_1 = __webpack_require__(63952);
var UPLCVar = /** @class */ (function () {
    function UPLCVar(deBruijn) {
        this._deBruijn = (0, ints_1.forceBigUInt)(deBruijn);
        (0, assert_1.assert)(this._deBruijn >= BigInt(0), "invalid deBruijn index; while creating 'UPLCVar' instance, deBruijn index was: "
            + this._deBruijn);
    }
    Object.defineProperty(UPLCVar, "UPLCTag", {
        get: function () {
            return bitstream_1.BitStream.fromBinStr("0000");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UPLCVar.prototype, "deBruijn", {
        get: function () { return this._deBruijn; },
        enumerable: false,
        configurable: true
    });
    UPLCVar.prototype.clone = function () {
        return new UPLCVar(this.deBruijn);
    };
    return UPLCVar;
}());
exports.UPLCVar = UPLCVar;


/***/ }),

/***/ 39068:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(80271), exports);
__exportStar(__webpack_require__(54696), exports);
__exportStar(__webpack_require__(93974), exports);
__exportStar(__webpack_require__(54915), exports);
__exportStar(__webpack_require__(66064), exports);
__exportStar(__webpack_require__(51644), exports);
__exportStar(__webpack_require__(77838), exports);
__exportStar(__webpack_require__(79369), exports);
__exportStar(__webpack_require__(66240), exports);
__exportStar(__webpack_require__(49629), exports);


/***/ }),

/***/ 88867:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(72931), exports);
__exportStar(__webpack_require__(33558), exports);
__exportStar(__webpack_require__(66129), exports);
__exportStar(__webpack_require__(48017), exports);
__exportStar(__webpack_require__(57784), exports);
__exportStar(__webpack_require__(39068), exports);


/***/ }),

/***/ 99140:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 72931:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(99140), exports);


/***/ }),

/***/ 16379:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * @static
 */
var BitUtils = /** @class */ (function () {
    function BitUtils() {
    }
    /**
     * @deprecated not sure it has ever made sense to have it
     * @returns a number in range ```[ 0 , 255 ]``` ( ```[ 0b0000_0000, 0b1111_1111 ]``` ) based on the first byte
     */
    BitUtils.getFirstByte = function (bits) {
        return Number("0x".concat(bits.toString(16).slice(0, 2)));
    };
    /**
     * @deprecated use ```andMaskOfLength``` instead
     */
    BitUtils.andMaskOfLengthInt = function (n) {
        n = Math.round(Math.abs(n));
        // operatons used are valid on singed int32
        if (n >= 30) {
            return BitUtils.andMaskOfLength(BigInt(n));
        }
        return BigInt((1 << n) - 1);
    };
    /**
     * returns a ```bigint``` of that as the last ```n``` bits setted to ones;
     *
     * example
     * ```ts
     * BitUtils.getMaskOfLength( 7 ) === Bigint( 0b0111_1111 ); // true
     * ```
     */
    BitUtils.andMaskOfLength = function (n) {
        return BigInt((BigInt(1)
            << n)
            - BigInt(1));
    };
    BitUtils.getNLastBits = function (fromNuber, nBits) {
        return (fromNuber & BitUtils.andMaskOfLength(nBits));
    };
    /**
     * @returns the number of bits from the first setted to ```1``` on the left up until the end
     */
    BitUtils.getNOfUsedBits = function (bits) {
        if (bits === BigInt(0))
            return 0;
        return bits.toString(2).length;
    };
    BitUtils.minBytesRequired = function (bigint) {
        if (bigint < BigInt(0))
            throw new Error("BitUtils.minBytesRequired works for positives integers only");
        var fullByteOnes = BigInt(255);
        var mask = fullByteOnes;
        var bytesRequired = 1;
        while (bigint !== (bigint & mask)) {
            mask = (mask << BigInt(8)) | fullByteOnes;
            bytesRequired++;
        }
        return bytesRequired;
    };
    return BitUtils;
}());
exports["default"] = BitUtils;


/***/ }),

/***/ 29149:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isInByteOffset = void 0;
var bitstream_1 = __webpack_require__(85840);
var BitUtils_1 = __importDefault(__webpack_require__(16379));
var assert_1 = __webpack_require__(63952);
function isInByteOffset(offset) {
    return (offset === 0 ||
        offset === 1 ||
        offset === 2 ||
        offset === 3 ||
        offset === 4 ||
        offset === 5 ||
        offset === 6 ||
        offset === 7);
}
exports.isInByteOffset = isInByteOffset;
/**
 * @static
 */
var UPLCFlatUtils = /** @class */ (function () {
    /**
     * @deprecated this is a @static class, it is not supposed to have instances
     */
    function UPLCFlatUtils() {
    }
    ;
    UPLCFlatUtils.zigzagBigint = function (bigint) {
        return (bigint >>
            (BigInt(BitUtils_1.default.getNOfUsedBits(bigint)))) ^ // XOR
            (bigint << BigInt(1));
    };
    UPLCFlatUtils.unzigzagBigint = function (bigint) {
        return (((bigint >> BigInt(1))) ^ // XOR
            -(bigint & BigInt(1)));
    };
    /**
     * source: https://hydra.iohk.io/build/5988492/download/1/plutus-core-specification.pdf#Variable%20length%20data
     *
     * Non-empty lists are encoded by prefixing the element stored with ‘0’ if this is the last element
     * or ‘1’ if there is more data following.
     *
     * We encode Integers as a non-empty list of chunks, 7 bits each, with the least significant chunk
     * first and the most significant bit first in the chunk.
     */
    UPLCFlatUtils.encodeBigIntAsVariableLengthBitStream = function (integer) {
        (0, assert_1.assert)(typeof integer === "bigint", "expected a bigint as input; got instance of type: " + typeof integer);
        if (integer === BigInt(0))
            return bitstream_1.BitStream.fromBinStr("00000000");
        (0, assert_1.assert)(integer > BigInt(0), "'UPLCFlatUtils.encodeBigIntAsVariableLengthBitStream' can only encode non-negative integers; the given input was: " + integer.toString());
        // store binary string for easy BitStream creation
        var chunks = [];
        var mask = BigInt(127);
        // 1. Converting to binary
        var nBits = BitUtils_1.default.getNOfUsedBits(integer);
        for (var nAddedBits = 0; nAddedBits < nBits; nAddedBits += 7) {
            // 3. Reorder chunks (least significant chunk first)
            // 
            // push at the end because the mask starts from the last signigficat chunk first
            // so chunk[1] is the second least significant and so on
            chunks.push(
            // 2. Split into 7 bit chunks
            // take 7 bits
            ((integer & mask)
                // allign to the start 
                >> BigInt(nAddedBits))
                // translate to biinary
                .toString(2)
                // make sure the bits are 7 in total
                .padStart(7, '0'));
            mask = mask << BigInt(7);
        }
        // 4. Add list constructor tags
        for (var i = 0; i < chunks.length; i++) {
            chunks[i] = (i === chunks.length - 1 ? '0' : '1') + chunks[i];
        }
        return bitstream_1.BitStream.fromBinStr(chunks.join(''));
    };
    UPLCFlatUtils.getPadBitStream = function (n) {
        (0, assert_1.assert)(isInByteOffset(n), "addPadTo only works for pads from 0 inclusive to 7 inclusive");
        if (n === 0) {
            return bitstream_1.BitStream.fromBinStr("1".padStart(8, '0'));
        }
        return bitstream_1.BitStream.fromBinStr("1".padStart(n, '0'));
    };
    /**
     * **_SIDE EFFECT_**: modifies the ```toPad``` ```BitStream``` passed as first argument
     *
     * @param toPad
     * @param n
     * @returns
     */
    UPLCFlatUtils.addPadTo = function (toPad, n) {
        (0, assert_1.assert)(bitstream_1.BitStream.isStrictInstance(toPad), "BitStream strict instance expected as first argument in 'UPLCFlatUtils.addPadTo'");
        toPad.append(UPLCFlatUtils.getPadBitStream(n));
        return;
    };
    Object.defineProperty(UPLCFlatUtils, "padToByteDefaultOptions", {
        get: function () {
            return Object.freeze({
                onByteAllignedAddNewByte: true,
                withOneAsEndPadding: true
            });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * **_SIDE EFFECT_**: modifies the ```toPad``` ```BitStream``` passed as first argument
     *
     * @param toPad
     * @param options
     * @returns
     */
    UPLCFlatUtils.padToByte = function (toPad, options) {
        var opts = __assign(__assign({}, UPLCFlatUtils.padToByteDefaultOptions), (options === undefined ? {} : options));
        var nBitsMissingToByte = toPad.getNBitsMissingToByte();
        if (nBitsMissingToByte === 0) {
            if (opts.onByteAllignedAddNewByte) {
                toPad.append(bitstream_1.BitStream.fromBinStr((opts.withOneAsEndPadding ? "1" : "0").padStart(8, '0')));
            }
            else {
                // do nothing, already alligned
            }
            return;
        }
        toPad.append(bitstream_1.BitStream.fromBinStr((opts.withOneAsEndPadding ? "1" : "0").padStart(nBitsMissingToByte, '0')));
        return;
    };
    return UPLCFlatUtils;
}());
exports["default"] = UPLCFlatUtils;


/***/ }),

/***/ 63952:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assert = void 0;
function assert(condition, errorMessage, addInfos) {
    var args = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args[_i - 3] = arguments[_i];
    }
    if (condition)
        return;
    args.length > 0 && console.error.apply(console, __spreadArray([], __read(args), false));
    addInfos && console.error(addInfos);
    if (errorMessage instanceof Error) {
        throw errorMessage;
    }
    ;
    throw new Error(errorMessage);
}
exports.assert = assert;


/***/ }),

/***/ 12776:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getTextBetweenMatchingQuotes = void 0;
function getTextBetweenMatchingQuotes(str) {
    for (var i = 0, ch = "", openIdx = -1; i < str.length; i++) {
        ch = str[i];
        if (ch === '"') {
            if (openIdx < 0)
                openIdx = i;
            else
                return str.slice(openIdx + 1, i);
        }
        else if (ch === "\\")
            i++; // grab whatever is next
    }
    return undefined;
}
exports.getTextBetweenMatchingQuotes = getTextBetweenMatchingQuotes;


/***/ }),

/***/ 89815:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.indexOfMany = void 0;
function indexOfMany(str) {
    var search = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        search[_i - 1] = arguments[_i];
    }
    var idxs = search.map(function (toSearch) { return str.indexOf(toSearch); }).filter(function (idx) { return idx >= 0; });
    return idxs.length === 0 ? -1 : Math.min.apply(Math, __spreadArray([], __read(idxs), false));
}
exports.indexOfMany = indexOfMany;


/***/ }),

/***/ 64990:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.indexOfNextCommaOutsideParentesis = void 0;
function indexOfNextCommaOutsideParentesis(str) {
    for (var i = 0, ch = "", nOpen = 0, nBrackets = 0; i < str.length; i++) {
        ch = str[i];
        if (ch === "(")
            nOpen++;
        else if (ch === ")")
            nOpen--;
        else if (ch === "[")
            nBrackets++;
        else if (ch === "]")
            nBrackets--;
        else if (ch === "," &&
            nOpen <= 0 &&
            nBrackets <= 0)
            return i;
    }
    return -1;
}
exports.indexOfNextCommaOutsideParentesis = indexOfNextCommaOutsideParentesis;


/***/ }),

/***/ 74486:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.indexOfNextUnmatchedParentesis = void 0;
function indexOfNextUnmatchedParentesis(str) {
    for (var i = 0, ch = "", nOpen = 0; i < str.length; i++) {
        ch = str[i];
        if (ch === "(")
            nOpen++;
        else if (ch === ")")
            nOpen--;
        if (nOpen < 0)
            return i;
    }
    return -1;
}
exports.indexOfNextUnmatchedParentesis = indexOfNextUnmatchedParentesis;


/***/ }),

/***/ 25301:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.unsafeForceUInt = exports.forceBigUInt = exports.canBeUInteger = void 0;
function canBeUInteger(something) {
    return ((typeof something === "bigint" && something >= BigInt(0)) ||
        (typeof something === "number" && something === Math.round(Math.abs(something))));
}
exports.canBeUInteger = canBeUInteger;
function forceBigUInt(toForce) {
    if (!canBeUInteger(toForce)) {
        // console.error( toForce );
        throw new Error("trying to convert an integer to an unsigned Integer, the number was negative");
    }
    return BigInt(toForce);
}
exports.forceBigUInt = forceBigUInt;
;
function unsafeForceUInt(toForce) {
    if (!canBeUInteger(toForce)) {
        // console.error( toForce );
        throw new Error("trying to convert an integer to an unsigned Integer, the number was negative");
    }
    return Number(toForce);
}
exports.unsafeForceUInt = unsafeForceUInt;


/***/ }),

/***/ 63083:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var possibleNames = __webpack_require__(89908);

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;

/** @type {import('.')} */
module.exports = function availableTypedArrays() {
	var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g[possibleNames[i]] === 'function') {
			// @ts-expect-error
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};


/***/ }),

/***/ 93967:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 24799:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ neverKeyword; },
/* harmony export */   "AI": function() { return /* binding */ IndexSignature; },
/* harmony export */   "AR": function() { return /* binding */ getAnnotation; },
/* harmony export */   "Aj": function() { return /* binding */ DescriptionAnnotationId; },
/* harmony export */   "B$": function() { return /* binding */ Refinement; },
/* harmony export */   "Bh": function() { return /* binding */ encodedAST; },
/* harmony export */   "CA": function() { return /* binding */ IdentifierAnnotationId; },
/* harmony export */   "DZ": function() { return /* binding */ objectKeyword; },
/* harmony export */   "Dr": function() { return /* binding */ defaultParseOption; },
/* harmony export */   "EJ": function() { return /* binding */ Union; },
/* harmony export */   "GY": function() { return /* binding */ mapMembers; },
/* harmony export */   "I4": function() { return /* binding */ TypeAnnotationId; },
/* harmony export */   "IM": function() { return /* binding */ record; },
/* harmony export */   "Jg": function() { return /* binding */ isMembers; },
/* harmony export */   "KN": function() { return /* binding */ symbolKeyword; },
/* harmony export */   "Lf": function() { return /* binding */ TitleAnnotationId; },
/* harmony export */   "M7": function() { return /* binding */ getTemplateLiteralRegExp; },
/* harmony export */   "Nh": function() { return /* binding */ DocumentationAnnotationId; },
/* harmony export */   "O5": function() { return /* binding */ getSurrogateAnnotation; },
/* harmony export */   "Q7": function() { return /* binding */ ConcurrencyAnnotationId; },
/* harmony export */   "Qc": function() { return /* binding */ TupleType; },
/* harmony export */   "TA": function() { return /* binding */ anyKeyword; },
/* harmony export */   "TI": function() { return /* binding */ isRefinement; },
/* harmony export */   "TJ": function() { return /* binding */ PropertySignature; },
/* harmony export */   "UX": function() { return /* binding */ Suspend; },
/* harmony export */   "Uy": function() { return /* binding */ ParseIssueTitleAnnotationId; },
/* harmony export */   "V5": function() { return /* binding */ PropertySignatureTransformation; },
/* harmony export */   "VF": function() { return /* binding */ UniqueSymbol; },
/* harmony export */   "W_": function() { return /* binding */ Element; },
/* harmony export */   "Yc": function() { return /* binding */ typeAST; },
/* harmony export */   "aN": function() { return /* binding */ JSONSchemaAnnotationId; },
/* harmony export */   "ai": function() { return /* binding */ unknownKeyword; },
/* harmony export */   "by": function() { return /* binding */ ExamplesAnnotationId; },
/* harmony export */   "d1": function() { return /* binding */ getParseIssueTitleAnnotation; },
/* harmony export */   "ds": function() { return /* binding */ annotations; },
/* harmony export */   "eg": function() { return /* binding */ MessageAnnotationId; },
/* harmony export */   "gr": function() { return /* binding */ Declaration; },
/* harmony export */   "gx": function() { return /* binding */ bigIntKeyword; },
/* harmony export */   "hA": function() { return /* binding */ booleanKeyword; },
/* harmony export */   "hw": function() { return /* binding */ stringKeyword; },
/* harmony export */   "lB": function() { return /* binding */ $null; },
/* harmony export */   "mm": function() { return /* binding */ getConcurrencyAnnotation; },
/* harmony export */   "n2": function() { return /* binding */ TypeLiteralTransformation; },
/* harmony export */   "n_": function() { return /* binding */ isLiteral; },
/* harmony export */   "oA": function() { return /* binding */ BatchingAnnotationId; },
/* harmony export */   "oH": function() { return /* binding */ FinalTransformation; },
/* harmony export */   "qC": function() { return /* binding */ compose; },
/* harmony export */   "sC": function() { return /* binding */ getMessageAnnotation; },
/* harmony export */   "t$": function() { return /* binding */ Literal; },
/* harmony export */   "tW": function() { return /* binding */ TypeLiteral; },
/* harmony export */   "uo": function() { return /* binding */ numberKeyword; },
/* harmony export */   "w9": function() { return /* binding */ DefaultAnnotationId; },
/* harmony export */   "we": function() { return /* binding */ getBatchingAnnotation; },
/* harmony export */   "x8": function() { return /* binding */ undefinedKeyword; },
/* harmony export */   "zA": function() { return /* binding */ Transformation; },
/* harmony export */   "zv": function() { return /* binding */ voidKeyword; }
/* harmony export */ });
/* unused harmony exports BrandAnnotationId, SurrogateAnnotationId, getBrandAnnotation, getTitleAnnotation, getIdentifierAnnotation, getDescriptionAnnotation, getExamplesAnnotation, getDefaultAnnotation, getJSONSchemaAnnotation, getDocumentationAnnotation, getJSONIdentifierAnnotation, isDeclaration, isUniqueSymbol, UndefinedKeyword, isUndefinedKeyword, VoidKeyword, isVoidKeyword, NeverKeyword, isNeverKeyword, UnknownKeyword, isUnknownKeyword, AnyKeyword, isAnyKeyword, StringKeyword, isStringKeyword, NumberKeyword, isNumberKeyword, BooleanKeyword, isBooleanKeyword, BigIntKeyword, isBigIntKeyword, SymbolKeyword, isSymbolKeyword, ObjectKeyword, isObjectKeyword, Enums, isEnums, TemplateLiteralSpan, TemplateLiteral, isTemplateLiteral, isTupleType, isParameter, isTypeLiteral, flatten, unify, isUnion, isSuspend, isTransformation, isFinalTransformation, ComposeTransformation, composeTransformation, isComposeTransformation, isTypeLiteralTransformation, keyof, getPropertySignatures, getNumberIndexedAccess, getPropertyKeyIndexedAccess, pick, omit, orUndefined, partial, required, mutable, getCompiler, getToPropertySignatures, getToIndexSignatures, getJSONIdentifier, hash, getCardinality, getWeight, getParameterBase, rename */
/* harmony import */ var effect_Array__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37901);
/* harmony import */ var effect_Function__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17316);
/* harmony import */ var effect_GlobalValue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4726);
/* harmony import */ var effect_Number__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15839);
/* harmony import */ var effect_Option__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16749);
/* harmony import */ var effect_Order__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51988);
/* harmony import */ var effect_Predicate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71335);
/* harmony import */ var effect_RegExp__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7035);
/* harmony import */ var _internal_errors_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48147);
/* harmony import */ var _internal_util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10852);
/**
 * @since 1.0.0
 */











/**
 * @category annotations
 * @since 1.0.0
 */
const BrandAnnotationId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/annotation/Brand")));
/**
 * @category annotations
 * @since 1.0.0
 */
const TypeAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Type");
/**
 * @category annotations
 * @since 1.0.0
 */
const MessageAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Message");
/**
 * @category annotations
 * @since 1.0.0
 */
const IdentifierAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Identifier");
/**
 * @category annotations
 * @since 1.0.0
 */
const TitleAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Title");
/**
 * @category annotations
 * @since 1.0.0
 */
const DescriptionAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Description");
/**
 * @category annotations
 * @since 1.0.0
 */
const ExamplesAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Examples");
/**
 * @category annotations
 * @since 1.0.0
 */
const DefaultAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Default");
/**
 * @category annotations
 * @since 1.0.0
 */
const JSONSchemaAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/JSONSchema");
/**
 * @category annotations
 * @since 1.0.0
 */
const DocumentationAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Documentation");
/**
 * @category annotations
 * @since 1.0.0
 */
const ConcurrencyAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Concurrency");
/**
 * @category annotations
 * @since 1.0.0
 */
const BatchingAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Batching");
/** @internal */
const SurrogateAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Surrogate");
/**
 * @category annotations
 * @since 1.0.0
 */
const ParseIssueTitleAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/ParseIssueTitle");
/**
 * @category annotations
 * @since 1.0.0
 */
const getAnnotation = /*#__PURE__*/(0,effect_Function__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (annotated, key) => Object.prototype.hasOwnProperty.call(annotated.annotations, key) ? effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .some */ .G(annotated.annotations[key]) : effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .none */ .YP());
/**
 * @category annotations
 * @since 1.0.0
 */
const getBrandAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(BrandAnnotationId)));
/**
 * @category annotations
 * @since 1.0.0
 */
const getMessageAnnotation = /*#__PURE__*/getAnnotation(MessageAnnotationId);
/**
 * @category annotations
 * @since 1.0.0
 */
const getTitleAnnotation = /*#__PURE__*/getAnnotation(TitleAnnotationId);
/**
 * @category annotations
 * @since 1.0.0
 */
const getIdentifierAnnotation = /*#__PURE__*/getAnnotation(IdentifierAnnotationId);
/**
 * @category annotations
 * @since 1.0.0
 */
const getDescriptionAnnotation = /*#__PURE__*/getAnnotation(DescriptionAnnotationId);
/**
 * @category annotations
 * @since 1.0.0
 */
const getExamplesAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(ExamplesAnnotationId)));
/**
 * @category annotations
 * @since 1.0.0
 */
const getDefaultAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(DefaultAnnotationId)));
/**
 * @category annotations
 * @since 1.0.0
 */
const getJSONSchemaAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(JSONSchemaAnnotationId)));
/**
 * @category annotations
 * @since 1.0.0
 */
const getDocumentationAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(DocumentationAnnotationId)));
/**
 * @category annotations
 * @since 1.0.0
 */
const getConcurrencyAnnotation = /*#__PURE__*/getAnnotation(ConcurrencyAnnotationId);
/**
 * @category annotations
 * @since 1.0.0
 */
const getBatchingAnnotation = /*#__PURE__*/getAnnotation(BatchingAnnotationId);
/**
 * @category annotations
 * @since 1.0.0
 */
const getParseIssueTitleAnnotation = /*#__PURE__*/getAnnotation(ParseIssueTitleAnnotationId);
/** @internal */
const getSurrogateAnnotation = /*#__PURE__*/getAnnotation(SurrogateAnnotationId);
const JSONIdentifierAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/JSONIdentifier");
/** @internal */
const getJSONIdentifierAnnotation = /*#__PURE__*/getAnnotation(JSONIdentifierAnnotationId);
/**
 * @category model
 * @since 1.0.0
 */
class Declaration {
  typeParameters;
  decodeUnknown;
  encodeUnknown;
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "Declaration";
  constructor(typeParameters, decodeUnknown, encodeUnknown, annotations = {}) {
    this.typeParameters = typeParameters;
    this.decodeUnknown = decodeUnknown;
    this.encodeUnknown = encodeUnknown;
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this, verbose), () => "<declaration schema>");
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      typeParameters: this.typeParameters.map(ast => ast.toJSON()),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
const createASTGuard = tag => ast => ast._tag === tag;
/**
 * @category guards
 * @since 1.0.0
 */
const isDeclaration = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("Declaration")));
/**
 * @category model
 * @since 1.0.0
 */
class Literal {
  literal;
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "Literal";
  constructor(literal, annotations = {}) {
    this.literal = literal;
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this, verbose), () => _internal_util_js__WEBPACK_IMPORTED_MODULE_2__/* .formatUnknown */ .cT(this.literal));
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      literal: effect_Predicate__WEBPACK_IMPORTED_MODULE_3__/* .isBigInt */ .C4(this.literal) ? String(this.literal) : this.literal,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 1.0.0
 */
const isLiteral = /*#__PURE__*/createASTGuard("Literal");
const $null = /*#__PURE__*/new Literal(null, {
  [IdentifierAnnotationId]: "null"
});

/**
 * @category model
 * @since 1.0.0
 */
class UniqueSymbol {
  symbol;
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "UniqueSymbol";
  constructor(symbol, annotations = {}) {
    this.symbol = symbol;
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this, verbose), () => _internal_util_js__WEBPACK_IMPORTED_MODULE_2__/* .formatUnknown */ .cT(this.symbol));
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      symbol: String(this.symbol),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 1.0.0
 */
const isUniqueSymbol = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("UniqueSymbol")));
/**
 * @category model
 * @since 1.0.0
 */
class UndefinedKeyword {
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "UndefinedKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return formatKeyword(this, verbose);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const undefinedKeyword = /*#__PURE__*/new UndefinedKeyword({
  [TitleAnnotationId]: "undefined"
});
/**
 * @category guards
 * @since 1.0.0
 */
const isUndefinedKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("UndefinedKeyword")));
/**
 * @category model
 * @since 1.0.0
 */
class VoidKeyword {
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "VoidKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return formatKeyword(this, verbose);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const voidKeyword = /*#__PURE__*/new VoidKeyword({
  [TitleAnnotationId]: "void"
});
/**
 * @category guards
 * @since 1.0.0
 */
const isVoidKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("VoidKeyword")));
/**
 * @category model
 * @since 1.0.0
 */
class NeverKeyword {
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "NeverKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return formatKeyword(this, verbose);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const neverKeyword = /*#__PURE__*/new NeverKeyword({
  [TitleAnnotationId]: "never"
});
/**
 * @category guards
 * @since 1.0.0
 */
const isNeverKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("NeverKeyword")));
/**
 * @category model
 * @since 1.0.0
 */
class UnknownKeyword {
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "UnknownKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return formatKeyword(this, verbose);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const unknownKeyword = /*#__PURE__*/new UnknownKeyword({
  [TitleAnnotationId]: "unknown"
});
/**
 * @category guards
 * @since 1.0.0
 */
const isUnknownKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("UnknownKeyword")));
/**
 * @category model
 * @since 1.0.0
 */
class AnyKeyword {
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "AnyKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return formatKeyword(this, verbose);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const anyKeyword = /*#__PURE__*/new AnyKeyword({
  [TitleAnnotationId]: "any"
});
/**
 * @category guards
 * @since 1.0.0
 */
const isAnyKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("AnyKeyword")));
/**
 * @category model
 * @since 1.0.0
 */
class StringKeyword {
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "StringKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return formatKeyword(this, verbose);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const stringKeyword = /*#__PURE__*/new StringKeyword({
  [TitleAnnotationId]: "string",
  [DescriptionAnnotationId]: "a string"
});
/**
 * @category guards
 * @since 1.0.0
 */
const isStringKeyword = /*#__PURE__*/createASTGuard("StringKeyword");
/**
 * @category model
 * @since 1.0.0
 */
class NumberKeyword {
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "NumberKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return formatKeyword(this, verbose);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const numberKeyword = /*#__PURE__*/new NumberKeyword({
  [TitleAnnotationId]: "number",
  [DescriptionAnnotationId]: "a number"
});
/**
 * @category guards
 * @since 1.0.0
 */
const isNumberKeyword = /*#__PURE__*/createASTGuard("NumberKeyword");
/**
 * @category model
 * @since 1.0.0
 */
class BooleanKeyword {
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "BooleanKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return formatKeyword(this, verbose);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const booleanKeyword = /*#__PURE__*/new BooleanKeyword({
  [TitleAnnotationId]: "boolean",
  [DescriptionAnnotationId]: "a boolean"
});
/**
 * @category guards
 * @since 1.0.0
 */
const isBooleanKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("BooleanKeyword")));
/**
 * @category model
 * @since 1.0.0
 */
class BigIntKeyword {
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "BigIntKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return formatKeyword(this, verbose);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const bigIntKeyword = /*#__PURE__*/new BigIntKeyword({
  [TitleAnnotationId]: "bigint",
  [DescriptionAnnotationId]: "a bigint"
});
/**
 * @category guards
 * @since 1.0.0
 */
const isBigIntKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("BigIntKeyword")));
/**
 * @category model
 * @since 1.0.0
 */
class SymbolKeyword {
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "SymbolKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return formatKeyword(this, verbose);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const symbolKeyword = /*#__PURE__*/new SymbolKeyword({
  [TitleAnnotationId]: "symbol",
  [DescriptionAnnotationId]: "a symbol"
});
/**
 * @category guards
 * @since 1.0.0
 */
const isSymbolKeyword = /*#__PURE__*/createASTGuard("SymbolKeyword");
/**
 * @category model
 * @since 1.0.0
 */
class ObjectKeyword {
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "ObjectKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return formatKeyword(this, verbose);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const objectKeyword = /*#__PURE__*/new ObjectKeyword({
  [IdentifierAnnotationId]: "object",
  [TitleAnnotationId]: "object",
  [DescriptionAnnotationId]: "an object in the TypeScript meaning, i.e. the `object` type"
});
/**
 * @category guards
 * @since 1.0.0
 */
const isObjectKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("ObjectKeyword")));
/**
 * @category model
 * @since 1.0.0
 */
class Enums {
  enums;
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "Enums";
  constructor(enums, annotations = {}) {
    this.enums = enums;
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return Option.getOrElse(getExpected(this, verbose), () => `<enum ${this.enums.length} value(s): ${this.enums.map((_, value) => JSON.stringify(value)).join(" | ")}>`);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      enums: this.enums,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 1.0.0
 */
const isEnums = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("Enums")));
/**
 * @category model
 * @since 1.0.0
 */
class TemplateLiteralSpan {
  type;
  literal;
  constructor(type, literal) {
    this.type = type;
    this.literal = literal;
  }
  /**
   * @since 1.0.0
   */
  toString() {
    switch (this.type._tag) {
      case "StringKeyword":
        return "${string}";
      case "NumberKeyword":
        return "${number}";
    }
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      type: this.type.toJSON(),
      literal: this.literal
    };
  }
}
/**
 * @category model
 * @since 1.0.0
 */
class TemplateLiteral {
  head;
  spans;
  annotations;
  static make = (/* unused pure expression or super */ null && ((head, spans, annotations = {}) => Arr.isNonEmptyReadonlyArray(spans) ? new TemplateLiteral(head, spans, annotations) : new Literal(head)));
  /**
   * @since 1.0.0
   */
  _tag = "TemplateLiteral";
  constructor(head, spans, annotations = {}) {
    this.head = head;
    this.spans = spans;
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return Option.getOrElse(getExpected(this, verbose), () => formatTemplateLiteral(this));
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      head: this.head,
      spans: this.spans.map(span => span.toJSON()),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
const formatTemplateLiteral = ast => "`" + ast.head + ast.spans.map(span => String(span) + span.literal).join("") + "`";
/**
 * @category guards
 * @since 1.0.0
 */
const isTemplateLiteral = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("TemplateLiteral")));
/**
 * @category model
 * @since 1.0.0
 */
class Element {
  type;
  isOptional;
  constructor(type, isOptional) {
    this.type = type;
    this.isOptional = isOptional;
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      type: this.type.toJSON(),
      isOptional: this.isOptional
    };
  }
  /**
   * @since 1.0.0
   */
  toString() {
    return String(this.type) + (this.isOptional ? "?" : "");
  }
}
/**
 * @category model
 * @since 1.0.0
 */
class TupleType {
  elements;
  rest;
  isReadonly;
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "TupleType";
  constructor(elements, rest, isReadonly, annotations = {}) {
    this.elements = elements;
    this.rest = rest;
    this.isReadonly = isReadonly;
    this.annotations = annotations;
    let hasOptionalElement = false;
    let hasIllegalRequiredElement = false;
    for (const e of elements) {
      if (e.isOptional) {
        hasOptionalElement = true;
      } else if (hasOptionalElement) {
        hasIllegalRequiredElement = true;
        break;
      }
    }
    if (hasIllegalRequiredElement || hasOptionalElement && rest.length > 1) {
      throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getRequiredElementFollowinAnOptionalElementErrorMessage */ .Dm);
    }
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this, verbose), () => formatTuple(this));
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      elements: this.elements.map(e => e.toJSON()),
      rest: this.rest.map(ast => ast.toJSON()),
      isReadonly: this.isReadonly,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
const formatTuple = ast => {
  const formattedElements = ast.elements.map(String).join(", ");
  return effect_Array__WEBPACK_IMPORTED_MODULE_5__/* .matchLeft */ .aL(ast.rest, {
    onEmpty: () => `readonly [${formattedElements}]`,
    onNonEmpty: (head, tail) => {
      const formattedHead = String(head);
      const wrappedHead = formattedHead.includes(" | ") ? `(${formattedHead})` : formattedHead;
      if (tail.length > 0) {
        const formattedTail = tail.map(String).join(", ");
        if (ast.elements.length > 0) {
          return `readonly [${formattedElements}, ...${wrappedHead}[], ${formattedTail}]`;
        } else {
          return `readonly [...${wrappedHead}[], ${formattedTail}]`;
        }
      } else {
        if (ast.elements.length > 0) {
          return `readonly [${formattedElements}, ...${wrappedHead}[]]`;
        } else {
          return `ReadonlyArray<${formattedHead}>`;
        }
      }
    }
  });
};
/**
 * @category guards
 * @since 1.0.0
 */
const isTupleType = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("TupleType")));
/**
 * @category model
 * @since 1.0.0
 */
class PropertySignature {
  name;
  type;
  isOptional;
  isReadonly;
  annotations;
  constructor(name, type, isOptional, isReadonly, annotations = {}) {
    this.name = name;
    this.type = type;
    this.isOptional = isOptional;
    this.isReadonly = isReadonly;
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      name: String(this.name),
      type: this.type.toJSON(),
      isOptional: this.isOptional,
      isReadonly: this.isReadonly,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @since 1.0.0
 */
const isParameter = ast => {
  switch (ast._tag) {
    case "StringKeyword":
    case "SymbolKeyword":
    case "TemplateLiteral":
      return true;
    case "Refinement":
      return isParameter(ast.from);
  }
  return false;
};
/**
 * @category model
 * @since 1.0.0
 */
class IndexSignature {
  type;
  isReadonly;
  /**
   * @since 1.0.0
   */
  parameter;
  constructor(parameter, type, isReadonly) {
    this.type = type;
    this.isReadonly = isReadonly;
    if (isParameter(parameter)) {
      this.parameter = parameter;
    } else {
      throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getIndexSignatureParameterErrorMessage */ .n8);
    }
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      parameter: this.parameter.toJSON(),
      type: this.type.toJSON(),
      isReadonly: this.isReadonly
    };
  }
}
/**
 * @category model
 * @since 1.0.0
 */
class TypeLiteral {
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "TypeLiteral";
  /**
   * @since 1.0.0
   */
  propertySignatures;
  /**
   * @since 1.0.0
   */
  indexSignatures;
  constructor(propertySignatures, indexSignatures, annotations = {}) {
    this.annotations = annotations;
    // check for duplicate property signatures
    const keys = {};
    for (let i = 0; i < propertySignatures.length; i++) {
      const name = propertySignatures[i].name;
      if (Object.prototype.hasOwnProperty.call(keys, name)) {
        throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getDuplicatePropertySignatureErrorMessage */ .cX(name));
      }
      keys[name] = null;
    }
    // check for duplicate index signatures
    const parameters = {
      string: false,
      symbol: false
    };
    for (let i = 0; i < indexSignatures.length; i++) {
      const parameter = getParameterBase(indexSignatures[i].parameter);
      if (isStringKeyword(parameter)) {
        if (parameters.string) {
          throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getDuplicateIndexSignatureErrorMessage */ .A9("string"));
        }
        parameters.string = true;
      } else if (isSymbolKeyword(parameter)) {
        if (parameters.symbol) {
          throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getDuplicateIndexSignatureErrorMessage */ .A9("symbol"));
        }
        parameters.symbol = true;
      }
    }
    this.propertySignatures = sortPropertySignatures(propertySignatures);
    this.indexSignatures = sortIndexSignatures(indexSignatures);
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this, verbose), () => formatTypeLiteral(this));
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      propertySignatures: this.propertySignatures.map(ps => ps.toJSON()),
      indexSignatures: this.indexSignatures.map(ps => ps.toJSON()),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
const formatTypeLiteral = ast => {
  const formattedPropertySignatures = ast.propertySignatures.map(ps => String(ps.name) + (ps.isOptional ? "?" : "") + ": " + ps.type).join("; ");
  if (ast.indexSignatures.length > 0) {
    const formattedIndexSignatures = ast.indexSignatures.map(is => `[x: ${getParameterBase(is.parameter)}]: ${is.type}`).join("; ");
    if (ast.propertySignatures.length > 0) {
      return `{ ${formattedPropertySignatures}; ${formattedIndexSignatures} }`;
    } else {
      return `{ ${formattedIndexSignatures} }`;
    }
  } else {
    if (ast.propertySignatures.length > 0) {
      return `{ ${formattedPropertySignatures} }`;
    } else {
      return "{}";
    }
  }
};
/**
 * @category guards
 * @since 1.0.0
 */
const isTypeLiteral = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("TypeLiteral")));
const removeNevers = candidates => candidates.filter(ast => !(ast === neverKeyword));
const sortCandidates = /*#__PURE__*/effect_Array__WEBPACK_IMPORTED_MODULE_5__/* .sort */ .wx( /*#__PURE__*/effect_Order__WEBPACK_IMPORTED_MODULE_6__/* .mapInput */ .$H(effect_Number__WEBPACK_IMPORTED_MODULE_7__/* .Order */ .KM, ast => {
  switch (ast._tag) {
    case "AnyKeyword":
      return 0;
    case "UnknownKeyword":
      return 1;
    case "ObjectKeyword":
      return 2;
    case "StringKeyword":
    case "NumberKeyword":
    case "BooleanKeyword":
    case "BigIntKeyword":
    case "SymbolKeyword":
      return 3;
  }
  return 4;
}));
const literalMap = {
  string: "StringKeyword",
  number: "NumberKeyword",
  boolean: "BooleanKeyword",
  bigint: "BigIntKeyword"
};
/** @internal */
const flatten = candidates => effect_Array__WEBPACK_IMPORTED_MODULE_5__/* .flatMap */ .VS(candidates, ast => isUnion(ast) ? flatten(ast.types) : [ast]);
/** @internal */
const unify = candidates => {
  const cs = sortCandidates(candidates);
  const out = [];
  const uniques = {};
  const literals = [];
  for (const ast of cs) {
    switch (ast._tag) {
      case "NeverKeyword":
        break;
      case "AnyKeyword":
        return [anyKeyword];
      case "UnknownKeyword":
        return [unknownKeyword];
      // uniques
      case "ObjectKeyword":
      case "UndefinedKeyword":
      case "VoidKeyword":
      case "StringKeyword":
      case "NumberKeyword":
      case "BooleanKeyword":
      case "BigIntKeyword":
      case "SymbolKeyword":
        {
          if (!uniques[ast._tag]) {
            uniques[ast._tag] = ast;
            out.push(ast);
          }
          break;
        }
      case "Literal":
        {
          const type = typeof ast.literal;
          switch (type) {
            case "string":
            case "number":
            case "bigint":
            case "boolean":
              {
                const _tag = literalMap[type];
                if (!uniques[_tag] && !literals.includes(ast.literal)) {
                  literals.push(ast.literal);
                  out.push(ast);
                }
                break;
              }
            // null
            case "object":
              {
                if (!literals.includes(ast.literal)) {
                  literals.push(ast.literal);
                  out.push(ast);
                }
                break;
              }
          }
          break;
        }
      case "UniqueSymbol":
        {
          if (!uniques["SymbolKeyword"] && !literals.includes(ast.symbol)) {
            literals.push(ast.symbol);
            out.push(ast);
          }
          break;
        }
      case "TupleType":
        {
          if (!uniques["ObjectKeyword"]) {
            out.push(ast);
          }
          break;
        }
      case "TypeLiteral":
        {
          if (ast.propertySignatures.length === 0 && ast.indexSignatures.length === 0) {
            if (!uniques["{}"]) {
              uniques["{}"] = ast;
              out.push(ast);
            }
          } else if (!uniques["ObjectKeyword"]) {
            out.push(ast);
          }
          break;
        }
      default:
        out.push(ast);
    }
  }
  return out;
};
/**
 * @category model
 * @since 1.0.0
 */
class Union {
  types;
  annotations;
  static make = (candidates, annotations) => {
    const types = [];
    const memo = new Set();
    for (let i = 0; i < candidates.length; i++) {
      const ast = candidates[i];
      if (ast === neverKeyword || memo.has(ast)) {
        continue;
      }
      memo.add(ast);
      types.push(ast);
    }
    return Union.union(types, annotations);
  };
  /** @internal */
  static members = (candidates, annotations) => {
    return Union.union(removeNevers(candidates), annotations);
  };
  /** @internal */
  static unify = (candidates, annotations) => {
    return Union.union(unify(flatten(candidates)), annotations);
  };
  /** @internal */
  static union = (types, annotations) => {
    return isMembers(types) ? new Union(types, annotations) : types.length === 1 ? types[0] : neverKeyword;
  };
  /**
   * @since 1.0.0
   */
  _tag = "Union";
  constructor(types, annotations = {}) {
    this.types = types;
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this, verbose), () => this.types.map(String).join(" | "));
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      types: this.types.map(ast => ast.toJSON()),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/** @internal */
const mapMembers = (members, f) => members.map(f);
/** @internal */
const isMembers = as => as.length > 1;
/**
 * @category guards
 * @since 1.0.0
 */
const isUnion = /*#__PURE__*/createASTGuard("Union");
const toJSONMemoMap = /*#__PURE__*/(0,effect_GlobalValue__WEBPACK_IMPORTED_MODULE_8__/* .globalValue */ .K)( /*#__PURE__*/Symbol.for("@effect/schema/AST/toJSONMemoMap"), () => new WeakMap());
/**
 * @category model
 * @since 1.0.0
 */
class Suspend {
  f;
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "Suspend";
  constructor(f, annotations = {}) {
    this.f = f;
    this.annotations = annotations;
    this.f = _internal_util_js__WEBPACK_IMPORTED_MODULE_2__/* .memoizeThunk */ .d3(f);
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return getExpected(this, verbose).pipe(effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .orElse */ .vx(() => effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VS(effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .liftThrowable */ .eZ(this.f)(), ast => getExpected(ast, verbose))), effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(() => "<suspended schema>"));
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    const ast = this.f();
    let out = toJSONMemoMap.get(ast);
    if (out) {
      return out;
    }
    toJSONMemoMap.set(ast, {
      _tag: this._tag
    });
    out = {
      _tag: this._tag,
      ast: ast.toJSON(),
      annotations: toJSONAnnotations(this.annotations)
    };
    toJSONMemoMap.set(ast, out);
    return out;
  }
}
/**
 * @category guards
 * @since 1.0.0
 */
const isSuspend = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("Suspend")));
/**
 * @category model
 * @since 1.0.0
 */
class Refinement {
  from;
  filter;
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "Refinement";
  constructor(from, filter, annotations = {}) {
    this.from = from;
    this.filter = filter;
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this, verbose), () => "<refinement schema>");
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      from: this.from.toJSON(),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 1.0.0
 */
const isRefinement = /*#__PURE__*/createASTGuard("Refinement");
/**
 * @since 1.0.0
 */
const defaultParseOption = {};
/**
 * @category model
 * @since 1.0.0
 */
class Transformation {
  from;
  to;
  transformation;
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "Transformation";
  constructor(from, to, transformation, annotations = {}) {
    this.from = from;
    this.to = to;
    this.transformation = transformation;
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString(verbose = false) {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this, verbose), () => `(${String(this.from)} <-> ${String(this.to)})`);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      from: this.from.toJSON(),
      to: this.to.toJSON(),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 1.0.0
 */
const isTransformation = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("Transformation")));
/**
 * @category model
 * @since 1.0.0
 */
class FinalTransformation {
  decode;
  encode;
  /**
   * @since 1.0.0
   */
  _tag = "FinalTransformation";
  constructor(decode, encode) {
    this.decode = decode;
    this.encode = encode;
  }
}
const createTransformationGuard = tag => ast => ast._tag === tag;
/**
 * @category guards
 * @since 1.0.0
 */
const isFinalTransformation = /*#__PURE__*/(/* unused pure expression or super */ null && (createTransformationGuard("FinalTransformation")));
/**
 * @category model
 * @since 1.0.0
 */
class ComposeTransformation {
  /**
   * @since 1.0.0
   */
  _tag = "ComposeTransformation";
}
/**
 * @category constructors
 * @since 1.0.0
 */
const composeTransformation = /*#__PURE__*/new ComposeTransformation();
/**
 * @category guards
 * @since 1.0.0
 */
const isComposeTransformation = /*#__PURE__*/(/* unused pure expression or super */ null && (createTransformationGuard("ComposeTransformation")));
/**
 * Represents a `PropertySignature -> PropertySignature` transformation
 *
 * The semantic of `decode` is:
 * - `none()` represents the absence of the key/value pair
 * - `some(value)` represents the presence of the key/value pair
 *
 * The semantic of `encode` is:
 * - `none()` you don't want to output the key/value pair
 * - `some(value)` you want to output the key/value pair
 *
 * @category model
 * @since 1.0.0
 */
class PropertySignatureTransformation {
  from;
  to;
  decode;
  encode;
  constructor(from, to, decode, encode) {
    this.from = from;
    this.to = to;
    this.decode = decode;
    this.encode = encode;
  }
}
const isRenamingPropertySignatureTransformation = t => t.decode === identity && t.encode === identity;
/**
 * @category model
 * @since 1.0.0
 */
class TypeLiteralTransformation {
  propertySignatureTransformations;
  /**
   * @since 1.0.0
   */
  _tag = "TypeLiteralTransformation";
  constructor(propertySignatureTransformations) {
    this.propertySignatureTransformations = propertySignatureTransformations;
    // check for duplicate property signature transformations
    const fromKeys = {};
    const toKeys = {};
    for (const pst of propertySignatureTransformations) {
      const from = pst.from;
      if (fromKeys[from]) {
        throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getDuplicatePropertySignatureTransformationErrorMessage */ .Mg(from));
      }
      fromKeys[from] = true;
      const to = pst.to;
      if (toKeys[to]) {
        throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getDuplicatePropertySignatureTransformationErrorMessage */ .Mg(to));
      }
      toKeys[to] = true;
    }
  }
}
/**
 * @category guards
 * @since 1.0.0
 */
const isTypeLiteralTransformation = /*#__PURE__*/(/* unused pure expression or super */ null && (createTransformationGuard("TypeLiteralTransformation")));
// -------------------------------------------------------------------------------------
// API
// -------------------------------------------------------------------------------------
/**
 * Adds a group of annotations, potentially overwriting existing annotations.
 *
 * @since 1.0.0
 */
const annotations = (ast, annotations) => {
  const d = Object.getOwnPropertyDescriptors(ast);
  d.annotations.value = {
    ...ast.annotations,
    ...annotations
  };
  return Object.create(Object.getPrototypeOf(ast), d);
};
/**
 * Equivalent at runtime to the TypeScript type-level `keyof` operator.
 *
 * @since 1.0.0
 */
const keyof = ast => Union.unify(_keyof(ast));
const STRING_KEYWORD_PATTERN = ".*";
const NUMBER_KEYWORD_PATTERN = "[+-]?\\d*\\.?\\d+(?:[Ee][+-]?\\d+)?";
/**
 * @since 1.0.0
 */
const getTemplateLiteralRegExp = ast => {
  let pattern = `^${effect_RegExp__WEBPACK_IMPORTED_MODULE_9__/* .escape */ .Y(ast.head)}`;
  for (const span of ast.spans) {
    if (isStringKeyword(span.type)) {
      pattern += STRING_KEYWORD_PATTERN;
    } else if (isNumberKeyword(span.type)) {
      pattern += NUMBER_KEYWORD_PATTERN;
    }
    pattern += effect_RegExp__WEBPACK_IMPORTED_MODULE_9__/* .escape */ .Y(span.literal);
  }
  pattern += "$";
  return new RegExp(pattern);
};
/**
 * @since 1.0.0
 */
const getPropertySignatures = ast => {
  switch (ast._tag) {
    case "Declaration":
      {
        const annotation = getSurrogateAnnotation(ast);
        if (Option.isSome(annotation)) {
          return getPropertySignatures(annotation.value);
        }
        break;
      }
    case "TypeLiteral":
      return ast.propertySignatures.slice();
    case "Suspend":
      return getPropertySignatures(ast.f());
  }
  return getPropertyKeys(ast).map(name => getPropertyKeyIndexedAccess(ast, name));
};
/** @internal */
const getNumberIndexedAccess = ast => {
  switch (ast._tag) {
    case "TupleType":
      {
        let hasOptional = false;
        let out = [];
        for (const e of ast.elements) {
          if (e.isOptional) {
            hasOptional = true;
          }
          out.push(e.type);
        }
        if (hasOptional) {
          out.push(undefinedKeyword);
        }
        out = out.concat(ast.rest);
        return Union.make(out);
      }
    case "Refinement":
      return getNumberIndexedAccess(ast.from);
    case "Union":
      return Union.make(ast.types.map(getNumberIndexedAccess));
    case "Suspend":
      return getNumberIndexedAccess(ast.f());
  }
  throw new Error(errors_.getAPIErrorMessage("NumberIndexedAccess", `unsupported schema (${ast})`));
};
/** @internal */
const getPropertyKeyIndexedAccess = (ast, name) => {
  switch (ast._tag) {
    case "Declaration":
      {
        const annotation = getSurrogateAnnotation(ast);
        if (Option.isSome(annotation)) {
          return getPropertyKeyIndexedAccess(annotation.value, name);
        }
        break;
      }
    case "TypeLiteral":
      {
        const ops = Arr.findFirst(ast.propertySignatures, ps => ps.name === name);
        if (Option.isSome(ops)) {
          return ops.value;
        } else {
          if (Predicate.isString(name)) {
            for (const is of ast.indexSignatures) {
              const parameterBase = getParameterBase(is.parameter);
              switch (parameterBase._tag) {
                case "TemplateLiteral":
                  {
                    const regex = getTemplateLiteralRegExp(parameterBase);
                    if (regex.test(name)) {
                      return new PropertySignature(name, is.type, false, false);
                    }
                    break;
                  }
                case "StringKeyword":
                  return new PropertySignature(name, is.type, false, false);
              }
            }
          } else if (Predicate.isSymbol(name)) {
            for (const is of ast.indexSignatures) {
              const parameterBase = getParameterBase(is.parameter);
              if (isSymbolKeyword(parameterBase)) {
                return new PropertySignature(name, is.type, false, false);
              }
            }
          }
        }
        break;
      }
    case "Union":
      return new PropertySignature(name, Union.make(ast.types.map(ast => getPropertyKeyIndexedAccess(ast, name).type)), false, true);
    case "Suspend":
      return getPropertyKeyIndexedAccess(ast.f(), name);
  }
  return new PropertySignature(name, neverKeyword, false, true);
};
const getPropertyKeys = ast => {
  switch (ast._tag) {
    case "Declaration":
      {
        const annotation = getSurrogateAnnotation(ast);
        if (Option.isSome(annotation)) {
          return getPropertyKeys(annotation.value);
        }
        break;
      }
    case "TypeLiteral":
      return ast.propertySignatures.map(ps => ps.name);
    case "Suspend":
      return getPropertyKeys(ast.f());
    case "Union":
      return ast.types.slice(1).reduce((out, ast) => Arr.intersection(out, getPropertyKeys(ast)), getPropertyKeys(ast.types[0]));
    case "Transformation":
      return getPropertyKeys(ast.to);
  }
  return [];
};
/** @internal */
const record = (key, value) => {
  const propertySignatures = [];
  const indexSignatures = [];
  const go = key => {
    switch (key._tag) {
      case "NeverKeyword":
        break;
      case "StringKeyword":
      case "SymbolKeyword":
      case "TemplateLiteral":
      case "Refinement":
        indexSignatures.push(new IndexSignature(key, value, true));
        break;
      case "Literal":
        if (effect_Predicate__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD(key.literal) || effect_Predicate__WEBPACK_IMPORTED_MODULE_3__/* .isNumber */ .hj(key.literal)) {
          propertySignatures.push(new PropertySignature(key.literal, value, false, true));
        } else {
          throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getAPIErrorMessage */ .l4("Record", `unsupported literal (${_internal_util_js__WEBPACK_IMPORTED_MODULE_2__/* .formatUnknown */ .cT(key.literal)})`));
        }
        break;
      case "UniqueSymbol":
        propertySignatures.push(new PropertySignature(key.symbol, value, false, true));
        break;
      case "Union":
        key.types.forEach(go);
        break;
      default:
        throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getAPIErrorMessage */ .l4("Record", `unsupported key schema (${key})`));
    }
  };
  go(key);
  return {
    propertySignatures,
    indexSignatures
  };
};
/**
 * Equivalent at runtime to the built-in TypeScript utility type `Pick`.
 *
 * @since 1.0.0
 */
const pick = (ast, keys) => {
  if (isTransformation(ast)) {
    switch (ast.transformation._tag) {
      case "ComposeTransformation":
        return new Transformation(pick(ast.from, keys), pick(ast.to, keys), composeTransformation);
      case "TypeLiteralTransformation":
        {
          const ts = [];
          const fromKeys = [];
          for (const k of keys) {
            const t = ast.transformation.propertySignatureTransformations.find(t => t.to === k);
            if (t) {
              ts.push(t);
              fromKeys.push(t.from);
            } else {
              fromKeys.push(k);
            }
          }
          return new Transformation(pick(ast.from, fromKeys), pick(ast.to, keys), Arr.isNonEmptyReadonlyArray(ts) ? new TypeLiteralTransformation(ts) : composeTransformation);
        }
      case "FinalTransformation":
        {
          const annotation = getSurrogateAnnotation(ast);
          if (Option.isSome(annotation)) {
            return pick(annotation.value, keys);
          }
          throw new Error(errors_.getAPIErrorMessage("Pick", "cannot handle this kind of transformation"));
        }
    }
  }
  return new TypeLiteral(keys.map(key => getPropertyKeyIndexedAccess(ast, key)), []);
};
/**
 * Equivalent at runtime to the built-in TypeScript utility type `Omit`.
 *
 * @since 1.0.0
 */
const omit = (ast, keys) => pick(ast, getPropertyKeys(ast).filter(name => !keys.includes(name)));
/** @internal */
const orUndefined = ast => Union.make([ast, undefinedKeyword]);
/**
 * Equivalent at runtime to the built-in TypeScript utility type `Partial`.
 *
 * @since 1.0.0
 */
const partial = (ast, options) => {
  const exact = options?.exact === true;
  switch (ast._tag) {
    case "TupleType":
      return new TupleType(ast.elements.map(e => new Element(exact ? e.type : orUndefined(e.type), true)), Arr.match(ast.rest, {
        onEmpty: () => ast.rest,
        onNonEmpty: rest => [Union.make([...rest, undefinedKeyword])]
      }), ast.isReadonly);
    case "TypeLiteral":
      return new TypeLiteral(ast.propertySignatures.map(ps => new PropertySignature(ps.name, exact ? ps.type : orUndefined(ps.type), true, ps.isReadonly, ps.annotations)), ast.indexSignatures.map(is => new IndexSignature(is.parameter, orUndefined(is.type), is.isReadonly)));
    case "Union":
      return Union.make(ast.types.map(member => partial(member, options)));
    case "Suspend":
      return new Suspend(() => partial(ast.f(), options));
    case "Declaration":
      throw new Error(errors_.getAPIErrorMessage("partial", "cannot handle declarations"));
    case "Refinement":
      throw new Error(errors_.getAPIErrorMessage("partial", "cannot handle refinements"));
    case "Transformation":
      {
        if (isTypeLiteralTransformation(ast.transformation) && ast.transformation.propertySignatureTransformations.every(isRenamingPropertySignatureTransformation)) {
          return new Transformation(partial(ast.from, options), partial(ast.to, options), ast.transformation);
        }
        throw new Error(errors_.getAPIErrorMessage("partial", "cannot handle transformations"));
      }
  }
  return ast;
};
/**
 * Equivalent at runtime to the built-in TypeScript utility type `Required`.
 *
 * @since 1.0.0
 */
const required = ast => {
  switch (ast._tag) {
    case "TupleType":
      return new TupleType(ast.elements.map(e => new Element(e.type, false)), ast.rest, ast.isReadonly);
    case "TypeLiteral":
      return new TypeLiteral(ast.propertySignatures.map(f => new PropertySignature(f.name, f.type, false, f.isReadonly, f.annotations)), ast.indexSignatures);
    case "Union":
      return Union.make(ast.types.map(member => required(member)));
    case "Suspend":
      return new Suspend(() => required(ast.f()));
    case "Declaration":
      throw new Error(errors_.getAPIErrorMessage("required", "cannot handle declarations"));
    case "Refinement":
      throw new Error(errors_.getAPIErrorMessage("required", "cannot handle refinements"));
    case "Transformation":
      {
        if (isTypeLiteralTransformation(ast.transformation) && ast.transformation.propertySignatureTransformations.every(isRenamingPropertySignatureTransformation)) {
          return new Transformation(required(ast.from), required(ast.to), ast.transformation);
        }
        throw new Error(errors_.getAPIErrorMessage("required", "cannot handle transformations"));
      }
  }
  return ast;
};
/**
 * Creates a new AST with shallow mutability applied to its properties.
 *
 * @param ast - The original AST to make properties mutable (shallowly).
 *
 * @since 1.0.0
 */
const mutable = ast => {
  switch (ast._tag) {
    case "TupleType":
      return ast.isReadonly === false ? ast : new TupleType(ast.elements, ast.rest, false, ast.annotations);
    case "TypeLiteral":
      {
        const propertySignatures = changeMap(ast.propertySignatures, ps => ps.isReadonly === false ? ps : new PropertySignature(ps.name, ps.type, ps.isOptional, false, ps.annotations));
        const indexSignatures = changeMap(ast.indexSignatures, is => is.isReadonly === false ? is : new IndexSignature(is.parameter, is.type, false));
        return propertySignatures === ast.propertySignatures && indexSignatures === ast.indexSignatures ? ast : new TypeLiteral(propertySignatures, indexSignatures, ast.annotations);
      }
    case "Union":
      {
        const types = changeMap(ast.types, mutable);
        return types === ast.types ? ast : Union.make(types, ast.annotations);
      }
    case "Suspend":
      return new Suspend(() => mutable(ast.f()), ast.annotations);
    case "Refinement":
      {
        const from = mutable(ast.from);
        return from === ast.from ? ast : new Refinement(from, ast.filter, ast.annotations);
      }
    case "Transformation":
      {
        const from = mutable(ast.from);
        const to = mutable(ast.to);
        return from === ast.from && to === ast.to ? ast : new Transformation(from, to, ast.transformation, ast.annotations);
      }
  }
  return ast;
};
/**
 * @since 1.0.0
 */
const getCompiler = match => {
  const compile = ast => match[ast._tag](ast, compile);
  return compile;
};
/** @internal */
const getToPropertySignatures = ps => ps.map(p => new PropertySignature(p.name, typeAST(p.type), p.isOptional, p.isReadonly, p.annotations));
/** @internal */
const getToIndexSignatures = ps => ps.map(is => new IndexSignature(is.parameter, typeAST(is.type), is.isReadonly));
/**
 * @since 1.0.0
 */
const typeAST = ast => {
  switch (ast._tag) {
    case "Declaration":
      {
        const typeParameters = changeMap(ast.typeParameters, typeAST);
        return typeParameters === ast.typeParameters ? ast : new Declaration(typeParameters, ast.decodeUnknown, ast.encodeUnknown, ast.annotations);
      }
    case "TupleType":
      {
        const elements = changeMap(ast.elements, e => {
          const type = typeAST(e.type);
          return type === e.type ? e : new Element(type, e.isOptional);
        });
        const rest = changeMap(ast.rest, typeAST);
        return elements === ast.elements && rest === ast.rest ? ast : new TupleType(elements, rest, ast.isReadonly, ast.annotations);
      }
    case "TypeLiteral":
      {
        const propertySignatures = changeMap(ast.propertySignatures, p => {
          const type = typeAST(p.type);
          return type === p.type ? p : new PropertySignature(p.name, type, p.isOptional, p.isReadonly);
        });
        const indexSignatures = changeMap(ast.indexSignatures, is => {
          const type = typeAST(is.type);
          return type === is.type ? is : new IndexSignature(is.parameter, type, is.isReadonly);
        });
        return propertySignatures === ast.propertySignatures && indexSignatures === ast.indexSignatures ? ast : new TypeLiteral(propertySignatures, indexSignatures, ast.annotations);
      }
    case "Union":
      {
        const types = changeMap(ast.types, typeAST);
        return types === ast.types ? ast : Union.make(types, ast.annotations);
      }
    case "Suspend":
      return new Suspend(() => typeAST(ast.f()), ast.annotations);
    case "Refinement":
      {
        const from = typeAST(ast.from);
        return from === ast.from ? ast : new Refinement(from, ast.filter, ast.annotations);
      }
    case "Transformation":
      return typeAST(ast.to);
  }
  return ast;
};
/** @internal */
const getJSONIdentifier = annotated => effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .orElse */ .vx(getJSONIdentifierAnnotation(annotated), () => getIdentifierAnnotation(annotated));
const createJSONIdentifierAnnotation = annotated => effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .match */ .EQ(getJSONIdentifier(annotated), {
  onNone: () => undefined,
  onSome: identifier => ({
    [JSONIdentifierAnnotationId]: identifier
  })
});
function changeMap(as, f) {
  let changed = false;
  const out = effect_Array__WEBPACK_IMPORTED_MODULE_5__/* .allocate */ .TK(as.length);
  for (let i = 0; i < as.length; i++) {
    const a = as[i];
    const fa = f(a);
    if (fa !== a) {
      changed = true;
    }
    out[i] = fa;
  }
  return changed ? out : as;
}
/**
 * @since 1.0.0
 */
const encodedAST = ast => {
  switch (ast._tag) {
    case "Declaration":
      {
        const typeParameters = changeMap(ast.typeParameters, encodedAST);
        return typeParameters === ast.typeParameters ? ast : new Declaration(typeParameters, ast.decodeUnknown, ast.encodeUnknown, ast.annotations);
      }
    case "TupleType":
      {
        const elements = changeMap(ast.elements, e => {
          const type = encodedAST(e.type);
          return type === e.type ? e : new Element(type, e.isOptional);
        });
        const rest = changeMap(ast.rest, encodedAST);
        return elements === ast.elements && rest === ast.rest ? ast : new TupleType(elements, rest, ast.isReadonly, createJSONIdentifierAnnotation(ast));
      }
    case "TypeLiteral":
      {
        const propertySignatures = changeMap(ast.propertySignatures, ps => {
          const type = encodedAST(ps.type);
          return type === ps.type ? ps : new PropertySignature(ps.name, type, ps.isOptional, ps.isReadonly);
        });
        const indexSignatures = changeMap(ast.indexSignatures, is => {
          const type = encodedAST(is.type);
          return type === is.type ? is : new IndexSignature(is.parameter, type, is.isReadonly);
        });
        return propertySignatures === ast.propertySignatures && indexSignatures === ast.indexSignatures ? ast : new TypeLiteral(propertySignatures, indexSignatures, createJSONIdentifierAnnotation(ast));
      }
    case "Union":
      {
        const types = changeMap(ast.types, encodedAST);
        return types === ast.types ? ast : Union.make(types, createJSONIdentifierAnnotation(ast));
      }
    case "Suspend":
      return new Suspend(() => encodedAST(ast.f()), createJSONIdentifierAnnotation(ast));
    case "Refinement":
    case "Transformation":
      return encodedAST(ast.from);
  }
  return ast;
};
const toJSONAnnotations = annotations => {
  const out = {};
  for (const k of Object.getOwnPropertySymbols(annotations)) {
    out[String(k)] = annotations[k];
  }
  return out;
};
/**
 * @since 1.0.0
 */
const hash = ast => Hash.string(JSON.stringify(ast, null, 2));
/** @internal */
const getCardinality = ast => {
  switch (ast._tag) {
    case "NeverKeyword":
      return 0;
    case "Literal":
    case "UndefinedKeyword":
    case "VoidKeyword":
    case "UniqueSymbol":
      return 1;
    case "BooleanKeyword":
      return 2;
    case "StringKeyword":
    case "NumberKeyword":
    case "BigIntKeyword":
    case "SymbolKeyword":
      return 3;
    case "ObjectKeyword":
      return 5;
    case "UnknownKeyword":
    case "AnyKeyword":
      return 6;
    default:
      return 4;
  }
};
const sortPropertySignatures = /*#__PURE__*/effect_Array__WEBPACK_IMPORTED_MODULE_5__/* .sort */ .wx( /*#__PURE__*/effect_Order__WEBPACK_IMPORTED_MODULE_6__/* .mapInput */ .$H(effect_Number__WEBPACK_IMPORTED_MODULE_7__/* .Order */ .KM, ps => getCardinality(ps.type)));
const sortIndexSignatures = /*#__PURE__*/effect_Array__WEBPACK_IMPORTED_MODULE_5__/* .sort */ .wx( /*#__PURE__*/effect_Order__WEBPACK_IMPORTED_MODULE_6__/* .mapInput */ .$H(effect_Number__WEBPACK_IMPORTED_MODULE_7__/* .Order */ .KM, is => {
  switch (getParameterBase(is.parameter)._tag) {
    case "StringKeyword":
      return 2;
    case "SymbolKeyword":
      return 3;
    case "TemplateLiteral":
      return 1;
  }
}));
const WeightOrder = /*#__PURE__*/effect_Order__WEBPACK_IMPORTED_MODULE_6__/* .tuple */ .bc(effect_Number__WEBPACK_IMPORTED_MODULE_7__/* .Order */ .KM, effect_Number__WEBPACK_IMPORTED_MODULE_7__/* .Order */ .KM, effect_Number__WEBPACK_IMPORTED_MODULE_7__/* .Order */ .KM);
const maxWeight = /*#__PURE__*/(/* unused pure expression or super */ null && (Order.max(WeightOrder)));
const emptyWeight = (/* unused pure expression or super */ null && ([0, 0, 0]));
const maxWeightAll = weights => weights.reduce(maxWeight, emptyWeight);
/** @internal */
const getWeight = ast => {
  switch (ast._tag) {
    case "TupleType":
      {
        return [2, ast.elements.length, ast.rest.length];
      }
    case "TypeLiteral":
      {
        const y = ast.propertySignatures.length;
        const z = ast.indexSignatures.length;
        return y + z === 0 ? [-4, 0, 0] : [4, y, z];
      }
    case "Declaration":
      {
        const annotation = getSurrogateAnnotation(ast);
        if (Option.isSome(annotation)) {
          const [_, y, z] = getWeight(annotation.value);
          return [6, y, z];
        }
        return [6, 0, 0];
      }
    case "Suspend":
      return [8, 0, 0];
    case "Union":
      return maxWeightAll(ast.types.map(getWeight));
    case "Refinement":
      {
        const [x, y, z] = getWeight(ast.from);
        return [x + 1, y, z];
      }
    case "Transformation":
      return getWeight(ast.from);
    case "ObjectKeyword":
      return [-2, 0, 0];
    case "UnknownKeyword":
    case "AnyKeyword":
      return [-4, 0, 0];
    default:
      return emptyWeight;
  }
};
/** @internal */
const getParameterBase = ast => {
  switch (ast._tag) {
    case "StringKeyword":
    case "SymbolKeyword":
    case "TemplateLiteral":
      return ast;
    case "Refinement":
      return getParameterBase(ast.from);
  }
};
const equalsTemplateLiteralSpan = /*#__PURE__*/(/* unused pure expression or super */ null && (Arr.getEquivalence((self, that) => self.type._tag === that.type._tag && self.literal === that.literal)));
const equalsEnums = /*#__PURE__*/(/* unused pure expression or super */ null && (Arr.getEquivalence((self, that) => that[0] === self[0] && that[1] === self[1])));
const equals = (self, that) => {
  switch (self._tag) {
    case "Literal":
      return isLiteral(that) && that.literal === self.literal;
    case "UniqueSymbol":
      return isUniqueSymbol(that) && that.symbol === self.symbol;
    case "UndefinedKeyword":
    case "VoidKeyword":
    case "NeverKeyword":
    case "UnknownKeyword":
    case "AnyKeyword":
    case "StringKeyword":
    case "NumberKeyword":
    case "BooleanKeyword":
    case "BigIntKeyword":
    case "SymbolKeyword":
    case "ObjectKeyword":
      return that._tag === self._tag;
    case "TemplateLiteral":
      return isTemplateLiteral(that) && that.head === self.head && equalsTemplateLiteralSpan(that.spans, self.spans);
    case "Enums":
      return isEnums(that) && equalsEnums(that.enums, self.enums);
    case "Refinement":
    case "TupleType":
    case "TypeLiteral":
    case "Union":
    case "Suspend":
    case "Transformation":
    case "Declaration":
      return self === that;
  }
};
const intersection = /*#__PURE__*/(/* unused pure expression or super */ null && (Arr.intersectionWith(equals)));
const _keyof = ast => {
  switch (ast._tag) {
    case "Declaration":
      {
        const annotation = getSurrogateAnnotation(ast);
        if (Option.isSome(annotation)) {
          return _keyof(annotation.value);
        }
        break;
      }
    case "TypeLiteral":
      return ast.propertySignatures.map(p => Predicate.isSymbol(p.name) ? new UniqueSymbol(p.name) : new Literal(p.name)).concat(ast.indexSignatures.map(is => getParameterBase(is.parameter)));
    case "Suspend":
      return _keyof(ast.f());
    case "Union":
      return ast.types.slice(1).reduce((out, ast) => intersection(out, _keyof(ast)), _keyof(ast.types[0]));
    case "Transformation":
      return _keyof(ast.to);
  }
  throw new Error(errors_.getAPIErrorMessage("KeyOf", `unsupported schema (${ast})`));
};
/** @internal */
const compose = (ab, cd) => new Transformation(ab, cd, composeTransformation);
/** @internal */
const rename = (ast, mapping) => {
  switch (ast._tag) {
    case "TypeLiteral":
      {
        const propertySignatureTransformations = [];
        for (const key of util_.ownKeys(mapping)) {
          const name = mapping[key];
          if (name !== undefined) {
            propertySignatureTransformations.push(new PropertySignatureTransformation(key, name, identity, identity));
          }
        }
        if (propertySignatureTransformations.length === 0) {
          return ast;
        }
        return new Transformation(ast, new TypeLiteral(ast.propertySignatures.map(ps => {
          const name = mapping[ps.name];
          return new PropertySignature(name === undefined ? ps.name : name, typeAST(ps.type), ps.isOptional, ps.isReadonly, ps.annotations);
        }), ast.indexSignatures), new TypeLiteralTransformation(propertySignatureTransformations));
      }
    case "Suspend":
      return new Suspend(() => rename(ast.f(), mapping));
    case "Transformation":
      return compose(ast, rename(typeAST(ast), mapping));
  }
  throw new Error(`rename: cannot rename (${ast})`);
};
const formatKeyword = (ast, verbose = false) => effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(ast, verbose), () => ast._tag);
const getExpected = (ast, verbose) => {
  if (verbose) {
    const description = getDescriptionAnnotation(ast).pipe(effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .orElse */ .vx(() => getTitleAnnotation(ast)));
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .match */ .EQ(getIdentifierAnnotation(ast), {
      onNone: () => description,
      onSome: identifier => effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .match */ .EQ(description, {
        onNone: () => effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .some */ .G(identifier),
        onSome: description => effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .some */ .G(`${identifier} (${description})`)
      })
    });
  } else {
    return getIdentifierAnnotation(ast).pipe(effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .orElse */ .vx(() => getTitleAnnotation(ast)), effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .orElse */ .vx(() => getDescriptionAnnotation(ast)));
  }
};
//# sourceMappingURL=AST.js.map

/***/ }),

/***/ 6137:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Dy": function() { return /* binding */ Type; },
  "Kc": function() { return /* binding */ asserts; },
  "G$": function() { return /* binding */ decodeUnknownSync; },
  "bG": function() { return /* binding */ fail; },
  "Yo": function() { return /* binding */ fromOption; },
  "is": function() { return /* binding */ is; },
  "ng": function() { return /* binding */ succeed; },
  "JH": function() { return /* binding */ _try; }
});

// UNUSED EXPORTS: Declaration, Forbidden, Index, Key, Member, Missing, ParseError, Refinement, Transformation, TupleType, TypeLiteral, Unexpected, Union, decode, decodeEither, decodeOption, decodePromise, decodeSync, decodeUnknown, decodeUnknownEither, decodeUnknownOption, decodeUnknownPromise, eitherOrUndefined, encode, encodeEither, encodeOption, encodePromise, encodeSync, encodeUnknown, encodeUnknownEither, encodeUnknownOption, encodeUnknownPromise, encodeUnknownSync, flatMap, getFinalTransformation, getLiterals, getSearchTree, map, mapBoth, mapError, mergeParseOptions, missing, orElse, parseError, validate, validateEither, validateOption, validatePromise, validateSync

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Array.js + 2 modules
var esm_Array = __webpack_require__(37901);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Data.js
var Data = __webpack_require__(21566);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Effect.js + 6 modules
var esm_Effect = __webpack_require__(96347);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Either.js
var esm_Either = __webpack_require__(87585);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/GlobalValue.js
var GlobalValue = __webpack_require__(4726);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Inspectable.js
var Inspectable = __webpack_require__(16371);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var esm_Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var Predicate = __webpack_require__(71335);
// EXTERNAL MODULE: ./node_modules/@effect/schema/dist/esm/AST.js
var esm_AST = __webpack_require__(24799);
// EXTERNAL MODULE: ./node_modules/@effect/schema/dist/esm/internal/util.js
var util = __webpack_require__(10852);
;// CONCATENATED MODULE: ./node_modules/@effect/schema/dist/esm/TreeFormatter.js
/**
 * @since 1.0.0
 */





const make = (value, forest = []) => ({
  value,
  forest
});
/**
 * @category formatting
 * @since 1.0.0
 */
const formatIssue = issue => esm_Effect/* map */.UID(go(issue), tree => drawTree(tree));
/**
 * @category formatting
 * @since 1.0.0
 */
const formatIssueSync = issue => esm_Effect/* runSync */.Wno(formatIssue(issue));
/**
 * @category formatting
 * @since 1.0.0
 */
const formatError = error => formatIssue(error.error);
/**
 * @category formatting
 * @since 1.0.0
 */
const formatErrorSync = error => formatIssueSync(error.error);
const drawTree = tree => tree.value + draw("\n", tree.forest);
const draw = (indentation, forest) => {
  let r = "";
  const len = forest.length;
  let tree;
  for (let i = 0; i < len; i++) {
    tree = forest[i];
    const isLast = i === len - 1;
    r += indentation + (isLast ? "└" : "├") + "─ " + tree.value;
    r += draw(indentation + (len > 1 && !isLast ? "│  " : "   "), tree.forest);
  }
  return r;
};
const formatTransformationKind = kind => {
  switch (kind) {
    case "Encoded":
      return "Encoded side transformation failure";
    case "Transformation":
      return "Transformation process failure";
    case "Type":
      return "Type side transformation failure";
  }
};
const formatRefinementKind = kind => {
  switch (kind) {
    case "From":
      return "From side refinement failure";
    case "Predicate":
      return "Predicate refinement failure";
  }
};
const getPrevMessage = issue => {
  switch (issue._tag) {
    case "Refinement":
      {
        if (issue.kind === "From") {
          return getMessage(issue.error);
        }
        break;
      }
    case "Transformation":
      return getMessage(issue.error);
  }
  return esm_Option/* none */.YP();
};
const getCurrentMessage = issue => esm_AST/* getMessageAnnotation */.sC(issue.ast).pipe(esm_Effect/* flatMap */.VSD(annotation => {
  const out = annotation(issue);
  return Predicate/* isString */.HD(out) ? esm_Effect/* succeed */.ng0(out) : out;
}));
/** @internal */
const getMessage = issue => esm_Effect/* catchAll */.kmb(getPrevMessage(issue), () => getCurrentMessage(issue));
const getParseIssueTitleAnnotation = issue => esm_Option/* filterMap */.DZ(esm_AST/* getParseIssueTitleAnnotation */.d1(issue.ast), annotation => esm_Option/* fromNullable */.ij(annotation(issue)));
/** @internal */
const formatTypeMessage = e => getMessage(e).pipe(esm_Effect/* orElse */.vxS(() => getParseIssueTitleAnnotation(e)), esm_Effect/* orElse */.vxS(() => e.message), esm_Effect/* catchAll */.kmb(() => esm_Effect/* succeed */.ng0(`Expected ${e.ast.toString(true)}, actual ${util/* formatUnknown */.cT(e.actual)}`)));
const getParseIssueTitle = issue => esm_Option/* getOrElse */.fS(getParseIssueTitleAnnotation(issue), () => String(issue.ast));
/** @internal */
const formatForbiddenMessage = e => esm_Option/* getOrElse */.fS(e.message, () => "is forbidden");
const getTree = (issue, onFailure) => esm_Effect/* matchEffect */.PwY(getMessage(issue), {
  onFailure,
  onSuccess: message => esm_Effect/* succeed */.ng0(make(message))
});
const go = e => {
  switch (e._tag) {
    case "Type":
      return esm_Effect/* map */.UID(formatTypeMessage(e), make);
    case "Forbidden":
      return esm_Effect/* succeed */.ng0(make(getParseIssueTitle(e), [make(formatForbiddenMessage(e))]));
    case "Unexpected":
      return esm_Effect/* succeed */.ng0(make(`is unexpected, expected ${e.ast.toString(true)}`));
    case "Missing":
      return esm_Effect/* succeed */.ng0(make("is missing"));
    case "Union":
      return getTree(e, () => esm_Effect/* map */.UID(esm_Effect/* forEach */.Ed_(e.errors, e => {
        switch (e._tag) {
          case "Member":
            return esm_Effect/* map */.UID(go(e.error), tree => make(`Union member`, [tree]));
          default:
            return go(e);
        }
      }), forest => make(getParseIssueTitle(e), forest)));
    case "TupleType":
      return getTree(e, () => esm_Effect/* map */.UID(esm_Effect/* forEach */.Ed_(e.errors, index => esm_Effect/* map */.UID(go(index.error), tree => make(`[${index.index}]`, [tree]))), forest => make(getParseIssueTitle(e), forest)));
    case "TypeLiteral":
      return getTree(e, () => esm_Effect/* map */.UID(esm_Effect/* forEach */.Ed_(e.errors, key => esm_Effect/* map */.UID(go(key.error), tree => make(`[${util/* formatUnknown */.cT(key.key)}]`, [tree]))), forest => make(getParseIssueTitle(e), forest)));
    case "Transformation":
      return getTree(e, () => esm_Effect/* map */.UID(go(e.error), tree => make(getParseIssueTitle(e), [make(formatTransformationKind(e.kind), [tree])])));
    case "Refinement":
      return getTree(e, () => esm_Effect/* map */.UID(go(e.error), tree => make(getParseIssueTitle(e), [make(formatRefinementKind(e.kind), [tree])])));
    case "Declaration":
      return getTree(e, () => {
        const error = e.error;
        const shouldSkipDefaultMessage = error._tag === "Type" && error.ast === e.ast;
        return shouldSkipDefaultMessage ? go(error) : esm_Effect/* map */.UID(go(error), tree => make(getParseIssueTitle(e), [tree]));
      });
  }
};
//# sourceMappingURL=TreeFormatter.js.map
;// CONCATENATED MODULE: ./node_modules/@effect/schema/dist/esm/ParseResult.js
/**
 * @since 1.0.0
 */












/**
 * Error that occurs when a declaration has an error.
 *
 * @category model
 * @since 1.0.0
 */
class Declaration {
  ast;
  actual;
  error;
  /**
   * @since 1.0.0
   */
  _tag = "Declaration";
  constructor(ast, actual, error) {
    this.ast = ast;
    this.actual = actual;
    this.error = error;
  }
}
/**
 * Error that occurs when a refinement has an error.
 *
 * @category model
 * @since 1.0.0
 */
class Refinement {
  ast;
  actual;
  kind;
  error;
  /**
   * @since 1.0.0
   */
  _tag = "Refinement";
  constructor(ast, actual, kind, error) {
    this.ast = ast;
    this.actual = actual;
    this.kind = kind;
    this.error = error;
  }
}
/**
 * Error that occurs when an array or tuple has an error.
 *
 * @category model
 * @since 1.0.0
 */
class TupleType {
  ast;
  actual;
  errors;
  output;
  /**
   * @since 1.0.0
   */
  _tag = "TupleType";
  constructor(ast, actual, errors, output = []) {
    this.ast = ast;
    this.actual = actual;
    this.errors = errors;
    this.output = output;
  }
}
/**
 * The `Index` error indicates that there was an error at a specific index in an array or tuple.
 *
 * @category model
 * @since 1.0.0
 */
class Index {
  index;
  error;
  /**
   * @since 1.0.0
   */
  _tag = "Index";
  constructor(index, error) {
    this.index = index;
    this.error = error;
  }
}
/**
 * Error that occurs when a type literal or record has an error.
 *
 * @category model
 * @since 1.0.0
 */
class TypeLiteral {
  ast;
  actual;
  errors;
  output;
  /**
   * @since 1.0.0
   */
  _tag = "TypeLiteral";
  constructor(ast, actual, errors, output = {}) {
    this.ast = ast;
    this.actual = actual;
    this.errors = errors;
    this.output = output;
  }
}
/**
 * The `Key` variant of the `ParseIssue` type represents an error that occurs when a key in a type literal or record is invalid.
 *
 * @category model
 * @since 1.0.0
 */
class Key {
  key;
  error;
  /**
   * @since 1.0.0
   */
  _tag = "Key";
  constructor(key, error) {
    this.key = key;
    this.error = error;
  }
}
/**
 * Error that occurs when an unexpected key or index is present.
 *
 * @category model
 * @since 1.0.0
 */
class Unexpected {
  ast;
  /**
   * @since 1.0.0
   */
  _tag = "Unexpected";
  constructor(ast) {
    this.ast = ast;
  }
}
/**
 * Error that occurs when a transformation has an error.
 *
 * @category model
 * @since 1.0.0
 */
class Transformation {
  ast;
  actual;
  kind;
  error;
  /**
   * @since 1.0.0
   */
  _tag = "Transformation";
  constructor(ast, actual, kind, error) {
    this.ast = ast;
    this.actual = actual;
    this.kind = kind;
    this.error = error;
  }
}
/**
 * The `Type` variant of the `ParseIssue` type represents an error that occurs when the `actual` value is not of the expected type.
 * The `ast` field specifies the expected type, and the `actual` field contains the value that caused the error.
 *
 * @category model
 * @since 1.0.0
 */
class Type {
  ast;
  actual;
  /**
   * @since 1.0.0
   */
  _tag = "Type";
  /**
   * @since 1.0.0
   */
  message;
  constructor(ast, actual, message) {
    this.ast = ast;
    this.actual = actual;
    this.message = esm_Option/* fromNullable */.ij(message);
  }
}
/**
 * The `Forbidden` variant of the `ParseIssue` type represents a forbidden operation, such as when encountering an Effect that is not allowed to execute (e.g., using `runSync`).
 *
 * @category model
 * @since 1.0.0
 */
class Forbidden {
  ast;
  actual;
  /**
   * @since 1.0.0
   */
  _tag = "Forbidden";
  /**
   * @since 1.0.0
   */
  message;
  constructor(ast, actual, message) {
    this.ast = ast;
    this.actual = actual;
    this.message = esm_Option/* fromNullable */.ij(message);
  }
}
/**
 * Error that occurs when a required key or index is missing.
 *
 * @category model
 * @since 1.0.0
 */
class Missing {
  /**
   * @since 1.0.0
   */
  _tag = "Missing";
}
/**
 * @category constructors
 * @since 1.0.0
 */
const missing = /*#__PURE__*/new Missing();
/**
 * Error that occurs when a member in a union has an error.
 *
 * @category model
 * @since 1.0.0
 */
class Member {
  ast;
  error;
  /**
   * @since 1.0.0
   */
  _tag = "Member";
  constructor(ast, error) {
    this.ast = ast;
    this.error = error;
  }
}
/**
 * Error that occurs when a union has an error.
 *
 * @category model
 * @since 1.0.0
 */
class Union {
  ast;
  actual;
  errors;
  /**
   * @since 1.0.0
   */
  _tag = "Union";
  constructor(ast, actual, errors) {
    this.ast = ast;
    this.actual = actual;
    this.errors = errors;
  }
}
/**
 * @since 1.0.0
 */
class ParseError extends (0,Data/* TaggedError */.fZ)("ParseError") {
  get message() {
    return this.toString();
  }
  /**
   * @since 1.0.0
   */
  toString() {
    return TreeFormatter.formatIssueSync(this.error);
  }
  /**
   * @since 1.0.0
   */
  toJSON() {
    return {
      _id: "ParseError",
      message: this.toString()
    };
  }
  /**
   * @since 1.0.0
   */
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return this.toJSON();
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const parseError = issue => new ParseError({
  error: issue
});
/**
 * @category constructors
 * @since 1.0.0
 */
const succeed = esm_Either/* right */.F2;
/**
 * @category constructors
 * @since 1.0.0
 */
const fail = esm_Either/* left */.t$;
const _try = esm_Either/* try */.JH;

/**
 * @category constructors
 * @since 1.0.0
 */
const fromOption = esm_Either/* fromOption */.Yo;
/**
 * @category optimisation
 * @since 1.0.0
 */
const flatMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const s = self;
  if (s["_tag"] === "Left") {
    return s;
  }
  if (s["_tag"] === "Right") {
    return f(s.right);
  }
  return esm_Effect/* flatMap */.VSD(self, f);
});
/**
 * @category optimisation
 * @since 1.0.0
 */
const map = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const s = self;
  if (s["_tag"] === "Left") {
    return s;
  }
  if (s["_tag"] === "Right") {
    return esm_Either/* right */.F2(f(s.right));
  }
  return esm_Effect/* map */.UID(self, f);
});
/**
 * @category optimisation
 * @since 1.0.0
 */
const mapError = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const s = self;
  if (s["_tag"] === "Left") {
    return esm_Either/* left */.t$(f(s.left));
  }
  if (s["_tag"] === "Right") {
    return s;
  }
  return esm_Effect/* mapError */.d1Y(self, f);
});
/**
 * @category optimisation
 * @since 1.0.0
 */
const eitherOrUndefined = self => {
  const s = self;
  if (s["_tag"] === "Left" || s["_tag"] === "Right") {
    return s;
  }
};
/**
 * @category optimisation
 * @since 1.0.0
 */
const mapBoth = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, options) => {
  const s = self;
  if (s["_tag"] === "Left") {
    return Either.left(options.onFailure(s.left));
  }
  if (s["_tag"] === "Right") {
    return Either.right(options.onSuccess(s.right));
  }
  return Effect.mapBoth(self, options);
})));
/**
 * @category optimisation
 * @since 1.0.0
 */
const orElse = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  const s = self;
  if (s["_tag"] === "Left") {
    return f(s.left);
  }
  if (s["_tag"] === "Right") {
    return s;
  }
  return Effect.catchAll(self, f);
})));
/** @internal */
const mergeParseOptions = (a, b) => {
  if (a === undefined) {
    return b;
  }
  if (b === undefined) {
    return a;
  }
  const out = {};
  out.errors = b.errors ?? a.errors;
  out.onExcessProperty = b.onExcessProperty ?? a.onExcessProperty;
  return out;
};
const getEither = (ast, isDecoding, options) => {
  const parser = goMemo(ast, isDecoding);
  return (u, overrideOptions) => parser(u, mergeParseOptions(options, overrideOptions));
};
const getSync = (ast, isDecoding, options) => {
  const parser = getEither(ast, isDecoding, options);
  return (input, overrideOptions) => esm_Either/* getOrThrowWith */.G$(parser(input, overrideOptions), e => new Error(formatIssueSync(e)));
};
const getOption = (ast, isDecoding, options) => {
  const parser = getEither(ast, isDecoding, options);
  return (input, overrideOptions) => Option.getRight(parser(input, overrideOptions));
};
const getEffect = (ast, isDecoding, options) => {
  const parser = goMemo(ast, isDecoding);
  return (input, overrideOptions) => parser(input, {
    ...mergeParseOptions(options, overrideOptions),
    isEffectAllowed: true
  });
};
/**
 * @category decoding
 * @since 1.0.0
 */
const decodeUnknownSync = (schema, options) => getSync(schema.ast, true, options);
/**
 * @category decoding
 * @since 1.0.0
 */
const decodeUnknownOption = (schema, options) => getOption(schema.ast, true, options);
/**
 * @category decoding
 * @since 1.0.0
 */
const decodeUnknownEither = (schema, options) => getEither(schema.ast, true, options);
/**
 * @category decoding
 * @since 1.0.0
 */
const decodeUnknownPromise = (schema, options) => {
  const parser = decodeUnknown(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category decoding
 * @since 1.0.0
 */
const decodeUnknown = (schema, options) => getEffect(schema.ast, true, options);
/**
 * @category encoding
 * @since 1.0.0
 */
const encodeUnknownSync = (schema, options) => getSync(schema.ast, false, options);
/**
 * @category encoding
 * @since 1.0.0
 */
const encodeUnknownOption = (schema, options) => getOption(schema.ast, false, options);
/**
 * @category encoding
 * @since 1.0.0
 */
const encodeUnknownEither = (schema, options) => getEither(schema.ast, false, options);
/**
 * @category encoding
 * @since 1.0.0
 */
const encodeUnknownPromise = (schema, options) => {
  const parser = encodeUnknown(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category encoding
 * @since 1.0.0
 */
const encodeUnknown = (schema, options) => getEffect(schema.ast, false, options);
/**
 * @category decoding
 * @since 1.0.0
 */
const decodeSync = (/* unused pure expression or super */ null && (decodeUnknownSync));
/**
 * @category decoding
 * @since 1.0.0
 */
const decodeOption = (/* unused pure expression or super */ null && (decodeUnknownOption));
/**
 * @category decoding
 * @since 1.0.0
 */
const decodeEither = (/* unused pure expression or super */ null && (decodeUnknownEither));
/**
 * @category decoding
 * @since 1.0.0
 */
const decodePromise = (/* unused pure expression or super */ null && (decodeUnknownPromise));
/**
 * @category decoding
 * @since 1.0.0
 */
const decode = (/* unused pure expression or super */ null && (decodeUnknown));
/**
 * @category validation
 * @since 1.0.0
 */
const validateSync = (schema, options) => getSync(AST.typeAST(schema.ast), true, options);
/**
 * @category validation
 * @since 1.0.0
 */
const validateOption = (schema, options) => getOption(AST.typeAST(schema.ast), true, options);
/**
 * @category validation
 * @since 1.0.0
 */
const validateEither = (schema, options) => getEither(AST.typeAST(schema.ast), true, options);
/**
 * @category validation
 * @since 1.0.0
 */
const validatePromise = (schema, options) => {
  const parser = validate(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category validation
 * @since 1.0.0
 */
const validate = (schema, options) => getEffect(AST.typeAST(schema.ast), true, options);
/**
 * @category validation
 * @since 1.0.0
 */
const is = (schema, options) => {
  const parser = goMemo(esm_AST/* typeAST */.Yc(schema.ast), true);
  return (u, overrideOptions) => esm_Either/* isRight */.tO(parser(u, {
    ...mergeParseOptions(options, overrideOptions),
    isExact: true
  }));
};
/**
 * @category validation
 * @since 1.0.0
 */
const asserts = (schema, options) => {
  const parser = goMemo(esm_AST/* typeAST */.Yc(schema.ast), true);
  return (u, overrideOptions) => {
    const result = parser(u, {
      ...mergeParseOptions(options, overrideOptions),
      isExact: true
    });
    if (esm_Either/* isLeft */.nM(result)) {
      throw new Error(formatIssueSync(result.left));
    }
  };
};
/**
 * @category encoding
 * @since 1.0.0
 */
const encodeSync = (/* unused pure expression or super */ null && (encodeUnknownSync));
/**
 * @category encoding
 * @since 1.0.0
 */
const encodeOption = (/* unused pure expression or super */ null && (encodeUnknownOption));
/**
 * @category encoding
 * @since 1.0.0
 */
const encodeEither = (/* unused pure expression or super */ null && (encodeUnknownEither));
/**
 * @category encoding
 * @since 1.0.0
 */
const encodePromise = (/* unused pure expression or super */ null && (encodeUnknownPromise));
/**
 * @category encoding
 * @since 1.0.0
 */
const encode = (/* unused pure expression or super */ null && (encodeUnknown));
const decodeMemoMap = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("@effect/schema/Parser/decodeMemoMap"), () => new WeakMap());
const encodeMemoMap = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("@effect/schema/Parser/encodeMemoMap"), () => new WeakMap());
const goMemo = (ast, isDecoding) => {
  const memoMap = isDecoding ? decodeMemoMap : encodeMemoMap;
  const memo = memoMap.get(ast);
  if (memo) {
    return memo;
  }
  const parser = ParseResult_go(ast, isDecoding);
  memoMap.set(ast, parser);
  return parser;
};
const getConcurrency = ast => esm_Option/* getOrUndefined */.jD(esm_AST/* getConcurrencyAnnotation */.mm(ast));
const getBatching = ast => esm_Option/* getOrUndefined */.jD(esm_AST/* getBatchingAnnotation */.we(ast));
const ParseResult_go = (ast, isDecoding) => {
  switch (ast._tag) {
    case "Refinement":
      {
        if (isDecoding) {
          const from = goMemo(ast.from, true);
          return (i, options) => handleForbidden(flatMap(mapError(from(i, options), e => new Refinement(ast, i, "From", e)), a => esm_Option/* match */.EQ(ast.filter(a, options ?? esm_AST/* defaultParseOption */.Dr, ast), {
            onNone: () => esm_Either/* right */.F2(a),
            onSome: e => esm_Either/* left */.t$(new Refinement(ast, i, "Predicate", e))
          })), ast, i, options);
        } else {
          const from = goMemo(esm_AST/* typeAST */.Yc(ast), true);
          const to = goMemo(dropRightRefinement(ast.from), false);
          return (i, options) => handleForbidden(flatMap(from(i, options), a => to(a, options)), ast, i, options);
        }
      }
    case "Transformation":
      {
        const transform = getFinalTransformation(ast.transformation, isDecoding);
        const from = isDecoding ? goMemo(ast.from, true) : goMemo(ast.to, false);
        const to = isDecoding ? goMemo(ast.to, true) : goMemo(ast.from, false);
        return (i1, options) => handleForbidden(flatMap(mapError(from(i1, options), e => new Transformation(ast, i1, isDecoding ? "Encoded" : "Type", e)), a => flatMap(mapError(transform(a, options ?? esm_AST/* defaultParseOption */.Dr, ast), e => new Transformation(ast, i1, "Transformation", e)), i2 => mapError(to(i2, options), e => new Transformation(ast, i1, isDecoding ? "Type" : "Encoded", e)))), ast, i1, options);
      }
    case "Declaration":
      {
        const parse = isDecoding ? ast.decodeUnknown(...ast.typeParameters) : ast.encodeUnknown(...ast.typeParameters);
        return (i, options) => handleForbidden(mapError(parse(i, options ?? esm_AST/* defaultParseOption */.Dr, ast), e => new Declaration(ast, i, e)), ast, i, options);
      }
    case "Literal":
      return fromRefinement(ast, u => u === ast.literal);
    case "UniqueSymbol":
      return fromRefinement(ast, u => u === ast.symbol);
    case "UndefinedKeyword":
      return fromRefinement(ast, Predicate/* isUndefined */.o8);
    case "VoidKeyword":
      return fromRefinement(ast, Predicate/* isUndefined */.o8);
    case "NeverKeyword":
      return fromRefinement(ast, Predicate/* isNever */.r2);
    case "UnknownKeyword":
    case "AnyKeyword":
      return esm_Either/* right */.F2;
    case "StringKeyword":
      return fromRefinement(ast, Predicate/* isString */.HD);
    case "NumberKeyword":
      return fromRefinement(ast, Predicate/* isNumber */.hj);
    case "BooleanKeyword":
      return fromRefinement(ast, Predicate/* isBoolean */.jn);
    case "BigIntKeyword":
      return fromRefinement(ast, Predicate/* isBigInt */.C4);
    case "SymbolKeyword":
      return fromRefinement(ast, Predicate/* isSymbol */.yk);
    case "ObjectKeyword":
      return fromRefinement(ast, Predicate/* isObject */.Kn);
    case "Enums":
      return fromRefinement(ast, u => ast.enums.some(([_, value]) => value === u));
    case "TemplateLiteral":
      {
        const regex = esm_AST/* getTemplateLiteralRegExp */.M7(ast);
        return fromRefinement(ast, u => Predicate/* isString */.HD(u) && regex.test(u));
      }
    case "TupleType":
      {
        const elements = ast.elements.map(e => goMemo(e.type, isDecoding));
        const rest = ast.rest.map(ast => goMemo(ast, isDecoding));
        let requiredLen = ast.elements.filter(e => !e.isOptional).length;
        if (ast.rest.length > 0) {
          requiredLen += ast.rest.length - 1;
        }
        const expectedAST = esm_AST/* Union.make */.EJ.make(ast.elements.map((_, i) => new esm_AST/* Literal */.t$(i)));
        const concurrency = getConcurrency(ast);
        const batching = getBatching(ast);
        return (input, options) => {
          if (!esm_Array/* isArray */.kJ(input)) {
            return esm_Either/* left */.t$(new Type(ast, input));
          }
          const allErrors = options?.errors === "all";
          const es = [];
          let stepKey = 0;
          // ---------------------------------------------
          // handle missing indexes
          // ---------------------------------------------
          const len = input.length;
          for (let i = len; i <= requiredLen - 1; i++) {
            const e = new Index(i, missing);
            if (allErrors) {
              es.push([stepKey++, e]);
              continue;
            } else {
              return esm_Either/* left */.t$(new TupleType(ast, input, [e]));
            }
          }
          // ---------------------------------------------
          // handle excess indexes
          // ---------------------------------------------
          if (ast.rest.length === 0) {
            for (let i = ast.elements.length; i <= len - 1; i++) {
              const e = new Index(i, new Unexpected(expectedAST));
              if (allErrors) {
                es.push([stepKey++, e]);
                continue;
              } else {
                return esm_Either/* left */.t$(new TupleType(ast, input, [e]));
              }
            }
          }
          const output = [];
          let i = 0;
          let queue = undefined;
          // ---------------------------------------------
          // handle elements
          // ---------------------------------------------
          for (; i < elements.length; i++) {
            if (len < i + 1) {
              if (ast.elements[i].isOptional) {
                // the input element is missing
                continue;
              }
            } else {
              const parser = elements[i];
              const te = parser(input[i], options);
              const eu = eitherOrUndefined(te);
              if (eu) {
                if (esm_Either/* isLeft */.nM(eu)) {
                  // the input element is present but is not valid
                  const e = new Index(i, eu.left);
                  if (allErrors) {
                    es.push([stepKey++, e]);
                    continue;
                  } else {
                    return esm_Either/* left */.t$(new TupleType(ast, input, [e], sortByIndex(output)));
                  }
                }
                output.push([stepKey++, eu.right]);
              } else {
                const nk = stepKey++;
                const index = i;
                if (!queue) {
                  queue = [];
                }
                queue.push(({
                  es,
                  output
                }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(te), t => {
                  if (esm_Either/* isLeft */.nM(t)) {
                    // the input element is present but is not valid
                    const e = new Index(index, t.left);
                    if (allErrors) {
                      es.push([nk, e]);
                      return esm_Effect/* void */.Hcj;
                    } else {
                      return esm_Either/* left */.t$(new TupleType(ast, input, [e], sortByIndex(output)));
                    }
                  }
                  output.push([nk, t.right]);
                  return esm_Effect/* void */.Hcj;
                }));
              }
            }
          }
          // ---------------------------------------------
          // handle rest element
          // ---------------------------------------------
          if (esm_Array/* isNonEmptyReadonlyArray */.Ux(rest)) {
            const [head, ...tail] = rest;
            for (; i < len - tail.length; i++) {
              const te = head(input[i], options);
              const eu = eitherOrUndefined(te);
              if (eu) {
                if (esm_Either/* isLeft */.nM(eu)) {
                  const e = new Index(i, eu.left);
                  if (allErrors) {
                    es.push([stepKey++, e]);
                    continue;
                  } else {
                    return esm_Either/* left */.t$(new TupleType(ast, input, [e], sortByIndex(output)));
                  }
                } else {
                  output.push([stepKey++, eu.right]);
                }
              } else {
                const nk = stepKey++;
                const index = i;
                if (!queue) {
                  queue = [];
                }
                queue.push(({
                  es,
                  output
                }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(te), t => {
                  if (esm_Either/* isLeft */.nM(t)) {
                    const e = new Index(index, t.left);
                    if (allErrors) {
                      es.push([nk, e]);
                      return esm_Effect/* void */.Hcj;
                    } else {
                      return esm_Either/* left */.t$(new TupleType(ast, input, [e], sortByIndex(output)));
                    }
                  } else {
                    output.push([nk, t.right]);
                    return esm_Effect/* void */.Hcj;
                  }
                }));
              }
            }
            // ---------------------------------------------
            // handle post rest elements
            // ---------------------------------------------
            for (let j = 0; j < tail.length; j++) {
              i += j;
              if (len < i + 1) {
                continue;
              } else {
                const te = tail[j](input[i], options);
                const eu = eitherOrUndefined(te);
                if (eu) {
                  if (esm_Either/* isLeft */.nM(eu)) {
                    // the input element is present but is not valid
                    const e = new Index(i, eu.left);
                    if (allErrors) {
                      es.push([stepKey++, e]);
                      continue;
                    } else {
                      return esm_Either/* left */.t$(new TupleType(ast, input, [e], sortByIndex(output)));
                    }
                  }
                  output.push([stepKey++, eu.right]);
                } else {
                  const nk = stepKey++;
                  const index = i;
                  if (!queue) {
                    queue = [];
                  }
                  queue.push(({
                    es,
                    output
                  }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(te), t => {
                    if (esm_Either/* isLeft */.nM(t)) {
                      // the input element is present but is not valid
                      const e = new Index(index, t.left);
                      if (allErrors) {
                        es.push([nk, e]);
                        return esm_Effect/* void */.Hcj;
                      } else {
                        return esm_Either/* left */.t$(new TupleType(ast, input, [e], sortByIndex(output)));
                      }
                    }
                    output.push([nk, t.right]);
                    return esm_Effect/* void */.Hcj;
                  }));
                }
              }
            }
          }
          // ---------------------------------------------
          // compute result
          // ---------------------------------------------
          const computeResult = ({
            es,
            output
          }) => esm_Array/* isNonEmptyArray */.Of(es) ? esm_Either/* left */.t$(new TupleType(ast, input, sortByIndex(es), sortByIndex(output))) : esm_Either/* right */.F2(sortByIndex(output));
          if (queue && queue.length > 0) {
            const cqueue = queue;
            return esm_Effect/* suspend */.RqG(() => {
              const state = {
                es: esm_Array/* copy */.JG(es),
                output: esm_Array/* copy */.JG(output)
              };
              return esm_Effect/* flatMap */.VSD(esm_Effect/* forEach */.Ed_(cqueue, f => f(state), {
                concurrency,
                batching,
                discard: true
              }), () => computeResult(state));
            });
          }
          return computeResult({
            output,
            es
          });
        };
      }
    case "TypeLiteral":
      {
        if (ast.propertySignatures.length === 0 && ast.indexSignatures.length === 0) {
          return fromRefinement(ast, Predicate/* isNotNullable */.jW);
        }
        const propertySignatures = [];
        const expectedKeys = {};
        for (const ps of ast.propertySignatures) {
          propertySignatures.push([goMemo(ps.type, isDecoding), ps]);
          expectedKeys[ps.name] = null;
        }
        const indexSignatures = ast.indexSignatures.map(is => [goMemo(is.parameter, isDecoding), goMemo(is.type, isDecoding), is.parameter]);
        const expectedAST = esm_AST/* Union.make */.EJ.make(ast.indexSignatures.map(is => is.parameter).concat(util/* ownKeys */.Wp(expectedKeys).map(key => Predicate/* isSymbol */.yk(key) ? new esm_AST/* UniqueSymbol */.VF(key) : new esm_AST/* Literal */.t$(key))));
        const expected = goMemo(expectedAST, isDecoding);
        const concurrency = getConcurrency(ast);
        const batching = getBatching(ast);
        return (input, options) => {
          if (!Predicate/* isRecord */.Uy(input)) {
            return esm_Either/* left */.t$(new Type(ast, input));
          }
          const allErrors = options?.errors === "all";
          const es = [];
          let stepKey = 0;
          // ---------------------------------------------
          // handle excess properties
          // ---------------------------------------------
          const onExcessPropertyError = options?.onExcessProperty === "error";
          const onExcessPropertyPreserve = options?.onExcessProperty === "preserve";
          const output = {};
          if (onExcessPropertyError || onExcessPropertyPreserve) {
            for (const key of util/* ownKeys */.Wp(input)) {
              const eu = eitherOrUndefined(expected(key, options));
              if (esm_Either/* isLeft */.nM(eu)) {
                // key is unexpected
                if (onExcessPropertyError) {
                  const e = new Key(key, new Unexpected(expectedAST));
                  if (allErrors) {
                    es.push([stepKey++, e]);
                    continue;
                  } else {
                    return esm_Either/* left */.t$(new TypeLiteral(ast, input, [e], output));
                  }
                } else {
                  // preserve key
                  output[key] = input[key];
                }
              }
            }
          }
          let queue = undefined;
          const isExact = options?.isExact === true;
          for (let i = 0; i < propertySignatures.length; i++) {
            const ps = propertySignatures[i][1];
            const name = ps.name;
            const hasKey = Object.prototype.hasOwnProperty.call(input, name);
            if (!hasKey) {
              if (ps.isOptional) {
                continue;
              } else if (isExact) {
                const e = new Key(name, missing);
                if (allErrors) {
                  es.push([stepKey++, e]);
                  continue;
                } else {
                  return esm_Either/* left */.t$(new TypeLiteral(ast, input, [e], output));
                }
              }
            }
            const parser = propertySignatures[i][0];
            const te = parser(input[name], options);
            const eu = eitherOrUndefined(te);
            if (eu) {
              if (esm_Either/* isLeft */.nM(eu)) {
                const e = new Key(name, hasKey ? eu.left : missing);
                if (allErrors) {
                  es.push([stepKey++, e]);
                  continue;
                } else {
                  return esm_Either/* left */.t$(new TypeLiteral(ast, input, [e], output));
                }
              }
              output[name] = eu.right;
            } else {
              const nk = stepKey++;
              const index = name;
              if (!queue) {
                queue = [];
              }
              queue.push(({
                es,
                output
              }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(te), t => {
                if (esm_Either/* isLeft */.nM(t)) {
                  const e = new Key(index, hasKey ? t.left : missing);
                  if (allErrors) {
                    es.push([nk, e]);
                    return esm_Effect/* void */.Hcj;
                  } else {
                    return esm_Either/* left */.t$(new TypeLiteral(ast, input, [e], output));
                  }
                }
                output[index] = t.right;
                return esm_Effect/* void */.Hcj;
              }));
            }
          }
          // ---------------------------------------------
          // handle index signatures
          // ---------------------------------------------
          for (let i = 0; i < indexSignatures.length; i++) {
            const indexSignature = indexSignatures[i];
            const parameter = indexSignature[0];
            const type = indexSignature[1];
            const keys = util/* getKeysForIndexSignature */.k8(input, indexSignature[2]);
            for (const key of keys) {
              // ---------------------------------------------
              // handle keys
              // ---------------------------------------------
              const keu = eitherOrUndefined(parameter(key, options));
              if (keu && esm_Either/* isRight */.tO(keu)) {
                // ---------------------------------------------
                // handle values
                // ---------------------------------------------
                const vpr = type(input[key], options);
                const veu = eitherOrUndefined(vpr);
                if (veu) {
                  if (esm_Either/* isLeft */.nM(veu)) {
                    const e = new Key(key, veu.left);
                    if (allErrors) {
                      es.push([stepKey++, e]);
                      continue;
                    } else {
                      return esm_Either/* left */.t$(new TypeLiteral(ast, input, [e], output));
                    }
                  } else {
                    if (!Object.prototype.hasOwnProperty.call(expectedKeys, key)) {
                      output[key] = veu.right;
                    }
                  }
                } else {
                  const nk = stepKey++;
                  const index = key;
                  if (!queue) {
                    queue = [];
                  }
                  queue.push(({
                    es,
                    output
                  }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(vpr), tv => {
                    if (esm_Either/* isLeft */.nM(tv)) {
                      const e = new Key(index, tv.left);
                      if (allErrors) {
                        es.push([nk, e]);
                        return esm_Effect/* void */.Hcj;
                      } else {
                        return esm_Either/* left */.t$(new TypeLiteral(ast, input, [e], output));
                      }
                    } else {
                      if (!Object.prototype.hasOwnProperty.call(expectedKeys, key)) {
                        output[key] = tv.right;
                      }
                      return esm_Effect/* void */.Hcj;
                    }
                  }));
                }
              }
            }
          }
          // ---------------------------------------------
          // compute result
          // ---------------------------------------------
          const computeResult = ({
            es,
            output
          }) => esm_Array/* isNonEmptyArray */.Of(es) ? esm_Either/* left */.t$(new TypeLiteral(ast, input, sortByIndex(es), output)) : esm_Either/* right */.F2(output);
          if (queue && queue.length > 0) {
            const cqueue = queue;
            return esm_Effect/* suspend */.RqG(() => {
              const state = {
                es: esm_Array/* copy */.JG(es),
                output: Object.assign({}, output)
              };
              return esm_Effect/* flatMap */.VSD(esm_Effect/* forEach */.Ed_(cqueue, f => f(state), {
                concurrency,
                batching,
                discard: true
              }), () => computeResult(state));
            });
          }
          return computeResult({
            es,
            output
          });
        };
      }
    case "Union":
      {
        const searchTree = getSearchTree(ast.types, isDecoding);
        const ownKeys = util/* ownKeys */.Wp(searchTree.keys);
        const len = ownKeys.length;
        const map = new Map();
        for (let i = 0; i < ast.types.length; i++) {
          map.set(ast.types[i], goMemo(ast.types[i], isDecoding));
        }
        const concurrency = getConcurrency(ast) ?? 1;
        const batching = getBatching(ast);
        return (input, options) => {
          const es = [];
          let stepKey = 0;
          let candidates = [];
          if (len > 0) {
            // if there is at least one key then input must be an object
            if (Predicate/* isRecord */.Uy(input)) {
              for (let i = 0; i < len; i++) {
                const name = ownKeys[i];
                const buckets = searchTree.keys[name].buckets;
                // for each property that should contain a literal, check if the input contains that property
                if (Object.prototype.hasOwnProperty.call(input, name)) {
                  const literal = String(input[name]);
                  // check that the value obtained from the input for the property corresponds to an existing bucket
                  if (Object.prototype.hasOwnProperty.call(buckets, literal)) {
                    // retrive the minimal set of candidates for decoding
                    candidates = candidates.concat(buckets[literal]);
                  } else {
                    const literals = esm_AST/* Union.make */.EJ.make(searchTree.keys[name].literals);
                    es.push([stepKey++, new TypeLiteral(new esm_AST/* TypeLiteral */.tW([new esm_AST/* PropertySignature */.TJ(name, literals, false, true)], []), input, [new Key(name, new Type(literals, input[name]))])]);
                  }
                } else {
                  const literals = esm_AST/* Union.make */.EJ.make(searchTree.keys[name].literals);
                  es.push([stepKey++, new TypeLiteral(new esm_AST/* TypeLiteral */.tW([new esm_AST/* PropertySignature */.TJ(name, literals, false, true)], []), input, [new Key(name, missing)])]);
                }
              }
            } else {
              es.push([stepKey++, new Type(ast, input)]);
            }
          }
          if (searchTree.otherwise.length > 0) {
            candidates = candidates.concat(searchTree.otherwise);
          }
          let queue = undefined;
          for (let i = 0; i < candidates.length; i++) {
            const candidate = candidates[i];
            const pr = map.get(candidate)(input, options);
            // the members of a union are ordered based on which one should be decoded first,
            // therefore if one member has added a task, all subsequent members must
            // also add a task to the queue even if they are synchronous
            const eu = !queue || queue.length === 0 ? eitherOrUndefined(pr) : undefined;
            if (eu) {
              if (esm_Either/* isRight */.tO(eu)) {
                return esm_Either/* right */.F2(eu.right);
              } else {
                es.push([stepKey++, new Member(candidate, eu.left)]);
              }
            } else {
              const nk = stepKey++;
              if (!queue) {
                queue = [];
              }
              queue.push(state => esm_Effect/* suspend */.RqG(() => {
                if ("finalResult" in state) {
                  return esm_Effect/* void */.Hcj;
                } else {
                  return esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(pr), t => {
                    if (esm_Either/* isRight */.tO(t)) {
                      state.finalResult = esm_Either/* right */.F2(t.right);
                    } else {
                      state.es.push([nk, new Member(candidate, t.left)]);
                    }
                    return esm_Effect/* void */.Hcj;
                  });
                }
              }));
            }
          }
          // ---------------------------------------------
          // compute result
          // ---------------------------------------------
          const computeResult = es => esm_Array/* isNonEmptyArray */.Of(es) ? es.length === 1 && es[0][1]._tag === "Type" ? esm_Either/* left */.t$(es[0][1]) : esm_Either/* left */.t$(new Union(ast, input, sortByIndex(es))) :
          // this should never happen
          esm_Either/* left */.t$(new Type(esm_AST/* neverKeyword */.$y, input));
          if (queue && queue.length > 0) {
            const cqueue = queue;
            return esm_Effect/* suspend */.RqG(() => {
              const state = {
                es: esm_Array/* copy */.JG(es)
              };
              return esm_Effect/* flatMap */.VSD(esm_Effect/* forEach */.Ed_(cqueue, f => f(state), {
                concurrency,
                batching,
                discard: true
              }), () => {
                if ("finalResult" in state) {
                  return state.finalResult;
                }
                return computeResult(state.es);
              });
            });
          }
          return computeResult(es);
        };
      }
    case "Suspend":
      {
        const get = util/* memoizeThunk */.d3(() => goMemo(esm_AST/* annotations */.ds(ast.f(), ast.annotations), isDecoding));
        return (a, options) => get()(a, options);
      }
  }
};
const fromRefinement = (ast, refinement) => u => refinement(u) ? esm_Either/* right */.F2(u) : esm_Either/* left */.t$(new Type(ast, u));
/** @internal */
const getLiterals = (ast, isDecoding) => {
  switch (ast._tag) {
    case "Declaration":
      {
        const annotation = esm_AST/* getSurrogateAnnotation */.O5(ast);
        if (esm_Option/* isSome */.pC(annotation)) {
          return getLiterals(annotation.value, isDecoding);
        }
        break;
      }
    case "TypeLiteral":
      {
        const out = [];
        for (let i = 0; i < ast.propertySignatures.length; i++) {
          const propertySignature = ast.propertySignatures[i];
          const type = isDecoding ? esm_AST/* encodedAST */.Bh(propertySignature.type) : esm_AST/* typeAST */.Yc(propertySignature.type);
          if (esm_AST/* isLiteral */.n_(type) && !propertySignature.isOptional) {
            out.push([propertySignature.name, type]);
          }
        }
        return out;
      }
    case "Refinement":
      return getLiterals(ast.from, isDecoding);
    case "Suspend":
      return getLiterals(ast.f(), isDecoding);
    case "Transformation":
      return getLiterals(isDecoding ? ast.from : ast.to, isDecoding);
  }
  return [];
};
/**
 * The purpose of the algorithm is to narrow down the pool of possible candidates for decoding as much as possible.
 *
 * This function separates the schemas into two groups, `keys` and `otherwise`:
 *
 * - `keys`: the schema has at least one property with a literal value
 * - `otherwise`: the schema has no properties with a literal value
 *
 * If a schema has at least one property with a literal value, so it ends up in `keys`, first a namespace is created for
 * the name of the property containing the literal, and then within this namespace a "bucket" is created for the literal
 * value in which to store all the schemas that have the same property and literal value.
 *
 * @internal
 */
const getSearchTree = (members, isDecoding) => {
  const keys = {};
  const otherwise = [];
  for (let i = 0; i < members.length; i++) {
    const member = members[i];
    const tags = getLiterals(member, isDecoding);
    if (tags.length > 0) {
      for (let j = 0; j < tags.length; j++) {
        const [key, literal] = tags[j];
        const hash = String(literal.literal);
        keys[key] = keys[key] || {
          buckets: {},
          literals: []
        };
        const buckets = keys[key].buckets;
        if (Object.prototype.hasOwnProperty.call(buckets, hash)) {
          if (j < tags.length - 1) {
            continue;
          }
          buckets[hash].push(member);
          keys[key].literals.push(literal);
        } else {
          buckets[hash] = [member];
          keys[key].literals.push(literal);
          break;
        }
      }
    } else {
      otherwise.push(member);
    }
  }
  return {
    keys,
    otherwise
  };
};
const dropRightRefinement = ast => esm_AST/* isRefinement */.TI(ast) ? dropRightRefinement(ast.from) : ast;
const handleForbidden = (effect, ast, actual, options) => {
  const eu = eitherOrUndefined(effect);
  if (eu) {
    return eu;
  }
  if (options?.isEffectAllowed === true) {
    return effect;
  }
  try {
    return esm_Effect/* runSync */.Wno(esm_Effect/* either */.wEe(effect));
  } catch (e) {
    return esm_Either/* left */.t$(new Forbidden(ast, actual, "cannot be be resolved synchronously, this is caused by using runSync on an effect that performs async work"));
  }
};
function sortByIndex(es) {
  return es.sort(([a], [b]) => a > b ? 1 : a < b ? -1 : 0).map(([_, a]) => a);
}
// -------------------------------------------------------------------------------------
// transformations interpreter
// -------------------------------------------------------------------------------------
/** @internal */
const getFinalTransformation = (transformation, isDecoding) => {
  switch (transformation._tag) {
    case "FinalTransformation":
      return isDecoding ? transformation.decode : transformation.encode;
    case "ComposeTransformation":
      return esm_Either/* right */.F2;
    case "TypeLiteralTransformation":
      return input => {
        let out = esm_Either/* right */.F2(input);
        // ---------------------------------------------
        // handle property signature transformations
        // ---------------------------------------------
        for (const pst of transformation.propertySignatureTransformations) {
          const [from, to] = isDecoding ? [pst.from, pst.to] : [pst.to, pst.from];
          const transformation = isDecoding ? pst.decode : pst.encode;
          const f = input => {
            const o = transformation(Object.prototype.hasOwnProperty.call(input, from) ? esm_Option/* some */.G(input[from]) : esm_Option/* none */.YP());
            delete input[from];
            if (esm_Option/* isSome */.pC(o)) {
              input[to] = o.value;
            }
            return input;
          };
          out = map(out, f);
        }
        return out;
      };
  }
};
//# sourceMappingURL=ParseResult.js.map

/***/ }),

/***/ 51375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mJB": function() { return /* binding */ $Array; },
  "Mr_": function() { return /* binding */ $Number; },
  "c7w": function() { return /* binding */ $Object; },
  "WVy": function() { return /* binding */ Record; },
  "Ld9": function() { return /* binding */ $String; },
  "lJd": function() { return /* binding */ Uint8ArrayFromSelf; },
  "EJI": function() { return /* binding */ Union; },
  "BSk": function() { return /* binding */ maxLength; },
  "MoP": function() { return /* binding */ parseJson; },
  "RqG": function() { return /* binding */ suspend; }
});

// UNUSED EXPORTS: Any, Base64, Base64Url, BetweenBigDecimalTypeId, BetweenBigIntTypeId, BetweenDurationTypeId, BetweenTypeId, BigDecimal, BigDecimalFromNumber, BigDecimalFromSelf, BigInt, BigIntFromNumber, BigIntFromSelf, Boolean, BooleanFromUnknown, BrandTypeId, Cause, CauseDefectUnknown, CauseFromSelf, Char, Chunk, ChunkFromSelf, Class, Data, DataFromSelf, Date, DateFromSelf, DateFromString, Duration, DurationFromMillis, DurationFromNanos, DurationFromSelf, Either, EitherFromSelf, EitherFromUnion, EndsWithTypeId, Enums, Exit, ExitFromSelf, FiberId, FiberIdFromSelf, Finite, FiniteTypeId, FromPropertySignature, GreaterThanBigDecimalTypeId, GreaterThanBigIntTypeId, GreaterThanDurationTypeId, GreaterThanOrEqualToBigDecimalTypeId, GreaterThanOrEqualToBigIntTypeId, GreaterThanOrEqualToDurationTypeId, GreaterThanOrEqualToTypeId, GreaterThanTypeId, HashMap, HashMapFromSelf, HashSet, HashSetFromSelf, Hex, IncludesTypeId, InstanceOfTypeId, Int, IntTypeId, ItemsCountTypeId, JsonNumber, JsonNumberTypeId, LengthTypeId, LessThanBigDecimalTypeId, LessThanBigIntTypeId, LessThanDurationTypeId, LessThanOrEqualToBigDecimalTypeId, LessThanOrEqualToBigIntTypeId, LessThanOrEqualToDurationTypeId, LessThanOrEqualToTypeId, LessThanTypeId, List, ListFromSelf, Literal, Lowercase, Lowercased, LowercasedTypeId, Map, MapFromSelf, MaxItemsTypeId, MaxLengthTypeId, MinItemsTypeId, MinLengthTypeId, MultipleOfTypeId, Negative, NegativeBigDecimalFromSelf, NegativeBigDecimalTypeId, NegativeBigInt, NegativeBigIntFromSelf, Never, NonEmpty, NonEmptyArray, NonNaN, NonNaNTypeId, NonNegative, NonNegativeBigDecimalFromSelf, NonNegativeBigDecimalTypeId, NonNegativeBigInt, NonNegativeBigIntFromSelf, NonPositive, NonPositiveBigDecimalFromSelf, NonPositiveBigDecimalTypeId, NonPositiveBigInt, NonPositiveBigIntFromSelf, Not, Null, NullOr, NullishOr, NumberFromString, Option, OptionFromNullOr, OptionFromNullishOr, OptionFromSelf, OptionFromUndefinedOr, PatternTypeId, Positive, PositiveBigDecimalFromSelf, PositiveBigDecimalTypeId, PositiveBigInt, PositiveBigIntFromSelf, PropertySignatureDeclaration, PropertySignatureImpl, PropertySignatureTransformation, PropertySignatureTypeId, ReadonlyMap, ReadonlyMapFromSelf, ReadonlySet, ReadonlySetFromSelf, Secret, SecretFromSelf, Set, SetFromSelf, SortedSet, SortedSetFromSelf, StartsWithTypeId, Struct, Symbol, SymbolFromSelf, TaggedClass, TaggedError, TaggedRequest, TemplateLiteral, ToPropertySignature, Trim, Trimmed, TrimmedTypeId, Tuple, TypeId, ULID, ULIDTypeId, UUID, UUIDTypeId, Uint8Array, Undefined, UndefinedOr, UniqueSymbolFromSelf, Unknown, Uppercase, Uppercased, UppercasedTypeId, ValidDateFromSelf, ValidDateTypeId, Void, annotations, asBrandSchema, asSchema, asserts, attachPropertySignature, batching, between, betweenBigDecimal, betweenBigInt, betweenDuration, brand, clamp, clampBigDecimal, clampBigInt, clampDuration, compose, concurrency, declare, decode, decodeEither, decodeOption, decodePromise, decodeSync, decodeUnknown, decodeUnknownEither, decodeUnknownOption, decodeUnknownPromise, decodeUnknownSync, default, description, documentation, encode, encodeEither, encodeOption, encodePromise, encodeSync, encodeUnknown, encodeUnknownEither, encodeUnknownOption, encodeUnknownPromise, encodeUnknownSync, encodedSchema, endsWith, equivalence, examples, extend, filter, finite, format, fromBrand, fromKey, getNumberIndexedAccess, greaterThan, greaterThanBigDecimal, greaterThanBigInt, greaterThanDuration, greaterThanOrEqualTo, greaterThanOrEqualToBigDecimal, greaterThanOrEqualToBigInt, greaterThanOrEqualToDuration, hash, head, headOrElse, identifier, includes, instanceOf, int, is, isSchema, itemsCount, jsonSchema, keyof, length, lessThan, lessThanBigDecimal, lessThanBigInt, lessThanDuration, lessThanOrEqualTo, lessThanOrEqualToBigDecimal, lessThanOrEqualToBigInt, lessThanOrEqualToDuration, lowercased, make, maxItems, message, minItems, minLength, multipleOf, mutable, negative, negativeBigDecimal, negativeBigInt, nonEmpty, nonNaN, nonNegative, nonNegativeBigDecimal, nonNegativeBigInt, nonPositive, nonPositiveBigDecimal, nonPositiveBigInt, omit, optional, optionalElement, optionalToOptional, optionalToRequired, parseIssueTitle, partial, pattern, pick, pickLiteral, pluck, positive, positiveBigDecimal, positiveBigInt, propertySignature, rename, required, split, startsWith, title, transform, transformLiteral, transformLiterals, transformOrFail, trimmed, typeSchema, uppercased, validDate, validate, validateEither, validateOption, validatePromise, validateSync

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Array.js + 2 modules
var esm_Array = __webpack_require__(37901);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/BigDecimal.js
var BigDecimal = __webpack_require__(53954);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/BigInt.js
var esm_BigInt = __webpack_require__(37787);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Boolean.js
var Boolean = __webpack_require__(49349);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Duration.js
var Duration = __webpack_require__(13571);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Either.js
var Either = __webpack_require__(87585);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Encoding.js + 4 modules
var Encoding = __webpack_require__(53678);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equal.js
var esm_Equal = __webpack_require__(67492);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equivalence.js
var esm_Equivalence = __webpack_require__(27786);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/FiberId.js
var FiberId = __webpack_require__(57303);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Number.js
var esm_Number = __webpack_require__(15839);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var esm_Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Pipeable.js
var Pipeable = __webpack_require__(92817);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var esm_Predicate = __webpack_require__(71335);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/GlobalValue.js
var GlobalValue = __webpack_require__(4726);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Hash.js
var Hash = __webpack_require__(89379);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Inspectable.js
var Inspectable = __webpack_require__(16371);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/redacted.js







/** @internal */
const RedactedSymbolKey = "effect/Redacted";
/** @internal */
const redactedRegistry = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)("effect/Redacted/redactedRegistry", () => new WeakMap());
/** @internal */
const RedactedTypeId = /*#__PURE__*/Symbol.for(RedactedSymbolKey);
/** @internal */
const proto = {
  [RedactedTypeId]: {
    _A: _ => _
  },
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  },
  toString() {
    return "<redacted>";
  },
  toJSON() {
    return "<redacted>";
  },
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return "<redacted>";
  },
  [Hash/* symbol */.NA]() {
    return (0,Function/* pipe */.zG)(Hash/* hash */.vp(RedactedSymbolKey), Hash/* combine */.$e(Hash/* hash */.vp(redactedRegistry.get(this))), Hash/* cached */.HX(this));
  },
  [esm_Equal/* symbol */.NA](that) {
    return isRedacted(that) && esm_Equal/* equals */.fS(redactedRegistry.get(this), redactedRegistry.get(that));
  }
};
/** @internal */
const isRedacted = u => (0,esm_Predicate/* hasProperty */.l$)(u, RedactedTypeId);
/** @internal */
const make = value => {
  const redacted = Object.create(proto);
  redactedRegistry.set(redacted, value);
  return redacted;
};
/** @internal */
const value = self => {
  if (redactedRegistry.has(self)) {
    return redactedRegistry.get(self);
  } else {
    throw new Error("Unable to get redacted value");
  }
};
/** @internal */
const unsafeWipe = self => redactedRegistry.delete(self);
//# sourceMappingURL=redacted.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/secret.js



/**
 * @internal
 * @deprecated
 */
const SecretSymbolKey = "effect/Secret";
/**
 * @internal
 * @deprecated
 */
const SecretTypeId = /*#__PURE__*/Symbol.for(SecretSymbolKey);
/**
 * @internal
 * @deprecated
 */
const isSecret = u => (0,esm_Predicate/* hasProperty */.l$)(u, SecretTypeId);
const SecretProto = {
  ...proto,
  [SecretTypeId]: SecretTypeId
};
/**
 * @internal
 * @deprecated
 */
const secret_make = bytes => {
  const secret = Object.create(SecretProto);
  Object.defineProperty(secret, "toString", {
    enumerable: false,
    value() {
      return "Secret(<redacted>)";
    }
  });
  Object.defineProperty(secret, "toJSON", {
    enumerable: false,
    value() {
      return "<redacted>";
    }
  });
  Object.defineProperty(secret, "raw", {
    enumerable: false,
    value: bytes
  });
  redactedRegistry.set(secret, bytes.map(byte => String.fromCharCode(byte)).join(""));
  return secret;
};
/**
 * @internal
 * @deprecated
 */
const fromIterable = iterable => secret_make(esm_Array/* fromIterable */.EE(iterable).map(char => char.charCodeAt(0)));
/**
 * @internal
 * @deprecated
 */
const fromString = text => {
  return secret_make(text.split("").map(char => char.charCodeAt(0)));
};
/**
 * @internal
 * @deprecated
 */
const secret_value = self => {
  return self.raw.map(byte => String.fromCharCode(byte)).join("");
};
/**
 * @internal
 * @deprecated
 */
const secret_unsafeWipe = self => {
  for (let i = 0; i < self.raw.length; i++) {
    self.raw[i] = 0;
  }
  redactedRegistry["delete"](self);
};
//# sourceMappingURL=secret.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/Secret.js

/**
 * @since 2.0.0
 * @category symbols
 * @deprecated
 */
const Secret_SecretTypeId = SecretTypeId;
/**
 * @since 2.0.0
 * @category refinements
 * @deprecated
 */
const Secret_isSecret = isSecret;
/**
 * @since 2.0.0
 * @category constructors
 * @deprecated
 */
const Secret_make = secret_make;
/**
 * @since 2.0.0
 * @category constructors
 * @deprecated
 */
const Secret_fromIterable = fromIterable;
/**
 * @since 2.0.0
 * @category constructors
 * @deprecated
 */
const Secret_fromString = fromString;
/**
 * @since 2.0.0
 * @category getters
 * @deprecated
 */
const Secret_value = secret_value;
/**
 * @since 2.0.0
 * @category unsafe
 * @deprecated
 */
const Secret_unsafeWipe = secret_unsafeWipe;
//# sourceMappingURL=Secret.js.map
;// CONCATENATED MODULE: ./node_modules/@effect/schema/dist/esm/Arbitrary.js
/**
 * @since 1.0.0
 */








/**
 * @category hooks
 * @since 1.0.0
 */
const ArbitraryHookId = /*#__PURE__*/Symbol.for("@effect/schema/ArbitraryHookId");
/**
 * @category annotations
 * @since 1.0.0
 */
const arbitrary = handler => self => self.annotations({
  [ArbitraryHookId]: handler
});
/**
 * Returns a LazyArbitrary for the `A` type of the provided schema.
 *
 * @category arbitrary
 * @since 1.0.0
 */
const makeLazy = schema => go(schema.ast, {});
/**
 * Returns a fast-check Arbitrary for the `A` type of the provided schema.
 *
 * @category arbitrary
 * @since 1.0.0
 */
const Arbitrary_make = schema => makeLazy(schema)(FastCheck);
const depthSize = 1;
const record = (fc, key, value, options) => {
  return (options.isSuspend ? fc.oneof({
    depthSize
  }, fc.constant([]), fc.array(fc.tuple(key, value), {
    minLength: 1,
    maxLength: 2
  })) : fc.array(fc.tuple(key, value))).map(tuples => {
    const out = {};
    for (const [k, v] of tuples) {
      out[k] = v;
    }
    return out;
  });
};
const getHook = /*#__PURE__*/(/* unused pure expression or super */ null && (AST.getAnnotation(ArbitraryHookId)));
const getRefinementFromArbitrary = (ast, options) => {
  const constraints = combineConstraints(options.constraints, getConstraints(ast));
  return go(ast.from, constraints ? {
    ...options,
    constraints
  } : options);
};
const go = (ast, options) => {
  const hook = getHook(ast);
  if (Option.isSome(hook)) {
    switch (ast._tag) {
      case "Declaration":
        return hook.value(...ast.typeParameters.map(p => go(p, options)));
      case "Refinement":
        return hook.value(getRefinementFromArbitrary(ast, options));
      default:
        return hook.value();
    }
  }
  switch (ast._tag) {
    case "Declaration":
      {
        throw new Error(errors_.getArbitraryErrorMessage(`a declaration without annotations (${ast})`));
      }
    case "Literal":
      return fc => fc.constant(ast.literal);
    case "UniqueSymbol":
      return fc => fc.constant(ast.symbol);
    case "UndefinedKeyword":
    case "VoidKeyword":
      return fc => fc.constant(undefined);
    case "NeverKeyword":
      return () => {
        throw new Error(errors_.getArbitraryErrorMessage("`never`"));
      };
    case "UnknownKeyword":
    case "AnyKeyword":
      return fc => fc.anything();
    case "StringKeyword":
      return fc => {
        if (options.constraints) {
          switch (options.constraints._tag) {
            case "StringConstraints":
              return fc.string(options.constraints.constraints);
          }
        }
        return fc.string();
      };
    case "NumberKeyword":
      return fc => {
        if (options.constraints) {
          switch (options.constraints._tag) {
            case "NumberConstraints":
              return fc.float(options.constraints.constraints);
            case "IntegerConstraints":
              return fc.integer(options.constraints.constraints);
          }
        }
        return fc.float();
      };
    case "BooleanKeyword":
      return fc => fc.boolean();
    case "BigIntKeyword":
      return fc => {
        if (options.constraints) {
          switch (options.constraints._tag) {
            case "BigIntConstraints":
              return fc.bigInt(options.constraints.constraints);
          }
        }
        return fc.bigInt();
      };
    case "SymbolKeyword":
      return fc => fc.string().map(s => Symbol.for(s));
    case "ObjectKeyword":
      return fc => fc.oneof(fc.object(), fc.array(fc.anything()));
    case "TemplateLiteral":
      {
        return fc => {
          const string = fc.string({
            maxLength: 5
          });
          const number = fc.float({
            noDefaultInfinity: true
          }).filter(n => !Number.isNaN(n));
          const components = [fc.constant(ast.head)];
          for (const span of ast.spans) {
            if (AST.isStringKeyword(span.type)) {
              components.push(string);
            } else {
              components.push(number);
            }
            components.push(fc.constant(span.literal));
          }
          return fc.tuple(...components).map(spans => spans.join(""));
        };
      }
    case "TupleType":
      {
        const elements = [];
        let hasOptionals = false;
        for (const element of ast.elements) {
          elements.push(go(element.type, options));
          if (element.isOptional) {
            hasOptionals = true;
          }
        }
        const rest = ast.rest.map(e => go(e, options));
        return fc => {
          // ---------------------------------------------
          // handle elements
          // ---------------------------------------------
          let output = fc.tuple(...elements.map(arb => arb(fc)));
          if (hasOptionals) {
            const indexes = fc.tuple(...ast.elements.map(element => element.isOptional ? fc.boolean() : fc.constant(true)));
            output = output.chain(tuple => indexes.map(booleans => {
              for (const [i, b] of booleans.reverse().entries()) {
                if (!b) {
                  tuple.splice(booleans.length - i, 1);
                }
              }
              return tuple;
            }));
          }
          // ---------------------------------------------
          // handle rest element
          // ---------------------------------------------
          if (Arr.isNonEmptyReadonlyArray(rest)) {
            const [head, ...tail] = rest;
            const arb = head(fc);
            const constraints = options.constraints;
            output = output.chain(as => {
              let out = fc.array(arb);
              if (options.isSuspend) {
                out = fc.oneof({
                  depthSize
                }, fc.constant([]), fc.array(arb, {
                  minLength: 1,
                  maxLength: 2
                }));
              } else if (constraints && constraints._tag === "ArrayConstraints") {
                out = fc.array(arb, constraints.constraints);
              }
              return out.map(rest => [...as, ...rest]);
            });
            // ---------------------------------------------
            // handle post rest elements
            // ---------------------------------------------
            for (let j = 0; j < tail.length; j++) {
              output = output.chain(as => tail[j](fc).map(a => [...as, a]));
            }
          }
          return output;
        };
      }
    case "TypeLiteral":
      {
        const propertySignaturesTypes = ast.propertySignatures.map(f => go(f.type, options));
        const indexSignatures = ast.indexSignatures.map(is => [go(is.parameter, options), go(is.type, options)]);
        return fc => {
          const arbs = {};
          const requiredKeys = [];
          // ---------------------------------------------
          // handle property signatures
          // ---------------------------------------------
          for (let i = 0; i < propertySignaturesTypes.length; i++) {
            const ps = ast.propertySignatures[i];
            const name = ps.name;
            if (!ps.isOptional) {
              requiredKeys.push(name);
            }
            arbs[name] = propertySignaturesTypes[i](fc);
          }
          let output = fc.record(arbs, {
            requiredKeys
          });
          // ---------------------------------------------
          // handle index signatures
          // ---------------------------------------------
          for (let i = 0; i < indexSignatures.length; i++) {
            const parameter = indexSignatures[i][0](fc);
            const type = indexSignatures[i][1](fc);
            output = output.chain(o => {
              return record(fc, parameter, type, options).map(d => ({
                ...d,
                ...o
              }));
            });
          }
          return output;
        };
      }
    case "Union":
      {
        const types = ast.types.map(t => go(t, options));
        return fc => fc.oneof({
          depthSize
        }, ...types.map(arb => arb(fc)));
      }
    case "Enums":
      {
        if (ast.enums.length === 0) {
          throw new Error(errors_.getArbitraryErrorMessage("an empty enum"));
        }
        return fc => fc.oneof(...ast.enums.map(([_, value]) => fc.constant(value)));
      }
    case "Refinement":
      {
        const from = getRefinementFromArbitrary(ast, options);
        return fc => from(fc).filter(a => Option.isNone(ast.filter(a, AST.defaultParseOption, ast)));
      }
    case "Suspend":
      {
        const get = util_.memoizeThunk(() => go(ast.f(), {
          ...options,
          isSuspend: true
        }));
        return fc => fc.constant(null).chain(() => get()(fc));
      }
    case "Transformation":
      return go(ast.to, options);
  }
};
/** @internal */
class NumberConstraints {
  _tag = "NumberConstraints";
  constraints;
  constructor(options) {
    this.constraints = {};
    if (Predicate.isNumber(options.min)) {
      this.constraints.min = Math.fround(options.min);
    }
    if (Predicate.isNumber(options.max)) {
      this.constraints.max = Math.fround(options.max);
    }
    if (Predicate.isBoolean(options.noNaN)) {
      this.constraints.noNaN = options.noNaN;
    }
    if (Predicate.isBoolean(options.noDefaultInfinity)) {
      this.constraints.noDefaultInfinity = options.noDefaultInfinity;
    }
  }
}
/** @internal */
class StringConstraints {
  _tag = "StringConstraints";
  constraints;
  constructor(options) {
    this.constraints = {};
    if (Predicate.isNumber(options.minLength)) {
      this.constraints.minLength = options.minLength;
    }
    if (Predicate.isNumber(options.maxLength)) {
      this.constraints.maxLength = options.maxLength;
    }
  }
}
/** @internal */
class IntegerConstraints {
  _tag = "IntegerConstraints";
  constraints;
  constructor(options) {
    this.constraints = {};
    if (Predicate.isNumber(options.min)) {
      this.constraints.min = options.min;
    }
    if (Predicate.isNumber(options.max)) {
      this.constraints.max = options.max;
    }
  }
}
/** @internal */
class ArrayConstraints {
  _tag = "ArrayConstraints";
  constraints;
  constructor(options) {
    this.constraints = {};
    if (Predicate.isNumber(options.minLength)) {
      this.constraints.minLength = options.minLength;
    }
    if (Predicate.isNumber(options.maxLength)) {
      this.constraints.maxLength = options.maxLength;
    }
  }
}
/** @internal */
class BigIntConstraints {
  _tag = "BigIntConstraints";
  constraints;
  constructor(options) {
    this.constraints = {};
    if (Predicate.isBigInt(options.min)) {
      this.constraints.min = options.min;
    }
    if (Predicate.isBigInt(options.max)) {
      this.constraints.max = options.max;
    }
  }
}
/** @internal */
const getConstraints = ast => {
  const TypeAnnotationId = ast.annotations[AST.TypeAnnotationId];
  const jsonSchema = ast.annotations[AST.JSONSchemaAnnotationId];
  switch (TypeAnnotationId) {
    // int
    case filters_.IntTypeId:
      return new IntegerConstraints({});
    // number
    case filters_.GreaterThanTypeId:
    case filters_.GreaterThanOrEqualToTypeId:
    case filters_.LessThanTypeId:
    case filters_.LessThanOrEqualToTypeId:
    case filters_.BetweenTypeId:
      return new NumberConstraints({
        min: jsonSchema.exclusiveMinimum ?? jsonSchema.minimum,
        max: jsonSchema.exclusiveMaximum ?? jsonSchema.maximum
      });
    // bigint
    case filters_.GreaterThanBigintTypeId:
    case filters_.GreaterThanOrEqualToBigIntTypeId:
    case filters_.LessThanBigIntTypeId:
    case filters_.LessThanOrEqualToBigIntTypeId:
    case filters_.BetweenBigintTypeId:
      {
        const constraints = ast.annotations[TypeAnnotationId];
        return new BigIntConstraints(constraints);
      }
    // string
    case filters_.MinLengthTypeId:
    case filters_.MaxLengthTypeId:
    case filters_.LengthTypeId:
      return new StringConstraints(jsonSchema);
    // array
    case filters_.MinItemsTypeId:
    case filters_.MaxItemsTypeId:
    case filters_.ItemsCountTypeId:
      return new ArrayConstraints({
        minLength: jsonSchema.minItems,
        maxLength: jsonSchema.maxItems
      });
  }
};
/** @internal */
const combineConstraints = (c1, c2) => {
  if (c1 === undefined) {
    return c2;
  }
  if (c2 === undefined) {
    return c1;
  }
  switch (c1._tag) {
    case "ArrayConstraints":
      {
        switch (c2._tag) {
          case "ArrayConstraints":
            return new ArrayConstraints({
              minLength: getMax(c1.constraints.minLength, c2.constraints.minLength),
              maxLength: getMin(c1.constraints.maxLength, c2.constraints.maxLength)
            });
        }
        break;
      }
    case "NumberConstraints":
      {
        switch (c2._tag) {
          case "NumberConstraints":
            return new NumberConstraints({
              min: getMax(c1.constraints.min, c2.constraints.min),
              max: getMin(c1.constraints.max, c2.constraints.max),
              noNaN: getOr(c1.constraints.noNaN, c2.constraints.noNaN),
              noDefaultInfinity: getOr(c1.constraints.noDefaultInfinity, c2.constraints.noDefaultInfinity)
            });
          case "IntegerConstraints":
            return new IntegerConstraints({
              min: getMax(c1.constraints.min, c2.constraints.min),
              max: getMin(c1.constraints.max, c2.constraints.max)
            });
        }
        break;
      }
    case "BigIntConstraints":
      {
        switch (c2._tag) {
          case "BigIntConstraints":
            return new BigIntConstraints({
              min: getMax(c1.constraints.min, c2.constraints.min),
              max: getMin(c1.constraints.max, c2.constraints.max)
            });
        }
        break;
      }
    case "StringConstraints":
      {
        switch (c2._tag) {
          case "StringConstraints":
            return new StringConstraints({
              minLength: getMax(c1.constraints.minLength, c2.constraints.minLength),
              maxLength: getMin(c1.constraints.maxLength, c2.constraints.maxLength)
            });
        }
        break;
      }
    case "IntegerConstraints":
      {
        switch (c2._tag) {
          case "NumberConstraints":
          case "IntegerConstraints":
            {
              return new IntegerConstraints({
                min: getMax(c1.constraints.min, c2.constraints.min),
                max: getMin(c1.constraints.max, c2.constraints.max)
              });
            }
        }
        break;
      }
  }
};
const getOr = (a, b) => {
  return a === undefined ? b : b === undefined ? a : a || b;
};
function getMax(n1, n2) {
  return n1 === undefined ? n2 : n2 === undefined ? n1 : n1 <= n2 ? n2 : n1;
}
function getMin(n1, n2) {
  return n1 === undefined ? n2 : n2 === undefined ? n1 : n1 <= n2 ? n1 : n2;
}
//# sourceMappingURL=Arbitrary.js.map
// EXTERNAL MODULE: ./node_modules/@effect/schema/dist/esm/AST.js
var esm_AST = __webpack_require__(24799);
;// CONCATENATED MODULE: ./node_modules/@effect/schema/dist/esm/Equivalence.js
/**
 * @since 1.0.0
 */









/**
 * @category hooks
 * @since 1.0.0
 */
const EquivalenceHookId = /*#__PURE__*/Symbol.for("@effect/schema/EquivalenceHookId");
/**
 * @category annotations
 * @since 1.0.0
 */
const equivalence = handler => self => self.annotations({
  [EquivalenceHookId]: handler
});
/**
 * @category Equivalence
 * @since 1.0.0
 */
const Equivalence_make = schema => Equivalence_go(schema.ast);
const Equivalence_getHook = /*#__PURE__*/(/* unused pure expression or super */ null && (AST.getAnnotation(EquivalenceHookId)));
const Equivalence_go = ast => {
  const hook = Equivalence_getHook(ast);
  if (Option.isSome(hook)) {
    switch (ast._tag) {
      case "Declaration":
        return hook.value(...ast.typeParameters.map(Equivalence_go));
      case "Refinement":
        return hook.value(Equivalence_go(ast.from));
      default:
        return hook.value();
    }
  }
  switch (ast._tag) {
    case "NeverKeyword":
      throw new Error(errors_.getEquivalenceErrorMessage("`never`"));
    case "Transformation":
      return Equivalence_go(ast.to);
    case "Declaration":
    case "Literal":
    case "StringKeyword":
    case "TemplateLiteral":
    case "UniqueSymbol":
    case "SymbolKeyword":
    case "UnknownKeyword":
    case "AnyKeyword":
    case "NumberKeyword":
    case "BooleanKeyword":
    case "BigIntKeyword":
    case "UndefinedKeyword":
    case "VoidKeyword":
    case "Enums":
    case "ObjectKeyword":
      return Equal.equals;
    case "Refinement":
      return Equivalence_go(ast.from);
    case "Suspend":
      {
        const get = util_.memoizeThunk(() => Equivalence_go(ast.f()));
        return (a, b) => get()(a, b);
      }
    case "TupleType":
      {
        const elements = ast.elements.map(element => Equivalence_go(element.type));
        const rest = ast.rest.map(Equivalence_go);
        return Equivalence.make((a, b) => {
          const len = a.length;
          if (len !== b.length) {
            return false;
          }
          // ---------------------------------------------
          // handle elements
          // ---------------------------------------------
          let i = 0;
          for (; i < Math.min(len, ast.elements.length); i++) {
            if (!elements[i](a[i], b[i])) {
              return false;
            }
          }
          // ---------------------------------------------
          // handle rest element
          // ---------------------------------------------
          if (Arr.isNonEmptyReadonlyArray(rest)) {
            const [head, ...tail] = rest;
            for (; i < len - tail.length; i++) {
              if (!head(a[i], b[i])) {
                return false;
              }
            }
            // ---------------------------------------------
            // handle post rest elements
            // ---------------------------------------------
            for (let j = 0; j < tail.length; j++) {
              i += j;
              if (!tail[j](a[i], b[i])) {
                return false;
              }
            }
          }
          return true;
        });
      }
    case "TypeLiteral":
      {
        if (ast.propertySignatures.length === 0 && ast.indexSignatures.length === 0) {
          return Equal.equals;
        }
        const propertySignatures = ast.propertySignatures.map(ps => Equivalence_go(ps.type));
        const indexSignatures = ast.indexSignatures.map(is => Equivalence_go(is.type));
        return Equivalence.make((a, b) => {
          const aStringKeys = Object.keys(a);
          const aSymbolKeys = Object.getOwnPropertySymbols(a);
          // ---------------------------------------------
          // handle property signatures
          // ---------------------------------------------
          for (let i = 0; i < propertySignatures.length; i++) {
            const ps = ast.propertySignatures[i];
            const name = ps.name;
            const aHas = Object.prototype.hasOwnProperty.call(a, name);
            const bHas = Object.prototype.hasOwnProperty.call(b, name);
            if (ps.isOptional) {
              if (aHas !== bHas) {
                return false;
              }
            }
            if (aHas && bHas && !propertySignatures[i](a[name], b[name])) {
              return false;
            }
          }
          // ---------------------------------------------
          // handle index signatures
          // ---------------------------------------------
          let bSymbolKeys;
          let bStringKeys;
          for (let i = 0; i < indexSignatures.length; i++) {
            const is = ast.indexSignatures[i];
            const base = AST.getParameterBase(is.parameter);
            const isSymbol = AST.isSymbolKeyword(base);
            if (isSymbol) {
              bSymbolKeys = bSymbolKeys || Object.getOwnPropertySymbols(b);
              if (aSymbolKeys.length !== bSymbolKeys.length) {
                return false;
              }
            } else {
              bStringKeys = bStringKeys || Object.keys(b);
              if (aStringKeys.length !== bStringKeys.length) {
                return false;
              }
            }
            const aKeys = isSymbol ? aSymbolKeys : aStringKeys;
            for (let j = 0; j < aKeys.length; j++) {
              const key = aKeys[j];
              if (!Object.prototype.hasOwnProperty.call(b, key) || !indexSignatures[i](a[key], b[key])) {
                return false;
              }
            }
          }
          return true;
        });
      }
    case "Union":
      {
        const searchTree = ParseResult.getSearchTree(ast.types, true);
        const ownKeys = util_.ownKeys(searchTree.keys);
        const len = ownKeys.length;
        return Equivalence.make((a, b) => {
          let candidates = [];
          if (len > 0 && Predicate.isRecord(a)) {
            for (let i = 0; i < len; i++) {
              const name = ownKeys[i];
              const buckets = searchTree.keys[name].buckets;
              if (Object.prototype.hasOwnProperty.call(a, name)) {
                const literal = String(a[name]);
                if (Object.prototype.hasOwnProperty.call(buckets, literal)) {
                  candidates = candidates.concat(buckets[literal]);
                }
              }
            }
          }
          if (searchTree.otherwise.length > 0) {
            candidates = candidates.concat(searchTree.otherwise);
          }
          const tuples = candidates.map(ast => [Equivalence_go(ast), ParseResult.is({
            ast
          })]);
          for (let i = 0; i < tuples.length; i++) {
            const [equivalence, is] = tuples[i];
            if (is(a) && is(b)) {
              if (equivalence(a, b)) {
                return true;
              }
            }
          }
          return false;
        });
      }
  }
};
//# sourceMappingURL=Equivalence.js.map
;// CONCATENATED MODULE: ./node_modules/@effect/schema/dist/esm/internal/filters.js
/** @internal */
const GreaterThanTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/GreaterThan");
/** @internal */
const GreaterThanOrEqualToTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/GreaterThanOrEqualTo");
/** @internal */
const LessThanTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/LessThan");
/** @internal */
const LessThanOrEqualToTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/LessThanOrEqualTo");
/** @internal */
const IntTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Int");
/** @internal */
const BetweenTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Between");
/** @internal */
const GreaterThanBigintTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/GreaterThanBigint");
/** @internal */
const GreaterThanOrEqualToBigIntTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/GreaterThanOrEqualToBigint");
/** @internal */
const LessThanBigIntTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/LessThanBigint");
/** @internal */
const LessThanOrEqualToBigIntTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/LessThanOrEqualToBigint");
/** @internal */
const BetweenBigintTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/BetweenBigint");
/** @internal */
const MinLengthTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/MinLength");
/** @internal */
const MaxLengthTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/MaxLength");
/** @internal */
const LengthTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Length");
/** @internal */
const MinItemsTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/MinItems");
/** @internal */
const MaxItemsTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/MaxItems");
/** @internal */
const ItemsCountTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/ItemsCount");
//# sourceMappingURL=filters.js.map
// EXTERNAL MODULE: ./node_modules/@effect/schema/dist/esm/internal/util.js
var util = __webpack_require__(10852);
// EXTERNAL MODULE: ./node_modules/@effect/schema/dist/esm/ParseResult.js + 1 modules
var esm_ParseResult = __webpack_require__(6137);
// EXTERNAL MODULE: ./node_modules/@effect/schema/dist/esm/internal/errors.js
var errors = __webpack_require__(48147);
;// CONCATENATED MODULE: ./node_modules/@effect/schema/dist/esm/Pretty.js
/**
 * @since 1.0.0
 */






/**
 * @category hooks
 * @since 1.0.0
 */
const PrettyHookId = /*#__PURE__*/Symbol.for("@effect/schema/PrettyHookId");
/**
 * @category annotations
 * @since 1.0.0
 */
const pretty = handler => self => self.annotations({
  [PrettyHookId]: handler
});
/**
 * @category prettify
 * @since 1.0.0
 */
const Pretty_make = schema => compile(schema.ast);
const Pretty_getHook = /*#__PURE__*/esm_AST/* getAnnotation */.AR(PrettyHookId);
const getMatcher = defaultPretty => ast => esm_Option/* match */.EQ(Pretty_getHook(ast), {
  onNone: () => defaultPretty,
  onSome: handler => handler()
});
const Pretty_toString = /*#__PURE__*/getMatcher(a => String(a));
const stringify = /*#__PURE__*/getMatcher(a => JSON.stringify(a));
const formatUnknown = /*#__PURE__*/getMatcher(util/* formatUnknown */.cT);
/**
 * @since 1.0.0
 */
const match = {
  "Declaration": (ast, go) => {
    const hook = Pretty_getHook(ast);
    if (esm_Option/* isSome */.pC(hook)) {
      return hook.value(...ast.typeParameters.map(go));
    }
    throw new Error(errors/* getPrettyErrorMessage */.dp(`a declaration without annotations (${ast})`));
  },
  "VoidKeyword": /*#__PURE__*/getMatcher(() => "void(0)"),
  "NeverKeyword": /*#__PURE__*/getMatcher(() => {
    throw new Error("cannot pretty print a `never` value");
  }),
  "Literal": /*#__PURE__*/getMatcher(literal => typeof literal === "bigint" ? `${String(literal)}n` : JSON.stringify(literal)),
  "SymbolKeyword": Pretty_toString,
  "UniqueSymbol": Pretty_toString,
  "TemplateLiteral": stringify,
  "UndefinedKeyword": Pretty_toString,
  "UnknownKeyword": formatUnknown,
  "AnyKeyword": formatUnknown,
  "ObjectKeyword": formatUnknown,
  "StringKeyword": stringify,
  "NumberKeyword": Pretty_toString,
  "BooleanKeyword": Pretty_toString,
  "BigIntKeyword": /*#__PURE__*/getMatcher(a => `${String(a)}n`),
  "Enums": stringify,
  "TupleType": (ast, go) => {
    const hook = Pretty_getHook(ast);
    if (esm_Option/* isSome */.pC(hook)) {
      return hook.value();
    }
    const elements = ast.elements.map(e => go(e.type));
    const rest = ast.rest.map(go);
    return input => {
      const output = [];
      let i = 0;
      // ---------------------------------------------
      // handle elements
      // ---------------------------------------------
      for (; i < elements.length; i++) {
        if (input.length < i + 1) {
          if (ast.elements[i].isOptional) {
            continue;
          }
        } else {
          output.push(elements[i](input[i]));
        }
      }
      // ---------------------------------------------
      // handle rest element
      // ---------------------------------------------
      if (esm_Array/* isNonEmptyReadonlyArray */.Ux(rest)) {
        const [head, ...tail] = rest;
        for (; i < input.length - tail.length; i++) {
          output.push(head(input[i]));
        }
        // ---------------------------------------------
        // handle post rest elements
        // ---------------------------------------------
        for (let j = 0; j < tail.length; j++) {
          i += j;
          output.push(tail[j](input[i]));
        }
      }
      return "[" + output.join(", ") + "]";
    };
  },
  "TypeLiteral": (ast, go) => {
    const hook = Pretty_getHook(ast);
    if (esm_Option/* isSome */.pC(hook)) {
      return hook.value();
    }
    const propertySignaturesTypes = ast.propertySignatures.map(f => go(f.type));
    const indexSignatureTypes = ast.indexSignatures.map(is => go(is.type));
    const expectedKeys = {};
    for (let i = 0; i < propertySignaturesTypes.length; i++) {
      expectedKeys[ast.propertySignatures[i].name] = null;
    }
    return input => {
      const output = [];
      // ---------------------------------------------
      // handle property signatures
      // ---------------------------------------------
      for (let i = 0; i < propertySignaturesTypes.length; i++) {
        const ps = ast.propertySignatures[i];
        const name = ps.name;
        if (ps.isOptional && !Object.prototype.hasOwnProperty.call(input, name)) {
          continue;
        }
        output.push(`${util/* formatPropertyKey */.AH(name)}: ${propertySignaturesTypes[i](input[name])}`);
      }
      // ---------------------------------------------
      // handle index signatures
      // ---------------------------------------------
      if (indexSignatureTypes.length > 0) {
        for (let i = 0; i < indexSignatureTypes.length; i++) {
          const type = indexSignatureTypes[i];
          const keys = util/* getKeysForIndexSignature */.k8(input, ast.indexSignatures[i].parameter);
          for (const key of keys) {
            if (Object.prototype.hasOwnProperty.call(expectedKeys, key)) {
              continue;
            }
            output.push(`${util/* formatPropertyKey */.AH(key)}: ${type(input[key])}`);
          }
        }
      }
      return esm_Array/* isNonEmptyReadonlyArray */.Ux(output) ? "{ " + output.join(", ") + " }" : "{}";
    };
  },
  "Union": (ast, go) => {
    const hook = Pretty_getHook(ast);
    if (esm_Option/* isSome */.pC(hook)) {
      return hook.value();
    }
    const types = ast.types.map(ast => [esm_ParseResult.is({
      ast
    }), go(ast)]);
    return a => {
      const index = types.findIndex(([is]) => is(a));
      return types[index][1](a);
    };
  },
  "Suspend": (ast, go) => {
    return esm_Option/* match */.EQ(Pretty_getHook(ast), {
      onNone: () => {
        const get = util/* memoizeThunk */.d3(() => go(ast.f()));
        return a => get()(a);
      },
      onSome: handler => handler()
    });
  },
  "Refinement": (ast, go) => {
    return esm_Option/* match */.EQ(Pretty_getHook(ast), {
      onNone: () => go(ast.from),
      onSome: handler => handler()
    });
  },
  "Transformation": (ast, go) => {
    return esm_Option/* match */.EQ(Pretty_getHook(ast), {
      onNone: () => go(ast.to),
      onSome: handler => handler()
    });
  }
};
const compile = /*#__PURE__*/(/* unused pure expression or super */ null && (AST.getCompiler(match)));
//# sourceMappingURL=Pretty.js.map
;// CONCATENATED MODULE: ./node_modules/@effect/schema/dist/esm/Schema.js
/**
 * @since 1.0.0
 */






































/**
 * @since 1.0.0
 * @category symbol
 */
const TypeId = /*#__PURE__*/Symbol.for("@effect/schema/Schema");
const variance = {
  /* c8 ignore next */
  _A: _ => _,
  /* c8 ignore next */
  _I: _ => _,
  /* c8 ignore next */
  _R: _ => _
};
const toASTAnnotations = annotations => {
  if (!annotations) {
    return {};
  }
  const out = {};
  // symbols are reserved for custom annotations
  const custom = Object.getOwnPropertySymbols(annotations);
  for (const sym of custom) {
    out[sym] = annotations[sym];
  }
  // string keys are reserved as /schema namespace
  if (annotations.typeId !== undefined) {
    const typeId = annotations.typeId;
    if (typeof typeId === "object") {
      out[esm_AST/* TypeAnnotationId */.I4] = typeId.id;
      out[typeId.id] = typeId.annotation;
    } else {
      out[esm_AST/* TypeAnnotationId */.I4] = typeId;
    }
  }
  const move = (from, to) => {
    if (annotations[from] !== undefined) {
      out[to] = annotations[from];
    }
  };
  move("message", esm_AST/* MessageAnnotationId */.eg);
  move("identifier", esm_AST/* IdentifierAnnotationId */.CA);
  move("title", esm_AST/* TitleAnnotationId */.Lf);
  move("description", esm_AST/* DescriptionAnnotationId */.Aj);
  move("examples", esm_AST/* ExamplesAnnotationId */.by);
  move("default", esm_AST/* DefaultAnnotationId */.w9);
  move("documentation", esm_AST/* DocumentationAnnotationId */.Nh);
  move("jsonSchema", esm_AST/* JSONSchemaAnnotationId */.aN);
  move("arbitrary", ArbitraryHookId);
  move("pretty", PrettyHookId);
  move("equivalence", EquivalenceHookId);
  move("concurrency", esm_AST/* ConcurrencyAnnotationId */.Q7);
  move("batching", esm_AST/* BatchingAnnotationId */.oA);
  move("parseIssueTitle", esm_AST/* ParseIssueTitleAnnotationId */.Uy);
  return out;
};
class SchemaImpl {
  ast;
  [TypeId] = variance;
  constructor(ast) {
    this.ast = ast;
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
  annotations(annotations) {
    return new SchemaImpl(esm_AST/* annotations */.ds(this.ast, toASTAnnotations(annotations)));
  }
  toString() {
    return String(this.ast);
  }
}
/**
 * @since 1.0.0
 */
const asSchema = schema => schema;
/**
 * @category hashing
 * @since 1.0.0
 */
const hash = schema => AST.hash(schema.ast);
/**
 * @category formatting
 * @since 1.0.0
 */
const format = schema => String(schema.ast);
/**
 * @since 1.0.0
 */
const encodedSchema = schema => Schema_make(AST.encodedAST(schema.ast));
/**
 * @since 1.0.0
 */
const typeSchema = schema => Schema_make(AST.typeAST(schema.ast));
/* c8 ignore start */

/* c8 ignore end */
/**
 * @category encoding
 * @since 1.0.0
 */
const encodeUnknown = (schema, options) => {
  const encodeUnknown = ParseResult.encodeUnknown(schema, options);
  return (u, overrideOptions) => ParseResult.mapError(encodeUnknown(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category encoding
 * @since 1.0.0
 */
const encodeUnknownEither = (schema, options) => {
  const encodeUnknownEither = ParseResult.encodeUnknownEither(schema, options);
  return (u, overrideOptions) => either_.mapLeft(encodeUnknownEither(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category encoding
 * @since 1.0.0
 */
const encodeUnknownPromise = (schema, options) => {
  const parser = encodeUnknown(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category encoding
 * @since 1.0.0
 */
const encode = (/* unused pure expression or super */ null && (encodeUnknown));
/**
 * @category encoding
 * @since 1.0.0
 */
const encodeEither = (/* unused pure expression or super */ null && (encodeUnknownEither));
/**
 * @category encoding
 * @since 1.0.0
 */
const encodePromise = (/* unused pure expression or super */ null && (encodeUnknownPromise));
/**
 * @category decoding
 * @since 1.0.0
 */
const decodeUnknown = (schema, options) => {
  const decodeUnknown = ParseResult.decodeUnknown(schema, options);
  return (u, overrideOptions) => ParseResult.mapError(decodeUnknown(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category decoding
 * @since 1.0.0
 */
const decodeUnknownEither = (schema, options) => {
  const decodeUnknownEither = ParseResult.decodeUnknownEither(schema, options);
  return (u, overrideOptions) => either_.mapLeft(decodeUnknownEither(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category decoding
 * @since 1.0.0
 */
const decodeUnknownPromise = (schema, options) => {
  const parser = decodeUnknown(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category decoding
 * @since 1.0.0
 */
const decode = (/* unused pure expression or super */ null && (decodeUnknown));
/**
 * @category decoding
 * @since 1.0.0
 */
const decodeEither = (/* unused pure expression or super */ null && (decodeUnknownEither));
/**
 * @category decoding
 * @since 1.0.0
 */
const decodePromise = (/* unused pure expression or super */ null && (decodeUnknownPromise));
/**
 * @category validation
 * @since 1.0.0
 */
const validate = (schema, options) => {
  const validate = ParseResult.validate(schema, options);
  return (u, overrideOptions) => ParseResult.mapError(validate(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category validation
 * @since 1.0.0
 */
const validateEither = (schema, options) => {
  const validateEither = ParseResult.validateEither(schema, options);
  return (u, overrideOptions) => either_.mapLeft(validateEither(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category validation
 * @since 1.0.0
 */
const validatePromise = (schema, options) => {
  const parser = validate(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * Tests if a value is a `Schema`.
 *
 * @category guards
 * @since 1.0.0
 */
const isSchema = u => esm_Predicate/* hasProperty */.l$(u, TypeId) && esm_Predicate/* isObject */.Kn(u[TypeId]);
/**
 * @category constructors
 * @since 1.0.0
 */
const Schema_make = ast => new SchemaImpl(ast);
class LiteralImpl extends SchemaImpl {
  static ast = literals => {
    return esm_AST/* isMembers */.Jg(literals) ? esm_AST/* Union.make */.EJ.make(esm_AST/* mapMembers */.GY(literals, literal => new esm_AST/* Literal */.t$(literal))) : new esm_AST/* Literal */.t$(literals[0]);
  };
  literals;
  constructor(literals, ast = LiteralImpl.ast(literals)) {
    super(ast);
    this.literals = [...literals];
  }
  annotations(annotations) {
    return new LiteralImpl(this.literals, esm_AST/* annotations */.ds(this.ast, toASTAnnotations(annotations)));
  }
}
function Literal(...literals) {
  return esm_Array/* isNonEmptyReadonlyArray */.Ux(literals) ? new LiteralImpl(literals) : Never;
}
/**
 * Creates a new `Schema` from a literal schema.
 *
 * @example
 * import * as S from "@effect/schema/Schema"
 * import { Either } from "effect"
 *
 * const schema = S.Literal("a", "b", "c").pipe(S.pickLiteral("a", "b"))
 *
 * assert.deepStrictEqual(S.decodeSync(schema)("a"), "a")
 * assert.deepStrictEqual(S.decodeSync(schema)("b"), "b")
 * assert.strictEqual(Either.isLeft(S.decodeUnknownEither(schema)("c")), true)
 *
 * @category constructors
 * @since 1.0.0
 */
const pickLiteral = (...literals) => _schema => Literal(...literals);
/**
 * @category constructors
 * @since 1.0.0
 */
const UniqueSymbolFromSelf = symbol => Schema_make(new AST.UniqueSymbol(symbol));
class EnumsImpl extends (/* unused pure expression or super */ null && (SchemaImpl)) {
  enums;
  static ast = (/* unused pure expression or super */ null && (enums => {
    return new AST.Enums(Object.keys(enums).filter(key => typeof enums[enums[key]] !== "number").map(key => [key, enums[key]]));
  }));
  constructor(enums, ast = EnumsImpl.ast(enums)) {
    super(ast);
    this.enums = enums;
  }
  annotations(annotations) {
    return new EnumsImpl(this.enums, AST.annotations(this.ast, toASTAnnotations(annotations)));
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const Enums = enums => new EnumsImpl(enums);
/**
 * @category constructors
 * @since 1.0.0
 */
const TemplateLiteral = (...[head, ...tail]) => {
  let types = getTemplateLiterals(head.ast);
  for (const span of tail) {
    types = array_.flatMap(types, a => getTemplateLiterals(span.ast).map(b => combineTemplateLiterals(a, b)));
  }
  return Schema_make(AST.Union.make(types));
};
const combineTemplateLiterals = (a, b) => {
  if (AST.isLiteral(a)) {
    return AST.isLiteral(b) ? new AST.Literal(String(a.literal) + String(b.literal)) : AST.TemplateLiteral.make(String(a.literal) + b.head, b.spans);
  }
  if (AST.isLiteral(b)) {
    return AST.TemplateLiteral.make(a.head, array_.modifyNonEmptyLast(a.spans, span => new AST.TemplateLiteralSpan(span.type, span.literal + String(b.literal))));
  }
  return AST.TemplateLiteral.make(a.head, array_.appendAll(array_.modifyNonEmptyLast(a.spans, span => new AST.TemplateLiteralSpan(span.type, span.literal + String(b.head))), b.spans));
};
const getTemplateLiterals = ast => {
  switch (ast._tag) {
    case "Literal":
      return [ast];
    case "NumberKeyword":
    case "StringKeyword":
      return [AST.TemplateLiteral.make("", [new AST.TemplateLiteralSpan(ast, "")])];
    case "Union":
      return array_.flatMap(ast.types, getTemplateLiterals);
    default:
      throw new Error(`unsupported template literal span (${ast})`);
  }
};
const declareConstructor = (typeParameters, options, annotations) => Schema_make(new esm_AST/* Declaration */.gr(typeParameters.map(tp => tp.ast), (...typeParameters) => options.decode(...typeParameters.map(Schema_make)), (...typeParameters) => options.encode(...typeParameters.map(Schema_make)), toASTAnnotations(annotations)));
const declarePrimitive = (is, annotations) => {
  const decodeUnknown = () => (input, _, ast) => is(input) ? esm_ParseResult/* succeed */.ng(input) : esm_ParseResult/* fail */.bG(new esm_ParseResult/* Type */.Dy(ast, input));
  const encodeUnknown = decodeUnknown;
  return Schema_make(new esm_AST/* Declaration */.gr([], decodeUnknown, encodeUnknown, toASTAnnotations(annotations)));
};
/**
 * The constraint `R extends Schema.Context<P[number]>` enforces dependencies solely from `typeParameters`.
 * This ensures that when you call `Schema.to` or `Schema.from`, you receive a schema with a `never` context.
 *
 * @category constructors
 * @since 1.0.0
 */
const declare = function () {
  if (Array.isArray(arguments[0])) {
    const typeParameters = arguments[0];
    const options = arguments[1];
    const annotations = arguments[2];
    return declareConstructor(typeParameters, options, annotations);
  }
  const is = arguments[0];
  const annotations = arguments[1];
  return declarePrimitive(is, annotations);
};
/**
 * @category type id
 * @since 1.0.0
 */
const BrandTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/Brand")));
/**
 * @category constructors
 * @since 1.0.0
 */
const fromBrand = (constructor, annotations) => self => Schema_make(new AST.Refinement(self.ast, (a, _, ast) => {
  const either = constructor.either(a);
  return either_.isLeft(either) ? option_.some(new ParseResult.Type(ast, a, either.left.map(v => v.message).join(", "))) : option_.none();
}, toASTAnnotations({
  typeId: {
    id: BrandTypeId,
    annotation: {
      constructor
    }
  },
  ...annotations
})));
/**
 * @category type id
 * @since 1.0.0
 */
const InstanceOfTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/InstanceOf")));
/**
 * @category constructors
 * @since 1.0.0
 */
const instanceOf = (constructor, annotations) => declare(u => u instanceof constructor, {
  title: constructor.name,
  description: `an instance of ${constructor.name}`,
  pretty: () => String,
  typeId: {
    id: InstanceOfTypeId,
    annotation: {
      constructor
    }
  },
  ...annotations
});
/**
 * @category primitives
 * @since 1.0.0
 */
const Undefined = /*#__PURE__*/Schema_make(esm_AST/* undefinedKeyword */.x8);
/**
 * @category primitives
 * @since 1.0.0
 */
const Void = /*#__PURE__*/Schema_make(esm_AST/* voidKeyword */.zv);
/**
 * @category primitives
 * @since 1.0.0
 */
const Null = /*#__PURE__*/Schema_make(esm_AST/* null */.lB);
/**
 * @category primitives
 * @since 1.0.0
 */
const Never = /*#__PURE__*/Schema_make(esm_AST/* neverKeyword */.$y);
/**
 * @category primitives
 * @since 1.0.0
 */
const Unknown = /*#__PURE__*/Schema_make(esm_AST/* unknownKeyword */.ai);
/**
 * @category primitives
 * @since 1.0.0
 */
const Any = /*#__PURE__*/Schema_make(esm_AST/* anyKeyword */.TA);
const $String = /*#__PURE__*/Schema_make(esm_AST/* stringKeyword */.hw);
const $Number = /*#__PURE__*/Schema_make(esm_AST/* numberKeyword */.uo);
const $Boolean = /*#__PURE__*/Schema_make(esm_AST/* booleanKeyword */.hA);
/**
 * @category primitives
 * @since 1.0.0
 */
const BigIntFromSelf = /*#__PURE__*/Schema_make(esm_AST/* bigIntKeyword */.gx);
/**
 * @category primitives
 * @since 1.0.0
 */
const SymbolFromSelf = /*#__PURE__*/Schema_make(esm_AST/* symbolKeyword */.KN);
const $Object = /*#__PURE__*/Schema_make(esm_AST/* objectKeyword */.DZ);

class UnionImpl extends SchemaImpl {
  static ast = members => {
    return esm_AST/* Union.members */.EJ.members(members.map(m => m.ast));
  };
  members;
  constructor(members, ast = UnionImpl.ast(members)) {
    super(ast);
    this.members = [...members];
  }
  annotations(annotations) {
    return new UnionImpl(this.members, esm_AST/* annotations */.ds(this.ast, toASTAnnotations(annotations)));
  }
}
function Union(...members) {
  return esm_AST/* isMembers */.Jg(members) ? new UnionImpl(members) : esm_Array/* isNonEmptyReadonlyArray */.Ux(members) ? members[0] : Never;
}
/**
 * @category combinators
 * @since 1.0.0
 */
const NullOr = self => Union(self, Null);
/**
 * @category combinators
 * @since 1.0.0
 */
const UndefinedOr = self => Union(self, Undefined);
/**
 * @category combinators
 * @since 1.0.0
 */
const NullishOr = self => Union(self, Null, Undefined);
/**
 * @category combinators
 * @since 1.0.0
 */
const keyof = self => Schema_make(AST.keyof(self.ast));
/**
 * @since 1.0.0
 */
const optionalElement = self => new OptionalElementImpl(self);
class OptionalElementImpl {
  optionalElement;
  [TypeId];
  constructor(optionalElement) {
    this.optionalElement = optionalElement;
  }
  toString() {
    return `${this.optionalElement.ast}?`;
  }
}
class TupleTypeImpl extends SchemaImpl {
  elements;
  rest;
  static ast = (elements, rest) => {
    return new esm_AST/* TupleType */.Qc(elements.map(schema => isSchema(schema) ? new esm_AST/* Element */.W_(schema.ast, false) : new esm_AST/* Element */.W_(schema.optionalElement.ast, true)), rest.map(e => e.ast), true);
  };
  constructor(elements, rest, ast = TupleTypeImpl.ast(elements, rest)) {
    super(ast);
    this.elements = elements;
    this.rest = rest;
  }
  annotations(annotations) {
    return new TupleTypeImpl(this.elements, this.rest, esm_AST/* annotations */.ds(this.ast, toASTAnnotations(annotations)));
  }
}
function Tuple(...args) {
  return Array.isArray(args[0]) ? new TupleTypeImpl(args[0], args.slice(1)) : new TupleTypeImpl(args, []);
}
class $ArrayImpl extends TupleTypeImpl {
  value;
  constructor(value, ast) {
    super([], [value], ast);
    this.value = value;
  }
  annotations(annotations) {
    return new $ArrayImpl(this.value, esm_AST/* annotations */.ds(this.ast, toASTAnnotations(annotations)));
  }
}
const $Array = value => new $ArrayImpl(value);

class NonEmptyArrayImpl extends (/* unused pure expression or super */ null && (TupleTypeImpl)) {
  value;
  constructor(value, ast) {
    super([value], [value], ast);
    this.value = value;
  }
  annotations(annotations) {
    return new NonEmptyArrayImpl(this.value, AST.annotations(this.ast, toASTAnnotations(annotations)));
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const NonEmptyArray = value => new NonEmptyArrayImpl(value);
const formatToken = isOptional => isOptional ? "\"?:\"" : "\":\"";
/**
 * @category PropertySignature
 * @since 1.0.0
 */
class PropertySignatureDeclaration {
  type;
  isOptional;
  isReadonly;
  annotations;
  /**
   * @since 1.0.0
   */
  _tag = "PropertySignatureDeclaration";
  constructor(type, isOptional, isReadonly, annotations) {
    this.type = type;
    this.isOptional = isOptional;
    this.isReadonly = isReadonly;
    this.annotations = annotations;
  }
  /**
   * @since 1.0.0
   */
  toString() {
    const token = formatToken(this.isOptional);
    const type = String(this.type);
    return `PropertySignature<${token}, ${type}, never, ${token}, ${type}>`;
  }
}
/**
 * @category PropertySignature
 * @since 1.0.0
 */
class FromPropertySignature {
  type;
  isOptional;
  isReadonly;
  annotations;
  fromKey;
  constructor(type, isOptional, isReadonly, annotations, fromKey) {
    this.type = type;
    this.isOptional = isOptional;
    this.isReadonly = isReadonly;
    this.annotations = annotations;
    this.fromKey = fromKey;
  }
}
/**
 * @category PropertySignature
 * @since 1.0.0
 */
class ToPropertySignature {
  type;
  isOptional;
  isReadonly;
  annotations;
  constructor(type, isOptional, isReadonly, annotations) {
    this.type = type;
    this.isOptional = isOptional;
    this.isReadonly = isReadonly;
    this.annotations = annotations;
  }
}
const formatPropertyKey = p => {
  if (p === undefined) {
    return "never";
  }
  if (Predicate.isString(p)) {
    return JSON.stringify(p);
  }
  return String(p);
};
/**
 * @category PropertySignature
 * @since 1.0.0
 */
class PropertySignatureTransformation {
  from;
  to;
  decode;
  encode;
  /**
   * @since 1.0.0
   */
  _tag = "PropertySignatureTransformation";
  constructor(from, to, decode, encode) {
    this.from = from;
    this.to = to;
    this.decode = decode;
    this.encode = encode;
  }
  /**
   * @since 1.0.0
   */
  toString() {
    return `PropertySignature<${formatToken(this.to.isOptional)}, ${this.to.type}, ${formatPropertyKey(this.from.fromKey)}, ${formatToken(this.from.isOptional)}, ${this.from.type}>`;
  }
}
/**
 * @since 1.0.0
 * @category symbol
 */
const PropertySignatureTypeId = /*#__PURE__*/Symbol.for("@effect/schema/PropertySignature");
const propertySignatureAnnotations_ = (ast, annotations) => {
  switch (ast._tag) {
    case "PropertySignatureDeclaration":
      {
        return new PropertySignatureDeclaration(ast.type, ast.isOptional, ast.isReadonly, {
          ...ast.annotations,
          ...annotations
        });
      }
    case "PropertySignatureTransformation":
      {
        return new PropertySignatureTransformation(new FromPropertySignature(ast.from.type, ast.from.isOptional, ast.from.isReadonly, ast.from.annotations), new ToPropertySignature(ast.to.type, ast.to.isOptional, ast.to.isReadonly, {
          ...ast.to.annotations,
          ...annotations
        }), ast.decode, ast.encode);
      }
  }
};
/** @internal */
class PropertySignatureImpl {
  ast;
  [TypeId];
  [PropertySignatureTypeId] = null;
  _Key;
  _EncodedToken;
  _TypeToken;
  constructor(ast) {
    this.ast = ast;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
  annotations(annotations) {
    return new PropertySignatureImpl(propertySignatureAnnotations_(this.ast, toASTAnnotations(annotations)));
  }
  toString() {
    return String(this.ast);
  }
}
/**
 * @category PropertySignature
 * @since 1.0.0
 */
const propertySignature = self => new PropertySignatureImpl(new PropertySignatureDeclaration(self.ast, false, true, {}));
/**
 * @category PropertySignature
 * @since 1.0.0
 */
const fromKey = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, key) => {
  const ast = self.ast;
  switch (ast._tag) {
    case "PropertySignatureDeclaration":
      {
        return new PropertySignatureImpl(new PropertySignatureTransformation(new FromPropertySignature(ast.type, ast.isOptional, ast.isReadonly, ast.annotations, key), new ToPropertySignature(AST.typeAST(ast.type), ast.isOptional, ast.isReadonly, {}), identity, identity));
      }
    case "PropertySignatureTransformation":
      return new PropertySignatureImpl(new PropertySignatureTransformation(new FromPropertySignature(ast.from.type, ast.from.isOptional, ast.from.isReadonly, ast.from.annotations, key), ast.to, ast.decode, ast.encode));
  }
})));
/**
 * - `decode`: `none` as argument means: the value is missing in the input
 * - `encode`: `none` as return value means: the value will be missing in the output
 *
 * @category PropertySignature
 * @since 1.0.0
 */
const optionalToRequired = (from, to, options) => new PropertySignatureImpl(new PropertySignatureTransformation(new FromPropertySignature(from.ast, true, true, {}, undefined), new ToPropertySignature(to.ast, false, true, {}), o => option_.some(options.decode(o)), option_.flatMap(options.encode)));
/**
 * - `decode`:
 *   - `none` as argument means: the value is missing in the input
 *   - `none` as return value means: the value will be missing in the output
 * - `encode`:
 *   - `none` as argument means: the value is missing in the input
 *   - `none` as return value means: the value will be missing in the output
 *
 * @category PropertySignature
 * @since 1.0.0
 */
const optionalToOptional = (from, to, options) => new PropertySignatureImpl(new PropertySignatureTransformation(new FromPropertySignature(from.ast, true, true, {}, undefined), new ToPropertySignature(to.ast, true, true, {}), options.decode, options.encode));
/**
 * @category PropertySignature
 * @since 1.0.0
 */
const optional = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isSchema(args[0]), (schema, options) => {
  const isExact = options?.exact;
  const defaultValue = options?.default;
  const isNullable = options?.nullable;
  const asOption = options?.as == "Option";
  if (isExact) {
    if (defaultValue) {
      if (isNullable) {
        return optionalToRequired(NullOr(schema), typeSchema(schema), {
          decode: option_.match({
            onNone: defaultValue,
            onSome: a => a === null ? defaultValue() : a
          }),
          encode: option_.some
        });
      } else {
        return optionalToRequired(schema, typeSchema(schema), {
          decode: option_.match({
            onNone: defaultValue,
            onSome: identity
          }),
          encode: option_.some
        });
      }
    } else if (asOption) {
      if (isNullable) {
        return optionalToRequired(NullOr(schema), OptionFromSelf(typeSchema(schema)), {
          decode: option_.filter(Predicate.isNotNull),
          encode: identity
        });
      } else {
        return optionalToRequired(schema, OptionFromSelf(typeSchema(schema)), {
          decode: identity,
          encode: identity
        });
      }
    } else {
      if (isNullable) {
        return optionalToOptional(NullOr(schema), typeSchema(schema), {
          decode: option_.filter(Predicate.isNotNull),
          encode: identity
        });
      } else {
        return new PropertySignatureImpl(new PropertySignatureDeclaration(schema.ast, true, true, {}));
      }
    }
  } else {
    if (defaultValue) {
      if (isNullable) {
        return optionalToRequired(NullishOr(schema), typeSchema(schema), {
          decode: option_.match({
            onNone: defaultValue,
            onSome: a => a == null ? defaultValue() : a
          }),
          encode: option_.some
        });
      } else {
        return optionalToRequired(UndefinedOr(schema), typeSchema(schema), {
          decode: option_.match({
            onNone: defaultValue,
            onSome: a => a === undefined ? defaultValue() : a
          }),
          encode: option_.some
        });
      }
    } else if (asOption) {
      if (isNullable) {
        return optionalToRequired(NullishOr(schema), OptionFromSelf(typeSchema(schema)), {
          decode: option_.filter(a => a != null),
          encode: identity
        });
      } else {
        return optionalToRequired(UndefinedOr(schema), OptionFromSelf(typeSchema(schema)), {
          decode: option_.filter(Predicate.isNotUndefined),
          encode: identity
        });
      }
    } else {
      if (isNullable) {
        return optionalToOptional(NullishOr(schema), UndefinedOr(typeSchema(schema)), {
          decode: option_.filter(Predicate.isNotNull),
          encode: identity
        });
      } else {
        return new PropertySignatureImpl(new PropertySignatureDeclaration(UndefinedOr(schema).ast, true, true, {}));
      }
    }
  }
})));
const isPropertySignature = u => esm_Predicate/* hasProperty */.l$(u, PropertySignatureTypeId);
class TypeLiteralImpl extends SchemaImpl {
  static ast = (fields, records) => {
    const ownKeys = util/* ownKeys */.Wp(fields);
    const pss = [];
    if (ownKeys.length > 0) {
      const from = [];
      const to = [];
      const transformations = [];
      for (let i = 0; i < ownKeys.length; i++) {
        const key = ownKeys[i];
        const field = fields[key];
        if (isPropertySignature(field)) {
          const ast = field.ast;
          switch (ast._tag) {
            case "PropertySignatureDeclaration":
              {
                const type = ast.type;
                const isOptional = ast.isOptional;
                const toAnnotations = ast.annotations;
                from.push(new esm_AST/* PropertySignature */.TJ(key, type, isOptional, true));
                to.push(new esm_AST/* PropertySignature */.TJ(key, esm_AST/* typeAST */.Yc(type), isOptional, true, toAnnotations));
                pss.push(new esm_AST/* PropertySignature */.TJ(key, type, isOptional, true, toAnnotations));
                break;
              }
            case "PropertySignatureTransformation":
              {
                const fromKey = ast.from.fromKey ?? key;
                from.push(new esm_AST/* PropertySignature */.TJ(fromKey, ast.from.type, ast.from.isOptional, true, ast.from.annotations));
                to.push(new esm_AST/* PropertySignature */.TJ(key, ast.to.type, ast.to.isOptional, true, ast.to.annotations));
                transformations.push(new esm_AST/* PropertySignatureTransformation */.V5(fromKey, key, ast.decode, ast.encode));
                break;
              }
          }
        } else {
          from.push(new esm_AST/* PropertySignature */.TJ(key, field.ast, false, true));
          to.push(new esm_AST/* PropertySignature */.TJ(key, esm_AST/* typeAST */.Yc(field.ast), false, true));
          pss.push(new esm_AST/* PropertySignature */.TJ(key, field.ast, false, true));
        }
      }
      if (esm_Array/* isNonEmptyReadonlyArray */.Ux(transformations)) {
        const issFrom = [];
        const issTo = [];
        for (const r of records) {
          const {
            indexSignatures,
            propertySignatures
          } = esm_AST/* record */.IM(r.key.ast, r.value.ast);
          propertySignatures.forEach(ps => {
            from.push(ps);
            to.push(new esm_AST/* PropertySignature */.TJ(ps.name, esm_AST/* typeAST */.Yc(ps.type), ps.isOptional, ps.isReadonly, ps.annotations));
          });
          indexSignatures.forEach(is => {
            issFrom.push(is);
            issTo.push(new esm_AST/* IndexSignature */.AI(is.parameter, esm_AST/* typeAST */.Yc(is.type), is.isReadonly));
          });
        }
        return new esm_AST/* Transformation */.zA(new esm_AST/* TypeLiteral */.tW(from, issFrom, {
          [esm_AST/* TitleAnnotationId */.Lf]: "Struct (Encoded side)"
        }), new esm_AST/* TypeLiteral */.tW(to, issTo, {
          [esm_AST/* TitleAnnotationId */.Lf]: "Struct (Type side)"
        }), new esm_AST/* TypeLiteralTransformation */.n2(transformations));
      }
    }
    const iss = [];
    for (const r of records) {
      const {
        indexSignatures,
        propertySignatures
      } = esm_AST/* record */.IM(r.key.ast, r.value.ast);
      propertySignatures.forEach(ps => pss.push(ps));
      indexSignatures.forEach(is => iss.push(is));
    }
    return new esm_AST/* TypeLiteral */.tW(pss, iss);
  };
  fields;
  records;
  constructor(fields, records, ast = TypeLiteralImpl.ast(fields, records)) {
    super(ast);
    this.fields = {
      ...fields
    };
    this.records = [...records];
  }
  annotations(annotations) {
    return new TypeLiteralImpl(this.fields, this.records, esm_AST/* annotations */.ds(this.ast, toASTAnnotations(annotations)));
  }
}
function Struct(fields, ...records) {
  return new TypeLiteralImpl(fields, records);
}
class $RecordImpl extends TypeLiteralImpl {
  key;
  value;
  constructor(key, value, ast) {
    super({}, [{
      key,
      value
    }], ast);
    this.key = key;
    this.value = value;
  }
  annotations(annotations) {
    return new $RecordImpl(this.key, this.value, esm_AST/* annotations */.ds(this.ast, toASTAnnotations(annotations)));
  }
}
/**
 * @category constructors
 * @since 1.0.0
 */
const Record = (key, value) => new $RecordImpl(key, value);
/**
 * @category struct transformations
 * @since 1.0.0
 */
const pick = (...keys) => self => Schema_make(AST.pick(self.ast, keys));
/**
 * @category struct transformations
 * @since 1.0.0
 */
const omit = (...keys) => self => Schema_make(AST.omit(self.ast, keys));
/**
 * Given a schema `Schema<A, I, R>` and a key `key: K`, this function extracts a specific field from the `A` type,
 * producing a new schema that represents a transformation from the `{ readonly [key]: I[K] }` type to `A[K]`.
 *
 * @example
 * import * as S from "@effect/schema/Schema"
 *
 * // ---------------------------------------------
 * // use case: pull out a single field from a
 * // struct through a transformation
 * // ---------------------------------------------
 *
 * const mytable = S.Struct({
 *   column1: S.NumberFromString,
 *   column2: S.Number
 * })
 *
 * // const pullOutColumn: S.Schema<number, {
 * //     readonly column1: string;
 * // }, never>
 * const pullOutColumn = mytable.pipe(S.pluck("column1"))
 *
 * console.log(S.decodeUnknownEither(S.Array(pullOutColumn))([{ column1: "1", column2: 100 }, { column1: "2", column2: 300 }]))
 * // Output: { _id: 'Either', _tag: 'Right', right: [ 1, 2 ] }
 *
 * @category struct transformations
 * @since 1.0.0
 */
const pluck = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (schema, key) => {
  const ps = AST.getPropertyKeyIndexedAccess(AST.typeAST(schema.ast), key);
  const value = Schema_make(ps.isOptional ? AST.orUndefined(ps.type) : ps.type);
  return transform(schema.pipe(pick(key)), value, {
    decode: a => a[key],
    encode: ak => ps.isOptional && ak === undefined ? {} : {
      [key]: ak
    }
  });
})));
const makeBrandSchema = (self, annotations) => {
  const ast = AST.annotations(self, toASTAnnotations(annotations));
  const schema = Schema_make(ast);
  const validateEither_ = validateEither(schema);
  //     v-- function
  const out = brand_.refined(unbranded => either_.match(validateEither_(unbranded), {
    onLeft: e => option_.some(brand_.error(TreeFormatter.formatErrorSync(e), e)),
    onRight: () => option_.none()
  }));
  // ----------------
  // Schema interface
  // ----------------
  Object.setPrototypeOf(Object.assign(out, schema, {
    annotations: a => makeBrandSchema(ast, a)
  }), Object.getPrototypeOf(schema));
  return out;
};
/**
 * @category branding
 * @since 1.0.0
 */
const asBrandSchema = schema => schema;
/**
 * Returns a nominal branded schema by applying a brand to a given schema.
 *
 * ```
 * Schema<A> + B -> Schema<A & Brand<B>>
 * ```
 *
 * @param self - The input schema to be combined with the brand.
 * @param brand - The brand to apply.
 *
 * @example
 * import * as Schema from "@effect/schema/Schema"
 *
 * const Int = Schema.Number.pipe(Schema.int(), Schema.brand("Int"))
 * type Int = Schema.Schema.Type<typeof Int> // number & Brand<"Int">
 *
 * @category branding
 * @since 1.0.0
 */
const brand = (brand, annotations) => self => {
  const brandAnnotation = option_.match(AST.getBrandAnnotation(self.ast), {
    onNone: () => [brand],
    onSome: brands => [...brands, brand]
  });
  return makeBrandSchema(self.ast, {
    // add a default title annotation containing the brand
    title: String(self.ast) + ` & Brand<${util_.formatUnknown(brand)}>`,
    ...annotations,
    [AST.BrandAnnotationId]: brandAnnotation
  });
};
/**
 * @category combinators
 * @since 1.0.0
 */
const partial = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isSchema(args[0]), (self, options) => Schema_make(AST.partial(self.ast, options)))));
/**
 * @category combinators
 * @since 1.0.0
 */
const required = self => Schema_make(AST.required(self.ast));
/**
 * Creates a new schema with shallow mutability applied to its properties.
 *
 * @param schema - The original schema to make properties mutable (shallowly).
 *
 * @category combinators
 * @since 1.0.0
 */
const mutable = schema => Schema_make(AST.mutable(schema.ast));
const getExtendErrorMessage = (x, y, path) => errors_.getAPIErrorMessage("Extend", `cannot extend \`${x}\` with \`${y}\` (path [${path?.join(", ")}])`);
const intersectTypeLiterals = (x, y, path) => {
  if (AST.isTypeLiteral(x) && AST.isTypeLiteral(y)) {
    const propertySignatures = [...x.propertySignatures];
    for (const ps of y.propertySignatures) {
      const name = ps.name;
      const i = propertySignatures.findIndex(ps => ps.name === name);
      if (i === -1) {
        propertySignatures.push(ps);
      } else {
        const {
          isOptional,
          type
        } = propertySignatures[i];
        path = [...path, util_.formatUnknown(name)];
        propertySignatures[i] = new AST.PropertySignature(name, extendAST(type, ps.type, path), isOptional, true);
      }
    }
    return new AST.TypeLiteral(propertySignatures, x.indexSignatures.concat(y.indexSignatures));
  }
  throw new Error(getExtendErrorMessage(x, y, path));
};
const extendAST = (x, y, path) => AST.Union.make(intersectUnionMembers([x], [y], path));
const intersectUnionMembers = (xs, ys, path) => array_.flatMap(xs, x => array_.flatMap(ys, y => {
  if (AST.isUnion(x)) {
    return intersectUnionMembers(x.types, AST.isUnion(y) ? y.types : [y], path);
  } else if (AST.isUnion(y)) {
    return intersectUnionMembers([x], y.types, path);
  }
  if (AST.isTypeLiteral(x)) {
    if (AST.isTypeLiteral(y)) {
      return [intersectTypeLiterals(x, y, path)];
    } else if (AST.isTransformation(y) && AST.isTypeLiteralTransformation(y.transformation)) {
      return [new AST.Transformation(intersectTypeLiterals(x, y.from, path), intersectTypeLiterals(AST.typeAST(x), y.to, path), new AST.TypeLiteralTransformation(y.transformation.propertySignatureTransformations))];
    }
  } else if (AST.isTransformation(x) && AST.isTypeLiteralTransformation(x.transformation)) {
    if (AST.isTypeLiteral(y)) {
      return [new AST.Transformation(intersectTypeLiterals(x.from, y, path), intersectTypeLiterals(x.to, AST.typeAST(y), path), new AST.TypeLiteralTransformation(x.transformation.propertySignatureTransformations))];
    } else if (AST.isTransformation(y) && AST.isTypeLiteralTransformation(y.transformation)) {
      return [new AST.Transformation(intersectTypeLiterals(x.from, y.from, path), intersectTypeLiterals(x.to, y.to, path), new AST.TypeLiteralTransformation(x.transformation.propertySignatureTransformations.concat(y.transformation.propertySignatureTransformations)))];
    }
  }
  throw new Error(getExtendErrorMessage(x, y, path));
}));
/**
 * @category combinators
 * @since 1.0.0
 */
const extend = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => Schema_make(extendAST(self.ast, that.ast, [])))));
/**
 * @category combinators
 * @since 1.0.0
 */
const compose = /*#__PURE__*/(0,Function/* dual */.OB)(args => isSchema(args[1]), (from, to) => Schema_make(esm_AST/* compose */.qC(from.ast, to.ast)));
/**
 * @category constructors
 * @since 1.0.0
 */
const suspend = f => Schema_make(new esm_AST/* Suspend */.UX(() => f().ast));
function filter(predicate, annotations) {
  return self => Schema_make(new esm_AST/* Refinement */.B$(self.ast, (a, options, ast) => {
    const out = predicate(a, options, ast);
    if (esm_Predicate/* isBoolean */.jn(out)) {
      return out ? esm_Option/* none */.YP() : esm_Option/* some */.G(new esm_ParseResult/* Type */.Dy(ast, a));
    }
    return out;
  }, toASTAnnotations(annotations)));
}
class transformOrFailImpl extends SchemaImpl {
  from;
  to;
  constructor(from, to, ast) {
    super(ast);
    this.from = from;
    this.to = to;
  }
  annotations(annotations) {
    return new transformOrFailImpl(this.from, this.to, esm_AST/* annotations */.ds(this.ast, toASTAnnotations(annotations)));
  }
}
/**
 * Create a new `Schema` by transforming the input and output of an existing `Schema`
 * using the provided decoding functions.
 *
 * @category combinators
 * @since 1.0.0
 */
const transformOrFail = /*#__PURE__*/(0,Function/* dual */.OB)(args => isSchema(args[0]) && isSchema(args[1]), (from, to, options) => new transformOrFailImpl(from, to, new esm_AST/* Transformation */.zA(from.ast, to.ast, new esm_AST/* FinalTransformation */.oH(options.decode, options.encode))));
/**
 * Create a new `Schema` by transforming the input and output of an existing `Schema`
 * using the provided mapping functions.
 *
 * @category combinators
 * @since 1.0.0
 */
const transform = /*#__PURE__*/(0,Function/* dual */.OB)(args => isSchema(args[0]) && isSchema(args[1]), (from, to, options) => transformOrFail(from, to, {
  decode: fromA => esm_ParseResult/* succeed */.ng(options.decode(fromA)),
  encode: toI => esm_ParseResult/* succeed */.ng(options.encode(toI))
}));
/**
 * Creates a new `Schema` which transforms literal values.
 *
 * @example
 * import * as S from "@effect/schema/Schema"
 *
 * const schema = S.transformLiteral(0, "a")
 *
 * assert.deepStrictEqual(S.decodeSync(schema)(0), "a")
 *
 * @category constructors
 * @since 1.0.0
 */
const transformLiteral = (from, to) => transform(Literal(from), Literal(to), {
  decode: () => to,
  encode: () => from
});
function transformLiterals(...pairs) {
  return Union(...pairs.map(([from, to]) => transformLiteral(from, to)));
}
/**
 * Attaches a property signature with the specified key and value to the schema.
 * This API is useful when you want to add a property to your schema which doesn't describe the shape of the input,
 * but rather maps to another schema, for example when you want to add a discriminant to a simple union.
 *
 * @param self - The input schema.
 * @param key - The name of the property to add to the schema.
 * @param value - The value of the property to add to the schema.
 *
 * @example
 * import * as S from "@effect/schema/Schema"
 * import { pipe } from "effect/Function"
 *
 * const Circle = S.Struct({ radius: S.Number })
 * const Square = S.Struct({ sideLength: S.Number })
 * const Shape = S.Union(
 *   Circle.pipe(S.attachPropertySignature("kind", "circle")),
 *   Square.pipe(S.attachPropertySignature("kind", "square"))
 * )
 *
 * assert.deepStrictEqual(S.decodeSync(Shape)({ radius: 10 }), {
 *   kind: "circle",
 *   radius: 10
 * })
 *
 * @category combinators
 * @since 1.0.0
 */
const attachPropertySignature = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isSchema(args[0]), (schema, key, value, annotations) => {
  const attached = extend(typeSchema(schema), Struct({
    [key]: Predicate.isSymbol(value) ? UniqueSymbolFromSelf(value) : Literal(value)
  })).ast;
  return Schema_make(new AST.Transformation(schema.ast, annotations ? AST.annotations(attached, toASTAnnotations(annotations)) : attached, new AST.TypeLiteralTransformation([new AST.PropertySignatureTransformation(key, key, () => option_.some(value), () => option_.none())])));
})));
/**
 * @category annotations
 * @since 1.0.0
 */
const annotations = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, annotations) => self.annotations(annotations))));
/**
 * @category annotations
 * @since 1.0.0
 */
const message = message => self => self.annotations({
  [AST.MessageAnnotationId]: message
});
/**
 * @category annotations
 * @since 1.0.0
 */
const identifier = identifier => self => self.annotations({
  [AST.IdentifierAnnotationId]: identifier
});
/**
 * @category annotations
 * @since 1.0.0
 */
const title = title => self => self.annotations({
  [AST.TitleAnnotationId]: title
});
/**
 * @category annotations
 * @since 1.0.0
 */
const description = description => self => self.annotations({
  [AST.DescriptionAnnotationId]: description
});
/**
 * @category annotations
 * @since 1.0.0
 */
const examples = examples => self => self.annotations({
  [AST.ExamplesAnnotationId]: examples
});
const $default = value => self => self.annotations({
  [AST.DefaultAnnotationId]: value
});

/**
 * @category annotations
 * @since 1.0.0
 */
const documentation = documentation => self => self.annotations({
  [AST.DocumentationAnnotationId]: documentation
});
/**
 * Attaches a JSON Schema annotation to a schema that represents a refinement.
 *
 * If the schema is composed of more than one refinement, the corresponding annotations will be merged.
 *
 * @category annotations
 * @since 1.0.0
 */
const jsonSchema = jsonSchema => self => self.annotations({
  [AST.JSONSchemaAnnotationId]: jsonSchema
});
/**
 * @category annotations
 * @since 1.0.0
 */
const Schema_equivalence = equivalence => self => self.annotations({
  [equivalence_.EquivalenceHookId]: () => equivalence
});
/**
 * @category annotations
 * @since 1.0.0
 */
const concurrency = concurrency => self => self.annotations({
  [AST.ConcurrencyAnnotationId]: concurrency
});
/**
 * @category annotations
 * @since 1.0.0
 */
const batching = batching => self => self.annotations({
  [AST.BatchingAnnotationId]: batching
});
/**
 * @category annotations
 * @since 1.0.0
 */
const parseIssueTitle = f => self => self.annotations({
  [AST.ParseIssueTitleAnnotationId]: f
});
/**
 * @category renaming
 * @since 1.0.0
 */
const rename = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, mapping) => {
  return Schema_make(AST.rename(self.ast, mapping));
})));
/**
 * @category type id
 * @since 1.0.0
 */
const TrimmedTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Trimmed");
/**
 * Verifies that a string contains no leading or trailing whitespaces.
 *
 * Note. This combinator does not make any transformations, it only validates.
 * If what you were looking for was a combinator to trim strings, then check out the `trim` combinator.
 *
 * @category string filters
 * @since 1.0.0
 */
const trimmed = annotations => self => self.pipe(filter(a => a === a.trim(), {
  typeId: TrimmedTypeId,
  description: "a string with no leading or trailing whitespace",
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_MaxLengthTypeId = MaxLengthTypeId;
/**
 * @category string filters
 * @since 1.0.0
 */
const maxLength = (maxLength, annotations) => self => self.pipe(filter(a => a.length <= maxLength, {
  typeId: Schema_MaxLengthTypeId,
  description: `a string at most ${maxLength} character(s) long`,
  jsonSchema: {
    maxLength
  },
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_MinLengthTypeId = MinLengthTypeId;
/**
 * @category string filters
 * @since 1.0.0
 */
const minLength = (minLength, annotations) => self => self.pipe(filter(a => a.length >= minLength, {
  typeId: Schema_MinLengthTypeId,
  description: `a string at least ${minLength} character(s) long`,
  jsonSchema: {
    minLength
  },
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const PatternTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Pattern");
/**
 * @category string filters
 * @since 1.0.0
 */
const pattern = (regex, annotations) => self => {
  const pattern = regex.source;
  return self.pipe(filter(a => {
    // The following line ensures that `lastIndex` is reset to `0` in case the user has specified the `g` flag
    regex.lastIndex = 0;
    return regex.test(a);
  }, {
    typeId: {
      id: PatternTypeId,
      annotation: {
        regex
      }
    },
    description: `a string matching the pattern ${pattern}`,
    jsonSchema: {
      pattern
    },
    arbitrary: () => fc => fc.stringMatching(regex),
    ...annotations
  }));
};
/**
 * @category type id
 * @since 1.0.0
 */
const StartsWithTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/StartsWith")));
/**
 * @category string filters
 * @since 1.0.0
 */
const startsWith = (startsWith, annotations) => self => self.pipe(filter(a => a.startsWith(startsWith), {
  typeId: {
    id: StartsWithTypeId,
    annotation: {
      startsWith
    }
  },
  description: `a string starting with ${JSON.stringify(startsWith)}`,
  jsonSchema: {
    pattern: `^${startsWith}`
  },
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const EndsWithTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/EndsWith")));
/**
 * @category string filters
 * @since 1.0.0
 */
const endsWith = (endsWith, annotations) => self => self.pipe(filter(a => a.endsWith(endsWith), {
  typeId: {
    id: EndsWithTypeId,
    annotation: {
      endsWith
    }
  },
  description: `a string ending with ${JSON.stringify(endsWith)}`,
  jsonSchema: {
    pattern: `^.*${endsWith}$`
  },
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const IncludesTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/Includes")));
/**
 * @category string filters
 * @since 1.0.0
 */
const includes = (searchString, annotations) => self => self.pipe(filter(a => a.includes(searchString), {
  typeId: {
    id: IncludesTypeId,
    annotation: {
      includes: searchString
    }
  },
  description: `a string including ${JSON.stringify(searchString)}`,
  jsonSchema: {
    pattern: `.*${searchString}.*`
  },
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const LowercasedTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Lowercased");
/**
 * Verifies that a string is lowercased.
 *
 * @category string filters
 * @since 1.0.0
 */
const lowercased = annotations => self => self.pipe(filter(a => a === a.toLowerCase(), {
  typeId: LowercasedTypeId,
  description: "a lowercase string",
  ...annotations
}));
/**
 * @category string constructors
 * @since 1.0.0
 */
const Lowercased = /*#__PURE__*/$String.pipe( /*#__PURE__*/lowercased({
  identifier: "Lowercased",
  title: "Lowercased"
}));
/**
 * @category type id
 * @since 1.0.0
 */
const UppercasedTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Uppercased");
/**
 * Verifies that a string is uppercased.
 *
 * @category string filters
 * @since 1.0.0
 */
const uppercased = annotations => self => self.pipe(filter(a => a === a.toUpperCase(), {
  typeId: UppercasedTypeId,
  description: "an uppercase string",
  ...annotations
}));
/**
 * @category string constructors
 * @since 1.0.0
 */
const Uppercased = /*#__PURE__*/$String.pipe( /*#__PURE__*/uppercased({
  identifier: "Uppercased",
  title: "Uppercased"
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_LengthTypeId = LengthTypeId;
/**
 * @category string filters
 * @since 1.0.0
 */
const Schema_length = (length, annotations) => self => {
  const minLength = esm_Predicate/* isObject */.Kn(length) ? Math.max(0, Math.floor(length.min)) : Math.max(0, Math.floor(length));
  const maxLength = esm_Predicate/* isObject */.Kn(length) ? Math.max(minLength, Math.floor(length.max)) : minLength;
  if (minLength !== maxLength) {
    return self.pipe(filter(a => a.length >= minLength && a.length <= maxLength, {
      typeId: Schema_LengthTypeId,
      description: `a string at least ${minLength} character(s) and at most ${maxLength} character(s) long`,
      jsonSchema: {
        minLength,
        maxLength
      },
      ...annotations
    }));
  }
  return self.pipe(filter(a => a.length === minLength, {
    typeId: Schema_LengthTypeId,
    description: minLength === 1 ? `a single character` : `a string ${minLength} character(s) long`,
    jsonSchema: {
      minLength,
      maxLength: minLength
    },
    ...annotations
  }));
};
/**
 * A schema representing a single character.
 *
 * @category string constructors
 * @since 1.0.0
 */
const Char = /*#__PURE__*/$String.pipe( /*#__PURE__*/Schema_length(1, {
  identifier: "Char"
}));
/**
 * @category string filters
 * @since 1.0.0
 */
const nonEmpty = annotations => minLength(1, {
  description: "a non empty string",
  ...annotations
});
/**
 * This schema converts a string to lowercase.
 *
 * @category string transformations
 * @since 1.0.0
 */
const Lowercase = /*#__PURE__*/transform($String, Lowercased, {
  decode: s => s.toLowerCase(),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "Lowercase"
});
/**
 * This schema converts a string to uppercase.
 *
 * @category string transformations
 * @since 1.0.0
 */
const Uppercase = /*#__PURE__*/transform($String, Uppercased, {
  decode: s => s.toUpperCase(),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "Uppercase"
});
/**
 * @category string constructors
 * @since 1.0.0
 */
const Trimmed = /*#__PURE__*/$String.pipe( /*#__PURE__*/trimmed({
  identifier: "Trimmed",
  title: "Trimmed"
}));
/**
 * This schema allows removing whitespaces from the beginning and end of a string.
 *
 * @category string transformations
 * @since 1.0.0
 */
const Trim = /*#__PURE__*/transform($String, Trimmed, {
  decode: s => s.trim(),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "Trim"
});
/**
 * Returns a schema that allows splitting a string into an array of strings.
 *
 * @category string transformations
 * @since 1.0.0
 */
const split = separator => transform($String, $Array($String), {
  decode: string_.split(separator),
  encode: array_.join(separator)
});
const JsonString = /*#__PURE__*/$String.annotations({
  [esm_AST/* IdentifierAnnotationId */.CA]: "JsonString",
  [esm_AST/* TitleAnnotationId */.Lf]: "JsonString",
  [esm_AST/* DescriptionAnnotationId */.Aj]: "a JSON string"
});
/**
 * The `ParseJson` combinator provides a method to convert JSON strings into the `unknown` type using the underlying
 * functionality of `JSON.parse`. It also utilizes `JSON.stringify` for encoding.
 *
 * You can optionally provide a `ParseJsonOptions` to configure both `JSON.parse` and `JSON.stringify` executions.
 *
 * Optionally, you can pass a schema `Schema<A, I, R>` to obtain an `A` type instead of `unknown`.
 *
 * @example
 * import * as S from "@effect/schema/Schema"
 *
 * assert.deepStrictEqual(S.decodeUnknownSync(S.parseJson())(`{"a":"1"}`), { a: "1" })
 * assert.deepStrictEqual(S.decodeUnknownSync(S.parseJson(S.Struct({ a: S.NumberFromString })))(`{"a":"1"}`), { a: 1 })
 *
 * @category string transformations
 * @since 1.0.0
 */
const parseJson = (schema, o) => {
  if (isSchema(schema)) {
    return compose(parseJson(o), schema);
  }
  const options = schema;
  return transformOrFail(JsonString, Unknown, {
    decode: (s, _, ast) => esm_ParseResult/* try */.JH({
      try: () => JSON.parse(s, options?.reviver),
      catch: e => new esm_ParseResult/* Type */.Dy(ast, s, e.message)
    }),
    encode: (u, _, ast) => esm_ParseResult/* try */.JH({
      try: () => JSON.stringify(u, options?.replacer, options?.space),
      catch: e => new esm_ParseResult/* Type */.Dy(ast, u, e.message)
    })
  });
};
/**
 * @category string constructors
 * @since 1.0.0
 */
const NonEmpty = /*#__PURE__*/$String.pipe( /*#__PURE__*/nonEmpty({
  identifier: "NonEmpty",
  title: "NonEmpty"
}));
/**
 * @category type id
 * @since 1.0.0
 */
const UUIDTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/UUID");
const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;
/**
 * Represents a Universally Unique Identifier (UUID).
 *
 * This schema ensures that the provided string adheres to the standard UUID format.
 *
 * @category string constructors
 * @since 1.0.0
 */
const UUID = /*#__PURE__*/$String.pipe( /*#__PURE__*/pattern(uuidRegex, {
  typeId: UUIDTypeId,
  identifier: "UUID",
  title: "UUID",
  description: "a Universally Unique Identifier",
  arbitrary: () => fc => fc.uuid()
}));
/**
 * @category type id
 * @since 1.0.0
 */
const ULIDTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/ULID");
const ulidRegex = /^[0-7][0-9A-HJKMNP-TV-Z]{25}$/i;
/**
 * Represents a Universally Unique Lexicographically Sortable Identifier (ULID).
 *
 * ULIDs are designed to be compact, URL-safe, and ordered, making them suitable for use as identifiers.
 * This schema ensures that the provided string adheres to the standard ULID format.
 *
 * @category string constructors
 * @since 1.0.0
 */
const ULID = /*#__PURE__*/$String.pipe( /*#__PURE__*/pattern(ulidRegex, {
  typeId: ULIDTypeId,
  identifier: "ULID",
  title: "ULID",
  description: "a Universally Unique Lexicographically Sortable Identifier",
  arbitrary: () => fc => fc.ulid()
}));
/**
 * @category type id
 * @since 1.0.0
 */
const FiniteTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Finite");
/**
 * Ensures that the provided value is a finite number.
 *
 * This schema filters out non-finite numeric values, allowing only finite numbers to pass through.
 *
 * @category number filters
 * @since 1.0.0
 */
const finite = annotations => self => self.pipe(filter(a => Number.isFinite(a), {
  typeId: FiniteTypeId,
  description: "a finite number",
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_GreaterThanTypeId = GreaterThanTypeId;
/**
 * This filter checks whether the provided number is greater than the specified minimum.
 *
 * @category number filters
 * @since 1.0.0
 */
const greaterThan = (min, annotations) => self => self.pipe(filter(a => a > min, {
  typeId: Schema_GreaterThanTypeId,
  description: min === 0 ? "a positive number" : `a number greater than ${min}`,
  jsonSchema: {
    exclusiveMinimum: min
  },
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_GreaterThanOrEqualToTypeId = GreaterThanOrEqualToTypeId;
/**
 * This filter checks whether the provided number is greater than or equal to the specified minimum.
 *
 * @category number filters
 * @since 1.0.0
 */
const greaterThanOrEqualTo = (min, annotations) => self => self.pipe(filter(a => a >= min, {
  typeId: Schema_GreaterThanOrEqualToTypeId,
  description: min === 0 ? "a non-negative number" : `a number greater than or equal to ${min}`,
  jsonSchema: {
    minimum: min
  },
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const MultipleOfTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/MultipleOf")));
/**
 * @category number filters
 * @since 1.0.0
 */
const multipleOf = (divisor, annotations) => self => self.pipe(filter(a => number_.remainder(a, divisor) === 0, {
  typeId: MultipleOfTypeId,
  description: `a number divisible by ${divisor}`,
  jsonSchema: {
    multipleOf: Math.abs(divisor)
  },
  // spec requires positive divisor
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_IntTypeId = IntTypeId;
/**
 * @category number filters
 * @since 1.0.0
 */
const Schema_int = annotations => self => self.pipe(filter(a => Number.isSafeInteger(a), {
  typeId: Schema_IntTypeId,
  title: "integer",
  description: "an integer",
  jsonSchema: {
    type: "integer"
  },
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_LessThanTypeId = LessThanTypeId;
/**
 * This filter checks whether the provided number is less than the specified maximum.
 *
 * @category number filters
 * @since 1.0.0
 */
const lessThan = (max, annotations) => self => self.pipe(filter(a => a < max, {
  typeId: Schema_LessThanTypeId,
  description: max === 0 ? "a negative number" : `a number less than ${max}`,
  jsonSchema: {
    exclusiveMaximum: max
  },
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_LessThanOrEqualToTypeId = LessThanOrEqualToTypeId;
/**
 * This schema checks whether the provided number is less than or equal to the specified maximum.
 *
 * @category number filters
 * @since 1.0.0
 */
const lessThanOrEqualTo = (max, annotations) => self => self.pipe(filter(a => a <= max, {
  typeId: Schema_LessThanOrEqualToTypeId,
  description: max === 0 ? "a non-positive number" : `a number less than or equal to ${max}`,
  jsonSchema: {
    maximum: max
  },
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_BetweenTypeId = BetweenTypeId;
/**
 * This filter checks whether the provided number falls within the specified minimum and maximum values.
 *
 * @category number filters
 * @since 1.0.0
 */
const between = (min, max, annotations) => self => self.pipe(filter(a => a >= min && a <= max, {
  typeId: Schema_BetweenTypeId,
  description: `a number between ${min} and ${max}`,
  jsonSchema: {
    maximum: max,
    minimum: min
  },
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const NonNaNTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/NonNaN");
/**
 * @category number filters
 * @since 1.0.0
 */
const nonNaN = annotations => self => self.pipe(filter(a => !Number.isNaN(a), {
  typeId: NonNaNTypeId,
  description: "a number excluding NaN",
  ...annotations
}));
/**
 * @category number filters
 * @since 1.0.0
 */
const positive = annotations => greaterThan(0, annotations);
/**
 * @category number filters
 * @since 1.0.0
 */
const negative = annotations => lessThan(0, annotations);
/**
 * @category number filters
 * @since 1.0.0
 */
const nonPositive = annotations => lessThanOrEqualTo(0, annotations);
/**
 * @category number filters
 * @since 1.0.0
 */
const nonNegative = annotations => greaterThanOrEqualTo(0, annotations);
/**
 * Clamps a number between a minimum and a maximum value.
 *
 * @category number transformations
 * @since 1.0.0
 */
const clamp = (minimum, maximum) => self => transform(self, self.pipe(typeSchema, between(minimum, maximum)), {
  strict: false,
  decode: self => number_.clamp(self, {
    minimum,
    maximum
  }),
  encode: identity
});
/**
 * This schema transforms a `string` into a `number` by parsing the string using the `Number` function.
 *
 * It returns an error if the value can't be converted (for example when non-numeric characters are provided).
 *
 * The following special string values are supported: "NaN", "Infinity", "-Infinity".
 *
 * @category number constructors
 * @since 1.0.0
 */
const NumberFromString = /*#__PURE__*/transformOrFail($String, $Number, {
  decode: (s, _, ast) => esm_ParseResult/* fromOption */.Yo(esm_Number/* parse */.Qc(s), () => new esm_ParseResult/* Type */.Dy(ast, s)),
  encode: n => esm_ParseResult/* succeed */.ng(String(n))
}).annotations({
  identifier: "NumberFromString"
});
/**
 * @category number constructors
 * @since 1.0.0
 */
const Finite = /*#__PURE__*/$Number.pipe( /*#__PURE__*/finite({
  identifier: "Finite",
  title: "Finite"
}));
/**
 * @category number constructors
 * @since 1.0.0
 */
const Int = /*#__PURE__*/$Number.pipe( /*#__PURE__*/Schema_int({
  identifier: "Int",
  title: "Int"
}));
/**
 * @category number constructors
 * @since 1.0.0
 */
const NonNaN = /*#__PURE__*/$Number.pipe( /*#__PURE__*/nonNaN({
  identifier: "NonNaN",
  title: "NonNaN"
}));
/**
 * @category number constructors
 * @since 1.0.0
 */
const Positive = /*#__PURE__*/$Number.pipe( /*#__PURE__*/positive({
  identifier: "Positive",
  title: "Positive"
}));
/**
 * @category number constructors
 * @since 1.0.0
 */
const Negative = /*#__PURE__*/$Number.pipe( /*#__PURE__*/negative({
  identifier: "Negative",
  title: "Negative"
}));
/**
 * @category number constructors
 * @since 1.0.0
 */
const NonPositive = /*#__PURE__*/$Number.pipe( /*#__PURE__*/nonPositive({
  identifier: "NonPositive",
  title: "NonPositive"
}));
/**
 * @category number constructors
 * @since 1.0.0
 */
const NonNegative = /*#__PURE__*/$Number.pipe( /*#__PURE__*/nonNegative({
  identifier: "NonNegative",
  title: "NonNegative"
}));
/**
 * @category type id
 * @since 1.0.0
 */
const JsonNumberTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/JsonNumber");
/**
 * The `JsonNumber` is a schema for representing JSON numbers. It ensures that the provided value is a valid
 * number by filtering out `NaN` and `(+/-) Infinity`. This is useful when you want to validate and represent numbers in JSON
 * format.
 *
 * @example
 * import * as S from "@effect/schema/Schema"
 *
 * const is = S.is(S.JsonNumber)
 *
 * assert.deepStrictEqual(is(42), true)
 * assert.deepStrictEqual(is(Number.NaN), false)
 * assert.deepStrictEqual(is(Number.POSITIVE_INFINITY), false)
 * assert.deepStrictEqual(is(Number.NEGATIVE_INFINITY), false)
 *
 * @category number constructors
 * @since 1.0.0
 */
const JsonNumber = /*#__PURE__*/$Number.pipe( /*#__PURE__*/filter(n => !Number.isNaN(n) && Number.isFinite(n), {
  typeId: JsonNumberTypeId,
  identifier: "JsonNumber",
  title: "JSON-compatible number",
  description: "a JSON-compatible number, excluding NaN, +Infinity, and -Infinity",
  jsonSchema: {
    type: "number"
  }
}));
/**
 * @category boolean transformations
 * @since 1.0.0
 */
const Not = /*#__PURE__*/transform($Boolean, $Boolean, {
  decode: Boolean/* not */.ff,
  encode: Boolean/* not */.ff
});
const $Symbol = /*#__PURE__*/transform($String, SymbolFromSelf, {
  strict: false,
  decode: s => Symbol.for(s),
  encode: sym => sym.description
}).annotations({
  identifier: "symbol"
});

/**
 * @category type id
 * @since 1.0.0
 */
const GreaterThanBigIntTypeId = GreaterThanBigintTypeId;
/**
 * @category bigint filters
 * @since 1.0.0
 */
const greaterThanBigInt = (min, annotations) => self => self.pipe(filter(a => a > min, {
  typeId: {
    id: GreaterThanBigIntTypeId,
    annotation: {
      min
    }
  },
  description: min === 0n ? "a positive bigint" : `a bigint greater than ${min}n`,
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_GreaterThanOrEqualToBigIntTypeId = GreaterThanOrEqualToBigIntTypeId;
/**
 * @category bigint filters
 * @since 1.0.0
 */
const greaterThanOrEqualToBigInt = (min, annotations) => self => self.pipe(filter(a => a >= min, {
  typeId: {
    id: Schema_GreaterThanOrEqualToBigIntTypeId,
    annotation: {
      min
    }
  },
  description: min === 0n ? "a non-negative bigint" : `a bigint greater than or equal to ${min}n`,
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_LessThanBigIntTypeId = LessThanBigIntTypeId;
/**
 * @category bigint filters
 * @since 1.0.0
 */
const lessThanBigInt = (max, annotations) => self => self.pipe(filter(a => a < max, {
  typeId: {
    id: Schema_LessThanBigIntTypeId,
    annotation: {
      max
    }
  },
  description: max === 0n ? "a negative bigint" : `a bigint less than ${max}n`,
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_LessThanOrEqualToBigIntTypeId = LessThanOrEqualToBigIntTypeId;
/**
 * @category bigint filters
 * @since 1.0.0
 */
const lessThanOrEqualToBigInt = (max, annotations) => self => self.pipe(filter(a => a <= max, {
  typeId: {
    id: Schema_LessThanOrEqualToBigIntTypeId,
    annotation: {
      max
    }
  },
  description: max === 0n ? "a non-positive bigint" : `a bigint less than or equal to ${max}n`,
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const BetweenBigIntTypeId = BetweenBigintTypeId;
/**
 * @category bigint filters
 * @since 1.0.0
 */
const betweenBigInt = (min, max, annotations) => self => self.pipe(filter(a => a >= min && a <= max, {
  typeId: {
    id: BetweenBigIntTypeId,
    annotation: {
      max,
      min
    }
  },
  description: `a bigint between ${min}n and ${max}n`,
  ...annotations
}));
/**
 * @category bigint filters
 * @since 1.0.0
 */
const positiveBigInt = annotations => greaterThanBigInt(0n, annotations);
/**
 * @category bigint filters
 * @since 1.0.0
 */
const negativeBigInt = annotations => lessThanBigInt(0n, annotations);
/**
 * @category bigint filters
 * @since 1.0.0
 */
const nonNegativeBigInt = annotations => greaterThanOrEqualToBigInt(0n, annotations);
/**
 * @category bigint filters
 * @since 1.0.0
 */
const nonPositiveBigInt = annotations => lessThanOrEqualToBigInt(0n, annotations);
/**
 * Clamps a bigint between a minimum and a maximum value.
 *
 * @category bigint transformations
 * @since 1.0.0
 */
const clampBigInt = (minimum, maximum) => self => transform(self, self.pipe(typeSchema, betweenBigInt(minimum, maximum)), {
  strict: false,
  decode: self => bigInt_.clamp(self, {
    minimum,
    maximum
  }),
  encode: identity
});
const bigint = /*#__PURE__*/transformOrFail($String, BigIntFromSelf, {
  decode: (s, _, ast) => esm_ParseResult/* fromOption */.Yo(esm_BigInt/* fromString */.mL(s), () => new esm_ParseResult/* Type */.Dy(ast, s)),
  encode: n => esm_ParseResult/* succeed */.ng(String(n))
}).annotations({
  identifier: "bigint"
});

/**
 * @category bigint constructors
 * @since 1.0.0
 */
const PositiveBigIntFromSelf = /*#__PURE__*/BigIntFromSelf.pipe( /*#__PURE__*/positiveBigInt({
  identifier: "PositiveBigintFromSelf",
  title: "PositiveBigintFromSelf"
}));
/**
 * @category bigint constructors
 * @since 1.0.0
 */
const PositiveBigInt = /*#__PURE__*/bigint.pipe( /*#__PURE__*/positiveBigInt({
  identifier: "PositiveBigint",
  title: "PositiveBigint"
}));
/**
 * @category bigint constructors
 * @since 1.0.0
 */
const NegativeBigIntFromSelf = /*#__PURE__*/BigIntFromSelf.pipe( /*#__PURE__*/negativeBigInt({
  identifier: "NegativeBigintFromSelf",
  title: "NegativeBigintFromSelf"
}));
/**
 * @category bigint constructors
 * @since 1.0.0
 */
const NegativeBigInt = /*#__PURE__*/bigint.pipe( /*#__PURE__*/negativeBigInt({
  identifier: "NegativeBigint",
  title: "NegativeBigint"
}));
/**
 * @category bigint constructors
 * @since 1.0.0
 */
const NonPositiveBigIntFromSelf = /*#__PURE__*/BigIntFromSelf.pipe( /*#__PURE__*/nonPositiveBigInt({
  identifier: "NonPositiveBigintFromSelf",
  title: "NonPositiveBigintFromSelf"
}));
/**
 * @category bigint constructors
 * @since 1.0.0
 */
const NonPositiveBigInt = /*#__PURE__*/bigint.pipe( /*#__PURE__*/nonPositiveBigInt({
  identifier: "NonPositiveBigint",
  title: "NonPositiveBigint"
}));
/**
 * @category bigint constructors
 * @since 1.0.0
 */
const NonNegativeBigIntFromSelf = /*#__PURE__*/BigIntFromSelf.pipe( /*#__PURE__*/nonNegativeBigInt({
  identifier: "NonNegativeBigintFromSelf",
  title: "NonNegativeBigintFromSelf"
}));
/**
 * @category bigint constructors
 * @since 1.0.0
 */
const NonNegativeBigInt = /*#__PURE__*/bigint.pipe( /*#__PURE__*/nonNegativeBigInt({
  identifier: "NonNegativeBigint",
  title: "NonNegativeBigint"
}));
/**
 * This schema transforms a `number` into a `bigint` by parsing the number using the `BigInt` function.
 *
 * It returns an error if the value can't be safely encoded as a `number` due to being out of range.
 *
 * @category bigint transformations
 * @since 1.0.0
 */
const BigIntFromNumber = /*#__PURE__*/transformOrFail($Number, BigIntFromSelf, {
  decode: (n, _, ast) => esm_ParseResult/* fromOption */.Yo(esm_BigInt/* fromNumber */.xS(n), () => new esm_ParseResult/* Type */.Dy(ast, n)),
  encode: (b, _, ast) => esm_ParseResult/* fromOption */.Yo(esm_BigInt/* toNumber */.He(b), () => new esm_ParseResult/* Type */.Dy(ast, b))
}).annotations({
  identifier: "BigintFromNumber"
});
/**
 * @category Secret constructors
 * @since 1.0.0
 */
const SecretFromSelf = /*#__PURE__*/declare(Secret_isSecret, {
  identifier: "SecretFromSelf",
  pretty: () => secret => String(secret),
  arbitrary: () => fc => fc.string().map(_ => Secret_fromString(_))
});
/**
 * A schema that transforms a `string` into a `Secret`.
 *
 * @category Secret transformations
 * @since 1.0.0
 */
const Secret = /*#__PURE__*/transform($String, SecretFromSelf, {
  strict: false,
  decode: str => Secret_fromString(str),
  encode: secret => Secret_value(secret)
}).annotations({
  identifier: "Secret"
});
/**
 * @category Duration constructors
 * @since 1.0.0
 */
const DurationFromSelf = /*#__PURE__*/declare(Duration/* isDuration */._9, {
  identifier: "DurationFromSelf",
  pretty: () => String,
  arbitrary: () => fc => fc.oneof(fc.constant(Duration/* infinity */.Fd), fc.bigUint().map(_ => Duration/* nanos */.o6(_)), fc.bigUint().map(_ => Duration/* micros */.Ti(_)), fc.maxSafeNat().map(_ => Duration/* millis */.YX(_)), fc.maxSafeNat().map(_ => Duration/* seconds */.m9(_)), fc.maxSafeNat().map(_ => Duration/* minutes */.LK(_)), fc.maxSafeNat().map(_ => Duration/* hours */.i4(_)), fc.maxSafeNat().map(_ => Duration/* days */.an(_)), fc.maxSafeNat().map(_ => Duration/* weeks */.P4(_))),
  equivalence: () => Duration/* Equivalence */.CZ
});
/**
 * A schema that transforms a `bigint` tuple into a `Duration`.
 * Treats the value as the number of nanoseconds.
 *
 * @category Duration transformations
 * @since 1.0.0
 */
const DurationFromNanos = /*#__PURE__*/transformOrFail(BigIntFromSelf, DurationFromSelf, {
  decode: nanos => esm_ParseResult/* succeed */.ng(Duration/* nanos */.o6(nanos)),
  encode: (duration, _, ast) => esm_Option/* match */.EQ(Duration/* toNanos */.CU(duration), {
    onNone: () => esm_ParseResult/* fail */.bG(new esm_ParseResult/* Type */.Dy(ast, duration)),
    onSome: val => esm_ParseResult/* succeed */.ng(val)
  })
}).annotations({
  identifier: "DurationFromNanos"
});
/**
 * A schema that transforms a `number` tuple into a `Duration`.
 * Treats the value as the number of milliseconds.
 *
 * @category Duration transformations
 * @since 1.0.0
 */
const DurationFromMillis = /*#__PURE__*/transform($Number, DurationFromSelf, {
  decode: ms => Duration/* millis */.YX(ms),
  encode: n => Duration/* toMillis */.eq(n)
}).annotations({
  identifier: "DurationFromMillis"
});
const hrTime = /*#__PURE__*/Tuple( /*#__PURE__*/NonNegative.pipe( /*#__PURE__*/finite({
  [esm_AST/* TitleAnnotationId */.Lf]: "seconds",
  [esm_AST/* DescriptionAnnotationId */.Aj]: "seconds"
})), /*#__PURE__*/NonNegative.pipe( /*#__PURE__*/finite({
  [esm_AST/* TitleAnnotationId */.Lf]: "nanos",
  [esm_AST/* DescriptionAnnotationId */.Aj]: "nanos"
})));
/**
 * A schema that transforms a `[number, number]` tuple into a `Duration`.
 *
 * @category Duration transformations
 * @since 1.0.0
 */
const Schema_Duration = /*#__PURE__*/transform(hrTime, DurationFromSelf, {
  decode: ([seconds, nanos]) => Duration/* nanos */.o6(BigInt(seconds) * BigInt(1e9) + BigInt(nanos)),
  encode: duration => Duration/* toHrTime */.hX(duration)
}).annotations({
  identifier: "Duration"
});
/**
 * Clamps a `Duration` between a minimum and a maximum value.
 *
 * @category Duration transformations
 * @since 1.0.0
 */
const clampDuration = (minimum, maximum) => self => transform(self, self.pipe(typeSchema, betweenDuration(minimum, maximum)), {
  strict: false,
  decode: self => duration_.clamp(self, {
    minimum,
    maximum
  }),
  encode: identity
});
/**
 * @category type id
 * @since 1.0.0
 */
const LessThanDurationTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/LessThanDuration")));
/**
 * @category Duration filters
 * @since 1.0.0
 */
const lessThanDuration = (max, annotations) => self => self.pipe(filter(a => duration_.lessThan(a, max), {
  typeId: {
    id: LessThanDurationTypeId,
    annotation: {
      max
    }
  },
  description: `a Duration less than ${duration_.decode(max)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const LessThanOrEqualToDurationTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/LessThanOrEqualToDuration")));
/**
 * @category Duration filters
 * @since 1.0.0
 */
const lessThanOrEqualToDuration = (max, annotations) => self => self.pipe(filter(a => duration_.lessThanOrEqualTo(a, max), {
  typeId: {
    id: LessThanDurationTypeId,
    annotation: {
      max
    }
  },
  description: `a Duration less than or equal to ${duration_.decode(max)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const GreaterThanDurationTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/GreaterThanDuration")));
/**
 * @category Duration filters
 * @since 1.0.0
 */
const greaterThanDuration = (min, annotations) => self => self.pipe(filter(a => duration_.greaterThan(a, min), {
  typeId: {
    id: GreaterThanDurationTypeId,
    annotation: {
      min
    }
  },
  description: `a Duration greater than ${duration_.decode(min)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const GreaterThanOrEqualToDurationTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/GreaterThanOrEqualToDuration")));
/**
 * @category Duration filters
 * @since 1.0.0
 */
const greaterThanOrEqualToDuration = (min, annotations) => self => self.pipe(filter(a => duration_.greaterThanOrEqualTo(a, min), {
  typeId: {
    id: GreaterThanOrEqualToDurationTypeId,
    annotation: {
      min
    }
  },
  description: `a Duration greater than or equal to ${duration_.decode(min)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const BetweenDurationTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/BetweenDuration")));
/**
 * @category Duration filters
 * @since 1.0.0
 */
const betweenDuration = (minimum, maximum, annotations) => self => self.pipe(filter(a => duration_.between(a, {
  minimum,
  maximum
}), {
  typeId: {
    id: BetweenDurationTypeId,
    annotation: {
      maximum,
      minimum
    }
  },
  description: `a Duration between ${duration_.decode(minimum)} and ${duration_.decode(maximum)}`,
  ...annotations
}));
/**
 * @category Uint8Array constructors
 * @since 1.0.0
 */
const Uint8ArrayFromSelf = /*#__PURE__*/declare(esm_Predicate/* isUint8Array */.lq, {
  identifier: "Uint8ArrayFromSelf",
  pretty: () => u8arr => `new Uint8Array(${JSON.stringify(Array.from(u8arr))})`,
  arbitrary: () => fc => fc.uint8Array(),
  equivalence: () => esm_Array/* getEquivalence */.c5(esm_Equal/* equals */.fS)
});
const $Uint8Array = /*#__PURE__*/transform($Array($Number.pipe(between(0, 255, {
  title: "8-bit unsigned integer",
  description: "a 8-bit unsigned integer"
}))).annotations({
  description: "an array of 8-bit unsigned integers"
}), Uint8ArrayFromSelf, {
  decode: numbers => Uint8Array.from(numbers),
  encode: uint8Array => Array.from(uint8Array)
}).annotations({
  identifier: "Uint8Array"
});

const makeEncodingTransformation = (id, decode, encode) => transformOrFail($String, Uint8ArrayFromSelf, {
  strict: false,
  decode: (s, _, ast) => Either/* mapLeft */.Vn(decode(s), decodeException => new esm_ParseResult/* Type */.Dy(ast, s, decodeException.message)),
  encode: u => esm_ParseResult/* succeed */.ng(encode(u))
}).annotations({
  identifier: id
});
/**
 * @category Encoding transformations
 * @since 1.0.0
 */
const Base64 = /*#__PURE__*/makeEncodingTransformation("Base64", Encoding/* decodeBase64 */.NV, Encoding/* encodeBase64 */.oF);
/**
 * @category Encoding transformations
 * @since 1.0.0
 */
const Base64Url = /*#__PURE__*/makeEncodingTransformation("Base64Url", Encoding/* decodeBase64Url */.fr, Encoding/* encodeBase64Url */.Mp);
/**
 * @category Encoding transformations
 * @since 1.0.0
 */
const Hex = /*#__PURE__*/makeEncodingTransformation("Hex", Encoding/* decodeHex */.QT, Encoding/* encodeHex */.U$);
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_MinItemsTypeId = MinItemsTypeId;
/**
 * @category ReadonlyArray filters
 * @since 1.0.0
 */
const minItems = (n, annotations) => self => self.pipe(filter(a => a.length >= n, {
  typeId: Schema_MinItemsTypeId,
  description: `an array of at least ${n} items`,
  jsonSchema: {
    minItems: n
  },
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_MaxItemsTypeId = MaxItemsTypeId;
/**
 * @category ReadonlyArray filters
 * @since 1.0.0
 */
const maxItems = (n, annotations) => self => self.pipe(filter(a => a.length <= n, {
  typeId: Schema_MaxItemsTypeId,
  description: `an array of at most ${n} items`,
  jsonSchema: {
    maxItems: n
  },
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const Schema_ItemsCountTypeId = ItemsCountTypeId;
/**
 * @category ReadonlyArray filters
 * @since 1.0.0
 */
const itemsCount = (n, annotations) => self => self.pipe(filter(a => a.length === n, {
  typeId: Schema_ItemsCountTypeId,
  description: `an array of exactly ${n} item(s)`,
  jsonSchema: {
    minItems: n,
    maxItems: n
  },
  ...annotations
}));
/**
 * @category ReadonlyArray transformations
 * @since 1.0.0
 */
const getNumberIndexedAccess = self => Schema_make(AST.getNumberIndexedAccess(self.ast));
/**
 * Get the first element of a `ReadonlyArray`, or `None` if the array is empty.
 *
 * @category ReadonlyArray transformations
 * @since 1.0.0
 */
const head = self => transform(self, OptionFromSelf(getNumberIndexedAccess(typeSchema(self))), {
  decode: array_.head,
  encode: option_.match({
    onNone: () => [],
    onSome: array_.of
  })
});
/**
 * Retrieves the first element of a `ReadonlyArray`.
 *
 * If the array is empty, it returns the `fallback` argument if provided; otherwise, it fails.
 *
 * @category ReadonlyArray transformations
 * @since 1.0.0
 */
const headOrElse = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isSchema(args[0]), (self, fallback) => transformOrFail(self, getNumberIndexedAccess(typeSchema(self)), {
  decode: (as, _, ast) => as.length > 0 ? ParseResult.succeed(as[0]) : fallback ? ParseResult.succeed(fallback()) : ParseResult.fail(new ParseResult.Type(ast, as)),
  encode: a => ParseResult.succeed(array_.of(a))
}))));
/**
 * @category type id
 * @since 1.0.0
 */
const ValidDateTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/ValidDate");
/**
 * A filter that **excludes invalid** dates (e.g., `new Date("Invalid Date")` is rejected).
 *
 * @category Date filters
 * @since 1.0.0
 */
const validDate = annotations => self => self.pipe(filter(a => !Number.isNaN(a.getTime()), {
  typeId: ValidDateTypeId,
  description: "a valid Date",
  ...annotations
}));
/**
 * Represents a schema for handling potentially **invalid** `Date` instances (e.g., `new Date("Invalid Date")` is not rejected).
 *
 * @category Date constructors
 * @since 1.0.0
 */
const DateFromSelf = /*#__PURE__*/declare(esm_Predicate/* isDate */.J_, {
  identifier: "DateFromSelf",
  description: "a potentially invalid Date instance",
  pretty: () => date => `new Date(${JSON.stringify(date)})`,
  arbitrary: () => fc => fc.date({
    noInvalidDate: false
  }),
  equivalence: () => esm_Equivalence/* Date */.Ej
});
/**
 * Represents a schema for handling only **valid** dates. For example, `new Date("Invalid Date")` is rejected, even though it is an instance of `Date`.
 *
 * @category Date constructors
 * @since 1.0.0
 */
const ValidDateFromSelf = /*#__PURE__*/DateFromSelf.pipe( /*#__PURE__*/validDate({
  identifier: "ValidDateFromSelf",
  description: "a valid Date instance"
}));
/**
 * Represents a schema that converts a `string` into a (potentially invalid) `Date` (e.g., `new Date("Invalid Date")` is not rejected).
 *
 * @category Date transformations
 * @since 1.0.0
 */
const DateFromString = /*#__PURE__*/transform($String, DateFromSelf, {
  decode: s => new Date(s),
  encode: n => n.toISOString()
}).annotations({
  identifier: "DateFromString"
});
const $Date = /*#__PURE__*/DateFromString.pipe( /*#__PURE__*/validDate({
  identifier: "Date"
}));

const OptionNoneEncoded = /*#__PURE__*/Struct({
  _tag: Literal("None")
}).annotations({
  description: "NoneEncoded"
});
const optionSomeEncoded = value => Struct({
  _tag: Literal("Some"),
  value
}).annotations({
  description: `SomeEncoded<${format(value)}>`
});
const optionEncoded = value => Union(OptionNoneEncoded, optionSomeEncoded(value)).annotations({
  description: `OptionEncoded<${format(value)}>`
});
const optionDecode = input => input._tag === "None" ? option_.none() : option_.some(input.value);
const optionArbitrary = value => fc => fc.oneof(fc.record({
  _tag: fc.constant("None")
}), fc.record({
  _tag: fc.constant("Some"),
  value: value(fc)
})).map(optionDecode);
const optionPretty = value => option_.match({
  onNone: () => "none()",
  onSome: a => `some(${value(a)})`
});
const optionParse = decodeUnknown => (u, options, ast) => option_.isOption(u) ? option_.isNone(u) ? ParseResult.succeed(option_.none()) : ParseResult.map(decodeUnknown(u.value, options), option_.some) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Option transformations
 * @since 1.0.0
 */
const OptionFromSelf = value => {
  return declare([value], {
    decode: value => optionParse(ParseResult.decodeUnknown(value)),
    encode: value => optionParse(ParseResult.encodeUnknown(value))
  }, {
    description: `Option<${format(value)}>`,
    pretty: optionPretty,
    arbitrary: optionArbitrary,
    equivalence: option_.getEquivalence
  });
};
const makeNoneEncoded = {
  _tag: "None"
};
const makeSomeEncoded = value => ({
  _tag: "Some",
  value
});
/**
 * @category Option transformations
 * @since 1.0.0
 */
const Schema_Option = value => {
  const value_ = asSchema(value);
  return transform(optionEncoded(value_), OptionFromSelf(typeSchema(value_)), {
    decode: optionDecode,
    encode: option_.match({
      onNone: () => makeNoneEncoded,
      onSome: makeSomeEncoded
    })
  });
};
/**
 * @category Option transformations
 * @since 1.0.0
 */
const OptionFromNullOr = value => {
  const value_ = asSchema(value);
  return transform(NullOr(value_), OptionFromSelf(typeSchema(value_)), {
    decode: option_.fromNullable,
    encode: option_.getOrNull
  });
};
/**
 * @category Option transformations
 * @since 1.0.0
 */
const OptionFromNullishOr = (value, onNoneEncoding) => {
  const value_ = asSchema(value);
  return transform(NullishOr(value_), OptionFromSelf(typeSchema(value_)), {
    decode: option_.fromNullable,
    encode: onNoneEncoding === null ? option_.getOrNull : option_.getOrUndefined
  });
};
/**
 * @category Option transformations
 * @since 1.0.0
 */
const OptionFromUndefinedOr = value => {
  const value_ = asSchema(value);
  return transform(UndefinedOr(value_), OptionFromSelf(typeSchema(value_)), {
    decode: option_.fromNullable,
    encode: option_.getOrUndefined
  });
};
const rightEncoded = right => Struct({
  _tag: Literal("Right"),
  right
}).annotations({
  description: `RightEncoded<${format(right)}>`
});
const leftEncoded = left => Struct({
  _tag: Literal("Left"),
  left
}).annotations({
  description: `LeftEncoded<${format(left)}>`
});
const eitherEncoded = (right, left) => Union(rightEncoded(right), leftEncoded(left)).annotations({
  description: `EitherEncoded<${format(left)}, ${format(right)}>`
});
const eitherDecode = input => input._tag === "Left" ? either_.left(input.left) : either_.right(input.right);
const eitherArbitrary = (right, left) => fc => fc.oneof(fc.record({
  _tag: fc.constant("Left"),
  left: left(fc)
}), fc.record({
  _tag: fc.constant("Right"),
  right: right(fc)
})).map(eitherDecode);
const eitherPretty = (right, left) => either_.match({
  onLeft: e => `left(${left(e)})`,
  onRight: a => `right(${right(a)})`
});
const eitherParse = (parseRight, decodeUnknownLeft) => (u, options, ast) => either_.isEither(u) ? either_.match(u, {
  onLeft: left => ParseResult.map(decodeUnknownLeft(left, options), either_.left),
  onRight: right => ParseResult.map(parseRight(right, options), either_.right)
}) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Either transformations
 * @since 1.0.0
 */
const EitherFromSelf = ({
  left,
  right
}) => {
  return declare([right, left], {
    decode: (right, left) => eitherParse(ParseResult.decodeUnknown(right), ParseResult.decodeUnknown(left)),
    encode: (right, left) => eitherParse(ParseResult.encodeUnknown(right), ParseResult.encodeUnknown(left))
  }, {
    description: `Either<${format(right)}, ${format(left)}>`,
    pretty: eitherPretty,
    arbitrary: eitherArbitrary,
    equivalence: (right, left) => either_.getEquivalence({
      left,
      right
    })
  });
};
const makeLeftEncoded = left => ({
  _tag: "Left",
  left
});
const makeRightEncoded = right => ({
  _tag: "Right",
  right
});
/**
 * @category Either transformations
 * @since 1.0.0
 */
const Schema_Either = ({
  left,
  right
}) => {
  const right_ = asSchema(right);
  const left_ = asSchema(left);
  return transform(eitherEncoded(right_, left_), EitherFromSelf({
    left: typeSchema(left_),
    right: typeSchema(right_)
  }), {
    decode: eitherDecode,
    encode: either_.match({
      onLeft: makeLeftEncoded,
      onRight: makeRightEncoded
    })
  });
};
/**
 * @example
 * import * as Schema from "@effect/schema/Schema"
 *
 * // Schema<string | number, Either<string, number>>
 * Schema.EitherFromUnion({ left: Schema.String, right: Schema.Number })
 *
 * @category Either transformations
 * @since 1.0.0
 */
const EitherFromUnion = ({
  left,
  right
}) => {
  const right_ = asSchema(right);
  const left_ = asSchema(left);
  const toright = typeSchema(right_);
  const toleft = typeSchema(left_);
  const fromRight = transform(right_, rightEncoded(toright), {
    decode: makeRightEncoded,
    encode: r => r.right
  });
  const fromLeft = transform(left_, leftEncoded(toleft), {
    decode: makeLeftEncoded,
    encode: l => l.left
  });
  return transform(Union(fromRight, fromLeft), EitherFromSelf({
    left: toleft,
    right: toright
  }), {
    decode: from => from._tag === "Left" ? either_.left(from.left) : either_.right(from.right),
    encode: either_.match({
      onLeft: makeLeftEncoded,
      onRight: makeRightEncoded
    })
  });
};
const mapArbitrary = (key, value) => fc => fc.array(fc.tuple(key(fc), value(fc))).map(as => new Map(as));
const readonlyMapPretty = (key, value) => map => `new Map([${Array.from(map.entries()).map(([k, v]) => `[${key(k)}, ${value(v)}]`).join(", ")}])`;
const readonlyMapEquivalence = (key, value) => {
  const arrayEquivalence = array_.getEquivalence(Equivalence.make(([ka, va], [kb, vb]) => key(ka, kb) && value(va, vb)));
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a.entries()), Array.from(b.entries())));
};
const readonlyMapParse = decodeUnknown => (u, options, ast) => Predicate.isMap(u) ? ParseResult.map(decodeUnknown(Array.from(u.entries()), options), as => new Map(as)) : ParseResult.fail(new ParseResult.Type(ast, u));
const mapFromSelf_ = (key, value, description) => declare([key, value], {
  decode: (Key, Value) => readonlyMapParse(ParseResult.decodeUnknown($Array(Tuple(Key, Value)))),
  encode: (Key, Value) => readonlyMapParse(ParseResult.encodeUnknown($Array(Tuple(Key, Value))))
}, {
  description,
  pretty: readonlyMapPretty,
  arbitrary: mapArbitrary,
  equivalence: readonlyMapEquivalence
});
/**
 * @category ReadonlyMap
 * @since 1.0.0
 */
const ReadonlyMapFromSelf = ({
  key,
  value
}) => mapFromSelf_(key, value, `ReadonlyMap<${format(key)}, ${format(value)}>`);
/**
 * @category Map
 * @since 1.0.0
 */
const MapFromSelf = ({
  key,
  value
}) => mapFromSelf_(key, value, `Map<${format(key)}, ${format(value)}>`);
/**
 * @category ReadonlyMap transformations
 * @since 1.0.0
 */
const ReadonlyMap = ({
  key,
  value
}) => {
  const key_ = asSchema(key);
  const value_ = asSchema(value);
  return transform($Array(Tuple(key_, value_)), ReadonlyMapFromSelf({
    key: typeSchema(key_),
    value: typeSchema(value_)
  }), {
    decode: as => new Map(as),
    encode: map => Array.from(map.entries())
  });
};
const map = ({
  key,
  value
}) => {
  const key_ = asSchema(key);
  const value_ = asSchema(value);
  return transform($Array(Tuple(key_, value_)), MapFromSelf({
    key: typeSchema(key_),
    value: typeSchema(value_)
  }), {
    decode: as => new Map(as),
    encode: map => Array.from(map.entries())
  });
};

const setArbitrary = item => fc => fc.array(item(fc)).map(as => new Set(as));
const readonlySetPretty = item => set => `new Set([${Array.from(set.values()).map(a => item(a)).join(", ")}])`;
const readonlySetEquivalence = item => {
  const arrayEquivalence = array_.getEquivalence(item);
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a.values()), Array.from(b.values())));
};
const readonlySetParse = decodeUnknown => (u, options, ast) => Predicate.isSet(u) ? ParseResult.map(decodeUnknown(Array.from(u.values()), options), as => new Set(as)) : ParseResult.fail(new ParseResult.Type(ast, u));
const setFromSelf_ = (value, description) => declare([value], {
  decode: item => readonlySetParse(ParseResult.decodeUnknown($Array(item))),
  encode: item => readonlySetParse(ParseResult.encodeUnknown($Array(item)))
}, {
  description,
  pretty: readonlySetPretty,
  arbitrary: setArbitrary,
  equivalence: readonlySetEquivalence
});
/**
 * @category ReadonlySet
 * @since 1.0.0
 */
const ReadonlySetFromSelf = value => setFromSelf_(value, `ReadonlySet<${format(value)}>`);
/**
 * @category Set
 * @since 1.0.0
 */
const SetFromSelf = value => setFromSelf_(value, `Set<${format(value)}>`);
/**
 * @category ReadonlySet transformations
 * @since 1.0.0
 */
const ReadonlySet = value => {
  const value_ = asSchema(value);
  return transform($Array(value_), ReadonlySetFromSelf(typeSchema(value_)), {
    decode: as => new Set(as),
    encode: set => Array.from(set)
  });
};
const set = value => {
  const value_ = asSchema(value);
  return transform($Array(value_), SetFromSelf(typeSchema(value_)), {
    decode: as => new Set(as),
    encode: set => Array.from(set)
  });
};

const bigDecimalPretty = () => val => `BigDecimal(${BigDecimal/* format */.WU(BigDecimal/* normalize */.Fv(val))})`;
const bigDecimalArbitrary = () => fc => fc.tuple(fc.bigInt(), fc.integer()).map(([value, scale]) => BigDecimal/* make */.Sy(value, scale));
/**
 * @category BigDecimal constructors
 * @since 1.0.0
 */
const BigDecimalFromSelf = /*#__PURE__*/declare(BigDecimal/* isBigDecimal */.Hv, {
  identifier: "BigDecimalFromSelf",
  pretty: bigDecimalPretty,
  arbitrary: bigDecimalArbitrary,
  equivalence: () => BigDecimal/* Equivalence */.CZ
});
/**
 * @category BigDecimal transformations
 * @since 1.0.0
 */
const Schema_BigDecimal = /*#__PURE__*/transformOrFail($String, BigDecimalFromSelf, {
  decode: (num, _, ast) => BigDecimal/* fromString */.mL(num).pipe(esm_Option/* match */.EQ({
    onNone: () => esm_ParseResult/* fail */.bG(new esm_ParseResult/* Type */.Dy(ast, num)),
    onSome: val => esm_ParseResult/* succeed */.ng(BigDecimal/* normalize */.Fv(val))
  })),
  encode: val => esm_ParseResult/* succeed */.ng(BigDecimal/* format */.WU(BigDecimal/* normalize */.Fv(val)))
}).annotations({
  identifier: "BigDecimal"
});
/**
 * A schema that transforms a `number` into a `BigDecimal`.
 * When encoding, this Schema will produce incorrect results if the BigDecimal exceeds the 64-bit range of a number.
 *
 * @category BigDecimal transformations
 * @since 1.0.0
 */
const BigDecimalFromNumber = /*#__PURE__*/transformOrFail($Number, BigDecimalFromSelf, {
  decode: num => esm_ParseResult/* succeed */.ng(BigDecimal/* fromNumber */.xS(num)),
  encode: val => esm_ParseResult/* succeed */.ng(BigDecimal/* unsafeToNumber */.mn(val))
}).annotations({
  identifier: "BigDecimalFromNumber"
});
/**
 * @category type id
 * @since 1.0.0
 */
const GreaterThanBigDecimalTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/GreaterThanBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 1.0.0
 */
const greaterThanBigDecimal = (min, annotations) => self => self.pipe(filter(a => bigDecimal_.greaterThan(a, min), {
  typeId: {
    id: GreaterThanBigDecimalTypeId,
    annotation: {
      min
    }
  },
  description: `a BigDecimal greater than ${bigDecimal_.format(min)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const GreaterThanOrEqualToBigDecimalTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/GreaterThanOrEqualToBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 1.0.0
 */
const greaterThanOrEqualToBigDecimal = (min, annotations) => self => self.pipe(filter(a => bigDecimal_.greaterThanOrEqualTo(a, min), {
  typeId: {
    id: GreaterThanOrEqualToBigDecimalTypeId,
    annotation: {
      min
    }
  },
  description: `a BigDecimal greater than or equal to ${bigDecimal_.format(min)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const LessThanBigDecimalTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/LessThanBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 1.0.0
 */
const lessThanBigDecimal = (max, annotations) => self => self.pipe(filter(a => bigDecimal_.lessThan(a, max), {
  typeId: {
    id: LessThanBigDecimalTypeId,
    annotation: {
      max
    }
  },
  description: `a BigDecimal less than ${bigDecimal_.format(max)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const LessThanOrEqualToBigDecimalTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/LessThanOrEqualToBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 1.0.0
 */
const lessThanOrEqualToBigDecimal = (max, annotations) => self => self.pipe(filter(a => bigDecimal_.lessThanOrEqualTo(a, max), {
  typeId: {
    id: LessThanOrEqualToBigDecimalTypeId,
    annotation: {
      max
    }
  },
  description: `a BigDecimal less than or equal to ${bigDecimal_.format(max)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 1.0.0
 */
const PositiveBigDecimalTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/PositiveBigDecimal");
/**
 * @category BigDecimal filters
 * @since 1.0.0
 */
const positiveBigDecimal = annotations => self => self.pipe(filter(a => BigDecimal/* isPositive */.xP(a), {
  typeId: {
    id: PositiveBigDecimalTypeId,
    annotation: {}
  },
  description: `a positive BigDecimal`,
  ...annotations
}));
/**
 * @category BigDecimal constructors
 * @since 1.0.0
 */
const PositiveBigDecimalFromSelf = /*#__PURE__*/BigDecimalFromSelf.pipe( /*#__PURE__*/positiveBigDecimal({
  identifier: "PositiveBigDecimalFromSelf",
  title: "PositiveBigDecimalFromSelf"
}));
/**
 * @category type id
 * @since 1.0.0
 */
const NonNegativeBigDecimalTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/NonNegativeBigDecimal");
/**
 * @category BigDecimal filters
 * @since 1.0.0
 */
const nonNegativeBigDecimal = annotations => self => self.pipe(filter(a => a.value >= 0n, {
  typeId: {
    id: NonNegativeBigDecimalTypeId,
    annotation: {}
  },
  description: `a non-negative BigDecimal`,
  ...annotations
}));
/**
 * @category BigDecimal constructors
 * @since 1.0.0
 */
const NonNegativeBigDecimalFromSelf = /*#__PURE__*/BigDecimalFromSelf.pipe( /*#__PURE__*/nonNegativeBigDecimal({
  identifier: "NonNegativeBigDecimalFromSelf",
  title: "NonNegativeBigDecimalFromSelf"
}));
/**
 * @category type id
 * @since 1.0.0
 */
const NegativeBigDecimalTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/NegativeBigDecimal");
/**
 * @category BigDecimal filters
 * @since 1.0.0
 */
const negativeBigDecimal = annotations => self => self.pipe(filter(a => BigDecimal/* isNegative */.nM(a), {
  typeId: {
    id: NegativeBigDecimalTypeId,
    annotation: {}
  },
  description: `a negative BigDecimal`,
  ...annotations
}));
/**
 * @category BigDecimal constructors
 * @since 1.0.0
 */
const NegativeBigDecimalFromSelf = /*#__PURE__*/BigDecimalFromSelf.pipe( /*#__PURE__*/negativeBigDecimal({
  identifier: "NegativeBigDecimalFromSelf",
  title: "NegativeBigDecimalFromSelf"
}));
/**
 * @category type id
 * @since 1.0.0
 */
const NonPositiveBigDecimalTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/NonPositiveBigDecimal");
/**
 * @category BigDecimal filters
 * @since 1.0.0
 */
const nonPositiveBigDecimal = annotations => self => self.pipe(filter(a => a.value <= 0n, {
  typeId: {
    id: NonPositiveBigDecimalTypeId,
    annotation: {}
  },
  description: `a non-positive BigDecimal`,
  ...annotations
}));
/**
 * @category BigDecimal constructors
 * @since 1.0.0
 */
const NonPositiveBigDecimalFromSelf = /*#__PURE__*/BigDecimalFromSelf.pipe( /*#__PURE__*/nonPositiveBigDecimal({
  identifier: "NonPositiveBigDecimalFromSelf",
  title: "NonPositiveBigDecimalFromSelf"
}));
/**
 * @category type id
 * @since 1.0.0
 */
const BetweenBigDecimalTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/BetweenBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 1.0.0
 */
const betweenBigDecimal = (minimum, maximum, annotations) => self => self.pipe(filter(a => bigDecimal_.between(a, {
  minimum,
  maximum
}), {
  typeId: {
    id: BetweenBigDecimalTypeId,
    annotation: {
      maximum,
      minimum
    }
  },
  description: `a BigDecimal between ${bigDecimal_.format(minimum)} and ${bigDecimal_.format(maximum)}`,
  ...annotations
}));
/**
 * Clamps a `BigDecimal` between a minimum and a maximum value.
 *
 * @category BigDecimal transformations
 * @since 1.0.0
 */
const clampBigDecimal = (minimum, maximum) => self => transform(self, self.pipe(typeSchema, betweenBigDecimal(minimum, maximum)), {
  strict: false,
  decode: self => bigDecimal_.clamp(self, {
    minimum,
    maximum
  }),
  encode: identity
});
const chunkArbitrary = item => fc => fc.array(item(fc)).map(chunk_.fromIterable);
const chunkPretty = item => c => `Chunk(${chunk_.toReadonlyArray(c).map(item).join(", ")})`;
const chunkParse = decodeUnknown => (u, options, ast) => chunk_.isChunk(u) ? chunk_.isEmpty(u) ? ParseResult.succeed(chunk_.empty()) : ParseResult.map(decodeUnknown(chunk_.toReadonlyArray(u), options), chunk_.fromIterable) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Chunk transformations
 * @since 1.0.0
 */
const ChunkFromSelf = value => {
  return declare([value], {
    decode: item => chunkParse(ParseResult.decodeUnknown($Array(item))),
    encode: item => chunkParse(ParseResult.encodeUnknown($Array(item)))
  }, {
    description: `Chunk<${format(value)}>`,
    pretty: chunkPretty,
    arbitrary: chunkArbitrary,
    equivalence: chunk_.getEquivalence
  });
};
/**
 * @category Chunk transformations
 * @since 1.0.0
 */
const Chunk = value => {
  const value_ = asSchema(value);
  return transform($Array(value_), ChunkFromSelf(typeSchema(value_)), {
    decode: as => as.length === 0 ? chunk_.empty() : chunk_.fromIterable(as),
    encode: chunk_.toReadonlyArray
  });
};
const toData = a => Array.isArray(a) ? data_.array(a) : data_.struct(a);
const dataArbitrary = item => fc => item(fc).map(toData);
const dataPretty = item => d => `Data(${item(d)})`;
const dataParse = decodeUnknown => (u, options, ast) => Equal.isEqual(u) ? ParseResult.map(decodeUnknown(u, options), toData) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Data transformations
 * @since 1.0.0
 */
const DataFromSelf = item => {
  return declare([item], {
    decode: item => dataParse(ParseResult.decodeUnknown(item)),
    encode: item => dataParse(ParseResult.encodeUnknown(item))
  }, {
    description: `Data<${format(item)}>`,
    pretty: dataPretty,
    arbitrary: dataArbitrary
  });
};
/**
 * @category Data transformations
 * @since 1.0.0
 */
const Data = item => transform(item, DataFromSelf(typeSchema(item)), {
  strict: false,
  decode: toData,
  encode: a => Array.isArray(a) ? Array.from(a) : Object.assign({}, a)
});
/**
 * @category classes
 * @since 1.0.0
 */
const Class = identifier => (fields, annotations) => makeClass({
  kind: "Class",
  identifier,
  fields,
  Base: data_.Class,
  annotations
});
/**
 * @category classes
 * @since 1.0.0
 */
const TaggedClass = identifier => (tag, fields, annotations) => makeClass({
  kind: "TaggedClass",
  identifier: identifier ?? tag,
  fields: extendFields({
    _tag: Literal(tag)
  }, fields),
  Base: data_.Class,
  tag: {
    _tag: tag
  },
  annotations
});
/**
 * @category classes
 * @since 1.0.0
 */
const TaggedError = identifier => (tag, fields, annotations) => {
  class Base extends data_.Error {}
  ;
  Base.prototype.name = tag;
  return makeClass({
    kind: "TaggedError",
    identifier: identifier ?? tag,
    fields: extendFields({
      _tag: Literal(tag)
    }, fields),
    Base,
    tag: {
      _tag: tag
    },
    annotations,
    toStringOverride(self) {
      if (Predicate.isString(self.message) && self.message.length > 0) {
        let message = `${self._tag}: ${self.message}`;
        if (Predicate.isString(self.stack)) {
          message = `${message}\n${self.stack.split("\n").slice(1).join("\n")}`;
        }
        return message;
      }
    }
  });
};
/**
 * @category classes
 * @since 1.0.0
 */
const TaggedRequest = identifier => (tag, Failure, Success, fields, annotations) => {
  class SerializableRequest extends Request.Class {
    get [serializable_.symbol]() {
      return this.constructor;
    }
    get [serializable_.symbolResult]() {
      return {
        Failure,
        Success
      };
    }
  }
  return makeClass({
    kind: "TaggedRequest",
    identifier: identifier ?? tag,
    fields: extendFields({
      _tag: Literal(tag)
    }, fields),
    Base: SerializableRequest,
    tag: {
      _tag: tag
    },
    annotations
  });
};
const extendFields = (a, b) => {
  const out = {
    ...a
  };
  for (const name of util_.ownKeys(b)) {
    if (name in a) {
      throw new Error(errors_.getDuplicatePropertySignatureErrorMessage(name));
    }
    out[name] = b[name];
  }
  return out;
};
const makeClass = ({
  Base,
  annotations,
  fields,
  fromSchema,
  identifier,
  kind,
  tag,
  toStringOverride
}) => {
  const classSymbol = Symbol.for(`@effect/schema/${kind}/${identifier}`);
  const schema = fromSchema ?? Struct(fields);
  const from = option_.match(AST.getTitleAnnotation(schema.ast), {
    onNone: () => schema.annotations({
      title: `${identifier} (Encoded side)`
    }),
    onSome: () => schema
  });
  return class extends Base {
    constructor(props = {}, disableValidation = false) {
      if (tag !== undefined) {
        props = {
          ...props,
          ...tag
        };
      }
      if (disableValidation !== true) {
        props = ParseResult.validateSync(schema)(props);
      }
      super(props, true);
    }
    // ----------------
    // Schema interface
    // ----------------
    static [TypeId] = variance;
    static get ast() {
      const toSchema = typeSchema(schema);
      const guard = ParseResult.is(toSchema);
      const fallbackInstanceOf = u => Predicate.hasProperty(u, classSymbol) && guard(u);
      const encode = ParseResult.encodeUnknown(toSchema);
      const declaration = declare([toSchema], {
        decode: () => (input, _, ast) => input instanceof this || fallbackInstanceOf(input) ? ParseResult.succeed(input) : ParseResult.fail(new ParseResult.Type(ast, input)),
        encode: () => (input, options) => input instanceof this ? ParseResult.succeed(input) : ParseResult.map(encode(input, options), props => new this(props, true))
      }, {
        identifier,
        title: identifier,
        description: `an instance of ${identifier}`,
        pretty: pretty => self => `${identifier}(${pretty(self)})`,
        arbitrary: arb => fc => arb(fc).map(props => new this(props)),
        equivalence: identity,
        [AST.SurrogateAnnotationId]: toSchema.ast,
        ...annotations
      });
      const transformation = transform(from, declaration, {
        decode: input => new this(input, true),
        encode: identity
      }).annotations({
        [AST.SurrogateAnnotationId]: schema.ast
      });
      return transformation.ast;
    }
    static pipe() {
      return pipeArguments(this, arguments);
    }
    static annotations(annotations) {
      return Schema_make(this.ast).annotations(annotations);
    }
    static toString() {
      return `(${String(from)} <-> ${identifier})`;
    }
    // ----------------
    // Class interface
    // ----------------
    static fields = {
      ...fields
    };
    static identifier = identifier;
    static extend(identifier) {
      return (newFields, annotations) => {
        const extendedFields = extendFields(fields, newFields);
        return makeClass({
          kind,
          identifier,
          fields: extendedFields,
          Base: this,
          tag,
          annotations
        });
      };
    }
    static transformOrFail(identifier) {
      return (newFields, options, annotations) => {
        const transformedFields = extendFields(fields, newFields);
        return makeClass({
          kind,
          identifier,
          fromSchema: transformOrFail(schema, typeSchema(Struct(transformedFields)), options),
          fields: transformedFields,
          Base: this,
          tag,
          annotations
        });
      };
    }
    static transformOrFailFrom(identifier) {
      return (newFields, options, annotations) => {
        const transformedFields = extendFields(fields, newFields);
        return makeClass({
          kind,
          identifier,
          fromSchema: transformOrFail(encodedSchema(schema), Struct(transformedFields), options),
          fields: transformedFields,
          Base: this,
          tag,
          annotations
        });
      };
    }
    // ----------------
    // other
    // ----------------
    get [classSymbol]() {
      return classSymbol;
    }
    toString() {
      if (toStringOverride !== undefined) {
        const out = toStringOverride(this);
        if (out !== undefined) {
          return out;
        }
      }
      return `${identifier}({ ${util_.ownKeys(fields).map(p => `${util_.formatPropertyKey(p)}: ${util_.formatUnknown(this[p])}`).join(", ")} })`;
    }
  };
};
const FiberIdNoneEncoded = /*#__PURE__*/Struct({
  _tag: Literal("None")
}).annotations({
  identifier: "FiberIdNoneEncoded"
});
const FiberIdRuntimeEncoded = /*#__PURE__*/Struct({
  _tag: Literal("Runtime"),
  id: Int.annotations({
    title: "id",
    description: "id"
  }),
  startTimeMillis: Int.annotations({
    title: "startTimeMillis",
    description: "startTimeMillis"
  })
}).annotations({
  identifier: "FiberIdRuntimeEncoded"
});
const FiberIdCompositeEncoded = /*#__PURE__*/Struct({
  _tag: Literal("Composite"),
  left: suspend(() => FiberIdEncoded),
  right: suspend(() => FiberIdEncoded)
}).annotations({
  identifier: "FiberIdCompositeEncoded"
});
const FiberIdEncoded = /*#__PURE__*/Union(FiberIdNoneEncoded, FiberIdRuntimeEncoded, FiberIdCompositeEncoded).annotations({
  identifier: "FiberIdEncoded"
});
const fiberIdArbitrary = fc => fc.letrec(tie => ({
  None: fc.record({
    _tag: fc.constant("None")
  }),
  Runtime: fc.record({
    _tag: fc.constant("Runtime"),
    id: fc.integer(),
    startTimeMillis: fc.integer()
  }),
  Composite: fc.record({
    _tag: fc.constant("Composite"),
    left: tie("FiberId"),
    right: tie("FiberId")
  }),
  FiberId: fc.oneof(tie("None"), tie("Runtime"), tie("Composite"))
})).FiberId.map(fiberIdDecode);
const fiberIdPretty = fiberId => {
  switch (fiberId._tag) {
    case "None":
      return "FiberId.none";
    case "Runtime":
      return `FiberId.runtime(${fiberId.id}, ${fiberId.startTimeMillis})`;
    case "Composite":
      return `FiberId.composite(${fiberIdPretty(fiberId.right)}, ${fiberIdPretty(fiberId.left)})`;
  }
};
/**
 * @category FiberId constructors
 * @since 1.0.0
 */
const FiberIdFromSelf = /*#__PURE__*/declare(FiberId/* isFiberId */.ez, {
  identifier: "FiberIdFromSelf",
  pretty: () => fiberIdPretty,
  arbitrary: () => fiberIdArbitrary
});
const fiberIdDecode = input => {
  switch (input._tag) {
    case "None":
      return FiberId/* none */.YP;
    case "Runtime":
      return FiberId/* runtime */.GZ(input.id, input.startTimeMillis);
    case "Composite":
      return FiberId/* composite */.h$(fiberIdDecode(input.left), fiberIdDecode(input.right));
  }
};
const fiberIdEncode = input => {
  switch (input._tag) {
    case "None":
      return {
        _tag: "None"
      };
    case "Runtime":
      return {
        _tag: "Runtime",
        id: input.id,
        startTimeMillis: input.startTimeMillis
      };
    case "Composite":
      return {
        _tag: "Composite",
        left: fiberIdEncode(input.left),
        right: fiberIdEncode(input.right)
      };
  }
};
/**
 * @category FiberId transformations
 * @since 1.0.0
 */
const Schema_FiberId = /*#__PURE__*/transform(FiberIdEncoded, FiberIdFromSelf, {
  decode: fiberIdDecode,
  encode: fiberIdEncode
}).annotations({
  identifier: "FiberId"
});
const causeDieEncoded = defect => Struct({
  _tag: Literal("Die"),
  defect
});
const CauseEmptyEncoded = /*#__PURE__*/Struct({
  _tag: /*#__PURE__*/Literal("Empty")
});
const causeFailEncoded = error => Struct({
  _tag: Literal("Fail"),
  error
});
const CauseInterruptEncoded = /*#__PURE__*/Struct({
  _tag: /*#__PURE__*/Literal("Interrupt"),
  fiberId: FiberIdEncoded
});
const causeParallelEncoded = causeEncoded => Struct({
  _tag: Literal("Parallel"),
  left: causeEncoded,
  right: causeEncoded
});
const causeSequentialEncoded = causeEncoded => Struct({
  _tag: Literal("Sequential"),
  left: causeEncoded,
  right: causeEncoded
});
const causeEncoded = (error, defect) => {
  const recur = suspend(() => out);
  const out = Union(CauseEmptyEncoded, causeFailEncoded(error), causeDieEncoded(defect), CauseInterruptEncoded, causeSequentialEncoded(recur), causeParallelEncoded(recur)).annotations({
    description: `CauseEncoded<${format(error)}>`
  });
  return out;
};
const causeArbitrary = (error, defect) => fc => fc.letrec(tie => ({
  Empty: fc.record({
    _tag: fc.constant("Empty")
  }),
  Fail: fc.record({
    _tag: fc.constant("Fail"),
    error: error(fc)
  }),
  Die: fc.record({
    _tag: fc.constant("Die"),
    defect: defect(fc)
  }),
  Interrupt: fc.record({
    _tag: fc.constant("Interrupt"),
    fiberId: fiberIdArbitrary(fc)
  }),
  Sequential: fc.record({
    _tag: fc.constant("Sequential"),
    left: tie("Cause"),
    right: tie("Cause")
  }),
  Parallel: fc.record({
    _tag: fc.constant("Parallel"),
    left: tie("Cause"),
    right: tie("Cause")
  }),
  Cause: fc.oneof(tie("Empty"), tie("Fail"), tie("Die"), tie("Interrupt"), tie("Sequential"), tie("Parallel"))
})).Cause.map(causeDecode);
const causePretty = error => cause => {
  const f = cause => {
    switch (cause._tag) {
      case "Empty":
        return "Cause.empty";
      case "Fail":
        return `Cause.fail(${error(cause.error)})`;
      case "Die":
        return `Cause.die(${cause_.pretty(cause)})`;
      case "Interrupt":
        return `Cause.interrupt(${fiberIdPretty(cause.fiberId)})`;
      case "Sequential":
        return `Cause.sequential(${f(cause.left)}, ${f(cause.right)})`;
      case "Parallel":
        return `Cause.parallel(${f(cause.left)}, ${f(cause.right)})`;
    }
  };
  return f(cause);
};
const causeParse = decodeUnknown => (u, options, ast) => cause_.isCause(u) ? ParseResult.map(decodeUnknown(causeEncode(u), options), causeDecode) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Cause transformations
 * @since 1.0.0
 */
const CauseFromSelf = ({
  defect = Unknown,
  error
}) => {
  return declare([error, defect], {
    decode: (error, defect) => causeParse(ParseResult.decodeUnknown(causeEncoded(error, defect))),
    encode: (error, defect) => causeParse(ParseResult.encodeUnknown(causeEncoded(error, defect)))
  }, {
    description: `Cause<${format(error)}>`,
    pretty: causePretty,
    arbitrary: causeArbitrary
  });
};
function causeDecode(cause) {
  switch (cause._tag) {
    case "Empty":
      return cause_.empty;
    case "Fail":
      return cause_.fail(cause.error);
    case "Die":
      return cause_.die(cause.defect);
    case "Interrupt":
      return cause_.interrupt(fiberIdDecode(cause.fiberId));
    case "Sequential":
      return cause_.sequential(causeDecode(cause.left), causeDecode(cause.right));
    case "Parallel":
      return cause_.parallel(causeDecode(cause.left), causeDecode(cause.right));
  }
}
function causeEncode(cause) {
  switch (cause._tag) {
    case "Empty":
      return {
        _tag: "Empty"
      };
    case "Fail":
      return {
        _tag: "Fail",
        error: cause.error
      };
    case "Die":
      return {
        _tag: "Die",
        defect: cause.defect
      };
    case "Interrupt":
      return {
        _tag: "Interrupt",
        fiberId: cause.fiberId
      };
    case "Sequential":
      return {
        _tag: "Sequential",
        left: causeEncode(cause.left),
        right: causeEncode(cause.right)
      };
    case "Parallel":
      return {
        _tag: "Parallel",
        left: causeEncode(cause.left),
        right: causeEncode(cause.right)
      };
  }
}
/**
 * @category Cause transformations
 * @since 1.0.0
 */
const CauseDefectUnknown = /*#__PURE__*/transform(Unknown, Unknown, {
  decode: u => {
    if (esm_Predicate/* isObject */.Kn(u) && "message" in u && typeof u.message === "string") {
      const err = new Error(u.message, {
        cause: u
      });
      if ("name" in u && typeof u.name === "string") {
        err.name = u.name;
      }
      err.stack = "stack" in u && typeof u.stack === "string" ? u.stack : "";
      return err;
    }
    return String(u);
  },
  encode: defect => {
    if (defect instanceof Error) {
      return {
        name: defect.name,
        message: defect.message
      };
    }
    return String(defect);
  }
});
/**
 * @category Cause transformations
 * @since 1.0.0
 */
const Cause = ({
  defect = CauseDefectUnknown,
  error
}) => {
  const error_ = asSchema(error);
  return transform(causeEncoded(error_, defect), CauseFromSelf({
    error: typeSchema(error_),
    defect: typeSchema(defect)
  }), {
    decode: causeDecode,
    encode: causeEncode
  });
};
const exitFailureEncoded = (error, defect) => Struct({
  _tag: Literal("Failure"),
  cause: causeEncoded(error, defect)
}).annotations({
  description: `FailureEncoded<${format(error)}>`
});
const exitSuccessEncoded = value => Struct({
  _tag: Literal("Success"),
  value
}).annotations({
  description: `SuccessEncoded<${format(value)}>`
});
const exitEncoded = (value, error, defect) => Union(exitFailureEncoded(error, defect), exitSuccessEncoded(value)).annotations({
  description: `ExitEncoded<${format(value)}, ${format(error)}>`
});
const exitDecode = input => {
  switch (input._tag) {
    case "Failure":
      return exit_.failCause(causeDecode(input.cause));
    case "Success":
      return exit_.succeed(input.value);
  }
};
const exitArbitrary = (value, error, defect) => fc => fc.oneof(fc.record({
  _tag: fc.constant("Failure"),
  cause: causeArbitrary(error, defect)(fc)
}), fc.record({
  _tag: fc.constant("Success"),
  value: value(fc)
})).map(exitDecode);
const exitPretty = (value, error) => exit => exit._tag === "Failure" ? `Exit.failCause(${causePretty(error)(exit.cause)})` : `Exit.succeed(${value(exit.value)})`;
const exitParse = (decodeUnknownValue, decodeUnknownCause) => (u, options, ast) => exit_.isExit(u) ? exit_.match(u, {
  onFailure: cause => ParseResult.map(decodeUnknownCause(cause, options), exit_.failCause),
  onSuccess: value => ParseResult.map(decodeUnknownValue(value, options), exit_.succeed)
}) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Exit transformations
 * @since 1.0.0
 */
const ExitFromSelf = ({
  defect = Unknown,
  failure,
  success
}) => declare([success, failure, defect], {
  decode: (success, failure, defect) => exitParse(ParseResult.decodeUnknown(success), ParseResult.decodeUnknown(CauseFromSelf({
    error: failure,
    defect
  }))),
  encode: (success, failure, defect) => exitParse(ParseResult.encodeUnknown(success), ParseResult.encodeUnknown(CauseFromSelf({
    error: failure,
    defect
  })))
}, {
  description: `Exit<${format(success)}, ${format(failure)}>`,
  pretty: exitPretty,
  arbitrary: exitArbitrary
});
/**
 * @category Exit transformations
 * @since 1.0.0
 */
const Exit = ({
  defect = CauseDefectUnknown,
  failure,
  success
}) => {
  const success_ = asSchema(success);
  const failure_ = asSchema(failure);
  return transform(exitEncoded(success_, failure_, defect), ExitFromSelf({
    failure: typeSchema(failure_),
    success: typeSchema(success_),
    defect: typeSchema(defect)
  }), {
    decode: exitDecode,
    encode: exit => exit._tag === "Failure" ? {
      _tag: "Failure",
      cause: exit.cause
    } : {
      _tag: "Success",
      value: exit.value
    }
  });
};
const hashSetArbitrary = item => fc => fc.array(item(fc)).map(as => hashSet_.fromIterable(as));
const hashSetPretty = item => set => `HashSet(${Array.from(set).map(a => item(a)).join(", ")})`;
const hashSetEquivalence = item => {
  const arrayEquivalence = array_.getEquivalence(item);
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a), Array.from(b)));
};
const hashSetParse = decodeUnknown => (u, options, ast) => hashSet_.isHashSet(u) ? ParseResult.map(decodeUnknown(Array.from(u), options), as => hashSet_.fromIterable(as)) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category HashSet transformations
 * @since 1.0.0
 */
const HashSetFromSelf = value => {
  return declare([value], {
    decode: item => hashSetParse(ParseResult.decodeUnknown($Array(item))),
    encode: item => hashSetParse(ParseResult.encodeUnknown($Array(item)))
  }, {
    description: `HashSet<${format(value)}>`,
    pretty: hashSetPretty,
    arbitrary: hashSetArbitrary,
    equivalence: hashSetEquivalence
  });
};
/**
 * @category HashSet transformations
 * @since 1.0.0
 */
const HashSet = value => {
  const value_ = asSchema(value);
  return transform($Array(value_), HashSetFromSelf(typeSchema(value_)), {
    decode: as => hashSet_.fromIterable(as),
    encode: set => Array.from(set)
  });
};
const hashMapArbitrary = (key, value) => fc => fc.array(fc.tuple(key(fc), value(fc))).map(as => hashMap_.fromIterable(as));
const hashMapPretty = (key, value) => map => `HashMap([${Array.from(map).map(([k, v]) => `[${key(k)}, ${value(v)}]`).join(", ")}])`;
const hashMapEquivalence = (key, value) => {
  const arrayEquivalence = array_.getEquivalence(Equivalence.make(([ka, va], [kb, vb]) => key(ka, kb) && value(va, vb)));
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a), Array.from(b)));
};
const hashMapParse = decodeUnknown => (u, options, ast) => hashMap_.isHashMap(u) ? ParseResult.map(decodeUnknown(Array.from(u), options), as => hashMap_.fromIterable(as)) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category HashMap transformations
 * @since 1.0.0
 */
const HashMapFromSelf = ({
  key,
  value
}) => {
  return declare([key, value], {
    decode: (key, value) => hashMapParse(ParseResult.decodeUnknown($Array(Tuple(key, value)))),
    encode: (key, value) => hashMapParse(ParseResult.encodeUnknown($Array(Tuple(key, value))))
  }, {
    description: `HashMap<${format(key)}, ${format(value)}>`,
    pretty: hashMapPretty,
    arbitrary: hashMapArbitrary,
    equivalence: hashMapEquivalence
  });
};
/**
 * @category HashMap transformations
 * @since 1.0.0
 */
const HashMap = ({
  key,
  value
}) => {
  const key_ = asSchema(key);
  const value_ = asSchema(value);
  return transform($Array(Tuple(key_, value_)), HashMapFromSelf({
    key: typeSchema(key_),
    value: typeSchema(value_)
  }), {
    decode: as => hashMap_.fromIterable(as),
    encode: map => Array.from(map)
  });
};
const listArbitrary = item => fc => fc.array(item(fc)).map(as => list_.fromIterable(as));
const listPretty = item => set => `List(${Array.from(set).map(a => item(a)).join(", ")})`;
const listEquivalence = item => {
  const arrayEquivalence = array_.getEquivalence(item);
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a), Array.from(b)));
};
const listParse = decodeUnknown => (u, options, ast) => list_.isList(u) ? ParseResult.map(decodeUnknown(Array.from(u), options), as => list_.fromIterable(as)) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category List transformations
 * @since 1.0.0
 */
const ListFromSelf = value => {
  return declare([value], {
    decode: item => listParse(ParseResult.decodeUnknown($Array(item))),
    encode: item => listParse(ParseResult.encodeUnknown($Array(item)))
  }, {
    description: `List<${format(value)}>`,
    pretty: listPretty,
    arbitrary: listArbitrary,
    equivalence: listEquivalence
  });
};
/**
 * @category List transformations
 * @since 1.0.0
 */
const List = value => {
  const value_ = asSchema(value);
  return transform($Array(value_), ListFromSelf(typeSchema(value_)), {
    decode: as => list_.fromIterable(as),
    encode: set => Array.from(set)
  });
};
const sortedSetArbitrary = (item, ord) => fc => fc.array(item(fc)).map(as => sortedSet_.fromIterable(as, ord));
const sortedSetPretty = item => set => `new SortedSet([${Array.from(sortedSet_.values(set)).map(a => item(a)).join(", ")}])`;
const sortedSetParse = (decodeUnknown, ord) => (u, options, ast) => sortedSet_.isSortedSet(u) ? ParseResult.map(decodeUnknown(Array.from(sortedSet_.values(u)), options), as => sortedSet_.fromIterable(as, ord)) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category SortedSet transformations
 * @since 1.0.0
 */
const SortedSetFromSelf = (value, ordA, ordI) => {
  return declare([value], {
    decode: item => sortedSetParse(ParseResult.decodeUnknown($Array(item)), ordA),
    encode: item => sortedSetParse(ParseResult.encodeUnknown($Array(item)), ordI)
  }, {
    description: `SortedSet<${format(value)}>`,
    pretty: sortedSetPretty,
    arbitrary: arb => sortedSetArbitrary(arb, ordA),
    equivalence: () => sortedSet_.getEquivalence()
  });
};
/**
 * @category SortedSet transformations
 * @since 1.0.0
 */
const SortedSet = (value, ordA) => {
  const value_ = asSchema(value);
  const to = typeSchema(value_);
  return transform($Array(value_), SortedSetFromSelf(to, ordA, ordA), {
    decode: as => sortedSet_.fromIterable(as, ordA),
    encode: set => Array.from(sortedSet_.values(set))
  });
};
/**
 * Converts an arbitrary value to a `boolean` by testing whether it is truthy.
 * Uses `!!val` to coerce the value to a `boolean`.
 *
 * @see https://developer.mozilla.org/docs/Glossary/Truthy
 * @category boolean constructors
 * @since 1.0.0
 */
const BooleanFromUnknown = /*#__PURE__*/transform(Unknown, $Boolean, {
  decode: esm_Predicate/* isTruthy */.fQ,
  encode: Function/* identity */.yR
}).annotations({
  identifier: "BooleanFromUnknown"
});
//# sourceMappingURL=Schema.js.map

/***/ }),

/***/ 48147:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A9": function() { return /* binding */ getDuplicateIndexSignatureErrorMessage; },
/* harmony export */   "Dm": function() { return /* binding */ getRequiredElementFollowinAnOptionalElementErrorMessage; },
/* harmony export */   "Mg": function() { return /* binding */ getDuplicatePropertySignatureTransformationErrorMessage; },
/* harmony export */   "cX": function() { return /* binding */ getDuplicatePropertySignatureErrorMessage; },
/* harmony export */   "dp": function() { return /* binding */ getPrettyErrorMessage; },
/* harmony export */   "l4": function() { return /* binding */ getAPIErrorMessage; },
/* harmony export */   "n8": function() { return /* binding */ getIndexSignatureParameterErrorMessage; }
/* harmony export */ });
/* unused harmony exports getArbitraryErrorMessage, getEquivalenceErrorMessage */
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10852);

/** @internal */
const getDuplicatePropertySignatureErrorMessage = name => `Duplicate property signature ${_util_js__WEBPACK_IMPORTED_MODULE_0__/* .formatUnknown */ .cT(name)}`;
/** @internal */
const getDuplicateIndexSignatureErrorMessage = name => `Duplicate index signature for type \`${name}\``;
/** @internal */
const getIndexSignatureParameterErrorMessage = "An index signature parameter type must be `string`, `symbol`, a template literal type or a refinement of the previous types";
/** @internal */
const getRequiredElementFollowinAnOptionalElementErrorMessage = "A required element cannot follow an optional element. ts(1257)";
/** @internal */
const getDuplicatePropertySignatureTransformationErrorMessage = name => `Duplicate property signature transformation ${_util_js__WEBPACK_IMPORTED_MODULE_0__/* .formatUnknown */ .cT(name)}`;
/** @internal */
const getArbitraryErrorMessage = message => `cannot build an Arbitrary for ${message}`;
/** @internal */
const getPrettyErrorMessage = message => `cannot build a Pretty for ${message}`;
/** @internal */
const getEquivalenceErrorMessage = message => `cannot build an Equivalence for ${message}`;
/** @internal */
const getAPIErrorMessage = (api, message) => `${api}: ${message}`;
//# sourceMappingURL=errors.js.map

/***/ }),

/***/ 10852:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AH": function() { return /* binding */ formatPropertyKey; },
/* harmony export */   "Wp": function() { return /* binding */ ownKeys; },
/* harmony export */   "cT": function() { return /* binding */ formatUnknown; },
/* harmony export */   "d3": function() { return /* binding */ memoizeThunk; },
/* harmony export */   "k8": function() { return /* binding */ getKeysForIndexSignature; }
/* harmony export */ });
/* harmony import */ var effect_Predicate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71335);

/** @internal */
const getKeysForIndexSignature = (input, parameter) => {
  switch (parameter._tag) {
    case "StringKeyword":
    case "TemplateLiteral":
      return Object.keys(input);
    case "SymbolKeyword":
      return Object.getOwnPropertySymbols(input);
    case "Refinement":
      return getKeysForIndexSignature(input, parameter.from);
  }
};
/** @internal */
const ownKeys = o => Object.keys(o).concat(Object.getOwnPropertySymbols(o));
/** @internal */
const memoizeThunk = f => {
  let done = false;
  let a;
  return () => {
    if (done) {
      return a;
    }
    a = f();
    done = true;
    return a;
  };
};
/** @internal */
const formatUnknown = u => {
  if (effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD(u)) {
    return JSON.stringify(u);
  } else if (effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj(u) || u == null || effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isBoolean */ .jn(u) || effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isSymbol */ .yk(u) || effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isDate */ .J_(u)) {
    return String(u);
  } else if (effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isBigInt */ .C4(u)) {
    return String(u) + "n";
  } else if (!Array.isArray(u) && effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .hasProperty */ .l$(u, "toString") && effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .mf(u["toString"]) && u["toString"] !== Object.prototype.toString) {
    return u["toString"]();
  }
  try {
    JSON.stringify(u);
    if (Array.isArray(u)) {
      return `[${u.map(formatUnknown).join(",")}]`;
    } else {
      return `{${ownKeys(u).map(k => `${effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD(k) ? JSON.stringify(k) : String(k)}:${formatUnknown(u[k])}`).join(",")}}`;
    }
  } catch (e) {
    return String(u);
  }
};
/** @internal */
const formatPropertyKey = name => typeof name === "string" ? JSON.stringify(name) : String(name);
//# sourceMappingURL=util.js.map

/***/ }),

/***/ 34837:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H_": function() { return /* binding */ fromHex; },
/* harmony export */   "NC": function() { return /* binding */ toHex; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "t1": function() { return /* binding */ fromText; }
/* harmony export */ });
/* unused harmony exports isBytes, toText */
// src/core-utils.ts
function assert_bytes(b, ...lengths) {
  if (!isBytes(b)) throw new Error("Uint8Array expected");
  if (lengths.length > 0 && !lengths.includes(b.length))
    throw new Error(
      `Uint8Array expected of length ${lengths}, not of length=${b.length}`
    );
}
function isBytes(a) {
  return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
var asciis = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function asciiToBase16(char) {
  if (char >= asciis._0 && char <= asciis._9) return char - asciis._0;
  if (char >= asciis._A && char <= asciis._F) return char - (asciis._A - 10);
  if (char >= asciis._a && char <= asciis._f) return char - (asciis._a - 10);
  return;
}
var hexes = /* @__PURE__ */ Array.from(
  { length: 256 },
  (_, i) => i.toString(16).padStart(2, "0")
);
function fromHex(hex) {
  if (typeof hex !== "string")
    throw new Error("hex string expected, got " + typeof hex);
  const hl = hex.length;
  const al = hl / 2;
  if (hl % 2)
    throw new Error(
      "padded hex string expected, got unpadded hex of length " + hl
    );
  const array = new Uint8Array(al);
  for (let ai = 0, hi = 0; ai < al; ai++, hi += 2) {
    const n1 = asciiToBase16(hex.charCodeAt(hi));
    const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
    if (n1 === void 0 || n2 === void 0) {
      const char = hex[hi] + hex[hi + 1];
      throw new Error(
        'hex string expected, got non-hex character "' + char + '" at index ' + hi
      );
    }
    array[ai] = n1 * 16 + n2;
  }
  return array;
}
function toHex(bytes) {
  assert_bytes(bytes);
  let hex = "";
  for (let i = 0; i < bytes.length; i++) {
    hex += hexes[bytes[i]];
  }
  return hex;
}
function toText(hex) {
  return new TextDecoder().decode(fromHex(hex)).toString();
}
function fromText(text) {
  return toHex(new TextEncoder().encode(text));
}
var sleep = (ms = 1e3) => new Promise((r) => setTimeout(r, ms));



/***/ }),

/***/ 79969:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ crc8; }
/* harmony export */ });
// src/crc8.ts
var TABLE = [
  0,
  7,
  14,
  9,
  28,
  27,
  18,
  21,
  56,
  63,
  54,
  49,
  36,
  35,
  42,
  45,
  112,
  119,
  126,
  121,
  108,
  107,
  98,
  101,
  72,
  79,
  70,
  65,
  84,
  83,
  90,
  93,
  224,
  231,
  238,
  233,
  252,
  251,
  242,
  245,
  216,
  223,
  214,
  209,
  196,
  195,
  202,
  205,
  144,
  151,
  158,
  153,
  140,
  139,
  130,
  133,
  168,
  175,
  166,
  161,
  180,
  179,
  186,
  189,
  199,
  192,
  201,
  206,
  219,
  220,
  213,
  210,
  255,
  248,
  241,
  246,
  227,
  228,
  237,
  234,
  183,
  176,
  185,
  190,
  171,
  172,
  165,
  162,
  143,
  136,
  129,
  134,
  147,
  148,
  157,
  154,
  39,
  32,
  41,
  46,
  59,
  60,
  53,
  50,
  31,
  24,
  17,
  22,
  3,
  4,
  13,
  10,
  87,
  80,
  89,
  94,
  75,
  76,
  69,
  66,
  111,
  104,
  97,
  102,
  115,
  116,
  125,
  122,
  137,
  142,
  135,
  128,
  149,
  146,
  155,
  156,
  177,
  182,
  191,
  184,
  173,
  170,
  163,
  164,
  249,
  254,
  247,
  240,
  229,
  226,
  235,
  236,
  193,
  198,
  207,
  200,
  221,
  218,
  211,
  212,
  105,
  110,
  103,
  96,
  117,
  114,
  123,
  124,
  81,
  86,
  95,
  88,
  77,
  74,
  67,
  68,
  25,
  30,
  23,
  16,
  5,
  2,
  11,
  12,
  33,
  38,
  47,
  40,
  61,
  58,
  51,
  52,
  78,
  73,
  64,
  71,
  82,
  85,
  92,
  91,
  118,
  113,
  120,
  127,
  106,
  109,
  100,
  99,
  62,
  57,
  48,
  55,
  34,
  37,
  44,
  43,
  6,
  1,
  8,
  15,
  26,
  29,
  20,
  19,
  174,
  169,
  160,
  167,
  178,
  181,
  188,
  187,
  150,
  145,
  152,
  159,
  138,
  141,
  132,
  131,
  222,
  217,
  208,
  215,
  194,
  197,
  204,
  203,
  230,
  225,
  232,
  239,
  250,
  253,
  244,
  243
];
if (typeof Int32Array !== "undefined") {
  TABLE = new Int32Array(TABLE);
}
function crc8(current, previous = 0) {
  let crc = ~~previous;
  for (let index = 0; index < current.length; index++) {
    crc = TABLE[(crc ^ current[index]) & 255] & 255;
  }
  return crc;
}



/***/ }),

/***/ 76100:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EE": function() { return /* reexport safe */ _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__.EE; },
/* harmony export */   "G2": function() { return /* reexport safe */ _lucid_evolution_provider__WEBPACK_IMPORTED_MODULE_19__.G2; },
/* harmony export */   "H_": function() { return /* reexport safe */ _lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_7__.H_; },
/* harmony export */   "IL": function() { return /* reexport safe */ _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__.IL; },
/* harmony export */   "NR": function() { return /* reexport module object */ _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__; },
/* harmony export */   "Vw": function() { return /* reexport safe */ _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_3__.Vw; },
/* harmony export */   "_k": function() { return /* binding */ Lucid; },
/* harmony export */   "aI": function() { return /* reexport safe */ _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__.aI; },
/* harmony export */   "eI": function() { return /* reexport safe */ _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__.eI; },
/* harmony export */   "fL": function() { return /* reexport safe */ _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_3__.fL; },
/* harmony export */   "nz": function() { return /* reexport safe */ _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__.nz; },
/* harmony export */   "of": function() { return /* reexport safe */ _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__.of; },
/* harmony export */   "sn": function() { return /* reexport safe */ _lucid_evolution_provider__WEBPACK_IMPORTED_MODULE_19__.sn; }
/* harmony export */ });
/* unused harmony exports ERROR_MESSAGE, NullableError, RunTimeError, TxBuilderError, TxSignerError, TxSubmitError, UnauthorizedNetwork, makeReturn, makeSubmit, makeTxBuilder, makeTxSignBuilder */
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96347);
/* harmony import */ var _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82381);
/* harmony import */ var _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87830);
/* harmony import */ var _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46533);
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17316);
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21566);
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20591);
/* harmony import */ var _lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34837);
/* harmony import */ var _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51375);
/* harmony import */ var _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6137);
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(37901);
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10800);
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(53959);
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(37787);
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(16749);
/* harmony import */ var _lucid_evolution_uplc__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79958);
/* harmony import */ var effect_Predicate__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71335);
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(92646);
/* harmony import */ var _lucid_evolution_wallet__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8713);
/* harmony import */ var _lucid_evolution_provider__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(88464);
/* harmony import */ var _lucid_evolution_sign_data__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(48415);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__, _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__, _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_3__, _lucid_evolution_uplc__WEBPACK_IMPORTED_MODULE_10__, _lucid_evolution_wallet__WEBPACK_IMPORTED_MODULE_18__, _lucid_evolution_provider__WEBPACK_IMPORTED_MODULE_19__, _lucid_evolution_sign_data__WEBPACK_IMPORTED_MODULE_20__]);
([_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__, _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__, _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_3__, _lucid_evolution_uplc__WEBPACK_IMPORTED_MODULE_10__, _lucid_evolution_wallet__WEBPACK_IMPORTED_MODULE_18__, _lucid_evolution_provider__WEBPACK_IMPORTED_MODULE_19__, _lucid_evolution_sign_data__WEBPACK_IMPORTED_MODULE_20__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
// src/core.ts


var makeReturn = (program) => {
  return {
    unsafeRun: () => effect__WEBPACK_IMPORTED_MODULE_1__/* .runPromise */ .VR7(program),
    safeRun: () => effect__WEBPACK_IMPORTED_MODULE_1__/* .runPromise */ .VR7(effect__WEBPACK_IMPORTED_MODULE_1__/* .either */ .wEe(program)),
    program: () => program
  };
};

// src/lucid-evolution/utils.ts


var datumOf = async (provider, utxo, type) => {
  if (!utxo.datum) {
    if (!utxo.datumHash) {
      throw new Error("This UTxO does not have a datum hash.");
    }
    utxo.datum = await provider.getDatum(utxo.datumHash);
  }
  return _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_3__/* .Data.from */ .Vw.from(utxo.datum, type);
};
var metadataOf = async (provider, unit) => {
  const { policyId, name, label } = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .fromUnit */ .g9)(unit);
  switch (label) {
    case 222:
    case 333:
    case 444: {
      const utxo = await provider.getUtxoByUnit((0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .toUnit */ .nn)(policyId, name, 100));
      const metadata = await datumOf(provider, utxo);
      return _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_3__/* .Data.toJson */ .Vw.toJson(metadata.fields[0]);
    }
    default:
      throw new Error("No variant matched.");
  }
};

// src/lucid-evolution/LucidEvolution.ts


// src/tx-builder/internal/Collect.ts




// src/Errors.ts

var ERROR_MESSAGE = {
  MULTIPLE_POLICIES: "MULTIPLE_POLICIES: Only one policy id allowed. You can chain multiple mintAssets functions together if you need to mint assets with different policy ids. ",
  EMPTY_UTXO: "EMPTY_UTXO: UTxO array is empty. If a Tx has been recently submitted, consider waiting for chain sync",
  MISSING_WALLET: "MISSING_WALLET: please ensure that your wallet has been properly configured and initialized",
  MISSING_REDEEMER: "MISSING_REDEEMER: redeemer can not be undefined",
  DATUM_NOT_SET: "DATUM_NOT_SET: Script inputs becomes unspendable without datum.",
  EMPTY_ASSETS: "EMPTY_ASSETS: Attempting to pay to an address with an empty assets object",
  MISSING_REWARD_TYPE: "MISSING_REWARD_TYPE: Address type must be Reward type.",
  MISSING_STAKE_CREDENTIAL: "MISSING_STAKE_CREDENTIAL: Address does not contain stake credential",
  MISSING_PAYMENT_CREDENTIAL: "MISSING_PAYMENT_CREDENTIAL: Address does not contain payment credential",
  INVALID_METADATA: "INVALID_METADATA: metadata is invalid",
  SCRIPT_CREDENTIAL_NOT_ALLOWED: "SCRIPT_CREDENTIAL_NOT_ALLOWED: Only verification key credential is allowed",
  INVALID_SCRIPT: "INVALID_SCRIPT: Script is invalid",
  EXPECTED_KEY_HASH: "EXPECTED_KEY_HASH",
  INVALID_NETWORK: (address, actualNetworkId, network) => `Invalid address: ${address}, Expected address with network id ${actualNetworkId}, current network ${network}`,
  MISSING_SCRIPT: (hash) => `MISSING_SCRIPT: Script not found when building transaction, consider using attach modules. script_hash: ${hash}`,
  MISSING_POLICY: (policyId) => `MISSING_POLICY: No policy found, policy_id: ${policyId}`
};
var NullableError = class extends effect__WEBPACK_IMPORTED_MODULE_4__/* .TaggedError */ .fZ("NullableError") {
};
var UnauthorizedNetwork = class extends effect__WEBPACK_IMPORTED_MODULE_4__/* .TaggedError */ .fZ(
  "UnauthorizedNetwork"
) {
};
var TxBuilderError = class extends effect__WEBPACK_IMPORTED_MODULE_4__/* .TaggedError */ .fZ("TxBuilderError") {
  get message() {
    return `${this.cause}`;
  }
};
var TxSignerError = class extends effect__WEBPACK_IMPORTED_MODULE_4__/* .TaggedError */ .fZ("TxSignerError") {
  get message() {
    return `${this.cause}`;
  }
};
var TxSubmitError = class extends effect__WEBPACK_IMPORTED_MODULE_4__/* .TaggedError */ .fZ("TxSubmitError") {
  get message() {
    return `${this.cause}`;
  }
};
var RunTimeError = class extends effect__WEBPACK_IMPORTED_MODULE_4__/* .TaggedError */ .fZ("RunTimeError") {
  get message() {
    return `${this.cause}`;
  }
};

// src/tx-builder/internal/Collect.ts


// src/tx-builder/internal/TxUtils.ts




var txBuilderError = (cause) => new TxBuilderError({ cause: `{ TxBuilderError : ${cause} }` });
var toCMLAddress = (address, lucidConfig) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* ($) {
  const { type } = yield* validateAddressDetails(address, lucidConfig);
  return type === "Byron" ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ByronAddress.from_base58 */ .jZ5.from_base58(address).to_address() : _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Address.from_bech32 */ .kLt.from_bech32(address);
});
var toV1 = (script) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusScript.from_v1 */ .qPp.from_v1(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV1Script.from_cbor_hex */ .Z1S.from_cbor_hex(script));
var toV2 = (script) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusScript.from_v2 */ .qPp.from_v2(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV2Script.from_cbor_hex */ .$hr.from_cbor_hex(script));
var toV3 = (script) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusScript.from_v3 */ .qPp.from_v3(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV3Script.from_cbor_hex */ .z58.from_cbor_hex(script));
var toPartial = (script, redeemer) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PartialPlutusWitness["new"] */ .tTm["new"](
  _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusScriptWitness.new_script */ .Zmg.new_script(script),
  _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusData.from_cbor_hex */ .$zK.from_cbor_hex(redeemer)
);
var handleRedeemerBuilder = (config, partialProgram, redeemer) => {
  if (typeof redeemer === "object") {
    config.partialPrograms.set(redeemer, partialProgram);
  } else {
    const program = partialProgram(redeemer);
    config.programs.push(program);
  }
};
var validateAddressDetails = (address, lucidConfig) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* ($) {
  const addressDetails = yield* $(
    effect__WEBPACK_IMPORTED_MODULE_1__/* ["try"] */ .JHF({
      try: () => (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .getAddressDetails */ .IL)(address),
      catch: (cause) => new TxBuilderError({
        cause
      })
    })
  );
  const actualNetworkId = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .networkToId */ .dZ)(lucidConfig.network);
  if (addressDetails.networkId !== actualNetworkId)
    yield* new TxBuilderError({
      cause: ERROR_MESSAGE.INVALID_NETWORK(
        address,
        actualNetworkId,
        lucidConfig.network
      )
    });
  return addressDetails;
});
var processCertificate = (stakeCredential, config, buildCert, redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  switch (stakeCredential.type) {
    case "Key": {
      const credential = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_pub_key */ .hJE.new_pub_key(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_hex */ ._Wl.from_hex(stakeCredential.hash)
      );
      const certBuilder = buildCert(credential);
      config.txBuilder.add_cert(certBuilder.payment_key());
      break;
    }
    case "Script": {
      const credential = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_script */ .hJE.new_script(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ScriptHash.from_hex */ .nJe.from_hex(stakeCredential.hash)
      );
      const certBuilder = buildCert(credential);
      const script = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(config.scripts.get(stakeCredential.hash)),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
          () => txBuilderError(ERROR_MESSAGE.MISSING_SCRIPT(stakeCredential.hash))
        )
      );
      const addPlutusCertificate = (scriptVersion) => {
        return effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
          const red = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
            effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(redeemer),
            effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
              () => txBuilderError(ERROR_MESSAGE.MISSING_REDEEMER)
            )
          );
          config.txBuilder.add_cert(
            certBuilder.plutus_script(
              toPartial(scriptVersion, red),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
            )
          );
        });
      };
      switch (script.type) {
        case "PlutusV1":
          yield* addPlutusCertificate(toV1(script.script));
          break;
        case "PlutusV2":
          yield* addPlutusCertificate(toV2(script.script));
          break;
        case "PlutusV3":
          yield* addPlutusCertificate(toV3(script.script));
          break;
        case "Native":
          config.txBuilder.add_cert(
            certBuilder.native_script(
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.from_cbor_hex */ .$xJ.from_cbor_hex(script.script),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScriptWitnessInfo.assume_signature_count */ .mM8.assume_signature_count()
            )
          );
          break;
      }
      break;
    }
  }
});
var validateAndGetStakeCredential = (rewardAddress, config) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const addressDetails = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    validateAddressDetails(rewardAddress, config.lucidConfig),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .andThen */ .Po9(
      (address) => address.type !== "Reward" ? txBuilderError(ERROR_MESSAGE.MISSING_REWARD_TYPE) : effect__WEBPACK_IMPORTED_MODULE_1__/* .succeed */ .ng0(address)
    )
  );
  const stakeCredential = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(addressDetails.stakeCredential),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
      () => txBuilderError(ERROR_MESSAGE.MISSING_STAKE_CREDENTIAL)
    )
  );
  return stakeCredential;
});
var resolveDatum = (datumHash, datum, provider) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  if (!datumHash || datum) return datum;
  return yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* .tryPromise */ .p6W({
      try: () => provider.getDatum(datumHash),
      catch: txBuilderError
    }),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID(_lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_3__/* .Data.to */ .Vw.to)
  );
});

// src/tx-builder/internal/Collect.ts


// src/tx-builder/internal/Service.ts

var TxConfig = class extends effect__WEBPACK_IMPORTED_MODULE_6__/* .Tag */ .Vp("TxConfig")() {
};

// src/tx-builder/internal/Collect.ts
var collectError = (cause) => new TxBuilderError({ cause: `{ Collect: ${cause} }` });
var collectFromUTxO = (utxos, collectInputs = true) => (redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  if (utxos.length === 0) yield* collectError(ERROR_MESSAGE.EMPTY_UTXO);
  for (const utxo of utxos) {
    const resolvedDatum = yield* resolveDatum(
      utxo.datumHash,
      utxo.datum,
      config.lucidConfig.provider
    );
    if (collectInputs) config.collectedInputs.push(utxo);
    const input = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleInputBuilder.from_transaction_unspent_output */ .ph5.from_transaction_unspent_output(
      (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .utxoToCore */ .Sw)({ ...utxo, datum: resolvedDatum })
    );
    const credential = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .paymentCredentialOf */ .I9)(utxo.address);
    if (credential.type == "Script") {
      const script = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(config.scripts.get(credential.hash)),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
          () => collectError(
            collectError(ERROR_MESSAGE.MISSING_SCRIPT(credential.hash))
          )
        )
      );
      switch (script.type) {
        case "Native":
          config.txBuilder.add_input(
            input.native_script(
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.from_cbor_hex */ .$xJ.from_cbor_hex(script.script),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScriptWitnessInfo.assume_signature_count */ .mM8.assume_signature_count()
            )
          );
          break;
        case "PlutusV1": {
          const red = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
            effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(redeemer),
            effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
              () => collectError(ERROR_MESSAGE.MISSING_REDEEMER)
            )
          );
          config.txBuilder.add_input(
            input.plutus_script(
              toPartial(toV1(script.script), red),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"](),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusData.from_cbor_hex */ .$zK.from_cbor_hex(utxo.datum)
            )
          );
          break;
        }
        case "PlutusV2": {
          const v2 = toV2(script.script);
          const red = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
            effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(redeemer),
            effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
              () => collectError(ERROR_MESSAGE.MISSING_REDEEMER)
            )
          );
          const partial = toPartial(v2, red);
          config.txBuilder.add_input(
            utxo.datum && utxo.datumHash ? input.plutus_script(
              partial,
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"](),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusData.from_cbor_hex */ .$zK.from_cbor_hex(utxo.datum)
            ) : input.plutus_script_inline_datum(
              partial,
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
            )
          );
          break;
        }
        case "PlutusV3": {
          const v3 = toV3(script.script);
          const red = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
            effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(redeemer),
            effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
              () => collectError(ERROR_MESSAGE.MISSING_REDEEMER)
            )
          );
          const partial = toPartial(v3, red);
          config.txBuilder.add_input(
            utxo.datum && utxo.datumHash ? input.plutus_script(
              partial,
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"](),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusData.from_cbor_hex */ .$zK.from_cbor_hex(utxo.datum)
            ) : input.plutus_script_inline_datum(
              partial,
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
            )
          );
          break;
        }
      }
    } else {
      config.txBuilder.add_input(input.payment_key());
    }
  }
});
var collectFromUTxOPartial = (utxos, redeemerBuilder) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  if (utxos.length === 0) yield* collectError(ERROR_MESSAGE.EMPTY_UTXO);
  if (redeemerBuilder.kind === "self") redeemerBuilder.inputs = utxos;
  for (const utxo of utxos) {
    if (utxo.datumHash && !utxo.datum) {
      const data = yield* effect__WEBPACK_IMPORTED_MODULE_1__/* .tryPromise */ .p6W({
        try: () => datumOf(config.lucidConfig.provider, utxo),
        catch: (cause) => collectError({ cause })
      });
      utxo.datum = _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_3__/* .Data.to */ .Vw.to(data);
    }
    config.collectedInputs.push(utxo);
  }
  const partialProgram = collectFromUTxO(utxos, false);
  config.partialPrograms.set(redeemerBuilder, partialProgram);
});

// src/tx-builder/internal/Read.ts


var readError = (cause) => new TxBuilderError({ cause: `{ Read : ${cause} }` });
var readFrom = (utxos) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  if (utxos.length === 0) yield* readError(ERROR_MESSAGE.EMPTY_UTXO);
  for (const utxo of utxos) {
    const resolvedDatum = yield* resolveDatum(
      utxo.datumHash,
      utxo.datum,
      config.lucidConfig.provider
    );
    const coreUtxo = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .utxoToCore */ .Sw)({ ...utxo, datum: resolvedDatum });
    const exists = config.readInputs.some(
      (input) => input.txHash === utxo.txHash && input.outputIndex === utxo.outputIndex
    );
    if (!exists) {
      config.txBuilder.add_reference_input(coreUtxo);
      config.readInputs.push(utxo);
    }
  }
});

// src/tx-builder/internal/Attach.ts

var attachScript = ({ type, script }) => {
  switch (type) {
    case "Native":
      return {
        key: _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.from_cbor_hex */ .$xJ.from_cbor_hex(script).hash().to_hex(),
        value: { type, script }
      };
    case "PlutusV1":
      return {
        key: _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV1Script.from_cbor_hex */ .Z1S.from_cbor_hex((0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .applyDoubleCborEncoding */ .EE)(script)).hash().to_hex(),
        value: { type, script: (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .applyDoubleCborEncoding */ .EE)(script) }
      };
    case "PlutusV2":
      return {
        key: _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV2Script.from_cbor_hex */ .$hr.from_cbor_hex((0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .applyDoubleCborEncoding */ .EE)(script)).hash().to_hex(),
        value: { type, script: (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .applyDoubleCborEncoding */ .EE)(script) }
      };
    case "PlutusV3":
      return {
        key: _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV3Script.from_cbor_hex */ .z58.from_cbor_hex((0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .applyDoubleCborEncoding */ .EE)(script)).hash().to_hex(),
        value: { type, script: (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .applyDoubleCborEncoding */ .EE)(script) }
      };
    default:
      throw new Error(`Exhaustive check failed: Unhandled case ${type}`);
  }
};
var attachSpendingValidator = (spendingValidator) => attachScript(spendingValidator);
var attachMintingPolicy = (mintingPolicy) => attachScript(mintingPolicy);
var attachCertificateValidator = (certValidator) => attachScript(certValidator);
var attachWithdrawalValidator = (withdrawalValidator) => attachScript(withdrawalValidator);
var attachVoteValidator = (voteValidator) => attachScript(voteValidator);
var attachProposeValidator = (proposeValidator) => attachScript(proposeValidator);

// src/tx-builder/internal/Pay.ts


var payError = (cause) => new TxBuilderError({ cause: `{ Pay: ${cause} }` });
var payToAddress = (address, assets) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const outputBuilder = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionOutputBuilder["new"] */ .eVX["new"]().with_address(yield* toCMLAddress(address, config.lucidConfig)).next();
  if (Object.keys(assets).length == 0)
    yield* payError(ERROR_MESSAGE.EMPTY_ASSETS);
  const value = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .assetsToValue */ .D)(assets);
  let outputResult = outputBuilder.with_asset_and_min_required_coin(
    value.multi_asset(),
    config.lucidConfig.protocolParameters.coinsPerUtxoByte
  ).build();
  const setLovelaces = assets["lovelace"];
  if (setLovelaces) {
    const minLovelace = outputResult.output().amount().coin();
    if (setLovelaces > minLovelace) {
      outputResult = outputBuilder.with_value(value).build();
    }
  }
  config.totalOutputAssets = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .addAssets */ .q$)(
    config.totalOutputAssets,
    (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .valueToAssets */ .I6)(outputResult.output().amount())
  );
  config.payToOutputs = [
    ...config.payToOutputs,
    (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .coreToTxOutput */ .yZ)(outputResult.output())
  ];
  config.txBuilder.add_output(outputResult);
});
var ToAddressWithData = (address, outputDatum, assets, scriptRef) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const outputBuilder = buildBaseOutput(address, outputDatum, scriptRef);
  assets ??= {};
  const value = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .assetsToValue */ .D)(assets);
  let outputResult = outputBuilder.with_asset_and_min_required_coin(
    value.multi_asset(),
    config.lucidConfig.protocolParameters.coinsPerUtxoByte
  ).build();
  const setLovelaces = assets["lovelace"];
  if (setLovelaces) {
    const minLovelace = outputResult.output().amount().coin();
    if (setLovelaces > minLovelace) {
      outputResult = outputBuilder.with_value(value).build();
    }
  }
  config.totalOutputAssets = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .addAssets */ .q$)(
    config.totalOutputAssets,
    (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .valueToAssets */ .I6)(outputResult.output().amount())
  );
  config.payToOutputs = [
    ...config.payToOutputs,
    (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .coreToTxOutput */ .yZ)(outputResult.output())
  ];
  config.txBuilder.add_output(outputResult);
});
var ToContract = (address, outputDatum, assets, scriptRef) => ToAddressWithData(address, outputDatum, assets, scriptRef);
var buildBaseOutput = (address, outputDatum, scriptRef) => {
  let baseBuilder;
  const addressBuilder = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionOutputBuilder["new"] */ .eVX["new"]().with_address(
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Address.from_bech32 */ .kLt.from_bech32(address)
  );
  if (outputDatum) {
    if (outputDatum.value.trim() === "") {
      throw new Error(
        "datum value is missing. Please provide a non-empty cbor hex data."
      );
    }
    switch (outputDatum.kind) {
      case "hash": {
        const datumOption = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .DatumOption.new_hash */ .QjN.new_hash(
          _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .DatumHash.from_hex */ .odP.from_hex(outputDatum.value)
        );
        baseBuilder = addressBuilder.with_data(datumOption);
        break;
      }
      case "asHash": {
        const plutusData = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusData.from_cbor_hex */ .$zK.from_cbor_hex(outputDatum.value);
        baseBuilder = addressBuilder.with_communication_data(plutusData);
        break;
      }
      case "inline": {
        const plutusData = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusData.from_cbor_hex */ .$zK.from_cbor_hex(outputDatum.value);
        const datumOption = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .DatumOption.new_datum */ .QjN.new_datum(plutusData);
        baseBuilder = addressBuilder.with_data(datumOption);
        break;
      }
      default:
        throw new Error(`Unknown outputDatum: ${outputDatum}`);
    }
  } else {
    baseBuilder = addressBuilder;
  }
  return scriptRef ? baseBuilder.with_reference_script((0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .toScriptRef */ .pZ)(scriptRef)).next() : baseBuilder.next();
};

// src/tx-builder/internal/Mint.ts


var mintError = (cause) => new TxBuilderError({ cause: `{ Mint: ${cause} }` });
var mintAssets = (assets) => (redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const units = Object.keys(assets);
  const policyId = units[0].slice(0, 56);
  const mintAssets2 = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .MapAssetNameToNonZeroInt64["new"] */ .SdH["new"]();
  for (const unit of units) {
    if (unit.slice(0, 56) !== policyId) {
      yield* mintError(ERROR_MESSAGE.MULTIPLE_POLICIES);
    }
    mintAssets2.insert(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .AssetName.from_hex */ .JfL.from_hex(unit.slice(56)), assets[unit]);
  }
  const mintBuilder = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleMintBuilder["new"] */ .Pvg["new"](mintAssets2);
  const policy = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(config.scripts.get(policyId)),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
      () => mintError(ERROR_MESSAGE.MISSING_POLICY(policyId))
    )
  );
  switch (policy.type) {
    case "Native":
      config.txBuilder.add_mint(
        mintBuilder.native_script(
          _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.from_cbor_hex */ .$xJ.from_cbor_hex(policy.script),
          _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScriptWitnessInfo.assume_signature_count */ .mM8.assume_signature_count()
        )
      );
      break;
    case "PlutusV1": {
      const red = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(redeemer),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(() => mintError(ERROR_MESSAGE.MISSING_REDEEMER))
      );
      config.txBuilder.add_mint(
        mintBuilder.plutus_script(
          toPartial(toV1(policy.script), red),
          _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
        )
      );
      break;
    }
    case "PlutusV2": {
      const red = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(redeemer),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(() => mintError(ERROR_MESSAGE.MISSING_REDEEMER))
      );
      config.txBuilder.add_mint(
        mintBuilder.plutus_script(
          toPartial(toV2(policy.script), red),
          _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
        )
      );
      break;
    }
    case "PlutusV3": {
      const red = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(redeemer),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(() => mintError(ERROR_MESSAGE.MISSING_REDEEMER))
      );
      config.txBuilder.add_mint(
        mintBuilder.plutus_script(
          toPartial(toV3(policy.script), red),
          _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
        )
      );
      break;
    }
  }
});

// src/tx-builder/internal/Interval.ts


var validFrom = (unixTime) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const slot = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .unixTimeToSlot */ .Hf)(config.lucidConfig.network, unixTime);
  config.txBuilder.set_validity_start_interval(BigInt(slot));
});
var validTo = (unixTime) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const slot = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .unixTimeToSlot */ .Hf)(config.lucidConfig.network, unixTime);
  config.txBuilder.set_ttl(BigInt(slot));
});

// src/tx-builder/internal/Signer.ts


var addSignerError = (cause) => new TxBuilderError({ cause: `{ Signer: ${cause} }` });
var addSigner = (address) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const addressDetails = yield* validateAddressDetails(
    address,
    config.lucidConfig
  );
  const credential = addressDetails.type === "Reward" ? yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(addressDetails.stakeCredential),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
      () => addSignerError(ERROR_MESSAGE.MISSING_STAKE_CREDENTIAL)
    )
  ) : yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(addressDetails.paymentCredential),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
      () => addSignerError(ERROR_MESSAGE.MISSING_PAYMENT_CREDENTIAL)
    )
  );
  if (credential.type === "Script")
    yield* addSignerError(ERROR_MESSAGE.SCRIPT_CREDENTIAL_NOT_ALLOWED);
  return credential.hash;
}).pipe(effect__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VSD((keyHash) => addSignerKey(keyHash)));
var addSignerKey = (keyHash) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  config.txBuilder.add_required_signer(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_hex */ ._Wl.from_hex(keyHash));
});

// src/tx-builder/internal/Stake.ts


var stakeError = (cause) => new TxBuilderError({ cause: `{ Stake: ${cause} }` });
var registerStake = (rewardAddress) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const addressDetails = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    validateAddressDetails(rewardAddress, config.lucidConfig),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .andThen */ .Po9(
      (address) => address.type !== "Reward" ? stakeError(ERROR_MESSAGE.MISSING_REWARD_TYPE) : effect__WEBPACK_IMPORTED_MODULE_1__/* .succeed */ .ng0(address)
    )
  );
  const stakeCredential = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(addressDetails.stakeCredential),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
      () => stakeError(ERROR_MESSAGE.MISSING_STAKE_CREDENTIAL)
    )
  );
  const credential = stakeCredential.type === "Key" ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_pub_key */ .hJE.new_pub_key(
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_hex */ ._Wl.from_hex(stakeCredential.hash)
  ) : _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_script */ .hJE.new_script(
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ScriptHash.from_hex */ .nJe.from_hex(stakeCredential.hash)
  );
  const certBuilder = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_stake_registration */ .KBB.new_stake_registration(credential)
  );
  config.txBuilder.add_cert(certBuilder.skip_witness());
});
var deRegisterStake = (rewardAddress, redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const addressDetails = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    validateAddressDetails(rewardAddress, config.lucidConfig),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .andThen */ .Po9(
      (address) => address.type !== "Reward" ? stakeError(ERROR_MESSAGE.MISSING_REWARD_TYPE) : effect__WEBPACK_IMPORTED_MODULE_1__/* .succeed */ .ng0(address)
    )
  );
  const stakeCredential = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(addressDetails.stakeCredential),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
      () => stakeError(ERROR_MESSAGE.MISSING_STAKE_CREDENTIAL)
    )
  );
  const createCertBuilder = (credential, config2) => {
    return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_unreg_cert */ .KBB.new_unreg_cert(
        credential,
        config2.lucidConfig.protocolParameters.keyDeposit
      )
    );
  };
  switch (stakeCredential.type) {
    case "Key": {
      const credential = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_pub_key */ .hJE.new_pub_key(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_hex */ ._Wl.from_hex(stakeCredential.hash)
      );
      const certBuilder = createCertBuilder(credential, config);
      config.txBuilder.add_cert(certBuilder.payment_key());
      break;
    }
    case "Script": {
      const credential = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_script */ .hJE.new_script(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ScriptHash.from_hex */ .nJe.from_hex(stakeCredential.hash)
      );
      const certBuilder = createCertBuilder(credential, config);
      const script = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(config.scripts.get(stakeCredential.hash)),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
          () => stakeError(ERROR_MESSAGE.MISSING_SCRIPT(stakeCredential.hash))
        )
      );
      const handleRedeemer = () => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(redeemer),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(() => stakeError(ERROR_MESSAGE.MISSING_REDEEMER))
      );
      switch (script.type) {
        case "PlutusV1": {
          const red = yield* handleRedeemer();
          config.txBuilder.add_cert(
            certBuilder.plutus_script(
              toPartial(toV1(script.script), red),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
            )
          );
          break;
        }
        case "PlutusV2": {
          const red = yield* handleRedeemer();
          config.txBuilder.add_cert(
            certBuilder.plutus_script(
              toPartial(toV2(script.script), red),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
            )
          );
          break;
        }
        case "PlutusV3": {
          const red = yield* handleRedeemer();
          config.txBuilder.add_cert(
            certBuilder.plutus_script(
              toPartial(toV3(script.script), red),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
            )
          );
          break;
        }
        case "Native": {
          config.txBuilder.add_cert(
            certBuilder.native_script(
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.from_cbor_hex */ .$xJ.from_cbor_hex(script.script),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScriptWitnessInfo.assume_signature_count */ .mM8.assume_signature_count()
            )
          );
          break;
        }
      }
    }
  }
});
var withdraw = (rewardAddress, amount) => (redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const addressDetails = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    validateAddressDetails(rewardAddress, config.lucidConfig),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .andThen */ .Po9(
      (address) => address.type !== "Reward" ? stakeError(ERROR_MESSAGE.MISSING_REWARD_TYPE) : effect__WEBPACK_IMPORTED_MODULE_1__/* .succeed */ .ng0(address)
    )
  );
  const withdrawBuilder = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RewardAddress.from_address */ .mf5.from_address(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Address.from_bech32 */ .kLt.from_bech32(rewardAddress)
      )
    ),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
      () => stakeError(ERROR_MESSAGE.MISSING_STAKE_CREDENTIAL)
    ),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .andThen */ .Po9(
      (address) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleWithdrawalBuilder["new"] */ .Ooy["new"](address, amount)
    )
  );
  const stakeCredential = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(addressDetails.stakeCredential),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
      () => stakeError(ERROR_MESSAGE.MISSING_STAKE_CREDENTIAL)
    )
  );
  const handleRedeemer = () => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(redeemer),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(() => stakeError(ERROR_MESSAGE.MISSING_REDEEMER))
  );
  switch (stakeCredential.type) {
    case "Key": {
      config.txBuilder.add_withdrawal(withdrawBuilder.payment_key());
      break;
    }
    case "Script": {
      const script = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(config.scripts.get(stakeCredential.hash)),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
          () => stakeError(ERROR_MESSAGE.MISSING_SCRIPT(stakeCredential.hash))
        )
      );
      switch (script.type) {
        case "PlutusV1": {
          const red = yield* handleRedeemer();
          config.txBuilder.add_withdrawal(
            withdrawBuilder.plutus_script(
              toPartial(toV1(script.script), red),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
            )
          );
          break;
        }
        case "PlutusV2": {
          const red = yield* handleRedeemer();
          config.txBuilder.add_withdrawal(
            withdrawBuilder.plutus_script(
              toPartial(toV2(script.script), red),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
            )
          );
          break;
        }
        case "PlutusV3": {
          const red = yield* handleRedeemer();
          config.txBuilder.add_withdrawal(
            withdrawBuilder.plutus_script(
              toPartial(toV3(script.script), red),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
            )
          );
          break;
        }
        case "Native": {
          config.txBuilder.add_withdrawal(
            withdrawBuilder.native_script(
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.from_cbor_hex */ .$xJ.from_cbor_hex(script.script),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScriptWitnessInfo.assume_signature_count */ .mM8.assume_signature_count()
            )
          );
          break;
        }
      }
    }
  }
});

// src/tx-builder/internal/Pool.ts



var poolError = (cause) => new TxBuilderError({ cause: `{ Pool : ${cause} }` });
var delegateTo = (rewardAddress, poolId, redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const addressDetails = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    validateAddressDetails(rewardAddress, config.lucidConfig),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .andThen */ .Po9(
      (address) => address.type !== "Reward" ? poolError(ERROR_MESSAGE.MISSING_REWARD_TYPE) : effect__WEBPACK_IMPORTED_MODULE_1__/* .succeed */ .ng0(address)
    )
  );
  const stakeCredential = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(addressDetails.stakeCredential),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
      () => poolError(ERROR_MESSAGE.MISSING_STAKE_CREDENTIAL)
    )
  );
  switch (stakeCredential.type) {
    case "Key": {
      const credential = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_pub_key */ .hJE.new_pub_key(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_hex */ ._Wl.from_hex(stakeCredential.hash)
      );
      const certBuilder = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_stake_delegation */ .KBB.new_stake_delegation(
          credential,
          _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_bech32 */ ._Wl.from_bech32(poolId)
        )
      );
      config.txBuilder.add_cert(certBuilder.payment_key());
      break;
    }
    case "Script": {
      const credential = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_script */ .hJE.new_script(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ScriptHash.from_hex */ .nJe.from_hex(stakeCredential.hash)
      );
      const certBuilder = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_stake_delegation */ .KBB.new_stake_delegation(
          credential,
          _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_bech32 */ ._Wl.from_bech32(poolId)
        )
      );
      const script = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(config.scripts.get(stakeCredential.hash)),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
          () => poolError(ERROR_MESSAGE.MISSING_SCRIPT(stakeCredential.hash))
        )
      );
      const handleRedeemer = () => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(redeemer),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(() => poolError(ERROR_MESSAGE.MISSING_REDEEMER))
      );
      switch (script.type) {
        case "PlutusV1": {
          const red = yield* handleRedeemer();
          config.txBuilder.add_cert(
            certBuilder.plutus_script(
              toPartial(toV1(script.script), red),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
            )
          );
          break;
        }
        case "PlutusV2": {
          const red = yield* handleRedeemer();
          config.txBuilder.add_cert(
            certBuilder.plutus_script(
              toPartial(toV2(script.script), red),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
            )
          );
          break;
        }
        case "PlutusV3": {
          const red = yield* handleRedeemer();
          config.txBuilder.add_cert(
            certBuilder.plutus_script(
              toPartial(toV3(script.script), red),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]()
            )
          );
          break;
        }
        case "Native": {
          config.txBuilder.add_cert(
            certBuilder.native_script(
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.from_cbor_hex */ .$xJ.from_cbor_hex(script.script),
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScriptWitnessInfo.assume_signature_count */ .mM8.assume_signature_count()
            )
          );
          break;
        }
      }
    }
  }
});

// src/tx-builder/internal/Governance.ts


var isDRepCredential = (deleg) => !("__typename" in deleg);
var isDRepAlwaysAbstain = (deleg) => !isDRepCredential(deleg) && deleg.__typename === "AlwaysAbstain";
var isDRepAlwaysNoConfidence = (deleg) => !isDRepCredential(deleg) && deleg.__typename === "AlwaysNoConfidence";
var toCMLDRep = (drep) => {
  if (isDRepAlwaysAbstain(drep)) {
    return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .DRep.new_always_abstain */ .Jth.new_always_abstain();
  } else if (isDRepAlwaysNoConfidence(drep)) {
    return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .DRep.new_always_no_confidence */ .Jth.new_always_no_confidence();
  } else if (isDRepCredential(drep)) {
    switch (drep.type) {
      case "Key":
        return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .DRep.new_key */ .Jth.new_key(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_hex */ ._Wl.from_hex(drep.hash));
      case "Script":
        return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .DRep.new_script */ .Jth.new_script(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ScriptHash.from_hex */ .nJe.from_hex(drep.hash));
      default:
        throw new Error(`Unsupported DRep type: ${drep.type}`);
    }
  }
  throw new Error(`Unexpected DRep type: ${drep}`);
};
var delegateVoteToDRep = (rewardAddress, drep, redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const stakeCredential = yield* validateAndGetStakeCredential(
    rewardAddress,
    config
  );
  const cmlDRep = toCMLDRep(drep);
  const buildCert = (credential) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_vote_deleg_cert */ .KBB.new_vote_deleg_cert(credential, cmlDRep)
  );
  yield* processCertificate(stakeCredential, config, buildCert, redeemer);
});
var delegateVoteToPoolAndDRep = (rewardAddress, poolId, drep, redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const stakeCredential = yield* validateAndGetStakeCredential(
    rewardAddress,
    config
  );
  const cmlDRep = toCMLDRep(drep);
  const buildCert = (credential) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_stake_vote_deleg_cert */ .KBB.new_stake_vote_deleg_cert(
      credential,
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_bech32 */ ._Wl.from_bech32(poolId),
      cmlDRep
    )
  );
  yield* processCertificate(stakeCredential, config, buildCert, redeemer);
});
var registerAndDelegateToPool = (rewardAddress, poolId, redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const stakeCredential = yield* validateAndGetStakeCredential(
    rewardAddress,
    config
  );
  const buildCert = (credential) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_stake_reg_deleg_cert */ .KBB.new_stake_reg_deleg_cert(
      credential,
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_bech32 */ ._Wl.from_bech32(poolId),
      config.lucidConfig.protocolParameters.keyDeposit
    )
  );
  yield* processCertificate(stakeCredential, config, buildCert, redeemer);
});
var registerAndDelegateToDRep = (rewardAddress, drep, redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const stakeCredential = yield* validateAndGetStakeCredential(
    rewardAddress,
    config
  );
  const cmlDRep = toCMLDRep(drep);
  const buildCert = (credential) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_vote_reg_deleg_cert */ .KBB.new_vote_reg_deleg_cert(
      credential,
      cmlDRep,
      config.lucidConfig.protocolParameters.keyDeposit
    )
  );
  yield* processCertificate(stakeCredential, config, buildCert, redeemer);
});
var registerAndDelegateToPoolAndDRep = (rewardAddress, poolId, drep, redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const stakeCredential = yield* validateAndGetStakeCredential(
    rewardAddress,
    config
  );
  const cmlDRep = toCMLDRep(drep);
  const buildCert = (credential) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_stake_vote_reg_deleg_cert */ .KBB.new_stake_vote_reg_deleg_cert(
      credential,
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_bech32 */ ._Wl.from_bech32(poolId),
      cmlDRep,
      config.lucidConfig.protocolParameters.keyDeposit
    )
  );
  yield* processCertificate(stakeCredential, config, buildCert, redeemer);
});
var registerDRep = (rewardAddress, anchor, redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const stakeCredential = yield* validateAndGetStakeCredential(
    rewardAddress,
    config
  );
  const cmlAnchor = anchor ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Anchor["new"] */ .eee["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Url.from_json */ .R9e.from_json(anchor.url),
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .AnchorDocHash.from_hex */ .YOZ.from_hex(anchor.dataHash)
  ) : void 0;
  const buildCert = (credential) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_reg_drep_cert */ .KBB.new_reg_drep_cert(
      credential,
      config.lucidConfig.protocolParameters.drepDeposit,
      cmlAnchor
    )
  );
  yield* processCertificate(stakeCredential, config, buildCert, redeemer);
});
var deregisterDRep = (rewardAddress, redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const stakeCredential = yield* validateAndGetStakeCredential(
    rewardAddress,
    config
  );
  const buildCert = (credential) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_unreg_drep_cert */ .KBB.new_unreg_drep_cert(
      credential,
      config.lucidConfig.protocolParameters.drepDeposit
    )
  );
  yield* processCertificate(stakeCredential, config, buildCert, redeemer);
});
var updateDRep = (rewardAddress, anchor, redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const stakeCredential = yield* validateAndGetStakeCredential(
    rewardAddress,
    config
  );
  const cmlAnchor = anchor ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Anchor["new"] */ .eee["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Url.from_json */ .R9e.from_json(anchor.url),
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .AnchorDocHash.from_hex */ .YOZ.from_hex(anchor.dataHash)
  ) : void 0;
  const buildCert = (credential) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_update_drep_cert */ .KBB.new_update_drep_cert(credential, cmlAnchor)
  );
  yield* processCertificate(stakeCredential, config, buildCert, redeemer);
});
var authCommitteeHot = (coldAddress, hotAddress, redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const coldCred = yield* validateAndGetStakeCredential(coldAddress, config);
  const hotCred = yield* validateAndGetStakeCredential(hotAddress, config);
  const hotCredential = hotCred.type === "Key" ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_pub_key */ .hJE.new_pub_key(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_hex */ ._Wl.from_hex(hotCred.hash)) : _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_script */ .hJE.new_script(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ScriptHash.from_hex */ .nJe.from_hex(hotCred.hash));
  const buildCert = (credential) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_auth_committee_hot_cert */ .KBB.new_auth_committee_hot_cert(credential, hotCredential)
  );
  yield* processCertificate(coldCred, config, buildCert, redeemer);
});
var resignCommitteeHot = (coldAddress, anchor, redeemer) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const coldCred = yield* validateAndGetStakeCredential(coldAddress, config);
  const cmlAnchor = anchor ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Anchor["new"] */ .eee["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Url.from_json */ .R9e.from_json(anchor.url),
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .AnchorDocHash.from_hex */ .YOZ.from_hex(anchor.dataHash)
  ) : void 0;
  const buildCert = (credential) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleCertificateBuilder["new"] */ .vJ3["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Certificate.new_resign_committee_cold_cert */ .KBB.new_resign_committee_cold_cert(credential, cmlAnchor)
  );
  yield* processCertificate(coldCred, config, buildCert, redeemer);
});

// src/tx-builder/internal/Metadata.ts



var attachMetadata = (config, label, metadata) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const auxiliaryData = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .AuxiliaryData["new"] */ .TOz["new"]();
  const meta = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Metadata["new"] */ .SFo["new"]();
  meta.set(
    BigInt(label),
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionMetadatum.from_json */ .T01.from_json(
      JSON.stringify(toCardanoMetadata(metadata))
    )
  );
  auxiliaryData.add_metadata(meta);
  config.txBuilder.add_auxiliary_data(auxiliaryData);
  auxiliaryData.free();
  meta.free();
});
var TextSchema = _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .String.pipe */ .Ld9.pipe(_effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .maxLength */ .BSk(64));
var TransactionMetadataSchema = _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .Union */ .EJI(
  TextSchema,
  _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .Number */ .Mr_,
  _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .Uint8ArrayFromSelf */ .lJd,
  _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .Array */ .mJB(_effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .suspend */ .RqG(() => TransactionMetadataSchema)),
  _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .Record */ .WVy(
    _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .String */ .Ld9,
    _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .suspend */ .RqG(() => TransactionMetadataSchema)
  )
);
var toCardanoMetadata = (json) => {
  const d = _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_9__/* .asserts */ .Kc(TransactionMetadataSchema)(json);
  if (_effect_schema_Schema__WEBPACK_IMPORTED_MODULE_9__.is(TextSchema)(json)) {
    return { string: json };
  }
  if (typeof json === "number") {
    return { int: json };
  }
  if (json instanceof Uint8Array) {
    return { bytes: (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_7__/* .toHex */ .NC)(json) };
  }
  if (Array.isArray(json)) {
    return { list: json.map((value) => toCardanoMetadata(value)) };
  }
  if (typeof json === "object" && json !== null) {
    const mapEntries = Object.entries(json).map(([k, v]) => ({
      k: toCardanoMetadata(k),
      v: toCardanoMetadata(v)
    }));
    return { map: mapEntries };
  }
  throw new Error("Unsupported type");
};

// src/tx-builder/internal/CompleteTxBuilder.ts



// src/tx-sign-builder/TxSignBuilder.ts


// src/tx-sign-builder/internal/CompleteTxSigner.ts


// src/tx-submit/TxSubmit.ts


var makeSubmit = (wallet, txSigned) => {
  const submit = (options) => effect__WEBPACK_IMPORTED_MODULE_1__/* .tryPromise */ .p6W({
    try: () => wallet.submitTx(
      options.canonical ? txSigned.to_canonical_cbor_hex() : txSigned.to_cbor_hex()
    ),
    catch: (cause) => new TxSubmitError({ cause })
  });
  return {
    submit: (options = { canonical: false }) => makeReturn(submit(options)).unsafeRun(),
    submitProgram: (options = { canonical: false }) => submit(options),
    submitSafe: (options = { canonical: false }) => makeReturn(submit(options)).safeRun(),
    toCBOR: (options = { canonical: false }) => options.canonical ? txSigned.to_canonical_cbor_hex() : txSigned.to_cbor_hex(),
    toTransaction: () => txSigned,
    toJSON: () => _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_9__/* .decodeUnknownSync */ .G$(_effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .parseJson */ .MoP(_effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .Object */ .c7w))(txSigned.to_json()),
    toHash: () => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .hash_transaction */ .o28(txSigned.body()).to_hex()
  };
};

// src/tx-sign-builder/internal/Sign.ts

var signError = (cause) => new TxSignerError({ cause });
var mkWitnessFromWallet = (wallet, txComplete) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
  effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(wallet),
  effect__WEBPACK_IMPORTED_MODULE_1__/* .catchAll */ .kmb(() => signError(ERROR_MESSAGE.MISSING_WALLET)),
  effect__WEBPACK_IMPORTED_MODULE_1__/* .tryMapPromise */ .lmO({
    try: (wallet2) => wallet2.signTx(txComplete),
    catch: (cause) => signError(cause)
  })
);
var withWallet = (config) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
  mkWitnessFromWallet(config.wallet, config.txComplete),
  effect__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID((witness) => config.witnessSetBuilder.add_existing(witness))
);
var partialWithWallet = (config) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
  mkWitnessFromWallet(config.wallet, config.txComplete),
  effect__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID((witness) => witness.to_cbor_hex())
);
var mkWitnessFromPrivateKey = (privateKey, txComplete) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
  effect__WEBPACK_IMPORTED_MODULE_1__/* ["try"] */ .JHF({
    try: () => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PrivateKey.from_bech32 */ ._q4.from_bech32(privateKey),
    catch: signError
  }),
  effect__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID(
    (privateKey2) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .make_vkey_witness */ .i4D(
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .hash_transaction */ .o28(txComplete.body()),
      privateKey2
    )
  )
);
var withPrivateKey = (config, privateKey) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
  mkWitnessFromPrivateKey(privateKey, config.txComplete),
  effect__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID((witness) => config.witnessSetBuilder.add_vkey(witness))
);
var partialWithPrivateKey = (config, privateKey) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
  mkWitnessFromPrivateKey(privateKey, config.txComplete),
  effect__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID((witness) => {
    const witnessBuilder = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionWitnessSetBuilder["new"] */ .S__["new"]();
    witnessBuilder.add_vkey(witness);
    return witnessBuilder.build().to_cbor_hex();
  })
);
var assemble = (config, witnesses) => effect__WEBPACK_IMPORTED_MODULE_1__/* .forEach */ .Ed_(
  witnesses,
  (witness) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* ["try"] */ .JHF({
      try: () => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionWitnessSet.from_cbor_hex */ .XgB.from_cbor_hex(witness),
      catch: signError
    }),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID((witness2) => config.witnessSetBuilder.add_existing(witness2))
  )
);

// src/tx-sign-builder/internal/CompleteTxSigner.ts
var completeTxSigner = (config) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  yield* effect__WEBPACK_IMPORTED_MODULE_1__/* .all */ .$6P(config.programs, { concurrency: "unbounded" });
  const plutus_datums = config.txComplete.witness_set().plutus_datums();
  config.witnessSetBuilder.add_existing(config.txComplete.witness_set());
  if (plutus_datums) {
    for (let i = 0; i < plutus_datums.len(); i++) {
      config.witnessSetBuilder.add_plutus_datum(plutus_datums.get(i));
    }
  }
  const txWitnessSet = config.witnessSetBuilder.build();
  const signedTx = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Transaction["new"] */ .YW8["new"](
    config.txComplete.body(),
    txWitnessSet,
    true,
    config.txComplete.auxiliary_data()
  );
  const wallet = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(config.wallet),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(() => signError(ERROR_MESSAGE.MISSING_WALLET))
  );
  return makeSubmit(wallet, signedTx);
}).pipe(effect__WEBPACK_IMPORTED_MODULE_1__/* .catchAllDefect */ .KPM((cause) => new RunTimeError({ cause })));

// src/tx-sign-builder/TxSignBuilder.ts
var makeTxSignBuilder = (wallet, tx) => {
  const redeemers = tx.witness_set().redeemers();
  const exUnits = { cpu: 0, mem: 0 };
  if (redeemers) {
    const arrLegacyRedeemer = redeemers?.as_arr_legacy_redeemer();
    if (arrLegacyRedeemer) {
      for (let i = 0; i < arrLegacyRedeemer.len(); i++) {
        const redeemer = arrLegacyRedeemer.get(i);
        exUnits.cpu += parseInt(redeemer.ex_units().steps().toString());
        exUnits.mem += parseInt(redeemer.ex_units().mem().toString());
      }
    }
    const mapRedeemerKeyToRedeemerVal = redeemers?.as_map_redeemer_key_to_redeemer_val();
    if (mapRedeemerKeyToRedeemerVal) {
      const keys = mapRedeemerKeyToRedeemerVal.keys();
      for (let i = 0; i < (keys.len() || 0); i++) {
        const key = keys.get(i);
        const value = mapRedeemerKeyToRedeemerVal.get(key);
        exUnits.cpu += parseInt(value.ex_units().steps().toString());
        exUnits.mem += parseInt(value.ex_units().mem().toString());
      }
    }
  }
  const config = {
    txComplete: tx,
    witnessSetBuilder: _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionWitnessSetBuilder["new"] */ .S__["new"](),
    programs: [],
    wallet,
    fee: parseInt(tx.body().fee().toString()),
    exUnits
  };
  const txSignBuilder = {
    sign: {
      withWallet: () => {
        const program = withWallet(config);
        config.programs.push(program);
        return txSignBuilder;
      },
      withPrivateKey: (privateKey) => {
        const program = withPrivateKey(config, privateKey);
        config.programs.push(program);
        return txSignBuilder;
      }
    },
    partialSign: {
      withWallet: () => makeReturn(partialWithWallet(config)).unsafeRun(),
      withWalletEffect: () => partialWithWallet(config),
      withWalletSafe: () => makeReturn(partialWithWallet(config)).safeRun(),
      withPrivateKey: (privateKey) => makeReturn(partialWithPrivateKey(config, privateKey)).unsafeRun(),
      withPrivateKeyEffect: (privateKey) => partialWithPrivateKey(config, privateKey),
      withPrivateKeySafe: (privateKey) => makeReturn(partialWithPrivateKey(config, privateKey)).safeRun()
    },
    assemble: (witnesses) => {
      const program = assemble(config, witnesses);
      config.programs.push(program);
      return txSignBuilder;
    },
    toCBOR: (options = { canonical: false }) => options.canonical ? config.txComplete.to_canonical_cbor_hex() : config.txComplete.to_cbor_hex(),
    toTransaction: () => config.txComplete,
    toJSON: () => _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_9__/* .decodeUnknownSync */ .G$(_effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .parseJson */ .MoP(_effect_schema_Schema__WEBPACK_IMPORTED_MODULE_8__/* .Object */ .c7w))(config.txComplete.to_json()),
    toHash: () => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .hash_transaction */ .o28(config.txComplete.body()).to_hex(),
    complete: () => makeReturn(completeTxSigner(config)).unsafeRun(),
    completeProgram: () => completeTxSigner(config),
    completeSafe: () => makeReturn(completeTxSigner(config)).safeRun()
  };
  return txSignBuilder;
};

// src/tx-builder/internal/CompleteTxBuilder.ts



var completeTxError = (cause) => new TxBuilderError({ cause: `{ Complete: ${cause} }` });
var complete = (options = {}) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const wallet = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(config.lucidConfig.wallet),
    effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(() => completeTxError(ERROR_MESSAGE.MISSING_WALLET))
  );
  const walletAddress = yield* effect__WEBPACK_IMPORTED_MODULE_1__/* .promise */ .MCc(() => wallet.address());
  const {
    coinSelection = true,
    changeAddress = walletAddress,
    localUPLCEval = true,
    setCollateral = 5000000n,
    canonical = false,
    includeLeftoverLovelaceAsFee = false,
    presetWalletInputs = []
  } = options;
  const walletInputs = presetWalletInputs.length === 0 ? yield* effect__WEBPACK_IMPORTED_MODULE_1__/* .tryPromise */ .p6W({
    try: () => wallet.getUtxos(),
    catch: (error) => completeTxError(error)
  }) : presetWalletInputs;
  yield* effect__WEBPACK_IMPORTED_MODULE_1__/* .all */ .$6P(config.programs);
  const hasPlutusScriptExecutions = Array.from(
    config.scripts.values()
  ).some((value) => value.type !== "Native");
  yield* selectionAndEvaluation(
    walletInputs,
    changeAddress,
    coinSelection,
    localUPLCEval,
    includeLeftoverLovelaceAsFee,
    false
  );
  if (hasPlutusScriptExecutions) {
    const minFee = config.txBuilder.min_fee(true);
    const refScriptFee = yield* calculateMinRefScriptFee(config);
    let estimatedFee = minFee + refScriptFee;
    const totalCollateral = BigInt(
      Math.ceil(
        Math.max(
          config.lucidConfig.protocolParameters.collateralPercentage * Number(estimatedFee) / 100,
          Number(setCollateral)
        )
      )
    );
    const collateralInput = yield* findCollateral(
      config.lucidConfig.protocolParameters.coinsPerUtxoByte,
      totalCollateral,
      walletInputs
    );
    yield* applyCollateral(totalCollateral, collateralInput, changeAddress);
    yield* selectionAndEvaluation(
      walletInputs,
      changeAddress,
      coinSelection,
      localUPLCEval,
      includeLeftoverLovelaceAsFee,
      true
    );
  }
  config.txBuilder.add_change_if_needed(
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Address.from_bech32 */ .kLt.from_bech32(changeAddress),
    true
  );
  const transaction = yield* effect__WEBPACK_IMPORTED_MODULE_1__/* ["try"] */ .JHF({
    try: () => config.txBuilder.build(
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ChangeSelectionAlgo.Default */ .KCG.Default,
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Address.from_bech32 */ .kLt.from_bech32(changeAddress)
    ).build_unchecked(),
    catch: (error) => completeTxError(error)
  });
  const derivedInputs = deriveInputsFromTransaction(transaction);
  const derivedWalletInputs = derivedInputs.filter(
    (utxo) => utxo.address === walletAddress
  );
  const updatedWalletInputs = (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    effect__WEBPACK_IMPORTED_MODULE_11__/* .differenceWith */ .F2(_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .isEqualUTxO */ .wF)(walletInputs, config.consumedInputs),
    (availableWalletInputs) => [
      ...derivedWalletInputs,
      ...availableWalletInputs
    ]
  );
  return effect__WEBPACK_IMPORTED_MODULE_12__/* .make */ .Sy(
    updatedWalletInputs,
    derivedInputs,
    makeTxSignBuilder(
      config.lucidConfig.wallet,
      canonical ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Transaction.from_cbor_bytes */ .YW8.from_cbor_bytes(
        transaction.to_canonical_cbor_bytes()
      ) : transaction
    )
  );
}).pipe(effect__WEBPACK_IMPORTED_MODULE_1__/* .catchAllDefect */ .KPM((cause) => new RunTimeError({ cause })));
var selectionAndEvaluation = (walletInputs, changeAddress, coinSelection, localUPLCEval, includeLeftoverLovelaceAsFee, script_calculation) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const refScriptInputs = config.readInputs.filter(
    (input) => input.scriptRef
  );
  const availableInputs = effect__WEBPACK_IMPORTED_MODULE_11__/* .differenceWith */ .F2(_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .isEqualUTxO */ .wF)(walletInputs, [
    ...config.collectedInputs,
    ...refScriptInputs
  ]);
  const { selected: inputsToAdd, burnable } = coinSelection !== false ? yield* doCoinSelection(
    config,
    availableInputs,
    script_calculation,
    includeLeftoverLovelaceAsFee
  ) : { selected: [], burnable: { lovelace: 0n } };
  let estimatedFee = 0n;
  if (effect__WEBPACK_IMPORTED_MODULE_11__/* .isEmptyArray */ .yD(inputsToAdd)) {
    if (script_calculation) return;
    estimatedFee += burnable.lovelace;
  }
  if (effect__WEBPACK_IMPORTED_MODULE_11__/* .isNonEmptyArray */ .Of(inputsToAdd)) {
    for (const utxo of inputsToAdd) {
      const input = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleInputBuilder.from_transaction_unspent_output */ .ph5.from_transaction_unspent_output(
        (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .utxoToCore */ .Sw)(utxo)
      ).payment_key();
      config.txBuilder.add_input(input);
    }
    config.collectedInputs = [...config.collectedInputs, ...inputsToAdd];
    estimatedFee = yield* estimateFee(config, script_calculation);
  }
  config.consumedInputs = [...config.collectedInputs];
  if (config.partialPrograms.size > 0) {
    if (script_calculation) {
      yield* completeTxError(
        `RedeemerBuilder: Coin selection had to be updated after building redeemers, possibly leading to incorrect indices. Try setting a minimum fee of ${estimatedFee} lovelaces.`
      );
    } else yield* completePartialPrograms();
  }
  const txRedeemerBuilder = yield* effect__WEBPACK_IMPORTED_MODULE_1__/* ["try"] */ .JHF({
    try: () => config.txBuilder.build_for_evaluation(
      0,
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Address.from_bech32 */ .kLt.from_bech32(changeAddress)
    ),
    catch: (error) => completeTxError(error)
  });
  if (txRedeemerBuilder.draft_tx().witness_set().redeemers()) {
    if (localUPLCEval !== false) {
      applyUPLCEval(
        yield* evalTransaction(config, txRedeemerBuilder, walletInputs),
        config.txBuilder
      );
    } else {
      applyUPLCEvalProvider(
        yield* evalTransactionProvider(
          config,
          txRedeemerBuilder,
          walletInputs
        ),
        config.txBuilder
      );
    }
  }
}).pipe(effect__WEBPACK_IMPORTED_MODULE_1__/* .catchAllDefect */ .KPM((cause) => new RunTimeError({ cause })));
var completePartialPrograms = () => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  const sortedInputs = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .sortUTxOs */ .KW)(config.collectedInputs, "Canonical");
  const indicesMap = /* @__PURE__ */ new Map();
  sortedInputs.forEach((value, index) => {
    indicesMap.set(value.txHash + value.outputIndex, BigInt(index));
  });
  const newPrograms = [];
  for (const [
    redeemerBuilder,
    partialProgram
  ] of config.partialPrograms.entries()) {
    if (redeemerBuilder.kind === "selected") {
      const inputIndices = redeemerBuilder.inputs.flatMap((value) => {
        const index = indicesMap.get(value.txHash + value.outputIndex);
        if (index !== void 0) return index;
        else return [];
      });
      if (effect__WEBPACK_IMPORTED_MODULE_11__/* .isEmptyArray */ .yD(inputIndices) || inputIndices.length !== redeemerBuilder.inputs.length)
        yield* completeTxError(
          `RedeemerBuilder: Missing indices for inputs: ${(0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringify */ .Pz)(redeemerBuilder.inputs)}`
        );
      const redeemer = redeemerBuilder.makeRedeemer(inputIndices);
      const program = partialProgram(redeemer);
      newPrograms.push(program);
    } else {
      const inputs = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(redeemerBuilder.inputs),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
          () => completeTxError(
            `RedeemerBuilder: Inputs for redeemer builder not founds: ${(0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringify */ .Pz)(redeemerBuilder)}`
          )
        )
      );
      for (const input of inputs) {
        const index = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
          effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(
            indicesMap.get(input.txHash + input.outputIndex)
          ),
          effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(
            () => completeTxError(`Index not found for input: ${input}`)
          )
        );
        const redeemer = redeemerBuilder.makeRedeemer(index);
        const program = collectFromUTxO([input], false)(redeemer);
        newPrograms.push(program);
      }
    }
  }
  yield* effect__WEBPACK_IMPORTED_MODULE_1__/* .all */ .$6P(newPrograms);
});
var applyUPLCEval = (uplcEval, txbuilder) => {
  for (const bytes of uplcEval) {
    const redeemer = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .LegacyRedeemer.from_cbor_bytes */ .be0.from_cbor_bytes(bytes);
    const exUnits = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ExUnits["new"] */ .Yw6["new"](
      redeemer.ex_units().mem(),
      redeemer.ex_units().steps()
    );
    txbuilder.set_exunits(
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerWitnessKey["new"] */ .p6y["new"](redeemer.tag(), redeemer.index()),
      exUnits
    );
  }
};
var applyUPLCEvalProvider = (evalRedeemerList, txbuilder) => {
  for (const evalRedeemer of evalRedeemerList) {
    const exUnits = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ExUnits["new"] */ .Yw6["new"](
      BigInt(evalRedeemer.ex_units.mem),
      BigInt(evalRedeemer.ex_units.steps)
    );
    txbuilder.set_exunits(
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerWitnessKey["new"] */ .p6y["new"](
        (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .toCMLRedeemerTag */ .V7)(evalRedeemer.redeemer_tag),
        BigInt(evalRedeemer.redeemer_index)
      ),
      exUnits
    );
  }
};
var setRedeemerstoZero = (tx) => {
  const redeemers = tx.witness_set().redeemers();
  if (!redeemers) return tx;
  const arrLegacyRedeemer = redeemers.as_arr_legacy_redeemer();
  if (arrLegacyRedeemer) {
    const redeemerList = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .LegacyRedeemerList["new"] */ .zTP["new"]();
    for (let i = 0; i < arrLegacyRedeemer.len(); i++) {
      const redeemer = arrLegacyRedeemer.get(i);
      const dummyRedeemer = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .LegacyRedeemer["new"] */ .be0["new"](
        redeemer.tag(),
        redeemer.index(),
        redeemer.data(),
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ExUnits["new"] */ .Yw6["new"](0n, 0n)
      );
      redeemerList.add(dummyRedeemer);
    }
    const dummyWitnessSet = tx.witness_set();
    dummyWitnessSet.set_redeemers(
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Redeemers.new_arr_legacy_redeemer */ .F5E.new_arr_legacy_redeemer(redeemerList)
    );
    return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Transaction["new"] */ .YW8["new"](
      tx.body(),
      dummyWitnessSet,
      true,
      tx.auxiliary_data()
    );
  }
  const mapRedeemerKeyToRedeemerVal = redeemers.as_map_redeemer_key_to_redeemer_val();
  if (mapRedeemerKeyToRedeemerVal) {
    const dummyWitnessSet = tx.witness_set();
    dummyWitnessSet.set_redeemers(
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Redeemers.new_map_redeemer_key_to_redeemer_val */ .F5E.new_map_redeemer_key_to_redeemer_val(
        mapRedeemerKeyToRedeemerVal
      )
    );
    return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Transaction["new"] */ .YW8["new"](
      tx.body(),
      dummyWitnessSet,
      true,
      tx.auxiliary_data()
    );
  }
  return tx;
};
var applyCollateral = (setCollateral, collateralInputs, changeAddress) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const { config } = yield* TxConfig;
  for (const utxo of collateralInputs) {
    const collateralInput = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .SingleInputBuilder.from_transaction_unspent_output */ .ph5.from_transaction_unspent_output(
      (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .utxoToCore */ .Sw)(utxo)
    ).payment_key();
    config.txBuilder.add_collateral(collateralInput);
  }
  const returnassets = (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    sumAssetsFromInputs(collateralInputs),
    effect__WEBPACK_IMPORTED_MODULE_13__/* .union */ .G0({ lovelace: -setCollateral }, effect__WEBPACK_IMPORTED_MODULE_14__/* .sum */ .Sm)
  );
  const collateralOutputBuilder = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionOutputBuilder["new"] */ .eVX["new"]().with_address(
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Address.from_bech32 */ .kLt.from_bech32(changeAddress)
  );
  config.txBuilder.set_collateral_return(
    collateralOutputBuilder.next().with_value((0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .assetsToValue */ .D)(returnassets)).build().output()
  );
});
var findCollateral = (coinsPerUtxoByte, setCollateral, inputs) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const collateralLovelace = { lovelace: setCollateral };
  const error = completeTxError(
    `Your wallet does not have enough funds to cover the required ${setCollateral} Lovelace collateral. Or it contains UTxOs with reference scripts; which
      are excluded from collateral selection.`
  );
  const { selected } = yield* recursive(
    (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .sortUTxOs */ .KW)(inputs),
    collateralLovelace,
    coinsPerUtxoByte,
    void 0,
    false,
    error
  );
  if (selected.length > 3)
    yield* completeTxError(
      `Selected ${selected.length} inputs as collateral, but max collateral inputs is 3 to cover the ${setCollateral} Lovelace collateral ${(0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringify */ .Pz)(selected)}`
    );
  return selected;
});
var doCoinSelection = (config, availableInputs, script_calculation, includeLeftoverLovelaceAsFee) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const estimatedFee = {
    lovelace: yield* estimateFee(config, script_calculation)
  };
  const negatedMintedAssets = negateAssets(config.mintedAssets);
  const negatedCollectedAssets = negateAssets(
    sumAssetsFromInputs(config.collectedInputs)
  );
  const assetsDelta = (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    config.totalOutputAssets,
    effect__WEBPACK_IMPORTED_MODULE_13__/* .union */ .G0(estimatedFee, effect__WEBPACK_IMPORTED_MODULE_14__/* .sum */ .Sm),
    effect__WEBPACK_IMPORTED_MODULE_13__/* .union */ .G0(negatedCollectedAssets, effect__WEBPACK_IMPORTED_MODULE_14__/* .sum */ .Sm),
    effect__WEBPACK_IMPORTED_MODULE_13__/* .union */ .G0(negatedMintedAssets, effect__WEBPACK_IMPORTED_MODULE_14__/* .sum */ .Sm)
  );
  let requiredAssets = (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    assetsDelta,
    effect__WEBPACK_IMPORTED_MODULE_13__/* .filter */ .hX((amount) => amount > 0n)
  );
  const notRequiredAssets = (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    assetsDelta,
    effect__WEBPACK_IMPORTED_MODULE_13__/* .filter */ .hX((amount) => amount < 0n),
    negateAssets
  );
  return yield* recursive(
    (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .sortUTxOs */ .KW)(availableInputs),
    requiredAssets,
    config.lucidConfig.protocolParameters.coinsPerUtxoByte,
    notRequiredAssets,
    includeLeftoverLovelaceAsFee
  );
});
var estimateFee = (config, script_calculation) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const minFee = config.txBuilder.min_fee(script_calculation);
  const refScriptFee = yield* calculateMinRefScriptFee(config);
  let estimatedFee = minFee + refScriptFee;
  const customMinFee = config.minFee;
  if (customMinFee !== void 0 && customMinFee > minFee || refScriptFee > 0n) {
    estimatedFee = customMinFee ? customMinFee > estimatedFee ? customMinFee : estimatedFee : estimatedFee;
    config.txBuilder.set_fee(estimatedFee);
  }
  return estimatedFee;
});
var evalTransactionProvider = (config, txRedeemerBuilder, walletInputs) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const txEvaluation = setRedeemerstoZero(txRedeemerBuilder.draft_tx());
  const txUtxos = [...config.collectedInputs, ...config.readInputs].map(
    ({ datumHash, datum, ...rest }) => ({
      ...rest,
      datumHash,
      datum: datumHash ? void 0 : datum
    })
  );
  const uplc_eval = yield* effect__WEBPACK_IMPORTED_MODULE_1__/* .tryPromise */ .p6W({
    try: () => config.lucidConfig.provider.evaluateTx(
      txEvaluation.to_cbor_hex(),
      txUtxos
    ),
    catch: (error) => completeTxError(error)
  });
  return uplc_eval;
});
var evalTransaction = (config, txRedeemerBuilder, walletInputs) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  const txEvaluation = setRedeemerstoZero(txRedeemerBuilder.draft_tx());
  const txUtxos = [
    ...walletInputs,
    ...config.collectedInputs,
    ...config.readInputs
  ].map(({ datumHash, datum, ...rest }) => ({
    ...rest,
    datumHash,
    datum: datumHash ? void 0 : datum
  }));
  const ins = txUtxos.map((utxo) => (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .utxoToTransactionInput */ .f5)(utxo));
  const outs = txUtxos.map((utxo) => (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .utxoToTransactionOutput */ .pU)(utxo));
  const slotConfig = _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_3__/* .SLOT_CONFIG_NETWORK */ .BV[config.lucidConfig.network];
  const uplc_eval = yield* effect__WEBPACK_IMPORTED_MODULE_1__/* ["try"] */ .JHF({
    try: () => _lucid_evolution_uplc__WEBPACK_IMPORTED_MODULE_10__/* .eval_phase_two_raw */ .Lz(
      txEvaluation.to_cbor_bytes(),
      ins.map((value) => value.to_cbor_bytes()),
      outs.map((value) => value.to_cbor_bytes()),
      config.lucidConfig.costModels.to_cbor_bytes(),
      config.lucidConfig.protocolParameters.maxTxExSteps,
      config.lucidConfig.protocolParameters.maxTxExMem,
      BigInt(slotConfig.zeroTime),
      BigInt(slotConfig.zeroSlot),
      slotConfig.slotLength
    ),
    catch: (error) => completeTxError(
      `${(0,effect_Predicate__WEBPACK_IMPORTED_MODULE_15__/* .isError */ .VZ)(error) ? error : JSON.stringify(error).replace(/\\n\s*/g, " ").trim()}`
    )
  });
  return uplc_eval;
});
var calculateMinLovelace = (coinsPerUtxoByte, multiAssets, changeAddress) => {
  const dummyAddress = "addr_test1qrngfyc452vy4twdrepdjc50d4kvqutgt0hs9w6j2qhcdjfx0gpv7rsrjtxv97rplyz3ymyaqdwqa635zrcdena94ljs0xy950";
  return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionOutputBuilder["new"] */ .eVX["new"]().with_address(
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Address.from_bech32 */ .kLt.from_bech32(changeAddress ? changeAddress : dummyAddress)
  ).next().with_asset_and_min_required_coin(
    multiAssets ? (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .assetsToValue */ .D)(multiAssets).multi_asset() : _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .MultiAsset["new"] */ .MLF["new"](),
    coinsPerUtxoByte
  ).build().output().amount().coin();
};
var calculateMinRefScriptFee = (config) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  let fee = 0n;
  let totalScriptSize = 0;
  for (const utxo of config.readInputs) {
    if (utxo.scriptRef) {
      totalScriptSize = totalScriptSize + utxo.scriptRef.script.length / 2;
    }
  }
  for (const utxo of config.collectedInputs) {
    if (utxo.scriptRef) {
      totalScriptSize = totalScriptSize + utxo.scriptRef.script.length / 2;
    }
  }
  if (totalScriptSize === 0) return fee;
  const fees = [15, 18, 21.6, 25.92, 31.1, 37.32, 44.79, 53.75];
  let counter = 0;
  while (totalScriptSize > 0) {
    if (counter > fees.length - 1) {
      yield* completeTxError(
        "Total reference script size in a transaction cannot exceed 200,000 bytes."
      );
    }
    if (totalScriptSize > 25e3)
      fee = fee + BigInt(Math.ceil(25e3 * fees[counter]));
    else fee = fee + BigInt(Math.ceil(totalScriptSize * fees[counter]));
    totalScriptSize = totalScriptSize - 25e3;
    counter++;
  }
  return fee;
});
var deriveInputsFromTransaction = (tx) => {
  const outputs = tx.body().outputs();
  const txHash = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .hash_transaction */ .o28(tx.body()).to_hex();
  const utxos = [];
  for (let index = 0; index < outputs.len(); index++) {
    const output = outputs.get(index);
    const utxo = {
      txHash,
      outputIndex: index,
      ...(0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .coreToTxOutput */ .yZ)(output)
    };
    utxos.push(utxo);
  }
  return utxos;
};
var negateAssets = (assets) => effect__WEBPACK_IMPORTED_MODULE_13__/* .map */ .UI(assets, (amount) => -amount);
var sumAssetsFromInputs = (inputs) => effect__WEBPACK_IMPORTED_MODULE_11__/* .isEmptyArray */ .yD(inputs) ? {} : inputs.map((utxo) => utxo.assets).reduce((acc, cur) => effect__WEBPACK_IMPORTED_MODULE_13__/* .union */ .G0(acc, cur, effect__WEBPACK_IMPORTED_MODULE_14__/* .sum */ .Sm));
var calculateExtraLovelace = (leftoverAssets, coinsPerUtxoByte) => {
  return (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(leftoverAssets, (assets) => {
    const minLovelace = calculateMinLovelace(coinsPerUtxoByte, assets);
    const currentLovelace = assets["lovelace"] || 0n;
    return currentLovelace >= minLovelace ? effect__WEBPACK_IMPORTED_MODULE_16__/* .none */ .YP() : effect__WEBPACK_IMPORTED_MODULE_16__/* .some */ .G({ lovelace: minLovelace - currentLovelace });
  });
};
var recursive = (inputs, requiredAssets, coinsPerUtxoByte, externalAssets = {}, includeLeftoverLovelaceAsFee, error) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
  let selected = [];
  error ??= completeTxError(
    `Your wallet does not have enough funds to cover the required assets: ${(0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringify */ .Pz)(requiredAssets)}
      Or it contains UTxOs with reference scripts; which are excluded from coin selection.`
  );
  if (!effect__WEBPACK_IMPORTED_MODULE_13__/* .isEmptyRecord */ .sG(requiredAssets)) {
    selected = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .selectUTxOs */ .GP)(inputs, requiredAssets, true);
    if (effect__WEBPACK_IMPORTED_MODULE_11__/* .isEmptyArray */ .yD(selected)) yield* error;
  }
  const selectedAssets = sumAssetsFromInputs(selected);
  let availableAssets = (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    selectedAssets,
    effect__WEBPACK_IMPORTED_MODULE_13__/* .union */ .G0(requiredAssets, (self, that) => self - that),
    effect__WEBPACK_IMPORTED_MODULE_13__/* .union */ .G0(externalAssets, effect__WEBPACK_IMPORTED_MODULE_14__/* .sum */ .Sm)
  );
  let extraLovelace = (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
    calculateExtraLovelace(availableAssets, coinsPerUtxoByte),
    effect__WEBPACK_IMPORTED_MODULE_16__/* .getOrUndefined */ .jD
  );
  let remainingInputs = inputs;
  while (extraLovelace) {
    remainingInputs = effect__WEBPACK_IMPORTED_MODULE_11__/* .differenceWith */ .F2(_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .isEqualUTxO */ .wF)(
      remainingInputs,
      selected
    );
    const extraSelected = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .selectUTxOs */ .GP)(remainingInputs, extraLovelace, true);
    if (effect__WEBPACK_IMPORTED_MODULE_11__/* .isEmptyArray */ .yD(extraSelected)) {
      if (includeLeftoverLovelaceAsFee)
        return { selected: [...selected], burnable: extraLovelace };
      yield* completeTxError(
        `Your wallet does not have enough funds to cover required minimum ADA for change output: ${(0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringify */ .Pz)(extraLovelace)}
          Or it contains UTxOs with reference scripts; which are excluded from coin selection.`
      );
    }
    const extraSelectedAssets = sumAssetsFromInputs(extraSelected);
    selected = [...selected, ...extraSelected];
    availableAssets = effect__WEBPACK_IMPORTED_MODULE_13__/* .union */ .G0(
      availableAssets,
      extraSelectedAssets,
      effect__WEBPACK_IMPORTED_MODULE_14__/* .sum */ .Sm
    );
    extraLovelace = (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
      calculateExtraLovelace(availableAssets, coinsPerUtxoByte),
      effect__WEBPACK_IMPORTED_MODULE_16__/* .getOrUndefined */ .jD
    );
  }
  return { selected, burnable: { lovelace: 0n } };
});

// src/tx-builder/TxBuilder.ts


function makeTxBuilder(lucidConfig) {
  const config = {
    lucidConfig,
    txBuilder: _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionBuilder["new"] */ .hKc["new"](lucidConfig.txbuilderconfig),
    walletInputs: [],
    collectedInputs: [],
    readInputs: [],
    consumedInputs: [],
    totalOutputAssets: {},
    payToOutputs: [],
    mintedAssets: {},
    scripts: /* @__PURE__ */ new Map(),
    programs: [],
    partialPrograms: /* @__PURE__ */ new Map(),
    minFee: void 0
  };
  const configLayer = effect__WEBPACK_IMPORTED_MODULE_17__/* .succeed */ .ng(TxConfig, { config });
  const txBuilder = {
    readFrom: (utxos) => {
      utxos.map((utxo) => {
        if (utxo.scriptRef) {
          const scriptKeyValue = attachScript(utxo.scriptRef);
          config.scripts.set(scriptKeyValue.key, scriptKeyValue.value);
        }
      });
      const program = readFrom(utxos);
      config.programs.push(program);
      return txBuilder;
    },
    collectFrom: (utxos, redeemer) => {
      const program = typeof redeemer === "object" ? collectFromUTxOPartial(utxos, redeemer) : collectFromUTxO(utxos)(redeemer);
      config.programs.push(program);
      return txBuilder;
    },
    pay: {
      ToAddress: (address, assets) => {
        const program = payToAddress(address, assets);
        config.programs.push(program);
        return txBuilder;
      },
      ToAddressWithData: (address, outputDatum, assets, scriptRef) => {
        const program = ToAddressWithData(
          address,
          outputDatum,
          assets,
          scriptRef
        );
        config.programs.push(program);
        return txBuilder;
      },
      ToContract: (address, outputDatum, assets, scriptRef) => {
        const program = ToContract(address, outputDatum, assets, scriptRef);
        config.programs.push(program);
        return txBuilder;
      }
    },
    addSigner: (address) => {
      const program = addSigner(address);
      config.programs.push(program);
      return txBuilder;
    },
    addSignerKey: (keyHash) => {
      const program = addSignerKey(keyHash);
      config.programs.push(program);
      return txBuilder;
    },
    registerStake: (rewardAddress) => {
      const program = registerStake(rewardAddress);
      config.programs.push(program);
      return txBuilder;
    },
    register: {
      Stake: (rewardAddress) => {
        const program = registerStake(rewardAddress);
        config.programs.push(program);
        return txBuilder;
      },
      DRep: (rewardAddress, anchor, redeemer) => {
        const program = registerDRep(
          rewardAddress,
          anchor,
          redeemer
        );
        config.programs.push(program);
        return txBuilder;
      }
    },
    deRegisterStake: (rewardAddress, redeemer) => {
      const program = deRegisterStake(rewardAddress, redeemer);
      config.programs.push(program);
      return txBuilder;
    },
    deregister: {
      Stake: (rewardAddress, redeemer) => {
        const program = deRegisterStake(rewardAddress, redeemer);
        config.programs.push(program);
        return txBuilder;
      },
      DRep: (rewardAddress, redeemer) => {
        const program = deregisterDRep(rewardAddress, redeemer);
        config.programs.push(program);
        return txBuilder;
      }
    },
    withdraw: (rewardAddress, amount, redeemer) => {
      const partialProgram = withdraw(rewardAddress, amount);
      handleRedeemerBuilder(config, partialProgram, redeemer);
      return txBuilder;
    },
    mintAssets: (assets, redeemer) => {
      config.mintedAssets = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .addAssets */ .q$)(config.mintedAssets, assets);
      const partialProgram = mintAssets(assets);
      handleRedeemerBuilder(config, partialProgram, redeemer);
      return txBuilder;
    },
    validFrom: (unixTime) => {
      const program = validFrom(unixTime);
      config.programs.push(program);
      return txBuilder;
    },
    validTo: (unixTime) => {
      const program = validTo(unixTime);
      config.programs.push(program);
      return txBuilder;
    },
    delegateTo: (rewardAddress, poolId, redeemer) => {
      const program = delegateTo(rewardAddress, poolId, redeemer);
      config.programs.push(program);
      return txBuilder;
    },
    delegate: {
      ToPool: (rewardAddress, poolId, redeemer) => {
        const program = delegateTo(rewardAddress, poolId, redeemer);
        config.programs.push(program);
        return txBuilder;
      },
      VoteToDRep: (rewardAddress, drep, redeemer) => {
        const program = delegateVoteToDRep(
          rewardAddress,
          drep,
          redeemer
        );
        config.programs.push(program);
        return txBuilder;
      },
      VoteToPoolAndDRep: (rewardAddress, poolId, drep, redeemer) => {
        const program = delegateVoteToPoolAndDRep(
          rewardAddress,
          poolId,
          drep,
          redeemer
        );
        config.programs.push(program);
        return txBuilder;
      }
    },
    registerAndDelegate: {
      ToPool: (rewardAddress, poolId, redeemer) => {
        const program = registerAndDelegateToPool(
          rewardAddress,
          poolId,
          redeemer
        );
        config.programs.push(program);
        return txBuilder;
      },
      ToDRep: (rewardAddress, drep, redeemer) => {
        const program = registerAndDelegateToDRep(
          rewardAddress,
          drep,
          redeemer
        );
        config.programs.push(program);
        return txBuilder;
      },
      ToPoolAndDRep: (rewardAddress, poolId, drep, redeemer) => {
        const program = registerAndDelegateToPoolAndDRep(
          rewardAddress,
          poolId,
          drep,
          redeemer
        );
        config.programs.push(program);
        return txBuilder;
      }
    },
    updateDRep: (rewardAddress, anchor, redeemer) => {
      const program = updateDRep(rewardAddress, anchor, redeemer);
      config.programs.push(program);
      return txBuilder;
    },
    authCommitteeHot: (coldAddress, hotAddress, redeemer) => {
      const program = authCommitteeHot(
        coldAddress,
        hotAddress,
        redeemer
      );
      config.programs.push(program);
      return txBuilder;
    },
    resignCommitteeHot: (coldAddress, anchor, redeemer) => {
      const program = resignCommitteeHot(
        coldAddress,
        anchor,
        redeemer
      );
      config.programs.push(program);
      return txBuilder;
    },
    attachMetadata: (label, metadata) => {
      const program = attachMetadata(config, label, metadata);
      config.programs.push(program);
      return txBuilder;
    },
    attach: {
      Script: (script) => {
        const scriptKeyValue = attachScript(script);
        config.scripts.set(scriptKeyValue.key, scriptKeyValue.value);
        return txBuilder;
      },
      SpendingValidator: (spendingValidator) => {
        const scriptKeyValue = attachSpendingValidator(spendingValidator);
        config.scripts.set(scriptKeyValue.key, scriptKeyValue.value);
        return txBuilder;
      },
      MintingPolicy: (mintingPolicy) => {
        const scriptKeyValue = attachMintingPolicy(mintingPolicy);
        config.scripts.set(scriptKeyValue.key, scriptKeyValue.value);
        return txBuilder;
      },
      CertificateValidator: (certValidator) => {
        const scriptKeyValue = attachCertificateValidator(certValidator);
        config.scripts.set(scriptKeyValue.key, scriptKeyValue.value);
        return txBuilder;
      },
      WithdrawalValidator: (withdrawalValidator) => {
        const scriptKeyValue = attachWithdrawalValidator(withdrawalValidator);
        config.scripts.set(scriptKeyValue.key, scriptKeyValue.value);
        return txBuilder;
      },
      VoteValidator: (voteValidator) => {
        const scriptKeyValue = attachVoteValidator(voteValidator);
        config.scripts.set(scriptKeyValue.key, scriptKeyValue.value);
        return txBuilder;
      },
      ProposeValidator: (proposeValidator) => {
        const scriptKeyValue = attachProposeValidator(proposeValidator);
        config.scripts.set(scriptKeyValue.key, scriptKeyValue.value);
        return txBuilder;
      }
    },
    compose: (tx) => {
      if (tx) {
        const rawConfig = tx.rawConfig();
        config.programs = [...config.programs, ...tx.getPrograms()];
        config.scripts = new Map([...config.scripts, ...rawConfig.scripts]);
        config.mintedAssets = Object.entries({
          ...config.mintedAssets,
          ...rawConfig.mintedAssets
        }).reduce((acc, [key, value]) => {
          acc[key] = (config.mintedAssets[key] || 0n) + BigInt(value);
          return acc;
        }, {});
      }
      return txBuilder;
    },
    setMinFee: (fee) => {
      config.minFee = fee;
      return txBuilder;
    },
    complete: (options) => makeReturn(
      (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        complete(options),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .provide */ .JJ_(configLayer),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID((result) => result[2])
      )
    ).unsafeRun(),
    completeProgram: (options) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
      complete(options),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .provide */ .JJ_(configLayer),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID((result) => result[2])
    ),
    completeSafe: (options) => makeReturn(
      (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        complete(options),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .provide */ .JJ_(configLayer),
        effect__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID((result) => result[2])
      )
    ).safeRun(),
    chainProgram: (options) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(complete(options), effect__WEBPACK_IMPORTED_MODULE_1__/* .provide */ .JJ_(configLayer)),
    chain: (options) => makeReturn(
      (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(complete(options), effect__WEBPACK_IMPORTED_MODULE_1__/* .provide */ .JJ_(configLayer))
    ).unsafeRun(),
    chainSafe: (options) => makeReturn(
      (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(complete(options), effect__WEBPACK_IMPORTED_MODULE_1__/* .provide */ .JJ_(configLayer))
    ).safeRun(),
    rawConfig: () => config,
    config: () => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
      effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
        yield* effect__WEBPACK_IMPORTED_MODULE_1__/* .all */ .$6P(config.programs);
        return config;
      }),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .provide */ .JJ_(configLayer),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .runPromise */ .VR7
    ),
    lucidConfig: () => config.lucidConfig,
    getPrograms: () => config.programs
  };
  return txBuilder;
}

// src/tx-builder/TxConfig.ts
var makeTxConfig = (protocolParameters, costModels) => {
  const exUnitsPrices = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ExUnitPrices["new"] */ .wJb["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Rational["new"] */ .uGy["new"](
      BigInt(protocolParameters.priceMem * 1e8),
      100000000n
    ),
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Rational["new"] */ .uGy["new"](
      BigInt(protocolParameters.priceStep * 1e8),
      100000000n
    )
  );
  const txBuilderConfig = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionBuilderConfigBuilder["new"] */ .szC["new"]().fee_algo(
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .LinearFee["new"] */ .H8G["new"](
      BigInt(protocolParameters.minFeeA),
      BigInt(protocolParameters.minFeeB),
      BigInt(protocolParameters.minFeeRefScriptCostPerByte)
    )
  ).coins_per_utxo_byte(protocolParameters.coinsPerUtxoByte).pool_deposit(protocolParameters.poolDeposit).key_deposit(protocolParameters.keyDeposit).max_value_size(protocolParameters.maxValSize).max_tx_size(protocolParameters.maxTxSize).ex_unit_prices(exUnitsPrices).collateral_percentage(protocolParameters.collateralPercentage).max_collateral_inputs(protocolParameters.maxCollateralInputs).cost_models(costModels).collateral_percentage(protocolParameters.collateralPercentage).max_collateral_inputs(protocolParameters.maxCollateralInputs).build();
  return txBuilderConfig;
};

// src/lucid-evolution/LucidEvolution.ts



var Lucid = async (provider, network, options = {}) => {
  const protocolParameters = options.presetProtocolParameters || await provider?.getProtocolParameters();
  const costModels = protocolParameters ? (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .createCostModels */ .sJ)(protocolParameters.costModels) : void 0;
  const config = {
    provider,
    network,
    wallet: void 0,
    costModels,
    txbuilderconfig: protocolParameters && costModels ? makeTxConfig(protocolParameters, costModels) : void 0,
    protocolParameters
  };
  if (config.provider && "slot" in config.provider) {
    const emulator = config.provider;
    effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
      const custom = yield* (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
        validateNotNullableNetwork(network)
        // Effect.filterOrFail(
        //   (network) => network === "Custom",
        //   () =>
        //     new UnauthorizedNetwork({
        //       message: `Expected Custom, received ${String(network)}`,
        //     }),
        // ),
      );
      _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_3__/* .SLOT_CONFIG_NETWORK */ .BV[custom] = {
        zeroTime: emulator.now(),
        zeroSlot: 0,
        slotLength: 1e3
      };
    }).pipe(effect__WEBPACK_IMPORTED_MODULE_1__/* .runSync */ .Wno);
  }
  return {
    config: () => config,
    wallet: () => config.wallet,
    overrideUTxOs: (utxos) => config.wallet?.overrideUTxOs(utxos),
    switchProvider: async (provider2) => {
      const protocolParam = await provider2.getProtocolParameters();
      const costModels2 = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .createCostModels */ .sJ)(protocolParam.costModels);
      config.provider = provider2;
      config.costModels = costModels2;
      config.txbuilderconfig = makeTxConfig(protocolParam, costModels2);
      config.protocolParameters = protocolParam;
    },
    newTx: () => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
      const provider2 = yield* effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(config.provider);
      const network2 = yield* effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(config.network);
      const costModels2 = yield* validateNotNullable(
        config.costModels,
        "CostModels are not set in Lucid instance"
      );
      const txbuilderconfig = yield* validateNotNullable(
        config.txbuilderconfig,
        "txbuilderconfig is not set in Lucid instance"
      );
      const protocolParameters2 = yield* validateNotNullable(
        config.protocolParameters,
        "protocolParameters are not set in Lucid instance"
      );
      return makeTxBuilder({
        provider: provider2,
        network: network2,
        wallet: config.wallet,
        costModels: costModels2,
        txbuilderconfig,
        protocolParameters: protocolParameters2
      });
    }).pipe(effect__WEBPACK_IMPORTED_MODULE_1__/* .runSync */ .Wno),
    fromTx: (tx) => makeTxSignBuilder(
      config.wallet,
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Transaction.from_cbor_hex */ .YW8.from_cbor_hex(tx)
    ),
    selectWallet: {
      fromSeed: (seed, options2) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
        config.wallet = (0,_lucid_evolution_wallet__WEBPACK_IMPORTED_MODULE_18__/* .makeWalletFromSeed */ .EM)(
          yield* validateNotNullableProvider(config.provider),
          yield* validateNotNullableNetwork(network),
          seed,
          options2
        );
      }).pipe(effect__WEBPACK_IMPORTED_MODULE_1__/* .runSync */ .Wno),
      fromPrivateKey: (privateKey) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
        config.wallet = (0,_lucid_evolution_wallet__WEBPACK_IMPORTED_MODULE_18__/* .makeWalletFromPrivateKey */ .J9)(
          yield* validateNotNullableProvider(config.provider),
          yield* validateNotNullableNetwork(network),
          privateKey
        );
      }).pipe(effect__WEBPACK_IMPORTED_MODULE_1__/* .runSync */ .Wno),
      fromAPI: (walletAPI) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
        config.wallet = (0,_lucid_evolution_wallet__WEBPACK_IMPORTED_MODULE_18__/* .makeWalletFromAPI */ .aZ)(
          yield* validateNotNullableProvider(config.provider),
          walletAPI
        );
      }).pipe(effect__WEBPACK_IMPORTED_MODULE_1__/* .runSync */ .Wno),
      fromAddress: (address, utxos) => effect__WEBPACK_IMPORTED_MODULE_1__/* .gen */ .Yr4(function* () {
        config.wallet = (0,_lucid_evolution_wallet__WEBPACK_IMPORTED_MODULE_18__/* .makeWalletFromAddress */ .Iy)(
          yield* validateNotNullableProvider(config.provider),
          yield* validateNotNullableNetwork(network),
          address,
          utxos
        );
      }).pipe(effect__WEBPACK_IMPORTED_MODULE_1__/* .runSync */ .Wno)
    },
    currentSlot: () => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
      validateNotNullableNetwork(config.network),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID((network2) => (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .unixTimeToSlot */ .Hf)(network2, Date.now())),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .runSync */ .Wno
    ),
    unixTimeToSlot: (unixTime) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
      validateNotNullableNetwork(config.network),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID((network2) => (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .unixTimeToSlot */ .Hf)(network2, unixTime)),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .runSync */ .Wno
    ),
    utxosAt: (addressOrCredential) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
      validateNotNullableProvider(config.provider),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VSD(
        (provider2) => effect__WEBPACK_IMPORTED_MODULE_1__/* .promise */ .MCc(() => provider2.getUtxos(addressOrCredential))
      ),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .runPromise */ .VR7
    ),
    utxosAtWithUnit: (addressOrCredential, unit) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
      validateNotNullableProvider(config.provider),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VSD(
        (provider2) => effect__WEBPACK_IMPORTED_MODULE_1__/* .promise */ .MCc(
          () => provider2.getUtxosWithUnit(addressOrCredential, unit)
        )
      ),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .runPromise */ .VR7
    ),
    utxoByUnit: (unit) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
      validateNotNullableProvider(config.provider),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VSD(
        (provider2) => effect__WEBPACK_IMPORTED_MODULE_1__/* .promise */ .MCc(() => provider2.getUtxoByUnit(unit))
      ),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .runPromise */ .VR7
    ),
    utxosByOutRef: (outRefs) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
      validateNotNullableProvider(config.provider),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VSD(
        (provider2) => effect__WEBPACK_IMPORTED_MODULE_1__/* .promise */ .MCc(() => provider2.getUtxosByOutRef(outRefs))
      ),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .runPromise */ .VR7
    ),
    delegationAt: (rewardAddress) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
      validateNotNullableProvider(config.provider),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VSD(
        (provider2) => effect__WEBPACK_IMPORTED_MODULE_1__/* .promise */ .MCc(() => provider2.getDelegation(rewardAddress))
      ),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .runPromise */ .VR7
    ),
    awaitTx: (txHash, checkInterval) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
      validateNotNullableProvider(config.provider),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VSD(
        (provider2) => effect__WEBPACK_IMPORTED_MODULE_1__/* .promise */ .MCc(() => provider2.awaitTx(txHash, checkInterval))
      ),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .runPromise */ .VR7
    ),
    datumOf: (utxo, type) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
      validateNotNullableProvider(config.provider),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VSD(
        (provider2) => effect__WEBPACK_IMPORTED_MODULE_1__/* .promise */ .MCc(() => datumOf(provider2, utxo, type))
      ),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .runPromise */ .VR7
    ),
    metadataOf: (unit) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
      validateNotNullableProvider(config.provider),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VSD(
        (provider2) => effect__WEBPACK_IMPORTED_MODULE_1__/* .promise */ .MCc(() => metadataOf(provider2, unit))
      ),
      effect__WEBPACK_IMPORTED_MODULE_1__/* .runPromise */ .VR7
    )
  };
};
var validateNotNullable = (value, message) => (0,effect__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(
  effect__WEBPACK_IMPORTED_MODULE_1__/* .fromNullable */ .ijW(value),
  effect__WEBPACK_IMPORTED_MODULE_1__/* .orElseFail */ .LPI(() => new NullableError({ message }))
);
var validateNotNullableNetwork = (network) => validateNotNullable(network, "Network is not set in Lucid instance");
var validateNotNullableProvider = (provider) => validateNotNullable(provider, "Provider is not set in Lucid instance");

// src/index.ts








//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 46533:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BV": function() { return /* binding */ SLOT_CONFIG_NETWORK; },
/* harmony export */   "Vw": function() { return /* binding */ Data; },
/* harmony export */   "WN": function() { return /* binding */ unixTimeToEnclosingSlot; },
/* harmony export */   "fL": function() { return /* binding */ Constr; }
/* harmony export */ });
/* unused harmony export slotToBeginUnixTime */
/* harmony import */ var _sinclair_typebox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67954);
/* harmony import */ var _lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34837);
/* harmony import */ var _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82381);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__]);
_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to2, from2, except, desc) => {
  if (from2 && typeof from2 === "object" || typeof from2 === "function") {
    for (let key of __getOwnPropNames(from2))
      if (!__hasOwnProp.call(to2, key) && key !== except)
        __defProp(to2, key, { get: () => from2[key], enumerable: !(desc = __getOwnPropDesc(from2, key)) || desc.enumerable });
  }
  return to2;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Constr: () => Constr,
  Data: () => Data,
  SLOT_CONFIG_NETWORK: () => SLOT_CONFIG_NETWORK,
  slotToBeginUnixTime: () => slotToBeginUnixTime,
  unixTimeToEnclosingSlot: () => unixTimeToEnclosingSlot
});

// src/data.ts
var data_exports = {};
__export(data_exports, {
  Constr: () => Constr,
  Data: () => Data
});
__reExport(data_exports, _sinclair_typebox__WEBPACK_IMPORTED_MODULE_0__);




var Constr = class {
  index;
  fields;
  constructor(index, fields) {
    this.index = index;
    this.fields = fields;
  }
};
var Data = {
  // Types
  // Note: Recursive types are not supported (yet)
  Integer: function(options) {
    const integer = _sinclair_typebox__WEBPACK_IMPORTED_MODULE_0__.Type.Unsafe({ dataType: "integer" });
    if (options) {
      Object.entries(options).forEach(([key, value]) => {
        integer[key] = value;
      });
    }
    return integer;
  },
  Bytes: function(options) {
    const bytes = _sinclair_typebox__WEBPACK_IMPORTED_MODULE_0__.Type.Unsafe({ dataType: "bytes" });
    if (options) {
      Object.entries(options).forEach(([key, value]) => {
        bytes[key] = value;
      });
    }
    return bytes;
  },
  Boolean: function() {
    return _sinclair_typebox__WEBPACK_IMPORTED_MODULE_0__.Type.Unsafe({
      anyOf: [
        {
          title: "False",
          dataType: "constructor",
          index: 0,
          fields: []
        },
        {
          title: "True",
          dataType: "constructor",
          index: 1,
          fields: []
        }
      ]
    });
  },
  Any: function() {
    return _sinclair_typebox__WEBPACK_IMPORTED_MODULE_0__.Type.Unsafe({ description: "Any Data." });
  },
  Array: function(items, options) {
    const array = _sinclair_typebox__WEBPACK_IMPORTED_MODULE_0__.Type.Array(items);
    replaceProperties(array, { dataType: "list", items });
    if (options) {
      Object.entries(options).forEach(([key, value]) => {
        array[key] = value;
      });
    }
    return array;
  },
  Map: function(keys, values, options) {
    const map = _sinclair_typebox__WEBPACK_IMPORTED_MODULE_0__.Type.Unsafe({
      dataType: "map",
      keys,
      values
    });
    if (options) {
      Object.entries(options).forEach(([key, value]) => {
        map[key] = value;
      });
    }
    return map;
  },
  /**
   * Object applies by default a PlutusData Constr with index 0.\
   * Set 'hasConstr' to false to serialize Object as PlutusData List.
   */
  Object: function(properties, options) {
    const object = _sinclair_typebox__WEBPACK_IMPORTED_MODULE_0__.Type.Object(properties);
    replaceProperties(object, {
      anyOf: [
        {
          dataType: "constructor",
          index: 0,
          // Will be replaced when using Data.Enum
          fields: Object.entries(properties).map(([title, p]) => ({
            ...p,
            title
          }))
        }
      ]
    });
    object.anyOf[0].hasConstr = typeof options?.hasConstr === "undefined" || options.hasConstr;
    return object;
  },
  Enum: function(items) {
    const union = _sinclair_typebox__WEBPACK_IMPORTED_MODULE_0__.Type.Union(items);
    replaceProperties(union, {
      anyOf: items.map(
        (item, index) => item.anyOf[0].fields.length === 0 ? {
          ...item.anyOf[0],
          index
        } : {
          dataType: "constructor",
          title: (() => {
            const title = item.anyOf[0].fields[0].title;
            if (title.charAt(0) !== title.charAt(0).toUpperCase()) {
              throw new Error(
                `Enum '${title}' needs to start with an uppercase letter.`
              );
            }
            return item.anyOf[0].fields[0].title;
          })(),
          index,
          fields: item.anyOf[0].fields[0].items || item.anyOf[0].fields[0].anyOf[0].fields
        }
      )
    });
    return union;
  },
  /**
   * Tuple is by default a PlutusData List.\
   * Set 'hasConstr' to true to apply a PlutusData Constr with index 0.
   */
  Tuple: function(items, options) {
    const tuple = _sinclair_typebox__WEBPACK_IMPORTED_MODULE_0__.Type.Tuple(items);
    replaceProperties(tuple, {
      dataType: "list",
      items
    });
    if (options) {
      Object.entries(options).forEach(([key, value]) => {
        tuple[key] = value;
      });
    }
    return tuple;
  },
  Literal: function(title) {
    if (title.charAt(0) !== title.charAt(0).toUpperCase()) {
      throw new Error(
        `Enum '${title}' needs to start with an uppercase letter.`
      );
    }
    const literal = _sinclair_typebox__WEBPACK_IMPORTED_MODULE_0__.Type.Literal(title);
    replaceProperties(literal, {
      anyOf: [
        {
          dataType: "constructor",
          title,
          index: 0,
          // Will be replaced in Data.Enum
          fields: []
        }
      ]
    });
    return literal;
  },
  Nullable: function(item) {
    return _sinclair_typebox__WEBPACK_IMPORTED_MODULE_0__.Type.Unsafe({
      anyOf: [
        {
          title: "Some",
          description: "An optional value.",
          dataType: "constructor",
          index: 0,
          fields: [item]
        },
        {
          title: "None",
          description: "Nothing.",
          dataType: "constructor",
          index: 1,
          fields: []
        }
      ]
    });
  },
  /**
   * Convert PlutusData to Cbor encoded data.\
   * Or apply a shape and convert the provided data struct to Cbor encoded data.
   */
  to,
  /** Convert Cbor encoded data to PlutusData */
  from,
  /**
   * Note Constr cannot be used here.\
   * Strings prefixed with '0x' are not UTF-8 encoded.
   */
  fromJson,
  /**
   * Note Constr cannot be used here, also only bytes/integers as Json keys.\
   */
  toJson,
  void: function() {
    return "d87980";
  },
  castFrom,
  castTo
};
function to(data, type, options = {}) {
  const { canonical = false } = options;
  function serialize(data2) {
    try {
      if (typeof data2 === "bigint") {
        return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .PlutusData.new_integer */ .$zK.new_integer(
          _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .BigInteger.from_str */ .Jhp.from_str(data2.toString())
        );
      } else if (typeof data2 === "string") {
        return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .PlutusData.new_bytes */ .$zK.new_bytes((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(data2));
      } else if (data2 instanceof Constr) {
        const { index, fields } = data2;
        const plutusList = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .PlutusDataList["new"] */ .ODz["new"]();
        fields.forEach((field) => plutusList.add(serialize(field)));
        return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .PlutusData.new_constr_plutus_data */ .$zK.new_constr_plutus_data(
          _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .ConstrPlutusData["new"] */ .LvZ["new"](
            _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .BigInteger.from_str */ .Jhp.from_str(index.toString()).as_u64(),
            plutusList
          )
        );
      } else if (data2 instanceof Array) {
        const plutusList = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .PlutusDataList["new"] */ .ODz["new"]();
        data2.forEach((arg) => plutusList.add(serialize(arg)));
        return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .PlutusData.new_list */ .$zK.new_list(plutusList);
      } else if (data2 instanceof Map) {
        const plutusMap = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .PlutusMap["new"] */ .FRj["new"]();
        for (const [key, value] of data2.entries()) {
          plutusMap.set(serialize(key), serialize(value));
        }
        return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .PlutusData.new_map */ .$zK.new_map(plutusMap);
      }
      throw new Error("Unsupported type");
    } catch (error) {
      throw new Error("Could not serialize the data: " + error);
    }
  }
  const d = type ? castTo(data, type) : data;
  return canonical ? serialize(d).to_canonical_cbor_hex() : serialize(d).to_cardano_node_format().to_cbor_hex();
}
function from(raw, type) {
  function deserialize(data2) {
    if (data2.kind() === 0) {
      const constr = data2.as_constr_plutus_data();
      const l = constr.fields();
      const desL = [];
      for (let i = 0; i < l.len(); i++) {
        desL.push(deserialize(l.get(i)));
      }
      return new Constr(parseInt(constr.alternative().toString()), desL);
    } else if (data2.kind() === 1) {
      const m = data2.as_map();
      const desM = /* @__PURE__ */ new Map();
      const keys = m.keys();
      for (let i = 0; i < keys.len(); i++) {
        desM.set(deserialize(keys.get(i)), deserialize(m.get(keys.get(i))));
      }
      return desM;
    } else if (data2.kind() === 2) {
      const l = data2.as_list();
      const desL = [];
      for (let i = 0; i < l.len(); i++) {
        desL.push(deserialize(l.get(i)));
      }
      return desL;
    } else if (data2.kind() === 3) {
      return BigInt(data2.as_integer().to_str());
    } else if (data2.kind() === 4) {
      return (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .toHex */ .NC)(data2.as_bytes());
    }
    throw new Error("Unsupported type");
  }
  const data = deserialize(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .PlutusData.from_cbor_hex */ .$zK.from_cbor_hex(raw));
  return type ? castFrom(data, type) : data;
}
function fromJson(json) {
  function toData(json2) {
    if (typeof json2 === "string") {
      return json2.startsWith("0x") ? (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .toHex */ .NC)((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(json2.slice(2))) : (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromText */ .t1)(json2);
    }
    if (typeof json2 === "number") return BigInt(json2);
    if (typeof json2 === "bigint") return json2;
    if (json2 instanceof Array) return json2.map((v) => toData(v));
    if (json2 instanceof Object) {
      const tempMap = /* @__PURE__ */ new Map();
      Object.entries(json2).forEach(([key, value]) => {
        tempMap.set(toData(key), toData(value));
      });
      return tempMap;
    }
    throw new Error("Unsupported type");
  }
  return toData(json);
}
function toJson(plutusData) {
  function fromData(data) {
    if (typeof data === "bigint" || typeof data === "number" || typeof data === "string" && !isNaN(parseInt(data)) && data.slice(-1) === "n") {
      const bigint = typeof data === "string" ? BigInt(data.slice(0, -1)) : data;
      return parseInt(bigint.toString());
    }
    if (typeof data === "string") {
      try {
        return new TextDecoder(void 0, { fatal: true }).decode(
          (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(data)
        );
      } catch (_) {
        return "0x" + (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .toHex */ .NC)((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(data));
      }
    }
    if (data instanceof Array) return data.map((v) => fromData(v));
    if (data instanceof Map) {
      const tempJson = {};
      data.forEach((value, key) => {
        const convertedKey = fromData(key);
        if (typeof convertedKey !== "string" && typeof convertedKey !== "number") {
          throw new Error(
            "Unsupported type (Note: Only bytes or integers can be keys of a JSON object)"
          );
        }
        tempJson[convertedKey] = fromData(value);
      });
      return tempJson;
    }
    throw new Error(
      "Unsupported type (Note: Constructor cannot be converted to JSON)"
    );
  }
  return fromData(plutusData);
}
function castFrom(data, type) {
  const shape = type;
  if (!shape) throw new Error("Could not type cast data.");
  const shapeType = (shape.anyOf ? "enum" : "") || shape.dataType;
  switch (shapeType) {
    case "integer": {
      if (typeof data !== "bigint") {
        throw new Error("Could not type cast to integer.");
      }
      integerConstraints(data, shape);
      return data;
    }
    case "bytes": {
      if (typeof data !== "string") {
        throw new Error("Could not type cast to bytes.");
      }
      bytesConstraints(data, shape);
      return data;
    }
    case "constructor": {
      if (isVoid(shape)) {
        if (!(data instanceof Constr) || data.index !== 0 || data.fields.length !== 0) {
          throw new Error("Could not type cast to void.");
        }
        return void 0;
      } else if (data instanceof Constr && data.index === shape.index && (shape.hasConstr || shape.hasConstr === void 0)) {
        const fields = {};
        if (shape.fields.length !== data.fields.length) {
          throw new Error(
            "Could not type cast to object. Fields do not match."
          );
        }
        shape.fields.forEach((field, fieldIndex) => {
          const title = field.title || "wrapper";
          if (/[A-Z]/.test(title[0])) {
            throw new Error(
              "Could not type cast to object. Object properties need to start with a lowercase letter."
            );
          }
          fields[title] = castFrom(data.fields[fieldIndex], field);
        });
        return fields;
      } else if (data instanceof Array && !shape.hasConstr && shape.hasConstr !== void 0) {
        const fields = {};
        if (shape.fields.length !== data.length) {
          throw new Error("Could not ype cast to object. Fields do not match.");
        }
        shape.fields.forEach((field, fieldIndex) => {
          const title = field.title || "wrapper";
          if (/[A-Z]/.test(title[0])) {
            throw new Error(
              "Could not type cast to object. Object properties need to start with a lowercase letter."
            );
          }
          fields[title] = castFrom(data[fieldIndex], field);
        });
        return fields;
      }
      throw new Error("Could not type cast to object.");
    }
    case "enum": {
      if (shape.anyOf.length === 1) {
        return castFrom(data, shape.anyOf[0]);
      }
      if (!(data instanceof Constr)) {
        throw new Error("Could not type cast to enum.");
      }
      const enumShape = shape.anyOf.find(
        (entry) => entry.index === data.index
      );
      if (!enumShape || enumShape.fields.length !== data.fields.length) {
        throw new Error("Could not type cast to enum.");
      }
      if (isBoolean(shape)) {
        if (data.fields.length !== 0) {
          throw new Error("Could not type cast to boolean.");
        }
        switch (data.index) {
          case 0:
            return false;
          case 1:
            return true;
        }
        throw new Error("Could not type cast to boolean.");
      } else if (isNullable(shape)) {
        switch (data.index) {
          case 0: {
            if (data.fields.length !== 1) {
              throw new Error("Could not type cast to nullable object.");
            }
            return castFrom(data.fields[0], shape.anyOf[0].fields[0]);
          }
          case 1: {
            if (data.fields.length !== 0) {
              throw new Error("Could not type cast to nullable object.");
            }
            return null;
          }
        }
        throw new Error("Could not type cast to nullable object.");
      }
      switch (enumShape.dataType) {
        case "constructor": {
          if (enumShape.fields.length === 0) {
            if (/[A-Z]/.test(enumShape.title[0])) {
              return enumShape.title;
            }
            throw new Error("Could not type cast to enum.");
          } else {
            if (!/[A-Z]/.test(enumShape.title)) {
              throw new Error(
                "Could not type cast to enum. Enums need to start with an uppercase letter."
              );
            }
            if (enumShape.fields.length !== data.fields.length) {
              throw new Error("Could not type cast to enum.");
            }
            const args = enumShape.fields[0].title ? Object.fromEntries(
              enumShape.fields.map((field, index) => [
                field.title,
                castFrom(data.fields[index], field)
              ])
            ) : enumShape.fields.map(
              (field, index) => castFrom(data.fields[index], field)
            );
            return {
              [enumShape.title]: args
            };
          }
        }
      }
      throw new Error("Could not type cast to enum.");
    }
    case "list": {
      if (shape.items instanceof Array) {
        if (data instanceof Constr && data.index === 0 && shape.hasConstr) {
          return data.fields.map(
            (field, index) => castFrom(field, shape.items[index])
          );
        } else if (data instanceof Array && !shape.hasConstr) {
          return data.map(
            (field, index) => castFrom(field, shape.items[index])
          );
        }
        throw new Error("Could not type cast to tuple.");
      } else {
        if (!(data instanceof Array)) {
          throw new Error("Could not type cast to array.");
        }
        listConstraints(data, shape);
        return data.map((field) => castFrom(field, shape.items));
      }
    }
    case "map": {
      if (!(data instanceof Map)) {
        throw new Error("Could not type cast to map.");
      }
      mapConstraints(data, shape);
      const map = /* @__PURE__ */ new Map();
      for (const [key, value] of data.entries()) {
        map.set(castFrom(key, shape.keys), castFrom(value, shape.values));
      }
      return map;
    }
    case void 0: {
      return data;
    }
  }
  throw new Error("Could not type cast data.");
}
function castTo(struct, type) {
  const shape = type;
  if (!shape) throw new Error("Could not type cast struct.");
  const shapeType = (shape.anyOf ? "enum" : "") || shape.dataType;
  switch (shapeType) {
    case "integer": {
      if (typeof struct !== "bigint") {
        throw new Error("Could not type cast to integer.");
      }
      integerConstraints(struct, shape);
      return struct;
    }
    case "bytes": {
      if (typeof struct !== "string") {
        throw new Error("Could not type cast to bytes.");
      }
      bytesConstraints(struct, shape);
      return struct;
    }
    case "constructor": {
      if (isVoid(shape)) {
        if (struct !== void 0) {
          throw new Error("Could not type cast to void.");
        }
        return new Constr(0, []);
      } else if (typeof struct !== "object" || struct === null || shape.fields.length !== Object.keys(struct).length) {
        throw new Error("Could not type cast to constructor.");
      }
      const fields = shape.fields.map(
        (field) => castTo(
          struct[field.title || "wrapper"],
          field
        )
      );
      return shape.hasConstr || shape.hasConstr === void 0 ? new Constr(shape.index, fields) : fields;
    }
    case "enum": {
      if (shape.anyOf.length === 1) {
        return castTo(struct, shape.anyOf[0]);
      }
      if (isBoolean(shape)) {
        if (typeof struct !== "boolean") {
          throw new Error("Could not type cast to boolean.");
        }
        return new Constr(struct ? 1 : 0, []);
      } else if (isNullable(shape)) {
        if (struct === null) return new Constr(1, []);
        else {
          const fields = shape.anyOf[0].fields;
          if (fields.length !== 1) {
            throw new Error("Could not type cast to nullable object.");
          }
          return new Constr(0, [castTo(struct, fields[0])]);
        }
      }
      switch (typeof struct) {
        case "string": {
          if (!/[A-Z]/.test(struct[0])) {
            throw new Error(
              "Could not type cast to enum. Enum needs to start with an uppercase letter."
            );
          }
          const enumIndex = shape.anyOf.findIndex(
            (s) => s.dataType === "constructor" && s.fields.length === 0 && s.title === struct
          );
          if (enumIndex === -1) throw new Error("Could not type cast to enum.");
          return new Constr(enumIndex, []);
        }
        case "object": {
          if (struct === null) throw new Error("Could not type cast to enum.");
          const structTitle = Object.keys(struct)[0];
          if (!/[A-Z]/.test(structTitle)) {
            throw new Error(
              "Could not type cast to enum. Enum needs to start with an uppercase letter."
            );
          }
          const enumEntry = shape.anyOf.find(
            (s) => s.dataType === "constructor" && s.title === structTitle
          );
          if (!enumEntry) throw new Error("Could not type cast to enum.");
          const args = struct[structTitle];
          return new Constr(
            enumEntry.index,
            // check if named args
            args instanceof Array ? args.map(
              (item, index) => castTo(item, enumEntry.fields[index])
            ) : enumEntry.fields.map((entry) => {
              const [_, item] = Object.entries(args).find(
                ([title]) => title === entry.title
              );
              return castTo(item, entry);
            })
          );
        }
      }
      throw new Error("Could not type cast to enum.");
    }
    case "list": {
      if (!(struct instanceof Array)) {
        throw new Error("Could not type cast to array/tuple.");
      }
      if (shape.items instanceof Array) {
        const fields = struct.map(
          (item, index) => castTo(item, shape.items[index])
        );
        return shape.hasConstr ? new Constr(0, fields) : fields;
      } else {
        listConstraints(struct, shape);
        return struct.map((item) => castTo(item, shape.items));
      }
    }
    case "map": {
      if (!(struct instanceof Map)) {
        throw new Error("Could not type cast to map.");
      }
      mapConstraints(struct, shape);
      const map = /* @__PURE__ */ new Map();
      for (const [key, value] of struct.entries()) {
        map.set(castTo(key, shape.keys), castTo(value, shape.values));
      }
      return map;
    }
    case void 0: {
      return struct;
    }
  }
  throw new Error("Could not type cast struct.");
}
function integerConstraints(integer, shape) {
  if (shape.minimum && integer < BigInt(shape.minimum)) {
    throw new Error(
      `Integer ${integer} is below the minimum ${shape.minimum}.`
    );
  }
  if (shape.maximum && integer > BigInt(shape.maximum)) {
    throw new Error(
      `Integer ${integer} is above the maxiumum ${shape.maximum}.`
    );
  }
  if (shape.exclusiveMinimum && integer <= BigInt(shape.exclusiveMinimum)) {
    throw new Error(
      `Integer ${integer} is below the exclusive minimum ${shape.exclusiveMinimum}.`
    );
  }
  if (shape.exclusiveMaximum && integer >= BigInt(shape.exclusiveMaximum)) {
    throw new Error(
      `Integer ${integer} is above the exclusive maximum ${shape.exclusiveMaximum}.`
    );
  }
}
function bytesConstraints(bytes, shape) {
  if (shape.enum && !shape.enum.some((keyword) => keyword === bytes))
    throw new Error(`None of the keywords match with '${bytes}'.`);
  if (shape.minLength && bytes.length / 2 < shape.minLength) {
    throw new Error(
      `Bytes need to have a length of at least ${shape.minLength} bytes.`
    );
  }
  if (shape.maxLength && bytes.length / 2 > shape.maxLength) {
    throw new Error(
      `Bytes can have a length of at most ${shape.minLength} bytes.`
    );
  }
}
function listConstraints(list, shape) {
  if (shape.minItems && list.length < shape.minItems) {
    throw new Error(`Array needs to contain at least ${shape.minItems} items.`);
  }
  if (shape.maxItems && list.length > shape.maxItems) {
    throw new Error(`Array can contain at most ${shape.maxItems} items.`);
  }
  if (shape.uniqueItems && new Set(list).size !== list.length) {
    throw new Error("Array constains duplicates.");
  }
}
function mapConstraints(map, shape) {
  if (shape.minItems && map.size < shape.minItems) {
    throw new Error(`Map needs to contain at least ${shape.minItems} items.`);
  }
  if (shape.maxItems && map.size > shape.maxItems) {
    throw new Error(`Map can contain at most ${shape.maxItems} items.`);
  }
}
function isBoolean(shape) {
  return shape.anyOf && shape.anyOf[0]?.title === "False" && shape.anyOf[1]?.title === "True";
}
function isVoid(shape) {
  return shape.index === 0 && shape.fields.length === 0;
}
function isNullable(shape) {
  return shape.anyOf && shape.anyOf[0]?.title === "Some" && shape.anyOf[1]?.title === "None";
}
function replaceProperties(object, properties) {
  Object.keys(object).forEach((key) => {
    delete object[key];
  });
  Object.assign(object, properties);
}

// src/index.ts
__reExport(src_exports, data_exports);

// src/time.ts
var SLOT_CONFIG_NETWORK = {
  Mainnet: { zeroTime: 1596059091e3, zeroSlot: 4492800, slotLength: 1e3 },
  // Starting at Shelley era
  Preview: { zeroTime: 1666656e6, zeroSlot: 0, slotLength: 1e3 },
  // Starting at Shelley era
  Preprod: {
    zeroTime: 16540416e5 + 1728e6,
    zeroSlot: 86400,
    slotLength: 1e3
  },
  // Starting at Shelley era
  /** Customizable slot config (Initialized with 0 values). */
  Custom: { zeroTime: 0, zeroSlot: 0, slotLength: 0 }
};
function slotToBeginUnixTime(slot, slotConfig) {
  const msAfterBegin = (slot - slotConfig.zeroSlot) * slotConfig.slotLength;
  return slotConfig.zeroTime + msAfterBegin;
}
function unixTimeToEnclosingSlot(unixTime, slotConfig) {
  const timePassed = unixTime - slotConfig.zeroTime;
  const slotsPassed = Math.floor(timePassed / slotConfig.slotLength);
  return slotsPassed + slotConfig.zeroSlot;
}


__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 88464:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G2": function() { return /* binding */ Emulator; },
/* harmony export */   "sn": function() { return /* binding */ Blockfrost; }
/* harmony export */ });
/* unused harmony exports Koios, KoiosError, Kupmios, KupmiosError, Maestro, generateEmulatorAccount, generateEmulatorAccountFromPrivateKey */
/* harmony import */ var _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82381);
/* harmony import */ var _lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34837);
/* harmony import */ var _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87830);
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17316);
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53959);
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21566);
/* harmony import */ var effect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39838);
/* harmony import */ var _lucid_evolution_wallet__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8713);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__, _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__, _lucid_evolution_wallet__WEBPACK_IMPORTED_MODULE_7__]);
([_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__, _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__, _lucid_evolution_wallet__WEBPACK_IMPORTED_MODULE_7__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
// src/core.ts


// src/blockfrost.ts



// package.json
var package_default = {
  name: "@lucid-evolution/provider",
  version: "0.1.89",
  description: "",
  main: "./dist/index.js",
  types: "./dist/index.d.ts",
  type: "module",
  exports: {
    ".": {
      require: "./dist/index.cjs",
      import: "./dist/index.js",
      types: "./dist/index.d.ts"
    }
  },
  files: [
    "dist"
  ],
  publishConfig: {
    access: "public"
  },
  scripts: {
    build: "tsup src/index.ts --format esm,cjs --dts --clean",
    clean: "rm -rf .turbo && rm -rf node_modules && rm -rf dist",
    test: "vitest run"
  },
  keywords: [],
  author: "",
  license: "MIT",
  browser: {
    "@anastasia-labs/cardano-multiplatform-lib-nodejs": "@anastasia-labs/cardano-multiplatform-lib-browser"
  },
  dependencies: {
    "@anastasia-labs/cardano-multiplatform-lib-browser": "6.0.2-3",
    "@anastasia-labs/cardano-multiplatform-lib-nodejs": "6.0.2-3",
    "@effect/platform": "^0.71.3",
    "@effect/schema": "^0.68.26",
    "@lucid-evolution/core-types": "workspace:*",
    "@lucid-evolution/core-utils": "workspace:*",
    "@lucid-evolution/utils": "workspace:*",
    "@lucid-evolution/wallet": "workspace:*",
    effect: "^3.11.7"
  },
  devDependencies: {
    "@types/node": "^20.12.8",
    tsup: "^8.0.2",
    typescript: "^5.4.5",
    vitest: "^2.0.4"
  }
};

// src/internal/blockfrost.ts


var toAditionalUTXOs = (utxos) => (utxos || []).map((utxo) => [
  {
    txId: utxo.txHash,
    index: utxo.outputIndex
  },
  {
    address: utxo.address,
    value: {
      coins: Number(utxo.assets["lovelace"]),
      assets: fromAssets(utxo.assets)
    },
    datumHash: utxo.datumHash,
    datum: utxo.datum,
    script: toTxOutScript(utxo.scriptRef)
  }
]);
var toTxOutScript = (scriptRef) => {
  if (scriptRef) {
    switch (scriptRef.type) {
      case "PlutusV1":
        return { "plutus:v1": (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .applySingleCborEncoding */ .wt)(scriptRef.script) };
      case "PlutusV2":
        return { "plutus:v2": (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .applySingleCborEncoding */ .wt)(scriptRef.script) };
      case "PlutusV3":
        return { "plutus:v3": (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .applySingleCborEncoding */ .wt)(scriptRef.script) };
      default:
        return void 0;
    }
  }
};
var fromAssets = (assets) => (0,effect__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(
  effect__WEBPACK_IMPORTED_MODULE_4__/* .remove */ .Od(assets, "lovelace"),
  effect__WEBPACK_IMPORTED_MODULE_4__/* .mapEntries */ .V7((amount, unit) => [
    unit.length === 56 ? unit.slice(0, 56) : unit.slice(0, 56) + "." + unit.slice(56),
    Number(amount)
  ]),
  (r) => effect__WEBPACK_IMPORTED_MODULE_4__/* .isEmptyRecord */ .sG(r) ? void 0 : r
);
var fromLegacyRedeemerTag = (redeemerTag) => {
  switch (redeemerTag) {
    case "certificate":
      return "publish";
    case "withdrawal":
      return "withdraw";
    default:
      return redeemerTag;
  }
};

// src/blockfrost.ts
var Blockfrost = class {
  url;
  projectId;
  constructor(url, projectId) {
    this.url = url;
    this.projectId = projectId || "";
  }
  async getProtocolParameters() {
    const result = await fetch(`${this.url}/epochs/latest/parameters`, {
      headers: { project_id: this.projectId, lucid }
    }).then((res) => res.json());
    return {
      minFeeA: parseInt(result.min_fee_a),
      minFeeB: parseInt(result.min_fee_b),
      maxTxSize: parseInt(result.max_tx_size),
      maxValSize: parseInt(result.max_val_size),
      keyDeposit: BigInt(result.key_deposit),
      poolDeposit: BigInt(result.pool_deposit),
      drepDeposit: BigInt(result.drep_deposit),
      govActionDeposit: BigInt(result.gov_action_deposit),
      priceMem: parseFloat(result.price_mem),
      priceStep: parseFloat(result.price_step),
      maxTxExMem: BigInt(result.max_tx_ex_mem),
      maxTxExSteps: BigInt(result.max_tx_ex_steps),
      coinsPerUtxoByte: BigInt(result.coins_per_utxo_size),
      collateralPercentage: parseInt(result.collateral_percent),
      maxCollateralInputs: parseInt(result.max_collateral_inputs),
      minFeeRefScriptCostPerByte: parseInt(
        result.min_fee_ref_script_cost_per_byte
      ),
      costModels: result.cost_models
    };
  }
  async getUtxos(addressOrCredential) {
    const queryPredicate = (() => {
      if (typeof addressOrCredential === "string") return addressOrCredential;
      const credentialBech32 = addressOrCredential.type === "Key" ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_hex */ ._Wl.from_hex(addressOrCredential.hash).to_bech32(
        "addr_vkh"
      ) : _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ScriptHash.from_hex */ .nJe.from_hex(addressOrCredential.hash).to_bech32(
        "addr_vkh"
      );
      return credentialBech32;
    })();
    let result = [];
    let page = 1;
    while (true) {
      const pageResult = await fetch(
        `${this.url}/addresses/${queryPredicate}/utxos?page=${page}`,
        { headers: { project_id: this.projectId, lucid } }
      ).then((res) => res.json());
      if (pageResult.error) {
        if (pageResult.status_code === 404) {
          return [];
        } else {
          throw new Error("Could not fetch UTxOs from Blockfrost. Try again.");
        }
      }
      result = result.concat(pageResult);
      if (pageResult.length <= 0) break;
      page++;
    }
    return this.blockfrostUtxosToUtxos(result);
  }
  async getUtxosWithUnit(addressOrCredential, unit) {
    const queryPredicate = (() => {
      if (typeof addressOrCredential === "string") return addressOrCredential;
      const credentialBech32 = addressOrCredential.type === "Key" ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_hex */ ._Wl.from_hex(addressOrCredential.hash).to_bech32(
        "addr_vkh"
      ) : _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ScriptHash.from_hex */ .nJe.from_hex(addressOrCredential.hash).to_bech32(
        "addr_vkh"
      );
      return credentialBech32;
    })();
    let result = [];
    let page = 1;
    while (true) {
      const pageResult = await fetch(
        `${this.url}/addresses/${queryPredicate}/utxos/${unit}?page=${page}`,
        { headers: { project_id: this.projectId, lucid } }
      ).then((res) => res.json());
      if (pageResult.error) {
        if (pageResult.status_code === 404) {
          return [];
        } else {
          throw new Error("Could not fetch UTxOs from Blockfrost. Try again.");
        }
      }
      result = result.concat(pageResult);
      if (pageResult.length <= 0) break;
      page++;
    }
    return this.blockfrostUtxosToUtxos(result);
  }
  async getUtxoByUnit(unit) {
    const addresses = await fetch(
      `${this.url}/assets/${unit}/addresses?count=2`,
      { headers: { project_id: this.projectId, lucid } }
    ).then((res) => res.json());
    if (!addresses || addresses.error) {
      throw new Error("Unit not found.");
    }
    if (addresses.length > 1) {
      throw new Error("Unit needs to be an NFT or only held by one address.");
    }
    const address = addresses[0].address;
    const utxos = await this.getUtxosWithUnit(address, unit);
    if (utxos.length > 1) {
      throw new Error("Unit needs to be an NFT or only held by one address.");
    }
    return utxos[0];
  }
  async getUtxosByOutRef(outRefs) {
    const queryHashes = [...new Set(outRefs.map((outRef) => outRef.txHash))];
    const utxos = await Promise.all(
      queryHashes.map(async (txHash) => {
        const result = await fetch(`${this.url}/txs/${txHash}/utxos`, {
          headers: { project_id: this.projectId, lucid }
        }).then((res) => res.json());
        if (!result || result.error) {
          return [];
        }
        const utxosResult = result.outputs.map(
          (r) => ({
            ...r,
            tx_hash: txHash
          })
        );
        return this.blockfrostUtxosToUtxos(utxosResult);
      })
    );
    return utxos.reduce((acc, utxos2) => acc.concat(utxos2), []).filter(
      (utxo) => outRefs.some(
        (outRef) => utxo.txHash === outRef.txHash && utxo.outputIndex === outRef.outputIndex
      )
    );
  }
  async getDelegation(rewardAddress) {
    const result = await fetch(`${this.url}/accounts/${rewardAddress}`, {
      headers: { project_id: this.projectId, lucid }
    }).then((res) => res.json());
    if (!result || result.error) {
      return { poolId: null, rewards: 0n };
    }
    return {
      poolId: result.pool_id || null,
      rewards: BigInt(result.withdrawable_amount)
    };
  }
  async getDatum(datumHash) {
    const datum = await fetch(`${this.url}/scripts/datum/${datumHash}/cbor`, {
      headers: { project_id: this.projectId, lucid }
    }).then((res) => res.json()).then((res) => res.cbor);
    if (!datum || datum.error) {
      throw new Error(`No datum found for datum hash: ${datumHash}`);
    }
    return datum;
  }
  awaitTx(txHash, checkInterval = 3e3) {
    return new Promise((res) => {
      const confirmation = setInterval(async () => {
        const isConfirmed = await fetch(`${this.url}/txs/${txHash}/cbor`, {
          headers: { project_id: this.projectId, lucid }
        }).then((res2) => res2.json());
        if (isConfirmed && !isConfirmed.error) {
          clearInterval(confirmation);
          await new Promise((res2) => setTimeout(() => res2(1), 1e3));
          return res(true);
        }
      }, checkInterval);
    });
  }
  async submitTx(tx) {
    const result = await fetch(`${this.url}/tx/submit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/cbor",
        project_id: this.projectId,
        lucid
      },
      body: (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(tx)
    }).then((res) => res.json());
    if (!result || result.error) {
      if (result?.status_code === 400) throw new Error(result.message);
      else throw new Error("Could not submit transaction.");
    }
    return result;
  }
  async blockfrostUtxosToUtxos(result) {
    const utxos = [];
    const batchSize = 10;
    let count = 0;
    for (let i = 0; i < result.length; i += batchSize) {
      const batch = result.slice(i, i + batchSize);
      count += batchSize;
      await handleRateLimit(count);
      const batchResults = await Promise.all(
        batch.map(async (r) => {
          return {
            txHash: r.tx_hash,
            outputIndex: r.output_index,
            assets: Object.fromEntries(
              r.amount.map(({ unit, quantity }) => [unit, BigInt(quantity)])
            ),
            address: r.address,
            datumHash: !r.inline_datum && r.data_hash || void 0,
            datum: r.inline_datum || void 0,
            scriptRef: r.reference_script_hash ? await (async () => {
              const { type } = await fetch(
                `${this.url}/scripts/${r.reference_script_hash}`,
                {
                  headers: { project_id: this.projectId, lucid }
                }
              ).then((res) => res.json());
              const { cbor: script } = await fetch(
                `${this.url}/scripts/${r.reference_script_hash}/cbor`,
                { headers: { project_id: this.projectId, lucid } }
              ).then((res) => res.json());
              switch (type) {
                case "timelock":
                  const { json: native } = await fetch(
                    `${this.url}/scripts/${r.reference_script_hash}/json`,
                    { headers: { project_id: this.projectId, lucid } }
                  ).then((res) => res.json());
                  return (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .scriptFromNative */ .jC)(native);
                case "plutusV1":
                  return {
                    type: "PlutusV1",
                    script: (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .applyDoubleCborEncoding */ .EE)(script)
                  };
                case "plutusV2":
                  return {
                    type: "PlutusV2",
                    script: (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .applyDoubleCborEncoding */ .EE)(script)
                  };
                case "plutusV3":
                  return {
                    type: "PlutusV3",
                    script: (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .applyDoubleCborEncoding */ .EE)(script)
                  };
              }
            })() : void 0
          };
        })
      );
      utxos.push(...batchResults);
    }
    return utxos;
  }
  async evaluateTx(tx, additionalUTxOs) {
    const payload = {
      cbor: tx,
      additionalUtxoSet: toAditionalUTXOs(additionalUTxOs)
    };
    const res = await fetch(`${this.url}/utils/txs/evaluate/utxos`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        project_id: this.projectId,
        lucid
      },
      body: JSON.stringify(payload)
    }).then((res2) => res2.json());
    if (!res || res.fault) {
      const message = res?.status_code === 400 ? res.message : `Could not evaluate the transaction: ${JSON.stringify(res)}. Transaction: ${tx}`;
      throw new Error(message);
    }
    const blockfrostRedeemer = res;
    if (!("EvaluationResult" in blockfrostRedeemer.result)) {
      throw new Error(
        `EvaluateTransaction fails: ${JSON.stringify(blockfrostRedeemer.result)}`
      );
    }
    const evalRedeemers = [];
    Object.entries(blockfrostRedeemer.result.EvaluationResult).forEach(
      ([redeemerPointer, data]) => {
        const [pTag, pIndex] = redeemerPointer.split(":");
        evalRedeemers.push({
          redeemer_tag: fromLegacyRedeemerTag(
            pTag
          ),
          redeemer_index: Number(pIndex),
          ex_units: { mem: Number(data.memory), steps: Number(data.steps) }
        });
      }
    );
    return evalRedeemers;
  }
};
var handleRateLimit = async (count) => {
  if (count % 100 === 0) {
    await (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .sleep */ ._v)(5e3);
  } else if (count % 10 === 0) {
    await (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .sleep */ ._v)(500);
  }
};
var lucid = package_default.version;

// src/kupmios.ts




// src/internal/ogmios.ts


var JSONRPCSchema = (schema) => S.Struct({
  jsonrpc: S.String,
  method: S.optional(S.String),
  id: S.NullOr(S.Number),
  result: schema
}).annotations({ identifier: "JSONRPCSchema" });
var LovelaceAsset = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  lovelace: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_
});
var TupleNumberFromString = effect__WEBPACK_IMPORTED_MODULE_5__/* .compose */ .qCK(
  effect__WEBPACK_IMPORTED_MODULE_5__/* .split */ .Vl2("/"),
  effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(effect__WEBPACK_IMPORTED_MODULE_5__/* .NumberFromString */ ._Li)
);
var ProtocolParametersSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  minFeeCoefficient: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  minFeeReferenceScripts: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    base: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
    range: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
    multiplier: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_
  }),
  maxReferenceScriptsSize: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    bytes: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_
  }),
  stakePoolVotingThresholds: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    noConfidence: TupleNumberFromString,
    constitutionalCommittee: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
      default: TupleNumberFromString,
      stateOfNoConfidence: TupleNumberFromString
    }),
    hardForkInitiation: TupleNumberFromString,
    protocolParametersUpdate: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
      security: TupleNumberFromString
    })
  }),
  delegateRepresentativeVotingThresholds: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    noConfidence: TupleNumberFromString,
    constitutionalCommittee: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
      default: TupleNumberFromString,
      stateOfNoConfidence: TupleNumberFromString
    }),
    constitution: TupleNumberFromString,
    hardForkInitiation: TupleNumberFromString,
    protocolParametersUpdate: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
      network: TupleNumberFromString,
      economic: TupleNumberFromString,
      technical: TupleNumberFromString,
      governance: TupleNumberFromString
    }),
    treasuryWithdrawals: TupleNumberFromString
  }),
  constitutionalCommitteeMinSize: effect__WEBPACK_IMPORTED_MODULE_5__/* .optional */ .jtO(effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_),
  constitutionalCommitteeMaxTermLength: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  governanceActionLifetime: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  governanceActionDeposit: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    ada: LovelaceAsset
  }),
  delegateRepresentativeDeposit: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    ada: LovelaceAsset
  }),
  delegateRepresentativeMaxIdleTime: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  minFeeConstant: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ ada: LovelaceAsset }),
  maxBlockBodySize: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ bytes: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_ }),
  maxBlockHeaderSize: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ bytes: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_ }),
  maxTransactionSize: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ bytes: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_ }),
  stakeCredentialDeposit: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ ada: LovelaceAsset }),
  stakePoolDeposit: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ ada: LovelaceAsset }),
  stakePoolRetirementEpochBound: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  desiredNumberOfStakePools: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  stakePoolPledgeInfluence: TupleNumberFromString,
  monetaryExpansion: TupleNumberFromString,
  treasuryExpansion: TupleNumberFromString,
  minStakePoolCost: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ ada: LovelaceAsset }),
  minUtxoDepositConstant: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ ada: LovelaceAsset }),
  minUtxoDepositCoefficient: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  plutusCostModels: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    "plutus:v1": effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_),
    "plutus:v2": effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_),
    "plutus:v3": effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_)
  }),
  scriptExecutionPrices: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    memory: TupleNumberFromString,
    cpu: TupleNumberFromString
  }),
  maxExecutionUnitsPerTransaction: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    memory: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
    cpu: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_
  }),
  maxExecutionUnitsPerBlock: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ memory: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_, cpu: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_ }),
  maxValueSize: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ bytes: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_ }),
  collateralPercentage: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  maxCollateralInputs: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  version: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ major: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_, minor: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_ })
}).annotations({ identifier: "ProtocolParametersSchema" });
var Delegation = effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(
  effect__WEBPACK_IMPORTED_MODULE_5__/* .Record */ .WVy({
    key: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
    value: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
      delegate: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ id: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9 }),
      rewards: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ ada: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ lovelace: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_ }) }),
      deposit: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ ada: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ lovelace: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_ }) })
    })
  })
);
var RedeemerSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  validator: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    purpose: effect__WEBPACK_IMPORTED_MODULE_5__/* .Literal */ .t$L(
      "spend",
      "mint",
      "publish",
      "withdraw",
      "vote",
      "propose"
    ),
    index: effect__WEBPACK_IMPORTED_MODULE_5__/* .Int */ .J7n
  }),
  budget: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    memory: effect__WEBPACK_IMPORTED_MODULE_5__/* .Int */ .J7n,
    cpu: effect__WEBPACK_IMPORTED_MODULE_5__/* .Int */ .J7n
  })
}).annotations({ identifier: "RedeemerSchema" });
var toOgmiosUTxOs = (utxos) => {
  const toOgmiosScript = (scriptRef) => {
    if (scriptRef) {
      switch (scriptRef.type) {
        case "PlutusV1":
          return {
            language: "plutus:v1",
            cbor: applySingleCborEncoding2(scriptRef.script)
          };
        case "PlutusV2":
          return {
            language: "plutus:v2",
            cbor: applySingleCborEncoding2(scriptRef.script)
          };
        case "PlutusV3":
          return {
            language: "plutus:v3",
            cbor: applySingleCborEncoding2(scriptRef.script)
          };
        default:
          return null;
      }
    }
  };
  const toOgmiosAssets = (assets) => {
    const newAssets = {};
    Object.entries(assets).forEach(([unit, amount]) => {
      if (unit == "lovelace") return;
      const { policyId, assetName } = fromUnit(unit);
      if (!newAssets[policyId]) {
        newAssets[policyId] = {};
      }
      return newAssets[policyId][assetName ? assetName : ""] = Number(amount);
    });
    return newAssets;
  };
  return (utxos || []).map(
    (utxo) => ({
      transaction: {
        id: utxo.txHash
      },
      index: utxo.outputIndex,
      address: utxo.address,
      value: {
        ada: { lovelace: Number(utxo.assets["lovelace"]) },
        ...toOgmiosAssets(utxo.assets)
      },
      datumHash: utxo.datumHash,
      datum: utxo.datum,
      script: toOgmiosScript(utxo.scriptRef)
    })
  );
};

// src/internal/kupo.ts

var ValueSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  coins: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  assets: effect__WEBPACK_IMPORTED_MODULE_5__/* .Record */ .WVy({ key: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9, value: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_ })
});
var UTxOSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  transaction_index: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  transaction_id: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  output_index: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  address: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  value: ValueSchema,
  datum_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  datum_type: effect__WEBPACK_IMPORTED_MODULE_5__/* .optional */ .jtO(effect__WEBPACK_IMPORTED_MODULE_5__/* .Literal */ .t$L("hash", "inline")),
  script_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  created_at: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    slot_no: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
    header_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9
  }),
  spent_at: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(
    effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
      slot_no: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
      header_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9
    })
  )
});
var ScriptSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(
  effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    language: effect__WEBPACK_IMPORTED_MODULE_5__/* .Literal */ .t$L("native", "plutus:v1", "plutus:v2", "plutus:v3"),
    script: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9
  })
);
var DatumSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ datum: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9 }));
var DelegationSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(
  effect__WEBPACK_IMPORTED_MODULE_5__/* .Record */ .WVy({
    key: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
    value: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
      delegate: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ id: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9 }),
      rewards: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ ada: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ lovelace: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_ }) }),
      deposit: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ ada: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({ lovelace: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_ }) })
    })
  })
);

// src/internal/HttpUtils.ts


var filterStatusOk = (self) => self.status >= 200 && self.status < 300 ? Effect.succeed(self) : self.text.pipe(
  Effect.flatMap(
    (text) => Effect.fail(
      new HttpClientError.ResponseError({
        response: self,
        request: self.request,
        reason: "StatusCode",
        description: `non 2xx status code : ${text}`
      })
    )
  )
);
var makeGet = (url, schema, headers) => pipe2(
  // Initiate a GET request to the specified URL
  HttpClientRequest.get(url),
  // Conditional bearer token authentication
  headers ? HttpClientRequest.setHeaders(headers) : identity,
  // Execute the HTTP request and retrieve the response
  HttpClient.execute,
  // Ensure only 2xx responses are treated as successes.
  Effect.flatMap(filterStatusOk),
  // Parse the response body using the provided JSON schema
  // This validates and transforms the response to the expected type
  Effect.flatMap(HttpClientResponse.schemaBodyJson(schema)),
  // Ensure request is aborted if the program is interrupted
  // Prevents resource leaks and ensures clean request termination
  Effect.scoped
);
var makePostAsJson = (url, data, schema, headers) => pipe2(
  // Initiate a POST request to the specified URL
  HttpClientRequest.post(url),
  // Conditional headers
  headers ? HttpClientRequest.setHeaders(headers) : identity,
  // Set the request body as Json
  HttpClientRequest.bodyJson(data),
  // Execute the HTTP request and retrieve the response
  Effect.flatMap(HttpClient.execute),
  // Ensure only 2xx responses are treated as successes.
  Effect.flatMap(filterStatusOk),
  // Parse the response body using the provided JSON schema
  // This validates and transforms the response to the expected type
  Effect.flatMap(HttpClientResponse.schemaBodyJson(schema)),
  // Ensure request is aborted if the program is interrupted
  // Prevents resource leaks and ensures clean request termination
  Effect.scoped
);
var makePostAsUint8Array = (url, data, schema, headers) => pipe2(
  // Initiate a POST request to the specified URL
  HttpClientRequest.post(url),
  // Conditional bearer token authentication
  headers ? HttpClientRequest.setHeaders(headers) : identity,
  // Set the request body as a Uint8Array with CBOR content type
  HttpClientRequest.bodyUint8Array(data, "application/cbor"),
  // Execute the HTTP request and retrieve the response
  HttpClient.execute,
  // Ensure only 2xx responses are treated as successes.
  Effect.flatMap(filterStatusOk),
  // Parse the response body using the provided JSON schema
  // This validates and transforms the response to the expected type
  Effect.flatMap(HttpClientResponse.schemaBodyJson(schema)),
  // Ensure request is aborted if the program is interrupted
  // Prevents resource leaks and ensures clean request termination
  Effect.scoped
);

// src/kupmios.ts

var KupmiosError = class extends effect__WEBPACK_IMPORTED_MODULE_6__/* .TaggedError */ .fZ("KupmiosError") {
  get message() {
    return `${this.cause}`;
  }
};
var Kupmios = class {
  kupoUrl;
  ogmiosUrl;
  headers;
  constructor(kupoUrl, ogmiosUrl, headers) {
    this.kupoUrl = kupoUrl;
    this.ogmiosUrl = ogmiosUrl;
    this.headers = headers;
  }
  async getProtocolParameters() {
    const data = {
      jsonrpc: "2.0",
      method: "queryLedgerState/protocolParameters",
      params: {},
      id: null
    };
    const schema = JSONRPCSchema(ProtocolParametersSchema);
    const { result } = await pipe3(
      makePostAsJson(
        this.ogmiosUrl,
        data,
        schema,
        this.headers?.ogmiosHeader
      ),
      Effect2.timeout(1e4),
      Effect2.catchAll((cause) => new KupmiosError({ cause })),
      Effect2.provide(FetchHttpClient.layer),
      Effect2.runPromise
    );
    return toProtocolParameters(result);
  }
  async getUtxos(addressOrCredential) {
    const isAddress = typeof addressOrCredential === "string";
    const queryPredicate = isAddress ? addressOrCredential : addressOrCredential.hash;
    const pattern = `${this.kupoUrl}/matches/${queryPredicate}${isAddress ? "" : "/*"}?unspent`;
    const schema = S3.Array(UTxOSchema);
    const utxos = await pipe3(
      makeGet(pattern, schema, this.headers?.kupoHeader),
      Effect2.flatMap((u) => kupmiosUtxosToUtxos(this.kupoUrl, u)),
      Effect2.timeout(1e4),
      Effect2.catchAll((cause) => new KupmiosError({ cause })),
      Effect2.provide(FetchHttpClient.layer),
      Effect2.runPromise
    );
    return utxos;
  }
  async getUtxosWithUnit(addressOrCredential, unit) {
    const isAddress = typeof addressOrCredential === "string";
    const queryPredicate = isAddress ? addressOrCredential : addressOrCredential.hash;
    const { policyId, assetName } = fromUnit2(unit);
    const pattern = `${this.kupoUrl}/matches/${queryPredicate}${isAddress ? "" : "/*"}?unspent&policy_id=${policyId}${assetName ? `&asset_name=${assetName}` : ""}`;
    const schema = S3.Array(UTxOSchema);
    const utxos = await pipe3(
      makeGet(pattern, schema, this.headers?.kupoHeader),
      Effect2.flatMap((u) => kupmiosUtxosToUtxos(this.kupoUrl, u)),
      Effect2.timeout(1e4),
      Effect2.catchAll((cause) => new KupmiosError({ cause })),
      Effect2.provide(FetchHttpClient.layer),
      Effect2.runPromise
    );
    return utxos;
  }
  async getUtxoByUnit(unit) {
    const { policyId, assetName } = fromUnit2(unit);
    const pattern = `${this.kupoUrl}/matches/${policyId}.${assetName ? `${assetName}` : "*"}?unspent`;
    const schema = S3.Array(UTxOSchema);
    const utxos = await pipe3(
      makeGet(pattern, schema, this.headers?.kupoHeader),
      Effect2.flatMap((u) => kupmiosUtxosToUtxos(this.kupoUrl, u)),
      Effect2.timeout(1e4),
      Effect2.catchAll((cause) => new KupmiosError({ cause })),
      Effect2.provide(FetchHttpClient.layer),
      Effect2.runPromise
    );
    if (utxos.length > 1) {
      throw new Error("Unit needs to be an NFT or only held by one address.");
    }
    return utxos[0];
  }
  async getUtxosByOutRef(outRefs) {
    const queryHashes = [
      ...new Set(outRefs.map((outRef) => outRef.txHash))
    ];
    const mkPattern = (txHash) => `${this.kupoUrl}/matches/*@${txHash}?unspent`;
    const schema = S3.Array(UTxOSchema);
    const program = Effect2.forEach(
      queryHashes,
      (txHash) => pipe3(
        makeGet(mkPattern(txHash), schema, this.headers?.kupoHeader),
        Effect2.flatMap((u) => kupmiosUtxosToUtxos(this.kupoUrl, u)),
        Effect2.timeout(1e4),
        Effect2.catchAll((cause) => new KupmiosError({ cause }))
      )
    );
    const utxos = await Effect2.runPromise(
      pipe3(program, Effect2.provide(FetchHttpClient.layer))
    );
    return _Array.flatten(utxos).filter(
      (utxo) => outRefs.some(
        (outRef) => utxo.txHash === outRef.txHash && utxo.outputIndex === outRef.outputIndex
      )
    );
  }
  async getDelegation(rewardAddress) {
    const data = {
      jsonrpc: "2.0",
      method: "queryLedgerState/rewardAccountSummaries",
      params: { keys: [rewardAddress] },
      id: null
    };
    const schema = JSONRPCSchema(Delegation);
    const { result } = await pipe3(
      makePostAsJson(
        this.ogmiosUrl,
        data,
        schema,
        this.headers?.ogmiosHeader
      ),
      Effect2.provide(FetchHttpClient.layer),
      Effect2.timeout(1e4),
      Effect2.catchAll((cause) => new KupmiosError({ cause })),
      Effect2.runPromise
    );
    const delegation = result ? Object.values(result)[0] : null;
    return {
      poolId: delegation?.delegate?.id || null,
      rewards: BigInt(delegation?.rewards?.ada?.lovelace || 0)
    };
  }
  async getDatum(datumHash) {
    const pattern = `${this.kupoUrl}/datums/${datumHash}`;
    const schema = DatumSchema;
    const result = await pipe3(
      makeGet(pattern, schema, this.headers?.kupoHeader),
      Effect2.provide(FetchHttpClient.layer),
      Effect2.timeout(1e4),
      Effect2.flatMap(Effect2.fromNullable),
      Effect2.catchAll((cause) => new KupmiosError({ cause })),
      Effect2.runPromise
    );
    return result.datum;
  }
  async awaitTx(txHash, checkInterval = 2e4) {
    const pattern = `${this.kupoUrl}/matches/*@${txHash}?unspent`;
    const schema = S3.Array(UTxOSchema).annotations({
      identifier: "Array<KupmiosSchema.KupoUTxO>"
    });
    const result = await pipe3(
      makeGet(pattern, schema, this.headers?.kupoHeader),
      Effect2.provide(FetchHttpClient.layer),
      Effect2.repeat({
        schedule: Schedule.exponential(checkInterval),
        until: (result2) => result2.length > 0
      }),
      Effect2.timeout(16e4),
      Effect2.catchAll((cause) => new KupmiosError({ cause })),
      Effect2.as(true),
      Effect2.runPromise
    );
    return result;
  }
  async submitTx(cbor) {
    const data = {
      jsonrpc: "2.0",
      method: "submitTransaction",
      params: {
        transaction: { cbor }
      },
      id: null
    };
    const schema = JSONRPCSchema(
      S3.Struct({
        transaction: S3.Struct({
          id: S3.String
        })
      })
    );
    const { result } = await pipe3(
      makePostAsJson(
        this.ogmiosUrl,
        data,
        schema,
        this.headers?.ogmiosHeader
      ),
      Effect2.provide(FetchHttpClient.layer),
      Effect2.timeout(1e4),
      Effect2.catchAll((cause) => new KupmiosError({ cause })),
      Effect2.runPromise
    );
    return result.transaction.id;
  }
  async evaluateTx(tx, additionalUTxOs) {
    const data = {
      jsonrpc: "2.0",
      method: "evaluateTransaction",
      params: {
        transaction: { cbor: tx },
        additionalUtxo: toOgmiosUTxOs(additionalUTxOs)
      },
      id: null
    };
    const schema = JSONRPCSchema(S3.Array(RedeemerSchema));
    const { result } = await pipe3(
      makePostAsJson(
        this.ogmiosUrl,
        data,
        schema,
        this.headers?.ogmiosHeader
      ),
      Effect2.provide(FetchHttpClient.layer),
      Effect2.timeout(1e4),
      Effect2.catchAll((cause) => new KupmiosError({ cause })),
      Effect2.runPromise
    );
    const evalRedeemers = result.map((item) => ({
      ex_units: {
        mem: item.budget.memory,
        steps: item.budget.cpu
      },
      redeemer_index: item.validator.index,
      redeemer_tag: item.validator.purpose
    }));
    return evalRedeemers;
  }
};
var getDatumEffect = (kupoUrl, datum_type, datum_hash, kupoHeader) => Effect2.gen(function* () {
  if (datum_type === "inline" && datum_hash) {
    const pattern = `${kupoUrl}/datums/${datum_hash}`;
    const schema = DatumSchema;
    return yield* pipe3(
      makeGet(pattern, schema, kupoHeader),
      Effect2.flatMap(Effect2.fromNullable),
      Effect2.map((result) => result.datum),
      Effect2.retry(
        Schedule.compose(Schedule.exponential(50), Schedule.recurs(5))
      ),
      Effect2.timeout(5e3)
    );
  } else return void 0;
});
var getScriptEffect = (kupoUrl, script_hash, kupoHeader) => Effect2.gen(function* () {
  if (script_hash) {
    const pattern = `${kupoUrl}/scripts/${script_hash}`;
    const schema = ScriptSchema;
    return yield* pipe3(
      makeGet(pattern, schema, kupoHeader),
      Effect2.flatMap(Effect2.fromNullable),
      Effect2.retry(
        Schedule.compose(Schedule.exponential(50), Schedule.recurs(5))
      ),
      Effect2.timeout(5e3),
      Effect2.map(({ language, script }) => {
        switch (language) {
          case "native":
            return {
              type: "Native",
              script
            };
          case "plutus:v1":
            return {
              type: "PlutusV1",
              script: applyDoubleCborEncoding2(script)
            };
          case "plutus:v2":
            return {
              type: "PlutusV2",
              script: applyDoubleCborEncoding2(script)
            };
          case "plutus:v3":
            return {
              type: "PlutusV3",
              script: applyDoubleCborEncoding2(script)
            };
        }
      })
    );
  } else return void 0;
});
var toAssets = (value) => {
  const assets = { lovelace: BigInt(value.coins) };
  for (const unit of Object.keys(value.assets)) {
    assets[unit.replace(".", "")] = BigInt(value.assets[unit]);
  }
  return assets;
};
var toProtocolParameters = (result) => {
  return {
    minFeeA: result.minFeeCoefficient,
    minFeeB: result.minFeeConstant.ada.lovelace,
    maxTxSize: result.maxTransactionSize.bytes,
    maxValSize: result.maxValueSize.bytes,
    keyDeposit: BigInt(result.stakeCredentialDeposit.ada.lovelace),
    poolDeposit: BigInt(result.stakePoolDeposit.ada.lovelace),
    drepDeposit: BigInt(result.delegateRepresentativeDeposit.ada.lovelace),
    govActionDeposit: BigInt(result.governanceActionDeposit.ada.lovelace),
    priceMem: result.scriptExecutionPrices.memory[0] / result.scriptExecutionPrices.memory[1],
    priceStep: result.scriptExecutionPrices.cpu[0] / result.scriptExecutionPrices.cpu[1],
    maxTxExMem: BigInt(result.maxExecutionUnitsPerTransaction.memory),
    maxTxExSteps: BigInt(result.maxExecutionUnitsPerTransaction.cpu),
    // NOTE: coinsPerUtxoByte is now called utxoCostPerByte:
    // https://github.com/IntersectMBO/cardano-node/pull/4141
    // Ogmios v6.x calls it minUtxoDepositCoefficient according to the following
    // documentation from its protocol parameters data model:
    // https://github.com/CardanoSolutions/ogmios/blob/master/architectural-decisions/accepted/017-api-version-6-major-rewrite.md#protocol-parameters
    coinsPerUtxoByte: BigInt(result.minUtxoDepositCoefficient),
    collateralPercentage: result.collateralPercentage,
    maxCollateralInputs: result.maxCollateralInputs,
    minFeeRefScriptCostPerByte: result.minFeeReferenceScripts.base,
    costModels: {
      PlutusV1: Object.fromEntries(
        result.plutusCostModels["plutus:v1"].map((value, index) => [
          index.toString(),
          value
        ])
      ),
      PlutusV2: Object.fromEntries(
        result.plutusCostModels["plutus:v2"].map((value, index) => [
          index.toString(),
          value
        ])
      ),
      PlutusV3: Object.fromEntries(
        result.plutusCostModels["plutus:v3"].map((value, index) => [
          index.toString(),
          value
        ])
      )
    }
  };
};
var kupmiosUtxosToUtxos = (kupoURL, utxos, kupoHeader) => Effect2.forEach(
  utxos,
  (utxo) => {
    return pipe3(
      Effect2.all([
        getDatumEffect(kupoURL, utxo.datum_type, utxo.datum_hash, kupoHeader),
        getScriptEffect(kupoURL, utxo.script_hash, kupoHeader)
      ]),
      Effect2.map(
        ([datum, script]) => ({
          txHash: utxo.transaction_id,
          outputIndex: utxo.output_index,
          address: utxo.address,
          assets: toAssets(utxo.value),
          datumHash: utxo.datum_type === "hash" ? utxo.datum_hash : void 0,
          datum,
          scriptRef: script
        })
      )
    );
  },
  { concurrency: "unbounded" }
);

// src/emulator.ts




function generateEmulatorAccountFromPrivateKey(assets) {
  const privateKey = CML.PrivateKey.generate_ed25519().to_bech32();
  const priv = CML.PrivateKey.from_bech32(privateKey);
  const pubKeyHash = priv.to_public().hash();
  const address = CML.EnterpriseAddress.new(
    0,
    CML.Credential.new_pub_key(pubKeyHash)
  ).to_address().to_bech32(void 0);
  return {
    seedPhrase: "",
    address,
    assets,
    privateKey
  };
}
function generateEmulatorAccount(assets) {
  const seedPhrase = generateSeedPhrase();
  return {
    seedPhrase,
    address: walletFromSeed(seedPhrase, {
      addressType: "Base",
      accountIndex: 0,
      network: "Custom"
    }).address,
    assets,
    privateKey: ""
  };
}
var Emulator = class {
  ledger;
  mempool = {};
  /**
   * Only stake key registrations/delegations and rewards are tracked.
   * Other certificates are not tracked.
   */
  chain = {};
  blockHeight;
  slot;
  time;
  protocolParameters;
  datumTable = {};
  constructor(accounts, protocolParameters = _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .PROTOCOL_PARAMETERS_DEFAULT */ .DV) {
    const GENESIS_HASH = "00".repeat(32);
    this.blockHeight = 0;
    this.slot = 0;
    this.time = Date.now();
    this.ledger = {};
    accounts.forEach(({ address, assets, outputData }, index) => {
      if ([outputData?.hash, outputData?.asHash, outputData?.inline].filter(
        (b) => b
      ).length > 1) {
        throw new Error(
          "Not allowed to set hash, asHash and inline at the same time."
        );
      }
      this.ledger[GENESIS_HASH + index] = {
        utxo: {
          txHash: GENESIS_HASH,
          outputIndex: index,
          address,
          assets,
          datumHash: outputData?.asHash ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .hash_plutus_data */ .SZC(
            _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusData.from_cbor_hex */ .$zK.from_cbor_hex(outputData.asHash)
          ).to_hex() : outputData?.hash,
          datum: outputData?.inline,
          scriptRef: outputData?.scriptRef
        },
        spent: false
      };
    });
    this.protocolParameters = protocolParameters;
  }
  now() {
    return this.time;
  }
  awaitSlot(length = 1) {
    this.slot += length;
    this.time += length * 1e3;
    const currentHeight = this.blockHeight;
    this.blockHeight = Math.floor(this.slot / 20);
    if (this.blockHeight > currentHeight) {
      for (const [outRef, { utxo, spent }] of Object.entries(this.mempool)) {
        this.ledger[outRef] = { utxo, spent };
      }
      for (const [outRef, { spent }] of Object.entries(this.ledger)) {
        if (spent) delete this.ledger[outRef];
      }
      this.mempool = {};
    }
  }
  awaitBlock(height = 1) {
    this.blockHeight += height;
    this.slot += height * 20;
    this.time += height * 20 * 1e3;
    for (const [outRef, { utxo, spent }] of Object.entries(this.mempool)) {
      this.ledger[outRef] = { utxo, spent };
    }
    for (const [outRef, { spent }] of Object.entries(this.ledger)) {
      if (spent) delete this.ledger[outRef];
    }
    this.mempool = {};
  }
  getUtxos(addressOrCredential) {
    const utxos = Object.values(this.ledger).flatMap(({ utxo }) => {
      if (typeof addressOrCredential === "string") {
        return addressOrCredential === utxo.address ? utxo : [];
      } else {
        const { paymentCredential } = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .getAddressDetails */ .IL)(utxo.address);
        return paymentCredential?.hash === addressOrCredential.hash ? utxo : [];
      }
    });
    return Promise.resolve(utxos);
  }
  getProtocolParameters() {
    return Promise.resolve(this.protocolParameters);
  }
  getDatum(datumHash) {
    return Promise.resolve(this.datumTable[datumHash]);
  }
  getUtxosWithUnit(addressOrCredential, unit) {
    const utxos = Object.values(this.ledger).flatMap(({ utxo }) => {
      if (typeof addressOrCredential === "string") {
        return addressOrCredential === utxo.address && utxo.assets[unit] > 0n ? utxo : [];
      } else {
        const { paymentCredential } = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .getAddressDetails */ .IL)(utxo.address);
        return paymentCredential?.hash === addressOrCredential.hash && utxo.assets[unit] > 0n ? utxo : [];
      }
    });
    return Promise.resolve(utxos);
  }
  getUtxosByOutRef(outRefs) {
    return Promise.resolve(
      outRefs.flatMap(
        (outRef) => this.ledger[outRef.txHash + outRef.outputIndex]?.utxo || []
      )
    );
  }
  getUtxoByUnit(unit) {
    const utxos = Object.values(this.ledger).flatMap(
      ({ utxo }) => utxo.assets[unit] > 0n ? utxo : []
    );
    if (utxos.length > 1) {
      throw new Error("Unit needs to be an NFT or only held by one address.");
    }
    return Promise.resolve(utxos[0]);
  }
  getDelegation(rewardAddress) {
    return Promise.resolve({
      poolId: this.chain[rewardAddress]?.delegation?.poolId || null,
      rewards: this.chain[rewardAddress]?.delegation?.rewards || 0n
    });
  }
  awaitTx(txHash) {
    if (this.mempool[txHash + 0]) {
      this.awaitBlock();
      return Promise.resolve(true);
    }
    return Promise.resolve(true);
  }
  /**
   * Emulates the behaviour of the reward distribution at epoch boundaries.
   * Stake keys need to be registered and delegated like on a real chain in order to receive rewards.
   */
  distributeRewards(rewards) {
    for (const [
      rewardAddress,
      { registeredStake, delegation }
    ] of Object.entries(this.chain)) {
      if (registeredStake && delegation.poolId) {
        this.chain[rewardAddress] = {
          registeredStake,
          delegation: {
            poolId: delegation.poolId,
            rewards: delegation.rewards += rewards
          }
        };
      }
    }
    this.awaitBlock();
  }
  submitTx(tx) {
    const desTx = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Transaction.from_cbor_hex */ .YW8.from_cbor_hex(tx);
    const body = desTx.body();
    const witnesses = desTx.witness_set();
    const datums = witnesses.plutus_datums();
    const txHash = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .hash_transaction */ .o28(body).to_hex();
    const lowerBound = body.validity_interval_start() ? parseInt(body.validity_interval_start().toString()) : null;
    const upperBound = body.ttl() ? parseInt(body.ttl().toString()) : null;
    if (Number.isInteger(lowerBound) && this.slot < lowerBound) {
      throw new Error(
        `Lower bound (${lowerBound}) not in slot range (${this.slot}).`
      );
    }
    if (Number.isInteger(upperBound) && this.slot > upperBound) {
      throw new Error(
        `Upper bound (${upperBound}) not in slot range (${this.slot}).`
      );
    }
    const datumTable = (() => {
      const table = {};
      for (let i = 0; i < (datums?.len() || 0); i++) {
        const datum = datums.get(i);
        const datumHash = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .hash_plutus_data */ .SZC(datum).to_hex();
        table[datumHash] = datum.to_cbor_hex();
      }
      return table;
    })();
    const consumedHashes = /* @__PURE__ */ new Set();
    const keyHashes = (() => {
      const keyHashes2 = [];
      for (let i = 0; i < (witnesses.vkeywitnesses()?.len() || 0); i++) {
        const witness = witnesses.vkeywitnesses().get(i);
        const publicKey = witness.vkey();
        const keyHash = publicKey.hash().to_hex();
        if (!publicKey.verify((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(txHash), witness.ed25519_signature())) {
          throw new Error(`Invalid vkey witness. Key hash: ${keyHash}`);
        }
        keyHashes2.push(keyHash);
      }
      return keyHashes2;
    })();
    const edKeyHashes = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHashList["new"] */ .OUf["new"]();
    keyHashes.forEach(
      (keyHash) => edKeyHashes.add(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_hex */ ._Wl.from_hex(keyHash))
    );
    const nativeHashes = (() => {
      const scriptHashes = [];
      for (let i = 0; i < (witnesses.native_scripts()?.len() || 0); i++) {
        const witness = witnesses.native_scripts().get(i);
        const scriptHash = witness.hash().to_hex();
        if (!witness.verify(
          Number.isInteger(lowerBound) ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .BigInteger.from_str */ .Jhp.from_str(lowerBound.toString()).to_js_value() : void 0,
          Number.isInteger(upperBound) ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .BigInteger.from_str */ .Jhp.from_str(upperBound.toString()).to_js_value() : void 0,
          edKeyHashes
        )) {
          throw new Error(
            `Invalid native script witness. Script hash: ${scriptHash}`
          );
        }
        for (let i2 = 0; i2 < witness.get_required_signers().len(); i2++) {
          const keyHash = witness.get_required_signers().get(i2).to_hex();
          consumedHashes.add(keyHash);
        }
        scriptHashes.push(scriptHash);
      }
      return scriptHashes;
    })();
    const nativeHashesOptional = {};
    const plutusHashesOptional = [];
    const plutusHashes = (() => {
      const scriptHashes = [];
      for (let i = 0; i < (witnesses.plutus_v1_scripts()?.len() || 0); i++) {
        const script = witnesses.plutus_v1_scripts().get(i);
        const scriptHash = script.hash().to_hex();
        scriptHashes.push(scriptHash);
      }
      for (let i = 0; i < (witnesses.plutus_v2_scripts()?.len() || 0); i++) {
        const script = witnesses.plutus_v2_scripts().get(i);
        const scriptHash = script.hash().to_hex();
        scriptHashes.push(scriptHash);
      }
      for (let i = 0; i < (witnesses.plutus_v3_scripts()?.len() || 0); i++) {
        const script = witnesses.plutus_v3_scripts().get(i);
        const scriptHash = script.hash().to_hex();
        scriptHashes.push(scriptHash);
      }
      return scriptHashes;
    })();
    const inputs = body.inputs();
    const resolvedInputs = [];
    for (let i = 0; i < inputs.len(); i++) {
      const input = inputs.get(i);
      const outRef = input.transaction_id().to_hex() + input.index().toString();
      const entryLedger = this.ledger[outRef];
      const { entry, type } = !entryLedger ? { entry: this.mempool[outRef], type: "Mempool" } : { entry: entryLedger, type: "Ledger" };
      if (!entry || entry.spent) {
        throw new Error(
          `Could not spend UTxO: ${JSON.stringify({
            txHash: entry?.utxo.txHash,
            outputIndex: entry?.utxo.outputIndex
          })}
It does not exist or was already spent.`
        );
      }
      const scriptRef = entry.utxo.scriptRef;
      if (scriptRef) {
        switch (scriptRef.type) {
          case "Native": {
            const script = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.from_cbor_bytes */ .$xJ.from_cbor_bytes(
              (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(scriptRef.script)
            );
            nativeHashesOptional[script.hash().to_hex()] = script;
            break;
          }
          case "PlutusV1": {
            const script = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusScript.from_v1 */ .qPp.from_v1(
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV1Script.from_cbor_bytes */ .Z1S.from_cbor_bytes((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(scriptRef.script))
            );
            plutusHashesOptional.push(script.hash().to_hex());
            break;
          }
          case "PlutusV2": {
            const script = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusScript.from_v2 */ .qPp.from_v2(
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV2Script.from_cbor_bytes */ .$hr.from_cbor_bytes((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(scriptRef.script))
            );
            plutusHashesOptional.push(script.hash().to_hex());
            break;
          }
          case "PlutusV3": {
            const script = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusScript.from_v3 */ .qPp.from_v3(
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV3Script.from_cbor_bytes */ .z58.from_cbor_bytes((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(scriptRef.script))
            );
            plutusHashesOptional.push(script.hash().to_hex());
            break;
          }
        }
      }
      if (entry.utxo.datumHash) consumedHashes.add(entry.utxo.datumHash);
      resolvedInputs.push({ entry, type });
    }
    for (let i = 0; i < (body.reference_inputs()?.len() || 0); i++) {
      const input = body.reference_inputs().get(i);
      const outRef = input.transaction_id().to_hex() + input.index().toString();
      const entry = this.ledger[outRef] || this.mempool[outRef];
      if (!entry || entry.spent) {
        throw new Error(
          `Could not read UTxO: ${JSON.stringify({
            txHash: entry?.utxo.txHash,
            outputIndex: entry?.utxo.outputIndex
          })}
It does not exist or was already spent.`
        );
      }
      const scriptRef = entry.utxo.scriptRef;
      if (scriptRef) {
        switch (scriptRef.type) {
          case "Native": {
            const script = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.from_cbor_bytes */ .$xJ.from_cbor_bytes(
              (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(scriptRef.script)
            );
            nativeHashesOptional[script.hash().to_hex()] = script;
            break;
          }
          case "PlutusV1": {
            const script = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusScript.from_v1 */ .qPp.from_v1(
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV1Script.from_cbor_bytes */ .Z1S.from_cbor_bytes((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(scriptRef.script))
            );
            plutusHashesOptional.push(script.hash().to_hex());
            break;
          }
          case "PlutusV2": {
            const script = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusScript.from_v2 */ .qPp.from_v2(
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV2Script.from_cbor_bytes */ .$hr.from_cbor_bytes((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(scriptRef.script))
            );
            plutusHashesOptional.push(script.hash().to_hex());
            break;
          }
          case "PlutusV3": {
            const script = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusScript.from_v3 */ .qPp.from_v3(
              _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV3Script.from_cbor_bytes */ .z58.from_cbor_bytes((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(scriptRef.script))
            );
            plutusHashesOptional.push(script.hash().to_hex());
            break;
          }
        }
      }
      if (entry.utxo.datumHash) consumedHashes.add(entry.utxo.datumHash);
    }
    const redeemers = (() => {
      const tagMap = {
        0: "Spend",
        1: "Mint",
        2: "Cert",
        3: "Reward",
        4: "Proposing",
        5: "Voting"
      };
      const collected = [];
      const redeemers2 = witnesses.redeemers();
      const arrLegacyRedeemer = redeemers2?.as_arr_legacy_redeemer();
      if (arrLegacyRedeemer) {
        for (let i = 0; i < (arrLegacyRedeemer.len() || 0); i++) {
          const redeemer = arrLegacyRedeemer.get(i);
          collected.push({
            tag: tagMap[redeemer.tag()],
            index: Number(redeemer.index())
          });
        }
      }
      const mapRedeemerKeyToRedeemerVal = redeemers2?.as_map_redeemer_key_to_redeemer_val();
      if (mapRedeemerKeyToRedeemerVal) {
        const keys = mapRedeemerKeyToRedeemerVal.keys();
        for (let i = 0; i < (keys.len() || 0); i++) {
          const key = keys.get(i);
          collected.push({
            tag: tagMap[key.tag()],
            index: Number(key.index())
          });
        }
      }
      return collected;
    })();
    function checkAndConsumeHash(credential, tag, index) {
      switch (credential.type) {
        case "Key": {
          if (!keyHashes.includes(credential.hash)) {
            throw new Error(
              `Missing vkey witness. Key hash: ${credential.hash}`
            );
          }
          consumedHashes.add(credential.hash);
          break;
        }
        case "Script": {
          if (nativeHashes.includes(credential.hash)) {
            consumedHashes.add(credential.hash);
            break;
          } else if (nativeHashesOptional[credential.hash]) {
            if (!nativeHashesOptional[credential.hash].verify(
              Number.isInteger(lowerBound) ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .BigInteger.from_str */ .Jhp.from_str(
                lowerBound.toString()
              ).to_js_value() : void 0,
              Number.isInteger(upperBound) ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .BigInteger.from_str */ .Jhp.from_str(
                upperBound.toString()
              ).to_js_value() : void 0,
              edKeyHashes
            )) {
              throw new Error(
                `Invalid native script witness. Script hash: ${credential.hash}`
              );
            }
            break;
          } else if (plutusHashes.includes(credential.hash) || plutusHashesOptional.includes(credential.hash)) {
            if (redeemers.find(
              (redeemer) => redeemer.tag === tag && redeemer.index === index
            )) {
              consumedHashes.add(credential.hash);
              break;
            }
          }
          throw new Error(
            `Missing script witness. Script hash: ${credential.hash}`
          );
        }
      }
    }
    for (let i = 0; i < (body.collateral_inputs()?.len() || 0); i++) {
      const input = body.collateral_inputs().get(i);
      const outRef = input.transaction_id().to_hex() + input.index().toString();
      const entry = this.ledger[outRef] || this.mempool[outRef];
      if (!entry || entry.spent) {
        throw new Error(
          `Could not read UTxO: ${JSON.stringify({
            txHash: entry?.utxo.txHash,
            outputIndex: entry?.utxo.outputIndex
          })}
It does not exist or was already spent.`
        );
      }
      const { paymentCredential } = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .getAddressDetails */ .IL)(entry.utxo.address);
      if (paymentCredential?.type === "Script") {
        throw new Error("Collateral inputs can only contain vkeys.");
      }
      checkAndConsumeHash(paymentCredential, null, null);
    }
    for (let i = 0; i < (body.required_signers()?.len() || 0); i++) {
      const signer = body.required_signers().get(i);
      checkAndConsumeHash({ type: "Key", hash: signer.to_hex() }, null, null);
    }
    for (let index = 0; index < (body.mint()?.keys().len() || 0); index++) {
      const policyId = body.mint().keys().get(index).to_hex();
      checkAndConsumeHash({ type: "Script", hash: policyId }, "Mint", index);
    }
    const withdrawalRequests = [];
    for (let index = 0; index < (body.withdrawals()?.keys().len() || 0); index++) {
      const rawAddress = body.withdrawals().keys().get(index);
      const withdrawal = BigInt(
        body.withdrawals().get(rawAddress).toString()
      );
      const rewardAddress = rawAddress.to_address().to_bech32(void 0);
      const { stakeCredential } = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .getAddressDetails */ .IL)(rewardAddress);
      checkAndConsumeHash(stakeCredential, "Reward", index);
      if (this.chain[rewardAddress]?.delegation.rewards !== withdrawal) {
        throw new Error(
          "Withdrawal amount doesn't match actual reward balance."
        );
      }
      withdrawalRequests.push({ rewardAddress, withdrawal });
    }
    const certRequests = [];
    for (let index = 0; index < (body.certs()?.len() || 0); index++) {
      const cert = body.certs().get(index);
      switch (cert.kind()) {
        case 0: {
          const registration = cert.as_stake_registration();
          const rewardAddress = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RewardAddress["new"] */ .mf5["new"](
            _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NetworkInfo.testnet */ .JlX.testnet().network_id(),
            registration.stake_credential()
          ).to_address().to_bech32(void 0);
          if (this.chain[rewardAddress]?.registeredStake) {
            throw new Error(
              `Stake key is already registered. Reward address: ${rewardAddress}`
            );
          }
          certRequests.push({ type: "Registration", rewardAddress });
          break;
        }
        case 1: {
          const deregistration = cert.as_stake_deregistration();
          const rewardAddress = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RewardAddress["new"] */ .mf5["new"](
            _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NetworkInfo.testnet */ .JlX.testnet().network_id(),
            deregistration.stake_credential()
          ).to_address().to_bech32(void 0);
          const { stakeCredential } = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .getAddressDetails */ .IL)(rewardAddress);
          checkAndConsumeHash(stakeCredential, "Cert", index);
          if (!this.chain[rewardAddress]?.registeredStake) {
            throw new Error(
              `Stake key is already deregistered. Reward address: ${rewardAddress}`
            );
          }
          certRequests.push({ type: "Deregistration", rewardAddress });
          break;
        }
        case 2: {
          const delegation = cert.as_stake_delegation();
          const rewardAddress = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RewardAddress["new"] */ .mf5["new"](
            _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NetworkInfo.testnet */ .JlX.testnet().network_id(),
            delegation.stake_credential()
          ).to_address().to_bech32(void 0);
          const poolId = delegation.pool().to_bech32("pool");
          const { stakeCredential } = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .getAddressDetails */ .IL)(rewardAddress);
          checkAndConsumeHash(stakeCredential, "Cert", index);
          if (!this.chain[rewardAddress]?.registeredStake && !certRequests.find(
            (request) => request.type === "Registration" && request.rewardAddress === rewardAddress
          )) {
            throw new Error(
              `Stake key is not registered. Reward address: ${rewardAddress}`
            );
          }
          certRequests.push({ type: "Delegation", rewardAddress, poolId });
          break;
        }
      }
    }
    resolvedInputs.forEach(({ entry: { utxo } }, index) => {
      const { paymentCredential } = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .getAddressDetails */ .IL)(utxo.address);
      checkAndConsumeHash(paymentCredential, "Spend", index);
    });
    const outputs = (() => {
      const collected = [];
      for (let i = 0; i < body.outputs().len(); i++) {
        const output = body.outputs().get(i);
        const unspentOutput = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionUnspentOutput["new"] */ .ZAD["new"](
          _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionInput["new"] */ .XRW["new"](
            _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionHash.from_hex */ .wf_.from_hex(txHash),
            _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .BigInteger.from_str */ .Jhp.from_str(i.toString()).to_js_value()
          ),
          output
        );
        const utxo = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .coreToUtxo */ .lo)(unspentOutput);
        if (utxo.datumHash) consumedHashes.add(utxo.datumHash);
        collected.push({
          utxo,
          spent: false
        });
      }
      return collected;
    })();
    const [extraKeyHash] = keyHashes.filter(
      (keyHash) => !consumedHashes.has(keyHash)
    );
    if (extraKeyHash) {
      throw new Error(`Extraneous vkey witness. Key hash: ${extraKeyHash}`);
    }
    const [extraNativeHash] = nativeHashes.filter(
      (scriptHash) => !consumedHashes.has(scriptHash)
    );
    if (extraNativeHash) {
      throw new Error(
        `Extraneous native script. Script hash: ${extraNativeHash}`
      );
    }
    const [extraPlutusHash] = plutusHashes.filter(
      (scriptHash) => !consumedHashes.has(scriptHash)
    );
    if (extraPlutusHash) {
      throw new Error(
        `Extraneous plutus script. Script hash: ${extraPlutusHash}`
      );
    }
    const [extraDatumHash] = Object.keys(datumTable).filter(
      (datumHash) => !consumedHashes.has(datumHash)
    );
    if (extraDatumHash) {
      throw new Error(`Extraneous plutus data. Datum hash: ${extraDatumHash}`);
    }
    resolvedInputs.forEach(({ entry, type }) => {
      const outRef = entry.utxo.txHash + entry.utxo.outputIndex;
      entry.spent = true;
      if (type === "Ledger") this.ledger[outRef] = entry;
      else if (type === "Mempool") this.mempool[outRef] = entry;
    });
    withdrawalRequests.forEach(({ rewardAddress, withdrawal }) => {
      this.chain[rewardAddress].delegation.rewards -= withdrawal;
    });
    certRequests.forEach(({ type, rewardAddress, poolId }) => {
      switch (type) {
        case "Registration": {
          if (this.chain[rewardAddress]) {
            this.chain[rewardAddress].registeredStake = true;
          } else {
            this.chain[rewardAddress] = {
              registeredStake: true,
              delegation: { poolId: null, rewards: 0n }
            };
          }
          break;
        }
        case "Deregistration": {
          this.chain[rewardAddress].registeredStake = false;
          this.chain[rewardAddress].delegation.poolId = null;
          break;
        }
        case "Delegation": {
          this.chain[rewardAddress].delegation.poolId = poolId;
        }
      }
    });
    outputs.forEach(({ utxo, spent }) => {
      this.mempool[utxo.txHash + utxo.outputIndex] = {
        utxo,
        spent
      };
    });
    for (const [datumHash, datum] of Object.entries(datumTable)) {
      this.datumTable[datumHash] = datum;
    }
    return Promise.resolve(txHash);
  }
  async evaluateTx(tx, additionalUTxOs) {
    const desTx = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Transaction.from_cbor_hex */ .YW8.from_cbor_hex(tx);
    const redeemers = desTx.witness_set().redeemers();
    if (!redeemers) {
      return [];
    }
    let evalRedeemers = [];
    const arrLegacyRedeemer = redeemers.as_arr_legacy_redeemer();
    if (arrLegacyRedeemer) {
      for (let i = 0; i < arrLegacyRedeemer.len(); i++) {
        const legacyRedeemer = arrLegacyRedeemer.get(i);
        evalRedeemers.push({
          ex_units: {
            mem: Number(legacyRedeemer.ex_units().mem()),
            steps: Number(legacyRedeemer.ex_units().steps())
          },
          redeemer_index: Number(legacyRedeemer.index()),
          redeemer_tag: (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .fromCMLRedeemerTag */ .a6)(legacyRedeemer.tag())
        });
      }
      return evalRedeemers;
    }
    const mapRedeemerKeyToRedeemerVal = redeemers.as_map_redeemer_key_to_redeemer_val();
    if (mapRedeemerKeyToRedeemerVal) {
      const keys = mapRedeemerKeyToRedeemerVal.keys();
      for (let i = 0; i < keys.len(); i++) {
        const key = keys.get(i);
        const redeemerVal = mapRedeemerKeyToRedeemerVal.get(key);
        if (redeemerVal) {
          evalRedeemers.push({
            ex_units: {
              mem: Number(redeemerVal.ex_units().mem()),
              steps: Number(redeemerVal.ex_units().steps())
            },
            redeemer_index: Number(key.index),
            redeemer_tag: (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_2__/* .fromCMLRedeemerTag */ .a6)(key.tag())
          });
        }
      }
      return evalRedeemers;
    }
    return evalRedeemers;
  }
  log() {
    function getRandomColor(unit) {
      const seed = unit === "lovelace" ? "1" : unit;
      let num = 0;
      for (let i = 0; i < seed.length; i++) {
        num += seed.charCodeAt(i);
      }
      const r = num * 123 % 256;
      const g = num * 321 % 256;
      const b = num * 213 % 256;
      return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }
    const totalBalances = {};
    const balances = {};
    for (const { utxo } of Object.values(this.ledger)) {
      for (const [unit, quantity] of Object.entries(utxo.assets)) {
        if (!balances[utxo.address]) {
          balances[utxo.address] = { [unit]: quantity };
        } else if (!balances[utxo.address]?.[unit]) {
          balances[utxo.address][unit] = quantity;
        } else {
          balances[utxo.address][unit] += quantity;
        }
        if (!totalBalances[unit]) {
          totalBalances[unit] = quantity;
        } else {
          totalBalances[unit] += quantity;
        }
      }
    }
    console.log("\n%cBlockchain state", "color:purple");
    console.log(
      `
    Block height:   %c${this.blockHeight}%c
    Slot:           %c${this.slot}%c
    Unix time:      %c${this.time}
  `,
      "color:yellow",
      "color:white",
      "color:yellow",
      "color:white",
      "color:yellow"
    );
    console.log("\n");
    for (const [address, assets] of Object.entries(balances)) {
      console.log(`Address: %c${address}`, "color:blue", "\n");
      for (const [unit, quantity] of Object.entries(assets)) {
        const barLength = Math.max(
          Math.floor(60 * (Number(quantity) / Number(totalBalances[unit]))),
          1
        );
        console.log(
          `%c${"\u2586".repeat(barLength) + " ".repeat(60 - barLength)}`,
          `color: ${getRandomColor(unit)}`,
          "",
          `${unit}:`,
          quantity,
          ""
        );
      }
      console.log(`
${"\u2581".repeat(60)}
`);
    }
  }
};

// src/maestro.ts


var Maestro = class {
  url;
  apiKey;
  turboSubmit;
  constructor({ network, apiKey, turboSubmit = false }) {
    this.url = `https://${network}.gomaestro-api.org/v1`;
    this.apiKey = apiKey;
    this.turboSubmit = turboSubmit;
  }
  async getProtocolParameters() {
    const timestampedResult = await fetch(`${this.url}/protocol-parameters`, {
      headers: this.commonHeaders()
    }).then((res) => res.json());
    const result = timestampedResult.data;
    const decimalFromRationalString = (str) => {
      const forwardSlashIndex = str.indexOf("/");
      return parseInt(str.slice(0, forwardSlashIndex)) / parseInt(str.slice(forwardSlashIndex + 1));
    };
    return {
      minFeeA: parseInt(result.min_fee_coefficient),
      minFeeB: parseInt(result.min_fee_constant.ada.lovelace),
      maxTxSize: parseInt(result.max_transaction_size.bytes),
      maxValSize: parseInt(result.max_value_size.bytes),
      keyDeposit: BigInt(result.stake_credential_deposit.ada.lovelace),
      poolDeposit: BigInt(result.stake_pool_deposit.ada.lovelace),
      drepDeposit: BigInt(result.delegate_representative_deposit.ada.lovelace),
      govActionDeposit: BigInt(result.governance_action_deposit.ada.lovelace),
      priceMem: decimalFromRationalString(
        result.script_execution_prices.memory
      ),
      priceStep: decimalFromRationalString(result.script_execution_prices.cpu),
      maxTxExMem: BigInt(result.max_execution_units_per_transaction.memory),
      maxTxExSteps: BigInt(result.max_execution_units_per_transaction.cpu),
      coinsPerUtxoByte: BigInt(result.min_utxo_deposit_coefficient),
      collateralPercentage: parseInt(result.collateral_percentage),
      maxCollateralInputs: parseInt(result.max_collateral_inputs),
      minFeeRefScriptCostPerByte: parseInt(
        result.min_fee_reference_scripts.base
      ),
      costModels: {
        PlutusV1: Object.fromEntries(
          result.plutus_cost_models.plutus_v1.map(
            (value, index) => [index.toString(), value]
          )
        ),
        PlutusV2: Object.fromEntries(
          result.plutus_cost_models.plutus_v2.map(
            (value, index) => [index.toString(), value]
          )
        ),
        PlutusV3: Object.fromEntries(
          result.plutus_cost_models.plutus_v3.map(
            (value, index) => [index.toString(), value]
          )
        )
      }
    };
  }
  async getUtxosInternal(addressOrCredential, unit) {
    const queryPredicate = (() => {
      if (typeof addressOrCredential === "string") {
        return "/addresses/" + addressOrCredential;
      }
      let credentialBech32Query = "/addresses/cred/";
      credentialBech32Query += addressOrCredential.type === "Key" ? CML.Ed25519KeyHash.from_hex(addressOrCredential.hash).to_bech32(
        "addr_vkh"
      ) : CML.ScriptHash.from_hex(addressOrCredential.hash).to_bech32(
        "addr_shared_vkh"
      );
      return credentialBech32Query;
    })();
    const qparams = new URLSearchParams({
      count: "100",
      ...unit && { asset: unit }
    });
    const result = await this.getAllPagesData(
      async (qry) => await fetch(qry, {
        headers: this.requireAmountsAsStrings(this.commonHeaders())
      }),
      `${this.url}${queryPredicate}/utxos`,
      qparams,
      "Location: getUtxosInternal. Error: Could not fetch UTxOs from Maestro"
    );
    return result.map(this.maestroUtxoToUtxo);
  }
  getUtxos(addressOrCredential) {
    return this.getUtxosInternal(addressOrCredential);
  }
  getUtxosWithUnit(addressOrCredential, unit) {
    return this.getUtxosInternal(addressOrCredential, unit);
  }
  async getUtxoByUnit(unit) {
    const timestampedAddressesResponse = await fetch(
      `${this.url}/assets/${unit}/addresses?count=2`,
      { headers: this.commonHeaders() }
    );
    const timestampedAddresses = await timestampedAddressesResponse.json();
    if (!timestampedAddressesResponse.ok) {
      if (timestampedAddresses.message) {
        throw new Error(timestampedAddresses.message);
      }
      throw new Error(
        "Location: getUtxoByUnit. Error: Couldn't perform query. Received status code: " + timestampedAddressesResponse.status
      );
    }
    const addressesWithAmount = timestampedAddresses.data;
    if (addressesWithAmount.length === 0) {
      throw new Error("Location: getUtxoByUnit. Error: Unit not found.");
    }
    if (addressesWithAmount.length > 1) {
      throw new Error(
        "Location: getUtxoByUnit. Error: Unit needs to be an NFT or only held by one address."
      );
    }
    const address = addressesWithAmount[0].address;
    const utxos = await this.getUtxosWithUnit(address, unit);
    if (utxos.length > 1) {
      throw new Error(
        "Location: getUtxoByUnit. Error: Unit needs to be an NFT or only held by one address."
      );
    }
    return utxos[0];
  }
  async getUtxosByOutRef(outRefs) {
    const qry = `${this.url}/transactions/outputs`;
    const body = JSON.stringify(
      outRefs.map(({ txHash, outputIndex }) => `${txHash}#${outputIndex}`)
    );
    const utxos = await this.getAllPagesData(
      async (qry2) => await fetch(qry2, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...this.requireAmountsAsStrings(this.commonHeaders())
        },
        body
      }),
      qry,
      new URLSearchParams({}),
      "Location: getUtxosByOutRef. Error: Could not fetch UTxOs by references from Maestro"
    );
    return utxos.map(this.maestroUtxoToUtxo);
  }
  async getDelegation(rewardAddress) {
    const timestampedResultResponse = await fetch(
      `${this.url}/accounts/${rewardAddress}`,
      { headers: this.commonHeaders() }
    );
    if (!timestampedResultResponse.ok) {
      return { poolId: null, rewards: 0n };
    }
    const timestampedResult = await timestampedResultResponse.json();
    const result = timestampedResult.data;
    return {
      poolId: result.delegated_pool || null,
      rewards: BigInt(result.rewards_available)
    };
  }
  async getDatum(datumHash) {
    const timestampedResultResponse = await fetch(
      `${this.url}/datums/${datumHash}`,
      {
        headers: this.commonHeaders()
      }
    );
    if (!timestampedResultResponse.ok) {
      if (timestampedResultResponse.status === 404) {
        throw new Error(`No datum found for datum hash: ${datumHash}`);
      } else {
        throw new Error(
          "Location: getDatum. Error: Couldn't successfully perform query. Received status code: " + timestampedResultResponse.status
        );
      }
    }
    const timestampedResult = await timestampedResultResponse.json();
    return timestampedResult.data.bytes;
  }
  awaitTx(txHash, checkInterval = 3e3) {
    return new Promise((res) => {
      const confirmation = setInterval(async () => {
        const isConfirmedResponse = await fetch(
          `${this.url}/transactions/${txHash}/cbor`,
          {
            headers: this.commonHeaders()
          }
        );
        if (isConfirmedResponse.ok) {
          await isConfirmedResponse.json();
          clearInterval(confirmation);
          await new Promise((res2) => setTimeout(() => res2(1), 1e3));
          return res(true);
        }
      }, checkInterval);
    });
  }
  async submitTx(tx) {
    let queryUrl = `${this.url}/txmanager`;
    queryUrl += this.turboSubmit ? "/turbosubmit" : "";
    const response = await fetch(queryUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/cbor",
        Accept: "text/plain",
        ...this.commonHeaders()
      },
      body: fromHex3(tx)
    });
    const result = await response.text();
    if (!response.ok) {
      if (response.status === 400) throw new Error(result);
      else {
        throw new Error(
          "Could not submit transaction. Received status code: " + response.status
        );
      }
    }
    return result;
  }
  commonHeaders() {
    return { "api-key": this.apiKey, lucid: lucid2 };
  }
  requireAmountsAsStrings(obj) {
    return { ...obj, "amounts-as-strings": "true" };
  }
  maestroUtxoToUtxo(result) {
    return {
      txHash: result.tx_hash,
      outputIndex: result.index,
      assets: (() => {
        const a = {};
        result.assets.forEach((am) => {
          a[am.unit] = BigInt(am.amount);
        });
        return a;
      })(),
      address: result.address,
      datumHash: result.datum ? result.datum.type == "inline" ? void 0 : result.datum.hash : void 0,
      datum: result.datum?.bytes,
      scriptRef: toScriptRef(result.reference_script)
    };
  }
  async getAllPagesData(getResponse, qry, paramsGiven, errorMsg) {
    let nextCursor = null;
    let result = [];
    while (true) {
      if (nextCursor !== null) {
        paramsGiven.set("cursor", nextCursor);
      }
      const response = await getResponse(`${qry}?` + paramsGiven);
      const pageResult = await response.json();
      if (!response.ok) {
        throw new Error(
          `${errorMsg}. Received status code: ${response.status}`
        );
      }
      nextCursor = pageResult.next_cursor;
      result = result.concat(pageResult.data);
      if (nextCursor == null) break;
    }
    return result;
  }
  async evaluateTx(tx, additionalUTxOs) {
    const additionalMaestroUTxOs = (additionalUTxOs || []).map((utxo) => ({
      tx_hash: utxo.txHash,
      index: utxo.outputIndex,
      txout_cbor: utxoToCore(utxo).output().to_cbor_hex()
    }));
    const payload = {
      cbor: tx,
      additional_utxos: additionalMaestroUTxOs
    };
    const res = await fetch(`${this.url}/transactions/evaluate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "api-key": this.apiKey
      },
      body: JSON.stringify(payload)
    });
    if (!res.ok) {
      const body = await res.text();
      console.error("Response error:", JSON.stringify(res));
      throw new Error(`Evaluate transaction failed: ${body}`);
    }
    const result = await res.json();
    return result;
  }
};
var toScriptRef = (reference_script) => {
  if (reference_script && reference_script.bytes) {
    switch (reference_script.type) {
      case "native":
        return scriptFromNative2(reference_script.json);
      case "plutusv1":
        return {
          type: "PlutusV1",
          script: applyDoubleCborEncoding3(reference_script.bytes)
        };
      case "plutusv2":
        return {
          type: "PlutusV2",
          script: applyDoubleCborEncoding3(reference_script.bytes)
        };
      case "plutusv3":
        return {
          type: "PlutusV3",
          script: applyDoubleCborEncoding3(reference_script.bytes)
        };
      default:
        return void 0;
    }
  }
};
var lucid2 = package_default.version;

// src/koios.ts



// src/internal/koios.ts



var ProtocolParametersSchema2 = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  pvt_motion_no_confidence: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  pvt_committee_normal: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  pvt_committee_no_confidence: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  pvt_hard_fork_initiation: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  pvtpp_security_group: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  dvt_motion_no_confidence: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  dvt_committee_normal: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  dvt_committee_no_confidence: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  dvt_update_to_constitution: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  dvt_hard_fork_initiation: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  dvt_p_p_network_group: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  dvt_p_p_economic_group: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  dvt_p_p_technical_group: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  dvt_p_p_gov_group: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  dvt_treasury_withdrawal: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  committee_min_size: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  committee_max_term_length: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  gov_action_lifetime: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  gov_action_deposit: effect__WEBPACK_IMPORTED_MODULE_5__/* .NumberFromString */ ._Li,
  drep_deposit: effect__WEBPACK_IMPORTED_MODULE_5__/* .NumberFromString */ ._Li,
  drep_activity: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  min_fee_ref_script_cost_per_byte: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  epoch_no: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  min_fee_a: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  min_fee_b: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  max_block_size: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  max_tx_size: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  max_bh_size: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  key_deposit: effect__WEBPACK_IMPORTED_MODULE_5__/* .BigInt */ .tkx,
  pool_deposit: effect__WEBPACK_IMPORTED_MODULE_5__/* .BigInt */ .tkx,
  max_epoch: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  optimal_pool_count: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  influence: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  monetary_expand_rate: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  treasury_growth_rate: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  decentralisation: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  extra_entropy: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  protocol_major: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  protocol_minor: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  min_utxo_value: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  min_pool_cost: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  nonce: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  block_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  cost_models: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    PlutusV1: effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_),
    PlutusV2: effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_),
    PlutusV3: effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_)
  }),
  price_mem: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  price_step: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  max_tx_ex_mem: effect__WEBPACK_IMPORTED_MODULE_5__/* .BigIntFromNumber */ .L7B,
  max_tx_ex_steps: effect__WEBPACK_IMPORTED_MODULE_5__/* .BigIntFromNumber */ .L7B,
  max_block_ex_mem: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  max_block_ex_steps: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  max_val_size: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  collateral_percent: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  max_collateral_inputs: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  coins_per_utxo_size: effect__WEBPACK_IMPORTED_MODULE_5__/* .BigInt */ .tkx
});
var AssetSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  policy_id: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  asset_name: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  fingerprint: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  decimals: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  quantity: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9
});
var ReferenceScriptSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  size: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_),
  type: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  bytes: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  value: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .Object */ .c7w)
});
var UTxOSchema2 = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  tx_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  tx_index: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  block_time: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  block_height: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_),
  value: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  datum_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  inline_datum: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(
    effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
      bytes: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
      value: effect__WEBPACK_IMPORTED_MODULE_5__/* .Object */ .c7w
    })
  ),
  reference_script: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(ReferenceScriptSchema),
  asset_list: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(AssetSchema))
});
var AddressInfoSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(
  effect__WEBPACK_IMPORTED_MODULE_5__/* .NullishOr */ .F98(
    effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
      address: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
      balance: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
      stake_address: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
      script_address: effect__WEBPACK_IMPORTED_MODULE_5__/* .Boolean */ .gec,
      utxo_set: effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(UTxOSchema2)
    })
  )
);
var InputOutputSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  payment_addr: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
    bech32: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
    cred: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9
  }),
  stake_addr: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  tx_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  tx_index: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  value: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  datum_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  inline_datum: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(
    effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
      bytes: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
      value: effect__WEBPACK_IMPORTED_MODULE_5__/* .Object */ .c7w
    })
  ),
  reference_script: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(ReferenceScriptSchema),
  asset_list: effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(AssetSchema)
});
var TxInfoSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  tx_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  block_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  block_height: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  epoch_no: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  epoch_slot: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  absolute_slot: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  tx_timestamp: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  tx_block_index: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  tx_size: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
  total_output: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  fee: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  treasury_donation: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  deposit: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  invalid_before: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  invalid_after: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  collateral_inputs: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(InputOutputSchema)),
  collateral_output: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(InputOutputSchema),
  reference_inputs: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(InputOutputSchema)),
  inputs: effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(InputOutputSchema),
  outputs: effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(InputOutputSchema),
  withdrawals: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(
    effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(
      effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
        amount: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
        stake_addr: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9
      })
    )
  ),
  assets_minted: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(AssetSchema)),
  metadata: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .Object */ .c7w),
  certificates: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(
    effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(
      effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
        index: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
        type: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
        info: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .Object */ .c7w)
      })
    )
  ),
  native_scripts: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(
    effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(
      effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
        script_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
        script_json: effect__WEBPACK_IMPORTED_MODULE_5__/* .Object */ .c7w
      })
    )
  ),
  plutus_contracts: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(
    effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(
      effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
        address: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
        spends_input: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(
          effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
            tx_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
            tx_index: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_
          })
        ),
        script_hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
        bytecode: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
        size: effect__WEBPACK_IMPORTED_MODULE_5__/* .Number */ .Mr_,
        valid_contract: effect__WEBPACK_IMPORTED_MODULE_5__/* .Boolean */ .gec,
        input: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
          redeemer: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
            purpose: effect__WEBPACK_IMPORTED_MODULE_5__/* .Literal */ .t$L("spend", "mint", "cert", "reward"),
            fee: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
            unit: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
              steps: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
              mem: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9
            }),
            datum: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
              hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
              value: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .Object */ .c7w)
            })
          }),
          datum: effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
            hash: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
            value: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .Object */ .c7w)
          })
        })
      })
    )
  ),
  //TODO: add S.Struct
  // https://preprod.koios.rest/#post-/tx_info
  voting_procedures: effect__WEBPACK_IMPORTED_MODULE_5__/* .Array */ .mJB(effect__WEBPACK_IMPORTED_MODULE_5__/* .Object */ .c7w),
  //TODO: add S.Struct
  // https://preprod.koios.rest/#post-/tx_info
  proposal_procedures: effect__WEBPACK_IMPORTED_MODULE_5__/* .Object */ .c7w
});
var TxHashSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9;
var AssetAddressSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  payment_address: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9,
  stake_address: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  quantity: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9
});
var AccountInfoSchema = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  delegated_pool: effect__WEBPACK_IMPORTED_MODULE_5__/* .NullOr */ .Auj(effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9),
  rewards_available: effect__WEBPACK_IMPORTED_MODULE_5__/* .NumberFromString */ ._Li
});
var DatumInfo = effect__WEBPACK_IMPORTED_MODULE_5__/* .Struct */ .AUF({
  bytes: effect__WEBPACK_IMPORTED_MODULE_5__/* .String */ .Ld9
});
var toUTxO = (koiosUTxO, address) => ({
  txHash: koiosUTxO.tx_hash,
  outputIndex: koiosUTxO.tx_index,
  assets: (() => {
    const a = {};
    if (koiosUTxO.asset_list) {
      koiosUTxO.asset_list.forEach((am) => {
        a[am.policy_id + am.asset_name] = BigInt(am.quantity);
      });
    }
    a["lovelace"] = BigInt(koiosUTxO.value);
    return a;
  })(),
  address,
  datumHash: koiosUTxO.inline_datum ? void 0 : koiosUTxO.datum_hash || void 0,
  datum: koiosUTxO.inline_datum ? koiosUTxO.inline_datum.bytes : void 0,
  scriptRef: toScriptRef2(koiosUTxO.reference_script)
});
var toScriptRef2 = (reference_script) => {
  if (reference_script && reference_script.bytes && reference_script.type) {
    switch (reference_script.type) {
      case "plutusV1":
        return {
          type: "PlutusV1",
          script: applyDoubleCborEncoding4(reference_script.bytes)
        };
      case "plutusV2":
        return {
          type: "PlutusV2",
          script: applyDoubleCborEncoding4(reference_script.bytes)
        };
      case "plutusV3":
        return {
          type: "PlutusV3",
          script: applyDoubleCborEncoding4(reference_script.bytes)
        };
      default:
        return void 0;
    }
  }
};
var getUtxosEffect = (baseUrl, addressOrCredential, headers) => {
  const url = `${baseUrl}/address_info`;
  const body = {
    _addresses: [addressOrCredential]
  };
  const schema = AddressInfoSchema;
  const result = pipe4(
    Effect3.if(typeof addressOrCredential === "string", {
      onFalse: () => Effect3.fail("Credential Type is not supported in Koios yet."),
      onTrue: () => makePostAsJson(url, body, schema, headers)
    }),
    Effect3.map(
      ([result2]) => result2 ? result2.utxo_set.map((koiosUtxo) => toUTxO(koiosUtxo, result2.address)) : []
    ),
    Effect3.provide(FetchHttpClient2.layer)
  );
  return result;
};

// src/koios.ts


var KoiosError = class extends effect__WEBPACK_IMPORTED_MODULE_6__/* .TaggedError */ .fZ("KoiosError") {
  get message() {
    return `${this.cause}`;
  }
};
var Koios = class {
  baseUrl;
  token;
  constructor(baseUrl, token) {
    this.baseUrl = baseUrl;
    this.token = token;
  }
  async getProtocolParameters() {
    const url = `${this.baseUrl}/epoch_params?limit=1`;
    const schema = S5.Array(ProtocolParametersSchema2);
    const bearerToken = this.token ? { Authorization: `Bearer ${this.token}` } : void 0;
    const [result] = await pipe5(
      makeGet(url, schema, bearerToken),
      // Allows for dependency injection and easier testing
      Effect4.provide(FetchHttpClient3.layer),
      Effect4.timeout(1e4),
      Effect4.catchAllCause((cause) => new KoiosError({ cause })),
      Effect4.runPromise
    );
    return {
      minFeeA: result.min_fee_a,
      minFeeB: result.min_fee_b,
      maxTxSize: result.max_tx_size,
      maxValSize: result.max_val_size,
      keyDeposit: result.key_deposit,
      poolDeposit: result.pool_deposit,
      drepDeposit: BigInt(result.drep_deposit),
      govActionDeposit: BigInt(result.gov_action_deposit),
      priceMem: result.price_mem,
      priceStep: result.price_step,
      maxTxExMem: result.max_tx_ex_mem,
      maxTxExSteps: result.max_tx_ex_steps,
      coinsPerUtxoByte: result.coins_per_utxo_size,
      collateralPercentage: result.collateral_percent,
      maxCollateralInputs: result.max_collateral_inputs,
      minFeeRefScriptCostPerByte: result.min_fee_ref_script_cost_per_byte,
      costModels: {
        PlutusV1: Object.fromEntries(
          result.cost_models.PlutusV1.map((value, index) => [
            index.toString(),
            value
          ])
        ),
        PlutusV2: Object.fromEntries(
          result.cost_models.PlutusV2.map((value, index) => [
            index.toString(),
            value
          ])
        ),
        PlutusV3: Object.fromEntries(
          result.cost_models.PlutusV3.map((value, index) => [
            index.toString(),
            value
          ])
        )
      }
    };
  }
  async getUtxos(addressOrCredential) {
    const bearerToken = this.token ? { Authorization: `Bearer ${this.token}` } : void 0;
    const result = await pipe5(
      getUtxosEffect(this.baseUrl, addressOrCredential, bearerToken),
      Effect4.timeout(1e4),
      Effect4.catchAllCause((cause) => new KoiosError({ cause })),
      Effect4.runPromise
    );
    return result;
  }
  async getUtxosWithUnit(addressOrCredential, unit) {
    const bearerToken = this.token ? { Authorization: `Bearer ${this.token}` } : void 0;
    const result = await pipe5(
      getUtxosEffect(this.baseUrl, addressOrCredential, bearerToken),
      Effect4.map(
        (utxos) => utxos.filter((utxo) => {
          const keys = Object.keys(utxo.assets);
          return keys.length > 0 && keys.includes(unit);
        })
      ),
      Effect4.timeout(1e4),
      Effect4.catchAllCause((cause) => new KoiosError({ cause })),
      Effect4.runPromise
    );
    return result;
  }
  async getUtxoByUnit(unit) {
    let { policyId, assetName } = fromUnit3(unit);
    const url = `${this.baseUrl}/asset_addresses?_asset_policy=${policyId}&_asset_name=${assetName}`;
    const bearerToken = this.token ? { Authorization: `Bearer ${this.token}` } : void 0;
    const result = await pipe5(
      makeGet(url, S5.Array(AssetAddressSchema), bearerToken),
      // Allows for dependency injection and easier testing
      Effect4.provide(FetchHttpClient3.layer),
      Effect4.flatMap(
        (adresses) => adresses.length === 0 ? Effect4.fail("Unit not found") : Effect4.succeed(adresses)
      ),
      Effect4.flatMap(
        (adresses) => adresses.length > 1 ? Effect4.fail("Unit needs to be an NFT or only held by one address.") : Effect4.succeed(adresses[0])
      ),
      Effect4.flatMap(
        (address) => getUtxosEffect(
          this.baseUrl,
          address.payment_address,
          bearerToken
        )
      ),
      Effect4.map(
        (utxos) => utxos.filter((utxo) => {
          const keys = Object.keys(utxo.assets);
          return keys.length > 0 && keys.includes(unit);
        })
      ),
      Effect4.flatMap(
        (utxos) => utxos.length > 1 ? Effect4.fail("Unit needs to be an NFT or only held by one address.") : Effect4.succeed(utxos[0])
      ),
      Effect4.timeout(1e4),
      Effect4.catchAllCause((cause) => new KoiosError({ cause })),
      Effect4.runPromise
    );
    return result;
  }
  async getUtxosByOutRef(outRefs) {
    const url = `${this.baseUrl}/tx_info`;
    const body = {
      _tx_hashes: [...new Set(outRefs.map((outRef) => outRef.txHash))],
      _assets: true,
      _scripts: true
    };
    const schema = S5.Array(TxInfoSchema);
    const bearerToken = this.token ? { Authorization: `Bearer ${this.token}` } : void 0;
    const [result] = await pipe5(
      makePostAsJson(url, body, schema, bearerToken),
      // Allows for dependency injection and easier testing
      Effect4.provide(FetchHttpClient3.layer),
      Effect4.timeout(1e4),
      Effect4.catchAllCause((cause) => new KoiosError({ cause })),
      Effect4.runPromise
    );
    if (result) {
      const utxos = result.outputs.map(
        (koiosInputOutput) => toUTxO(
          {
            tx_hash: koiosInputOutput.tx_hash,
            tx_index: koiosInputOutput.tx_index,
            block_time: 0,
            block_height: result.block_height,
            value: koiosInputOutput.value,
            datum_hash: koiosInputOutput.datum_hash,
            inline_datum: koiosInputOutput.inline_datum,
            reference_script: koiosInputOutput.reference_script,
            asset_list: koiosInputOutput.asset_list
          },
          koiosInputOutput.payment_addr.bech32
        )
      );
      return utxos.filter(
        (utxo) => outRefs.some(
          (outRef) => utxo.txHash === outRef.txHash && utxo.outputIndex === outRef.outputIndex
        )
      );
    } else {
      return [];
    }
  }
  async getDelegation(rewardAddress) {
    const body = {
      _stake_addresses: [rewardAddress]
    };
    const url = `${this.baseUrl}/account_info`;
    const bearerToken = this.token ? { Authorization: `Bearer ${this.token}` } : void 0;
    const result = await pipe5(
      makePostAsJson(
        url,
        body,
        S5.Array(AccountInfoSchema),
        bearerToken
      ),
      // Allows for dependency injection and easier testing
      Effect4.provide(FetchHttpClient3.layer),
      Effect4.flatMap(
        (result2) => result2.length === 0 ? Effect4.fail("No Delegation Found by Reward Address") : Effect4.succeed(result2[0])
      ),
      Effect4.timeout(1e4),
      Effect4.catchAllCause((cause) => new KoiosError({ cause })),
      Effect4.runPromise
    );
    return {
      poolId: result.delegated_pool || null,
      rewards: BigInt(result.rewards_available)
    };
  }
  async getDatum(datumHash) {
    const url = `${this.baseUrl}/datum_info`;
    const body = {
      _datum_hashes: [datumHash]
    };
    const bearerToken = this.token ? { Authorization: `Bearer ${this.token}` } : void 0;
    const result = await pipe5(
      makePostAsJson(
        url,
        body,
        S5.Array(DatumInfo),
        bearerToken
      ),
      // Allows for dependency injection and easier testing
      Effect4.provide(FetchHttpClient3.layer),
      Effect4.flatMap(
        (result2) => result2.length === 0 ? Effect4.fail("No Datum Found by Datum Hash") : Effect4.succeed(result2[0])
      ),
      Effect4.timeout(1e4),
      Effect4.catchAllCause((cause) => new KoiosError({ cause })),
      Effect4.runPromise
    );
    return result.bytes;
  }
  async awaitTx(txHash, checkInterval = 2e4) {
    const url = `${this.baseUrl}/tx_info`;
    const body = {
      _tx_hashes: [txHash]
    };
    const schema = S5.Array(TxInfoSchema);
    const bearerToken = this.token ? { Authorization: `Bearer ${this.token}` } : void 0;
    const result = await pipe5(
      makePostAsJson(url, body, schema, bearerToken),
      Effect4.repeat({
        schedule: Schedule2.exponential(checkInterval),
        until: (result2) => result2.length > 0
      }),
      // Allows for dependency injection and easier testing
      Effect4.provide(FetchHttpClient3.layer),
      Effect4.timeout(16e4),
      Effect4.orDie,
      Effect4.as(true),
      Effect4.runPromise
    );
    return result;
  }
  async submitTx(tx) {
    const url = `${this.baseUrl}/submittx`;
    const body = fromHex4(tx);
    const schema = TxHashSchema;
    const bearerToken = this.token ? { Authorization: `Bearer ${this.token}` } : void 0;
    const result = await pipe5(
      makePostAsUint8Array(url, body, schema, bearerToken),
      // Allows for dependency injection and easier testing
      Effect4.provide(FetchHttpClient3.layer),
      Effect4.timeout(1e4),
      Effect4.catchAllCause((cause) => new KoiosError({ cause })),
      Effect4.runPromise
    );
    return result;
  }
  async evaluateTx(tx, additionalUTxOs) {
    const url = `${this.baseUrl}/ogmios`;
    const body = {
      jsonrpc: "2.0",
      method: "evaluateTransaction",
      params: {
        transaction: { cbor: tx },
        additionalUtxo: toOgmiosUTxOs(additionalUTxOs)
      },
      id: null
    };
    const schema = JSONRPCSchema(S5.Array(RedeemerSchema));
    const bearerToken = this.token ? { Authorization: `Bearer ${this.token}` } : void 0;
    const { result } = await pipe5(
      makePostAsJson(url, body, schema, bearerToken),
      // Allows for dependency injection and easier testing
      Effect4.provide(FetchHttpClient3.layer),
      Effect4.timeout(1e4),
      Effect4.catchAllCause((cause) => new KoiosError({ cause })),
      Effect4.runPromise
    );
    const evalRedeemers = result.map((item) => ({
      ex_units: {
        mem: item.budget.memory,
        steps: item.budget.cpu
      },
      redeemer_index: item.validator.index,
      redeemer_tag: item.validator.purpose
    }));
    return evalRedeemers;
  }
};


__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 48415:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ signData; }
/* harmony export */ });
/* unused harmony export verifyData */
/* harmony import */ var _lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34837);
/* harmony import */ var _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82381);
/* harmony import */ var _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85573);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_1__, _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__]);
([_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_1__, _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
// src/sign_data.ts



function signData(addressHex, payload, privateKey) {
  const protectedHeaders = _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .HeaderMap["new"] */ .BF["new"]();
  protectedHeaders.set_algorithm_id(
    _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Label.from_algorithm_id */ .__.from_algorithm_id(_emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .AlgorithmId.EdDSA */ .f3.EdDSA)
  );
  protectedHeaders.set_header(
    _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Label.new_text */ .__.new_text("address"),
    _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .CBORValue.new_bytes */ .Jz.new_bytes((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .fromHex */ .H_)(addressHex))
  );
  const protectedSerialized = _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .ProtectedHeaderMap["new"] */ .UP["new"](protectedHeaders);
  const unprotectedHeaders = _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .HeaderMap["new"] */ .BF["new"]();
  const headers = _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Headers["new"] */ .PM["new"](protectedSerialized, unprotectedHeaders);
  const builder = _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .COSESign1Builder["new"] */ .DZ["new"](headers, (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .fromHex */ .H_)(payload), false);
  const toSign = builder.make_data_to_sign().to_bytes();
  const priv = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_1__/* .PrivateKey.from_bech32 */ ._q4.from_bech32(privateKey);
  const signedSigStruc = priv.sign(toSign).to_raw_bytes();
  const coseSign1 = builder.build(signedSigStruc);
  const key = _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .COSEKey["new"] */ .VU["new"](
    _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Label.from_key_type */ .__.from_key_type(_emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .KeyType.OKP */ .Yh.OKP)
    //OKP
  );
  key.set_algorithm_id(_emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Label.from_algorithm_id */ .__.from_algorithm_id(_emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .AlgorithmId.EdDSA */ .f3.EdDSA));
  key.set_header(
    _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Label.new_int */ .__.new_int(_emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Int.new_negative */ .J7.new_negative(_emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .BigNum.from_str */ .Wb.from_str("1"))),
    _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .CBORValue.new_int */ .Jz.new_int(
      _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Int.new_i32 */ .J7.new_i32(6)
      //M.CurveType.Ed25519
    )
  );
  key.set_header(
    _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Label.new_int */ .__.new_int(_emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Int.new_negative */ .J7.new_negative(_emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .BigNum.from_str */ .Wb.from_str("2"))),
    _emurgo_cardano_message_signing_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .CBORValue.new_bytes */ .Jz.new_bytes(priv.to_public().to_raw_bytes())
  );
  return {
    signature: (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .toHex */ .NC)(coseSign1.to_bytes()),
    key: (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_0__/* .toHex */ .NC)(key.to_bytes())
  };
}
function verifyData(addressHex, keyHash, payload, signedMessage) {
  const cose1 = M.COSESign1.from_bytes(fromHex(signedMessage.signature));
  const key = M.COSEKey.from_bytes(fromHex(signedMessage.key));
  const protectedHeaders = cose1.headers().protected().deserialized_headers();
  const cose1Address = (() => {
    try {
      return toHex(
        protectedHeaders.header(M.Label.new_text("address"))?.as_bytes()
      );
    } catch (_e) {
      throw new Error("No address found in signature.");
    }
  })();
  const cose1AlgorithmId = (() => {
    try {
      const int = protectedHeaders.algorithm_id()?.as_int();
      if (int?.is_positive()) return parseInt(int.as_positive()?.to_str());
      return parseInt(int?.as_negative()?.to_str());
    } catch (_e) {
      throw new Error("Failed to retrieve Algorithm Id.");
    }
  })();
  const keyAlgorithmId = (() => {
    try {
      const int = key.algorithm_id()?.as_int();
      if (int?.is_positive()) return parseInt(int.as_positive()?.to_str());
      return parseInt(int?.as_negative()?.to_str());
    } catch (_e) {
      throw new Error("Failed to retrieve Algorithm Id.");
    }
  })();
  const keyCurve = (() => {
    try {
      const int = key.header(M.Label.new_int(M.Int.new_negative(M.BigNum.from_str("1"))))?.as_int();
      if (int?.is_positive()) return parseInt(int.as_positive()?.to_str());
      return parseInt(int?.as_negative()?.to_str());
    } catch (_e) {
      throw new Error("Failed to retrieve Curve.");
    }
  })();
  const keyType = (() => {
    try {
      const int = key.key_type().as_int();
      if (int?.is_positive()) return parseInt(int.as_positive()?.to_str());
      return parseInt(int?.as_negative()?.to_str());
    } catch (_e) {
      throw new Error("Failed to retrieve Key Type.");
    }
  })();
  const publicKey = (() => {
    try {
      return CML.PublicKey.from_bytes(
        key.header(M.Label.new_int(M.Int.new_negative(M.BigNum.from_str("2"))))?.as_bytes()
      );
    } catch (_e) {
      throw new Error("No public key found.");
    }
  })();
  const cose1Payload = (() => {
    try {
      return toHex(cose1.payload());
    } catch (_e) {
      throw new Error("No payload found.");
    }
  })();
  const signature = CML.Ed25519Signature.from_raw_bytes(cose1.signature());
  const data = cose1.signed_data(void 0, void 0).to_bytes();
  if (cose1Address !== addressHex) return false;
  if (keyHash !== publicKey.hash().to_hex()) return false;
  if (cose1AlgorithmId !== keyAlgorithmId && cose1AlgorithmId !== M.AlgorithmId.EdDSA) {
    return false;
  }
  if (keyCurve !== 6) return false;
  if (keyType !== 1) return false;
  if (cose1Payload !== payload) return false;
  return publicKey.verify(data, signature);
}


__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 87830:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ assetsToValue; },
/* harmony export */   "DV": function() { return /* binding */ PROTOCOL_PARAMETERS_DEFAULT; },
/* harmony export */   "EE": function() { return /* binding */ applyDoubleCborEncoding; },
/* harmony export */   "EP": function() { return /* binding */ credentialToRewardAddress; },
/* harmony export */   "GP": function() { return /* binding */ selectUTxOs; },
/* harmony export */   "Hf": function() { return /* binding */ unixTimeToSlot; },
/* harmony export */   "I6": function() { return /* binding */ valueToAssets; },
/* harmony export */   "I9": function() { return /* binding */ paymentCredentialOf; },
/* harmony export */   "IL": function() { return /* binding */ getAddressDetails; },
/* harmony export */   "KW": function() { return /* binding */ sortUTxOs; },
/* harmony export */   "Pz": function() { return /* binding */ stringify; },
/* harmony export */   "Sw": function() { return /* binding */ utxoToCore; },
/* harmony export */   "V7": function() { return /* binding */ toCMLRedeemerTag; },
/* harmony export */   "a6": function() { return /* binding */ fromCMLRedeemerTag; },
/* harmony export */   "aI": function() { return /* binding */ validatorToScriptHash; },
/* harmony export */   "dZ": function() { return /* binding */ networkToId; },
/* harmony export */   "eI": function() { return /* binding */ applyParamsToScript; },
/* harmony export */   "f5": function() { return /* binding */ utxoToTransactionInput; },
/* harmony export */   "g9": function() { return /* binding */ fromUnit; },
/* harmony export */   "jC": function() { return /* binding */ scriptFromNative; },
/* harmony export */   "lo": function() { return /* binding */ coreToUtxo; },
/* harmony export */   "nn": function() { return /* binding */ toUnit; },
/* harmony export */   "nz": function() { return /* binding */ validatorToAddress; },
/* harmony export */   "of": function() { return /* binding */ mintingPolicyToId; },
/* harmony export */   "pU": function() { return /* binding */ utxoToTransactionOutput; },
/* harmony export */   "pZ": function() { return /* binding */ toScriptRef; },
/* harmony export */   "q$": function() { return /* binding */ addAssets; },
/* harmony export */   "sJ": function() { return /* binding */ createCostModels; },
/* harmony export */   "wF": function() { return /* binding */ isEqualUTxO; },
/* harmony export */   "wt": function() { return /* binding */ applySingleCborEncoding; },
/* harmony export */   "yZ": function() { return /* binding */ coreToTxOutput; }
/* harmony export */ });
/* unused harmony exports CBOREncodingLevel, addressFromHexOrBech32, calculateMinLovelaceFromUTxO, coreToOutRef, coresToOutRefs, coresToTxOutputs, coresToUtxos, credentialToAddress, datumJsonToCbor, datumToHash, drepIDToCredential, fromLabel, fromScriptRef, generatePrivateKey, generateSeedPhrase, getInputIndices, getUniqueTokenName, keyHashToCredential, parseCMLNative, scriptFromCMLNative, scriptHashToCredential, slotToUnixTime, sortCanonical, stakeCredentialOf, toCMLNativeScript, toLabel, toPublicKey, utxosToCores, validatorToRewardAddress */
/* harmony import */ var _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36054);
/* harmony import */ var _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65694);
/* harmony import */ var _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82381);
/* harmony import */ var _lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34837);
/* harmony import */ var cbor_x__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24234);
/* harmony import */ var _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46533);
/* harmony import */ var _harmoniclabs_uplc__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88867);
/* harmony import */ var _harmoniclabs_plutus_data__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34635);
/* harmony import */ var bip39__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2153);
/* harmony import */ var _lucid_evolution_crc8__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79969);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__, _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_5__]);
([_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__, _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_5__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
// src/native.ts


// src/core.ts


// src/native.ts
var toCMLNativeScript = (native) => {
  switch (native.type) {
    case "sig":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.new_script_pubkey */ .$xJ.new_script_pubkey(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_hex */ ._Wl.from_hex(native.keyHash)
      );
    case "before":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.new_script_invalid_hereafter */ .$xJ.new_script_invalid_hereafter(BigInt(native.slot));
    case "after":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.new_script_invalid_before */ .$xJ.new_script_invalid_before(BigInt(native.slot));
    case "all": {
      const nativeList = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScriptList["new"] */ .X3N["new"]();
      native.scripts.map((script) => nativeList.add(toCMLNativeScript(script)));
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.new_script_all */ .$xJ.new_script_all(nativeList);
    }
    case "any": {
      const nativeList = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScriptList["new"] */ .X3N["new"]();
      native.scripts.map((script) => nativeList.add(toCMLNativeScript(script)));
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.new_script_any */ .$xJ.new_script_any(nativeList);
    }
    case "atLeast": {
      const nativeList = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScriptList["new"] */ .X3N["new"]();
      native.scripts.map((script) => nativeList.add(toCMLNativeScript(script)));
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.new_script_n_of_k */ .$xJ.new_script_n_of_k(
        BigInt(native.required),
        nativeList
      );
    }
  }
};
var scriptFromNative = (native) => {
  return {
    type: "Native",
    script: toCMLNativeScript(native).to_cbor_hex()
  };
};
var CMLNativeSchema = _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Union */ .EJI(
  _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Struct */ .AUF({
    ScriptPubkey: _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Struct */ .AUF({
      ed25519_key_hash: _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .String */ .Ld9
    })
  }),
  _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Struct */ .AUF({
    ScriptInvalidBefore: _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Struct */ .AUF({
      before: _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Number */ .Mr_
    })
  }),
  _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Struct */ .AUF({
    ScriptInvalidHereafter: _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Struct */ .AUF({
      after: _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Number */ .Mr_
    })
  }),
  _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Struct */ .AUF({
    ScriptAll: _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Struct */ .AUF({
      native_scripts: _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Array */ .mJB(_effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .suspend */ .RqG(() => CMLNativeSchema))
    })
  }),
  _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Struct */ .AUF({
    ScriptAny: _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Struct */ .AUF({
      native_scripts: _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Array */ .mJB(_effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .suspend */ .RqG(() => CMLNativeSchema))
    })
  }),
  _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Struct */ .AUF({
    ScriptNOfK: _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Struct */ .AUF({
      n: _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Number */ .Mr_,
      native_scripts: _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .Array */ .mJB(_effect_schema_Schema__WEBPACK_IMPORTED_MODULE_1__/* .suspend */ .RqG(() => CMLNativeSchema))
    })
  })
);
var parseCMLNative = _effect_schema_Schema__WEBPACK_IMPORTED_MODULE_2__/* .decodeUnknownSync */ .G$(CMLNativeSchema);
var scriptFromCMLNative = (cmlNative) => {
  return {
    type: "Native",
    script: CML.NativeScript.from_json(JSON.stringify(cmlNative)).to_cbor_hex()
  };
};

// src/network.ts
function networkToId(network) {
  switch (network) {
    case "Preview":
      return 0;
    case "Preprod":
      return 0;
    case "Custom":
      return 0;
    case "Mainnet":
      return 1;
    default:
      throw new Error("Network not found");
  }
}

// src/cbor.ts


var applyDoubleCborEncoding = (script) => {
  try {
    (0,cbor_x__WEBPACK_IMPORTED_MODULE_4__/* .decode */ .Jx)((0,cbor_x__WEBPACK_IMPORTED_MODULE_4__/* .decode */ .Jx)((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .fromHex */ .H_)(script)));
    return script;
  } catch (error) {
    try {
      (0,cbor_x__WEBPACK_IMPORTED_MODULE_4__/* .decode */ .Jx)((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .fromHex */ .H_)(script));
      return (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .toHex */ .NC)(Uint8Array.from((0,cbor_x__WEBPACK_IMPORTED_MODULE_4__/* .encode */ .cv)((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .fromHex */ .H_)(script).buffer)));
    } catch (error2) {
      return (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .toHex */ .NC)(Uint8Array.from((0,cbor_x__WEBPACK_IMPORTED_MODULE_4__/* .encode */ .cv)((0,cbor_x__WEBPACK_IMPORTED_MODULE_4__/* .encode */ .cv)((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .fromHex */ .H_)(script).buffer))));
    }
  }
};
var applySingleCborEncoding = (script) => {
  try {
    (0,cbor_x__WEBPACK_IMPORTED_MODULE_4__/* .decode */ .Jx)((0,cbor_x__WEBPACK_IMPORTED_MODULE_4__/* .decode */ .Jx)((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .fromHex */ .H_)(script)));
    return (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .toHex */ .NC)((0,cbor_x__WEBPACK_IMPORTED_MODULE_4__/* .decode */ .Jx)((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .fromHex */ .H_)(script)));
  } catch (error) {
    try {
      (0,cbor_x__WEBPACK_IMPORTED_MODULE_4__/* .decode */ .Jx)((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .fromHex */ .H_)(script));
      return script;
    } catch (error2) {
      return (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .toHex */ .NC)(Uint8Array.from((0,cbor_x__WEBPACK_IMPORTED_MODULE_4__/* .encode */ .cv)((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .fromHex */ .H_)(script).buffer)));
    }
  }
};
var CBOREncodingLevel = (script) => {
  try {
    decode(decode(fromHex(script)));
    return "double";
  } catch (error) {
    try {
      decode(fromHex(script));
      return "single";
    } catch (error2) {
      throw new Error("Script is not CBOR-encoded or invalid format.");
    }
  }
};
function datumJsonToCbor(json) {
  const convert = (json2) => {
    if (!isNaN(json2.int)) {
      const plutusBigInt = CML.BigInteger.from_str(json2.int.toString());
      return CML.PlutusData.new_integer(plutusBigInt);
    } else if (json2.bytes || !isNaN(Number(json2.bytes))) {
      return CML.PlutusData.new_bytes(fromHex(json2.bytes));
    } else if (json2.list) {
      const l = CML.PlutusDataList.new();
      json2.list.forEach((v) => {
        l.add(convert(v));
      });
      return CML.PlutusData.new_list(l);
    } else if (json2.map && json2.map.length > 0 && typeof json2.map[0] === "object") {
      const m = CML.PlutusMap.new();
      json2.map.forEach(({ k, v }) => {
        m.set(convert(k), convert(v));
      });
      return CML.PlutusData.new_map(m);
    } else if (json2.map && typeof json2.map === "function") {
      const l = CML.PlutusDataList.new();
      Object.values(json2).forEach((value) => {
        l.add(convert(value));
      });
      return CML.PlutusData.new_list(l);
    } else if (!isNaN(json2.constructor)) {
      const l = CML.PlutusDataList.new();
      json2.fields.forEach((v) => {
        l.add(convert(v));
      });
      const bigInt = CML.BigInteger.from_str(
        json2.constructor.toString()
      ).as_u64();
      return CML.PlutusData.new_constr_plutus_data(
        CML.ConstrPlutusData.new(bigInt, l)
      );
    }
    throw new Error("Unsupported type");
  };
  return convert(json).to_cbor_hex();
}

// src/scripts.ts





function validatorToAddress(network, validator, stakeCredential) {
  const validatorHash = validatorToScriptHash(validator);
  if (stakeCredential) {
    return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .BaseAddress["new"] */ .pv["new"](
      networkToId(network),
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_script */ .hJE.new_script(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ScriptHash.from_hex */ .nJe.from_hex(validatorHash)),
      stakeCredential.type === "Key" ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_pub_key */ .hJE.new_pub_key(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_hex */ ._Wl.from_hex(stakeCredential.hash)
      ) : _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_script */ .hJE.new_script(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ScriptHash.from_hex */ .nJe.from_hex(stakeCredential.hash)
      )
    ).to_address().to_bech32(void 0);
  } else {
    return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .EnterpriseAddress["new"] */ .Z0E["new"](
      networkToId(network),
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_script */ .hJE.new_script(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ScriptHash.from_hex */ .nJe.from_hex(validatorHash))
    ).to_address().to_bech32(void 0);
  }
}
function validatorToScriptHash(validator) {
  switch (validator.type) {
    case "Native":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.from_cbor_hex */ .$xJ.from_cbor_hex(validator.script).hash().to_hex();
    case "PlutusV1":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusScript.from_v1 */ .qPp.from_v1(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV1Script.from_cbor_hex */ .Z1S.from_cbor_hex(
          applyDoubleCborEncoding(validator.script)
        )
      ).hash().to_hex();
    case "PlutusV2":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusScript.from_v2 */ .qPp.from_v2(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV2Script.from_cbor_hex */ .$hr.from_cbor_hex(
          applyDoubleCborEncoding(validator.script)
        )
      ).hash().to_hex();
    case "PlutusV3":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusScript.from_v3 */ .qPp.from_v3(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV3Script.from_cbor_hex */ .z58.from_cbor_hex(
          applyDoubleCborEncoding(validator.script)
        )
      ).hash().to_hex();
    default:
      throw new Error("No variant matched");
  }
}
function toScriptRef(script) {
  switch (script.type) {
    case "Native":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Script.new_native */ .XfO.new_native(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .NativeScript.from_cbor_hex */ .$xJ.from_cbor_hex(script.script)
      );
    case "PlutusV1":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Script.new_plutus_v1 */ .XfO.new_plutus_v1(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV1Script.from_cbor_hex */ .Z1S.from_cbor_hex(
          applyDoubleCborEncoding(script.script)
        )
      );
    case "PlutusV2":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Script.new_plutus_v2 */ .XfO.new_plutus_v2(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV2Script.from_cbor_hex */ .$hr.from_cbor_hex(
          applyDoubleCborEncoding(script.script)
        )
      );
    case "PlutusV3":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Script.new_plutus_v3 */ .XfO.new_plutus_v3(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusV3Script.from_cbor_hex */ .z58.from_cbor_hex(
          applyDoubleCborEncoding(script.script)
        )
      );
    default:
      throw new Error("No variant matched.");
  }
}
function fromScriptRef(scriptRef) {
  const kind = scriptRef.kind();
  switch (kind) {
    case 0:
      return {
        type: "Native",
        script: scriptRef.as_native().to_cbor_hex()
      };
    case 1:
      return {
        type: "PlutusV1",
        script: scriptRef.as_plutus_v1().to_cbor_hex()
      };
    case 2:
      return {
        type: "PlutusV2",
        script: scriptRef.as_plutus_v2().to_cbor_hex()
      };
    case 3:
      return {
        type: "PlutusV3",
        script: scriptRef.as_plutus_v3().to_cbor_hex()
      };
    default:
      throw new Error("No variant matched.");
  }
}
function mintingPolicyToId(mintingPolicy) {
  return validatorToScriptHash(mintingPolicy);
}
function applyParamsToScript(plutusScript, params, type) {
  const program = (0,_harmoniclabs_uplc__WEBPACK_IMPORTED_MODULE_6__.parseUPLC)(
    (0,cbor_x__WEBPACK_IMPORTED_MODULE_4__/* .decode */ .Jx)((0,cbor_x__WEBPACK_IMPORTED_MODULE_4__/* .decode */ .Jx)((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .fromHex */ .H_)(applyDoubleCborEncoding(plutusScript)))),
    "flat"
  );
  const parameters = type ? _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_5__/* .Data.castTo */ .Vw.castTo(params, type) : params;
  const appliedProgram = parameters.reduce((body, currentParameter) => {
    const data = _harmoniclabs_uplc__WEBPACK_IMPORTED_MODULE_6__.UPLCConst.data((0,_harmoniclabs_plutus_data__WEBPACK_IMPORTED_MODULE_7__.dataFromCbor)(_lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_5__/* .Data.to */ .Vw.to(currentParameter)));
    const appliedParameter = new _harmoniclabs_uplc__WEBPACK_IMPORTED_MODULE_6__.Application(body, data);
    return appliedParameter;
  }, program.body);
  return applyDoubleCborEncoding(
    (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .toHex */ .NC)(
      (0,_harmoniclabs_uplc__WEBPACK_IMPORTED_MODULE_6__.encodeUPLC)(new _harmoniclabs_uplc__WEBPACK_IMPORTED_MODULE_6__.UPLCProgram(program.version, appliedProgram)).toBuffer().buffer
    )
  );
}

// src/address.ts
function addressFromHexOrBech32(address) {
  try {
    return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Address.from_hex */ .kLt.from_hex(address);
  } catch (_e) {
    try {
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Address.from_bech32 */ .kLt.from_bech32(address);
    } catch (_e2) {
      throw new Error("Could not deserialize address.");
    }
  }
}
function credentialToRewardAddress(network, stakeCredential) {
  return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RewardAddress["new"] */ .mf5["new"](
    networkToId(network),
    stakeCredential.type === "Key" ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_pub_key */ .hJE.new_pub_key(
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Ed25519KeyHash.from_hex */ ._Wl.from_hex(stakeCredential.hash)
    ) : _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Credential.new_script */ .hJE.new_script(
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ScriptHash.from_hex */ .nJe.from_hex(stakeCredential.hash)
    )
  ).to_address().to_bech32(void 0);
}
function validatorToRewardAddress(network, validator) {
  const validatorHash = validatorToScriptHash(validator);
  return CML.RewardAddress.new(
    networkToId(network),
    CML.Credential.new_script(CML.ScriptHash.from_hex(validatorHash))
  ).to_address().to_bech32(void 0);
}
function getAddressDetails(address) {
  try {
    const parsedAddress = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .BaseAddress.from_address */ .pv.from_address(
      addressFromHexOrBech32(address)
    );
    const paymentCredential = parsedAddress.payment().kind() === 0 ? {
      type: "Key",
      hash: parsedAddress.payment().as_pub_key().to_hex()
    } : {
      type: "Script",
      hash: parsedAddress.payment().as_script().to_hex()
    };
    const stakeCredential = parsedAddress.stake().kind() === 0 ? {
      type: "Key",
      hash: parsedAddress.stake().as_pub_key().to_hex()
    } : {
      type: "Script",
      hash: parsedAddress.stake().as_script().to_hex()
    };
    return {
      type: "Base",
      networkId: parsedAddress.to_address().network_id(),
      address: {
        bech32: parsedAddress.to_address().to_bech32(void 0),
        hex: parsedAddress.to_address().to_hex()
      },
      paymentCredential,
      stakeCredential
    };
  } catch (_e) {
  }
  try {
    const parsedAddress = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .EnterpriseAddress.from_address */ .Z0E.from_address(
      addressFromHexOrBech32(address)
    );
    const paymentCredential = parsedAddress.payment().kind() === 0 ? {
      type: "Key",
      hash: parsedAddress.payment().as_pub_key().to_hex()
    } : {
      type: "Script",
      hash: parsedAddress.payment().as_script().to_hex()
    };
    return {
      type: "Enterprise",
      networkId: parsedAddress.to_address().network_id(),
      address: {
        bech32: parsedAddress.to_address().to_bech32(void 0),
        hex: parsedAddress.to_address().to_hex()
      },
      paymentCredential
    };
  } catch (_e) {
  }
  try {
    const parsedAddress = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PointerAddress.from_address */ .gdK.from_address(
      addressFromHexOrBech32(address)
    );
    const paymentCredential = parsedAddress?.payment().kind() === 0 ? {
      type: "Key",
      hash: parsedAddress.payment().as_pub_key().to_hex()
    } : {
      type: "Script",
      hash: parsedAddress.payment().as_script().to_hex()
    };
    return {
      type: "Pointer",
      networkId: parsedAddress.to_address().network_id(),
      address: {
        bech32: parsedAddress.to_address().to_bech32(void 0),
        hex: parsedAddress.to_address().to_hex()
      },
      paymentCredential
    };
  } catch (_e) {
  }
  try {
    const parsedAddress = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RewardAddress.from_address */ .mf5.from_address(
      addressFromHexOrBech32(address)
    );
    const stakeCredential = parsedAddress.payment().kind() === 0 ? {
      type: "Key",
      hash: parsedAddress.payment().as_pub_key().to_hex()
    } : {
      type: "Script",
      hash: parsedAddress.payment().as_script().to_hex()
    };
    return {
      type: "Reward",
      networkId: parsedAddress.to_address().network_id(),
      address: {
        bech32: parsedAddress.to_address().to_bech32(void 0),
        hex: parsedAddress.to_address().to_hex()
      },
      stakeCredential
    };
  } catch (_e) {
  }
  try {
    const parsedAddress = ((address2) => {
      try {
        return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ByronAddress.from_cbor_hex */ .jZ5.from_cbor_hex(address2);
      } catch (_e) {
        try {
          return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ByronAddress.from_base58 */ .jZ5.from_base58(address2);
        } catch (_e2) {
          throw new Error("Could not deserialize address.");
        }
      }
    })(address);
    return {
      type: "Byron",
      networkId: parsedAddress.content().network_id(),
      address: {
        bech32: "",
        hex: parsedAddress.to_address().to_hex()
      }
    };
  } catch (_e) {
  }
  throw new Error("No address type matched for: " + address);
}

// src/cost_model.ts
function createCostModels(costModels) {
  const costmodel = {
    0: [],
    1: [],
    2: []
  };
  for (const cost of Object.values(costModels.PlutusV1)) {
    costmodel[0]?.push(cost);
  }
  for (const cost of Object.values(costModels.PlutusV2)) {
    costmodel[1]?.push(cost);
  }
  for (const cost of Object.values(costModels.PlutusV3)) {
    costmodel[2]?.push(cost);
  }
  return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .CostModels.from_json */ .yYJ.from_json(JSON.stringify(costmodel));
}
var PROTOCOL_PARAMETERS_DEFAULT = {
  minFeeA: 44,
  minFeeB: 155381,
  maxTxSize: 16384,
  maxValSize: 5e3,
  keyDeposit: 2000000n,
  poolDeposit: 500000000n,
  drepDeposit: 500000000n,
  govActionDeposit: 100000000000n,
  priceMem: 0.0577,
  priceStep: 721e-7,
  maxTxExMem: 14000000n,
  maxTxExSteps: 10000000000n,
  coinsPerUtxoByte: 4310n,
  collateralPercentage: 150,
  maxCollateralInputs: 3,
  minFeeRefScriptCostPerByte: 15,
  costModels: {
    PlutusV1: {
      "0": 100788,
      "1": 420,
      "2": 1,
      "3": 1,
      "4": 1e3,
      "5": 173,
      "6": 0,
      "7": 1,
      "8": 1e3,
      "9": 59957,
      "10": 4,
      "11": 1,
      "12": 11183,
      "13": 32,
      "14": 201305,
      "15": 8356,
      "16": 4,
      "17": 16e3,
      "18": 100,
      "19": 16e3,
      "20": 100,
      "21": 16e3,
      "22": 100,
      "23": 16e3,
      "24": 100,
      "25": 16e3,
      "26": 100,
      "27": 16e3,
      "28": 100,
      "29": 100,
      "30": 100,
      "31": 16e3,
      "32": 100,
      "33": 94375,
      "34": 32,
      "35": 132994,
      "36": 32,
      "37": 61462,
      "38": 4,
      "39": 72010,
      "40": 178,
      "41": 0,
      "42": 1,
      "43": 22151,
      "44": 32,
      "45": 91189,
      "46": 769,
      "47": 4,
      "48": 2,
      "49": 85848,
      "50": 228465,
      "51": 122,
      "52": 0,
      "53": 1,
      "54": 1,
      "55": 1e3,
      "56": 42921,
      "57": 4,
      "58": 2,
      "59": 24548,
      "60": 29498,
      "61": 38,
      "62": 1,
      "63": 898148,
      "64": 27279,
      "65": 1,
      "66": 51775,
      "67": 558,
      "68": 1,
      "69": 39184,
      "70": 1e3,
      "71": 60594,
      "72": 1,
      "73": 141895,
      "74": 32,
      "75": 83150,
      "76": 32,
      "77": 15299,
      "78": 32,
      "79": 76049,
      "80": 1,
      "81": 13169,
      "82": 4,
      "83": 22100,
      "84": 10,
      "85": 28999,
      "86": 74,
      "87": 1,
      "88": 28999,
      "89": 74,
      "90": 1,
      "91": 43285,
      "92": 552,
      "93": 1,
      "94": 44749,
      "95": 541,
      "96": 1,
      "97": 33852,
      "98": 32,
      "99": 68246,
      "100": 32,
      "101": 72362,
      "102": 32,
      "103": 7243,
      "104": 32,
      "105": 7391,
      "106": 32,
      "107": 11546,
      "108": 32,
      "109": 85848,
      "110": 228465,
      "111": 122,
      "112": 0,
      "113": 1,
      "114": 1,
      "115": 90434,
      "116": 519,
      "117": 0,
      "118": 1,
      "119": 74433,
      "120": 32,
      "121": 85848,
      "122": 228465,
      "123": 122,
      "124": 0,
      "125": 1,
      "126": 1,
      "127": 85848,
      "128": 228465,
      "129": 122,
      "130": 0,
      "131": 1,
      "132": 1,
      "133": 270652,
      "134": 22588,
      "135": 4,
      "136": 1457325,
      "137": 64566,
      "138": 4,
      "139": 20467,
      "140": 1,
      "141": 4,
      "142": 0,
      "143": 141992,
      "144": 32,
      "145": 100788,
      "146": 420,
      "147": 1,
      "148": 1,
      "149": 81663,
      "150": 32,
      "151": 59498,
      "152": 32,
      "153": 20142,
      "154": 32,
      "155": 24588,
      "156": 32,
      "157": 20744,
      "158": 32,
      "159": 25933,
      "160": 32,
      "161": 24623,
      "162": 32,
      "163": 53384111,
      "164": 14333,
      "165": 10
    },
    PlutusV2: {
      "0": 100788,
      "1": 420,
      "2": 1,
      "3": 1,
      "4": 1e3,
      "5": 173,
      "6": 0,
      "7": 1,
      "8": 1e3,
      "9": 59957,
      "10": 4,
      "11": 1,
      "12": 11183,
      "13": 32,
      "14": 201305,
      "15": 8356,
      "16": 4,
      "17": 16e3,
      "18": 100,
      "19": 16e3,
      "20": 100,
      "21": 16e3,
      "22": 100,
      "23": 16e3,
      "24": 100,
      "25": 16e3,
      "26": 100,
      "27": 16e3,
      "28": 100,
      "29": 100,
      "30": 100,
      "31": 16e3,
      "32": 100,
      "33": 94375,
      "34": 32,
      "35": 132994,
      "36": 32,
      "37": 61462,
      "38": 4,
      "39": 72010,
      "40": 178,
      "41": 0,
      "42": 1,
      "43": 22151,
      "44": 32,
      "45": 91189,
      "46": 769,
      "47": 4,
      "48": 2,
      "49": 85848,
      "50": 228465,
      "51": 122,
      "52": 0,
      "53": 1,
      "54": 1,
      "55": 1e3,
      "56": 42921,
      "57": 4,
      "58": 2,
      "59": 24548,
      "60": 29498,
      "61": 38,
      "62": 1,
      "63": 898148,
      "64": 27279,
      "65": 1,
      "66": 51775,
      "67": 558,
      "68": 1,
      "69": 39184,
      "70": 1e3,
      "71": 60594,
      "72": 1,
      "73": 141895,
      "74": 32,
      "75": 83150,
      "76": 32,
      "77": 15299,
      "78": 32,
      "79": 76049,
      "80": 1,
      "81": 13169,
      "82": 4,
      "83": 22100,
      "84": 10,
      "85": 28999,
      "86": 74,
      "87": 1,
      "88": 28999,
      "89": 74,
      "90": 1,
      "91": 43285,
      "92": 552,
      "93": 1,
      "94": 44749,
      "95": 541,
      "96": 1,
      "97": 33852,
      "98": 32,
      "99": 68246,
      "100": 32,
      "101": 72362,
      "102": 32,
      "103": 7243,
      "104": 32,
      "105": 7391,
      "106": 32,
      "107": 11546,
      "108": 32,
      "109": 85848,
      "110": 228465,
      "111": 122,
      "112": 0,
      "113": 1,
      "114": 1,
      "115": 90434,
      "116": 519,
      "117": 0,
      "118": 1,
      "119": 74433,
      "120": 32,
      "121": 85848,
      "122": 228465,
      "123": 122,
      "124": 0,
      "125": 1,
      "126": 1,
      "127": 85848,
      "128": 228465,
      "129": 122,
      "130": 0,
      "131": 1,
      "132": 1,
      "133": 955506,
      "134": 213312,
      "135": 0,
      "136": 2,
      "137": 270652,
      "138": 22588,
      "139": 4,
      "140": 1457325,
      "141": 64566,
      "142": 4,
      "143": 20467,
      "144": 1,
      "145": 4,
      "146": 0,
      "147": 141992,
      "148": 32,
      "149": 100788,
      "150": 420,
      "151": 1,
      "152": 1,
      "153": 81663,
      "154": 32,
      "155": 59498,
      "156": 32,
      "157": 20142,
      "158": 32,
      "159": 24588,
      "160": 32,
      "161": 20744,
      "162": 32,
      "163": 25933,
      "164": 32,
      "165": 24623,
      "166": 32,
      "167": 43053543,
      "168": 10,
      "169": 53384111,
      "170": 14333,
      "171": 10,
      "172": 43574283,
      "173": 26308,
      "174": 10
    },
    PlutusV3: {
      "0": 100788,
      "1": 420,
      "2": 1,
      "3": 1,
      "4": 1e3,
      "5": 173,
      "6": 0,
      "7": 1,
      "8": 1e3,
      "9": 59957,
      "10": 4,
      "11": 1,
      "12": 11183,
      "13": 32,
      "14": 201305,
      "15": 8356,
      "16": 4,
      "17": 16e3,
      "18": 100,
      "19": 16e3,
      "20": 100,
      "21": 16e3,
      "22": 100,
      "23": 16e3,
      "24": 100,
      "25": 16e3,
      "26": 100,
      "27": 16e3,
      "28": 100,
      "29": 100,
      "30": 100,
      "31": 16e3,
      "32": 100,
      "33": 94375,
      "34": 32,
      "35": 132994,
      "36": 32,
      "37": 61462,
      "38": 4,
      "39": 72010,
      "40": 178,
      "41": 0,
      "42": 1,
      "43": 22151,
      "44": 32,
      "45": 91189,
      "46": 769,
      "47": 4,
      "48": 2,
      "49": 85848,
      "50": 123203,
      "51": 7305,
      "52": -900,
      "53": 1716,
      "54": 549,
      "55": 57,
      "56": 85848,
      "57": 0,
      "58": 1,
      "59": 1,
      "60": 1e3,
      "61": 42921,
      "62": 4,
      "63": 2,
      "64": 24548,
      "65": 29498,
      "66": 38,
      "67": 1,
      "68": 898148,
      "69": 27279,
      "70": 1,
      "71": 51775,
      "72": 558,
      "73": 1,
      "74": 39184,
      "75": 1e3,
      "76": 60594,
      "77": 1,
      "78": 141895,
      "79": 32,
      "80": 83150,
      "81": 32,
      "82": 15299,
      "83": 32,
      "84": 76049,
      "85": 1,
      "86": 13169,
      "87": 4,
      "88": 22100,
      "89": 10,
      "90": 28999,
      "91": 74,
      "92": 1,
      "93": 28999,
      "94": 74,
      "95": 1,
      "96": 43285,
      "97": 552,
      "98": 1,
      "99": 44749,
      "100": 541,
      "101": 1,
      "102": 33852,
      "103": 32,
      "104": 68246,
      "105": 32,
      "106": 72362,
      "107": 32,
      "108": 7243,
      "109": 32,
      "110": 7391,
      "111": 32,
      "112": 11546,
      "113": 32,
      "114": 85848,
      "115": 123203,
      "116": 7305,
      "117": -900,
      "118": 1716,
      "119": 549,
      "120": 57,
      "121": 85848,
      "122": 0,
      "123": 1,
      "124": 90434,
      "125": 519,
      "126": 0,
      "127": 1,
      "128": 74433,
      "129": 32,
      "130": 85848,
      "131": 123203,
      "132": 7305,
      "133": -900,
      "134": 1716,
      "135": 549,
      "136": 57,
      "137": 85848,
      "138": 0,
      "139": 1,
      "140": 1,
      "141": 85848,
      "142": 123203,
      "143": 7305,
      "144": -900,
      "145": 1716,
      "146": 549,
      "147": 57,
      "148": 85848,
      "149": 0,
      "150": 1,
      "151": 955506,
      "152": 213312,
      "153": 0,
      "154": 2,
      "155": 270652,
      "156": 22588,
      "157": 4,
      "158": 1457325,
      "159": 64566,
      "160": 4,
      "161": 20467,
      "162": 1,
      "163": 4,
      "164": 0,
      "165": 141992,
      "166": 32,
      "167": 100788,
      "168": 420,
      "169": 1,
      "170": 1,
      "171": 81663,
      "172": 32,
      "173": 59498,
      "174": 32,
      "175": 20142,
      "176": 32,
      "177": 24588,
      "178": 32,
      "179": 20744,
      "180": 32,
      "181": 25933,
      "182": 32,
      "183": 24623,
      "184": 32,
      "185": 43053543,
      "186": 10,
      "187": 53384111,
      "188": 14333,
      "189": 10,
      "190": 43574283,
      "191": 26308,
      "192": 10,
      "193": 16e3,
      "194": 100,
      "195": 16e3,
      "196": 100,
      "197": 962335,
      "198": 18,
      "199": 2780678,
      "200": 6,
      "201": 442008,
      "202": 1,
      "203": 52538055,
      "204": 3756,
      "205": 18,
      "206": 267929,
      "207": 18,
      "208": 76433006,
      "209": 8868,
      "210": 18,
      "211": 52948122,
      "212": 18,
      "213": 1995836,
      "214": 36,
      "215": 3227919,
      "216": 12,
      "217": 901022,
      "218": 1,
      "219": 166917843,
      "220": 4307,
      "221": 36,
      "222": 284546,
      "223": 36,
      "224": 158221314,
      "225": 26549,
      "226": 36,
      "227": 74698472,
      "228": 36,
      "229": 333849714,
      "230": 1,
      "231": 254006273,
      "232": 72,
      "233": 2174038,
      "234": 72,
      "235": 2261318,
      "236": 64571,
      "237": 4,
      "238": 207616,
      "239": 8310,
      "240": 4,
      "241": 1293828,
      "242": 28716,
      "243": 63,
      "244": 0,
      "245": 1,
      "246": 1006041,
      "247": 43623,
      "248": 251,
      "249": 0,
      "250": 1,
      "251": 100181,
      "252": 726,
      "253": 719,
      "254": 0,
      "255": 1,
      "256": 100181,
      "257": 726,
      "258": 719,
      "259": 0,
      "260": 1,
      "261": 100181,
      "262": 726,
      "263": 719,
      "264": 0,
      "265": 1,
      "266": 107878,
      "267": 680,
      "268": 0,
      "269": 1,
      "270": 95336,
      "271": 1,
      "272": 281145,
      "273": 18848,
      "274": 0,
      "275": 1,
      "276": 180194,
      "277": 159,
      "278": 1,
      "279": 1,
      "280": 158519,
      "281": 8942,
      "282": 0,
      "283": 1,
      "284": 159378,
      "285": 8813,
      "286": 0,
      "287": 1,
      "288": 107490,
      "289": 3298,
      "290": 1,
      "291": 106057,
      "292": 655,
      "293": 1,
      "294": 1964219,
      "295": 24520,
      "296": 3
    }
  }
};

// src/credential.ts

function credentialToAddress(network, paymentCredential, stakeCredential) {
  if (stakeCredential) {
    return CML.BaseAddress.new(
      networkToId(network),
      paymentCredential.type === "Key" ? CML.Credential.new_pub_key(
        CML.Ed25519KeyHash.from_hex(paymentCredential.hash)
      ) : CML.Credential.new_script(
        CML.ScriptHash.from_hex(paymentCredential.hash)
      ),
      stakeCredential.type === "Key" ? CML.Credential.new_pub_key(
        CML.Ed25519KeyHash.from_hex(stakeCredential.hash)
      ) : CML.Credential.new_script(
        CML.ScriptHash.from_hex(stakeCredential.hash)
      )
    ).to_address().to_bech32(void 0);
  } else {
    return CML.EnterpriseAddress.new(
      networkToId(network),
      paymentCredential.type === "Key" ? CML.Credential.new_pub_key(
        CML.Ed25519KeyHash.from_hex(paymentCredential.hash)
      ) : CML.Credential.new_script(
        CML.ScriptHash.from_hex(paymentCredential.hash)
      )
    ).to_address().to_bech32(void 0);
  }
}
function scriptHashToCredential(scriptHash) {
  return {
    type: "Script",
    hash: scriptHash
  };
}
function keyHashToCredential(keyHash) {
  return {
    type: "Key",
    hash: keyHash
  };
}
function paymentCredentialOf(address) {
  const { paymentCredential } = getAddressDetails(address);
  if (!paymentCredential) {
    throw new Error(
      "The specified address does not contain a payment credential."
    );
  }
  return paymentCredential;
}
function stakeCredentialOf(rewardAddress) {
  const { stakeCredential } = getAddressDetails(rewardAddress);
  if (!stakeCredential) {
    throw new Error(
      "The specified address does not contain a stake credential."
    );
  }
  return stakeCredential;
}
var drepIDToCredential = (drepID) => {
  if (!Cardano.DRepID.isValid(drepID)) {
    throw new Error(`Invalid DRep ID: ${drepID}`);
  }
  const drepId = Cardano.DRepID(drepID);
  const drepCred = Cardano.DRepID.toCredential(drepId);
  return {
    type: drepCred.type == Cardano.CredentialType.KeyHash ? "Key" : "Script",
    hash: drepCred.hash
  };
};

// src/datum.ts
function datumToHash(datum) {
  return CML.hash_plutus_data(CML.PlutusData.from_cbor_hex(datum)).to_hex();
}

// src/keys.ts

function generatePrivateKey() {
  return CML.PrivateKey.generate_ed25519().to_bech32();
}
function generateSeedPhrase() {
  return generateMnemonic(256);
}
function toPublicKey(privateKey) {
  return CML.PrivateKey.from_bech32(privateKey).to_public().to_bech32();
}

// src/label.ts


function toLabel(num) {
  if (num < 0 || num > 65535) {
    throw new Error(
      `Label ${num} out of range: min label 1 - max label 65535.`
    );
  }
  const numHex = num.toString(16).padStart(4, "0");
  return "0" + numHex + checksum(numHex) + "0";
}
function fromLabel(label) {
  if (label.length !== 8 || !(label[0] === "0" && label[7] === "0")) {
    return null;
  }
  const numHex = label.slice(1, 5);
  const num = parseInt(numHex, 16);
  const check = label.slice(5, 7);
  return check === checksum(numHex) ? num : null;
}
function checksum(num) {
  return (0,_lucid_evolution_crc8__WEBPACK_IMPORTED_MODULE_9__/* .crc8 */ .t)((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_3__/* .fromHex */ .H_)(num)).toString(16).padStart(2, "0");
}

// src/time.ts

function unixTimeToSlot(network, unixTime) {
  return (0,_lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_5__/* .unixTimeToEnclosingSlot */ .WN)(unixTime, _lucid_evolution_plutus__WEBPACK_IMPORTED_MODULE_5__/* .SLOT_CONFIG_NETWORK */ .BV[network]);
}
function slotToUnixTime(network, slot) {
  return slotToBeginUnixTime(slot, SLOT_CONFIG_NETWORK[network]);
}

// src/value.ts


function valueToAssets(value) {
  const assets = {};
  assets["lovelace"] = value.coin();
  if (value.has_multiassets()) {
    const ma = value.multi_asset();
    const multiAssets = ma.keys();
    for (let j = 0; j < multiAssets.len(); j++) {
      const policy = multiAssets.get(j);
      const policyAssets = ma.get_assets(policy);
      const assetNames = policyAssets.keys();
      for (let k = 0; k < assetNames.len(); k++) {
        const policyAsset = assetNames.get(k);
        const quantity = policyAssets.get(policyAsset);
        const unit = policy.to_hex() + policyAsset.to_js_value();
        assets[unit] = quantity;
      }
    }
  }
  return assets;
}
function assetsToValue(assets) {
  const multiAsset = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .MultiAsset["new"] */ .MLF["new"]();
  const lovelace = assets["lovelace"] ? BigInt(assets["lovelace"]) : 0n;
  const units = Object.keys(assets);
  const policies = Array.from(
    new Set(
      units.filter((unit) => unit !== "lovelace").map((unit) => unit.slice(0, 56))
    )
  );
  for (const policy of policies) {
    const policyUnits = units.filter((unit) => unit.slice(0, 56) === policy);
    const assetsValue = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .MapAssetNameToCoin["new"] */ .pJ9["new"]();
    for (const unit of policyUnits) {
      assetsValue.insert(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .AssetName.from_hex */ .JfL.from_hex(unit.slice(56)),
        BigInt(assets[unit])
      );
    }
    multiAsset.insert_assets(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .ScriptHash.from_hex */ .nJe.from_hex(policy), assetsValue);
  }
  return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Value["new"] */ .B4R["new"](lovelace, multiAsset);
}
function fromUnit(unit) {
  const policyId = unit.slice(0, 56);
  const assetName = unit.slice(56) || null;
  const label = fromLabel(unit.slice(56, 64));
  const name = (() => {
    const hexName = Number.isInteger(label) ? unit.slice(64) : unit.slice(56);
    return hexName || null;
  })();
  return { policyId, assetName, name, label };
}
function toUnit(policyId, name, label) {
  const hexLabel = Number.isInteger(label) ? toLabel(label) : "";
  const n = name ? name : "";
  if ((n + hexLabel).length > 64) {
    throw new Error("Asset name size exceeds 32 bytes.");
  }
  if (policyId.length !== 56) {
    throw new Error(`Policy id invalid: ${policyId}.`);
  }
  return policyId + hexLabel + n;
}
function addAssets(...assets) {
  return assets.reduce((a, b) => {
    for (const k in b) {
      if (Object.hasOwn(b, k)) {
        const sum = (a[k] || 0n) + b[k];
        if (sum === 0n) {
          delete a[k];
        } else {
          a[k] = sum;
        }
      }
    }
    return a;
  }, {});
}
async function getUniqueTokenName(utxo) {
  const id = fromHex4(utxo.txHash);
  const data = new Uint8Array([utxo.outputIndex, ...id]);
  const hash = new Uint8Array(await crypto.subtle.digest("SHA3-256", data));
  return toHex3(hash);
}
var sortCanonical = (assets) => pipe(
  Object.entries(assets).sort(([aUnit], [bUnit]) => {
    const a = fromUnit(aUnit);
    const b = fromUnit(bUnit);
    if (a.policyId.length !== b.policyId.length)
      return a.policyId.length - b.policyId.length;
    if (a.policyId === b.policyId) {
      const aAssetName = a.assetName || "";
      const bAssetName = b.assetName || "";
      if (aAssetName.length !== bAssetName.length)
        return aAssetName.length - bAssetName.length;
      return aAssetName.localeCompare(bAssetName);
    }
    return a.policyId.localeCompare(b.policyId);
  }),
  Object.fromEntries
);

// src/utxo.ts
var utxoToTransactionOutput = (utxo) => {
  return buildOutput(utxo).with_value(assetsToValue(utxo.assets)).build().output();
};
var utxoToTransactionInput = (utxo) => {
  return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionInput["new"] */ .XRW["new"](
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionHash.from_hex */ .wf_.from_hex(utxo.txHash),
    BigInt(utxo.outputIndex)
  );
};
var utxoToCore = (utxo) => {
  const out = utxoToTransactionOutput(utxo);
  const utxoCore = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionUnspentOutput["new"] */ .ZAD["new"](
    utxoToTransactionInput(utxo),
    out
  );
  return utxoCore;
};
function utxosToCores(utxos) {
  const result = [];
  for (const utxo of utxos) {
    result.push(utxoToCore(utxo));
  }
  return result;
}
function coreToUtxo(coreUtxo) {
  const utxo = {
    ...coreToOutRef(coreUtxo.input()),
    ...coreToTxOutput(coreUtxo.output())
  };
  return utxo;
}
function coresToUtxos(utxos) {
  const result = [];
  for (let i = 0; i < utxos.length; i++) {
    result.push(coreToUtxo(utxos[i]));
  }
  return result;
}
function coreToOutRef(input) {
  return {
    txHash: input.transaction_id().to_hex(),
    outputIndex: parseInt(input.index().toString())
  };
}
function coresToOutRefs(inputs) {
  const result = [];
  for (let i = 0; i < inputs.length; i++) {
    result.push(coreToOutRef(inputs[i]));
  }
  return result;
}
function coreToTxOutput(output) {
  return {
    assets: valueToAssets(output.amount()),
    address: output.address().to_bech32(void 0),
    datumHash: output.datum()?.as_hash()?.to_hex(),
    datum: output.datum()?.as_datum()?.to_cbor_hex(),
    scriptRef: output.script_ref() && fromScriptRef(output.script_ref())
  };
}
function coresToTxOutputs(outputs) {
  let result = [];
  for (let i = 0; i < outputs.length; i++) {
    result.push(coreToTxOutput(outputs[i]));
  }
  return result;
}
var selectUTxOs = (utxos, totalAssets, includeUTxOsWithScriptRef = false) => {
  const selectedUtxos = [];
  let isSelected = false;
  const assetsRequired = new Map(Object.entries(totalAssets));
  for (const utxo of utxos) {
    if (!includeUTxOsWithScriptRef && utxo.scriptRef) continue;
    isSelected = false;
    for (const [unit, amount] of assetsRequired) {
      if (Object.hasOwn(utxo.assets, unit)) {
        const utxoAmount = utxo.assets[unit];
        if (utxoAmount >= amount) {
          assetsRequired.delete(unit);
        } else {
          assetsRequired.set(unit, amount - utxoAmount);
        }
        isSelected = true;
      }
    }
    if (isSelected) {
      selectedUtxos.push(utxo);
    }
    if (assetsRequired.size == 0) {
      break;
    }
  }
  if (assetsRequired.size > 0) return [];
  return selectedUtxos;
};
var sortUTxOs = (utxos, order = "LargestFirst") => {
  switch (order) {
    case "LargestFirst":
      return [...utxos].sort(largestFirst);
    case "SmallestFirst":
      return [...utxos].sort(smallestFirst);
    case "Canonical":
      return [...utxos].sort(canonical);
  }
};
var largestFirst = (a, b) => {
  const lovelaceA = Number(a.assets["lovelace"]);
  const lovelaceB = Number(b.assets["lovelace"]);
  if (lovelaceA === lovelaceB) {
    return Object.keys(a.assets).length - Object.keys(b.assets).length;
  }
  return -1 * (lovelaceA - lovelaceB);
};
var smallestFirst = (a, b) => {
  const lovelaceA = Number(a.assets["lovelace"]);
  const lovelaceB = Number(b.assets["lovelace"]);
  if (lovelaceA == lovelaceB) {
    return Object.keys(a.assets).length - Object.keys(b.assets).length;
  }
  return lovelaceA - lovelaceB;
};
var canonical = (a, b) => {
  if (a.txHash < b.txHash) {
    return -1;
  } else if (a.txHash > b.txHash) {
    return 1;
  } else {
    return a.outputIndex - b.outputIndex;
  }
};
var isEqualUTxO = (self, that) => self.txHash === that.txHash && self.outputIndex === that.outputIndex;
function getInputIndices(indexInputs, allInputs, sorted = false) {
  const sortedInputs = sorted ? allInputs : sortUTxOs(allInputs, "Canonical");
  const indicesMap = /* @__PURE__ */ new Map();
  sortedInputs.forEach((value, index) => {
    indicesMap.set(value.txHash + value.outputIndex, BigInt(index));
  });
  return indexInputs.flatMap((value) => {
    const index = indicesMap.get(value.txHash + value.outputIndex);
    if (index !== void 0) return index;
    else return [];
  });
}
var calculateMinLovelaceFromUTxO = (coinsPerUtxoByte, utxo) => buildOutput(utxo).with_asset_and_min_required_coin(
  assetsToValue(utxo.assets).multi_asset(),
  coinsPerUtxoByte
).build().output().amount().coin();
var buildOutput = (utxo) => {
  const builder = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .TransactionOutputBuilder["new"] */ .eVX["new"]().with_address(
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .Address.from_bech32 */ .kLt.from_bech32(utxo.address)
  );
  return utxo.scriptRef ? buildDatum(utxo, builder).with_reference_script(toScriptRef(utxo.scriptRef)).next() : buildDatum(utxo, builder).next();
};
var buildDatum = (utxo, builder) => {
  if (utxo.datumHash && utxo.datum)
    return builder.with_communication_data(
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusData.from_cbor_hex */ .$zK.from_cbor_hex(utxo.datum)
    );
  if (utxo.datum)
    return builder.with_data(
      _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .DatumOption.new_datum */ .QjN.new_datum(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .PlutusData.from_cbor_hex */ .$zK.from_cbor_hex(utxo.datum))
    );
  return builder;
};

// src/objects.ts
var stringify = (data) => JSON.stringify(
  data,
  (key, value) => typeof value === "bigint" ? value.toString() + "n" : value,
  2
);

// src/redeemer.ts
var toCMLRedeemerTag = (tag) => {
  switch (tag) {
    case "spend":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerTag.Spend */ .QSL.Spend;
    case "mint":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerTag.Mint */ .QSL.Mint;
    case "publish":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerTag.Cert */ .QSL.Cert;
    case "withdraw":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerTag.Reward */ .QSL.Reward;
    case "vote":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerTag.Voting */ .QSL.Voting;
    case "propose":
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerTag.Proposing */ .QSL.Proposing;
    default:
      throw new Error(`Exhaustive check failed: Unhandled case ${tag}`);
  }
};
var fromCMLRedeemerTag = (tag) => {
  switch (tag) {
    case _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerTag.Spend */ .QSL.Spend:
      return "spend";
    case _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerTag.Mint */ .QSL.Mint:
      return "mint";
    case _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerTag.Cert */ .QSL.Cert:
      return "publish";
    case _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerTag.Reward */ .QSL.Reward:
      return "withdraw";
    case _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerTag.Voting */ .QSL.Voting:
      return "vote";
    case _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_0__/* .RedeemerTag.Proposing */ .QSL.Proposing:
      return "propose";
    default:
      throw new Error(`Exhaustive check failed: Unhandled case ${tag}`);
  }
};


__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 27677:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ neverKeyword; },
/* harmony export */   "AI": function() { return /* binding */ IndexSignature; },
/* harmony export */   "AR": function() { return /* binding */ getAnnotation; },
/* harmony export */   "Aj": function() { return /* binding */ DescriptionAnnotationId; },
/* harmony export */   "B$": function() { return /* binding */ Refinement; },
/* harmony export */   "Bh": function() { return /* binding */ encodedAST; },
/* harmony export */   "CA": function() { return /* binding */ IdentifierAnnotationId; },
/* harmony export */   "DZ": function() { return /* binding */ objectKeyword; },
/* harmony export */   "Dr": function() { return /* binding */ defaultParseOption; },
/* harmony export */   "Dy": function() { return /* binding */ Type; },
/* harmony export */   "EJ": function() { return /* binding */ Union; },
/* harmony export */   "GY": function() { return /* binding */ mapMembers; },
/* harmony export */   "H1": function() { return /* binding */ OptionalType; },
/* harmony export */   "I4": function() { return /* binding */ TypeAnnotationId; },
/* harmony export */   "IM": function() { return /* binding */ record; },
/* harmony export */   "Jg": function() { return /* binding */ isMembers; },
/* harmony export */   "KN": function() { return /* binding */ symbolKeyword; },
/* harmony export */   "Lf": function() { return /* binding */ TitleAnnotationId; },
/* harmony export */   "M7": function() { return /* binding */ getTemplateLiteralRegExp; },
/* harmony export */   "Nh": function() { return /* binding */ DocumentationAnnotationId; },
/* harmony export */   "O5": function() { return /* binding */ getSurrogateAnnotation; },
/* harmony export */   "Q7": function() { return /* binding */ ConcurrencyAnnotationId; },
/* harmony export */   "Qc": function() { return /* binding */ TupleType; },
/* harmony export */   "TA": function() { return /* binding */ anyKeyword; },
/* harmony export */   "TI": function() { return /* binding */ isRefinement; },
/* harmony export */   "TJ": function() { return /* binding */ PropertySignature; },
/* harmony export */   "TO": function() { return /* binding */ getParseOptionsAnnotation; },
/* harmony export */   "UX": function() { return /* binding */ Suspend; },
/* harmony export */   "Uy": function() { return /* binding */ ParseIssueTitleAnnotationId; },
/* harmony export */   "V5": function() { return /* binding */ PropertySignatureTransformation; },
/* harmony export */   "VF": function() { return /* binding */ UniqueSymbol; },
/* harmony export */   "Yc": function() { return /* binding */ typeAST; },
/* harmony export */   "aN": function() { return /* binding */ JSONSchemaAnnotationId; },
/* harmony export */   "ai": function() { return /* binding */ unknownKeyword; },
/* harmony export */   "by": function() { return /* binding */ ExamplesAnnotationId; },
/* harmony export */   "d1": function() { return /* binding */ getParseIssueTitleAnnotation; },
/* harmony export */   "ds": function() { return /* binding */ annotations; },
/* harmony export */   "eg": function() { return /* binding */ MessageAnnotationId; },
/* harmony export */   "ej": function() { return /* binding */ getMissingMessageAnnotation; },
/* harmony export */   "gI": function() { return /* binding */ preserveAnnotations; },
/* harmony export */   "gr": function() { return /* binding */ Declaration; },
/* harmony export */   "gx": function() { return /* binding */ bigIntKeyword; },
/* harmony export */   "hA": function() { return /* binding */ booleanKeyword; },
/* harmony export */   "hw": function() { return /* binding */ stringKeyword; },
/* harmony export */   "iD": function() { return /* binding */ MissingMessageAnnotationId; },
/* harmony export */   "lB": function() { return /* binding */ $null; },
/* harmony export */   "mm": function() { return /* binding */ getConcurrencyAnnotation; },
/* harmony export */   "n2": function() { return /* binding */ TypeLiteralTransformation; },
/* harmony export */   "n_": function() { return /* binding */ isLiteral; },
/* harmony export */   "oA": function() { return /* binding */ BatchingAnnotationId; },
/* harmony export */   "oH": function() { return /* binding */ FinalTransformation; },
/* harmony export */   "sC": function() { return /* binding */ getMessageAnnotation; },
/* harmony export */   "t$": function() { return /* binding */ Literal; },
/* harmony export */   "tW": function() { return /* binding */ TypeLiteral; },
/* harmony export */   "uo": function() { return /* binding */ numberKeyword; },
/* harmony export */   "v3": function() { return /* binding */ ParseOptionsAnnotationId; },
/* harmony export */   "w9": function() { return /* binding */ DefaultAnnotationId; },
/* harmony export */   "we": function() { return /* binding */ getBatchingAnnotation; },
/* harmony export */   "x8": function() { return /* binding */ undefinedKeyword; },
/* harmony export */   "zA": function() { return /* binding */ Transformation; },
/* harmony export */   "zv": function() { return /* binding */ voidKeyword; }
/* harmony export */ });
/* unused harmony exports BrandAnnotationId, SurrogateAnnotationId, StableFilterAnnotationId, getBrandAnnotation, getTitleAnnotation, getIdentifierAnnotation, getDescriptionAnnotation, getExamplesAnnotation, getDefaultAnnotation, getJSONSchemaAnnotation, getDocumentationAnnotation, getJSONIdentifierAnnotation, isDeclaration, isUniqueSymbol, UndefinedKeyword, isUndefinedKeyword, VoidKeyword, isVoidKeyword, NeverKeyword, isNeverKeyword, UnknownKeyword, isUnknownKeyword, AnyKeyword, isAnyKeyword, StringKeyword, isStringKeyword, NumberKeyword, isNumberKeyword, BooleanKeyword, isBooleanKeyword, BigIntKeyword, isBigIntKeyword, SymbolKeyword, isSymbolKeyword, ObjectKeyword, isObjectKeyword, Enums, isEnums, TemplateLiteralSpan, TemplateLiteral, isTemplateLiteral, isTupleType, isParameter, isTypeLiteral, flatten, unify, isUnion, isSuspend, isTransformation, isFinalTransformation, ComposeTransformation, composeTransformation, isComposeTransformation, isTypeLiteralTransformation, keyof, getPropertySignatures, getNumberIndexedAccess, getPropertyKeyIndexedAccess, pick, omit, orUndefined, partial, required, mutable, getCompiler, getJSONIdentifier, encodedBoundAST, getCardinality, getWeight, getParameterBase, compose, rename */
/* harmony import */ var effect_Array__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37901);
/* harmony import */ var effect_Function__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17316);
/* harmony import */ var effect_GlobalValue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4726);
/* harmony import */ var effect_Number__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15839);
/* harmony import */ var effect_Option__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16749);
/* harmony import */ var effect_Order__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51988);
/* harmony import */ var effect_Predicate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71335);
/* harmony import */ var effect_RegExp__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7035);
/* harmony import */ var _internal_errors_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69790);
/* harmony import */ var _internal_util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7677);
/**
 * @since 0.67.0
 */










/**
 * @category annotations
 * @since 0.67.0
 */
const BrandAnnotationId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/annotation/Brand")));
/**
 * @category annotations
 * @since 0.67.0
 */
const TypeAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Type");
/**
 * @category annotations
 * @since 0.67.0
 */
const MessageAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Message");
/**
 * @category annotations
 * @since 0.67.0
 */
const MissingMessageAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/MissingMessage");
/**
 * @category annotations
 * @since 0.67.0
 */
const IdentifierAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Identifier");
/**
 * @category annotations
 * @since 0.67.0
 */
const TitleAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Title");
/**
 * @category annotations
 * @since 0.67.0
 */
const DescriptionAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Description");
/**
 * @category annotations
 * @since 0.67.0
 */
const ExamplesAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Examples");
/**
 * @category annotations
 * @since 0.67.0
 */
const DefaultAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Default");
/**
 * @category annotations
 * @since 0.67.0
 */
const JSONSchemaAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/JSONSchema");
/**
 * @category annotations
 * @since 0.67.0
 */
const DocumentationAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Documentation");
/**
 * @category annotations
 * @since 0.67.0
 */
const ConcurrencyAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Concurrency");
/**
 * @category annotations
 * @since 0.67.0
 */
const BatchingAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Batching");
/**
 * @category annotations
 * @since 0.67.0
 */
const ParseIssueTitleAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/ParseIssueTitle");
/**
 * @category annotations
 * @since 0.68.3
 */
const ParseOptionsAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/ParseOptions");
/** @internal */
const SurrogateAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/Surrogate");
/** @internal */
const StableFilterAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/StableFilter");
/**
 * @category annotations
 * @since 0.67.0
 */
const getAnnotation = /*#__PURE__*/(0,effect_Function__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (annotated, key) => Object.prototype.hasOwnProperty.call(annotated.annotations, key) ? effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .some */ .G(annotated.annotations[key]) : effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .none */ .YP());
/**
 * @category annotations
 * @since 0.67.0
 */
const getBrandAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(BrandAnnotationId)));
/**
 * @category annotations
 * @since 0.67.0
 */
const getMessageAnnotation = /*#__PURE__*/getAnnotation(MessageAnnotationId);
/**
 * @category annotations
 * @since 0.67.0
 */
const getMissingMessageAnnotation = /*#__PURE__*/getAnnotation(MissingMessageAnnotationId);
/**
 * @category annotations
 * @since 0.67.0
 */
const getTitleAnnotation = /*#__PURE__*/getAnnotation(TitleAnnotationId);
/**
 * @category annotations
 * @since 0.67.0
 */
const getIdentifierAnnotation = /*#__PURE__*/getAnnotation(IdentifierAnnotationId);
/**
 * @category annotations
 * @since 0.67.0
 */
const getDescriptionAnnotation = /*#__PURE__*/getAnnotation(DescriptionAnnotationId);
/**
 * @category annotations
 * @since 0.67.0
 */
const getExamplesAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(ExamplesAnnotationId)));
/**
 * @category annotations
 * @since 0.67.0
 */
const getDefaultAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(DefaultAnnotationId)));
/**
 * @category annotations
 * @since 0.67.0
 */
const getJSONSchemaAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(JSONSchemaAnnotationId)));
/**
 * @category annotations
 * @since 0.67.0
 */
const getDocumentationAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(DocumentationAnnotationId)));
/**
 * @category annotations
 * @since 0.67.0
 */
const getConcurrencyAnnotation = /*#__PURE__*/getAnnotation(ConcurrencyAnnotationId);
/**
 * @category annotations
 * @since 0.67.0
 */
const getBatchingAnnotation = /*#__PURE__*/getAnnotation(BatchingAnnotationId);
/**
 * @category annotations
 * @since 0.67.0
 */
const getParseIssueTitleAnnotation = /*#__PURE__*/getAnnotation(ParseIssueTitleAnnotationId);
/**
 * @category annotations
 * @since 0.68.3
 */
const getParseOptionsAnnotation = /*#__PURE__*/getAnnotation(ParseOptionsAnnotationId);
/** @internal */
const getSurrogateAnnotation = /*#__PURE__*/getAnnotation(SurrogateAnnotationId);
const getStableFilterAnnotation = /*#__PURE__*/getAnnotation(StableFilterAnnotationId);
const JSONIdentifierAnnotationId = /*#__PURE__*/Symbol.for("@effect/schema/annotation/JSONIdentifier");
/** @internal */
const getJSONIdentifierAnnotation = /*#__PURE__*/getAnnotation(JSONIdentifierAnnotationId);
/**
 * @category model
 * @since 0.67.0
 */
class Declaration {
  typeParameters;
  decodeUnknown;
  encodeUnknown;
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "Declaration";
  constructor(typeParameters, decodeUnknown, encodeUnknown, annotations = {}) {
    this.typeParameters = typeParameters;
    this.decodeUnknown = decodeUnknown;
    this.encodeUnknown = encodeUnknown;
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this), () => "<declaration schema>");
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      typeParameters: this.typeParameters.map(ast => ast.toJSON()),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
const createASTGuard = tag => ast => ast._tag === tag;
/**
 * @category guards
 * @since 0.67.0
 */
const isDeclaration = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("Declaration")));
/**
 * @category model
 * @since 0.67.0
 */
class Literal {
  literal;
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "Literal";
  constructor(literal, annotations = {}) {
    this.literal = literal;
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this), () => _internal_util_js__WEBPACK_IMPORTED_MODULE_2__/* .formatUnknown */ .cT(this.literal));
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      literal: effect_Predicate__WEBPACK_IMPORTED_MODULE_3__/* .isBigInt */ .C4(this.literal) ? String(this.literal) : this.literal,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 0.67.0
 */
const isLiteral = /*#__PURE__*/createASTGuard("Literal");
const $null = /*#__PURE__*/new Literal(null, {
  [IdentifierAnnotationId]: "null"
});

/**
 * @category model
 * @since 0.67.0
 */
class UniqueSymbol {
  symbol;
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "UniqueSymbol";
  constructor(symbol, annotations = {}) {
    this.symbol = symbol;
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this), () => _internal_util_js__WEBPACK_IMPORTED_MODULE_2__/* .formatUnknown */ .cT(this.symbol));
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      symbol: String(this.symbol),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 0.67.0
 */
const isUniqueSymbol = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("UniqueSymbol")));
/**
 * @category model
 * @since 0.67.0
 */
class UndefinedKeyword {
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "UndefinedKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 0.67.0
 */
const undefinedKeyword = /*#__PURE__*/new UndefinedKeyword({
  [TitleAnnotationId]: "undefined"
});
/**
 * @category guards
 * @since 0.67.0
 */
const isUndefinedKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("UndefinedKeyword")));
/**
 * @category model
 * @since 0.67.0
 */
class VoidKeyword {
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "VoidKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 0.67.0
 */
const voidKeyword = /*#__PURE__*/new VoidKeyword({
  [TitleAnnotationId]: "void"
});
/**
 * @category guards
 * @since 0.67.0
 */
const isVoidKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("VoidKeyword")));
/**
 * @category model
 * @since 0.67.0
 */
class NeverKeyword {
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "NeverKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 0.67.0
 */
const neverKeyword = /*#__PURE__*/new NeverKeyword({
  [TitleAnnotationId]: "never"
});
/**
 * @category guards
 * @since 0.67.0
 */
const isNeverKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("NeverKeyword")));
/**
 * @category model
 * @since 0.67.0
 */
class UnknownKeyword {
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "UnknownKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 0.67.0
 */
const unknownKeyword = /*#__PURE__*/new UnknownKeyword({
  [TitleAnnotationId]: "unknown"
});
/**
 * @category guards
 * @since 0.67.0
 */
const isUnknownKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("UnknownKeyword")));
/**
 * @category model
 * @since 0.67.0
 */
class AnyKeyword {
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "AnyKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 0.67.0
 */
const anyKeyword = /*#__PURE__*/new AnyKeyword({
  [TitleAnnotationId]: "any"
});
/**
 * @category guards
 * @since 0.67.0
 */
const isAnyKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("AnyKeyword")));
/**
 * @category model
 * @since 0.67.0
 */
class StringKeyword {
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "StringKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 0.67.0
 */
const stringKeyword = /*#__PURE__*/new StringKeyword({
  [TitleAnnotationId]: "string",
  [DescriptionAnnotationId]: "a string"
});
/**
 * @category guards
 * @since 0.67.0
 */
const isStringKeyword = /*#__PURE__*/createASTGuard("StringKeyword");
/**
 * @category model
 * @since 0.67.0
 */
class NumberKeyword {
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "NumberKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 0.67.0
 */
const numberKeyword = /*#__PURE__*/new NumberKeyword({
  [TitleAnnotationId]: "number",
  [DescriptionAnnotationId]: "a number"
});
/**
 * @category guards
 * @since 0.67.0
 */
const isNumberKeyword = /*#__PURE__*/createASTGuard("NumberKeyword");
/**
 * @category model
 * @since 0.67.0
 */
class BooleanKeyword {
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "BooleanKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 0.67.0
 */
const booleanKeyword = /*#__PURE__*/new BooleanKeyword({
  [TitleAnnotationId]: "boolean",
  [DescriptionAnnotationId]: "a boolean"
});
/**
 * @category guards
 * @since 0.67.0
 */
const isBooleanKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("BooleanKeyword")));
/**
 * @category model
 * @since 0.67.0
 */
class BigIntKeyword {
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "BigIntKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 0.67.0
 */
const bigIntKeyword = /*#__PURE__*/new BigIntKeyword({
  [TitleAnnotationId]: "bigint",
  [DescriptionAnnotationId]: "a bigint"
});
/**
 * @category guards
 * @since 0.67.0
 */
const isBigIntKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("BigIntKeyword")));
/**
 * @category model
 * @since 0.67.0
 */
class SymbolKeyword {
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "SymbolKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 0.67.0
 */
const symbolKeyword = /*#__PURE__*/new SymbolKeyword({
  [TitleAnnotationId]: "symbol",
  [DescriptionAnnotationId]: "a symbol"
});
/**
 * @category guards
 * @since 0.67.0
 */
const isSymbolKeyword = /*#__PURE__*/createASTGuard("SymbolKeyword");
/**
 * @category model
 * @since 0.67.0
 */
class ObjectKeyword {
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "ObjectKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 0.67.0
 */
const objectKeyword = /*#__PURE__*/new ObjectKeyword({
  [IdentifierAnnotationId]: "object",
  [TitleAnnotationId]: "object",
  [DescriptionAnnotationId]: "an object in the TypeScript meaning, i.e. the `object` type"
});
/**
 * @category guards
 * @since 0.67.0
 */
const isObjectKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("ObjectKeyword")));
/**
 * @category model
 * @since 0.67.0
 */
class Enums {
  enums;
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "Enums";
  constructor(enums, annotations = {}) {
    this.enums = enums;
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return Option.getOrElse(getExpected(this), () => `<enum ${this.enums.length} value(s): ${this.enums.map((_, value) => JSON.stringify(value)).join(" | ")}>`);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      enums: this.enums,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 0.67.0
 */
const isEnums = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("Enums")));
/**
 * @category model
 * @since 0.67.0
 */
class TemplateLiteralSpan {
  type;
  literal;
  constructor(type, literal) {
    this.type = type;
    this.literal = literal;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    switch (this.type._tag) {
      case "StringKeyword":
        return "${string}";
      case "NumberKeyword":
        return "${number}";
    }
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      type: this.type.toJSON(),
      literal: this.literal
    };
  }
}
/**
 * @category model
 * @since 0.67.0
 */
class TemplateLiteral {
  head;
  spans;
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "TemplateLiteral";
  constructor(head, spans, annotations = {}) {
    this.head = head;
    this.spans = spans;
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return Option.getOrElse(getExpected(this), () => formatTemplateLiteral(this));
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      head: this.head,
      spans: this.spans.map(span => span.toJSON()),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
const formatTemplateLiteral = ast => "`" + ast.head + ast.spans.map(span => String(span) + span.literal).join("") + "`";
/**
 * @category guards
 * @since 0.67.0
 */
const isTemplateLiteral = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("TemplateLiteral")));
/**
 * @category model
 * @since 0.68.0
 */
class Type {
  type;
  annotations;
  constructor(type, annotations = {}) {
    this.type = type;
    this.annotations = annotations;
  }
  /**
   * @since 0.68.0
   */
  toJSON() {
    return {
      type: this.type.toJSON(),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
  /**
   * @since 0.68.0
   */
  toString() {
    return String(this.type);
  }
}
/**
 * @category model
 * @since 0.68.0
 */
class OptionalType extends Type {
  isOptional;
  constructor(type, isOptional, annotations = {}) {
    super(type, annotations);
    this.isOptional = isOptional;
  }
  /**
   * @since 0.68.0
   */
  toJSON() {
    return {
      type: this.type.toJSON(),
      isOptional: this.isOptional,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
  /**
   * @since 0.68.0
   */
  toString() {
    return String(this.type) + (this.isOptional ? "?" : "");
  }
}
const getRestASTs = rest => rest.map(annotatedAST => annotatedAST.type);
/**
 * @category model
 * @since 0.67.0
 */
class TupleType {
  elements;
  rest;
  isReadonly;
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "TupleType";
  constructor(elements, rest, isReadonly, annotations = {}) {
    this.elements = elements;
    this.rest = rest;
    this.isReadonly = isReadonly;
    this.annotations = annotations;
    let hasOptionalElement = false;
    let hasIllegalRequiredElement = false;
    for (const e of elements) {
      if (e.isOptional) {
        hasOptionalElement = true;
      } else if (hasOptionalElement) {
        hasIllegalRequiredElement = true;
        break;
      }
    }
    if (hasIllegalRequiredElement || hasOptionalElement && rest.length > 1) {
      throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getASTRequiredElementFollowinAnOptionalElementErrorMessage */ .Iy);
    }
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this), () => formatTuple(this));
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      elements: this.elements.map(e => e.toJSON()),
      rest: this.rest.map(ast => ast.toJSON()),
      isReadonly: this.isReadonly,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
const formatTuple = ast => {
  const formattedElements = ast.elements.map(String).join(", ");
  return effect_Array__WEBPACK_IMPORTED_MODULE_5__/* .matchLeft */ .aL(ast.rest, {
    onEmpty: () => `readonly [${formattedElements}]`,
    onNonEmpty: (head, tail) => {
      const formattedHead = String(head);
      const wrappedHead = formattedHead.includes(" | ") ? `(${formattedHead})` : formattedHead;
      if (tail.length > 0) {
        const formattedTail = tail.map(String).join(", ");
        if (ast.elements.length > 0) {
          return `readonly [${formattedElements}, ...${wrappedHead}[], ${formattedTail}]`;
        } else {
          return `readonly [...${wrappedHead}[], ${formattedTail}]`;
        }
      } else {
        if (ast.elements.length > 0) {
          return `readonly [${formattedElements}, ...${wrappedHead}[]]`;
        } else {
          return `ReadonlyArray<${formattedHead}>`;
        }
      }
    }
  });
};
/**
 * @category guards
 * @since 0.67.0
 */
const isTupleType = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("TupleType")));
/**
 * @category model
 * @since 0.67.0
 */
class PropertySignature extends OptionalType {
  name;
  isReadonly;
  constructor(name, type, isOptional, isReadonly, annotations) {
    super(type, isOptional, annotations);
    this.name = name;
    this.isReadonly = isReadonly;
  }
  /**
   * @since 0.68.18
   */
  toString() {
    return (this.isReadonly ? "readonly " : "") + String(this.name) + (this.isOptional ? "?" : "") + ": " + this.type;
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      name: String(this.name),
      type: this.type.toJSON(),
      isOptional: this.isOptional,
      isReadonly: this.isReadonly,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @since 0.67.0
 */
const isParameter = ast => {
  switch (ast._tag) {
    case "StringKeyword":
    case "SymbolKeyword":
    case "TemplateLiteral":
      return true;
    case "Refinement":
      return isParameter(ast.from);
  }
  return false;
};
/**
 * @category model
 * @since 0.67.0
 */
class IndexSignature {
  type;
  isReadonly;
  /**
   * @since 0.67.0
   */
  parameter;
  constructor(parameter, type, isReadonly) {
    this.type = type;
    this.isReadonly = isReadonly;
    if (isParameter(parameter)) {
      this.parameter = parameter;
    } else {
      throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getASTIndexSignatureParameterErrorMessage */ .PG);
    }
  }
  /**
   * @since 0.68.18
   */
  toString() {
    return (this.isReadonly ? "readonly " : "") + `[x: ${this.parameter}]: ${this.type}`;
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      parameter: this.parameter.toJSON(),
      type: this.type.toJSON(),
      isReadonly: this.isReadonly
    };
  }
}
/**
 * @category model
 * @since 0.67.0
 */
class TypeLiteral {
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "TypeLiteral";
  /**
   * @since 0.67.0
   */
  propertySignatures;
  /**
   * @since 0.67.0
   */
  indexSignatures;
  constructor(propertySignatures, indexSignatures, annotations = {}) {
    this.annotations = annotations;
    // check for duplicate property signatures
    const keys = {};
    for (let i = 0; i < propertySignatures.length; i++) {
      const name = propertySignatures[i].name;
      if (Object.prototype.hasOwnProperty.call(keys, name)) {
        throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getASTDuplicatePropertySignatureErrorMessage */ .H7(name));
      }
      keys[name] = null;
    }
    // check for duplicate index signatures
    const parameters = {
      string: false,
      symbol: false
    };
    for (let i = 0; i < indexSignatures.length; i++) {
      const parameter = getParameterBase(indexSignatures[i].parameter);
      if (isStringKeyword(parameter)) {
        if (parameters.string) {
          throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getASTDuplicateIndexSignatureErrorMessage */ .FA("string"));
        }
        parameters.string = true;
      } else if (isSymbolKeyword(parameter)) {
        if (parameters.symbol) {
          throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getASTDuplicateIndexSignatureErrorMessage */ .FA("symbol"));
        }
        parameters.symbol = true;
      }
    }
    this.propertySignatures = sortPropertySignatures(propertySignatures);
    this.indexSignatures = sortIndexSignatures(indexSignatures);
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this), () => formatTypeLiteral(this));
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      propertySignatures: this.propertySignatures.map(ps => ps.toJSON()),
      indexSignatures: this.indexSignatures.map(ps => ps.toJSON()),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
const formatIndexSignatures = iss => iss.map(String).join("; ");
const formatTypeLiteral = ast => {
  if (ast.propertySignatures.length > 0) {
    const pss = ast.propertySignatures.map(String).join("; ");
    if (ast.indexSignatures.length > 0) {
      return `{ ${pss}; ${formatIndexSignatures(ast.indexSignatures)} }`;
    } else {
      return `{ ${pss} }`;
    }
  } else {
    if (ast.indexSignatures.length > 0) {
      return `{ ${formatIndexSignatures(ast.indexSignatures)} }`;
    } else {
      return "{}";
    }
  }
};
/**
 * @category guards
 * @since 0.67.0
 */
const isTypeLiteral = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("TypeLiteral")));
const removeNevers = candidates => candidates.filter(ast => !(ast === neverKeyword));
const sortCandidates = /*#__PURE__*/effect_Array__WEBPACK_IMPORTED_MODULE_5__/* .sort */ .wx( /*#__PURE__*/effect_Order__WEBPACK_IMPORTED_MODULE_6__/* .mapInput */ .$H(effect_Number__WEBPACK_IMPORTED_MODULE_7__/* .Order */ .KM, ast => {
  switch (ast._tag) {
    case "AnyKeyword":
      return 0;
    case "UnknownKeyword":
      return 1;
    case "ObjectKeyword":
      return 2;
    case "StringKeyword":
    case "NumberKeyword":
    case "BooleanKeyword":
    case "BigIntKeyword":
    case "SymbolKeyword":
      return 3;
  }
  return 4;
}));
const literalMap = {
  string: "StringKeyword",
  number: "NumberKeyword",
  boolean: "BooleanKeyword",
  bigint: "BigIntKeyword"
};
/** @internal */
const flatten = candidates => effect_Array__WEBPACK_IMPORTED_MODULE_5__/* .flatMap */ .VS(candidates, ast => isUnion(ast) ? flatten(ast.types) : [ast]);
/** @internal */
const unify = candidates => {
  const cs = sortCandidates(candidates);
  const out = [];
  const uniques = {};
  const literals = [];
  for (const ast of cs) {
    switch (ast._tag) {
      case "NeverKeyword":
        break;
      case "AnyKeyword":
        return [anyKeyword];
      case "UnknownKeyword":
        return [unknownKeyword];
      // uniques
      case "ObjectKeyword":
      case "UndefinedKeyword":
      case "VoidKeyword":
      case "StringKeyword":
      case "NumberKeyword":
      case "BooleanKeyword":
      case "BigIntKeyword":
      case "SymbolKeyword":
        {
          if (!uniques[ast._tag]) {
            uniques[ast._tag] = ast;
            out.push(ast);
          }
          break;
        }
      case "Literal":
        {
          const type = typeof ast.literal;
          switch (type) {
            case "string":
            case "number":
            case "bigint":
            case "boolean":
              {
                const _tag = literalMap[type];
                if (!uniques[_tag] && !literals.includes(ast.literal)) {
                  literals.push(ast.literal);
                  out.push(ast);
                }
                break;
              }
            // null
            case "object":
              {
                if (!literals.includes(ast.literal)) {
                  literals.push(ast.literal);
                  out.push(ast);
                }
                break;
              }
          }
          break;
        }
      case "UniqueSymbol":
        {
          if (!uniques["SymbolKeyword"] && !literals.includes(ast.symbol)) {
            literals.push(ast.symbol);
            out.push(ast);
          }
          break;
        }
      case "TupleType":
        {
          if (!uniques["ObjectKeyword"]) {
            out.push(ast);
          }
          break;
        }
      case "TypeLiteral":
        {
          if (ast.propertySignatures.length === 0 && ast.indexSignatures.length === 0) {
            if (!uniques["{}"]) {
              uniques["{}"] = ast;
              out.push(ast);
            }
          } else if (!uniques["ObjectKeyword"]) {
            out.push(ast);
          }
          break;
        }
      default:
        out.push(ast);
    }
  }
  return out;
};
/**
 * @category model
 * @since 0.67.0
 */
class Union {
  types;
  annotations;
  static make = (candidates, annotations) => {
    const types = [];
    const memo = new Set();
    for (let i = 0; i < candidates.length; i++) {
      const ast = candidates[i];
      if (ast === neverKeyword || memo.has(ast)) {
        continue;
      }
      memo.add(ast);
      types.push(ast);
    }
    return Union.union(types, annotations);
  };
  /** @internal */
  static members = (candidates, annotations) => {
    return Union.union(removeNevers(candidates), annotations);
  };
  /** @internal */
  static unify = (candidates, annotations) => {
    return Union.union(unify(flatten(candidates)), annotations);
  };
  /** @internal */
  static union = (types, annotations) => {
    return isMembers(types) ? new Union(types, annotations) : types.length === 1 ? types[0] : neverKeyword;
  };
  /**
   * @since 0.67.0
   */
  _tag = "Union";
  constructor(types, annotations = {}) {
    this.types = types;
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this), () => this.types.map(String).join(" | "));
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      types: this.types.map(ast => ast.toJSON()),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/** @internal */
const mapMembers = (members, f) => members.map(f);
/** @internal */
const isMembers = as => as.length > 1;
/**
 * @category guards
 * @since 0.67.0
 */
const isUnion = /*#__PURE__*/createASTGuard("Union");
const toJSONMemoMap = /*#__PURE__*/(0,effect_GlobalValue__WEBPACK_IMPORTED_MODULE_8__/* .globalValue */ .K)( /*#__PURE__*/Symbol.for("@effect/schema/AST/toJSONMemoMap"), () => new WeakMap());
/**
 * @category model
 * @since 0.67.0
 */
class Suspend {
  f;
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "Suspend";
  constructor(f, annotations = {}) {
    this.f = f;
    this.annotations = annotations;
    this.f = _internal_util_js__WEBPACK_IMPORTED_MODULE_2__/* .memoizeThunk */ .d3(f);
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return getExpected(this).pipe(effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .orElse */ .vx(() => effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VS(effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .liftThrowable */ .eZ(this.f)(), ast => getExpected(ast))), effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(() => "<suspended schema>"));
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    const ast = this.f();
    let out = toJSONMemoMap.get(ast);
    if (out) {
      return out;
    }
    toJSONMemoMap.set(ast, {
      _tag: this._tag
    });
    out = {
      _tag: this._tag,
      ast: ast.toJSON(),
      annotations: toJSONAnnotations(this.annotations)
    };
    toJSONMemoMap.set(ast, out);
    return out;
  }
}
/**
 * @category guards
 * @since 0.67.0
 */
const isSuspend = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("Suspend")));
/**
 * @category model
 * @since 0.67.0
 */
class Refinement {
  from;
  filter;
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "Refinement";
  constructor(from, filter, annotations = {}) {
    this.from = from;
    this.filter = filter;
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this), () => `{ ${this.from} | filter }`);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      from: this.from.toJSON(),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 0.67.0
 */
const isRefinement = /*#__PURE__*/createASTGuard("Refinement");
/**
 * @since 0.67.0
 */
const defaultParseOption = {};
/**
 * @category model
 * @since 0.67.0
 */
class Transformation {
  from;
  to;
  transformation;
  annotations;
  /**
   * @since 0.67.0
   */
  _tag = "Transformation";
  constructor(from, to, transformation, annotations = {}) {
    this.from = from;
    this.to = to;
    this.transformation = transformation;
    this.annotations = annotations;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(this), () => `(${String(this.from)} <-> ${String(this.to)})`);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      from: this.from.toJSON(),
      to: this.to.toJSON(),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 0.67.0
 */
const isTransformation = /*#__PURE__*/createASTGuard("Transformation");
/**
 * @category model
 * @since 0.67.0
 */
class FinalTransformation {
  decode;
  encode;
  /**
   * @since 0.67.0
   */
  _tag = "FinalTransformation";
  constructor(decode, encode) {
    this.decode = decode;
    this.encode = encode;
  }
}
const createTransformationGuard = tag => ast => ast._tag === tag;
/**
 * @category guards
 * @since 0.67.0
 */
const isFinalTransformation = /*#__PURE__*/(/* unused pure expression or super */ null && (createTransformationGuard("FinalTransformation")));
/**
 * @category model
 * @since 0.67.0
 */
class ComposeTransformation {
  /**
   * @since 0.67.0
   */
  _tag = "ComposeTransformation";
}
/**
 * @category constructors
 * @since 0.67.0
 */
const composeTransformation = /*#__PURE__*/new ComposeTransformation();
/**
 * @category guards
 * @since 0.67.0
 */
const isComposeTransformation = /*#__PURE__*/(/* unused pure expression or super */ null && (createTransformationGuard("ComposeTransformation")));
/**
 * Represents a `PropertySignature -> PropertySignature` transformation
 *
 * The semantic of `decode` is:
 * - `none()` represents the absence of the key/value pair
 * - `some(value)` represents the presence of the key/value pair
 *
 * The semantic of `encode` is:
 * - `none()` you don't want to output the key/value pair
 * - `some(value)` you want to output the key/value pair
 *
 * @category model
 * @since 0.67.0
 */
class PropertySignatureTransformation {
  from;
  to;
  decode;
  encode;
  constructor(from, to, decode, encode) {
    this.from = from;
    this.to = to;
    this.decode = decode;
    this.encode = encode;
  }
}
const isRenamingPropertySignatureTransformation = t => t.decode === identity && t.encode === identity;
/**
 * @category model
 * @since 0.67.0
 */
class TypeLiteralTransformation {
  propertySignatureTransformations;
  /**
   * @since 0.67.0
   */
  _tag = "TypeLiteralTransformation";
  constructor(propertySignatureTransformations) {
    this.propertySignatureTransformations = propertySignatureTransformations;
    // check for duplicate property signature transformations
    const fromKeys = {};
    const toKeys = {};
    for (const pst of propertySignatureTransformations) {
      const from = pst.from;
      if (fromKeys[from]) {
        throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getASTDuplicatePropertySignatureTransformationErrorMessage */ .Zo(from));
      }
      fromKeys[from] = true;
      const to = pst.to;
      if (toKeys[to]) {
        throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getASTDuplicatePropertySignatureTransformationErrorMessage */ .Zo(to));
      }
      toKeys[to] = true;
    }
  }
}
/**
 * @category guards
 * @since 0.67.0
 */
const isTypeLiteralTransformation = /*#__PURE__*/(/* unused pure expression or super */ null && (createTransformationGuard("TypeLiteralTransformation")));
// -------------------------------------------------------------------------------------
// API
// -------------------------------------------------------------------------------------
/**
 * Adds a group of annotations, potentially overwriting existing annotations.
 *
 * @since 0.67.0
 */
const annotations = (ast, annotations) => {
  const d = Object.getOwnPropertyDescriptors(ast);
  d.annotations.value = {
    ...ast.annotations,
    ...annotations
  };
  return Object.create(Object.getPrototypeOf(ast), d);
};
/**
 * Equivalent at runtime to the TypeScript type-level `keyof` operator.
 *
 * @since 0.67.0
 */
const keyof = ast => Union.unify(_keyof(ast));
const STRING_KEYWORD_PATTERN = ".*";
const NUMBER_KEYWORD_PATTERN = "[+-]?\\d*\\.?\\d+(?:[Ee][+-]?\\d+)?";
/**
 * @since 0.67.0
 */
const getTemplateLiteralRegExp = ast => {
  let pattern = `^${effect_RegExp__WEBPACK_IMPORTED_MODULE_9__/* .escape */ .Y(ast.head)}`;
  for (const span of ast.spans) {
    if (isStringKeyword(span.type)) {
      pattern += STRING_KEYWORD_PATTERN;
    } else if (isNumberKeyword(span.type)) {
      pattern += NUMBER_KEYWORD_PATTERN;
    }
    pattern += effect_RegExp__WEBPACK_IMPORTED_MODULE_9__/* .escape */ .Y(span.literal);
  }
  pattern += "$";
  return new RegExp(pattern);
};
/**
 * @since 0.67.0
 */
const getPropertySignatures = ast => {
  switch (ast._tag) {
    case "Declaration":
      {
        const annotation = getSurrogateAnnotation(ast);
        if (Option.isSome(annotation)) {
          return getPropertySignatures(annotation.value);
        }
        break;
      }
    case "TypeLiteral":
      return ast.propertySignatures.slice();
    case "Suspend":
      return getPropertySignatures(ast.f());
  }
  return getPropertyKeys(ast).map(name => getPropertyKeyIndexedAccess(ast, name));
};
/** @internal */
const getNumberIndexedAccess = ast => {
  switch (ast._tag) {
    case "TupleType":
      {
        let hasOptional = false;
        let out = [];
        for (const e of ast.elements) {
          if (e.isOptional) {
            hasOptional = true;
          }
          out.push(e.type);
        }
        if (hasOptional) {
          out.push(undefinedKeyword);
        }
        out = out.concat(getRestASTs(ast.rest));
        return Union.make(out);
      }
    case "Refinement":
      return getNumberIndexedAccess(ast.from);
    case "Union":
      return Union.make(ast.types.map(getNumberIndexedAccess));
    case "Suspend":
      return getNumberIndexedAccess(ast.f());
  }
  throw new Error(errors_.getASTUnsupportedSchema(ast));
};
/** @internal */
const getPropertyKeyIndexedAccess = (ast, name) => {
  switch (ast._tag) {
    case "Declaration":
      {
        const annotation = getSurrogateAnnotation(ast);
        if (Option.isSome(annotation)) {
          return getPropertyKeyIndexedAccess(annotation.value, name);
        }
        break;
      }
    case "TypeLiteral":
      {
        const ops = Arr.findFirst(ast.propertySignatures, ps => ps.name === name);
        if (Option.isSome(ops)) {
          return ops.value;
        } else {
          if (Predicate.isString(name)) {
            for (const is of ast.indexSignatures) {
              const parameterBase = getParameterBase(is.parameter);
              switch (parameterBase._tag) {
                case "TemplateLiteral":
                  {
                    const regex = getTemplateLiteralRegExp(parameterBase);
                    if (regex.test(name)) {
                      return new PropertySignature(name, is.type, false, true);
                    }
                    break;
                  }
                case "StringKeyword":
                  return new PropertySignature(name, is.type, false, true);
              }
            }
          } else if (Predicate.isSymbol(name)) {
            for (const is of ast.indexSignatures) {
              const parameterBase = getParameterBase(is.parameter);
              if (isSymbolKeyword(parameterBase)) {
                return new PropertySignature(name, is.type, false, true);
              }
            }
          }
        }
        break;
      }
    case "Union":
      return new PropertySignature(name, Union.make(ast.types.map(ast => getPropertyKeyIndexedAccess(ast, name).type)), false, true);
    case "Suspend":
      return getPropertyKeyIndexedAccess(ast.f(), name);
  }
  return new PropertySignature(name, neverKeyword, false, true);
};
const getPropertyKeys = ast => {
  switch (ast._tag) {
    case "Declaration":
      {
        const annotation = getSurrogateAnnotation(ast);
        if (Option.isSome(annotation)) {
          return getPropertyKeys(annotation.value);
        }
        break;
      }
    case "TypeLiteral":
      return ast.propertySignatures.map(ps => ps.name);
    case "Suspend":
      return getPropertyKeys(ast.f());
    case "Union":
      return ast.types.slice(1).reduce((out, ast) => Arr.intersection(out, getPropertyKeys(ast)), getPropertyKeys(ast.types[0]));
    case "Transformation":
      return getPropertyKeys(ast.to);
  }
  return [];
};
/** @internal */
const record = (key, value) => {
  const propertySignatures = [];
  const indexSignatures = [];
  const go = key => {
    switch (key._tag) {
      case "NeverKeyword":
        break;
      case "StringKeyword":
      case "SymbolKeyword":
      case "TemplateLiteral":
      case "Refinement":
        indexSignatures.push(new IndexSignature(key, value, true));
        break;
      case "Literal":
        if (effect_Predicate__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD(key.literal) || effect_Predicate__WEBPACK_IMPORTED_MODULE_3__/* .isNumber */ .hj(key.literal)) {
          propertySignatures.push(new PropertySignature(key.literal, value, false, true));
        } else {
          throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getASTUnsupportedLiteral */ .a_(key.literal));
        }
        break;
      case "Enums":
        {
          for (const [_, name] of key.enums) {
            propertySignatures.push(new PropertySignature(name, value, false, true));
          }
          break;
        }
      case "UniqueSymbol":
        propertySignatures.push(new PropertySignature(key.symbol, value, false, true));
        break;
      case "Union":
        key.types.forEach(go);
        break;
      default:
        throw new Error(_internal_errors_js__WEBPACK_IMPORTED_MODULE_4__/* .getASTUnsupportedKeySchema */ .Zb(key));
    }
  };
  go(key);
  return {
    propertySignatures,
    indexSignatures
  };
};
/**
 * Equivalent at runtime to the built-in TypeScript utility type `Pick`.
 *
 * @since 0.67.0
 */
const pick = (ast, keys) => {
  if (isTransformation(ast)) {
    switch (ast.transformation._tag) {
      case "ComposeTransformation":
        return new Transformation(pick(ast.from, keys), pick(ast.to, keys), composeTransformation);
      case "TypeLiteralTransformation":
        {
          const ts = [];
          const fromKeys = [];
          for (const k of keys) {
            const t = ast.transformation.propertySignatureTransformations.find(t => t.to === k);
            if (t) {
              ts.push(t);
              fromKeys.push(t.from);
            } else {
              fromKeys.push(k);
            }
          }
          return Arr.isNonEmptyReadonlyArray(ts) ? new Transformation(pick(ast.from, fromKeys), pick(ast.to, keys), new TypeLiteralTransformation(ts)) : pick(ast.from, fromKeys);
        }
      case "FinalTransformation":
        {
          const annotation = getSurrogateAnnotation(ast);
          if (Option.isSome(annotation)) {
            return pick(annotation.value, keys);
          }
          throw new Error(errors_.getASTUnsupportedSchema(ast));
        }
    }
  }
  return new TypeLiteral(keys.map(key => getPropertyKeyIndexedAccess(ast, key)), []);
};
/**
 * Equivalent at runtime to the built-in TypeScript utility type `Omit`.
 *
 * @since 0.67.0
 */
const omit = (ast, keys) => pick(ast, getPropertyKeys(ast).filter(name => !keys.includes(name)));
/** @internal */
const orUndefined = ast => Union.make([ast, undefinedKeyword]);
/**
 * Equivalent at runtime to the built-in TypeScript utility type `Partial`.
 *
 * @since 0.67.0
 */
const partial = (ast, options) => {
  const exact = options?.exact === true;
  switch (ast._tag) {
    case "TupleType":
      return new TupleType(ast.elements.map(e => new OptionalType(exact ? e.type : orUndefined(e.type), true)), Arr.match(ast.rest, {
        onEmpty: () => ast.rest,
        onNonEmpty: rest => [new Type(Union.make([...getRestASTs(rest), undefinedKeyword]))]
      }), ast.isReadonly);
    case "TypeLiteral":
      return new TypeLiteral(ast.propertySignatures.map(ps => new PropertySignature(ps.name, exact ? ps.type : orUndefined(ps.type), true, ps.isReadonly, ps.annotations)), ast.indexSignatures.map(is => new IndexSignature(is.parameter, orUndefined(is.type), is.isReadonly)));
    case "Union":
      return Union.make(ast.types.map(member => partial(member, options)));
    case "Suspend":
      return new Suspend(() => partial(ast.f(), options));
    case "Declaration":
      throw new Error(errors_.getASTUnsupportedSchema(ast));
    case "Refinement":
      throw new Error(errors_.getASTUnsupportedSchema(ast));
    case "Transformation":
      {
        if (isTypeLiteralTransformation(ast.transformation) && ast.transformation.propertySignatureTransformations.every(isRenamingPropertySignatureTransformation)) {
          return new Transformation(partial(ast.from, options), partial(ast.to, options), ast.transformation);
        }
        throw new Error(errors_.getASTUnsupportedSchema(ast));
      }
  }
  return ast;
};
/**
 * Equivalent at runtime to the built-in TypeScript utility type `Required`.
 *
 * @since 0.67.0
 */
const required = ast => {
  switch (ast._tag) {
    case "TupleType":
      return new TupleType(ast.elements.map(e => new OptionalType(e.type, false)), ast.rest, ast.isReadonly);
    case "TypeLiteral":
      return new TypeLiteral(ast.propertySignatures.map(f => new PropertySignature(f.name, f.type, false, f.isReadonly, f.annotations)), ast.indexSignatures);
    case "Union":
      return Union.make(ast.types.map(member => required(member)));
    case "Suspend":
      return new Suspend(() => required(ast.f()));
    case "Declaration":
      throw new Error(errors_.getASTUnsupportedSchema(ast));
    case "Refinement":
      throw new Error(errors_.getASTUnsupportedSchema(ast));
    case "Transformation":
      {
        if (isTypeLiteralTransformation(ast.transformation) && ast.transformation.propertySignatureTransformations.every(isRenamingPropertySignatureTransformation)) {
          return new Transformation(required(ast.from), required(ast.to), ast.transformation);
        }
        throw new Error(errors_.getASTUnsupportedSchema(ast));
      }
  }
  return ast;
};
/**
 * Creates a new AST with shallow mutability applied to its properties.
 *
 * @param ast - The original AST to make properties mutable (shallowly).
 *
 * @since 0.67.0
 */
const mutable = ast => {
  switch (ast._tag) {
    case "TupleType":
      return ast.isReadonly === false ? ast : new TupleType(ast.elements, ast.rest, false, ast.annotations);
    case "TypeLiteral":
      {
        const propertySignatures = changeMap(ast.propertySignatures, ps => ps.isReadonly === false ? ps : new PropertySignature(ps.name, ps.type, ps.isOptional, false, ps.annotations));
        const indexSignatures = changeMap(ast.indexSignatures, is => is.isReadonly === false ? is : new IndexSignature(is.parameter, is.type, false));
        return propertySignatures === ast.propertySignatures && indexSignatures === ast.indexSignatures ? ast : new TypeLiteral(propertySignatures, indexSignatures, ast.annotations);
      }
    case "Union":
      {
        const types = changeMap(ast.types, mutable);
        return types === ast.types ? ast : Union.make(types, ast.annotations);
      }
    case "Suspend":
      return new Suspend(() => mutable(ast.f()), ast.annotations);
    case "Refinement":
      {
        const from = mutable(ast.from);
        return from === ast.from ? ast : new Refinement(from, ast.filter, ast.annotations);
      }
    case "Transformation":
      {
        const from = mutable(ast.from);
        const to = mutable(ast.to);
        return from === ast.from && to === ast.to ? ast : new Transformation(from, to, ast.transformation, ast.annotations);
      }
  }
  return ast;
};
/**
 * @since 0.67.0
 */
const getCompiler = match => {
  const compile = (ast, path) => match[ast._tag](ast, compile, path);
  return compile;
};
/**
 * @since 0.67.0
 */
const typeAST = ast => {
  switch (ast._tag) {
    case "Declaration":
      {
        const typeParameters = changeMap(ast.typeParameters, typeAST);
        return typeParameters === ast.typeParameters ? ast : new Declaration(typeParameters, ast.decodeUnknown, ast.encodeUnknown, ast.annotations);
      }
    case "TupleType":
      {
        const elements = changeMap(ast.elements, e => {
          const type = typeAST(e.type);
          return type === e.type ? e : new OptionalType(type, e.isOptional);
        });
        const restASTs = getRestASTs(ast.rest);
        const rest = changeMap(restASTs, typeAST);
        return elements === ast.elements && rest === restASTs ? ast : new TupleType(elements, rest.map(type => new Type(type)), ast.isReadonly, ast.annotations);
      }
    case "TypeLiteral":
      {
        const propertySignatures = changeMap(ast.propertySignatures, p => {
          const type = typeAST(p.type);
          return type === p.type ? p : new PropertySignature(p.name, type, p.isOptional, p.isReadonly);
        });
        const indexSignatures = changeMap(ast.indexSignatures, is => {
          const type = typeAST(is.type);
          return type === is.type ? is : new IndexSignature(is.parameter, type, is.isReadonly);
        });
        return propertySignatures === ast.propertySignatures && indexSignatures === ast.indexSignatures ? ast : new TypeLiteral(propertySignatures, indexSignatures, ast.annotations);
      }
    case "Union":
      {
        const types = changeMap(ast.types, typeAST);
        return types === ast.types ? ast : Union.make(types, ast.annotations);
      }
    case "Suspend":
      return new Suspend(() => typeAST(ast.f()), ast.annotations);
    case "Refinement":
      {
        const from = typeAST(ast.from);
        return from === ast.from ? ast : new Refinement(from, ast.filter, ast.annotations);
      }
    case "Transformation":
      return typeAST(ast.to);
  }
  return ast;
};
/** @internal */
const preserveAnnotations = annotationIds => annotated => {
  let out = undefined;
  for (const id of annotationIds) {
    if (Object.prototype.hasOwnProperty.call(annotated.annotations, id)) {
      if (out === undefined) {
        out = {};
      }
      out[id] = annotated.annotations[id];
    }
  }
  return out;
};
/** @internal */
const getJSONIdentifier = annotated => effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .orElse */ .vx(getJSONIdentifierAnnotation(annotated), () => getIdentifierAnnotation(annotated));
// To generate a JSON Schema from a recursive schema, an `identifier` annotation
// is required. So, when we calculate the encodedAST, we need to preserve the
// annotation in the form of an internal custom annotation that acts as a
// surrogate for the identifier, which the JSON Schema compiler can then read.
const createJSONIdentifierAnnotation = annotated => effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .match */ .EQ(getJSONIdentifier(annotated), {
  onNone: () => undefined,
  onSome: identifier => ({
    [JSONIdentifierAnnotationId]: identifier
  })
});
function changeMap(as, f) {
  let changed = false;
  const out = effect_Array__WEBPACK_IMPORTED_MODULE_5__/* .allocate */ .TK(as.length);
  for (let i = 0; i < as.length; i++) {
    const a = as[i];
    const fa = f(a);
    if (fa !== a) {
      changed = true;
    }
    out[i] = fa;
  }
  return changed ? out : as;
}
const encodedAST_ = (ast, isBound) => {
  switch (ast._tag) {
    case "Declaration":
      {
        const typeParameters = changeMap(ast.typeParameters, ast => encodedAST_(ast, isBound));
        return typeParameters === ast.typeParameters ? ast : new Declaration(typeParameters, ast.decodeUnknown, ast.encodeUnknown, ast.annotations);
      }
    case "TupleType":
      {
        const elements = changeMap(ast.elements, e => {
          const type = encodedAST_(e.type, isBound);
          return type === e.type ? e : new OptionalType(type, e.isOptional);
        });
        const restASTs = getRestASTs(ast.rest);
        const rest = changeMap(restASTs, ast => encodedAST_(ast, isBound));
        return elements === ast.elements && rest === restASTs ? ast : new TupleType(elements, rest.map(ast => new Type(ast)), ast.isReadonly, createJSONIdentifierAnnotation(ast));
      }
    case "TypeLiteral":
      {
        const propertySignatures = changeMap(ast.propertySignatures, ps => {
          const type = encodedAST_(ps.type, isBound);
          return type === ps.type ? ps : new PropertySignature(ps.name, type, ps.isOptional, ps.isReadonly);
        });
        const indexSignatures = changeMap(ast.indexSignatures, is => {
          const type = encodedAST_(is.type, isBound);
          return type === is.type ? is : new IndexSignature(is.parameter, type, is.isReadonly);
        });
        return propertySignatures === ast.propertySignatures && indexSignatures === ast.indexSignatures ? ast : new TypeLiteral(propertySignatures, indexSignatures, createJSONIdentifierAnnotation(ast));
      }
    case "Union":
      {
        const types = changeMap(ast.types, ast => encodedAST_(ast, isBound));
        return types === ast.types ? ast : Union.make(types, createJSONIdentifierAnnotation(ast));
      }
    case "Suspend":
      return new Suspend(() => encodedAST_(ast.f(), isBound), createJSONIdentifierAnnotation(ast));
    case "Refinement":
      {
        const from = encodedAST_(ast.from, isBound);
        if (isBound) {
          if (from === ast.from) {
            return ast;
          }
          if (!isTransformation(ast.from)) {
            const annotations = getStableFilterAnnotation(ast);
            if (effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .isSome */ .pC(annotations) && annotations.value === true) {
              return new Refinement(from, ast.filter);
            }
          }
        }
        return from;
      }
    case "Transformation":
      return encodedAST_(ast.from, isBound);
  }
  return ast;
};
/**
 * @since 0.67.0
 */
const encodedAST = ast => encodedAST_(ast, false);
/**
 * @since 0.67.0
 */
const encodedBoundAST = ast => encodedAST_(ast, true);
const toJSONAnnotations = annotations => {
  const out = {};
  for (const k of Object.getOwnPropertySymbols(annotations)) {
    out[String(k)] = annotations[k];
  }
  return out;
};
/** @internal */
const getCardinality = ast => {
  switch (ast._tag) {
    case "NeverKeyword":
      return 0;
    case "Literal":
    case "UndefinedKeyword":
    case "VoidKeyword":
    case "UniqueSymbol":
      return 1;
    case "BooleanKeyword":
      return 2;
    case "StringKeyword":
    case "NumberKeyword":
    case "BigIntKeyword":
    case "SymbolKeyword":
      return 3;
    case "ObjectKeyword":
      return 5;
    case "UnknownKeyword":
    case "AnyKeyword":
      return 6;
    default:
      return 4;
  }
};
const sortPropertySignatures = /*#__PURE__*/effect_Array__WEBPACK_IMPORTED_MODULE_5__/* .sort */ .wx( /*#__PURE__*/effect_Order__WEBPACK_IMPORTED_MODULE_6__/* .mapInput */ .$H(effect_Number__WEBPACK_IMPORTED_MODULE_7__/* .Order */ .KM, ps => getCardinality(ps.type)));
const sortIndexSignatures = /*#__PURE__*/effect_Array__WEBPACK_IMPORTED_MODULE_5__/* .sort */ .wx( /*#__PURE__*/effect_Order__WEBPACK_IMPORTED_MODULE_6__/* .mapInput */ .$H(effect_Number__WEBPACK_IMPORTED_MODULE_7__/* .Order */ .KM, is => {
  switch (getParameterBase(is.parameter)._tag) {
    case "StringKeyword":
      return 2;
    case "SymbolKeyword":
      return 3;
    case "TemplateLiteral":
      return 1;
  }
}));
const WeightOrder = /*#__PURE__*/effect_Order__WEBPACK_IMPORTED_MODULE_6__/* .tuple */ .bc(effect_Number__WEBPACK_IMPORTED_MODULE_7__/* .Order */ .KM, effect_Number__WEBPACK_IMPORTED_MODULE_7__/* .Order */ .KM, effect_Number__WEBPACK_IMPORTED_MODULE_7__/* .Order */ .KM);
const maxWeight = /*#__PURE__*/(/* unused pure expression or super */ null && (Order.max(WeightOrder)));
const emptyWeight = (/* unused pure expression or super */ null && ([0, 0, 0]));
const maxWeightAll = weights => weights.reduce(maxWeight, emptyWeight);
/** @internal */
const getWeight = ast => {
  switch (ast._tag) {
    case "TupleType":
      {
        return [2, ast.elements.length, ast.rest.length];
      }
    case "TypeLiteral":
      {
        const y = ast.propertySignatures.length;
        const z = ast.indexSignatures.length;
        return y + z === 0 ? [-4, 0, 0] : [4, y, z];
      }
    case "Declaration":
      {
        const annotation = getSurrogateAnnotation(ast);
        if (Option.isSome(annotation)) {
          const [_, y, z] = getWeight(annotation.value);
          return [6, y, z];
        }
        return [6, 0, 0];
      }
    case "Suspend":
      return [8, 0, 0];
    case "Union":
      return maxWeightAll(ast.types.map(getWeight));
    case "Refinement":
      {
        const [x, y, z] = getWeight(ast.from);
        return [x + 1, y, z];
      }
    case "Transformation":
      return getWeight(ast.from);
    case "ObjectKeyword":
      return [-2, 0, 0];
    case "UnknownKeyword":
    case "AnyKeyword":
      return [-4, 0, 0];
    default:
      return emptyWeight;
  }
};
/** @internal */
const getParameterBase = ast => {
  switch (ast._tag) {
    case "StringKeyword":
    case "SymbolKeyword":
    case "TemplateLiteral":
      return ast;
    case "Refinement":
      return getParameterBase(ast.from);
  }
};
const equalsTemplateLiteralSpan = /*#__PURE__*/(/* unused pure expression or super */ null && (Arr.getEquivalence((self, that) => self.type._tag === that.type._tag && self.literal === that.literal)));
const equalsEnums = /*#__PURE__*/(/* unused pure expression or super */ null && (Arr.getEquivalence((self, that) => that[0] === self[0] && that[1] === self[1])));
const equals = (self, that) => {
  switch (self._tag) {
    case "Literal":
      return isLiteral(that) && that.literal === self.literal;
    case "UniqueSymbol":
      return isUniqueSymbol(that) && that.symbol === self.symbol;
    case "UndefinedKeyword":
    case "VoidKeyword":
    case "NeverKeyword":
    case "UnknownKeyword":
    case "AnyKeyword":
    case "StringKeyword":
    case "NumberKeyword":
    case "BooleanKeyword":
    case "BigIntKeyword":
    case "SymbolKeyword":
    case "ObjectKeyword":
      return that._tag === self._tag;
    case "TemplateLiteral":
      return isTemplateLiteral(that) && that.head === self.head && equalsTemplateLiteralSpan(that.spans, self.spans);
    case "Enums":
      return isEnums(that) && equalsEnums(that.enums, self.enums);
    case "Refinement":
    case "TupleType":
    case "TypeLiteral":
    case "Union":
    case "Suspend":
    case "Transformation":
    case "Declaration":
      return self === that;
  }
};
const intersection = /*#__PURE__*/(/* unused pure expression or super */ null && (Arr.intersectionWith(equals)));
const _keyof = ast => {
  switch (ast._tag) {
    case "Declaration":
      {
        const annotation = getSurrogateAnnotation(ast);
        if (Option.isSome(annotation)) {
          return _keyof(annotation.value);
        }
        break;
      }
    case "TypeLiteral":
      return ast.propertySignatures.map(p => Predicate.isSymbol(p.name) ? new UniqueSymbol(p.name) : new Literal(p.name)).concat(ast.indexSignatures.map(is => getParameterBase(is.parameter)));
    case "Suspend":
      return _keyof(ast.f());
    case "Union":
      return ast.types.slice(1).reduce((out, ast) => intersection(out, _keyof(ast)), _keyof(ast.types[0]));
    case "Transformation":
      return _keyof(ast.to);
  }
  throw new Error(errors_.getASTUnsupportedSchema(ast));
};
/** @internal */
const compose = (ab, cd) => new Transformation(ab, cd, composeTransformation);
/** @internal */
const rename = (ast, mapping) => {
  switch (ast._tag) {
    case "TypeLiteral":
      {
        const propertySignatureTransformations = [];
        for (const key of util_.ownKeys(mapping)) {
          const name = mapping[key];
          if (name !== undefined) {
            propertySignatureTransformations.push(new PropertySignatureTransformation(key, name, identity, identity));
          }
        }
        if (propertySignatureTransformations.length === 0) {
          return ast;
        }
        return new Transformation(ast, new TypeLiteral(ast.propertySignatures.map(ps => {
          const name = mapping[ps.name];
          return new PropertySignature(name === undefined ? ps.name : name, typeAST(ps.type), ps.isOptional, ps.isReadonly, ps.annotations);
        }), ast.indexSignatures), new TypeLiteralTransformation(propertySignatureTransformations));
      }
    case "Union":
      return Union.make(ast.types.map(ast => rename(ast, mapping)));
    case "Suspend":
      return new Suspend(() => rename(ast.f(), mapping));
    case "Transformation":
      return compose(ast, rename(typeAST(ast), mapping));
  }
  throw new Error(errors_.getASTUnsupportedRenameSchema(ast));
};
const formatKeyword = ast => effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .getOrElse */ .fS(getExpected(ast), () => ast._tag);
const getExpected = ast => {
  return getIdentifierAnnotation(ast).pipe(effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .orElse */ .vx(() => getTitleAnnotation(ast)), effect_Option__WEBPACK_IMPORTED_MODULE_1__/* .orElse */ .vx(() => getDescriptionAnnotation(ast)));
};
//# sourceMappingURL=AST.js.map

/***/ }),

/***/ 65694:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bU": function() { return /* binding */ Composite; },
  "gb": function() { return /* binding */ Pointer; },
  "Dy": function() { return /* binding */ Type; },
  "G$": function() { return /* binding */ decodeUnknownSync; },
  "bG": function() { return /* binding */ fail; },
  "Yo": function() { return /* binding */ fromOption; },
  "is": function() { return /* binding */ is; },
  "ng": function() { return /* binding */ succeed; },
  "Dr": function() { return /* binding */ validateSync; }
});

// UNUSED EXPORTS: Forbidden, Missing, ParseError, ParseErrorTypeId, Refinement, Transformation, Unexpected, asserts, decode, decodeEither, decodeOption, decodePromise, decodeSync, decodeUnknown, decodeUnknownEither, decodeUnknownOption, decodeUnknownPromise, eitherOrUndefined, encode, encodeEither, encodeOption, encodePromise, encodeSync, encodeUnknown, encodeUnknownEither, encodeUnknownOption, encodeUnknownPromise, encodeUnknownSync, flatMap, getFinalTransformation, getLiterals, getSearchTree, isComposite, isParseError, map, mapBoth, mapError, mergeInternalOptions, orElse, parseError, try, validate, validateEither, validateOption, validatePromise

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Array.js + 2 modules
var esm_Array = __webpack_require__(37901);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Data.js
var Data = __webpack_require__(21566);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Effect.js + 6 modules
var esm_Effect = __webpack_require__(96347);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Either.js
var esm_Either = __webpack_require__(87585);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/GlobalValue.js
var GlobalValue = __webpack_require__(4726);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Inspectable.js
var Inspectable = __webpack_require__(16371);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var esm_Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var esm_Predicate = __webpack_require__(71335);
// EXTERNAL MODULE: ./node_modules/@lucid-evolution/utils/node_modules/@effect/schema/dist/esm/AST.js
var esm_AST = __webpack_require__(27677);
// EXTERNAL MODULE: ./node_modules/@lucid-evolution/utils/node_modules/@effect/schema/dist/esm/internal/util.js
var util = __webpack_require__(7677);
;// CONCATENATED MODULE: ./node_modules/@lucid-evolution/utils/node_modules/@effect/schema/dist/esm/TreeFormatter.js
/**
 * @since 0.67.0
 */





const make = (value, forest = []) => ({
  value,
  forest
});
/**
 * @category formatting
 * @since 0.67.0
 */
const formatIssue = issue => esm_Effect/* map */.UID(go(issue), tree => drawTree(tree));
/**
 * @category formatting
 * @since 0.67.0
 */
const formatIssueSync = issue => esm_Effect/* runSync */.Wno(formatIssue(issue));
/**
 * @category formatting
 * @since 0.67.0
 */
const formatError = error => formatIssue(error.issue);
/**
 * @category formatting
 * @since 0.67.0
 */
const formatErrorSync = error => formatIssueSync(error.issue);
const drawTree = tree => tree.value + draw("\n", tree.forest);
const draw = (indentation, forest) => {
  let r = "";
  const len = forest.length;
  let tree;
  for (let i = 0; i < len; i++) {
    tree = forest[i];
    const isLast = i === len - 1;
    r += indentation + (isLast ? "└" : "├") + "─ " + tree.value;
    r += draw(indentation + (len > 1 && !isLast ? "│  " : "   "), tree.forest);
  }
  return r;
};
const formatTransformationKind = kind => {
  switch (kind) {
    case "Encoded":
      return "Encoded side transformation failure";
    case "Transformation":
      return "Transformation process failure";
    case "Type":
      return "Type side transformation failure";
  }
};
const formatRefinementKind = kind => {
  switch (kind) {
    case "From":
      return "From side refinement failure";
    case "Predicate":
      return "Predicate refinement failure";
  }
};
const getAnnotated = issue => "ast" in issue ? esm_Option/* some */.G(issue.ast) : esm_Option/* none */.YP();
const getCurrentMessage = issue => getAnnotated(issue).pipe(esm_Option/* flatMap */.VS(esm_AST/* getMessageAnnotation */.sC), esm_Effect/* flatMap */.VSD(annotation => {
  const out = annotation(issue);
  return esm_Predicate/* isString */.HD(out) ? esm_Effect/* succeed */.ng0({
    message: out,
    override: false
  }) : esm_Effect/* isEffect */.cdB(out) ? esm_Effect/* map */.UID(out, message => ({
    message,
    override: false
  })) : esm_Predicate/* isString */.HD(out.message) ? esm_Effect/* succeed */.ng0({
    message: out.message,
    override: out.override
  }) : esm_Effect/* map */.UID(out.message, message => ({
    message,
    override: out.override
  }));
}));
const createParseIssueGuard = tag => issue => issue._tag === tag;
const isComposite = /*#__PURE__*/createParseIssueGuard("Composite");
const isRefinement = /*#__PURE__*/createParseIssueGuard("Refinement");
const isTransformation = /*#__PURE__*/createParseIssueGuard("Transformation");
/** @internal */
const getMessage = issue => getCurrentMessage(issue).pipe(esm_Effect/* flatMap */.VSD(currentMessage => {
  const useInnerMessage = !currentMessage.override && (isComposite(issue) || isRefinement(issue) && issue.kind === "From" || isTransformation(issue) && issue.kind !== "Transformation");
  return useInnerMessage ? isTransformation(issue) || isRefinement(issue) ? getMessage(issue.issue) : esm_Option/* none */.YP() : esm_Effect/* succeed */.ng0(currentMessage.message);
}));
const getParseIssueTitleAnnotation = issue => getAnnotated(issue).pipe(esm_Option/* flatMap */.VS(esm_AST/* getParseIssueTitleAnnotation */.d1), esm_Option/* filterMap */.DZ(annotation => esm_Option/* fromNullable */.ij(annotation(issue))));
/** @internal */
const formatTypeMessage = e => getMessage(e).pipe(esm_Effect/* orElse */.vxS(() => getParseIssueTitleAnnotation(e)), esm_Effect/* catchAll */.kmb(() => esm_Effect/* succeed */.ng0(e.message ?? `Expected ${String(e.ast)}, actual ${util/* formatUnknown */.cT(e.actual)}`)));
const getParseIssueTitle = issue => esm_Option/* getOrElse */.fS(getParseIssueTitleAnnotation(issue), () => String(issue.ast));
/** @internal */
const formatForbiddenMessage = e => e.message ?? "is forbidden";
/** @internal */
const formatUnexpectedMessage = e => e.message ?? "is unexpected";
/** @internal */
const formatMissingMessage = e => esm_AST/* getMissingMessageAnnotation */.ej(e.ast).pipe(esm_Effect/* flatMap */.VSD(annotation => {
  const out = annotation();
  return esm_Predicate/* isString */.HD(out) ? esm_Effect/* succeed */.ng0(out) : out;
}), esm_Effect/* catchAll */.kmb(() => esm_Effect/* succeed */.ng0(e.message ?? "is missing")));
const getTree = (issue, onFailure) => esm_Effect/* matchEffect */.PwY(getMessage(issue), {
  onFailure,
  onSuccess: message => esm_Effect/* succeed */.ng0(make(message))
});
const go = e => {
  switch (e._tag) {
    case "Type":
      return esm_Effect/* map */.UID(formatTypeMessage(e), make);
    case "Forbidden":
      return esm_Effect/* succeed */.ng0(make(getParseIssueTitle(e), [make(formatForbiddenMessage(e))]));
    case "Unexpected":
      return esm_Effect/* succeed */.ng0(make(formatUnexpectedMessage(e)));
    case "Missing":
      return esm_Effect/* map */.UID(formatMissingMessage(e), make);
    case "Transformation":
      return getTree(e, () => esm_Effect/* map */.UID(go(e.issue), tree => make(getParseIssueTitle(e), [make(formatTransformationKind(e.kind), [tree])])));
    case "Refinement":
      return getTree(e, () => esm_Effect/* map */.UID(go(e.issue), tree => make(getParseIssueTitle(e), [make(formatRefinementKind(e.kind), [tree])])));
    case "Pointer":
      return esm_Effect/* map */.UID(go(e.issue), tree => make(util/* formatPath */.dI(e.path), [tree]));
    case "Composite":
      {
        const parseIssueTitle = getParseIssueTitle(e);
        return getTree(e, () => util/* isNonEmpty */.Od(e.issues) ? esm_Effect/* map */.UID(esm_Effect/* forEach */.Ed_(e.issues, go), forest => make(parseIssueTitle, forest)) : esm_Effect/* map */.UID(go(e.issues), tree => make(parseIssueTitle, [tree])));
      }
  }
};
//# sourceMappingURL=TreeFormatter.js.map
;// CONCATENATED MODULE: ./node_modules/@lucid-evolution/utils/node_modules/@effect/schema/dist/esm/ParseResult.js
/**
 * @since 0.67.0
 */












/**
 * @category model
 * @since 0.68.0
 */
class Pointer {
  path;
  actual;
  issue;
  /**
   * @since 0.68.0
   */
  _tag = "Pointer";
  constructor(path, actual, issue) {
    this.path = path;
    this.actual = actual;
    this.issue = issue;
  }
}
/**
 * Error that occurs when an unexpected key or index is present.
 *
 * @category model
 * @since 0.67.0
 */
class Unexpected {
  actual;
  message;
  /**
   * @since 0.67.0
   */
  _tag = "Unexpected";
  constructor(actual,
  /**
   * @since 0.68.0
   */
  message) {
    this.actual = actual;
    this.message = message;
  }
}
/**
 * Error that occurs when a required key or index is missing.
 *
 * @category model
 * @since 0.67.0
 */
class Missing {
  ast;
  message;
  /**
   * @since 0.67.0
   */
  _tag = "Missing";
  /**
   * @since 0.68.0
   */
  actual = undefined;
  constructor(
  /**
   * @since 0.68.0
   */
  ast,
  /**
   * @since 0.68.0
   */
  message) {
    this.ast = ast;
    this.message = message;
  }
}
/**
 * Error that contains multiple issues.
 *
 * @category model
 * @since 0.68.0
 */
class Composite {
  ast;
  actual;
  issues;
  output;
  /**
   * @since 0.68.0
   */
  _tag = "Composite";
  constructor(ast, actual, issues, output) {
    this.ast = ast;
    this.actual = actual;
    this.issues = issues;
    this.output = output;
  }
}
/**
 * Returns `true` if the value is a `Composite`.
 *
 * @category guards
 * @since 0.68.0
 */
const ParseResult_isComposite = u => Predicate.hasProperty(u, "_tag");
/**
 * Error that occurs when a refinement has an error.
 *
 * @category model
 * @since 0.67.0
 */
class Refinement {
  ast;
  actual;
  kind;
  issue;
  /**
   * @since 0.67.0
   */
  _tag = "Refinement";
  constructor(ast, actual, kind, issue) {
    this.ast = ast;
    this.actual = actual;
    this.kind = kind;
    this.issue = issue;
  }
}
/**
 * Error that occurs when a transformation has an error.
 *
 * @category model
 * @since 0.67.0
 */
class Transformation {
  ast;
  actual;
  kind;
  issue;
  /**
   * @since 0.67.0
   */
  _tag = "Transformation";
  constructor(ast, actual, kind, issue) {
    this.ast = ast;
    this.actual = actual;
    this.kind = kind;
    this.issue = issue;
  }
}
/**
 * The `Type` variant of the `ParseIssue` type represents an error that occurs when the `actual` value is not of the expected type.
 * The `ast` field specifies the expected type, and the `actual` field contains the value that caused the error.
 *
 * @category model
 * @since 0.67.0
 */
class Type {
  ast;
  actual;
  message;
  /**
   * @since 0.67.0
   */
  _tag = "Type";
  constructor(ast, actual, message) {
    this.ast = ast;
    this.actual = actual;
    this.message = message;
  }
}
/**
 * The `Forbidden` variant of the `ParseIssue` type represents a forbidden operation, such as when encountering an Effect that is not allowed to execute (e.g., using `runSync`).
 *
 * @category model
 * @since 0.67.0
 */
class Forbidden {
  ast;
  actual;
  message;
  /**
   * @since 0.67.0
   */
  _tag = "Forbidden";
  constructor(ast, actual, message) {
    this.ast = ast;
    this.actual = actual;
    this.message = message;
  }
}
/**
 * @category type id
 * @since 0.68.0
 */
const ParseErrorTypeId = /*#__PURE__*/Symbol.for("@effect/schema/ParseErrorTypeId");
/**
 * @since 0.68.0
 */
const isParseError = u => Predicate.hasProperty(u, ParseErrorTypeId);
/**
 * @since 0.67.0
 */
class ParseError extends /*#__PURE__*/(0,Data/* TaggedError */.fZ)("ParseError") {
  /**
   * @since 0.68.0
   */
  [ParseErrorTypeId] = ParseErrorTypeId;
  get message() {
    return this.toString();
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return formatIssueSync(this.issue);
  }
  /**
   * @since 0.67.0
   */
  toJSON() {
    return {
      _id: "ParseError",
      message: this.toString()
    };
  }
  /**
   * @since 0.67.0
   */
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return this.toJSON();
  }
}
/**
 * @category constructors
 * @since 0.67.0
 */
const parseError = issue => new ParseError({
  issue
});
/**
 * @category constructors
 * @since 0.67.0
 */
const succeed = esm_Either/* right */.F2;
/**
 * @category constructors
 * @since 0.67.0
 */
const fail = esm_Either/* left */.t$;
const _try = esm_Either/* try */.JH;

/**
 * @category constructors
 * @since 0.67.0
 */
const fromOption = esm_Either/* fromOption */.Yo;
/**
 * @category optimisation
 * @since 0.67.0
 */
const flatMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const s = self;
  if (s["_tag"] === "Left") {
    return s;
  }
  if (s["_tag"] === "Right") {
    return f(s.right);
  }
  return esm_Effect/* flatMap */.VSD(self, f);
});
/**
 * @category optimisation
 * @since 0.67.0
 */
const map = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const s = self;
  if (s["_tag"] === "Left") {
    return s;
  }
  if (s["_tag"] === "Right") {
    return esm_Either/* right */.F2(f(s.right));
  }
  return esm_Effect/* map */.UID(self, f);
});
/**
 * @category optimisation
 * @since 0.67.0
 */
const mapError = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const s = self;
  if (s["_tag"] === "Left") {
    return esm_Either/* left */.t$(f(s.left));
  }
  if (s["_tag"] === "Right") {
    return s;
  }
  return esm_Effect/* mapError */.d1Y(self, f);
});
/**
 * @category optimisation
 * @since 0.67.0
 */
const eitherOrUndefined = self => {
  const s = self;
  if (s["_tag"] === "Left" || s["_tag"] === "Right") {
    return s;
  }
};
/**
 * @category optimisation
 * @since 0.67.0
 */
const mapBoth = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, options) => {
  const s = self;
  if (s["_tag"] === "Left") {
    return Either.left(options.onFailure(s.left));
  }
  if (s["_tag"] === "Right") {
    return Either.right(options.onSuccess(s.right));
  }
  return Effect.mapBoth(self, options);
})));
/**
 * @category optimisation
 * @since 0.67.0
 */
const orElse = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  const s = self;
  if (s["_tag"] === "Left") {
    return f(s.left);
  }
  if (s["_tag"] === "Right") {
    return s;
  }
  return Effect.catchAll(self, f);
})));
/** @internal */
const mergeInternalOptions = (options, overrideOptions) => {
  if (overrideOptions === undefined || esm_Predicate/* isNumber */.hj(overrideOptions)) {
    return options;
  }
  if (options === undefined) {
    return overrideOptions;
  }
  return {
    ...options,
    ...overrideOptions
  };
};
const getEither = (ast, isDecoding, options) => {
  const parser = goMemo(ast, isDecoding);
  return (u, overrideOptions) => parser(u, mergeInternalOptions(options, overrideOptions));
};
const getSync = (ast, isDecoding, options) => {
  const parser = getEither(ast, isDecoding, options);
  return (input, overrideOptions) => esm_Either/* getOrThrowWith */.G$(parser(input, overrideOptions), parseError);
};
const getOption = (ast, isDecoding, options) => {
  const parser = getEither(ast, isDecoding, options);
  return (input, overrideOptions) => Option.getRight(parser(input, overrideOptions));
};
const getEffect = (ast, isDecoding, options) => {
  const parser = goMemo(ast, isDecoding);
  return (input, overrideOptions) => parser(input, {
    ...mergeInternalOptions(options, overrideOptions),
    isEffectAllowed: true
  });
};
/**
 * @throws `ParseError`
 * @category decoding
 * @since 0.67.0
 */
const decodeUnknownSync = (schema, options) => getSync(schema.ast, true, options);
/**
 * @category decoding
 * @since 0.67.0
 */
const decodeUnknownOption = (schema, options) => getOption(schema.ast, true, options);
/**
 * @category decoding
 * @since 0.67.0
 */
const decodeUnknownEither = (schema, options) => getEither(schema.ast, true, options);
/**
 * @category decoding
 * @since 0.67.0
 */
const decodeUnknownPromise = (schema, options) => {
  const parser = decodeUnknown(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category decoding
 * @since 0.67.0
 */
const decodeUnknown = (schema, options) => getEffect(schema.ast, true, options);
/**
 * @throws `ParseError`
 * @category encoding
 * @since 0.67.0
 */
const encodeUnknownSync = (schema, options) => getSync(schema.ast, false, options);
/**
 * @category encoding
 * @since 0.67.0
 */
const encodeUnknownOption = (schema, options) => getOption(schema.ast, false, options);
/**
 * @category encoding
 * @since 0.67.0
 */
const encodeUnknownEither = (schema, options) => getEither(schema.ast, false, options);
/**
 * @category encoding
 * @since 0.67.0
 */
const encodeUnknownPromise = (schema, options) => {
  const parser = encodeUnknown(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category encoding
 * @since 0.67.0
 */
const encodeUnknown = (schema, options) => getEffect(schema.ast, false, options);
/**
 * @category decoding
 * @since 0.67.0
 */
const decodeSync = (/* unused pure expression or super */ null && (decodeUnknownSync));
/**
 * @category decoding
 * @since 0.67.0
 */
const decodeOption = (/* unused pure expression or super */ null && (decodeUnknownOption));
/**
 * @category decoding
 * @since 0.67.0
 */
const decodeEither = (/* unused pure expression or super */ null && (decodeUnknownEither));
/**
 * @category decoding
 * @since 0.67.0
 */
const decodePromise = (/* unused pure expression or super */ null && (decodeUnknownPromise));
/**
 * @category decoding
 * @since 0.67.0
 */
const decode = (/* unused pure expression or super */ null && (decodeUnknown));
/**
 * @throws `ParseError`
 * @category validation
 * @since 0.67.0
 */
const validateSync = (schema, options) => getSync(esm_AST/* typeAST */.Yc(schema.ast), true, options);
/**
 * @category validation
 * @since 0.67.0
 */
const validateOption = (schema, options) => getOption(AST.typeAST(schema.ast), true, options);
/**
 * @category validation
 * @since 0.67.0
 */
const validateEither = (schema, options) => getEither(AST.typeAST(schema.ast), true, options);
/**
 * @category validation
 * @since 0.67.0
 */
const validatePromise = (schema, options) => {
  const parser = validate(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category validation
 * @since 0.67.0
 */
const validate = (schema, options) => getEffect(AST.typeAST(schema.ast), true, options);
/**
 * By default the option `exact` is set to `true`.
 *
 * @category validation
 * @since 0.67.0
 */
const is = (schema, options) => {
  const parser = goMemo(esm_AST/* typeAST */.Yc(schema.ast), true);
  return (u, overrideOptions) => esm_Either/* isRight */.tO(parser(u, {
    exact: true,
    ...mergeInternalOptions(options, overrideOptions)
  }));
};
/**
 * By default the option `exact` is set to `true`.
 *
 * @throws `ParseError`
 * @category validation
 * @since 0.67.0
 */
const asserts = (schema, options) => {
  const parser = goMemo(AST.typeAST(schema.ast), true);
  return (u, overrideOptions) => {
    const result = parser(u, {
      exact: true,
      ...mergeInternalOptions(options, overrideOptions)
    });
    if (Either.isLeft(result)) {
      throw parseError(result.left);
    }
  };
};
/**
 * @category encoding
 * @since 0.67.0
 */
const encodeSync = (/* unused pure expression or super */ null && (encodeUnknownSync));
/**
 * @category encoding
 * @since 0.67.0
 */
const encodeOption = (/* unused pure expression or super */ null && (encodeUnknownOption));
/**
 * @category encoding
 * @since 0.67.0
 */
const encodeEither = (/* unused pure expression or super */ null && (encodeUnknownEither));
/**
 * @category encoding
 * @since 0.67.0
 */
const encodePromise = (/* unused pure expression or super */ null && (encodeUnknownPromise));
/**
 * @category encoding
 * @since 0.67.0
 */
const encode = (/* unused pure expression or super */ null && (encodeUnknown));
const decodeMemoMap = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("@effect/schema/Parser/decodeMemoMap"), () => new WeakMap());
const encodeMemoMap = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("@effect/schema/Parser/encodeMemoMap"), () => new WeakMap());
const goMemo = (ast, isDecoding) => {
  const memoMap = isDecoding ? decodeMemoMap : encodeMemoMap;
  const memo = memoMap.get(ast);
  if (memo) {
    return memo;
  }
  const raw = ParseResult_go(ast, isDecoding);
  const parseOptionsAnnotation = esm_AST/* getParseOptionsAnnotation */.TO(ast);
  const parser = esm_Option/* isSome */.pC(parseOptionsAnnotation) ? (i, options) => raw(i, mergeInternalOptions(options, parseOptionsAnnotation.value)) : raw;
  memoMap.set(ast, parser);
  return parser;
};
const getConcurrency = ast => esm_Option/* getOrUndefined */.jD(esm_AST/* getConcurrencyAnnotation */.mm(ast));
const getBatching = ast => esm_Option/* getOrUndefined */.jD(esm_AST/* getBatchingAnnotation */.we(ast));
const ParseResult_go = (ast, isDecoding) => {
  switch (ast._tag) {
    case "Refinement":
      {
        if (isDecoding) {
          const from = goMemo(ast.from, true);
          return (i, options) => handleForbidden(flatMap(mapError(from(i, options), e => new Refinement(ast, i, "From", e)), a => esm_Option/* match */.EQ(ast.filter(a, options ?? esm_AST/* defaultParseOption */.Dr, ast), {
            onNone: () => esm_Either/* right */.F2(a),
            onSome: e => esm_Either/* left */.t$(new Refinement(ast, i, "Predicate", e))
          })), ast, i, options);
        } else {
          const from = goMemo(esm_AST/* typeAST */.Yc(ast), true);
          const to = goMemo(dropRightRefinement(ast.from), false);
          return (i, options) => handleForbidden(flatMap(from(i, options), a => to(a, options)), ast, i, options);
        }
      }
    case "Transformation":
      {
        const transform = getFinalTransformation(ast.transformation, isDecoding);
        const from = isDecoding ? goMemo(ast.from, true) : goMemo(ast.to, false);
        const to = isDecoding ? goMemo(ast.to, true) : goMemo(ast.from, false);
        return (i1, options) => handleForbidden(flatMap(mapError(from(i1, options), e => new Transformation(ast, i1, isDecoding ? "Encoded" : "Type", e)), a => flatMap(mapError(transform(a, options ?? esm_AST/* defaultParseOption */.Dr, ast), e => new Transformation(ast, i1, "Transformation", e)), i2 => mapError(to(i2, options), e => new Transformation(ast, i1, isDecoding ? "Type" : "Encoded", e)))), ast, i1, options);
      }
    case "Declaration":
      {
        const parse = isDecoding ? ast.decodeUnknown(...ast.typeParameters) : ast.encodeUnknown(...ast.typeParameters);
        return (i, options) => handleForbidden(parse(i, options ?? esm_AST/* defaultParseOption */.Dr, ast), ast, i, options);
      }
    case "Literal":
      return fromRefinement(ast, u => u === ast.literal);
    case "UniqueSymbol":
      return fromRefinement(ast, u => u === ast.symbol);
    case "UndefinedKeyword":
      return fromRefinement(ast, esm_Predicate/* isUndefined */.o8);
    case "VoidKeyword":
      return fromRefinement(ast, esm_Predicate/* isUndefined */.o8);
    case "NeverKeyword":
      return fromRefinement(ast, esm_Predicate/* isNever */.r2);
    case "UnknownKeyword":
    case "AnyKeyword":
      return esm_Either/* right */.F2;
    case "StringKeyword":
      return fromRefinement(ast, esm_Predicate/* isString */.HD);
    case "NumberKeyword":
      return fromRefinement(ast, esm_Predicate/* isNumber */.hj);
    case "BooleanKeyword":
      return fromRefinement(ast, esm_Predicate/* isBoolean */.jn);
    case "BigIntKeyword":
      return fromRefinement(ast, esm_Predicate/* isBigInt */.C4);
    case "SymbolKeyword":
      return fromRefinement(ast, esm_Predicate/* isSymbol */.yk);
    case "ObjectKeyword":
      return fromRefinement(ast, esm_Predicate/* isObject */.Kn);
    case "Enums":
      return fromRefinement(ast, u => ast.enums.some(([_, value]) => value === u));
    case "TemplateLiteral":
      {
        const regex = esm_AST/* getTemplateLiteralRegExp */.M7(ast);
        return fromRefinement(ast, u => esm_Predicate/* isString */.HD(u) && regex.test(u));
      }
    case "TupleType":
      {
        const elements = ast.elements.map(e => goMemo(e.type, isDecoding));
        const rest = ast.rest.map(annotatedAST => goMemo(annotatedAST.type, isDecoding));
        let requiredTypes = ast.elements.filter(e => !e.isOptional);
        if (ast.rest.length > 0) {
          requiredTypes = requiredTypes.concat(ast.rest.slice(1));
        }
        const requiredLen = requiredTypes.length;
        const expectedIndexes = ast.elements.length > 0 ? ast.elements.map((_, i) => i).join(" | ") : "never";
        const concurrency = getConcurrency(ast);
        const batching = getBatching(ast);
        return (input, options) => {
          if (!esm_Array/* isArray */.kJ(input)) {
            return esm_Either/* left */.t$(new Type(ast, input));
          }
          const allErrors = options?.errors === "all";
          const es = [];
          let stepKey = 0;
          const output = [];
          // ---------------------------------------------
          // handle missing indexes
          // ---------------------------------------------
          const len = input.length;
          for (let i = len; i <= requiredLen - 1; i++) {
            const e = new Pointer(i, input, new Missing(requiredTypes[i - len]));
            if (allErrors) {
              es.push([stepKey++, e]);
              continue;
            } else {
              return esm_Either/* left */.t$(new Composite(ast, input, e, output));
            }
          }
          // ---------------------------------------------
          // handle excess indexes
          // ---------------------------------------------
          if (ast.rest.length === 0) {
            for (let i = ast.elements.length; i <= len - 1; i++) {
              const e = new Pointer(i, input, new Unexpected(input[i], `is unexpected, expected: ${expectedIndexes}`));
              if (allErrors) {
                es.push([stepKey++, e]);
                continue;
              } else {
                return esm_Either/* left */.t$(new Composite(ast, input, e, output));
              }
            }
          }
          let i = 0;
          let queue = undefined;
          // ---------------------------------------------
          // handle elements
          // ---------------------------------------------
          for (; i < elements.length; i++) {
            if (len < i + 1) {
              if (ast.elements[i].isOptional) {
                // the input element is missing
                continue;
              }
            } else {
              const parser = elements[i];
              const te = parser(input[i], options);
              const eu = eitherOrUndefined(te);
              if (eu) {
                if (esm_Either/* isLeft */.nM(eu)) {
                  // the input element is present but is not valid
                  const e = new Pointer(i, input, eu.left);
                  if (allErrors) {
                    es.push([stepKey++, e]);
                    continue;
                  } else {
                    return esm_Either/* left */.t$(new Composite(ast, input, e, sortByIndex(output)));
                  }
                }
                output.push([stepKey++, eu.right]);
              } else {
                const nk = stepKey++;
                const index = i;
                if (!queue) {
                  queue = [];
                }
                queue.push(({
                  es,
                  output
                }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(te), t => {
                  if (esm_Either/* isLeft */.nM(t)) {
                    // the input element is present but is not valid
                    const e = new Pointer(index, input, t.left);
                    if (allErrors) {
                      es.push([nk, e]);
                      return esm_Effect/* void */.Hcj;
                    } else {
                      return esm_Either/* left */.t$(new Composite(ast, input, e, sortByIndex(output)));
                    }
                  }
                  output.push([nk, t.right]);
                  return esm_Effect/* void */.Hcj;
                }));
              }
            }
          }
          // ---------------------------------------------
          // handle rest element
          // ---------------------------------------------
          if (esm_Array/* isNonEmptyReadonlyArray */.Ux(rest)) {
            const [head, ...tail] = rest;
            for (; i < len - tail.length; i++) {
              const te = head(input[i], options);
              const eu = eitherOrUndefined(te);
              if (eu) {
                if (esm_Either/* isLeft */.nM(eu)) {
                  const e = new Pointer(i, input, eu.left);
                  if (allErrors) {
                    es.push([stepKey++, e]);
                    continue;
                  } else {
                    return esm_Either/* left */.t$(new Composite(ast, input, e, sortByIndex(output)));
                  }
                } else {
                  output.push([stepKey++, eu.right]);
                }
              } else {
                const nk = stepKey++;
                const index = i;
                if (!queue) {
                  queue = [];
                }
                queue.push(({
                  es,
                  output
                }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(te), t => {
                  if (esm_Either/* isLeft */.nM(t)) {
                    const e = new Pointer(index, input, t.left);
                    if (allErrors) {
                      es.push([nk, e]);
                      return esm_Effect/* void */.Hcj;
                    } else {
                      return esm_Either/* left */.t$(new Composite(ast, input, e, sortByIndex(output)));
                    }
                  } else {
                    output.push([nk, t.right]);
                    return esm_Effect/* void */.Hcj;
                  }
                }));
              }
            }
            // ---------------------------------------------
            // handle post rest elements
            // ---------------------------------------------
            for (let j = 0; j < tail.length; j++) {
              i += j;
              if (len < i + 1) {
                continue;
              } else {
                const te = tail[j](input[i], options);
                const eu = eitherOrUndefined(te);
                if (eu) {
                  if (esm_Either/* isLeft */.nM(eu)) {
                    // the input element is present but is not valid
                    const e = new Pointer(i, input, eu.left);
                    if (allErrors) {
                      es.push([stepKey++, e]);
                      continue;
                    } else {
                      return esm_Either/* left */.t$(new Composite(ast, input, e, sortByIndex(output)));
                    }
                  }
                  output.push([stepKey++, eu.right]);
                } else {
                  const nk = stepKey++;
                  const index = i;
                  if (!queue) {
                    queue = [];
                  }
                  queue.push(({
                    es,
                    output
                  }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(te), t => {
                    if (esm_Either/* isLeft */.nM(t)) {
                      // the input element is present but is not valid
                      const e = new Pointer(index, input, t.left);
                      if (allErrors) {
                        es.push([nk, e]);
                        return esm_Effect/* void */.Hcj;
                      } else {
                        return esm_Either/* left */.t$(new Composite(ast, input, e, sortByIndex(output)));
                      }
                    }
                    output.push([nk, t.right]);
                    return esm_Effect/* void */.Hcj;
                  }));
                }
              }
            }
          }
          // ---------------------------------------------
          // compute result
          // ---------------------------------------------
          const computeResult = ({
            es,
            output
          }) => esm_Array/* isNonEmptyArray */.Of(es) ? esm_Either/* left */.t$(new Composite(ast, input, sortByIndex(es), sortByIndex(output))) : esm_Either/* right */.F2(sortByIndex(output));
          if (queue && queue.length > 0) {
            const cqueue = queue;
            return esm_Effect/* suspend */.RqG(() => {
              const state = {
                es: esm_Array/* copy */.JG(es),
                output: esm_Array/* copy */.JG(output)
              };
              return esm_Effect/* flatMap */.VSD(esm_Effect/* forEach */.Ed_(cqueue, f => f(state), {
                concurrency,
                batching,
                discard: true
              }), () => computeResult(state));
            });
          }
          return computeResult({
            output,
            es
          });
        };
      }
    case "TypeLiteral":
      {
        if (ast.propertySignatures.length === 0 && ast.indexSignatures.length === 0) {
          return fromRefinement(ast, esm_Predicate/* isNotNullable */.jW);
        }
        const propertySignatures = [];
        const expectedKeysMap = {};
        const expectedKeys = [];
        for (const ps of ast.propertySignatures) {
          propertySignatures.push([goMemo(ps.type, isDecoding), ps]);
          expectedKeysMap[ps.name] = null;
          expectedKeys.push(ps.name);
        }
        const indexSignatures = ast.indexSignatures.map(is => [goMemo(is.parameter, isDecoding), goMemo(is.type, isDecoding), is.parameter]);
        const expectedAST = esm_AST/* Union.make */.EJ.make(ast.indexSignatures.map(is => is.parameter).concat(expectedKeys.map(key => esm_Predicate/* isSymbol */.yk(key) ? new esm_AST/* UniqueSymbol */.VF(key) : new esm_AST/* Literal */.t$(key))));
        const expected = goMemo(expectedAST, isDecoding);
        const concurrency = getConcurrency(ast);
        const batching = getBatching(ast);
        return (input, options) => {
          if (!esm_Predicate/* isRecord */.Uy(input)) {
            return esm_Either/* left */.t$(new Type(ast, input));
          }
          const allErrors = options?.errors === "all";
          const es = [];
          let stepKey = 0;
          // ---------------------------------------------
          // handle excess properties
          // ---------------------------------------------
          const onExcessPropertyError = options?.onExcessProperty === "error";
          const onExcessPropertyPreserve = options?.onExcessProperty === "preserve";
          const output = {};
          let inputKeys;
          if (onExcessPropertyError || onExcessPropertyPreserve) {
            inputKeys = util/* ownKeys */.Wp(input);
            for (const key of inputKeys) {
              const eu = eitherOrUndefined(expected(key, options));
              if (esm_Either/* isLeft */.nM(eu)) {
                // key is unexpected
                if (onExcessPropertyError) {
                  const e = new Pointer(key, input, new Unexpected(input[key], `is unexpected, expected: ${String(expectedAST)}`));
                  if (allErrors) {
                    es.push([stepKey++, e]);
                    continue;
                  } else {
                    return esm_Either/* left */.t$(new Composite(ast, input, e, output));
                  }
                } else {
                  // preserve key
                  output[key] = input[key];
                }
              }
            }
          }
          let queue = undefined;
          const isExact = options?.exact === true;
          for (let i = 0; i < propertySignatures.length; i++) {
            const ps = propertySignatures[i][1];
            const name = ps.name;
            const hasKey = Object.prototype.hasOwnProperty.call(input, name);
            if (!hasKey) {
              if (ps.isOptional) {
                continue;
              } else if (isExact) {
                const e = new Pointer(name, input, new Missing(ps));
                if (allErrors) {
                  es.push([stepKey++, e]);
                  continue;
                } else {
                  return esm_Either/* left */.t$(new Composite(ast, input, e, output));
                }
              }
            }
            const parser = propertySignatures[i][0];
            const te = parser(input[name], options);
            const eu = eitherOrUndefined(te);
            if (eu) {
              if (esm_Either/* isLeft */.nM(eu)) {
                const e = new Pointer(name, input, hasKey ? eu.left : new Missing(ps));
                if (allErrors) {
                  es.push([stepKey++, e]);
                  continue;
                } else {
                  return esm_Either/* left */.t$(new Composite(ast, input, e, output));
                }
              }
              output[name] = eu.right;
            } else {
              const nk = stepKey++;
              const index = name;
              if (!queue) {
                queue = [];
              }
              queue.push(({
                es,
                output
              }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(te), t => {
                if (esm_Either/* isLeft */.nM(t)) {
                  const e = new Pointer(index, input, hasKey ? t.left : new Missing(ps));
                  if (allErrors) {
                    es.push([nk, e]);
                    return esm_Effect/* void */.Hcj;
                  } else {
                    return esm_Either/* left */.t$(new Composite(ast, input, e, output));
                  }
                }
                output[index] = t.right;
                return esm_Effect/* void */.Hcj;
              }));
            }
          }
          // ---------------------------------------------
          // handle index signatures
          // ---------------------------------------------
          for (let i = 0; i < indexSignatures.length; i++) {
            const indexSignature = indexSignatures[i];
            const parameter = indexSignature[0];
            const type = indexSignature[1];
            const keys = util/* getKeysForIndexSignature */.k8(input, indexSignature[2]);
            for (const key of keys) {
              // ---------------------------------------------
              // handle keys
              // ---------------------------------------------
              const keu = eitherOrUndefined(parameter(key, options));
              if (keu && esm_Either/* isRight */.tO(keu)) {
                // ---------------------------------------------
                // handle values
                // ---------------------------------------------
                const vpr = type(input[key], options);
                const veu = eitherOrUndefined(vpr);
                if (veu) {
                  if (esm_Either/* isLeft */.nM(veu)) {
                    const e = new Pointer(key, input, veu.left);
                    if (allErrors) {
                      es.push([stepKey++, e]);
                      continue;
                    } else {
                      return esm_Either/* left */.t$(new Composite(ast, input, e, output));
                    }
                  } else {
                    if (!Object.prototype.hasOwnProperty.call(expectedKeysMap, key)) {
                      output[key] = veu.right;
                    }
                  }
                } else {
                  const nk = stepKey++;
                  const index = key;
                  if (!queue) {
                    queue = [];
                  }
                  queue.push(({
                    es,
                    output
                  }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(vpr), tv => {
                    if (esm_Either/* isLeft */.nM(tv)) {
                      const e = new Pointer(index, input, tv.left);
                      if (allErrors) {
                        es.push([nk, e]);
                        return esm_Effect/* void */.Hcj;
                      } else {
                        return esm_Either/* left */.t$(new Composite(ast, input, e, output));
                      }
                    } else {
                      if (!Object.prototype.hasOwnProperty.call(expectedKeysMap, key)) {
                        output[key] = tv.right;
                      }
                      return esm_Effect/* void */.Hcj;
                    }
                  }));
                }
              }
            }
          }
          // ---------------------------------------------
          // compute result
          // ---------------------------------------------
          const computeResult = ({
            es,
            output
          }) => {
            if (esm_Array/* isNonEmptyArray */.Of(es)) {
              return esm_Either/* left */.t$(new Composite(ast, input, sortByIndex(es), output));
            }
            if (options?.propertyOrder === "original") {
              // preserve input keys order
              const keys = inputKeys || util/* ownKeys */.Wp(input);
              for (const name of expectedKeys) {
                if (keys.indexOf(name) === -1) {
                  keys.push(name);
                }
              }
              const out = {};
              for (const key of keys) {
                if (Object.prototype.hasOwnProperty.call(output, key)) {
                  out[key] = output[key];
                }
              }
              return esm_Either/* right */.F2(out);
            }
            return esm_Either/* right */.F2(output);
          };
          if (queue && queue.length > 0) {
            const cqueue = queue;
            return esm_Effect/* suspend */.RqG(() => {
              const state = {
                es: esm_Array/* copy */.JG(es),
                output: Object.assign({}, output)
              };
              return esm_Effect/* flatMap */.VSD(esm_Effect/* forEach */.Ed_(cqueue, f => f(state), {
                concurrency,
                batching,
                discard: true
              }), () => computeResult(state));
            });
          }
          return computeResult({
            es,
            output
          });
        };
      }
    case "Union":
      {
        const searchTree = getSearchTree(ast.types, isDecoding);
        const ownKeys = util/* ownKeys */.Wp(searchTree.keys);
        const len = ownKeys.length;
        const map = new Map();
        for (let i = 0; i < ast.types.length; i++) {
          map.set(ast.types[i], goMemo(ast.types[i], isDecoding));
        }
        const concurrency = getConcurrency(ast) ?? 1;
        const batching = getBatching(ast);
        return (input, options) => {
          const es = [];
          let stepKey = 0;
          let candidates = [];
          if (len > 0) {
            // if there is at least one key then input must be an object
            if (esm_Predicate/* isRecord */.Uy(input)) {
              for (let i = 0; i < len; i++) {
                const name = ownKeys[i];
                const buckets = searchTree.keys[name].buckets;
                // for each property that should contain a literal, check if the input contains that property
                if (Object.prototype.hasOwnProperty.call(input, name)) {
                  const literal = String(input[name]);
                  // check that the value obtained from the input for the property corresponds to an existing bucket
                  if (Object.prototype.hasOwnProperty.call(buckets, literal)) {
                    // retrive the minimal set of candidates for decoding
                    candidates = candidates.concat(buckets[literal]);
                  } else {
                    const literals = esm_AST/* Union.make */.EJ.make(searchTree.keys[name].literals);
                    es.push([stepKey++, new Composite(new esm_AST/* TypeLiteral */.tW([new esm_AST/* PropertySignature */.TJ(name, literals, false, true)], []), input, new Pointer(name, input, new Type(literals, input[name])))]);
                  }
                } else {
                  const literals = esm_AST/* Union.make */.EJ.make(searchTree.keys[name].literals);
                  const fakeps = new esm_AST/* PropertySignature */.TJ(name, literals, false, true); // TODO: inherit message annotation from the union?
                  es.push([stepKey++, new Composite(new esm_AST/* TypeLiteral */.tW([fakeps], []), input, new Pointer(name, input, new Missing(fakeps)))]);
                }
              }
            } else {
              es.push([stepKey++, new Type(ast, input)]);
            }
          }
          if (searchTree.otherwise.length > 0) {
            candidates = candidates.concat(searchTree.otherwise);
          }
          let queue = undefined;
          for (let i = 0; i < candidates.length; i++) {
            const candidate = candidates[i];
            const pr = map.get(candidate)(input, options);
            // the members of a union are ordered based on which one should be decoded first,
            // therefore if one member has added a task, all subsequent members must
            // also add a task to the queue even if they are synchronous
            const eu = !queue || queue.length === 0 ? eitherOrUndefined(pr) : undefined;
            if (eu) {
              if (esm_Either/* isRight */.tO(eu)) {
                return esm_Either/* right */.F2(eu.right);
              } else {
                es.push([stepKey++, eu.left]);
              }
            } else {
              const nk = stepKey++;
              if (!queue) {
                queue = [];
              }
              queue.push(state => esm_Effect/* suspend */.RqG(() => {
                if ("finalResult" in state) {
                  return esm_Effect/* void */.Hcj;
                } else {
                  return esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(pr), t => {
                    if (esm_Either/* isRight */.tO(t)) {
                      state.finalResult = esm_Either/* right */.F2(t.right);
                    } else {
                      state.es.push([nk, t.left]);
                    }
                    return esm_Effect/* void */.Hcj;
                  });
                }
              }));
            }
          }
          // ---------------------------------------------
          // compute result
          // ---------------------------------------------
          const computeResult = es => esm_Array/* isNonEmptyArray */.Of(es) ? es.length === 1 && es[0][1]._tag === "Type" ? esm_Either/* left */.t$(es[0][1]) : esm_Either/* left */.t$(new Composite(ast, input, sortByIndex(es))) :
          // this should never happen
          esm_Either/* left */.t$(new Type(ast, input));
          if (queue && queue.length > 0) {
            const cqueue = queue;
            return esm_Effect/* suspend */.RqG(() => {
              const state = {
                es: esm_Array/* copy */.JG(es)
              };
              return esm_Effect/* flatMap */.VSD(esm_Effect/* forEach */.Ed_(cqueue, f => f(state), {
                concurrency,
                batching,
                discard: true
              }), () => {
                if ("finalResult" in state) {
                  return state.finalResult;
                }
                return computeResult(state.es);
              });
            });
          }
          return computeResult(es);
        };
      }
    case "Suspend":
      {
        const get = util/* memoizeThunk */.d3(() => goMemo(esm_AST/* annotations */.ds(ast.f(), ast.annotations), isDecoding));
        return (a, options) => get()(a, options);
      }
  }
};
const fromRefinement = (ast, refinement) => u => refinement(u) ? esm_Either/* right */.F2(u) : esm_Either/* left */.t$(new Type(ast, u));
/** @internal */
const getLiterals = (ast, isDecoding) => {
  switch (ast._tag) {
    case "Declaration":
      {
        const annotation = esm_AST/* getSurrogateAnnotation */.O5(ast);
        if (esm_Option/* isSome */.pC(annotation)) {
          return getLiterals(annotation.value, isDecoding);
        }
        break;
      }
    case "TypeLiteral":
      {
        const out = [];
        for (let i = 0; i < ast.propertySignatures.length; i++) {
          const propertySignature = ast.propertySignatures[i];
          const type = isDecoding ? esm_AST/* encodedAST */.Bh(propertySignature.type) : esm_AST/* typeAST */.Yc(propertySignature.type);
          if (esm_AST/* isLiteral */.n_(type) && !propertySignature.isOptional) {
            out.push([propertySignature.name, type]);
          }
        }
        return out;
      }
    case "Refinement":
      return getLiterals(ast.from, isDecoding);
    case "Suspend":
      return getLiterals(ast.f(), isDecoding);
    case "Transformation":
      return getLiterals(isDecoding ? ast.from : ast.to, isDecoding);
  }
  return [];
};
/**
 * The purpose of the algorithm is to narrow down the pool of possible candidates for decoding as much as possible.
 *
 * This function separates the schemas into two groups, `keys` and `otherwise`:
 *
 * - `keys`: the schema has at least one property with a literal value
 * - `otherwise`: the schema has no properties with a literal value
 *
 * If a schema has at least one property with a literal value, so it ends up in `keys`, first a namespace is created for
 * the name of the property containing the literal, and then within this namespace a "bucket" is created for the literal
 * value in which to store all the schemas that have the same property and literal value.
 *
 * @internal
 */
const getSearchTree = (members, isDecoding) => {
  const keys = {};
  const otherwise = [];
  for (let i = 0; i < members.length; i++) {
    const member = members[i];
    const tags = getLiterals(member, isDecoding);
    if (tags.length > 0) {
      for (let j = 0; j < tags.length; j++) {
        const [key, literal] = tags[j];
        const hash = String(literal.literal);
        keys[key] = keys[key] || {
          buckets: {},
          literals: []
        };
        const buckets = keys[key].buckets;
        if (Object.prototype.hasOwnProperty.call(buckets, hash)) {
          if (j < tags.length - 1) {
            continue;
          }
          buckets[hash].push(member);
          keys[key].literals.push(literal);
        } else {
          buckets[hash] = [member];
          keys[key].literals.push(literal);
          break;
        }
      }
    } else {
      otherwise.push(member);
    }
  }
  return {
    keys,
    otherwise
  };
};
const dropRightRefinement = ast => esm_AST/* isRefinement */.TI(ast) ? dropRightRefinement(ast.from) : ast;
const handleForbidden = (effect, ast, actual, options) => {
  const eu = eitherOrUndefined(effect);
  if (eu) {
    return eu;
  }
  if (options?.isEffectAllowed === true) {
    return effect;
  }
  try {
    return esm_Effect/* runSync */.Wno(esm_Effect/* either */.wEe(effect));
  } catch (e) {
    return esm_Either/* left */.t$(new Forbidden(ast, actual, "cannot be be resolved synchronously, this is caused by using runSync on an effect that performs async work"));
  }
};
const compare = ([a], [b]) => a > b ? 1 : a < b ? -1 : 0;
function sortByIndex(es) {
  return es.sort(compare).map(t => t[1]);
}
// -------------------------------------------------------------------------------------
// transformations interpreter
// -------------------------------------------------------------------------------------
/** @internal */
const getFinalTransformation = (transformation, isDecoding) => {
  switch (transformation._tag) {
    case "FinalTransformation":
      return isDecoding ? transformation.decode : transformation.encode;
    case "ComposeTransformation":
      return esm_Either/* right */.F2;
    case "TypeLiteralTransformation":
      return input => {
        let out = esm_Either/* right */.F2(input);
        // ---------------------------------------------
        // handle property signature transformations
        // ---------------------------------------------
        for (const pst of transformation.propertySignatureTransformations) {
          const [from, to] = isDecoding ? [pst.from, pst.to] : [pst.to, pst.from];
          const transformation = isDecoding ? pst.decode : pst.encode;
          const f = input => {
            const o = transformation(Object.prototype.hasOwnProperty.call(input, from) ? esm_Option/* some */.G(input[from]) : esm_Option/* none */.YP());
            delete input[from];
            if (esm_Option/* isSome */.pC(o)) {
              input[to] = o.value;
            }
            return input;
          };
          out = map(out, f);
        }
        return out;
      };
  }
};
//# sourceMappingURL=ParseResult.js.map

/***/ }),

/***/ 36054:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mJB": function() { return /* binding */ Array$; },
  "Mr_": function() { return /* binding */ Number$; },
  "Ld9": function() { return /* binding */ String$; },
  "AUF": function() { return /* binding */ Schema_Struct; },
  "EJI": function() { return /* binding */ Union; },
  "RqG": function() { return /* binding */ suspend; }
});

// UNUSED EXPORTS: Any, Base64, Base64Url, BetweenBigDecimalTypeId, BetweenBigIntTypeId, BetweenDurationTypeId, BetweenTypeId, BigDecimal, BigDecimalFromNumber, BigDecimalFromSelf, BigInt, BigIntFromNumber, BigIntFromSelf, Boolean, BooleanFromUnknown, BrandTypeId, Capitalize, Capitalized, CapitalizedTypeId, Cause, CauseDefectUnknown, CauseFromSelf, Char, Chunk, ChunkFromSelf, Class, Config, Data, DataFromSelf, Date, DateFromNumber, DateFromSelf, DateFromString, Duration, DurationFromMillis, DurationFromNanos, DurationFromSelf, Either, EitherFromSelf, EitherFromUnion, EndsWithTypeId, Enums, Exit, ExitFromSelf, FiberId, FiberIdFromSelf, Finite, FiniteTypeId, FromPropertySignature, GreaterThanBigDecimalTypeId, GreaterThanBigIntTypeId, GreaterThanDurationTypeId, GreaterThanOrEqualToBigDecimalTypeId, GreaterThanOrEqualToBigIntTypeId, GreaterThanOrEqualToDurationTypeId, GreaterThanOrEqualToTypeId, GreaterThanTypeId, HashMap, HashMapFromSelf, HashSet, HashSetFromSelf, Hex, IncludesTypeId, InstanceOfTypeId, Int, IntTypeId, ItemsCountTypeId, JsonNumber, JsonNumberTypeId, LengthTypeId, LessThanBigDecimalTypeId, LessThanBigIntTypeId, LessThanDurationTypeId, LessThanOrEqualToBigDecimalTypeId, LessThanOrEqualToBigIntTypeId, LessThanOrEqualToDurationTypeId, LessThanOrEqualToTypeId, LessThanTypeId, List, ListFromSelf, Literal, Lowercase, Lowercased, LowercasedTypeId, Map, MapFromRecord, MapFromSelf, MaxItemsTypeId, MaxLengthTypeId, MinItemsTypeId, MinLengthTypeId, MultipleOfTypeId, Negative, NegativeBigDecimalFromSelf, NegativeBigDecimalTypeId, NegativeBigInt, NegativeBigIntFromSelf, Never, NonEmpty, NonEmptyArray, NonEmptyChunk, NonEmptyChunkFromSelf, NonNaN, NonNaNTypeId, NonNegative, NonNegativeBigDecimalFromSelf, NonNegativeBigDecimalTypeId, NonNegativeBigInt, NonNegativeBigIntFromSelf, NonPositive, NonPositiveBigDecimalFromSelf, NonPositiveBigDecimalTypeId, NonPositiveBigInt, NonPositiveBigIntFromSelf, Not, Null, NullOr, NullishOr, NumberFromString, Object, Option, OptionFromNullOr, OptionFromNullishOr, OptionFromSelf, OptionFromUndefinedOr, PatternTypeId, Positive, PositiveBigDecimalFromSelf, PositiveBigDecimalTypeId, PositiveBigInt, PositiveBigIntFromSelf, PropertySignatureDeclaration, PropertySignatureTransformation, PropertySignatureTypeId, ReadonlyMap, ReadonlyMapFromRecord, ReadonlyMapFromSelf, ReadonlySet, ReadonlySetFromSelf, Record, Redacted, RedactedFromSelf, Set, SetFromSelf, SortedSet, SortedSetFromSelf, StartsWithTypeId, Symbol, SymbolFromSelf, TaggedClass, TaggedError, TaggedRequest, TaggedStruct, TemplateLiteral, ToPropertySignature, Trim, Trimmed, TrimmedTypeId, Tuple, TypeId, ULID, ULIDTypeId, UUID, UUIDTypeId, Uint8Array, Uint8ArrayFromSelf, Uncapitalize, Uncapitalized, UncapitalizedTypeId, Undefined, UndefinedOr, UniqueSymbolFromSelf, Unknown, Uppercase, Uppercased, UppercasedTypeId, ValidDateFromSelf, ValidDateTypeId, Void, annotations, asSchema, asserts, attachPropertySignature, between, betweenBigDecimal, betweenBigInt, betweenDuration, brand, capitalized, clamp, clampBigDecimal, clampBigInt, clampDuration, compose, declare, decode, decodeEither, decodeOption, decodePromise, decodeSync, decodeUnknown, decodeUnknownEither, decodeUnknownOption, decodeUnknownPromise, decodeUnknownSync, element, encode, encodeEither, encodeOption, encodePromise, encodeSync, encodeUnknown, encodeUnknownEither, encodeUnknownOption, encodeUnknownPromise, encodeUnknownSync, encodedBoundSchema, encodedSchema, endsWith, extend, filter, filterEffect, finite, format, fromBrand, fromKey, getClassTag, getNumberIndexedAccess, greaterThan, greaterThanBigDecimal, greaterThanBigInt, greaterThanDuration, greaterThanOrEqualTo, greaterThanOrEqualToBigDecimal, greaterThanOrEqualToBigInt, greaterThanOrEqualToDuration, head, headOrElse, includes, instanceOf, int, is, isSchema, itemsCount, keyof, length, lessThan, lessThanBigDecimal, lessThanBigInt, lessThanDuration, lessThanOrEqualTo, lessThanOrEqualToBigDecimal, lessThanOrEqualToBigInt, lessThanOrEqualToDuration, lowercased, make, makePropertySignature, maxItems, maxLength, minItems, minLength, multipleOf, mutable, negative, negativeBigDecimal, negativeBigInt, nonEmpty, nonNaN, nonNegative, nonNegativeBigDecimal, nonNegativeBigInt, nonPositive, nonPositiveBigDecimal, nonPositiveBigInt, omit, optional, optionalElement, optionalToOptional, optionalToRequired, parseJson, parseNumber, partial, pattern, pick, pickLiteral, pluck, positive, positiveBigDecimal, positiveBigInt, propertySignature, refineTypeId, rename, required, requiredToOptional, split, startsWith, tag, transform, transformLiteral, transformLiterals, transformOrFail, trimmed, typeSchema, uncapitalized, uppercased, validDate, validate, validateEither, validateOption, validatePromise, validateSync, withConstructorDefault, withDecodingDefault, withDefaults

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Array.js + 2 modules
var esm_Array = __webpack_require__(37901);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/BigDecimal.js
var BigDecimal = __webpack_require__(53954);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/BigInt.js
var esm_BigInt = __webpack_require__(37787);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Boolean.js
var Boolean = __webpack_require__(49349);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Duration.js
var Duration = __webpack_require__(13571);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Either.js
var Either = __webpack_require__(87585);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Encoding.js + 4 modules
var Encoding = __webpack_require__(53678);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equal.js
var esm_Equal = __webpack_require__(67492);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equivalence.js
var esm_Equivalence = __webpack_require__(27786);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/FiberId.js
var FiberId = __webpack_require__(57303);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Number.js
var esm_Number = __webpack_require__(15839);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var esm_Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Pipeable.js
var Pipeable = __webpack_require__(92817);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var esm_Predicate = __webpack_require__(71335);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/String.js
var esm_String = __webpack_require__(55354);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Struct.js
var Struct = __webpack_require__(44576);
;// CONCATENATED MODULE: ./node_modules/@lucid-evolution/utils/node_modules/@effect/schema/dist/esm/Arbitrary.js
/**
 * @since 0.67.0
 */








/**
 * @category hooks
 * @since 0.67.0
 */
const ArbitraryHookId = /*#__PURE__*/Symbol.for("@effect/schema/ArbitraryHookId");
/**
 * @category annotations
 * @since 0.67.0
 */
const arbitrary = handler => self => self.annotations({
  [ArbitraryHookId]: handler
});
/**
 * Returns a LazyArbitrary for the `A` type of the provided schema.
 *
 * @category arbitrary
 * @since 0.67.0
 */
const makeLazy = schema => go(schema.ast, {}, []);
/**
 * Returns a fast-check Arbitrary for the `A` type of the provided schema.
 *
 * @category arbitrary
 * @since 0.67.0
 */
const make = schema => makeLazy(schema)(FastCheck);
const depthSize = 1;
const record = (fc, key, value, options) => {
  return (options.isSuspend ? fc.oneof({
    depthSize
  }, fc.constant([]), fc.array(fc.tuple(key, value), {
    minLength: 1,
    maxLength: 2
  })) : fc.array(fc.tuple(key, value))).map(tuples => {
    const out = {};
    for (const [k, v] of tuples) {
      out[k] = v;
    }
    return out;
  });
};
const getHook = /*#__PURE__*/(/* unused pure expression or super */ null && (AST.getAnnotation(ArbitraryHookId)));
const getRefinementFromArbitrary = (ast, options, path) => {
  const constraints = combineConstraints(options.constraints, getConstraints(ast));
  return go(ast.from, constraints ? {
    ...options,
    constraints
  } : options, path);
};
const go = (ast, options, path) => {
  const hook = getHook(ast);
  if (Option.isSome(hook)) {
    switch (ast._tag) {
      case "Declaration":
        return hook.value(...ast.typeParameters.map(p => go(p, options, path)));
      case "Refinement":
        return hook.value(getRefinementFromArbitrary(ast, options, path));
      default:
        return hook.value();
    }
  }
  switch (ast._tag) {
    case "Declaration":
      {
        throw new Error(errors_.getArbitraryMissingAnnotationErrorMessage(path, ast));
      }
    case "Literal":
      return fc => fc.constant(ast.literal);
    case "UniqueSymbol":
      return fc => fc.constant(ast.symbol);
    case "UndefinedKeyword":
    case "VoidKeyword":
      return fc => fc.constant(undefined);
    case "NeverKeyword":
      return () => {
        throw new Error(errors_.getArbitraryUnsupportedErrorMessage(path, ast));
      };
    case "UnknownKeyword":
    case "AnyKeyword":
      return fc => fc.anything();
    case "StringKeyword":
      return fc => {
        if (options.constraints) {
          switch (options.constraints._tag) {
            case "StringConstraints":
              return fc.string(options.constraints.constraints);
          }
        }
        return fc.string();
      };
    case "NumberKeyword":
      return fc => {
        if (options.constraints) {
          switch (options.constraints._tag) {
            case "NumberConstraints":
              return fc.float(options.constraints.constraints);
            case "IntegerConstraints":
              return fc.integer(options.constraints.constraints);
          }
        }
        return fc.float();
      };
    case "BooleanKeyword":
      return fc => fc.boolean();
    case "BigIntKeyword":
      return fc => {
        if (options.constraints) {
          switch (options.constraints._tag) {
            case "BigIntConstraints":
              return fc.bigInt(options.constraints.constraints);
          }
        }
        return fc.bigInt();
      };
    case "SymbolKeyword":
      return fc => fc.string().map(s => Symbol.for(s));
    case "ObjectKeyword":
      return fc => fc.oneof(fc.object(), fc.array(fc.anything()));
    case "TemplateLiteral":
      {
        return fc => {
          const string = fc.string({
            maxLength: 5
          });
          const number = fc.float({
            noDefaultInfinity: true
          }).filter(n => !Number.isNaN(n));
          const components = [fc.constant(ast.head)];
          for (const span of ast.spans) {
            if (AST.isStringKeyword(span.type)) {
              components.push(string);
            } else {
              components.push(number);
            }
            components.push(fc.constant(span.literal));
          }
          return fc.tuple(...components).map(spans => spans.join(""));
        };
      }
    case "TupleType":
      {
        const elements = [];
        let hasOptionals = false;
        let i = 0;
        for (const element of ast.elements) {
          elements.push(go(element.type, options, path.concat(i++)));
          if (element.isOptional) {
            hasOptionals = true;
          }
        }
        const rest = ast.rest.map(annotatedAST => go(annotatedAST.type, options, path));
        return fc => {
          // ---------------------------------------------
          // handle elements
          // ---------------------------------------------
          let output = fc.tuple(...elements.map(arb => arb(fc)));
          if (hasOptionals) {
            const indexes = fc.tuple(...ast.elements.map(element => element.isOptional ? fc.boolean() : fc.constant(true)));
            output = output.chain(tuple => indexes.map(booleans => {
              for (const [i, b] of booleans.reverse().entries()) {
                if (!b) {
                  tuple.splice(booleans.length - i, 1);
                }
              }
              return tuple;
            }));
          }
          // ---------------------------------------------
          // handle rest element
          // ---------------------------------------------
          if (Arr.isNonEmptyReadonlyArray(rest)) {
            const [head, ...tail] = rest;
            const arb = head(fc);
            const constraints = options.constraints;
            output = output.chain(as => {
              let out = fc.array(arb);
              if (options.isSuspend) {
                out = fc.oneof({
                  depthSize
                }, fc.constant([]), fc.array(arb, {
                  minLength: 1,
                  maxLength: 2
                }));
              } else if (constraints && constraints._tag === "ArrayConstraints") {
                out = fc.array(arb, constraints.constraints);
              }
              return out.map(rest => [...as, ...rest]);
            });
            // ---------------------------------------------
            // handle post rest elements
            // ---------------------------------------------
            for (let j = 0; j < tail.length; j++) {
              output = output.chain(as => tail[j](fc).map(a => [...as, a]));
            }
          }
          return output;
        };
      }
    case "TypeLiteral":
      {
        const propertySignaturesTypes = ast.propertySignatures.map(ps => go(ps.type, options, path.concat(ps.name)));
        const indexSignatures = ast.indexSignatures.map(is => [go(is.parameter, options, path), go(is.type, options, path)]);
        return fc => {
          const arbs = {};
          const requiredKeys = [];
          // ---------------------------------------------
          // handle property signatures
          // ---------------------------------------------
          for (let i = 0; i < propertySignaturesTypes.length; i++) {
            const ps = ast.propertySignatures[i];
            const name = ps.name;
            if (!ps.isOptional) {
              requiredKeys.push(name);
            }
            arbs[name] = propertySignaturesTypes[i](fc);
          }
          let output = fc.record(arbs, {
            requiredKeys
          });
          // ---------------------------------------------
          // handle index signatures
          // ---------------------------------------------
          for (let i = 0; i < indexSignatures.length; i++) {
            const parameter = indexSignatures[i][0](fc);
            const type = indexSignatures[i][1](fc);
            output = output.chain(o => {
              return record(fc, parameter, type, options).map(d => ({
                ...d,
                ...o
              }));
            });
          }
          return output;
        };
      }
    case "Union":
      {
        const types = ast.types.map(t => go(t, options, path));
        return fc => fc.oneof({
          depthSize
        }, ...types.map(arb => arb(fc)));
      }
    case "Enums":
      {
        if (ast.enums.length === 0) {
          throw new Error(errors_.getArbitraryEmptyEnumErrorMessage(path));
        }
        return fc => fc.oneof(...ast.enums.map(([_, value]) => fc.constant(value)));
      }
    case "Refinement":
      {
        const from = getRefinementFromArbitrary(ast, options, path);
        return fc => from(fc).filter(a => Option.isNone(ast.filter(a, AST.defaultParseOption, ast)));
      }
    case "Suspend":
      {
        const get = util_.memoizeThunk(() => go(ast.f(), {
          ...options,
          isSuspend: true
        }, path));
        return fc => fc.constant(null).chain(() => get()(fc));
      }
    case "Transformation":
      return go(ast.to, options, path);
  }
};
/** @internal */
class NumberConstraints {
  _tag = "NumberConstraints";
  constraints;
  constructor(options) {
    this.constraints = {};
    if (Predicate.isNumber(options.min)) {
      this.constraints.min = Math.fround(options.min);
    }
    if (Predicate.isNumber(options.max)) {
      this.constraints.max = Math.fround(options.max);
    }
    if (Predicate.isBoolean(options.noNaN)) {
      this.constraints.noNaN = options.noNaN;
    }
    if (Predicate.isBoolean(options.noDefaultInfinity)) {
      this.constraints.noDefaultInfinity = options.noDefaultInfinity;
    }
  }
}
/** @internal */
class StringConstraints {
  _tag = "StringConstraints";
  constraints;
  constructor(options) {
    this.constraints = {};
    if (Predicate.isNumber(options.minLength)) {
      this.constraints.minLength = options.minLength;
    }
    if (Predicate.isNumber(options.maxLength)) {
      this.constraints.maxLength = options.maxLength;
    }
  }
}
/** @internal */
class IntegerConstraints {
  _tag = "IntegerConstraints";
  constraints;
  constructor(options) {
    this.constraints = {};
    if (Predicate.isNumber(options.min)) {
      this.constraints.min = options.min;
    }
    if (Predicate.isNumber(options.max)) {
      this.constraints.max = options.max;
    }
  }
}
/** @internal */
class ArrayConstraints {
  _tag = "ArrayConstraints";
  constraints;
  constructor(options) {
    this.constraints = {};
    if (Predicate.isNumber(options.minLength)) {
      this.constraints.minLength = options.minLength;
    }
    if (Predicate.isNumber(options.maxLength)) {
      this.constraints.maxLength = options.maxLength;
    }
  }
}
/** @internal */
class BigIntConstraints {
  _tag = "BigIntConstraints";
  constraints;
  constructor(options) {
    this.constraints = {};
    if (Predicate.isBigInt(options.min)) {
      this.constraints.min = options.min;
    }
    if (Predicate.isBigInt(options.max)) {
      this.constraints.max = options.max;
    }
  }
}
/** @internal */
const getConstraints = ast => {
  const TypeAnnotationId = ast.annotations[AST.TypeAnnotationId];
  const jsonSchema = ast.annotations[AST.JSONSchemaAnnotationId];
  switch (TypeAnnotationId) {
    // int
    case filters_.IntTypeId:
      return new IntegerConstraints({});
    // number
    case filters_.GreaterThanTypeId:
    case filters_.GreaterThanOrEqualToTypeId:
    case filters_.LessThanTypeId:
    case filters_.LessThanOrEqualToTypeId:
    case filters_.BetweenTypeId:
      return new NumberConstraints({
        min: jsonSchema.exclusiveMinimum ?? jsonSchema.minimum,
        max: jsonSchema.exclusiveMaximum ?? jsonSchema.maximum
      });
    // bigint
    case filters_.GreaterThanBigintTypeId:
    case filters_.GreaterThanOrEqualToBigIntTypeId:
    case filters_.LessThanBigIntTypeId:
    case filters_.LessThanOrEqualToBigIntTypeId:
    case filters_.BetweenBigintTypeId:
      {
        const constraints = ast.annotations[TypeAnnotationId];
        return new BigIntConstraints(constraints);
      }
    // string
    case filters_.MinLengthTypeId:
    case filters_.MaxLengthTypeId:
    case filters_.LengthTypeId:
      return new StringConstraints(jsonSchema);
    // array
    case filters_.MinItemsTypeId:
    case filters_.MaxItemsTypeId:
    case filters_.ItemsCountTypeId:
      return new ArrayConstraints({
        minLength: jsonSchema.minItems,
        maxLength: jsonSchema.maxItems
      });
  }
};
/** @internal */
const combineConstraints = (c1, c2) => {
  if (c1 === undefined) {
    return c2;
  }
  if (c2 === undefined) {
    return c1;
  }
  switch (c1._tag) {
    case "ArrayConstraints":
      {
        switch (c2._tag) {
          case "ArrayConstraints":
            return new ArrayConstraints({
              minLength: getMax(c1.constraints.minLength, c2.constraints.minLength),
              maxLength: getMin(c1.constraints.maxLength, c2.constraints.maxLength)
            });
        }
        break;
      }
    case "NumberConstraints":
      {
        switch (c2._tag) {
          case "NumberConstraints":
            return new NumberConstraints({
              min: getMax(c1.constraints.min, c2.constraints.min),
              max: getMin(c1.constraints.max, c2.constraints.max),
              noNaN: getOr(c1.constraints.noNaN, c2.constraints.noNaN),
              noDefaultInfinity: getOr(c1.constraints.noDefaultInfinity, c2.constraints.noDefaultInfinity)
            });
          case "IntegerConstraints":
            return new IntegerConstraints({
              min: getMax(c1.constraints.min, c2.constraints.min),
              max: getMin(c1.constraints.max, c2.constraints.max)
            });
        }
        break;
      }
    case "BigIntConstraints":
      {
        switch (c2._tag) {
          case "BigIntConstraints":
            return new BigIntConstraints({
              min: getMax(c1.constraints.min, c2.constraints.min),
              max: getMin(c1.constraints.max, c2.constraints.max)
            });
        }
        break;
      }
    case "StringConstraints":
      {
        switch (c2._tag) {
          case "StringConstraints":
            return new StringConstraints({
              minLength: getMax(c1.constraints.minLength, c2.constraints.minLength),
              maxLength: getMin(c1.constraints.maxLength, c2.constraints.maxLength)
            });
        }
        break;
      }
    case "IntegerConstraints":
      {
        switch (c2._tag) {
          case "NumberConstraints":
          case "IntegerConstraints":
            {
              return new IntegerConstraints({
                min: getMax(c1.constraints.min, c2.constraints.min),
                max: getMin(c1.constraints.max, c2.constraints.max)
              });
            }
        }
        break;
      }
  }
};
const getOr = (a, b) => {
  return a === undefined ? b : b === undefined ? a : a || b;
};
function getMax(n1, n2) {
  return n1 === undefined ? n2 : n2 === undefined ? n1 : n1 <= n2 ? n2 : n1;
}
function getMin(n1, n2) {
  return n1 === undefined ? n2 : n2 === undefined ? n1 : n1 <= n2 ? n1 : n2;
}
//# sourceMappingURL=Arbitrary.js.map
// EXTERNAL MODULE: ./node_modules/@lucid-evolution/utils/node_modules/@effect/schema/dist/esm/AST.js
var esm_AST = __webpack_require__(27677);
;// CONCATENATED MODULE: ./node_modules/@lucid-evolution/utils/node_modules/@effect/schema/dist/esm/Equivalence.js
/**
 * @since 0.67.0
 */









/**
 * @category hooks
 * @since 0.67.0
 */
const EquivalenceHookId = /*#__PURE__*/Symbol.for("@effect/schema/EquivalenceHookId");
/**
 * @category annotations
 * @since 0.67.0
 */
const equivalence = handler => self => self.annotations({
  [EquivalenceHookId]: handler
});
/**
 * @category Equivalence
 * @since 0.67.0
 */
const Equivalence_make = schema => Equivalence_go(schema.ast, []);
const Equivalence_getHook = /*#__PURE__*/(/* unused pure expression or super */ null && (AST.getAnnotation(EquivalenceHookId)));
const Equivalence_go = (ast, path) => {
  const hook = Equivalence_getHook(ast);
  if (Option.isSome(hook)) {
    switch (ast._tag) {
      case "Declaration":
        return hook.value(...ast.typeParameters.map(tp => Equivalence_go(tp, path)));
      case "Refinement":
        return hook.value(Equivalence_go(ast.from, path));
      default:
        return hook.value();
    }
  }
  switch (ast._tag) {
    case "NeverKeyword":
      throw new Error(errors_.getEquivalenceUnsupportedErrorMessage(ast, path));
    case "Transformation":
      return Equivalence_go(ast.to, path);
    case "Declaration":
    case "Literal":
    case "StringKeyword":
    case "TemplateLiteral":
    case "UniqueSymbol":
    case "SymbolKeyword":
    case "UnknownKeyword":
    case "AnyKeyword":
    case "NumberKeyword":
    case "BooleanKeyword":
    case "BigIntKeyword":
    case "UndefinedKeyword":
    case "VoidKeyword":
    case "Enums":
    case "ObjectKeyword":
      return Equal.equals;
    case "Refinement":
      return Equivalence_go(ast.from, path);
    case "Suspend":
      {
        const get = util_.memoizeThunk(() => Equivalence_go(ast.f(), path));
        return (a, b) => get()(a, b);
      }
    case "TupleType":
      {
        const elements = ast.elements.map((element, i) => Equivalence_go(element.type, path.concat(i)));
        const rest = ast.rest.map(annotatedAST => Equivalence_go(annotatedAST.type, path));
        return Equivalence.make((a, b) => {
          const len = a.length;
          if (len !== b.length) {
            return false;
          }
          // ---------------------------------------------
          // handle elements
          // ---------------------------------------------
          let i = 0;
          for (; i < Math.min(len, ast.elements.length); i++) {
            if (!elements[i](a[i], b[i])) {
              return false;
            }
          }
          // ---------------------------------------------
          // handle rest element
          // ---------------------------------------------
          if (Arr.isNonEmptyReadonlyArray(rest)) {
            const [head, ...tail] = rest;
            for (; i < len - tail.length; i++) {
              if (!head(a[i], b[i])) {
                return false;
              }
            }
            // ---------------------------------------------
            // handle post rest elements
            // ---------------------------------------------
            for (let j = 0; j < tail.length; j++) {
              i += j;
              if (!tail[j](a[i], b[i])) {
                return false;
              }
            }
          }
          return true;
        });
      }
    case "TypeLiteral":
      {
        if (ast.propertySignatures.length === 0 && ast.indexSignatures.length === 0) {
          return Equal.equals;
        }
        const propertySignatures = ast.propertySignatures.map(ps => Equivalence_go(ps.type, path.concat(ps.name)));
        const indexSignatures = ast.indexSignatures.map(is => Equivalence_go(is.type, path));
        return Equivalence.make((a, b) => {
          const aStringKeys = Object.keys(a);
          const aSymbolKeys = Object.getOwnPropertySymbols(a);
          // ---------------------------------------------
          // handle property signatures
          // ---------------------------------------------
          for (let i = 0; i < propertySignatures.length; i++) {
            const ps = ast.propertySignatures[i];
            const name = ps.name;
            const aHas = Object.prototype.hasOwnProperty.call(a, name);
            const bHas = Object.prototype.hasOwnProperty.call(b, name);
            if (ps.isOptional) {
              if (aHas !== bHas) {
                return false;
              }
            }
            if (aHas && bHas && !propertySignatures[i](a[name], b[name])) {
              return false;
            }
          }
          // ---------------------------------------------
          // handle index signatures
          // ---------------------------------------------
          let bSymbolKeys;
          let bStringKeys;
          for (let i = 0; i < indexSignatures.length; i++) {
            const is = ast.indexSignatures[i];
            const base = AST.getParameterBase(is.parameter);
            const isSymbol = AST.isSymbolKeyword(base);
            if (isSymbol) {
              bSymbolKeys = bSymbolKeys || Object.getOwnPropertySymbols(b);
              if (aSymbolKeys.length !== bSymbolKeys.length) {
                return false;
              }
            } else {
              bStringKeys = bStringKeys || Object.keys(b);
              if (aStringKeys.length !== bStringKeys.length) {
                return false;
              }
            }
            const aKeys = isSymbol ? aSymbolKeys : aStringKeys;
            for (let j = 0; j < aKeys.length; j++) {
              const key = aKeys[j];
              if (!Object.prototype.hasOwnProperty.call(b, key) || !indexSignatures[i](a[key], b[key])) {
                return false;
              }
            }
          }
          return true;
        });
      }
    case "Union":
      {
        const searchTree = ParseResult.getSearchTree(ast.types, true);
        const ownKeys = util_.ownKeys(searchTree.keys);
        const len = ownKeys.length;
        return Equivalence.make((a, b) => {
          let candidates = [];
          if (len > 0 && Predicate.isRecord(a)) {
            for (let i = 0; i < len; i++) {
              const name = ownKeys[i];
              const buckets = searchTree.keys[name].buckets;
              if (Object.prototype.hasOwnProperty.call(a, name)) {
                const literal = String(a[name]);
                if (Object.prototype.hasOwnProperty.call(buckets, literal)) {
                  candidates = candidates.concat(buckets[literal]);
                }
              }
            }
          }
          if (searchTree.otherwise.length > 0) {
            candidates = candidates.concat(searchTree.otherwise);
          }
          const tuples = candidates.map(ast => [Equivalence_go(ast, path), ParseResult.is({
            ast
          })]);
          for (let i = 0; i < tuples.length; i++) {
            const [equivalence, is] = tuples[i];
            if (is(a) && is(b)) {
              if (equivalence(a, b)) {
                return true;
              }
            }
          }
          return false;
        });
      }
  }
};
//# sourceMappingURL=Equivalence.js.map
;// CONCATENATED MODULE: ./node_modules/@lucid-evolution/utils/node_modules/@effect/schema/dist/esm/internal/filters.js
/** @internal */
const GreaterThanTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/GreaterThan");
/** @internal */
const GreaterThanOrEqualToTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/GreaterThanOrEqualTo");
/** @internal */
const LessThanTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/LessThan");
/** @internal */
const LessThanOrEqualToTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/LessThanOrEqualTo");
/** @internal */
const IntTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Int");
/** @internal */
const BetweenTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Between");
/** @internal */
const GreaterThanBigintTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/GreaterThanBigint");
/** @internal */
const GreaterThanOrEqualToBigIntTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/GreaterThanOrEqualToBigint");
/** @internal */
const LessThanBigIntTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/LessThanBigint");
/** @internal */
const LessThanOrEqualToBigIntTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/LessThanOrEqualToBigint");
/** @internal */
const BetweenBigintTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/BetweenBigint");
/** @internal */
const MinLengthTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/MinLength");
/** @internal */
const MaxLengthTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/MaxLength");
/** @internal */
const LengthTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Length");
/** @internal */
const MinItemsTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/MinItems");
/** @internal */
const MaxItemsTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/MaxItems");
/** @internal */
const ItemsCountTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/ItemsCount");
/** @internal */
const ParseJsonTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/ParseJson")));
//# sourceMappingURL=filters.js.map
// EXTERNAL MODULE: ./node_modules/@lucid-evolution/utils/node_modules/@effect/schema/dist/esm/internal/util.js
var util = __webpack_require__(7677);
// EXTERNAL MODULE: ./node_modules/@lucid-evolution/utils/node_modules/@effect/schema/dist/esm/ParseResult.js + 1 modules
var esm_ParseResult = __webpack_require__(65694);
// EXTERNAL MODULE: ./node_modules/@lucid-evolution/utils/node_modules/@effect/schema/dist/esm/internal/errors.js
var errors = __webpack_require__(69790);
;// CONCATENATED MODULE: ./node_modules/@lucid-evolution/utils/node_modules/@effect/schema/dist/esm/Pretty.js
/**
 * @since 0.67.0
 */






/**
 * @category hooks
 * @since 0.67.0
 */
const PrettyHookId = /*#__PURE__*/Symbol.for("@effect/schema/PrettyHookId");
/**
 * @category annotations
 * @since 0.67.0
 */
const pretty = handler => self => self.annotations({
  [PrettyHookId]: handler
});
/**
 * @category prettify
 * @since 0.67.0
 */
const Pretty_make = schema => compile(schema.ast, []);
const Pretty_getHook = /*#__PURE__*/esm_AST/* getAnnotation */.AR(PrettyHookId);
const getMatcher = defaultPretty => ast => esm_Option/* match */.EQ(Pretty_getHook(ast), {
  onNone: () => defaultPretty,
  onSome: handler => handler()
});
const Pretty_toString = /*#__PURE__*/getMatcher(a => String(a));
const stringify = /*#__PURE__*/getMatcher(a => JSON.stringify(a));
const formatUnknown = /*#__PURE__*/getMatcher(util/* formatUnknown */.cT);
/**
 * @since 0.67.0
 */
const match = {
  "Declaration": (ast, go, path) => {
    const hook = Pretty_getHook(ast);
    if (esm_Option/* isSome */.pC(hook)) {
      return hook.value(...ast.typeParameters.map(tp => go(tp, path)));
    }
    throw new Error(errors/* getPrettyMissingAnnotationErrorMessage */.AU(path, ast));
  },
  "VoidKeyword": /*#__PURE__*/getMatcher(() => "void(0)"),
  "NeverKeyword": /*#__PURE__*/getMatcher(() => {
    throw new Error(errors/* getPrettyNeverErrorMessage */.D_);
  }),
  "Literal": /*#__PURE__*/getMatcher(literal => typeof literal === "bigint" ? `${String(literal)}n` : JSON.stringify(literal)),
  "SymbolKeyword": Pretty_toString,
  "UniqueSymbol": Pretty_toString,
  "TemplateLiteral": stringify,
  "UndefinedKeyword": Pretty_toString,
  "UnknownKeyword": formatUnknown,
  "AnyKeyword": formatUnknown,
  "ObjectKeyword": formatUnknown,
  "StringKeyword": stringify,
  "NumberKeyword": Pretty_toString,
  "BooleanKeyword": Pretty_toString,
  "BigIntKeyword": /*#__PURE__*/getMatcher(a => `${String(a)}n`),
  "Enums": stringify,
  "TupleType": (ast, go, path) => {
    const hook = Pretty_getHook(ast);
    if (esm_Option/* isSome */.pC(hook)) {
      return hook.value();
    }
    const elements = ast.elements.map((e, i) => go(e.type, path.concat(i)));
    const rest = ast.rest.map(annotatedAST => go(annotatedAST.type, path));
    return input => {
      const output = [];
      let i = 0;
      // ---------------------------------------------
      // handle elements
      // ---------------------------------------------
      for (; i < elements.length; i++) {
        if (input.length < i + 1) {
          if (ast.elements[i].isOptional) {
            continue;
          }
        } else {
          output.push(elements[i](input[i]));
        }
      }
      // ---------------------------------------------
      // handle rest element
      // ---------------------------------------------
      if (esm_Array/* isNonEmptyReadonlyArray */.Ux(rest)) {
        const [head, ...tail] = rest;
        for (; i < input.length - tail.length; i++) {
          output.push(head(input[i]));
        }
        // ---------------------------------------------
        // handle post rest elements
        // ---------------------------------------------
        for (let j = 0; j < tail.length; j++) {
          i += j;
          output.push(tail[j](input[i]));
        }
      }
      return "[" + output.join(", ") + "]";
    };
  },
  "TypeLiteral": (ast, go, path) => {
    const hook = Pretty_getHook(ast);
    if (esm_Option/* isSome */.pC(hook)) {
      return hook.value();
    }
    const propertySignaturesTypes = ast.propertySignatures.map(ps => go(ps.type, path.concat(ps.name)));
    const indexSignatureTypes = ast.indexSignatures.map(is => go(is.type, path));
    const expectedKeys = {};
    for (let i = 0; i < propertySignaturesTypes.length; i++) {
      expectedKeys[ast.propertySignatures[i].name] = null;
    }
    return input => {
      const output = [];
      // ---------------------------------------------
      // handle property signatures
      // ---------------------------------------------
      for (let i = 0; i < propertySignaturesTypes.length; i++) {
        const ps = ast.propertySignatures[i];
        const name = ps.name;
        if (ps.isOptional && !Object.prototype.hasOwnProperty.call(input, name)) {
          continue;
        }
        output.push(`${util/* formatPropertyKey */.AH(name)}: ${propertySignaturesTypes[i](input[name])}`);
      }
      // ---------------------------------------------
      // handle index signatures
      // ---------------------------------------------
      if (indexSignatureTypes.length > 0) {
        for (let i = 0; i < indexSignatureTypes.length; i++) {
          const type = indexSignatureTypes[i];
          const keys = util/* getKeysForIndexSignature */.k8(input, ast.indexSignatures[i].parameter);
          for (const key of keys) {
            if (Object.prototype.hasOwnProperty.call(expectedKeys, key)) {
              continue;
            }
            output.push(`${util/* formatPropertyKey */.AH(key)}: ${type(input[key])}`);
          }
        }
      }
      return esm_Array/* isNonEmptyReadonlyArray */.Ux(output) ? "{ " + output.join(", ") + " }" : "{}";
    };
  },
  "Union": (ast, go, path) => {
    const hook = Pretty_getHook(ast);
    if (esm_Option/* isSome */.pC(hook)) {
      return hook.value();
    }
    const types = ast.types.map(ast => [esm_ParseResult.is({
      ast
    }), go(ast, path)]);
    return a => {
      const index = types.findIndex(([is]) => is(a));
      if (index === -1) {
        throw new Error(errors/* getPrettyNoMatchingSchemaErrorMessage */.yd(a, path, ast));
      }
      return types[index][1](a);
    };
  },
  "Suspend": (ast, go, path) => {
    return esm_Option/* match */.EQ(Pretty_getHook(ast), {
      onNone: () => {
        const get = util/* memoizeThunk */.d3(() => go(ast.f(), path));
        return a => get()(a);
      },
      onSome: handler => handler()
    });
  },
  "Refinement": (ast, go, path) => {
    return esm_Option/* match */.EQ(Pretty_getHook(ast), {
      onNone: () => go(ast.from, path),
      onSome: handler => handler()
    });
  },
  "Transformation": (ast, go, path) => {
    return esm_Option/* match */.EQ(Pretty_getHook(ast), {
      onNone: () => go(ast.to, path),
      onSome: handler => handler()
    });
  }
};
const compile = /*#__PURE__*/(/* unused pure expression or super */ null && (AST.getCompiler(match)));
//# sourceMappingURL=Pretty.js.map
;// CONCATENATED MODULE: ./node_modules/@lucid-evolution/utils/node_modules/@effect/schema/dist/esm/Schema.js
/**
 * @since 0.67.0
 */










































/**
 * @since 0.67.0
 * @category symbol
 */
const TypeId = /*#__PURE__*/Symbol.for("@effect/schema/Schema");
/**
 * @category constructors
 * @since 0.67.0
 */
const Schema_make = ast => class SchemaClass {
  [TypeId] = variance;
  static Type;
  static Encoded;
  static [TypeId] = variance;
  static ast = ast;
  static annotations(annotations) {
    return Schema_make(mergeSchemaAnnotations(this.ast, annotations));
  }
  static pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
  static toString() {
    return String(ast);
  }
};
const variance = {
  /* c8 ignore next */
  _A: _ => _,
  /* c8 ignore next */
  _I: _ => _,
  /* c8 ignore next */
  _R: _ => _
};
const toASTAnnotations = annotations => {
  if (!annotations) {
    return {};
  }
  const out = {};
  // symbols are reserved for custom annotations
  const custom = Object.getOwnPropertySymbols(annotations);
  for (const sym of custom) {
    out[sym] = annotations[sym];
  }
  // string keys are reserved as /schema namespace
  if (annotations.typeId !== undefined) {
    const typeId = annotations.typeId;
    if (typeof typeId === "object") {
      out[esm_AST/* TypeAnnotationId */.I4] = typeId.id;
      out[typeId.id] = typeId.annotation;
    } else {
      out[esm_AST/* TypeAnnotationId */.I4] = typeId;
    }
  }
  const move = (from, to) => {
    if (annotations[from] !== undefined) {
      out[to] = annotations[from];
    }
  };
  move("message", esm_AST/* MessageAnnotationId */.eg);
  move("missingMessage", esm_AST/* MissingMessageAnnotationId */.iD);
  move("identifier", esm_AST/* IdentifierAnnotationId */.CA);
  move("title", esm_AST/* TitleAnnotationId */.Lf);
  move("description", esm_AST/* DescriptionAnnotationId */.Aj);
  move("examples", esm_AST/* ExamplesAnnotationId */.by);
  move("default", esm_AST/* DefaultAnnotationId */.w9);
  move("documentation", esm_AST/* DocumentationAnnotationId */.Nh);
  move("jsonSchema", esm_AST/* JSONSchemaAnnotationId */.aN);
  move("arbitrary", ArbitraryHookId);
  move("pretty", PrettyHookId);
  move("equivalence", EquivalenceHookId);
  move("concurrency", esm_AST/* ConcurrencyAnnotationId */.Q7);
  move("batching", esm_AST/* BatchingAnnotationId */.oA);
  move("parseIssueTitle", esm_AST/* ParseIssueTitleAnnotationId */.Uy);
  move("parseOptions", esm_AST/* ParseOptionsAnnotationId */.v3);
  return out;
};
const mergeSchemaAnnotations = (ast, annotations) => esm_AST/* annotations */.ds(ast, toASTAnnotations(annotations));
/**
 * @since 0.67.0
 */
const asSchema = schema => schema;
/**
 * @category formatting
 * @since 0.67.0
 */
const format = schema => String(schema.ast);
/**
 * The `encodedSchema` function allows you to extract the `Encoded` portion of a
 * schema, creating a new schema that conforms to the properties defined in the
 * original schema without retaining any refinements or transformations that
 * were applied previously.
 *
 * @since 0.67.0
 */
const encodedSchema = schema => Schema_make(AST.encodedAST(schema.ast));
/**
 * The `encodedBoundSchema` function is similar to `encodedSchema` but preserves
 * the refinements up to the first transformation point in the original schema.
 *
 * @since 0.67.17
 */
const encodedBoundSchema = schema => Schema_make(AST.encodedBoundAST(schema.ast));
/**
 * The `typeSchema` function allows you to extract the `Type` portion of a
 * schema, creating a new schema that conforms to the properties defined in the
 * original schema without considering the initial encoding or transformation
 * processes.
 *
 * @since 0.67.0
 */
const typeSchema = schema => Schema_make(AST.typeAST(schema.ast));
/* c8 ignore start */

/* c8 ignore end */
/**
 * @category encoding
 * @since 0.67.0
 */
const encodeUnknown = (schema, options) => {
  const encodeUnknown = ParseResult.encodeUnknown(schema, options);
  return (u, overrideOptions) => ParseResult.mapError(encodeUnknown(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category encoding
 * @since 0.67.0
 */
const encodeUnknownEither = (schema, options) => {
  const encodeUnknownEither = ParseResult.encodeUnknownEither(schema, options);
  return (u, overrideOptions) => either_.mapLeft(encodeUnknownEither(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category encoding
 * @since 0.67.0
 */
const encodeUnknownPromise = (schema, options) => {
  const parser = encodeUnknown(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category encoding
 * @since 0.67.0
 */
const encode = (/* unused pure expression or super */ null && (encodeUnknown));
/**
 * @category encoding
 * @since 0.67.0
 */
const encodeEither = (/* unused pure expression or super */ null && (encodeUnknownEither));
/**
 * @category encoding
 * @since 0.67.0
 */
const encodePromise = (/* unused pure expression or super */ null && (encodeUnknownPromise));
/**
 * @category decoding
 * @since 0.67.0
 */
const decodeUnknown = (schema, options) => {
  const decodeUnknown = ParseResult.decodeUnknown(schema, options);
  return (u, overrideOptions) => ParseResult.mapError(decodeUnknown(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category decoding
 * @since 0.67.0
 */
const decodeUnknownEither = (schema, options) => {
  const decodeUnknownEither = ParseResult.decodeUnknownEither(schema, options);
  return (u, overrideOptions) => either_.mapLeft(decodeUnknownEither(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category decoding
 * @since 0.67.0
 */
const decodeUnknownPromise = (schema, options) => {
  const parser = decodeUnknown(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category decoding
 * @since 0.67.0
 */
const decode = (/* unused pure expression or super */ null && (decodeUnknown));
/**
 * @category decoding
 * @since 0.67.0
 */
const decodeEither = (/* unused pure expression or super */ null && (decodeUnknownEither));
/**
 * @category decoding
 * @since 0.67.0
 */
const decodePromise = (/* unused pure expression or super */ null && (decodeUnknownPromise));
/**
 * @category validation
 * @since 0.67.0
 */
const validate = (schema, options) => {
  const validate = ParseResult.validate(schema, options);
  return (u, overrideOptions) => ParseResult.mapError(validate(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category validation
 * @since 0.67.0
 */
const validateEither = (schema, options) => {
  const validateEither = ParseResult.validateEither(schema, options);
  return (u, overrideOptions) => either_.mapLeft(validateEither(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category validation
 * @since 0.67.0
 */
const validatePromise = (schema, options) => {
  const parser = validate(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * Tests if a value is a `Schema`.
 *
 * @category guards
 * @since 0.67.0
 */
const isSchema = u => esm_Predicate/* hasProperty */.l$(u, TypeId) && esm_Predicate/* isObject */.Kn(u[TypeId]);
const getDefaultLiteralAST = literals => esm_AST/* isMembers */.Jg(literals) ? esm_AST/* Union.make */.EJ.make(esm_AST/* mapMembers */.GY(literals, literal => new esm_AST/* Literal */.t$(literal))) : new esm_AST/* Literal */.t$(literals[0]);
const makeLiteralClass = (literals, ast = getDefaultLiteralAST(literals)) => class LiteralClass extends Schema_make(ast) {
  static annotations(annotations) {
    return makeLiteralClass(this.literals, mergeSchemaAnnotations(this.ast, annotations));
  }
  static literals = [...literals];
};
function Literal(...literals) {
  return esm_Array/* isNonEmptyReadonlyArray */.Ux(literals) ? makeLiteralClass(literals) : Never;
}
/**
 * Creates a new `Schema` from a literal schema.
 *
 * @example
 * import * as S from "@effect/schema/Schema"
 * import { Either } from "effect"
 *
 * const schema = S.Literal("a", "b", "c").pipe(S.pickLiteral("a", "b"))
 *
 * assert.deepStrictEqual(S.decodeSync(schema)("a"), "a")
 * assert.deepStrictEqual(S.decodeSync(schema)("b"), "b")
 * assert.strictEqual(Either.isLeft(S.decodeUnknownEither(schema)("c")), true)
 *
 * @category constructors
 * @since 0.67.0
 */
const pickLiteral = (...literals) => _schema => Literal(...literals);
/**
 * @category constructors
 * @since 0.67.0
 */
const UniqueSymbolFromSelf = symbol => Schema_make(new AST.UniqueSymbol(symbol));
const getDefaultEnumsAST = enums => new AST.Enums(Object.keys(enums).filter(key => typeof enums[enums[key]] !== "number").map(key => [key, enums[key]]));
const makeEnumsClass = (enums, ast = getDefaultEnumsAST(enums)) => class EnumsClass extends Schema_make(ast) {
  static annotations(annotations) {
    return makeEnumsClass(this.enums, mergeSchemaAnnotations(this.ast, annotations));
  }
  static enums = {
    ...enums
  };
};
/**
 * @category constructors
 * @since 0.67.0
 */
const Enums = enums => makeEnumsClass(enums);
/**
 * @category constructors
 * @since 0.67.0
 */
const TemplateLiteral = (...[head, ...tail]) => {
  let astOrs = getTemplateLiterals(getTemplateLiteralParameterAST(head));
  for (const span of tail) {
    astOrs = array_.flatMap(astOrs, a => getTemplateLiterals(getTemplateLiteralParameterAST(span)).map(b => combineTemplateLiterals(a, b)));
  }
  return Schema_make(AST.Union.make(astOrs.map(astOr => Predicate.isString(astOr) ? new AST.Literal(astOr) : astOr)));
};
const getTemplateLiteralParameterAST = span => isSchema(span) ? span.ast : new AST.Literal(String(span));
const combineTemplateLiterals = (a, b) => {
  if (Predicate.isString(a)) {
    return Predicate.isString(b) ? a + b : new AST.TemplateLiteral(a + b.head, b.spans);
  }
  if (Predicate.isString(b)) {
    return new AST.TemplateLiteral(a.head, array_.modifyNonEmptyLast(a.spans, span => new AST.TemplateLiteralSpan(span.type, span.literal + b)));
  }
  return new AST.TemplateLiteral(a.head, array_.appendAll(array_.modifyNonEmptyLast(a.spans, span => new AST.TemplateLiteralSpan(span.type, span.literal + String(b.head))), b.spans));
};
const getTemplateLiterals = ast => {
  switch (ast._tag) {
    case "Literal":
      return [String(ast.literal)];
    case "NumberKeyword":
    case "StringKeyword":
      return [new AST.TemplateLiteral("", [new AST.TemplateLiteralSpan(ast, "")])];
    case "Union":
      return array_.flatMap(ast.types, getTemplateLiterals);
  }
  throw new Error(errors_.getSchemaUnsupportedLiteralSpanErrorMessage(ast));
};
const declareConstructor = (typeParameters, options, annotations) => Schema_make(new esm_AST/* Declaration */.gr(typeParameters.map(tp => tp.ast), (...typeParameters) => options.decode(...typeParameters.map(Schema_make)), (...typeParameters) => options.encode(...typeParameters.map(Schema_make)), toASTAnnotations(annotations)));
const declarePrimitive = (is, annotations) => {
  const decodeUnknown = () => (input, _, ast) => is(input) ? esm_ParseResult/* succeed */.ng(input) : esm_ParseResult/* fail */.bG(new esm_ParseResult/* Type */.Dy(ast, input));
  const encodeUnknown = decodeUnknown;
  return Schema_make(new esm_AST/* Declaration */.gr([], decodeUnknown, encodeUnknown, toASTAnnotations(annotations)));
};
/**
 * The constraint `R extends Schema.Context<P[number]>` enforces dependencies solely from `typeParameters`.
 * This ensures that when you call `Schema.to` or `Schema.from`, you receive a schema with a `never` context.
 *
 * @category constructors
 * @since 0.67.0
 */
const declare = function () {
  if (Array.isArray(arguments[0])) {
    const typeParameters = arguments[0];
    const options = arguments[1];
    const annotations = arguments[2];
    return declareConstructor(typeParameters, options, annotations);
  }
  const is = arguments[0];
  const annotations = arguments[1];
  return declarePrimitive(is, annotations);
};
/**
 * @category type id
 * @since 0.67.0
 */
const BrandTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/Brand")));
/**
 * @category constructors
 * @since 0.67.0
 */
const fromBrand = (constructor, annotations) => self => makeBrandClass(new AST.Refinement(self.ast, function predicate(a, _, ast) {
  const either = constructor.either(a);
  return either_.isLeft(either) ? option_.some(new ParseResult.Type(ast, a, either.left.map(v => v.message).join(", "))) : option_.none();
}, toASTAnnotations({
  typeId: {
    id: BrandTypeId,
    annotation: {
      constructor
    }
  },
  ...annotations
})));
/**
 * @category type id
 * @since 0.67.0
 */
const InstanceOfTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/InstanceOf")));
/**
 * @category constructors
 * @since 0.67.0
 */
const instanceOf = (constructor, annotations) => declare(u => u instanceof constructor, {
  title: constructor.name,
  description: `an instance of ${constructor.name}`,
  pretty: () => String,
  typeId: {
    id: InstanceOfTypeId,
    annotation: {
      constructor
    }
  },
  ...annotations
});
/**
 * @category primitives
 * @since 0.67.0
 */
class Undefined extends /*#__PURE__*/Schema_make(esm_AST/* undefinedKeyword */.x8) {}
/**
 * @category primitives
 * @since 0.67.0
 */
class Void extends /*#__PURE__*/Schema_make(esm_AST/* voidKeyword */.zv) {}
/**
 * @category primitives
 * @since 0.67.0
 */
class Null extends /*#__PURE__*/Schema_make(esm_AST/* null */.lB) {}
/**
 * @category primitives
 * @since 0.67.0
 */
class Never extends /*#__PURE__*/Schema_make(esm_AST/* neverKeyword */.$y) {}
/**
 * @category primitives
 * @since 0.67.0
 */
class Unknown extends /*#__PURE__*/Schema_make(esm_AST/* unknownKeyword */.ai) {}
/**
 * @category primitives
 * @since 0.67.0
 */
class Any extends /*#__PURE__*/Schema_make(esm_AST/* anyKeyword */.TA) {}
/**
 * @category primitives
 * @since 0.67.0
 */
class BigIntFromSelf extends /*#__PURE__*/Schema_make(esm_AST/* bigIntKeyword */.gx) {}
/**
 * @category primitives
 * @since 0.67.0
 */
class SymbolFromSelf extends /*#__PURE__*/Schema_make(esm_AST/* symbolKeyword */.KN) {}
/** @ignore */
class String$ extends /*#__PURE__*/Schema_make(esm_AST/* stringKeyword */.hw) {}
/** @ignore */
class Number$ extends /*#__PURE__*/Schema_make(esm_AST/* numberKeyword */.uo) {}
/** @ignore */
class Boolean$ extends /*#__PURE__*/Schema_make(esm_AST/* booleanKeyword */.hA) {}
/** @ignore */
class Object$ extends /*#__PURE__*/Schema_make(esm_AST/* objectKeyword */.DZ) {}

const getDefaultUnionAST = members => esm_AST/* Union.members */.EJ.members(members.map(m => m.ast));
const makeUnionClass = (members, ast = getDefaultUnionAST(members)) => class UnionClass extends Schema_make(ast) {
  static annotations(annotations) {
    return makeUnionClass(this.members, mergeSchemaAnnotations(this.ast, annotations));
  }
  static members = [...members];
};
function Union(...members) {
  return esm_AST/* isMembers */.Jg(members) ? makeUnionClass(members) : esm_Array/* isNonEmptyReadonlyArray */.Ux(members) ? members[0] : Never;
}
/**
 * @category combinators
 * @since 0.67.0
 */
const NullOr = self => Union(self, Null);
/**
 * @category combinators
 * @since 0.67.0
 */
const UndefinedOr = self => Union(self, Undefined);
/**
 * @category combinators
 * @since 0.67.0
 */
const NullishOr = self => Union(self, Null, Undefined);
/**
 * @category combinators
 * @since 0.67.0
 */
const keyof = self => Schema_make(AST.keyof(self.ast));
/**
 * @since 0.68.0
 */
const Schema_element = self => new ElementImpl(new AST.OptionalType(self.ast, false), self);
/**
 * @since 0.67.0
 */
const optionalElement = self => new ElementImpl(new AST.OptionalType(self.ast, true), self);
class ElementImpl {
  ast;
  from;
  [TypeId];
  _Token;
  constructor(ast, from) {
    this.ast = ast;
    this.from = from;
  }
  annotations(annotations) {
    return new ElementImpl(new AST.OptionalType(this.ast.type, this.ast.isOptional, {
      ...this.ast.annotations,
      ...toASTAnnotations(annotations)
    }), this.from);
  }
  toString() {
    return `${this.ast.type}${this.ast.isOptional ? "?" : ""}`;
  }
}
const getDefaultTupleTypeAST = (elements, rest) => new esm_AST/* TupleType */.Qc(elements.map(el => isSchema(el) ? new esm_AST/* OptionalType */.H1(el.ast, false) : el.ast), rest.map(el => isSchema(el) ? new esm_AST/* Type */.Dy(el.ast) : el.ast), true);
const makeTupleTypeClass = (elements, rest, ast = getDefaultTupleTypeAST(elements, rest)) => class TupleTypeClass extends Schema_make(ast) {
  static annotations(annotations) {
    return makeTupleTypeClass(this.elements, this.rest, mergeSchemaAnnotations(this.ast, annotations));
  }
  static elements = [...elements];
  static rest = [...rest];
};
function Tuple(...args) {
  return Array.isArray(args[0]) ? makeTupleTypeClass(args[0], args.slice(1)) : makeTupleTypeClass(args, []);
}
const makeArrayClass = (value, ast) => class ArrayClass extends makeTupleTypeClass([], [value], ast) {
  static annotations(annotations) {
    return makeArrayClass(this.value, mergeSchemaAnnotations(this.ast, annotations));
  }
  static value = value;
};
const Array$ = value => makeArrayClass(value);

const makeNonEmptyArrayClass = (value, ast) => class NonEmptyArrayClass extends makeTupleTypeClass([value], [value], ast) {
  static annotations(annotations) {
    return makeNonEmptyArrayClass(this.value, mergeSchemaAnnotations(this.ast, annotations));
  }
  static value = value;
};
/**
 * @category constructors
 * @since 0.67.0
 */
const NonEmptyArray = value => makeNonEmptyArrayClass(value);
const formatPropertySignatureToken = isOptional => isOptional ? "\"?:\"" : "\":\"";
/**
 * @category PropertySignature
 * @since 0.67.0
 */
class PropertySignatureDeclaration extends esm_AST/* OptionalType */.H1 {
  isReadonly;
  defaultValue;
  /**
   * @since 0.67.0
   */
  _tag = "PropertySignatureDeclaration";
  constructor(type, isOptional, isReadonly, annotations, defaultValue) {
    super(type, isOptional, annotations);
    this.isReadonly = isReadonly;
    this.defaultValue = defaultValue;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    const token = formatPropertySignatureToken(this.isOptional);
    const type = String(this.type);
    return `PropertySignature<${token}, ${type}, never, ${token}, ${type}>`;
  }
}
/**
 * @category PropertySignature
 * @since 0.67.0
 */
class FromPropertySignature extends esm_AST/* OptionalType */.H1 {
  isReadonly;
  fromKey;
  constructor(type, isOptional, isReadonly, annotations, fromKey) {
    super(type, isOptional, annotations);
    this.isReadonly = isReadonly;
    this.fromKey = fromKey;
  }
}
/**
 * @category PropertySignature
 * @since 0.67.0
 */
class ToPropertySignature extends esm_AST/* OptionalType */.H1 {
  isReadonly;
  defaultValue;
  constructor(type, isOptional, isReadonly, annotations, defaultValue) {
    super(type, isOptional, annotations);
    this.isReadonly = isReadonly;
    this.defaultValue = defaultValue;
  }
}
const formatPropertyKey = p => {
  if (p === undefined) {
    return "never";
  }
  if (Predicate.isString(p)) {
    return JSON.stringify(p);
  }
  return String(p);
};
/**
 * @category PropertySignature
 * @since 0.67.0
 */
class PropertySignatureTransformation {
  from;
  to;
  decode;
  encode;
  /**
   * @since 0.67.0
   */
  _tag = "PropertySignatureTransformation";
  constructor(from, to, decode, encode) {
    this.from = from;
    this.to = to;
    this.decode = decode;
    this.encode = encode;
  }
  /**
   * @since 0.67.0
   */
  toString() {
    return `PropertySignature<${formatPropertySignatureToken(this.to.isOptional)}, ${this.to.type}, ${formatPropertyKey(this.from.fromKey)}, ${formatPropertySignatureToken(this.from.isOptional)}, ${this.from.type}>`;
  }
}
const mergeSignatureAnnotations = (ast, annotations) => {
  switch (ast._tag) {
    case "PropertySignatureDeclaration":
      {
        return new PropertySignatureDeclaration(ast.type, ast.isOptional, ast.isReadonly, {
          ...ast.annotations,
          ...annotations
        }, ast.defaultValue);
      }
    case "PropertySignatureTransformation":
      {
        return new PropertySignatureTransformation(new FromPropertySignature(ast.from.type, ast.from.isOptional, ast.from.isReadonly, ast.from.annotations), new ToPropertySignature(ast.to.type, ast.to.isOptional, ast.to.isReadonly, {
          ...ast.to.annotations,
          ...annotations
        }, ast.to.defaultValue), ast.decode, ast.encode);
      }
  }
};
/**
 * @since 0.68.0
 * @category symbol
 */
const PropertySignatureTypeId = /*#__PURE__*/Symbol.for("@effect/schema/PropertySignature");
class PropertySignatureImpl {
  ast;
  [TypeId];
  [PropertySignatureTypeId] = null;
  _TypeToken;
  _Key;
  _EncodedToken;
  _HasDefault;
  constructor(ast) {
    this.ast = ast;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
  annotations(annotations) {
    return new PropertySignatureImpl(mergeSignatureAnnotations(this.ast, toASTAnnotations(annotations)));
  }
  toString() {
    return String(this.ast);
  }
}
/**
 * @category PropertySignature
 * @since 0.67.15
 */
const makePropertySignature = ast => new PropertySignatureImpl(ast);
class PropertySignatureWithFromImpl extends (/* unused pure expression or super */ null && (PropertySignatureImpl)) {
  from;
  constructor(ast, from) {
    super(ast);
    this.from = from;
  }
  annotations(annotations) {
    return new PropertySignatureWithFromImpl(mergeSignatureAnnotations(this.ast, toASTAnnotations(annotations)), this.from);
  }
}
/**
 * Lifts a `Schema` into a `PropertySignature`.
 *
 * @category PropertySignature
 * @since 0.67.0
 */
const propertySignature = self => new PropertySignatureWithFromImpl(new PropertySignatureDeclaration(self.ast, false, true, {}, undefined), self);
/**
 * Enhances a property signature with a default constructor value.
 *
 * @category PropertySignature
 * @since 0.67.0
 */
const withConstructorDefault = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, defaultValue) => {
  const ast = self.ast;
  switch (ast._tag) {
    case "PropertySignatureDeclaration":
      return makePropertySignature(new PropertySignatureDeclaration(ast.type, ast.isOptional, ast.isReadonly, ast.annotations, defaultValue));
    case "PropertySignatureTransformation":
      return makePropertySignature(new PropertySignatureTransformation(ast.from, new ToPropertySignature(ast.to.type, ast.to.isOptional, ast.to.isReadonly, ast.to.annotations, defaultValue), ast.decode, ast.encode));
  }
})));
const applyDefaultValue = (o, defaultValue) => option_.match(o, {
  onNone: () => option_.some(defaultValue()),
  onSome: value => option_.some(value === undefined ? defaultValue() : value)
});
/**
 * Enhances a property signature with a default decoding value.
 *
 * @category PropertySignature
 * @since 0.67.0
 */
const withDecodingDefault = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, defaultValue) => {
  const ast = self.ast;
  switch (ast._tag) {
    case "PropertySignatureDeclaration":
      return makePropertySignature(new PropertySignatureTransformation(ast, new ToPropertySignature(AST.typeAST(ast.type), false, true, {}, undefined), o => applyDefaultValue(o, defaultValue), identity));
    case "PropertySignatureTransformation":
      return makePropertySignature(new PropertySignatureTransformation(ast.from, new ToPropertySignature(ast.to.type, false, ast.to.isReadonly, ast.to.annotations, ast.to.defaultValue), o => applyDefaultValue(ast.decode(o), defaultValue), ast.encode));
  }
})));
/**
 * Enhances a property signature with a default decoding value and a default constructor value.
 *
 * @category PropertySignature
 * @since 0.67.0
 */
const withDefaults = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, defaults) => self.pipe(withDecodingDefault(defaults.decoding), withConstructorDefault(defaults.constructor)))));
/**
 * Enhances a property signature by specifying a different key for it in the Encoded type.
 *
 * @category PropertySignature
 * @since 0.67.0
 */
const fromKey = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, key) => {
  const ast = self.ast;
  switch (ast._tag) {
    case "PropertySignatureDeclaration":
      {
        return makePropertySignature(new PropertySignatureTransformation(new FromPropertySignature(ast.type, ast.isOptional, ast.isReadonly, ast.annotations, key), new ToPropertySignature(AST.typeAST(ast.type), ast.isOptional, ast.isReadonly, {}, ast.defaultValue), identity, identity));
      }
    case "PropertySignatureTransformation":
      return makePropertySignature(new PropertySignatureTransformation(new FromPropertySignature(ast.from.type, ast.from.isOptional, ast.from.isReadonly, ast.from.annotations, key), ast.to, ast.decode, ast.encode));
  }
})));
/**
 * Converts an optional property to a required one through a transformation `Option -> Type`.
 *
 * - `decode`: `none` as argument means the value is missing in the input.
 * - `encode`: `none` as return value means the value will be missing in the output.
 *
 * @category PropertySignature
 * @since 0.67.0
 */
const optionalToRequired = (from, to, options) => makePropertySignature(new PropertySignatureTransformation(new FromPropertySignature(from.ast, true, true, {}, undefined), new ToPropertySignature(to.ast, false, true, {}, undefined), o => option_.some(options.decode(o)), option_.flatMap(options.encode)));
/**
 * Converts an optional property to a required one through a transformation `Type -> Option`.
 *
 * - `decode`: `none` as return value means the value will be missing in the output.
 * - `encode`: `none` as argument means the value is missing in the input.
 *
 * @category PropertySignature
 * @since 0.67.15
 */
const requiredToOptional = (from, to, options) => makePropertySignature(new PropertySignatureTransformation(new FromPropertySignature(from.ast, false, true, {}, undefined), new ToPropertySignature(to.ast, true, true, {}, undefined), option_.flatMap(options.decode), o => option_.some(options.encode(o))));
/**
 * Converts an optional property to another optional property through a transformation `Option -> Option`.
 *
 * - `decode`:
 *   - `none` as argument means the value is missing in the input.
 *   - `none` as return value means the value will be missing in the output.
 * - `encode`:
 *   - `none` as argument means the value is missing in the input.
 *   - `none` as return value means the value will be missing in the output.
 *
 * @category PropertySignature
 * @since 0.67.0
 */
const optionalToOptional = (from, to, options) => makePropertySignature(new PropertySignatureTransformation(new FromPropertySignature(from.ast, true, true, {}, undefined), new ToPropertySignature(to.ast, true, true, {}, undefined), options.decode, options.encode));
const optionalPropertySignatureAST = (from, options) => {
  const isExact = options?.exact;
  const defaultValue = options?.default;
  const isNullable = options?.nullable;
  const asOption = options?.as == "Option";
  const asOptionEncode = options?.onNoneEncoding ? option_.orElse(options.onNoneEncoding) : identity;
  if (isExact) {
    if (defaultValue) {
      if (isNullable) {
        return withConstructorDefault(optionalToRequired(NullOr(from), typeSchema(from), {
          decode: option_.match({
            onNone: defaultValue,
            onSome: a => a === null ? defaultValue() : a
          }),
          encode: option_.some
        }), defaultValue).ast;
      } else {
        return withConstructorDefault(optionalToRequired(from, typeSchema(from), {
          decode: option_.match({
            onNone: defaultValue,
            onSome: identity
          }),
          encode: option_.some
        }), defaultValue).ast;
      }
    } else if (asOption) {
      if (isNullable) {
        return optionalToRequired(NullOr(from), OptionFromSelf(typeSchema(from)), {
          decode: option_.filter(Predicate.isNotNull),
          encode: asOptionEncode
        }).ast;
      } else {
        return optionalToRequired(from, OptionFromSelf(typeSchema(from)), {
          decode: identity,
          encode: identity
        }).ast;
      }
    } else {
      if (isNullable) {
        return optionalToOptional(NullOr(from), typeSchema(from), {
          decode: option_.filter(Predicate.isNotNull),
          encode: identity
        }).ast;
      } else {
        return new PropertySignatureDeclaration(from.ast, true, true, {}, undefined);
      }
    }
  } else {
    if (defaultValue) {
      if (isNullable) {
        return withConstructorDefault(optionalToRequired(NullishOr(from), typeSchema(from), {
          decode: option_.match({
            onNone: defaultValue,
            onSome: a => a == null ? defaultValue() : a
          }),
          encode: option_.some
        }), defaultValue).ast;
      } else {
        return withConstructorDefault(optionalToRequired(UndefinedOr(from), typeSchema(from), {
          decode: option_.match({
            onNone: defaultValue,
            onSome: a => a === undefined ? defaultValue() : a
          }),
          encode: option_.some
        }), defaultValue).ast;
      }
    } else if (asOption) {
      if (isNullable) {
        return optionalToRequired(NullishOr(from), OptionFromSelf(typeSchema(from)), {
          decode: option_.filter(a => a != null),
          encode: asOptionEncode
        }).ast;
      } else {
        return optionalToRequired(UndefinedOr(from), OptionFromSelf(typeSchema(from)), {
          decode: option_.filter(Predicate.isNotUndefined),
          encode: asOptionEncode
        }).ast;
      }
    } else {
      if (isNullable) {
        return optionalToOptional(NullishOr(from), UndefinedOr(typeSchema(from)), {
          decode: option_.filter(Predicate.isNotNull),
          encode: identity
        }).ast;
      } else {
        return new PropertySignatureDeclaration(UndefinedOr(from).ast, true, true, {}, undefined);
      }
    }
  }
};
/**
 * @category PropertySignature
 * @since 0.67.0
 */
const optional = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isSchema(args[0]), (from, options) => {
  return new PropertySignatureWithFromImpl(optionalPropertySignatureAST(from, options), from);
})));
const isPropertySignature = u => esm_Predicate/* hasProperty */.l$(u, PropertySignatureTypeId);
const getDefaultTypeLiteralAST = (fields, records) => {
  const ownKeys = util/* ownKeys */.Wp(fields);
  const pss = [];
  if (ownKeys.length > 0) {
    const from = [];
    const to = [];
    const transformations = [];
    for (let i = 0; i < ownKeys.length; i++) {
      const key = ownKeys[i];
      const field = fields[key];
      if (isPropertySignature(field)) {
        const ast = field.ast;
        switch (ast._tag) {
          case "PropertySignatureDeclaration":
            {
              const type = ast.type;
              const isOptional = ast.isOptional;
              const toAnnotations = ast.annotations;
              from.push(new esm_AST/* PropertySignature */.TJ(key, type, isOptional, true));
              to.push(new esm_AST/* PropertySignature */.TJ(key, esm_AST/* typeAST */.Yc(type), isOptional, true, toAnnotations));
              pss.push(new esm_AST/* PropertySignature */.TJ(key, type, isOptional, true, toAnnotations));
              break;
            }
          case "PropertySignatureTransformation":
            {
              const fromKey = ast.from.fromKey ?? key;
              from.push(new esm_AST/* PropertySignature */.TJ(fromKey, ast.from.type, ast.from.isOptional, true, ast.from.annotations));
              to.push(new esm_AST/* PropertySignature */.TJ(key, ast.to.type, ast.to.isOptional, true, ast.to.annotations));
              transformations.push(new esm_AST/* PropertySignatureTransformation */.V5(fromKey, key, ast.decode, ast.encode));
              break;
            }
        }
      } else {
        from.push(new esm_AST/* PropertySignature */.TJ(key, field.ast, false, true));
        to.push(new esm_AST/* PropertySignature */.TJ(key, esm_AST/* typeAST */.Yc(field.ast), false, true));
        pss.push(new esm_AST/* PropertySignature */.TJ(key, field.ast, false, true));
      }
    }
    if (esm_Array/* isNonEmptyReadonlyArray */.Ux(transformations)) {
      const issFrom = [];
      const issTo = [];
      for (const r of records) {
        const {
          indexSignatures,
          propertySignatures
        } = esm_AST/* record */.IM(r.key.ast, r.value.ast);
        propertySignatures.forEach(ps => {
          from.push(ps);
          to.push(new esm_AST/* PropertySignature */.TJ(ps.name, esm_AST/* typeAST */.Yc(ps.type), ps.isOptional, ps.isReadonly, ps.annotations));
        });
        indexSignatures.forEach(is => {
          issFrom.push(is);
          issTo.push(new esm_AST/* IndexSignature */.AI(is.parameter, esm_AST/* typeAST */.Yc(is.type), is.isReadonly));
        });
      }
      return new esm_AST/* Transformation */.zA(new esm_AST/* TypeLiteral */.tW(from, issFrom, {
        [esm_AST/* TitleAnnotationId */.Lf]: "Struct (Encoded side)"
      }), new esm_AST/* TypeLiteral */.tW(to, issTo, {
        [esm_AST/* TitleAnnotationId */.Lf]: "Struct (Type side)"
      }), new esm_AST/* TypeLiteralTransformation */.n2(transformations));
    }
  }
  const iss = [];
  for (const r of records) {
    const {
      indexSignatures,
      propertySignatures
    } = esm_AST/* record */.IM(r.key.ast, r.value.ast);
    propertySignatures.forEach(ps => pss.push(ps));
    indexSignatures.forEach(is => iss.push(is));
  }
  return new esm_AST/* TypeLiteral */.tW(pss, iss);
};
const lazilyMergeDefaults = (fields, out) => {
  const ownKeys = util/* ownKeys */.Wp(fields);
  for (const key of ownKeys) {
    const field = fields[key];
    if (out[key] === undefined && isPropertySignature(field)) {
      const ast = field.ast;
      const defaultValue = ast._tag === "PropertySignatureDeclaration" ? ast.defaultValue : ast.to.defaultValue;
      if (defaultValue !== undefined) {
        out[key] = defaultValue();
      }
    }
  }
  return out;
};
const makeTypeLiteralClass = (fields, records, ast = getDefaultTypeLiteralAST(fields, records)) => {
  return class TypeLiteralClass extends Schema_make(ast) {
    static annotations(annotations) {
      return makeTypeLiteralClass(this.fields, this.records, mergeSchemaAnnotations(this.ast, annotations));
    }
    static fields = {
      ...fields
    };
    static records = [...records];
    static make = (props, options) => {
      const propsWithDefaults = lazilyMergeDefaults(fields, {
        ...props
      });
      return getDisableValidationMakeOption(options) ? propsWithDefaults : esm_ParseResult/* validateSync */.Dr(this)(propsWithDefaults);
    };
    static pick(...keys) {
      return Schema_Struct(Struct/* pick */.ei(fields, ...keys));
    }
    static omit(...keys) {
      return Schema_Struct(Struct/* omit */.CE(fields, ...keys));
    }
  };
};
function Schema_Struct(fields, ...records) {
  return makeTypeLiteralClass(fields, records);
}
/**
 * Returns a property signature that represents a tag.
 * A tag is a literal value that is used to distinguish between different types of objects.
 * The tag is optional when using the `make` method.
 *
 * @see {@link TaggedStruct}
 *
 * @example
 * import { Schema } from "@effect/schema"
 *
 * const User = Schema.Struct({
 *   _tag: Schema.tag("User"),
 *   name: Schema.String,
 *   age: Schema.Number
 * })
 *
 * assert.deepStrictEqual(User.make({ name: "John", age: 44 }), { _tag: "User", name: "John", age: 44 })
 *
 * @since 0.67.14
 */
const tag = tag => Literal(tag).pipe(propertySignature, withConstructorDefault(() => tag));
/**
 * A tagged struct is a struct that has a tag property that is used to distinguish between different types of objects.
 *
 * The tag is optional when using the `make` method.
 *
 * @example
 * import { Schema } from "@effect/schema"
 *
 * const User = Schema.TaggedStruct("User", {
 *   name: Schema.String,
 *   age: Schema.Number
 * })
 *
 * assert.deepStrictEqual(User.make({ name: "John", age: 44 }), { _tag: "User", name: "John", age: 44 })
 *
 * @category constructors
 * @since 0.67.14
 */
const TaggedStruct = (value, fields) => Schema_Struct({
  _tag: tag(value),
  ...fields
});
const makeRecordClass = (key, value, ast) => class RecordClass extends makeTypeLiteralClass({}, [{
  key,
  value
}], ast) {
  static annotations(annotations) {
    return makeRecordClass(key, value, mergeSchemaAnnotations(this.ast, annotations));
  }
  static key = key;
  static value = value;
};
/**
 * @category constructors
 * @since 0.67.0
 */
const Record = (key, value) => makeRecordClass(key, value);
/**
 * @category struct transformations
 * @since 0.67.0
 */
const pick = (...keys) => self => Schema_make(AST.pick(self.ast, keys));
/**
 * @category struct transformations
 * @since 0.67.0
 */
const omit = (...keys) => self => Schema_make(AST.omit(self.ast, keys));
/**
 * Given a schema `Schema<A, I, R>` and a key `key: K`, this function extracts a specific field from the `A` type,
 * producing a new schema that represents a transformation from the `{ readonly [key]: I[K] }` type to `A[K]`.
 *
 * @example
 * import * as S from "@effect/schema/Schema"
 *
 * // ---------------------------------------------
 * // use case: pull out a single field from a
 * // struct through a transformation
 * // ---------------------------------------------
 *
 * const mytable = S.Struct({
 *   column1: S.NumberFromString,
 *   column2: S.Number
 * })
 *
 * // const pullOutColumn: S.Schema<number, {
 * //     readonly column1: string;
 * // }, never>
 * const pullOutColumn = mytable.pipe(S.pluck("column1"))
 *
 * console.log(S.decodeUnknownEither(S.Array(pullOutColumn))([{ column1: "1", column2: 100 }, { column1: "2", column2: 300 }]))
 * // Output: { _id: 'Either', _tag: 'Right', right: [ 1, 2 ] }
 *
 * @category struct transformations
 * @since 0.67.0
 */
const pluck = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (schema, key) => {
  const ps = AST.getPropertyKeyIndexedAccess(AST.typeAST(schema.ast), key);
  const value = Schema_make(ps.isOptional ? AST.orUndefined(ps.type) : ps.type);
  return transform(schema.pipe(pick(key)), value, {
    strict: true,
    decode: a => a[key],
    encode: ak => ps.isOptional && ak === undefined ? {} : {
      [key]: ak
    }
  });
})));
const makeBrandClass = ast => class BrandClass extends Schema_make(ast) {
  static annotations(annotations) {
    return makeBrandClass(mergeSchemaAnnotations(this.ast, annotations));
  }
  static make = (a, options) => {
    return getDisableValidationMakeOption(options) ? a : ParseResult.validateSync(this)(a);
  };
};
/**
 * Returns a nominal branded schema by applying a brand to a given schema.
 *
 * ```
 * Schema<A> + B -> Schema<A & Brand<B>>
 * ```
 *
 * @param self - The input schema to be combined with the brand.
 * @param brand - The brand to apply.
 *
 * @example
 * import * as Schema from "@effect/schema/Schema"
 *
 * const Int = Schema.Number.pipe(Schema.int(), Schema.brand("Int"))
 * type Int = Schema.Schema.Type<typeof Int> // number & Brand<"Int">
 *
 * @category branding
 * @since 0.67.0
 */
const brand = (brand, annotations) => self => {
  const annotation = option_.match(AST.getBrandAnnotation(self.ast), {
    onNone: () => [brand],
    onSome: brands => [...brands, brand]
  });
  const ast = AST.annotations(self.ast, toASTAnnotations({
    // add a default title annotation containing the brand
    title: String(self.ast) + ` & Brand<${util_.formatUnknown(brand)}>`,
    ...annotations,
    [AST.BrandAnnotationId]: annotation
  }));
  return makeBrandClass(ast);
};
/**
 * @category combinators
 * @since 0.67.0
 */
const partial = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isSchema(args[0]), (self, options) => Schema_make(AST.partial(self.ast, options)))));
/**
 * @category combinators
 * @since 0.67.0
 */
const required = self => Schema_make(AST.required(self.ast));
/**
 * Creates a new schema with shallow mutability applied to its properties.
 *
 * @param schema - The original schema to make properties mutable (shallowly).
 *
 * @category combinators
 * @since 0.67.0
 */
const mutable = schema => Schema_make(AST.mutable(schema.ast));
const intersectTypeLiterals = (x, y, path) => {
  if (AST.isTypeLiteral(x) && AST.isTypeLiteral(y)) {
    const propertySignatures = [...x.propertySignatures];
    for (const ps of y.propertySignatures) {
      const name = ps.name;
      const i = propertySignatures.findIndex(ps => ps.name === name);
      if (i === -1) {
        propertySignatures.push(ps);
      } else {
        const {
          isOptional,
          type
        } = propertySignatures[i];
        propertySignatures[i] = new AST.PropertySignature(name, extendAST(type, ps.type, path.concat(name)), isOptional, true);
      }
    }
    return new AST.TypeLiteral(propertySignatures, x.indexSignatures.concat(y.indexSignatures));
  }
  throw new Error(errors_.getSchemaExtendErrorMessage(x, y, path));
};
const preserveRefinementAnnotations = /*#__PURE__*/esm_AST/* preserveAnnotations */.gI([esm_AST/* MessageAnnotationId */.eg, esm_AST/* JSONSchemaAnnotationId */.aN]);
const addRefinementToMembers = (refinement, asts) => asts.map(ast => new AST.Refinement(ast, refinement.filter, preserveRefinementAnnotations(refinement)));
const extendAST = (x, y, path) => AST.Union.make(intersectUnionMembers([x], [y], path));
const getTypes = ast => AST.isUnion(ast) ? ast.types : [ast];
const intersectUnionMembers = (xs, ys, path) => array_.flatMap(xs, x => array_.flatMap(ys, y => {
  switch (x._tag) {
    case "Union":
      return intersectUnionMembers(x.types, getTypes(y), path);
    case "Suspend":
      return [new AST.Suspend(() => extendAST(x.f(), y, path))];
    case "Refinement":
      return addRefinementToMembers(x, intersectUnionMembers(getTypes(x.from), getTypes(y), path));
    case "TypeLiteral":
      {
        switch (y._tag) {
          case "Union":
            return intersectUnionMembers([x], y.types, path);
          case "Suspend":
            return [new AST.Suspend(() => extendAST(x, y.f(), path))];
          case "Refinement":
            return addRefinementToMembers(y, intersectUnionMembers([x], getTypes(y.from), path));
          case "TypeLiteral":
            return [intersectTypeLiterals(x, y, path)];
          case "Transformation":
            {
              if (AST.isTypeLiteralTransformation(y.transformation)) {
                return [new AST.Transformation(intersectTypeLiterals(x, y.from, path), intersectTypeLiterals(AST.typeAST(x), y.to, path), new AST.TypeLiteralTransformation(y.transformation.propertySignatureTransformations))];
              }
              break;
            }
        }
        break;
      }
    case "Transformation":
      {
        if (AST.isTypeLiteralTransformation(x.transformation)) {
          switch (y._tag) {
            case "Union":
              return intersectUnionMembers([x], y.types, path);
            case "Suspend":
              return [new AST.Suspend(() => extendAST(x, y.f(), path))];
            case "Refinement":
              return addRefinementToMembers(y, intersectUnionMembers([x], getTypes(y.from), path));
            case "TypeLiteral":
              return [new AST.Transformation(intersectTypeLiterals(x.from, y, path), intersectTypeLiterals(x.to, AST.typeAST(y), path), new AST.TypeLiteralTransformation(x.transformation.propertySignatureTransformations))];
            case "Transformation":
              {
                if (AST.isTypeLiteralTransformation(y.transformation)) {
                  return [new AST.Transformation(intersectTypeLiterals(x.from, y.from, path), intersectTypeLiterals(x.to, y.to, path), new AST.TypeLiteralTransformation(x.transformation.propertySignatureTransformations.concat(y.transformation.propertySignatureTransformations)))];
                }
              }
              break;
          }
        }
        break;
      }
  }
  throw new Error(errors_.getSchemaExtendErrorMessage(x, y, path));
}));
/**
 * Extends a schema by adding additional fields or index signatures.
 *
 * 1) It only supports **structs**, refinements of structs, unions of structs, suspensions of structs
 * (informally `Supported = Struct | Refinement of Supported | Union of Supported | suspend(() => Supported)`)
 * 2) The arguments must represent disjoint types (e.g., `extend(Struct({ a: String }), Struct({ a: String })))` raises an error)
 *
 * @example
 * import * as Schema from "@effect/schema/Schema"
 *
 * const schema = Schema.Struct({
 *   a: Schema.String,
 *   b: Schema.String
 * })
 *
 * // const extended: S.Schema<{
 * //     readonly [x: string]: string;
 * //     readonly a: string;
 * //     readonly b: string;
 * //     readonly c: string;
 * // }>
 * const extended = Schema.asSchema(schema.pipe(
 *   Schema.extend(Schema.Struct({ c: Schema.String })), // <= you can add more fields
 *   Schema.extend(Schema.Record(Schema.String, Schema.String)) // <= you can add index signatures
 * ))
 *
 * @category combinators
 * @since 0.67.0
 */
const extend = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => Schema_make(extendAST(self.ast, that.ast, [])))));
/**
 * @category combinators
 * @since 0.67.0
 */
const compose = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isSchema(args[1]), (from, to) => Schema_make(AST.compose(from.ast, to.ast)))));
/**
 * @category constructors
 * @since 0.67.0
 */
const suspend = f => Schema_make(new esm_AST/* Suspend */.UX(() => f().ast));
/**
 * @since 0.68.8
 * @category symbol
 */
const refineTypeId = /*#__PURE__*/Symbol.for("@effect/schema/refine");
const makeRefineClass = (from, filter, ast) => class RefineClass extends Schema_make(ast) {
  static annotations(annotations) {
    return makeRefineClass(this.from, this.filter, mergeSchemaAnnotations(this.ast, annotations));
  }
  static [refineTypeId] = from;
  static from = from;
  static filter = filter;
  static make = (a, options) => {
    return getDisableValidationMakeOption(options) ? a : esm_ParseResult/* validateSync */.Dr(this)(a);
  };
};
const fromFilterPredicateReturnTypeItem = (item, ast, input) => {
  if (esm_Predicate/* isBoolean */.jn(item)) {
    return item ? esm_Option/* none */.YP() : esm_Option/* some */.G(new esm_ParseResult/* Type */.Dy(ast, input));
  }
  if (esm_Predicate/* isString */.HD(item)) {
    return esm_Option/* some */.G(new esm_ParseResult/* Type */.Dy(ast, input, item));
  }
  if (item !== undefined) {
    if ("_tag" in item) {
      return esm_Option/* some */.G(item);
    }
    const issue = new esm_ParseResult/* Type */.Dy(ast, input, item.message);
    return esm_Option/* some */.G(esm_Array/* isNonEmptyReadonlyArray */.Ux(item.path) ? new esm_ParseResult/* Pointer */.gb(item.path, input, issue) : issue);
  }
  return esm_Option/* none */.YP();
};
const toFilterParseIssue = (out, ast, input) => {
  if (util/* isSingle */.U7(out)) {
    return fromFilterPredicateReturnTypeItem(out, ast, input);
  }
  if (esm_Array/* isNonEmptyReadonlyArray */.Ux(out)) {
    const issues = esm_Array/* filterMap */.DZ(out, issue => fromFilterPredicateReturnTypeItem(issue, ast, input));
    if (esm_Array/* isNonEmptyReadonlyArray */.Ux(issues)) {
      return esm_Option/* some */.G(issues.length === 1 ? issues[0] : new esm_ParseResult/* Composite */.bU(ast, input, issues));
    }
  }
  return esm_Option/* none */.YP();
};
function filter(predicate, annotations) {
  return self => {
    function filter(input, options, ast) {
      return toFilterParseIssue(predicate(input, options, ast), ast, input);
    }
    const ast = new esm_AST/* Refinement */.B$(self.ast, filter, toASTAnnotations(annotations));
    return makeRefineClass(self, filter, ast);
  };
}
/**
 * @category transformations
 * @since 0.68.17
 */
const filterEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => transformOrFail(self, typeSchema(self), {
  strict: true,
  decode: (a, options, ast) => ParseResult.flatMap(f(a, options, ast), filterReturnType => option_.match(toFilterParseIssue(filterReturnType, ast, a), {
    onNone: () => ParseResult.succeed(a),
    onSome: ParseResult.fail
  })),
  encode: ParseResult.succeed
}))));
const makeTransformationClass = (from, to, ast) => class TransformationClass extends Schema_make(ast) {
  static annotations(annotations) {
    return makeTransformationClass(this.from, this.to, mergeSchemaAnnotations(this.ast, annotations));
  }
  static from = from;
  static to = to;
};
/**
 * Create a new `Schema` by transforming the input and output of an existing `Schema`
 * using the provided decoding functions.
 *
 * @category transformations
 * @since 0.67.0
 */
const transformOrFail = /*#__PURE__*/(0,Function/* dual */.OB)(args => isSchema(args[0]) && isSchema(args[1]), (from, to, options) => makeTransformationClass(from, to, new esm_AST/* Transformation */.zA(from.ast, to.ast, new esm_AST/* FinalTransformation */.oH(options.decode, options.encode))));
/**
 * Create a new `Schema` by transforming the input and output of an existing `Schema`
 * using the provided mapping functions.
 *
 * @category transformations
 * @since 0.67.0
 */
const transform = /*#__PURE__*/(0,Function/* dual */.OB)(args => isSchema(args[0]) && isSchema(args[1]), (from, to, options) => transformOrFail(from, to, {
  strict: true,
  decode: fromA => esm_ParseResult/* succeed */.ng(options.decode(fromA)),
  encode: toI => esm_ParseResult/* succeed */.ng(options.encode(toI))
}));
/**
 * Creates a new `Schema` which transforms literal values.
 *
 * @example
 * import * as S from "@effect/schema/Schema"
 *
 * const schema = S.transformLiteral(0, "a")
 *
 * assert.deepStrictEqual(S.decodeSync(schema)(0), "a")
 *
 * @category constructors
 * @since 0.67.0
 */
const transformLiteral = (from, to) => transform(Literal(from), Literal(to), {
  strict: true,
  decode: () => to,
  encode: () => from
});
function transformLiterals(...pairs) {
  return Union(...pairs.map(([from, to]) => transformLiteral(from, to)));
}
/**
 * Attaches a property signature with the specified key and value to the schema.
 * This API is useful when you want to add a property to your schema which doesn't describe the shape of the input,
 * but rather maps to another schema, for example when you want to add a discriminant to a simple union.
 *
 * @param self - The input schema.
 * @param key - The name of the property to add to the schema.
 * @param value - The value of the property to add to the schema.
 *
 * @example
 * import * as S from "@effect/schema/Schema"
 * import { pipe } from "effect/Function"
 *
 * const Circle = S.Struct({ radius: S.Number })
 * const Square = S.Struct({ sideLength: S.Number })
 * const Shape = S.Union(
 *   Circle.pipe(S.attachPropertySignature("kind", "circle")),
 *   Square.pipe(S.attachPropertySignature("kind", "square"))
 * )
 *
 * assert.deepStrictEqual(S.decodeSync(Shape)({ radius: 10 }), {
 *   kind: "circle",
 *   radius: 10
 * })
 *
 * @category combinators
 * @since 0.67.0
 */
const attachPropertySignature = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isSchema(args[0]), (schema, key, value, annotations) => {
  const ast = extend(typeSchema(schema), Schema_Struct({
    [key]: Predicate.isSymbol(value) ? UniqueSymbolFromSelf(value) : Literal(value)
  })).ast;
  return Schema_make(new AST.Transformation(schema.ast, annotations ? mergeSchemaAnnotations(ast, annotations) : ast, new AST.TypeLiteralTransformation([new AST.PropertySignatureTransformation(key, key, () => option_.some(value), () => option_.none())])));
})));
/**
 * @category annotations
 * @since 0.67.0
 */
const annotations = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, annotations) => self.annotations(annotations))));
/**
 * @category renaming
 * @since 0.67.0
 */
const rename = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, mapping) => Schema_make(AST.rename(self.ast, mapping)))));
/**
 * @category type id
 * @since 0.67.0
 */
const TrimmedTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Trimmed");
/**
 * Verifies that a string contains no leading or trailing whitespaces.
 *
 * Note. This combinator does not make any transformations, it only validates.
 * If what you were looking for was a combinator to trim strings, then check out the `trim` combinator.
 *
 * @category string filters
 * @since 0.67.0
 */
const trimmed = annotations => self => self.pipe(filter(a => a === a.trim(), {
  typeId: TrimmedTypeId,
  description: "a string with no leading or trailing whitespace",
  jsonSchema: {
    pattern: "^\\S[\\s\\S]*\\S$|^\\S$|^$"
  },
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_MaxLengthTypeId = MaxLengthTypeId;
/**
 * @category string filters
 * @since 0.67.0
 */
const maxLength = (maxLength, annotations) => self => self.pipe(filter(a => a.length <= maxLength, {
  typeId: Schema_MaxLengthTypeId,
  description: `a string at most ${maxLength} character(s) long`,
  jsonSchema: {
    maxLength
  },
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_MinLengthTypeId = MinLengthTypeId;
/**
 * @category string filters
 * @since 0.67.0
 */
const minLength = (minLength, annotations) => self => self.pipe(filter(a => a.length >= minLength, {
  typeId: Schema_MinLengthTypeId,
  description: `a string at least ${minLength} character(s) long`,
  jsonSchema: {
    minLength
  },
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const PatternTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Pattern");
/**
 * @category string filters
 * @since 0.67.0
 */
const pattern = (regex, annotations) => self => {
  const pattern = regex.source;
  return self.pipe(filter(a => {
    // The following line ensures that `lastIndex` is reset to `0` in case the user has specified the `g` flag
    regex.lastIndex = 0;
    return regex.test(a);
  }, {
    typeId: {
      id: PatternTypeId,
      annotation: {
        regex
      }
    },
    description: `a string matching the pattern ${pattern}`,
    jsonSchema: {
      pattern
    },
    arbitrary: () => fc => fc.stringMatching(regex),
    ...annotations
  }));
};
/**
 * @category type id
 * @since 0.67.0
 */
const StartsWithTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/StartsWith")));
/**
 * @category string filters
 * @since 0.67.0
 */
const startsWith = (startsWith, annotations) => self => self.pipe(filter(a => a.startsWith(startsWith), {
  typeId: {
    id: StartsWithTypeId,
    annotation: {
      startsWith
    }
  },
  description: `a string starting with ${JSON.stringify(startsWith)}`,
  jsonSchema: {
    pattern: `^${startsWith}`
  },
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const EndsWithTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/EndsWith")));
/**
 * @category string filters
 * @since 0.67.0
 */
const endsWith = (endsWith, annotations) => self => self.pipe(filter(a => a.endsWith(endsWith), {
  typeId: {
    id: EndsWithTypeId,
    annotation: {
      endsWith
    }
  },
  description: `a string ending with ${JSON.stringify(endsWith)}`,
  jsonSchema: {
    pattern: `^.*${endsWith}$`
  },
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const IncludesTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/Includes")));
/**
 * @category string filters
 * @since 0.67.0
 */
const includes = (searchString, annotations) => self => self.pipe(filter(a => a.includes(searchString), {
  typeId: {
    id: IncludesTypeId,
    annotation: {
      includes: searchString
    }
  },
  description: `a string including ${JSON.stringify(searchString)}`,
  jsonSchema: {
    pattern: `.*${searchString}.*`
  },
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const LowercasedTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Lowercased");
/**
 * Verifies that a string is lowercased.
 *
 * @category string filters
 * @since 0.67.0
 */
const lowercased = annotations => self => self.pipe(filter(a => a === a.toLowerCase(), {
  typeId: LowercasedTypeId,
  description: "a lowercase string",
  ...annotations
}));
/**
 * @category string constructors
 * @since 0.67.0
 */
class Lowercased extends /*#__PURE__*/String$.pipe( /*#__PURE__*/lowercased({
  identifier: "Lowercased",
  title: "Lowercased"
})) {}
/**
 * @category type id
 * @since 0.68.18
 */
const CapitalizedTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Capitalized");
/**
 * Verifies that a string is capitalized.
 *
 * @category string filters
 * @since 0.68.18
 */
const capitalized = annotations => self => self.pipe(filter(a => a[0]?.toUpperCase() === a[0], {
  typeId: CapitalizedTypeId,
  description: "a capitalized string",
  ...annotations
}));
/**
 * @category string constructors
 * @since 0.68.18
 */
class Capitalized extends /*#__PURE__*/String$.pipe( /*#__PURE__*/capitalized({
  identifier: "Capitalized",
  title: "Capitalized"
})) {}
/**
 * @category type id
 * @since 0.68.18
 */
const UncapitalizedTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Uncapitalized");
/**
 * Verifies that a string is uncapitalized.
 *
 * @category string filters
 * @since 0.68.18
 */
const uncapitalized = annotations => self => self.pipe(filter(a => a[0]?.toLowerCase() === a[0], {
  typeId: UncapitalizedTypeId,
  description: "a uncapitalized string",
  ...annotations
}));
/**
 * @category string constructors
 * @since 0.68.18
 */
class Uncapitalized extends /*#__PURE__*/String$.pipe( /*#__PURE__*/uncapitalized({
  identifier: "Uncapitalized",
  title: "Uncapitalized"
})) {}
/**
 * @category type id
 * @since 0.67.0
 */
const UppercasedTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Uppercased");
/**
 * Verifies that a string is uppercased.
 *
 * @category string filters
 * @since 0.67.0
 */
const uppercased = annotations => self => self.pipe(filter(a => a === a.toUpperCase(), {
  typeId: UppercasedTypeId,
  description: "an uppercase string",
  ...annotations
}));
/**
 * @category string constructors
 * @since 0.67.0
 */
class Uppercased extends /*#__PURE__*/String$.pipe( /*#__PURE__*/uppercased({
  identifier: "Uppercased",
  title: "Uppercased"
})) {}
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_LengthTypeId = LengthTypeId;
/**
 * @category string filters
 * @since 0.67.0
 */
const Schema_length = (length, annotations) => self => {
  const minLength = esm_Predicate/* isObject */.Kn(length) ? Math.max(0, Math.floor(length.min)) : Math.max(0, Math.floor(length));
  const maxLength = esm_Predicate/* isObject */.Kn(length) ? Math.max(minLength, Math.floor(length.max)) : minLength;
  if (minLength !== maxLength) {
    return self.pipe(filter(a => a.length >= minLength && a.length <= maxLength, {
      typeId: Schema_LengthTypeId,
      description: `a string at least ${minLength} character(s) and at most ${maxLength} character(s) long`,
      jsonSchema: {
        minLength,
        maxLength
      },
      ...annotations
    }));
  }
  return self.pipe(filter(a => a.length === minLength, {
    typeId: Schema_LengthTypeId,
    description: minLength === 1 ? `a single character` : `a string ${minLength} character(s) long`,
    jsonSchema: {
      minLength,
      maxLength: minLength
    },
    ...annotations
  }));
};
/**
 * A schema representing a single character.
 *
 * @category string constructors
 * @since 0.67.0
 */
class Char extends /*#__PURE__*/String$.pipe( /*#__PURE__*/Schema_length(1, {
  identifier: "Char"
})) {}
/**
 * @category string filters
 * @since 0.67.0
 */
const nonEmpty = annotations => minLength(1, {
  description: "a non empty string",
  ...annotations
});
/**
 * This schema converts a string to lowercase.
 *
 * @category string transformations
 * @since 0.67.0
 */
class Lowercase extends /*#__PURE__*/transform(String$, Lowercased, {
  strict: true,
  decode: s => s.toLowerCase(),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "Lowercase"
}) {}
/**
 * This schema converts a string to uppercase.
 *
 * @category string transformations
 * @since 0.67.0
 */
class Uppercase extends /*#__PURE__*/transform(String$, Uppercased, {
  strict: true,
  decode: s => s.toUpperCase(),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "Uppercase"
}) {}
/**
 * This schema converts a string to capitalized one.
 *
 * @category string transformations
 * @since 0.68.18
 */
class Capitalize extends /*#__PURE__*/transform(String$, Capitalized, {
  strict: true,
  decode: s => esm_String/* capitalize */.kC(s),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "Capitalize"
}) {}
/**
 * This schema converts a string to uncapitalized one.
 *
 * @category string transformations
 * @since 0.68.18
 */
class Uncapitalize extends /*#__PURE__*/transform(String$, Uncapitalized, {
  strict: true,
  decode: s => esm_String/* uncapitalize */.Le(s),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "Uncapitalize"
}) {}
/**
 * @category string constructors
 * @since 0.67.0
 */
class Trimmed extends /*#__PURE__*/String$.pipe( /*#__PURE__*/trimmed({
  identifier: "Trimmed",
  title: "Trimmed"
})) {}
/**
 * This schema allows removing whitespaces from the beginning and end of a string.
 *
 * @category string transformations
 * @since 0.67.0
 */
class Trim extends /*#__PURE__*/transform(String$, Trimmed, {
  strict: true,
  decode: s => s.trim(),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "Trim"
}) {}
/**
 * Returns a schema that allows splitting a string into an array of strings.
 *
 * @category string transformations
 * @since 0.67.0
 */
const split = separator => transform(String$, Array$(String$), {
  strict: true,
  decode: string_.split(separator),
  encode: array_.join(separator)
});
const JsonString = /*#__PURE__*/String$.annotations({
  [esm_AST/* IdentifierAnnotationId */.CA]: "JsonString",
  [esm_AST/* TitleAnnotationId */.Lf]: "JsonString",
  [esm_AST/* DescriptionAnnotationId */.Aj]: "a JSON string"
});
const getParseJsonTransformation = options => transformOrFail(JsonString, Unknown, {
  strict: true,
  decode: (s, _, ast) => ParseResult.try({
    try: () => JSON.parse(s, options?.reviver),
    catch: e => new ParseResult.Type(ast, s, e.message)
  }),
  encode: (u, _, ast) => ParseResult.try({
    try: () => JSON.stringify(u, options?.replacer, options?.space),
    catch: e => new ParseResult.Type(ast, u, e.message)
  })
}).annotations({
  typeId: filters_.ParseJsonTypeId
});
/**
 * The `ParseJson` combinator provides a method to convert JSON strings into the `unknown` type using the underlying
 * functionality of `JSON.parse`. It also utilizes `JSON.stringify` for encoding.
 *
 * You can optionally provide a `ParseJsonOptions` to configure both `JSON.parse` and `JSON.stringify` executions.
 *
 * Optionally, you can pass a schema `Schema<A, I, R>` to obtain an `A` type instead of `unknown`.
 *
 * @example
 * import * as S from "@effect/schema/Schema"
 *
 * assert.deepStrictEqual(S.decodeUnknownSync(S.parseJson())(`{"a":"1"}`), { a: "1" })
 * assert.deepStrictEqual(S.decodeUnknownSync(S.parseJson(S.Struct({ a: S.NumberFromString })))(`{"a":"1"}`), { a: 1 })
 *
 * @category string transformations
 * @since 0.67.0
 */
const parseJson = (schema, o) => isSchema(schema) ? compose(parseJson(o), schema) : getParseJsonTransformation(schema);
/**
 * @category string constructors
 * @since 0.67.0
 */
class NonEmpty extends /*#__PURE__*/String$.pipe( /*#__PURE__*/nonEmpty({
  identifier: "NonEmpty",
  title: "NonEmpty"
})) {}
/**
 * @category type id
 * @since 0.67.0
 */
const UUIDTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/UUID");
const uuidRegexp = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;
/**
 * Represents a Universally Unique Identifier (UUID).
 *
 * This schema ensures that the provided string adheres to the standard UUID format.
 *
 * @category string constructors
 * @since 0.67.0
 */
class UUID extends /*#__PURE__*/String$.pipe( /*#__PURE__*/pattern(uuidRegexp, {
  typeId: UUIDTypeId,
  identifier: "UUID",
  title: "UUID",
  description: "a Universally Unique Identifier",
  arbitrary: () => fc => fc.uuid()
})) {}
/**
 * @category type id
 * @since 0.67.0
 */
const ULIDTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/ULID");
const ulidRegexp = /^[0-7][0-9A-HJKMNP-TV-Z]{25}$/i;
/**
 * Represents a Universally Unique Lexicographically Sortable Identifier (ULID).
 *
 * ULIDs are designed to be compact, URL-safe, and ordered, making them suitable for use as identifiers.
 * This schema ensures that the provided string adheres to the standard ULID format.
 *
 * @category string constructors
 * @since 0.67.0
 */
class ULID extends /*#__PURE__*/String$.pipe( /*#__PURE__*/pattern(ulidRegexp, {
  typeId: ULIDTypeId,
  identifier: "ULID",
  title: "ULID",
  description: "a Universally Unique Lexicographically Sortable Identifier",
  arbitrary: () => fc => fc.ulid()
})) {}
/**
 * @category type id
 * @since 0.67.0
 */
const FiniteTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/Finite");
/**
 * Ensures that the provided value is a finite number.
 *
 * This schema filters out non-finite numeric values, allowing only finite numbers to pass through.
 *
 * @category number filters
 * @since 0.67.0
 */
const finite = annotations => self => self.pipe(filter(a => Number.isFinite(a), {
  typeId: FiniteTypeId,
  description: "a finite number",
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_GreaterThanTypeId = GreaterThanTypeId;
/**
 * This filter checks whether the provided number is greater than the specified minimum.
 *
 * @category number filters
 * @since 0.67.0
 */
const greaterThan = (min, annotations) => self => self.pipe(filter(a => a > min, {
  typeId: Schema_GreaterThanTypeId,
  description: min === 0 ? "a positive number" : `a number greater than ${min}`,
  jsonSchema: {
    exclusiveMinimum: min
  },
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_GreaterThanOrEqualToTypeId = GreaterThanOrEqualToTypeId;
/**
 * This filter checks whether the provided number is greater than or equal to the specified minimum.
 *
 * @category number filters
 * @since 0.67.0
 */
const greaterThanOrEqualTo = (min, annotations) => self => self.pipe(filter(a => a >= min, {
  typeId: Schema_GreaterThanOrEqualToTypeId,
  description: min === 0 ? "a non-negative number" : `a number greater than or equal to ${min}`,
  jsonSchema: {
    minimum: min
  },
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const MultipleOfTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/MultipleOf")));
/**
 * @category number filters
 * @since 0.67.0
 */
const multipleOf = (divisor, annotations) => self => self.pipe(filter(a => number_.remainder(a, divisor) === 0, {
  typeId: MultipleOfTypeId,
  description: `a number divisible by ${divisor}`,
  jsonSchema: {
    multipleOf: Math.abs(divisor)
  },
  // spec requires positive divisor
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_IntTypeId = IntTypeId;
/**
 * @category number filters
 * @since 0.67.0
 */
const Schema_int = annotations => self => self.pipe(filter(a => Number.isSafeInteger(a), {
  typeId: Schema_IntTypeId,
  title: "integer",
  description: "an integer",
  jsonSchema: {
    type: "integer"
  },
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_LessThanTypeId = LessThanTypeId;
/**
 * This filter checks whether the provided number is less than the specified maximum.
 *
 * @category number filters
 * @since 0.67.0
 */
const lessThan = (max, annotations) => self => self.pipe(filter(a => a < max, {
  typeId: Schema_LessThanTypeId,
  description: max === 0 ? "a negative number" : `a number less than ${max}`,
  jsonSchema: {
    exclusiveMaximum: max
  },
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_LessThanOrEqualToTypeId = LessThanOrEqualToTypeId;
/**
 * This schema checks whether the provided number is less than or equal to the specified maximum.
 *
 * @category number filters
 * @since 0.67.0
 */
const lessThanOrEqualTo = (max, annotations) => self => self.pipe(filter(a => a <= max, {
  typeId: Schema_LessThanOrEqualToTypeId,
  description: max === 0 ? "a non-positive number" : `a number less than or equal to ${max}`,
  jsonSchema: {
    maximum: max
  },
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_BetweenTypeId = BetweenTypeId;
/**
 * This filter checks whether the provided number falls within the specified minimum and maximum values.
 *
 * @category number filters
 * @since 0.67.0
 */
const between = (min, max, annotations) => self => self.pipe(filter(a => a >= min && a <= max, {
  typeId: Schema_BetweenTypeId,
  description: `a number between ${min} and ${max}`,
  jsonSchema: {
    maximum: max,
    minimum: min
  },
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const NonNaNTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/NonNaN");
/**
 * @category number filters
 * @since 0.67.0
 */
const nonNaN = annotations => self => self.pipe(filter(a => !Number.isNaN(a), {
  typeId: NonNaNTypeId,
  description: "a number excluding NaN",
  ...annotations
}));
/**
 * @category number filters
 * @since 0.67.0
 */
const positive = annotations => greaterThan(0, annotations);
/**
 * @category number filters
 * @since 0.67.0
 */
const negative = annotations => lessThan(0, annotations);
/**
 * @category number filters
 * @since 0.67.0
 */
const nonPositive = annotations => lessThanOrEqualTo(0, annotations);
/**
 * @category number filters
 * @since 0.67.0
 */
const nonNegative = annotations => greaterThanOrEqualTo(0, annotations);
/**
 * Clamps a number between a minimum and a maximum value.
 *
 * @category number transformations
 * @since 0.67.0
 */
const clamp = (minimum, maximum) => self => transform(self, self.pipe(typeSchema, between(minimum, maximum)), {
  strict: false,
  decode: self => number_.clamp(self, {
    minimum,
    maximum
  }),
  encode: identity
});
/**
 * Transforms a `string` into a `number` by parsing the string using the `parse` function of the `effect/Number` module.
 *
 * It returns an error if the value can't be converted (for example when non-numeric characters are provided).
 *
 * The following special string values are supported: "NaN", "Infinity", "-Infinity".
 *
 * @category number transformations
 * @since 0.67.0
 */
const parseNumber = self => transformOrFail(self, Number$, {
  strict: false,
  decode: (s, _, ast) => esm_ParseResult/* fromOption */.Yo(esm_Number/* parse */.Qc(s), () => new esm_ParseResult/* Type */.Dy(ast, s)),
  encode: n => esm_ParseResult/* succeed */.ng(String(n))
});
/**
 * This schema transforms a `string` into a `number` by parsing the string using the `parse` function of the `effect/Number` module.
 *
 * It returns an error if the value can't be converted (for example when non-numeric characters are provided).
 *
 * The following special string values are supported: "NaN", "Infinity", "-Infinity".
 *
 * @category number constructors
 * @since 0.67.0
 */
class NumberFromString extends /*#__PURE__*/parseNumber(String$).annotations({
  identifier: "NumberFromString"
}) {}
/**
 * @category number constructors
 * @since 0.67.0
 */
class Finite extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/finite({
  identifier: "Finite",
  title: "Finite"
})) {}
/**
 * @category number constructors
 * @since 0.67.0
 */
class Int extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/Schema_int({
  identifier: "Int",
  title: "Int"
})) {}
/**
 * @category number constructors
 * @since 0.67.0
 */
class NonNaN extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/nonNaN({
  identifier: "NonNaN",
  title: "NonNaN"
})) {}
/**
 * @category number constructors
 * @since 0.67.0
 */
class Positive extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/positive({
  identifier: "Positive",
  title: "Positive"
})) {}
/**
 * @category number constructors
 * @since 0.67.0
 */
class Negative extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/negative({
  identifier: "Negative",
  title: "Negative"
})) {}
/**
 * @category number constructors
 * @since 0.67.0
 */
class NonPositive extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/nonPositive({
  identifier: "NonPositive",
  title: "NonPositive"
})) {}
/**
 * @category number constructors
 * @since 0.67.0
 */
class NonNegative extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/nonNegative({
  identifier: "NonNegative",
  title: "NonNegative"
})) {}
/**
 * @category type id
 * @since 0.67.0
 */
const JsonNumberTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/JsonNumber");
/**
 * The `JsonNumber` is a schema for representing JSON numbers. It ensures that the provided value is a valid
 * number by filtering out `NaN` and `(+/-) Infinity`. This is useful when you want to validate and represent numbers in JSON
 * format.
 *
 * @example
 * import * as S from "@effect/schema/Schema"
 *
 * const is = S.is(S.JsonNumber)
 *
 * assert.deepStrictEqual(is(42), true)
 * assert.deepStrictEqual(is(Number.NaN), false)
 * assert.deepStrictEqual(is(Number.POSITIVE_INFINITY), false)
 * assert.deepStrictEqual(is(Number.NEGATIVE_INFINITY), false)
 *
 * @category number constructors
 * @since 0.67.0
 */
class JsonNumber extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/filter(n => !Number.isNaN(n) && Number.isFinite(n), {
  typeId: JsonNumberTypeId,
  identifier: "JsonNumber",
  title: "JSON-compatible number",
  description: "a JSON-compatible number, excluding NaN, +Infinity, and -Infinity",
  jsonSchema: {
    type: "number"
  }
})) {}
/**
 * @category boolean transformations
 * @since 0.67.0
 */
class Not extends /*#__PURE__*/transform(Boolean$, Boolean$, {
  strict: true,
  decode: Boolean/* not */.ff,
  encode: Boolean/* not */.ff
}) {}
/** @ignore */
class Symbol$ extends /*#__PURE__*/transform(String$, SymbolFromSelf, {
  strict: false,
  decode: s => Symbol.for(s),
  encode: sym => sym.description
}).annotations({
  identifier: "symbol"
}) {}

/**
 * @category type id
 * @since 0.67.0
 */
const GreaterThanBigIntTypeId = GreaterThanBigintTypeId;
/**
 * @category bigint filters
 * @since 0.67.0
 */
const greaterThanBigInt = (min, annotations) => self => self.pipe(filter(a => a > min, {
  typeId: {
    id: GreaterThanBigIntTypeId,
    annotation: {
      min
    }
  },
  description: min === 0n ? "a positive bigint" : `a bigint greater than ${min}n`,
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_GreaterThanOrEqualToBigIntTypeId = GreaterThanOrEqualToBigIntTypeId;
/**
 * @category bigint filters
 * @since 0.67.0
 */
const greaterThanOrEqualToBigInt = (min, annotations) => self => self.pipe(filter(a => a >= min, {
  typeId: {
    id: Schema_GreaterThanOrEqualToBigIntTypeId,
    annotation: {
      min
    }
  },
  description: min === 0n ? "a non-negative bigint" : `a bigint greater than or equal to ${min}n`,
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_LessThanBigIntTypeId = LessThanBigIntTypeId;
/**
 * @category bigint filters
 * @since 0.67.0
 */
const lessThanBigInt = (max, annotations) => self => self.pipe(filter(a => a < max, {
  typeId: {
    id: Schema_LessThanBigIntTypeId,
    annotation: {
      max
    }
  },
  description: max === 0n ? "a negative bigint" : `a bigint less than ${max}n`,
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_LessThanOrEqualToBigIntTypeId = LessThanOrEqualToBigIntTypeId;
/**
 * @category bigint filters
 * @since 0.67.0
 */
const lessThanOrEqualToBigInt = (max, annotations) => self => self.pipe(filter(a => a <= max, {
  typeId: {
    id: Schema_LessThanOrEqualToBigIntTypeId,
    annotation: {
      max
    }
  },
  description: max === 0n ? "a non-positive bigint" : `a bigint less than or equal to ${max}n`,
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const BetweenBigIntTypeId = BetweenBigintTypeId;
/**
 * @category bigint filters
 * @since 0.67.0
 */
const betweenBigInt = (min, max, annotations) => self => self.pipe(filter(a => a >= min && a <= max, {
  typeId: {
    id: BetweenBigIntTypeId,
    annotation: {
      max,
      min
    }
  },
  description: `a bigint between ${min}n and ${max}n`,
  ...annotations
}));
/**
 * @category bigint filters
 * @since 0.67.0
 */
const positiveBigInt = annotations => greaterThanBigInt(0n, annotations);
/**
 * @category bigint filters
 * @since 0.67.0
 */
const negativeBigInt = annotations => lessThanBigInt(0n, annotations);
/**
 * @category bigint filters
 * @since 0.67.0
 */
const nonNegativeBigInt = annotations => greaterThanOrEqualToBigInt(0n, annotations);
/**
 * @category bigint filters
 * @since 0.67.0
 */
const nonPositiveBigInt = annotations => lessThanOrEqualToBigInt(0n, annotations);
/**
 * Clamps a bigint between a minimum and a maximum value.
 *
 * @category bigint transformations
 * @since 0.67.0
 */
const clampBigInt = (minimum, maximum) => self => transform(self, self.pipe(typeSchema, betweenBigInt(minimum, maximum)), {
  strict: false,
  decode: self => bigInt_.clamp(self, {
    minimum,
    maximum
  }),
  encode: identity
});
/** @ignore */
class BigInt$ extends /*#__PURE__*/transformOrFail(String$, BigIntFromSelf, {
  strict: true,
  decode: (s, _, ast) => esm_ParseResult/* fromOption */.Yo(esm_BigInt/* fromString */.mL(s), () => new esm_ParseResult/* Type */.Dy(ast, s)),
  encode: n => esm_ParseResult/* succeed */.ng(String(n))
}).annotations({
  identifier: "bigint"
}) {}

/**
 * @category bigint constructors
 * @since 0.67.0
 */
const PositiveBigIntFromSelf = /*#__PURE__*/BigIntFromSelf.pipe( /*#__PURE__*/positiveBigInt({
  identifier: "PositiveBigintFromSelf",
  title: "PositiveBigintFromSelf"
}));
/**
 * @category bigint constructors
 * @since 0.67.0
 */
const PositiveBigInt = /*#__PURE__*/BigInt$.pipe( /*#__PURE__*/positiveBigInt({
  identifier: "PositiveBigint",
  title: "PositiveBigint"
}));
/**
 * @category bigint constructors
 * @since 0.67.0
 */
const NegativeBigIntFromSelf = /*#__PURE__*/BigIntFromSelf.pipe( /*#__PURE__*/negativeBigInt({
  identifier: "NegativeBigintFromSelf",
  title: "NegativeBigintFromSelf"
}));
/**
 * @category bigint constructors
 * @since 0.67.0
 */
const NegativeBigInt = /*#__PURE__*/BigInt$.pipe( /*#__PURE__*/negativeBigInt({
  identifier: "NegativeBigint",
  title: "NegativeBigint"
}));
/**
 * @category bigint constructors
 * @since 0.67.0
 */
const NonPositiveBigIntFromSelf = /*#__PURE__*/BigIntFromSelf.pipe( /*#__PURE__*/nonPositiveBigInt({
  identifier: "NonPositiveBigintFromSelf",
  title: "NonPositiveBigintFromSelf"
}));
/**
 * @category bigint constructors
 * @since 0.67.0
 */
const NonPositiveBigInt = /*#__PURE__*/BigInt$.pipe( /*#__PURE__*/nonPositiveBigInt({
  identifier: "NonPositiveBigint",
  title: "NonPositiveBigint"
}));
/**
 * @category bigint constructors
 * @since 0.67.0
 */
const NonNegativeBigIntFromSelf = /*#__PURE__*/BigIntFromSelf.pipe( /*#__PURE__*/nonNegativeBigInt({
  identifier: "NonNegativeBigintFromSelf",
  title: "NonNegativeBigintFromSelf"
}));
/**
 * @category bigint constructors
 * @since 0.67.0
 */
const NonNegativeBigInt = /*#__PURE__*/BigInt$.pipe( /*#__PURE__*/nonNegativeBigInt({
  identifier: "NonNegativeBigint",
  title: "NonNegativeBigint"
}));
/**
 * This schema transforms a `number` into a `bigint` by parsing the number using the `BigInt` function.
 *
 * It returns an error if the value can't be safely encoded as a `number` due to being out of range.
 *
 * @category bigint transformations
 * @since 0.67.0
 */
class BigIntFromNumber extends /*#__PURE__*/transformOrFail(Number$, BigIntFromSelf, {
  strict: true,
  decode: (n, _, ast) => esm_ParseResult/* fromOption */.Yo(esm_BigInt/* fromNumber */.xS(n), () => new esm_ParseResult/* Type */.Dy(ast, n)),
  encode: (b, _, ast) => esm_ParseResult/* fromOption */.Yo(esm_BigInt/* toNumber */.He(b), () => new esm_ParseResult/* Type */.Dy(ast, b))
}).annotations({
  identifier: "BigintFromNumber"
}) {}
const redactedArbitrary = value => fc => value(fc).map(x => redacted_.make(x));
const toComposite = (eff, onSuccess, ast, actual) => ParseResult.mapBoth(eff, {
  onFailure: e => new ParseResult.Composite(ast, actual, e),
  onSuccess
});
const redactedParse = decodeUnknown => (u, options, ast) => redacted_.isRedacted(u) ? toComposite(decodeUnknown(redacted_.value(u), options), redacted_.make, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Redacted constructors
 * @since 0.67.21
 */
const RedactedFromSelf = value => declare([value], {
  decode: value => redactedParse(ParseResult.decodeUnknown(value)),
  encode: value => redactedParse(ParseResult.encodeUnknown(value))
}, {
  description: "Redacted(<redacted>)",
  pretty: () => () => "Redacted(<redacted>)",
  arbitrary: redactedArbitrary,
  equivalence: redacted_.getEquivalence
});
/**
 * A schema that transforms any type `A` into a `Redacted<A>`.
 *
 * @category Redacted transformations
 * @since 0.67.21
 */
const Redacted = value => {
  return transform(value, RedactedFromSelf(typeSchema(value)), {
    strict: true,
    decode: value => redacted_.make(value),
    encode: value => redacted_.value(value)
  });
};
/**
 * @category Duration constructors
 * @since 0.67.0
 */
class DurationFromSelf extends /*#__PURE__*/declare(Duration/* isDuration */._9, {
  identifier: "DurationFromSelf",
  pretty: () => String,
  arbitrary: () => fc => fc.oneof(fc.constant(Duration/* infinity */.Fd), fc.bigUint().map(_ => Duration/* nanos */.o6(_)), fc.bigUint().map(_ => Duration/* micros */.Ti(_)), fc.maxSafeNat().map(_ => Duration/* millis */.YX(_)), fc.maxSafeNat().map(_ => Duration/* seconds */.m9(_)), fc.maxSafeNat().map(_ => Duration/* minutes */.LK(_)), fc.maxSafeNat().map(_ => Duration/* hours */.i4(_)), fc.maxSafeNat().map(_ => Duration/* days */.an(_)), fc.maxSafeNat().map(_ => Duration/* weeks */.P4(_))),
  equivalence: () => Duration/* Equivalence */.CZ
}) {}
/**
 * A schema that transforms a `bigint` tuple into a `Duration`.
 * Treats the value as the number of nanoseconds.
 *
 * @category Duration transformations
 * @since 0.67.0
 */
class DurationFromNanos extends /*#__PURE__*/transformOrFail(BigIntFromSelf, DurationFromSelf, {
  strict: true,
  decode: nanos => esm_ParseResult/* succeed */.ng(Duration/* nanos */.o6(nanos)),
  encode: (duration, _, ast) => esm_Option/* match */.EQ(Duration/* toNanos */.CU(duration), {
    onNone: () => esm_ParseResult/* fail */.bG(new esm_ParseResult/* Type */.Dy(ast, duration)),
    onSome: val => esm_ParseResult/* succeed */.ng(val)
  })
}).annotations({
  identifier: "DurationFromNanos"
}) {}
/**
 * A schema that transforms a `number` tuple into a `Duration`.
 * Treats the value as the number of milliseconds.
 *
 * @category Duration transformations
 * @since 0.67.0
 */
class DurationFromMillis extends /*#__PURE__*/transform(Number$, DurationFromSelf, {
  strict: true,
  decode: ms => Duration/* millis */.YX(ms),
  encode: n => Duration/* toMillis */.eq(n)
}).annotations({
  identifier: "DurationFromMillis"
}) {}
const hrTime = /*#__PURE__*/Tuple( /*#__PURE__*/NonNegative.pipe( /*#__PURE__*/finite({
  [esm_AST/* TitleAnnotationId */.Lf]: "seconds",
  [esm_AST/* DescriptionAnnotationId */.Aj]: "seconds"
})), /*#__PURE__*/NonNegative.pipe( /*#__PURE__*/finite({
  [esm_AST/* TitleAnnotationId */.Lf]: "nanos",
  [esm_AST/* DescriptionAnnotationId */.Aj]: "nanos"
})));
/**
 * A schema that transforms a `[number, number]` tuple into a `Duration`.
 *
 * @category Duration transformations
 * @since 0.67.0
 */
class Schema_Duration extends /*#__PURE__*/transform(hrTime, DurationFromSelf, {
  strict: true,
  decode: ([seconds, nanos]) => Duration/* nanos */.o6(BigInt(seconds) * BigInt(1e9) + BigInt(nanos)),
  encode: duration => Duration/* toHrTime */.hX(duration)
}).annotations({
  identifier: "Duration"
}) {}
/**
 * Clamps a `Duration` between a minimum and a maximum value.
 *
 * @category Duration transformations
 * @since 0.67.0
 */
const clampDuration = (minimum, maximum) => self => transform(self, self.pipe(typeSchema, betweenDuration(minimum, maximum)), {
  strict: false,
  decode: self => duration_.clamp(self, {
    minimum,
    maximum
  }),
  encode: identity
});
/**
 * @category type id
 * @since 0.67.0
 */
const LessThanDurationTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/LessThanDuration")));
/**
 * @category Duration filters
 * @since 0.67.0
 */
const lessThanDuration = (max, annotations) => self => self.pipe(filter(a => duration_.lessThan(a, max), {
  typeId: {
    id: LessThanDurationTypeId,
    annotation: {
      max
    }
  },
  description: `a Duration less than ${duration_.decode(max)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const LessThanOrEqualToDurationTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/LessThanOrEqualToDuration")));
/**
 * @category Duration filters
 * @since 0.67.0
 */
const lessThanOrEqualToDuration = (max, annotations) => self => self.pipe(filter(a => duration_.lessThanOrEqualTo(a, max), {
  typeId: {
    id: LessThanDurationTypeId,
    annotation: {
      max
    }
  },
  description: `a Duration less than or equal to ${duration_.decode(max)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const GreaterThanDurationTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/GreaterThanDuration")));
/**
 * @category Duration filters
 * @since 0.67.0
 */
const greaterThanDuration = (min, annotations) => self => self.pipe(filter(a => duration_.greaterThan(a, min), {
  typeId: {
    id: GreaterThanDurationTypeId,
    annotation: {
      min
    }
  },
  description: `a Duration greater than ${duration_.decode(min)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const GreaterThanOrEqualToDurationTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/GreaterThanOrEqualToDuration")));
/**
 * @category Duration filters
 * @since 0.67.0
 */
const greaterThanOrEqualToDuration = (min, annotations) => self => self.pipe(filter(a => duration_.greaterThanOrEqualTo(a, min), {
  typeId: {
    id: GreaterThanOrEqualToDurationTypeId,
    annotation: {
      min
    }
  },
  description: `a Duration greater than or equal to ${duration_.decode(min)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const BetweenDurationTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/BetweenDuration")));
/**
 * @category Duration filters
 * @since 0.67.0
 */
const betweenDuration = (minimum, maximum, annotations) => self => self.pipe(filter(a => duration_.between(a, {
  minimum,
  maximum
}), {
  typeId: {
    id: BetweenDurationTypeId,
    annotation: {
      maximum,
      minimum
    }
  },
  description: `a Duration between ${duration_.decode(minimum)} and ${duration_.decode(maximum)}`,
  ...annotations
}));
/**
 * @category Uint8Array constructors
 * @since 0.67.0
 */
const Uint8ArrayFromSelf = /*#__PURE__*/declare(esm_Predicate/* isUint8Array */.lq, {
  identifier: "Uint8ArrayFromSelf",
  pretty: () => u8arr => `new Uint8Array(${JSON.stringify(Array.from(u8arr))})`,
  arbitrary: () => fc => fc.uint8Array(),
  equivalence: () => esm_Array/* getEquivalence */.c5(esm_Equal/* equals */.fS)
});
const Uint8Array$ = /*#__PURE__*/transform(Array$(Number$.pipe(between(0, 255, {
  title: "8-bit unsigned integer",
  description: "a 8-bit unsigned integer"
}))).annotations({
  description: "an array of 8-bit unsigned integers"
}), Uint8ArrayFromSelf, {
  strict: true,
  decode: numbers => Uint8Array.from(numbers),
  encode: uint8Array => Array.from(uint8Array)
}).annotations({
  identifier: "Uint8Array"
});

const makeEncodingTransformation = (id, decode, encode) => transformOrFail(String$, Uint8ArrayFromSelf, {
  strict: true,
  decode: (s, _, ast) => Either/* mapLeft */.Vn(decode(s), decodeException => new esm_ParseResult/* Type */.Dy(ast, s, decodeException.message)),
  encode: u => esm_ParseResult/* succeed */.ng(encode(u))
}).annotations({
  identifier: id
});
/**
 * @category Encoding transformations
 * @since 0.67.0
 */
const Base64 = /*#__PURE__*/makeEncodingTransformation("Base64", Encoding/* decodeBase64 */.NV, Encoding/* encodeBase64 */.oF);
/**
 * @category Encoding transformations
 * @since 0.67.0
 */
const Base64Url = /*#__PURE__*/makeEncodingTransformation("Base64Url", Encoding/* decodeBase64Url */.fr, Encoding/* encodeBase64Url */.Mp);
/**
 * @category Encoding transformations
 * @since 0.67.0
 */
const Hex = /*#__PURE__*/makeEncodingTransformation("Hex", Encoding/* decodeHex */.QT, Encoding/* encodeHex */.U$);
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_MinItemsTypeId = MinItemsTypeId;
/**
 * @category ReadonlyArray filters
 * @since 0.67.0
 */
const minItems = (n, annotations) => self => {
  const minItems = Math.floor(n);
  if (minItems < 1) {
    throw new Error(errors_.getInvalidArgumentErrorMessage(`Expected an integer greater than or equal to 1, actual ${n}`));
  }
  return self.pipe(filter(a => a.length >= minItems, {
    typeId: Schema_MinItemsTypeId,
    description: `an array of at least ${minItems} items`,
    jsonSchema: {
      minItems
    },
    [AST.StableFilterAnnotationId]: true,
    ...annotations
  }));
};
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_MaxItemsTypeId = MaxItemsTypeId;
/**
 * @category ReadonlyArray filters
 * @since 0.67.0
 */
const maxItems = (n, annotations) => self => self.pipe(filter(a => a.length <= n, {
  typeId: Schema_MaxItemsTypeId,
  description: `an array of at most ${n} items`,
  jsonSchema: {
    maxItems: n
  },
  [AST.StableFilterAnnotationId]: true,
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const Schema_ItemsCountTypeId = ItemsCountTypeId;
/**
 * @category ReadonlyArray filters
 * @since 0.67.0
 */
const itemsCount = (n, annotations) => self => self.pipe(filter(a => a.length === n, {
  typeId: Schema_ItemsCountTypeId,
  description: `an array of exactly ${n} item(s)`,
  jsonSchema: {
    minItems: n,
    maxItems: n
  },
  [AST.StableFilterAnnotationId]: true,
  ...annotations
}));
/**
 * @category ReadonlyArray transformations
 * @since 0.67.0
 */
const getNumberIndexedAccess = self => Schema_make(AST.getNumberIndexedAccess(self.ast));
/**
 * Get the first element of a `ReadonlyArray`, or `None` if the array is empty.
 *
 * @category ReadonlyArray transformations
 * @since 0.67.0
 */
const head = self => transform(self, OptionFromSelf(getNumberIndexedAccess(typeSchema(self))), {
  strict: true,
  decode: array_.head,
  encode: option_.match({
    onNone: () => [],
    onSome: array_.of
  })
});
/**
 * Retrieves the first element of a `ReadonlyArray`.
 *
 * If the array is empty, it returns the `fallback` argument if provided; otherwise, it fails.
 *
 * @category ReadonlyArray transformations
 * @since 0.67.0
 */
const headOrElse = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isSchema(args[0]), (self, fallback) => transformOrFail(self, getNumberIndexedAccess(typeSchema(self)), {
  strict: true,
  decode: (as, _, ast) => as.length > 0 ? ParseResult.succeed(as[0]) : fallback ? ParseResult.succeed(fallback()) : ParseResult.fail(new ParseResult.Type(ast, as)),
  encode: a => ParseResult.succeed(array_.of(a))
}))));
/**
 * @category type id
 * @since 0.67.0
 */
const ValidDateTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/ValidDate");
/**
 * Defines a filter that specifically rejects invalid dates, such as `new
 * Date("Invalid Date")`. This filter ensures that only properly formatted and
 * valid date objects are accepted, enhancing data integrity by preventing
 * erroneous date values from being processed.
 *
 * @category Date filters
 * @since 0.67.0
 */
const validDate = annotations => self => self.pipe(filter(a => !Number.isNaN(a.getTime()), {
  typeId: ValidDateTypeId,
  description: "a valid Date",
  ...annotations
}));
/**
 * Describes a schema that accommodates potentially invalid `Date` instances,
 * such as `new Date("Invalid Date")`, without rejection.
 *
 * @category Date constructors
 * @since 0.67.0
 */
class DateFromSelf extends /*#__PURE__*/declare(esm_Predicate/* isDate */.J_, {
  identifier: "DateFromSelf",
  description: "a potentially invalid Date instance",
  pretty: () => date => `new Date(${JSON.stringify(date)})`,
  arbitrary: () => fc => fc.date({
    noInvalidDate: false
  }),
  equivalence: () => esm_Equivalence/* Date */.Ej
}) {}
/**
 * Defines a schema that ensures only valid dates are accepted. This schema
 * rejects values like `new Date("Invalid Date")`, which, despite being a `Date`
 * instance, represents an invalid date. Such stringent validation ensures that
 * all date objects processed through this schema are properly formed and
 * represent real dates.
 *
 * @category Date constructors
 * @since 0.67.0
 */
class ValidDateFromSelf extends /*#__PURE__*/DateFromSelf.pipe( /*#__PURE__*/validDate({
  identifier: "ValidDateFromSelf",
  description: "a valid Date instance"
})) {}
/**
 * Defines a schema that attempts to convert a `string` to a `Date` object using
 * the `new Date` constructor. This conversion is lenient, meaning it does not
 * reject strings that do not form valid dates (e.g., using `new Date("Invalid
 * Date")` results in a `Date` object, despite being invalid).
 *
 * @category Date transformations
 * @since 0.67.0
 */
class DateFromString extends /*#__PURE__*/transform(String$, DateFromSelf, {
  strict: true,
  decode: s => new Date(s),
  encode: d => d.toISOString()
}).annotations({
  identifier: "DateFromString"
}) {}
/** @ignore */
class Date$ extends /*#__PURE__*/DateFromString.pipe( /*#__PURE__*/validDate({
  identifier: "Date"
})) {}

/**
 * Defines a schema that converts a `number` into a `Date` object using the `new
 * Date` constructor. This schema does not validate the numerical input,
 * allowing potentially invalid values such as `NaN`, `Infinity`, and
 * `-Infinity` to be converted into `Date` objects. During the encoding process,
 * any invalid `Date` object will be encoded to `NaN`.
 *
 * @category Date transformations
 * @since 0.67.0
 */
class DateFromNumber extends /*#__PURE__*/transform(Number$, DateFromSelf, {
  strict: true,
  decode: n => new Date(n),
  encode: d => d.getTime()
}).annotations({
  identifier: "DateFromNumber"
}) {}
const OptionNoneEncoded = /*#__PURE__*/Schema_Struct({
  _tag: Literal("None")
}).annotations({
  description: "NoneEncoded"
});
const optionSomeEncoded = value => Schema_Struct({
  _tag: Literal("Some"),
  value
}).annotations({
  description: `SomeEncoded<${format(value)}>`
});
const optionEncoded = value => Union(OptionNoneEncoded, optionSomeEncoded(value)).annotations({
  description: `OptionEncoded<${format(value)}>`
});
const optionDecode = input => input._tag === "None" ? option_.none() : option_.some(input.value);
const optionArbitrary = value => fc => fc.oneof(fc.record({
  _tag: fc.constant("None")
}), fc.record({
  _tag: fc.constant("Some"),
  value: value(fc)
})).map(optionDecode);
const optionPretty = value => option_.match({
  onNone: () => "none()",
  onSome: a => `some(${value(a)})`
});
const optionParse = decodeUnknown => (u, options, ast) => option_.isOption(u) ? option_.isNone(u) ? ParseResult.succeed(option_.none()) : toComposite(decodeUnknown(u.value, options), option_.some, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Option transformations
 * @since 0.67.0
 */
const OptionFromSelf = value => {
  return declare([value], {
    decode: value => optionParse(ParseResult.decodeUnknown(value)),
    encode: value => optionParse(ParseResult.encodeUnknown(value))
  }, {
    description: `Option<${format(value)}>`,
    pretty: optionPretty,
    arbitrary: optionArbitrary,
    equivalence: option_.getEquivalence
  });
};
const makeNoneEncoded = {
  _tag: "None"
};
const makeSomeEncoded = value => ({
  _tag: "Some",
  value
});
/**
 * @category Option transformations
 * @since 0.67.0
 */
const Schema_Option = value => {
  const value_ = asSchema(value);
  return transform(optionEncoded(value_), OptionFromSelf(typeSchema(value_)), {
    strict: true,
    decode: optionDecode,
    encode: option_.match({
      onNone: () => makeNoneEncoded,
      onSome: makeSomeEncoded
    })
  });
};
/**
 * @category Option transformations
 * @since 0.67.0
 */
const OptionFromNullOr = value => {
  const value_ = asSchema(value);
  return transform(NullOr(value_), OptionFromSelf(typeSchema(value_)), {
    strict: true,
    decode: option_.fromNullable,
    encode: option_.getOrNull
  });
};
/**
 * @category Option transformations
 * @since 0.67.0
 */
const OptionFromNullishOr = (value, onNoneEncoding) => {
  const value_ = asSchema(value);
  return transform(NullishOr(value_), OptionFromSelf(typeSchema(value_)), {
    strict: true,
    decode: option_.fromNullable,
    encode: onNoneEncoding === null ? option_.getOrNull : option_.getOrUndefined
  });
};
/**
 * @category Option transformations
 * @since 0.67.0
 */
const OptionFromUndefinedOr = value => {
  const value_ = asSchema(value);
  return transform(UndefinedOr(value_), OptionFromSelf(typeSchema(value_)), {
    strict: true,
    decode: option_.fromNullable,
    encode: option_.getOrUndefined
  });
};
const rightEncoded = right => Schema_Struct({
  _tag: Literal("Right"),
  right
}).annotations({
  description: `RightEncoded<${format(right)}>`
});
const leftEncoded = left => Schema_Struct({
  _tag: Literal("Left"),
  left
}).annotations({
  description: `LeftEncoded<${format(left)}>`
});
const eitherEncoded = (right, left) => Union(rightEncoded(right), leftEncoded(left)).annotations({
  description: `EitherEncoded<${format(left)}, ${format(right)}>`
});
const eitherDecode = input => input._tag === "Left" ? either_.left(input.left) : either_.right(input.right);
const eitherArbitrary = (right, left) => fc => fc.oneof(fc.record({
  _tag: fc.constant("Left"),
  left: left(fc)
}), fc.record({
  _tag: fc.constant("Right"),
  right: right(fc)
})).map(eitherDecode);
const eitherPretty = (right, left) => either_.match({
  onLeft: e => `left(${left(e)})`,
  onRight: a => `right(${right(a)})`
});
const eitherParse = (parseRight, decodeUnknownLeft) => (u, options, ast) => either_.isEither(u) ? either_.match(u, {
  onLeft: left => toComposite(decodeUnknownLeft(left, options), either_.left, ast, u),
  onRight: right => toComposite(parseRight(right, options), either_.right, ast, u)
}) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Either transformations
 * @since 0.67.0
 */
const EitherFromSelf = ({
  left,
  right
}) => {
  return declare([right, left], {
    decode: (right, left) => eitherParse(ParseResult.decodeUnknown(right), ParseResult.decodeUnknown(left)),
    encode: (right, left) => eitherParse(ParseResult.encodeUnknown(right), ParseResult.encodeUnknown(left))
  }, {
    description: `Either<${format(right)}, ${format(left)}>`,
    pretty: eitherPretty,
    arbitrary: eitherArbitrary,
    equivalence: (right, left) => either_.getEquivalence({
      left,
      right
    })
  });
};
const makeLeftEncoded = left => ({
  _tag: "Left",
  left
});
const makeRightEncoded = right => ({
  _tag: "Right",
  right
});
/**
 * @category Either transformations
 * @since 0.67.0
 */
const Schema_Either = ({
  left,
  right
}) => {
  const right_ = asSchema(right);
  const left_ = asSchema(left);
  return transform(eitherEncoded(right_, left_), EitherFromSelf({
    left: typeSchema(left_),
    right: typeSchema(right_)
  }), {
    strict: true,
    decode: eitherDecode,
    encode: either_.match({
      onLeft: makeLeftEncoded,
      onRight: makeRightEncoded
    })
  });
};
/**
 * @example
 * import * as Schema from "@effect/schema/Schema"
 *
 * // Schema<string | number, Either<string, number>>
 * Schema.EitherFromUnion({ left: Schema.String, right: Schema.Number })
 *
 * @category Either transformations
 * @since 0.67.0
 */
const EitherFromUnion = ({
  left,
  right
}) => {
  const right_ = asSchema(right);
  const left_ = asSchema(left);
  const toright = typeSchema(right_);
  const toleft = typeSchema(left_);
  const fromRight = transform(right_, rightEncoded(toright), {
    strict: true,
    decode: makeRightEncoded,
    encode: r => r.right
  });
  const fromLeft = transform(left_, leftEncoded(toleft), {
    strict: true,
    decode: makeLeftEncoded,
    encode: l => l.left
  });
  return transform(Union(fromRight, fromLeft), EitherFromSelf({
    left: toleft,
    right: toright
  }), {
    strict: true,
    decode: from => from._tag === "Left" ? either_.left(from.left) : either_.right(from.right),
    encode: either_.match({
      onLeft: makeLeftEncoded,
      onRight: makeRightEncoded
    })
  });
};
const mapArbitrary = (key, value) => fc => fc.array(fc.tuple(key(fc), value(fc))).map(as => new Map(as));
const readonlyMapPretty = (key, value) => map => `new Map([${Array.from(map.entries()).map(([k, v]) => `[${key(k)}, ${value(v)}]`).join(", ")}])`;
const readonlyMapEquivalence = (key, value) => {
  const arrayEquivalence = array_.getEquivalence(Equivalence.make(([ka, va], [kb, vb]) => key(ka, kb) && value(va, vb)));
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a.entries()), Array.from(b.entries())));
};
const readonlyMapParse = decodeUnknown => (u, options, ast) => Predicate.isMap(u) ? toComposite(decodeUnknown(Array.from(u.entries()), options), as => new Map(as), ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
const mapFromSelf_ = (key, value, description) => declare([key, value], {
  decode: (Key, Value) => readonlyMapParse(ParseResult.decodeUnknown(Array$(Tuple(Key, Value)))),
  encode: (Key, Value) => readonlyMapParse(ParseResult.encodeUnknown(Array$(Tuple(Key, Value))))
}, {
  description,
  pretty: readonlyMapPretty,
  arbitrary: mapArbitrary,
  equivalence: readonlyMapEquivalence
});
/**
 * @category ReadonlyMap
 * @since 0.67.0
 */
const ReadonlyMapFromSelf = ({
  key,
  value
}) => mapFromSelf_(key, value, `ReadonlyMap<${format(key)}, ${format(value)}>`);
/**
 * @category Map
 * @since 0.67.0
 */
const MapFromSelf = ({
  key,
  value
}) => mapFromSelf_(key, value, `Map<${format(key)}, ${format(value)}>`);
/**
 * @category ReadonlyMap transformations
 * @since 0.67.0
 */
const ReadonlyMap = ({
  key,
  value
}) => {
  const key_ = asSchema(key);
  const value_ = asSchema(value);
  return transform(Array$(Tuple(key_, value_)), ReadonlyMapFromSelf({
    key: typeSchema(key_),
    value: typeSchema(value_)
  }), {
    strict: true,
    decode: as => new Map(as),
    encode: map => Array.from(map.entries())
  });
};
const map = ({
  key,
  value
}) => {
  const key_ = asSchema(key);
  const value_ = asSchema(value);
  return transform(Array$(Tuple(key_, value_)), MapFromSelf({
    key: typeSchema(key_),
    value: typeSchema(value_)
  }), {
    strict: true,
    decode: as => new Map(as),
    encode: map => Array.from(map.entries())
  });
};

/**
 * @category ReadonlyMap transformations
 * @since 0.68.15
 */
const ReadonlyMapFromRecord = ({
  key,
  value
}) => transform(Record(encodedBoundSchema(key), value), ReadonlyMapFromSelf({
  key,
  value: typeSchema(value)
}), {
  strict: true,
  decode: record => new Map(Object.entries(record)),
  encode: record_.fromEntries
});
/**
 * @category Map transformations
 * @since 0.68.15
 */
const MapFromRecord = ({
  key,
  value
}) => transform(Record(encodedBoundSchema(key), value), MapFromSelf({
  key,
  value: typeSchema(value)
}), {
  strict: true,
  decode: record => new Map(Object.entries(record)),
  encode: record_.fromEntries
});
const setArbitrary = item => fc => fc.array(item(fc)).map(as => new Set(as));
const readonlySetPretty = item => set => `new Set([${Array.from(set.values()).map(a => item(a)).join(", ")}])`;
const readonlySetEquivalence = item => {
  const arrayEquivalence = array_.getEquivalence(item);
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a.values()), Array.from(b.values())));
};
const readonlySetParse = decodeUnknown => (u, options, ast) => Predicate.isSet(u) ? toComposite(decodeUnknown(Array.from(u.values()), options), as => new Set(as), ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
const setFromSelf_ = (value, description) => declare([value], {
  decode: item => readonlySetParse(ParseResult.decodeUnknown(Array$(item))),
  encode: item => readonlySetParse(ParseResult.encodeUnknown(Array$(item)))
}, {
  description,
  pretty: readonlySetPretty,
  arbitrary: setArbitrary,
  equivalence: readonlySetEquivalence
});
/**
 * @category ReadonlySet
 * @since 0.67.0
 */
const ReadonlySetFromSelf = value => setFromSelf_(value, `ReadonlySet<${format(value)}>`);
/**
 * @category Set
 * @since 0.67.0
 */
const SetFromSelf = value => setFromSelf_(value, `Set<${format(value)}>`);
/**
 * @category ReadonlySet transformations
 * @since 0.67.0
 */
const ReadonlySet = value => {
  const value_ = asSchema(value);
  return transform(Array$(value_), ReadonlySetFromSelf(typeSchema(value_)), {
    strict: true,
    decode: as => new Set(as),
    encode: set => Array.from(set)
  });
};
const set = value => {
  const value_ = asSchema(value);
  return transform(Array$(value_), SetFromSelf(typeSchema(value_)), {
    strict: true,
    decode: as => new Set(as),
    encode: set => Array.from(set)
  });
};

const bigDecimalPretty = () => val => `BigDecimal(${BigDecimal/* format */.WU(BigDecimal/* normalize */.Fv(val))})`;
const bigDecimalArbitrary = () => fc => fc.tuple(fc.bigInt(), fc.integer()).map(([value, scale]) => BigDecimal/* make */.Sy(value, scale));
/**
 * @category BigDecimal constructors
 * @since 0.67.0
 */
class BigDecimalFromSelf extends /*#__PURE__*/declare(BigDecimal/* isBigDecimal */.Hv, {
  identifier: "BigDecimalFromSelf",
  pretty: bigDecimalPretty,
  arbitrary: bigDecimalArbitrary,
  equivalence: () => BigDecimal/* Equivalence */.CZ
}) {}
/**
 * @category BigDecimal transformations
 * @since 0.67.0
 */
class Schema_BigDecimal extends /*#__PURE__*/transformOrFail(String$, BigDecimalFromSelf, {
  strict: true,
  decode: (num, _, ast) => BigDecimal/* fromString */.mL(num).pipe(esm_Option/* match */.EQ({
    onNone: () => esm_ParseResult/* fail */.bG(new esm_ParseResult/* Type */.Dy(ast, num)),
    onSome: val => esm_ParseResult/* succeed */.ng(BigDecimal/* normalize */.Fv(val))
  })),
  encode: val => esm_ParseResult/* succeed */.ng(BigDecimal/* format */.WU(BigDecimal/* normalize */.Fv(val)))
}).annotations({
  identifier: "BigDecimal"
}) {}
/**
 * A schema that transforms a `number` into a `BigDecimal`.
 * When encoding, this Schema will produce incorrect results if the BigDecimal exceeds the 64-bit range of a number.
 *
 * @category BigDecimal transformations
 * @since 0.67.0
 */
class BigDecimalFromNumber extends /*#__PURE__*/transformOrFail(Number$, BigDecimalFromSelf, {
  strict: true,
  decode: num => esm_ParseResult/* succeed */.ng(BigDecimal/* fromNumber */.xS(num)),
  encode: val => esm_ParseResult/* succeed */.ng(BigDecimal/* unsafeToNumber */.mn(val))
}).annotations({
  identifier: "BigDecimalFromNumber"
}) {}
/**
 * @category type id
 * @since 0.67.0
 */
const GreaterThanBigDecimalTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/GreaterThanBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 0.67.0
 */
const greaterThanBigDecimal = (min, annotations) => self => self.pipe(filter(a => bigDecimal_.greaterThan(a, min), {
  typeId: {
    id: GreaterThanBigDecimalTypeId,
    annotation: {
      min
    }
  },
  description: `a BigDecimal greater than ${bigDecimal_.format(min)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const GreaterThanOrEqualToBigDecimalTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/GreaterThanOrEqualToBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 0.67.0
 */
const greaterThanOrEqualToBigDecimal = (min, annotations) => self => self.pipe(filter(a => bigDecimal_.greaterThanOrEqualTo(a, min), {
  typeId: {
    id: GreaterThanOrEqualToBigDecimalTypeId,
    annotation: {
      min
    }
  },
  description: `a BigDecimal greater than or equal to ${bigDecimal_.format(min)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const LessThanBigDecimalTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/LessThanBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 0.67.0
 */
const lessThanBigDecimal = (max, annotations) => self => self.pipe(filter(a => bigDecimal_.lessThan(a, max), {
  typeId: {
    id: LessThanBigDecimalTypeId,
    annotation: {
      max
    }
  },
  description: `a BigDecimal less than ${bigDecimal_.format(max)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const LessThanOrEqualToBigDecimalTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/LessThanOrEqualToBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 0.67.0
 */
const lessThanOrEqualToBigDecimal = (max, annotations) => self => self.pipe(filter(a => bigDecimal_.lessThanOrEqualTo(a, max), {
  typeId: {
    id: LessThanOrEqualToBigDecimalTypeId,
    annotation: {
      max
    }
  },
  description: `a BigDecimal less than or equal to ${bigDecimal_.format(max)}`,
  ...annotations
}));
/**
 * @category type id
 * @since 0.67.0
 */
const PositiveBigDecimalTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/PositiveBigDecimal");
/**
 * @category BigDecimal filters
 * @since 0.67.0
 */
const positiveBigDecimal = annotations => self => self.pipe(filter(a => BigDecimal/* isPositive */.xP(a), {
  typeId: {
    id: PositiveBigDecimalTypeId,
    annotation: {}
  },
  description: `a positive BigDecimal`,
  ...annotations
}));
/**
 * @category BigDecimal constructors
 * @since 0.67.0
 */
const PositiveBigDecimalFromSelf = /*#__PURE__*/BigDecimalFromSelf.pipe( /*#__PURE__*/positiveBigDecimal({
  identifier: "PositiveBigDecimalFromSelf",
  title: "PositiveBigDecimalFromSelf"
}));
/**
 * @category type id
 * @since 0.67.0
 */
const NonNegativeBigDecimalTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/NonNegativeBigDecimal");
/**
 * @category BigDecimal filters
 * @since 0.67.0
 */
const nonNegativeBigDecimal = annotations => self => self.pipe(filter(a => a.value >= 0n, {
  typeId: {
    id: NonNegativeBigDecimalTypeId,
    annotation: {}
  },
  description: `a non-negative BigDecimal`,
  ...annotations
}));
/**
 * @category BigDecimal constructors
 * @since 0.67.0
 */
const NonNegativeBigDecimalFromSelf = /*#__PURE__*/BigDecimalFromSelf.pipe( /*#__PURE__*/nonNegativeBigDecimal({
  identifier: "NonNegativeBigDecimalFromSelf",
  title: "NonNegativeBigDecimalFromSelf"
}));
/**
 * @category type id
 * @since 0.67.0
 */
const NegativeBigDecimalTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/NegativeBigDecimal");
/**
 * @category BigDecimal filters
 * @since 0.67.0
 */
const negativeBigDecimal = annotations => self => self.pipe(filter(a => BigDecimal/* isNegative */.nM(a), {
  typeId: {
    id: NegativeBigDecimalTypeId,
    annotation: {}
  },
  description: `a negative BigDecimal`,
  ...annotations
}));
/**
 * @category BigDecimal constructors
 * @since 0.67.0
 */
const NegativeBigDecimalFromSelf = /*#__PURE__*/BigDecimalFromSelf.pipe( /*#__PURE__*/negativeBigDecimal({
  identifier: "NegativeBigDecimalFromSelf",
  title: "NegativeBigDecimalFromSelf"
}));
/**
 * @category type id
 * @since 0.67.0
 */
const NonPositiveBigDecimalTypeId = /*#__PURE__*/Symbol.for("@effect/schema/TypeId/NonPositiveBigDecimal");
/**
 * @category BigDecimal filters
 * @since 0.67.0
 */
const nonPositiveBigDecimal = annotations => self => self.pipe(filter(a => a.value <= 0n, {
  typeId: {
    id: NonPositiveBigDecimalTypeId,
    annotation: {}
  },
  description: `a non-positive BigDecimal`,
  ...annotations
}));
/**
 * @category BigDecimal constructors
 * @since 0.67.0
 */
const NonPositiveBigDecimalFromSelf = /*#__PURE__*/BigDecimalFromSelf.pipe( /*#__PURE__*/nonPositiveBigDecimal({
  identifier: "NonPositiveBigDecimalFromSelf",
  title: "NonPositiveBigDecimalFromSelf"
}));
/**
 * @category type id
 * @since 0.67.0
 */
const BetweenBigDecimalTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("@effect/schema/TypeId/BetweenBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 0.67.0
 */
const betweenBigDecimal = (minimum, maximum, annotations) => self => self.pipe(filter(a => bigDecimal_.between(a, {
  minimum,
  maximum
}), {
  typeId: {
    id: BetweenBigDecimalTypeId,
    annotation: {
      maximum,
      minimum
    }
  },
  description: `a BigDecimal between ${bigDecimal_.format(minimum)} and ${bigDecimal_.format(maximum)}`,
  ...annotations
}));
/**
 * Clamps a `BigDecimal` between a minimum and a maximum value.
 *
 * @category BigDecimal transformations
 * @since 0.67.0
 */
const clampBigDecimal = (minimum, maximum) => self => transform(self, self.pipe(typeSchema, betweenBigDecimal(minimum, maximum)), {
  strict: false,
  decode: self => bigDecimal_.clamp(self, {
    minimum,
    maximum
  }),
  encode: identity
});
const chunkArbitrary = item => fc => fc.array(item(fc)).map(chunk_.fromIterable);
const chunkPretty = item => c => `Chunk(${chunk_.toReadonlyArray(c).map(item).join(", ")})`;
const chunkParse = decodeUnknown => (u, options, ast) => chunk_.isChunk(u) ? chunk_.isEmpty(u) ? ParseResult.succeed(chunk_.empty()) : toComposite(decodeUnknown(chunk_.toReadonlyArray(u), options), chunk_.fromIterable, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Chunk
 * @since 0.67.0
 */
const ChunkFromSelf = value => {
  return declare([value], {
    decode: item => chunkParse(ParseResult.decodeUnknown(Array$(item))),
    encode: item => chunkParse(ParseResult.encodeUnknown(Array$(item)))
  }, {
    description: `Chunk<${format(value)}>`,
    pretty: chunkPretty,
    arbitrary: chunkArbitrary,
    equivalence: chunk_.getEquivalence
  });
};
/**
 * @category Chunk transformations
 * @since 0.67.0
 */
const Chunk = value => {
  const value_ = asSchema(value);
  return transform(Array$(value_), ChunkFromSelf(typeSchema(value_)), {
    strict: true,
    decode: as => as.length === 0 ? chunk_.empty() : chunk_.fromIterable(as),
    encode: chunk_.toReadonlyArray
  });
};
const nonEmptyChunkArbitrary = item => fc => fastCheck_.array(item(fc), {
  minLength: 1
}).map(as => chunk_.unsafeFromNonEmptyArray(as));
const nonEmptyChunkPretty = item => c => `NonEmptyChunk(${chunk_.toReadonlyArray(c).map(item).join(", ")})`;
const nonEmptyChunkParse = decodeUnknown => (u, options, ast) => chunk_.isChunk(u) && chunk_.isNonEmpty(u) ? toComposite(decodeUnknown(chunk_.toReadonlyArray(u), options), chunk_.unsafeFromNonEmptyArray, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Chunk
 * @since 0.67.23
 */
const NonEmptyChunkFromSelf = value => {
  return declare([value], {
    decode: item => nonEmptyChunkParse(ParseResult.decodeUnknown(NonEmptyArray(item))),
    encode: item => nonEmptyChunkParse(ParseResult.encodeUnknown(NonEmptyArray(item)))
  }, {
    description: `NonEmptyChunk<${format(value)}>`,
    pretty: nonEmptyChunkPretty,
    arbitrary: nonEmptyChunkArbitrary,
    equivalence: chunk_.getEquivalence
  });
};
/**
 * @category Chunk transformations
 * @since 0.67.23
 */
const NonEmptyChunk = value => {
  const value_ = asSchema(value);
  return transform(NonEmptyArray(value_), NonEmptyChunkFromSelf(typeSchema(value_)), {
    strict: true,
    decode: chunk_.unsafeFromNonEmptyArray,
    encode: chunk_.toReadonlyArray
  });
};
const toData = a => Array.isArray(a) ? data_.array(a) : data_.struct(a);
const dataArbitrary = item => fc => item(fc).map(toData);
const dataPretty = item => d => `Data(${item(d)})`;
const dataParse = decodeUnknown => (u, options, ast) => Equal.isEqual(u) ? toComposite(decodeUnknown(u, options), toData, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Data transformations
 * @since 0.67.0
 */
const DataFromSelf = item => declare([item], {
  decode: item => dataParse(ParseResult.decodeUnknown(item)),
  encode: item => dataParse(ParseResult.encodeUnknown(item))
}, {
  description: `Data<${format(item)}>`,
  pretty: dataPretty,
  arbitrary: dataArbitrary
});
/**
 * @category Data transformations
 * @since 0.67.0
 */
const Data = item => transform(item, DataFromSelf(typeSchema(item)), {
  strict: false,
  decode: toData,
  encode: a => Array.isArray(a) ? Array.from(a) : Object.assign({}, a)
});
const isField = u => isSchema(u) || isPropertySignature(u);
const isFields = fields => util_.ownKeys(fields).every(key => isField(fields[key]));
const getFields = hasFields => "fields" in hasFields ? hasFields.fields : getFields(hasFields[refineTypeId]);
const getSchemaFromFieldsOr = fieldsOr => isFields(fieldsOr) ? Schema_Struct(fieldsOr) : isSchema(fieldsOr) ? fieldsOr : Schema_Struct(getFields(fieldsOr));
const getFieldsFromFieldsOr = fieldsOr => isFields(fieldsOr) ? fieldsOr : getFields(fieldsOr);
/**
 * @category classes
 * @since 0.67.0
 */
const Class = identifier => (fieldsOr, annotations) => makeClass({
  kind: "Class",
  identifier,
  schema: getSchemaFromFieldsOr(fieldsOr),
  fields: getFieldsFromFieldsOr(fieldsOr),
  Base: data_.Class,
  annotations
});
/** @internal */
const getClassTag = tag => withConstructorDefault(propertySignature(Literal(tag)), () => tag);
/**
 * @category classes
 * @since 0.67.0
 */
const TaggedClass = identifier => (tag, fieldsOr, annotations) => {
  const fields = getFieldsFromFieldsOr(fieldsOr);
  const schema = getSchemaFromFieldsOr(fieldsOr);
  const newFields = {
    _tag: getClassTag(tag)
  };
  const taggedFields = extendFields(newFields, fields);
  return class TaggedClass extends makeClass({
    kind: "TaggedClass",
    identifier: identifier ?? tag,
    schema: extend(schema, Schema_Struct(newFields)),
    fields: taggedFields,
    Base: data_.Class,
    annotations
  }) {
    static _tag = tag;
  };
};
/**
 * @category classes
 * @since 0.67.0
 */
const TaggedError = identifier => (tag, fieldsOr, annotations) => {
  class Base extends data_.Error {}
  ;
  Base.prototype.name = tag;
  const fields = getFieldsFromFieldsOr(fieldsOr);
  const schema = getSchemaFromFieldsOr(fieldsOr);
  const newFields = {
    _tag: getClassTag(tag)
  };
  const taggedFields = extendFields(newFields, fields);
  return class TaggedErrorClass extends makeClass({
    kind: "TaggedError",
    identifier: identifier ?? tag,
    schema: extend(schema, Schema_Struct(newFields)),
    fields: taggedFields,
    Base,
    annotations,
    disableToString: true
  }) {
    static _tag = tag;
    get message() {
      return `{ ${util_.ownKeys(fields).map(p => `${util_.formatPropertyKey(p)}: ${util_.formatUnknown(this[p])}`).join(", ")} }`;
    }
  };
};
/**
 * @category classes
 * @since 0.67.0
 */
const TaggedRequest = identifier => (tag, Failure, Success, fields, annotations) => {
  const taggedFields = extendFields({
    _tag: getClassTag(tag)
  }, fields);
  return class TaggedRequestClass extends makeClass({
    kind: "TaggedRequest",
    identifier: identifier ?? tag,
    schema: Schema_Struct(taggedFields),
    fields: taggedFields,
    Base: Request.Class,
    annotations
  }) {
    static _tag = tag;
    get [serializable_.symbol]() {
      return this.constructor;
    }
    get [serializable_.symbolResult]() {
      return {
        Failure,
        Success
      };
    }
  };
};
const extendFields = (a, b) => {
  const out = {
    ...a
  };
  for (const key of util_.ownKeys(b)) {
    if (key in a) {
      throw new Error(errors_.getASTDuplicatePropertySignatureErrorMessage(key));
    }
    out[key] = b[key];
  }
  return out;
};
// does not overwrite existing title annotation
const orElseTitleAnnotation = (schema, title) => {
  const annotation = AST.getTitleAnnotation(schema.ast);
  if (option_.isNone(annotation)) {
    return schema.annotations({
      title
    });
  }
  return schema;
};
const getDisableValidationMakeOption = options => esm_Predicate/* isBoolean */.jn(options) ? options : options?.disableValidation ?? false;
const makeClass = ({
  Base,
  annotations,
  disableToString,
  fields,
  identifier,
  kind,
  schema
}) => {
  const classSymbol = Symbol.for(`@effect/schema/${kind}/${identifier}`);
  const validateSchema = orElseTitleAnnotation(schema, `${identifier} (Constructor)`);
  const encodedSide = orElseTitleAnnotation(schema, `${identifier} (Encoded side)`);
  const typeSide = orElseTitleAnnotation(typeSchema(schema), `${identifier} (Type side)`);
  const fallbackInstanceOf = u => Predicate.hasProperty(u, classSymbol) && ParseResult.is(typeSide)(u);
  const klass = class extends Base {
    constructor(props = {}, options = false) {
      props = {
        ...props
      };
      if (kind !== "Class") {
        delete props["_tag"];
      }
      props = lazilyMergeDefaults(fields, props);
      if (!getDisableValidationMakeOption(options)) {
        props = ParseResult.validateSync(validateSchema)(props);
      }
      super(props, true);
    }
    // ----------------
    // Schema interface
    // ----------------
    static [TypeId] = variance;
    static get ast() {
      const declaration = declare([typeSide], {
        decode: () => (input, _, ast) => input instanceof this || fallbackInstanceOf(input) ? ParseResult.succeed(input) : ParseResult.fail(new ParseResult.Type(ast, input)),
        encode: () => (input, options) => input instanceof this ? ParseResult.succeed(input) : ParseResult.map(ParseResult.encodeUnknown(typeSide)(input, options), props => new this(props, true))
      }, {
        identifier,
        title: identifier,
        description: `an instance of ${identifier}`,
        pretty: pretty => self => `${identifier}(${pretty(self)})`,
        arbitrary: arb => fc => arb(fc).map(props => new this(props)),
        equivalence: identity,
        [AST.SurrogateAnnotationId]: typeSide.ast,
        ...annotations
      });
      const transformation = transform(encodedSide, declaration, {
        strict: true,
        decode: input => new this(input, true),
        encode: identity
      }).annotations({
        [AST.SurrogateAnnotationId]: schema.ast
      });
      return transformation.ast;
    }
    static pipe() {
      return pipeArguments(this, arguments);
    }
    static annotations(annotations) {
      return Schema_make(this.ast).annotations(annotations);
    }
    static toString() {
      return `(${String(encodedSide)} <-> ${identifier})`;
    }
    // ----------------
    // Class interface
    // ----------------
    static make(...args) {
      return new this(...args);
    }
    static fields = {
      ...fields
    };
    static identifier = identifier;
    static extend(identifier) {
      return (newFieldsOr, annotations) => {
        const newFields = getFieldsFromFieldsOr(newFieldsOr);
        const newSchema = getSchemaFromFieldsOr(newFieldsOr);
        const extendedFields = extendFields(fields, newFields);
        return makeClass({
          kind,
          identifier,
          schema: extend(schema, newSchema),
          fields: extendedFields,
          Base: this,
          annotations
        });
      };
    }
    static transformOrFail(identifier) {
      return (newFields, options, annotations) => {
        const transformedFields = extendFields(fields, newFields);
        return makeClass({
          kind,
          identifier,
          schema: transformOrFail(schema, typeSchema(Schema_Struct(transformedFields)), options),
          fields: transformedFields,
          Base: this,
          annotations
        });
      };
    }
    static transformOrFailFrom(identifier) {
      return (newFields, options, annotations) => {
        const transformedFields = extendFields(fields, newFields);
        return makeClass({
          kind,
          identifier,
          schema: transformOrFail(encodedSchema(schema), Schema_Struct(transformedFields), options),
          fields: transformedFields,
          Base: this,
          annotations
        });
      };
    }
    // ----------------
    // other
    // ----------------
    get [classSymbol]() {
      return classSymbol;
    }
  };
  if (disableToString !== true) {
    Object.defineProperty(klass.prototype, "toString", {
      value() {
        return `${identifier}({ ${util_.ownKeys(fields).map(p => `${util_.formatPropertyKey(p)}: ${util_.formatUnknown(this[p])}`).join(", ")} })`;
      },
      configurable: true
    });
  }
  return klass;
};
const FiberIdNoneEncoded = /*#__PURE__*/Schema_Struct({
  _tag: Literal("None")
}).annotations({
  identifier: "FiberIdNoneEncoded"
});
const FiberIdRuntimeEncoded = /*#__PURE__*/Schema_Struct({
  _tag: Literal("Runtime"),
  id: Int.annotations({
    title: "id",
    description: "id"
  }),
  startTimeMillis: Int.annotations({
    title: "startTimeMillis",
    description: "startTimeMillis"
  })
}).annotations({
  identifier: "FiberIdRuntimeEncoded"
});
const FiberIdCompositeEncoded = /*#__PURE__*/Schema_Struct({
  _tag: Literal("Composite"),
  left: suspend(() => FiberIdEncoded),
  right: suspend(() => FiberIdEncoded)
}).annotations({
  identifier: "FiberIdCompositeEncoded"
});
const FiberIdEncoded = /*#__PURE__*/Union(FiberIdNoneEncoded, FiberIdRuntimeEncoded, FiberIdCompositeEncoded).annotations({
  identifier: "FiberIdEncoded"
});
const fiberIdArbitrary = fc => fc.letrec(tie => ({
  None: fc.record({
    _tag: fc.constant("None")
  }),
  Runtime: fc.record({
    _tag: fc.constant("Runtime"),
    id: fc.integer(),
    startTimeMillis: fc.integer()
  }),
  Composite: fc.record({
    _tag: fc.constant("Composite"),
    left: tie("FiberId"),
    right: tie("FiberId")
  }),
  FiberId: fc.oneof(tie("None"), tie("Runtime"), tie("Composite"))
})).FiberId.map(fiberIdDecode);
const fiberIdPretty = fiberId => {
  switch (fiberId._tag) {
    case "None":
      return "FiberId.none";
    case "Runtime":
      return `FiberId.runtime(${fiberId.id}, ${fiberId.startTimeMillis})`;
    case "Composite":
      return `FiberId.composite(${fiberIdPretty(fiberId.right)}, ${fiberIdPretty(fiberId.left)})`;
  }
};
/**
 * @category FiberId constructors
 * @since 0.67.0
 */
class FiberIdFromSelf extends /*#__PURE__*/declare(FiberId/* isFiberId */.ez, {
  identifier: "FiberIdFromSelf",
  pretty: () => fiberIdPretty,
  arbitrary: () => fiberIdArbitrary
}) {}
const fiberIdDecode = input => {
  switch (input._tag) {
    case "None":
      return FiberId/* none */.YP;
    case "Runtime":
      return FiberId/* runtime */.GZ(input.id, input.startTimeMillis);
    case "Composite":
      return FiberId/* composite */.h$(fiberIdDecode(input.left), fiberIdDecode(input.right));
  }
};
const fiberIdEncode = input => {
  switch (input._tag) {
    case "None":
      return {
        _tag: "None"
      };
    case "Runtime":
      return {
        _tag: "Runtime",
        id: input.id,
        startTimeMillis: input.startTimeMillis
      };
    case "Composite":
      return {
        _tag: "Composite",
        left: fiberIdEncode(input.left),
        right: fiberIdEncode(input.right)
      };
  }
};
/**
 * @category FiberId transformations
 * @since 0.67.0
 */
class Schema_FiberId extends /*#__PURE__*/transform(FiberIdEncoded, FiberIdFromSelf, {
  strict: true,
  decode: fiberIdDecode,
  encode: fiberIdEncode
}).annotations({
  identifier: "FiberId"
}) {}
const causeDieEncoded = defect => Schema_Struct({
  _tag: Literal("Die"),
  defect
});
const CauseEmptyEncoded = /*#__PURE__*/Schema_Struct({
  _tag: /*#__PURE__*/Literal("Empty")
});
const causeFailEncoded = error => Schema_Struct({
  _tag: Literal("Fail"),
  error
});
const CauseInterruptEncoded = /*#__PURE__*/Schema_Struct({
  _tag: /*#__PURE__*/Literal("Interrupt"),
  fiberId: FiberIdEncoded
});
const causeParallelEncoded = causeEncoded => Schema_Struct({
  _tag: Literal("Parallel"),
  left: causeEncoded,
  right: causeEncoded
});
const causeSequentialEncoded = causeEncoded => Schema_Struct({
  _tag: Literal("Sequential"),
  left: causeEncoded,
  right: causeEncoded
});
const causeEncoded = (error, defect) => {
  const recur = suspend(() => out);
  const out = Union(CauseEmptyEncoded, causeFailEncoded(error), causeDieEncoded(defect), CauseInterruptEncoded, causeSequentialEncoded(recur), causeParallelEncoded(recur)).annotations({
    description: `CauseEncoded<${format(error)}>`
  });
  return out;
};
const causeArbitrary = (error, defect) => fc => fc.letrec(tie => ({
  Empty: fc.record({
    _tag: fc.constant("Empty")
  }),
  Fail: fc.record({
    _tag: fc.constant("Fail"),
    error: error(fc)
  }),
  Die: fc.record({
    _tag: fc.constant("Die"),
    defect: defect(fc)
  }),
  Interrupt: fc.record({
    _tag: fc.constant("Interrupt"),
    fiberId: fiberIdArbitrary(fc)
  }),
  Sequential: fc.record({
    _tag: fc.constant("Sequential"),
    left: tie("Cause"),
    right: tie("Cause")
  }),
  Parallel: fc.record({
    _tag: fc.constant("Parallel"),
    left: tie("Cause"),
    right: tie("Cause")
  }),
  Cause: fc.oneof(tie("Empty"), tie("Fail"), tie("Die"), tie("Interrupt"), tie("Sequential"), tie("Parallel"))
})).Cause.map(causeDecode);
const causePretty = error => cause => {
  const f = cause => {
    switch (cause._tag) {
      case "Empty":
        return "Cause.empty";
      case "Fail":
        return `Cause.fail(${error(cause.error)})`;
      case "Die":
        return `Cause.die(${cause_.pretty(cause)})`;
      case "Interrupt":
        return `Cause.interrupt(${fiberIdPretty(cause.fiberId)})`;
      case "Sequential":
        return `Cause.sequential(${f(cause.left)}, ${f(cause.right)})`;
      case "Parallel":
        return `Cause.parallel(${f(cause.left)}, ${f(cause.right)})`;
    }
  };
  return f(cause);
};
const causeParse = decodeUnknown => (u, options, ast) => cause_.isCause(u) ? toComposite(decodeUnknown(causeEncode(u), options), causeDecode, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Cause transformations
 * @since 0.67.0
 */
const CauseFromSelf = ({
  defect = Unknown,
  error
}) => {
  return declare([error, defect], {
    decode: (error, defect) => causeParse(ParseResult.decodeUnknown(causeEncoded(error, defect))),
    encode: (error, defect) => causeParse(ParseResult.encodeUnknown(causeEncoded(error, defect)))
  }, {
    description: `Cause<${format(error)}>`,
    pretty: causePretty,
    arbitrary: causeArbitrary
  });
};
function causeDecode(cause) {
  switch (cause._tag) {
    case "Empty":
      return cause_.empty;
    case "Fail":
      return cause_.fail(cause.error);
    case "Die":
      return cause_.die(cause.defect);
    case "Interrupt":
      return cause_.interrupt(fiberIdDecode(cause.fiberId));
    case "Sequential":
      return cause_.sequential(causeDecode(cause.left), causeDecode(cause.right));
    case "Parallel":
      return cause_.parallel(causeDecode(cause.left), causeDecode(cause.right));
  }
}
function causeEncode(cause) {
  switch (cause._tag) {
    case "Empty":
      return {
        _tag: "Empty"
      };
    case "Fail":
      return {
        _tag: "Fail",
        error: cause.error
      };
    case "Die":
      return {
        _tag: "Die",
        defect: cause.defect
      };
    case "Interrupt":
      return {
        _tag: "Interrupt",
        fiberId: cause.fiberId
      };
    case "Sequential":
      return {
        _tag: "Sequential",
        left: causeEncode(cause.left),
        right: causeEncode(cause.right)
      };
    case "Parallel":
      return {
        _tag: "Parallel",
        left: causeEncode(cause.left),
        right: causeEncode(cause.right)
      };
  }
}
/**
 * @category Cause transformations
 * @since 0.67.0
 */
const CauseDefectUnknown = /*#__PURE__*/transform(Unknown, Unknown, {
  strict: true,
  decode: u => {
    if (esm_Predicate/* isObject */.Kn(u) && "message" in u && typeof u.message === "string") {
      const err = new Error(u.message, {
        cause: u
      });
      if ("name" in u && typeof u.name === "string") {
        err.name = u.name;
      }
      err.stack = "stack" in u && typeof u.stack === "string" ? u.stack : "";
      return err;
    }
    return String(u);
  },
  encode: defect => {
    if (defect instanceof Error) {
      return {
        name: defect.name,
        message: defect.message
      };
    }
    return String(defect);
  }
});
/**
 * @category Cause transformations
 * @since 0.67.0
 */
const Cause = ({
  defect = CauseDefectUnknown,
  error
}) => {
  const error_ = asSchema(error);
  return transform(causeEncoded(error_, defect), CauseFromSelf({
    error: typeSchema(error_),
    defect: typeSchema(defect)
  }), {
    strict: true,
    decode: causeDecode,
    encode: causeEncode
  });
};
const exitFailureEncoded = (error, defect) => Schema_Struct({
  _tag: Literal("Failure"),
  cause: causeEncoded(error, defect)
}).annotations({
  description: `FailureEncoded<${format(error)}>`
});
const exitSuccessEncoded = value => Schema_Struct({
  _tag: Literal("Success"),
  value
}).annotations({
  description: `SuccessEncoded<${format(value)}>`
});
const exitEncoded = (value, error, defect) => Union(exitFailureEncoded(error, defect), exitSuccessEncoded(value)).annotations({
  description: `ExitEncoded<${format(value)}, ${format(error)}>`
});
const exitDecode = input => {
  switch (input._tag) {
    case "Failure":
      return exit_.failCause(causeDecode(input.cause));
    case "Success":
      return exit_.succeed(input.value);
  }
};
const exitArbitrary = (value, error, defect) => fc => fc.oneof(fc.record({
  _tag: fc.constant("Failure"),
  cause: causeArbitrary(error, defect)(fc)
}), fc.record({
  _tag: fc.constant("Success"),
  value: value(fc)
})).map(exitDecode);
const exitPretty = (value, error) => exit => exit._tag === "Failure" ? `Exit.failCause(${causePretty(error)(exit.cause)})` : `Exit.succeed(${value(exit.value)})`;
const exitParse = (decodeUnknownValue, decodeUnknownCause) => (u, options, ast) => exit_.isExit(u) ? exit_.match(u, {
  onFailure: cause => toComposite(decodeUnknownCause(cause, options), exit_.failCause, ast, u),
  onSuccess: value => toComposite(decodeUnknownValue(value, options), exit_.succeed, ast, u)
}) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Exit transformations
 * @since 0.67.0
 */
const ExitFromSelf = ({
  defect = Unknown,
  failure,
  success
}) => declare([success, failure, defect], {
  decode: (success, failure, defect) => exitParse(ParseResult.decodeUnknown(success), ParseResult.decodeUnknown(CauseFromSelf({
    error: failure,
    defect
  }))),
  encode: (success, failure, defect) => exitParse(ParseResult.encodeUnknown(success), ParseResult.encodeUnknown(CauseFromSelf({
    error: failure,
    defect
  })))
}, {
  description: `Exit<${format(success)}, ${format(failure)}>`,
  pretty: exitPretty,
  arbitrary: exitArbitrary
});
/**
 * @category Exit transformations
 * @since 0.67.0
 */
const Exit = ({
  defect = CauseDefectUnknown,
  failure,
  success
}) => {
  const success_ = asSchema(success);
  const failure_ = asSchema(failure);
  return transform(exitEncoded(success_, failure_, defect), ExitFromSelf({
    failure: typeSchema(failure_),
    success: typeSchema(success_),
    defect: typeSchema(defect)
  }), {
    strict: true,
    decode: exitDecode,
    encode: exit => exit._tag === "Failure" ? {
      _tag: "Failure",
      cause: exit.cause
    } : {
      _tag: "Success",
      value: exit.value
    }
  });
};
const hashSetArbitrary = item => fc => fc.array(item(fc)).map(as => hashSet_.fromIterable(as));
const hashSetPretty = item => set => `HashSet(${Array.from(set).map(a => item(a)).join(", ")})`;
const hashSetEquivalence = item => {
  const arrayEquivalence = array_.getEquivalence(item);
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a), Array.from(b)));
};
const hashSetParse = decodeUnknown => (u, options, ast) => hashSet_.isHashSet(u) ? toComposite(decodeUnknown(Array.from(u), options), hashSet_.fromIterable, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category HashSet transformations
 * @since 0.67.0
 */
const HashSetFromSelf = value => {
  return declare([value], {
    decode: item => hashSetParse(ParseResult.decodeUnknown(Array$(item))),
    encode: item => hashSetParse(ParseResult.encodeUnknown(Array$(item)))
  }, {
    description: `HashSet<${format(value)}>`,
    pretty: hashSetPretty,
    arbitrary: hashSetArbitrary,
    equivalence: hashSetEquivalence
  });
};
/**
 * @category HashSet transformations
 * @since 0.67.0
 */
const HashSet = value => {
  const value_ = asSchema(value);
  return transform(Array$(value_), HashSetFromSelf(typeSchema(value_)), {
    strict: true,
    decode: as => hashSet_.fromIterable(as),
    encode: set => Array.from(set)
  });
};
const hashMapArbitrary = (key, value) => fc => fc.array(fc.tuple(key(fc), value(fc))).map(as => hashMap_.fromIterable(as));
const hashMapPretty = (key, value) => map => `HashMap([${Array.from(map).map(([k, v]) => `[${key(k)}, ${value(v)}]`).join(", ")}])`;
const hashMapEquivalence = (key, value) => {
  const arrayEquivalence = array_.getEquivalence(Equivalence.make(([ka, va], [kb, vb]) => key(ka, kb) && value(va, vb)));
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a), Array.from(b)));
};
const hashMapParse = decodeUnknown => (u, options, ast) => hashMap_.isHashMap(u) ? toComposite(decodeUnknown(Array.from(u), options), hashMap_.fromIterable, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category HashMap transformations
 * @since 0.67.0
 */
const HashMapFromSelf = ({
  key,
  value
}) => {
  return declare([key, value], {
    decode: (key, value) => hashMapParse(ParseResult.decodeUnknown(Array$(Tuple(key, value)))),
    encode: (key, value) => hashMapParse(ParseResult.encodeUnknown(Array$(Tuple(key, value))))
  }, {
    description: `HashMap<${format(key)}, ${format(value)}>`,
    pretty: hashMapPretty,
    arbitrary: hashMapArbitrary,
    equivalence: hashMapEquivalence
  });
};
/**
 * @category HashMap transformations
 * @since 0.67.0
 */
const HashMap = ({
  key,
  value
}) => {
  const key_ = asSchema(key);
  const value_ = asSchema(value);
  return transform(Array$(Tuple(key_, value_)), HashMapFromSelf({
    key: typeSchema(key_),
    value: typeSchema(value_)
  }), {
    strict: true,
    decode: as => hashMap_.fromIterable(as),
    encode: map => Array.from(map)
  });
};
const listArbitrary = item => fc => fc.array(item(fc)).map(as => list_.fromIterable(as));
const listPretty = item => set => `List(${Array.from(set).map(a => item(a)).join(", ")})`;
const listEquivalence = item => {
  const arrayEquivalence = array_.getEquivalence(item);
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a), Array.from(b)));
};
const listParse = decodeUnknown => (u, options, ast) => list_.isList(u) ? toComposite(decodeUnknown(Array.from(u), options), list_.fromIterable, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category List transformations
 * @since 0.67.0
 */
const ListFromSelf = value => {
  return declare([value], {
    decode: item => listParse(ParseResult.decodeUnknown(Array$(item))),
    encode: item => listParse(ParseResult.encodeUnknown(Array$(item)))
  }, {
    description: `List<${format(value)}>`,
    pretty: listPretty,
    arbitrary: listArbitrary,
    equivalence: listEquivalence
  });
};
/**
 * @category List transformations
 * @since 0.67.0
 */
const List = value => {
  const value_ = asSchema(value);
  return transform(Array$(value_), ListFromSelf(typeSchema(value_)), {
    strict: true,
    decode: as => list_.fromIterable(as),
    encode: set => Array.from(set)
  });
};
const sortedSetArbitrary = (item, ord) => fc => fc.array(item(fc)).map(as => sortedSet_.fromIterable(as, ord));
const sortedSetPretty = item => set => `new SortedSet([${Array.from(sortedSet_.values(set)).map(a => item(a)).join(", ")}])`;
const sortedSetParse = (decodeUnknown, ord) => (u, options, ast) => sortedSet_.isSortedSet(u) ? toComposite(decodeUnknown(Array.from(sortedSet_.values(u)), options), as => sortedSet_.fromIterable(as, ord), ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category SortedSet transformations
 * @since 0.67.0
 */
const SortedSetFromSelf = (value, ordA, ordI) => {
  return declare([value], {
    decode: item => sortedSetParse(ParseResult.decodeUnknown(Array$(item)), ordA),
    encode: item => sortedSetParse(ParseResult.encodeUnknown(Array$(item)), ordI)
  }, {
    description: `SortedSet<${format(value)}>`,
    pretty: sortedSetPretty,
    arbitrary: arb => sortedSetArbitrary(arb, ordA),
    equivalence: () => sortedSet_.getEquivalence()
  });
};
/**
 * @category SortedSet transformations
 * @since 0.67.0
 */
const SortedSet = (value, ordA) => {
  const value_ = asSchema(value);
  const to = typeSchema(value_);
  return transform(Array$(value_), SortedSetFromSelf(to, ordA, ordA), {
    strict: true,
    decode: as => sortedSet_.fromIterable(as, ordA),
    encode: set => Array.from(sortedSet_.values(set))
  });
};
/**
 * Converts an arbitrary value to a `boolean` by testing whether it is truthy.
 * Uses `!!val` to coerce the value to a `boolean`.
 *
 * @see https://developer.mozilla.org/docs/Glossary/Truthy
 * @category boolean constructors
 * @since 0.67.0
 */
class BooleanFromUnknown extends /*#__PURE__*/transform(Unknown, Boolean$, {
  strict: true,
  decode: esm_Predicate/* isTruthy */.fQ,
  encode: Function/* identity */.yR
}).annotations({
  identifier: "BooleanFromUnknown"
}) {}
/**
 * @category Config validations
 * @since 0.67.12
 */
const Config = (name, schema) => {
  const decodeEither_ = decodeEither(schema);
  return config_.string(name).pipe(config_.mapOrFail(a => decodeEither_(a).pipe(either_.mapLeft(error => configError_.InvalidData([], TreeFormatter.formatErrorSync(error))))));
};
//# sourceMappingURL=Schema.js.map

/***/ }),

/***/ 69790:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AU": function() { return /* binding */ getPrettyMissingAnnotationErrorMessage; },
/* harmony export */   "D_": function() { return /* binding */ getPrettyNeverErrorMessage; },
/* harmony export */   "FA": function() { return /* binding */ getASTDuplicateIndexSignatureErrorMessage; },
/* harmony export */   "H7": function() { return /* binding */ getASTDuplicatePropertySignatureErrorMessage; },
/* harmony export */   "Iy": function() { return /* binding */ getASTRequiredElementFollowinAnOptionalElementErrorMessage; },
/* harmony export */   "PG": function() { return /* binding */ getASTIndexSignatureParameterErrorMessage; },
/* harmony export */   "Zb": function() { return /* binding */ getASTUnsupportedKeySchema; },
/* harmony export */   "Zo": function() { return /* binding */ getASTDuplicatePropertySignatureTransformationErrorMessage; },
/* harmony export */   "a_": function() { return /* binding */ getASTUnsupportedLiteral; },
/* harmony export */   "yd": function() { return /* binding */ getPrettyNoMatchingSchemaErrorMessage; }
/* harmony export */ });
/* unused harmony exports getInvalidArgumentErrorMessage, getArbitraryUnsupportedErrorMessage, getArbitraryMissingAnnotationErrorMessage, getArbitraryEmptyEnumErrorMessage, getEquivalenceUnsupportedErrorMessage, getJSONSchemaMissingAnnotationErrorMessage, getJSONSchemaMissingIdentifierAnnotationErrorMessage, getJSONSchemaUnsupportedParameterErrorMessage, getJSONSchemaUnsupportedPostRestElementsErrorMessage, getJSONSchemaUnsupportedKeyErrorMessage, getSchemaExtendErrorMessage, getSchemaUnsupportedLiteralSpanErrorMessage, getASTUnsupportedSchema, getASTUnsupportedRenameSchema */
/* harmony import */ var effect_Array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37901);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7677);


const getErrorMessage = (reason, details, path, ast) => {
  let out = reason;
  if (path && effect_Array__WEBPACK_IMPORTED_MODULE_0__/* .isNonEmptyReadonlyArray */ .Ux(path)) {
    out += `\nat path: ${_util_js__WEBPACK_IMPORTED_MODULE_1__/* .formatPath */ .dI(path)}`;
  }
  if (details !== undefined) {
    out += `\ndetails: ${details}`;
  }
  if (ast) {
    out += `\nschema (${ast._tag}): ${ast}`;
  }
  return out;
};
// ---------------------------------------------
// generic
// ---------------------------------------------
/** @internal */
const getInvalidArgumentErrorMessage = details => getErrorMessage("Invalid Argument", details);
const getUnsupportedSchemaErrorMessage = (details, path, ast) => getErrorMessage("Unsupported schema", details, path, ast);
const getMissingAnnotationErrorMessage = (details, path, ast) => getErrorMessage("Missing annotation", details, path, ast);
// ---------------------------------------------
// Arbitrary
// ---------------------------------------------
/** @internal */
const getArbitraryUnsupportedErrorMessage = (path, ast) => getUnsupportedSchemaErrorMessage("Cannot build an Arbitrary for this schema", path, ast);
/** @internal */
const getArbitraryMissingAnnotationErrorMessage = (path, ast) => getMissingAnnotationErrorMessage(`Generating an Arbitrary for this schema requires an "arbitrary" annotation`, path, ast);
/** @internal */
const getArbitraryEmptyEnumErrorMessage = path => getErrorMessage("Empty Enums schema", "Generating an Arbitrary for this schema requires at least one enum", path);
// ---------------------------------------------
// Equivalence
// ---------------------------------------------
/** @internal */
const getEquivalenceUnsupportedErrorMessage = (ast, path) => getUnsupportedSchemaErrorMessage("Cannot build an Equivalence", path, ast);
// ---------------------------------------------
// JSON Schema
// ---------------------------------------------
/** @internal */
const getJSONSchemaMissingAnnotationErrorMessage = (path, ast) => getMissingAnnotationErrorMessage(`Generating a JSON Schema for this schema requires a "jsonSchema" annotation`, path, ast);
/** @internal */
const getJSONSchemaMissingIdentifierAnnotationErrorMessage = (path, ast) => getMissingAnnotationErrorMessage(`Generating a JSON Schema for this schema requires an "identifier" annotation`, path, ast);
/** @internal */
const getJSONSchemaUnsupportedParameterErrorMessage = (path, parameter) => getErrorMessage("Unsupported index signature parameter", undefined, path, parameter);
/** @internal */
const getJSONSchemaUnsupportedPostRestElementsErrorMessage = path => getErrorMessage("Generating a JSON Schema for post-rest elements is not currently supported. You're welcome to contribute by submitting a Pull Request", undefined, path);
/** @internal */
const getJSONSchemaUnsupportedKeyErrorMessage = (key, path) => getErrorMessage("Unsupported key", `Cannot encode ${util_.formatPropertyKey(key)} key to JSON Schema`, path);
// ---------------------------------------------
// Pretty
// ---------------------------------------------
/** @internal */
const getPrettyMissingAnnotationErrorMessage = (path, ast) => getMissingAnnotationErrorMessage(`Generating a Pretty for this schema requires a "pretty" annotation`, path, ast);
/** @internal */
const getPrettyNeverErrorMessage = "Cannot pretty print a `never` value";
/** @internal */
const getPrettyNoMatchingSchemaErrorMessage = (actual, path, ast) => getErrorMessage("Unexpected Error", `Cannot find a matching schema for ${_util_js__WEBPACK_IMPORTED_MODULE_1__/* .formatUnknown */ .cT(actual)}`, path, ast);
// ---------------------------------------------
// Schema
// ---------------------------------------------
/** @internal */
const getSchemaExtendErrorMessage = (x, y, path) => getErrorMessage("Unsupported schema or overlapping types", `cannot extend ${x} with ${y}`, path);
/** @internal */
const getSchemaUnsupportedLiteralSpanErrorMessage = ast => getErrorMessage("Unsupported template literal span", undefined, undefined, ast);
// ---------------------------------------------
// AST
// ---------------------------------------------
/** @internal */
const getASTUnsupportedSchema = ast => getUnsupportedSchemaErrorMessage(undefined, undefined, ast);
/** @internal */
const getASTUnsupportedKeySchema = ast => getErrorMessage("Unsupported key schema", undefined, undefined, ast);
/** @internal */
const getASTUnsupportedLiteral = literal => getErrorMessage("Unsupported literal", `literal value: ${_util_js__WEBPACK_IMPORTED_MODULE_1__/* .formatUnknown */ .cT(literal)}`);
/** @internal */
const getASTDuplicateIndexSignatureErrorMessage = type => getErrorMessage("Duplicate index signature", `${type} index signature`);
/** @internal */
const getASTIndexSignatureParameterErrorMessage = /*#__PURE__*/getErrorMessage("Unsupported index signature parameter", "An index signature parameter type must be `string`, `symbol`, a template literal type or a refinement of the previous types");
/** @internal */
const getASTRequiredElementFollowinAnOptionalElementErrorMessage = /*#__PURE__*/getErrorMessage("Invalid element", "A required element cannot follow an optional element. ts(1257)");
/** @internal */
const getASTDuplicatePropertySignatureTransformationErrorMessage = key => getErrorMessage("Duplicate property signature transformation", `Duplicate key ${_util_js__WEBPACK_IMPORTED_MODULE_1__/* .formatUnknown */ .cT(key)}`);
/** @internal */
const getASTUnsupportedRenameSchema = ast => getUnsupportedSchemaErrorMessage(undefined, undefined, ast);
/** @internal */
const getASTDuplicatePropertySignatureErrorMessage = key => getErrorMessage("Duplicate property signature", `Duplicate key ${_util_js__WEBPACK_IMPORTED_MODULE_1__/* .formatUnknown */ .cT(key)}`);
//# sourceMappingURL=errors.js.map

/***/ }),

/***/ 7677:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AH": function() { return /* binding */ formatPropertyKey; },
/* harmony export */   "Od": function() { return /* binding */ isNonEmpty; },
/* harmony export */   "U7": function() { return /* binding */ isSingle; },
/* harmony export */   "Wp": function() { return /* binding */ ownKeys; },
/* harmony export */   "cT": function() { return /* binding */ formatUnknown; },
/* harmony export */   "d3": function() { return /* binding */ memoizeThunk; },
/* harmony export */   "dI": function() { return /* binding */ formatPath; },
/* harmony export */   "k8": function() { return /* binding */ getKeysForIndexSignature; }
/* harmony export */ });
/* unused harmony export formatPathKey */
/* harmony import */ var effect_Array__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37901);
/* harmony import */ var effect_Predicate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71335);


/** @internal */
const getKeysForIndexSignature = (input, parameter) => {
  switch (parameter._tag) {
    case "StringKeyword":
    case "TemplateLiteral":
      return Object.keys(input);
    case "SymbolKeyword":
      return Object.getOwnPropertySymbols(input);
    case "Refinement":
      return getKeysForIndexSignature(input, parameter.from);
  }
};
/** @internal */
const ownKeys = o => Object.keys(o).concat(Object.getOwnPropertySymbols(o));
/** @internal */
const memoizeThunk = f => {
  let done = false;
  let a;
  return () => {
    if (done) {
      return a;
    }
    a = f();
    done = true;
    return a;
  };
};
/** @internal */
const formatUnknown = u => {
  if (effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD(u)) {
    return JSON.stringify(u);
  } else if (effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj(u) || u == null || effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isBoolean */ .jn(u) || effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isSymbol */ .yk(u) || effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isDate */ .J_(u)) {
    return String(u);
  } else if (effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isBigInt */ .C4(u)) {
    return String(u) + "n";
  } else if (!effect_Array__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .kJ(u) && effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .hasProperty */ .l$(u, "toString") && effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .mf(u["toString"]) && u["toString"] !== Object.prototype.toString) {
    return u["toString"]();
  }
  try {
    JSON.stringify(u);
    if (effect_Array__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .kJ(u)) {
      return `[${u.map(formatUnknown).join(",")}]`;
    } else {
      return `{${ownKeys(u).map(k => `${effect_Predicate__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD(k) ? JSON.stringify(k) : String(k)}:${formatUnknown(u[k])}`).join(",")}}`;
    }
  } catch (e) {
    return String(u);
  }
};
/** @internal */
const formatPropertyKey = name => typeof name === "string" ? JSON.stringify(name) : String(name);
/** @internal */
const isNonEmpty = x => Array.isArray(x);
/** @internal */
const isSingle = x => !Array.isArray(x);
/** @internal */
const formatPathKey = key => `[${formatPropertyKey(key)}]`;
/** @internal */
const formatPath = path => isNonEmpty(path) ? path.map(formatPathKey).join("") : formatPathKey(path);
//# sourceMappingURL=util.js.map

/***/ }),

/***/ 8713:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EM": function() { return /* binding */ makeWalletFromSeed; },
/* harmony export */   "Iy": function() { return /* binding */ makeWalletFromAddress; },
/* harmony export */   "J9": function() { return /* binding */ makeWalletFromPrivateKey; },
/* harmony export */   "aZ": function() { return /* binding */ makeWalletFromAPI; }
/* harmony export */ });
/* unused harmony exports discoverOwnUsedTxKeyHashes, walletFromSeed */
/* harmony import */ var _lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87830);
/* harmony import */ var _lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34837);
/* harmony import */ var _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82381);
/* harmony import */ var bip39__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2153);
/* harmony import */ var _lucid_evolution_sign_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48415);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__, _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__, _lucid_evolution_sign_data__WEBPACK_IMPORTED_MODULE_4__]);
([_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__, _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__, _lucid_evolution_sign_data__WEBPACK_IMPORTED_MODULE_4__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
// src/wallet.ts



// src/core.ts


// src/wallet.ts

function walletFromSeed(seed, options = {}) {
  const {
    addressType = "Base",
    accountIndex = 0,
    network = "Mainnet"
  } = options;
  function harden(num) {
    if (typeof num !== "number") throw new Error("Type number required here!");
    return 2147483648 + num;
  }
  const entropy = (0,bip39__WEBPACK_IMPORTED_MODULE_3__/* .mnemonicToEntropy */ .oy)(seed);
  const rootKey = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Bip32PrivateKey.from_bip39_entropy */ .BSq.from_bip39_entropy(
    (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(entropy),
    options?.password ? new TextEncoder().encode(options.password) : new Uint8Array()
  );
  const accountKey = rootKey.derive(harden(1852)).derive(harden(1815)).derive(harden(accountIndex));
  rootKey.free();
  const paymentKey = accountKey.derive(0).derive(0).to_raw_key();
  const stakeKey = accountKey.derive(2).derive(0).to_raw_key();
  const paymentKeyHash = paymentKey.to_public().hash();
  const stakeKeyHash = stakeKey.to_public().hash();
  const networkId = network === "Mainnet" ? 1 : 0;
  const address = addressType === "Base" ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .BaseAddress["new"] */ .pv["new"](
    networkId,
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Credential.new_pub_key */ .hJE.new_pub_key(paymentKeyHash),
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Credential.new_pub_key */ .hJE.new_pub_key(stakeKeyHash)
  ).to_address().to_bech32(void 0) : _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .EnterpriseAddress["new"] */ .Z0E["new"](
    networkId,
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Credential.new_pub_key */ .hJE.new_pub_key(paymentKeyHash)
  ).to_address().to_bech32(void 0);
  const rewardAddress = addressType === "Base" ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .RewardAddress["new"] */ .mf5["new"](
    networkId,
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Credential.new_pub_key */ .hJE.new_pub_key(stakeKeyHash)
  ).to_address().to_bech32(void 0) : null;
  return {
    address,
    rewardAddress,
    paymentKey: paymentKey.to_bech32(),
    stakeKey: addressType === "Base" ? stakeKey.to_bech32() : null
  };
}
function discoverOwnUsedTxKeyHashes(tx, ownKeyHashes, ownUtxos) {
  const usedKeyHashes = [];
  const inputs = tx.body().inputs();
  for (let i = 0; i < inputs.len(); i++) {
    const input = inputs.get(i);
    const txHash = input.transaction_id().to_hex();
    const outputIndex = Number(input.index());
    const utxo = ownUtxos.find(
      (utxo2) => utxo2.txHash === txHash && utxo2.outputIndex === outputIndex
    );
    if (utxo) {
      const { paymentCredential } = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAddressDetails */ .IL)(utxo.address);
      usedKeyHashes.push(paymentCredential?.hash);
    }
  }
  const txBody = tx.body();
  function keyHashFromCert(txBody2) {
    const certs = txBody2.certs();
    if (!certs) return;
    for (let i = 0; i < certs.len(); i++) {
      const cert = certs.get(i);
      switch (cert.kind()) {
        case 0:
          break;
        case 1: {
          const credential = cert.as_stake_deregistration()?.stake_credential();
          switch (credential?.kind()) {
            case 0:
              usedKeyHashes.push(credential.as_pub_key()?.to_hex());
              break;
            case 1:
              usedKeyHashes.push(credential.as_script()?.to_hex());
              break;
          }
          break;
        }
        case 2: {
          const credential = cert.as_stake_delegation()?.stake_credential();
          if (credential?.kind() === 0) {
            const keyHash = credential.as_pub_key()?.to_hex();
            usedKeyHashes.push(keyHash);
          }
          break;
        }
        case 3: {
          const poolParams = cert.as_pool_registration()?.pool_params();
          const owners = poolParams?.pool_owners();
          if (!owners) break;
          for (let i2 = 0; i2 < owners.len(); i2++) {
            const keyHash = owners.get(i2).to_hex();
            usedKeyHashes.push(keyHash);
          }
          const operator = poolParams.operator().to_hex();
          usedKeyHashes.push(operator);
          break;
        }
        case 4: {
          const operator = cert.as_pool_retirement()?.pool().to_hex();
          usedKeyHashes.push(operator);
          break;
        }
        case 6: {
          const credential = cert.as_unreg_cert()?.stake_credential();
          if (credential) {
            usedKeyHashes.push(credential.as_pub_key()?.to_hex());
          }
          break;
        }
        case 7: {
          const credential = cert.as_vote_deleg_cert()?.stake_credential();
          if (credential) {
            usedKeyHashes.push(credential.as_pub_key()?.to_hex());
          }
          break;
        }
        case 8: {
          const credential = cert.as_stake_vote_deleg_cert()?.stake_credential();
          if (credential) {
            usedKeyHashes.push(credential.as_pub_key()?.to_hex());
          }
          break;
        }
        case 9: {
          const credential = cert.as_stake_reg_deleg_cert()?.stake_credential();
          if (credential) {
            usedKeyHashes.push(credential.as_pub_key()?.to_hex());
          }
          break;
        }
        case 10: {
          const credential = cert.as_vote_reg_deleg_cert()?.stake_credential();
          if (credential) {
            usedKeyHashes.push(credential.as_pub_key()?.to_hex());
          }
          break;
        }
        case 11: {
          const credential = cert.as_stake_vote_reg_deleg_cert()?.stake_credential();
          if (credential) {
            usedKeyHashes.push(credential.as_pub_key()?.to_hex());
          }
          break;
        }
        case 12: {
          const credential = cert.as_auth_committee_hot_cert()?.committee_cold_credential();
          if (credential) {
            usedKeyHashes.push(credential.as_pub_key()?.to_hex());
          }
          break;
        }
        case 13: {
          const credential = cert.as_resign_committee_cold_cert()?.committee_cold_credential();
          if (credential) {
            usedKeyHashes.push(credential.as_pub_key()?.to_hex());
          }
          break;
        }
        case 14: {
          const credential = cert.as_reg_drep_cert()?.drep_credential();
          if (credential) {
            usedKeyHashes.push(credential.as_pub_key()?.to_hex());
          }
          break;
        }
        case 15: {
          const credential = cert.as_unreg_drep_cert()?.drep_credential();
          if (credential) {
            usedKeyHashes.push(credential.as_pub_key()?.to_hex());
          }
          break;
        }
        case 16: {
          const credential = cert.as_update_drep_cert()?.drep_credential();
          if (credential) {
            usedKeyHashes.push(credential.as_pub_key()?.to_hex());
          }
          break;
        }
        default:
          break;
      }
    }
  }
  if (txBody.certs()) keyHashFromCert(txBody);
  const withdrawals = txBody.withdrawals();
  function keyHashFromWithdrawal(withdrawals2) {
    const rewardAddresses = withdrawals2.keys();
    for (let i = 0; i < rewardAddresses.len(); i++) {
      const credential = rewardAddresses.get(i).payment();
      switch (credential.kind()) {
        case 0:
          usedKeyHashes.push(credential.as_pub_key()?.to_hex());
          break;
        case 1:
          usedKeyHashes.push(credential.as_script()?.to_hex());
          break;
      }
    }
  }
  if (withdrawals) keyHashFromWithdrawal(withdrawals);
  const scripts = tx.witness_set().native_scripts();
  function keyHashFromScript(scripts2) {
    for (let i = 0; i < scripts2.len(); i++) {
      const script = scripts2.get(i);
      if (script.kind() === 0) {
        const keyHash = script.as_script_pubkey()?.ed25519_key_hash().to_hex();
        usedKeyHashes.push(keyHash);
      }
      if (script.kind() === 1) {
        keyHashFromScript(script.as_script_all().native_scripts());
        return;
      }
      if (script.kind() === 2) {
        keyHashFromScript(script.as_script_any().native_scripts());
        return;
      }
      if (script.kind() === 3) {
        keyHashFromScript(script.as_script_n_of_k().native_scripts());
        return;
      }
    }
  }
  if (scripts) keyHashFromScript(scripts);
  const requiredSigners = txBody.required_signers();
  if (requiredSigners) {
    for (let i = 0; i < requiredSigners.len(); i++) {
      usedKeyHashes.push(requiredSigners.get(i).to_hex());
    }
  }
  const collateral = txBody.collateral_inputs();
  if (collateral) {
    for (let i = 0; i < collateral.len(); i++) {
      const input = collateral.get(i);
      const txHash = input.transaction_id().to_hex();
      const outputIndex = Number(input.index());
      const utxo = ownUtxos.find(
        (utxo2) => utxo2.txHash === txHash && utxo2.outputIndex === outputIndex
      );
      if (utxo) {
        const { paymentCredential } = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAddressDetails */ .IL)(utxo.address);
        usedKeyHashes.push(paymentCredential?.hash);
      }
    }
  }
  return usedKeyHashes.filter((k) => ownKeyHashes.includes(k));
}

// src/wallet_selection.ts



var makeWalletFromSeed = (provider, network, seed, options) => {
  const config = {
    overriddenUTxOs: []
  };
  const { address, rewardAddress, paymentKey, stakeKey } = walletFromSeed(
    seed,
    {
      addressType: options?.addressType || "Base",
      accountIndex: options?.accountIndex || 0,
      password: options?.password,
      network
    }
  );
  const paymentKeyHash = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .PrivateKey.from_bech32 */ ._q4.from_bech32(paymentKey).to_public().hash().to_hex();
  const stakeKeyHash = stakeKey ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .PrivateKey.from_bech32 */ ._q4.from_bech32(stakeKey).to_public().hash().to_hex() : "";
  const privKeyHashMap = {
    [paymentKeyHash]: paymentKey,
    [stakeKeyHash]: stakeKey
  };
  return {
    overrideUTxOs: (utxos) => config.overriddenUTxOs = utxos,
    address: async () => address,
    rewardAddress: async () => rewardAddress || null,
    getUtxos: async () => config.overriddenUTxOs.length > 0 ? config.overriddenUTxOs : provider.getUtxos(address),
    getUtxosCore: async () => {
      const utxos = config.overriddenUTxOs.length > 0 ? config.overriddenUTxOs : await provider.getUtxos(address);
      const coreUtxos = [];
      for (const utxo of utxos) {
        coreUtxos.push((0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__/* .utxoToCore */ .Sw)(utxo));
      }
      return coreUtxos;
    },
    getDelegation: async () => {
      return rewardAddress ? await provider.getDelegation(rewardAddress) : { poolId: null, rewards: 0n };
    },
    signTx: async (tx) => {
      const utxos = config.overriddenUTxOs.length > 0 ? config.overriddenUTxOs : await provider.getUtxos(address);
      const ownKeyHashes = [paymentKeyHash, stakeKeyHash];
      const usedKeyHashes = discoverOwnUsedTxKeyHashes(tx, ownKeyHashes, utxos);
      const txWitnessSetBuilder = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .TransactionWitnessSetBuilder["new"] */ .S__["new"]();
      for (const keyHash of usedKeyHashes) {
        const priv = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .PrivateKey.from_bech32 */ ._q4.from_bech32(privKeyHashMap[keyHash]);
        const witness = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .make_vkey_witness */ .i4D(
          _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .hash_transaction */ .o28(tx.body()),
          priv
        );
        txWitnessSetBuilder.add_vkey(witness);
      }
      return txWitnessSetBuilder.build();
    },
    signMessage: async (address2, payload) => {
      const {
        paymentCredential,
        stakeCredential,
        address: { hex: hexAddress }
      } = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAddressDetails */ .IL)(address2);
      const keyHash = paymentCredential?.hash || stakeCredential?.hash;
      const privateKey = privKeyHashMap[keyHash];
      if (!privateKey) {
        throw new Error(`Cannot sign message for address: ${address2}.`);
      }
      return (0,_lucid_evolution_sign_data__WEBPACK_IMPORTED_MODULE_4__/* .signData */ .r)(hexAddress, payload, privateKey);
    },
    submitTx: async (tx) => provider.submitTx(tx)
  };
};
var makeWalletFromPrivateKey = (provider, network, privateKey) => {
  const priv = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .PrivateKey.from_bech32 */ ._q4.from_bech32(privateKey);
  const pubKeyHash = priv.to_public().hash();
  const address = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .EnterpriseAddress["new"] */ .Z0E["new"](
    network === "Mainnet" ? 1 : 0,
    _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Credential.new_pub_key */ .hJE.new_pub_key(pubKeyHash)
  ).to_address().to_bech32(void 0);
  const config = {
    overriddenUTxOs: []
  };
  return {
    overrideUTxOs: (utxos) => config.overriddenUTxOs = utxos,
    address: async () => address,
    rewardAddress: async () => null,
    getUtxos: async () => config.overriddenUTxOs.length > 0 ? config.overriddenUTxOs : provider.getUtxos(address),
    getUtxosCore: async () => {
      const utxos = config.overriddenUTxOs.length > 0 ? config.overriddenUTxOs : await provider.getUtxos(address);
      const coreUtxos = [];
      for (const utxo of utxos) {
        coreUtxos.push((0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__/* .utxoToCore */ .Sw)(utxo));
      }
      return coreUtxos;
    },
    getDelegation: async () => {
      return { poolId: null, rewards: 0n };
    },
    signTx: async (tx) => {
      const witness = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .make_vkey_witness */ .i4D(
        _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .hash_transaction */ .o28(tx.body()),
        priv
      );
      const txWitnessSetBuilder = _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .TransactionWitnessSetBuilder["new"] */ .S__["new"]();
      txWitnessSetBuilder.add_vkey(witness);
      return txWitnessSetBuilder.build();
    },
    signMessage: async (address2, payload) => {
      const {
        paymentCredential,
        address: { hex: hexAddress }
      } = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAddressDetails */ .IL)(address2);
      const keyHash = paymentCredential?.hash;
      const originalKeyHash = pubKeyHash.to_hex();
      if (!keyHash || keyHash !== originalKeyHash) {
        throw new Error(`Cannot sign message for address: ${address2}.`);
      }
      return (0,_lucid_evolution_sign_data__WEBPACK_IMPORTED_MODULE_4__/* .signData */ .r)(hexAddress, payload, privateKey);
    },
    submitTx: async (tx) => {
      return await provider.submitTx(tx);
    }
  };
};
var makeWalletFromAPI = (provider, api) => {
  const config = {
    overriddenUTxOs: []
  };
  const getAddressHex = async () => {
    const [addressHex] = await api.getUsedAddresses();
    if (addressHex) return addressHex;
    const [unusedAddressHex] = await api.getUnusedAddresses();
    return unusedAddressHex;
  };
  const getRewardAddress = async () => {
    const [rewardAddressHex] = await api.getRewardAddresses();
    const rewardAddress = rewardAddressHex ? _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .RewardAddress.from_address */ .mf5.from_address(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Address.from_hex */ .kLt.from_hex(rewardAddressHex)).to_address().to_bech32(void 0) : null;
    return rewardAddress;
  };
  return {
    overrideUTxOs: (utxos) => config.overriddenUTxOs = utxos,
    address: async () => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Address.from_hex */ .kLt.from_hex(await getAddressHex()).to_bech32(void 0),
    rewardAddress: async () => getRewardAddress(),
    getUtxos: async () => {
      const utxos = config.overriddenUTxOs.length > 0 ? config.overriddenUTxOs : (await api.getUtxos() || []).map(
        (utxo) => (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__/* .coreToUtxo */ .lo)(
          _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .TransactionUnspentOutput.from_cbor_bytes */ .ZAD.from_cbor_bytes((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromHex */ .H_)(utxo))
        )
      );
      return utxos;
    },
    getUtxosCore: async () => {
      const utxos = config.overriddenUTxOs.length > 0 ? config.overriddenUTxOs.map(_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__/* .utxoToCore */ .Sw) : (await api.getUtxos() || []).map(
        (utxo) => _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .TransactionUnspentOutput.from_cbor_hex */ .ZAD.from_cbor_hex(utxo)
      );
      return utxos;
    },
    getDelegation: async () => {
      const rewardAddr = await getRewardAddress();
      return rewardAddr ? await provider.getDelegation(rewardAddr) : { poolId: null, rewards: 0n };
    },
    signTx: async (tx) => {
      const witnessSet = await api.signTx((0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .toHex */ .NC)(tx.to_cbor_bytes()), true);
      return _anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .TransactionWitnessSet.from_cbor_hex */ .XgB.from_cbor_hex(witnessSet);
    },
    signMessage: async (address, payload) => {
      const hexAddress = (0,_lucid_evolution_core_utils__WEBPACK_IMPORTED_MODULE_1__/* .toHex */ .NC)(_anastasia_labs_cardano_multiplatform_lib_nodejs__WEBPACK_IMPORTED_MODULE_2__/* .Address.from_bech32 */ .kLt.from_bech32(address).to_raw_bytes());
      return await api.signData(hexAddress, payload);
    },
    submitTx: async (tx) => api.submitTx(tx)
  };
};
var makeWalletFromAddress = (provider, network, address, utxos) => {
  const { stakeCredential } = (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAddressDetails */ .IL)(address);
  const rewardAddress = stakeCredential ? (0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__/* .credentialToRewardAddress */ .EP)(network, stakeCredential) : null;
  const config = {
    overriddenUTxOs: utxos
  };
  return {
    overrideUTxOs: (utxos2) => config.overriddenUTxOs = utxos2,
    address: async () => address,
    rewardAddress: async () => rewardAddress,
    getUtxos: async () => config.overriddenUTxOs.length > 0 ? config.overriddenUTxOs : provider.getUtxos(address),
    getUtxosCore: async () => {
      const utxos2 = config.overriddenUTxOs.length > 0 ? config.overriddenUTxOs : await provider.getUtxos(address);
      const coreUtxos = [];
      for (const utxo of utxos2) {
        coreUtxos.push((0,_lucid_evolution_utils__WEBPACK_IMPORTED_MODULE_0__/* .utxoToCore */ .Sw)(utxo));
      }
      return coreUtxos;
    },
    getDelegation: async () => rewardAddress ? provider.getDelegation(rewardAddress) : { poolId: null, rewards: 0n },
    signTx: async (_tx) => {
      throw new Error("Not implemented");
    },
    signMessage: async (_address, _payload) => {
      throw new Error("Not implemented");
    },
    submitTx: async (tx) => provider.submitTx(tx)
  };
};


__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 67954:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Any": function() { return /* reexport */ Any; },
  "Array": function() { return /* reexport */ array_Array; },
  "AsyncIterator": function() { return /* reexport */ AsyncIterator; },
  "Awaited": function() { return /* reexport */ Awaited; },
  "BigInt": function() { return /* reexport */ BigInt; },
  "Boolean": function() { return /* reexport */ Boolean; },
  "Capitalize": function() { return /* reexport */ Capitalize; },
  "Clone": function() { return /* reexport */ Clone; },
  "CloneRest": function() { return /* reexport */ CloneRest; },
  "CloneType": function() { return /* reexport */ CloneType; },
  "Composite": function() { return /* reexport */ Composite; },
  "Const": function() { return /* reexport */ Const; },
  "Constructor": function() { return /* reexport */ Constructor; },
  "ConstructorParameters": function() { return /* reexport */ ConstructorParameters; },
  "Date": function() { return /* reexport */ date_Date; },
  "Deref": function() { return /* reexport */ Deref; },
  "Enum": function() { return /* reexport */ Enum; },
  "Exclude": function() { return /* reexport */ Exclude; },
  "ExcludeFromMappedResult": function() { return /* reexport */ ExcludeFromMappedResult; },
  "ExcludeFromTemplateLiteral": function() { return /* reexport */ ExcludeFromTemplateLiteral; },
  "Extends": function() { return /* reexport */ Extends; },
  "ExtendsCheck": function() { return /* reexport */ ExtendsCheck; },
  "ExtendsFromMappedKey": function() { return /* reexport */ ExtendsFromMappedKey; },
  "ExtendsFromMappedResult": function() { return /* reexport */ ExtendsFromMappedResult; },
  "ExtendsResolverError": function() { return /* reexport */ ExtendsResolverError; },
  "ExtendsResult": function() { return /* reexport */ ExtendsResult; },
  "ExtendsUndefinedCheck": function() { return /* reexport */ ExtendsUndefinedCheck; },
  "Extract": function() { return /* reexport */ Extract; },
  "ExtractFromMappedResult": function() { return /* reexport */ ExtractFromMappedResult; },
  "ExtractFromTemplateLiteral": function() { return /* reexport */ ExtractFromTemplateLiteral; },
  "FormatRegistry": function() { return /* reexport */ format_namespaceObject; },
  "Function": function() { return /* reexport */ Function; },
  "Hint": function() { return /* reexport */ Hint; },
  "Increment": function() { return /* reexport */ Increment; },
  "Index": function() { return /* reexport */ Index; },
  "IndexFromMappedKey": function() { return /* reexport */ IndexFromMappedKey; },
  "IndexFromMappedResult": function() { return /* reexport */ IndexFromMappedResult; },
  "IndexFromPropertyKey": function() { return /* reexport */ IndexFromPropertyKey; },
  "IndexFromPropertyKeys": function() { return /* reexport */ IndexFromPropertyKeys; },
  "IndexPropertyKeys": function() { return /* reexport */ IndexPropertyKeys; },
  "InstanceType": function() { return /* reexport */ InstanceType; },
  "Integer": function() { return /* reexport */ Integer; },
  "Intersect": function() { return /* reexport */ Intersect; },
  "IntersectEvaluated": function() { return /* reexport */ IntersectEvaluated; },
  "Intrinsic": function() { return /* reexport */ Intrinsic; },
  "IntrinsicFromMappedKey": function() { return /* reexport */ IntrinsicFromMappedKey; },
  "IsTemplateLiteralExpressionFinite": function() { return /* reexport */ IsTemplateLiteralExpressionFinite; },
  "IsTemplateLiteralFinite": function() { return /* reexport */ IsTemplateLiteralFinite; },
  "Iterator": function() { return /* reexport */ Iterator; },
  "JavaScriptTypeBuilder": function() { return /* reexport */ JavaScriptTypeBuilder; },
  "JsonTypeBuilder": function() { return /* reexport */ JsonTypeBuilder; },
  "KeyOf": function() { return /* reexport */ KeyOf; },
  "KeyOfFromMappedResult": function() { return /* reexport */ KeyOfFromMappedResult; },
  "KeyOfPattern": function() { return /* reexport */ KeyOfPattern; },
  "KeyOfPropertyEntries": function() { return /* reexport */ KeyOfPropertyEntries; },
  "KeyOfPropertyKeys": function() { return /* reexport */ KeyOfPropertyKeys; },
  "KeyOfPropertyKeysToRest": function() { return /* reexport */ KeyOfPropertyKeysToRest; },
  "Kind": function() { return /* reexport */ Kind; },
  "KindGuard": function() { return /* reexport */ kind_namespaceObject; },
  "Literal": function() { return /* reexport */ Literal; },
  "Lowercase": function() { return /* reexport */ Lowercase; },
  "Mapped": function() { return /* reexport */ Mapped; },
  "MappedFunctionReturnType": function() { return /* reexport */ MappedFunctionReturnType; },
  "MappedKey": function() { return /* reexport */ MappedKey; },
  "MappedResult": function() { return /* reexport */ MappedResult; },
  "Never": function() { return /* reexport */ Never; },
  "Not": function() { return /* reexport */ not_Not; },
  "Null": function() { return /* reexport */ Null; },
  "Number": function() { return /* reexport */ number_Number; },
  "Object": function() { return /* reexport */ object_Object; },
  "Omit": function() { return /* reexport */ Omit; },
  "OmitFromMappedKey": function() { return /* reexport */ OmitFromMappedKey; },
  "OmitFromMappedResult": function() { return /* reexport */ OmitFromMappedResult; },
  "Optional": function() { return /* reexport */ Optional; },
  "OptionalFromMappedResult": function() { return /* reexport */ OptionalFromMappedResult; },
  "OptionalKind": function() { return /* reexport */ OptionalKind; },
  "Parameters": function() { return /* reexport */ Parameters; },
  "Partial": function() { return /* reexport */ Partial; },
  "PartialFromMappedResult": function() { return /* reexport */ PartialFromMappedResult; },
  "PatternBoolean": function() { return /* reexport */ PatternBoolean; },
  "PatternBooleanExact": function() { return /* reexport */ PatternBooleanExact; },
  "PatternNever": function() { return /* reexport */ PatternNever; },
  "PatternNeverExact": function() { return /* reexport */ PatternNeverExact; },
  "PatternNumber": function() { return /* reexport */ PatternNumber; },
  "PatternNumberExact": function() { return /* reexport */ PatternNumberExact; },
  "PatternString": function() { return /* reexport */ PatternString; },
  "PatternStringExact": function() { return /* reexport */ PatternStringExact; },
  "Pick": function() { return /* reexport */ Pick; },
  "PickFromMappedKey": function() { return /* reexport */ PickFromMappedKey; },
  "PickFromMappedResult": function() { return /* reexport */ PickFromMappedResult; },
  "Promise": function() { return /* reexport */ Promise; },
  "Readonly": function() { return /* reexport */ Readonly; },
  "ReadonlyFromMappedResult": function() { return /* reexport */ ReadonlyFromMappedResult; },
  "ReadonlyKind": function() { return /* reexport */ ReadonlyKind; },
  "ReadonlyOptional": function() { return /* reexport */ ReadonlyOptional; },
  "Record": function() { return /* reexport */ Record; },
  "Recursive": function() { return /* reexport */ Recursive; },
  "Ref": function() { return /* reexport */ Ref; },
  "RegExp": function() { return /* reexport */ regexp_RegExp; },
  "Required": function() { return /* reexport */ Required; },
  "RequiredFromMappedResult": function() { return /* reexport */ RequiredFromMappedResult; },
  "Rest": function() { return /* reexport */ Rest; },
  "ReturnType": function() { return /* reexport */ ReturnType; },
  "SetComplement": function() { return /* reexport */ SetComplement; },
  "SetDistinct": function() { return /* reexport */ SetDistinct; },
  "SetIncludes": function() { return /* reexport */ SetIncludes; },
  "SetIntersect": function() { return /* reexport */ SetIntersect; },
  "SetIntersectMany": function() { return /* reexport */ SetIntersectMany; },
  "SetIsSubset": function() { return /* reexport */ SetIsSubset; },
  "SetUnion": function() { return /* reexport */ SetUnion; },
  "SetUnionMany": function() { return /* reexport */ SetUnionMany; },
  "Strict": function() { return /* reexport */ Strict; },
  "String": function() { return /* reexport */ string_String; },
  "Symbol": function() { return /* reexport */ symbol_Symbol; },
  "TemplateLiteral": function() { return /* reexport */ TemplateLiteral; },
  "TemplateLiteralExpressionGenerate": function() { return /* reexport */ TemplateLiteralExpressionGenerate; },
  "TemplateLiteralFiniteError": function() { return /* reexport */ TemplateLiteralFiniteError; },
  "TemplateLiteralGenerate": function() { return /* reexport */ TemplateLiteralGenerate; },
  "TemplateLiteralGenerateError": function() { return /* reexport */ TemplateLiteralGenerateError; },
  "TemplateLiteralParse": function() { return /* reexport */ TemplateLiteralParse; },
  "TemplateLiteralParseExact": function() { return /* reexport */ TemplateLiteralParseExact; },
  "TemplateLiteralParserError": function() { return /* reexport */ TemplateLiteralParserError; },
  "TemplateLiteralPattern": function() { return /* reexport */ TemplateLiteralPattern; },
  "TemplateLiteralPatternError": function() { return /* reexport */ TemplateLiteralPatternError; },
  "TemplateLiteralSyntax": function() { return /* reexport */ TemplateLiteralSyntax; },
  "TemplateLiteralToUnion": function() { return /* reexport */ TemplateLiteralToUnion; },
  "Transform": function() { return /* reexport */ Transform; },
  "TransformDecodeBuilder": function() { return /* reexport */ TransformDecodeBuilder; },
  "TransformEncodeBuilder": function() { return /* reexport */ TransformEncodeBuilder; },
  "TransformKind": function() { return /* reexport */ TransformKind; },
  "Tuple": function() { return /* reexport */ Tuple; },
  "Type": function() { return /* reexport */ Type; },
  "TypeBoxError": function() { return /* reexport */ TypeBoxError; },
  "TypeGuard": function() { return /* reexport */ guard_type_namespaceObject; },
  "TypeRegistry": function() { return /* reexport */ registry_type_namespaceObject; },
  "Uint8Array": function() { return /* reexport */ uint8array_Uint8Array; },
  "Uncapitalize": function() { return /* reexport */ Uncapitalize; },
  "Undefined": function() { return /* reexport */ Undefined; },
  "Union": function() { return /* reexport */ Union; },
  "UnionEvaluated": function() { return /* reexport */ UnionEvaluated; },
  "Unknown": function() { return /* reexport */ Unknown; },
  "Unsafe": function() { return /* reexport */ Unsafe; },
  "Uppercase": function() { return /* reexport */ Uppercase; },
  "ValueGuard": function() { return /* reexport */ value_namespaceObject; },
  "Void": function() { return /* reexport */ Void; }
});

// NAMESPACE OBJECT: ./node_modules/@sinclair/typebox/build/esm/type/guard/value.mjs
var value_namespaceObject = {};
__webpack_require__.r(value_namespaceObject);
__webpack_require__.d(value_namespaceObject, {
  "IsArray": function() { return IsArray; },
  "IsAsyncIterator": function() { return IsAsyncIterator; },
  "IsBigInt": function() { return IsBigInt; },
  "IsBoolean": function() { return IsBoolean; },
  "IsDate": function() { return IsDate; },
  "IsFunction": function() { return IsFunction; },
  "IsIterator": function() { return IsIterator; },
  "IsNull": function() { return IsNull; },
  "IsNumber": function() { return IsNumber; },
  "IsObject": function() { return IsObject; },
  "IsRegExp": function() { return IsRegExp; },
  "IsString": function() { return IsString; },
  "IsSymbol": function() { return IsSymbol; },
  "IsUint8Array": function() { return IsUint8Array; },
  "IsUndefined": function() { return IsUndefined; }
});

// NAMESPACE OBJECT: ./node_modules/@sinclair/typebox/build/esm/type/guard/kind.mjs
var kind_namespaceObject = {};
__webpack_require__.r(kind_namespaceObject);
__webpack_require__.d(kind_namespaceObject, {
  "IsAny": function() { return IsAny; },
  "IsArray": function() { return kind_IsArray; },
  "IsAsyncIterator": function() { return kind_IsAsyncIterator; },
  "IsBigInt": function() { return kind_IsBigInt; },
  "IsBoolean": function() { return kind_IsBoolean; },
  "IsConstructor": function() { return IsConstructor; },
  "IsDate": function() { return kind_IsDate; },
  "IsFunction": function() { return kind_IsFunction; },
  "IsInteger": function() { return IsInteger; },
  "IsIntersect": function() { return IsIntersect; },
  "IsIterator": function() { return kind_IsIterator; },
  "IsKind": function() { return IsKind; },
  "IsKindOf": function() { return IsKindOf; },
  "IsLiteral": function() { return IsLiteral; },
  "IsLiteralBoolean": function() { return IsLiteralBoolean; },
  "IsLiteralNumber": function() { return IsLiteralNumber; },
  "IsLiteralString": function() { return IsLiteralString; },
  "IsMappedKey": function() { return IsMappedKey; },
  "IsMappedResult": function() { return IsMappedResult; },
  "IsNever": function() { return IsNever; },
  "IsNot": function() { return IsNot; },
  "IsNull": function() { return kind_IsNull; },
  "IsNumber": function() { return kind_IsNumber; },
  "IsObject": function() { return kind_IsObject; },
  "IsOptional": function() { return IsOptional; },
  "IsPromise": function() { return IsPromise; },
  "IsProperties": function() { return IsProperties; },
  "IsReadonly": function() { return IsReadonly; },
  "IsRecord": function() { return IsRecord; },
  "IsRecursive": function() { return IsRecursive; },
  "IsRef": function() { return IsRef; },
  "IsRegExp": function() { return kind_IsRegExp; },
  "IsSchema": function() { return IsSchema; },
  "IsString": function() { return kind_IsString; },
  "IsSymbol": function() { return kind_IsSymbol; },
  "IsTemplateLiteral": function() { return IsTemplateLiteral; },
  "IsThis": function() { return IsThis; },
  "IsTransform": function() { return IsTransform; },
  "IsTuple": function() { return IsTuple; },
  "IsUint8Array": function() { return kind_IsUint8Array; },
  "IsUndefined": function() { return kind_IsUndefined; },
  "IsUnion": function() { return IsUnion; },
  "IsUnknown": function() { return IsUnknown; },
  "IsUnsafe": function() { return IsUnsafe; },
  "IsVoid": function() { return IsVoid; }
});

// NAMESPACE OBJECT: ./node_modules/@sinclair/typebox/build/esm/type/guard/type.mjs
var guard_type_namespaceObject = {};
__webpack_require__.r(guard_type_namespaceObject);
__webpack_require__.d(guard_type_namespaceObject, {
  "IsAny": function() { return type_IsAny; },
  "IsArray": function() { return type_IsArray; },
  "IsAsyncIterator": function() { return type_IsAsyncIterator; },
  "IsBigInt": function() { return type_IsBigInt; },
  "IsBoolean": function() { return type_IsBoolean; },
  "IsConstructor": function() { return type_IsConstructor; },
  "IsDate": function() { return type_IsDate; },
  "IsFunction": function() { return type_IsFunction; },
  "IsInteger": function() { return type_IsInteger; },
  "IsIntersect": function() { return type_IsIntersect; },
  "IsIterator": function() { return type_IsIterator; },
  "IsKind": function() { return type_IsKind; },
  "IsKindOf": function() { return type_IsKindOf; },
  "IsLiteral": function() { return type_IsLiteral; },
  "IsLiteralBoolean": function() { return type_IsLiteralBoolean; },
  "IsLiteralNumber": function() { return type_IsLiteralNumber; },
  "IsLiteralString": function() { return type_IsLiteralString; },
  "IsLiteralValue": function() { return IsLiteralValue; },
  "IsMappedKey": function() { return type_IsMappedKey; },
  "IsMappedResult": function() { return type_IsMappedResult; },
  "IsNever": function() { return type_IsNever; },
  "IsNot": function() { return type_IsNot; },
  "IsNull": function() { return type_IsNull; },
  "IsNumber": function() { return type_IsNumber; },
  "IsObject": function() { return type_IsObject; },
  "IsOptional": function() { return type_IsOptional; },
  "IsPromise": function() { return type_IsPromise; },
  "IsProperties": function() { return type_IsProperties; },
  "IsReadonly": function() { return type_IsReadonly; },
  "IsRecord": function() { return type_IsRecord; },
  "IsRecursive": function() { return type_IsRecursive; },
  "IsRef": function() { return type_IsRef; },
  "IsRegExp": function() { return type_IsRegExp; },
  "IsSchema": function() { return type_IsSchema; },
  "IsString": function() { return type_IsString; },
  "IsSymbol": function() { return type_IsSymbol; },
  "IsTemplateLiteral": function() { return type_IsTemplateLiteral; },
  "IsThis": function() { return type_IsThis; },
  "IsTransform": function() { return type_IsTransform; },
  "IsTuple": function() { return type_IsTuple; },
  "IsUint8Array": function() { return type_IsUint8Array; },
  "IsUndefined": function() { return type_IsUndefined; },
  "IsUnion": function() { return type_IsUnion; },
  "IsUnionLiteral": function() { return IsUnionLiteral; },
  "IsUnknown": function() { return type_IsUnknown; },
  "IsUnsafe": function() { return type_IsUnsafe; },
  "IsVoid": function() { return type_IsVoid; },
  "TypeGuardUnknownTypeError": function() { return TypeGuardUnknownTypeError; }
});

// NAMESPACE OBJECT: ./node_modules/@sinclair/typebox/build/esm/type/registry/format.mjs
var format_namespaceObject = {};
__webpack_require__.r(format_namespaceObject);
__webpack_require__.d(format_namespaceObject, {
  "Clear": function() { return Clear; },
  "Delete": function() { return Delete; },
  "Entries": function() { return Entries; },
  "Get": function() { return Get; },
  "Has": function() { return Has; },
  "Set": function() { return format_Set; }
});

// NAMESPACE OBJECT: ./node_modules/@sinclair/typebox/build/esm/type/registry/type.mjs
var registry_type_namespaceObject = {};
__webpack_require__.r(registry_type_namespaceObject);
__webpack_require__.d(registry_type_namespaceObject, {
  "Clear": function() { return type_Clear; },
  "Delete": function() { return type_Delete; },
  "Entries": function() { return type_Entries; },
  "Get": function() { return type_Get; },
  "Has": function() { return type_Has; },
  "Set": function() { return type_Set; }
});

// NAMESPACE OBJECT: ./node_modules/@sinclair/typebox/build/esm/type/type/type.mjs
var type_type_namespaceObject = {};
__webpack_require__.r(type_type_namespaceObject);
__webpack_require__.d(type_type_namespaceObject, {
  "Any": function() { return Any; },
  "Array": function() { return array_Array; },
  "AsyncIterator": function() { return AsyncIterator; },
  "Awaited": function() { return Awaited; },
  "BigInt": function() { return BigInt; },
  "Boolean": function() { return Boolean; },
  "Capitalize": function() { return Capitalize; },
  "Composite": function() { return Composite; },
  "Const": function() { return Const; },
  "Constructor": function() { return Constructor; },
  "ConstructorParameters": function() { return ConstructorParameters; },
  "Date": function() { return date_Date; },
  "Deref": function() { return Deref; },
  "Enum": function() { return Enum; },
  "Exclude": function() { return Exclude; },
  "Extends": function() { return Extends; },
  "Extract": function() { return Extract; },
  "Function": function() { return Function; },
  "Index": function() { return Index; },
  "InstanceType": function() { return InstanceType; },
  "Integer": function() { return Integer; },
  "Intersect": function() { return Intersect; },
  "Iterator": function() { return Iterator; },
  "KeyOf": function() { return KeyOf; },
  "Literal": function() { return Literal; },
  "Lowercase": function() { return Lowercase; },
  "Mapped": function() { return Mapped; },
  "Never": function() { return Never; },
  "Not": function() { return not_Not; },
  "Null": function() { return Null; },
  "Number": function() { return number_Number; },
  "Object": function() { return object_Object; },
  "Omit": function() { return Omit; },
  "Optional": function() { return Optional; },
  "Parameters": function() { return Parameters; },
  "Partial": function() { return Partial; },
  "Pick": function() { return Pick; },
  "Promise": function() { return Promise; },
  "Readonly": function() { return Readonly; },
  "ReadonlyOptional": function() { return ReadonlyOptional; },
  "Record": function() { return Record; },
  "Recursive": function() { return Recursive; },
  "Ref": function() { return Ref; },
  "RegExp": function() { return regexp_RegExp; },
  "Required": function() { return Required; },
  "Rest": function() { return Rest; },
  "ReturnType": function() { return ReturnType; },
  "Strict": function() { return Strict; },
  "String": function() { return string_String; },
  "Symbol": function() { return symbol_Symbol; },
  "TemplateLiteral": function() { return TemplateLiteral; },
  "Transform": function() { return Transform; },
  "Tuple": function() { return Tuple; },
  "Uint8Array": function() { return uint8array_Uint8Array; },
  "Uncapitalize": function() { return Uncapitalize; },
  "Undefined": function() { return Undefined; },
  "Union": function() { return Union; },
  "Unknown": function() { return Unknown; },
  "Unsafe": function() { return Unsafe; },
  "Uppercase": function() { return Uppercase; },
  "Void": function() { return Void; }
});

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/guard/value.mjs
/** Returns true if this value is an async iterator */
function IsAsyncIterator(value) {
    return IsObject(value) && !IsArray(value) && !IsUint8Array(value) && Symbol.asyncIterator in value;
}
/** Returns true if this value is an array */
function IsArray(value) {
    return Array.isArray(value);
}
/** Returns true if this value is bigint */
function IsBigInt(value) {
    return typeof value === 'bigint';
}
/** Returns true if this value is a boolean */
function IsBoolean(value) {
    return typeof value === 'boolean';
}
/** Returns true if this value is a Date object */
function IsDate(value) {
    return value instanceof globalThis.Date;
}
/** Returns true if this value is a function */
function IsFunction(value) {
    return typeof value === 'function';
}
/** Returns true if this value is an iterator */
function IsIterator(value) {
    return IsObject(value) && !IsArray(value) && !IsUint8Array(value) && Symbol.iterator in value;
}
/** Returns true if this value is null */
function IsNull(value) {
    return value === null;
}
/** Returns true if this value is number */
function IsNumber(value) {
    return typeof value === 'number';
}
/** Returns true if this value is an object */
function IsObject(value) {
    return typeof value === 'object' && value !== null;
}
/** Returns true if this value is RegExp */
function IsRegExp(value) {
    return value instanceof globalThis.RegExp;
}
/** Returns true if this value is string */
function IsString(value) {
    return typeof value === 'string';
}
/** Returns true if this value is symbol */
function IsSymbol(value) {
    return typeof value === 'symbol';
}
/** Returns true if this value is a Uint8Array */
function IsUint8Array(value) {
    return value instanceof globalThis.Uint8Array;
}
/** Returns true if this value is undefined */
function IsUndefined(value) {
    return value === undefined;
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/clone/value.mjs

function ArrayType(value) {
    return value.map((value) => Visit(value));
}
function DateType(value) {
    return new Date(value.getTime());
}
function Uint8ArrayType(value) {
    return new Uint8Array(value);
}
function RegExpType(value) {
    return new RegExp(value.source, value.flags);
}
function ObjectType(value) {
    const result = {};
    for (const key of Object.getOwnPropertyNames(value)) {
        result[key] = Visit(value[key]);
    }
    for (const key of Object.getOwnPropertySymbols(value)) {
        result[key] = Visit(value[key]);
    }
    return result;
}
// prettier-ignore
function Visit(value) {
    return (IsArray(value) ? ArrayType(value) :
        IsDate(value) ? DateType(value) :
            IsUint8Array(value) ? Uint8ArrayType(value) :
                IsRegExp(value) ? RegExpType(value) :
                    IsObject(value) ? ObjectType(value) :
                        value);
}
/** Clones a value */
function Clone(value) {
    return Visit(value);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/clone/type.mjs

/** Clones a Rest */
function CloneRest(schemas) {
    return schemas.map((schema) => CloneType(schema));
}
/** Clones a Type */
function CloneType(schema, options = {}) {
    return { ...Clone(schema), ...options };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/clone/index.mjs



;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/error/error.mjs
/** The base Error type thrown for all TypeBox exceptions  */
class TypeBoxError extends Error {
    constructor(message) {
        super(message);
    }
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/error/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/symbols/symbols.mjs
/** Symbol key applied to transform types */
const TransformKind = Symbol.for('TypeBox.Transform');
/** Symbol key applied to readonly types */
const ReadonlyKind = Symbol.for('TypeBox.Readonly');
/** Symbol key applied to optional types */
const OptionalKind = Symbol.for('TypeBox.Optional');
/** Symbol key applied to types */
const Hint = Symbol.for('TypeBox.Hint');
/** Symbol key applied to types */
const Kind = Symbol.for('TypeBox.Kind');

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/symbols/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/guard/kind.mjs


/** `[Kind-Only]` Returns true if this value has a Readonly symbol */
function IsReadonly(value) {
    return IsObject(value) && value[ReadonlyKind] === 'Readonly';
}
/** `[Kind-Only]` Returns true if this value has a Optional symbol */
function IsOptional(value) {
    return IsObject(value) && value[OptionalKind] === 'Optional';
}
/** `[Kind-Only]` Returns true if the given value is TAny */
function IsAny(value) {
    return IsKindOf(value, 'Any');
}
/** `[Kind-Only]` Returns true if the given value is TArray */
function kind_IsArray(value) {
    return IsKindOf(value, 'Array');
}
/** `[Kind-Only]` Returns true if the given value is TAsyncIterator */
function kind_IsAsyncIterator(value) {
    return IsKindOf(value, 'AsyncIterator');
}
/** `[Kind-Only]` Returns true if the given value is TBigInt */
function kind_IsBigInt(value) {
    return IsKindOf(value, 'BigInt');
}
/** `[Kind-Only]` Returns true if the given value is TBoolean */
function kind_IsBoolean(value) {
    return IsKindOf(value, 'Boolean');
}
/** `[Kind-Only]` Returns true if the given value is TConstructor */
function IsConstructor(value) {
    return IsKindOf(value, 'Constructor');
}
/** `[Kind-Only]` Returns true if the given value is TDate */
function kind_IsDate(value) {
    return IsKindOf(value, 'Date');
}
/** `[Kind-Only]` Returns true if the given value is TFunction */
function kind_IsFunction(value) {
    return IsKindOf(value, 'Function');
}
/** `[Kind-Only]` Returns true if the given value is TInteger */
function IsInteger(value) {
    return IsKindOf(value, 'Integer');
}
/** `[Kind-Only]` Returns true if the given schema is TProperties */
function IsProperties(value) {
    return IsObject(value);
}
/** `[Kind-Only]` Returns true if the given value is TIntersect */
function IsIntersect(value) {
    return IsKindOf(value, 'Intersect');
}
/** `[Kind-Only]` Returns true if the given value is TIterator */
function kind_IsIterator(value) {
    return IsKindOf(value, 'Iterator');
}
/** `[Kind-Only]` Returns true if the given value is a TKind with the given name. */
function IsKindOf(value, kind) {
    return IsObject(value) && Kind in value && value[Kind] === kind;
}
/** `[Kind-Only]` Returns true if the given value is TLiteral<string> */
function IsLiteralString(value) {
    return IsLiteral(value) && IsString(value.const);
}
/** `[Kind-Only]` Returns true if the given value is TLiteral<number> */
function IsLiteralNumber(value) {
    return IsLiteral(value) && IsNumber(value.const);
}
/** `[Kind-Only]` Returns true if the given value is TLiteral<boolean> */
function IsLiteralBoolean(value) {
    return IsLiteral(value) && IsBoolean(value.const);
}
/** `[Kind-Only]` Returns true if the given value is TLiteral */
function IsLiteral(value) {
    return IsKindOf(value, 'Literal');
}
/** `[Kind-Only]` Returns true if the given value is a TMappedKey */
function IsMappedKey(value) {
    return IsKindOf(value, 'MappedKey');
}
/** `[Kind-Only]` Returns true if the given value is TMappedResult */
function IsMappedResult(value) {
    return IsKindOf(value, 'MappedResult');
}
/** `[Kind-Only]` Returns true if the given value is TNever */
function IsNever(value) {
    return IsKindOf(value, 'Never');
}
/** `[Kind-Only]` Returns true if the given value is TNot */
function IsNot(value) {
    return IsKindOf(value, 'Not');
}
/** `[Kind-Only]` Returns true if the given value is TNull */
function kind_IsNull(value) {
    return IsKindOf(value, 'Null');
}
/** `[Kind-Only]` Returns true if the given value is TNumber */
function kind_IsNumber(value) {
    return IsKindOf(value, 'Number');
}
/** `[Kind-Only]` Returns true if the given value is TObject */
function kind_IsObject(value) {
    return IsKindOf(value, 'Object');
}
/** `[Kind-Only]` Returns true if the given value is TPromise */
function IsPromise(value) {
    return IsKindOf(value, 'Promise');
}
/** `[Kind-Only]` Returns true if the given value is TRecord */
function IsRecord(value) {
    return IsKindOf(value, 'Record');
}
/** `[Kind-Only]` Returns true if this value is TRecursive */
function IsRecursive(value) {
    return IsObject(value) && Hint in value && value[Hint] === 'Recursive';
}
/** `[Kind-Only]` Returns true if the given value is TRef */
function IsRef(value) {
    return IsKindOf(value, 'Ref');
}
/** `[Kind-Only]` Returns true if the given value is TRegExp */
function kind_IsRegExp(value) {
    return IsKindOf(value, 'RegExp');
}
/** `[Kind-Only]` Returns true if the given value is TString */
function kind_IsString(value) {
    return IsKindOf(value, 'String');
}
/** `[Kind-Only]` Returns true if the given value is TSymbol */
function kind_IsSymbol(value) {
    return IsKindOf(value, 'Symbol');
}
/** `[Kind-Only]` Returns true if the given value is TTemplateLiteral */
function IsTemplateLiteral(value) {
    return IsKindOf(value, 'TemplateLiteral');
}
/** `[Kind-Only]` Returns true if the given value is TThis */
function IsThis(value) {
    return IsKindOf(value, 'This');
}
/** `[Kind-Only]` Returns true of this value is TTransform */
function IsTransform(value) {
    return IsObject(value) && TransformKind in value;
}
/** `[Kind-Only]` Returns true if the given value is TTuple */
function IsTuple(value) {
    return IsKindOf(value, 'Tuple');
}
/** `[Kind-Only]` Returns true if the given value is TUndefined */
function kind_IsUndefined(value) {
    return IsKindOf(value, 'Undefined');
}
/** `[Kind-Only]` Returns true if the given value is TUnion */
function IsUnion(value) {
    return IsKindOf(value, 'Union');
}
/** `[Kind-Only]` Returns true if the given value is TUint8Array */
function kind_IsUint8Array(value) {
    return IsKindOf(value, 'Uint8Array');
}
/** `[Kind-Only]` Returns true if the given value is TUnknown */
function IsUnknown(value) {
    return IsKindOf(value, 'Unknown');
}
/** `[Kind-Only]` Returns true if the given value is a raw TUnsafe */
function IsUnsafe(value) {
    return IsKindOf(value, 'Unsafe');
}
/** `[Kind-Only]` Returns true if the given value is TVoid */
function IsVoid(value) {
    return IsKindOf(value, 'Void');
}
/** `[Kind-Only]` Returns true if the given value is TKind */
function IsKind(value) {
    return IsObject(value) && Kind in value && IsString(value[Kind]);
}
/** `[Kind-Only]` Returns true if the given value is TSchema */
function IsSchema(value) {
    // prettier-ignore
    return (IsAny(value) ||
        kind_IsArray(value) ||
        kind_IsBoolean(value) ||
        kind_IsBigInt(value) ||
        kind_IsAsyncIterator(value) ||
        IsConstructor(value) ||
        kind_IsDate(value) ||
        kind_IsFunction(value) ||
        IsInteger(value) ||
        IsIntersect(value) ||
        kind_IsIterator(value) ||
        IsLiteral(value) ||
        IsMappedKey(value) ||
        IsMappedResult(value) ||
        IsNever(value) ||
        IsNot(value) ||
        kind_IsNull(value) ||
        kind_IsNumber(value) ||
        kind_IsObject(value) ||
        IsPromise(value) ||
        IsRecord(value) ||
        IsRef(value) ||
        kind_IsRegExp(value) ||
        kind_IsString(value) ||
        kind_IsSymbol(value) ||
        IsTemplateLiteral(value) ||
        IsThis(value) ||
        IsTuple(value) ||
        kind_IsUndefined(value) ||
        IsUnion(value) ||
        kind_IsUint8Array(value) ||
        IsUnknown(value) ||
        IsUnsafe(value) ||
        IsVoid(value) ||
        IsKind(value));
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/guard/type.mjs



class TypeGuardUnknownTypeError extends TypeBoxError {
}
const KnownTypes = [
    'Any',
    'Array',
    'AsyncIterator',
    'BigInt',
    'Boolean',
    'Constructor',
    'Date',
    'Enum',
    'Function',
    'Integer',
    'Intersect',
    'Iterator',
    'Literal',
    'MappedKey',
    'MappedResult',
    'Not',
    'Null',
    'Number',
    'Object',
    'Promise',
    'Record',
    'Ref',
    'RegExp',
    'String',
    'Symbol',
    'TemplateLiteral',
    'This',
    'Tuple',
    'Undefined',
    'Union',
    'Uint8Array',
    'Unknown',
    'Void',
];
function IsPattern(value) {
    try {
        new RegExp(value);
        return true;
    }
    catch {
        return false;
    }
}
function IsControlCharacterFree(value) {
    if (!IsString(value))
        return false;
    for (let i = 0; i < value.length; i++) {
        const code = value.charCodeAt(i);
        if ((code >= 7 && code <= 13) || code === 27 || code === 127) {
            return false;
        }
    }
    return true;
}
function IsAdditionalProperties(value) {
    return IsOptionalBoolean(value) || type_IsSchema(value);
}
function IsOptionalBigInt(value) {
    return IsUndefined(value) || IsBigInt(value);
}
function IsOptionalNumber(value) {
    return IsUndefined(value) || IsNumber(value);
}
function IsOptionalBoolean(value) {
    return IsUndefined(value) || IsBoolean(value);
}
function IsOptionalString(value) {
    return IsUndefined(value) || IsString(value);
}
function IsOptionalPattern(value) {
    return IsUndefined(value) || (IsString(value) && IsControlCharacterFree(value) && IsPattern(value));
}
function IsOptionalFormat(value) {
    return IsUndefined(value) || (IsString(value) && IsControlCharacterFree(value));
}
function IsOptionalSchema(value) {
    return IsUndefined(value) || type_IsSchema(value);
}
// ------------------------------------------------------------------
// Modifiers
// ------------------------------------------------------------------
/** Returns true if this value has a Readonly symbol */
function type_IsReadonly(value) {
    return IsObject(value) && value[ReadonlyKind] === 'Readonly';
}
/** Returns true if this value has a Optional symbol */
function type_IsOptional(value) {
    return IsObject(value) && value[OptionalKind] === 'Optional';
}
// ------------------------------------------------------------------
// Types
// ------------------------------------------------------------------
/** Returns true if the given value is TAny */
function type_IsAny(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Any') &&
        IsOptionalString(value.$id));
}
/** Returns true if the given value is TArray */
function type_IsArray(value) {
    return (type_IsKindOf(value, 'Array') &&
        value.type === 'array' &&
        IsOptionalString(value.$id) &&
        type_IsSchema(value.items) &&
        IsOptionalNumber(value.minItems) &&
        IsOptionalNumber(value.maxItems) &&
        IsOptionalBoolean(value.uniqueItems) &&
        IsOptionalSchema(value.contains) &&
        IsOptionalNumber(value.minContains) &&
        IsOptionalNumber(value.maxContains));
}
/** Returns true if the given value is TAsyncIterator */
function type_IsAsyncIterator(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'AsyncIterator') &&
        value.type === 'AsyncIterator' &&
        IsOptionalString(value.$id) &&
        type_IsSchema(value.items));
}
/** Returns true if the given value is TBigInt */
function type_IsBigInt(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'BigInt') &&
        value.type === 'bigint' &&
        IsOptionalString(value.$id) &&
        IsOptionalBigInt(value.exclusiveMaximum) &&
        IsOptionalBigInt(value.exclusiveMinimum) &&
        IsOptionalBigInt(value.maximum) &&
        IsOptionalBigInt(value.minimum) &&
        IsOptionalBigInt(value.multipleOf));
}
/** Returns true if the given value is TBoolean */
function type_IsBoolean(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Boolean') &&
        value.type === 'boolean' &&
        IsOptionalString(value.$id));
}
/** Returns true if the given value is TConstructor */
function type_IsConstructor(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Constructor') &&
        value.type === 'Constructor' &&
        IsOptionalString(value.$id) &&
        IsArray(value.parameters) &&
        value.parameters.every(schema => type_IsSchema(schema)) &&
        type_IsSchema(value.returns));
}
/** Returns true if the given value is TDate */
function type_IsDate(value) {
    return (type_IsKindOf(value, 'Date') &&
        value.type === 'Date' &&
        IsOptionalString(value.$id) &&
        IsOptionalNumber(value.exclusiveMaximumTimestamp) &&
        IsOptionalNumber(value.exclusiveMinimumTimestamp) &&
        IsOptionalNumber(value.maximumTimestamp) &&
        IsOptionalNumber(value.minimumTimestamp) &&
        IsOptionalNumber(value.multipleOfTimestamp));
}
/** Returns true if the given value is TFunction */
function type_IsFunction(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Function') &&
        value.type === 'Function' &&
        IsOptionalString(value.$id) &&
        IsArray(value.parameters) &&
        value.parameters.every(schema => type_IsSchema(schema)) &&
        type_IsSchema(value.returns));
}
/** Returns true if the given value is TInteger */
function type_IsInteger(value) {
    return (type_IsKindOf(value, 'Integer') &&
        value.type === 'integer' &&
        IsOptionalString(value.$id) &&
        IsOptionalNumber(value.exclusiveMaximum) &&
        IsOptionalNumber(value.exclusiveMinimum) &&
        IsOptionalNumber(value.maximum) &&
        IsOptionalNumber(value.minimum) &&
        IsOptionalNumber(value.multipleOf));
}
/** Returns true if the given schema is TProperties */
function type_IsProperties(value) {
    // prettier-ignore
    return (IsObject(value) &&
        Object.entries(value).every(([key, schema]) => IsControlCharacterFree(key) && type_IsSchema(schema)));
}
/** Returns true if the given value is TIntersect */
function type_IsIntersect(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Intersect') &&
        (IsString(value.type) && value.type !== 'object' ? false : true) &&
        IsArray(value.allOf) &&
        value.allOf.every(schema => type_IsSchema(schema) && !type_IsTransform(schema)) &&
        IsOptionalString(value.type) &&
        (IsOptionalBoolean(value.unevaluatedProperties) || IsOptionalSchema(value.unevaluatedProperties)) &&
        IsOptionalString(value.$id));
}
/** Returns true if the given value is TIterator */
function type_IsIterator(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Iterator') &&
        value.type === 'Iterator' &&
        IsOptionalString(value.$id) &&
        type_IsSchema(value.items));
}
/** Returns true if the given value is a TKind with the given name. */
function type_IsKindOf(value, kind) {
    return IsObject(value) && Kind in value && value[Kind] === kind;
}
/** Returns true if the given value is TLiteral<string> */
function type_IsLiteralString(value) {
    return type_IsLiteral(value) && IsString(value.const);
}
/** Returns true if the given value is TLiteral<number> */
function type_IsLiteralNumber(value) {
    return type_IsLiteral(value) && IsNumber(value.const);
}
/** Returns true if the given value is TLiteral<boolean> */
function type_IsLiteralBoolean(value) {
    return type_IsLiteral(value) && IsBoolean(value.const);
}
/** Returns true if the given value is TLiteral */
function type_IsLiteral(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Literal') &&
        IsOptionalString(value.$id) && IsLiteralValue(value.const));
}
/** Returns true if the given value is a TLiteralValue */
function IsLiteralValue(value) {
    return IsBoolean(value) || IsNumber(value) || IsString(value);
}
/** Returns true if the given value is a TMappedKey */
function type_IsMappedKey(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'MappedKey') &&
        IsArray(value.keys) &&
        value.keys.every(key => IsNumber(key) || IsString(key)));
}
/** Returns true if the given value is TMappedResult */
function type_IsMappedResult(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'MappedResult') &&
        type_IsProperties(value.properties));
}
/** Returns true if the given value is TNever */
function type_IsNever(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Never') &&
        IsObject(value.not) &&
        Object.getOwnPropertyNames(value.not).length === 0);
}
/** Returns true if the given value is TNot */
function type_IsNot(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Not') &&
        type_IsSchema(value.not));
}
/** Returns true if the given value is TNull */
function type_IsNull(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Null') &&
        value.type === 'null' &&
        IsOptionalString(value.$id));
}
/** Returns true if the given value is TNumber */
function type_IsNumber(value) {
    return (type_IsKindOf(value, 'Number') &&
        value.type === 'number' &&
        IsOptionalString(value.$id) &&
        IsOptionalNumber(value.exclusiveMaximum) &&
        IsOptionalNumber(value.exclusiveMinimum) &&
        IsOptionalNumber(value.maximum) &&
        IsOptionalNumber(value.minimum) &&
        IsOptionalNumber(value.multipleOf));
}
/** Returns true if the given value is TObject */
function type_IsObject(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Object') &&
        value.type === 'object' &&
        IsOptionalString(value.$id) &&
        type_IsProperties(value.properties) &&
        IsAdditionalProperties(value.additionalProperties) &&
        IsOptionalNumber(value.minProperties) &&
        IsOptionalNumber(value.maxProperties));
}
/** Returns true if the given value is TPromise */
function type_IsPromise(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Promise') &&
        value.type === 'Promise' &&
        IsOptionalString(value.$id) &&
        type_IsSchema(value.item));
}
/** Returns true if the given value is TRecord */
function type_IsRecord(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Record') &&
        value.type === 'object' &&
        IsOptionalString(value.$id) &&
        IsAdditionalProperties(value.additionalProperties) &&
        IsObject(value.patternProperties) &&
        ((schema) => {
            const keys = Object.getOwnPropertyNames(schema.patternProperties);
            return (keys.length === 1 &&
                IsPattern(keys[0]) &&
                IsObject(schema.patternProperties) &&
                type_IsSchema(schema.patternProperties[keys[0]]));
        })(value));
}
/** Returns true if this value is TRecursive */
function type_IsRecursive(value) {
    return IsObject(value) && Hint in value && value[Hint] === 'Recursive';
}
/** Returns true if the given value is TRef */
function type_IsRef(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Ref') &&
        IsOptionalString(value.$id) &&
        IsString(value.$ref));
}
/** Returns true if the given value is TRegExp */
function type_IsRegExp(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'RegExp') &&
        IsOptionalString(value.$id) &&
        IsString(value.source) &&
        IsString(value.flags) &&
        IsOptionalNumber(value.maxLength) &&
        IsOptionalNumber(value.minLength));
}
/** Returns true if the given value is TString */
function type_IsString(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'String') &&
        value.type === 'string' &&
        IsOptionalString(value.$id) &&
        IsOptionalNumber(value.minLength) &&
        IsOptionalNumber(value.maxLength) &&
        IsOptionalPattern(value.pattern) &&
        IsOptionalFormat(value.format));
}
/** Returns true if the given value is TSymbol */
function type_IsSymbol(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Symbol') &&
        value.type === 'symbol' &&
        IsOptionalString(value.$id));
}
/** Returns true if the given value is TTemplateLiteral */
function type_IsTemplateLiteral(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'TemplateLiteral') &&
        value.type === 'string' &&
        IsString(value.pattern) &&
        value.pattern[0] === '^' &&
        value.pattern[value.pattern.length - 1] === '$');
}
/** Returns true if the given value is TThis */
function type_IsThis(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'This') &&
        IsOptionalString(value.$id) &&
        IsString(value.$ref));
}
/** Returns true of this value is TTransform */
function type_IsTransform(value) {
    return IsObject(value) && TransformKind in value;
}
/** Returns true if the given value is TTuple */
function type_IsTuple(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Tuple') &&
        value.type === 'array' &&
        IsOptionalString(value.$id) &&
        IsNumber(value.minItems) &&
        IsNumber(value.maxItems) &&
        value.minItems === value.maxItems &&
        (( // empty
        IsUndefined(value.items) &&
            IsUndefined(value.additionalItems) &&
            value.minItems === 0) || (IsArray(value.items) &&
            value.items.every(schema => type_IsSchema(schema)))));
}
/** Returns true if the given value is TUndefined */
function type_IsUndefined(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Undefined') &&
        value.type === 'undefined' &&
        IsOptionalString(value.$id));
}
/** Returns true if the given value is TUnion<Literal<string | number>[]> */
function IsUnionLiteral(value) {
    return type_IsUnion(value) && value.anyOf.every((schema) => type_IsLiteralString(schema) || type_IsLiteralNumber(schema));
}
/** Returns true if the given value is TUnion */
function type_IsUnion(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Union') &&
        IsOptionalString(value.$id) &&
        IsObject(value) &&
        IsArray(value.anyOf) &&
        value.anyOf.every(schema => type_IsSchema(schema)));
}
/** Returns true if the given value is TUint8Array */
function type_IsUint8Array(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Uint8Array') &&
        value.type === 'Uint8Array' &&
        IsOptionalString(value.$id) &&
        IsOptionalNumber(value.minByteLength) &&
        IsOptionalNumber(value.maxByteLength));
}
/** Returns true if the given value is TUnknown */
function type_IsUnknown(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Unknown') &&
        IsOptionalString(value.$id));
}
/** Returns true if the given value is a raw TUnsafe */
function type_IsUnsafe(value) {
    return type_IsKindOf(value, 'Unsafe');
}
/** Returns true if the given value is TVoid */
function type_IsVoid(value) {
    // prettier-ignore
    return (type_IsKindOf(value, 'Void') &&
        value.type === 'void' &&
        IsOptionalString(value.$id));
}
/** Returns true if the given value is TKind */
function type_IsKind(value) {
    return IsObject(value) && Kind in value && IsString(value[Kind]) && !KnownTypes.includes(value[Kind]);
}
/** Returns true if the given value is TSchema */
function type_IsSchema(value) {
    // prettier-ignore
    return (IsObject(value)) && (type_IsAny(value) ||
        type_IsArray(value) ||
        type_IsBoolean(value) ||
        type_IsBigInt(value) ||
        type_IsAsyncIterator(value) ||
        type_IsConstructor(value) ||
        type_IsDate(value) ||
        type_IsFunction(value) ||
        type_IsInteger(value) ||
        type_IsIntersect(value) ||
        type_IsIterator(value) ||
        type_IsLiteral(value) ||
        type_IsMappedKey(value) ||
        type_IsMappedResult(value) ||
        type_IsNever(value) ||
        type_IsNot(value) ||
        type_IsNull(value) ||
        type_IsNumber(value) ||
        type_IsObject(value) ||
        type_IsPromise(value) ||
        type_IsRecord(value) ||
        type_IsRef(value) ||
        type_IsRegExp(value) ||
        type_IsString(value) ||
        type_IsSymbol(value) ||
        type_IsTemplateLiteral(value) ||
        type_IsThis(value) ||
        type_IsTuple(value) ||
        type_IsUndefined(value) ||
        type_IsUnion(value) ||
        type_IsUint8Array(value) ||
        type_IsUnknown(value) ||
        type_IsUnsafe(value) ||
        type_IsVoid(value) ||
        type_IsKind(value));
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/guard/index.mjs




;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/helpers/helpers.mjs
/** Increments the given string value + 1 */
function Increment(T) {
    return (parseInt(T) + 1).toString();
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/helpers/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/patterns/patterns.mjs
const PatternBoolean = '(true|false)';
const PatternNumber = '(0|[1-9][0-9]*)';
const PatternString = '(.*)';
const PatternNever = '(?!.*)';
const PatternBooleanExact = `^${PatternBoolean}$`;
const PatternNumberExact = `^${PatternNumber}$`;
const PatternStringExact = `^${PatternString}$`;
const PatternNeverExact = `^${PatternNever}$`;

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/patterns/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/registry/format.mjs
/** A registry for user defined string formats */
const map = new Map();
/** Returns the entries in this registry */
function Entries() {
    return new Map(map);
}
/** Clears all user defined string formats */
function Clear() {
    return map.clear();
}
/** Deletes a registered format */
function Delete(format) {
    return map.delete(format);
}
/** Returns true if the user defined string format exists */
function Has(format) {
    return map.has(format);
}
/** Sets a validation function for a user defined string format */
function format_Set(format, func) {
    map.set(format, func);
}
/** Gets a validation function for a user defined string format */
function Get(format) {
    return map.get(format);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/registry/type.mjs
/** A registry for user defined types */
const type_map = new Map();
/** Returns the entries in this registry */
function type_Entries() {
    return new Map(type_map);
}
/** Clears all user defined types */
function type_Clear() {
    return type_map.clear();
}
/** Deletes a registered type */
function type_Delete(kind) {
    return type_map.delete(kind);
}
/** Returns true if this registry contains this kind */
function type_Has(kind) {
    return type_map.has(kind);
}
/** Sets a validation function for a user defined type */
function type_Set(kind, func) {
    type_map.set(kind, func);
}
/** Gets a custom validation function for a user defined type */
function type_Get(kind) {
    return type_map.get(kind);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/registry/index.mjs



;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/sets/set.mjs
/** Returns true if element right is in the set of left */
// prettier-ignore
function SetIncludes(T, S) {
    return T.includes(S);
}
/** Returns true if left is a subset of right */
function SetIsSubset(T, S) {
    return T.every((L) => SetIncludes(S, L));
}
/** Returns a distinct set of elements */
function SetDistinct(T) {
    return [...new Set(T)];
}
/** Returns the Intersect of the given sets */
function SetIntersect(T, S) {
    return T.filter((L) => S.includes(L));
}
/** Returns the Union of the given sets */
function SetUnion(T, S) {
    return [...T, ...S];
}
/** Returns the Complement by omitting elements in T that are in S */
// prettier-ignore
function SetComplement(T, S) {
    return T.filter(L => !S.includes(L));
}
// prettier-ignore
function SetIntersectManyResolve(T, Init) {
    return T.reduce((Acc, L) => {
        return SetIntersect(Acc, L);
    }, Init);
}
// prettier-ignore
function SetIntersectMany(T) {
    return (T.length === 1
        ? T[0]
        // Use left to initialize the accumulator for resolve
        : T.length > 1
            ? SetIntersectManyResolve(T.slice(1), T[0])
            : []);
}
/** Returns the Union of multiple sets */
function SetUnionMany(T) {
    const Acc = [];
    for (const L of T)
        Acc.push(...L);
    return Acc;
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/sets/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/any/any.mjs

/** `[Json]` Creates an Any type */
function Any(options = {}) {
    return { ...options, [Kind]: 'Any' };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/any/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/array/array.mjs


/** `[Json]` Creates an Array type */
function array_Array(schema, options = {}) {
    return {
        ...options,
        [Kind]: 'Array',
        type: 'array',
        items: CloneType(schema),
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/array/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/async-iterator/async-iterator.mjs


/** `[JavaScript]` Creates a AsyncIterator type */
function AsyncIterator(items, options = {}) {
    return {
        ...options,
        [Kind]: 'AsyncIterator',
        type: 'AsyncIterator',
        items: CloneType(items),
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/async-iterator/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/discard/discard.mjs
function DiscardKey(value, key) {
    const { [key]: _, ...rest } = value;
    return rest;
}
function Discard(value, keys) {
    return keys.reduce((acc, key) => DiscardKey(acc, key), value);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/never/never.mjs

/** `[Json]` Creates a Never type */
function Never(options = {}) {
    return {
        ...options,
        [Kind]: 'Never',
        not: {},
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/never/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/mapped/mapped-key.mjs

// prettier-ignore
function MappedKey(T) {
    return {
        [Kind]: 'MappedKey',
        keys: T
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/mapped/mapped-result.mjs

// prettier-ignore
function MappedResult(properties) {
    return {
        [Kind]: 'MappedResult',
        properties
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/constructor/constructor.mjs


/** `[JavaScript]` Creates a Constructor type */
function Constructor(parameters, returns, options) {
    return {
        ...options,
        [Kind]: 'Constructor',
        type: 'Constructor',
        parameters: CloneRest(parameters),
        returns: CloneType(returns),
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/constructor/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/function/function.mjs


/** `[JavaScript]` Creates a Function type */
function Function(parameters, returns, options) {
    return {
        ...options,
        [Kind]: 'Function',
        type: 'Function',
        parameters: CloneRest(parameters),
        returns: CloneType(returns),
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/function/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/union/union-create.mjs


function UnionCreate(T, options) {
    return { ...options, [Kind]: 'Union', anyOf: CloneRest(T) };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/union/union-evaluated.mjs






// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function IsUnionOptional(T) {
    return T.some(L => IsOptional(L));
}
// prettier-ignore
function RemoveOptionalFromRest(T) {
    return T.map(L => IsOptional(L) ? RemoveOptionalFromType(L) : L);
}
// prettier-ignore
function RemoveOptionalFromType(T) {
    return (Discard(T, [OptionalKind]));
}
// prettier-ignore
function ResolveUnion(T, options) {
    return (IsUnionOptional(T)
        ? Optional(UnionCreate(RemoveOptionalFromRest(T), options))
        : UnionCreate(RemoveOptionalFromRest(T), options));
}
/** `[Json]` Creates an evaluated Union type */
function UnionEvaluated(T, options = {}) {
    // prettier-ignore
    return (T.length === 0 ? Never(options) :
        T.length === 1 ? CloneType(T[0], options) :
            ResolveUnion(T, options));
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/union/union-type.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/union/union.mjs



/** `[Json]` Creates a Union type */
function Union(T, options = {}) {
    // prettier-ignore
    return (T.length === 0 ? Never(options) :
        T.length === 1 ? CloneType(T[0], options) :
            UnionCreate(T, options));
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/union/index.mjs




;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/template-literal/parse.mjs

// ------------------------------------------------------------------
// TemplateLiteralParserError
// ------------------------------------------------------------------
class TemplateLiteralParserError extends TypeBoxError {
}
// -------------------------------------------------------------------
// Unescape
//
// Unescape for these control characters specifically. Note that this
// function is only called on non union group content, and where we
// still want to allow the user to embed control characters in that
// content. For review.
// -------------------------------------------------------------------
// prettier-ignore
function Unescape(pattern) {
    return pattern
        .replace(/\\\$/g, '$')
        .replace(/\\\*/g, '*')
        .replace(/\\\^/g, '^')
        .replace(/\\\|/g, '|')
        .replace(/\\\(/g, '(')
        .replace(/\\\)/g, ')');
}
// -------------------------------------------------------------------
// Control Characters
// -------------------------------------------------------------------
function IsNonEscaped(pattern, index, char) {
    return pattern[index] === char && pattern.charCodeAt(index - 1) !== 92;
}
function IsOpenParen(pattern, index) {
    return IsNonEscaped(pattern, index, '(');
}
function IsCloseParen(pattern, index) {
    return IsNonEscaped(pattern, index, ')');
}
function IsSeparator(pattern, index) {
    return IsNonEscaped(pattern, index, '|');
}
// -------------------------------------------------------------------
// Control Groups
// -------------------------------------------------------------------
function IsGroup(pattern) {
    if (!(IsOpenParen(pattern, 0) && IsCloseParen(pattern, pattern.length - 1)))
        return false;
    let count = 0;
    for (let index = 0; index < pattern.length; index++) {
        if (IsOpenParen(pattern, index))
            count += 1;
        if (IsCloseParen(pattern, index))
            count -= 1;
        if (count === 0 && index !== pattern.length - 1)
            return false;
    }
    return true;
}
// prettier-ignore
function InGroup(pattern) {
    return pattern.slice(1, pattern.length - 1);
}
// prettier-ignore
function IsPrecedenceOr(pattern) {
    let count = 0;
    for (let index = 0; index < pattern.length; index++) {
        if (IsOpenParen(pattern, index))
            count += 1;
        if (IsCloseParen(pattern, index))
            count -= 1;
        if (IsSeparator(pattern, index) && count === 0)
            return true;
    }
    return false;
}
// prettier-ignore
function IsPrecedenceAnd(pattern) {
    for (let index = 0; index < pattern.length; index++) {
        if (IsOpenParen(pattern, index))
            return true;
    }
    return false;
}
// prettier-ignore
function Or(pattern) {
    let [count, start] = [0, 0];
    const expressions = [];
    for (let index = 0; index < pattern.length; index++) {
        if (IsOpenParen(pattern, index))
            count += 1;
        if (IsCloseParen(pattern, index))
            count -= 1;
        if (IsSeparator(pattern, index) && count === 0) {
            const range = pattern.slice(start, index);
            if (range.length > 0)
                expressions.push(TemplateLiteralParse(range));
            start = index + 1;
        }
    }
    const range = pattern.slice(start);
    if (range.length > 0)
        expressions.push(TemplateLiteralParse(range));
    if (expressions.length === 0)
        return { type: 'const', const: '' };
    if (expressions.length === 1)
        return expressions[0];
    return { type: 'or', expr: expressions };
}
// prettier-ignore
function And(pattern) {
    function Group(value, index) {
        if (!IsOpenParen(value, index))
            throw new TemplateLiteralParserError(`TemplateLiteralParser: Index must point to open parens`);
        let count = 0;
        for (let scan = index; scan < value.length; scan++) {
            if (IsOpenParen(value, scan))
                count += 1;
            if (IsCloseParen(value, scan))
                count -= 1;
            if (count === 0)
                return [index, scan];
        }
        throw new TemplateLiteralParserError(`TemplateLiteralParser: Unclosed group parens in expression`);
    }
    function Range(pattern, index) {
        for (let scan = index; scan < pattern.length; scan++) {
            if (IsOpenParen(pattern, scan))
                return [index, scan];
        }
        return [index, pattern.length];
    }
    const expressions = [];
    for (let index = 0; index < pattern.length; index++) {
        if (IsOpenParen(pattern, index)) {
            const [start, end] = Group(pattern, index);
            const range = pattern.slice(start, end + 1);
            expressions.push(TemplateLiteralParse(range));
            index = end;
        }
        else {
            const [start, end] = Range(pattern, index);
            const range = pattern.slice(start, end);
            if (range.length > 0)
                expressions.push(TemplateLiteralParse(range));
            index = end - 1;
        }
    }
    return ((expressions.length === 0) ? { type: 'const', const: '' } :
        (expressions.length === 1) ? expressions[0] :
            { type: 'and', expr: expressions });
}
// ------------------------------------------------------------------
// TemplateLiteralParse
// ------------------------------------------------------------------
/** Parses a pattern and returns an expression tree */
function TemplateLiteralParse(pattern) {
    // prettier-ignore
    return (IsGroup(pattern) ? TemplateLiteralParse(InGroup(pattern)) :
        IsPrecedenceOr(pattern) ? Or(pattern) :
            IsPrecedenceAnd(pattern) ? And(pattern) :
                { type: 'const', const: Unescape(pattern) });
}
// ------------------------------------------------------------------
// TemplateLiteralParseExact
// ------------------------------------------------------------------
/** Parses a pattern and strips forward and trailing ^ and $ */
function TemplateLiteralParseExact(pattern) {
    return TemplateLiteralParse(pattern.slice(1, pattern.length - 1));
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/template-literal/finite.mjs


// ------------------------------------------------------------------
// TemplateLiteralFiniteError
// ------------------------------------------------------------------
class TemplateLiteralFiniteError extends TypeBoxError {
}
// ------------------------------------------------------------------
// IsTemplateLiteralFiniteCheck
// ------------------------------------------------------------------
// prettier-ignore
function IsNumberExpression(expression) {
    return (expression.type === 'or' &&
        expression.expr.length === 2 &&
        expression.expr[0].type === 'const' &&
        expression.expr[0].const === '0' &&
        expression.expr[1].type === 'const' &&
        expression.expr[1].const === '[1-9][0-9]*');
}
// prettier-ignore
function IsBooleanExpression(expression) {
    return (expression.type === 'or' &&
        expression.expr.length === 2 &&
        expression.expr[0].type === 'const' &&
        expression.expr[0].const === 'true' &&
        expression.expr[1].type === 'const' &&
        expression.expr[1].const === 'false');
}
// prettier-ignore
function IsStringExpression(expression) {
    return expression.type === 'const' && expression.const === '.*';
}
// ------------------------------------------------------------------
// IsTemplateLiteralExpressionFinite
// ------------------------------------------------------------------
// prettier-ignore
function IsTemplateLiteralExpressionFinite(expression) {
    return (IsNumberExpression(expression) || IsStringExpression(expression) ? false :
        IsBooleanExpression(expression) ? true :
            (expression.type === 'and') ? expression.expr.every((expr) => IsTemplateLiteralExpressionFinite(expr)) :
                (expression.type === 'or') ? expression.expr.every((expr) => IsTemplateLiteralExpressionFinite(expr)) :
                    (expression.type === 'const') ? true :
                        (() => { throw new TemplateLiteralFiniteError(`Unknown expression type`); })());
}
/** Returns true if this TemplateLiteral resolves to a finite set of values */
function IsTemplateLiteralFinite(schema) {
    const expression = TemplateLiteralParseExact(schema.pattern);
    return IsTemplateLiteralExpressionFinite(expression);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/template-literal/generate.mjs



// ------------------------------------------------------------------
// TemplateLiteralGenerateError
// ------------------------------------------------------------------
class TemplateLiteralGenerateError extends TypeBoxError {
}
// ------------------------------------------------------------------
// TemplateLiteralExpressionGenerate
// ------------------------------------------------------------------
// prettier-ignore
function* GenerateReduce(buffer) {
    if (buffer.length === 1)
        return yield* buffer[0];
    for (const left of buffer[0]) {
        for (const right of GenerateReduce(buffer.slice(1))) {
            yield `${left}${right}`;
        }
    }
}
// prettier-ignore
function* GenerateAnd(expression) {
    return yield* GenerateReduce(expression.expr.map((expr) => [...TemplateLiteralExpressionGenerate(expr)]));
}
// prettier-ignore
function* GenerateOr(expression) {
    for (const expr of expression.expr)
        yield* TemplateLiteralExpressionGenerate(expr);
}
// prettier-ignore
function* GenerateConst(expression) {
    return yield expression.const;
}
function* TemplateLiteralExpressionGenerate(expression) {
    return expression.type === 'and'
        ? yield* GenerateAnd(expression)
        : expression.type === 'or'
            ? yield* GenerateOr(expression)
            : expression.type === 'const'
                ? yield* GenerateConst(expression)
                : (() => {
                    throw new TemplateLiteralGenerateError('Unknown expression');
                })();
}
/** Generates a tuple of strings from the given TemplateLiteral. Returns an empty tuple if infinite. */
function TemplateLiteralGenerate(schema) {
    const expression = TemplateLiteralParseExact(schema.pattern);
    // prettier-ignore
    return (IsTemplateLiteralExpressionFinite(expression)
        ? [...TemplateLiteralExpressionGenerate(expression)]
        : []);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/literal/literal.mjs

/** `[Json]` Creates a Literal type */
function Literal(value, options = {}) {
    return {
        ...options,
        [Kind]: 'Literal',
        const: value,
        type: typeof value,
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/literal/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/boolean/boolean.mjs

/** `[Json]` Creates a Boolean type */
function Boolean(options = {}) {
    return {
        ...options,
        [Kind]: 'Boolean',
        type: 'boolean',
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/boolean/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/bigint/bigint.mjs

/** `[JavaScript]` Creates a BigInt type */
function BigInt(options = {}) {
    return {
        ...options,
        [Kind]: 'BigInt',
        type: 'bigint',
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/bigint/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/number/number.mjs

/** `[Json]` Creates a Number type */
function number_Number(options = {}) {
    return {
        ...options,
        [Kind]: 'Number',
        type: 'number',
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/number/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/string/string.mjs

/** `[Json]` Creates a String type */
function string_String(options = {}) {
    return { ...options, [Kind]: 'String', type: 'string' };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/string/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/template-literal/syntax.mjs







// ------------------------------------------------------------------
// SyntaxParsers
// ------------------------------------------------------------------
// prettier-ignore
function* FromUnion(syntax) {
    const trim = syntax.trim().replace(/"|'/g, '');
    return (trim === 'boolean' ? yield Boolean() :
        trim === 'number' ? yield number_Number() :
            trim === 'bigint' ? yield BigInt() :
                trim === 'string' ? yield string_String() :
                    yield (() => {
                        const literals = trim.split('|').map((literal) => Literal(literal.trim()));
                        return (literals.length === 0 ? Never() :
                            literals.length === 1 ? literals[0] :
                                UnionEvaluated(literals));
                    })());
}
// prettier-ignore
function* FromTerminal(syntax) {
    if (syntax[1] !== '{') {
        const L = Literal('$');
        const R = FromSyntax(syntax.slice(1));
        return yield* [L, ...R];
    }
    for (let i = 2; i < syntax.length; i++) {
        if (syntax[i] === '}') {
            const L = FromUnion(syntax.slice(2, i));
            const R = FromSyntax(syntax.slice(i + 1));
            return yield* [...L, ...R];
        }
    }
    yield Literal(syntax);
}
// prettier-ignore
function* FromSyntax(syntax) {
    for (let i = 0; i < syntax.length; i++) {
        if (syntax[i] === '$') {
            const L = Literal(syntax.slice(0, i));
            const R = FromTerminal(syntax.slice(i));
            return yield* [L, ...R];
        }
    }
    yield Literal(syntax);
}
/** Parses TemplateLiteralSyntax and returns a tuple of TemplateLiteralKinds */
function TemplateLiteralSyntax(syntax) {
    return [...FromSyntax(syntax)];
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/template-literal/pattern.mjs



// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// ------------------------------------------------------------------
// TemplateLiteralPatternError
// ------------------------------------------------------------------
class TemplateLiteralPatternError extends TypeBoxError {
}
// ------------------------------------------------------------------
// TemplateLiteralPattern
// ------------------------------------------------------------------
function Escape(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
// prettier-ignore
function pattern_Visit(schema, acc) {
    return (IsTemplateLiteral(schema) ? schema.pattern.slice(1, schema.pattern.length - 1) :
        IsUnion(schema) ? `(${schema.anyOf.map((schema) => pattern_Visit(schema, acc)).join('|')})` :
            kind_IsNumber(schema) ? `${acc}${PatternNumber}` :
                IsInteger(schema) ? `${acc}${PatternNumber}` :
                    kind_IsBigInt(schema) ? `${acc}${PatternNumber}` :
                        kind_IsString(schema) ? `${acc}${PatternString}` :
                            IsLiteral(schema) ? `${acc}${Escape(schema.const.toString())}` :
                                kind_IsBoolean(schema) ? `${acc}${PatternBoolean}` :
                                    (() => { throw new TemplateLiteralPatternError(`Unexpected Kind '${schema[Kind]}'`); })());
}
function TemplateLiteralPattern(kinds) {
    return `^${kinds.map((schema) => pattern_Visit(schema, '')).join('')}\$`;
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/template-literal/union.mjs



/** Returns a Union from the given TemplateLiteral */
function TemplateLiteralToUnion(schema) {
    const R = TemplateLiteralGenerate(schema);
    const L = R.map((S) => Literal(S));
    return UnionEvaluated(L);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/template-literal/template-literal.mjs




/** `[Json]` Creates a TemplateLiteral type */
// prettier-ignore
function TemplateLiteral(unresolved, options = {}) {
    const pattern = IsString(unresolved)
        ? TemplateLiteralPattern(TemplateLiteralSyntax(unresolved))
        : TemplateLiteralPattern(unresolved);
    return { ...options, [Kind]: 'TemplateLiteral', type: 'string', pattern };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/template-literal/index.mjs








;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/indexed/indexed-property-keys.mjs

// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function FromTemplateLiteral(T) {
    const R = TemplateLiteralGenerate(T);
    return R.map(S => S.toString());
}
// prettier-ignore
function indexed_property_keys_FromUnion(T) {
    const Acc = [];
    for (const L of T)
        Acc.push(...IndexPropertyKeys(L));
    return Acc;
}
// prettier-ignore
function FromLiteral(T) {
    return ([T.toString()] // TS 5.4 observes TLiteralValue as not having a toString()
    );
}
/** Returns a tuple of PropertyKeys derived from the given TSchema */
// prettier-ignore
function IndexPropertyKeys(T) {
    return [...new Set((IsTemplateLiteral(T) ? FromTemplateLiteral(T) :
            IsUnion(T) ? indexed_property_keys_FromUnion(T.anyOf) :
                IsLiteral(T) ? FromLiteral(T.const) :
                    kind_IsNumber(T) ? ['[number]'] :
                        IsInteger(T) ? ['[number]'] :
                            []))];
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/indexed/indexed-from-mapped-result.mjs



// prettier-ignore
function FromProperties(T, P, options) {
    const Acc = {};
    for (const K2 of Object.getOwnPropertyNames(P)) {
        Acc[K2] = Index(T, IndexPropertyKeys(P[K2]), options);
    }
    return Acc;
}
// prettier-ignore
function FromMappedResult(T, R, options) {
    return FromProperties(T, R.properties, options);
}
// prettier-ignore
function IndexFromMappedResult(T, R, options) {
    const P = FromMappedResult(T, R, options);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/indexed/indexed.mjs







// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function FromRest(T, K) {
    return T.map(L => IndexFromPropertyKey(L, K));
}
// prettier-ignore
function FromIntersectRest(T) {
    return T.filter(L => !IsNever(L));
}
// prettier-ignore
function FromIntersect(T, K) {
    return (IntersectEvaluated(FromIntersectRest(FromRest(T, K))));
}
// prettier-ignore
function FromUnionRest(T) {
    return (T.some(L => IsNever(L))
        ? []
        : T);
}
// prettier-ignore
function indexed_FromUnion(T, K) {
    return (UnionEvaluated(FromUnionRest(FromRest(T, K))));
}
// prettier-ignore
function FromTuple(T, K) {
    return (K in T ? T[K] :
        K === '[number]' ? UnionEvaluated(T) :
            Never());
}
// prettier-ignore
function FromArray(T, K) {
    return (K === '[number]'
        ? T
        : Never());
}
// prettier-ignore
function FromProperty(T, K) {
    return (K in T ? T[K] : Never());
}
// prettier-ignore
function IndexFromPropertyKey(T, K) {
    return (IsIntersect(T) ? FromIntersect(T.allOf, K) :
        IsUnion(T) ? indexed_FromUnion(T.anyOf, K) :
            IsTuple(T) ? FromTuple(T.items ?? [], K) :
                kind_IsArray(T) ? FromArray(T.items, K) :
                    kind_IsObject(T) ? FromProperty(T.properties, K) :
                        Never());
}
// prettier-ignore
function IndexFromPropertyKeys(T, K) {
    return K.map(L => IndexFromPropertyKey(T, L));
}
// prettier-ignore
function FromSchema(T, K) {
    return (UnionEvaluated(IndexFromPropertyKeys(T, K)));
}
/** `[Json]` Returns an Indexed property type for the given keys */
function Index(T, K, options = {}) {
    // prettier-ignore
    return (IsMappedResult(K) ? CloneType(IndexFromMappedResult(T, K, options)) :
        IsMappedKey(K) ? CloneType(IndexFromMappedKey(T, K, options)) :
            IsSchema(K) ? CloneType(FromSchema(T, IndexPropertyKeys(K)), options) :
                CloneType(FromSchema(T, K), options));
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/indexed/indexed-from-mapped-key.mjs


// prettier-ignore
function MappedIndexPropertyKey(T, K, options) {
    return { [K]: Index(T, [K], options) };
}
// prettier-ignore
function MappedIndexPropertyKeys(T, K, options) {
    return K.reduce((Acc, L) => {
        return { ...Acc, ...MappedIndexPropertyKey(T, L, options) };
    }, {});
}
// prettier-ignore
function MappedIndexProperties(T, K, options) {
    return MappedIndexPropertyKeys(T, K.keys, options);
}
// prettier-ignore
function IndexFromMappedKey(T, K, options) {
    const P = MappedIndexProperties(T, K, options);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/indexed/index.mjs





;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/iterator/iterator.mjs


/** `[JavaScript]` Creates an Iterator type */
function Iterator(items, options = {}) {
    return {
        ...options,
        [Kind]: 'Iterator',
        type: 'Iterator',
        items: CloneType(items),
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/iterator/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/object/object.mjs


// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

/** `[Json]` Creates an Object type */
function _Object(properties, options = {}) {
    const propertyKeys = globalThis.Object.getOwnPropertyNames(properties);
    const optionalKeys = propertyKeys.filter((key) => IsOptional(properties[key]));
    const requiredKeys = propertyKeys.filter((name) => !optionalKeys.includes(name));
    const clonedAdditionalProperties = IsSchema(options.additionalProperties) ? { additionalProperties: CloneType(options.additionalProperties) } : {};
    const clonedProperties = {};
    for (const key of propertyKeys)
        clonedProperties[key] = CloneType(properties[key]);
    return (requiredKeys.length > 0
        ? { ...options, ...clonedAdditionalProperties, [Kind]: 'Object', type: 'object', properties: clonedProperties, required: requiredKeys }
        : { ...options, ...clonedAdditionalProperties, [Kind]: 'Object', type: 'object', properties: clonedProperties });
}
/** `[Json]` Creates an Object type */
const object_Object = _Object;

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/object/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/promise/promise.mjs


/** `[JavaScript]` Creates a Promise type */
function Promise(item, options = {}) {
    return {
        ...options,
        [Kind]: 'Promise',
        type: 'Promise',
        item: CloneType(item),
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/promise/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/readonly/readonly.mjs





function RemoveReadonly(schema) {
    return Discard(CloneType(schema), [ReadonlyKind]);
}
function AddReadonly(schema) {
    return { ...CloneType(schema), [ReadonlyKind]: 'Readonly' };
}
// prettier-ignore
function ReadonlyWithFlag(schema, F) {
    return (F === false
        ? RemoveReadonly(schema)
        : AddReadonly(schema));
}
/** `[Json]` Creates a Readonly property */
function Readonly(schema, enable) {
    const F = enable ?? true;
    return IsMappedResult(schema) ? ReadonlyFromMappedResult(schema, F) : ReadonlyWithFlag(schema, F);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/readonly/readonly-from-mapped-result.mjs


// prettier-ignore
function readonly_from_mapped_result_FromProperties(K, F) {
    const Acc = {};
    for (const K2 of globalThis.Object.getOwnPropertyNames(K))
        Acc[K2] = Readonly(K[K2], F);
    return Acc;
}
// prettier-ignore
function readonly_from_mapped_result_FromMappedResult(R, F) {
    return readonly_from_mapped_result_FromProperties(R.properties, F);
}
// prettier-ignore
function ReadonlyFromMappedResult(R, F) {
    const P = readonly_from_mapped_result_FromMappedResult(R, F);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/readonly/index.mjs



;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/tuple/tuple.mjs


/** `[Json]` Creates a Tuple type */
function Tuple(items, options = {}) {
    // return TupleResolver.Resolve(T)
    const [additionalItems, minItems, maxItems] = [false, items.length, items.length];
    // prettier-ignore
    return (items.length > 0 ?
        { ...options, [Kind]: 'Tuple', type: 'array', items: CloneRest(items), additionalItems, minItems, maxItems } :
        { ...options, [Kind]: 'Tuple', type: 'array', minItems, maxItems });
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/tuple/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/mapped/mapped.mjs



// evaluation types














// operator

// mapping types

// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function mapped_FromMappedResult(K, P) {
    return (K in P
        ? FromSchemaType(K, P[K])
        : MappedResult(P));
}
// prettier-ignore
function MappedKeyToKnownMappedResultProperties(K) {
    return { [K]: Literal(K) };
}
// prettier-ignore
function MappedKeyToUnknownMappedResultProperties(P) {
    const Acc = {};
    for (const L of P)
        Acc[L] = Literal(L);
    return Acc;
}
// prettier-ignore
function MappedKeyToMappedResultProperties(K, P) {
    return (SetIncludes(P, K)
        ? MappedKeyToKnownMappedResultProperties(K)
        : MappedKeyToUnknownMappedResultProperties(P));
}
// prettier-ignore
function FromMappedKey(K, P) {
    const R = MappedKeyToMappedResultProperties(K, P);
    return mapped_FromMappedResult(K, R);
}
// prettier-ignore
function mapped_FromRest(K, T) {
    return T.map(L => FromSchemaType(K, L));
}
// prettier-ignore
function mapped_FromProperties(K, T) {
    const Acc = {};
    for (const K2 of globalThis.Object.getOwnPropertyNames(T))
        Acc[K2] = FromSchemaType(K, T[K2]);
    return Acc;
}
// prettier-ignore
function FromSchemaType(K, T) {
    return (
    // unevaluated modifier types
    IsOptional(T) ? Optional(FromSchemaType(K, Discard(T, [OptionalKind]))) :
        IsReadonly(T) ? Readonly(FromSchemaType(K, Discard(T, [ReadonlyKind]))) :
            // unevaluated mapped types
            IsMappedResult(T) ? mapped_FromMappedResult(K, T.properties) :
                IsMappedKey(T) ? FromMappedKey(K, T.keys) :
                    // unevaluated types
                    IsConstructor(T) ? Constructor(mapped_FromRest(K, T.parameters), FromSchemaType(K, T.returns)) :
                        kind_IsFunction(T) ? Function(mapped_FromRest(K, T.parameters), FromSchemaType(K, T.returns)) :
                            kind_IsAsyncIterator(T) ? AsyncIterator(FromSchemaType(K, T.items)) :
                                kind_IsIterator(T) ? Iterator(FromSchemaType(K, T.items)) :
                                    IsIntersect(T) ? Intersect(mapped_FromRest(K, T.allOf)) :
                                        IsUnion(T) ? Union(mapped_FromRest(K, T.anyOf)) :
                                            IsTuple(T) ? Tuple(mapped_FromRest(K, T.items ?? [])) :
                                                kind_IsObject(T) ? object_Object(mapped_FromProperties(K, T.properties)) :
                                                    kind_IsArray(T) ? array_Array(FromSchemaType(K, T.items)) :
                                                        IsPromise(T) ? Promise(FromSchemaType(K, T.item)) :
                                                            T);
}
// prettier-ignore
function MappedFunctionReturnType(K, T) {
    const Acc = {};
    for (const L of K)
        Acc[L] = FromSchemaType(L, T);
    return Acc;
}
/** `[Json]` Creates a Mapped object type */
function Mapped(key, map, options = {}) {
    const K = IsSchema(key) ? IndexPropertyKeys(key) : key;
    const RT = map({ [Kind]: 'MappedKey', keys: K });
    const R = MappedFunctionReturnType(K, RT);
    return CloneType(object_Object(R), options);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/mapped/index.mjs




;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/optional/optional.mjs





function RemoveOptional(schema) {
    return Discard(CloneType(schema), [OptionalKind]);
}
function AddOptional(schema) {
    return { ...CloneType(schema), [OptionalKind]: 'Optional' };
}
// prettier-ignore
function OptionalWithFlag(schema, F) {
    return (F === false
        ? RemoveOptional(schema)
        : AddOptional(schema));
}
/** `[Json]` Creates a Optional property */
function Optional(schema, enable) {
    const F = enable ?? true;
    return IsMappedResult(schema) ? OptionalFromMappedResult(schema, F) : OptionalWithFlag(schema, F);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/optional/optional-from-mapped-result.mjs


// prettier-ignore
function optional_from_mapped_result_FromProperties(P, F) {
    const Acc = {};
    for (const K2 of globalThis.Object.getOwnPropertyNames(P))
        Acc[K2] = Optional(P[K2], F);
    return Acc;
}
// prettier-ignore
function optional_from_mapped_result_FromMappedResult(R, F) {
    return optional_from_mapped_result_FromProperties(R.properties, F);
}
// prettier-ignore
function OptionalFromMappedResult(R, F) {
    const P = optional_from_mapped_result_FromMappedResult(R, F);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/optional/index.mjs



;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/intersect/intersect-create.mjs


// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// ------------------------------------------------------------------
// IntersectCreate
// ------------------------------------------------------------------
// prettier-ignore
function IntersectCreate(T, options) {
    const allObjects = T.every((schema) => kind_IsObject(schema));
    const clonedUnevaluatedProperties = IsSchema(options.unevaluatedProperties)
        ? { unevaluatedProperties: CloneType(options.unevaluatedProperties) }
        : {};
    return ((options.unevaluatedProperties === false || IsSchema(options.unevaluatedProperties) || allObjects
        ? { ...options, ...clonedUnevaluatedProperties, [Kind]: 'Intersect', type: 'object', allOf: CloneRest(T) }
        : { ...options, ...clonedUnevaluatedProperties, [Kind]: 'Intersect', allOf: CloneRest(T) }));
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/intersect/intersect-evaluated.mjs






// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function IsIntersectOptional(T) {
    return T.every(L => IsOptional(L));
}
// prettier-ignore
function intersect_evaluated_RemoveOptionalFromType(T) {
    return (Discard(T, [OptionalKind]));
}
// prettier-ignore
function intersect_evaluated_RemoveOptionalFromRest(T) {
    return T.map(L => IsOptional(L) ? intersect_evaluated_RemoveOptionalFromType(L) : L);
}
// prettier-ignore
function ResolveIntersect(T, options) {
    return (IsIntersectOptional(T)
        ? Optional(IntersectCreate(intersect_evaluated_RemoveOptionalFromRest(T), options))
        : IntersectCreate(intersect_evaluated_RemoveOptionalFromRest(T), options));
}
/** `[Json]` Creates an evaluated Intersect type */
function IntersectEvaluated(T, options = {}) {
    if (T.length === 0)
        return Never(options);
    if (T.length === 1)
        return CloneType(T[0], options);
    if (T.some((schema) => IsTransform(schema)))
        throw new Error('Cannot intersect transform types');
    return ResolveIntersect(T, options);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/intersect/intersect-type.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/intersect/intersect.mjs



// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

/** `[Json]` Creates an evaluated Intersect type */
function Intersect(T, options = {}) {
    if (T.length === 0)
        return Never(options);
    if (T.length === 1)
        return CloneType(T[0], options);
    if (T.some((schema) => IsTransform(schema)))
        throw new Error('Cannot intersect transform types');
    return IntersectCreate(T, options);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/intersect/index.mjs




;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/awaited/awaited.mjs



// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function awaited_FromRest(T) {
    return T.map(L => AwaitedResolve(L));
}
// prettier-ignore
function awaited_FromIntersect(T) {
    return Intersect(awaited_FromRest(T));
}
// prettier-ignore
function awaited_FromUnion(T) {
    return Union(awaited_FromRest(T));
}
// prettier-ignore
function FromPromise(T) {
    return AwaitedResolve(T);
}
// ----------------------------------------------------------------
// AwaitedResolve
// ----------------------------------------------------------------
// prettier-ignore
function AwaitedResolve(T) {
    return (IsIntersect(T) ? awaited_FromIntersect(T.allOf) :
        IsUnion(T) ? awaited_FromUnion(T.anyOf) :
            IsPromise(T) ? FromPromise(T.item) :
                T);
}
/** `[JavaScript]` Constructs a type by recursively unwrapping Promise types */
function Awaited(T, options = {}) {
    return CloneType(AwaitedResolve(T), options);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/awaited/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/keyof/keyof-property-keys.mjs

// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function keyof_property_keys_FromRest(T) {
    const Acc = [];
    for (const L of T)
        Acc.push(KeyOfPropertyKeys(L));
    return Acc;
}
// prettier-ignore
function keyof_property_keys_FromIntersect(T) {
    const C = keyof_property_keys_FromRest(T);
    const R = SetUnionMany(C);
    return R;
}
// prettier-ignore
function keyof_property_keys_FromUnion(T) {
    const C = keyof_property_keys_FromRest(T);
    const R = SetIntersectMany(C);
    return R;
}
// prettier-ignore
function keyof_property_keys_FromTuple(T) {
    return T.map((_, I) => I.toString());
}
// prettier-ignore
function keyof_property_keys_FromArray(_) {
    return (['[number]']);
}
// prettier-ignore
function keyof_property_keys_FromProperties(T) {
    return (globalThis.Object.getOwnPropertyNames(T));
}
// ------------------------------------------------------------------
// FromPatternProperties
// ------------------------------------------------------------------
// prettier-ignore
function FromPatternProperties(patternProperties) {
    if (!includePatternProperties)
        return [];
    const patternPropertyKeys = globalThis.Object.getOwnPropertyNames(patternProperties);
    return patternPropertyKeys.map(key => {
        return (key[0] === '^' && key[key.length - 1] === '$')
            ? key.slice(1, key.length - 1)
            : key;
    });
}
/** Returns a tuple of PropertyKeys derived from the given TSchema. */
// prettier-ignore
function KeyOfPropertyKeys(T) {
    return (IsIntersect(T) ? keyof_property_keys_FromIntersect(T.allOf) :
        IsUnion(T) ? keyof_property_keys_FromUnion(T.anyOf) :
            IsTuple(T) ? keyof_property_keys_FromTuple(T.items ?? []) :
                kind_IsArray(T) ? keyof_property_keys_FromArray(T.items) :
                    kind_IsObject(T) ? keyof_property_keys_FromProperties(T.properties) :
                        IsRecord(T) ? FromPatternProperties(T.patternProperties) :
                            []);
}
// ----------------------------------------------------------------
// KeyOfPattern
// ----------------------------------------------------------------
let includePatternProperties = false;
/** Returns a regular expression pattern derived from the given TSchema */
function KeyOfPattern(schema) {
    includePatternProperties = true;
    const keys = KeyOfPropertyKeys(schema);
    includePatternProperties = false;
    const pattern = keys.map((key) => `(${key})`);
    return `^(${pattern.join('|')})$`;
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/keyof/keyof.mjs






// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function KeyOfPropertyKeysToRest(T) {
    return T.map(L => L === '[number]' ? number_Number() : Literal(L));
}
/** `[Json]` Creates a KeyOf type */
function KeyOf(T, options = {}) {
    if (IsMappedResult(T)) {
        return KeyOfFromMappedResult(T, options);
    }
    else {
        const K = KeyOfPropertyKeys(T);
        const S = KeyOfPropertyKeysToRest(K);
        const U = UnionEvaluated(S);
        return CloneType(U, options);
    }
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/keyof/keyof-from-mapped-result.mjs


// prettier-ignore
function keyof_from_mapped_result_FromProperties(K, options) {
    const Acc = {};
    for (const K2 of globalThis.Object.getOwnPropertyNames(K))
        Acc[K2] = KeyOf(K[K2], options);
    return Acc;
}
// prettier-ignore
function keyof_from_mapped_result_FromMappedResult(R, options) {
    return keyof_from_mapped_result_FromProperties(R.properties, options);
}
// prettier-ignore
function KeyOfFromMappedResult(R, options) {
    const P = keyof_from_mapped_result_FromMappedResult(R, options);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/keyof/keyof-property-entries.mjs


/**
 * `[Utility]` Resolves an array of keys and schemas from the given schema. This method is faster
 * than obtaining the keys and resolving each individually via indexing. This method was written
 * accellerate Intersect and Union encoding.
 */
function KeyOfPropertyEntries(schema) {
    const keys = KeyOfPropertyKeys(schema);
    const schemas = IndexFromPropertyKeys(schema, keys);
    return keys.map((_, index) => [keys[index], schemas[index]]);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/keyof/index.mjs





;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/composite/composite.mjs





// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function CompositeKeys(T) {
    const Acc = [];
    for (const L of T)
        Acc.push(...KeyOfPropertyKeys(L));
    return SetDistinct(Acc);
}
// prettier-ignore
function FilterNever(T) {
    return T.filter(L => !IsNever(L));
}
// prettier-ignore
function CompositeProperty(T, K) {
    const Acc = [];
    for (const L of T)
        Acc.push(...IndexFromPropertyKeys(L, [K]));
    return FilterNever(Acc);
}
// prettier-ignore
function CompositeProperties(T, K) {
    const Acc = {};
    for (const L of K) {
        Acc[L] = IntersectEvaluated(CompositeProperty(T, L));
    }
    return Acc;
}
// prettier-ignore
function Composite(T, options = {}) {
    const K = CompositeKeys(T);
    const P = CompositeProperties(T, K);
    const R = object_Object(P, options);
    return R;
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/composite/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/date/date.mjs

/** `[JavaScript]` Creates a Date type */
function date_Date(options = {}) {
    return {
        ...options,
        [Kind]: 'Date',
        type: 'Date',
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/date/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/null/null.mjs

/** `[Json]` Creates a Null type */
function Null(options = {}) {
    return {
        ...options,
        [Kind]: 'Null',
        type: 'null',
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/null/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/symbol/symbol.mjs

/** `[JavaScript]` Creates a Symbol type */
function symbol_Symbol(options) {
    return { ...options, [Kind]: 'Symbol', type: 'symbol' };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/symbol/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/undefined/undefined.mjs

/** `[JavaScript]` Creates a Undefined type */
function Undefined(options = {}) {
    return { ...options, [Kind]: 'Undefined', type: 'undefined' };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/undefined/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/uint8array/uint8array.mjs

/** `[JavaScript]` Creates a Uint8Array type */
function uint8array_Uint8Array(options = {}) {
    return { ...options, [Kind]: 'Uint8Array', type: 'Uint8Array' };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/uint8array/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/unknown/unknown.mjs

/** `[Json]` Creates an Unknown type */
function Unknown(options = {}) {
    return {
        ...options,
        [Kind]: 'Unknown',
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/unknown/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/const/const.mjs














// ------------------------------------------------------------------
// ValueGuard
// ------------------------------------------------------------------

// prettier-ignore
function const_FromArray(T) {
    return T.map(L => FromValue(L, false));
}
// prettier-ignore
function const_FromProperties(value) {
    const Acc = {};
    for (const K of globalThis.Object.getOwnPropertyNames(value))
        Acc[K] = Readonly(FromValue(value[K], false));
    return Acc;
}
function ConditionalReadonly(T, root) {
    return (root === true ? T : Readonly(T));
}
// prettier-ignore
function FromValue(value, root) {
    return (IsAsyncIterator(value) ? ConditionalReadonly(Any(), root) :
        IsIterator(value) ? ConditionalReadonly(Any(), root) :
            IsArray(value) ? Readonly(Tuple(const_FromArray(value))) :
                IsUint8Array(value) ? uint8array_Uint8Array() :
                    IsDate(value) ? date_Date() :
                        IsObject(value) ? ConditionalReadonly(object_Object(const_FromProperties(value)), root) :
                            IsFunction(value) ? ConditionalReadonly(Function([], Unknown()), root) :
                                IsUndefined(value) ? Undefined() :
                                    IsNull(value) ? Null() :
                                        IsSymbol(value) ? symbol_Symbol() :
                                            IsBigInt(value) ? BigInt() :
                                                IsNumber(value) ? Literal(value) :
                                                    IsBoolean(value) ? Literal(value) :
                                                        IsString(value) ? Literal(value) :
                                                            object_Object({}));
}
/** `[JavaScript]` Creates a readonly const type from the given value. */
function Const(T, options = {}) {
    return CloneType(FromValue(T, true), options);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/const/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/constructor-parameters/constructor-parameters.mjs


/** `[JavaScript]` Extracts the ConstructorParameters from the given Constructor type */
function ConstructorParameters(schema, options = {}) {
    return Tuple(CloneRest(schema.parameters), { ...options });
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/constructor-parameters/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/deref/deref.mjs



// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

function deref_FromRest(schema, references) {
    return schema.map((schema) => Deref(schema, references));
}
// prettier-ignore
function deref_FromProperties(properties, references) {
    const Acc = {};
    for (const K of globalThis.Object.getOwnPropertyNames(properties)) {
        Acc[K] = Deref(properties[K], references);
    }
    return Acc;
}
// prettier-ignore
function FromConstructor(schema, references) {
    schema.parameters = deref_FromRest(schema.parameters, references);
    schema.returns = Deref(schema.returns, references);
    return schema;
}
// prettier-ignore
function FromFunction(schema, references) {
    schema.parameters = deref_FromRest(schema.parameters, references);
    schema.returns = Deref(schema.returns, references);
    return schema;
}
// prettier-ignore
function deref_FromIntersect(schema, references) {
    schema.allOf = deref_FromRest(schema.allOf, references);
    return schema;
}
// prettier-ignore
function deref_FromUnion(schema, references) {
    schema.anyOf = deref_FromRest(schema.anyOf, references);
    return schema;
}
// prettier-ignore
function deref_FromTuple(schema, references) {
    if (IsUndefined(schema.items))
        return schema;
    schema.items = deref_FromRest(schema.items, references);
    return schema;
}
// prettier-ignore
function deref_FromArray(schema, references) {
    schema.items = Deref(schema.items, references);
    return schema;
}
// prettier-ignore
function FromObject(schema, references) {
    schema.properties = deref_FromProperties(schema.properties, references);
    return schema;
}
// prettier-ignore
function deref_FromPromise(schema, references) {
    schema.item = Deref(schema.item, references);
    return schema;
}
// prettier-ignore
function FromAsyncIterator(schema, references) {
    schema.items = Deref(schema.items, references);
    return schema;
}
// prettier-ignore
function FromIterator(schema, references) {
    schema.items = Deref(schema.items, references);
    return schema;
}
// prettier-ignore
function FromRef(schema, references) {
    const target = references.find(remote => remote.$id === schema.$ref);
    if (target === undefined)
        throw Error(`Unable to dereference schema with $id ${schema.$ref}`);
    const discard = Discard(target, ['$id']);
    return Deref(discard, references);
}
// prettier-ignore
function DerefResolve(schema, references) {
    return (IsConstructor(schema) ? FromConstructor(schema, references) :
        kind_IsFunction(schema) ? FromFunction(schema, references) :
            IsIntersect(schema) ? deref_FromIntersect(schema, references) :
                IsUnion(schema) ? deref_FromUnion(schema, references) :
                    IsTuple(schema) ? deref_FromTuple(schema, references) :
                        kind_IsArray(schema) ? deref_FromArray(schema, references) :
                            kind_IsObject(schema) ? FromObject(schema, references) :
                                IsPromise(schema) ? deref_FromPromise(schema, references) :
                                    kind_IsAsyncIterator(schema) ? FromAsyncIterator(schema, references) :
                                        kind_IsIterator(schema) ? FromIterator(schema, references) :
                                            IsRef(schema) ? FromRef(schema, references) :
                                                schema);
}
// ------------------------------------------------------------------
// TDeref
// ------------------------------------------------------------------
/** `[Json]` Creates a dereferenced type */
function Deref(schema, references) {
    return DerefResolve(CloneType(schema), CloneRest(references));
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/deref/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/enum/enum.mjs



// ------------------------------------------------------------------
// ValueGuard
// ------------------------------------------------------------------

/** `[Json]` Creates a Enum type */
function Enum(item, options = {}) {
    if (IsUndefined(item))
        throw new Error('Enum undefined or empty');
    const values1 = globalThis.Object.getOwnPropertyNames(item)
        .filter((key) => isNaN(key))
        .map((key) => item[key]);
    const values2 = [...new Set(values1)];
    const anyOf = values2.map((value) => Literal(value));
    return Union(anyOf, { ...options, [Hint]: 'Enum' });
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/enum/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/extends/extends-check.mjs










class ExtendsResolverError extends TypeBoxError {
}
var ExtendsResult;
(function (ExtendsResult) {
    ExtendsResult[ExtendsResult["Union"] = 0] = "Union";
    ExtendsResult[ExtendsResult["True"] = 1] = "True";
    ExtendsResult[ExtendsResult["False"] = 2] = "False";
})(ExtendsResult || (ExtendsResult = {}));
// ------------------------------------------------------------------
// IntoBooleanResult
// ------------------------------------------------------------------
// prettier-ignore
function IntoBooleanResult(result) {
    return result === ExtendsResult.False ? result : ExtendsResult.True;
}
// ------------------------------------------------------------------
// Throw
// ------------------------------------------------------------------
// prettier-ignore
function Throw(message) {
    throw new ExtendsResolverError(message);
}
// ------------------------------------------------------------------
// StructuralRight
// ------------------------------------------------------------------
// prettier-ignore
function IsStructuralRight(right) {
    return (type_IsNever(right) ||
        type_IsIntersect(right) ||
        type_IsUnion(right) ||
        type_IsUnknown(right) ||
        type_IsAny(right));
}
// prettier-ignore
function StructuralRight(left, right) {
    return (type_IsNever(right) ? FromNeverRight(left, right) :
        type_IsIntersect(right) ? FromIntersectRight(left, right) :
            type_IsUnion(right) ? FromUnionRight(left, right) :
                type_IsUnknown(right) ? FromUnknownRight(left, right) :
                    type_IsAny(right) ? FromAnyRight(left, right) :
                        Throw('StructuralRight'));
}
// ------------------------------------------------------------------
// Any
// ------------------------------------------------------------------
// prettier-ignore
function FromAnyRight(left, right) {
    return ExtendsResult.True;
}
// prettier-ignore
function FromAny(left, right) {
    return (type_IsIntersect(right) ? FromIntersectRight(left, right) :
        (type_IsUnion(right) && right.anyOf.some((schema) => type_IsAny(schema) || type_IsUnknown(schema))) ? ExtendsResult.True :
            type_IsUnion(right) ? ExtendsResult.Union :
                type_IsUnknown(right) ? ExtendsResult.True :
                    type_IsAny(right) ? ExtendsResult.True :
                        ExtendsResult.Union);
}
// ------------------------------------------------------------------
// Array
// ------------------------------------------------------------------
// prettier-ignore
function FromArrayRight(left, right) {
    return (type_IsUnknown(left) ? ExtendsResult.False :
        type_IsAny(left) ? ExtendsResult.Union :
            type_IsNever(left) ? ExtendsResult.True :
                ExtendsResult.False);
}
// prettier-ignore
function extends_check_FromArray(left, right) {
    return (type_IsObject(right) && IsObjectArrayLike(right) ? ExtendsResult.True :
        IsStructuralRight(right) ? StructuralRight(left, right) :
            !type_IsArray(right) ? ExtendsResult.False :
                IntoBooleanResult(extends_check_Visit(left.items, right.items)));
}
// ------------------------------------------------------------------
// AsyncIterator
// ------------------------------------------------------------------
// prettier-ignore
function extends_check_FromAsyncIterator(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        !type_IsAsyncIterator(right) ? ExtendsResult.False :
            IntoBooleanResult(extends_check_Visit(left.items, right.items)));
}
// ------------------------------------------------------------------
// BigInt
// ------------------------------------------------------------------
// prettier-ignore
function FromBigInt(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) ? FromObjectRight(left, right) :
            type_IsRecord(right) ? FromRecordRight(left, right) :
                type_IsBigInt(right) ? ExtendsResult.True :
                    ExtendsResult.False);
}
// ------------------------------------------------------------------
// Boolean
// ------------------------------------------------------------------
// prettier-ignore
function FromBooleanRight(left, right) {
    return (type_IsLiteralBoolean(left) ? ExtendsResult.True :
        type_IsBoolean(left) ? ExtendsResult.True :
            ExtendsResult.False);
}
// prettier-ignore
function FromBoolean(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) ? FromObjectRight(left, right) :
            type_IsRecord(right) ? FromRecordRight(left, right) :
                type_IsBoolean(right) ? ExtendsResult.True :
                    ExtendsResult.False);
}
// ------------------------------------------------------------------
// Constructor
// ------------------------------------------------------------------
// prettier-ignore
function extends_check_FromConstructor(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) ? FromObjectRight(left, right) :
            !type_IsConstructor(right) ? ExtendsResult.False :
                left.parameters.length > right.parameters.length ? ExtendsResult.False :
                    (!left.parameters.every((schema, index) => IntoBooleanResult(extends_check_Visit(right.parameters[index], schema)) === ExtendsResult.True)) ? ExtendsResult.False :
                        IntoBooleanResult(extends_check_Visit(left.returns, right.returns)));
}
// ------------------------------------------------------------------
// Date
// ------------------------------------------------------------------
// prettier-ignore
function FromDate(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) ? FromObjectRight(left, right) :
            type_IsRecord(right) ? FromRecordRight(left, right) :
                type_IsDate(right) ? ExtendsResult.True :
                    ExtendsResult.False);
}
// ------------------------------------------------------------------
// Function
// ------------------------------------------------------------------
// prettier-ignore
function extends_check_FromFunction(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) ? FromObjectRight(left, right) :
            !type_IsFunction(right) ? ExtendsResult.False :
                left.parameters.length > right.parameters.length ? ExtendsResult.False :
                    (!left.parameters.every((schema, index) => IntoBooleanResult(extends_check_Visit(right.parameters[index], schema)) === ExtendsResult.True)) ? ExtendsResult.False :
                        IntoBooleanResult(extends_check_Visit(left.returns, right.returns)));
}
// ------------------------------------------------------------------
// Integer
// ------------------------------------------------------------------
// prettier-ignore
function FromIntegerRight(left, right) {
    return (type_IsLiteral(left) && IsNumber(left.const) ? ExtendsResult.True :
        type_IsNumber(left) || type_IsInteger(left) ? ExtendsResult.True :
            ExtendsResult.False);
}
// prettier-ignore
function FromInteger(left, right) {
    return (type_IsInteger(right) || type_IsNumber(right) ? ExtendsResult.True :
        IsStructuralRight(right) ? StructuralRight(left, right) :
            type_IsObject(right) ? FromObjectRight(left, right) :
                type_IsRecord(right) ? FromRecordRight(left, right) :
                    ExtendsResult.False);
}
// ------------------------------------------------------------------
// Intersect
// ------------------------------------------------------------------
// prettier-ignore
function FromIntersectRight(left, right) {
    return right.allOf.every((schema) => extends_check_Visit(left, schema) === ExtendsResult.True)
        ? ExtendsResult.True
        : ExtendsResult.False;
}
// prettier-ignore
function extends_check_FromIntersect(left, right) {
    return left.allOf.some((schema) => extends_check_Visit(schema, right) === ExtendsResult.True)
        ? ExtendsResult.True
        : ExtendsResult.False;
}
// ------------------------------------------------------------------
// Iterator
// ------------------------------------------------------------------
// prettier-ignore
function extends_check_FromIterator(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        !type_IsIterator(right) ? ExtendsResult.False :
            IntoBooleanResult(extends_check_Visit(left.items, right.items)));
}
// ------------------------------------------------------------------
// Literal
// ------------------------------------------------------------------
// prettier-ignore
function extends_check_FromLiteral(left, right) {
    return (type_IsLiteral(right) && right.const === left.const ? ExtendsResult.True :
        IsStructuralRight(right) ? StructuralRight(left, right) :
            type_IsObject(right) ? FromObjectRight(left, right) :
                type_IsRecord(right) ? FromRecordRight(left, right) :
                    type_IsString(right) ? FromStringRight(left, right) :
                        type_IsNumber(right) ? FromNumberRight(left, right) :
                            type_IsInteger(right) ? FromIntegerRight(left, right) :
                                type_IsBoolean(right) ? FromBooleanRight(left, right) :
                                    ExtendsResult.False);
}
// ------------------------------------------------------------------
// Never
// ------------------------------------------------------------------
// prettier-ignore
function FromNeverRight(left, right) {
    return ExtendsResult.False;
}
// prettier-ignore
function FromNever(left, right) {
    return ExtendsResult.True;
}
// ------------------------------------------------------------------
// Not
// ------------------------------------------------------------------
// prettier-ignore
function UnwrapTNot(schema) {
    let [current, depth] = [schema, 0];
    while (true) {
        if (!type_IsNot(current))
            break;
        current = current.not;
        depth += 1;
    }
    return depth % 2 === 0 ? current : Unknown();
}
// prettier-ignore
function FromNot(left, right) {
    // TypeScript has no concept of negated types, and attempts to correctly check the negated
    // type at runtime would put TypeBox at odds with TypeScripts ability to statically infer
    // the type. Instead we unwrap to either unknown or T and continue evaluating.
    // prettier-ignore
    return (type_IsNot(left) ? extends_check_Visit(UnwrapTNot(left), right) :
        type_IsNot(right) ? extends_check_Visit(left, UnwrapTNot(right)) :
            Throw('Invalid fallthrough for Not'));
}
// ------------------------------------------------------------------
// Null
// ------------------------------------------------------------------
// prettier-ignore
function FromNull(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) ? FromObjectRight(left, right) :
            type_IsRecord(right) ? FromRecordRight(left, right) :
                type_IsNull(right) ? ExtendsResult.True :
                    ExtendsResult.False);
}
// ------------------------------------------------------------------
// Number
// ------------------------------------------------------------------
// prettier-ignore
function FromNumberRight(left, right) {
    return (type_IsLiteralNumber(left) ? ExtendsResult.True :
        type_IsNumber(left) || type_IsInteger(left) ? ExtendsResult.True :
            ExtendsResult.False);
}
// prettier-ignore
function FromNumber(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) ? FromObjectRight(left, right) :
            type_IsRecord(right) ? FromRecordRight(left, right) :
                type_IsInteger(right) || type_IsNumber(right) ? ExtendsResult.True :
                    ExtendsResult.False);
}
// ------------------------------------------------------------------
// Object
// ------------------------------------------------------------------
// prettier-ignore
function IsObjectPropertyCount(schema, count) {
    return Object.getOwnPropertyNames(schema.properties).length === count;
}
// prettier-ignore
function IsObjectStringLike(schema) {
    return IsObjectArrayLike(schema);
}
// prettier-ignore
function IsObjectSymbolLike(schema) {
    return IsObjectPropertyCount(schema, 0) || (IsObjectPropertyCount(schema, 1) && 'description' in schema.properties && type_IsUnion(schema.properties.description) && schema.properties.description.anyOf.length === 2 && ((type_IsString(schema.properties.description.anyOf[0]) &&
        type_IsUndefined(schema.properties.description.anyOf[1])) || (type_IsString(schema.properties.description.anyOf[1]) &&
        type_IsUndefined(schema.properties.description.anyOf[0]))));
}
// prettier-ignore
function IsObjectNumberLike(schema) {
    return IsObjectPropertyCount(schema, 0);
}
// prettier-ignore
function IsObjectBooleanLike(schema) {
    return IsObjectPropertyCount(schema, 0);
}
// prettier-ignore
function IsObjectBigIntLike(schema) {
    return IsObjectPropertyCount(schema, 0);
}
// prettier-ignore
function IsObjectDateLike(schema) {
    return IsObjectPropertyCount(schema, 0);
}
// prettier-ignore
function IsObjectUint8ArrayLike(schema) {
    return IsObjectArrayLike(schema);
}
// prettier-ignore
function IsObjectFunctionLike(schema) {
    const length = number_Number();
    return IsObjectPropertyCount(schema, 0) || (IsObjectPropertyCount(schema, 1) && 'length' in schema.properties && IntoBooleanResult(extends_check_Visit(schema.properties['length'], length)) === ExtendsResult.True);
}
// prettier-ignore
function IsObjectConstructorLike(schema) {
    return IsObjectPropertyCount(schema, 0);
}
// prettier-ignore
function IsObjectArrayLike(schema) {
    const length = number_Number();
    return IsObjectPropertyCount(schema, 0) || (IsObjectPropertyCount(schema, 1) && 'length' in schema.properties && IntoBooleanResult(extends_check_Visit(schema.properties['length'], length)) === ExtendsResult.True);
}
// prettier-ignore
function IsObjectPromiseLike(schema) {
    const then = Function([Any()], Any());
    return IsObjectPropertyCount(schema, 0) || (IsObjectPropertyCount(schema, 1) && 'then' in schema.properties && IntoBooleanResult(extends_check_Visit(schema.properties['then'], then)) === ExtendsResult.True);
}
// ------------------------------------------------------------------
// Property
// ------------------------------------------------------------------
// prettier-ignore
function Property(left, right) {
    return (extends_check_Visit(left, right) === ExtendsResult.False ? ExtendsResult.False :
        type_IsOptional(left) && !type_IsOptional(right) ? ExtendsResult.False :
            ExtendsResult.True);
}
// prettier-ignore
function FromObjectRight(left, right) {
    return (type_IsUnknown(left) ? ExtendsResult.False :
        type_IsAny(left) ? ExtendsResult.Union : (type_IsNever(left) ||
            (type_IsLiteralString(left) && IsObjectStringLike(right)) ||
            (type_IsLiteralNumber(left) && IsObjectNumberLike(right)) ||
            (type_IsLiteralBoolean(left) && IsObjectBooleanLike(right)) ||
            (type_IsSymbol(left) && IsObjectSymbolLike(right)) ||
            (type_IsBigInt(left) && IsObjectBigIntLike(right)) ||
            (type_IsString(left) && IsObjectStringLike(right)) ||
            (type_IsSymbol(left) && IsObjectSymbolLike(right)) ||
            (type_IsNumber(left) && IsObjectNumberLike(right)) ||
            (type_IsInteger(left) && IsObjectNumberLike(right)) ||
            (type_IsBoolean(left) && IsObjectBooleanLike(right)) ||
            (type_IsUint8Array(left) && IsObjectUint8ArrayLike(right)) ||
            (type_IsDate(left) && IsObjectDateLike(right)) ||
            (type_IsConstructor(left) && IsObjectConstructorLike(right)) ||
            (type_IsFunction(left) && IsObjectFunctionLike(right))) ? ExtendsResult.True :
            (type_IsRecord(left) && type_IsString(RecordKey(left))) ? (() => {
                // When expressing a Record with literal key values, the Record is converted into a Object with
                // the Hint assigned as `Record`. This is used to invert the extends logic.
                return right[Hint] === 'Record' ? ExtendsResult.True : ExtendsResult.False;
            })() :
                (type_IsRecord(left) && type_IsNumber(RecordKey(left))) ? (() => {
                    return IsObjectPropertyCount(right, 0) ? ExtendsResult.True : ExtendsResult.False;
                })() :
                    ExtendsResult.False);
}
// prettier-ignore
function extends_check_FromObject(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsRecord(right) ? FromRecordRight(left, right) :
            !type_IsObject(right) ? ExtendsResult.False :
                (() => {
                    for (const key of Object.getOwnPropertyNames(right.properties)) {
                        if (!(key in left.properties) && !type_IsOptional(right.properties[key])) {
                            return ExtendsResult.False;
                        }
                        if (type_IsOptional(right.properties[key])) {
                            return ExtendsResult.True;
                        }
                        if (Property(left.properties[key], right.properties[key]) === ExtendsResult.False) {
                            return ExtendsResult.False;
                        }
                    }
                    return ExtendsResult.True;
                })());
}
// ------------------------------------------------------------------
// Promise
// ------------------------------------------------------------------
// prettier-ignore
function extends_check_FromPromise(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) && IsObjectPromiseLike(right) ? ExtendsResult.True :
            !type_IsPromise(right) ? ExtendsResult.False :
                IntoBooleanResult(extends_check_Visit(left.item, right.item)));
}
// ------------------------------------------------------------------
// Record
// ------------------------------------------------------------------
// prettier-ignore
function RecordKey(schema) {
    return (PatternNumberExact in schema.patternProperties ? number_Number() :
        PatternStringExact in schema.patternProperties ? string_String() :
            Throw('Unknown record key pattern'));
}
// prettier-ignore
function RecordValue(schema) {
    return (PatternNumberExact in schema.patternProperties ? schema.patternProperties[PatternNumberExact] :
        PatternStringExact in schema.patternProperties ? schema.patternProperties[PatternStringExact] :
            Throw('Unable to get record value schema'));
}
// prettier-ignore
function FromRecordRight(left, right) {
    const [Key, Value] = [RecordKey(right), RecordValue(right)];
    return ((type_IsLiteralString(left) && type_IsNumber(Key) && IntoBooleanResult(extends_check_Visit(left, Value)) === ExtendsResult.True) ? ExtendsResult.True :
        type_IsUint8Array(left) && type_IsNumber(Key) ? extends_check_Visit(left, Value) :
            type_IsString(left) && type_IsNumber(Key) ? extends_check_Visit(left, Value) :
                type_IsArray(left) && type_IsNumber(Key) ? extends_check_Visit(left, Value) :
                    type_IsObject(left) ? (() => {
                        for (const key of Object.getOwnPropertyNames(left.properties)) {
                            if (Property(Value, left.properties[key]) === ExtendsResult.False) {
                                return ExtendsResult.False;
                            }
                        }
                        return ExtendsResult.True;
                    })() :
                        ExtendsResult.False);
}
// prettier-ignore
function FromRecord(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) ? FromObjectRight(left, right) :
            !type_IsRecord(right) ? ExtendsResult.False :
                extends_check_Visit(RecordValue(left), RecordValue(right)));
}
// ------------------------------------------------------------------
// RegExp
// ------------------------------------------------------------------
// prettier-ignore
function FromRegExp(left, right) {
    // Note: RegExp types evaluate as strings, not RegExp objects.
    // Here we remap either into string and continue evaluating.
    const L = type_IsRegExp(left) ? string_String() : left;
    const R = type_IsRegExp(right) ? string_String() : right;
    return extends_check_Visit(L, R);
}
// ------------------------------------------------------------------
// String
// ------------------------------------------------------------------
// prettier-ignore
function FromStringRight(left, right) {
    return (type_IsLiteral(left) && IsString(left.const) ? ExtendsResult.True :
        type_IsString(left) ? ExtendsResult.True :
            ExtendsResult.False);
}
// prettier-ignore
function FromString(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) ? FromObjectRight(left, right) :
            type_IsRecord(right) ? FromRecordRight(left, right) :
                type_IsString(right) ? ExtendsResult.True :
                    ExtendsResult.False);
}
// ------------------------------------------------------------------
// Symbol
// ------------------------------------------------------------------
// prettier-ignore
function FromSymbol(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) ? FromObjectRight(left, right) :
            type_IsRecord(right) ? FromRecordRight(left, right) :
                type_IsSymbol(right) ? ExtendsResult.True :
                    ExtendsResult.False);
}
// ------------------------------------------------------------------
// TemplateLiteral
// ------------------------------------------------------------------
// prettier-ignore
function extends_check_FromTemplateLiteral(left, right) {
    // TemplateLiteral types are resolved to either unions for finite expressions or string
    // for infinite expressions. Here we call to TemplateLiteralResolver to resolve for
    // either type and continue evaluating.
    return (type_IsTemplateLiteral(left) ? extends_check_Visit(TemplateLiteralToUnion(left), right) :
        type_IsTemplateLiteral(right) ? extends_check_Visit(left, TemplateLiteralToUnion(right)) :
            Throw('Invalid fallthrough for TemplateLiteral'));
}
// ------------------------------------------------------------------
// Tuple
// ------------------------------------------------------------------
// prettier-ignore
function IsArrayOfTuple(left, right) {
    return (type_IsArray(right) &&
        left.items !== undefined &&
        left.items.every((schema) => extends_check_Visit(schema, right.items) === ExtendsResult.True));
}
// prettier-ignore
function FromTupleRight(left, right) {
    return (type_IsNever(left) ? ExtendsResult.True :
        type_IsUnknown(left) ? ExtendsResult.False :
            type_IsAny(left) ? ExtendsResult.Union :
                ExtendsResult.False);
}
// prettier-ignore
function extends_check_FromTuple(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) && IsObjectArrayLike(right) ? ExtendsResult.True :
            type_IsArray(right) && IsArrayOfTuple(left, right) ? ExtendsResult.True :
                !type_IsTuple(right) ? ExtendsResult.False :
                    (IsUndefined(left.items) && !IsUndefined(right.items)) || (!IsUndefined(left.items) && IsUndefined(right.items)) ? ExtendsResult.False :
                        (IsUndefined(left.items) && !IsUndefined(right.items)) ? ExtendsResult.True :
                            left.items.every((schema, index) => extends_check_Visit(schema, right.items[index]) === ExtendsResult.True) ? ExtendsResult.True :
                                ExtendsResult.False);
}
// ------------------------------------------------------------------
// Uint8Array
// ------------------------------------------------------------------
// prettier-ignore
function FromUint8Array(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) ? FromObjectRight(left, right) :
            type_IsRecord(right) ? FromRecordRight(left, right) :
                type_IsUint8Array(right) ? ExtendsResult.True :
                    ExtendsResult.False);
}
// ------------------------------------------------------------------
// Undefined
// ------------------------------------------------------------------
// prettier-ignore
function FromUndefined(left, right) {
    return (IsStructuralRight(right) ? StructuralRight(left, right) :
        type_IsObject(right) ? FromObjectRight(left, right) :
            type_IsRecord(right) ? FromRecordRight(left, right) :
                type_IsVoid(right) ? FromVoidRight(left, right) :
                    type_IsUndefined(right) ? ExtendsResult.True :
                        ExtendsResult.False);
}
// ------------------------------------------------------------------
// Union
// ------------------------------------------------------------------
// prettier-ignore
function FromUnionRight(left, right) {
    return right.anyOf.some((schema) => extends_check_Visit(left, schema) === ExtendsResult.True)
        ? ExtendsResult.True
        : ExtendsResult.False;
}
// prettier-ignore
function extends_check_FromUnion(left, right) {
    return left.anyOf.every((schema) => extends_check_Visit(schema, right) === ExtendsResult.True)
        ? ExtendsResult.True
        : ExtendsResult.False;
}
// ------------------------------------------------------------------
// Unknown
// ------------------------------------------------------------------
// prettier-ignore
function FromUnknownRight(left, right) {
    return ExtendsResult.True;
}
// prettier-ignore
function FromUnknown(left, right) {
    return (type_IsNever(right) ? FromNeverRight(left, right) :
        type_IsIntersect(right) ? FromIntersectRight(left, right) :
            type_IsUnion(right) ? FromUnionRight(left, right) :
                type_IsAny(right) ? FromAnyRight(left, right) :
                    type_IsString(right) ? FromStringRight(left, right) :
                        type_IsNumber(right) ? FromNumberRight(left, right) :
                            type_IsInteger(right) ? FromIntegerRight(left, right) :
                                type_IsBoolean(right) ? FromBooleanRight(left, right) :
                                    type_IsArray(right) ? FromArrayRight(left, right) :
                                        type_IsTuple(right) ? FromTupleRight(left, right) :
                                            type_IsObject(right) ? FromObjectRight(left, right) :
                                                type_IsUnknown(right) ? ExtendsResult.True :
                                                    ExtendsResult.False);
}
// ------------------------------------------------------------------
// Void
// ------------------------------------------------------------------
// prettier-ignore
function FromVoidRight(left, right) {
    return (type_IsUndefined(left) ? ExtendsResult.True :
        type_IsUndefined(left) ? ExtendsResult.True :
            ExtendsResult.False);
}
// prettier-ignore
function FromVoid(left, right) {
    return (type_IsIntersect(right) ? FromIntersectRight(left, right) :
        type_IsUnion(right) ? FromUnionRight(left, right) :
            type_IsUnknown(right) ? FromUnknownRight(left, right) :
                type_IsAny(right) ? FromAnyRight(left, right) :
                    type_IsObject(right) ? FromObjectRight(left, right) :
                        type_IsVoid(right) ? ExtendsResult.True :
                            ExtendsResult.False);
}
// prettier-ignore
function extends_check_Visit(left, right) {
    return (
    // resolvable
    (type_IsTemplateLiteral(left) || type_IsTemplateLiteral(right)) ? extends_check_FromTemplateLiteral(left, right) :
        (type_IsRegExp(left) || type_IsRegExp(right)) ? FromRegExp(left, right) :
            (type_IsNot(left) || type_IsNot(right)) ? FromNot(left, right) :
                // standard
                type_IsAny(left) ? FromAny(left, right) :
                    type_IsArray(left) ? extends_check_FromArray(left, right) :
                        type_IsBigInt(left) ? FromBigInt(left, right) :
                            type_IsBoolean(left) ? FromBoolean(left, right) :
                                type_IsAsyncIterator(left) ? extends_check_FromAsyncIterator(left, right) :
                                    type_IsConstructor(left) ? extends_check_FromConstructor(left, right) :
                                        type_IsDate(left) ? FromDate(left, right) :
                                            type_IsFunction(left) ? extends_check_FromFunction(left, right) :
                                                type_IsInteger(left) ? FromInteger(left, right) :
                                                    type_IsIntersect(left) ? extends_check_FromIntersect(left, right) :
                                                        type_IsIterator(left) ? extends_check_FromIterator(left, right) :
                                                            type_IsLiteral(left) ? extends_check_FromLiteral(left, right) :
                                                                type_IsNever(left) ? FromNever(left, right) :
                                                                    type_IsNull(left) ? FromNull(left, right) :
                                                                        type_IsNumber(left) ? FromNumber(left, right) :
                                                                            type_IsObject(left) ? extends_check_FromObject(left, right) :
                                                                                type_IsRecord(left) ? FromRecord(left, right) :
                                                                                    type_IsString(left) ? FromString(left, right) :
                                                                                        type_IsSymbol(left) ? FromSymbol(left, right) :
                                                                                            type_IsTuple(left) ? extends_check_FromTuple(left, right) :
                                                                                                type_IsPromise(left) ? extends_check_FromPromise(left, right) :
                                                                                                    type_IsUint8Array(left) ? FromUint8Array(left, right) :
                                                                                                        type_IsUndefined(left) ? FromUndefined(left, right) :
                                                                                                            type_IsUnion(left) ? extends_check_FromUnion(left, right) :
                                                                                                                type_IsUnknown(left) ? FromUnknown(left, right) :
                                                                                                                    type_IsVoid(left) ? FromVoid(left, right) :
                                                                                                                        Throw(`Unknown left type operand '${left[Kind]}'`));
}
function ExtendsCheck(left, right) {
    return extends_check_Visit(left, right);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/extends/extends-from-mapped-result.mjs


// prettier-ignore
function extends_from_mapped_result_FromProperties(P, Right, True, False, options) {
    const Acc = {};
    for (const K2 of globalThis.Object.getOwnPropertyNames(P))
        Acc[K2] = Extends(P[K2], Right, True, False, options);
    return Acc;
}
// prettier-ignore
function extends_from_mapped_result_FromMappedResult(Left, Right, True, False, options) {
    return extends_from_mapped_result_FromProperties(Left.properties, Right, True, False, options);
}
// prettier-ignore
function ExtendsFromMappedResult(Left, Right, True, False, options) {
    const P = extends_from_mapped_result_FromMappedResult(Left, Right, True, False, options);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/extends/extends.mjs





// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function ExtendsResolve(left, right, trueType, falseType) {
    const R = ExtendsCheck(left, right);
    return (R === ExtendsResult.Union ? Union([trueType, falseType]) :
        R === ExtendsResult.True ? trueType :
            falseType);
}
/** `[Json]` Creates a Conditional type */
function Extends(L, R, T, F, options = {}) {
    // prettier-ignore
    return (IsMappedResult(L) ? ExtendsFromMappedResult(L, R, T, F, options) :
        IsMappedKey(L) ? CloneType(ExtendsFromMappedKey(L, R, T, F, options)) :
            CloneType(ExtendsResolve(L, R, T, F), options));
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/extends/extends-from-mapped-key.mjs



// prettier-ignore
function FromPropertyKey(K, U, L, R, options) {
    return {
        [K]: Extends(Literal(K), U, L, R, options)
    };
}
// prettier-ignore
function FromPropertyKeys(K, U, L, R, options) {
    return K.reduce((Acc, LK) => {
        return { ...Acc, ...FromPropertyKey(LK, U, L, R, options) };
    }, {});
}
// prettier-ignore
function extends_from_mapped_key_FromMappedKey(K, U, L, R, options) {
    return FromPropertyKeys(K.keys, U, L, R, options);
}
// prettier-ignore
function ExtendsFromMappedKey(T, U, L, R, options) {
    const P = extends_from_mapped_key_FromMappedKey(T, U, L, R, options);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/extends/extends-undefined.mjs

/** Fast undefined check used for properties of type undefined */
function extends_undefined_Intersect(schema) {
    return schema.allOf.every((schema) => ExtendsUndefinedCheck(schema));
}
function extends_undefined_Union(schema) {
    return schema.anyOf.some((schema) => ExtendsUndefinedCheck(schema));
}
function Not(schema) {
    return !ExtendsUndefinedCheck(schema.not);
}
/** Fast undefined check used for properties of type undefined */
// prettier-ignore
function ExtendsUndefinedCheck(schema) {
    return (schema[Kind] === 'Intersect' ? extends_undefined_Intersect(schema) :
        schema[Kind] === 'Union' ? extends_undefined_Union(schema) :
            schema[Kind] === 'Not' ? Not(schema) :
                schema[Kind] === 'Undefined' ? true :
                    false);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/extends/index.mjs






;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/exclude/exclude-from-template-literal.mjs


function ExcludeFromTemplateLiteral(L, R) {
    return Exclude(TemplateLiteralToUnion(L), R);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/exclude/exclude.mjs






// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

function ExcludeRest(L, R) {
    const excluded = L.filter((inner) => ExtendsCheck(inner, R) === ExtendsResult.False);
    return excluded.length === 1 ? excluded[0] : Union(excluded);
}
/** `[Json]` Constructs a type by excluding from unionType all union members that are assignable to excludedMembers */
function Exclude(L, R, options = {}) {
    // overloads
    if (IsTemplateLiteral(L))
        return CloneType(ExcludeFromTemplateLiteral(L, R), options);
    if (IsMappedResult(L))
        return CloneType(ExcludeFromMappedResult(L, R), options);
    // prettier-ignore
    return CloneType(IsUnion(L) ? ExcludeRest(L.anyOf, R) :
        ExtendsCheck(L, R) !== ExtendsResult.False ? Never() : L, options);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/exclude/exclude-from-mapped-result.mjs


// prettier-ignore
function exclude_from_mapped_result_FromProperties(P, U) {
    const Acc = {};
    for (const K2 of globalThis.Object.getOwnPropertyNames(P))
        Acc[K2] = Exclude(P[K2], U);
    return Acc;
}
// prettier-ignore
function exclude_from_mapped_result_FromMappedResult(R, T) {
    return exclude_from_mapped_result_FromProperties(R.properties, T);
}
// prettier-ignore
function ExcludeFromMappedResult(R, T) {
    const P = exclude_from_mapped_result_FromMappedResult(R, T);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/exclude/index.mjs




;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/extract/extract-from-template-literal.mjs


function ExtractFromTemplateLiteral(L, R) {
    return Extract(TemplateLiteralToUnion(L), R);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/extract/extract.mjs






// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

function ExtractRest(L, R) {
    const extracted = L.filter((inner) => ExtendsCheck(inner, R) !== ExtendsResult.False);
    return extracted.length === 1 ? extracted[0] : Union(extracted);
}
/** `[Json]` Constructs a type by extracting from type all union members that are assignable to union */
function Extract(L, R, options = {}) {
    // overloads
    if (IsTemplateLiteral(L))
        return CloneType(ExtractFromTemplateLiteral(L, R), options);
    if (IsMappedResult(L))
        return CloneType(ExtractFromMappedResult(L, R), options);
    // prettier-ignore
    return CloneType(IsUnion(L) ? ExtractRest(L.anyOf, R) :
        ExtendsCheck(L, R) !== ExtendsResult.False ? L : Never(), options);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/extract/extract-from-mapped-result.mjs


// prettier-ignore
function extract_from_mapped_result_FromProperties(P, T) {
    const Acc = {};
    for (const K2 of globalThis.Object.getOwnPropertyNames(P))
        Acc[K2] = Extract(P[K2], T);
    return Acc;
}
// prettier-ignore
function extract_from_mapped_result_FromMappedResult(R, T) {
    return extract_from_mapped_result_FromProperties(R.properties, T);
}
// prettier-ignore
function ExtractFromMappedResult(R, T) {
    const P = extract_from_mapped_result_FromMappedResult(R, T);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/extract/index.mjs




;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/instance-type/instance-type.mjs

/** `[JavaScript]` Extracts the InstanceType from the given Constructor type */
function InstanceType(schema, options = {}) {
    return CloneType(schema.returns, options);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/instance-type/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/integer/integer.mjs

/** `[Json]` Creates an Integer type */
function Integer(options = {}) {
    return {
        ...options,
        [Kind]: 'Integer',
        type: 'integer',
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/integer/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/intrinsic/intrinsic-from-mapped-key.mjs



// prettier-ignore
function MappedIntrinsicPropertyKey(K, M, options) {
    return {
        [K]: Intrinsic(Literal(K), M, options)
    };
}
// prettier-ignore
function MappedIntrinsicPropertyKeys(K, M, options) {
    return K.reduce((Acc, L) => {
        return { ...Acc, ...MappedIntrinsicPropertyKey(L, M, options) };
    }, {});
}
// prettier-ignore
function MappedIntrinsicProperties(T, M, options) {
    return MappedIntrinsicPropertyKeys(T['keys'], M, options);
}
// prettier-ignore
function IntrinsicFromMappedKey(T, M, options) {
    const P = MappedIntrinsicProperties(T, M, options);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/intrinsic/intrinsic.mjs




// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// ------------------------------------------------------------------
// Apply
// ------------------------------------------------------------------
function ApplyUncapitalize(value) {
    const [first, rest] = [value.slice(0, 1), value.slice(1)];
    return [first.toLowerCase(), rest].join('');
}
function ApplyCapitalize(value) {
    const [first, rest] = [value.slice(0, 1), value.slice(1)];
    return [first.toUpperCase(), rest].join('');
}
function ApplyUppercase(value) {
    return value.toUpperCase();
}
function ApplyLowercase(value) {
    return value.toLowerCase();
}
function intrinsic_FromTemplateLiteral(schema, mode, options) {
    // note: template literals require special runtime handling as they are encoded in string patterns.
    // This diverges from the mapped type which would otherwise map on the template literal kind.
    const expression = TemplateLiteralParseExact(schema.pattern);
    const finite = IsTemplateLiteralExpressionFinite(expression);
    if (!finite)
        return { ...schema, pattern: FromLiteralValue(schema.pattern, mode) };
    const strings = [...TemplateLiteralExpressionGenerate(expression)];
    const literals = strings.map((value) => Literal(value));
    const mapped = intrinsic_FromRest(literals, mode);
    const union = Union(mapped);
    return TemplateLiteral([union], options);
}
// prettier-ignore
function FromLiteralValue(value, mode) {
    return (typeof value === 'string' ? (mode === 'Uncapitalize' ? ApplyUncapitalize(value) :
        mode === 'Capitalize' ? ApplyCapitalize(value) :
            mode === 'Uppercase' ? ApplyUppercase(value) :
                mode === 'Lowercase' ? ApplyLowercase(value) :
                    value) : value.toString());
}
// prettier-ignore
function intrinsic_FromRest(T, M) {
    return T.map(L => Intrinsic(L, M));
}
/** Applies an intrinsic string manipulation to the given type. */
function Intrinsic(schema, mode, options = {}) {
    // prettier-ignore
    return (
    // Intrinsic-Mapped-Inference
    IsMappedKey(schema) ? IntrinsicFromMappedKey(schema, mode, options) :
        // Standard-Inference
        IsTemplateLiteral(schema) ? intrinsic_FromTemplateLiteral(schema, mode, schema) :
            IsUnion(schema) ? Union(intrinsic_FromRest(schema.anyOf, mode), options) :
                IsLiteral(schema) ? Literal(FromLiteralValue(schema.const, mode), options) :
                    schema);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/intrinsic/capitalize.mjs

/** `[Json]` Intrinsic function to Capitalize LiteralString types */
function Capitalize(T, options = {}) {
    return Intrinsic(T, 'Capitalize', options);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/intrinsic/lowercase.mjs

/** `[Json]` Intrinsic function to Lowercase LiteralString types */
function Lowercase(T, options = {}) {
    return Intrinsic(T, 'Lowercase', options);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/intrinsic/uncapitalize.mjs

/** `[Json]` Intrinsic function to Uncapitalize LiteralString types */
function Uncapitalize(T, options = {}) {
    return Intrinsic(T, 'Uncapitalize', options);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/intrinsic/uppercase.mjs

/** `[Json]` Intrinsic function to Uppercase LiteralString types */
function Uppercase(T, options = {}) {
    return Intrinsic(T, 'Uppercase', options);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/intrinsic/index.mjs







;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/not/not.mjs


/** `[Json]` Creates a Not type */
function not_Not(schema, options) {
    return {
        ...options,
        [Kind]: 'Not',
        not: CloneType(schema),
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/not/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/omit/omit-from-mapped-result.mjs


// prettier-ignore
function omit_from_mapped_result_FromProperties(P, K, options) {
    const Acc = {};
    for (const K2 of globalThis.Object.getOwnPropertyNames(P))
        Acc[K2] = Omit(P[K2], K, options);
    return Acc;
}
// prettier-ignore
function omit_from_mapped_result_FromMappedResult(R, K, options) {
    return omit_from_mapped_result_FromProperties(R.properties, K, options);
}
// prettier-ignore
function OmitFromMappedResult(R, K, options) {
    const P = omit_from_mapped_result_FromMappedResult(R, K, options);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/omit/omit.mjs









// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function omit_FromIntersect(T, K) {
    return T.map((T) => OmitResolve(T, K));
}
// prettier-ignore
function omit_FromUnion(T, K) {
    return T.map((T) => OmitResolve(T, K));
}
// ------------------------------------------------------------------
// FromProperty
// ------------------------------------------------------------------
// prettier-ignore
function omit_FromProperty(T, K) {
    const { [K]: _, ...R } = T;
    return R;
}
// prettier-ignore
function omit_FromProperties(T, K) {
    return K.reduce((T, K2) => omit_FromProperty(T, K2), T);
}
// ------------------------------------------------------------------
// OmitResolve
// ------------------------------------------------------------------
// prettier-ignore
function OmitResolve(T, K) {
    return (IsIntersect(T) ? Intersect(omit_FromIntersect(T.allOf, K)) :
        IsUnion(T) ? Union(omit_FromUnion(T.anyOf, K)) :
            kind_IsObject(T) ? object_Object(omit_FromProperties(T.properties, K)) :
                object_Object({}));
}
function Omit(T, K, options = {}) {
    // mapped
    if (IsMappedKey(K))
        return OmitFromMappedKey(T, K, options);
    if (IsMappedResult(T))
        return OmitFromMappedResult(T, K, options);
    // non-mapped
    const I = IsSchema(K) ? IndexPropertyKeys(K) : K;
    const D = Discard(T, [TransformKind, '$id', 'required']);
    const R = CloneType(OmitResolve(T, I), options);
    return { ...D, ...R };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/omit/omit-from-mapped-key.mjs


// prettier-ignore
function omit_from_mapped_key_FromPropertyKey(T, K, options) {
    return {
        [K]: Omit(T, [K], options)
    };
}
// prettier-ignore
function omit_from_mapped_key_FromPropertyKeys(T, K, options) {
    return K.reduce((Acc, LK) => {
        return { ...Acc, ...omit_from_mapped_key_FromPropertyKey(T, LK, options) };
    }, {});
}
// prettier-ignore
function omit_from_mapped_key_FromMappedKey(T, K, options) {
    return omit_from_mapped_key_FromPropertyKeys(T, K.keys, options);
}
// prettier-ignore
function OmitFromMappedKey(T, K, options) {
    const P = omit_from_mapped_key_FromMappedKey(T, K, options);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/omit/index.mjs




;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/parameters/parameters.mjs


/** `[JavaScript]` Extracts the Parameters from the given Function type */
function Parameters(schema, options = {}) {
    return Tuple(CloneRest(schema.parameters), { ...options });
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/parameters/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/partial/partial.mjs








// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function partial_FromRest(T) {
    return T.map(L => PartialResolve(L));
}
// prettier-ignore
function partial_FromProperties(T) {
    const Acc = {};
    for (const K of globalThis.Object.getOwnPropertyNames(T))
        Acc[K] = Optional(T[K]);
    return Acc;
}
// ------------------------------------------------------------------
// PartialResolve
// ------------------------------------------------------------------
// prettier-ignore
function PartialResolve(T) {
    return (IsIntersect(T) ? Intersect(partial_FromRest(T.allOf)) :
        IsUnion(T) ? Union(partial_FromRest(T.anyOf)) :
            kind_IsObject(T) ? object_Object(partial_FromProperties(T.properties)) :
                object_Object({}));
}
/** `[Json]` Constructs a type where all properties are optional */
function Partial(T, options = {}) {
    if (IsMappedResult(T))
        return PartialFromMappedResult(T, options);
    const D = Discard(T, [TransformKind, '$id', 'required']);
    const R = CloneType(PartialResolve(T), options);
    return { ...D, ...R };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/partial/partial-from-mapped-result.mjs


// prettier-ignore
function partial_from_mapped_result_FromProperties(K, options) {
    const Acc = {};
    for (const K2 of globalThis.Object.getOwnPropertyNames(K))
        Acc[K2] = Partial(K[K2], options);
    return Acc;
}
// prettier-ignore
function partial_from_mapped_result_FromMappedResult(R, options) {
    return partial_from_mapped_result_FromProperties(R.properties, options);
}
// prettier-ignore
function PartialFromMappedResult(R, options) {
    const P = partial_from_mapped_result_FromMappedResult(R, options);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/partial/index.mjs



;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/pick/pick-from-mapped-result.mjs


// prettier-ignore
function pick_from_mapped_result_FromProperties(P, K, options) {
    const Acc = {};
    for (const K2 of globalThis.Object.getOwnPropertyNames(P))
        Acc[K2] = Pick(P[K2], K, options);
    return Acc;
}
// prettier-ignore
function pick_from_mapped_result_FromMappedResult(R, K, options) {
    return pick_from_mapped_result_FromProperties(R.properties, K, options);
}
// prettier-ignore
function PickFromMappedResult(R, K, options) {
    const P = pick_from_mapped_result_FromMappedResult(R, K, options);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/pick/pick.mjs









// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

function pick_FromIntersect(T, K) {
    return T.map((T) => PickResolve(T, K));
}
// prettier-ignore
function pick_FromUnion(T, K) {
    return T.map((T) => PickResolve(T, K));
}
// prettier-ignore
function pick_FromProperties(T, K) {
    const Acc = {};
    for (const K2 of K)
        if (K2 in T)
            Acc[K2] = T[K2];
    return Acc;
}
// ------------------------------------------------------------------
// PickResolve
// ------------------------------------------------------------------
// prettier-ignore
function PickResolve(T, K) {
    return (IsIntersect(T) ? Intersect(pick_FromIntersect(T.allOf, K)) :
        IsUnion(T) ? Union(pick_FromUnion(T.anyOf, K)) :
            kind_IsObject(T) ? object_Object(pick_FromProperties(T.properties, K)) :
                object_Object({}));
}
function Pick(T, K, options = {}) {
    // mapped
    if (IsMappedKey(K))
        return PickFromMappedKey(T, K, options);
    if (IsMappedResult(T))
        return PickFromMappedResult(T, K, options);
    // non-mapped
    const I = IsSchema(K) ? IndexPropertyKeys(K) : K;
    const D = Discard(T, [TransformKind, '$id', 'required']);
    const R = CloneType(PickResolve(T, I), options);
    return { ...D, ...R };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/pick/pick-from-mapped-key.mjs


// prettier-ignore
function pick_from_mapped_key_FromPropertyKey(T, K, options) {
    return {
        [K]: Pick(T, [K], options)
    };
}
// prettier-ignore
function pick_from_mapped_key_FromPropertyKeys(T, K, options) {
    return K.reduce((Acc, LK) => {
        return { ...Acc, ...pick_from_mapped_key_FromPropertyKey(T, LK, options) };
    }, {});
}
// prettier-ignore
function pick_from_mapped_key_FromMappedKey(T, K, options) {
    return pick_from_mapped_key_FromPropertyKeys(T, K.keys, options);
}
// prettier-ignore
function PickFromMappedKey(T, K, options) {
    const P = pick_from_mapped_key_FromMappedKey(T, K, options);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/pick/index.mjs




;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/readonly-optional/readonly-optional.mjs


/** `[Json]` Creates a Readonly and Optional property */
function ReadonlyOptional(schema) {
    return Readonly(Optional(schema));
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/readonly-optional/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/record/record.mjs








// ------------------------------------------------------------------
// ValueGuard
// ------------------------------------------------------------------

// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// ------------------------------------------------------------------
// RecordCreateFromPattern
// ------------------------------------------------------------------
// prettier-ignore
function RecordCreateFromPattern(pattern, T, options) {
    return {
        ...options,
        [Kind]: 'Record',
        type: 'object',
        patternProperties: { [pattern]: CloneType(T) }
    };
}
// ------------------------------------------------------------------
// RecordCreateFromKeys
// ------------------------------------------------------------------
// prettier-ignore
function RecordCreateFromKeys(K, T, options) {
    const Acc = {};
    for (const K2 of K)
        Acc[K2] = CloneType(T);
    return object_Object(Acc, { ...options, [Hint]: 'Record' });
}
// prettier-ignore
function FromTemplateLiteralKey(K, T, options) {
    return (IsTemplateLiteralFinite(K)
        ? RecordCreateFromKeys(IndexPropertyKeys(K), T, options)
        : RecordCreateFromPattern(K.pattern, T, options));
}
// prettier-ignore
function FromUnionKey(K, T, options) {
    return RecordCreateFromKeys(IndexPropertyKeys(Union(K)), T, options);
}
// prettier-ignore
function FromLiteralKey(K, T, options) {
    return RecordCreateFromKeys([K.toString()], T, options);
}
// prettier-ignore
function FromRegExpKey(K, T, options) {
    return RecordCreateFromPattern(K.source, T, options);
}
// prettier-ignore
function FromStringKey(K, T, options) {
    const pattern = IsUndefined(K.pattern) ? PatternStringExact : K.pattern;
    return RecordCreateFromPattern(pattern, T, options);
}
// prettier-ignore
function FromAnyKey(K, T, options) {
    return RecordCreateFromPattern(PatternStringExact, T, options);
}
// prettier-ignore
function FromNeverKey(K, T, options) {
    return RecordCreateFromPattern(PatternNeverExact, T, options);
}
// prettier-ignore
function FromIntegerKey(_, T, options) {
    return RecordCreateFromPattern(PatternNumberExact, T, options);
}
// prettier-ignore
function FromNumberKey(_, T, options) {
    return RecordCreateFromPattern(PatternNumberExact, T, options);
}
// ------------------------------------------------------------------
// TRecordOrObject
// ------------------------------------------------------------------
/** `[Json]` Creates a Record type */
function Record(K, T, options = {}) {
    // prettier-ignore
    return (IsUnion(K) ? FromUnionKey(K.anyOf, T, options) :
        IsTemplateLiteral(K) ? FromTemplateLiteralKey(K, T, options) :
            IsLiteral(K) ? FromLiteralKey(K.const, T, options) :
                IsInteger(K) ? FromIntegerKey(K, T, options) :
                    kind_IsNumber(K) ? FromNumberKey(K, T, options) :
                        kind_IsRegExp(K) ? FromRegExpKey(K, T, options) :
                            kind_IsString(K) ? FromStringKey(K, T, options) :
                                IsAny(K) ? FromAnyKey(K, T, options) :
                                    IsNever(K) ? FromNeverKey(K, T, options) :
                                        Never(options));
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/record/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/recursive/recursive.mjs



// Auto Tracked For Recursive Types without ID's
let Ordinal = 0;
/** `[Json]` Creates a Recursive type */
function Recursive(callback, options = {}) {
    if (IsUndefined(options.$id))
        options.$id = `T${Ordinal++}`;
    const thisType = callback({ [Kind]: 'This', $ref: `${options.$id}` });
    thisType.$id = options.$id;
    // prettier-ignore
    return CloneType({ ...options, [Hint]: 'Recursive', ...thisType });
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/recursive/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/ref/ref.mjs

// ------------------------------------------------------------------
// ValueGuard
// ------------------------------------------------------------------

/** `[Json]` Creates a Ref type. */
function Ref(unresolved, options = {}) {
    if (IsString(unresolved))
        return { ...options, [Kind]: 'Ref', $ref: unresolved };
    if (IsUndefined(unresolved.$id))
        throw new Error('Reference target type must specify an $id');
    return {
        ...options,
        [Kind]: 'Ref',
        $ref: unresolved.$id,
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/ref/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/regexp/regexp.mjs


/** `[JavaScript]` Creates a RegExp type */
function regexp_RegExp(unresolved, options = {}) {
    const expr = IsString(unresolved) ? new globalThis.RegExp(unresolved) : unresolved;
    return { ...options, [Kind]: 'RegExp', type: 'RegExp', source: expr.source, flags: expr.flags };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/regexp/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/required/required.mjs







// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function required_FromRest(T) {
    return T.map(L => RequiredResolve(L));
}
// prettier-ignore
function required_FromProperties(T) {
    const Acc = {};
    for (const K of globalThis.Object.getOwnPropertyNames(T))
        Acc[K] = Discard(T[K], [OptionalKind]);
    return Acc;
}
// ------------------------------------------------------------------
// RequiredResolve
// ------------------------------------------------------------------
// prettier-ignore
function RequiredResolve(T) {
    return (IsIntersect(T) ? Intersect(required_FromRest(T.allOf)) :
        IsUnion(T) ? Union(required_FromRest(T.anyOf)) :
            kind_IsObject(T) ? object_Object(required_FromProperties(T.properties)) :
                object_Object({}));
}
/** `[Json]` Constructs a type where all properties are required */
function Required(T, options = {}) {
    if (IsMappedResult(T)) {
        return RequiredFromMappedResult(T, options);
    }
    else {
        const D = Discard(T, [TransformKind, '$id', 'required']);
        const R = CloneType(RequiredResolve(T), options);
        return { ...D, ...R };
    }
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/required/required-from-mapped-result.mjs


// prettier-ignore
function required_from_mapped_result_FromProperties(P, options) {
    const Acc = {};
    for (const K2 of globalThis.Object.getOwnPropertyNames(P))
        Acc[K2] = Required(P[K2], options);
    return Acc;
}
// prettier-ignore
function required_from_mapped_result_FromMappedResult(R, options) {
    return required_from_mapped_result_FromProperties(R.properties, options);
}
// prettier-ignore
function RequiredFromMappedResult(R, options) {
    const P = required_from_mapped_result_FromMappedResult(R, options);
    return MappedResult(P);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/required/index.mjs



;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/rest/rest.mjs

// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// prettier-ignore
function RestResolve(T) {
    return (IsIntersect(T) ? CloneRest(T.allOf) :
        IsUnion(T) ? CloneRest(T.anyOf) :
            IsTuple(T) ? CloneRest(T.items ?? []) :
                []);
}
/** `[Json]` Extracts interior Rest elements from Tuple, Intersect and Union types */
function Rest(T) {
    return CloneRest(RestResolve(T));
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/rest/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/return-type/return-type.mjs

/** `[JavaScript]` Extracts the ReturnType from the given Function type */
function ReturnType(schema, options = {}) {
    return CloneType(schema.returns, options);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/return-type/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/schema/schema.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/schema/index.mjs



;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/strict/strict.mjs
/** `[Json]` Omits compositing symbols from this schema. */
function Strict(schema) {
    return JSON.parse(JSON.stringify(schema));
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/strict/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/transform/transform.mjs


// ------------------------------------------------------------------
// TypeGuard
// ------------------------------------------------------------------

// ------------------------------------------------------------------
// TransformBuilders
// ------------------------------------------------------------------
class TransformDecodeBuilder {
    constructor(schema) {
        this.schema = schema;
    }
    Decode(decode) {
        return new TransformEncodeBuilder(this.schema, decode);
    }
}
// prettier-ignore
class TransformEncodeBuilder {
    constructor(schema, decode) {
        this.schema = schema;
        this.decode = decode;
    }
    EncodeTransform(encode, schema) {
        const Encode = (value) => schema[TransformKind].Encode(encode(value));
        const Decode = (value) => this.decode(schema[TransformKind].Decode(value));
        const Codec = { Encode: Encode, Decode: Decode };
        return { ...schema, [TransformKind]: Codec };
    }
    EncodeSchema(encode, schema) {
        const Codec = { Decode: this.decode, Encode: encode };
        return { ...schema, [TransformKind]: Codec };
    }
    Encode(encode) {
        const schema = CloneType(this.schema);
        return (IsTransform(schema) ? this.EncodeTransform(encode, schema) : this.EncodeSchema(encode, schema));
    }
}
/** `[Json]` Creates a Transform type */
function Transform(schema) {
    return new TransformDecodeBuilder(schema);
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/transform/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/unsafe/unsafe.mjs

/** `[Json]` Creates a Unsafe type that will infers as the generic argument T */
function Unsafe(options = {}) {
    return {
        ...options,
        [Kind]: options[Kind] ?? 'Unsafe',
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/unsafe/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/void/void.mjs

/** `[JavaScript]` Creates a Void type */
function Void(options = {}) {
    return {
        ...options,
        [Kind]: 'Void',
        type: 'void',
    };
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/void/index.mjs


;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/type/json.mjs









































/** Json Type Builder with Static Resolution for TypeScript */
class JsonTypeBuilder {
    // ------------------------------------------------------------------------
    // Strict
    // ------------------------------------------------------------------------
    /** `[Json]` Omits compositing symbols from this schema */
    Strict(schema) {
        return Strict(schema);
    }
    // ------------------------------------------------------------------------
    // Modifiers
    // ------------------------------------------------------------------------
    /** `[Json]` Creates a Readonly and Optional property */
    ReadonlyOptional(schema) {
        return ReadonlyOptional(schema);
    }
    /** `[Json]` Creates a Readonly property */
    Readonly(schema, enable) {
        return Readonly(schema, enable ?? true);
    }
    /** `[Json]` Creates a Optional property */
    Optional(schema, enable) {
        return Optional(schema, enable ?? true);
    }
    // ------------------------------------------------------------------------
    // Types
    // ------------------------------------------------------------------------
    /** `[Json]` Creates an Any type */
    Any(options = {}) {
        return Any(options);
    }
    /** `[Json]` Creates an Array type */
    Array(schema, options = {}) {
        return array_Array(schema, options);
    }
    /** `[Json]` Creates a Boolean type */
    Boolean(options = {}) {
        return Boolean(options);
    }
    /** `[Json]` Intrinsic function to Capitalize LiteralString types */
    Capitalize(schema, options = {}) {
        return Capitalize(schema, options);
    }
    /** `[Json]` Creates a Composite object type */
    Composite(schemas, options) {
        return Composite(schemas, options); // (error) TS 5.4.0-dev - review TComposite implementation
    }
    /** `[JavaScript]` Creates a readonly const type from the given value. */
    Const(value, options = {}) {
        return Const(value, options);
    }
    /** `[Json]` Creates a dereferenced type */
    Deref(schema, references) {
        return Deref(schema, references);
    }
    /** `[Json]` Creates a Enum type */
    Enum(item, options = {}) {
        return Enum(item, options);
    }
    /** `[Json]` Constructs a type by excluding from unionType all union members that are assignable to excludedMembers */
    Exclude(unionType, excludedMembers, options = {}) {
        return Exclude(unionType, excludedMembers, options);
    }
    /** `[Json]` Creates a Conditional type */
    Extends(L, R, T, F, options = {}) {
        return Extends(L, R, T, F, options);
    }
    /** `[Json]` Constructs a type by extracting from type all union members that are assignable to union */
    Extract(type, union, options = {}) {
        return Extract(type, union, options);
    }
    /** `[Json]` Returns an Indexed property type for the given keys */
    Index(schema, unresolved, options = {}) {
        return Index(schema, unresolved, options);
    }
    /** `[Json]` Creates an Integer type */
    Integer(options = {}) {
        return Integer(options);
    }
    /** `[Json]` Creates an Intersect type */
    Intersect(T, options = {}) {
        return Intersect(T, options);
    }
    /** `[Json]` Creates a KeyOf type */
    KeyOf(schema, options = {}) {
        return KeyOf(schema, options);
    }
    /** `[Json]` Creates a Literal type */
    Literal(value, options = {}) {
        return Literal(value, options);
    }
    /** `[Json]` Intrinsic function to Lowercase LiteralString types */
    Lowercase(schema, options = {}) {
        return Lowercase(schema, options);
    }
    /** `[Json]` Creates a Mapped object type */
    Mapped(key, map, options = {}) {
        return Mapped(key, map, options);
    }
    /** `[Json]` Creates a Never type */
    Never(options = {}) {
        return Never(options);
    }
    /** `[Json]` Creates a Not type */
    Not(schema, options) {
        return not_Not(schema, options);
    }
    /** `[Json]` Creates a Null type */
    Null(options = {}) {
        return Null(options);
    }
    /** `[Json]` Creates a Number type */
    Number(options = {}) {
        return number_Number(options);
    }
    /** `[Json]` Creates an Object type */
    Object(properties, options = {}) {
        return object_Object(properties, options);
    }
    /** `[Json]` Constructs a type whose keys are omitted from the given type */
    Omit(schema, unresolved, options = {}) {
        return Omit(schema, unresolved, options);
    }
    /** `[Json]` Constructs a type where all properties are optional */
    Partial(schema, options = {}) {
        return Partial(schema, options);
    }
    /** `[Json]` Constructs a type whose keys are picked from the given type */
    Pick(schema, unresolved, options = {}) {
        return Pick(schema, unresolved, options);
    }
    /** `[Json]` Creates a Record type */
    Record(key, schema, options = {}) {
        return Record(key, schema, options);
    }
    /** `[Json]` Creates a Recursive type */
    Recursive(callback, options = {}) {
        return Recursive(callback, options);
    }
    /** `[Json]` Creates a Ref type. */
    Ref(unresolved, options = {}) {
        return Ref(unresolved, options);
    }
    /** `[Json]` Constructs a type where all properties are required */
    Required(schema, options = {}) {
        return Required(schema, options);
    }
    /** `[Json]` Extracts interior Rest elements from Tuple, Intersect and Union types */
    Rest(schema) {
        return Rest(schema);
    }
    /** `[Json]` Creates a String type */
    String(options = {}) {
        return string_String(options);
    }
    /** `[Json]` Creates a TemplateLiteral type */
    TemplateLiteral(unresolved, options = {}) {
        return TemplateLiteral(unresolved, options);
    }
    /** `[Json]` Creates a Transform type */
    Transform(schema) {
        return Transform(schema);
    }
    /** `[Json]` Creates a Tuple type */
    Tuple(items, options = {}) {
        return Tuple(items, options);
    }
    /** `[Json]` Intrinsic function to Uncapitalize LiteralString types */
    Uncapitalize(schema, options = {}) {
        return Uncapitalize(schema, options);
    }
    /** `[Json]` Creates a Union type */
    Union(schemas, options = {}) {
        return Union(schemas, options);
    }
    /** `[Json]` Creates an Unknown type */
    Unknown(options = {}) {
        return Unknown(options);
    }
    /** `[Json]` Creates a Unsafe type that will infers as the generic argument T */
    Unsafe(options = {}) {
        return Unsafe(options);
    }
    /** `[Json]` Intrinsic function to Uppercase LiteralString types */
    Uppercase(schema, options = {}) {
        return Uppercase(schema, options);
    }
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/type/type.mjs
// ------------------------------------------------------------------
// Type: Module
// ------------------------------------------------------------------



























































;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/type/javascript.mjs


















/** JavaScript Type Builder with Static Resolution for TypeScript */
class JavaScriptTypeBuilder extends JsonTypeBuilder {
    /** `[JavaScript]` Creates a AsyncIterator type */
    AsyncIterator(items, options = {}) {
        return AsyncIterator(items, options);
    }
    /** `[JavaScript]` Constructs a type by recursively unwrapping Promise types */
    Awaited(schema, options = {}) {
        return Awaited(schema, options);
    }
    /** `[JavaScript]` Creates a BigInt type */
    BigInt(options = {}) {
        return BigInt(options);
    }
    /** `[JavaScript]` Extracts the ConstructorParameters from the given Constructor type */
    ConstructorParameters(schema, options = {}) {
        return ConstructorParameters(schema, options);
    }
    /** `[JavaScript]` Creates a Constructor type */
    Constructor(parameters, returns, options) {
        return Constructor(parameters, returns, options);
    }
    /** `[JavaScript]` Creates a Date type */
    Date(options = {}) {
        return date_Date(options);
    }
    /** `[JavaScript]` Creates a Function type */
    Function(parameters, returns, options) {
        return Function(parameters, returns, options);
    }
    /** `[JavaScript]` Extracts the InstanceType from the given Constructor type */
    InstanceType(schema, options = {}) {
        return InstanceType(schema, options);
    }
    /** `[JavaScript]` Creates an Iterator type */
    Iterator(items, options = {}) {
        return Iterator(items, options);
    }
    /** `[JavaScript]` Extracts the Parameters from the given Function type */
    Parameters(schema, options = {}) {
        return Parameters(schema, options);
    }
    /** `[JavaScript]` Creates a Promise type */
    Promise(item, options = {}) {
        return Promise(item, options);
    }
    /** `[JavaScript]` Creates a RegExp type */
    RegExp(unresolved, options = {}) {
        return regexp_RegExp(unresolved, options);
    }
    /** `[JavaScript]` Extracts the ReturnType from the given Function type */
    ReturnType(schema, options = {}) {
        return ReturnType(schema, options);
    }
    /** `[JavaScript]` Creates a Symbol type */
    Symbol(options) {
        return symbol_Symbol(options);
    }
    /** `[JavaScript]` Creates a Undefined type */
    Undefined(options = {}) {
        return Undefined(options);
    }
    /** `[JavaScript]` Creates a Uint8Array type */
    Uint8Array(options = {}) {
        return uint8array_Uint8Array(options);
    }
    /** `[JavaScript]` Creates a Void type */
    Void(options = {}) {
        return Void(options);
    }
}

;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/type/type/index.mjs
// ------------------------------------------------------------------
// JsonTypeBuilder
// ------------------------------------------------------------------

// ------------------------------------------------------------------
// JavaScriptTypeBuilder
// ------------------------------------------------------------------


/** JavaScript Type Builder with Static Resolution for TypeScript */
const Type = type_type_namespaceObject;



;// CONCATENATED MODULE: ./node_modules/@sinclair/typebox/build/esm/index.mjs
// ------------------------------------------------------------------
// Infrastructure
// ------------------------------------------------------------------








// ------------------------------------------------------------------
// Types
// ------------------------------------------------------------------




























































// ------------------------------------------------------------------
// Namespace
// ------------------------------------------------------------------



/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 51438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 16567:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 88029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 24234:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jx": function() { return /* reexport */ decode; },
  "cv": function() { return /* reexport */ encode; }
});

// UNUSED EXPORTS: ALWAYS, DECIMAL_FIT, DECIMAL_ROUND, Decoder, Encoder, FLOAT32_OPTIONS, NEVER, REUSE_BUFFER_MODE, Tag, addExtension, clearSource, decodeIter, decodeMultiple, encodeAsAsyncIterable, encodeAsIterable, encodeIter, isNativeAccelerationEnabled, roundFloat32, setSizeLimits

;// CONCATENATED MODULE: ./node_modules/cbor-x/decode.js
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
let decoder
try {
	decoder = new TextDecoder()
} catch(error) {}
let src
let srcEnd
let position = 0
let alreadySet
const EMPTY_ARRAY = []
const LEGACY_RECORD_INLINE_ID = 105
const RECORD_DEFINITIONS_ID = 0xdffe
const RECORD_INLINE_ID = 0xdfff // temporary first-come first-serve tag // proposed tag: 0x7265 // 're'
const BUNDLED_STRINGS_ID = 0xdff9
const PACKED_TABLE_TAG_ID = 51
const PACKED_REFERENCE_TAG_ID = 6
const STOP_CODE = {}
let maxArraySize = 112810000 // This is the maximum array size in V8. We would potentially detect and set it higher
// for JSC, but this is pretty large and should be sufficient for most use cases
let maxMapSize = 16810000 // JavaScript has a fixed maximum map size of about 16710000, but JS itself enforces this,
// so we don't need to

let maxObjectSize = 16710000; // This is the maximum number of keys in a Map. It takes over a minute to create this
// many keys in an object, so also probably a reasonable choice there.
let strings = EMPTY_ARRAY
let stringPosition = 0
let currentDecoder = {}
let currentStructures
let srcString
let srcStringStart = 0
let srcStringEnd = 0
let bundledStrings
let referenceMap
let currentExtensions = []
let currentExtensionRanges = []
let packedValues
let dataView
let restoreMapsAsObject
let defaultOptions = {
	useRecords: false,
	mapsAsObjects: true
}
let sequentialMode = false
let inlineObjectReadThreshold = 2;
var BlockedFunction // we use search and replace to change the next call to BlockedFunction to avoid CSP issues for
// no-eval build
try {
	new Function('')
} catch(error) {
	// if eval variants are not supported, do not create inline object readers ever
	inlineObjectReadThreshold = Infinity
}



class decode_Decoder {
	constructor(options) {
		if (options) {
			if ((options.keyMap || options._keyMap) && !options.useRecords) {
				options.useRecords = false
				options.mapsAsObjects = true
			}
			if (options.useRecords === false && options.mapsAsObjects === undefined)
				options.mapsAsObjects = true
			if (options.getStructures)
				options.getShared = options.getStructures
			if (options.getShared && !options.structures)
				(options.structures = []).uninitialized = true // this is what we use to denote an uninitialized structures
			if (options.keyMap) {
				this.mapKey = new Map()
				for (let [k,v] of Object.entries(options.keyMap)) this.mapKey.set(v,k)
			}
		}
		Object.assign(this, options)
	}
	/*
	decodeKey(key) {
		return this.keyMap
			? Object.keys(this.keyMap)[Object.values(this.keyMap).indexOf(key)] || key
			: key
	}
	*/
	decodeKey(key) {
		return this.keyMap ? this.mapKey.get(key) || key : key
	}
	
	encodeKey(key) {
		return this.keyMap && this.keyMap.hasOwnProperty(key) ? this.keyMap[key] : key
	}

	encodeKeys(rec) {
		if (!this._keyMap) return rec
		let map = new Map()
		for (let [k,v] of Object.entries(rec)) map.set((this._keyMap.hasOwnProperty(k) ? this._keyMap[k] : k), v)
		return map
	}

	decodeKeys(map) {
		if (!this._keyMap || map.constructor.name != 'Map') return map
		if (!this._mapKey) {
			this._mapKey = new Map()
			for (let [k,v] of Object.entries(this._keyMap)) this._mapKey.set(v,k)
		}
		let res = {}
		//map.forEach((v,k) => res[Object.keys(this._keyMap)[Object.values(this._keyMap).indexOf(k)] || k] = v)
		map.forEach((v,k) => res[safeKey(this._mapKey.has(k) ? this._mapKey.get(k) : k)] =  v)
		return res
	}
	
	mapDecode(source, end) {
	
		let res = this.decode(source)
		if (this._keyMap) { 
			//Experiemntal support for Optimised KeyMap  decoding 
			switch (res.constructor.name) {
				case 'Array': return res.map(r => this.decodeKeys(r))
				//case 'Map': return this.decodeKeys(res)
			}
		}
		return res
	}

	decode(source, end) {
		if (src) {
			// re-entrant execution, save the state and restore it after we do this decode
			return saveState(() => {
				clearSource()
				return this ? this.decode(source, end) : decode_Decoder.prototype.decode.call(defaultOptions, source, end)
			})
		}
		srcEnd = end > -1 ? end : source.length
		position = 0
		stringPosition = 0
		srcStringEnd = 0
		srcString = null
		strings = EMPTY_ARRAY
		bundledStrings = null
		src = source
		// this provides cached access to the data view for a buffer if it is getting reused, which is a recommend
		// technique for getting data from a database where it can be copied into an existing buffer instead of creating
		// new ones
		try {
			dataView = source.dataView || (source.dataView = new DataView(source.buffer, source.byteOffset, source.byteLength))
		} catch(error) {
			// if it doesn't have a buffer, maybe it is the wrong type of object
			src = null
			if (source instanceof Uint8Array)
				throw error
			throw new Error('Source must be a Uint8Array or Buffer but was a ' + ((source && typeof source == 'object') ? source.constructor.name : typeof source))
		}
		if (this instanceof decode_Decoder) {
			currentDecoder = this
			packedValues = this.sharedValues &&
				(this.pack ? new Array(this.maxPrivatePackedValues || 16).concat(this.sharedValues) :
				this.sharedValues)
			if (this.structures) {
				currentStructures = this.structures
				return checkedRead()
			} else if (!currentStructures || currentStructures.length > 0) {
				currentStructures = []
			}
		} else {
			currentDecoder = defaultOptions
			if (!currentStructures || currentStructures.length > 0)
				currentStructures = []
			packedValues = null
		}
		return checkedRead()
	}
	decodeMultiple(source, forEach) {
		let values, lastPosition = 0
		try {
			let size = source.length
			sequentialMode = true
			let value = this ? this.decode(source, size) : defaultDecoder.decode(source, size)
			if (forEach) {
				if (forEach(value) === false) {
					return
				}
				while(position < size) {
					lastPosition = position
					if (forEach(checkedRead()) === false) {
						return
					}
				}
			}
			else {
				values = [ value ]
				while(position < size) {
					lastPosition = position
					values.push(checkedRead())
				}
				return values
			}
		} catch(error) {
			error.lastPosition = lastPosition
			error.values = values
			throw error
		} finally {
			sequentialMode = false
			clearSource()
		}
	}
}
function getPosition() {
	return position
}
function checkedRead() {
	try {
		let result = read()
		if (bundledStrings) {
			if (position >= bundledStrings.postBundlePosition) {
				let error = new Error('Unexpected bundle position');
				error.incomplete = true;
				throw error
			}
			// bundled strings to skip past
			position = bundledStrings.postBundlePosition;
			bundledStrings = null;
		}

		if (position == srcEnd) {
			// finished reading this source, cleanup references
			currentStructures = null
			src = null
			if (referenceMap)
				referenceMap = null
		} else if (position > srcEnd) {
			// over read
			let error = new Error('Unexpected end of CBOR data')
			error.incomplete = true
			throw error
		} else if (!sequentialMode) {
			throw new Error('Data read, but end of buffer not reached')
		}
		// else more to read, but we are reading sequentially, so don't clear source yet
		return result
	} catch(error) {
		clearSource()
		if (error instanceof RangeError || error.message.startsWith('Unexpected end of buffer')) {
			error.incomplete = true
		}
		throw error
	}
}

function read() {
	let token = src[position++]
	let majorType = token >> 5
	token = token & 0x1f
	if (token > 0x17) {
		switch (token) {
			case 0x18:
				token = src[position++]
				break
			case 0x19:
				if (majorType == 7) {
					return getFloat16()
				}
				token = dataView.getUint16(position)
				position += 2
				break
			case 0x1a:
				if (majorType == 7) {
					let value = dataView.getFloat32(position)
					if (currentDecoder.useFloat32 > 2) {
						// this does rounding of numbers that were encoded in 32-bit float to nearest significant decimal digit that could be preserved
						let multiplier = mult10[((src[position] & 0x7f) << 1) | (src[position + 1] >> 7)]
						position += 4
						return ((multiplier * value + (value > 0 ? 0.5 : -0.5)) >> 0) / multiplier
					}
					position += 4
					return value
				}
				token = dataView.getUint32(position)
				position += 4
				break
			case 0x1b:
				if (majorType == 7) {
					let value = dataView.getFloat64(position)
					position += 8
					return value
				}
				if (majorType > 1) {
					if (dataView.getUint32(position) > 0)
						throw new Error('JavaScript does not support arrays, maps, or strings with length over 4294967295')
					token = dataView.getUint32(position + 4)
				} else if (currentDecoder.int64AsNumber) {
					token = dataView.getUint32(position) * 0x100000000
					token += dataView.getUint32(position + 4)
				} else
					token = dataView.getBigUint64(position)
				position += 8
				break
			case 0x1f: 
				// indefinite length
				switch(majorType) {
					case 2: // byte string
					case 3: // text string
						throw new Error('Indefinite length not supported for byte or text strings')
					case 4: // array
						let array = []
						let value, i = 0
						while ((value = read()) != STOP_CODE) {
							if (i >= maxArraySize) throw new Error(`Array length exceeds ${maxArraySize}`)
							array[i++] = value
						}
						return majorType == 4 ? array : majorType == 3 ? array.join('') : Buffer.concat(array)
					case 5: // map
						let key
						if (currentDecoder.mapsAsObjects) {
							let object = {}
							let i = 0;
							if (currentDecoder.keyMap) {
								while((key = read()) != STOP_CODE) {
									if (i++ >= maxMapSize) throw new Error(`Property count exceeds ${maxMapSize}`)
									object[safeKey(currentDecoder.decodeKey(key))] = read()
								}
							}
							else {
								while ((key = read()) != STOP_CODE) {
									if (i++ >= maxMapSize) throw new Error(`Property count exceeds ${maxMapSize}`)
									object[safeKey(key)] = read()
								}
							}
							return object
						} else {
							if (restoreMapsAsObject) {
								currentDecoder.mapsAsObjects = true
								restoreMapsAsObject = false
							}
							let map = new Map()
							if (currentDecoder.keyMap) {
								let i = 0;
								while((key = read()) != STOP_CODE) {
									if (i++ >= maxMapSize) {
										throw new Error(`Map size exceeds ${maxMapSize}`);
									}
									map.set(currentDecoder.decodeKey(key), read())
								}
							}
							else {
								let i = 0;
								while ((key = read()) != STOP_CODE) {
									if (i++ >= maxMapSize) {
										throw new Error(`Map size exceeds ${maxMapSize}`);
									}
									map.set(key, read())
								}
							}
							return map
						}
					case 7:
						return STOP_CODE
					default:
						throw new Error('Invalid major type for indefinite length ' + majorType)
				}
			default:
				throw new Error('Unknown token ' + token)
		}
	}
	switch (majorType) {
		case 0: // positive int
			return token
		case 1: // negative int
			return ~token
		case 2: // buffer
			return readBin(token)
		case 3: // string
			if (srcStringEnd >= position) {
				return srcString.slice(position - srcStringStart, (position += token) - srcStringStart)
			}
			if (srcStringEnd == 0 && srcEnd < 140 && token < 32) {
				// for small blocks, avoiding the overhead of the extract call is helpful
				let string = token < 16 ? shortStringInJS(token) : longStringInJS(token)
				if (string != null)
					return string
			}
			return readFixedString(token)
		case 4: // array
			if (token >= maxArraySize) throw new Error(`Array length exceeds ${maxArraySize}`)
			let array = new Array(token)
		  //if (currentDecoder.keyMap) for (let i = 0; i < token; i++) array[i] = currentDecoder.decodeKey(read())	
			//else 
			for (let i = 0; i < token; i++) array[i] = read()
			return array
		case 5: // map
			if (token >= maxMapSize) throw new Error(`Map size exceeds ${maxArraySize}`)
			if (currentDecoder.mapsAsObjects) {
				let object = {}
				if (currentDecoder.keyMap) for (let i = 0; i < token; i++) object[safeKey(currentDecoder.decodeKey(read()))] = read()
				else for (let i = 0; i < token; i++) object[safeKey(read())] = read()
				return object
			} else {
				if (restoreMapsAsObject) {
					currentDecoder.mapsAsObjects = true
					restoreMapsAsObject = false
				}
				let map = new Map()
				if (currentDecoder.keyMap) for (let i = 0; i < token; i++) map.set(currentDecoder.decodeKey(read()),read())
				else for (let i = 0; i < token; i++) map.set(read(), read())
				return map
			}
		case 6: // extension
			if (token >= BUNDLED_STRINGS_ID) {
				let structure = currentStructures[token & 0x1fff] // check record structures first
				// At some point we may provide an option for dynamic tag assignment with a range like token >= 8 && (token < 16 || (token > 0x80 && token < 0xc0) || (token > 0x130 && token < 0x4000))
				if (structure) {
					if (!structure.read) structure.read = createStructureReader(structure)
					return structure.read()
				}
				if (token < 0x10000) {
					if (token == RECORD_INLINE_ID) { // we do a special check for this so that we can keep the
						// currentExtensions as densely stored array (v8 stores arrays densely under about 3000 elements)
						let length = readJustLength()
						let id = read()
						let structure = read()
						recordDefinition(id, structure)
						let object = {}
						if (currentDecoder.keyMap) for (let i = 2; i < length; i++) {
							let key = currentDecoder.decodeKey(structure[i - 2])
							object[safeKey(key)] = read()
						}
						else for (let i = 2; i < length; i++) {
							let key = structure[i - 2]
							object[safeKey(key)] = read()
						}
						return object
					}
					else if (token == RECORD_DEFINITIONS_ID) {
						let length = readJustLength()
						let id = read()
						for (let i = 2; i < length; i++) {
							recordDefinition(id++, read())
						}
						return read()
					} else if (token == BUNDLED_STRINGS_ID) {
						return readBundleExt()
					}
					if (currentDecoder.getShared) {
						loadShared()
						structure = currentStructures[token & 0x1fff]
						if (structure) {
							if (!structure.read)
								structure.read = createStructureReader(structure)
							return structure.read()
						}
					}
				}
			}
			let extension = currentExtensions[token]
			if (extension) {
				if (extension.handlesRead)
					return extension(read)
				else
					return extension(read())
			} else {
				let input = read()
				for (let i = 0; i < currentExtensionRanges.length; i++) {
					let value = currentExtensionRanges[i](token, input)
					if (value !== undefined)
						return value
				}
				return new Tag(input, token)
			}
		case 7: // fixed value
			switch (token) {
				case 0x14: return false
				case 0x15: return true
				case 0x16: return null
				case 0x17: return; // undefined
				case 0x1f:
				default:
					let packedValue = (packedValues || getPackedValues())[token]
					if (packedValue !== undefined)
						return packedValue
					throw new Error('Unknown token ' + token)
			}
		default: // negative int
			if (isNaN(token)) {
				let error = new Error('Unexpected end of CBOR data')
				error.incomplete = true
				throw error
			}
			throw new Error('Unknown CBOR token ' + token)
	}
}
const validName = /^[a-zA-Z_$][a-zA-Z\d_$]*$/
function createStructureReader(structure) {
	if (!structure) throw new Error('Structure is required in record definition');
	function readObject() {
		// get the array size from the header
		let length = src[position++]
		//let majorType = token >> 5
		length = length & 0x1f
		if (length > 0x17) {
			switch (length) {
				case 0x18:
					length = src[position++]
					break
				case 0x19:
					length = dataView.getUint16(position)
					position += 2
					break
				case 0x1a:
					length = dataView.getUint32(position)
					position += 4
					break
				default:
					throw new Error('Expected array header, but got ' + src[position - 1])
			}
		}
		// This initial function is quick to instantiate, but runs slower. After several iterations pay the cost to build the faster function
		let compiledReader = this.compiledReader // first look to see if we have the fast compiled function
		while(compiledReader) {
			// we have a fast compiled object literal reader
			if (compiledReader.propertyCount === length)
				return compiledReader(read) // with the right length, so we use it
			compiledReader = compiledReader.next // see if there is another reader with the right length
		}
		if (this.slowReads++ >= inlineObjectReadThreshold) { // create a fast compiled reader
			let array = this.length == length ? this : this.slice(0, length)
			compiledReader = currentDecoder.keyMap 
			? new Function('r', 'return {' + array.map(k => currentDecoder.decodeKey(k)).map(k => validName.test(k) ? safeKey(k) + ':r()' : ('[' + JSON.stringify(k) + ']:r()')).join(',') + '}')
			: new Function('r', 'return {' + array.map(key => validName.test(key) ? safeKey(key) + ':r()' : ('[' + JSON.stringify(key) + ']:r()')).join(',') + '}')
			if (this.compiledReader)
				compiledReader.next = this.compiledReader // if there is an existing one, we store multiple readers as a linked list because it is usually pretty rare to have multiple readers (of different length) for the same structure
			compiledReader.propertyCount = length
			this.compiledReader = compiledReader
			return compiledReader(read)
		}
		let object = {}
		if (currentDecoder.keyMap) for (let i = 0; i < length; i++) object[safeKey(currentDecoder.decodeKey(this[i]))] = read()
		else for (let i = 0; i < length; i++) {
			object[safeKey(this[i])] = read();
		}
		return object
	}
	structure.slowReads = 0
	return readObject
}

function safeKey(key) {
	// protect against prototype pollution
	if (typeof key === 'string') return key === '__proto__' ? '__proto_' : key
	if (typeof key === 'number' || typeof key === 'boolean' || typeof key === 'bigint') return key.toString();
	if (key == null) return key + '';
	// protect against expensive (DoS) string conversions
	throw new Error('Invalid property name type ' + typeof key);
}

let readFixedString = readStringJS
let readString8 = (/* unused pure expression or super */ null && (readStringJS))
let readString16 = (/* unused pure expression or super */ null && (readStringJS))
let readString32 = (/* unused pure expression or super */ null && (readStringJS))

let isNativeAccelerationEnabled = false
function setExtractor(extractStrings) {
	isNativeAccelerationEnabled = true
	readFixedString = readString(1)
	readString8 = readString(2)
	readString16 = readString(3)
	readString32 = readString(5)
	function readString(headerLength) {
		return function readString(length) {
			let string = strings[stringPosition++]
			if (string == null) {
				if (bundledStrings)
					return readStringJS(length)
				let extraction = extractStrings(position, srcEnd, length, src)
				if (typeof extraction == 'string') {
					string = extraction
					strings = EMPTY_ARRAY
				} else {
					strings = extraction
					stringPosition = 1
					srcStringEnd = 1 // even if a utf-8 string was decoded, must indicate we are in the midst of extracted strings and can't skip strings
					string = strings[0]
					if (string === undefined)
						throw new Error('Unexpected end of buffer')
				}
			}
			let srcStringLength = string.length
			if (srcStringLength <= length) {
				position += length
				return string
			}
			srcString = string
			srcStringStart = position
			srcStringEnd = position + srcStringLength
			position += length
			return string.slice(0, length) // we know we just want the beginning
		}
	}
}
function readStringJS(length) {
	let result
	if (length < 16) {
		if (result = shortStringInJS(length))
			return result
	}
	if (length > 64 && decoder)
		return decoder.decode(src.subarray(position, position += length))
	const end = position + length
	const units = []
	result = ''
	while (position < end) {
		const byte1 = src[position++]
		if ((byte1 & 0x80) === 0) {
			// 1 byte
			units.push(byte1)
		} else if ((byte1 & 0xe0) === 0xc0) {
			// 2 bytes
			const byte2 = src[position++] & 0x3f
			units.push(((byte1 & 0x1f) << 6) | byte2)
		} else if ((byte1 & 0xf0) === 0xe0) {
			// 3 bytes
			const byte2 = src[position++] & 0x3f
			const byte3 = src[position++] & 0x3f
			units.push(((byte1 & 0x1f) << 12) | (byte2 << 6) | byte3)
		} else if ((byte1 & 0xf8) === 0xf0) {
			// 4 bytes
			const byte2 = src[position++] & 0x3f
			const byte3 = src[position++] & 0x3f
			const byte4 = src[position++] & 0x3f
			let unit = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0c) | (byte3 << 0x06) | byte4
			if (unit > 0xffff) {
				unit -= 0x10000
				units.push(((unit >>> 10) & 0x3ff) | 0xd800)
				unit = 0xdc00 | (unit & 0x3ff)
			}
			units.push(unit)
		} else {
			units.push(byte1)
		}

		if (units.length >= 0x1000) {
			result += fromCharCode.apply(String, units)
			units.length = 0
		}
	}

	if (units.length > 0) {
		result += fromCharCode.apply(String, units)
	}

	return result
}
let fromCharCode = String.fromCharCode
function longStringInJS(length) {
	let start = position
	let bytes = new Array(length)
	for (let i = 0; i < length; i++) {
		const byte = src[position++];
		if ((byte & 0x80) > 0) {
			position = start
    			return
    		}
    		bytes[i] = byte
    	}
    	return fromCharCode.apply(String, bytes)
}
function shortStringInJS(length) {
	if (length < 4) {
		if (length < 2) {
			if (length === 0)
				return ''
			else {
				let a = src[position++]
				if ((a & 0x80) > 1) {
					position -= 1
					return
				}
				return fromCharCode(a)
			}
		} else {
			let a = src[position++]
			let b = src[position++]
			if ((a & 0x80) > 0 || (b & 0x80) > 0) {
				position -= 2
				return
			}
			if (length < 3)
				return fromCharCode(a, b)
			let c = src[position++]
			if ((c & 0x80) > 0) {
				position -= 3
				return
			}
			return fromCharCode(a, b, c)
		}
	} else {
		let a = src[position++]
		let b = src[position++]
		let c = src[position++]
		let d = src[position++]
		if ((a & 0x80) > 0 || (b & 0x80) > 0 || (c & 0x80) > 0 || (d & 0x80) > 0) {
			position -= 4
			return
		}
		if (length < 6) {
			if (length === 4)
				return fromCharCode(a, b, c, d)
			else {
				let e = src[position++]
				if ((e & 0x80) > 0) {
					position -= 5
					return
				}
				return fromCharCode(a, b, c, d, e)
			}
		} else if (length < 8) {
			let e = src[position++]
			let f = src[position++]
			if ((e & 0x80) > 0 || (f & 0x80) > 0) {
				position -= 6
				return
			}
			if (length < 7)
				return fromCharCode(a, b, c, d, e, f)
			let g = src[position++]
			if ((g & 0x80) > 0) {
				position -= 7
				return
			}
			return fromCharCode(a, b, c, d, e, f, g)
		} else {
			let e = src[position++]
			let f = src[position++]
			let g = src[position++]
			let h = src[position++]
			if ((e & 0x80) > 0 || (f & 0x80) > 0 || (g & 0x80) > 0 || (h & 0x80) > 0) {
				position -= 8
				return
			}
			if (length < 10) {
				if (length === 8)
					return fromCharCode(a, b, c, d, e, f, g, h)
				else {
					let i = src[position++]
					if ((i & 0x80) > 0) {
						position -= 9
						return
					}
					return fromCharCode(a, b, c, d, e, f, g, h, i)
				}
			} else if (length < 12) {
				let i = src[position++]
				let j = src[position++]
				if ((i & 0x80) > 0 || (j & 0x80) > 0) {
					position -= 10
					return
				}
				if (length < 11)
					return fromCharCode(a, b, c, d, e, f, g, h, i, j)
				let k = src[position++]
				if ((k & 0x80) > 0) {
					position -= 11
					return
				}
				return fromCharCode(a, b, c, d, e, f, g, h, i, j, k)
			} else {
				let i = src[position++]
				let j = src[position++]
				let k = src[position++]
				let l = src[position++]
				if ((i & 0x80) > 0 || (j & 0x80) > 0 || (k & 0x80) > 0 || (l & 0x80) > 0) {
					position -= 12
					return
				}
				if (length < 14) {
					if (length === 12)
						return fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l)
					else {
						let m = src[position++]
						if ((m & 0x80) > 0) {
							position -= 13
							return
						}
						return fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l, m)
					}
				} else {
					let m = src[position++]
					let n = src[position++]
					if ((m & 0x80) > 0 || (n & 0x80) > 0) {
						position -= 14
						return
					}
					if (length < 15)
						return fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l, m, n)
					let o = src[position++]
					if ((o & 0x80) > 0) {
						position -= 15
						return
					}
					return fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o)
				}
			}
		}
	}
}

function readBin(length) {
	return currentDecoder.copyBuffers ?
		// specifically use the copying slice (not the node one)
		Uint8Array.prototype.slice.call(src, position, position += length) :
		src.subarray(position, position += length)
}
function readExt(length) {
	let type = src[position++]
	if (currentExtensions[type]) {
		return currentExtensions[type](src.subarray(position, position += length))
	}
	else
		throw new Error('Unknown extension type ' + type)
}
let f32Array = new Float32Array(1)
let u8Array = new Uint8Array(f32Array.buffer, 0, 4)
function getFloat16() {
	let byte0 = src[position++]
	let byte1 = src[position++]
	let exponent = (byte0 & 0x7f) >> 2;
	if (exponent === 0x1f) { // specials
		if (byte1 || (byte0 & 3))
			return NaN;
		return (byte0 & 0x80) ? -Infinity : Infinity;
	}
	if (exponent === 0) { // sub-normals
		// significand with 10 fractional bits and divided by 2^14
		let abs = (((byte0 & 3) << 8) | byte1) / (1 << 24)
		return (byte0 & 0x80) ? -abs : abs
	}

	u8Array[3] = (byte0 & 0x80) | // sign bit
		((exponent >> 1) + 56) // 4 of 5 of the exponent bits, re-offset-ed
	u8Array[2] = ((byte0 & 7) << 5) | // last exponent bit and first two mantissa bits
		(byte1 >> 3) // next 5 bits of mantissa
	u8Array[1] = byte1 << 5; // last three bits of mantissa
	u8Array[0] = 0;
	return f32Array[0];
}

let keyCache = new Array(4096)
function readKey() {
	let length = src[position++]
	if (length >= 0x60 && length < 0x78) {
		// fixstr, potentially use key cache
		length = length - 0x60
		if (srcStringEnd >= position) // if it has been extracted, must use it (and faster anyway)
			return srcString.slice(position - srcStringStart, (position += length) - srcStringStart)
		else if (!(srcStringEnd == 0 && srcEnd < 180))
			return readFixedString(length)
	} else { // not cacheable, go back and do a standard read
		position--
		return read()
	}
	let key = ((length << 5) ^ (length > 1 ? dataView.getUint16(position) : length > 0 ? src[position] : 0)) & 0xfff
	let entry = keyCache[key]
	let checkPosition = position
	let end = position + length - 3
	let chunk
	let i = 0
	if (entry && entry.bytes == length) {
		while (checkPosition < end) {
			chunk = dataView.getUint32(checkPosition)
			if (chunk != entry[i++]) {
				checkPosition = 0x70000000
				break
			}
			checkPosition += 4
		}
		end += 3
		while (checkPosition < end) {
			chunk = src[checkPosition++]
			if (chunk != entry[i++]) {
				checkPosition = 0x70000000
				break
			}
		}
		if (checkPosition === end) {
			position = checkPosition
			return entry.string
		}
		end -= 3
		checkPosition = position
	}
	entry = []
	keyCache[key] = entry
	entry.bytes = length
	while (checkPosition < end) {
		chunk = dataView.getUint32(checkPosition)
		entry.push(chunk)
		checkPosition += 4
	}
	end += 3
	while (checkPosition < end) {
		chunk = src[checkPosition++]
		entry.push(chunk)
	}
	// for small blocks, avoiding the overhead of the extract call is helpful
	let string = length < 16 ? shortStringInJS(length) : longStringInJS(length)
	if (string != null)
		return entry.string = string
	return entry.string = readFixedString(length)
}

class Tag {
	constructor(value, tag) {
		this.value = value
		this.tag = tag
	}
}

currentExtensions[0] = (dateString) => {
	// string date extension
	return new Date(dateString)
}

currentExtensions[1] = (epochSec) => {
	// numeric date extension
	return new Date(Math.round(epochSec * 1000))
}

currentExtensions[2] = (buffer) => {
	// bigint extension
	let value = BigInt(0)
	for (let i = 0, l = buffer.byteLength; i < l; i++) {
		value = BigInt(buffer[i]) + (value << BigInt(8))
	}
	return value
}

currentExtensions[3] = (buffer) => {
	// negative bigint extension
	return BigInt(-1) - currentExtensions[2](buffer)
}
currentExtensions[4] = (fraction) => {
	// best to reparse to maintain accuracy
	return +(fraction[1] + 'e' + fraction[0])
}

currentExtensions[5] = (fraction) => {
	// probably not sufficiently accurate
	return fraction[1] * Math.exp(fraction[0] * Math.log(2))
}

// the registration of the record definition extension
const recordDefinition = (id, structure) => {
	id = id - 0xe000
	let existingStructure = currentStructures[id]
	if (existingStructure && existingStructure.isShared) {
		(currentStructures.restoreStructures || (currentStructures.restoreStructures = []))[id] = existingStructure
	}
	currentStructures[id] = structure

	structure.read = createStructureReader(structure)
}
currentExtensions[LEGACY_RECORD_INLINE_ID] = (data) => {
	let length = data.length
	let structure = data[1]
	recordDefinition(data[0], structure)
	let object = {}
	for (let i = 2; i < length; i++) {
		let key = structure[i - 2]
		object[safeKey(key)] = data[i]
	}
	return object
}
currentExtensions[14] = (value) => {
	if (bundledStrings)
		return bundledStrings[0].slice(bundledStrings.position0, bundledStrings.position0 += value)
	return new Tag(value, 14)
}
currentExtensions[15] = (value) => {
	if (bundledStrings)
		return bundledStrings[1].slice(bundledStrings.position1, bundledStrings.position1 += value)
	return new Tag(value, 15)
}
let glbl = { Error, RegExp }
currentExtensions[27] = (data) => { // http://cbor.schmorp.de/generic-object
	return (glbl[data[0]] || Error)(data[1], data[2])
}
const packedTable = (read) => {
	if (src[position++] != 0x84) {
		let error = new Error('Packed values structure must be followed by a 4 element array')
		if (src.length < position)
			error.incomplete = true
		throw error
	}
	let newPackedValues = read() // packed values
	if (!newPackedValues || !newPackedValues.length) {
		let error = new Error('Packed values structure must be followed by a 4 element array')
		error.incomplete = true
		throw error
	}
	packedValues = packedValues ? newPackedValues.concat(packedValues.slice(newPackedValues.length)) : newPackedValues
	packedValues.prefixes = read()
	packedValues.suffixes = read()
	return read() // read the rump
}
packedTable.handlesRead = true
currentExtensions[51] = packedTable

currentExtensions[PACKED_REFERENCE_TAG_ID] = (data) => { // packed reference
	if (!packedValues) {
		if (currentDecoder.getShared)
			loadShared()
		else
			return new Tag(data, PACKED_REFERENCE_TAG_ID)
	}
	if (typeof data == 'number')
		return packedValues[16 + (data >= 0 ? 2 * data : (-2 * data - 1))]
	let error = new Error('No support for non-integer packed references yet')
	if (data === undefined)
		error.incomplete = true
	throw error
}

// The following code is an incomplete implementation of http://cbor.schmorp.de/stringref
// the real thing would need to implemennt more logic to populate the stringRefs table and
// maintain a stack of stringRef "namespaces".
//
// currentExtensions[25] = (id) => {
// 	return stringRefs[id]
// }
// currentExtensions[256] = (read) => {
// 	stringRefs = []
// 	try {
// 		return read()
// 	} finally {
// 		stringRefs = null
// 	}
// }
// currentExtensions[256].handlesRead = true

currentExtensions[28] = (read) => { 
	// shareable http://cbor.schmorp.de/value-sharing (for structured clones)
	if (!referenceMap) {
		referenceMap = new Map()
		referenceMap.id = 0
	}
	let id = referenceMap.id++
	let startingPosition = position
	let token = src[position]
	let target
	// TODO: handle Maps, Sets, and other types that can cycle; this is complicated, because you potentially need to read
	// ahead past references to record structure definitions
	if ((token >> 5) == 4)
		target = []
	else
		target = {}

	let refEntry = { target } // a placeholder object
	referenceMap.set(id, refEntry)
	let targetProperties = read() // read the next value as the target object to id
	if (refEntry.used) {// there is a cycle, so we have to assign properties to original target
		if (Object.getPrototypeOf(target) !== Object.getPrototypeOf(targetProperties)) {
			// this means that the returned target does not match the targetProperties, so we need rerun the read to
			// have the correctly create instance be assigned as a reference, then we do the copy the properties back to the
			// target
			// reset the position so that the read can be repeated
			position = startingPosition
			// the returned instance is our new target for references
			target = targetProperties
			referenceMap.set(id, { target })
			targetProperties = read()
		}
		return Object.assign(target, targetProperties)
	}
	refEntry.target = targetProperties // the placeholder wasn't used, replace with the deserialized one
	return targetProperties // no cycle, can just use the returned read object
}
currentExtensions[28].handlesRead = true

currentExtensions[29] = (id) => {
	// sharedref http://cbor.schmorp.de/value-sharing (for structured clones)
	let refEntry = referenceMap.get(id)
	refEntry.used = true
	return refEntry.target
}

currentExtensions[258] = (array) => new Set(array); // https://github.com/input-output-hk/cbor-sets-spec/blob/master/CBOR_SETS.md
(currentExtensions[259] = (read) => {
	// https://github.com/shanewholloway/js-cbor-codec/blob/master/docs/CBOR-259-spec
	// for decoding as a standard Map
	if (currentDecoder.mapsAsObjects) {
		currentDecoder.mapsAsObjects = false
		restoreMapsAsObject = true
	}
	return read()
}).handlesRead = true
function combine(a, b) {
	if (typeof a === 'string')
		return a + b
	if (a instanceof Array)
		return a.concat(b)
	return Object.assign({}, a, b)
}
function getPackedValues() {
	if (!packedValues) {
		if (currentDecoder.getShared)
			loadShared()
		else
			throw new Error('No packed values available')
	}
	return packedValues
}
const SHARED_DATA_TAG_ID = 0x53687264 // ascii 'Shrd'
currentExtensionRanges.push((tag, input) => {
	if (tag >= 225 && tag <= 255)
		return combine(getPackedValues().prefixes[tag - 224], input)
	if (tag >= 28704 && tag <= 32767)
		return combine(getPackedValues().prefixes[tag - 28672], input)
	if (tag >= 1879052288 && tag <= 2147483647)
		return combine(getPackedValues().prefixes[tag - 1879048192], input)
	if (tag >= 216 && tag <= 223)
		return combine(input, getPackedValues().suffixes[tag - 216])
	if (tag >= 27647 && tag <= 28671)
		return combine(input, getPackedValues().suffixes[tag - 27639])
	if (tag >= 1811940352 && tag <= 1879048191)
		return combine(input, getPackedValues().suffixes[tag - 1811939328])
	if (tag == SHARED_DATA_TAG_ID) {// we do a special check for this so that we can keep the currentExtensions as densely stored array (v8 stores arrays densely under about 3000 elements)
		return {
			packedValues: packedValues,
			structures: currentStructures.slice(0),
			version: input,
		}
	}
	if (tag == 55799) // self-descriptive CBOR tag, just return input value
		return input
})

const isLittleEndianMachine = new Uint8Array(new Uint16Array([1]).buffer)[0] == 1
const typedArrays = [Uint8Array, Uint8ClampedArray, Uint16Array, Uint32Array,
	typeof BigUint64Array == 'undefined' ? { name:'BigUint64Array' } : BigUint64Array, Int8Array, Int16Array, Int32Array,
	typeof BigInt64Array == 'undefined' ? { name:'BigInt64Array' } : BigInt64Array, Float32Array, Float64Array]
const typedArrayTags = [64, 68, 69, 70, 71, 72, 77, 78, 79, 85, 86]
for (let i = 0; i < typedArrays.length; i++) {
	registerTypedArray(typedArrays[i], typedArrayTags[i])
}
function registerTypedArray(TypedArray, tag) {
	let dvMethod = 'get' + TypedArray.name.slice(0, -5)
	let bytesPerElement;
	if (typeof TypedArray === 'function')
		bytesPerElement = TypedArray.BYTES_PER_ELEMENT;
	else
		TypedArray = null;
	for (let littleEndian = 0; littleEndian < 2; littleEndian++) {
		if (!littleEndian && bytesPerElement == 1)
			continue
		let sizeShift = bytesPerElement == 2 ? 1 : bytesPerElement == 4 ? 2 : bytesPerElement == 8 ? 3 : 0
		currentExtensions[littleEndian ? tag : (tag - 4)] = (bytesPerElement == 1 || littleEndian == isLittleEndianMachine) ? (buffer) => {
			if (!TypedArray)
				throw new Error('Could not find typed array for code ' + tag)
			if (!currentDecoder.copyBuffers) {
				// try provide a direct view, but will only work if we are byte-aligned
				if (bytesPerElement === 1 ||
					bytesPerElement === 2 && !(buffer.byteOffset & 1) ||
					bytesPerElement === 4 && !(buffer.byteOffset & 3) ||
					bytesPerElement === 8 && !(buffer.byteOffset & 7))
					return new TypedArray(buffer.buffer, buffer.byteOffset, buffer.byteLength >> sizeShift);
			}
			// we have to slice/copy here to get a new ArrayBuffer, if we are not word/byte aligned
			return new TypedArray(Uint8Array.prototype.slice.call(buffer, 0).buffer)
		} : buffer => {
			if (!TypedArray)
				throw new Error('Could not find typed array for code ' + tag)
			let dv = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength)
			let elements = buffer.length >> sizeShift
			let ta = new TypedArray(elements)
			let method = dv[dvMethod]
			for (let i = 0; i < elements; i++) {
				ta[i] = method.call(dv, i << sizeShift, littleEndian)
			}
			return ta
		}
	}
}

function readBundleExt() {
	let length = readJustLength()
	let bundlePosition = position + read()
	for (let i = 2; i < length; i++) {
		// skip past bundles that were already read
		let bundleLength = readJustLength() // this will increment position, so must add to position afterwards
		position += bundleLength
	}
	let dataPosition = position
	position = bundlePosition
	bundledStrings = [readStringJS(readJustLength()), readStringJS(readJustLength())]
	bundledStrings.position0 = 0
	bundledStrings.position1 = 0
	bundledStrings.postBundlePosition = position
	position = dataPosition
	return read()
}

function readJustLength() {
	let token = src[position++] & 0x1f
	if (token > 0x17) {
		switch (token) {
			case 0x18:
				token = src[position++]
				break
			case 0x19:
				token = dataView.getUint16(position)
				position += 2
				break
			case 0x1a:
				token = dataView.getUint32(position)
				position += 4
				break
		}
	}
	return token
}

function loadShared() {
	if (currentDecoder.getShared) {
		let sharedData = saveState(() => {
			// save the state in case getShared modifies our buffer
			src = null
			return currentDecoder.getShared()
		}) || {}
		let updatedStructures = sharedData.structures || []
		currentDecoder.sharedVersion = sharedData.version
		packedValues = currentDecoder.sharedValues = sharedData.packedValues
		if (currentStructures === true)
			currentDecoder.structures = currentStructures = updatedStructures
		else
			currentStructures.splice.apply(currentStructures, [0, updatedStructures.length].concat(updatedStructures))
	}
}

function saveState(callback) {
	let savedSrcEnd = srcEnd
	let savedPosition = position
	let savedStringPosition = stringPosition
	let savedSrcStringStart = srcStringStart
	let savedSrcStringEnd = srcStringEnd
	let savedSrcString = srcString
	let savedStrings = strings
	let savedReferenceMap = referenceMap
	let savedBundledStrings = bundledStrings

	// TODO: We may need to revisit this if we do more external calls to user code (since it could be slow)
	let savedSrc = new Uint8Array(src.slice(0, srcEnd)) // we copy the data in case it changes while external data is processed
	let savedStructures = currentStructures
	let savedDecoder = currentDecoder
	let savedSequentialMode = sequentialMode
	let value = callback()
	srcEnd = savedSrcEnd
	position = savedPosition
	stringPosition = savedStringPosition
	srcStringStart = savedSrcStringStart
	srcStringEnd = savedSrcStringEnd
	srcString = savedSrcString
	strings = savedStrings
	referenceMap = savedReferenceMap
	bundledStrings = savedBundledStrings
	src = savedSrc
	sequentialMode = savedSequentialMode
	currentStructures = savedStructures
	currentDecoder = savedDecoder
	dataView = new DataView(src.buffer, src.byteOffset, src.byteLength)
	return value
}
function clearSource() {
	src = null
	referenceMap = null
	currentStructures = null
}

function addExtension(extension) {
	currentExtensions[extension.tag] = extension.decode
}

function setSizeLimits(limits) {
	if (limits.maxMapSize) maxMapSize = limits.maxMapSize;
	if (limits.maxArraySize) maxArraySize = limits.maxArraySize;
	if (limits.maxObjectSize) maxObjectSize = limits.maxObjectSize;
}

const mult10 = new Array(147) // this is a table matching binary exponents to the multiplier to determine significant digit rounding
for (let i = 0; i < 256; i++) {
	mult10[i] = +('1e' + Math.floor(45.15 - i * 0.30103))
}
let defaultDecoder = new decode_Decoder({ useRecords: false })
const decode = defaultDecoder.decode
const decodeMultiple = defaultDecoder.decodeMultiple
const FLOAT32_OPTIONS = {
	NEVER: 0,
	ALWAYS: 1,
	DECIMAL_ROUND: 3,
	DECIMAL_FIT: 4
}
function roundFloat32(float32Number) {
	f32Array[0] = float32Number
	let multiplier = mult10[((u8Array[3] & 0x7f) << 1) | (u8Array[2] >> 7)]
	return ((multiplier * float32Number + (float32Number > 0 ? 0.5 : -0.5)) >> 0) / multiplier
}

;// CONCATENATED MODULE: ./node_modules/cbor-x/encode.js

let textEncoder
try {
	textEncoder = new TextEncoder()
} catch (error) {}
let extensions, extensionClasses
const encode_Buffer = typeof globalThis === 'object' && globalThis.Buffer;
const hasNodeBuffer = typeof encode_Buffer !== 'undefined'
const ByteArrayAllocate = hasNodeBuffer ? encode_Buffer.allocUnsafeSlow : Uint8Array
const ByteArray = hasNodeBuffer ? encode_Buffer : Uint8Array
const MAX_STRUCTURES = 0x100
const MAX_BUFFER_SIZE = hasNodeBuffer ? 0x100000000 : 0x7fd00000
let serializationId = 1
let throwOnIterable
let target
let targetView
let encode_position = 0
let safeEnd
let encode_bundledStrings = null
const MAX_BUNDLE_SIZE = 0xf000
const hasNonLatin = /[\u0080-\uFFFF]/
const RECORD_SYMBOL = Symbol('record-id')
class encode_Encoder extends decode_Decoder {
	constructor(options) {
		super(options)
		this.offset = 0
		let typeBuffer
		let start
		let sharedStructures
		let hasSharedUpdate
		let structures
		let referenceMap
		options = options || {}
		let encodeUtf8 = ByteArray.prototype.utf8Write ? function(string, position, maxBytes) {
			return target.utf8Write(string, position, maxBytes)
		} : (textEncoder && textEncoder.encodeInto) ?
			function(string, position) {
				return textEncoder.encodeInto(string, target.subarray(position)).written
			} : false

		let encoder = this
		let hasSharedStructures = options.structures || options.saveStructures
		let maxSharedStructures = options.maxSharedStructures
		if (maxSharedStructures == null)
			maxSharedStructures = hasSharedStructures ? 128 : 0
		if (maxSharedStructures > 8190)
			throw new Error('Maximum maxSharedStructure is 8190')
		let isSequential = options.sequential
		if (isSequential) {
			maxSharedStructures = 0
		}
		if (!this.structures)
			this.structures = []
		if (this.saveStructures)
			this.saveShared = this.saveStructures
		let samplingPackedValues, packedObjectMap, sharedValues = options.sharedValues
		let sharedPackedObjectMap
		if (sharedValues) {
			sharedPackedObjectMap = Object.create(null)
			for (let i = 0, l = sharedValues.length; i < l; i++) {
				sharedPackedObjectMap[sharedValues[i]] = i
			}
		}
		let recordIdsToRemove = []
		let transitionsCount = 0
		let serializationsSinceTransitionRebuild = 0
		
		this.mapEncode = function(value, encodeOptions) {
			// Experimental support for premapping keys using _keyMap instad of keyMap - not optiimised yet)
			if (this._keyMap && !this._mapped) {
				//console.log('encoding ', value)
				switch (value.constructor.name) {
					case 'Array': 
						value = value.map(r => this.encodeKeys(r))
						break
					//case 'Map': 
					//	value = this.encodeKeys(value)
					//	break
				}
				//this._mapped = true
			}
			return this.encode(value, encodeOptions)
		}
		
		this.encode = function(value, encodeOptions)	{
			if (!target) {
				target = new ByteArrayAllocate(8192)
				targetView = new DataView(target.buffer, 0, 8192)
				encode_position = 0
			}
			safeEnd = target.length - 10
			if (safeEnd - encode_position < 0x800) {
				// don't start too close to the end, 
				target = new ByteArrayAllocate(target.length)
				targetView = new DataView(target.buffer, 0, target.length)
				safeEnd = target.length - 10
				encode_position = 0
			} else if (encodeOptions === REUSE_BUFFER_MODE)
				encode_position = (encode_position + 7) & 0x7ffffff8 // Word align to make any future copying of this buffer faster
			start = encode_position
			if (encoder.useSelfDescribedHeader) {
				targetView.setUint32(encode_position, 0xd9d9f700) // tag two byte, then self-descriptive tag
				encode_position += 3
			}
			referenceMap = encoder.structuredClone ? new Map() : null
			if (encoder.bundleStrings && typeof value !== 'string') {
				encode_bundledStrings = []
				encode_bundledStrings.size = Infinity // force a new bundle start on first string
			} else
				encode_bundledStrings = null

			sharedStructures = encoder.structures
			if (sharedStructures) {
				if (sharedStructures.uninitialized) {
					let sharedData = encoder.getShared() || {}
					encoder.structures = sharedStructures = sharedData.structures || []
					encoder.sharedVersion = sharedData.version
					let sharedValues = encoder.sharedValues = sharedData.packedValues
					if (sharedValues) {
						sharedPackedObjectMap = {}
						for (let i = 0, l = sharedValues.length; i < l; i++)
							sharedPackedObjectMap[sharedValues[i]] = i
					}
				}
				let sharedStructuresLength = sharedStructures.length
				if (sharedStructuresLength > maxSharedStructures && !isSequential)
					sharedStructuresLength = maxSharedStructures
				if (!sharedStructures.transitions) {
					// rebuild our structure transitions
					sharedStructures.transitions = Object.create(null)
					for (let i = 0; i < sharedStructuresLength; i++) {
						let keys = sharedStructures[i]
						//console.log('shared struct keys:', keys)
						if (!keys)
							continue
						let nextTransition, transition = sharedStructures.transitions
						for (let j = 0, l = keys.length; j < l; j++) {
							if (transition[RECORD_SYMBOL] === undefined)
								transition[RECORD_SYMBOL] = i
							let key = keys[j]
							nextTransition = transition[key]
							if (!nextTransition) {
								nextTransition = transition[key] = Object.create(null)
							}
							transition = nextTransition
						}
						transition[RECORD_SYMBOL] = i | 0x100000
					}
				}
				if (!isSequential)
					sharedStructures.nextId = sharedStructuresLength
			}
			if (hasSharedUpdate)
				hasSharedUpdate = false
			structures = sharedStructures || []
			packedObjectMap = sharedPackedObjectMap
			if (options.pack) {
				let packedValues = new Map()
				packedValues.values = []
				packedValues.encoder = encoder
				packedValues.maxValues = options.maxPrivatePackedValues || (sharedPackedObjectMap ? 16 : Infinity)
				packedValues.objectMap = sharedPackedObjectMap || false
				packedValues.samplingPackedValues = samplingPackedValues
				findRepetitiveStrings(value, packedValues)
				if (packedValues.values.length > 0) {
					target[encode_position++] = 0xd8 // one-byte tag
					target[encode_position++] = 51 // tag 51 for packed shared structures https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
					writeArrayHeader(4)
					let valuesArray = packedValues.values
					encode(valuesArray)
					writeArrayHeader(0) // prefixes
					writeArrayHeader(0) // suffixes
					packedObjectMap = Object.create(sharedPackedObjectMap || null)
					for (let i = 0, l = valuesArray.length; i < l; i++) {
						packedObjectMap[valuesArray[i]] = i
					}
				}
			}
			throwOnIterable = encodeOptions & THROW_ON_ITERABLE;
			try {
				if (throwOnIterable)
					return;
				encode(value)
				if (encode_bundledStrings) {
					writeBundles(start, encode)
				}
				encoder.offset = encode_position // update the offset so next serialization doesn't write over our buffer, but can continue writing to same buffer sequentially
				if (referenceMap && referenceMap.idsToInsert) {
					encode_position += referenceMap.idsToInsert.length * 2
					if (encode_position > safeEnd)
						makeRoom(encode_position)
					encoder.offset = encode_position
					let serialized = insertIds(target.subarray(start, encode_position), referenceMap.idsToInsert)
					referenceMap = null
					return serialized
				}
				if (encodeOptions & REUSE_BUFFER_MODE) {
					target.start = start
					target.end = encode_position
					return target
				}
				return target.subarray(start, encode_position) // position can change if we call encode again in saveShared, so we get the buffer now
			} finally {
				if (sharedStructures) {
					if (serializationsSinceTransitionRebuild < 10)
						serializationsSinceTransitionRebuild++
					if (sharedStructures.length > maxSharedStructures)
						sharedStructures.length = maxSharedStructures
					if (transitionsCount > 10000) {
						// force a rebuild occasionally after a lot of transitions so it can get cleaned up
						sharedStructures.transitions = null
						serializationsSinceTransitionRebuild = 0
						transitionsCount = 0
						if (recordIdsToRemove.length > 0)
							recordIdsToRemove = []
					} else if (recordIdsToRemove.length > 0 && !isSequential) {
						for (let i = 0, l = recordIdsToRemove.length; i < l; i++) {
							recordIdsToRemove[i][RECORD_SYMBOL] = undefined
						}
						recordIdsToRemove = []
						//sharedStructures.nextId = maxSharedStructures
					}
				}
				if (hasSharedUpdate && encoder.saveShared) {
					if (encoder.structures.length > maxSharedStructures) {
						encoder.structures = encoder.structures.slice(0, maxSharedStructures)
					}
					// we can't rely on start/end with REUSE_BUFFER_MODE since they will (probably) change when we save
					let returnBuffer = target.subarray(start, encode_position)
					if (encoder.updateSharedData() === false)
						return encoder.encode(value) // re-encode if it fails
					return returnBuffer
				}
				if (encodeOptions & RESET_BUFFER_MODE)
					encode_position = start
			}
		}
		this.findCommonStringsToPack = () => {
			samplingPackedValues = new Map()
			if (!sharedPackedObjectMap)
				sharedPackedObjectMap = Object.create(null)
			return (options) => {
				let threshold = options && options.threshold || 4
				let position = this.pack ? options.maxPrivatePackedValues || 16 : 0
				if (!sharedValues)
					sharedValues = this.sharedValues = []
				for (let [ key, status ] of samplingPackedValues) {
					if (status.count > threshold) {
						sharedPackedObjectMap[key] = position++
						sharedValues.push(key)
						hasSharedUpdate = true
					}
				}
				while (this.saveShared && this.updateSharedData() === false) {}
				samplingPackedValues = null
			}
		}
		const encode = (value) => {
			if (encode_position > safeEnd)
				target = makeRoom(encode_position)

			var type = typeof value
			var length
			if (type === 'string') {
				if (packedObjectMap) {
					let packedPosition = packedObjectMap[value]
					if (packedPosition >= 0) {
						if (packedPosition < 16)
							target[encode_position++] = packedPosition + 0xe0 // simple values, defined in https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
						else {
							target[encode_position++] = 0xc6 // tag 6 defined in https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
							if (packedPosition & 1)
								encode((15 - packedPosition) >> 1)
							else
								encode((packedPosition - 16) >> 1)
						}
						return
/*						} else if (packedStatus.serializationId != serializationId) {
							packedStatus.serializationId = serializationId
							packedStatus.count = 1
							if (options.sharedPack) {
								let sharedCount = packedStatus.sharedCount = (packedStatus.sharedCount || 0) + 1
								if (shareCount > (options.sharedPack.threshold || 5)) {
									let sharedPosition = packedStatus.position = packedStatus.nextSharedPosition
									hasSharedUpdate = true
									if (sharedPosition < 16)
										target[position++] = sharedPosition + 0xc0

								}
							}
						} // else any in-doc incrementation?*/
					} else if (samplingPackedValues && !options.pack) {
						let status = samplingPackedValues.get(value)
						if (status)
							status.count++
						else
							samplingPackedValues.set(value, {
								count: 1,
							})
					}
				}
				let strLength = value.length
				if (encode_bundledStrings && strLength >= 4 && strLength < 0x400) {
					if ((encode_bundledStrings.size += strLength) > MAX_BUNDLE_SIZE) {
						let extStart
						let maxBytes = (encode_bundledStrings[0] ? encode_bundledStrings[0].length * 3 + encode_bundledStrings[1].length : 0) + 10
						if (encode_position + maxBytes > safeEnd)
							target = makeRoom(encode_position + maxBytes)
						target[encode_position++] = 0xd9 // tag 16-bit
						target[encode_position++] = 0xdf // tag 0xdff9
						target[encode_position++] = 0xf9
						// TODO: If we only have one bundle with any string data, only write one string bundle
						target[encode_position++] = encode_bundledStrings.position ? 0x84 : 0x82 // array of 4 or 2 elements depending on if we write bundles
						target[encode_position++] = 0x1a // 32-bit unsigned int
						extStart = encode_position - start
						encode_position += 4 // reserve for writing bundle reference
						if (encode_bundledStrings.position) {
							writeBundles(start, encode) // write the last bundles
						}
						encode_bundledStrings = ['', ''] // create new ones
						encode_bundledStrings.size = 0
						encode_bundledStrings.position = extStart
					}
					let twoByte = hasNonLatin.test(value)
					encode_bundledStrings[twoByte ? 0 : 1] += value
					target[encode_position++] = twoByte ? 0xce : 0xcf
					encode(strLength);
					return
				}
				let headerSize
				// first we estimate the header size, so we can write to the correct location
				if (strLength < 0x20) {
					headerSize = 1
				} else if (strLength < 0x100) {
					headerSize = 2
				} else if (strLength < 0x10000) {
					headerSize = 3
				} else {
					headerSize = 5
				}
				let maxBytes = strLength * 3
				if (encode_position + maxBytes > safeEnd)
					target = makeRoom(encode_position + maxBytes)

				if (strLength < 0x40 || !encodeUtf8) {
					let i, c1, c2, strPosition = encode_position + headerSize
					for (i = 0; i < strLength; i++) {
						c1 = value.charCodeAt(i)
						if (c1 < 0x80) {
							target[strPosition++] = c1
						} else if (c1 < 0x800) {
							target[strPosition++] = c1 >> 6 | 0xc0
							target[strPosition++] = c1 & 0x3f | 0x80
						} else if (
							(c1 & 0xfc00) === 0xd800 &&
							((c2 = value.charCodeAt(i + 1)) & 0xfc00) === 0xdc00
						) {
							c1 = 0x10000 + ((c1 & 0x03ff) << 10) + (c2 & 0x03ff)
							i++
							target[strPosition++] = c1 >> 18 | 0xf0
							target[strPosition++] = c1 >> 12 & 0x3f | 0x80
							target[strPosition++] = c1 >> 6 & 0x3f | 0x80
							target[strPosition++] = c1 & 0x3f | 0x80
						} else {
							target[strPosition++] = c1 >> 12 | 0xe0
							target[strPosition++] = c1 >> 6 & 0x3f | 0x80
							target[strPosition++] = c1 & 0x3f | 0x80
						}
					}
					length = strPosition - encode_position - headerSize
				} else {
					length = encodeUtf8(value, encode_position + headerSize, maxBytes)
				}

				if (length < 0x18) {
					target[encode_position++] = 0x60 | length
				} else if (length < 0x100) {
					if (headerSize < 2) {
						target.copyWithin(encode_position + 2, encode_position + 1, encode_position + 1 + length)
					}
					target[encode_position++] = 0x78
					target[encode_position++] = length
				} else if (length < 0x10000) {
					if (headerSize < 3) {
						target.copyWithin(encode_position + 3, encode_position + 2, encode_position + 2 + length)
					}
					target[encode_position++] = 0x79
					target[encode_position++] = length >> 8
					target[encode_position++] = length & 0xff
				} else {
					if (headerSize < 5) {
						target.copyWithin(encode_position + 5, encode_position + 3, encode_position + 3 + length)
					}
					target[encode_position++] = 0x7a
					targetView.setUint32(encode_position, length)
					encode_position += 4
				}
				encode_position += length
			} else if (type === 'number') {
				if (!this.alwaysUseFloat && value >>> 0 === value) {// positive integer, 32-bit or less
					// positive uint
					if (value < 0x18) {
						target[encode_position++] = value
					} else if (value < 0x100) {
						target[encode_position++] = 0x18
						target[encode_position++] = value
					} else if (value < 0x10000) {
						target[encode_position++] = 0x19
						target[encode_position++] = value >> 8
						target[encode_position++] = value & 0xff
					} else {
						target[encode_position++] = 0x1a
						targetView.setUint32(encode_position, value)
						encode_position += 4
					}
				} else if (!this.alwaysUseFloat && value >> 0 === value) { // negative integer
					if (value >= -0x18) {
						target[encode_position++] = 0x1f - value
					} else if (value >= -0x100) {
						target[encode_position++] = 0x38
						target[encode_position++] = ~value
					} else if (value >= -0x10000) {
						target[encode_position++] = 0x39
						targetView.setUint16(encode_position, ~value)
						encode_position += 2
					} else {
						target[encode_position++] = 0x3a
						targetView.setUint32(encode_position, ~value)
						encode_position += 4
					}
				} else {
					let useFloat32
					if ((useFloat32 = this.useFloat32) > 0 && value < 0x100000000 && value >= -0x80000000) {
						target[encode_position++] = 0xfa
						targetView.setFloat32(encode_position, value)
						let xShifted
						if (useFloat32 < 4 ||
								// this checks for rounding of numbers that were encoded in 32-bit float to nearest significant decimal digit that could be preserved
								((xShifted = value * mult10[((target[encode_position] & 0x7f) << 1) | (target[encode_position + 1] >> 7)]) >> 0) === xShifted) {
							encode_position += 4
							return
						} else
							encode_position-- // move back into position for writing a double
					}
					target[encode_position++] = 0xfb
					targetView.setFloat64(encode_position, value)
					encode_position += 8
				}
			} else if (type === 'object') {
				if (!value)
					target[encode_position++] = 0xf6
				else {
					if (referenceMap) {
						let referee = referenceMap.get(value)
						if (referee) {
							target[encode_position++] = 0xd8
							target[encode_position++] = 29 // http://cbor.schmorp.de/value-sharing
							target[encode_position++] = 0x19 // 16-bit uint
							if (!referee.references) {
								let idsToInsert = referenceMap.idsToInsert || (referenceMap.idsToInsert = [])
								referee.references = []
								idsToInsert.push(referee)
							}
							referee.references.push(encode_position - start)
							encode_position += 2 // TODO: also support 32-bit
							return
						} else 
							referenceMap.set(value, { offset: encode_position - start })
					}
					let constructor = value.constructor
					if (constructor === Object) {
						writeObject(value)
					} else if (constructor === Array) {
						length = value.length
						if (length < 0x18) {
							target[encode_position++] = 0x80 | length
						} else {
							writeArrayHeader(length)
						}
						for (let i = 0; i < length; i++) {
							encode(value[i])
						}
					} else if (constructor === Map) {
						if (this.mapsAsObjects ? this.useTag259ForMaps !== false : this.useTag259ForMaps) {
							// use Tag 259 (https://github.com/shanewholloway/js-cbor-codec/blob/master/docs/CBOR-259-spec--explicit-maps.md) for maps if the user wants it that way
							target[encode_position++] = 0xd9
							target[encode_position++] = 1
							target[encode_position++] = 3
						}
						length = value.size
						if (length < 0x18) {
							target[encode_position++] = 0xa0 | length
						} else if (length < 0x100) {
							target[encode_position++] = 0xb8
							target[encode_position++] = length
						} else if (length < 0x10000) {
							target[encode_position++] = 0xb9
							target[encode_position++] = length >> 8
							target[encode_position++] = length & 0xff
						} else {
							target[encode_position++] = 0xba
							targetView.setUint32(encode_position, length)
							encode_position += 4
						}
						if (encoder.keyMap) { 
							for (let [ key, entryValue ] of value) {
								encode(encoder.encodeKey(key))
								encode(entryValue)
							} 
						} else { 
							for (let [ key, entryValue ] of value) {
								encode(key) 
								encode(entryValue)
							} 	
						}
					} else {
						for (let i = 0, l = extensions.length; i < l; i++) {
							let extensionClass = extensionClasses[i]
							if (value instanceof extensionClass) {
								let extension = extensions[i]
								let tag = extension.tag
								if (tag == undefined)
									tag = extension.getTag && extension.getTag.call(this, value)
								if (tag < 0x18) {
									target[encode_position++] = 0xc0 | tag
								} else if (tag < 0x100) {
									target[encode_position++] = 0xd8
									target[encode_position++] = tag
								} else if (tag < 0x10000) {
									target[encode_position++] = 0xd9
									target[encode_position++] = tag >> 8
									target[encode_position++] = tag & 0xff
								} else if (tag > -1) {
									target[encode_position++] = 0xda
									targetView.setUint32(encode_position, tag)
									encode_position += 4
								} // else undefined, don't write tag
								extension.encode.call(this, value, encode, makeRoom)
								return
							}
						}
						if (value[Symbol.iterator]) {
							if (throwOnIterable) {
								let error = new Error('Iterable should be serialized as iterator')
								error.iteratorNotHandled = true;
								throw error;
							}
							target[encode_position++] = 0x9f // indefinite length array
							for (let entry of value) {
								encode(entry)
							}
							target[encode_position++] = 0xff // stop-code
							return
						}
						if (value[Symbol.asyncIterator] || isBlob(value)) {
							let error = new Error('Iterable/blob should be serialized as iterator')
							error.iteratorNotHandled = true;
							throw error;
						}
						if (this.useToJSON && value.toJSON) {
							const json = value.toJSON()
							// if for some reason value.toJSON returns itself it'll loop forever
							if (json !== value)
								return encode(json)
						}

						// no extension found, write as a plain object
						writeObject(value)
					}
				}
			} else if (type === 'boolean') {
				target[encode_position++] = value ? 0xf5 : 0xf4
			} else if (type === 'bigint') {
				if (value < (BigInt(1)<<BigInt(64)) && value >= 0) {
					// use an unsigned int as long as it fits
					target[encode_position++] = 0x1b
					targetView.setBigUint64(encode_position, value)
				} else if (value > -(BigInt(1)<<BigInt(64)) && value < 0) {
					// if we can fit an unsigned int, use that
					target[encode_position++] = 0x3b
					targetView.setBigUint64(encode_position, -value - BigInt(1))
				} else {
					// overflow
					if (this.largeBigIntToFloat) {
						target[encode_position++] = 0xfb
						targetView.setFloat64(encode_position, Number(value))
					} else {
						if (value >= BigInt(0))
							target[encode_position++] = 0xc2 // tag 2
						else {
							target[encode_position++] = 0xc3 // tag 2
							value = BigInt(-1) - value;
						}
						let bytes = [];
						while (value) {
							bytes.push(Number(value & BigInt(0xff)));
							value >>= BigInt(8);
						}
						writeBuffer(new Uint8Array(bytes.reverse()), makeRoom);
						return;
					}
				}
				encode_position += 8
			} else if (type === 'undefined') {
				target[encode_position++] = 0xf7
			} else {
				throw new Error('Unknown type: ' + type)
			}
		}

		const writeObject = this.useRecords === false ? this.variableMapSize ? (object) => {
			// this method is slightly slower, but generates "preferred serialization" (optimally small for smaller objects)
			let keys = Object.keys(object)
			let vals = Object.values(object)
			let length = keys.length
			if (length < 0x18) {
				target[encode_position++] = 0xa0 | length
			} else if (length < 0x100) {
				target[encode_position++] = 0xb8
				target[encode_position++] = length
			} else if (length < 0x10000) {
				target[encode_position++] = 0xb9
				target[encode_position++] = length >> 8
				target[encode_position++] = length & 0xff
			} else {
				target[encode_position++] = 0xba
				targetView.setUint32(encode_position, length)
				encode_position += 4
			}
			let key
			if (encoder.keyMap) { 
				for (let i = 0; i < length; i++) {
					encode(encoder.encodeKey(keys[i]))
					encode(vals[i])
				}
			} else {
				for (let i = 0; i < length; i++) {
					encode(keys[i])
					encode(vals[i])
				}
			}
		} :
		(object) => {
			target[encode_position++] = 0xb9 // always use map 16, so we can preallocate and set the length afterwards
			let objectOffset = encode_position - start
			encode_position += 2
			let size = 0
			if (encoder.keyMap) {
				for (let key in object) if (typeof object.hasOwnProperty !== 'function' || object.hasOwnProperty(key)) {
					encode(encoder.encodeKey(key))
					encode(object[key])
					size++
				}
			} else { 
				for (let key in object) if (typeof object.hasOwnProperty !== 'function' || object.hasOwnProperty(key)) {
						encode(key)
						encode(object[key])
					size++
				}
			}
			target[objectOffset++ + start] = size >> 8
			target[objectOffset + start] = size & 0xff
		} :
		(object, skipValues) => {
			let nextTransition, transition = structures.transitions || (structures.transitions = Object.create(null))
			let newTransitions = 0
			let length = 0
			let parentRecordId
			let keys
			if (this.keyMap) {
				keys = Object.keys(object).map(k => this.encodeKey(k))
				length = keys.length
				for (let i = 0; i < length; i++) {
					let key = keys[i]
					nextTransition = transition[key]
					if (!nextTransition) {
						nextTransition = transition[key] = Object.create(null)
						newTransitions++
					}
					transition = nextTransition
				}				
			} else {
				for (let key in object) if (typeof object.hasOwnProperty !== 'function' || object.hasOwnProperty(key)) {
					nextTransition = transition[key]
					if (!nextTransition) {
						if (transition[RECORD_SYMBOL] & 0x100000) {// this indicates it is a brancheable/extendable terminal node, so we will use this record id and extend it
							parentRecordId = transition[RECORD_SYMBOL] & 0xffff
						}
						nextTransition = transition[key] = Object.create(null)
						newTransitions++
					}
					transition = nextTransition
					length++
				}
			}
			let recordId = transition[RECORD_SYMBOL]
			if (recordId !== undefined) {
				recordId &= 0xffff
				target[encode_position++] = 0xd9
				target[encode_position++] = (recordId >> 8) | 0xe0
				target[encode_position++] = recordId & 0xff
			} else {
				if (!keys)
					keys = transition.__keys__ || (transition.__keys__ = Object.keys(object))
				if (parentRecordId === undefined) {
					recordId = structures.nextId++
					if (!recordId) {
						recordId = 0
						structures.nextId = 1
					}
					if (recordId >= MAX_STRUCTURES) {// cycle back around
						structures.nextId = (recordId = maxSharedStructures) + 1
					}
				} else {
					recordId = parentRecordId
				}
				structures[recordId] = keys
				if (recordId < maxSharedStructures) {
					target[encode_position++] = 0xd9
					target[encode_position++] = (recordId >> 8) | 0xe0
					target[encode_position++] = recordId & 0xff
					transition = structures.transitions
					for (let i = 0; i < length; i++) {
						if (transition[RECORD_SYMBOL] === undefined || (transition[RECORD_SYMBOL] & 0x100000))
							transition[RECORD_SYMBOL] = recordId
						transition = transition[keys[i]]
					}
					transition[RECORD_SYMBOL] = recordId | 0x100000 // indicates it is a extendable terminal
					hasSharedUpdate = true
				} else {
					transition[RECORD_SYMBOL] = recordId
					targetView.setUint32(encode_position, 0xd9dfff00) // tag two byte, then record definition id
					encode_position += 3
					if (newTransitions)
						transitionsCount += serializationsSinceTransitionRebuild * newTransitions
					// record the removal of the id, we can maintain our shared structure
					if (recordIdsToRemove.length >= MAX_STRUCTURES - maxSharedStructures)
						recordIdsToRemove.shift()[RECORD_SYMBOL] = undefined // we are cycling back through, and have to remove old ones
					recordIdsToRemove.push(transition)
					writeArrayHeader(length + 2)
					encode(0xe000 + recordId)
					encode(keys)
					if (skipValues) return; // special exit for iterator
					for (let key in object)
						if (typeof object.hasOwnProperty !== 'function' || object.hasOwnProperty(key))
							encode(object[key])
					return
				}
			}
			if (length < 0x18) { // write the array header
				target[encode_position++] = 0x80 | length
			} else {
				writeArrayHeader(length)
			}
			if (skipValues) return; // special exit for iterator
			for (let key in object)
				if (typeof object.hasOwnProperty !== 'function' || object.hasOwnProperty(key))
					encode(object[key])
		}
		const makeRoom = (end) => {
			let newSize
			if (end > 0x1000000) {
				// special handling for really large buffers
				if ((end - start) > MAX_BUFFER_SIZE)
					throw new Error('Encoded buffer would be larger than maximum buffer size')
				newSize = Math.min(MAX_BUFFER_SIZE,
					Math.round(Math.max((end - start) * (end > 0x4000000 ? 1.25 : 2), 0x400000) / 0x1000) * 0x1000)
			} else // faster handling for smaller buffers
				newSize = ((Math.max((end - start) << 2, target.length - 1) >> 12) + 1) << 12
			let newBuffer = new ByteArrayAllocate(newSize)
			targetView = new DataView(newBuffer.buffer, 0, newSize)
			if (target.copy)
				target.copy(newBuffer, 0, start, end)
			else
				newBuffer.set(target.slice(start, end))
			encode_position -= start
			start = 0
			safeEnd = newBuffer.length - 10
			return target = newBuffer
		}
		let chunkThreshold = 100;
		let continuedChunkThreshold = 1000;
		this.encodeAsIterable = function(value, options) {
			return startEncoding(value, options, encodeObjectAsIterable);
		}
		this.encodeAsAsyncIterable = function(value, options) {
			return startEncoding(value, options, encodeObjectAsAsyncIterable);
		}

		function* encodeObjectAsIterable(object, iterateProperties, finalIterable) {
			let constructor = object.constructor;
			if (constructor === Object) {
				let useRecords = encoder.useRecords !== false;
				if (useRecords)
					writeObject(object, true); // write the record identifier
				else
					writeEntityLength(Object.keys(object).length, 0xa0);
				for (let key in object) {
					let value = object[key];
					if (!useRecords) encode(key);
					if (value && typeof value === 'object') {
						if (iterateProperties[key])
							yield* encodeObjectAsIterable(value, iterateProperties[key]);
						else
							yield* tryEncode(value, iterateProperties, key);
					} else encode(value);
				}
			} else if (constructor === Array) {
				let length = object.length;
				writeArrayHeader(length);
				for (let i = 0; i < length; i++) {
					let value = object[i];
					if (value && (typeof value === 'object' || encode_position - start > chunkThreshold)) {
						if (iterateProperties.element)
							yield* encodeObjectAsIterable(value, iterateProperties.element);
						else
							yield* tryEncode(value, iterateProperties, 'element');
					} else encode(value);
				}
			} else if (object[Symbol.iterator] && !object.buffer) { // iterator, but exclude typed arrays
				target[encode_position++] = 0x9f; // start indefinite array
				for (let value of object) {
					if (value && (typeof value === 'object' || encode_position - start > chunkThreshold)) {
						if (iterateProperties.element)
							yield* encodeObjectAsIterable(value, iterateProperties.element);
						else
							yield* tryEncode(value, iterateProperties, 'element');
					} else encode(value);
				}
				target[encode_position++] = 0xff; // stop byte
			} else if (isBlob(object)){
				writeEntityLength(object.size, 0x40); // encode as binary data
				yield target.subarray(start, encode_position);
				yield object; // directly return blobs, they have to be encoded asynchronously
				restartEncoding();
			} else if (object[Symbol.asyncIterator]) {
				target[encode_position++] = 0x9f; // start indefinite array
				yield target.subarray(start, encode_position);
				yield object; // directly return async iterators, they have to be encoded asynchronously
				restartEncoding();
				target[encode_position++] = 0xff; // stop byte
			} else {
				encode(object);
			}
			if (finalIterable && encode_position > start) yield target.subarray(start, encode_position);
			else if (encode_position - start > chunkThreshold) {
				yield target.subarray(start, encode_position);
				restartEncoding();
			}
		}
		function* tryEncode(value, iterateProperties, key) {
			let restart = encode_position - start;
			try {
				encode(value);
				if (encode_position - start > chunkThreshold) {
					yield target.subarray(start, encode_position);
					restartEncoding();
				}
			} catch (error) {
				if (error.iteratorNotHandled) {
					iterateProperties[key] = {};
					encode_position = start + restart; // restart our position so we don't have partial data from last encode
					yield* encodeObjectAsIterable.call(this, value, iterateProperties[key]);
				} else throw error;
			}
		}
		function restartEncoding() {
			chunkThreshold = continuedChunkThreshold;
			encoder.encode(null, THROW_ON_ITERABLE); // restart encoding
		}
		function startEncoding(value, options, encodeIterable) {
			if (options && options.chunkThreshold) // explicitly specified chunk sizes
				chunkThreshold = continuedChunkThreshold = options.chunkThreshold;
			else // we start with a smaller threshold to get initial bytes sent quickly
				chunkThreshold = 100;
			if (value && typeof value === 'object') {
				encoder.encode(null, THROW_ON_ITERABLE); // start encoding
				return encodeIterable(value, encoder.iterateProperties || (encoder.iterateProperties = {}), true);
			}
			return [encoder.encode(value)];
		}

		async function* encodeObjectAsAsyncIterable(value, iterateProperties) {
			for (let encodedValue of encodeObjectAsIterable(value, iterateProperties, true)) {
				let constructor = encodedValue.constructor;
				if (constructor === ByteArray || constructor === Uint8Array)
					yield encodedValue;
				else if (isBlob(encodedValue)) {
					let reader = encodedValue.stream().getReader();
					let next;
					while (!(next = await reader.read()).done) {
						yield next.value;
					}
				} else if (encodedValue[Symbol.asyncIterator]) {
					for await (let asyncValue of encodedValue) {
						restartEncoding();
						if (asyncValue)
							yield* encodeObjectAsAsyncIterable(asyncValue, iterateProperties.async || (iterateProperties.async = {}));
						else yield encoder.encode(asyncValue);
					}
				} else {
					yield encodedValue;
				}
			}
		}
	}
	useBuffer(buffer) {
		// this means we are finished using our own buffer and we can write over it safely
		target = buffer
		targetView = new DataView(target.buffer, target.byteOffset, target.byteLength)
		encode_position = 0
	}
	clearSharedData() {
		if (this.structures)
			this.structures = []
		if (this.sharedValues)
			this.sharedValues = undefined
	}
	updateSharedData() {
		let lastVersion = this.sharedVersion || 0
		this.sharedVersion = lastVersion + 1
		let structuresCopy = this.structures.slice(0)
		let sharedData = new SharedData(structuresCopy, this.sharedValues, this.sharedVersion)
		let saveResults = this.saveShared(sharedData,
				existingShared => (existingShared && existingShared.version || 0) == lastVersion)
		if (saveResults === false) {
			// get updated structures and try again if the update failed
			sharedData = this.getShared() || {}
			this.structures = sharedData.structures || []
			this.sharedValues = sharedData.packedValues
			this.sharedVersion = sharedData.version
			this.structures.nextId = this.structures.length
		} else {
			// restore structures
			structuresCopy.forEach((structure, i) => this.structures[i] = structure)
		}
		// saveShared may fail to write and reload, or may have reloaded to check compatibility and overwrite saved data, either way load the correct shared data
		return saveResults
	}
}
function writeEntityLength(length, majorValue) {
	if (length < 0x18)
		target[encode_position++] = majorValue | length
	else if (length < 0x100) {
		target[encode_position++] = majorValue | 0x18
		target[encode_position++] = length
	} else if (length < 0x10000) {
		target[encode_position++] = majorValue | 0x19
		target[encode_position++] = length >> 8
		target[encode_position++] = length & 0xff
	} else {
		target[encode_position++] = majorValue | 0x1a
		targetView.setUint32(encode_position, length)
		encode_position += 4
	}

}
class SharedData {
	constructor(structures, values, version) {
		this.structures = structures
		this.packedValues = values
		this.version = version
	}
}

function writeArrayHeader(length) {
	if (length < 0x18)
		target[encode_position++] = 0x80 | length
	else if (length < 0x100) {
		target[encode_position++] = 0x98
		target[encode_position++] = length
	} else if (length < 0x10000) {
		target[encode_position++] = 0x99
		target[encode_position++] = length >> 8
		target[encode_position++] = length & 0xff
	} else {
		target[encode_position++] = 0x9a
		targetView.setUint32(encode_position, length)
		encode_position += 4
	}
}

const BlobConstructor = typeof Blob === 'undefined' ? function(){} : Blob;
function isBlob(object) {
	if (object instanceof BlobConstructor)
		return true;
	let tag = object[Symbol.toStringTag];
	return tag === 'Blob' || tag === 'File';
}
function findRepetitiveStrings(value, packedValues) {
	switch(typeof value) {
		case 'string':
			if (value.length > 3) {
				if (packedValues.objectMap[value] > -1 || packedValues.values.length >= packedValues.maxValues)
					return
				let packedStatus = packedValues.get(value)
				if (packedStatus) {
					if (++packedStatus.count == 2) {
						packedValues.values.push(value)
					}
				} else {
					packedValues.set(value, {
						count: 1,
					})
					if (packedValues.samplingPackedValues) {
						let status = packedValues.samplingPackedValues.get(value)
						if (status)
							status.count++
						else
							packedValues.samplingPackedValues.set(value, {
								count: 1,
							})
					}
				}
			}
			break
		case 'object':
			if (value) {
				if (value instanceof Array) {
					for (let i = 0, l = value.length; i < l; i++) {
						findRepetitiveStrings(value[i], packedValues)
					}

				} else {
					let includeKeys = !packedValues.encoder.useRecords
					for (var key in value) {
						if (value.hasOwnProperty(key)) {
							if (includeKeys)
								findRepetitiveStrings(key, packedValues)
							findRepetitiveStrings(value[key], packedValues)
						}
					}
				}
			}
			break
		case 'function': console.log(value)
	}
}
const encode_isLittleEndianMachine = new Uint8Array(new Uint16Array([1]).buffer)[0] == 1
extensionClasses = [ Date, Set, Error, RegExp, Tag, ArrayBuffer,
	Uint8Array, Uint8ClampedArray, Uint16Array, Uint32Array,
	typeof BigUint64Array == 'undefined' ? function() {} : BigUint64Array, Int8Array, Int16Array, Int32Array,
	typeof BigInt64Array == 'undefined' ? function() {} : BigInt64Array,
	Float32Array, Float64Array, SharedData ]

//Object.getPrototypeOf(Uint8Array.prototype).constructor /*TypedArray*/
extensions = [{ // Date
	tag: 1,
	encode(date, encode) {
		let seconds = date.getTime() / 1000
		if ((this.useTimestamp32 || date.getMilliseconds() === 0) && seconds >= 0 && seconds < 0x100000000) {
			// Timestamp 32
			target[encode_position++] = 0x1a
			targetView.setUint32(encode_position, seconds)
			encode_position += 4
		} else {
			// Timestamp float64
			target[encode_position++] = 0xfb
			targetView.setFloat64(encode_position, seconds)
			encode_position += 8
		}
	}
}, { // Set
	tag: 258, // https://github.com/input-output-hk/cbor-sets-spec/blob/master/CBOR_SETS.md
	encode(set, encode) {
		let array = Array.from(set)
		encode(array)
	}
}, { // Error
	tag: 27, // http://cbor.schmorp.de/generic-object
	encode(error, encode) {
		encode([ error.name, error.message ])
	}
}, { // RegExp
	tag: 27, // http://cbor.schmorp.de/generic-object
	encode(regex, encode) {
		encode([ 'RegExp', regex.source, regex.flags ])
	}
}, { // Tag
	getTag(tag) {
		return tag.tag
	},
	encode(tag, encode) {
		encode(tag.value)
	}
}, { // ArrayBuffer
	encode(arrayBuffer, encode, makeRoom) {
		writeBuffer(arrayBuffer, makeRoom)
	}
}, { // Uint8Array
	getTag(typedArray) {
		if (typedArray.constructor === Uint8Array) {
			if (this.tagUint8Array || hasNodeBuffer && this.tagUint8Array !== false)
				return 64;
		} // else no tag
	},
	encode(typedArray, encode, makeRoom) {
		writeBuffer(typedArray, makeRoom)
	}
},
	typedArrayEncoder(68, 1),
	typedArrayEncoder(69, 2),
	typedArrayEncoder(70, 4),
	typedArrayEncoder(71, 8),
	typedArrayEncoder(72, 1),
	typedArrayEncoder(77, 2),
	typedArrayEncoder(78, 4),
	typedArrayEncoder(79, 8),
	typedArrayEncoder(85, 4),
	typedArrayEncoder(86, 8),
{
	encode(sharedData, encode) { // write SharedData
		let packedValues = sharedData.packedValues || []
		let sharedStructures = sharedData.structures || []
		if (packedValues.values.length > 0) {
			target[encode_position++] = 0xd8 // one-byte tag
			target[encode_position++] = 51 // tag 51 for packed shared structures https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
			writeArrayHeader(4)
			let valuesArray = packedValues.values
			encode(valuesArray)
			writeArrayHeader(0) // prefixes
			writeArrayHeader(0) // suffixes
			packedObjectMap = Object.create(sharedPackedObjectMap || null)
			for (let i = 0, l = valuesArray.length; i < l; i++) {
				packedObjectMap[valuesArray[i]] = i
			}
		}
		if (sharedStructures) {
			targetView.setUint32(encode_position, 0xd9dffe00)
			encode_position += 3
			let definitions = sharedStructures.slice(0)
			definitions.unshift(0xe000)
			definitions.push(new Tag(sharedData.version, 0x53687264))
			encode(definitions)
		} else
			encode(new Tag(sharedData.version, 0x53687264))
		}
	}]
function typedArrayEncoder(tag, size) {
	if (!encode_isLittleEndianMachine && size > 1)
		tag -= 4 // the big endian equivalents are 4 less
	return {
		tag: tag,
		encode: function writeExtBuffer(typedArray, encode) {
			let length = typedArray.byteLength
			let offset = typedArray.byteOffset || 0
			let buffer = typedArray.buffer || typedArray
			encode(hasNodeBuffer ? encode_Buffer.from(buffer, offset, length) :
				new Uint8Array(buffer, offset, length))
		}
	}
}
function writeBuffer(buffer, makeRoom) {
	let length = buffer.byteLength
	if (length < 0x18) {
		target[encode_position++] = 0x40 + length
	} else if (length < 0x100) {
		target[encode_position++] = 0x58
		target[encode_position++] = length
	} else if (length < 0x10000) {
		target[encode_position++] = 0x59
		target[encode_position++] = length >> 8
		target[encode_position++] = length & 0xff
	} else {
		target[encode_position++] = 0x5a
		targetView.setUint32(encode_position, length)
		encode_position += 4
	}
	if (encode_position + length >= target.length) {
		makeRoom(encode_position + length)
	}
	// if it is already a typed array (has an ArrayBuffer), use that, but if it is an ArrayBuffer itself,
	// must wrap it to set it.
	target.set(buffer.buffer ? buffer : new Uint8Array(buffer), encode_position)
	encode_position += length
}

function insertIds(serialized, idsToInsert) {
	// insert the ids that need to be referenced for structured clones
	let nextId
	let distanceToMove = idsToInsert.length * 2
	let lastEnd = serialized.length - distanceToMove
	idsToInsert.sort((a, b) => a.offset > b.offset ? 1 : -1)
	for (let id = 0; id < idsToInsert.length; id++) {
		let referee = idsToInsert[id]
		referee.id = id
		for (let position of referee.references) {
			serialized[position++] = id >> 8
			serialized[position] = id & 0xff
		}
	}
	while (nextId = idsToInsert.pop()) {
		let offset = nextId.offset
		serialized.copyWithin(offset + distanceToMove, offset, lastEnd)
		distanceToMove -= 2
		let position = offset + distanceToMove
		serialized[position++] = 0xd8
		serialized[position++] = 28 // http://cbor.schmorp.de/value-sharing
		lastEnd = offset
	}
	return serialized
}
function writeBundles(start, encode) {
	targetView.setUint32(encode_bundledStrings.position + start, encode_position - encode_bundledStrings.position - start + 1) // the offset to bundle
	let writeStrings = encode_bundledStrings
	encode_bundledStrings = null
	encode(writeStrings[0])
	encode(writeStrings[1])
}

function encode_addExtension(extension) {
	if (extension.Class) {
		if (!extension.encode)
			throw new Error('Extension has no encode function')
		extensionClasses.unshift(extension.Class)
		extensions.unshift(extension)
	}
	decodeAddExtension(extension)
}
let defaultEncoder = new encode_Encoder({ useRecords: false })
const encode = defaultEncoder.encode
const encodeAsIterable = defaultEncoder.encodeAsIterable
const encodeAsAsyncIterable = defaultEncoder.encodeAsAsyncIterable

;
const { NEVER, ALWAYS, DECIMAL_ROUND, DECIMAL_FIT } = FLOAT32_OPTIONS
const REUSE_BUFFER_MODE = 512
const RESET_BUFFER_MODE = 1024
const THROW_ON_ITERABLE = 2048



;// CONCATENATED MODULE: ./node_modules/cbor-x/iterators.js
/* provided dependency */ var iterators_Buffer = __webpack_require__(48764)["Buffer"];



/**
 * Given an Iterable first argument, returns an Iterable where each value is encoded as a Buffer
 * If the argument is only Async Iterable, the return value will be an Async Iterable.
 * @param {Iterable|Iterator|AsyncIterable|AsyncIterator} objectIterator - iterable source, like a Readable object stream, an array, Set, or custom object
 * @param {options} [options] - cbor-x Encoder options
 * @returns {IterableIterator|Promise.<AsyncIterableIterator>}
 */
function encodeIter (objectIterator, options = {}) {
  if (!objectIterator || typeof objectIterator !== 'object') {
    throw new Error('first argument must be an Iterable, Async Iterable, or a Promise for an Async Iterable')
  } else if (typeof objectIterator[Symbol.iterator] === 'function') {
    return encodeIterSync(objectIterator, options)
  } else if (typeof objectIterator.then === 'function' || typeof objectIterator[Symbol.asyncIterator] === 'function') {
    return encodeIterAsync(objectIterator, options)
  } else {
    throw new Error('first argument must be an Iterable, Async Iterable, Iterator, Async Iterator, or a Promise')
  }
}

function * encodeIterSync (objectIterator, options) {
  const encoder = new Encoder(options)
  for (const value of objectIterator) {
    yield encoder.encode(value)
  }
}

async function * encodeIterAsync (objectIterator, options) {
  const encoder = new Encoder(options)
  for await (const value of objectIterator) {
    yield encoder.encode(value)
  }
}

/**
 * Given an Iterable/Iterator input which yields buffers, returns an IterableIterator which yields sync decoded objects
 * Or, given an Async Iterable/Iterator which yields promises resolving in buffers, returns an AsyncIterableIterator.
 * @param {Iterable|Iterator|AsyncIterable|AsyncIterableIterator} bufferIterator
 * @param {object} [options] - Decoder options
 * @returns {IterableIterator|Promise.<AsyncIterableIterator}
 */
function decodeIter (bufferIterator, options = {}) {
  if (!bufferIterator || typeof bufferIterator !== 'object') {
    throw new Error('first argument must be an Iterable, Async Iterable, Iterator, Async Iterator, or a promise')
  }

  const decoder = new Decoder(options)
  let incomplete
  const parser = (chunk) => {
    let yields
    // if there's incomplete data from previous chunk, concatinate and try again
    if (incomplete) {
      chunk = iterators_Buffer.concat([incomplete, chunk])
      incomplete = undefined
    }

    try {
      yields = decoder.decodeMultiple(chunk)
    } catch (err) {
      if (err.incomplete) {
        incomplete = chunk.slice(err.lastPosition)
        yields = err.values
      } else {
        throw err
      }
    }
    return yields
  }

  if (typeof bufferIterator[Symbol.iterator] === 'function') {
    return (function * iter () {
      for (const value of bufferIterator) {
        yield * parser(value)
      }
    })()
  } else if (typeof bufferIterator[Symbol.asyncIterator] === 'function') {
    return (async function * iter () {
      for await (const value of bufferIterator) {
        yield * parser(value)
      }
    })()
  }
}

;// CONCATENATED MODULE: ./node_modules/cbor-x/index.js





/***/ }),

/***/ 37901:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TK": function() { return /* binding */ allocate; },
  "R3": function() { return /* binding */ Array_append; },
  "oq": function() { return /* binding */ Array_appendAll; },
  "r3": function() { return /* binding */ Array_contains; },
  "hr": function() { return /* binding */ Array_containsWith; },
  "JG": function() { return /* binding */ copy; },
  "D8": function() { return /* binding */ dedupe; },
  "F2": function() { return /* binding */ differenceWith; },
  "Cw": function() { return /* binding */ Array_drop; },
  "cS": function() { return /* binding */ Array_empty; },
  "zx": function() { return /* binding */ ensure; },
  "DZ": function() { return /* binding */ Array_filterMap; },
  "Ew": function() { return /* binding */ Array_findFirst; },
  "ln": function() { return /* binding */ findFirstIndex; },
  "dF": function() { return /* binding */ Array_findLast; },
  "qr": function() { return /* binding */ findLastIndex; },
  "VS": function() { return /* binding */ Array_flatMap; },
  "xH": function() { return /* binding */ Array_flatten; },
  "EE": function() { return /* binding */ fromIterable; },
  "c5": function() { return /* binding */ getEquivalence; },
  "Mg": function() { return /* binding */ Array_getSomes; },
  "YM": function() { return /* binding */ Array_head; },
  "dK": function() { return /* binding */ headNonEmpty; },
  "kJ": function() { return /* binding */ isArray; },
  "yD": function() { return /* binding */ isEmptyArray; },
  "Of": function() { return /* binding */ Array_isNonEmptyArray; },
  "Ux": function() { return /* binding */ isNonEmptyReadonlyArray; },
  "v_": function() { return /* binding */ join; },
  "Z$": function() { return /* binding */ last; },
  "w4": function() { return /* binding */ lastNonEmpty; },
  "KB": function() { return /* binding */ Array_makeBy; },
  "UI": function() { return /* binding */ Array_map; },
  "aL": function() { return /* binding */ matchLeft; },
  "of": function() { return /* binding */ Array_of; },
  "tV": function() { return /* binding */ partitionMap; },
  "Ce": function() { return /* binding */ Array_prepend; },
  "u4": function() { return /* binding */ Array_reduce; },
  "nq": function() { return /* binding */ reduceRight; },
  "GY": function() { return /* binding */ reverse; },
  "wx": function() { return /* binding */ sort; },
  "yP": function() { return /* binding */ span; },
  "fm": function() { return /* binding */ tailNonEmpty; },
  "JJ": function() { return /* binding */ Array_unfold; },
  "G0": function() { return /* binding */ union; },
  "MH": function() { return /* binding */ unsafeGet; },
  "$R": function() { return /* binding */ Array_zip; }
});

// UNUSED EXPORTS: Do, bind, bindTo, cartesian, cartesianWith, chop, chunksOf, dedupeAdjacent, dedupeAdjacentWith, dedupeWith, difference, dropRight, dropWhile, every, extend, filter, filterMapWhile, flatMapNullable, forEach, fromNullable, fromOption, fromRecord, get, getLefts, getOrder, getRights, group, groupBy, groupWith, init, initNonEmpty, insertAt, intersection, intersectionWith, intersperse, isEmptyReadonlyArray, length, let, liftEither, liftNullable, liftOption, liftPredicate, make, mapAccum, match, matchRight, max, min, modify, modifyNonEmptyHead, modifyNonEmptyLast, modifyOption, pad, partition, prependAll, range, remove, replace, replaceOption, replicate, rotate, scan, scanRight, separate, setNonEmptyHead, setNonEmptyLast, some, sortBy, sortWith, split, splitAt, splitNonEmptyAt, splitWhere, tail, take, takeRight, takeWhile, unappend, unionWith, unprepend, unzip, window, zipWith

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Either.js
var esm_Either = __webpack_require__(87585);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equal.js
var esm_Equal = __webpack_require__(67492);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equivalence.js
var Equivalence = __webpack_require__(27786);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/array.js
/**
 * @since 2.0.0
 */
/** @internal */
const isNonEmptyArray = self => self.length > 0;
//# sourceMappingURL=array.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var esm_Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var Predicate = __webpack_require__(71335);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/Iterable.js
/**
 * This module provides utility functions for working with Iterables in TypeScript.
 *
 * @since 2.0.0
 */






/**
 * Return a `Iterable` with element `i` initialized with `f(i)`.
 *
 * If the `length` is not specified, the `Iterable` will be infinite.
 *
 * **Note**. `length` is normalized to an integer >= 1.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { makeBy } from "effect/Iterable"
 *
 * assert.deepStrictEqual(Array.from(makeBy(n => n * 2, { length: 5 })), [0, 2, 4, 6, 8])
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const makeBy = (f, options) => {
  const max = options?.length !== undefined ? Math.max(1, Math.floor(options.length)) : Infinity;
  return {
    [Symbol.iterator]() {
      let i = 0;
      return {
        next() {
          if (i < max) {
            return {
              value: f(i++),
              done: false
            };
          }
          return {
            done: true,
            value: undefined
          };
        }
      };
    }
  };
};
/**
 * Return a `Iterable` containing a range of integers, including both endpoints.
 *
 * If `end` is omitted, the range will not have an upper bound.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { range } from "effect/Iterable"
 *
 * assert.deepStrictEqual(Array.from(range(1, 3)), [1, 2, 3])
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const range = (start, end) => {
  if (end === undefined) {
    return makeBy(i => start + i);
  }
  return makeBy(i => start + i, {
    length: start <= end ? end - start + 1 : 1
  });
};
/**
 * Return a `Iterable` containing a value repeated the specified number of times.
 *
 * **Note**. `n` is normalized to an integer >= 1.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { replicate } from "effect/Iterable"
 *
 * assert.deepStrictEqual(Array.from(replicate("a", 3)), ["a", "a", "a"])
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const replicate = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (a, n) => makeBy(() => a, {
  length: n
}))));
/**
 * Takes a record and returns an Iterable of tuples containing its keys and values.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { fromRecord } from "effect/Iterable"
 *
 * const x = { a: 1, b: 2, c: 3 }
 * assert.deepStrictEqual(Array.from(fromRecord(x)), [["a", 1], ["b", 2], ["c", 3]])
 * ```
 *
 * @category conversions
 * @since 2.0.0
 */
const fromRecord = self => ({
  *[Symbol.iterator]() {
    for (const key in self) {
      if (Object.prototype.hasOwnProperty.call(self, key)) {
        yield [key, self[key]];
      }
    }
  }
});
/**
 * Prepend an element to the front of an `Iterable`, creating a new `Iterable`.
 *
 * @category concatenating
 * @since 2.0.0
 */
const prepend = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, head) => prependAll(self, [head]))));
/**
 * Prepends the specified prefix iterable to the beginning of the specified iterable.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Iterable } from "effect"
 *
 * assert.deepStrictEqual(
 *   Array.from(Iterable.prependAll([1, 2], ["a", "b"])),
 *   ["a", "b", 1, 2]
 * )
 * ```
 *
 * @category concatenating
 * @since 2.0.0
 */
const prependAll = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => appendAll(that, self))));
/**
 * Append an element to the end of an `Iterable`, creating a new `Iterable`.
 *
 * @category concatenating
 * @since 2.0.0
 */
const append = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, last) => appendAll(self, [last]))));
/**
 * Concatenates two iterables, combining their elements.
 *
 * @category concatenating
 * @since 2.0.0
 */
const appendAll = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => ({
  [Symbol.iterator]() {
    const iterA = self[Symbol.iterator]();
    let doneA = false;
    let iterB;
    return {
      next() {
        if (!doneA) {
          const r = iterA.next();
          if (r.done) {
            doneA = true;
            iterB = that[Symbol.iterator]();
            return iterB.next();
          }
          return r;
        }
        return iterB.next();
      }
    };
  }
}))));
/**
 * Reduce an `Iterable` from the left, keeping all intermediate results instead of only the final result.
 *
 * @category folding
 * @since 2.0.0
 */
const scan = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, b, f) => ({
  [Symbol.iterator]() {
    let acc = b;
    let iterator;
    function next() {
      if (iterator === undefined) {
        iterator = self[Symbol.iterator]();
        return {
          done: false,
          value: acc
        };
      }
      const result = iterator.next();
      if (result.done) {
        return result;
      }
      acc = f(acc, result.value);
      return {
        done: false,
        value: acc
      };
    }
    return {
      next
    };
  }
}))));
/**
 * Determine if an `Iterable` is empty
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isEmpty } from "effect/Iterable"
 *
 * assert.deepStrictEqual(isEmpty([]), true);
 * assert.deepStrictEqual(isEmpty([1, 2, 3]), false);
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isEmpty = self => {
  const iterator = self[Symbol.iterator]();
  return iterator.next().done === true;
};
/**
 * Return the number of elements in a `Iterable`.
 *
 * @category getters
 * @since 2.0.0
 */
const size = self => {
  const iterator = self[Symbol.iterator]();
  let count = 0;
  while (!iterator.next().done) {
    count++;
  }
  return count;
};
/**
 * Get the first element of a `Iterable`, or `None` if the `Iterable` is empty.
 *
 * @category getters
 * @since 2.0.0
 */
const head = self => {
  const iterator = self[Symbol.iterator]();
  const result = iterator.next();
  return result.done ? O.none() : O.some(result.value);
};
/**
 * Get the first element of a `Iterable`, or throw an error if the `Iterable` is empty.
 *
 * @category getters
 * @since 3.3.0
 */
const unsafeHead = self => {
  const iterator = self[Symbol.iterator]();
  const result = iterator.next();
  if (result.done) throw new Error("unsafeHead: empty iterable");
  return result.value;
};
/**
 * Keep only a max number of elements from the start of an `Iterable`, creating a new `Iterable`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @category getters
 * @since 2.0.0
 */
const take = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => ({
  [Symbol.iterator]() {
    let i = 0;
    const iterator = self[Symbol.iterator]();
    return {
      next() {
        if (i < n) {
          i++;
          return iterator.next();
        }
        return {
          done: true,
          value: undefined
        };
      }
    };
  }
}))));
/**
 * Calculate the longest initial Iterable for which all element satisfy the specified predicate, creating a new `Iterable`.
 *
 * @category getters
 * @since 2.0.0
 */
const takeWhile = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => ({
  [Symbol.iterator]() {
    const iterator = self[Symbol.iterator]();
    let i = 0;
    return {
      next() {
        const result = iterator.next();
        if (result.done || !predicate(result.value, i++)) {
          return {
            done: true,
            value: undefined
          };
        }
        return result;
      }
    };
  }
}))));
/**
 * Drop a max number of elements from the start of an `Iterable`
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * @category getters
 * @since 2.0.0
 */
const drop = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => ({
  [Symbol.iterator]() {
    const iterator = self[Symbol.iterator]();
    let i = 0;
    return {
      next() {
        while (i < n) {
          const result = iterator.next();
          if (result.done) {
            return {
              done: true,
              value: undefined
            };
          }
          i++;
        }
        return iterator.next();
      }
    };
  }
}))));
/**
 * Returns the first element that satisfies the specified
 * predicate, or `None` if no such element exists.
 *
 * @category elements
 * @since 2.0.0
 */
const findFirst = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  let i = 0;
  for (const a of self) {
    const o = f(a, i);
    if ((0,Predicate/* isBoolean */.jn)(o)) {
      if (o) {
        return esm_Option/* some */.G(a);
      }
    } else {
      if (esm_Option/* isSome */.pC(o)) {
        return o;
      }
    }
    i++;
  }
  return esm_Option/* none */.YP();
});
/**
 * Find the last element for which a predicate holds.
 *
 * @category elements
 * @since 2.0.0
 */
const findLast = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  let i = 0;
  let last = O.none();
  for (const a of self) {
    const o = f(a, i);
    if (isBoolean(o)) {
      if (o) {
        last = O.some(a);
      }
    } else {
      if (O.isSome(o)) {
        last = o;
      }
    }
    i++;
  }
  return last;
})));
/**
 * Takes two `Iterable`s and returns an `Iterable` of corresponding pairs.
 *
 * @category zipping
 * @since 2.0.0
 */
const zip = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => zipWith(self, that, Tuple.make))));
/**
 * Apply a function to pairs of elements at the same index in two `Iterable`s, collecting the results. If one
 * input `Iterable` is short, excess elements of the longer `Iterable` are discarded.
 *
 * @category zipping
 * @since 2.0.0
 */
const zipWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, that, f) => ({
  [Symbol.iterator]() {
    const selfIterator = self[Symbol.iterator]();
    const thatIterator = that[Symbol.iterator]();
    return {
      next() {
        const selfResult = selfIterator.next();
        const thatResult = thatIterator.next();
        if (selfResult.done || thatResult.done) {
          return {
            done: true,
            value: undefined
          };
        }
        return {
          done: false,
          value: f(selfResult.value, thatResult.value)
        };
      }
    };
  }
}))));
/**
 * Places an element in between members of an `Iterable`.
 * If the input is a non-empty array, the result is also a non-empty array.
 *
 * @since 2.0.0
 */
const intersperse = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, middle) => ({
  [Symbol.iterator]() {
    const iterator = self[Symbol.iterator]();
    let next = iterator.next();
    let emitted = false;
    return {
      next() {
        if (next.done) {
          return next;
        } else if (emitted) {
          emitted = false;
          return {
            done: false,
            value: middle
          };
        }
        emitted = true;
        const result = next;
        next = iterator.next();
        return result;
      }
    };
  }
}))));
/**
 * Returns a function that checks if an `Iterable` contains a given value using a provided `isEquivalent` function.
 *
 * @category elements
 * @since 2.0.0
 */
const containsWith = isEquivalent => dual(2, (self, a) => {
  for (const i of self) {
    if (isEquivalent(a, i)) {
      return true;
    }
  }
  return false;
});
const _equivalence = /*#__PURE__*/(/* unused pure expression or super */ null && (Equal.equivalence()));
/**
 * Returns a function that checks if a `Iterable` contains a given value using the default `Equivalence`.
 *
 * @category elements
 * @since 2.0.0
 */
const contains = /*#__PURE__*/(/* unused pure expression or super */ null && (containsWith(_equivalence)));
/**
 * Splits an `Iterable` into length-`n` pieces. The last piece will be shorter if `n` does not evenly divide the length of
 * the `Iterable`.
 *
 * @category splitting
 * @since 2.0.0
 */
const chunksOf = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => {
  const safeN = Math.max(1, Math.floor(n));
  return {
    [Symbol.iterator]() {
      let iterator = self[Symbol.iterator]();
      return {
        next() {
          if (iterator === undefined) {
            return {
              done: true,
              value: undefined
            };
          }
          const chunk = [];
          for (let i = 0; i < safeN; i++) {
            const result = iterator.next();
            if (result.done) {
              iterator = undefined;
              return chunk.length === 0 ? {
                done: true,
                value: undefined
              } : {
                done: false,
                value: chunk
              };
            }
            chunk.push(result.value);
          }
          return {
            done: false,
            value: chunk
          };
        }
      };
    }
  };
})));
/**
 * Group equal, consecutive elements of an `Iterable` into `NonEmptyArray`s using the provided `isEquivalent` function.
 *
 * @category grouping
 * @since 2.0.0
 */
const groupWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, isEquivalent) => ({
  [Symbol.iterator]() {
    const iterator = self[Symbol.iterator]();
    let nextResult;
    return {
      next() {
        let result;
        if (nextResult !== undefined) {
          if (nextResult.done) {
            return {
              done: true,
              value: undefined
            };
          }
          result = nextResult;
          nextResult = undefined;
        } else {
          result = iterator.next();
          if (result.done) {
            return {
              done: true,
              value: undefined
            };
          }
        }
        const chunk = [result.value];
        while (true) {
          const next = iterator.next();
          if (next.done || !isEquivalent(result.value, next.value)) {
            nextResult = next;
            return {
              done: false,
              value: chunk
            };
          }
          chunk.push(next.value);
        }
      }
    };
  }
}))));
/**
 * Group equal, consecutive elements of an `Iterable` into `NonEmptyArray`s.
 *
 * @category grouping
 * @since 2.0.0
 */
const group = /*#__PURE__*/(/* unused pure expression or super */ null && (groupWith( /*#__PURE__*/Equal.equivalence())));
/**
 * Splits an `Iterable` into sub-non-empty-arrays stored in an object, based on the result of calling a `string`-returning
 * function on each element, and grouping the results according to values returned
 *
 * @category grouping
 * @since 2.0.0
 */
const groupBy = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  const out = {};
  for (const a of self) {
    const k = f(a);
    if (Object.prototype.hasOwnProperty.call(out, k)) {
      out[k].push(a);
    } else {
      out[k] = [a];
    }
  }
  return out;
})));
const constEmpty = {
  [Symbol.iterator]() {
    return constEmptyIterator;
  }
};
const constEmptyIterator = {
  next() {
    return {
      done: true,
      value: undefined
    };
  }
};
/**
 * @category constructors
 * @since 2.0.0
 */
const empty = () => constEmpty;
/**
 * Constructs a new `Iterable<A>` from the specified value.
 *
 * @category constructors
 * @since 2.0.0
 */
const of = a => [a];
/**
 * @category mapping
 * @since 2.0.0
 */
const map = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => ({
  [Symbol.iterator]() {
    const iterator = self[Symbol.iterator]();
    let i = 0;
    return {
      next() {
        const result = iterator.next();
        if (result.done) {
          return {
            done: true,
            value: undefined
          };
        }
        return {
          done: false,
          value: f(result.value, i++)
        };
      }
    };
  }
}))));
/**
 * Applies a function to each element in an Iterable and returns a new Iterable containing the concatenated mapped elements.
 *
 * @category sequencing
 * @since 2.0.0
 */
const flatMap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => flatten(map(self, f)))));
/**
 * Flattens an Iterable of Iterables into a single Iterable
 *
 * @category sequencing
 * @since 2.0.0
 */
const flatten = self => ({
  [Symbol.iterator]() {
    const outerIterator = self[Symbol.iterator]();
    let innerIterator;
    function next() {
      if (innerIterator === undefined) {
        const next = outerIterator.next();
        if (next.done) {
          return next;
        }
        innerIterator = next.value[Symbol.iterator]();
      }
      const result = innerIterator.next();
      if (result.done) {
        innerIterator = undefined;
        return next();
      }
      return result;
    }
    return {
      next
    };
  }
});
/**
 * @category filtering
 * @since 2.0.0
 */
const filterMap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => ({
  [Symbol.iterator]() {
    const iterator = self[Symbol.iterator]();
    let i = 0;
    return {
      next() {
        let result = iterator.next();
        while (!result.done) {
          const b = f(result.value, i++);
          if (O.isSome(b)) {
            return {
              done: false,
              value: b.value
            };
          }
          result = iterator.next();
        }
        return {
          done: true,
          value: undefined
        };
      }
    };
  }
}))));
/**
 * Transforms all elements of the `Iterable` for as long as the specified function returns some value
 *
 * @category filtering
 * @since 2.0.0
 */
const filterMapWhile = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => ({
  [Symbol.iterator]() {
    const iterator = self[Symbol.iterator]();
    let i = 0;
    return {
      next() {
        const result = iterator.next();
        if (result.done) {
          return {
            done: true,
            value: undefined
          };
        }
        const b = f(result.value, i++);
        if (O.isSome(b)) {
          return {
            done: false,
            value: b.value
          };
        }
        return {
          done: true,
          value: undefined
        };
      }
    };
  }
}))));
/**
 * Retrieves the `Some` values from an `Iterable` of `Option`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Iterable, Option } from "effect"
 *
 * assert.deepStrictEqual(
 *   Array.from(Iterable.getSomes([Option.some(1), Option.none(), Option.some(2)])),
 *   [1, 2]
 * )
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const getSomes = /*#__PURE__*/(/* unused pure expression or super */ null && (filterMap(identity)));
/**
 * Retrieves the `Left` values from an `Iterable` of `Either`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Iterable, Either } from "effect"
 *
 * assert.deepStrictEqual(
 *   Array.from(Iterable.getLefts([Either.right(1), Either.left("err"), Either.right(2)])),
 *   ["err"]
 * )
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const getLefts = self => filterMap(self, E.getLeft);
/**
 * Retrieves the `Right` values from an `Iterable` of `Either`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Iterable, Either } from "effect"
 *
 * assert.deepStrictEqual(
 *   Array.from(Iterable.getRights([Either.right(1), Either.left("err"), Either.right(2)])),
 *   [1, 2]
 * )
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const getRights = self => filterMap(self, E.getRight);
/**
 * @category filtering
 * @since 2.0.0
 */
const filter = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => ({
  [Symbol.iterator]() {
    const iterator = self[Symbol.iterator]();
    let i = 0;
    return {
      next() {
        let result = iterator.next();
        while (!result.done) {
          if (predicate(result.value, i++)) {
            return {
              done: false,
              value: result.value
            };
          }
          result = iterator.next();
        }
        return {
          done: true,
          value: undefined
        };
      }
    };
  }
}))));
/**
 * @category sequencing
 * @since 2.0.0
 */
const flatMapNullable = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => filterMap(self, a => {
  const b = f(a);
  return b == null ? O.none() : O.some(b);
}))));
/**
 * Check if a predicate holds true for some `Iterable` element.
 *
 * @category elements
 * @since 2.0.0
 */
const some = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => {
  let i = 0;
  for (const a of self) {
    if (predicate(a, i++)) {
      return true;
    }
  }
  return false;
})));
/**
 * @category constructors
 * @since 2.0.0
 */
const unfold = (b, f) => ({
  [Symbol.iterator]() {
    let next = b;
    return {
      next() {
        const o = f(next);
        if (O.isNone(o)) {
          return {
            done: true,
            value: undefined
          };
        }
        const [a, b] = o.value;
        next = b;
        return {
          done: false,
          value: a
        };
      }
    };
  }
});
/**
 * Iterate over the `Iterable` applying `f`.
 *
 * @since 2.0.0
 */
const forEach = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  let i = 0;
  for (const a of self) {
    f(a, i++);
  }
})));
/**
 * @category folding
 * @since 2.0.0
 */
const reduce = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, b, f) => {
  if (Array.isArray(self)) {
    return self.reduce(f, b);
  }
  let i = 0;
  let result = b;
  for (const n of self) {
    result = f(result, n, i++);
  }
  return result;
})));
/**
 * Deduplicates adjacent elements that are identical using the provided `isEquivalent` function.
 *
 * @since 2.0.0
 */
const dedupeAdjacentWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, isEquivalent) => ({
  [Symbol.iterator]() {
    const iterator = self[Symbol.iterator]();
    let first = true;
    let last;
    function next() {
      const result = iterator.next();
      if (result.done) {
        return {
          done: true,
          value: undefined
        };
      }
      if (first) {
        first = false;
        last = result.value;
        return result;
      }
      const current = result.value;
      if (isEquivalent(last, current)) {
        return next();
      }
      last = current;
      return result;
    }
    return {
      next
    };
  }
}))));
/**
 * Deduplicates adjacent elements that are identical.
 *
 * @since 2.0.0
 */
const dedupeAdjacent = /*#__PURE__*/(/* unused pure expression or super */ null && (dedupeAdjacentWith( /*#__PURE__*/Equal.equivalence())));
/**
 * Zips this Iterable crosswise with the specified Iterable using the specified combiner.
 *
 * @since 2.0.0
 * @category elements
 */
const cartesianWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, that, f) => flatMap(self, a => map(that, b => f(a, b))))));
/**
 * Zips this Iterable crosswise with the specified Iterable.
 *
 * @since 2.0.0
 * @category elements
 */
const cartesian = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => cartesianWith(self, that, (a, b) => [a, b]))));
//# sourceMappingURL=Iterable.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Order.js
var esm_Order = __webpack_require__(51988);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Record.js
var Record = __webpack_require__(53959);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Tuple.js
var esm_Tuple = __webpack_require__(10800);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/Array.js
/**
 * This module provides utility functions for working with arrays in TypeScript.
 *
 * @since 2.0.0
 */












/**
 * Builds a `NonEmptyArray` from an non-empty collection of elements.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.make(1, 2, 3)
 * console.log(result) // [1, 2, 3]
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const make = (...elements) => elements;
/**
 * Creates a new `Array` of the specified length.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.allocate<number>(3)
 * console.log(result) // [ <3 empty items> ]
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const allocate = n => new Array(n);
/**
 * Return a `NonEmptyArray` of length `n` with element `i` initialized with `f(i)`.
 *
 * **Note**. `n` is normalized to an integer >= 1.
 *
 * **Example**
 *
 * ```ts
 * import { makeBy } from "effect/Array"
 *
 * const result = makeBy(5, n => n * 2)
 * console.log(result) // [0, 2, 4, 6, 8]
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const Array_makeBy = /*#__PURE__*/(0,Function/* dual */.OB)(2, (n, f) => {
  const max = Math.max(1, Math.floor(n));
  const out = new Array(max);
  for (let i = 0; i < max; i++) {
    out[i] = f(i);
  }
  return out;
});
/**
 * Return a `NonEmptyArray` containing a range of integers, including both endpoints.
 *
 * **Example**
 *
 * ```ts
 * import { range } from "effect/Array"
 *
 * const result = range(1, 3)
 * console.log(result) // [1, 2, 3]
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const Array_range = (start, end) => start <= end ? Array_makeBy(end - start + 1, i => start + i) : [start];
/**
 * Return a `NonEmptyArray` containing a value repeated the specified number of times.
 *
 * **Note**. `n` is normalized to an integer >= 1.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.replicate("a", 3)
 * console.log(result) // ["a", "a", "a"]
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const Array_replicate = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (a, n) => Array_makeBy(n, () => a))));
/**
 * Creates a new `Array` from an iterable collection of values.
 * If the input is already an array, it returns the input as-is.
 * Otherwise, it converts the iterable collection to an array.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.fromIterable(new Set([1, 2, 3]))
 * console.log(result) // [1, 2, 3]
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const fromIterable = collection => Array.isArray(collection) ? collection : Array.from(collection);
/**
 * Creates a new `Array` from a value that might not be an iterable.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * console.log(Array.ensure("a")) // ["a"]
 * console.log(Array.ensure(["a"])) // ["a"]
 * console.log(Array.ensure(["a", "b", "c"])) // ["a", "b", "c"]
 * ```
 *
 * @category constructors
 * @since 3.3.0
 */
const ensure = self => Array.isArray(self) ? self : [self];
/**
 * Takes a record and returns an array of tuples containing its keys and values.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.fromRecord({ a: 1, b: 2, c: 3 })
 * console.log(result) // [["a", 1], ["b", 2], ["c", 3]]
 * ```
 *
 * @category conversions
 * @since 2.0.0
 */
const Array_fromRecord = Record/* toEntries */.Yz;
/**
 * Converts an `Option` to an array.
 *
 * **Example**
 *
 * ```ts
 * import { Array, Option } from "effect"
 *
 * console.log(Array.fromOption(Option.some(1))) // [1]
 * console.log(Array.fromOption(Option.none())) // []
 * ```
 *
 * @category conversions
 * @since 2.0.0
 */
const fromOption = esm_Option/* toArray */.qo;
/**
 * Matches the elements of an array, applying functions to cases of empty and non-empty arrays.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const match = Array.match({
 *   onEmpty: () => "empty",
 *   onNonEmpty: ([head, ...tail]) => `head: ${head}, tail: ${tail.length}`
 * })
 * console.log(match([])) // "empty"
 * console.log(match([1, 2, 3])) // "head: 1, tail: 2"
 * ```
 *
 * @category pattern matching
 * @since 2.0.0
 */
const match = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, {
  onEmpty,
  onNonEmpty
}) => isNonEmptyReadonlyArray(self) ? onNonEmpty(self) : onEmpty())));
/**
 * Matches the elements of an array from the left, applying functions to cases of empty and non-empty arrays.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const matchLeft = Array.matchLeft({
 *   onEmpty: () => "empty",
 *   onNonEmpty: (head, tail) => `head: ${head}, tail: ${tail.length}`
 * })
 * console.log(matchLeft([])) // "empty"
 * console.log(matchLeft([1, 2, 3])) // "head: 1, tail: 2"
 * ```
 *
 * @category pattern matching
 * @since 2.0.0
 */
const matchLeft = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, {
  onEmpty,
  onNonEmpty
}) => isNonEmptyReadonlyArray(self) ? onNonEmpty(headNonEmpty(self), tailNonEmpty(self)) : onEmpty());
/**
 * Matches the elements of an array from the right, applying functions to cases of empty and non-empty arrays.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const matchRight = Array.matchRight({
 *   onEmpty: () => "empty",
 *   onNonEmpty: (init, last) => `init: ${init.length}, last: ${last}`
 * })
 * console.log(matchRight([])) // "empty"
 * console.log(matchRight([1, 2, 3])) // "init: 2, last: 3"
 * ```
 *
 * @category pattern matching
 * @since 2.0.0
 */
const matchRight = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, {
  onEmpty,
  onNonEmpty
}) => isNonEmptyReadonlyArray(self) ? onNonEmpty(initNonEmpty(self), lastNonEmpty(self)) : onEmpty())));
/**
 * Prepend an element to the front of an `Iterable`, creating a new `NonEmptyArray`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.prepend([2, 3, 4], 1)
 * console.log(result) // [1, 2, 3, 4]
 * ```
 *
 * @category concatenating
 * @since 2.0.0
 */
const Array_prepend = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, head) => [head, ...self]);
/**
 * Prepends the specified prefix array (or iterable) to the beginning of the specified array (or iterable).
 * If either array is non-empty, the result is also a non-empty array.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.prependAll([2, 3], [0, 1])
 * console.log(result) // [0, 1, 2, 3]
 * ```
 *
 * @category concatenating
 * @since 2.0.0
 */
const Array_prependAll = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => fromIterable(that).concat(fromIterable(self)))));
/**
 * Append an element to the end of an `Iterable`, creating a new `NonEmptyArray`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.append([1, 2, 3], 4);
 * console.log(result) // [1, 2, 3, 4]
 * ```
 *
 * @category concatenating
 * @since 2.0.0
 */
const Array_append = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, last) => [...self, last]);
/**
 * Concatenates two arrays (or iterables), combining their elements.
 * If either array is non-empty, the result is also a non-empty array.
 *
 * @category concatenating
 * @since 2.0.0
 */
const Array_appendAll = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => fromIterable(self).concat(fromIterable(that)));
/**
 * Accumulates values from an `Iterable` starting from the left, storing
 * each intermediate result in an array. Useful for tracking the progression of
 * a value through a series of transformations.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect";
 *
 * const result = Array.scan([1, 2, 3, 4], 0, (acc, value) => acc + value)
 * console.log(result) // [0, 1, 3, 6, 10]
 *
 * // Explanation:
 * // This function starts with the initial value (0 in this case)
 * // and adds each element of the array to this accumulator one by one,
 * // keeping track of the cumulative sum after each addition.
 * // Each of these sums is captured in the resulting array.
 * ```
 *
 * @category folding
 * @since 2.0.0
 */
const Array_scan = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, b, f) => {
  const out = [b];
  let i = 0;
  for (const a of self) {
    out[i + 1] = f(out[i], a);
    i++;
  }
  return out;
})));
/**
 * Accumulates values from an `Iterable` starting from the right, storing
 * each intermediate result in an array. Useful for tracking the progression of
 * a value through a series of transformations.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect";
 *
 * const result = Array.scanRight([1, 2, 3, 4], 0, (acc, value) => acc + value)
 * console.log(result) // [10, 9, 7, 4, 0]
 * ```
 *
 * @category folding
 * @since 2.0.0
 */
const scanRight = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, b, f) => {
  const input = fromIterable(self);
  const out = new Array(input.length + 1);
  out[input.length] = b;
  for (let i = input.length - 1; i >= 0; i--) {
    out[i] = f(out[i + 1], input[i]);
  }
  return out;
})));
/**
 * Determine if `unknown` is an Array.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * console.log(Array.isArray(null)) // false
 * console.log(Array.isArray([1, 2, 3])) // true
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isArray = Array.isArray;
/**
 * Determine if an `Array` is empty narrowing down the type to `[]`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * console.log(Array.isEmptyArray([])) // true
 * console.log(Array.isEmptyArray([1, 2, 3])) // false
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isEmptyArray = self => self.length === 0;
/**
 * Determine if a `ReadonlyArray` is empty narrowing down the type to `readonly []`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * console.log(Array.isEmptyReadonlyArray([])) // true
 * console.log(Array.isEmptyReadonlyArray([1, 2, 3])) // false
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isEmptyReadonlyArray = isEmptyArray;
/**
 * Determine if an `Array` is non empty narrowing down the type to `NonEmptyArray`.
 *
 * An `Array` is considered to be a `NonEmptyArray` if it contains at least one element.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * console.log(Array.isNonEmptyArray([])) // false
 * console.log(Array.isNonEmptyArray([1, 2, 3])) // true
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const Array_isNonEmptyArray = isNonEmptyArray;
/**
 * Determine if a `ReadonlyArray` is non empty narrowing down the type to `NonEmptyReadonlyArray`.
 *
 * A `ReadonlyArray` is considered to be a `NonEmptyReadonlyArray` if it contains at least one element.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * console.log(Array.isNonEmptyReadonlyArray([])) // false
 * console.log(Array.isNonEmptyReadonlyArray([1, 2, 3])) // true
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isNonEmptyReadonlyArray = isNonEmptyArray;
/**
 * Return the number of elements in a `ReadonlyArray`.
 *
 * @category getters
 * @since 2.0.0
 */
const Array_length = self => self.length;
const isOutOfBounds = (i, as) => i < 0 || i >= as.length;
const clamp = (i, as) => Math.floor(Math.min(Math.max(0, i), as.length));
/**
 * This function provides a safe way to read a value at a particular index from a `ReadonlyArray`.
 *
 * @category getters
 * @since 2.0.0
 */
const get = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, index) => {
  const i = Math.floor(index);
  return isOutOfBounds(i, self) ? esm_Option/* none */.YP() : esm_Option/* some */.G(self[i]);
});
/**
 * Gets an element unsafely, will throw on out of bounds.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeGet = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, index) => {
  const i = Math.floor(index);
  if (isOutOfBounds(i, self)) {
    throw new Error(`Index ${i} out of bounds`);
  }
  return self[i];
});
/**
 * Return a tuple containing the first element, and a new `Array` of the remaining elements, if any.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect";
 *
 * const result = Array.unprepend([1, 2, 3, 4])
 * console.log(result) // [1, [2, 3, 4]]
 * ```
 *
 * @category splitting
 * @since 2.0.0
 */
const unprepend = self => [headNonEmpty(self), tailNonEmpty(self)];
/**
 * Return a tuple containing a copy of the `NonEmptyReadonlyArray` without its last element, and that last element.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect";
 *
 * const result = Array.unappend([1, 2, 3, 4])
 * console.log(result) // [[1, 2, 3], 4]
 * ```
 *
 * @category splitting
 * @since 2.0.0
 */
const unappend = self => [initNonEmpty(self), lastNonEmpty(self)];
/**
 * Get the first element of a `ReadonlyArray`, or `None` if the `ReadonlyArray` is empty.
 *
 * @category getters
 * @since 2.0.0
 */
const Array_head = /*#__PURE__*/get(0);
/**
 * Get the first element of a non empty array.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.headNonEmpty([1, 2, 3, 4])
 * console.log(result) // 1
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const headNonEmpty = /*#__PURE__*/unsafeGet(0);
/**
 * Get the last element in a `ReadonlyArray`, or `None` if the `ReadonlyArray` is empty.
 *
 * @category getters
 * @since 2.0.0
 */
const last = self => isNonEmptyReadonlyArray(self) ? esm_Option/* some */.G(lastNonEmpty(self)) : esm_Option/* none */.YP();
/**
 * Get the last element of a non empty array.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.lastNonEmpty([1, 2, 3, 4])
 * console.log(result) // 4
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const lastNonEmpty = self => self[self.length - 1];
/**
 * Get all but the first element of an `Iterable`, creating a new `Array`, or `None` if the `Iterable` is empty.
 *
 * @category getters
 * @since 2.0.0
 */
const tail = self => {
  const input = fromIterable(self);
  return isNonEmptyReadonlyArray(input) ? Option.some(tailNonEmpty(input)) : Option.none();
};
/**
 * Get all but the first element of a `NonEmptyReadonlyArray`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.tailNonEmpty([1, 2, 3, 4])
 * console.log(result) // [2, 3, 4]
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const tailNonEmpty = self => self.slice(1);
/**
 * Get all but the last element of an `Iterable`, creating a new `Array`, or `None` if the `Iterable` is empty.
 *
 * @category getters
 * @since 2.0.0
 */
const init = self => {
  const input = fromIterable(self);
  return isNonEmptyReadonlyArray(input) ? Option.some(initNonEmpty(input)) : Option.none();
};
/**
 * Get all but the last element of a non empty array, creating a new array.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.initNonEmpty([1, 2, 3, 4])
 * console.log(result) // [1, 2, 3]
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const initNonEmpty = self => self.slice(0, -1);
/**
 * Keep only a max number of elements from the start of an `Iterable`, creating a new `Array`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.take([1, 2, 3, 4, 5], 3)
 * console.log(result) // [1, 2, 3]
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const Array_take = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => {
  const input = fromIterable(self);
  return input.slice(0, clamp(n, input));
})));
/**
 * Keep only a max number of elements from the end of an `Iterable`, creating a new `Array`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.takeRight([1, 2, 3, 4, 5], 3)
 * console.log(result) // [3, 4, 5]
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const takeRight = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => {
  const input = fromIterable(self);
  const i = clamp(n, input);
  return i === 0 ? [] : input.slice(-i);
})));
/**
 * Calculate the longest initial subarray for which all element satisfy the specified predicate, creating a new `Array`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.takeWhile([1, 3, 2, 4, 1, 2], x => x < 4)
 * console.log(result) // [1, 3, 2]
 *
 * // Explanation:
 * // - The function starts with the first element (`1`), which is less than `4`, so it adds `1` to the result.
 * // - The next element (`3`) is also less than `4`, so it adds `3`.
 * // - The next element (`2`) is again less than `4`, so it adds `2`.
 * // - The function then encounters `4`, which is not less than `4`. At this point, it stops checking further elements and finalizes the result.
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const Array_takeWhile = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => {
  let i = 0;
  const out = [];
  for (const a of self) {
    if (!predicate(a, i)) {
      break;
    }
    out.push(a);
    i++;
  }
  return out;
})));
const spanIndex = (self, predicate) => {
  let i = 0;
  for (const a of self) {
    if (!predicate(a, i)) {
      break;
    }
    i++;
  }
  return i;
};
/**
 * Split an `Iterable` into two parts:
 *
 * 1. the longest initial subarray for which all elements satisfy the specified predicate
 * 2. the remaining elements
 *
 * @category splitting
 * @since 2.0.0
 */
const span = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, predicate) => splitAt(self, spanIndex(self, predicate)));
/**
 * Drop a max number of elements from the start of an `Iterable`, creating a new `Array`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.drop([1, 2, 3, 4, 5], 2)
 * console.log(result) // [3, 4, 5]
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const Array_drop = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, n) => {
  const input = fromIterable(self);
  return input.slice(clamp(n, input), input.length);
});
/**
 * Drop a max number of elements from the end of an `Iterable`, creating a new `Array`.
 *
 * **Note**. `n` is normalized to a non negative integer.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.dropRight([1, 2, 3, 4, 5], 2)
 * console.log(result) // [1, 2, 3]
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const dropRight = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => {
  const input = fromIterable(self);
  return input.slice(0, input.length - clamp(n, input));
})));
/**
 * Remove the longest initial subarray for which all element satisfy the specified predicate, creating a new `Array`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.dropWhile([1, 2, 3, 4, 5], x => x < 4)
 * console.log(result) // [4, 5]
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const dropWhile = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => fromIterable(self).slice(spanIndex(self, predicate)))));
/**
 * Return the first index for which a predicate holds.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.findFirstIndex([5, 3, 8, 9], x => x > 5)
 * console.log(result) // Option.some(2)
 * ```
 *
 * @category elements
 * @since 2.0.0
 */
const findFirstIndex = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, predicate) => {
  let i = 0;
  for (const a of self) {
    if (predicate(a, i)) {
      return esm_Option/* some */.G(i);
    }
    i++;
  }
  return esm_Option/* none */.YP();
});
/**
 * Return the last index for which a predicate holds.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.findLastIndex([1, 3, 8, 9], x => x < 5)
 * console.log(result) // Option.some(1)
 * ```
 *
 * @category elements
 * @since 2.0.0
 */
const findLastIndex = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, predicate) => {
  const input = fromIterable(self);
  for (let i = input.length - 1; i >= 0; i--) {
    if (predicate(input[i], i)) {
      return esm_Option/* some */.G(i);
    }
  }
  return esm_Option/* none */.YP();
});
/**
 * Returns the first element that satisfies the specified
 * predicate, or `None` if no such element exists.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.findFirst([1, 2, 3, 4, 5], x => x > 3)
 * console.log(result) // Option.some(4)
 * ```
 *
 * @category elements
 * @since 2.0.0
 */
const Array_findFirst = findFirst;
/**
 * Finds the last element in an iterable collection that satisfies the given predicate or refinement.
 * Returns an `Option` containing the found element, or `Option.none` if no element matches.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.findLast([1, 2, 3, 4, 5], n => n % 2 === 0)
 * console.log(result) // Option.some(4)
 * ```
 *
 * @category elements
 * @since 2.0.0
 */
const Array_findLast = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const input = fromIterable(self);
  for (let i = input.length - 1; i >= 0; i--) {
    const a = input[i];
    const o = f(a, i);
    if (Predicate/* isBoolean */.jn(o)) {
      if (o) {
        return esm_Option/* some */.G(a);
      }
    } else {
      if (esm_Option/* isSome */.pC(o)) {
        return o;
      }
    }
  }
  return esm_Option/* none */.YP();
});
/**
 * Insert an element at the specified index, creating a new `NonEmptyArray`,
 * or return `None` if the index is out of bounds.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.insertAt(['a', 'b', 'c', 'e'], 3, 'd')
 * console.log(result) // Option.some(['a', 'b', 'c', 'd', 'e'])
 * ```
 *
 * @since 2.0.0
 */
const insertAt = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, i, b) => {
  const out = Array.from(self);
  //             v--- `= self.length` is ok, it means inserting in last position
  if (i < 0 || i > out.length) {
    return Option.none();
  }
  out.splice(i, 0, b);
  return Option.some(out);
})));
/**
 * Change the element at the specified index, creating a new `Array`,
 * or return a copy of the input if the index is out of bounds.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.replace(['a', 'b', 'c', 'd'], 1, 'z')
 * console.log(result) // ['a', 'z', 'c', 'd']
 * ```
 *
 * @since 2.0.0
 */
const replace = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, i, b) => modify(self, i, () => b))));
/**
 * Replaces an element in an array with the given value, returning an option of the updated array.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.replaceOption([1, 2, 3], 1, 4)
 * console.log(result) // Option.some([1, 4, 3])
 * ```
 *
 * @since 2.0.0
 */
const replaceOption = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, i, b) => modifyOption(self, i, () => b))));
/**
 * Apply a function to the element at the specified index, creating a new `Array`,
 * or return a copy of the input if the index is out of bounds.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.modify([1, 2, 3, 4], 2, (n) => n * 2)
 * console.log(result) // [1, 2, 6, 4]
 * ```
 *
 * @since 2.0.0
 */
const modify = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, i, f) => Option.getOrElse(modifyOption(self, i, f), () => Array.from(self)))));
/**
 * Apply a function to the element at the specified index, creating a new `Array`,
 * or return `None` if the index is out of bounds.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const input = [1, 2, 3, 4]
 * const result = Array.modifyOption(input, 2, (n) => n * 2)
 * console.log(result) // Option.some([1, 2, 6, 4])
 *
 * const outOfBoundsResult = Array.modifyOption(input, 5, (n) => n * 2)
 * console.log(outOfBoundsResult) // Option.none()
 * ```
 *
 * @since 2.0.0
 */
const modifyOption = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, i, f) => {
  const arr = Array.from(self);
  if (isOutOfBounds(i, arr)) {
    return Option.none();
  }
  const out = arr;
  const b = f(arr[i]);
  out[i] = b;
  return Option.some(out);
})));
/**
 * Delete the element at the specified index, creating a new `Array`,
 * or return a copy of the input if the index is out of bounds.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const input = [1, 2, 3, 4]
 * const result = Array.remove(input, 2)
 * console.log(result) // [1, 2, 4]
 *
 * const outOfBoundsResult = Array.remove(input, 5)
 * console.log(outOfBoundsResult) // [1, 2, 3, 4]
 * ```
 *
 * @since 2.0.0
 */
const remove = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, i) => {
  const out = Array.from(self);
  if (isOutOfBounds(i, out)) {
    return out;
  }
  out.splice(i, 1);
  return out;
})));
/**
 * Reverse an `Iterable`, creating a new `Array`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.reverse([1, 2, 3, 4])
 * console.log(result) // [4, 3, 2, 1]
 * ```
 *
 * @category elements
 * @since 2.0.0
 */
const reverse = self => Array.from(self).reverse();
/**
 * Create a new array with elements sorted in increasing order based on the specified comparator.
 * If the input is a `NonEmptyReadonlyArray`, the output will also be a `NonEmptyReadonlyArray`.
 *
 * @category sorting
 * @since 2.0.0
 */
const sort = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, O) => {
  const out = Array.from(self);
  out.sort(O);
  return out;
});
/**
 * Sorts an array based on a provided mapping function and order. The mapping
 * function transforms the elements into a value that can be compared, and the
 * order defines how those values should be sorted.
 *
 * **Example**
 *
 * ```ts
 * import { Array, Order } from "effect"
 *
 * const result = Array.sortWith(["aaa", "b", "cc"], (s) => s.length, Order.number)
 * console.log(result) // ["b", "cc", "aaa"]
 *
 * // Explanation:
 * // The array of strings is sorted based on their lengths. The mapping function `(s) => s.length`
 * // converts each string into its length, and the `Order.number` specifies that the lengths should
 * // be sorted in ascending order.
 * ```
 *
 * @since 2.0.0
 * @category elements
 */
const sortWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, f, order) => Array.from(self).map(a => [a, f(a)]).sort(([, a], [, b]) => order(a, b)).map(([_]) => _))));
/**
 * Sorts the elements of an `Iterable` in increasing order based on the provided
 * orders. The elements are compared using the first order in `orders`, then the
 * second order if the first comparison is equal, and so on.
 *
 * **Example**
 *
 * ```ts
 * import { Array, Order, pipe } from "effect"
 *
 * const users = [
 *   { name: "Alice", age: 30 },
 *   { name: "Bob", age: 25 },
 *   { name: "Charlie", age: 30 }
 * ]
 *
 * const result = pipe(
 *   users,
 *   Array.sortBy(
 *     Order.mapInput(Order.number, (user: (typeof users)[number]) => user.age),
 *     Order.mapInput(Order.string, (user: (typeof users)[number]) => user.name)
 *   )
 * )
 *
 * console.log(result)
 * // [
 * //   { name: "Bob", age: 25 },
 * //   { name: "Alice", age: 30 },
 * //   { name: "Charlie", age: 30 }
 * // ]
 *
 * // Explanation:
 * // The array of users is sorted first by age in ascending order. When ages are equal,
 * // the users are further sorted by name in ascending order.
 * ```
 *
 * @category sorting
 * @since 2.0.0
 */
const sortBy = (...orders) => {
  const sortByAll = sort(Order.combineAll(orders));
  return self => {
    const input = fromIterable(self);
    if (isNonEmptyReadonlyArray(input)) {
      return sortByAll(input);
    }
    return [];
  };
};
/**
 * Takes two `Iterable`s and returns an `Array` of corresponding pairs.
 * If one input `Iterable` is short, excess elements of the
 * longer `Iterable` are discarded.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.zip([1, 2, 3], ['a', 'b'])
 * console.log(result) // [[1, 'a'], [2, 'b']]
 * ```
 *
 * @category zipping
 * @since 2.0.0
 */
const Array_zip = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => Array_zipWith(self, that, esm_Tuple/* make */.Sy));
/**
 * Apply a function to pairs of elements at the same index in two `Iterable`s, collecting the results in a new `Array`. If one
 * input `Iterable` is short, excess elements of the longer `Iterable` are discarded.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.zipWith([1, 2, 3], [4, 5, 6], (a, b) => a + b)
 * console.log(result) // [5, 7, 9]
 * ```
 *
 * @category zipping
 * @since 2.0.0
 */
const Array_zipWith = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, that, f) => {
  const as = fromIterable(self);
  const bs = fromIterable(that);
  if (isNonEmptyReadonlyArray(as) && isNonEmptyReadonlyArray(bs)) {
    const out = [f(headNonEmpty(as), headNonEmpty(bs))];
    const len = Math.min(as.length, bs.length);
    for (let i = 1; i < len; i++) {
      out[i] = f(as[i], bs[i]);
    }
    return out;
  }
  return [];
});
/**
 * This function is the inverse of `zip`. Takes an `Iterable` of pairs and return two corresponding `Array`s.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.unzip([[1, "a"], [2, "b"], [3, "c"]])
 * console.log(result) // [[1, 2, 3], ['a', 'b', 'c']]
 * ```
 *
 * @since 2.0.0
 */
const unzip = self => {
  const input = fromIterable(self);
  if (isNonEmptyReadonlyArray(input)) {
    const fa = [input[0][0]];
    const fb = [input[0][1]];
    for (let i = 1; i < input.length; i++) {
      fa[i] = input[i][0];
      fb[i] = input[i][1];
    }
    return [fa, fb];
  }
  return [[], []];
};
/**
 * Places an element in between members of an `Iterable`.
 * If the input is a non-empty array, the result is also a non-empty array.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.intersperse([1, 2, 3], 0)
 * console.log(result) // [1, 0, 2, 0, 3]
 * ```
 *
 * @since 2.0.0
 */
const Array_intersperse = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, middle) => {
  const input = fromIterable(self);
  if (isNonEmptyReadonlyArray(input)) {
    const out = [headNonEmpty(input)];
    const tail = tailNonEmpty(input);
    for (let i = 0; i < tail.length; i++) {
      if (i < tail.length) {
        out.push(middle);
      }
      out.push(tail[i]);
    }
    return out;
  }
  return [];
})));
/**
 * Apply a function to the head, creating a new `NonEmptyReadonlyArray`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.modifyNonEmptyHead([1, 2, 3], n => n * 10)
 * console.log(result) // [10, 2, 3]
 * ```
 *
 * @since 2.0.0
 */
const modifyNonEmptyHead = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => [f(headNonEmpty(self)), ...tailNonEmpty(self)])));
/**
 * Change the head, creating a new `NonEmptyReadonlyArray`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.setNonEmptyHead([1, 2, 3], 10)
 * console.log(result) // [10, 2, 3]
 * ```
 *
 * @since 2.0.0
 */
const setNonEmptyHead = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, b) => modifyNonEmptyHead(self, () => b))));
/**
 * Apply a function to the last element, creating a new `NonEmptyReadonlyArray`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.modifyNonEmptyLast([1, 2, 3], n => n * 2)
 * console.log(result) // [1, 2, 6]
 * ```
 *
 * @since 2.0.0
 */
const modifyNonEmptyLast = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => Array_append(initNonEmpty(self), f(lastNonEmpty(self))))));
/**
 * Change the last element, creating a new `NonEmptyReadonlyArray`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.setNonEmptyLast([1, 2, 3], 4)
 * console.log(result) // [1, 2, 4]
 * ```
 *
 * @since 2.0.0
 */
const setNonEmptyLast = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, b) => modifyNonEmptyLast(self, () => b))));
/**
 * Rotate an `Iterable` by `n` steps.
 * If the input is a non-empty array, the result is also a non-empty array.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.rotate(['a', 'b', 'c', 'd'], 2)
 * console.log(result) // ['c', 'd', 'a', 'b']
 * ```
 *
 * @since 2.0.0
 */
const rotate = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => {
  const input = fromIterable(self);
  if (isNonEmptyReadonlyArray(input)) {
    const len = input.length;
    const m = Math.round(n) % len;
    if (isOutOfBounds(Math.abs(m), input) || m === 0) {
      return copy(input);
    }
    if (m < 0) {
      const [f, s] = splitNonEmptyAt(input, -m);
      return Array_appendAll(s, f);
    } else {
      return rotate(self, m - len);
    }
  }
  return [];
})));
/**
 * Returns a function that checks if a `ReadonlyArray` contains a given value using a provided `isEquivalent` function.
 *
 * **Example**
 *
 * ```ts
 * import { Array, pipe } from "effect"
 *
 * const isEquivalent = (a: number, b: number) => a === b
 * const containsNumber = Array.containsWith(isEquivalent)
 * const result = pipe([1, 2, 3, 4], containsNumber(3))
 * console.log(result) // true
 * ```
 *
 * @category elements
 * @since 2.0.0
 */
const Array_containsWith = isEquivalent => (0,Function/* dual */.OB)(2, (self, a) => {
  for (const i of self) {
    if (isEquivalent(a, i)) {
      return true;
    }
  }
  return false;
});
const Array_equivalence = /*#__PURE__*/esm_Equal/* equivalence */.DE();
/**
 * Returns a function that checks if a `ReadonlyArray` contains a given value using the default `Equivalence`.
 *
 * **Example**
 *
 * ```ts
 * import { Array, pipe } from "effect"
 *
 * const result = pipe(['a', 'b', 'c', 'd'], Array.contains('c'))
 * console.log(result) // true
 * ```
 *
 * @category elements
 * @since 2.0.0
 */
const Array_contains = /*#__PURE__*/Array_containsWith(Array_equivalence);
/**
 * A useful recursion pattern for processing an `Iterable` to produce a new `Array`, often used for "chopping" up the input
 * `Iterable`. Typically chop is called with some function that will consume an initial prefix of the `Iterable` and produce a
 * value and the rest of the `Array`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.chop([1, 2, 3, 4, 5], (as): [number, Array<number>] => [as[0] * 2, as.slice(1)])
 * console.log(result) // [2, 4, 6, 8, 10]
 *
 * // Explanation:
 * // The `chopFunction` takes the first element of the array, doubles it, and then returns it along with the rest of the array.
 * // The `chop` function applies this `chopFunction` recursively to the input array `[1, 2, 3, 4, 5]`,
 * // resulting in a new array `[2, 4, 6, 8, 10]`.
 * ```
 *
 * @since 2.0.0
 */
const chop = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  const input = fromIterable(self);
  if (isNonEmptyReadonlyArray(input)) {
    const [b, rest] = f(input);
    const out = [b];
    let next = rest;
    while (internalArray.isNonEmptyArray(next)) {
      const [b, rest] = f(next);
      out.push(b);
      next = rest;
    }
    return out;
  }
  return [];
})));
/**
 * Splits an `Iterable` into two segments, with the first segment containing a maximum of `n` elements.
 * The value of `n` can be `0`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.splitAt([1, 2, 3, 4, 5], 3)
 * console.log(result) // [[1, 2, 3], [4, 5]]
 * ```
 *
 * @category splitting
 * @since 2.0.0
 */
const splitAt = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, n) => {
  const input = Array.from(self);
  const _n = Math.floor(n);
  if (isNonEmptyReadonlyArray(input)) {
    if (_n >= 1) {
      return splitNonEmptyAt(input, _n);
    }
    return [[], input];
  }
  return [input, []];
});
/**
 * Splits a `NonEmptyReadonlyArray` into two segments, with the first segment containing a maximum of `n` elements.
 * The value of `n` must be `>= 1`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.splitNonEmptyAt(["a", "b", "c", "d", "e"], 3)
 * console.log(result) // [["a", "b", "c"], ["d", "e"]]
 * ```
 *
 * @category splitting
 * @since 2.0.0
 */
const splitNonEmptyAt = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, n) => {
  const _n = Math.max(1, Math.floor(n));
  return _n >= self.length ? [copy(self), []] : [Array_prepend(self.slice(1, _n), headNonEmpty(self)), self.slice(_n)];
});
/**
 * Splits this iterable into `n` equally sized arrays.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.split([1, 2, 3, 4, 5, 6, 7, 8], 3)
 * console.log(result) // [[1, 2, 3], [4, 5, 6], [7, 8]]
 * ```
 *
 * @since 2.0.0
 * @category splitting
 */
const split = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => {
  const input = fromIterable(self);
  return Array_chunksOf(input, Math.ceil(input.length / Math.floor(n)));
})));
/**
 * Splits this iterable on the first element that matches this predicate.
 * Returns a tuple containing two arrays: the first one is before the match, and the second one is from the match onward.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.splitWhere([1, 2, 3, 4, 5], n => n > 3)
 * console.log(result) // [[1, 2, 3], [4, 5]]
 * ```
 *
 * @category splitting
 * @since 2.0.0
 */
const splitWhere = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => span(self, (a, i) => !predicate(a, i)))));
/**
 * Copies an array.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.copy([1, 2, 3])
 * console.log(result) // [1, 2, 3]
 * ```
 *
 * @since 2.0.0
 */
const copy = self => self.slice();
/**
 * Pads an array.
 * Returns a new array of length `n` with the elements of `array` followed by `fill` elements if `array` is shorter than `n`.
 * If `array` is longer than `n`, the returned array will be a slice of `array` containing the `n` first elements of `array`.
 * If `n` is less than or equal to 0, the returned array will be an empty array.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.pad([1, 2, 3], 6, 0)
 * console.log(result) // [1, 2, 3, 0, 0, 0]
 * ```
 *
 * @since 3.8.4
 */
const pad = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, n, fill) => {
  if (self.length >= n) {
    return Array_take(self, n);
  }
  return Array_appendAll(self, Array_makeBy(n - self.length, () => fill));
})));
/**
 * Splits an `Iterable` into length-`n` pieces. The last piece will be shorter if `n` does not evenly divide the length of
 * the `Iterable`. Note that `chunksOf(n)([])` is `[]`, not `[[]]`. This is intentional, and is consistent with a recursive
 * definition of `chunksOf`; it satisfies the property that
 *
 * ```ts skip-type-checking
 * chunksOf(n)(xs).concat(chunksOf(n)(ys)) == chunksOf(n)(xs.concat(ys)))
 * ```
 *
 * whenever `n` evenly divides the length of `self`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.chunksOf([1, 2, 3, 4, 5], 2)
 * console.log(result) // [[1, 2], [3, 4], [5]]
 *
 * // Explanation:
 * // The `chunksOf` function takes an array of numbers `[1, 2, 3, 4, 5]` and a number `2`.
 * // It splits the array into chunks of length 2. Since the array length is not evenly divisible by 2,
 * // the last chunk contains the remaining elements.
 * // The result is `[[1, 2], [3, 4], [5]]`.
 * ```
 *
 * @category splitting
 * @since 2.0.0
 */
const Array_chunksOf = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => {
  const input = fromIterable(self);
  if (isNonEmptyReadonlyArray(input)) {
    return chop(input, splitNonEmptyAt(n));
  }
  return [];
})));
/**
 * Creates sliding windows of size `n` from an `Iterable`.
 * If the number of elements is less than `n` or if `n` is not greater than zero,
 * an empty array is returned.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Array } from "effect"
 *
 * const numbers = [1, 2, 3, 4, 5]
 * assert.deepStrictEqual(Array.window(numbers, 3), [[1, 2, 3], [2, 3, 4], [3, 4, 5]])
 * assert.deepStrictEqual(Array.window(numbers, 6), [])
 * ```
 *
 * @category splitting
 * @since 3.13.2
 */
const Array_window = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => {
  const input = fromIterable(self);
  if (n > 0 && isNonEmptyReadonlyArray(input)) {
    return Array.from({
      length: input.length - (n - 1)
    }, (_, index) => input.slice(index, index + n));
  }
  return [];
})));
/**
 * Group equal, consecutive elements of a `NonEmptyReadonlyArray` into `NonEmptyArray`s using the provided `isEquivalent` function.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.groupWith(["a", "a", "b", "b", "b", "c", "a"], (x, y) => x === y)
 * console.log(result) // [["a", "a"], ["b", "b", "b"], ["c"], ["a"]]
 * ```
 *
 * @category grouping
 * @since 2.0.0
 */
const Array_groupWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, isEquivalent) => chop(self, as => {
  const h = headNonEmpty(as);
  const out = [h];
  let i = 1;
  for (; i < as.length; i++) {
    const a = as[i];
    if (isEquivalent(a, h)) {
      out.push(a);
    } else {
      break;
    }
  }
  return [out, as.slice(i)];
}))));
/**
 * Group equal, consecutive elements of a `NonEmptyReadonlyArray` into `NonEmptyArray`s.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.group([1, 1, 2, 2, 2, 3, 1])
 * console.log(result) // [[1, 1], [2, 2, 2], [3], [1]]
 * ```
 *
 * @category grouping
 * @since 2.0.0
 */
const Array_group = /*#__PURE__*/(/* unused pure expression or super */ null && (Array_groupWith( /*#__PURE__*/Equal.equivalence())));
/**
 * Splits an `Iterable` into sub-non-empty-arrays stored in an object, based on the result of calling a `string`-returning
 * function on each element, and grouping the results according to values returned
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const people = [
 *   { name: "Alice", group: "A" },
 *   { name: "Bob", group: "B" },
 *   { name: "Charlie", group: "A" }
 * ]
 *
 * const result = Array.groupBy(people, person => person.group)
 * console.log(result)
 * // {
 * //  A: [{ name: "Alice", group: "A" }, { name: "Charlie", group: "A" }],
 * //  B: [{ name: "Bob", group: "B" }]
 * // }
 * ```
 *
 * @category grouping
 * @since 2.0.0
 */
const Array_groupBy = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  const out = {};
  for (const a of self) {
    const k = f(a);
    if (Object.prototype.hasOwnProperty.call(out, k)) {
      out[k].push(a);
    } else {
      out[k] = [a];
    }
  }
  return out;
})));
/**
 * Calculates the union of two arrays using the provided equivalence relation.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const union = Array.unionWith([1, 2], [2, 3], (a, b) => a === b)
 * console.log(union) // [1, 2, 3]
 * ```
 *
 * @since 2.0.0
 */
const unionWith = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, that, isEquivalent) => {
  const a = fromIterable(self);
  const b = fromIterable(that);
  if (isNonEmptyReadonlyArray(a)) {
    if (isNonEmptyReadonlyArray(b)) {
      const dedupe = dedupeWith(isEquivalent);
      return dedupe(Array_appendAll(a, b));
    }
    return a;
  }
  return b;
});
/**
 * Creates a union of two arrays, removing duplicates.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.union([1, 2], [2, 3])
 * console.log(result) // [1, 2, 3]
 * ```
 *
 * @since 2.0.0
 */
const union = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => unionWith(self, that, Array_equivalence));
/**
 * Creates an `Array` of unique values that are included in all given `Iterable`s using the provided `isEquivalent` function.
 * The order and references of result values are determined by the first `Iterable`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const array1 = [{ id: 1 }, { id: 2 }, { id: 3 }]
 * const array2 = [{ id: 3 }, { id: 4 }, { id: 1 }]
 * const isEquivalent = (a: { id: number }, b: { id: number }) => a.id === b.id
 * const result = Array.intersectionWith(isEquivalent)(array2)(array1)
 * console.log(result) // [{ id: 1 }, { id: 3 }]
 * ```
 *
 * @since 2.0.0
 */
const intersectionWith = isEquivalent => {
  const has = Array_containsWith(isEquivalent);
  return dual(2, (self, that) => fromIterable(self).filter(a => has(that, a)));
};
/**
 * Creates an `Array` of unique values that are included in all given `Iterable`s.
 * The order and references of result values are determined by the first `Iterable`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.intersection([1, 2, 3], [3, 4, 1])
 * console.log(result) // [1, 3]
 * ```
 *
 * @since 2.0.0
 */
const intersection = /*#__PURE__*/(/* unused pure expression or super */ null && (intersectionWith(Array_equivalence)));
/**
 * Creates a `Array` of values not included in the other given `Iterable` using the provided `isEquivalent` function.
 * The order and references of result values are determined by the first `Iterable`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const array1 = [1, 2, 3]
 * const array2 = [2, 3, 4]
 * const difference = Array.differenceWith<number>((a, b) => a === b)(array1, array2)
 * console.log(difference) // [1]
 * ```
 *
 * @since 2.0.0
 */
const differenceWith = isEquivalent => {
  const has = Array_containsWith(isEquivalent);
  return (0,Function/* dual */.OB)(2, (self, that) => fromIterable(self).filter(a => !has(that, a)));
};
/**
 * Creates a `Array` of values not included in the other given `Iterable`.
 * The order and references of result values are determined by the first `Iterable`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const difference = Array.difference([1, 2, 3], [2, 3, 4])
 * console.log(difference) // [1]
 * ```
 *
 * @since 2.0.0
 */
const difference = /*#__PURE__*/(/* unused pure expression or super */ null && (differenceWith(Array_equivalence)));
/**
 * @category constructors
 * @since 2.0.0
 */
const Array_empty = () => [];
/**
 * Constructs a new `NonEmptyArray<A>` from the specified value.
 *
 * @category constructors
 * @since 2.0.0
 */
const Array_of = a => [a];
/**
 * @category mapping
 * @since 2.0.0
 */
const Array_map = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => self.map(f));
/**
 * Applies a function to each element in an array and returns a new array containing the concatenated mapped elements.
 *
 * @category sequencing
 * @since 2.0.0
 */
const Array_flatMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  if (isEmptyReadonlyArray(self)) {
    return [];
  }
  const out = [];
  for (let i = 0; i < self.length; i++) {
    const inner = f(self[i], i);
    for (let j = 0; j < inner.length; j++) {
      out.push(inner[j]);
    }
  }
  return out;
});
/**
 * Combines multiple arrays into a single array by concatenating all elements
 * from each nested array. This function ensures that the structure of nested
 * arrays is collapsed into a single, flat array.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.flatten([[1, 2], [], [3, 4], [], [5, 6]])
 * console.log(result) // [1, 2, 3, 4, 5, 6]
 * ```
 *
 * @category sequencing
 * @since 2.0.0
 */
const Array_flatten = /*#__PURE__*/Array_flatMap(Function/* identity */.yR);
/**
 * Applies a function to each element of the `Iterable` and filters based on the result, keeping the transformed values where the function returns `Some`.
 * This method combines filtering and mapping functionalities, allowing transformations and filtering of elements based on a single function pass.
 *
 * **Example**
 *
 * ```ts
 * import { Array, Option } from "effect"
 *
 * const evenSquares = (x: number) => x % 2 === 0 ? Option.some(x * x) : Option.none()
 *
 * const result = Array.filterMap([1, 2, 3, 4, 5], evenSquares);
 * console.log(result) // [4, 16]
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const Array_filterMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const as = fromIterable(self);
  const out = [];
  for (let i = 0; i < as.length; i++) {
    const o = f(as[i], i);
    if (esm_Option/* isSome */.pC(o)) {
      out.push(o.value);
    }
  }
  return out;
});
/**
 * Applies a function to each element of the array and filters based on the result, stopping when a condition is not met.
 * This method combines filtering and mapping in a single pass, and short-circuits, i.e., stops processing, as soon as the function returns `None`.
 * This is useful when you need to transform an array but only up to the point where a certain condition holds true.
 *
 * **Example**
 *
 * ```ts
 * import { Array, Option } from "effect"
 *
 * const toSquareTillOdd = (x: number) => x % 2 === 0 ? Option.some(x * x) : Option.none()
 *
 * const result = Array.filterMapWhile([2, 4, 5], toSquareTillOdd)
 * console.log(result) // [4, 16]
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const Array_filterMapWhile = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  let i = 0;
  const out = [];
  for (const a of self) {
    const b = f(a, i);
    if (Option.isSome(b)) {
      out.push(b.value);
    } else {
      break;
    }
    i++;
  }
  return out;
})));
/**
 * Applies a function to each element of the `Iterable`, categorizing the results into two separate arrays.
 * This function is particularly useful for operations where each element can result in two possible types,
 * and you want to separate these types into different collections. For instance, separating validation results
 * into successes and failures.
 *
 * **Example**
 *
 * ```ts
 * import { Array, Either } from "effect";
 *
 * const isEven = (x: number) => x % 2 === 0
 *
 * const result = Array.partitionMap([1, 2, 3, 4, 5], x =>
 *   isEven(x) ? Either.right(x) : Either.left(x)
 * )
 * console.log(result)
 * // [
 * //   [1, 3, 5],
 * //   [2, 4]
 * // ]
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const partitionMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const left = [];
  const right = [];
  const as = fromIterable(self);
  for (let i = 0; i < as.length; i++) {
    const e = f(as[i], i);
    if (esm_Either/* isLeft */.nM(e)) {
      left.push(e.left);
    } else {
      right.push(e.right);
    }
  }
  return [left, right];
});
/**
 * Retrieves the `Some` values from an `Iterable` of `Option`s, collecting them into an array.
 *
 * **Example**
 *
 * ```ts
 * import { Array, Option } from "effect"
 *
 * const result = Array.getSomes([Option.some(1), Option.none(), Option.some(2)])
 * console.log(result) // [1, 2]
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const Array_getSomes = /*#__PURE__*/Array_filterMap(Function/* identity */.yR);
/**
 * Retrieves the `Left` values from an `Iterable` of `Either`s, collecting them into an array.
 *
 * **Example**
 *
 * ```ts
 * import { Array, Either } from "effect"
 *
 * const result = Array.getLefts([Either.right(1), Either.left("err"), Either.right(2)])
 * console.log(result) // ["err"]
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const Array_getLefts = self => {
  const out = [];
  for (const a of self) {
    if (Either.isLeft(a)) {
      out.push(a.left);
    }
  }
  return out;
};
/**
 * Retrieves the `Right` values from an `Iterable` of `Either`s, collecting them into an array.
 *
 * **Example**
 *
 * ```ts
 * import { Array, Either } from "effect"
 *
 * const result = Array.getRights([Either.right(1), Either.left("err"), Either.right(2)])
 * console.log(result) // [1, 2]
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const Array_getRights = self => {
  const out = [];
  for (const a of self) {
    if (Either.isRight(a)) {
      out.push(a.right);
    }
  }
  return out;
};
/**
 * @category filtering
 * @since 2.0.0
 */
const Array_filter = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => {
  const as = fromIterable(self);
  const out = [];
  for (let i = 0; i < as.length; i++) {
    if (predicate(as[i], i)) {
      out.push(as[i]);
    }
  }
  return out;
})));
/**
 * Separate elements based on a predicate that also exposes the index of the element.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.partition([1, 2, 3, 4], n => n % 2 === 0)
 * console.log(result) // [[1, 3], [2, 4]]
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const partition = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => {
  const left = [];
  const right = [];
  const as = fromIterable(self);
  for (let i = 0; i < as.length; i++) {
    if (predicate(as[i], i)) {
      right.push(as[i]);
    } else {
      left.push(as[i]);
    }
  }
  return [left, right];
})));
/**
 * Separates an `Iterable` into two arrays based on a predicate.
 *
 * @category filtering
 * @since 2.0.0
 */
const separate = /*#__PURE__*/(/* unused pure expression or super */ null && (partitionMap(identity)));
/**
 * Reduces an array from the left.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.reduce([1, 2, 3], 0, (acc, n) => acc + n)
 * console.log(result) // 6
 * ```
 *
 * @category folding
 * @since 2.0.0
 */
const Array_reduce = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, b, f) => fromIterable(self).reduce((b, a, i) => f(b, a, i), b));
/**
 * Reduces an array from the right.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.reduceRight([1, 2, 3], 0, (acc, n) => acc + n)
 * console.log(result) // 6
 * ```
 *
 * @category folding
 * @since 2.0.0
 */
const reduceRight = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, b, f) => fromIterable(self).reduceRight((b, a, i) => f(b, a, i), b));
/**
 * Lifts a predicate into an array.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const isEven = (n: number) => n % 2 === 0
 * const to = Array.liftPredicate(isEven)
 * console.log(to(1)) // []
 * console.log(to(2)) // [2]
 * ```
 *
 * @category lifting
 * @since 2.0.0
 */
const liftPredicate = predicate => b => predicate(b) ? [b] : [];
/**
 * @category lifting
 * @since 2.0.0
 */
const liftOption = f => (...a) => fromOption(f(...a));
/**
 * @category conversions
 * @since 2.0.0
 */
const fromNullable = a => a == null ? Array_empty() : [a];
/**
 * @category lifting
 * @since 2.0.0
 */
const liftNullable = f => (...a) => fromNullable(f(...a));
/**
 * Maps over an array and flattens the result, removing null and undefined values.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.flatMapNullable([1, 2, 3], n => (n % 2 === 0 ? null : n))
 * console.log(result) // [1, 3]
 *
 * // Explanation:
 * // The array of numbers [1, 2, 3] is mapped with a function that returns null for even numbers
 * // and the number itself for odd numbers. The resulting array [1, null, 3] is then flattened
 * // to remove null values, resulting in [1, 3].
 * ```
 *
 * @category sequencing
 * @since 2.0.0
 */
const Array_flatMapNullable = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => Array_flatMap(self, a => fromNullable(f(a))))));
/**
 * Lifts a function that returns an `Either` into a function that returns an array.
 * If the `Either` is a left, it returns an empty array.
 * If the `Either` is a right, it returns an array with the right value.
 *
 * **Example**
 *
 * ```ts
 * import { Array, Either } from "effect"
 *
 * const parseNumber = (s: string): Either.Either<number, Error> =>
 *   isNaN(Number(s)) ? Either.left(new Error("Not a number")) : Either.right(Number(s))
 *
 * const liftedParseNumber = Array.liftEither(parseNumber)
 *
 * const result1 = liftedParseNumber("42")
 * console.log(result1) // [42]
 *
 * const result2 = liftedParseNumber("not a number")
 * console.log(result2) // []
 *
 * // Explanation:
 * // The function parseNumber is lifted to return an array.
 * // When parsing "42", it returns an Either.left with the number 42, resulting in [42].
 * // When parsing "not a number", it returns an Either.right with an error, resulting in an empty array [].
 * ```
 *
 * @category lifting
 * @since 2.0.0
 */
const liftEither = f => (...a) => {
  const e = f(...a);
  return Either.isLeft(e) ? [] : [e.right];
};
/**
 * Check if a predicate holds true for every `ReadonlyArray` element.
 *
 * @category elements
 * @since 2.0.0
 */
const every = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, refinement) => self.every(refinement))));
/**
 * Check if a predicate holds true for some `ReadonlyArray` element.
 *
 * @category elements
 * @since 2.0.0
 */
const Array_some = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => self.some(predicate))));
/**
 * Extends an array with a function that maps each subarray to a value.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.extend([1, 2, 3], as => as.length)
 * console.log(result) // [3, 2, 1]
 *
 * // Explanation:
 * // The function maps each subarray starting from each element to its length.
 * // The subarrays are: [1, 2, 3], [2, 3], [3].
 * // The lengths are: 3, 2, 1.
 * // Therefore, the result is [3, 2, 1].
 * ```
 *
 * @since 2.0.0
 */
const extend = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => self.map((_, i, as) => f(as.slice(i))))));
/**
 * Finds the minimum element in an array based on a comparator.
 *
 * **Example**
 *
 * ```ts
 * import { Array, Order } from "effect"
 *
 * const result = Array.min([3, 1, 2], Order.number)
 * console.log(result) // 1
 * ```
 *
 * @since 2.0.0
 */
const min = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, O) => self.reduce(Order.min(O)))));
/**
 * Finds the maximum element in an array based on a comparator.
 *
 * **Example**
 *
 * ```ts
 * import { Array, Order } from "effect"
 *
 * const result = Array.max([3, 1, 2], Order.number)
 * console.log(result) // 3
 * ```
 *
 * @since 2.0.0
 */
const max = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, O) => self.reduce(Order.max(O)))));
/**
 * @category constructors
 * @since 2.0.0
 */
const Array_unfold = (b, f) => {
  const out = [];
  let next = b;
  let o;
  while (esm_Option/* isSome */.pC(o = f(next))) {
    const [a, b] = o.value;
    out.push(a);
    next = b;
  }
  return out;
};
/**
 * This function creates and returns a new `Order` for an array of values based on a given `Order` for the elements of the array.
 * The returned `Order` compares two arrays by applying the given `Order` to each element in the arrays.
 * If all elements are equal, the arrays are then compared based on their length.
 * It is useful when you need to compare two arrays of the same type and you have a specific way of comparing each element of the array.
 *
 * @category instances
 * @since 2.0.0
 */
const getOrder = esm_Order/* array */.IX;
/**
 * Creates an equivalence relation for arrays.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const eq = Array.getEquivalence<number>((a, b) => a === b)
 * console.log(eq([1, 2, 3], [1, 2, 3])) // true
 * ```
 *
 * @category instances
 * @since 2.0.0
 */
const getEquivalence = Equivalence/* array */.IX;
/**
 * Performs a side-effect for each element of the `Iterable`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * Array.forEach([1, 2, 3], n => console.log(n)) // 1, 2, 3
 * ```
 *
 * @since 2.0.0
 */
const Array_forEach = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => fromIterable(self).forEach((a, i) => f(a, i)))));
/**
 * Remove duplicates from an `Iterable` using the provided `isEquivalent` function,
 * preserving the order of the first occurrence of each element.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.dedupeWith([1, 2, 2, 3, 3, 3], (a, b) => a === b)
 * console.log(result) // [1, 2, 3]
 * ```
 *
 * @since 2.0.0
 */
const dedupeWith = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, isEquivalent) => {
  const input = fromIterable(self);
  if (isNonEmptyReadonlyArray(input)) {
    const out = [headNonEmpty(input)];
    const rest = tailNonEmpty(input);
    for (const r of rest) {
      if (out.every(a => !isEquivalent(r, a))) {
        out.push(r);
      }
    }
    return out;
  }
  return [];
});
/**
 * Remove duplicates from an `Iterable`, preserving the order of the first occurrence of each element.
 * The equivalence used to compare elements is provided by `Equal.equivalence()` from the `Equal` module.
 *
 * @since 2.0.0
 */
const dedupe = self => dedupeWith(self, esm_Equal/* equivalence */.DE());
/**
 * Deduplicates adjacent elements that are identical using the provided `isEquivalent` function.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.dedupeAdjacentWith([1, 1, 2, 2, 3, 3], (a, b) => a === b)
 * console.log(result) // [1, 2, 3]
 * ```
 *
 * @since 2.0.0
 */
const Array_dedupeAdjacentWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, isEquivalent) => {
  const out = [];
  let lastA = Option.none();
  for (const a of self) {
    if (Option.isNone(lastA) || !isEquivalent(a, lastA.value)) {
      out.push(a);
      lastA = Option.some(a);
    }
  }
  return out;
})));
/**
 * Deduplicates adjacent elements that are identical.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.dedupeAdjacent([1, 1, 2, 2, 3, 3])
 * console.log(result) // [1, 2, 3]
 * ```
 *
 * @since 2.0.0
 */
const Array_dedupeAdjacent = /*#__PURE__*/(/* unused pure expression or super */ null && (Array_dedupeAdjacentWith( /*#__PURE__*/Equal.equivalence())));
/**
 * Joins the elements together with "sep" in the middle.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const strings = ["a", "b", "c"]
 * const joined = Array.join(strings, "-")
 * console.log(joined) // "a-b-c"
 * ```
 *
 * @since 2.0.0
 * @category folding
 */
const join = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, sep) => fromIterable(self).join(sep));
/**
 * Statefully maps over the chunk, producing new elements of type `B`.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.mapAccum([1, 2, 3], 0, (acc, n) => [acc + n, acc + n])
 * console.log(result) // [6, [1, 3, 6]]
 * ```
 *
 * @since 2.0.0
 * @category folding
 */
const mapAccum = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, s, f) => {
  let i = 0;
  let s1 = s;
  const out = [];
  for (const a of self) {
    const r = f(s1, a, i);
    s1 = r[0];
    out.push(r[1]);
    i++;
  }
  return [s1, out];
})));
/**
 * Zips this chunk crosswise with the specified chunk using the specified combiner.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.cartesianWith([1, 2], ["a", "b"], (a, b) => `${a}-${b}`)
 * console.log(result) // ["1-a", "1-b", "2-a", "2-b"]
 * ```
 *
 * @since 2.0.0
 * @category elements
 */
const Array_cartesianWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, that, f) => Array_flatMap(self, a => Array_map(that, b => f(a, b))))));
/**
 * Zips this chunk crosswise with the specified chunk.
 *
 * **Example**
 *
 * ```ts
 * import { Array } from "effect"
 *
 * const result = Array.cartesian([1, 2], ["a", "b"])
 * console.log(result) // [[1, "a"], [1, "b"], [2, "a"], [2, "b"]]
 * ```
 *
 * @since 2.0.0
 * @category elements
 */
const Array_cartesian = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => Array_cartesianWith(self, that, (a, b) => [a, b]))));
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * The "do simulation" for array allows you to sequentially apply operations to the elements of arrays, just as nested loops allow you to go through all combinations of elements in an arrays.
 *
 * It can be used to simulate "array comprehension".
 * It's a technique that allows you to create new arrays by iterating over existing ones and applying specific **conditions** or **transformations** to the elements. It's like assembling a new collection from pieces of other collections based on certain rules.
 *
 * Here's how the do simulation works:
 *
 * 1. Start the do simulation using the `Do` value
 * 2. Within the do simulation scope, you can use the `bind` function to define variables and bind them to `Array` values
 * 3. You can accumulate multiple `bind` statements to define multiple variables within the scope
 * 4. Inside the do simulation scope, you can also use the `let` function to define variables and bind them to simple values
 * 5. Regular `Option` functions like `map` and `filter` can still be used within the do simulation. These functions will receive the accumulated variables as arguments within the scope
 *
 * **Example**
 *
 * ```ts
 * import { Array, pipe } from "effect"
 *
 * const doResult = pipe(
 *   Array.Do,
 *   Array.bind("x", () => [1, 3, 5]),
 *   Array.bind("y", () => [2, 4, 6]),
 *   Array.filter(({ x, y }) => x < y), // condition
 *   Array.map(({ x, y }) => [x, y] as const) // transformation
 * )
 * console.log(doResult) // [[1, 2], [1, 4], [1, 6], [3, 4], [3, 6], [5, 6]]
 *
 * // equivalent
 * const x = [1, 3, 5],
 *       y = [2, 4, 6],
 *       result = [];
 * for(let i = 0; i < x.length; i++) {
 *   for(let j = 0; j < y.length; j++) {
 *     const _x = x[i], _y = y[j];
 *     if(_x < _y) result.push([_x, _y] as const)
 *   }
 * }
 * ```
 *
 * @see {@link bindTo}
 * @see {@link bind}
 * @see {@link let_ let}
 *
 * @category do notation
 * @since 3.2.0
 */
const Do = /*#__PURE__*/Array_of({});
/**
 * The "do simulation" for array allows you to sequentially apply operations to the elements of arrays, just as nested loops allow you to go through all combinations of elements in an arrays.
 *
 * It can be used to simulate "array comprehension".
 * It's a technique that allows you to create new arrays by iterating over existing ones and applying specific **conditions** or **transformations** to the elements. It's like assembling a new collection from pieces of other collections based on certain rules.
 *
 * Here's how the do simulation works:
 *
 * 1. Start the do simulation using the `Do` value
 * 2. Within the do simulation scope, you can use the `bind` function to define variables and bind them to `Array` values
 * 3. You can accumulate multiple `bind` statements to define multiple variables within the scope
 * 4. Inside the do simulation scope, you can also use the `let` function to define variables and bind them to simple values
 * 5. Regular `Option` functions like `map` and `filter` can still be used within the do simulation. These functions will receive the accumulated variables as arguments within the scope
 *
 * **Example**
 *
 * ```ts
 * import { Array, pipe } from "effect"
 *
 * const doResult = pipe(
 *   Array.Do,
 *   Array.bind("x", () => [1, 3, 5]),
 *   Array.bind("y", () => [2, 4, 6]),
 *   Array.filter(({ x, y }) => x < y), // condition
 *   Array.map(({ x, y }) => [x, y] as const) // transformation
 * )
 * console.log(doResult) // [[1, 2], [1, 4], [1, 6], [3, 4], [3, 6], [5, 6]]
 *
 * // equivalent
 * const x = [1, 3, 5],
 *       y = [2, 4, 6],
 *       result = [];
 * for(let i = 0; i < x.length; i++) {
 *   for(let j = 0; j < y.length; j++) {
 *     const _x = x[i], _y = y[j];
 *     if(_x < _y) result.push([_x, _y] as const)
 *   }
 * }
 * ```
 *
 * @see {@link bindTo}
 * @see {@link Do}
 * @see {@link let_ let}
 *
 * @category do notation
 * @since 3.2.0
 */
const bind = /*#__PURE__*/(/* unused pure expression or super */ null && (internalDoNotation.bind(Array_map, Array_flatMap)));
/**
 * The "do simulation" for array allows you to sequentially apply operations to the elements of arrays, just as nested loops allow you to go through all combinations of elements in an arrays.
 *
 * It can be used to simulate "array comprehension".
 * It's a technique that allows you to create new arrays by iterating over existing ones and applying specific **conditions** or **transformations** to the elements. It's like assembling a new collection from pieces of other collections based on certain rules.
 *
 * Here's how the do simulation works:
 *
 * 1. Start the do simulation using the `Do` value
 * 2. Within the do simulation scope, you can use the `bind` function to define variables and bind them to `Array` values
 * 3. You can accumulate multiple `bind` statements to define multiple variables within the scope
 * 4. Inside the do simulation scope, you can also use the `let` function to define variables and bind them to simple values
 * 5. Regular `Option` functions like `map` and `filter` can still be used within the do simulation. These functions will receive the accumulated variables as arguments within the scope
 *
 * **Example**
 *
 * ```ts
 * import { Array, pipe } from "effect"
 *
 * const doResult = pipe(
 *   Array.Do,
 *   Array.bind("x", () => [1, 3, 5]),
 *   Array.bind("y", () => [2, 4, 6]),
 *   Array.filter(({ x, y }) => x < y), // condition
 *   Array.map(({ x, y }) => [x, y] as const) // transformation
 * )
 * console.log(doResult) // [[1, 2], [1, 4], [1, 6], [3, 4], [3, 6], [5, 6]]
 *
 * // equivalent
 * const x = [1, 3, 5],
 *       y = [2, 4, 6],
 *       result = [];
 * for(let i = 0; i < x.length; i++) {
 *   for(let j = 0; j < y.length; j++) {
 *     const _x = x[i], _y = y[j];
 *     if(_x < _y) result.push([_x, _y] as const)
 *   }
 * }
 * ```
 *
 * @see {@link bindTo}
 * @see {@link Do}
 * @see {@link let_ let}
 *
 * @category do notation
 * @since 3.2.0
 */
const bindTo = /*#__PURE__*/(/* unused pure expression or super */ null && (internalDoNotation.bindTo(Array_map)));
const let_ = /*#__PURE__*/(/* unused pure expression or super */ null && (internalDoNotation.let_(Array_map)));

//# sourceMappingURL=Array.js.map

/***/ }),

/***/ 53954:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CZ": function() { return /* binding */ Equivalence; },
/* harmony export */   "Fv": function() { return /* binding */ normalize; },
/* harmony export */   "Hv": function() { return /* binding */ isBigDecimal; },
/* harmony export */   "Ow": function() { return /* binding */ unsafeFromNumber; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "WU": function() { return /* binding */ format; },
/* harmony export */   "mL": function() { return /* binding */ fromString; },
/* harmony export */   "mn": function() { return /* binding */ unsafeToNumber; },
/* harmony export */   "nM": function() { return /* binding */ isNegative; },
/* harmony export */   "xP": function() { return /* binding */ isPositive; },
/* harmony export */   "xS": function() { return /* binding */ fromNumber; }
/* harmony export */ });
/* unused harmony exports TypeId, unsafeMakeNormalized, scale, sum, multiply, subtract, roundTerminal, divide, unsafeDivide, Order, lessThan, lessThanOrEqualTo, greaterThan, greaterThanOrEqualTo, between, clamp, min, max, sign, abs, negate, remainder, unsafeRemainder, equals, fromBigInt, safeFromNumber, unsafeFromString, toExponential, isInteger, isZero */
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67492);
/* harmony import */ var _Equivalence_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27786);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17316);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89379);
/* harmony import */ var _Inspectable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16371);
/* harmony import */ var _Option_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16749);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92817);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71335);
/**
 * This module provides utility functions and type class instances for working with the `BigDecimal` type in TypeScript.
 * It includes functions for basic arithmetic operations, as well as type class instances for `Equivalence` and `Order`.
 *
 * A `BigDecimal` allows storing any real number to arbitrary precision; which avoids common floating point errors
 * (such as 0.1 + 0.2 ≠ 0.3) at the cost of complexity.
 *
 * Internally, `BigDecimal` uses a `BigInt` object, paired with a 64-bit integer which determines the position of the
 * decimal point. Therefore, the precision *is not* actually arbitrary, but limited to 2<sup>63</sup> decimal places.
 *
 * It is not recommended to convert a floating point number to a decimal directly, as the floating point representation
 * may be unexpected.
 *
 * @module BigDecimal
 * @since 2.0.0
 * @see {@link module:BigInt} for more similar operations on `bigint` types
 * @see {@link module:Number} for more similar operations on `number` types
 */









const DEFAULT_PRECISION = 100;
const FINITE_INT_REGEX = /^[+-]?\d+$/;
/**
 * @since 2.0.0
 * @category symbols
 */
const TypeId = /*#__PURE__*/Symbol.for("effect/BigDecimal");
const BigDecimalProto = {
  [TypeId]: TypeId,
  [_Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .symbol */ .NA]() {
    const normalized = normalize(this);
    return (0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(_Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .hash */ .vp(normalized.value), _Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .combine */ .$e(_Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx(normalized.scale)), _Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .cached */ .HX(this));
  },
  [_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .symbol */ .NA](that) {
    return isBigDecimal(that) && equals(this, that);
  },
  toString() {
    return `BigDecimal(${format(this)})`;
  },
  toJSON() {
    return {
      _id: "BigDecimal",
      value: String(this.value),
      scale: this.scale
    };
  },
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_3__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  },
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_4__/* .pipeArguments */ .n)(this, arguments);
  }
};
/**
 * Checks if a given value is a `BigDecimal`.
 *
 * @since 2.0.0
 * @category guards
 */
const isBigDecimal = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_5__/* .hasProperty */ .l$)(u, TypeId);
/**
 * Creates a `BigDecimal` from a `bigint` value and a scale.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = (value, scale) => {
  const o = Object.create(BigDecimalProto);
  o.value = value;
  o.scale = scale;
  return o;
};
/**
 * Internal function used to create pre-normalized `BigDecimal`s.
 *
 * @internal
 */
const unsafeMakeNormalized = (value, scale) => {
  if (value !== bigint0 && value % bigint10 === bigint0) {
    throw new RangeError("Value must be normalized");
  }
  const o = make(value, scale);
  o.normalized = o;
  return o;
};
const bigint0 = /*#__PURE__*/BigInt(0);
const bigint1 = /*#__PURE__*/(/* unused pure expression or super */ null && (BigInt(1)));
const bigint10 = /*#__PURE__*/BigInt(10);
const zero = /*#__PURE__*/unsafeMakeNormalized(bigint0, 0);
/**
 * Normalizes a given `BigDecimal` by removing trailing zeros.
 *
 * **Example**
 *
 * ```ts
 * import * as assert from "node:assert"
 * import { normalize, make, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(normalize(unsafeFromString("123.00000")), normalize(make(123n, 0)))
 * assert.deepStrictEqual(normalize(unsafeFromString("12300000")), normalize(make(123n, -5)))
 * ```
 *
 * @since 2.0.0
 * @category scaling
 */
const normalize = self => {
  if (self.normalized === undefined) {
    if (self.value === bigint0) {
      self.normalized = zero;
    } else {
      const digits = `${self.value}`;
      let trail = 0;
      for (let i = digits.length - 1; i >= 0; i--) {
        if (digits[i] === "0") {
          trail++;
        } else {
          break;
        }
      }
      if (trail === 0) {
        self.normalized = self;
      }
      const value = BigInt(digits.substring(0, digits.length - trail));
      const scale = self.scale - trail;
      self.normalized = unsafeMakeNormalized(value, scale);
    }
  }
  return self.normalized;
};
/**
 * Scales a given `BigDecimal` to the specified scale.
 *
 * If the given scale is smaller than the current scale, the value will be rounded down to
 * the nearest integer.
 *
 * @since 2.0.0
 * @category scaling
 */
const scale = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, scale) => {
  if (scale > self.scale) {
    return make(self.value * bigint10 ** BigInt(scale - self.scale), scale);
  }
  if (scale < self.scale) {
    return make(self.value / bigint10 ** BigInt(self.scale - scale), scale);
  }
  return self;
});
/**
 * Provides an addition operation on `BigDecimal`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { sum, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(sum(unsafeFromString("2"), unsafeFromString("3")), unsafeFromString("5"))
 * ```
 *
 * @since 2.0.0
 * @category math
 */
const sum = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => {
  if (that.value === bigint0) {
    return self;
  }
  if (self.value === bigint0) {
    return that;
  }
  if (self.scale > that.scale) {
    return make(scale(that, self.scale).value + self.value, self.scale);
  }
  if (self.scale < that.scale) {
    return make(scale(self, that.scale).value + that.value, that.scale);
  }
  return make(self.value + that.value, self.scale);
})));
/**
 * Provides a multiplication operation on `BigDecimal`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { multiply, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(multiply(unsafeFromString("2"), unsafeFromString("3")), unsafeFromString("6"))
 * ```
 *
 * @since 2.0.0
 * @category math
 */
const multiply = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => {
  if (that.value === bigint0 || self.value === bigint0) {
    return zero;
  }
  return make(self.value * that.value, self.scale + that.scale);
})));
/**
 * Provides a subtraction operation on `BigDecimal`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { subtract, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(subtract(unsafeFromString("2"), unsafeFromString("3")), unsafeFromString("-1"))
 * ```
 *
 * @since 2.0.0
 * @category math
 */
const subtract = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => {
  if (that.value === bigint0) {
    return self;
  }
  if (self.value === bigint0) {
    return make(-that.value, that.scale);
  }
  if (self.scale > that.scale) {
    return make(self.value - scale(that, self.scale).value, self.scale);
  }
  if (self.scale < that.scale) {
    return make(scale(self, that.scale).value - that.value, that.scale);
  }
  return make(self.value - that.value, self.scale);
})));
/**
 * Internal function used for arbitrary precision division.
 */
const divideWithPrecision = (num, den, scale, precision) => {
  const numNegative = num < bigint0;
  const denNegative = den < bigint0;
  const negateResult = numNegative !== denNegative;
  num = numNegative ? -num : num;
  den = denNegative ? -den : den;
  // Shift digits until numerator is larger than denominator (set scale appropriately).
  while (num < den) {
    num *= bigint10;
    scale++;
  }
  // First division.
  let quotient = num / den;
  let remainder = num % den;
  if (remainder === bigint0) {
    // No remainder, return immediately.
    return make(negateResult ? -quotient : quotient, scale);
  }
  // The quotient is guaranteed to be non-negative at this point. No need to consider sign.
  let count = `${quotient}`.length;
  // Shift the remainder by 1 decimal; The quotient will be 1 digit upon next division.
  remainder *= bigint10;
  while (remainder !== bigint0 && count < precision) {
    const q = remainder / den;
    const r = remainder % den;
    quotient = quotient * bigint10 + q;
    remainder = r * bigint10;
    count++;
    scale++;
  }
  if (remainder !== bigint0) {
    // Round final number with remainder.
    quotient += roundTerminal(remainder / den);
  }
  return make(negateResult ? -quotient : quotient, scale);
};
/**
 * Internal function used for rounding.
 *
 * Returns 1 if the most significant digit is >= 5, otherwise 0.
 *
 * This is used after dividing a number by a power of ten and rounding the last digit.
 *
 * @internal
 */
const roundTerminal = n => {
  const pos = n >= bigint0 ? 0 : 1;
  return Number(`${n}`[pos]) < 5 ? bigint0 : bigint1;
};
/**
 * Provides a division operation on `BigDecimal`s.
 *
 * If the dividend is not a multiple of the divisor the result will be a `BigDecimal` value
 * which represents the integer division rounded down to the nearest integer.
 *
 * If the divisor is `0`, the result will be `None`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { BigDecimal, Option } from "effect"
 *
 * assert.deepStrictEqual(BigDecimal.divide(BigDecimal.unsafeFromString("6"), BigDecimal.unsafeFromString("3")), Option.some(BigDecimal.unsafeFromString("2")))
 * assert.deepStrictEqual(BigDecimal.divide(BigDecimal.unsafeFromString("6"), BigDecimal.unsafeFromString("4")), Option.some(BigDecimal.unsafeFromString("1.5")))
 * assert.deepStrictEqual(BigDecimal.divide(BigDecimal.unsafeFromString("6"), BigDecimal.unsafeFromString("0")), Option.none())
 * ```
 *
 * @since 2.0.0
 * @category math
 */
const divide = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => {
  if (that.value === bigint0) {
    return Option.none();
  }
  if (self.value === bigint0) {
    return Option.some(zero);
  }
  const scale = self.scale - that.scale;
  if (self.value === that.value) {
    return Option.some(make(bigint1, scale));
  }
  return Option.some(divideWithPrecision(self.value, that.value, scale, DEFAULT_PRECISION));
})));
/**
 * Provides an unsafe division operation on `BigDecimal`s.
 *
 * If the dividend is not a multiple of the divisor the result will be a `BigDecimal` value
 * which represents the integer division rounded down to the nearest integer.
 *
 * Throws a `RangeError` if the divisor is `0`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { unsafeDivide, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(unsafeDivide(unsafeFromString("6"), unsafeFromString("3")), unsafeFromString("2"))
 * assert.deepStrictEqual(unsafeDivide(unsafeFromString("6"), unsafeFromString("4")), unsafeFromString("1.5"))
 * ```
 *
 * @since 2.0.0
 * @category math
 */
const unsafeDivide = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => {
  if (that.value === bigint0) {
    throw new RangeError("Division by zero");
  }
  if (self.value === bigint0) {
    return zero;
  }
  const scale = self.scale - that.scale;
  if (self.value === that.value) {
    return make(bigint1, scale);
  }
  return divideWithPrecision(self.value, that.value, scale, DEFAULT_PRECISION);
})));
/**
 * @since 2.0.0
 * @category instances
 */
const Order = /*#__PURE__*/(/* unused pure expression or super */ null && (order.make((self, that) => {
  const scmp = order.number(sign(self), sign(that));
  if (scmp !== 0) {
    return scmp;
  }
  if (self.scale > that.scale) {
    return order.bigint(self.value, scale(that, self.scale).value);
  }
  if (self.scale < that.scale) {
    return order.bigint(scale(self, that.scale).value, that.value);
  }
  return order.bigint(self.value, that.value);
})));
/**
 * Returns `true` if the first argument is less than the second, otherwise `false`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { lessThan, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(lessThan(unsafeFromString("2"), unsafeFromString("3")), true)
 * assert.deepStrictEqual(lessThan(unsafeFromString("3"), unsafeFromString("3")), false)
 * assert.deepStrictEqual(lessThan(unsafeFromString("4"), unsafeFromString("3")), false)
 * ```
 *
 * @since 2.0.0
 * @category predicates
 */
const lessThan = /*#__PURE__*/(/* unused pure expression or super */ null && (order.lessThan(Order)));
/**
 * Checks if a given `BigDecimal` is less than or equal to the provided one.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { lessThanOrEqualTo, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(lessThanOrEqualTo(unsafeFromString("2"), unsafeFromString("3")), true)
 * assert.deepStrictEqual(lessThanOrEqualTo(unsafeFromString("3"), unsafeFromString("3")), true)
 * assert.deepStrictEqual(lessThanOrEqualTo(unsafeFromString("4"), unsafeFromString("3")), false)
 * ```
 *
 * @since 2.0.0
 * @category predicates
 */
const lessThanOrEqualTo = /*#__PURE__*/(/* unused pure expression or super */ null && (order.lessThanOrEqualTo(Order)));
/**
 * Returns `true` if the first argument is greater than the second, otherwise `false`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { greaterThan, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(greaterThan(unsafeFromString("2"), unsafeFromString("3")), false)
 * assert.deepStrictEqual(greaterThan(unsafeFromString("3"), unsafeFromString("3")), false)
 * assert.deepStrictEqual(greaterThan(unsafeFromString("4"), unsafeFromString("3")), true)
 * ```
 *
 * @since 2.0.0
 * @category predicates
 */
const greaterThan = /*#__PURE__*/(/* unused pure expression or super */ null && (order.greaterThan(Order)));
/**
 * Checks if a given `BigDecimal` is greater than or equal to the provided one.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { greaterThanOrEqualTo, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(greaterThanOrEqualTo(unsafeFromString("2"), unsafeFromString("3")), false)
 * assert.deepStrictEqual(greaterThanOrEqualTo(unsafeFromString("3"), unsafeFromString("3")), true)
 * assert.deepStrictEqual(greaterThanOrEqualTo(unsafeFromString("4"), unsafeFromString("3")), true)
 * ```
 *
 * @since 2.0.0
 * @category predicates
 */
const greaterThanOrEqualTo = /*#__PURE__*/(/* unused pure expression or super */ null && (order.greaterThanOrEqualTo(Order)));
/**
 * Checks if a `BigDecimal` is between a `minimum` and `maximum` value (inclusive).
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { BigDecimal } from "effect"
 *
 * const between = BigDecimal.between({
 *   minimum: BigDecimal.unsafeFromString("1"),
 *   maximum: BigDecimal.unsafeFromString("5") }
 * )
 *
 * assert.deepStrictEqual(between(BigDecimal.unsafeFromString("3")), true)
 * assert.deepStrictEqual(between(BigDecimal.unsafeFromString("0")), false)
 * assert.deepStrictEqual(between(BigDecimal.unsafeFromString("6")), false)
 * ```
 *
 * @since 2.0.0
 * @category predicates
 */
const between = /*#__PURE__*/(/* unused pure expression or super */ null && (order.between(Order)));
/**
 * Restricts the given `BigDecimal` to be within the range specified by the `minimum` and `maximum` values.
 *
 * - If the `BigDecimal` is less than the `minimum` value, the function returns the `minimum` value.
 * - If the `BigDecimal` is greater than the `maximum` value, the function returns the `maximum` value.
 * - Otherwise, it returns the original `BigDecimal`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { BigDecimal } from "effect"
 *
 * const clamp = BigDecimal.clamp({
 *   minimum: BigDecimal.unsafeFromString("1"),
 *   maximum: BigDecimal.unsafeFromString("5") }
 * )
 *
 * assert.deepStrictEqual(clamp(BigDecimal.unsafeFromString("3")), BigDecimal.unsafeFromString("3"))
 * assert.deepStrictEqual(clamp(BigDecimal.unsafeFromString("0")), BigDecimal.unsafeFromString("1"))
 * assert.deepStrictEqual(clamp(BigDecimal.unsafeFromString("6")), BigDecimal.unsafeFromString("5"))
 * ```
 *
 * @since 2.0.0
 * @category math
 */
const clamp = /*#__PURE__*/(/* unused pure expression or super */ null && (order.clamp(Order)));
/**
 * Returns the minimum between two `BigDecimal`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { min, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(min(unsafeFromString("2"), unsafeFromString("3")), unsafeFromString("2"))
 * ```
 *
 * @since 2.0.0
 * @category math
 */
const min = /*#__PURE__*/(/* unused pure expression or super */ null && (order.min(Order)));
/**
 * Returns the maximum between two `BigDecimal`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { max, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(max(unsafeFromString("2"), unsafeFromString("3")), unsafeFromString("3"))
 * ```
 *
 * @since 2.0.0
 * @category math
 */
const max = /*#__PURE__*/(/* unused pure expression or super */ null && (order.max(Order)));
/**
 * Determines the sign of a given `BigDecimal`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { sign, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(sign(unsafeFromString("-5")), -1)
 * assert.deepStrictEqual(sign(unsafeFromString("0")), 0)
 * assert.deepStrictEqual(sign(unsafeFromString("5")), 1)
 * ```
 *
 * @since 2.0.0
 * @category math
 */
const sign = n => n.value === bigint0 ? 0 : n.value < bigint0 ? -1 : 1;
/**
 * Determines the absolute value of a given `BigDecimal`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { abs, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(abs(unsafeFromString("-5")), unsafeFromString("5"))
 * assert.deepStrictEqual(abs(unsafeFromString("0")), unsafeFromString("0"))
 * assert.deepStrictEqual(abs(unsafeFromString("5")), unsafeFromString("5"))
 * ```
 *
 * @since 2.0.0
 * @category math
 */
const abs = n => n.value < bigint0 ? make(-n.value, n.scale) : n;
/**
 * Provides a negate operation on `BigDecimal`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { negate, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(negate(unsafeFromString("3")), unsafeFromString("-3"))
 * assert.deepStrictEqual(negate(unsafeFromString("-6")), unsafeFromString("6"))
 * ```
 *
 * @since 2.0.0
 * @category math
 */
const negate = n => make(-n.value, n.scale);
/**
 * Returns the remainder left over when one operand is divided by a second operand.
 *
 * If the divisor is `0`, the result will be `None`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { BigDecimal, Option } from "effect"
 *
 * assert.deepStrictEqual(BigDecimal.remainder(BigDecimal.unsafeFromString("2"), BigDecimal.unsafeFromString("2")), Option.some(BigDecimal.unsafeFromString("0")))
 * assert.deepStrictEqual(BigDecimal.remainder(BigDecimal.unsafeFromString("3"), BigDecimal.unsafeFromString("2")), Option.some(BigDecimal.unsafeFromString("1")))
 * assert.deepStrictEqual(BigDecimal.remainder(BigDecimal.unsafeFromString("-4"), BigDecimal.unsafeFromString("2")), Option.some(BigDecimal.unsafeFromString("0")))
 * ```
 *
 * @since 2.0.0
 * @category math
 */
const remainder = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, divisor) => {
  if (divisor.value === bigint0) {
    return Option.none();
  }
  const max = Math.max(self.scale, divisor.scale);
  return Option.some(make(scale(self, max).value % scale(divisor, max).value, max));
})));
/**
 * Returns the remainder left over when one operand is divided by a second operand.
 *
 * Throws a `RangeError` if the divisor is `0`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { unsafeRemainder, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(unsafeRemainder(unsafeFromString("2"), unsafeFromString("2")), unsafeFromString("0"))
 * assert.deepStrictEqual(unsafeRemainder(unsafeFromString("3"), unsafeFromString("2")), unsafeFromString("1"))
 * assert.deepStrictEqual(unsafeRemainder(unsafeFromString("-4"), unsafeFromString("2")), unsafeFromString("0"))
 * ```
 *
 * @since 2.0.0
 * @category math
 */
const unsafeRemainder = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, divisor) => {
  if (divisor.value === bigint0) {
    throw new RangeError("Division by zero");
  }
  const max = Math.max(self.scale, divisor.scale);
  return make(scale(self, max).value % scale(divisor, max).value, max);
})));
/**
 * @category instances
 * @since 2.0.0
 */
const Equivalence = /*#__PURE__*/_Equivalence_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .Sy((self, that) => {
  if (self.scale > that.scale) {
    return scale(that, self.scale).value === self.value;
  }
  if (self.scale < that.scale) {
    return scale(self, that.scale).value === that.value;
  }
  return self.value === that.value;
});
/**
 * Checks if two `BigDecimal`s are equal.
 *
 * @since 2.0.0
 * @category predicates
 */
const equals = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, that) => Equivalence(self, that));
/**
 * Creates a `BigDecimal` from a `bigint` value.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromBigInt = n => make(n, 0);
/**
 * Creates a `BigDecimal` from a `number` value.
 *
 * It is not recommended to convert a floating point number to a decimal directly,
 * as the floating point representation may be unexpected.
 *
 * Throws a `RangeError` if the number is not finite (`NaN`, `+Infinity` or `-Infinity`).
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { unsafeFromNumber, make } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(unsafeFromNumber(123), make(123n, 0))
 * assert.deepStrictEqual(unsafeFromNumber(123.456), make(123456n, 3))
 * ```
 *
 * @since 3.11.0
 * @category constructors
 */
const unsafeFromNumber = n => _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .getOrThrowWith */ .G$(safeFromNumber(n), () => new RangeError(`Number must be finite, got ${n}`));
/**
 * Creates a `BigDecimal` from a `number` value.
 *
 * It is not recommended to convert a floating point number to a decimal directly,
 * as the floating point representation may be unexpected.
 *
 * Throws a `RangeError` if the number is not finite (`NaN`, `+Infinity` or `-Infinity`).
 *
 * @since 2.0.0
 * @category constructors
 * @deprecated Use {@link unsafeFromNumber} instead.
 */
const fromNumber = unsafeFromNumber;
// TODO(4.0): Rename this to `fromNumber` after removing the current, unsafe implementation of `fromNumber`.
/**
 * Creates a `BigDecimal` from a `number` value.
 *
 * It is not recommended to convert a floating point number to a decimal directly,
 * as the floating point representation may be unexpected.
 *
 * Returns `None` if the number is not finite (`NaN`, `+Infinity` or `-Infinity`).
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { BigDecimal, Option } from "effect"
 *
 * assert.deepStrictEqual(BigDecimal.safeFromNumber(123), Option.some(BigDecimal.make(123n, 0)))
 * assert.deepStrictEqual(BigDecimal.safeFromNumber(123.456), Option.some(BigDecimal.make(123456n, 3)))
 * assert.deepStrictEqual(BigDecimal.safeFromNumber(Infinity), Option.none())
 * ```
 *
 * @since 3.11.0
 * @category constructors
 */
const safeFromNumber = n => {
  if (!Number.isFinite(n)) {
    return _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .none */ .YP();
  }
  const string = `${n}`;
  if (string.includes("e")) {
    return fromString(string);
  }
  const [lead, trail = ""] = string.split(".");
  return _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .some */ .G(make(BigInt(`${lead}${trail}`), trail.length));
};
/**
 * Parses a numerical `string` into a `BigDecimal`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { BigDecimal, Option } from "effect"
 *
 * assert.deepStrictEqual(BigDecimal.fromString("123"), Option.some(BigDecimal.make(123n, 0)))
 * assert.deepStrictEqual(BigDecimal.fromString("123.456"), Option.some(BigDecimal.make(123456n, 3)))
 * assert.deepStrictEqual(BigDecimal.fromString("123.abc"), Option.none())
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
const fromString = s => {
  if (s === "") {
    return _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .some */ .G(zero);
  }
  let base;
  let exp;
  const seperator = s.search(/[eE]/);
  if (seperator !== -1) {
    const trail = s.slice(seperator + 1);
    base = s.slice(0, seperator);
    exp = Number(trail);
    if (base === "" || !Number.isSafeInteger(exp) || !FINITE_INT_REGEX.test(trail)) {
      return _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .none */ .YP();
    }
  } else {
    base = s;
    exp = 0;
  }
  let digits;
  let offset;
  const dot = base.search(/\./);
  if (dot !== -1) {
    const lead = base.slice(0, dot);
    const trail = base.slice(dot + 1);
    digits = `${lead}${trail}`;
    offset = trail.length;
  } else {
    digits = base;
    offset = 0;
  }
  if (!FINITE_INT_REGEX.test(digits)) {
    return _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .none */ .YP();
  }
  const scale = offset - exp;
  if (!Number.isSafeInteger(scale)) {
    return _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .none */ .YP();
  }
  return _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .some */ .G(make(BigInt(digits), scale));
};
/**
 * Parses a numerical `string` into a `BigDecimal`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { unsafeFromString, make } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(unsafeFromString("123"), make(123n, 0))
 * assert.deepStrictEqual(unsafeFromString("123.456"), make(123456n, 3))
 * assert.throws(() => unsafeFromString("123.abc"))
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
const unsafeFromString = s => Option.getOrThrowWith(fromString(s), () => new Error("Invalid numerical string"));
/**
 * Formats a given `BigDecimal` as a `string`.
 *
 * If the scale of the `BigDecimal` is greater than or equal to 16, the `BigDecimal` will
 * be formatted in scientific notation.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { format, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(format(unsafeFromString("-5")), "-5")
 * assert.deepStrictEqual(format(unsafeFromString("123.456")), "123.456")
 * assert.deepStrictEqual(format(unsafeFromString("-0.00000123")), "-0.00000123")
 * ```
 *
 * @since 2.0.0
 * @category conversions
 */
const format = n => {
  const normalized = normalize(n);
  if (Math.abs(normalized.scale) >= 16) {
    return toExponential(normalized);
  }
  const negative = normalized.value < bigint0;
  const absolute = negative ? `${normalized.value}`.substring(1) : `${normalized.value}`;
  let before;
  let after;
  if (normalized.scale >= absolute.length) {
    before = "0";
    after = "0".repeat(normalized.scale - absolute.length) + absolute;
  } else {
    const location = absolute.length - normalized.scale;
    if (location > absolute.length) {
      const zeros = location - absolute.length;
      before = `${absolute}${"0".repeat(zeros)}`;
      after = "";
    } else {
      after = absolute.slice(location);
      before = absolute.slice(0, location);
    }
  }
  const complete = after === "" ? before : `${before}.${after}`;
  return negative ? `-${complete}` : complete;
};
/**
 * Formats a given `BigDecimal` as a `string` in scientific notation.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { toExponential, make } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(toExponential(make(123456n, -5)), "1.23456e+10")
 * ```
 *
 * @since 3.11.0
 * @category conversions
 */
const toExponential = n => {
  if (isZero(n)) {
    return "0e+0";
  }
  const normalized = normalize(n);
  const digits = `${abs(normalized).value}`;
  const head = digits.slice(0, 1);
  const tail = digits.slice(1);
  let output = `${isNegative(normalized) ? "-" : ""}${head}`;
  if (tail !== "") {
    output += `.${tail}`;
  }
  const exp = tail.length - normalized.scale;
  return `${output}e${exp >= 0 ? "+" : ""}${exp}`;
};
/**
 * Converts a `BigDecimal` to a `number`.
 *
 * This function will produce incorrect results if the `BigDecimal` exceeds the 64-bit range of a `number`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { unsafeToNumber, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(unsafeToNumber(unsafeFromString("123.456")), 123.456)
 * ```
 *
 * @since 2.0.0
 * @category conversions
 */
const unsafeToNumber = n => Number(format(n));
/**
 * Checks if a given `BigDecimal` is an integer.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isInteger, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(isInteger(unsafeFromString("0")), true)
 * assert.deepStrictEqual(isInteger(unsafeFromString("1")), true)
 * assert.deepStrictEqual(isInteger(unsafeFromString("1.1")), false)
 * ```
 *
 * @since 2.0.0
 * @category predicates
 */
const isInteger = n => normalize(n).scale <= 0;
/**
 * Checks if a given `BigDecimal` is `0`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isZero, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(isZero(unsafeFromString("0")), true)
 * assert.deepStrictEqual(isZero(unsafeFromString("1")), false)
 * ```
 *
 * @since 2.0.0
 * @category predicates
 */
const isZero = n => n.value === bigint0;
/**
 * Checks if a given `BigDecimal` is negative.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isNegative, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(isNegative(unsafeFromString("-1")), true)
 * assert.deepStrictEqual(isNegative(unsafeFromString("0")), false)
 * assert.deepStrictEqual(isNegative(unsafeFromString("1")), false)
 * ```
 *
 * @since 2.0.0
 * @category predicates
 */
const isNegative = n => n.value < bigint0;
/**
 * Checks if a given `BigDecimal` is positive.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isPositive, unsafeFromString } from "effect/BigDecimal"
 *
 * assert.deepStrictEqual(isPositive(unsafeFromString("-1")), false)
 * assert.deepStrictEqual(isPositive(unsafeFromString("0")), false)
 * assert.deepStrictEqual(isPositive(unsafeFromString("1")), true)
 * ```
 *
 * @since 2.0.0
 * @category predicates
 */
const isPositive = n => n.value > bigint0;
//# sourceMappingURL=BigDecimal.js.map

/***/ }),

/***/ 37787:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "He": function() { return /* binding */ toNumber; },
/* harmony export */   "Sm": function() { return /* binding */ sum; },
/* harmony export */   "mL": function() { return /* binding */ fromString; },
/* harmony export */   "xS": function() { return /* binding */ fromNumber; }
/* harmony export */ });
/* unused harmony exports isBigInt, multiply, subtract, divide, unsafeDivide, increment, decrement, Equivalence, Order, lessThan, lessThanOrEqualTo, greaterThan, greaterThanOrEqualTo, between, clamp, min, max, sign, abs, gcd, lcm, unsafeSqrt, sqrt, sumAll, multiplyAll */
/* harmony import */ var _Equivalence_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27786);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17316);
/* harmony import */ var _Option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16749);
/* harmony import */ var _Order_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51988);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71335);
/**
 * This module provides utility functions and type class instances for working with the `bigint` type in TypeScript.
 * It includes functions for basic arithmetic operations, as well as type class instances for
 * `Equivalence` and `Order`.
 *
 * @module BigInt
 * @since 2.0.0
 * @see {@link module:BigDecimal} for more similar operations on `BigDecimal` types
 * @see {@link module:Number} for more similar operations on `number` types
 */





const bigint0 = /*#__PURE__*/(/* unused pure expression or super */ null && (BigInt(0)));
const bigint1 = /*#__PURE__*/(/* unused pure expression or super */ null && (BigInt(1)));
const bigint2 = /*#__PURE__*/(/* unused pure expression or super */ null && (BigInt(2)));
/**
 * Tests if a value is a `bigint`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isBigInt } from "effect/BigInt"
 *
 * assert.deepStrictEqual(isBigInt(1n), true)
 * assert.deepStrictEqual(isBigInt(1), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isBigInt = _Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isBigInt */ .C4;
/**
 * Provides an addition operation on `bigint`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { sum } from "effect/BigInt"
 *
 * assert.deepStrictEqual(sum(2n, 3n), 5n)
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const sum = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, that) => self + that);
/**
 * Provides a multiplication operation on `bigint`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { multiply } from "effect/BigInt"
 *
 * assert.deepStrictEqual(multiply(2n, 3n), 6n)
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const multiply = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => self * that)));
/**
 * Provides a subtraction operation on `bigint`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { subtract } from "effect/BigInt"
 *
 * assert.deepStrictEqual(subtract(2n, 3n), -1n)
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const subtract = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => self - that)));
/**
 * Provides a division operation on `bigint`s.
 *
 * If the dividend is not a multiple of the divisor the result will be a `bigint` value
 * which represents the integer division rounded down to the nearest integer.
 *
 * Returns `None` if the divisor is `0n`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { BigInt, Option } from "effect"
 *
 * assert.deepStrictEqual(BigInt.divide(6n, 3n), Option.some(2n))
 * assert.deepStrictEqual(BigInt.divide(6n, 0n), Option.none())
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const divide = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => that === bigint0 ? Option.none() : Option.some(self / that))));
/**
 * Provides a division operation on `bigint`s.
 *
 * If the dividend is not a multiple of the divisor the result will be a `bigint` value
 * which represents the integer division rounded down to the nearest integer.
 *
 * Throws a `RangeError` if the divisor is `0n`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { unsafeDivide } from "effect/BigInt"
 *
 * assert.deepStrictEqual(unsafeDivide(6n, 3n), 2n)
 * assert.deepStrictEqual(unsafeDivide(6n, 4n), 1n)
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const unsafeDivide = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => self / that)));
/**
 * Returns the result of adding `1n` to a given number.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { increment } from "effect/BigInt"
 *
 * assert.deepStrictEqual(increment(2n), 3n)
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const increment = n => n + bigint1;
/**
 * Decrements a number by `1n`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { decrement } from "effect/BigInt"
 *
 * assert.deepStrictEqual(decrement(3n), 2n)
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const decrement = n => n - bigint1;
/**
 * @category instances
 * @since 2.0.0
 */
const Equivalence = _Equivalence_js__WEBPACK_IMPORTED_MODULE_2__/* .bigint */ .Kv;
/**
 * @category instances
 * @since 2.0.0
 */
const Order = _Order_js__WEBPACK_IMPORTED_MODULE_3__/* .bigint */ .Kv;
/**
 * Returns `true` if the first argument is less than the second, otherwise `false`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { lessThan } from "effect/BigInt"
 *
 * assert.deepStrictEqual(lessThan(2n, 3n), true)
 * assert.deepStrictEqual(lessThan(3n, 3n), false)
 * assert.deepStrictEqual(lessThan(4n, 3n), false)
 * ```
 *
 * @category predicates
 * @since 2.0.0
 */
const lessThan = /*#__PURE__*/(/* unused pure expression or super */ null && (order.lessThan(Order)));
/**
 * Returns a function that checks if a given `bigint` is less than or equal to the provided one.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { lessThanOrEqualTo } from "effect/BigInt"
 *
 * assert.deepStrictEqual(lessThanOrEqualTo(2n, 3n), true)
 * assert.deepStrictEqual(lessThanOrEqualTo(3n, 3n), true)
 * assert.deepStrictEqual(lessThanOrEqualTo(4n, 3n), false)
 * ```
 *
 * @category predicates
 * @since 2.0.0
 */
const lessThanOrEqualTo = /*#__PURE__*/(/* unused pure expression or super */ null && (order.lessThanOrEqualTo(Order)));
/**
 * Returns `true` if the first argument is greater than the second, otherwise `false`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { greaterThan } from "effect/BigInt"
 *
 * assert.deepStrictEqual(greaterThan(2n, 3n), false)
 * assert.deepStrictEqual(greaterThan(3n, 3n), false)
 * assert.deepStrictEqual(greaterThan(4n, 3n), true)
 * ```
 *
 * @category predicates
 * @since 2.0.0
 */
const greaterThan = /*#__PURE__*/(/* unused pure expression or super */ null && (order.greaterThan(Order)));
/**
 * Returns a function that checks if a given `bigint` is greater than or equal to the provided one.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { greaterThanOrEqualTo } from "effect/BigInt"
 *
 * assert.deepStrictEqual(greaterThanOrEqualTo(2n, 3n), false)
 * assert.deepStrictEqual(greaterThanOrEqualTo(3n, 3n), true)
 * assert.deepStrictEqual(greaterThanOrEqualTo(4n, 3n), true)
 * ```
 *
 * @category predicates
 * @since 2.0.0
 */
const greaterThanOrEqualTo = /*#__PURE__*/(/* unused pure expression or super */ null && (order.greaterThanOrEqualTo(Order)));
/**
 * Checks if a `bigint` is between a `minimum` and `maximum` value (inclusive).
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { BigInt } from "effect"
 *
 * const between = BigInt.between({ minimum: 0n, maximum: 5n })
 *
 * assert.deepStrictEqual(between(3n), true)
 * assert.deepStrictEqual(between(-1n), false)
 * assert.deepStrictEqual(between(6n), false)
 * ```
 *
 * @category predicates
 * @since 2.0.0
 */
const between = /*#__PURE__*/(/* unused pure expression or super */ null && (order.between(Order)));
/**
 * Restricts the given `bigint` to be within the range specified by the `minimum` and `maximum` values.
 *
 * - If the `bigint` is less than the `minimum` value, the function returns the `minimum` value.
 * - If the `bigint` is greater than the `maximum` value, the function returns the `maximum` value.
 * - Otherwise, it returns the original `bigint`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { BigInt } from "effect"
 *
 * const clamp = BigInt.clamp({ minimum: 1n, maximum: 5n })
 *
 * assert.equal(clamp(3n), 3n)
 * assert.equal(clamp(0n), 1n)
 * assert.equal(clamp(6n), 5n)
 * ```
 *
 * @since 2.0.0
 */
const clamp = /*#__PURE__*/(/* unused pure expression or super */ null && (order.clamp(Order)));
/**
 * Returns the minimum between two `bigint`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { min } from "effect/BigInt"
 *
 * assert.deepStrictEqual(min(2n, 3n), 2n)
 * ```
 *
 * @since 2.0.0
 */
const min = /*#__PURE__*/(/* unused pure expression or super */ null && (order.min(Order)));
/**
 * Returns the maximum between two `bigint`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { max } from "effect/BigInt"
 *
 * assert.deepStrictEqual(max(2n, 3n), 3n)
 * ```
 *
 * @since 2.0.0
 */
const max = /*#__PURE__*/(/* unused pure expression or super */ null && (order.max(Order)));
/**
 * Determines the sign of a given `bigint`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { sign } from "effect/BigInt"
 *
 * assert.deepStrictEqual(sign(-5n), -1)
 * assert.deepStrictEqual(sign(0n), 0)
 * assert.deepStrictEqual(sign(5n), 1)
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const sign = n => Order(n, bigint0);
/**
 * Determines the absolute value of a given `bigint`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { abs } from "effect/BigInt"
 *
 * assert.deepStrictEqual(abs(-5n), 5n)
 * assert.deepStrictEqual(abs(0n), 0n)
 * assert.deepStrictEqual(abs(5n), 5n)
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const abs = n => n < bigint0 ? -n : n;
/**
 * Determines the greatest common divisor of two `bigint`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { gcd } from "effect/BigInt"
 *
 * assert.deepStrictEqual(gcd(2n, 3n), 1n)
 * assert.deepStrictEqual(gcd(2n, 4n), 2n)
 * assert.deepStrictEqual(gcd(16n, 24n), 8n)
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const gcd = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => {
  while (that !== bigint0) {
    const t = that;
    that = self % that;
    self = t;
  }
  return self;
})));
/**
 * Determines the least common multiple of two `bigint`s.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { lcm } from "effect/BigInt"
 *
 * assert.deepStrictEqual(lcm(2n, 3n), 6n)
 * assert.deepStrictEqual(lcm(2n, 4n), 4n)
 * assert.deepStrictEqual(lcm(16n, 24n), 48n)
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const lcm = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => self * that / gcd(self, that))));
/**
 * Determines the square root of a given `bigint` unsafely. Throws if the given `bigint` is negative.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { unsafeSqrt } from "effect/BigInt"
 *
 * assert.deepStrictEqual(unsafeSqrt(4n), 2n)
 * assert.deepStrictEqual(unsafeSqrt(9n), 3n)
 * assert.deepStrictEqual(unsafeSqrt(16n), 4n)
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const unsafeSqrt = n => {
  if (n < bigint0) {
    throw new RangeError("Cannot take the square root of a negative number");
  }
  if (n < bigint2) {
    return n;
  }
  let x = n / bigint2;
  while (x * x > n) {
    x = (n / x + x) / bigint2;
  }
  return x;
};
/**
 * Determines the square root of a given `bigint` safely. Returns `none` if the given `bigint` is negative.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { BigInt, Option } from "effect"
 *
 * assert.deepStrictEqual(BigInt.sqrt(4n), Option.some(2n))
 * assert.deepStrictEqual(BigInt.sqrt(9n), Option.some(3n))
 * assert.deepStrictEqual(BigInt.sqrt(16n), Option.some(4n))
 * assert.deepStrictEqual(BigInt.sqrt(-1n), Option.none())
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const sqrt = n => greaterThanOrEqualTo(n, bigint0) ? Option.some(unsafeSqrt(n)) : Option.none();
/**
 * Takes an `Iterable` of `bigint`s and returns their sum as a single `bigint
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { sumAll } from "effect/BigInt"
 *
 * assert.deepStrictEqual(sumAll([2n, 3n, 4n]), 9n)
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const sumAll = collection => {
  let out = bigint0;
  for (const n of collection) {
    out += n;
  }
  return out;
};
/**
 * Takes an `Iterable` of `bigint`s and returns their multiplication as a single `number`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { multiplyAll } from "effect/BigInt"
 *
 * assert.deepStrictEqual(multiplyAll([2n, 3n, 4n]), 24n)
 * ```
 *
 * @category math
 * @since 2.0.0
 */
const multiplyAll = collection => {
  let out = bigint1;
  for (const n of collection) {
    if (n === bigint0) {
      return bigint0;
    }
    out *= n;
  }
  return out;
};
/**
 * Takes a `bigint` and returns an `Option` of `number`.
 *
 * If the `bigint` is outside the safe integer range for JavaScript (`Number.MAX_SAFE_INTEGER`
 * and `Number.MIN_SAFE_INTEGER`), it returns `Option.none()`. Otherwise, it converts the `bigint`
 * to a number and returns `Option.some(number)`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { BigInt as BI, Option } from "effect"
 *
 * assert.deepStrictEqual(BI.toNumber(BigInt(42)), Option.some(42))
 * assert.deepStrictEqual(BI.toNumber(BigInt(Number.MAX_SAFE_INTEGER) + BigInt(1)), Option.none())
 * assert.deepStrictEqual(BI.toNumber(BigInt(Number.MIN_SAFE_INTEGER) - BigInt(1)), Option.none())
 * ```
 *
 * @category conversions
 * @since 2.0.0
 */
const toNumber = b => {
  if (b > BigInt(Number.MAX_SAFE_INTEGER) || b < BigInt(Number.MIN_SAFE_INTEGER)) {
    return _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .none */ .YP();
  }
  return _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .some */ .G(Number(b));
};
/**
 * Takes a string and returns an `Option` of `bigint`.
 *
 * If the string is empty or contains characters that cannot be converted into a `bigint`,
 * it returns `Option.none()`, otherwise, it returns `Option.some(bigint)`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { BigInt as BI, Option } from "effect"
 *
 * assert.deepStrictEqual(BI.fromString("42"), Option.some(BigInt(42)))
 * assert.deepStrictEqual(BI.fromString(" "), Option.none())
 * assert.deepStrictEqual(BI.fromString("a"), Option.none())
 * ```
 *
 * @category conversions
 * @since 2.4.12
 */
const fromString = s => {
  try {
    return s.trim() === "" ? _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .none */ .YP() : _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .some */ .G(BigInt(s));
  } catch (_) {
    return _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .none */ .YP();
  }
};
/**
 * Takes a number and returns an `Option` of `bigint`.
 *
 * If the number is outside the safe integer range for JavaScript (`Number.MAX_SAFE_INTEGER`
 * and `Number.MIN_SAFE_INTEGER`), it returns `Option.none()`. Otherwise, it attempts to
 * convert the number to a `bigint` and returns `Option.some(bigint)`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { BigInt as BI, Option } from "effect"
 *
 * assert.deepStrictEqual(BI.fromNumber(42), Option.some(BigInt(42)))
 * assert.deepStrictEqual(BI.fromNumber(Number.MAX_SAFE_INTEGER + 1), Option.none())
 * assert.deepStrictEqual(BI.fromNumber(Number.MIN_SAFE_INTEGER - 1), Option.none())
 * ```
 *
 * @category conversions
 * @since 2.4.12
 */
const fromNumber = n => {
  if (n > Number.MAX_SAFE_INTEGER || n < Number.MIN_SAFE_INTEGER) {
    return _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .none */ .YP();
  }
  try {
    return _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .some */ .G(BigInt(n));
  } catch (_) {
    return _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .none */ .YP();
  }
};
//# sourceMappingURL=BigInt.js.map

/***/ }),

/***/ 49349:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ff": function() { return /* binding */ not; }
/* harmony export */ });
/* unused harmony exports isBoolean, match, Equivalence, Order, and, nand, or, nor, xor, eqv, implies, every, some */
/* harmony import */ var _Equivalence_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27786);
/* harmony import */ var _Order_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51988);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71335);
/**
 * This module provides utility functions and type class instances for working with the `boolean` type in TypeScript.
 * It includes functions for basic boolean operations, as well as type class instances for
 * `Equivalence` and `Order`.
 *
 * @since 2.0.0
 */




/**
 * Tests if a value is a `boolean`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isBoolean } from "effect/Boolean"
 *
 * assert.deepStrictEqual(isBoolean(true), true)
 * assert.deepStrictEqual(isBoolean("true"), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isBoolean = _Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isBoolean */ .jn;
/**
 * This function returns the result of either of the given functions depending on the value of the boolean parameter.
 * It is useful when you have to run one of two functions depending on the boolean value.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Boolean } from "effect"
 *
 * assert.deepStrictEqual(Boolean.match(true, { onFalse: () => "It's false!", onTrue: () => "It's true!" }), "It's true!")
 * ```
 *
 * @category pattern matching
 * @since 2.0.0
 */
const match = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (value, options) => value ? options.onTrue() : options.onFalse())));
/**
 * @category instances
 * @since 2.0.0
 */
const Equivalence = _Equivalence_js__WEBPACK_IMPORTED_MODULE_1__/* .boolean */ .O7;
/**
 * @category instances
 * @since 2.0.0
 */
const Order = _Order_js__WEBPACK_IMPORTED_MODULE_2__/* .boolean */ .O7;
/**
 * Negates the given boolean: `!self`
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { not } from "effect/Boolean"
 *
 * assert.deepStrictEqual(not(true), false)
 * assert.deepStrictEqual(not(false), true)
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const not = self => !self;
/**
 * Combines two boolean using AND: `self && that`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { and } from "effect/Boolean"
 *
 * assert.deepStrictEqual(and(true, true), true)
 * assert.deepStrictEqual(and(true, false), false)
 * assert.deepStrictEqual(and(false, true), false)
 * assert.deepStrictEqual(and(false, false), false)
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const and = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => self && that)));
/**
 * Combines two boolean using NAND: `!(self && that)`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { nand } from "effect/Boolean"
 *
 * assert.deepStrictEqual(nand(true, true), false)
 * assert.deepStrictEqual(nand(true, false), true)
 * assert.deepStrictEqual(nand(false, true), true)
 * assert.deepStrictEqual(nand(false, false), true)
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const nand = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => !(self && that))));
/**
 * Combines two boolean using OR: `self || that`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { or } from "effect/Boolean"
 *
 * assert.deepStrictEqual(or(true, true), true)
 * assert.deepStrictEqual(or(true, false), true)
 * assert.deepStrictEqual(or(false, true), true)
 * assert.deepStrictEqual(or(false, false), false)
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const or = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => self || that)));
/**
 * Combines two booleans using NOR: `!(self || that)`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { nor } from "effect/Boolean"
 *
 * assert.deepStrictEqual(nor(true, true), false)
 * assert.deepStrictEqual(nor(true, false), false)
 * assert.deepStrictEqual(nor(false, true), false)
 * assert.deepStrictEqual(nor(false, false), true)
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const nor = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => !(self || that))));
/**
 * Combines two booleans using XOR: `(!self && that) || (self && !that)`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { xor } from "effect/Boolean"
 *
 * assert.deepStrictEqual(xor(true, true), false)
 * assert.deepStrictEqual(xor(true, false), true)
 * assert.deepStrictEqual(xor(false, true), true)
 * assert.deepStrictEqual(xor(false, false), false)
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const xor = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => !self && that || self && !that)));
/**
 * Combines two booleans using EQV (aka XNOR): `!xor(self, that)`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { eqv } from "effect/Boolean"
 *
 * assert.deepStrictEqual(eqv(true, true), true)
 * assert.deepStrictEqual(eqv(true, false), false)
 * assert.deepStrictEqual(eqv(false, true), false)
 * assert.deepStrictEqual(eqv(false, false), true)
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const eqv = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => !xor(self, that))));
/**
 * Combines two booleans using an implication: `(!self || that)`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { implies } from "effect/Boolean"
 *
 * assert.deepStrictEqual(implies(true, true), true)
 * assert.deepStrictEqual(implies(true, false), false)
 * assert.deepStrictEqual(implies(false, true), true)
 * assert.deepStrictEqual(implies(false, false), true)
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const implies = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => self ? that : true)));
/**
 * This utility function is used to check if all the elements in a collection of boolean values are `true`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { every } from "effect/Boolean"
 *
 * assert.deepStrictEqual(every([true, true, true]), true)
 * assert.deepStrictEqual(every([true, false, true]), false)
 * ```
 *
 * @since 2.0.0
 */
const every = collection => {
  for (const b of collection) {
    if (!b) {
      return false;
    }
  }
  return true;
};
/**
 * This utility function is used to check if at least one of the elements in a collection of boolean values is `true`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { some } from "effect/Boolean"
 *
 * assert.deepStrictEqual(some([true, false, true]), true)
 * assert.deepStrictEqual(some([false, false, false]), false)
 * ```
 *
 * @since 2.0.0
 */
const some = collection => {
  for (const b of collection) {
    if (b) {
      return true;
    }
  }
  return false;
};
//# sourceMappingURL=Boolean.js.map

/***/ }),

/***/ 91115:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DA": function() { return /* binding */ isFailType; },
/* harmony export */   "IC": function() { return /* binding */ pretty; },
/* harmony export */   "Xr": function() { return /* binding */ die; },
/* harmony export */   "bG": function() { return /* binding */ fail; },
/* harmony export */   "hl": function() { return /* binding */ failureOrCause; },
/* harmony export */   "j5": function() { return /* binding */ IllegalArgumentException; }
/* harmony export */ });
/* unused harmony exports CauseTypeId, RuntimeExceptionTypeId, InterruptedExceptionTypeId, IllegalArgumentExceptionTypeId, NoSuchElementExceptionTypeId, InvalidPubSubCapacityExceptionTypeId, ExceededCapacityExceptionTypeId, TimeoutExceptionTypeId, UnknownExceptionTypeId, YieldableError, empty, interrupt, parallel, sequential, isCause, isEmptyType, isDieType, isInterruptType, isSequentialType, isParallelType, size, isEmpty, isFailure, isDie, isInterrupted, isInterruptedOnly, failures, defects, interruptors, failureOption, flipCauseOption, dieOption, interruptOption, keepDefects, linearize, stripFailures, stripSomeDefects, as, map, flatMap, andThen, flatten, contains, squash, squashWith, find, filter, match, reduce, reduceWithContext, InterruptedException, isInterruptedException, isIllegalArgumentException, NoSuchElementException, isNoSuchElementException, RuntimeException, isRuntimeException, TimeoutException, UnknownException, isUnknownException, ExceededCapacityException, isExceededCapacityException, prettyErrors, originalError */
/* harmony import */ var _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69579);
/* harmony import */ var _internal_core_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39355);


/**
 * A unique symbol identifying the `Cause` type.
 *
 * **Details**
 *
 * This provides a symbol that helps identify instances of the `Cause` data
 * type. This can be used for advanced operations such as refining types or
 * building internal utilities that check whether an unknown value is a `Cause`.
 *
 * @see {@link isCause} Check if a value is a `Cause`
 *
 * @since 2.0.0
 * @category Symbols
 */
const CauseTypeId = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .CauseTypeId */ .Gt;
/**
 * A unique symbol identifying the `RuntimeException` type.
 *
 * **Details**
 *
 * This provides a symbol that identifies a `RuntimeException`. This is
 * typically used internally by the library to recognize checked exceptions that
 * occur during runtime.
 *
 * @see {@link RuntimeException} Create or work with a `RuntimeException`
 *
 * @since 2.0.0
 * @category Symbols
 */
const RuntimeExceptionTypeId = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .RuntimeExceptionTypeId */ .m_5;
/**
 * A unique symbol identifying the `InterruptedException` type.
 *
 * **Details**
 *
 * This provides a symbol that identifies an `InterruptedException`. This is
 * typically used internally to recognize when a fiber has been interrupted,
 * helping the framework handle interruption logic correctly.
 *
 * @see {@link InterruptedException} Create or work with an `InterruptedException`
 *
 * @since 2.0.0
 * @category Symbols
 */
const InterruptedExceptionTypeId = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .InterruptedExceptionTypeId */ .n67;
/**
 * A unique symbol identifying the `IllegalArgumentException` type.
 *
 * **Details**
 *
 * This provides a symbol that identifies an `IllegalArgumentException`. This is
 * often used in scenarios where invalid arguments are supplied to methods that
 * expect specific input.
 *
 * @see {@link IllegalArgumentException} Create or work with an `IllegalArgumentException`
 *
 * @since 2.0.0
 * @category Symbols
 */
const IllegalArgumentExceptionTypeId = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .IllegalArgumentExceptionTypeId */ .RHV;
/**
 * A unique symbol identifying the `NoSuchElementException` type.
 *
 * **Details**
 *
 * This provides a symbol that identifies a `NoSuchElementException`. It helps
 * differentiate cases where a required element is missing within a data
 * structure.
 *
 * @see {@link NoSuchElementException} Create or work with a `NoSuchElementException`
 *
 * @since 2.0.0
 * @category Symbols
 */
const NoSuchElementExceptionTypeId = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .NoSuchElementExceptionTypeId */ .qM6;
/**
 * A unique symbol identifying the `InvalidPubSubCapacityException` type.
 *
 * **Details**
 *
 * This provides a symbol that identifies an `InvalidPubSubCapacityException`.
 * It indicates an error related to an invalid capacity passed to a `PubSub`
 * structure.
 *
 * @see {@link InvalidPubSubCapacityException} Create or work with an `InvalidPubSubCapacityException`
 *
 * @since 2.0.0
 * @category Symbols
 */
const InvalidPubSubCapacityExceptionTypeId = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .InvalidPubSubCapacityExceptionTypeId */ .nYm;
/**
 * A unique symbol identifying the `ExceededCapacityException` type.
 *
 * **Details**
 *
 * This provides a symbol that identifies an `ExceededCapacityException`. It
 * denotes situations where a resource has exceeded its configured capacity
 * limit.
 *
 * @see {@link ExceededCapacityException} Create or work with an `ExceededCapacityException`
 *
 * @since 3.5.0
 * @category Symbols
 */
const ExceededCapacityExceptionTypeId = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .ExceededCapacityExceptionTypeId */ .Zc0;
/**
 * A unique symbol identifying the `TimeoutException` type.
 *
 * **Details**
 *
 * This provides a symbol that identifies a `TimeoutException`. It helps the
 * framework recognize errors related to operations that fail to complete within
 * a given timeframe.
 *
 * @see {@link TimeoutException} Create or work with a `TimeoutException`
 *
 * @since 2.0.0
 * @category Symbols
 */
const TimeoutExceptionTypeId = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .TimeoutExceptionTypeId */ .zMc;
/**
 * A unique symbol identifying the `UnknownException` type.
 *
 * **Details**
 *
 * This provides a symbol that identifies an `UnknownException`. It is typically
 * used for generic or unexpected errors that do not fit other specific
 * exception categories.
 *
 * @see {@link UnknownException} Create or work with an `UnknownException`
 *
 * @since 2.0.0
 * @category Symbols
 */
const UnknownExceptionTypeId = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .UnknownExceptionTypeId */ .eQB;
/**
 * Creates an error that occurs at runtime, extendable for other exception
 * types.
 *
 * @since 2.0.0
 * @category Errors
 */
const YieldableError = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .YieldableError */ .LJp;
/**
 * Creates an `Empty` cause.
 *
 * **Details**
 *
 * This function returns a cause that signifies "no error." It's commonly used
 * to represent an absence of failure conditions.
 *
 * @see {@link isEmpty} Check if a `Cause` is empty
 *
 * @since 2.0.0
 * @category Constructors
 */
const empty = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .empty */ .cS;
/**
 * Creates a `Fail` cause from an expected error.
 *
 * **Details**
 *
 * This function constructs a `Cause` carrying an error of type `E`. It's used
 * when you want to represent a known or anticipated failure in your effectful
 * computations.
 *
 * @see {@link isFailure} Check if a `Cause` contains a failure
 *
 * @since 2.0.0
 * @category Constructors
 */
const fail = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .fail */ .bG;
/**
 * Creates a `Die` cause from an unexpected error.
 *
 * **Details**
 *
 * This function wraps an unhandled or unknown defect (like a runtime crash)
 * into a `Cause`. It's useful for capturing unforeseen issues in a structured
 * way.
 *
 * @see {@link isDie} Check if a `Cause` contains a defect
 *
 * @since 2.0.0
 * @category Constructors
 */
const die = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .die */ .Xr;
/**
 * Creates an `Interrupt` cause from a `FiberId`.
 *
 * **Details**
 *
 * This function represents a fiber that has been interrupted. It stores the
 * identifier of the interrupted fiber, enabling precise tracking of concurrent
 * cancellations.
 *
 * @see {@link isInterrupted} Check if a `Cause` contains an interruption
 *
 * @since 2.0.0
 * @category Constructors
 */
const interrupt = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .interrupt */ .e1;
/**
 * Combines two `Cause`s in parallel.
 *
 * **Details**
 *
 * This function merges two errors that occurred simultaneously. Instead of
 * discarding one error, both are retained, allowing for richer error reporting
 * and debugging.
 *
 * @see {@link isParallelType} Check if a `Cause` is a `Parallel`
 *
 * @since 2.0.0
 * @category Constructors
 */
const parallel = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .parallel */ .Mf;
/**
 * Combines two `Cause`s sequentially.
 *
 * **Details**
 *
 * This function merges two errors that occurred in sequence, such as a main
 * error followed by a finalization error. It preserves both errors for complete
 * failure information.
 *
 * @see {@link isSequentialType} Check if a `Cause` is a `Sequential`
 *
 * @since 2.0.0
 * @category Constructors
 */
const sequential = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .sequential */ .Pe;
/**
 * Checks if a value is a `Cause`.
 *
 * @since 2.0.0
 * @category Guards
 */
const isCause = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .isCause */ .m_;
/**
 * Checks if a `Cause` is an `Empty` type.
 *
 * @see {@link empty} Create a new `Empty` cause
 *
 * @since 2.0.0
 * @category Guards
 */
const isEmptyType = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .isEmptyType */ .tg;
/**
 * Checks if a `Cause` is a `Fail` type.
 *
 * @see {@link fail} Create a new `Fail` cause
 *
 * @since 2.0.0
 * @category Guards
 */
const isFailType = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .isFailType */ .DA;
/**
 * Checks if a `Cause` is a `Die` type.
 *
 * @see {@link die} Create a new `Die` cause
 *
 * @since 2.0.0
 * @category Guards
 */
const isDieType = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .isDieType */ .QV;
/**
 * Checks if a `Cause` is an `Interrupt` type.
 *
 * @see {@link interrupt} Create an `Interrupt` cause
 *
 * @since 2.0.0
 * @category Guards
 */
const isInterruptType = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .isInterruptType */ .cb;
/**
 * Checks if a `Cause` is a `Sequential` type.
 *
 * @see {@link sequential} Combine two `Cause`s sequentially
 *
 * @since 2.0.0
 * @category Guards
 */
const isSequentialType = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .isSequentialType */ .F8;
/**
 * Checks if a `Cause` is a `Parallel` type.
 *
 * @see {@link parallel} Combine two `Cause`s in parallel
 *
 * @since 2.0.0
 * @category Guards
 */
const isParallelType = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .isParallelType */ .v2;
/**
 * Calculates the size of a `Cause`.
 *
 * **Details**
 *
 * This function returns the total number of `Cause` nodes in the semiring
 * structure, reflecting how many individual error elements are recorded.
 *
 * @since 2.0.0
 * @category Getters
 */
const size = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .size */ .dp;
/**
 * Checks if a `Cause` is entirely empty.
 *
 * **Details**
 *
 * This function returns `true` if the `Cause` contains no errors, defects, or
 * interruptions. It's helpful for verifying if a computation truly had no
 * failures.
 *
 * @since 2.0.0
 * @category Getters
 */
const isEmpty = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .isEmpty */ .xb;
/**
 * Checks if a `Cause` contains a failure.
 *
 * **Details**
 *
 * This function returns `true` if the `Cause` includes any `Fail` error. It's
 * commonly used to confirm whether a workflow encountered an anticipated error
 * versus just defects or interruptions.
 *
 * @since 2.0.0
 * @category Getters
 */
const isFailure = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .isFailure */ .hx;
/**
 * Checks if a `Cause` contains a defect.
 *
 * **Details**
 *
 * This function returns `true` if the `Cause` includes any unexpected or
 * unhandled errors (`Die`). It's useful for differentiating known failures from
 * unexpected ones.
 *
 * @since 2.0.0
 * @category Getters
 */
const isDie = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .isDie */ .Ux;
/**
 * Checks if a `Cause` contains an interruption.
 *
 * **Details**
 *
 * This function returns `true` if the `Cause` includes any fiber interruptions.
 *
 * @since 2.0.0
 * @category Getters
 */
const isInterrupted = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .isInterrupted */ .td;
/**
 * Checks if a `Cause` contains only interruptions.
 *
 * **Details**
 *
 * This function returns `true` if the `Cause` has been interrupted but does not
 * contain any other failures, such as `Fail` or `Die`. It's helpful for
 * verifying purely "cancellation" scenarios.
 *
 * @since 2.0.0
 * @category Getters
 */
const isInterruptedOnly = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .isInterruptedOnly */ .Jq;
/**
 * Extracts all recoverable errors of type `E` from a `Cause`.
 *
 * **Details**
 *
 * This function returns a chunk of errors, providing a list of all `Fail`
 * values found in the cause. It's useful for collecting all known failures for
 * logging or combined error handling.
 *
 * @since 2.0.0
 * @category Getters
 */
const failures = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .failures */ .mq;
/**
 * Extracts all unrecoverable defects from a `Cause`.
 *
 * **Details**
 *
 * This function returns a chunk of values representing unexpected errors
 * (`Die`). It's handy for capturing or logging unanticipated failures that
 * might need special handling, such as bug reports.
 *
 * @since 2.0.0
 * @category Getters
 */
const defects = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .defects */ .B4;
/**
 * Collects all `FiberId`s responsible for interrupting a fiber.
 *
 * **Details**
 *
 * This function returns a set of IDs indicating which fibers caused
 * interruptions within this `Cause`. It's useful for debugging concurrency
 * issues or tracing cancellations.
 *
 * @since 2.0.0
 * @category Getters
 */
const interruptors = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .interruptors */ .l7;
/**
 * Retrieves the first `Fail` error in a `Cause`, if present.
 *
 * **Details**
 *
 * This function returns an `Option` containing the first recoverable error
 * (`E`) from the cause. It's often used to quickly check if there's a primary
 * error to handle or display.
 *
 * @since 2.0.0
 * @category Getters
 */
const failureOption = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .failureOption */ .Iv;
/**
 * Splits a `Cause` into either its first `Fail` error or the rest of the cause
 * (which might only contain `Die` or `Interrupt`).
 *
 * **Details**
 *
 * This function either returns the checked error (`E`) or the remaining
 * `Cause<never>` with defects/interruptions. It helps you decide if there's a
 * recoverable path or if only unhandled issues remain.
 *
 * @since 2.0.0
 * @category Getters
 */
const failureOrCause = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .failureOrCause */ .hl;
/**
 * Strips out failures with an error of `None` from a `Cause<Option<E>>`.
 *
 * **Details**
 *
 * This function turns a `Cause<Option<E>>` into an `Option<Cause<E>>`. If the
 * cause only contains failures of `None`, it becomes `None`; otherwise, it
 * returns a `Cause` of the remaining errors. It's helpful when working with
 * optional errors and filtering out certain error paths.
 *
 * @since 2.0.0
 * @category Getters
 */
const flipCauseOption = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .flipCauseOption */ .kR;
/**
 * Retrieves the first `Die` defect in a `Cause`, if present.
 *
 * **Details**
 *
 * This function returns an `Option` containing the first unexpected failure
 * (`Die`) discovered. It's helpful for diagnosing the primary defect in a chain
 * of errors.
 *
 * @since 2.0.0
 * @category Getters
 */
const dieOption = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .dieOption */ .q9;
/**
 * Retrieves the first `Interrupt` in a `Cause`, if present.
 *
 * **Details**
 *
 * This function returns an `Option` with the first fiber interruption
 * discovered. This is particularly useful for concurrency analysis or debugging
 * cancellations.
 *
 * @since 2.0.0
 * @category Getters
 */
const interruptOption = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .interruptOption */ .$A;
/**
 * Removes all `Fail` and `Interrupt` nodes, keeping only defects (`Die`) in a
 * `Cause`.
 *
 * **Details**
 *
 * This function strips a cause of recoverable errors and interruptions, leaving
 * only unexpected failures. If no defects remain, it returns `None`. It's
 * valuable for focusing only on unanticipated problems when both known errors
 * and defects could occur.
 *
 * @since 2.0.0
 * @category Getters
 */
const keepDefects = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .keepDefects */ .tE;
// TODO(4.0): remove? what's the point of this API?
/**
 * Linearizes a `Cause` into a set of parallel causes, each containing a
 * sequential chain of failures.
 *
 * **Details**
 *
 * This function reorganizes the cause structure so that you can analyze each
 * parallel branch separately, even if they have multiple sequential errors.
 *
 * @since 2.0.0
 * @category Getters
 */
const linearize = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .linearize */ .Kk;
/**
 * Removes `Fail` and `Interrupt` nodes from a `Cause`, keeping only defects
 * (`Die`).
 *
 * **Details**
 *
 * This function is similar to `keepDefects` but returns a `Cause<never>`
 * directly, which can still store `Die` or finalizer-related defects. It's
 * helpful for analyzing only the irrecoverable portion of the error.
 *
 * @since 2.0.0
 * @category Getters
 */
const stripFailures = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .stripFailures */ .ly;
/**
 * Removes matching defects from a `Cause` using a partial function, returning
 * the remainder.
 *
 * **Details**
 *
 * This function applies a user-defined extraction function to each defect
 * (`Die`). If the function matches the defect, that defect is removed. If all
 * defects match, the result is `None`. Otherwise, you get a `Cause` with the
 * unmatched defects.
 *
 * @since 2.0.0
 * @category Getters
 */
const stripSomeDefects = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .stripSomeDefects */ .VO;
/**
 * Replaces any errors in a `Cause` with a provided constant error.
 *
 * **Details**
 *
 * This function transforms all `Fail` errors into the specified error value,
 * preserving the structure of the `Cause`. It's useful when you no longer need
 * the original error details but still want to keep the cause shape.
 *
 * @see {@link map} Apply a custom transformation to `Fail` errors
 *
 * @since 2.0.0
 * @category Mapping
 */
const as = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__.as;
/**
 * Transforms the errors in a `Cause` using a user-provided function.
 *
 * **Details**
 *
 * This function applies `f` to each `Fail` error while leaving defects (`Die`)
 * and interruptions untouched. It's useful for changing or simplifying error
 * types in your effectful workflows.
 *
 * @see {@link as} Replace errors with a single constant
 *
 * @since 2.0.0
 * @category Mapping
 */
const map = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI;
/**
 * Transforms errors in a `Cause` into new causes.
 *
 * **Details**
 *
 * This function applies a function `f` to each `Fail` error, converting it into
 * a new `Cause`. This is especially powerful for merging or restructuring error
 * types while preserving or combining cause information.
 *
 * @see {@link map} Apply a simpler transformation to errors
 *
 * @since 2.0.0
 * @category Sequencing
 */
const flatMap = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VS;
/**
 * Sequences two `Cause`s. The second `Cause` can be dependent on the result of
 * the first `Cause`.
 *
 * @since 2.0.0
 * @category Sequencing
 */
const andThen = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .andThen */ .Po;
/**
 * Flattens a nested `Cause` structure.
 *
 * **Details**
 *
 * This function takes a `Cause<Cause<E>>` and merges the layers into a single
 * `Cause<E>`. It's useful for eliminating additional nesting created by
 * repeated transformations or compositions.
 *
 * @see {@link flatMap} Compose nested causes
 *
 * @since 2.0.0
 * @category Sequencing
 */
const flatten = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .flatten */ .xH;
/**
 * Checks if the current `Cause` contains or is equal to another `Cause`.
 *
 * **Details**
 *
 * This function returns `true` if `that` cause is part of or the same as
 * the current `Cause`. It's useful when you need to check for specific
 * error patterns or deduplicate repeated failures.
 *
 * @since 2.0.0
 * @category Elements
 */
const contains = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .contains */ .r3;
/**
 * Extracts the most "important" defect from a `Cause`.
 *
 * **Details**
 *
 * This function reduces a `Cause` to a single, prioritized defect. It evaluates
 * the `Cause` in the following order of priority:
 *
 * 1. If the `Cause` contains a failure (e.g., from `Effect.fail`), it returns
 *    the raw error value.
 * 2. If there is no failure, it looks for the first defect (e.g., from
 *    `Effect.die`).
 * 3. If neither of the above is present, and the `Cause` stems from an
 *    interruption, it creates and returns an `InterruptedException`.
 *
 * This function ensures you can always extract a meaningful representation of
 * the primary issue from a potentially complex `Cause` structure.
 *
 * **When to Use**
 *
 * Use this function when you need to extract the most relevant error or defect
 * from a `Cause`, especially in scenarios where multiple errors or defects may
 * be present. It's particularly useful for simplifying error reporting or
 * logging.
 *
 * @see {@link squashWith} Allows transforming failures into defects when squashing.
 *
 * @since 2.0.0
 * @category Destructors
 */
const squash = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .causeSquash */ .USh;
/**
 * Extracts the most "important" defect from a `Cause`, transforming failures
 * into defects using a provided function.
 *
 * **Details**
 *
 * This function reduces a `Cause` to a single, prioritized defect, while
 * allowing you to transform recoverable failures into defects through a custom
 * function. It processes the `Cause` in the following order:
 *
 * 1. If the `Cause` contains a failure (e.g., from `Effect.fail`), it applies
 *    the provided function `f` to the error to transform it into a defect.
 * 2. If there is no failure, it looks for the first defect (e.g., from
 *    `Effect.die`) and returns it.
 * 3. If neither is present and the `Cause` stems from an interruption, it
 *    returns an `InterruptedException`.
 *
 * This function is particularly useful when you need custom handling or
 * transformation of errors while processing a `Cause`.
 *
 * @see {@link squash} Extracts the most "important" defect without transforming failures.
 *
 * @since 2.0.0
 * @category Destructors
 */
const squashWith = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .causeSquashWith */ .WnW;
/**
 * Searches a `Cause` using a partial function to extract information.
 *
 * **Details**
 *
 * This function allows you to search through a `Cause` using a custom partial
 * function. The partial function is applied to the `Cause`, and if it matches,
 * the result is returned wrapped in a `Some`. If no match is found, the result
 * is `None`.
 *
 * This is particularly useful when you are only interested in specific types of
 * errors, defects, or interruption causes within a potentially complex `Cause`
 * structure. By leveraging a partial function, you can focus on extracting only
 * the relevant information you care about.
 *
 * The partial function should return an `Option` indicating whether it matched
 * and the value it extracted.
 *
 * @since 2.0.0
 * @category Elements
 */
const find = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .find */ .sE;
/**
 * Preserves parts of a `Cause` that match a given predicate.
 *
 * **Details**
 *
 * This function allows you to retain only the parts of a `Cause` structure that
 * match a specified predicate or refinement. Any parts of the `Cause` that do
 * not match the provided condition are excluded from the result.
 *
 * You can use this function in two ways:
 * - With a `Predicate`: A function that evaluates whether a `Cause` should be
 *   retained based on its value.
 * - With a `Refinement`: A more specific predicate that can refine the type of
 *   the `Cause`.
 *
 * This is useful when you need to extract specific types of errors, defects, or
 * interruptions from a `Cause` while discarding unrelated parts.
 *
 * @since 2.0.0
 * @category Filtering
 */
const filter = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .filter */ .hX;
/**
 * Transforms a `Cause` into a single value using custom handlers for each
 * possible case.
 *
 * **Details**
 *
 * This function processes a `Cause` by applying a set of custom handlers to
 * each possible type of cause: `Empty`, `Fail`, `Die`, `Interrupt`,
 * `Sequential`, and `Parallel`. The result of this function is a single value
 * of type `Z`. This function allows you to define exactly how to handle each
 * part of a `Cause`, whether it's a failure, defect, interruption, or a
 * combination of these.
 *
 * The options parameter provides handlers for:
 * - `onEmpty`: Handles the case where the cause is `Empty`, meaning no errors
 *   occurred.
 * - `onFail`: Processes a failure with an error of type `E`.
 * - `onDie`: Processes a defect (unexpected error).
 * - `onInterrupt`: Handles a fiber interruption, providing the `FiberId` of the
 *   interruption.
 * - `onSequential`: Combines two sequential causes into a single value of type
 *   `Z`.
 * - `onParallel`: Combines two parallel causes into a single value of type `Z`.
 *
 * @since 2.0.0
 * @category Matching
 */
const match = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .match */ .EQ;
/**
 * Combines all parts of a `Cause` into a single value by starting with an
 * initial value.
 *
 * **Details**
 *
 * This function processes a `Cause` by starting with an initial value (`zero`)
 * and applying a custom function (`pf`) to combine all elements of the `Cause`
 * into a single result of type `Z`. The custom function determines how each
 * part of the `Cause` contributes to the final result. The function can return
 * an `Option` to either continue combining values or skip specific parts of the
 * `Cause`.
 *
 * This function is useful for tasks such as:
 * - Aggregating error messages from a `Cause` into a single string.
 * - Summarizing the structure of a `Cause` into a simplified result.
 * - Filtering or processing only specific parts of a `Cause`.
 *
 * The reduction proceeds in a top-down manner, visiting all nodes in the
 * `Cause` structure. This gives you complete control over how each part of the
 * `Cause` contributes to the final result.
 *
 * @since 2.0.0
 * @category Reducing
 */
const reduce = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .reduce */ .u4;
/**
 * Combines all parts of a `Cause` into a single value using a custom reducer
 * and a context.
 *
 * **Details**
 *
 * This function allows you to reduce a `Cause` into a single value of type `Z`
 * using a custom `CauseReducer`. A `CauseReducer` provides methods to handle
 * specific parts of the `Cause`, such as failures, defects, or interruptions.
 * Additionally, this function provides access to a `context` value, which can
 * be used to carry information or maintain state during the reduction process.
 *
 * This is particularly useful when the reduction process needs additional
 * context or configuration, such as:
 * - Aggregating error details with dynamic formatting.
 * - Collecting logs or statistics about the `Cause`.
 * - Performing stateful transformations based on the `context`.
 *
 * @see {@link reduce} To reduce a `Cause` without additional context.
 *
 * @since 2.0.0
 * @category Reducing
 */
const reduceWithContext = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .reduceWithContext */ .g3;
/**
 * Creates an error that indicates a `Fiber` was interrupted.
 *
 * **Details**
 *
 * This function constructs an `InterruptedException` recognized by the Effect
 * runtime. It is usually thrown or returned when a fiber's execution is
 * interrupted by external events or by another fiber. This is particularly
 * helpful in concurrent programs where fibers may halt each other before
 * completion.
 *
 * @since 2.0.0
 * @category Errors
 */
const InterruptedException = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .InterruptedException */ .rLI;
/**
 * Checks if a given unknown value is an `InterruptedException`.
 *
 * @since 2.0.0
 * @category Guards
 */
const isInterruptedException = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .isInterruptedException */ .lNG;
/**
 * Creates an error indicating an invalid method argument.
 *
 * **Details**
 *
 * This function constructs an `IllegalArgumentException`. It is typically
 * thrown or returned when an operation receives improper inputs, such as
 * out-of-range values or invalid object states.
 *
 * @since 2.0.0
 * @category Errors
 */
const IllegalArgumentException = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .IllegalArgumentException */ .j5q;
/**
 * Checks if a given unknown value is an `IllegalArgumentException`.
 *
 * @since 2.0.0
 * @category Guards
 */
const isIllegalArgumentException = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .isIllegalArgumentException */ .jNB;
/**
 * Creates an error indicating a missing element.
 *
 * **Details**
 *
 * This function constructs a `NoSuchElementException`. It helps you clearly
 * communicate that a required element is unavailable.
 *
 * @since 2.0.0
 * @category Errors
 */
const NoSuchElementException = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .NoSuchElementException */ .buj;
/**
 * Checks if a given unknown value is a `NoSuchElementException`.
 *
 * @since 2.0.0
 * @category Guards
 */
const isNoSuchElementException = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .isNoSuchElementException */ .nNR;
/**
 * Creates an error for general runtime errors.
 *
 * **Details**
 *
 * This function constructs a `RuntimeException`, for errors that occur at
 * runtime but are not specifically typed or categorized as interruptions,
 * missing elements, or invalid arguments. It helps unify a wide range of
 * unexpected conditions under a single, recognizable error type.
 *
 * @since 2.0.0
 * @category Errors
 */
const RuntimeException = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .RuntimeException */ .OZu;
/**
 * Checks if a given unknown value is a `RuntimeException`.
 *
 * @since 2.0.0
 * @category Guards
 */
const isRuntimeException = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .isRuntimeException */ .Gp9;
/**
 * Creates an error for operations that exceed their expected time.
 *
 * **Details**
 *
 * This function constructs a `TimeoutException`. It is typically used to signal
 * that an operation or fiber did not complete within a designated time limit,
 * allowing you to handle slow or hanging processes.
 *
 * @since 2.0.0
 * @category Errors
 */
const TimeoutException = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .TimeoutException */ .R_A;
/**
 * Creates an instance of `UnknownException`, an error object used to handle
 * unknown errors such as those from rejected promises.
 *
 * **Details**
 *
 * This function constructs an `UnknownException` with flexible behavior for
 * managing the error message and cause.
 *
 * The required `error` argument is passed as the `cause` to the global `Error`
 * constructor, ensuring that the original cause is preserved in the error chain
 * for debugging purposes. This ensures that the origin stack trace is
 * preserved.
 *
 * The `error` argument is always stored in the `error` property of the
 * `UnknownException` instance for reference, regardless of its type.
 *
 * Additionally, if you provide a `message` argument, it is used as the error
 * message. If no `message` is provided, the error message defaults to `"An
 * unknown error occurred"`.
 *
 * **When to Use**
 *
 * Use this function when you need to handle unexpected or unknown errors in
 * your application, particularly when the source of the error might not provide
 * a clear message. This is useful for wrapping generic errors thrown from
 * promises or external APIs.
 *
 * @since 2.0.0
 * @category Errors
 */
const UnknownException = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .UnknownException */ .ioe;
/**
 * Checks if a given unknown value is an `UnknownException`.
 *
 * @since 2.0.0
 * @category Guards
 */
const isUnknownException = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .isUnknownException */ .DSj;
/**
 * Creates an error indicating resource capacity has been exceeded.
 *
 * **Details**
 *
 * This function constructs an `ExceededCapacityException`, signifying that an
 * operation or resource usage surpassed established limits. This can be
 * essential for concurrency or resource management situations, ensuring your
 * application doesn't go beyond acceptable thresholds.
 *
 * @since 3.5.0
 * @category Errors
 */
const ExceededCapacityException = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .ExceededCapacityException */ .KOM;
/**
 * Checks if a given unknown value is an `ExceededCapacityException`.
 *
 * @since 3.5.0
 * @category Guards
 */
const isExceededCapacityException = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .isExceededCapacityException */ .B7o;
/**
 * Converts a `Cause` into a human-readable string.
 *
 * **Details**
 *
 * This function pretty-prints the entire `Cause`, including any failures,
 * defects, and interruptions. It can be especially helpful for logging,
 * debugging, or displaying structured errors to users.
 *
 * You can optionally pass `options` to configure how the error cause is
 * rendered. By default, it includes essential details of all errors in the
 * `Cause`.
 *
 * @see {@link prettyErrors} Get a list of `PrettyError` objects instead of a single string.
 *
 * @since 2.0.0
 * @category Formatting
 */
const pretty = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .pretty */ .IC;
/**
 * Returns a list of prettified errors (`PrettyError`) from a `Cause`.
 *
 * **Details**
 *
 * This function inspects the entire `Cause` and produces an array of
 * `PrettyError` objects. Each object may include additional metadata, such as a
 * `Span`, to provide deeper insights into where and how the error occurred.
 *
 * @since 3.2.0
 * @category Formatting
 */
const prettyErrors = _internal_cause_js__WEBPACK_IMPORTED_MODULE_0__/* .prettyErrors */ .sD;
/**
 * Retrieves the original, unproxied error instance from an error object.
 *
 * **Details**
 *
 * This function returns the underlying error object without any
 * library-specific wrapping or proxying that might occur during error handling.
 * This can be essential if you need direct access to the error's native
 * properties, such as stack traces or custom data fields, for detailed
 * debugging or integration with external systems.
 *
 * @since 2.0.0
 * @category Errors
 */
const originalError = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .originalInstance */ .qko;
//# sourceMappingURL=Cause.js.map

/***/ }),

/***/ 14109:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AO": function() { return /* binding */ toReadonlyArray; },
/* harmony export */   "Ce": function() { return /* binding */ prepend; },
/* harmony export */   "Cw": function() { return /* binding */ drop; },
/* harmony export */   "EE": function() { return /* binding */ fromIterable; },
/* harmony export */   "GY": function() { return /* binding */ reverse; },
/* harmony export */   "JN": function() { return /* binding */ unsafeFromArray; },
/* harmony export */   "MH": function() { return /* binding */ unsafeGet; },
/* harmony export */   "Od": function() { return /* binding */ isNonEmpty; },
/* harmony export */   "R3": function() { return /* binding */ append; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "YM": function() { return /* binding */ head; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "dK": function() { return /* binding */ headNonEmpty; },
/* harmony export */   "fm": function() { return /* binding */ tailNonEmpty; },
/* harmony export */   "nx": function() { return /* binding */ unsafeHead; },
/* harmony export */   "of": function() { return /* binding */ of; },
/* harmony export */   "oq": function() { return /* binding */ appendAll; },
/* harmony export */   "xb": function() { return /* binding */ isEmpty; }
/* harmony export */ });
/* unused harmony exports getEquivalence, isChunk, toArray, get, unsafeFromNonEmptyArray, take, dropRight, dropWhile, prependAll, filterMap, filter, filterMapWhile, compact, flatMap, forEach, flatten, chunksOf, intersection, last, unsafeLast, lastNonEmpty, map, mapAccum, partition, partitionMap, separate, size, sort, sortWith, splitAt, splitNonEmptyAt, split, splitWhere, tail, takeRight, takeWhile, union, dedupe, dedupeAdjacent, unzip, zipWith, zip, remove, modifyOption, modify, replace, replaceOption, makeBy, range, contains, containsWith, findFirst, findFirstIndex, findLast, findLastIndex, every, some, join, reduce, reduceRight, differenceWith, difference */
/* harmony import */ var _Array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37901);
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67492);
/* harmony import */ var _Equivalence_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27786);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17316);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89379);
/* harmony import */ var _Inspectable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16371);
/* harmony import */ var _Option_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16749);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92817);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71335);
/**
 * @since 2.0.0
 */










const TypeId = /*#__PURE__*/Symbol.for("effect/Chunk");
function copy(src, srcPos, dest, destPos, len) {
  for (let i = srcPos; i < Math.min(src.length, srcPos + len); i++) {
    dest[destPos + i - srcPos] = src[i];
  }
  return dest;
}
const emptyArray = [];
/**
 * Compares the two chunks of equal length using the specified function
 *
 * @category equivalence
 * @since 2.0.0
 */
const getEquivalence = isEquivalent => _Equivalence_js__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy((self, that) => self.length === that.length && toReadonlyArray(self).every((value, i) => isEquivalent(value, unsafeGet(that, i))));
const _equivalence = /*#__PURE__*/getEquivalence(_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS);
const ChunkProto = {
  [TypeId]: {
    _A: _ => _
  },
  toString() {
    return (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_2__/* .format */ .WU)(this.toJSON());
  },
  toJSON() {
    return {
      _id: "Chunk",
      values: toReadonlyArray(this).map(_Inspectable_js__WEBPACK_IMPORTED_MODULE_2__/* .toJSON */ .au)
    };
  },
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_2__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  },
  [_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .symbol */ .NA](that) {
    return isChunk(that) && _equivalence(this, that);
  },
  [_Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .symbol */ .NA]() {
    return _Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .cached */ .HX(this, _Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .array */ .IX(toReadonlyArray(this)));
  },
  [Symbol.iterator]() {
    switch (this.backing._tag) {
      case "IArray":
        {
          return this.backing.array[Symbol.iterator]();
        }
      case "IEmpty":
        {
          return emptyArray[Symbol.iterator]();
        }
      default:
        {
          return toReadonlyArray(this)[Symbol.iterator]();
        }
    }
  },
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_4__/* .pipeArguments */ .n)(this, arguments);
  }
};
const makeChunk = backing => {
  const chunk = Object.create(ChunkProto);
  chunk.backing = backing;
  switch (backing._tag) {
    case "IEmpty":
      {
        chunk.length = 0;
        chunk.depth = 0;
        chunk.left = chunk;
        chunk.right = chunk;
        break;
      }
    case "IConcat":
      {
        chunk.length = backing.left.length + backing.right.length;
        chunk.depth = 1 + Math.max(backing.left.depth, backing.right.depth);
        chunk.left = backing.left;
        chunk.right = backing.right;
        break;
      }
    case "IArray":
      {
        chunk.length = backing.array.length;
        chunk.depth = 0;
        chunk.left = _empty;
        chunk.right = _empty;
        break;
      }
    case "ISingleton":
      {
        chunk.length = 1;
        chunk.depth = 0;
        chunk.left = _empty;
        chunk.right = _empty;
        break;
      }
    case "ISlice":
      {
        chunk.length = backing.length;
        chunk.depth = backing.chunk.depth + 1;
        chunk.left = _empty;
        chunk.right = _empty;
        break;
      }
  }
  return chunk;
};
/**
 * Checks if `u` is a `Chunk<unknown>`
 *
 * @category constructors
 * @since 2.0.0
 */
const isChunk = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_5__/* .hasProperty */ .l$)(u, TypeId);
const _empty = /*#__PURE__*/makeChunk({
  _tag: "IEmpty"
});
/**
 * @category constructors
 * @since 2.0.0
 */
const empty = () => _empty;
/**
 * Builds a `NonEmptyChunk` from an non-empty collection of elements.
 *
 * @category constructors
 * @since 2.0.0
 */
const make = (...as) => unsafeFromNonEmptyArray(as);
/**
 * Builds a `NonEmptyChunk` from a single element.
 *
 * @category constructors
 * @since 2.0.0
 */
const of = a => makeChunk({
  _tag: "ISingleton",
  a
});
/**
 * Creates a new `Chunk` from an iterable collection of values.
 *
 * @category constructors
 * @since 2.0.0
 */
const fromIterable = self => isChunk(self) ? self : unsafeFromArray(_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .fromIterable */ .EE(self));
const copyToArray = (self, array, initial) => {
  switch (self.backing._tag) {
    case "IArray":
      {
        copy(self.backing.array, 0, array, initial, self.length);
        break;
      }
    case "IConcat":
      {
        copyToArray(self.left, array, initial);
        copyToArray(self.right, array, initial + self.left.length);
        break;
      }
    case "ISingleton":
      {
        array[initial] = self.backing.a;
        break;
      }
    case "ISlice":
      {
        let i = 0;
        let j = initial;
        while (i < self.length) {
          array[j] = unsafeGet(self, i);
          i += 1;
          j += 1;
        }
        break;
      }
  }
};
const toArray_ = self => toReadonlyArray(self).slice();
/**
 * Converts a `Chunk` into an `Array`. If the provided `Chunk` is non-empty
 * (`NonEmptyChunk`), the function will return a `NonEmptyArray`, ensuring the
 * non-empty property is preserved.
 *
 * @category conversions
 * @since 2.0.0
 */
const toArray = (/* unused pure expression or super */ null && (toArray_));
const toReadonlyArray_ = self => {
  switch (self.backing._tag) {
    case "IEmpty":
      {
        return emptyArray;
      }
    case "IArray":
      {
        return self.backing.array;
      }
    default:
      {
        const arr = new Array(self.length);
        copyToArray(self, arr, 0);
        self.backing = {
          _tag: "IArray",
          array: arr
        };
        self.left = _empty;
        self.right = _empty;
        self.depth = 0;
        return arr;
      }
  }
};
/**
 * Converts a `Chunk` into a `ReadonlyArray`. If the provided `Chunk` is
 * non-empty (`NonEmptyChunk`), the function will return a
 * `NonEmptyReadonlyArray`, ensuring the non-empty property is preserved.
 *
 * @category conversions
 * @since 2.0.0
 */
const toReadonlyArray = toReadonlyArray_;
const reverseChunk = self => {
  switch (self.backing._tag) {
    case "IEmpty":
    case "ISingleton":
      return self;
    case "IArray":
      {
        return makeChunk({
          _tag: "IArray",
          array: _Array_js__WEBPACK_IMPORTED_MODULE_6__/* .reverse */ .GY(self.backing.array)
        });
      }
    case "IConcat":
      {
        return makeChunk({
          _tag: "IConcat",
          left: reverse(self.backing.right),
          right: reverse(self.backing.left)
        });
      }
    case "ISlice":
      return unsafeFromArray(_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .reverse */ .GY(toReadonlyArray(self)));
  }
};
/**
 * Reverses the order of elements in a `Chunk`.
 * Importantly, if the input chunk is a `NonEmptyChunk`, the reversed chunk will also be a `NonEmptyChunk`.
 *
 * **Example**
 *
 * ```ts
 * import { Chunk } from "effect"
 *
 * const chunk = Chunk.make(1, 2, 3)
 * const result = Chunk.reverse(chunk)
 *
 * console.log(result)
 * // { _id: 'Chunk', values: [ 3, 2, 1 ] }
 * ```
 *
 * @since 2.0.0
 * @category elements
 */
const reverse = reverseChunk;
/**
 * This function provides a safe way to read a value at a particular index from a `Chunk`.
 *
 * @category elements
 * @since 2.0.0
 */
const get = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_7__/* .dual */ .OB)(2, (self, index) => index < 0 || index >= self.length ? _Option_js__WEBPACK_IMPORTED_MODULE_8__/* .none */ .YP() : _Option_js__WEBPACK_IMPORTED_MODULE_8__/* .some */ .G(unsafeGet(self, index)));
/**
 * Wraps an array into a chunk without copying, unsafe on mutable arrays
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeFromArray = self => self.length === 0 ? empty() : self.length === 1 ? of(self[0]) : makeChunk({
  _tag: "IArray",
  array: self
});
/**
 * Wraps an array into a chunk without copying, unsafe on mutable arrays
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeFromNonEmptyArray = self => unsafeFromArray(self);
/**
 * Gets an element unsafely, will throw on out of bounds
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeGet = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_7__/* .dual */ .OB)(2, (self, index) => {
  switch (self.backing._tag) {
    case "IEmpty":
      {
        throw new Error(`Index out of bounds`);
      }
    case "ISingleton":
      {
        if (index !== 0) {
          throw new Error(`Index out of bounds`);
        }
        return self.backing.a;
      }
    case "IArray":
      {
        if (index >= self.length || index < 0) {
          throw new Error(`Index out of bounds`);
        }
        return self.backing.array[index];
      }
    case "IConcat":
      {
        return index < self.left.length ? unsafeGet(self.left, index) : unsafeGet(self.right, index - self.left.length);
      }
    case "ISlice":
      {
        return unsafeGet(self.backing.chunk, index + self.backing.offset);
      }
  }
});
/**
 * Appends the specified element to the end of the `Chunk`.
 *
 * @category concatenating
 * @since 2.0.0
 */
const append = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_7__/* .dual */ .OB)(2, (self, a) => appendAll(self, of(a)));
/**
 * Prepend an element to the front of a `Chunk`, creating a new `NonEmptyChunk`.
 *
 * @category concatenating
 * @since 2.0.0
 */
const prepend = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_7__/* .dual */ .OB)(2, (self, elem) => appendAll(of(elem), self));
/**
 * Takes the first up to `n` elements from the chunk
 *
 * @since 2.0.0
 */
const take = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => {
  if (n <= 0) {
    return _empty;
  } else if (n >= self.length) {
    return self;
  } else {
    switch (self.backing._tag) {
      case "ISlice":
        {
          return makeChunk({
            _tag: "ISlice",
            chunk: self.backing.chunk,
            length: n,
            offset: self.backing.offset
          });
        }
      case "IConcat":
        {
          if (n > self.left.length) {
            return makeChunk({
              _tag: "IConcat",
              left: self.left,
              right: take(self.right, n - self.left.length)
            });
          }
          return take(self.left, n);
        }
      default:
        {
          return makeChunk({
            _tag: "ISlice",
            chunk: self,
            offset: 0,
            length: n
          });
        }
    }
  }
})));
/**
 * Drops the first up to `n` elements from the chunk
 *
 * @since 2.0.0
 */
const drop = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_7__/* .dual */ .OB)(2, (self, n) => {
  if (n <= 0) {
    return self;
  } else if (n >= self.length) {
    return _empty;
  } else {
    switch (self.backing._tag) {
      case "ISlice":
        {
          return makeChunk({
            _tag: "ISlice",
            chunk: self.backing.chunk,
            offset: self.backing.offset + n,
            length: self.backing.length - n
          });
        }
      case "IConcat":
        {
          if (n > self.left.length) {
            return drop(self.right, n - self.left.length);
          }
          return makeChunk({
            _tag: "IConcat",
            left: drop(self.left, n),
            right: self.right
          });
        }
      default:
        {
          return makeChunk({
            _tag: "ISlice",
            chunk: self,
            offset: n,
            length: self.length - n
          });
        }
    }
  }
});
/**
 * Drops the last `n` elements.
 *
 * @since 2.0.0
 */
const dropRight = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => take(self, Math.max(0, self.length - n)))));
/**
 * Drops all elements so long as the predicate returns true.
 *
 * @since 2.0.0
 */
const dropWhile = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => {
  const arr = toReadonlyArray(self);
  const len = arr.length;
  let i = 0;
  while (i < len && predicate(arr[i])) {
    i++;
  }
  return drop(self, i);
})));
/**
 * Prepends the specified prefix chunk to the beginning of the specified chunk.
 * If either chunk is non-empty, the result is also a non-empty chunk.
 *
 * **Example**
 *
 * ```ts
 * import { Chunk } from "effect"
 *
 * const result = Chunk.make(1, 2).pipe(Chunk.prependAll(Chunk.make("a", "b")), Chunk.toArray)
 *
 * console.log(result)
 * // [ "a", "b", 1, 2 ]
 * ```
 *
 * @category concatenating
 * @since 2.0.0
 */
const prependAll = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => appendAll(that, self))));
/**
 * Concatenates two chunks, combining their elements.
 * If either chunk is non-empty, the result is also a non-empty chunk.
 *
 * **Example**
 *
 * ```ts
 * import { Chunk } from "effect"
 *
 * const result = Chunk.make(1, 2).pipe(Chunk.appendAll(Chunk.make("a", "b")), Chunk.toArray)
 *
 * console.log(result)
 * // [ 1, 2, "a", "b" ]
 * ```
 *
 * @category concatenating
 * @since 2.0.0
 */
const appendAll = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_7__/* .dual */ .OB)(2, (self, that) => {
  if (self.backing._tag === "IEmpty") {
    return that;
  }
  if (that.backing._tag === "IEmpty") {
    return self;
  }
  const diff = that.depth - self.depth;
  if (Math.abs(diff) <= 1) {
    return makeChunk({
      _tag: "IConcat",
      left: self,
      right: that
    });
  } else if (diff < -1) {
    if (self.left.depth >= self.right.depth) {
      const nr = appendAll(self.right, that);
      return makeChunk({
        _tag: "IConcat",
        left: self.left,
        right: nr
      });
    } else {
      const nrr = appendAll(self.right.right, that);
      if (nrr.depth === self.depth - 3) {
        const nr = makeChunk({
          _tag: "IConcat",
          left: self.right.left,
          right: nrr
        });
        return makeChunk({
          _tag: "IConcat",
          left: self.left,
          right: nr
        });
      } else {
        const nl = makeChunk({
          _tag: "IConcat",
          left: self.left,
          right: self.right.left
        });
        return makeChunk({
          _tag: "IConcat",
          left: nl,
          right: nrr
        });
      }
    }
  } else {
    if (that.right.depth >= that.left.depth) {
      const nl = appendAll(self, that.left);
      return makeChunk({
        _tag: "IConcat",
        left: nl,
        right: that.right
      });
    } else {
      const nll = appendAll(self, that.left.left);
      if (nll.depth === that.depth - 3) {
        const nl = makeChunk({
          _tag: "IConcat",
          left: nll,
          right: that.left.right
        });
        return makeChunk({
          _tag: "IConcat",
          left: nl,
          right: that.right
        });
      } else {
        const nr = makeChunk({
          _tag: "IConcat",
          left: that.left.right,
          right: that.right
        });
        return makeChunk({
          _tag: "IConcat",
          left: nll,
          right: nr
        });
      }
    }
  }
});
/**
 * Returns a filtered and mapped subset of the elements.
 *
 * @since 2.0.0
 * @category filtering
 */
const filterMap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => unsafeFromArray(RA.filterMap(self, f)))));
/**
 * Returns a filtered and mapped subset of the elements.
 *
 * @since 2.0.0
 * @category filtering
 */
const filter = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => unsafeFromArray(RA.filter(self, predicate)))));
/**
 * Transforms all elements of the chunk for as long as the specified function returns some value
 *
 * @since 2.0.0
 * @category filtering
 */
const filterMapWhile = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => unsafeFromArray(RA.filterMapWhile(self, f)))));
/**
 * Filter out optional values
 *
 * @since 2.0.0
 * @category filtering
 */
const compact = self => filterMap(self, identity);
/**
 * Applies a function to each element in a chunk and returns a new chunk containing the concatenated mapped elements.
 *
 * @since 2.0.0
 * @category sequencing
 */
const flatMap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  if (self.backing._tag === "ISingleton") {
    return f(self.backing.a, 0);
  }
  let out = _empty;
  let i = 0;
  for (const k of self) {
    out = appendAll(out, f(k, i++));
  }
  return out;
})));
/**
 * Iterates over each element of a `Chunk` and applies a function to it.
 *
 * **Details**
 *
 * This function processes every element of the given `Chunk`, calling the
 * provided function `f` on each element. It does not return a new value;
 * instead, it is primarily used for side effects, such as logging or
 * accumulating data in an external variable.
 *
 * @since 2.0.0
 * @category combinators
 */
const forEach = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => toReadonlyArray(self).forEach(f))));
/**
 * Flattens a chunk of chunks into a single chunk by concatenating all chunks.
 *
 * @since 2.0.0
 * @category sequencing
 */
const flatten = /*#__PURE__*/(/* unused pure expression or super */ null && (flatMap(identity)));
/**
 * Groups elements in chunks of up to `n` elements.
 *
 * @since 2.0.0
 * @category elements
 */
const chunksOf = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => {
  const gr = [];
  let current = [];
  toReadonlyArray(self).forEach(a => {
    current.push(a);
    if (current.length >= n) {
      gr.push(unsafeFromArray(current));
      current = [];
    }
  });
  if (current.length > 0) {
    gr.push(unsafeFromArray(current));
  }
  return unsafeFromArray(gr);
})));
/**
 * Creates a Chunk of unique values that are included in all given Chunks.
 *
 * The order and references of result values are determined by the Chunk.
 *
 * @since 2.0.0
 * @category elements
 */
const intersection = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => unsafeFromArray(RA.intersection(toReadonlyArray(self), toReadonlyArray(that))))));
/**
 * Determines if the chunk is empty.
 *
 * @since 2.0.0
 * @category elements
 */
const isEmpty = self => self.length === 0;
/**
 * Determines if the chunk is not empty.
 *
 * @since 2.0.0
 * @category elements
 */
const isNonEmpty = self => self.length > 0;
/**
 * Returns the first element of this chunk if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
const head = /*#__PURE__*/get(0);
/**
 * Returns the first element of this chunk.
 *
 * It will throw an error if the chunk is empty.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeHead = self => unsafeGet(self, 0);
/**
 * Returns the first element of this non empty chunk.
 *
 * @since 2.0.0
 * @category elements
 */
const headNonEmpty = unsafeHead;
/**
 * Returns the last element of this chunk if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
const last = self => get(self, self.length - 1);
/**
 * Returns the last element of this chunk.
 *
 * It will throw an error if the chunk is empty.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeLast = self => unsafeGet(self, self.length - 1);
/**
 * Returns the last element of this non empty chunk.
 *
 * @since 3.4.0
 * @category elements
 */
const lastNonEmpty = (/* unused pure expression or super */ null && (unsafeLast));
/**
 * Transforms the elements of a chunk using the specified mapping function.
 * If the input chunk is non-empty, the resulting chunk will also be non-empty.
 *
 * **Example**
 *
 * ```ts
 * import { Chunk } from "effect"
 *
 * const result = Chunk.map(Chunk.make(1, 2), (n) => n + 1)
 *
 * console.log(result)
 * // { _id: 'Chunk', values: [ 2, 3 ] }
 * ```
 *
 * @since 2.0.0
 * @category mapping
 */
const map = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => self.backing._tag === "ISingleton" ? of(f(self.backing.a, 0)) : unsafeFromArray(pipe(toReadonlyArray(self), RA.map((a, i) => f(a, i)))))));
/**
 * Statefully maps over the chunk, producing new elements of type `B`.
 *
 * @since 2.0.0
 * @category folding
 */
const mapAccum = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, s, f) => {
  const [s1, as] = RA.mapAccum(self, s, f);
  return [s1, unsafeFromArray(as)];
})));
/**
 * Separate elements based on a predicate that also exposes the index of the element.
 *
 * @category filtering
 * @since 2.0.0
 */
const partition = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => pipe(RA.partition(toReadonlyArray(self), predicate), ([l, r]) => [unsafeFromArray(l), unsafeFromArray(r)]))));
/**
 * Partitions the elements of this chunk into two chunks using f.
 *
 * @category filtering
 * @since 2.0.0
 */
const partitionMap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => pipe(RA.partitionMap(toReadonlyArray(self), f), ([l, r]) => [unsafeFromArray(l), unsafeFromArray(r)]))));
/**
 * Partitions the elements of this chunk into two chunks.
 *
 * @category filtering
 * @since 2.0.0
 */
const separate = self => pipe(RA.separate(toReadonlyArray(self)), ([l, r]) => [unsafeFromArray(l), unsafeFromArray(r)]);
/**
 * Retireves the size of the chunk
 *
 * @since 2.0.0
 * @category elements
 */
const size = self => self.length;
/**
 * Sort the elements of a Chunk in increasing order, creating a new Chunk.
 *
 * @since 2.0.0
 * @category sorting
 */
const sort = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, O) => unsafeFromArray(RA.sort(toReadonlyArray(self), O)))));
/**
 * @since 2.0.0
 * @category sorting
 */
const sortWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, f, order) => sort(self, Order.mapInput(order, f)))));
/**
 *  Returns two splits of this chunk at the specified index.
 *
 * @since 2.0.0
 * @category splitting
 */
const splitAt = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => [take(self, n), drop(self, n)])));
/**
 * Splits a `NonEmptyChunk` into two segments, with the first segment containing a maximum of `n` elements.
 * The value of `n` must be `>= 1`.
 *
 * @category splitting
 * @since 2.0.0
 */
const splitNonEmptyAt = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => {
  const _n = Math.max(1, Math.floor(n));
  return _n >= self.length ? [self, empty()] : [take(self, _n), drop(self, _n)];
})));
/**
 * Splits this chunk into `n` equally sized chunks.
 *
 * @since 2.0.0
 * @category splitting
 */
const split = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => chunksOf(self, Math.ceil(self.length / Math.floor(n))))));
/**
 * Splits this chunk on the first element that matches this predicate.
 * Returns a tuple containing two chunks: the first one is before the match, and the second one is from the match onward.
 *
 * @category splitting
 * @since 2.0.0
 */
const splitWhere = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => {
  let i = 0;
  for (const a of toReadonlyArray(self)) {
    if (predicate(a)) {
      break;
    } else {
      i++;
    }
  }
  return splitAt(self, i);
})));
/**
 * Returns every elements after the first.
 *
 * @since 2.0.0
 * @category elements
 */
const tail = self => self.length > 0 ? O.some(drop(self, 1)) : O.none();
/**
 * Returns every elements after the first.
 *
 * @since 2.0.0
 * @category elements
 */
const tailNonEmpty = self => drop(self, 1);
/**
 * Takes the last `n` elements.
 *
 * @since 2.0.0
 * @category elements
 */
const takeRight = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => drop(self, self.length - n))));
/**
 * Takes all elements so long as the predicate returns true.
 *
 * @since 2.0.0
 * @category elements
 */
const takeWhile = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => {
  const out = [];
  for (const a of toReadonlyArray(self)) {
    if (predicate(a)) {
      out.push(a);
    } else {
      break;
    }
  }
  return unsafeFromArray(out);
})));
/**
 * Creates a Chunks of unique values, in order, from all given Chunks.
 *
 * @since 2.0.0
 * @category elements
 */
const union = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => unsafeFromArray(RA.union(toReadonlyArray(self), toReadonlyArray(that))))));
/**
 * Remove duplicates from an array, keeping the first occurrence of an element.
 *
 * @since 2.0.0
 * @category elements
 */
const dedupe = self => unsafeFromArray(RA.dedupe(toReadonlyArray(self)));
/**
 * Deduplicates adjacent elements that are identical.
 *
 * @since 2.0.0
 * @category filtering
 */
const dedupeAdjacent = self => unsafeFromArray(RA.dedupeAdjacent(self));
/**
 * Takes a `Chunk` of pairs and return two corresponding `Chunk`s.
 *
 * Note: The function is reverse of `zip`.
 *
 * @since 2.0.0
 * @category elements
 */
const unzip = self => {
  const [left, right] = RA.unzip(self);
  return [unsafeFromArray(left), unsafeFromArray(right)];
};
/**
 * Zips this chunk pointwise with the specified chunk using the specified combiner.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, that, f) => unsafeFromArray(RA.zipWith(self, that, f)))));
/**
 * Zips this chunk pointwise with the specified chunk.
 *
 * @since 2.0.0
 * @category zipping
 */
const zip = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => zipWith(self, that, (a, b) => [a, b]))));
/**
 * Delete the element at the specified index, creating a new `Chunk`.
 *
 * @since 2.0.0
 */
const remove = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, i) => unsafeFromArray(RA.remove(toReadonlyArray(self), i)))));
/**
 * @since 2.0.0
 */
const modifyOption = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, i, f) => O.map(RA.modifyOption(toReadonlyArray(self), i, f), unsafeFromArray))));
/**
 * Apply a function to the element at the specified index, creating a new `Chunk`,
 * or returning the input if the index is out of bounds.
 *
 * @since 2.0.0
 */
const modify = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, i, f) => O.getOrElse(modifyOption(self, i, f), () => self))));
/**
 * Change the element at the specified index, creating a new `Chunk`,
 * or returning the input if the index is out of bounds.
 *
 * @since 2.0.0
 */
const replace = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, i, b) => modify(self, i, () => b))));
/**
 * @since 2.0.0
 */
const replaceOption = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, i, b) => modifyOption(self, i, () => b))));
/**
 * Return a Chunk of length n with element i initialized with f(i).
 *
 * **Note**. `n` is normalized to an integer >= 1.
 *
 * @category constructors
 * @since 2.0.0
 */
const makeBy = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (n, f) => fromIterable(RA.makeBy(n, f)))));
/**
 * Create a non empty `Chunk` containing a range of integers, including both endpoints.
 *
 * @category constructors
 * @since 2.0.0
 */
const range = (start, end) => start <= end ? makeBy(end - start + 1, i => start + i) : of(start);
// -------------------------------------------------------------------------------------
// re-exports from ReadonlyArray
// -------------------------------------------------------------------------------------
/**
 * Returns a function that checks if a `Chunk` contains a given value using the default `Equivalence`.
 *
 * @category elements
 * @since 2.0.0
 */
const contains = _Array_js__WEBPACK_IMPORTED_MODULE_6__/* .contains */ .r3;
/**
 * Returns a function that checks if a `Chunk` contains a given value using a provided `isEquivalent` function.
 *
 * @category elements
 * @since 2.0.0
 */
const containsWith = _Array_js__WEBPACK_IMPORTED_MODULE_6__/* .containsWith */ .hr;
/**
 * Returns the first element that satisfies the specified
 * predicate, or `None` if no such element exists.
 *
 * @category elements
 * @since 2.0.0
 */
const findFirst = _Array_js__WEBPACK_IMPORTED_MODULE_6__/* .findFirst */ .Ew;
/**
 * Return the first index for which a predicate holds.
 *
 * @category elements
 * @since 2.0.0
 */
const findFirstIndex = _Array_js__WEBPACK_IMPORTED_MODULE_6__/* .findFirstIndex */ .ln;
/**
 * Find the last element for which a predicate holds.
 *
 * @category elements
 * @since 2.0.0
 */
const findLast = _Array_js__WEBPACK_IMPORTED_MODULE_6__/* .findLast */ .dF;
/**
 * Return the last index for which a predicate holds.
 *
 * @category elements
 * @since 2.0.0
 */
const findLastIndex = _Array_js__WEBPACK_IMPORTED_MODULE_6__/* .findLastIndex */ .qr;
/**
 * Check if a predicate holds true for every `Chunk` element.
 *
 * @category elements
 * @since 2.0.0
 */
const every = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, refinement) => RA.fromIterable(self).every(refinement))));
/**
 * Check if a predicate holds true for some `Chunk` element.
 *
 * @category elements
 * @since 2.0.0
 */
const some = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => RA.fromIterable(self).some(predicate))));
/**
 * Joins the elements together with "sep" in the middle.
 *
 * @category folding
 * @since 2.0.0
 */
const join = _Array_js__WEBPACK_IMPORTED_MODULE_6__/* .join */ .v_;
/**
 * @category folding
 * @since 2.0.0
 */
const reduce = _Array_js__WEBPACK_IMPORTED_MODULE_6__/* .reduce */ .u4;
/**
 * @category folding
 * @since 2.0.0
 */
const reduceRight = _Array_js__WEBPACK_IMPORTED_MODULE_6__/* .reduceRight */ .nq;
/**
 * Creates a `Chunk` of values not included in the other given `Chunk` using the provided `isEquivalent` function.
 * The order and references of result values are determined by the first `Chunk`.
 *
 * @since 3.2.0
 */
const differenceWith = isEquivalent => {
  return dual(2, (self, that) => unsafeFromArray(RA.differenceWith(isEquivalent)(that, self)));
};
/**
 * Creates a `Chunk` of values not included in the other given `Chunk`.
 * The order and references of result values are determined by the first `Chunk`.
 *
 * @since 3.2.0
 */
const difference = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => unsafeFromArray(RA.difference(that, self)))));
//# sourceMappingURL=Chunk.js.map

/***/ }),

/***/ 9605:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nl": function() { return /* binding */ currentTimeNanos; },
/* harmony export */   "SU": function() { return /* binding */ Clock; },
/* harmony export */   "UA": function() { return /* binding */ clockWith; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "b4": function() { return /* binding */ currentTimeMillis; }
/* harmony export */ });
/* unused harmony exports ClockTypeId, make */
/* harmony import */ var _internal_clock_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53318);
/* harmony import */ var _internal_defaultServices_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74266);


/**
 * @since 2.0.0
 * @category symbols
 */
const ClockTypeId = _internal_clock_js__WEBPACK_IMPORTED_MODULE_0__/* .ClockTypeId */ .uh;
/**
 * @since 2.0.0
 * @category constructors
 */
const make = _internal_clock_js__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy;
/**
 * @since 2.0.0
 * @category constructors
 */
const sleep = _internal_defaultServices_js__WEBPACK_IMPORTED_MODULE_1__/* .sleep */ ._v;
/**
 * @since 2.0.0
 * @category constructors
 */
const currentTimeMillis = _internal_defaultServices_js__WEBPACK_IMPORTED_MODULE_1__/* .currentTimeMillis */ .b4;
/**
 * @since 2.0.0
 * @category constructors
 */
const currentTimeNanos = _internal_defaultServices_js__WEBPACK_IMPORTED_MODULE_1__/* .currentTimeNanos */ .Nl;
/**
 * @since 2.0.0
 * @category constructors
 */
const clockWith = _internal_defaultServices_js__WEBPACK_IMPORTED_MODULE_1__/* .clockWith */ .UA;
/**
 * @since 2.0.0
 * @category context
 */
const Clock = _internal_clock_js__WEBPACK_IMPORTED_MODULE_0__/* .clockTag */ .GL;
//# sourceMappingURL=Clock.js.map

/***/ }),

/***/ 20591:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IH": function() { return /* binding */ add; },
/* harmony export */   "MH": function() { return /* binding */ unsafeGet; },
/* harmony export */   "PI": function() { return /* binding */ isContext; },
/* harmony export */   "Rl": function() { return /* binding */ getOption; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "TS": function() { return /* binding */ merge; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "Vp": function() { return /* binding */ Tag; },
/* harmony export */   "YR": function() { return /* binding */ isTag; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "hV": function() { return /* binding */ GenericTag; },
/* harmony export */   "s3": function() { return /* binding */ Reference; }
/* harmony export */ });
/* unused harmony exports unsafeMake, isReference, getOrElse, mergeAll, pick, omit */
/* harmony import */ var _internal_context_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40197);

const TagTypeId = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .TagTypeId */ .Og;
const ReferenceTypeId = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .ReferenceTypeId */ .no;
/**
 * Creates a new `Tag` instance with an optional key parameter.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Context } from "effect"
 *
 * assert.strictEqual(Context.GenericTag("PORT").key === Context.GenericTag("PORT").key, true)
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
const GenericTag = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .makeGenericTag */ .uq;
const TypeId = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .TypeId */ .aC;
/**
 * @since 2.0.0
 * @category constructors
 */
const unsafeMake = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .makeContext */ .fC;
/**
 * Checks if the provided argument is a `Context`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Context } from "effect"
 *
 * assert.strictEqual(Context.isContext(Context.empty()), true)
 * ```
 *
 * @since 2.0.0
 * @category guards
 */
const isContext = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .isContext */ .PI;
/**
 * Checks if the provided argument is a `Tag`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Context } from "effect"
 *
 * assert.strictEqual(Context.isTag(Context.GenericTag("Tag")), true)
 * ```
 *
 * @since 2.0.0
 * @category guards
 */
const isTag = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .isTag */ .YR;
/**
 * Checks if the provided argument is a `Reference`.
 *
 * @since 3.11.0
 * @category guards
 * @experimental
 */
const isReference = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .isReference */ .Yk;
/**
 * Returns an empty `Context`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Context } from "effect"
 *
 * assert.strictEqual(Context.isContext(Context.empty()), true)
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .empty */ .cS;
/**
 * Creates a new `Context` with a single service associated to the tag.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Context } from "effect"
 *
 * const Port = Context.GenericTag<{ PORT: number }>("Port")
 *
 * const Services = Context.make(Port, { PORT: 8080 })
 *
 * assert.deepStrictEqual(Context.get(Services, Port), { PORT: 8080 })
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
const make = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy;
/**
 * Adds a service to a given `Context`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Context, pipe } from "effect"
 *
 * const Port = Context.GenericTag<{ PORT: number }>("Port")
 * const Timeout = Context.GenericTag<{ TIMEOUT: number }>("Timeout")
 *
 * const someContext = Context.make(Port, { PORT: 8080 })
 *
 * const Services = pipe(
 *   someContext,
 *   Context.add(Timeout, { TIMEOUT: 5000 })
 * )
 *
 * assert.deepStrictEqual(Context.get(Services, Port), { PORT: 8080 })
 * assert.deepStrictEqual(Context.get(Services, Timeout), { TIMEOUT: 5000 })
 * ```
 *
 * @since 2.0.0
 */
const add = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .add */ .IH;
/**
 * Get a service from the context that corresponds to the given tag.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, Context } from "effect"
 *
 * const Port = Context.GenericTag<{ PORT: number }>("Port")
 * const Timeout = Context.GenericTag<{ TIMEOUT: number }>("Timeout")
 *
 * const Services = pipe(
 *   Context.make(Port, { PORT: 8080 }),
 *   Context.add(Timeout, { TIMEOUT: 5000 })
 * )
 *
 * assert.deepStrictEqual(Context.get(Services, Timeout), { TIMEOUT: 5000 })
 * ```
 *
 * @since 2.0.0
 * @category getters
 */
const get = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2;
/**
 * Get a service from the context that corresponds to the given tag, or
 * use the fallback value.
 *
 * @since 3.7.0
 * @category getters
 */
const getOrElse = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .getOrElse */ .fS;
/**
 * Get a service from the context that corresponds to the given tag.
 * This function is unsafe because if the tag is not present in the context, a runtime error will be thrown.
 *
 * For a safer version see {@link getOption}.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Context } from "effect"
 *
 * const Port = Context.GenericTag<{ PORT: number }>("Port")
 * const Timeout = Context.GenericTag<{ TIMEOUT: number }>("Timeout")
 *
 * const Services = Context.make(Port, { PORT: 8080 })
 *
 * assert.deepStrictEqual(Context.unsafeGet(Services, Port), { PORT: 8080 })
 * assert.throws(() => Context.unsafeGet(Services, Timeout))
 * ```
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeGet = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .unsafeGet */ .MH;
/**
 * Get the value associated with the specified tag from the context wrapped in an `Option` object. If the tag is not
 * found, the `Option` object will be `None`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Context, Option } from "effect"
 *
 * const Port = Context.GenericTag<{ PORT: number }>("Port")
 * const Timeout = Context.GenericTag<{ TIMEOUT: number }>("Timeout")
 *
 * const Services = Context.make(Port, { PORT: 8080 })
 *
 * assert.deepStrictEqual(Context.getOption(Services, Port), Option.some({ PORT: 8080 }))
 * assert.deepStrictEqual(Context.getOption(Services, Timeout), Option.none())
 * ```
 *
 * @since 2.0.0
 * @category getters
 */
const getOption = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .getOption */ .Rl;
/**
 * Merges two `Context`s, returning a new `Context` containing the services of both.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Context } from "effect"
 *
 * const Port = Context.GenericTag<{ PORT: number }>("Port")
 * const Timeout = Context.GenericTag<{ TIMEOUT: number }>("Timeout")
 *
 * const firstContext = Context.make(Port, { PORT: 8080 })
 * const secondContext = Context.make(Timeout, { TIMEOUT: 5000 })
 *
 * const Services = Context.merge(firstContext, secondContext)
 *
 * assert.deepStrictEqual(Context.get(Services, Port), { PORT: 8080 })
 * assert.deepStrictEqual(Context.get(Services, Timeout), { TIMEOUT: 5000 })
 * ```
 *
 * @since 2.0.0
 */
const merge = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TS;
/**
 * Merges any number of `Context`s, returning a new `Context` containing the services of all.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Context } from "effect"
 *
 * const Port = Context.GenericTag<{ PORT: number }>("Port")
 * const Timeout = Context.GenericTag<{ TIMEOUT: number }>("Timeout")
 * const Host = Context.GenericTag<{ HOST: string }>("Host")
 *
 * const firstContext = Context.make(Port, { PORT: 8080 })
 * const secondContext = Context.make(Timeout, { TIMEOUT: 5000 })
 * const thirdContext = Context.make(Host, { HOST: "localhost" })
 *
 * const Services = Context.mergeAll(firstContext, secondContext, thirdContext)
 *
 * assert.deepStrictEqual(Context.get(Services, Port), { PORT: 8080 })
 * assert.deepStrictEqual(Context.get(Services, Timeout), { TIMEOUT: 5000 })
 * assert.deepStrictEqual(Context.get(Services, Host), { HOST: "localhost" })
 * ```
 *
 * @since 3.12.0
 */
const mergeAll = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .mergeAll */ .Jn;
/**
 * Returns a new `Context` that contains only the specified services.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, Context, Option } from "effect"
 *
 * const Port = Context.GenericTag<{ PORT: number }>("Port")
 * const Timeout = Context.GenericTag<{ TIMEOUT: number }>("Timeout")
 *
 * const someContext = pipe(
 *   Context.make(Port, { PORT: 8080 }),
 *   Context.add(Timeout, { TIMEOUT: 5000 })
 * )
 *
 * const Services = pipe(someContext, Context.pick(Port))
 *
 * assert.deepStrictEqual(Context.getOption(Services, Port), Option.some({ PORT: 8080 }))
 * assert.deepStrictEqual(Context.getOption(Services, Timeout), Option.none())
 * ```
 *
 * @since 2.0.0
 */
const pick = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .pick */ .ei;
/**
 * @since 2.0.0
 */
const omit = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .omit */ .CE;
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Context, Layer } from "effect"
 *
 * class MyTag extends Context.Tag("MyTag")<
 *  MyTag,
 *  { readonly myNum: number }
 * >() {
 *  static Live = Layer.succeed(this, { myNum: 108 })
 * }
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
const Tag = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .Tag */ .Vp;
/**
 * Creates a context tag with a default value.
 *
 * **Details**
 *
 * `Context.Reference` allows you to create a tag that can hold a value. You can
 * provide a default value for the service, which will automatically be used
 * when the context is accessed, or override it with a custom implementation
 * when needed.
 *
 * **Example** (Declaring a Tag with a default value)
 *
 * ```ts
 * import * as assert from "node:assert"
 * import { Context, Effect } from "effect"
 *
 * class SpecialNumber extends Context.Reference<SpecialNumber>()(
 *   "SpecialNumber",
 *   { defaultValue: () => 2048 }
 * ) {}
 *
 * //      ┌─── Effect<void, never, never>
 * //      ▼
 * const program = Effect.gen(function* () {
 *   const specialNumber = yield* SpecialNumber
 *   console.log(`The special number is ${specialNumber}`)
 * })
 *
 * // No need to provide the SpecialNumber implementation
 * Effect.runPromise(program)
 * // Output: The special number is 2048
 * ```
 *
 * **Example** (Overriding the default value)
 *
 * ```ts
 * import { Context, Effect } from "effect"
 *
 * class SpecialNumber extends Context.Reference<SpecialNumber>()(
 *   "SpecialNumber",
 *   { defaultValue: () => 2048 }
 * ) {}
 *
 * const program = Effect.gen(function* () {
 *   const specialNumber = yield* SpecialNumber
 *   console.log(`The special number is ${specialNumber}`)
 * })
 *
 * Effect.runPromise(program.pipe(Effect.provideService(SpecialNumber, -1)))
 * // Output: The special number is -1
 * ```
 *
 * @since 3.11.0
 * @category constructors
 * @experimental
 */
const Reference = _internal_context_js__WEBPACK_IMPORTED_MODULE_0__/* .Reference */ .s3;
//# sourceMappingURL=Context.js.map

/***/ }),

/***/ 21566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fZ": function() { return /* binding */ TaggedError; }
/* harmony export */ });
/* unused harmony exports struct, unsafeStruct, tuple, array, unsafeArray, case, tagged, Class, TaggedClass, Structural, taggedEnum, Error */
/* harmony import */ var _internal_core_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39355);
/* harmony import */ var _internal_data_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84685);




/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Data, Equal } from "effect"
 *
 * const alice = Data.struct({ name: "Alice", age: 30 })
 *
 * const bob = Data.struct({ name: "Bob", age: 40 })
 *
 * assert.deepStrictEqual(Equal.equals(alice, alice), true)
 * assert.deepStrictEqual(Equal.equals(alice, Data.struct({ name: "Alice", age: 30 })), true)
 *
 * assert.deepStrictEqual(Equal.equals(alice, { name: "Alice", age: 30 }), false)
 * assert.deepStrictEqual(Equal.equals(alice, bob), false)
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const struct = _internal_data_js__WEBPACK_IMPORTED_MODULE_0__/* .struct */ .n_;
/**
 * @category constructors
 * @since 2.0.0
 */
const unsafeStruct = as => Object.setPrototypeOf(as, StructuralPrototype);
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Data, Equal } from "effect"
 *
 * const alice = Data.tuple("Alice", 30)
 *
 * const bob = Data.tuple("Bob", 40)
 *
 * assert.deepStrictEqual(Equal.equals(alice, alice), true)
 * assert.deepStrictEqual(Equal.equals(alice, Data.tuple("Alice", 30)), true)
 *
 * assert.deepStrictEqual(Equal.equals(alice, ["Alice", 30]), false)
 * assert.deepStrictEqual(Equal.equals(alice, bob), false)
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const tuple = (...as) => unsafeArray(as);
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Data, Equal } from "effect"
 *
 * const alice = Data.struct({ name: "Alice", age: 30 })
 * const bob = Data.struct({ name: "Bob", age: 40 })
 *
 * const persons = Data.array([alice, bob])
 *
 * assert.deepStrictEqual(
 *   Equal.equals(
 *     persons,
 *     Data.array([
 *       Data.struct({ name: "Alice", age: 30 }),
 *       Data.struct({ name: "Bob", age: 40 })
 *     ])
 *   ),
 *   true
 * )
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const array = as => unsafeArray(as.slice(0));
/**
 * @category constructors
 * @since 2.0.0
 */
const unsafeArray = as => Object.setPrototypeOf(as, internal.ArrayProto);
const _case = () => args => args === undefined ? Object.create(StructuralPrototype) : struct(args);

/**
 * Provides a tagged constructor for the specified `Case`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Data } from "effect"
 *
 * interface Person {
 *   readonly _tag: "Person" // the tag
 *   readonly name: string
 * }
 *
 * const Person = Data.tagged<Person>("Person")
 *
 * const mike = Person({ name: "Mike" })
 *
 * assert.deepEqual(mike, { _tag: "Person", name: "Mike" })
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
const tagged = tag => args => {
  const value = args === undefined ? Object.create(StructuralPrototype) : struct(args);
  value._tag = tag;
  return value;
};
/**
 * Provides a constructor for a Case Class.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Data, Equal } from "effect"
 *
 * class Person extends Data.Class<{ readonly name: string }> {}
 *
 * // Creating instances of Person
 * const mike1 = new Person({ name: "Mike" })
 * const mike2 = new Person({ name: "Mike" })
 * const john = new Person({ name: "John" })
 *
 * // Checking equality
 * assert.deepStrictEqual(Equal.equals(mike1, mike2), true)
 * assert.deepStrictEqual(Equal.equals(mike1, john), false)
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
const Class = _internal_data_js__WEBPACK_IMPORTED_MODULE_0__/* .Structural */ .Kj;
/**
 * Provides a Tagged constructor for a Case Class.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Data, Equal } from "effect"
 *
 * class Person extends Data.TaggedClass("Person")<{ readonly name: string }> {}
 *
 * // Creating instances of Person
 * const mike1 = new Person({ name: "Mike" })
 * const mike2 = new Person({ name: "Mike" })
 * const john = new Person({ name: "John" })
 *
 * // Checking equality
 * assert.deepStrictEqual(Equal.equals(mike1, mike2), true)
 * assert.deepStrictEqual(Equal.equals(mike1, john), false)
 *
 * assert.deepStrictEqual(mike1._tag, "Person")
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
const TaggedClass = tag => {
  class Base extends Class {
    _tag = tag;
  }
  return Base;
};
/**
 * @since 2.0.0
 * @category constructors
 */
const Structural = _internal_data_js__WEBPACK_IMPORTED_MODULE_0__/* .Structural */ .Kj;
/**
 * Create a constructor for a tagged union of `Data` structs.
 *
 * You can also pass a `TaggedEnum.WithGenerics` if you want to add generics to
 * the constructor.
 *
 * @example
 * ```ts
 * import { Data } from "effect"
 *
 * const { BadRequest, NotFound } = Data.taggedEnum<
 *   | { readonly _tag: "BadRequest"; readonly status: 400; readonly message: string }
 *   | { readonly _tag: "NotFound"; readonly status: 404; readonly message: string }
 * >()
 *
 * const notFound = NotFound({ status: 404, message: "Not Found" })
 * ```
 *
 * @example
 * import { Data } from "effect"
 *
 * type MyResult<E, A> = Data.TaggedEnum<{
 *   Failure: { readonly error: E }
 *   Success: { readonly value: A }
 * }>
 * interface MyResultDefinition extends Data.TaggedEnum.WithGenerics<2> {
 *   readonly taggedEnum: MyResult<this["A"], this["B"]>
 * }
 * const { Failure, Success } = Data.taggedEnum<MyResultDefinition>()
 *
 * const success = Success({ value: 1 })
 *
 * @category constructors
 * @since 2.0.0
 */
const taggedEnum = () => new Proxy({}, {
  get(_target, tag, _receiver) {
    if (tag === "$is") {
      return Predicate.isTagged;
    } else if (tag === "$match") {
      return taggedMatch;
    }
    return tagged(tag);
  }
});
function taggedMatch() {
  if (arguments.length === 1) {
    const cases = arguments[0];
    return function (value) {
      return cases[value._tag](value);
    };
  }
  const value = arguments[0];
  const cases = arguments[1];
  return cases[value._tag](value);
}
/**
 * Provides a constructor for a Case Class.
 *
 * @since 2.0.0
 * @category constructors
 */
const Error = /*#__PURE__*/function () {
  const plainArgsSymbol = /*#__PURE__*/Symbol.for("effect/Data/Error/plainArgs");
  const O = {
    BaseEffectError: class extends _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .YieldableError */ .LJp {
      constructor(args) {
        super(args?.message, args?.cause ? {
          cause: args.cause
        } : undefined);
        if (args) {
          Object.assign(this, args);
          Object.defineProperty(this, plainArgsSymbol, {
            value: args,
            enumerable: false
          });
        }
      }
      toJSON() {
        return {
          ...this[plainArgsSymbol],
          ...this
        };
      }
    }
  };
  return O.BaseEffectError;
}();
/**
 * @since 2.0.0
 * @category constructors
 */
const TaggedError = tag => {
  const O = {
    BaseEffectError: class extends Error {
      _tag = tag;
    }
  };
  O.BaseEffectError.prototype.name = tag;
  return O.BaseEffectError;
};
//# sourceMappingURL=Data.js.map

/***/ }),

/***/ 72022:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Uz": function() { return /* binding */ _await; },
/* harmony export */   "aT": function() { return /* binding */ done; },
/* harmony export */   "e1": function() { return /* binding */ interrupt; },
/* harmony export */   "t0": function() { return /* binding */ unsafeMake; }
/* harmony export */ });
/* unused harmony exports DeferredTypeId, make, makeAs, complete, completeWith, fail, failSync, failCause, failCauseSync, die, dieSync, interruptWith, isDone, poll, succeed, sync, unsafeDone */
/* harmony import */ var _internal_core_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39355);
/* harmony import */ var _internal_deferred_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32387);


/**
 * @since 2.0.0
 * @category symbols
 */
const DeferredTypeId = _internal_deferred_js__WEBPACK_IMPORTED_MODULE_0__/* .DeferredTypeId */ .zD;
/**
 * Creates a new `Deferred`.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredMake */ .kPu;
/**
 * Creates a new `Deferred` from the specified `FiberId`.
 *
 * @since 2.0.0
 * @category constructors
 */
const makeAs = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredMakeAs */ .HZA;
const _await = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredAwait */ .Odg;

/**
 * Completes the deferred with the result of the specified effect. If the
 * deferred has already been completed, the method will produce false.
 *
 * Note that `Deferred.completeWith` will be much faster, so consider using
 * that if you do not need to memoize the result of the specified effect.
 *
 * @since 2.0.0
 * @category utils
 */
const complete = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredComplete */ .klV;
/**
 * Completes the deferred with the result of the specified effect. If the
 * deferred has already been completed, the method will produce false.
 *
 * @since 2.0.0
 * @category utils
 */
const completeWith = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredCompleteWith */ .KwY;
/**
 * Exits the `Deferred` with the specified `Exit` value, which will be
 * propagated to all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
const done = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredDone */ .J9x;
/**
 * Fails the `Deferred` with the specified error, which will be propagated to
 * all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
const fail = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredFail */ .S5h;
/**
 * Fails the `Deferred` with the specified error, which will be propagated to
 * all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
const failSync = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredFailSync */ .i26;
/**
 * Fails the `Deferred` with the specified `Cause`, which will be propagated to
 * all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
const failCause = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredFailCause */ .yd6;
/**
 * Fails the `Deferred` with the specified `Cause`, which will be propagated to
 * all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
const failCauseSync = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredFailCauseSync */ .HSD;
/**
 * Kills the `Deferred` with the specified defect, which will be propagated to
 * all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
const die = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredDie */ .pB5;
/**
 * Kills the `Deferred` with the specified defect, which will be propagated to
 * all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category utils
 */
const dieSync = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredDieSync */ .skT;
/**
 * Completes the `Deferred` with interruption. This will interrupt all fibers
 * waiting on the value of the `Deferred` with the `FiberId` of the fiber
 * calling this method.
 *
 * @since 2.0.0
 * @category utils
 */
const interrupt = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredInterrupt */ .$cv;
/**
 * Completes the `Deferred` with interruption. This will interrupt all fibers
 * waiting on the value of the `Deferred` with the specified `FiberId`.
 *
 * @since 2.0.0
 * @category utils
 */
const interruptWith = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredInterruptWith */ .n86;
/**
 * Returns `true` if this `Deferred` has already been completed with a value or
 * an error, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isDone = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredIsDone */ .re6;
/**
 * Returns a `Some<Effect<A, E, R>>` from the `Deferred` if this `Deferred` has
 * already been completed, `None` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const poll = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredPoll */ .gKZ;
/**
 * Completes the `Deferred` with the specified value.
 *
 * @since 2.0.0
 * @category utils
 */
const succeed = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredSucceed */ .QtZ;
/**
 * Completes the `Deferred` with the specified lazily evaluated value.
 *
 * @since 2.0.0
 * @category utils
 */
const sync = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredSync */ .UnW;
/**
 * Unsafely creates a new `Deferred` from the specified `FiberId`.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeMake = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredUnsafeMake */ .OJ4;
/**
 * Unsafely exits the `Deferred` with the specified `Exit` value, which will be
 * propagated to all fibers waiting on the value of the `Deferred`.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeDone = _internal_core_js__WEBPACK_IMPORTED_MODULE_1__/* .deferredUnsafeDone */ .zxF;
//# sourceMappingURL=Deferred.js.map

/***/ }),

/***/ 13571:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CU": function() { return /* binding */ toNanos; },
/* harmony export */   "CZ": function() { return /* binding */ Equivalence; },
/* harmony export */   "Fd": function() { return /* binding */ infinity; },
/* harmony export */   "Jx": function() { return /* binding */ decode; },
/* harmony export */   "LK": function() { return /* binding */ minutes; },
/* harmony export */   "MK": function() { return /* binding */ lessThanOrEqualTo; },
/* harmony export */   "P4": function() { return /* binding */ weeks; },
/* harmony export */   "Ti": function() { return /* binding */ micros; },
/* harmony export */   "WU": function() { return /* binding */ format; },
/* harmony export */   "YX": function() { return /* binding */ millis; },
/* harmony export */   "_9": function() { return /* binding */ isDuration; },
/* harmony export */   "an": function() { return /* binding */ days; },
/* harmony export */   "bM": function() { return /* binding */ zero; },
/* harmony export */   "eq": function() { return /* binding */ toMillis; },
/* harmony export */   "hX": function() { return /* binding */ toHrTime; },
/* harmony export */   "i4": function() { return /* binding */ hours; },
/* harmony export */   "m9": function() { return /* binding */ seconds; },
/* harmony export */   "o6": function() { return /* binding */ nanos; },
/* harmony export */   "wZ": function() { return /* binding */ greaterThanOrEqualTo; },
/* harmony export */   "xV": function() { return /* binding */ isFinite; }
/* harmony export */ });
/* unused harmony exports decodeUnknown, isZero, toSeconds, toMinutes, toHours, toDays, toWeeks, unsafeToNanos, match, matchWith, Order, between, min, max, clamp, divide, unsafeDivide, times, subtract, sum, lessThan, greaterThan, equals, parts, unsafeFormatIso, formatIso, fromIso */
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17316);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89379);
/* harmony import */ var _Inspectable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16371);
/* harmony import */ var _Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16749);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92817);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71335);
/**
 * @since 2.0.0
 */








const TypeId = /*#__PURE__*/Symbol.for("effect/Duration");
const bigint0 = /*#__PURE__*/BigInt(0);
const bigint24 = /*#__PURE__*/BigInt(24);
const bigint60 = /*#__PURE__*/BigInt(60);
const bigint1e3 = /*#__PURE__*/BigInt(1_000);
const bigint1e6 = /*#__PURE__*/BigInt(1_000_000);
const bigint1e9 = /*#__PURE__*/BigInt(1_000_000_000);
const DURATION_REGEX = /^(-?\d+(?:\.\d+)?)\s+(nanos?|micros?|millis?|seconds?|minutes?|hours?|days?|weeks?)$/;
/**
 * @since 2.0.0
 */
const decode = input => {
  if (isDuration(input)) {
    return input;
  } else if ((0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj)(input)) {
    return millis(input);
  } else if ((0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isBigInt */ .C4)(input)) {
    return nanos(input);
  } else if (Array.isArray(input) && input.length === 2 && input.every(_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj)) {
    if (input[0] === -Infinity || input[1] === -Infinity || Number.isNaN(input[0]) || Number.isNaN(input[1])) {
      return zero;
    }
    if (input[0] === Infinity || input[1] === Infinity) {
      return infinity;
    }
    return nanos(BigInt(Math.round(input[0] * 1_000_000_000)) + BigInt(Math.round(input[1])));
  } else if ((0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(input)) {
    const match = DURATION_REGEX.exec(input);
    if (match) {
      const [_, valueStr, unit] = match;
      const value = Number(valueStr);
      switch (unit) {
        case "nano":
        case "nanos":
          return nanos(BigInt(valueStr));
        case "micro":
        case "micros":
          return micros(BigInt(valueStr));
        case "milli":
        case "millis":
          return millis(value);
        case "second":
        case "seconds":
          return seconds(value);
        case "minute":
        case "minutes":
          return minutes(value);
        case "hour":
        case "hours":
          return hours(value);
        case "day":
        case "days":
          return days(value);
        case "week":
        case "weeks":
          return weeks(value);
      }
    }
  }
  throw new Error("Invalid DurationInput");
};
/**
 * @since 2.5.0
 */
const decodeUnknown = /*#__PURE__*/(/* unused pure expression or super */ null && (Option.liftThrowable(decode)));
const zeroValue = {
  _tag: "Millis",
  millis: 0
};
const infinityValue = {
  _tag: "Infinity"
};
const DurationProto = {
  [TypeId]: TypeId,
  [_Hash_js__WEBPACK_IMPORTED_MODULE_1__/* .symbol */ .NA]() {
    return _Hash_js__WEBPACK_IMPORTED_MODULE_1__/* .cached */ .HX(this, _Hash_js__WEBPACK_IMPORTED_MODULE_1__/* .structure */ .Fh(this.value));
  },
  [_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .symbol */ .NA](that) {
    return isDuration(that) && equals(this, that);
  },
  toString() {
    return `Duration(${format(this)})`;
  },
  toJSON() {
    switch (this.value._tag) {
      case "Millis":
        return {
          _id: "Duration",
          _tag: "Millis",
          millis: this.value.millis
        };
      case "Nanos":
        return {
          _id: "Duration",
          _tag: "Nanos",
          hrtime: toHrTime(this)
        };
      case "Infinity":
        return {
          _id: "Duration",
          _tag: "Infinity"
        };
    }
  },
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_3__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  },
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_4__/* .pipeArguments */ .n)(this, arguments);
  }
};
const make = input => {
  const duration = Object.create(DurationProto);
  if ((0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj)(input)) {
    if (isNaN(input) || input <= 0) {
      duration.value = zeroValue;
    } else if (!Number.isFinite(input)) {
      duration.value = infinityValue;
    } else if (!Number.isInteger(input)) {
      duration.value = {
        _tag: "Nanos",
        nanos: BigInt(Math.round(input * 1_000_000))
      };
    } else {
      duration.value = {
        _tag: "Millis",
        millis: input
      };
    }
  } else if (input <= bigint0) {
    duration.value = zeroValue;
  } else {
    duration.value = {
      _tag: "Nanos",
      nanos: input
    };
  }
  return duration;
};
/**
 * @since 2.0.0
 * @category guards
 */
const isDuration = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .hasProperty */ .l$)(u, TypeId);
/**
 * @since 2.0.0
 * @category guards
 */
const isFinite = self => self.value._tag !== "Infinity";
/**
 * @since 3.5.0
 * @category guards
 */
const isZero = self => {
  switch (self.value._tag) {
    case "Millis":
      {
        return self.value.millis === 0;
      }
    case "Nanos":
      {
        return self.value.nanos === bigint0;
      }
    case "Infinity":
      {
        return false;
      }
  }
};
/**
 * @since 2.0.0
 * @category constructors
 */
const zero = /*#__PURE__*/make(0);
/**
 * @since 2.0.0
 * @category constructors
 */
const infinity = /*#__PURE__*/make(Infinity);
/**
 * @since 2.0.0
 * @category constructors
 */
const nanos = nanos => make(nanos);
/**
 * @since 2.0.0
 * @category constructors
 */
const micros = micros => make(micros * bigint1e3);
/**
 * @since 2.0.0
 * @category constructors
 */
const millis = millis => make(millis);
/**
 * @since 2.0.0
 * @category constructors
 */
const seconds = seconds => make(seconds * 1000);
/**
 * @since 2.0.0
 * @category constructors
 */
const minutes = minutes => make(minutes * 60_000);
/**
 * @since 2.0.0
 * @category constructors
 */
const hours = hours => make(hours * 3_600_000);
/**
 * @since 2.0.0
 * @category constructors
 */
const days = days => make(days * 86_400_000);
/**
 * @since 2.0.0
 * @category constructors
 */
const weeks = weeks => make(weeks * 604_800_000);
/**
 * @since 2.0.0
 * @category getters
 */
const toMillis = self => match(self, {
  onMillis: millis => millis,
  onNanos: nanos => Number(nanos) / 1_000_000
});
/**
 * @since 2.0.0
 * @category getters
 */
const toSeconds = self => match(self, {
  onMillis: millis => millis / 1_000,
  onNanos: nanos => Number(nanos) / 1_000_000_000
});
/**
 * @since 3.8.0
 * @category getters
 */
const toMinutes = self => match(self, {
  onMillis: millis => millis / 60_000,
  onNanos: nanos => Number(nanos) / 60_000_000_000
});
/**
 * @since 3.8.0
 * @category getters
 */
const toHours = self => match(self, {
  onMillis: millis => millis / 3_600_000,
  onNanos: nanos => Number(nanos) / 3_600_000_000_000
});
/**
 * @since 3.8.0
 * @category getters
 */
const toDays = self => match(self, {
  onMillis: millis => millis / 86_400_000,
  onNanos: nanos => Number(nanos) / 86_400_000_000_000
});
/**
 * @since 3.8.0
 * @category getters
 */
const toWeeks = self => match(self, {
  onMillis: millis => millis / 604_800_000,
  onNanos: nanos => Number(nanos) / 604_800_000_000_000
});
/**
 * Get the duration in nanoseconds as a bigint.
 *
 * If the duration is infinite, returns `Option.none()`
 *
 * @since 2.0.0
 * @category getters
 */
const toNanos = self => {
  const _self = decode(self);
  switch (_self.value._tag) {
    case "Infinity":
      return _Option_js__WEBPACK_IMPORTED_MODULE_5__/* .none */ .YP();
    case "Nanos":
      return _Option_js__WEBPACK_IMPORTED_MODULE_5__/* .some */ .G(_self.value.nanos);
    case "Millis":
      return _Option_js__WEBPACK_IMPORTED_MODULE_5__/* .some */ .G(BigInt(Math.round(_self.value.millis * 1_000_000)));
  }
};
/**
 * Get the duration in nanoseconds as a bigint.
 *
 * If the duration is infinite, it throws an error.
 *
 * @since 2.0.0
 * @category getters
 */
const unsafeToNanos = self => {
  const _self = decode(self);
  switch (_self.value._tag) {
    case "Infinity":
      throw new Error("Cannot convert infinite duration to nanos");
    case "Nanos":
      return _self.value.nanos;
    case "Millis":
      return BigInt(Math.round(_self.value.millis * 1_000_000));
  }
};
/**
 * @since 2.0.0
 * @category getters
 */
const toHrTime = self => {
  const _self = decode(self);
  switch (_self.value._tag) {
    case "Infinity":
      return [Infinity, 0];
    case "Nanos":
      return [Number(_self.value.nanos / bigint1e9), Number(_self.value.nanos % bigint1e9)];
    case "Millis":
      return [Math.floor(_self.value.millis / 1000), Math.round(_self.value.millis % 1000 * 1_000_000)];
  }
};
/**
 * @since 2.0.0
 * @category pattern matching
 */
const match = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, options) => {
  const _self = decode(self);
  switch (_self.value._tag) {
    case "Nanos":
      return options.onNanos(_self.value.nanos);
    case "Infinity":
      return options.onMillis(Infinity);
    case "Millis":
      return options.onMillis(_self.value.millis);
  }
});
/**
 * @since 2.0.0
 * @category pattern matching
 */
const matchWith = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(3, (self, that, options) => {
  const _self = decode(self);
  const _that = decode(that);
  if (_self.value._tag === "Infinity" || _that.value._tag === "Infinity") {
    return options.onMillis(toMillis(_self), toMillis(_that));
  } else if (_self.value._tag === "Nanos" || _that.value._tag === "Nanos") {
    const selfNanos = _self.value._tag === "Nanos" ? _self.value.nanos : BigInt(Math.round(_self.value.millis * 1_000_000));
    const thatNanos = _that.value._tag === "Nanos" ? _that.value.nanos : BigInt(Math.round(_that.value.millis * 1_000_000));
    return options.onNanos(selfNanos, thatNanos);
  }
  return options.onMillis(_self.value.millis, _that.value.millis);
});
/**
 * @category instances
 * @since 2.0.0
 */
const Order = /*#__PURE__*/(/* unused pure expression or super */ null && (order.make((self, that) => matchWith(self, that, {
  onMillis: (self, that) => self < that ? -1 : self > that ? 1 : 0,
  onNanos: (self, that) => self < that ? -1 : self > that ? 1 : 0
}))));
/**
 * Checks if a `Duration` is between a `minimum` and `maximum` value.
 *
 * @category predicates
 * @since 2.0.0
 */
const between = /*#__PURE__*/(/* unused pure expression or super */ null && (order.between( /*#__PURE__*/order.mapInput(Order, decode))));
/**
 * @category instances
 * @since 2.0.0
 */
const Equivalence = (self, that) => matchWith(self, that, {
  onMillis: (self, that) => self === that,
  onNanos: (self, that) => self === that
});
const _min = /*#__PURE__*/(/* unused pure expression or super */ null && (order.min(Order)));
/**
 * @since 2.0.0
 */
const min = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => _min(decode(self), decode(that)))));
const _max = /*#__PURE__*/(/* unused pure expression or super */ null && (order.max(Order)));
/**
 * @since 2.0.0
 * @category order
 */
const max = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => _max(decode(self), decode(that)))));
const _clamp = /*#__PURE__*/(/* unused pure expression or super */ null && (order.clamp(Order)));
/**
 * @since 2.0.0
 * @category order
 */
const clamp = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, options) => _clamp(decode(self), {
  minimum: decode(options.minimum),
  maximum: decode(options.maximum)
}))));
/**
 * @since 2.4.19
 * @category math
 */
const divide = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, by) => match(self, {
  onMillis: millis => {
    if (by === 0 || isNaN(by) || !Number.isFinite(by)) {
      return Option.none();
    }
    return Option.some(make(millis / by));
  },
  onNanos: nanos => {
    if (isNaN(by) || by <= 0 || !Number.isFinite(by)) {
      return Option.none();
    }
    try {
      return Option.some(make(nanos / BigInt(by)));
    } catch (e) {
      return Option.none();
    }
  }
}))));
/**
 * @since 2.4.19
 * @category math
 */
const unsafeDivide = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, by) => match(self, {
  onMillis: millis => make(millis / by),
  onNanos: nanos => {
    if (isNaN(by) || by < 0 || Object.is(by, -0)) {
      return zero;
    } else if (Object.is(by, 0) || !Number.isFinite(by)) {
      return infinity;
    }
    return make(nanos / BigInt(by));
  }
}))));
/**
 * @since 2.0.0
 * @category math
 */
const times = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, times) => match(self, {
  onMillis: millis => make(millis * times),
  onNanos: nanos => make(nanos * BigInt(times))
}))));
/**
 * @since 2.0.0
 * @category math
 */
const subtract = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => matchWith(self, that, {
  onMillis: (self, that) => make(self - that),
  onNanos: (self, that) => make(self - that)
}))));
/**
 * @since 2.0.0
 * @category math
 */
const sum = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => matchWith(self, that, {
  onMillis: (self, that) => make(self + that),
  onNanos: (self, that) => make(self + that)
}))));
/**
 * @since 2.0.0
 * @category predicates
 */
const lessThan = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => matchWith(self, that, {
  onMillis: (self, that) => self < that,
  onNanos: (self, that) => self < that
}))));
/**
 * @since 2.0.0
 * @category predicates
 */
const lessThanOrEqualTo = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, that) => matchWith(self, that, {
  onMillis: (self, that) => self <= that,
  onNanos: (self, that) => self <= that
}));
/**
 * @since 2.0.0
 * @category predicates
 */
const greaterThan = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => matchWith(self, that, {
  onMillis: (self, that) => self > that,
  onNanos: (self, that) => self > that
}))));
/**
 * @since 2.0.0
 * @category predicates
 */
const greaterThanOrEqualTo = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, that) => matchWith(self, that, {
  onMillis: (self, that) => self >= that,
  onNanos: (self, that) => self >= that
}));
/**
 * @since 2.0.0
 * @category predicates
 */
const equals = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, that) => Equivalence(decode(self), decode(that)));
/**
 * Converts a `Duration` to its parts.
 *
 * @since 3.8.0
 * @category conversions
 */
const parts = self => {
  const duration = decode(self);
  if (duration.value._tag === "Infinity") {
    return {
      days: Infinity,
      hours: Infinity,
      minutes: Infinity,
      seconds: Infinity,
      millis: Infinity,
      nanos: Infinity
    };
  }
  const nanos = unsafeToNanos(duration);
  const ms = nanos / bigint1e6;
  const sec = ms / bigint1e3;
  const min = sec / bigint60;
  const hr = min / bigint60;
  const days = hr / bigint24;
  return {
    days: Number(days),
    hours: Number(hr % bigint24),
    minutes: Number(min % bigint60),
    seconds: Number(sec % bigint60),
    millis: Number(ms % bigint1e3),
    nanos: Number(nanos % bigint1e6)
  };
};
/**
 * Converts a `Duration` to a human readable string.
 *
 * @since 2.0.0
 * @category conversions
 * @example
 * ```ts
 * import { Duration } from "effect"
 *
 * Duration.format(Duration.millis(1000)) // "1s"
 * Duration.format(Duration.millis(1001)) // "1s 1ms"
 * ```
 */
const format = self => {
  const duration = decode(self);
  if (duration.value._tag === "Infinity") {
    return "Infinity";
  }
  if (isZero(duration)) {
    return "0";
  }
  const fragments = parts(duration);
  const pieces = [];
  if (fragments.days !== 0) {
    pieces.push(`${fragments.days}d`);
  }
  if (fragments.hours !== 0) {
    pieces.push(`${fragments.hours}h`);
  }
  if (fragments.minutes !== 0) {
    pieces.push(`${fragments.minutes}m`);
  }
  if (fragments.seconds !== 0) {
    pieces.push(`${fragments.seconds}s`);
  }
  if (fragments.millis !== 0) {
    pieces.push(`${fragments.millis}ms`);
  }
  if (fragments.nanos !== 0) {
    pieces.push(`${fragments.nanos}ns`);
  }
  return pieces.join(" ");
};
/**
 * Formats a Duration into an ISO8601 duration string.
 *
 * Months are assumed to be 30 days and years are assumed to be 365 days.
 *
 * Milliseconds and nanoseconds are expressed as fractional seconds.
 *
 * @example
 * ```ts
 * import { Duration } from "effect"
 *
 * Duration.unsafeFormatIso(Duration.days(1)) // => "P1D"
 * Duration.unsafeFormatIso(Duration.minutes(90)) // => "PT1H30M"
 * Duration.unsafeFormatIso(Duration.millis(1500)) // => "PT1.5S"
 * ```
 *
 * @throws `RangeError` If the duration is not finite.
 *
 * @since 3.13.0
 * @category conversions
 */
const unsafeFormatIso = self => {
  const duration = decode(self);
  if (!isFinite(duration)) {
    throw new RangeError("Cannot format infinite duration");
  }
  const fragments = [];
  const {
    days,
    hours,
    millis,
    minutes,
    nanos,
    seconds
  } = parts(duration);
  let rest = days;
  if (rest >= 365) {
    const years = Math.floor(rest / 365);
    rest %= 365;
    fragments.push(`${years}Y`);
  }
  if (rest >= 30) {
    const months = Math.floor(rest / 30);
    rest %= 30;
    fragments.push(`${months}M`);
  }
  if (rest >= 7) {
    const weeks = Math.floor(rest / 7);
    rest %= 7;
    fragments.push(`${weeks}W`);
  }
  if (rest > 0) {
    fragments.push(`${rest}D`);
  }
  if (hours !== 0 || minutes !== 0 || seconds !== 0 || millis !== 0 || nanos !== 0) {
    fragments.push("T");
    if (hours !== 0) {
      fragments.push(`${hours}H`);
    }
    if (minutes !== 0) {
      fragments.push(`${minutes}M`);
    }
    if (seconds !== 0 || millis !== 0 || nanos !== 0) {
      const total = BigInt(seconds) * bigint1e9 + BigInt(millis) * bigint1e6 + BigInt(nanos);
      const str = (Number(total) / 1e9).toFixed(9).replace(/\.?0+$/, "");
      fragments.push(`${str}S`);
    }
  }
  return `P${fragments.join("") || "T0S"}`;
};
/**
 * Formats a Duration into an ISO8601 duration string.
 *
 * Months are assumed to be 30 days and years are assumed to be 365 days.
 *
 * Returns `Option.none()` if the duration is infinite.
 *
 * @example
 * ```ts
 * import { Duration, Option } from "effect"
 *
 * Duration.formatIso(Duration.days(1)) // => Option.some("P1D")
 * Duration.formatIso(Duration.minutes(90)) // => Option.some("PT1H30M")
 * Duration.formatIso(Duration.millis(1500)) // => Option.some("PT1.5S")
 * Duration.formatIso(Duration.infinity) // => Option.none()
 * ```
 *
 * @since 3.13.0
 * @category conversions
 */
const formatIso = self => {
  const duration = decode(self);
  return isFinite(duration) ? Option.some(unsafeFormatIso(duration)) : Option.none();
};
/**
 * Parses an ISO8601 duration string into a `Duration`.
 *
 * Months are assumed to be 30 days and years are assumed to be 365 days.
 *
 * @example
 * ```ts
 * import { Duration, Option } from "effect"
 *
 * Duration.fromIso("P1D") // => Option.some(Duration.days(1))
 * Duration.fromIso("PT1H") // => Option.some(Duration.hours(1))
 * Duration.fromIso("PT1M") // => Option.some(Duration.minutes(1))
 * Duration.fromIso("PT1.5S") // => Option.some(Duration.seconds(1.5))
 * ```
 *
 * @since 3.13.0
 * @category conversions
 */
const fromIso = iso => {
  const result = DURATION_ISO_REGEX.exec(iso);
  if (result == null) {
    return Option.none();
  }
  const [years, months, weeks, days, hours, mins, secs] = result.slice(1, 8).map(_ => _ ? Number(_) : 0);
  const value = years * 365 * 24 * 60 * 60 + months * 30 * 24 * 60 * 60 + weeks * 7 * 24 * 60 * 60 + days * 24 * 60 * 60 + hours * 60 * 60 + mins * 60 + secs;
  return Option.some(seconds(value));
};
const DURATION_ISO_REGEX = /^P(?!$)(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?!$)(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?)?$/;
//# sourceMappingURL=Duration.js.map

/***/ }),

/***/ 96347:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$6P": function() { return /* binding */ Effect_all; },
  "Po9": function() { return /* binding */ andThen; },
  "kmb": function() { return /* binding */ catchAll; },
  "KPM": function() { return /* binding */ catchAllDefect; },
  "wEe": function() { return /* binding */ either; },
  "VSD": function() { return /* binding */ flatMap; },
  "Ed_": function() { return /* binding */ Effect_forEach; },
  "ijW": function() { return /* binding */ fromNullable; },
  "Yr4": function() { return /* binding */ gen; },
  "cdB": function() { return /* binding */ isEffect; },
  "UID": function() { return /* binding */ map; },
  "SAn": function() { return /* binding */ mapBoth; },
  "d1Y": function() { return /* binding */ mapError; },
  "PwY": function() { return /* binding */ matchEffect; },
  "vxS": function() { return /* binding */ orElse; },
  "LPI": function() { return /* binding */ orElseFail; },
  "MCc": function() { return /* binding */ promise; },
  "JJ_": function() { return /* binding */ provide; },
  "gMF": function() { return /* binding */ runFork; },
  "VR7": function() { return /* binding */ runPromise; },
  "Wno": function() { return /* binding */ runSync; },
  "ng0": function() { return /* binding */ Effect_succeed; },
  "RqG": function() { return /* binding */ suspend; },
  "JHF": function() { return /* binding */ try_; },
  "lmO": function() { return /* binding */ tryMapPromise; },
  "p6W": function() { return /* binding */ tryPromise; },
  "Hcj": function() { return /* binding */ _void; }
});

// UNUSED EXPORTS: Do, EffectTypeId, Service, Tag, acquireRelease, acquireReleaseInterruptible, acquireUseRelease, addFinalizer, allSuccesses, allWith, allowInterrupt, annotateCurrentSpan, annotateLogs, annotateLogsScoped, annotateSpans, ap, as, asSome, asSomeError, asVoid, async, asyncEffect, awaitAllChildren, bind, bindAll, bindTo, blocked, cacheRequestResult, cached, cachedFunction, cachedInvalidateWithTTL, cachedWithTTL, catch, catchAllCause, catchIf, catchSome, catchSomeCause, catchSomeDefect, catchTag, catchTags, cause, checkInterruptible, clock, clockWith, configProviderWith, console, consoleWith, context, contextWith, contextWithEffect, currentParentSpan, currentSpan, custom, daemonChildren, delay, descriptor, descriptorWith, die, dieMessage, dieSync, diffFiberRefs, disconnect, dropUntil, dropWhile, ensuring, ensuringChild, ensuringChildren, eventually, every, exists, exit, fail, failCause, failCauseSync, failSync, fiberId, fiberIdWith, filter, filterEffectOrElse, filterEffectOrFail, filterMap, filterOrDie, filterOrDieMessage, filterOrElse, filterOrFail, finalizersMask, findFirst, firstSuccessOf, flatten, flip, flipWith, fn, fnUntraced, forever, fork, forkAll, forkDaemon, forkIn, forkScoped, forkWithErrorHandler, fromFiber, fromFiberEffect, functionWithSpan, getFiberRefs, getRuntimeFlags, head, if, ignore, ignoreLogged, inheritFiberRefs, interrupt, interruptWith, interruptible, interruptibleMask, intoDeferred, isFailure, isSuccess, iterate, labelMetrics, labelMetricsScoped, let, liftPredicate, linkSpanCurrent, linkSpans, locally, locallyScoped, locallyScopedWith, locallyWith, log, logAnnotations, logDebug, logError, logFatal, logInfo, logTrace, logWarning, logWithLevel, loop, makeLatch, makeSemaphore, makeSpan, makeSpanScoped, mapAccum, mapErrorCause, mapInputContext, match, matchCause, matchCauseEffect, merge, mergeAll, metricLabels, negate, never, none, onError, onExit, onInterrupt, once, option, optionFromOptional, orDie, orDieWith, orElseSucceed, parallelErrors, parallelFinalizers, partition, patchFiberRefs, patchRuntimeFlags, provideService, provideServiceEffect, race, raceAll, raceFirst, raceWith, random, randomWith, reduce, reduceEffect, reduceRight, reduceWhile, repeat, repeatN, repeatOrElse, replicate, replicateEffect, request, retry, retryOrElse, runCallback, runPromiseExit, runRequestBlock, runSyncExit, runtime, sandbox, schedule, scheduleForked, scheduleFrom, scope, scopeWith, scoped, scopedWith, sequentialFinalizers, serviceConstants, serviceFunction, serviceFunctionEffect, serviceFunctions, serviceMembers, serviceOption, serviceOptional, setFiberRefs, sleep, spanAnnotations, spanLinks, step, succeedNone, succeedSome, summarized, supervised, sync, tagMetrics, tagMetricsScoped, takeUntil, takeWhile, tap, tapBoth, tapDefect, tapError, tapErrorCause, tapErrorTag, timed, timedWith, timeout, timeoutFail, timeoutFailCause, timeoutOption, timeoutTo, tracer, tracerWith, transplant, transposeMapOption, transposeOption, tryMap, uninterruptible, uninterruptibleMask, unless, unlessEffect, unsafeMakeLatch, unsafeMakeSemaphore, unsandbox, updateFiberRefs, updateService, useSpan, using, validate, validateAll, validateFirst, validateWith, when, whenEffect, whenFiberRef, whenLogLevel, whenRef, whileLoop, withClock, withClockScoped, withConcurrency, withConfigProvider, withConfigProviderScoped, withConsole, withConsoleScoped, withEarlyRelease, withFiberRuntime, withLogSpan, withMaxOpsBeforeYield, withMetric, withParentSpan, withRandom, withRandomScoped, withRequestBatching, withRequestCache, withRequestCaching, withRuntimeFlagsPatch, withRuntimeFlagsPatchScoped, withScheduler, withSchedulingPriority, withSpan, withSpanScoped, withTracer, withTracerEnabled, withTracerScoped, withTracerTiming, withUnhandledErrorLogLevel, yieldNow, zip, zipLeft, zipRight, zipWith

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Context.js
var esm_Context = __webpack_require__(20591);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/core.js + 1 modules
var internal_core = __webpack_require__(39355);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/defaultServices.js
var internal_defaultServices = __webpack_require__(74266);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/defaultServices/console.js
var defaultServices_console = __webpack_require__(2338);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/fiberRuntime.js + 14 modules
var internal_fiberRuntime = __webpack_require__(90886);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/console.js







/** @internal */
const console = /*#__PURE__*/internal_core/* map */.UID( /*#__PURE__*/internal_core/* fiberRefGet */.grZ(internal_defaultServices/* currentServices */.Pm), /*#__PURE__*/esm_Context/* get */.U2(defaultServices_console/* consoleTag */.KM));
/** @internal */
const consoleWith = f => internal_core/* fiberRefGetWith */.$Dw(internal_defaultServices/* currentServices */.Pm, services => f(esm_Context/* get */.U2(services, defaultServices_console/* consoleTag */.KM)));
/** @internal */
const withConsole = /*#__PURE__*/(0,Function/* dual */.OB)(2, (effect, value) => internal_core/* fiberRefLocallyWith */.LzL(effect, internal_defaultServices/* currentServices */.Pm, esm_Context/* add */.IH(defaultServices_console/* consoleTag */.KM, value)));
/** @internal */
const withConsoleScoped = console => internal_fiberRuntime/* fiberRefLocallyScopedWith */.lS(internal_defaultServices/* currentServices */.Pm, esm_Context/* add */.IH(defaultServices_console/* consoleTag */.KM, console));
/** @internal */
const setConsole = console => layer.scopedDiscard(fiberRuntime.fiberRefLocallyScopedWith(defaultServices.currentServices, Context.add(defaultConsole.consoleTag, console)));
/** @internal */
const assert = (condition, ...args) => consoleWith(_ => _.assert(condition, ...args));
/** @internal */
const clear = /*#__PURE__*/(/* unused pure expression or super */ null && (consoleWith(_ => _.clear)));
/** @internal */
const count = label => consoleWith(_ => _.count(label));
/** @internal */
const countReset = label => consoleWith(_ => _.countReset(label));
/** @internal */
const debug = (...args) => consoleWith(_ => _.debug(...args));
/** @internal */
const dir = (item, options) => consoleWith(_ => _.dir(item, options));
/** @internal */
const dirxml = (...args) => consoleWith(_ => _.dirxml(...args));
/** @internal */
const error = (...args) => consoleWith(_ => _.error(...args));
/** @internal */
const group = options => consoleWith(_ => fiberRuntime.acquireRelease(_.group(options), () => _.groupEnd));
/** @internal */
const info = (...args) => consoleWith(_ => _.info(...args));
/** @internal */
const log = (...args) => consoleWith(_ => _.log(...args));
/** @internal */
const table = (tabularData, properties) => consoleWith(_ => _.table(tabularData, properties));
/** @internal */
const time = label => consoleWith(_ => fiberRuntime.acquireRelease(_.time(label), () => _.timeEnd(label)));
/** @internal */
const timeLog = (label, ...args) => consoleWith(_ => _.timeLog(label, ...args));
/** @internal */
const trace = (...args) => consoleWith(_ => _.trace(...args));
/** @internal */
const warn = (...args) => consoleWith(_ => _.warn(...args));
/** @internal */
const withGroup = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => core.isEffect(args[0]), (self, options) => consoleWith(_ => core.acquireUseRelease(_.group(options), () => self, () => _.groupEnd)))));
/** @internal */
const withTime = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => core.isEffect(args[0]), (self, label) => consoleWith(_ => core.acquireUseRelease(_.time(label), () => self, () => _.timeEnd(label))))));
//# sourceMappingURL=console.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/core-effect.js + 3 modules
var core_effect = __webpack_require__(53623);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/effect/circular.js
var circular = __webpack_require__(34606);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/layer.js + 3 modules
var internal_layer = __webpack_require__(58590);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Duration.js
var esm_Duration = __webpack_require__(13571);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/GlobalValue.js
var GlobalValue = __webpack_require__(4726);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/blockedRequests.js
var blockedRequests = __webpack_require__(96850);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Deferred.js
var Deferred = __webpack_require__(72022);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Either.js
var Either = __webpack_require__(87585);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equal.js
var Equal = __webpack_require__(67492);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Exit.js
var Exit = __webpack_require__(76658);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Hash.js
var Hash = __webpack_require__(89379);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/MutableHashMap.js
var MutableHashMap = __webpack_require__(30424);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Inspectable.js
var Inspectable = __webpack_require__(16371);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Pipeable.js
var Pipeable = __webpack_require__(92817);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/MutableList.js
/**
 * @since 2.0.0
 */



const TypeId = /*#__PURE__*/Symbol.for("effect/MutableList");
const MutableListProto = {
  [TypeId]: TypeId,
  [Symbol.iterator]() {
    let done = false;
    let head = this.head;
    return {
      next() {
        if (done) {
          return this.return();
        }
        if (head == null) {
          done = true;
          return this.return();
        }
        const value = head.value;
        head = head.next;
        return {
          done,
          value
        };
      },
      return(value) {
        if (!done) {
          done = true;
        }
        return {
          done: true,
          value
        };
      }
    };
  },
  toString() {
    return (0,Inspectable/* format */.WU)(this.toJSON());
  },
  toJSON() {
    return {
      _id: "MutableList",
      values: Array.from(this).map(Inspectable/* toJSON */.au)
    };
  },
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return this.toJSON();
  },
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
};
/** @internal */
const makeNode = value => ({
  value,
  removed: false,
  prev: undefined,
  next: undefined
});
/**
 * Creates an empty `MutableList`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = () => {
  const list = Object.create(MutableListProto);
  list.head = undefined;
  list.tail = undefined;
  list._length = 0;
  return list;
};
/**
 * Creates a new `MutableList` from an iterable collection of values.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable = iterable => {
  const list = empty();
  for (const element of iterable) {
    append(list, element);
  }
  return list;
};
/**
 * Creates a new `MutableList` from the specified elements.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = (...elements) => fromIterable(elements);
/**
 * Returns `true` if the list contains zero elements, `false`, otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isEmpty = self => MutableList_length(self) === 0;
/**
 * Returns the length of the list.
 *
 * @since 2.0.0
 * @category getters
 */
const MutableList_length = self => self._length;
/**
 * Returns the last element of the list, if it exists.
 *
 * @since 2.0.0
 * @category getters
 */
const tail = self => self.tail === undefined ? undefined : self.tail.value;
/**
 * Returns the first element of the list, if it exists.
 *
 * @since 2.0.0
 * @category getters
 */
const head = self => self.head === undefined ? undefined : self.head.value;
/**
 * Executes the specified function `f` for each element in the list.
 *
 * @since 2.0.0
 * @category traversing
 */
const forEach = /*#__PURE__*/(/* unused pure expression or super */ null && (Dual.dual(2, (self, f) => {
  let current = self.head;
  while (current !== undefined) {
    f(current.value);
    current = current.next;
  }
})));
/**
 * Removes all elements from the doubly-linked list.
 *
 * @since 2.0.0
 */
const MutableList_reset = self => {
  ;
  self._length = 0;
  self.head = undefined;
  self.tail = undefined;
  return self;
};
/**
 * Appends the specified element to the end of the `MutableList`.
 *
 * @category concatenating
 * @since 2.0.0
 */
const append = /*#__PURE__*/Function/* dual */.OB(2, (self, value) => {
  const node = makeNode(value);
  if (self.head === undefined) {
    self.head = node;
  }
  if (self.tail === undefined) {
    self.tail = node;
  } else {
    self.tail.next = node;
    node.prev = self.tail;
    self.tail = node;
  }
  ;
  self._length += 1;
  return self;
});
/**
 * Removes the first value from the list and returns it, if it exists.
 *
 * @since 0.0.1
 */
const shift = self => {
  const head = self.head;
  if (head !== undefined) {
    remove(self, head);
    return head.value;
  }
  return undefined;
};
/**
 * Removes the last value from the list and returns it, if it exists.
 *
 * @since 0.0.1
 */
const pop = self => {
  const tail = self.tail;
  if (tail !== undefined) {
    remove(self, tail);
    return tail.value;
  }
  return undefined;
};
/**
 * Prepends the specified value to the beginning of the list.
 *
 * @category concatenating
 * @since 2.0.0
 */
const prepend = /*#__PURE__*/(/* unused pure expression or super */ null && (Dual.dual(2, (self, value) => {
  const node = makeNode(value);
  node.next = self.head;
  if (self.head !== undefined) {
    self.head.prev = node;
  }
  self.head = node;
  if (self.tail === undefined) {
    self.tail = node;
  }
  ;
  self._length += 1;
  return self;
})));
const remove = (self, node) => {
  if (node.removed) {
    return;
  }
  node.removed = true;
  if (node.prev !== undefined && node.next !== undefined) {
    node.prev.next = node.next;
    node.next.prev = node.prev;
  } else if (node.prev !== undefined) {
    self.tail = node.prev;
    node.prev.next = undefined;
  } else if (node.next !== undefined) {
    self.head = node.next;
    node.next.prev = undefined;
  } else {
    self.tail = undefined;
    self.head = undefined;
  }
  if (self._length > 0) {
    ;
    self._length -= 1;
  }
};
//# sourceMappingURL=MutableList.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/MutableQueue.js
/**
 * @since 2.0.0
 */





const MutableQueue_TypeId = /*#__PURE__*/Symbol.for("effect/MutableQueue");
/**
 * @since 2.0.0
 * @category symbol
 */
const EmptyMutableQueue = /*#__PURE__*/Symbol.for("effect/mutable/MutableQueue/Empty");
const MutableQueueProto = {
  [MutableQueue_TypeId]: MutableQueue_TypeId,
  [Symbol.iterator]() {
    return Array.from(this.queue)[Symbol.iterator]();
  },
  toString() {
    return (0,Inspectable/* format */.WU)(this.toJSON());
  },
  toJSON() {
    return {
      _id: "MutableQueue",
      values: Array.from(this).map(Inspectable/* toJSON */.au)
    };
  },
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return this.toJSON();
  },
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
};
const MutableQueue_make = capacity => {
  const queue = Object.create(MutableQueueProto);
  queue.queue = empty();
  queue.capacity = capacity;
  return queue;
};
/**
 * Creates a new bounded `MutableQueue`.
 *
 * @since 2.0.0
 * @category constructors
 */
const bounded = capacity => MutableQueue_make(capacity);
/**
 * Creates a new unbounded `MutableQueue`.
 *
 * @since 2.0.0
 * @category constructors
 */
const unbounded = () => MutableQueue_make(undefined);
/**
 * Returns the current number of elements in the queue.
 *
 * @since 2.0.0
 * @category getters
 */
const MutableQueue_length = self => MutableList.length(self.queue);
/**
 * Returns `true` if the queue is empty, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const MutableQueue_isEmpty = self => MutableList.isEmpty(self.queue);
/**
 * Returns `true` if the queue is full, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isFull = self => self.capacity === undefined ? false : MutableList.length(self.queue) === self.capacity;
/**
 * The **maximum** number of elements that a queue can hold.
 *
 * **Note**: unbounded queues can still implement this interface with
 * `capacity = Infinity`.
 *
 * @since 2.0.0
 * @category getters
 */
const capacity = self => self.capacity === undefined ? Infinity : self.capacity;
/**
 * Offers an element to the queue.
 *
 * Returns whether the enqueue was successful or not.
 *
 * @since 2.0.0
 */
const offer = /*#__PURE__*/Function/* dual */.OB(2, (self, value) => {
  const queueLength = MutableList_length(self.queue);
  if (self.capacity !== undefined && queueLength === self.capacity) {
    return false;
  }
  append(value)(self.queue);
  return true;
});
/**
 * Enqueues a collection of values into the queue.
 *
 * Returns a `Chunk` of the values that were **not** able to be enqueued.
 *
 * @since 2.0.0
 */
const offerAll = /*#__PURE__*/(/* unused pure expression or super */ null && (Dual.dual(2, (self, values) => {
  const iterator = values[Symbol.iterator]();
  let next;
  let remainder = Chunk.empty();
  let offering = true;
  while (offering && (next = iterator.next()) && !next.done) {
    offering = offer(next.value)(self);
  }
  while (next != null && !next.done) {
    remainder = Chunk.prepend(next.value)(remainder);
    next = iterator.next();
  }
  return Chunk.reverse(remainder);
})));
/**
 * Dequeues an element from the queue.
 *
 * Returns either an element from the queue, or the `def` param.
 *
 * **Note**: if there is no meaningful default for your type, you can always
 * use `poll(MutableQueue.EmptyMutableQueue)`.
 *
 * @since 2.0.0
 */
const poll = /*#__PURE__*/Function/* dual */.OB(2, (self, def) => {
  if (isEmpty(self.queue)) {
    return def;
  }
  return shift(self.queue);
});
/**
 * Dequeues up to `n` elements from the queue.
 *
 * Returns a `List` of up to `n` elements.
 *
 * @since 2.0.0
 */
const pollUpTo = /*#__PURE__*/(/* unused pure expression or super */ null && (Dual.dual(2, (self, n) => {
  let result = Chunk.empty();
  let count = 0;
  while (count < n) {
    const element = poll(EmptyMutableQueue)(self);
    if (element === EmptyMutableQueue) {
      break;
    }
    result = Chunk.prepend(element)(result);
    count += 1;
  }
  return Chunk.reverse(result);
})));
//# sourceMappingURL=MutableQueue.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/MutableRef.js
var MutableRef = __webpack_require__(23182);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var Predicate = __webpack_require__(71335);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/data.js
var data = __webpack_require__(84685);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/fiberId.js
var fiberId = __webpack_require__(26219);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/cache.js


















/** @internal */
const complete = (key, exit, entryStats, timeToLiveMillis) => data/* struct */.n_({
  _tag: "Complete",
  key,
  exit,
  entryStats,
  timeToLiveMillis
});
/** @internal */
const pending = (key, deferred) => data/* struct */.n_({
  _tag: "Pending",
  key,
  deferred
});
/** @internal */
const refreshing = (deferred, complete) => data/* struct */.n_({
  _tag: "Refreshing",
  deferred,
  complete
});
/** @internal */
const MapKeyTypeId = /*#__PURE__*/Symbol.for("effect/Cache/MapKey");
class MapKeyImpl {
  current;
  [MapKeyTypeId] = MapKeyTypeId;
  previous = undefined;
  next = undefined;
  constructor(current) {
    this.current = current;
  }
  [Hash/* symbol */.NA]() {
    return (0,Function/* pipe */.zG)(Hash/* hash */.vp(this.current), Hash/* combine */.$e(Hash/* hash */.vp(this.previous)), Hash/* combine */.$e(Hash/* hash */.vp(this.next)), Hash/* cached */.HX(this));
  }
  [Equal/* symbol */.NA](that) {
    if (this === that) {
      return true;
    }
    return isMapKey(that) && Equal/* equals */.fS(this.current, that.current) && Equal/* equals */.fS(this.previous, that.previous) && Equal/* equals */.fS(this.next, that.next);
  }
}
/** @internal */
const makeMapKey = current => new MapKeyImpl(current);
/** @internal */
const isMapKey = u => (0,Predicate/* hasProperty */.l$)(u, MapKeyTypeId);
class KeySetImpl {
  head = undefined;
  tail = undefined;
  add(key) {
    if (key !== this.tail) {
      if (this.tail === undefined) {
        this.head = key;
        this.tail = key;
      } else {
        const previous = key.previous;
        const next = key.next;
        if (next !== undefined) {
          key.next = undefined;
          if (previous !== undefined) {
            previous.next = next;
            next.previous = previous;
          } else {
            this.head = next;
            this.head.previous = undefined;
          }
        }
        this.tail.next = key;
        key.previous = this.tail;
        this.tail = key;
      }
    }
  }
  remove() {
    const key = this.head;
    if (key !== undefined) {
      const next = key.next;
      if (next !== undefined) {
        key.next = undefined;
        this.head = next;
        this.head.previous = undefined;
      } else {
        this.head = undefined;
        this.tail = undefined;
      }
    }
    return key;
  }
}
/** @internal */
const makeKeySet = () => new KeySetImpl();
/**
 * Constructs a new `CacheState` from the specified values.
 *
 * @internal
 */
const makeCacheState = (map, keys, accesses, updating, hits, misses) => ({
  map,
  keys,
  accesses,
  updating,
  hits,
  misses
});
/**
 * Constructs an initial cache state.
 *
 * @internal
 */
const initialCacheState = () => makeCacheState(MutableHashMap/* empty */.cS(), makeKeySet(), unbounded(), MutableRef/* make */.Sy(false), 0, 0);
/** @internal */
const CacheSymbolKey = "effect/Cache";
/** @internal */
const CacheTypeId = /*#__PURE__*/Symbol.for(CacheSymbolKey);
const cacheVariance = {
  /* c8 ignore next */
  _Key: _ => _,
  /* c8 ignore next */
  _Error: _ => _,
  /* c8 ignore next */
  _Value: _ => _
};
/** @internal */
const ConsumerCacheSymbolKey = "effect/ConsumerCache";
/** @internal */
const ConsumerCacheTypeId = /*#__PURE__*/Symbol.for(ConsumerCacheSymbolKey);
const consumerCacheVariance = {
  /* c8 ignore next */
  _Key: _ => _,
  /* c8 ignore next */
  _Error: _ => _,
  /* c8 ignore next */
  _Value: _ => _
};
/** @internal */
const makeCacheStats = options => options;
/** @internal */
const makeEntryStats = loadedMillis => ({
  loadedMillis
});
class CacheImpl {
  capacity;
  context;
  fiberId;
  lookup;
  timeToLive;
  [CacheTypeId] = cacheVariance;
  [ConsumerCacheTypeId] = consumerCacheVariance;
  cacheState;
  constructor(capacity, context, fiberId, lookup, timeToLive) {
    this.capacity = capacity;
    this.context = context;
    this.fiberId = fiberId;
    this.lookup = lookup;
    this.timeToLive = timeToLive;
    this.cacheState = initialCacheState();
  }
  get(key) {
    return internal_core/* map */.UID(this.getEither(key), Either/* merge */.TS);
  }
  get cacheStats() {
    return internal_core/* sync */.Z_X(() => makeCacheStats({
      hits: this.cacheState.hits,
      misses: this.cacheState.misses,
      size: MutableHashMap/* size */.dp(this.cacheState.map)
    }));
  }
  getOption(key) {
    return internal_core/* suspend */.RqG(() => Option/* match */.EQ(MutableHashMap/* get */.U2(this.cacheState.map, key), {
      onNone: () => {
        const mapKey = makeMapKey(key);
        this.trackAccess(mapKey);
        this.trackMiss();
        return internal_core/* succeed */.ng0(Option/* none */.YP());
      },
      onSome: value => this.resolveMapValue(value)
    }));
  }
  getOptionComplete(key) {
    return internal_core/* suspend */.RqG(() => Option/* match */.EQ(MutableHashMap/* get */.U2(this.cacheState.map, key), {
      onNone: () => {
        const mapKey = makeMapKey(key);
        this.trackAccess(mapKey);
        this.trackMiss();
        return internal_core/* succeed */.ng0(Option/* none */.YP());
      },
      onSome: value => this.resolveMapValue(value, true)
    }));
  }
  contains(key) {
    return internal_core/* sync */.Z_X(() => MutableHashMap/* has */.e$(this.cacheState.map, key));
  }
  entryStats(key) {
    return internal_core/* sync */.Z_X(() => {
      const option = MutableHashMap/* get */.U2(this.cacheState.map, key);
      if (Option/* isSome */.pC(option)) {
        switch (option.value._tag) {
          case "Complete":
            {
              const loaded = option.value.entryStats.loadedMillis;
              return Option/* some */.G(makeEntryStats(loaded));
            }
          case "Pending":
            {
              return Option/* none */.YP();
            }
          case "Refreshing":
            {
              const loaded = option.value.complete.entryStats.loadedMillis;
              return Option/* some */.G(makeEntryStats(loaded));
            }
        }
      }
      return Option/* none */.YP();
    });
  }
  getEither(key) {
    return internal_core/* suspend */.RqG(() => {
      const k = key;
      let mapKey = undefined;
      let deferred = undefined;
      let value = Option/* getOrUndefined */.jD(MutableHashMap/* get */.U2(this.cacheState.map, k));
      if (value === undefined) {
        deferred = Deferred/* unsafeMake */.t0(this.fiberId);
        mapKey = makeMapKey(k);
        if (MutableHashMap/* has */.e$(this.cacheState.map, k)) {
          value = Option/* getOrUndefined */.jD(MutableHashMap/* get */.U2(this.cacheState.map, k));
        } else {
          MutableHashMap/* set */.t8(this.cacheState.map, k, pending(mapKey, deferred));
        }
      }
      if (value === undefined) {
        this.trackAccess(mapKey);
        this.trackMiss();
        return internal_core/* map */.UID(this.lookupValueOf(key, deferred), Either/* right */.F2);
      } else {
        return internal_core/* flatMap */.VSD(this.resolveMapValue(value), Option/* match */.EQ({
          onNone: () => this.getEither(key),
          onSome: value => internal_core/* succeed */.ng0(Either/* left */.t$(value))
        }));
      }
    });
  }
  invalidate(key) {
    return internal_core/* sync */.Z_X(() => {
      MutableHashMap/* remove */.Od(this.cacheState.map, key);
    });
  }
  invalidateWhen(key, when) {
    return internal_core/* sync */.Z_X(() => {
      const value = MutableHashMap/* get */.U2(this.cacheState.map, key);
      if (Option/* isSome */.pC(value) && value.value._tag === "Complete") {
        if (value.value.exit._tag === "Success") {
          if (when(value.value.exit.value)) {
            MutableHashMap/* remove */.Od(this.cacheState.map, key);
          }
        }
      }
    });
  }
  get invalidateAll() {
    return internal_core/* sync */.Z_X(() => {
      this.cacheState.map = MutableHashMap/* empty */.cS();
    });
  }
  refresh(key) {
    return core_effect/* clockWith */.UA(clock => internal_core/* suspend */.RqG(() => {
      const k = key;
      const deferred = Deferred/* unsafeMake */.t0(this.fiberId);
      let value = Option/* getOrUndefined */.jD(MutableHashMap/* get */.U2(this.cacheState.map, k));
      if (value === undefined) {
        if (MutableHashMap/* has */.e$(this.cacheState.map, k)) {
          value = Option/* getOrUndefined */.jD(MutableHashMap/* get */.U2(this.cacheState.map, k));
        } else {
          MutableHashMap/* set */.t8(this.cacheState.map, k, pending(makeMapKey(k), deferred));
        }
      }
      if (value === undefined) {
        return internal_core/* asVoid */.a2S(this.lookupValueOf(key, deferred));
      } else {
        switch (value._tag) {
          case "Complete":
            {
              if (this.hasExpired(clock, value.timeToLiveMillis)) {
                const found = Option/* getOrUndefined */.jD(MutableHashMap/* get */.U2(this.cacheState.map, k));
                if (Equal/* equals */.fS(found, value)) {
                  MutableHashMap/* remove */.Od(this.cacheState.map, k);
                }
                return internal_core/* asVoid */.a2S(this.get(key));
              }
              // Only trigger the lookup if we're still the current value, `completedResult`
              return (0,Function/* pipe */.zG)(this.lookupValueOf(key, deferred), core_effect/* when */.gx(() => {
                const current = Option/* getOrUndefined */.jD(MutableHashMap/* get */.U2(this.cacheState.map, k));
                if (Equal/* equals */.fS(current, value)) {
                  const mapValue = refreshing(deferred, value);
                  MutableHashMap/* set */.t8(this.cacheState.map, k, mapValue);
                  return true;
                }
                return false;
              }), internal_core/* asVoid */.a2S);
            }
          case "Pending":
            {
              return Deferred/* await */.Uz(value.deferred);
            }
          case "Refreshing":
            {
              return Deferred/* await */.Uz(value.deferred);
            }
        }
      }
    }));
  }
  set(key, value) {
    return core_effect/* clockWith */.UA(clock => internal_core/* sync */.Z_X(() => {
      const now = clock.unsafeCurrentTimeMillis();
      const k = key;
      const lookupResult = Exit/* succeed */.ng(value);
      const mapValue = complete(makeMapKey(k), lookupResult, makeEntryStats(now), now + esm_Duration/* toMillis */.eq(esm_Duration/* decode */.Jx(this.timeToLive(lookupResult))));
      MutableHashMap/* set */.t8(this.cacheState.map, k, mapValue);
    }));
  }
  get size() {
    return internal_core/* sync */.Z_X(() => {
      return MutableHashMap/* size */.dp(this.cacheState.map);
    });
  }
  get values() {
    return internal_core/* sync */.Z_X(() => {
      const values = [];
      for (const entry of this.cacheState.map) {
        if (entry[1]._tag === "Complete" && entry[1].exit._tag === "Success") {
          values.push(entry[1].exit.value);
        }
      }
      return values;
    });
  }
  get entries() {
    return internal_core/* sync */.Z_X(() => {
      const values = [];
      for (const entry of this.cacheState.map) {
        if (entry[1]._tag === "Complete" && entry[1].exit._tag === "Success") {
          values.push([entry[0], entry[1].exit.value]);
        }
      }
      return values;
    });
  }
  get keys() {
    return internal_core/* sync */.Z_X(() => {
      const keys = [];
      for (const entry of this.cacheState.map) {
        if (entry[1]._tag === "Complete" && entry[1].exit._tag === "Success") {
          keys.push(entry[0]);
        }
      }
      return keys;
    });
  }
  resolveMapValue(value, ignorePending = false) {
    return core_effect/* clockWith */.UA(clock => {
      switch (value._tag) {
        case "Complete":
          {
            this.trackAccess(value.key);
            if (this.hasExpired(clock, value.timeToLiveMillis)) {
              MutableHashMap/* remove */.Od(this.cacheState.map, value.key.current);
              return internal_core/* succeed */.ng0(Option/* none */.YP());
            }
            this.trackHit();
            return internal_core/* map */.UID(value.exit, Option/* some */.G);
          }
        case "Pending":
          {
            this.trackAccess(value.key);
            this.trackHit();
            if (ignorePending) {
              return internal_core/* succeed */.ng0(Option/* none */.YP());
            }
            return internal_core/* map */.UID(Deferred/* await */.Uz(value.deferred), Option/* some */.G);
          }
        case "Refreshing":
          {
            this.trackAccess(value.complete.key);
            this.trackHit();
            if (this.hasExpired(clock, value.complete.timeToLiveMillis)) {
              if (ignorePending) {
                return internal_core/* succeed */.ng0(Option/* none */.YP());
              }
              return internal_core/* map */.UID(Deferred/* await */.Uz(value.deferred), Option/* some */.G);
            }
            return internal_core/* map */.UID(value.complete.exit, Option/* some */.G);
          }
      }
    });
  }
  trackHit() {
    this.cacheState.hits = this.cacheState.hits + 1;
  }
  trackMiss() {
    this.cacheState.misses = this.cacheState.misses + 1;
  }
  trackAccess(key) {
    offer(this.cacheState.accesses, key);
    if (MutableRef/* compareAndSet */.te(this.cacheState.updating, false, true)) {
      let loop = true;
      while (loop) {
        const key = poll(this.cacheState.accesses, EmptyMutableQueue);
        if (key === EmptyMutableQueue) {
          loop = false;
        } else {
          this.cacheState.keys.add(key);
        }
      }
      let size = MutableHashMap/* size */.dp(this.cacheState.map);
      loop = size > this.capacity;
      while (loop) {
        const key = this.cacheState.keys.remove();
        if (key !== undefined) {
          if (MutableHashMap/* has */.e$(this.cacheState.map, key.current)) {
            MutableHashMap/* remove */.Od(this.cacheState.map, key.current);
            size = size - 1;
            loop = size > this.capacity;
          }
        } else {
          loop = false;
        }
      }
      MutableRef/* set */.t8(this.cacheState.updating, false);
    }
  }
  hasExpired(clock, timeToLiveMillis) {
    return clock.unsafeCurrentTimeMillis() > timeToLiveMillis;
  }
  lookupValueOf(input, deferred) {
    return core_effect/* clockWith */.UA(clock => internal_core/* suspend */.RqG(() => {
      const key = input;
      return (0,Function/* pipe */.zG)(this.lookup(input), internal_core/* provideContext */.qNZ(this.context), internal_core/* exit */.JFt, internal_core/* flatMap */.VSD(exit => {
        const now = clock.unsafeCurrentTimeMillis();
        const stats = makeEntryStats(now);
        const value = complete(makeMapKey(key), exit, stats, now + esm_Duration/* toMillis */.eq(esm_Duration/* decode */.Jx(this.timeToLive(exit))));
        MutableHashMap/* set */.t8(this.cacheState.map, key, value);
        return internal_core/* zipRight */.qs5(Deferred/* done */.aT(deferred, exit), exit);
      }), internal_core/* onInterrupt */.J7b(() => internal_core/* zipRight */.qs5(Deferred/* interrupt */.e1(deferred), internal_core/* sync */.Z_X(() => {
        MutableHashMap/* remove */.Od(this.cacheState.map, key);
      }))));
    }));
  }
}
/** @internal */
const cache_make = options => {
  const timeToLive = Duration.decode(options.timeToLive);
  return makeWith({
    capacity: options.capacity,
    lookup: options.lookup,
    timeToLive: () => timeToLive
  });
};
/** @internal */
const makeWith = options => core.map(fiberRuntime.all([core.context(), core.fiberId]), ([context, fiberId]) => new CacheImpl(options.capacity, context, fiberId, options.lookup, exit => Duration.decode(options.timeToLive(exit))));
/** @internal */
const unsafeMakeWith = (capacity, lookup, timeToLive) => new CacheImpl(capacity, esm_Context/* empty */.cS(), fiberId/* none */.YP, lookup, exit => esm_Duration/* decode */.Jx(timeToLive(exit)));
//# sourceMappingURL=cache.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/request.js
var internal_request = __webpack_require__(82913);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/query.js








/** @internal */
const currentCache = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentCache"), () => internal_core/* fiberRefUnsafeMake */.kgb(unsafeMakeWith(65536, () => internal_core/* map */.UID(internal_core/* deferredMake */.kPu(), handle => ({
  listeners: new internal_request/* Listeners */.zy(),
  handle
})), () => (0,esm_Duration/* seconds */.m9)(60))));
/** @internal */
const currentCacheEnabled = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentCacheEnabled"), () => internal_core/* fiberRefUnsafeMake */.kgb(false));
/** @internal */
const fromRequest = (request, dataSource) => internal_core/* flatMap */.VSD(internal_core/* isEffect */.cdB(dataSource) ? dataSource : internal_core/* succeed */.ng0(dataSource), ds => internal_core/* fiberIdWith */.mrY(id => {
  const proxy = new Proxy(request, {});
  return internal_core/* fiberRefGetWith */.$Dw(currentCacheEnabled, cacheEnabled => {
    if (cacheEnabled) {
      const cached = internal_core/* fiberRefGetWith */.$Dw(currentCache, cache => internal_core/* flatMap */.VSD(cache.getEither(proxy), orNew => {
        switch (orNew._tag) {
          case "Left":
            {
              if (orNew.left.listeners.interrupted) {
                return internal_core/* flatMap */.VSD(cache.invalidateWhen(proxy, entry => entry.handle === orNew.left.handle), () => cached);
              }
              orNew.left.listeners.increment();
              return internal_core/* uninterruptibleMask */.UO$(restore => internal_core/* flatMap */.VSD(internal_core/* exit */.JFt(internal_core/* blocked */.IN$(blockedRequests/* empty */.cS, restore(internal_core/* deferredAwait */.Odg(orNew.left.handle)))), exit => {
                orNew.left.listeners.decrement();
                return exit;
              }));
            }
          case "Right":
            {
              orNew.right.listeners.increment();
              return internal_core/* uninterruptibleMask */.UO$(restore => internal_core/* flatMap */.VSD(internal_core/* exit */.JFt(internal_core/* blocked */.IN$(blockedRequests/* single */.Zr(ds, blockedRequests/* makeEntry */.E6({
                request: proxy,
                result: orNew.right.handle,
                listeners: orNew.right.listeners,
                ownerId: id,
                state: {
                  completed: false
                }
              })), restore(internal_core/* deferredAwait */.Odg(orNew.right.handle)))), () => {
                orNew.right.listeners.decrement();
                return internal_core/* deferredAwait */.Odg(orNew.right.handle);
              }));
            }
        }
      }));
      return cached;
    }
    const listeners = new internal_request/* Listeners */.zy();
    listeners.increment();
    return internal_core/* flatMap */.VSD(internal_core/* deferredMake */.kPu(), ref => (0,internal_fiberRuntime/* ensuring */.IH)(internal_core/* blocked */.IN$(blockedRequests/* single */.Zr(ds, blockedRequests/* makeEntry */.E6({
      request: proxy,
      result: ref,
      listeners,
      ownerId: id,
      state: {
        completed: false
      }
    })), internal_core/* deferredAwait */.Odg(ref)), internal_core/* sync */.Z_X(() => listeners.decrement())));
  });
}));
/** @internal */
const cacheRequest = (request, result) => {
  return internal_core/* fiberRefGetWith */.$Dw(currentCacheEnabled, cacheEnabled => {
    if (cacheEnabled) {
      return internal_core/* fiberRefGetWith */.$Dw(currentCache, cache => internal_core/* flatMap */.VSD(cache.getEither(request), orNew => {
        switch (orNew._tag) {
          case "Left":
            {
              return internal_core/* void */.Hcj;
            }
          case "Right":
            {
              return internal_core/* deferredComplete */.klV(orNew.right.handle, result);
            }
        }
      }));
    }
    return internal_core/* void */.Hcj;
  });
};
/** @internal */
const withRequestCaching = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, strategy) => internal_core/* fiberRefLocally */.EXC(self, currentCacheEnabled, strategy));
/** @internal */
const withRequestCache = /*#__PURE__*/(0,Function/* dual */.OB)(2,
// @ts-expect-error
(self, cache) => internal_core/* fiberRefLocally */.EXC(self, currentCache, cache));
//# sourceMappingURL=query.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/runtime.js + 1 modules
var runtime = __webpack_require__(22296);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/schedule.js
var schedule = __webpack_require__(97200);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/Request.js





/**
 * @since 2.0.0
 * @category symbols
 */
const RequestTypeId = internal_request/* RequestTypeId */.Vd;
/**
 * Returns `true` if the specified value is a `Request`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isRequest = internal_request/* isRequest */.gJ;
/**
 * Constructs a new `Request`.
 *
 * @since 2.0.0
 * @category constructors
 */
const of = internal_request.of;
/**
 * Constructs a new `Request`.
 *
 * @since 2.0.0
 * @category constructors
 */
const tagged = internal_request/* tagged */.NS;
/**
 * Provides a constructor for a Request Class.
 *
 * @example
 * ```ts
 * import { Request } from "effect"
 *
 * type Success = string
 * type Error = never
 *
 * class MyRequest extends Request.Class<Success, Error, {
 *   readonly id: string
 * }> {}
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
const Class = internal_request/* Class */.wT;
/**
 * Provides a Tagged constructor for a Request Class.
 *
 * @example
 * ```ts
 * import { Request } from "effect"
 *
 * type Success = string
 * type Error = never
 *
 * class MyRequest extends Request.TaggedClass("MyRequest")<Success, Error, {
 *   readonly name: string
 * }> {}
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
const TaggedClass = internal_request/* TaggedClass */.cL;
/**
 * Complete a `Request` with the specified result.
 *
 * @since 2.0.0
 * @category request completion
 */
const Request_complete = internal_request/* complete */.N;
/**
 * Interrupts the child effect when requests are no longer needed
 *
 * @since 2.0.0
 * @category request completion
 */
const interruptWhenPossible = internal_fiberRuntime/* interruptWhenPossible */.hu;
/**
 * Complete a `Request` with the specified effectful computation, failing the
 * request with the error from the effect workflow if it fails, and completing
 * the request with the value of the effect workflow if it succeeds.
 *
 * @since 2.0.0
 * @category request completion
 */
const completeEffect = internal_request/* completeEffect */.AM;
/**
 * Complete a `Request` with the specified error.
 *
 * @since 2.0.0
 * @category request completion
 */
const fail = internal_request/* fail */.bG;
/**
 * Complete a `Request` with the specified cause.
 *
 * @since 2.0.0
 * @category request completion
 */
const failCause = internal_request/* failCause */.Dh;
/**
 * Complete a `Request` with the specified value.
 *
 * @since 2.0.0
 * @category request completion
 */
const succeed = internal_request/* succeed */.ng;
/**
 * @since 2.0.0
 * @category models
 */
const makeCache = options => cache.make({
  ...options,
  lookup: () => core.map(core.deferredMake(), handle => ({
    listeners: new internal.Listeners(),
    handle
  }))
});
/**
 * @since 2.0.0
 * @category symbols
 */
const EntryTypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/RequestBlock.Entry")));
/**
 * @since 2.0.0
 * @category guards
 */
const isEntry = blockedRequests/* isEntry */.R5;
/**
 * @since 2.0.0
 * @category constructors
 */
const makeEntry = blockedRequests/* makeEntry */.E6;
//# sourceMappingURL=Request.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Scheduler.js
var Scheduler = __webpack_require__(22019);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/Effect.js


















/**
 * @since 2.0.0
 * @category Symbols
 */
const EffectTypeId = internal_core/* EffectTypeId */.Hjt;
/**
 * Checks if a given value is an `Effect` value.
 *
 * **When to Use**
 *
 * This function can be useful for checking the type of a value before
 * attempting to operate on it as an `Effect` value. For example, you could use
 * `Effect.isEffect` to check the type of a value before using it as an argument
 * to a function that expects an `Effect` value.
 *
 * @since 2.0.0
 * @category Guards
 */
const isEffect = internal_core/* isEffect */.cdB;
/**
 * Returns an effect that caches its result for a specified `Duration`,
 * known as "timeToLive" (TTL).
 *
 * **Details**
 *
 * This function is used to cache the result of an effect for a specified amount
 * of time. This means that the first time the effect is evaluated, its result
 * is computed and stored.
 *
 * If the effect is evaluated again within the specified `timeToLive`, the
 * cached result will be used, avoiding recomputation.
 *
 * After the specified duration has passed, the cache expires, and the effect
 * will be recomputed upon the next evaluation.
 *
 * **When to Use**
 *
 * Use this function when you have an effect that involves costly operations or
 * computations, and you want to avoid repeating them within a short time frame.
 *
 * It's ideal for scenarios where the result of an effect doesn't change
 * frequently and can be reused for a specified duration.
 *
 * By caching the result, you can improve efficiency and reduce unnecessary
 * computations, especially in performance-critical applications.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * let i = 1
 * const expensiveTask = Effect.promise<string>(() => {
 *   console.log("expensive task...")
 *   return new Promise((resolve) => {
 *     setTimeout(() => {
 *       resolve(`result ${i++}`)
 *     }, 100)
 *   })
 * })
 *
 * const program = Effect.gen(function* () {
 *   const cached = yield* Effect.cachedWithTTL(expensiveTask, "150 millis")
 *   yield* cached.pipe(Effect.andThen(Console.log))
 *   yield* cached.pipe(Effect.andThen(Console.log))
 *   yield* Effect.sleep("100 millis")
 *   yield* cached.pipe(Effect.andThen(Console.log))
 * })
 *
 * Effect.runFork(program)
 * // Output:
 * // expensive task...
 * // result 1
 * // result 1
 * // expensive task...
 * // result 2
 * ```
 *
 * @see {@link cached} for a similar function that caches the result
 * indefinitely.
 * @see {@link cachedInvalidateWithTTL} for a similar function that includes an
 * additional effect for manually invalidating the cached value.
 *
 * @since 2.0.0
 * @category Caching
 */
const cachedWithTTL = circular/* cached */.HX;
/**
 * Caches an effect's result for a specified duration and allows manual
 * invalidation before expiration.
 *
 * **Details**
 *
 * This function behaves similarly to {@link cachedWithTTL} by caching the
 * result of an effect for a specified period of time. However, it introduces an
 * additional feature: it provides an effect that allows you to manually
 * invalidate the cached result before it naturally expires.
 *
 * This gives you more control over the cache, allowing you to refresh the
 * result when needed, even if the original cache has not yet expired.
 *
 * Once the cache is invalidated, the next time the effect is evaluated, the
 * result will be recomputed, and the cache will be refreshed.
 *
 * **When to Use**
 *
 * Use this function when you have an effect whose result needs to be cached for
 * a certain period, but you also want the option to refresh the cache manually
 * before the expiration time.
 *
 * This is useful when you need to ensure that the cached data remains valid for
 * a certain period but still want to invalidate it if the underlying data
 * changes or if you want to force a recomputation.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * let i = 1
 * const expensiveTask = Effect.promise<string>(() => {
 *   console.log("expensive task...")
 *   return new Promise((resolve) => {
 *     setTimeout(() => {
 *       resolve(`result ${i++}`)
 *     }, 100)
 *   })
 * })
 *
 * const program = Effect.gen(function* () {
 *   const [cached, invalidate] = yield* Effect.cachedInvalidateWithTTL(
 *     expensiveTask,
 *     "1 hour"
 *   )
 *   yield* cached.pipe(Effect.andThen(Console.log))
 *   yield* cached.pipe(Effect.andThen(Console.log))
 *   yield* invalidate
 *   yield* cached.pipe(Effect.andThen(Console.log))
 * })
 *
 * Effect.runFork(program)
 * // Output:
 * // expensive task...
 * // result 1
 * // result 1
 * // expensive task...
 * // result 2
 * ```
 *
 * @see {@link cached} for a similar function that caches the result
 * indefinitely.
 * @see {@link cachedWithTTL} for a similar function that caches the result for
 * a specified duration but does not include an effect for manual invalidation.
 *
 * @since 2.0.0
 * @category Caching
 */
const cachedInvalidateWithTTL = circular/* cachedInvalidateWithTTL */.z4;
/**
 * Returns an effect that lazily computes a result and caches it for subsequent
 * evaluations.
 *
 * **Details**
 *
 * This function wraps an effect and ensures that its result is computed only
 * once. Once the result is computed, it is cached, meaning that subsequent
 * evaluations of the same effect will return the cached result without
 * re-executing the logic.
 *
 * **When to Use**
 *
 * Use this function when you have an expensive or time-consuming operation that
 * you want to avoid repeating. The first evaluation will compute the result,
 * and all following evaluations will immediately return the cached value,
 * improving performance and reducing unnecessary work.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * let i = 1
 * const expensiveTask = Effect.promise<string>(() => {
 *   console.log("expensive task...")
 *   return new Promise((resolve) => {
 *     setTimeout(() => {
 *       resolve(`result ${i++}`)
 *     }, 100)
 *   })
 * })
 *
 * const program = Effect.gen(function* () {
 *   console.log("non-cached version:")
 *   yield* expensiveTask.pipe(Effect.andThen(Console.log))
 *   yield* expensiveTask.pipe(Effect.andThen(Console.log))
 *   console.log("cached version:")
 *   const cached = yield* Effect.cached(expensiveTask)
 *   yield* cached.pipe(Effect.andThen(Console.log))
 *   yield* cached.pipe(Effect.andThen(Console.log))
 * })
 *
 * Effect.runFork(program)
 * // Output:
 * // non-cached version:
 * // expensive task...
 * // result 1
 * // expensive task...
 * // result 2
 * // cached version:
 * // expensive task...
 * // result 3
 * // result 3
 * ```
 *
 * @see {@link cachedWithTTL} for a similar function that includes a
 * time-to-live duration for the cached value.
 * @see {@link cachedInvalidateWithTTL} for a similar function that includes an
 * additional effect for manually invalidating the cached value.
 *
 * @since 2.0.0
 * @category Caching
 */
const cached = core_effect/* memoize */.HP;
/**
 * Returns a memoized version of a function with effects, reusing results for
 * the same inputs.
 *
 * **Details**
 *
 * This function creates a memoized version of a given function that performs an
 * effect. Memoization ensures that once a result is computed for a specific
 * input, it is stored and reused for subsequent calls with the same input,
 * reducing the need to recompute the result.
 *
 * The function can optionally take an `Equivalence` parameter to
 * determine how inputs are compared for caching purposes.
 *
 * **When to Use**
 *
 * Use this function when you have a function that performs an effect and you
 * want to avoid recomputing the result for the same input multiple times.
 *
 * It's ideal for functions that produce deterministic results based on their
 * inputs, and you want to improve performance by caching the output.
 *
 * This is particularly useful in scenarios where the function involves
 * expensive calculations or operations that should be avoided after the first
 * execution with the same parameters.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Random } from "effect"
 *
 * const program = Effect.gen(function* () {
 *   const randomNumber = (n: number) => Random.nextIntBetween(1, n)
 *   console.log("non-memoized version:")
 *   console.log(yield* randomNumber(10))
 *   console.log(yield* randomNumber(10))
 *
 *   console.log("memoized version:")
 *   const memoized = yield* Effect.cachedFunction(randomNumber)
 *   console.log(yield* memoized(10))
 *   console.log(yield* memoized(10))
 * })
 *
 * Effect.runFork(program)
 * // Example Output:
 * // non-memoized version:
 * // 2
 * // 8
 * // memoized version:
 * // 5
 * // 5
 * ```
 *
 * @since 2.0.0
 * @category Caching
 */
const cachedFunction = circular/* cachedFunction */.oH;
/**
 * Returns an effect that executes only once, regardless of how many times it's
 * called.
 *
 * **Details**
 *
 * This function ensures that a specific effect is executed only a single time,
 * no matter how many times it is invoked. The result of the effect will be
 * cached, and subsequent calls to the effect will immediately return the cached
 * result without re-executing the original logic.
 *
 * **When to Use**
 *
 * Use this function when you need to perform a task only once, regardless of
 * how many times the effect is triggered. It's particularly useful when you
 * have initialization tasks, logging, or other one-time actions that should not
 * be repeated. This can help optimize performance and avoid redundant actions.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const program = Effect.gen(function* () {
 *   const task1 = Console.log("task1")
 *   yield* Effect.repeatN(task1, 2)
 *   const task2 = yield* Effect.once(Console.log("task2"))
 *   yield* Effect.repeatN(task2, 2)
 * })
 *
 * Effect.runFork(program)
 * // Output:
 * // task1
 * // task1
 * // task1
 * // task2
 * ```
 *
 * @since 2.0.0
 * @category Caching
 */
const once = core_effect/* once */.IH;
/**
 * Combines multiple effects into one, returning results based on the input
 * structure.
 *
 * **Details**
 *
 * Use this function when you need to run multiple effects and combine their
 * results into a single output. It supports tuples, iterables, structs, and
 * records, making it flexible for different input types.
 *
 * For instance, if the input is a tuple:
 *
 * ```ts skip-type-checking
 * //         ┌─── a tuple of effects
 * //         ▼
 * Effect.all([effect1, effect2, ...])
 * ```
 *
 * the effects are executed sequentially, and the result is a new effect
 * containing the results as a tuple. The results in the tuple match the order
 * of the effects passed to `Effect.all`.
 *
 * **Concurrency**
 *
 * You can control the execution order (e.g., sequential vs. concurrent) using
 * the `concurrency` option.
 *
 * **Short-Circuiting Behavior**
 *
 * This function stops execution on the first error it encounters, this is
 * called "short-circuiting". If any effect in the collection fails, the
 * remaining effects will not run, and the error will be propagated. To change
 * this behavior, you can use the `mode` option, which allows all effects to run
 * and collect results as `Either` or `Option`.
 *
 * **The `mode` option**
 *
 * The `{ mode: "either" }` option changes the behavior of `Effect.all` to
 * ensure all effects run, even if some fail. Instead of stopping on the first
 * failure, this mode collects both successes and failures, returning an array
 * of `Either` instances where each result is either a `Right` (success) or a
 * `Left` (failure).
 *
 * Similarly, the `{ mode: "validate" }` option uses `Option` to indicate
 * success or failure. Each effect returns `None` for success and `Some` with
 * the error for failure.
 *
 * **Example** (Combining Effects in Tuples)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const tupleOfEffects = [
 *   Effect.succeed(42).pipe(Effect.tap(Console.log)),
 *   Effect.succeed("Hello").pipe(Effect.tap(Console.log))
 * ] as const
 *
 * //      ┌─── Effect<[number, string], never, never>
 * //      ▼
 * const resultsAsTuple = Effect.all(tupleOfEffects)
 *
 * Effect.runPromise(resultsAsTuple).then(console.log)
 * // Output:
 * // 42
 * // Hello
 * // [ 42, 'Hello' ]
 * ```
 *
 * **Example** (Combining Effects in Iterables)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const iterableOfEffects: Iterable<Effect.Effect<number>> = [1, 2, 3].map(
 *   (n) => Effect.succeed(n).pipe(Effect.tap(Console.log))
 * )
 *
 * //      ┌─── Effect<number[], never, never>
 * //      ▼
 * const resultsAsArray = Effect.all(iterableOfEffects)
 *
 * Effect.runPromise(resultsAsArray).then(console.log)
 * // Output:
 * // 1
 * // 2
 * // 3
 * // [ 1, 2, 3 ]
 * ```
 *
 * **Example** (Combining Effects in Structs)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const structOfEffects = {
 *   a: Effect.succeed(42).pipe(Effect.tap(Console.log)),
 *   b: Effect.succeed("Hello").pipe(Effect.tap(Console.log))
 * }
 *
 * //      ┌─── Effect<{ a: number; b: string; }, never, never>
 * //      ▼
 * const resultsAsStruct = Effect.all(structOfEffects)
 *
 * Effect.runPromise(resultsAsStruct).then(console.log)
 * // Output:
 * // 42
 * // Hello
 * // { a: 42, b: 'Hello' }
 * ```
 *
 * **Example** (Combining Effects in Records)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const recordOfEffects: Record<string, Effect.Effect<number>> = {
 *   key1: Effect.succeed(1).pipe(Effect.tap(Console.log)),
 *   key2: Effect.succeed(2).pipe(Effect.tap(Console.log))
 * }
 *
 * //      ┌─── Effect<{ [x: string]: number; }, never, never>
 * //      ▼
 * const resultsAsRecord = Effect.all(recordOfEffects)
 *
 * Effect.runPromise(resultsAsRecord).then(console.log)
 * // Output:
 * // 1
 * // 2
 * // { key1: 1, key2: 2 }
 * ```
 *
 * **Example** (Short-Circuiting Behavior)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const program = Effect.all([
 *   Effect.succeed("Task1").pipe(Effect.tap(Console.log)),
 *   Effect.fail("Task2: Oh no!").pipe(Effect.tap(Console.log)),
 *   // Won't execute due to earlier failure
 *   Effect.succeed("Task3").pipe(Effect.tap(Console.log))
 * ])
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // Task1
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: { _id: 'Cause', _tag: 'Fail', failure: 'Task2: Oh no!' }
 * // }
 * ```
 *
 * **Example** (Collecting Results with `mode: "either"`)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const effects = [
 *   Effect.succeed("Task1").pipe(Effect.tap(Console.log)),
 *   Effect.fail("Task2: Oh no!").pipe(Effect.tap(Console.log)),
 *   Effect.succeed("Task3").pipe(Effect.tap(Console.log))
 * ]
 *
 * const program = Effect.all(effects, { mode: "either" })
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // Task1
 * // Task3
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Success',
 * //   value: [
 * //     { _id: 'Either', _tag: 'Right', right: 'Task1' },
 * //     { _id: 'Either', _tag: 'Left', left: 'Task2: Oh no!' },
 * //     { _id: 'Either', _tag: 'Right', right: 'Task3' }
 * //   ]
 * // }
 * ```
 *
 * **Example** (Collecting Results with `mode: "validate"`)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const effects = [
 *   Effect.succeed("Task1").pipe(Effect.tap(Console.log)),
 *   Effect.fail("Task2: Oh no!").pipe(Effect.tap(Console.log)),
 *   Effect.succeed("Task3").pipe(Effect.tap(Console.log))
 * ]
 *
 * const program = Effect.all(effects, { mode: "validate" })
 *
 * Effect.runPromiseExit(program).then((result) => console.log("%o", result))
 * // Output:
 * // Task1
 * // Task3
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: {
 * //     _id: 'Cause',
 * //     _tag: 'Fail',
 * //     failure: [
 * //       { _id: 'Option', _tag: 'None' },
 * //       { _id: 'Option', _tag: 'Some', value: 'Task2: Oh no!' },
 * //       { _id: 'Option', _tag: 'None' }
 * //     ]
 * //   }
 * // }
 * ```
 *
 * @see {@link forEach} for iterating over elements and applying an effect.
 * @see {@link allWith} for a data-last version of this function.
 *
 * @since 2.0.0
 * @category Collecting
 */
const Effect_all = internal_fiberRuntime/* all */.$6;
/**
 * A data-last version of {@link all}, designed for use in pipelines.
 *
 * **When to Use**
 *
 * This function enables you to combine multiple effects and customize execution
 * options such as concurrency levels. This version is useful in functional
 * pipelines where you first define your data and then apply operations to it.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, pipe } from "effect"
 *
 * const task1 = Effect.succeed(1).pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Effect.log("task1 done"))
 * )
 *
 * const task2 = Effect.succeed("hello").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Effect.log("task2 done"))
 * )
 *
 * const program = pipe(
 *   [task1, task2],
 *   // Run both effects concurrently using the concurrent option
 *   Effect.allWith({ concurrency: 2 })
 * )
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // timestamp=... level=INFO fiber=#3 message="task2 done"
 * // timestamp=... level=INFO fiber=#2 message="task1 done"
 * // [ 1, 'hello' ]
 * ```
 *
 * @since 2.0.0
 * @category Collecting
 */
const allWith = internal_fiberRuntime/* allWith */.IZ;
/**
 * Evaluates and runs each effect in the iterable, collecting only the
 * successful results while discarding failures.
 *
 * **Details**
 *
 * This function function processes an iterable of effects and runs each one. If
 * an effect is successful, its result is collected; if it fails, the result is
 * discarded. This ensures that only successful outcomes are kept.
 *
 * **Options**
 *
 * The function also allows you to customize how the effects are handled by
 * specifying options such as concurrency, batching, and how finalizers behave.
 * These options provide flexibility in running the effects concurrently or
 * adjusting other execution details.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const tasks = [
 *   Effect.succeed(1),
 *   Effect.fail("Error 1"),
 *   Effect.succeed(2),
 *   Effect.fail("Error 2")
 * ]
 *
 * const program = Effect.gen(function*() {
 *   const successfulResults = yield* Effect.allSuccesses(tasks)
 *   console.log(successfulResults)
 * })
 *
 * Effect.runFork(program)
 * // Output: [1, 2]
 *
 * ```
 *
 * @since 2.0.0
 * @category Collecting
 */
const allSuccesses = internal_fiberRuntime/* allSuccesses */.YI;
/**
 * Drops elements until the effectful predicate returns `true`.
 *
 * **Details**
 *
 * This function processes a collection of elements and uses an effectful
 * predicate to determine when to stop dropping elements. It drops elements from
 * the beginning of the collection until the predicate returns `true`.
 *
 * The predicate is a function that takes an element and its index in the
 * collection and returns an effect that evaluates to a boolean.
 *
 * Once the predicate returns `true`, the remaining elements of the collection
 * are returned.
 *
 * **Note**: The first element for which the predicate returns `true` is also
 * dropped.
 *
 * **When to Use**
 *
 * This function allows you to conditionally skip over a part of the collection
 * based on some criteria defined in the predicate.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const numbers = [1, 2, 3, 4, 5, 6]
 * const predicate = (n: number, i: number) => Effect.succeed(n > 3)
 *
 * const program = Effect.gen(function*() {
 *   const result = yield* Effect.dropUntil(numbers, predicate)
 *   console.log(result)
 * })
 *
 * Effect.runFork(program)
 * // Output: [5, 6]
 * ```
 *
 * @see {@link dropWhile} for a similar function that drops elements while the
 * predicate returns `true`.
 *
 * @since 2.0.0
 * @category Collecting
 */
const dropUntil = core_effect/* dropUntil */.NP;
/**
 * Drops elements as long as the predicate returns `true`.
 *
 * **Details**
 *
 * This function processes a collection of elements and uses a predicate to
 * decide whether to drop an element.
 *
 * The predicate is a function that takes an element and its index, and it
 * returns an effect that evaluates to a boolean.
 *
 * As long as the predicate returns `true`, elements will continue to be dropped
 * from the collection.
 *
 * Once the predicate returns `false`, the remaining elements are kept.
 *
 * **When to Use**
 *
 * This function allows you to discard elements from the start of a collection
 * based on a condition, and only keep the rest when the condition no longer
 * holds.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const numbers = [1, 2, 3, 4, 5, 6]
 * const predicate = (n: number, i: number) => Effect.succeed(n <= 3)
 *
 * const program = Effect.gen(function*() {
 *   const result = yield* Effect.dropWhile(numbers, predicate)
 *   console.log(result)
 * })
 *
 * Effect.runFork(program)
 * // Output: [4, 5, 6]
 * ```
 *
 * @see {@link dropUntil} for a similar function that drops elements until the
 * predicate returns `true`.
 *
 * @since 2.0.0
 * @category Collecting
 */
const dropWhile = core_effect/* dropWhile */.$x;
/**
 * Takes elements from a collection until the effectful predicate returns
 * `true`.
 *
 * **Details**
 *
 * This function processes a collection of elements and uses an effectful
 * predicate to decide when to stop taking elements. The elements are taken from
 * the beginning of the collection until the predicate returns `true`.
 *
 * The predicate is a function that takes an element and its index in the
 * collection, and returns an effect that resolves to a boolean.
 *
 * Once the predicate returns `true`, the remaining elements of the collection
 * are discarded, and the function stops taking more elements.
 *
 * **Note**: The first element for which the predicate returns `true` is also
 * included in the result.
 *
 * **When to Use**
 *
 * Use this function when you want to conditionally take elements from a
 * collection based on a dynamic condition. For example, you may want to collect
 * numbers from a list until a certain threshold is reached, or gather items
 * until a specific condition is met.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const numbers = [1, 2, 3, 4, 5, 6]
 * const predicate = (n: number, i: number) => Effect.succeed(n > 3)
 *
 * const program = Effect.gen(function*() {
 *   const result = yield* Effect.takeUntil(numbers, predicate)
 *   console.log(result)
 * })
 *
 * Effect.runFork(program)
 * // Output: [ 1, 2, 3, 4 ]
 * ```
 *
 * @see {@link takeWhile} for a similar function that takes elements while the
 * predicate returns `true`.
 *
 * @since 2.0.0
 * @category Collecting
 */
const takeUntil = core_effect/* takeUntil */.Rs;
/**
 * Takes elements as long as the predicate returns `true`.
 *
 * **Details**
 *
 * This function processes a collection of elements and uses a predicate to
 * decide whether to take an element.
 *
 * The predicate is a function that takes an element and its index, and it
 * returns an effect that evaluates to a boolean.
 *
 * As long as the predicate returns `true`, elements will continue to be taken
 * from the collection.
 *
 * Once the predicate returns `false`, the remaining elements are discarded.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const numbers = [1, 2, 3, 4, 5, 6]
 * const predicate = (n: number, i: number) => Effect.succeed(n <= 3)
 *
 * const program = Effect.gen(function*() {
 *   const result = yield* Effect.takeWhile(numbers, predicate)
 *   console.log(result)
 * })
 *
 * Effect.runFork(program)
 * // Output: [1, 2, 3]
 * ```
 *
 * @see {@link takeUntil} for a similar function that takes elements until the predicate returns `true`.
 *
 * @since 2.0.0
 * @category Collecting
 */
const takeWhile = core_effect/* takeWhile */.oE;
/**
 * Determines whether all elements of the iterable satisfy the effectful
 * predicate.
 *
 * **Details**
 *
 * This function checks whether every element in a given collection (an
 * iterable) satisfies a condition defined by an effectful predicate.
 *
 * The predicate is a function that takes an element and its index, and it
 * returns an effect that evaluates to a boolean.
 *
 * The function will process each element and return `true` if all elements
 * satisfy the predicate; otherwise, it returns `false`.
 *
 * **When to Use**
 *
 * This function is useful when you need to verify that all items in a
 * collection meet certain criteria, even when the evaluation of each item
 * involves effects, such as asynchronous checks or complex computations.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const numbers = [2, 4, 6, 8]
 * const predicate = (n: number, i: number) => Effect.succeed(n % 2 === 0)
 *
 * const program = Effect.gen(function*() {
 *   const allEven = yield* Effect.every(numbers, predicate)
 *   console.log(allEven)
 * })
 *
 * Effect.runFork(program)
 * // Output: true
 * ```
 *
 * @see {@link exists} for a similar function that returns a boolean indicating
 * whether **any** element satisfies the predicate.
 *
 * @since 2.0.0
 * @category Condition Checking
 */
const every = core_effect/* every */.yW;
/**
 * Determines whether any element of the iterable satisfies the effectual
 * predicate.
 *
 * **Details**
 *
 * This function checks whether any element in a given collection (an iterable)
 * satisfies a condition defined by an effectful predicate.
 *
 * The predicate is a function that takes an element and its index, and it
 * returns an effect that evaluates to a boolean.
 *
 * The function will process each element, and if any element satisfies the
 * predicate (returns `true`), the function will immediately return `true`.
 *
 * If none of the elements satisfy the condition, it will return `false`.
 *
 * **When to Use**
 *
 * This function allows you to quickly check for a condition in a collection
 * without having to manually iterate over it.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const numbers = [1, 2, 3, 4]
 * const predicate = (n: number, i: number) => Effect.succeed(n > 2)
 *
 * const program = Effect.gen(function*() {
 *   const hasLargeNumber = yield* Effect.exists(numbers, predicate)
 *   console.log(hasLargeNumber)
 * })
 *
 * Effect.runFork(program)
 * // Output: true
 * ```
 *
 * @see {@link every} for a similar function that checks if **all** elements
 * satisfy the predicate.
 *
 * @since 2.0.0
 * @category Condition Checking
 */
const exists = internal_fiberRuntime/* exists */.Gg;
/**
 * Filters an iterable using the specified effectful predicate.
 *
 * **Details**
 *
 * This function filters a collection (an iterable) by applying an effectful
 * predicate.
 *
 * The predicate is a function that takes an element and its index, and it
 * returns an effect that evaluates to a boolean.
 *
 * The function processes each element in the collection and keeps only those
 * that satisfy the condition defined by the predicate.
 *
 * **Options**
 *
 * You can also adjust the behavior with options such as concurrency, batching,
 * or whether to negate the condition.
 *
 * **When to Use**
 *
 * This function allows you to selectively keep or remove elements based on a
 * condition that may involve asynchronous or side-effect-causing operations.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const numbers = [1, 2, 3, 4, 5]
 * const predicate = (n: number, i: number) => Effect.succeed(n % 2 === 0)
 *
 * const program = Effect.gen(function*() {
 *   const result = yield* Effect.filter(numbers, predicate)
 *   console.log(result)
 * })
 *
 * Effect.runFork(program)
 * // Output: [2, 4]
 * ```
 *
 * @since 2.0.0
 * @category Filtering
 */
const filter = internal_fiberRuntime/* filter */.hX;
/**
 * Filters and maps elements sequentially in one operation.
 *
 * This function processes each element one by one. It applies a function that
 * returns an `Option` to each element. If the function returns `Some`, the
 * element is kept; if it returns `None`, the element is removed. The operation
 * is done sequentially for each element.
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect, Option } from "effect"
 *
 * const task = (n: number) =>
 *   Effect.succeed(n).pipe(
 *     Effect.delay(1000 - (n * 100)),
 *     Effect.tap(Console.log(`task${n} done`))
 *   )
 *
 * const program = Effect.filterMap(
 *   [task(1), task(2), task(3), task(4)],
 *   (n) => n % 2 === 0 ? Option.some(n) : Option.none()
 * )
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // task1 done
 * // task2 done
 * // task3 done
 * // task4 done
 * // [ 2, 4 ]
 * ```
 *
 * @since 2.0.0
 * @category Filtering
 */
const filterMap = core_effect/* filterMap */.DZ;
/**
 * Returns the first element that satisfies the effectful predicate.
 *
 * **Details**
 *
 * This function processes a collection of elements and applies an effectful
 * predicate to each element.
 *
 * The predicate is a function that takes an element and its index in the
 * collection, and it returns an effect that evaluates to a boolean.
 *
 * The function stops as soon as it finds the first element for which the
 * predicate returns `true` and returns that element wrapped in an `Option`.
 *
 * If no element satisfies the predicate, the result will be `None`.
 *
 * **When to Use**
 *
 * This function allows you to efficiently find an element that meets a specific
 * condition, even when the evaluation involves effects like asynchronous
 * operations or side effects.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const numbers = [1, 2, 3, 4, 5]
 * const predicate = (n: number, i: number) => Effect.succeed(n > 3)
 *
 * const program = Effect.gen(function*() {
 *   const result = yield* Effect.findFirst(numbers, predicate)
 *   console.log(result)
 * })
 *
 * Effect.runFork(program)
 * // Output: { _id: 'Option', _tag: 'Some', value: 4 }
 * ```
 *
 * @since 2.0.0
 * @category Collecting
 */
const findFirst = core_effect/* findFirst */.Ew;
/**
 * Executes an effectful operation for each element in an `Iterable`.
 *
 * **Details**
 *
 * This function applies a provided operation to each element in the iterable,
 * producing a new effect that returns an array of results.
 *
 * If any effect fails, the iteration stops immediately (short-circuiting), and
 * the error is propagated.
 *
 * **Concurrency**
 *
 * The `concurrency` option controls how many operations are performed
 * concurrently. By default, the operations are performed sequentially.
 *
 * **Discarding Results**
 *
 * If the `discard` option is set to `true`, the intermediate results are not
 * collected, and the final result of the operation is `void`.
 *
 * **Example** (Applying Effects to Iterable Elements)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const result = Effect.forEach([1, 2, 3, 4, 5], (n, index) =>
 *   Console.log(`Currently at index ${index}`).pipe(Effect.as(n * 2))
 * )
 *
 * Effect.runPromise(result).then(console.log)
 * // Output:
 * // Currently at index 0
 * // Currently at index 1
 * // Currently at index 2
 * // Currently at index 3
 * // Currently at index 4
 * // [ 2, 4, 6, 8, 10 ]
 * ```
 *
 * **Example** (Discarding Results)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * // Apply effects but discard the results
 * const result = Effect.forEach(
 *   [1, 2, 3, 4, 5],
 *   (n, index) =>
 *     Console.log(`Currently at index ${index}`).pipe(Effect.as(n * 2)),
 *   { discard: true }
 * )
 *
 * Effect.runPromise(result).then(console.log)
 * // Output:
 * // Currently at index 0
 * // Currently at index 1
 * // Currently at index 2
 * // Currently at index 3
 * // Currently at index 4
 * // undefined
 * ```
 *
 * @see {@link all} for combining multiple effects into one.
 *
 * @since 2.0.0
 * @category Looping
 */
const Effect_forEach = internal_fiberRuntime/* forEach */.Ed;
/**
 * Returns the first element of the iterable if the collection is non-empty, or
 * fails with the error `NoSuchElementException` if the collection is empty.
 *
 * **When to Use**
 *
 * This function is useful when you need to retrieve the first item from a
 * collection and want to handle the case where the collection might be empty
 * without causing an unhandled exception.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * // Simulate an async operation
 * const fetchNumbers = Effect.succeed([1, 2, 3]).pipe(Effect.delay("100 millis"))
 *
 * const program = Effect.gen(function*() {
 *   const firstElement = yield* Effect.head(fetchNumbers)
 *   console.log(firstElement)
 * })
 *
 * Effect.runFork(program)
 * // Output: 1
 * ```
 *
 * @since 2.0.0
 * @category Collecting
 */
const Effect_head = core_effect/* head */.YM;
/**
 * Merges an `Iterable<Effect<A, E, R>>` to a single effect.
 *
 * **Details**
 *
 * This function takes an iterable of effects and combines them into a single
 * effect. It does this by iterating over each effect in the collection and
 * applying a function that accumulates results into a "zero" value, which
 * starts with an initial value and is updated with each effect's success.
 *
 * The provided function `f` is called for each element in the iterable,
 * allowing you to specify how to combine the results.
 *
 * **Options**
 *
 * The function also allows you to customize how the effects are handled by
 * specifying options such as concurrency, batching, and how finalizers behave.
 * These options provide flexibility in running the effects concurrently or
 * adjusting other execution details.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const numbers = [Effect.succeed(1), Effect.succeed(2), Effect.succeed(3)]
 * const add = (sum: number, value: number, i: number) => sum + value
 * const zero = 0
 *
 * const program = Effect.gen(function*() {
 *   const total = yield* Effect.mergeAll(numbers, zero, add)
 *   console.log(total)
 * })
 *
 * Effect.runFork(program)
 * // Output: 6
 * ```
 *
 * @since 2.0.0
 * @category Collecting
 */
const mergeAll = internal_fiberRuntime/* mergeAll */.Jn;
/**
 * Processes an iterable and applies an effectful function to each element,
 * categorizing the results into successes and failures.
 *
 * **Details**
 *
 * This function processes each element in the provided iterable by applying an
 * effectful function to it. The results are then categorized into two separate
 * lists: one for failures and another for successes. This separation allows you
 * to handle the two categories differently. Failures are collected in a list
 * without interrupting the processing of the remaining elements, so the
 * operation continues even if some elements fail. This is particularly useful
 * when you need to handle both successful and failed results separately,
 * without stopping the entire process on encountering a failure.
 *
 * **When to Use**
 *
 * Use this function when you want to process a collection of items and handle
 * errors or failures without interrupting the processing of other items. It's
 * useful when you need to distinguish between successful and failed results and
 * process them separately, for example, when logging errors while continuing to
 * work with valid data. The function ensures that failures are captured, while
 * successes are processed normally.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * //      ┌─── Effect<[string[], number[]], never, never>
 * //      ▼
 * const program = Effect.partition([0, 1, 2, 3, 4], (n) => {
 *   if (n % 2 === 0) {
 *     return Effect.succeed(n)
 *   } else {
 *     return Effect.fail(`${n} is not even`)
 *   }
 * })
 *
 * Effect.runPromise(program).then(console.log, console.error)
 * // Output:
 * // [ [ '1 is not even', '3 is not even' ], [ 0, 2, 4 ] ]
 * ```
 *
 * @see {@link validateAll} for a function that either collects all failures or all successes.
 * @see {@link validateFirst} for a function that stops at the first success.
 *
 * @since 2.0.0
 * @category Error Accumulation
 */
const partition = internal_fiberRuntime/* partition */.uK;
/**
 * Reduces an `Iterable<A>` using an effectual function `f`, working
 * sequentially from left to right.
 *
 * **Details**
 *
 * This function takes an iterable and applies a function `f` to each element in
 * the iterable. The function works sequentially, starting with an initial value
 * `zero` and then combining it with each element in the collection. The
 * provided function `f` is called for each element in the iterable, allowing
 * you to accumulate a result based on the current value and the element being
 * processed.
 *
 * **When to Use**
 *
 * The function is often used for operations like summing a collection of
 * numbers or combining results from multiple tasks. It ensures that operations
 * are performed one after the other, maintaining the order of the elements.
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * const processOrder = (id: number) =>
 *   Effect.succeed({ id, price: 100 * id })
 *     .pipe(Effect.tap(() => Console.log(`Order ${id} processed`)), Effect.delay(500 - (id * 100)))
 *
 * const program = Effect.reduce(
 *   [1, 2, 3, 4],
 *   0,
 *   (acc, id, i) =>
 *     processOrder(id)
 *       .pipe(Effect.map((order) => acc + order.price))
 * )
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // Order 1 processed
 * // Order 2 processed
 * // Order 3 processed
 * // Order 4 processed
 * // 1000
 * ```
 *
 * @see {@link reduceWhile} for a similar function that stops the process based on a predicate.
 * @see {@link reduceRight} for a similar function that works from right to left.
 *
 * @since 2.0.0
 * @category Collecting
 */
const reduce = core_effect/* reduce */.u4;
/**
 * Reduces an `Iterable<A>` using an effectual function `body`, working
 * sequentially from left to right, stopping the process early when the
 * predicate `while` is not satisfied.
 *
 * **Details**
 *
 * This function processes a collection of elements, applying a function `body`
 * to reduce them to a single value, starting from the first element. It checks
 * the value of the accumulator against a predicate (`while`). If at any point
 * the predicate returns `false`, the reduction stops, and the accumulated
 * result is returned.
 *
 * **When to Use**
 *
 * Use this function when you need to reduce a collection of elements, but only
 * continue the process as long as a certain condition holds true. For example,
 * if you want to sum values in a list but stop as soon as the sum exceeds a
 * certain threshold, you can use this function.
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * const processOrder = (id: number) =>
 *   Effect.succeed({ id, price: 100 * id })
 *     .pipe(Effect.tap(() => Console.log(`Order ${id} processed`)), Effect.delay(500 - (id * 100)))
 *
 * const program = Effect.reduceWhile(
 *   [1, 2, 3, 4],
 *   0,
 *   {
 *     body: (acc, id, i) =>
 *       processOrder(id)
 *         .pipe(Effect.map((order) => acc + order.price)),
 *     while: (acc) => acc < 500
 *   }
 * )
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // Order 1 processed
 * // Order 2 processed
 * // Order 3 processed
 * // 600
 * ```
 *
 * @since 2.0.0
 * @category Collecting
 */
const reduceWhile = core_effect/* reduceWhile */.jQ;
/**
 * Reduces an `Iterable<A>` using an effectual function `f`, working
 * sequentially from right to left.
 *
 * **Details**
 *
 * This function takes an iterable and applies a function `f` to each element in
 * the iterable. The function works sequentially, starting with an initial value
 * `zero` and then combining it with each element in the collection. The
 * provided function `f` is called for each element in the iterable, allowing
 * you to accumulate a result based on the current value and the element being
 * processed.
 *
 * **When to Use**
 *
 * The function is often used for operations like summing a collection of
 * numbers or combining results from multiple tasks. It ensures that operations
 * are performed one after the other, maintaining the order of the elements.
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * const processOrder = (id: number) =>
 *   Effect.succeed({ id, price: 100 * id })
 *     .pipe(Effect.tap(() => Console.log(`Order ${id} processed`)), Effect.delay(500 - (id * 100)))
 *
 * const program = Effect.reduceRight(
 *   [1, 2, 3, 4],
 *   0,
 *   (id, acc, i) =>
 *     processOrder(id)
 *       .pipe(Effect.map((order) => acc + order.price))
 * )
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // Order 4 processed
 * // Order 3 processed
 * // Order 2 processed
 * // Order 1 processed
 * // 1000
 * ```
 *
 * @see {@link reduce} for a similar function that works from left to right.
 *
 * @since 2.0.0
 * @category Collecting
 */
const reduceRight = core_effect/* reduceRight */.nq;
/**
 * Reduces an `Iterable<Effect<A, E, R>>` to a single effect.
 *
 * **Details**
 *
 * This function processes a collection of effects and combines them into one
 * single effect. It starts with an initial effect (`zero`) and applies a
 * function `f` to each element in the collection.
 *
 * **Options**
 *
 * The function also allows you to customize how the effects are handled by
 * specifying options such as concurrency, batching, and how finalizers behave.
 * These options provide flexibility in running the effects concurrently or
 * adjusting other execution details.
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * const processOrder = (id: number) =>
 *   Effect.succeed({ id, price: 100 * id })
 *     .pipe(Effect.tap(() => Console.log(`Order ${id} processed`)), Effect.delay(500 - (id * 100)))
 *
 * const program = Effect.reduceEffect(
 *   [processOrder(1), processOrder(2), processOrder(3), processOrder(4)],
 *   Effect.succeed(0),
 *   (acc, order, i) => acc + order.price
 * )
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // Order 1 processed
 * // Order 2 processed
 * // Order 3 processed
 * // Order 4 processed
 * // 1000
 * ```
 *
 * @since 2.0.0
 * @category Collecting
 */
const reduceEffect = internal_fiberRuntime/* reduceEffect */.rN;
/**
 * Replicates the given effect `n` times.
 *
 * **Details**
 *
 * This function takes an effect and replicates it a specified number of times
 * (`n`). The result is an array of `n` effects, each of which is identical to
 * the original effect.
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * const task = Effect.succeed("Hello, World!").pipe(
 *   Effect.tap(Console.log)
 * )
 *
 * const program = Effect.gen(function*() {
 *   // Replicate the task 3 times
 *   const tasks = Effect.replicate(task, 3)
 *   for (const t of tasks) {
 *     // Run each task
 *     yield* t
 *   }
 * })
 *
 * Effect.runFork(program)
 * // Output:
 * // Hello, World!
 * // Hello, World!
 * // Hello, World!
 * ```
 *
 * @since 2.0.0
 */
const replicate = internal_fiberRuntime/* replicate */.AS;
/**
 * Performs this effect the specified number of times and collects the results.
 *
 * **Details**
 *
 * This function repeats an effect multiple times and collects the results into
 * an array. You specify how many times to execute the effect, and it runs that
 * many times, either in sequence or concurrently depending on the provided
 * options.
 *
 * **Options**
 *
 * If the `discard` option is set to `true`, the intermediate results are not
 * collected, and the final result of the operation is `void`.
 *
 * The function also allows you to customize how the effects are handled by
 * specifying options such as concurrency, batching, and how finalizers behave.
 * These options provide flexibility in running the effects concurrently or
 * adjusting other execution details.
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * let counter = 0
 *
 * const task = Effect.sync(() => ++counter).pipe(
 *   Effect.tap(() => Console.log(`Task completed`))
 * )
 *
 * const program = Effect.gen(function*() {
 *   // Replicate the task 3 times and collect the results
 *   const results = yield* Effect.replicateEffect(task, 3)
 *   yield* Console.log(`Results: ${results.join(", ")}`)
 * })
 *
 * Effect.runFork(program)
 * // Output:
 * // Task completed
 * // Task completed
 * // Task completed
 * // Results: 1, 2, 3
 * ```
 *
 * @since 2.0.0
 * @category Collecting
 */
const replicateEffect = internal_fiberRuntime/* replicateEffect */.VT;
/**
 * Applies an effectful operation to each element in a collection while
 * collecting both successes and failures.
 *
 * **Details**
 *
 * This function allows you to apply an effectful operation to every item in a
 * collection.
 *
 * Unlike {@link forEach}, which would stop at the first error, this function
 * continues processing all elements, accumulating both successes and failures.
 *
 * **When to Use**
 *
 * Use this function when you want to process every item in a collection, even
 * if some items fail. This is particularly useful when you need to perform
 * operations on all elements without halting due to an error.
 *
 * Keep in mind that if there are any failures, **all successes will be lost**,
 * so this function is not suitable when you need to keep the successful results
 * in case of errors.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * //      ┌─── Effect<number[], [string, ...string[]], never>
 * //      ▼
 * const program = Effect.validateAll([1, 2, 3, 4, 5], (n) => {
 *   if (n < 4) {
 *     return Console.log(`item ${n}`).pipe(Effect.as(n))
 *   } else {
 *     return Effect.fail(`${n} is not less that 4`)
 *   }
 * })
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // item 1
 * // item 2
 * // item 3
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: {
 * //     _id: 'Cause',
 * //     _tag: 'Fail',
 * //     failure: [ '4 is not less that 4', '5 is not less that 4' ]
 * //   }
 * // }
 * ```
 *
 * @see {@link forEach} for a similar function that stops at the first error.
 * @see {@link partition} when you need to separate successes and failures
 * instead of losing successes with errors.
 *
 * @since 2.0.0
 * @category Error Accumulation
 */
const validateAll = internal_fiberRuntime/* validateAll */.Kf;
/**
 * This function is similar to {@link validateAll} but with a key difference: it
 * returns the first successful result or all errors if none of the operations
 * succeed.
 *
 * **Details**
 *
 * This function processes a collection of elements and applies an effectful
 * operation to each. Unlike {@link validateAll}, which accumulates both
 * successes and failures, `Effect.validateFirst` stops and returns the first
 * success it encounters. If no success occurs, it returns all accumulated
 * errors. This can be useful when you are interested in the first successful
 * result and want to avoid processing further once a valid result is found.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * //      ┌─── Effect<number, string[], never>
 * //      ▼
 * const program = Effect.validateFirst([1, 2, 3, 4, 5], (n) => {
 *   if (n < 4) {
 *     return Effect.fail(`${n} is not less that 4`)
 *   } else {
 *     return Console.log(`item ${n}`).pipe(Effect.as(n))
 *   }
 * })
 *
 * Effect.runPromise(program).then(console.log, console.error)
 * // Output:
 * // item 4
 * // 4
 * ```
 *
 * @see {@link validateAll} for a similar function that accumulates all results.
 * @see {@link firstSuccessOf} for a similar function that processes multiple
 * effects and returns the first successful one or the last error.
 *
 * @since 2.0.0
 * @category Error Accumulation
 */
const validateFirst = internal_fiberRuntime/* validateFirst */.Kt;
/**
 * Creates an `Effect` from a callback-based asynchronous function.
 *
 * **Details**
 *
 * The `resume` function:
 * - Must be called exactly once. Any additional calls will be ignored.
 * - Can return an optional `Effect` that will be run if the `Fiber` executing
 *   this `Effect` is interrupted. This can be useful in scenarios where you
 *   need to handle resource cleanup if the operation is interrupted.
 * - Can receive an `AbortSignal` to handle interruption if needed.
 *
 * The `FiberId` of the fiber that may complete the async callback may also be
 * specified using the `blockingOn` argument. This is called the "blocking
 * fiber" because it suspends the fiber executing the `async` effect (i.e.
 * semantically blocks the fiber from making progress). Specifying this fiber id
 * in cases where it is known will improve diagnostics, but not affect the
 * behavior of the returned effect.
 *
 * **When to Use**
 *
 * Use `Effect.async` when dealing with APIs that use callback-style instead of
 * `async/await` or `Promise`.
 *
 * **Example** (Wrapping a Callback API)
 *
 * ```ts
 * import { Effect } from "effect"
 * import * as NodeFS from "node:fs"
 *
 * const readFile = (filename: string) =>
 *   Effect.async<Buffer, Error>((resume) => {
 *     NodeFS.readFile(filename, (error, data) => {
 *       if (error) {
 *         // Resume with a failed Effect if an error occurs
 *         resume(Effect.fail(error))
 *       } else {
 *         // Resume with a succeeded Effect if successful
 *         resume(Effect.succeed(data))
 *       }
 *     })
 *   })
 *
 * //      ┌─── Effect<Buffer, Error, never>
 * //      ▼
 * const program = readFile("example.txt")
 * ```
 *
 * **Example** (Handling Interruption with Cleanup)
 *
 * ```ts
 * import { Effect, Fiber } from "effect"
 * import * as NodeFS from "node:fs"
 *
 * // Simulates a long-running operation to write to a file
 * const writeFileWithCleanup = (filename: string, data: string) =>
 *   Effect.async<void, Error>((resume) => {
 *     const writeStream = NodeFS.createWriteStream(filename)
 *
 *     // Start writing data to the file
 *     writeStream.write(data)
 *
 *     // When the stream is finished, resume with success
 *     writeStream.on("finish", () => resume(Effect.void))
 *
 *     // In case of an error during writing, resume with failure
 *     writeStream.on("error", (err) => resume(Effect.fail(err)))
 *
 *     // Handle interruption by returning a cleanup effect
 *     return Effect.sync(() => {
 *       console.log(`Cleaning up ${filename}`)
 *       NodeFS.unlinkSync(filename)
 *     })
 *   })
 *
 * const program = Effect.gen(function* () {
 *   const fiber = yield* Effect.fork(
 *     writeFileWithCleanup("example.txt", "Some long data...")
 *   )
 *   // Simulate interrupting the fiber after 1 second
 *   yield* Effect.sleep("1 second")
 *   yield* Fiber.interrupt(fiber) // This will trigger the cleanup
 * })
 *
 * // Run the program
 * Effect.runPromise(program)
 * // Output:
 * // Cleaning up example.txt
 * ```
 *
 * **Example** (Handling Interruption with AbortSignal)
 *
 * ```ts
 * import { Effect, Fiber } from "effect"
 *
 * // A task that supports interruption using AbortSignal
 * const interruptibleTask = Effect.async<void, Error>((resume, signal) => {
 *   // Handle interruption
 *   signal.addEventListener("abort", () => {
 *     console.log("Abort signal received")
 *     clearTimeout(timeoutId)
 *   })
 *
 *   // Simulate a long-running task
 *   const timeoutId = setTimeout(() => {
 *     console.log("Operation completed")
 *     resume(Effect.void)
 *   }, 2000)
 * })
 *
 * const program = Effect.gen(function* () {
 *   const fiber = yield* Effect.fork(interruptibleTask)
 *   // Simulate interrupting the fiber after 1 second
 *   yield* Effect.sleep("1 second")
 *   yield* Fiber.interrupt(fiber)
 * })
 *
 * // Run the program
 * Effect.runPromise(program)
 * // Output:
 * // Abort signal received
 * ```
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const Effect_async = internal_core/* async */.PFx;
/**
 * A variant of {@link async} where the registration function may return an `Effect`.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const asyncEffect = runtime/* asyncEffect */.FW;
/**
 * Low level constructor that enables for custom stack tracing cutpoints.
 *
 * It is meant to be called with a bag of instructions that become available in
 * the "this" of the effect.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const throwingFunction = () => { throw new Error() }
 * const blowUp = Effect.custom(throwingFunction, function() {
 *   return Effect.succeed(this.effect_instruction_i0())
 * })
 * ```
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const custom = internal_core/* custom */.PGm;
/**
 * @since 2.0.0
 * @category Creating Effects
 */
const withFiberRuntime = internal_core/* withFiberRuntime */.ECC;
/**
 * Creates an `Effect` that represents a recoverable error.
 *
 * **When to Use**
 *
 * Use this function to explicitly signal an error in an `Effect`. The error
 * will keep propagating unless it is handled. You can handle the error with
 * functions like {@link catchAll} or {@link catchTag}.
 *
 * **Example** (Creating a Failed Effect)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * //      ┌─── Effect<never, Error, never>
 * //      ▼
 * const failure = Effect.fail(
 *   new Error("Operation failed due to network error")
 * )
 * ```
 *
 * @see {@link succeed} to create an effect that represents a successful value.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const Effect_fail = internal_core/* fail */.bGj;
/**
 * Creates an `Effect` that fails with the specified error, evaluated lazily.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const failSync = internal_core/* failSync */.zph;
/**
 * Creates an `Effect` that fails with the specified `Cause`.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const Effect_failCause = internal_core/* failCause */.DhG;
/**
 * Creates an `Effect` that fails with the specified `Cause`, evaluated lazily.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const failCauseSync = internal_core/* failCauseSync */.euP;
/**
 * Creates an effect that terminates a fiber with a specified error.
 *
 * **Details**
 *
 * This function is used to signal a defect, which represents a critical and
 * unexpected error in the code. When invoked, it produces an effect that does
 * not handle the error and instead terminates the fiber.
 *
 * The error channel of the resulting effect is of type `never`, indicating that
 * it cannot recover from this failure.
 *
 * **When to Use**
 *
 * Use this function when encountering unexpected conditions in your code that
 * should not be handled as regular errors but instead represent unrecoverable
 * defects.
 *
 * **Example** (Terminating on Division by Zero with a Specified Error)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const divide = (a: number, b: number) =>
 *   b === 0
 *     ? Effect.die(new Error("Cannot divide by zero"))
 *     : Effect.succeed(a / b)
 *
 * //      ┌─── Effect<number, never, never>
 * //      ▼
 * const program = divide(1, 0)
 *
 * Effect.runPromise(program).catch(console.error)
 * // Output:
 * // (FiberFailure) Error: Cannot divide by zero
 * //   ...stack trace...
 * ```
 *
 * @see {@link dieSync} for a variant that throws a specified error, evaluated
 * lazily.
 * @see {@link dieMessage} for a variant that throws a `RuntimeException` with a
 * message.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const die = internal_core/* die */.Xre;
/**
 * Creates an effect that terminates a fiber with a `RuntimeException`
 * containing the specified message.
 *
 * **Details**
 *
 * This function is used to signal a defect, representing a critical and
 * unexpected error in the code. When invoked, it produces an effect that
 * terminates the fiber with a `RuntimeException` carrying the given message.
 *
 * The resulting effect has an error channel of type `never`, indicating it does
 * not handle or recover from the error.
 *
 * **When to Use**
 *
 * Use this function when you want to terminate a fiber due to an unrecoverable
 * defect and include a clear explanation in the message.
 *
 * **Example** (Terminating on Division by Zero with a Specified Message)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const divide = (a: number, b: number) =>
 *   b === 0
 *     ? Effect.dieMessage("Cannot divide by zero")
 *     : Effect.succeed(a / b)
 *
 * //      ┌─── Effect<number, never, never>
 * //      ▼
 * const program = divide(1, 0)
 *
 * Effect.runPromise(program).catch(console.error)
 * // Output:
 * // (FiberFailure) RuntimeException: Cannot divide by zero
 * //   ...stack trace...
 * ```
 *
 * @see {@link die} for a variant that throws a specified error.
 * @see {@link dieSync} for a variant that throws a specified error, evaluated
 * lazily.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const dieMessage = internal_core/* dieMessage */.lFE;
/**
 * Creates an effect that dies with the specified error, evaluated lazily.
 *
 * **Details**
 *
 * This function allows you to create an effect that will terminate with a fatal error.
 * The error is provided as a lazy argument, meaning it will only be evaluated when the effect runs.
 *
 * @see {@link die} if you don't need to evaluate the error lazily.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const dieSync = internal_core/* dieSync */.AgX;
/**
 * Provides a way to write effectful code using generator functions, simplifying
 * control flow and error handling.
 *
 * **When to Use**
 *
 * `Effect.gen` allows you to write code that looks and behaves like synchronous
 * code, but it can handle asynchronous tasks, errors, and complex control flow
 * (like loops and conditions). It helps make asynchronous code more readable
 * and easier to manage.
 *
 * The generator functions work similarly to `async/await` but with more
 * explicit control over the execution of effects. You can `yield*` values from
 * effects and return the final result at the end.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const addServiceCharge = (amount: number) => amount + 1
 *
 * const applyDiscount = (
 *   total: number,
 *   discountRate: number
 * ): Effect.Effect<number, Error> =>
 *   discountRate === 0
 *     ? Effect.fail(new Error("Discount rate cannot be zero"))
 *     : Effect.succeed(total - (total * discountRate) / 100)
 *
 * const fetchTransactionAmount = Effect.promise(() => Promise.resolve(100))
 *
 * const fetchDiscountRate = Effect.promise(() => Promise.resolve(5))
 *
 * export const program = Effect.gen(function* () {
 *   const transactionAmount = yield* fetchTransactionAmount
 *   const discountRate = yield* fetchDiscountRate
 *   const discountedAmount = yield* applyDiscount(
 *     transactionAmount,
 *     discountRate
 *   )
 *   const finalAmount = addServiceCharge(discountedAmount)
 *   return `Final amount to charge: ${finalAmount}`
 * })
 * ```
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const gen = internal_core/* gen */.Yr4;
/**
 * An effect that that runs indefinitely and never produces any result. The
 * moral equivalent of `while(true) {}`, only without the wasted CPU cycles.
 *
 * **When to Use**
 *
 * It could be useful for long-running background tasks or to simulate waiting
 * behavior without actually consuming resources. This effect is ideal for cases
 * where you want to keep the program alive or in a certain state without
 * performing any active work.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const never = internal_core/* never */.FiN;
/**
 * Ensures the `Option` is `None`, returning `void`. Otherwise, raises a
 * `NoSuchElementException`.
 *
 * **Details**
 *
 * This function checks if the provided `Option` is `None`. If it is, it returns
 * an effect that produces no result (i.e., `void`). If the `Option` is not
 * `None` (i.e., it contains a value), the function will raise a
 * `NoSuchElementException` error.
 *
 * **When to Use**
 *
 * This is useful when you want to ensure that a certain value is absent (i.e.,
 * `None`) before continuing execution, and to handle cases where the value is
 * unexpectedly present.
 *
 * @since 2.0.0
 */
const none = core_effect/* none */.YP;
/**
 * Creates an `Effect` that represents an asynchronous computation guaranteed to
 * succeed.
 *
 * **Details**
 *
 * The provided function (`thunk`) returns a `Promise` that should never reject; if it does, the error
 * will be treated as a "defect".
 *
 * This defect is not a standard error but indicates a flaw in the logic that
 * was expected to be error-free. You can think of it similar to an unexpected
 * crash in the program, which can be further managed or logged using tools like
 * {@link catchAllDefect}.
 *
 * **Interruptions**
 *
 * An optional `AbortSignal` can be provided to allow for interruption of the
 * wrapped `Promise` API.
 *
 * **When to Use**
 *
 * Use this function when you are sure the operation will not reject.
 *
 * **Example** (Delayed Message)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const delay = (message: string) =>
 *   Effect.promise<string>(
 *     () =>
 *       new Promise((resolve) => {
 *         setTimeout(() => {
 *           resolve(message)
 *         }, 2000)
 *       })
 *   )
 *
 * //      ┌─── Effect<string, never, never>
 * //      ▼
 * const program = delay("Async operation completed successfully!")
 * ```
 *
 * @see {@link tryPromise} for a version that can handle failures.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const promise = core_effect/* promise */.MC;
/**
 * Creates an `Effect` that always succeeds with a given value.
 *
 * **When to Use**
 *
 * Use this function when you need an effect that completes successfully with a
 * specific value without any errors or external dependencies.
 *
 * **Example** (Creating a Successful Effect)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * // Creating an effect that represents a successful scenario
 * //
 * //      ┌─── Effect<number, never, never>
 * //      ▼
 * const success = Effect.succeed(42)
 * ```
 *
 * @see {@link fail} to create an effect that represents a failure.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const Effect_succeed = internal_core/* succeed */.ng0;
/**
 * Returns an effect which succeeds with `None`.
 *
 * **When to Use**
 *
 * Use this function when you need to represent the absence of a value in your
 * code, especially when working with optional data. This can be helpful when
 * you want to indicate that no result is available without throwing an error or
 * performing additional logic.
 *
 * @see {@link succeedSome} to create an effect that succeeds with a `Some` value.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const succeedNone = core_effect/* succeedNone */.pF;
/**
 * Returns an effect which succeeds with the value wrapped in a `Some`.
 *
 * @see {@link succeedNone} for a similar function that returns `None` when the value is absent.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const succeedSome = core_effect/* succeedSome */.i4;
/**
 * Delays the creation of an `Effect` until it is actually needed.
 *
 * **Details**
 *
 * The `Effect.suspend` function takes a thunk that represents the effect and
 * wraps it in a suspended effect. This means the effect will not be created
 * until it is explicitly needed, which is helpful in various scenarios:
 * - **Lazy Evaluation**: Helps optimize performance by deferring computations,
 *   especially when the effect might not be needed, or when its computation is
 *   expensive. This also ensures that any side effects or scoped captures are
 *   re-executed on each invocation.
 * - **Handling Circular Dependencies**: Useful in managing circular
 *   dependencies, such as recursive functions that need to avoid eager
 *   evaluation to prevent stack overflow.
 * - **Unifying Return Types**: Can help TypeScript unify return types in
 *   situations where multiple branches of logic return different effects,
 *   simplifying type inference.
 *
 * **When to Use**
 *
 * Use this function when you need to defer the evaluation of an effect until it
 * is required. This is particularly useful for optimizing expensive
 * computations, managing circular dependencies, or resolving type inference
 * issues.
 *
 * **Example** (Lazy Evaluation with Side Effects)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * let i = 0
 *
 * const bad = Effect.succeed(i++)
 *
 * const good = Effect.suspend(() => Effect.succeed(i++))
 *
 * console.log(Effect.runSync(bad)) // Output: 0
 * console.log(Effect.runSync(bad)) // Output: 0
 *
 * console.log(Effect.runSync(good)) // Output: 1
 * console.log(Effect.runSync(good)) // Output: 2
 * ```
 *
 * **Example** (Recursive Fibonacci)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const blowsUp = (n: number): Effect.Effect<number> =>
 *   n < 2
 *     ? Effect.succeed(1)
 *     : Effect.zipWith(blowsUp(n - 1), blowsUp(n - 2), (a, b) => a + b)
 *
 * console.log(Effect.runSync(blowsUp(32)))
 * // crash: JavaScript heap out of memory
 *
 * const allGood = (n: number): Effect.Effect<number> =>
 *   n < 2
 *     ? Effect.succeed(1)
 *     : Effect.zipWith(
 *         Effect.suspend(() => allGood(n - 1)),
 *         Effect.suspend(() => allGood(n - 2)),
 *         (a, b) => a + b
 *       )
 *
 * console.log(Effect.runSync(allGood(32)))
 * // Output: 3524578
 * ```
 *
 * **Example** (Using Effect.suspend to Help TypeScript Infer Types)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * //   Without suspend, TypeScript may struggle with type inference.
 * //   Inferred type:
 * //     (a: number, b: number) =>
 * //       Effect<never, Error, never> | Effect<number, never, never>
 * const withoutSuspend = (a: number, b: number) =>
 *   b === 0
 *     ? Effect.fail(new Error("Cannot divide by zero"))
 *     : Effect.succeed(a / b)
 *
 * //   Using suspend to unify return types.
 * //   Inferred type:
 * //     (a: number, b: number) => Effect<number, Error, never>
 * const withSuspend = (a: number, b: number) =>
 *   Effect.suspend(() =>
 *     b === 0
 *       ? Effect.fail(new Error("Cannot divide by zero"))
 *       : Effect.succeed(a / b)
 *   )
 * ```
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const suspend = internal_core/* suspend */.RqG;
/**
 * Creates an `Effect` that represents a synchronous side-effectful computation.
 *
 * **Details**
 *
 * The provided function (`thunk`) must not throw errors; if it does, the error
 * will be treated as a "defect".
 *
 * This defect is not a standard error but indicates a flaw in the logic that
 * was expected to be error-free. You can think of it similar to an unexpected
 * crash in the program, which can be further managed or logged using tools like
 * {@link catchAllDefect}.
 *
 * **When to Use**
 *
 * Use this function when you are sure the operation will not fail.
 *
 * **Example** (Logging a Message)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const log = (message: string) =>
 *   Effect.sync(() => {
 *     console.log(message) // side effect
 *   })
 *
 * //      ┌─── Effect<void, never, never>
 * //      ▼
 * const program = log("Hello, World!")
 * ```
 *
 * @see {@link try_ | try} for a version that can handle failures.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const sync = internal_core/* sync */.Z_X;
const _void = internal_core/* void */.Hcj;

/**
 * @since 2.0.0
 * @category Creating Effects
 */
const yieldNow = internal_core/* yieldNow */.T4Q;
const _catch = core_effect/* _catch */.Xw;

/**
 * Handles all errors in an effect by providing a fallback effect.
 *
 * **Details**
 *
 * This function catches any errors that may occur during the execution of an
 * effect and allows you to handle them by specifying a fallback effect. This
 * ensures that the program continues without failing by recovering from errors
 * using the provided fallback logic.
 *
 * **Note**: This function only handles recoverable errors. It will not recover
 * from unrecoverable defects.
 *
 * **Example** (Providing Recovery Logic for Recoverable Errors)
 *
 * ```ts
 * import { Effect, Random } from "effect"
 *
 * class HttpError {
 *   readonly _tag = "HttpError"
 * }
 *
 * class ValidationError {
 *   readonly _tag = "ValidationError"
 * }
 *
 * //      ┌─── Effect<string, HttpError | ValidationError, never>
 * //      ▼
 * const program = Effect.gen(function* () {
 *   const n1 = yield* Random.next
 *   const n2 = yield* Random.next
 *   if (n1 < 0.5) {
 *     yield* Effect.fail(new HttpError())
 *   }
 *   if (n2 < 0.5) {
 *     yield* Effect.fail(new ValidationError())
 *   }
 *   return "some result"
 * })
 *
 * //      ┌─── Effect<string, never, never>
 * //      ▼
 * const recovered = program.pipe(
 *   Effect.catchAll((error) =>
 *     Effect.succeed(`Recovering from ${error._tag}`)
 *   )
 * )
 * ```
 *
 * @see {@link catchAllCause} for a version that can recover from both
 * recoverable and unrecoverable errors.
 *
 * @since 2.0.0
 * @category Error handling
 */
const catchAll = internal_core/* catchAll */.kmb;
/**
 * Handles both recoverable and unrecoverable errors by providing a recovery
 * effect.
 *
 * **When to Use**
 *
 * The `catchAllCause` function allows you to handle all errors, including
 * unrecoverable defects, by providing a recovery effect. The recovery logic is
 * based on the `Cause` of the error, which provides detailed information about
 * the failure.
 *
 * **When to Recover from Defects**
 *
 * Defects are unexpected errors that typically shouldn't be recovered from, as
 * they often indicate serious issues. However, in some cases, such as
 * dynamically loaded plugins, controlled recovery might be needed.
 *
 * **Example** (Recovering from All Errors)
 *
 * ```ts
 * import { Cause, Effect } from "effect"
 *
 * // Define an effect that may fail with a recoverable or unrecoverable error
 * const program = Effect.fail("Something went wrong!")
 *
 * // Recover from all errors by examining the cause
 * const recovered = program.pipe(
 *   Effect.catchAllCause((cause) =>
 *     Cause.isFailure(cause)
 *       ? Effect.succeed("Recovered from a regular error")
 *       : Effect.succeed("Recovered from a defect")
 *   )
 * )
 *
 * Effect.runPromise(recovered).then(console.log)
 * // Output: "Recovered from a regular error"
 * ```
 *
 * @since 2.0.0
 * @category Error handling
 */
const catchAllCause = internal_core/* catchAllCause */.Npq;
/**
 * Recovers from all defects using a provided recovery function.
 *
 * **When to Use**
 *
 * There is no sensible way to recover from defects. This method should be used
 * only at the boundary between Effect and an external system, to transmit
 * information on a defect for diagnostic or explanatory purposes.
 *
 * **Details**
 *
 * `catchAllDefect` allows you to handle defects, which are unexpected errors
 * that usually cause the program to terminate. This function lets you recover
 * from these defects by providing a function that handles the error. However,
 * it does not handle expected errors (like those from {@link fail}) or
 * execution interruptions (like those from {@link interrupt}).
 *
 * **When to Recover from Defects**
 *
 * Defects are unexpected errors that typically shouldn't be recovered from, as
 * they often indicate serious issues. However, in some cases, such as
 * dynamically loaded plugins, controlled recovery might be needed.
 *
 * **Example** (Handling All Defects)
 *
 * ```ts
 * import { Effect, Cause, Console } from "effect"
 *
 * // Simulating a runtime error
 * const task = Effect.dieMessage("Boom!")
 *
 * const program = Effect.catchAllDefect(task, (defect) => {
 *   if (Cause.isRuntimeException(defect)) {
 *     return Console.log(
 *       `RuntimeException defect caught: ${defect.message}`
 *     )
 *   }
 *   return Console.log("Unknown defect caught.")
 * })
 *
 * // We get an Exit.Success because we caught all defects
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // RuntimeException defect caught: Boom!
 * // {
 * //   _id: "Exit",
 * //   _tag: "Success",
 * //   value: undefined
 * // }
 * ```
 *
 * @since 2.0.0
 * @category Error handling
 */
const catchAllDefect = core_effect/* catchAllDefect */.KP;
/**
 * Recovers from specific errors based on a predicate.
 *
 * **When to Use**
 *
 * `catchIf` works similarly to {@link catchSome}, but it allows you to
 * recover from errors by providing a predicate function. If the predicate
 * matches the error, the recovery effect is applied. This function doesn't
 * alter the error type, so the resulting effect still carries the original
 * error type unless a user-defined type guard is used to narrow the type.
 *
 * **Example** (Catching Specific Errors with a Predicate)
 *
 * ```ts
 * import { Effect, Random } from "effect"
 *
 * class HttpError {
 *   readonly _tag = "HttpError"
 * }
 *
 * class ValidationError {
 *   readonly _tag = "ValidationError"
 * }
 *
 * //      ┌─── Effect<string, HttpError | ValidationError, never>
 * //      ▼
 * const program = Effect.gen(function* () {
 *   const n1 = yield* Random.next
 *   const n2 = yield* Random.next
 *   if (n1 < 0.5) {
 *     yield* Effect.fail(new HttpError())
 *   }
 *   if (n2 < 0.5) {
 *     yield* Effect.fail(new ValidationError())
 *   }
 *   return "some result"
 * })
 *
 * //      ┌─── Effect<string, ValidationError, never>
 * //      ▼
 * const recovered = program.pipe(
 *   Effect.catchIf(
 *     // Only handle HttpError errors
 *     (error) => error._tag === "HttpError",
 *     () => Effect.succeed("Recovering from HttpError")
 *   )
 * )
 * ```
 *
 * @since 2.0.0
 * @category Error handling
 */
const catchIf = internal_core/* catchIf */.yNi;
/**
 * Catches and recovers from specific types of errors, allowing you to attempt
 * recovery only for certain errors.
 *
 * **Details**
 *
 * `catchSome` lets you selectively catch and handle errors of certain
 * types by providing a recovery effect for specific errors. If the error
 * matches a condition, recovery is attempted; if not, it doesn't affect the
 * program. This function doesn't alter the error type, meaning the error type
 * remains the same as in the original effect.
 *
 * **Example** (Handling Specific Errors with Effect.catchSome)
 *
 * ```ts
 * import { Effect, Random, Option } from "effect"
 *
 * class HttpError {
 *   readonly _tag = "HttpError"
 * }
 *
 * class ValidationError {
 *   readonly _tag = "ValidationError"
 * }
 *
 * //      ┌─── Effect<string, HttpError | ValidationError, never>
 * //      ▼
 * const program = Effect.gen(function* () {
 *   const n1 = yield* Random.next
 *   const n2 = yield* Random.next
 *   if (n1 < 0.5) {
 *     yield* Effect.fail(new HttpError())
 *   }
 *   if (n2 < 0.5) {
 *     yield* Effect.fail(new ValidationError())
 *   }
 *   return "some result"
 * })
 *
 * //      ┌─── Effect<string, HttpError | ValidationError, never>
 * //      ▼
 * const recovered = program.pipe(
 *   Effect.catchSome((error) => {
 *     // Only handle HttpError errors
 *     if (error._tag === "HttpError") {
 *       return Option.some(Effect.succeed("Recovering from HttpError"))
 *     } else {
 *       return Option.none()
 *     }
 *   })
 * )
 * ```
 *
 * @see {@link catchIf} for a version that allows you to recover from errors based on a predicate.
 *
 * @since 2.0.0
 * @category Error handling
 */
const catchSome = internal_core/* catchSome */.ENG;
/**
 * Recovers from specific causes using a provided partial function.
 *
 * @see {@link catchSome} for a version that allows you to recover from errors.
 * @see {@link catchSomeDefect} for a version that allows you to recover from defects.
 *
 * @since 2.0.0
 * @category Error handling
 */
const catchSomeCause = core_effect/* catchSomeCause */.y8;
/**
 * Recovers from specific defects using a provided partial function.
 *
 * **Details**
 *
 * `catchSomeDefect` allows you to handle specific defects, which are
 * unexpected errors that can cause the program to stop. It uses a partial
 * function to catch only certain defects and ignores others. The function does
 * not handle expected errors (such as those caused by {@link fail}) or
 * interruptions in execution (like those caused by {@link interrupt}).
 *
 * This function provides a way to handle certain types of defects while
 * allowing others to propagate and cause failure in the program.
 *
 * **Note**: There is no sensible way to recover from defects. This method
 * should be used only at the boundary between Effect and an external system, to
 * transmit information on a defect for diagnostic or explanatory purposes.
 *
 * **How the Partial Function Works**
 *
 * The function provided to `catchSomeDefect` acts as a filter and a handler for defects:
 * - It receives the defect as an input.
 * - If the defect matches a specific condition (e.g., a certain error type), the function returns
 *   an `Option.some` containing the recovery logic.
 * - If the defect does not match, the function returns `Option.none`, allowing the defect to propagate.
 *
 * **Example** (Handling Specific Defects)
 *
 * ```ts
 * import { Effect, Cause, Option, Console } from "effect"
 *
 * // Simulating a runtime error
 * const task = Effect.dieMessage("Boom!")
 *
 * const program = Effect.catchSomeDefect(task, (defect) => {
 *   if (Cause.isIllegalArgumentException(defect)) {
 *     return Option.some(
 *       Console.log(
 *         `Caught an IllegalArgumentException defect: ${defect.message}`
 *       )
 *     )
 *   }
 *   return Option.none()
 * })
 *
 * // Since we are only catching IllegalArgumentException
 * // we will get an Exit.Failure because we simulated a runtime error.
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: {
 * //     _id: 'Cause',
 * //     _tag: 'Die',
 * //     defect: { _tag: 'RuntimeException' }
 * //   }
 * // }
 * ```
 *
 * @since 2.0.0
 * @category Error handling
 */
const catchSomeDefect = core_effect/* catchSomeDefect */.C5;
/**
 * Catches and handles specific errors by their `_tag` field, which is used as a
 * discriminator.
 *
 * **When to Use**
 *
 * `catchTag` is useful when your errors are tagged with a readonly `_tag` field
 * that identifies the error type. You can use this function to handle specific
 * error types by matching the `_tag` value. This allows for precise error
 * handling, ensuring that only specific errors are caught and handled.
 *
 * The error type must have a readonly `_tag` field to use `catchTag`. This
 * field is used to identify and match errors.
 *
 * **Example** (Handling Errors by Tag)
 *
 * ```ts
 * import { Effect, Random } from "effect"
 *
 * class HttpError {
 *   readonly _tag = "HttpError"
 * }
 *
 * class ValidationError {
 *   readonly _tag = "ValidationError"
 * }
 *
 * //      ┌─── Effect<string, HttpError | ValidationError, never>
 * //      ▼
 * const program = Effect.gen(function* () {
 *   const n1 = yield* Random.next
 *   const n2 = yield* Random.next
 *   if (n1 < 0.5) {
 *     yield* Effect.fail(new HttpError())
 *   }
 *   if (n2 < 0.5) {
 *     yield* Effect.fail(new ValidationError())
 *   }
 *   return "some result"
 * })
 *
 * //      ┌─── Effect<string, ValidationError, never>
 * //      ▼
 * const recovered = program.pipe(
 *   // Only handle HttpError errors
 *   Effect.catchTag("HttpError", (_HttpError) =>
 *     Effect.succeed("Recovering from HttpError")
 *   )
 * )
 * ```
 *
 * @see {@link catchTags} for a version that allows you to handle multiple error
 * types at once.
 *
 * @since 2.0.0
 * @category Error handling
 */
const catchTag = core_effect/* catchTag */.Gl;
/**
 * Handles multiple errors in a single block of code using their `_tag` field.
 *
 * **When to Use**
 *
 * `catchTags` is a convenient way to handle multiple error types at
 * once. Instead of using {@link catchTag} multiple times, you can pass an
 * object where each key is an error type's `_tag`, and the value is the handler
 * for that specific error. This allows you to catch and recover from multiple
 * error types in a single call.
 *
 * The error type must have a readonly `_tag` field to use `catchTag`. This
 * field is used to identify and match errors.
 *
 * **Example** (Handling Multiple Tagged Error Types at Once)
 *
 * ```ts
 * import { Effect, Random } from "effect"
 *
 * class HttpError {
 *   readonly _tag = "HttpError"
 * }
 *
 * class ValidationError {
 *   readonly _tag = "ValidationError"
 * }
 *
 * //      ┌─── Effect<string, HttpError | ValidationError, never>
 * //      ▼
 * const program = Effect.gen(function* () {
 *   const n1 = yield* Random.next
 *   const n2 = yield* Random.next
 *   if (n1 < 0.5) {
 *     yield* Effect.fail(new HttpError())
 *   }
 *   if (n2 < 0.5) {
 *     yield* Effect.fail(new ValidationError())
 *   }
 *   return "some result"
 * })
 *
 * //      ┌─── Effect<string, never, never>
 * //      ▼
 * const recovered = program.pipe(
 *   Effect.catchTags({
 *     HttpError: (_HttpError) =>
 *       Effect.succeed(`Recovering from HttpError`),
 *     ValidationError: (_ValidationError) =>
 *       Effect.succeed(`Recovering from ValidationError`)
 *   })
 * )
 * ```
 *
 * @since 2.0.0
 * @category Error handling
 */
const catchTags = core_effect/* catchTags */.dL;
/**
 * Retrieves the cause of a failure in an effect.
 *
 * **Details**
 *
 * This function allows you to expose the detailed cause of an effect, which
 * includes a more precise representation of failures, such as error messages
 * and defects.
 *
 * **When to Use**
 *
 * This function is helpful when you need to inspect the cause of a failure in
 * an effect, giving you more information than just the error message. It can be
 * used to log, handle, or analyze failures in more detail, including
 * distinguishing between different types of defects (e.g., runtime exceptions,
 * interruptions, etc.).
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * //      ┌─── Effect<number, string, never>
 * //      ▼
 * const program = Effect.fail("Oh uh!").pipe(Effect.as(2))
 *
 * //      ┌─── Effect<void, never, never>
 * //      ▼
 * const recovered = Effect.gen(function* () {
 *   const cause = yield* Effect.cause(program)
 *   yield* Console.log(cause)
 * })
 * ```
 *
 * @since 2.0.0
 * @category Error handling
 */
const cause = core_effect/* cause */.tx;
/**
 * Runs an effect repeatedly until it succeeds, ignoring errors.
 *
 * **Details**
 *
 * This function takes an effect and runs it repeatedly until the effect
 * successfully completes. If the effect fails, it will ignore the error and
 * retry the operation. This is useful when you need to perform a task that may
 * fail occasionally, but you want to keep trying until it eventually succeeds.
 * It works by repeatedly executing the effect until it no longer throws an
 * error.
 *
 * **When to Use**
 *
 * Use this function when you want to retry an operation multiple times until it
 * succeeds. It is helpful in cases where the operation may fail temporarily
 * (e.g., a network request), and you want to keep trying without handling or
 * worrying about the errors.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * let counter = 0
 *
 * const effect = Effect.try(() => {
 *   counter++
 *   if (counter < 3) {
 *     console.log("running effect")
 *     throw new Error("error")
 *   } else {
 *     console.log("effect done")
 *     return "some result"
 *   }
 * })
 *
 * const program = Effect.eventually(effect)
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // running effect
 * // running effect
 * // effect done
 * // some result
 * ```
 *
 * @since 2.0.0
 * @category Error handling
 */
const eventually = core_effect/* eventually */.zm;
/**
 * Discards both the success and failure values of an effect.
 *
 * **When to Use**
 *
 * `ignore` allows you to run an effect without caring about its result, whether
 * it succeeds or fails. This is useful when you only care about the side
 * effects of the effect and do not need to handle or process its outcome.
 *
 * **Example** (Using Effect.ignore to Discard Values)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * //      ┌─── Effect<number, string, never>
 * //      ▼
 * const task = Effect.fail("Uh oh!").pipe(Effect.as(5))
 *
 * //      ┌─── Effect<void, never, never>
 * //      ▼
 * const program = Effect.ignore(task)
 * ```
 *
 * @see {@link ignoreLogged} to log failures while ignoring them.
 *
 * @since 2.0.0
 * @category Error handling
 */
const ignore = core_effect/* ignore */.ID;
/**
 * Ignores the result of an effect but logs any failures.
 *
 * **Details**
 *
 * This function takes an effect and returns a new effect that ignores whether
 * the original effect succeeds or fails. However, if the effect fails, it will
 * log the failure at the Debug level, so you can keep track of any issues that
 * arise.
 *
 * **When to Use**
 *
 * This is useful in scenarios where you want to continue with your program
 * regardless of the result of the effect, but you still want to be aware of
 * potential failures that may need attention later.
 *
 * @since 2.0.0
 * @category Error handling
 */
const ignoreLogged = core_effect/* ignoreLogged */.RC;
/**
 * Combines all errors from concurrent operations into a single error.
 *
 * **Details**
 *
 * This function is used when you have multiple operations running at the same
 * time, and you want to capture all the errors that occur across those
 * operations. Instead of handling each error separately, it combines all the
 * errors into one unified error.
 *
 * **When to Use**
 *
 * When using this function, any errors that occur in the concurrently running
 * operations will be grouped together into a single error. This helps simplify
 * error handling in cases where you don't need to differentiate between each
 * failure, but simply want to know that multiple failures occurred.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const fail1 = Effect.fail("Oh uh!")
 * const fail2 = Effect.fail("Oh no!")
 * const die = Effect.dieMessage("Boom!")
 *
 * // Run all effects concurrently and capture all errors
 * const program = Effect.all([fail1, fail2, die], {
 *   concurrency: "unbounded"
 * }).pipe(Effect.asVoid, Effect.parallelErrors)
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: { _id: 'Cause', _tag: 'Fail', failure: [ 'Oh uh!', 'Oh no!' ] }
 * // }
 * ```
 *
 * @since 2.0.0
 * @category Error handling
 */
const parallelErrors = core_effect/* parallelErrors */.ki;
/**
 * Transforms an effect to expose detailed error causes.
 *
 * **Details**
 *
 * This function enhances an effect by providing detailed information about any
 * error, defect, or interruption that may occur during its execution. It
 * modifies the error channel of the effect so that it includes a full cause of
 * the failure, wrapped in a `Cause<E>` type.
 *
 * After applying this function, you can use operators like {@link catchAll} and
 * {@link catchTags} to handle specific types of errors.
 *
 * If you no longer need the detailed cause information, you can revert the
 * changes using {@link unsandbox} to return to the original error-handling
 * behavior.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * //      ┌─── Effect<string, Error, never>
 * //      ▼
 * const task = Effect.fail(new Error("Oh uh!")).pipe(
 *   Effect.as("primary result")
 * )
 *
 * //      ┌─── Effect<string, Cause<Error>, never>
 * //      ▼
 * const sandboxed = Effect.sandbox(task)
 *
 * const program = Effect.catchTags(sandboxed, {
 *   Die: (cause) =>
 *     Console.log(`Caught a defect: ${cause.defect}`).pipe(
 *       Effect.as("fallback result on defect")
 *     ),
 *   Interrupt: (cause) =>
 *     Console.log(`Caught a defect: ${cause.fiberId}`).pipe(
 *       Effect.as("fallback result on fiber interruption")
 *     ),
 *   Fail: (cause) =>
 *     Console.log(`Caught a defect: ${cause.error}`).pipe(
 *       Effect.as("fallback result on failure")
 *     )
 * })
 *
 * // Restore the original error handling with unsandbox
 * const main = Effect.unsandbox(program)
 *
 * Effect.runPromise(main).then(console.log)
 * // Output:
 * // Caught a defect: Oh uh!
 * // fallback result on failure
 * ```
 *
 * @see {@link unsandbox} to restore the original error handling.
 *
 * @since 2.0.0
 * @category Error handling
 */
const sandbox = core_effect/* sandbox */.vH;
/**
 * Retries a failing effect based on a defined retry policy.
 *
 * **Details**
 *
 * The `Effect.retry` function takes an effect and a {@link Schedule} policy,
 * and will automatically retry the effect if it fails, following the rules of
 * the policy.
 *
 * If the effect ultimately succeeds, the result will be returned.
 *
 * If the maximum retries are exhausted and the effect still fails, the failure
 * is propagated.
 *
 * **When to Use**
 *
 * This can be useful when dealing with intermittent failures, such as network
 * issues or temporary resource unavailability. By defining a retry policy, you
 * can control the number of retries, the delay between them, and when to stop
 * retrying.
 *
 * **Example** (Retrying with a Fixed Delay)
 *
 * ```ts
 * import { Effect, Schedule } from "effect"
 *
 * let count = 0
 *
 * // Simulates an effect with possible failures
 * const task = Effect.async<string, Error>((resume) => {
 *   if (count <= 2) {
 *     count++
 *     console.log("failure")
 *     resume(Effect.fail(new Error()))
 *   } else {
 *     console.log("success")
 *     resume(Effect.succeed("yay!"))
 *   }
 * })
 *
 * // Define a repetition policy using a fixed delay between retries
 * const policy = Schedule.fixed("100 millis")
 *
 * const repeated = Effect.retry(task, policy)
 *
 * Effect.runPromise(repeated).then(console.log)
 * // Output:
 * // failure
 * // failure
 * // failure
 * // success
 * // yay!
 * ```
 *
 * **Example** (Retrying a Task up to 5 times)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * let count = 0
 *
 * // Simulates an effect with possible failures
 * const task = Effect.async<string, Error>((resume) => {
 *   if (count <= 2) {
 *     count++
 *     console.log("failure")
 *     resume(Effect.fail(new Error()))
 *   } else {
 *     console.log("success")
 *     resume(Effect.succeed("yay!"))
 *   }
 * })
 *
 * // Retry the task up to 5 times
 * Effect.runPromise(Effect.retry(task, { times: 5 })).then(console.log)
 * // Output:
 * // failure
 * // failure
 * // failure
 * // success
 * ```
 *
 * **Example** (Retrying Until a Specific Condition is Met)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * let count = 0
 *
 * // Define an effect that simulates varying error on each invocation
 * const action = Effect.failSync(() => {
 *   console.log(`Action called ${++count} time(s)`)
 *   return `Error ${count}`
 * })
 *
 * // Retry the action until a specific condition is met
 * const program = Effect.retry(action, {
 *   until: (err) => err === "Error 3"
 * })
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // Action called 1 time(s)
 * // Action called 2 time(s)
 * // Action called 3 time(s)
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: { _id: 'Cause', _tag: 'Fail', failure: 'Error 3' }
 * // }
 * ```
 *
 * @see {@link retryOrElse} for a version that allows you to run a fallback.
 * @see {@link repeat} if your retry condition is based on successful outcomes rather than errors.
 *
 * @since 2.0.0
 * @category Error handling
 */
const retry = schedule/* retry_combined */.H;
/**
 * Retries a failing effect and runs a fallback effect if retries are exhausted.
 *
 * **Details**
 *
 * The `Effect.retryOrElse` function attempts to retry a failing effect multiple
 * times according to a defined {@link Schedule} policy.
 *
 * If the retries are exhausted and the effect still fails, it runs a fallback
 * effect instead.
 *
 * **When to Use**
 *
 * This function is useful when you want to handle failures gracefully by
 * specifying an alternative action after repeated failures.
 *
 * **Example** (Retrying with Fallback)
 *
 * ```ts
 * import { Effect, Schedule, Console } from "effect"
 *
 * let count = 0
 *
 * // Simulates an effect with possible failures
 * const task = Effect.async<string, Error>((resume) => {
 *   if (count <= 2) {
 *     count++
 *     console.log("failure")
 *     resume(Effect.fail(new Error()))
 *   } else {
 *     console.log("success")
 *     resume(Effect.succeed("yay!"))
 *   }
 * })
 *
 * // Retry the task with a delay between retries and a maximum of 2 retries
 * const policy = Schedule.addDelay(Schedule.recurs(2), () => "100 millis")
 *
 * // If all retries fail, run the fallback effect
 * const repeated = Effect.retryOrElse(
 *   task,
 *   policy,
 *   // fallback
 *   () => Console.log("orElse").pipe(Effect.as("default value"))
 * )
 *
 * Effect.runPromise(repeated).then(console.log)
 * // Output:
 * // failure
 * // failure
 * // failure
 * // orElse
 * // default value
 * ```
 *
 * @see {@link retry} for a version that does not run a fallback effect.
 *
 * @since 2.0.0
 * @category Error handling
 */
const retryOrElse = schedule/* retryOrElse_Effect */.Gt;
const try_ = core_effect/* try_ */.DV;

/**
 * Returns an effect that maps its success using the specified side-effecting
 * `try` function, converting any errors into typed failed effects using the
 * `catch` function.
 *
 * @see {@link tryPromise} for a version that works with asynchronous computations.
 *
 * @since 2.0.0
 * @category Error handling
 */
const tryMap = core_effect/* tryMap */.K$;
/**
 * Returns an effect that maps its success using the specified side-effecting
 * `try` function, converting any promise rejections into typed failed effects
 * using the `catch` function.
 *
 * An optional `AbortSignal` can be provided to allow for interruption of the
 * wrapped `Promise` API.
 *
 * @see {@link tryMap} for a version that works with synchronous computations.
 *
 * @since 2.0.0
 * @category Error handling
 */
const tryMapPromise = core_effect/* tryMapPromise */.lm;
/**
 * Creates an `Effect` that represents an asynchronous computation that might
 * fail.
 *
 * **When to Use**
 *
 * In situations where you need to perform asynchronous operations that might
 * fail, such as fetching data from an API, you can use the `tryPromise`
 * constructor. This constructor is designed to handle operations that could
 * throw exceptions by capturing those exceptions and transforming them into
 * manageable errors.
 *
 * **Error Handling**
 *
 * There are two ways to handle errors with `tryPromise`:
 *
 * 1. If you don't provide a `catch` function, the error is caught and the
 *    effect fails with an `UnknownException`.
 * 2. If you provide a `catch` function, the error is caught and the `catch`
 *    function maps it to an error of type `E`.
 *
 * **Interruptions**
 *
 * An optional `AbortSignal` can be provided to allow for interruption of the
 * wrapped `Promise` API.
 *
 * **Example** (Fetching a TODO Item)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const getTodo = (id: number) =>
 *   // Will catch any errors and propagate them as UnknownException
 *   Effect.tryPromise(() =>
 *     fetch(`https://jsonplaceholder.typicode.com/todos/${id}`)
 *   )
 *
 * //      ┌─── Effect<Response, UnknownException, never>
 * //      ▼
 * const program = getTodo(1)
 * ```
 *
 * **Example** (Custom Error Handling)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const getTodo = (id: number) =>
 *   Effect.tryPromise({
 *     try: () => fetch(`https://jsonplaceholder.typicode.com/todos/${id}`),
 *     // remap the error
 *     catch: (unknown) => new Error(`something went wrong ${unknown}`)
 *   })
 *
 * //      ┌─── Effect<Response, Error, never>
 * //      ▼
 * const program = getTodo(1)
 * ```
 *
 * @see {@link promise} if the effectful computation is asynchronous and does not throw errors.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const tryPromise = core_effect/* tryPromise */.p6;
/**
 * The `unsandbox` function is used to revert an effect that has been
 * sandboxed by {@link sandbox}. When you apply `unsandbox`, the
 * effect's error channel is restored to its original state, without the
 * detailed `Cause<E>` information. This means that any underlying causes of
 * errors, defects, or fiber interruptions are no longer exposed in the error
 * channel.
 *
 * This function is useful when you want to remove the detailed error tracking
 * provided by `sandbox` and return to the standard error handling for
 * your effect. Once unsandboxed, the effect behaves as if `sandbox` was
 * never applied.
 *
 * @see {@link sandbox} to expose the full cause of failures, defects, or interruptions.
 *
 * @since 2.0.0
 * @category Error handling
 */
const unsandbox = core_effect/* unsandbox */.wi;
/**
 * Allows interruption of the current fiber, even in uninterruptible regions.
 *
 * **Details**
 *
 * This effect checks whether any other fibers are attempting to interrupt the
 * current fiber. If so, it allows the current fiber to perform a
 * self-interruption.
 *
 * **When to Use**
 *
 * This is useful in situations where you want to allow interruption to happen
 * even in regions of the code that are normally uninterruptible.
 *
 * @since 2.0.0
 * @category Interruption
 */
const allowInterrupt = core_effect/* allowInterrupt */.Q9;
/**
 * Checks if interruption is allowed and executes a callback accordingly.
 *
 * **Details**
 *
 * This function checks the current interrupt status of the running fiber. It
 * then calls the provided callback, passing a boolean indicating whether
 * interruption is allowed.
 *
 * **When to Use**
 *
 * This is useful for handling specific logic based on whether the current
 * operation can be interrupted, such as when performing asynchronous operations
 * or handling cancellation.
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * const program = Effect.gen(function*() {
 *   yield* Effect.checkInterruptible((isInterruptible) => {
 *     if (isInterruptible) {
 *       return Console.log("You can interrupt this operation.")
 *     } else {
 *       return Console.log("This operation cannot be interrupted.")
 *     }
 *   })
 * })
 *
 * Effect.runPromise(program)
 * // Output: You can interrupt this operation.
 *
 * Effect.runPromise(program.pipe(Effect.uninterruptible))
 * // Output: This operation cannot be interrupted.
 *
 * ```
 *
 *  @since 2.0.0
 * @category Interruption
 */
const checkInterruptible = internal_core/* checkInterruptible */.oGW;
/**
 * Provides a way to handle timeouts in uninterruptible effects, allowing them
 * to continue in the background while the main control flow proceeds with the
 * timeout error.
 *
 * **Details**
 *
 * The `disconnect` function allows an uninterruptible effect to continue
 * running in the background, while enabling the main control flow to
 * immediately recognize a timeout condition. This is useful when you want to
 * avoid blocking the program due to long-running tasks, especially when those
 * tasks do not need to affect the flow of the rest of the program.
 *
 * Without `disconnect`, an uninterruptible effect will ignore the
 * timeout and continue executing until it completes. The timeout error will
 * only be assessed after the effect finishes, which can cause delays in
 * recognizing a timeout.
 *
 * With `disconnect`, the uninterruptible effect proceeds in the
 * background while the main program flow can immediately handle the timeout
 * error or trigger alternative logic. This enables faster timeout handling
 * without waiting for the completion of the long-running task.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const longRunningTask = Effect.gen(function* () {
 *   console.log("Start heavy processing...")
 *   yield* Effect.sleep("5 seconds") // Simulate a long process
 *   console.log("Heavy processing done.")
 *   return "Data processed"
 * })
 *
 * const timedEffect = longRunningTask.pipe(
 *   Effect.uninterruptible,
 *   // Allows the task to finish in the background if it times out
 *   Effect.disconnect,
 *   Effect.timeout("1 second")
 * )
 *
 * Effect.runPromiseExit(timedEffect).then(console.log)
 * // Output:
 * // Start heavy processing...
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: {
 * //     _id: 'Cause',
 * //     _tag: 'Fail',
 * //     failure: { _tag: 'TimeoutException' }
 * //   }
 * // }
 * // Heavy processing done.
 * ```
 *
 * @see {@link timeout} for a version that interrupts the effect.
 * @see {@link uninterruptible} for creating an uninterruptible effect.
 *
 * @since 2.0.0
 * @category Interruption
 */
const disconnect = internal_fiberRuntime/* disconnect */.zP;
/**
 * Represents an effect that interrupts the current fiber.
 *
 * **Details**
 *
 * This effect models the explicit interruption of the fiber in which it runs.
 * When executed, it causes the fiber to stop its operation immediately,
 * capturing the interruption details such as the fiber's ID and its start time.
 * The resulting interruption can be observed in the `Exit` type if the effect
 * is run with functions like {@link runPromiseExit}.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const program = Effect.gen(function* () {
 *   console.log("start")
 *   yield* Effect.sleep("2 seconds")
 *   yield* Effect.interrupt
 *   console.log("done")
 *   return "some result"
 * })
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // start
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: {
 * //     _id: 'Cause',
 * //     _tag: 'Interrupt',
 * //     fiberId: {
 * //       _id: 'FiberId',
 * //       _tag: 'Runtime',
 * //       id: 0,
 * //       startTimeMillis: ...
 * //     }
 * //   }
 * // }
 * ```
 *
 * @since 2.0.0
 * @category Interruption
 */
const interrupt = internal_core/* interrupt */.e1i;
/**
 * @since 2.0.0
 * @category Interruption
 */
const interruptWith = internal_core/* interruptWith */.m4x;
/**
 * Marks an effect as interruptible.
 *
 * @since 2.0.0
 * @category Interruption
 */
const interruptible = internal_core/* interruptible */.um_;
/**
 * This function behaves like {@link interruptible}, but it also provides a
 * `restore` function. This function can be used to restore the interruptibility
 * of any specific region of code.
 *
 * @since 2.0.0
 * @category Interruption
 */
const interruptibleMask = internal_core/* interruptibleMask */.RxE;
/**
 * Registers a cleanup effect to run when an effect is interrupted.
 *
 * **Details**
 *
 * This function allows you to specify an effect to run when the fiber is
 * interrupted. This effect will be executed when the fiber is interrupted,
 * allowing you to perform cleanup or other actions.
 *
 * **Example** (Running a Cleanup Action on Interruption)
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * // This handler is executed when the fiber is interrupted
 * const handler = Effect.onInterrupt((_fibers) => Console.log("Cleanup completed"))
 *
 * const success = Console.log("Task completed").pipe(Effect.as("some result"), handler)
 *
 * Effect.runFork(success)
 * // Output:
 * // Task completed
 *
 * const failure = Console.log("Task failed").pipe(Effect.andThen(Effect.fail("some error")), handler)
 *
 * Effect.runFork(failure)
 * // Output:
 * // Task failed
 *
 * const interruption = Console.log("Task interrupted").pipe(Effect.andThen(Effect.interrupt), handler)
 *
 * Effect.runFork(interruption)
 * // Output:
 * // Task interrupted
 * // Cleanup completed
 * ```
 *
 * @since 2.0.0
 * @category Interruption
 */
const onInterrupt = internal_core/* onInterrupt */.J7b;
/**
 * Marks an effect as uninterruptible.
 *
 * @since 2.0.0
 * @category Interruption
 */
const uninterruptible = internal_core/* uninterruptible */.wUc;
/**
 * This function behaves like {@link uninterruptible}, but it also provides a
 * `restore` function. This function can be used to restore the interruptibility
 * of any specific region of code.
 *
 * @since 2.0.0
 * @category Interruption
 */
const uninterruptibleMask = internal_core/* uninterruptibleMask */.UO$;
/**
 * Transforms a `Predicate` function into an `Effect` returning the input value if the predicate returns `true`
 * or failing with specified error if the predicate fails
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const isPositive = (n: number): boolean => n > 0
 *
 * // succeeds with `1`
 * Effect.liftPredicate(1, isPositive, n => `${n} is not positive`)
 *
 * // fails with `"0 is not positive"`
 * Effect.liftPredicate(0, isPositive, n => `${n} is not positive`)
 * ```
 *
 * @category Condition Checking
 * @since 3.4.0
 */
const liftPredicate = core_effect/* liftPredicate */.NA;
/**
 * Replaces the value inside an effect with a constant value.
 *
 * **Details**
 *
 * This function allows you to ignore the original value inside an effect and
 * replace it with a constant value.
 *
 * **When to Use**
 *
 * It is useful when you no longer need the value produced by an effect but want
 * to ensure that the effect completes successfully with a specific constant
 * result instead. For instance, you can replace the value produced by a
 * computation with a predefined value, ignoring what was calculated before.
 *
 * **Example** (Replacing a Value)
 *
 * ```ts
 * import { pipe, Effect } from "effect"
 *
 * // Replaces the value 5 with the constant "new value"
 * const program = pipe(Effect.succeed(5), Effect.as("new value"))
 *
 * Effect.runPromise(program).then(console.log)
 * // Output: "new value"
 * ```
 *
 * @since 2.0.0
 * @category Mapping
 */
const as = internal_core.as;
/**
 * This function maps the success value of an `Effect` value to a `Some` value
 * in an `Option` value. If the original `Effect` value fails, the returned
 * `Effect` value will also fail.
 *
 * @category Mapping
 * @since 2.0.0
 */
const asSome = core_effect/* asSome */.l0;
/**
 * This function maps the error value of an `Effect` value to a `Some` value
 * in an `Option` value. If the original `Effect` value succeeds, the returned
 * `Effect` value will also succeed.
 *
 * @category Mapping
 * @since 2.0.0
 */
const asSomeError = core_effect/* asSomeError */.Ps;
/**
 * This function maps the success value of an `Effect` value to `void`. If the
 * original `Effect` value succeeds, the returned `Effect` value will also
 * succeed. If the original `Effect` value fails, the returned `Effect` value
 * will fail with the same error.
 *
 * @since 2.0.0
 * @category Mapping
 */
const asVoid = internal_core/* asVoid */.a2S;
/**
 * Swaps the success and error channels of an effect.
 *
 * **Details**
 *
 * This function reverses the flow of an effect by swapping its success and
 * error channels. The success value becomes an error, and the error value
 * becomes a success.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * //      ┌─── Effect<number, string, never>
 * //      ▼
 * const program = Effect.fail("Oh uh!").pipe(Effect.as(2))
 *
 * //      ┌─── Effect<string, number, never>
 * //      ▼
 * const flipped = Effect.flip(program)
 * ```
 *
 * @since 2.0.0
 * @category Mapping
 */
const flip = internal_core/* flip */.RRI;
/**
 * Swaps the error/value parameters, applies the function `f` and flips the
 * parameters back
 *
 * @since 2.0.0
 * @category Mapping
 */
const flipWith = core_effect/* flipWith */.tG;
/**
 * Transforms the value inside an effect by applying a function to it.
 *
 * **Syntax**
 *
 * ```ts skip-type-checking
 * const mappedEffect = pipe(myEffect, Effect.map(transformation))
 * // or
 * const mappedEffect = Effect.map(myEffect, transformation)
 * // or
 * const mappedEffect = myEffect.pipe(Effect.map(transformation))
 * ```
 *
 * **Details**
 *
 * `map` takes a function and applies it to the value contained within an
 * effect, creating a new effect with the transformed value.
 *
 * It's important to note that effects are immutable, meaning that the original
 * effect is not modified. Instead, a new effect is returned with the updated
 * value.
 *
 * **Example** (Adding a Service Charge)
 *
 * ```ts
 * import { pipe, Effect } from "effect"
 *
 * const addServiceCharge = (amount: number) => amount + 1
 *
 * const fetchTransactionAmount = Effect.promise(() => Promise.resolve(100))
 *
 * const finalAmount = pipe(
 *   fetchTransactionAmount,
 *   Effect.map(addServiceCharge)
 * )
 *
 * Effect.runPromise(finalAmount).then(console.log)
 * // Output: 101
 * ```
 *
 * @see {@link mapError} for a version that operates on the error channel.
 * @see {@link mapBoth} for a version that operates on both channels.
 * @see {@link flatMap} or {@link andThen} for a version that can return a new effect.
 *
 * @since 2.0.0
 * @category Mapping
 */
const map = internal_core/* map */.UID;
/**
 * Applies a stateful transformation to each element of a collection, producing
 * new elements along with an updated state.
 *
 * **When to Use**
 *
 * Use `mapAccum` when you need to process each element of a collection while
 * keeping track of some state across iterations.
 *
 * **Details**
 *
 * `mapAccum` takes an initial state (`initial`) and a function (`f`) that is
 * applied to each element. This function returns a new state and a transformed
 * element. The final effect produces both the accumulated state and the
 * transformed collection.
 *
 * If the input collection is a non-empty array, the return type will match the
 * input collection type.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * // Define an initial state and a transformation function
 * const initialState = 0
 *
 * const transformation = (state: number, element: string) =>
 *   Effect.succeed<[number, string]>([state + element.length, element.toUpperCase()])
 *
 * // Apply mapAccum to transform an array of strings
 * const program = Effect.mapAccum(["a", "bb", "ccc"], initialState, transformation)
 *
 * Effect.runPromise(program).then(([finalState, transformedCollection]) => {
 *   console.log(finalState)
 *   console.log(transformedCollection)
 * })
 * // Output:
 * // 6
 * // [ 'A', 'BB', 'CCC' ]
 * ```
 *
 * @since 2.0.0
 * @category Mapping
 */
const mapAccum = core_effect/* mapAccum */.zJ;
/**
 * Applies transformations to both the success and error channels of an effect.
 *
 * **Details**
 *
 * This function takes two map functions as arguments: one for the error channel
 * and one for the success channel. You can use it when you want to modify both
 * the error and the success values without altering the overall success or
 * failure status of the effect.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * //      ┌─── Effect<number, string, never>
 * //      ▼
 * const simulatedTask = Effect.fail("Oh no!").pipe(Effect.as(1))
 *
 * //      ┌─── Effect<boolean, Error, never>
 * //      ▼
 * const modified = Effect.mapBoth(simulatedTask, {
 *   onFailure: (message) => new Error(message),
 *   onSuccess: (n) => n > 0
 * })
 * ```
 *
 * @see {@link map} for a version that operates on the success channel.
 * @see {@link mapError} for a version that operates on the error channel.
 *
 * @since 2.0.0
 * @category Mapping
 */
const mapBoth = internal_core/* mapBoth */.SAn;
/**
 * Transforms or modifies the error produced by an effect without affecting its
 * success value.
 *
 * **When to Use**
 *
 * This function is helpful when you want to enhance the error with additional
 * information, change the error type, or apply custom error handling while
 * keeping the original behavior of the effect's success values intact. It only
 * operates on the error channel and leaves the success channel unchanged.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * //      ┌─── Effect<number, string, never>
 * //      ▼
 * const simulatedTask = Effect.fail("Oh no!").pipe(Effect.as(1))
 *
 * //      ┌─── Effect<number, Error, never>
 * //      ▼
 * const mapped = Effect.mapError(
 *   simulatedTask,
 *   (message) => new Error(message)
 * )
 * ```
 *
 * @see {@link map} for a version that operates on the success channel.
 * @see {@link mapBoth} for a version that operates on both channels.
 * @see {@link orElseFail} if you want to replace the error with a new one.
 *
 * @since 2.0.0
 * @category Mapping
 */
const mapError = internal_core/* mapError */.d1Y;
/**
 * Maps the cause of failure of an effect using a specified function.
 *
 * @see {@link sandbox} for a version that exposes the full cause of failures, defects, or interruptions.
 * @see {@link catchAllCause} for a version that can recover from all types of defects.
 *
 * @since 2.0.0
 * @category Mapping
 */
const mapErrorCause = core_effect/* mapErrorCause */.$p;
/**
 * Combines both success and error channels of an effect into a single outcome.
 *
 * **Details**
 *
 * This function transforms an effect that may fail into one that always returns
 * a value, where both success and failure outcomes are handled as values in the
 * success channel.
 *
 * **When to Use**
 *
 * This can be useful when you want to continue execution regardless of the
 * error type and still capture both successful results and errors as part of
 * the outcome.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * //      ┌─── Effect<number, string, never>
 * //      ▼
 * const program = Effect.fail("Oh uh!").pipe(Effect.as(2))
 *
 * //      ┌─── Effect<number | string, never, never>
 * //      ▼
 * const recovered = Effect.merge(program)
 * ```
 *
 * @since 2.0.0
 * @category Mapping
 */
const merge = core_effect/* merge */.TS;
/**
 * Returns a new effect with the boolean value of this effect negated.
 *
 * @since 2.0.0
 * @category Mapping
 */
const negate = core_effect/* negate */.tk;
/**
 * Creates a scoped resource using an `acquire` and `release` effect.
 *
 * **Details**
 *
 * This function helps manage resources by combining two `Effect` values: one
 * for acquiring the resource and one for releasing it.
 *
 * `acquireRelease` does the following:
 *
 *   1. Ensures that the effect that acquires the resource will not be
 *      interrupted. Note that acquisition may still fail due to internal
 *      reasons (such as an uncaught exception).
 *   2. Ensures that the `release` effect will not be interrupted, and will be
 *      executed as long as the acquisition effect successfully acquires the
 *      resource.
 *
 * If the `acquire` function succeeds, the `release` function is added to the
 * list of finalizers for the scope. This ensures that the release will happen
 * automatically when the scope is closed.
 *
 * Both `acquire` and `release` run uninterruptibly, meaning they cannot be
 * interrupted while they are executing.
 *
 * Additionally, the `release` function can be influenced by the exit value when
 * the scope closes, allowing for custom handling of how the resource is
 * released based on the execution outcome.
 *
 * **When to Use**
 *
 * This function is used to ensure that an effect that represents the
 * acquisition of a resource (for example, opening a file, launching a thread,
 * etc.) will not be interrupted, and that the resource will always be released
 * when the `Effect` completes execution.
 *
 * **Example** (Defining a Simple Resource)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * // Define an interface for a resource
 * interface MyResource {
 *   readonly contents: string
 *   readonly close: () => Promise<void>
 * }
 *
 * // Simulate resource acquisition
 * const getMyResource = (): Promise<MyResource> =>
 *   Promise.resolve({
 *     contents: "lorem ipsum",
 *     close: () =>
 *       new Promise((resolve) => {
 *         console.log("Resource released")
 *         resolve()
 *       })
 *   })
 *
 * // Define how the resource is acquired
 * const acquire = Effect.tryPromise({
 *   try: () =>
 *     getMyResource().then((res) => {
 *       console.log("Resource acquired")
 *       return res
 *     }),
 *   catch: () => new Error("getMyResourceError")
 * })
 *
 * // Define how the resource is released
 * const release = (res: MyResource) => Effect.promise(() => res.close())
 *
 * // Create the resource management workflow
 * //
 * //      ┌─── Effect<MyResource, Error, Scope>
 * //      ▼
 * const resource = Effect.acquireRelease(acquire, release)
 * ```
 *
 * @see {@link acquireUseRelease} for a version that automatically handles the scoping of resources.
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const acquireRelease = internal_fiberRuntime/* acquireRelease */.S8;
/**
 * Creates a scoped resource with an interruptible acquire action.
 *
 * **Details**
 *
 * This function is similar to {@link acquireRelease}, but it allows the
 * acquisition of the resource to be interrupted. The `acquire` effect, which
 * represents the process of obtaining the resource, can be interrupted if
 * necessary.
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const acquireReleaseInterruptible = internal_fiberRuntime/* acquireReleaseInterruptible */.Ro;
/**
 * Many real-world operations involve working with resources that must be released when no longer needed, such as:
 *
 * - Database connections
 * - File handles
 * - Network requests
 *
 * This function ensures that a resource is:
 *
 * 1. **Acquired** properly.
 * 2. **Used** for its intended purpose.
 * 3. **Released** even if an error occurs.
 *
 * **Example** (Automatically Managing Resource Lifetime)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * // Define an interface for a resource
 * interface MyResource {
 *   readonly contents: string
 *   readonly close: () => Promise<void>
 * }
 *
 * // Simulate resource acquisition
 * const getMyResource = (): Promise<MyResource> =>
 *   Promise.resolve({
 *     contents: "lorem ipsum",
 *     close: () =>
 *       new Promise((resolve) => {
 *         console.log("Resource released")
 *         resolve()
 *       })
 *   })
 *
 * // Define how the resource is acquired
 * const acquire = Effect.tryPromise({
 *   try: () =>
 *     getMyResource().then((res) => {
 *       console.log("Resource acquired")
 *       return res
 *     }),
 *   catch: () => new Error("getMyResourceError")
 * })
 *
 * // Define how the resource is released
 * const release = (res: MyResource) => Effect.promise(() => res.close())
 *
 * const use = (res: MyResource) => Console.log(`content is ${res.contents}`)
 *
 * //      ┌─── Effect<void, Error, never>
 * //      ▼
 * const program = Effect.acquireUseRelease(acquire, use, release)
 *
 * Effect.runPromise(program)
 * // Output:
 * // Resource acquired
 * // content is lorem ipsum
 * // Resource released
 * ```
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const acquireUseRelease = internal_core/* acquireUseRelease */.ni3;
/**
 * Ensures a finalizer is added to the scope of the calling effect, guaranteeing
 * it runs when the scope is closed.
 *
 * **Details**
 *
 * This function adds a finalizer that will execute whenever the scope of the
 * effect is closed, regardless of whether the effect succeeds, fails, or is
 * interrupted. The finalizer receives the `Exit` value of the effect's scope,
 * allowing it to react differently depending on how the effect concludes.
 *
 * Finalizers are a reliable way to manage resource cleanup, ensuring that
 * resources such as file handles, network connections, or database transactions
 * are properly closed even in the event of an unexpected interruption or error.
 *
 * Finalizers operate in conjunction with Effect's scoped resources. If an
 * effect with a finalizer is wrapped in a scope, the finalizer will execute
 * automatically when the scope ends.
 *
 * **Example** (Adding a Finalizer on Success)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * //      ┌─── Effect<string, never, Scope>
 * //      ▼
 * const program = Effect.gen(function* () {
 *   yield* Effect.addFinalizer((exit) =>
 *     Console.log(`Finalizer executed. Exit status: ${exit._tag}`)
 *   )
 *   return "some result"
 * })
 *
 * // Wrapping the effect in a scope
 * //
 * //      ┌─── Effect<string, never, never>
 * //      ▼
 * const runnable = Effect.scoped(program)
 *
 * Effect.runPromiseExit(runnable).then(console.log)
 * // Output:
 * // Finalizer executed. Exit status: Success
 * // { _id: 'Exit', _tag: 'Success', value: 'some result' }
 * ```
 *
 * **Example** (Adding a Finalizer on Failure)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * //      ┌─── Effect<never, string, Scope>
 * //      ▼
 * const program = Effect.gen(function* () {
 *   yield* Effect.addFinalizer((exit) =>
 *     Console.log(`Finalizer executed. Exit status: ${exit._tag}`)
 *   )
 *   return yield* Effect.fail("Uh oh!")
 * })
 *
 * // Wrapping the effect in a scope
 * //
 * //      ┌─── Effect<never, string, never>
 * //      ▼
 * const runnable = Effect.scoped(program)
 *
 * Effect.runPromiseExit(runnable).then(console.log)
 * // Output:
 * // Finalizer executed. Exit status: Failure
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: { _id: 'Cause', _tag: 'Fail', failure: 'Uh oh!' }
 * // }
 * ```
 *
 * **Example** (Adding a Finalizer on Interruption)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * //      ┌─── Effect<never, never, Scope>
 * //      ▼
 * const program = Effect.gen(function* () {
 *   yield* Effect.addFinalizer((exit) =>
 *     Console.log(`Finalizer executed. Exit status: ${exit._tag}`)
 *   )
 *   return yield* Effect.interrupt
 * })
 *
 * // Wrapping the effect in a scope
 * //
 * //      ┌─── Effect<never, never, never>
 * //      ▼
 * const runnable = Effect.scoped(program)
 *
 * Effect.runPromiseExit(runnable).then(console.log)
 * // Output:
 * // Finalizer executed. Exit status: Failure
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: {
 * //     _id: 'Cause',
 * //     _tag: 'Interrupt',
 * //     fiberId: {
 * //       _id: 'FiberId',
 * //       _tag: 'Runtime',
 * //       id: 0,
 * //       startTimeMillis: ...
 * //     }
 * //   }
 * // }
 * ```
 *
 * @see {@link onExit} for attaching a finalizer directly to an effect.
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const addFinalizer = internal_fiberRuntime/* addFinalizer */.yR;
/**
 * Guarantees the execution of a finalizer when an effect starts execution.
 *
 * **Details**
 *
 * This function allows you to specify a `finalizer` effect that will always be
 * run once the effect starts execution, regardless of whether the effect
 * succeeds, fails, or is interrupted.
 *
 * **When to Use**
 *
 * This is useful when you need to ensure that certain cleanup or final steps
 * are executed in all cases, such as releasing resources or performing
 * necessary logging.
 *
 * While this function provides strong guarantees about executing the finalizer,
 * it is considered a low-level tool, which may not be ideal for more complex
 * resource management. For higher-level resource management with automatic
 * acquisition and release, see the {@link acquireRelease} family of functions.
 * For use cases where you need access to the result of an effect, consider
 * using {@link onExit}.
 *
 * **Example** (Running a Finalizer in All Outcomes)
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * // Define a cleanup effect
 * const handler = Effect.ensuring(Console.log("Cleanup completed"))
 *
 * // Define a successful effect
 * const success = Console.log("Task completed").pipe(
 *   Effect.as("some result"),
 *   handler
 * )
 *
 * Effect.runFork(success)
 * // Output:
 * // Task completed
 * // Cleanup completed
 *
 * // Define a failing effect
 * const failure = Console.log("Task failed").pipe(
 *   Effect.andThen(Effect.fail("some error")),
 *   handler
 * )
 *
 * Effect.runFork(failure)
 * // Output:
 * // Task failed
 * // Cleanup completed
 *
 * // Define an interrupted effect
 * const interruption = Console.log("Task interrupted").pipe(
 *   Effect.andThen(Effect.interrupt),
 *   handler
 * )
 *
 * Effect.runFork(interruption)
 * // Output:
 * // Task interrupted
 * // Cleanup completed
 * ```
 *
 * @see {@link onExit} for a version that provides access to the result of an
 * effect.
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const ensuring = internal_fiberRuntime/* ensuring */.IH;
/**
 * Ensures a cleanup effect runs whenever the calling effect fails, providing
 * the failure cause to the cleanup effect.
 *
 * **Details**
 *
 * This function allows you to attach a cleanup effect that runs whenever the
 * calling effect fails. The cleanup effect receives the cause of the failure,
 * allowing you to perform actions such as logging, releasing resources, or
 * executing additional recovery logic based on the error. The cleanup effect
 * will execute even if the failure is due to interruption.
 *
 * Importantly, the cleanup effect itself is uninterruptible, ensuring that it
 * completes regardless of external interruptions.
 *
 * **Example** (Running Cleanup Only on Failure)
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * // This handler logs the failure cause when the effect fails
 * const handler = Effect.onError((cause) =>
 *   Console.log(`Cleanup completed: ${cause}`)
 * )
 *
 * // Define a successful effect
 * const success = Console.log("Task completed").pipe(
 *   Effect.as("some result"),
 *   handler
 * )
 *
 * Effect.runFork(success)
 * // Output:
 * // Task completed
 *
 * // Define a failing effect
 * const failure = Console.log("Task failed").pipe(
 *   Effect.andThen(Effect.fail("some error")),
 *   handler
 * )
 *
 * Effect.runFork(failure)
 * // Output:
 * // Task failed
 * // Cleanup completed: Error: some error
 *
 * // Define a failing effect
 * const defect = Console.log("Task failed with defect").pipe(
 *   Effect.andThen(Effect.die("Boom!")),
 *   handler
 * )
 *
 * Effect.runFork(defect)
 * // Output:
 * // Task failed with defect
 * // Cleanup completed: Error: Boom!
 *
 * // Define an interrupted effect
 * const interruption = Console.log("Task interrupted").pipe(
 *   Effect.andThen(Effect.interrupt),
 *   handler
 * )
 *
 * Effect.runFork(interruption)
 * // Output:
 * // Task interrupted
 * // Cleanup completed: All fibers interrupted without errors.
 * ```
 *
 * @see {@link ensuring} for attaching a cleanup effect that runs on both success and failure.
 * @see {@link onExit} for attaching a cleanup effect that runs on all possible exits.
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const onError = internal_core/* onError */.qQ3;
/**
 * Guarantees that a cleanup function runs regardless of whether the effect
 * succeeds, fails, or is interrupted.
 *
 * **Details**
 *
 * This function ensures that a provided cleanup function is executed after the
 * effect completes, regardless of the outcome. The cleanup function is given
 * the `Exit` value of the effect, which provides detailed information about the
 * result:
 * - If the effect succeeds, the `Exit` contains the success value.
 * - If the effect fails, the `Exit` contains the error or failure cause.
 * - If the effect is interrupted, the `Exit` reflects the interruption.
 *
 * The cleanup function is guaranteed to run uninterruptibly, ensuring reliable
 * resource management even in complex or high-concurrency scenarios.
 *
 * **Example** (Running a Cleanup Function with the Effect’s Result)
 *
 * ```ts
 * import { Console, Effect, Exit } from "effect"
 *
 * // Define a cleanup effect that logs the result
 * const handler = Effect.onExit((exit) =>
 *   Console.log(`Cleanup completed: ${Exit.getOrElse(exit, String)}`)
 * )
 *
 * // Define a successful effect
 * const success = Console.log("Task completed").pipe(
 *   Effect.as("some result"),
 *   handler
 * )
 *
 * Effect.runFork(success)
 * // Output:
 * // Task completed
 * // Cleanup completed: some result
 *
 * // Define a failing effect
 * const failure = Console.log("Task failed").pipe(
 *   Effect.andThen(Effect.fail("some error")),
 *   handler
 * )
 *
 * Effect.runFork(failure)
 * // Output:
 * // Task failed
 * // Cleanup completed: Error: some error
 *
 * // Define an interrupted effect
 * const interruption = Console.log("Task interrupted").pipe(
 *   Effect.andThen(Effect.interrupt),
 *   handler
 * )
 *
 * Effect.runFork(interruption)
 * // Output:
 * // Task interrupted
 * // Cleanup completed: All fibers interrupted without errors.
 * ```
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const onExit = internal_core/* onExit */.dsk;
/**
 * Ensures that finalizers are run concurrently when the scope of an effect is
 * closed.
 *
 * **Details**
 *
 * This function modifies the behavior of finalizers within a scoped workflow to
 * allow them to run concurrently when the scope is closed.
 *
 * By default, finalizers are executed sequentially in reverse order of their
 * addition, but this function changes that behavior to execute all finalizers
 * concurrently.
 *
 * **When to Use**
 *
 * Running finalizers concurrently can improve performance when multiple
 * independent cleanup tasks need to be performed. However, it requires that
 * these tasks do not depend on the order of execution or introduce race
 * conditions.
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * // Define a program that adds multiple finalizers
 * const program = Effect.gen(function*() {
 *   yield* Effect.addFinalizer(() => Console.log("Finalizer 1 executed").pipe(Effect.delay("300 millis")))
 *   yield* Effect.addFinalizer(() => Console.log("Finalizer 2 executed").pipe(Effect.delay("100 millis")))
 *   yield* Effect.addFinalizer(() => Console.log("Finalizer 3 executed").pipe(Effect.delay("200 millis")))
 *   return "some result"
 * })
 *
 * // Modify the program to ensure finalizers run in parallel
 * const modified = program.pipe(Effect.parallelFinalizers)
 *
 * const runnable = Effect.scoped(modified)
 *
 * Effect.runFork(runnable)
 * // Output:
 * // Finalizer 2 executed
 * // Finalizer 3 executed
 * // Finalizer 1 executed
 * ```
 *
 * @see {@link sequentialFinalizers} for a version that ensures finalizers are run sequentially.
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const parallelFinalizers = internal_fiberRuntime/* parallelFinalizers */.BE;
/**
 * Ensures that finalizers are run sequentially in reverse order of their
 * addition.
 *
 * **Details**
 *
 * This function modifies the behavior of finalizers within a scoped workflow to
 * ensure they are run sequentially in reverse order when the scope is closed.
 *
 * By default, finalizers are executed sequentially, so this only changes the
 * behavior if the scope is configured to run finalizers concurrently.
 *
 * @see {@link parallelFinalizers} for a version that ensures finalizers are run concurrently.
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const sequentialFinalizers = internal_fiberRuntime/* sequentialFinalizers */.r;
/**
 * Applies a custom execution strategy to finalizers within a scoped workflow.
 *
 * **Details**
 *
 * This function allows you to control how finalizers are executed in a scope by
 * applying a specified `ExecutionStrategy`. The `strategy` can dictate whether
 * finalizers run (e.g., sequentially or in parallel).
 *
 * Additionally, the function provides a `restore` operation, which ensures that
 * the effect passed to it is executed under the default execution strategy.
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const finalizersMask = internal_fiberRuntime/* finalizersMask */.qm;
/**
 * Provides access to the current scope in a scoped workflow.
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const scope = internal_fiberRuntime/* scope */.eI;
/**
 * Accesses the current scope and uses it to perform the specified effect.
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const scopeWith = internal_fiberRuntime/* scopeWith */.ZO;
/**
 * Creates a `Scope`, passes it to the specified effectful function, and closes
 * the scope when the effect completes (whether through success, failure, or
 * interruption).
 *
 * @since 3.11.0
 * @category Scoping, Resources & Finalization
 */
const scopedWith = internal_fiberRuntime/* scopedWith */.HK;
/**
 * Scopes all resources used in an effect to the lifetime of the effect.
 *
 * **Details**
 *
 * This function ensures that all resources used within an effect are tied to
 * its lifetime. Finalizers for these resources are executed automatically when
 * the effect completes, whether through success, failure, or interruption. This
 * guarantees proper resource cleanup without requiring explicit management.
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const scoped = internal_fiberRuntime/* scopedEffect */.N1;
/**
 * Scopes all resources acquired by one effect to the lifetime of another
 * effect.
 *
 * **Details**
 *
 * This function allows you to scope the resources acquired by one effect
 * (`self`) to the lifetime of another effect (`use`). This ensures that the
 * resources are cleaned up as soon as the `use` effect completes, regardless of
 * how the `use` effect ends (success, failure, or interruption).
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * const acquire = Console.log("Acquiring resource").pipe(
 *   Effect.as(1),
 *   Effect.tap(Effect.addFinalizer(() => Console.log("Releasing resource")))
 * )
 * const use = (resource: number) => Console.log(`Using resource: ${resource}`)
 *
 * const program = acquire.pipe(Effect.using(use))
 *
 * Effect.runFork(program)
 * // Output:
 * // Acquiring resource
 * // Using resource: 1
 * // Releasing resource
 * ```
 *
 * @see {@link scopedWith} Manage scoped operations with a temporary scope.
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const using = internal_fiberRuntime/* using */.gW;
/**
 * Returns the result of the effect and a finalizer to close its scope.
 *
 * **Details**
 *
 * This function allows you to retrieve both the result of an effect and a
 * finalizer that can be used to manually close its scope. This is useful for
 * workflows where you need early access to the result while retaining control
 * over the resource cleanup process.
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * const acquire = Console.log("Acquiring resource").pipe(
 *   Effect.as(1),
 *   Effect.tap(Effect.addFinalizer(() => Console.log("Releasing resource")))
 * )
 * const program = Effect.gen(function*() {
 *   const [finalizer, resource] = yield* Effect.withEarlyRelease(acquire)
 *   console.log(`Using resource: ${resource}`)
 *   yield* Effect.sleep("1 second")
 *   yield* finalizer
 * })
 *
 * Effect.runFork(program.pipe(Effect.scoped))
 * // Output:
 * // Acquiring resource
 * // Using resource: 1
 * // Releasing resource
 * ```
 *
 * @since 2.0.0
 * @category Scoping, Resources & Finalization
 */
const withEarlyRelease = internal_fiberRuntime/* withEarlyRelease */.KC;
/**
 * Returns a new effect that will not succeed with its value before first
 * waiting for the end of all child fibers forked by the effect.
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const awaitAllChildren = circular/* awaitAllChildren */.NZ;
/**
 * Returns a new workflow that will not supervise any fibers forked by this
 * workflow.
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const daemonChildren = internal_fiberRuntime/* daemonChildren */.qi;
/**
 * Constructs an effect with information about the current `Fiber`.
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const descriptor = core_effect/* descriptor */.qI;
/**
 * Constructs an effect based on information about the current `Fiber`.
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const descriptorWith = core_effect/* descriptorWith */.vG;
/**
 * Returns a new workflow that executes this one and captures the changes in
 * `FiberRef` values.
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const diffFiberRefs = core_effect/* diffFiberRefs */.gT;
/**
 * Acts on the children of this fiber (collected into a single fiber),
 * guaranteeing the specified callback will be invoked, whether or not this
 * effect succeeds.
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const ensuringChild = circular/* ensuringChild */.a7;
/**
 * Acts on the children of this fiber, guaranteeing the specified callback
 * will be invoked, whether or not this effect succeeds.
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const ensuringChildren = circular/* ensuringChildren */.Ij;
/**
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const Effect_fiberId = internal_core/* fiberId */.ezx;
/**
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const fiberIdWith = internal_core/* fiberIdWith */.mrY;
/**
 * Creates a new fiber to run an effect concurrently.
 *
 * **Details**
 *
 * This function takes an effect and forks it into a separate fiber, allowing it
 * to run concurrently without blocking the original effect. The new fiber
 * starts execution immediately after being created, and the fiber object is
 * returned immediately without waiting for the effect to begin. This is useful
 * when you want to run tasks concurrently while continuing other tasks in the
 * parent fiber.
 *
 * The forked fiber is attached to the parent fiber's scope. This means that
 * when the parent fiber terminates, the child fiber will also be terminated
 * automatically. This feature, known as "auto supervision," ensures that no
 * fibers are left running unintentionally. If you prefer not to have this auto
 * supervision behavior, you can use {@link forkDaemon} or {@link forkIn}.
 *
 * **When to Use**
 *
 * Use this function when you need to run an effect concurrently without
 * blocking the current execution flow. For example, you might use it to launch
 * background tasks or concurrent computations. However, working with fibers can
 * be complex, so before using this function directly, you might want to explore
 * higher-level functions like {@link raceWith}, {@link zip}, or others that can
 * manage concurrency for you.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const fib = (n: number): Effect.Effect<number> =>
 *   n < 2
 *     ? Effect.succeed(n)
 *     : Effect.zipWith(fib(n - 1), fib(n - 2), (a, b) => a + b)
 *
 * //      ┌─── Effect<RuntimeFiber<number, never>, never, never>
 * //      ▼
 * const fib10Fiber = Effect.fork(fib(10))
 * ```
 *
 * @see {@link forkWithErrorHandler} for a version that allows you to handle errors.
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const fork = internal_fiberRuntime/* fork */.rM;
/**
 * Creates a long-running background fiber that is independent of its parent.
 *
 * **Details**
 *
 * This function creates a "daemon" fiber that runs in the background and is not
 * tied to the lifecycle of its parent fiber. Unlike normal fibers that stop
 * when the parent fiber terminates, a daemon fiber will continue running until
 * the global scope closes or the fiber completes naturally. This makes it
 * useful for tasks that need to run in the background independently, such as
 * periodic logging, monitoring, or background data processing.
 *
 * **Example** (Creating a Daemon Fiber)
 *
 * ```ts
 * import { Effect, Console, Schedule } from "effect"
 *
 * // Daemon fiber that logs a message repeatedly every second
 * const daemon = Effect.repeat(
 *   Console.log("daemon: still running!"),
 *   Schedule.fixed("1 second")
 * )
 *
 * const parent = Effect.gen(function* () {
 *   console.log("parent: started!")
 *   // Daemon fiber running independently
 *   yield* Effect.forkDaemon(daemon)
 *   yield* Effect.sleep("3 seconds")
 *   console.log("parent: finished!")
 * })
 *
 * Effect.runFork(parent)
 * // Output:
 * // parent: started!
 * // daemon: still running!
 * // daemon: still running!
 * // daemon: still running!
 * // parent: finished!
 * // daemon: still running!
 * // daemon: still running!
 * // daemon: still running!
 * // daemon: still running!
 * // daemon: still running!
 * // ...etc...
 * ```
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const forkDaemon = internal_fiberRuntime/* forkDaemon */.Zp;
/**
 * Returns an effect that forks all of the specified values, and returns a
 * composite fiber that produces a list of their results, in order.
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const forkAll = circular/* forkAll */.Xe;
/**
 * Forks an effect in a specific scope, allowing finer control over its
 * execution.
 *
 * **Details**
 *
 * There are some cases where we need more fine-grained control, so we want to
 * fork a fiber in a specific scope. We can use the `Effect.forkIn` operator
 * which takes the target scope as an argument.
 *
 * The fiber will be interrupted when the scope is closed.
 *
 * **Example** (Forking a Fiber in a Specific Scope)
 *
 * In this example, the child fiber is forked into the outerScope,
 * allowing it to outlive the inner scope but still be terminated
 * when the outerScope is closed.
 *
 * ```ts
 * import { Console, Effect, Schedule } from "effect"
 *
 * // Child fiber that logs a message repeatedly every second
 * const child = Effect.repeat(
 *   Console.log("child: still running!"),
 *   Schedule.fixed("1 second")
 * )
 *
 * const program = Effect.scoped(
 *   Effect.gen(function* () {
 *     yield* Effect.addFinalizer(() =>
 *       Console.log("The outer scope is about to be closed!")
 *     )
 *
 *     // Capture the outer scope
 *     const outerScope = yield* Effect.scope
 *
 *     // Create an inner scope
 *     yield* Effect.scoped(
 *       Effect.gen(function* () {
 *         yield* Effect.addFinalizer(() =>
 *           Console.log("The inner scope is about to be closed!")
 *         )
 *         // Fork the child fiber in the outer scope
 *         yield* Effect.forkIn(child, outerScope)
 *         yield* Effect.sleep("3 seconds")
 *       })
 *     )
 *
 *     yield* Effect.sleep("5 seconds")
 *   })
 * )
 *
 * Effect.runFork(program)
 * // Output:
 * // child: still running!
 * // child: still running!
 * // child: still running!
 * // The inner scope is about to be closed!
 * // child: still running!
 * // child: still running!
 * // child: still running!
 * // child: still running!
 * // child: still running!
 * // child: still running!
 * // The outer scope is about to be closed!
 * ```
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const forkIn = circular/* forkIn */.Bo;
/**
 * Forks a fiber in a local scope, ensuring it outlives its parent.
 *
 * **Details**
 *
 * This function is used to create fibers that are tied to a local scope,
 * meaning they are not dependent on their parent fiber's lifecycle. Instead,
 * they will continue running until the scope they were created in is closed.
 * This is particularly useful when you need a fiber to run independently of the
 * parent fiber, but still want it to be terminated when the scope ends.
 *
 * Fibers created with this function are isolated from the parent fiber’s
 * termination, so they can run for a longer period. This behavior is different
 * from fibers created with {@link fork}, which are terminated when the parent fiber
 * terminates. With `forkScoped`, the child fiber will keep running until the
 * local scope ends, regardless of the state of the parent fiber.
 *
 * **Example** (Forking a Fiber in a Local Scope)
 *
 * In this example, the child fiber continues to run beyond the lifetime of the parent fiber.
 * The child fiber is tied to the local scope and will be terminated only when the scope ends.
 *
 * ```ts
 * import { Effect, Console, Schedule } from "effect"
 *
 * // Child fiber that logs a message repeatedly every second
 * const child = Effect.repeat(
 *   Console.log("child: still running!"),
 *   Schedule.fixed("1 second")
 * )
 *
 * //      ┌─── Effect<void, never, Scope>
 * //      ▼
 * const parent = Effect.gen(function* () {
 *   console.log("parent: started!")
 *   // Child fiber attached to local scope
 *   yield* Effect.forkScoped(child)
 *   yield* Effect.sleep("3 seconds")
 *   console.log("parent: finished!")
 * })
 *
 * // Program runs within a local scope
 * const program = Effect.scoped(
 *   Effect.gen(function* () {
 *     console.log("Local scope started!")
 *     yield* Effect.fork(parent)
 *     // Scope lasts for 5 seconds
 *     yield* Effect.sleep("5 seconds")
 *     console.log("Leaving the local scope!")
 *   })
 * )
 *
 * Effect.runFork(program)
 * // Output:
 * // Local scope started!
 * // parent: started!
 * // child: still running!
 * // child: still running!
 * // child: still running!
 * // parent: finished!
 * // child: still running!
 * // child: still running!
 * // Leaving the local scope!
 * ```
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const forkScoped = circular/* forkScoped */.CL;
/**
 * Like {@link fork} but handles an error with the provided handler.
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const forkWithErrorHandler = internal_fiberRuntime/* forkWithErrorHandler */.lg;
/**
 * Creates an `Effect` value that represents the exit value of the specified
 * fiber.
 *
 * @see {@link fromFiberEffect} for creating an effect from a fiber obtained from an effect.
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const fromFiber = circular/* fromFiber */.yE;
/**
 * Creates an `Effect` value that represents the exit value of a fiber obtained
 * from an effect.
 *
 * @see {@link fromFiber} for creating an effect from a fiber.
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const fromFiberEffect = circular/* fromFiberEffect */.ql;
/**
 * Supervises child fibers by reporting them to a specified supervisor.
 *
 * **Details**
 *
 * This function takes a supervisor as an argument and returns an effect where
 * all child fibers forked within it are supervised by the provided supervisor.
 * This enables you to capture detailed information about these child fibers,
 * such as their status, through the supervisor.
 *
 * **Example** (Monitoring Fiber Count)
 *
 * ```ts
 * import { Effect, Supervisor, Schedule, Fiber, FiberStatus } from "effect"
 *
 * // Main program that monitors fibers while calculating a Fibonacci number
 * const program = Effect.gen(function* () {
 *   // Create a supervisor to track child fibers
 *   const supervisor = yield* Supervisor.track
 *
 *   // Start a Fibonacci calculation, supervised by the supervisor
 *   const fibFiber = yield* fib(20).pipe(
 *     Effect.supervised(supervisor),
 *     // Fork the Fibonacci effect into a fiber
 *     Effect.fork
 *   )
 *
 *   // Define a schedule to periodically monitor the fiber count every 500ms
 *   const policy = Schedule.spaced("500 millis").pipe(
 *     Schedule.whileInputEffect((_) =>
 *       Fiber.status(fibFiber).pipe(
 *         // Continue while the Fibonacci fiber is not done
 *         Effect.andThen((status) => status !== FiberStatus.done)
 *       )
 *     )
 *   )
 *
 *   // Start monitoring the fibers, using the supervisor to track the count
 *   const monitorFiber = yield* monitorFibers(supervisor).pipe(
 *     // Repeat the monitoring according to the schedule
 *     Effect.repeat(policy),
 *     // Fork the monitoring into its own fiber
 *     Effect.fork
 *   )
 *
 *   // Join the monitor and Fibonacci fibers to ensure they complete
 *   yield* Fiber.join(monitorFiber)
 *   const result = yield* Fiber.join(fibFiber)
 *
 *   console.log(`fibonacci result: ${result}`)
 * })
 *
 * // Function to monitor and log the number of active fibers
 * const monitorFibers = (
 *   supervisor: Supervisor.Supervisor<Array<Fiber.RuntimeFiber<any, any>>>
 * ): Effect.Effect<void> =>
 *   Effect.gen(function* () {
 *     const fibers = yield* supervisor.value // Get the current set of fibers
 *     console.log(`number of fibers: ${fibers.length}`)
 *   })
 *
 * // Recursive Fibonacci calculation, spawning fibers for each recursive step
 * const fib = (n: number): Effect.Effect<number> =>
 *   Effect.gen(function* () {
 *     if (n <= 1) {
 *       return 1
 *     }
 *     yield* Effect.sleep("500 millis") // Simulate work by delaying
 *
 *     // Fork two fibers for the recursive Fibonacci calls
 *     const fiber1 = yield* Effect.fork(fib(n - 2))
 *     const fiber2 = yield* Effect.fork(fib(n - 1))
 *
 *     // Join the fibers to retrieve their results
 *     const v1 = yield* Fiber.join(fiber1)
 *     const v2 = yield* Fiber.join(fiber2)
 *
 *     return v1 + v2 // Combine the results
 *   })
 *
 * Effect.runPromise(program)
 * // Output:
 * // number of fibers: 0
 * // number of fibers: 2
 * // number of fibers: 6
 * // number of fibers: 14
 * // number of fibers: 30
 * // number of fibers: 62
 * // number of fibers: 126
 * // number of fibers: 254
 * // number of fibers: 510
 * // number of fibers: 1022
 * // number of fibers: 2034
 * // number of fibers: 3795
 * // number of fibers: 5810
 * // number of fibers: 6474
 * // number of fibers: 4942
 * // number of fibers: 2515
 * // number of fibers: 832
 * // number of fibers: 170
 * // number of fibers: 18
 * // number of fibers: 0
 * // fibonacci result: 10946
 * ```
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const supervised = circular/* supervised */.Lj;
/**
 * Transplants specified effects so that when those effects fork other
 * effects, the forked effects will be governed by the scope of the fiber that
 * executes this effect.
 *
 * This can be used to "graft" deep grandchildren onto a higher-level scope,
 * effectively extending their lifespans into the parent scope.
 *
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const transplant = internal_core/* transplant */.Yxn;
/**
 * @since 2.0.0
 * @category Supervision & Fibers
 */
const withConcurrency = internal_core/* withConcurrency */.l9G;
/**
 * Sets the provided scheduler for usage in the wrapped effect
 *
 * @since 2.0.0
 * @category Scheduler
 */
const withScheduler = Scheduler/* withScheduler */.ez;
/**
 * Sets the scheduling priority used when yielding
 *
 * @since 2.0.0
 * @category Scheduler
 */
const withSchedulingPriority = internal_core/* withSchedulingPriority */.uqd;
/**
 * Sets the maximum number of operations before yield by the default schedulers
 *
 * @since 2.0.0
 * @category Scheduler
 */
const withMaxOpsBeforeYield = internal_core/* withMaxOpsBeforeYield */.U76;
/**
 * Retrieves the `Clock` service from the context.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const program = Effect.gen(function*() {
 *   const clock = yield* Effect.clock
 *   const currentTime = yield* clock.currentTimeMillis
 *   console.log(`Current time in milliseconds: ${currentTime}`)
 * })
 *
 * Effect.runFork(program)
 * // Example Output:
 * // Current time in milliseconds: 1735484796134
 * ```
 *
 * @since 2.0.0
 * @category Clock
 */
const clock = core_effect/* clock */.mC;
/**
 * Retrieves the `Clock` service from the context and provides it to the
 * specified effectful function.
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * const program = Effect.clockWith((clock) =>
 *   clock.currentTimeMillis.pipe(
 *     Effect.map((currentTime) => `Current time is: ${currentTime}`),
 *     Effect.tap(Console.log)
 *   )
 * )
 *
 * Effect.runFork(program)
 * // Example Output:
 * // Current time is: 1735484929744
 * ```
 *
 * @since 2.0.0
 * @category Clock
 */
const clockWith = core_effect/* clockWith */.UA;
/**
 * Sets the implementation of the `Clock` service to the specified value and
 * restores it to its original value when the scope is closed.
 *
 * @since 2.0.0
 * @category Clock
 */
const withClockScoped = internal_fiberRuntime/* withClockScoped */.Zx;
/**
 * Executes the specified workflow with the specified implementation of the
 * `Clock` service.
 *
 * @since 2.0.0
 * @category Clock
 */
const withClock = internal_defaultServices/* withClock */.rZ;
/**
 * Retreives the `Console` service from the context
 *
 * @since 2.0.0
 * @category Console
 */
const Effect_console = console;
/**
 * Retreives the `Console` service from the context and provides it to the
 * specified effectful function.
 *
 * @since 2.0.0
 * @category Console
 */
const Effect_consoleWith = consoleWith;
/**
 * Sets the implementation of the console service to the specified value and
 * restores it to its original value when the scope is closed.
 *
 * @since 2.0.0
 * @category Creating Effects
 */
const Effect_withConsoleScoped = withConsoleScoped;
/**
 * Executes the specified workflow with the specified implementation of the
 * console service.
 *
 * @since 2.0.0
 * @category Console
 */
const Effect_withConsole = withConsole;
/**
 * Delays the execution of an effect by a specified `Duration`.
 *
 * **Details
 *
 * This function postpones the execution of the provided effect by the specified
 * duration. The duration can be provided in various formats supported by the
 * `Duration` module.
 *
 * Internally, this function does not block the thread; instead, it uses an
 * efficient, non-blocking mechanism to introduce the delay.
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * const task = Console.log("Task executed")
 *
 * const program = Console.log("start").pipe(
 *   Effect.andThen(
 *     // Delays the log message by 2 seconds
 *     task.pipe(Effect.delay("2 seconds"))
 *   )
 * )
 *
 * Effect.runFork(program)
 * // Output:
 * // start
 * // Task executed
 * ```
 *
 * @since 2.0.0
 * @category Delays & Timeouts
 */
const delay = core_effect/* delay */.gw;
/**
 * Suspends the execution of an effect for a specified `Duration`.
 *
 * **Details**
 *
 * This function pauses the execution of an effect for a given duration. It is
 * asynchronous, meaning that it does not block the fiber executing the effect.
 * Instead, the fiber is suspended during the delay period and can resume once
 * the specified time has passed.
 *
 * The duration can be specified using various formats supported by the
 * `Duration` module, such as a string (`"2 seconds"`) or numeric value
 * representing milliseconds.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const program = Effect.gen(function*() {
 *   console.log("Starting task...")
 *   yield* Effect.sleep("3 seconds") // Waits for 3 seconds
 *   console.log("Task completed!")
 * })
 *
 * Effect.runFork(program)
 * // Output:
 * // Starting task...
 * // Task completed!
 * ```
 *
 * @since 2.0.0
 * @category Delays & Timeouts
 */
const sleep = core_effect/* sleep */._v;
/**
 * Executes an effect and measures the time it takes to complete.
 *
 * **Details**
 *
 * This function wraps the provided effect and returns a new effect that, when
 * executed, performs the original effect and calculates its execution duration.
 *
 * The result of the new effect includes both the execution time (as a
 * `Duration`) and the original effect's result. This is useful for monitoring
 * performance or gaining insights into the time taken by specific operations.
 *
 * The original effect's behavior (success, failure, or interruption) remains
 * unchanged, and the timing information is provided alongside the result in a
 * tuple.
 *
 * **Example**
 *
 * ```ts
 * import { Duration, Effect } from "effect"
 *
 * const task = Effect.gen(function*() {
 *   yield* Effect.sleep("2 seconds") // Simulates some work
 *   return "some result"
 * })
 *
 * const timedTask = task.pipe(Effect.timed)
 *
 * const program = Effect.gen(function*() {
 *   const [duration, result] = yield* timedTask
 *   console.log(`Task completed in ${Duration.toMillis(duration)} ms with result: ${result}`)
 * })
 *
 * Effect.runFork(program)
 * // Output: Task completed in 2003.749125 ms with result: some result
 * ```
 *
 * @since 2.0.0
 * @category Delays & Timeouts
 */
const timed = core_effect/* timed */.E1;
/**
 * Executes an effect and measures its execution time using a custom clock.
 *
 * **Details**
 *
 * This function extends the functionality of {@link timed} by allowing you to
 * specify a custom clock for measuring the execution duration. The provided
 * effect (`nanoseconds`) represents the clock and should return the current
 * time in nanoseconds. The timing information is computed using this custom
 * clock instead of the default system clock.
 *
 * @since 2.0.0
 * @category Delays & Timeouts
 */
const timedWith = core_effect/* timedWith */.qP;
/**
 * Adds a time limit to an effect, triggering a timeout if the effect exceeds
 * the duration.
 *
 * **Details**
 *
 * This function allows you to enforce a time limit on the execution of an
 * effect. If the effect does not complete within the given duration, it fails
 * with a `TimeoutException`. This is useful for preventing tasks from hanging
 * indefinitely, especially in scenarios where responsiveness or resource limits
 * are critical.
 *
 * The returned effect will either:
 * - Succeed with the original effect's result if it completes within the
 *   specified duration.
 * - Fail with a `TimeoutException` if the time limit is exceeded.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const task = Effect.gen(function* () {
 *   console.log("Start processing...")
 *   yield* Effect.sleep("2 seconds") // Simulates a delay in processing
 *   console.log("Processing complete.")
 *   return "Result"
 * })
 *
 * // Output will show a TimeoutException as the task takes longer
 * // than the specified timeout duration
 * const timedEffect = task.pipe(Effect.timeout("1 second"))
 *
 * Effect.runPromiseExit(timedEffect).then(console.log)
 * // Output:
 * // Start processing...
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: {
 * //     _id: 'Cause',
 * //     _tag: 'Fail',
 * //     failure: { _tag: 'TimeoutException' }
 * //   }
 * // }
 * ```
 *
 * @see {@link timeoutFail} for a version that raises a custom error.
 * @see {@link timeoutFailCause} for a version that raises a custom defect.
 * @see {@link timeoutTo} for a version that allows specifying both success and
 * timeout handlers.
 *
 * @since 2.0.0
 * @category Delays & Timeouts
 */
const timeout = circular/* timeout */.Vs;
/**
 * Gracefully handles timeouts by returning an `Option` that represents either
 * the result or a timeout.
 *
 * **Details**
 *
 * This function wraps the outcome of an effect in an `Option` type. If the
 * effect completes within the specified duration, it returns a `Some`
 * containing the result. If the effect times out, it returns a `None`. Unlike
 * other timeout methods, this approach does not raise errors or exceptions;
 * instead, it allows you to treat timeouts as a regular outcome, simplifying
 * the logic for handling delays.
 *
 * **When to Use**
 *
 * This is useful when you want to handle timeouts without causing the program
 * to fail, making it easier to manage situations where you expect tasks might
 * take too long but want to continue executing other tasks.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const task = Effect.gen(function* () {
 *   console.log("Start processing...")
 *   yield* Effect.sleep("2 seconds") // Simulates a delay in processing
 *   console.log("Processing complete.")
 *   return "Result"
 * })
 *
 * const timedOutEffect = Effect.all([
 *   task.pipe(Effect.timeoutOption("3 seconds")),
 *   task.pipe(Effect.timeoutOption("1 second"))
 * ])
 *
 * Effect.runPromise(timedOutEffect).then(console.log)
 * // Output:
 * // Start processing...
 * // Processing complete.
 * // Start processing...
 * // [
 * //   { _id: 'Option', _tag: 'Some', value: 'Result' },
 * //   { _id: 'Option', _tag: 'None' }
 * // ]
 * ```
 *
 * @see {@link timeout} for a version that raises a `TimeoutException`.
 * @see {@link timeoutFail} for a version that raises a custom error.
 * @see {@link timeoutFailCause} for a version that raises a custom defect.
 * @see {@link timeoutTo} for a version that allows specifying both success and
 * timeout handlers.
 *
 * @since 3.1.0
 * @category Delays & Timeouts
 */
const timeoutOption = circular/* timeoutOption */.ES;
/**
 * Specifies a custom error to be produced when a timeout occurs.
 *
 * **Details**
 *
 * This function allows you to handle timeouts in a customized way by defining a
 * specific error to be raised when an effect exceeds the given duration. Unlike
 * default timeout behaviors that use generic exceptions, this function gives
 * you the flexibility to specify a meaningful error type that aligns with your
 * application's needs.
 *
 * When you apply this function, you provide:
 * - A `duration`: The time limit for the effect.
 * - An `onTimeout` function: A lazy evaluation function that generates the
 *   custom error if the timeout occurs.
 *
 * If the effect completes within the time limit, its result is returned
 * normally. Otherwise, the `onTimeout` function is triggered, and its output is
 * used as the error for the effect.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const task = Effect.gen(function* () {
 *   console.log("Start processing...")
 *   yield* Effect.sleep("2 seconds") // Simulates a delay in processing
 *   console.log("Processing complete.")
 *   return "Result"
 * })
 *
 * class MyTimeoutError {
 *   readonly _tag = "MyTimeoutError"
 * }
 *
 * const program = task.pipe(
 *   Effect.timeoutFail({
 *     duration: "1 second",
 *     onTimeout: () => new MyTimeoutError() // Custom timeout error
 *   })
 * )
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // Start processing...
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: {
 * //     _id: 'Cause',
 * //     _tag: 'Fail',
 * //     failure: MyTimeoutError { _tag: 'MyTimeoutError' }
 * //   }
 * // }
 * ```
 *
 * @see {@link timeout} for a version that raises a `TimeoutException`.
 * @see {@link timeoutFailCause} for a version that raises a custom defect.
 * @see {@link timeoutTo} for a version that allows specifying both success and
 * timeout handlers.
 *
 * @since 2.0.0
 * @category Delays & Timeouts
 */
const timeoutFail = circular/* timeoutFail */.Ai;
/**
 * Specifies a custom defect to be thrown when a timeout occurs.
 *
 * **Details**
 *
 * This function allows you to handle timeouts as exceptional cases by
 * generating a custom defect when an effect exceeds the specified duration. You
 * provide:
 * - A `duration`: The time limit for the effect.
 * - An `onTimeout` function: A lazy evaluation function that generates the
 *   custom defect (typically created using `Cause.die`).
 *
 * If the effect completes within the time limit, its result is returned
 * normally. Otherwise, the custom defect is triggered, and the effect fails
 * with that defect.
 *
 * **When to Use**
 *
 * This is especially useful when you need to treat timeouts as critical
 * failures in your application and wish to include meaningful information in
 * the defect.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Cause } from "effect"
 *
 * const task = Effect.gen(function* () {
 *   console.log("Start processing...")
 *   yield* Effect.sleep("2 seconds") // Simulates a delay in processing
 *   console.log("Processing complete.")
 *   return "Result"
 * })
 *
 * const program = task.pipe(
 *   Effect.timeoutFailCause({
 *     duration: "1 second",
 *     onTimeout: () => Cause.die("Timed out!") // Custom defect for timeout
 *   })
 * )
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // Start processing...
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: { _id: 'Cause', _tag: 'Die', defect: 'Timed out!' }
 * // }
 * ```
 *
 * @see {@link timeout} for a version that raises a `TimeoutException`.
 * @see {@link timeoutFail} for a version that raises a custom error.
 * @see {@link timeoutTo} for a version that allows specifying both success and
 * timeout handlers.
 *
 * @since 2.0.0
 * @category Delays & Timeouts
 */
const timeoutFailCause = circular/* timeoutFailCause */.R0;
/**
 * Provides custom behavior for successful and timed-out operations.
 *
 * **Details**
 *
 * This function allows you to define distinct outcomes for an effect depending
 * on whether it completes within a specified time frame or exceeds the timeout
 * duration. You can provide:
 * - `onSuccess`: A handler for processing the result of the effect if it
 *   completes successfully within the time limit.
 * - `onTimeout`: A handler for generating a result when the effect times out.
 * - `duration`: The maximum allowed time for the effect to complete.
 *
 * **When to Use**
 *
 * Unlike {@link timeout}, which raises an exception for timeouts, this function
 * gives you full control over the behavior for both success and timeout
 * scenarios. It is particularly useful when you want to encapsulate timeouts
 * and successes into a specific data structure, like an `Either` type, to
 * represent these outcomes in a meaningful way.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Either } from "effect"
 *
 * const task = Effect.gen(function* () {
 *   console.log("Start processing...")
 *   yield* Effect.sleep("2 seconds") // Simulates a delay in processing
 *   console.log("Processing complete.")
 *   return "Result"
 * })
 *
 * const program = task.pipe(
 *   Effect.timeoutTo({
 *     duration: "1 second",
 *     onSuccess: (result): Either.Either<string, string> =>
 *       Either.right(result),
 *     onTimeout: (): Either.Either<string, string> =>
 *       Either.left("Timed out!")
 *   })
 * )
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // Start processing...
 * // {
 * //   _id: "Either",
 * //   _tag: "Left",
 * //   left: "Timed out!"
 * // }
 * ```
 *
 * @see {@link timeout} for a version that raises a `TimeoutException`.
 * @see {@link timeoutFail} for a version that raises a custom error.
 * @see {@link timeoutFailCause} for a version that raises a custom defect.
 *
 * @since 2.0.0
 * @category Delays & Timeouts
 */
const timeoutTo = circular/* timeoutTo */.eS;
/**
 * Allows working with the default configuration provider.
 *
 * **Details**
 *
 * This function retrieves the default configuration provider and passes it to
 * the provided function, which can use it to perform computations or retrieve
 * configuration values. The function can return an effect that leverages the
 * configuration provider for its operations.
 *
 * @since 2.0.0
 * @category Config
 */
const configProviderWith = internal_defaultServices/* configProviderWith */.D5;
/**
 * Executes an effect using a specific configuration provider.
 *
 * **Details**
 *
 * This function lets you run an effect with a specified configuration provider.
 * The custom provider will override the default configuration provider for the
 * duration of the effect's execution.
 *
 * **When to Use**
 *
 * This is particularly useful when you need to use a different set of
 * configuration values or sources for specific parts of your application.
 *
 * **Example**
 *
 * ```ts
 * import { Config, ConfigProvider, Effect } from "effect"
 *
 * const customProvider: ConfigProvider.ConfigProvider = ConfigProvider.fromMap(
 *   new Map([["custom-key", "custom-value"]])
 * )
 *
 * const program = Effect.withConfigProvider(customProvider)(
 *   Effect.gen(function*() {
 *     const value = yield* Config.string("custom-key")
 *     console.log(`Config value: ${value}`)
 *   })
 * )
 *
 * Effect.runPromise(program)
 * // Output:
 * // Config value: custom-value
 * ```
 *
 * @since 2.0.0
 * @category Config
 */
const withConfigProvider = internal_defaultServices/* withConfigProvider */.wD;
/**
 * Sets a configuration provider within a scope.
 *
 * **Details**
 *
 * This function sets the configuration provider to a specified value and
 * ensures that it is restored to its original value when the scope is closed.
 *
 * @since 2.0.0
 * @category Config
 */
const withConfigProviderScoped = internal_fiberRuntime/* withConfigProviderScoped */.Yk;
/**
 * Accesses the full context of the effect.
 *
 * **Details**
 *
 * This function provides the ability to access the entire context required by
 * an effect. The context is a container that holds dependencies or environment
 * values needed by an effect to run. By using this function, you can retrieve
 * and work with the context directly within an effect.
 *
 * @since 2.0.0
 * @category Context
 */
const context = internal_core/* context */.Do7;
/**
 * Accesses the context and applies a transformation function.
 *
 * **Details**
 *
 * This function retrieves the context of the effect and applies a pure
 * transformation function to it. The result of the transformation is then
 * returned within the effect.
 *
 * @see {@link contextWithEffect} for a version that allows effectful transformations.
 *
 * @since 2.0.0
 * @category Context
 */
const contextWith = core_effect/* contextWith */.bp;
/**
 * Accesses the context and performs an effectful transformation.
 *
 * **Details**
 *
 * This function retrieves the context and allows you to transform it
 * effectually using another effect. It is useful when the transformation
 * involves asynchronous or effectful operations.
 *
 * @see {@link contextWith} for a version that allows pure transformations.
 *
 * @since 2.0.0
 * @category Context
 */
const contextWithEffect = internal_core/* contextWithEffect */.RuX;
/**
 * Provides part of the required context while leaving the rest unchanged.
 *
 * **Details**
 *
 * This function allows you to transform the context required by an effect,
 * providing part of the context and leaving the rest to be fulfilled later.
 *
 * **Example**
 *
 * ```ts
 * import { Context, Effect } from "effect"
 *
 * class Service1 extends Context.Tag("Service1")<Service1, { readonly port: number }>() {}
 * class Service2 extends Context.Tag("Service2")<Service2, { readonly connection: string }>() {}
 *
 * const program = Effect.gen(function*() {
 *   const service1 = yield* Service1
 *   console.log(service1.port)
 *   const service2 = yield* Service2
 *   console.log(service2.connection)
 *   return "some result"
 * })
 *
 * //      ┌─── Effect<string, never, Service2>
 * //      ▼
 * const programWithService1 = Effect.mapInputContext(
 *   program,
 *   (ctx: Context.Context<Service2>) => Context.add(ctx, Service1, { port: 3000 })
 * )
 *
 * const runnable = programWithService1.pipe(
 *   Effect.provideService(Service2, { connection: "localhost" }),
 *   Effect.provideService(Service1, { port: 3001 })
 * )
 *
 * Effect.runPromise(runnable)
 * // Output:
 * // 3000
 * // localhost
 * ```
 *
 * @since 2.0.0
 * @category Context
 */
const mapInputContext = internal_core/* mapInputContext */.nP$;
/**
 * Provides necessary dependencies to an effect, removing its environmental
 * requirements.
 *
 * **Details**
 *
 * This function allows you to supply the required environment for an effect.
 * The environment can be provided in the form of one or more `Layer`s, a
 * `Context`, a `Runtime`, or a `ManagedRuntime`. Once the environment is
 * provided, the effect can run without requiring external dependencies.
 *
 * You can compose layers to create a modular and reusable way of setting up the
 * environment for effects. For example, layers can be used to configure
 * databases, logging services, or any other required dependencies.
 *
 * **Example**
 *
 * ```ts
 * import { Context, Effect, Layer } from "effect"
 *
 * class Database extends Context.Tag("Database")<
 *   Database,
 *   { readonly query: (sql: string) => Effect.Effect<Array<unknown>> }
 * >() {}
 *
 * const DatabaseLive = Layer.succeed(
 *   Database,
 *   {
 *     // Simulate a database query
 *     query: (sql: string) => Effect.log(`Executing query: ${sql}`).pipe(Effect.as([]))
 *   }
 * )
 *
 * //      ┌─── Effect<unknown[], never, Database>
 * //      ▼
 * const program = Effect.gen(function*() {
 *   const database = yield* Database
 *   const result = yield* database.query("SELECT * FROM users")
 *   return result
 * })
 *
 * //      ┌─── Effect<unknown[], never, never>
 * //      ▼
 * const runnable = Effect.provide(program, DatabaseLive)
 *
 * Effect.runPromise(runnable).then(console.log)
 * // Output:
 * // timestamp=... level=INFO fiber=#0 message="Executing query: SELECT * FROM users"
 * // []
 * ```
 *
 * @see {@link provideService} for providing a service to an effect.
 *
 * @since 2.0.0
 * @category Context
 */
const provide = internal_layer/* effect_provide */.uZ;
/**
 * Provides an implementation for a service in the context of an effect.
 *
 * **Details**
 *
 * This function allows you to supply a specific implementation for a service
 * required by an effect. Services are typically defined using `Context.Tag`,
 * which acts as a unique identifier for the service. By using this function,
 * you link the service to its concrete implementation, enabling the effect to
 * execute successfully without additional requirements.
 *
 * For example, you can use this function to provide a random number generator,
 * a logger, or any other service your effect depends on. Once the service is
 * provided, all parts of the effect that rely on the service will automatically
 * use the implementation you supplied.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Context } from "effect"
 *
 * // Declaring a tag for a service that generates random numbers
 * class Random extends Context.Tag("MyRandomService")<
 *   Random,
 *   { readonly next: Effect.Effect<number> }
 * >() {}
 *
 * // Using the service
 * const program = Effect.gen(function* () {
 *   const random = yield* Random
 *   const randomNumber = yield* random.next
 *   console.log(`random number: ${randomNumber}`)
 * })
 *
 * // Providing the implementation
 * //
 * //      ┌─── Effect<void, never, never>
 * //      ▼
 * const runnable = Effect.provideService(program, Random, {
 *   next: Effect.sync(() => Math.random())
 * })
 *
 * // Run successfully
 * Effect.runPromise(runnable)
 * // Example Output:
 * // random number: 0.8241872233134417
 * ```
 *
 * @see {@link provide} for providing multiple layers to an effect.
 *
 * @since 2.0.0
 * @category Context
 */
const provideService = core_effect/* provideService */.aH;
/**
 * Dynamically provides an implementation for a service using an effect.
 *
 * **Details**
 *
 * This function allows you to provide an implementation for a service
 * dynamically by using another effect. The provided effect is executed to
 * produce the service implementation, which is then made available to the
 * consuming effect. This is particularly useful when the service implementation
 * itself requires asynchronous or resource-intensive initialization.
 *
 * For example, you can use this function to lazily initialize a database
 * connection or fetch configuration values from an external source before
 * making the service available to your effect.
 *
 * @since 2.0.0
 * @category Context
 */
const provideServiceEffect = core_effect/* provideServiceEffect */.VZ;
/**
 * Creates a function that uses a service from the context to produce a value.
 *
 * @see {@link serviceFunctionEffect} for a version that returns an effect.
 *
 * @since 2.0.0
 * @category Context
 */
const serviceFunction = core_effect/* serviceFunction */.B8;
/**
 * Creates a function that uses a service from the context to produce an effect.
 *
 * @see {@link serviceFunction} for a version that returns a value.
 *
 * @since 2.0.0
 * @category Context
 */
const serviceFunctionEffect = core_effect/* serviceFunctionEffect */.M2;
/**
 * @since 2.0.0
 * @category Context
 */
const serviceFunctions = core_effect/* serviceFunctions */.Ft;
/**
 * @since 2.0.0
 * @category Context
 */
const serviceConstants = core_effect/* serviceConstants */.E9;
/**
 * @since 2.0.0
 * @category Context
 */
const serviceMembers = core_effect/* serviceMembers */.DM;
/**
 * Retrieves an optional service from the context as an `Option`.
 *
 * **Details**
 *
 * This function retrieves a service from the context and wraps it in an
 * `Option`. If the service is available, it returns a `Some` containing the
 * service. If the service is not found, it returns a `None`. This approach is
 * useful when you want to handle the absence of a service gracefully without
 * causing an error.
 *
 * **When to Use**
 *
 * Use this function when:
 * - You need to access a service that may or may not be present in the context.
 * - You want to handle the absence of a service using the `Option` type instead
 *   of throwing an error.
 *
 * @see {@link serviceOptional} for a version that throws an error if the service is missing.
 *
 * @since 2.0.0
 * @category Context
 */
const serviceOption = core_effect/* serviceOption */.my;
/**
 * Retrieves a service from the context, throwing an error if it is missing.
 *
 * **Details**
 *
 * This function retrieves a required service from the context. If the service
 * is available, it returns the service. If the service is missing, it throws a
 * `NoSuchElementException`, which can be handled using Effect's error-handling
 * mechanisms. This is useful for services that are critical to the execution of
 * your effect.
 *
 * @see {@link serviceOption} for a version that returns an `Option` instead of throwing an error.
 *
 * @since 2.0.0
 * @category Context
 */
const serviceOptional = core_effect/* serviceOptional */.A1;
/**
 * Updates a service in the context with a new implementation.
 *
 * **Details**
 *
 * This function modifies the existing implementation of a service in the
 * context. It retrieves the current service, applies the provided
 * transformation function `f`, and replaces the old service with the
 * transformed one.
 *
 * **When to Use**
 *
 * This is useful for adapting or extending a service's behavior during the
 * execution of an effect.
 *
 * @since 2.0.0
 * @category Context
 */
const updateService = core_effect/* updateService */.Pg;
/**
 * The "do simulation" in Effect allows you to write code in a more declarative style, similar to the "do notation" in other programming languages. It provides a way to define variables and perform operations on them using functions like `bind` and `let`.
 *
 * Here's how the do simulation works:
 *
 * 1. Start the do simulation using the `Do` value
 * 2. Within the do simulation scope, you can use the `bind` function to define variables and bind them to `Effect` values
 * 3. You can accumulate multiple `bind` statements to define multiple variables within the scope
 * 4. Inside the do simulation scope, you can also use the `let` function to define variables and bind them to simple values
 *
 * **Example**
 *
 * ```ts
 * import * as assert from "node:assert"
 * import { Effect, pipe } from "effect"
 *
 * const result = pipe(
 *   Effect.Do,
 *   Effect.bind("x", () => Effect.succeed(2)),
 *   Effect.bind("y", () => Effect.succeed(3)),
 *   Effect.let("sum", ({ x, y }) => x + y)
 * )
 * assert.deepStrictEqual(Effect.runSync(result), { x: 2, y: 3, sum: 5 })
 * ```
 *
 * @see {@link bind}
 * @see {@link bindTo}
 * @see {@link let_ let}
 *
 * @category Do notation
 * @since 2.0.0
 */
const Do = core_effect.Do;
/**
 * The "do simulation" in Effect allows you to write code in a more declarative style, similar to the "do notation" in other programming languages. It provides a way to define variables and perform operations on them using functions like `bind` and `let`.
 *
 * Here's how the do simulation works:
 *
 * 1. Start the do simulation using the `Do` value
 * 2. Within the do simulation scope, you can use the `bind` function to define variables and bind them to `Effect` values
 * 3. You can accumulate multiple `bind` statements to define multiple variables within the scope
 * 4. Inside the do simulation scope, you can also use the `let` function to define variables and bind them to simple values
 *
 * **Example**
 *
 * ```ts
 * import * as assert from "node:assert"
 * import { Effect, pipe } from "effect"
 *
 * const result = pipe(
 *   Effect.Do,
 *   Effect.bind("x", () => Effect.succeed(2)),
 *   Effect.bind("y", () => Effect.succeed(3)),
 *   Effect.let("sum", ({ x, y }) => x + y)
 * )
 * assert.deepStrictEqual(Effect.runSync(result), { x: 2, y: 3, sum: 5 })
 * ```
 *
 * @see {@link Do}
 * @see {@link bindTo}
 * @see {@link let_ let}
 *
 * @category Do notation
 * @since 2.0.0
 */
const bind = core_effect/* bind */.ak;
/**
 * `bindAll` combines `all` with `bind`. It is useful
 * when you want to concurrently run multiple effects and then combine their
 * results in a Do notation pipeline.
 *
 * **Example**
 *
 * ```ts
 * import * as assert from "node:assert"
 * import { Effect, Either, pipe } from "effect"
 *
 * const result = pipe(
 *   Effect.Do,
 *   Effect.bind("x", () => Effect.succeed(2)),
 *   Effect.bindAll(({ x }) => ({
 *     a: Effect.succeed(x),
 *     b: Effect.fail("oops"),
 *   }), { concurrency: 2, mode: "either" })
 * )
 * assert.deepStrictEqual(Effect.runSync(result), { x: 2, a: Either.right(2), b: Either.left("oops") })
 * ```
 *
 * @category Do notation
 * @since 3.7.0
 */
const bindAll = circular/* bindAll */.Ev;
/**
 * The "do simulation" in Effect allows you to write code in a more declarative style, similar to the "do notation" in other programming languages. It provides a way to define variables and perform operations on them using functions like `bind` and `let`.
 *
 * Here's how the do simulation works:
 *
 * 1. Start the do simulation using the `Do` value
 * 2. Within the do simulation scope, you can use the `bind` function to define variables and bind them to `Effect` values
 * 3. You can accumulate multiple `bind` statements to define multiple variables within the scope
 * 4. Inside the do simulation scope, you can also use the `let` function to define variables and bind them to simple values
 *
 * **Example**
 *
 * ```ts
 * import * as assert from "node:assert"
 * import { Effect, pipe } from "effect"
 *
 * const result = pipe(
 *   Effect.Do,
 *   Effect.bind("x", () => Effect.succeed(2)),
 *   Effect.bind("y", () => Effect.succeed(3)),
 *   Effect.let("sum", ({ x, y }) => x + y)
 * )
 * assert.deepStrictEqual(Effect.runSync(result), { x: 2, y: 3, sum: 5 })
 * ```
 *
 * @see {@link Do}
 * @see {@link bind}
 * @see {@link let_ let}
 *
 * @category Do notation
 * @since 2.0.0
 */
const bindTo = core_effect/* bindTo */.YO;
const let_ = core_effect/* let_ */.Zp;

/**
 * Encapsulates the result of an effect in an `Option`.
 *
 * **Details**
 *
 * This function wraps the outcome of an effect in an `Option` type. If the
 * original effect succeeds, the success value is wrapped in `Option.some`. If
 * the effect fails, the failure is converted to `Option.none`.
 *
 * This is particularly useful for scenarios where you want to represent the
 * absence of a value explicitly, without causing the resulting effect to fail.
 * The resulting effect has an error type of `never`, meaning it cannot fail
 * directly. However, unrecoverable errors, also referred to as defects, are
 * not captured and will still result in failure.
 *
 * **Example** (Using Effect.option to Handle Errors)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const maybe1 = Effect.option(Effect.succeed(1))
 *
 * Effect.runPromiseExit(maybe1).then(console.log)
 * // Output:
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Success',
 * //   value: { _id: 'Option', _tag: 'Some', value: 1 }
 * // }
 *
 * const maybe2 = Effect.option(Effect.fail("Uh oh!"))
 *
 * Effect.runPromiseExit(maybe2).then(console.log)
 * // Output:
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Success',
 * //   value: { _id: 'Option', _tag: 'None' }
 * // }
 *
 * const maybe3 = Effect.option(Effect.die("Boom!"))
 *
 * Effect.runPromiseExit(maybe3).then(console.log)
 * // Output:
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: { _id: 'Cause', _tag: 'Die', defect: 'Boom!' }
 * // }
 * ```
 *
 * @see {@link either} for a version that uses `Either` instead.
 * @see {@link exit} for a version that encapsulates both recoverable errors and defects in an `Exit`.
 *
 * @since 2.0.0
 * @category Outcome Encapsulation
 */
const Effect_option = core_effect/* option */.Kw;
/**
 * Encapsulates both success and failure of an `Effect` into an `Either` type.
 *
 * **Details**
 *
 * This function converts an effect that may fail into an effect that always
 * succeeds, wrapping the outcome in an `Either` type. The result will be
 * `Either.Left` if the effect fails, containing the recoverable error, or
 * `Either.Right` if it succeeds, containing the result.
 *
 * Using this function, you can handle recoverable errors explicitly without
 * causing the effect to fail. This is particularly useful in scenarios where
 * you want to chain effects and manage both success and failure in the same
 * logical flow.
 *
 * It's important to note that unrecoverable errors, often referred to as
 * "defects," are still thrown and not captured within the `Either` type. Only
 * failures that are explicitly represented as recoverable errors in the effect
 * are encapsulated.
 *
 * The resulting effect cannot fail directly because all recoverable failures
 * are represented inside the `Either` type.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Either, Random } from "effect"
 *
 * class HttpError {
 *   readonly _tag = "HttpError"
 * }
 *
 * class ValidationError {
 *   readonly _tag = "ValidationError"
 * }
 *
 * //      ┌─── Effect<string, HttpError | ValidationError, never>
 * //      ▼
 * const program = Effect.gen(function* () {
 *   const n1 = yield* Random.next
 *   const n2 = yield* Random.next
 *   if (n1 < 0.5) {
 *     yield* Effect.fail(new HttpError())
 *   }
 *   if (n2 < 0.5) {
 *     yield* Effect.fail(new ValidationError())
 *   }
 *   return "some result"
 * })
 *
 * //      ┌─── Effect<string, never, never>
 * //      ▼
 * const recovered = Effect.gen(function* () {
 *   //      ┌─── Either<string, HttpError | ValidationError>
 *   //      ▼
 *   const failureOrSuccess = yield* Effect.either(program)
 *   return Either.match(failureOrSuccess, {
 *     onLeft: (error) => `Recovering from ${error._tag}`,
 *     onRight: (value) => value // Do nothing in case of success
 *   })
 * })
 * ```
 *
 * @see {@link option} for a version that uses `Option` instead.
 * @see {@link exit} for a version that encapsulates both recoverable errors and defects in an `Exit`.
 *
 * @since 2.0.0
 * @category Outcome Encapsulation
 */
const either = internal_core/* either */.wEe;
/**
 * Encapsulates both success and failure of an `Effect` using the `Exit` type.
 *
 * **Details**
 *
 * This function converts an effect into one that always succeeds, wrapping its
 * outcome in the `Exit` type. The `Exit` type provides explicit handling of
 * both success (`Exit.Success`) and failure (`Exit.Failure`) cases, including
 * defects (unrecoverable errors).
 *
 * Unlike {@link either} or {@link option}, this function also encapsulates
 * defects, which are typically unrecoverable and would otherwise terminate the
 * effect. With the `Exit` type, defects are represented in `Exit.Failure`,
 * allowing for detailed introspection and structured error handling.
 *
 * This makes the resulting effect robust and incapable of direct failure (its
 * error type is `never`). It is particularly useful for workflows where all
 * outcomes, including unexpected defects, must be managed and analyzed.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Cause, Console, Exit } from "effect"
 *
 * // Simulating a runtime error
 * const task = Effect.dieMessage("Boom!")
 *
 * const program = Effect.gen(function* () {
 *   const exit = yield* Effect.exit(task)
 *   if (Exit.isFailure(exit)) {
 *     const cause = exit.cause
 *     if (
 *       Cause.isDieType(cause) &&
 *       Cause.isRuntimeException(cause.defect)
 *     ) {
 *       yield* Console.log(
 *         `RuntimeException defect caught: ${cause.defect.message}`
 *       )
 *     } else {
 *       yield* Console.log("Unknown failure caught.")
 *     }
 *   }
 * })
 *
 * // We get an Exit.Success because we caught all failures
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // RuntimeException defect caught: Boom!
 * // {
 * //   _id: "Exit",
 * //   _tag: "Success",
 * //   value: undefined
 * // }
 * ```
 *
 * @see {@link option} for a version that uses `Option` instead.
 * @see {@link either} for a version that uses `Either` instead.
 *
 * @since 2.0.0
 * @category Outcome Encapsulation
 */
const exit = internal_core/* exit */.JFt;
/**
 * Converts an `Effect` into an operation that completes a `Deferred` with its result.
 *
 * **Details**
 *
 * The `intoDeferred` function takes an effect and a `Deferred` and ensures that the `Deferred`
 * is completed based on the outcome of the effect. If the effect succeeds, the `Deferred` is
 * completed with the success value. If the effect fails, the `Deferred` is completed with the
 * failure. Additionally, if the effect is interrupted, the `Deferred` will also be interrupted.
 *
 * **Example**
 *
 * ```ts
 * import { Deferred, Effect } from "effect"
 *
 * // Define an effect that succeeds
 * const successEffect = Effect.succeed(42)
 *
 * const program = Effect.gen(function*() {
 *   // Create a deferred
 *   const deferred = yield* Deferred.make<number, string>()
 *
 *   // Complete the deferred using the successEffect
 *   const isCompleted = yield* Effect.intoDeferred(successEffect, deferred)
 *
 *   // Access the value of the deferred
 *   const value = yield* Deferred.await(deferred)
 *   console.log(value)
 *
 *   return isCompleted
 * })
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // 42
 * // true
 * ```
 *
 * @since 2.0.0
 * @category Synchronization Utilities
 */
const intoDeferred = internal_core/* intoDeferred */.S4Q;
const if_ = internal_core/* if_ */.pHF;

/**
 * Filters an effect, dying with a custom defect if the predicate fails.
 *
 * **Details**
 *
 * This function applies a predicate to the result of an effect. If the
 * predicate evaluates to `false`, the effect dies with a custom defect
 * generated by the `orDieWith` function.
 *
 * **When to Use**
 *
 * This is useful for enforcing constraints on values and treating violations as
 * fatal program errors.
 *
 * @since 2.0.0
 * @category Filtering
 */
const filterOrDie = core_effect/* filterOrDie */.eW;
/**
 * Filters an effect, dying with a custom message if the predicate fails.
 *
 * **Details**
 *
 * This function works like {@link filterOrDie} but allows you to specify a
 * custom error message to describe the reason for the failure. The message is
 * included in the defect when the predicate evaluates to `false`.
 *
 * @since 2.0.0
 * @category Filtering
 */
const filterOrDieMessage = core_effect/* filterOrDieMessage */.FY;
/**
 * Filters an effect, providing an alternative effect if the predicate fails.
 *
 * **Details**
 *
 * This function applies a predicate to the result of an effect. If the
 * predicate evaluates to `false`, it executes the `orElse` effect instead. The
 * `orElse` effect can produce an alternative value or perform additional
 * computations.
 *
 * @since 2.0.0
 * @category Filtering
 */
const filterOrElse = core_effect/* filterOrElse */.Y$;
/**
 * Filters an effect, failing with a custom error if the predicate fails.
 *
 * **Details**
 *
 * This function applies a predicate to the result of an effect. If the
 * predicate evaluates to `false`, the effect fails with a custom error
 * generated by the `orFailWith` function.
 *
 * **When to Use**
 *
 * This is useful for enforcing constraints and treating violations as
 * recoverable errors.
 *
 * **Providing a Guard**
 *
 * In addition to the filtering capabilities discussed earlier, you have the
 * option to further refine and narrow down the type of the success channel by
 * providing a [user-defined type
 * guard](https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates).
 * Let's explore this concept through an example:
 *
 * **Example**
 *
 * ```ts
 * import { Effect, pipe } from "effect"
 *
 * // Define a user interface
 * interface User {
 *   readonly name: string
 * }
 *
 * // Simulate an asynchronous authentication function
 * declare const auth: () => Promise<User | null>
 *
 * const program = pipe(
 *   Effect.promise(() => auth()),
 *   // Use filterOrFail with a custom type guard to ensure user is not null
 *   Effect.filterOrFail(
 *     (user): user is User => user !== null, // Type guard
 *     () => new Error("Unauthorized")
 *   ),
 *   // 'user' now has the type `User` (not `User | null`)
 *   Effect.andThen((user) => user.name)
 * )
 * ```
 *
 * @since 2.0.0
 * @category Filtering
 */
const filterOrFail = core_effect/* filterOrFail */.lF;
/**
 * Filters an effect with an effectful predicate, falling back to an alternative
 * effect if the predicate fails.
 *
 * **Details**
 *
 * This function applies a predicate to the result of an effect. If the
 * predicate evaluates to `false`, the effect falls back to the `orElse`
 * effect. The `orElse` effect can produce an alternative value or perform
 * additional computations.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, pipe } from "effect"
 *
 * // Define a user interface
 * interface User {
 *   readonly name: string
 * }
 *
 * // Simulate an asynchronous authentication function
 * declare const auth: () => Promise<User | null>
 *
 * const program = pipe(
 *   Effect.promise(() => auth()),
 *   // Use filterEffectOrElse with an effectful predicate
 *   Effect.filterEffectOrElse({
 *     predicate: (user) => Effect.succeed(user !== null),
 *     orElse: (user) => Effect.fail(new Error(`Unauthorized user: ${user}`))
 *   }),
 * )
 * ```
 *
 * @since 3.13.0
 * @category Filtering
 */
const filterEffectOrElse = internal_core/* filterEffectOrElse */.u_7;
/**
 * Filters an effect with an effectful predicate, failing with a custom error if the predicate fails.
 *
 * **Details**
 *
 * This function applies a predicate to the result of an effect. If the
 * predicate evaluates to `false`, the effect fails with a custom error
 * generated by the `orFailWith` function.
 *
 * **When to Use**
 *
 * This is useful for enforcing constraints and treating violations as
 * recoverable errors.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, pipe } from "effect"
 *
 * // Define a user interface
 * interface User {
 *   readonly name: string
 * }
 *
 * // Simulate an asynchronous authentication function
 * declare const auth: () => Promise<User | null>
 *
 * const program = pipe(
 *   Effect.promise(() => auth()),
 *   // Use filterEffectOrFail with an effectful predicate
 *   Effect.filterEffectOrFail({
 *     predicate: (user) => Effect.succeed(user !== null),
 *     orFailWith: () => new Error("Unauthorized")
 *   }),
 * )
 * ```
 *
 * @since 3.13.0
 * @category Filtering
 */
const filterEffectOrFail = internal_core/* filterEffectOrFail */.JEf;
/**
 * Executes an effect only if the condition is `false`.
 *
 * @see {@link unlessEffect} for a version that allows the condition to be an effect.
 * @see {@link when} for a version that executes the effect when the condition is `true`.
 *
 * @since 2.0.0
 * @category Conditional Operators
 */
const unless = core_effect/* unless */.qh;
/**
 * Conditionally execute an effect based on the result of another effect.
 *
 * @see {@link unless} for a version that allows the condition to be a boolean.
 * @see {@link whenEffect} for a version that executes the effect when the condition is `true`.
 *
 * @since 2.0.0
 * @category Conditional Operators
 */
const unlessEffect = core_effect/* unlessEffect */.d7;
/**
 * Conditionally executes an effect based on a boolean condition.
 *
 * **Details**
 *
 * This function allows you to run an effect only if a given condition evaluates
 * to `true`. If the condition is `true`, the effect is executed, and its result
 * is wrapped in an `Option.some`. If the condition is `false`, the effect is
 * skipped, and the result is `Option.none`.
 *
 * **When to Use**
 *
 * This function is useful for scenarios where you need to dynamically decide
 * whether to execute an effect based on runtime logic, while also representing
 * the skipped case explicitly.
 *
 * **Example** (Conditional Effect Execution)
 *
 * ```ts
 * import { Effect, Option } from "effect"
 *
 * const validateWeightOption = (
 *   weight: number
 * ): Effect.Effect<Option.Option<number>> =>
 *   // Conditionally execute the effect if the weight is non-negative
 *   Effect.succeed(weight).pipe(Effect.when(() => weight >= 0))
 *
 * // Run with a valid weight
 * Effect.runPromise(validateWeightOption(100)).then(console.log)
 * // Output:
 * // {
 * //   _id: "Option",
 * //   _tag: "Some",
 * //   value: 100
 * // }
 *
 * // Run with an invalid weight
 * Effect.runPromise(validateWeightOption(-5)).then(console.log)
 * // Output:
 * // {
 * //   _id: "Option",
 * //   _tag: "None"
 * // }
 * ```
 *
 * @see {@link whenEffect} for a version that allows the condition to be an effect.
 * @see {@link unless} for a version that executes the effect when the condition is `false`.
 *
 * @since 2.0.0
 * @category Conditional Operators
 */
const when = core_effect/* when */.gx;
/**
 * Conditionally executes an effect based on the result of another effect.
 *
 * **Details**
 *
 * This function allows you to run an effect only if a conditional effect
 * evaluating to a boolean resolves to `true`. If the conditional effect
 * evaluates to `true`, the specified effect is executed, and its result is
 * wrapped in `Option.some`. If the conditional effect evaluates to `false`, the
 * effect is skipped, and the result is `Option.none`.
 *
 * **When to Use**
 *
 * This function is particularly useful when the decision to execute an effect
 * depends on the result of another effect, such as a random value, a
 * user-provided input, or a network request result.
 *
 * **Example** (Using an Effect as a Condition)
 *
 * ```ts
 * import { Effect, Random } from "effect"
 *
 * const randomIntOption = Random.nextInt.pipe(
 *   Effect.whenEffect(Random.nextBoolean)
 * )
 *
 * console.log(Effect.runSync(randomIntOption))
 * // Example Output:
 * // { _id: 'Option', _tag: 'Some', value: 8609104974198840 }
 * ```
 *
 * @see {@link when} for a version that allows the condition to be a boolean.
 * @see {@link unlessEffect} for a version that executes the effect when the condition is `false`.
 *
 * @since 2.0.0
 * @category Conditional Operators
 */
const whenEffect = internal_core/* whenEffect */.FNZ;
/**
 * Executes an effect conditionally based on the value of a `FiberRef` that
 * satisfies a predicate.
 *
 * **Details**
 *
 * This function enables you to execute an effect only when the value of a
 * specified `FiberRef` meets a certain condition defined by a predicate. If the
 * value satisfies the predicate, the effect is executed, and the result is
 * wrapped in an `Option.some`. If the predicate is not satisfied, the effect is
 * skipped, and the result is `Option.none`. In both cases, the current value of
 * the `FiberRef` is included in the result.
 *
 * @since 2.0.0
 * @category Conditional Operators
 */
const whenFiberRef = core_effect/* whenFiberRef */.Q2;
/**
 * Executes an effect conditionally based on the value of a `Ref` that satisfies
 * a predicate.
 *
 * **Details**
 *
 * This function allows you to execute an effect only when the value of a
 * specified `Ref` meets a condition defined by a predicate. If the value
 * satisfies the predicate, the effect is executed, and the result is wrapped in
 * an `Option.some`. If the predicate is not satisfied, the effect is skipped,
 * and the result is `Option.none`. In both cases, the current value of the
 * `Ref` is included in the result.
 *
 * @since 2.0.0
 * @category Conditional Operators
 */
const whenRef = core_effect/* whenRef */.kD;
/**
 * Chains effects to produce new `Effect` instances, useful for combining
 * operations that depend on previous results.
 *
 * **Syntax**
 *
 * ```ts skip-type-checking
 * const flatMappedEffect = pipe(myEffect, Effect.flatMap(transformation))
 * // or
 * const flatMappedEffect = Effect.flatMap(myEffect, transformation)
 * // or
 * const flatMappedEffect = myEffect.pipe(Effect.flatMap(transformation))
 * ```
 *
 * **Details**
 *
 * `flatMap` lets you sequence effects so that the result of one effect can be
 * used in the next step. It is similar to `flatMap` used with arrays but works
 * specifically with `Effect` instances, allowing you to avoid deeply nested
 * effect structures.
 *
 * Since effects are immutable, `flatMap` always returns a new effect instead of
 * changing the original one.
 *
 * **When to Use**
 *
 * Use `flatMap` when you need to chain multiple effects, ensuring that each
 * step produces a new `Effect` while flattening any nested effects that may
 * occur.
 *
 * **Example**
 *
 * ```ts
 * import { pipe, Effect } from "effect"
 *
 * // Function to apply a discount safely to a transaction amount
 * const applyDiscount = (
 *   total: number,
 *   discountRate: number
 * ): Effect.Effect<number, Error> =>
 *   discountRate === 0
 *     ? Effect.fail(new Error("Discount rate cannot be zero"))
 *     : Effect.succeed(total - (total * discountRate) / 100)
 *
 * // Simulated asynchronous task to fetch a transaction amount from database
 * const fetchTransactionAmount = Effect.promise(() => Promise.resolve(100))
 *
 * // Chaining the fetch and discount application using `flatMap`
 * const finalAmount = pipe(
 *   fetchTransactionAmount,
 *   Effect.flatMap((amount) => applyDiscount(amount, 5))
 * )
 *
 * Effect.runPromise(finalAmount).then(console.log)
 * // Output: 95
 * ```
 *
 * @see {@link tap} for a version that ignores the result of the effect.
 *
 * @since 2.0.0
 * @category Sequencing
 */
const flatMap = internal_core/* flatMap */.VSD;
/**
 * Chains two actions, where the second action can depend on the result of the
 * first.
 *
 * **Syntax**
 *
 * ```ts skip-type-checking
 * const transformedEffect = pipe(myEffect, Effect.andThen(anotherEffect))
 * // or
 * const transformedEffect = Effect.andThen(myEffect, anotherEffect)
 * // or
 * const transformedEffect = myEffect.pipe(Effect.andThen(anotherEffect))
 * ```
 *
 * **When to Use**
 *
 * Use `andThen` when you need to run multiple actions in sequence, with the
 * second action depending on the result of the first. This is useful for
 * combining effects or handling computations that must happen in order.
 *
 * **Details**
 *
 * The second action can be:
 *
 * - A constant value (similar to {@link as})
 * - A function returning a value (similar to {@link map})
 * - A `Promise`
 * - A function returning a `Promise`
 * - An `Effect`
 * - A function returning an `Effect` (similar to {@link flatMap})
 *
 * **Note:** `andThen` works well with both `Option` and `Either` types,
 * treating them as effects.
 *
 * **Example** (Applying a Discount Based on Fetched Amount)
 *
 * ```ts
 * import { pipe, Effect } from "effect"
 *
 * // Function to apply a discount safely to a transaction amount
 * const applyDiscount = (
 *   total: number,
 *   discountRate: number
 * ): Effect.Effect<number, Error> =>
 *   discountRate === 0
 *     ? Effect.fail(new Error("Discount rate cannot be zero"))
 *     : Effect.succeed(total - (total * discountRate) / 100)
 *
 * // Simulated asynchronous task to fetch a transaction amount from database
 * const fetchTransactionAmount = Effect.promise(() => Promise.resolve(100))
 *
 * // Using Effect.map and Effect.flatMap
 * const result1 = pipe(
 *   fetchTransactionAmount,
 *   Effect.map((amount) => amount * 2),
 *   Effect.flatMap((amount) => applyDiscount(amount, 5))
 * )
 *
 * Effect.runPromise(result1).then(console.log)
 * // Output: 190
 *
 * // Using Effect.andThen
 * const result2 = pipe(
 *   fetchTransactionAmount,
 *   Effect.andThen((amount) => amount * 2),
 *   Effect.andThen((amount) => applyDiscount(amount, 5))
 * )
 *
 * Effect.runPromise(result2).then(console.log)
 * // Output: 190
 * ```
 *
 * @since 2.0.0
 * @category Sequencing
 */
const andThen = internal_core/* andThen */.Po9;
/**
 * @since 2.0.0
 * @category Sequencing
 */
const flatten = internal_core/* flatten */.xHg;
/**
 * Races two effects and returns the result of the first successful one.
 *
 * **Details**
 *
 * This function takes two effects and runs them concurrently. The first effect
 * that successfully completes will determine the result of the race, and the
 * other effect will be interrupted.
 *
 * If neither effect succeeds, the function will fail with a `Cause`
 * containing all the errors.
 *
 * **When to Use**
 *
 * This is useful when you want to run two effects concurrently, but only care
 * about the first one to succeed. It is commonly used in cases like timeouts,
 * retries, or when you want to optimize for the faster response without
 * worrying about the other effect.
 *
 * **Handling Success or Failure with Either**
 *
 * If you want to handle the result of whichever task completes first, whether
 * it succeeds or fails, you can use the `Effect.either` function. This function
 * wraps the result in an `Either` type, allowing you to see if the result
 * was a success (`Right`) or a failure (`Left`).
 *
 * **Example** (Both Tasks Succeed)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const task1 = Effect.succeed("task1").pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Console.log("task1 done")),
 *   Effect.onInterrupt(() => Console.log("task1 interrupted"))
 * )
 * const task2 = Effect.succeed("task2").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Console.log("task2 done")),
 *   Effect.onInterrupt(() => Console.log("task2 interrupted"))
 * )
 *
 * const program = Effect.race(task1, task2)
 *
 * Effect.runFork(program)
 * // Output:
 * // task1 done
 * // task2 interrupted
 * ```
 *
 * **Example** (One Task Fails, One Succeeds)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const task1 = Effect.fail("task1").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Console.log("task1 done")),
 *   Effect.onInterrupt(() => Console.log("task1 interrupted"))
 * )
 * const task2 = Effect.succeed("task2").pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Console.log("task2 done")),
 *   Effect.onInterrupt(() => Console.log("task2 interrupted"))
 * )
 *
 * const program = Effect.race(task1, task2)
 *
 * Effect.runFork(program)
 * // Output:
 * // task2 done
 * ```
 *
 * **Example** (Both Tasks Fail)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const task1 = Effect.fail("task1").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Console.log("task1 done")),
 *   Effect.onInterrupt(() => Console.log("task1 interrupted"))
 * )
 * const task2 = Effect.fail("task2").pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Console.log("task2 done")),
 *   Effect.onInterrupt(() => Console.log("task2 interrupted"))
 * )
 *
 * const program = Effect.race(task1, task2)
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: {
 * //     _id: 'Cause',
 * //     _tag: 'Parallel',
 * //     left: { _id: 'Cause', _tag: 'Fail', failure: 'task1' },
 * //     right: { _id: 'Cause', _tag: 'Fail', failure: 'task2' }
 * //   }
 * // }
 * ```
 *
 * **Example** (Handling Success or Failure with Either)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const task1 = Effect.fail("task1").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Console.log("task1 done")),
 *   Effect.onInterrupt(() => Console.log("task1 interrupted"))
 * )
 * const task2 = Effect.succeed("task2").pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Console.log("task2 done")),
 *   Effect.onInterrupt(() => Console.log("task2 interrupted"))
 * )
 *
 * // Run both tasks concurrently, wrapping the result
 * // in Either to capture success or failure
 * const program = Effect.race(Effect.either(task1), Effect.either(task2))
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // task2 interrupted
 * // { _id: 'Either', _tag: 'Left', left: 'task1' }
 * ```
 *
 * @see {@link raceAll} for a version that handles multiple effects.
 * @see {@link raceFirst} for a version that returns the result of the first effect to complete.
 *
 * @since 2.0.0
 * @category Racing
 */
const race = internal_fiberRuntime/* race */.S3;
/**
 * Races multiple effects and returns the first successful result.
 *
 * **Details**
 *
 * This function runs multiple effects concurrently and returns the result of
 * the first one to succeed. If one effect succeeds, the others will be
 * interrupted.
 *
 * If none of the effects succeed, the function will fail with the last error
 * encountered.
 *
 * **When to Use**
 *
 * This is useful when you want to race multiple effects, but only care about
 * the first one to succeed. It is commonly used in cases like timeouts,
 * retries, or when you want to optimize for the faster response without
 * worrying about the other effects.
 *
 * **Example** (All Tasks Succeed)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const task1 = Effect.succeed("task1").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Console.log("task1 done")),
 *   Effect.onInterrupt(() => Console.log("task1 interrupted"))
 * )
 * const task2 = Effect.succeed("task2").pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Console.log("task2 done")),
 *   Effect.onInterrupt(() => Console.log("task2 interrupted"))
 * )
 *
 * const task3 = Effect.succeed("task3").pipe(
 *   Effect.delay("150 millis"),
 *   Effect.tap(Console.log("task3 done")),
 *   Effect.onInterrupt(() => Console.log("task3 interrupted"))
 * )
 *
 * const program = Effect.raceAll([task1, task2, task3])
 *
 * Effect.runFork(program)
 * // Output:
 * // task1 done
 * // task2 interrupted
 * // task3 interrupted
 * ```
 *
 * **Example** (One Task Fails, Two Tasks Succeed)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const task1 = Effect.fail("task1").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Console.log("task1 done")),
 *   Effect.onInterrupt(() => Console.log("task1 interrupted"))
 * )
 * const task2 = Effect.succeed("task2").pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Console.log("task2 done")),
 *   Effect.onInterrupt(() => Console.log("task2 interrupted"))
 * )
 *
 * const task3 = Effect.succeed("task3").pipe(
 *   Effect.delay("150 millis"),
 *   Effect.tap(Console.log("task3 done")),
 *   Effect.onInterrupt(() => Console.log("task3 interrupted"))
 * )
 *
 * const program = Effect.raceAll([task1, task2, task3])
 *
 * Effect.runFork(program)
 * // Output:
 * // task3 done
 * // task2 interrupted
 * ```
 *
 * **Example** (All Tasks Fail)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const task1 = Effect.fail("task1").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Console.log("task1 done")),
 *   Effect.onInterrupt(() => Console.log("task1 interrupted"))
 * )
 * const task2 = Effect.fail("task2").pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Console.log("task2 done")),
 *   Effect.onInterrupt(() => Console.log("task2 interrupted"))
 * )
 *
 * const task3 = Effect.fail("task3").pipe(
 *   Effect.delay("150 millis"),
 *   Effect.tap(Console.log("task3 done")),
 *   Effect.onInterrupt(() => Console.log("task3 interrupted"))
 * )
 *
 * const program = Effect.raceAll([task1, task2, task3])
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: { _id: 'Cause', _tag: 'Fail', failure: 'task2' }
 * // }
 * ```
 *
 * @see {@link race} for a version that handles only two effects.
 *
 * @since 2.0.0
 * @category Racing
 */
const raceAll = internal_fiberRuntime/* raceAll */.xu;
/**
 * Races two effects and returns the result of the first one to complete.
 *
 * **Details**
 *
 * This function takes two effects and runs them concurrently, returning the
 * result of the first one that completes, regardless of whether it succeeds or
 * fails.
 *
 * **When to Use**
 *
 * This function is useful when you want to race two operations, and you want to
 * proceed with whichever one finishes first, regardless of whether it succeeds
 * or fails.
 *
 * **Disconnecting Effects**
 *
 * The `Effect.raceFirst` function safely interrupts the “loser” effect once the other completes, but it will not resume until the loser is cleanly terminated.
 *
 * If you want a quicker return, you can disconnect the interrupt signal for both effects. Instead of calling:
 *
 * ```ts skip-type-checking
 * Effect.raceFirst(task1, task2)
 * ```
 *
 * You can use:
 *
 * ```ts skip-type-checking
 * Effect.raceFirst(Effect.disconnect(task1), Effect.disconnect(task2))
 * ```
 *
 * This allows both effects to complete independently while still terminating the losing effect in the background.
 *
 * **Example** (Both Tasks Succeed)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const task1 = Effect.succeed("task1").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Console.log("task1 done")),
 *   Effect.onInterrupt(() =>
 *     Console.log("task1 interrupted").pipe(Effect.delay("100 millis"))
 *   )
 * )
 * const task2 = Effect.succeed("task2").pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Console.log("task2 done")),
 *   Effect.onInterrupt(() =>
 *     Console.log("task2 interrupted").pipe(Effect.delay("100 millis"))
 *   )
 * )
 *
 * const program = Effect.raceFirst(task1, task2).pipe(
 *   Effect.tap(Console.log("more work..."))
 * )
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // task1 done
 * // task2 interrupted
 * // more work...
 * // { _id: 'Exit', _tag: 'Success', value: 'task1' }
 * ```
 *
 * **Example** (One Task Fails, One Succeeds)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const task1 = Effect.fail("task1").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Console.log("task1 done")),
 *   Effect.onInterrupt(() =>
 *     Console.log("task1 interrupted").pipe(Effect.delay("100 millis"))
 *   )
 * )
 * const task2 = Effect.succeed("task2").pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Console.log("task2 done")),
 *   Effect.onInterrupt(() =>
 *     Console.log("task2 interrupted").pipe(Effect.delay("100 millis"))
 *   )
 * )
 *
 * const program = Effect.raceFirst(task1, task2).pipe(
 *   Effect.tap(Console.log("more work..."))
 * )
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // task2 interrupted
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: { _id: 'Cause', _tag: 'Fail', failure: 'task1' }
 * // }
 * ```
 *
 * **Example** (Using Effect.disconnect for Quicker Return)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const task1 = Effect.succeed("task1").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Console.log("task1 done")),
 *   Effect.onInterrupt(() =>
 *     Console.log("task1 interrupted").pipe(Effect.delay("100 millis"))
 *   )
 * )
 * const task2 = Effect.succeed("task2").pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Console.log("task2 done")),
 *   Effect.onInterrupt(() =>
 *     Console.log("task2 interrupted").pipe(Effect.delay("100 millis"))
 *   )
 * )
 *
 * // Race the two tasks with disconnect to allow quicker return
 * const program = Effect.raceFirst(
 *   Effect.disconnect(task1),
 *   Effect.disconnect(task2)
 * ).pipe(Effect.tap(Console.log("more work...")))
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // task1 done
 * // more work...
 * // { _id: 'Exit', _tag: 'Success', value: 'task1' }
 * // task2 interrupted
 * ```
 *
 * @since 2.0.0
 * @category Racing
 */
const raceFirst = circular/* raceFirst */.x3;
/**
 * Races two effects and calls a finisher when the first one completes.
 *
 * **Details**
 *
 * This function runs two effects concurrently and calls a specified “finisher”
 * function once one of the effects completes, regardless of whether it succeeds
 * or fails.
 *
 * The finisher functions for each effect allow you to handle the results of
 * each effect as soon as they complete.
 *
 * The function takes two finisher callbacks, one for each effect, and allows
 * you to specify how to handle the result of the race.
 *
 * **When to Use**
 *
 * This function is useful when you need to react to the completion of either
 * effect without waiting for both to finish. It can be used whenever you want
 * to take action based on the first available result.
 *
 * **Example** (Handling Results of Concurrent Tasks)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const task1 = Effect.succeed("task1").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Console.log("task1 done")),
 *   Effect.onInterrupt(() =>
 *     Console.log("task1 interrupted").pipe(Effect.delay("100 millis"))
 *   )
 * )
 * const task2 = Effect.succeed("task2").pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Console.log("task2 done")),
 *   Effect.onInterrupt(() =>
 *     Console.log("task2 interrupted").pipe(Effect.delay("100 millis"))
 *   )
 * )
 *
 * const program = Effect.raceWith(task1, task2, {
 *   onSelfDone: (exit) => Console.log(`task1 exited with ${exit}`),
 *   onOtherDone: (exit) => Console.log(`task2 exited with ${exit}`)
 * })
 *
 * Effect.runFork(program)
 * // Output:
 * // task1 done
 * // task1 exited with {
 * //   "_id": "Exit",
 * //   "_tag": "Success",
 * //   "value": "task1"
 * // }
 * // task2 interrupted
 * ```
 *
 * @since 2.0.0
 * @category Racing
 */
const raceWith = internal_fiberRuntime/* raceWith */.QQ;
/**
 * Summarizes a effect by computing some value before and after execution, and
 * then combining the values to produce a summary, together with the result of
 * execution.
 *
 * @since 2.0.0
 * @category Sequencing
 */
const summarized = core_effect/* summarized */.bA;
/**
 * Runs a side effect with the result of an effect without changing the original
 * value.
 *
 * **Details**
 *
 * This function works similarly to `flatMap`, but it ignores the result of the
 * function passed to it. The value from the previous effect remains available
 * for the next part of the chain. Note that if the side effect fails, the
 * entire chain will fail too.
 *
 * **When to Use**
 *
 * Use this function when you want to perform a side effect, like logging or
 * tracking, without modifying the main value. This is useful when you need to
 * observe or record an action but want the original value to be passed to the
 * next step.
 *
 * **Example** (Logging a step in a pipeline)
 *
 * ```ts
 * import { Console, Effect, pipe } from "effect"
 *
 * // Function to apply a discount safely to a transaction amount
 * const applyDiscount = (
 *   total: number,
 *   discountRate: number
 * ): Effect.Effect<number, Error> =>
 *   discountRate === 0
 *     ? Effect.fail(new Error("Discount rate cannot be zero"))
 *     : Effect.succeed(total - (total * discountRate) / 100)
 *
 * // Simulated asynchronous task to fetch a transaction amount from database
 * const fetchTransactionAmount = Effect.promise(() => Promise.resolve(100))
 *
 * const finalAmount = pipe(
 *   fetchTransactionAmount,
 *   // Log the fetched transaction amount
 *   Effect.tap((amount) => Console.log(`Apply a discount to: ${amount}`)),
 *   // `amount` is still available!
 *   Effect.flatMap((amount) => applyDiscount(amount, 5))
 * )
 *
 * Effect.runPromise(finalAmount).then(console.log)
 * // Output:
 * // Apply a discount to: 100
 * // 95
 * ```
 *
 * @see {@link flatMap} for a version that allows you to change the value.
 *
 * @since 2.0.0
 * @category Sequencing
 */
const tap = internal_core/* tap */.bwX;
/**
 * Allows you to inspect both success and failure outcomes of an effect and
 * perform side effects for each.
 *
 * **Details**
 *
 * This function enables you to handle both success and failure cases
 * separately, without modifying the main effect's result. It is particularly
 * useful for scenarios where you need to log, monitor, or perform additional
 * actions depending on whether the effect succeeded or failed.
 *
 * When the effect succeeds, the `onSuccess` handler is executed with the
 * success value. When the effect fails, the `onFailure` handler is executed
 * with the failure value. Both handlers can include side effects such as
 * logging or analytics, and neither modifies the original effect's output.
 *
 * If either the success or failure handler fails, the overall effect will also
 * fail.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Random, Console } from "effect"
 *
 * // Simulate a task that might fail
 * const task = Effect.filterOrFail(
 *   Random.nextRange(-1, 1),
 *   (n) => n >= 0,
 *   () => "random number is negative"
 * )
 *
 * // Use tapBoth to log both success and failure outcomes
 * const tapping = Effect.tapBoth(task, {
 *   onFailure: (error) => Console.log(`failure: ${error}`),
 *   onSuccess: (randomNumber) =>
 *     Console.log(`random number: ${randomNumber}`)
 * })
 *
 * Effect.runFork(tapping)
 * // Example Output:
 * // failure: random number is negative
 * ```
 *
 * @since 2.0.0
 * @category Sequencing
 */
const tapBoth = core_effect/* tapBoth */.iG;
/**
 * Inspect severe errors or defects (non-recoverable failures) in an effect.
 *
 * **Details**
 *
 * This function is specifically designed to handle and inspect defects, which
 * are critical failures in your program, such as unexpected runtime exceptions
 * or system-level errors. Unlike normal recoverable errors, defects typically
 * indicate serious issues that cannot be addressed through standard error
 * handling.
 *
 * When a defect occurs in an effect, the function you provide to this function
 * will be executed, allowing you to log, monitor, or handle the defect in some
 * way. Importantly, this does not alter the main result of the effect. If no
 * defect occurs, the effect behaves as if this function was not used.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * // Simulate a task that fails with a recoverable error
 * const task1: Effect.Effect<number, string> = Effect.fail("NetworkError")
 *
 * // tapDefect won't log anything because NetworkError is not a defect
 * const tapping1 = Effect.tapDefect(task1, (cause) =>
 *   Console.log(`defect: ${cause}`)
 * )
 *
 * Effect.runFork(tapping1)
 * // No Output
 *
 * // Simulate a severe failure in the system
 * const task2: Effect.Effect<number, string> = Effect.dieMessage(
 *   "Something went wrong"
 * )
 *
 * // Log the defect using tapDefect
 * const tapping2 = Effect.tapDefect(task2, (cause) =>
 *   Console.log(`defect: ${cause}`)
 * )
 *
 * Effect.runFork(tapping2)
 * // Output:
 * // defect: RuntimeException: Something went wrong
 * //   ... stack trace ...
 * ```
 *
 * @since 2.0.0
 * @category Sequencing
 */
const tapDefect = core_effect/* tapDefect */.xv;
/**
 * Execute a side effect on failure without modifying the original effect.
 *
 * **Details**
 *
 * This function allows you to inspect and react to the failure of an effect by
 * executing an additional effect. The failure value is passed to the provided
 * function, enabling you to log it, track it, or perform any other operation.
 * Importantly, the original failure remains intact and is re-propagated, so the
 * effect's behavior is unchanged.
 *
 * The side effect you provide is only executed when the effect fails. If the
 * effect succeeds, the function is ignored, and the success value is propagated
 * as usual.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * // Simulate a task that fails with an error
 * const task: Effect.Effect<number, string> = Effect.fail("NetworkError")
 *
 * // Use tapError to log the error message when the task fails
 * const tapping = Effect.tapError(task, (error) =>
 *   Console.log(`expected error: ${error}`)
 * )
 *
 * Effect.runFork(tapping)
 * // Output:
 * // expected error: NetworkError
 * ```
 *
 * @since 2.0.0
 * @category Sequencing
 */
const tapError = core_effect/* tapError */.sn;
/**
 * Inspect errors matching a specific tag without altering the original effect.
 *
 * **Details**
 *
 * This function allows you to inspect and handle specific error types based on
 * their `_tag` property. It is particularly useful in applications where errors
 * are modeled with tagged types (e.g., union types with discriminating tags).
 * By targeting errors with a specific `_tag`, you can log or perform actions on
 * them while leaving the error channel and overall effect unchanged.
 *
 * If the error doesn't match the specified tag, this function does nothing, and
 * the effect proceeds as usual.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * class NetworkError {
 *   readonly _tag = "NetworkError"
 *   constructor(readonly statusCode: number) {}
 * }
 *
 * class ValidationError {
 *   readonly _tag = "ValidationError"
 *   constructor(readonly field: string) {}
 * }
 *
 * // Create a task that fails with a NetworkError
 * const task: Effect.Effect<number, NetworkError | ValidationError> =
 *   Effect.fail(new NetworkError(504))
 *
 * // Use tapErrorTag to inspect only NetworkError types and log the status code
 * const tapping = Effect.tapErrorTag(task, "NetworkError", (error) =>
 *   Console.log(`expected error: ${error.statusCode}`)
 * )
 *
 * Effect.runFork(tapping)
 * // Output:
 * // expected error: 504
 * ```
 *
 * @since 2.0.0
 * @category Sequencing
 */
const tapErrorTag = core_effect/* tapErrorTag */.WO;
/**
 * Inspect the complete cause of an error, including failures and defects.
 *
 * **Details**
 *
 * This function provides access to the full cause of an error, including both
 * recoverable failures and irrecoverable defects. It allows you to handle, log,
 * or monitor specific error causes without modifying the result of the effect.
 * The full `Cause` object encapsulates the error and its contextual
 * information, making it useful for debugging and understanding failure
 * scenarios in complex workflows.
 *
 * The effect itself is not modified, and any errors or defects remain in the
 * error channel of the original effect.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * // Create a task that fails with a NetworkError
 * const task1: Effect.Effect<number, string> = Effect.fail("NetworkError")
 *
 * const tapping1 = Effect.tapErrorCause(task1, (cause) =>
 *   Console.log(`error cause: ${cause}`)
 * )
 *
 * Effect.runFork(tapping1)
 * // Output:
 * // error cause: Error: NetworkError
 *
 * // Simulate a severe failure in the system
 * const task2: Effect.Effect<number, string> = Effect.dieMessage(
 *   "Something went wrong"
 * )
 *
 * const tapping2 = Effect.tapErrorCause(task2, (cause) =>
 *   Console.log(`error cause: ${cause}`)
 * )
 *
 * Effect.runFork(tapping2)
 * // Output:
 * // error cause: RuntimeException: Something went wrong
 * //   ... stack trace ...
 * ```
 *
 * @since 2.0.0
 * @category Sequencing
 */
const tapErrorCause = core_effect/* tapErrorCause */.OM;
/**
 * Repeats an effect indefinitely until an error occurs.
 *
 * **Details**
 *
 * This function executes an effect repeatedly in an infinite loop. Each
 * iteration is executed sequentially, and the loop continues until the first
 * error occurs. If the effect succeeds, it starts over from the beginning. If
 * the effect fails, the error is propagated, and the loop stops.
 *
 * Be cautious when using this function, as it will run indefinitely unless an
 * error interrupts it. This makes it suitable for long-running processes or
 * continuous polling tasks, but you should ensure proper error handling or
 * combine it with other operators like `timeout` or `schedule` to prevent
 * unintentional infinite loops.
 *
 * @since 2.0.0
 * @category Repetition / Recursion
 */
const forever = core_effect/* forever */.Yo;
/**
 * Repeatedly updates a state through an effectful operation until a condition
 * is no longer met.
 *
 * **Details**
 *
 * This function provides a way to implement effectful loops, similar to a
 * `while` loop in JavaScript.
 *
 * ```ts skip-type-checking
 * let result = initial
 *
 * while (options.while(result)) {
 *   result = options.body(result)
 * }
 *
 * return result
 * ```
 *
 * It starts with an initial state, checks a
 * condition (`while`), and executes a body operation to update the state if the
 * condition evaluates to `true`. The process repeats until the condition
 * returns `false`.
 *
 * The state is passed between iterations, allowing the body operation to modify
 * it dynamically. The final state after the loop ends is returned as the result
 * of the effect.
 *
 * **When to Use**
 *
 * This is particularly useful for scenarios where looping logic involves
 * asynchronous or side-effectful operations, such as polling or iterative
 * computations that depend on external factors.
 *
 * **Example** (Effectful Iteration)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const result = Effect.iterate(
 *   // Initial result
 *   1,
 *   {
 *     // Condition to continue iterating
 *     while: (result) => result <= 5,
 *     // Operation to change the result
 *     body: (result) => Effect.succeed(result + 1)
 *   }
 * )
 *
 * Effect.runPromise(result).then(console.log)
 * // Output: 6
 * ```
 *
 * @since 2.0.0
 * @category Looping
 */
const iterate = core_effect/* iterate */.UP;
/**
 * Repeatedly executes a loop with a state, collecting results or discarding
 * them based on configuration.
 *
 * **Details**
 *
 * This function performs an effectful loop, starting with an initial state and
 * iterating as long as the `while` condition evaluates to `true`, similar to a
 * `while` loop in JavaScript.
 *
 * ```ts skip-type-checking
 * let state = initial
 * const result = []
 *
 * while (options.while(state)) {
 *   result.push(options.body(state)) // Perform the effectful operation
 *   state = options.step(state) // Update the state
 * }
 *
 * return result
 * ```
 *
 * During each iteration, the `step` function updates the state, and the `body`
 * effect is executed.
 *
 * The results of the body effect can be collected in an array or discarded
 * based on the `discard` option.
 *
 * **Discarding Intermediate Results**
 *
 * - If `discard` is `false` or not provided, the intermediate results are
 *   collected into an array and returned as the final result.
 * - If `discard` is `true`, the intermediate results are ignored, and the
 *   effect returns `void`.
 *
 * **When to Use**
 *
 * This is useful for implementing loops where you need to perform effectful
 * computations repeatedly, such as processing items in a list, generating
 * values, or performing iterative updates.
 *
 * **Example** (Looping with Collected Results)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * // A loop that runs 5 times, collecting each iteration's result
 * const result = Effect.loop(
 *   // Initial state
 *   1,
 *   {
 *     // Condition to continue looping
 *     while: (state) => state <= 5,
 *     // State update function
 *     step: (state) => state + 1,
 *     // Effect to be performed on each iteration
 *     body: (state) => Effect.succeed(state)
 *   }
 * )
 *
 * Effect.runPromise(result).then(console.log)
 * // Output: [1, 2, 3, 4, 5]
 * ```
 *
 * **Example** (Loop with Discarded Results)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const result = Effect.loop(
 *   // Initial state
 *   1,
 *   {
 *     // Condition to continue looping
 *     while: (state) => state <= 5,
 *     // State update function
 *     step: (state) => state + 1,
 *     // Effect to be performed on each iteration
 *     body: (state) => Console.log(`Currently at state ${state}`),
 *     // Discard intermediate results
 *     discard: true
 *   }
 * )
 *
 * Effect.runPromise(result).then(console.log)
 * // Output:
 * // Currently at state 1
 * // Currently at state 2
 * // Currently at state 3
 * // Currently at state 4
 * // Currently at state 5
 * // undefined
 * ```
 *
 * @since 2.0.0
 * @category Looping
 */
const loop = core_effect/* loop */.VX;
/**
 * Repeats an effect based on a specified schedule or until the first failure.
 *
 * **Details**
 *
 * This function executes an effect repeatedly according to the given schedule.
 * Each repetition occurs after the initial execution of the effect, meaning
 * that the schedule determines the number of additional repetitions. For
 * example, using `Schedule.once` will result in the effect being executed twice
 * (once initially and once as part of the repetition).
 *
 * If the effect succeeds, it is repeated according to the schedule. If it
 * fails, the repetition stops immediately, and the failure is returned.
 *
 * The schedule can also specify delays between repetitions, making it useful
 * for tasks like retrying operations with backoff, periodic execution, or
 * performing a series of dependent actions.
 *
 * You can combine schedules for more advanced repetition logic, such as adding
 * delays, limiting recursions, or dynamically adjusting based on the outcome of
 * each execution.
 *
 * **Example** (Success Example)
 *
 * ```ts
 * import { Effect, Schedule, Console } from "effect"
 *
 * const action = Console.log("success")
 * const policy = Schedule.addDelay(Schedule.recurs(2), () => "100 millis")
 * const program = Effect.repeat(action, policy)
 *
 * Effect.runPromise(program).then((n) => console.log(`repetitions: ${n}`))
 * ```
 *
 * **Example** (Failure Example)
 *
 * ```ts
 * import { Effect, Schedule } from "effect"
 *
 * let count = 0
 *
 * // Define an async effect that simulates an action with possible failures
 * const action = Effect.async<string, string>((resume) => {
 *   if (count > 1) {
 *     console.log("failure")
 *     resume(Effect.fail("Uh oh!"))
 *   } else {
 *     count++
 *     console.log("success")
 *     resume(Effect.succeed("yay!"))
 *   }
 * })
 *
 * const policy = Schedule.addDelay(Schedule.recurs(2), () => "100 millis")
 * const program = Effect.repeat(action, policy)
 *
 * Effect.runPromiseExit(program).then(console.log)
 * ```
 *
 * @since 2.0.0
 * @category Repetition / Recursion
 */
const repeat = schedule/* repeat_combined */.kq;
/**
 * Repeats an effect a specified number of times or until the first failure.
 *
 * **Details**
 *
 * This function executes an effect initially and then repeats it the specified
 * number of times, as long as it succeeds. For example, calling
 * `repeatN(action, 2)` will execute `action` once initially and then repeat it
 * two additional times if there are no failures.
 *
 * If the effect fails during any repetition, the failure is returned, and no
 * further repetitions are attempted.
 *
 * **When to Use**
 *
 * This function is useful for tasks that need to be retried a fixed number of
 * times or for performing repeated actions without requiring a schedule.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const action = Console.log("success")
 * const program = Effect.repeatN(action, 2)
 *
 * Effect.runPromise(program)
 * ```
 *
 * @since 2.0.0
 * @category Repetition / Recursion
 */
const repeatN = core_effect/* repeatN */.$I;
/**
 * Repeats an effect with a schedule, handling failures using a custom handler.
 *
 * **Details**
 *
 * This function allows you to execute an effect repeatedly based on a specified
 * schedule. If the effect fails at any point, a custom failure handler is
 * invoked. The handler is provided with both the failure value and the output
 * of the schedule at the time of failure. This enables advanced error recovery
 * or alternative fallback logic while maintaining flexibility in how
 * repetitions are handled.
 *
 * For example, using a schedule with `recurs(2)` will allow for two additional
 * repetitions after the initial execution, provided the effect succeeds. If a
 * failure occurs during any iteration, the failure handler is invoked to handle
 * the situation.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Schedule } from "effect"
 *
 * let count = 0
 *
 * // Define an async effect that simulates an action with possible failures
 * const action = Effect.async<string, string>((resume) => {
 *   if (count > 1) {
 *     console.log("failure")
 *     resume(Effect.fail("Uh oh!"))
 *   } else {
 *     count++
 *     console.log("success")
 *     resume(Effect.succeed("yay!"))
 *   }
 * })
 *
 * const policy = Schedule.addDelay(
 *   Schedule.recurs(2), // Repeat for a maximum of 2 times
 *   () => "100 millis" // Add a delay of 100 milliseconds between repetitions
 * )
 *
 * const program = Effect.repeatOrElse(action, policy, () =>
 *   Effect.sync(() => {
 *     console.log("orElse")
 *     return count - 1
 *   })
 * )
 *
 * Effect.runPromise(program).then((n) => console.log(`repetitions: ${n}`))
 * ```
 *
 * @since 2.0.0
 * @category Repetition / Recursion
 */
const repeatOrElse = schedule/* repeatOrElse_Effect */.rl;
/**
 * Repeats an effect based on a specified schedule.
 *
 * **Details**
 *
 * This function allows you to execute an effect repeatedly according to a given
 * schedule. The schedule determines the timing and number of repetitions. Each
 * repetition can also depend on the decision of the schedule, providing
 * flexibility for complex workflows. This function does not modify the effect's
 * success or failure; it only controls its repetition.
 *
 * For example, you can use a schedule that recurs a specific number of times,
 * adds delays between repetitions, or customizes repetition behavior based on
 * external inputs. The effect runs initially and is repeated according to the
 * schedule.
 *
 * @see {@link scheduleFrom} for a variant that allows the schedule's decision
 * to depend on the result of this effect.
 *
 * @since 2.0.0
 * @category Repetition / Recursion
 */
const Effect_schedule = schedule/* schedule_Effect */.fh;
/**
 * Runs an effect repeatedly on a new fiber according to a given schedule.
 *
 * **Details**
 *
 * This function starts the provided effect on a new fiber and runs it
 * repeatedly based on the specified schedule. The repetitions are managed by
 * the schedule's rules, which define the timing and number of iterations. The
 * fiber is attached to the current scope, meaning it is automatically managed
 * and cleaned up when the scope is closed.
 *
 * The function returns a `RuntimeFiber` that allows you to monitor or interact
 * with the running fiber.
 *
 * **When to Use**
 *
 * This is particularly useful for concurrent execution of scheduled tasks or
 * when you want to continue processing without waiting for the repetitions to
 * complete.
 *
 * @since 2.0.0
 * @category Repetition / Recursion
 */
const scheduleForked = circular/* scheduleForked */.Fw;
/**
 * Runs an effect repeatedly according to a schedule, starting from a specified
 * input value.
 *
 * **Details**
 *
 * This function allows you to repeatedly execute an effect based on a schedule.
 * The schedule starts with the given `initial` input value, which is passed to
 * the first execution. Subsequent executions of the effect are controlled by
 * the schedule's rules, using the output of the previous iteration as the input
 * for the next one.
 *
 * The returned effect will complete when the schedule ends or the effect fails,
 * propagating the error.
 *
 * @since 2.0.0
 * @category Repetition / Recursion
 */
const scheduleFrom = schedule/* scheduleFrom_Effect */.zW;
/**
 * @since 2.0.0
 * @category Repetition / Recursion
 */
const whileLoop = internal_core/* whileLoop */.Hib;
/**
 * Returns a collection of all `FiberRef` values for the fiber running this
 * effect.
 *
 * @since 2.0.0
 * @category Fiber Refs
 */
const getFiberRefs = core_effect/* fiberRefs */.tW;
/**
 * Inherits values from all `FiberRef` instances into current fiber.
 *
 * @since 2.0.0
 * @category Fiber Refs
 */
const inheritFiberRefs = core_effect/* inheritFiberRefs */.CT;
/**
 * @since 2.0.0
 * @category Fiber Refs
 */
const locally = internal_core/* fiberRefLocally */.EXC;
/**
 * @since 2.0.0
 * @category Fiber Refs
 */
const locallyWith = internal_core/* fiberRefLocallyWith */.LzL;
/**
 * @since 2.0.0
 * @category Fiber Refs
 */
const locallyScoped = internal_fiberRuntime/* fiberRefLocallyScoped */.tX;
/**
 * @since 2.0.0
 * @category Fiber Refs
 */
const locallyScopedWith = internal_fiberRuntime/* fiberRefLocallyScopedWith */.lS;
/**
 * Applies the specified changes to the `FiberRef` values for the fiber
 * running this workflow.
 *
 * @since 2.0.0
 * @category Fiber Refs
 */
const patchFiberRefs = core_effect/* patchFiberRefs */.au;
/**
 * Sets the `FiberRef` values for the fiber running this effect to the values
 * in the specified collection of `FiberRef` values.
 *
 * @since 2.0.0
 * @category Fiber Refs
 */
const setFiberRefs = core_effect/* setFiberRefs */.js;
/**
 * Updates the `FiberRef` values for the fiber running this effect using the
 * specified function.
 *
 * @since 2.0.0
 * @category Fiber Refs
 */
const updateFiberRefs = core_effect/* updateFiberRefs */.L;
/**
 * Checks if an effect has failed.
 *
 * **Details**
 *
 * This function evaluates whether an effect has resulted in a failure. It
 * returns a boolean value wrapped in an effect, with `true` indicating the
 * effect failed and `false` otherwise.
 *
 * The resulting effect cannot fail (`never` in the error channel) but retains
 * the context of the original effect.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const failure = Effect.fail("Uh oh!")
 *
 * console.log(Effect.runSync(Effect.isFailure(failure)))
 * // Output: true
 *
 * const defect = Effect.dieMessage("BOOM!")
 *
 * Effect.runSync(Effect.isFailure(defect))
 * // throws: BOOM!
 * ```
 *
 * @since 2.0.0
 * @category Condition Checking
 */
const isFailure = core_effect/* isFailure */.hx;
/**
 * Checks if an effect has succeeded.
 *
 * **Details**
 *
 * This function evaluates whether an effect has resulted in a success. It
 * returns a boolean value wrapped in an effect, with `true` indicating the
 * effect succeeded and `false` otherwise.
 *
 * The resulting effect cannot fail (`never` in the error channel) but retains
 * the context of the original effect.
 *
 * @since 2.0.0
 * @category Condition Checking
 */
const isSuccess = core_effect/* isSuccess */.d6;
/**
 * Handles both success and failure cases of an effect without performing side
 * effects.
 *
 * **Details**
 *
 * `match` lets you define custom handlers for both success and failure
 * scenarios. You provide separate functions to handle each case, allowing you
 * to process the result if the effect succeeds, or handle the error if the
 * effect fails.
 *
 * **When to Use**
 *
 * This is useful for structuring your code to respond differently to success or
 * failure without triggering side effects.
 *
 * **Example** (Handling Both Success and Failure Cases)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const success: Effect.Effect<number, Error> = Effect.succeed(42)
 *
 * const program1 = Effect.match(success, {
 *   onFailure: (error) => `failure: ${error.message}`,
 *   onSuccess: (value) => `success: ${value}`
 * })
 *
 * // Run and log the result of the successful effect
 * Effect.runPromise(program1).then(console.log)
 * // Output: "success: 42"
 *
 * const failure: Effect.Effect<number, Error> = Effect.fail(
 *   new Error("Uh oh!")
 * )
 *
 * const program2 = Effect.match(failure, {
 *   onFailure: (error) => `failure: ${error.message}`,
 *   onSuccess: (value) => `success: ${value}`
 * })
 *
 * // Run and log the result of the failed effect
 * Effect.runPromise(program2).then(console.log)
 * // Output: "failure: Uh oh!"
 * ```
 *
 * @see {@link matchEffect} if you need to perform side effects in the handlers.
 *
 * @since 2.0.0
 * @category Matching
 */
const match = core_effect/* match */.EQ;
/**
 * Handles failures by matching the cause of failure.
 *
 * **Details**
 *
 * The `matchCause` function allows you to handle failures with access to the
 * full cause of the failure within a fiber.
 *
 * **When to Use**
 *
 * This is useful for differentiating between different types of errors, such as
 * regular failures, defects, or interruptions. You can provide specific
 * handling logic for each failure type based on the cause.
 *
 * **Example** (Handling Different Failure Causes)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const task: Effect.Effect<number, Error> = Effect.die("Uh oh!")
 *
 * const program = Effect.matchCause(task, {
 *   onFailure: (cause) => {
 *     switch (cause._tag) {
 *       case "Fail":
 *         // Handle standard failure
 *         return `Fail: ${cause.error.message}`
 *       case "Die":
 *         // Handle defects (unexpected errors)
 *         return `Die: ${cause.defect}`
 *       case "Interrupt":
 *         // Handle interruption
 *         return `${cause.fiberId} interrupted!`
 *     }
 *     // Fallback for other causes
 *     return "failed due to other causes"
 *   },
 *   onSuccess: (value) =>
 *     // task completes successfully
 *     `succeeded with ${value} value`
 * })
 *
 * Effect.runPromise(program).then(console.log)
 * // Output: "Die: Uh oh!"
 * ```
 *
 * @see {@link matchCauseEffect} if you need to perform side effects in the
 * handlers.
 * @see {@link match} if you don't need to handle the cause of the failure.
 *
 * @since 2.0.0
 * @category Matching
 */
const matchCause = internal_core/* matchCause */.eYH;
/**
 * Handles failures with access to the cause and allows performing side effects.
 *
 * **Details**
 *
 * The `matchCauseEffect` function works similarly to {@link matchCause}, but it
 * also allows you to perform additional side effects based on the failure
 * cause. This function provides access to the complete cause of the failure,
 * making it possible to differentiate between various failure types, and allows
 * you to respond accordingly while performing side effects (like logging or
 * other operations).
 *
 * **Example** (Handling Different Failure Causes with Side Effects)
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const task: Effect.Effect<number, Error> = Effect.die("Uh oh!")
 *
 * const program = Effect.matchCauseEffect(task, {
 *   onFailure: (cause) => {
 *     switch (cause._tag) {
 *       case "Fail":
 *         // Handle standard failure with a logged message
 *         return Console.log(`Fail: ${cause.error.message}`)
 *       case "Die":
 *         // Handle defects (unexpected errors) by logging the defect
 *         return Console.log(`Die: ${cause.defect}`)
 *       case "Interrupt":
 *         // Handle interruption and log the fiberId that was interrupted
 *         return Console.log(`${cause.fiberId} interrupted!`)
 *     }
 *     // Fallback for other causes
 *     return Console.log("failed due to other causes")
 *   },
 *   onSuccess: (value) =>
 *     // Log success if the task completes successfully
 *     Console.log(`succeeded with ${value} value`)
 * })
 *
 * Effect.runPromise(program)
 * // Output: "Die: Uh oh!"
 * ```
 *
 * @see {@link matchCause} if you don't need side effects and only want to handle the result or failure.
 * @see {@link matchEffect} if you don't need to handle the cause of the failure.
 *
 * @since 2.0.0
 * @category Matching
 */
const matchCauseEffect = internal_core/* matchCauseEffect */.Bpg;
/**
 * Handles both success and failure cases of an effect, allowing for additional
 * side effects.
 *
 * **Details**
 *
 * The `matchEffect` function is similar to {@link match}, but it enables you to
 * perform side effects in the handlers for both success and failure outcomes.
 *
 * **When to Use**
 *
 * This is useful when you need to execute additional actions, like logging or
 * notifying users, based on whether an effect succeeds or fails.
 *
 * **Example** (Handling Both Success and Failure Cases with Side Effects)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const success: Effect.Effect<number, Error> = Effect.succeed(42)
 * const failure: Effect.Effect<number, Error> = Effect.fail(
 *   new Error("Uh oh!")
 * )
 *
 * const program1 = Effect.matchEffect(success, {
 *   onFailure: (error) =>
 *     Effect.succeed(`failure: ${error.message}`).pipe(
 *       Effect.tap(Effect.log)
 *     ),
 *   onSuccess: (value) =>
 *     Effect.succeed(`success: ${value}`).pipe(Effect.tap(Effect.log))
 * })
 *
 * console.log(Effect.runSync(program1))
 * // Output:
 * // timestamp=... level=INFO fiber=#0 message="success: 42"
 * // success: 42
 *
 * const program2 = Effect.matchEffect(failure, {
 *   onFailure: (error) =>
 *     Effect.succeed(`failure: ${error.message}`).pipe(
 *       Effect.tap(Effect.log)
 *     ),
 *   onSuccess: (value) =>
 *     Effect.succeed(`success: ${value}`).pipe(Effect.tap(Effect.log))
 * })
 *
 * console.log(Effect.runSync(program2))
 * // Output:
 * // timestamp=... level=INFO fiber=#1 message="failure: Uh oh!"
 * // failure: Uh oh!
 * ```
 *
 * @see {@link match} if you don't need side effects and only want to handle the
 * result or failure.
 *
 * @since 2.0.0
 * @category Matching
 */
const matchEffect = internal_core/* matchEffect */.PwY;
/**
 * Logs one or more messages or error causes at the current log level.
 *
 * **Details**
 *
 * This function provides a simple way to log messages or error causes during
 * the execution of your effects. By default, logs are recorded at the `INFO`
 * level, but this can be adjusted using other logging utilities
 * (`Logger.withMinimumLogLevel`). Multiple items, including `Cause` instances,
 * can be logged in a single call. When logging `Cause` instances, detailed
 * error information is included in the log output.
 *
 * The log output includes useful metadata like the current timestamp, log
 * level, and fiber ID, making it suitable for debugging and tracking purposes.
 * This function does not interrupt or alter the effect's execution flow.
 *
 * **Example**
 *
 * ```ts
 * import { Cause, Effect } from "effect"
 *
 * const program = Effect.log(
 *   "message1",
 *   "message2",
 *   Cause.die("Oh no!"),
 *   Cause.die("Oh uh!")
 * )
 *
 * Effect.runFork(program)
 * // Output:
 * // timestamp=... level=INFO fiber=#0 message=message1 message=message2 cause="Error: Oh no!
 * // Error: Oh uh!"
 * ```
 *
 * @since 2.0.0
 * @category Logging
 */
const Effect_log = core_effect/* log */.cM;
/**
 * Logs messages or error causes at a specified log level.
 *
 * **Details**
 *
 * This function allows you to log one or more messages or error causes while
 * specifying the desired log level (e.g., DEBUG, INFO, ERROR). It provides
 * flexibility in categorizing logs based on their importance or severity,
 * making it easier to filter logs during debugging or production monitoring.
 *
 * **Example**
 *
 * ```ts
 * import { Cause, Effect, LogLevel } from "effect"
 *
 * const program = Effect.logWithLevel(
 *   LogLevel.Error,
 *   "Critical error encountered",
 *   Cause.die("System failure!")
 * )
 *
 * Effect.runFork(program)
 * // Output:
 * // timestamp=... level=ERROR fiber=#0 message=Critical error encountered cause="Error: System failure!"
 * ```
 *
 * @since 2.0.0
 * @category Logging
 */
const logWithLevel = (level, ...message) => effect.logWithLevel(level)(...message);
/**
 * Logs messages at the TRACE log level.
 *
 * **Details**
 *
 * This function logs the specified messages at the TRACE level. TRACE logs are
 * typically used for very detailed diagnostic information. These messages are
 * not displayed by default. To view them, you must adjust the logging
 * configuration by setting the minimum log level to `LogLevel.Trace` using
 * `Logger.withMinimumLogLevel`.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Logger, LogLevel } from "effect"
 *
 * const program = Effect.logTrace("message1").pipe(Logger.withMinimumLogLevel(LogLevel.Trace))
 *
 * Effect.runFork(program)
 * // timestamp=... level=TRACE fiber=#0 message=message1
 * ```
 *
 * @since 2.0.0
 * @category Logging
 */
const logTrace = core_effect/* logTrace */.qn;
/**
 * Logs messages at the DEBUG log level.
 *
 * **Details**
 *
 * This function logs messages at the DEBUG level, which is typically used for
 * diagnosing application behavior during development. DEBUG messages provide
 * less detailed information than TRACE logs but are still not shown by default.
 * To view these logs, adjust the log level using `Logger.withMinimumLogLevel`.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Logger, LogLevel } from "effect"
 *
 * const program = Effect.logDebug("message1").pipe(Logger.withMinimumLogLevel(LogLevel.Debug))
 *
 * Effect.runFork(program)
 * // timestamp=... level=DEBUG fiber=#0 message=message1
 * ```
 *
 * @since 2.0.0
 * @category Logging
 */
const logDebug = core_effect/* logDebug */.o7;
/**
 * Logs messages at the INFO log level.
 *
 * **Details**
 *
 * This function logs messages at the INFO level, suitable for general
 * application events or operational messages. INFO logs are shown by default
 * and are commonly used for highlighting normal, non-error operations.
 *
 * @since 2.0.0
 * @category Logging
 */
const logInfo = core_effect/* logInfo */.PN;
/**
 * Logs messages at the WARNING log level.
 *
 * **Details**
 *
 * This function logs messages at the WARNING level, suitable for highlighting
 * potential issues that are not errors but may require attention. These
 * messages indicate that something unexpected occurred or might lead to errors
 * in the future.
 *
 * @since 2.0.0
 * @category Logging
 */
const logWarning = core_effect/* logWarning */.KE;
/**
 * Logs messages at the ERROR log level.
 *
 * **Details**
 *
 * This function logs messages at the ERROR level, suitable for reporting
 * application errors or failures. These logs are typically used for unexpected
 * issues that need immediate attention.
 *
 * @since 2.0.0
 * @category Logging
 */
const logError = core_effect/* logError */.H;
/**
 * Logs messages at the FATAL log level.
 *
 * **Details**
 *
 * This function logs messages at the FATAL level, suitable for reporting
 * critical errors that cause the application to terminate or stop functioning.
 * These logs are typically used for unrecoverable errors that require immediate
 * attention.
 *
 * @since 2.0.0
 * @category Logging
 */
const logFatal = core_effect/* logFatal */.qX;
/**
 * Adds a log span to an effect for tracking and logging its execution duration.
 *
 * **Details**
 *
 * This function wraps an effect with a log span, providing performance
 * monitoring and debugging capabilities. The log span tracks the duration of
 * the wrapped effect and logs it with the specified label. This is particularly
 * useful when analyzing time-sensitive operations or understanding the
 * execution time of specific tasks in your application.
 *
 * The logged output will include the label and the total time taken for the
 * operation. The span information is included in the log metadata, making it
 * easy to trace performance metrics in logs.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const program = Effect.gen(function*() {
 *   yield* Effect.sleep("1 second")
 *   yield* Effect.log("The job is finished!")
 * }).pipe(Effect.withLogSpan("myspan"))
 *
 * Effect.runFork(program)
 * // timestamp=... level=INFO fiber=#0 message="The job is finished!" myspan=1011ms
 * ```
 *
 * @since 2.0.0
 * @category Logging
 */
const withLogSpan = core_effect/* withLogSpan */.JP;
/**
 * Adds custom annotations to log entries generated within an effect.
 *
 * **Details**
 *
 * This function allows you to enhance log messages by appending additional
 * context in the form of key-value pairs. These annotations are included in
 * every log message created during the execution of the effect, making the logs
 * more informative and easier to trace.
 *
 * The annotations can be specified as a single key-value pair or as a record of
 * multiple key-value pairs. This is particularly useful for tracking
 * operations, debugging, or associating specific metadata with logs for better
 * observability.
 *
 * The annotated key-value pairs will appear alongside the log message in the
 * output.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const program = Effect.gen(function*() {
 *   yield* Effect.log("message1")
 *   yield* Effect.log("message2")
 * }).pipe(Effect.annotateLogs("taskId", "1234")) // Annotation as key/value pair
 *
 * Effect.runFork(program)
 * // timestamp=... level=INFO fiber=#0 message=message1 taskId=1234
 * // timestamp=... level=INFO fiber=#0 message=message2 taskId=1234
 * ```
 *
 * @see {@link annotateLogsScoped} to add log annotations with a limited scope.
 *
 * @since 2.0.0
 * @category Logging
 */
const annotateLogs = core_effect/* annotateLogs */.z;
/**
 * Adds log annotations with a limited scope to enhance contextual logging.
 *
 * **Details**
 *
 * This function allows you to apply key-value annotations to log entries
 * generated within a specific scope of your effect computations. The
 * annotations are restricted to the defined `Scope`, ensuring that they are
 * only applied to logs produced during that scope. Once the scope ends, the
 * annotations are automatically removed, making it easier to manage
 * context-specific logging without affecting other parts of your application.
 *
 * The annotations can be provided as a single key-value pair or as a record of
 * multiple key-value pairs. This flexibility enables fine-grained control over
 * the additional metadata included in logs for specific tasks or operations.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const program = Effect.gen(function*() {
 *   yield* Effect.log("no annotations")
 *   yield* Effect.annotateLogsScoped({ key: "value" })
 *   yield* Effect.log("message1") // Annotation is applied to this log
 *   yield* Effect.log("message2") // Annotation is applied to this log
 * }).pipe(Effect.scoped, Effect.andThen(Effect.log("no annotations again")))
 *
 * Effect.runFork(program)
 * // timestamp=... level=INFO fiber=#0 message="no annotations"
 * // timestamp=... level=INFO fiber=#0 message=message1 key=value
 * // timestamp=... level=INFO fiber=#0 message=message2 key=value
 * // timestamp=... level=INFO fiber=#0 message="no annotations again"
 * ```
 *
 * @see {@link annotateLogs} to add custom annotations to log entries generated within an effect.
 *
 * @since 3.1.0
 * @category Logging
 */
const annotateLogsScoped = internal_fiberRuntime/* annotateLogsScoped */.gA;
/**
 * Retrieves the current log annotations for the current scope.
 *
 * **Details**
 *
 * This function provides access to the log annotations associated with the
 * current scope. Log annotations are key-value pairs that provide additional
 * context to log entries. They are often used to add metadata such as tags,
 * identifiers, or extra debugging information to logs.
 *
 * By using this function, you can inspect or utilize the annotations applied to
 * the current scope, making it easier to trace and debug specific sections of
 * your application.
 *
 * @see {@link annotateLogs} to add custom annotations to log entries generated within an effect.
 * @see {@link annotateLogsScoped} to add log annotations with a limited scope.
 *
 * @since 2.0.0
 * @category Logging
 */
const logAnnotations = core_effect/* logAnnotations */.$F;
/**
 * Configures whether child fibers will log unhandled errors and at what log
 * level.
 *
 * **Details**
 *
 * This function allows you to control whether unhandled errors from child
 * fibers are logged and to specify the log level for these errors. By default,
 * unhandled errors are reported via the logger. However, using this function,
 * you can choose to suppress these logs by passing `Option.none` or adjust the
 * log level to a specific severity, such as `Error`, `Warning`, or `Info`.
 *
 * This configuration is scoped to the effect it is applied to, meaning the
 * changes only apply to the child fibers created within that effect's context.
 * It is especially useful when you want to reduce noise in logs or prioritize
 * certain types of errors.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Fiber, LogLevel, Option } from "effect"
 *
 * const program = Effect.gen(function*() {
 *   const fiber = yield* Effect.fork(Effect.fail("Unhandled error!"))
 *   yield* Fiber.join(fiber)
 * })
 *
 * Effect.runFork(program.pipe(Effect.withUnhandledErrorLogLevel(Option.some(LogLevel.Error))))
 * // Output:
 * // timestamp=... level=ERROR fiber=#1 message="Fiber terminated with an unhandled error" cause="Error: Unhandled error!"
 * ```
 *
 * @since 2.0.0
 * @category Logging
 */
const withUnhandledErrorLogLevel = internal_core/* withUnhandledErrorLogLevel */.uw7;
/**
 * Conditionally executes an effect based on the specified log level and currently enabled log level.
 *
 * **Details**
 *
 * This function runs the provided effect only if the specified log level is
 * enabled. If the log level is enabled, the effect is executed and its result
 * is wrapped in `Some`. If the log level is not enabled, the effect is not
 * executed and `None` is returned.
 *
 * This function is useful for conditionally executing logging-related effects
 * or other operations that depend on the current log level configuration.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Logger, LogLevel } from "effect"
 *
 * const program = Effect.gen(function* () {
 *   yield* Effect.whenLogLevel(Effect.logTrace("message1"), LogLevel.Trace); // returns `None`
 *   yield* Effect.whenLogLevel(Effect.logDebug("message2"), LogLevel.Debug); // returns `Some`
 * }).pipe(Logger.withMinimumLogLevel(LogLevel.Debug));
 *
 * Effect.runFork(program)
 * // timestamp=... level=DEBUG fiber=#0 message=message2
 * ```
 *
 * @see {@link FiberRef.currentMinimumLogLevel} to retrieve the current minimum log level.
 *
 * @since 3.13.0
 * @category Logging
 */
const whenLogLevel = internal_fiberRuntime/* whenLogLevel */.fH;
/**
 * Converts an effect's failure into a fiber termination, removing the error
 * from the effect's type.
 *
 * **Details**
 *
 * The `orDie` function is used when you encounter errors that you do not want
 * to handle or recover from. It removes the error type from the effect and
 * ensures that any failure will terminate the fiber. This is useful for
 * propagating failures as defects, signaling that they should not be handled
 * within the effect.
 *
 * **When to Use*
 *
 * Use `orDie` when failures should be treated as unrecoverable defects and no
 * error handling is required.
 *
 * **Example** (Propagating an Error as a Defect)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const divide = (a: number, b: number) =>
 *   b === 0
 *     ? Effect.fail(new Error("Cannot divide by zero"))
 *     : Effect.succeed(a / b)
 *
 * //      ┌─── Effect<number, never, never>
 * //      ▼
 * const program = Effect.orDie(divide(1, 0))
 *
 * Effect.runPromise(program).catch(console.error)
 * // Output:
 * // (FiberFailure) Error: Cannot divide by zero
 * //   ...stack trace...
 * ```
 *
 * @see {@link orDieWith} if you need to customize the error.
 *
 * @since 2.0.0
 * @category Converting Failures to Defects
 */
const orDie = internal_core/* orDie */.e3I;
/**
 * Converts an effect's failure into a fiber termination with a custom error.
 *
 * **Details**
 *
 * The `orDieWith` function behaves like {@link orDie}, but it allows you to provide a mapping
 * function to transform the error before terminating the fiber. This is useful for cases where
 * you want to include a more detailed or user-friendly error when the failure is propagated
 * as a defect.
 *
 * **When to Use**
 *
 * Use `orDieWith` when failures should terminate the fiber as defects, and you want to customize
 * the error for clarity or debugging purposes.
 *
 * **Example** (Customizing Defect)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const divide = (a: number, b: number) =>
 *   b === 0
 *     ? Effect.fail(new Error("Cannot divide by zero"))
 *     : Effect.succeed(a / b)
 *
 * //      ┌─── Effect<number, never, never>
 * //      ▼
 * const program = Effect.orDieWith(
 *   divide(1, 0),
 *   (error) => new Error(`defect: ${error.message}`)
 * )
 *
 * Effect.runPromise(program).catch(console.error)
 * // Output:
 * // (FiberFailure) Error: defect: Cannot divide by zero
 * //   ...stack trace...
 * ```
 *
 * @see {@link orDie} if you don't need to customize the error.
 *
 * @since 2.0.0
 * @category Converting Failures to Defects
 */
const orDieWith = internal_core/* orDieWith */.war;
/**
 * Attempts one effect, and if it fails, falls back to another effect.
 *
 * **Details**
 *
 * This function allows you to try executing an effect, and if it fails
 * (produces an error), a fallback effect is executed instead. The fallback
 * effect is defined as a lazy argument, meaning it will only be evaluated if
 * the first effect fails. This provides a way to recover from errors by
 * specifying an alternative path of execution.
 *
 * The error type of the resulting effect will be that of the fallback effect,
 * as the first effect's error is replaced when the fallback is executed.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const success = Effect.succeed("success")
 * const failure = Effect.fail("failure")
 * const fallback = Effect.succeed("fallback")
 *
 * // Try the success effect first, fallback is not used
 * const program1 = Effect.orElse(success, () => fallback)
 * console.log(Effect.runSync(program1))
 * // Output: "success"
 *
 * // Try the failure effect first, fallback is used
 * const program2 = Effect.orElse(failure, () => fallback)
 * console.log(Effect.runSync(program2))
 * // Output: "fallback"
 * ```
 *
 * @see {@link catchAll} if you need to access the error in the fallback effect.
 *
 * @since 2.0.0
 * @category Fallback
 */
const orElse = internal_core/* orElse */.vxS;
/**
 * Replaces the failure of an effect with a custom failure value.
 *
 * **Details**
 *
 * This function allows you to handle the failure of an effect by replacing it
 * with a predefined failure value. If the effect fails, the new failure value
 * provided by the `evaluate` function will be returned instead of the original
 * failure. If the effect succeeds, the original success value is returned
 * unchanged.
 *
 * **When to Use**
 *
 * This is particularly useful when you want to standardize error handling or
 * provide a consistent failure value for specific operations. It simplifies
 * error management by ensuring that all failures are replaced with a controlled
 * alternative.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const validate = (age: number): Effect.Effect<number, string> => {
 *   if (age < 0) {
 *     return Effect.fail("NegativeAgeError")
 *   } else if (age < 18) {
 *     return Effect.fail("IllegalAgeError")
 *   } else {
 *     return Effect.succeed(age)
 *   }
 * }
 *
 * const program = Effect.orElseFail(validate(-1), () => "invalid age")
 *
 * console.log(Effect.runSyncExit(program))
 * // Output:
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: { _id: 'Cause', _tag: 'Fail', failure: 'invalid age' }
 * // }
 * ```
 *
 * @see {@link mapError} if you need to access the error to transform it.
 *
 * @since 2.0.0
 * @category Fallback
 */
const orElseFail = core_effect/* orElseFail */.LP;
/**
 * Ensures the effect always succeeds by replacing failures with a default
 * success value.
 *
 * **Details**
 *
 * This function transforms an effect that may fail into one that cannot fail by
 * replacing any failure with a provided success value. If the original effect
 * fails, the failure is "swallowed," and the specified success value is
 * returned instead. If the original effect succeeds, its value remains
 * unchanged.
 *
 * **When to Use**
 *
 * This is especially useful for providing default values in case of failure,
 * ensuring that an effect always completes successfully. By using this
 * function, you can avoid the need for complex error handling and guarantee a
 * fallback result.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const validate = (age: number): Effect.Effect<number, string> => {
 *   if (age < 0) {
 *     return Effect.fail("NegativeAgeError")
 *   } else if (age < 18) {
 *     return Effect.fail("IllegalAgeError")
 *   } else {
 *     return Effect.succeed(age)
 *   }
 * }
 *
 * const program = Effect.orElseSucceed(validate(-1), () => 18)
 *
 * console.log(Effect.runSyncExit(program))
 * // Output:
 * // { _id: 'Exit', _tag: 'Success', value: 18 }
 * ```
 *
 * @since 2.0.0
 * @category Fallback
 */
const orElseSucceed = core_effect/* orElseSucceed */.pt;
/**
 * Runs a sequence of effects and returns the result of the first successful
 * one.
 *
 * **Details**
 *
 * This function allows you to execute a collection of effects in sequence,
 * stopping at the first success. If an effect succeeds, its result is
 * immediately returned, and no further effects in the sequence are executed.
 * However, if all the effects fail, the function will return the error of the
 * last effect.
 *
 * The execution is sequential, meaning that effects are evaluated one at a time
 * in the order they are provided. This ensures predictable behavior and avoids
 * unnecessary computations.
 *
 * If the collection of effects is empty, an `IllegalArgumentException` is
 * thrown, indicating that the operation is invalid without any effects to try.
 *
 * **When to Use**
 *
 * This is particularly useful when you have multiple fallback strategies or
 * alternative sources to obtain a result, such as attempting multiple APIs,
 * retrieving configurations, or accessing resources in a prioritized manner.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * interface Config {
 *   host: string
 *   port: number
 *   apiKey: string
 * }
 *
 * // Create a configuration object with sample values
 * const makeConfig = (name: string): Config => ({
 *   host: `${name}.example.com`,
 *   port: 8080,
 *   apiKey: "12345-abcde"
 * })
 *
 * // Simulate retrieving configuration from a remote node
 * const remoteConfig = (name: string): Effect.Effect<Config, Error> =>
 *   Effect.gen(function* () {
 *     // Simulate node3 being the only one with available config
 *     if (name === "node3") {
 *       yield* Console.log(`Config for ${name} found`)
 *       return makeConfig(name)
 *     } else {
 *       yield* Console.log(`Unavailable config for ${name}`)
 *       return yield* Effect.fail(new Error(`Config not found for ${name}`))
 *     }
 *   })
 *
 * // Define the master configuration and potential fallback nodes
 * const masterConfig = remoteConfig("master")
 * const nodeConfigs = ["node1", "node2", "node3", "node4"].map(remoteConfig)
 *
 * // Attempt to find a working configuration,
 * // starting with the master and then falling back to other nodes
 * const config = Effect.firstSuccessOf([masterConfig, ...nodeConfigs])
 *
 * // Run the effect to retrieve the configuration
 * const result = Effect.runSync(config)
 *
 * console.log(result)
 * // Output:
 * // Unavailable config for master
 * // Unavailable config for node1
 * // Unavailable config for node2
 * // Config for node3 found
 * // { host: 'node3.example.com', port: 8080, apiKey: '12345-abcde' }
 * ```
 *
 * @since 2.0.0
 * @category Fallback
 */
const firstSuccessOf = core_effect/* firstSuccessOf */.n7;
/**
 * Retrieves the `Random` service from the context.
 *
 * @since 2.0.0
 * @category Random
 */
const random = core_effect/* random */.MX;
/**
 * Retrieves the `Random` service from the context and uses it to run the
 * specified effect.
 *
 * @since 2.0.0
 * @category Random
 */
const randomWith = internal_defaultServices/* randomWith */.MD;
/**
 * Executes the specified effect with the specified implementation of the
 * `Random` service.
 *
 * @since 2.0.0
 * @category Random
 */
const withRandom = internal_defaultServices/* withRandom */.Z0;
/**
 * Sets the implementation of the `Random` service to the specified value and
 * restores it to its original value when the scope is closed.
 *
 * @since 2.0.0
 * @category Random
 */
const withRandomScoped = internal_fiberRuntime/* withRandomScoped */.vY;
/**
 * Returns an effect that accesses the runtime, which can be used to (unsafely)
 * execute tasks.
 *
 * **When to Use**
 *
 * This is useful for integration with legacy code that must call back into
 * Effect code.
 *
 * @since 2.0.0
 * @category Runtime
 */
const Effect_runtime = runtime/* runtime */.GZ;
/**
 * Retrieves an effect that succeeds with the current runtime flags, which
 * govern behavior and features of the runtime system.
 *
 * @since 2.0.0
 * @category Runtime
 */
const getRuntimeFlags = internal_core/* runtimeFlags */.CpT;
/**
 * @since 2.0.0
 * @category Runtime
 */
const patchRuntimeFlags = internal_core/* updateRuntimeFlags */.$Cr;
/**
 * @since 2.0.0
 * @category Runtime
 */
const withRuntimeFlagsPatch = internal_core/* withRuntimeFlags */.ZYt;
/**
 * @since 2.0.0
 * @category Runtime
 */
const withRuntimeFlagsPatchScoped = internal_fiberRuntime/* withRuntimeFlagsScoped */.fn;
/**
 * Tags each metric in an effect with specific key-value pairs.
 *
 * **Details**
 *
 * This function allows you to tag all metrics in an effect with a set of
 * key-value pairs or a single key-value pair. Tags help you add metadata to
 * metrics, making it easier to filter and categorize them in monitoring
 * systems. The provided tags will apply to all metrics generated within the
 * effect's scope.
 *
 * @since 2.0.0
 * @category Metrics
 */
const tagMetrics = core_effect/* tagMetrics */._t;
/**
 * Adds labels to metrics within an effect using `MetricLabel` objects.
 *
 * **Details**
 *
 * This function allows you to label metrics using `MetricLabel` objects. Labels
 * help add structured metadata to metrics for categorization and filtering in
 * monitoring systems. The provided labels will apply to all metrics within the
 * effect's execution.
 *
 * @since 2.0.0
 * @category Metrics
 */
const labelMetrics = core_effect/* labelMetrics */.mX;
/**
 * Tags metrics within a scope with a specific key-value pair.
 *
 * **Details**
 *
 * This function tags all metrics within a scope with the provided key-value
 * pair. Once the scope is closed, the tag is automatically removed. This is
 * useful for applying temporary context-specific tags to metrics during scoped
 * operations.
 *
 * @since 2.0.0
 * @category Metrics
 */
const tagMetricsScoped = internal_fiberRuntime/* tagMetricsScoped */.en;
/**
 * Adds labels to metrics within a scope using `MetricLabel` objects.
 *
 * **Details**
 *
 * This function allows you to apply labels to all metrics generated within a
 * specific scope using an array of `MetricLabel` objects. These labels provide
 * additional metadata to metrics, which can be used for categorization,
 * filtering, or monitoring purposes. The labels are scoped and will be removed
 * automatically once the scope is closed, ensuring they are only applied
 * temporarily within the defined context.
 *
 * @since 2.0.0
 * @category Metrics
 */
const labelMetricsScoped = internal_fiberRuntime/* labelMetricsScoped */.Ld;
/**
 * Retrieves the metric labels associated with the current scope.
 *
 * @since 2.0.0
 * @category Metrics
 */
const metricLabels = internal_core/* metricLabels */.x_F;
/**
 * Associates a metric with the current effect, updating it as the effect progresses.
 *
 * @since 2.0.0
 * @category Metrics
 */
const withMetric = core_effect/* withMetric */.yz;
/**
 * Unsafely creates a new Semaphore.
 *
 * @since 2.0.0
 * @category Semaphore
 */
const unsafeMakeSemaphore = circular/* unsafeMakeSemaphore */.Ct;
/**
 * Creates a new semaphore with the specified number of permits.
 *
 * **Details**
 *
 * This function initializes a semaphore that controls concurrent access to a
 * shared resource. The number of permits determines how many tasks can access
 * the resource concurrently.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * // Create a semaphore with 3 permits
 * const mutex = Effect.makeSemaphore(3)
 * ```
 *
 * @since 2.0.0
 * @category Semaphore
 */
const makeSemaphore = circular/* makeSemaphore */.Fi;
/**
 * @category Latch
 * @since 3.8.0
 */
const unsafeMakeLatch = circular/* unsafeMakeLatch */.db;
/**
 * Creates a new `Latch`, starting in the specified state.
 *
 * **Details**
 *
 * This function initializes a `Latch` safely, ensuring proper runtime
 * guarantees. By default, the latch starts in the closed state.
 *
 * **Example**
 *
 * ```ts
 * import { Console, Effect } from "effect"
 *
 * const program = Effect.gen(function*() {
 *   // Create a latch, starting in the closed state
 *   const latch = yield* Effect.makeLatch(false)
 *
 *   // Fork a fiber that logs "open sesame" when the latch is opened
 *   const fiber = yield* Console.log("open sesame").pipe(
 *     latch.whenOpen,
 *     Effect.fork
 *   )
 *
 *   yield* Effect.sleep("1 second")
 *
 *   // Open the latch
 *   yield* latch.open
 *   yield* fiber.await
 * })
 *
 * Effect.runFork(program)
 * // Output: open sesame (after 1 second)
 * ```
 *
 * @category Latch
 * @since 3.8.0
 */
const makeLatch = circular/* makeLatch */.vM;
/**
 * Runs an effect in the background, returning a fiber that can be observed or
 * interrupted.
 *
 * Unless you specifically need a `Promise` or synchronous operation, `runFork`
 * is a good default choice.
 *
 * **Details**
 *
 * This function is the foundational way to execute an effect in the background.
 * It creates a "fiber," a lightweight, cooperative thread of execution that can
 * be observed (to access its result), interrupted, or joined. Fibers are useful
 * for concurrent programming and allow effects to run independently of the main
 * program flow.
 *
 * Once the effect is running in a fiber, you can monitor its progress, cancel
 * it if necessary, or retrieve its result when it completes. If the effect
 * fails, the fiber will propagate the failure, which you can observe and
 * handle.
 *
 * **When to Use**
 *
 * Use this function when you need to run an effect in the background,
 * especially if the effect is long-running or performs periodic tasks. It's
 * suitable for tasks that need to run independently but might still need
 * observation or management, like logging, monitoring, or scheduled tasks.
 *
 * This function is ideal if you don't need the result immediately or if the
 * effect is part of a larger concurrent workflow.
 *
 * **Example** (Running an Effect in the Background)
 *
 * ```ts
 * import { Effect, Console, Schedule, Fiber } from "effect"
 *
 * //      ┌─── Effect<number, never, never>
 * //      ▼
 * const program = Effect.repeat(
 *   Console.log("running..."),
 *   Schedule.spaced("200 millis")
 * )
 *
 * //      ┌─── RuntimeFiber<number, never>
 * //      ▼
 * const fiber = Effect.runFork(program)
 *
 * setTimeout(() => {
 *   Effect.runFork(Fiber.interrupt(fiber))
 * }, 500)
 * ```
 *
 * @since 2.0.0
 * @category Running Effects
 */
const runFork = runtime/* unsafeForkEffect */.m5;
/**
 * Executes an effect asynchronously and handles the result using a callback.
 *
 * **Details**
 *
 * This function runs an effect asynchronously and passes the result (`Exit`) to
 * a specified callback. The callback is invoked with the outcome of the effect:
 * - On success, the callback receives the successful result.
 * - On failure, the callback receives the failure information.
 *
 * **When to Use**
 *
 * This function is effectful and should only be invoked at the edges of your
 * program.
 *
 * @since 2.0.0
 * @category Running Effects
 */
const runCallback = runtime/* unsafeRunEffect */.pd;
/**
 * Executes an effect and returns the result as a `Promise`.
 *
 * **Details**
 *
 * This function runs an effect and converts its result into a `Promise`. If the
 * effect succeeds, the `Promise` will resolve with the successful result. If
 * the effect fails, the `Promise` will reject with an error, which includes the
 * failure details of the effect.
 *
 * The optional `options` parameter allows you to pass an `AbortSignal` for
 * cancellation, enabling more fine-grained control over asynchronous tasks.
 *
 * **When to Use**
 *
 * Use this function when you need to execute an effect and work with its result
 * in a promise-based system, such as when integrating with third-party
 * libraries that expect `Promise` results.
 *
 * **Example** (Running a Successful Effect as a Promise)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * Effect.runPromise(Effect.succeed(1)).then(console.log)
 * // Output: 1
 * ```
 *
 * **Example** (Handling a Failing Effect as a Rejected Promise)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * Effect.runPromise(Effect.fail("my error")).catch(console.error)
 * // Output:
 * // (FiberFailure) Error: my error
 * ```
 *
 * @see {@link runPromiseExit} for a version that returns an `Exit` type instead
 * of rejecting.
 *
 * @since 2.0.0
 * @category Running Effects
 */
const runPromise = runtime/* unsafeRunPromiseEffect */.GB;
/**
 * Runs an effect and returns a `Promise` that resolves to an `Exit`,
 * representing the outcome.
 *
 * **Details**
 *
 * This function executes an effect and resolves to an `Exit` object. The `Exit`
 * type provides detailed information about the result of the effect:
 * - If the effect succeeds, the `Exit` will be of type `Success` and include
 *   the value produced by the effect.
 * - If the effect fails, the `Exit` will be of type `Failure` and contain a
 *   `Cause` object, detailing the failure.
 *
 * Using this function allows you to examine both successful results and failure
 * cases in a unified way, while still leveraging `Promise` for handling the
 * asynchronous behavior of the effect.
 *
 * **When to Use**
 *
 * Use this function when you need to understand the outcome of an effect,
 * whether it succeeded or failed, and want to work with this result using
 * `Promise` syntax. This is particularly useful when integrating with systems
 * that rely on promises but need more detailed error handling than a simple
 * rejection.
 *
 * **Example** (Handling Results as Exit)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * // Execute a successful effect and get the Exit result as a Promise
 * Effect.runPromiseExit(Effect.succeed(1)).then(console.log)
 * // Output:
 * // {
 * //   _id: "Exit",
 * //   _tag: "Success",
 * //   value: 1
 * // }
 *
 * // Execute a failing effect and get the Exit result as a Promise
 * Effect.runPromiseExit(Effect.fail("my error")).then(console.log)
 * // Output:
 * // {
 * //   _id: "Exit",
 * //   _tag: "Failure",
 * //   cause: {
 * //     _id: "Cause",
 * //     _tag: "Fail",
 * //     failure: "my error"
 * //   }
 * // }
 * ```
 *
 * @since 2.0.0
 * @category Running Effects
 */
const runPromiseExit = runtime/* unsafeRunPromiseExitEffect */.p6;
/**
 * Executes an effect synchronously, running it immediately and returning the
 * result.
 *
 * **Details**
 *
 * This function evaluates the provided effect synchronously, returning its
 * result directly. It is ideal for effects that do not fail or include
 * asynchronous operations. If the effect does fail or involves async tasks, it
 * will throw an error. Execution stops at the point of failure or asynchronous
 * operation, making it unsuitable for effects that require asynchronous
 * handling.
 *
 * **Important**: Attempting to run effects that involve asynchronous operations
 * or failures will result in exceptions being thrown, so use this function with
 * care for purely synchronous and error-free effects.
 *
 * **When to Use**
 *
 * Use this function when:
 * - You are sure that the effect will not fail or involve asynchronous
 *   operations.
 * - You need a direct, synchronous result from the effect.
 * - You are working within a context where asynchronous effects are not
 *   allowed.
 *
 * Avoid using this function for effects that can fail or require asynchronous
 * handling. For such cases, consider using {@link runPromise} or
 * {@link runSyncExit}.
 *
 * **Example** (Synchronous Logging)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const program = Effect.sync(() => {
 *   console.log("Hello, World!")
 *   return 1
 * })
 *
 * const result = Effect.runSync(program)
 * // Output: Hello, World!
 *
 * console.log(result)
 * // Output: 1
 * ```
 *
 * **Example** (Incorrect Usage with Failing or Async Effects)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * try {
 *   // Attempt to run an effect that fails
 *   Effect.runSync(Effect.fail("my error"))
 * } catch (e) {
 *   console.error(e)
 * }
 * // Output:
 * // (FiberFailure) Error: my error
 *
 * try {
 *   // Attempt to run an effect that involves async work
 *   Effect.runSync(Effect.promise(() => Promise.resolve(1)))
 * } catch (e) {
 *   console.error(e)
 * }
 * // Output:
 * // (FiberFailure) AsyncFiberException: Fiber #0 cannot be resolved synchronously. This is caused by using runSync on an effect that performs async work
 * ```
 *
 * @see {@link runSyncExit} for a version that returns an `Exit` type instead of
 * throwing an error.
 *
 * @since 2.0.0
 * @category Running Effects
 */
const runSync = runtime/* unsafeRunSyncEffect */.I7;
/**
 * Runs an effect synchronously and returns the result as an `Exit` type.
 *
 * **Details**
 *
 * This function executes the provided effect synchronously and returns an `Exit`
 * type that encapsulates the outcome of the effect:
 * - If the effect succeeds, the result is wrapped in a `Success`.
 * - If the effect fails, it returns a `Failure` containing a `Cause` that explains
 *   the failure.
 *
 * If the effect involves asynchronous operations, this function will return a `Failure`
 * with a `Die` cause, indicating that it cannot resolve the effect synchronously.
 * This makes the function suitable for use only with effects that are synchronous
 * in nature.
 *
 * **When to Use**
 *
 * Use this function when:
 * - You want to handle both success and failure outcomes in a structured way using the `Exit` type.
 * - You are working with effects that are purely synchronous and do not involve asynchronous operations.
 * - You need to debug or inspect failures, including their causes, in a detailed manner.
 *
 * Avoid using this function for effects that involve asynchronous operations, as it will fail with a `Die` cause.
 *
 * **Example** (Handling Results as Exit)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * console.log(Effect.runSyncExit(Effect.succeed(1)))
 * // Output:
 * // {
 * //   _id: "Exit",
 * //   _tag: "Success",
 * //   value: 1
 * // }
 *
 * console.log(Effect.runSyncExit(Effect.fail("my error")))
 * // Output:
 * // {
 * //   _id: "Exit",
 * //   _tag: "Failure",
 * //   cause: {
 * //     _id: "Cause",
 * //     _tag: "Fail",
 * //     failure: "my error"
 * //   }
 * // }
 * ```
 *
 * **Example** (Asynchronous Operation Resulting in Die)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * console.log(Effect.runSyncExit(Effect.promise(() => Promise.resolve(1))))
 * // Output:
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: {
 * //     _id: 'Cause',
 * //     _tag: 'Die',
 * //     defect: [Fiber #0 cannot be resolved synchronously. This is caused by using runSync on an effect that performs async work] {
 * //       fiber: [FiberRuntime],
 * //       _tag: 'AsyncFiberException',
 * //       name: 'AsyncFiberException'
 * //     }
 * //   }
 * // }
 * ```
 *
 * @since 2.0.0
 * @category Running Effects
 */
const runSyncExit = runtime/* unsafeRunSyncExitEffect */.uv;
/**
 * Combines multiple effects and accumulates both successes and failures.
 *
 * **Details**
 *
 * This function allows you to combine multiple effects, continuing through all
 * effects even if some of them fail. Unlike other functions that stop execution
 * upon encountering an error, this function collects all errors into a `Cause`.
 * The final result includes all successes and the accumulated failures.
 *
 * By default, effects are executed sequentially, but you can control
 * concurrency and batching behavior using the `options` parameter. This
 * provides flexibility in scenarios where you want to maximize performance or
 * ensure specific ordering.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Console } from "effect"
 *
 * const task1 = Console.log("task1").pipe(Effect.as(1))
 * const task2 = Effect.fail("Oh uh!").pipe(Effect.as(2))
 * const task3 = Console.log("task2").pipe(Effect.as(3))
 * const task4 = Effect.fail("Oh no!").pipe(Effect.as(4))
 *
 * const program = task1.pipe(
 *   Effect.validate(task2),
 *   Effect.validate(task3),
 *   Effect.validate(task4)
 * )
 *
 * Effect.runPromiseExit(program).then(console.log)
 * // Output:
 * // task1
 * // task2
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: {
 * //     _id: 'Cause',
 * //     _tag: 'Sequential',
 * //     left: { _id: 'Cause', _tag: 'Fail', failure: 'Oh uh!' },
 * //     right: { _id: 'Cause', _tag: 'Fail', failure: 'Oh no!' }
 * //   }
 * // }
 * ```
 *
 * @see {@link zip} for a version that stops at the first error.
 *
 * @since 2.0.0
 * @category Error Accumulation
 */
const validate = internal_fiberRuntime/* validate */.Gu;
/**
 * Sequentially combines two effects using a specified combiner function while
 * accumulating errors.
 *
 * **Details**
 *
 * This function combines two effects, `self` and `that`, into a single effect
 * by applying the provided combiner function to their results. If both effects
 * succeed, the combiner function is applied to their results to produce the
 * final value. If either effect fails, the failures are accumulated into a
 * combined `Cause`.
 *
 * By default, effects are executed sequentially. However, the execution mode
 * can be controlled using the `options` parameter to enable concurrency,
 * batching, or customized finalizer behavior.
 *
 * @since 2.0.0
 * @category Error Accumulation
 */
const validateWith = internal_fiberRuntime/* validateWith */.QV;
/**
 * Combines two effects into a single effect, producing a tuple of their
 * results.
 *
 * **Details**
 *
 * This function combines two effects, `self` and `that`, into one. It executes
 * the first effect (`self`) and then the second effect (`that`), collecting
 * their results into a tuple. Both effects must succeed for the resulting
 * effect to succeed. If either effect fails, the entire operation fails.
 *
 * By default, the effects are executed sequentially. If the `concurrent` option
 * is set to `true`, the effects will run concurrently, potentially improving
 * performance for independent operations.
 *
 * **Example** (Combining Two Effects Sequentially)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const task1 = Effect.succeed(1).pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Effect.log("task1 done"))
 * )
 * const task2 = Effect.succeed("hello").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Effect.log("task2 done"))
 * )
 *
 * // Combine the two effects together
 * //
 * //      ┌─── Effect<[number, string], never, never>
 * //      ▼
 * const program = Effect.zip(task1, task2)
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // timestamp=... level=INFO fiber=#0 message="task1 done"
 * // timestamp=... level=INFO fiber=#0 message="task2 done"
 * // [ 1, 'hello' ]
 * ```
 *
 * **Example** (Combining Two Effects Concurrently)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const task1 = Effect.succeed(1).pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Effect.log("task1 done"))
 * )
 * const task2 = Effect.succeed("hello").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Effect.log("task2 done"))
 * )
 *
 * // Run both effects concurrently using the concurrent option
 * const program = Effect.zip(task1, task2, { concurrent: true })
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // timestamp=... level=INFO fiber=#0 message="task2 done"
 * // timestamp=... level=INFO fiber=#0 message="task1 done"
 * // [ 1, 'hello' ]
 * ```
 *
 * @see {@link zipWith} for a version that combines the results with a custom
 * function.
 * @see {@link validate} for a version that accumulates errors.
 *
 * @since 2.0.0
 * @category Zipping
 */
const zip = internal_fiberRuntime/* zipOptions */.Jq;
/**
 * Executes two effects sequentially, returning the result of the first effect
 * and ignoring the result of the second.
 *
 * **Details**
 *
 * This function allows you to run two effects in sequence, where the result of
 * the first effect is preserved, and the result of the second effect is
 * discarded. By default, the two effects are executed sequentially. If you need
 * them to run concurrently, you can pass the `{ concurrent: true }` option.
 *
 * The second effect will always be executed, even though its result is ignored.
 * This makes it useful for cases where you want to execute an effect for its
 * side effects while keeping the result of another effect.
 *
 * **When to Use**
 *
 * Use this function when you are only interested in the result of the first
 * effect but still need to run the second effect for its side effects, such as
 * logging or performing a cleanup action.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const task1 = Effect.succeed(1).pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Effect.log("task1 done"))
 * )
 * const task2 = Effect.succeed("hello").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Effect.log("task2 done"))
 * )
 *
 * const program = Effect.zipLeft(task1, task2)
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // timestamp=... level=INFO fiber=#0 message="task1 done"
 * // timestamp=... level=INFO fiber=#0 message="task2 done"
 * // 1
 * ```
 *
 * @see {@link zipRight} for a version that returns the result of the second
 * effect.
 *
 * @since 2.0.0
 * @category Zipping
 */
const zipLeft = internal_fiberRuntime/* zipLeftOptions */.jr;
/**
 * Executes two effects sequentially, returning the result of the second effect
 * while ignoring the result of the first.
 *
 * **Details**
 *
 * This function allows you to run two effects in sequence, keeping the result
 * of the second effect and discarding the result of the first. By default, the
 * two effects are executed sequentially. If you need them to run concurrently,
 * you can pass the `{ concurrent: true }` option.
 *
 * The first effect will always be executed, even though its result is ignored.
 * This makes it useful for scenarios where the first effect is needed for its
 * side effects, but only the result of the second effect is important.
 *
 * **When to Use**
 *
 * Use this function when you are only interested in the result of the second
 * effect but still need to run the first effect for its side effects, such as
 * initialization or setup tasks.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const task1 = Effect.succeed(1).pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Effect.log("task1 done"))
 * )
 * const task2 = Effect.succeed("hello").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Effect.log("task2 done"))
 * )
 *
 * const program = Effect.zipRight(task1, task2)
 *
 * Effect.runPromise(program).then(console.log)
 * // Output:
 * // timestamp=... level=INFO fiber=#0 message="task1 done"
 * // timestamp=... level=INFO fiber=#0 message="task2 done"
 * // hello
 * ```
 *
 * @see {@link zipLeft} for a version that returns the result of the first
 * effect.
 *
 * @since 2.0.0
 * @category Zipping
 */
const zipRight = internal_fiberRuntime/* zipRightOptions */.tv;
/**
 * Combines two effects sequentially and applies a function to their results to
 * produce a single value.
 *
 * **Details**
 *
 * This function runs two effects in sequence (or concurrently, if the `{
 * concurrent: true }` option is provided) and combines their results using a
 * provided function. Unlike {@link zip}, which returns a tuple of the results,
 * this function processes the results with a custom function to produce a
 * single output.
 *
 * **Example** (Combining Effects with a Custom Function)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const task1 = Effect.succeed(1).pipe(
 *   Effect.delay("200 millis"),
 *   Effect.tap(Effect.log("task1 done"))
 * )
 * const task2 = Effect.succeed("hello").pipe(
 *   Effect.delay("100 millis"),
 *   Effect.tap(Effect.log("task2 done"))
 * )
 *
 * const task3 = Effect.zipWith(
 *   task1,
 *   task2,
 *   // Combines results into a single value
 *   (number, string) => number + string.length
 * )
 *
 * Effect.runPromise(task3).then(console.log)
 * // Output:
 * // timestamp=... level=INFO fiber=#3 message="task1 done"
 * // timestamp=... level=INFO fiber=#2 message="task2 done"
 * // 6
 * ```
 *
 * @since 2.0.0
 * @category Zipping
 */
const zipWith = internal_fiberRuntime/* zipWithOptions */.xn;
/**
 * Applies the function produced by one effect to the value produced by another effect.
 *
 * **Details**
 *
 * This function combines two effects:
 * - The first effect produces a function of type `(a: A) => B`.
 * - The second effect produces a value of type `A`.
 *
 * Once both effects complete successfully, the function is applied to the value, resulting in an effect that produces a value of type `B`.
 *
 * @since 2.0.0
 */
const ap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => zipWith(self, that, (f, a) => f(a)))));
/**
 * @category Requests & Batching
 * @since 2.0.0
 */
const blocked = internal_core/* blocked */.IN$;
/**
 * @category Requests & Batching
 * @since 2.0.0
 */
const runRequestBlock = internal_core/* runRequestBlock */.f6m;
/**
 * @category Requests & Batching
 * @since 2.0.0
 */
const step = internal_core/* step */.Nbs;
/**
 * @since 2.0.0
 * @category Requests & Batching
 */
const request = /*#__PURE__*/(0,Function/* dual */.OB)(args => isRequest(args[0]), fromRequest);
/**
 * @since 2.0.0
 * @category Requests & Batching
 */
const cacheRequestResult = cacheRequest;
/**
 * @since 2.0.0
 * @category Requests & Batching
 */
const withRequestBatching = internal_core/* withRequestBatching */.ZLd;
/**
 * @since 2.0.0
 * @category Requests & Batching
 */
const Effect_withRequestCaching = withRequestCaching;
/**
 * @since 2.0.0
 * @category Requests & Batching
 */
const Effect_withRequestCache = withRequestCache;
/**
 * @since 2.0.0
 * @category Tracing
 */
const tracer = core_effect/* tracer */.Z7;
/**
 * @since 2.0.0
 * @category Tracing
 */
const tracerWith = internal_defaultServices/* tracerWith */.$f;
/**
 * @since 2.0.0
 * @category Tracing
 */
const withTracer = internal_defaultServices/* withTracer */.oJ;
/**
 * @since 2.0.0
 * @category Tracing
 */
const withTracerScoped = internal_fiberRuntime/* withTracerScoped */.at;
/**
 * Disable the tracer for the given Effect.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * Effect.succeed(42).pipe(
 *   Effect.withSpan("my-span"),
 *   // the span will not be registered with the tracer
 *   Effect.withTracerEnabled(false)
 * )
 * ```
 *
 * @since 2.0.0
 * @category Tracing
 */
const withTracerEnabled = internal_core/* withTracerEnabled */._uo;
/**
 * @since 2.0.0
 * @category Tracing
 */
const withTracerTiming = internal_core/* withTracerTiming */.ObN;
/**
 * Adds annotations to each span in the effect for enhanced traceability.
 *
 * **Details**
 *
 * This function lets you attach key-value annotations to all spans generated
 * during the execution of an effect. Annotations provide additional context,
 * such as metadata or labels, which can help you understand and debug
 * asynchronous workflows more effectively.
 *
 * You can either pass a single key-value pair or a record of key-value pairs to
 * annotate the spans. These annotations can then be visualized in tracing tools
 * that support span annotations.
 *
 * @since 2.0.0
 * @category Tracing
 */
const annotateSpans = core_effect/* annotateSpans */.wV;
/**
 * Adds annotations to the currently active span for traceability.
 *
 * **Details**
 *
 * This function adds key-value annotations to the currently active span in the
 * effect's trace. These annotations help provide more context about the
 * operation being executed at a specific point in time. Unlike
 * {@link annotateSpans}, which applies to all spans in an effect, this function
 * focuses solely on the active span.
 *
 * You can either pass a single key-value pair or a record of key-value pairs to
 * annotate the span. These annotations are useful for adding metadata to
 * operations, especially in systems with detailed observability requirements.
 *
 * @since 2.0.0
 * @category Tracing
 */
const annotateCurrentSpan = core_effect/* annotateCurrentSpan */.H5;
/**
 * @since 2.0.0
 * @category Tracing
 */
const currentSpan = core_effect/* currentSpan */.f3;
/**
 * @since 2.0.0
 * @category Tracing
 */
const currentParentSpan = core_effect/* currentParentSpan */.bs;
/**
 * @since 2.0.0
 * @category Tracing
 */
const spanAnnotations = core_effect/* spanAnnotations */.xf;
/**
 * @since 2.0.0
 * @category Tracing
 */
const spanLinks = core_effect/* spanLinks */.Dp;
/**
 * For all spans in this effect, add a link with the provided span.
 *
 * @since 2.0.0
 * @category Tracing
 */
const linkSpans = core_effect/* linkSpans */.Rc;
/**
 * Add span links to the current span.
 *
 * @since 3.14.0
 * @category Tracing
 */
const linkSpanCurrent = core_effect/* linkSpanCurrent */.y2;
/**
 * Create a new span for tracing.
 *
 * @since 2.0.0
 * @category Tracing
 */
const makeSpan = core_effect/* makeSpan */.v8;
/**
 * Create a new span for tracing, and automatically close it when the Scope
 * finalizes.
 *
 * The span is not added to the current span stack, so no child spans will be
 * created for it.
 *
 * @since 2.0.0
 * @category Tracing
 */
const makeSpanScoped = internal_fiberRuntime/* makeSpanScoped */.ey;
/**
 * Create a new span for tracing, and automatically close it when the effect
 * completes.
 *
 * The span is not added to the current span stack, so no child spans will be
 * created for it.
 *
 * @since 2.0.0
 * @category Tracing
 */
const useSpan = core_effect/* useSpan */._g;
/**
 * Wraps the effect with a new span for tracing.
 *
 * @since 2.0.0
 * @category Tracing
 */
const withSpan = core_effect/* withSpan */.cq;
/**
 * Wraps a function that returns an effect with a new span for tracing.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const getTodo = Effect.functionWithSpan({
 *   body: (id: number) => Effect.succeed(`Got todo ${id}!`),
 *   options: (id) => ({
 *     name: `getTodo-${id}`,
 *     attributes: { id }
 *   })
 * })
 * ```
 *
 * @since 3.2.0
 * @category Tracing
 */
const functionWithSpan = core_effect/* functionWithSpan */.pm;
/**
 * Wraps the effect with a new span for tracing.
 *
 * The span is ended when the Scope is finalized.
 *
 * @since 2.0.0
 * @category Tracing
 */
const withSpanScoped = internal_fiberRuntime/* withSpanScoped */.$u;
/**
 * Adds the provided span to the current span stack.
 *
 * @since 2.0.0
 * @category Tracing
 */
const withParentSpan = core_effect/* withParentSpan */.cV;
/**
 * Safely handles nullable values by creating an effect that fails for `null` or
 * `undefined`.
 *
 * **Details**
 *
 * This function ensures that an input value is non-null and non-undefined
 * before processing it. If the value is valid, the effect succeeds with the
 * value. If the value is `null` or `undefined`, the effect fails with a
 * `NoSuchElementException`. This is particularly useful for avoiding
 * null-related errors by clearly separating valid values from invalid ones in
 * effectful computations.
 *
 * The failure with `NoSuchElementException` allows you to explicitly handle
 * cases where a value is expected but not provided, leading to safer and more
 * predictable code.
 *
 * **When to Use**
 *
 * Use this function when working with values that may be `null` or `undefined`
 * and you want to ensure that only non-null values are processed. It helps
 * enforce null-safety and makes error handling more explicit.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * //      ┌─── Effect<number, NoSuchElementException, never>
 * //      ▼
 * const maybe1 = Effect.fromNullable(1)
 *
 * Effect.runPromiseExit(maybe1).then(console.log)
 * // Output:
 * // { _id: 'Exit', _tag: 'Success', value: 1 }
 *
 * //      ┌─── Effect<number, NoSuchElementException, never>
 * //      ▼
 * const maybe2 = Effect.fromNullable(null as number | null)
 *
 * Effect.runPromiseExit(maybe2).then(console.log)
 * // Output:
 * // {
 * //   _id: 'Exit',
 * //   _tag: 'Failure',
 * //   cause: {
 * //     _id: 'Cause',
 * //     _tag: 'Fail',
 * //     failure: { _tag: 'NoSuchElementException' }
 * //   }
 * // }
 * ```
 *
 * @since 2.0.0
 * @category Optional Wrapping & Unwrapping
 */
const fromNullable = core_effect/* fromNullable */.ij;
/**
 * Converts an effect that may fail with a `NoSuchElementException` into an
 * effect that succeeds with an `Option`.
 *
 * **Details**
 *
 * This function transforms an effect that might fail with
 * `Cause.NoSuchElementException` into an effect that succeeds with an `Option`
 * type. If the original effect succeeds, its value is wrapped in `Option.some`.
 * If it fails specifically due to a `NoSuchElementException`, the failure is
 * mapped to `Option.none`. Other types of failures remain unchanged and are
 * passed through as they are.
 *
 * This is useful when working with effects where you want to gracefully handle
 * the absence of a value while preserving other potential failures.
 *
 * **When to Use**
 *
 * Use this function when you need to handle missing values as `Option.none`
 * rather than throwing or propagating errors like `NoSuchElementException`.
 * It’s ideal for scenarios where you want to explicitly represent optionality
 * in a type-safe way while retaining other failure information.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * //      ┌─── Effect<number, NoSuchElementException, never>
 * //      ▼
 * const maybe1 = Effect.fromNullable(1)
 *
 * //      ┌─── Effect<Option<number>, never, never>
 * //      ▼
 * const option1 = Effect.optionFromOptional(maybe1)
 *
 * Effect.runPromise(option1).then(console.log)
 * // Output: { _id: 'Option', _tag: 'Some', value: 1 }
 *
 * //      ┌─── Effect<number, NoSuchElementException, never>
 * //      ▼
 * const maybe2 = Effect.fromNullable(null as number | null)
 *
 * //      ┌─── Effect<Option<number>, never, never>
 * //      ▼
 * const option2 = Effect.optionFromOptional(maybe2)
 *
 * Effect.runPromise(option2).then(console.log)
 * // Output: { _tag: 'None' }
 * ```
 *
 * @since 2.0.0
 * @category Optional Wrapping & Unwrapping
 */
const optionFromOptional = core_effect/* optionFromOptional */.Ds;
/**
 * Converts an `Option` of an `Effect` into an `Effect` of an `Option`.
 *
 * **Details**
 *
 * This function transforms an `Option<Effect<A, E, R>>` into an
 * `Effect<Option<A>, E, R>`. If the `Option` is `None`, the resulting `Effect`
 * will immediately succeed with a `None` value. If the `Option` is `Some`, the
 * inner `Effect` will be executed, and its result wrapped in a `Some`.
 *
 * **Example**
 *
 * ```ts
 * import { Effect, Option } from "effect"
 *
 * //      ┌─── Option<Effect<number, never, never>>
 * //      ▼
 * const maybe = Option.some(Effect.succeed(42))
 *
 * //      ┌─── Effect<Option<number>, never, never>
 * //      ▼
 * const result = Effect.transposeOption(maybe)
 *
 * console.log(Effect.runSync(result))
 * // Output: { _id: 'Option', _tag: 'Some', value: 42 }
 * ```
 *
 * @since 3.13.0
 * @category Optional Wrapping & Unwrapping
 */
const transposeOption = self => {
  return option_.isNone(self) ? succeedNone : map(self.value, option_.some);
};
/**
 * Applies an `Effect` on an `Option` and transposes the result.
 *
 * **Details**
 *
 * If the `Option` is `None`, the resulting `Effect` will immediately succeed with a `None` value.
 * If the `Option` is `Some`, the effectful operation will be executed on the inner value, and its result wrapped in a `Some`.
 *
 * @example
 * ```ts
 * import { Effect, Option, pipe } from "effect"
 *
 * //          ┌─── Effect<Option<number>, never, never>>
 * //          ▼
 * const noneResult = pipe(
 *   Option.none(),
 *   Effect.transposeMapOption(() => Effect.succeed(42)) // will not be executed
 * )
 * console.log(Effect.runSync(noneResult))
 * // Output: { _id: 'Option', _tag: 'None' }
 *
 * //          ┌─── Effect<Option<number>, never, never>>
 * //          ▼
 * const someSuccessResult = pipe(
 *   Option.some(42),
 *   Effect.transposeMapOption((value) => Effect.succeed(value * 2))
 * )
 * console.log(Effect.runSync(someSuccessResult))
 * // Output: { _id: 'Option', _tag: 'Some', value: 84 }
 * ```
 *
 * @since 3.14.0
 * @category Optional Wrapping & Unwrapping
 */
const transposeMapOption = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => option_.isNone(self) ? succeedNone : map(f(self.value), option_.some))));
const makeTagProxy = TagClass => {
  const cache = new Map();
  return new Proxy(TagClass, {
    get(target, prop, receiver) {
      if (prop in target) {
        return Reflect.get(target, prop, receiver);
      }
      if (cache.has(prop)) {
        return cache.get(prop);
      }
      const fn = (...args) => core.andThen(target, s => {
        if (typeof s[prop] === "function") {
          cache.set(prop, (...args) => core.andThen(target, s => s[prop](...args)));
          return s[prop](...args);
        }
        cache.set(prop, core.andThen(target, s => s[prop]));
        return s[prop];
      });
      const cn = core.andThen(target, s => s[prop]);
      Object.assign(fn, cn);
      Object.setPrototypeOf(fn, Object.getPrototypeOf(cn));
      cache.set(prop, fn);
      return fn;
    }
  });
};
/**
 * Creates a unique tag for a dependency, embedding the service's methods as
 * static properties.
 *
 * **Details**
 *
 * This function allows you to define a `Tag` for a service or dependency in
 * your application. The `Tag` not only acts as an identifier but also provides
 * direct access to the service's methods via static properties. This makes it
 * easier to access and use the service in your code without manually managing
 * contexts.
 *
 * In the example below, the fields of the service (in this case, the `notify`
 * method) are turned into static properties of the Notifications class, making
 * it easier to access them.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * class Notifications extends Effect.Tag("Notifications")<
 *   Notifications,
 *   { readonly notify: (message: string) => Effect.Effect<void> }
 * >() {}
 *
 * // Create an effect that depends on the Notifications service
 * const action = Notifications.notify("Hello, world!")
 * ```
 *
 * @since 2.0.0
 * @category Context
 */
const Tag = id => () => {
  const limit = Error.stackTraceLimit;
  Error.stackTraceLimit = 2;
  const creationError = new Error();
  Error.stackTraceLimit = limit;
  function TagClass() {}
  Object.setPrototypeOf(TagClass, TagProto);
  TagClass.key = id;
  Object.defineProperty(TagClass, "use", {
    get() {
      return body => core.andThen(this, body);
    }
  });
  Object.defineProperty(TagClass, "stack", {
    get() {
      return creationError.stack;
    }
  });
  return makeTagProxy(TagClass);
};
/**
 * Simplifies the creation and management of services in Effect by defining both
 * a `Tag` and a `Layer`.
 *
 * **Details**
 *
 * This function allows you to streamline the creation of services by combining
 * the definition of a `Context.Tag` and a `Layer` in a single step. It supports
 * various ways of providing the service implementation:
 * - Using an `effect` to define the service dynamically.
 * - Using `sync` or `succeed` to define the service statically.
 * - Using `scoped` to create services with lifecycle management.
 *
 * It also allows you to specify dependencies for the service, which will be
 * provided automatically when the service is used. Accessors can be optionally
 * generated for the service, making it more convenient to use.
 *
 * **Example**
 *
 * ```ts
 * import { Effect } from 'effect';
 *
 * class Prefix extends Effect.Service<Prefix>()("Prefix", {
 *  sync: () => ({ prefix: "PRE" })
 * }) {}
 *
 * class Logger extends Effect.Service<Logger>()("Logger", {
 *  accessors: true,
 *  effect: Effect.gen(function* () {
 *    const { prefix } = yield* Prefix
 *    return {
 *      info: (message: string) =>
 *        Effect.sync(() => {
 *          console.log(`[${prefix}][${message}]`)
 *        })
 *    }
 *  }),
 *  dependencies: [Prefix.Default]
 * }) {}
 * ```
 *
 * @since 3.9.0
 * @category Context
 * @experimental might be up for breaking changes
 */
const Service = function () {
  return function () {
    const [id, maker] = arguments;
    const proxy = "accessors" in maker ? maker["accessors"] : false;
    const limit = Error.stackTraceLimit;
    Error.stackTraceLimit = 2;
    const creationError = new Error();
    Error.stackTraceLimit = limit;
    let patchState = "unchecked";
    const TagClass = function (service) {
      if (patchState === "unchecked") {
        const proto = Object.getPrototypeOf(service);
        if (proto === Object.prototype || proto === null) {
          patchState = "plain";
        } else {
          const selfProto = Object.getPrototypeOf(this);
          Object.setPrototypeOf(selfProto, proto);
          patchState = "patched";
        }
      }
      if (patchState === "plain") {
        Object.assign(this, service);
      } else if (patchState === "patched") {
        Object.setPrototypeOf(service, Object.getPrototypeOf(this));
        return service;
      }
    };
    TagClass.prototype._tag = id;
    Object.defineProperty(TagClass, "make", {
      get() {
        return service => new this(service);
      }
    });
    Object.defineProperty(TagClass, "use", {
      get() {
        return body => core.andThen(this, body);
      }
    });
    TagClass.key = id;
    Object.assign(TagClass, TagProto);
    Object.defineProperty(TagClass, "stack", {
      get() {
        return creationError.stack;
      }
    });
    const hasDeps = "dependencies" in maker && maker.dependencies.length > 0;
    const layerName = hasDeps ? "DefaultWithoutDependencies" : "Default";
    let layerCache;
    if ("effect" in maker) {
      Object.defineProperty(TagClass, layerName, {
        get() {
          return layerCache ??= layer.fromEffect(TagClass, map(maker.effect, _ => new this(_)));
        }
      });
    } else if ("scoped" in maker) {
      Object.defineProperty(TagClass, layerName, {
        get() {
          return layerCache ??= layer.scoped(TagClass, map(maker.scoped, _ => new this(_)));
        }
      });
    } else if ("sync" in maker) {
      Object.defineProperty(TagClass, layerName, {
        get() {
          return layerCache ??= layer.sync(TagClass, () => new this(maker.sync()));
        }
      });
    } else {
      Object.defineProperty(TagClass, layerName, {
        get() {
          return layerCache ??= layer.succeed(TagClass, new this(maker.succeed));
        }
      });
    }
    if (hasDeps) {
      let layerWithDepsCache;
      Object.defineProperty(TagClass, "Default", {
        get() {
          return layerWithDepsCache ??= layer.provide(this.DefaultWithoutDependencies, maker.dependencies);
        }
      });
    }
    return proxy === true ? makeTagProxy(TagClass) : TagClass;
  };
};
/**
 * The `Effect.fn` function allows you to create traced functions that return an
 * effect. It provides two key features:
 *
 * - **Stack traces with location details** if an error occurs.
 * - **Automatic span creation** for tracing when a span name is provided.
 *
 * If a span name is passed as the first argument, the function's execution is
 * tracked using that name. If no name is provided, stack tracing still works,
 * but spans are not created.
 *
 * A function can be defined using either:
 *
 * - A generator function, allowing the use of `yield*` for effect composition.
 * - A regular function that returns an `Effect`.
 *
 * **Example** (Creating a Traced Function with a Span Name)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const myfunc = Effect.fn("myspan")(function* <N extends number>(n: N) {
 *   yield* Effect.annotateCurrentSpan("n", n) // Attach metadata to the span
 *   console.log(`got: ${n}`)
 *   yield* Effect.fail(new Error("Boom!")) // Simulate failure
 * })
 *
 * Effect.runFork(myfunc(100).pipe(Effect.catchAllCause(Effect.logError)))
 * // Output:
 * // got: 100
 * // timestamp=... level=ERROR fiber=#0 cause="Error: Boom!
 * //     at <anonymous> (/.../index.ts:6:22) <= Raise location
 * //     at myspan (/.../index.ts:3:23)  <= Definition location
 * //     at myspan (/.../index.ts:9:16)" <= Call location
 * ```
 *
 * `Effect.fn` automatically creates spans. The spans capture information about
 * the function execution, including metadata and error details.
 *
 * **Example** (Exporting Spans to the Console)
 *
 * ```ts skip-type-checking
 * import { Effect } from "effect"
 * import { NodeSdk } from "@effect/opentelemetry"
 * import {
 *   ConsoleSpanExporter,
 *   BatchSpanProcessor
 * } from "@opentelemetry/sdk-trace-base"
 *
 * const myfunc = Effect.fn("myspan")(function* <N extends number>(n: N) {
 *   yield* Effect.annotateCurrentSpan("n", n)
 *   console.log(`got: ${n}`)
 *   yield* Effect.fail(new Error("Boom!"))
 * })
 *
 * const program = myfunc(100)
 *
 * const NodeSdkLive = NodeSdk.layer(() => ({
 *   resource: { serviceName: "example" },
 *   // Export span data to the console
 *   spanProcessor: new BatchSpanProcessor(new ConsoleSpanExporter())
 * }))
 *
 * Effect.runFork(program.pipe(Effect.provide(NodeSdkLive)))
 * // Output:
 * // got: 100
 * // {
 * //   resource: {
 * //     attributes: {
 * //       'service.name': 'example',
 * //       'telemetry.sdk.language': 'nodejs',
 * //       'telemetry.sdk.name': '@effect/opentelemetry',
 * //       'telemetry.sdk.version': '1.30.1'
 * //     }
 * //   },
 * //   instrumentationScope: { name: 'example', version: undefined, schemaUrl: undefined },
 * //   traceId: '22801570119e57a6e2aacda3dec9665b',
 * //   parentId: undefined,
 * //   traceState: undefined,
 * //   name: 'myspan',
 * //   id: '7af530c1e01bc0cb',
 * //   kind: 0,
 * //   timestamp: 1741182277518402.2,
 * //   duration: 4300.416,
 * //   attributes: {
 * //     n: 100,
 * //     'code.stacktrace': 'at <anonymous> (/.../index.ts:8:23)\n' +
 * //       'at <anonymous> (/.../index.ts:14:17)'
 * //   },
 * //   status: { code: 2, message: 'Boom!' },
 * //   events: [
 * //     {
 * //       name: 'exception',
 * //       attributes: {
 * //         'exception.type': 'Error',
 * //         'exception.message': 'Boom!',
 * //         'exception.stacktrace': 'Error: Boom!\n' +
 * //           '    at <anonymous> (/.../index.ts:11:22)\n' +
 * //           '    at myspan (/.../index.ts:8:23)\n' +
 * //           '    at myspan (/.../index.ts:14:17)'
 * //       },
 * //       time: [ 1741182277, 522702583 ],
 * //       droppedAttributesCount: 0
 * //     }
 * //   ],
 * //   links: []
 * // }
 * ```
 *
 * `Effect.fn` also acts as a pipe function, allowing you to create a pipeline
 * after the function definition using the effect returned by the generator
 * function as the starting value of the pipeline.
 *
 * **Example** (Creating a Traced Function with a Delay)
 *
 * ```ts
 * import { Effect } from "effect"
 *
 * const myfunc = Effect.fn(
 *   function* (n: number) {
 *     console.log(`got: ${n}`)
 *     yield* Effect.fail(new Error("Boom!"))
 *   },
 *   // You can access both the created effect and the original arguments
 *   (effect, n) => Effect.delay(effect, `${n / 100} seconds`)
 * )
 *
 * Effect.runFork(myfunc(100).pipe(Effect.catchAllCause(Effect.logError)))
 * // Output:
 * // got: 100
 * // timestamp=... level=ERROR fiber=#0 cause="Error: Boom! (<= after 1 second)
 * ```
 *
 * @see {@link fnUntraced} for a version of this function that doesn't add a span.
 *
 * @since 3.11.0
 * @category Tracing
 */
const fn = function (nameOrBody, ...pipeables) {
  const limit = Error.stackTraceLimit;
  Error.stackTraceLimit = 2;
  const errorDef = new Error();
  Error.stackTraceLimit = limit;
  if (typeof nameOrBody !== "string") {
    return defineLength(nameOrBody.length, function (...args) {
      const limit = Error.stackTraceLimit;
      Error.stackTraceLimit = 2;
      const errorCall = new Error();
      Error.stackTraceLimit = limit;
      return fnApply({
        self: this,
        body: nameOrBody,
        args,
        pipeables,
        spanName: "<anonymous>",
        spanOptions: {
          context: internalTracer.DisablePropagation.context(true)
        },
        errorDef,
        errorCall
      });
    });
  }
  const name = nameOrBody;
  const options = pipeables[0];
  return (body, ...pipeables) => defineLength(body.length, function (...args) {
    const limit = Error.stackTraceLimit;
    Error.stackTraceLimit = 2;
    const errorCall = new Error();
    Error.stackTraceLimit = limit;
    return fnApply({
      self: this,
      body,
      args,
      pipeables,
      spanName: name,
      spanOptions: options,
      errorDef,
      errorCall
    });
  });
};
function defineLength(length, fn) {
  return Object.defineProperty(fn, "length", {
    value: length,
    configurable: true
  });
}
function fnApply(options) {
  let effect;
  let fnError = undefined;
  if (isGeneratorFunction(options.body)) {
    effect = core.fromIterator(() => options.body.apply(options.self, options.args));
  } else {
    try {
      effect = options.body.apply(options.self, options.args);
    } catch (error) {
      fnError = error;
      effect = die(error);
    }
  }
  if (options.pipeables.length > 0) {
    try {
      for (const x of options.pipeables) {
        effect = x(effect, ...options.args);
      }
    } catch (error) {
      effect = fnError ? Effect_failCause(internalCause.sequential(internalCause.die(fnError), internalCause.die(error))) : die(error);
    }
  }
  let cache = false;
  const captureStackTrace = () => {
    if (cache !== false) {
      return cache;
    }
    if (options.errorCall.stack) {
      const stackDef = options.errorDef.stack.trim().split("\n");
      const stackCall = options.errorCall.stack.trim().split("\n");
      let endStackDef = stackDef.slice(2).join("\n").trim();
      if (!endStackDef.includes(`(`)) {
        endStackDef = endStackDef.replace(/at (.*)/, "at ($1)");
      }
      let endStackCall = stackCall.slice(2).join("\n").trim();
      if (!endStackCall.includes(`(`)) {
        endStackCall = endStackCall.replace(/at (.*)/, "at ($1)");
      }
      cache = `${endStackDef}\n${endStackCall}`;
      return cache;
    }
  };
  const opts = options.spanOptions && "captureStackTrace" in options.spanOptions ? options.spanOptions : {
    captureStackTrace,
    ...options.spanOptions
  };
  return withSpan(effect, options.spanName, opts);
}
/**
 * Same as {@link fn}, but allows you to create a function that is not traced, for when performance is critical.
 *
 * @see {@link fn} for a version that includes tracing.
 *
 * @since 3.12.0
 * @category Tracing
 */
const fnUntraced = internal_core/* fnUntraced */.RC_;
//# sourceMappingURL=Effect.js.map

/***/ }),

/***/ 34744:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ku": function() { return /* binding */ CommitPrototype; },
/* harmony export */   "tU": function() { return /* binding */ EffectPrototype; },
/* harmony export */   "wT": function() { return /* binding */ Class; }
/* harmony export */ });
/* unused harmony exports EffectTypeId, StreamTypeId, SinkTypeId, ChannelTypeId, StructuralCommitPrototype, StructuralClass */
/* harmony import */ var _internal_effectable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10020);

/**
 * @since 2.0.0
 * @category type ids
 */
const EffectTypeId = _internal_effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .EffectTypeId */ .Hj;
/**
 * @since 2.0.0
 * @category type ids
 */
const StreamTypeId = _internal_effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .StreamTypeId */ .qx;
/**
 * @since 2.0.0
 * @category type ids
 */
const SinkTypeId = _internal_effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .SinkTypeId */ .G1;
/**
 * @since 2.0.0
 * @category type ids
 */
const ChannelTypeId = _internal_effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .ChannelTypeId */ .Fc;
/**
 * @since 2.0.0
 * @category prototypes
 */
const EffectPrototype = _internal_effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .EffectPrototype */ .tU;
/**
 * @since 2.0.0
 * @category prototypes
 */
const CommitPrototype = _internal_effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .CommitPrototype */ .ku;
/**
 * @since 2.0.0
 * @category prototypes
 */
const StructuralCommitPrototype = _internal_effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .StructuralCommitPrototype */ .Sh;
const Base = _internal_effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .Base */ .XY;
const StructuralBase = _internal_effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .StructuralBase */ .t3;
/**
 * @since 2.0.0
 * @category constructors
 */
class Class extends Base {}
/**
 * @since 2.0.0
 * @category constructors
 */
class StructuralClass extends (/* unused pure expression or super */ null && (StructuralBase)) {}
//# sourceMappingURL=Effectable.js.map

/***/ }),

/***/ 87585:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EQ": function() { return /* binding */ match; },
/* harmony export */   "F2": function() { return /* binding */ right; },
/* harmony export */   "FT": function() { return /* binding */ isEither; },
/* harmony export */   "G$": function() { return /* binding */ getOrThrowWith; },
/* harmony export */   "Gg": function() { return /* binding */ getOrThrow; },
/* harmony export */   "JH": function() { return /* binding */ try_; },
/* harmony export */   "SA": function() { return /* binding */ mapBoth; },
/* harmony export */   "TS": function() { return /* binding */ merge; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "Vn": function() { return /* binding */ mapLeft; },
/* harmony export */   "Yo": function() { return /* binding */ fromOption; },
/* harmony export */   "nM": function() { return /* binding */ isLeft; },
/* harmony export */   "t$": function() { return /* binding */ left; },
/* harmony export */   "tO": function() { return /* binding */ isRight; }
/* harmony export */ });
/* unused harmony exports TypeId, void, fromNullable, getRight, getLeft, getEquivalence, liftPredicate, filterOrLeft, getOrElse, getOrNull, getOrUndefined, orElse, flatMap, andThen, zipWith, ap, all, flip, gen, Do, bind, bindTo, let, transposeOption */
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17316);
/* harmony import */ var _internal_either_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75974);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71335);
/**
 * @since 2.0.0
 */







/**
 * @category symbols
 * @since 2.0.0
 */
const TypeId = _internal_either_js__WEBPACK_IMPORTED_MODULE_0__/* .TypeId */ .aC;
/**
 * Constructs a new `Either` holding a `Right` value. This usually represents a successful value due to the right bias
 * of this structure.
 *
 * @category constructors
 * @since 2.0.0
 */
const right = _internal_either_js__WEBPACK_IMPORTED_MODULE_0__/* .right */ .F2;
const void_ = /*#__PURE__*/right(void 0);

/**
 * Constructs a new `Either` holding a `Left` value. This usually represents a failure, due to the right-bias of this
 * structure.
 *
 * @category constructors
 * @since 2.0.0
 */
const left = _internal_either_js__WEBPACK_IMPORTED_MODULE_0__/* .left */ .t$;
/**
 * Takes a lazy default and a nullable value, if the value is not nully (`null` or `undefined`), turn it into a `Right`, if the value is nully use
 * the provided default as a `Left`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either } from "effect"
 *
 * assert.deepStrictEqual(Either.fromNullable(1, () => 'fallback'), Either.right(1))
 * assert.deepStrictEqual(Either.fromNullable(null, () => 'fallback'), Either.left('fallback'))
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const fromNullable = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, onNullable) => self == null ? left(onNullable(self)) : right(self))));
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either, Option } from "effect"
 *
 * assert.deepStrictEqual(Either.fromOption(Option.some(1), () => 'error'), Either.right(1))
 * assert.deepStrictEqual(Either.fromOption(Option.none(), () => 'error'), Either.left('error'))
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const fromOption = _internal_either_js__WEBPACK_IMPORTED_MODULE_0__/* .fromOption */ .Yo;
const try_ = evaluate => {
  if ((0,_Predicate_js__WEBPACK_IMPORTED_MODULE_1__/* .isFunction */ .mf)(evaluate)) {
    try {
      return right(evaluate());
    } catch (e) {
      return left(e);
    }
  } else {
    try {
      return right(evaluate.try());
    } catch (e) {
      return left(evaluate.catch(e));
    }
  }
};

/**
 * Tests if a value is a `Either`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either } from "effect"
 *
 * assert.deepStrictEqual(Either.isEither(Either.right(1)), true)
 * assert.deepStrictEqual(Either.isEither(Either.left("a")), true)
 * assert.deepStrictEqual(Either.isEither({ right: 1 }), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isEither = _internal_either_js__WEBPACK_IMPORTED_MODULE_0__/* .isEither */ .FT;
/**
 * Determine if a `Either` is a `Left`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either } from "effect"
 *
 * assert.deepStrictEqual(Either.isLeft(Either.right(1)), false)
 * assert.deepStrictEqual(Either.isLeft(Either.left("a")), true)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isLeft = _internal_either_js__WEBPACK_IMPORTED_MODULE_0__/* .isLeft */ .nM;
/**
 * Determine if a `Either` is a `Right`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either } from "effect"
 *
 * assert.deepStrictEqual(Either.isRight(Either.right(1)), true)
 * assert.deepStrictEqual(Either.isRight(Either.left("a")), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isRight = _internal_either_js__WEBPACK_IMPORTED_MODULE_0__/* .isRight */ .tO;
/**
 * Converts a `Either` to an `Option` discarding the `Left`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either, Option } from "effect"
 *
 * assert.deepStrictEqual(Either.getRight(Either.right('ok')), Option.some('ok'))
 * assert.deepStrictEqual(Either.getRight(Either.left('err')), Option.none())
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const getRight = _internal_either_js__WEBPACK_IMPORTED_MODULE_0__/* .getRight */ .EK;
/**
 * Converts a `Either` to an `Option` discarding the value.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either, Option } from "effect"
 *
 * assert.deepStrictEqual(Either.getLeft(Either.right('ok')), Option.none())
 * assert.deepStrictEqual(Either.getLeft(Either.left('err')), Option.some('err'))
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const getLeft = _internal_either_js__WEBPACK_IMPORTED_MODULE_0__/* .getLeft */ .IS;
/**
 * @category equivalence
 * @since 2.0.0
 */
const getEquivalence = ({
  left,
  right
}) => Equivalence.make((x, y) => isLeft(x) ? isLeft(y) && left(x.left, y.left) : isRight(y) && right(x.right, y.right));
/**
 * @category mapping
 * @since 2.0.0
 */
const mapBoth = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, {
  onLeft,
  onRight
}) => isLeft(self) ? left(onLeft(self.left)) : right(onRight(self.right)));
/**
 * Maps the `Left` side of an `Either` value to a new `Either` value.
 *
 * @category mapping
 * @since 2.0.0
 */
const mapLeft = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, f) => isLeft(self) ? left(f(self.left)) : right(self.right));
/**
 * Maps the `Right` side of an `Either` value to a new `Either` value.
 *
 * @category mapping
 * @since 2.0.0
 */
const map = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, f) => isRight(self) ? right(f(self.right)) : left(self.left));
/**
 * Takes two functions and an `Either` value, if the value is a `Left` the inner value is applied to the `onLeft function,
 * if the value is a `Right` the inner value is applied to the `onRight` function.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, Either } from "effect"
 *
 * const onLeft  = (strings: ReadonlyArray<string>): string => `strings: ${strings.join(', ')}`
 *
 * const onRight = (value: number): string => `Ok: ${value}`
 *
 * assert.deepStrictEqual(pipe(Either.right(1), Either.match({ onLeft, onRight })), 'Ok: 1')
 * assert.deepStrictEqual(
 *   pipe(Either.left(['string 1', 'string 2']), Either.match({ onLeft, onRight })),
 *   'strings: string 1, string 2'
 * )
 * ```
 *
 * @category pattern matching
 * @since 2.0.0
 */
const match = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, {
  onLeft,
  onRight
}) => isLeft(self) ? onLeft(self.left) : onRight(self.right));
/**
 * Transforms a `Predicate` function into a `Right` of the input value if the predicate returns `true`
 * or `Left` of the result of the provided function if the predicate returns false
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, Either } from "effect"
 *
 * const isPositive = (n: number): boolean => n > 0
 * const isPositiveEither = Either.liftPredicate(isPositive, n => `${n} is not positive`)
 *
 * assert.deepStrictEqual(
 *   isPositiveEither(1),
 *   Either.right(1)
 * )
 * assert.deepStrictEqual(
 *   isPositiveEither(0),
 *   Either.left("0 is not positive")
 * )
 * ```
 *
 * @category lifting
 * @since 3.4.0
 */
const liftPredicate = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (a, predicate, orLeftWith) => predicate(a) ? right(a) : left(orLeftWith(a)))));
/**
 * Filter the right value with the provided function.
 * If the predicate fails, set the left value with the result of the provided function.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, Either } from "effect"
 *
 * const isPositive = (n: number): boolean => n > 0
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     Either.right(1),
 *     Either.filterOrLeft(isPositive, n => `${n} is not positive`)
 *   ),
 *   Either.right(1)
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     Either.right(0),
 *     Either.filterOrLeft(isPositive, n => `${n} is not positive`)
 *   ),
 *   Either.left("0 is not positive")
 * )
 * ```
 *
 * @since 2.0.0
 * @category filtering & conditionals
 */
const filterOrLeft = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, predicate, orLeftWith) => flatMap(self, r => predicate(r) ? right(r) : left(orLeftWith(r))))));
/**
 * @category getters
 * @since 2.0.0
 */
const merge = /*#__PURE__*/match({
  onLeft: _Function_js__WEBPACK_IMPORTED_MODULE_2__/* .identity */ .yR,
  onRight: _Function_js__WEBPACK_IMPORTED_MODULE_2__/* .identity */ .yR
});
/**
 * Returns the wrapped value if it's a `Right` or a default value if is a `Left`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either } from "effect"
 *
 * assert.deepStrictEqual(Either.getOrElse(Either.right(1), (error) => error + "!"), 1)
 * assert.deepStrictEqual(Either.getOrElse(Either.left("not a number"), (error) => error + "!"), "not a number!")
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const getOrElse = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, onLeft) => isLeft(self) ? onLeft(self.left) : self.right)));
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either } from "effect"
 *
 * assert.deepStrictEqual(Either.getOrNull(Either.right(1)), 1)
 * assert.deepStrictEqual(Either.getOrNull(Either.left("a")), null)
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const getOrNull = /*#__PURE__*/(/* unused pure expression or super */ null && (getOrElse(constNull)));
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either } from "effect"
 *
 * assert.deepStrictEqual(Either.getOrUndefined(Either.right(1)), 1)
 * assert.deepStrictEqual(Either.getOrUndefined(Either.left("a")), undefined)
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const getOrUndefined = /*#__PURE__*/(/* unused pure expression or super */ null && (getOrElse(constUndefined)));
/**
 * Extracts the value of an `Either` or throws if the `Either` is `Left`.
 *
 * If a default error is sufficient for your use case and you don't need to configure the thrown error, see {@link getOrThrow}.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either } from "effect"
 *
 * assert.deepStrictEqual(
 *   Either.getOrThrowWith(Either.right(1), () => new Error('Unexpected Left')),
 *   1
 * )
 * assert.throws(() => Either.getOrThrowWith(Either.left("error"), () => new Error('Unexpected Left')))
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const getOrThrowWith = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, onLeft) => {
  if (isRight(self)) {
    return self.right;
  }
  throw onLeft(self.left);
});
// TODO(4.0): by default should throw `L` (i.e getOrThrowWith with the identity function)
/**
 * Extracts the value of an `Either` or throws if the `Either` is `Left`.
 *
 * The thrown error is a default error. To configure the error thrown, see  {@link getOrThrowWith}.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either } from "effect"
 *
 * assert.deepStrictEqual(Either.getOrThrow(Either.right(1)), 1)
 * assert.throws(() => Either.getOrThrow(Either.left("error")))
 * ```
 *
 * @throws `Error("getOrThrow called on a Left")`
 *
 * @category getters
 * @since 2.0.0
 */
const getOrThrow = /*#__PURE__*/getOrThrowWith(() => new Error("getOrThrow called on a Left"));
/**
 * Returns `self` if it is a `Right` or `that` otherwise.
 *
 * @category error handling
 * @since 2.0.0
 */
const orElse = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => isLeft(self) ? that(self.left) : right(self.right))));
/**
 * @category sequencing
 * @since 2.0.0
 */
const flatMap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => isLeft(self) ? left(self.left) : f(self.right))));
/**
 * Executes a sequence of two `Either`s. The second `Either` can be dependent on the result of the first `Either`.
 *
 * @category sequencing
 * @since 2.0.0
 */
const andThen = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => flatMap(self, a => {
  const b = isFunction(f) ? f(a) : f;
  return isEither(b) ? b : right(b);
}))));
/**
 * @category zipping
 * @since 2.0.0
 */
const zipWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, that, f) => flatMap(self, r => map(that, r2 => f(r, r2))))));
/**
 * @category combining
 * @since 2.0.0
 */
const ap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => zipWith(self, that, (f, a) => f(a)))));
/**
 * Takes a structure of `Either`s and returns an `Either` of values with the same structure.
 *
 * - If a tuple is supplied, then the returned `Either` will contain a tuple with the same length.
 * - If a struct is supplied, then the returned `Either` will contain a struct with the same keys.
 * - If an iterable is supplied, then the returned `Either` will contain an array.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either } from "effect"
 *
 * assert.deepStrictEqual(Either.all([Either.right(1), Either.right(2)]), Either.right([1, 2]))
 * assert.deepStrictEqual(Either.all({ right: Either.right(1), b: Either.right("hello") }), Either.right({ right: 1, b: "hello" }))
 * assert.deepStrictEqual(Either.all({ right: Either.right(1), b: Either.left("error") }), Either.left("error"))
 * ```
 *
 * @category combining
 * @since 2.0.0
 */
// @ts-expect-error
const all = input => {
  if (Symbol.iterator in input) {
    const out = [];
    for (const e of input) {
      if (isLeft(e)) {
        return e;
      }
      out.push(e.right);
    }
    return right(out);
  }
  const out = {};
  for (const key of Object.keys(input)) {
    const e = input[key];
    if (isLeft(e)) {
      return e;
    }
    out[key] = e.right;
  }
  return right(out);
};
/**
 * Returns an `Either` that swaps the error/success cases. This allows you to
 * use all methods on the error channel, possibly before flipping back.
 *
 * @since 2.0.0
 * @category mapping
 */
const flip = self => isLeft(self) ? right(self.left) : left(self.right);
const adapter = /*#__PURE__*/(/* unused pure expression or super */ null && (Gen.adapter()));
/**
 * @category generators
 * @since 2.0.0
 */
const gen = (...args) => {
  const f = args.length === 1 ? args[0] : args[1].bind(args[0]);
  const iterator = f(adapter);
  let state = iterator.next();
  while (!state.done) {
    const current = Gen.isGenKind(state.value) ? state.value.value : Gen.yieldWrapGet(state.value);
    if (isLeft(current)) {
      return current;
    }
    state = iterator.next(current.right);
  }
  return right(state.value);
};
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * The "do simulation" in Effect allows you to write code in a more declarative style, similar to the "do notation" in other programming languages. It provides a way to define variables and perform operations on them using functions like `bind` and `let`.
 *
 * Here's how the do simulation works:
 *
 * 1. Start the do simulation using the `Do` value
 * 2. Within the do simulation scope, you can use the `bind` function to define variables and bind them to `Either` values
 * 3. You can accumulate multiple `bind` statements to define multiple variables within the scope
 * 4. Inside the do simulation scope, you can also use the `let` function to define variables and bind them to simple values
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either, pipe } from "effect"
 *
 * const result = pipe(
 *   Either.Do,
 *   Either.bind("x", () => Either.right(2)),
 *   Either.bind("y", () => Either.right(3)),
 *   Either.let("sum", ({ x, y }) => x + y)
 * )
 * assert.deepStrictEqual(result, Either.right({ x: 2, y: 3, sum: 5 }))
 * ```
 *
 * @see {@link bind}
 * @see {@link bindTo}
 * @see {@link let_ let}
 *
 * @category do notation
 * @since 2.0.0
 */
const Do = /*#__PURE__*/right({});
/**
 * The "do simulation" in Effect allows you to write code in a more declarative style, similar to the "do notation" in other programming languages. It provides a way to define variables and perform operations on them using functions like `bind` and `let`.
 *
 * Here's how the do simulation works:
 *
 * 1. Start the do simulation using the `Do` value
 * 2. Within the do simulation scope, you can use the `bind` function to define variables and bind them to `Either` values
 * 3. You can accumulate multiple `bind` statements to define multiple variables within the scope
 * 4. Inside the do simulation scope, you can also use the `let` function to define variables and bind them to simple values
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either, pipe } from "effect"
 *
 * const result = pipe(
 *   Either.Do,
 *   Either.bind("x", () => Either.right(2)),
 *   Either.bind("y", () => Either.right(3)),
 *   Either.let("sum", ({ x, y }) => x + y)
 * )
 * assert.deepStrictEqual(result, Either.right({ x: 2, y: 3, sum: 5 }))
 * ```
 *
 * @see {@link Do}
 * @see {@link bindTo}
 * @see {@link let_ let}
 *
 * @category do notation
 * @since 2.0.0
 */
const bind = /*#__PURE__*/(/* unused pure expression or super */ null && (doNotation.bind(map, flatMap)));
/**
 * The "do simulation" in Effect allows you to write code in a more declarative style, similar to the "do notation" in other programming languages. It provides a way to define variables and perform operations on them using functions like `bind` and `let`.
 *
 * Here's how the do simulation works:
 *
 * 1. Start the do simulation using the `Do` value
 * 2. Within the do simulation scope, you can use the `bind` function to define variables and bind them to `Either` values
 * 3. You can accumulate multiple `bind` statements to define multiple variables within the scope
 * 4. Inside the do simulation scope, you can also use the `let` function to define variables and bind them to simple values
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either, pipe } from "effect"
 *
 * const result = pipe(
 *   Either.Do,
 *   Either.bind("x", () => Either.right(2)),
 *   Either.bind("y", () => Either.right(3)),
 *   Either.let("sum", ({ x, y }) => x + y)
 * )
 * assert.deepStrictEqual(result, Either.right({ x: 2, y: 3, sum: 5 }))
 * ```
 *
 * @see {@link Do}
 * @see {@link bind}
 * @see {@link let_ let}
 *
 * @category do notation
 * @since 2.0.0
 */
const bindTo = /*#__PURE__*/(/* unused pure expression or super */ null && (doNotation.bindTo(map)));
const let_ = /*#__PURE__*/(/* unused pure expression or super */ null && (doNotation.let_(map)));

/**
 * Converts an `Option` of an `Either` into an `Either` of an `Option`.
 *
 * **Details**
 *
 * This function transforms an `Option<Either<A, E>>` into an
 * `Either<Option<A>, E>`. If the `Option` is `None`, the resulting `Either`
 * will be a `Right` with a `None` value. If the `Option` is `Some`, the
 * inner `Either` will be executed, and its result wrapped in a `Some`.
 *
 * @example
 * ```ts
 * import { Effect, Either, Option } from "effect"
 *
 * //      ┌─── Option<Either<number, never>>
 * //      ▼
 * const maybe = Option.some(Either.right(42))
 *
 * //      ┌─── Either<Option<number>, never, never>
 * //      ▼
 * const result = Either.transposeOption(maybe)
 *
 * console.log(Effect.runSync(result))
 * // Output: { _id: 'Option', _tag: 'Some', value: 42 }
 * ```
 *
 * @since 3.14.0
 * @category Optional Wrapping & Unwrapping
 */
const transposeOption = self => {
  return option_.isNone(self) ? right(option_.none) : map(self.value, option_.some);
};
//# sourceMappingURL=Either.js.map

/***/ }),

/***/ 53678:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NV": function() { return /* binding */ decodeBase64; },
  "TV": function() { return /* binding */ decodeBase64String; },
  "fr": function() { return /* binding */ decodeBase64Url; },
  "K": function() { return /* binding */ decodeBase64UrlString; },
  "QT": function() { return /* binding */ decodeHex; },
  "nX": function() { return /* binding */ decodeHexString; },
  "gi": function() { return /* binding */ decodeUriComponent; },
  "oF": function() { return /* binding */ encodeBase64; },
  "Mp": function() { return /* binding */ encodeBase64Url; },
  "U$": function() { return /* binding */ encodeHex; },
  "BO": function() { return /* binding */ encodeUriComponent; }
});

// UNUSED EXPORTS: DecodeException, DecodeExceptionTypeId, EncodeException, EncodeExceptionTypeId, isDecodeException, isEncodeException

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Either.js
var Either = __webpack_require__(87585);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var Predicate = __webpack_require__(71335);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/encoding/common.js

/** @internal */
const DecodeExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Encoding/errors/Decode");
/** @internal */
const DecodeException = (input, message) => {
  const out = {
    _tag: "DecodeException",
    [DecodeExceptionTypeId]: DecodeExceptionTypeId,
    input
  };
  if ((0,Predicate/* isString */.HD)(message)) {
    out.message = message;
  }
  return out;
};
/** @internal */
const isDecodeException = u => (0,Predicate/* hasProperty */.l$)(u, DecodeExceptionTypeId);
/** @internal */
const EncodeExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Encoding/errors/Encode");
/** @internal */
const EncodeException = (input, message) => {
  const out = {
    _tag: "EncodeException",
    [EncodeExceptionTypeId]: EncodeExceptionTypeId,
    input
  };
  if ((0,Predicate/* isString */.HD)(message)) {
    out.message = message;
  }
  return out;
};
/** @internal */
const isEncodeException = u => (0,Predicate/* hasProperty */.l$)(u, EncodeExceptionTypeId);
/** @interal */
const encoder = /*#__PURE__*/new TextEncoder();
/** @interal */
const decoder = /*#__PURE__*/new TextDecoder();
//# sourceMappingURL=common.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/encoding/base64.js


/** @internal */
const encode = bytes => {
  const length = bytes.length;
  let result = "";
  let i;
  for (i = 2; i < length; i += 3) {
    result += base64abc[bytes[i - 2] >> 2];
    result += base64abc[(bytes[i - 2] & 0x03) << 4 | bytes[i - 1] >> 4];
    result += base64abc[(bytes[i - 1] & 0x0f) << 2 | bytes[i] >> 6];
    result += base64abc[bytes[i] & 0x3f];
  }
  if (i === length + 1) {
    // 1 octet yet to write
    result += base64abc[bytes[i - 2] >> 2];
    result += base64abc[(bytes[i - 2] & 0x03) << 4];
    result += "==";
  }
  if (i === length) {
    // 2 octets yet to write
    result += base64abc[bytes[i - 2] >> 2];
    result += base64abc[(bytes[i - 2] & 0x03) << 4 | bytes[i - 1] >> 4];
    result += base64abc[(bytes[i - 1] & 0x0f) << 2];
    result += "=";
  }
  return result;
};
/** @internal */
const decode = str => {
  const stripped = stripCrlf(str);
  const length = stripped.length;
  if (length % 4 !== 0) {
    return Either/* left */.t$(DecodeException(stripped, `Length must be a multiple of 4, but is ${length}`));
  }
  const index = stripped.indexOf("=");
  if (index !== -1 && (index < length - 2 || index === length - 2 && stripped[length - 1] !== "=")) {
    return Either/* left */.t$(DecodeException(stripped, "Found a '=' character, but it is not at the end"));
  }
  try {
    const missingOctets = stripped.endsWith("==") ? 2 : stripped.endsWith("=") ? 1 : 0;
    const result = new Uint8Array(3 * (length / 4) - missingOctets);
    for (let i = 0, j = 0; i < length; i += 4, j += 3) {
      const buffer = getBase64Code(stripped.charCodeAt(i)) << 18 | getBase64Code(stripped.charCodeAt(i + 1)) << 12 | getBase64Code(stripped.charCodeAt(i + 2)) << 6 | getBase64Code(stripped.charCodeAt(i + 3));
      result[j] = buffer >> 16;
      result[j + 1] = buffer >> 8 & 0xff;
      result[j + 2] = buffer & 0xff;
    }
    return Either/* right */.F2(result);
  } catch (e) {
    return Either/* left */.t$(DecodeException(stripped, e instanceof Error ? e.message : "Invalid input"));
  }
};
/** @internal */
const stripCrlf = str => str.replace(/[\n\r]/g, "");
/** @internal */
function getBase64Code(charCode) {
  if (charCode >= base64codes.length) {
    throw new TypeError(`Invalid character ${String.fromCharCode(charCode)}`);
  }
  const code = base64codes[charCode];
  if (code === 255) {
    throw new TypeError(`Invalid character ${String.fromCharCode(charCode)}`);
  }
  return code;
}
/** @internal */
const base64abc = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "+", "/"];
/** @internal */
const base64codes = [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 62, 255, 255, 255, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 255, 255, 255, 0, 255, 255, 255, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 255, 255, 255, 255, 255, 255, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51];
//# sourceMappingURL=base64.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/encoding/base64Url.js



/** @internal */
const base64Url_encode = data => encode(data).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
/** @internal */
const base64Url_decode = str => {
  const stripped = stripCrlf(str);
  const length = stripped.length;
  if (length % 4 === 1) {
    return Either/* left */.t$(DecodeException(stripped, `Length should be a multiple of 4, but is ${length}`));
  }
  if (!/^[-_A-Z0-9]*?={0,2}$/i.test(stripped)) {
    return Either/* left */.t$(DecodeException(stripped, "Invalid input"));
  }
  // Some variants allow or require omitting the padding '=' signs
  let sanitized = length % 4 === 2 ? `${stripped}==` : length % 4 === 3 ? `${stripped}=` : stripped;
  sanitized = sanitized.replace(/-/g, "+").replace(/_/g, "/");
  return decode(sanitized);
};
//# sourceMappingURL=base64Url.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/encoding/hex.js


/** @internal */
const hex_encode = bytes => {
  let result = "";
  for (let i = 0; i < bytes.length; ++i) {
    result += bytesToHex[bytes[i]];
  }
  return result;
};
/** @internal */
const hex_decode = str => {
  const bytes = new TextEncoder().encode(str);
  if (bytes.length % 2 !== 0) {
    return Either/* left */.t$(DecodeException(str, `Length must be a multiple of 2, but is ${bytes.length}`));
  }
  try {
    const length = bytes.length / 2;
    const result = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
      const a = fromHexChar(bytes[i * 2]);
      const b = fromHexChar(bytes[i * 2 + 1]);
      result[i] = a << 4 | b;
    }
    return Either/* right */.F2(result);
  } catch (e) {
    return Either/* left */.t$(DecodeException(str, e instanceof Error ? e.message : "Invalid input"));
  }
};
/** @internal */
const bytesToHex = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
/** @internal */
const fromHexChar = byte => {
  // '0' <= byte && byte <= '9'
  if (48 <= byte && byte <= 57) {
    return byte - 48;
  }
  // 'a' <= byte && byte <= 'f'
  if (97 <= byte && byte <= 102) {
    return byte - 97 + 10;
  }
  // 'A' <= byte && byte <= 'F'
  if (65 <= byte && byte <= 70) {
    return byte - 65 + 10;
  }
  throw new TypeError("Invalid input");
};
//# sourceMappingURL=hex.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/Encoding.js
/**
 * This module provides encoding & decoding functionality for:
 *
 * - base64 (RFC4648)
 * - base64 (URL)
 * - hex
 *
 * @since 2.0.0
 */





/**
 * Encodes the given value into a base64 (RFC4648) `string`.
 *
 * @category encoding
 * @since 2.0.0
 */
const encodeBase64 = input => typeof input === "string" ? encode(encoder.encode(input)) : encode(input);
/**
 * Decodes a base64 (RFC4648) encoded `string` into a `Uint8Array`.
 *
 * @category decoding
 * @since 2.0.0
 */
const decodeBase64 = str => decode(str);
/**
 * Decodes a base64 (RFC4648) encoded `string` into a UTF-8 `string`.
 *
 * @category decoding
 * @since 2.0.0
 */
const decodeBase64String = str => Either/* map */.UI(decodeBase64(str), _ => decoder.decode(_));
/**
 * Encodes the given value into a base64 (URL) `string`.
 *
 * @category encoding
 * @since 2.0.0
 */
const encodeBase64Url = input => typeof input === "string" ? base64Url_encode(encoder.encode(input)) : base64Url_encode(input);
/**
 * Decodes a base64 (URL) encoded `string` into a `Uint8Array`.
 *
 * @category decoding
 * @since 2.0.0
 */
const decodeBase64Url = str => base64Url_decode(str);
/**
 * Decodes a base64 (URL) encoded `string` into a UTF-8 `string`.
 *
 * @category decoding
 * @since 2.0.0
 */
const decodeBase64UrlString = str => Either/* map */.UI(decodeBase64Url(str), _ => decoder.decode(_));
/**
 * Encodes the given value into a hex `string`.
 *
 * @category encoding
 * @since 2.0.0
 */
const encodeHex = input => typeof input === "string" ? hex_encode(encoder.encode(input)) : hex_encode(input);
/**
 * Decodes a hex encoded `string` into a `Uint8Array`.
 *
 * @category decoding
 * @since 2.0.0
 */
const decodeHex = str => hex_decode(str);
/**
 * Decodes a hex encoded `string` into a UTF-8 `string`.
 *
 * @category decoding
 * @since 2.0.0
 */
const decodeHexString = str => Either/* map */.UI(decodeHex(str), _ => decoder.decode(_));
/**
 * Encodes a UTF-8 `string` into a URI component `string`.
 *
 * @category encoding
 * @since 3.12.0
 */
const encodeUriComponent = str => Either/* try */.JH({
  try: () => encodeURIComponent(str),
  catch: e => Encoding_EncodeException(str, e instanceof Error ? e.message : "Invalid input")
});
/**
 * Decodes a URI component `string` into a UTF-8 `string`.
 *
 * @category decoding
 * @since 3.12.0
 */
const decodeUriComponent = str => Either/* try */.JH({
  try: () => decodeURIComponent(str),
  catch: e => Encoding_DecodeException(str, e instanceof Error ? e.message : "Invalid input")
});
/**
 * @since 2.0.0
 * @category symbols
 */
const Encoding_DecodeExceptionTypeId = DecodeExceptionTypeId;
/**
 * Creates a checked exception which occurs when decoding fails.
 *
 * @since 2.0.0
 * @category errors
 */
const Encoding_DecodeException = DecodeException;
/**
 * Returns `true` if the specified value is an `DecodeException`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const Encoding_isDecodeException = isDecodeException;
/**
 * @since 3.12.0
 * @category symbols
 */
const Encoding_EncodeExceptionTypeId = EncodeExceptionTypeId;
/**
 * Creates a checked exception which occurs when encoding fails.
 *
 * @since 3.12.0
 * @category errors
 */
const Encoding_EncodeException = EncodeException;
/**
 * Returns `true` if the specified value is an `EncodeException`, `false` otherwise.
 *
 * @since 3.12.0
 * @category refinements
 */
const Encoding_isEncodeException = isEncodeException;
//# sourceMappingURL=Encoding.js.map

/***/ }),

/***/ 67492:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DE": function() { return /* binding */ equivalence; },
/* harmony export */   "NA": function() { return /* binding */ symbol; },
/* harmony export */   "Xy": function() { return /* binding */ isEqual; },
/* harmony export */   "fS": function() { return /* binding */ equals; }
/* harmony export */ });
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89379);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71335);
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70762);



/**
 * @since 2.0.0
 * @category symbols
 */
const symbol = /*#__PURE__*/Symbol.for("effect/Equal");
function equals() {
  if (arguments.length === 1) {
    return self => compareBoth(self, arguments[0]);
  }
  return compareBoth(arguments[0], arguments[1]);
}
function compareBoth(self, that) {
  if (self === that) {
    return true;
  }
  const selfType = typeof self;
  if (selfType !== typeof that) {
    return false;
  }
  if (selfType === "object" || selfType === "function") {
    if (self !== null && that !== null) {
      if (isEqual(self) && isEqual(that)) {
        if (_Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .hash */ .vp(self) === _Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .hash */ .vp(that) && self[symbol](that)) {
          return true;
        } else {
          return _Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .structuralRegionState.enabled */ .uL.enabled && _Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .structuralRegionState.tester */ .uL.tester ? _Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .structuralRegionState.tester */ .uL.tester(self, that) : false;
        }
      } else if (self instanceof Date && that instanceof Date) {
        return self.toISOString() === that.toISOString();
      } else if (self instanceof URL && that instanceof URL) {
        return self.href === that.href;
      }
    }
    if (_Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .structuralRegionState.enabled */ .uL.enabled) {
      if (Array.isArray(self) && Array.isArray(that)) {
        return self.length === that.length && self.every((v, i) => compareBoth(v, that[i]));
      }
      if (Object.getPrototypeOf(self) === Object.prototype && Object.getPrototypeOf(self) === Object.prototype) {
        const keysSelf = Object.keys(self);
        const keysThat = Object.keys(that);
        if (keysSelf.length === keysThat.length) {
          for (const key of keysSelf) {
            // @ts-expect-error
            if (!(key in that && compareBoth(self[key], that[key]))) {
              return _Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .structuralRegionState.tester */ .uL.tester ? _Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .structuralRegionState.tester */ .uL.tester(self, that) : false;
            }
          }
          return true;
        }
      }
      return _Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .structuralRegionState.tester */ .uL.tester ? _Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .structuralRegionState.tester */ .uL.tester(self, that) : false;
    }
  }
  return _Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .structuralRegionState.enabled */ .uL.enabled && _Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .structuralRegionState.tester */ .uL.tester ? _Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .structuralRegionState.tester */ .uL.tester(self, that) : false;
}
/**
 * @since 2.0.0
 * @category guards
 */
const isEqual = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_2__/* .hasProperty */ .l$)(u, symbol);
/**
 * @since 2.0.0
 * @category instances
 */
const equivalence = () => equals;
//# sourceMappingURL=Equal.js.map

/***/ }),

/***/ 27786:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ mapInput; },
/* harmony export */   "Ej": function() { return /* binding */ Date; },
/* harmony export */   "IX": function() { return /* binding */ array; },
/* harmony export */   "Kv": function() { return /* binding */ bigint; },
/* harmony export */   "O7": function() { return /* binding */ boolean; },
/* harmony export */   "Rx": function() { return /* binding */ number; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "Z_": function() { return /* binding */ string; },
/* harmony export */   "bc": function() { return /* binding */ tuple; },
/* harmony export */   "n_": function() { return /* binding */ struct; }
/* harmony export */ });
/* unused harmony exports strict, symbol, combine, combineMany, combineAll, product, all, productMany */
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17316);
/**
 * This module provides an implementation of the `Equivalence` type class, which defines a binary relation
 * that is reflexive, symmetric, and transitive. In other words, it defines a notion of equivalence between values of a certain type.
 * These properties are also known in mathematics as an "equivalence relation".
 *
 * @since 2.0.0
 */

/**
 * @category constructors
 * @since 2.0.0
 */
const make = isEquivalent => (self, that) => self === that || isEquivalent(self, that);
const isStrictEquivalent = (x, y) => x === y;
/**
 * Return an `Equivalence` that uses strict equality (===) to compare values.
 *
 * @since 2.0.0
 * @category constructors
 */
const strict = () => isStrictEquivalent;
/**
 * @category instances
 * @since 2.0.0
 */
const string = /*#__PURE__*/strict();
/**
 * @category instances
 * @since 2.0.0
 */
const number = /*#__PURE__*/strict();
/**
 * @category instances
 * @since 2.0.0
 */
const boolean = /*#__PURE__*/strict();
/**
 * @category instances
 * @since 2.0.0
 */
const bigint = /*#__PURE__*/strict();
/**
 * @category instances
 * @since 2.0.0
 */
const symbol = /*#__PURE__*/(/* unused pure expression or super */ null && (strict()));
/**
 * @category combining
 * @since 2.0.0
 */
const combine = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => make((x, y) => self(x, y) && that(x, y)))));
/**
 * @category combining
 * @since 2.0.0
 */
const combineMany = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, collection) => make((x, y) => {
  if (!self(x, y)) {
    return false;
  }
  for (const equivalence of collection) {
    if (!equivalence(x, y)) {
      return false;
    }
  }
  return true;
}))));
const isAlwaysEquivalent = (_x, _y) => true;
/**
 * @category combining
 * @since 2.0.0
 */
const combineAll = collection => combineMany(isAlwaysEquivalent, collection);
/**
 * @category mapping
 * @since 2.0.0
 */
const mapInput = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, f) => make((x, y) => self(f(x), f(y))));
/**
 * @category instances
 * @since 2.0.0
 */
const Date = /*#__PURE__*/mapInput(number, date => date.getTime());
/**
 * @category combining
 * @since 2.0.0
 */
const product = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => make(([xa, xb], [ya, yb]) => self(xa, ya) && that(xb, yb)))));
/**
 * @category combining
 * @since 2.0.0
 */
const all = collection => {
  return make((x, y) => {
    const len = Math.min(x.length, y.length);
    let collectionLength = 0;
    for (const equivalence of collection) {
      if (collectionLength >= len) {
        break;
      }
      if (!equivalence(x[collectionLength], y[collectionLength])) {
        return false;
      }
      collectionLength++;
    }
    return true;
  });
};
/**
 * @category combining
 * @since 2.0.0
 */
const productMany = (self, collection) => {
  const equivalence = all(collection);
  return make((x, y) => !self(x[0], y[0]) ? false : equivalence(x.slice(1), y.slice(1)));
};
/**
 * Similar to `Promise.all` but operates on `Equivalence`s.
 *
 * ```ts skip-type-checking
 * [Equivalence<A>, Equivalence<B>, ...] -> Equivalence<[A, B, ...]>
 * ```
 *
 * Given a tuple of `Equivalence`s returns a new `Equivalence` that compares values of a tuple
 * by applying each `Equivalence` to the corresponding element of the tuple.
 *
 * @category combinators
 * @since 2.0.0
 */
const tuple = (...elements) => all(elements);
/**
 * Creates a new `Equivalence` for an array of values based on a given `Equivalence` for the elements of the array.
 *
 * @category combinators
 * @since 2.0.0
 */
const array = item => make((self, that) => {
  if (self.length !== that.length) {
    return false;
  }
  for (let i = 0; i < self.length; i++) {
    const isEq = item(self[i], that[i]);
    if (!isEq) {
      return false;
    }
  }
  return true;
});
/**
 * Given a struct of `Equivalence`s returns a new `Equivalence` that compares values of a struct
 * by applying each `Equivalence` to the corresponding property of the struct.
 *
 * @category combinators
 * @since 2.0.0
 */
const struct = fields => {
  const keys = Object.keys(fields);
  return make((self, that) => {
    for (const key of keys) {
      if (!fields[key](self[key], that[key])) {
        return false;
      }
    }
    return true;
  });
};
//# sourceMappingURL=Equivalence.js.map

/***/ }),

/***/ 76658:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dh": function() { return /* binding */ failCause; },
/* harmony export */   "EQ": function() { return /* binding */ match; },
/* harmony export */   "bG": function() { return /* binding */ fail; },
/* harmony export */   "d6": function() { return /* binding */ isSuccess; },
/* harmony export */   "e1": function() { return /* binding */ interrupt; },
/* harmony export */   "jF": function() { return /* binding */ forEachEffect; },
/* harmony export */   "ng": function() { return /* binding */ succeed; },
/* harmony export */   "xH": function() { return /* binding */ flatten; },
/* harmony export */   "yL": function() { return /* binding */ zipWith; }
/* harmony export */ });
/* unused harmony exports isExit, isFailure, isInterrupted, as, asVoid, causeOption, all, die, exists, flatMap, flatMapEffect, fromEither, fromOption, getOrElse, map, mapBoth, mapError, mapErrorCause, matchEffect, void, zip, zipLeft, zipRight, zipPar, zipParLeft, zipParRight */
/* harmony import */ var _internal_core_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39355);

/**
 * Returns `true` if the specified value is an `Exit`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isExit = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitIsExit */ .fX8;
/**
 * Returns `true` if the specified `Exit` is a `Failure`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isFailure = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitIsFailure */ .Ioz;
/**
 * Returns `true` if the specified `Exit` is a `Success`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isSuccess = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitIsSuccess */ .dcz;
/**
 * Returns `true` if the specified exit is a `Failure` **and** the `Cause` of
 * the failure was due to interruption, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isInterrupted = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitIsInterrupted */ .y8V;
/**
 * Maps the `Success` value of the specified exit to the provided constant
 * value.
 *
 * @since 2.0.0
 * @category mapping
 */
const as = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitAs */ .AZM;
/**
 * Maps the `Success` value of the specified exit to a void.
 *
 * @since 2.0.0
 * @category mapping
 */
const asVoid = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitAsVoid */ .MKG;
/**
 * Returns a `Some<Cause<E>>` if the specified exit is a `Failure`, `None`
 * otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const causeOption = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitCauseOption */ .fa7;
/**
 * Collects all of the specified exit values into a `Some<Exit<List<A>, E>>`. If
 * the provided iterable contains no elements, `None` will be returned.
 *
 * @since 2.0.0
 * @category constructors
 */
const all = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitCollectAll */ .jxF;
/**
 * Constructs a new `Exit.Failure` from the specified unrecoverable defect.
 *
 * @since 2.0.0
 * @category constructors
 */
const die = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitDie */ .ai8;
/**
 * Executes the predicate on the value of the specified exit if it is a
 * `Success`, otherwise returns `false`.
 *
 * @since 2.0.0
 * @category elements
 */
const exists = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitExists */ .oMA;
/**
 * Constructs a new `Exit.Failure` from the specified recoverable error of type
 * `E`.
 *
 * @since 2.0.0
 * @category constructors
 */
const fail = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitFail */ .bT5;
/**
 * Constructs a new `Exit.Failure` from the specified `Cause` of type `E`.
 *
 * @since 2.0.0
 * @category constructors
 */
const failCause = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitFailCause */ .KiG;
/**
 * @since 2.0.0
 * @category sequencing
 */
const flatMap = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitFlatMap */ .SMH;
/**
 * @since 2.0.0
 * @category sequencing
 */
const flatMapEffect = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitFlatMapEffect */ .pcb;
/**
 * @since 2.0.0
 * @category sequencing
 */
const flatten = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitFlatten */ .L$o;
/**
 * @since 2.0.0
 * @category traversing
 */
const forEachEffect = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitForEachEffect */ .XZ7;
/**
 * Converts an `Either<R, L>` into an `Exit<R, L>`.
 *
 * @since 2.0.0
 * @category conversions
 */
const fromEither = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitFromEither */ .KTm;
/**
 * Converts an `Option<A>` into an `Exit<void, A>`.
 *
 * @since 2.0.0
 * @category conversions
 */
const fromOption = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitFromOption */ .RxU;
/**
 * Returns the `A` if specified exit is a `Success`, otherwise returns the
 * alternate `A` value computed from the specified function which receives the
 * `Cause<E>` of the exit `Failure`.
 *
 * @since 2.0.0
 * @category getters
 */
const getOrElse = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitGetOrElse */ .giG;
/**
 * Constructs a new `Exit.Failure` from the specified `FiberId` indicating that
 * the `Fiber` running an `Effect` workflow was terminated due to interruption.
 *
 * @since 2.0.0
 * @category constructors
 */
const interrupt = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitInterrupt */ .eq6;
/**
 * Maps over the `Success` value of the specified exit using the provided
 * function.
 *
 * @since 2.0.0
 * @category mapping
 */
const map = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitMap */ .Fh8;
/**
 * Maps over the `Success` and `Failure` cases of the specified exit using the
 * provided functions.
 *
 * @since 2.0.0
 * @category mapping
 */
const mapBoth = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitMapBoth */ .V74;
/**
 * Maps over the error contained in the `Failure` of the specified exit using
 * the provided function.
 *
 * @since 2.0.0
 * @category mapping
 */
const mapError = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitMapError */ .HYP;
/**
 * Maps over the `Cause` contained in the `Failure` of the specified exit using
 * the provided function.
 *
 * @since 2.0.0
 * @category mapping
 */
const mapErrorCause = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitMapErrorCause */ .wvn;
/**
 * @since 2.0.0
 * @category folding
 */
const match = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitMatch */ .Bs2;
/**
 * @since 2.0.0
 * @category folding
 */
const matchEffect = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitMatchEffect */ .aoR;
/**
 * Constructs a new `Exit.Success` containing the specified value of type `A`.
 *
 * @since 2.0.0
 * @category constructors
 */
const succeed = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitSucceed */ .SID;
const void_ = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitVoid */ .E7$;

/**
 * Sequentially zips the this result with the specified result or else returns
 * the failed `Cause<E | E2>`.
 *
 * @since 2.0.0
 * @category zipping
 */
const zip = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitZip */ .a69;
/**
 * Sequentially zips the this result with the specified result discarding the
 * second element of the tuple or else returns the failed `Cause<E | E2>`.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipLeft = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitZipLeft */ ._TW;
/**
 * Sequentially zips the this result with the specified result discarding the
 * first element of the tuple or else returns the failed `Cause<E | E2>`.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipRight = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitZipRight */ .XIR;
/**
 * Parallelly zips the this result with the specified result or else returns
 * the failed `Cause<E | E2>`.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipPar = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitZipPar */ .$7G;
/**
 * Parallelly zips the this result with the specified result discarding the
 * second element of the tuple or else returns the failed `Cause<E | E2>`.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipParLeft = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitZipParLeft */ .u9x;
/**
 * Parallelly zips the this result with the specified result discarding the
 * first element of the tuple or else returns the failed `Cause<E | E2>`.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipParRight = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitZipParRight */ .VEn;
/**
 * Zips this exit together with that exit using the specified combination
 * functions.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipWith = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitZipWith */ .dG6;
//# sourceMappingURL=Exit.js.map

/***/ }),

/***/ 57303:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "GZ": function() { return /* binding */ runtime; },
/* harmony export */   "Q9": function() { return /* binding */ threadName; },
/* harmony export */   "YP": function() { return /* binding */ none; },
/* harmony export */   "ez": function() { return /* binding */ isFiberId; },
/* harmony export */   "fS": function() { return /* binding */ getOrElse; },
/* harmony export */   "h$": function() { return /* binding */ composite; },
/* harmony export */   "r$": function() { return /* binding */ ids; },
/* harmony export */   "t0": function() { return /* binding */ unsafeMake; }
/* harmony export */ });
/* unused harmony exports FiberIdTypeId, isNone, isRuntime, isComposite, combineAll, make, toOption, toSet */
/* harmony import */ var _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26219);

/**
 * @since 2.0.0
 * @category symbols
 */
const FiberIdTypeId = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .FiberIdTypeId */ .aC;
/**
 * @since 2.0.0
 * @category constructors
 */
const none = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .none */ .YP;
/**
 * @since 2.0.0
 * @category constructors
 */
const runtime = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .runtime */ .GZ;
/**
 * @since 2.0.0
 * @category constructors
 */
const composite = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .composite */ .h$;
/**
 * Returns `true` if the specified unknown value is a `FiberId`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isFiberId = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .isFiberId */ .ez;
/**
 * Returns `true` if the `FiberId` is a `None`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isNone = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .isNone */ .Wi;
/**
 * Returns `true` if the `FiberId` is a `Runtime`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isRuntime = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .isRuntime */ .X9;
/**
 * Returns `true` if the `FiberId` is a `Composite`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isComposite = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .isComposite */ .k2;
/**
 * Combine two `FiberId`s.
 *
 * @since 2.0.0
 * @category constructors
 */
const combine = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .combine */ .$e;
/**
 * Combines a set of `FiberId`s into a single `FiberId`.
 *
 * @since 2.0.0
 * @category constructors
 */
const combineAll = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .combineAll */ .c3;
/**
 * Returns this `FiberId` if it is not `None`, otherwise returns that `FiberId`.
 *
 * @since 2.0.0
 * @category utils
 */
const getOrElse = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .getOrElse */ .fS;
/**
 * Get the set of identifiers for this `FiberId`.
 *
 * @since 2.0.0
 * @category destructors
 */
const ids = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .ids */ .r$;
/**
 * Creates a new `FiberId`.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy;
/**
 * Creates a string representing the name of the current thread of execution
 * represented by the specified `FiberId`.
 *
 * @since 2.0.0
 * @category destructors
 */
const threadName = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .threadName */ .Q9;
/**
 * Convert a `FiberId` into an `Option<FiberId>`.
 *
 * @since 2.0.0
 * @category destructors
 */
const toOption = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .toOption */ .Er;
/**
 * Convert a `FiberId` into a `HashSet<FiberId>`.
 *
 * @since 2.0.0
 * @category destructors
 */
const toSet = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .toSet */ .Rg;
/**
 * Unsafely creates a new `FiberId`.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeMake = _internal_fiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .unsafeMake */ .t0;
//# sourceMappingURL=FiberId.js.map

/***/ }),

/***/ 6639:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ao": function() { return /* binding */ joinAs; },
/* harmony export */   "Bi": function() { return /* binding */ setAll; },
/* harmony export */   "CJ": function() { return /* binding */ getOrDefault; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "iW": function() { return /* binding */ updateManyAs; }
/* harmony export */ });
/* unused harmony exports FiberRefsSym, delete, fiberRefs, forkAs, updateAs, unsafeMake */
/* harmony import */ var _internal_fiberRefs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79049);

/**
 * @since 2.0.0
 * @category symbols
 */
const FiberRefsSym = _internal_fiberRefs_js__WEBPACK_IMPORTED_MODULE_0__/* .FiberRefsSym */ .iH;
const delete_ = _internal_fiberRefs_js__WEBPACK_IMPORTED_MODULE_0__/* .delete_ */ .$v;

/**
 * Returns a set of each `FiberRef` in this collection.
 *
 * @since 2.0.0
 * @category getters
 */
const fiberRefs = _internal_fiberRefs_js__WEBPACK_IMPORTED_MODULE_0__/* .fiberRefs */ .$x;
/**
 * Forks this collection of fiber refs as the specified child fiber id. This
 * will potentially modify the value of the fiber refs, as determined by the
 * individual fiber refs that make up the collection.
 *
 * @since 2.0.0
 * @category utils
 */
const forkAs = _internal_fiberRefs_js__WEBPACK_IMPORTED_MODULE_0__/* .forkAs */ .xN;
/**
 * Gets the value of the specified `FiberRef` in this collection of `FiberRef`
 * values if it exists or `None` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const get = _internal_fiberRefs_js__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2;
/**
 * Gets the value of the specified `FiberRef` in this collection of `FiberRef`
 * values if it exists or the `initial` value of the `FiberRef` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const getOrDefault = _internal_fiberRefs_js__WEBPACK_IMPORTED_MODULE_0__/* .getOrDefault */ .CJ;
/**
 * Joins this collection of fiber refs to the specified collection, as the
 * specified fiber id. This will perform diffing and merging to ensure
 * preservation of maximum information from both child and parent refs.
 *
 * @since 2.0.0
 * @category utils
 */
const joinAs = _internal_fiberRefs_js__WEBPACK_IMPORTED_MODULE_0__/* .joinAs */ .Ao;
/**
 * Set each ref to either its value or its default.
 *
 * @since 2.0.0
 * @category utils
 */
const setAll = _internal_fiberRefs_js__WEBPACK_IMPORTED_MODULE_0__/* .setAll */ .Bi;
/**
 * Updates the value of the specified `FiberRef` using the provided `FiberId`
 *
 * @since 2.0.0
 * @category utils
 */
const updateAs = _internal_fiberRefs_js__WEBPACK_IMPORTED_MODULE_0__/* .updateAs */ .SJ;
/**
 * Updates the values of the specified `FiberRef` & value pairs using the provided `FiberId`
 *
 * @since 2.0.0
 * @category utils
 */
const updateManyAs = _internal_fiberRefs_js__WEBPACK_IMPORTED_MODULE_0__/* .updateManyAs */ .iW;
/**
 * Note: it will not copy the provided Map, make sure to provide a fresh one.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeMake = _internal_fiberRefs_js__WEBPACK_IMPORTED_MODULE_0__/* .unsafeMake */ .t0;
/**
 * The empty collection of `FiberRef` values.
 *
 * @category constructors
 * @since 2.0.0
 */
const empty = _internal_fiberRefs_js__WEBPACK_IMPORTED_MODULE_0__/* .empty */ .cS;
//# sourceMappingURL=FiberRefs.js.map

/***/ }),

/***/ 58714:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hg": function() { return /* binding */ diff; },
/* harmony export */   "r$": function() { return /* binding */ patch; }
/* harmony export */ });
/* unused harmony exports empty, combine */
/* harmony import */ var _internal_fiberRefs_patch_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2108);

/**
 * @since 2.0.0
 * @category constructors
 */
const empty = _internal_fiberRefs_patch_js__WEBPACK_IMPORTED_MODULE_0__/* .empty */ .cS;
/**
 * Constructs a patch that describes the changes between the specified
 * collections of `FiberRef`
 *
 * @since 2.0.0
 * @category constructors
 */
const diff = _internal_fiberRefs_patch_js__WEBPACK_IMPORTED_MODULE_0__/* .diff */ .Hg;
/**
 * Combines this patch and the specified patch to create a new patch that
 * describes applying the changes from this patch and the specified patch
 * sequentially.
 *
 * @since 2.0.0
 * @category constructors
 */
const combine = _internal_fiberRefs_patch_js__WEBPACK_IMPORTED_MODULE_0__/* .combine */ .$e;
/**
 * Applies the changes described by this patch to the specified collection
 * of `FiberRef` values.
 *
 * @since 2.0.0
 * @category destructors
 */
const patch = _internal_fiberRefs_patch_js__WEBPACK_IMPORTED_MODULE_0__/* .patch */ .r$;
//# sourceMappingURL=FiberRefsPatch.js.map

/***/ }),

/***/ 32860:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aT": function() { return /* binding */ FiberStatus_done; },
  "_b": function() { return /* binding */ FiberStatus_isDone; },
  "An": function() { return /* binding */ FiberStatus_isRunning; },
  "sy": function() { return /* binding */ FiberStatus_isSuspended; },
  "wC": function() { return /* binding */ FiberStatus_running; },
  "rv": function() { return /* binding */ FiberStatus_suspended; }
});

// UNUSED EXPORTS: FiberStatusTypeId, isFiberStatus

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equal.js
var Equal = __webpack_require__(67492);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Hash.js
var Hash = __webpack_require__(89379);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var Predicate = __webpack_require__(71335);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/fiberStatus.js




const FiberStatusSymbolKey = "effect/FiberStatus";
/** @internal */
const FiberStatusTypeId = /*#__PURE__*/Symbol.for(FiberStatusSymbolKey);
/** @internal */
const OP_DONE = "Done";
/** @internal */
const OP_RUNNING = "Running";
/** @internal */
const OP_SUSPENDED = "Suspended";
const DoneHash = /*#__PURE__*/Hash/* string */.Z_(`${FiberStatusSymbolKey}-${OP_DONE}`);
/** @internal */
class Done {
  [FiberStatusTypeId] = FiberStatusTypeId;
  _tag = OP_DONE;
  [Hash/* symbol */.NA]() {
    return DoneHash;
  }
  [Equal/* symbol */.NA](that) {
    return isFiberStatus(that) && that._tag === OP_DONE;
  }
}
/** @internal */
class Running {
  runtimeFlags;
  [FiberStatusTypeId] = FiberStatusTypeId;
  _tag = OP_RUNNING;
  constructor(runtimeFlags) {
    this.runtimeFlags = runtimeFlags;
  }
  [Hash/* symbol */.NA]() {
    return (0,Function/* pipe */.zG)(Hash/* hash */.vp(FiberStatusSymbolKey), Hash/* combine */.$e(Hash/* hash */.vp(this._tag)), Hash/* combine */.$e(Hash/* hash */.vp(this.runtimeFlags)), Hash/* cached */.HX(this));
  }
  [Equal/* symbol */.NA](that) {
    return isFiberStatus(that) && that._tag === OP_RUNNING && this.runtimeFlags === that.runtimeFlags;
  }
}
/** @internal */
class Suspended {
  runtimeFlags;
  blockingOn;
  [FiberStatusTypeId] = FiberStatusTypeId;
  _tag = OP_SUSPENDED;
  constructor(runtimeFlags, blockingOn) {
    this.runtimeFlags = runtimeFlags;
    this.blockingOn = blockingOn;
  }
  [Hash/* symbol */.NA]() {
    return (0,Function/* pipe */.zG)(Hash/* hash */.vp(FiberStatusSymbolKey), Hash/* combine */.$e(Hash/* hash */.vp(this._tag)), Hash/* combine */.$e(Hash/* hash */.vp(this.runtimeFlags)), Hash/* combine */.$e(Hash/* hash */.vp(this.blockingOn)), Hash/* cached */.HX(this));
  }
  [Equal/* symbol */.NA](that) {
    return isFiberStatus(that) && that._tag === OP_SUSPENDED && this.runtimeFlags === that.runtimeFlags && Equal/* equals */.fS(this.blockingOn, that.blockingOn);
  }
}
/** @internal */
const done = /*#__PURE__*/new Done();
/** @internal */
const running = runtimeFlags => new Running(runtimeFlags);
/** @internal */
const suspended = (runtimeFlags, blockingOn) => new Suspended(runtimeFlags, blockingOn);
/** @internal */
const isFiberStatus = u => (0,Predicate/* hasProperty */.l$)(u, FiberStatusTypeId);
/** @internal */
const isDone = self => self._tag === OP_DONE;
/** @internal */
const isRunning = self => self._tag === OP_RUNNING;
/** @internal */
const isSuspended = self => self._tag === OP_SUSPENDED;
//# sourceMappingURL=fiberStatus.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/FiberStatus.js

/**
 * @since 2.0.0
 * @category symbols
 */
const FiberStatus_FiberStatusTypeId = FiberStatusTypeId;
/**
 * @since 2.0.0
 * @category constructors
 */
const FiberStatus_done = done;
/**
 * @since 2.0.0
 * @category constructors
 */
const FiberStatus_running = running;
/**
 * @since 2.0.0
 * @category constructors
 */
const FiberStatus_suspended = suspended;
/**
 * Returns `true` if the specified value is a `FiberStatus`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const FiberStatus_isFiberStatus = isFiberStatus;
/**
 * Returns `true` if the specified `FiberStatus` is `Done`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const FiberStatus_isDone = isDone;
/**
 * Returns `true` if the specified `FiberStatus` is `Running`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const FiberStatus_isRunning = isRunning;
/**
 * Returns `true` if the specified `FiberStatus` is `Suspended`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const FiberStatus_isSuspended = isSuspended;
//# sourceMappingURL=FiberStatus.js.map

/***/ }),

/***/ 17316:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OB": function() { return /* binding */ dual; },
/* harmony export */   "Q1": function() { return /* binding */ constVoid; },
/* harmony export */   "W8": function() { return /* binding */ constTrue; },
/* harmony export */   "a9": function() { return /* binding */ constant; },
/* harmony export */   "jv": function() { return /* binding */ constFalse; },
/* harmony export */   "mf": function() { return /* binding */ isFunction; },
/* harmony export */   "r5": function() { return /* binding */ constUndefined; },
/* harmony export */   "yR": function() { return /* binding */ identity; },
/* harmony export */   "zG": function() { return /* binding */ pipe; }
/* harmony export */ });
/* unused harmony exports apply, satisfies, unsafeCoerce, constNull, flip, compose, absurd, tupled, untupled, flow, hole, SK */
/**
 * Tests if a value is a `function`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isFunction } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isFunction(isFunction), true)
 * assert.deepStrictEqual(isFunction("function"), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isFunction = input => typeof input === "function";
/**
 * Creates a function that can be used in a data-last (aka `pipe`able) or
 * data-first style.
 *
 * The first parameter to `dual` is either the arity of the uncurried function
 * or a predicate that determines if the function is being used in a data-first
 * or data-last style.
 *
 * Using the arity is the most common use case, but there are some cases where
 * you may want to use a predicate. For example, if you have a function that
 * takes an optional argument, you can use a predicate to determine if the
 * function is being used in a data-first or data-last style.
 *
 * You can pass either the arity of the uncurried function or a predicate
 * which determines if the function is being used in a data-first or
 * data-last style.
 *
 * **Example** (Using arity to determine data-first or data-last style)
 *
 * ```ts
 * import { dual, pipe } from "effect/Function"
 *
 * const sum = dual<
 *   (that: number) => (self: number) => number,
 *   (self: number, that: number) => number
 * >(2, (self, that) => self + that)
 *
 * console.log(sum(2, 3)) // 5
 * console.log(pipe(2, sum(3))) // 5
 * ```
 *
 * **Example** (Using call signatures to define the overloads)
 *
 * ```ts
 * import { dual, pipe } from "effect/Function"
 *
 * const sum: {
 *   (that: number): (self: number) => number
 *   (self: number, that: number): number
 * } = dual(2, (self: number, that: number): number => self + that)
 *
 * console.log(sum(2, 3)) // 5
 * console.log(pipe(2, sum(3))) // 5
 * ```
 *
 * **Example** (Using a predicate to determine data-first or data-last style)
 *
 * ```ts
 * import { dual, pipe } from "effect/Function"
 *
 * const sum = dual<
 *   (that: number) => (self: number) => number,
 *   (self: number, that: number) => number
 * >(
 *   (args) => args.length === 2,
 *   (self, that) => self + that
 * )
 *
 * console.log(sum(2, 3)) // 5
 * console.log(pipe(2, sum(3))) // 5
 * ```
 *
 * @since 2.0.0
 */
const dual = function (arity, body) {
  if (typeof arity === "function") {
    return function () {
      if (arity(arguments)) {
        // @ts-expect-error
        return body.apply(this, arguments);
      }
      return self => body(self, ...arguments);
    };
  }
  switch (arity) {
    case 0:
    case 1:
      throw new RangeError(`Invalid arity ${arity}`);
    case 2:
      return function (a, b) {
        if (arguments.length >= 2) {
          return body(a, b);
        }
        return function (self) {
          return body(self, a);
        };
      };
    case 3:
      return function (a, b, c) {
        if (arguments.length >= 3) {
          return body(a, b, c);
        }
        return function (self) {
          return body(self, a, b);
        };
      };
    case 4:
      return function (a, b, c, d) {
        if (arguments.length >= 4) {
          return body(a, b, c, d);
        }
        return function (self) {
          return body(self, a, b, c);
        };
      };
    case 5:
      return function (a, b, c, d, e) {
        if (arguments.length >= 5) {
          return body(a, b, c, d, e);
        }
        return function (self) {
          return body(self, a, b, c, d);
        };
      };
    default:
      return function () {
        if (arguments.length >= arity) {
          // @ts-expect-error
          return body.apply(this, arguments);
        }
        const args = arguments;
        return function (self) {
          return body(self, ...args);
        };
      };
  }
};
/**
 * Apply a function to a given value.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, apply } from "effect/Function"
 * import { length } from "effect/String"
 *
 * assert.deepStrictEqual(pipe(length, apply("hello")), 5)
 * ```
 *
 * @since 2.0.0
 */
const apply = a => self => self(a);
/**
 * The identity function, i.e. A function that returns its input argument.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { identity } from "effect/Function"
 *
 * assert.deepStrictEqual(identity(5), 5)
 * ```
 *
 * @since 2.0.0
 */
const identity = a => a;
/**
 * A function that ensures that the type of an expression matches some type,
 * without changing the resulting type of that expression.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { satisfies } from "effect/Function"
 *
 * const test1 = satisfies<number>()(5 as const)
 *     //^? const test: 5
 *     // @ts-expect-error
 * const test2 = satisfies<string>()(5)
 *     //^? Argument of type 'number' is not assignable to parameter of type 'string'
 *
 * assert.deepStrictEqual(satisfies<number>()(5), 5)
 * ```
 *
 * @since 2.0.0
 */
const satisfies = () => b => b;
/**
 * Casts the result to the specified type.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { unsafeCoerce, identity } from "effect/Function"
 *
 * assert.deepStrictEqual(unsafeCoerce, identity)
 * ```
 *
 * @since 2.0.0
 */
const unsafeCoerce = (/* unused pure expression or super */ null && (identity));
/**
 * Creates a constant value that never changes.
 *
 * This is useful when you want to pass a value to a higher-order function (a function that takes another function as its argument)
 * and want that inner function to always use the same value, no matter how many times it is called.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { constant } from "effect/Function"
 *
 * const constNull = constant(null)
 *
 * assert.deepStrictEqual(constNull(), null)
 * assert.deepStrictEqual(constNull(), null)
 * ```
 *
 * @since 2.0.0
 */
const constant = value => () => value;
/**
 * A thunk that returns always `true`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { constTrue } from "effect/Function"
 *
 * assert.deepStrictEqual(constTrue(), true)
 * ```
 *
 * @since 2.0.0
 */
const constTrue = /*#__PURE__*/constant(true);
/**
 * A thunk that returns always `false`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { constFalse } from "effect/Function"
 *
 * assert.deepStrictEqual(constFalse(), false)
 * ```
 *
 * @since 2.0.0
 */
const constFalse = /*#__PURE__*/constant(false);
/**
 * A thunk that returns always `null`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { constNull } from "effect/Function"
 *
 * assert.deepStrictEqual(constNull(), null)
 * ```
 *
 * @since 2.0.0
 */
const constNull = /*#__PURE__*/(/* unused pure expression or super */ null && (constant(null)));
/**
 * A thunk that returns always `undefined`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { constUndefined } from "effect/Function"
 *
 * assert.deepStrictEqual(constUndefined(), undefined)
 * ```
 *
 * @since 2.0.0
 */
const constUndefined = /*#__PURE__*/constant(undefined);
/**
 * A thunk that returns always `void`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { constVoid } from "effect/Function"
 *
 * assert.deepStrictEqual(constVoid(), undefined)
 * ```
 *
 * @since 2.0.0
 */
const constVoid = constUndefined;
/**
 * Reverses the order of arguments for a curried function.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { flip } from "effect/Function"
 *
 * const f = (a: number) => (b: string) => a - b.length
 *
 * assert.deepStrictEqual(flip(f)('aaa')(2), -1)
 * ```
 *
 * @since 2.0.0
 */
const flip = f => (...b) => (...a) => f(...a)(...b);
/**
 * Composes two functions, `ab` and `bc` into a single function that takes in an argument `a` of type `A` and returns a result of type `C`.
 * The result is obtained by first applying the `ab` function to `a` and then applying the `bc` function to the result of `ab`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { compose } from "effect/Function"
 *
 * const increment = (n: number) => n + 1;
 * const square = (n: number) => n * n;
 *
 * assert.strictEqual(compose(increment, square)(2), 9);
 * ```
 *
 * @since 2.0.0
 */
const compose = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (ab, bc) => a => bc(ab(a)))));
/**
 * The `absurd` function is a stub for cases where a value of type `never` is encountered in your code,
 * meaning that it should be impossible for this code to be executed.
 *
 * This function is particularly useful when it's necessary to specify that certain cases are impossible.
 *
 * @since 2.0.0
 */
const absurd = _ => {
  throw new Error("Called `absurd` function which should be uncallable");
};
/**
 * Creates a   version of this function: instead of `n` arguments, it accepts a single tuple argument.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { tupled } from "effect/Function"
 *
 * const sumTupled = tupled((x: number, y: number): number => x + y)
 *
 * assert.deepStrictEqual(sumTupled([1, 2]), 3)
 * ```
 *
 * @since 2.0.0
 */
const tupled = f => a => f(...a);
/**
 * Inverse function of `tupled`
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { untupled } from "effect/Function"
 *
 * const getFirst = untupled(<A, B>(tuple: [A, B]): A => tuple[0])
 *
 * assert.deepStrictEqual(getFirst(1, 2), 1)
 * ```
 *
 * @since 2.0.0
 */
const untupled = f => (...a) => f(a);
function pipe(a, ab, bc, cd, de, ef, fg, gh, hi) {
  switch (arguments.length) {
    case 1:
      return a;
    case 2:
      return ab(a);
    case 3:
      return bc(ab(a));
    case 4:
      return cd(bc(ab(a)));
    case 5:
      return de(cd(bc(ab(a))));
    case 6:
      return ef(de(cd(bc(ab(a)))));
    case 7:
      return fg(ef(de(cd(bc(ab(a))))));
    case 8:
      return gh(fg(ef(de(cd(bc(ab(a)))))));
    case 9:
      return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
    default:
      {
        let ret = arguments[0];
        for (let i = 1; i < arguments.length; i++) {
          ret = arguments[i](ret);
        }
        return ret;
      }
  }
}
function flow(ab, bc, cd, de, ef, fg, gh, hi, ij) {
  switch (arguments.length) {
    case 1:
      return ab;
    case 2:
      return function () {
        return bc(ab.apply(this, arguments));
      };
    case 3:
      return function () {
        return cd(bc(ab.apply(this, arguments)));
      };
    case 4:
      return function () {
        return de(cd(bc(ab.apply(this, arguments))));
      };
    case 5:
      return function () {
        return ef(de(cd(bc(ab.apply(this, arguments)))));
      };
    case 6:
      return function () {
        return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
      };
    case 7:
      return function () {
        return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
      };
    case 8:
      return function () {
        return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
      };
    case 9:
      return function () {
        return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
      };
  }
  return;
}
/**
 * Type hole simulation.
 *
 * @since 2.0.0
 */
const hole = /*#__PURE__*/(/* unused pure expression or super */ null && (unsafeCoerce(absurd)));
/**
 * The SK combinator, also known as the "S-K combinator" or "S-combinator", is a fundamental combinator in the
 * lambda calculus and the SKI combinator calculus.
 *
 * This function is useful for discarding the first argument passed to it and returning the second argument.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { SK } from "effect/Function";
 *
 * assert.deepStrictEqual(SK(0, "hello"), "hello")
 * ```
 *
 * @since 2.0.0
 */
const SK = (_, b) => b;
//# sourceMappingURL=Function.js.map

/***/ }),

/***/ 4726:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ globalValue; }
/* harmony export */ });
/* harmony import */ var _internal_version_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69500);
/**
 * The `GlobalValue` module ensures that a single instance of a value is created globally,
 * even when modules are imported multiple times (e.g., due to mixing CommonJS and ESM builds)
 * or during hot-reloading in development environments like Next.js or Remix.
 *
 * It achieves this by using a versioned global store, identified by a unique `Symbol` tied to
 * the current version of the `effect` library. The store holds values that are keyed by an identifier,
 * allowing the reuse of previously computed instances across imports or reloads.
 *
 * This pattern is particularly useful in scenarios where frequent reloading can cause services or
 * single-instance objects to be recreated unnecessarily, such as in development environments with hot-reloading.
 *
 * @since 2.0.0
 */

const globalStoreId = `effect/GlobalValue/globalStoreId/${/*#__PURE__*/_internal_version_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentVersion */ .w()}`;
let globalStore;
/**
 * Retrieves or computes a global value associated with the given `id`. If the value for this `id`
 * has already been computed, it will be returned from the global store. If it does not exist yet,
 * the provided `compute` function will be executed to compute the value, store it, and then return it.
 *
 * This ensures that even in cases where the module is imported multiple times (e.g., in mixed environments
 * like CommonJS and ESM, or during hot-reloading in development), the value is computed only once and reused
 * thereafter.
 *
 * @example
 * ```ts
 * import { globalValue } from "effect/GlobalValue"
 *
 * // This cache will persist as long as the module is running,
 * // even if reloaded or imported elsewhere
 * const myCache = globalValue(
 *   Symbol.for("myCache"),
 *   () => new WeakMap<object, number>()
 * )
 * ```
 *
 * @since 2.0.0
 */
const globalValue = (id, compute) => {
  if (!globalStore) {
    // @ts-expect-error
    globalThis[globalStoreId] ??= new Map();
    // @ts-expect-error
    globalStore = globalThis[globalStoreId];
  }
  if (!globalStore.has(id)) {
    globalStore.set(id, compute());
  }
  return globalStore.get(id);
};
//# sourceMappingURL=GlobalValue.js.map

/***/ }),

/***/ 89379:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "Fh": function() { return /* binding */ structure; },
/* harmony export */   "HX": function() { return /* binding */ cached; },
/* harmony export */   "IX": function() { return /* binding */ array; },
/* harmony export */   "MX": function() { return /* binding */ random; },
/* harmony export */   "NA": function() { return /* binding */ symbol; },
/* harmony export */   "Rx": function() { return /* binding */ number; },
/* harmony export */   "Z_": function() { return /* binding */ string; },
/* harmony export */   "vp": function() { return /* binding */ hash; }
/* harmony export */ });
/* unused harmony exports optimize, isHash, structureKeys */
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17316);
/* harmony import */ var _GlobalValue_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4726);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71335);
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70762);
/**
 * @since 2.0.0
 */




/** @internal */
const randomHashCache = /*#__PURE__*/(0,_GlobalValue_js__WEBPACK_IMPORTED_MODULE_0__/* .globalValue */ .K)( /*#__PURE__*/Symbol.for("effect/Hash/randomHashCache"), () => new WeakMap());
/**
 * @since 2.0.0
 * @category symbols
 */
const symbol = /*#__PURE__*/Symbol.for("effect/Hash");
/**
 * @since 2.0.0
 * @category hashing
 */
const hash = self => {
  if (_Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .structuralRegionState.enabled */ .uL.enabled === true) {
    return 0;
  }
  switch (typeof self) {
    case "number":
      return number(self);
    case "bigint":
      return string(self.toString(10));
    case "boolean":
      return string(String(self));
    case "symbol":
      return string(String(self));
    case "string":
      return string(self);
    case "undefined":
      return string("undefined");
    case "function":
    case "object":
      {
        if (self === null) {
          return string("null");
        } else if (self instanceof Date) {
          return hash(self.toISOString());
        } else if (self instanceof URL) {
          return hash(self.href);
        } else if (isHash(self)) {
          return self[symbol]();
        } else {
          return random(self);
        }
      }
    default:
      throw new Error(`BUG: unhandled typeof ${typeof self} - please report an issue at https://github.com/Effect-TS/effect/issues`);
  }
};
/**
 * @since 2.0.0
 * @category hashing
 */
const random = self => {
  if (!randomHashCache.has(self)) {
    randomHashCache.set(self, number(Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)));
  }
  return randomHashCache.get(self);
};
/**
 * @since 2.0.0
 * @category hashing
 */
const combine = b => self => self * 53 ^ b;
/**
 * @since 2.0.0
 * @category hashing
 */
const optimize = n => n & 0xbfffffff | n >>> 1 & 0x40000000;
/**
 * @since 2.0.0
 * @category guards
 */
const isHash = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_2__/* .hasProperty */ .l$)(u, symbol);
/**
 * @since 2.0.0
 * @category hashing
 */
const number = n => {
  if (n !== n || n === Infinity) {
    return 0;
  }
  let h = n | 0;
  if (h !== n) {
    h ^= n * 0xffffffff;
  }
  while (n > 0xffffffff) {
    h ^= n /= 0xffffffff;
  }
  return optimize(h);
};
/**
 * @since 2.0.0
 * @category hashing
 */
const string = str => {
  let h = 5381,
    i = str.length;
  while (i) {
    h = h * 33 ^ str.charCodeAt(--i);
  }
  return optimize(h);
};
/**
 * @since 2.0.0
 * @category hashing
 */
const structureKeys = (o, keys) => {
  let h = 12289;
  for (let i = 0; i < keys.length; i++) {
    h ^= (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(string(keys[i]), combine(hash(o[keys[i]])));
  }
  return optimize(h);
};
/**
 * @since 2.0.0
 * @category hashing
 */
const structure = o => structureKeys(o, Object.keys(o));
/**
 * @since 2.0.0
 * @category hashing
 */
const array = arr => {
  let h = 6151;
  for (let i = 0; i < arr.length; i++) {
    h = (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(h, combine(hash(arr[i])));
  }
  return optimize(h);
};
/**
 * @since 2.0.0
 * @category hashing
 */
const cached = function () {
  if (arguments.length === 1) {
    const self = arguments[0];
    return function (hash) {
      Object.defineProperty(self, symbol, {
        value() {
          return hash;
        },
        enumerable: false
      });
      return hash;
    };
  }
  const self = arguments[0];
  const hash = arguments[1];
  Object.defineProperty(self, symbol, {
    value() {
      return hash;
    },
    enumerable: false
  });
  return hash;
};
//# sourceMappingURL=Hash.js.map

/***/ }),

/***/ 61952:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cS": function() { return /* binding */ empty; },
  "Ed": function() { return /* binding */ forEach; },
  "EE": function() { return /* binding */ fromIterable; },
  "U2": function() { return /* binding */ get; },
  "xb": function() { return /* binding */ isEmpty; },
  "XP": function() { return /* binding */ keys; },
  "UI": function() { return /* binding */ map; },
  "cq": function() { return /* binding */ modifyAt; },
  "JG": function() { return /* binding */ mutate; },
  "u4": function() { return /* binding */ reduce; },
  "Od": function() { return /* binding */ remove; },
  "t8": function() { return /* binding */ set; },
  "dp": function() { return /* binding */ size; }
});

// UNUSED EXPORTS: beginMutation, compact, endMutation, entries, every, filter, filterMap, findFirst, flatMap, getHash, has, hasHash, isHashMap, keySet, make, modify, modifyHash, removeMany, some, toEntries, toValues, union, unsafeGet, values

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/hashMap.js + 5 modules
var hashMap = __webpack_require__(67733);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/hashSet.js
var hashSet = __webpack_require__(686);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/hashMap/keySet.js

/** @internal */
function keySet(self) {
  return (0,hashSet/* makeImpl */.Rd)(self);
}
//# sourceMappingURL=keySet.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/HashMap.js
/**
 * @since 2.0.0
 */


const TypeId = hashMap/* HashMapTypeId */.yh;
/**
 * @since 2.0.0
 * @category refinements
 */
const isHashMap = hashMap/* isHashMap */.c8;
/**
 * Creates a new `HashMap`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = hashMap/* empty */.cS;
/**
 * Constructs a new `HashMap` from an array of key/value pairs.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = hashMap/* make */.Sy;
/**
 * Creates a new `HashMap` from an iterable collection of key/value pairs.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable = hashMap/* fromIterable */.EE;
/**
 * Checks if the `HashMap` contains any entries.
 *
 * @since 2.0.0
 * @category elements
 */
const isEmpty = hashMap/* isEmpty */.xb;
/**
 * Safely lookup the value for the specified key in the `HashMap` using the
 * internal hashing function.
 *
 * @since 2.0.0
 * @category elements
 */
const get = hashMap/* get */.U2;
/**
 * Lookup the value for the specified key in the `HashMap` using a custom hash.
 *
 * @since 2.0.0
 * @category elements
 */
const getHash = hashMap/* getHash */.XR;
/**
 * Unsafely lookup the value for the specified key in the `HashMap` using the
 * internal hashing function.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeGet = hashMap/* unsafeGet */.MH;
/**
 * Checks if the specified key has an entry in the `HashMap`.
 *
 * @since 2.0.0
 * @category elements
 */
const has = hashMap/* has */.e$;
/**
 * Checks if the specified key has an entry in the `HashMap` using a custom
 * hash.
 *
 * @since 2.0.0
 * @category elements
 */
const hasHash = hashMap/* hasHash */.u9;
/**
 * Sets the specified key to the specified value using the internal hashing
 * function.
 *
 * @since 2.0.0
 */
const set = hashMap/* set */.t8;
/**
 * Returns an `IterableIterator` of the keys within the `HashMap`.
 *
 * @since 2.0.0
 * @category getters
 */
const keys = hashMap/* keys */.XP;
/**
 * Returns a `HashSet` of keys within the `HashMap`.
 *
 * @since 2.0.0
 * @category getter
 */
const HashMap_keySet = keySet;
/**
 * Returns an `IterableIterator` of the values within the `HashMap`.
 *
 * @since 2.0.0
 * @category getters
 */
const values = hashMap/* values */.VO;
/**
 * Returns an `Array` of the values within the `HashMap`.
 *
 * @since 3.13.0
 * @category getters
 */
const toValues = self => Array.from(values(self));
/**
 * Returns an `IterableIterator` of the entries within the `HashMap`.
 *
 * @since 2.0.0
 * @category getters
 */
const entries = hashMap/* entries */.qh;
/**
 * Returns an `Array<[K, V]>` of the entries within the `HashMap`.
 *
 * @since 2.0.0
 * @category getters
 */
const toEntries = self => Array.from(entries(self));
/**
 * Returns the number of entries within the `HashMap`.
 *
 * @since 2.0.0
 * @category getters
 */
const size = hashMap/* size */.dp;
/**
 * Marks the `HashMap` as mutable.
 *
 * @since 2.0.0
 */
const beginMutation = hashMap/* beginMutation */.iy;
/**
 * Marks the `HashMap` as immutable.
 *
 * @since 2.0.0
 */
const endMutation = hashMap/* endMutation */.Rx;
/**
 * Mutates the `HashMap` within the context of the provided function.
 *
 * @since 2.0.0
 */
const mutate = hashMap/* mutate */.JG;
/**
 * Set or remove the specified key in the `HashMap` using the specified
 * update function. The value of the specified key will be computed using the
 * provided hash.
 *
 * The update function will be invoked with the current value of the key if it
 * exists, or `None` if no such value exists.
 *
 * @since 2.0.0
 */
const modifyAt = hashMap/* modifyAt */.cq;
/**
 * Alter the value of the specified key in the `HashMap` using the specified
 * update function. The value of the specified key will be computed using the
 * provided hash.
 *
 * The update function will be invoked with the current value of the key if it
 * exists, or `None` if no such value exists.
 *
 * This function will always either update or insert a value into the `HashMap`.
 *
 * @since 2.0.0
 */
const modifyHash = hashMap/* modifyHash */.Hp;
/**
 * Updates the value of the specified key within the `HashMap` if it exists.
 *
 * @since 2.0.0
 */
const modify = hashMap/* modify */.Pj;
/**
 * Performs a union of this `HashMap` and that `HashMap`.
 *
 * @since 2.0.0
 */
const union = hashMap/* union */.G0;
/**
 * Remove the entry for the specified key in the `HashMap` using the internal
 * hashing function.
 *
 * @since 2.0.0
 */
const remove = hashMap/* remove */.Od;
/**
 * Removes all entries in the `HashMap` which have the specified keys.
 *
 * @since 2.0.0
 */
const removeMany = hashMap/* removeMany */.CS;
/**
 * Maps over the entries of the `HashMap` using the specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
const map = hashMap/* map */.UI;
/**
 * Chains over the entries of the `HashMap` using the specified function.
 *
 * **NOTE**: the hash and equal of both maps have to be the same.
 *
 * @since 2.0.0
 * @category sequencing
 */
const flatMap = hashMap/* flatMap */.VS;
/**
 * Applies the specified function to the entries of the `HashMap`.
 *
 * @since 2.0.0
 * @category traversing
 */
const forEach = hashMap/* forEach */.Ed;
/**
 * Reduces the specified state over the entries of the `HashMap`.
 *
 * @since 2.0.0
 * @category folding
 */
const reduce = hashMap/* reduce */.u4;
/**
 * Filters entries out of a `HashMap` using the specified predicate.
 *
 * @since 2.0.0
 * @category filtering
 */
const filter = hashMap/* filter */.hX;
/**
 * Filters out `None` values from a `HashMap` of `Options`s.
 *
 * @since 2.0.0
 * @category filtering
 */
const compact = hashMap/* compact */.oA;
/**
 * Maps over the entries of the `HashMap` using the specified partial function
 * and filters out `None` values.
 *
 * @since 2.0.0
 * @category filtering
 */
const filterMap = hashMap/* filterMap */.DZ;
/**
 * Returns the first element that satisfies the specified
 * predicate, or `None` if no such element exists.
 *
 * @category elements
 * @since 2.0.0
 */
const findFirst = hashMap/* findFirst */.Ew;
/**
 * Checks if any entry in a hashmap meets a specific condition.
 *
 * @since 3.13.0
 * @category elements
 */
const some = hashMap/* some */.G;
/**
 * Checks if all entries in a hashmap meets a specific condition.
 *
 * @param self - The hashmap to check.
 * @param predicate - The condition to test entries (value, key).
 *
 * @since 3.14.0
 * @category elements
 */
const every = hashMap/* every */.yW;
//# sourceMappingURL=HashMap.js.map

/***/ }),

/***/ 9551:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EE": function() { return /* binding */ fromIterable; },
/* harmony export */   "G0": function() { return /* binding */ union; },
/* harmony export */   "IH": function() { return /* binding */ add; },
/* harmony export */   "Od": function() { return /* binding */ remove; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "VS": function() { return /* binding */ flatMap; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "dp": function() { return /* binding */ size; },
/* harmony export */   "e$": function() { return /* binding */ has; },
/* harmony export */   "e5": function() { return /* binding */ difference; },
/* harmony export */   "u4": function() { return /* binding */ reduce; },
/* harmony export */   "yW": function() { return /* binding */ every; }
/* harmony export */ });
/* unused harmony exports isHashSet, some, isSubset, values, toValues, beginMutation, endMutation, mutate, intersection, toggle, forEach, filter, partition */
/* harmony import */ var _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(686);
/**
 * # HashSet
 *
 * An immutable `HashSet` provides a collection of unique values with efficient
 * lookup, insertion and removal. Once created, a `HashSet` cannot be modified;
 * any operation that would alter the set instead returns a new `HashSet` with
 * the changes. This immutability offers benefits like predictable state
 * management and easier reasoning about your code.
 *
 * ## What Problem Does It Solve?
 *
 * `HashSet` solves the problem of maintaining an unsorted collection where each
 * value appears exactly once, with fast operations for checking membership and
 * adding/removing values.
 *
 * ## When to Use
 *
 * Use `HashSet` when you need:
 *
 * - A collection with no duplicate values
 * - Efficient membership testing (**`O(1)`** average complexity)
 * - Set operations like union, intersection, and difference
 * - An immutable data structure that preserves functional programming patterns
 *
 * ## Advanced Features
 *
 * HashSet provides operations for:
 *
 * - Transforming sets with map and flatMap
 * - Filtering elements with filter
 * - Combining sets with union, intersection and difference
 * - Performance optimizations via mutable operations in controlled contexts
 *
 * ## Performance Characteristics
 *
 * - **Lookup** operations ({@link module:HashSet.has}): **`O(1)`** average time
 *   complexity
 * - **Insertion** operations ({@link module:HashSet.add}): **`O(1)`** average time
 *   complexity
 * - **Removal** operations ({@link module:HashSet.remove}): **`O(1)`** average
 *   time complexity
 * - **Set** operations ({@link module:HashSet.union},
 *   {@link module:HashSet.intersection}): **`O(n)`** where n is the size of the
 *   smaller set
 * - **Iteration**: **`O(n)`** where n is the size of the set
 *
 * The HashSet data structure implements the following traits:
 *
 * - {@link Iterable}: allows iterating over the values in the set
 * - {@link Equal}: allows comparing two sets for value-based equality
 * - {@link Pipeable}: allows chaining operations with the pipe operator
 * - {@link Inspectable}: allows inspecting the contents of the set
 *
 * ## Operations Reference
 *
 * | Category     | Operation                           | Description                                 | Complexity |
 * | ------------ | ----------------------------------- | ------------------------------------------- | ---------- |
 * | constructors | {@link module:HashSet.empty}        | Creates an empty HashSet                    | O(1)       |
 * | constructors | {@link module:HashSet.fromIterable} | Creates a HashSet from an iterable          | O(n)       |
 * | constructors | {@link module:HashSet.make}         | Creates a HashSet from multiple values      | O(n)       |
 * |              |                                     |                                             |            |
 * | elements     | {@link module:HashSet.has}          | Checks if a value exists in the set         | O(1) avg   |
 * | elements     | {@link module:HashSet.some}         | Checks if any element satisfies a predicate | O(n)       |
 * | elements     | {@link module:HashSet.every}        | Checks if all elements satisfy a predicate  | O(n)       |
 * | elements     | {@link module:HashSet.isSubset}     | Checks if a set is a subset of another      | O(n)       |
 * |              |                                     |                                             |            |
 * | getters      | {@link module:HashSet.values}       | Gets an iterator of all values              | O(1)       |
 * | getters      | {@link module:HashSet.toValues}     | Gets an array of all values                 | O(n)       |
 * | getters      | {@link module:HashSet.size}         | Gets the number of elements                 | O(1)       |
 * |              |                                     |                                             |            |
 * | mutations    | {@link module:HashSet.add}          | Adds a value to the set                     | O(1) avg   |
 * | mutations    | {@link module:HashSet.remove}       | Removes a value from the set                | O(1) avg   |
 * | mutations    | {@link module:HashSet.toggle}       | Toggles a value's presence                  | O(1) avg   |
 * |              |                                     |                                             |            |
 * | operations   | {@link module:HashSet.difference}   | Computes set difference (A - B)             | O(n)       |
 * | operations   | {@link module:HashSet.intersection} | Computes set intersection (A ∩ B)           | O(n)       |
 * | operations   | {@link module:HashSet.union}        | Computes set union (A ∪ B)                  | O(n)       |
 * |              |                                     |                                             |            |
 * | mapping      | {@link module:HashSet.map}          | Transforms each element                     | O(n)       |
 * |              |                                     |                                             |            |
 * | sequencing   | {@link module:HashSet.flatMap}      | Transforms and flattens elements            | O(n)       |
 * |              |                                     |                                             |            |
 * | traversing   | {@link module:HashSet.forEach}      | Applies a function to each element          | O(n)       |
 * |              |                                     |                                             |            |
 * | folding      | {@link module:HashSet.reduce}       | Reduces the set to a single value           | O(n)       |
 * |              |                                     |                                             |            |
 * | filtering    | {@link module:HashSet.filter}       | Keeps elements that satisfy a predicate     | O(n)       |
 * |              |                                     |                                             |            |
 * | partitioning | {@link module:HashSet.partition}    | Splits into two sets by a predicate         | O(n)       |
 *
 * ## Notes
 *
 * ### Composability with the Effect Ecosystem:
 *
 * This `HashSet` is designed to work seamlessly within the Effect ecosystem. It
 * implements the {@link Iterable}, {@link Equal}, {@link Pipeable}, and
 * {@link Inspectable} traits from Effect. This ensures compatibility with other
 * Effect data structures and functionalities. For example, you can easily use
 * Effect's `pipe` method to chain operations on the `HashSet`.
 *
 * **Equality of Elements with Effect's {@link Equal `Equal`} Trait:**
 *
 * This `HashSet` relies on Effect's {@link Equal} trait to determine the
 * uniqueness of elements within the set. The way equality is checked depends on
 * the type of the elements:
 *
 * - **Primitive Values:** For primitive JavaScript values like strings, numbers,
 *   booleans, `null`, and `undefined`, equality is determined by their value
 *   (similar to the `===` operator).
 * - **Objects and Custom Types:** For objects and other custom types, equality is
 *   determined by whether those types implement the {@link Equal} interface
 *   themselves. If an element type implements `Equal`, the `HashSet` will
 *   delegate to that implementation to perform the equality check. This allows
 *   you to define custom logic for determining when two instances of your
 *   objects should be considered equal based on their properties, rather than
 *   just their object identity.
 *
 * ```ts
 * import { Equal, Hash, HashSet } from "effect"
 *
 * class Person implements Equal.Equal {
 *   constructor(
 *     readonly id: number, // Unique identifier
 *     readonly name: string,
 *     readonly age: number
 *   ) {}
 *
 *   // Define equality based on id, name, and age
 *   [Equal.symbol](that: Equal.Equal): boolean {
 *     if (that instanceof Person) {
 *       return (
 *         Equal.equals(this.id, that.id) &&
 *         Equal.equals(this.name, that.name) &&
 *         Equal.equals(this.age, that.age)
 *       )
 *     }
 *     return false
 *   }
 *
 *   // Generate a hash code based on the unique id
 *   [Hash.symbol](): number {
 *     return Hash.hash(this.id)
 *   }
 * }
 *
 * // Creating a HashSet with objects that implement the Equal interface
 * const set = HashSet.empty().pipe(
 *   HashSet.add(new Person(1, "Alice", 30)),
 *   HashSet.add(new Person(1, "Alice", 30))
 * )
 *
 * // HashSet recognizes them as equal, so only one element is stored
 * console.log(HashSet.size(set))
 * // Output: 1
 * ```
 *
 * **Simplifying Equality and Hashing with `Data` and `Schema`:**
 *
 * Effect's {@link Data} and {@link Schema `Schema.Data`} modules offer powerful
 * ways to automatically handle the implementation of both the {@link Equal} and
 * {@link Hash} traits for your custom data structures.
 *
 * - **`Data` Module:** By using constructors like `Data.struct`, `Data.tuple`,
 *   `Data.array`, or `Data.case` to define your data types, Effect
 *   automatically generates the necessary implementations for value-based
 *   equality and consistent hashing. This significantly reduces boilerplate and
 *   ensures correctness.
 *
 * ```ts
 * import { HashSet, Data, Equal } from "effect"
 * import assert from "node:assert/strict"
 *
 * // Data.* implements the `Equal` traits for us
 * const person1 = Data.struct({ id: 1, name: "Alice", age: 30 })
 * const person2 = Data.struct({ id: 1, name: "Alice", age: 30 })
 *
 * assert(Equal.equals(person1, person2))
 *
 * const set = HashSet.empty().pipe(
 *   HashSet.add(person1),
 *   HashSet.add(person2)
 * )
 *
 * // HashSet recognizes them as equal, so only one element is stored
 * console.log(HashSet.size(set)) // Output: 1
 * ```
 *
 * - **`Schema` Module:** When defining data schemas using the {@link Schema}
 *   module, you can use `Schema.Data` to automatically include the `Equal` and
 *   `Hash` traits in the decoded objects. This is particularly important when
 *   working with `HashSet`. **For decoded objects to be correctly recognized as
 *   equal within a `HashSet`, ensure that the schema for those objects is
 *   defined using `Schema.Data`.**
 *
 * ```ts
 * import { Equal, HashSet, Schema } from "effect"
 * import assert from "node:assert/strict"
 *
 * // Schema.Data implements the `Equal` traits for us
 * const PersonSchema = Schema.Data(
 *   Schema.Struct({
 *     id: Schema.Number,
 *     name: Schema.String,
 *     age: Schema.Number
 *   })
 * )
 *
 * const Person = Schema.decode(PersonSchema)
 *
 * const person1 = Person({ id: 1, name: "Alice", age: 30 })
 * const person2 = Person({ id: 1, name: "Alice", age: 30 })
 *
 * assert(Equal.equals(person1, person2)) // Output: true
 *
 * const set = HashSet.empty().pipe(
 *   HashSet.add(person1),
 *   HashSet.add(person2)
 * )
 *
 * // HashSet thanks to Schema.Data implementation of the `Equal` trait, recognizes the two Person as equal, so only one element is stored
 * console.log(HashSet.size(set)) // Output: 1
 * ```
 *
 * ### Interoperability with the JavaScript Runtime:
 *
 * To interoperate with the regular JavaScript runtime, Effect's `HashSet`
 * provides methods to access its elements in formats readily usable by
 * JavaScript APIs: {@link values `HashSet.values`},
 * {@link toValues `HashSet.toValues`}
 *
 * ```ts
 * import { HashSet } from "effect"
 *
 * const hashSet: HashSet.HashSet<number> = HashSet.make(1, 2, 3)
 *
 * // Using HashSet.values to convert HashSet.HashSet<A> to IterableIterator<A>
 * const iterable: IterableIterator<number> = HashSet.values(hashSet)
 *
 * console.log(...iterable) // Logs:  1 2 3
 *
 * // Using HashSet.toValues to convert HashSet.HashSet<A> to Array<A>
 * const array: Array<number> = HashSet.toValues(hashSet)
 *
 * console.log(array) // Logs: [ 1, 2, 3 ]
 * ```
 *
 * Be mindful of performance implications (both time and space complexity) when
 * frequently converting between Effect's immutable HashSet and mutable
 * JavaScript data structures, especially for large collections.
 *
 * @module HashSet
 * @since 2.0.0
 */

const TypeId = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .HashSetTypeId */ .TG;
/**
 * @memberof HashSet
 * @since 2.0.0
 * @category refinements
 */
const isHashSet = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .isHashSet */ .Tx;
/**
 * Creates an empty `HashSet`.
 *
 * Time complexity: **`O(1)`**
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category constructors
 * @example
 *
 * ```ts
 * import { HashSet, pipe } from "effect"
 *
 * console.log(
 *   pipe(
 *     // Provide a type argument to create a HashSet of a specific type
 *     HashSet.empty<number>(),
 *     HashSet.add(1),
 *     HashSet.add(1), // Notice the duplicate
 *     HashSet.add(2),
 *     HashSet.toValues
 *   )
 * ) // Output: [1, 2]
 * ```
 *
 * @see Other `HashSet` constructors are {@link module:HashSet.make} {@link module:HashSet.fromIterable}
 */
const empty = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .empty */ .cS;
/**
 * Creates a new `HashSet` from an iterable collection of values.
 *
 * Time complexity: **`O(n)`** where n is the number of elements in the iterable
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category constructors
 * @example
 *
 * ```ts
 * // Creating a HashSet from an Array
 * import { HashSet, pipe } from "effect"
 *
 * console.log(
 *   pipe(
 *     [1, 2, 3, 4, 5, 1, 2, 3], // Array<number> is an Iterable<number>;  Note the duplicates.
 *     HashSet.fromIterable,
 *     HashSet.toValues
 *   )
 * ) // Output: [1, 2, 3, 4, 5]
 * ```
 *
 * @example
 *
 * ```ts
 * // Creating a HashSet from a Set
 * import { HashSet, pipe } from "effect"
 *
 * console.log(
 *   pipe(
 *     new Set(["apple", "banana", "orange", "apple"]), // Set<string> is an Iterable<string>
 *     HashSet.fromIterable,
 *     HashSet.toValues
 *   )
 * ) // Output: ["apple", "banana", "orange"]
 * ```
 *
 * @example
 *
 * ```ts
 * // Creating a HashSet from a Generator
 * import { HashSet } from "effect"
 *
 * // Generator functions return iterables
 * function* fibonacci(n: number): Generator<number, void, unknown> {
 *   let [a, b] = [0, 1]
 *   for (let i = 0; i < n; i++) {
 *     yield a
 *     ;[a, b] = [b, a + b]
 *   }
 * }
 *
 * // Create a HashSet from the first 10 Fibonacci numbers
 * const fibonacciSet = HashSet.fromIterable(fibonacci(10))
 *
 * console.log(HashSet.toValues(fibonacciSet))
 * // Outputs: [0, 1, 2, 3, 5, 8, 13, 21, 34] but in unsorted order
 * ```
 *
 * @example
 *
 * ```ts
 * //  Creating a HashSet from another HashSet
 * import { HashSet, pipe } from "effect"
 *
 * console.log(
 *   pipe(
 *     // since HashSet implements the Iterable interface, we can use it to create a new HashSet
 *     HashSet.make(1, 2, 3, 4),
 *     HashSet.fromIterable,
 *     HashSet.toValues // turns the HashSet back into an array
 *   )
 * ) // Output: [1, 2, 3, 4]
 * ```
 *
 * @example
 *
 * ```ts
 * // Creating a HashSet from other Effect's data structures like Chunk
 * import { Chunk, HashSet, pipe } from "effect"
 *
 * console.log(
 *   pipe(
 *     Chunk.make(1, 2, 3, 4), // Iterable<number>
 *     HashSet.fromIterable,
 *     HashSet.toValues // turns the HashSet back into an array
 *   )
 * ) // Outputs: [1, 2, 3, 4]
 * ```
 *
 * @see Other `HashSet` constructors are {@link module:HashSet.empty} {@link module:HashSet.make}
 */
const fromIterable = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .fromIterable */ .EE;
/**
 * Construct a new `HashSet` from a variable number of values.
 *
 * Time complexity: **`O(n)`** where n is the number of elements
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category constructors
 * @example
 *
 * ```ts
 * import { Equal, Hash, HashSet, pipe } from "effect"
 * import assert from "node:assert/strict"
 *
 * class Character implements Equal.Equal {
 *   readonly name: string
 *   readonly trait: string
 *
 *   constructor(name: string, trait: string) {
 *     this.name = name
 *     this.trait = trait
 *   }
 *
 *   // Define equality based on name, and trait
 *   [Equal.symbol](that: Equal.Equal): boolean {
 *     if (that instanceof Character) {
 *       return (
 *         Equal.equals(this.name, that.name) &&
 *         Equal.equals(this.trait, that.trait)
 *       )
 *     }
 *     return false
 *   }
 *
 *   // Generate a hash code based on the sum of the character's name and trait
 *   [Hash.symbol](): number {
 *     return Hash.hash(this.name + this.trait)
 *   }
 *
 *   static readonly of = (name: string, trait: string): Character => {
 *     return new Character(name, trait)
 *   }
 * }
 *
 * assert.strictEqual(
 *   Equal.equals(
 *     HashSet.make(
 *       Character.of("Alice", "Curious"),
 *       Character.of("Alice", "Curious"),
 *       Character.of("White Rabbit", "Always late"),
 *       Character.of("Mad Hatter", "Tea enthusiast")
 *     ),
 *     // Is the same as adding each character to an empty set
 *     pipe(
 *       HashSet.empty(),
 *       HashSet.add(Character.of("Alice", "Curious")),
 *       HashSet.add(Character.of("Alice", "Curious")), // Alice tried to attend twice!
 *       HashSet.add(Character.of("White Rabbit", "Always late")),
 *       HashSet.add(Character.of("Mad Hatter", "Tea enthusiast"))
 *     )
 *   ),
 *   true,
 *   "`HashSet.make` and `HashSet.empty() + HashSet.add()` should be equal"
 * )
 *
 * assert.strictEqual(
 *   Equal.equals(
 *     HashSet.make(
 *       Character.of("Alice", "Curious"),
 *       Character.of("Alice", "Curious"),
 *       Character.of("White Rabbit", "Always late"),
 *       Character.of("Mad Hatter", "Tea enthusiast")
 *     ),
 *     HashSet.fromIterable([
 *       Character.of("Alice", "Curious"),
 *       Character.of("Alice", "Curious"),
 *       Character.of("White Rabbit", "Always late"),
 *       Character.of("Mad Hatter", "Tea enthusiast")
 *     ])
 *   ),
 *   true,
 *   "`HashSet.make` and `HashSet.fromIterable` should be equal"
 * )
 * ```
 *
 * @see Other `HashSet` constructors are {@link module:HashSet.fromIterable} {@link module:HashSet.empty}
 */
const make = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy;
/**
 * Checks if the specified value exists in the `HashSet`.
 *
 * Time complexity: **`O(1)`** average
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category elements
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(HashSet.make(0, 1, 2), HashSet.has(3)) // false
 *
 * // or piped with the pipe function
 * HashSet.make(0, 1, 2).pipe(HashSet.has(3)) // false
 *
 * // or with `data-first` API
 * HashSet.has(HashSet.make(0, 1, 2), 3) // false
 * ```
 *
 * @returns A `boolean` signaling the presence of the value in the HashSet
 * @see Other `HashSet` elements are {@link module:HashSet.some} {@link module:HashSet.every} {@link module:HashSet.isSubset}
 */
const has = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .has */ .e$;
/**
 * Check if a predicate holds true for some `HashSet` element.
 *
 * Time complexity: **`O(n)`** where n is the number of elements in the set
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category elements
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * const set: HashSet.HashSet<number> = HashSet.make(0, 1, 2)
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(
 *   set,
 *   HashSet.some((n) => n > 0)
 * ) // true
 *
 * // or piped with the pipe function
 * set.pipe(HashSet.some((n) => n > 0)) // true
 *
 * // or with `data-first` API
 * HashSet.some(set, (n) => n > 0) // true
 * ```
 *
 * @see Other `HashSet` elements are {@link module:HashSet.has} {@link module:HashSet.every} {@link module:HashSet.isSubset}
 */
const some = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .some */ .G;
/**
 * Check if a predicate holds true for every `HashSet` element.
 *
 * Time complexity is **`O(n)`** as it needs to traverse the whole HashSet
 * collection
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category elements
 * @example
 *
 * ```ts
 * // Syntax with Refinement
 * import { HashSet, pipe, Predicate } from "effect"
 *
 * const numberOrString = HashSet.make(1, "1", "one", "uno")
 *
 * // with `data-last`, a.k.a. `pipeable` API and `Refinement`
 * pipe(
 *   numberOrString, // HashSet.HashSet<number | string>
 *   HashSet.every(Predicate.isString)
 * ) // HashSet.HashSet<string>
 *
 * // or piped with the pipe function and  `Refinement`
 * numberOrString // HashSet.HashSet<number | string>
 *   .pipe(HashSet.every(Predicate.isString)) // HashSet.HashSet<string>
 *
 * // or with `data-first` API and `Refinement`
 * HashSet.every(
 *   numberOrString, // HashSet.HashSet<number | string>
 *   Predicate.isString
 * ) // HashSet.HashSet<string>
 * ```
 *
 * @example
 *
 * ```ts
 * // Syntax with Predicate
 * import { HashSet, pipe } from "effect"
 *
 * const set = HashSet.make(1, 2, 3)
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(
 *   set,
 *   HashSet.every((n) => n >= 0)
 * ) // true
 *
 * // or piped with the pipe function
 * set.pipe(HashSet.every((n) => n >= 0)) // true
 *
 * // or with `data-first` API
 * HashSet.every(set, (n) => n >= 0) // true
 * ```
 *
 * @returns A boolean once it has evaluated that whole collection fulfill the
 *   Predicate function
 * @see Other `HashSet` elements are {@link module:HashSet.has} {@link module:HashSet.some} {@link module:HashSet.isSubset}
 */
const every = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .every */ .yW;
/**
 * Returns `true` if and only if every element in the this `HashSet` is an
 * element of the second set,
 *
 * **NOTE**: the hash and equal of both sets must be the same.
 *
 * Time complexity analysis is of **`O(n)`**
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category elements
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * const set1 = HashSet.make(0, 1)
 * const set2 = HashSet.make(1, 2)
 * const set3 = HashSet.make(0, 1, 2)
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(set1, HashSet.isSubset(set2)) // false
 * pipe(set1, HashSet.isSubset(set3)) // true
 *
 * // or piped with the pipe function
 * set1.pipe(HashSet.isSubset(set2)) // false
 * set1.pipe(HashSet.isSubset(set3)) // true
 *
 * // or with `data-first` API
 * HashSet.isSubset(set1, set2) // false
 * HashSet.isSubset(set1, set3) // true)
 * ```
 *
 * @see Other `HashSet` elements are {@link module:HashSet.has} {@link module:HashSet.some} {@link module:HashSet.every}
 */
const isSubset = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .isSubset */ .KX;
/**
 * Returns an `IterableIterator` of the values in the `HashSet`.
 *
 * Time complexity: **`O(1)`**
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category getters
 * @example
 *
 * ```ts
 * import { HashSet, pipe } from "effect"
 *
 * const numberIterable = pipe(
 *   HashSet.make(0, 1, 1, 2), // HashSet.HashSet<number>
 *   HashSet.values // takes an HashSet<A> and returns an IterableIterator<A>
 * )
 *
 * for (const number of numberIterable) {
 *   console.log(number) // it will logs: 0, 1, 2
 * }
 * ```
 *
 * @see Other `HashSet` getters are {@link module:HashSet.toValues} {@link module:HashSet.size}
 */
const values = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .values */ .VO;
/**
 * Returns an `Array` of the values within the `HashSet`.
 *
 * Time complexity: **`O(n)`** where n is the number of elements in the set
 *
 * @memberof HashSet
 * @since 3.13.0
 * @category getters
 * @example
 *
 * ```ts
 * import { HashSet, pipe } from "effect"
 * import { deepStrictEqual } from "node:assert/strict"
 *
 * deepStrictEqual(
 *   pipe(
 *     HashSet.make(0, 1, 1, 2), // HashSet<number>
 *     HashSet.toValues // takes an HashSet<A> and returns an Array<A>
 *   ),
 *   Array.of(0, 1, 2)
 * )
 * ```
 *
 * @see Other `HashSet` getters are {@link module:HashSet.values} {@link module:HashSet.size}
 */
const toValues = self => Array.from(values(self));
/**
 * Calculates the number of values in the `HashSet`.
 *
 * Time complexity: **`O(1)`**
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category getters
 * @example
 *
 * ```ts
 * import { HashSet, pipe } from "effect"
 * import assert from "node:assert/strict"
 *
 * assert.deepStrictEqual(pipe(HashSet.empty(), HashSet.size), 0)
 *
 * assert.deepStrictEqual(
 *   pipe(HashSet.make(1, 2, 2, 3, 4, 3), HashSet.size),
 *   4
 * )
 * ```
 *
 * @see Other `HashSet` getters are {@link module:HashSet.values} {@link module:HashSet.toValues}
 */
const size = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .size */ .dp;
/**
 * Creates a new mutable version of the `HashSet`
 *
 * When a `HashSet` is mutable, operations like {@link add} and {@link remove}
 * modify the data structure in place instead of creating a new one, which is
 * more efficient when performing multiple operations.
 *
 * @memberof HashSet
 * @since 2.0.0
 * @example
 *
 * ```ts
 * import { HashSet } from "effect"
 * import assert from "node:assert/strict"
 *
 * const UPPER_BOUND = 10_000
 *
 * const immutableSet = HashSet.empty<number>().pipe(HashSet.add(0))
 *
 * // Create a mutable version of the immutableSet
 * const mutableSet = HashSet.beginMutation(immutableSet)
 *
 * for (let i = 1; i < UPPER_BOUND; i++) {
 *   // Operations now modify the set in place instead of creating new instances
 *   // This is more efficient when making multiple changes
 *   const pointerToMutableSet = HashSet.add(mutableSet, i)
 *
 *   // the two sets have the same identity, hence `add` is mutating mutableSet and not returning a new HashSet instance
 *   assert(Object.is(mutableSet, pointerToMutableSet))
 *   assert.equal(HashSet.has(mutableSet, i), true) // `i` is in the mutableSet
 *   assert.equal(HashSet.has(immutableSet, i), false) // `i` is not in the immutableSet
 * }
 *
 * const next = UPPER_BOUND + 1
 * // When done, mark the set as immutable again
 * HashSet.endMutation(mutableSet).pipe(
 *   HashSet.add(next) // since this returns a new HashSet, it will not be logged as part of the mutableSet
 * )
 * assert.equal(HashSet.has(mutableSet, next), false)
 *
 * console.log(HashSet.toValues(immutableSet)) // [0]
 * console.log(HashSet.toValues(mutableSet).sort((a, b) => a - b)) // [0, 1, 2, 3, ...rest]
 * ```
 *
 * @see Other `HashSet` mutations are {@link module:HashSet.add} {@link module:HashSet.remove} {@link module:HashSet.toggle} {@link module:HashSet.endMutation} {@link module:HashSet.mutate}
 */
const beginMutation = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .beginMutation */ .iy;
/**
 * Makes the `HashSet` immutable again.
 *
 * After calling `endMutation`, operations like {@link add} and {@link remove}
 * will create new instances of the `HashSet` instead of modifying the existing
 * one.
 *
 * @memberof HashSet
 * @since 2.0.0
 * @example
 *
 * ```ts
 * import { HashSet } from "effect"
 * import assert from "node:assert/strict"
 *
 * // Create a mutable set
 * const mutableSet = HashSet.beginMutation(HashSet.empty<number>())
 *
 * // Add some elements to the mutable set
 * HashSet.add(mutableSet, 1)
 * HashSet.add(mutableSet, 2)
 *
 * // Before endMutation, operations modify the set in place
 * const sameSet = HashSet.add(mutableSet, 3)
 * assert(Object.is(mutableSet, sameSet)) // true - same object reference
 * assert.deepStrictEqual(HashSet.toValues(mutableSet).sort(), [1, 2, 3])
 *
 * // Make the set immutable again
 * const immutableSet = HashSet.endMutation(mutableSet)
 *
 * // endMutation returns the same set instance, now made immutable
 * assert(Object.is(mutableSet, immutableSet)) // true - same object reference
 *
 * // After endMutation, operations create new instances
 * const newSet = HashSet.add(immutableSet, 4)
 * assert(!Object.is(immutableSet, newSet)) // false - different object references
 *
 * // The original set remains unchanged
 * assert.deepStrictEqual(HashSet.toValues(immutableSet).sort(), [1, 2, 3])
 *
 * // The new set contains the added element
 * assert.deepStrictEqual(HashSet.toValues(newSet).sort(), [1, 2, 3, 4])
 * ```
 *
 * @see Other `HashSet` mutations are {@link module:HashSet.add} {@link module:HashSet.remove} {@link module:HashSet.toggle} {@link module:HashSet.beginMutation} {@link module:HashSet.mutate}
 */
const endMutation = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .endMutation */ .Rx;
/**
 * Mutates the `HashSet` within the context of the provided function.
 *
 * You can consider it a functional abstraction on top of the lower-level
 * mutation primitives of {@link module:HashSet.beginMutation} `->` `mutable
 * context` `->` {@link HashSet.endMutation}.
 *
 * @memberof HashSet
 * @since 2.0.0
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * // with data-last, a.k.a. pipeable API
 * pipe(
 *   HashSet.make(1, 2, 3),
 *   HashSet.mutate((set) => {
 *     HashSet.add(set, 4)
 *     HashSet.remove(set, 1)
 *   })
 * )
 *
 * // or piped with the pipe function
 * HashSet.make(1, 2, 3).pipe(
 *   HashSet.mutate((set) => {
 *     HashSet.add(set, 4)
 *     HashSet.remove(set, 1)
 *   })
 * )
 *
 * // or with data-first API
 * HashSet.mutate(HashSet.make(1, 2, 3), (set) => {
 *   HashSet.add(set, 4)
 *   HashSet.remove(set, 1)
 * })
 * ```
 *
 * @see Other `HashSet` mutations are {@link module:HashSet.add} {@link module:HashSet.remove} {@link module:HashSet.toggle} {@link module:HashSet.beginMutation} {@link module:HashSet.endMutation}
 */
const mutate = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .mutate */ .JG;
/**
 * Adds a value to the `HashSet`.
 *
 * Time complexity: **`O(1)`** average
 *
 * @remarks
 * Remember that a `HashSet` is a collection of unique values, so adding a value
 * that already exists in the `HashSet` will not add a duplicate.
 *
 * Remember that HashSet is an immutable data structure, so the `add` function,
 * like all other functions that modify the HashSet, will return a new HashSet
 * with the added value.
 * @memberof HashSet
 * @since 2.0.0
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * // with data-last, a.k.a. pipeable API
 * pipe(HashSet.empty(), HashSet.add(0), HashSet.add(0))
 *
 * // or piped with the pipe function
 * HashSet.empty().pipe(HashSet.add(0))
 *
 * // or with data-first API
 * HashSet.add(HashSet.empty(), 0)
 * ```
 *
 * @see Other `HashSet` mutations are {@link module:HashSet.remove} {@link module:HashSet.toggle} {@link module:HashSet.beginMutation} {@link module:HashSet.endMutation} {@link module:HashSet.mutate}
 */
const add = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .add */ .IH;
/**
 * Removes a value from the `HashSet`.
 *
 * Time complexity: **`O(1)`** average
 *
 * @memberof HashSet
 * @since 2.0.0
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(HashSet.make(0, 1, 2), HashSet.remove(0))
 *
 * // or piped with the pipe function
 * HashSet.make(0, 1, 2).pipe(HashSet.remove(0))
 *
 * // or with `data-first` API
 * HashSet.remove(HashSet.make(0, 1, 2), 0)
 * ```
 *
 * @see Other `HashSet` mutations are {@link module:HashSet.add} {@link module:HashSet.toggle} {@link module:HashSet.beginMutation} {@link module:HashSet.endMutation} {@link module:HashSet.mutate}
 */
const remove = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .remove */ .Od;
/**
 * Computes the set difference `(A - B)` between this `HashSet` and the
 * specified `Iterable<A>`.
 *
 * Time complexity: **`O(n)`** where n is the number of elements in the set
 *
 * **NOTE**: the hash and equal of the values in both the set and the iterable
 * must be the same; meaning we cannot compute a difference between a `HashSet
 * of bananas` and a `HashSet of elephants` as they are not the same type and
 * won't implement the Equal trait in the same way.
 *
 * @memberof HashSet
 * @since 2.0.0
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * // with data-last, a.k.a. pipeable API
 * pipe(HashSet.make(1, 2, 3), HashSet.difference(HashSet.make(3, 4, 5)))
 *
 * // or piped with the pipe function
 * HashSet.make(1, 2, 3).pipe(HashSet.difference(HashSet.make(3, 4, 5)))
 *
 * // or with data-first API
 * HashSet.difference(HashSet.make(1, 2, 3), HashSet.make(3, 4, 5))
 * ```
 *
 * @see Other `HashSet` operations are {@link module:HashSet.intersection} {@link module:HashSet.union}
 */
const difference = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .difference */ .e5;
/**
 * Returns a `HashSet` of values which are present in both this set and that
 * `Iterable<A>`. Computes set intersection (A ∩ B)
 *
 * Time complexity: **`O(n)`** where n is the number of elements in the smaller
 * set
 *
 * **NOTE**: the hash and equal of the values in both the set and the iterable
 * must be the same.
 *
 * @memberof HashSet
 * @since 2.0.0
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * // with data-last, a.k.a. pipeable API
 * pipe(HashSet.make(1, 2, 3), HashSet.intersection(HashSet.make(2, 3, 4)))
 *
 * // or piped with the pipe function
 * HashSet.make(1, 2, 3).pipe(HashSet.intersection(HashSet.make(2, 3, 4)))
 *
 * // or with data-first API
 * HashSet.intersection(HashSet.make(1, 2, 3), HashSet.make(2, 3, 4))
 * ```
 *
 * @see Other `HashSet` operations are {@link module:HashSet.difference} {@link module:HashSet.union}
 */
const intersection = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .intersection */ .jV;
/**
 * Computes the set union `( self ∪ that )` between this `HashSet` and the
 * specified `Iterable<A>`.
 *
 * Time complexity: **`O(n)`** where n is the number of elements in the set
 *
 * **NOTE**: the hash and equal of the values in both the set and the iterable
 * must be the same.
 *
 * @memberof HashSet
 * @since 2.0.0
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * // with data-last, a.k.a. pipeable API
 * pipe(HashSet.make(1, 2, 3), HashSet.union(HashSet.make(3, 4, 5)))
 *
 * // or piped with the pipe function
 * HashSet.make(1, 2, 3).pipe(HashSet.union(HashSet.make(3, 4, 5)))
 *
 * // or with data-first API
 * HashSet.union(HashSet.make(1, 2, 3), HashSet.make(3, 4, 5))
 * ```
 *
 * @see Other `HashSet` operations are {@link module:HashSet.difference} {@link module:HashSet.intersection}
 */
const union = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .union */ .G0;
/**
 * Checks if a value is present in the `HashSet`. If it is present, the value
 * will be removed from the `HashSet`, otherwise the value will be added to the
 * `HashSet`.
 *
 * Time complexity: **`O(1)`** average
 *
 * @memberof HashSet
 * @since 2.0.0
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(HashSet.make(0, 1, 2), HashSet.toggle(0))
 *
 * // or piped with the pipe function
 * HashSet.make(0, 1, 2).pipe(HashSet.toggle(0))
 *
 * // or with `data-first` API
 * HashSet.toggle(HashSet.make(0, 1, 2), 0)
 * ```
 *
 * @returns A new `HashSet` where the toggled value is being either added or
 *   removed based on the initial `HashSet` state.
 * @see Other `HashSet` mutations are {@link module:HashSet.add} {@link module:HashSet.remove} {@link module:HashSet.beginMutation} {@link module:HashSet.endMutation} {@link module:HashSet.mutate}
 */
const toggle = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .toggle */ .ZN;
/**
 * Maps over the values of the `HashSet` using the specified function.
 *
 * The time complexity is of **`O(n)`**.
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category mapping
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(
 *   HashSet.make(0, 1, 2), // HashSet.HashSet<number>
 *   HashSet.map(String) // HashSet.HashSet<string>
 * )
 *
 * // or piped with the pipe method
 * HashSet.make(0, 1, 2).pipe(HashSet.map(String))
 *
 * // or with `data-first` API
 * HashSet.map(HashSet.make(0, 1, 2), String)
 * ```
 */
const map = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI;
/**
 * Chains over the values of the `HashSet` using the specified function.
 *
 * The time complexity is of **`O(n)`**.
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category sequencing
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(
 *   HashSet.make(0, 1, 2), // HashSet.HashSet<number>
 *   HashSet.flatMap((n) => Array.of(String(n))) // HashSet.HashSet<string>
 * )
 *
 * // or piped with the pipe method
 * HashSet.make(0, 1, 2) // HashSet.HashSet<number>
 *   .pipe(
 *     HashSet.flatMap((n) => Array.of(String(n))) // HashSet.HashSet<string>
 *   )
 *
 * // or with `data-first` API
 * HashSet.flatMap(HashSet.make(0, 1, 2), (n) => Array.of(String(n)))
 * ```
 */
const flatMap = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VS;
/**
 * Applies the specified function to the values of the `HashSet`.
 *
 * The time complexity is of **`O(n)`**.
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category traversing
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(HashSet.make(0, 1, 2), HashSet.forEach(console.log)) // logs: 0 1 2
 *
 * // or piped with the pipe method
 * HashSet.make(0, 1, 2).pipe(HashSet.forEach(console.log)) // logs: 0 1 2
 *
 * // or with `data-first` API
 * HashSet.forEach(HashSet.make(0, 1, 2), console.log) // logs: 0 1 2
 * ```
 */
const forEach = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .forEach */ .Ed;
/**
 * Reduces the specified state over the values of the `HashSet`.
 *
 * The time complexity is of **`O(n)`**.
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category folding
 * @example
 *
 * ```ts
 * // Syntax
 * import { HashSet, pipe } from "effect"
 *
 * const sum = (a: number, b: number): number => a + b
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(HashSet.make(0, 1, 2), HashSet.reduce(0, sum))
 *
 * // or with the pipe method
 * HashSet.make(0, 1, 2).pipe(HashSet.reduce(0, sum))
 *
 * // or with `data-first` API
 * HashSet.reduce(HashSet.make(0, 1, 2), 0, sum)
 * ```
 */
const reduce = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .reduce */ .u4;
/**
 * Filters values out of a `HashSet` using the specified predicate.
 *
 * The time complexity is of **`O(n)`**.
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category filtering
 * @example
 *
 * ```ts
 * // Syntax with  Predicate
 * import { HashSet, type Predicate, pipe } from "effect"
 *
 * const filterPositiveNumbers: Predicate.Predicate<number> = (n) => n > 0
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(
 *   HashSet.make(-2, -1, 0, 1, 2),
 *   HashSet.filter(filterPositiveNumbers)
 * )
 *
 * // or with the pipe method
 * HashSet.make(-2, -1, 0, 1, 2).pipe(HashSet.filter(filterPositiveNumbers))
 *
 * // or with `data-first` API
 * HashSet.filter(HashSet.make(-2, -1, 0, 1, 2), filterPositiveNumbers)
 * ```
 *
 * @example
 *
 * ```ts
 * /// Syntax with Refinement
 * import { HashSet, pipe } from "effect"
 *
 * const stringRefinement = (value: unknown): value is string =>
 *   typeof value === "string"
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(
 *   HashSet.make(1, "unos", 2, "two", 3, "trois", 4, "vier"), // // HashSet.HashSet<number | string>
 *   HashSet.filter(stringRefinement)
 * ) // HashSet.HashSet<string>
 *
 * // or with the pipe method
 * HashSet.make(1, "unos", 2, "two", 3, "trois", 4, "vier") // HashSet.HashSet<number | string>
 *   .pipe(HashSet.filter(stringRefinement)) // HashSet.HashSet<string>
 *
 * // or with `data-first` API
 * HashSet.filter(
 *   HashSet.make(1, "unos", 2, "two", 3, "trois", 4, "vier"), // HashSet.HashSet<number | string>
 *   stringRefinement
 * ) // HashSet.HashSet<string>
 * ```
 */
const filter = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .filter */ .hX;
/**
 * Partition the values of a `HashSet` using the specified predicate.
 *
 * If a value matches the predicate, it will be placed into the `HashSet` on the
 * right side of the resulting `Tuple`, otherwise the value will be placed into
 * the left side.
 *
 * Time complexity is of **`O(n)`**.
 *
 * @memberof HashSet
 * @since 2.0.0
 * @category partitioning
 * @example
 *
 * ```ts
 * // Syntax with Predicate
 * import { HashSet, pipe, Predicate } from "effect"
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(
 *   HashSet.make(0, 1, 2, 3, 4, 5),
 *   HashSet.partition((n) => n % 2 === 0)
 * )
 *
 * // or with the pipe method
 * HashSet.make(0, 1, 2, 3, 4, 5).pipe(
 *   HashSet.partition((n) => n % 2 === 0)
 * )
 *
 * // or with `data-first` API
 * HashSet.partition(HashSet.make(0, 1, 2, 3, 4, 5), (n) => n % 2 === 0)
 * ```
 *
 * @example
 *
 * ```ts
 * // Syntax with Refinement
 * import { HashSet, pipe, Predicate } from "effect"
 *
 * const stringRefinement: Predicate.Refinement<string | number, string> = (
 *   value
 * ) => typeof value === "string"
 *
 * // with `data-last`, a.k.a. `pipeable` API
 * pipe(
 *   HashSet.make(1, "unos", 2, "two", 3, "trois", 4, "vier"),
 *   HashSet.partition(stringRefinement)
 * )
 *
 * // or with the pipe method
 * HashSet.make(1, "unos", 2, "two", 3, "trois", 4, "vier").pipe(
 *   HashSet.partition(stringRefinement)
 * )
 *
 * // or with `data-first` API
 * HashSet.partition(
 *   HashSet.make(1, "unos", 2, "two", 3, "trois", 4, "vier"),
 *   stringRefinement
 * )
 * ```
 */
const partition = _internal_hashSet_js__WEBPACK_IMPORTED_MODULE_0__/* .partition */ .uK;
//# sourceMappingURL=HashSet.js.map

/***/ }),

/***/ 16371:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OY": function() { return /* binding */ toStringUnknown; },
/* harmony export */   "WU": function() { return /* binding */ format; },
/* harmony export */   "au": function() { return /* binding */ toJSON; },
/* harmony export */   "j5": function() { return /* binding */ NodeInspectSymbol; },
/* harmony export */   "qU": function() { return /* binding */ withRedactableContext; },
/* harmony export */   "qk": function() { return /* binding */ stringifyCircular; }
/* harmony export */ });
/* unused harmony exports BaseProto, Class, symbolRedactable, isRedactable, redact */
/* harmony import */ var _GlobalValue_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4726);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71335);


/**
 * @since 2.0.0
 * @category symbols
 */
const NodeInspectSymbol = /*#__PURE__*/Symbol.for("nodejs.util.inspect.custom");
/**
 * @since 2.0.0
 */
const toJSON = x => {
  try {
    if ((0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .hasProperty */ .l$)(x, "toJSON") && (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .mf)(x["toJSON"]) && x["toJSON"].length === 0) {
      return x.toJSON();
    } else if (Array.isArray(x)) {
      return x.map(toJSON);
    }
  } catch (_) {
    return {};
  }
  return redact(x);
};
/**
 * @since 2.0.0
 */
const format = x => JSON.stringify(x, null, 2);
/**
 * @since 2.0.0
 */
const BaseProto = {
  toJSON() {
    return toJSON(this);
  },
  [NodeInspectSymbol]() {
    return this.toJSON();
  },
  toString() {
    return format(this.toJSON());
  }
};
/**
 * @since 2.0.0
 */
class Class {
  /**
   * @since 2.0.0
   */
  [NodeInspectSymbol]() {
    return this.toJSON();
  }
  /**
   * @since 2.0.0
   */
  toString() {
    return format(this.toJSON());
  }
}
/**
 * @since 2.0.0
 */
const toStringUnknown = (u, whitespace = 2) => {
  if (typeof u === "string") {
    return u;
  }
  try {
    return typeof u === "object" ? stringifyCircular(u, whitespace) : String(u);
  } catch (_) {
    return String(u);
  }
};
/**
 * @since 2.0.0
 */
const stringifyCircular = (obj, whitespace) => {
  let cache = [];
  const retVal = JSON.stringify(obj, (_key, value) => typeof value === "object" && value !== null ? cache.includes(value) ? undefined // circular reference
  : cache.push(value) && (redactableState.fiberRefs !== undefined && isRedactable(value) ? value[symbolRedactable](redactableState.fiberRefs) : value) : value, whitespace);
  cache = undefined;
  return retVal;
};
/**
 * @since 3.10.0
 * @category redactable
 */
const symbolRedactable = /*#__PURE__*/Symbol.for("effect/Inspectable/Redactable");
/**
 * @since 3.10.0
 * @category redactable
 */
const isRedactable = u => typeof u === "object" && u !== null && symbolRedactable in u;
const redactableState = /*#__PURE__*/(0,_GlobalValue_js__WEBPACK_IMPORTED_MODULE_1__/* .globalValue */ .K)("effect/Inspectable/redactableState", () => ({
  fiberRefs: undefined
}));
/**
 * @since 3.10.0
 * @category redactable
 */
const withRedactableContext = (context, f) => {
  const prev = redactableState.fiberRefs;
  redactableState.fiberRefs = context;
  try {
    return f();
  } finally {
    redactableState.fiberRefs = prev;
  }
};
/**
 * @since 3.10.0
 * @category redactable
 */
const redact = u => {
  if (isRedactable(u) && redactableState.fiberRefs !== undefined) {
    return u[symbolRedactable](redactableState.fiberRefs);
  }
  return u;
};
//# sourceMappingURL=Inspectable.js.map

/***/ }),

/***/ 92646:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ng": function() { return /* binding */ succeed; }
});

// UNUSED EXPORTS: CurrentMemoMap, LayerTypeId, MemoMapTypeId, annotateLogs, annotateSpans, build, buildWithMemoMap, buildWithScope, catchAll, catchAllCause, context, die, dieSync, discard, effect, effectContext, effectDiscard, empty, extendScope, fail, failCause, failCauseSync, failSync, fiberRefLocallyScopedWith, flatMap, flatten, fresh, function, isFresh, isLayer, launch, locally, locallyEffect, locallyScoped, locallyWith, makeMemoMap, map, mapError, match, matchCause, memoize, merge, mergeAll, orDie, orElse, parentSpan, passthrough, project, provide, provideMerge, retry, scope, scoped, scopedContext, scopedDiscard, service, setClock, setConfigProvider, setRequestBatching, setRequestCache, setRequestCaching, setScheduler, setTracer, setTracerEnabled, setTracerTiming, setUnhandledErrorLogLevel, span, succeedContext, suspend, sync, syncContext, tap, tapError, tapErrorCause, toRuntime, toRuntimeWithMemoMap, unwrapEffect, unwrapScoped, updateService, withParentSpan, withSpan, zipWith

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/layer.js + 3 modules
var internal_layer = __webpack_require__(58590);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Context.js
var esm_Context = __webpack_require__(20591);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/core.js + 1 modules
var internal_core = __webpack_require__(39355);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/fiberRuntime.js + 14 modules
var internal_fiberRuntime = __webpack_require__(90886);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/runtimeFlags.js
var runtimeFlags = __webpack_require__(4536);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/runtimeFlagsPatch.js
var runtimeFlagsPatch = __webpack_require__(43886);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/tracer.js
var tracer = __webpack_require__(10434);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/layer/circular.js










// circular with Logger
/** @internal */
const minimumLogLevel = level => layer.scopedDiscard(fiberRuntime.fiberRefLocallyScoped(fiberRuntime.currentMinimumLogLevel, level));
/** @internal */
const withMinimumLogLevel = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, level) => core.fiberRefLocally(fiberRuntime.currentMinimumLogLevel, level)(self))));
/** @internal */
const addLogger = logger => layer.scopedDiscard(fiberRuntime.fiberRefLocallyScopedWith(fiberRuntime.currentLoggers, HashSet.add(logger)));
/** @internal */
const addLoggerEffect = effect => layer.unwrapEffect(core.map(effect, addLogger));
/** @internal */
const addLoggerScoped = effect => layer.unwrapScoped(core.map(effect, addLogger));
/** @internal */
const removeLogger = logger => layer.scopedDiscard(fiberRuntime.fiberRefLocallyScopedWith(fiberRuntime.currentLoggers, HashSet.remove(logger)));
/** @internal */
const replaceLogger = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => layer.flatMap(removeLogger(self), () => addLogger(that)))));
/** @internal */
const replaceLoggerEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => layer.flatMap(removeLogger(self), () => addLoggerEffect(that)))));
/** @internal */
const replaceLoggerScoped = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => layer.flatMap(removeLogger(self), () => addLoggerScoped(that)))));
/** @internal */
const addSupervisor = supervisor => layer.scopedDiscard(fiberRuntime.fiberRefLocallyScopedWith(fiberRuntime.currentSupervisor, current => new supervisor_.Zip(current, supervisor)));
/** @internal */
const enableCooperativeYielding = /*#__PURE__*/internal_layer/* scopedDiscard */.oc( /*#__PURE__*/internal_fiberRuntime/* withRuntimeFlagsScoped */.fn( /*#__PURE__*/runtimeFlagsPatch/* enable */.wp(runtimeFlags/* CooperativeYielding */.d0)));
/** @internal */
const enableInterruption = /*#__PURE__*/internal_layer/* scopedDiscard */.oc( /*#__PURE__*/internal_fiberRuntime/* withRuntimeFlagsScoped */.fn( /*#__PURE__*/runtimeFlagsPatch/* enable */.wp(runtimeFlags/* Interruption */.tm)));
/** @internal */
const enableOpSupervision = /*#__PURE__*/internal_layer/* scopedDiscard */.oc( /*#__PURE__*/internal_fiberRuntime/* withRuntimeFlagsScoped */.fn( /*#__PURE__*/runtimeFlagsPatch/* enable */.wp(runtimeFlags/* OpSupervision */.mP)));
/** @internal */
const enableRuntimeMetrics = /*#__PURE__*/internal_layer/* scopedDiscard */.oc( /*#__PURE__*/internal_fiberRuntime/* withRuntimeFlagsScoped */.fn( /*#__PURE__*/runtimeFlagsPatch/* enable */.wp(runtimeFlags/* RuntimeMetrics */.LC)));
/** @internal */
const enableWindDown = /*#__PURE__*/internal_layer/* scopedDiscard */.oc( /*#__PURE__*/internal_fiberRuntime/* withRuntimeFlagsScoped */.fn( /*#__PURE__*/runtimeFlagsPatch/* enable */.wp(runtimeFlags/* WindDown */.st)));
/** @internal */
const disableCooperativeYielding = /*#__PURE__*/internal_layer/* scopedDiscard */.oc( /*#__PURE__*/internal_fiberRuntime/* withRuntimeFlagsScoped */.fn( /*#__PURE__*/runtimeFlagsPatch/* disable */.h$(runtimeFlags/* CooperativeYielding */.d0)));
/** @internal */
const disableInterruption = /*#__PURE__*/internal_layer/* scopedDiscard */.oc( /*#__PURE__*/internal_fiberRuntime/* withRuntimeFlagsScoped */.fn( /*#__PURE__*/runtimeFlagsPatch/* disable */.h$(runtimeFlags/* Interruption */.tm)));
/** @internal */
const disableOpSupervision = /*#__PURE__*/internal_layer/* scopedDiscard */.oc( /*#__PURE__*/internal_fiberRuntime/* withRuntimeFlagsScoped */.fn( /*#__PURE__*/runtimeFlagsPatch/* disable */.h$(runtimeFlags/* OpSupervision */.mP)));
/** @internal */
const disableRuntimeMetrics = /*#__PURE__*/internal_layer/* scopedDiscard */.oc( /*#__PURE__*/internal_fiberRuntime/* withRuntimeFlagsScoped */.fn( /*#__PURE__*/runtimeFlagsPatch/* disable */.h$(runtimeFlags/* RuntimeMetrics */.LC)));
/** @internal */
const disableWindDown = /*#__PURE__*/internal_layer/* scopedDiscard */.oc( /*#__PURE__*/internal_fiberRuntime/* withRuntimeFlagsScoped */.fn( /*#__PURE__*/runtimeFlagsPatch/* disable */.h$(runtimeFlags/* WindDown */.st)));
/** @internal */
const setConfigProvider = configProvider => internal_layer/* scopedDiscard */.oc(internal_fiberRuntime/* withConfigProviderScoped */.Yk(configProvider));
/** @internal */
const parentSpan = span => internal_layer/* succeedContext */.zm(esm_Context/* make */.Sy(tracer/* spanTag */.N7, span));
/** @internal */
const span = (name, options) => {
  options = tracer/* addSpanStackTrace */.W8(options);
  return internal_layer/* scoped */.Yn(tracer/* spanTag */.N7, options?.onEnd ? internal_core/* tap */.bwX(internal_fiberRuntime/* makeSpanScoped */.ey(name, options), span => internal_fiberRuntime/* addFinalizer */.yR(exit => options.onEnd(span, exit))) : internal_fiberRuntime/* makeSpanScoped */.ey(name, options));
};
/** @internal */
const setTracer = tracer => internal_layer/* scopedDiscard */.oc(internal_fiberRuntime/* withTracerScoped */.at(tracer));
//# sourceMappingURL=circular.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/Layer.js










/**
 * @since 2.0.0
 * @category symbols
 */
const LayerTypeId = internal_layer/* LayerTypeId */.ow;
/**
 * @since 2.0.0
 * @category symbols
 */
const MemoMapTypeId = internal_layer/* MemoMapTypeId */.$X;
/**
 * @since 3.13.0
 * @category models
 */
const CurrentMemoMap = internal_layer/* CurrentMemoMap */.jQ;
/**
 * Returns `true` if the specified value is a `Layer`, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isLayer = internal_layer/* isLayer */.zS;
/**
 * Returns `true` if the specified `Layer` is a fresh version that will not be
 * shared, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isFresh = internal_layer/* isFresh */.VN;
/**
 * @since 3.3.0
 * @category tracing
 */
const annotateLogs = internal_layer/* annotateLogs */.z;
/**
 * @since 3.3.0
 * @category tracing
 */
const annotateSpans = internal_layer/* annotateSpans */.wV;
/**
 * Builds a layer into a scoped value.
 *
 * @since 2.0.0
 * @category destructors
 */
const build = internal_layer/* build */.J_;
/**
 * Builds a layer into an `Effect` value. Any resources associated with this
 * layer will be released when the specified scope is closed unless their scope
 * has been extended. This allows building layers where the lifetime of some of
 * the services output by the layer exceed the lifetime of the effect the
 * layer is provided to.
 *
 * @since 2.0.0
 * @category destructors
 */
const buildWithScope = internal_layer/* buildWithScope */.ok;
/**
 * Recovers from all errors.
 *
 * @since 2.0.0
 * @category error handling
 */
const catchAll = internal_layer/* catchAll */.km;
/**
 * Recovers from all errors.
 *
 * @since 2.0.0
 * @category error handling
 */
const catchAllCause = internal_layer/* catchAllCause */.Np;
/**
 * Constructs a `Layer` that passes along the specified context as an
 * output.
 *
 * @since 2.0.0
 * @category constructors
 */
const context = internal_layer/* context */.Do;
/**
 * Constructs a layer that dies with the specified defect.
 *
 * @since 2.0.0
 * @category constructors
 */
const die = internal_layer/* die */.Xr;
/**
 * Constructs a layer that dies with the specified defect.
 *
 * @since 2.0.0
 * @category constructors
 */
const dieSync = internal_layer/* dieSync */.Ag;
/**
 * Replaces the layer's output with `never` and includes the layer only for its
 * side-effects.
 *
 * @since 2.0.0
 * @category mapping
 */
const discard = internal_layer/* discard */.eJ;
/**
 * Constructs a layer from the specified effect.
 *
 * @since 2.0.0
 * @category constructors
 */
const effect = internal_layer/* fromEffect */.SH;
/**
 * Constructs a layer from the specified effect, discarding its output.
 *
 * @since 2.0.0
 * @category constructors
 */
const effectDiscard = internal_layer/* fromEffectDiscard */.Dg;
/**
 * Constructs a layer from the specified effect, which must return one or more
 * services.
 *
 * @since 2.0.0
 * @category constructors
 */
const effectContext = internal_layer/* fromEffectContext */.Cg;
/**
 * A Layer that constructs an empty Context.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = internal_layer/* empty */.cS;
/**
 * Extends the scope of this layer, returning a new layer that when provided
 * to an effect will not immediately release its associated resources when
 * that effect completes execution but instead when the scope the resulting
 * effect depends on is closed.
 *
 * @since 2.0.0
 * @category utils
 */
const extendScope = internal_layer/* extendScope */.A2;
/**
 * Constructs a layer that fails with the specified error.
 *
 * @since 2.0.0
 * @category constructors
 */
const fail = internal_layer/* fail */.bG;
/**
 * Constructs a layer that fails with the specified error.
 *
 * @since 2.0.0
 * @category constructors
 */
const failSync = internal_layer/* failSync */.zp;
/**
 * Constructs a layer that fails with the specified cause.
 *
 * @since 2.0.0
 * @category constructors
 */
const failCause = internal_layer/* failCause */.Dh;
/**
 * Constructs a layer that fails with the specified cause.
 *
 * @since 2.0.0
 * @category constructors
 */
const failCauseSync = internal_layer/* failCauseSync */.eu;
/**
 * Constructs a layer dynamically based on the output of this layer.
 *
 * @since 2.0.0
 * @category sequencing
 */
const flatMap = internal_layer/* flatMap */.VS;
/**
 * Flattens layers nested in the context of an effect.
 *
 * @since 2.0.0
 * @category sequencing
 */
const flatten = internal_layer/* flatten */.xH;
/**
 * Creates a fresh version of this layer that will not be shared.
 *
 * @since 2.0.0
 * @category utils
 */
const fresh = internal_layer/* fresh */.DQ;
const fromFunction = internal_layer/* fromFunction */.iT;

/**
 * Builds this layer and uses it until it is interrupted. This is useful when
 * your entire application is a layer, such as an HTTP server.
 *
 * @since 2.0.0
 * @category conversions
 */
const launch = internal_layer/* launch */.uP;
/**
 * Returns a new layer whose output is mapped by the specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
const map = internal_layer/* map */.UI;
/**
 * Returns a layer with its error channel mapped using the specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
const mapError = internal_layer/* mapError */.d1;
/**
 * Feeds the error or output services of this layer into the input of either
 * the specified `failure` or `success` layers, resulting in a new layer with
 * the inputs of this layer, and the error or outputs of the specified layer.
 *
 * @since 2.0.0
 * @category folding
 */
const match = internal_layer/* match */.EQ;
/**
 * Feeds the error or output services of this layer into the input of either
 * the specified `failure` or `success` layers, resulting in a new layer with
 * the inputs of this layer, and the error or outputs of the specified layer.
 *
 * @since 2.0.0
 * @category folding
 */
const matchCause = internal_layer/* matchCause */.eY;
/**
 * Returns a scoped effect that, if evaluated, will return the lazily computed
 * result of this layer.
 *
 * @since 2.0.0
 * @category utils
 */
const memoize = internal_layer/* memoize */.HP;
/**
 * Merges this layer with the specified layer concurrently, producing a new layer with combined input and output types.
 *
 * @since 2.0.0
 * @category zipping
 */
const merge = internal_layer/* merge */.TS;
/**
 * Combines all the provided layers concurrently, creating a new layer with merged input, error, and output types.
 *
 * @since 2.0.0
 * @category zipping
 */
const mergeAll = internal_layer/* mergeAll */.Jn;
/**
 * Translates effect failure into death of the fiber, making all failures
 * unchecked and not a part of the type of the layer.
 *
 * @since 2.0.0
 * @category error handling
 */
const orDie = internal_layer/* orDie */.e3;
/**
 * Executes this layer and returns its output, if it succeeds, but otherwise
 * executes the specified layer.
 *
 * @since 2.0.0
 * @category error handling
 */
const orElse = internal_layer/* orElse */.vx;
/**
 * Returns a new layer that produces the outputs of this layer but also
 * passes through the inputs.
 *
 * @since 2.0.0
 * @category utils
 */
const passthrough = internal_layer/* passthrough */.B2;
/**
 * Projects out part of one of the services output by this layer using the
 * specified function.
 *
 * @since 2.0.0
 * @category utils
 */
const project = internal_layer/* project */.iV;
/**
 * @since 2.0.0
 * @category utils
 */
const locallyEffect = internal_layer/* locallyEffect */.DM;
/**
 * @since 2.0.0
 * @category utils
 */
const locally = internal_layer/* fiberRefLocally */.EX;
/**
 * @since 2.0.0
 * @category utils
 */
const locallyWith = internal_layer/* fiberRefLocallyWith */.Lz;
/**
 * @since 2.0.0
 * @category utils
 */
const locallyScoped = internal_layer/* fiberRefLocallyScoped */.tX;
/**
 * @since 2.0.0
 * @category utils
 */
const fiberRefLocallyScopedWith = internal_layer/* fiberRefLocallyScopedWith */.lS;
/**
 * Retries constructing this layer according to the specified schedule.
 *
 * @since 2.0.0
 * @category retrying
 */
const retry = internal_layer/* retry */.XD;
/**
 * A layer that constructs a scope and closes it when the workflow the layer
 * is provided to completes execution, whether by success, failure, or
 * interruption. This can be used to close a scope when providing a layer to a
 * workflow.
 *
 * @since 2.0.0
 * @category constructors
 */
const scope = internal_layer/* scope */.eI;
/**
 * Constructs a layer from the specified scoped effect.
 *
 * @since 2.0.0
 * @category constructors
 */
const scoped = internal_layer/* scoped */.Yn;
/**
 * Constructs a layer from the specified scoped effect.
 *
 * @since 2.0.0
 * @category constructors
 */
const scopedDiscard = internal_layer/* scopedDiscard */.oc;
/**
 * Constructs a layer from the specified scoped effect, which must return one
 * or more services.
 *
 * @since 2.0.0
 * @category constructors
 */
const scopedContext = internal_layer/* scopedContext */.u3;
/**
 * Constructs a layer that accesses and returns the specified service from the
 * context.
 *
 * @since 2.0.0
 * @category constructors
 */
const service = internal_layer/* service */.Xn;
/**
 * Constructs a layer from the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
const succeed = internal_layer/* succeed */.ng;
/**
 * Constructs a layer from the specified value, which must return one or more
 * services.
 *
 * @since 2.0.0
 * @category constructors
 */
const succeedContext = internal_layer/* succeedContext */.zm;
/**
 * Lazily constructs a layer. This is useful to avoid infinite recursion when
 * creating layers that refer to themselves.
 *
 * @since 2.0.0
 * @category constructors
 */
const suspend = internal_layer/* suspend */.Rq;
/**
 * Lazily constructs a layer from the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
const sync = internal_layer/* sync */.Z_;
/**
 * Lazily constructs a layer from the specified value, which must return one or more
 * services.
 *
 * @since 2.0.0
 * @category constructors
 */
const syncContext = internal_layer/* syncContext */.$2;
/**
 * Performs the specified effect if this layer succeeds.
 *
 * @since 2.0.0
 * @category sequencing
 */
const tap = internal_layer/* tap */.bw;
/**
 * Performs the specified effect if this layer fails.
 *
 * @since 2.0.0
 * @category sequencing
 */
const tapError = internal_layer/* tapError */.sn;
/**
 * Performs the specified effect if this layer fails.
 *
 * @since 2.0.0
 * @category sequencing
 */
const tapErrorCause = internal_layer/* tapErrorCause */.OM;
/**
 * Converts a layer that requires no services into a scoped runtime, which can
 * be used to execute effects.
 *
 * @since 2.0.0
 * @category conversions
 */
const toRuntime = internal_layer/* toRuntime */.yK;
/**
 * Converts a layer that requires no services into a scoped runtime, which can
 * be used to execute effects.
 *
 * @since 2.0.0
 * @category conversions
 */
const toRuntimeWithMemoMap = internal_layer/* toRuntimeWithMemoMap */.CC;
/**
 * Feeds the output services of this builder into the input of the specified
 * builder, resulting in a new builder with the inputs of this builder as
 * well as any leftover inputs, and the outputs of the specified builder.
 *
 * @since 2.0.0
 * @category utils
 */
const provide = internal_layer/* provide */.JJ;
/**
 * Feeds the output services of this layer into the input of the specified
 * layer, resulting in a new layer with the inputs of this layer, and the
 * outputs of both layers.
 *
 * @since 2.0.0
 * @category utils
 */
const provideMerge = internal_layer/* provideMerge */.hT;
/**
 * Combines this layer with the specified layer concurrently, creating a new layer with merged input types and
 * combined output types using the provided function.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipWith = internal_layer/* zipWith */.yL;
/**
 * @since 2.0.0
 * @category utils
 */
const unwrapEffect = internal_layer/* unwrapEffect */._u;
/**
 * @since 2.0.0
 * @category utils
 */
const unwrapScoped = internal_layer/* unwrapScoped */.iA;
/**
 * @since 2.0.0
 * @category clock
 */
const setClock = clock => scopedDiscard(fiberRuntime.fiberRefLocallyScopedWith(defaultServices.currentServices, Context.add(clockTag, clock)));
/**
 * Sets the current `ConfigProvider`.
 *
 * @since 2.0.0
 * @category config
 */
const Layer_setConfigProvider = setConfigProvider;
/**
 * Adds the provided span to the span stack.
 *
 * @since 2.0.0
 * @category tracing
 */
const Layer_parentSpan = parentSpan;
/**
 * @since 2.0.0
 * @category requests & batching
 */
const setRequestBatching = requestBatching => scopedDiscard(fiberRuntime.fiberRefLocallyScoped(core.currentRequestBatching, requestBatching));
/**
 * @since 2.0.0
 * @category requests & batching
 */
const setRequestCaching = requestCaching => scopedDiscard(fiberRuntime.fiberRefLocallyScoped(query.currentCacheEnabled, requestCaching));
/**
 * @since 2.0.0
 * @category requests & batching
 */
const setRequestCache = cache => scopedDiscard(core.isEffect(cache) ? core.flatMap(cache, x => fiberRuntime.fiberRefLocallyScoped(query.currentCache, x)) : fiberRuntime.fiberRefLocallyScoped(query.currentCache, cache));
/**
 * @since 2.0.0
 * @category scheduler
 */
const setScheduler = scheduler => scopedDiscard(fiberRuntime.fiberRefLocallyScoped(Scheduler.currentScheduler, scheduler));
/**
 * Create and add a span to the current span stack.
 *
 * The span is ended when the Layer is released.
 *
 * @since 2.0.0
 * @category tracing
 */
const Layer_span = span;
/**
 * Create a Layer that sets the current Tracer
 *
 * @since 2.0.0
 * @category tracing
 */
const Layer_setTracer = setTracer;
/**
 * @since 2.0.0
 * @category tracing
 */
const setTracerEnabled = enabled => scopedDiscard(fiberRuntime.fiberRefLocallyScoped(core.currentTracerEnabled, enabled));
/**
 * @since 2.0.0
 * @category tracing
 */
const setTracerTiming = enabled => scopedDiscard(fiberRuntime.fiberRefLocallyScoped(core.currentTracerTimingEnabled, enabled));
/**
 * @since 2.0.0
 * @category logging
 */
const setUnhandledErrorLogLevel = level => scopedDiscard(fiberRuntime.fiberRefLocallyScoped(core.currentUnhandledErrorLogLevel, level));
/**
 * @since 2.0.0
 * @category tracing
 */
const withSpan = internal_layer/* withSpan */.cq;
/**
 * @since 2.0.0
 * @category tracing
 */
const withParentSpan = internal_layer/* withParentSpan */.cV;
// -----------------------------------------------------------------------------
// memo map
// -----------------------------------------------------------------------------
/**
 * Constructs a `MemoMap` that can be used to build additional layers.
 *
 * @since 2.0.0
 * @category memo map
 */
const makeMemoMap = internal_layer/* makeMemoMap */.Qj;
/**
 * Builds a layer into an `Effect` value, using the specified `MemoMap` to memoize
 * the layer construction.
 *
 * @since 2.0.0
 * @category memo map
 */
const buildWithMemoMap = internal_layer/* buildWithMemoMap */.eQ;
/**
 * Updates a service in the context with a new implementation.
 *
 * **Details**
 *
 * This function modifies the existing implementation of a service in the
 * context. It retrieves the current service, applies the provided
 * transformation function `f`, and replaces the old service with the
 * transformed one.
 *
 * **When to Use**
 *
 * This is useful for adapting or extending a service's behavior during the
 * creation of a layer.
 *
 * @since 3.13.0
 * @category utils
 */
const updateService = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (layer, tag, f) => provide(layer, map(context(), c => Context.add(c, tag, f(Context.unsafeGet(c, tag))))))));
//# sourceMappingURL=Layer.js.map

/***/ }),

/***/ 16104:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ce": function() { return /* binding */ prepend; },
/* harmony export */   "GY": function() { return /* binding */ reverse; },
/* harmony export */   "QI": function() { return /* binding */ cons; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "hg": function() { return /* binding */ isCons; },
/* harmony export */   "kK": function() { return /* binding */ isNil; },
/* harmony export */   "of": function() { return /* binding */ of; },
/* harmony export */   "oq": function() { return /* binding */ appendAll; },
/* harmony export */   "u4": function() { return /* binding */ reduce; }
/* harmony export */ });
/* unused harmony exports TypeId, toArray, getEquivalence, isList, size, nil, fromIterable, make, append, prependAll, prependAllReversed, drop, every, some, filter, filterMap, compact, findFirst, flatMap, forEach, head, last, map, partition, partitionMap, reduceRight, splitAt, tail, take, toChunk, unsafeHead, unsafeLast, unsafeTail */
/* harmony import */ var _Array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37901);
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67492);
/* harmony import */ var _Equivalence_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27786);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17316);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89379);
/* harmony import */ var _Inspectable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16371);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92817);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71335);
/**
 * A data type for immutable linked lists representing ordered collections of elements of type `A`.
 *
 * This data type is optimal for last-in-first-out (LIFO), stack-like access patterns. If you need another access pattern, for example, random access or FIFO, consider using a collection more suited to this than `List`.
 *
 * **Performance**
 *
 * - Time: `List` has `O(1)` prepend and head/tail access. Most other operations are `O(n)` on the number of elements in the list. This includes the index-based lookup of elements, `length`, `append` and `reverse`.
 * - Space: `List` implements structural sharing of the tail list. This means that many operations are either zero- or constant-memory cost.
 *
 * @since 2.0.0
 */
/**
 * This file is ported from
 *
 * Scala (https://www.scala-lang.org)
 *
 * Copyright EPFL and Lightbend, Inc.
 *
 * Licensed under Apache License 2.0
 * (http://www.apache.org/licenses/LICENSE-2.0).
 */











/**
 * @since 2.0.0
 * @category symbol
 */
const TypeId = /*#__PURE__*/Symbol.for("effect/List");
/**
 * Converts the specified `List` to an `Array`.
 *
 * @category conversions
 * @since 2.0.0
 */
const toArray = self => _Array_js__WEBPACK_IMPORTED_MODULE_0__/* .fromIterable */ .EE(self);
/**
 * @category equivalence
 * @since 2.0.0
 */
const getEquivalence = isEquivalent => _Equivalence_js__WEBPACK_IMPORTED_MODULE_1__/* .mapInput */ .$H(_Array_js__WEBPACK_IMPORTED_MODULE_0__/* .getEquivalence */ .c5(isEquivalent), toArray);
const _equivalence = /*#__PURE__*/getEquivalence(_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .equals */ .fS);
const ConsProto = {
  [TypeId]: TypeId,
  _tag: "Cons",
  toString() {
    return (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_3__/* .format */ .WU)(this.toJSON());
  },
  toJSON() {
    return {
      _id: "List",
      _tag: "Cons",
      values: toArray(this).map(_Inspectable_js__WEBPACK_IMPORTED_MODULE_3__/* .toJSON */ .au)
    };
  },
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_3__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  },
  [_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .symbol */ .NA](that) {
    return isList(that) && this._tag === that._tag && _equivalence(this, that);
  },
  [_Hash_js__WEBPACK_IMPORTED_MODULE_4__/* .symbol */ .NA]() {
    return _Hash_js__WEBPACK_IMPORTED_MODULE_4__/* .cached */ .HX(this, _Hash_js__WEBPACK_IMPORTED_MODULE_4__/* .array */ .IX(toArray(this)));
  },
  [Symbol.iterator]() {
    let done = false;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let self = this;
    return {
      next() {
        if (done) {
          return this.return();
        }
        if (self._tag === "Nil") {
          done = true;
          return this.return();
        }
        const value = self.head;
        self = self.tail;
        return {
          done,
          value
        };
      },
      return(value) {
        if (!done) {
          done = true;
        }
        return {
          done: true,
          value
        };
      }
    };
  },
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_5__/* .pipeArguments */ .n)(this, arguments);
  }
};
const makeCons = (head, tail) => {
  const cons = Object.create(ConsProto);
  cons.head = head;
  cons.tail = tail;
  return cons;
};
const NilHash = /*#__PURE__*/_Hash_js__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_("Nil");
const NilProto = {
  [TypeId]: TypeId,
  _tag: "Nil",
  toString() {
    return (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_3__/* .format */ .WU)(this.toJSON());
  },
  toJSON() {
    return {
      _id: "List",
      _tag: "Nil"
    };
  },
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_3__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  },
  [_Hash_js__WEBPACK_IMPORTED_MODULE_4__/* .symbol */ .NA]() {
    return NilHash;
  },
  [_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .symbol */ .NA](that) {
    return isList(that) && this._tag === that._tag;
  },
  [Symbol.iterator]() {
    return {
      next() {
        return {
          done: true,
          value: undefined
        };
      }
    };
  },
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_5__/* .pipeArguments */ .n)(this, arguments);
  }
};
const _Nil = /*#__PURE__*/Object.create(NilProto);
/**
 * Returns `true` if the specified value is a `List`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isList = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_6__/* .hasProperty */ .l$)(u, TypeId);
/**
 * Returns `true` if the specified value is a `List.Nil<A>`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isNil = self => self._tag === "Nil";
/**
 * Returns `true` if the specified value is a `List.Cons<A>`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isCons = self => self._tag === "Cons";
/**
 * Returns the number of elements contained in the specified `List`
 *
 * @since 2.0.0
 * @category getters
 */
const size = self => {
  let these = self;
  let len = 0;
  while (!isNil(these)) {
    len += 1;
    these = these.tail;
  }
  return len;
};
/**
 * Constructs a new empty `List<A>`.
 *
 * @since 2.0.0
 * @category constructors
 */
const nil = () => _Nil;
/**
 * Constructs a new `List.Cons<A>` from the specified `head` and `tail` values.
 *
 * @since 2.0.0
 * @category constructors
 */
const cons = (head, tail) => makeCons(head, tail);
/**
 * Constructs a new empty `List<A>`.
 *
 * Alias of {@link nil}.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = nil;
/**
 * Constructs a new `List<A>` from the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
const of = value => makeCons(value, _Nil);
/**
 * Creates a new `List` from an iterable collection of values.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable = prefix => {
  const iterator = prefix[Symbol.iterator]();
  let next;
  if ((next = iterator.next()) && !next.done) {
    const result = makeCons(next.value, _Nil);
    let curr = result;
    while ((next = iterator.next()) && !next.done) {
      const temp = makeCons(next.value, _Nil);
      curr.tail = temp;
      curr = temp;
    }
    return result;
  } else {
    return _Nil;
  }
};
/**
 * Constructs a new `List<A>` from the specified values.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = (...elements) => fromIterable(elements);
/**
 * Appends the specified element to the end of the `List`, creating a new `Cons`.
 *
 * @category concatenating
 * @since 2.0.0
 */
const append = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, element) => appendAll(self, of(element)))));
/**
 * Concatenates two lists, combining their elements.
 * If either list is non-empty, the result is also a non-empty list.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { List } from "effect"
 *
 * assert.deepStrictEqual(
 *   List.make(1, 2).pipe(List.appendAll(List.make("a", "b")), List.toArray),
 *   [1, 2, "a", "b"]
 * )
 * ```
 *
 * @category concatenating
 * @since 2.0.0
 */
const appendAll = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_7__/* .dual */ .OB)(2, (self, that) => prependAll(that, self));
/**
 * Prepends the specified element to the beginning of the list.
 *
 * @category concatenating
 * @since 2.0.0
 */
const prepend = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_7__/* .dual */ .OB)(2, (self, element) => cons(element, self));
/**
 * Prepends the specified prefix list to the beginning of the specified list.
 * If either list is non-empty, the result is also a non-empty list.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { List } from "effect"
 *
 * assert.deepStrictEqual(
 *   List.make(1, 2).pipe(List.prependAll(List.make("a", "b")), List.toArray),
 *   ["a", "b", 1, 2]
 * )
 * ```
 *
 * @category concatenating
 * @since 2.0.0
 */
const prependAll = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_7__/* .dual */ .OB)(2, (self, prefix) => {
  if (isNil(self)) {
    return prefix;
  } else if (isNil(prefix)) {
    return self;
  } else {
    const result = makeCons(prefix.head, self);
    let curr = result;
    let that = prefix.tail;
    while (!isNil(that)) {
      const temp = makeCons(that.head, self);
      curr.tail = temp;
      curr = temp;
      that = that.tail;
    }
    return result;
  }
});
/**
 * Prepends the specified prefix list (in reverse order) to the beginning of the
 * specified list.
 *
 * @category concatenating
 * @since 2.0.0
 */
const prependAllReversed = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, prefix) => {
  let out = self;
  let pres = prefix;
  while (isCons(pres)) {
    out = makeCons(pres.head, out);
    pres = pres.tail;
  }
  return out;
})));
/**
 * Drops the first `n` elements from the specified list.
 *
 * @since 2.0.0
 * @category combinators
 */
const drop = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => {
  if (n <= 0) {
    return self;
  }
  if (n >= size(self)) {
    return _Nil;
  }
  let these = self;
  let i = 0;
  while (!isNil(these) && i < n) {
    these = these.tail;
    i += 1;
  }
  return these;
})));
/**
 * Check if a predicate holds true for every `List` element.
 *
 * @since 2.0.0
 * @category elements
 */
const every = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, refinement) => {
  for (const a of self) {
    if (!refinement(a)) {
      return false;
    }
  }
  return true;
})));
/**
 * Check if a predicate holds true for some `List` element.
 *
 * @since 2.0.0
 * @category elements
 */
const some = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => {
  let these = self;
  while (!isNil(these)) {
    if (predicate(these.head)) {
      return true;
    }
    these = these.tail;
  }
  return false;
})));
/**
 * Filters a list using the specified predicate.
 *
 * @since 2.0.0
 * @category combinators
 */
const filter = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => noneIn(self, predicate, false))));
// everything seen so far is not included
const noneIn = (self, predicate, isFlipped) => {
  while (true) {
    if (isNil(self)) {
      return _Nil;
    } else {
      if (predicate(self.head) !== isFlipped) {
        return allIn(self, self.tail, predicate, isFlipped);
      } else {
        self = self.tail;
      }
    }
  }
};
// everything from 'start' is included, if everything from this point is in we can return the origin
// start otherwise if we discover an element that is out we must create a new partial list.
const allIn = (start, remaining, predicate, isFlipped) => {
  while (true) {
    if (isNil(remaining)) {
      return start;
    } else {
      if (predicate(remaining.head) !== isFlipped) {
        remaining = remaining.tail;
      } else {
        return partialFill(start, remaining, predicate, isFlipped);
      }
    }
  }
};
// we have seen elements that should be included then one that should be excluded, start building
const partialFill = (origStart, firstMiss, predicate, isFlipped) => {
  const newHead = makeCons(unsafeHead(origStart), _Nil);
  let toProcess = unsafeTail(origStart);
  let currentLast = newHead;
  // we know that all elements are :: until at least firstMiss.tail
  while (!(toProcess === firstMiss)) {
    const newElem = makeCons(unsafeHead(toProcess), _Nil);
    currentLast.tail = newElem;
    currentLast = unsafeCoerce(newElem);
    toProcess = unsafeCoerce(toProcess.tail);
  }
  // at this point newHead points to a list which is a duplicate of all the 'in' elements up to the first miss.
  // currentLast is the last element in that list.
  // now we are going to try and share as much of the tail as we can, only moving elements across when we have to.
  let next = firstMiss.tail;
  let nextToCopy = unsafeCoerce(next); // the next element we would need to copy to our list if we cant share.
  while (!isNil(next)) {
    // generally recommended is next.isNonEmpty but this incurs an extra method call.
    const head = unsafeHead(next);
    if (predicate(head) !== isFlipped) {
      next = next.tail;
    } else {
      // its not a match - do we have outstanding elements?
      while (!(nextToCopy === next)) {
        const newElem = makeCons(unsafeHead(nextToCopy), _Nil);
        currentLast.tail = newElem;
        currentLast = newElem;
        nextToCopy = unsafeCoerce(nextToCopy.tail);
      }
      nextToCopy = unsafeCoerce(next.tail);
      next = next.tail;
    }
  }
  // we have remaining elements - they are unchanged attach them to the end
  if (!isNil(nextToCopy)) {
    currentLast.tail = nextToCopy;
  }
  return newHead;
};
/**
 * Filters and maps a list using the specified partial function. The resulting
 * list may be smaller than the input list due to the possibility of the partial
 * function not being defined for some elements.
 *
 * @since 2.0.0
 * @category combinators
 */
const filterMap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  const bs = [];
  for (const a of self) {
    const oa = f(a);
    if (Option.isSome(oa)) {
      bs.push(oa.value);
    }
  }
  return fromIterable(bs);
})));
/**
 * Removes all `None` values from the specified list.
 *
 * @since 2.0.0
 * @category combinators
 */
const compact = self => filterMap(self, identity);
/**
 * Returns the first element that satisfies the specified
 * predicate, or `None` if no such element exists.
 *
 * @category elements
 * @since 2.0.0
 */
const findFirst = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => {
  let these = self;
  while (!isNil(these)) {
    if (predicate(these.head)) {
      return Option.some(these.head);
    }
    these = these.tail;
  }
  return Option.none();
})));
/**
 * Applies a function to each element in a list and returns a new list containing the concatenated mapped elements.
 *
 * @since 2.0.0
 * @category sequencing
 */
const flatMap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  let rest = self;
  let head = undefined;
  let tail = undefined;
  while (!isNil(rest)) {
    let bs = f(rest.head);
    while (!isNil(bs)) {
      const next = makeCons(bs.head, _Nil);
      if (tail === undefined) {
        head = next;
      } else {
        tail.tail = next;
      }
      tail = next;
      bs = bs.tail;
    }
    rest = rest.tail;
  }
  if (head === undefined) {
    return _Nil;
  }
  return head;
})));
/**
 * Applies the specified function to each element of the `List`.
 *
 * @since 2.0.0
 * @category combinators
 */
const forEach = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  let these = self;
  while (!isNil(these)) {
    f(these.head);
    these = these.tail;
  }
})));
/**
 * Returns the first element of the specified list, or `None` if the list is
 * empty.
 *
 * @since 2.0.0
 * @category getters
 */
const head = self => isNil(self) ? Option.none() : Option.some(self.head);
/**
 * Returns the last element of the specified list, or `None` if the list is
 * empty.
 *
 * @since 2.0.0
 * @category getters
 */
const last = self => isNil(self) ? Option.none() : Option.some(unsafeLast(self));
/**
 * Applies the specified mapping function to each element of the list.
 *
 * @since 2.0.0
 * @category mapping
 */
const map = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  if (isNil(self)) {
    return self;
  } else {
    let i = 0;
    const head = makeCons(f(self.head, i++), _Nil);
    let nextHead = head;
    let rest = self.tail;
    while (!isNil(rest)) {
      const next = makeCons(f(rest.head, i++), _Nil);
      nextHead.tail = next;
      nextHead = next;
      rest = rest.tail;
    }
    return head;
  }
})));
/**
 * Partition a list into two lists, where the first list contains all elements
 * that did not satisfy the specified predicate, and the second list contains
 * all elements that did satisfy the specified predicate.
 *
 * @since 2.0.0
 * @category combinators
 */
const partition = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => {
  const left = [];
  const right = [];
  for (const a of self) {
    if (predicate(a)) {
      right.push(a);
    } else {
      left.push(a);
    }
  }
  return [fromIterable(left), fromIterable(right)];
})));
/**
 * Partition a list into two lists, where the first list contains all elements
 * for which the specified function returned a `Left`, and the second list
 * contains all elements for which the specified function returned a `Right`.
 *
 * @since 2.0.0
 * @category combinators
 */
const partitionMap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  const left = [];
  const right = [];
  for (const a of self) {
    const e = f(a);
    if (Either.isLeft(e)) {
      left.push(e.left);
    } else {
      right.push(e.right);
    }
  }
  return [fromIterable(left), fromIterable(right)];
})));
/**
 * Folds over the elements of the list using the specified function, using the
 * specified initial value.
 *
 * @since 2.0.0
 * @category folding
 */
const reduce = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_7__/* .dual */ .OB)(3, (self, zero, f) => {
  let acc = zero;
  let these = self;
  while (!isNil(these)) {
    acc = f(acc, these.head);
    these = these.tail;
  }
  return acc;
});
/**
 * Folds over the elements of the list using the specified function, beginning
 * with the last element of the list, using the specified initial value.
 *
 * @since 2.0.0
 * @category folding
 */
const reduceRight = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, zero, f) => {
  let acc = zero;
  let these = reverse(self);
  while (!isNil(these)) {
    acc = f(acc, these.head);
    these = these.tail;
  }
  return acc;
})));
/**
 * Returns a new list with the elements of the specified list in reverse order.
 *
 * @since 2.0.0
 * @category elements
 */
const reverse = self => {
  let result = empty();
  let these = self;
  while (!isNil(these)) {
    result = prepend(result, these.head);
    these = these.tail;
  }
  return result;
};
/**
 * Splits the specified list into two lists at the specified index.
 *
 * @since 2.0.0
 * @category combinators
 */
const splitAt = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => [take(self, n), drop(self, n)])));
/**
 * Returns the tail of the specified list, or `None` if the list is empty.
 *
 * @since 2.0.0
 * @category getters
 */
const tail = self => isNil(self) ? Option.none() : Option.some(self.tail);
/**
 * Takes the specified number of elements from the beginning of the specified
 * list.
 *
 * @since 2.0.0
 * @category combinators
 */
const take = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => {
  if (n <= 0) {
    return _Nil;
  }
  if (n >= size(self)) {
    return self;
  }
  let these = make(unsafeHead(self));
  let current = unsafeTail(self);
  for (let i = 1; i < n; i++) {
    these = makeCons(unsafeHead(current), these);
    current = unsafeTail(current);
  }
  return reverse(these);
})));
/**
 * Converts the specified `List` to a `Chunk`.
 *
 * @since 2.0.0
 * @category conversions
 */
const toChunk = self => Chunk.fromIterable(self);
const getExpectedListToBeNonEmptyErrorMessage = "Expected List to be non-empty";
/**
 * Unsafely returns the first element of the specified `List`.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeHead = self => {
  if (isNil(self)) {
    throw new Error(getExpectedListToBeNonEmptyErrorMessage);
  }
  return self.head;
};
/**
 * Unsafely returns the last element of the specified `List`.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeLast = self => {
  if (isNil(self)) {
    throw new Error(getExpectedListToBeNonEmptyErrorMessage);
  }
  let these = self;
  let scout = self.tail;
  while (!isNil(scout)) {
    these = scout;
    scout = scout.tail;
  }
  return these.head;
};
/**
 * Unsafely returns the tail of the specified `List`.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeTail = self => {
  if (isNil(self)) {
    throw new Error(getExpectedListToBeNonEmptyErrorMessage);
  }
  return self.tail;
};
//# sourceMappingURL=List.js.map

/***/ }),

/***/ 69783:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gu": function() { return /* binding */ Fatal; },
/* harmony export */   "cG": function() { return /* binding */ Debug; },
/* harmony export */   "fM": function() { return /* binding */ Trace; },
/* harmony export */   "ik": function() { return /* binding */ fromLiteral; },
/* harmony export */   "jj": function() { return /* binding */ Error; },
/* harmony export */   "kI": function() { return /* binding */ Info; },
/* harmony export */   "tS": function() { return /* binding */ greaterThan; },
/* harmony export */   "v3": function() { return /* binding */ Warning; }
/* harmony export */ });
/* unused harmony exports All, None, allLevels, locally, Order, lessThan, lessThanEqual, greaterThanEqual */
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17316);
/* harmony import */ var _internal_core_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39355);
/* harmony import */ var _Number_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15839);
/* harmony import */ var _Order_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51988);




/**
 * @since 2.0.0
 * @category constructors
 */
const All = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .logLevelAll */ .V_D;
/**
 * @since 2.0.0
 * @category constructors
 */
const Fatal = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .logLevelFatal */ ._7M;
/**
 * @since 2.0.0
 * @category constructors
 */
const Error = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .logLevelError */ .Ngl;
/**
 * @since 2.0.0
 * @category constructors
 */
const Warning = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .logLevelWarning */ .RX8;
/**
 * @since 2.0.0
 * @category constructors
 */
const Info = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .logLevelInfo */ .xUq;
/**
 * @since 2.0.0
 * @category constructors
 */
const Debug = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .logLevelDebug */ .M2X;
/**
 * @since 2.0.0
 * @category constructors
 */
const Trace = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .logLevelTrace */ .Lth;
/**
 * @since 2.0.0
 * @category constructors
 */
const None = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .logLevelNone */ .R$E;
/**
 * @since 2.0.0
 * @category constructors
 */
const allLevels = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .allLogLevels */ .N8w;
/**
 * Temporarily sets a `LogLevel` for an `Effect` workflow.
 *
 * **Details**
 *
 * This function allows you to apply a specific `LogLevel` locally to an
 * `Effect` workflow. Once the workflow completes, the `LogLevel` reverts to its
 * previous state.
 *
 * **When to Use**
 *
 * This is particularly useful when you want to adjust the verbosity of logging
 * for specific parts of your program without affecting the global log level.
 *
 * @example
 * ```ts
 * import { Effect, LogLevel } from "effect"
 *
 * const program = Effect.gen(function*() {
 *   yield* Effect.log("message1")
 *   yield* Effect.gen(function*() {
 *     yield* Effect.log("message2")
 *     yield* Effect.log("message3")
 *   }).pipe(LogLevel.locally(LogLevel.Warning))
 * })
 *
 * Effect.runFork(program)
 * // timestamp=... level=INFO fiber=#0 message=message1
 * // timestamp=... level=WARN fiber=#0 message=message2
 * // timestamp=... level=WARN fiber=#0 message=message3
 * ```
 *
 * @since 2.0.0
 * @category utils
 */
const locally = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (use, self) => core.fiberRefLocally(use, core.currentLogLevel, self))));
/**
 * @since 2.0.0
 * @category instances
 */
const Order = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(_Number_js__WEBPACK_IMPORTED_MODULE_2__/* .Order */ .KM, /*#__PURE__*/_Order_js__WEBPACK_IMPORTED_MODULE_3__/* .mapInput */ .$H(level => level.ordinal));
/**
 * @since 2.0.0
 * @category ordering
 */
const lessThan = /*#__PURE__*/(/* unused pure expression or super */ null && (order.lessThan(Order)));
/**
 * @since 2.0.0
 * @category ordering
 */
const lessThanEqual = /*#__PURE__*/(/* unused pure expression or super */ null && (order.lessThanOrEqualTo(Order)));
/**
 * @since 2.0.0
 * @category ordering
 */
const greaterThan = /*#__PURE__*/_Order_js__WEBPACK_IMPORTED_MODULE_3__/* .greaterThan */ .tS(Order);
/**
 * @since 2.0.0
 * @category ordering
 */
const greaterThanEqual = /*#__PURE__*/(/* unused pure expression or super */ null && (order.greaterThanOrEqualTo(Order)));
/**
 * @since 2.0.0
 * @category conversions
 */
const fromLiteral = literal => {
  switch (literal) {
    case "All":
      return All;
    case "Debug":
      return Debug;
    case "Error":
      return Error;
    case "Fatal":
      return Fatal;
    case "Info":
      return Info;
    case "Trace":
      return Trace;
    case "None":
      return None;
    case "Warning":
      return Warning;
  }
};
//# sourceMappingURL=LogLevel.js.map

/***/ }),

/***/ 30424:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Od": function() { return /* binding */ remove; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "dp": function() { return /* binding */ size; },
/* harmony export */   "e$": function() { return /* binding */ has; },
/* harmony export */   "t8": function() { return /* binding */ set; }
/* harmony export */ });
/* unused harmony exports make, fromIterable, keys, values, modify, modifyAt, clear, isEmpty, forEach */
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17316);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89379);
/* harmony import */ var _Inspectable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16371);
/* harmony import */ var _Option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16749);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92817);






const TypeId = /*#__PURE__*/Symbol.for("effect/MutableHashMap");
const MutableHashMapProto = {
  [TypeId]: TypeId,
  [Symbol.iterator]() {
    return new MutableHashMapIterator(this);
  },
  toString() {
    return (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_0__/* .format */ .WU)(this.toJSON());
  },
  toJSON() {
    return {
      _id: "MutableHashMap",
      values: Array.from(this).map(_Inspectable_js__WEBPACK_IMPORTED_MODULE_0__/* .toJSON */ .au)
    };
  },
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_0__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  },
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_1__/* .pipeArguments */ .n)(this, arguments);
  }
};
class MutableHashMapIterator {
  self;
  referentialIterator;
  bucketIterator;
  constructor(self) {
    this.self = self;
    this.referentialIterator = self.referential[Symbol.iterator]();
  }
  next() {
    if (this.bucketIterator !== undefined) {
      return this.bucketIterator.next();
    }
    const result = this.referentialIterator.next();
    if (result.done) {
      this.bucketIterator = new BucketIterator(this.self.buckets.values());
      return this.next();
    }
    return result;
  }
  [Symbol.iterator]() {
    return new MutableHashMapIterator(this.self);
  }
}
class BucketIterator {
  backing;
  constructor(backing) {
    this.backing = backing;
  }
  currentBucket;
  next() {
    if (this.currentBucket === undefined) {
      const result = this.backing.next();
      if (result.done) {
        return result;
      }
      this.currentBucket = result.value[Symbol.iterator]();
    }
    const result = this.currentBucket.next();
    if (result.done) {
      this.currentBucket = undefined;
      return this.next();
    }
    return result;
  }
}
/**
 * @since 2.0.0
 * @category constructors
 */
const empty = () => {
  const self = Object.create(MutableHashMapProto);
  self.referential = new Map();
  self.buckets = new Map();
  self.bucketsSize = 0;
  return self;
};
/**
 * @since 2.0.0
 * @category constructors
 */
const make = (...entries) => fromIterable(entries);
/**
 * Creates a new `MutableHashMap` from an iterable collection of key/value pairs.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable = entries => {
  const self = empty();
  for (const [key, value] of entries) {
    set(self, key, value);
  }
  return self;
};
/**
 * @since 2.0.0
 * @category elements
 */
const get = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, key) => {
  if (_Equal_js__WEBPACK_IMPORTED_MODULE_3__/* .isEqual */ .Xy(key) === false) {
    return self.referential.has(key) ? _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .some */ .G(self.referential.get(key)) : _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .none */ .YP();
  }
  const hash = key[_Hash_js__WEBPACK_IMPORTED_MODULE_5__/* .symbol */ .NA]();
  const bucket = self.buckets.get(hash);
  if (bucket === undefined) {
    return _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .none */ .YP();
  }
  return getFromBucket(self, bucket, key);
});
/**
 * @since 3.8.0
 * @category elements
 */
const keys = self => {
  const keys = Array.from(self.referential.keys());
  for (const bucket of self.buckets.values()) {
    for (let i = 0, len = bucket.length; i < len; i++) {
      keys.push(bucket[i][0]);
    }
  }
  return keys;
};
/**
 * @since 3.8.0
 * @category elements
 */
const values = self => {
  const values = Array.from(self.referential.values());
  for (const bucket of self.buckets.values()) {
    for (let i = 0, len = bucket.length; i < len; i++) {
      values.push(bucket[i][1]);
    }
  }
  return values;
};
const getFromBucket = (self, bucket, key, remove = false) => {
  for (let i = 0, len = bucket.length; i < len; i++) {
    if (key[_Equal_js__WEBPACK_IMPORTED_MODULE_3__/* .symbol */ .NA](bucket[i][0])) {
      const value = bucket[i][1];
      if (remove) {
        bucket.splice(i, 1);
        self.bucketsSize--;
      }
      return _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .some */ .G(value);
    }
  }
  return _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .none */ .YP();
};
/**
 * @since 2.0.0
 * @category elements
 */
const has = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, key) => _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .isSome */ .pC(get(self, key)));
/**
 * @since 2.0.0
 */
const set = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(3, (self, key, value) => {
  if (_Equal_js__WEBPACK_IMPORTED_MODULE_3__/* .isEqual */ .Xy(key) === false) {
    self.referential.set(key, value);
    return self;
  }
  const hash = key[_Hash_js__WEBPACK_IMPORTED_MODULE_5__/* .symbol */ .NA]();
  const bucket = self.buckets.get(hash);
  if (bucket === undefined) {
    self.buckets.set(hash, [[key, value]]);
    self.bucketsSize++;
    return self;
  }
  removeFromBucket(self, bucket, key);
  bucket.push([key, value]);
  self.bucketsSize++;
  return self;
});
const removeFromBucket = (self, bucket, key) => {
  for (let i = 0, len = bucket.length; i < len; i++) {
    if (key[_Equal_js__WEBPACK_IMPORTED_MODULE_3__/* .symbol */ .NA](bucket[i][0])) {
      bucket.splice(i, 1);
      self.bucketsSize--;
      return;
    }
  }
};
/**
 * Updates the value of the specified key within the `MutableHashMap` if it exists.
 *
 * @since 2.0.0
 */
const modify = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, key, f) => {
  if (Equal.isEqual(key) === false) {
    if (self.referential.has(key)) {
      self.referential.set(key, f(self.referential.get(key)));
    }
    return self;
  }
  const hash = key[Hash.symbol]();
  const bucket = self.buckets.get(hash);
  if (bucket === undefined) {
    return self;
  }
  const value = getFromBucket(self, bucket, key, true);
  if (Option.isNone(value)) {
    return self;
  }
  bucket.push([key, f(value.value)]);
  self.bucketsSize++;
  return self;
})));
/**
 * Set or remove the specified key in the `MutableHashMap` using the specified
 * update function.
 *
 * @since 2.0.0
 */
const modifyAt = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, key, f) => {
  if (Equal.isEqual(key) === false) {
    const result = f(get(self, key));
    if (Option.isSome(result)) {
      set(self, key, result.value);
    } else {
      remove(self, key);
    }
    return self;
  }
  const hash = key[Hash.symbol]();
  const bucket = self.buckets.get(hash);
  if (bucket === undefined) {
    const result = f(Option.none());
    return Option.isSome(result) ? set(self, key, result.value) : self;
  }
  const result = f(getFromBucket(self, bucket, key, true));
  if (Option.isNone(result)) {
    if (bucket.length === 0) {
      self.buckets.delete(hash);
    }
    return self;
  }
  bucket.push([key, result.value]);
  self.bucketsSize++;
  return self;
})));
/**
 * @since 2.0.0
 */
const remove = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, key) => {
  if (_Equal_js__WEBPACK_IMPORTED_MODULE_3__/* .isEqual */ .Xy(key) === false) {
    self.referential.delete(key);
    return self;
  }
  const hash = key[_Hash_js__WEBPACK_IMPORTED_MODULE_5__/* .symbol */ .NA]();
  const bucket = self.buckets.get(hash);
  if (bucket === undefined) {
    return self;
  }
  removeFromBucket(self, bucket, key);
  if (bucket.length === 0) {
    self.buckets.delete(hash);
  }
  return self;
});
/**
 * @since 2.0.0
 */
const clear = self => {
  self.referential.clear();
  self.buckets.clear();
  self.bucketsSize = 0;
  return self;
};
/**
 * @since 2.0.0
 * @category elements
 */
const size = self => {
  return self.referential.size + self.bucketsSize;
};
/**
 * @since 2.0.0
 */
const isEmpty = self => size(self) === 0;
/**
 * @since 2.0.0
 */
const forEach = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  self.referential.forEach(f);
  for (const bucket of self.buckets.values()) {
    for (const [key, value] of bucket) {
      f(value, key);
    }
  }
})));
//# sourceMappingURL=MutableHashMap.js.map

/***/ }),

/***/ 23182:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "t8": function() { return /* binding */ set; },
/* harmony export */   "te": function() { return /* binding */ compareAndSet; }
/* harmony export */ });
/* unused harmony exports decrement, decrementAndGet, getAndDecrement, getAndIncrement, getAndSet, getAndUpdate, increment, incrementAndGet, setAndGet, update, updateAndGet, toggle */
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17316);
/* harmony import */ var _Inspectable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16371);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92817);
/**
 * @since 2.0.0
 */




const TypeId = /*#__PURE__*/Symbol.for("effect/MutableRef");
const MutableRefProto = {
  [TypeId]: TypeId,
  toString() {
    return (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_0__/* .format */ .WU)(this.toJSON());
  },
  toJSON() {
    return {
      _id: "MutableRef",
      current: (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_0__/* .toJSON */ .au)(this.current)
    };
  },
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_0__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  },
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_1__/* .pipeArguments */ .n)(this, arguments);
  }
};
/**
 * @since 2.0.0
 * @category constructors
 */
const make = value => {
  const ref = Object.create(MutableRefProto);
  ref.current = value;
  return ref;
};
/**
 * @since 2.0.0
 * @category general
 */
const compareAndSet = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB(3, (self, oldValue, newValue) => {
  if (_Equal_js__WEBPACK_IMPORTED_MODULE_3__/* .equals */ .fS(oldValue, self.current)) {
    self.current = newValue;
    return true;
  }
  return false;
});
/**
 * @since 2.0.0
 * @category numeric
 */
const decrement = self => update(self, n => n - 1);
/**
 * @since 2.0.0
 * @category numeric
 */
const decrementAndGet = self => updateAndGet(self, n => n - 1);
/**
 * @since 2.0.0
 * @category general
 */
const get = self => self.current;
/**
 * @since 2.0.0
 * @category numeric
 */
const getAndDecrement = self => getAndUpdate(self, n => n - 1);
/**
 * @since 2.0.0
 * @category numeric
 */
const getAndIncrement = self => getAndUpdate(self, n => n + 1);
/**
 * @since 2.0.0
 * @category general
 */
const getAndSet = /*#__PURE__*/(/* unused pure expression or super */ null && (Dual.dual(2, (self, value) => {
  const ret = self.current;
  self.current = value;
  return ret;
})));
/**
 * @since 2.0.0
 * @category general
 */
const getAndUpdate = /*#__PURE__*/(/* unused pure expression or super */ null && (Dual.dual(2, (self, f) => getAndSet(self, f(get(self))))));
/**
 * @since 2.0.0
 * @category numeric
 */
const increment = self => update(self, n => n + 1);
/**
 * @since 2.0.0
 * @category numeric
 */
const incrementAndGet = self => updateAndGet(self, n => n + 1);
/**
 * @since 2.0.0
 * @category general
 */
const set = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB(2, (self, value) => {
  self.current = value;
  return self;
});
/**
 * @since 2.0.0
 * @category general
 */
const setAndGet = /*#__PURE__*/(/* unused pure expression or super */ null && (Dual.dual(2, (self, value) => {
  self.current = value;
  return self.current;
})));
/**
 * @since 2.0.0
 * @category general
 */
const update = /*#__PURE__*/(/* unused pure expression or super */ null && (Dual.dual(2, (self, f) => set(self, f(get(self))))));
/**
 * @since 2.0.0
 * @category general
 */
const updateAndGet = /*#__PURE__*/(/* unused pure expression or super */ null && (Dual.dual(2, (self, f) => setAndGet(self, f(get(self))))));
/**
 * @since 2.0.0
 * @category boolean
 */
const toggle = self => update(self, _ => !_);
//# sourceMappingURL=MutableRef.js.map

/***/ }),

/***/ 15839:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KM": function() { return /* binding */ Order; },
/* harmony export */   "Qc": function() { return /* binding */ parse; }
/* harmony export */ });
/* unused harmony exports isNumber, negate, sum, sumAll, subtract, multiply, multiplyAll, divide, unsafeDivide, increment, decrement, Equivalence, lessThan, lessThanOrEqualTo, greaterThan, greaterThanOrEqualTo, between, clamp, min, max, sign, remainder, nextPow2, round */
/* harmony import */ var _Equivalence_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27786);
/* harmony import */ var _internal_option_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70602);
/* harmony import */ var _Order_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51988);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71335);
/**
 * # Number
 *
 * This module provides utility functions and type class instances for working
 * with the `number` type in TypeScript. It includes functions for basic
 * arithmetic operations, as well as type class instances for `Equivalence` and
 * `Order`.
 *
 * ## Operations Reference
 *
 * | Category     | Operation                                  | Description                                             | Domain                         | Co-domain             |
 * | ------------ | ------------------------------------------ | ------------------------------------------------------- | ------------------------------ | --------------------- |
 * | constructors | {@link module:Number.parse}                | Safely parses a string to a number                      | `string`                       | `Option<number>`      |
 * |              |                                            |                                                         |                                |                       |
 * | math         | {@link module:Number.sum}                  | Adds two numbers                                        | `number`, `number`             | `number`              |
 * | math         | {@link module:Number.sumAll}               | Sums all numbers in a collection                        | `Iterable<number>`             | `number`              |
 * | math         | {@link module:Number.subtract}             | Subtracts one number from another                       | `number`, `number`             | `number`              |
 * | math         | {@link module:Number.multiply}             | Multiplies two numbers                                  | `number`, `number`             | `number`              |
 * | math         | {@link module:Number.multiplyAll}          | Multiplies all numbers in a collection                  | `Iterable<number>`             | `number`              |
 * | math         | {@link module:Number.divide}               | Safely divides handling division by zero                | `number`, `number`             | `Option<number>`      |
 * | math         | {@link module:Number.unsafeDivide}         | Divides but misbehaves for division by zero             | `number`, `number`             | `number`              |
 * | math         | {@link module:Number.remainder}            | Calculates remainder of division                        | `number`, `number`             | `number`              |
 * | math         | {@link module:Number.increment}            | Adds 1 to a number                                      | `number`                       | `number`              |
 * | math         | {@link module:Number.decrement}            | Subtracts 1 from a number                               | `number`                       | `number`              |
 * | math         | {@link module:Number.sign}                 | Determines the sign of a number                         | `number`                       | `Ordering`            |
 * | math         | {@link module:Number.nextPow2}             | Finds the next power of 2                               | `number`                       | `number`              |
 * | math         | {@link module:Number.round}                | Rounds a number with specified precision                | `number`, `number`             | `number`              |
 * |              |                                            |                                                         |                                |                       |
 * | predicates   | {@link module:Number.between}              | Checks if a number is in a range                        | `number`, `{minimum, maximum}` | `boolean`             |
 * | predicates   | {@link module:Number.lessThan}             | Checks if one number is less than another               | `number`, `number`             | `boolean`             |
 * | predicates   | {@link module:Number.lessThanOrEqualTo}    | Checks if one number is less than or equal              | `number`, `number`             | `boolean`             |
 * | predicates   | {@link module:Number.greaterThan}          | Checks if one number is greater than another            | `number`, `number`             | `boolean`             |
 * | predicates   | {@link module:Number.greaterThanOrEqualTo} | Checks if one number is greater or equal                | `number`, `number`             | `boolean`             |
 * |              |                                            |                                                         |                                |                       |
 * | guards       | {@link module:Number.isNumber}             | Type guard for JavaScript numbers                       | `unknown`                      | `boolean`             |
 * |              |                                            |                                                         |                                |                       |
 * | comparison   | {@link module:Number.min}                  | Returns the minimum of two numbers                      | `number`, `number`             | `number`              |
 * | comparison   | {@link module:Number.max}                  | Returns the maximum of two numbers                      | `number`, `number`             | `number`              |
 * | comparison   | {@link module:Number.clamp}                | Restricts a number to a range                           | `number`, `{minimum, maximum}` | `number`              |
 * |              |                                            |                                                         |                                |                       |
 * | instances    | {@link module:Number.Equivalence}          | Equivalence instance for numbers                        |                                | `Equivalence<number>` |
 * | instances    | {@link module:Number.Order}                | Order instance for numbers                              |                                | `Order<number>`       |
 * |              |                                            |                                                         |                                |                       |
 * | errors       | {@link module:Number.DivisionByZeroError}  | Error thrown by unsafeDivide                            |                                |                       |
 *
 * ## Composition Patterns and Type Safety
 *
 * When building function pipelines, understanding how types flow through
 * operations is critical:
 *
 * ### Composing with type-preserving operations
 *
 * Most operations in this module are type-preserving (`number → number`),
 * making them easily composable in pipelines:
 *
 * ```ts
 * import { pipe } from "effect"
 * import * as Number from "effect/Number"
 *
 * const result = pipe(
 *   10,
 *   Number.increment, // number → number
 *   Number.multiply(2), // number → number
 *   Number.round(1) // number → number
 * ) // Result: number (21)
 * ```
 *
 * ### Working with Option results
 *
 * Operations that might fail (like division by zero) return Option types and
 * require Option combinators:
 *
 * ```ts
 * import { pipe, Option } from "effect"
 * import * as Number from "effect/Number"
 *
 * const result = pipe(
 *   10,
 *   Number.divide(0), // number → Option<number>
 *   Option.getOrElse(() => 0) // Option<number> → number
 * ) // Result: number (0)
 * ```
 *
 * ### Composition best practices
 *
 * - Chain type-preserving operations for maximum composability
 * - Use Option combinators when working with potentially failing operations
 * - Consider using Effect for operations that might fail with specific errors
 * - Remember that all operations maintain JavaScript's floating-point precision
 *   limitations
 *
 * @module Number
 * @since 2.0.0
 * @see {@link module:BigInt} for more similar operations on `bigint` types
 * @see {@link module:BigDecimal} for more similar operations on `BigDecimal` types
 */






/**
 * Type guard that tests if a value is a member of the set of JavaScript
 * numbers.
 *
 * @memberof Number
 * @since 2.0.0
 * @category guards
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import * as Number from "effect/Number"
 *
 * // Regular numbers
 * assert.equal(Number.isNumber(2), true)
 * assert.equal(Number.isNumber(-3.14), true)
 * assert.equal(Number.isNumber(0), true)
 *
 * // Special numeric values
 * assert.equal(Number.isNumber(Infinity), true)
 * assert.equal(Number.isNumber(NaN), true)
 *
 * // Non-number values
 * assert.equal(Number.isNumber("2"), false)
 * assert.equal(Number.isNumber(true), false)
 * assert.equal(Number.isNumber(null), false)
 * assert.equal(Number.isNumber(undefined), false)
 * assert.equal(Number.isNumber({}), false)
 * assert.equal(Number.isNumber([]), false)
 *
 * // Using as a type guard in conditionals
 * function processValue(value: unknown): string {
 *   if (Number.isNumber(value)) {
 *     // TypeScript now knows 'value' is a number
 *     return `Numeric value: ${value.toFixed(2)}`
 *   }
 *   return "Not a number"
 * }
 *
 * assert.strictEqual(processValue(42), "Numeric value: 42.00")
 * assert.strictEqual(processValue("hello"), "Not a number")
 *
 * // Filtering for numbers in an array
 * const mixed = [1, "two", 3, false, 5]
 * const onlyNumbers = mixed.filter(Number.isNumber)
 * assert.equal(onlyNumbers, [1, 3, 5])
 * ```
 *
 * @param input - The value to test for membership in the set of JavaScript
 *   numbers
 *
 * @returns `true` if the input is a JavaScript number, `false` otherwise
 */
const isNumber = _Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj;
/**
 * Returns the additive inverse of a number, effectively negating it.
 *
 * @memberof Number
 * @since 3.14.6
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { pipe } from "effect"
 * import * as Number from "effect/Number"
 *
 * assert.equal(
 *   Number.negate(5), //
 *   -5
 * )
 *
 * assert.equal(
 *   Number.negate(-5), //
 *   5
 * )
 *
 * assert.equal(
 *   Number.negate(0), //
 *   0
 * )
 * ```
 *
 * @param n - The number value to be negated.
 *
 * @returns The negated number value.
 */
const negate = n => multiply(n, -1);
/**
 * Performs addition in the set of JavaScript numbers.
 *
 * @memberof Number
 * @since 2.0.0
 * @category math
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { pipe } from "effect"
 * import * as Number from "effect/Number"
 *
 * // Data-first style (direct application)
 * assert.equal(Number.sum(2, 3), 5)
 * assert.equal(Number.sum(-10, 5), -5)
 * assert.equal(Number.sum(0.1, 0.2), 0.30000000000000004) // Note: floating-point precision limitation
 *
 * // Data-last style (pipeable)
 * assert.equal(
 *   pipe(
 *     10,
 *     Number.sum(5) // 10 + 5 = 15
 *   ),
 *   15
 * )
 *
 * // Chaining multiple additions
 * assert.equal(
 *   pipe(
 *     1,
 *     Number.sum(2), // 1 + 2 = 3
 *     Number.sum(3), // 3 + 3 = 6
 *     Number.sum(4) // 6 + 4 = 10
 *   ),
 *   10
 * )
 *
 * // Identity property: a + 0 = a
 * assert.equal(Number.sum(42, 0), 42)
 *
 * // Commutative property: a + b = b + a
 * assert.equal(Number.sum(5, 3), Number.sum(3, 5))
 * ```
 */
const sum = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => self + that)));
/**
 * Computes the sum of all elements in an iterable collection of numbers.
 *
 * @memberof Number
 * @since 2.0.0
 * @category math
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import * as Number from "effect/Number"
 *
 * // Basic sums
 * assert.equal(Number.sumAll([2, 3, 4]), 9) // 2 + 3 + 4 = 9
 * assert.equal(Number.sumAll([1.1, 2.2, 3.3]), 6.6) // 1.1 + 2.2 + 3.3 = 6.6
 *
 * // Empty collection returns the additive identity (0)
 * assert.equal(Number.sumAll([]), 0)
 *
 * // Single element collection
 * assert.equal(Number.sumAll([42]), 42)
 *
 * // Sums with negative numbers
 * assert.equal(Number.sumAll([2, -3, 4]), 3) // 2 + (-3) + 4 = 3
 * assert.equal(Number.sumAll([-2, -3, -4]), -9) // (-2) + (-3) + (-4) = -9
 *
 * // Works with any iterable
 * assert.equal(Number.sumAll(new Set([2, 3, 4])), 9)
 *
 * // Using with generated sequences
 * function* range(start: number, end: number) {
 *   for (let i = start; i <= end; i++) yield i
 * }
 *
 * // Compute sum of first 5 natural numbers: 1 + 2 + 3 + 4 + 5 = 15
 * assert.equal(Number.sumAll(range(1, 5)), 15)
 *
 * // Floating point precision example
 * assert.equal(
 *   Number.sumAll([0.1, 0.2]),
 *   0.30000000000000004 // Note IEEE 754 precision limitation
 * )
 * ```
 *
 * @param collection - An `iterable` containing the `numbers` to sum
 *
 * @returns The sum of all numbers in the collection, or 0 if the collection is
 *   empty
 */
const sumAll = collection => _Iterable.reduce(collection, 0, sum);
/**
 * Performs subtraction in the set of JavaScript numbers.
 *
 * @memberof Number
 * @since 2.0.0
 * @category math
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { pipe } from "effect"
 * import * as Number from "effect/Number"
 *
 * // Data-first style (direct application)
 * assert.equal(Number.subtract(2, 3), -1) // 2 - 3 = -1
 * assert.equal(Number.subtract(10, 5), 5) // 10 - 5 = 5
 * assert.equal(Number.subtract(0.3, 0.1), 0.19999999999999998) // Note: floating-point precision limitation
 *
 * // Data-last style (pipeable)
 * assert.equal(
 *   pipe(
 *     10,
 *     Number.subtract(5) // 10 - 5 = 5
 *   ),
 *   5
 * )
 *
 * // Chaining multiple subtractions
 * assert.equal(
 *   pipe(
 *     20,
 *     Number.subtract(5), // 20 - 5 = 15
 *     Number.subtract(3), // 15 - 3 = 12
 *     Number.subtract(2) // 12 - 2 = 10
 *   ),
 *   10
 * )
 *
 * // Right identity property: a - 0 = a
 * assert.equal(Number.subtract(42, 0), 42)
 *
 * // Self-annihilation property: a - a = 0
 * assert.equal(Number.subtract(42, 42), 0)
 *
 * // Non-commutative property: a - b ≠ b - a
 * assert.equal(Number.subtract(5, 3), 2) // 5 - 3 = 2
 * assert.equal(Number.subtract(3, 5), -2) // 3 - 5 = -2
 *
 * // Inverse relation: a - b = -(b - a)
 * assert.equal(Number.subtract(5, 3), -Number.subtract(3, 5))
 * ```
 */
const subtract = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (minuend, subtrahend) => minuend - subtrahend)));
/**
 * Performs **multiplication** in the set of JavaScript numbers.
 *
 * @memberof Number
 * @since 2.0.0
 * @category math
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { pipe } from "effect"
 * import * as Number from "effect/Number"
 *
 * // Data-first style (direct application)
 * assert.equal(Number.multiply(2, 3), 6) // 2 × 3 = 6
 * assert.equal(Number.multiply(-4, 5), -20) // (-4) × 5 = -20
 * assert.equal(Number.multiply(-3, -2), 6) // (-3) × (-2) = 6
 * assert.equal(Number.multiply(0.1, 0.2), 0.020000000000000004) // Note: floating-point precision limitation
 *
 * // Data-last style (pipeable)
 * assert.equal(
 *   pipe(
 *     10,
 *     Number.multiply(5) // 10 × 5 = 50
 *   ),
 *   50
 * )
 *
 * // Chaining multiple multiplications
 * assert.equal(
 *   pipe(
 *     2,
 *     Number.multiply(3), // 2 × 3 = 6
 *     Number.multiply(4), // 6 × 4 = 24
 *     Number.multiply(0.5) // 24 × 0.5 = 12
 *   ),
 *   12
 * )
 *
 * // Identity property: a × 1 = a
 * assert.equal(Number.multiply(42, 1), 42)
 *
 * // Zero property: a × 0 = 0
 * assert.equal(Number.multiply(42, 0), 0)
 *
 * // Commutative property: a × b = b × a
 * assert.equal(Number.multiply(5, 3), Number.multiply(3, 5))
 *
 * // Associative property: (a × b) × c = a × (b × c)
 * const a = 2,
 *   b = 3,
 *   c = 4
 * assert.equal(
 *   Number.multiply(Number.multiply(a, b), c),
 *   Number.multiply(a, Number.multiply(b, c))
 * )
 * ```
 */
const multiply = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (multiplier, multiplicand) => multiplier * multiplicand)));
/**
 * Computes the product of all elements in an iterable collection of numbers.
 *
 * @memberof Number
 * @since 2.0.0
 * @category math
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import * as Number from "effect/Number"
 *
 * // Basic products
 * assert.equal(Number.multiplyAll([2, 3, 4]), 24) // 2 × 3 × 4 = 24
 * assert.equal(Number.multiplyAll([1.5, 2, 3]), 9) // 1.5 × 2 × 3 = 9
 *
 * // Empty collection returns the multiplicative identity (1)
 * assert.equal(Number.multiplyAll([]), 1)
 *
 * // Single element collection
 * assert.equal(Number.multiplyAll([42]), 42)
 *
 * // Products with negative numbers
 * assert.equal(Number.multiplyAll([2, -3, 4]), -24) // 2 × (-3) × 4 = -24
 * assert.equal(Number.multiplyAll([-2, -3]), 6) // (-2) × (-3) = 6
 *
 * // Zero property - if any element is zero, product is zero
 * assert.equal(Number.multiplyAll([2, 0, 3]), 0)
 *
 * // Works with any iterable
 * assert.equal(Number.multiplyAll(new Set([2, 3, 4])), 24)
 *
 * // Using with generated sequences
 * function* range(start: number, end: number) {
 *   for (let i = start; i <= end; i++) yield i
 * }
 *
 * // Compute factorial: 5! = 5 × 4 × 3 × 2 × 1 = 120
 * assert.equal(Number.multiplyAll(range(1, 5)), 120)
 * ```
 *
 * @param collection - An `iterable` containing the `numbers` to multiply
 *
 * @returns The product of all numbers in the collection, or 1 if the collection
 *   is empty
 */
const multiplyAll = collection => {
  let out = 1;
  for (const n of collection) {
    if (n === 0) {
      return 0;
    }
    out *= n;
  }
  return out;
};
/**
 * Performs division in the set of JavaScript numbers, returning the result
 * wrapped in an `Option` to handle division by zero.
 *
 * @memberof Number
 * @since 2.0.0
 * @category math
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { pipe, Option } from "effect"
 * import * as Number from "effect/Number"
 *
 * // Data-first style (direct application)
 * assert.equal(Number.divide(6, 3), Option.some(2)) // 6 ÷ 3 = 2
 * assert.equal(Number.divide(-8, 4), Option.some(-2)) // (-8) ÷ 4 = -2
 * assert.equal(Number.divide(-10, -5), Option.some(2)) // (-10) ÷ (-5) = 2
 * assert.equal(Number.divide(1, 3), Option.some(0.3333333333333333)) // Note: floating-point approximation
 *
 * // Handling division by zero
 * assert.equal(Number.divide(6, 0), Option.none()) // 6 ÷ 0 is undefined
 *
 * // Data-last style (pipeable)
 * assert.equal(
 *   pipe(
 *     10,
 *     Number.divide(2) // 10 ÷ 2 = 5
 *   ),
 *   Option.some(5)
 * )
 *
 * // Chaining multiple divisions using Option combinators
 * assert.equal(
 *   pipe(
 *     Option.some(24),
 *     Option.flatMap((n) => Number.divide(n, 2)), // 24 ÷ 2 = 12
 *     Option.flatMap(Number.divide(3)), // 12 ÷ 3 = 4
 *     Option.flatMap(Number.divide(2)) // 4 ÷ 2 = 2
 *   ),
 *   Option.some(2)
 * )
 *
 * // Division-by-one property: a ÷ 1 = a
 * assert.equal(Number.divide(42, 1), Option.some(42))
 *
 * // Self-division property: a ÷ a = 1 (for a ≠ 0)
 * assert.equal(Number.divide(42, 42), Option.some(1))
 *
 * // Non-commutative property: a ÷ b ≠ b ÷ a
 * assert.notDeepStrictEqual(
 *   Number.divide(6, 3), // 6 ÷ 3 = 2
 *   Number.divide(3, 6) // 3 ÷ 6 = 0.5
 * )
 * ```
 */
const divide = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (dividend, divisor) => divisor === 0 ? option.none : option.some(dividend / divisor))));
/**
 * Performs division in the set of JavaScript numbers, but misbehaves for
 * division by zero.
 *
 * Unlike {@link module:Number.divide} which returns an Option, this function
 * directly returns a number or `Infinity` or `NaN`.
 *
 * - If the `divisor` is zero, it returns `Infinity`.
 * - If both the `dividend` and the `divisor` are zero, then it returns `NaN`.
 *
 * @memberof Number
 * @since 2.0.0
 * @category math
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { pipe } from "effect"
 * import * as Number from "effect/Number"
 *
 * // Data-first style (direct application)
 * assert.equal(Number.unsafeDivide(6, 3), 2) // 6 ÷ 3 = 2
 * assert.equal(Number.unsafeDivide(-8, 4), -2) // (-8) ÷ 4 = -2
 * assert.equal(Number.unsafeDivide(-10, -5), 2) // (-10) ÷ (-5) = 2
 * assert.equal(Number.unsafeDivide(1, 3), 0.3333333333333333)
 *
 * // Data-last style (pipeable)
 * assert.equal(
 *   pipe(
 *     10,
 *     Number.unsafeDivide(2) // 10 ÷ 2 = 5
 *   ),
 *   5
 * )
 *
 * // Chaining multiple divisions
 * assert.equal(
 *   pipe(
 *     24,
 *     Number.unsafeDivide(2), // 24 ÷ 2 = 12
 *     Number.unsafeDivide(3), // 12 ÷ 3 = 4
 *     Number.unsafeDivide(2) // 4 ÷ 2 = 2
 *   ),
 *   2
 * )
 *
 * assert.equal(Number.unsafeDivide(6, 0), Infinity)
 *
 * assert.equal(Number.unsafeDivide(0, 0), NaN)
 *
 * // Compare with safe division
 * const safeResult = Number.divide(6, 3) // Option.some(2)
 * const unsafeResult = Number.unsafeDivide(6, 3) // 2 directly
 * ```
 *
 * @throws - An {@link module:Number.DivisionByZeroError} if the divisor is zero.
 * @see {@link module:Number.divide} - Safe division returning an Option
 */
const unsafeDivide = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (dividend, divisor) => dividend / divisor)));
/**
 * Returns the result of adding `1` to a given number.
 *
 * @memberof Number
 * @since 2.0.0
 * @category math
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { increment } from "effect/Number"
 *
 * assert.equal(increment(2), 3)
 * ```
 */
const increment = n => sum(n, 1);
/**
 * Decrements a number by `1`.
 *
 * @memberof Number
 * @since 2.0.0
 * @category math
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { decrement } from "effect/Number"
 *
 * assert.equal(decrement(3), 2)
 * ```
 */
const decrement = n => subtract(n, 1);
/**
 * @memberof Number
 * @since 2.0.0
 * @category instances
 */
const Equivalence = _Equivalence_js__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx;
/**
 * @memberof Number
 * @since 2.0.0
 * @category instances
 */
const Order = _Order_js__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx;
/**
 * Returns `true` if the first argument is less than the second, otherwise
 * `false`.
 *
 * @memberof Number
 * @since 2.0.0
 * @category predicates
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { lessThan } from "effect/Number"
 *
 * assert.equal(lessThan(2, 3), true)
 * assert.equal(lessThan(3, 3), false)
 * assert.equal(lessThan(4, 3), false)
 * ```
 */
const lessThan = /*#__PURE__*/(/* unused pure expression or super */ null && (order.lessThan(Order)));
/**
 * Returns a function that checks if a given `number` is less than or equal to
 * the provided one.
 *
 * @memberof Number
 * @since 2.0.0
 * @category predicates
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { lessThanOrEqualTo } from "effect/Number"
 *
 * assert.equal(lessThanOrEqualTo(2, 3), true)
 * assert.equal(lessThanOrEqualTo(3, 3), true)
 * assert.equal(lessThanOrEqualTo(4, 3), false)
 * ```
 */
const lessThanOrEqualTo = /*#__PURE__*/(/* unused pure expression or super */ null && (order.lessThanOrEqualTo(Order)));
/**
 * Returns `true` if the first argument is greater than the second, otherwise
 * `false`.
 *
 * @memberof Number
 * @since 2.0.0
 * @category predicates
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { greaterThan } from "effect/Number"
 *
 * assert.equal(greaterThan(2, 3), false)
 * assert.equal(greaterThan(3, 3), false)
 * assert.equal(greaterThan(4, 3), true)
 * ```
 */
const greaterThan = /*#__PURE__*/(/* unused pure expression or super */ null && (order.greaterThan(Order)));
/**
 * Returns a function that checks if a given `number` is greater than or equal
 * to the provided one.
 *
 * @memberof Number
 * @since 2.0.0
 * @category predicates
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { greaterThanOrEqualTo } from "effect/Number"
 *
 * assert.equal(greaterThanOrEqualTo(2, 3), false)
 * assert.equal(greaterThanOrEqualTo(3, 3), true)
 * assert.equal(greaterThanOrEqualTo(4, 3), true)
 * ```
 */
const greaterThanOrEqualTo = /*#__PURE__*/(/* unused pure expression or super */ null && (order.greaterThanOrEqualTo(Order)));
/**
 * Checks if a `number` is between a `minimum` and `maximum` value (inclusive).
 *
 * @memberof Number
 * @since 2.0.0
 * @category predicates
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { Number } from "effect"
 *
 * const between = Number.between({ minimum: 0, maximum: 5 })
 *
 * assert.equal(between(3), true)
 * assert.equal(between(-1), false)
 * assert.equal(between(6), false)
 * ```
 */
const between = /*#__PURE__*/(/* unused pure expression or super */ null && (order.between(Order)));
/**
 * Restricts the given `number` to be within the range specified by the
 * `minimum` and `maximum` values.
 *
 * - If the `number` is less than the `minimum` value, the function returns the
 *   `minimum` value.
 * - If the `number` is greater than the `maximum` value, the function returns the
 *   `maximum` value.
 * - Otherwise, it returns the original `number`.
 *
 * @memberof Number
 * @since 2.0.0
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { Number } from "effect"
 *
 * const clamp = Number.clamp({ minimum: 1, maximum: 5 })
 *
 * assert.equal(clamp(3), 3)
 * assert.equal(clamp(0), 1)
 * assert.equal(clamp(6), 5)
 * ```
 */
const clamp = /*#__PURE__*/(/* unused pure expression or super */ null && (order.clamp(Order)));
/**
 * Returns the minimum between two `number`s.
 *
 * @memberof Number
 * @since 2.0.0
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { min } from "effect/Number"
 *
 * assert.equal(min(2, 3), 2)
 * ```
 */
const min = /*#__PURE__*/(/* unused pure expression or super */ null && (order.min(Order)));
/**
 * Returns the maximum between two `number`s.
 *
 * @memberof Number
 * @since 2.0.0
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { max } from "effect/Number"
 *
 * assert.equal(max(2, 3), 3)
 * ```
 */
const max = /*#__PURE__*/(/* unused pure expression or super */ null && (order.max(Order)));
/**
 * Determines the sign of a given `number`.
 *
 * @memberof Number
 * @since 2.0.0
 * @category math
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { sign } from "effect/Number"
 *
 * assert.equal(sign(-5), -1)
 * assert.equal(sign(0), 0)
 * assert.equal(sign(5), 1)
 * ```
 */
const sign = n => Order(n, 0);
/**
 * Returns the remainder left over when one operand is divided by a second
 * operand.
 *
 * It always takes the sign of the dividend.
 *
 * @memberof Number
 * @since 2.0.0
 * @category math
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { remainder } from "effect/Number"
 *
 * assert.equal(remainder(2, 2), 0)
 * assert.equal(remainder(3, 2), 1)
 * assert.equal(remainder(-4, 2), -0)
 * ```
 */
const remainder = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (dividend, divisor) => {
  // https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
  const selfDecCount = (dividend.toString().split(".")[1] || "").length;
  const divisorDecCount = (divisor.toString().split(".")[1] || "").length;
  const decCount = selfDecCount > divisorDecCount ? selfDecCount : divisorDecCount;
  const selfInt = parseInt(dividend.toFixed(decCount).replace(".", ""));
  const divisorInt = parseInt(divisor.toFixed(decCount).replace(".", ""));
  return selfInt % divisorInt / Math.pow(10, decCount);
})));
/**
 * Returns the next power of 2 greater than or equal to the given number.
 *
 * - For `positive` inputs, returns the smallest power of 2 that is >= the input
 * - For `zero`, returns 2
 * - For `negative` inputs, returns NaN (as logarithms of negative numbers are
 *   undefined)
 * - For `NaN` input, returns NaN
 * - For `Infinity`, returns Infinity
 *
 * @memberof Number
 * @since 2.0.0
 * @category math
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { nextPow2 } from "effect/Number"
 *
 * assert.equal(nextPow2(5), 8)
 * assert.equal(nextPow2(17), 32)
 * assert.equal(nextPow2(0), 2)
 * assert.equal(Number.isNaN(nextPow2(-1)), true) // Negative inputs result in NaN
 * ```
 */
const nextPow2 = n => {
  const nextPow = Math.ceil(Math.log(n) / Math.log(2));
  return Math.max(Math.pow(2, nextPow), 2);
};
/**
 * Tries to parse a `number` from a `string` using the `Number()` function. The
 * following special string values are supported: "NaN", "Infinity",
 * "-Infinity".
 *
 * @memberof Number
 * @since 2.0.0
 * @category constructors
 */
const parse = s => {
  if (s === "NaN") {
    return _internal_option_js__WEBPACK_IMPORTED_MODULE_3__/* .some */ .G(NaN);
  }
  if (s === "Infinity") {
    return _internal_option_js__WEBPACK_IMPORTED_MODULE_3__/* .some */ .G(Infinity);
  }
  if (s === "-Infinity") {
    return _internal_option_js__WEBPACK_IMPORTED_MODULE_3__/* .some */ .G(-Infinity);
  }
  if (s.trim() === "") {
    return _internal_option_js__WEBPACK_IMPORTED_MODULE_3__/* .none */ .YP;
  }
  const n = Number(s);
  return Number.isNaN(n) ? _internal_option_js__WEBPACK_IMPORTED_MODULE_3__/* .none */ .YP : _internal_option_js__WEBPACK_IMPORTED_MODULE_3__/* .some */ .G(n);
};
/**
 * Returns the number rounded with the given precision.
 *
 * @memberof Number
 * @since 3.8.0
 * @category math
 * @example
 *
 * ```ts
 * import * as assert from "node:assert/strict"
 * import { round } from "effect/Number"
 *
 * assert.equal(round(1.1234, 2), 1.12)
 * assert.equal(round(1.567, 2), 1.57)
 * ```
 */
const round = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, precision) => {
  const factor = Math.pow(10, precision);
  return Math.round(self * factor) / factor;
})));
//# sourceMappingURL=Number.js.map

/***/ }),

/***/ 16749:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cc": function() { return /* binding */ orElseSome; },
/* harmony export */   "DZ": function() { return /* binding */ filterMap; },
/* harmony export */   "EQ": function() { return /* binding */ match; },
/* harmony export */   "G": function() { return /* binding */ some; },
/* harmony export */   "G$": function() { return /* binding */ getOrThrowWith; },
/* harmony export */   "Gg": function() { return /* binding */ exists; },
/* harmony export */   "Kn": function() { return /* binding */ isOption; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "VS": function() { return /* binding */ flatMap; },
/* harmony export */   "Wi": function() { return /* binding */ isNone; },
/* harmony export */   "YP": function() { return /* binding */ none; },
/* harmony export */   "bT": function() { return /* binding */ mergeWith; },
/* harmony export */   "c5": function() { return /* binding */ getEquivalence; },
/* harmony export */   "eZ": function() { return /* binding */ liftThrowable; },
/* harmony export */   "fS": function() { return /* binding */ getOrElse; },
/* harmony export */   "gf": function() { return /* binding */ getOrThrow; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "ij": function() { return /* binding */ fromNullable; },
/* harmony export */   "jD": function() { return /* binding */ getOrUndefined; },
/* harmony export */   "ny": function() { return /* binding */ flatMapNullable; },
/* harmony export */   "pC": function() { return /* binding */ isSome; },
/* harmony export */   "qo": function() { return /* binding */ toArray; },
/* harmony export */   "r3": function() { return /* binding */ contains; },
/* harmony export */   "vx": function() { return /* binding */ orElse; }
/* harmony export */ });
/* unused harmony exports TypeId, toRefinement, fromIterable, getRight, getLeft, orElseEither, firstSomeOf, liftNullable, getOrNull, as, asVoid, void, andThen, flatten, zipRight, zipLeft, composeK, tap, product, productMany, all, zipWith, ap, reduceCompact, partitionMap, getOrder, lift2, liftPredicate, containsWith, bindTo, let, bind, Do, gen */
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67492);
/* harmony import */ var _Equivalence_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27786);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17316);
/* harmony import */ var _internal_either_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75974);
/* harmony import */ var _internal_option_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70602);








/**
 * @category Symbols
 * @since 2.0.0
 */
const TypeId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/Option")));
/**
 * Represents the absence of a value by creating an empty `Option`.
 *
 * `Option.none` returns an `Option<never>`, which is a subtype of `Option<A>`.
 * This means you can use it in place of any `Option<A>` regardless of the type
 * `A`.
 *
 * **Example** (Creating an Option with No Value)
 *
 * ```ts
 * import { Option } from "effect"
 *
 * // An Option holding no value
 * //
 * //      ┌─── Option<never>
 * //      ▼
 * const noValue = Option.none()
 *
 * console.log(noValue)
 * // Output: { _id: 'Option', _tag: 'None' }
 * ```
 *
 * @see {@link some} for the opposite operation.
 *
 * @category Constructors
 * @since 2.0.0
 */
const none = () => _internal_option_js__WEBPACK_IMPORTED_MODULE_0__/* .none */ .YP;
/**
 * Wraps the given value into an `Option` to represent its presence.
 *
 * **Example** (Creating an Option with a Value)
 *
 * ```ts
 * import { Option } from "effect"
 *
 * // An Option holding the number 1
 * //
 * //      ┌─── Option<number>
 * //      ▼
 * const value = Option.some(1)
 *
 * console.log(value)
 * // Output: { _id: 'Option', _tag: 'Some', value: 1 }
 * ```
 *
 * @see {@link none} for the opposite operation.
 *
 * @category Constructors
 * @since 2.0.0
 */
const some = _internal_option_js__WEBPACK_IMPORTED_MODULE_0__/* .some */ .G;
/**
 * Determines whether the given value is an `Option`.
 *
 * **Details**
 *
 * This function checks if a value is an instance of `Option`. It returns `true`
 * if the value is either `Option.some` or `Option.none`, and `false` otherwise.
 * This is particularly useful when working with unknown values or when you need
 * to ensure type safety in your code.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * console.log(Option.isOption(Option.some(1)))
 * // Output: true
 *
 * console.log(Option.isOption(Option.none()))
 * // Output: true
 *
 * console.log(Option.isOption({}))
 * // Output: false
 * ```
 *
 * @category Guards
 * @since 2.0.0
 */
const isOption = _internal_option_js__WEBPACK_IMPORTED_MODULE_0__/* .isOption */ .Kn;
/**
 * Checks whether an `Option` represents the absence of a value (`None`).
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * console.log(Option.isNone(Option.some(1)))
 * // Output: false
 *
 * console.log(Option.isNone(Option.none()))
 * // Output: true
 * ```
 *
 * @see {@link isSome} for the opposite check.
 *
 * @category Guards
 * @since 2.0.0
 */
const isNone = _internal_option_js__WEBPACK_IMPORTED_MODULE_0__/* .isNone */ .Wi;
/**
 * Checks whether an `Option` contains a value (`Some`).
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * console.log(Option.isSome(Option.some(1)))
 * // Output: true
 *
 * console.log(Option.isSome(Option.none()))
 * // Output: false
 * ```
 *
 * @see {@link isNone} for the opposite check.
 *
 * @category Guards
 * @since 2.0.0
 */
const isSome = _internal_option_js__WEBPACK_IMPORTED_MODULE_0__/* .isSome */ .pC;
/**
 * Performs pattern matching on an `Option` to handle both `Some` and `None`
 * cases.
 *
 * **Details**
 *
 * This function allows you to match against an `Option` and handle both
 * scenarios: when the `Option` is `None` (i.e., contains no value), and when
 * the `Option` is `Some` (i.e., contains a value). It executes one of the
 * provided functions based on the case:
 *
 * - If the `Option` is `None`, the `onNone` function is executed and its result
 *   is returned.
 * - If the `Option` is `Some`, the `onSome` function is executed with the
 *   contained value, and its result is returned.
 *
 * This function provides a concise and functional way to handle optional values
 * without resorting to `if` or manual checks, making your code more declarative
 * and readable.
 *
 * **Example** (Pattern Matching with Option)
 *
 * ```ts
 * import { Option } from "effect"
 *
 * const foo = Option.some(1)
 *
 * const message = Option.match(foo, {
 *   onNone: () => "Option is empty",
 *   onSome: (value) => `Option has a value: ${value}`
 * })
 *
 * console.log(message)
 * // Output: "Option has a value: 1"
 * ```
 *
 * @category Pattern matching
 * @since 2.0.0
 */
const match = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, {
  onNone,
  onSome
}) => isNone(self) ? onNone() : onSome(self.value));
/**
 * Converts an `Option`-returning function into a type guard.
 *
 * **Details**
 *
 * This function transforms a function that returns an `Option` into a type
 * guard, ensuring type safety when validating or narrowing types. The returned
 * type guard function checks whether the input satisfies the condition defined
 * in the original `Option`-returning function.
 *
 * If the original function returns `Option.some`, the type guard evaluates to
 * `true`, confirming the input is of the desired type. If the function returns
 * `Option.none`, the type guard evaluates to `false`.
 *
 * This utility is especially useful for validating types in union types,
 * filtering arrays, or ensuring safe handling of specific subtypes.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * type MyData = string | number
 *
 * const parseString = (data: MyData): Option.Option<string> =>
 *   typeof data === "string" ? Option.some(data) : Option.none()
 *
 * //      ┌─── (a: MyData) => a is string
 * //      ▼
 * const isString = Option.toRefinement(parseString)
 *
 * console.log(isString("a"))
 * // Output: true
 *
 * console.log(isString(1))
 * // Output: false
 * ```
 *
 * @category Conversions
 * @since 2.0.0
 */
const toRefinement = f => a => isSome(f(a));
/**
 * Converts an `Iterable` into an `Option`, wrapping the first element if it
 * exists.
 *
 * **Details**
 *
 * This function takes an `Iterable` (e.g., an array, a generator, or any object
 * implementing the `Iterable` interface) and returns an `Option` based on its
 * content:
 *
 * - If the `Iterable` contains at least one element, the first element is
 *   wrapped in a `Some` and returned.
 * - If the `Iterable` is empty, `None` is returned, representing the absence of
 *   a value.
 *
 * This utility is useful for safely handling collections that might be empty,
 * ensuring you explicitly handle both cases where a value exists or doesn't.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * console.log(Option.fromIterable([1, 2, 3]))
 * // Output: { _id: 'Option', _tag: 'Some', value: 1 }
 *
 * console.log(Option.fromIterable([]))
 * // Output: { _id: 'Option', _tag: 'None' }
 * ```
 *
 * @category Constructors
 * @since 2.0.0
 */
const fromIterable = collection => {
  for (const a of collection) {
    return some(a);
  }
  return none();
};
/**
 * Converts an `Either` into an `Option` by discarding the error and extracting
 * the right value.
 *
 * **Details**
 *
 * This function takes an `Either` and returns an `Option` based on its value:
 *
 * - If the `Either` is a `Right`, its value is wrapped in a `Some` and
 *   returned.
 * - If the `Either` is a `Left`, the error is discarded, and `None` is
 *   returned.
 *
 * This is particularly useful when you only care about the success case
 * (`Right`) of an `Either` and want to handle the result using `Option`. By
 * using this function, you can convert `Either` into a simpler structure for
 * cases where error handling is not required.
 *
 * @example
 * ```ts
 * import { Either, Option } from "effect"
 *
 * console.log(Option.getRight(Either.right("ok")))
 * // Output: { _id: 'Option', _tag: 'Some', value: 'ok' }
 *
 * console.log(Option.getRight(Either.left("err")))
 * // Output: { _id: 'Option', _tag: 'None' }
 * ```
 *
 * @see {@link getLeft} for the opposite operation.
 *
 * @category Conversions
 * @since 2.0.0
 */
const getRight = _internal_either_js__WEBPACK_IMPORTED_MODULE_2__/* .getRight */ .EK;
/**
 * Converts an `Either` into an `Option` by discarding the right value and
 * extracting the left value.
 *
 * **Details**
 *
 * This function transforms an `Either` into an `Option` as follows:
 *
 * - If the `Either` is a `Left`, its value is wrapped in a `Some` and returned.
 * - If the `Either` is a `Right`, the value is discarded, and `None` is
 *   returned.
 *
 * This utility is useful when you only care about the error case (`Left`) of an
 * `Either` and want to handle it as an `Option`. By discarding the right value,
 * it simplifies error-focused workflows.
 *
 * @example
 * ```ts
 * import { Either, Option } from "effect"
 *
 * console.log(Option.getLeft(Either.right("ok")))
 * // Output: { _id: 'Option', _tag: 'None' }
 *
 * console.log(Option.getLeft(Either.left("err")))
 * // Output: { _id: 'Option', _tag: 'Some', value: 'err' }
 * ```
 *
 * @see {@link getRight} for the opposite operation.
 *
 * @category Conversions
 * @since 2.0.0
 */
const getLeft = _internal_either_js__WEBPACK_IMPORTED_MODULE_2__/* .getLeft */ .IS;
/**
 * Returns the value contained in the `Option` if it is `Some`, otherwise
 * evaluates and returns the result of `onNone`.
 *
 * **Details**
 *
 * This function allows you to provide a fallback value or computation for when
 * an `Option` is `None`. If the `Option` contains a value (`Some`), that value
 * is returned. If it is empty (`None`), the `onNone` function is executed, and
 * its result is returned instead.
 *
 * This utility is helpful for safely handling `Option` values by ensuring you
 * always receive a meaningful result, whether or not the `Option` contains a
 * value. It is particularly useful for providing default values or alternative
 * logic when working with optional values.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * console.log(Option.some(1).pipe(Option.getOrElse(() => 0)))
 * // Output: 1
 *
 * console.log(Option.none().pipe(Option.getOrElse(() => 0)))
 * // Output: 0
 * ```
 *
 * @see {@link getOrNull} for a version that returns `null` instead of executing a function.
 * @see {@link getOrUndefined} for a version that returns `undefined` instead of executing a function.
 *
 * @category Getters
 * @since 2.0.0
 */
const getOrElse = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, onNone) => isNone(self) ? onNone() : self.value);
/**
 * Returns the provided `Option` `that` if the current `Option` (`self`) is
 * `None`; otherwise, it returns `self`.
 *
 * **Details**
 *
 * This function provides a fallback mechanism for `Option` values. If the
 * current `Option` is `None` (i.e., it contains no value), the `that` function
 * is evaluated, and its resulting `Option` is returned. If the current `Option`
 * is `Some` (i.e., it contains a value), the original `Option` is returned
 * unchanged.
 *
 * This is particularly useful for chaining fallback values or computations,
 * allowing you to provide alternative `Option` values when the first one is
 * empty.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * console.log(Option.none().pipe(Option.orElse(() => Option.none())))
 * // Output: { _id: 'Option', _tag: 'None' }
 *
 * console.log(Option.some("a").pipe(Option.orElse(() => Option.none())))
 * // Output: { _id: 'Option', _tag: 'Some', value: 'a' }
 *
 * console.log(Option.none().pipe(Option.orElse(() => Option.some("b"))))
 * // Output: { _id: 'Option', _tag: 'Some', value: 'b' }
 *
 * console.log(Option.some("a").pipe(Option.orElse(() => Option.some("b"))))
 * // Output: { _id: 'Option', _tag: 'Some', value: 'a' }
 * ```
 *
 * @category Error handling
 * @since 2.0.0
 */
const orElse = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, that) => isNone(self) ? that() : self);
/**
 * Returns the provided default value wrapped in `Some` if the current `Option`
 * (`self`) is `None`; otherwise, returns `self`.
 *
 * **Details**
 *
 * This function provides a way to supply a default value for cases where an
 * `Option` is `None`. If the current `Option` is empty (`None`), the `onNone`
 * function is executed to compute the default value, which is then wrapped in a
 * `Some`. If the current `Option` contains a value (`Some`), it is returned as
 * is.
 *
 * This is particularly useful for handling optional values where a fallback
 * default needs to be provided explicitly in case of absence.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * console.log(Option.none().pipe(Option.orElseSome(() => "b")))
 * // Output: { _id: 'Option', _tag: 'Some', value: 'b' }
 *
 * console.log(Option.some("a").pipe(Option.orElseSome(() => "b")))
 * // Output: { _id: 'Option', _tag: 'Some', value: 'a' }
 * ```
 *
 * @category Error handling
 * @since 2.0.0
 */
const orElseSome = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, onNone) => isNone(self) ? some(onNone()) : self);
/**
 * Similar to {@link orElse}, but returns an `Either` wrapped in an `Option` to
 * indicate the source of the value.
 *
 * **Details**
 *
 * This function allows you to provide a fallback `Option` in case the current
 * `Option` (`self`) is `None`. However, unlike `orElse`, it returns the value
 * wrapped in an `Either` object, providing additional information about where
 * the value came from:
 *
 * - If the value is from the fallback `Option` (`that`), it is wrapped in an
 *   `Either.right`.
 * - If the value is from the original `Option` (`self`), it is wrapped in an
 *   `Either.left`.
 *
 * This is especially useful when you need to differentiate between values
 * originating from the primary `Option` and those coming from the fallback,
 * while still maintaining the `Option`-style handling.
 *
 * @category Error handling
 * @since 2.0.0
 */
const orElseEither = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => isNone(self) ? map(that(), either.right) : map(self, either.left))));
/**
 * Returns the first `Some` value found in an `Iterable` collection of
 * `Option`s, or `None` if no `Some` is found.
 *
 * **Details**
 *
 * This function iterates over a collection of `Option` values and returns the
 * first `Some` it encounters. If the collection contains only `None` values,
 * the result will also be `None`. This utility is useful for efficiently
 * finding the first valid value in a sequence of potentially empty or invalid
 * options.
 *
 * The iteration stops as soon as a `Some` is found, making this function
 * efficient for large collections.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * console.log(Option.firstSomeOf([
 *   Option.none(),
 *   Option.some(1),
 *   Option.some(2)
 * ]))
 * // Output: { _id: 'Option', _tag: 'Some', value: 1 }
 * ```
 *
 * @category Error handling
 * @since 2.0.0
 */
const firstSomeOf = collection => {
  let out = none();
  for (out of collection) {
    if (isSome(out)) {
      return out;
    }
  }
  return out;
};
/**
 * Converts a nullable value into an `Option`. Returns `None` if the value is
 * `null` or `undefined`, otherwise wraps the value in a `Some`.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * console.log(Option.fromNullable(undefined))
 * // Output: { _id: 'Option', _tag: 'None' }
 *
 * console.log(Option.fromNullable(null))
 * // Output: { _id: 'Option', _tag: 'None' }
 *
 * console.log(Option.fromNullable(1))
 * // Output: { _id: 'Option', _tag: 'Some', value: 1 }
 * ```
 *
 * @category Conversions
 * @since 2.0.0
 */
const fromNullable = nullableValue => nullableValue == null ? none() : some(nullableValue);
/**
 * Lifts a function that returns `null` or `undefined` into the `Option`
 * context.
 *
 * **Details**
 *
 * This function takes a function `f` that might return `null` or `undefined`
 * and transforms it into a function that returns an `Option`. The resulting
 * function will return:
 * - `Some` if the original function produces a non-null, non-undefined value.
 * - `None` if the original function produces `null` or `undefined`.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * const parse = (s: string): number | undefined => {
 *   const n = parseFloat(s)
 *   return isNaN(n) ? undefined : n
 * }
 *
 * const parseOption = Option.liftNullable(parse)
 *
 * console.log(parseOption("1"))
 * // Output: { _id: 'Option', _tag: 'Some', value: 1 }
 *
 * console.log(parseOption("not a number"))
 * // Output: { _id: 'Option', _tag: 'None' }
 * ```
 *
 * @category Conversions
 * @since 2.0.0
 */
const liftNullable = f => (...a) => fromNullable(f(...a));
/**
 * Returns the value contained in the `Option` if it is `Some`; otherwise,
 * returns `null`.
 *
 * **Details**
 *
 * This function provides a way to extract the value of an `Option` while
 * falling back to `null` if the `Option` is `None`.
 *
 * It is particularly useful in scenarios where `null` is an acceptable
 * placeholder for the absence of a value, such as when interacting with APIs or
 * systems that use `null` as a default for missing values.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * console.log(Option.getOrNull(Option.some(1)))
 * // Output: 1
 *
 * console.log(Option.getOrNull(Option.none()))
 * // Output: null
 * ```
 *
 * @category Getters
 * @since 2.0.0
 */
const getOrNull = /*#__PURE__*/(/* unused pure expression or super */ null && (getOrElse(constNull)));
/**
 * Returns the value contained in the `Option` if it is `Some`; otherwise,
 * returns `undefined`.
 *
 * **Details**
 *
 * This function provides a way to extract the value of an `Option` while
 * falling back to `undefined` if the `Option` is `None`.
 *
 * It is particularly useful in scenarios where `undefined` is an acceptable
 * placeholder for the absence of a value, such as when interacting with APIs or
 * systems that use `undefined` as a default for missing values.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * console.log(Option.getOrUndefined(Option.some(1)))
 * // Output: 1
 *
 * console.log(Option.getOrUndefined(Option.none()))
 * // Output: undefined
 * ```
 *
 * @category Getters
 * @since 2.0.0
 */
const getOrUndefined = /*#__PURE__*/getOrElse(_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .constUndefined */ .r5);
/**
 * Lifts a function that throws exceptions into a function that returns an
 * `Option`.
 *
 * **Details**
 *
 * This utility function takes a function `f` that might throw an exception and
 * transforms it into a safer function that returns an `Option`. If the original
 * function executes successfully, the result is wrapped in a `Some`. If an
 * exception is thrown, the result is `None`, allowing the developer to handle
 * errors in a functional, type-safe way.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * const parse = Option.liftThrowable(JSON.parse)
 *
 * console.log(parse("1"))
 * // Output: { _id: 'Option', _tag: 'Some', value: 1 }
 *
 * console.log(parse(""))
 * // Output: { _id: 'Option', _tag: 'None' }
 * ```
 *
 * @category Conversions
 * @since 2.0.0
 */
const liftThrowable = f => (...a) => {
  try {
    return some(f(...a));
  } catch (e) {
    return none();
  }
};
/**
 * Extracts the value of an `Option` or throws an error if the `Option` is
 * `None`, using a custom error factory.
 *
 * **Details**
 *
 * This function allows you to extract the value of an `Option` when it is
 * `Some`. If the `Option` is `None`, it throws an error generated by the
 * provided `onNone` function. This utility is particularly useful when you need
 * a fail-fast behavior for empty `Option` values and want to provide a custom
 * error message or object.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Option } from "effect"
 *
 * assert.deepStrictEqual(
 *   Option.getOrThrowWith(Option.some(1), () => new Error('Unexpected None')),
 *   1
 * )
 * assert.throws(() => Option.getOrThrowWith(Option.none(), () => new Error('Unexpected None')))
 * ```
 *
 * @see {@link getOrThrow} for a version that throws a default error.
 *
 * @category Conversions
 * @since 2.0.0
 */
const getOrThrowWith = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, onNone) => {
  if (isSome(self)) {
    return self.value;
  }
  throw onNone();
});
/**
 * Extracts the value of an `Option` or throws a default error if the `Option`
 * is `None`.
 *
 * **Details**
 *
 * This function extracts the value from an `Option` if it is `Some`. If the
 * `Option` is `None`, it throws a default error. It is useful for fail-fast
 * scenarios where the absence of a value is treated as an exceptional case and
 * a default error is sufficient.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Option } from "effect"
 *
 * assert.deepStrictEqual(Option.getOrThrow(Option.some(1)), 1)
 * assert.throws(() => Option.getOrThrow(Option.none()))
 * ```
 *
 * @see {@link getOrThrowWith} for a version that allows you to provide a custom error.
 *
 * @category Conversions
 * @since 2.0.0
 */
const getOrThrow = /*#__PURE__*/getOrThrowWith(() => new Error("getOrThrow called on a None"));
/**
 * Transforms the value inside a `Some` to a new value using the provided
 * function, while leaving `None` unchanged.
 *
 * **Details**
 *
 * This function applies a mapping function `f` to the value inside an `Option`
 * if it is a `Some`. If the `Option` is `None`, it remains unchanged. The
 * result is a new `Option` with the transformed value (if it was a `Some`) or
 * still `None`.
 *
 * This utility is particularly useful for chaining transformations in a
 * functional way without needing to manually handle `None` cases.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * // Mapping over a `Some`
 * const someValue = Option.some(2)
 *
 * console.log(Option.map(someValue, (n) => n * 2))
 * // Output: { _id: 'Option', _tag: 'Some', value: 4 }
 *
 * // Mapping over a `None`
 * const noneValue = Option.none<number>()
 *
 * console.log(Option.map(noneValue, (n) => n * 2))
 * // Output: { _id: 'Option', _tag: 'None' }
 * ```
 *
 * @category Mapping
 * @since 2.0.0
 */
const map = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, f) => isNone(self) ? none() : some(f(self.value)));
/**
 * Replaces the value inside a `Some` with the specified constant value, leaving
 * `None` unchanged.
 *
 * **Details**
 *
 * This function transforms an `Option` by replacing the value inside a `Some`
 * with the given constant value `b`. If the `Option` is `None`, it remains
 * unchanged.
 *
 * This is useful when you want to preserve the presence of a value (`Some`) but
 * replace its content with a fixed value.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * // Replacing the value of a `Some`
 * const someValue = Option.some(42)
 *
 * console.log(Option.as(someValue, "new value"))
 * // Output: { _id: 'Option', _tag: 'Some', value: 'new value' }
 *
 * // Replacing a `None` (no effect)
 * const noneValue = Option.none<number>()
 *
 * console.log(Option.as(noneValue, "new value"))
 * // Output: { _id: 'Option', _tag: 'None' }
 * ```
 *
 * @category Mapping
 * @since 2.0.0
 */
const as = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, b) => map(self, () => b))));
/**
 * Replaces the value inside a `Some` with the constant value `void`, leaving
 * `None` unchanged.
 *
 * **Details**
 *
 * This function transforms an `Option` by replacing the value inside a `Some`
 * with `void`. If the `Option` is `None`, it remains unchanged.
 *
 * This is particularly useful in scenarios where the presence or absence of a
 * value is significant, but the actual content of the value is irrelevant.
 *
 * @category Mapping
 * @since 2.0.0
 */
const asVoid = /*#__PURE__*/(/* unused pure expression or super */ null && (as(undefined)));
const void_ = /*#__PURE__*/(/* unused pure expression or super */ null && (some(undefined)));

/**
 * Applies a function to the value of a `Some` and flattens the resulting
 * `Option`. If the input is `None`, it remains `None`.
 *
 * **Details**
 *
 * This function allows you to chain computations that return `Option` values.
 * If the input `Option` is `Some`, the provided function `f` is applied to the
 * contained value, and the resulting `Option` is returned. If the input is
 * `None`, the function is not applied, and the result remains `None`.
 *
 * This utility is particularly useful for sequencing operations that may fail
 * or produce optional results, enabling clean and concise workflows for
 * handling such cases.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * interface Address {
 *   readonly city: string
 *   readonly street: Option.Option<string>
 * }
 *
 * interface User {
 *   readonly id: number
 *   readonly username: string
 *   readonly email: Option.Option<string>
 *   readonly address: Option.Option<Address>
 * }
 *
 * const user: User = {
 *   id: 1,
 *   username: "john_doe",
 *   email: Option.some("john.doe@example.com"),
 *   address: Option.some({
 *     city: "New York",
 *     street: Option.some("123 Main St")
 *   })
 * }
 *
 * // Use flatMap to extract the street value
 * const street = user.address.pipe(
 *   Option.flatMap((address) => address.street)
 * )
 *
 * console.log(street)
 * // Output: { _id: 'Option', _tag: 'Some', value: '123 Main St' }
 * ```
 *
 * @category Sequencing
 * @since 2.0.0
 */
const flatMap = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, f) => isNone(self) ? none() : f(self.value));
/**
 * Chains two `Option`s together. The second `Option` can either be a static
 * value or depend on the result of the first `Option`.
 *
 * **Details**
 *
 * This function enables sequencing of two `Option` computations. If the first
 * `Option` is `Some`, the second `Option` is evaluated. The second `Option` can
 * either:
 *
 * - Be a static `Option` value.
 * - Be a function that produces an `Option`, optionally based on the value of
 *   the first `Option`.
 *
 * If the first `Option` is `None`, the function skips the evaluation of the
 * second `Option` and directly returns `None`.
 *
 * @category Sequencing
 * @since 2.0.0
 */
const andThen = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => flatMap(self, a => {
  const b = isFunction(f) ? f(a) : f;
  return isOption(b) ? b : some(b);
}))));
/**
 * Combines `flatMap` and `fromNullable`, transforming the value inside a `Some`
 * using a function that may return `null` or `undefined`.
 *
 * **Details**
 *
 * This function applies a transformation function `f` to the value inside a
 * `Some`. The function `f` may return a value, `null`, or `undefined`. If `f`
 * returns a value, it is wrapped in a `Some`. If `f` returns `null` or
 * `undefined`, the result is `None`. If the input `Option` is `None`, the
 * function is not applied, and `None` is returned.
 *
 * This utility is particularly useful when working with deeply nested optional
 * values or chaining computations that may result in `null` or `undefined` at
 * some point.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * interface Employee {
 *   company?: {
 *     address?: {
 *       street?: {
 *         name?: string
 *       }
 *     }
 *   }
 * }
 *
 * const employee1: Employee = { company: { address: { street: { name: "high street" } } } }
 *
 * // Extracting a deeply nested property
 * console.log(
 *   Option.some(employee1)
 *     .pipe(Option.flatMapNullable((employee) => employee.company?.address?.street?.name))
 * )
 * // Output: { _id: 'Option', _tag: 'Some', value: 'high street' }
 *
 * const employee2: Employee = { company: { address: { street: {} } } }
 *
 * // Property does not exist
 * console.log(
 *   Option.some(employee2)
 *     .pipe(Option.flatMapNullable((employee) => employee.company?.address?.street?.name))
 * )
 * // Output: { _id: 'Option', _tag: 'None' }
 * ```
 *
 * @category Sequencing
 * @since 2.0.0
 */
const flatMapNullable = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, f) => isNone(self) ? none() : fromNullable(f(self.value)));
/**
 * Flattens an `Option` of `Option` into a single `Option`.
 *
 * **Details**
 *
 * This function takes an `Option` that wraps another `Option` and flattens it
 * into a single `Option`. If the outer `Option` is `Some`, the function
 * extracts the inner `Option`. If the outer `Option` is `None`, the result
 * remains `None`.
 *
 * This is useful for simplifying nested `Option` structures that may arise
 * during functional operations.
 *
 * @category Sequencing
 * @since 2.0.0
 */
const flatten = /*#__PURE__*/(/* unused pure expression or super */ null && (flatMap(identity)));
/**
 * Combines two `Option`s, keeping the value from the second `Option` if both
 * are `Some`.
 *
 * **Details**
 *
 * This function takes two `Option`s and returns the second one if the first is
 * `Some`. If the first `Option` is `None`, the result will also be `None`,
 * regardless of the second `Option`. It effectively "zips" the two `Option`s
 * while discarding the value from the first `Option`.
 *
 * This is particularly useful when sequencing computations where the result of
 * the first computation is not needed, and you only care about the result of
 * the second computation.
 *
 * @category Zipping
 * @since 2.0.0
 */
const zipRight = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => flatMap(self, () => that))));
/**
 * Combines two `Option`s, keeping the value from the first `Option` if both are
 * `Some`.
 *
 * **Details**
 *
 * This function takes two `Option`s and returns the first one if it is `Some`.
 * If either the first `Option` or the second `Option` is `None`, the result
 * will be `None`. This operation "zips" the two `Option`s while discarding the
 * value from the second `Option`.
 *
 * This is useful when sequencing computations where the second `Option`
 * represents a dependency or condition that must hold, but its value is
 * irrelevant.
 *
 * @category Zipping
 * @since 2.0.0
 */
const zipLeft = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => tap(self, () => that))));
/**
 * Composes two functions that return `Option` values, creating a new function
 * that chains them together.
 *
 * **Details**
 *
 * This function allows you to compose two computations, each represented by a
 * function that returns an `Option`. The result of the first function is passed
 * to the second function if it is `Some`. If the first function returns `None`,
 * the composed function short-circuits and returns `None` without invoking the
 * second function.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * const parse = (s: string): Option.Option<number> => isNaN(Number(s)) ? Option.none() : Option.some(Number(s))
 *
 * const double = (n: number): Option.Option<number> => n > 0 ? Option.some(n * 2) : Option.none()
 *
 * const parseAndDouble = Option.composeK(parse, double)
 *
 * console.log(parseAndDouble("42"))
 * // Output: { _id: 'Option', _tag: 'Some', value: 84 }
 *
 * console.log(parseAndDouble("not a number"))
 * // Output: { _id: 'Option', _tag: 'None' }
 * ```
 *
 * @category Sequencing
 * @since 2.0.0
 */
const composeK = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (afb, bfc) => a => flatMap(afb(a), bfc))));
/**
 * Applies the provided function `f` to the value of the `Option` if it is
 * `Some` and returns the original `Option`, unless `f` returns `None`, in which
 * case it returns `None`.
 *
 * **Details**
 *
 * This function allows you to perform additional computations on the value of
 * an `Option` without modifying its original value. If the `Option` is `Some`,
 * the provided function `f` is executed with the value, and its result
 * determines whether the original `Option` is returned (`Some`) or the result
 * is `None` if `f` returns `None`. If the input `Option` is `None`, the
 * function is not executed, and `None` is returned.
 *
 * This is particularly useful for applying side conditions or performing
 * validation checks while retaining the original `Option`'s value.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * const getInteger = (n: number) => Number.isInteger(n) ? Option.some(n) : Option.none()
 *
 * console.log(Option.tap(Option.none(), getInteger))
 * // Output: { _id: 'Option', _tag: 'None' }
 *
 * console.log(Option.tap(Option.some(1), getInteger))
 * // Output: { _id: 'Option', _tag: 'Some', value: 1 }
 *
 * console.log(Option.tap(Option.some(1.14), getInteger))
 * // Output: { _id: 'Option', _tag: 'None' }
 * ```
 *
 * @category Sequencing
 * @since 2.0.0
 */
const tap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => flatMap(self, a => map(f(a), () => a)))));
/**
 * Combines two `Option` values into a single `Option` containing a tuple of
 * their values if both are `Some`.
 *
 * **Details**
 *
 * This function takes two `Option`s and combines their values into a tuple `[A,
 * B]` if both are `Some`. If either of the `Option`s is `None`, the result is
 * `None`. This is particularly useful for combining multiple `Option` values
 * into a single one, ensuring both contain valid values.
 *
 * @category Combining
 * @since 2.0.0
 */
const product = (self, that) => isSome(self) && isSome(that) ? some([self.value, that.value]) : none();
/**
 * Combines an `Option` with a collection of `Option`s into a single `Option`
 * containing a tuple of their values if all are `Some`.
 *
 * **Details**
 *
 * This function takes a primary `Option` and a collection of `Option`s and
 * combines their values into a tuple `[A, ...Array<A>]` if all are `Some`. If
 * the primary `Option` or any `Option` in the collection is `None`, the result
 * is `None`.
 *
 * @category Combining
 * @since 2.0.0
 */
const productMany = (self, collection) => {
  if (isNone(self)) {
    return none();
  }
  const out = [self.value];
  for (const o of collection) {
    if (isNone(o)) {
      return none();
    }
    out.push(o.value);
  }
  return some(out);
};
/**
 * Combines a structure of `Option`s into a single `Option` containing the
 * values with the same structure.
 *
 * **Details**
 *
 * This function takes a structure of `Option`s (a tuple, struct, or iterable)
 * and produces a single `Option` that contains the values from the input
 * structure if all `Option`s are `Some`. If any `Option` in the input is
 * `None`, the result is `None`. The structure of the input is preserved in the
 * output.
 *
 * - If the input is a tuple (e.g., an array), the result will be an `Option`
 *   containing a tuple with the same length.
 * - If the input is a struct (e.g., an object), the result will be an `Option`
 *   containing a struct with the same keys.
 * - If the input is an iterable, the result will be an `Option` containing an
 *   array.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * const maybeName: Option.Option<string> = Option.some("John")
 * const maybeAge: Option.Option<number> = Option.some(25)
 *
 * //      ┌─── Option<[string, number]>
 * //      ▼
 * const tuple = Option.all([maybeName, maybeAge])
 * console.log(tuple)
 * // Output:
 * // { _id: 'Option', _tag: 'Some', value: [ 'John', 25 ] }
 *
 * //      ┌─── Option<{ name: string; age: number; }>
 * //      ▼
 * const struct = Option.all({ name: maybeName, age: maybeAge })
 * console.log(struct)
 * // Output:
 * // { _id: 'Option', _tag: 'Some', value: { name: 'John', age: 25 } }
 * ```
 *
 * @category Combining
 * @since 2.0.0
 */
// @ts-expect-error
const all = input => {
  if (Symbol.iterator in input) {
    const out = [];
    for (const o of input) {
      if (isNone(o)) {
        return none();
      }
      out.push(o.value);
    }
    return some(out);
  }
  const out = {};
  for (const key of Object.keys(input)) {
    const o = input[key];
    if (isNone(o)) {
      return none();
    }
    out[key] = o.value;
  }
  return some(out);
};
/**
 * Combines two `Option` values into a new `Option` by applying a provided
 * function to their values.
 *
 * **Details**
 *
 * This function takes two `Option` values (`self` and `that`) and a combining
 * function `f`. If both `Option` values are `Some`, the function `f` is applied
 * to their values, and the result is wrapped in a new `Some`. If either
 * `Option` is `None`, the result is `None`.
 *
 * This utility is useful for combining two optional computations into a single
 * result while maintaining type safety and avoiding explicit checks for `None`.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * const maybeName: Option.Option<string> = Option.some("John")
 * const maybeAge: Option.Option<number> = Option.some(25)
 *
 * // Combine the name and age into a person object
 * const person = Option.zipWith(maybeName, maybeAge, (name, age) => ({
 *   name: name.toUpperCase(),
 *   age
 * }))
 *
 * console.log(person)
 * // Output:
 * // { _id: 'Option', _tag: 'Some', value: { name: 'JOHN', age: 25 } }
 * ```
 *
 * @category Zipping
 * @since 2.0.0
 */
const zipWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, that, f) => map(product(self, that), ([a, b]) => f(a, b)))));
/**
 * Applies a function inside a `Some` to a value inside another `Some`,
 * combining them into a new `Option`.
 *
 * **Details**
 *
 * This function allows you to apply a function wrapped in an `Option` (`self`)
 * to a value wrapped in another `Option` (`that`). If both `Option`s are
 * `Some`, the function is applied to the value, and the result is wrapped in a
 * new `Some`. If either `Option` is `None`, the result is `None`.
 *
 * @category Combining
 * @since 2.0.0
 */
const ap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => zipWith(self, that, (f, a) => f(a)))));
/**
 * Reduces an `Iterable` of `Option<A>` to a single value of type `B`, ignoring
 * elements that are `None`.
 *
 * **Details**
 *
 * This function takes an initial value of type `B` and a reducing function `f`
 * that combines the accumulator with values of type `A`. It processes an
 * iterable of `Option<A>`, applying `f` only to the `Some` values while
 * ignoring the `None` values. The result is a single value of type `B`.
 *
 * This utility is particularly useful for aggregating values from an iterable
 * of `Option`s while skipping the absent (`None`) values.
 *
 * @example
 * ```ts
 * import { Option, pipe } from "effect"
 *
 * const iterable = [Option.some(1), Option.none(), Option.some(2), Option.none()]
 *
 * console.log(pipe(iterable, Option.reduceCompact(0, (b, a) => b + a)))
 * // Output: 3
 * ```
 *
 * @category Reducing
 * @since 2.0.0
 */
const reduceCompact = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, b, f) => {
  let out = b;
  for (const oa of self) {
    if (isSome(oa)) {
      out = f(out, oa.value);
    }
  }
  return out;
})));
/**
 * Converts an `Option` into an `Array`.
 * If the input is `None`, an empty array is returned.
 * If the input is `Some`, its value is wrapped in a single-element array.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * console.log(Option.toArray(Option.some(1)))
 * // Output: [1]
 *
 * console.log(Option.toArray(Option.none()))
 * // Output: []
 * ```
 *
 * @category Conversions
 * @since 2.0.0
 */
const toArray = self => isNone(self) ? [] : [self.value];
/**
 * Splits an `Option` into two `Option`s based on the result of a mapping
 * function that produces an `Either`.
 *
 * **Details**
 *
 * This function takes an `Option` and a mapping function `f` that converts its
 * value into an `Either`. It returns a tuple of two `Option`s:
 *
 * - The first `Option` (`left`) contains the value from the `Left` side of the
 *   `Either` if it exists, otherwise `None`.
 * - The second `Option` (`right`) contains the value from the `Right` side of
 *   the `Either` if it exists, otherwise `None`.
 *
 * If the input `Option` is `None`, both returned `Option`s are `None`.
 *
 * This utility is useful for filtering and categorizing the contents of an
 * `Option` based on a bifurcating computation.
 *
 * @category Filtering
 * @since 2.0.0
 */
const partitionMap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  if (isNone(self)) {
    return [none(), none()];
  }
  const e = f(self.value);
  return either.isLeft(e) ? [some(e.left), none()] : [none(), some(e.right)];
})));
// TODO(4.0): remove?
/**
 * Alias of {@link flatMap}.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * // Transform and filter numbers
 * const transformEven = (n: Option.Option<number>): Option.Option<string> =>
 *   Option.filterMap(n, (n) => (n % 2 === 0 ? Option.some(`Even: ${n}`) : Option.none()))
 *
 * console.log(transformEven(Option.none()))
 * // Output: { _id: 'Option', _tag: 'None' }
 *
 * console.log(transformEven(Option.some(1)))
 * // Output: { _id: 'Option', _tag: 'None' }
 *
 * console.log(transformEven(Option.some(2)))
 * // Output: { _id: 'Option', _tag: 'Some', value: 'Even: 2' }
 * ```
 *
 * @category Filtering
 * @since 2.0.0
 */
const filterMap = flatMap;
/**
 * Filters an `Option` using a predicate. If the predicate is not satisfied or the `Option` is `None` returns `None`.
 *
 * If you need to change the type of the `Option` in addition to filtering, see `filterMap`.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * const removeEmptyString = (input: Option.Option<string>) =>
 *   Option.filter(input, (value) => value !== "")
 *
 * console.log(removeEmptyString(Option.none()))
 * // Output: { _id: 'Option', _tag: 'None' }
 *
 * console.log(removeEmptyString(Option.some("")))
 * // Output: { _id: 'Option', _tag: 'None' }
 *
 * console.log(removeEmptyString(Option.some("a")))
 * // Output: { _id: 'Option', _tag: 'Some', value: 'a' }
 * ```
 *
 * @category Filtering
 * @since 2.0.0
 */
const filter = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, predicate) => filterMap(self, b => predicate(b) ? _internal_option_js__WEBPACK_IMPORTED_MODULE_0__/* .some */ .G(b) : _internal_option_js__WEBPACK_IMPORTED_MODULE_0__/* .none */ .YP));
/**
 * Creates an `Equivalence` instance for comparing `Option` values, using a
 * provided `Equivalence` for the inner type.
 *
 * **Details**
 *
 * This function takes an `Equivalence` instance for a specific type `A` and
 * produces an `Equivalence` instance for `Option<A>`. The resulting
 * `Equivalence` determines whether two `Option` values are equivalent:
 *
 * - Two `None`s are considered equivalent.
 * - A `Some` and a `None` are not equivalent.
 * - Two `Some` values are equivalent if their inner values are equivalent
 *   according to the provided `Equivalence`.
 *
 * **Example** (Comparing Optional Numbers for Equivalence)
 *
 * ```ts
 * import { Number, Option } from "effect"
 *
 * const isEquivalent = Option.getEquivalence(Number.Equivalence)
 *
 * console.log(isEquivalent(Option.none(), Option.none()))
 * // Output: true
 *
 * console.log(isEquivalent(Option.none(), Option.some(1)))
 * // Output: false
 *
 * console.log(isEquivalent(Option.some(1), Option.none()))
 * // Output: false
 *
 * console.log(isEquivalent(Option.some(1), Option.some(2)))
 * // Output: false
 *
 * console.log(isEquivalent(Option.some(1), Option.some(1)))
 * // Output: true
 * ```
 *
 * @category Equivalence
 * @since 2.0.0
 */
const getEquivalence = isEquivalent => _Equivalence_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .Sy((x, y) => isNone(x) ? isNone(y) : isNone(y) ? false : isEquivalent(x.value, y.value));
/**
 * Creates an `Order` instance for comparing `Option` values, using a provided
 * `Order` for the inner type.
 *
 * **Details**
 *
 * This function produces an `Order` instance for `Option<A>`, allowing `Option`
 * values to be compared:
 *
 * - `None` is always considered less than any `Some` value.
 * - If both are `Some`, their inner values are compared using the provided
 *   `Order` instance.
 *
 * @example
 * ```ts
 * import { Number, Option } from "effect"
 *
 * const order = Option.getOrder(Number.Order)
 *
 * console.log(order(Option.none(), Option.none()))
 * // Output: 0
 *
 * console.log(order(Option.none(), Option.some(1)))
 * // Output: -1
 *
 * console.log(order(Option.some(1), Option.none()))
 * // Output: 1
 *
 * console.log(order(Option.some(1), Option.some(2)))
 * // Output: -1
 *
 * console.log(order(Option.some(1), Option.some(1)))
 * // Output: 0
 * ```
 *
 * @category Sorting
 * @since 2.0.0
 */
const getOrder = O => order.make((self, that) => isSome(self) ? isSome(that) ? O(self.value, that.value) : 1 : -1);
/**
 * Lifts a binary function to work with `Option` values, allowing the function
 * to operate on two `Option`s.
 *
 * **Details**
 *
 * This function takes a binary function `f` and returns a new function that
 * applies `f` to the values of two `Option`s (`self` and `that`). If both
 * `Option`s are `Some`, the binary function `f` is applied to their values, and
 * the result is wrapped in a new `Some`. If either `Option` is `None`, the
 * result is `None`.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * // A binary function to add two numbers
 * const add = (a: number, b: number): number => a + b
 *
 * // Lift the `add` function to work with `Option` values
 * const addOptions = Option.lift2(add)
 *
 * // Both `Option`s are `Some`
 * console.log(addOptions(Option.some(2), Option.some(3)))
 * // Output: { _id: 'Option', _tag: 'Some', value: 5 }
 *
 * // One `Option` is `None`
 * console.log(addOptions(Option.some(2), Option.none()))
 * // Output: { _id: 'Option', _tag: 'None' }
 * ```
 *
 * @category Lifting
 * @since 2.0.0
 */
const lift2 = f => dual(2, (self, that) => zipWith(self, that, f));
/**
 * Lifts a `Predicate` or `Refinement` into the `Option` context, returning a
 * `Some` of the input value if the predicate is satisfied, or `None` otherwise.
 *
 * **Details**
 *
 * This function transforms a `Predicate` (or a more specific `Refinement`) into
 * a function that produces an `Option`. If the predicate evaluates to `true`,
 * the input value is wrapped in a `Some`. If the predicate evaluates to
 * `false`, the result is `None`.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * // Check if a number is positive
 * const isPositive = (n: number) => n > 0
 *
 * //      ┌─── (b: number) => Option<number>
 * //      ▼
 * const parsePositive = Option.liftPredicate(isPositive)
 *
 * console.log(parsePositive(1))
 * // Output: { _id: 'Option', _tag: 'Some', value: 1 }
 *
 * console.log(parsePositive(-1))
 * // OUtput: { _id: 'Option', _tag: 'None' }
 * ```
 *
 * @category Lifting
 * @since 2.0.0
 */
const liftPredicate = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (b, predicate) => predicate(b) ? some(b) : none())));
/**
 * Returns a function that checks if an `Option` contains a specified value,
 * using a provided equivalence function.
 *
 * **Details**
 *
 * This function allows you to check whether an `Option` contains a specific
 * value. It uses an equivalence function `isEquivalent` to compare the value
 * inside the `Option` to the provided value. If the `Option` is `Some` and the
 * equivalence function returns `true`, the result is `true`. If the `Option` is
 * `None` or the values are not equivalent, the result is `false`.
 *
 * @example
 * ```ts
 * import { Number, Option } from "effect"
 *
 * const contains = Option.containsWith(Number.Equivalence)
 *
 * console.log(Option.some(2).pipe(contains(2)))
 * // Output: true
 *
 * console.log(Option.some(1).pipe(contains(2)))
 * // Output: false
 *
 * console.log(Option.none().pipe(contains(2)))
 * // Output: false
 * ```
 *
 * @see {@link contains} for a version that uses the default `Equivalence`.
 *
 * @category Elements
 * @since 2.0.0
 */
const containsWith = isEquivalent => (0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, a) => isNone(self) ? false : isEquivalent(self.value, a));
const _equivalence = /*#__PURE__*/_Equal_js__WEBPACK_IMPORTED_MODULE_4__/* .equivalence */ .DE();
/**
 * Returns a function that checks if an `Option` contains a specified value
 * using the default `Equivalence`.
 *
 * **Details**
 *
 * This function allows you to check whether an `Option` contains a specific
 * value. It uses the default `Equivalence` for equality comparison. If the
 * `Option` is `Some` and its value is equivalent to the provided value, the
 * result is `true`. If the `Option` is `None` or the values are not equivalent,
 * the result is `false`.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * console.log(Option.some(2).pipe(Option.contains(2)))
 * // Output: true
 *
 * console.log(Option.some(1).pipe(Option.contains(2)))
 * // Output: false
 *
 * console.log(Option.none().pipe(Option.contains(2)))
 * // Output: false
 * ```
 *
 * @see {@link containsWith} for a version that allows you to specify a custom equivalence function.
 *
 * @category Elements
 * @since 2.0.0
 */
const contains = /*#__PURE__*/containsWith(_equivalence);
/**
 * Checks if a value in an `Option` satisfies a given predicate or refinement.
 *
 * **Details**
 *
 * This function allows you to check if a value inside a `Some` meets a
 * specified condition. If the `Option` is `None`, the result is `false`. If the
 * `Option` is `Some`, the provided predicate or refinement is applied to the
 * value:
 *
 * - If the condition is met, the result is `true`.
 * - If the condition is not met, the result is `false`.
 *
 * @example
 * ```ts
 * import { Option } from "effect"
 *
 * const isEven = (n: number) => n % 2 === 0
 *
 * console.log(Option.some(2).pipe(Option.exists(isEven)))
 * // Output: true
 *
 * console.log(Option.some(1).pipe(Option.exists(isEven)))
 * // Output: false
 *
 * console.log(Option.none().pipe(Option.exists(isEven)))
 * // Output: false
 * ```
 *
 * @category Elements
 * @since 2.0.0
 */
const exists = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, refinement) => isNone(self) ? false : refinement(self.value));
// -------------------------------------------------------------------------------------
// do notation
// -------------------------------------------------------------------------------------
/**
 * The "do simulation" in Effect allows you to write code in a more declarative style, similar to the "do notation" in other programming languages. It provides a way to define variables and perform operations on them using functions like `bind` and `let`.
 *
 * Here's how the do simulation works:
 *
 * 1. Start the do simulation using the `Do` value
 * 2. Within the do simulation scope, you can use the `bind` function to define variables and bind them to `Option` values
 * 3. You can accumulate multiple `bind` statements to define multiple variables within the scope
 * 4. Inside the do simulation scope, you can also use the `let` function to define variables and bind them to simple values
 * 5. Regular `Option` functions like `map` and `filter` can still be used within the do simulation. These functions will receive the accumulated variables as arguments within the scope
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Option, pipe } from "effect"
 *
 * const result = pipe(
 *   Option.Do,
 *   Option.bind("x", () => Option.some(2)),
 *   Option.bind("y", () => Option.some(3)),
 *   Option.let("sum", ({ x, y }) => x + y),
 *   Option.filter(({ x, y }) => x * y > 5)
 * )
 * assert.deepStrictEqual(result, Option.some({ x: 2, y: 3, sum: 5 }))
 * ```
 *
 * @see {@link Do}
 * @see {@link bind}
 * @see {@link let_ let}
 *
 * @category Do notation
 * @since 2.0.0
 */
const bindTo = /*#__PURE__*/(/* unused pure expression or super */ null && (doNotation.bindTo(map)));
const let_ = /*#__PURE__*/(/* unused pure expression or super */ null && (doNotation.let_(map)));

/**
 * The "do simulation" in Effect allows you to write code in a more declarative style, similar to the "do notation" in other programming languages. It provides a way to define variables and perform operations on them using functions like `bind` and `let`.
 *
 * Here's how the do simulation works:
 *
 * 1. Start the do simulation using the `Do` value
 * 2. Within the do simulation scope, you can use the `bind` function to define variables and bind them to `Option` values
 * 3. You can accumulate multiple `bind` statements to define multiple variables within the scope
 * 4. Inside the do simulation scope, you can also use the `let` function to define variables and bind them to simple values
 * 5. Regular `Option` functions like `map` and `filter` can still be used within the do simulation. These functions will receive the accumulated variables as arguments within the scope
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Option, pipe } from "effect"
 *
 * const result = pipe(
 *   Option.Do,
 *   Option.bind("x", () => Option.some(2)),
 *   Option.bind("y", () => Option.some(3)),
 *   Option.let("sum", ({ x, y }) => x + y),
 *   Option.filter(({ x, y }) => x * y > 5)
 * )
 * assert.deepStrictEqual(result, Option.some({ x: 2, y: 3, sum: 5 }))
 * ```
 *
 * @see {@link Do}
 * @see {@link bindTo}
 * @see {@link let_ let}
 *
 * @category Do notation
 * @since 2.0.0
 */
const bind = /*#__PURE__*/(/* unused pure expression or super */ null && (doNotation.bind(map, flatMap)));
/**
 * The "do simulation" in Effect allows you to write code in a more declarative style, similar to the "do notation" in other programming languages. It provides a way to define variables and perform operations on them using functions like `bind` and `let`.
 *
 * Here's how the do simulation works:
 *
 * 1. Start the do simulation using the `Do` value
 * 2. Within the do simulation scope, you can use the `bind` function to define variables and bind them to `Option` values
 * 3. You can accumulate multiple `bind` statements to define multiple variables within the scope
 * 4. Inside the do simulation scope, you can also use the `let` function to define variables and bind them to simple values
 * 5. Regular `Option` functions like `map` and `filter` can still be used within the do simulation. These functions will receive the accumulated variables as arguments within the scope
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Option, pipe } from "effect"
 *
 * const result = pipe(
 *   Option.Do,
 *   Option.bind("x", () => Option.some(2)),
 *   Option.bind("y", () => Option.some(3)),
 *   Option.let("sum", ({ x, y }) => x + y),
 *   Option.filter(({ x, y }) => x * y > 5)
 * )
 * assert.deepStrictEqual(result, Option.some({ x: 2, y: 3, sum: 5 }))
 * ```
 *
 * @see {@link bindTo}
 * @see {@link bind}
 * @see {@link let_ let}
 *
 * @category Do notation
 * @since 2.0.0
 */
const Do = /*#__PURE__*/some({});
const adapter = /*#__PURE__*/(/* unused pure expression or super */ null && (Gen.adapter()));
/**
 * Similar to `Effect.gen`, `Option.gen` provides a more readable,
 * generator-based syntax for working with `Option` values, making code that
 * involves `Option` easier to write and understand. This approach is similar to
 * using `async/await` but tailored for `Option`.
 *
 * **Example** (Using `Option.gen` to Create a Combined Value)
 *
 * ```ts
 * import { Option } from "effect"
 *
 * const maybeName: Option.Option<string> = Option.some("John")
 * const maybeAge: Option.Option<number> = Option.some(25)
 *
 * const person = Option.gen(function* () {
 *   const name = (yield* maybeName).toUpperCase()
 *   const age = yield* maybeAge
 *   return { name, age }
 * })
 *
 * console.log(person)
 * // Output:
 * // { _id: 'Option', _tag: 'Some', value: { name: 'JOHN', age: 25 } }
 * ```
 *
 * @category Generators
 * @since 2.0.0
 */
const gen = (...args) => {
  const f = args.length === 1 ? args[0] : args[1].bind(args[0]);
  const iterator = f(adapter);
  let state = iterator.next();
  while (!state.done) {
    const current = Gen.isGenKind(state.value) ? state.value.value : Gen.yieldWrapGet(state.value);
    if (isNone(current)) {
      return current;
    }
    state = iterator.next(current.value);
  }
  return some(state.value);
};
/**
 * Merges two optional values, applying a function if both exist.
 * Unlike {@link zipWith}, this function returns `None` only if both inputs are `None`.
 *
 * @internal
 */
const mergeWith = f => (o1, o2) => {
  if (isNone(o1)) {
    return o2;
  } else if (isNone(o2)) {
    return o1;
  }
  return some(f(o1.value, o2.value));
};
//# sourceMappingURL=Option.js.map

/***/ }),

/***/ 51988:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ mapInput; },
/* harmony export */   "Fp": function() { return /* binding */ max; },
/* harmony export */   "IX": function() { return /* binding */ array; },
/* harmony export */   "Kv": function() { return /* binding */ bigint; },
/* harmony export */   "MK": function() { return /* binding */ lessThanOrEqualTo; },
/* harmony export */   "O7": function() { return /* binding */ boolean; },
/* harmony export */   "Qj": function() { return /* binding */ lessThan; },
/* harmony export */   "Rx": function() { return /* binding */ number; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "VV": function() { return /* binding */ min; },
/* harmony export */   "Z_": function() { return /* binding */ string; },
/* harmony export */   "bc": function() { return /* binding */ tuple; },
/* harmony export */   "n_": function() { return /* binding */ struct; },
/* harmony export */   "tS": function() { return /* binding */ greaterThan; },
/* harmony export */   "uZ": function() { return /* binding */ clamp; },
/* harmony export */   "vX": function() { return /* binding */ between; },
/* harmony export */   "wZ": function() { return /* binding */ greaterThanOrEqualTo; }
/* harmony export */ });
/* unused harmony exports reverse, combine, combineMany, empty, combineAll, Date, product, all, productMany */
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17316);
/**
 * This module provides an implementation of the `Order` type class which is used to define a total ordering on some type `A`.
 * An order is defined by a relation `<=`, which obeys the following laws:
 *
 * - either `x <= y` or `y <= x` (totality)
 * - if `x <= y` and `y <= x`, then `x == y` (antisymmetry)
 * - if `x <= y` and `y <= z`, then `x <= z` (transitivity)
 *
 * The truth table for compare is defined as follows:
 *
 * | `x <= y` | `x >= y` | Ordering |                       |
 * | -------- | -------- | -------- | --------------------- |
 * | `true`   | `true`   | `0`      | corresponds to x == y |
 * | `true`   | `false`  | `< 0`    | corresponds to x < y  |
 * | `false`  | `true`   | `> 0`    | corresponds to x > y  |
 *
 * @since 2.0.0
 */

/**
 * @category constructors
 * @since 2.0.0
 */
const make = compare => (self, that) => self === that ? 0 : compare(self, that);
/**
 * @category instances
 * @since 2.0.0
 */
const string = /*#__PURE__*/make((self, that) => self < that ? -1 : 1);
/**
 * @category instances
 * @since 2.0.0
 */
const number = /*#__PURE__*/make((self, that) => self < that ? -1 : 1);
/**
 * @category instances
 * @since 2.0.0
 */
const boolean = /*#__PURE__*/make((self, that) => self < that ? -1 : 1);
/**
 * @category instances
 * @since 2.0.0
 */
const bigint = /*#__PURE__*/make((self, that) => self < that ? -1 : 1);
/**
 * @since 2.0.0
 */
const reverse = O => make((self, that) => O(that, self));
/**
 * @category combining
 * @since 2.0.0
 */
const combine = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => make((a1, a2) => {
  const out = self(a1, a2);
  if (out !== 0) {
    return out;
  }
  return that(a1, a2);
}))));
/**
 * @category combining
 * @since 2.0.0
 */
const combineMany = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, collection) => make((a1, a2) => {
  let out = self(a1, a2);
  if (out !== 0) {
    return out;
  }
  for (const O of collection) {
    out = O(a1, a2);
    if (out !== 0) {
      return out;
    }
  }
  return out;
}))));
/**
 * @since 2.0.0
 */
const empty = () => make(() => 0);
/**
 * @category combining
 * @since 2.0.0
 */
const combineAll = collection => combineMany(empty(), collection);
/**
 * @category mapping
 * @since 2.0.0
 */
const mapInput = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, f) => make((b1, b2) => self(f(b1), f(b2))));
/**
 * @category instances
 * @since 2.0.0
 */
const Date = /*#__PURE__*/(/* unused pure expression or super */ null && (mapInput(number, date => date.getTime())));
/**
 * @category combining
 * @since 2.0.0
 */
const product = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => make(([xa, xb], [ya, yb]) => {
  const o = self(xa, ya);
  return o !== 0 ? o : that(xb, yb);
}))));
/**
 * @category combining
 * @since 2.0.0
 */
const all = collection => {
  return make((x, y) => {
    const len = Math.min(x.length, y.length);
    let collectionLength = 0;
    for (const O of collection) {
      if (collectionLength >= len) {
        break;
      }
      const o = O(x[collectionLength], y[collectionLength]);
      if (o !== 0) {
        return o;
      }
      collectionLength++;
    }
    return 0;
  });
};
/**
 * @category combining
 * @since 2.0.0
 */
const productMany = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, collection) => {
  const O = all(collection);
  return make((x, y) => {
    const o = self(x[0], y[0]);
    return o !== 0 ? o : O(x.slice(1), y.slice(1));
  });
})));
/**
 * Similar to `Promise.all` but operates on `Order`s.
 *
 * ```
 * [Order<A>, Order<B>, ...] -> Order<[A, B, ...]>
 * ```
 *
 * This function creates and returns a new `Order` for a tuple of values based on the given `Order`s for each element in the tuple.
 * The returned `Order` compares two tuples of the same type by applying the corresponding `Order` to each element in the tuple.
 * It is useful when you need to compare two tuples of the same type and you have a specific way of comparing each element
 * of the tuple.
 *
 * @category combinators
 * @since 2.0.0
 */
const tuple = (...elements) => all(elements);
/**
 * This function creates and returns a new `Order` for an array of values based on a given `Order` for the elements of the array.
 * The returned `Order` compares two arrays by applying the given `Order` to each element in the arrays.
 * If all elements are equal, the arrays are then compared based on their length.
 * It is useful when you need to compare two arrays of the same type and you have a specific way of comparing each element of the array.
 *
 * @category combinators
 * @since 2.0.0
 */
const array = O => make((self, that) => {
  const aLen = self.length;
  const bLen = that.length;
  const len = Math.min(aLen, bLen);
  for (let i = 0; i < len; i++) {
    const o = O(self[i], that[i]);
    if (o !== 0) {
      return o;
    }
  }
  return number(aLen, bLen);
});
/**
 * This function creates and returns a new `Order` for a struct of values based on the given `Order`s
 * for each property in the struct.
 *
 * @category combinators
 * @since 2.0.0
 */
const struct = fields => {
  const keys = Object.keys(fields);
  return make((self, that) => {
    for (const key of keys) {
      const o = fields[key](self[key], that[key]);
      if (o !== 0) {
        return o;
      }
    }
    return 0;
  });
};
/**
 * Test whether one value is _strictly less than_ another.
 *
 * @since 2.0.0
 */
const lessThan = O => (0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, that) => O(self, that) === -1);
/**
 * Test whether one value is _strictly greater than_ another.
 *
 * @since 2.0.0
 */
const greaterThan = O => (0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, that) => O(self, that) === 1);
/**
 * Test whether one value is _non-strictly less than_ another.
 *
 * @since 2.0.0
 */
const lessThanOrEqualTo = O => (0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, that) => O(self, that) !== 1);
/**
 * Test whether one value is _non-strictly greater than_ another.
 *
 * @since 2.0.0
 */
const greaterThanOrEqualTo = O => (0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, that) => O(self, that) !== -1);
/**
 * Take the minimum of two values. If they are considered equal, the first argument is chosen.
 *
 * @since 2.0.0
 */
const min = O => (0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, that) => self === that || O(self, that) < 1 ? self : that);
/**
 * Take the maximum of two values. If they are considered equal, the first argument is chosen.
 *
 * @since 2.0.0
 */
const max = O => (0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, that) => self === that || O(self, that) > -1 ? self : that);
/**
 * Clamp a value between a minimum and a maximum.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Order, Number } from "effect"
 *
 * const clamp = Order.clamp(Number.Order)({ minimum: 1, maximum: 5 })
 *
 * assert.equal(clamp(3), 3)
 * assert.equal(clamp(0), 1)
 * assert.equal(clamp(6), 5)
 * ```
 *
 * @since 2.0.0
 */
const clamp = O => (0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, options) => min(O)(options.maximum, max(O)(options.minimum, self)));
/**
 * Test whether a value is between a minimum and a maximum (inclusive).
 *
 * @since 2.0.0
 */
const between = O => (0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, options) => !lessThan(O)(self, options.minimum) && !greaterThan(O)(self, options.maximum));
//# sourceMappingURL=Order.js.map

/***/ }),

/***/ 92817:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ pipeArguments; }
/* harmony export */ });
/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 */
const pipeArguments = (self, args) => {
  switch (args.length) {
    case 0:
      return self;
    case 1:
      return args[0](self);
    case 2:
      return args[1](args[0](self));
    case 3:
      return args[2](args[1](args[0](self)));
    case 4:
      return args[3](args[2](args[1](args[0](self))));
    case 5:
      return args[4](args[3](args[2](args[1](args[0](self)))));
    case 6:
      return args[5](args[4](args[3](args[2](args[1](args[0](self))))));
    case 7:
      return args[6](args[5](args[4](args[3](args[2](args[1](args[0](self)))))));
    case 8:
      return args[7](args[6](args[5](args[4](args[3](args[2](args[1](args[0](self))))))));
    case 9:
      return args[8](args[7](args[6](args[5](args[4](args[3](args[2](args[1](args[0](self)))))))));
    default:
      {
        let ret = self;
        for (let i = 0, len = args.length; i < len; i++) {
          ret = args[i](ret);
        }
        return ret;
      }
  }
};
//# sourceMappingURL=Pipeable.js.map

/***/ }),

/***/ 71335:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bd": function() { return /* binding */ isTagged; },
/* harmony export */   "C4": function() { return /* binding */ isBigInt; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J_": function() { return /* binding */ isDate; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "TW": function() { return /* binding */ isIterable; },
/* harmony export */   "U3": function() { return /* binding */ isRecordOrArray; },
/* harmony export */   "Uy": function() { return /* binding */ isRecord; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "Yd": function() { return /* binding */ isNullable; },
/* harmony export */   "fQ": function() { return /* binding */ isTruthy; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "jW": function() { return /* binding */ isNotNullable; },
/* harmony export */   "jn": function() { return /* binding */ isBoolean; },
/* harmony export */   "l$": function() { return /* binding */ hasProperty; },
/* harmony export */   "lq": function() { return /* binding */ isUint8Array; },
/* harmony export */   "mf": function() { return /* binding */ isFunction; },
/* harmony export */   "o8": function() { return /* binding */ isUndefined; },
/* harmony export */   "r2": function() { return /* binding */ isNever; },
/* harmony export */   "y8": function() { return /* binding */ isPromiseLike; },
/* harmony export */   "yk": function() { return /* binding */ isSymbol; }
/* harmony export */ });
/* unused harmony exports mapInput, isTupleOf, isTupleOfAtLeast, isSet, isMap, isPropertyKey, isNotUndefined, isNull, isNotNull, isUnknown, isReadonlyRecord, isPromise, compose, product, all, productMany, tuple, struct, not, or, and, xor, eqv, implies, nor, nand, every, some */
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17316);
/**
 * @since 2.0.0
 */

/**
 * Given a `Predicate<A>` returns a `Predicate<B>`
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Predicate, Number } from "effect"
 *
 * const minLength3 = Predicate.mapInput(Number.greaterThan(2), (s: string) => s.length)
 *
 * assert.deepStrictEqual(minLength3("a"), false)
 * assert.deepStrictEqual(minLength3("aa"), false)
 * assert.deepStrictEqual(minLength3("aaa"), true)
 * assert.deepStrictEqual(minLength3("aaaa"), true)
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const mapInput = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => b => self(f(b)))));
/**
 * Determine if an `Array` is a tuple with exactly `N` elements, narrowing down the type to `TupleOf`.
 *
 * An `Array` is considered to be a `TupleOf` if its length is exactly `N`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isTupleOf } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isTupleOf([1, 2, 3], 3), true);
 * assert.deepStrictEqual(isTupleOf([1, 2, 3], 2), false);
 * assert.deepStrictEqual(isTupleOf([1, 2, 3], 4), false);
 *
 * const arr: number[] = [1, 2, 3];
 * if (isTupleOf(arr, 3)) {
 *   console.log(arr);
 *   // ^? [number, number, number]
 * }
 * ```
 *
 * @category guards
 * @since 3.3.0
 */
const isTupleOf = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => self.length === n)));
/**
 * Determine if an `Array` is a tuple with at least `N` elements, narrowing down the type to `TupleOfAtLeast`.
 *
 * An `Array` is considered to be a `TupleOfAtLeast` if its length is at least `N`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isTupleOfAtLeast } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isTupleOfAtLeast([1, 2, 3], 3), true);
 * assert.deepStrictEqual(isTupleOfAtLeast([1, 2, 3], 2), true);
 * assert.deepStrictEqual(isTupleOfAtLeast([1, 2, 3], 4), false);
 *
 * const arr: number[] = [1, 2, 3, 4];
 * if (isTupleOfAtLeast(arr, 3)) {
 *   console.log(arr);
 *   // ^? [number, number, number, ...number[]]
 * }
 * ```
 *
 * @category guards
 * @since 3.3.0
 */
const isTupleOfAtLeast = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => self.length >= n)));
/**
 * Tests if a value is `truthy`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isTruthy } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isTruthy(1), true)
 * assert.deepStrictEqual(isTruthy(0), false)
 * assert.deepStrictEqual(isTruthy(""), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isTruthy = input => !!input;
/**
 * Tests if a value is a `Set`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isSet } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isSet(new Set([1, 2])), true)
 * assert.deepStrictEqual(isSet(new Set()), true)
 * assert.deepStrictEqual(isSet({}), false)
 * assert.deepStrictEqual(isSet(null), false)
 * assert.deepStrictEqual(isSet(undefined), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isSet = input => input instanceof Set;
/**
 * Tests if a value is a `Map`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isMap } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isMap(new Map()), true)
 * assert.deepStrictEqual(isMap({}), false)
 * assert.deepStrictEqual(isMap(null), false)
 * assert.deepStrictEqual(isMap(undefined), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isMap = input => input instanceof Map;
/**
 * Tests if a value is a `string`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isString } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isString("a"), true)
 *
 * assert.deepStrictEqual(isString(1), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isString = input => typeof input === "string";
/**
 * Tests if a value is a `number`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isNumber } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isNumber(2), true)
 *
 * assert.deepStrictEqual(isNumber("2"), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isNumber = input => typeof input === "number";
/**
 * Tests if a value is a `boolean`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isBoolean } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isBoolean(true), true)
 *
 * assert.deepStrictEqual(isBoolean("true"), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isBoolean = input => typeof input === "boolean";
/**
 * Tests if a value is a `bigint`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isBigInt } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isBigInt(1n), true)
 *
 * assert.deepStrictEqual(isBigInt(1), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isBigInt = input => typeof input === "bigint";
/**
 * Tests if a value is a `symbol`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isSymbol } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isSymbol(Symbol.for("a")), true)
 *
 * assert.deepStrictEqual(isSymbol("a"), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isSymbol = input => typeof input === "symbol";
// TODO: make public
/** @internal */
const isPropertyKey = u => isString(u) || isNumber(u) || isSymbol(u);
/**
 * Tests if a value is a `function`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isFunction } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isFunction(isFunction), true)
 *
 * assert.deepStrictEqual(isFunction("function"), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isFunction = _Function_js__WEBPACK_IMPORTED_MODULE_0__/* .isFunction */ .mf;
/**
 * Tests if a value is `undefined`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isUndefined } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isUndefined(undefined), true)
 *
 * assert.deepStrictEqual(isUndefined(null), false)
 * assert.deepStrictEqual(isUndefined("undefined"), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isUndefined = input => input === undefined;
/**
 * Tests if a value is not `undefined`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isNotUndefined } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isNotUndefined(null), true)
 * assert.deepStrictEqual(isNotUndefined("undefined"), true)
 *
 * assert.deepStrictEqual(isNotUndefined(undefined), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isNotUndefined = input => input !== undefined;
/**
 * Tests if a value is `null`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isNull } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isNull(null), true)
 *
 * assert.deepStrictEqual(isNull(undefined), false)
 * assert.deepStrictEqual(isNull("null"), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isNull = input => input === null;
/**
 * Tests if a value is not `null`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isNotNull } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isNotNull(undefined), true)
 * assert.deepStrictEqual(isNotNull("null"), true)
 *
 * assert.deepStrictEqual(isNotNull(null), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isNotNull = input => input !== null;
/**
 * A guard that always fails.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isNever } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isNever(null), false)
 * assert.deepStrictEqual(isNever(undefined), false)
 * assert.deepStrictEqual(isNever({}), false)
 * assert.deepStrictEqual(isNever([]), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isNever = _ => false;
/**
 * A guard that always succeeds.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isUnknown } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isUnknown(null), true)
 * assert.deepStrictEqual(isUnknown(undefined), true)
 *
 * assert.deepStrictEqual(isUnknown({}), true)
 * assert.deepStrictEqual(isUnknown([]), true)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isUnknown = _ => true;
/** @internal */
const isRecordOrArray = input => typeof input === "object" && input !== null;
/**
 * Tests if a value is an `object`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isObject } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isObject({}), true)
 * assert.deepStrictEqual(isObject([]), true)
 *
 * assert.deepStrictEqual(isObject(null), false)
 * assert.deepStrictEqual(isObject(undefined), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isObject = input => isRecordOrArray(input) || isFunction(input);
/**
 * Checks whether a value is an `object` containing a specified property key.
 *
 * @category guards
 * @since 2.0.0
 */
const hasProperty = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, property) => isObject(self) && property in self);
/**
 * Tests if a value is an `object` with a property `_tag` that matches the given tag.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isTagged } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isTagged(1, "a"), false)
 * assert.deepStrictEqual(isTagged(null, "a"), false)
 * assert.deepStrictEqual(isTagged({}, "a"), false)
 * assert.deepStrictEqual(isTagged({ a: "a" }, "a"), false)
 * assert.deepStrictEqual(isTagged({ _tag: "a" }, "a"), true)
 * assert.deepStrictEqual(isTagged("a")({ _tag: "a" }), true)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isTagged = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, tag) => hasProperty(self, "_tag") && self["_tag"] === tag);
/**
 * A guard that succeeds when the input is `null` or `undefined`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isNullable } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isNullable(null), true)
 * assert.deepStrictEqual(isNullable(undefined), true)
 *
 * assert.deepStrictEqual(isNullable({}), false)
 * assert.deepStrictEqual(isNullable([]), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isNullable = input => input === null || input === undefined;
/**
 * A guard that succeeds when the input is not `null` or `undefined`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isNotNullable } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isNotNullable({}), true)
 * assert.deepStrictEqual(isNotNullable([]), true)
 *
 * assert.deepStrictEqual(isNotNullable(null), false)
 * assert.deepStrictEqual(isNotNullable(undefined), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isNotNullable = input => input !== null && input !== undefined;
/**
 * A guard that succeeds when the input is an `Error`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isError } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isError(new Error()), true)
 *
 * assert.deepStrictEqual(isError(null), false)
 * assert.deepStrictEqual(isError({}), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isError = input => input instanceof Error;
/**
 * A guard that succeeds when the input is a `Uint8Array`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isUint8Array } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isUint8Array(new Uint8Array()), true)
 *
 * assert.deepStrictEqual(isUint8Array(null), false)
 * assert.deepStrictEqual(isUint8Array({}), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isUint8Array = input => input instanceof Uint8Array;
/**
 * A guard that succeeds when the input is a `Date`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isDate } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isDate(new Date()), true)
 *
 * assert.deepStrictEqual(isDate(null), false)
 * assert.deepStrictEqual(isDate({}), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isDate = input => input instanceof Date;
/**
 * A guard that succeeds when the input is an `Iterable`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isIterable } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isIterable([]), true)
 * assert.deepStrictEqual(isIterable(new Set()), true)
 *
 * assert.deepStrictEqual(isIterable(null), false)
 * assert.deepStrictEqual(isIterable({}), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isIterable = input => hasProperty(input, Symbol.iterator);
/**
 * A guard that succeeds when the input is a record.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isRecord } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isRecord({}), true)
 * assert.deepStrictEqual(isRecord({ a: 1 }), true)
 *
 * assert.deepStrictEqual(isRecord([]), false)
 * assert.deepStrictEqual(isRecord([1, 2, 3]), false)
 * assert.deepStrictEqual(isRecord(null), false)
 * assert.deepStrictEqual(isRecord(undefined), false)
 * assert.deepStrictEqual(isRecord(() => null), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isRecord = input => isRecordOrArray(input) && !Array.isArray(input);
/**
 * A guard that succeeds when the input is a readonly record.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isReadonlyRecord } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isReadonlyRecord({}), true)
 * assert.deepStrictEqual(isReadonlyRecord({ a: 1 }), true)
 *
 * assert.deepStrictEqual(isReadonlyRecord([]), false)
 * assert.deepStrictEqual(isReadonlyRecord([1, 2, 3]), false)
 * assert.deepStrictEqual(isReadonlyRecord(null), false)
 * assert.deepStrictEqual(isReadonlyRecord(undefined), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isReadonlyRecord = (/* unused pure expression or super */ null && (isRecord));
/**
 * A guard that succeeds when the input is a Promise.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isPromise } from "effect/Predicate"
 *
 * assert.deepStrictEqual(isPromise({}), false)
 * assert.deepStrictEqual(isPromise(Promise.resolve("hello")), true)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isPromise = input => hasProperty(input, "then") && "catch" in input && isFunction(input.then) && isFunction(input.catch);
/**
 * @category guards
 * @since 2.0.0
 */
const isPromiseLike = input => hasProperty(input, "then") && isFunction(input.then);
/**
 * Tests if a value is a `RegExp`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Predicate } from "effect"
 *
 * assert.deepStrictEqual(Predicate.isRegExp(/a/), true)
 * assert.deepStrictEqual(Predicate.isRegExp("a"), false)
 * ```
 *
 * @category guards
 * @since 3.9.0
 */
const isRegExp = input => input instanceof RegExp;
/**
 * @since 2.0.0
 */
const compose = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (ab, bc) => a => ab(a) && bc(a))));
/**
 * @category combining
 * @since 2.0.0
 */
const product = (self, that) => ([a, b]) => self(a) && that(b);
/**
 * @category combining
 * @since 2.0.0
 */
const all = collection => {
  return as => {
    let collectionIndex = 0;
    for (const p of collection) {
      if (collectionIndex >= as.length) {
        break;
      }
      if (p(as[collectionIndex]) === false) {
        return false;
      }
      collectionIndex++;
    }
    return true;
  };
};
/**
 * @category combining
 * @since 2.0.0
 */
const productMany = (self, collection) => {
  const rest = all(collection);
  return ([head, ...tail]) => self(head) === false ? false : rest(tail);
};
/**
 * Similar to `Promise.all` but operates on `Predicate`s.
 *
 * ```ts skip-type-checking
 * [Refinement<A, B>, Refinement<C, D>, ...] -> Refinement<[A, C, ...], [B, D, ...]>
 * [Predicate<A>, Predicate<B>, ...] -> Predicate<[A, B, ...]>
 * [Refinement<A, B>, Predicate<C>, ...] -> Refinement<[A, C, ...], [B, C, ...]>
 * ```
 *
 * @since 2.0.0
 */
const tuple = (...elements) => all(elements);
/**
 * ```ts skip-type-checking
 * { ab: Refinement<A, B>; cd: Refinement<C, D>, ... } -> Refinement<{ ab: A; cd: C; ... }, { ab: B; cd: D; ... }>
 * { a: Predicate<A, B>; b: Predicate<B>, ... } -> Predicate<{ a: A; b: B; ... }>
 * { ab: Refinement<A, B>; c: Predicate<C>, ... } -> Refinement<{ ab: A; c: C; ... }, { ab: B; c: С; ... }>
 * ```
 *
 * @since 2.0.0
 */
const struct = fields => {
  const keys = Object.keys(fields);
  return a => {
    for (const key of keys) {
      if (!fields[key](a[key])) {
        return false;
      }
    }
    return true;
  };
};
/**
 * Negates the result of a given predicate.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Predicate, Number } from "effect"
 *
 * const isPositive = Predicate.not(Number.lessThan(0))
 *
 * assert.deepStrictEqual(isPositive(-1), false)
 * assert.deepStrictEqual(isPositive(0), true)
 * assert.deepStrictEqual(isPositive(1), true)
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const not = self => a => !self(a);
/**
 * Combines two predicates into a new predicate that returns `true` if at least one of the predicates returns `true`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Predicate, Number } from "effect"
 *
 * const nonZero = Predicate.or(Number.lessThan(0), Number.greaterThan(0))
 *
 * assert.deepStrictEqual(nonZero(-1), true)
 * assert.deepStrictEqual(nonZero(0), false)
 * assert.deepStrictEqual(nonZero(1), true)
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const or = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => a => self(a) || that(a))));
/**
 * Combines two predicates into a new predicate that returns `true` if both of the predicates returns `true`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Predicate } from "effect"
 *
 * const minLength = (n: number) => (s: string) => s.length >= n
 * const maxLength = (n: number) => (s: string) => s.length <= n
 *
 * const length = (n: number) => Predicate.and(minLength(n), maxLength(n))
 *
 * assert.deepStrictEqual(length(2)("aa"), true)
 * assert.deepStrictEqual(length(2)("a"), false)
 * assert.deepStrictEqual(length(2)("aaa"), false)
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const and = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => a => self(a) && that(a))));
/**
 * @category combinators
 * @since 2.0.0
 */
const xor = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => a => self(a) !== that(a))));
/**
 * @category combinators
 * @since 2.0.0
 */
const eqv = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => a => self(a) === that(a))));
/**
 * Represents the logical implication combinator for predicates. In formal
 * logic, the implication operator `->` denotes that if the first proposition
 * (antecedent) is true, then the second proposition (consequent) must also be
 * true. In simpler terms, `p implies q` can be interpreted as "if p then q". If
 * the first predicate holds, then the second predicate must hold
 * for the given context.
 *
 * In practical terms within TypeScript, `p implies q` is equivalent to `!p || (p && q)`.
 *
 * Note that if the antecedent is `false`, the result is `true` by default
 * because the outcome of the consequent cannot be determined.
 *
 * This function is useful in situations where you need to enforce rules or
 * constraints that are contingent on certain conditions.
 * It proves especially helpful in defining property tests.
 *
 * The example below illustrates the transitive property of order using the
 * `implies` function. In simple terms, if `a <= b` and `b <= c`, then `a <= c`
 * must be true.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Predicate } from "effect"
 *
 * type Triple = {
 *   readonly a: number
 *   readonly b: number
 *   readonly c: number
 * }
 *
 * const transitivity = Predicate.implies(
 *   // antecedent
 *   (input: Triple) => input.a <= input.b && input.b <= input.c,
 *   // consequent
 *   (input: Triple) => input.a <= input.c
 * )
 *
 * assert.equal(transitivity({ a: 1, b: 2, c: 3 }), true)
 * // antecedent is `false`, so the result is `true`
 * assert.equal(transitivity({ a: 1, b: 0, c: 0 }), true)
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const implies = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (antecedent, consequent) => a => antecedent(a) ? consequent(a) : true)));
/**
 * @category combinators
 * @since 2.0.0
 */
const nor = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => a => !(self(a) || that(a)))));
/**
 * @category combinators
 * @since 2.0.0
 */
const nand = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => a => !(self(a) && that(a)))));
/**
 * @category elements
 * @since 2.0.0
 */
const every = collection => a => {
  for (const p of collection) {
    if (!p(a)) {
      return false;
    }
  }
  return true;
};
/**
 * @category elements
 * @since 2.0.0
 */
const some = collection => a => {
  for (const p of collection) {
    if (p(a)) {
      return true;
    }
  }
  return false;
};
//# sourceMappingURL=Predicate.js.map

/***/ }),

/***/ 88005:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aC": function() { return /* binding */ TypeId; }
/* harmony export */ });
/* unused harmony exports isReadable, make, map, mapEffect, unwrap */
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92817);




/**
 * @since 2.0.0
 * @category type ids
 */
const TypeId = /*#__PURE__*/Symbol.for("effect/Readable");
/**
 * @since 2.0.0
 * @category refinements
 */
const isReadable = u => hasProperty(u, TypeId);
const Proto = {
  [TypeId]: TypeId,
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_0__/* .pipeArguments */ .n)(this, arguments);
  }
};
/**
 * @since 2.0.0
 * @category constructors
 */
const make = get => {
  const self = Object.create(Proto);
  self.get = get;
  return self;
};
/**
 * @since 2.0.0
 * @category combinators
 */
const map = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => make(core.map(self.get, f)))));
/**
 * @since 2.0.0
 * @category combinators
 */
const mapEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => make(core.flatMap(self.get, f)))));
/**
 * @since 2.0.0
 * @category constructors
 */
const unwrap = effect => make(core.flatMap(effect, s => s.get));
//# sourceMappingURL=Readable.js.map

/***/ }),

/***/ 53959:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G0": function() { return /* binding */ union; },
/* harmony export */   "Od": function() { return /* binding */ remove; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "V7": function() { return /* binding */ mapEntries; },
/* harmony export */   "Yz": function() { return /* binding */ toEntries; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "sG": function() { return /* binding */ isEmptyRecord; }
/* harmony export */ });
/* unused harmony exports empty, isEmptyReadonlyRecord, fromIterableWith, fromIterableBy, fromEntries, collect, size, has, get, modify, modifyOption, replaceOption, pop, mapKeys, filterMap, getSomes, getLefts, getRights, partitionMap, separate, partition, keys, values, set, replace, isSubrecordBy, isSubrecord, reduce, every, some, intersection, difference, getEquivalence, singleton */
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17316);
/**
 * This module provides utility functions for working with records in TypeScript.
 *
 * @since 2.0.0
 */




/**
 * Creates a new, empty record.
 *
 * @category constructors
 * @since 2.0.0
 */
const empty = () => ({});
/**
 * Determine if a record is empty.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isEmptyRecord } from "effect/Record"
 *
 * assert.deepStrictEqual(isEmptyRecord({}), true);
 * assert.deepStrictEqual(isEmptyRecord({ a: 3 }), false);
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isEmptyRecord = self => keys(self).length === 0;
/**
 * Determine if a record is empty.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { isEmptyReadonlyRecord } from "effect/Record"
 *
 * assert.deepStrictEqual(isEmptyReadonlyRecord({}), true);
 * assert.deepStrictEqual(isEmptyReadonlyRecord({ a: 3 }), false);
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isEmptyReadonlyRecord = (/* unused pure expression or super */ null && (isEmptyRecord));
/**
 * Takes an iterable and a projection function and returns a record.
 * The projection function maps each value of the iterable to a tuple of a key and a value, which is then added to the resulting record.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { fromIterableWith } from "effect/Record"
 *
 * const input = [1, 2, 3, 4]
 *
 * assert.deepStrictEqual(
 *   fromIterableWith(input, a => [String(a), a * 2]),
 *   { '1': 2, '2': 4, '3': 6, '4': 8 }
 * )
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const fromIterableWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  const out = empty();
  for (const a of self) {
    const [k, b] = f(a);
    out[k] = b;
  }
  return out;
})));
/**
 * Creates a new record from an iterable, utilizing the provided function to determine the key for each element.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { fromIterableBy } from "effect/Record"
 *
 * const users = [
 *   { id: "2", name: "name2" },
 *   { id: "1", name: "name1" }
 * ]
 *
 * assert.deepStrictEqual(
 *   fromIterableBy(users, user => user.id),
 *   {
 *     "2": { id: "2", name: "name2" },
 *     "1": { id: "1", name: "name1" }
 *   }
 * )
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const fromIterableBy = (items, f) => fromIterableWith(items, a => [f(a), a]);
/**
 * Builds a record from an iterable of key-value pairs.
 *
 * If there are conflicting keys when using `fromEntries`, the last occurrence of the key/value pair will overwrite the
 * previous ones. So the resulting record will only have the value of the last occurrence of each key.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { fromEntries } from "effect/Record"
 *
 * const input: Array<[string, number]> = [["a", 1], ["b", 2]]
 *
 * assert.deepStrictEqual(fromEntries(input), { a: 1, b: 2 })
 * ```
 *
 * @since 2.0.0
 * @category constructors
 */
const fromEntries = Object.fromEntries;
/**
 * Transforms the values of a record into an `Array` with a custom mapping function.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { collect } from "effect/Record"
 *
 * const x = { a: 1, b: 2, c: 3 }
 * assert.deepStrictEqual(collect(x, (key, n) => [key, n]), [["a", 1], ["b", 2], ["c", 3]])
 * ```
 *
 * @category conversions
 * @since 2.0.0
 */
const collect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, f) => {
  const out = [];
  for (const key of keys(self)) {
    out.push(f(key, self[key]));
  }
  return out;
});
/**
 * Takes a record and returns an array of tuples containing its keys and values.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { toEntries } from "effect/Record"
 *
 * const x = { a: 1, b: 2, c: 3 }
 * assert.deepStrictEqual(toEntries(x), [["a", 1], ["b", 2], ["c", 3]])
 * ```
 *
 * @category conversions
 * @since 2.0.0
 */
const toEntries = /*#__PURE__*/collect((key, value) => [key, value]);
/**
 * Returns the number of key/value pairs in a record.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { size } from "effect/Record";
 *
 * assert.deepStrictEqual(size({ a: "a", b: 1, c: true }), 3);
 * ```
 *
 * @since 2.0.0
 */
const size = self => keys(self).length;
/**
 * Check if a given `key` exists in a record.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { empty, has } from "effect/Record"
 *
 * assert.deepStrictEqual(has({ a: 1, b: 2 }, "a"), true);
 * assert.deepStrictEqual(has(empty<string>(), "c"), false);
 * ```
 *
 * @since 2.0.0
 */
const has = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, key) => Object.prototype.hasOwnProperty.call(self, key));
/**
 * Retrieve a value at a particular key from a record, returning it wrapped in an `Option`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Record as R, Option } from "effect"
 *
 * const person: Record<string, unknown> = { name: "John Doe", age: 35 }
 *
 * assert.deepStrictEqual(R.get(person, "name"), Option.some("John Doe"))
 * assert.deepStrictEqual(R.get(person, "email"), Option.none())
 * ```
 *
 * @since 2.0.0
 */
const get = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, key) => has(self, key) ? Option.some(self[key]) : Option.none())));
/**
 * Apply a function to the element at the specified key, creating a new record.
 * If the key does not exist, the record is returned unchanged.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Record as R } from "effect"
 *
 * const f = (x: number) => x * 2
 *
 * assert.deepStrictEqual(
 *  R.modify({ a: 3 }, 'a', f),
 *  { a: 6 }
 * )
 * assert.deepStrictEqual(
 *  R.modify({ a: 3 } as Record<string, number>, 'b', f),
 *  { a: 3 }
 * )
 * ```
 *
 * @since 2.0.0
 */
const modify = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, key, f) => {
  if (!has(self, key)) {
    return {
      ...self
    };
  }
  return {
    ...self,
    [key]: f(self[key])
  };
})));
/**
 * Apply a function to the element at the specified key, creating a new record,
 * or return `None` if the key doesn't exist.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Record as R, Option } from "effect"
 *
 * const f = (x: number) => x * 2
 *
 * assert.deepStrictEqual(
 *  R.modifyOption({ a: 3 }, 'a', f),
 *  Option.some({ a: 6 })
 * )
 * assert.deepStrictEqual(
 *  R.modifyOption({ a: 3 } as Record<string, number>, 'b', f),
 *  Option.none()
 * )
 * ```
 *
 * @since 2.0.0
 */
const modifyOption = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, key, f) => {
  if (!has(self, key)) {
    return Option.none();
  }
  return Option.some({
    ...self,
    [key]: f(self[key])
  });
})));
/**
 * Replaces a value in the record with the new value passed as parameter.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Record, Option } from "effect"
 *
 * assert.deepStrictEqual(
 *   Record.replaceOption({ a: 1, b: 2, c: 3 }, 'a', 10),
 *   Option.some({ a: 10, b: 2, c: 3 })
 * )
 * assert.deepStrictEqual(Record.replaceOption(Record.empty<string>(), 'a', 10), Option.none())
 * ```
 *
 * @since 2.0.0
 */
const replaceOption = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, key, b) => modifyOption(self, key, () => b))));
/**
 * If the given key exists in the record, returns a new record with the key removed,
 * otherwise returns a copy of the original record.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { remove } from "effect/Record"
 *
 * assert.deepStrictEqual(remove({ a: 1, b: 2 }, "a"), { b: 2 })
 * ```
 *
 * @since 2.0.0
 */
const remove = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, key) => {
  if (!has(self, key)) {
    return {
      ...self
    };
  }
  const out = {
    ...self
  };
  delete out[key];
  return out;
});
/**
 * Retrieves the value of the property with the given `key` from a record and returns an `Option`
 * of a tuple with the value and the record with the removed property.
 * If the key is not present, returns `O.none`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Record as R, Option } from "effect"
 *
 * assert.deepStrictEqual(R.pop({ a: 1, b: 2 }, "a"), Option.some([1, { b: 2 }]))
 * assert.deepStrictEqual(R.pop({ a: 1, b: 2 } as Record<string, number>, "c"), Option.none())
 * ```
 *
 * @category record
 * @since 2.0.0
 */
const pop = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, key) => has(self, key) ? Option.some([self[key], remove(self, key)]) : Option.none())));
/**
 * Maps a record into another record by applying a transformation function to each of its values.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { map } from "effect/Record"
 *
 * const f = (n: number) => `-${n}`
 *
 * assert.deepStrictEqual(map({ a: 3, b: 5 }, f), { a: "-3", b: "-5" })
 *
 * const g = (n: number, key: string) => `${key.toUpperCase()}-${n}`
 *
 * assert.deepStrictEqual(map({ a: 3, b: 5 }, g), { a: "A-3", b: "B-5" })
 * ```
 *
 * @category mapping
 * @since 2.0.0
 */
const map = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, f) => {
  const out = {
    ...self
  };
  for (const key of keys(self)) {
    out[key] = f(self[key], key);
  }
  return out;
});
/**
 * Maps the keys of a `ReadonlyRecord` while preserving the corresponding values.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { mapKeys } from "effect/Record"
 *
 * assert.deepStrictEqual(mapKeys({ a: 3, b: 5 }, (key) => key.toUpperCase()), { A: 3, B: 5 })
 * ```
 *
 * @category mapping
 * @since 2.0.0
 */
const mapKeys = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  const out = {};
  for (const key of keys(self)) {
    const a = self[key];
    out[f(key, a)] = a;
  }
  return out;
})));
/**
 * Maps entries of a `ReadonlyRecord` using the provided function, allowing modification of both keys and corresponding values.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { mapEntries } from "effect/Record"
 *
 * assert.deepStrictEqual(mapEntries({ a: 3, b: 5 }, (a, key) => [key.toUpperCase(), a + 1]), { A: 4, B: 6 })
 * ```
 *
 * @category mapping
 * @since 2.0.0
 */
const mapEntries = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, f) => {
  const out = {};
  for (const key of keys(self)) {
    const [k, b] = f(self[key], key);
    out[k] = b;
  }
  return out;
});
/**
 * Transforms a record into a record by applying the function `f` to each key and value in the original record.
 * If the function returns `Some`, the key-value pair is included in the output record.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Record, Option } from "effect"
 *
 * const x = { a: 1, b: 2, c: 3 }
 * const f = (a: number, key: string) => a > 2 ? Option.some(a * 2) : Option.none()
 * assert.deepStrictEqual(Record.filterMap(x, f), { c: 6 })
 * ```
 *
 * @since 2.0.0
 */
const filterMap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  const out = empty();
  for (const key of keys(self)) {
    const o = f(self[key], key);
    if (Option.isSome(o)) {
      out[key] = o.value;
    }
  }
  return out;
})));
/**
 * Selects properties from a record whose values match the given predicate.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { filter } from "effect/Record"
 *
 * const x = { a: 1, b: 2, c: 3, d: 4 }
 * assert.deepStrictEqual(filter(x, (n) => n > 2), { c: 3, d: 4 })
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const filter = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, predicate) => {
  const out = empty();
  for (const key of keys(self)) {
    if (predicate(self[key], key)) {
      out[key] = self[key];
    }
  }
  return out;
});
/**
 * Given a record with `Option` values, returns a new record containing only the `Some` values, preserving the original keys.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Record, Option } from "effect"
 *
 * assert.deepStrictEqual(
 *   Record.getSomes({ a: Option.some(1), b: Option.none(), c: Option.some(2) }),
 *   { a: 1, c: 2 }
 * )
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const getSomes = /*#__PURE__*/(/* unused pure expression or super */ null && (filterMap(identity)));
/**
 * Given a record with `Either` values, returns a new record containing only the `Left` values, preserving the original keys.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Record, Either } from "effect"
 *
 * assert.deepStrictEqual(
 *   Record.getLefts({ a: Either.right(1), b: Either.left("err"), c: Either.right(2) }),
 *   { b: "err" }
 * )
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const getLefts = self => {
  const out = empty();
  for (const key of keys(self)) {
    const value = self[key];
    if (E.isLeft(value)) {
      out[key] = value.left;
    }
  }
  return out;
};
/**
 * Given a record with `Either` values, returns a new record containing only the `Right` values, preserving the original keys.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Record, Either } from "effect"
 *
 * assert.deepStrictEqual(
 *   Record.getRights({ a: Either.right(1), b: Either.left("err"), c: Either.right(2) }),
 *   { a: 1, c: 2 }
 * )
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const getRights = self => {
  const out = empty();
  for (const key of keys(self)) {
    const value = self[key];
    if (E.isRight(value)) {
      out[key] = value.right;
    }
  }
  return out;
};
/**
 * Partitions the elements of a record into two groups: those that match a predicate, and those that don't.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Record, Either } from "effect"
 *
 * const x = { a: 1, b: 2, c: 3 }
 * const f = (n: number) => (n % 2 === 0 ? Either.right(n) : Either.left(n))
 * assert.deepStrictEqual(Record.partitionMap(x, f), [{ a: 1, c: 3 }, { b: 2}])
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const partitionMap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  const left = empty();
  const right = empty();
  for (const key of keys(self)) {
    const e = f(self[key], key);
    if (E.isLeft(e)) {
      left[key] = e.left;
    } else {
      right[key] = e.right;
    }
  }
  return [left, right];
})));
/**
 * Partitions a record of `Either` values into two separate records,
 * one with the `Left` values and one with the `Right` values.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Record, Either } from "effect"
 *
 * assert.deepStrictEqual(
 *   Record.separate({ a: Either.left("e"), b: Either.right(1) }),
 *   [{ a: "e" }, { b: 1 }]
 * )
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const separate = /*#__PURE__*/(/* unused pure expression or super */ null && (partitionMap(identity)));
/**
 * Partitions a record into two separate records based on the result of a predicate function.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { partition } from "effect/Record"
 *
 * assert.deepStrictEqual(
 *   partition({ a: 1, b: 3 }, (n) => n > 2),
 *   [{ a: 1 }, { b: 3 }]
 * )
 * ```
 *
 * @category filtering
 * @since 2.0.0
 */
const partition = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => {
  const left = empty();
  const right = empty();
  for (const key of keys(self)) {
    if (predicate(self[key], key)) {
      right[key] = self[key];
    } else {
      left[key] = self[key];
    }
  }
  return [left, right];
})));
/**
 * Retrieve the keys of a given record as an array.
 *
 * @since 2.0.0
 */
const keys = self => Object.keys(self);
/**
 * Retrieve the values of a given record as an array.
 *
 * @since 2.0.0
 */
const values = self => collect(self, (_, a) => a);
/**
 * Add a new key-value pair or update an existing key's value in a record.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { set } from "effect/Record"
 *
 * assert.deepStrictEqual(set("a", 5)({ a: 1, b: 2 }), { a: 5, b: 2 });
 * assert.deepStrictEqual(set("c", 5)({ a: 1, b: 2 }), { a: 1, b: 2, c: 5 });
 * ```
 *
 * @since 2.0.0
 */
const set = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, key, value) => {
  return {
    ...self,
    [key]: value
  };
})));
/**
 * Replace a key's value in a record and return the updated record.
 * If the key does not exist in the record, a copy of the original record is returned.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Record } from "effect"
 *
 * assert.deepStrictEqual(Record.replace("a", 3)({ a: 1, b: 2 }), { a: 3, b: 2 });
 * assert.deepStrictEqual(Record.replace("c", 3)({ a: 1, b: 2 }), { a: 1, b: 2 });
 * ```
 *
 * @since 2.0.0
 */
const replace = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, key, value) => {
  if (has(self, key)) {
    return {
      ...self,
      [key]: value
    };
  }
  return {
    ...self
  };
})));
/**
 * Check if all the keys and values in one record are also found in another record.
 *
 * @since 2.0.0
 */
const isSubrecordBy = equivalence => dual(2, (self, that) => {
  for (const key of keys(self)) {
    if (!has(that, key) || !equivalence(self[key], that[key])) {
      return false;
    }
  }
  return true;
});
/**
 * Check if one record is a subrecord of another, meaning it contains all the keys and values found in the second record.
 * This comparison uses default equality checks (`Equal.equivalence()`).
 *
 * @since 2.0.0
 */
const isSubrecord = /*#__PURE__*/(/* unused pure expression or super */ null && (isSubrecordBy( /*#__PURE__*/Equal.equivalence())));
/**
 * Reduce a record to a single value by combining its entries with a specified function.
 *
 * @category folding
 * @since 2.0.0
 */
const reduce = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, zero, f) => {
  let out = zero;
  for (const key of keys(self)) {
    out = f(out, self[key], key);
  }
  return out;
})));
/**
 * Check if all entries in a record meet a specific condition.
 *
 * @since 2.0.0
 */
const every = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, refinement) => {
  for (const key of keys(self)) {
    if (!refinement(self[key], key)) {
      return false;
    }
  }
  return true;
})));
/**
 * Check if any entry in a record meets a specific condition.
 *
 * @since 2.0.0
 */
const some = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, predicate) => {
  for (const key of keys(self)) {
    if (predicate(self[key], key)) {
      return true;
    }
  }
  return false;
})));
/**
 * Merge two records, preserving entries that exist in either of the records.
 *
 * @since 2.0.0
 */
const union = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(3, (self, that, combine) => {
  if (isEmptyRecord(self)) {
    return {
      ...that
    };
  }
  if (isEmptyRecord(that)) {
    return {
      ...self
    };
  }
  const out = empty();
  for (const key of keys(self)) {
    if (has(that, key)) {
      out[key] = combine(self[key], that[key]);
    } else {
      out[key] = self[key];
    }
  }
  for (const key of keys(that)) {
    if (!has(out, key)) {
      out[key] = that[key];
    }
  }
  return out;
});
/**
 * Merge two records, retaining only the entries that exist in both records.
 *
 * @since 2.0.0
 */
const intersection = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, that, combine) => {
  const out = empty();
  if (isEmptyRecord(self) || isEmptyRecord(that)) {
    return out;
  }
  for (const key of keys(self)) {
    if (has(that, key)) {
      out[key] = combine(self[key], that[key]);
    }
  }
  return out;
})));
/**
 * Merge two records, preserving only the entries that are unique to each record.
 *
 * @since 2.0.0
 */
const difference = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => {
  if (isEmptyRecord(self)) {
    return {
      ...that
    };
  }
  if (isEmptyRecord(that)) {
    return {
      ...self
    };
  }
  const out = {};
  for (const key of keys(self)) {
    if (!has(that, key)) {
      out[key] = self[key];
    }
  }
  for (const key of keys(that)) {
    if (!has(self, key)) {
      out[key] = that[key];
    }
  }
  return out;
})));
/**
 * Create an `Equivalence` for records using the provided `Equivalence` for values.
 *
 * @category instances
 * @since 2.0.0
 */
const getEquivalence = equivalence => {
  const is = isSubrecordBy(equivalence);
  return (self, that) => is(self, that) && is(that, self);
};
/**
 * Create a non-empty record from a single element.
 *
 * @category constructors
 * @since 2.0.0
 */
const singleton = (key, value) => ({
  [key]: value
});
//# sourceMappingURL=Record.js.map

/***/ }),

/***/ 2532:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pj": function() { return /* binding */ modify; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "Vx": function() { return /* binding */ update; },
/* harmony export */   "yO": function() { return /* binding */ getAndSet; }
/* harmony export */ });
/* unused harmony exports RefTypeId, getAndUpdate, getAndUpdateSome, modifySome, set, setAndGet, updateAndGet, updateSome, updateSomeAndGet, unsafeMake */
/* harmony import */ var _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7411);

/**
 * @since 2.0.0
 * @category symbols
 */
const RefTypeId = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .RefTypeId */ .n7;
/**
 * @since 2.0.0
 * @category constructors
 */
const make = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy;
/**
 * @since 2.0.0
 * @category getters
 */
const get = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2;
/**
 * @since 2.0.0
 * @category utils
 */
const getAndSet = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .getAndSet */ .yO;
/**
 * @since 2.0.0
 * @category utils
 */
const getAndUpdate = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .getAndUpdate */ .CX;
/**
 * @since 2.0.0
 * @category utils
 */
const getAndUpdateSome = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .getAndUpdateSome */ .HC;
/**
 * @since 2.0.0
 * @category utils
 */
const modify = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .modify */ .Pj;
/**
 * @since 2.0.0
 * @category utils
 */
const modifySome = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .modifySome */ .Of;
/**
 * @since 2.0.0
 * @category utils
 */
const set = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .set */ .t8;
/**
 * @since 2.0.0
 * @category utils
 */
const setAndGet = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .setAndGet */ .Dg;
/**
 * @since 2.0.0
 * @category utils
 */
const update = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .update */ .Vx;
/**
 * @since 2.0.0
 * @category utils
 */
const updateAndGet = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .updateAndGet */ .J5;
/**
 * @since 2.0.0
 * @category utils
 */
const updateSome = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSome */ .nZ;
/**
 * @since 2.0.0
 * @category utils
 */
const updateSomeAndGet = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSomeAndGet */ .NY;
/**
 * @since 2.0.0
 * @category unsafe
 */
const unsafeMake = _internal_ref_js__WEBPACK_IMPORTED_MODULE_0__/* .unsafeMake */ .t0;
//# sourceMappingURL=Ref.js.map

/***/ }),

/***/ 7035:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ escape; }
/* harmony export */ });
/* unused harmony export isRegExp */
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71335);
/**
 * This module provides utility functions for working with RegExp in TypeScript.
 *
 * @since 2.0.0
 */

/**
 * Tests if a value is a `RegExp`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { RegExp } from "effect"
 *
 * assert.deepStrictEqual(RegExp.isRegExp(/a/), true)
 * assert.deepStrictEqual(RegExp.isRegExp("a"), false)
 * ```
 *
 * @category guards
 * @since 3.9.0
 */
const isRegExp = _Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj;
/**
 * Escapes special characters in a regular expression pattern.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { RegExp } from "effect"
 *
 * assert.deepStrictEqual(RegExp.escape("a*b"), "a\\*b")
 * ```
 *
 * @since 2.0.0
 */
const escape = string => string.replace(/[/\\^$*+?.()|[\]{}]/g, "\\$&");
//# sourceMappingURL=RegExp.js.map

/***/ }),

/***/ 26045:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "De": function() { return /* binding */ exclude; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "h$": function() { return /* binding */ disable; },
/* harmony export */   "wp": function() { return /* binding */ enable; }
/* harmony export */ });
/* unused harmony exports make, isEmpty, isActive, isEnabled, isDisabled, includes, andThen, both, either, inverse, enabledSet, disabledSet, render */
/* harmony import */ var _internal_runtimeFlags_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4536);
/* harmony import */ var _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43886);
/**
 * @since 2.0.0
 */


/**
 * The empty `RuntimeFlagsPatch`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .empty */ .cS;
/**
 * @since 2.0.0
 * @category constructors
 */
const make = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy;
/**
 * Creates a `RuntimeFlagsPatch` describing enabling the provided `RuntimeFlag`.
 *
 * @since 2.0.0
 * @category constructors
 */
const enable = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .enable */ .wp;
/**
 * Creates a `RuntimeFlagsPatch` describing disabling the provided `RuntimeFlag`.
 *
 * @since 2.0.0
 * @category constructors
 */
const disable = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .disable */ .h$;
/**
 * Returns `true` if the specified `RuntimeFlagsPatch` is empty.
 *
 * @since 2.0.0
 * @category getters
 */
const isEmpty = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .isEmpty */ .xb;
/**
 * Returns `true` if the `RuntimeFlagsPatch` describes the specified
 * `RuntimeFlag` as active.
 *
 * @since 2.0.0
 * @category elements
 */
const isActive = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .isActive */ .zh;
/**
 * Returns `true` if the `RuntimeFlagsPatch` describes the specified
 * `RuntimeFlag` as enabled.
 *
 * @since 2.0.0
 * @category elements
 */
const isEnabled = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .isEnabled */ ._k;
/**
 * Returns `true` if the `RuntimeFlagsPatch` describes the specified
 * `RuntimeFlag` as disabled.
 *
 * @since 2.0.0
 * @category elements
 */
const isDisabled = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .isDisabled */ .pK;
/**
 * Returns `true` if the `RuntimeFlagsPatch` includes the specified
 * `RuntimeFlag`, `false` otherwise.
 *
 * @since 2.0.0
 * @category elements
 */
const includes = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .isActive */ .zh;
/**
 * Creates a `RuntimeFlagsPatch` describing the application of the `self` patch,
 * followed by `that` patch.
 *
 * @since 2.0.0
 * @category utils
 */
const andThen = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .andThen */ .Po;
/**
 * Creates a `RuntimeFlagsPatch` describing application of both the `self` patch
 * and `that` patch.
 *
 * @since 2.0.0
 * @category utils
 */
const both = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .both */ .Hk;
/**
 * Creates a `RuntimeFlagsPatch` describing application of either the `self`
 * patch or `that` patch.
 *
 * @since 2.0.0
 * @category utils
 */
const either = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .either */ .wE;
/**
 * Creates a `RuntimeFlagsPatch` which describes exclusion of the specified
 * `RuntimeFlag` from the set of `RuntimeFlags`.
 *
 * @category utils
 * @since 2.0.0
 */
const exclude = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .exclude */ .De;
/**
 * Creates a `RuntimeFlagsPatch` which describes the inverse of the patch
 * specified by the provided `RuntimeFlagsPatch`.
 *
 * @since 2.0.0
 * @category utils
 */
const inverse = _internal_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_0__/* .inverse */ .SO;
/**
 * Returns a `ReadonlySet<number>` containing the `RuntimeFlags` described as
 * enabled by the specified `RuntimeFlagsPatch`.
 *
 * @since 2.0.0
 * @category destructors
 */
const enabledSet = _internal_runtimeFlags_js__WEBPACK_IMPORTED_MODULE_1__/* .enabledSet */ .Q6;
/**
 * Returns a `ReadonlySet<number>` containing the `RuntimeFlags` described as
 * disabled by the specified `RuntimeFlagsPatch`.
 *
 * @since 2.0.0
 * @category destructors
 */
const disabledSet = _internal_runtimeFlags_js__WEBPACK_IMPORTED_MODULE_1__/* .disabledSet */ .Wu;
/**
 * Renders the provided `RuntimeFlagsPatch` to a string.
 *
 * @since 2.0.0
 * @category destructors
 */
const render = _internal_runtimeFlags_js__WEBPACK_IMPORTED_MODULE_1__/* .renderPatch */ .yI;
//# sourceMappingURL=RuntimeFlagsPatch.js.map

/***/ }),

/***/ 82429:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jx": function() { return /* binding */ ScheduleDecision_continue; },
  "y3": function() { return /* binding */ ScheduleDecision_continueWith; },
  "aT": function() { return /* binding */ ScheduleDecision_done; },
  "Jg": function() { return /* binding */ ScheduleDecision_isContinue; },
  "_b": function() { return /* binding */ ScheduleDecision_isDone; }
});

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Chunk.js
var Chunk = __webpack_require__(14109);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/ScheduleIntervals.js + 1 modules
var ScheduleIntervals = __webpack_require__(75313);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/schedule/decision.js


/** @internal */
const OP_CONTINUE = "Continue";
/** @internal */
const OP_DONE = "Done";
/** @internal */
const _continue = intervals => {
  return {
    _tag: OP_CONTINUE,
    intervals
  };
};
/** @internal */
const continueWith = interval => {
  return {
    _tag: OP_CONTINUE,
    intervals: ScheduleIntervals/* make */.Sy(Chunk.of(interval))
  };
};
/** @internal */
const done = {
  _tag: OP_DONE
};
/** @internal */
const isContinue = self => {
  return self._tag === OP_CONTINUE;
};
/** @internal */
const isDone = self => {
  return self._tag === OP_DONE;
};
//# sourceMappingURL=decision.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/ScheduleDecision.js
/**
 * @since 2.0.0
 */

const ScheduleDecision_continue = _continue;

/**
 * @since 2.0.0
 * @category constructors
 */
const ScheduleDecision_continueWith = continueWith;
/**
 * @since 2.0.0
 * @category constructors
 */
const ScheduleDecision_done = done;
/**
 * @since 2.0.0
 * @category refinements
 */
const ScheduleDecision_isContinue = isContinue;
/**
 * @since 2.0.0
 * @category refinements
 */
const ScheduleDecision_isDone = isDone;
//# sourceMappingURL=ScheduleDecision.js.map

/***/ }),

/***/ 51286:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e4": function() { return /* binding */ ScheduleInterval_after; },
  "cS": function() { return /* binding */ ScheduleInterval_empty; },
  "wf": function() { return /* binding */ ScheduleInterval_intersect; },
  "xb": function() { return /* binding */ ScheduleInterval_isEmpty; },
  "Qj": function() { return /* binding */ ScheduleInterval_lessThan; },
  "Sy": function() { return /* binding */ ScheduleInterval_make; }
});

// UNUSED EXPORTS: IntervalTypeId, before, isNonEmpty, max, min, size, union

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Duration.js
var Duration = __webpack_require__(13571);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var Option = __webpack_require__(16749);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/schedule/interval.js



/** @internal */
const IntervalSymbolKey = "effect/ScheduleInterval";
/** @internal */
const IntervalTypeId = /*#__PURE__*/Symbol.for(IntervalSymbolKey);
/** @internal */
const empty = {
  [IntervalTypeId]: IntervalTypeId,
  startMillis: 0,
  endMillis: 0
};
/** @internal */
const make = (startMillis, endMillis) => {
  if (startMillis > endMillis) {
    return empty;
  }
  return {
    [IntervalTypeId]: IntervalTypeId,
    startMillis,
    endMillis
  };
};
/** @internal */
const lessThan = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => min(self, that) === self);
/** @internal */
const min = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => {
  if (self.endMillis <= that.startMillis) return self;
  if (that.endMillis <= self.startMillis) return that;
  if (self.startMillis < that.startMillis) return self;
  if (that.startMillis < self.startMillis) return that;
  if (self.endMillis <= that.endMillis) return self;
  return that;
});
/** @internal */
const max = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => min(self, that) === self ? that : self);
/** @internal */
const isEmpty = self => {
  return self.startMillis >= self.endMillis;
};
/** @internal */
const isNonEmpty = self => {
  return !isEmpty(self);
};
/** @internal */
const intersect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => {
  const start = Math.max(self.startMillis, that.startMillis);
  const end = Math.min(self.endMillis, that.endMillis);
  return make(start, end);
});
/** @internal */
const size = self => {
  return Duration/* millis */.YX(self.endMillis - self.startMillis);
};
/** @internal */
const union = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => {
  const start = Math.max(self.startMillis, that.startMillis);
  const end = Math.min(self.endMillis, that.endMillis);
  return start < end ? Option/* none */.YP() : Option/* some */.G(make(start, end));
});
/** @internal */
const after = startMilliseconds => {
  return make(startMilliseconds, Number.POSITIVE_INFINITY);
};
/** @internal */
const before = endMilliseconds => {
  return make(Number.NEGATIVE_INFINITY, endMilliseconds);
};
//# sourceMappingURL=interval.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/ScheduleInterval.js

/**
 * @since 2.0.0
 * @category symbols
 */
const ScheduleInterval_IntervalTypeId = IntervalTypeId;
/**
 * Constructs a new interval from the two specified endpoints. If the start
 * endpoint greater than the end endpoint, then a zero size interval will be
 * returned.
 *
 * @since 2.0.0
 * @category constructors
 */
const ScheduleInterval_make = make;
/**
 * An `Interval` of zero-width.
 *
 * @since 2.0.0
 * @category constructors
 */
const ScheduleInterval_empty = empty;
/**
 * Returns `true` if this `Interval` is less than `that` interval, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category ordering
 */
const ScheduleInterval_lessThan = lessThan;
/**
 * Returns the minimum of two `Interval`s.
 *
 * @since 2.0.0
 * @category ordering
 */
const ScheduleInterval_min = min;
/**
 * Returns the maximum of two `Interval`s.
 *
 * @since 2.0.0
 * @category ordering
 */
const ScheduleInterval_max = max;
/**
 * Returns `true` if the specified `Interval` is empty, `false` otherwise.
 *
 * @since 2.0.0
 * @category ordering
 */
const ScheduleInterval_isEmpty = isEmpty;
/**
 * Returns `true` if the specified `Interval` is non-empty, `false` otherwise.
 *
 * @since 2.0.0
 * @category ordering
 */
const ScheduleInterval_isNonEmpty = isNonEmpty;
/**
 * Computes a new `Interval` which is the intersection of this `Interval` and
 * that `Interval`.
 *
 * @since 2.0.0
 * @category ordering
 */
const ScheduleInterval_intersect = intersect;
/**
 * Calculates the size of the `Interval` as the `Duration` from the start of the
 * interval to the end of the interval.
 *
 * @since 2.0.0
 * @category getters
 */
const ScheduleInterval_size = size;
/**
 * Computes a new `Interval` which is the union of this `Interval` and that
 * `Interval` as a `Some`, otherwise returns `None` if the two intervals cannot
 * form a union.
 *
 * @since 2.0.0
 * @category utils
 */
const ScheduleInterval_union = union;
/**
 * Construct an `Interval` that includes all time equal to and after the
 * specified start time.
 *
 * @since 2.0.0
 * @category constructors
 */
const ScheduleInterval_after = after;
/**
 * Construct an `Interval` that includes all time equal to and before the
 * specified end time.
 *
 * @category constructors
 * @since 2.0.0
 */
const ScheduleInterval_before = before;
//# sourceMappingURL=ScheduleInterval.js.map

/***/ }),

/***/ 75313:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ut": function() { return /* binding */ ScheduleIntervals_end; },
  "wf": function() { return /* binding */ ScheduleIntervals_intersect; },
  "Od": function() { return /* binding */ ScheduleIntervals_isNonEmpty; },
  "Qj": function() { return /* binding */ ScheduleIntervals_lessThan; },
  "Sy": function() { return /* binding */ ScheduleIntervals_make; },
  "BL": function() { return /* binding */ ScheduleIntervals_start; }
});

// UNUSED EXPORTS: IntervalsTypeId, empty, fromIterable, max, union

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Chunk.js
var Chunk = __webpack_require__(14109);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/ScheduleInterval.js + 1 modules
var ScheduleInterval = __webpack_require__(51286);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/errors.js
var errors = __webpack_require__(3910);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/schedule/intervals.js





/** @internal */
const IntervalsSymbolKey = "effect/ScheduleIntervals";
/** @internal */
const IntervalsTypeId = /*#__PURE__*/Symbol.for(IntervalsSymbolKey);
/** @internal */
const make = intervals => {
  return {
    [IntervalsTypeId]: IntervalsTypeId,
    intervals
  };
};
/** @internal */
const empty = /*#__PURE__*/make( /*#__PURE__*/Chunk/* empty */.cS());
/** @internal */
const fromIterable = intervals => Array.from(intervals).reduce((intervals, interval) => (0,Function/* pipe */.zG)(intervals, union(make(Chunk.of(interval)))), empty);
/** @internal */
const union = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => {
  if (!Chunk/* isNonEmpty */.Od(that.intervals)) {
    return self;
  }
  if (!Chunk/* isNonEmpty */.Od(self.intervals)) {
    return that;
  }
  if (Chunk/* headNonEmpty */.dK(self.intervals).startMillis < Chunk/* headNonEmpty */.dK(that.intervals).startMillis) {
    return unionLoop(Chunk/* tailNonEmpty */.fm(self.intervals), that.intervals, Chunk/* headNonEmpty */.dK(self.intervals), Chunk/* empty */.cS());
  }
  return unionLoop(self.intervals, Chunk/* tailNonEmpty */.fm(that.intervals), Chunk/* headNonEmpty */.dK(that.intervals), Chunk/* empty */.cS());
});
/** @internal */
const unionLoop = (_self, _that, _interval, _acc) => {
  let self = _self;
  let that = _that;
  let interval = _interval;
  let acc = _acc;
  while (Chunk/* isNonEmpty */.Od(self) || Chunk/* isNonEmpty */.Od(that)) {
    if (!Chunk/* isNonEmpty */.Od(self) && Chunk/* isNonEmpty */.Od(that)) {
      if (interval.endMillis < Chunk/* headNonEmpty */.dK(that).startMillis) {
        acc = (0,Function/* pipe */.zG)(acc, Chunk/* prepend */.Ce(interval));
        interval = Chunk/* headNonEmpty */.dK(that);
        that = Chunk/* tailNonEmpty */.fm(that);
        self = Chunk/* empty */.cS();
      } else {
        interval = ScheduleInterval/* make */.Sy(interval.startMillis, Chunk/* headNonEmpty */.dK(that).endMillis);
        that = Chunk/* tailNonEmpty */.fm(that);
        self = Chunk/* empty */.cS();
      }
    } else if (Chunk/* isNonEmpty */.Od(self) && Chunk/* isEmpty */.xb(that)) {
      if (interval.endMillis < Chunk/* headNonEmpty */.dK(self).startMillis) {
        acc = (0,Function/* pipe */.zG)(acc, Chunk/* prepend */.Ce(interval));
        interval = Chunk/* headNonEmpty */.dK(self);
        that = Chunk/* empty */.cS();
        self = Chunk/* tailNonEmpty */.fm(self);
      } else {
        interval = ScheduleInterval/* make */.Sy(interval.startMillis, Chunk/* headNonEmpty */.dK(self).endMillis);
        that = Chunk/* empty */.cS();
        self = Chunk/* tailNonEmpty */.fm(self);
      }
    } else if (Chunk/* isNonEmpty */.Od(self) && Chunk/* isNonEmpty */.Od(that)) {
      if (Chunk/* headNonEmpty */.dK(self).startMillis < Chunk/* headNonEmpty */.dK(that).startMillis) {
        if (interval.endMillis < Chunk/* headNonEmpty */.dK(self).startMillis) {
          acc = (0,Function/* pipe */.zG)(acc, Chunk/* prepend */.Ce(interval));
          interval = Chunk/* headNonEmpty */.dK(self);
          self = Chunk/* tailNonEmpty */.fm(self);
        } else {
          interval = ScheduleInterval/* make */.Sy(interval.startMillis, Chunk/* headNonEmpty */.dK(self).endMillis);
          self = Chunk/* tailNonEmpty */.fm(self);
        }
      } else if (interval.endMillis < Chunk/* headNonEmpty */.dK(that).startMillis) {
        acc = (0,Function/* pipe */.zG)(acc, Chunk/* prepend */.Ce(interval));
        interval = Chunk/* headNonEmpty */.dK(that);
        that = Chunk/* tailNonEmpty */.fm(that);
      } else {
        interval = ScheduleInterval/* make */.Sy(interval.startMillis, Chunk/* headNonEmpty */.dK(that).endMillis);
        that = Chunk/* tailNonEmpty */.fm(that);
      }
    } else {
      throw new Error((0,errors/* getBugErrorMessage */.s)("Intervals.unionLoop"));
    }
  }
  return make((0,Function/* pipe */.zG)(acc, Chunk/* prepend */.Ce(interval), Chunk/* reverse */.GY));
};
/** @internal */
const intersect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => intersectLoop(self.intervals, that.intervals, Chunk/* empty */.cS()));
/** @internal */
const intersectLoop = (_left, _right, _acc) => {
  let left = _left;
  let right = _right;
  let acc = _acc;
  while (Chunk/* isNonEmpty */.Od(left) && Chunk/* isNonEmpty */.Od(right)) {
    const interval = (0,Function/* pipe */.zG)(Chunk/* headNonEmpty */.dK(left), ScheduleInterval/* intersect */.wf(Chunk/* headNonEmpty */.dK(right)));
    const intervals = ScheduleInterval/* isEmpty */.xb(interval) ? acc : (0,Function/* pipe */.zG)(acc, Chunk/* prepend */.Ce(interval));
    if ((0,Function/* pipe */.zG)(Chunk/* headNonEmpty */.dK(left), ScheduleInterval/* lessThan */.Qj(Chunk/* headNonEmpty */.dK(right)))) {
      left = Chunk/* tailNonEmpty */.fm(left);
    } else {
      right = Chunk/* tailNonEmpty */.fm(right);
    }
    acc = intervals;
  }
  return make(Chunk/* reverse */.GY(acc));
};
/** @internal */
const start = self => {
  return (0,Function/* pipe */.zG)(self.intervals, Chunk/* head */.YM, Option/* getOrElse */.fS(() => ScheduleInterval/* empty */.cS)).startMillis;
};
/** @internal */
const end = self => {
  return (0,Function/* pipe */.zG)(self.intervals, Chunk/* head */.YM, Option/* getOrElse */.fS(() => ScheduleInterval/* empty */.cS)).endMillis;
};
/** @internal */
const lessThan = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => start(self) < start(that));
/** @internal */
const isNonEmpty = self => {
  return Chunk/* isNonEmpty */.Od(self.intervals);
};
/** @internal */
const max = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => lessThan(self, that) ? that : self);
//# sourceMappingURL=intervals.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/ScheduleIntervals.js

/**
 * @since 2.0.0
 * @category symbols
 */
const ScheduleIntervals_IntervalsTypeId = IntervalsTypeId;
/**
 * Creates a new `Intervals` from a `List` of `Interval`s.
 *
 * @since 2.0.0
 * @category constructors
 */
const ScheduleIntervals_make = make;
/**
 * Constructs an empty list of `Interval`s.
 *
 * @since 2.0.0
 * @category constructors
 */
const ScheduleIntervals_empty = empty;
/**
 * Creates `Intervals` from the specified `Iterable<Interval>`.
 *
 * @since 2.0.0
 * @category constructors
 */
const ScheduleIntervals_fromIterable = fromIterable;
/**
 * Computes the union of this `Intervals` and  that `Intervals`
 *
 * @since 2.0.0
 * @category utils
 */
const ScheduleIntervals_union = union;
/**
 * Produces the intersection of this `Intervals` and that `Intervals`.
 *
 * @since 2.0.0
 * @category utils
 */
const ScheduleIntervals_intersect = intersect;
/**
 * The start of the earliest interval in the specified `Intervals`.
 *
 * @since 2.0.0
 * @category getters
 */
const ScheduleIntervals_start = start;
/**
 * The end of the latest interval in the specified `Intervals`.
 *
 * @since 2.0.0
 * @category getters
 */
const ScheduleIntervals_end = end;
/**
 * Returns `true` if the start of this `Intervals` is before the start of that
 * `Intervals`, `false` otherwise.
 *
 * @since 2.0.0
 * @category ordering
 */
const ScheduleIntervals_lessThan = lessThan;
/**
 * Returns `true` if this `Intervals` is non-empty, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const ScheduleIntervals_isNonEmpty = isNonEmpty;
/**
 * Returns the maximum of the two `Intervals` (i.e. which has the latest start).
 *
 * @since 2.0.0
 * @category ordering
 */
const ScheduleIntervals_max = max;
//# sourceMappingURL=ScheduleIntervals.js.map

/***/ }),

/***/ 22019:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ SyncScheduler; },
/* harmony export */   "ez": function() { return /* binding */ withScheduler; },
/* harmony export */   "xt": function() { return /* binding */ currentScheduler; }
/* harmony export */ });
/* unused harmony exports PriorityBuckets, MixedScheduler, defaultScheduler, ControlledScheduler, makeMatrix, defaultShouldYield, make, makeBatched, timer, timerBatched */
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17316);
/* harmony import */ var _GlobalValue_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4726);
/* harmony import */ var _internal_core_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39355);
/**
 * @since 2.0.0
 */



/**
 * @since 2.0.0
 * @category utils
 */
class PriorityBuckets {
  /**
   * @since 2.0.0
   */
  buckets = [];
  /**
   * @since 2.0.0
   */
  scheduleTask(task, priority) {
    const length = this.buckets.length;
    let bucket = undefined;
    let index = 0;
    for (; index < length; index++) {
      if (this.buckets[index][0] <= priority) {
        bucket = this.buckets[index];
      } else {
        break;
      }
    }
    if (bucket && bucket[0] === priority) {
      bucket[1].push(task);
    } else if (index === length) {
      this.buckets.push([priority, [task]]);
    } else {
      this.buckets.splice(index, 0, [priority, [task]]);
    }
  }
}
/**
 * @since 2.0.0
 * @category constructors
 */
class MixedScheduler {
  maxNextTickBeforeTimer;
  /**
   * @since 2.0.0
   */
  running = false;
  /**
   * @since 2.0.0
   */
  tasks = /*#__PURE__*/new PriorityBuckets();
  constructor(
  /**
   * @since 2.0.0
   */
  maxNextTickBeforeTimer) {
    this.maxNextTickBeforeTimer = maxNextTickBeforeTimer;
  }
  /**
   * @since 2.0.0
   */
  starveInternal(depth) {
    const tasks = this.tasks.buckets;
    this.tasks.buckets = [];
    for (const [_, toRun] of tasks) {
      for (let i = 0; i < toRun.length; i++) {
        toRun[i]();
      }
    }
    if (this.tasks.buckets.length === 0) {
      this.running = false;
    } else {
      this.starve(depth);
    }
  }
  /**
   * @since 2.0.0
   */
  starve(depth = 0) {
    if (depth >= this.maxNextTickBeforeTimer) {
      setTimeout(() => this.starveInternal(0), 0);
    } else {
      Promise.resolve(void 0).then(() => this.starveInternal(depth + 1));
    }
  }
  /**
   * @since 2.0.0
   */
  shouldYield(fiber) {
    return fiber.currentOpCount > fiber.getFiberRef(_internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .currentMaxOpsBeforeYield */ .Of7) ? fiber.getFiberRef(_internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .currentSchedulingPriority */ .opO) : false;
  }
  /**
   * @since 2.0.0
   */
  scheduleTask(task, priority) {
    this.tasks.scheduleTask(task, priority);
    if (!this.running) {
      this.running = true;
      this.starve();
    }
  }
}
/**
 * @since 2.0.0
 * @category schedulers
 */
const defaultScheduler = /*#__PURE__*/(0,_GlobalValue_js__WEBPACK_IMPORTED_MODULE_1__/* .globalValue */ .K)( /*#__PURE__*/Symbol.for("effect/Scheduler/defaultScheduler"), () => new MixedScheduler(2048));
/**
 * @since 2.0.0
 * @category constructors
 */
class SyncScheduler {
  /**
   * @since 2.0.0
   */
  tasks = /*#__PURE__*/new PriorityBuckets();
  /**
   * @since 2.0.0
   */
  deferred = false;
  /**
   * @since 2.0.0
   */
  scheduleTask(task, priority) {
    if (this.deferred) {
      defaultScheduler.scheduleTask(task, priority);
    } else {
      this.tasks.scheduleTask(task, priority);
    }
  }
  /**
   * @since 2.0.0
   */
  shouldYield(fiber) {
    return fiber.currentOpCount > fiber.getFiberRef(_internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .currentMaxOpsBeforeYield */ .Of7) ? fiber.getFiberRef(_internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .currentSchedulingPriority */ .opO) : false;
  }
  /**
   * @since 2.0.0
   */
  flush() {
    while (this.tasks.buckets.length > 0) {
      const tasks = this.tasks.buckets;
      this.tasks.buckets = [];
      for (const [_, toRun] of tasks) {
        for (let i = 0; i < toRun.length; i++) {
          toRun[i]();
        }
      }
    }
    this.deferred = true;
  }
}
/**
 * @since 2.0.0
 * @category constructors
 */
class ControlledScheduler {
  /**
   * @since 2.0.0
   */
  tasks = /*#__PURE__*/new PriorityBuckets();
  /**
   * @since 2.0.0
   */
  deferred = false;
  /**
   * @since 2.0.0
   */
  scheduleTask(task, priority) {
    if (this.deferred) {
      defaultScheduler.scheduleTask(task, priority);
    } else {
      this.tasks.scheduleTask(task, priority);
    }
  }
  /**
   * @since 2.0.0
   */
  shouldYield(fiber) {
    return fiber.currentOpCount > fiber.getFiberRef(core.currentMaxOpsBeforeYield) ? fiber.getFiberRef(core.currentSchedulingPriority) : false;
  }
  /**
   * @since 2.0.0
   */
  step() {
    const tasks = this.tasks.buckets;
    this.tasks.buckets = [];
    for (const [_, toRun] of tasks) {
      for (let i = 0; i < toRun.length; i++) {
        toRun[i]();
      }
    }
  }
}
/**
 * @since 2.0.0
 * @category constructors
 */
const makeMatrix = (...record) => {
  const index = record.sort(([p0], [p1]) => p0 < p1 ? -1 : p0 > p1 ? 1 : 0);
  return {
    shouldYield(fiber) {
      for (const scheduler of record) {
        const priority = scheduler[1].shouldYield(fiber);
        if (priority !== false) {
          return priority;
        }
      }
      return false;
    },
    scheduleTask(task, priority) {
      let scheduler = undefined;
      for (const i of index) {
        if (priority >= i[0]) {
          scheduler = i[1];
        } else {
          return (scheduler ?? defaultScheduler).scheduleTask(task, priority);
        }
      }
      return (scheduler ?? defaultScheduler).scheduleTask(task, priority);
    }
  };
};
/**
 * @since 2.0.0
 * @category utilities
 */
const defaultShouldYield = fiber => {
  return fiber.currentOpCount > fiber.getFiberRef(core.currentMaxOpsBeforeYield) ? fiber.getFiberRef(core.currentSchedulingPriority) : false;
};
/**
 * @since 2.0.0
 * @category constructors
 */
const make = (scheduleTask, shouldYield = defaultShouldYield) => ({
  scheduleTask,
  shouldYield
});
/**
 * @since 2.0.0
 * @category constructors
 */
const makeBatched = (callback, shouldYield = defaultShouldYield) => {
  let running = false;
  const tasks = new PriorityBuckets();
  const starveInternal = () => {
    const tasksToRun = tasks.buckets;
    tasks.buckets = [];
    for (const [_, toRun] of tasksToRun) {
      for (let i = 0; i < toRun.length; i++) {
        toRun[i]();
      }
    }
    if (tasks.buckets.length === 0) {
      running = false;
    } else {
      starve();
    }
  };
  const starve = () => callback(starveInternal);
  return make((task, priority) => {
    tasks.scheduleTask(task, priority);
    if (!running) {
      running = true;
      starve();
    }
  }, shouldYield);
};
/**
 * @since 2.0.0
 * @category constructors
 */
const timer = (ms, shouldYield = defaultShouldYield) => make(task => setTimeout(task, ms), shouldYield);
/**
 * @since 2.0.0
 * @category constructors
 */
const timerBatched = (ms, shouldYield = defaultShouldYield) => makeBatched(task => setTimeout(task, ms), shouldYield);
/** @internal */
const currentScheduler = /*#__PURE__*/(0,_GlobalValue_js__WEBPACK_IMPORTED_MODULE_1__/* .globalValue */ .K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentScheduler"), () => _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .fiberRefUnsafeMake */ .kgb(defaultScheduler));
/** @internal */
const withScheduler = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, scheduler) => _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .fiberRefLocally */ .EXC(self, currentScheduler, scheduler));
//# sourceMappingURL=Scheduler.js.map

/***/ }),

/***/ 39838:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mJB": function() { return /* binding */ Array$; },
  "tkx": function() { return /* binding */ BigInt$; },
  "L7B": function() { return /* binding */ BigIntFromNumber; },
  "gec": function() { return /* binding */ Boolean$; },
  "J7n": function() { return /* binding */ Int; },
  "t$L": function() { return /* binding */ Schema_Literal; },
  "Auj": function() { return /* binding */ NullOr; },
  "F98": function() { return /* binding */ NullishOr; },
  "Mr_": function() { return /* binding */ Number$; },
  "_Li": function() { return /* binding */ NumberFromString; },
  "c7w": function() { return /* binding */ Object$; },
  "WVy": function() { return /* binding */ Record; },
  "Ld9": function() { return /* binding */ String$; },
  "AUF": function() { return /* binding */ Schema_Struct; },
  "qCK": function() { return /* binding */ Schema_compose; },
  "jtO": function() { return /* binding */ optional; },
  "Vl2": function() { return /* binding */ split; }
});

// UNUSED EXPORTS: Any, ArrayEnsure, ArrayFormatterIssue, BetweenBigDecimalSchemaId, BetweenBigIntSchemaId, BetweenDateSchemaId, BetweenDurationSchemaId, BetweenSchemaId, BigDecimal, BigDecimalFromNumber, BigDecimalFromSelf, BigIntFromSelf, BooleanFromString, BooleanFromUnknown, BrandSchemaId, Capitalize, Capitalized, CapitalizedSchemaId, Cause, CauseFromSelf, Char, Chunk, ChunkFromSelf, Class, Config, Data, DataFromSelf, Date, DateFromNumber, DateFromSelf, DateFromSelfSchemaId, DateFromString, DateTimeUtc, DateTimeUtcFromDate, DateTimeUtcFromNumber, DateTimeUtcFromSelf, DateTimeZoned, DateTimeZonedFromSelf, Defect, Duration, DurationFromMillis, DurationFromNanos, DurationFromSelf, Either, EitherFromSelf, EitherFromUnion, EndsWithSchemaId, Enums, Exit, ExitFromSelf, FiberId, FiberIdFromSelf, Finite, FiniteSchemaId, FromPropertySignature, GreaterThanBigDecimalSchemaId, GreaterThanBigIntSchemaId, GreaterThanDateSchemaId, GreaterThanDurationSchemaId, GreaterThanOrEqualToBigDecimalSchemaId, GreaterThanOrEqualToBigIntSchemaId, GreaterThanOrEqualToDateSchemaId, GreaterThanOrEqualToDurationSchemaId, GreaterThanOrEqualToSchemaId, GreaterThanSchemaId, HashMap, HashMapFromSelf, HashSet, HashSetFromSelf, IncludesSchemaId, InstanceOfSchemaId, IntSchemaId, ItemsCountSchemaId, JsonNumber, JsonNumberSchemaId, LengthSchemaId, LessThanBigDecimalSchemaId, LessThanBigIntSchemaId, LessThanDateSchemaId, LessThanDurationSchemaId, LessThanOrEqualToBigDecimalSchemaId, LessThanOrEqualToBigIntSchemaId, LessThanOrEqualToDateSchemaId, LessThanOrEqualToDurationSchemaId, LessThanOrEqualToSchemaId, LessThanSchemaId, List, ListFromSelf, Lowercase, Lowercased, LowercasedSchemaId, Map, MapFromRecord, MapFromSelf, MaxItemsSchemaId, MaxLengthSchemaId, MinItemsSchemaId, MinLengthSchemaId, MultipleOfSchemaId, Negative, NegativeBigDecimalFromSelf, NegativeBigDecimalSchemaId, NegativeBigInt, NegativeBigIntFromSelf, Never, NonEmptyArray, NonEmptyArrayEnsure, NonEmptyChunk, NonEmptyChunkFromSelf, NonEmptyString, NonEmptyTrimmedString, NonNaN, NonNaNSchemaId, NonNegative, NonNegativeBigDecimalFromSelf, NonNegativeBigDecimalSchemaId, NonNegativeBigInt, NonNegativeBigIntFromSelf, NonNegativeInt, NonPositive, NonPositiveBigDecimalFromSelf, NonPositiveBigDecimalSchemaId, NonPositiveBigInt, NonPositiveBigIntFromSelf, Not, Null, Option, OptionFromNonEmptyTrimmedString, OptionFromNullOr, OptionFromNullishOr, OptionFromSelf, OptionFromUndefinedOr, PatternSchemaId, Positive, PositiveBigDecimalFromSelf, PositiveBigDecimalSchemaId, PositiveBigInt, PositiveBigIntFromSelf, PropertyKey, PropertySignatureDeclaration, PropertySignatureTransformation, PropertySignatureTypeId, ReadonlyMap, ReadonlyMapFromRecord, ReadonlyMapFromSelf, ReadonlySet, ReadonlySetFromSelf, Redacted, RedactedFromSelf, RefineSchemaId, Set, SetFromSelf, SortedSet, SortedSetFromSelf, StartsWithSchemaId, StringFromBase64, StringFromBase64Url, StringFromHex, StringFromUriComponent, Symbol, SymbolFromSelf, TaggedClass, TaggedError, TaggedRequest, TaggedStruct, TemplateLiteral, TemplateLiteralParser, TimeZone, TimeZoneFromSelf, TimeZoneNamed, TimeZoneNamedFromSelf, TimeZoneOffset, TimeZoneOffsetFromSelf, ToPropertySignature, Trim, Trimmed, TrimmedSchemaId, Tuple, TypeId, ULID, ULIDSchemaId, URL, URLFromSelf, UUID, UUIDSchemaId, Uint8, Uint8Array, Uint8ArrayFromBase64, Uint8ArrayFromBase64Url, Uint8ArrayFromHex, Uint8ArrayFromSelf, Uncapitalize, Uncapitalized, UncapitalizedSchemaId, Undefined, UndefinedOr, Union, UniqueSymbolFromSelf, Unknown, Uppercase, Uppercased, UppercasedSchemaId, ValidDateFromSelf, ValidDateSchemaId, Void, annotations, asSchema, asSerializable, asSerializableWithResult, asWithResult, asserts, attachPropertySignature, between, betweenBigDecimal, betweenBigInt, betweenDate, betweenDuration, brand, capitalized, clamp, clampBigDecimal, clampBigInt, clampDuration, declare, decode, decodeEither, decodeOption, decodePromise, decodeSync, decodeUnknown, decodeUnknownEither, decodeUnknownOption, decodeUnknownPromise, decodeUnknownSync, deserialize, deserializeExit, deserializeFailure, deserializeSuccess, element, encode, encodeEither, encodeOption, encodePromise, encodeSync, encodeUnknown, encodeUnknownEither, encodeUnknownOption, encodeUnknownPromise, encodeUnknownSync, encodedBoundSchema, encodedSchema, endsWith, equivalence, exitSchema, extend, failureSchema, filter, filterEffect, finite, format, fromBrand, fromKey, getClassTag, getNumberIndexedAccess, greaterThan, greaterThanBigDecimal, greaterThanBigInt, greaterThanDate, greaterThanDuration, greaterThanOrEqualTo, greaterThanOrEqualToBigDecimal, greaterThanOrEqualToBigInt, greaterThanOrEqualToDate, greaterThanOrEqualToDuration, head, headNonEmpty, headOrElse, includes, instanceOf, int, is, isPropertySignature, isSchema, itemsCount, keyof, length, lessThan, lessThanBigDecimal, lessThanBigInt, lessThanDate, lessThanDuration, lessThanOrEqualTo, lessThanOrEqualToBigDecimal, lessThanOrEqualToBigInt, lessThanOrEqualToDate, lessThanOrEqualToDuration, lowercased, make, makePropertySignature, maxItems, maxLength, minItems, minLength, multipleOf, mutable, negative, negativeBigDecimal, negativeBigInt, nonEmptyString, nonNaN, nonNegative, nonNegativeBigDecimal, nonNegativeBigInt, nonPositive, nonPositiveBigDecimal, nonPositiveBigInt, omit, optionalElement, optionalToOptional, optionalToRequired, optionalWith, parseJson, parseNumber, partial, partialWith, pattern, pick, pickLiteral, pluck, positive, positiveBigDecimal, positiveBigInt, propertySignature, rename, required, requiredToOptional, serializableSchema, serialize, serializeExit, serializeFailure, serializeSuccess, standardSchemaV1, startsWith, successSchema, suspend, symbolSerializable, symbolWithResult, tag, transform, transformLiteral, transformLiterals, transformOrFail, trimmed, typeSchema, uncapitalized, uppercased, validDate, validate, validateEither, validateOption, validatePromise, validateSync, withConstructorDefault, withDecodingDefault, withDefaults

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Array.js + 2 modules
var esm_Array = __webpack_require__(37901);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/BigDecimal.js
var BigDecimal = __webpack_require__(53954);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/BigInt.js
var esm_BigInt = __webpack_require__(37787);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Boolean.js
var Boolean = __webpack_require__(49349);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Cause.js
var Cause = __webpack_require__(91115);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Clock.js
var Clock = __webpack_require__(9605);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Duration.js
var Duration = __webpack_require__(13571);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Either.js
var esm_Either = __webpack_require__(87585);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equal.js
var esm_Equal = __webpack_require__(67492);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equivalence.js
var esm_Equivalence = __webpack_require__(27786);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/GlobalValue.js
var GlobalValue = __webpack_require__(4726);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Hash.js
var Hash = __webpack_require__(89379);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Inspectable.js
var Inspectable = __webpack_require__(16371);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var esm_Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Order.js
var Order = __webpack_require__(51988);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Pipeable.js
var Pipeable = __webpack_require__(92817);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var esm_Predicate = __webpack_require__(71335);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/core-effect.js + 3 modules
var core_effect = __webpack_require__(53623);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/core.js + 1 modules
var core = __webpack_require__(39355);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/dateTime.js
















/** @internal */
const TypeId = /*#__PURE__*/Symbol.for("effect/DateTime");
/** @internal */
const TimeZoneTypeId = /*#__PURE__*/Symbol.for("effect/DateTime/TimeZone");
const Proto = {
  [TypeId]: TypeId,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  },
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return this.toString();
  },
  toJSON() {
    return toDateUtc(this).toJSON();
  }
};
const ProtoUtc = {
  ...Proto,
  _tag: "Utc",
  [Hash/* symbol */.NA]() {
    return Hash/* cached */.HX(this, Hash/* number */.Rx(this.epochMillis));
  },
  [esm_Equal/* symbol */.NA](that) {
    return isDateTime(that) && that._tag === "Utc" && this.epochMillis === that.epochMillis;
  },
  toString() {
    return `DateTime.Utc(${toDateUtc(this).toJSON()})`;
  }
};
const ProtoZoned = {
  ...Proto,
  _tag: "Zoned",
  [Hash/* symbol */.NA]() {
    return (0,Function/* pipe */.zG)(Hash/* number */.Rx(this.epochMillis), Hash/* combine */.$e(Hash/* hash */.vp(this.zone)), Hash/* cached */.HX(this));
  },
  [esm_Equal/* symbol */.NA](that) {
    return isDateTime(that) && that._tag === "Zoned" && this.epochMillis === that.epochMillis && esm_Equal/* equals */.fS(this.zone, that.zone);
  },
  toString() {
    return `DateTime.Zoned(${formatIsoZoned(this)})`;
  }
};
const ProtoTimeZone = {
  [TimeZoneTypeId]: TimeZoneTypeId,
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return this.toString();
  }
};
const ProtoTimeZoneNamed = {
  ...ProtoTimeZone,
  _tag: "Named",
  [Hash/* symbol */.NA]() {
    return Hash/* cached */.HX(this, Hash/* string */.Z_(`Named:${this.id}`));
  },
  [esm_Equal/* symbol */.NA](that) {
    return isTimeZone(that) && that._tag === "Named" && this.id === that.id;
  },
  toString() {
    return `TimeZone.Named(${this.id})`;
  },
  toJSON() {
    return {
      _id: "TimeZone",
      _tag: "Named",
      id: this.id
    };
  }
};
const ProtoTimeZoneOffset = {
  ...ProtoTimeZone,
  _tag: "Offset",
  [Hash/* symbol */.NA]() {
    return Hash/* cached */.HX(this, Hash/* string */.Z_(`Offset:${this.offset}`));
  },
  [esm_Equal/* symbol */.NA](that) {
    return isTimeZone(that) && that._tag === "Offset" && this.offset === that.offset;
  },
  toString() {
    return `TimeZone.Offset(${offsetToString(this.offset)})`;
  },
  toJSON() {
    return {
      _id: "TimeZone",
      _tag: "Offset",
      offset: this.offset
    };
  }
};
/** @internal */
const makeZonedProto = (epochMillis, zone, partsUtc) => {
  const self = Object.create(ProtoZoned);
  self.epochMillis = epochMillis;
  self.zone = zone;
  Object.defineProperty(self, "partsUtc", {
    value: partsUtc,
    enumerable: false,
    writable: true
  });
  Object.defineProperty(self, "adjustedEpochMillis", {
    value: undefined,
    enumerable: false,
    writable: true
  });
  Object.defineProperty(self, "partsAdjusted", {
    value: undefined,
    enumerable: false,
    writable: true
  });
  return self;
};
// =============================================================================
// guards
// =============================================================================
/** @internal */
const isDateTime = u => esm_Predicate/* hasProperty */.l$(u, TypeId);
const isDateTimeArgs = args => isDateTime(args[0]);
/** @internal */
const isTimeZone = u => esm_Predicate/* hasProperty */.l$(u, TimeZoneTypeId);
/** @internal */
const isTimeZoneOffset = u => isTimeZone(u) && u._tag === "Offset";
/** @internal */
const isTimeZoneNamed = u => isTimeZone(u) && u._tag === "Named";
/** @internal */
const isUtc = self => self._tag === "Utc";
/** @internal */
const isZoned = self => self._tag === "Zoned";
// =============================================================================
// instances
// =============================================================================
/** @internal */
const dateTime_Equivalence = /*#__PURE__*/esm_Equivalence/* make */.Sy((a, b) => a.epochMillis === b.epochMillis);
/** @internal */
const dateTime_Order = /*#__PURE__*/Order/* make */.Sy((self, that) => self.epochMillis < that.epochMillis ? -1 : self.epochMillis > that.epochMillis ? 1 : 0);
/** @internal */
const clamp = /*#__PURE__*/Order/* clamp */.uZ(dateTime_Order);
// =============================================================================
// constructors
// =============================================================================
const makeUtc = epochMillis => {
  const self = Object.create(ProtoUtc);
  self.epochMillis = epochMillis;
  Object.defineProperty(self, "partsUtc", {
    value: undefined,
    enumerable: false,
    writable: true
  });
  return self;
};
/** @internal */
const unsafeFromDate = date => {
  const epochMillis = date.getTime();
  if (Number.isNaN(epochMillis)) {
    throw new Cause/* IllegalArgumentException */.j5("Invalid date");
  }
  return makeUtc(epochMillis);
};
/** @internal */
const unsafeMake = input => {
  if (isDateTime(input)) {
    return input;
  } else if (input instanceof Date) {
    return unsafeFromDate(input);
  } else if (typeof input === "object") {
    const date = new Date(0);
    setPartsDate(date, input);
    return unsafeFromDate(date);
  }
  return unsafeFromDate(new Date(input));
};
const minEpochMillis = -8640000000000000 + 12 * 60 * 60 * 1000;
const maxEpochMillis = 8640000000000000 - 14 * 60 * 60 * 1000;
/** @internal */
const unsafeMakeZoned = (input, options) => {
  if (options?.timeZone === undefined && isDateTime(input) && isZoned(input)) {
    return input;
  }
  const self = unsafeMake(input);
  if (self.epochMillis < minEpochMillis || self.epochMillis > maxEpochMillis) {
    throw new Cause/* IllegalArgumentException */.j5(`Epoch millis out of range: ${self.epochMillis}`);
  }
  let zone;
  if (options?.timeZone === undefined) {
    const offset = new Date(self.epochMillis).getTimezoneOffset() * -60 * 1000;
    zone = zoneMakeOffset(offset);
  } else if (isTimeZone(options?.timeZone)) {
    zone = options.timeZone;
  } else if (typeof options?.timeZone === "number") {
    zone = zoneMakeOffset(options.timeZone);
  } else {
    const parsedZone = zoneFromString(options.timeZone);
    if (esm_Option/* isNone */.Wi(parsedZone)) {
      throw new Cause/* IllegalArgumentException */.j5(`Invalid time zone: ${options.timeZone}`);
    }
    zone = parsedZone.value;
  }
  if (options?.adjustForTimeZone !== true) {
    return makeZonedProto(self.epochMillis, zone, self.partsUtc);
  }
  return makeZonedFromAdjusted(self.epochMillis, zone);
};
/** @internal */
const makeZoned = /*#__PURE__*/esm_Option/* liftThrowable */.eZ(unsafeMakeZoned);
/** @internal */
const make = /*#__PURE__*/esm_Option/* liftThrowable */.eZ(unsafeMake);
const zonedStringRegex = /^(.{17,35})\[(.+)\]$/;
/** @internal */
const makeZonedFromString = input => {
  const match = zonedStringRegex.exec(input);
  if (match === null) {
    const offset = parseOffset(input);
    return offset !== null ? makeZoned(input, {
      timeZone: offset
    }) : esm_Option/* none */.YP();
  }
  const [, isoString, timeZone] = match;
  return makeZoned(isoString, {
    timeZone
  });
};
/** @internal */
const now = /*#__PURE__*/core/* map */.UID(Clock/* currentTimeMillis */.b4, makeUtc);
/** @internal */
const nowAsDate = /*#__PURE__*/core/* map */.UID(Clock/* currentTimeMillis */.b4, millis => new Date(millis));
/** @internal */
const unsafeNow = () => makeUtc(Date.now());
// =============================================================================
// time zones
// =============================================================================
/** @internal */
const toUtc = self => makeUtc(self.epochMillis);
/** @internal */
const setZone = /*#__PURE__*/(0,Function/* dual */.OB)(isDateTimeArgs, (self, zone, options) => options?.adjustForTimeZone === true ? makeZonedFromAdjusted(self.epochMillis, zone) : makeZonedProto(self.epochMillis, zone, self.partsUtc));
/** @internal */
const setZoneOffset = /*#__PURE__*/(0,Function/* dual */.OB)(isDateTimeArgs, (self, offset, options) => setZone(self, zoneMakeOffset(offset), options));
const validZoneCache = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)("effect/DateTime/validZoneCache", () => new Map());
const formatOptions = {
  day: "numeric",
  month: "numeric",
  year: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  timeZoneName: "longOffset",
  fractionalSecondDigits: 3,
  hourCycle: "h23"
};
const zoneMakeIntl = format => {
  const zoneId = format.resolvedOptions().timeZone;
  if (validZoneCache.has(zoneId)) {
    return validZoneCache.get(zoneId);
  }
  const zone = Object.create(ProtoTimeZoneNamed);
  zone.id = zoneId;
  zone.format = format;
  validZoneCache.set(zoneId, zone);
  return zone;
};
/** @internal */
const zoneUnsafeMakeNamed = zoneId => {
  if (validZoneCache.has(zoneId)) {
    return validZoneCache.get(zoneId);
  }
  try {
    return zoneMakeIntl(new Intl.DateTimeFormat("en-US", {
      ...formatOptions,
      timeZone: zoneId
    }));
  } catch (_) {
    throw new Cause/* IllegalArgumentException */.j5(`Invalid time zone: ${zoneId}`);
  }
};
/** @internal */
const zoneMakeOffset = offset => {
  const zone = Object.create(ProtoTimeZoneOffset);
  zone.offset = offset;
  return zone;
};
/** @internal */
const zoneMakeNamed = /*#__PURE__*/esm_Option/* liftThrowable */.eZ(zoneUnsafeMakeNamed);
/** @internal */
const zoneMakeNamedEffect = zoneId => core_effect/* try_ */.DV({
  try: () => zoneUnsafeMakeNamed(zoneId),
  catch: e => e
});
/** @internal */
const zoneMakeLocal = () => zoneMakeIntl(new Intl.DateTimeFormat("en-US", formatOptions));
const offsetZoneRegex = /^(?:GMT|[+-])/;
/** @internal */
const zoneFromString = zone => {
  if (offsetZoneRegex.test(zone)) {
    const offset = parseOffset(zone);
    return offset === null ? esm_Option/* none */.YP() : esm_Option/* some */.G(zoneMakeOffset(offset));
  }
  return zoneMakeNamed(zone);
};
/** @internal */
const zoneToString = self => {
  if (self._tag === "Offset") {
    return offsetToString(self.offset);
  }
  return self.id;
};
/** @internal */
const setZoneNamed = /*#__PURE__*/(0,Function/* dual */.OB)(isDateTimeArgs, (self, zoneId, options) => esm_Option/* map */.UI(zoneMakeNamed(zoneId), zone => setZone(self, zone, options)));
/** @internal */
const unsafeSetZoneNamed = /*#__PURE__*/(0,Function/* dual */.OB)(isDateTimeArgs, (self, zoneId, options) => setZone(self, zoneUnsafeMakeNamed(zoneId), options));
// =============================================================================
// comparisons
// =============================================================================
/** @internal */
const distance = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, other) => toEpochMillis(other) - toEpochMillis(self));
/** @internal */
const distanceDurationEither = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, other) => {
  const diffMillis = distance(self, other);
  return diffMillis > 0 ? esm_Either/* right */.F2(Duration/* millis */.YX(diffMillis)) : esm_Either/* left */.t$(Duration/* millis */.YX(-diffMillis));
});
/** @internal */
const distanceDuration = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, other) => Duration/* millis */.YX(Math.abs(distance(self, other))));
/** @internal */
const min = /*#__PURE__*/Order/* min */.VV(dateTime_Order);
/** @internal */
const max = /*#__PURE__*/Order/* max */.Fp(dateTime_Order);
/** @internal */
const greaterThan = /*#__PURE__*/Order/* greaterThan */.tS(dateTime_Order);
/** @internal */
const greaterThanOrEqualTo = /*#__PURE__*/Order/* greaterThanOrEqualTo */.wZ(dateTime_Order);
/** @internal */
const lessThan = /*#__PURE__*/Order/* lessThan */.Qj(dateTime_Order);
/** @internal */
const lessThanOrEqualTo = /*#__PURE__*/Order/* lessThanOrEqualTo */.MK(dateTime_Order);
/** @internal */
const between = /*#__PURE__*/Order/* between */.vX(dateTime_Order);
/** @internal */
const isFuture = self => core/* map */.UID(now, lessThan(self));
/** @internal */
const unsafeIsFuture = self => lessThan(unsafeNow(), self);
/** @internal */
const isPast = self => core/* map */.UID(now, greaterThan(self));
/** @internal */
const unsafeIsPast = self => greaterThan(unsafeNow(), self);
// =============================================================================
// conversions
// =============================================================================
/** @internal */
const toDateUtc = self => new Date(self.epochMillis);
/** @internal */
const toDate = self => {
  if (self._tag === "Utc") {
    return new Date(self.epochMillis);
  } else if (self.zone._tag === "Offset") {
    return new Date(self.epochMillis + self.zone.offset);
  } else if (self.adjustedEpochMillis !== undefined) {
    return new Date(self.adjustedEpochMillis);
  }
  const parts = self.zone.format.formatToParts(self.epochMillis).filter(_ => _.type !== "literal");
  const date = new Date(0);
  date.setUTCFullYear(Number(parts[2].value), Number(parts[0].value) - 1, Number(parts[1].value));
  date.setUTCHours(Number(parts[3].value), Number(parts[4].value), Number(parts[5].value), Number(parts[6].value));
  self.adjustedEpochMillis = date.getTime();
  return date;
};
/** @internal */
const zonedOffset = self => {
  const date = toDate(self);
  return date.getTime() - toEpochMillis(self);
};
const offsetToString = offset => {
  const abs = Math.abs(offset);
  let hours = Math.floor(abs / (60 * 60 * 1000));
  let minutes = Math.round(abs % (60 * 60 * 1000) / (60 * 1000));
  if (minutes === 60) {
    hours += 1;
    minutes = 0;
  }
  return `${offset < 0 ? "-" : "+"}${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};
/** @internal */
const zonedOffsetIso = self => offsetToString(zonedOffset(self));
/** @internal */
const toEpochMillis = self => self.epochMillis;
/** @internal */
const removeTime = self => withDate(self, date => {
  date.setUTCHours(0, 0, 0, 0);
  return makeUtc(date.getTime());
});
// =============================================================================
// parts
// =============================================================================
const dateToParts = date => ({
  millis: date.getUTCMilliseconds(),
  seconds: date.getUTCSeconds(),
  minutes: date.getUTCMinutes(),
  hours: date.getUTCHours(),
  day: date.getUTCDate(),
  weekDay: date.getUTCDay(),
  month: date.getUTCMonth() + 1,
  year: date.getUTCFullYear()
});
/** @internal */
const toParts = self => {
  if (self._tag === "Utc") {
    return toPartsUtc(self);
  } else if (self.partsAdjusted !== undefined) {
    return self.partsAdjusted;
  }
  self.partsAdjusted = withDate(self, dateToParts);
  return self.partsAdjusted;
};
/** @internal */
const toPartsUtc = self => {
  if (self.partsUtc !== undefined) {
    return self.partsUtc;
  }
  self.partsUtc = withDateUtc(self, dateToParts);
  return self.partsUtc;
};
/** @internal */
const getPartUtc = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, part) => toPartsUtc(self)[part]);
/** @internal */
const getPart = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, part) => toParts(self)[part]);
const setPartsDate = (date, parts) => {
  if (parts.year !== undefined) {
    date.setUTCFullYear(parts.year);
  }
  if (parts.month !== undefined) {
    date.setUTCMonth(parts.month - 1);
  }
  if (parts.day !== undefined) {
    date.setUTCDate(parts.day);
  }
  if (parts.weekDay !== undefined) {
    const diff = parts.weekDay - date.getUTCDay();
    date.setUTCDate(date.getUTCDate() + diff);
  }
  if (parts.hours !== undefined) {
    date.setUTCHours(parts.hours);
  }
  if (parts.minutes !== undefined) {
    date.setUTCMinutes(parts.minutes);
  }
  if (parts.seconds !== undefined) {
    date.setUTCSeconds(parts.seconds);
  }
  if (parts.millis !== undefined) {
    date.setUTCMilliseconds(parts.millis);
  }
};
/** @internal */
const setParts = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, parts) => mutate(self, date => setPartsDate(date, parts)));
/** @internal */
const setPartsUtc = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, parts) => mutateUtc(self, date => setPartsDate(date, parts)));
// =============================================================================
// mapping
// =============================================================================
const makeZonedFromAdjusted = (adjustedMillis, zone) => {
  const offset = zone._tag === "Offset" ? zone.offset : calculateNamedOffset(adjustedMillis, zone);
  return makeZonedProto(adjustedMillis - offset, zone);
};
const offsetRegex = /([+-])(\d{2}):(\d{2})$/;
const parseOffset = offset => {
  const match = offsetRegex.exec(offset);
  if (match === null) {
    return null;
  }
  const [, sign, hours, minutes] = match;
  return (sign === "+" ? 1 : -1) * (Number(hours) * 60 + Number(minutes)) * 60 * 1000;
};
const calculateNamedOffset = (adjustedMillis, zone) => {
  const offset = zone.format.formatToParts(adjustedMillis).find(_ => _.type === "timeZoneName")?.value ?? "";
  if (offset === "GMT") {
    return 0;
  }
  const result = parseOffset(offset);
  if (result === null) {
    // fallback to using the adjusted date
    return zonedOffset(makeZonedProto(adjustedMillis, zone));
  }
  return result;
};
/** @internal */
const mutate = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  if (self._tag === "Utc") {
    const date = toDateUtc(self);
    f(date);
    return makeUtc(date.getTime());
  }
  const adjustedDate = toDate(self);
  const newAdjustedDate = new Date(adjustedDate.getTime());
  f(newAdjustedDate);
  return makeZonedFromAdjusted(newAdjustedDate.getTime(), self.zone);
});
/** @internal */
const mutateUtc = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => mapEpochMillis(self, millis => {
  const date = new Date(millis);
  f(date);
  return date.getTime();
}));
/** @internal */
const mapEpochMillis = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const millis = f(toEpochMillis(self));
  return self._tag === "Utc" ? makeUtc(millis) : makeZonedProto(millis, self.zone);
});
/** @internal */
const withDate = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => f(toDate(self)));
/** @internal */
const withDateUtc = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => f(toDateUtc(self)));
/** @internal */
const match = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, options) => self._tag === "Utc" ? options.onUtc(self) : options.onZoned(self));
// =============================================================================
// math
// =============================================================================
/** @internal */
const addDuration = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, duration) => mapEpochMillis(self, millis => millis + Duration/* toMillis */.eq(duration)));
/** @internal */
const subtractDuration = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, duration) => mapEpochMillis(self, millis => millis - Duration/* toMillis */.eq(duration)));
const addMillis = (date, amount) => {
  date.setTime(date.getTime() + amount);
};
/** @internal */
const add = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, parts) => mutate(self, date => {
  if (parts.millis) {
    addMillis(date, parts.millis);
  }
  if (parts.seconds) {
    addMillis(date, parts.seconds * 1000);
  }
  if (parts.minutes) {
    addMillis(date, parts.minutes * 60 * 1000);
  }
  if (parts.hours) {
    addMillis(date, parts.hours * 60 * 60 * 1000);
  }
  if (parts.days) {
    date.setUTCDate(date.getUTCDate() + parts.days);
  }
  if (parts.weeks) {
    date.setUTCDate(date.getUTCDate() + parts.weeks * 7);
  }
  if (parts.months) {
    const day = date.getUTCDate();
    date.setUTCMonth(date.getUTCMonth() + parts.months + 1, 0);
    if (day < date.getUTCDate()) {
      date.setUTCDate(day);
    }
  }
  if (parts.years) {
    const day = date.getUTCDate();
    const month = date.getUTCMonth();
    date.setUTCFullYear(date.getUTCFullYear() + parts.years, month + 1, 0);
    if (day < date.getUTCDate()) {
      date.setUTCDate(day);
    }
  }
}));
/** @internal */
const subtract = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, parts) => {
  const newParts = {};
  for (const key in parts) {
    newParts[key] = -1 * parts[key];
  }
  return add(self, newParts);
});
const startOfDate = (date, part, options) => {
  switch (part) {
    case "second":
      {
        date.setUTCMilliseconds(0);
        break;
      }
    case "minute":
      {
        date.setUTCSeconds(0, 0);
        break;
      }
    case "hour":
      {
        date.setUTCMinutes(0, 0, 0);
        break;
      }
    case "day":
      {
        date.setUTCHours(0, 0, 0, 0);
        break;
      }
    case "week":
      {
        const weekStartsOn = options?.weekStartsOn ?? 0;
        const day = date.getUTCDay();
        const diff = (day - weekStartsOn + 7) % 7;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        break;
      }
    case "month":
      {
        date.setUTCDate(1);
        date.setUTCHours(0, 0, 0, 0);
        break;
      }
    case "year":
      {
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
        break;
      }
  }
};
/** @internal */
const startOf = /*#__PURE__*/(0,Function/* dual */.OB)(isDateTimeArgs, (self, part, options) => mutate(self, date => startOfDate(date, part, options)));
const endOfDate = (date, part, options) => {
  switch (part) {
    case "second":
      {
        date.setUTCMilliseconds(999);
        break;
      }
    case "minute":
      {
        date.setUTCSeconds(59, 999);
        break;
      }
    case "hour":
      {
        date.setUTCMinutes(59, 59, 999);
        break;
      }
    case "day":
      {
        date.setUTCHours(23, 59, 59, 999);
        break;
      }
    case "week":
      {
        const weekStartsOn = options?.weekStartsOn ?? 0;
        const day = date.getUTCDay();
        const diff = (day - weekStartsOn + 7) % 7;
        date.setUTCDate(date.getUTCDate() - diff + 6);
        date.setUTCHours(23, 59, 59, 999);
        break;
      }
    case "month":
      {
        date.setUTCMonth(date.getUTCMonth() + 1, 0);
        date.setUTCHours(23, 59, 59, 999);
        break;
      }
    case "year":
      {
        date.setUTCMonth(11, 31);
        date.setUTCHours(23, 59, 59, 999);
        break;
      }
  }
};
/** @internal */
const endOf = /*#__PURE__*/(0,Function/* dual */.OB)(isDateTimeArgs, (self, part, options) => mutate(self, date => endOfDate(date, part, options)));
/** @internal */
const nearest = /*#__PURE__*/(0,Function/* dual */.OB)(isDateTimeArgs, (self, part, options) => mutate(self, date => {
  if (part === "milli") return;
  const millis = date.getTime();
  const start = new Date(millis);
  startOfDate(start, part, options);
  const startMillis = start.getTime();
  const end = new Date(millis);
  endOfDate(end, part, options);
  const endMillis = end.getTime() + 1;
  const diffStart = millis - startMillis;
  const diffEnd = endMillis - millis;
  if (diffStart < diffEnd) {
    date.setTime(startMillis);
  } else {
    date.setTime(endMillis);
  }
}));
// =============================================================================
// formatting
// =============================================================================
const intlTimeZone = self => {
  if (self._tag === "Named") {
    return self.id;
  }
  return offsetToString(self.offset);
};
/** @internal */
const format = /*#__PURE__*/(0,Function/* dual */.OB)(isDateTimeArgs, (self, options) => {
  try {
    return new Intl.DateTimeFormat(options?.locale, {
      timeZone: self._tag === "Utc" ? "UTC" : intlTimeZone(self.zone),
      ...options
    }).format(self.epochMillis);
  } catch (_) {
    return new Intl.DateTimeFormat(options?.locale, {
      timeZone: "UTC",
      ...options
    }).format(toDate(self));
  }
});
/** @internal */
const formatLocal = /*#__PURE__*/(0,Function/* dual */.OB)(isDateTimeArgs, (self, options) => new Intl.DateTimeFormat(options?.locale, options).format(self.epochMillis));
/** @internal */
const formatUtc = /*#__PURE__*/(0,Function/* dual */.OB)(isDateTimeArgs, (self, options) => new Intl.DateTimeFormat(options?.locale, {
  ...options,
  timeZone: "UTC"
}).format(self.epochMillis));
/** @internal */
const formatIntl = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, format) => format.format(self.epochMillis));
/** @internal */
const formatIso = self => toDateUtc(self).toISOString();
/** @internal */
const formatIsoDate = self => toDate(self).toISOString().slice(0, 10);
/** @internal */
const formatIsoDateUtc = self => toDateUtc(self).toISOString().slice(0, 10);
/** @internal */
const formatIsoOffset = self => {
  const date = toDate(self);
  return self._tag === "Utc" ? date.toISOString() : `${date.toISOString().slice(0, -1)}${zonedOffsetIso(self)}`;
};
/** @internal */
const formatIsoZoned = self => self.zone._tag === "Offset" ? formatIsoOffset(self) : `${formatIsoOffset(self)}[${self.zone.id}]`;
//# sourceMappingURL=dateTime.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/DateTime.js





/**
 * @since 3.6.0
 * @category type ids
 */
const DateTime_TypeId = TypeId;
/**
 * @since 3.6.0
 * @category type ids
 */
const DateTime_TimeZoneTypeId = TimeZoneTypeId;
// =============================================================================
// guards
// =============================================================================
/**
 * @since 3.6.0
 * @category guards
 */
const DateTime_isDateTime = isDateTime;
/**
 * @since 3.6.0
 * @category guards
 */
const DateTime_isTimeZone = isTimeZone;
/**
 * @since 3.6.0
 * @category guards
 */
const DateTime_isTimeZoneOffset = isTimeZoneOffset;
/**
 * @since 3.6.0
 * @category guards
 */
const DateTime_isTimeZoneNamed = isTimeZoneNamed;
/**
 * @since 3.6.0
 * @category guards
 */
const DateTime_isUtc = isUtc;
/**
 * @since 3.6.0
 * @category guards
 */
const DateTime_isZoned = isZoned;
// =============================================================================
// instances
// =============================================================================
/**
 * @since 3.6.0
 * @category instances
 */
const DateTime_Equivalence = dateTime_Equivalence;
/**
 * @since 3.6.0
 * @category instances
 */
const DateTime_Order = dateTime_Order;
/**
 * @since 3.6.0
 */
const DateTime_clamp = clamp;
// =============================================================================
// constructors
// =============================================================================
/**
 * Create a `DateTime` from a `Date`.
 *
 * If the `Date` is invalid, an `IllegalArgumentException` will be thrown.
 *
 * @since 3.6.0
 * @category constructors
 */
const DateTime_unsafeFromDate = unsafeFromDate;
/**
 * Create a `DateTime` from one of the following:
 *
 * - A `DateTime`
 * - A `Date` instance (invalid dates will throw an `IllegalArgumentException`)
 * - The `number` of milliseconds since the Unix epoch
 * - An object with the parts of a date
 * - A `string` that can be parsed by `Date.parse`
 *
 * @since 3.6.0
 * @category constructors
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * // from Date
 * DateTime.unsafeMake(new Date())
 *
 * // from parts
 * DateTime.unsafeMake({ year: 2024 })
 *
 * // from string
 * DateTime.unsafeMake("2024-01-01")
 * ```
 */
const DateTime_unsafeMake = unsafeMake;
/**
 * Create a `DateTime.Zoned` using `DateTime.unsafeMake` and a time zone.
 *
 * The input is treated as UTC and then the time zone is attached, unless
 * `adjustForTimeZone` is set to `true`. In that case, the input is treated as
 * already in the time zone.
 *
 * @since 3.6.0
 * @category constructors
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * DateTime.unsafeMakeZoned(new Date(), { timeZone: "Europe/London" })
 * ```
 */
const DateTime_unsafeMakeZoned = unsafeMakeZoned;
/**
 * Create a `DateTime.Zoned` using `DateTime.make` and a time zone.
 *
 * The input is treated as UTC and then the time zone is attached.
 *
 * If the date time input or time zone is invalid, `None` will be returned.
 *
 * @since 3.6.0
 * @category constructors
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * DateTime.makeZoned(new Date(), { timeZone: "Europe/London" })
 * ```
 */
const DateTime_makeZoned = makeZoned;
/**
 * Create a `DateTime` from one of the following:
 *
 * - A `DateTime`
 * - A `Date` instance (invalid dates will throw an `IllegalArgumentException`)
 * - The `number` of milliseconds since the Unix epoch
 * - An object with the parts of a date
 * - A `string` that can be parsed by `Date.parse`
 *
 * If the input is invalid, `None` will be returned.
 *
 * @since 3.6.0
 * @category constructors
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * // from Date
 * DateTime.make(new Date())
 *
 * // from parts
 * DateTime.make({ year: 2024 })
 *
 * // from string
 * DateTime.make("2024-01-01")
 * ```
 */
const DateTime_make = make;
/**
 * Create a `DateTime.Zoned` from a string.
 *
 * It uses the format: `YYYY-MM-DDTHH:mm:ss.sss+HH:MM[Time/Zone]`.
 *
 * @since 3.6.0
 * @category constructors
 */
const DateTime_makeZonedFromString = makeZonedFromString;
/**
 * Get the current time using the `Clock` service and convert it to a `DateTime`.
 *
 * @since 3.6.0
 * @category constructors
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   const now = yield* DateTime.now
 * })
 * ```
 */
const DateTime_now = now;
/**
 * Get the current time using the `Clock` service.
 *
 * @since 3.14.0
 * @category constructors
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   const now = yield* DateTime.nowAsDate
 * })
 * ```
 */
const DateTime_nowAsDate = nowAsDate;
/**
 * Get the current time using `Date.now`.
 *
 * @since 3.6.0
 * @category constructors
 */
const DateTime_unsafeNow = unsafeNow;
// =============================================================================
// time zones
// =============================================================================
/**
 * For a `DateTime` returns a new `DateTime.Utc`.
 *
 * @since 3.13.0
 * @category time zones
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * const now = DateTime.unsafeMakeZoned({ year: 2024 }, { timeZone: "Europe/London" })
 *
 * // set as UTC
 * const utc: DateTime.Utc = DateTime.toUtc(now)
 * ```
 */
const DateTime_toUtc = toUtc;
/**
 * Set the time zone of a `DateTime`, returning a new `DateTime.Zoned`.
 *
 * @since 3.6.0
 * @category time zones
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   const now = yield* DateTime.now
 *   const zone = DateTime.zoneUnsafeMakeNamed("Europe/London")
 *
 *   // set the time zone
 *   const zoned: DateTime.Zoned = DateTime.setZone(now, zone)
 * })
 * ```
 */
const DateTime_setZone = setZone;
/**
 * Add a fixed offset time zone to a `DateTime`.
 *
 * The offset is in milliseconds.
 *
 * @since 3.6.0
 * @category time zones
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   const now = yield* DateTime.now
 *
 *   // set the offset time zone in milliseconds
 *   const zoned: DateTime.Zoned = DateTime.setZoneOffset(now, 3 * 60 * 60 * 1000)
 * })
 * ```
 */
const DateTime_setZoneOffset = setZoneOffset;
/**
 * Attempt to create a named time zone from a IANA time zone identifier.
 *
 * If the time zone is invalid, an `IllegalArgumentException` will be thrown.
 *
 * @since 3.6.0
 * @category time zones
 */
const DateTime_zoneUnsafeMakeNamed = zoneUnsafeMakeNamed;
/**
 * Create a fixed offset time zone.
 *
 * @since 3.6.0
 * @category time zones
 */
const DateTime_zoneMakeOffset = zoneMakeOffset;
/**
 * Create a named time zone from a IANA time zone identifier. If the time zone
 * is invalid, `None` will be returned.
 *
 * @since 3.6.0
 * @category time zones
 */
const DateTime_zoneMakeNamed = zoneMakeNamed;
/**
 * Create a named time zone from a IANA time zone identifier. If the time zone
 * is invalid, it will fail with an `IllegalArgumentException`.
 *
 * @since 3.6.0
 * @category time zones
 */
const DateTime_zoneMakeNamedEffect = zoneMakeNamedEffect;
/**
 * Create a named time zone from the system's local time zone.
 *
 * @since 3.6.0
 * @category time zones
 */
const DateTime_zoneMakeLocal = zoneMakeLocal;
/**
 * Try parse a TimeZone from a string
 *
 * @since 3.6.0
 * @category time zones
 */
const DateTime_zoneFromString = zoneFromString;
/**
 * Format a `TimeZone` as a string.
 *
 * @since 3.6.0
 * @category time zones
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * // Outputs "+03:00"
 * DateTime.zoneToString(DateTime.zoneMakeOffset(3 * 60 * 60 * 1000))
 *
 * // Outputs "Europe/London"
 * DateTime.zoneToString(DateTime.zoneUnsafeMakeNamed("Europe/London"))
 * ```
 */
const DateTime_zoneToString = zoneToString;
/**
 * Set the time zone of a `DateTime` from an IANA time zone identifier. If the
 * time zone is invalid, `None` will be returned.
 *
 * @since 3.6.0
 * @category time zones
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   const now = yield* DateTime.now
 *   // set the time zone, returns an Option
 *   DateTime.setZoneNamed(now, "Europe/London")
 * })
 * ```
 */
const DateTime_setZoneNamed = setZoneNamed;
/**
 * Set the time zone of a `DateTime` from an IANA time zone identifier. If the
 * time zone is invalid, an `IllegalArgumentException` will be thrown.
 *
 * @since 3.6.0
 * @category time zones
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   const now = yield* DateTime.now
 *   // set the time zone
 *   DateTime.unsafeSetZoneNamed(now, "Europe/London")
 * })
 * ```
 */
const DateTime_unsafeSetZoneNamed = unsafeSetZoneNamed;
// =============================================================================
// comparisons
// =============================================================================
/**
 * Calulate the difference between two `DateTime` values, returning the number
 * of milliseconds the `other` DateTime is from `self`.
 *
 * If `other` is *after* `self`, the result will be a positive number.
 *
 * @since 3.6.0
 * @category comparisons
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   const now = yield* DateTime.now
 *   const other = DateTime.add(now, { minutes: 1 })
 *
 *   // returns 60000
 *   DateTime.distance(now, other)
 * })
 * ```
 */
const DateTime_distance = distance;
/**
 * Calulate the difference between two `DateTime` values.
 *
 * If the `other` DateTime is before `self`, the result will be a negative
 * `Duration`, returned as a `Left`.
 *
 * If the `other` DateTime is after `self`, the result will be a positive
 * `Duration`, returned as a `Right`.
 *
 * @since 3.6.0
 * @category comparisons
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   const now = yield* DateTime.now
 *   const other = DateTime.add(now, { minutes: 1 })
 *
 *   // returns Either.right(Duration.minutes(1))
 *   DateTime.distanceDurationEither(now, other)
 *
 *   // returns Either.left(Duration.minutes(1))
 *   DateTime.distanceDurationEither(other, now)
 * })
 * ```
 */
const DateTime_distanceDurationEither = distanceDurationEither;
/**
 * Calulate the distance between two `DateTime` values.
 *
 * @since 3.6.0
 * @category comparisons
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   const now = yield* DateTime.now
 *   const other = DateTime.add(now, { minutes: 1 })
 *
 *   // returns Duration.minutes(1)
 *   DateTime.distanceDuration(now, other)
 * })
 * ```
 */
const DateTime_distanceDuration = distanceDuration;
/**
 * @since 3.6.0
 * @category comparisons
 */
const DateTime_min = min;
/**
 * @since 3.6.0
 * @category comparisons
 */
const DateTime_max = max;
/**
 * @since 3.6.0
 * @category comparisons
 */
const DateTime_greaterThan = greaterThan;
/**
 * @since 3.6.0
 * @category comparisons
 */
const DateTime_greaterThanOrEqualTo = greaterThanOrEqualTo;
/**
 * @since 3.6.0
 * @category comparisons
 */
const DateTime_lessThan = lessThan;
/**
 * @since 3.6.0
 * @category comparisons
 */
const DateTime_lessThanOrEqualTo = lessThanOrEqualTo;
/**
 * @since 3.6.0
 * @category comparisons
 */
const DateTime_between = between;
/**
 * @since 3.6.0
 * @category comparisons
 */
const DateTime_isFuture = isFuture;
/**
 * @since 3.6.0
 * @category comparisons
 */
const DateTime_unsafeIsFuture = unsafeIsFuture;
/**
 * @since 3.6.0
 * @category comparisons
 */
const DateTime_isPast = isPast;
/**
 * @since 3.6.0
 * @category comparisons
 */
const DateTime_unsafeIsPast = unsafeIsPast;
// =============================================================================
// conversions
// =============================================================================
/**
 * Get the UTC `Date` of a `DateTime`.
 *
 * @since 3.6.0
 * @category conversions
 */
const DateTime_toDateUtc = toDateUtc;
/**
 * Convert a `DateTime` to a `Date`, applying the time zone first.
 *
 * @since 3.6.0
 * @category conversions
 */
const DateTime_toDate = toDate;
/**
 * Calculate the time zone offset of a `DateTime.Zoned` in milliseconds.
 *
 * @since 3.6.0
 * @category conversions
 */
const DateTime_zonedOffset = zonedOffset;
/**
 * Calculate the time zone offset of a `DateTime` in milliseconds.
 *
 * The offset is formatted as "±HH:MM".
 *
 * @since 3.6.0
 * @category conversions
 */
const DateTime_zonedOffsetIso = zonedOffsetIso;
/**
 * Get the milliseconds since the Unix epoch of a `DateTime`.
 *
 * @since 3.6.0
 * @category conversions
 */
const DateTime_toEpochMillis = toEpochMillis;
/**
 * Remove the time aspect of a `DateTime`, first adjusting for the time
 * zone. It will return a `DateTime.Utc` only containing the date.
 *
 * @since 3.6.0
 * @category conversions
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * // returns "2024-01-01T00:00:00Z"
 * DateTime.unsafeMakeZoned("2024-01-01T05:00:00Z", {
 *   timeZone: "Pacific/Auckland",
 *   adjustForTimeZone: true
 * }).pipe(
 *   DateTime.removeTime,
 *   DateTime.formatIso
 * )
 * ```
 */
const DateTime_removeTime = removeTime;
// =============================================================================
// parts
// =============================================================================
/**
 * Get the different parts of a `DateTime` as an object.
 *
 * The parts will be time zone adjusted.
 *
 * @since 3.6.0
 * @category parts
 */
const DateTime_toParts = toParts;
/**
 * Get the different parts of a `DateTime` as an object.
 *
 * The parts will be in UTC.
 *
 * @since 3.6.0
 * @category parts
 */
const DateTime_toPartsUtc = toPartsUtc;
/**
 * Get a part of a `DateTime` as a number.
 *
 * The part will be in the UTC time zone.
 *
 * @since 3.6.0
 * @category parts
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { DateTime } from "effect"
 *
 * const now = DateTime.unsafeMake({ year: 2024 })
 * const year = DateTime.getPartUtc(now, "year")
 * assert.strictEqual(year, 2024)
 * ```
 */
const DateTime_getPartUtc = getPartUtc;
/**
 * Get a part of a `DateTime` as a number.
 *
 * The part will be time zone adjusted.
 *
 * @since 3.6.0
 * @category parts
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { DateTime } from "effect"
 *
 * const now = DateTime.unsafeMakeZoned({ year: 2024 }, { timeZone: "Europe/London" })
 * const year = DateTime.getPart(now, "year")
 * assert.strictEqual(year, 2024)
 * ```
 */
const DateTime_getPart = getPart;
/**
 * Set the different parts of a `DateTime` as an object.
 *
 * The Date will be time zone adjusted.
 *
 * @since 3.6.0
 * @category parts
 */
const DateTime_setParts = setParts;
/**
 * Set the different parts of a `DateTime` as an object.
 *
 * @since 3.6.0
 * @category parts
 */
const DateTime_setPartsUtc = setPartsUtc;
// =============================================================================
// current time zone
// =============================================================================
/**
 * @since 3.11.0
 * @category current time zone
 */
class CurrentTimeZone extends /*#__PURE__*/(/* unused pure expression or super */ null && (Context.Tag("effect/DateTime/CurrentTimeZone")())) {}
/**
 * Set the time zone of a `DateTime` to the current time zone, which is
 * determined by the `CurrentTimeZone` service.
 *
 * @since 3.6.0
 * @category current time zone
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   const now = yield* DateTime.now
 *
 *   // set the time zone to "Europe/London"
 *   const zoned = yield* DateTime.setZoneCurrent(now)
 * }).pipe(DateTime.withCurrentZoneNamed("Europe/London"))
 * ```
 */
const setZoneCurrent = self => Effect.map(CurrentTimeZone, zone => DateTime_setZone(self, zone));
/**
 * Provide the `CurrentTimeZone` to an effect.
 *
 * @since 3.6.0
 * @category current time zone
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * const zone = DateTime.zoneUnsafeMakeNamed("Europe/London")
 *
 * Effect.gen(function* () {
 *   const now = yield* DateTime.nowInCurrentZone
 * }).pipe(DateTime.withCurrentZone(zone))
 * ```
 */
const withCurrentZone = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (effect, zone) => Effect.provideService(effect, CurrentTimeZone, zone))));
/**
 * Provide the `CurrentTimeZone` to an effect, using the system's local time
 * zone.
 *
 * @since 3.6.0
 * @category current time zone
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   // will use the system's local time zone
 *   const now = yield* DateTime.nowInCurrentZone
 * }).pipe(DateTime.withCurrentZoneLocal)
 * ```
 */
const withCurrentZoneLocal = effect => Effect.provideServiceEffect(effect, CurrentTimeZone, Effect.sync(DateTime_zoneMakeLocal));
/**
 * Provide the `CurrentTimeZone` to an effect, using a offset.
 *
 * @since 3.6.0
 * @category current time zone
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   // will use the system's local time zone
 *   const now = yield* DateTime.nowInCurrentZone
 * }).pipe(DateTime.withCurrentZoneOffset(3 * 60 * 60 * 1000))
 * ```
 */
const withCurrentZoneOffset = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (effect, offset) => Effect.provideService(effect, CurrentTimeZone, DateTime_zoneMakeOffset(offset)))));
/**
 * Provide the `CurrentTimeZone` to an effect using an IANA time zone
 * identifier.
 *
 * If the time zone is invalid, it will fail with an `IllegalArgumentException`.
 *
 * @since 3.6.0
 * @category current time zone
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   // will use the "Europe/London" time zone
 *   const now = yield* DateTime.nowInCurrentZone
 * }).pipe(DateTime.withCurrentZoneNamed("Europe/London"))
 * ```
 */
const withCurrentZoneNamed = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (effect, zone) => Effect.provideServiceEffect(effect, CurrentTimeZone, DateTime_zoneMakeNamedEffect(zone)))));
/**
 * Get the current time as a `DateTime.Zoned`, using the `CurrentTimeZone`.
 *
 * @since 3.6.0
 * @category current time zone
 * @example
 * ```ts
 * import { DateTime, Effect } from "effect"
 *
 * Effect.gen(function* () {
 *   // will use the "Europe/London" time zone
 *   const now = yield* DateTime.nowInCurrentZone
 * }).pipe(DateTime.withCurrentZoneNamed("Europe/London"))
 * ```
 */
const nowInCurrentZone = /*#__PURE__*/(/* unused pure expression or super */ null && (Effect.flatMap(DateTime_now, setZoneCurrent)));
// =============================================================================
// mapping
// =============================================================================
/**
 * Modify a `DateTime` by applying a function to a cloned `Date` instance.
 *
 * The `Date` will first have the time zone applied if possible, and then be
 * converted back to a `DateTime` within the same time zone.
 *
 * @since 3.6.0
 * @category mapping
 */
const DateTime_mutate = mutate;
/**
 * Modify a `DateTime` by applying a function to a cloned UTC `Date` instance.
 *
 * @since 3.6.0
 * @category mapping
 */
const DateTime_mutateUtc = mutateUtc;
/**
 * Transform a `DateTime` by applying a function to the number of milliseconds
 * since the Unix epoch.
 *
 * @since 3.6.0
 * @category mapping
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * // add 10 milliseconds
 * DateTime.unsafeMake(0).pipe(
 *   DateTime.mapEpochMillis((millis) => millis + 10)
 * )
 * ```
 */
const DateTime_mapEpochMillis = mapEpochMillis;
/**
 * Using the time zone adjusted `Date`, apply a function to the `Date` and
 * return the result.
 *
 * @since 3.6.0
 * @category mapping
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * // get the time zone adjusted date in milliseconds
 * DateTime.unsafeMakeZoned(0, { timeZone: "Europe/London" }).pipe(
 *   DateTime.withDate((date) => date.getTime())
 * )
 * ```
 */
const DateTime_withDate = withDate;
/**
 * Using the time zone adjusted `Date`, apply a function to the `Date` and
 * return the result.
 *
 * @since 3.6.0
 * @category mapping
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * // get the date in milliseconds
 * DateTime.unsafeMake(0).pipe(
 *   DateTime.withDateUtc((date) => date.getTime())
 * )
 * ```
 */
const DateTime_withDateUtc = withDateUtc;
/**
 * @since 3.6.0
 * @category mapping
 */
const DateTime_match = match;
// =============================================================================
// math
// =============================================================================
/**
 * Add the given `Duration` to a `DateTime`.
 *
 * @since 3.6.0
 * @category math
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * // add 5 minutes
 * DateTime.unsafeMake(0).pipe(
 *   DateTime.addDuration("5 minutes")
 * )
 * ```
 */
const DateTime_addDuration = addDuration;
/**
 * Subtract the given `Duration` from a `DateTime`.
 *
 * @since 3.6.0
 * @category math
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * // subtract 5 minutes
 * DateTime.unsafeMake(0).pipe(
 *   DateTime.subtractDuration("5 minutes")
 * )
 * ```
 */
const DateTime_subtractDuration = subtractDuration;
/**
 * Add the given `amount` of `unit`'s to a `DateTime`.
 *
 * The time zone is taken into account when adding days, weeks, months, and
 * years.
 *
 * @since 3.6.0
 * @category math
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * // add 5 minutes
 * DateTime.unsafeMake(0).pipe(
 *   DateTime.add({ minutes: 5 })
 * )
 * ```
 */
const DateTime_add = add;
/**
 * Subtract the given `amount` of `unit`'s from a `DateTime`.
 *
 * @since 3.6.0
 * @category math
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * // subtract 5 minutes
 * DateTime.unsafeMake(0).pipe(
 *   DateTime.subtract({ minutes: 5 })
 * )
 * ```
 */
const DateTime_subtract = subtract;
/**
 * Converts a `DateTime` to the start of the given `part`.
 *
 * If the part is `week`, the `weekStartsOn` option can be used to specify the
 * day of the week that the week starts on. The default is 0 (Sunday).
 *
 * @since 3.6.0
 * @category math
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * // returns "2024-01-01T00:00:00Z"
 * DateTime.unsafeMake("2024-01-01T12:00:00Z").pipe(
 *   DateTime.startOf("day"),
 *   DateTime.formatIso
 * )
 * ```
 */
const DateTime_startOf = startOf;
/**
 * Converts a `DateTime` to the end of the given `part`.
 *
 * If the part is `week`, the `weekStartsOn` option can be used to specify the
 * day of the week that the week starts on. The default is 0 (Sunday).
 *
 * @since 3.6.0
 * @category math
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * // returns "2024-01-01T23:59:59.999Z"
 * DateTime.unsafeMake("2024-01-01T12:00:00Z").pipe(
 *   DateTime.endOf("day"),
 *   DateTime.formatIso
 * )
 * ```
 */
const DateTime_endOf = endOf;
/**
 * Converts a `DateTime` to the nearest given `part`.
 *
 * If the part is `week`, the `weekStartsOn` option can be used to specify the
 * day of the week that the week starts on. The default is 0 (Sunday).
 *
 * @since 3.6.0
 * @category math
 * @example
 * ```ts
 * import { DateTime } from "effect"
 *
 * // returns "2024-01-02T00:00:00Z"
 * DateTime.unsafeMake("2024-01-01T12:01:00Z").pipe(
 *   DateTime.nearest("day"),
 *   DateTime.formatIso
 * )
 * ```
 */
const DateTime_nearest = nearest;
// =============================================================================
// formatting
// =============================================================================
/**
 * Format a `DateTime` as a string using the `DateTimeFormat` API.
 *
 * The `timeZone` option is set to the offset of the time zone.
 *
 * Note: On Node versions < 22, fixed "Offset" zones will set the time zone to
 * "UTC" and use the adjusted `Date`.
 *
 * @since 3.6.0
 * @category formatting
 */
const DateTime_format = format;
/**
 * Format a `DateTime` as a string using the `DateTimeFormat` API.
 *
 * It will use the system's local time zone & locale.
 *
 * @since 3.6.0
 * @category formatting
 */
const DateTime_formatLocal = formatLocal;
/**
 * Format a `DateTime` as a string using the `DateTimeFormat` API.
 *
 * This forces the time zone to be UTC.
 *
 * @since 3.6.0
 * @category formatting
 */
const DateTime_formatUtc = formatUtc;
/**
 * Format a `DateTime` as a string using the `DateTimeFormat` API.
 *
 * @since 3.6.0
 * @category formatting
 */
const DateTime_formatIntl = formatIntl;
/**
 * Format a `DateTime` as a UTC ISO string.
 *
 * @since 3.6.0
 * @category formatting
 */
const DateTime_formatIso = formatIso;
/**
 * Format a `DateTime` as a time zone adjusted ISO date string.
 *
 * @since 3.6.0
 * @category formatting
 */
const DateTime_formatIsoDate = formatIsoDate;
/**
 * Format a `DateTime` as a UTC ISO date string.
 *
 * @since 3.6.0
 * @category formatting
 */
const DateTime_formatIsoDateUtc = formatIsoDateUtc;
/**
 * Format a `DateTime.Zoned` as a ISO string with an offset.
 *
 * @since 3.6.0
 * @category formatting
 */
const DateTime_formatIsoOffset = formatIsoOffset;
/**
 * Format a `DateTime.Zoned` as a string.
 *
 * It uses the format: `YYYY-MM-DDTHH:mm:ss.sss+HH:MM[Time/Zone]`.
 *
 * @since 3.6.0
 * @category formatting
 */
const DateTime_formatIsoZoned = formatIsoZoned;
/**
 * Create a Layer from the given time zone.
 *
 * @since 3.6.0
 * @category current time zone
 */
const layerCurrentZone = zone => Layer.succeed(CurrentTimeZone, zone);
/**
 * Create a Layer from the given time zone offset.
 *
 * @since 3.6.0
 * @category current time zone
 */
const layerCurrentZoneOffset = offset => Layer.succeed(CurrentTimeZone, Internal.zoneMakeOffset(offset));
/**
 * Create a Layer from the given IANA time zone identifier.
 *
 * @since 3.6.0
 * @category current time zone
 */
const layerCurrentZoneNamed = zoneId => Layer.effect(CurrentTimeZone, Internal.zoneMakeNamedEffect(zoneId));
/**
 * Create a Layer from the systems local time zone.
 *
 * @since 3.6.0
 * @category current time zone
 */
const layerCurrentZoneLocal = /*#__PURE__*/(/* unused pure expression or super */ null && (Layer.sync(CurrentTimeZone, DateTime_zoneMakeLocal)));
//# sourceMappingURL=DateTime.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Encoding.js + 4 modules
var Encoding = __webpack_require__(53678);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/FiberId.js
var FiberId = __webpack_require__(57303);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/cause.js + 1 modules
var cause = __webpack_require__(69579);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/schema/schemaId.js
/** @internal */
const DateFromSelfSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/DateFromSelf");
/** @internal */
const GreaterThanSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/GreaterThan");
/** @internal */
const GreaterThanOrEqualToSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/GreaterThanOrEqualTo");
/** @internal */
const LessThanSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/LessThan");
/** @internal */
const LessThanOrEqualToSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/LessThanOrEqualTo");
/** @internal */
const IntSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Int");
/** @internal */
const NonNaNSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/NonNaN");
/** @internal */
const FiniteSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Finite");
/** @internal */
const JsonNumberSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/JsonNumber");
/** @internal */
const BetweenSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Between");
/** @internal */
const GreaterThanBigintSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/GreaterThanBigint");
/** @internal */
const GreaterThanOrEqualToBigIntSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/GreaterThanOrEqualToBigint");
/** @internal */
const LessThanBigIntSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/LessThanBigint");
/** @internal */
const LessThanOrEqualToBigIntSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/LessThanOrEqualToBigint");
/** @internal */
const BetweenBigintSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/BetweenBigint");
/** @internal */
const MinLengthSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/MinLength");
/** @internal */
const MaxLengthSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/MaxLength");
/** @internal */
const LengthSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Length");
/** @internal */
const MinItemsSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/MinItems");
/** @internal */
const MaxItemsSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/MaxItems");
/** @internal */
const ItemsCountSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/ItemsCount");
//# sourceMappingURL=schemaId.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/schema/util.js

/** @internal */
const getKeysForIndexSignature = (input, parameter) => {
  switch (parameter._tag) {
    case "StringKeyword":
    case "TemplateLiteral":
      return Object.keys(input);
    case "SymbolKeyword":
      return Object.getOwnPropertySymbols(input);
    case "Refinement":
      return getKeysForIndexSignature(input, parameter.from);
  }
};
/**
 * JavaScript does not store the insertion order of properties in a way that
 * combines both string and symbol keys. The internal order groups string keys
 * and symbol keys separately. Hence concatenating the keys is fine.
 *
 * @internal
 */
const util_ownKeys = o => Object.keys(o).concat(Object.getOwnPropertySymbols(o));
/** @internal */
const memoizeThunk = f => {
  let done = false;
  let a;
  return () => {
    if (done) {
      return a;
    }
    a = f();
    done = true;
    return a;
  };
};
/** @internal */
const formatDate = date => {
  try {
    return date.toISOString();
  } catch (e) {
    return String(date);
  }
};
/** @internal */
const formatUnknown = (u, checkCircular = true) => {
  if (Array.isArray(u)) {
    return `[${u.map(i => formatUnknown(i, checkCircular)).join(",")}]`;
  }
  if (esm_Predicate/* isDate */.J_(u)) {
    return formatDate(u);
  }
  if (esm_Predicate/* hasProperty */.l$(u, "toString") && esm_Predicate/* isFunction */.mf(u["toString"]) && u["toString"] !== Object.prototype.toString) {
    return u["toString"]();
  }
  if (esm_Predicate/* isString */.HD(u)) {
    return JSON.stringify(u);
  }
  if (esm_Predicate/* isNumber */.hj(u) || u == null || esm_Predicate/* isBoolean */.jn(u) || esm_Predicate/* isSymbol */.yk(u)) {
    return String(u);
  }
  if (esm_Predicate/* isBigInt */.C4(u)) {
    return String(u) + "n";
  }
  if (esm_Predicate/* isIterable */.TW(u)) {
    return `${u.constructor.name}(${formatUnknown(Array.from(u), checkCircular)})`;
  }
  try {
    if (checkCircular) {
      JSON.stringify(u); // check for circular references
    }
    const pojo = `{${util_ownKeys(u).map(k => `${esm_Predicate/* isString */.HD(k) ? JSON.stringify(k) : String(k)}:${formatUnknown(u[k], false)}`).join(",")}}`;
    const name = u.constructor.name;
    return u.constructor !== Object.prototype.constructor ? `${name}(${pojo})` : pojo;
  } catch (e) {
    return "<circular structure>";
  }
};
/** @internal */
const formatPropertyKey = name => typeof name === "string" ? JSON.stringify(name) : String(name);
/** @internal */
const isNonEmpty = x => Array.isArray(x);
/** @internal */
const isSingle = x => !Array.isArray(x);
/** @internal */
const formatPathKey = key => `[${formatPropertyKey(key)}]`;
/** @internal */
const formatPath = path => isNonEmpty(path) ? path.map(formatPathKey).join("") : formatPathKey(path);
//# sourceMappingURL=util.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Number.js
var esm_Number = __webpack_require__(15839);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Data.js
var Data = __webpack_require__(21566);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Effect.js + 6 modules
var esm_Effect = __webpack_require__(96347);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Exit.js
var Exit = __webpack_require__(76658);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Scheduler.js
var Scheduler = __webpack_require__(22019);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/schema/errors.js


const getErrorMessage = (reason, details, path, ast) => {
  let out = reason;
  if (path && esm_Array/* isNonEmptyReadonlyArray */.Ux(path)) {
    out += `\nat path: ${formatPath(path)}`;
  }
  if (details !== undefined) {
    out += `\ndetails: ${details}`;
  }
  if (ast) {
    out += `\nschema (${ast._tag}): ${ast}`;
  }
  return out;
};
// ---------------------------------------------
// generic
// ---------------------------------------------
/** @internal */
const getInvalidArgumentErrorMessage = details => getErrorMessage("Invalid Argument", details);
const getUnsupportedSchemaErrorMessage = (details, path, ast) => getErrorMessage("Unsupported schema", details, path, ast);
const getMissingAnnotationErrorMessage = (details, path, ast) => getErrorMessage("Missing annotation", details, path, ast);
// ---------------------------------------------
// Arbitrary
// ---------------------------------------------
/** @internal */
const getArbitraryUnsupportedErrorMessage = (path, ast) => getUnsupportedSchemaErrorMessage("Cannot build an Arbitrary for this schema", path, ast);
/** @internal */
const getArbitraryMissingAnnotationErrorMessage = (path, ast) => getMissingAnnotationErrorMessage(`Generating an Arbitrary for this schema requires an "arbitrary" annotation`, path, ast);
/** @internal */
const getArbitraryEmptyEnumErrorMessage = path => getErrorMessage("Empty Enums schema", "Generating an Arbitrary for this schema requires at least one enum", path);
// ---------------------------------------------
// Equivalence
// ---------------------------------------------
/** @internal */
const getEquivalenceUnsupportedErrorMessage = (ast, path) => getUnsupportedSchemaErrorMessage("Cannot build an Equivalence", path, ast);
// ---------------------------------------------
// JSON Schema
// ---------------------------------------------
/** @internal */
const getJSONSchemaMissingAnnotationErrorMessage = (path, ast) => getMissingAnnotationErrorMessage(`Generating a JSON Schema for this schema requires a "jsonSchema" annotation`, path, ast);
/** @internal */
const getJSONSchemaMissingIdentifierAnnotationErrorMessage = (path, ast) => getMissingAnnotationErrorMessage(`Generating a JSON Schema for this schema requires an "identifier" annotation`, path, ast);
/** @internal */
const getJSONSchemaUnsupportedPostRestElementsErrorMessage = path => getErrorMessage("Generating a JSON Schema for post-rest elements is not currently supported. You're welcome to contribute by submitting a Pull Request", undefined, path);
/** @internal */
const getJSONSchemaUnsupportedKeyErrorMessage = (key, path) => getErrorMessage("Unsupported key", `Cannot encode ${util_.formatPropertyKey(key)} key to JSON Schema`, path);
// ---------------------------------------------
// Pretty
// ---------------------------------------------
/** @internal */
const getPrettyMissingAnnotationErrorMessage = (path, ast) => getMissingAnnotationErrorMessage(`Generating a Pretty for this schema requires a "pretty" annotation`, path, ast);
/** @internal */
const getPrettyNeverErrorMessage = "Cannot pretty print a `never` value";
/** @internal */
const getPrettyNoMatchingSchemaErrorMessage = (actual, path, ast) => getErrorMessage("Unexpected Error", `Cannot find a matching schema for ${util_.formatUnknown(actual)}`, path, ast);
// ---------------------------------------------
// Schema
// ---------------------------------------------
/** @internal */
const getSchemaExtendErrorMessage = (x, y, path) => getErrorMessage("Unsupported schema or overlapping types", `cannot extend ${x} with ${y}`, path);
/** @internal */
const getSchemaUnsupportedLiteralSpanErrorMessage = ast => getErrorMessage("Unsupported template literal span", undefined, undefined, ast);
// ---------------------------------------------
// AST
// ---------------------------------------------
/** @internal */
const getASTUnsupportedSchemaErrorMessage = ast => getUnsupportedSchemaErrorMessage(undefined, undefined, ast);
/** @internal */
const getASTUnsupportedKeySchemaErrorMessage = ast => getErrorMessage("Unsupported key schema", undefined, undefined, ast);
/** @internal */
const getASTUnsupportedLiteralErrorMessage = literal => getErrorMessage("Unsupported literal", `literal value: ${formatUnknown(literal)}`);
/** @internal */
const getASTDuplicateIndexSignatureErrorMessage = type => getErrorMessage("Duplicate index signature", `${type} index signature`);
/** @internal */
const getASTIndexSignatureParameterErrorMessage = /*#__PURE__*/getErrorMessage("Unsupported index signature parameter", "An index signature parameter type must be `string`, `symbol`, a template literal type or a refinement of the previous types");
/** @internal */
const getASTRequiredElementFollowinAnOptionalElementErrorMessage = /*#__PURE__*/getErrorMessage("Invalid element", "A required element cannot follow an optional element. ts(1257)");
/** @internal */
const getASTDuplicatePropertySignatureTransformationErrorMessage = key => getErrorMessage("Duplicate property signature transformation", `Duplicate key ${formatUnknown(key)}`);
/** @internal */
const getASTUnsupportedRenameSchemaErrorMessage = ast => getUnsupportedSchemaErrorMessage(undefined, undefined, ast);
/** @internal */
const getASTDuplicatePropertySignatureErrorMessage = key => getErrorMessage("Duplicate property signature", `Duplicate key ${formatUnknown(key)}`);
//# sourceMappingURL=errors.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/RegExp.js
var esm_RegExp = __webpack_require__(7035);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/SchemaAST.js
/**
 * @since 3.10.0
 */










/**
 * @category annotations
 * @since 3.10.0
 */
const BrandAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Brand");
/**
 * @category annotations
 * @since 3.10.0
 */
const SchemaIdAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/SchemaId");
/**
 * @category annotations
 * @since 3.10.0
 */
const MessageAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Message");
/**
 * @category annotations
 * @since 3.10.0
 */
const MissingMessageAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/MissingMessage");
/**
 * @category annotations
 * @since 3.10.0
 */
const IdentifierAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Identifier");
/**
 * @category annotations
 * @since 3.10.0
 */
const TitleAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Title");
/** @internal */
const AutoTitleAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/AutoTitle");
/**
 * @category annotations
 * @since 3.10.0
 */
const DescriptionAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Description");
/**
 * @category annotations
 * @since 3.10.0
 */
const ExamplesAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Examples");
/**
 * @category annotations
 * @since 3.10.0
 */
const DefaultAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Default");
/**
 * @category annotations
 * @since 3.10.0
 */
const JSONSchemaAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/JSONSchema");
/**
 * @category annotations
 * @since 3.10.0
 */
const ArbitraryAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Arbitrary");
/**
 * @category annotations
 * @since 3.10.0
 */
const PrettyAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Pretty");
/**
 * @category annotations
 * @since 3.10.0
 */
const EquivalenceAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Equivalence");
/**
 * @category annotations
 * @since 3.10.0
 */
const DocumentationAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Documentation");
/**
 * @category annotations
 * @since 3.10.0
 */
const ConcurrencyAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Concurrency");
/**
 * @category annotations
 * @since 3.10.0
 */
const BatchingAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Batching");
/**
 * @category annotations
 * @since 3.10.0
 */
const ParseIssueTitleAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/ParseIssueTitle");
/**
 * @category annotations
 * @since 3.10.0
 */
const ParseOptionsAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/ParseOptions");
/**
 * @category annotations
 * @since 3.10.0
 */
const DecodingFallbackAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/DecodingFallback");
/**
 * @category annotations
 * @since 3.10.0
 */
const SurrogateAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/Surrogate");
/** @internal */
const StableFilterAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/StableFilter");
/**
 * @category annotations
 * @since 3.10.0
 */
const getAnnotation = /*#__PURE__*/(0,Function/* dual */.OB)(2, (annotated, key) => Object.prototype.hasOwnProperty.call(annotated.annotations, key) ? esm_Option/* some */.G(annotated.annotations[key]) : esm_Option/* none */.YP());
/**
 * @category annotations
 * @since 3.10.0
 */
const getBrandAnnotation = /*#__PURE__*/getAnnotation(BrandAnnotationId);
/**
 * @category annotations
 * @since 3.14.2
 */
const getSchemaIdAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(SchemaIdAnnotationId)));
/**
 * @category annotations
 * @since 3.10.0
 */
const getMessageAnnotation = /*#__PURE__*/getAnnotation(MessageAnnotationId);
/**
 * @category annotations
 * @since 3.10.0
 */
const getMissingMessageAnnotation = /*#__PURE__*/getAnnotation(MissingMessageAnnotationId);
/**
 * @category annotations
 * @since 3.10.0
 */
const getTitleAnnotation = /*#__PURE__*/getAnnotation(TitleAnnotationId);
/** @internal */
const getAutoTitleAnnotation = /*#__PURE__*/getAnnotation(AutoTitleAnnotationId);
/**
 * @category annotations
 * @since 3.10.0
 */
const getIdentifierAnnotation = /*#__PURE__*/getAnnotation(IdentifierAnnotationId);
/**
 * @category annotations
 * @since 3.10.0
 */
const getDescriptionAnnotation = /*#__PURE__*/getAnnotation(DescriptionAnnotationId);
/**
 * @category annotations
 * @since 3.10.0
 */
const getExamplesAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(ExamplesAnnotationId)));
/**
 * @category annotations
 * @since 3.10.0
 */
const getDefaultAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(DefaultAnnotationId)));
/**
 * @category annotations
 * @since 3.10.0
 */
const getJSONSchemaAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(JSONSchemaAnnotationId)));
/**
 * @category annotations
 * @since 3.10.0
 */
const getDocumentationAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (getAnnotation(DocumentationAnnotationId)));
/**
 * @category annotations
 * @since 3.10.0
 */
const getConcurrencyAnnotation = /*#__PURE__*/getAnnotation(ConcurrencyAnnotationId);
/**
 * @category annotations
 * @since 3.10.0
 */
const getBatchingAnnotation = /*#__PURE__*/getAnnotation(BatchingAnnotationId);
/**
 * @category annotations
 * @since 3.10.0
 */
const getParseIssueTitleAnnotation = /*#__PURE__*/getAnnotation(ParseIssueTitleAnnotationId);
/**
 * @category annotations
 * @since 3.10.0
 */
const getParseOptionsAnnotation = /*#__PURE__*/getAnnotation(ParseOptionsAnnotationId);
/**
 * @category annotations
 * @since 3.10.0
 */
const getDecodingFallbackAnnotation = /*#__PURE__*/getAnnotation(DecodingFallbackAnnotationId);
/**
 * @category annotations
 * @since 3.10.0
 */
const getSurrogateAnnotation = /*#__PURE__*/getAnnotation(SurrogateAnnotationId);
const getStableFilterAnnotation = /*#__PURE__*/getAnnotation(StableFilterAnnotationId);
/** @internal */
const hasStableFilter = annotated => esm_Option/* exists */.Gg(getStableFilterAnnotation(annotated), b => b === true);
/**
 * @category annotations
 * @since 3.10.0
 */
const JSONIdentifierAnnotationId = /*#__PURE__*/Symbol.for("effect/annotation/JSONIdentifier");
/**
 * @category annotations
 * @since 3.10.0
 */
const getJSONIdentifierAnnotation = /*#__PURE__*/getAnnotation(JSONIdentifierAnnotationId);
/**
 * @category annotations
 * @since 3.10.0
 */
const getJSONIdentifier = annotated => esm_Option/* orElse */.vx(getJSONIdentifierAnnotation(annotated), () => getIdentifierAnnotation(annotated));
// -------------------------------------------------------------------------------------
// schema ids
// -------------------------------------------------------------------------------------
/**
 * @category schema id
 * @since 3.10.0
 */
const ParseJsonSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/schema/ParseJson")));
/**
 * @category model
 * @since 3.10.0
 */
class Declaration {
  typeParameters;
  decodeUnknown;
  encodeUnknown;
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "Declaration";
  constructor(typeParameters, decodeUnknown, encodeUnknown, annotations = {}) {
    this.typeParameters = typeParameters;
    this.decodeUnknown = decodeUnknown;
    this.encodeUnknown = encodeUnknown;
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return esm_Option/* getOrElse */.fS(getExpected(this), () => "<declaration schema>");
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      typeParameters: this.typeParameters.map(ast => ast.toJSON()),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
const createASTGuard = tag => ast => ast._tag === tag;
/**
 * @category guards
 * @since 3.10.0
 */
const isDeclaration = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("Declaration")));
/**
 * @category model
 * @since 3.10.0
 */
class Literal {
  literal;
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "Literal";
  constructor(literal, annotations = {}) {
    this.literal = literal;
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return esm_Option/* getOrElse */.fS(getExpected(this), () => formatUnknown(this.literal));
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      literal: esm_Predicate/* isBigInt */.C4(this.literal) ? String(this.literal) : this.literal,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 3.10.0
 */
const isLiteral = /*#__PURE__*/createASTGuard("Literal");
const $null = /*#__PURE__*/new Literal(null);

/**
 * @category model
 * @since 3.10.0
 */
class UniqueSymbol {
  symbol;
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "UniqueSymbol";
  constructor(symbol, annotations = {}) {
    this.symbol = symbol;
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return esm_Option/* getOrElse */.fS(getExpected(this), () => formatUnknown(this.symbol));
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      symbol: String(this.symbol),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 3.10.0
 */
const isUniqueSymbol = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("UniqueSymbol")));
/**
 * @category model
 * @since 3.10.0
 */
class UndefinedKeyword {
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "UndefinedKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 3.10.0
 */
const undefinedKeyword = /*#__PURE__*/new UndefinedKeyword({
  [TitleAnnotationId]: "undefined"
});
/**
 * @category guards
 * @since 3.10.0
 */
const isUndefinedKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("UndefinedKeyword")));
/**
 * @category model
 * @since 3.10.0
 */
class VoidKeyword {
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "VoidKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 3.10.0
 */
const voidKeyword = /*#__PURE__*/new VoidKeyword({
  [TitleAnnotationId]: "void"
});
/**
 * @category guards
 * @since 3.10.0
 */
const isVoidKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("VoidKeyword")));
/**
 * @category model
 * @since 3.10.0
 */
class NeverKeyword {
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "NeverKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 3.10.0
 */
const neverKeyword = /*#__PURE__*/new NeverKeyword({
  [TitleAnnotationId]: "never"
});
/**
 * @category guards
 * @since 3.10.0
 */
const isNeverKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("NeverKeyword")));
/**
 * @category model
 * @since 3.10.0
 */
class UnknownKeyword {
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "UnknownKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 3.10.0
 */
const unknownKeyword = /*#__PURE__*/new UnknownKeyword({
  [TitleAnnotationId]: "unknown"
});
/**
 * @category guards
 * @since 3.10.0
 */
const isUnknownKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("UnknownKeyword")));
/**
 * @category model
 * @since 3.10.0
 */
class AnyKeyword {
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "AnyKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 3.10.0
 */
const anyKeyword = /*#__PURE__*/new AnyKeyword({
  [TitleAnnotationId]: "any"
});
/**
 * @category guards
 * @since 3.10.0
 */
const isAnyKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("AnyKeyword")));
/**
 * @category model
 * @since 3.10.0
 */
class StringKeyword {
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "StringKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 3.10.0
 */
const stringKeyword = /*#__PURE__*/new StringKeyword({
  [TitleAnnotationId]: "string",
  [DescriptionAnnotationId]: "a string"
});
/**
 * @category guards
 * @since 3.10.0
 */
const isStringKeyword = /*#__PURE__*/createASTGuard("StringKeyword");
/**
 * @category model
 * @since 3.10.0
 */
class NumberKeyword {
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "NumberKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 3.10.0
 */
const numberKeyword = /*#__PURE__*/new NumberKeyword({
  [TitleAnnotationId]: "number",
  [DescriptionAnnotationId]: "a number"
});
/**
 * @category guards
 * @since 3.10.0
 */
const isNumberKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("NumberKeyword")));
/**
 * @category model
 * @since 3.10.0
 */
class BooleanKeyword {
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "BooleanKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 3.10.0
 */
const booleanKeyword = /*#__PURE__*/new BooleanKeyword({
  [TitleAnnotationId]: "boolean",
  [DescriptionAnnotationId]: "a boolean"
});
/**
 * @category guards
 * @since 3.10.0
 */
const isBooleanKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("BooleanKeyword")));
/**
 * @category model
 * @since 3.10.0
 */
class BigIntKeyword {
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "BigIntKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 3.10.0
 */
const bigIntKeyword = /*#__PURE__*/new BigIntKeyword({
  [TitleAnnotationId]: "bigint",
  [DescriptionAnnotationId]: "a bigint"
});
/**
 * @category guards
 * @since 3.10.0
 */
const isBigIntKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("BigIntKeyword")));
/**
 * @category model
 * @since 3.10.0
 */
class SymbolKeyword {
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "SymbolKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 3.10.0
 */
const symbolKeyword = /*#__PURE__*/new SymbolKeyword({
  [TitleAnnotationId]: "symbol",
  [DescriptionAnnotationId]: "a symbol"
});
/**
 * @category guards
 * @since 3.10.0
 */
const isSymbolKeyword = /*#__PURE__*/createASTGuard("SymbolKeyword");
/**
 * @category model
 * @since 3.10.0
 */
class ObjectKeyword {
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "ObjectKeyword";
  constructor(annotations = {}) {
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return formatKeyword(this);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category constructors
 * @since 3.10.0
 */
const objectKeyword = /*#__PURE__*/new ObjectKeyword({
  [TitleAnnotationId]: "object",
  [DescriptionAnnotationId]: "an object in the TypeScript meaning, i.e. the `object` type"
});
/**
 * @category guards
 * @since 3.10.0
 */
const isObjectKeyword = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("ObjectKeyword")));
/**
 * @category model
 * @since 3.10.0
 */
class Enums {
  enums;
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "Enums";
  constructor(enums, annotations = {}) {
    this.enums = enums;
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return Option.getOrElse(getExpected(this), () => `<enum ${this.enums.length} value(s): ${this.enums.map(([_, value]) => JSON.stringify(value)).join(" | ")}>`);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      enums: this.enums,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 3.10.0
 */
const isEnums = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("Enums")));
const isTemplateLiteralSpanType = ast => {
  switch (ast._tag) {
    case "Literal":
    case "NumberKeyword":
    case "StringKeyword":
    case "TemplateLiteral":
      return true;
    case "Union":
      return ast.types.every(isTemplateLiteralSpanType);
  }
  return false;
};
const templateLiteralSpanUnionTypeToString = type => {
  switch (type._tag) {
    case "Literal":
      return JSON.stringify(String(type.literal));
    case "StringKeyword":
      return "string";
    case "NumberKeyword":
      return "number";
    case "TemplateLiteral":
      return String(type);
    case "Union":
      return type.types.map(templateLiteralSpanUnionTypeToString).join(" | ");
  }
};
const templateLiteralSpanTypeToString = type => {
  switch (type._tag) {
    case "Literal":
      return String(type.literal);
    case "StringKeyword":
      return "${string}";
    case "NumberKeyword":
      return "${number}";
    case "TemplateLiteral":
      return "${" + String(type) + "}";
    case "Union":
      return "${" + type.types.map(templateLiteralSpanUnionTypeToString).join(" | ") + "}";
  }
};
/**
 * @category model
 * @since 3.10.0
 */
class TemplateLiteralSpan {
  literal;
  /**
   * @since 3.10.0
   */
  type;
  constructor(type, literal) {
    this.literal = literal;
    if (isTemplateLiteralSpanType(type)) {
      this.type = type;
    } else {
      throw new Error(errors_.getSchemaUnsupportedLiteralSpanErrorMessage(type));
    }
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return templateLiteralSpanTypeToString(this.type) + this.literal;
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      type: this.type.toJSON(),
      literal: this.literal
    };
  }
}
/**
 * @category model
 * @since 3.10.0
 */
class TemplateLiteral {
  head;
  spans;
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "TemplateLiteral";
  constructor(head, spans, annotations = {}) {
    this.head = head;
    this.spans = spans;
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return Option.getOrElse(getExpected(this), () => formatTemplateLiteral(this));
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      head: this.head,
      spans: this.spans.map(span => span.toJSON()),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
const formatTemplateLiteral = ast => "`" + ast.head + ast.spans.map(String).join("") + "`";
/**
 * @category guards
 * @since 3.10.0
 */
const isTemplateLiteral = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("TemplateLiteral")));
/**
 * @category model
 * @since 3.10.0
 */
class Type {
  type;
  annotations;
  constructor(type, annotations = {}) {
    this.type = type;
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      type: this.type.toJSON(),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return String(this.type);
  }
}
/**
 * @category model
 * @since 3.10.0
 */
class OptionalType extends Type {
  isOptional;
  constructor(type, isOptional, annotations = {}) {
    super(type, annotations);
    this.isOptional = isOptional;
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      type: this.type.toJSON(),
      isOptional: this.isOptional,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return String(this.type) + (this.isOptional ? "?" : "");
  }
}
const getRestASTs = rest => rest.map(annotatedAST => annotatedAST.type);
/**
 * @category model
 * @since 3.10.0
 */
class TupleType {
  elements;
  rest;
  isReadonly;
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "TupleType";
  constructor(elements, rest, isReadonly, annotations = {}) {
    this.elements = elements;
    this.rest = rest;
    this.isReadonly = isReadonly;
    this.annotations = annotations;
    let hasOptionalElement = false;
    let hasIllegalRequiredElement = false;
    for (const e of elements) {
      if (e.isOptional) {
        hasOptionalElement = true;
      } else if (hasOptionalElement) {
        hasIllegalRequiredElement = true;
        break;
      }
    }
    if (hasIllegalRequiredElement || hasOptionalElement && rest.length > 1) {
      throw new Error(getASTRequiredElementFollowinAnOptionalElementErrorMessage);
    }
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return esm_Option/* getOrElse */.fS(getExpected(this), () => formatTuple(this));
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      elements: this.elements.map(e => e.toJSON()),
      rest: this.rest.map(ast => ast.toJSON()),
      isReadonly: this.isReadonly,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
const formatTuple = ast => {
  const formattedElements = ast.elements.map(String).join(", ");
  return esm_Array/* matchLeft */.aL(ast.rest, {
    onEmpty: () => `readonly [${formattedElements}]`,
    onNonEmpty: (head, tail) => {
      const formattedHead = String(head);
      const wrappedHead = formattedHead.includes(" | ") ? `(${formattedHead})` : formattedHead;
      if (tail.length > 0) {
        const formattedTail = tail.map(String).join(", ");
        if (ast.elements.length > 0) {
          return `readonly [${formattedElements}, ...${wrappedHead}[], ${formattedTail}]`;
        } else {
          return `readonly [...${wrappedHead}[], ${formattedTail}]`;
        }
      } else {
        if (ast.elements.length > 0) {
          return `readonly [${formattedElements}, ...${wrappedHead}[]]`;
        } else {
          return `ReadonlyArray<${formattedHead}>`;
        }
      }
    }
  });
};
/**
 * @category guards
 * @since 3.10.0
 */
const isTupleType = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("TupleType")));
/**
 * @category model
 * @since 3.10.0
 */
class PropertySignature extends OptionalType {
  name;
  isReadonly;
  constructor(name, type, isOptional, isReadonly, annotations) {
    super(type, isOptional, annotations);
    this.name = name;
    this.isReadonly = isReadonly;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return (this.isReadonly ? "readonly " : "") + String(this.name) + (this.isOptional ? "?" : "") + ": " + this.type;
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      name: String(this.name),
      type: this.type.toJSON(),
      isOptional: this.isOptional,
      isReadonly: this.isReadonly,
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @since 3.10.0
 */
const isParameter = ast => {
  switch (ast._tag) {
    case "StringKeyword":
    case "SymbolKeyword":
    case "TemplateLiteral":
      return true;
    case "Refinement":
      return isParameter(ast.from);
  }
  return false;
};
/**
 * @category model
 * @since 3.10.0
 */
class IndexSignature {
  type;
  isReadonly;
  /**
   * @since 3.10.0
   */
  parameter;
  constructor(parameter, type, isReadonly) {
    this.type = type;
    this.isReadonly = isReadonly;
    if (isParameter(parameter)) {
      this.parameter = parameter;
    } else {
      throw new Error(getASTIndexSignatureParameterErrorMessage);
    }
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return (this.isReadonly ? "readonly " : "") + `[x: ${this.parameter}]: ${this.type}`;
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      parameter: this.parameter.toJSON(),
      type: this.type.toJSON(),
      isReadonly: this.isReadonly
    };
  }
}
/**
 * @category model
 * @since 3.10.0
 */
class TypeLiteral {
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "TypeLiteral";
  /**
   * @since 3.10.0
   */
  propertySignatures;
  /**
   * @since 3.10.0
   */
  indexSignatures;
  constructor(propertySignatures, indexSignatures, annotations = {}) {
    this.annotations = annotations;
    // check for duplicate property signatures
    const keys = {};
    for (let i = 0; i < propertySignatures.length; i++) {
      const name = propertySignatures[i].name;
      if (Object.prototype.hasOwnProperty.call(keys, name)) {
        throw new Error(getASTDuplicatePropertySignatureErrorMessage(name));
      }
      keys[name] = null;
    }
    // check for duplicate index signatures
    const parameters = {
      string: false,
      symbol: false
    };
    for (let i = 0; i < indexSignatures.length; i++) {
      const encodedParameter = getEncodedParameter(indexSignatures[i].parameter);
      if (isStringKeyword(encodedParameter)) {
        if (parameters.string) {
          throw new Error(getASTDuplicateIndexSignatureErrorMessage("string"));
        }
        parameters.string = true;
      } else if (isSymbolKeyword(encodedParameter)) {
        if (parameters.symbol) {
          throw new Error(getASTDuplicateIndexSignatureErrorMessage("symbol"));
        }
        parameters.symbol = true;
      }
    }
    this.propertySignatures = propertySignatures;
    this.indexSignatures = indexSignatures;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return esm_Option/* getOrElse */.fS(getExpected(this), () => formatTypeLiteral(this));
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      propertySignatures: this.propertySignatures.map(ps => ps.toJSON()),
      indexSignatures: this.indexSignatures.map(ps => ps.toJSON()),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
const formatIndexSignatures = iss => iss.map(String).join("; ");
const formatTypeLiteral = ast => {
  if (ast.propertySignatures.length > 0) {
    const pss = ast.propertySignatures.map(String).join("; ");
    if (ast.indexSignatures.length > 0) {
      return `{ ${pss}; ${formatIndexSignatures(ast.indexSignatures)} }`;
    } else {
      return `{ ${pss} }`;
    }
  } else {
    if (ast.indexSignatures.length > 0) {
      return `{ ${formatIndexSignatures(ast.indexSignatures)} }`;
    } else {
      return "{}";
    }
  }
};
/**
 * @category guards
 * @since 3.10.0
 */
const isTypeLiteral = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("TypeLiteral")));
const sortCandidates = /*#__PURE__*/esm_Array/* sort */.wx( /*#__PURE__*/Order/* mapInput */.$H(esm_Number/* Order */.KM, ast => {
  switch (ast._tag) {
    case "AnyKeyword":
      return 0;
    case "UnknownKeyword":
      return 1;
    case "ObjectKeyword":
      return 2;
    case "StringKeyword":
    case "NumberKeyword":
    case "BooleanKeyword":
    case "BigIntKeyword":
    case "SymbolKeyword":
      return 3;
  }
  return 4;
}));
const literalMap = {
  string: "StringKeyword",
  number: "NumberKeyword",
  boolean: "BooleanKeyword",
  bigint: "BigIntKeyword"
};
/** @internal */
const flatten = candidates => esm_Array/* flatMap */.VS(candidates, ast => isUnion(ast) ? flatten(ast.types) : [ast]);
/** @internal */
const unify = candidates => {
  const cs = sortCandidates(candidates);
  const out = [];
  const uniques = {};
  const literals = [];
  for (const ast of cs) {
    switch (ast._tag) {
      case "NeverKeyword":
        break;
      case "AnyKeyword":
        return [anyKeyword];
      case "UnknownKeyword":
        return [unknownKeyword];
      // uniques
      case "ObjectKeyword":
      case "UndefinedKeyword":
      case "VoidKeyword":
      case "StringKeyword":
      case "NumberKeyword":
      case "BooleanKeyword":
      case "BigIntKeyword":
      case "SymbolKeyword":
        {
          if (!uniques[ast._tag]) {
            uniques[ast._tag] = ast;
            out.push(ast);
          }
          break;
        }
      case "Literal":
        {
          const type = typeof ast.literal;
          switch (type) {
            case "string":
            case "number":
            case "bigint":
            case "boolean":
              {
                const _tag = literalMap[type];
                if (!uniques[_tag] && !literals.includes(ast.literal)) {
                  literals.push(ast.literal);
                  out.push(ast);
                }
                break;
              }
            // null
            case "object":
              {
                if (!literals.includes(ast.literal)) {
                  literals.push(ast.literal);
                  out.push(ast);
                }
                break;
              }
          }
          break;
        }
      case "UniqueSymbol":
        {
          if (!uniques["SymbolKeyword"] && !literals.includes(ast.symbol)) {
            literals.push(ast.symbol);
            out.push(ast);
          }
          break;
        }
      case "TupleType":
        {
          if (!uniques["ObjectKeyword"]) {
            out.push(ast);
          }
          break;
        }
      case "TypeLiteral":
        {
          if (ast.propertySignatures.length === 0 && ast.indexSignatures.length === 0) {
            if (!uniques["{}"]) {
              uniques["{}"] = ast;
              out.push(ast);
            }
          } else if (!uniques["ObjectKeyword"]) {
            out.push(ast);
          }
          break;
        }
      default:
        out.push(ast);
    }
  }
  return out;
};
/**
 * @category model
 * @since 3.10.0
 */
class Union {
  types;
  annotations;
  static make = (types, annotations) => {
    return isMembers(types) ? new Union(types, annotations) : types.length === 1 ? types[0] : neverKeyword;
  };
  /** @internal */
  static unify = (candidates, annotations) => {
    return Union.make(unify(flatten(candidates)), annotations);
  };
  /**
   * @since 3.10.0
   */
  _tag = "Union";
  constructor(types, annotations = {}) {
    this.types = types;
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return esm_Option/* getOrElse */.fS(getExpected(this), () => this.types.map(String).join(" | "));
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      types: this.types.map(ast => ast.toJSON()),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/** @internal */
const mapMembers = (members, f) => members.map(f);
/** @internal */
const isMembers = as => as.length > 1;
/**
 * @category guards
 * @since 3.10.0
 */
const isUnion = /*#__PURE__*/createASTGuard("Union");
const toJSONMemoMap = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/Schema/AST/toJSONMemoMap"), () => new WeakMap());
/**
 * @category model
 * @since 3.10.0
 */
class Suspend {
  f;
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "Suspend";
  constructor(f, annotations = {}) {
    this.f = f;
    this.annotations = annotations;
    this.f = memoizeThunk(f);
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return getExpected(this).pipe(esm_Option/* orElse */.vx(() => esm_Option/* flatMap */.VS(esm_Option/* liftThrowable */.eZ(this.f)(), ast => getExpected(ast))), esm_Option/* getOrElse */.fS(() => "<suspended schema>"));
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    const ast = this.f();
    let out = toJSONMemoMap.get(ast);
    if (out) {
      return out;
    }
    toJSONMemoMap.set(ast, {
      _tag: this._tag
    });
    out = {
      _tag: this._tag,
      ast: ast.toJSON(),
      annotations: toJSONAnnotations(this.annotations)
    };
    toJSONMemoMap.set(ast, out);
    return out;
  }
}
/**
 * @category guards
 * @since 3.10.0
 */
const isSuspend = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("Suspend")));
/**
 * @category model
 * @since 3.10.0
 */
class Refinement {
  from;
  filter;
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "Refinement";
  constructor(from, filter, annotations = {}) {
    this.from = from;
    this.filter = filter;
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return getIdentifierAnnotation(this).pipe(esm_Option/* getOrElse */.fS(() => esm_Option/* match */.EQ(getOrElseExpected(this), {
      onNone: () => `{ ${this.from} | filter }`,
      onSome: expected => isRefinement(this.from) ? String(this.from) + " & " + expected : expected
    })));
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      from: this.from.toJSON(),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 3.10.0
 */
const isRefinement = /*#__PURE__*/createASTGuard("Refinement");
/**
 * @since 3.10.0
 */
const defaultParseOption = {};
/**
 * @category model
 * @since 3.10.0
 */
class Transformation {
  from;
  to;
  transformation;
  annotations;
  /**
   * @since 3.10.0
   */
  _tag = "Transformation";
  constructor(from, to, transformation, annotations = {}) {
    this.from = from;
    this.to = to;
    this.transformation = transformation;
    this.annotations = annotations;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return esm_Option/* getOrElse */.fS(getExpected(this), () => `(${String(this.from)} <-> ${String(this.to)})`);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _tag: this._tag,
      from: this.from.toJSON(),
      to: this.to.toJSON(),
      annotations: toJSONAnnotations(this.annotations)
    };
  }
}
/**
 * @category guards
 * @since 3.10.0
 */
const isTransformation = /*#__PURE__*/(/* unused pure expression or super */ null && (createASTGuard("Transformation")));
/**
 * @category model
 * @since 3.10.0
 */
class FinalTransformation {
  decode;
  encode;
  /**
   * @since 3.10.0
   */
  _tag = "FinalTransformation";
  constructor(decode, encode) {
    this.decode = decode;
    this.encode = encode;
  }
}
const createTransformationGuard = tag => ast => ast._tag === tag;
/**
 * @category guards
 * @since 3.10.0
 */
const isFinalTransformation = /*#__PURE__*/(/* unused pure expression or super */ null && (createTransformationGuard("FinalTransformation")));
/**
 * @category model
 * @since 3.10.0
 */
class ComposeTransformation {
  /**
   * @since 3.10.0
   */
  _tag = "ComposeTransformation";
}
/**
 * @category constructors
 * @since 3.10.0
 */
const composeTransformation = /*#__PURE__*/new ComposeTransformation();
/**
 * @category guards
 * @since 3.10.0
 */
const isComposeTransformation = /*#__PURE__*/(/* unused pure expression or super */ null && (createTransformationGuard("ComposeTransformation")));
/**
 * Represents a `PropertySignature -> PropertySignature` transformation
 *
 * The semantic of `decode` is:
 * - `none()` represents the absence of the key/value pair
 * - `some(value)` represents the presence of the key/value pair
 *
 * The semantic of `encode` is:
 * - `none()` you don't want to output the key/value pair
 * - `some(value)` you want to output the key/value pair
 *
 * @category model
 * @since 3.10.0
 */
class PropertySignatureTransformation {
  from;
  to;
  decode;
  encode;
  constructor(from, to, decode, encode) {
    this.from = from;
    this.to = to;
    this.decode = decode;
    this.encode = encode;
  }
}
const isRenamingPropertySignatureTransformation = t => t.decode === identity && t.encode === identity;
/**
 * @category model
 * @since 3.10.0
 */
class TypeLiteralTransformation {
  propertySignatureTransformations;
  /**
   * @since 3.10.0
   */
  _tag = "TypeLiteralTransformation";
  constructor(propertySignatureTransformations) {
    this.propertySignatureTransformations = propertySignatureTransformations;
    // check for duplicate property signature transformations
    const fromKeys = {};
    const toKeys = {};
    for (const pst of propertySignatureTransformations) {
      const from = pst.from;
      if (fromKeys[from]) {
        throw new Error(getASTDuplicatePropertySignatureTransformationErrorMessage(from));
      }
      fromKeys[from] = true;
      const to = pst.to;
      if (toKeys[to]) {
        throw new Error(getASTDuplicatePropertySignatureTransformationErrorMessage(to));
      }
      toKeys[to] = true;
    }
  }
}
/**
 * @category guards
 * @since 3.10.0
 */
const isTypeLiteralTransformation = /*#__PURE__*/(/* unused pure expression or super */ null && (createTransformationGuard("TypeLiteralTransformation")));
// -------------------------------------------------------------------------------------
// API
// -------------------------------------------------------------------------------------
/**
 * Merges a set of new annotations with existing ones, potentially overwriting
 * any duplicates.
 *
 * @since 3.10.0
 */
const SchemaAST_annotations = (ast, overrides) => {
  const d = Object.getOwnPropertyDescriptors(ast);
  const value = {
    ...ast.annotations,
    ...overrides
  };
  const surrogate = getSurrogateAnnotation(ast);
  if (esm_Option/* isSome */.pC(surrogate)) {
    value[SurrogateAnnotationId] = SchemaAST_annotations(surrogate.value, overrides);
  }
  d.annotations.value = value;
  return Object.create(Object.getPrototypeOf(ast), d);
};
/**
 * Equivalent at runtime to the TypeScript type-level `keyof` operator.
 *
 * @since 3.10.0
 */
const keyof = ast => Union.unify(_keyof(ast));
const STRING_KEYWORD_PATTERN = "[\\s\\S]*"; // any string, including newlines
const NUMBER_KEYWORD_PATTERN = "[+-]?\\d*\\.?\\d+(?:[Ee][+-]?\\d+)?";
const getTemplateLiteralSpanTypePattern = (type, capture) => {
  switch (type._tag) {
    case "Literal":
      return esm_RegExp/* escape */.Y(String(type.literal));
    case "StringKeyword":
      return STRING_KEYWORD_PATTERN;
    case "NumberKeyword":
      return NUMBER_KEYWORD_PATTERN;
    case "TemplateLiteral":
      return getTemplateLiteralPattern(type, capture, false);
    case "Union":
      return type.types.map(type => getTemplateLiteralSpanTypePattern(type, capture)).join("|");
  }
};
const handleTemplateLiteralSpanTypeParens = (type, s, capture, top) => {
  if (isUnion(type)) {
    if (capture && !top) {
      return `(?:${s})`;
    }
  } else if (!capture || !top) {
    return s;
  }
  return `(${s})`;
};
const getTemplateLiteralPattern = (ast, capture, top) => {
  let pattern = ``;
  if (ast.head !== "") {
    const head = esm_RegExp/* escape */.Y(ast.head);
    pattern += capture && top ? `(${head})` : head;
  }
  for (const span of ast.spans) {
    const spanPattern = getTemplateLiteralSpanTypePattern(span.type, capture);
    pattern += handleTemplateLiteralSpanTypeParens(span.type, spanPattern, capture, top);
    if (span.literal !== "") {
      const literal = esm_RegExp/* escape */.Y(span.literal);
      pattern += capture && top ? `(${literal})` : literal;
    }
  }
  return pattern;
};
/**
 * Generates a regular expression from a `TemplateLiteral` AST node.
 *
 * @see {@link getTemplateLiteralCapturingRegExp} for a variant that captures the pattern.
 *
 * @since 3.10.0
 */
const getTemplateLiteralRegExp = ast => new RegExp(`^${getTemplateLiteralPattern(ast, false, true)}$`);
/**
 * Generates a regular expression that captures the pattern defined by the given `TemplateLiteral` AST.
 *
 * @see {@link getTemplateLiteralRegExp} for a variant that does not capture the pattern.
 *
 * @since 3.10.0
 */
const getTemplateLiteralCapturingRegExp = ast => new RegExp(`^${getTemplateLiteralPattern(ast, true, true)}$`);
/**
 * @since 3.10.0
 */
const getPropertySignatures = ast => {
  const annotation = getSurrogateAnnotation(ast);
  if (Option.isSome(annotation)) {
    return getPropertySignatures(annotation.value);
  }
  switch (ast._tag) {
    case "TypeLiteral":
      return ast.propertySignatures.slice();
    case "Suspend":
      return getPropertySignatures(ast.f());
    case "Refinement":
      return getPropertySignatures(ast.from);
  }
  return getPropertyKeys(ast).map(name => getPropertyKeyIndexedAccess(ast, name));
};
const getIndexSignatures = ast => {
  const annotation = getSurrogateAnnotation(ast);
  if (Option.isSome(annotation)) {
    return getIndexSignatures(annotation.value);
  }
  switch (ast._tag) {
    case "TypeLiteral":
      return ast.indexSignatures.slice();
    case "Suspend":
      return getIndexSignatures(ast.f());
    case "Refinement":
      return getIndexSignatures(ast.from);
  }
  return [];
};
/** @internal */
const getNumberIndexedAccess = ast => {
  switch (ast._tag) {
    case "TupleType":
      {
        let hasOptional = false;
        let out = [];
        for (const e of ast.elements) {
          if (e.isOptional) {
            hasOptional = true;
          }
          out.push(e.type);
        }
        if (hasOptional) {
          out.push(undefinedKeyword);
        }
        out = out.concat(getRestASTs(ast.rest));
        return Union.make(out);
      }
    case "Refinement":
      return getNumberIndexedAccess(ast.from);
    case "Union":
      return Union.make(ast.types.map(getNumberIndexedAccess));
    case "Suspend":
      return getNumberIndexedAccess(ast.f());
  }
  throw new Error(errors_.getASTUnsupportedSchemaErrorMessage(ast));
};
const getTypeLiteralPropertySignature = (ast, name) => {
  // from property signatures...
  const ops = Arr.findFirst(ast.propertySignatures, ps => ps.name === name);
  if (Option.isSome(ops)) {
    return ops.value;
  }
  // from index signatures...
  if (Predicate.isString(name)) {
    let out = undefined;
    for (const is of ast.indexSignatures) {
      const encodedParameter = getEncodedParameter(is.parameter);
      switch (encodedParameter._tag) {
        case "TemplateLiteral":
          {
            const regex = getTemplateLiteralRegExp(encodedParameter);
            if (regex.test(name)) {
              return new PropertySignature(name, is.type, false, true);
            }
            break;
          }
        case "StringKeyword":
          {
            if (out === undefined) {
              out = new PropertySignature(name, is.type, false, true);
            }
          }
      }
    }
    if (out) {
      return out;
    }
  } else if (Predicate.isSymbol(name)) {
    for (const is of ast.indexSignatures) {
      const encodedParameter = getEncodedParameter(is.parameter);
      if (isSymbolKeyword(encodedParameter)) {
        return new PropertySignature(name, is.type, false, true);
      }
    }
  }
};
/** @internal */
const getPropertyKeyIndexedAccess = (ast, name) => {
  const annotation = getSurrogateAnnotation(ast);
  if (Option.isSome(annotation)) {
    return getPropertyKeyIndexedAccess(annotation.value, name);
  }
  switch (ast._tag) {
    case "TypeLiteral":
      {
        const ps = getTypeLiteralPropertySignature(ast, name);
        if (ps) {
          return ps;
        }
        break;
      }
    case "Union":
      return new PropertySignature(name, Union.make(ast.types.map(ast => getPropertyKeyIndexedAccess(ast, name).type)), false, true);
    case "Suspend":
      return getPropertyKeyIndexedAccess(ast.f(), name);
    case "Refinement":
      return getPropertyKeyIndexedAccess(ast.from, name);
  }
  throw new Error(errors_.getASTUnsupportedSchemaErrorMessage(ast));
};
const getPropertyKeys = ast => {
  const annotation = getSurrogateAnnotation(ast);
  if (Option.isSome(annotation)) {
    return getPropertyKeys(annotation.value);
  }
  switch (ast._tag) {
    case "TypeLiteral":
      return ast.propertySignatures.map(ps => ps.name);
    case "Union":
      return ast.types.slice(1).reduce((out, ast) => Arr.intersection(out, getPropertyKeys(ast)), getPropertyKeys(ast.types[0]));
    case "Suspend":
      return getPropertyKeys(ast.f());
    case "Refinement":
      return getPropertyKeys(ast.from);
    case "Transformation":
      return getPropertyKeys(ast.to);
  }
  return [];
};
/** @internal */
const record = (key, value) => {
  const propertySignatures = [];
  const indexSignatures = [];
  const go = key => {
    switch (key._tag) {
      case "NeverKeyword":
        break;
      case "StringKeyword":
      case "SymbolKeyword":
      case "TemplateLiteral":
      case "Refinement":
        indexSignatures.push(new IndexSignature(key, value, true));
        break;
      case "Literal":
        if (esm_Predicate/* isString */.HD(key.literal) || esm_Predicate/* isNumber */.hj(key.literal)) {
          propertySignatures.push(new PropertySignature(key.literal, value, false, true));
        } else {
          throw new Error(getASTUnsupportedLiteralErrorMessage(key.literal));
        }
        break;
      case "Enums":
        {
          for (const [_, name] of key.enums) {
            propertySignatures.push(new PropertySignature(name, value, false, true));
          }
          break;
        }
      case "UniqueSymbol":
        propertySignatures.push(new PropertySignature(key.symbol, value, false, true));
        break;
      case "Union":
        key.types.forEach(go);
        break;
      default:
        throw new Error(getASTUnsupportedKeySchemaErrorMessage(key));
    }
  };
  go(key);
  return {
    propertySignatures,
    indexSignatures
  };
};
/**
 * Equivalent at runtime to the built-in TypeScript utility type `Pick`.
 *
 * @since 3.10.0
 */
const pick = (ast, keys) => {
  const annotation = getSurrogateAnnotation(ast);
  if (Option.isSome(annotation)) {
    return pick(annotation.value, keys);
  }
  switch (ast._tag) {
    case "TypeLiteral":
      {
        const pss = [];
        const names = {};
        for (const ps of ast.propertySignatures) {
          names[ps.name] = null;
          if (keys.includes(ps.name)) {
            pss.push(ps);
          }
        }
        for (const key of keys) {
          if (!(key in names)) {
            const ps = getTypeLiteralPropertySignature(ast, key);
            if (ps) {
              pss.push(ps);
            }
          }
        }
        return new TypeLiteral(pss, []);
      }
    case "Union":
      return new TypeLiteral(keys.map(name => getPropertyKeyIndexedAccess(ast, name)), []);
    case "Suspend":
      return pick(ast.f(), keys);
    case "Refinement":
      return pick(ast.from, keys);
    case "Transformation":
      {
        switch (ast.transformation._tag) {
          case "ComposeTransformation":
            return new Transformation(pick(ast.from, keys), pick(ast.to, keys), composeTransformation);
          case "TypeLiteralTransformation":
            {
              const ts = [];
              const fromKeys = [];
              for (const k of keys) {
                const t = ast.transformation.propertySignatureTransformations.find(t => t.to === k);
                if (t) {
                  ts.push(t);
                  fromKeys.push(t.from);
                } else {
                  fromKeys.push(k);
                }
              }
              return Arr.isNonEmptyReadonlyArray(ts) ? new Transformation(pick(ast.from, fromKeys), pick(ast.to, keys), new TypeLiteralTransformation(ts)) : pick(ast.from, fromKeys);
            }
        }
      }
  }
  throw new Error(errors_.getASTUnsupportedSchemaErrorMessage(ast));
};
/**
 * Equivalent at runtime to the built-in TypeScript utility type `Omit`.
 *
 * @since 3.10.0
 */
const omit = (ast, keys) => {
  let indexSignatures = getIndexSignatures(ast);
  if (indexSignatures.length > 0) {
    if (indexSignatures.some(is => isStringKeyword(getEncodedParameter(is.parameter)))) {
      indexSignatures = indexSignatures.filter(is => !isTemplateLiteral(getEncodedParameter(is.parameter)));
    }
    return new TypeLiteral([], indexSignatures);
  }
  return pick(ast, getPropertyKeys(ast).filter(name => !keys.includes(name)));
};
/** @internal */
const orUndefined = ast => Union.make([ast, undefinedKeyword]);
/**
 * Equivalent at runtime to the built-in TypeScript utility type `Partial`.
 *
 * @since 3.10.0
 */
const partial = (ast, options) => {
  const exact = options?.exact === true;
  switch (ast._tag) {
    case "TupleType":
      return new TupleType(ast.elements.map(e => new OptionalType(exact ? e.type : orUndefined(e.type), true)), Arr.match(ast.rest, {
        onEmpty: () => ast.rest,
        onNonEmpty: rest => [new Type(Union.make([...getRestASTs(rest), undefinedKeyword]))]
      }), ast.isReadonly);
    case "TypeLiteral":
      return new TypeLiteral(ast.propertySignatures.map(ps => new PropertySignature(ps.name, exact ? ps.type : orUndefined(ps.type), true, ps.isReadonly, ps.annotations)), ast.indexSignatures.map(is => new IndexSignature(is.parameter, orUndefined(is.type), is.isReadonly)));
    case "Union":
      return Union.make(ast.types.map(member => partial(member, options)));
    case "Suspend":
      return new Suspend(() => partial(ast.f(), options));
    case "Declaration":
    case "Refinement":
      throw new Error(errors_.getASTUnsupportedSchemaErrorMessage(ast));
    case "Transformation":
      {
        if (isTypeLiteralTransformation(ast.transformation) && ast.transformation.propertySignatureTransformations.every(isRenamingPropertySignatureTransformation)) {
          return new Transformation(partial(ast.from, options), partial(ast.to, options), ast.transformation);
        }
        throw new Error(errors_.getASTUnsupportedSchemaErrorMessage(ast));
      }
  }
  return ast;
};
/**
 * Equivalent at runtime to the built-in TypeScript utility type `Required`.
 *
 * @since 3.10.0
 */
const required = ast => {
  switch (ast._tag) {
    case "TupleType":
      return new TupleType(ast.elements.map(e => new OptionalType(e.type, false)), ast.rest, ast.isReadonly);
    case "TypeLiteral":
      return new TypeLiteral(ast.propertySignatures.map(f => new PropertySignature(f.name, f.type, false, f.isReadonly, f.annotations)), ast.indexSignatures);
    case "Union":
      return Union.make(ast.types.map(member => required(member)));
    case "Suspend":
      return new Suspend(() => required(ast.f()));
    case "Declaration":
    case "Refinement":
      throw new Error(errors_.getASTUnsupportedSchemaErrorMessage(ast));
    case "Transformation":
      {
        if (isTypeLiteralTransformation(ast.transformation) && ast.transformation.propertySignatureTransformations.every(isRenamingPropertySignatureTransformation)) {
          return new Transformation(required(ast.from), required(ast.to), ast.transformation);
        }
        throw new Error(errors_.getASTUnsupportedSchemaErrorMessage(ast));
      }
  }
  return ast;
};
/**
 * Creates a new AST with shallow mutability applied to its properties.
 *
 * @since 3.10.0
 */
const mutable = ast => {
  switch (ast._tag) {
    case "TupleType":
      return ast.isReadonly === false ? ast : new TupleType(ast.elements, ast.rest, false, ast.annotations);
    case "TypeLiteral":
      {
        const propertySignatures = changeMap(ast.propertySignatures, ps => ps.isReadonly === false ? ps : new PropertySignature(ps.name, ps.type, ps.isOptional, false, ps.annotations));
        const indexSignatures = changeMap(ast.indexSignatures, is => is.isReadonly === false ? is : new IndexSignature(is.parameter, is.type, false));
        return propertySignatures === ast.propertySignatures && indexSignatures === ast.indexSignatures ? ast : new TypeLiteral(propertySignatures, indexSignatures, ast.annotations);
      }
    case "Union":
      {
        const types = changeMap(ast.types, mutable);
        return types === ast.types ? ast : Union.make(types, ast.annotations);
      }
    case "Suspend":
      return new Suspend(() => mutable(ast.f()), ast.annotations);
    case "Refinement":
      {
        const from = mutable(ast.from);
        return from === ast.from ? ast : new Refinement(from, ast.filter, ast.annotations);
      }
    case "Transformation":
      {
        const from = mutable(ast.from);
        const to = mutable(ast.to);
        return from === ast.from && to === ast.to ? ast : new Transformation(from, to, ast.transformation, ast.annotations);
      }
  }
  return ast;
};
/**
 * @since 3.10.0
 */
const getCompiler = match => {
  const compile = (ast, path) => match[ast._tag](ast, compile, path);
  return compile;
};
/** @internal */
const pickAnnotations = annotationIds => annotated => {
  let out = undefined;
  for (const id of annotationIds) {
    if (Object.prototype.hasOwnProperty.call(annotated.annotations, id)) {
      if (out === undefined) {
        out = {};
      }
      out[id] = annotated.annotations[id];
    }
  }
  return out;
};
/** @internal */
const omitAnnotations = annotationIds => annotated => {
  const out = {
    ...annotated.annotations
  };
  for (const id of annotationIds) {
    delete out[id];
  }
  return out;
};
const preserveTransformationAnnotations = /*#__PURE__*/pickAnnotations([ExamplesAnnotationId, DefaultAnnotationId, JSONSchemaAnnotationId, ArbitraryAnnotationId, PrettyAnnotationId, EquivalenceAnnotationId]);
/**
 * @since 3.10.0
 */
const typeAST = ast => {
  switch (ast._tag) {
    case "Declaration":
      {
        const typeParameters = changeMap(ast.typeParameters, typeAST);
        return typeParameters === ast.typeParameters ? ast : new Declaration(typeParameters, ast.decodeUnknown, ast.encodeUnknown, ast.annotations);
      }
    case "TupleType":
      {
        const elements = changeMap(ast.elements, e => {
          const type = typeAST(e.type);
          return type === e.type ? e : new OptionalType(type, e.isOptional);
        });
        const restASTs = getRestASTs(ast.rest);
        const rest = changeMap(restASTs, typeAST);
        return elements === ast.elements && rest === restASTs ? ast : new TupleType(elements, rest.map(type => new Type(type)), ast.isReadonly, ast.annotations);
      }
    case "TypeLiteral":
      {
        const propertySignatures = changeMap(ast.propertySignatures, p => {
          const type = typeAST(p.type);
          return type === p.type ? p : new PropertySignature(p.name, type, p.isOptional, p.isReadonly);
        });
        const indexSignatures = changeMap(ast.indexSignatures, is => {
          const type = typeAST(is.type);
          return type === is.type ? is : new IndexSignature(is.parameter, type, is.isReadonly);
        });
        return propertySignatures === ast.propertySignatures && indexSignatures === ast.indexSignatures ? ast : new TypeLiteral(propertySignatures, indexSignatures, ast.annotations);
      }
    case "Union":
      {
        const types = changeMap(ast.types, typeAST);
        return types === ast.types ? ast : Union.make(types, ast.annotations);
      }
    case "Suspend":
      return new Suspend(() => typeAST(ast.f()), ast.annotations);
    case "Refinement":
      {
        const from = typeAST(ast.from);
        return from === ast.from ? ast : new Refinement(from, ast.filter, ast.annotations);
      }
    case "Transformation":
      {
        const preserve = preserveTransformationAnnotations(ast);
        return typeAST(preserve !== undefined ? SchemaAST_annotations(ast.to, preserve) : ast.to);
      }
  }
  return ast;
};
// To generate a JSON Schema from a recursive schema, an `identifier` annotation
// is required. So, when we calculate the encodedAST, we need to preserve the
// annotation in the form of an internal custom annotation that acts as a
// surrogate for the identifier, which the JSON Schema compiler can then read.
const createJSONIdentifierAnnotation = annotated => esm_Option/* match */.EQ(getJSONIdentifier(annotated), {
  onNone: () => undefined,
  onSome: identifier => ({
    [JSONIdentifierAnnotationId]: identifier
  })
});
function changeMap(as, f) {
  let changed = false;
  const out = esm_Array/* allocate */.TK(as.length);
  for (let i = 0; i < as.length; i++) {
    const a = as[i];
    const fa = f(a);
    if (fa !== a) {
      changed = true;
    }
    out[i] = fa;
  }
  return changed ? out : as;
}
/**
 * Returns the from part of a transformation if it exists
 *
 * @internal
 */
const getTransformationFrom = ast => {
  switch (ast._tag) {
    case "Transformation":
      return ast.from;
    case "Refinement":
      return getTransformationFrom(ast.from);
    case "Suspend":
      return getTransformationFrom(ast.f());
  }
};
const encodedAST_ = (ast, isBound) => {
  switch (ast._tag) {
    case "Declaration":
      {
        const typeParameters = changeMap(ast.typeParameters, ast => encodedAST_(ast, isBound));
        return typeParameters === ast.typeParameters ? ast : new Declaration(typeParameters, ast.decodeUnknown, ast.encodeUnknown, ast.annotations);
      }
    case "TupleType":
      {
        const elements = changeMap(ast.elements, e => {
          const type = encodedAST_(e.type, isBound);
          return type === e.type ? e : new OptionalType(type, e.isOptional);
        });
        const restASTs = getRestASTs(ast.rest);
        const rest = changeMap(restASTs, ast => encodedAST_(ast, isBound));
        return elements === ast.elements && rest === restASTs ? ast : new TupleType(elements, rest.map(ast => new Type(ast)), ast.isReadonly, createJSONIdentifierAnnotation(ast));
      }
    case "TypeLiteral":
      {
        const propertySignatures = changeMap(ast.propertySignatures, ps => {
          const type = encodedAST_(ps.type, isBound);
          return type === ps.type ? ps : new PropertySignature(ps.name, type, ps.isOptional, ps.isReadonly);
        });
        const indexSignatures = changeMap(ast.indexSignatures, is => {
          const type = encodedAST_(is.type, isBound);
          return type === is.type ? is : new IndexSignature(is.parameter, type, is.isReadonly);
        });
        return propertySignatures === ast.propertySignatures && indexSignatures === ast.indexSignatures ? ast : new TypeLiteral(propertySignatures, indexSignatures, createJSONIdentifierAnnotation(ast));
      }
    case "Union":
      {
        const types = changeMap(ast.types, ast => encodedAST_(ast, isBound));
        return types === ast.types ? ast : Union.make(types, createJSONIdentifierAnnotation(ast));
      }
    case "Suspend":
      return new Suspend(() => encodedAST_(ast.f(), isBound), createJSONIdentifierAnnotation(ast));
    case "Refinement":
      {
        const from = encodedAST_(ast.from, isBound);
        if (isBound) {
          if (from === ast.from) {
            return ast;
          }
          if (getTransformationFrom(ast.from) === undefined && hasStableFilter(ast)) {
            return new Refinement(from, ast.filter, ast.annotations);
          }
        }
        const identifier = createJSONIdentifierAnnotation(ast);
        return identifier ? SchemaAST_annotations(from, identifier) : from;
      }
    case "Transformation":
      {
        const identifier = createJSONIdentifierAnnotation(ast);
        return encodedAST_(identifier ? SchemaAST_annotations(ast.from, identifier) : ast.from, isBound);
      }
  }
  return ast;
};
/**
 * @since 3.10.0
 */
const encodedAST = ast => encodedAST_(ast, false);
/**
 * @since 3.10.0
 */
const encodedBoundAST = ast => encodedAST_(ast, true);
const toJSONAnnotations = annotations => {
  const out = {};
  for (const k of Object.getOwnPropertySymbols(annotations)) {
    out[String(k)] = annotations[k];
  }
  return out;
};
/** @internal */
const getEncodedParameter = ast => {
  switch (ast._tag) {
    case "StringKeyword":
    case "SymbolKeyword":
    case "TemplateLiteral":
      return ast;
    case "Refinement":
      return getEncodedParameter(ast.from);
  }
};
/** @internal  */
const equals = (self, that) => {
  switch (self._tag) {
    case "Literal":
      return isLiteral(that) && that.literal === self.literal;
    case "UniqueSymbol":
      return isUniqueSymbol(that) && that.symbol === self.symbol;
    case "UndefinedKeyword":
    case "VoidKeyword":
    case "NeverKeyword":
    case "UnknownKeyword":
    case "AnyKeyword":
    case "StringKeyword":
    case "NumberKeyword":
    case "BooleanKeyword":
    case "BigIntKeyword":
    case "SymbolKeyword":
    case "ObjectKeyword":
      return that._tag === self._tag;
    case "TemplateLiteral":
      return isTemplateLiteral(that) && that.head === self.head && equalsTemplateLiteralSpan(that.spans, self.spans);
    case "Enums":
      return isEnums(that) && equalsEnums(that.enums, self.enums);
    case "Union":
      return isUnion(that) && equalsUnion(self.types, that.types);
    case "Refinement":
    case "TupleType":
    case "TypeLiteral":
    case "Suspend":
    case "Transformation":
    case "Declaration":
      return self === that;
  }
};
const equalsTemplateLiteralSpan = /*#__PURE__*/(/* unused pure expression or super */ null && (Arr.getEquivalence((self, that) => {
  return self.literal === that.literal && equals(self.type, that.type);
})));
const equalsEnums = /*#__PURE__*/(/* unused pure expression or super */ null && (Arr.getEquivalence((self, that) => that[0] === self[0] && that[1] === self[1])));
const equalsUnion = /*#__PURE__*/(/* unused pure expression or super */ null && (Arr.getEquivalence(equals)));
const intersection = /*#__PURE__*/(/* unused pure expression or super */ null && (Arr.intersectionWith(equals)));
const _keyof = ast => {
  switch (ast._tag) {
    case "Declaration":
      {
        const annotation = getSurrogateAnnotation(ast);
        if (Option.isSome(annotation)) {
          return _keyof(annotation.value);
        }
        break;
      }
    case "TypeLiteral":
      return ast.propertySignatures.map(p => Predicate.isSymbol(p.name) ? new UniqueSymbol(p.name) : new Literal(p.name)).concat(ast.indexSignatures.map(is => getEncodedParameter(is.parameter)));
    case "Suspend":
      return _keyof(ast.f());
    case "Union":
      return ast.types.slice(1).reduce((out, ast) => intersection(out, _keyof(ast)), _keyof(ast.types[0]));
    case "Transformation":
      return _keyof(ast.to);
  }
  throw new Error(errors_.getASTUnsupportedSchemaErrorMessage(ast));
};
/** @internal */
const compose = (ab, cd) => new Transformation(ab, cd, composeTransformation);
/** @internal */
const rename = (ast, mapping) => {
  switch (ast._tag) {
    case "TypeLiteral":
      {
        const propertySignatureTransformations = [];
        for (const key of util_.ownKeys(mapping)) {
          const name = mapping[key];
          if (name !== undefined) {
            propertySignatureTransformations.push(new PropertySignatureTransformation(key, name, identity, identity));
          }
        }
        if (propertySignatureTransformations.length === 0) {
          return ast;
        }
        return new Transformation(ast, new TypeLiteral(ast.propertySignatures.map(ps => {
          const name = mapping[ps.name];
          return new PropertySignature(name === undefined ? ps.name : name, typeAST(ps.type), ps.isOptional, ps.isReadonly, ps.annotations);
        }), ast.indexSignatures), new TypeLiteralTransformation(propertySignatureTransformations));
      }
    case "Union":
      return Union.make(ast.types.map(ast => rename(ast, mapping)));
    case "Suspend":
      return new Suspend(() => rename(ast.f(), mapping));
    case "Transformation":
      return compose(ast, rename(typeAST(ast), mapping));
  }
  throw new Error(errors_.getASTUnsupportedRenameSchemaErrorMessage(ast));
};
const formatKeyword = ast => esm_Option/* getOrElse */.fS(getExpected(ast), () => ast._tag);
function getBrands(ast) {
  return esm_Option/* match */.EQ(getBrandAnnotation(ast), {
    onNone: () => "",
    onSome: brands => brands.map(brand => ` & Brand<${formatUnknown(brand)}>`).join("")
  });
}
const getOrElseExpected = ast => getTitleAnnotation(ast).pipe(esm_Option/* orElse */.vx(() => getDescriptionAnnotation(ast)), esm_Option/* orElse */.vx(() => getAutoTitleAnnotation(ast)), esm_Option/* map */.UI(s => s + getBrands(ast)));
const getExpected = ast => esm_Option/* orElse */.vx(getIdentifierAnnotation(ast), () => getOrElseExpected(ast));
/** @internal */
const pruneUndefined = (ast, self, onTransformation) => {
  switch (ast._tag) {
    case "UndefinedKeyword":
      return neverKeyword;
    case "Union":
      {
        const types = [];
        let hasUndefined = false;
        for (const type of ast.types) {
          const pruned = self(type);
          if (pruned) {
            hasUndefined = true;
            if (!isNeverKeyword(pruned)) {
              types.push(pruned);
            }
          } else {
            types.push(type);
          }
        }
        if (hasUndefined) {
          return Union.make(types);
        }
        break;
      }
    case "Suspend":
      return self(ast.f());
    case "Transformation":
      return onTransformation(ast);
  }
};
//# sourceMappingURL=SchemaAST.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/ParseResult.js
/**
 * @since 3.10.0
 */














/**
 * @category model
 * @since 3.10.0
 */
class Pointer {
  path;
  actual;
  issue;
  /**
   * @since 3.10.0
   */
  _tag = "Pointer";
  constructor(path, actual, issue) {
    this.path = path;
    this.actual = actual;
    this.issue = issue;
  }
}
/**
 * Error that occurs when an unexpected key or index is present.
 *
 * @category model
 * @since 3.10.0
 */
class Unexpected {
  actual;
  message;
  /**
   * @since 3.10.0
   */
  _tag = "Unexpected";
  constructor(actual,
  /**
   * @since 3.10.0
   */
  message) {
    this.actual = actual;
    this.message = message;
  }
}
/**
 * Error that occurs when a required key or index is missing.
 *
 * @category model
 * @since 3.10.0
 */
class Missing {
  ast;
  message;
  /**
   * @since 3.10.0
   */
  _tag = "Missing";
  /**
   * @since 3.10.0
   */
  actual = undefined;
  constructor(
  /**
   * @since 3.10.0
   */
  ast,
  /**
   * @since 3.10.0
   */
  message) {
    this.ast = ast;
    this.message = message;
  }
}
/**
 * Error that contains multiple issues.
 *
 * @category model
 * @since 3.10.0
 */
class Composite {
  ast;
  actual;
  issues;
  output;
  /**
   * @since 3.10.0
   */
  _tag = "Composite";
  constructor(ast, actual, issues, output) {
    this.ast = ast;
    this.actual = actual;
    this.issues = issues;
    this.output = output;
  }
}
/**
 * Error that occurs when a refinement has an error.
 *
 * @category model
 * @since 3.10.0
 */
class ParseResult_Refinement {
  ast;
  actual;
  kind;
  issue;
  /**
   * @since 3.10.0
   */
  _tag = "Refinement";
  constructor(ast, actual, kind, issue) {
    this.ast = ast;
    this.actual = actual;
    this.kind = kind;
    this.issue = issue;
  }
}
/**
 * Error that occurs when a transformation has an error.
 *
 * @category model
 * @since 3.10.0
 */
class ParseResult_Transformation {
  ast;
  actual;
  kind;
  issue;
  /**
   * @since 3.10.0
   */
  _tag = "Transformation";
  constructor(ast, actual, kind, issue) {
    this.ast = ast;
    this.actual = actual;
    this.kind = kind;
    this.issue = issue;
  }
}
/**
 * The `Type` variant of the `ParseIssue` type represents an error that occurs when the `actual` value is not of the expected type.
 * The `ast` field specifies the expected type, and the `actual` field contains the value that caused the error.
 *
 * @category model
 * @since 3.10.0
 */
class ParseResult_Type {
  ast;
  actual;
  message;
  /**
   * @since 3.10.0
   */
  _tag = "Type";
  constructor(ast, actual, message) {
    this.ast = ast;
    this.actual = actual;
    this.message = message;
  }
}
/**
 * The `Forbidden` variant of the `ParseIssue` type represents a forbidden operation, such as when encountering an Effect that is not allowed to execute (e.g., using `runSync`).
 *
 * @category model
 * @since 3.10.0
 */
class Forbidden {
  ast;
  actual;
  message;
  /**
   * @since 3.10.0
   */
  _tag = "Forbidden";
  constructor(ast, actual, message) {
    this.ast = ast;
    this.actual = actual;
    this.message = message;
  }
}
/**
 * @category type id
 * @since 3.10.0
 */
const ParseErrorTypeId = /*#__PURE__*/Symbol.for("effect/Schema/ParseErrorTypeId");
/**
 * @since 3.10.0
 */
const isParseError = u => Predicate.hasProperty(u, ParseErrorTypeId);
/**
 * @since 3.10.0
 */
class ParseError extends /*#__PURE__*/(0,Data/* TaggedError */.fZ)("ParseError") {
  /**
   * @since 3.10.0
   */
  [ParseErrorTypeId] = ParseErrorTypeId;
  get message() {
    return this.toString();
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return TreeFormatter.formatIssueSync(this.issue);
  }
  /**
   * @since 3.10.0
   */
  toJSON() {
    return {
      _id: "ParseError",
      message: this.toString()
    };
  }
  /**
   * @since 3.10.0
   */
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return this.toJSON();
  }
}
/**
 * @category constructors
 * @since 3.10.0
 */
const parseError = issue => new ParseError({
  issue
});
/**
 * @category constructors
 * @since 3.10.0
 */
const succeed = esm_Either/* right */.F2;
/**
 * @category constructors
 * @since 3.10.0
 */
const fail = esm_Either/* left */.t$;
const _try = esm_Either/* try */.JH;

/**
 * @category constructors
 * @since 3.10.0
 */
const fromOption = esm_Either/* fromOption */.Yo;
const isEither = esm_Either/* isEither */.FT;
/**
 * @category optimisation
 * @since 3.10.0
 */
const flatMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  return isEither(self) ? esm_Either/* match */.EQ(self, {
    onLeft: esm_Either/* left */.t$,
    onRight: f
  }) : esm_Effect/* flatMap */.VSD(self, f);
});
/**
 * @category optimisation
 * @since 3.10.0
 */
const map = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  return isEither(self) ? esm_Either/* map */.UI(self, f) : esm_Effect/* map */.UID(self, f);
});
/**
 * @category optimisation
 * @since 3.10.0
 */
const mapError = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  return isEither(self) ? esm_Either/* mapLeft */.Vn(self, f) : esm_Effect/* mapError */.d1Y(self, f);
});
// TODO(4.0): remove
/**
 * @category optimisation
 * @since 3.10.0
 */
const eitherOrUndefined = self => {
  if (isEither(self)) {
    return self;
  }
};
/**
 * @category optimisation
 * @since 3.10.0
 */
const mapBoth = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, options) => {
  return isEither(self) ? esm_Either/* mapBoth */.SA(self, {
    onLeft: options.onFailure,
    onRight: options.onSuccess
  }) : esm_Effect/* mapBoth */.SAn(self, options);
});
/**
 * @category optimisation
 * @since 3.10.0
 */
const orElse = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  return isEither(self) ? esm_Either/* match */.EQ(self, {
    onLeft: f,
    onRight: esm_Either/* right */.F2
  }) : esm_Effect/* catchAll */.kmb(self, f);
});
/** @internal */
const mergeInternalOptions = (options, overrideOptions) => {
  if (overrideOptions === undefined || esm_Predicate/* isNumber */.hj(overrideOptions)) {
    return options;
  }
  if (options === undefined) {
    return overrideOptions;
  }
  return {
    ...options,
    ...overrideOptions
  };
};
const getEither = (ast, isDecoding, options) => {
  const parser = goMemo(ast, isDecoding);
  return (u, overrideOptions) => parser(u, mergeInternalOptions(options, overrideOptions));
};
const getSync = (ast, isDecoding, options) => {
  const parser = getEither(ast, isDecoding, options);
  return (input, overrideOptions) => esm_Either/* getOrThrowWith */.G$(parser(input, overrideOptions), parseError);
};
/** @internal */
const getOption = (ast, isDecoding, options) => {
  const parser = getEither(ast, isDecoding, options);
  return (input, overrideOptions) => Option.getRight(parser(input, overrideOptions));
};
const getEffect = (ast, isDecoding, options) => {
  const parser = goMemo(ast, isDecoding);
  return (input, overrideOptions) => parser(input, {
    ...mergeInternalOptions(options, overrideOptions),
    isEffectAllowed: true
  });
};
/**
 * @throws `ParseError`
 * @category decoding
 * @since 3.10.0
 */
const decodeUnknownSync = (schema, options) => getSync(schema.ast, true, options);
/**
 * @category decoding
 * @since 3.10.0
 */
const decodeUnknownOption = (schema, options) => getOption(schema.ast, true, options);
/**
 * @category decoding
 * @since 3.10.0
 */
const decodeUnknownEither = (schema, options) => getEither(schema.ast, true, options);
/**
 * @category decoding
 * @since 3.10.0
 */
const decodeUnknownPromise = (schema, options) => {
  const parser = decodeUnknown(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category decoding
 * @since 3.10.0
 */
const decodeUnknown = (schema, options) => getEffect(schema.ast, true, options);
/**
 * @throws `ParseError`
 * @category encoding
 * @since 3.10.0
 */
const encodeUnknownSync = (schema, options) => getSync(schema.ast, false, options);
/**
 * @category encoding
 * @since 3.10.0
 */
const encodeUnknownOption = (schema, options) => getOption(schema.ast, false, options);
/**
 * @category encoding
 * @since 3.10.0
 */
const encodeUnknownEither = (schema, options) => getEither(schema.ast, false, options);
/**
 * @category encoding
 * @since 3.10.0
 */
const encodeUnknownPromise = (schema, options) => {
  const parser = encodeUnknown(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category encoding
 * @since 3.10.0
 */
const encodeUnknown = (schema, options) => getEffect(schema.ast, false, options);
/**
 * @category decoding
 * @since 3.10.0
 */
const decodeSync = (/* unused pure expression or super */ null && (decodeUnknownSync));
/**
 * @category decoding
 * @since 3.10.0
 */
const decodeOption = (/* unused pure expression or super */ null && (decodeUnknownOption));
/**
 * @category decoding
 * @since 3.10.0
 */
const decodeEither = (/* unused pure expression or super */ null && (decodeUnknownEither));
/**
 * @category decoding
 * @since 3.10.0
 */
const decodePromise = (/* unused pure expression or super */ null && (decodeUnknownPromise));
/**
 * @category decoding
 * @since 3.10.0
 */
const decode = (/* unused pure expression or super */ null && (decodeUnknown));
/**
 * @throws `ParseError`
 * @category validation
 * @since 3.10.0
 */
const validateSync = (schema, options) => getSync(typeAST(schema.ast), true, options);
/**
 * @category validation
 * @since 3.10.0
 */
const validateOption = (schema, options) => getOption(AST.typeAST(schema.ast), true, options);
/**
 * @category validation
 * @since 3.10.0
 */
const validateEither = (schema, options) => getEither(AST.typeAST(schema.ast), true, options);
/**
 * @category validation
 * @since 3.10.0
 */
const validatePromise = (schema, options) => {
  const parser = validate(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category validation
 * @since 3.10.0
 */
const validate = (schema, options) => getEffect(AST.typeAST(schema.ast), true, options);
/**
 * By default the option `exact` is set to `true`.
 *
 * @category validation
 * @since 3.10.0
 */
const is = (schema, options) => {
  const parser = goMemo(AST.typeAST(schema.ast), true);
  return (u, overrideOptions) => Either.isRight(parser(u, {
    exact: true,
    ...mergeInternalOptions(options, overrideOptions)
  }));
};
/**
 * By default the option `exact` is set to `true`.
 *
 * @throws `ParseError`
 * @category validation
 * @since 3.10.0
 */
const asserts = (schema, options) => {
  const parser = goMemo(AST.typeAST(schema.ast), true);
  return (u, overrideOptions) => {
    const result = parser(u, {
      exact: true,
      ...mergeInternalOptions(options, overrideOptions)
    });
    if (Either.isLeft(result)) {
      throw parseError(result.left);
    }
  };
};
/**
 * @category encoding
 * @since 3.10.0
 */
const encodeSync = (/* unused pure expression or super */ null && (encodeUnknownSync));
/**
 * @category encoding
 * @since 3.10.0
 */
const encodeOption = (/* unused pure expression or super */ null && (encodeUnknownOption));
/**
 * @category encoding
 * @since 3.10.0
 */
const encodeEither = (/* unused pure expression or super */ null && (encodeUnknownEither));
/**
 * @category encoding
 * @since 3.10.0
 */
const encodePromise = (/* unused pure expression or super */ null && (encodeUnknownPromise));
/**
 * @category encoding
 * @since 3.10.0
 */
const encode = (/* unused pure expression or super */ null && (encodeUnknown));
const decodeMemoMap = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/ParseResult/decodeMemoMap"), () => new WeakMap());
const encodeMemoMap = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/ParseResult/encodeMemoMap"), () => new WeakMap());
const goMemo = (ast, isDecoding) => {
  const memoMap = isDecoding ? decodeMemoMap : encodeMemoMap;
  const memo = memoMap.get(ast);
  if (memo) {
    return memo;
  }
  const raw = go(ast, isDecoding);
  const parseOptionsAnnotation = getParseOptionsAnnotation(ast);
  const parserWithOptions = esm_Option/* isSome */.pC(parseOptionsAnnotation) ? (i, options) => raw(i, mergeInternalOptions(options, parseOptionsAnnotation.value)) : raw;
  const decodingFallbackAnnotation = getDecodingFallbackAnnotation(ast);
  const parser = isDecoding && esm_Option/* isSome */.pC(decodingFallbackAnnotation) ? (i, options) => handleForbidden(orElse(parserWithOptions(i, options), decodingFallbackAnnotation.value), ast, i, options) : parserWithOptions;
  memoMap.set(ast, parser);
  return parser;
};
const getConcurrency = ast => esm_Option/* getOrUndefined */.jD(getConcurrencyAnnotation(ast));
const getBatching = ast => esm_Option/* getOrUndefined */.jD(getBatchingAnnotation(ast));
const go = (ast, isDecoding) => {
  switch (ast._tag) {
    case "Refinement":
      {
        if (isDecoding) {
          const from = goMemo(ast.from, true);
          return (i, options) => {
            options = options ?? defaultParseOption;
            const allErrors = options?.errors === "all";
            const result = flatMap(orElse(from(i, options), ef => {
              const issue = new ParseResult_Refinement(ast, i, "From", ef);
              if (allErrors && hasStableFilter(ast) && isComposite(ef)) {
                return esm_Option/* match */.EQ(ast.filter(i, options, ast), {
                  onNone: () => esm_Either/* left */.t$(issue),
                  onSome: ep => esm_Either/* left */.t$(new Composite(ast, i, [issue, new ParseResult_Refinement(ast, i, "Predicate", ep)]))
                });
              }
              return esm_Either/* left */.t$(issue);
            }), a => esm_Option/* match */.EQ(ast.filter(a, options, ast), {
              onNone: () => esm_Either/* right */.F2(a),
              onSome: ep => esm_Either/* left */.t$(new ParseResult_Refinement(ast, i, "Predicate", ep))
            }));
            return handleForbidden(result, ast, i, options);
          };
        } else {
          const from = goMemo(typeAST(ast), true);
          const to = goMemo(dropRightRefinement(ast.from), false);
          return (i, options) => handleForbidden(flatMap(from(i, options), a => to(a, options)), ast, i, options);
        }
      }
    case "Transformation":
      {
        const transform = getFinalTransformation(ast.transformation, isDecoding);
        const from = isDecoding ? goMemo(ast.from, true) : goMemo(ast.to, false);
        const to = isDecoding ? goMemo(ast.to, true) : goMemo(ast.from, false);
        return (i, options) => handleForbidden(flatMap(mapError(from(i, options), e => new ParseResult_Transformation(ast, i, isDecoding ? "Encoded" : "Type", e)), a => flatMap(mapError(transform(a, options ?? defaultParseOption, ast, i), e => new ParseResult_Transformation(ast, i, "Transformation", e)), i2 => mapError(to(i2, options), e => new ParseResult_Transformation(ast, i, isDecoding ? "Type" : "Encoded", e)))), ast, i, options);
      }
    case "Declaration":
      {
        const parse = isDecoding ? ast.decodeUnknown(...ast.typeParameters) : ast.encodeUnknown(...ast.typeParameters);
        return (i, options) => handleForbidden(parse(i, options ?? defaultParseOption, ast), ast, i, options);
      }
    case "Literal":
      return fromRefinement(ast, u => u === ast.literal);
    case "UniqueSymbol":
      return fromRefinement(ast, u => u === ast.symbol);
    case "UndefinedKeyword":
      return fromRefinement(ast, esm_Predicate/* isUndefined */.o8);
    case "NeverKeyword":
      return fromRefinement(ast, esm_Predicate/* isNever */.r2);
    case "UnknownKeyword":
    case "AnyKeyword":
    case "VoidKeyword":
      return esm_Either/* right */.F2;
    case "StringKeyword":
      return fromRefinement(ast, esm_Predicate/* isString */.HD);
    case "NumberKeyword":
      return fromRefinement(ast, esm_Predicate/* isNumber */.hj);
    case "BooleanKeyword":
      return fromRefinement(ast, esm_Predicate/* isBoolean */.jn);
    case "BigIntKeyword":
      return fromRefinement(ast, esm_Predicate/* isBigInt */.C4);
    case "SymbolKeyword":
      return fromRefinement(ast, esm_Predicate/* isSymbol */.yk);
    case "ObjectKeyword":
      return fromRefinement(ast, esm_Predicate/* isObject */.Kn);
    case "Enums":
      return fromRefinement(ast, u => ast.enums.some(([_, value]) => value === u));
    case "TemplateLiteral":
      {
        const regex = getTemplateLiteralRegExp(ast);
        return fromRefinement(ast, u => esm_Predicate/* isString */.HD(u) && regex.test(u));
      }
    case "TupleType":
      {
        const elements = ast.elements.map(e => goMemo(e.type, isDecoding));
        const rest = ast.rest.map(annotatedAST => goMemo(annotatedAST.type, isDecoding));
        let requiredTypes = ast.elements.filter(e => !e.isOptional);
        if (ast.rest.length > 0) {
          requiredTypes = requiredTypes.concat(ast.rest.slice(1));
        }
        const requiredLen = requiredTypes.length;
        const expectedIndexes = ast.elements.length > 0 ? ast.elements.map((_, i) => i).join(" | ") : "never";
        const concurrency = getConcurrency(ast);
        const batching = getBatching(ast);
        return (input, options) => {
          if (!esm_Array/* isArray */.kJ(input)) {
            return esm_Either/* left */.t$(new ParseResult_Type(ast, input));
          }
          const allErrors = options?.errors === "all";
          const es = [];
          let stepKey = 0;
          const output = [];
          // ---------------------------------------------
          // handle missing indexes
          // ---------------------------------------------
          const len = input.length;
          for (let i = len; i <= requiredLen - 1; i++) {
            const e = new Pointer(i, input, new Missing(requiredTypes[i - len]));
            if (allErrors) {
              es.push([stepKey++, e]);
              continue;
            } else {
              return esm_Either/* left */.t$(new Composite(ast, input, e, output));
            }
          }
          // ---------------------------------------------
          // handle excess indexes
          // ---------------------------------------------
          if (ast.rest.length === 0) {
            for (let i = ast.elements.length; i <= len - 1; i++) {
              const e = new Pointer(i, input, new Unexpected(input[i], `is unexpected, expected: ${expectedIndexes}`));
              if (allErrors) {
                es.push([stepKey++, e]);
                continue;
              } else {
                return esm_Either/* left */.t$(new Composite(ast, input, e, output));
              }
            }
          }
          let i = 0;
          let queue = undefined;
          // ---------------------------------------------
          // handle elements
          // ---------------------------------------------
          for (; i < elements.length; i++) {
            if (len < i + 1) {
              if (ast.elements[i].isOptional) {
                // the input element is missing
                continue;
              }
            } else {
              const parser = elements[i];
              const te = parser(input[i], options);
              if (isEither(te)) {
                if (esm_Either/* isLeft */.nM(te)) {
                  // the input element is present but is not valid
                  const e = new Pointer(i, input, te.left);
                  if (allErrors) {
                    es.push([stepKey++, e]);
                    continue;
                  } else {
                    return esm_Either/* left */.t$(new Composite(ast, input, e, sortByIndex(output)));
                  }
                }
                output.push([stepKey++, te.right]);
              } else {
                const nk = stepKey++;
                const index = i;
                if (!queue) {
                  queue = [];
                }
                queue.push(({
                  es,
                  output
                }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(te), t => {
                  if (esm_Either/* isLeft */.nM(t)) {
                    // the input element is present but is not valid
                    const e = new Pointer(index, input, t.left);
                    if (allErrors) {
                      es.push([nk, e]);
                      return esm_Effect/* void */.Hcj;
                    } else {
                      return esm_Either/* left */.t$(new Composite(ast, input, e, sortByIndex(output)));
                    }
                  }
                  output.push([nk, t.right]);
                  return esm_Effect/* void */.Hcj;
                }));
              }
            }
          }
          // ---------------------------------------------
          // handle rest element
          // ---------------------------------------------
          if (esm_Array/* isNonEmptyReadonlyArray */.Ux(rest)) {
            const [head, ...tail] = rest;
            for (; i < len - tail.length; i++) {
              const te = head(input[i], options);
              if (isEither(te)) {
                if (esm_Either/* isLeft */.nM(te)) {
                  const e = new Pointer(i, input, te.left);
                  if (allErrors) {
                    es.push([stepKey++, e]);
                    continue;
                  } else {
                    return esm_Either/* left */.t$(new Composite(ast, input, e, sortByIndex(output)));
                  }
                } else {
                  output.push([stepKey++, te.right]);
                }
              } else {
                const nk = stepKey++;
                const index = i;
                if (!queue) {
                  queue = [];
                }
                queue.push(({
                  es,
                  output
                }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(te), t => {
                  if (esm_Either/* isLeft */.nM(t)) {
                    const e = new Pointer(index, input, t.left);
                    if (allErrors) {
                      es.push([nk, e]);
                      return esm_Effect/* void */.Hcj;
                    } else {
                      return esm_Either/* left */.t$(new Composite(ast, input, e, sortByIndex(output)));
                    }
                  } else {
                    output.push([nk, t.right]);
                    return esm_Effect/* void */.Hcj;
                  }
                }));
              }
            }
            // ---------------------------------------------
            // handle post rest elements
            // ---------------------------------------------
            for (let j = 0; j < tail.length; j++) {
              i += j;
              if (len < i + 1) {
                continue;
              } else {
                const te = tail[j](input[i], options);
                if (isEither(te)) {
                  if (esm_Either/* isLeft */.nM(te)) {
                    // the input element is present but is not valid
                    const e = new Pointer(i, input, te.left);
                    if (allErrors) {
                      es.push([stepKey++, e]);
                      continue;
                    } else {
                      return esm_Either/* left */.t$(new Composite(ast, input, e, sortByIndex(output)));
                    }
                  }
                  output.push([stepKey++, te.right]);
                } else {
                  const nk = stepKey++;
                  const index = i;
                  if (!queue) {
                    queue = [];
                  }
                  queue.push(({
                    es,
                    output
                  }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(te), t => {
                    if (esm_Either/* isLeft */.nM(t)) {
                      // the input element is present but is not valid
                      const e = new Pointer(index, input, t.left);
                      if (allErrors) {
                        es.push([nk, e]);
                        return esm_Effect/* void */.Hcj;
                      } else {
                        return esm_Either/* left */.t$(new Composite(ast, input, e, sortByIndex(output)));
                      }
                    }
                    output.push([nk, t.right]);
                    return esm_Effect/* void */.Hcj;
                  }));
                }
              }
            }
          }
          // ---------------------------------------------
          // compute result
          // ---------------------------------------------
          const computeResult = ({
            es,
            output
          }) => esm_Array/* isNonEmptyArray */.Of(es) ? esm_Either/* left */.t$(new Composite(ast, input, sortByIndex(es), sortByIndex(output))) : esm_Either/* right */.F2(sortByIndex(output));
          if (queue && queue.length > 0) {
            const cqueue = queue;
            return esm_Effect/* suspend */.RqG(() => {
              const state = {
                es: esm_Array/* copy */.JG(es),
                output: esm_Array/* copy */.JG(output)
              };
              return esm_Effect/* flatMap */.VSD(esm_Effect/* forEach */.Ed_(cqueue, f => f(state), {
                concurrency,
                batching,
                discard: true
              }), () => computeResult(state));
            });
          }
          return computeResult({
            output,
            es
          });
        };
      }
    case "TypeLiteral":
      {
        if (ast.propertySignatures.length === 0 && ast.indexSignatures.length === 0) {
          return fromRefinement(ast, esm_Predicate/* isNotNullable */.jW);
        }
        const propertySignatures = [];
        const expectedKeysMap = {};
        const expectedKeys = [];
        for (const ps of ast.propertySignatures) {
          propertySignatures.push([goMemo(ps.type, isDecoding), ps]);
          expectedKeysMap[ps.name] = null;
          expectedKeys.push(ps.name);
        }
        const indexSignatures = ast.indexSignatures.map(is => [goMemo(is.parameter, isDecoding), goMemo(is.type, isDecoding), is.parameter]);
        const expectedAST = Union.make(ast.indexSignatures.map(is => is.parameter).concat(expectedKeys.map(key => esm_Predicate/* isSymbol */.yk(key) ? new UniqueSymbol(key) : new Literal(key))));
        const expected = goMemo(expectedAST, isDecoding);
        const concurrency = getConcurrency(ast);
        const batching = getBatching(ast);
        return (input, options) => {
          if (!esm_Predicate/* isRecord */.Uy(input)) {
            return esm_Either/* left */.t$(new ParseResult_Type(ast, input));
          }
          const allErrors = options?.errors === "all";
          const es = [];
          let stepKey = 0;
          // ---------------------------------------------
          // handle excess properties
          // ---------------------------------------------
          const onExcessPropertyError = options?.onExcessProperty === "error";
          const onExcessPropertyPreserve = options?.onExcessProperty === "preserve";
          const output = {};
          let inputKeys;
          if (onExcessPropertyError || onExcessPropertyPreserve) {
            inputKeys = util_ownKeys(input);
            for (const key of inputKeys) {
              const te = expected(key, options);
              if (isEither(te) && esm_Either/* isLeft */.nM(te)) {
                // key is unexpected
                if (onExcessPropertyError) {
                  const e = new Pointer(key, input, new Unexpected(input[key], `is unexpected, expected: ${String(expectedAST)}`));
                  if (allErrors) {
                    es.push([stepKey++, e]);
                    continue;
                  } else {
                    return esm_Either/* left */.t$(new Composite(ast, input, e, output));
                  }
                } else {
                  // preserve key
                  output[key] = input[key];
                }
              }
            }
          }
          let queue = undefined;
          const isExact = options?.exact === true;
          for (let i = 0; i < propertySignatures.length; i++) {
            const ps = propertySignatures[i][1];
            const name = ps.name;
            const hasKey = Object.prototype.hasOwnProperty.call(input, name);
            if (!hasKey) {
              if (ps.isOptional) {
                continue;
              } else if (isExact) {
                const e = new Pointer(name, input, new Missing(ps));
                if (allErrors) {
                  es.push([stepKey++, e]);
                  continue;
                } else {
                  return esm_Either/* left */.t$(new Composite(ast, input, e, output));
                }
              }
            }
            const parser = propertySignatures[i][0];
            const te = parser(input[name], options);
            if (isEither(te)) {
              if (esm_Either/* isLeft */.nM(te)) {
                const e = new Pointer(name, input, hasKey ? te.left : new Missing(ps));
                if (allErrors) {
                  es.push([stepKey++, e]);
                  continue;
                } else {
                  return esm_Either/* left */.t$(new Composite(ast, input, e, output));
                }
              }
              output[name] = te.right;
            } else {
              const nk = stepKey++;
              const index = name;
              if (!queue) {
                queue = [];
              }
              queue.push(({
                es,
                output
              }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(te), t => {
                if (esm_Either/* isLeft */.nM(t)) {
                  const e = new Pointer(index, input, hasKey ? t.left : new Missing(ps));
                  if (allErrors) {
                    es.push([nk, e]);
                    return esm_Effect/* void */.Hcj;
                  } else {
                    return esm_Either/* left */.t$(new Composite(ast, input, e, output));
                  }
                }
                output[index] = t.right;
                return esm_Effect/* void */.Hcj;
              }));
            }
          }
          // ---------------------------------------------
          // handle index signatures
          // ---------------------------------------------
          for (let i = 0; i < indexSignatures.length; i++) {
            const indexSignature = indexSignatures[i];
            const parameter = indexSignature[0];
            const type = indexSignature[1];
            const keys = getKeysForIndexSignature(input, indexSignature[2]);
            for (const key of keys) {
              // ---------------------------------------------
              // handle keys
              // ---------------------------------------------
              const keu = parameter(key, options);
              if (isEither(keu) && esm_Either/* isRight */.tO(keu)) {
                // ---------------------------------------------
                // handle values
                // ---------------------------------------------
                const vpr = type(input[key], options);
                if (isEither(vpr)) {
                  if (esm_Either/* isLeft */.nM(vpr)) {
                    const e = new Pointer(key, input, vpr.left);
                    if (allErrors) {
                      es.push([stepKey++, e]);
                      continue;
                    } else {
                      return esm_Either/* left */.t$(new Composite(ast, input, e, output));
                    }
                  } else {
                    if (!Object.prototype.hasOwnProperty.call(expectedKeysMap, key)) {
                      output[key] = vpr.right;
                    }
                  }
                } else {
                  const nk = stepKey++;
                  const index = key;
                  if (!queue) {
                    queue = [];
                  }
                  queue.push(({
                    es,
                    output
                  }) => esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(vpr), tv => {
                    if (esm_Either/* isLeft */.nM(tv)) {
                      const e = new Pointer(index, input, tv.left);
                      if (allErrors) {
                        es.push([nk, e]);
                        return esm_Effect/* void */.Hcj;
                      } else {
                        return esm_Either/* left */.t$(new Composite(ast, input, e, output));
                      }
                    } else {
                      if (!Object.prototype.hasOwnProperty.call(expectedKeysMap, key)) {
                        output[key] = tv.right;
                      }
                      return esm_Effect/* void */.Hcj;
                    }
                  }));
                }
              }
            }
          }
          // ---------------------------------------------
          // compute result
          // ---------------------------------------------
          const computeResult = ({
            es,
            output
          }) => {
            if (esm_Array/* isNonEmptyArray */.Of(es)) {
              return esm_Either/* left */.t$(new Composite(ast, input, sortByIndex(es), output));
            }
            if (options?.propertyOrder === "original") {
              // preserve input keys order
              const keys = inputKeys || util_ownKeys(input);
              for (const name of expectedKeys) {
                if (keys.indexOf(name) === -1) {
                  keys.push(name);
                }
              }
              const out = {};
              for (const key of keys) {
                if (Object.prototype.hasOwnProperty.call(output, key)) {
                  out[key] = output[key];
                }
              }
              return esm_Either/* right */.F2(out);
            }
            return esm_Either/* right */.F2(output);
          };
          if (queue && queue.length > 0) {
            const cqueue = queue;
            return esm_Effect/* suspend */.RqG(() => {
              const state = {
                es: esm_Array/* copy */.JG(es),
                output: Object.assign({}, output)
              };
              return esm_Effect/* flatMap */.VSD(esm_Effect/* forEach */.Ed_(cqueue, f => f(state), {
                concurrency,
                batching,
                discard: true
              }), () => computeResult(state));
            });
          }
          return computeResult({
            es,
            output
          });
        };
      }
    case "Union":
      {
        const searchTree = getSearchTree(ast.types, isDecoding);
        const ownKeys = util_ownKeys(searchTree.keys);
        const ownKeysLen = ownKeys.length;
        const astTypesLen = ast.types.length;
        const map = new Map();
        for (let i = 0; i < astTypesLen; i++) {
          map.set(ast.types[i], goMemo(ast.types[i], isDecoding));
        }
        const concurrency = getConcurrency(ast) ?? 1;
        const batching = getBatching(ast);
        return (input, options) => {
          const es = [];
          let stepKey = 0;
          let candidates = [];
          if (ownKeysLen > 0) {
            if (esm_Predicate/* isRecordOrArray */.U3(input)) {
              for (let i = 0; i < ownKeysLen; i++) {
                const name = ownKeys[i];
                const buckets = searchTree.keys[name].buckets;
                // for each property that should contain a literal, check if the input contains that property
                if (Object.prototype.hasOwnProperty.call(input, name)) {
                  const literal = String(input[name]);
                  // check that the value obtained from the input for the property corresponds to an existing bucket
                  if (Object.prototype.hasOwnProperty.call(buckets, literal)) {
                    // retrive the minimal set of candidates for decoding
                    candidates = candidates.concat(buckets[literal]);
                  } else {
                    const {
                      candidates,
                      literals
                    } = searchTree.keys[name];
                    const literalsUnion = Union.make(literals);
                    const errorAst = candidates.length === astTypesLen ? new TypeLiteral([new PropertySignature(name, literalsUnion, false, true)], []) : Union.make(candidates);
                    es.push([stepKey++, new Composite(errorAst, input, new Pointer(name, input, new ParseResult_Type(literalsUnion, input[name])))]);
                  }
                } else {
                  const {
                    candidates,
                    literals
                  } = searchTree.keys[name];
                  const fakePropertySignature = new PropertySignature(name, Union.make(literals), false, true);
                  const errorAst = candidates.length === astTypesLen ? new TypeLiteral([fakePropertySignature], []) : Union.make(candidates);
                  es.push([stepKey++, new Composite(errorAst, input, new Pointer(name, input, new Missing(fakePropertySignature)))]);
                }
              }
            } else {
              const errorAst = searchTree.candidates.length === astTypesLen ? ast : Union.make(searchTree.candidates);
              es.push([stepKey++, new ParseResult_Type(errorAst, input)]);
            }
          }
          if (searchTree.otherwise.length > 0) {
            candidates = candidates.concat(searchTree.otherwise);
          }
          let queue = undefined;
          for (let i = 0; i < candidates.length; i++) {
            const candidate = candidates[i];
            const pr = map.get(candidate)(input, options);
            // the members of a union are ordered based on which one should be decoded first,
            // therefore if one member has added a task, all subsequent members must
            // also add a task to the queue even if they are synchronous
            if (isEither(pr) && (!queue || queue.length === 0)) {
              if (esm_Either/* isRight */.tO(pr)) {
                return pr;
              } else {
                es.push([stepKey++, pr.left]);
              }
            } else {
              const nk = stepKey++;
              if (!queue) {
                queue = [];
              }
              queue.push(state => esm_Effect/* suspend */.RqG(() => {
                if ("finalResult" in state) {
                  return esm_Effect/* void */.Hcj;
                } else {
                  return esm_Effect/* flatMap */.VSD(esm_Effect/* either */.wEe(pr), t => {
                    if (esm_Either/* isRight */.tO(t)) {
                      state.finalResult = t;
                    } else {
                      state.es.push([nk, t.left]);
                    }
                    return esm_Effect/* void */.Hcj;
                  });
                }
              }));
            }
          }
          // ---------------------------------------------
          // compute result
          // ---------------------------------------------
          const computeResult = es => esm_Array/* isNonEmptyArray */.Of(es) ? es.length === 1 && es[0][1]._tag === "Type" ? esm_Either/* left */.t$(es[0][1]) : esm_Either/* left */.t$(new Composite(ast, input, sortByIndex(es))) :
          // this should never happen
          esm_Either/* left */.t$(new ParseResult_Type(ast, input));
          if (queue && queue.length > 0) {
            const cqueue = queue;
            return esm_Effect/* suspend */.RqG(() => {
              const state = {
                es: esm_Array/* copy */.JG(es)
              };
              return esm_Effect/* flatMap */.VSD(esm_Effect/* forEach */.Ed_(cqueue, f => f(state), {
                concurrency,
                batching,
                discard: true
              }), () => {
                if ("finalResult" in state) {
                  return state.finalResult;
                }
                return computeResult(state.es);
              });
            });
          }
          return computeResult(es);
        };
      }
    case "Suspend":
      {
        const get = memoizeThunk(() => goMemo(SchemaAST_annotations(ast.f(), ast.annotations), isDecoding));
        return (a, options) => get()(a, options);
      }
  }
};
const fromRefinement = (ast, refinement) => u => refinement(u) ? esm_Either/* right */.F2(u) : esm_Either/* left */.t$(new ParseResult_Type(ast, u));
/** @internal */
const getLiterals = (ast, isDecoding) => {
  switch (ast._tag) {
    case "Declaration":
      {
        const annotation = getSurrogateAnnotation(ast);
        if (esm_Option/* isSome */.pC(annotation)) {
          return getLiterals(annotation.value, isDecoding);
        }
        break;
      }
    case "TypeLiteral":
      {
        const out = [];
        for (let i = 0; i < ast.propertySignatures.length; i++) {
          const propertySignature = ast.propertySignatures[i];
          const type = isDecoding ? encodedAST(propertySignature.type) : typeAST(propertySignature.type);
          if (isLiteral(type) && !propertySignature.isOptional) {
            out.push([propertySignature.name, type]);
          }
        }
        return out;
      }
    case "TupleType":
      {
        const out = [];
        for (let i = 0; i < ast.elements.length; i++) {
          const element = ast.elements[i];
          const type = isDecoding ? encodedAST(element.type) : typeAST(element.type);
          if (isLiteral(type) && !element.isOptional) {
            out.push([i, type]);
          }
        }
        return out;
      }
    case "Refinement":
      return getLiterals(ast.from, isDecoding);
    case "Suspend":
      return getLiterals(ast.f(), isDecoding);
    case "Transformation":
      return getLiterals(isDecoding ? ast.from : ast.to, isDecoding);
  }
  return [];
};
/**
 * The purpose of the algorithm is to narrow down the pool of possible
 * candidates for decoding as much as possible.
 *
 * This function separates the schemas into two groups, `keys` and `otherwise`:
 *
 * - `keys`: the schema has at least one property with a literal value
 * - `otherwise`: the schema has no properties with a literal value
 *
 * If a schema has at least one property with a literal value, so it ends up in
 * `keys`, first a namespace is created for the name of the property containing
 * the literal, and then within this namespace a "bucket" is created for the
 * literal value in which to store all the schemas that have the same property
 * and literal value.
 *
 * @internal
 */
const getSearchTree = (members, isDecoding) => {
  const keys = {};
  const otherwise = [];
  const candidates = [];
  for (let i = 0; i < members.length; i++) {
    const member = members[i];
    const tags = getLiterals(member, isDecoding);
    if (tags.length > 0) {
      candidates.push(member);
      for (let j = 0; j < tags.length; j++) {
        const [key, literal] = tags[j];
        const hash = String(literal.literal);
        keys[key] = keys[key] || {
          buckets: {},
          literals: [],
          candidates: []
        };
        const buckets = keys[key].buckets;
        if (Object.prototype.hasOwnProperty.call(buckets, hash)) {
          if (j < tags.length - 1) {
            continue;
          }
          buckets[hash].push(member);
          keys[key].literals.push(literal);
          keys[key].candidates.push(member);
        } else {
          buckets[hash] = [member];
          keys[key].literals.push(literal);
          keys[key].candidates.push(member);
          break;
        }
      }
    } else {
      otherwise.push(member);
    }
  }
  return {
    keys,
    otherwise,
    candidates
  };
};
const dropRightRefinement = ast => isRefinement(ast) ? dropRightRefinement(ast.from) : ast;
const handleForbidden = (effect, ast, actual, options) => {
  // If effects are allowed, return the original effect
  if (options?.isEffectAllowed === true) {
    return effect;
  }
  // If the effect is already an Either, return it directly
  if (isEither(effect)) {
    return effect;
  }
  // Otherwise, attempt to execute the effect synchronously
  const scheduler = new Scheduler/* SyncScheduler */.$V();
  const fiber = esm_Effect/* runFork */.gMF(effect, {
    scheduler
  });
  scheduler.flush();
  const exit = fiber.unsafePoll();
  if (exit) {
    if (Exit/* isSuccess */.d6(exit)) {
      // If the effect successfully resolves, wrap the value in a Right
      return esm_Either/* right */.F2(exit.value);
    }
    const cause = exit.cause;
    if (Cause/* isFailType */.DA(cause)) {
      // The effect executed synchronously but failed due to a ParseIssue
      return esm_Either/* left */.t$(cause.error);
    }
    // The effect executed synchronously but failed due to a defect (e.g., a missing dependency)
    return esm_Either/* left */.t$(new Forbidden(ast, actual, Cause/* pretty */.IC(cause)));
  }
  // The effect could not be resolved synchronously, meaning it performs async work
  return esm_Either/* left */.t$(new Forbidden(ast, actual, "cannot be be resolved synchronously, this is caused by using runSync on an effect that performs async work"));
};
const compare = ([a], [b]) => a > b ? 1 : a < b ? -1 : 0;
function sortByIndex(es) {
  return es.sort(compare).map(t => t[1]);
}
// -------------------------------------------------------------------------------------
// transformations interpreter
// -------------------------------------------------------------------------------------
/** @internal */
const getFinalTransformation = (transformation, isDecoding) => {
  switch (transformation._tag) {
    case "FinalTransformation":
      return isDecoding ? transformation.decode : transformation.encode;
    case "ComposeTransformation":
      return esm_Either/* right */.F2;
    case "TypeLiteralTransformation":
      return input => {
        let out = esm_Either/* right */.F2(input);
        // ---------------------------------------------
        // handle property signature transformations
        // ---------------------------------------------
        for (const pst of transformation.propertySignatureTransformations) {
          const [from, to] = isDecoding ? [pst.from, pst.to] : [pst.to, pst.from];
          const transformation = isDecoding ? pst.decode : pst.encode;
          const f = input => {
            const o = transformation(Object.prototype.hasOwnProperty.call(input, from) ? esm_Option/* some */.G(input[from]) : esm_Option/* none */.YP());
            delete input[from];
            if (esm_Option/* isSome */.pC(o)) {
              input[to] = o.value;
            }
            return input;
          };
          out = map(out, f);
        }
        return out;
      };
  }
};
const makeTree = (value, forest = []) => ({
  value,
  forest
});
/**
 * @category formatting
 * @since 3.10.0
 */
const TreeFormatter = {
  formatIssue: issue => map(formatTree(issue), drawTree),
  formatIssueSync: issue => {
    const e = TreeFormatter.formatIssue(issue);
    return isEither(e) ? esm_Either/* getOrThrow */.Gg(e) : esm_Effect/* runSync */.Wno(e);
  },
  formatError: error => TreeFormatter.formatIssue(error.issue),
  formatErrorSync: error => TreeFormatter.formatIssueSync(error.issue)
};
const drawTree = tree => tree.value + draw("\n", tree.forest);
const draw = (indentation, forest) => {
  let r = "";
  const len = forest.length;
  let tree;
  for (let i = 0; i < len; i++) {
    tree = forest[i];
    const isLast = i === len - 1;
    r += indentation + (isLast ? "└" : "├") + "─ " + tree.value;
    r += draw(indentation + (len > 1 && !isLast ? "│  " : "   "), tree.forest);
  }
  return r;
};
const formatTransformationKind = kind => {
  switch (kind) {
    case "Encoded":
      return "Encoded side transformation failure";
    case "Transformation":
      return "Transformation process failure";
    case "Type":
      return "Type side transformation failure";
  }
};
const formatRefinementKind = kind => {
  switch (kind) {
    case "From":
      return "From side refinement failure";
    case "Predicate":
      return "Predicate refinement failure";
  }
};
const getAnnotated = issue => "ast" in issue ? esm_Option/* some */.G(issue.ast) : esm_Option/* none */.YP();
// TODO: replace with Either.void when 3.13 lands
const Either_void = /*#__PURE__*/esm_Either/* right */.F2(undefined);
const getCurrentMessage = issue => getAnnotated(issue).pipe(esm_Option/* flatMap */.VS(getMessageAnnotation), esm_Option/* match */.EQ({
  onNone: () => Either_void,
  onSome: messageAnnotation => {
    const union = messageAnnotation(issue);
    if (esm_Predicate/* isString */.HD(union)) {
      return esm_Either/* right */.F2({
        message: union,
        override: false
      });
    }
    if (esm_Effect/* isEffect */.cdB(union)) {
      return esm_Effect/* map */.UID(union, message => ({
        message,
        override: false
      }));
    }
    if (esm_Predicate/* isString */.HD(union.message)) {
      return esm_Either/* right */.F2({
        message: union.message,
        override: union.override
      });
    }
    return esm_Effect/* map */.UID(union.message, message => ({
      message,
      override: union.override
    }));
  }
}));
const createParseIssueGuard = tag => issue => issue._tag === tag;
/**
 * Returns `true` if the value is a `Composite`.
 *
 * @category guards
 * @since 3.10.0
 */
const isComposite = /*#__PURE__*/createParseIssueGuard("Composite");
const ParseResult_isRefinement = /*#__PURE__*/createParseIssueGuard("Refinement");
const ParseResult_isTransformation = /*#__PURE__*/createParseIssueGuard("Transformation");
const getMessage = issue => flatMap(getCurrentMessage(issue), currentMessage => {
  if (currentMessage !== undefined) {
    const useInnerMessage = !currentMessage.override && (isComposite(issue) || ParseResult_isRefinement(issue) && issue.kind === "From" || ParseResult_isTransformation(issue) && issue.kind !== "Transformation");
    return useInnerMessage ? ParseResult_isTransformation(issue) || ParseResult_isRefinement(issue) ? getMessage(issue.issue) : Either_void : esm_Either/* right */.F2(currentMessage.message);
  }
  return Either_void;
});
const ParseResult_getParseIssueTitleAnnotation = issue => getAnnotated(issue).pipe(esm_Option/* flatMap */.VS(getParseIssueTitleAnnotation), esm_Option/* flatMapNullable */.ny(annotation => annotation(issue)), esm_Option/* getOrUndefined */.jD);
/** @internal */
function getRefinementExpected(ast) {
  return getDescriptionAnnotation(ast).pipe(esm_Option/* orElse */.vx(() => getTitleAnnotation(ast)), esm_Option/* orElse */.vx(() => getAutoTitleAnnotation(ast)), esm_Option/* orElse */.vx(() => getIdentifierAnnotation(ast)), esm_Option/* getOrElse */.fS(() => `{ ${ast.from} | filter }`));
}
function getDefaultTypeMessage(issue) {
  if (issue.message !== undefined) {
    return issue.message;
  }
  const expected = isRefinement(issue.ast) ? getRefinementExpected(issue.ast) : String(issue.ast);
  return `Expected ${expected}, actual ${formatUnknown(issue.actual)}`;
}
const formatTypeMessage = issue => map(getMessage(issue), message => message ?? ParseResult_getParseIssueTitleAnnotation(issue) ?? getDefaultTypeMessage(issue));
const getParseIssueTitle = issue => ParseResult_getParseIssueTitleAnnotation(issue) ?? String(issue.ast);
const formatForbiddenMessage = issue => issue.message ?? "is forbidden";
const formatUnexpectedMessage = issue => issue.message ?? "is unexpected";
const formatMissingMessage = issue => {
  const missingMessageAnnotation = getMissingMessageAnnotation(issue.ast);
  if (esm_Option/* isSome */.pC(missingMessageAnnotation)) {
    const annotation = missingMessageAnnotation.value();
    return esm_Predicate/* isString */.HD(annotation) ? esm_Either/* right */.F2(annotation) : annotation;
  }
  return esm_Either/* right */.F2(issue.message ?? "is missing");
};
const formatTree = issue => {
  switch (issue._tag) {
    case "Type":
      return map(formatTypeMessage(issue), makeTree);
    case "Forbidden":
      return esm_Either/* right */.F2(makeTree(getParseIssueTitle(issue), [makeTree(formatForbiddenMessage(issue))]));
    case "Unexpected":
      return esm_Either/* right */.F2(makeTree(formatUnexpectedMessage(issue)));
    case "Missing":
      return map(formatMissingMessage(issue), makeTree);
    case "Transformation":
      return flatMap(getMessage(issue), message => {
        if (message !== undefined) {
          return esm_Either/* right */.F2(makeTree(message));
        }
        return map(formatTree(issue.issue), tree => makeTree(getParseIssueTitle(issue), [makeTree(formatTransformationKind(issue.kind), [tree])]));
      });
    case "Refinement":
      return flatMap(getMessage(issue), message => {
        if (message !== undefined) {
          return esm_Either/* right */.F2(makeTree(message));
        }
        return map(formatTree(issue.issue), tree => makeTree(getParseIssueTitle(issue), [makeTree(formatRefinementKind(issue.kind), [tree])]));
      });
    case "Pointer":
      return map(formatTree(issue.issue), tree => makeTree(formatPath(issue.path), [tree]));
    case "Composite":
      return flatMap(getMessage(issue), message => {
        if (message !== undefined) {
          return esm_Either/* right */.F2(makeTree(message));
        }
        const parseIssueTitle = getParseIssueTitle(issue);
        return isNonEmpty(issue.issues) ? map(esm_Effect/* forEach */.Ed_(issue.issues, formatTree), forest => makeTree(parseIssueTitle, forest)) : map(formatTree(issue.issues), tree => makeTree(parseIssueTitle, [tree]));
      });
  }
};
const makeArrayFormatterIssue = (_tag, path, message) => ({
  _tag,
  path,
  message
});
/**
 * @category formatting
 * @since 3.10.0
 */
const ArrayFormatter = {
  formatIssue: issue => getArrayFormatterIssues(issue, undefined, []),
  formatIssueSync: issue => {
    const e = ArrayFormatter.formatIssue(issue);
    return isEither(e) ? esm_Either/* getOrThrow */.Gg(e) : esm_Effect/* runSync */.Wno(e);
  },
  formatError: error => ArrayFormatter.formatIssue(error.issue),
  formatErrorSync: error => ArrayFormatter.formatIssueSync(error.issue)
};
const getArrayFormatterIssues = (issue, parentTag, path) => {
  const _tag = issue._tag;
  switch (_tag) {
    case "Type":
      return map(formatTypeMessage(issue), message => [makeArrayFormatterIssue(parentTag ?? _tag, path, message)]);
    case "Forbidden":
      return esm_Either/* right */.F2([makeArrayFormatterIssue(_tag, path, formatForbiddenMessage(issue))]);
    case "Unexpected":
      return esm_Either/* right */.F2([makeArrayFormatterIssue(_tag, path, formatUnexpectedMessage(issue))]);
    case "Missing":
      return map(formatMissingMessage(issue), message => [makeArrayFormatterIssue(_tag, path, message)]);
    case "Pointer":
      return getArrayFormatterIssues(issue.issue, undefined, path.concat(issue.path));
    case "Composite":
      return flatMap(getMessage(issue), message => {
        if (message !== undefined) {
          return esm_Either/* right */.F2([makeArrayFormatterIssue(_tag, path, message)]);
        }
        return isNonEmpty(issue.issues) ? map(esm_Effect/* forEach */.Ed_(issue.issues, issue => getArrayFormatterIssues(issue, undefined, path)), esm_Array/* flatten */.xH) : getArrayFormatterIssues(issue.issues, undefined, path);
      });
    case "Refinement":
      return flatMap(getMessage(issue), message => {
        if (message !== undefined) {
          return esm_Either/* right */.F2([makeArrayFormatterIssue(_tag, path, message)]);
        }
        return getArrayFormatterIssues(issue.issue, issue.kind === "Predicate" ? _tag : undefined, path);
      });
    case "Transformation":
      return flatMap(getMessage(issue), message => {
        if (message !== undefined) {
          return esm_Either/* right */.F2([makeArrayFormatterIssue(_tag, path, message)]);
        }
        return getArrayFormatterIssues(issue.issue, issue.kind === "Transformation" ? _tag : undefined, path);
      });
  }
};
//# sourceMappingURL=ParseResult.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/String.js
var esm_String = __webpack_require__(55354);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Struct.js
var Struct = __webpack_require__(44576);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/Schema.js
/**
 * @since 3.10.0
 */








































/**
 * @since 3.10.0
 * @category symbol
 */
const Schema_TypeId = /*#__PURE__*/Symbol.for("effect/Schema");
/**
 * @category constructors
 * @since 3.10.0
 */
function Schema_make(ast) {
  return class SchemaClass {
    [Schema_TypeId] = variance;
    static ast = ast;
    static annotations(annotations) {
      return Schema_make(mergeSchemaAnnotations(this.ast, annotations));
    }
    static pipe() {
      return (0,Pipeable/* pipeArguments */.n)(this, arguments);
    }
    static toString() {
      return String(ast);
    }
    static Type;
    static Encoded;
    static Context;
    static [Schema_TypeId] = variance;
  };
}
const variance = {
  /* c8 ignore next */
  _A: _ => _,
  /* c8 ignore next */
  _I: _ => _,
  /* c8 ignore next */
  _R: _ => _
};
const makeStandardResult = exit => exit_.isSuccess(exit) ? exit.value : makeStandardFailureResult(cause_.pretty(exit.cause));
const makeStandardFailureResult = message => ({
  issues: [{
    message
  }]
});
const makeStandardFailureFromParseIssue = issue => Effect.map(ParseResult.ArrayFormatter.formatIssue(issue), issues => ({
  issues: issues.map(issue => ({
    path: issue.path,
    message: issue.message
  }))
}));
/**
 * Returns a "Standard Schema" object conforming to the [Standard Schema
 * v1](https://standardschema.dev/) specification.
 *
 * This function creates a schema whose `validate` method attempts to decode and
 * validate the provided input synchronously. If the underlying `Schema`
 * includes any asynchronous components (e.g., asynchronous message resolutions
 * or checks), then validation will necessarily return a `Promise` instead.
 *
 * Any detected defects will be reported via a single issue containing no
 * `path`.
 *
 * @example
 * ```ts
 * import { Schema } from "effect"
 *
 * const schema = Schema.Struct({
 *   name: Schema.String
 * })
 *
 * //      ┌─── StandardSchemaV1<{ readonly name: string; }>
 * //      ▼
 * const standardSchema = Schema.standardSchemaV1(schema)
 * ```
 *
 * @category Standard Schema
 * @since 3.13.0
 */
const standardSchemaV1 = (schema, overrideOptions) => {
  const decodeUnknown = ParseResult.decodeUnknown(schema, {
    errors: "all"
  });
  return class StandardSchemaV1Class extends Schema_make(schema.ast) {
    static "~standard" = {
      version: 1,
      vendor: "effect",
      validate(value) {
        const scheduler = new scheduler_.SyncScheduler();
        const fiber = Effect.runFork(Effect.matchEffect(decodeUnknown(value, overrideOptions), {
          onFailure: makeStandardFailureFromParseIssue,
          onSuccess: value => Effect.succeed({
            value
          })
        }), {
          scheduler
        });
        scheduler.flush();
        const exit = fiber.unsafePoll();
        if (exit) {
          return makeStandardResult(exit);
        }
        return new Promise(resolve => {
          fiber.addObserver(exit => {
            resolve(makeStandardResult(exit));
          });
        });
      }
    };
  };
};
const builtInAnnotations = {
  schemaId: SchemaIdAnnotationId,
  message: MessageAnnotationId,
  missingMessage: MissingMessageAnnotationId,
  identifier: IdentifierAnnotationId,
  title: TitleAnnotationId,
  description: DescriptionAnnotationId,
  examples: ExamplesAnnotationId,
  default: DefaultAnnotationId,
  documentation: DocumentationAnnotationId,
  jsonSchema: JSONSchemaAnnotationId,
  arbitrary: ArbitraryAnnotationId,
  pretty: PrettyAnnotationId,
  equivalence: EquivalenceAnnotationId,
  concurrency: ConcurrencyAnnotationId,
  batching: BatchingAnnotationId,
  parseIssueTitle: ParseIssueTitleAnnotationId,
  parseOptions: ParseOptionsAnnotationId,
  decodingFallback: DecodingFallbackAnnotationId
};
const toASTAnnotations = annotations => {
  if (!annotations) {
    return {};
  }
  const out = {
    ...annotations
  };
  for (const key in builtInAnnotations) {
    if (key in annotations) {
      const id = builtInAnnotations[key];
      out[id] = annotations[key];
      delete out[key];
    }
  }
  return out;
};
const mergeSchemaAnnotations = (ast, annotations) => SchemaAST_annotations(ast, toASTAnnotations(annotations));
/**
 * @since 3.10.0
 */
function asSchema(schema) {
  return schema;
}
/**
 * @category formatting
 * @since 3.10.0
 */
const Schema_format = schema => String(schema.ast);
/**
 * The `encodedSchema` function allows you to extract the `Encoded` portion of a
 * schema, creating a new schema that conforms to the properties defined in the
 * original schema without retaining any refinements or transformations that
 * were applied previously.
 *
 * @since 3.10.0
 */
const encodedSchema = schema => Schema_make(AST.encodedAST(schema.ast));
/**
 * The `encodedBoundSchema` function is similar to `encodedSchema` but preserves
 * the refinements up to the first transformation point in the original schema.
 *
 * @since 3.10.0
 */
const encodedBoundSchema = schema => Schema_make(AST.encodedBoundAST(schema.ast));
/**
 * The `typeSchema` function allows you to extract the `Type` portion of a
 * schema, creating a new schema that conforms to the properties defined in the
 * original schema without considering the initial encoding or transformation
 * processes.
 *
 * @since 3.10.0
 */
const typeSchema = schema => Schema_make(AST.typeAST(schema.ast));
/* c8 ignore start */

/* c8 ignore end */
/**
 * @category encoding
 * @since 3.10.0
 */
const Schema_encodeUnknown = (schema, options) => {
  const encodeUnknown = ParseResult.encodeUnknown(schema, options);
  return (u, overrideOptions) => ParseResult.mapError(encodeUnknown(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category encoding
 * @since 3.10.0
 */
const Schema_encodeUnknownEither = (schema, options) => {
  const encodeUnknownEither = ParseResult.encodeUnknownEither(schema, options);
  return (u, overrideOptions) => either_.mapLeft(encodeUnknownEither(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category encoding
 * @since 3.10.0
 */
const Schema_encodeUnknownPromise = (schema, options) => {
  const parser = Schema_encodeUnknown(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category encoding
 * @since 3.10.0
 */
const Schema_encode = (/* unused pure expression or super */ null && (Schema_encodeUnknown));
/**
 * @category encoding
 * @since 3.10.0
 */
const Schema_encodeEither = (/* unused pure expression or super */ null && (Schema_encodeUnknownEither));
/**
 * @category encoding
 * @since 3.10.0
 */
const Schema_encodePromise = (/* unused pure expression or super */ null && (Schema_encodeUnknownPromise));
/**
 * @category decoding
 * @since 3.10.0
 */
const Schema_decodeUnknown = (schema, options) => {
  const decodeUnknown = ParseResult.decodeUnknown(schema, options);
  return (u, overrideOptions) => ParseResult.mapError(decodeUnknown(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category decoding
 * @since 3.10.0
 */
const Schema_decodeUnknownEither = (schema, options) => {
  const decodeUnknownEither = ParseResult.decodeUnknownEither(schema, options);
  return (u, overrideOptions) => either_.mapLeft(decodeUnknownEither(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category decoding
 * @since 3.10.0
 */
const Schema_decodeUnknownPromise = (schema, options) => {
  const parser = Schema_decodeUnknown(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * @category decoding
 * @since 3.10.0
 */
const Schema_decode = (/* unused pure expression or super */ null && (Schema_decodeUnknown));
/**
 * @category decoding
 * @since 3.10.0
 */
const Schema_decodeEither = (/* unused pure expression or super */ null && (Schema_decodeUnknownEither));
/**
 * @category decoding
 * @since 3.10.0
 */
const Schema_decodePromise = (/* unused pure expression or super */ null && (Schema_decodeUnknownPromise));
/**
 * @category validation
 * @since 3.10.0
 */
const Schema_validate = (schema, options) => {
  const validate = ParseResult.validate(schema, options);
  return (u, overrideOptions) => ParseResult.mapError(validate(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category validation
 * @since 3.10.0
 */
const Schema_validateEither = (schema, options) => {
  const validateEither = ParseResult.validateEither(schema, options);
  return (u, overrideOptions) => either_.mapLeft(validateEither(u, overrideOptions), ParseResult.parseError);
};
/**
 * @category validation
 * @since 3.10.0
 */
const Schema_validatePromise = (schema, options) => {
  const parser = Schema_validate(schema, options);
  return (u, overrideOptions) => Effect.runPromise(parser(u, overrideOptions));
};
/**
 * Tests if a value is a `Schema`.
 *
 * @category guards
 * @since 3.10.0
 */
const isSchema = u => esm_Predicate/* hasProperty */.l$(u, Schema_TypeId) && esm_Predicate/* isObject */.Kn(u[Schema_TypeId]);
function getDefaultLiteralAST(literals) {
  return isMembers(literals) ? Union.make(mapMembers(literals, literal => new Literal(literal))) : new Literal(literals[0]);
}
function makeLiteralClass(literals, ast = getDefaultLiteralAST(literals)) {
  return class LiteralClass extends Schema_make(ast) {
    static annotations(annotations) {
      return makeLiteralClass(this.literals, mergeSchemaAnnotations(this.ast, annotations));
    }
    static literals = [...literals];
  };
}
function Schema_Literal(...literals) {
  return esm_Array/* isNonEmptyReadonlyArray */.Ux(literals) ? makeLiteralClass(literals) : Never;
}
/**
 * Creates a new `Schema` from a literal schema.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Either, Schema } from "effect"
 *
 * const schema = Schema.Literal("a", "b", "c").pipe(Schema.pickLiteral("a", "b"))
 *
 * assert.deepStrictEqual(Schema.decodeSync(schema)("a"), "a")
 * assert.deepStrictEqual(Schema.decodeSync(schema)("b"), "b")
 * assert.strictEqual(Either.isLeft(Schema.decodeUnknownEither(schema)("c")), true)
 * ```
 *
 * @category constructors
 * @since 3.10.0
 */
const pickLiteral = (...literals) => _schema => Schema_Literal(...literals);
/**
 * @category constructors
 * @since 3.10.0
 */
const UniqueSymbolFromSelf = symbol => Schema_make(new AST.UniqueSymbol(symbol));
const getDefaultEnumsAST = enums => new AST.Enums(Object.keys(enums).filter(key => typeof enums[enums[key]] !== "number").map(key => [key, enums[key]]));
const makeEnumsClass = (enums, ast = getDefaultEnumsAST(enums)) => class EnumsClass extends Schema_make(ast) {
  static annotations(annotations) {
    return makeEnumsClass(this.enums, mergeSchemaAnnotations(this.ast, annotations));
  }
  static enums = {
    ...enums
  };
};
/**
 * @category constructors
 * @since 3.10.0
 */
const Schema_Enums = enums => makeEnumsClass(enums);
/**
 * @category template literal
 * @since 3.10.0
 */
const Schema_TemplateLiteral = (...[head, ...tail]) => {
  const spans = [];
  let h = "";
  let ts = tail;
  if (isSchema(head)) {
    if (AST.isLiteral(head.ast)) {
      h = String(head.ast.literal);
    } else {
      ts = [head, ...ts];
    }
  } else {
    h = String(head);
  }
  for (let i = 0; i < ts.length; i++) {
    const item = ts[i];
    if (isSchema(item)) {
      if (i < ts.length - 1) {
        const next = ts[i + 1];
        if (isSchema(next)) {
          if (AST.isLiteral(next.ast)) {
            spans.push(new AST.TemplateLiteralSpan(item.ast, String(next.ast.literal)));
            i++;
            continue;
          }
        } else {
          spans.push(new AST.TemplateLiteralSpan(item.ast, String(next)));
          i++;
          continue;
        }
      }
      spans.push(new AST.TemplateLiteralSpan(item.ast, ""));
    } else {
      spans.push(new AST.TemplateLiteralSpan(new AST.Literal(item), ""));
    }
  }
  if (array_.isNonEmptyArray(spans)) {
    return Schema_make(new AST.TemplateLiteral(h, spans));
  } else {
    return Schema_make(new AST.TemplateLiteral("", [new AST.TemplateLiteralSpan(new AST.Literal(h), "")]));
  }
};
function getTemplateLiteralParserCoercedElement(encoded, schema) {
  const ast = encoded.ast;
  switch (ast._tag) {
    case "Literal":
      {
        const literal = ast.literal;
        if (!Predicate.isString(literal)) {
          const s = String(literal);
          return transform(Schema_Literal(s), schema, {
            strict: true,
            decode: () => literal,
            encode: () => s
          });
        }
        break;
      }
    case "NumberKeyword":
      return Schema_compose(NumberFromString, schema);
    case "Union":
      {
        const members = [];
        let hasCoercions = false;
        for (const member of ast.types) {
          const schema = Schema_make(member);
          const encoded = encodedSchema(schema);
          const coerced = getTemplateLiteralParserCoercedElement(encoded, schema);
          if (coerced) {
            hasCoercions = true;
          }
          members.push(coerced ?? schema);
        }
        return hasCoercions ? Schema_compose(Schema_Union(...members), schema) : schema;
      }
  }
}
/**
 * @category template literal
 * @since 3.10.0
 */
const TemplateLiteralParser = (...params) => {
  const encodedSchemas = [];
  const elements = [];
  const schemas = [];
  let coerced = false;
  for (let i = 0; i < params.length; i++) {
    const param = params[i];
    const schema = isSchema(param) ? param : Schema_Literal(param);
    schemas.push(schema);
    const encoded = encodedSchema(schema);
    encodedSchemas.push(encoded);
    const element = getTemplateLiteralParserCoercedElement(encoded, schema);
    if (element) {
      elements.push(element);
      coerced = true;
    } else {
      elements.push(schema);
    }
  }
  const from = Schema_TemplateLiteral(...encodedSchemas);
  const re = AST.getTemplateLiteralCapturingRegExp(from.ast);
  let to = Tuple(...elements);
  if (coerced) {
    to = to.annotations({
      [AST.AutoTitleAnnotationId]: Schema_format(Tuple(...schemas))
    });
  }
  return class TemplateLiteralParserClass extends transformOrFail(from, to, {
    strict: false,
    decode: (i, _, ast) => {
      const match = re.exec(i);
      return match ? ParseResult.succeed(match.slice(1, params.length + 1)) : ParseResult.fail(new ParseResult.Type(ast, i, `${re.source}: no match for ${JSON.stringify(i)}`));
    },
    encode: tuple => ParseResult.succeed(tuple.join(""))
  }) {
    static params = params.slice();
  };
};
const declareConstructor = (typeParameters, options, annotations) => makeDeclareClass(typeParameters, new Declaration(typeParameters.map(tp => tp.ast), (...typeParameters) => options.decode(...typeParameters.map(Schema_make)), (...typeParameters) => options.encode(...typeParameters.map(Schema_make)), toASTAnnotations(annotations)));
const declarePrimitive = (is, annotations) => {
  const decodeUnknown = () => (input, _, ast) => is(input) ? succeed(input) : fail(new ParseResult_Type(ast, input));
  const encodeUnknown = decodeUnknown;
  return makeDeclareClass([], new Declaration([], decodeUnknown, encodeUnknown, toASTAnnotations(annotations)));
};
function makeDeclareClass(typeParameters, ast) {
  return class DeclareClass extends Schema_make(ast) {
    static annotations(annotations) {
      return makeDeclareClass(this.typeParameters, mergeSchemaAnnotations(this.ast, annotations));
    }
    static typeParameters = [...typeParameters];
  };
}
/**
 * The constraint `R extends Schema.Context<P[number]>` enforces dependencies solely from `typeParameters`.
 * This ensures that when you call `Schema.to` or `Schema.from`, you receive a schema with a `never` context.
 *
 * @category constructors
 * @since 3.10.0
 */
const declare = function () {
  if (Array.isArray(arguments[0])) {
    const typeParameters = arguments[0];
    const options = arguments[1];
    const annotations = arguments[2];
    return declareConstructor(typeParameters, options, annotations);
  }
  const is = arguments[0];
  const annotations = arguments[1];
  return declarePrimitive(is, annotations);
};
/**
 * @category schema id
 * @since 3.10.0
 */
const BrandSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/Brand")));
/**
 * @category constructors
 * @since 3.10.0
 */
const fromBrand = (constructor, annotations) => self => {
  const out = makeBrandClass(self, new AST.Refinement(self.ast, function predicate(a, _, ast) {
    const either = constructor.either(a);
    return either_.isLeft(either) ? option_.some(new ParseResult.Type(ast, a, either.left.map(v => v.message).join(", "))) : option_.none();
  }, toASTAnnotations({
    schemaId: BrandSchemaId,
    [BrandSchemaId]: {
      constructor
    },
    ...annotations
  })));
  return out;
};
/**
 * @category schema id
 * @since 3.10.0
 */
const InstanceOfSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/InstanceOf");
/**
 * @category constructors
 * @since 3.10.0
 */
const instanceOf = (constructor, annotations) => declare(u => u instanceof constructor, {
  title: constructor.name,
  description: `an instance of ${constructor.name}`,
  pretty: () => String,
  schemaId: InstanceOfSchemaId,
  [InstanceOfSchemaId]: {
    constructor
  },
  ...annotations
});
/**
 * @category primitives
 * @since 3.10.0
 */
class Undefined extends /*#__PURE__*/Schema_make(undefinedKeyword) {}
/**
 * @category primitives
 * @since 3.10.0
 */
class Void extends /*#__PURE__*/Schema_make(voidKeyword) {}
/**
 * @category primitives
 * @since 3.10.0
 */
class Null extends /*#__PURE__*/Schema_make($null) {}
/**
 * @category primitives
 * @since 3.10.0
 */
class Never extends /*#__PURE__*/Schema_make(neverKeyword) {}
/**
 * @category primitives
 * @since 3.10.0
 */
class Unknown extends /*#__PURE__*/Schema_make(unknownKeyword) {}
/**
 * @category primitives
 * @since 3.10.0
 */
class Any extends /*#__PURE__*/Schema_make(anyKeyword) {}
/**
 * @category primitives
 * @since 3.10.0
 */
class BigIntFromSelf extends /*#__PURE__*/Schema_make(bigIntKeyword) {}
/**
 * @category primitives
 * @since 3.10.0
 */
class SymbolFromSelf extends /*#__PURE__*/Schema_make(symbolKeyword) {}
/** @ignore */
class String$ extends /*#__PURE__*/Schema_make(stringKeyword) {}
/** @ignore */
class Number$ extends /*#__PURE__*/Schema_make(numberKeyword) {}
/** @ignore */
class Boolean$ extends /*#__PURE__*/Schema_make(booleanKeyword) {}
/** @ignore */
class Object$ extends /*#__PURE__*/Schema_make(objectKeyword) {}

const getDefaultUnionAST = members => Union.make(members.map(m => m.ast));
function makeUnionClass(members, ast = getDefaultUnionAST(members)) {
  return class UnionClass extends Schema_make(ast) {
    static annotations(annotations) {
      return makeUnionClass(this.members, mergeSchemaAnnotations(this.ast, annotations));
    }
    static members = [...members];
  };
}
function Schema_Union(...members) {
  return isMembers(members) ? makeUnionClass(members) : esm_Array/* isNonEmptyReadonlyArray */.Ux(members) ? members[0] : Never;
}
/**
 * @category combinators
 * @since 3.10.0
 */
const NullOr = self => Schema_Union(self, Null);
/**
 * @category combinators
 * @since 3.10.0
 */
const UndefinedOr = self => Schema_Union(self, Undefined);
/**
 * @category combinators
 * @since 3.10.0
 */
const NullishOr = self => Schema_Union(self, Null, Undefined);
/**
 * @category combinators
 * @since 3.10.0
 */
const Schema_keyof = self => Schema_make(AST.keyof(self.ast));
/**
 * @since 3.10.0
 */
const Schema_element = self => new ElementImpl(new OptionalType(self.ast, false), self);
/**
 * @since 3.10.0
 */
const optionalElement = self => new ElementImpl(new AST.OptionalType(self.ast, true), self);
class ElementImpl {
  ast;
  from;
  [Schema_TypeId];
  _Token;
  constructor(ast, from) {
    this.ast = ast;
    this.from = from;
  }
  annotations(annotations) {
    return new ElementImpl(new OptionalType(this.ast.type, this.ast.isOptional, {
      ...this.ast.annotations,
      ...toASTAnnotations(annotations)
    }), this.from);
  }
  toString() {
    return `${this.ast.type}${this.ast.isOptional ? "?" : ""}`;
  }
}
const getDefaultTupleTypeAST = (elements, rest) => new TupleType(elements.map(el => isSchema(el) ? new OptionalType(el.ast, false) : el.ast), rest.map(el => isSchema(el) ? new Type(el.ast) : el.ast), true);
function makeTupleTypeClass(elements, rest, ast = getDefaultTupleTypeAST(elements, rest)) {
  return class TupleTypeClass extends Schema_make(ast) {
    static annotations(annotations) {
      return makeTupleTypeClass(this.elements, this.rest, mergeSchemaAnnotations(this.ast, annotations));
    }
    static elements = [...elements];
    static rest = [...rest];
  };
}
function Tuple(...args) {
  return Array.isArray(args[0]) ? makeTupleTypeClass(args[0], args.slice(1)) : makeTupleTypeClass(args, []);
}
function makeArrayClass(value, ast) {
  return class ArrayClass extends makeTupleTypeClass([], [value], ast) {
    static annotations(annotations) {
      return makeArrayClass(this.value, mergeSchemaAnnotations(this.ast, annotations));
    }
    static value = value;
  };
}
const Array$ = value => makeArrayClass(value);

function makeNonEmptyArrayClass(value, ast) {
  return class NonEmptyArrayClass extends makeTupleTypeClass([value], [value], ast) {
    static annotations(annotations) {
      return makeNonEmptyArrayClass(this.value, mergeSchemaAnnotations(this.ast, annotations));
    }
    static value = value;
  };
}
/**
 * @category constructors
 * @since 3.10.0
 */
const NonEmptyArray = value => makeNonEmptyArrayClass(value);
/**
 * @category constructors
 * @since 3.10.0
 */
function ArrayEnsure(value) {
  return transform(Schema_Union(value, Array$(value)), Array$(typeSchema(asSchema(value))), {
    strict: true,
    decode: i => array_.ensure(i),
    encode: a => a.length === 1 ? a[0] : a
  });
}
/**
 * @category constructors
 * @since 3.10.0
 */
function NonEmptyArrayEnsure(value) {
  return transform(Schema_Union(value, NonEmptyArray(value)), NonEmptyArray(typeSchema(asSchema(value))), {
    strict: true,
    decode: i => array_.isNonEmptyReadonlyArray(i) ? i : array_.of(i),
    encode: a => a.length === 1 ? a[0] : a
  });
}
const formatPropertySignatureToken = isOptional => isOptional ? "\"?:\"" : "\":\"";
/**
 * @category PropertySignature
 * @since 3.10.0
 */
class PropertySignatureDeclaration extends OptionalType {
  isReadonly;
  defaultValue;
  /**
   * @since 3.10.0
   */
  _tag = "PropertySignatureDeclaration";
  constructor(type, isOptional, isReadonly, annotations, defaultValue) {
    super(type, isOptional, annotations);
    this.isReadonly = isReadonly;
    this.defaultValue = defaultValue;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    const token = formatPropertySignatureToken(this.isOptional);
    const type = String(this.type);
    return `PropertySignature<${token}, ${type}, never, ${token}, ${type}>`;
  }
}
/**
 * @category PropertySignature
 * @since 3.10.0
 */
class FromPropertySignature extends OptionalType {
  isReadonly;
  fromKey;
  constructor(type, isOptional, isReadonly, annotations, fromKey) {
    super(type, isOptional, annotations);
    this.isReadonly = isReadonly;
    this.fromKey = fromKey;
  }
}
/**
 * @category PropertySignature
 * @since 3.10.0
 */
class ToPropertySignature extends OptionalType {
  isReadonly;
  defaultValue;
  constructor(type, isOptional, isReadonly, annotations, defaultValue) {
    super(type, isOptional, annotations);
    this.isReadonly = isReadonly;
    this.defaultValue = defaultValue;
  }
}
const Schema_formatPropertyKey = p => {
  if (p === undefined) {
    return "never";
  }
  if (esm_Predicate/* isString */.HD(p)) {
    return JSON.stringify(p);
  }
  return String(p);
};
/**
 * @category PropertySignature
 * @since 3.10.0
 */
class Schema_PropertySignatureTransformation {
  from;
  to;
  decode;
  encode;
  /**
   * @since 3.10.0
   */
  _tag = "PropertySignatureTransformation";
  constructor(from, to, decode, encode) {
    this.from = from;
    this.to = to;
    this.decode = decode;
    this.encode = encode;
  }
  /**
   * @since 3.10.0
   */
  toString() {
    return `PropertySignature<${formatPropertySignatureToken(this.to.isOptional)}, ${this.to.type}, ${Schema_formatPropertyKey(this.from.fromKey)}, ${formatPropertySignatureToken(this.from.isOptional)}, ${this.from.type}>`;
  }
}
const mergeSignatureAnnotations = (ast, annotations) => {
  switch (ast._tag) {
    case "PropertySignatureDeclaration":
      {
        return new PropertySignatureDeclaration(ast.type, ast.isOptional, ast.isReadonly, {
          ...ast.annotations,
          ...annotations
        }, ast.defaultValue);
      }
    case "PropertySignatureTransformation":
      {
        return new Schema_PropertySignatureTransformation(ast.from, new ToPropertySignature(ast.to.type, ast.to.isOptional, ast.to.isReadonly, {
          ...ast.to.annotations,
          ...annotations
        }, ast.to.defaultValue), ast.decode, ast.encode);
      }
  }
};
/**
 * @since 3.10.0
 * @category symbol
 */
const PropertySignatureTypeId = /*#__PURE__*/Symbol.for("effect/PropertySignature");
/**
 * @since 3.10.0
 * @category guards
 */
const isPropertySignature = u => esm_Predicate/* hasProperty */.l$(u, PropertySignatureTypeId);
class PropertySignatureImpl {
  ast;
  [Schema_TypeId];
  [PropertySignatureTypeId] = null;
  _TypeToken;
  _Key;
  _EncodedToken;
  _HasDefault;
  constructor(ast) {
    this.ast = ast;
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
  annotations(annotations) {
    return new PropertySignatureImpl(mergeSignatureAnnotations(this.ast, toASTAnnotations(annotations)));
  }
  toString() {
    return String(this.ast);
  }
}
/**
 * @category PropertySignature
 * @since 3.10.0
 */
const makePropertySignature = ast => new PropertySignatureImpl(ast);
class PropertySignatureWithFromImpl extends PropertySignatureImpl {
  from;
  constructor(ast, from) {
    super(ast);
    this.from = from;
  }
  annotations(annotations) {
    return new PropertySignatureWithFromImpl(mergeSignatureAnnotations(this.ast, toASTAnnotations(annotations)), this.from);
  }
}
/**
 * Lifts a `Schema` into a `PropertySignature`.
 *
 * @category PropertySignature
 * @since 3.10.0
 */
const propertySignature = self => new PropertySignatureWithFromImpl(new PropertySignatureDeclaration(self.ast, false, true, {}, undefined), self);
/**
 * Enhances a property signature with a default constructor value.
 *
 * @category PropertySignature
 * @since 3.10.0
 */
const withConstructorDefault = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, defaultValue) => {
  const ast = self.ast;
  switch (ast._tag) {
    case "PropertySignatureDeclaration":
      return makePropertySignature(new PropertySignatureDeclaration(ast.type, ast.isOptional, ast.isReadonly, ast.annotations, defaultValue));
    case "PropertySignatureTransformation":
      return makePropertySignature(new Schema_PropertySignatureTransformation(ast.from, new ToPropertySignature(ast.to.type, ast.to.isOptional, ast.to.isReadonly, ast.to.annotations, defaultValue), ast.decode, ast.encode));
  }
});
const applyDefaultValue = (o, defaultValue) => option_.match(o, {
  onNone: () => option_.some(defaultValue()),
  onSome: value => option_.some(value === undefined ? defaultValue() : value)
});
const Schema_pruneUndefined = ast => AST.pruneUndefined(ast, Schema_pruneUndefined, ast => {
  const pruned = Schema_pruneUndefined(ast.to);
  if (pruned) {
    return new AST.Transformation(ast.from, pruned, ast.transformation);
  }
});
/**
 * Enhances a property signature with a default decoding value.
 *
 * @category PropertySignature
 * @since 3.10.0
 */
const withDecodingDefault = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, defaultValue) => {
  const ast = self.ast;
  switch (ast._tag) {
    case "PropertySignatureDeclaration":
      {
        const to = AST.typeAST(ast.type);
        return makePropertySignature(new Schema_PropertySignatureTransformation(new FromPropertySignature(ast.type, ast.isOptional, ast.isReadonly, ast.annotations), new ToPropertySignature(Schema_pruneUndefined(to) ?? to, false, true, {}, ast.defaultValue), o => applyDefaultValue(o, defaultValue), identity));
      }
    case "PropertySignatureTransformation":
      {
        const to = ast.to.type;
        return makePropertySignature(new Schema_PropertySignatureTransformation(ast.from, new ToPropertySignature(Schema_pruneUndefined(to) ?? to, false, ast.to.isReadonly, ast.to.annotations, ast.to.defaultValue), o => applyDefaultValue(ast.decode(o), defaultValue), ast.encode));
      }
  }
})));
/**
 * Enhances a property signature with a default decoding value and a default constructor value.
 *
 * @category PropertySignature
 * @since 3.10.0
 */
const withDefaults = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, defaults) => self.pipe(withDecodingDefault(defaults.decoding), withConstructorDefault(defaults.constructor)))));
/**
 * Enhances a property signature by specifying a different key for it in the Encoded type.
 *
 * @category PropertySignature
 * @since 3.10.0
 */
const fromKey = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, key) => {
  const ast = self.ast;
  switch (ast._tag) {
    case "PropertySignatureDeclaration":
      {
        return makePropertySignature(new Schema_PropertySignatureTransformation(new FromPropertySignature(ast.type, ast.isOptional, ast.isReadonly, ast.annotations, key), new ToPropertySignature(AST.typeAST(ast.type), ast.isOptional, ast.isReadonly, {}, ast.defaultValue), identity, identity));
      }
    case "PropertySignatureTransformation":
      return makePropertySignature(new Schema_PropertySignatureTransformation(new FromPropertySignature(ast.from.type, ast.from.isOptional, ast.from.isReadonly, ast.from.annotations, key), ast.to, ast.decode, ast.encode));
  }
})));
/**
 * Converts an optional property to a required one through a transformation `Option -> Type`.
 *
 * - `decode`: `none` as argument means the value is missing in the input.
 * - `encode`: `none` as return value means the value will be missing in the output.
 *
 * @category PropertySignature
 * @since 3.10.0
 */
const optionalToRequired = (from, to, options) => makePropertySignature(new Schema_PropertySignatureTransformation(new FromPropertySignature(from.ast, true, true, {}, undefined), new ToPropertySignature(to.ast, false, true, {}, undefined), o => option_.some(options.decode(o)), option_.flatMap(options.encode)));
/**
 * Converts an optional property to a required one through a transformation `Type -> Option`.
 *
 * - `decode`: `none` as return value means the value will be missing in the output.
 * - `encode`: `none` as argument means the value is missing in the input.
 *
 * @category PropertySignature
 * @since 3.10.0
 */
const requiredToOptional = (from, to, options) => makePropertySignature(new Schema_PropertySignatureTransformation(new FromPropertySignature(from.ast, false, true, {}, undefined), new ToPropertySignature(to.ast, true, true, {}, undefined), option_.flatMap(options.decode), o => option_.some(options.encode(o))));
/**
 * Converts an optional property to another optional property through a transformation `Option -> Option`.
 *
 * - `decode`:
 *   - `none` as argument means the value is missing in the input.
 *   - `none` as return value means the value will be missing in the output.
 * - `encode`:
 *   - `none` as argument means the value is missing in the input.
 *   - `none` as return value means the value will be missing in the output.
 *
 * @category PropertySignature
 * @since 3.10.0
 */
const optionalToOptional = (from, to, options) => makePropertySignature(new Schema_PropertySignatureTransformation(new FromPropertySignature(from.ast, true, true, {}, undefined), new ToPropertySignature(to.ast, true, true, {}, undefined), options.decode, options.encode));
const optionalPropertySignatureAST = (self, options) => {
  const isExact = options?.exact;
  const defaultValue = options?.default;
  const isNullable = options?.nullable;
  const asOption = options?.as == "Option";
  const asOptionEncode = options?.onNoneEncoding ? option_.orElse(options.onNoneEncoding) : identity;
  if (isExact) {
    if (defaultValue) {
      if (isNullable) {
        return withConstructorDefault(optionalToRequired(NullOr(self), typeSchema(self), {
          decode: option_.match({
            onNone: defaultValue,
            onSome: a => a === null ? defaultValue() : a
          }),
          encode: option_.some
        }), defaultValue).ast;
      } else {
        return withConstructorDefault(optionalToRequired(self, typeSchema(self), {
          decode: option_.match({
            onNone: defaultValue,
            onSome: identity
          }),
          encode: option_.some
        }), defaultValue).ast;
      }
    } else if (asOption) {
      if (isNullable) {
        return optionalToRequired(NullOr(self), OptionFromSelf(typeSchema(self)), {
          decode: option_.filter(Predicate.isNotNull),
          encode: asOptionEncode
        }).ast;
      } else {
        return optionalToRequired(self, OptionFromSelf(typeSchema(self)), {
          decode: identity,
          encode: identity
        }).ast;
      }
    } else {
      if (isNullable) {
        return optionalToOptional(NullOr(self), typeSchema(self), {
          decode: option_.filter(Predicate.isNotNull),
          encode: identity
        }).ast;
      } else {
        return new PropertySignatureDeclaration(self.ast, true, true, {}, undefined);
      }
    }
  } else {
    if (defaultValue) {
      if (isNullable) {
        return withConstructorDefault(optionalToRequired(NullishOr(self), typeSchema(self), {
          decode: option_.match({
            onNone: defaultValue,
            onSome: a => a == null ? defaultValue() : a
          }),
          encode: option_.some
        }), defaultValue).ast;
      } else {
        return withConstructorDefault(optionalToRequired(UndefinedOr(self), typeSchema(self), {
          decode: option_.match({
            onNone: defaultValue,
            onSome: a => a === undefined ? defaultValue() : a
          }),
          encode: option_.some
        }), defaultValue).ast;
      }
    } else if (asOption) {
      if (isNullable) {
        return optionalToRequired(NullishOr(self), OptionFromSelf(typeSchema(self)), {
          decode: option_.filter(a => a != null),
          encode: asOptionEncode
        }).ast;
      } else {
        return optionalToRequired(UndefinedOr(self), OptionFromSelf(typeSchema(self)), {
          decode: option_.filter(Predicate.isNotUndefined),
          encode: asOptionEncode
        }).ast;
      }
    } else {
      if (isNullable) {
        return optionalToOptional(NullishOr(self), UndefinedOr(typeSchema(self)), {
          decode: option_.filter(Predicate.isNotNull),
          encode: identity
        }).ast;
      } else {
        return new PropertySignatureDeclaration(UndefinedOr(self).ast, true, true, {}, undefined);
      }
    }
  }
};
/**
 * @category PropertySignature
 * @since 3.10.0
 */
const optional = self => {
  const ast = self.ast === undefinedKeyword || self.ast === neverKeyword ? undefinedKeyword : UndefinedOr(self).ast;
  return new PropertySignatureWithFromImpl(new PropertySignatureDeclaration(ast, true, true, {}, undefined), self);
};
/**
 * @category PropertySignature
 * @since 3.10.0
 */
const optionalWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isSchema(args[0]), (self, options) => {
  return new PropertySignatureWithFromImpl(optionalPropertySignatureAST(self, options), self);
})));
const preserveMissingMessageAnnotation = /*#__PURE__*/pickAnnotations([MissingMessageAnnotationId]);
const getDefaultTypeLiteralAST = (fields, records) => {
  const ownKeys = util_ownKeys(fields);
  const pss = [];
  if (ownKeys.length > 0) {
    const from = [];
    const to = [];
    const transformations = [];
    for (let i = 0; i < ownKeys.length; i++) {
      const key = ownKeys[i];
      const field = fields[key];
      if (isPropertySignature(field)) {
        const ast = field.ast;
        switch (ast._tag) {
          case "PropertySignatureDeclaration":
            {
              const type = ast.type;
              const isOptional = ast.isOptional;
              const toAnnotations = ast.annotations;
              from.push(new PropertySignature(key, type, isOptional, true, preserveMissingMessageAnnotation(ast)));
              to.push(new PropertySignature(key, typeAST(type), isOptional, true, toAnnotations));
              pss.push(new PropertySignature(key, type, isOptional, true, toAnnotations));
              break;
            }
          case "PropertySignatureTransformation":
            {
              const fromKey = ast.from.fromKey ?? key;
              from.push(new PropertySignature(fromKey, ast.from.type, ast.from.isOptional, true, ast.from.annotations));
              to.push(new PropertySignature(key, ast.to.type, ast.to.isOptional, true, ast.to.annotations));
              transformations.push(new PropertySignatureTransformation(fromKey, key, ast.decode, ast.encode));
              break;
            }
        }
      } else {
        from.push(new PropertySignature(key, field.ast, false, true));
        to.push(new PropertySignature(key, typeAST(field.ast), false, true));
        pss.push(new PropertySignature(key, field.ast, false, true));
      }
    }
    if (esm_Array/* isNonEmptyReadonlyArray */.Ux(transformations)) {
      const issFrom = [];
      const issTo = [];
      for (const r of records) {
        const {
          indexSignatures,
          propertySignatures
        } = record(r.key.ast, r.value.ast);
        propertySignatures.forEach(ps => {
          from.push(ps);
          to.push(new PropertySignature(ps.name, typeAST(ps.type), ps.isOptional, ps.isReadonly, ps.annotations));
        });
        indexSignatures.forEach(is => {
          issFrom.push(is);
          issTo.push(new IndexSignature(is.parameter, typeAST(is.type), is.isReadonly));
        });
      }
      return new Transformation(new TypeLiteral(from, issFrom, {
        [AutoTitleAnnotationId]: "Struct (Encoded side)"
      }), new TypeLiteral(to, issTo, {
        [AutoTitleAnnotationId]: "Struct (Type side)"
      }), new TypeLiteralTransformation(transformations));
    }
  }
  const iss = [];
  for (const r of records) {
    const {
      indexSignatures,
      propertySignatures
    } = record(r.key.ast, r.value.ast);
    propertySignatures.forEach(ps => pss.push(ps));
    indexSignatures.forEach(is => iss.push(is));
  }
  return new TypeLiteral(pss, iss);
};
const lazilyMergeDefaults = (fields, out) => {
  const ownKeys = util_ownKeys(fields);
  for (const key of ownKeys) {
    const field = fields[key];
    if (out[key] === undefined && isPropertySignature(field)) {
      const ast = field.ast;
      const defaultValue = ast._tag === "PropertySignatureDeclaration" ? ast.defaultValue : ast.to.defaultValue;
      if (defaultValue !== undefined) {
        out[key] = defaultValue();
      }
    }
  }
  return out;
};
function makeTypeLiteralClass(fields, records, ast = getDefaultTypeLiteralAST(fields, records)) {
  return class TypeLiteralClass extends Schema_make(ast) {
    static annotations(annotations) {
      return makeTypeLiteralClass(this.fields, this.records, mergeSchemaAnnotations(this.ast, annotations));
    }
    static fields = {
      ...fields
    };
    static records = [...records];
    static make = (props, options) => {
      const propsWithDefaults = lazilyMergeDefaults(fields, {
        ...props
      });
      return getDisableValidationMakeOption(options) ? propsWithDefaults : validateSync(this)(propsWithDefaults);
    };
    static pick(...keys) {
      return Schema_Struct(Struct/* pick */.ei(fields, ...keys));
    }
    static omit(...keys) {
      return Schema_Struct(Struct/* omit */.CE(fields, ...keys));
    }
  };
}
function Schema_Struct(fields, ...records) {
  return makeTypeLiteralClass(fields, records);
}
/**
 * Returns a property signature that represents a tag.
 * A tag is a literal value that is used to distinguish between different types of objects.
 * The tag is optional when using the `make` method.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Schema } from "effect"
 *
 * const User = Schema.Struct({
 *   _tag: Schema.tag("User"),
 *   name: Schema.String,
 *   age: Schema.Number
 * })
 *
 * assert.deepStrictEqual(User.make({ name: "John", age: 44 }), { _tag: "User", name: "John", age: 44 })
 * ```
 *
 * @see {@link TaggedStruct}
 *
 * @since 3.10.0
 */
const tag = tag => Schema_Literal(tag).pipe(propertySignature, withConstructorDefault(() => tag));
/**
 * A tagged struct is a struct that has a tag property that is used to distinguish between different types of objects.
 *
 * The tag is optional when using the `make` method.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Schema } from "effect"
 *
 * const User = Schema.TaggedStruct("User", {
 *   name: Schema.String,
 *   age: Schema.Number
 * })
 *
 * assert.deepStrictEqual(User.make({ name: "John", age: 44 }), { _tag: "User", name: "John", age: 44 })
 * ```
 *
 * @category constructors
 * @since 3.10.0
 */
const TaggedStruct = (value, fields) => Schema_Struct({
  _tag: tag(value),
  ...fields
});
function makeRecordClass(key, value, ast) {
  return class RecordClass extends makeTypeLiteralClass({}, [{
    key,
    value
  }], ast) {
    static annotations(annotations) {
      return makeRecordClass(key, value, mergeSchemaAnnotations(this.ast, annotations));
    }
    static key = key;
    static value = value;
  };
}
/**
 * @category constructors
 * @since 3.10.0
 */
const Record = options => makeRecordClass(options.key, options.value);
/**
 * @category struct transformations
 * @since 3.10.0
 */
const Schema_pick = (...keys) => self => Schema_make(AST.pick(self.ast, keys));
/**
 * @category struct transformations
 * @since 3.10.0
 */
const Schema_omit = (...keys) => self => Schema_make(AST.omit(self.ast, keys));
/**
 * Given a schema `Schema<A, I, R>` and a key `key: K`, this function extracts a specific field from the `A` type,
 * producing a new schema that represents a transformation from the `{ readonly [key]: I[K] }` type to `A[K]`.
 *
 * @example
 * ```ts
 * import * as Schema from "effect/Schema"
 *
 * // ---------------------------------------------
 * // use case: pull out a single field from a
 * // struct through a transformation
 * // ---------------------------------------------
 *
 * const mytable = Schema.Struct({
 *   column1: Schema.NumberFromString,
 *   column2: Schema.Number
 * })
 *
 * // const pullOutColumn: S.Schema<number, {
 * //     readonly column1: string;
 * // }, never>
 * const pullOutColumn = mytable.pipe(Schema.pluck("column1"))
 *
 * console.log(Schema.decodeUnknownEither(Schema.Array(pullOutColumn))([{ column1: "1", column2: 100 }, { column1: "2", column2: 300 }]))
 * // Output: { _id: 'Either', _tag: 'Right', right: [ 1, 2 ] }
 * ```
 *
 * @category struct transformations
 * @since 3.10.0
 */
const pluck = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (schema, key) => {
  const ps = AST.getPropertyKeyIndexedAccess(AST.typeAST(schema.ast), key);
  const value = Schema_make(ps.isOptional ? AST.orUndefined(ps.type) : ps.type);
  const out = transform(schema.pipe(Schema_pick(key)), value, {
    strict: true,
    decode: i => i[key],
    encode: a => ps.isOptional && a === undefined ? {} : {
      [key]: a
    }
  });
  return out;
})));
function makeBrandClass(from, ast) {
  return class BrandClass extends Schema_make(ast) {
    static annotations(annotations) {
      return makeBrandClass(this.from, mergeSchemaAnnotations(this.ast, annotations));
    }
    static make = (a, options) => {
      return getDisableValidationMakeOption(options) ? a : ParseResult.validateSync(this)(a);
    };
    static from = from;
  };
}
/**
 * Returns a nominal branded schema by applying a brand to a given schema.
 *
 * ```
 * Schema<A> + B -> Schema<A & Brand<B>>
 * ```
 *
 * @example
 * ```ts
 * import * as Schema from "effect/Schema"
 *
 * const Int = Schema.Number.pipe(Schema.int(), Schema.brand("Int"))
 * type Int = Schema.Schema.Type<typeof Int> // number & Brand<"Int">
 * ```
 *
 * @category branding
 * @since 3.10.0
 */
const brand = (brand, annotations) => self => {
  const annotation = option_.match(AST.getBrandAnnotation(self.ast), {
    onNone: () => [brand],
    onSome: brands => [...brands, brand]
  });
  const ast = AST.annotations(self.ast, toASTAnnotations({
    [AST.BrandAnnotationId]: annotation,
    ...annotations
  }));
  return makeBrandClass(self, ast);
};
/**
 * @category combinators
 * @since 3.10.0
 */
const Schema_partial = self => Schema_make(AST.partial(self.ast));
/**
 * @category combinators
 * @since 3.10.0
 */
const partialWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isSchema(args[0]), (self, options) => Schema_make(AST.partial(self.ast, options)))));
/**
 * @category combinators
 * @since 3.10.0
 */
const Schema_required = self => Schema_make(AST.required(self.ast));
/**
 * Creates a new schema with shallow mutability applied to its properties.
 *
 * @category combinators
 * @since 3.10.0
 */
const Schema_mutable = schema => Schema_make(AST.mutable(schema.ast));
const intersectTypeLiterals = (x, y, path) => {
  if (AST.isTypeLiteral(x) && AST.isTypeLiteral(y)) {
    const propertySignatures = [...x.propertySignatures];
    for (const ps of y.propertySignatures) {
      const name = ps.name;
      const i = propertySignatures.findIndex(ps => ps.name === name);
      if (i === -1) {
        propertySignatures.push(ps);
      } else {
        const {
          isOptional,
          type
        } = propertySignatures[i];
        propertySignatures[i] = new AST.PropertySignature(name, extendAST(type, ps.type, path.concat(name)), isOptional, true);
      }
    }
    return new AST.TypeLiteral(propertySignatures, x.indexSignatures.concat(y.indexSignatures));
  }
  throw new Error(errors_.getSchemaExtendErrorMessage(x, y, path));
};
const preserveRefinementAnnotations = /*#__PURE__*/omitAnnotations([IdentifierAnnotationId]);
const addRefinementToMembers = (refinement, asts) => asts.map(ast => new AST.Refinement(ast, refinement.filter, preserveRefinementAnnotations(refinement)));
const extendAST = (x, y, path) => AST.Union.make(intersectUnionMembers([x], [y], path));
const getTypes = ast => AST.isUnion(ast) ? ast.types : [ast];
const intersectUnionMembers = (xs, ys, path) => array_.flatMap(xs, x => array_.flatMap(ys, y => {
  switch (y._tag) {
    case "Literal":
      {
        if (Predicate.isString(y.literal) && AST.isStringKeyword(x) || Predicate.isNumber(y.literal) && AST.isNumberKeyword(x) || Predicate.isBoolean(y.literal) && AST.isBooleanKeyword(x)) {
          return [y];
        }
        break;
      }
    case "StringKeyword":
      {
        if (y === AST.stringKeyword) {
          if (AST.isStringKeyword(x) || AST.isLiteral(x) && Predicate.isString(x.literal)) {
            return [x];
          } else if (AST.isRefinement(x)) {
            return addRefinementToMembers(x, intersectUnionMembers(getTypes(x.from), [y], path));
          }
        } else if (x === AST.stringKeyword) {
          return [y];
        }
        break;
      }
    case "NumberKeyword":
      {
        if (y === AST.numberKeyword) {
          if (AST.isNumberKeyword(x) || AST.isLiteral(x) && Predicate.isNumber(x.literal)) {
            return [x];
          } else if (AST.isRefinement(x)) {
            return addRefinementToMembers(x, intersectUnionMembers(getTypes(x.from), [y], path));
          }
        } else if (x === AST.numberKeyword) {
          return [y];
        }
        break;
      }
    case "BooleanKeyword":
      {
        if (y === AST.booleanKeyword) {
          if (AST.isBooleanKeyword(x) || AST.isLiteral(x) && Predicate.isBoolean(x.literal)) {
            return [x];
          } else if (AST.isRefinement(x)) {
            return addRefinementToMembers(x, intersectUnionMembers(getTypes(x.from), [y], path));
          }
        } else if (x === AST.booleanKeyword) {
          return [y];
        }
        break;
      }
    case "Union":
      return intersectUnionMembers(getTypes(x), y.types, path);
    case "Suspend":
      return [new AST.Suspend(() => extendAST(x, y.f(), path))];
    case "Refinement":
      return addRefinementToMembers(y, intersectUnionMembers(getTypes(x), getTypes(y.from), path));
    case "TypeLiteral":
      {
        switch (x._tag) {
          case "Union":
            return intersectUnionMembers(x.types, [y], path);
          case "Suspend":
            return [new AST.Suspend(() => extendAST(x.f(), y, path))];
          case "Refinement":
            return addRefinementToMembers(x, intersectUnionMembers(getTypes(x.from), [y], path));
          case "TypeLiteral":
            return [intersectTypeLiterals(x, y, path)];
          case "Transformation":
            {
              const transformation = x.transformation;
              const from = intersectTypeLiterals(x.from, y, path);
              const to = intersectTypeLiterals(x.to, AST.typeAST(y), path);
              switch (transformation._tag) {
                case "TypeLiteralTransformation":
                  return [new AST.Transformation(from, to, new AST.TypeLiteralTransformation(transformation.propertySignatureTransformations))];
                case "ComposeTransformation":
                  return [new AST.Transformation(from, to, AST.composeTransformation)];
                case "FinalTransformation":
                  return [new AST.Transformation(from, to, new AST.FinalTransformation((fromA, options, ast, fromI) => ParseResult.map(transformation.decode(fromA, options, ast, fromI), partial => ({
                    ...fromA,
                    ...partial
                  })), (toI, options, ast, toA) => ParseResult.map(transformation.encode(toI, options, ast, toA), partial => ({
                    ...toI,
                    ...partial
                  }))))];
              }
            }
        }
        break;
      }
    case "Transformation":
      {
        if (AST.isTransformation(x)) {
          if (AST.isTypeLiteralTransformation(y.transformation) && AST.isTypeLiteralTransformation(x.transformation)) {
            return [new AST.Transformation(intersectTypeLiterals(x.from, y.from, path), intersectTypeLiterals(x.to, y.to, path), new AST.TypeLiteralTransformation(y.transformation.propertySignatureTransformations.concat(x.transformation.propertySignatureTransformations)))];
          }
        } else {
          return intersectUnionMembers([y], [x], path);
        }
        break;
      }
  }
  throw new Error(errors_.getSchemaExtendErrorMessage(x, y, path));
}));
/**
 * Extends a schema with another schema.
 *
 * Not all extensions are supported, and their support depends on the nature of
 * the involved schemas.
 *
 * Possible extensions include:
 * - `Schema.String` with another `Schema.String` refinement or a string literal
 * - `Schema.Number` with another `Schema.Number` refinement or a number literal
 * - `Schema.Boolean` with another `Schema.Boolean` refinement or a boolean
 *   literal
 * - A struct with another struct where overlapping fields support extension
 * - A struct with in index signature
 * - A struct with a union of supported schemas
 * - A refinement of a struct with a supported schema
 * - A suspend of a struct with a supported schema
 * - A transformation between structs where the “from” and “to” sides have no
 *   overlapping fields with the target struct
 *
 * @example
 * ```ts
 * import * as Schema from "effect/Schema"
 *
 * const schema = Schema.Struct({
 *   a: Schema.String,
 *   b: Schema.String
 * })
 *
 * // const extended: Schema<
 * //   {
 * //     readonly a: string
 * //     readonly b: string
 * //   } & {
 * //     readonly c: string
 * //   } & {
 * //     readonly [x: string]: string
 * //   }
 * // >
 * const extended = Schema.asSchema(schema.pipe(
 *   Schema.extend(Schema.Struct({ c: Schema.String })), // <= you can add more fields
 *   Schema.extend(Schema.Record({ key: Schema.String, value: Schema.String })) // <= you can add index signatures
 * ))
 * ```
 *
 * @category combinators
 * @since 3.10.0
 */
const extend = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => Schema_make(extendAST(self.ast, that.ast, [])))));
/**
 * @category combinators
 * @since 3.10.0
 */
const Schema_compose = /*#__PURE__*/(0,Function/* dual */.OB)(args => isSchema(args[1]), (from, to) => makeTransformationClass(from, to, compose(from.ast, to.ast)));
/**
 * @category constructors
 * @since 3.10.0
 */
const suspend = f => Schema_make(new Suspend(() => f().ast));
/**
 * @since 3.10.0
 * @category symbol
 */
const RefineSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Refine");
function makeRefineClass(from, filter, ast) {
  return class RefineClass extends Schema_make(ast) {
    static annotations(annotations) {
      return makeRefineClass(this.from, this.filter, mergeSchemaAnnotations(this.ast, annotations));
    }
    static [RefineSchemaId] = from;
    static from = from;
    static filter = filter;
    static make = (a, options) => {
      return getDisableValidationMakeOption(options) ? a : validateSync(this)(a);
    };
  };
}
const fromFilterPredicateReturnTypeItem = (item, ast, input) => {
  if (esm_Predicate/* isBoolean */.jn(item)) {
    return item ? esm_Option/* none */.YP() : esm_Option/* some */.G(new ParseResult_Type(ast, input));
  }
  if (esm_Predicate/* isString */.HD(item)) {
    return esm_Option/* some */.G(new ParseResult_Type(ast, input, item));
  }
  if (item !== undefined) {
    if ("_tag" in item) {
      return esm_Option/* some */.G(item);
    }
    const issue = new ParseResult_Type(ast, input, item.message);
    return esm_Option/* some */.G(esm_Array/* isNonEmptyReadonlyArray */.Ux(item.path) ? new Pointer(item.path, input, issue) : issue);
  }
  return esm_Option/* none */.YP();
};
const toFilterParseIssue = (out, ast, input) => {
  if (isSingle(out)) {
    return fromFilterPredicateReturnTypeItem(out, ast, input);
  }
  if (esm_Array/* isNonEmptyReadonlyArray */.Ux(out)) {
    const issues = esm_Array/* filterMap */.DZ(out, issue => fromFilterPredicateReturnTypeItem(issue, ast, input));
    if (esm_Array/* isNonEmptyReadonlyArray */.Ux(issues)) {
      return esm_Option/* some */.G(issues.length === 1 ? issues[0] : new Composite(ast, input, issues));
    }
  }
  return esm_Option/* none */.YP();
};
function filter(predicate, annotations) {
  return self => {
    function filter(input, options, ast) {
      return toFilterParseIssue(predicate(input, options, ast), ast, input);
    }
    const ast = new Refinement(self.ast, filter, toASTAnnotations(annotations));
    return makeRefineClass(self, filter, ast);
  };
}
/**
 * @category transformations
 * @since 3.10.0
 */
const filterEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => transformOrFail(self, typeSchema(self), {
  strict: true,
  decode: (i, options, ast) => ParseResult.flatMap(f(i, options, ast), filterReturnType => option_.match(toFilterParseIssue(filterReturnType, ast, i), {
    onNone: () => ParseResult.succeed(i),
    onSome: ParseResult.fail
  })),
  encode: a => ParseResult.succeed(a)
}))));
function makeTransformationClass(from, to, ast) {
  return class TransformationClass extends Schema_make(ast) {
    static annotations(annotations) {
      return makeTransformationClass(this.from, this.to, mergeSchemaAnnotations(this.ast, annotations));
    }
    static from = from;
    static to = to;
  };
}
/**
 * Create a new `Schema` by transforming the input and output of an existing `Schema`
 * using the provided decoding functions.
 *
 * @category transformations
 * @since 3.10.0
 */
const transformOrFail = /*#__PURE__*/(0,Function/* dual */.OB)(args => isSchema(args[0]) && isSchema(args[1]), (from, to, options) => makeTransformationClass(from, to, new Transformation(from.ast, to.ast, new FinalTransformation(options.decode, options.encode))));
/**
 * Create a new `Schema` by transforming the input and output of an existing `Schema`
 * using the provided mapping functions.
 *
 * @category transformations
 * @since 3.10.0
 */
const transform = /*#__PURE__*/(0,Function/* dual */.OB)(args => isSchema(args[0]) && isSchema(args[1]), (from, to, options) => transformOrFail(from, to, {
  strict: true,
  decode: (fromA, _options, _ast, toA) => succeed(options.decode(fromA, toA)),
  encode: (toI, _options, _ast, toA) => succeed(options.encode(toI, toA))
}));
/**
 * Creates a new `Schema` which transforms literal values.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import * as S from "effect/Schema"
 *
 * const schema = S.transformLiteral(0, "a")
 *
 * assert.deepStrictEqual(S.decodeSync(schema)(0), "a")
 * ```
 *
 * @category constructors
 * @since 3.10.0
 */
function transformLiteral(from, to) {
  return transform(Schema_Literal(from), Schema_Literal(to), {
    strict: true,
    decode: () => to,
    encode: () => from
  });
}
function transformLiterals(...pairs) {
  return Schema_Union(...pairs.map(([from, to]) => transformLiteral(from, to)));
}
/**
 * Attaches a property signature with the specified key and value to the schema.
 * This API is useful when you want to add a property to your schema which doesn't describe the shape of the input,
 * but rather maps to another schema, for example when you want to add a discriminant to a simple union.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import * as S from "effect/Schema"
 * import { pipe } from "effect/Function"
 *
 * const Circle = S.Struct({ radius: S.Number })
 * const Square = S.Struct({ sideLength: S.Number })
 * const Shape = S.Union(
 *   Circle.pipe(S.attachPropertySignature("kind", "circle")),
 *   Square.pipe(S.attachPropertySignature("kind", "square"))
 * )
 *
 * assert.deepStrictEqual(S.decodeSync(Shape)({ radius: 10 }), {
 *   kind: "circle",
 *   radius: 10
 * })
 * ```
 *
 * @category combinators
 * @since 3.10.0
 */
const attachPropertySignature = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isSchema(args[0]), (schema, key, value, annotations) => {
  const ast = extend(typeSchema(schema), Schema_Struct({
    [key]: Predicate.isSymbol(value) ? UniqueSymbolFromSelf(value) : Schema_Literal(value)
  })).ast;
  return Schema_make(new AST.Transformation(schema.ast, annotations ? mergeSchemaAnnotations(ast, annotations) : ast, new AST.TypeLiteralTransformation([new AST.PropertySignatureTransformation(key, key, () => option_.some(value), () => option_.none())])));
})));
/**
 * Merges a set of new annotations with existing ones, potentially overwriting
 * any duplicates.
 *
 * @category annotations
 * @since 3.10.0
 */
const annotations = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, annotations) => self.annotations(annotations))));
/**
 * @category renaming
 * @since 3.10.0
 */
const Schema_rename = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, mapping) => Schema_make(AST.rename(self.ast, mapping)))));
/**
 * @category schema id
 * @since 3.10.0
 */
const TrimmedSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Trimmed");
/**
 * Verifies that a string contains no leading or trailing whitespaces.
 *
 * Note. This combinator does not make any transformations, it only validates.
 * If what you were looking for was a combinator to trim strings, then check out the `trim` combinator.
 *
 * @category string filters
 * @since 3.10.0
 */
const trimmed = annotations => self => self.pipe(filter(a => a === a.trim(), {
  schemaId: TrimmedSchemaId,
  title: "trimmed",
  description: "a string with no leading or trailing whitespace",
  jsonSchema: {
    pattern: "^\\S[\\s\\S]*\\S$|^\\S$|^$"
  },
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_MaxLengthSchemaId = MaxLengthSchemaId;
/**
 * @category string filters
 * @since 3.10.0
 */
const maxLength = (maxLength, annotations) => self => self.pipe(filter(a => a.length <= maxLength, {
  schemaId: Schema_MaxLengthSchemaId,
  title: `maxLength(${maxLength})`,
  description: `a string at most ${maxLength} character(s) long`,
  jsonSchema: {
    maxLength
  },
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_MinLengthSchemaId = MinLengthSchemaId;
/**
 * @category string filters
 * @since 3.10.0
 */
const minLength = (minLength, annotations) => self => self.pipe(filter(a => a.length >= minLength, {
  schemaId: Schema_MinLengthSchemaId,
  title: `minLength(${minLength})`,
  description: `a string at least ${minLength} character(s) long`,
  jsonSchema: {
    minLength
  },
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_LengthSchemaId = LengthSchemaId;
/**
 * @category string filters
 * @since 3.10.0
 */
const Schema_length = (length, annotations) => self => {
  const minLength = esm_Predicate/* isObject */.Kn(length) ? Math.max(0, Math.floor(length.min)) : Math.max(0, Math.floor(length));
  const maxLength = esm_Predicate/* isObject */.Kn(length) ? Math.max(minLength, Math.floor(length.max)) : minLength;
  if (minLength !== maxLength) {
    return self.pipe(filter(a => a.length >= minLength && a.length <= maxLength, {
      schemaId: Schema_LengthSchemaId,
      title: `length({ min: ${minLength}, max: ${maxLength})`,
      description: `a string at least ${minLength} character(s) and at most ${maxLength} character(s) long`,
      jsonSchema: {
        minLength,
        maxLength
      },
      ...annotations
    }));
  }
  return self.pipe(filter(a => a.length === minLength, {
    schemaId: Schema_LengthSchemaId,
    title: `length(${minLength})`,
    description: minLength === 1 ? `a single character` : `a string ${minLength} character(s) long`,
    jsonSchema: {
      minLength,
      maxLength: minLength
    },
    ...annotations
  }));
};
/**
 * @category schema id
 * @since 3.10.0
 */
const PatternSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Pattern");
/**
 * @category string filters
 * @since 3.10.0
 */
const pattern = (regex, annotations) => self => {
  const source = regex.source;
  return self.pipe(filter(a => {
    // The following line ensures that `lastIndex` is reset to `0` in case the user has specified the `g` flag
    regex.lastIndex = 0;
    return regex.test(a);
  }, {
    schemaId: PatternSchemaId,
    [PatternSchemaId]: {
      regex
    },
    // title: `pattern(/${source}/)`, // avoiding this because it can be very long
    description: `a string matching the pattern ${source}`,
    jsonSchema: {
      pattern: source
    },
    ...annotations
  }));
};
/**
 * @category schema id
 * @since 3.10.0
 */
const StartsWithSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/StartsWith")));
/**
 * @category string filters
 * @since 3.10.0
 */
const startsWith = (startsWith, annotations) => self => {
  const formatted = JSON.stringify(startsWith);
  return self.pipe(filter(a => a.startsWith(startsWith), {
    schemaId: StartsWithSchemaId,
    [StartsWithSchemaId]: {
      startsWith
    },
    title: `startsWith(${formatted})`,
    description: `a string starting with ${formatted}`,
    jsonSchema: {
      pattern: `^${startsWith}`
    },
    ...annotations
  }));
};
/**
 * @category schema id
 * @since 3.10.0
 */
const EndsWithSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/EndsWith")));
/**
 * @category string filters
 * @since 3.10.0
 */
const endsWith = (endsWith, annotations) => self => {
  const formatted = JSON.stringify(endsWith);
  return self.pipe(filter(a => a.endsWith(endsWith), {
    schemaId: EndsWithSchemaId,
    [EndsWithSchemaId]: {
      endsWith
    },
    title: `endsWith(${formatted})`,
    description: `a string ending with ${formatted}`,
    jsonSchema: {
      pattern: `^.*${endsWith}$`
    },
    ...annotations
  }));
};
/**
 * @category schema id
 * @since 3.10.0
 */
const IncludesSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/Includes")));
/**
 * @category string filters
 * @since 3.10.0
 */
const includes = (searchString, annotations) => self => {
  const formatted = JSON.stringify(searchString);
  return self.pipe(filter(a => a.includes(searchString), {
    schemaId: IncludesSchemaId,
    [IncludesSchemaId]: {
      includes: searchString
    },
    title: `includes(${formatted})`,
    description: `a string including ${formatted}`,
    jsonSchema: {
      pattern: `.*${searchString}.*`
    },
    ...annotations
  }));
};
/**
 * @category schema id
 * @since 3.10.0
 */
const LowercasedSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Lowercased");
/**
 * Verifies that a string is lowercased.
 *
 * @category string filters
 * @since 3.10.0
 */
const lowercased = annotations => self => self.pipe(filter(a => a === a.toLowerCase(), {
  schemaId: LowercasedSchemaId,
  title: "lowercased",
  description: "a lowercase string",
  jsonSchema: {
    pattern: "^[^A-Z]*$"
  },
  ...annotations
}));
/**
 * @category string constructors
 * @since 3.10.0
 */
class Lowercased extends /*#__PURE__*/String$.pipe( /*#__PURE__*/lowercased({
  identifier: "Lowercased"
})) {}
/**
 * @category schema id
 * @since 3.10.0
 */
const UppercasedSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Uppercased");
/**
 * Verifies that a string is uppercased.
 *
 * @category string filters
 * @since 3.10.0
 */
const uppercased = annotations => self => self.pipe(filter(a => a === a.toUpperCase(), {
  schemaId: UppercasedSchemaId,
  title: "uppercased",
  description: "an uppercase string",
  jsonSchema: {
    pattern: "^[^a-z]*$"
  },
  ...annotations
}));
/**
 * @category string constructors
 * @since 3.10.0
 */
class Uppercased extends /*#__PURE__*/String$.pipe( /*#__PURE__*/uppercased({
  identifier: "Uppercased"
})) {}
/**
 * @category schema id
 * @since 3.10.0
 */
const CapitalizedSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Capitalized");
/**
 * Verifies that a string is capitalized.
 *
 * @category string filters
 * @since 3.10.0
 */
const capitalized = annotations => self => self.pipe(filter(a => a[0]?.toUpperCase() === a[0], {
  schemaId: CapitalizedSchemaId,
  title: "capitalized",
  description: "a capitalized string",
  jsonSchema: {
    pattern: "^[^a-z]?.*$"
  },
  ...annotations
}));
/**
 * @category string constructors
 * @since 3.10.0
 */
class Capitalized extends /*#__PURE__*/String$.pipe( /*#__PURE__*/capitalized({
  identifier: "Capitalized"
})) {}
/**
 * @category schema id
 * @since 3.10.0
 */
const UncapitalizedSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/Uncapitalized");
/**
 * Verifies that a string is uncapitalized.
 *
 * @category string filters
 * @since 3.10.0
 */
const uncapitalized = annotations => self => self.pipe(filter(a => a[0]?.toLowerCase() === a[0], {
  schemaId: UncapitalizedSchemaId,
  title: "uncapitalized",
  description: "a uncapitalized string",
  jsonSchema: {
    pattern: "^[^A-Z]?.*$"
  },
  ...annotations
}));
/**
 * @category string constructors
 * @since 3.10.0
 */
class Uncapitalized extends /*#__PURE__*/String$.pipe( /*#__PURE__*/uncapitalized({
  identifier: "Uncapitalized"
})) {}
/**
 * A schema representing a single character.
 *
 * @category string constructors
 * @since 3.10.0
 */
class Char extends /*#__PURE__*/String$.pipe( /*#__PURE__*/Schema_length(1, {
  identifier: "Char"
})) {}
/**
 * @category string filters
 * @since 3.10.0
 */
const nonEmptyString = annotations => minLength(1, {
  title: "nonEmptyString",
  description: "a non empty string",
  ...annotations
});
/**
 * This schema converts a string to lowercase.
 *
 * @category string transformations
 * @since 3.10.0
 */
class Lowercase extends /*#__PURE__*/transform(String$.annotations({
  description: "a string that will be converted to lowercase"
}), Lowercased, {
  strict: true,
  decode: i => i.toLowerCase(),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "Lowercase"
}) {}
/**
 * This schema converts a string to uppercase.
 *
 * @category string transformations
 * @since 3.10.0
 */
class Uppercase extends /*#__PURE__*/transform(String$.annotations({
  description: "a string that will be converted to uppercase"
}), Uppercased, {
  strict: true,
  decode: i => i.toUpperCase(),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "Uppercase"
}) {}
/**
 * This schema converts a string to capitalized one.
 *
 * @category string transformations
 * @since 3.10.0
 */
class Capitalize extends /*#__PURE__*/transform(String$.annotations({
  description: "a string that will be converted to a capitalized format"
}), Capitalized, {
  strict: true,
  decode: i => esm_String/* capitalize */.kC(i),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "Capitalize"
}) {}
/**
 * This schema converts a string to uncapitalized one.
 *
 * @category string transformations
 * @since 3.10.0
 */
class Uncapitalize extends /*#__PURE__*/transform(String$.annotations({
  description: "a string that will be converted to an uncapitalized format"
}), Uncapitalized, {
  strict: true,
  decode: i => esm_String/* uncapitalize */.Le(i),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "Uncapitalize"
}) {}
/**
 * @category string constructors
 * @since 3.10.0
 */
class Trimmed extends /*#__PURE__*/String$.pipe( /*#__PURE__*/trimmed({
  identifier: "Trimmed"
})) {}
/**
 * Useful for validating strings that must contain meaningful characters without
 * leading or trailing whitespace.
 *
 * @example
 * ```ts
 * import { Schema } from "effect"
 *
 * console.log(Schema.decodeOption(Schema.NonEmptyTrimmedString)("")) // Option.none()
 * console.log(Schema.decodeOption(Schema.NonEmptyTrimmedString)(" a ")) // Option.none()
 * console.log(Schema.decodeOption(Schema.NonEmptyTrimmedString)("a")) // Option.some("a")
 * ```
 *
 * @category string constructors
 * @since 3.10.0
 */
class NonEmptyTrimmedString extends /*#__PURE__*/Trimmed.pipe( /*#__PURE__*/nonEmptyString({
  identifier: "NonEmptyTrimmedString"
})) {}
/**
 * This schema allows removing whitespaces from the beginning and end of a string.
 *
 * @category string transformations
 * @since 3.10.0
 */
class Trim extends /*#__PURE__*/transform(String$.annotations({
  description: "a string that will be trimmed"
}), Trimmed, {
  strict: true,
  decode: i => i.trim(),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "Trim"
}) {}
/**
 * Returns a schema that allows splitting a string into an array of strings.
 *
 * @category string transformations
 * @since 3.10.0
 */
const split = separator => transform(String$.annotations({
  description: "a string that will be split"
}), Array$(String$), {
  strict: true,
  decode: i => i.split(separator),
  encode: a => a.join(separator)
});
const Schema_getErrorMessage = e => e instanceof Error ? e.message : String(e);
const getParseJsonTransformation = options => transformOrFail(String$.annotations({
  description: "a string to be decoded into JSON"
}), Unknown, {
  strict: true,
  decode: (i, _, ast) => ParseResult.try({
    try: () => JSON.parse(i, options?.reviver),
    catch: e => new ParseResult.Type(ast, i, Schema_getErrorMessage(e))
  }),
  encode: (a, _, ast) => ParseResult.try({
    try: () => JSON.stringify(a, options?.replacer, options?.space),
    catch: e => new ParseResult.Type(ast, a, Schema_getErrorMessage(e))
  })
}).annotations({
  title: "parseJson",
  schemaId: AST.ParseJsonSchemaId
});
/**
 * The `ParseJson` combinator provides a method to convert JSON strings into the `unknown` type using the underlying
 * functionality of `JSON.parse`. It also utilizes `JSON.stringify` for encoding.
 *
 * You can optionally provide a `ParseJsonOptions` to configure both `JSON.parse` and `JSON.stringify` executions.
 *
 * Optionally, you can pass a schema `Schema<A, I, R>` to obtain an `A` type instead of `unknown`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import * as Schema from "effect/Schema"
 *
 * assert.deepStrictEqual(Schema.decodeUnknownSync(Schema.parseJson())(`{"a":"1"}`), { a: "1" })
 * assert.deepStrictEqual(Schema.decodeUnknownSync(Schema.parseJson(Schema.Struct({ a: Schema.NumberFromString })))(`{"a":"1"}`), { a: 1 })
 * ```
 *
 * @category string transformations
 * @since 3.10.0
 */
const parseJson = (schemaOrOptions, o) => isSchema(schemaOrOptions) ? Schema_compose(parseJson(o), schemaOrOptions) : getParseJsonTransformation(schemaOrOptions);
/**
 * @category string constructors
 * @since 3.10.0
 */
class NonEmptyString extends /*#__PURE__*/String$.pipe( /*#__PURE__*/nonEmptyString({
  identifier: "NonEmptyString"
})) {}
/**
 * @category schema id
 * @since 3.10.0
 */
const UUIDSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/UUID");
const uuidRegexp = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;
/**
 * Represents a Universally Unique Identifier (UUID).
 *
 * This schema ensures that the provided string adheres to the standard UUID format.
 *
 * @category string constructors
 * @since 3.10.0
 */
class UUID extends /*#__PURE__*/String$.pipe( /*#__PURE__*/pattern(uuidRegexp, {
  schemaId: UUIDSchemaId,
  identifier: "UUID",
  jsonSchema: {
    format: "uuid",
    pattern: uuidRegexp.source
  },
  description: "a Universally Unique Identifier",
  arbitrary: () => fc => fc.uuid()
})) {}
/**
 * @category schema id
 * @since 3.10.0
 */
const ULIDSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/ULID");
const ulidRegexp = /^[0-7][0-9A-HJKMNP-TV-Z]{25}$/i;
/**
 * Represents a Universally Unique Lexicographically Sortable Identifier (ULID).
 *
 * ULIDs are designed to be compact, URL-safe, and ordered, making them suitable for use as identifiers.
 * This schema ensures that the provided string adheres to the standard ULID format.
 *
 * @category string constructors
 * @since 3.10.0
 */
class ULID extends /*#__PURE__*/String$.pipe( /*#__PURE__*/pattern(ulidRegexp, {
  schemaId: ULIDSchemaId,
  identifier: "ULID",
  description: "a Universally Unique Lexicographically Sortable Identifier",
  arbitrary: () => fc => fc.ulid()
})) {}
/**
 * Defines a schema that represents a `URL` object.
 *
 * @category URL constructors
 * @since 3.11.0
 */
class URLFromSelf extends /*#__PURE__*/instanceOf(URL, {
  identifier: "URLFromSelf",
  arbitrary: () => fc => fc.webUrl().map(s => new URL(s)),
  pretty: () => url => url.toString()
}) {}
/** @ignore */
class URL$ extends /*#__PURE__*/transformOrFail(String$.annotations({
  description: "a string to be decoded into a URL"
}), URLFromSelf, {
  strict: true,
  decode: (i, _, ast) => _try({
    try: () => new URL(i),
    catch: e => new ParseResult_Type(ast, i, `Unable to decode ${JSON.stringify(i)} into a URL. ${Schema_getErrorMessage(e)}`)
  }),
  encode: a => succeed(a.toString())
}).annotations({
  identifier: "URL",
  pretty: () => url => url.toString()
}) {}

/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_FiniteSchemaId = FiniteSchemaId;
/**
 * Ensures that the provided value is a finite number (excluding NaN, +Infinity, and -Infinity).
 *
 * @category number filters
 * @since 3.10.0
 */
const finite = annotations => self => self.pipe(filter(Number.isFinite, {
  schemaId: Schema_FiniteSchemaId,
  title: "finite",
  description: "a finite number",
  jsonSchema: {
    "type": "number"
  },
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_GreaterThanSchemaId = GreaterThanSchemaId;
/**
 * This filter checks whether the provided number is greater than the specified minimum.
 *
 * @category number filters
 * @since 3.10.0
 */
const Schema_greaterThan = (exclusiveMinimum, annotations) => self => self.pipe(filter(a => a > exclusiveMinimum, {
  schemaId: Schema_GreaterThanSchemaId,
  title: `greaterThan(${exclusiveMinimum})`,
  description: exclusiveMinimum === 0 ? "a positive number" : `a number greater than ${exclusiveMinimum}`,
  jsonSchema: {
    exclusiveMinimum
  },
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_GreaterThanOrEqualToSchemaId = GreaterThanOrEqualToSchemaId;
/**
 * This filter checks whether the provided number is greater than or equal to the specified minimum.
 *
 * @category number filters
 * @since 3.10.0
 */
const Schema_greaterThanOrEqualTo = (minimum, annotations) => self => self.pipe(filter(a => a >= minimum, {
  schemaId: Schema_GreaterThanOrEqualToSchemaId,
  title: `greaterThanOrEqualTo(${minimum})`,
  description: minimum === 0 ? "a non-negative number" : `a number greater than or equal to ${minimum}`,
  jsonSchema: {
    minimum
  },
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const MultipleOfSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/MultipleOf")));
/**
 * @category number filters
 * @since 3.10.0
 */
const multipleOf = (divisor, annotations) => self => {
  const positiveDivisor = Math.abs(divisor); // spec requires positive divisor
  return self.pipe(filter(a => number_.remainder(a, divisor) === 0, {
    schemaId: MultipleOfSchemaId,
    title: `multipleOf(${positiveDivisor})`,
    description: `a number divisible by ${positiveDivisor}`,
    jsonSchema: {
      multipleOf: positiveDivisor
    },
    ...annotations
  }));
};
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_IntSchemaId = IntSchemaId;
/**
 * Ensures that the provided value is an integer number (excluding NaN, +Infinity, and -Infinity).
 *
 * @category number filters
 * @since 3.10.0
 */
const Schema_int = annotations => self => self.pipe(filter(a => Number.isSafeInteger(a), {
  schemaId: Schema_IntSchemaId,
  title: "int",
  description: "an integer",
  jsonSchema: {
    type: "integer"
  },
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_LessThanSchemaId = LessThanSchemaId;
/**
 * This filter checks whether the provided number is less than the specified maximum.
 *
 * @category number filters
 * @since 3.10.0
 */
const Schema_lessThan = (exclusiveMaximum, annotations) => self => self.pipe(filter(a => a < exclusiveMaximum, {
  schemaId: Schema_LessThanSchemaId,
  title: `lessThan(${exclusiveMaximum})`,
  description: exclusiveMaximum === 0 ? "a negative number" : `a number less than ${exclusiveMaximum}`,
  jsonSchema: {
    exclusiveMaximum
  },
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_LessThanOrEqualToSchemaId = LessThanOrEqualToSchemaId;
/**
 * This schema checks whether the provided number is less than or equal to the specified maximum.
 *
 * @category number filters
 * @since 3.10.0
 */
const Schema_lessThanOrEqualTo = (maximum, annotations) => self => self.pipe(filter(a => a <= maximum, {
  schemaId: Schema_LessThanOrEqualToSchemaId,
  title: `lessThanOrEqualTo(${maximum})`,
  description: maximum === 0 ? "a non-positive number" : `a number less than or equal to ${maximum}`,
  jsonSchema: {
    maximum
  },
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_BetweenSchemaId = BetweenSchemaId;
/**
 * This filter checks whether the provided number falls within the specified minimum and maximum values.
 *
 * @category number filters
 * @since 3.10.0
 */
const Schema_between = (minimum, maximum, annotations) => self => self.pipe(filter(a => a >= minimum && a <= maximum, {
  schemaId: Schema_BetweenSchemaId,
  title: `between(${minimum}, ${maximum})`,
  description: `a number between ${minimum} and ${maximum}`,
  jsonSchema: {
    minimum,
    maximum
  },
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_NonNaNSchemaId = NonNaNSchemaId;
/**
 * @category number filters
 * @since 3.10.0
 */
const nonNaN = annotations => self => self.pipe(filter(a => !Number.isNaN(a), {
  schemaId: Schema_NonNaNSchemaId,
  title: "nonNaN",
  description: "a number excluding NaN",
  ...annotations
}));
/**
 * @category number filters
 * @since 3.10.0
 */
const positive = annotations => Schema_greaterThan(0, {
  title: "positive",
  ...annotations
});
/**
 * @category number filters
 * @since 3.10.0
 */
const negative = annotations => Schema_lessThan(0, {
  title: "negative",
  ...annotations
});
/**
 * @category number filters
 * @since 3.10.0
 */
const nonPositive = annotations => Schema_lessThanOrEqualTo(0, {
  title: "nonPositive",
  ...annotations
});
/**
 * @category number filters
 * @since 3.10.0
 */
const nonNegative = annotations => Schema_greaterThanOrEqualTo(0, {
  title: "nonNegative",
  ...annotations
});
/**
 * Clamps a number between a minimum and a maximum value.
 *
 * @category number transformations
 * @since 3.10.0
 */
const Schema_clamp = (minimum, maximum) => self => {
  return transform(self, typeSchema(self).pipe(Schema_between(minimum, maximum)), {
    strict: false,
    decode: i => number_.clamp(i, {
      minimum,
      maximum
    }),
    encode: identity
  });
};
/**
 * Transforms a `string` into a `number` by parsing the string using the `parse`
 * function of the `effect/Number` module.
 *
 * It returns an error if the value can't be converted (for example when
 * non-numeric characters are provided).
 *
 * The following special string values are supported: "NaN", "Infinity",
 * "-Infinity".
 *
 * @category number transformations
 * @since 3.10.0
 */
function parseNumber(self) {
  return transformOrFail(self, Number$, {
    strict: false,
    decode: (i, _, ast) => fromOption(esm_Number/* parse */.Qc(i), () => new ParseResult_Type(ast, i, `Unable to decode ${JSON.stringify(i)} into a number`)),
    encode: a => succeed(String(a))
  });
}
/**
 * This schema transforms a `string` into a `number` by parsing the string using the `parse` function of the `effect/Number` module.
 *
 * It returns an error if the value can't be converted (for example when non-numeric characters are provided).
 *
 * The following special string values are supported: "NaN", "Infinity", "-Infinity".
 *
 * @category number transformations
 * @since 3.10.0
 */
class NumberFromString extends /*#__PURE__*/parseNumber(String$.annotations({
  description: "a string to be decoded into a number"
})).annotations({
  identifier: "NumberFromString"
}) {}
/**
 * @category number constructors
 * @since 3.10.0
 */
class Finite extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/finite({
  identifier: "Finite"
})) {}
/**
 * @category number constructors
 * @since 3.10.0
 */
class Int extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/Schema_int({
  identifier: "Int"
})) {}
/**
 * @category number constructors
 * @since 3.10.0
 */
class NonNaN extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/nonNaN({
  identifier: "NonNaN"
})) {}
/**
 * @category number constructors
 * @since 3.10.0
 */
class Positive extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/positive({
  identifier: "Positive"
})) {}
/**
 * @category number constructors
 * @since 3.10.0
 */
class Negative extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/negative({
  identifier: "Negative"
})) {}
/**
 * @category number constructors
 * @since 3.10.0
 */
class NonPositive extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/nonPositive({
  identifier: "NonPositive"
})) {}
/**
 * @category number constructors
 * @since 3.10.0
 */
class NonNegative extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/nonNegative({
  identifier: "NonNegative"
})) {}
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_JsonNumberSchemaId = JsonNumberSchemaId;
/**
 * The `JsonNumber` is a schema for representing JSON numbers. It ensures that the provided value is a valid
 * number by filtering out `NaN` and `(+/-) Infinity`. This is useful when you want to validate and represent numbers in JSON
 * format.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import * as Schema from "effect/Schema"
 *
 * const is = Schema.is(S.JsonNumber)
 *
 * assert.deepStrictEqual(is(42), true)
 * assert.deepStrictEqual(is(Number.NaN), false)
 * assert.deepStrictEqual(is(Number.POSITIVE_INFINITY), false)
 * assert.deepStrictEqual(is(Number.NEGATIVE_INFINITY), false)
 * ```
 *
 * @category number constructors
 * @since 3.10.0
 */
class JsonNumber extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/finite({
  schemaId: Schema_JsonNumberSchemaId,
  identifier: "JsonNumber"
})) {}
/**
 * @category boolean transformations
 * @since 3.10.0
 */
class Not extends /*#__PURE__*/transform( /*#__PURE__*/Boolean$.annotations({
  description: "a boolean that will be negated"
}), Boolean$, {
  strict: true,
  decode: i => Boolean/* not */.ff(i),
  encode: a => Boolean/* not */.ff(a)
}) {}
const encodeSymbol = (sym, ast) => {
  const key = Symbol.keyFor(sym);
  return key === undefined ? fail(new ParseResult_Type(ast, sym, `Unable to encode a unique symbol ${String(sym)} into a string`)) : succeed(key);
};
const decodeSymbol = s => succeed(Symbol.for(s));
/** @ignore */
class Symbol$ extends /*#__PURE__*/transformOrFail(String$.annotations({
  description: "a string to be decoded into a globally shared symbol"
}), SymbolFromSelf, {
  strict: false,
  decode: i => decodeSymbol(i),
  encode: (a, _, ast) => encodeSymbol(a, ast)
}).annotations({
  identifier: "Symbol"
}) {}

/**
 * @category schema id
 * @since 3.10.0
 */
const GreaterThanBigIntSchemaId = GreaterThanBigintSchemaId;
/**
 * @category bigint filters
 * @since 3.10.0
 */
const greaterThanBigInt = (min, annotations) => self => self.pipe(filter(a => a > min, {
  schemaId: GreaterThanBigIntSchemaId,
  [GreaterThanBigIntSchemaId]: {
    min
  },
  title: `greaterThanBigInt(${min})`,
  description: min === 0n ? "a positive bigint" : `a bigint greater than ${min}n`,
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_GreaterThanOrEqualToBigIntSchemaId = GreaterThanOrEqualToBigIntSchemaId;
/**
 * @category bigint filters
 * @since 3.10.0
 */
const greaterThanOrEqualToBigInt = (min, annotations) => self => self.pipe(filter(a => a >= min, {
  schemaId: Schema_GreaterThanOrEqualToBigIntSchemaId,
  [Schema_GreaterThanOrEqualToBigIntSchemaId]: {
    min
  },
  title: `greaterThanOrEqualToBigInt(${min})`,
  description: min === 0n ? "a non-negative bigint" : `a bigint greater than or equal to ${min}n`,
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_LessThanBigIntSchemaId = LessThanBigIntSchemaId;
/**
 * @category bigint filters
 * @since 3.10.0
 */
const lessThanBigInt = (max, annotations) => self => self.pipe(filter(a => a < max, {
  schemaId: Schema_LessThanBigIntSchemaId,
  [Schema_LessThanBigIntSchemaId]: {
    max
  },
  title: `lessThanBigInt(${max})`,
  description: max === 0n ? "a negative bigint" : `a bigint less than ${max}n`,
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_LessThanOrEqualToBigIntSchemaId = LessThanOrEqualToBigIntSchemaId;
/**
 * @category bigint filters
 * @since 3.10.0
 */
const lessThanOrEqualToBigInt = (max, annotations) => self => self.pipe(filter(a => a <= max, {
  schemaId: Schema_LessThanOrEqualToBigIntSchemaId,
  [Schema_LessThanOrEqualToBigIntSchemaId]: {
    max
  },
  title: `lessThanOrEqualToBigInt(${max})`,
  description: max === 0n ? "a non-positive bigint" : `a bigint less than or equal to ${max}n`,
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const BetweenBigIntSchemaId = BetweenBigintSchemaId;
/**
 * @category bigint filters
 * @since 3.10.0
 */
const betweenBigInt = (min, max, annotations) => self => self.pipe(filter(a => a >= min && a <= max, {
  schemaId: BetweenBigIntSchemaId,
  [BetweenBigIntSchemaId]: {
    min,
    max
  },
  title: `betweenBigInt(${min}, ${max})`,
  description: `a bigint between ${min}n and ${max}n`,
  ...annotations
}));
/**
 * @category bigint filters
 * @since 3.10.0
 */
const positiveBigInt = annotations => greaterThanBigInt(0n, {
  title: "positiveBigInt",
  ...annotations
});
/**
 * @category bigint filters
 * @since 3.10.0
 */
const negativeBigInt = annotations => lessThanBigInt(0n, {
  title: "negativeBigInt",
  ...annotations
});
/**
 * @category bigint filters
 * @since 3.10.0
 */
const nonNegativeBigInt = annotations => greaterThanOrEqualToBigInt(0n, {
  title: "nonNegativeBigInt",
  ...annotations
});
/**
 * @category bigint filters
 * @since 3.10.0
 */
const nonPositiveBigInt = annotations => lessThanOrEqualToBigInt(0n, {
  title: "nonPositiveBigInt",
  ...annotations
});
/**
 * Clamps a bigint between a minimum and a maximum value.
 *
 * @category bigint transformations
 * @since 3.10.0
 */
const clampBigInt = (minimum, maximum) => self => transform(self, self.pipe(typeSchema, betweenBigInt(minimum, maximum)), {
  strict: false,
  decode: i => bigInt_.clamp(i, {
    minimum,
    maximum
  }),
  encode: identity
});
/** @ignore */
class BigInt$ extends /*#__PURE__*/transformOrFail(String$.annotations({
  description: "a string to be decoded into a bigint"
}), BigIntFromSelf, {
  strict: true,
  decode: (i, _, ast) => fromOption(esm_BigInt/* fromString */.mL(i), () => new ParseResult_Type(ast, i, `Unable to decode ${JSON.stringify(i)} into a bigint`)),
  encode: a => succeed(String(a))
}).annotations({
  identifier: "BigInt"
}) {}

/**
 * @category bigint constructors
 * @since 3.10.0
 */
const PositiveBigIntFromSelf = /*#__PURE__*/BigIntFromSelf.pipe( /*#__PURE__*/positiveBigInt({
  identifier: "PositiveBigintFromSelf"
}));
/**
 * @category bigint constructors
 * @since 3.10.0
 */
const PositiveBigInt = /*#__PURE__*/BigInt$.pipe( /*#__PURE__*/positiveBigInt({
  identifier: "PositiveBigint"
}));
/**
 * @category bigint constructors
 * @since 3.10.0
 */
const NegativeBigIntFromSelf = /*#__PURE__*/BigIntFromSelf.pipe( /*#__PURE__*/negativeBigInt({
  identifier: "NegativeBigintFromSelf"
}));
/**
 * @category bigint constructors
 * @since 3.10.0
 */
const NegativeBigInt = /*#__PURE__*/BigInt$.pipe( /*#__PURE__*/negativeBigInt({
  identifier: "NegativeBigint"
}));
/**
 * @category bigint constructors
 * @since 3.10.0
 */
const NonPositiveBigIntFromSelf = /*#__PURE__*/BigIntFromSelf.pipe( /*#__PURE__*/nonPositiveBigInt({
  identifier: "NonPositiveBigintFromSelf"
}));
/**
 * @category bigint constructors
 * @since 3.10.0
 */
const NonPositiveBigInt = /*#__PURE__*/BigInt$.pipe( /*#__PURE__*/nonPositiveBigInt({
  identifier: "NonPositiveBigint"
}));
/**
 * @category bigint constructors
 * @since 3.10.0
 */
const NonNegativeBigIntFromSelf = /*#__PURE__*/BigIntFromSelf.pipe( /*#__PURE__*/nonNegativeBigInt({
  identifier: "NonNegativeBigintFromSelf"
}));
/**
 * @category bigint constructors
 * @since 3.10.0
 */
const NonNegativeBigInt = /*#__PURE__*/BigInt$.pipe( /*#__PURE__*/nonNegativeBigInt({
  identifier: "NonNegativeBigint"
}));
/**
 * This schema transforms a `number` into a `bigint` by parsing the number using the `BigInt` function.
 *
 * It returns an error if the value can't be safely encoded as a `number` due to being out of range.
 *
 * @category bigint transformations
 * @since 3.10.0
 */
class BigIntFromNumber extends /*#__PURE__*/transformOrFail(Number$.annotations({
  description: "a number to be decoded into a bigint"
}), BigIntFromSelf.pipe(betweenBigInt(BigInt(Number.MIN_SAFE_INTEGER), BigInt(Number.MAX_SAFE_INTEGER))), {
  strict: true,
  decode: (i, _, ast) => fromOption(esm_BigInt/* fromNumber */.xS(i), () => new ParseResult_Type(ast, i, `Unable to decode ${i} into a bigint`)),
  encode: (a, _, ast) => fromOption(esm_BigInt/* toNumber */.He(a), () => new ParseResult_Type(ast, a, `Unable to encode ${a}n into a number`))
}).annotations({
  identifier: "BigIntFromNumber"
}) {}
const redactedArbitrary = value => fc => value(fc).map(redacted_.make);
const toComposite = (eff, onSuccess, ast, actual) => mapBoth(eff, {
  onFailure: e => new Composite(ast, actual, e),
  onSuccess
});
const redactedParse = decodeUnknown => (u, options, ast) => redacted_.isRedacted(u) ? toComposite(decodeUnknown(redacted_.value(u), options), redacted_.make, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Redacted constructors
 * @since 3.10.0
 */
const RedactedFromSelf = value => declare([value], {
  decode: value => redactedParse(ParseResult.decodeUnknown(value)),
  encode: value => redactedParse(ParseResult.encodeUnknown(value))
}, {
  description: "Redacted(<redacted>)",
  pretty: () => () => "Redacted(<redacted>)",
  arbitrary: redactedArbitrary,
  equivalence: redacted_.getEquivalence
});
/**
 * A transformation that transform a `Schema<A, I, R>` into a
 * `RedactedFromSelf<A>`.
 *
 * @category Redacted transformations
 * @since 3.10.0
 */
function Redacted(value) {
  return transform(value, RedactedFromSelf(typeSchema(asSchema(value))), {
    strict: true,
    decode: i => redacted_.make(i),
    encode: a => redacted_.value(a)
  });
}
/**
 * @category Duration constructors
 * @since 3.10.0
 */
class DurationFromSelf extends /*#__PURE__*/declare(Duration/* isDuration */._9, {
  identifier: "DurationFromSelf",
  pretty: () => String,
  arbitrary: () => fc => fc.oneof(fc.constant(Duration/* infinity */.Fd), fc.bigInt({
    min: 0n
  }).map(_ => Duration/* nanos */.o6(_)), fc.maxSafeNat().map(_ => Duration/* millis */.YX(_))),
  equivalence: () => Duration/* Equivalence */.CZ
}) {}
/**
 * A schema that transforms a non negative `bigint` into a `Duration`. Treats
 * the value as the number of nanoseconds.
 *
 * @category Duration transformations
 * @since 3.10.0
 */
class DurationFromNanos extends /*#__PURE__*/transformOrFail(NonNegativeBigIntFromSelf.annotations({
  description: "a bigint to be decoded into a Duration"
}), DurationFromSelf.pipe(filter(duration => Duration/* isFinite */.xV(duration), {
  description: "a finite duration"
})), {
  strict: true,
  decode: i => succeed(Duration/* nanos */.o6(i)),
  encode: (a, _, ast) => esm_Option/* match */.EQ(Duration/* toNanos */.CU(a), {
    onNone: () => fail(new ParseResult_Type(ast, a, `Unable to encode ${a} into a bigint`)),
    onSome: nanos => succeed(nanos)
  })
}).annotations({
  identifier: "DurationFromNanos"
}) {}
/**
 * A non-negative integer. +Infinity is excluded.
 *
 * @category number constructors
 * @since 3.11.10
 */
const NonNegativeInt = /*#__PURE__*/NonNegative.pipe(Schema_int()).annotations({
  identifier: "NonNegativeInt"
});
/**
 * A schema that transforms a (possibly Infinite) non negative number into a
 * `Duration`. Treats the value as the number of milliseconds.
 *
 * @category Duration transformations
 * @since 3.10.0
 */
class DurationFromMillis extends /*#__PURE__*/transform(NonNegative.annotations({
  description: "a non-negative number to be decoded into a Duration"
}), DurationFromSelf, {
  strict: true,
  decode: i => Duration/* millis */.YX(i),
  encode: a => Duration/* toMillis */.eq(a)
}).annotations({
  identifier: "DurationFromMillis"
}) {}
const DurationValueMillis = /*#__PURE__*/TaggedStruct("Millis", {
  millis: NonNegativeInt
});
const DurationValueNanos = /*#__PURE__*/TaggedStruct("Nanos", {
  nanos: BigInt$
});
const DurationValueInfinity = /*#__PURE__*/TaggedStruct("Infinity", {});
const durationValueInfinity = /*#__PURE__*/DurationValueInfinity.make({});
const DurationValue = /*#__PURE__*/Schema_Union(DurationValueMillis, DurationValueNanos, DurationValueInfinity).annotations({
  identifier: "DurationValue",
  description: "an JSON-compatible tagged union to be decoded into a Duration"
});
const FiniteHRTime = /*#__PURE__*/Tuple(Schema_element(NonNegativeInt).annotations({
  title: "seconds"
}), Schema_element(NonNegativeInt).annotations({
  title: "nanos"
})).annotations({
  identifier: "FiniteHRTime"
});
const InfiniteHRTime = /*#__PURE__*/Tuple(Schema_Literal(-1), Schema_Literal(0)).annotations({
  identifier: "InfiniteHRTime"
});
const HRTime = /*#__PURE__*/Schema_Union(FiniteHRTime, InfiniteHRTime).annotations({
  identifier: "HRTime",
  description: "a tuple of seconds and nanos to be decoded into a Duration"
});
const isDurationValue = u => typeof u === "object";
// TODO(4.0): remove HRTime union member
/**
 * A schema that converts a JSON-compatible tagged union into a `Duration`.
 *
 * @category Duration transformations
 * @since 3.10.0
 */
class Schema_Duration extends /*#__PURE__*/transform(Schema_Union(DurationValue, HRTime), DurationFromSelf, {
  strict: true,
  decode: i => {
    if (isDurationValue(i)) {
      switch (i._tag) {
        case "Millis":
          return Duration/* millis */.YX(i.millis);
        case "Nanos":
          return Duration/* nanos */.o6(i.nanos);
        case "Infinity":
          return Duration/* infinity */.Fd;
      }
    }
    const [seconds, nanos] = i;
    return seconds === -1 ? Duration/* infinity */.Fd : Duration/* nanos */.o6(BigInt(seconds) * BigInt(1e9) + BigInt(nanos));
  },
  encode: a => {
    switch (a.value._tag) {
      case "Millis":
        return DurationValueMillis.make({
          millis: a.value.millis
        });
      case "Nanos":
        return DurationValueNanos.make({
          nanos: a.value.nanos
        });
      case "Infinity":
        return durationValueInfinity;
    }
  }
}).annotations({
  identifier: "Duration"
}) {}
/**
 * Clamps a `Duration` between a minimum and a maximum value.
 *
 * @category Duration transformations
 * @since 3.10.0
 */
const clampDuration = (minimum, maximum) => self => transform(self, self.pipe(typeSchema, betweenDuration(minimum, maximum)), {
  strict: false,
  decode: i => duration_.clamp(i, {
    minimum,
    maximum
  }),
  encode: identity
});
/**
 * @category schema id
 * @since 3.10.0
 */
const LessThanDurationSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/LessThanDuration")));
/**
 * @category Duration filters
 * @since 3.10.0
 */
const lessThanDuration = (max, annotations) => self => self.pipe(filter(a => duration_.lessThan(a, max), {
  schemaId: LessThanDurationSchemaId,
  [LessThanDurationSchemaId]: {
    max
  },
  title: `lessThanDuration(${max})`,
  description: `a Duration less than ${duration_.decode(max)}`,
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const LessThanOrEqualToDurationSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/schema/LessThanOrEqualToDuration")));
/**
 * @category Duration filters
 * @since 3.10.0
 */
const lessThanOrEqualToDuration = (max, annotations) => self => self.pipe(filter(a => duration_.lessThanOrEqualTo(a, max), {
  schemaId: LessThanDurationSchemaId,
  [LessThanDurationSchemaId]: {
    max
  },
  title: `lessThanOrEqualToDuration(${max})`,
  description: `a Duration less than or equal to ${duration_.decode(max)}`,
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const GreaterThanDurationSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/GreaterThanDuration")));
/**
 * @category Duration filters
 * @since 3.10.0
 */
const greaterThanDuration = (min, annotations) => self => self.pipe(filter(a => duration_.greaterThan(a, min), {
  schemaId: GreaterThanDurationSchemaId,
  [GreaterThanDurationSchemaId]: {
    min
  },
  title: `greaterThanDuration(${min})`,
  description: `a Duration greater than ${duration_.decode(min)}`,
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const GreaterThanOrEqualToDurationSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/schema/GreaterThanOrEqualToDuration")));
/**
 * @category Duration filters
 * @since 3.10.0
 */
const greaterThanOrEqualToDuration = (min, annotations) => self => self.pipe(filter(a => duration_.greaterThanOrEqualTo(a, min), {
  schemaId: GreaterThanOrEqualToDurationSchemaId,
  [GreaterThanOrEqualToDurationSchemaId]: {
    min
  },
  title: `greaterThanOrEqualToDuration(${min})`,
  description: `a Duration greater than or equal to ${duration_.decode(min)}`,
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const BetweenDurationSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/BetweenDuration")));
/**
 * @category Duration filters
 * @since 3.10.0
 */
const betweenDuration = (minimum, maximum, annotations) => self => self.pipe(filter(a => duration_.between(a, {
  minimum,
  maximum
}), {
  schemaId: BetweenDurationSchemaId,
  [BetweenDurationSchemaId]: {
    maximum,
    minimum
  },
  title: `betweenDuration(${minimum}, ${maximum})`,
  description: `a Duration between ${duration_.decode(minimum)} and ${duration_.decode(maximum)}`,
  ...annotations
}));
/**
 * @category Uint8Array constructors
 * @since 3.10.0
 */
class Uint8ArrayFromSelf extends /*#__PURE__*/declare(esm_Predicate/* isUint8Array */.lq, {
  identifier: "Uint8ArrayFromSelf",
  pretty: () => u8arr => `new Uint8Array(${JSON.stringify(Array.from(u8arr))})`,
  arbitrary: () => fc => fc.uint8Array(),
  equivalence: () => esm_Array/* getEquivalence */.c5(esm_Equal/* equals */.fS)
}) {}
/**
 * @category number constructors
 * @since 3.11.10
 */
class Uint8 extends /*#__PURE__*/Number$.pipe( /*#__PURE__*/Schema_between(0, 255, {
  identifier: "Uint8",
  description: "a 8-bit unsigned integer"
})) {}
/** @ignore */
class Uint8Array$ extends /*#__PURE__*/transform(Array$(Uint8).annotations({
  description: "an array of 8-bit unsigned integers to be decoded into a Uint8Array"
}), Uint8ArrayFromSelf, {
  strict: true,
  decode: i => Uint8Array.from(i),
  encode: a => Array.from(a)
}).annotations({
  identifier: "Uint8Array"
}) {}

const makeUint8ArrayTransformation = (id, decode, encode) => transformOrFail(String$.annotations({
  description: "a string to be decoded into a Uint8Array"
}), Uint8ArrayFromSelf, {
  strict: true,
  decode: (i, _, ast) => esm_Either/* mapLeft */.Vn(decode(i), decodeException => new ParseResult_Type(ast, i, decodeException.message)),
  encode: a => succeed(encode(a))
}).annotations({
  identifier: id
});
/**
 * Decodes a base64 (RFC4648) encoded string into a `Uint8Array`.
 *
 * @category Uint8Array transformations
 * @since 3.10.0
 */
const Uint8ArrayFromBase64 = /*#__PURE__*/makeUint8ArrayTransformation("Uint8ArrayFromBase64", Encoding/* decodeBase64 */.NV, Encoding/* encodeBase64 */.oF);
/**
 * Decodes a base64 (URL) encoded string into a `Uint8Array`.
 *
 * @category Uint8Array transformations
 * @since 3.10.0
 */
const Uint8ArrayFromBase64Url = /*#__PURE__*/makeUint8ArrayTransformation("Uint8ArrayFromBase64Url", Encoding/* decodeBase64Url */.fr, Encoding/* encodeBase64Url */.Mp);
/**
 * Decodes a hex encoded string into a `Uint8Array`.
 *
 * @category Uint8Array transformations
 * @since 3.10.0
 */
const Uint8ArrayFromHex = /*#__PURE__*/makeUint8ArrayTransformation("Uint8ArrayFromHex", Encoding/* decodeHex */.QT, Encoding/* encodeHex */.U$);
const makeEncodingTransformation = (id, decode, encode) => transformOrFail(String$.annotations({
  description: `A string that is interpreted as being ${id}-encoded and will be decoded into a UTF-8 string`
}), String$, {
  strict: true,
  decode: (i, _, ast) => esm_Either/* mapLeft */.Vn(decode(i), decodeException => new ParseResult_Type(ast, i, decodeException.message)),
  encode: a => succeed(encode(a))
}).annotations({
  identifier: `StringFrom${id}`
});
/**
 * Decodes a base64 (RFC4648) encoded string into a UTF-8 string.
 *
 * @category string transformations
 * @since 3.10.0
 */
const StringFromBase64 = /*#__PURE__*/makeEncodingTransformation("Base64", Encoding/* decodeBase64String */.TV, Encoding/* encodeBase64 */.oF);
/**
 * Decodes a base64 (URL) encoded string into a UTF-8 string.
 *
 * @category string transformations
 * @since 3.10.0
 */
const StringFromBase64Url = /*#__PURE__*/makeEncodingTransformation("Base64Url", Encoding/* decodeBase64UrlString */.K, Encoding/* encodeBase64Url */.Mp);
/**
 * Decodes a hex encoded string into a UTF-8 string.
 *
 * @category string transformations
 * @since 3.10.0
 */
const StringFromHex = /*#__PURE__*/makeEncodingTransformation("Hex", Encoding/* decodeHexString */.nX, Encoding/* encodeHex */.U$);
/**
 * Decodes a URI component encoded string into a UTF-8 string.
 * Can be used to store data in a URL.
 *
 * @example
 * ```ts
 * import { Schema } from "effect"
 *
 * const PaginationSchema = Schema.Struct({
 *   maxItemPerPage: Schema.Number,
 *   page: Schema.Number
 * })
 *
 * const UrlSchema = Schema.compose(Schema.StringFromUriComponent, Schema.parseJson(PaginationSchema))
 *
 * console.log(Schema.encodeSync(UrlSchema)({ maxItemPerPage: 10, page: 1 }))
 * // Output: %7B%22maxItemPerPage%22%3A10%2C%22page%22%3A1%7D
 * ```
 *
 * @category string transformations
 * @since 3.12.0
 */
const StringFromUriComponent = /*#__PURE__*/transformOrFail(String$.annotations({
  description: `A string that is interpreted as being UriComponent-encoded and will be decoded into a UTF-8 string`
}), String$, {
  strict: true,
  decode: (i, _, ast) => esm_Either/* mapLeft */.Vn(Encoding/* decodeUriComponent */.gi(i), decodeException => new ParseResult_Type(ast, i, decodeException.message)),
  encode: (a, _, ast) => esm_Either/* mapLeft */.Vn(Encoding/* encodeUriComponent */.BO(a), encodeException => new ParseResult_Type(ast, a, encodeException.message))
}).annotations({
  identifier: `StringFromUriComponent`
});
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_MinItemsSchemaId = MinItemsSchemaId;
/**
 * @category ReadonlyArray filters
 * @since 3.10.0
 */
const minItems = (n, annotations) => self => {
  const minItems = Math.floor(n);
  if (minItems < 1) {
    throw new Error(errors_.getInvalidArgumentErrorMessage(`Expected an integer greater than or equal to 1, actual ${n}`));
  }
  return self.pipe(filter(a => a.length >= minItems, {
    schemaId: Schema_MinItemsSchemaId,
    title: `minItems(${minItems})`,
    description: `an array of at least ${minItems} item(s)`,
    jsonSchema: {
      minItems
    },
    [AST.StableFilterAnnotationId]: true,
    ...annotations
  }));
};
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_MaxItemsSchemaId = MaxItemsSchemaId;
/**
 * @category ReadonlyArray filters
 * @since 3.10.0
 */
const maxItems = (n, annotations) => self => {
  const maxItems = Math.floor(n);
  if (maxItems < 1) {
    throw new Error(errors_.getInvalidArgumentErrorMessage(`Expected an integer greater than or equal to 1, actual ${n}`));
  }
  return self.pipe(filter(a => a.length <= maxItems, {
    schemaId: Schema_MaxItemsSchemaId,
    title: `maxItems(${maxItems})`,
    description: `an array of at most ${maxItems} item(s)`,
    jsonSchema: {
      maxItems
    },
    [AST.StableFilterAnnotationId]: true,
    ...annotations
  }));
};
/**
 * @category schema id
 * @since 3.10.0
 */
const Schema_ItemsCountSchemaId = ItemsCountSchemaId;
/**
 * @category ReadonlyArray filters
 * @since 3.10.0
 */
const itemsCount = (n, annotations) => self => {
  const itemsCount = Math.floor(n);
  if (itemsCount < 0) {
    throw new Error(errors_.getInvalidArgumentErrorMessage(`Expected an integer greater than or equal to 0, actual ${n}`));
  }
  return self.pipe(filter(a => a.length === itemsCount, {
    schemaId: Schema_ItemsCountSchemaId,
    title: `itemsCount(${itemsCount})`,
    description: `an array of exactly ${itemsCount} item(s)`,
    jsonSchema: {
      minItems: itemsCount,
      maxItems: itemsCount
    },
    [AST.StableFilterAnnotationId]: true,
    ...annotations
  }));
};
/**
 * @category ReadonlyArray transformations
 * @since 3.10.0
 */
const Schema_getNumberIndexedAccess = self => Schema_make(AST.getNumberIndexedAccess(self.ast));
/**
 * Get the first element of a `ReadonlyArray`, or `None` if the array is empty.
 *
 * @category ReadonlyArray transformations
 * @since 3.10.0
 */
function head(self) {
  return transform(self, OptionFromSelf(Schema_getNumberIndexedAccess(typeSchema(self))), {
    strict: false,
    decode: i => array_.head(i),
    encode: a => option_.match(a, {
      onNone: () => [],
      onSome: array_.of
    })
  });
}
/**
 * Get the first element of a `NonEmptyReadonlyArray`.
 *
 * @category NonEmptyReadonlyArray transformations
 * @since 3.12.0
 */
function headNonEmpty(self) {
  return transform(self, Schema_getNumberIndexedAccess(typeSchema(self)), {
    strict: false,
    decode: i => array_.headNonEmpty(i),
    encode: a => array_.of(a)
  });
}
/**
 * Retrieves the first element of a `ReadonlyArray`.
 *
 * If the array is empty, it returns the `fallback` argument if provided; otherwise, it fails.
 *
 * @category ReadonlyArray transformations
 * @since 3.10.0
 */
const headOrElse = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isSchema(args[0]), (self, fallback) => transformOrFail(self, Schema_getNumberIndexedAccess(typeSchema(self)), {
  strict: true,
  decode: (i, _, ast) => i.length > 0 ? ParseResult.succeed(i[0]) : fallback ? ParseResult.succeed(fallback()) : ParseResult.fail(new ParseResult.Type(ast, i, "Unable to retrieve the first element of an empty array")),
  encode: a => ParseResult.succeed(array_.of(a))
}))));
/**
 * @category schema id
 * @since 3.10.0
 */
const ValidDateSchemaId = /*#__PURE__*/Symbol.for("effect/SchemaId/ValidDate");
/**
 * Defines a filter that specifically rejects invalid dates, such as `new
 * Date("Invalid Date")`. This filter ensures that only properly formatted and
 * valid date objects are accepted, enhancing data integrity by preventing
 * erroneous date values from being processed.
 *
 * @category Date filters
 * @since 3.10.0
 */
const validDate = annotations => self => self.pipe(filter(a => !Number.isNaN(a.getTime()), {
  schemaId: ValidDateSchemaId,
  [ValidDateSchemaId]: {
    noInvalidDate: true
  },
  title: "validDate",
  description: "a valid Date",
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const LessThanDateSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/LessThanDate")));
/**
 * @category Date filters
 * @since 3.10.0
 */
const lessThanDate = (max, annotations) => self => self.pipe(filter(a => a < max, {
  schemaId: LessThanDateSchemaId,
  [LessThanDateSchemaId]: {
    max
  },
  title: `lessThanDate(${util_.formatDate(max)})`,
  description: `a date before ${util_.formatDate(max)}`,
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const LessThanOrEqualToDateSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/schema/LessThanOrEqualToDate")));
/**
 * @category Date filters
 * @since 3.10.0
 */
const lessThanOrEqualToDate = (max, annotations) => self => self.pipe(filter(a => a <= max, {
  schemaId: LessThanDateSchemaId,
  [LessThanDateSchemaId]: {
    max
  },
  title: `lessThanOrEqualToDate(${util_.formatDate(max)})`,
  description: `a date before or equal to ${util_.formatDate(max)}`,
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const GreaterThanDateSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/GreaterThanDate")));
/**
 * @category Date filters
 * @since 3.10.0
 */
const greaterThanDate = (min, annotations) => self => self.pipe(filter(a => a > min, {
  schemaId: GreaterThanDateSchemaId,
  [GreaterThanDateSchemaId]: {
    min
  },
  title: `greaterThanDate(${util_.formatDate(min)})`,
  description: `a date after ${util_.formatDate(min)}`,
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const GreaterThanOrEqualToDateSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/schema/GreaterThanOrEqualToDate")));
/**
 * @category Date filters
 * @since 3.10.0
 */
const greaterThanOrEqualToDate = (min, annotations) => self => self.pipe(filter(a => a >= min, {
  schemaId: GreaterThanOrEqualToDateSchemaId,
  [GreaterThanOrEqualToDateSchemaId]: {
    min
  },
  title: `greaterThanOrEqualToDate(${util_.formatDate(min)})`,
  description: `a date after or equal to ${util_.formatDate(min)}`,
  ...annotations
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const BetweenDateSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/BetweenDate")));
/**
 * @category Date filters
 * @since 3.10.0
 */
const betweenDate = (min, max, annotations) => self => self.pipe(filter(a => a <= max && a >= min, {
  schemaId: BetweenDateSchemaId,
  [BetweenDateSchemaId]: {
    max,
    min
  },
  title: `betweenDate(${util_.formatDate(min)}, ${util_.formatDate(max)})`,
  description: `a date between ${util_.formatDate(min)} and ${util_.formatDate(max)}`,
  ...annotations
}));
/**
 * @category schema id
 * @since 3.11.8
 */
const Schema_DateFromSelfSchemaId = DateFromSelfSchemaId;
/**
 * Describes a schema that accommodates potentially invalid `Date` instances,
 * such as `new Date("Invalid Date")`, without rejection.
 *
 * @category Date constructors
 * @since 3.10.0
 */
class DateFromSelf extends /*#__PURE__*/declare(esm_Predicate/* isDate */.J_, {
  identifier: "DateFromSelf",
  schemaId: Schema_DateFromSelfSchemaId,
  [Schema_DateFromSelfSchemaId]: {
    noInvalidDate: false
  },
  description: "a potentially invalid Date instance",
  pretty: () => date => `new Date(${JSON.stringify(date)})`,
  arbitrary: () => fc => fc.date({
    noInvalidDate: false
  }),
  equivalence: () => esm_Equivalence/* Date */.Ej
}) {}
/**
 * Defines a schema that ensures only valid dates are accepted. This schema
 * rejects values like `new Date("Invalid Date")`, which, despite being a `Date`
 * instance, represents an invalid date. Such stringent validation ensures that
 * all date objects processed through this schema are properly formed and
 * represent real dates.
 *
 * @category Date constructors
 * @since 3.10.0
 */
class ValidDateFromSelf extends /*#__PURE__*/DateFromSelf.pipe( /*#__PURE__*/validDate({
  identifier: "ValidDateFromSelf",
  description: "a valid Date instance"
})) {}
/**
 * Defines a schema that attempts to convert a `string` to a `Date` object using
 * the `new Date` constructor. This conversion is lenient, meaning it does not
 * reject strings that do not form valid dates (e.g., using `new Date("Invalid
 * Date")` results in a `Date` object, despite being invalid).
 *
 * @category Date transformations
 * @since 3.10.0
 */
class DateFromString extends /*#__PURE__*/transform(String$.annotations({
  description: "a string to be decoded into a Date"
}), DateFromSelf, {
  strict: true,
  decode: i => new Date(i),
  encode: a => formatDate(a)
}).annotations({
  identifier: "DateFromString"
}) {}
/** @ignore */
class Date$ extends /*#__PURE__*/DateFromString.pipe( /*#__PURE__*/validDate({
  identifier: "Date"
})) {}

/**
 * Defines a schema that converts a `number` into a `Date` object using the `new
 * Date` constructor. This schema does not validate the numerical input,
 * allowing potentially invalid values such as `NaN`, `Infinity`, and
 * `-Infinity` to be converted into `Date` objects. During the encoding process,
 * any invalid `Date` object will be encoded to `NaN`.
 *
 * @category Date transformations
 * @since 3.10.0
 */
class DateFromNumber extends /*#__PURE__*/transform(Number$.annotations({
  description: "a number to be decoded into a Date"
}), DateFromSelf, {
  strict: true,
  decode: i => new Date(i),
  encode: a => a.getTime()
}).annotations({
  identifier: "DateFromNumber"
}) {}
/**
 * Describes a schema that represents a `DateTime.Utc` instance.
 *
 * @category DateTime.Utc constructors
 * @since 3.10.0
 */
class DateTimeUtcFromSelf extends /*#__PURE__*/declare(u => DateTime_isDateTime(u) && DateTime_isUtc(u), {
  identifier: "DateTimeUtcFromSelf",
  description: "a DateTime.Utc instance",
  pretty: () => dateTime => dateTime.toString(),
  arbitrary: () => fc => fc.date({
    noInvalidDate: true
  }).map(date => DateTime_unsafeFromDate(date)),
  equivalence: () => DateTime_Equivalence
}) {}
const decodeDateTimeUtc = (input, ast) => _try({
  try: () => DateTime_unsafeMake(input),
  catch: () => new ParseResult_Type(ast, input, `Unable to decode ${formatUnknown(input)} into a DateTime.Utc`)
});
/**
 * Defines a schema that attempts to convert a `number` to a `DateTime.Utc` instance using the `DateTime.unsafeMake` constructor.
 *
 * @category DateTime.Utc transformations
 * @since 3.10.0
 */
class DateTimeUtcFromNumber extends /*#__PURE__*/transformOrFail(Number$.annotations({
  description: "a number to be decoded into a DateTime.Utc"
}), DateTimeUtcFromSelf, {
  strict: true,
  decode: (i, _, ast) => decodeDateTimeUtc(i, ast),
  encode: a => succeed(DateTime_toEpochMillis(a))
}).annotations({
  identifier: "DateTimeUtcFromNumber"
}) {}
/**
 * Defines a schema that attempts to convert a `Date` to a `DateTime.Utc` instance using the `DateTime.unsafeMake` constructor.
 *
 * @category DateTime.Utc transformations
 * @since 3.12.0
 */
class DateTimeUtcFromDate extends /*#__PURE__*/transformOrFail(DateFromSelf.annotations({
  description: "a Date to be decoded into a DateTime.Utc"
}), DateTimeUtcFromSelf, {
  strict: true,
  decode: (i, _, ast) => decodeDateTimeUtc(i, ast),
  encode: a => succeed(DateTime_toDateUtc(a))
}).annotations({
  identifier: "DateTimeUtcFromDate"
}) {}
/**
 * Defines a schema that attempts to convert a `string` to a `DateTime.Utc` instance using the `DateTime.unsafeMake` constructor.
 *
 * @category DateTime.Utc transformations
 * @since 3.10.0
 */
class DateTimeUtc extends /*#__PURE__*/transformOrFail(String$.annotations({
  description: "a string to be decoded into a DateTime.Utc"
}), DateTimeUtcFromSelf, {
  strict: true,
  decode: (i, _, ast) => decodeDateTimeUtc(i, ast),
  encode: a => succeed(DateTime_formatIso(a))
}).annotations({
  identifier: "DateTimeUtc"
}) {}
const timeZoneOffsetArbitrary = () => fc => fc.integer({
  min: -12 * 60 * 60 * 1000,
  max: 14 * 60 * 60 * 1000
}).map(DateTime_zoneMakeOffset);
/**
 * Describes a schema that represents a `TimeZone.Offset` instance.
 *
 * @category TimeZone constructors
 * @since 3.10.0
 */
class TimeZoneOffsetFromSelf extends /*#__PURE__*/declare(DateTime_isTimeZoneOffset, {
  identifier: "TimeZoneOffsetFromSelf",
  description: "a TimeZone.Offset instance",
  pretty: () => zone => zone.toString(),
  arbitrary: timeZoneOffsetArbitrary
}) {}
/**
 * Defines a schema that converts a `number` to a `TimeZone.Offset` instance using the `DateTime.zoneMakeOffset` constructor.
 *
 * @category TimeZone transformations
 * @since 3.10.0
 */
class TimeZoneOffset extends /*#__PURE__*/transform(Number$.annotations({
  description: "a number to be decoded into a TimeZone.Offset"
}), TimeZoneOffsetFromSelf, {
  strict: true,
  decode: i => DateTime_zoneMakeOffset(i),
  encode: a => a.offset
}).annotations({
  identifier: "TimeZoneOffset"
}) {}
const timeZoneNamedArbitrary = () => fc => fc.constantFrom(...Intl.supportedValuesOf("timeZone")).map(DateTime_zoneUnsafeMakeNamed);
/**
 * Describes a schema that represents a `TimeZone.Named` instance.
 *
 * @category TimeZone constructors
 * @since 3.10.0
 */
class TimeZoneNamedFromSelf extends /*#__PURE__*/declare(DateTime_isTimeZoneNamed, {
  identifier: "TimeZoneNamedFromSelf",
  description: "a TimeZone.Named instance",
  pretty: () => zone => zone.toString(),
  arbitrary: timeZoneNamedArbitrary
}) {}
/**
 * Defines a schema that attempts to convert a `string` to a `TimeZone.Named` instance using the `DateTime.zoneUnsafeMakeNamed` constructor.
 *
 * @category TimeZone transformations
 * @since 3.10.0
 */
class TimeZoneNamed extends /*#__PURE__*/transformOrFail(String$.annotations({
  description: "a string to be decoded into a TimeZone.Named"
}), TimeZoneNamedFromSelf, {
  strict: true,
  decode: (i, _, ast) => _try({
    try: () => DateTime_zoneUnsafeMakeNamed(i),
    catch: () => new ParseResult_Type(ast, i, `Unable to decode ${JSON.stringify(i)} into a TimeZone.Named`)
  }),
  encode: a => succeed(a.id)
}).annotations({
  identifier: "TimeZoneNamed"
}) {}
/**
 * @category TimeZone constructors
 * @since 3.10.0
 */
class TimeZoneFromSelf extends /*#__PURE__*/Schema_Union(TimeZoneOffsetFromSelf, TimeZoneNamedFromSelf) {}
/**
 * Defines a schema that attempts to convert a `string` to a `TimeZone` using the `DateTime.zoneFromString` constructor.
 *
 * @category TimeZone transformations
 * @since 3.10.0
 */
class TimeZone extends /*#__PURE__*/transformOrFail(String$.annotations({
  description: "a string to be decoded into a TimeZone"
}), TimeZoneFromSelf, {
  strict: true,
  decode: (i, _, ast) => esm_Option/* match */.EQ(DateTime_zoneFromString(i), {
    onNone: () => fail(new ParseResult_Type(ast, i, `Unable to decode ${JSON.stringify(i)} into a TimeZone`)),
    onSome: succeed
  }),
  encode: a => succeed(DateTime_zoneToString(a))
}).annotations({
  identifier: "TimeZone"
}) {}
const timeZoneArbitrary = fc => fc.oneof(timeZoneOffsetArbitrary()(fc), timeZoneNamedArbitrary()(fc));
/**
 * Describes a schema that represents a `DateTime.Zoned` instance.
 *
 * @category DateTime.Zoned constructors
 * @since 3.10.0
 */
class DateTimeZonedFromSelf extends /*#__PURE__*/declare(u => DateTime_isDateTime(u) && DateTime_isZoned(u), {
  identifier: "DateTimeZonedFromSelf",
  description: "a DateTime.Zoned instance",
  pretty: () => dateTime => dateTime.toString(),
  arbitrary: () => fc => fc.tuple(fc.integer({
    // time zone db supports +/- 1000 years or so
    min: -31536000000000,
    max: 31536000000000
  }), timeZoneArbitrary(fc)).map(([millis, timeZone]) => DateTime_unsafeMakeZoned(millis, {
    timeZone
  })),
  equivalence: () => DateTime_Equivalence
}) {}
/**
 * Defines a schema that attempts to convert a `string` to a `DateTime.Zoned` instance.
 *
 * @category DateTime.Zoned transformations
 * @since 3.10.0
 */
class DateTimeZoned extends /*#__PURE__*/transformOrFail(String$.annotations({
  description: "a string to be decoded into a DateTime.Zoned"
}), DateTimeZonedFromSelf, {
  strict: true,
  decode: (i, _, ast) => esm_Option/* match */.EQ(DateTime_makeZonedFromString(i), {
    onNone: () => fail(new ParseResult_Type(ast, i, `Unable to decode ${JSON.stringify(i)} into a DateTime.Zoned`)),
    onSome: succeed
  }),
  encode: a => succeed(DateTime_formatIsoZoned(a))
}).annotations({
  identifier: "DateTimeZoned"
}) {}
const OptionNoneEncoded = /*#__PURE__*/Schema_Struct({
  _tag: Schema_Literal("None")
}).annotations({
  description: "NoneEncoded"
});
const optionSomeEncoded = value => Schema_Struct({
  _tag: Schema_Literal("Some"),
  value
}).annotations({
  description: `SomeEncoded<${Schema_format(value)}>`
});
const optionEncoded = value => Schema_Union(OptionNoneEncoded, optionSomeEncoded(value)).annotations({
  description: `OptionEncoded<${Schema_format(value)}>`
});
const optionDecode = input => input._tag === "None" ? esm_Option/* none */.YP() : esm_Option/* some */.G(input.value);
const optionArbitrary = (value, ctx) => fc => fc.oneof(ctx, fc.record({
  _tag: fc.constant("None")
}), fc.record({
  _tag: fc.constant("Some"),
  value: value(fc)
})).map(optionDecode);
const optionPretty = value => esm_Option/* match */.EQ({
  onNone: () => "none()",
  onSome: a => `some(${value(a)})`
});
const optionParse = decodeUnknown => (u, options, ast) => esm_Option/* isOption */.Kn(u) ? esm_Option/* isNone */.Wi(u) ? succeed(esm_Option/* none */.YP()) : toComposite(decodeUnknown(u.value, options), esm_Option/* some */.G, ast, u) : fail(new ParseResult_Type(ast, u));
/**
 * @category Option transformations
 * @since 3.10.0
 */
const OptionFromSelf = value => {
  return declare([value], {
    decode: value => optionParse(decodeUnknown(value)),
    encode: value => optionParse(encodeUnknown(value))
  }, {
    description: `Option<${Schema_format(value)}>`,
    pretty: optionPretty,
    arbitrary: optionArbitrary,
    equivalence: esm_Option/* getEquivalence */.c5
  });
};
const makeNoneEncoded = {
  _tag: "None"
};
const makeSomeEncoded = value => ({
  _tag: "Some",
  value
});
/**
 * @category Option transformations
 * @since 3.10.0
 */
function Schema_Option(value) {
  const value_ = asSchema(value);
  const out = transform(optionEncoded(value_), OptionFromSelf(typeSchema(value_)), {
    strict: true,
    decode: i => optionDecode(i),
    encode: a => option_.match(a, {
      onNone: () => makeNoneEncoded,
      onSome: makeSomeEncoded
    })
  });
  return out;
}
/**
 * @category Option transformations
 * @since 3.10.0
 */
function OptionFromNullOr(value) {
  return transform(NullOr(value), OptionFromSelf(typeSchema(asSchema(value))), {
    strict: true,
    decode: i => option_.fromNullable(i),
    encode: a => option_.getOrNull(a)
  });
}
/**
 * @category Option transformations
 * @since 3.10.0
 */
function OptionFromNullishOr(value, onNoneEncoding) {
  return transform(NullishOr(value), OptionFromSelf(typeSchema(asSchema(value))), {
    strict: true,
    decode: i => option_.fromNullable(i),
    encode: onNoneEncoding === null ? a => option_.getOrNull(a) : a => option_.getOrUndefined(a)
  });
}
/**
 * @category Option transformations
 * @since 3.10.0
 */
function OptionFromUndefinedOr(value) {
  return transform(UndefinedOr(value), OptionFromSelf(typeSchema(asSchema(value))), {
    strict: true,
    decode: i => option_.fromNullable(i),
    encode: a => option_.getOrUndefined(a)
  });
}
/**
 * Transforms strings into an Option type, effectively filtering out empty or
 * whitespace-only strings by trimming them and checking their length. Returns
 * `none` for invalid inputs and `some` for valid non-empty strings.
 *
 * @example
 * ```ts
 * import { Schema } from "effect"
 *
 * console.log(Schema.decodeSync(Schema.OptionFromNonEmptyTrimmedString)("")) // Option.none()
 * console.log(Schema.decodeSync(Schema.OptionFromNonEmptyTrimmedString)(" a ")) // Option.some("a")
 * console.log(Schema.decodeSync(Schema.OptionFromNonEmptyTrimmedString)("a")) // Option.some("a")
 * ```
 *
 * @category Option transformations
 * @since 3.10.0
 */
class OptionFromNonEmptyTrimmedString extends /*#__PURE__*/transform(String$, /*#__PURE__*/OptionFromSelf(NonEmptyTrimmedString), {
  strict: true,
  decode: i => esm_Option/* filter */.hX(esm_Option/* some */.G(i.trim()), esm_String/* isNonEmpty */.Od),
  encode: a => esm_Option/* getOrElse */.fS(a, () => "")
}) {}
const rightEncoded = right => Schema_Struct({
  _tag: Schema_Literal("Right"),
  right
}).annotations({
  description: `RightEncoded<${Schema_format(right)}>`
});
const leftEncoded = left => Schema_Struct({
  _tag: Schema_Literal("Left"),
  left
}).annotations({
  description: `LeftEncoded<${Schema_format(left)}>`
});
const eitherEncoded = (right, left) => Schema_Union(rightEncoded(right), leftEncoded(left)).annotations({
  description: `EitherEncoded<${Schema_format(left)}, ${Schema_format(right)}>`
});
const eitherDecode = input => input._tag === "Left" ? either_.left(input.left) : either_.right(input.right);
const eitherArbitrary = (right, left) => fc => fc.oneof(fc.record({
  _tag: fc.constant("Left"),
  left: left(fc)
}), fc.record({
  _tag: fc.constant("Right"),
  right: right(fc)
})).map(eitherDecode);
const eitherPretty = (right, left) => either_.match({
  onLeft: e => `left(${left(e)})`,
  onRight: a => `right(${right(a)})`
});
const eitherParse = (parseRight, decodeUnknownLeft) => (u, options, ast) => either_.isEither(u) ? either_.match(u, {
  onLeft: left => toComposite(decodeUnknownLeft(left, options), either_.left, ast, u),
  onRight: right => toComposite(parseRight(right, options), either_.right, ast, u)
}) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Either transformations
 * @since 3.10.0
 */
const EitherFromSelf = ({
  left,
  right
}) => {
  return declare([right, left], {
    decode: (right, left) => eitherParse(ParseResult.decodeUnknown(right), ParseResult.decodeUnknown(left)),
    encode: (right, left) => eitherParse(ParseResult.encodeUnknown(right), ParseResult.encodeUnknown(left))
  }, {
    description: `Either<${Schema_format(right)}, ${Schema_format(left)}>`,
    pretty: eitherPretty,
    arbitrary: eitherArbitrary,
    equivalence: (right, left) => either_.getEquivalence({
      left,
      right
    })
  });
};
const makeLeftEncoded = left => ({
  _tag: "Left",
  left
});
const makeRightEncoded = right => ({
  _tag: "Right",
  right
});
/**
 * @category Either transformations
 * @since 3.10.0
 */
const Schema_Either = ({
  left,
  right
}) => {
  const right_ = asSchema(right);
  const left_ = asSchema(left);
  const out = transform(eitherEncoded(right_, left_), EitherFromSelf({
    left: typeSchema(left_),
    right: typeSchema(right_)
  }), {
    strict: true,
    decode: i => eitherDecode(i),
    encode: a => either_.match(a, {
      onLeft: makeLeftEncoded,
      onRight: makeRightEncoded
    })
  });
  return out;
};
/**
 * @example
 * ```ts
 * import * as Schema from "effect/Schema"
 *
 * // Schema<string | number, Either<string, number>>
 * Schema.EitherFromUnion({ left: Schema.String, right: Schema.Number })
 * ```
 *
 * @category Either transformations
 * @since 3.10.0
 */
const EitherFromUnion = ({
  left,
  right
}) => {
  const right_ = asSchema(right);
  const left_ = asSchema(left);
  const toright = typeSchema(right_);
  const toleft = typeSchema(left_);
  const fromRight = transform(right_, rightEncoded(toright), {
    strict: true,
    decode: i => makeRightEncoded(i),
    encode: a => a.right
  });
  const fromLeft = transform(left_, leftEncoded(toleft), {
    strict: true,
    decode: i => makeLeftEncoded(i),
    encode: a => a.left
  });
  const out = transform(Schema_Union(fromRight, fromLeft), EitherFromSelf({
    left: toleft,
    right: toright
  }), {
    strict: true,
    decode: i => i._tag === "Left" ? either_.left(i.left) : either_.right(i.right),
    encode: a => either_.match(a, {
      onLeft: makeLeftEncoded,
      onRight: makeRightEncoded
    })
  });
  return out;
};
const mapArbitrary = (key, value, ctx) => {
  return fc => {
    const items = fc.array(fc.tuple(key(fc), value(fc)));
    return (ctx.depthIdentifier !== undefined ? fc.oneof(ctx, fc.constant([]), items) : items).map(as => new Map(as));
  };
};
const readonlyMapPretty = (key, value) => map => `new Map([${Array.from(map.entries()).map(([k, v]) => `[${key(k)}, ${value(v)}]`).join(", ")}])`;
const readonlyMapEquivalence = (key, value) => {
  const arrayEquivalence = array_.getEquivalence(Equivalence.make(([ka, va], [kb, vb]) => key(ka, kb) && value(va, vb)));
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a.entries()), Array.from(b.entries())));
};
const readonlyMapParse = decodeUnknown => (u, options, ast) => Predicate.isMap(u) ? toComposite(decodeUnknown(Array.from(u.entries()), options), as => new Map(as), ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
const mapFromSelf_ = (key, value, description) => declare([key, value], {
  decode: (Key, Value) => readonlyMapParse(ParseResult.decodeUnknown(Array$(Tuple(Key, Value)))),
  encode: (Key, Value) => readonlyMapParse(ParseResult.encodeUnknown(Array$(Tuple(Key, Value))))
}, {
  description,
  pretty: readonlyMapPretty,
  arbitrary: mapArbitrary,
  equivalence: readonlyMapEquivalence
});
/**
 * @category ReadonlyMap
 * @since 3.10.0
 */
const ReadonlyMapFromSelf = ({
  key,
  value
}) => mapFromSelf_(key, value, `ReadonlyMap<${Schema_format(key)}, ${Schema_format(value)}>`);
/**
 * @category Map
 * @since 3.10.0
 */
const MapFromSelf = ({
  key,
  value
}) => mapFromSelf_(key, value, `Map<${Schema_format(key)}, ${Schema_format(value)}>`);
/**
 * @category ReadonlyMap transformations
 * @since 3.10.0
 */
function ReadonlyMap({
  key,
  value
}) {
  return transform(Array$(Tuple(key, value)), ReadonlyMapFromSelf({
    key: typeSchema(asSchema(key)),
    value: typeSchema(asSchema(value))
  }), {
    strict: true,
    decode: i => new Map(i),
    encode: a => Array.from(a.entries())
  });
}
/** @ignore */
function Schema_map({
  key,
  value
}) {
  return transform(Array$(Tuple(key, value)), MapFromSelf({
    key: typeSchema(asSchema(key)),
    value: typeSchema(asSchema(value))
  }), {
    strict: true,
    decode: i => new Map(i),
    encode: a => Array.from(a.entries())
  });
}

/**
 * @category ReadonlyMap transformations
 * @since 3.10.0
 */
const ReadonlyMapFromRecord = ({
  key,
  value
}) => transform(Record({
  key: encodedBoundSchema(key),
  value
}).annotations({
  description: "a record to be decoded into a ReadonlyMap"
}), ReadonlyMapFromSelf({
  key,
  value: typeSchema(value)
}), {
  strict: true,
  decode: i => new Map(Object.entries(i)),
  encode: a => Object.fromEntries(a)
});
/**
 * @category Map transformations
 * @since 3.10.0
 */
const MapFromRecord = ({
  key,
  value
}) => transform(Record({
  key: encodedBoundSchema(key),
  value
}).annotations({
  description: "a record to be decoded into a Map"
}), MapFromSelf({
  key,
  value: typeSchema(value)
}), {
  strict: true,
  decode: i => new Map(Object.entries(i)),
  encode: a => Object.fromEntries(a)
});
const setArbitrary = (item, ctx) => fc => {
  const items = fc.array(item(fc));
  return (ctx.depthIdentifier !== undefined ? fc.oneof(ctx, fc.constant([]), items) : items).map(as => new Set(as));
};
const readonlySetPretty = item => set => `new Set([${Array.from(set.values()).map(a => item(a)).join(", ")}])`;
const readonlySetEquivalence = item => {
  const arrayEquivalence = array_.getEquivalence(item);
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a.values()), Array.from(b.values())));
};
const readonlySetParse = decodeUnknown => (u, options, ast) => Predicate.isSet(u) ? toComposite(decodeUnknown(Array.from(u.values()), options), as => new Set(as), ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
const setFromSelf_ = (value, description) => declare([value], {
  decode: item => readonlySetParse(ParseResult.decodeUnknown(Array$(item))),
  encode: item => readonlySetParse(ParseResult.encodeUnknown(Array$(item)))
}, {
  description,
  pretty: readonlySetPretty,
  arbitrary: setArbitrary,
  equivalence: readonlySetEquivalence
});
/**
 * @category ReadonlySet
 * @since 3.10.0
 */
const ReadonlySetFromSelf = value => setFromSelf_(value, `ReadonlySet<${Schema_format(value)}>`);
/**
 * @category Set
 * @since 3.10.0
 */
const SetFromSelf = value => setFromSelf_(value, `Set<${Schema_format(value)}>`);
/**
 * @category ReadonlySet transformations
 * @since 3.10.0
 */
function ReadonlySet(value) {
  return transform(Array$(value), ReadonlySetFromSelf(typeSchema(asSchema(value))), {
    strict: true,
    decode: i => new Set(i),
    encode: a => Array.from(a)
  });
}
/** @ignore */
function set(value) {
  return transform(Array$(value), SetFromSelf(typeSchema(asSchema(value))), {
    strict: true,
    decode: i => new Set(i),
    encode: a => Array.from(a)
  });
}

const bigDecimalPretty = () => val => `BigDecimal(${BigDecimal/* format */.WU(BigDecimal/* normalize */.Fv(val))})`;
const bigDecimalArbitrary = () => fc => fc.tuple(fc.bigInt(), fc.integer({
  min: 0,
  max: 18
})).map(([value, scale]) => BigDecimal/* make */.Sy(value, scale));
/**
 * @category BigDecimal constructors
 * @since 3.10.0
 */
class BigDecimalFromSelf extends /*#__PURE__*/declare(BigDecimal/* isBigDecimal */.Hv, {
  identifier: "BigDecimalFromSelf",
  pretty: bigDecimalPretty,
  arbitrary: bigDecimalArbitrary,
  equivalence: () => BigDecimal/* Equivalence */.CZ
}) {}
/**
 * @category BigDecimal transformations
 * @since 3.10.0
 */
class Schema_BigDecimal extends /*#__PURE__*/transformOrFail(String$.annotations({
  description: "a string to be decoded into a BigDecimal"
}), BigDecimalFromSelf, {
  strict: true,
  decode: (i, _, ast) => BigDecimal/* fromString */.mL(i).pipe(esm_Option/* match */.EQ({
    onNone: () => fail(new ParseResult_Type(ast, i, `Unable to decode ${JSON.stringify(i)} into a BigDecimal`)),
    onSome: val => succeed(BigDecimal/* normalize */.Fv(val))
  })),
  encode: a => succeed(BigDecimal/* format */.WU(BigDecimal/* normalize */.Fv(a)))
}).annotations({
  identifier: "BigDecimal"
}) {}
/**
 * A schema that transforms a `number` into a `BigDecimal`.
 * When encoding, this Schema will produce incorrect results if the BigDecimal exceeds the 64-bit range of a number.
 *
 * @category BigDecimal transformations
 * @since 3.10.0
 */
class BigDecimalFromNumber extends /*#__PURE__*/transform(Number$.annotations({
  description: "a number to be decoded into a BigDecimal"
}), BigDecimalFromSelf, {
  strict: true,
  decode: i => BigDecimal/* unsafeFromNumber */.Ow(i),
  encode: a => BigDecimal/* unsafeToNumber */.mn(a)
}).annotations({
  identifier: "BigDecimalFromNumber"
}) {}
/**
 * @category schema id
 * @since 3.10.0
 */
const GreaterThanBigDecimalSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/GreaterThanBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 3.10.0
 */
const greaterThanBigDecimal = (min, annotations) => self => {
  const formatted = bigDecimal_.format(min);
  return self.pipe(filter(a => bigDecimal_.greaterThan(a, min), {
    schemaId: GreaterThanBigDecimalSchemaId,
    [GreaterThanBigDecimalSchemaId]: {
      min
    },
    title: `greaterThanBigDecimal(${formatted})`,
    description: `a BigDecimal greater than ${formatted}`,
    ...annotations
  }));
};
/**
 * @category schema id
 * @since 3.10.0
 */
const GreaterThanOrEqualToBigDecimalSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/schema/GreaterThanOrEqualToBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 3.10.0
 */
const greaterThanOrEqualToBigDecimal = (min, annotations) => self => {
  const formatted = bigDecimal_.format(min);
  return self.pipe(filter(a => bigDecimal_.greaterThanOrEqualTo(a, min), {
    schemaId: GreaterThanOrEqualToBigDecimalSchemaId,
    [GreaterThanOrEqualToBigDecimalSchemaId]: {
      min
    },
    title: `greaterThanOrEqualToBigDecimal(${formatted})`,
    description: `a BigDecimal greater than or equal to ${formatted}`,
    ...annotations
  }));
};
/**
 * @category schema id
 * @since 3.10.0
 */
const LessThanBigDecimalSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/LessThanBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 3.10.0
 */
const lessThanBigDecimal = (max, annotations) => self => {
  const formatted = bigDecimal_.format(max);
  return self.pipe(filter(a => bigDecimal_.lessThan(a, max), {
    schemaId: LessThanBigDecimalSchemaId,
    [LessThanBigDecimalSchemaId]: {
      max
    },
    title: `lessThanBigDecimal(${formatted})`,
    description: `a BigDecimal less than ${formatted}`,
    ...annotations
  }));
};
/**
 * @category schema id
 * @since 3.10.0
 */
const LessThanOrEqualToBigDecimalSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/schema/LessThanOrEqualToBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 3.10.0
 */
const lessThanOrEqualToBigDecimal = (max, annotations) => self => {
  const formatted = bigDecimal_.format(max);
  return self.pipe(filter(a => bigDecimal_.lessThanOrEqualTo(a, max), {
    schemaId: LessThanOrEqualToBigDecimalSchemaId,
    [LessThanOrEqualToBigDecimalSchemaId]: {
      max
    },
    title: `lessThanOrEqualToBigDecimal(${formatted})`,
    description: `a BigDecimal less than or equal to ${formatted}`,
    ...annotations
  }));
};
/**
 * @category schema id
 * @since 3.10.0
 */
const PositiveBigDecimalSchemaId = /*#__PURE__*/Symbol.for("effect/schema/PositiveBigDecimal");
/**
 * @category BigDecimal filters
 * @since 3.10.0
 */
const positiveBigDecimal = annotations => self => self.pipe(filter(a => BigDecimal/* isPositive */.xP(a), {
  schemaId: PositiveBigDecimalSchemaId,
  title: "positiveBigDecimal",
  description: `a positive BigDecimal`,
  ...annotations
}));
/**
 * @category BigDecimal constructors
 * @since 3.10.0
 */
const PositiveBigDecimalFromSelf = /*#__PURE__*/BigDecimalFromSelf.pipe( /*#__PURE__*/positiveBigDecimal({
  identifier: "PositiveBigDecimalFromSelf"
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const NonNegativeBigDecimalSchemaId = /*#__PURE__*/Symbol.for("effect/schema/NonNegativeBigDecimal");
/**
 * @category BigDecimal filters
 * @since 3.10.0
 */
const nonNegativeBigDecimal = annotations => self => self.pipe(filter(a => a.value >= 0n, {
  schemaId: NonNegativeBigDecimalSchemaId,
  title: "nonNegativeBigDecimal",
  description: `a non-negative BigDecimal`,
  ...annotations
}));
/**
 * @category BigDecimal constructors
 * @since 3.10.0
 */
const NonNegativeBigDecimalFromSelf = /*#__PURE__*/BigDecimalFromSelf.pipe( /*#__PURE__*/nonNegativeBigDecimal({
  identifier: "NonNegativeBigDecimalFromSelf"
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const NegativeBigDecimalSchemaId = /*#__PURE__*/Symbol.for("effect/schema/NegativeBigDecimal");
/**
 * @category BigDecimal filters
 * @since 3.10.0
 */
const negativeBigDecimal = annotations => self => self.pipe(filter(a => BigDecimal/* isNegative */.nM(a), {
  schemaId: NegativeBigDecimalSchemaId,
  title: "negativeBigDecimal",
  description: `a negative BigDecimal`,
  ...annotations
}));
/**
 * @category BigDecimal constructors
 * @since 3.10.0
 */
const NegativeBigDecimalFromSelf = /*#__PURE__*/BigDecimalFromSelf.pipe( /*#__PURE__*/negativeBigDecimal({
  identifier: "NegativeBigDecimalFromSelf"
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const NonPositiveBigDecimalSchemaId = /*#__PURE__*/Symbol.for("effect/schema/NonPositiveBigDecimal");
/**
 * @category BigDecimal filters
 * @since 3.10.0
 */
const nonPositiveBigDecimal = annotations => self => self.pipe(filter(a => a.value <= 0n, {
  schemaId: NonPositiveBigDecimalSchemaId,
  title: "nonPositiveBigDecimal",
  description: `a non-positive BigDecimal`,
  ...annotations
}));
/**
 * @category BigDecimal constructors
 * @since 3.10.0
 */
const NonPositiveBigDecimalFromSelf = /*#__PURE__*/BigDecimalFromSelf.pipe( /*#__PURE__*/nonPositiveBigDecimal({
  identifier: "NonPositiveBigDecimalFromSelf"
}));
/**
 * @category schema id
 * @since 3.10.0
 */
const BetweenBigDecimalSchemaId = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/SchemaId/BetweenBigDecimal")));
/**
 * @category BigDecimal filters
 * @since 3.10.0
 */
const betweenBigDecimal = (minimum, maximum, annotations) => self => {
  const formattedMinimum = bigDecimal_.format(minimum);
  const formattedMaximum = bigDecimal_.format(maximum);
  return self.pipe(filter(a => bigDecimal_.between(a, {
    minimum,
    maximum
  }), {
    schemaId: BetweenBigDecimalSchemaId,
    [BetweenBigDecimalSchemaId]: {
      maximum,
      minimum
    },
    title: `betweenBigDecimal(${formattedMinimum}, ${formattedMaximum})`,
    description: `a BigDecimal between ${formattedMinimum} and ${formattedMaximum}`,
    ...annotations
  }));
};
/**
 * Clamps a `BigDecimal` between a minimum and a maximum value.
 *
 * @category BigDecimal transformations
 * @since 3.10.0
 */
const clampBigDecimal = (minimum, maximum) => self => transform(self, self.pipe(typeSchema, betweenBigDecimal(minimum, maximum)), {
  strict: false,
  decode: i => bigDecimal_.clamp(i, {
    minimum,
    maximum
  }),
  encode: identity
});
const chunkArbitrary = (item, ctx) => fc => {
  const items = fc.array(item(fc));
  return (ctx.depthIdentifier !== undefined ? fc.oneof(ctx, fc.constant([]), items) : items).map(chunk_.fromIterable);
};
const chunkPretty = item => c => `Chunk(${chunk_.toReadonlyArray(c).map(item).join(", ")})`;
const chunkParse = decodeUnknown => (u, options, ast) => chunk_.isChunk(u) ? chunk_.isEmpty(u) ? ParseResult.succeed(chunk_.empty()) : toComposite(decodeUnknown(chunk_.toReadonlyArray(u), options), chunk_.fromIterable, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Chunk
 * @since 3.10.0
 */
const ChunkFromSelf = value => {
  return declare([value], {
    decode: item => chunkParse(ParseResult.decodeUnknown(Array$(item))),
    encode: item => chunkParse(ParseResult.encodeUnknown(Array$(item)))
  }, {
    description: `Chunk<${Schema_format(value)}>`,
    pretty: chunkPretty,
    arbitrary: chunkArbitrary,
    equivalence: chunk_.getEquivalence
  });
};
/**
 * @category Chunk transformations
 * @since 3.10.0
 */
function Chunk(value) {
  return transform(Array$(value), ChunkFromSelf(typeSchema(asSchema(value))), {
    strict: true,
    decode: i => i.length === 0 ? chunk_.empty() : chunk_.fromIterable(i),
    encode: a => chunk_.toReadonlyArray(a)
  });
}
const nonEmptyChunkArbitrary = item => fc => fastCheck_.array(item(fc), {
  minLength: 1
}).map(as => chunk_.unsafeFromNonEmptyArray(as));
const nonEmptyChunkPretty = item => c => `NonEmptyChunk(${chunk_.toReadonlyArray(c).map(item).join(", ")})`;
const nonEmptyChunkParse = decodeUnknown => (u, options, ast) => chunk_.isChunk(u) && chunk_.isNonEmpty(u) ? toComposite(decodeUnknown(chunk_.toReadonlyArray(u), options), chunk_.unsafeFromNonEmptyArray, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Chunk
 * @since 3.10.0
 */
const NonEmptyChunkFromSelf = value => {
  return declare([value], {
    decode: item => nonEmptyChunkParse(ParseResult.decodeUnknown(NonEmptyArray(item))),
    encode: item => nonEmptyChunkParse(ParseResult.encodeUnknown(NonEmptyArray(item)))
  }, {
    description: `NonEmptyChunk<${Schema_format(value)}>`,
    pretty: nonEmptyChunkPretty,
    arbitrary: nonEmptyChunkArbitrary,
    equivalence: chunk_.getEquivalence
  });
};
/**
 * @category Chunk transformations
 * @since 3.10.0
 */
function NonEmptyChunk(value) {
  return transform(NonEmptyArray(value), NonEmptyChunkFromSelf(typeSchema(asSchema(value))), {
    strict: true,
    decode: i => chunk_.unsafeFromNonEmptyArray(i),
    encode: a => chunk_.toReadonlyArray(a)
  });
}
const decodeData = a => Array.isArray(a) ? data_.array(a) : data_.struct(a);
const dataArbitrary = item => fc => item(fc).map(decodeData);
const dataPretty = item => d => `Data(${item(d)})`;
const dataParse = decodeUnknown => (u, options, ast) => Equal.isEqual(u) ? toComposite(decodeUnknown(u, options), decodeData, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * Type and Encoded must extend `Readonly<Record<string, any>> |
 * ReadonlyArray<any>` to be compatible with this API.
 *
 * @category Data transformations
 * @since 3.10.0
 */
const DataFromSelf = value => {
  return declare([value], {
    decode: item => dataParse(ParseResult.decodeUnknown(item)),
    encode: item => dataParse(ParseResult.encodeUnknown(item))
  }, {
    description: `Data<${Schema_format(value)}>`,
    pretty: dataPretty,
    arbitrary: dataArbitrary
  });
};
/**
 * Type and Encoded must extend `Readonly<Record<string, any>> |
 * ReadonlyArray<any>` to be compatible with this API.
 *
 * @category Data transformations
 * @since 3.10.0
 */
const Schema_Data = value => {
  return transform(value, DataFromSelf(typeSchema(value)), {
    strict: false,
    decode: i => decodeData(i),
    encode: a => Array.isArray(a) ? Array.from(a) : Object.assign({}, a)
  });
};
const isField = u => isSchema(u) || isPropertySignature(u);
const isFields = fields => util_.ownKeys(fields).every(key => isField(fields[key]));
const getFields = hasFields => "fields" in hasFields ? hasFields.fields : getFields(hasFields[RefineSchemaId]);
const getSchemaFromFieldsOr = fieldsOr => isFields(fieldsOr) ? Schema_Struct(fieldsOr) : isSchema(fieldsOr) ? fieldsOr : Schema_Struct(getFields(fieldsOr));
const getFieldsFromFieldsOr = fieldsOr => isFields(fieldsOr) ? fieldsOr : getFields(fieldsOr);
/**
 * @example
 * ```ts
 * import { Schema } from "effect"
 *
 * class MyClass extends Schema.Class<MyClass>("MyClass")({
 *  someField: Schema.String
 * }) {
 *  someMethod() {
 *    return this.someField + "bar"
 *  }
 * }
 * ```
 *
 * @category classes
 * @since 3.10.0
 */
const Class = identifier => (fieldsOr, annotations) => makeClass({
  kind: "Class",
  identifier,
  schema: getSchemaFromFieldsOr(fieldsOr),
  fields: getFieldsFromFieldsOr(fieldsOr),
  Base: data_.Class,
  annotations
});
/** @internal */
const getClassTag = tag => withConstructorDefault(propertySignature(Schema_Literal(tag)), () => tag);
/**
 * @example
 * ```ts
 * import { Schema } from "effect"
 *
 * class MyClass extends Schema.TaggedClass<MyClass>("MyClass")("MyClass", {
 *  a: Schema.String
 * }) {}
 * ```
 *
 * @category classes
 * @since 3.10.0
 */
const TaggedClass = identifier => (tag, fieldsOr, annotations) => {
  const fields = getFieldsFromFieldsOr(fieldsOr);
  const schema = getSchemaFromFieldsOr(fieldsOr);
  const newFields = {
    _tag: getClassTag(tag)
  };
  const taggedFields = extendFields(newFields, fields);
  return class TaggedClass extends makeClass({
    kind: "TaggedClass",
    identifier: identifier ?? tag,
    schema: extend(schema, Schema_Struct(newFields)),
    fields: taggedFields,
    Base: data_.Class,
    annotations
  }) {
    static _tag = tag;
  };
};
/**
 * @example
 * ```ts
 * import { Schema } from "effect"
 *
 * class MyError extends Schema.TaggedError<MyError>("MyError")(
 *   "MyError",
 *   {
 *     module: Schema.String,
 *     method: Schema.String,
 *     description: Schema.String
 *   }
 * ) {
 *   get message(): string {
 *     return `${this.module}.${this.method}: ${this.description}`
 *   }
 * }
 * ```
 * @category classes
 * @since 3.10.0
 */
const TaggedError = identifier => (tag, fieldsOr, annotations) => {
  class Base extends data_.Error {}
  ;
  Base.prototype.name = tag;
  const fields = getFieldsFromFieldsOr(fieldsOr);
  const schema = getSchemaFromFieldsOr(fieldsOr);
  const newFields = {
    _tag: getClassTag(tag)
  };
  const taggedFields = extendFields(newFields, fields);
  return class TaggedErrorClass extends makeClass({
    kind: "TaggedError",
    identifier: identifier ?? tag,
    schema: extend(schema, Schema_Struct(newFields)),
    fields: taggedFields,
    Base,
    annotations,
    disableToString: true
  }) {
    static _tag = tag;
    get message() {
      return `{ ${util_.ownKeys(fields).map(p => `${util_.formatPropertyKey(p)}: ${util_.formatUnknown(this[p])}`).join(", ")} }`;
    }
  };
};
const extendFields = (a, b) => {
  const out = {
    ...a
  };
  for (const key of util_.ownKeys(b)) {
    if (key in a) {
      throw new Error(errors_.getASTDuplicatePropertySignatureErrorMessage(key));
    }
    out[key] = b[key];
  }
  return out;
};
function getDisableValidationMakeOption(options) {
  return esm_Predicate/* isBoolean */.jn(options) ? options : options?.disableValidation ?? false;
}
const astCache = /*#__PURE__*/(/* unused pure expression or super */ null && (globalValue("effect/Schema/astCache", () => new WeakMap())));
const getClassAnnotations = annotations => {
  if (annotations === undefined) {
    return [];
  } else if (Array.isArray(annotations)) {
    return annotations;
  } else {
    return [annotations];
  }
};
const makeClass = ({
  Base,
  annotations,
  disableToString,
  fields,
  identifier,
  kind,
  schema
}) => {
  const classSymbol = Symbol.for(`effect/Schema/${kind}/${identifier}`);
  const [typeAnnotations, transformationAnnotations, encodedAnnotations] = getClassAnnotations(annotations);
  const typeSchema_ = typeSchema(schema);
  const declarationSurrogate = typeSchema_.annotations({
    identifier,
    ...typeAnnotations
  });
  const typeSide = typeSchema_.annotations({
    [AST.AutoTitleAnnotationId]: `${identifier} (Type side)`,
    ...typeAnnotations
  });
  const constructorSchema = schema.annotations({
    [AST.AutoTitleAnnotationId]: `${identifier} (Constructor)`,
    ...typeAnnotations
  });
  const encodedSide = schema.annotations({
    [AST.AutoTitleAnnotationId]: `${identifier} (Encoded side)`,
    ...encodedAnnotations
  });
  const transformationSurrogate = schema.annotations({
    [AST.JSONIdentifierAnnotationId]: identifier,
    ...encodedAnnotations,
    ...typeAnnotations,
    ...transformationAnnotations
  });
  const fallbackInstanceOf = u => Predicate.hasProperty(u, classSymbol) && ParseResult.is(typeSide)(u);
  const klass = class extends Base {
    constructor(props = {}, options = false) {
      props = {
        ...props
      };
      if (kind !== "Class") {
        delete props["_tag"];
      }
      props = lazilyMergeDefaults(fields, props);
      if (!getDisableValidationMakeOption(options)) {
        props = ParseResult.validateSync(constructorSchema)(props);
      }
      super(props, true);
    }
    // ----------------
    // Schema interface
    // ----------------
    static [Schema_TypeId] = variance;
    static get ast() {
      let out = astCache.get(this);
      if (out) {
        return out;
      }
      const declaration = declare([schema], {
        decode: () => (input, _, ast) => input instanceof this || fallbackInstanceOf(input) ? ParseResult.succeed(input) : ParseResult.fail(new ParseResult.Type(ast, input)),
        encode: () => (input, options) => input instanceof this ? ParseResult.succeed(input) : ParseResult.map(ParseResult.encodeUnknown(typeSide)(input, options), props => new this(props, true))
      }, {
        identifier,
        pretty: pretty => self => `${identifier}(${pretty(self)})`,
        // @ts-expect-error
        arbitrary: arb => fc => arb(fc).map(props => new this(props)),
        equivalence: identity,
        [AST.SurrogateAnnotationId]: declarationSurrogate.ast,
        ...typeAnnotations
      });
      out = transform(encodedSide, declaration, {
        strict: true,
        decode: i => new this(i, true),
        encode: identity
      }).annotations({
        [AST.SurrogateAnnotationId]: transformationSurrogate.ast,
        ...transformationAnnotations
      }).ast;
      astCache.set(this, out);
      return out;
    }
    static pipe() {
      return pipeArguments(this, arguments);
    }
    static annotations(annotations) {
      return Schema_make(this.ast).annotations(annotations);
    }
    static toString() {
      return `(${String(encodedSide)} <-> ${identifier})`;
    }
    // ----------------
    // Class interface
    // ----------------
    static make(...args) {
      return new this(...args);
    }
    static fields = {
      ...fields
    };
    static identifier = identifier;
    static extend(identifier) {
      return (newFieldsOr, annotations) => {
        const newFields = getFieldsFromFieldsOr(newFieldsOr);
        const newSchema = getSchemaFromFieldsOr(newFieldsOr);
        const extendedFields = extendFields(fields, newFields);
        return makeClass({
          kind,
          identifier,
          schema: extend(schema, newSchema),
          fields: extendedFields,
          Base: this,
          annotations
        });
      };
    }
    static transformOrFail(identifier) {
      return (newFieldsOr, options, annotations) => {
        const transformedFields = extendFields(fields, newFieldsOr);
        return makeClass({
          kind,
          identifier,
          schema: transformOrFail(schema, typeSchema(Schema_Struct(transformedFields)), options),
          fields: transformedFields,
          Base: this,
          annotations
        });
      };
    }
    static transformOrFailFrom(identifier) {
      return (newFields, options, annotations) => {
        const transformedFields = extendFields(fields, newFields);
        return makeClass({
          kind,
          identifier,
          schema: transformOrFail(encodedSchema(schema), Schema_Struct(transformedFields), options),
          fields: transformedFields,
          Base: this,
          annotations
        });
      };
    }
    // ----------------
    // other
    // ----------------
    get [classSymbol]() {
      return classSymbol;
    }
  };
  if (disableToString !== true) {
    Object.defineProperty(klass.prototype, "toString", {
      value() {
        return `${identifier}({ ${util_.ownKeys(fields).map(p => `${util_.formatPropertyKey(p)}: ${util_.formatUnknown(this[p])}`).join(", ")} })`;
      },
      configurable: true,
      writable: true
    });
  }
  return klass;
};
const FiberIdNoneEncoded = /*#__PURE__*/Schema_Struct({
  _tag: Schema_Literal("None")
}).annotations({
  identifier: "FiberIdNoneEncoded"
});
const FiberIdRuntimeEncoded = /*#__PURE__*/Schema_Struct({
  _tag: Schema_Literal("Runtime"),
  id: Int,
  startTimeMillis: Int
}).annotations({
  identifier: "FiberIdRuntimeEncoded"
});
const FiberIdCompositeEncoded = /*#__PURE__*/Schema_Struct({
  _tag: Schema_Literal("Composite"),
  left: suspend(() => FiberIdEncoded),
  right: suspend(() => FiberIdEncoded)
}).annotations({
  identifier: "FiberIdCompositeEncoded"
});
const FiberIdEncoded = /*#__PURE__*/Schema_Union(FiberIdNoneEncoded, FiberIdRuntimeEncoded, FiberIdCompositeEncoded).annotations({
  identifier: "FiberIdEncoded"
});
const fiberIdArbitrary = fc => fc.letrec(tie => ({
  None: fc.record({
    _tag: fc.constant("None")
  }),
  Runtime: fc.record({
    _tag: fc.constant("Runtime"),
    id: fc.integer(),
    startTimeMillis: fc.integer()
  }),
  Composite: fc.record({
    _tag: fc.constant("Composite"),
    left: tie("FiberId"),
    right: tie("FiberId")
  }),
  FiberId: fc.oneof(tie("None"), tie("Runtime"), tie("Composite"))
})).FiberId.map(fiberIdDecode);
const fiberIdPretty = fiberId => {
  switch (fiberId._tag) {
    case "None":
      return "FiberId.none";
    case "Runtime":
      return `FiberId.runtime(${fiberId.id}, ${fiberId.startTimeMillis})`;
    case "Composite":
      return `FiberId.composite(${fiberIdPretty(fiberId.right)}, ${fiberIdPretty(fiberId.left)})`;
  }
};
/**
 * @category FiberId constructors
 * @since 3.10.0
 */
class FiberIdFromSelf extends /*#__PURE__*/declare(FiberId/* isFiberId */.ez, {
  identifier: "FiberIdFromSelf",
  pretty: () => fiberIdPretty,
  arbitrary: () => fiberIdArbitrary
}) {}
const fiberIdDecode = input => {
  switch (input._tag) {
    case "None":
      return FiberId/* none */.YP;
    case "Runtime":
      return FiberId/* runtime */.GZ(input.id, input.startTimeMillis);
    case "Composite":
      return FiberId/* composite */.h$(fiberIdDecode(input.left), fiberIdDecode(input.right));
  }
};
const fiberIdEncode = input => {
  switch (input._tag) {
    case "None":
      return {
        _tag: "None"
      };
    case "Runtime":
      return {
        _tag: "Runtime",
        id: input.id,
        startTimeMillis: input.startTimeMillis
      };
    case "Composite":
      return {
        _tag: "Composite",
        left: fiberIdEncode(input.left),
        right: fiberIdEncode(input.right)
      };
  }
};
/**
 * @category FiberId transformations
 * @since 3.10.0
 */
class Schema_FiberId extends /*#__PURE__*/transform(FiberIdEncoded, FiberIdFromSelf, {
  strict: true,
  decode: i => fiberIdDecode(i),
  encode: a => fiberIdEncode(a)
}).annotations({
  identifier: "FiberId"
}) {}
const causeDieEncoded = defect => Schema_Struct({
  _tag: Schema_Literal("Die"),
  defect
});
const CauseEmptyEncoded = /*#__PURE__*/Schema_Struct({
  _tag: /*#__PURE__*/Schema_Literal("Empty")
});
const causeFailEncoded = error => Schema_Struct({
  _tag: Schema_Literal("Fail"),
  error
});
const CauseInterruptEncoded = /*#__PURE__*/Schema_Struct({
  _tag: /*#__PURE__*/Schema_Literal("Interrupt"),
  fiberId: FiberIdEncoded
});
let causeEncodedId = 0;
const causeEncoded = (error, defect) => {
  const error_ = asSchema(error);
  const defect_ = asSchema(defect);
  const suspended = suspend(() => out);
  const out = Schema_Union(CauseEmptyEncoded, causeFailEncoded(error_), causeDieEncoded(defect_), CauseInterruptEncoded, Schema_Struct({
    _tag: Schema_Literal("Sequential"),
    left: suspended,
    right: suspended
  }), Schema_Struct({
    _tag: Schema_Literal("Parallel"),
    left: suspended,
    right: suspended
  })).annotations({
    title: `CauseEncoded<${Schema_format(error)}>`,
    [AST.JSONIdentifierAnnotationId]: `CauseEncoded${causeEncodedId++}`
  });
  return out;
};
const causeArbitrary = (error, defect) => fc => fc.letrec(tie => ({
  Empty: fc.record({
    _tag: fc.constant("Empty")
  }),
  Fail: fc.record({
    _tag: fc.constant("Fail"),
    error: error(fc)
  }),
  Die: fc.record({
    _tag: fc.constant("Die"),
    defect: defect(fc)
  }),
  Interrupt: fc.record({
    _tag: fc.constant("Interrupt"),
    fiberId: fiberIdArbitrary(fc)
  }),
  Sequential: fc.record({
    _tag: fc.constant("Sequential"),
    left: tie("Cause"),
    right: tie("Cause")
  }),
  Parallel: fc.record({
    _tag: fc.constant("Parallel"),
    left: tie("Cause"),
    right: tie("Cause")
  }),
  Cause: fc.oneof(tie("Empty"), tie("Fail"), tie("Die"), tie("Interrupt"), tie("Sequential"), tie("Parallel"))
})).Cause.map(causeDecode);
const causePretty = error => cause => {
  const f = cause => {
    switch (cause._tag) {
      case "Empty":
        return "Cause.empty";
      case "Fail":
        return `Cause.fail(${error(cause.error)})`;
      case "Die":
        return `Cause.die(${cause_.pretty(cause)})`;
      case "Interrupt":
        return `Cause.interrupt(${fiberIdPretty(cause.fiberId)})`;
      case "Sequential":
        return `Cause.sequential(${f(cause.left)}, ${f(cause.right)})`;
      case "Parallel":
        return `Cause.parallel(${f(cause.left)}, ${f(cause.right)})`;
    }
  };
  return f(cause);
};
const causeParse = decodeUnknown => (u, options, ast) => cause_.isCause(u) ? toComposite(decodeUnknown(causeEncode(u), options), causeDecode, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Cause transformations
 * @since 3.10.0
 */
const CauseFromSelf = ({
  defect,
  error
}) => {
  return declare([error, defect], {
    decode: (error, defect) => causeParse(ParseResult.decodeUnknown(causeEncoded(error, defect))),
    encode: (error, defect) => causeParse(ParseResult.encodeUnknown(causeEncoded(error, defect)))
  }, {
    title: `Cause<${error.ast}>`,
    pretty: causePretty,
    arbitrary: causeArbitrary
  });
};
function causeDecode(cause) {
  switch (cause._tag) {
    case "Empty":
      return cause_.empty;
    case "Fail":
      return cause_.fail(cause.error);
    case "Die":
      return cause_.die(cause.defect);
    case "Interrupt":
      return cause_.interrupt(fiberIdDecode(cause.fiberId));
    case "Sequential":
      return cause_.sequential(causeDecode(cause.left), causeDecode(cause.right));
    case "Parallel":
      return cause_.parallel(causeDecode(cause.left), causeDecode(cause.right));
  }
}
function causeEncode(cause) {
  switch (cause._tag) {
    case "Empty":
      return {
        _tag: "Empty"
      };
    case "Fail":
      return {
        _tag: "Fail",
        error: cause.error
      };
    case "Die":
      return {
        _tag: "Die",
        defect: cause.defect
      };
    case "Interrupt":
      return {
        _tag: "Interrupt",
        fiberId: cause.fiberId
      };
    case "Sequential":
      return {
        _tag: "Sequential",
        left: causeEncode(cause.left),
        right: causeEncode(cause.right)
      };
    case "Parallel":
      return {
        _tag: "Parallel",
        left: causeEncode(cause.left),
        right: causeEncode(cause.right)
      };
  }
}
/**
 * @category Cause transformations
 * @since 3.10.0
 */
const Schema_Cause = ({
  defect,
  error
}) => {
  const error_ = asSchema(error);
  const defect_ = asSchema(defect);
  const out = transform(causeEncoded(error_, defect_), CauseFromSelf({
    error: typeSchema(error_),
    defect: typeSchema(defect_)
  }), {
    strict: false,
    decode: i => causeDecode(i),
    encode: a => causeEncode(a)
  });
  return out;
};
/**
 * Defines a schema for handling JavaScript errors (`Error` instances) and other types of defects.
 * It decodes objects into Error instances if they match the expected structure (i.e., have a `message` and optionally a `name` and `stack`),
 * or converts other values to their string representations.
 *
 * When encoding, it converts `Error` instances back into plain objects containing only the error's name and message,
 * or other values into their string forms.
 *
 * This is useful for serializing and deserializing errors across network boundaries where error objects do not natively serialize.
 *
 * @category defect
 * @since 3.10.0
 */
class Defect extends /*#__PURE__*/transform(Unknown, Unknown, {
  strict: true,
  decode: i => {
    if (esm_Predicate/* isObject */.Kn(i) && "message" in i && typeof i.message === "string") {
      const err = new Error(i.message, {
        cause: i
      });
      if ("name" in i && typeof i.name === "string") {
        err.name = i.name;
      }
      err.stack = "stack" in i && typeof i.stack === "string" ? i.stack : "";
      return err;
    }
    return String(i);
  },
  encode: a => {
    if (a instanceof Error) {
      return {
        name: a.name,
        message: a.message
        // no stack because of security reasons
      };
    }
    return cause/* prettyErrorMessage */.Z3(a);
  }
}).annotations({
  identifier: "Defect"
}) {}
const exitFailureEncoded = (error, defect) => Schema_Struct({
  _tag: Schema_Literal("Failure"),
  cause: causeEncoded(error, defect)
});
const exitSuccessEncoded = value => Schema_Struct({
  _tag: Schema_Literal("Success"),
  value
});
const exitEncoded = (value, error, defect) => {
  return Schema_Union(exitFailureEncoded(error, defect), exitSuccessEncoded(value)).annotations({
    title: `ExitEncoded<${Schema_format(value)}, ${Schema_format(error)}, ${Schema_format(defect)}>`
  });
};
const exitDecode = input => {
  switch (input._tag) {
    case "Failure":
      return exit_.failCause(causeDecode(input.cause));
    case "Success":
      return exit_.succeed(input.value);
  }
};
const exitArbitrary = (value, error, defect) => fc => fc.oneof(fc.record({
  _tag: fc.constant("Failure"),
  cause: causeArbitrary(error, defect)(fc)
}), fc.record({
  _tag: fc.constant("Success"),
  value: value(fc)
})).map(exitDecode);
const exitPretty = (value, error) => exit => exit._tag === "Failure" ? `Exit.failCause(${causePretty(error)(exit.cause)})` : `Exit.succeed(${value(exit.value)})`;
const exitParse = (decodeUnknownValue, decodeUnknownCause) => (u, options, ast) => exit_.isExit(u) ? exit_.match(u, {
  onFailure: cause => toComposite(decodeUnknownCause(cause, options), exit_.failCause, ast, u),
  onSuccess: value => toComposite(decodeUnknownValue(value, options), exit_.succeed, ast, u)
}) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category Exit transformations
 * @since 3.10.0
 */
const ExitFromSelf = ({
  defect,
  failure,
  success
}) => declare([success, failure, defect], {
  decode: (success, failure, defect) => exitParse(ParseResult.decodeUnknown(success), ParseResult.decodeUnknown(CauseFromSelf({
    error: failure,
    defect
  }))),
  encode: (success, failure, defect) => exitParse(ParseResult.encodeUnknown(success), ParseResult.encodeUnknown(CauseFromSelf({
    error: failure,
    defect
  })))
}, {
  title: `Exit<${success.ast}, ${failure.ast}>`,
  pretty: exitPretty,
  arbitrary: exitArbitrary
});
/**
 * @category Exit transformations
 * @since 3.10.0
 */
const Schema_Exit = ({
  defect,
  failure,
  success
}) => {
  const success_ = asSchema(success);
  const failure_ = asSchema(failure);
  const defect_ = asSchema(defect);
  const out = transform(exitEncoded(success_, failure_, defect_), ExitFromSelf({
    failure: typeSchema(failure_),
    success: typeSchema(success_),
    defect: typeSchema(defect_)
  }), {
    strict: false,
    decode: i => exitDecode(i),
    encode: a => a._tag === "Failure" ? {
      _tag: "Failure",
      cause: a.cause
    } : {
      _tag: "Success",
      value: a.value
    }
  });
  return out;
};
const hashSetArbitrary = (item, ctx) => fc => {
  const items = fc.array(item(fc));
  return (ctx.depthIdentifier !== undefined ? fc.oneof(ctx, fc.constant([]), items) : items).map(hashSet_.fromIterable);
};
const hashSetPretty = item => set => `HashSet(${Array.from(set).map(a => item(a)).join(", ")})`;
const hashSetEquivalence = item => {
  const arrayEquivalence = array_.getEquivalence(item);
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a), Array.from(b)));
};
const hashSetParse = decodeUnknown => (u, options, ast) => hashSet_.isHashSet(u) ? toComposite(decodeUnknown(Array.from(u), options), hashSet_.fromIterable, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category HashSet transformations
 * @since 3.10.0
 */
const HashSetFromSelf = value => {
  return declare([value], {
    decode: item => hashSetParse(ParseResult.decodeUnknown(Array$(item))),
    encode: item => hashSetParse(ParseResult.encodeUnknown(Array$(item)))
  }, {
    description: `HashSet<${Schema_format(value)}>`,
    pretty: hashSetPretty,
    arbitrary: hashSetArbitrary,
    equivalence: hashSetEquivalence
  });
};
/**
 * @category HashSet transformations
 * @since 3.10.0
 */
function HashSet(value) {
  return transform(Array$(value), HashSetFromSelf(typeSchema(asSchema(value))), {
    strict: true,
    decode: i => hashSet_.fromIterable(i),
    encode: a => Array.from(a)
  });
}
const hashMapArbitrary = (key, value, ctx) => fc => {
  const items = fc.array(fc.tuple(key(fc), value(fc)));
  return (ctx.depthIdentifier !== undefined ? fc.oneof(ctx, fc.constant([]), items) : items).map(hashMap_.fromIterable);
};
const hashMapPretty = (key, value) => map => `HashMap([${Array.from(map).map(([k, v]) => `[${key(k)}, ${value(v)}]`).join(", ")}])`;
const hashMapEquivalence = (key, value) => {
  const arrayEquivalence = array_.getEquivalence(Equivalence.make(([ka, va], [kb, vb]) => key(ka, kb) && value(va, vb)));
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a), Array.from(b)));
};
const hashMapParse = decodeUnknown => (u, options, ast) => hashMap_.isHashMap(u) ? toComposite(decodeUnknown(Array.from(u), options), hashMap_.fromIterable, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category HashMap transformations
 * @since 3.10.0
 */
const HashMapFromSelf = ({
  key,
  value
}) => {
  return declare([key, value], {
    decode: (key, value) => hashMapParse(ParseResult.decodeUnknown(Array$(Tuple(key, value)))),
    encode: (key, value) => hashMapParse(ParseResult.encodeUnknown(Array$(Tuple(key, value))))
  }, {
    description: `HashMap<${Schema_format(key)}, ${Schema_format(value)}>`,
    pretty: hashMapPretty,
    arbitrary: hashMapArbitrary,
    equivalence: hashMapEquivalence
  });
};
/**
 * @category HashMap transformations
 * @since 3.10.0
 */
const HashMap = ({
  key,
  value
}) => {
  return transform(Array$(Tuple(key, value)), HashMapFromSelf({
    key: typeSchema(asSchema(key)),
    value: typeSchema(asSchema(value))
  }), {
    strict: true,
    decode: i => hashMap_.fromIterable(i),
    encode: a => Array.from(a)
  });
};
const listArbitrary = (item, ctx) => fc => {
  const items = fc.array(item(fc));
  return (ctx.depthIdentifier !== undefined ? fc.oneof(ctx, fc.constant([]), items) : items).map(list_.fromIterable);
};
const listPretty = item => set => `List(${Array.from(set).map(a => item(a)).join(", ")})`;
const listEquivalence = item => {
  const arrayEquivalence = array_.getEquivalence(item);
  return Equivalence.make((a, b) => arrayEquivalence(Array.from(a), Array.from(b)));
};
const listParse = decodeUnknown => (u, options, ast) => list_.isList(u) ? toComposite(decodeUnknown(Array.from(u), options), list_.fromIterable, ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category List transformations
 * @since 3.10.0
 */
const ListFromSelf = value => {
  return declare([value], {
    decode: item => listParse(ParseResult.decodeUnknown(Array$(item))),
    encode: item => listParse(ParseResult.encodeUnknown(Array$(item)))
  }, {
    description: `List<${Schema_format(value)}>`,
    pretty: listPretty,
    arbitrary: listArbitrary,
    equivalence: listEquivalence
  });
};
/**
 * @category List transformations
 * @since 3.10.0
 */
function List(value) {
  return transform(Array$(value), ListFromSelf(typeSchema(asSchema(value))), {
    strict: true,
    decode: i => list_.fromIterable(i),
    encode: a => Array.from(a)
  });
}
const sortedSetArbitrary = (item, ord, ctx) => fc => {
  const items = fc.array(item(fc));
  return (ctx.depthIdentifier !== undefined ? fc.oneof(ctx, fc.constant([]), items) : items).map(as => sortedSet_.fromIterable(as, ord));
};
const sortedSetPretty = item => set => `new SortedSet([${Array.from(sortedSet_.values(set)).map(a => item(a)).join(", ")}])`;
const sortedSetParse = (decodeUnknown, ord) => (u, options, ast) => sortedSet_.isSortedSet(u) ? toComposite(decodeUnknown(Array.from(sortedSet_.values(u)), options), as => sortedSet_.fromIterable(as, ord), ast, u) : ParseResult.fail(new ParseResult.Type(ast, u));
/**
 * @category SortedSet transformations
 * @since 3.10.0
 */
const SortedSetFromSelf = (value, ordA, ordI) => {
  return declare([value], {
    decode: item => sortedSetParse(ParseResult.decodeUnknown(Array$(item)), ordA),
    encode: item => sortedSetParse(ParseResult.encodeUnknown(Array$(item)), ordI)
  }, {
    description: `SortedSet<${Schema_format(value)}>`,
    pretty: sortedSetPretty,
    arbitrary: (arb, ctx) => sortedSetArbitrary(arb, ordA, ctx),
    equivalence: () => sortedSet_.getEquivalence()
  });
};
/**
 * @category SortedSet transformations
 * @since 3.10.0
 */
function SortedSet(value, ordA) {
  const to = typeSchema(asSchema(value));
  return transform(Array$(value), SortedSetFromSelf(to, ordA, ordA), {
    strict: true,
    decode: i => sortedSet_.fromIterable(i, ordA),
    encode: a => Array.from(sortedSet_.values(a))
  });
}
/**
 * Converts an arbitrary value to a `boolean` by testing whether it is truthy.
 * Uses `!!val` to coerce the value to a `boolean`.
 *
 * @see https://developer.mozilla.org/docs/Glossary/Truthy
 *
 * @category boolean constructors
 * @since 3.10.0
 */
class BooleanFromUnknown extends /*#__PURE__*/transform(Unknown, Boolean$, {
  strict: true,
  decode: i => esm_Predicate/* isTruthy */.fQ(i),
  encode: Function/* identity */.yR
}).annotations({
  identifier: "BooleanFromUnknown"
}) {}
/**
 * Converts an `string` value into its corresponding `boolean`
 * ("true" as `true` and "false" as `false`).
 *
 * @category boolean transformations
 * @since 3.11.0
 */
class BooleanFromString extends /*#__PURE__*/transform(Schema_Literal("true", "false").annotations({
  description: "a string to be decoded into a boolean"
}), Boolean$, {
  strict: true,
  decode: i => i === "true",
  encode: a => a ? "true" : "false"
}).annotations({
  identifier: "BooleanFromString"
}) {}
/**
 * @category Config validations
 * @since 3.10.0
 */
const Config = (name, schema) => {
  const decodeUnknownEither = ParseResult.decodeUnknownEither(schema);
  return config_.string(name).pipe(config_.mapOrFail(s => decodeUnknownEither(s).pipe(either_.mapLeft(error => configError_.InvalidData([], ParseResult.TreeFormatter.formatIssueSync(error))))));
};
// ---------------------------------------------
// Serializable
// ---------------------------------------------
/**
 * @since 3.10.0
 * @category symbol
 */
const symbolSerializable = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/Schema/Serializable/symbol")));
/**
 * @since 3.10.0
 */
const asSerializable = serializable => serializable;
/**
 * @since 3.10.0
 * @category accessor
 */
const serializableSchema = self => self[symbolSerializable];
/**
 * @since 3.10.0
 * @category encoding
 */
const serialize = self => Schema_encodeUnknown(self[symbolSerializable])(self);
/**
 * @since 3.10.0
 * @category decoding
 */
const deserialize = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, value) => Schema_decodeUnknown(self[symbolSerializable])(value))));
/**
 * @since 3.10.0
 * @category symbol
 */
const symbolWithResult = /*#__PURE__*/(/* unused pure expression or super */ null && (Symbol.for("effect/Schema/Serializable/symbolResult")));
/**
 * @since 3.10.0
 */
const asWithResult = withExit => withExit;
/**
 * @since 3.10.0
 * @category accessor
 */
const failureSchema = self => self[symbolWithResult].failure;
/**
 * @since 3.10.0
 * @category accessor
 */
const successSchema = self => self[symbolWithResult].success;
const exitSchemaCache = /*#__PURE__*/(/* unused pure expression or super */ null && (globalValue("effect/Schema/Serializable/exitSchemaCache", () => new WeakMap())));
/**
 * @since 3.10.0
 * @category accessor
 */
const exitSchema = self => {
  const proto = Object.getPrototypeOf(self);
  if (!(symbolWithResult in proto)) {
    return Schema_Exit({
      failure: failureSchema(self),
      success: successSchema(self),
      defect: Defect
    });
  }
  let schema = exitSchemaCache.get(proto);
  if (schema === undefined) {
    schema = Schema_Exit({
      failure: failureSchema(self),
      success: successSchema(self),
      defect: Defect
    });
    exitSchemaCache.set(proto, schema);
  }
  return schema;
};
/**
 * @since 3.10.0
 * @category encoding
 */
const serializeFailure = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, value) => Schema_encode(self[symbolWithResult].failure)(value))));
/**
 * @since 3.10.0
 * @category decoding
 */
const deserializeFailure = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, value) => Schema_decodeUnknown(self[symbolWithResult].failure)(value))));
/**
 * @since 3.10.0
 * @category encoding
 */
const serializeSuccess = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, value) => Schema_encode(self[symbolWithResult].success)(value))));
/**
 * @since 3.10.0
 * @category decoding
 */
const deserializeSuccess = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, value) => Schema_decodeUnknown(self[symbolWithResult].success)(value))));
/**
 * @since 3.10.0
 * @category encoding
 */
const serializeExit = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, value) => Schema_encode(exitSchema(self))(value))));
/**
 * @since 3.10.0
 * @category decoding
 */
const deserializeExit = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, value) => Schema_decodeUnknown(exitSchema(self))(value))));
/**
 * @since 3.10.0
 */
const asSerializableWithResult = procedure => procedure;
/**
 * @example
 * ```ts
 * import { Schema } from "effect"
 *
 * class MyRequest extends Schema.TaggedRequest<MyRequest>("MyRequest")("MyRequest", {
 *  failure: Schema.String,
 *  success: Schema.Number,
 *  payload: { id: Schema.String }
 * }) {}
 * ```
 *
 * @category classes
 * @since 3.10.0
 */
const TaggedRequest = identifier => (tag, options, annotations) => {
  const taggedFields = extendFields({
    _tag: getClassTag(tag)
  }, options.payload);
  return class TaggedRequestClass extends makeClass({
    kind: "TaggedRequest",
    identifier: identifier ?? tag,
    schema: Schema_Struct(taggedFields),
    fields: taggedFields,
    Base: Request.Class,
    annotations
  }) {
    static _tag = tag;
    static success = options.success;
    static failure = options.failure;
    get [symbolSerializable]() {
      return this.constructor;
    }
    get [symbolWithResult]() {
      return {
        failure: options.failure,
        success: options.success
      };
    }
  };
};
// -------------------------------------------------------------------------------------------------
// Equivalence compiler
// -------------------------------------------------------------------------------------------------
/**
 * Given a schema `Schema<A, I, R>`, returns an `Equivalence` instance for `A`.
 *
 * @category Equivalence
 * @since 3.10.0
 */
const equivalence = schema => Schema_go(schema.ast, []);
const getEquivalenceAnnotation = /*#__PURE__*/getAnnotation(EquivalenceAnnotationId);
const Schema_go = (ast, path) => {
  const hook = getEquivalenceAnnotation(ast);
  if (option_.isSome(hook)) {
    switch (ast._tag) {
      case "Declaration":
        return hook.value(...ast.typeParameters.map(tp => Schema_go(tp, path)));
      case "Refinement":
        return hook.value(Schema_go(ast.from, path));
      default:
        return hook.value();
    }
  }
  switch (ast._tag) {
    case "NeverKeyword":
      throw new Error(errors_.getEquivalenceUnsupportedErrorMessage(ast, path));
    case "Transformation":
      return Schema_go(ast.to, path);
    case "Declaration":
    case "Literal":
    case "StringKeyword":
    case "TemplateLiteral":
    case "UniqueSymbol":
    case "SymbolKeyword":
    case "UnknownKeyword":
    case "AnyKeyword":
    case "NumberKeyword":
    case "BooleanKeyword":
    case "BigIntKeyword":
    case "UndefinedKeyword":
    case "VoidKeyword":
    case "Enums":
    case "ObjectKeyword":
      return Equal.equals;
    case "Refinement":
      return Schema_go(ast.from, path);
    case "Suspend":
      {
        const get = util_.memoizeThunk(() => Schema_go(ast.f(), path));
        return (a, b) => get()(a, b);
      }
    case "TupleType":
      {
        const elements = ast.elements.map((element, i) => Schema_go(element.type, path.concat(i)));
        const rest = ast.rest.map(annotatedAST => Schema_go(annotatedAST.type, path));
        return Equivalence.make((a, b) => {
          const len = a.length;
          if (len !== b.length) {
            return false;
          }
          // ---------------------------------------------
          // handle elements
          // ---------------------------------------------
          let i = 0;
          for (; i < Math.min(len, ast.elements.length); i++) {
            if (!elements[i](a[i], b[i])) {
              return false;
            }
          }
          // ---------------------------------------------
          // handle rest element
          // ---------------------------------------------
          if (array_.isNonEmptyReadonlyArray(rest)) {
            const [head, ...tail] = rest;
            for (; i < len - tail.length; i++) {
              if (!head(a[i], b[i])) {
                return false;
              }
            }
            // ---------------------------------------------
            // handle post rest elements
            // ---------------------------------------------
            for (let j = 0; j < tail.length; j++) {
              i += j;
              if (!tail[j](a[i], b[i])) {
                return false;
              }
            }
          }
          return true;
        });
      }
    case "TypeLiteral":
      {
        if (ast.propertySignatures.length === 0 && ast.indexSignatures.length === 0) {
          return Equal.equals;
        }
        const propertySignatures = ast.propertySignatures.map(ps => Schema_go(ps.type, path.concat(ps.name)));
        const indexSignatures = ast.indexSignatures.map(is => Schema_go(is.type, path));
        return Equivalence.make((a, b) => {
          const aStringKeys = Object.keys(a);
          const aSymbolKeys = Object.getOwnPropertySymbols(a);
          // ---------------------------------------------
          // handle property signatures
          // ---------------------------------------------
          for (let i = 0; i < propertySignatures.length; i++) {
            const ps = ast.propertySignatures[i];
            const name = ps.name;
            const aHas = Object.prototype.hasOwnProperty.call(a, name);
            const bHas = Object.prototype.hasOwnProperty.call(b, name);
            if (ps.isOptional) {
              if (aHas !== bHas) {
                return false;
              }
            }
            if (aHas && bHas && !propertySignatures[i](a[name], b[name])) {
              return false;
            }
          }
          // ---------------------------------------------
          // handle index signatures
          // ---------------------------------------------
          let bSymbolKeys;
          let bStringKeys;
          for (let i = 0; i < indexSignatures.length; i++) {
            const is = ast.indexSignatures[i];
            const encodedParameter = AST.getEncodedParameter(is.parameter);
            const isSymbol = AST.isSymbolKeyword(encodedParameter);
            if (isSymbol) {
              bSymbolKeys = bSymbolKeys || Object.getOwnPropertySymbols(b);
              if (aSymbolKeys.length !== bSymbolKeys.length) {
                return false;
              }
            } else {
              bStringKeys = bStringKeys || Object.keys(b);
              if (aStringKeys.length !== bStringKeys.length) {
                return false;
              }
            }
            const aKeys = isSymbol ? aSymbolKeys : aStringKeys;
            for (let j = 0; j < aKeys.length; j++) {
              const key = aKeys[j];
              if (!Object.prototype.hasOwnProperty.call(b, key) || !indexSignatures[i](a[key], b[key])) {
                return false;
              }
            }
          }
          return true;
        });
      }
    case "Union":
      {
        const searchTree = ParseResult.getSearchTree(ast.types, true);
        const ownKeys = util_.ownKeys(searchTree.keys);
        const len = ownKeys.length;
        return Equivalence.make((a, b) => {
          let candidates = [];
          if (len > 0 && Predicate.isRecordOrArray(a)) {
            for (let i = 0; i < len; i++) {
              const name = ownKeys[i];
              const buckets = searchTree.keys[name].buckets;
              if (Object.prototype.hasOwnProperty.call(a, name)) {
                const literal = String(a[name]);
                if (Object.prototype.hasOwnProperty.call(buckets, literal)) {
                  candidates = candidates.concat(buckets[literal]);
                }
              }
            }
          }
          if (searchTree.otherwise.length > 0) {
            candidates = candidates.concat(searchTree.otherwise);
          }
          const tuples = candidates.map(ast => [Schema_go(ast, path), ParseResult.is({
            ast
          })]);
          for (let i = 0; i < tuples.length; i++) {
            const [equivalence, is] = tuples[i];
            if (is(a) && is(b)) {
              if (equivalence(a, b)) {
                return true;
              }
            }
          }
          return false;
        });
      }
  }
};
const SymbolStruct = /*#__PURE__*/TaggedStruct("symbol", {
  key: String$
}).annotations({
  description: "an object to be decoded into a globally shared symbol"
});
const SymbolFromStruct = /*#__PURE__*/transformOrFail(SymbolStruct, SymbolFromSelf, {
  strict: true,
  decode: i => decodeSymbol(i.key),
  encode: (a, _, ast) => map(encodeSymbol(a, ast), key => SymbolStruct.make({
    key
  }))
});
/** @ignore */
class PropertyKey$ extends /*#__PURE__*/Schema_Union(String$, Number$, SymbolFromStruct).annotations({
  identifier: "PropertyKey"
}) {}

/**
 * @category ArrayFormatter
 * @since 3.12.5
 */
class ArrayFormatterIssue extends /*#__PURE__*/Schema_Struct({
  _tag: propertySignature(Schema_Literal("Pointer", "Unexpected", "Missing", "Composite", "Refinement", "Transformation", "Type", "Forbidden")).annotations({
    description: "The tag identifying the type of parse issue"
  }),
  path: propertySignature(Array$(PropertyKey$)).annotations({
    description: "The path to the property where the issue occurred"
  }),
  message: propertySignature(String$).annotations({
    description: "A descriptive message explaining the issue"
  })
}).annotations({
  identifier: "ArrayFormatterIssue",
  description: "Represents an issue returned by the ArrayFormatter formatter"
}) {}
//# sourceMappingURL=Schema.js.map

/***/ }),

/***/ 101:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rM": function() { return /* binding */ fork; },
/* harmony export */   "sX": function() { return /* binding */ Scope; },
/* harmony export */   "xv": function() { return /* binding */ close; }
/* harmony export */ });
/* unused harmony exports ScopeTypeId, CloseableScopeTypeId, addFinalizer, addFinalizerExit, extend, use, make */
/* harmony import */ var _internal_core_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39355);
/* harmony import */ var _internal_fiberRuntime_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90886);
/**
 * @since 2.0.0
 */


/**
 * A unique identifier for the `Scope` type.
 *
 * @since 2.0.0
 * @category symbols
 */
const ScopeTypeId = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .ScopeTypeId */ .otW;
/**
 * A unique identifier for the `CloseableScope` type.
 *
 * @since 2.0.0
 * @category symbols
 */
const CloseableScopeTypeId = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .CloseableScopeTypeId */ .Bcn;
/**
 * A tag representing the current `Scope` in the environment.
 *
 * @since 2.0.0
 * @category context
 */
const Scope = _internal_fiberRuntime_js__WEBPACK_IMPORTED_MODULE_1__/* .scopeTag */ .XX;
/**
 * Adds a finalizer to this scope. The finalizer is guaranteed to be run when
 * the scope is closed. Use this when the finalizer does not need to know the
 * `Exit` value that the scope is closed with.
 *
 * @see {@link addFinalizerExit}
 *
 * @since 2.0.0
 * @category utils
 */
const addFinalizer = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .scopeAddFinalizer */ .tFM;
/**
 * Adds a finalizer to this scope. The finalizer receives the `Exit` value
 * when the scope is closed, allowing it to perform different actions based
 * on the exit status.
 *
 * @see {@link addFinalizer}
 *
 * @since 2.0.0
 * @category utils
 */
const addFinalizerExit = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .scopeAddFinalizerExit */ .veJ;
/**
 * Closes this scope with the specified exit value, running all finalizers that
 * have been added to the scope.
 *
 * @since 2.0.0
 * @category destructors
 */
const close = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .scopeClose */ .roQ;
/**
 * Extends the scope of an `Effect` that requires a scope into this scope.
 * It provides this scope to the effect but does not close the scope when the
 * effect completes execution. This allows extending a scoped value into a
 * larger scope.
 *
 * @since 2.0.0
 * @category utils
 */
const extend = _internal_fiberRuntime_js__WEBPACK_IMPORTED_MODULE_1__/* .scopeExtend */ .Vx;
/**
 * Forks a new child scope with the specified execution strategy. The child scope
 * will automatically be closed when this scope is closed.
 *
 * @since 2.0.0
 * @category utils
 */
const fork = _internal_core_js__WEBPACK_IMPORTED_MODULE_0__/* .scopeFork */ .Z5L;
/**
 * Provides this closeable scope to an `Effect` that requires a scope,
 * guaranteeing that the scope is closed with the result of that effect as
 * soon as the effect completes execution, whether by success, failure, or
 * interruption.
 *
 * @since 2.0.0
 * @category destructors
 */
const use = _internal_fiberRuntime_js__WEBPACK_IMPORTED_MODULE_1__/* .scopeUse */ .y0;
/**
 * Creates a new closeable scope where finalizers will run according to the
 * specified `ExecutionStrategy`. If no execution strategy is provided, `sequential`
 * will be used by default.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = _internal_fiberRuntime_js__WEBPACK_IMPORTED_MODULE_1__/* .scopeMake */ .RN;
//# sourceMappingURL=Scope.js.map

/***/ }),

/***/ 55354:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Le": function() { return /* binding */ uncapitalize; },
/* harmony export */   "Od": function() { return /* binding */ isNonEmpty; },
/* harmony export */   "kC": function() { return /* binding */ capitalize; }
/* harmony export */ });
/* unused harmony exports isString, Equivalence, Order, empty, concat, toUpperCase, toLowerCase, replace, trim, trimStart, trimEnd, slice, isEmpty, length, split, includes, startsWith, endsWith, charCodeAt, substring, at, charAt, codePointAt, indexOf, lastIndexOf, localeCompare, match, matchAll, normalize, padEnd, padStart, repeat, replaceAll, search, toLocaleLowerCase, toLocaleUpperCase, takeLeft, takeRight, linesIterator, linesWithSeparators, stripMarginWith, stripMargin, snakeToCamel, snakeToPascal, snakeToKebab, camelToSnake, pascalToSnake, kebabToSnake */
/* harmony import */ var _Equivalence_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27786);
/* harmony import */ var _Order_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51988);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71335);
/**
 * This module provides utility functions and type class instances for working with the `string` type in TypeScript.
 * It includes functions for basic string manipulation, as well as type class instances for
 * `Equivalence` and `Order`.
 *
 * @since 2.0.0
 */







/**
 * Tests if a value is a `string`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { String } from "effect"
 *
 * assert.deepStrictEqual(String.isString("a"), true)
 * assert.deepStrictEqual(String.isString(1), false)
 * ```
 *
 * @category guards
 * @since 2.0.0
 */
const isString = _Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD;
/**
 * @category instances
 * @since 2.0.0
 */
const Equivalence = _Equivalence_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_;
/**
 * @category instances
 * @since 2.0.0
 */
const Order = _Order_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_;
/**
 * The empty string `""`.
 *
 * @since 2.0.0
 */
const empty = "";
/**
 * Concatenates two strings at runtime.
 *
 * @since 2.0.0
 */
const concat = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => self + that)));
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * assert.deepStrictEqual(pipe('a', String.toUpperCase), 'A')
 * ```
 *
 * @since 2.0.0
 */
const toUpperCase = self => self.toUpperCase();
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * assert.deepStrictEqual(pipe('A', String.toLowerCase), 'a')
 * ```
 *
 * @since 2.0.0
 */
const toLowerCase = self => self.toLowerCase();
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * assert.deepStrictEqual(pipe('abc', String.capitalize), 'Abc')
 * ```
 *
 * @since 2.0.0
 */
const capitalize = self => {
  if (self.length === 0) return self;
  return toUpperCase(self[0]) + self.slice(1);
};
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * assert.deepStrictEqual(pipe('ABC', String.uncapitalize), 'aBC')
 * ```
 *
 * @since 2.0.0
 */
const uncapitalize = self => {
  if (self.length === 0) return self;
  return toLowerCase(self[0]) + self.slice(1);
};
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * assert.deepStrictEqual(pipe('abc', String.replace('b', 'd')), 'adc')
 * ```
 *
 * @since 2.0.0
 */
const replace = (searchValue, replaceValue) => self => self.replace(searchValue, replaceValue);
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { String } from "effect"
 *
 * assert.deepStrictEqual(String.trim(' a '), 'a')
 * ```
 *
 * @since 2.0.0
 */
const trim = self => self.trim();
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { String } from "effect"
 *
 * assert.deepStrictEqual(String.trimStart(' a '), 'a ')
 * ```
 *
 * @since 2.0.0
 */
const trimStart = self => self.trimStart();
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { String } from "effect"
 *
 * assert.deepStrictEqual(String.trimEnd(' a '), ' a')
 * ```
 *
 * @since 2.0.0
 */
const trimEnd = self => self.trimEnd();
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * assert.deepStrictEqual(pipe('abcd', String.slice(1, 3)), 'bc')
 * ```
 *
 * @since 2.0.0
 */
const slice = (start, end) => self => self.slice(start, end);
/**
 * Test whether a `string` is empty.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { String } from "effect"
 *
 * assert.deepStrictEqual(String.isEmpty(''), true)
 * assert.deepStrictEqual(String.isEmpty('a'), false)
 * ```
 *
 * @since 2.0.0
 */
const isEmpty = self => self.length === 0;
/**
 * Test whether a `string` is non empty.
 *
 * @since 2.0.0
 */
const isNonEmpty = self => self.length > 0;
/**
 * Calculate the number of characters in a `string`.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { String } from "effect"
 *
 * assert.deepStrictEqual(String.length('abc'), 3)
 * ```
 *
 * @since 2.0.0
 */
const length = self => self.length;
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * assert.deepStrictEqual(pipe('abc', String.split('')), ['a', 'b', 'c'])
 * assert.deepStrictEqual(pipe('', String.split('')), [''])
 * ```
 *
 * @since 2.0.0
 */
const split = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, separator) => {
  const out = self.split(separator);
  return readonlyArray.isNonEmptyArray(out) ? out : [self];
})));
/**
 * Returns `true` if `searchString` appears as a substring of `self`, at one or more positions that are
 * greater than or equal to `position`; otherwise, returns `false`.
 *
 * @since 2.0.0
 */
const includes = (searchString, position) => self => self.includes(searchString, position);
/**
 * @since 2.0.0
 */
const startsWith = (searchString, position) => self => self.startsWith(searchString, position);
/**
 * @since 2.0.0
 */
const endsWith = (searchString, position) => self => self.endsWith(searchString, position);
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String, Option } from "effect"
 *
 * assert.deepStrictEqual(pipe("abc", String.charCodeAt(1)), Option.some(98))
 * assert.deepStrictEqual(pipe("abc", String.charCodeAt(4)), Option.none())
 * ```
 *
 * @since 2.0.0
 */
const charCodeAt = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, index) => Option.filter(Option.some(self.charCodeAt(index)), charCode => !isNaN(charCode)))));
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String, Option } from "effect"
 *
 * assert.deepStrictEqual(pipe("abcd", String.substring(1)), "bcd")
 * assert.deepStrictEqual(pipe("abcd", String.substring(1, 3)), "bc")
 * ```
 *
 * @since 2.0.0
 */
const substring = (start, end) => self => self.substring(start, end);
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String, Option } from "effect"
 *
 * assert.deepStrictEqual(pipe("abc", String.at(1)), Option.some("b"))
 * assert.deepStrictEqual(pipe("abc", String.at(4)), Option.none())
 * ```
 *
 * @since 2.0.0
 */
const at = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, index) => Option.fromNullable(self.at(index)))));
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String, Option } from "effect"
 *
 * assert.deepStrictEqual(pipe("abc", String.charAt(1)), Option.some("b"))
 * assert.deepStrictEqual(pipe("abc", String.charAt(4)), Option.none())
 * ```
 *
 * @since 2.0.0
 */
const charAt = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, index) => Option.filter(Option.some(self.charAt(index)), isNonEmpty))));
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String, Option } from "effect"
 *
 * assert.deepStrictEqual(pipe("abc", String.codePointAt(1)), Option.some(98))
 * ```
 *
 * @since 2.0.0
 */
const codePointAt = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, index) => Option.fromNullable(self.codePointAt(index)))));
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String, Option } from "effect"
 *
 * assert.deepStrictEqual(pipe("abbbc", String.indexOf("b")), Option.some(1))
 * ```
 *
 * @since 2.0.0
 */
const indexOf = searchString => self => Option.filter(Option.some(self.indexOf(searchString)), number.greaterThanOrEqualTo(0));
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String, Option } from "effect"
 *
 * assert.deepStrictEqual(pipe("abbbc", String.lastIndexOf("b")), Option.some(3))
 * assert.deepStrictEqual(pipe("abbbc", String.lastIndexOf("d")), Option.none())
 * ```
 *
 * @since 2.0.0
 */
const lastIndexOf = searchString => self => Option.filter(Option.some(self.lastIndexOf(searchString)), number.greaterThanOrEqualTo(0));
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * assert.deepStrictEqual(pipe("a", String.localeCompare("b")), -1)
 * assert.deepStrictEqual(pipe("b", String.localeCompare("a")), 1)
 * assert.deepStrictEqual(pipe("a", String.localeCompare("a")), 0)
 * ```
 *
 * @since 2.0.0
 */
const localeCompare = (that, locales, options) => self => number.sign(self.localeCompare(that, locales, options));
/**
 * It is the `pipe`-able version of the native `match` method.
 *
 * @since 2.0.0
 */
const match = regexp => self => Option.fromNullable(self.match(regexp));
/**
 * It is the `pipe`-able version of the native `matchAll` method.
 *
 * @since 2.0.0
 */
const matchAll = regexp => self => self.matchAll(regexp);
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * const str = "\u1E9B\u0323";
 * assert.deepStrictEqual(pipe(str, String.normalize()), "\u1E9B\u0323")
 * assert.deepStrictEqual(pipe(str, String.normalize("NFC")), "\u1E9B\u0323")
 * assert.deepStrictEqual(pipe(str, String.normalize("NFD")), "\u017F\u0323\u0307")
 * assert.deepStrictEqual(pipe(str, String.normalize("NFKC")), "\u1E69")
 * assert.deepStrictEqual(pipe(str, String.normalize("NFKD")), "\u0073\u0323\u0307")
 * ```
 *
 * @since 2.0.0
 */
const normalize = form => self => self.normalize(form);
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * assert.deepStrictEqual(pipe("a", String.padEnd(5)), "a    ")
 * assert.deepStrictEqual(pipe("a", String.padEnd(5, "_")), "a____")
 * ```
 *
 * @since 2.0.0
 */
const padEnd = (maxLength, fillString) => self => self.padEnd(maxLength, fillString);
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * assert.deepStrictEqual(pipe("a", String.padStart(5)), "    a")
 * assert.deepStrictEqual(pipe("a", String.padStart(5, "_")), "____a")
 * ```
 *
 * @since 2.0.0
 */
const padStart = (maxLength, fillString) => self => self.padStart(maxLength, fillString);
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * assert.deepStrictEqual(pipe("a", String.repeat(5)), "aaaaa")
 * ```
 *
 * @since 2.0.0
 */
const repeat = count => self => self.repeat(count);
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * assert.deepStrictEqual(pipe("ababb", String.replaceAll("b", "c")), "acacc")
 * assert.deepStrictEqual(pipe("ababb", String.replaceAll(/ba/g, "cc")), "accbb")
 * ```
 *
 * @since 2.0.0
 */
const replaceAll = (searchValue, replaceValue) => self => self.replaceAll(searchValue, replaceValue);
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String, Option } from "effect"
 *
 * assert.deepStrictEqual(pipe("ababb", String.search("b")), Option.some(1))
 * assert.deepStrictEqual(pipe("ababb", String.search(/abb/)), Option.some(2))
 * assert.deepStrictEqual(pipe("ababb", String.search("d")), Option.none())
 * ```
 *
 * @since 2.0.0
 */
const search = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, regexp) => Option.filter(Option.some(self.search(regexp)), number.greaterThanOrEqualTo(0)))));
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * const str = "\u0130"
 * assert.deepStrictEqual(pipe(str, String.toLocaleLowerCase("tr")), "i")
 * ```
 *
 * @since 2.0.0
 */
const toLocaleLowerCase = locale => self => self.toLocaleLowerCase(locale);
/**
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, String } from "effect"
 *
 * const str = "i\u0307"
 * assert.deepStrictEqual(pipe(str, String.toLocaleUpperCase("lt-LT")), "I")
 * ```
 *
 * @since 2.0.0
 */
const toLocaleUpperCase = locale => self => self.toLocaleUpperCase(locale);
/**
 * Keep the specified number of characters from the start of a string.
 *
 * If `n` is larger than the available number of characters, the string will
 * be returned whole.
 *
 * If `n` is not a positive number, an empty string will be returned.
 *
 * If `n` is a float, it will be rounded down to the nearest integer.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { String } from "effect"
 *
 * assert.deepStrictEqual(String.takeLeft("Hello World", 5), "Hello")
 * ```
 *
 * @since 2.0.0
 */
const takeLeft = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => self.slice(0, Math.max(n, 0)))));
/**
 * Keep the specified number of characters from the end of a string.
 *
 * If `n` is larger than the available number of characters, the string will
 * be returned whole.
 *
 * If `n` is not a positive number, an empty string will be returned.
 *
 * If `n` is a float, it will be rounded down to the nearest integer.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { String } from "effect"
 *
 * assert.deepStrictEqual(String.takeRight("Hello World", 5), "World")
 * ```
 *
 * @since 2.0.0
 */
const takeRight = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => self.slice(Math.max(0, self.length - Math.floor(n)), Infinity))));
const CR = 0x0d;
const LF = 0x0a;
/**
 * Returns an `IterableIterator` which yields each line contained within the
 * string, trimming off the trailing newline character.
 *
 * @since 2.0.0
 */
const linesIterator = self => linesSeparated(self, true);
/**
 * Returns an `IterableIterator` which yields each line contained within the
 * string as well as the trailing newline character.
 *
 * @since 2.0.0
 */
const linesWithSeparators = s => linesSeparated(s, false);
/**
 * For every line in this string, strip a leading prefix consisting of blanks
 * or control characters followed by the character specified by `marginChar`
 * from the line.
 *
 * @since 2.0.0
 */
const stripMarginWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, marginChar) => {
  let out = "";
  for (const line of linesWithSeparators(self)) {
    let index = 0;
    while (index < line.length && line.charAt(index) <= " ") {
      index = index + 1;
    }
    const stripped = index < line.length && line.charAt(index) === marginChar ? line.substring(index + 1) : line;
    out = out + stripped;
  }
  return out;
})));
/**
 * For every line in this string, strip a leading prefix consisting of blanks
 * or control characters followed by the `"|"` character from the line.
 *
 * @since 2.0.0
 */
const stripMargin = self => stripMarginWith(self, "|");
/**
 * @since 2.0.0
 */
const snakeToCamel = self => {
  let str = self[0];
  for (let i = 1; i < self.length; i++) {
    str += self[i] === "_" ? self[++i].toUpperCase() : self[i];
  }
  return str;
};
/**
 * @since 2.0.0
 */
const snakeToPascal = self => {
  let str = self[0].toUpperCase();
  for (let i = 1; i < self.length; i++) {
    str += self[i] === "_" ? self[++i].toUpperCase() : self[i];
  }
  return str;
};
/**
 * @since 2.0.0
 */
const snakeToKebab = self => self.replace(/_/g, "-");
/**
 * @since 2.0.0
 */
const camelToSnake = self => self.replace(/([A-Z])/g, "_$1").toLowerCase();
/**
 * @since 2.0.0
 */
const pascalToSnake = self => (self.slice(0, 1) + self.slice(1).replace(/([A-Z])/g, "_$1")).toLowerCase();
/**
 * @since 2.0.0
 */
const kebabToSnake = self => self.replace(/-/g, "_");
class LinesIterator {
  s;
  stripped;
  index;
  length;
  constructor(s, stripped = false) {
    this.s = s;
    this.stripped = stripped;
    this.index = 0;
    this.length = s.length;
  }
  next() {
    if (this.done) {
      return {
        done: true,
        value: undefined
      };
    }
    const start = this.index;
    while (!this.done && !isLineBreak(this.s[this.index])) {
      this.index = this.index + 1;
    }
    let end = this.index;
    if (!this.done) {
      const char = this.s[this.index];
      this.index = this.index + 1;
      if (!this.done && isLineBreak2(char, this.s[this.index])) {
        this.index = this.index + 1;
      }
      if (!this.stripped) {
        end = this.index;
      }
    }
    return {
      done: false,
      value: this.s.substring(start, end)
    };
  }
  [Symbol.iterator]() {
    return new LinesIterator(this.s, this.stripped);
  }
  get done() {
    return this.index >= this.length;
  }
}
/**
 * Test if the provided character is a line break character (i.e. either `"\r"`
 * or `"\n"`).
 */
const isLineBreak = char => {
  const code = char.charCodeAt(0);
  return code === CR || code === LF;
};
/**
 * Test if the provided characters combine to form a carriage return/line-feed
 * (i.e. `"\r\n"`).
 */
const isLineBreak2 = (char0, char1) => char0.charCodeAt(0) === CR && char1.charCodeAt(0) === LF;
const linesSeparated = (self, stripped) => new LinesIterator(self, stripped);
//# sourceMappingURL=String.js.map

/***/ }),

/***/ 44576:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CE": function() { return /* binding */ omit; },
/* harmony export */   "ei": function() { return /* binding */ pick; }
/* harmony export */ });
/* unused harmony exports getEquivalence, getOrder, evolve, get, keys */
/* harmony import */ var _Equivalence_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27786);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17316);
/* harmony import */ var _Order_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51988);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71335);
/**
 * This module provides utility functions for working with structs in TypeScript.
 *
 * @since 2.0.0
 */




/**
 * Create a new object by picking properties of an existing object.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, Struct } from "effect"
 *
 * assert.deepStrictEqual(pipe({ a: "a", b: 1, c: true }, Struct.pick("a", "b")), { a: "a", b: 1 })
 * assert.deepStrictEqual(Struct.pick({ a: "a", b: 1, c: true }, "a", "b"), { a: "a", b: 1 })
 * ```
 *
 * @since 2.0.0
 */
const pick = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(args => _Predicate_js__WEBPACK_IMPORTED_MODULE_1__/* .isObject */ .Kn(args[0]), (s, ...keys) => {
  const out = {};
  for (const k of keys) {
    if (k in s) {
      out[k] = s[k];
    }
  }
  return out;
});
/**
 * Create a new object by omitting properties of an existing object.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, Struct } from "effect"
 *
 * assert.deepStrictEqual(pipe({ a: "a", b: 1, c: true }, Struct.omit("c")), { a: "a", b: 1 })
 * assert.deepStrictEqual(Struct.omit({ a: "a", b: 1, c: true }, "c"), { a: "a", b: 1 })
 * ```
 *
 * @since 2.0.0
 */
const omit = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(args => _Predicate_js__WEBPACK_IMPORTED_MODULE_1__/* .isObject */ .Kn(args[0]), (s, ...keys) => {
  const out = {
    ...s
  };
  for (const k of keys) {
    delete out[k];
  }
  return out;
});
/**
 * Given a struct of `Equivalence`s returns a new `Equivalence` that compares values of a struct
 * by applying each `Equivalence` to the corresponding property of the struct.
 *
 * Alias of {@link Equivalence.struct}.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Struct, String, Number } from "effect"
 *
 * const PersonEquivalence = Struct.getEquivalence({
 *   name: String.Equivalence,
 *   age: Number.Equivalence
 * })
 *
 * assert.deepStrictEqual(
 *   PersonEquivalence({ name: "John", age: 25 }, { name: "John", age: 25 }),
 *   true
 * )
 * assert.deepStrictEqual(
 *   PersonEquivalence({ name: "John", age: 25 }, { name: "John", age: 40 }),
 *   false
 * )
 * ```
 *
 * @category combinators
 * @since 2.0.0
 */
const getEquivalence = _Equivalence_js__WEBPACK_IMPORTED_MODULE_2__/* .struct */ .n_;
/**
 * This function creates and returns a new `Order` for a struct of values based on the given `Order`s
 * for each property in the struct.
 *
 * Alias of {@link order.struct}.
 *
 * @category combinators
 * @since 2.0.0
 */
const getOrder = _Order_js__WEBPACK_IMPORTED_MODULE_3__/* .struct */ .n_;
/**
 * Transforms the values of a Struct provided a transformation function for each key.
 * If no transformation function is provided for a key, it will return the origional value for that key.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, Struct } from "effect"
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     { a: 'a', b: 1, c: 3 },
 *     Struct.evolve({
 *       a: (a) => a.length,
 *       b: (b) => b * 2
 *     })
 *   ),
 *   { a: 1, b: 2, c: 3 }
 * )
 * ```
 *
 * @since 2.0.0
 */
const evolve = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (obj, t) => {
  const out = {
    ...obj
  };
  for (const k in t) {
    if (Object.prototype.hasOwnProperty.call(obj, k)) {
      // @ts-expect-error
      out[k] = t[k](obj[k]);
    }
  }
  return out;
})));
/**
 * Retrieves the value associated with the specified key from a struct.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, Struct } from "effect"
 *
 * const value = pipe({ a: 1, b: 2 }, Struct.get("a"))
 *
 * assert.deepStrictEqual(value, 1)
 * ```
 *
 * @since 2.0.0
 */
const get = key => s => s[key];
/**
 * Retrieves the object keys that are strings in a typed manner
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Struct } from "effect"
 *
 * const symbol: unique symbol = Symbol()
 *
 * const value = {
 *   a: 1,
 *   b: 2,
 *   [symbol]: 3
 * }
 *
 * const keys: Array<"a" | "b"> = Struct.keys(value)
 *
 * assert.deepStrictEqual(keys, ["a", "b"])
 * ```
 *
 * @since 3.6.0
 */
const keys = o => Object.keys(o);
//# sourceMappingURL=Struct.js.map

/***/ }),

/***/ 10800:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports getFirst, getSecond, map, mapBoth, mapFirst, mapSecond, swap, getEquivalence, getOrder, appendElement, at */
/* harmony import */ var _Equivalence_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27786);
/* harmony import */ var _Order_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51988);
/**
 * This module provides utility functions for working with tuples in TypeScript.
 *
 * @since 2.0.0
 */



/**
 * Constructs a new tuple from the provided values.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { make } from "effect/Tuple"
 *
 * assert.deepStrictEqual(make(1, 'hello', true), [1, 'hello', true])
 * ```
 *
 * @category constructors
 * @since 2.0.0
 */
const make = (...elements) => elements;
/**
 * Return the first element of a tuple.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { getFirst } from "effect/Tuple"
 *
 * assert.deepStrictEqual(getFirst(["hello", 42]), "hello")
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const getFirst = self => self[0];
/**
 * Return the second element of a tuple.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { getSecond } from "effect/Tuple"
 *
 * assert.deepStrictEqual(getSecond(["hello", 42]), 42)
 * ```
 *
 * @category getters
 * @since 2.0.0
 */
const getSecond = self => self[1];
/**
 * Transforms each element of tuple using the given function, treating tuple homomorphically
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { pipe, Tuple } from "effect"
 *
 * const result = pipe(
 *   ["a", 1, false] as const,
 *   Tuple.map((el) => el.toString().toUpperCase())
 * )
 * assert.deepStrictEqual(result, ['A', '1', 'FALSE'])
 * ```
 *
 * @category mapping
 * @since 3.9.0
 */
const map = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, fn) => self.map(element => fn(element)))));
/**
 * Transforms both elements of a tuple using the given functions.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { mapBoth } from "effect/Tuple"
 *
 * assert.deepStrictEqual(
 *   mapBoth(["hello", 42], { onFirst: s => s.toUpperCase(), onSecond: n => n.toString() }),
 *   ["HELLO", "42"]
 * )
 * ```
 *
 * @category mapping
 * @since 2.0.0
 */
const mapBoth = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, {
  onFirst,
  onSecond
}) => [onFirst(self[0]), onSecond(self[1])])));
/**
 * Transforms the first component of a tuple using a given function.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { mapFirst } from "effect/Tuple"
 *
 * assert.deepStrictEqual(
 *   mapFirst(["hello", 42], s => s.toUpperCase()),
 *   ["HELLO", 42]
 * )
 * ```
 *
 * @category mapping
 * @since 2.0.0
 */
const mapFirst = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => [f(self[0]), self[1]])));
/**
 * Transforms the second component of a tuple using a given function.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { mapSecond } from "effect/Tuple"
 *
 * assert.deepStrictEqual(
 *   mapSecond(["hello", 42], n => n.toString()),
 *   ["hello", "42"]
 * )
 * ```
 *
 * @category mapping
 * @since 2.0.0
 */
const mapSecond = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => [self[0], f(self[1])])));
/**
 * Swaps the two elements of a tuple.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { swap } from "effect/Tuple"
 *
 * assert.deepStrictEqual(swap(["hello", 42]), [42, "hello"])
 * ```
 *
 * @since 2.0.0
 */
const swap = self => [self[1], self[0]];
/**
 * Given a tuple of `Equivalence`s returns a new `Equivalence` that compares values of a tuple
 * by applying each `Equivalence` to the corresponding element of the tuple.
 *
 * @category combinators
 * @since 2.0.0
 */
const getEquivalence = _Equivalence_js__WEBPACK_IMPORTED_MODULE_0__/* .tuple */ .bc;
/**
 * This function creates and returns a new `Order` for a tuple of values based on the given `Order`s for each element in the tuple.
 * The returned `Order` compares two tuples of the same type by applying the corresponding `Order` to each element in the tuple.
 * It is useful when you need to compare two tuples of the same type and you have a specific way of comparing each element
 * of the tuple.
 *
 * @category combinators
 * @since 2.0.0
 */
const getOrder = _Order_js__WEBPACK_IMPORTED_MODULE_1__/* .tuple */ .bc;
/**
 * Appends an element to the end of a tuple.
 *
 * @category concatenating
 * @since 2.0.0
 */
const appendElement = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => [...self, that])));
/**
 * Retrieves the element at a specified index from a tuple.
 *
 * @example
 * ```ts
 * import * as assert from "node:assert"
 * import { Tuple } from "effect"
 *
 * assert.deepStrictEqual(Tuple.at([1, 'hello', true], 1), 'hello')
 * ```
 *
 * @category getters
 * @since 3.4.0
 */
const at = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, index) => self[index])));

//# sourceMappingURL=Tuple.js.map

/***/ }),

/***/ 70762:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MS": function() { return /* binding */ internalCall; },
/* harmony export */   "Mc": function() { return /* binding */ PCGRandom; },
/* harmony export */   "Rz": function() { return /* binding */ yieldWrapGet; },
/* harmony export */   "U9": function() { return /* binding */ SingleShotGen; },
/* harmony export */   "oY": function() { return /* binding */ YieldWrap; },
/* harmony export */   "uL": function() { return /* binding */ structuralRegionState; }
/* harmony export */ });
/* unused harmony exports GenKindTypeId, isGenKind, GenKindImpl, makeGenKind, adapter, YieldWrapTypeId, structuralRegion, isGeneratorFunction */
/* harmony import */ var _GlobalValue_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4726);
/* harmony import */ var _internal_errors_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3910);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71335);
/**
 * @since 2.0.0
 */




/*
 * Copyright 2014 Thom Chiovoloni, released under the MIT license.
 *
 * A random number generator based on the basic implementation of the PCG algorithm,
 * as described here: http://www.pcg-random.org/
 *
 * Adapted for TypeScript from Thom's original code at https://github.com/thomcc/pcg-random
 *
 * forked from https://github.com/frptools
 *
 * @since 2.0.0
 */
/**
 * @category symbols
 * @since 2.0.0
 */
const GenKindTypeId = /*#__PURE__*/Symbol.for("effect/Gen/GenKind");
/**
 * @category predicates
 * @since 3.0.6
 */
const isGenKind = u => isObject(u) && GenKindTypeId in u;
/**
 * @category constructors
 * @since 2.0.0
 */
class GenKindImpl {
  value;
  constructor(
  /**
   * @since 2.0.0
   */
  value) {
    this.value = value;
  }
  /**
   * @since 2.0.0
   */
  get _F() {
    return identity;
  }
  /**
   * @since 2.0.0
   */
  get _R() {
    return _ => _;
  }
  /**
   * @since 2.0.0
   */
  get _O() {
    return _ => _;
  }
  /**
   * @since 2.0.0
   */
  get _E() {
    return _ => _;
  }
  /**
   * @since 2.0.0
   */
  [GenKindTypeId] = GenKindTypeId;
  /**
   * @since 2.0.0
   */
  [Symbol.iterator]() {
    return new SingleShotGen(this);
  }
}
/**
 * @category constructors
 * @since 2.0.0
 */
class SingleShotGen {
  self;
  called = false;
  constructor(self) {
    this.self = self;
  }
  /**
   * @since 2.0.0
   */
  next(a) {
    return this.called ? {
      value: a,
      done: true
    } : (this.called = true, {
      value: this.self,
      done: false
    });
  }
  /**
   * @since 2.0.0
   */
  return(a) {
    return {
      value: a,
      done: true
    };
  }
  /**
   * @since 2.0.0
   */
  throw(e) {
    throw e;
  }
  /**
   * @since 2.0.0
   */
  [Symbol.iterator]() {
    return new SingleShotGen(this.self);
  }
}
/**
 * @category constructors
 * @since 2.0.0
 */
const makeGenKind = kind => new GenKindImpl(kind);
/**
 * @category adapters
 * @since 2.0.0
 */
const adapter = () => function () {
  let x = arguments[0];
  for (let i = 1; i < arguments.length; i++) {
    x = arguments[i](x);
  }
  return new GenKindImpl(x);
};
const defaultIncHi = 0x14057b7e;
const defaultIncLo = 0xf767814f;
const MUL_HI = 0x5851f42d >>> 0;
const MUL_LO = 0x4c957f2d >>> 0;
const BIT_53 = 9007199254740992.0;
const BIT_27 = 134217728.0;
/**
 * PCG is a family of simple fast space-efficient statistically good algorithms
 * for random number generation. Unlike many general-purpose RNGs, they are also
 * hard to predict.
 *
 * @category model
 * @since 2.0.0
 */
class PCGRandom {
  _state;
  constructor(seedHi, seedLo, incHi, incLo) {
    if ((0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isNullable */ .Yd)(seedLo) && (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isNullable */ .Yd)(seedHi)) {
      seedLo = Math.random() * 0xffffffff >>> 0;
      seedHi = 0;
    } else if ((0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isNullable */ .Yd)(seedLo)) {
      seedLo = seedHi;
      seedHi = 0;
    }
    if ((0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isNullable */ .Yd)(incLo) && (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isNullable */ .Yd)(incHi)) {
      incLo = this._state ? this._state[3] : defaultIncLo;
      incHi = this._state ? this._state[2] : defaultIncHi;
    } else if ((0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .isNullable */ .Yd)(incLo)) {
      incLo = incHi;
      incHi = 0;
    }
    this._state = new Int32Array([0, 0, incHi >>> 0, ((incLo || 0) | 1) >>> 0]);
    this._next();
    add64(this._state, this._state[0], this._state[1], seedHi >>> 0, seedLo >>> 0);
    this._next();
    return this;
  }
  /**
   * Returns a copy of the internal state of this random number generator as a
   * JavaScript Array.
   *
   * @category getters
   * @since 2.0.0
   */
  getState() {
    return [this._state[0], this._state[1], this._state[2], this._state[3]];
  }
  /**
   * Restore state previously retrieved using `getState()`.
   *
   * @since 2.0.0
   */
  setState(state) {
    this._state[0] = state[0];
    this._state[1] = state[1];
    this._state[2] = state[2];
    this._state[3] = state[3] | 1;
  }
  /**
   * Get a uniformly distributed 32 bit integer between [0, max).
   *
   * @category getter
   * @since 2.0.0
   */
  integer(max) {
    return Math.round(this.number() * Number.MAX_SAFE_INTEGER) % max;
  }
  /**
   * Get a uniformly distributed IEEE-754 double between 0.0 and 1.0, with
   * 53 bits of precision (every bit of the mantissa is randomized).
   *
   * @category getters
   * @since 2.0.0
   */
  number() {
    const hi = (this._next() & 0x03ffffff) * 1.0;
    const lo = (this._next() & 0x07ffffff) * 1.0;
    return (hi * BIT_27 + lo) / BIT_53;
  }
  /** @internal */
  _next() {
    // save current state (what we'll use for this number)
    const oldHi = this._state[0] >>> 0;
    const oldLo = this._state[1] >>> 0;
    // churn LCG.
    mul64(this._state, oldHi, oldLo, MUL_HI, MUL_LO);
    add64(this._state, this._state[0], this._state[1], this._state[2], this._state[3]);
    // get least sig. 32 bits of ((oldstate >> 18) ^ oldstate) >> 27
    let xsHi = oldHi >>> 18;
    let xsLo = (oldLo >>> 18 | oldHi << 14) >>> 0;
    xsHi = (xsHi ^ oldHi) >>> 0;
    xsLo = (xsLo ^ oldLo) >>> 0;
    const xorshifted = (xsLo >>> 27 | xsHi << 5) >>> 0;
    // rotate xorshifted right a random amount, based on the most sig. 5 bits
    // bits of the old state.
    const rot = oldHi >>> 27;
    const rot2 = (-rot >>> 0 & 31) >>> 0;
    return (xorshifted >>> rot | xorshifted << rot2) >>> 0;
  }
}
function mul64(out, aHi, aLo, bHi, bLo) {
  let c1 = (aLo >>> 16) * (bLo & 0xffff) >>> 0;
  let c0 = (aLo & 0xffff) * (bLo >>> 16) >>> 0;
  let lo = (aLo & 0xffff) * (bLo & 0xffff) >>> 0;
  let hi = (aLo >>> 16) * (bLo >>> 16) + ((c0 >>> 16) + (c1 >>> 16)) >>> 0;
  c0 = c0 << 16 >>> 0;
  lo = lo + c0 >>> 0;
  if (lo >>> 0 < c0 >>> 0) {
    hi = hi + 1 >>> 0;
  }
  c1 = c1 << 16 >>> 0;
  lo = lo + c1 >>> 0;
  if (lo >>> 0 < c1 >>> 0) {
    hi = hi + 1 >>> 0;
  }
  hi = hi + Math.imul(aLo, bHi) >>> 0;
  hi = hi + Math.imul(aHi, bLo) >>> 0;
  out[0] = hi;
  out[1] = lo;
}
// add two 64 bit numbers (given in parts), and store the result in `out`.
function add64(out, aHi, aLo, bHi, bLo) {
  let hi = aHi + bHi >>> 0;
  const lo = aLo + bLo >>> 0;
  if (lo >>> 0 < aLo >>> 0) {
    hi = hi + 1 | 0;
  }
  out[0] = hi;
  out[1] = lo;
}
/**
 * @since 3.0.6
 */
const YieldWrapTypeId = /*#__PURE__*/Symbol.for("effect/Utils/YieldWrap");
/**
 * @since 3.0.6
 */
class YieldWrap {
  /**
   * @since 3.0.6
   */
  #value;
  constructor(value) {
    this.#value = value;
  }
  /**
   * @since 3.0.6
   */
  [YieldWrapTypeId]() {
    return this.#value;
  }
}
/**
 * @since 3.0.6
 */
function yieldWrapGet(self) {
  if (typeof self === "object" && self !== null && YieldWrapTypeId in self) {
    return self[YieldWrapTypeId]();
  }
  throw new Error((0,_internal_errors_js__WEBPACK_IMPORTED_MODULE_1__/* .getBugErrorMessage */ .s)("yieldWrapGet"));
}
/**
 * Note: this is an experimental feature made available to allow custom matchers in tests, not to be directly used yet in user code
 *
 * @since 3.1.1
 * @status experimental
 * @category modifiers
 */
const structuralRegionState = /*#__PURE__*/(0,_GlobalValue_js__WEBPACK_IMPORTED_MODULE_2__/* .globalValue */ .K)("effect/Utils/isStructuralRegion", () => ({
  enabled: false,
  tester: undefined
}));
/**
 * Note: this is an experimental feature made available to allow custom matchers in tests, not to be directly used yet in user code
 *
 * @since 3.1.1
 * @status experimental
 * @category modifiers
 */
const structuralRegion = (body, tester) => {
  const current = structuralRegionState.enabled;
  const currentTester = structuralRegionState.tester;
  structuralRegionState.enabled = true;
  if (tester) {
    structuralRegionState.tester = tester;
  }
  try {
    return body();
  } finally {
    structuralRegionState.enabled = current;
    structuralRegionState.tester = currentTester;
  }
};
const standard = {
  effect_internal_function: body => {
    return body();
  }
};
const forced = {
  effect_internal_function: body => {
    try {
      return body();
    } finally {
      //
    }
  }
};
const isNotOptimizedAway = /*#__PURE__*/standard.effect_internal_function(() => new Error().stack)?.includes("effect_internal_function") === true;
/**
 * @since 3.2.2
 * @status experimental
 * @category tracing
 */
const internalCall = isNotOptimizedAway ? standard.effect_internal_function : forced.effect_internal_function;
const genConstructor = function* () {}.constructor;
/**
 * @since 3.11.0
 */
const isGeneratorFunction = u => isObject(u) && u.constructor === genConstructor;
//# sourceMappingURL=Utils.js.map

/***/ }),

/***/ 96850:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E6": function() { return /* binding */ makeEntry; },
/* harmony export */   "Hb": function() { return /* binding */ par; },
/* harmony export */   "R5": function() { return /* binding */ isEntry; },
/* harmony export */   "U": function() { return /* binding */ sequentialCollectionToChunk; },
/* harmony export */   "Zr": function() { return /* binding */ single; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "xH": function() { return /* binding */ flatten; }
/* harmony export */ });
/* unused harmony exports seq, MapRequestResolversReducer, mapRequestResolvers, reduce, EntryTypeId, RequestBlockParallelTypeId, parallelCollectionEmpty, parallelCollectionMake, parallelCollectionAdd, parallelCollectionCombine, parallelCollectionIsEmpty, parallelCollectionKeys, parallelCollectionToSequentialCollection, SequentialCollectionTypeId, sequentialCollectionMake, sequentialCollectionCombine, sequentialCollectionIsEmpty, sequentialCollectionKeys */
/* harmony import */ var _Chunk_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14109);
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67492);
/* harmony import */ var _HashMap_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61952);
/* harmony import */ var _List_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16104);
/* harmony import */ var _Option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16749);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71335);







/** @internal */
const empty = {
  _tag: "Empty"
};
/**
 * Combines this collection of blocked requests with the specified collection
 * of blocked requests, in parallel.
 *
 * @internal
 */
const par = (self, that) => ({
  _tag: "Par",
  left: self,
  right: that
});
/**
 * Combines this collection of blocked requests with the specified collection
 * of blocked requests, in sequence.
 *
 * @internal
 */
const seq = (self, that) => ({
  _tag: "Seq",
  left: self,
  right: that
});
/**
 * Constructs a collection of blocked requests from the specified blocked
 * request and data source.
 *
 * @internal
 */
const single = (dataSource, blockedRequest) => ({
  _tag: "Single",
  dataSource: dataSource,
  blockedRequest
});
/** @internal */
const MapRequestResolversReducer = f => ({
  emptyCase: () => empty,
  parCase: (left, right) => par(left, right),
  seqCase: (left, right) => seq(left, right),
  singleCase: (dataSource, blockedRequest) => single(f(dataSource), blockedRequest)
});
/**
 * Transforms all data sources with the specified data source aspect, which
 * can change the environment type of data sources but must preserve the
 * request type of each data source.
 *
 * @internal
 */
const mapRequestResolvers = (self, f) => reduce(self, MapRequestResolversReducer(f));
/**
 * Folds over the cases of this collection of blocked requests with the
 * specified functions.
 *
 * @internal
 */
const reduce = (self, reducer) => {
  let input = List.of(self);
  let output = List.empty();
  while (List.isCons(input)) {
    const current = input.head;
    switch (current._tag) {
      case "Empty":
        {
          output = List.cons(Either.right(reducer.emptyCase()), output);
          input = input.tail;
          break;
        }
      case "Par":
        {
          output = List.cons(Either.left({
            _tag: "ParCase"
          }), output);
          input = List.cons(current.left, List.cons(current.right, input.tail));
          break;
        }
      case "Seq":
        {
          output = List.cons(Either.left({
            _tag: "SeqCase"
          }), output);
          input = List.cons(current.left, List.cons(current.right, input.tail));
          break;
        }
      case "Single":
        {
          const result = reducer.singleCase(current.dataSource, current.blockedRequest);
          output = List.cons(Either.right(result), output);
          input = input.tail;
          break;
        }
    }
  }
  const result = List.reduce(output, List.empty(), (acc, current) => {
    switch (current._tag) {
      case "Left":
        {
          const left = List.unsafeHead(acc);
          const right = List.unsafeHead(List.unsafeTail(acc));
          const tail = List.unsafeTail(List.unsafeTail(acc));
          switch (current.left._tag) {
            case "ParCase":
              {
                return List.cons(reducer.parCase(left, right), tail);
              }
            case "SeqCase":
              {
                return List.cons(reducer.seqCase(left, right), tail);
              }
          }
        }
      case "Right":
        {
          return List.cons(current.right, acc);
        }
    }
  });
  if (List.isNil(result)) {
    throw new Error("BUG: BlockedRequests.reduce - please report an issue at https://github.com/Effect-TS/effect/issues");
  }
  return result.head;
};
/**
 * Flattens a collection of blocked requests into a collection of pipelined
 * and batched requests that can be submitted for execution.
 *
 * @internal
 */
const flatten = self => {
  let current = _List_js__WEBPACK_IMPORTED_MODULE_0__.of(self);
  let updated = _List_js__WEBPACK_IMPORTED_MODULE_0__/* .empty */ .cS();
  // eslint-disable-next-line no-constant-condition
  while (1) {
    const [parallel, sequential] = _List_js__WEBPACK_IMPORTED_MODULE_0__/* .reduce */ .u4(current, [parallelCollectionEmpty(), _List_js__WEBPACK_IMPORTED_MODULE_0__/* .empty */ .cS()], ([parallel, sequential], blockedRequest) => {
      const [par, seq] = step(blockedRequest);
      return [parallelCollectionCombine(parallel, par), _List_js__WEBPACK_IMPORTED_MODULE_0__/* .appendAll */ .oq(sequential, seq)];
    });
    updated = merge(updated, parallel);
    if (_List_js__WEBPACK_IMPORTED_MODULE_0__/* .isNil */ .kK(sequential)) {
      return _List_js__WEBPACK_IMPORTED_MODULE_0__/* .reverse */ .GY(updated);
    }
    current = sequential;
  }
  throw new Error("BUG: BlockedRequests.flatten - please report an issue at https://github.com/Effect-TS/effect/issues");
};
/**
 * Takes one step in evaluating a collection of blocked requests, returning a
 * collection of blocked requests that can be performed in parallel and a list
 * of blocked requests that must be performed sequentially after those
 * requests.
 */
const step = requests => {
  let current = requests;
  let parallel = parallelCollectionEmpty();
  let stack = _List_js__WEBPACK_IMPORTED_MODULE_0__/* .empty */ .cS();
  let sequential = _List_js__WEBPACK_IMPORTED_MODULE_0__/* .empty */ .cS();
  // eslint-disable-next-line no-constant-condition
  while (1) {
    switch (current._tag) {
      case "Empty":
        {
          if (_List_js__WEBPACK_IMPORTED_MODULE_0__/* .isNil */ .kK(stack)) {
            return [parallel, sequential];
          }
          current = stack.head;
          stack = stack.tail;
          break;
        }
      case "Par":
        {
          stack = _List_js__WEBPACK_IMPORTED_MODULE_0__/* .cons */ .QI(current.right, stack);
          current = current.left;
          break;
        }
      case "Seq":
        {
          const left = current.left;
          const right = current.right;
          switch (left._tag) {
            case "Empty":
              {
                current = right;
                break;
              }
            case "Par":
              {
                const l = left.left;
                const r = left.right;
                current = par(seq(l, right), seq(r, right));
                break;
              }
            case "Seq":
              {
                const l = left.left;
                const r = left.right;
                current = seq(l, seq(r, right));
                break;
              }
            case "Single":
              {
                current = left;
                sequential = _List_js__WEBPACK_IMPORTED_MODULE_0__/* .cons */ .QI(right, sequential);
                break;
              }
          }
          break;
        }
      case "Single":
        {
          parallel = parallelCollectionAdd(parallel, current);
          if (_List_js__WEBPACK_IMPORTED_MODULE_0__/* .isNil */ .kK(stack)) {
            return [parallel, sequential];
          }
          current = stack.head;
          stack = stack.tail;
          break;
        }
    }
  }
  throw new Error("BUG: BlockedRequests.step - please report an issue at https://github.com/Effect-TS/effect/issues");
};
/**
 * Merges a collection of requests that must be executed sequentially with a
 * collection of requests that can be executed in parallel. If the collections
 * are both from the same single data source then the requests can be
 * pipelined while preserving ordering guarantees.
 */
const merge = (sequential, parallel) => {
  if (_List_js__WEBPACK_IMPORTED_MODULE_0__/* .isNil */ .kK(sequential)) {
    return _List_js__WEBPACK_IMPORTED_MODULE_0__.of(parallelCollectionToSequentialCollection(parallel));
  }
  if (parallelCollectionIsEmpty(parallel)) {
    return sequential;
  }
  const seqHeadKeys = sequentialCollectionKeys(sequential.head);
  const parKeys = parallelCollectionKeys(parallel);
  if (seqHeadKeys.length === 1 && parKeys.length === 1 && _Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS(seqHeadKeys[0], parKeys[0])) {
    return _List_js__WEBPACK_IMPORTED_MODULE_0__/* .cons */ .QI(sequentialCollectionCombine(sequential.head, parallelCollectionToSequentialCollection(parallel)), sequential.tail);
  }
  return _List_js__WEBPACK_IMPORTED_MODULE_0__/* .cons */ .QI(parallelCollectionToSequentialCollection(parallel), sequential);
};
//
// circular
//
/** @internal */
const EntryTypeId = /*#__PURE__*/Symbol.for("effect/RequestBlock/Entry");
/** @internal */
class EntryImpl {
  request;
  result;
  listeners;
  ownerId;
  state;
  [EntryTypeId] = blockedRequestVariance;
  constructor(request, result, listeners, ownerId, state) {
    this.request = request;
    this.result = result;
    this.listeners = listeners;
    this.ownerId = ownerId;
    this.state = state;
  }
}
const blockedRequestVariance = {
  /* c8 ignore next */
  _R: _ => _
};
/** @internal */
const isEntry = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_2__/* .hasProperty */ .l$)(u, EntryTypeId);
/** @internal */
const makeEntry = options => new EntryImpl(options.request, options.result, options.listeners, options.ownerId, options.state);
/** @internal */
const RequestBlockParallelTypeId = /*#__PURE__*/Symbol.for("effect/RequestBlock/RequestBlockParallel");
const parallelVariance = {
  /* c8 ignore next */
  _R: _ => _
};
class ParallelImpl {
  map;
  [RequestBlockParallelTypeId] = parallelVariance;
  constructor(map) {
    this.map = map;
  }
}
/** @internal */
const parallelCollectionEmpty = () => new ParallelImpl(_HashMap_js__WEBPACK_IMPORTED_MODULE_3__/* .empty */ .cS());
/** @internal */
const parallelCollectionMake = (dataSource, blockedRequest) => new ParallelImpl(HashMap.make([dataSource, Chunk.of(blockedRequest)]));
/** @internal */
const parallelCollectionAdd = (self, blockedRequest) => new ParallelImpl(_HashMap_js__WEBPACK_IMPORTED_MODULE_3__/* .modifyAt */ .cq(self.map, blockedRequest.dataSource, _ => _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .orElseSome */ .Cc(_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .map */ .UI(_, _Chunk_js__WEBPACK_IMPORTED_MODULE_5__/* .append */ .R3(blockedRequest.blockedRequest)), () => _Chunk_js__WEBPACK_IMPORTED_MODULE_5__.of(blockedRequest.blockedRequest))));
/** @internal */
const parallelCollectionCombine = (self, that) => new ParallelImpl(_HashMap_js__WEBPACK_IMPORTED_MODULE_3__/* .reduce */ .u4(self.map, that.map, (map, value, key) => _HashMap_js__WEBPACK_IMPORTED_MODULE_3__/* .set */ .t8(map, key, _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .match */ .EQ(_HashMap_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(map, key), {
  onNone: () => value,
  onSome: other => _Chunk_js__WEBPACK_IMPORTED_MODULE_5__/* .appendAll */ .oq(value, other)
}))));
/** @internal */
const parallelCollectionIsEmpty = self => _HashMap_js__WEBPACK_IMPORTED_MODULE_3__/* .isEmpty */ .xb(self.map);
/** @internal */
const parallelCollectionKeys = self => Array.from(_HashMap_js__WEBPACK_IMPORTED_MODULE_3__/* .keys */ .XP(self.map));
/** @internal */
const parallelCollectionToSequentialCollection = self => sequentialCollectionMake(_HashMap_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(self.map, x => _Chunk_js__WEBPACK_IMPORTED_MODULE_5__.of(x)));
// TODO
// /** @internal */
// export const parallelCollectionToChunk = <R>(
//   self: ParallelCollection<R>
// ): Array<[RequestResolver.RequestResolver<unknown, R>, Array<Request.Entry<unknown>>]> => Array.from(self.map) as any
/** @internal */
const SequentialCollectionTypeId = /*#__PURE__*/Symbol.for("effect/RequestBlock/RequestBlockSequential");
const sequentialVariance = {
  /* c8 ignore next */
  _R: _ => _
};
class SequentialImpl {
  map;
  [SequentialCollectionTypeId] = sequentialVariance;
  constructor(map) {
    this.map = map;
  }
}
/** @internal */
const sequentialCollectionMake = map => new SequentialImpl(map);
/** @internal */
const sequentialCollectionCombine = (self, that) => new SequentialImpl(_HashMap_js__WEBPACK_IMPORTED_MODULE_3__/* .reduce */ .u4(that.map, self.map, (map, value, key) => _HashMap_js__WEBPACK_IMPORTED_MODULE_3__/* .set */ .t8(map, key, _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .match */ .EQ(_HashMap_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(map, key), {
  onNone: () => _Chunk_js__WEBPACK_IMPORTED_MODULE_5__/* .empty */ .cS(),
  onSome: a => _Chunk_js__WEBPACK_IMPORTED_MODULE_5__/* .appendAll */ .oq(a, value)
}))));
/** @internal */
const sequentialCollectionIsEmpty = self => HashMap.isEmpty(self.map);
/** @internal */
const sequentialCollectionKeys = self => Array.from(_HashMap_js__WEBPACK_IMPORTED_MODULE_3__/* .keys */ .XP(self.map));
/** @internal */
const sequentialCollectionToChunk = self => Array.from(self.map);
//# sourceMappingURL=blockedRequests.js.map

/***/ }),

/***/ 69579:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gt": function() { return /* binding */ CauseTypeId; },
  "Po": function() { return /* binding */ andThen; },
  "as": function() { return /* binding */ as; },
  "r3": function() { return /* binding */ contains; },
  "B4": function() { return /* binding */ defects; },
  "Xr": function() { return /* binding */ die; },
  "q9": function() { return /* binding */ dieOption; },
  "jH": function() { return /* binding */ electFailures; },
  "cS": function() { return /* binding */ empty; },
  "bG": function() { return /* binding */ fail; },
  "Iv": function() { return /* binding */ failureOption; },
  "hl": function() { return /* binding */ failureOrCause; },
  "mq": function() { return /* binding */ failures; },
  "hX": function() { return /* binding */ filter; },
  "sE": function() { return /* binding */ find; },
  "VS": function() { return /* binding */ flatMap; },
  "xH": function() { return /* binding */ flatten; },
  "kR": function() { return /* binding */ flipCauseOption; },
  "e1": function() { return /* binding */ interrupt; },
  "$A": function() { return /* binding */ interruptOption; },
  "l7": function() { return /* binding */ interruptors; },
  "m_": function() { return /* binding */ isCause; },
  "Ux": function() { return /* binding */ isDie; },
  "QV": function() { return /* binding */ isDieType; },
  "xb": function() { return /* binding */ isEmpty; },
  "tg": function() { return /* binding */ isEmptyType; },
  "DA": function() { return /* binding */ isFailType; },
  "hx": function() { return /* binding */ isFailure; },
  "cb": function() { return /* binding */ isInterruptType; },
  "td": function() { return /* binding */ isInterrupted; },
  "Jq": function() { return /* binding */ isInterruptedOnly; },
  "v2": function() { return /* binding */ isParallelType; },
  "F8": function() { return /* binding */ isSequentialType; },
  "tE": function() { return /* binding */ keepDefects; },
  "EI": function() { return /* binding */ keepDefectsAndElectFailures; },
  "Kk": function() { return /* binding */ linearize; },
  "UI": function() { return /* binding */ map; },
  "EQ": function() { return /* binding */ match; },
  "Mf": function() { return /* binding */ parallel; },
  "IC": function() { return /* binding */ pretty; },
  "Z3": function() { return /* binding */ prettyErrorMessage; },
  "sD": function() { return /* binding */ prettyErrors; },
  "u4": function() { return /* binding */ reduce; },
  "g3": function() { return /* binding */ reduceWithContext; },
  "Pe": function() { return /* binding */ sequential; },
  "dp": function() { return /* binding */ size; },
  "SC": function() { return /* binding */ spanSymbol; },
  "Vu": function() { return /* binding */ spanToTrace; },
  "ly": function() { return /* binding */ stripFailures; },
  "VO": function() { return /* binding */ stripSomeDefects; }
});

// UNUSED EXPORTS: PrettyError

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Array.js + 2 modules
var esm_Array = __webpack_require__(37901);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Chunk.js
var Chunk = __webpack_require__(14109);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Either.js
var Either = __webpack_require__(87585);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equal.js
var Equal = __webpack_require__(67492);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/GlobalValue.js
var GlobalValue = __webpack_require__(4726);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Hash.js
var Hash = __webpack_require__(89379);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/HashSet.js
var HashSet = __webpack_require__(9551);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Inspectable.js
var Inspectable = __webpack_require__(16371);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Pipeable.js
var Pipeable = __webpack_require__(92817);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var Predicate = __webpack_require__(71335);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/errors.js
var errors = __webpack_require__(3910);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/opCodes/cause.js
/** @internal */
const OP_DIE = "Die";
/** @internal */
const OP_EMPTY = "Empty";
/** @internal */
const OP_FAIL = "Fail";
/** @internal */
const OP_INTERRUPT = "Interrupt";
/** @internal */
const OP_PARALLEL = "Parallel";
/** @internal */
const OP_SEQUENTIAL = "Sequential";
//# sourceMappingURL=cause.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/cause.js














// -----------------------------------------------------------------------------
// Models
// -----------------------------------------------------------------------------
/** @internal */
const CauseSymbolKey = "effect/Cause";
/** @internal */
const CauseTypeId = /*#__PURE__*/Symbol.for(CauseSymbolKey);
const variance = {
  /* c8 ignore next */
  _E: _ => _
};
/** @internal */
const proto = {
  [CauseTypeId]: variance,
  [Hash/* symbol */.NA]() {
    return (0,Function/* pipe */.zG)(Hash/* hash */.vp(CauseSymbolKey), Hash/* combine */.$e(Hash/* hash */.vp(flattenCause(this))), Hash/* cached */.HX(this));
  },
  [Equal/* symbol */.NA](that) {
    return isCause(that) && causeEquals(this, that);
  },
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  },
  toJSON() {
    switch (this._tag) {
      case "Empty":
        return {
          _id: "Cause",
          _tag: this._tag
        };
      case "Die":
        return {
          _id: "Cause",
          _tag: this._tag,
          defect: (0,Inspectable/* toJSON */.au)(this.defect)
        };
      case "Interrupt":
        return {
          _id: "Cause",
          _tag: this._tag,
          fiberId: this.fiberId.toJSON()
        };
      case "Fail":
        return {
          _id: "Cause",
          _tag: this._tag,
          failure: (0,Inspectable/* toJSON */.au)(this.error)
        };
      case "Sequential":
      case "Parallel":
        return {
          _id: "Cause",
          _tag: this._tag,
          left: (0,Inspectable/* toJSON */.au)(this.left),
          right: (0,Inspectable/* toJSON */.au)(this.right)
        };
    }
  },
  toString() {
    return pretty(this);
  },
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return this.toJSON();
  }
};
// -----------------------------------------------------------------------------
// Constructors
// -----------------------------------------------------------------------------
/** @internal */
const empty = /*#__PURE__*/(() => {
  const o = /*#__PURE__*/Object.create(proto);
  o._tag = OP_EMPTY;
  return o;
})();
/** @internal */
const fail = error => {
  const o = Object.create(proto);
  o._tag = OP_FAIL;
  o.error = error;
  return o;
};
/** @internal */
const die = defect => {
  const o = Object.create(proto);
  o._tag = OP_DIE;
  o.defect = defect;
  return o;
};
/** @internal */
const interrupt = fiberId => {
  const o = Object.create(proto);
  o._tag = OP_INTERRUPT;
  o.fiberId = fiberId;
  return o;
};
/** @internal */
const parallel = (left, right) => {
  const o = Object.create(proto);
  o._tag = OP_PARALLEL;
  o.left = left;
  o.right = right;
  return o;
};
/** @internal */
const sequential = (left, right) => {
  const o = Object.create(proto);
  o._tag = OP_SEQUENTIAL;
  o.left = left;
  o.right = right;
  return o;
};
// -----------------------------------------------------------------------------
// Refinements
// -----------------------------------------------------------------------------
/** @internal */
const isCause = u => (0,Predicate/* hasProperty */.l$)(u, CauseTypeId);
/** @internal */
const isEmptyType = self => self._tag === OP_EMPTY;
/** @internal */
const isFailType = self => self._tag === OP_FAIL;
/** @internal */
const isDieType = self => self._tag === OP_DIE;
/** @internal */
const isInterruptType = self => self._tag === OP_INTERRUPT;
/** @internal */
const isSequentialType = self => self._tag === OP_SEQUENTIAL;
/** @internal */
const isParallelType = self => self._tag === OP_PARALLEL;
// -----------------------------------------------------------------------------
// Getters
// -----------------------------------------------------------------------------
/** @internal */
const size = self => reduceWithContext(self, void 0, SizeCauseReducer);
/** @internal */
const isEmpty = self => {
  if (self._tag === OP_EMPTY) {
    return true;
  }
  return reduce(self, true, (acc, cause) => {
    switch (cause._tag) {
      case OP_EMPTY:
        {
          return Option/* some */.G(acc);
        }
      case OP_DIE:
      case OP_FAIL:
      case OP_INTERRUPT:
        {
          return Option/* some */.G(false);
        }
      default:
        {
          return Option/* none */.YP();
        }
    }
  });
};
/** @internal */
const isFailure = self => Option/* isSome */.pC(failureOption(self));
/** @internal */
const isDie = self => Option/* isSome */.pC(dieOption(self));
/** @internal */
const isInterrupted = self => Option/* isSome */.pC(interruptOption(self));
/** @internal */
const isInterruptedOnly = self => reduceWithContext(undefined, IsInterruptedOnlyCauseReducer)(self);
/** @internal */
const failures = self => Chunk/* reverse */.GY(reduce(self, Chunk/* empty */.cS(), (list, cause) => cause._tag === OP_FAIL ? Option/* some */.G((0,Function/* pipe */.zG)(list, Chunk/* prepend */.Ce(cause.error))) : Option/* none */.YP()));
/** @internal */
const defects = self => Chunk/* reverse */.GY(reduce(self, Chunk/* empty */.cS(), (list, cause) => cause._tag === OP_DIE ? Option/* some */.G((0,Function/* pipe */.zG)(list, Chunk/* prepend */.Ce(cause.defect))) : Option/* none */.YP()));
/** @internal */
const interruptors = self => reduce(self, HashSet/* empty */.cS(), (set, cause) => cause._tag === OP_INTERRUPT ? Option/* some */.G((0,Function/* pipe */.zG)(set, HashSet/* add */.IH(cause.fiberId))) : Option/* none */.YP());
/** @internal */
const failureOption = self => find(self, cause => cause._tag === OP_FAIL ? Option/* some */.G(cause.error) : Option/* none */.YP());
/** @internal */
const failureOrCause = self => {
  const option = failureOption(self);
  switch (option._tag) {
    case "None":
      {
        // no `E` inside this `Cause`, so it can be safely cast to `never`
        return Either/* right */.F2(self);
      }
    case "Some":
      {
        return Either/* left */.t$(option.value);
      }
  }
};
/** @internal */
const dieOption = self => find(self, cause => cause._tag === OP_DIE ? Option/* some */.G(cause.defect) : Option/* none */.YP());
/** @internal */
const flipCauseOption = self => match(self, {
  onEmpty: Option/* some */.G(empty),
  onFail: Option/* map */.UI(fail),
  onDie: defect => Option/* some */.G(die(defect)),
  onInterrupt: fiberId => Option/* some */.G(interrupt(fiberId)),
  onSequential: Option/* mergeWith */.bT(sequential),
  onParallel: Option/* mergeWith */.bT(parallel)
});
/** @internal */
const interruptOption = self => find(self, cause => cause._tag === OP_INTERRUPT ? Option/* some */.G(cause.fiberId) : Option/* none */.YP());
/** @internal */
const keepDefects = self => match(self, {
  onEmpty: Option/* none */.YP(),
  onFail: () => Option/* none */.YP(),
  onDie: defect => Option/* some */.G(die(defect)),
  onInterrupt: () => Option/* none */.YP(),
  onSequential: Option/* mergeWith */.bT(sequential),
  onParallel: Option/* mergeWith */.bT(parallel)
});
/** @internal */
const keepDefectsAndElectFailures = self => match(self, {
  onEmpty: Option/* none */.YP(),
  onFail: failure => Option/* some */.G(die(failure)),
  onDie: defect => Option/* some */.G(die(defect)),
  onInterrupt: () => Option/* none */.YP(),
  onSequential: Option/* mergeWith */.bT(sequential),
  onParallel: Option/* mergeWith */.bT(parallel)
});
/** @internal */
const linearize = self => match(self, {
  onEmpty: HashSet/* empty */.cS(),
  onFail: error => HashSet/* make */.Sy(fail(error)),
  onDie: defect => HashSet/* make */.Sy(die(defect)),
  onInterrupt: fiberId => HashSet/* make */.Sy(interrupt(fiberId)),
  onSequential: (leftSet, rightSet) => HashSet/* flatMap */.VS(leftSet, leftCause => HashSet/* map */.UI(rightSet, rightCause => sequential(leftCause, rightCause))),
  onParallel: (leftSet, rightSet) => HashSet/* flatMap */.VS(leftSet, leftCause => HashSet/* map */.UI(rightSet, rightCause => parallel(leftCause, rightCause)))
});
/** @internal */
const stripFailures = self => match(self, {
  onEmpty: empty,
  onFail: () => empty,
  onDie: die,
  onInterrupt: interrupt,
  onSequential: sequential,
  onParallel: parallel
});
/** @internal */
const electFailures = self => match(self, {
  onEmpty: empty,
  onFail: die,
  onDie: die,
  onInterrupt: interrupt,
  onSequential: sequential,
  onParallel: parallel
});
/** @internal */
const stripSomeDefects = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, pf) => match(self, {
  onEmpty: Option/* some */.G(empty),
  onFail: error => Option/* some */.G(fail(error)),
  onDie: defect => {
    const option = pf(defect);
    return Option/* isSome */.pC(option) ? Option/* none */.YP() : Option/* some */.G(die(defect));
  },
  onInterrupt: fiberId => Option/* some */.G(interrupt(fiberId)),
  onSequential: Option/* mergeWith */.bT(sequential),
  onParallel: Option/* mergeWith */.bT(parallel)
}));
// -----------------------------------------------------------------------------
// Mapping
// -----------------------------------------------------------------------------
/** @internal */
const as = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, error) => map(self, () => error));
/** @internal */
const map = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => flatMap(self, e => fail(f(e))));
// -----------------------------------------------------------------------------
// Sequencing
// -----------------------------------------------------------------------------
/** @internal */
const flatMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => match(self, {
  onEmpty: empty,
  onFail: error => f(error),
  onDie: defect => die(defect),
  onInterrupt: fiberId => interrupt(fiberId),
  onSequential: (left, right) => sequential(left, right),
  onParallel: (left, right) => parallel(left, right)
}));
/** @internal */
const flatten = self => flatMap(self, Function/* identity */.yR);
/** @internal */
const andThen = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => (0,Predicate/* isFunction */.mf)(f) ? flatMap(self, f) : flatMap(self, () => f));
// -----------------------------------------------------------------------------
// Equality
// -----------------------------------------------------------------------------
/** @internal */
const contains = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => {
  if (that._tag === OP_EMPTY || self === that) {
    return true;
  }
  return reduce(self, false, (accumulator, cause) => {
    return Option/* some */.G(accumulator || causeEquals(cause, that));
  });
});
/** @internal */
const causeEquals = (left, right) => {
  let leftStack = Chunk.of(left);
  let rightStack = Chunk.of(right);
  while (Chunk/* isNonEmpty */.Od(leftStack) && Chunk/* isNonEmpty */.Od(rightStack)) {
    const [leftParallel, leftSequential] = (0,Function/* pipe */.zG)(Chunk/* headNonEmpty */.dK(leftStack), reduce([HashSet/* empty */.cS(), Chunk/* empty */.cS()], ([parallel, sequential], cause) => {
      const [par, seq] = evaluateCause(cause);
      return Option/* some */.G([(0,Function/* pipe */.zG)(parallel, HashSet/* union */.G0(par)), (0,Function/* pipe */.zG)(sequential, Chunk/* appendAll */.oq(seq))]);
    }));
    const [rightParallel, rightSequential] = (0,Function/* pipe */.zG)(Chunk/* headNonEmpty */.dK(rightStack), reduce([HashSet/* empty */.cS(), Chunk/* empty */.cS()], ([parallel, sequential], cause) => {
      const [par, seq] = evaluateCause(cause);
      return Option/* some */.G([(0,Function/* pipe */.zG)(parallel, HashSet/* union */.G0(par)), (0,Function/* pipe */.zG)(sequential, Chunk/* appendAll */.oq(seq))]);
    }));
    if (!Equal/* equals */.fS(leftParallel, rightParallel)) {
      return false;
    }
    leftStack = leftSequential;
    rightStack = rightSequential;
  }
  return true;
};
// -----------------------------------------------------------------------------
// Flattening
// -----------------------------------------------------------------------------
/**
 * Flattens a cause to a sequence of sets of causes, where each set represents
 * causes that fail in parallel and sequential sets represent causes that fail
 * after each other.
 *
 * @internal
 */
const flattenCause = cause => {
  return flattenCauseLoop(Chunk.of(cause), Chunk/* empty */.cS());
};
/** @internal */
const flattenCauseLoop = (causes, flattened) => {
  // eslint-disable-next-line no-constant-condition
  while (1) {
    const [parallel, sequential] = (0,Function/* pipe */.zG)(causes, esm_Array/* reduce */.u4([HashSet/* empty */.cS(), Chunk/* empty */.cS()], ([parallel, sequential], cause) => {
      const [par, seq] = evaluateCause(cause);
      return [(0,Function/* pipe */.zG)(parallel, HashSet/* union */.G0(par)), (0,Function/* pipe */.zG)(sequential, Chunk/* appendAll */.oq(seq))];
    }));
    const updated = HashSet/* size */.dp(parallel) > 0 ? (0,Function/* pipe */.zG)(flattened, Chunk/* prepend */.Ce(parallel)) : flattened;
    if (Chunk/* isEmpty */.xb(sequential)) {
      return Chunk/* reverse */.GY(updated);
    }
    causes = sequential;
    flattened = updated;
  }
  throw new Error((0,errors/* getBugErrorMessage */.s)("Cause.flattenCauseLoop"));
};
// -----------------------------------------------------------------------------
// Finding
// -----------------------------------------------------------------------------
/** @internal */
const find = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, pf) => {
  const stack = [self];
  while (stack.length > 0) {
    const item = stack.pop();
    const option = pf(item);
    switch (option._tag) {
      case "None":
        {
          switch (item._tag) {
            case OP_SEQUENTIAL:
            case OP_PARALLEL:
              {
                stack.push(item.right);
                stack.push(item.left);
                break;
              }
          }
          break;
        }
      case "Some":
        {
          return option;
        }
    }
  }
  return Option/* none */.YP();
});
// -----------------------------------------------------------------------------
// Filtering
// -----------------------------------------------------------------------------
/** @internal */
const filter = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, predicate) => reduceWithContext(self, void 0, FilterCauseReducer(predicate)));
// -----------------------------------------------------------------------------
// Evaluation
// -----------------------------------------------------------------------------
/**
 * Takes one step in evaluating a cause, returning a set of causes that fail
 * in parallel and a list of causes that fail sequentially after those causes.
 *
 * @internal
 */
const evaluateCause = self => {
  let cause = self;
  const stack = [];
  let _parallel = HashSet/* empty */.cS();
  let _sequential = Chunk/* empty */.cS();
  while (cause !== undefined) {
    switch (cause._tag) {
      case OP_EMPTY:
        {
          if (stack.length === 0) {
            return [_parallel, _sequential];
          }
          cause = stack.pop();
          break;
        }
      case OP_FAIL:
        {
          _parallel = HashSet/* add */.IH(_parallel, Chunk/* make */.Sy(cause._tag, cause.error));
          if (stack.length === 0) {
            return [_parallel, _sequential];
          }
          cause = stack.pop();
          break;
        }
      case OP_DIE:
        {
          _parallel = HashSet/* add */.IH(_parallel, Chunk/* make */.Sy(cause._tag, cause.defect));
          if (stack.length === 0) {
            return [_parallel, _sequential];
          }
          cause = stack.pop();
          break;
        }
      case OP_INTERRUPT:
        {
          _parallel = HashSet/* add */.IH(_parallel, Chunk/* make */.Sy(cause._tag, cause.fiberId));
          if (stack.length === 0) {
            return [_parallel, _sequential];
          }
          cause = stack.pop();
          break;
        }
      case OP_SEQUENTIAL:
        {
          switch (cause.left._tag) {
            case OP_EMPTY:
              {
                cause = cause.right;
                break;
              }
            case OP_SEQUENTIAL:
              {
                cause = sequential(cause.left.left, sequential(cause.left.right, cause.right));
                break;
              }
            case OP_PARALLEL:
              {
                cause = parallel(sequential(cause.left.left, cause.right), sequential(cause.left.right, cause.right));
                break;
              }
            default:
              {
                _sequential = Chunk/* prepend */.Ce(_sequential, cause.right);
                cause = cause.left;
                break;
              }
          }
          break;
        }
      case OP_PARALLEL:
        {
          stack.push(cause.right);
          cause = cause.left;
          break;
        }
    }
  }
  throw new Error((0,errors/* getBugErrorMessage */.s)("Cause.evaluateCauseLoop"));
};
// -----------------------------------------------------------------------------
// Reducing
// -----------------------------------------------------------------------------
/** @internal */
const SizeCauseReducer = {
  emptyCase: () => 0,
  failCase: () => 1,
  dieCase: () => 1,
  interruptCase: () => 1,
  sequentialCase: (_, left, right) => left + right,
  parallelCase: (_, left, right) => left + right
};
/** @internal */
const IsInterruptedOnlyCauseReducer = {
  emptyCase: Function/* constTrue */.W8,
  failCase: Function/* constFalse */.jv,
  dieCase: Function/* constFalse */.jv,
  interruptCase: Function/* constTrue */.W8,
  sequentialCase: (_, left, right) => left && right,
  parallelCase: (_, left, right) => left && right
};
/** @internal */
const FilterCauseReducer = predicate => ({
  emptyCase: () => empty,
  failCase: (_, error) => fail(error),
  dieCase: (_, defect) => die(defect),
  interruptCase: (_, fiberId) => interrupt(fiberId),
  sequentialCase: (_, left, right) => {
    if (predicate(left)) {
      if (predicate(right)) {
        return sequential(left, right);
      }
      return left;
    }
    if (predicate(right)) {
      return right;
    }
    return empty;
  },
  parallelCase: (_, left, right) => {
    if (predicate(left)) {
      if (predicate(right)) {
        return parallel(left, right);
      }
      return left;
    }
    if (predicate(right)) {
      return right;
    }
    return empty;
  }
});
const OP_SEQUENTIAL_CASE = "SequentialCase";
const OP_PARALLEL_CASE = "ParallelCase";
/** @internal */
const match = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, {
  onDie,
  onEmpty,
  onFail,
  onInterrupt,
  onParallel,
  onSequential
}) => {
  return reduceWithContext(self, void 0, {
    emptyCase: () => onEmpty,
    failCase: (_, error) => onFail(error),
    dieCase: (_, defect) => onDie(defect),
    interruptCase: (_, fiberId) => onInterrupt(fiberId),
    sequentialCase: (_, left, right) => onSequential(left, right),
    parallelCase: (_, left, right) => onParallel(left, right)
  });
});
/** @internal */
const reduce = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, zero, pf) => {
  let accumulator = zero;
  let cause = self;
  const causes = [];
  while (cause !== undefined) {
    const option = pf(accumulator, cause);
    accumulator = Option/* isSome */.pC(option) ? option.value : accumulator;
    switch (cause._tag) {
      case OP_SEQUENTIAL:
        {
          causes.push(cause.right);
          cause = cause.left;
          break;
        }
      case OP_PARALLEL:
        {
          causes.push(cause.right);
          cause = cause.left;
          break;
        }
      default:
        {
          cause = undefined;
          break;
        }
    }
    if (cause === undefined && causes.length > 0) {
      cause = causes.pop();
    }
  }
  return accumulator;
});
/** @internal */
const reduceWithContext = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, context, reducer) => {
  const input = [self];
  const output = [];
  while (input.length > 0) {
    const cause = input.pop();
    switch (cause._tag) {
      case OP_EMPTY:
        {
          output.push(Either/* right */.F2(reducer.emptyCase(context)));
          break;
        }
      case OP_FAIL:
        {
          output.push(Either/* right */.F2(reducer.failCase(context, cause.error)));
          break;
        }
      case OP_DIE:
        {
          output.push(Either/* right */.F2(reducer.dieCase(context, cause.defect)));
          break;
        }
      case OP_INTERRUPT:
        {
          output.push(Either/* right */.F2(reducer.interruptCase(context, cause.fiberId)));
          break;
        }
      case OP_SEQUENTIAL:
        {
          input.push(cause.right);
          input.push(cause.left);
          output.push(Either/* left */.t$({
            _tag: OP_SEQUENTIAL_CASE
          }));
          break;
        }
      case OP_PARALLEL:
        {
          input.push(cause.right);
          input.push(cause.left);
          output.push(Either/* left */.t$({
            _tag: OP_PARALLEL_CASE
          }));
          break;
        }
    }
  }
  const accumulator = [];
  while (output.length > 0) {
    const either = output.pop();
    switch (either._tag) {
      case "Left":
        {
          switch (either.left._tag) {
            case OP_SEQUENTIAL_CASE:
              {
                const left = accumulator.pop();
                const right = accumulator.pop();
                const value = reducer.sequentialCase(context, left, right);
                accumulator.push(value);
                break;
              }
            case OP_PARALLEL_CASE:
              {
                const left = accumulator.pop();
                const right = accumulator.pop();
                const value = reducer.parallelCase(context, left, right);
                accumulator.push(value);
                break;
              }
          }
          break;
        }
      case "Right":
        {
          accumulator.push(either.right);
          break;
        }
    }
  }
  if (accumulator.length === 0) {
    throw new Error("BUG: Cause.reduceWithContext - please report an issue at https://github.com/Effect-TS/effect/issues");
  }
  return accumulator.pop();
});
// -----------------------------------------------------------------------------
// Pretty Printing
// -----------------------------------------------------------------------------
/** @internal */
const pretty = (cause, options) => {
  if (isInterruptedOnly(cause)) {
    return "All fibers interrupted without errors.";
  }
  return prettyErrors(cause).map(function (e) {
    if (options?.renderErrorCause !== true || e.cause === undefined) {
      return e.stack;
    }
    return `${e.stack} {\n${renderErrorCause(e.cause, "  ")}\n}`;
  }).join("\n");
};
const renderErrorCause = (cause, prefix) => {
  const lines = cause.stack.split("\n");
  let stack = `${prefix}[cause]: ${lines[0]}`;
  for (let i = 1, len = lines.length; i < len; i++) {
    stack += `\n${prefix}${lines[i]}`;
  }
  if (cause.cause) {
    stack += ` {\n${renderErrorCause(cause.cause, `${prefix}  `)}\n${prefix}}`;
  }
  return stack;
};
/** @internal */
class PrettyError extends globalThis.Error {
  span = undefined;
  constructor(originalError) {
    const originalErrorIsObject = typeof originalError === "object" && originalError !== null;
    const prevLimit = Error.stackTraceLimit;
    Error.stackTraceLimit = 1;
    super(prettyErrorMessage(originalError), originalErrorIsObject && "cause" in originalError && typeof originalError.cause !== "undefined" ? {
      cause: new PrettyError(originalError.cause)
    } : undefined);
    if (this.message === "") {
      this.message = "An error has occurred";
    }
    Error.stackTraceLimit = prevLimit;
    this.name = originalError instanceof Error ? originalError.name : "Error";
    if (originalErrorIsObject) {
      if (spanSymbol in originalError) {
        this.span = originalError[spanSymbol];
      }
      Object.keys(originalError).forEach(key => {
        if (!(key in this)) {
          // @ts-expect-error
          this[key] = originalError[key];
        }
      });
    }
    this.stack = prettyErrorStack(`${this.name}: ${this.message}`, originalError instanceof Error && originalError.stack ? originalError.stack : "", this.span);
  }
}
/**
 * A utility function for generating human-readable error messages from a generic error of type `unknown`.
 *
 * Rules:
 *
 * 1) If the input `u` is already a string, it's considered a message.
 * 2) If `u` is an Error instance with a message defined, it uses the message.
 * 3) If `u` has a user-defined `toString()` method, it uses that method.
 * 4) Otherwise, it uses `Inspectable.stringifyCircular` to produce a string representation and uses it as the error message,
 *   with "Error" added as a prefix.
 *
 * @internal
 */
const prettyErrorMessage = u => {
  // 1)
  if (typeof u === "string") {
    return u;
  }
  // 2)
  if (typeof u === "object" && u !== null && u instanceof Error) {
    return u.message;
  }
  // 3)
  try {
    if ((0,Predicate/* hasProperty */.l$)(u, "toString") && (0,Predicate/* isFunction */.mf)(u["toString"]) && u["toString"] !== Object.prototype.toString && u["toString"] !== globalThis.Array.prototype.toString) {
      return u["toString"]();
    }
  } catch {
    // something's off, rollback to json
  }
  // 4)
  return (0,Inspectable/* stringifyCircular */.qk)(u);
};
const locationRegex = /\((.*)\)/g;
/** @internal */
const spanToTrace = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)("effect/Tracer/spanToTrace", () => new WeakMap());
const prettyErrorStack = (message, stack, span) => {
  const out = [message];
  const lines = stack.startsWith(message) ? stack.slice(message.length).split("\n") : stack.split("\n");
  for (let i = 1; i < lines.length; i++) {
    if (lines[i].includes(" at new BaseEffectError") || lines[i].includes(" at new YieldableError")) {
      i++;
      continue;
    }
    if (lines[i].includes("Generator.next")) {
      break;
    }
    if (lines[i].includes("effect_internal_function")) {
      break;
    }
    out.push(lines[i].replace(/at .*effect_instruction_i.*\((.*)\)/, "at $1").replace(/EffectPrimitive\.\w+/, "<anonymous>"));
  }
  if (span) {
    let current = span;
    let i = 0;
    while (current && current._tag === "Span" && i < 10) {
      const stackFn = spanToTrace.get(current);
      if (typeof stackFn === "function") {
        const stack = stackFn();
        if (typeof stack === "string") {
          const locationMatchAll = stack.matchAll(locationRegex);
          let match = false;
          for (const [, location] of locationMatchAll) {
            match = true;
            out.push(`    at ${current.name} (${location})`);
          }
          if (!match) {
            out.push(`    at ${current.name} (${stack.replace(/^at /, "")})`);
          }
        } else {
          out.push(`    at ${current.name}`);
        }
      } else {
        out.push(`    at ${current.name}`);
      }
      current = Option/* getOrUndefined */.jD(current.parent);
      i++;
    }
  }
  return out.join("\n");
};
/** @internal */
const spanSymbol = /*#__PURE__*/Symbol.for("effect/SpanAnnotation");
/** @internal */
const prettyErrors = cause => reduceWithContext(cause, void 0, {
  emptyCase: () => [],
  dieCase: (_, unknownError) => {
    return [new PrettyError(unknownError)];
  },
  failCase: (_, error) => {
    return [new PrettyError(error)];
  },
  interruptCase: () => [],
  parallelCase: (_, l, r) => [...l, ...r],
  sequentialCase: (_, l, r) => [...l, ...r]
});
//# sourceMappingURL=cause.js.map

/***/ }),

/***/ 53318:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GL": function() { return /* binding */ clockTag; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "uh": function() { return /* binding */ ClockTypeId; }
/* harmony export */ });
/* unused harmony exports MAX_TIMER_MILLIS, globalClockScheduler */
/* harmony import */ var _Context_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20591);
/* harmony import */ var _Duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13571);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17316);
/* harmony import */ var _core_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39355);
/* provided dependency */ var process = __webpack_require__(83454);




/** @internal */
const ClockSymbolKey = "effect/Clock";
/** @internal */
const ClockTypeId = /*#__PURE__*/Symbol.for(ClockSymbolKey);
/** @internal */
const clockTag = /*#__PURE__*/_Context_js__WEBPACK_IMPORTED_MODULE_0__/* .GenericTag */ .hV("effect/Clock");
/** @internal */
const MAX_TIMER_MILLIS = 2 ** 31 - 1;
/** @internal */
const globalClockScheduler = {
  unsafeSchedule(task, duration) {
    const millis = _Duration_js__WEBPACK_IMPORTED_MODULE_1__/* .toMillis */ .eq(duration);
    // If the duration is greater than the value allowable by the JS timer
    // functions, treat the value as an infinite duration
    if (millis > MAX_TIMER_MILLIS) {
      return _Function_js__WEBPACK_IMPORTED_MODULE_2__/* .constFalse */ .jv;
    }
    let completed = false;
    const handle = setTimeout(() => {
      completed = true;
      task();
    }, millis);
    return () => {
      clearTimeout(handle);
      return !completed;
    };
  }
};
const performanceNowNanos = /*#__PURE__*/function () {
  const bigint1e6 = /*#__PURE__*/BigInt(1_000_000);
  if (typeof performance === "undefined") {
    return () => BigInt(Date.now()) * bigint1e6;
  }
  let origin;
  return () => {
    if (origin === undefined) {
      origin = BigInt(Date.now()) * bigint1e6 - BigInt(Math.round(performance.now() * 1_000_000));
    }
    return origin + BigInt(Math.round(performance.now() * 1000000));
  };
}();
const processOrPerformanceNow = /*#__PURE__*/function () {
  const processHrtime = typeof process === "object" && "hrtime" in process && typeof process.hrtime.bigint === "function" ? process.hrtime : undefined;
  if (!processHrtime) {
    return performanceNowNanos;
  }
  const origin = /*#__PURE__*/performanceNowNanos() - /*#__PURE__*/processHrtime.bigint();
  return () => origin + processHrtime.bigint();
}();
/** @internal */
class ClockImpl {
  [ClockTypeId] = ClockTypeId;
  unsafeCurrentTimeMillis() {
    return Date.now();
  }
  unsafeCurrentTimeNanos() {
    return processOrPerformanceNow();
  }
  currentTimeMillis = /*#__PURE__*/_core_js__WEBPACK_IMPORTED_MODULE_3__/* .sync */ .Z_X(() => this.unsafeCurrentTimeMillis());
  currentTimeNanos = /*#__PURE__*/_core_js__WEBPACK_IMPORTED_MODULE_3__/* .sync */ .Z_X(() => this.unsafeCurrentTimeNanos());
  scheduler() {
    return _core_js__WEBPACK_IMPORTED_MODULE_3__/* .succeed */ .ng0(globalClockScheduler);
  }
  sleep(duration) {
    return _core_js__WEBPACK_IMPORTED_MODULE_3__/* .async */ .PFx(resume => {
      const canceler = globalClockScheduler.unsafeSchedule(() => resume(_core_js__WEBPACK_IMPORTED_MODULE_3__/* ["void"] */ .Hcj), duration);
      return _core_js__WEBPACK_IMPORTED_MODULE_3__/* .asVoid */ .a2S(_core_js__WEBPACK_IMPORTED_MODULE_3__/* .sync */ .Z_X(canceler));
    });
  }
}
/** @internal */
const make = () => new ClockImpl();
//# sourceMappingURL=clock.js.map

/***/ }),

/***/ 99609:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ currentRequestMap; }
/* harmony export */ });
/* harmony import */ var _GlobalValue_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4726);
/* harmony import */ var _core_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39355);


/** @internal */
const currentRequestMap = /*#__PURE__*/(0,_GlobalValue_js__WEBPACK_IMPORTED_MODULE_0__/* .globalValue */ .K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentRequestMap"), () => (0,_core_js__WEBPACK_IMPORTED_MODULE_1__/* .fiberRefUnsafeMake */ .kgb)(new Map()));
//# sourceMappingURL=completedRequestMap.js.map

/***/ }),

/***/ 54604:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a6": function() { return /* binding */ configProviderTag; },
  "r2": function() { return /* binding */ fromEnv; }
});

// UNUSED EXPORTS: ConfigProviderTypeId, FlatConfigProviderTypeId, constantCase, fromFlat, fromJson, fromMap, kebabCase, lowerCase, make, makeFlat, mapInputPath, nested, orElse, snakeCase, unnested, upperCase, within

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Array.js + 2 modules
var esm_Array = __webpack_require__(37901);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Context.js
var Context = __webpack_require__(20591);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Either.js
var esm_Either = __webpack_require__(87585);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/HashMap.js + 1 modules
var HashMap = __webpack_require__(61952);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/HashSet.js
var esm_HashSet = __webpack_require__(9551);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Number.js
var esm_Number = __webpack_require__(15839);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var esm_Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Pipeable.js
var Pipeable = __webpack_require__(92817);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/RegExp.js
var esm_RegExp = __webpack_require__(7035);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/opCodes/configError.js
/** @internal */
const OP_AND = "And";
/** @internal */
const OP_OR = "Or";
/** @internal */
const OP_INVALID_DATA = "InvalidData";
/** @internal */
const OP_MISSING_DATA = "MissingData";
/** @internal */
const OP_SOURCE_UNAVAILABLE = "SourceUnavailable";
/** @internal */
const OP_UNSUPPORTED = "Unsupported";
//# sourceMappingURL=configError.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/configError.js





/** @internal */
const ConfigErrorSymbolKey = "effect/ConfigError";
/** @internal */
const ConfigErrorTypeId = /*#__PURE__*/Symbol.for(ConfigErrorSymbolKey);
/** @internal */
const proto = {
  _tag: "ConfigError",
  [ConfigErrorTypeId]: ConfigErrorTypeId
};
/** @internal */
const And = (self, that) => {
  const error = Object.create(proto);
  error._op = OP_AND;
  error.left = self;
  error.right = that;
  Object.defineProperty(error, "toString", {
    enumerable: false,
    value() {
      return `${this.left} and ${this.right}`;
    }
  });
  return error;
};
/** @internal */
const Or = (self, that) => {
  const error = Object.create(proto);
  error._op = OP_OR;
  error.left = self;
  error.right = that;
  Object.defineProperty(error, "toString", {
    enumerable: false,
    value() {
      return `${this.left} or ${this.right}`;
    }
  });
  return error;
};
/** @internal */
const InvalidData = (path, message, options = {
  pathDelim: "."
}) => {
  const error = Object.create(proto);
  error._op = OP_INVALID_DATA;
  error.path = path;
  error.message = message;
  Object.defineProperty(error, "toString", {
    enumerable: false,
    value() {
      const path = (0,Function/* pipe */.zG)(this.path, esm_Array/* join */.v_(options.pathDelim));
      return `(Invalid data at ${path}: "${this.message}")`;
    }
  });
  return error;
};
/** @internal */
const MissingData = (path, message, options = {
  pathDelim: "."
}) => {
  const error = Object.create(proto);
  error._op = OP_MISSING_DATA;
  error.path = path;
  error.message = message;
  Object.defineProperty(error, "toString", {
    enumerable: false,
    value() {
      const path = (0,Function/* pipe */.zG)(this.path, esm_Array/* join */.v_(options.pathDelim));
      return `(Missing data at ${path}: "${this.message}")`;
    }
  });
  return error;
};
/** @internal */
const SourceUnavailable = (path, message, cause, options = {
  pathDelim: "."
}) => {
  const error = Object.create(proto);
  error._op = OP_SOURCE_UNAVAILABLE;
  error.path = path;
  error.message = message;
  error.cause = cause;
  Object.defineProperty(error, "toString", {
    enumerable: false,
    value() {
      const path = (0,Function/* pipe */.zG)(this.path, esm_Array/* join */.v_(options.pathDelim));
      return `(Source unavailable at ${path}: "${this.message}")`;
    }
  });
  return error;
};
/** @internal */
const Unsupported = (path, message, options = {
  pathDelim: "."
}) => {
  const error = Object.create(proto);
  error._op = OP_UNSUPPORTED;
  error.path = path;
  error.message = message;
  Object.defineProperty(error, "toString", {
    enumerable: false,
    value() {
      const path = (0,Function/* pipe */.zG)(this.path, esm_Array/* join */.v_(options.pathDelim));
      return `(Unsupported operation at ${path}: "${this.message}")`;
    }
  });
  return error;
};
/** @internal */
const isConfigError = u => hasProperty(u, ConfigErrorTypeId);
/** @internal */
const isAnd = self => self._op === OpCodes.OP_AND;
/** @internal */
const isOr = self => self._op === OpCodes.OP_OR;
/** @internal */
const isInvalidData = self => self._op === OpCodes.OP_INVALID_DATA;
/** @internal */
const isMissingData = self => self._op === OpCodes.OP_MISSING_DATA;
/** @internal */
const isSourceUnavailable = self => self._op === OpCodes.OP_SOURCE_UNAVAILABLE;
/** @internal */
const isUnsupported = self => self._op === OpCodes.OP_UNSUPPORTED;
/** @internal */
const prefixed = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, prefix) => {
  switch (self._op) {
    case OP_AND:
      {
        return And(prefixed(self.left, prefix), prefixed(self.right, prefix));
      }
    case OP_OR:
      {
        return Or(prefixed(self.left, prefix), prefixed(self.right, prefix));
      }
    case OP_INVALID_DATA:
      {
        return InvalidData([...prefix, ...self.path], self.message);
      }
    case OP_MISSING_DATA:
      {
        return MissingData([...prefix, ...self.path], self.message);
      }
    case OP_SOURCE_UNAVAILABLE:
      {
        return SourceUnavailable([...prefix, ...self.path], self.message, self.cause);
      }
    case OP_UNSUPPORTED:
      {
        return Unsupported([...prefix, ...self.path], self.message);
      }
  }
});
/** @internal */
const IsMissingDataOnlyReducer = {
  andCase: (_, left, right) => left && right,
  orCase: (_, left, right) => left && right,
  invalidDataCase: Function/* constFalse */.jv,
  missingDataCase: Function/* constTrue */.W8,
  sourceUnavailableCase: Function/* constFalse */.jv,
  unsupportedCase: Function/* constFalse */.jv
};
/** @internal */
const reduceWithContext = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, context, reducer) => {
  const input = [self];
  const output = [];
  while (input.length > 0) {
    const error = input.pop();
    switch (error._op) {
      case OpCodes.OP_AND:
        {
          input.push(error.right);
          input.push(error.left);
          output.push(Either.left({
            _op: "AndCase"
          }));
          break;
        }
      case OpCodes.OP_OR:
        {
          input.push(error.right);
          input.push(error.left);
          output.push(Either.left({
            _op: "OrCase"
          }));
          break;
        }
      case OpCodes.OP_INVALID_DATA:
        {
          output.push(Either.right(reducer.invalidDataCase(context, error.path, error.message)));
          break;
        }
      case OpCodes.OP_MISSING_DATA:
        {
          output.push(Either.right(reducer.missingDataCase(context, error.path, error.message)));
          break;
        }
      case OpCodes.OP_SOURCE_UNAVAILABLE:
        {
          output.push(Either.right(reducer.sourceUnavailableCase(context, error.path, error.message, error.cause)));
          break;
        }
      case OpCodes.OP_UNSUPPORTED:
        {
          output.push(Either.right(reducer.unsupportedCase(context, error.path, error.message)));
          break;
        }
    }
  }
  const accumulator = [];
  while (output.length > 0) {
    const either = output.pop();
    switch (either._op) {
      case "Left":
        {
          switch (either.left._op) {
            case "AndCase":
              {
                const left = accumulator.pop();
                const right = accumulator.pop();
                const value = reducer.andCase(context, left, right);
                accumulator.push(value);
                break;
              }
            case "OrCase":
              {
                const left = accumulator.pop();
                const right = accumulator.pop();
                const value = reducer.orCase(context, left, right);
                accumulator.push(value);
                break;
              }
          }
          break;
        }
      case "Right":
        {
          accumulator.push(either.right);
          break;
        }
    }
  }
  if (accumulator.length === 0) {
    throw new Error("BUG: ConfigError.reduceWithContext - please report an issue at https://github.com/Effect-TS/effect/issues");
  }
  return accumulator.pop();
})));
/** @internal */
const isMissingDataOnly = self => reduceWithContext(self, void 0, IsMissingDataOnlyReducer);
//# sourceMappingURL=configError.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/List.js
var List = __webpack_require__(16104);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/configProvider/pathPatch.js






/** @internal */
const empty = {
  _tag: "Empty"
};
/** @internal */
const andThen = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => ({
  _tag: "AndThen",
  first: self,
  second: that
}))));
/** @internal */
const mapName = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => andThen(self, {
  _tag: "MapName",
  f
}))));
/** @internal */
const nested = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, name) => andThen(self, {
  _tag: "Nested",
  name
}))));
/** @internal */
const unnested = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, name) => andThen(self, {
  _tag: "Unnested",
  name
}))));
/** @internal */
const patch = /*#__PURE__*/(0,Function/* dual */.OB)(2, (path, patch) => {
  let input = List.of(patch);
  let output = path;
  while (List/* isCons */.hg(input)) {
    const patch = input.head;
    switch (patch._tag) {
      case "Empty":
        {
          input = input.tail;
          break;
        }
      case "AndThen":
        {
          input = List/* cons */.QI(patch.first, List/* cons */.QI(patch.second, input.tail));
          break;
        }
      case "MapName":
        {
          output = esm_Array/* map */.UI(output, patch.f);
          input = input.tail;
          break;
        }
      case "Nested":
        {
          output = esm_Array/* prepend */.Ce(output, patch.name);
          input = input.tail;
          break;
        }
      case "Unnested":
        {
          const containsName = (0,Function/* pipe */.zG)(esm_Array/* head */.YM(output), esm_Option/* contains */.r3(patch.name));
          if (containsName) {
            output = esm_Array/* tailNonEmpty */.fm(output);
            input = input.tail;
          } else {
            return esm_Either/* left */.t$(MissingData(output, `Expected ${patch.name} to be in path in ConfigProvider#unnested`));
          }
          break;
        }
    }
  }
  return esm_Either/* right */.F2(output);
});
//# sourceMappingURL=pathPatch.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/core.js + 1 modules
var internal_core = __webpack_require__(39355);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/opCodes/config.js
/** @internal */
const OP_CONSTANT = "Constant";
/** @internal */
const OP_FAIL = "Fail";
/** @internal */
const OP_FALLBACK = "Fallback";
/** @internal */
const OP_DESCRIBED = "Described";
/** @internal */
const OP_LAZY = "Lazy";
/** @internal */
const OP_MAP_OR_FAIL = "MapOrFail";
/** @internal */
const OP_NESTED = "Nested";
/** @internal */
const OP_PRIMITIVE = "Primitive";
/** @internal */
const OP_SEQUENCE = "Sequence";
/** @internal */
const OP_HASHMAP = "HashMap";
/** @internal */
const OP_ZIP_WITH = "ZipWith";
//# sourceMappingURL=config.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/configProvider.js
/* provided dependency */ var process = __webpack_require__(83454);
















const concat = (l, r) => [...l, ...r];
/** @internal */
const ConfigProviderSymbolKey = "effect/ConfigProvider";
/** @internal */
const ConfigProviderTypeId = /*#__PURE__*/Symbol.for(ConfigProviderSymbolKey);
/** @internal */
const configProviderTag = /*#__PURE__*/Context/* GenericTag */.hV("effect/ConfigProvider");
/** @internal */
const FlatConfigProviderSymbolKey = "effect/ConfigProviderFlat";
/** @internal */
const FlatConfigProviderTypeId = /*#__PURE__*/Symbol.for(FlatConfigProviderSymbolKey);
/** @internal */
const make = options => ({
  [ConfigProviderTypeId]: ConfigProviderTypeId,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  },
  ...options
});
/** @internal */
const makeFlat = options => ({
  [FlatConfigProviderTypeId]: FlatConfigProviderTypeId,
  patch: options.patch,
  load: (path, config, split = true) => options.load(path, config, split),
  enumerateChildren: options.enumerateChildren
});
/** @internal */
const fromFlat = flat => make({
  load: config => internal_core/* flatMap */.VSD(fromFlatLoop(flat, esm_Array/* empty */.cS(), config, false), chunk => esm_Option/* match */.EQ(esm_Array/* head */.YM(chunk), {
    onNone: () => internal_core/* fail */.bGj(MissingData(esm_Array/* empty */.cS(), `Expected a single value having structure: ${config}`)),
    onSome: internal_core/* succeed */.ng0
  })),
  flattened: flat
});
/** @internal */
const fromEnv = options => {
  const {
    pathDelim,
    seqDelim
  } = Object.assign({}, {
    pathDelim: "_",
    seqDelim: ","
  }, options);
  const makePathString = path => (0,Function/* pipe */.zG)(path, esm_Array/* join */.v_(pathDelim));
  const unmakePathString = pathString => pathString.split(pathDelim);
  const getEnv = () => typeof process !== "undefined" && "env" in process && typeof process.env === "object" ? process.env : {};
  const load = (path, primitive, split = true) => {
    const pathString = makePathString(path);
    const current = getEnv();
    const valueOpt = pathString in current ? esm_Option/* some */.G(current[pathString]) : esm_Option/* none */.YP();
    return (0,Function/* pipe */.zG)(valueOpt, internal_core/* mapError */.d1Y(() => MissingData(path, `Expected ${pathString} to exist in the process context`)), internal_core/* flatMap */.VSD(value => parsePrimitive(value, path, primitive, seqDelim, split)));
  };
  const enumerateChildren = path => internal_core/* sync */.Z_X(() => {
    const current = getEnv();
    const keys = Object.keys(current);
    const keyPaths = keys.map(value => unmakePathString(value.toUpperCase()));
    const filteredKeyPaths = keyPaths.filter(keyPath => {
      for (let i = 0; i < path.length; i++) {
        const pathComponent = (0,Function/* pipe */.zG)(path, esm_Array/* unsafeGet */.MH(i));
        const currentElement = keyPath[i];
        if (currentElement === undefined || pathComponent !== currentElement) {
          return false;
        }
      }
      return true;
    }).flatMap(keyPath => keyPath.slice(path.length, path.length + 1));
    return esm_HashSet/* fromIterable */.EE(filteredKeyPaths);
  });
  return fromFlat(makeFlat({
    load,
    enumerateChildren,
    patch: empty
  }));
};
/** @internal */
const fromMap = (map, config) => {
  const {
    pathDelim,
    seqDelim
  } = Object.assign({
    seqDelim: ",",
    pathDelim: "."
  }, config);
  const makePathString = path => pipe(path, Arr.join(pathDelim));
  const unmakePathString = pathString => pathString.split(pathDelim);
  const mapWithIndexSplit = splitIndexInKeys(map, str => unmakePathString(str), makePathString);
  const load = (path, primitive, split = true) => {
    const pathString = makePathString(path);
    const valueOpt = mapWithIndexSplit.has(pathString) ? Option.some(mapWithIndexSplit.get(pathString)) : Option.none();
    return pipe(valueOpt, core.mapError(() => configError.MissingData(path, `Expected ${pathString} to exist in the provided map`)), core.flatMap(value => parsePrimitive(value, path, primitive, seqDelim, split)));
  };
  const enumerateChildren = path => core.sync(() => {
    const keyPaths = Arr.fromIterable(mapWithIndexSplit.keys()).map(unmakePathString);
    const filteredKeyPaths = keyPaths.filter(keyPath => {
      for (let i = 0; i < path.length; i++) {
        const pathComponent = pipe(path, Arr.unsafeGet(i));
        const currentElement = keyPath[i];
        if (currentElement === undefined || pathComponent !== currentElement) {
          return false;
        }
      }
      return true;
    }).flatMap(keyPath => keyPath.slice(path.length, path.length + 1));
    return HashSet.fromIterable(filteredKeyPaths);
  });
  return fromFlat(makeFlat({
    load,
    enumerateChildren,
    patch: pathPatch.empty
  }));
};
const extend = (leftDef, rightDef, left, right) => {
  const leftPad = esm_Array/* unfold */.JJ(left.length, index => index >= right.length ? esm_Option/* none */.YP() : esm_Option/* some */.G([leftDef(index), index + 1]));
  const rightPad = esm_Array/* unfold */.JJ(right.length, index => index >= left.length ? esm_Option/* none */.YP() : esm_Option/* some */.G([rightDef(index), index + 1]));
  const leftExtension = concat(left, leftPad);
  const rightExtension = concat(right, rightPad);
  return [leftExtension, rightExtension];
};
const appendConfigPath = (path, config) => {
  let op = config;
  if (op._tag === "Nested") {
    const out = path.slice();
    while (op._tag === "Nested") {
      out.push(op.name);
      op = op.config;
    }
    return out;
  }
  return path;
};
const fromFlatLoop = (flat, prefix, config, split) => {
  const op = config;
  switch (op._tag) {
    case OP_CONSTANT:
      {
        return internal_core/* succeed */.ng0(esm_Array.of(op.value));
      }
    case OP_DESCRIBED:
      {
        return internal_core/* suspend */.RqG(() => fromFlatLoop(flat, prefix, op.config, split));
      }
    case OP_FAIL:
      {
        return internal_core/* fail */.bGj(MissingData(prefix, op.message));
      }
    case OP_FALLBACK:
      {
        return (0,Function/* pipe */.zG)(internal_core/* suspend */.RqG(() => fromFlatLoop(flat, prefix, op.first, split)), internal_core/* catchAll */.kmb(error1 => {
          if (op.condition(error1)) {
            return (0,Function/* pipe */.zG)(fromFlatLoop(flat, prefix, op.second, split), internal_core/* catchAll */.kmb(error2 => internal_core/* fail */.bGj(Or(error1, error2))));
          }
          return internal_core/* fail */.bGj(error1);
        }));
      }
    case OP_LAZY:
      {
        return internal_core/* suspend */.RqG(() => fromFlatLoop(flat, prefix, op.config(), split));
      }
    case OP_MAP_OR_FAIL:
      {
        return internal_core/* suspend */.RqG(() => (0,Function/* pipe */.zG)(fromFlatLoop(flat, prefix, op.original, split), internal_core/* flatMap */.VSD(internal_core/* forEachSequential */.o9$(a => (0,Function/* pipe */.zG)(op.mapOrFail(a), internal_core/* mapError */.d1Y(prefixed(appendConfigPath(prefix, op.original))))))));
      }
    case OP_NESTED:
      {
        return internal_core/* suspend */.RqG(() => fromFlatLoop(flat, concat(prefix, esm_Array.of(op.name)), op.config, split));
      }
    case OP_PRIMITIVE:
      {
        return (0,Function/* pipe */.zG)(patch(prefix, flat.patch), internal_core/* flatMap */.VSD(prefix => (0,Function/* pipe */.zG)(flat.load(prefix, op, split), internal_core/* flatMap */.VSD(values => {
          if (values.length === 0) {
            const name = (0,Function/* pipe */.zG)(esm_Array/* last */.Z$(prefix), esm_Option/* getOrElse */.fS(() => "<n/a>"));
            return internal_core/* fail */.bGj(MissingData([], `Expected ${op.description} with name ${name}`));
          }
          return internal_core/* succeed */.ng0(values);
        }))));
      }
    case OP_SEQUENCE:
      {
        return (0,Function/* pipe */.zG)(patch(prefix, flat.patch), internal_core/* flatMap */.VSD(patchedPrefix => (0,Function/* pipe */.zG)(flat.enumerateChildren(patchedPrefix), internal_core/* flatMap */.VSD(indicesFrom), internal_core/* flatMap */.VSD(indices => {
          if (indices.length === 0) {
            return internal_core/* suspend */.RqG(() => internal_core/* map */.UID(fromFlatLoop(flat, prefix, op.config, true), esm_Array.of));
          }
          return (0,Function/* pipe */.zG)(internal_core/* forEachSequential */.o9$(indices, index => fromFlatLoop(flat, esm_Array/* append */.R3(prefix, `[${index}]`), op.config, true)), internal_core/* map */.UID(chunkChunk => {
            const flattened = esm_Array/* flatten */.xH(chunkChunk);
            if (flattened.length === 0) {
              return esm_Array.of(esm_Array/* empty */.cS());
            }
            return esm_Array.of(flattened);
          }));
        }))));
      }
    case OP_HASHMAP:
      {
        return internal_core/* suspend */.RqG(() => (0,Function/* pipe */.zG)(patch(prefix, flat.patch), internal_core/* flatMap */.VSD(prefix => (0,Function/* pipe */.zG)(flat.enumerateChildren(prefix), internal_core/* flatMap */.VSD(keys => {
          return (0,Function/* pipe */.zG)(keys, internal_core/* forEachSequential */.o9$(key => fromFlatLoop(flat, concat(prefix, esm_Array.of(key)), op.valueConfig, split)), internal_core/* map */.UID(matrix => {
            if (matrix.length === 0) {
              return esm_Array.of(HashMap/* empty */.cS());
            }
            return (0,Function/* pipe */.zG)(transpose(matrix), esm_Array/* map */.UI(values => HashMap/* fromIterable */.EE(esm_Array/* zip */.$R(esm_Array/* fromIterable */.EE(keys), values))));
          }));
        })))));
      }
    case OP_ZIP_WITH:
      {
        return internal_core/* suspend */.RqG(() => (0,Function/* pipe */.zG)(fromFlatLoop(flat, prefix, op.left, split), internal_core/* either */.wEe, internal_core/* flatMap */.VSD(left => (0,Function/* pipe */.zG)(fromFlatLoop(flat, prefix, op.right, split), internal_core/* either */.wEe, internal_core/* flatMap */.VSD(right => {
          if (esm_Either/* isLeft */.nM(left) && esm_Either/* isLeft */.nM(right)) {
            return internal_core/* fail */.bGj(And(left.left, right.left));
          }
          if (esm_Either/* isLeft */.nM(left) && esm_Either/* isRight */.tO(right)) {
            return internal_core/* fail */.bGj(left.left);
          }
          if (esm_Either/* isRight */.tO(left) && esm_Either/* isLeft */.nM(right)) {
            return internal_core/* fail */.bGj(right.left);
          }
          if (esm_Either/* isRight */.tO(left) && esm_Either/* isRight */.tO(right)) {
            const path = (0,Function/* pipe */.zG)(prefix, esm_Array/* join */.v_("."));
            const fail = fromFlatLoopFail(prefix, path);
            const [lefts, rights] = extend(fail, fail, (0,Function/* pipe */.zG)(left.right, esm_Array/* map */.UI(esm_Either/* right */.F2)), (0,Function/* pipe */.zG)(right.right, esm_Array/* map */.UI(esm_Either/* right */.F2)));
            return (0,Function/* pipe */.zG)(lefts, esm_Array/* zip */.$R(rights), internal_core/* forEachSequential */.o9$(([left, right]) => (0,Function/* pipe */.zG)(internal_core/* zip */.$Re(left, right), internal_core/* map */.UID(([left, right]) => op.zip(left, right)))));
          }
          throw new Error("BUG: ConfigProvider.fromFlatLoop - please report an issue at https://github.com/Effect-TS/effect/issues");
        })))));
      }
  }
};
const fromFlatLoopFail = (prefix, path) => index => esm_Either/* left */.t$(MissingData(prefix, `The element at index ${index} in a sequence at path "${path}" was missing`));
/** @internal */
const mapInputPath = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => fromFlat(mapInputPathFlat(self.flattened, f)))));
const mapInputPathFlat = (self, f) => makeFlat({
  load: (path, config, split = true) => self.load(path, config, split),
  enumerateChildren: path => self.enumerateChildren(path),
  patch: pathPatch.mapName(self.patch, f)
});
/** @internal */
const configProvider_nested = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, name) => fromFlat(makeFlat({
  load: (path, config) => self.flattened.load(path, config, true),
  enumerateChildren: path => self.flattened.enumerateChildren(path),
  patch: pathPatch.nested(self.flattened.patch, name)
})))));
/** @internal */
const configProvider_unnested = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, name) => fromFlat(makeFlat({
  load: (path, config) => self.flattened.load(path, config, true),
  enumerateChildren: path => self.flattened.enumerateChildren(path),
  patch: pathPatch.unnested(self.flattened.patch, name)
})))));
/** @internal */
const orElse = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => fromFlat(orElseFlat(self.flattened, () => that().flattened)))));
const orElseFlat = (self, that) => makeFlat({
  load: (path, config, split) => pipe(pathPatch.patch(path, self.patch), core.flatMap(patch => self.load(patch, config, split)), core.catchAll(error1 => pipe(core.sync(that), core.flatMap(that => pipe(pathPatch.patch(path, that.patch), core.flatMap(patch => that.load(patch, config, split)), core.catchAll(error2 => core.fail(configError.Or(error1, error2)))))))),
  enumerateChildren: path => pipe(pathPatch.patch(path, self.patch), core.flatMap(patch => self.enumerateChildren(patch)), core.either, core.flatMap(left => pipe(core.sync(that), core.flatMap(that => pipe(pathPatch.patch(path, that.patch), core.flatMap(patch => that.enumerateChildren(patch)), core.either, core.flatMap(right => {
    if (Either.isLeft(left) && Either.isLeft(right)) {
      return core.fail(configError.And(left.left, right.left));
    }
    if (Either.isLeft(left) && Either.isRight(right)) {
      return core.succeed(right.right);
    }
    if (Either.isRight(left) && Either.isLeft(right)) {
      return core.succeed(left.right);
    }
    if (Either.isRight(left) && Either.isRight(right)) {
      return core.succeed(pipe(left.right, HashSet.union(right.right)));
    }
    throw new Error("BUG: ConfigProvider.orElseFlat - please report an issue at https://github.com/Effect-TS/effect/issues");
  })))))),
  patch: pathPatch.empty
});
/** @internal */
const constantCase = self => mapInputPath(self, StringUtils.constantCase);
/** @internal */
const kebabCase = self => mapInputPath(self, StringUtils.kebabCase);
/** @internal */
const lowerCase = self => mapInputPath(self, StringUtils.lowerCase);
/** @internal */
const snakeCase = self => mapInputPath(self, StringUtils.snakeCase);
/** @internal */
const upperCase = self => mapInputPath(self, StringUtils.upperCase);
/** @internal */
const within = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, path, f) => {
  const unnest = Arr.reduce(path, self, (provider, name) => configProvider_unnested(provider, name));
  const nest = Arr.reduceRight(path, f(unnest), (provider, name) => configProvider_nested(provider, name));
  return orElse(nest, () => self);
})));
const splitPathString = (text, delim) => {
  const split = text.split(new RegExp(`\\s*${esm_RegExp/* escape */.Y(delim)}\\s*`));
  return split;
};
const parsePrimitive = (text, path, primitive, delimiter, split) => {
  if (!split) {
    return (0,Function/* pipe */.zG)(primitive.parse(text), internal_core/* mapBoth */.SAn({
      onFailure: prefixed(path),
      onSuccess: esm_Array.of
    }));
  }
  return (0,Function/* pipe */.zG)(splitPathString(text, delimiter), internal_core/* forEachSequential */.o9$(char => primitive.parse(char.trim())), internal_core/* mapError */.d1Y(prefixed(path)));
};
const transpose = array => {
  return Object.keys(array[0]).map(column => array.map(row => row[column]));
};
const indicesFrom = quotedIndices => (0,Function/* pipe */.zG)(internal_core/* forEachSequential */.o9$(quotedIndices, parseQuotedIndex), internal_core/* mapBoth */.SAn({
  onFailure: () => esm_Array/* empty */.cS(),
  onSuccess: esm_Array/* sort */.wx(esm_Number/* Order */.KM)
}), internal_core/* either */.wEe, internal_core/* map */.UID(esm_Either/* merge */.TS));
const STR_INDEX_REGEX = /(^.+)(\[(\d+)\])$/;
const QUOTED_INDEX_REGEX = /^(\[(\d+)\])$/;
const parseQuotedIndex = str => {
  const match = str.match(QUOTED_INDEX_REGEX);
  if (match !== null) {
    const matchedIndex = match[2];
    return (0,Function/* pipe */.zG)(matchedIndex !== undefined && matchedIndex.length > 0 ? esm_Option/* some */.G(matchedIndex) : esm_Option/* none */.YP(), esm_Option/* flatMap */.VS(parseInteger));
  }
  return esm_Option/* none */.YP();
};
const splitIndexInKeys = (map, unmakePathString, makePathString) => {
  const newMap = new Map();
  for (const [pathString, value] of map) {
    const keyWithIndex = pipe(unmakePathString(pathString), Arr.flatMap(key => Option.match(splitIndexFrom(key), {
      onNone: () => Arr.of(key),
      onSome: ([key, index]) => Arr.make(key, `[${index}]`)
    })));
    newMap.set(makePathString(keyWithIndex), value);
  }
  return newMap;
};
const splitIndexFrom = key => {
  const match = key.match(STR_INDEX_REGEX);
  if (match !== null) {
    const matchedString = match[1];
    const matchedIndex = match[3];
    const optionalString = matchedString !== undefined && matchedString.length > 0 ? Option.some(matchedString) : Option.none();
    const optionalIndex = pipe(matchedIndex !== undefined && matchedIndex.length > 0 ? Option.some(matchedIndex) : Option.none(), Option.flatMap(parseInteger));
    return Option.all([optionalString, optionalIndex]);
  }
  return Option.none();
};
const parseInteger = str => {
  const parsedIndex = Number.parseInt(str);
  return Number.isNaN(parsedIndex) ? esm_Option/* none */.YP() : esm_Option/* some */.G(parsedIndex);
};
const keyName = name => ({
  _tag: "KeyName",
  name
});
const keyIndex = index => ({
  _tag: "KeyIndex",
  index
});
/** @internal */
const fromJson = json => {
  const hiddenDelimiter = "\ufeff";
  const indexedEntries = Arr.map(getIndexedEntries(json), ([key, value]) => [configPathToString(key).join(hiddenDelimiter), value]);
  return fromMap(new Map(indexedEntries), {
    pathDelim: hiddenDelimiter,
    seqDelim: hiddenDelimiter
  });
};
const configPathToString = path => {
  const output = [];
  let i = 0;
  while (i < path.length) {
    const component = path[i];
    if (component._tag === "KeyName") {
      if (i + 1 < path.length) {
        const nextComponent = path[i + 1];
        if (nextComponent._tag === "KeyIndex") {
          output.push(`${component.name}[${nextComponent.index}]`);
          i += 2;
        } else {
          output.push(component.name);
          i += 1;
        }
      } else {
        output.push(component.name);
        i += 1;
      }
    }
  }
  return output;
};
const getIndexedEntries = config => {
  const loopAny = (path, value) => {
    if (typeof value === "string") {
      return Arr.make([path, value]);
    }
    if (typeof value === "number" || typeof value === "boolean") {
      return Arr.make([path, String(value)]);
    }
    if (Arr.isArray(value)) {
      return loopArray(path, value);
    }
    if (typeof value === "object" && value !== null) {
      return loopObject(path, value);
    }
    return Arr.empty();
  };
  const loopArray = (path, values) => Arr.match(values, {
    onEmpty: () => Arr.make([path, "<nil>"]),
    onNonEmpty: Arr.flatMap((value, index) => loopAny(Arr.append(path, keyIndex(index)), value))
  });
  const loopObject = (path, value) => Object.entries(value).filter(([, value]) => Predicate.isNotNullable(value)).flatMap(([key, value]) => {
    const newPath = Arr.append(path, keyName(key));
    const result = loopAny(newPath, value);
    if (Arr.isEmptyReadonlyArray(result)) {
      return Arr.make([newPath, ""]);
    }
    return result;
  });
  return loopObject(Arr.empty(), config);
};
//# sourceMappingURL=configProvider.js.map

/***/ }),

/***/ 40197:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CE": function() { return /* binding */ omit; },
/* harmony export */   "Gh": function() { return /* binding */ unsafeGetReference; },
/* harmony export */   "IH": function() { return /* binding */ add; },
/* harmony export */   "Jn": function() { return /* binding */ mergeAll; },
/* harmony export */   "MH": function() { return /* binding */ unsafeGet; },
/* harmony export */   "Og": function() { return /* binding */ TagTypeId; },
/* harmony export */   "PI": function() { return /* binding */ isContext; },
/* harmony export */   "Rl": function() { return /* binding */ getOption; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "TS": function() { return /* binding */ merge; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "Vp": function() { return /* binding */ Tag; },
/* harmony export */   "YR": function() { return /* binding */ isTag; },
/* harmony export */   "Yk": function() { return /* binding */ isReference; },
/* harmony export */   "aC": function() { return /* binding */ TypeId; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "ei": function() { return /* binding */ pick; },
/* harmony export */   "fC": function() { return /* binding */ makeContext; },
/* harmony export */   "fS": function() { return /* binding */ getOrElse; },
/* harmony export */   "no": function() { return /* binding */ ReferenceTypeId; },
/* harmony export */   "s3": function() { return /* binding */ Reference; },
/* harmony export */   "uq": function() { return /* binding */ makeGenericTag; }
/* harmony export */ });
/* unused harmony exports STMTypeId, TagProto, ReferenceProto, ContextProto */
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17316);
/* harmony import */ var _GlobalValue_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4726);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89379);
/* harmony import */ var _Inspectable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16371);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92817);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71335);
/* harmony import */ var _effectable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10020);
/* harmony import */ var _option_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70602);









/** @internal */
const TagTypeId = /*#__PURE__*/Symbol.for("effect/Context/Tag");
/** @internal */
const ReferenceTypeId = /*#__PURE__*/Symbol.for("effect/Context/Reference");
/** @internal */
const STMSymbolKey = "effect/STM";
/** @internal */
const STMTypeId = /*#__PURE__*/Symbol.for(STMSymbolKey);
/** @internal */
const TagProto = {
  ..._effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .EffectPrototype */ .tU,
  _op: "Tag",
  [STMTypeId]: _effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .effectVariance */ .Qo,
  [TagTypeId]: {
    _Service: _ => _,
    _Identifier: _ => _
  },
  toString() {
    return (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_1__/* .format */ .WU)(this.toJSON());
  },
  toJSON() {
    return {
      _id: "Tag",
      key: this.key,
      stack: this.stack
    };
  },
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_1__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  },
  of(self) {
    return self;
  },
  context(self) {
    return make(this, self);
  }
};
const ReferenceProto = {
  ...TagProto,
  [ReferenceTypeId]: ReferenceTypeId
};
/** @internal */
const makeGenericTag = key => {
  const limit = Error.stackTraceLimit;
  Error.stackTraceLimit = 2;
  const creationError = new Error();
  Error.stackTraceLimit = limit;
  const tag = Object.create(TagProto);
  Object.defineProperty(tag, "stack", {
    get() {
      return creationError.stack;
    }
  });
  tag.key = key;
  return tag;
};
/** @internal */
const Tag = id => () => {
  const limit = Error.stackTraceLimit;
  Error.stackTraceLimit = 2;
  const creationError = new Error();
  Error.stackTraceLimit = limit;
  function TagClass() {}
  Object.setPrototypeOf(TagClass, TagProto);
  TagClass.key = id;
  Object.defineProperty(TagClass, "stack", {
    get() {
      return creationError.stack;
    }
  });
  return TagClass;
};
/** @internal */
const Reference = () => (id, options) => {
  const limit = Error.stackTraceLimit;
  Error.stackTraceLimit = 2;
  const creationError = new Error();
  Error.stackTraceLimit = limit;
  function ReferenceClass() {}
  Object.setPrototypeOf(ReferenceClass, ReferenceProto);
  ReferenceClass.key = id;
  ReferenceClass.defaultValue = options.defaultValue;
  Object.defineProperty(ReferenceClass, "stack", {
    get() {
      return creationError.stack;
    }
  });
  return ReferenceClass;
};
/** @internal */
const TypeId = /*#__PURE__*/Symbol.for("effect/Context");
/** @internal */
const ContextProto = {
  [TypeId]: {
    _Services: _ => _
  },
  [_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .symbol */ .NA](that) {
    if (isContext(that)) {
      if (this.unsafeMap.size === that.unsafeMap.size) {
        for (const k of this.unsafeMap.keys()) {
          if (!that.unsafeMap.has(k) || !_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .equals */ .fS(this.unsafeMap.get(k), that.unsafeMap.get(k))) {
            return false;
          }
        }
        return true;
      }
    }
    return false;
  },
  [_Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .symbol */ .NA]() {
    return _Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .cached */ .HX(this, _Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .number */ .Rx(this.unsafeMap.size));
  },
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_4__/* .pipeArguments */ .n)(this, arguments);
  },
  toString() {
    return (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_1__/* .format */ .WU)(this.toJSON());
  },
  toJSON() {
    return {
      _id: "Context",
      services: Array.from(this.unsafeMap).map(_Inspectable_js__WEBPACK_IMPORTED_MODULE_1__/* .toJSON */ .au)
    };
  },
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_1__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  }
};
/** @internal */
const makeContext = unsafeMap => {
  const context = Object.create(ContextProto);
  context.unsafeMap = unsafeMap;
  return context;
};
const serviceNotFoundError = tag => {
  const error = new Error(`Service not found${tag.key ? `: ${String(tag.key)}` : ""}`);
  if (tag.stack) {
    const lines = tag.stack.split("\n");
    if (lines.length > 2) {
      const afterAt = lines[2].match(/at (.*)/);
      if (afterAt) {
        error.message = error.message + ` (defined at ${afterAt[1]})`;
      }
    }
  }
  if (error.stack) {
    const lines = error.stack.split("\n");
    lines.splice(1, 3);
    error.stack = lines.join("\n");
  }
  return error;
};
/** @internal */
const isContext = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_5__/* .hasProperty */ .l$)(u, TypeId);
/** @internal */
const isTag = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_5__/* .hasProperty */ .l$)(u, TagTypeId);
/** @internal */
const isReference = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_5__/* .hasProperty */ .l$)(u, ReferenceTypeId);
const _empty = /*#__PURE__*/makeContext( /*#__PURE__*/new Map());
/** @internal */
const empty = () => _empty;
/** @internal */
const make = (tag, service) => makeContext(new Map([[tag.key, service]]));
/** @internal */
const add = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(3, (self, tag, service) => {
  const map = new Map(self.unsafeMap);
  map.set(tag.key, service);
  return makeContext(map);
});
const defaultValueCache = /*#__PURE__*/(0,_GlobalValue_js__WEBPACK_IMPORTED_MODULE_7__/* .globalValue */ .K)("effect/Context/defaultValueCache", () => new Map());
const getDefaultValue = tag => {
  if (defaultValueCache.has(tag.key)) {
    return defaultValueCache.get(tag.key);
  }
  const value = tag.defaultValue();
  defaultValueCache.set(tag.key, value);
  return value;
};
/** @internal */
const unsafeGetReference = (self, tag) => {
  return self.unsafeMap.has(tag.key) ? self.unsafeMap.get(tag.key) : getDefaultValue(tag);
};
/** @internal */
const unsafeGet = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, tag) => {
  if (!self.unsafeMap.has(tag.key)) {
    if (ReferenceTypeId in tag) return getDefaultValue(tag);
    throw serviceNotFoundError(tag);
  }
  return self.unsafeMap.get(tag.key);
});
/** @internal */
const get = unsafeGet;
/** @internal */
const getOrElse = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(3, (self, tag, orElse) => {
  if (!self.unsafeMap.has(tag.key)) {
    return isReference(tag) ? getDefaultValue(tag) : orElse();
  }
  return self.unsafeMap.get(tag.key);
});
/** @internal */
const getOption = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, tag) => {
  if (!self.unsafeMap.has(tag.key)) {
    return isReference(tag) ? _option_js__WEBPACK_IMPORTED_MODULE_8__/* .some */ .G(getDefaultValue(tag)) : _option_js__WEBPACK_IMPORTED_MODULE_8__/* .none */ .YP;
  }
  return _option_js__WEBPACK_IMPORTED_MODULE_8__/* .some */ .G(self.unsafeMap.get(tag.key));
});
/** @internal */
const merge = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, that) => {
  const map = new Map(self.unsafeMap);
  for (const [tag, s] of that.unsafeMap) {
    map.set(tag, s);
  }
  return makeContext(map);
});
/** @internal */
const mergeAll = (...ctxs) => {
  const map = new Map();
  for (const ctx of ctxs) {
    for (const [tag, s] of ctx.unsafeMap) {
      map.set(tag, s);
    }
  }
  return makeContext(map);
};
/** @internal */
const pick = (...tags) => self => {
  const tagSet = new Set(tags.map(_ => _.key));
  const newEnv = new Map();
  for (const [tag, s] of self.unsafeMap.entries()) {
    if (tagSet.has(tag)) {
      newEnv.set(tag, s);
    }
  }
  return makeContext(newEnv);
};
/** @internal */
const omit = (...tags) => self => {
  const newEnv = new Map(self.unsafeMap);
  for (const tag of tags) {
    newEnv.delete(tag.key);
  }
  return makeContext(newEnv);
};
//# sourceMappingURL=context.js.map

/***/ }),

/***/ 53623:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Do": function() { return /* binding */ Do; },
  "Xw": function() { return /* binding */ _catch; },
  "Q9": function() { return /* binding */ allowInterrupt; },
  "H5": function() { return /* binding */ annotateCurrentSpan; },
  "z": function() { return /* binding */ annotateLogs; },
  "wV": function() { return /* binding */ annotateSpans; },
  "l0": function() { return /* binding */ asSome; },
  "Ps": function() { return /* binding */ asSomeError; },
  "ak": function() { return /* binding */ core_effect_bind; },
  "YO": function() { return /* binding */ core_effect_bindTo; },
  "KP": function() { return /* binding */ catchAllDefect; },
  "y8": function() { return /* binding */ catchSomeCause; },
  "C5": function() { return /* binding */ catchSomeDefect; },
  "Gl": function() { return /* binding */ catchTag; },
  "dL": function() { return /* binding */ catchTags; },
  "tx": function() { return /* binding */ cause; },
  "mC": function() { return /* binding */ clock; },
  "UA": function() { return /* binding */ clockWith; },
  "bp": function() { return /* binding */ contextWith; },
  "bs": function() { return /* binding */ currentParentSpan; },
  "f3": function() { return /* binding */ currentSpan; },
  "gw": function() { return /* binding */ delay; },
  "qI": function() { return /* binding */ descriptor; },
  "vG": function() { return /* binding */ descriptorWith; },
  "gT": function() { return /* binding */ diffFiberRefs; },
  "NP": function() { return /* binding */ dropUntil; },
  "$x": function() { return /* binding */ dropWhile; },
  "n5": function() { return /* binding */ endSpan; },
  "zm": function() { return /* binding */ eventually; },
  "yW": function() { return /* binding */ every; },
  "tW": function() { return /* binding */ fiberRefs; },
  "DZ": function() { return /* binding */ filterMap; },
  "eW": function() { return /* binding */ filterOrDie; },
  "FY": function() { return /* binding */ filterOrDieMessage; },
  "Y$": function() { return /* binding */ filterOrElse; },
  "lF": function() { return /* binding */ filterOrFail; },
  "Ew": function() { return /* binding */ findFirst; },
  "n7": function() { return /* binding */ firstSuccessOf; },
  "tG": function() { return /* binding */ flipWith; },
  "Yo": function() { return /* binding */ forever; },
  "ij": function() { return /* binding */ fromNullable; },
  "pm": function() { return /* binding */ functionWithSpan; },
  "YM": function() { return /* binding */ head; },
  "ID": function() { return /* binding */ ignore; },
  "RC": function() { return /* binding */ ignoreLogged; },
  "CT": function() { return /* binding */ inheritFiberRefs; },
  "hx": function() { return /* binding */ isFailure; },
  "d6": function() { return /* binding */ isSuccess; },
  "UP": function() { return /* binding */ iterate; },
  "mX": function() { return /* binding */ labelMetrics; },
  "Zp": function() { return /* binding */ core_effect_let_; },
  "NA": function() { return /* binding */ liftPredicate; },
  "y2": function() { return /* binding */ linkSpanCurrent; },
  "Rc": function() { return /* binding */ linkSpans; },
  "cM": function() { return /* binding */ log; },
  "$F": function() { return /* binding */ logAnnotations; },
  "o7": function() { return /* binding */ logDebug; },
  "H": function() { return /* binding */ logError; },
  "qX": function() { return /* binding */ logFatal; },
  "PN": function() { return /* binding */ logInfo; },
  "qn": function() { return /* binding */ logTrace; },
  "KE": function() { return /* binding */ logWarning; },
  "VX": function() { return /* binding */ loop; },
  "v8": function() { return /* binding */ makeSpan; },
  "zJ": function() { return /* binding */ mapAccum; },
  "$p": function() { return /* binding */ mapErrorCause; },
  "EQ": function() { return /* binding */ match; },
  "HP": function() { return /* binding */ memoize; },
  "TS": function() { return /* binding */ merge; },
  "tk": function() { return /* binding */ negate; },
  "YP": function() { return /* binding */ none; },
  "IH": function() { return /* binding */ once; },
  "Kw": function() { return /* binding */ core_effect_option; },
  "Ds": function() { return /* binding */ optionFromOptional; },
  "LP": function() { return /* binding */ orElseFail; },
  "pt": function() { return /* binding */ orElseSucceed; },
  "ki": function() { return /* binding */ parallelErrors; },
  "au": function() { return /* binding */ patchFiberRefs; },
  "MC": function() { return /* binding */ promise; },
  "aH": function() { return /* binding */ provideService; },
  "VZ": function() { return /* binding */ provideServiceEffect; },
  "MX": function() { return /* binding */ random; },
  "u4": function() { return /* binding */ reduce; },
  "nq": function() { return /* binding */ reduceRight; },
  "jQ": function() { return /* binding */ reduceWhile; },
  "$I": function() { return /* binding */ repeatN; },
  "vH": function() { return /* binding */ sandbox; },
  "E9": function() { return /* binding */ serviceConstants; },
  "B8": function() { return /* binding */ serviceFunction; },
  "M2": function() { return /* binding */ serviceFunctionEffect; },
  "Ft": function() { return /* binding */ serviceFunctions; },
  "DM": function() { return /* binding */ serviceMembers; },
  "my": function() { return /* binding */ serviceOption; },
  "A1": function() { return /* binding */ serviceOptional; },
  "js": function() { return /* binding */ setFiberRefs; },
  "_v": function() { return /* binding */ sleep; },
  "xf": function() { return /* binding */ spanAnnotations; },
  "Dp": function() { return /* binding */ spanLinks; },
  "pF": function() { return /* binding */ succeedNone; },
  "i4": function() { return /* binding */ succeedSome; },
  "bA": function() { return /* binding */ summarized; },
  "_t": function() { return /* binding */ tagMetrics; },
  "Rs": function() { return /* binding */ takeUntil; },
  "oE": function() { return /* binding */ takeWhile; },
  "iG": function() { return /* binding */ tapBoth; },
  "xv": function() { return /* binding */ tapDefect; },
  "sn": function() { return /* binding */ tapError; },
  "OM": function() { return /* binding */ tapErrorCause; },
  "WO": function() { return /* binding */ tapErrorTag; },
  "E1": function() { return /* binding */ timed; },
  "qP": function() { return /* binding */ timedWith; },
  "Z7": function() { return /* binding */ tracer; },
  "K$": function() { return /* binding */ tryMap; },
  "lm": function() { return /* binding */ tryMapPromise; },
  "p6": function() { return /* binding */ tryPromise; },
  "DV": function() { return /* binding */ try_; },
  "qh": function() { return /* binding */ unless; },
  "d7": function() { return /* binding */ unlessEffect; },
  "u1": function() { return /* binding */ unsafeMakeSpan; },
  "wi": function() { return /* binding */ unsandbox; },
  "L": function() { return /* binding */ updateFiberRefs; },
  "Pg": function() { return /* binding */ updateService; },
  "_g": function() { return /* binding */ useSpan; },
  "gx": function() { return /* binding */ when; },
  "Q2": function() { return /* binding */ whenFiberRef; },
  "kD": function() { return /* binding */ whenRef; },
  "JP": function() { return /* binding */ withLogSpan; },
  "yz": function() { return /* binding */ withMetric; },
  "cV": function() { return /* binding */ withParentSpan; },
  "cq": function() { return /* binding */ withSpan; }
});

// UNUSED EXPORTS: diffFiberRefsAndRuntimeFlags, logWithLevel, tracerWith

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Array.js + 2 modules
var esm_Array = __webpack_require__(37901);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Chunk.js
var Chunk = __webpack_require__(14109);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Clock.js
var Clock = __webpack_require__(9605);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Context.js
var Context = __webpack_require__(20591);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Duration.js
var Duration = __webpack_require__(13571);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/FiberRefs.js
var FiberRefs = __webpack_require__(6639);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/HashMap.js + 1 modules
var HashMap = __webpack_require__(61952);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/HashSet.js
var HashSet = __webpack_require__(9551);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/List.js
var List = __webpack_require__(16104);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/LogLevel.js
var LogLevel = __webpack_require__(69783);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/logSpan.js
var logSpan = __webpack_require__(96443);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/LogSpan.js
/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const make = logSpan/* make */.Sy;
/**
 * @since 2.0.0
 * @category destructors
 */
const render = logSpan/* render */.sY;
//# sourceMappingURL=LogSpan.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var Predicate = __webpack_require__(71335);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Ref.js
var Ref = __webpack_require__(2532);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/defaultServices.js
var defaultServices = __webpack_require__(74266);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/tracer.js
var internal_tracer = __webpack_require__(10434);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/Tracer.js


/**
 * @since 2.0.0
 */
const TracerTypeId = internal_tracer/* TracerTypeId */.i0;
/**
 * @since 2.0.0
 * @category tags
 */
const ParentSpan = internal_tracer/* spanTag */.N7;
/**
 * @since 2.0.0
 * @category tags
 */
const Tracer = internal_tracer/* tracerTag */.Fl;
/**
 * @since 2.0.0
 * @category constructors
 */
const Tracer_make = internal_tracer/* make */.Sy;
/**
 * @since 2.0.0
 * @category constructors
 */
const externalSpan = internal_tracer/* externalSpan */.kH;
/**
 * @since 2.0.0
 * @category constructors
 */
const tracerWith = defaultServices/* tracerWith */.$f;
/**
 * @since 3.12.0
 * @category annotations
 */
const DisablePropagation = internal_tracer/* DisablePropagation */.jS;
//# sourceMappingURL=Tracer.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Utils.js
var Utils = __webpack_require__(70762);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/cause.js + 1 modules
var internal_cause = __webpack_require__(69579);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/clock.js
var internal_clock = __webpack_require__(53318);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/core.js + 1 modules
var core = __webpack_require__(39355);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/doNotation.js

/** @internal */
const let_ = map => (0,Function/* dual */.OB)(3, (self, name, f) => map(self, a => Object.assign({}, a, {
  [name]: f(a)
})));
/** @internal */
const bindTo = map => (0,Function/* dual */.OB)(2, (self, name) => map(self, a => ({
  [name]: a
})));
/** @internal */
const bind = (map, flatMap) => (0,Function/* dual */.OB)(3, (self, name, f) => flatMap(self, a => map(f(a), b => Object.assign({}, a, {
  [name]: b
}))));
//# sourceMappingURL=doNotation.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/fiberRefs/patch.js
var fiberRefs_patch = __webpack_require__(2108);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/metric/label.js
var label = __webpack_require__(36548);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/runtimeFlags.js
var runtimeFlags = __webpack_require__(4536);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/core-effect.js


























/* @internal */
const annotateLogs = /*#__PURE__*/(0,Function/* dual */.OB)(args => core/* isEffect */.cdB(args[0]), function () {
  const args = arguments;
  return core/* fiberRefLocallyWith */.LzL(args[0], core/* currentLogAnnotations */.cMe, typeof args[1] === "string" ? HashMap/* set */.t8(args[1], args[2]) : annotations => Object.entries(args[1]).reduce((acc, [key, value]) => HashMap/* set */.t8(acc, key, value), annotations));
});
/* @internal */
const asSome = self => core/* map */.UID(self, Option/* some */.G);
/* @internal */
const asSomeError = self => core/* mapError */.d1Y(self, Option/* some */.G);
/* @internal */
const try_ = arg => {
  let evaluate;
  let onFailure = undefined;
  if (typeof arg === "function") {
    evaluate = arg;
  } else {
    evaluate = arg.try;
    onFailure = arg.catch;
  }
  return core/* suspend */.RqG(() => {
    try {
      return core/* succeed */.ng0((0,Utils/* internalCall */.MS)(evaluate));
    } catch (error) {
      return core/* fail */.bGj(onFailure ? (0,Utils/* internalCall */.MS)(() => onFailure(error)) : new core/* UnknownException */.ioe(error, "An unknown error occurred in Effect.try"));
    }
  });
};
/* @internal */
const _catch = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, tag, options) => core/* catchAll */.kmb(self, e => {
  if (Predicate/* hasProperty */.l$(e, tag) && e[tag] === options.failure) {
    return options.onFailure(e);
  }
  return core/* fail */.bGj(e);
}));
/* @internal */
const catchAllDefect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => core/* catchAllCause */.Npq(self, cause => {
  const option = internal_cause/* find */.sE(cause, _ => internal_cause/* isDieType */.QV(_) ? Option/* some */.G(_) : Option/* none */.YP());
  switch (option._tag) {
    case "None":
      {
        return core/* failCause */.DhG(cause);
      }
    case "Some":
      {
        return f(option.value.defect);
      }
  }
}));
/* @internal */
const catchSomeCause = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => core/* matchCauseEffect */.Bpg(self, {
  onFailure: cause => {
    const option = f(cause);
    switch (option._tag) {
      case "None":
        {
          return core/* failCause */.DhG(cause);
        }
      case "Some":
        {
          return option.value;
        }
    }
  },
  onSuccess: core/* succeed */.ng0
}));
/* @internal */
const catchSomeDefect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, pf) => core/* catchAllCause */.Npq(self, cause => {
  const option = internal_cause/* find */.sE(cause, _ => internal_cause/* isDieType */.QV(_) ? Option/* some */.G(_) : Option/* none */.YP());
  switch (option._tag) {
    case "None":
      {
        return core/* failCause */.DhG(cause);
      }
    case "Some":
      {
        const optionEffect = pf(option.value.defect);
        return optionEffect._tag === "Some" ? optionEffect.value : core/* failCause */.DhG(cause);
      }
  }
}));
/* @internal */
const catchTag = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, k, f) => core/* catchIf */.yNi(self, Predicate/* isTagged */.Bd(k), f));
/** @internal */
const catchTags = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, cases) => {
  let keys;
  return core/* catchIf */.yNi(self, e => {
    keys ??= Object.keys(cases);
    return Predicate/* hasProperty */.l$(e, "_tag") && Predicate/* isString */.HD(e["_tag"]) && keys.includes(e["_tag"]);
  }, e => cases[e["_tag"]](e));
});
/* @internal */
const cause = self => core/* matchCause */.eYH(self, {
  onFailure: Function/* identity */.yR,
  onSuccess: () => internal_cause/* empty */.cS
});
/* @internal */
const clockWith = Clock/* clockWith */.UA;
/* @internal */
const clock = /*#__PURE__*/clockWith(core/* succeed */.ng0);
/* @internal */
const delay = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, duration) => core/* zipRight */.qs5(Clock/* sleep */._v(duration), self));
/* @internal */
const descriptorWith = f => core/* withFiberRuntime */.ECC((state, status) => f({
  id: state.id(),
  status,
  interruptors: internal_cause/* interruptors */.l7(state.getFiberRef(core/* currentInterruptedCause */.LFL))
}));
/* @internal */
const allowInterrupt = /*#__PURE__*/descriptorWith(descriptor => HashSet/* size */.dp(descriptor.interruptors) > 0 ? core/* interrupt */.e1i : core/* void */.Hcj);
/* @internal */
const descriptor = /*#__PURE__*/descriptorWith(core/* succeed */.ng0);
/* @internal */
const diffFiberRefs = self => summarized(self, fiberRefs, fiberRefs_patch/* diff */.Hg);
/* @internal */
const diffFiberRefsAndRuntimeFlags = self => summarized(self, core/* zip */.$Re(fiberRefs, core/* runtimeFlags */.CpT), ([refs, flags], [refsNew, flagsNew]) => [fiberRefs_patch/* diff */.Hg(refs, refsNew), runtimeFlags/* diff */.Hg(flags, flagsNew)]);
/* @internal */
const Do = /*#__PURE__*/core/* succeed */.ng0({});
/* @internal */
const core_effect_bind = /*#__PURE__*/bind(core/* map */.UID, core/* flatMap */.VSD);
/* @internal */
const core_effect_bindTo = /*#__PURE__*/bindTo(core/* map */.UID);
/* @internal */
const core_effect_let_ = /*#__PURE__*/let_(core/* map */.UID);
/* @internal */
const dropUntil = /*#__PURE__*/(0,Function/* dual */.OB)(2, (elements, predicate) => core/* suspend */.RqG(() => {
  const iterator = elements[Symbol.iterator]();
  const builder = [];
  let next;
  let dropping = core/* succeed */.ng0(false);
  let i = 0;
  while ((next = iterator.next()) && !next.done) {
    const a = next.value;
    const index = i++;
    dropping = core/* flatMap */.VSD(dropping, bool => {
      if (bool) {
        builder.push(a);
        return core/* succeed */.ng0(true);
      }
      return predicate(a, index);
    });
  }
  return core/* map */.UID(dropping, () => builder);
}));
/* @internal */
const dropWhile = /*#__PURE__*/(0,Function/* dual */.OB)(2, (elements, predicate) => core/* suspend */.RqG(() => {
  const iterator = elements[Symbol.iterator]();
  const builder = [];
  let next;
  let dropping = core/* succeed */.ng0(true);
  let i = 0;
  while ((next = iterator.next()) && !next.done) {
    const a = next.value;
    const index = i++;
    dropping = core/* flatMap */.VSD(dropping, d => core/* map */.UID(d ? predicate(a, index) : core/* succeed */.ng0(false), b => {
      if (!b) {
        builder.push(a);
      }
      return b;
    }));
  }
  return core/* map */.UID(dropping, () => builder);
}));
/* @internal */
const contextWith = f => core/* map */.UID(core/* context */.Do7(), f);
/* @internal */
const eventually = self => core/* orElse */.vxS(self, () => core/* flatMap */.VSD(core/* yieldNow */.T4Q(), () => eventually(self)));
/* @internal */
const filterMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (elements, pf) => core/* map */.UID(core/* forEachSequential */.o9$(elements, Function/* identity */.yR), esm_Array/* filterMap */.DZ(pf)));
/* @internal */
const filterOrDie = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, predicate, orDieWith) => filterOrElse(self, predicate, a => core/* dieSync */.AgX(() => orDieWith(a))));
/* @internal */
const filterOrDieMessage = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, predicate, message) => filterOrElse(self, predicate, () => core/* dieMessage */.lFE(message)));
/* @internal */
const filterOrElse = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, predicate, orElse) => core/* flatMap */.VSD(self, a => predicate(a) ? core/* succeed */.ng0(a) : orElse(a)));
/** @internal */
const liftPredicate = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, predicate, orFailWith) => core/* suspend */.RqG(() => predicate(self) ? core/* succeed */.ng0(self) : core/* fail */.bGj(orFailWith(self))));
/* @internal */
const filterOrFail = /*#__PURE__*/(0,Function/* dual */.OB)(args => core/* isEffect */.cdB(args[0]), (self, predicate, orFailWith) => filterOrElse(self, predicate, a => orFailWith === undefined ? core/* fail */.bGj(new core/* NoSuchElementException */.buj()) : core/* failSync */.zph(() => orFailWith(a))));
/* @internal */
const findFirst = /*#__PURE__*/(0,Function/* dual */.OB)(2, (elements, predicate) => core/* suspend */.RqG(() => {
  const iterator = elements[Symbol.iterator]();
  const next = iterator.next();
  if (!next.done) {
    return findLoop(iterator, 0, predicate, next.value);
  }
  return core/* succeed */.ng0(Option/* none */.YP());
}));
const findLoop = (iterator, index, f, value) => core/* flatMap */.VSD(f(value, index), result => {
  if (result) {
    return core/* succeed */.ng0(Option/* some */.G(value));
  }
  const next = iterator.next();
  if (!next.done) {
    return findLoop(iterator, index + 1, f, next.value);
  }
  return core/* succeed */.ng0(Option/* none */.YP());
});
/* @internal */
const firstSuccessOf = effects => core/* suspend */.RqG(() => {
  const list = Chunk/* fromIterable */.EE(effects);
  if (!Chunk/* isNonEmpty */.Od(list)) {
    return core/* dieSync */.AgX(() => new core/* IllegalArgumentException */.j5q(`Received an empty collection of effects`));
  }
  return (0,Function/* pipe */.zG)(Chunk/* tailNonEmpty */.fm(list), esm_Array/* reduce */.u4(Chunk/* headNonEmpty */.dK(list), (left, right) => core/* orElse */.vxS(left, () => right)));
});
/* @internal */
const flipWith = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => core/* flip */.RRI(f(core/* flip */.RRI(self))));
/* @internal */
const match = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, options) => core/* matchEffect */.PwY(self, {
  onFailure: e => core/* succeed */.ng0(options.onFailure(e)),
  onSuccess: a => core/* succeed */.ng0(options.onSuccess(a))
}));
/* @internal */
const every = /*#__PURE__*/(0,Function/* dual */.OB)(2, (elements, predicate) => core/* suspend */.RqG(() => forAllLoop(elements[Symbol.iterator](), 0, predicate)));
const forAllLoop = (iterator, index, f) => {
  const next = iterator.next();
  return next.done ? core/* succeed */.ng0(true) : core/* flatMap */.VSD(f(next.value, index), b => b ? forAllLoop(iterator, index + 1, f) : core/* succeed */.ng0(b));
};
/* @internal */
const forever = self => {
  const loop = core/* flatMap */.VSD(core/* flatMap */.VSD(self, () => core/* yieldNow */.T4Q()), () => loop);
  return loop;
};
/* @internal */
const fiberRefs = /*#__PURE__*/core/* withFiberRuntime */.ECC(state => core/* succeed */.ng0(state.getFiberRefs()));
/* @internal */
const head = self => core/* flatMap */.VSD(self, as => {
  const iterator = as[Symbol.iterator]();
  const next = iterator.next();
  if (next.done) {
    return core/* fail */.bGj(new core/* NoSuchElementException */.buj());
  }
  return core/* succeed */.ng0(next.value);
});
/* @internal */
const ignore = self => match(self, {
  onFailure: Function/* constVoid */.Q1,
  onSuccess: Function/* constVoid */.Q1
});
/* @internal */
const ignoreLogged = self => core/* matchCauseEffect */.Bpg(self, {
  onFailure: cause => logDebug(cause, "An error was silently ignored because it is not anticipated to be useful"),
  onSuccess: () => core/* void */.Hcj
});
/* @internal */
const inheritFiberRefs = childFiberRefs => updateFiberRefs((parentFiberId, parentFiberRefs) => FiberRefs/* joinAs */.Ao(parentFiberRefs, parentFiberId, childFiberRefs));
/* @internal */
const isFailure = self => match(self, {
  onFailure: Function/* constTrue */.W8,
  onSuccess: Function/* constFalse */.jv
});
/* @internal */
const isSuccess = self => match(self, {
  onFailure: Function/* constFalse */.jv,
  onSuccess: Function/* constTrue */.W8
});
/* @internal */
const iterate = (initial, options) => core/* suspend */.RqG(() => {
  if (options.while(initial)) {
    return core/* flatMap */.VSD(options.body(initial), z2 => iterate(z2, options));
  }
  return core/* succeed */.ng0(initial);
});
/** @internal */
const logWithLevel = level => (...message) => {
  const levelOption = Option/* fromNullable */.ij(level);
  let cause = undefined;
  for (let i = 0, len = message.length; i < len; i++) {
    const msg = message[i];
    if (internal_cause/* isCause */.m_(msg)) {
      if (cause !== undefined) {
        cause = internal_cause/* sequential */.Pe(cause, msg);
      } else {
        cause = msg;
      }
      message = [...message.slice(0, i), ...message.slice(i + 1)];
      i--;
    }
  }
  if (cause === undefined) {
    cause = internal_cause/* empty */.cS;
  }
  return core/* withFiberRuntime */.ECC(fiberState => {
    fiberState.log(message, cause, levelOption);
    return core/* void */.Hcj;
  });
};
/** @internal */
const log = /*#__PURE__*/logWithLevel();
/** @internal */
const logTrace = /*#__PURE__*/logWithLevel(LogLevel/* Trace */.fM);
/** @internal */
const logDebug = /*#__PURE__*/logWithLevel(LogLevel/* Debug */.cG);
/** @internal */
const logInfo = /*#__PURE__*/logWithLevel(LogLevel/* Info */.kI);
/** @internal */
const logWarning = /*#__PURE__*/logWithLevel(LogLevel/* Warning */.v3);
/** @internal */
const logError = /*#__PURE__*/logWithLevel(LogLevel/* Error */.jj);
/** @internal */
const logFatal = /*#__PURE__*/logWithLevel(LogLevel/* Fatal */.Gu);
/* @internal */
const withLogSpan = /*#__PURE__*/(0,Function/* dual */.OB)(2, (effect, label) => core/* flatMap */.VSD(Clock/* currentTimeMillis */.b4, now => core/* fiberRefLocallyWith */.LzL(effect, core/* currentLogSpan */.yVv, List/* prepend */.Ce(make(label, now)))));
/* @internal */
const logAnnotations = /*#__PURE__*/core/* fiberRefGet */.grZ(core/* currentLogAnnotations */.cMe);
/* @internal */
const loop = (initial, options) => options.discard ? loopDiscard(initial, options.while, options.step, options.body) : core/* map */.UID(loopInternal(initial, options.while, options.step, options.body), esm_Array/* fromIterable */.EE);
const loopInternal = (initial, cont, inc, body) => core/* suspend */.RqG(() => cont(initial) ? core/* flatMap */.VSD(body(initial), a => core/* map */.UID(loopInternal(inc(initial), cont, inc, body), List/* prepend */.Ce(a))) : core/* sync */.Z_X(() => List/* empty */.cS()));
const loopDiscard = (initial, cont, inc, body) => core/* suspend */.RqG(() => cont(initial) ? core/* flatMap */.VSD(body(initial), () => loopDiscard(inc(initial), cont, inc, body)) : core/* void */.Hcj);
/* @internal */
const mapAccum = /*#__PURE__*/(0,Function/* dual */.OB)(3, (elements, initial, f) => core/* suspend */.RqG(() => {
  const iterator = elements[Symbol.iterator]();
  const builder = [];
  let result = core/* succeed */.ng0(initial);
  let next;
  let i = 0;
  while (!(next = iterator.next()).done) {
    const index = i++;
    const value = next.value;
    result = core/* flatMap */.VSD(result, state => core/* map */.UID(f(state, value, index), ([z, b]) => {
      builder.push(b);
      return z;
    }));
  }
  return core/* map */.UID(result, z => [z, builder]);
}));
/* @internal */
const mapErrorCause = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => core/* matchCauseEffect */.Bpg(self, {
  onFailure: c => core/* failCauseSync */.euP(() => f(c)),
  onSuccess: core/* succeed */.ng0
}));
/* @internal */
const memoize = self => (0,Function/* pipe */.zG)(core/* deferredMake */.kPu(), core/* flatMap */.VSD(deferred => (0,Function/* pipe */.zG)(diffFiberRefsAndRuntimeFlags(self), core/* intoDeferred */.S4Q(deferred), once, core/* map */.UID(complete => core/* zipRight */.qs5(complete, (0,Function/* pipe */.zG)(core/* deferredAwait */.Odg(deferred), core/* flatMap */.VSD(([patch, a]) => core.as(core/* zip */.$Re(patchFiberRefs(patch[0]), core/* updateRuntimeFlags */.$Cr(patch[1])), a))))))));
/* @internal */
const merge = self => core/* matchEffect */.PwY(self, {
  onFailure: e => core/* succeed */.ng0(e),
  onSuccess: core/* succeed */.ng0
});
/* @internal */
const negate = self => core/* map */.UID(self, b => !b);
/* @internal */
const none = self => core/* flatMap */.VSD(self, option => {
  switch (option._tag) {
    case "None":
      return core/* void */.Hcj;
    case "Some":
      return core/* fail */.bGj(new core/* NoSuchElementException */.buj());
  }
});
/* @internal */
const once = self => core/* map */.UID(Ref/* make */.Sy(true), ref => core/* asVoid */.a2S(core/* whenEffect */.FNZ(self, Ref/* getAndSet */.yO(ref, false))));
/* @internal */
const core_effect_option = self => core/* matchEffect */.PwY(self, {
  onFailure: () => core/* succeed */.ng0(Option/* none */.YP()),
  onSuccess: a => core/* succeed */.ng0(Option/* some */.G(a))
});
/* @internal */
const orElseFail = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, evaluate) => core/* orElse */.vxS(self, () => core/* failSync */.zph(evaluate)));
/* @internal */
const orElseSucceed = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, evaluate) => core/* orElse */.vxS(self, () => core/* sync */.Z_X(evaluate)));
/* @internal */
const parallelErrors = self => core/* matchCauseEffect */.Bpg(self, {
  onFailure: cause => {
    const errors = esm_Array/* fromIterable */.EE(internal_cause/* failures */.mq(cause));
    return errors.length === 0 ? core/* failCause */.DhG(cause) : core/* fail */.bGj(errors);
  },
  onSuccess: core/* succeed */.ng0
});
/* @internal */
const patchFiberRefs = patch => updateFiberRefs((fiberId, fiberRefs) => (0,Function/* pipe */.zG)(patch, fiberRefs_patch/* patch */.r$(fiberId, fiberRefs)));
/* @internal */
const promise = evaluate => evaluate.length >= 1 ? core/* async */.PFx((resolve, signal) => {
  try {
    evaluate(signal).then(a => resolve(core/* exitSucceed */.SID(a)), e => resolve(core/* exitDie */.ai8(e)));
  } catch (e) {
    resolve(core/* exitDie */.ai8(e));
  }
}) : core/* async */.PFx(resolve => {
  try {
    ;
    evaluate().then(a => resolve(core/* exitSucceed */.SID(a)), e => resolve(core/* exitDie */.ai8(e)));
  } catch (e) {
    resolve(core/* exitDie */.ai8(e));
  }
});
/* @internal */
const provideService = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, tag, service) => core/* contextWithEffect */.RuX(env => core/* provideContext */.qNZ(self, Context/* add */.IH(env, tag, service))));
/* @internal */
const provideServiceEffect = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, tag, effect) => core/* contextWithEffect */.RuX(env => core/* flatMap */.VSD(effect, service => core/* provideContext */.qNZ(self, (0,Function/* pipe */.zG)(env, Context/* add */.IH(tag, service))))));
/* @internal */
const random = /*#__PURE__*/defaultServices/* randomWith */.MD(core/* succeed */.ng0);
/* @internal */
const reduce = /*#__PURE__*/(0,Function/* dual */.OB)(3, (elements, zero, f) => esm_Array/* fromIterable */.EE(elements).reduce((acc, el, i) => core/* flatMap */.VSD(acc, a => f(a, el, i)), core/* succeed */.ng0(zero)));
/* @internal */
const reduceRight = /*#__PURE__*/(0,Function/* dual */.OB)(3, (elements, zero, f) => esm_Array/* fromIterable */.EE(elements).reduceRight((acc, el, i) => core/* flatMap */.VSD(acc, a => f(el, a, i)), core/* succeed */.ng0(zero)));
/* @internal */
const reduceWhile = /*#__PURE__*/(0,Function/* dual */.OB)(3, (elements, zero, options) => core/* flatMap */.VSD(core/* sync */.Z_X(() => elements[Symbol.iterator]()), iterator => reduceWhileLoop(iterator, 0, zero, options.while, options.body)));
const reduceWhileLoop = (iterator, index, state, predicate, f) => {
  const next = iterator.next();
  if (!next.done && predicate(state)) {
    return core/* flatMap */.VSD(f(state, next.value, index), nextState => reduceWhileLoop(iterator, index + 1, nextState, predicate, f));
  }
  return core/* succeed */.ng0(state);
};
/* @internal */
const repeatN = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, n) => core/* suspend */.RqG(() => repeatNLoop(self, n)));
/* @internal */
const repeatNLoop = (self, n) => core/* flatMap */.VSD(self, a => n <= 0 ? core/* succeed */.ng0(a) : core/* zipRight */.qs5(core/* yieldNow */.T4Q(), repeatNLoop(self, n - 1)));
/* @internal */
const sandbox = self => core/* matchCauseEffect */.Bpg(self, {
  onFailure: core/* fail */.bGj,
  onSuccess: core/* succeed */.ng0
});
/* @internal */
const setFiberRefs = fiberRefs => core/* suspend */.RqG(() => FiberRefs/* setAll */.Bi(fiberRefs));
/* @internal */
const sleep = Clock/* sleep */._v;
/* @internal */
const succeedNone = /*#__PURE__*/core/* succeed */.ng0( /*#__PURE__*/Option/* none */.YP());
/* @internal */
const succeedSome = value => core/* succeed */.ng0(Option/* some */.G(value));
/* @internal */
const summarized = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, summary, f) => core/* flatMap */.VSD(summary, start => core/* flatMap */.VSD(self, value => core/* map */.UID(summary, end => [f(start, end), value]))));
/* @internal */
const tagMetrics = /*#__PURE__*/(0,Function/* dual */.OB)(args => core/* isEffect */.cdB(args[0]), function () {
  return labelMetrics(arguments[0], typeof arguments[1] === "string" ? [label/* make */.Sy(arguments[1], arguments[2])] : Object.entries(arguments[1]).map(([k, v]) => label/* make */.Sy(k, v)));
});
/* @internal */
const labelMetrics = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, labels) => core/* fiberRefLocallyWith */.LzL(self, core/* currentMetricLabels */.VPq, old => esm_Array/* union */.G0(old, labels)));
/* @internal */
const takeUntil = /*#__PURE__*/(0,Function/* dual */.OB)(2, (elements, predicate) => core/* suspend */.RqG(() => {
  const iterator = elements[Symbol.iterator]();
  const builder = [];
  let next;
  let effect = core/* succeed */.ng0(false);
  let i = 0;
  while ((next = iterator.next()) && !next.done) {
    const a = next.value;
    const index = i++;
    effect = core/* flatMap */.VSD(effect, bool => {
      if (bool) {
        return core/* succeed */.ng0(true);
      }
      builder.push(a);
      return predicate(a, index);
    });
  }
  return core/* map */.UID(effect, () => builder);
}));
/* @internal */
const takeWhile = /*#__PURE__*/(0,Function/* dual */.OB)(2, (elements, predicate) => core/* suspend */.RqG(() => {
  const iterator = elements[Symbol.iterator]();
  const builder = [];
  let next;
  let taking = core/* succeed */.ng0(true);
  let i = 0;
  while ((next = iterator.next()) && !next.done) {
    const a = next.value;
    const index = i++;
    taking = core/* flatMap */.VSD(taking, taking => (0,Function/* pipe */.zG)(taking ? predicate(a, index) : core/* succeed */.ng0(false), core/* map */.UID(bool => {
      if (bool) {
        builder.push(a);
      }
      return bool;
    })));
  }
  return core/* map */.UID(taking, () => builder);
}));
/* @internal */
const tapBoth = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, {
  onFailure,
  onSuccess
}) => core/* matchCauseEffect */.Bpg(self, {
  onFailure: cause => {
    const either = internal_cause/* failureOrCause */.hl(cause);
    switch (either._tag) {
      case "Left":
        {
          return core/* zipRight */.qs5(onFailure(either.left), core/* failCause */.DhG(cause));
        }
      case "Right":
        {
          return core/* failCause */.DhG(cause);
        }
    }
  },
  onSuccess: a => core.as(onSuccess(a), a)
}));
/* @internal */
const tapDefect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => core/* catchAllCause */.Npq(self, cause => Option/* match */.EQ(internal_cause/* keepDefects */.tE(cause), {
  onNone: () => core/* failCause */.DhG(cause),
  onSome: a => core/* zipRight */.qs5(f(a), core/* failCause */.DhG(cause))
})));
/* @internal */
const tapError = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => core/* matchCauseEffect */.Bpg(self, {
  onFailure: cause => {
    const either = internal_cause/* failureOrCause */.hl(cause);
    switch (either._tag) {
      case "Left":
        return core/* zipRight */.qs5(f(either.left), core/* failCause */.DhG(cause));
      case "Right":
        return core/* failCause */.DhG(cause);
    }
  },
  onSuccess: core/* succeed */.ng0
}));
/* @internal */
const tapErrorTag = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, k, f) => tapError(self, e => {
  if (Predicate/* isTagged */.Bd(e, k)) {
    return f(e);
  }
  return core/* void */.Hcj;
}));
/* @internal */
const tapErrorCause = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => core/* matchCauseEffect */.Bpg(self, {
  onFailure: cause => core/* zipRight */.qs5(f(cause), core/* failCause */.DhG(cause)),
  onSuccess: core/* succeed */.ng0
}));
/* @internal */
const timed = self => timedWith(self, Clock/* currentTimeNanos */.Nl);
/* @internal */
const timedWith = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, nanos) => summarized(self, nanos, (start, end) => Duration/* nanos */.o6(end - start)));
/* @internal */
const core_effect_tracerWith = tracerWith;
/** @internal */
const tracer = /*#__PURE__*/core_effect_tracerWith(core/* succeed */.ng0);
/* @internal */
const tryPromise = arg => {
  let evaluate;
  let catcher = undefined;
  if (typeof arg === "function") {
    evaluate = arg;
  } else {
    evaluate = arg.try;
    catcher = arg.catch;
  }
  const fail = e => catcher ? core/* failSync */.zph(() => catcher(e)) : core/* fail */.bGj(new core/* UnknownException */.ioe(e, "An unknown error occurred in Effect.tryPromise"));
  if (evaluate.length >= 1) {
    return core/* async */.PFx((resolve, signal) => {
      try {
        evaluate(signal).then(a => resolve(core/* exitSucceed */.SID(a)), e => resolve(fail(e)));
      } catch (e) {
        resolve(fail(e));
      }
    });
  }
  return core/* async */.PFx(resolve => {
    try {
      evaluate().then(a => resolve(core/* exitSucceed */.SID(a)), e => resolve(fail(e)));
    } catch (e) {
      resolve(fail(e));
    }
  });
};
/* @internal */
const tryMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, options) => core/* flatMap */.VSD(self, a => try_({
  try: () => options.try(a),
  catch: options.catch
})));
/* @internal */
const tryMapPromise = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, options) => core/* flatMap */.VSD(self, a => tryPromise({
  try: options.try.length >= 1 ? signal => options.try(a, signal) : () => options.try(a),
  catch: options.catch
})));
/* @internal */
const unless = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, condition) => core/* suspend */.RqG(() => condition() ? succeedNone : asSome(self)));
/* @internal */
const unlessEffect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, condition) => core/* flatMap */.VSD(condition, b => b ? succeedNone : asSome(self)));
/* @internal */
const unsandbox = self => mapErrorCause(self, internal_cause/* flatten */.xH);
/* @internal */
const updateFiberRefs = f => core/* withFiberRuntime */.ECC(state => {
  state.setFiberRefs(f(state.id(), state.getFiberRefs()));
  return core/* void */.Hcj;
});
/* @internal */
const updateService = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, tag, f) => core/* mapInputContext */.nP$(self, context => Context/* add */.IH(context, tag, f(Context/* unsafeGet */.MH(context, tag)))));
/* @internal */
const when = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, condition) => core/* suspend */.RqG(() => condition() ? core/* map */.UID(self, Option/* some */.G) : core/* succeed */.ng0(Option/* none */.YP())));
/* @internal */
const whenFiberRef = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, fiberRef, predicate) => core/* flatMap */.VSD(core/* fiberRefGet */.grZ(fiberRef), s => predicate(s) ? core/* map */.UID(self, a => [s, Option/* some */.G(a)]) : core/* succeed */.ng0([s, Option/* none */.YP()])));
/* @internal */
const whenRef = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, ref, predicate) => core/* flatMap */.VSD(Ref/* get */.U2(ref), s => predicate(s) ? core/* map */.UID(self, a => [s, Option/* some */.G(a)]) : core/* succeed */.ng0([s, Option/* none */.YP()])));
/* @internal */
const withMetric = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, metric) => metric(self));
/** @internal */
const serviceFunctionEffect = (getService, f) => (...args) => core/* flatMap */.VSD(getService, a => f(a)(...args));
/** @internal */
const serviceFunction = (getService, f) => (...args) => core/* map */.UID(getService, a => f(a)(...args));
/** @internal */
const serviceFunctions = getService => new Proxy({}, {
  get(_target, prop, _receiver) {
    return (...args) => core/* flatMap */.VSD(getService, s => s[prop](...args));
  }
});
/** @internal */
const serviceConstants = getService => new Proxy({}, {
  get(_target, prop, _receiver) {
    return core/* flatMap */.VSD(getService, s => core/* isEffect */.cdB(s[prop]) ? s[prop] : core/* succeed */.ng0(s[prop]));
  }
});
/** @internal */
const serviceMembers = getService => ({
  functions: serviceFunctions(getService),
  constants: serviceConstants(getService)
});
/** @internal */
const serviceOption = tag => core/* map */.UID(core/* context */.Do7(), Context/* getOption */.Rl(tag));
/** @internal */
const serviceOptional = tag => core/* flatMap */.VSD(core/* context */.Do7(), Context/* getOption */.Rl(tag));
// -----------------------------------------------------------------------------
// tracing
// -----------------------------------------------------------------------------
/* @internal */
const annotateCurrentSpan = function () {
  const args = arguments;
  return ignore(core/* flatMap */.VSD(currentSpan, span => core/* sync */.Z_X(() => {
    if (typeof args[0] === "string") {
      span.attribute(args[0], args[1]);
    } else {
      for (const key in args[0]) {
        span.attribute(key, args[0][key]);
      }
    }
  })));
};
/* @internal */
const linkSpanCurrent = function () {
  const args = arguments;
  const links = Array.isArray(args[0]) ? args[0] : [{
    _tag: "SpanLink",
    span: args[0],
    attributes: args[1] ?? {}
  }];
  return ignore(core/* flatMap */.VSD(currentSpan, span => core/* sync */.Z_X(() => span.addLinks(links))));
};
/* @internal */
const annotateSpans = /*#__PURE__*/(0,Function/* dual */.OB)(args => core/* isEffect */.cdB(args[0]), function () {
  const args = arguments;
  return core/* fiberRefLocallyWith */.LzL(args[0], core/* currentTracerSpanAnnotations */.SUw, typeof args[1] === "string" ? HashMap/* set */.t8(args[1], args[2]) : annotations => Object.entries(args[1]).reduce((acc, [key, value]) => HashMap/* set */.t8(acc, key, value), annotations));
});
/** @internal */
const currentParentSpan = /*#__PURE__*/serviceOptional(internal_tracer/* spanTag */.N7);
/** @internal */
const currentSpan = /*#__PURE__*/core/* flatMap */.VSD( /*#__PURE__*/core/* context */.Do7(), context => {
  const span = context.unsafeMap.get(internal_tracer/* spanTag.key */.N7.key);
  return span !== undefined && span._tag === "Span" ? core/* succeed */.ng0(span) : core/* fail */.bGj(new core/* NoSuchElementException */.buj());
});
/* @internal */
const linkSpans = /*#__PURE__*/(0,Function/* dual */.OB)(args => core/* isEffect */.cdB(args[0]), (self, span, attributes) => core/* fiberRefLocallyWith */.LzL(self, core/* currentTracerSpanLinks */.krj, Chunk/* append */.R3({
  _tag: "SpanLink",
  span,
  attributes: attributes ?? {}
})));
const bigint0 = /*#__PURE__*/BigInt(0);
const filterDisablePropagation = /*#__PURE__*/Option/* flatMap */.VS(span => Context/* get */.U2(span.context, internal_tracer/* DisablePropagation */.jS) ? span._tag === "Span" ? filterDisablePropagation(span.parent) : Option/* none */.YP() : Option/* some */.G(span));
/** @internal */
const unsafeMakeSpan = (fiber, name, options) => {
  const disablePropagation = !fiber.getFiberRef(core/* currentTracerEnabled */.HXw) || options.context && Context/* get */.U2(options.context, internal_tracer/* DisablePropagation */.jS);
  const context = fiber.getFiberRef(core/* currentContext */.gbX);
  const parent = options.parent ? Option/* some */.G(options.parent) : options.root ? Option/* none */.YP() : filterDisablePropagation(Context/* getOption */.Rl(context, internal_tracer/* spanTag */.N7));
  let span;
  if (disablePropagation) {
    span = core/* noopSpan */.JAD({
      name,
      parent,
      context: Context/* add */.IH(options.context ?? Context/* empty */.cS(), internal_tracer/* DisablePropagation */.jS, true)
    });
  } else {
    const services = fiber.getFiberRef(defaultServices/* currentServices */.Pm);
    const tracer = Context/* get */.U2(services, internal_tracer/* tracerTag */.Fl);
    const clock = Context/* get */.U2(services, Clock/* Clock */.SU);
    const timingEnabled = fiber.getFiberRef(core/* currentTracerTimingEnabled */.of8);
    const fiberRefs = fiber.getFiberRefs();
    const annotationsFromEnv = FiberRefs/* get */.U2(fiberRefs, core/* currentTracerSpanAnnotations */.SUw);
    const linksFromEnv = FiberRefs/* get */.U2(fiberRefs, core/* currentTracerSpanLinks */.krj);
    const links = linksFromEnv._tag === "Some" ? options.links !== undefined ? [...Chunk/* toReadonlyArray */.AO(linksFromEnv.value), ...(options.links ?? [])] : Chunk/* toReadonlyArray */.AO(linksFromEnv.value) : options.links ?? esm_Array/* empty */.cS();
    span = tracer.span(name, parent, options.context ?? Context/* empty */.cS(), links, timingEnabled ? clock.unsafeCurrentTimeNanos() : bigint0, options.kind ?? "internal");
    if (annotationsFromEnv._tag === "Some") {
      HashMap/* forEach */.Ed(annotationsFromEnv.value, (value, key) => span.attribute(key, value));
    }
    if (options.attributes !== undefined) {
      Object.entries(options.attributes).forEach(([k, v]) => span.attribute(k, v));
    }
  }
  if (typeof options.captureStackTrace === "function") {
    internal_cause/* spanToTrace.set */.Vu.set(span, options.captureStackTrace);
  }
  return span;
};
/** @internal */
const makeSpan = (name, options) => {
  options = internal_tracer/* addSpanStackTrace */.W8(options);
  return core/* withFiberRuntime */.ECC(fiber => core/* succeed */.ng0(unsafeMakeSpan(fiber, name, options)));
};
/* @internal */
const spanAnnotations = /*#__PURE__*/core/* fiberRefGet */.grZ(core/* currentTracerSpanAnnotations */.SUw);
/* @internal */
const spanLinks = /*#__PURE__*/core/* fiberRefGet */.grZ(core/* currentTracerSpanLinks */.krj);
/** @internal */
const endSpan = (span, exit, clock, timingEnabled) => core/* sync */.Z_X(() => {
  if (span.status._tag === "Ended") {
    return;
  }
  if (core/* exitIsFailure */.Ioz(exit) && internal_cause/* spanToTrace.has */.Vu.has(span)) {
    span.attribute("code.stacktrace", internal_cause/* spanToTrace.get */.Vu.get(span)());
  }
  span.end(timingEnabled ? clock.unsafeCurrentTimeNanos() : bigint0, exit);
});
/** @internal */
const useSpan = (name, ...args) => {
  const options = internal_tracer/* addSpanStackTrace */.W8(args.length === 1 ? undefined : args[0]);
  const evaluate = args[args.length - 1];
  return core/* withFiberRuntime */.ECC(fiber => {
    const span = unsafeMakeSpan(fiber, name, options);
    const timingEnabled = fiber.getFiberRef(core/* currentTracerTimingEnabled */.of8);
    const clock = Context/* get */.U2(fiber.getFiberRef(defaultServices/* currentServices */.Pm), internal_clock/* clockTag */.GL);
    return core/* onExit */.dsk(evaluate(span), exit => endSpan(span, exit, clock, timingEnabled));
  });
};
/** @internal */
const withParentSpan = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, span) => provideService(self, internal_tracer/* spanTag */.N7, span));
/** @internal */
const withSpan = function () {
  const dataFirst = typeof arguments[0] !== "string";
  const name = dataFirst ? arguments[1] : arguments[0];
  const options = internal_tracer/* addSpanStackTrace */.W8(dataFirst ? arguments[2] : arguments[1]);
  if (dataFirst) {
    const self = arguments[0];
    return useSpan(name, options, span => withParentSpan(self, span));
  }
  return self => useSpan(name, options, span => withParentSpan(self, span));
};
const functionWithSpan = options => function () {
  let captureStackTrace = options.captureStackTrace ?? false;
  if (options.captureStackTrace !== false) {
    const limit = Error.stackTraceLimit;
    Error.stackTraceLimit = 2;
    const error = new Error();
    Error.stackTraceLimit = limit;
    let cache = false;
    captureStackTrace = () => {
      if (cache !== false) {
        return cache;
      }
      if (error.stack) {
        const stack = error.stack.trim().split("\n");
        cache = stack.slice(2).join("\n").trim();
        return cache;
      }
    };
  }
  return core/* suspend */.RqG(() => {
    const opts = typeof options.options === "function" ? options.options.apply(null, arguments) : options.options;
    return withSpan(core/* suspend */.RqG(() => (0,Utils/* internalCall */.MS)(() => options.body.apply(this, arguments))), opts.name, {
      ...opts,
      captureStackTrace
    });
  });
};
// -------------------------------------------------------------------------------------
// optionality
// -------------------------------------------------------------------------------------
/* @internal */
const fromNullable = value => value == null ? core/* fail */.bGj(new core/* NoSuchElementException */.buj()) : core/* succeed */.ng0(value);
/* @internal */
const optionFromOptional = self => core/* catchAll */.kmb(core/* map */.UID(self, Option/* some */.G), error => core/* isNoSuchElementException */.nNR(error) ? succeedNone : core/* fail */.bGj(error));
//# sourceMappingURL=core-effect.js.map

/***/ }),

/***/ 39355:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Bcn": function() { return /* binding */ CloseableScopeTypeId; },
  "Hjt": function() { return /* binding */ EffectTypeId; },
  "KOM": function() { return /* binding */ ExceededCapacityException; },
  "Zc0": function() { return /* binding */ ExceededCapacityExceptionTypeId; },
  "j5q": function() { return /* binding */ IllegalArgumentException; },
  "RHV": function() { return /* binding */ IllegalArgumentExceptionTypeId; },
  "rLI": function() { return /* binding */ InterruptedException; },
  "n67": function() { return /* binding */ InterruptedExceptionTypeId; },
  "nYm": function() { return /* binding */ InvalidPubSubCapacityExceptionTypeId; },
  "buj": function() { return /* binding */ NoSuchElementException; },
  "qM6": function() { return /* binding */ NoSuchElementExceptionTypeId; },
  "Zjb": function() { return /* binding */ RevertFlags; },
  "OZu": function() { return /* binding */ RuntimeException; },
  "m_5": function() { return /* binding */ RuntimeExceptionTypeId; },
  "otW": function() { return /* binding */ ScopeTypeId; },
  "R_A": function() { return /* binding */ TimeoutException; },
  "zMc": function() { return /* binding */ TimeoutExceptionTypeId; },
  "ioe": function() { return /* binding */ UnknownException; },
  "eQB": function() { return /* binding */ UnknownExceptionTypeId; },
  "LJp": function() { return /* binding */ YieldableError; },
  "ni3": function() { return /* binding */ acquireUseRelease; },
  "N8w": function() { return /* binding */ allLogLevels; },
  "Po9": function() { return /* binding */ andThen; },
  "as": function() { return /* binding */ as; },
  "a2S": function() { return /* binding */ asVoid; },
  "PFx": function() { return /* binding */ async_; },
  "qt5": function() { return /* binding */ asyncInterrupt; },
  "IN$": function() { return /* binding */ blocked; },
  "IED": function() { return /* binding */ capture; },
  "kmb": function() { return /* binding */ catchAll; },
  "Npq": function() { return /* binding */ catchAllCause; },
  "yNi": function() { return /* binding */ catchIf; },
  "ENG": function() { return /* binding */ catchSome; },
  "USh": function() { return /* binding */ causeSquash; },
  "WnW": function() { return /* binding */ causeSquashWith; },
  "oGW": function() { return /* binding */ checkInterruptible; },
  "Do7": function() { return /* binding */ context; },
  "RuX": function() { return /* binding */ contextWithEffect; },
  "vDZ": function() { return /* binding */ currentConcurrency; },
  "gbX": function() { return /* binding */ currentContext; },
  "ohq": function() { return /* binding */ currentForkScopeOverride; },
  "LFL": function() { return /* binding */ currentInterruptedCause; },
  "cMe": function() { return /* binding */ currentLogAnnotations; },
  "E0T": function() { return /* binding */ currentLogLevel; },
  "yVv": function() { return /* binding */ currentLogSpan; },
  "Of7": function() { return /* binding */ currentMaxOpsBeforeYield; },
  "VPq": function() { return /* binding */ currentMetricLabels; },
  "gTV": function() { return /* binding */ currentRequestBatching; },
  "opO": function() { return /* binding */ currentSchedulingPriority; },
  "vOg": function() { return /* binding */ currentSpanFromFiber; },
  "HXw": function() { return /* binding */ currentTracerEnabled; },
  "SUw": function() { return /* binding */ currentTracerSpanAnnotations; },
  "krj": function() { return /* binding */ currentTracerSpanLinks; },
  "of8": function() { return /* binding */ currentTracerTimingEnabled; },
  "tDY": function() { return /* binding */ currentUnhandledErrorLogLevel; },
  "PGm": function() { return /* binding */ custom; },
  "Odg": function() { return /* binding */ deferredAwait; },
  "klV": function() { return /* binding */ deferredComplete; },
  "KwY": function() { return /* binding */ deferredCompleteWith; },
  "pB5": function() { return /* binding */ deferredDie; },
  "skT": function() { return /* binding */ deferredDieSync; },
  "J9x": function() { return /* binding */ deferredDone; },
  "S5h": function() { return /* binding */ deferredFail; },
  "yd6": function() { return /* binding */ deferredFailCause; },
  "HSD": function() { return /* binding */ deferredFailCauseSync; },
  "i26": function() { return /* binding */ deferredFailSync; },
  "$cv": function() { return /* binding */ deferredInterrupt; },
  "n86": function() { return /* binding */ deferredInterruptWith; },
  "re6": function() { return /* binding */ deferredIsDone; },
  "kPu": function() { return /* binding */ deferredMake; },
  "HZA": function() { return /* binding */ deferredMakeAs; },
  "gKZ": function() { return /* binding */ deferredPoll; },
  "QtZ": function() { return /* binding */ deferredSucceed; },
  "UnW": function() { return /* binding */ deferredSync; },
  "zxF": function() { return /* binding */ deferredUnsafeDone; },
  "OJ4": function() { return /* binding */ deferredUnsafeMake; },
  "Xre": function() { return /* binding */ die; },
  "lFE": function() { return /* binding */ dieMessage; },
  "AgX": function() { return /* binding */ dieSync; },
  "wEe": function() { return /* binding */ either; },
  "JFt": function() { return /* binding */ exit; },
  "AZM": function() { return /* binding */ exitAs; },
  "MKG": function() { return /* binding */ exitAsVoid; },
  "fa7": function() { return /* binding */ exitCauseOption; },
  "jxF": function() { return /* binding */ exitCollectAll; },
  "ai8": function() { return /* binding */ exitDie; },
  "oMA": function() { return /* binding */ exitExists; },
  "bT5": function() { return /* binding */ exitFail; },
  "KiG": function() { return /* binding */ exitFailCause; },
  "SMH": function() { return /* binding */ exitFlatMap; },
  "pcb": function() { return /* binding */ exitFlatMapEffect; },
  "L$o": function() { return /* binding */ exitFlatten; },
  "XZ7": function() { return /* binding */ exitForEachEffect; },
  "KTm": function() { return /* binding */ exitFromEither; },
  "RxU": function() { return /* binding */ exitFromOption; },
  "giG": function() { return /* binding */ exitGetOrElse; },
  "eq6": function() { return /* binding */ exitInterrupt; },
  "fX8": function() { return /* binding */ exitIsExit; },
  "Ioz": function() { return /* binding */ exitIsFailure; },
  "y8V": function() { return /* binding */ exitIsInterrupted; },
  "dcz": function() { return /* binding */ exitIsSuccess; },
  "Fh8": function() { return /* binding */ exitMap; },
  "V74": function() { return /* binding */ exitMapBoth; },
  "HYP": function() { return /* binding */ exitMapError; },
  "wvn": function() { return /* binding */ exitMapErrorCause; },
  "Bs2": function() { return /* binding */ exitMatch; },
  "aoR": function() { return /* binding */ exitMatchEffect; },
  "SID": function() { return /* binding */ exitSucceed; },
  "E7$": function() { return /* binding */ exitVoid; },
  "a69": function() { return /* binding */ exitZip; },
  "_TW": function() { return /* binding */ exitZipLeft; },
  "$7G": function() { return /* binding */ exitZipPar; },
  "u9x": function() { return /* binding */ exitZipParLeft; },
  "VEn": function() { return /* binding */ exitZipParRight; },
  "XIR": function() { return /* binding */ exitZipRight; },
  "dG6": function() { return /* binding */ exitZipWith; },
  "bGj": function() { return /* binding */ fail; },
  "DhG": function() { return /* binding */ failCause; },
  "euP": function() { return /* binding */ failCauseSync; },
  "zph": function() { return /* binding */ failSync; },
  "ezx": function() { return /* binding */ fiberId; },
  "mrY": function() { return /* binding */ fiberIdWith; },
  "grZ": function() { return /* binding */ fiberRefGet; },
  "$Dw": function() { return /* binding */ fiberRefGetWith; },
  "EXC": function() { return /* binding */ fiberRefLocally; },
  "LzL": function() { return /* binding */ fiberRefLocallyWith; },
  "eqx": function() { return /* binding */ fiberRefSet; },
  "kgb": function() { return /* binding */ fiberRefUnsafeMake; },
  "BWU": function() { return /* binding */ fiberRefUnsafeMakeContext; },
  "WGV": function() { return /* binding */ fiberRefUnsafeMakeHashSet; },
  "laO": function() { return /* binding */ fiberRefUnsafeMakePatch; },
  "MZf": function() { return /* binding */ fiberRefUnsafeMakeRuntimeFlags; },
  "u_7": function() { return /* binding */ filterEffectOrElse; },
  "JEf": function() { return /* binding */ filterEffectOrFail; },
  "VSD": function() { return /* binding */ flatMap; },
  "xHg": function() { return /* binding */ flatten; },
  "RRI": function() { return /* binding */ flip; },
  "RC_": function() { return /* binding */ fnUntraced; },
  "o9$": function() { return /* binding */ forEachSequential; },
  "EaP": function() { return /* binding */ forEachSequentialDiscard; },
  "Yr4": function() { return /* binding */ gen; },
  "pHF": function() { return /* binding */ if_; },
  "e1i": function() { return /* binding */ interrupt; },
  "zU1": function() { return /* binding */ interruptAsFiber; },
  "u_W": function() { return /* binding */ interruptFiber; },
  "m4x": function() { return /* binding */ interruptWith; },
  "um_": function() { return /* binding */ interruptible; },
  "RxE": function() { return /* binding */ interruptibleMask; },
  "S4Q": function() { return /* binding */ intoDeferred; },
  "cdB": function() { return /* binding */ isEffect; },
  "B7o": function() { return /* binding */ isExceededCapacityException; },
  "jNB": function() { return /* binding */ isIllegalArgumentException; },
  "lNG": function() { return /* binding */ isInterruptedException; },
  "nNR": function() { return /* binding */ isNoSuchElementException; },
  "Gp9": function() { return /* binding */ isRuntimeException; },
  "DSj": function() { return /* binding */ isUnknownException; },
  "V_D": function() { return /* binding */ logLevelAll; },
  "M2X": function() { return /* binding */ logLevelDebug; },
  "Ngl": function() { return /* binding */ logLevelError; },
  "_7M": function() { return /* binding */ logLevelFatal; },
  "xUq": function() { return /* binding */ logLevelInfo; },
  "R$E": function() { return /* binding */ logLevelNone; },
  "Lth": function() { return /* binding */ logLevelTrace; },
  "RX8": function() { return /* binding */ logLevelWarning; },
  "UID": function() { return /* binding */ map; },
  "SAn": function() { return /* binding */ mapBoth; },
  "d1Y": function() { return /* binding */ mapError; },
  "nP$": function() { return /* binding */ mapInputContext; },
  "eYH": function() { return /* binding */ matchCause; },
  "Bpg": function() { return /* binding */ matchCauseEffect; },
  "PwY": function() { return /* binding */ matchEffect; },
  "x_F": function() { return /* binding */ metricLabels; },
  "FiN": function() { return /* binding */ never; },
  "JAD": function() { return /* binding */ noopSpan; },
  "qQ3": function() { return /* binding */ onError; },
  "dsk": function() { return /* binding */ onExit; },
  "J7b": function() { return /* binding */ onInterrupt; },
  "e3I": function() { return /* binding */ orDie; },
  "war": function() { return /* binding */ orDieWith; },
  "vxS": function() { return /* binding */ orElse; },
  "qko": function() { return /* binding */ originalInstance; },
  "tVo": function() { return /* binding */ partitionMap; },
  "qNZ": function() { return /* binding */ provideContext; },
  "Jng": function() { return /* binding */ provideSomeContext; },
  "f6m": function() { return /* binding */ runRequestBlock; },
  "CpT": function() { return /* binding */ core_runtimeFlags; },
  "tFM": function() { return /* binding */ scopeAddFinalizer; },
  "veJ": function() { return /* binding */ scopeAddFinalizerExit; },
  "roQ": function() { return /* binding */ scopeClose; },
  "Z5L": function() { return /* binding */ scopeFork; },
  "Nbs": function() { return /* binding */ step; },
  "ng0": function() { return /* binding */ succeed; },
  "RqG": function() { return /* binding */ suspend; },
  "Z_X": function() { return /* binding */ sync; },
  "bwX": function() { return /* binding */ tap; },
  "hx9": function() { return /* binding */ timeoutExceptionFromDuration; },
  "Yxn": function() { return /* binding */ transplant; },
  "wUc": function() { return /* binding */ uninterruptible; },
  "UO$": function() { return /* binding */ uninterruptibleMask; },
  "_OG": function() { return /* binding */ unsafeAsync; },
  "$Cr": function() { return /* binding */ updateRuntimeFlags; },
  "Hcj": function() { return /* binding */ void_; },
  "FNZ": function() { return /* binding */ whenEffect; },
  "Hib": function() { return /* binding */ whileLoop; },
  "l9G": function() { return /* binding */ withConcurrency; },
  "ECC": function() { return /* binding */ withFiberRuntime; },
  "U76": function() { return /* binding */ withMaxOpsBeforeYield; },
  "ZLd": function() { return /* binding */ withRequestBatching; },
  "ZYt": function() { return /* binding */ withRuntimeFlags; },
  "uqd": function() { return /* binding */ withSchedulingPriority; },
  "_uo": function() { return /* binding */ withTracerEnabled; },
  "ObN": function() { return /* binding */ withTracerTiming; },
  "uw7": function() { return /* binding */ withUnhandledErrorLogLevel; },
  "T4Q": function() { return /* binding */ yieldNow; },
  "$Re": function() { return /* binding */ zip; },
  "Ti7": function() { return /* binding */ zipLeft; },
  "qs5": function() { return /* binding */ zipRight; },
  "yL_": function() { return /* binding */ zipWith; }
});

// UNUSED EXPORTS: FiberRefTypeId, InvalidPubSubCapacityException, RequestResolverImpl, RequestResolverTypeId, attemptOrElse, contextWith, fiberRefDelete, fiberRefGetAndSet, fiberRefGetAndUpdate, fiberRefGetAndUpdateSome, fiberRefModify, fiberRefModifySome, fiberRefReset, fiberRefUnsafeMakeReadonlyArray, fiberRefUpdate, fiberRefUpdateAndGet, fiberRefUpdateSome, fiberRefUpdateSomeAndGet, fromIterator, isInvalidCapacityError, isRequestResolver, isTimeoutException, requestBlockLocally, resolverLocally, zipFlatten

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Array.js + 2 modules
var esm_Array = __webpack_require__(37901);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Chunk.js
var esm_Chunk = __webpack_require__(14109);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Context.js
var Context = __webpack_require__(20591);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Duration.js
var Duration = __webpack_require__(13571);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Either.js
var Either = __webpack_require__(87585);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equal.js
var esm_Equal = __webpack_require__(67492);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/FiberId.js
var FiberId = __webpack_require__(57303);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/GlobalValue.js
var GlobalValue = __webpack_require__(4726);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Hash.js
var esm_Hash = __webpack_require__(89379);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/HashMap.js + 1 modules
var HashMap = __webpack_require__(61952);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Inspectable.js
var Inspectable = __webpack_require__(16371);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/List.js
var List = __webpack_require__(16104);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/MutableRef.js
var MutableRef = __webpack_require__(23182);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var esm_Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Pipeable.js
var Pipeable = __webpack_require__(92817);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var Predicate = __webpack_require__(71335);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/RuntimeFlagsPatch.js
var RuntimeFlagsPatch = __webpack_require__(26045);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Utils.js
var Utils = __webpack_require__(70762);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/cause.js + 1 modules
var internal_cause = __webpack_require__(69579);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/deferred.js
var deferred = __webpack_require__(32387);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/differ.js
var internal_differ = __webpack_require__(49398);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/effectable.js
var effectable = __webpack_require__(10020);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/errors.js
var errors = __webpack_require__(3910);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/opCodes/deferred.js
var opCodes_deferred = __webpack_require__(4219);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/opCodes/effect.js
var opCodes_effect = __webpack_require__(11713);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/runtimeFlags.js
var runtimeFlags = __webpack_require__(4536);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/singleShotGen.js
/** @internal */
class SingleShotGen {
  self;
  called = false;
  constructor(self) {
    this.self = self;
  }
  next(a) {
    return this.called ? {
      value: a,
      done: true
    } : (this.called = true, {
      value: this.self,
      done: false
    });
  }
  return(a) {
    return {
      value: a,
      done: true
    };
  }
  throw(e) {
    throw e;
  }
  [Symbol.iterator]() {
    return new SingleShotGen(this.self);
  }
}
//# sourceMappingURL=singleShotGen.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/core.js





























// -----------------------------------------------------------------------------
// Effect
// -----------------------------------------------------------------------------
/**
 * @internal
 */
const blocked = (blockedRequests, _continue) => {
  const effect = new EffectPrimitive("Blocked");
  effect.effect_instruction_i0 = blockedRequests;
  effect.effect_instruction_i1 = _continue;
  return effect;
};
/**
 * @internal
 */
const runRequestBlock = blockedRequests => {
  const effect = new EffectPrimitive("RunBlocked");
  effect.effect_instruction_i0 = blockedRequests;
  return effect;
};
/** @internal */
const EffectTypeId = /*#__PURE__*/Symbol.for("effect/Effect");
/** @internal */
class RevertFlags {
  patch;
  op;
  _op = opCodes_effect/* OP_REVERT_FLAGS */.JX;
  constructor(patch, op) {
    this.patch = patch;
    this.op = op;
  }
}
class EffectPrimitive {
  _op;
  effect_instruction_i0 = undefined;
  effect_instruction_i1 = undefined;
  effect_instruction_i2 = undefined;
  trace = undefined;
  [EffectTypeId] = effectable/* effectVariance */.Qo;
  constructor(_op) {
    this._op = _op;
  }
  [esm_Equal/* symbol */.NA](that) {
    return this === that;
  }
  [esm_Hash/* symbol */.NA]() {
    return esm_Hash/* cached */.HX(this, esm_Hash/* random */.MX(this));
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
  toJSON() {
    return {
      _id: "Effect",
      _op: this._op,
      effect_instruction_i0: (0,Inspectable/* toJSON */.au)(this.effect_instruction_i0),
      effect_instruction_i1: (0,Inspectable/* toJSON */.au)(this.effect_instruction_i1),
      effect_instruction_i2: (0,Inspectable/* toJSON */.au)(this.effect_instruction_i2)
    };
  }
  toString() {
    return (0,Inspectable/* format */.WU)(this.toJSON());
  }
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return this.toJSON();
  }
  [Symbol.iterator]() {
    return new SingleShotGen(new Utils/* YieldWrap */.oY(this));
  }
}
/** @internal */
class EffectPrimitiveFailure {
  _op;
  effect_instruction_i0 = undefined;
  effect_instruction_i1 = undefined;
  effect_instruction_i2 = undefined;
  trace = undefined;
  [EffectTypeId] = effectable/* effectVariance */.Qo;
  constructor(_op) {
    this._op = _op;
    // @ts-expect-error
    this._tag = _op;
  }
  [esm_Equal/* symbol */.NA](that) {
    return exitIsExit(that) && that._op === "Failure" &&
    // @ts-expect-error
    esm_Equal/* equals */.fS(this.effect_instruction_i0, that.effect_instruction_i0);
  }
  [esm_Hash/* symbol */.NA]() {
    return (0,Function/* pipe */.zG)(
    // @ts-expect-error
    esm_Hash/* string */.Z_(this._tag),
    // @ts-expect-error
    esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.effect_instruction_i0)), esm_Hash/* cached */.HX(this));
  }
  get cause() {
    return this.effect_instruction_i0;
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
  toJSON() {
    return {
      _id: "Exit",
      _tag: this._op,
      cause: this.cause.toJSON()
    };
  }
  toString() {
    return (0,Inspectable/* format */.WU)(this.toJSON());
  }
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return this.toJSON();
  }
  [Symbol.iterator]() {
    return new SingleShotGen(new Utils/* YieldWrap */.oY(this));
  }
}
/** @internal */
class EffectPrimitiveSuccess {
  _op;
  effect_instruction_i0 = undefined;
  effect_instruction_i1 = undefined;
  effect_instruction_i2 = undefined;
  trace = undefined;
  [EffectTypeId] = effectable/* effectVariance */.Qo;
  constructor(_op) {
    this._op = _op;
    // @ts-expect-error
    this._tag = _op;
  }
  [esm_Equal/* symbol */.NA](that) {
    return exitIsExit(that) && that._op === "Success" &&
    // @ts-expect-error
    esm_Equal/* equals */.fS(this.effect_instruction_i0, that.effect_instruction_i0);
  }
  [esm_Hash/* symbol */.NA]() {
    return (0,Function/* pipe */.zG)(
    // @ts-expect-error
    esm_Hash/* string */.Z_(this._tag),
    // @ts-expect-error
    esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.effect_instruction_i0)), esm_Hash/* cached */.HX(this));
  }
  get value() {
    return this.effect_instruction_i0;
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
  toJSON() {
    return {
      _id: "Exit",
      _tag: this._op,
      value: (0,Inspectable/* toJSON */.au)(this.value)
    };
  }
  toString() {
    return (0,Inspectable/* format */.WU)(this.toJSON());
  }
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return this.toJSON();
  }
  [Symbol.iterator]() {
    return new SingleShotGen(new Utils/* YieldWrap */.oY(this));
  }
}
/** @internal */
const isEffect = u => (0,Predicate/* hasProperty */.l$)(u, EffectTypeId);
/* @internal */
const withFiberRuntime = withRuntime => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_WITH_RUNTIME */.EV);
  effect.effect_instruction_i0 = withRuntime;
  return effect;
};
/* @internal */
const acquireUseRelease = /*#__PURE__*/(0,Function/* dual */.OB)(3, (acquire, use, release) => uninterruptibleMask(restore => flatMap(acquire, a => flatMap(exit(suspend(() => restore(use(a)))), exit => {
  return suspend(() => release(a, exit)).pipe(matchCauseEffect({
    onFailure: cause => {
      switch (exit._tag) {
        case opCodes_effect/* OP_FAILURE */.N4:
          return failCause(internal_cause/* sequential */.Pe(exit.effect_instruction_i0, cause));
        case opCodes_effect/* OP_SUCCESS */.x$:
          return failCause(cause);
      }
    },
    onSuccess: () => exit
  }));
}))));
/* @internal */
const as = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, value) => flatMap(self, () => succeed(value)));
/* @internal */
const asVoid = self => as(self, void 0);
/* @internal */
const custom = function () {
  const wrapper = new EffectPrimitive(opCodes_effect/* OP_COMMIT */.vm);
  switch (arguments.length) {
    case 2:
      {
        wrapper.effect_instruction_i0 = arguments[0];
        wrapper.commit = arguments[1];
        break;
      }
    case 3:
      {
        wrapper.effect_instruction_i0 = arguments[0];
        wrapper.effect_instruction_i1 = arguments[1];
        wrapper.commit = arguments[2];
        break;
      }
    case 4:
      {
        wrapper.effect_instruction_i0 = arguments[0];
        wrapper.effect_instruction_i1 = arguments[1];
        wrapper.effect_instruction_i2 = arguments[2];
        wrapper.commit = arguments[3];
        break;
      }
    default:
      {
        throw new Error((0,errors/* getBugErrorMessage */.s)("you're not supposed to end up here"));
      }
  }
  return wrapper;
};
/* @internal */
const unsafeAsync = (register, blockingOn = FiberId/* none */.YP) => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_ASYNC */.m7);
  let cancelerRef = undefined;
  effect.effect_instruction_i0 = resume => {
    cancelerRef = register(resume);
  };
  effect.effect_instruction_i1 = blockingOn;
  return onInterrupt(effect, _ => isEffect(cancelerRef) ? cancelerRef : void_);
};
/* @internal */
const asyncInterrupt = (register, blockingOn = FiberId/* none */.YP) => suspend(() => unsafeAsync(register, blockingOn));
const async_ = (resume, blockingOn = FiberId/* none */.YP) => {
  return custom(resume, function () {
    let backingResume = undefined;
    let pendingEffect = undefined;
    function proxyResume(effect) {
      if (backingResume) {
        backingResume(effect);
      } else if (pendingEffect === undefined) {
        pendingEffect = effect;
      }
    }
    const effect = new EffectPrimitive(opCodes_effect/* OP_ASYNC */.m7);
    effect.effect_instruction_i0 = resume => {
      backingResume = resume;
      if (pendingEffect) {
        resume(pendingEffect);
      }
    };
    effect.effect_instruction_i1 = blockingOn;
    let cancelerRef = undefined;
    let controllerRef = undefined;
    if (this.effect_instruction_i0.length !== 1) {
      controllerRef = new AbortController();
      cancelerRef = (0,Utils/* internalCall */.MS)(() => this.effect_instruction_i0(proxyResume, controllerRef.signal));
    } else {
      cancelerRef = (0,Utils/* internalCall */.MS)(() => this.effect_instruction_i0(proxyResume));
    }
    return cancelerRef || controllerRef ? onInterrupt(effect, _ => {
      if (controllerRef) {
        controllerRef.abort();
      }
      return cancelerRef ?? void_;
    }) : effect;
  });
};

/* @internal */
const catchAllCause = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_ON_FAILURE */.PF);
  effect.effect_instruction_i0 = self;
  effect.effect_instruction_i1 = f;
  return effect;
});
/* @internal */
const catchAll = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => matchEffect(self, {
  onFailure: f,
  onSuccess: succeed
}));
/* @internal */
const catchIf = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, predicate, f) => catchAllCause(self, cause => {
  const either = internal_cause/* failureOrCause */.hl(cause);
  switch (either._tag) {
    case "Left":
      return predicate(either.left) ? f(either.left) : failCause(cause);
    case "Right":
      return failCause(either.right);
  }
}));
/* @internal */
const catchSome = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, pf) => catchAllCause(self, cause => {
  const either = internal_cause/* failureOrCause */.hl(cause);
  switch (either._tag) {
    case "Left":
      return (0,Function/* pipe */.zG)(pf(either.left), esm_Option/* getOrElse */.fS(() => failCause(cause)));
    case "Right":
      return failCause(either.right);
  }
}));
/* @internal */
const checkInterruptible = f => withFiberRuntime((_, status) => f(runtimeFlags/* interruption */.GO(status.runtimeFlags)));
const originalSymbol = /*#__PURE__*/Symbol.for("effect/OriginalAnnotation");
/* @internal */
const originalInstance = obj => {
  if ((0,Predicate/* hasProperty */.l$)(obj, originalSymbol)) {
    // @ts-expect-error
    return obj[originalSymbol];
  }
  return obj;
};
/* @internal */
const capture = (obj, span) => {
  if (esm_Option/* isSome */.pC(span)) {
    return new Proxy(obj, {
      has(target, p) {
        return p === internal_cause/* spanSymbol */.SC || p === originalSymbol || p in target;
      },
      get(target, p) {
        if (p === internal_cause/* spanSymbol */.SC) {
          return span.value;
        }
        if (p === originalSymbol) {
          return obj;
        }
        // @ts-expect-error
        return target[p];
      }
    });
  }
  return obj;
};
/* @internal */
const die = defect => (0,Predicate/* isObject */.Kn)(defect) && !(internal_cause/* spanSymbol */.SC in defect) ? withFiberRuntime(fiber => failCause(internal_cause/* die */.Xr(capture(defect, currentSpanFromFiber(fiber))))) : failCause(internal_cause/* die */.Xr(defect));
/* @internal */
const dieMessage = message => failCauseSync(() => internal_cause/* die */.Xr(new RuntimeException(message)));
/* @internal */
const dieSync = evaluate => flatMap(sync(evaluate), die);
/* @internal */
const either = self => matchEffect(self, {
  onFailure: e => succeed(Either/* left */.t$(e)),
  onSuccess: a => succeed(Either/* right */.F2(a))
});
/* @internal */
const exit = self => matchCause(self, {
  onFailure: exitFailCause,
  onSuccess: exitSucceed
});
/* @internal */
const fail = error => (0,Predicate/* isObject */.Kn)(error) && !(internal_cause/* spanSymbol */.SC in error) ? withFiberRuntime(fiber => failCause(internal_cause/* fail */.bG(capture(error, currentSpanFromFiber(fiber))))) : failCause(internal_cause/* fail */.bG(error));
/* @internal */
const failSync = evaluate => flatMap(sync(evaluate), fail);
/* @internal */
const failCause = cause => {
  const effect = new EffectPrimitiveFailure(opCodes_effect/* OP_FAILURE */.N4);
  effect.effect_instruction_i0 = cause;
  return effect;
};
/* @internal */
const failCauseSync = evaluate => flatMap(sync(evaluate), failCause);
/* @internal */
const fiberId = /*#__PURE__*/withFiberRuntime(state => succeed(state.id()));
/* @internal */
const fiberIdWith = f => withFiberRuntime(state => f(state.id()));
/* @internal */
const flatMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_ON_SUCCESS */.rm);
  effect.effect_instruction_i0 = self;
  effect.effect_instruction_i1 = f;
  return effect;
});
/* @internal */
const andThen = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => flatMap(self, a => {
  const b = typeof f === "function" ? f(a) : f;
  if (isEffect(b)) {
    return b;
  } else if ((0,Predicate/* isPromiseLike */.y8)(b)) {
    return unsafeAsync(resume => {
      b.then(a => resume(succeed(a)), e => resume(fail(new UnknownException(e, "An unknown error occurred in Effect.andThen"))));
    });
  }
  return succeed(b);
}));
/* @internal */
const step = self => {
  const effect = new EffectPrimitive("OnStep");
  effect.effect_instruction_i0 = self;
  return effect;
};
/* @internal */
const flatten = self => flatMap(self, Function/* identity */.yR);
/* @internal */
const flip = self => matchEffect(self, {
  onFailure: succeed,
  onSuccess: fail
});
/* @internal */
const matchCause = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, options) => matchCauseEffect(self, {
  onFailure: cause => succeed(options.onFailure(cause)),
  onSuccess: a => succeed(options.onSuccess(a))
}));
/* @internal */
const matchCauseEffect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, options) => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_ON_SUCCESS_AND_FAILURE */.kf);
  effect.effect_instruction_i0 = self;
  effect.effect_instruction_i1 = options.onFailure;
  effect.effect_instruction_i2 = options.onSuccess;
  return effect;
});
/* @internal */
const matchEffect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, options) => matchCauseEffect(self, {
  onFailure: cause => {
    const defects = internal_cause/* defects */.B4(cause);
    if (defects.length > 0) {
      return failCause(internal_cause/* electFailures */.jH(cause));
    }
    const failures = internal_cause/* failures */.mq(cause);
    if (failures.length > 0) {
      return options.onFailure(esm_Chunk/* unsafeHead */.nx(failures));
    }
    return failCause(cause);
  },
  onSuccess: options.onSuccess
}));
/* @internal */
const forEachSequential = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => suspend(() => {
  const arr = esm_Array/* fromIterable */.EE(self);
  const ret = esm_Array/* allocate */.TK(arr.length);
  let i = 0;
  return as(whileLoop({
    while: () => i < arr.length,
    body: () => f(arr[i], i),
    step: b => {
      ret[i++] = b;
    }
  }), ret);
}));
/* @internal */
const forEachSequentialDiscard = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => suspend(() => {
  const arr = esm_Array/* fromIterable */.EE(self);
  let i = 0;
  return whileLoop({
    while: () => i < arr.length,
    body: () => f(arr[i], i),
    step: () => {
      i++;
    }
  });
}));
/* @internal */
const if_ = /*#__PURE__*/(0,Function/* dual */.OB)(args => typeof args[0] === "boolean" || isEffect(args[0]), (self, options) => isEffect(self) ? flatMap(self, b => b ? options.onTrue() : options.onFalse()) : self ? options.onTrue() : options.onFalse());
/* @internal */
const interrupt = /*#__PURE__*/flatMap(fiberId, fiberId => interruptWith(fiberId));
/* @internal */
const interruptWith = fiberId => failCause(internal_cause/* interrupt */.e1(fiberId));
/* @internal */
const interruptible = self => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_UPDATE_RUNTIME_FLAGS */.rk);
  effect.effect_instruction_i0 = RuntimeFlagsPatch/* enable */.wp(runtimeFlags/* Interruption */.tm);
  effect.effect_instruction_i1 = () => self;
  return effect;
};
/* @internal */
const interruptibleMask = f => custom(f, function () {
  const effect = new EffectPrimitive(opCodes_effect/* OP_UPDATE_RUNTIME_FLAGS */.rk);
  effect.effect_instruction_i0 = RuntimeFlagsPatch/* enable */.wp(runtimeFlags/* Interruption */.tm);
  effect.effect_instruction_i1 = oldFlags => runtimeFlags/* interruption */.GO(oldFlags) ? (0,Utils/* internalCall */.MS)(() => this.effect_instruction_i0(interruptible)) : (0,Utils/* internalCall */.MS)(() => this.effect_instruction_i0(uninterruptible));
  return effect;
});
/* @internal */
const intoDeferred = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, deferred) => uninterruptibleMask(restore => flatMap(exit(restore(self)), exit => deferredDone(deferred, exit))));
/* @internal */
const map = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => flatMap(self, a => sync(() => f(a))));
/* @internal */
const mapBoth = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, options) => matchEffect(self, {
  onFailure: e => failSync(() => options.onFailure(e)),
  onSuccess: a => sync(() => options.onSuccess(a))
}));
/* @internal */
const mapError = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => matchCauseEffect(self, {
  onFailure: cause => {
    const either = internal_cause/* failureOrCause */.hl(cause);
    switch (either._tag) {
      case "Left":
        {
          return failSync(() => f(either.left));
        }
      case "Right":
        {
          return failCause(either.right);
        }
    }
  },
  onSuccess: succeed
}));
/* @internal */
const onError = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, cleanup) => onExit(self, exit => exitIsSuccess(exit) ? void_ : cleanup(exit.effect_instruction_i0)));
/* @internal */
const onExit = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, cleanup) => uninterruptibleMask(restore => matchCauseEffect(restore(self), {
  onFailure: cause1 => {
    const result = exitFailCause(cause1);
    return matchCauseEffect(cleanup(result), {
      onFailure: cause2 => exitFailCause(internal_cause/* sequential */.Pe(cause1, cause2)),
      onSuccess: () => result
    });
  },
  onSuccess: success => {
    const result = exitSucceed(success);
    return zipRight(cleanup(result), result);
  }
})));
/* @internal */
const onInterrupt = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, cleanup) => onExit(self, exitMatch({
  onFailure: cause => internal_cause/* isInterruptedOnly */.Jq(cause) ? asVoid(cleanup(internal_cause/* interruptors */.l7(cause))) : void_,
  onSuccess: () => void_
})));
/* @internal */
const orElse = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => attemptOrElse(self, that, succeed));
/* @internal */
const orDie = self => orDieWith(self, Function/* identity */.yR);
/* @internal */
const orDieWith = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => matchEffect(self, {
  onFailure: e => die(f(e)),
  onSuccess: succeed
}));
/* @internal */
const partitionMap = esm_Array/* partitionMap */.tV;
/* @internal */
const core_runtimeFlags = /*#__PURE__*/withFiberRuntime((_, status) => succeed(status.runtimeFlags));
/* @internal */
const succeed = value => {
  const effect = new EffectPrimitiveSuccess(opCodes_effect/* OP_SUCCESS */.x$);
  effect.effect_instruction_i0 = value;
  return effect;
};
/* @internal */
const suspend = evaluate => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_COMMIT */.vm);
  effect.commit = evaluate;
  return effect;
};
/* @internal */
const sync = thunk => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_SYNC */.Q0);
  effect.effect_instruction_i0 = thunk;
  return effect;
};
/* @internal */
const tap = /*#__PURE__*/(0,Function/* dual */.OB)(args => args.length === 3 || args.length === 2 && !((0,Predicate/* isObject */.Kn)(args[1]) && "onlyEffect" in args[1]), (self, f) => flatMap(self, a => {
  const b = typeof f === "function" ? f(a) : f;
  if (isEffect(b)) {
    return as(b, a);
  } else if ((0,Predicate/* isPromiseLike */.y8)(b)) {
    return unsafeAsync(resume => {
      b.then(_ => resume(succeed(a)), e => resume(fail(new UnknownException(e, "An unknown error occurred in Effect.tap"))));
    });
  }
  return succeed(a);
}));
/* @internal */
const transplant = f => withFiberRuntime(state => {
  const scopeOverride = state.getFiberRef(currentForkScopeOverride);
  const scope = (0,Function/* pipe */.zG)(scopeOverride, esm_Option/* getOrElse */.fS(() => state.scope()));
  return f(fiberRefLocally(currentForkScopeOverride, esm_Option/* some */.G(scope)));
});
/* @internal */
const attemptOrElse = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, that, onSuccess) => matchCauseEffect(self, {
  onFailure: cause => {
    const defects = internal_cause/* defects */.B4(cause);
    if (defects.length > 0) {
      return failCause(esm_Option/* getOrThrow */.gf(internal_cause/* keepDefectsAndElectFailures */.EI(cause)));
    }
    return that();
  },
  onSuccess
}));
/* @internal */
const uninterruptible = self => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_UPDATE_RUNTIME_FLAGS */.rk);
  effect.effect_instruction_i0 = RuntimeFlagsPatch/* disable */.h$(runtimeFlags/* Interruption */.tm);
  effect.effect_instruction_i1 = () => self;
  return effect;
};
/* @internal */
const uninterruptibleMask = f => custom(f, function () {
  const effect = new EffectPrimitive(opCodes_effect/* OP_UPDATE_RUNTIME_FLAGS */.rk);
  effect.effect_instruction_i0 = RuntimeFlagsPatch/* disable */.h$(runtimeFlags/* Interruption */.tm);
  effect.effect_instruction_i1 = oldFlags => runtimeFlags/* interruption */.GO(oldFlags) ? (0,Utils/* internalCall */.MS)(() => this.effect_instruction_i0(interruptible)) : (0,Utils/* internalCall */.MS)(() => this.effect_instruction_i0(uninterruptible));
  return effect;
});
const void_ = /*#__PURE__*/succeed(void 0);

/* @internal */
const updateRuntimeFlags = patch => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_UPDATE_RUNTIME_FLAGS */.rk);
  effect.effect_instruction_i0 = patch;
  effect.effect_instruction_i1 = void 0;
  return effect;
};
/* @internal */
const whenEffect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, condition) => flatMap(condition, b => {
  if (b) {
    return (0,Function/* pipe */.zG)(self, map(esm_Option/* some */.G));
  }
  return succeed(esm_Option/* none */.YP());
}));
/* @internal */
const whileLoop = options => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_WHILE */.Pv);
  effect.effect_instruction_i0 = options.while;
  effect.effect_instruction_i1 = options.body;
  effect.effect_instruction_i2 = options.step;
  return effect;
};
/* @internal */
const fromIterator = iterator => suspend(() => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_ITERATOR */.Rm);
  effect.effect_instruction_i0 = iterator();
  return effect;
});
/* @internal */
const gen = function () {
  const f = arguments.length === 1 ? arguments[0] : arguments[1].bind(arguments[0]);
  return fromIterator(() => f(Function/* pipe */.zG));
};
/** @internal */
const fnUntraced = (body, ...pipeables) => Object.defineProperty(pipeables.length === 0 ? function (...args) {
  return fromIterator(() => body.apply(this, args));
} : function (...args) {
  let effect = fromIterator(() => body.apply(this, args));
  for (const x of pipeables) {
    effect = x(effect, ...args);
  }
  return effect;
}, "length", {
  value: body.length,
  configurable: true
});
/* @internal */
const withConcurrency = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, concurrency) => fiberRefLocally(self, currentConcurrency, concurrency));
/* @internal */
const withRequestBatching = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, requestBatching) => fiberRefLocally(self, currentRequestBatching, requestBatching));
/* @internal */
const withRuntimeFlags = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, update) => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_UPDATE_RUNTIME_FLAGS */.rk);
  effect.effect_instruction_i0 = update;
  effect.effect_instruction_i1 = () => self;
  return effect;
});
/** @internal */
const withTracerEnabled = /*#__PURE__*/(0,Function/* dual */.OB)(2, (effect, enabled) => fiberRefLocally(effect, currentTracerEnabled, enabled));
/** @internal */
const withTracerTiming = /*#__PURE__*/(0,Function/* dual */.OB)(2, (effect, enabled) => fiberRefLocally(effect, currentTracerTimingEnabled, enabled));
/* @internal */
const yieldNow = options => {
  const effect = new EffectPrimitive(opCodes_effect/* OP_YIELD */.gl);
  return typeof options?.priority !== "undefined" ? withSchedulingPriority(effect, options.priority) : effect;
};
/* @internal */
const zip = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => flatMap(self, a => map(that, b => [a, b])));
/* @internal */
const zipFlatten = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => flatMap(self, a => map(that, b => [...a, b])))));
/* @internal */
const zipLeft = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => flatMap(self, a => as(that, a)));
/* @internal */
const zipRight = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => flatMap(self, () => that));
/* @internal */
const zipWith = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, that, f) => flatMap(self, a => map(that, b => f(a, b))));
/* @internal */
const never = /*#__PURE__*/asyncInterrupt(() => {
  const interval = setInterval(() => {
    //
  }, 2 ** 31 - 1);
  return sync(() => clearInterval(interval));
});
// -----------------------------------------------------------------------------
// Fiber
// -----------------------------------------------------------------------------
/* @internal */
const interruptFiber = self => flatMap(fiberId, fiberId => (0,Function/* pipe */.zG)(self, interruptAsFiber(fiberId)));
/* @internal */
const interruptAsFiber = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, fiberId) => flatMap(self.interruptAsFork(fiberId), () => self.await));
// -----------------------------------------------------------------------------
// LogLevel
// -----------------------------------------------------------------------------
/** @internal */
const logLevelAll = {
  _tag: "All",
  syslog: 0,
  label: "ALL",
  ordinal: Number.MIN_SAFE_INTEGER,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
};
/** @internal */
const logLevelFatal = {
  _tag: "Fatal",
  syslog: 2,
  label: "FATAL",
  ordinal: 50000,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
};
/** @internal */
const logLevelError = {
  _tag: "Error",
  syslog: 3,
  label: "ERROR",
  ordinal: 40000,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
};
/** @internal */
const logLevelWarning = {
  _tag: "Warning",
  syslog: 4,
  label: "WARN",
  ordinal: 30000,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
};
/** @internal */
const logLevelInfo = {
  _tag: "Info",
  syslog: 6,
  label: "INFO",
  ordinal: 20000,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
};
/** @internal */
const logLevelDebug = {
  _tag: "Debug",
  syslog: 7,
  label: "DEBUG",
  ordinal: 10000,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
};
/** @internal */
const logLevelTrace = {
  _tag: "Trace",
  syslog: 7,
  label: "TRACE",
  ordinal: 0,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
};
/** @internal */
const logLevelNone = {
  _tag: "None",
  syslog: 7,
  label: "OFF",
  ordinal: Number.MAX_SAFE_INTEGER,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
};
/** @internal */
const allLogLevels = [logLevelAll, logLevelTrace, logLevelDebug, logLevelInfo, logLevelWarning, logLevelError, logLevelFatal, logLevelNone];
// -----------------------------------------------------------------------------
// FiberRef
// -----------------------------------------------------------------------------
/** @internal */
const FiberRefSymbolKey = "effect/FiberRef";
/** @internal */
const FiberRefTypeId = /*#__PURE__*/Symbol.for(FiberRefSymbolKey);
const fiberRefVariance = {
  /* c8 ignore next */
  _A: _ => _
};
/* @internal */
const fiberRefGet = self => withFiberRuntime(fiber => exitSucceed(fiber.getFiberRef(self)));
/* @internal */
const fiberRefGetAndSet = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, value) => fiberRefModify(self, v => [v, value]))));
/* @internal */
const fiberRefGetAndUpdate = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => fiberRefModify(self, v => [v, f(v)]))));
/* @internal */
const fiberRefGetAndUpdateSome = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, pf) => fiberRefModify(self, v => [v, Option.getOrElse(pf(v), () => v)]))));
/* @internal */
const fiberRefGetWith = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => flatMap(fiberRefGet(self), f));
/* @internal */
const fiberRefSet = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, value) => fiberRefModify(self, () => [void 0, value]));
/* @internal */
const fiberRefDelete = self => withFiberRuntime(state => {
  state.unsafeDeleteFiberRef(self);
  return void_;
});
/* @internal */
const fiberRefReset = self => fiberRefSet(self, self.initial);
/* @internal */
const fiberRefModify = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => withFiberRuntime(state => {
  const [b, a] = f(state.getFiberRef(self));
  state.setFiberRef(self, a);
  return succeed(b);
}));
/* @internal */
const fiberRefModifySome = (self, def, f) => fiberRefModify(self, v => Option.getOrElse(f(v), () => [def, v]));
/* @internal */
const fiberRefUpdate = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => fiberRefModify(self, v => [void 0, f(v)]))));
/* @internal */
const fiberRefUpdateSome = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, pf) => fiberRefModify(self, v => [void 0, Option.getOrElse(pf(v), () => v)]))));
/* @internal */
const fiberRefUpdateAndGet = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => fiberRefModify(self, v => {
  const result = f(v);
  return [result, result];
}))));
/* @internal */
const fiberRefUpdateSomeAndGet = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, pf) => fiberRefModify(self, v => {
  const result = Option.getOrElse(pf(v), () => v);
  return [result, result];
}))));
// circular
/** @internal */
const RequestResolverSymbolKey = "effect/RequestResolver";
/** @internal */
const RequestResolverTypeId = /*#__PURE__*/Symbol.for(RequestResolverSymbolKey);
const requestResolverVariance = {
  /* c8 ignore next */
  _A: _ => _,
  /* c8 ignore next */
  _R: _ => _
};
/** @internal */
class RequestResolverImpl {
  runAll;
  target;
  [RequestResolverTypeId] = requestResolverVariance;
  constructor(runAll, target) {
    this.runAll = runAll;
    this.target = target;
  }
  [esm_Hash/* symbol */.NA]() {
    return Hash.cached(this, this.target ? Hash.hash(this.target) : Hash.random(this));
  }
  [esm_Equal/* symbol */.NA](that) {
    return this.target ? isRequestResolver(that) && Equal.equals(this.target, that.target) : this === that;
  }
  identified(...ids) {
    return new RequestResolverImpl(this.runAll, Chunk.fromIterable(ids));
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}
/** @internal */
const isRequestResolver = u => hasProperty(u, RequestResolverTypeId);
// end
/** @internal */
const resolverLocally = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (use, self, value) => new RequestResolverImpl(requests => fiberRefLocally(use.runAll(requests), self, value), Chunk.make("Locally", use, self, value)))));
/** @internal */
const requestBlockLocally = (self, ref, value) => blockedRequests_.reduce(self, LocallyReducer(ref, value));
const LocallyReducer = (ref, value) => ({
  emptyCase: () => blockedRequests_.empty,
  parCase: (left, right) => blockedRequests_.par(left, right),
  seqCase: (left, right) => blockedRequests_.seq(left, right),
  singleCase: (dataSource, blockedRequest) => blockedRequests_.single(resolverLocally(dataSource, ref, value), blockedRequest)
});
/* @internal */
const fiberRefLocally = /*#__PURE__*/(0,Function/* dual */.OB)(3, (use, self, value) => acquireUseRelease(zipLeft(fiberRefGet(self), fiberRefSet(self, value)), () => use, oldValue => fiberRefSet(self, oldValue)));
/* @internal */
const fiberRefLocallyWith = /*#__PURE__*/(0,Function/* dual */.OB)(3, (use, self, f) => fiberRefGetWith(self, a => fiberRefLocally(use, self, f(a))));
/** @internal */
const fiberRefUnsafeMake = (initial, options) => fiberRefUnsafeMakePatch(initial, {
  differ: internal_differ/* update */.Vx(),
  fork: options?.fork ?? Function/* identity */.yR,
  join: options?.join
});
/** @internal */
const fiberRefUnsafeMakeHashSet = initial => {
  const differ = internal_differ/* hashSet */.OS();
  return fiberRefUnsafeMakePatch(initial, {
    differ,
    fork: differ.empty
  });
};
/** @internal */
const fiberRefUnsafeMakeReadonlyArray = initial => {
  const differ = internal_differ/* readonlyArray */.Bk(internal_differ/* update */.Vx());
  return fiberRefUnsafeMakePatch(initial, {
    differ,
    fork: differ.empty
  });
};
/** @internal */
const fiberRefUnsafeMakeContext = initial => {
  const differ = internal_differ/* environment */.NZ();
  return fiberRefUnsafeMakePatch(initial, {
    differ,
    fork: differ.empty
  });
};
/** @internal */
const fiberRefUnsafeMakePatch = (initial, options) => {
  const _fiberRef = {
    ...effectable/* CommitPrototype */.ku,
    [FiberRefTypeId]: fiberRefVariance,
    initial,
    commit() {
      return fiberRefGet(this);
    },
    diff: (oldValue, newValue) => options.differ.diff(oldValue, newValue),
    combine: (first, second) => options.differ.combine(first, second),
    patch: patch => oldValue => options.differ.patch(patch, oldValue),
    fork: options.fork,
    join: options.join ?? ((_, n) => n)
  };
  return _fiberRef;
};
/** @internal */
const fiberRefUnsafeMakeRuntimeFlags = initial => fiberRefUnsafeMakePatch(initial, {
  differ: runtimeFlags/* differ */.FZ,
  fork: runtimeFlags/* differ.empty */.FZ.empty
});
/** @internal */
const currentContext = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentContext"), () => fiberRefUnsafeMakeContext(Context/* empty */.cS()));
/** @internal */
const currentSchedulingPriority = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentSchedulingPriority"), () => fiberRefUnsafeMake(0));
/** @internal */
const currentMaxOpsBeforeYield = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentMaxOpsBeforeYield"), () => fiberRefUnsafeMake(2048));
/** @internal */
const currentLogAnnotations = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentLogAnnotation"), () => fiberRefUnsafeMake(HashMap/* empty */.cS()));
/** @internal */
const currentLogLevel = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentLogLevel"), () => fiberRefUnsafeMake(logLevelInfo));
/** @internal */
const currentLogSpan = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentLogSpan"), () => fiberRefUnsafeMake(List/* empty */.cS()));
/** @internal */
const withSchedulingPriority = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, scheduler) => fiberRefLocally(self, currentSchedulingPriority, scheduler));
/** @internal */
const withMaxOpsBeforeYield = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, scheduler) => fiberRefLocally(self, currentMaxOpsBeforeYield, scheduler));
/** @internal */
const currentConcurrency = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentConcurrency"), () => fiberRefUnsafeMake("unbounded"));
/**
 * @internal
 */
const currentRequestBatching = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentRequestBatching"), () => fiberRefUnsafeMake(true));
/** @internal */
const currentUnhandledErrorLogLevel = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentUnhandledErrorLogLevel"), () => fiberRefUnsafeMake(esm_Option/* some */.G(logLevelDebug)));
/** @internal */
const withUnhandledErrorLogLevel = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, level) => fiberRefLocally(self, currentUnhandledErrorLogLevel, level));
/** @internal */
const currentMetricLabels = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentMetricLabels"), () => fiberRefUnsafeMakeReadonlyArray(esm_Array/* empty */.cS()));
/* @internal */
const metricLabels = /*#__PURE__*/fiberRefGet(currentMetricLabels);
/** @internal */
const currentForkScopeOverride = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentForkScopeOverride"), () => fiberRefUnsafeMake(esm_Option/* none */.YP(), {
  fork: () => esm_Option/* none */.YP(),
  join: (parent, _) => parent
}));
/** @internal */
const currentInterruptedCause = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentInterruptedCause"), () => fiberRefUnsafeMake(internal_cause/* empty */.cS, {
  fork: () => internal_cause/* empty */.cS,
  join: (parent, _) => parent
}));
/** @internal */
const currentTracerEnabled = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentTracerEnabled"), () => fiberRefUnsafeMake(true));
/** @internal */
const currentTracerTimingEnabled = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentTracerTiming"), () => fiberRefUnsafeMake(true));
/** @internal */
const currentTracerSpanAnnotations = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentTracerSpanAnnotations"), () => fiberRefUnsafeMake(HashMap/* empty */.cS()));
/** @internal */
const currentTracerSpanLinks = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentTracerSpanLinks"), () => fiberRefUnsafeMake(esm_Chunk/* empty */.cS()));
// -----------------------------------------------------------------------------
// Scope
// -----------------------------------------------------------------------------
/** @internal */
const ScopeTypeId = /*#__PURE__*/Symbol.for("effect/Scope");
/** @internal */
const CloseableScopeTypeId = /*#__PURE__*/Symbol.for("effect/CloseableScope");
/* @internal */
const scopeAddFinalizer = (self, finalizer) => self.addFinalizer(() => asVoid(finalizer));
/* @internal */
const scopeAddFinalizerExit = (self, finalizer) => self.addFinalizer(finalizer);
/* @internal */
const scopeClose = (self, exit) => self.close(exit);
/* @internal */
const scopeFork = (self, strategy) => self.fork(strategy);
// -----------------------------------------------------------------------------
// Cause
// -----------------------------------------------------------------------------
/** @internal */
const causeSquash = self => {
  return causeSquashWith(Function/* identity */.yR)(self);
};
/** @internal */
const causeSquashWith = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const option = (0,Function/* pipe */.zG)(self, internal_cause/* failureOption */.Iv, esm_Option/* map */.UI(f));
  switch (option._tag) {
    case "None":
      {
        return (0,Function/* pipe */.zG)(internal_cause/* defects */.B4(self), esm_Chunk/* head */.YM, esm_Option/* match */.EQ({
          onNone: () => {
            const interrupts = esm_Array/* fromIterable */.EE(internal_cause/* interruptors */.l7(self)).flatMap(fiberId => esm_Array/* fromIterable */.EE(FiberId/* ids */.r$(fiberId)).map(id => `#${id}`));
            return new InterruptedException(interrupts ? `Interrupted by fibers: ${interrupts.join(", ")}` : void 0);
          },
          onSome: Function/* identity */.yR
        }));
      }
    case "Some":
      {
        return option.value;
      }
  }
});
// -----------------------------------------------------------------------------
// Errors
// -----------------------------------------------------------------------------
/** @internal */
const YieldableError = /*#__PURE__*/function () {
  class YieldableError extends globalThis.Error {
    commit() {
      return fail(this);
    }
    toJSON() {
      const obj = {
        ...this
      };
      if (this.message) obj.message = this.message;
      if (this.cause) obj.cause = this.cause;
      return obj;
    }
    [Inspectable/* NodeInspectSymbol */.j5]() {
      if (this.toString !== globalThis.Error.prototype.toString) {
        return this.stack ? `${this.toString()}\n${this.stack.split("\n").slice(1).join("\n")}` : this.toString();
      } else if ("Bun" in globalThis) {
        return internal_cause/* pretty */.IC(internal_cause/* fail */.bG(this), {
          renderErrorCause: true
        });
      }
      return this;
    }
  }
  Object.assign(YieldableError.prototype, effectable/* StructuralCommitPrototype */.Sh);
  return YieldableError;
}();
const makeException = (proto, tag) => {
  class Base extends YieldableError {
    _tag = tag;
  }
  Object.assign(Base.prototype, proto);
  Base.prototype.name = tag;
  return Base;
};
/** @internal */
const RuntimeExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Cause/errors/RuntimeException");
/** @internal */
const RuntimeException = /*#__PURE__*/makeException({
  [RuntimeExceptionTypeId]: RuntimeExceptionTypeId
}, "RuntimeException");
/** @internal */
const isRuntimeException = u => (0,Predicate/* hasProperty */.l$)(u, RuntimeExceptionTypeId);
/** @internal */
const InterruptedExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Cause/errors/InterruptedException");
/** @internal */
const InterruptedException = /*#__PURE__*/makeException({
  [InterruptedExceptionTypeId]: InterruptedExceptionTypeId
}, "InterruptedException");
/** @internal */
const isInterruptedException = u => (0,Predicate/* hasProperty */.l$)(u, InterruptedExceptionTypeId);
/** @internal */
const IllegalArgumentExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Cause/errors/IllegalArgument");
/** @internal */
const IllegalArgumentException = /*#__PURE__*/makeException({
  [IllegalArgumentExceptionTypeId]: IllegalArgumentExceptionTypeId
}, "IllegalArgumentException");
/** @internal */
const isIllegalArgumentException = u => (0,Predicate/* hasProperty */.l$)(u, IllegalArgumentExceptionTypeId);
/** @internal */
const NoSuchElementExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Cause/errors/NoSuchElement");
/** @internal */
const NoSuchElementException = /*#__PURE__*/makeException({
  [NoSuchElementExceptionTypeId]: NoSuchElementExceptionTypeId
}, "NoSuchElementException");
/** @internal */
const isNoSuchElementException = u => (0,Predicate/* hasProperty */.l$)(u, NoSuchElementExceptionTypeId);
/** @internal */
const InvalidPubSubCapacityExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Cause/errors/InvalidPubSubCapacityException");
/** @internal */
const InvalidPubSubCapacityException = /*#__PURE__*/makeException({
  [InvalidPubSubCapacityExceptionTypeId]: InvalidPubSubCapacityExceptionTypeId
}, "InvalidPubSubCapacityException");
/** @internal */
const ExceededCapacityExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Cause/errors/ExceededCapacityException");
/** @internal */
const ExceededCapacityException = /*#__PURE__*/makeException({
  [ExceededCapacityExceptionTypeId]: ExceededCapacityExceptionTypeId
}, "ExceededCapacityException");
/** @internal */
const isExceededCapacityException = u => (0,Predicate/* hasProperty */.l$)(u, ExceededCapacityExceptionTypeId);
/** @internal */
const isInvalidCapacityError = u => hasProperty(u, InvalidPubSubCapacityExceptionTypeId);
/** @internal */
const TimeoutExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Cause/errors/Timeout");
/** @internal */
const TimeoutException = /*#__PURE__*/makeException({
  [TimeoutExceptionTypeId]: TimeoutExceptionTypeId
}, "TimeoutException");
/** @internal */
const timeoutExceptionFromDuration = duration => new TimeoutException(`Operation timed out after '${Duration/* format */.WU(duration)}'`);
/** @internal */
const isTimeoutException = u => hasProperty(u, TimeoutExceptionTypeId);
/** @internal */
const UnknownExceptionTypeId = /*#__PURE__*/Symbol.for("effect/Cause/errors/UnknownException");
/** @internal */
const UnknownException = /*#__PURE__*/function () {
  class UnknownException extends YieldableError {
    _tag = "UnknownException";
    error;
    constructor(cause, message) {
      super(message ?? "An unknown error occurred", {
        cause
      });
      this.error = cause;
    }
  }
  Object.assign(UnknownException.prototype, {
    [UnknownExceptionTypeId]: UnknownExceptionTypeId,
    name: "UnknownException"
  });
  return UnknownException;
}();
/** @internal */
const isUnknownException = u => (0,Predicate/* hasProperty */.l$)(u, UnknownExceptionTypeId);
// -----------------------------------------------------------------------------
// Exit
// -----------------------------------------------------------------------------
/** @internal */
const exitIsExit = u => isEffect(u) && "_tag" in u && (u._tag === "Success" || u._tag === "Failure");
/** @internal */
const exitIsFailure = self => self._tag === "Failure";
/** @internal */
const exitIsSuccess = self => self._tag === "Success";
/** @internal */
const exitIsInterrupted = self => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      return internal_cause/* isInterrupted */.td(self.effect_instruction_i0);
    case opCodes_effect/* OP_SUCCESS */.x$:
      return false;
  }
};
/** @internal */
const exitAs = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, value) => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      {
        return exitFailCause(self.effect_instruction_i0);
      }
    case opCodes_effect/* OP_SUCCESS */.x$:
      {
        return exitSucceed(value);
      }
  }
});
/** @internal */
const exitAsVoid = self => exitAs(self, void 0);
/** @internal */
const exitCauseOption = self => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      return esm_Option/* some */.G(self.effect_instruction_i0);
    case opCodes_effect/* OP_SUCCESS */.x$:
      return esm_Option/* none */.YP();
  }
};
/** @internal */
const exitCollectAll = (exits, options) => exitCollectAllInternal(exits, options?.parallel ? internal_cause/* parallel */.Mf : internal_cause/* sequential */.Pe);
/** @internal */
const exitDie = defect => exitFailCause(internal_cause/* die */.Xr(defect));
/** @internal */
const exitExists = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, refinement) => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      return false;
    case opCodes_effect/* OP_SUCCESS */.x$:
      return refinement(self.effect_instruction_i0);
  }
});
/** @internal */
const exitFail = error => exitFailCause(internal_cause/* fail */.bG(error));
/** @internal */
const exitFailCause = cause => {
  const effect = new EffectPrimitiveFailure(opCodes_effect/* OP_FAILURE */.N4);
  effect.effect_instruction_i0 = cause;
  return effect;
};
/** @internal */
const exitFlatMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      {
        return exitFailCause(self.effect_instruction_i0);
      }
    case opCodes_effect/* OP_SUCCESS */.x$:
      {
        return f(self.effect_instruction_i0);
      }
  }
});
/** @internal */
const exitFlatMapEffect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      {
        return succeed(exitFailCause(self.effect_instruction_i0));
      }
    case opCodes_effect/* OP_SUCCESS */.x$:
      {
        return f(self.effect_instruction_i0);
      }
  }
});
/** @internal */
const exitFlatten = self => (0,Function/* pipe */.zG)(self, exitFlatMap(Function/* identity */.yR));
/** @internal */
const exitForEachEffect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      {
        return succeed(exitFailCause(self.effect_instruction_i0));
      }
    case opCodes_effect/* OP_SUCCESS */.x$:
      {
        return exit(f(self.effect_instruction_i0));
      }
  }
});
/** @internal */
const exitFromEither = either => {
  switch (either._tag) {
    case "Left":
      return exitFail(either.left);
    case "Right":
      return exitSucceed(either.right);
  }
};
/** @internal */
const exitFromOption = option => {
  switch (option._tag) {
    case "None":
      return exitFail(void 0);
    case "Some":
      return exitSucceed(option.value);
  }
};
/** @internal */
const exitGetOrElse = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, orElse) => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      return orElse(self.effect_instruction_i0);
    case opCodes_effect/* OP_SUCCESS */.x$:
      return self.effect_instruction_i0;
  }
});
/** @internal */
const exitInterrupt = fiberId => exitFailCause(internal_cause/* interrupt */.e1(fiberId));
/** @internal */
const exitMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      return exitFailCause(self.effect_instruction_i0);
    case opCodes_effect/* OP_SUCCESS */.x$:
      return exitSucceed(f(self.effect_instruction_i0));
  }
});
/** @internal */
const exitMapBoth = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, {
  onFailure,
  onSuccess
}) => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      return exitFailCause((0,Function/* pipe */.zG)(self.effect_instruction_i0, internal_cause/* map */.UI(onFailure)));
    case opCodes_effect/* OP_SUCCESS */.x$:
      return exitSucceed(onSuccess(self.effect_instruction_i0));
  }
});
/** @internal */
const exitMapError = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      return exitFailCause((0,Function/* pipe */.zG)(self.effect_instruction_i0, internal_cause/* map */.UI(f)));
    case opCodes_effect/* OP_SUCCESS */.x$:
      return exitSucceed(self.effect_instruction_i0);
  }
});
/** @internal */
const exitMapErrorCause = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      return exitFailCause(f(self.effect_instruction_i0));
    case opCodes_effect/* OP_SUCCESS */.x$:
      return exitSucceed(self.effect_instruction_i0);
  }
});
/** @internal */
const exitMatch = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, {
  onFailure,
  onSuccess
}) => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      return onFailure(self.effect_instruction_i0);
    case opCodes_effect/* OP_SUCCESS */.x$:
      return onSuccess(self.effect_instruction_i0);
  }
});
/** @internal */
const exitMatchEffect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, {
  onFailure,
  onSuccess
}) => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      return onFailure(self.effect_instruction_i0);
    case opCodes_effect/* OP_SUCCESS */.x$:
      return onSuccess(self.effect_instruction_i0);
  }
});
/** @internal */
const exitSucceed = value => {
  const effect = new EffectPrimitiveSuccess(opCodes_effect/* OP_SUCCESS */.x$);
  effect.effect_instruction_i0 = value;
  return effect;
};
/** @internal */
const exitVoid = /*#__PURE__*/exitSucceed(void 0);
/** @internal */
const exitZip = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => exitZipWith(self, that, {
  onSuccess: (a, a2) => [a, a2],
  onFailure: internal_cause/* sequential */.Pe
}));
/** @internal */
const exitZipLeft = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => exitZipWith(self, that, {
  onSuccess: (a, _) => a,
  onFailure: internal_cause/* sequential */.Pe
}));
/** @internal */
const exitZipRight = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => exitZipWith(self, that, {
  onSuccess: (_, a2) => a2,
  onFailure: internal_cause/* sequential */.Pe
}));
/** @internal */
const exitZipPar = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => exitZipWith(self, that, {
  onSuccess: (a, a2) => [a, a2],
  onFailure: internal_cause/* parallel */.Mf
}));
/** @internal */
const exitZipParLeft = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => exitZipWith(self, that, {
  onSuccess: (a, _) => a,
  onFailure: internal_cause/* parallel */.Mf
}));
/** @internal */
const exitZipParRight = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => exitZipWith(self, that, {
  onSuccess: (_, a2) => a2,
  onFailure: internal_cause/* parallel */.Mf
}));
/** @internal */
const exitZipWith = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, that, {
  onFailure,
  onSuccess
}) => {
  switch (self._tag) {
    case opCodes_effect/* OP_FAILURE */.N4:
      {
        switch (that._tag) {
          case opCodes_effect/* OP_SUCCESS */.x$:
            return exitFailCause(self.effect_instruction_i0);
          case opCodes_effect/* OP_FAILURE */.N4:
            {
              return exitFailCause(onFailure(self.effect_instruction_i0, that.effect_instruction_i0));
            }
        }
      }
    case opCodes_effect/* OP_SUCCESS */.x$:
      {
        switch (that._tag) {
          case opCodes_effect/* OP_SUCCESS */.x$:
            return exitSucceed(onSuccess(self.effect_instruction_i0, that.effect_instruction_i0));
          case opCodes_effect/* OP_FAILURE */.N4:
            return exitFailCause(that.effect_instruction_i0);
        }
      }
  }
});
const exitCollectAllInternal = (exits, combineCauses) => {
  const list = esm_Chunk/* fromIterable */.EE(exits);
  if (!esm_Chunk/* isNonEmpty */.Od(list)) {
    return esm_Option/* none */.YP();
  }
  return (0,Function/* pipe */.zG)(esm_Chunk/* tailNonEmpty */.fm(list), esm_Array/* reduce */.u4((0,Function/* pipe */.zG)(esm_Chunk/* headNonEmpty */.dK(list), exitMap(esm_Chunk.of)), (accumulator, current) => (0,Function/* pipe */.zG)(accumulator, exitZipWith(current, {
    onSuccess: (list, value) => (0,Function/* pipe */.zG)(list, esm_Chunk/* prepend */.Ce(value)),
    onFailure: combineCauses
  }))), exitMap(esm_Chunk/* reverse */.GY), exitMap(chunk => esm_Chunk/* toReadonlyArray */.AO(chunk)), esm_Option/* some */.G);
};
// -----------------------------------------------------------------------------
// Deferred
// -----------------------------------------------------------------------------
/** @internal */
const deferredUnsafeMake = fiberId => {
  const _deferred = {
    ...effectable/* CommitPrototype */.ku,
    [deferred/* DeferredTypeId */.zD]: deferred/* deferredVariance */.JV,
    state: MutableRef/* make */.Sy(deferred/* pending */.Ot([])),
    commit() {
      return deferredAwait(this);
    },
    blockingOn: fiberId
  };
  return _deferred;
};
/* @internal */
const deferredMake = () => flatMap(fiberId, id => deferredMakeAs(id));
/* @internal */
const deferredMakeAs = fiberId => sync(() => deferredUnsafeMake(fiberId));
/* @internal */
const deferredAwait = self => asyncInterrupt(resume => {
  const state = MutableRef/* get */.U2(self.state);
  switch (state._tag) {
    case opCodes_deferred/* OP_STATE_DONE */.$:
      {
        return resume(state.effect);
      }
    case opCodes_deferred/* OP_STATE_PENDING */.c:
      {
        // we can push here as the internal state is mutable
        state.joiners.push(resume);
        return deferredInterruptJoiner(self, resume);
      }
  }
}, self.blockingOn);
/* @internal */
const deferredComplete = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, effect) => intoDeferred(effect, self));
/* @internal */
const deferredCompleteWith = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, effect) => sync(() => {
  const state = MutableRef/* get */.U2(self.state);
  switch (state._tag) {
    case opCodes_deferred/* OP_STATE_DONE */.$:
      {
        return false;
      }
    case opCodes_deferred/* OP_STATE_PENDING */.c:
      {
        MutableRef/* set */.t8(self.state, deferred/* done */.aT(effect));
        for (let i = 0, len = state.joiners.length; i < len; i++) {
          state.joiners[i](effect);
        }
        return true;
      }
  }
}));
/* @internal */
const deferredDone = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, exit) => deferredCompleteWith(self, exit));
/* @internal */
const deferredFail = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, error) => deferredCompleteWith(self, fail(error)));
/* @internal */
const deferredFailSync = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, evaluate) => deferredCompleteWith(self, failSync(evaluate)));
/* @internal */
const deferredFailCause = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, cause) => deferredCompleteWith(self, failCause(cause)));
/* @internal */
const deferredFailCauseSync = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, evaluate) => deferredCompleteWith(self, failCauseSync(evaluate)));
/* @internal */
const deferredDie = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, defect) => deferredCompleteWith(self, die(defect)));
/* @internal */
const deferredDieSync = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, evaluate) => deferredCompleteWith(self, dieSync(evaluate)));
/* @internal */
const deferredInterrupt = self => flatMap(fiberId, fiberId => deferredCompleteWith(self, interruptWith(fiberId)));
/* @internal */
const deferredInterruptWith = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, fiberId) => deferredCompleteWith(self, interruptWith(fiberId)));
/* @internal */
const deferredIsDone = self => sync(() => MutableRef/* get */.U2(self.state)._tag === opCodes_deferred/* OP_STATE_DONE */.$);
/* @internal */
const deferredPoll = self => sync(() => {
  const state = MutableRef/* get */.U2(self.state);
  switch (state._tag) {
    case opCodes_deferred/* OP_STATE_DONE */.$:
      {
        return esm_Option/* some */.G(state.effect);
      }
    case opCodes_deferred/* OP_STATE_PENDING */.c:
      {
        return esm_Option/* none */.YP();
      }
  }
});
/* @internal */
const deferredSucceed = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, value) => deferredCompleteWith(self, succeed(value)));
/* @internal */
const deferredSync = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, evaluate) => deferredCompleteWith(self, sync(evaluate)));
/** @internal */
const deferredUnsafeDone = (self, effect) => {
  const state = MutableRef/* get */.U2(self.state);
  if (state._tag === opCodes_deferred/* OP_STATE_PENDING */.c) {
    MutableRef/* set */.t8(self.state, deferred/* done */.aT(effect));
    for (let i = 0, len = state.joiners.length; i < len; i++) {
      state.joiners[i](effect);
    }
  }
};
const deferredInterruptJoiner = (self, joiner) => sync(() => {
  const state = MutableRef/* get */.U2(self.state);
  if (state._tag === opCodes_deferred/* OP_STATE_PENDING */.c) {
    const index = state.joiners.indexOf(joiner);
    if (index >= 0) {
      // we can splice here as the internal state is mutable
      state.joiners.splice(index, 1);
    }
  }
});
// -----------------------------------------------------------------------------
// Context
// -----------------------------------------------------------------------------
const constContext = /*#__PURE__*/withFiberRuntime(fiber => exitSucceed(fiber.currentContext));
/* @internal */
const context = () => constContext;
/* @internal */
const contextWith = f => map(context(), f);
/* @internal */
const contextWithEffect = f => flatMap(context(), f);
/* @internal */
const provideContext = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, context) => fiberRefLocally(currentContext, context)(self));
/* @internal */
const provideSomeContext = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, context) => fiberRefLocallyWith(currentContext, parent => Context/* merge */.TS(parent, context))(self));
/* @internal */
const mapInputContext = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => contextWithEffect(context => provideContext(self, f(context))));
// -----------------------------------------------------------------------------
// Filtering
// -----------------------------------------------------------------------------
/** @internal */
const filterEffectOrElse = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, options) => flatMap(self, a => flatMap(options.predicate(a), pass => pass ? succeed(a) : options.orElse(a))));
/** @internal */
const filterEffectOrFail = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, options) => filterEffectOrElse(self, {
  predicate: options.predicate,
  orElse: a => fail(options.orFailWith(a))
}));
// -----------------------------------------------------------------------------
// Tracing
// -----------------------------------------------------------------------------
/** @internal */
const currentSpanFromFiber = fiber => {
  const span = fiber.currentSpan;
  return span !== undefined && span._tag === "Span" ? esm_Option/* some */.G(span) : esm_Option/* none */.YP();
};
const NoopSpanProto = {
  _tag: "Span",
  spanId: "noop",
  traceId: "noop",
  sampled: false,
  status: {
    _tag: "Ended",
    startTime: /*#__PURE__*/BigInt(0),
    endTime: /*#__PURE__*/BigInt(0),
    exit: exitVoid
  },
  attributes: /*#__PURE__*/new Map(),
  links: [],
  kind: "internal",
  attribute() {},
  event() {},
  end() {},
  addLinks() {}
};
/** @internal */
const noopSpan = options => Object.assign(Object.create(NoopSpanProto), options);
//# sourceMappingURL=core.js.map

/***/ }),

/***/ 84685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kj": function() { return /* binding */ Structural; },
/* harmony export */   "n_": function() { return /* binding */ struct; }
/* harmony export */ });
/* unused harmony export ArrayProto */
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67492);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89379);
/* harmony import */ var _effectable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10020);



/** @internal */
const ArrayProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(Array.prototype), {
  [_Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .symbol */ .NA]() {
    return _Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .cached */ .HX(this, _Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .array */ .IX(this));
  },
  [_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .symbol */ .NA](that) {
    if (Array.isArray(that) && this.length === that.length) {
      return this.every((v, i) => _Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS(v, that[i]));
    } else {
      return false;
    }
  }
});
/** @internal */
const Structural = /*#__PURE__*/function () {
  function Structural(args) {
    if (args) {
      Object.assign(this, args);
    }
  }
  Structural.prototype = _effectable_js__WEBPACK_IMPORTED_MODULE_2__/* .StructuralPrototype */ .EO;
  return Structural;
}();
/** @internal */
const struct = as => Object.assign(Object.create(_effectable_js__WEBPACK_IMPORTED_MODULE_2__/* .StructuralPrototype */ .EO), as);
//# sourceMappingURL=data.js.map

/***/ }),

/***/ 74266:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$f": function() { return /* binding */ tracerWith; },
/* harmony export */   "D5": function() { return /* binding */ configProviderWith; },
/* harmony export */   "MD": function() { return /* binding */ randomWith; },
/* harmony export */   "Nl": function() { return /* binding */ currentTimeNanos; },
/* harmony export */   "Pm": function() { return /* binding */ currentServices; },
/* harmony export */   "UA": function() { return /* binding */ clockWith; },
/* harmony export */   "Z0": function() { return /* binding */ withRandom; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "b4": function() { return /* binding */ currentTimeMillis; },
/* harmony export */   "oJ": function() { return /* binding */ withTracer; },
/* harmony export */   "rZ": function() { return /* binding */ withClock; },
/* harmony export */   "wD": function() { return /* binding */ withConfigProvider; }
/* harmony export */ });
/* unused harmony exports liveServices, defaultServicesWith, config, configOrDie, next, nextInt, nextBoolean, nextRange, nextIntBetween, shuffle, choice */
/* harmony import */ var _Context_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20591);
/* harmony import */ var _Duration_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13571);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17316);
/* harmony import */ var _GlobalValue_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4726);
/* harmony import */ var _clock_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53318);
/* harmony import */ var _configProvider_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54604);
/* harmony import */ var _core_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39355);
/* harmony import */ var _defaultServices_console_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2338);
/* harmony import */ var _random_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94023);
/* harmony import */ var _tracer_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10434);











/** @internal */
const liveServices = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .pipe */ .zG)( /*#__PURE__*/_Context_js__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS(), /*#__PURE__*/_Context_js__WEBPACK_IMPORTED_MODULE_1__/* .add */ .IH(_clock_js__WEBPACK_IMPORTED_MODULE_2__/* .clockTag */ .GL, /*#__PURE__*/_clock_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .Sy()), /*#__PURE__*/_Context_js__WEBPACK_IMPORTED_MODULE_1__/* .add */ .IH(_defaultServices_console_js__WEBPACK_IMPORTED_MODULE_3__/* .consoleTag */ .KM, _defaultServices_console_js__WEBPACK_IMPORTED_MODULE_3__/* .defaultConsole */ .kO), /*#__PURE__*/_Context_js__WEBPACK_IMPORTED_MODULE_1__/* .add */ .IH(_random_js__WEBPACK_IMPORTED_MODULE_4__/* .randomTag */ .XB, /*#__PURE__*/_random_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .Sy( /*#__PURE__*/Math.random())), /*#__PURE__*/_Context_js__WEBPACK_IMPORTED_MODULE_1__/* .add */ .IH(_configProvider_js__WEBPACK_IMPORTED_MODULE_5__/* .configProviderTag */ .a6, /*#__PURE__*/_configProvider_js__WEBPACK_IMPORTED_MODULE_5__/* .fromEnv */ .r2()), /*#__PURE__*/_Context_js__WEBPACK_IMPORTED_MODULE_1__/* .add */ .IH(_tracer_js__WEBPACK_IMPORTED_MODULE_6__/* .tracerTag */ .Fl, _tracer_js__WEBPACK_IMPORTED_MODULE_6__/* .nativeTracer */ .qY));
/**
 * The `FiberRef` holding the default `Effect` services.
 *
 * @since 2.0.0
 * @category fiberRefs
 */
const currentServices = /*#__PURE__*/(0,_GlobalValue_js__WEBPACK_IMPORTED_MODULE_7__/* .globalValue */ .K)( /*#__PURE__*/Symbol.for("effect/DefaultServices/currentServices"), () => _core_js__WEBPACK_IMPORTED_MODULE_8__/* .fiberRefUnsafeMakeContext */ .BWU(liveServices));
// circular with Clock
/** @internal */
const sleep = duration => {
  const decodedDuration = _Duration_js__WEBPACK_IMPORTED_MODULE_9__/* .decode */ .Jx(duration);
  return clockWith(clock => clock.sleep(decodedDuration));
};
/** @internal */
const defaultServicesWith = f => _core_js__WEBPACK_IMPORTED_MODULE_8__/* .withFiberRuntime */ .ECC(fiber => f(fiber.currentDefaultServices));
/** @internal */
const clockWith = f => defaultServicesWith(services => f(services.unsafeMap.get(_clock_js__WEBPACK_IMPORTED_MODULE_2__/* .clockTag.key */ .GL.key)));
/** @internal */
const currentTimeMillis = /*#__PURE__*/clockWith(clock => clock.currentTimeMillis);
/** @internal */
const currentTimeNanos = /*#__PURE__*/clockWith(clock => clock.currentTimeNanos);
/** @internal */
const withClock = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (effect, c) => _core_js__WEBPACK_IMPORTED_MODULE_8__/* .fiberRefLocallyWith */ .LzL(currentServices, _Context_js__WEBPACK_IMPORTED_MODULE_1__/* .add */ .IH(_clock_js__WEBPACK_IMPORTED_MODULE_2__/* .clockTag */ .GL, c))(effect));
// circular with ConfigProvider
/** @internal */
const withConfigProvider = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, provider) => _core_js__WEBPACK_IMPORTED_MODULE_8__/* .fiberRefLocallyWith */ .LzL(currentServices, _Context_js__WEBPACK_IMPORTED_MODULE_1__/* .add */ .IH(_configProvider_js__WEBPACK_IMPORTED_MODULE_5__/* .configProviderTag */ .a6, provider))(self));
/** @internal */
const configProviderWith = f => defaultServicesWith(services => f(services.unsafeMap.get(_configProvider_js__WEBPACK_IMPORTED_MODULE_5__/* .configProviderTag.key */ .a6.key)));
/** @internal */
const config = config => configProviderWith(_ => _.load(config));
/** @internal */
const configOrDie = config => core.orDie(configProviderWith(_ => _.load(config)));
// circular with Random
/** @internal */
const randomWith = f => defaultServicesWith(services => f(services.unsafeMap.get(_random_js__WEBPACK_IMPORTED_MODULE_4__/* .randomTag.key */ .XB.key)));
/** @internal */
const withRandom = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (effect, value) => _core_js__WEBPACK_IMPORTED_MODULE_8__/* .fiberRefLocallyWith */ .LzL(currentServices, _Context_js__WEBPACK_IMPORTED_MODULE_1__/* .add */ .IH(_random_js__WEBPACK_IMPORTED_MODULE_4__/* .randomTag */ .XB, value))(effect));
/** @internal */
const next = /*#__PURE__*/(/* unused pure expression or super */ null && (randomWith(random => random.next)));
/** @internal */
const nextInt = /*#__PURE__*/(/* unused pure expression or super */ null && (randomWith(random => random.nextInt)));
/** @internal */
const nextBoolean = /*#__PURE__*/(/* unused pure expression or super */ null && (randomWith(random => random.nextBoolean)));
/** @internal */
const nextRange = (min, max) => randomWith(random => random.nextRange(min, max));
/** @internal */
const nextIntBetween = (min, max) => randomWith(random => random.nextIntBetween(min, max));
/** @internal */
const shuffle = elements => randomWith(random => random.shuffle(elements));
/** @internal */
const choice = elements => {
  const array = Array.fromIterable(elements);
  return core.map(array.length === 0 ? core.fail(new core.NoSuchElementException("Cannot select a random element from an empty array")) : randomWith(random => random.nextIntBetween(0, array.length)), i => array[i]);
};
// circular with Tracer
/** @internal */
const tracerWith = f => defaultServicesWith(services => f(services.unsafeMap.get(_tracer_js__WEBPACK_IMPORTED_MODULE_6__/* .tracerTag.key */ .Fl.key)));
/** @internal */
const withTracer = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (effect, value) => _core_js__WEBPACK_IMPORTED_MODULE_8__/* .fiberRefLocallyWith */ .LzL(currentServices, _Context_js__WEBPACK_IMPORTED_MODULE_1__/* .add */ .IH(_tracer_js__WEBPACK_IMPORTED_MODULE_6__/* .tracerTag */ .Fl, value))(effect));
//# sourceMappingURL=defaultServices.js.map

/***/ }),

/***/ 2338:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KM": function() { return /* binding */ consoleTag; },
/* harmony export */   "kO": function() { return /* binding */ defaultConsole; }
/* harmony export */ });
/* unused harmony export TypeId */
/* harmony import */ var _Context_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20591);
/* harmony import */ var _core_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39355);


/** @internal */
const TypeId = /*#__PURE__*/Symbol.for("effect/Console");
/** @internal */
const consoleTag = /*#__PURE__*/_Context_js__WEBPACK_IMPORTED_MODULE_0__/* .GenericTag */ .hV("effect/Console");
/** @internal */
const defaultConsole = {
  [TypeId]: TypeId,
  assert(condition, ...args) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
      console.assert(condition, ...args);
    });
  },
  clear: /*#__PURE__*/_core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
    console.clear();
  }),
  count(label) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
      console.count(label);
    });
  },
  countReset(label) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
      console.countReset(label);
    });
  },
  debug(...args) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
      console.debug(...args);
    });
  },
  dir(item, options) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
      console.dir(item, options);
    });
  },
  dirxml(...args) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
      console.dirxml(...args);
    });
  },
  error(...args) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
      console.error(...args);
    });
  },
  group(options) {
    return options?.collapsed ? _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => console.groupCollapsed(options?.label)) : _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => console.group(options?.label));
  },
  groupEnd: /*#__PURE__*/_core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
    console.groupEnd();
  }),
  info(...args) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
      console.info(...args);
    });
  },
  log(...args) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
      console.log(...args);
    });
  },
  table(tabularData, properties) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
      console.table(tabularData, properties);
    });
  },
  time(label) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => console.time(label));
  },
  timeEnd(label) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => console.timeEnd(label));
  },
  timeLog(label, ...args) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
      console.timeLog(label, ...args);
    });
  },
  trace(...args) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
      console.trace(...args);
    });
  },
  warn(...args) {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => {
      console.warn(...args);
    });
  },
  unsafe: console
};
//# sourceMappingURL=console.js.map

/***/ }),

/***/ 32387:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JV": function() { return /* binding */ deferredVariance; },
/* harmony export */   "Ot": function() { return /* binding */ pending; },
/* harmony export */   "aT": function() { return /* binding */ done; },
/* harmony export */   "zD": function() { return /* binding */ DeferredTypeId; }
/* harmony export */ });
/* harmony import */ var _opCodes_deferred_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4219);

/** @internal */
const DeferredSymbolKey = "effect/Deferred";
/** @internal */
const DeferredTypeId = /*#__PURE__*/Symbol.for(DeferredSymbolKey);
/** @internal */
const deferredVariance = {
  /* c8 ignore next */
  _E: _ => _,
  /* c8 ignore next */
  _A: _ => _
};
/** @internal */
const pending = joiners => {
  return {
    _tag: _opCodes_deferred_js__WEBPACK_IMPORTED_MODULE_0__/* .OP_STATE_PENDING */ .c,
    joiners
  };
};
/** @internal */
const done = effect => {
  return {
    _tag: _opCodes_deferred_js__WEBPACK_IMPORTED_MODULE_0__/* .OP_STATE_DONE */ .$,
    effect
  };
};
//# sourceMappingURL=deferred.js.map

/***/ }),

/***/ 49398:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$R": function() { return /* binding */ zip; },
/* harmony export */   "Bk": function() { return /* binding */ readonlyArray; },
/* harmony export */   "M0": function() { return /* binding */ DifferTypeId; },
/* harmony export */   "NZ": function() { return /* binding */ environment; },
/* harmony export */   "O0": function() { return /* binding */ orElseEither; },
/* harmony export */   "OS": function() { return /* binding */ hashSet; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "Vx": function() { return /* binding */ update; },
/* harmony export */   "ar": function() { return /* binding */ hashMap; },
/* harmony export */   "ok": function() { return /* binding */ updateWith; },
/* harmony export */   "vs": function() { return /* binding */ transform; },
/* harmony export */   "yo": function() { return /* binding */ chunk; }
/* harmony export */ });
/* unused harmony export DifferProto */
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17316);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92817);
/* harmony import */ var _differ_chunkPatch_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79862);
/* harmony import */ var _differ_contextPatch_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53621);
/* harmony import */ var _differ_hashMapPatch_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34937);
/* harmony import */ var _differ_hashSetPatch_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27074);
/* harmony import */ var _differ_orPatch_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42702);
/* harmony import */ var _differ_readonlyArrayPatch_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49451);










/** @internal */
const DifferTypeId = /*#__PURE__*/Symbol.for("effect/Differ");
/** @internal */
const DifferProto = {
  [DifferTypeId]: {
    _P: _Function_js__WEBPACK_IMPORTED_MODULE_0__/* .identity */ .yR,
    _V: _Function_js__WEBPACK_IMPORTED_MODULE_0__/* .identity */ .yR
  },
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_1__/* .pipeArguments */ .n)(this, arguments);
  }
};
/** @internal */
const make = params => {
  const differ = Object.create(DifferProto);
  differ.empty = params.empty;
  differ.diff = params.diff;
  differ.combine = params.combine;
  differ.patch = params.patch;
  return differ;
};
/** @internal */
const environment = () => make({
  empty: _differ_contextPatch_js__WEBPACK_IMPORTED_MODULE_2__/* .empty */ .cS(),
  combine: (first, second) => _differ_contextPatch_js__WEBPACK_IMPORTED_MODULE_2__/* .combine */ .$e(second)(first),
  diff: (oldValue, newValue) => _differ_contextPatch_js__WEBPACK_IMPORTED_MODULE_2__/* .diff */ .Hg(oldValue, newValue),
  patch: (patch, oldValue) => _differ_contextPatch_js__WEBPACK_IMPORTED_MODULE_2__/* .patch */ .r$(oldValue)(patch)
});
/** @internal */
const chunk = differ => make({
  empty: _differ_chunkPatch_js__WEBPACK_IMPORTED_MODULE_3__/* .empty */ .cS(),
  combine: (first, second) => _differ_chunkPatch_js__WEBPACK_IMPORTED_MODULE_3__/* .combine */ .$e(second)(first),
  diff: (oldValue, newValue) => _differ_chunkPatch_js__WEBPACK_IMPORTED_MODULE_3__/* .diff */ .Hg({
    oldValue,
    newValue,
    differ
  }),
  patch: (patch, oldValue) => _differ_chunkPatch_js__WEBPACK_IMPORTED_MODULE_3__/* .patch */ .r$(oldValue, differ)(patch)
});
/** @internal */
const hashMap = differ => make({
  empty: _differ_hashMapPatch_js__WEBPACK_IMPORTED_MODULE_4__/* .empty */ .cS(),
  combine: (first, second) => _differ_hashMapPatch_js__WEBPACK_IMPORTED_MODULE_4__/* .combine */ .$e(second)(first),
  diff: (oldValue, newValue) => _differ_hashMapPatch_js__WEBPACK_IMPORTED_MODULE_4__/* .diff */ .Hg({
    oldValue,
    newValue,
    differ
  }),
  patch: (patch, oldValue) => _differ_hashMapPatch_js__WEBPACK_IMPORTED_MODULE_4__/* .patch */ .r$(oldValue, differ)(patch)
});
/** @internal */
const hashSet = () => make({
  empty: _differ_hashSetPatch_js__WEBPACK_IMPORTED_MODULE_5__/* .empty */ .cS(),
  combine: (first, second) => _differ_hashSetPatch_js__WEBPACK_IMPORTED_MODULE_5__/* .combine */ .$e(second)(first),
  diff: (oldValue, newValue) => _differ_hashSetPatch_js__WEBPACK_IMPORTED_MODULE_5__/* .diff */ .Hg(oldValue, newValue),
  patch: (patch, oldValue) => _differ_hashSetPatch_js__WEBPACK_IMPORTED_MODULE_5__/* .patch */ .r$(oldValue)(patch)
});
/** @internal */
const orElseEither = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB(2, (self, that) => make({
  empty: _differ_orPatch_js__WEBPACK_IMPORTED_MODULE_6__/* .empty */ .cS(),
  combine: (first, second) => _differ_orPatch_js__WEBPACK_IMPORTED_MODULE_6__/* .combine */ .$e(first, second),
  diff: (oldValue, newValue) => _differ_orPatch_js__WEBPACK_IMPORTED_MODULE_6__/* .diff */ .Hg({
    oldValue,
    newValue,
    left: self,
    right: that
  }),
  patch: (patch, oldValue) => _differ_orPatch_js__WEBPACK_IMPORTED_MODULE_6__/* .patch */ .r$(patch, {
    oldValue,
    left: self,
    right: that
  })
}));
/** @internal */
const readonlyArray = differ => make({
  empty: _differ_readonlyArrayPatch_js__WEBPACK_IMPORTED_MODULE_7__/* .empty */ .cS(),
  combine: (first, second) => _differ_readonlyArrayPatch_js__WEBPACK_IMPORTED_MODULE_7__/* .combine */ .$e(first, second),
  diff: (oldValue, newValue) => _differ_readonlyArrayPatch_js__WEBPACK_IMPORTED_MODULE_7__/* .diff */ .Hg({
    oldValue,
    newValue,
    differ
  }),
  patch: (patch, oldValue) => _differ_readonlyArrayPatch_js__WEBPACK_IMPORTED_MODULE_7__/* .patch */ .r$(patch, oldValue, differ)
});
/** @internal */
const transform = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB(2, (self, {
  toNew,
  toOld
}) => make({
  empty: self.empty,
  combine: (first, second) => self.combine(first, second),
  diff: (oldValue, newValue) => self.diff(toOld(oldValue), toOld(newValue)),
  patch: (patch, oldValue) => toNew(self.patch(patch, toOld(oldValue)))
}));
/** @internal */
const update = () => updateWith((_, a) => a);
/** @internal */
const updateWith = f => make({
  empty: _Function_js__WEBPACK_IMPORTED_MODULE_0__/* .identity */ .yR,
  combine: (first, second) => {
    if (first === _Function_js__WEBPACK_IMPORTED_MODULE_0__/* .identity */ .yR) {
      return second;
    }
    if (second === _Function_js__WEBPACK_IMPORTED_MODULE_0__/* .identity */ .yR) {
      return first;
    }
    return a => second(first(a));
  },
  diff: (oldValue, newValue) => {
    if (_Equal_js__WEBPACK_IMPORTED_MODULE_8__/* .equals */ .fS(oldValue, newValue)) {
      return _Function_js__WEBPACK_IMPORTED_MODULE_0__/* .identity */ .yR;
    }
    return (0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .constant */ .a9)(newValue);
  },
  patch: (patch, oldValue) => f(oldValue, patch(oldValue))
});
/** @internal */
const zip = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB(2, (self, that) => make({
  empty: [self.empty, that.empty],
  combine: (first, second) => [self.combine(first[0], second[0]), that.combine(first[1], second[1])],
  diff: (oldValue, newValue) => [self.diff(oldValue[0], newValue[0]), that.diff(oldValue[1], newValue[1])],
  patch: (patch, oldValue) => [self.patch(patch[0], oldValue[0]), that.patch(patch[1], oldValue[1])]
}));
//# sourceMappingURL=differ.js.map

/***/ }),

/***/ 79862:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "Hg": function() { return /* binding */ diff; },
/* harmony export */   "Lg": function() { return /* binding */ ChunkPatchTypeId; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "r$": function() { return /* binding */ patch; }
/* harmony export */ });
/* harmony import */ var _Chunk_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14109);
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17316);
/* harmony import */ var _data_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84685);





/** @internal */
const ChunkPatchTypeId = /*#__PURE__*/Symbol.for("effect/DifferChunkPatch");
function variance(a) {
  return a;
}
const PatchProto = {
  ..._data_js__WEBPACK_IMPORTED_MODULE_0__/* .Structural.prototype */ .Kj.prototype,
  [ChunkPatchTypeId]: {
    _Value: variance,
    _Patch: variance
  }
};
const EmptyProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Empty"
});
const _empty = /*#__PURE__*/Object.create(EmptyProto);
/**
 * @internal
 */
const empty = () => _empty;
const AndThenProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "AndThen"
});
const makeAndThen = (first, second) => {
  const o = Object.create(AndThenProto);
  o.first = first;
  o.second = second;
  return o;
};
const AppendProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Append"
});
const makeAppend = values => {
  const o = Object.create(AppendProto);
  o.values = values;
  return o;
};
const SliceProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Slice"
});
const makeSlice = (from, until) => {
  const o = Object.create(SliceProto);
  o.from = from;
  o.until = until;
  return o;
};
const UpdateProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Update"
});
const makeUpdate = (index, patch) => {
  const o = Object.create(UpdateProto);
  o.index = index;
  o.patch = patch;
  return o;
};
/** @internal */
const diff = options => {
  let i = 0;
  let patch = empty();
  while (i < options.oldValue.length && i < options.newValue.length) {
    const oldElement = _Chunk_js__WEBPACK_IMPORTED_MODULE_1__/* .unsafeGet */ .MH(i)(options.oldValue);
    const newElement = _Chunk_js__WEBPACK_IMPORTED_MODULE_1__/* .unsafeGet */ .MH(i)(options.newValue);
    const valuePatch = options.differ.diff(oldElement, newElement);
    if (!_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .equals */ .fS(valuePatch, options.differ.empty)) {
      patch = (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(patch, combine(makeUpdate(i, valuePatch)));
    }
    i = i + 1;
  }
  if (i < options.oldValue.length) {
    patch = (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(patch, combine(makeSlice(0, i)));
  }
  if (i < options.newValue.length) {
    patch = (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(patch, combine(makeAppend(_Chunk_js__WEBPACK_IMPORTED_MODULE_1__/* .drop */ .Cw(i)(options.newValue))));
  }
  return patch;
};
/** @internal */
const combine = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .dual */ .OB(2, (self, that) => makeAndThen(self, that));
/** @internal */
const patch = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .dual */ .OB(3, (self, oldValue, differ) => {
  if (self._tag === "Empty") {
    return oldValue;
  }
  let chunk = oldValue;
  let patches = _Chunk_js__WEBPACK_IMPORTED_MODULE_1__.of(self);
  while (_Chunk_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonEmpty */ .Od(patches)) {
    const head = _Chunk_js__WEBPACK_IMPORTED_MODULE_1__/* .headNonEmpty */ .dK(patches);
    const tail = _Chunk_js__WEBPACK_IMPORTED_MODULE_1__/* .tailNonEmpty */ .fm(patches);
    switch (head._tag) {
      case "Empty":
        {
          patches = tail;
          break;
        }
      case "AndThen":
        {
          patches = _Chunk_js__WEBPACK_IMPORTED_MODULE_1__/* .prepend */ .Ce(head.first)(_Chunk_js__WEBPACK_IMPORTED_MODULE_1__/* .prepend */ .Ce(head.second)(tail));
          break;
        }
      case "Append":
        {
          chunk = _Chunk_js__WEBPACK_IMPORTED_MODULE_1__/* .appendAll */ .oq(head.values)(chunk);
          patches = tail;
          break;
        }
      case "Slice":
        {
          const array = _Chunk_js__WEBPACK_IMPORTED_MODULE_1__/* .toReadonlyArray */ .AO(chunk);
          chunk = _Chunk_js__WEBPACK_IMPORTED_MODULE_1__/* .unsafeFromArray */ .JN(array.slice(head.from, head.until));
          patches = tail;
          break;
        }
      case "Update":
        {
          const array = _Chunk_js__WEBPACK_IMPORTED_MODULE_1__/* .toReadonlyArray */ .AO(chunk);
          array[head.index] = differ.patch(head.patch, array[head.index]);
          chunk = _Chunk_js__WEBPACK_IMPORTED_MODULE_1__/* .unsafeFromArray */ .JN(array);
          patches = tail;
          break;
        }
    }
  }
  return chunk;
});
//# sourceMappingURL=chunkPatch.js.map

/***/ }),

/***/ 53621:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "Hg": function() { return /* binding */ diff; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "gy": function() { return /* binding */ ContextPatchTypeId; },
/* harmony export */   "r$": function() { return /* binding */ patch; }
/* harmony export */ });
/* harmony import */ var _Chunk_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14109);
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17316);
/* harmony import */ var _context_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40197);
/* harmony import */ var _data_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84685);





/** @internal */
const ContextPatchTypeId = /*#__PURE__*/Symbol.for("effect/DifferContextPatch");
function variance(a) {
  return a;
}
/** @internal */
const PatchProto = {
  ..._data_js__WEBPACK_IMPORTED_MODULE_0__/* .Structural.prototype */ .Kj.prototype,
  [ContextPatchTypeId]: {
    _Value: variance,
    _Patch: variance
  }
};
const EmptyProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Empty"
});
const _empty = /*#__PURE__*/Object.create(EmptyProto);
/**
 * @internal
 */
const empty = () => _empty;
const AndThenProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "AndThen"
});
const makeAndThen = (first, second) => {
  const o = Object.create(AndThenProto);
  o.first = first;
  o.second = second;
  return o;
};
const AddServiceProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "AddService"
});
const makeAddService = (key, service) => {
  const o = Object.create(AddServiceProto);
  o.key = key;
  o.service = service;
  return o;
};
const RemoveServiceProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "RemoveService"
});
const makeRemoveService = key => {
  const o = Object.create(RemoveServiceProto);
  o.key = key;
  return o;
};
const UpdateServiceProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "UpdateService"
});
const makeUpdateService = (key, update) => {
  const o = Object.create(UpdateServiceProto);
  o.key = key;
  o.update = update;
  return o;
};
/** @internal */
const diff = (oldValue, newValue) => {
  const missingServices = new Map(oldValue.unsafeMap);
  let patch = empty();
  for (const [tag, newService] of newValue.unsafeMap.entries()) {
    if (missingServices.has(tag)) {
      const old = missingServices.get(tag);
      missingServices.delete(tag);
      if (!_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS(old, newService)) {
        patch = combine(makeUpdateService(tag, () => newService))(patch);
      }
    } else {
      missingServices.delete(tag);
      patch = combine(makeAddService(tag, newService))(patch);
    }
  }
  for (const [tag] of missingServices.entries()) {
    patch = combine(makeRemoveService(tag))(patch);
  }
  return patch;
};
/** @internal */
const combine = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB(2, (self, that) => makeAndThen(self, that));
/** @internal */
const patch = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB(2, (self, context) => {
  if (self._tag === "Empty") {
    return context;
  }
  let wasServiceUpdated = false;
  let patches = _Chunk_js__WEBPACK_IMPORTED_MODULE_3__.of(self);
  const updatedContext = new Map(context.unsafeMap);
  while (_Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .isNonEmpty */ .Od(patches)) {
    const head = _Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .headNonEmpty */ .dK(patches);
    const tail = _Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .tailNonEmpty */ .fm(patches);
    switch (head._tag) {
      case "Empty":
        {
          patches = tail;
          break;
        }
      case "AddService":
        {
          updatedContext.set(head.key, head.service);
          patches = tail;
          break;
        }
      case "AndThen":
        {
          patches = _Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .prepend */ .Ce(_Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .prepend */ .Ce(tail, head.second), head.first);
          break;
        }
      case "RemoveService":
        {
          updatedContext.delete(head.key);
          patches = tail;
          break;
        }
      case "UpdateService":
        {
          updatedContext.set(head.key, head.update(updatedContext.get(head.key)));
          wasServiceUpdated = true;
          patches = tail;
          break;
        }
    }
  }
  if (!wasServiceUpdated) {
    return (0,_context_js__WEBPACK_IMPORTED_MODULE_4__/* .makeContext */ .fC)(updatedContext);
  }
  const map = new Map();
  for (const [tag] of context.unsafeMap) {
    if (updatedContext.has(tag)) {
      map.set(tag, updatedContext.get(tag));
      updatedContext.delete(tag);
    }
  }
  for (const [tag, s] of updatedContext) {
    map.set(tag, s);
  }
  return (0,_context_js__WEBPACK_IMPORTED_MODULE_4__/* .makeContext */ .fC)(map);
});
//# sourceMappingURL=contextPatch.js.map

/***/ }),

/***/ 34937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "Hg": function() { return /* binding */ diff; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "r$": function() { return /* binding */ patch; },
/* harmony export */   "xH": function() { return /* binding */ HashMapPatchTypeId; }
/* harmony export */ });
/* harmony import */ var _Chunk_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14109);
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17316);
/* harmony import */ var _HashMap_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61952);
/* harmony import */ var _data_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84685);





/** @internal */
const HashMapPatchTypeId = /*#__PURE__*/Symbol.for("effect/DifferHashMapPatch");
function variance(a) {
  return a;
}
/** @internal */
const PatchProto = {
  ..._data_js__WEBPACK_IMPORTED_MODULE_0__/* .Structural.prototype */ .Kj.prototype,
  [HashMapPatchTypeId]: {
    _Value: variance,
    _Key: variance,
    _Patch: variance
  }
};
const EmptyProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Empty"
});
const _empty = /*#__PURE__*/Object.create(EmptyProto);
/** @internal */
const empty = () => _empty;
const AndThenProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "AndThen"
});
const makeAndThen = (first, second) => {
  const o = Object.create(AndThenProto);
  o.first = first;
  o.second = second;
  return o;
};
const AddProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Add"
});
const makeAdd = (key, value) => {
  const o = Object.create(AddProto);
  o.key = key;
  o.value = value;
  return o;
};
const RemoveProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Remove"
});
const makeRemove = key => {
  const o = Object.create(RemoveProto);
  o.key = key;
  return o;
};
const UpdateProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Update"
});
const makeUpdate = (key, patch) => {
  const o = Object.create(UpdateProto);
  o.key = key;
  o.patch = patch;
  return o;
};
/** @internal */
const diff = options => {
  const [removed, patch] = _HashMap_js__WEBPACK_IMPORTED_MODULE_1__/* .reduce */ .u4([options.oldValue, empty()], ([map, patch], newValue, key) => {
    const option = _HashMap_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2(key)(map);
    switch (option._tag) {
      case "Some":
        {
          const valuePatch = options.differ.diff(option.value, newValue);
          if (_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .equals */ .fS(valuePatch, options.differ.empty)) {
            return [_HashMap_js__WEBPACK_IMPORTED_MODULE_1__/* .remove */ .Od(key)(map), patch];
          }
          return [_HashMap_js__WEBPACK_IMPORTED_MODULE_1__/* .remove */ .Od(key)(map), combine(makeUpdate(key, valuePatch))(patch)];
        }
      case "None":
        {
          return [map, combine(makeAdd(key, newValue))(patch)];
        }
    }
  })(options.newValue);
  return _HashMap_js__WEBPACK_IMPORTED_MODULE_1__/* .reduce */ .u4(patch, (patch, _, key) => combine(makeRemove(key))(patch))(removed);
};
/** @internal */
const combine = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .dual */ .OB(2, (self, that) => makeAndThen(self, that));
/** @internal */
const patch = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .dual */ .OB(3, (self, oldValue, differ) => {
  if (self._tag === "Empty") {
    return oldValue;
  }
  let map = oldValue;
  let patches = _Chunk_js__WEBPACK_IMPORTED_MODULE_4__.of(self);
  while (_Chunk_js__WEBPACK_IMPORTED_MODULE_4__/* .isNonEmpty */ .Od(patches)) {
    const head = _Chunk_js__WEBPACK_IMPORTED_MODULE_4__/* .headNonEmpty */ .dK(patches);
    const tail = _Chunk_js__WEBPACK_IMPORTED_MODULE_4__/* .tailNonEmpty */ .fm(patches);
    switch (head._tag) {
      case "Empty":
        {
          patches = tail;
          break;
        }
      case "AndThen":
        {
          patches = _Chunk_js__WEBPACK_IMPORTED_MODULE_4__/* .prepend */ .Ce(head.first)(_Chunk_js__WEBPACK_IMPORTED_MODULE_4__/* .prepend */ .Ce(head.second)(tail));
          break;
        }
      case "Add":
        {
          map = _HashMap_js__WEBPACK_IMPORTED_MODULE_1__/* .set */ .t8(head.key, head.value)(map);
          patches = tail;
          break;
        }
      case "Remove":
        {
          map = _HashMap_js__WEBPACK_IMPORTED_MODULE_1__/* .remove */ .Od(head.key)(map);
          patches = tail;
          break;
        }
      case "Update":
        {
          const option = _HashMap_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2(head.key)(map);
          if (option._tag === "Some") {
            map = _HashMap_js__WEBPACK_IMPORTED_MODULE_1__/* .set */ .t8(head.key, differ.patch(head.patch, option.value))(map);
          }
          patches = tail;
          break;
        }
    }
  }
  return map;
});
//# sourceMappingURL=hashMapPatch.js.map

/***/ }),

/***/ 27074:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "Hg": function() { return /* binding */ diff; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "r$": function() { return /* binding */ patch; },
/* harmony export */   "vv": function() { return /* binding */ HashSetPatchTypeId; }
/* harmony export */ });
/* unused harmony exports makeAndThen, makeAdd, makeRemove */
/* harmony import */ var _Chunk_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14109);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17316);
/* harmony import */ var _HashSet_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9551);
/* harmony import */ var _data_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84685);




/** @internal */
const HashSetPatchTypeId = /*#__PURE__*/Symbol.for("effect/DifferHashSetPatch");
function variance(a) {
  return a;
}
/** @internal */
const PatchProto = {
  ..._data_js__WEBPACK_IMPORTED_MODULE_0__/* .Structural.prototype */ .Kj.prototype,
  [HashSetPatchTypeId]: {
    _Value: variance,
    _Key: variance,
    _Patch: variance
  }
};
const EmptyProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Empty"
});
const _empty = /*#__PURE__*/Object.create(EmptyProto);
/** @internal */
const empty = () => _empty;
const AndThenProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "AndThen"
});
/** @internal */
const makeAndThen = (first, second) => {
  const o = Object.create(AndThenProto);
  o.first = first;
  o.second = second;
  return o;
};
const AddProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Add"
});
/** @internal */
const makeAdd = value => {
  const o = Object.create(AddProto);
  o.value = value;
  return o;
};
const RemoveProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Remove"
});
/** @internal */
const makeRemove = value => {
  const o = Object.create(RemoveProto);
  o.value = value;
  return o;
};
/** @internal */
const diff = (oldValue, newValue) => {
  const [removed, patch] = _HashSet_js__WEBPACK_IMPORTED_MODULE_1__/* .reduce */ .u4([oldValue, empty()], ([set, patch], value) => {
    if (_HashSet_js__WEBPACK_IMPORTED_MODULE_1__/* .has */ .e$(value)(set)) {
      return [_HashSet_js__WEBPACK_IMPORTED_MODULE_1__/* .remove */ .Od(value)(set), patch];
    }
    return [set, combine(makeAdd(value))(patch)];
  })(newValue);
  return _HashSet_js__WEBPACK_IMPORTED_MODULE_1__/* .reduce */ .u4(patch, (patch, value) => combine(makeRemove(value))(patch))(removed);
};
/** @internal */
const combine = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB(2, (self, that) => makeAndThen(self, that));
/** @internal */
const patch = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB(2, (self, oldValue) => {
  if (self._tag === "Empty") {
    return oldValue;
  }
  let set = oldValue;
  let patches = _Chunk_js__WEBPACK_IMPORTED_MODULE_3__.of(self);
  while (_Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .isNonEmpty */ .Od(patches)) {
    const head = _Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .headNonEmpty */ .dK(patches);
    const tail = _Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .tailNonEmpty */ .fm(patches);
    switch (head._tag) {
      case "Empty":
        {
          patches = tail;
          break;
        }
      case "AndThen":
        {
          patches = _Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .prepend */ .Ce(head.first)(_Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .prepend */ .Ce(head.second)(tail));
          break;
        }
      case "Add":
        {
          set = _HashSet_js__WEBPACK_IMPORTED_MODULE_1__/* .add */ .IH(head.value)(set);
          patches = tail;
          break;
        }
      case "Remove":
        {
          set = _HashSet_js__WEBPACK_IMPORTED_MODULE_1__/* .remove */ .Od(head.value)(set);
          patches = tail;
        }
    }
  }
  return set;
});
//# sourceMappingURL=hashSetPatch.js.map

/***/ }),

/***/ 42702:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "Hg": function() { return /* binding */ diff; },
/* harmony export */   "_e": function() { return /* binding */ OrPatchTypeId; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "r$": function() { return /* binding */ patch; }
/* harmony export */ });
/* unused harmony exports makeAndThen, makeSetLeft, makeSetRight, makeUpdateLeft, makeUpdateRight */
/* harmony import */ var _Chunk_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14109);
/* harmony import */ var _Either_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87585);
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17316);
/* harmony import */ var _data_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84685);





/** @internal */
const OrPatchTypeId = /*#__PURE__*/Symbol.for("effect/DifferOrPatch");
function variance(a) {
  return a;
}
/** @internal */
const PatchProto = {
  ..._data_js__WEBPACK_IMPORTED_MODULE_0__/* .Structural.prototype */ .Kj.prototype,
  [OrPatchTypeId]: {
    _Value: variance,
    _Key: variance,
    _Patch: variance
  }
};
const EmptyProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Empty"
});
const _empty = /*#__PURE__*/Object.create(EmptyProto);
/** @internal */
const empty = () => _empty;
const AndThenProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "AndThen"
});
/** @internal */
const makeAndThen = (first, second) => {
  const o = Object.create(AndThenProto);
  o.first = first;
  o.second = second;
  return o;
};
const SetLeftProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "SetLeft"
});
/** @internal */
const makeSetLeft = value => {
  const o = Object.create(SetLeftProto);
  o.value = value;
  return o;
};
const SetRightProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "SetRight"
});
/** @internal */
const makeSetRight = value => {
  const o = Object.create(SetRightProto);
  o.value = value;
  return o;
};
const UpdateLeftProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "UpdateLeft"
});
/** @internal */
const makeUpdateLeft = patch => {
  const o = Object.create(UpdateLeftProto);
  o.patch = patch;
  return o;
};
const UpdateRightProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "UpdateRight"
});
/** @internal */
const makeUpdateRight = patch => {
  const o = Object.create(UpdateRightProto);
  o.patch = patch;
  return o;
};
/** @internal */
const diff = options => {
  switch (options.oldValue._tag) {
    case "Left":
      {
        switch (options.newValue._tag) {
          case "Left":
            {
              const valuePatch = options.left.diff(options.oldValue.left, options.newValue.left);
              if (_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS(valuePatch, options.left.empty)) {
                return empty();
              }
              return makeUpdateLeft(valuePatch);
            }
          case "Right":
            {
              return makeSetRight(options.newValue.right);
            }
        }
      }
    case "Right":
      {
        switch (options.newValue._tag) {
          case "Left":
            {
              return makeSetLeft(options.newValue.left);
            }
          case "Right":
            {
              const valuePatch = options.right.diff(options.oldValue.right, options.newValue.right);
              if (_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS(valuePatch, options.right.empty)) {
                return empty();
              }
              return makeUpdateRight(valuePatch);
            }
        }
      }
  }
};
/** @internal */
const combine = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB(2, (self, that) => makeAndThen(self, that));
/** @internal */
const patch = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB(2, (self, {
  left,
  oldValue,
  right
}) => {
  if (self._tag === "Empty") {
    return oldValue;
  }
  let patches = _Chunk_js__WEBPACK_IMPORTED_MODULE_3__.of(self);
  let result = oldValue;
  while (_Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .isNonEmpty */ .Od(patches)) {
    const head = _Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .headNonEmpty */ .dK(patches);
    const tail = _Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .tailNonEmpty */ .fm(patches);
    switch (head._tag) {
      case "Empty":
        {
          patches = tail;
          break;
        }
      case "AndThen":
        {
          patches = _Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .prepend */ .Ce(head.first)(_Chunk_js__WEBPACK_IMPORTED_MODULE_3__/* .prepend */ .Ce(head.second)(tail));
          break;
        }
      case "UpdateLeft":
        {
          if (result._tag === "Left") {
            result = _Either_js__WEBPACK_IMPORTED_MODULE_4__/* .left */ .t$(left.patch(head.patch, result.left));
          }
          patches = tail;
          break;
        }
      case "UpdateRight":
        {
          if (result._tag === "Right") {
            result = _Either_js__WEBPACK_IMPORTED_MODULE_4__/* .right */ .F2(right.patch(head.patch, result.right));
          }
          patches = tail;
          break;
        }
      case "SetLeft":
        {
          result = _Either_js__WEBPACK_IMPORTED_MODULE_4__/* .left */ .t$(head.value);
          patches = tail;
          break;
        }
      case "SetRight":
        {
          result = _Either_js__WEBPACK_IMPORTED_MODULE_4__/* .right */ .F2(head.value);
          patches = tail;
          break;
        }
    }
  }
  return result;
});
//# sourceMappingURL=orPatch.js.map

/***/ }),

/***/ 49451:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "Hg": function() { return /* binding */ diff; },
/* harmony export */   "Nb": function() { return /* binding */ ReadonlyArrayPatchTypeId; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "r$": function() { return /* binding */ patch; }
/* harmony export */ });
/* harmony import */ var _Array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37901);
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17316);
/* harmony import */ var _data_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84685);




/** @internal */
const ReadonlyArrayPatchTypeId = /*#__PURE__*/Symbol.for("effect/DifferReadonlyArrayPatch");
function variance(a) {
  return a;
}
const PatchProto = {
  ..._data_js__WEBPACK_IMPORTED_MODULE_0__/* .Structural.prototype */ .Kj.prototype,
  [ReadonlyArrayPatchTypeId]: {
    _Value: variance,
    _Patch: variance
  }
};
const EmptyProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Empty"
});
const _empty = /*#__PURE__*/Object.create(EmptyProto);
/**
 * @internal
 */
const empty = () => _empty;
const AndThenProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "AndThen"
});
const makeAndThen = (first, second) => {
  const o = Object.create(AndThenProto);
  o.first = first;
  o.second = second;
  return o;
};
const AppendProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Append"
});
const makeAppend = values => {
  const o = Object.create(AppendProto);
  o.values = values;
  return o;
};
const SliceProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Slice"
});
const makeSlice = (from, until) => {
  const o = Object.create(SliceProto);
  o.from = from;
  o.until = until;
  return o;
};
const UpdateProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(PatchProto), {
  _tag: "Update"
});
const makeUpdate = (index, patch) => {
  const o = Object.create(UpdateProto);
  o.index = index;
  o.patch = patch;
  return o;
};
/** @internal */
const diff = options => {
  let i = 0;
  let patch = empty();
  while (i < options.oldValue.length && i < options.newValue.length) {
    const oldElement = options.oldValue[i];
    const newElement = options.newValue[i];
    const valuePatch = options.differ.diff(oldElement, newElement);
    if (!_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS(valuePatch, options.differ.empty)) {
      patch = combine(patch, makeUpdate(i, valuePatch));
    }
    i = i + 1;
  }
  if (i < options.oldValue.length) {
    patch = combine(patch, makeSlice(0, i));
  }
  if (i < options.newValue.length) {
    patch = combine(patch, makeAppend(_Array_js__WEBPACK_IMPORTED_MODULE_2__/* .drop */ .Cw(i)(options.newValue)));
  }
  return patch;
};
/** @internal */
const combine = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .dual */ .OB(2, (self, that) => makeAndThen(self, that));
/** @internal */
const patch = /*#__PURE__*/_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .dual */ .OB(3, (self, oldValue, differ) => {
  if (self._tag === "Empty") {
    return oldValue;
  }
  let readonlyArray = oldValue.slice();
  let patches = _Array_js__WEBPACK_IMPORTED_MODULE_2__.of(self);
  while (_Array_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonEmptyArray */ .Of(patches)) {
    const head = _Array_js__WEBPACK_IMPORTED_MODULE_2__/* .headNonEmpty */ .dK(patches);
    const tail = _Array_js__WEBPACK_IMPORTED_MODULE_2__/* .tailNonEmpty */ .fm(patches);
    switch (head._tag) {
      case "Empty":
        {
          patches = tail;
          break;
        }
      case "AndThen":
        {
          tail.unshift(head.first, head.second);
          patches = tail;
          break;
        }
      case "Append":
        {
          for (const value of head.values) {
            readonlyArray.push(value);
          }
          patches = tail;
          break;
        }
      case "Slice":
        {
          readonlyArray = readonlyArray.slice(head.from, head.until);
          patches = tail;
          break;
        }
      case "Update":
        {
          readonlyArray[head.index] = differ.patch(head.patch, readonlyArray[head.index]);
          patches = tail;
          break;
        }
    }
  }
  return readonlyArray;
});
//# sourceMappingURL=readonlyArrayPatch.js.map

/***/ }),

/***/ 34606:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": function() { return /* binding */ timeoutFail; },
/* harmony export */   "Bo": function() { return /* binding */ forkIn; },
/* harmony export */   "CL": function() { return /* binding */ forkScoped; },
/* harmony export */   "Ct": function() { return /* binding */ unsafeMakeSemaphore; },
/* harmony export */   "D6": function() { return /* binding */ zipFiber; },
/* harmony export */   "ES": function() { return /* binding */ timeoutOption; },
/* harmony export */   "Ev": function() { return /* binding */ bindAll; },
/* harmony export */   "Fi": function() { return /* binding */ makeSemaphore; },
/* harmony export */   "Fw": function() { return /* binding */ scheduleForked; },
/* harmony export */   "H4": function() { return /* binding */ zipLeftFiber; },
/* harmony export */   "HX": function() { return /* binding */ cached; },
/* harmony export */   "Ij": function() { return /* binding */ ensuringChildren; },
/* harmony export */   "Lj": function() { return /* binding */ supervised; },
/* harmony export */   "NZ": function() { return /* binding */ awaitAllChildren; },
/* harmony export */   "R0": function() { return /* binding */ timeoutFailCause; },
/* harmony export */   "Vs": function() { return /* binding */ timeout; },
/* harmony export */   "Xe": function() { return /* binding */ forkAll; },
/* harmony export */   "a7": function() { return /* binding */ ensuringChild; },
/* harmony export */   "c2": function() { return /* binding */ unsafeMakeSynchronized; },
/* harmony export */   "db": function() { return /* binding */ unsafeMakeLatch; },
/* harmony export */   "eS": function() { return /* binding */ timeoutTo; },
/* harmony export */   "oH": function() { return /* binding */ cachedFunction; },
/* harmony export */   "ql": function() { return /* binding */ fromFiberEffect; },
/* harmony export */   "v$": function() { return /* binding */ zipWithFiber; },
/* harmony export */   "v9": function() { return /* binding */ zipRightFiber; },
/* harmony export */   "vM": function() { return /* binding */ makeLatch; },
/* harmony export */   "x3": function() { return /* binding */ raceFirst; },
/* harmony export */   "yE": function() { return /* binding */ fromFiber; },
/* harmony export */   "yT": function() { return /* binding */ makeSynchronized; },
/* harmony export */   "z4": function() { return /* binding */ cachedInvalidateWithTTL; }
/* harmony export */ });
/* unused harmony exports SynchronizedTypeId, synchronizedVariance, updateSomeAndGetEffectSynchronized */
/* harmony import */ var _Duration_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13571);
/* harmony import */ var _Effectable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34744);
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67492);
/* harmony import */ var _Exit_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(76658);
/* harmony import */ var _FiberId_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(57303);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17316);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(89379);
/* harmony import */ var _MutableHashMap_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(30424);
/* harmony import */ var _Option_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16749);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(92817);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71335);
/* harmony import */ var _Readable_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(88005);
/* harmony import */ var _Scheduler_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22019);
/* harmony import */ var _cause_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(69579);
/* harmony import */ var _core_effect_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53623);
/* harmony import */ var _core_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39355);
/* harmony import */ var _fiber_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63914);
/* harmony import */ var _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90886);
/* harmony import */ var _fiberScope_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51770);
/* harmony import */ var _ref_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7411);
/* harmony import */ var _schedule_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97200);
/* harmony import */ var _supervisor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34357);






















/** @internal */
class Semaphore {
  permits;
  waiters = /*#__PURE__*/new Set();
  taken = 0;
  constructor(permits) {
    this.permits = permits;
  }
  get free() {
    return this.permits - this.taken;
  }
  take = n => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .asyncInterrupt */ .qt5(resume => {
    if (this.free < n) {
      const observer = () => {
        if (this.free < n) {
          return;
        }
        this.waiters.delete(observer);
        this.taken += n;
        resume(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .succeed */ .ng0(n));
      };
      this.waiters.add(observer);
      return _core_js__WEBPACK_IMPORTED_MODULE_0__/* .sync */ .Z_X(() => {
        this.waiters.delete(observer);
      });
    }
    this.taken += n;
    return resume(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .succeed */ .ng0(n));
  });
  updateTaken = f => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .withFiberRuntime */ .ECC(fiber => {
    this.taken = f(this.taken);
    if (this.waiters.size > 0) {
      fiber.getFiberRef(_Scheduler_js__WEBPACK_IMPORTED_MODULE_1__/* .currentScheduler */ .xt).scheduleTask(() => {
        const iter = this.waiters.values();
        let item = iter.next();
        while (item.done === false && this.free > 0) {
          item.value();
          item = iter.next();
        }
      }, fiber.getFiberRef(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .currentSchedulingPriority */ .opO));
    }
    return _core_js__WEBPACK_IMPORTED_MODULE_0__/* .succeed */ .ng0(this.free);
  });
  release = n => this.updateTaken(taken => taken - n);
  releaseAll = /*#__PURE__*/this.updateTaken(_ => 0);
  withPermits = n => self => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .uninterruptibleMask */ .UO$(restore => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(restore(this.take(n)), permits => _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .ensuring */ .IH(restore(self), this.release(permits))));
  withPermitsIfAvailable = n => self => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .uninterruptibleMask */ .UO$(restore => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .suspend */ .RqG(() => {
    if (this.free < n) {
      return _core_effect_js__WEBPACK_IMPORTED_MODULE_3__/* .succeedNone */ .pF;
    }
    this.taken += n;
    return _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .ensuring */ .IH(restore(_core_effect_js__WEBPACK_IMPORTED_MODULE_3__/* .asSome */ .l0(self)), this.release(n));
  }));
}
/** @internal */
const unsafeMakeSemaphore = permits => new Semaphore(permits);
/** @internal */
const makeSemaphore = permits => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .sync */ .Z_X(() => unsafeMakeSemaphore(permits));
class Latch extends _Effectable_js__WEBPACK_IMPORTED_MODULE_4__/* .Class */ .wT {
  isOpen;
  waiters = [];
  scheduled = false;
  constructor(isOpen) {
    super();
    this.isOpen = isOpen;
  }
  commit() {
    return this.await;
  }
  unsafeSchedule(fiber) {
    if (this.scheduled || this.waiters.length === 0) {
      return _core_js__WEBPACK_IMPORTED_MODULE_0__/* ["void"] */ .Hcj;
    }
    this.scheduled = true;
    fiber.currentScheduler.scheduleTask(this.flushWaiters, fiber.getFiberRef(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .currentSchedulingPriority */ .opO));
    return _core_js__WEBPACK_IMPORTED_MODULE_0__/* ["void"] */ .Hcj;
  }
  flushWaiters = () => {
    this.scheduled = false;
    const waiters = this.waiters;
    this.waiters = [];
    for (let i = 0; i < waiters.length; i++) {
      waiters[i](_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitVoid */ .E7$);
    }
  };
  open = /*#__PURE__*/_core_js__WEBPACK_IMPORTED_MODULE_0__/* .withFiberRuntime */ .ECC(fiber => {
    if (this.isOpen) {
      return _core_js__WEBPACK_IMPORTED_MODULE_0__/* ["void"] */ .Hcj;
    }
    this.isOpen = true;
    return this.unsafeSchedule(fiber);
  });
  unsafeOpen() {
    if (this.isOpen) return;
    this.isOpen = true;
    this.flushWaiters();
  }
  release = /*#__PURE__*/_core_js__WEBPACK_IMPORTED_MODULE_0__/* .withFiberRuntime */ .ECC(fiber => {
    if (this.isOpen) {
      return _core_js__WEBPACK_IMPORTED_MODULE_0__/* ["void"] */ .Hcj;
    }
    return this.unsafeSchedule(fiber);
  });
  await = /*#__PURE__*/_core_js__WEBPACK_IMPORTED_MODULE_0__/* .asyncInterrupt */ .qt5(resume => {
    if (this.isOpen) {
      return resume(_core_js__WEBPACK_IMPORTED_MODULE_0__/* ["void"] */ .Hcj);
    }
    this.waiters.push(resume);
    return _core_js__WEBPACK_IMPORTED_MODULE_0__/* .sync */ .Z_X(() => {
      const index = this.waiters.indexOf(resume);
      if (index !== -1) {
        this.waiters.splice(index, 1);
      }
    });
  });
  unsafeClose() {
    this.isOpen = false;
  }
  close = /*#__PURE__*/_core_js__WEBPACK_IMPORTED_MODULE_0__/* .sync */ .Z_X(() => {
    this.isOpen = false;
  });
  whenOpen = self => {
    return _core_js__WEBPACK_IMPORTED_MODULE_0__/* .zipRight */ .qs5(this.await, self);
  };
}
/** @internal */
const unsafeMakeLatch = open => new Latch(open ?? false);
/** @internal */
const makeLatch = open => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .sync */ .Z_X(() => unsafeMakeLatch(open));
/** @internal */
const awaitAllChildren = self => ensuringChildren(self, _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .fiberAwaitAll */ .GR);
/** @internal */
const cached = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, timeToLive) => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UID(cachedInvalidateWithTTL(self, timeToLive), tuple => tuple[0]));
/** @internal */
const cachedInvalidateWithTTL = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, timeToLive) => {
  const duration = _Duration_js__WEBPACK_IMPORTED_MODULE_6__/* .decode */ .Jx(timeToLive);
  return _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .context */ .Do7(), env => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UID(makeSynchronized(_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .none */ .YP()), cache => [_core_js__WEBPACK_IMPORTED_MODULE_0__/* .provideContext */ .qNZ(getCachedValue(self, duration, cache), env), invalidateCache(cache)]));
});
/** @internal */
const computeCachedValue = (self, timeToLive, start) => {
  const timeToLiveMillis = _Duration_js__WEBPACK_IMPORTED_MODULE_6__/* .toMillis */ .eq(_Duration_js__WEBPACK_IMPORTED_MODULE_6__/* .decode */ .Jx(timeToLive));
  return (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .deferredMake */ .kPu(), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .tap */ .bwX(deferred => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .intoDeferred */ .S4Q(self, deferred)), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UID(deferred => _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .some */ .G([start + timeToLiveMillis, deferred])));
};
/** @internal */
const getCachedValue = (self, timeToLive, cache) => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .uninterruptibleMask */ .UO$(restore => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(_core_effect_js__WEBPACK_IMPORTED_MODULE_3__/* .clockWith */ .UA(clock => clock.currentTimeMillis), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(time => updateSomeAndGetEffectSynchronized(cache, option => {
  switch (option._tag) {
    case "None":
      {
        return _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .some */ .G(computeCachedValue(self, timeToLive, time));
      }
    case "Some":
      {
        const [end] = option.value;
        return end - time <= 0 ? _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .some */ .G(computeCachedValue(self, timeToLive, time)) : _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .none */ .YP();
      }
  }
})), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(option => _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .isNone */ .Wi(option) ? _core_js__WEBPACK_IMPORTED_MODULE_0__/* .dieMessage */ .lFE("BUG: Effect.cachedInvalidate - please report an issue at https://github.com/Effect-TS/effect/issues") : restore(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .deferredAwait */ .Odg(option.value[1])))));
/** @internal */
const invalidateCache = cache => _ref_js__WEBPACK_IMPORTED_MODULE_8__/* .set */ .t8(cache, _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .none */ .YP());
/** @internal */
const ensuringChild = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, f) => ensuringChildren(self, children => f(_fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .fiberAll */ .kC(children))));
/** @internal */
const ensuringChildren = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, children) => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(_supervisor_js__WEBPACK_IMPORTED_MODULE_9__/* .track */ .j, supervisor => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(supervised(self, supervisor), _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .ensuring */ .IH(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(supervisor.value, children)))));
/** @internal */
const forkAll = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(args => _Predicate_js__WEBPACK_IMPORTED_MODULE_10__/* .isIterable */ .TW(args[0]), (effects, options) => options?.discard ? _core_js__WEBPACK_IMPORTED_MODULE_0__/* .forEachSequentialDiscard */ .EaP(effects, _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .fork */ .rM) : _core_js__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UID(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .forEachSequential */ .o9$(effects, _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .fork */ .rM), _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .fiberAll */ .kC));
/** @internal */
const forkIn = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, scope) => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .withFiberRuntime */ .ECC((parent, parentStatus) => {
  const scopeImpl = scope;
  const fiber = _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .unsafeFork */ .hU(self, parent, parentStatus.runtimeFlags, _fiberScope_js__WEBPACK_IMPORTED_MODULE_11__/* .globalScope */ ._A);
  if (scopeImpl.state._tag === "Open") {
    const finalizer = () => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .fiberIdWith */ .mrY(fiberId => _Equal_js__WEBPACK_IMPORTED_MODULE_12__/* .equals */ .fS(fiberId, fiber.id()) ? _core_js__WEBPACK_IMPORTED_MODULE_0__/* ["void"] */ .Hcj : _core_js__WEBPACK_IMPORTED_MODULE_0__/* .asVoid */ .a2S(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .interruptFiber */ .u_W(fiber)));
    const key = {};
    scopeImpl.state.finalizers.set(key, finalizer);
    fiber.addObserver(() => {
      if (scopeImpl.state._tag === "Closed") return;
      scopeImpl.state.finalizers.delete(key);
    });
  } else {
    fiber.unsafeInterruptAsFork(parent.id());
  }
  return _core_js__WEBPACK_IMPORTED_MODULE_0__/* .succeed */ .ng0(fiber);
}));
/** @internal */
const forkScoped = self => _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .scopeWith */ .ZO(scope => forkIn(self, scope));
/** @internal */
const fromFiber = fiber => _fiber_js__WEBPACK_IMPORTED_MODULE_13__/* .join */ .v_(fiber);
/** @internal */
const fromFiberEffect = fiber => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .suspend */ .RqG(() => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(fiber, _fiber_js__WEBPACK_IMPORTED_MODULE_13__/* .join */ .v_));
const memoKeySymbol = /*#__PURE__*/Symbol.for("effect/Effect/memoizeFunction.key");
class Key {
  a;
  eq;
  [memoKeySymbol] = memoKeySymbol;
  constructor(a, eq) {
    this.a = a;
    this.eq = eq;
  }
  [_Equal_js__WEBPACK_IMPORTED_MODULE_12__/* .symbol */ .NA](that) {
    if (_Predicate_js__WEBPACK_IMPORTED_MODULE_10__/* .hasProperty */ .l$(that, memoKeySymbol)) {
      if (this.eq) {
        return this.eq(this.a, that.a);
      } else {
        return _Equal_js__WEBPACK_IMPORTED_MODULE_12__/* .equals */ .fS(this.a, that.a);
      }
    }
    return false;
  }
  [_Hash_js__WEBPACK_IMPORTED_MODULE_14__/* .symbol */ .NA]() {
    return this.eq ? 0 : _Hash_js__WEBPACK_IMPORTED_MODULE_14__/* .cached */ .HX(this, _Hash_js__WEBPACK_IMPORTED_MODULE_14__/* .hash */ .vp(this.a));
  }
}
/** @internal */
const cachedFunction = (f, eq) => {
  return (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .sync */ .Z_X(() => _MutableHashMap_js__WEBPACK_IMPORTED_MODULE_15__/* .empty */ .cS()), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(makeSynchronized), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UID(ref => a => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(ref.modifyEffect(map => {
    const result = (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(map, _MutableHashMap_js__WEBPACK_IMPORTED_MODULE_15__/* .get */ .U2(new Key(a, eq)));
    if (_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .isNone */ .Wi(result)) {
      return (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .deferredMake */ .kPu(), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .tap */ .bwX(deferred => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(_core_effect_js__WEBPACK_IMPORTED_MODULE_3__/* .diffFiberRefs */ .gT(f(a)), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .intoDeferred */ .S4Q(deferred), _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .fork */ .rM)), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UID(deferred => [deferred, (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(map, _MutableHashMap_js__WEBPACK_IMPORTED_MODULE_15__/* .set */ .t8(new Key(a, eq), deferred))]));
    }
    return _core_js__WEBPACK_IMPORTED_MODULE_0__/* .succeed */ .ng0([result.value, map]);
  }), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .deferredAwait */ .Odg), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(([patch, b]) => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(_core_effect_js__WEBPACK_IMPORTED_MODULE_3__/* .patchFiberRefs */ .au(patch), _core_js__WEBPACK_IMPORTED_MODULE_0__.as(b))))));
};
/** @internal */
const raceFirst = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, that) => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exit */ .JFt(self), _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .race */ .S3(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .exit */ .JFt(that)), effect => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatten */ .xHg(effect)));
/** @internal */
const scheduleForked = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, schedule) => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(self, _schedule_js__WEBPACK_IMPORTED_MODULE_16__/* .schedule_Effect */ .fh(schedule), forkScoped));
/** @internal */
const supervised = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, supervisor) => {
  const supervise = _core_js__WEBPACK_IMPORTED_MODULE_0__/* .fiberRefLocallyWith */ .LzL(_fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .currentSupervisor */ .o6, s => s.zip(supervisor));
  return supervise(self);
});
/** @internal */
const timeout = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, duration) => timeoutFail(self, {
  onTimeout: () => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .timeoutExceptionFromDuration */ .hx9(duration),
  duration
}));
/** @internal */
const timeoutFail = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, {
  duration,
  onTimeout
}) => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatten */ .xHg(timeoutTo(self, {
  onTimeout: () => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .failSync */ .zph(onTimeout),
  onSuccess: _core_js__WEBPACK_IMPORTED_MODULE_0__/* .succeed */ .ng0,
  duration
})));
/** @internal */
const timeoutFailCause = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, {
  duration,
  onTimeout
}) => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatten */ .xHg(timeoutTo(self, {
  onTimeout: () => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .failCauseSync */ .euP(onTimeout),
  onSuccess: _core_js__WEBPACK_IMPORTED_MODULE_0__/* .succeed */ .ng0,
  duration
})));
/** @internal */
const timeoutOption = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, duration) => timeoutTo(self, {
  duration,
  onSuccess: _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .some */ .G,
  onTimeout: _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .none */ .YP
}));
/** @internal */
const timeoutTo = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, {
  duration,
  onSuccess,
  onTimeout
}) => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .fiberIdWith */ .mrY(parentFiberId => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .uninterruptibleMask */ .UO$(restore => _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .raceFibersWith */ .q4(restore(self), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .interruptible */ .um_(_core_effect_js__WEBPACK_IMPORTED_MODULE_3__/* .sleep */ ._v(duration)), {
  onSelfWin: (winner, loser) => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(winner.await, exit => {
    if (exit._tag === "Success") {
      return _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(winner.inheritAll, () => _core_js__WEBPACK_IMPORTED_MODULE_0__.as(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .interruptAsFiber */ .zU1(loser, parentFiberId), onSuccess(exit.value)));
    } else {
      return _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .interruptAsFiber */ .zU1(loser, parentFiberId), () => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitFailCause */ .KiG(exit.cause));
    }
  }),
  onOtherWin: (winner, loser) => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(winner.await, exit => {
    if (exit._tag === "Success") {
      return _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(winner.inheritAll, () => _core_js__WEBPACK_IMPORTED_MODULE_0__.as(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .interruptAsFiber */ .zU1(loser, parentFiberId), onTimeout()));
    } else {
      return _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .interruptAsFiber */ .zU1(loser, parentFiberId), () => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .exitFailCause */ .KiG(exit.cause));
    }
  }),
  otherScope: _fiberScope_js__WEBPACK_IMPORTED_MODULE_11__/* .globalScope */ ._A
}))));
// circular with Synchronized
/** @internal */
const SynchronizedSymbolKey = "effect/Ref/SynchronizedRef";
/** @internal */
const SynchronizedTypeId = /*#__PURE__*/Symbol.for(SynchronizedSymbolKey);
/** @internal */
const synchronizedVariance = {
  /* c8 ignore next */
  _A: _ => _
};
/** @internal */
class SynchronizedImpl extends _Effectable_js__WEBPACK_IMPORTED_MODULE_4__/* .Class */ .wT {
  ref;
  withLock;
  [SynchronizedTypeId] = synchronizedVariance;
  [_ref_js__WEBPACK_IMPORTED_MODULE_8__/* .RefTypeId */ .n7] = _ref_js__WEBPACK_IMPORTED_MODULE_8__/* .refVariance */ .Mr;
  [_Readable_js__WEBPACK_IMPORTED_MODULE_17__/* .TypeId */ .aC] = _Readable_js__WEBPACK_IMPORTED_MODULE_17__/* .TypeId */ .aC;
  constructor(ref, withLock) {
    super();
    this.ref = ref;
    this.withLock = withLock;
    this.get = _ref_js__WEBPACK_IMPORTED_MODULE_8__/* .get */ .U2(this.ref);
  }
  get;
  commit() {
    return this.get;
  }
  modify(f) {
    return this.modifyEffect(a => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .succeed */ .ng0(f(a)));
  }
  modifyEffect(f) {
    return this.withLock((0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(_ref_js__WEBPACK_IMPORTED_MODULE_8__/* .get */ .U2(this.ref), f), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(([b, a]) => _core_js__WEBPACK_IMPORTED_MODULE_0__.as(_ref_js__WEBPACK_IMPORTED_MODULE_8__/* .set */ .t8(this.ref, a), b))));
  }
}
/** @internal */
const makeSynchronized = value => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .sync */ .Z_X(() => unsafeMakeSynchronized(value));
/** @internal */
const unsafeMakeSynchronized = value => {
  const ref = _ref_js__WEBPACK_IMPORTED_MODULE_8__/* .unsafeMake */ .t0(value);
  const sem = unsafeMakeSemaphore(1);
  return new SynchronizedImpl(ref, sem.withPermits(1));
};
/** @internal */
const updateSomeAndGetEffectSynchronized = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, pf) => self.modifyEffect(value => {
  const result = pf(value);
  switch (result._tag) {
    case "None":
      {
        return _core_js__WEBPACK_IMPORTED_MODULE_0__/* .succeed */ .ng0([value, value]);
      }
    case "Some":
      {
        return _core_js__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UID(result.value, a => [a, a]);
      }
  }
}));
// circular with Fiber
/** @internal */
const zipFiber = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, that) => zipWithFiber(self, that, (a, b) => [a, b]));
/** @internal */
const zipLeftFiber = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, that) => zipWithFiber(self, that, (a, _) => a));
/** @internal */
const zipRightFiber = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, that) => zipWithFiber(self, that, (_, b) => b));
/** @internal */
const zipWithFiber = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(3, (self, that, f) => ({
  ..._Effectable_js__WEBPACK_IMPORTED_MODULE_4__/* .CommitPrototype */ .ku,
  commit() {
    return _fiber_js__WEBPACK_IMPORTED_MODULE_13__/* .join */ .v_(this);
  },
  [_fiber_js__WEBPACK_IMPORTED_MODULE_13__/* .FiberTypeId */ .tP]: _fiber_js__WEBPACK_IMPORTED_MODULE_13__/* .fiberVariance */ .kD,
  id: () => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(self.id(), _FiberId_js__WEBPACK_IMPORTED_MODULE_18__/* .getOrElse */ .fS(that.id())),
  await: (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(self.await, _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatten */ .xHg, _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .zipWithOptions */ .xn(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatten */ .xHg(that.await), f, {
    concurrent: true
  }), _core_js__WEBPACK_IMPORTED_MODULE_0__/* .exit */ .JFt),
  children: self.children,
  inheritAll: _core_js__WEBPACK_IMPORTED_MODULE_0__/* .zipRight */ .qs5(that.inheritAll, self.inheritAll),
  poll: _core_js__WEBPACK_IMPORTED_MODULE_0__/* .zipWith */ .yL_(self.poll, that.poll, (optionA, optionB) => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(optionA, _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .flatMap */ .VS(exitA => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(optionB, _Option_js__WEBPACK_IMPORTED_MODULE_7__/* .map */ .UI(exitB => _Exit_js__WEBPACK_IMPORTED_MODULE_19__/* .zipWith */ .yL(exitA, exitB, {
    onSuccess: f,
    onFailure: _cause_js__WEBPACK_IMPORTED_MODULE_20__/* .parallel */ .Mf
  })))))),
  interruptAsFork: id => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .zipRight */ .qs5(self.interruptAsFork(id), that.interruptAsFork(id)),
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_21__/* .pipeArguments */ .n)(this, arguments);
  }
}));
/* @internal */
const bindAll = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(args => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .isEffect */ .cdB(args[0]), (self, f, options) => _core_js__WEBPACK_IMPORTED_MODULE_0__/* .flatMap */ .VSD(self, a => _fiberRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .all */ .$6(f(a), options).pipe(_core_js__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UID(record => Object.assign({}, a, record)))));
//# sourceMappingURL=circular.js.map

/***/ }),

/***/ 10020:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EO": function() { return /* binding */ StructuralPrototype; },
/* harmony export */   "Fc": function() { return /* binding */ ChannelTypeId; },
/* harmony export */   "G1": function() { return /* binding */ SinkTypeId; },
/* harmony export */   "Hj": function() { return /* binding */ EffectTypeId; },
/* harmony export */   "Qo": function() { return /* binding */ effectVariance; },
/* harmony export */   "Sh": function() { return /* binding */ StructuralCommitPrototype; },
/* harmony export */   "XY": function() { return /* binding */ Base; },
/* harmony export */   "ku": function() { return /* binding */ CommitPrototype; },
/* harmony export */   "qx": function() { return /* binding */ StreamTypeId; },
/* harmony export */   "t3": function() { return /* binding */ StructuralBase; },
/* harmony export */   "tU": function() { return /* binding */ EffectPrototype; }
/* harmony export */ });
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67492);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89379);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92817);
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70762);
/* harmony import */ var _opCodes_effect_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11713);
/* harmony import */ var _version_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69500);






/** @internal */
const EffectTypeId = /*#__PURE__*/Symbol.for("effect/Effect");
/** @internal */
const StreamTypeId = /*#__PURE__*/Symbol.for("effect/Stream");
/** @internal */
const SinkTypeId = /*#__PURE__*/Symbol.for("effect/Sink");
/** @internal */
const ChannelTypeId = /*#__PURE__*/Symbol.for("effect/Channel");
/** @internal */
const effectVariance = {
  /* c8 ignore next */
  _R: _ => _,
  /* c8 ignore next */
  _E: _ => _,
  /* c8 ignore next */
  _A: _ => _,
  _V: /*#__PURE__*/_version_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentVersion */ .w()
};
const sinkVariance = {
  /* c8 ignore next */
  _A: _ => _,
  /* c8 ignore next */
  _In: _ => _,
  /* c8 ignore next */
  _L: _ => _,
  /* c8 ignore next */
  _E: _ => _,
  /* c8 ignore next */
  _R: _ => _
};
const channelVariance = {
  /* c8 ignore next */
  _Env: _ => _,
  /* c8 ignore next */
  _InErr: _ => _,
  /* c8 ignore next */
  _InElem: _ => _,
  /* c8 ignore next */
  _InDone: _ => _,
  /* c8 ignore next */
  _OutErr: _ => _,
  /* c8 ignore next */
  _OutElem: _ => _,
  /* c8 ignore next */
  _OutDone: _ => _
};
/** @internal */
const EffectPrototype = {
  [EffectTypeId]: effectVariance,
  [StreamTypeId]: effectVariance,
  [SinkTypeId]: sinkVariance,
  [ChannelTypeId]: channelVariance,
  [_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .symbol */ .NA](that) {
    return this === that;
  },
  [_Hash_js__WEBPACK_IMPORTED_MODULE_2__/* .symbol */ .NA]() {
    return _Hash_js__WEBPACK_IMPORTED_MODULE_2__/* .cached */ .HX(this, _Hash_js__WEBPACK_IMPORTED_MODULE_2__/* .random */ .MX(this));
  },
  [Symbol.iterator]() {
    return new _Utils_js__WEBPACK_IMPORTED_MODULE_3__/* .SingleShotGen */ .U9(new _Utils_js__WEBPACK_IMPORTED_MODULE_3__/* .YieldWrap */ .oY(this));
  },
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_4__/* .pipeArguments */ .n)(this, arguments);
  }
};
/** @internal */
const StructuralPrototype = {
  [_Hash_js__WEBPACK_IMPORTED_MODULE_2__/* .symbol */ .NA]() {
    return _Hash_js__WEBPACK_IMPORTED_MODULE_2__/* .cached */ .HX(this, _Hash_js__WEBPACK_IMPORTED_MODULE_2__/* .structure */ .Fh(this));
  },
  [_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .symbol */ .NA](that) {
    const selfKeys = Object.keys(this);
    const thatKeys = Object.keys(that);
    if (selfKeys.length !== thatKeys.length) {
      return false;
    }
    for (const key of selfKeys) {
      if (!(key in that && _Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS(this[key], that[key]))) {
        return false;
      }
    }
    return true;
  }
};
/** @internal */
const CommitPrototype = {
  ...EffectPrototype,
  _op: _opCodes_effect_js__WEBPACK_IMPORTED_MODULE_5__/* .OP_COMMIT */ .vm
};
/** @internal */
const StructuralCommitPrototype = {
  ...CommitPrototype,
  ...StructuralPrototype
};
/** @internal */
const Base = /*#__PURE__*/function () {
  function Base() {}
  Base.prototype = CommitPrototype;
  return Base;
}();
/** @internal */
const StructuralBase = /*#__PURE__*/function () {
  function Base() {}
  Base.prototype = StructuralCommitPrototype;
  return Base;
}();
//# sourceMappingURL=effectable.js.map

/***/ }),

/***/ 75974:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EK": function() { return /* binding */ getRight; },
/* harmony export */   "F2": function() { return /* binding */ right; },
/* harmony export */   "FT": function() { return /* binding */ isEither; },
/* harmony export */   "IS": function() { return /* binding */ getLeft; },
/* harmony export */   "Yo": function() { return /* binding */ fromOption; },
/* harmony export */   "aC": function() { return /* binding */ TypeId; },
/* harmony export */   "nM": function() { return /* binding */ isLeft; },
/* harmony export */   "t$": function() { return /* binding */ left; },
/* harmony export */   "tO": function() { return /* binding */ isRight; }
/* harmony export */ });
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17316);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89379);
/* harmony import */ var _Inspectable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16371);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71335);
/* harmony import */ var _effectable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10020);
/* harmony import */ var _option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70602);
/**
 * @since 2.0.0
 */







/**
 * @internal
 */
const TypeId = /*#__PURE__*/Symbol.for("effect/Either");
const CommonProto = {
  ..._effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .EffectPrototype */ .tU,
  [TypeId]: {
    _R: _ => _
  },
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_1__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  },
  toString() {
    return (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_1__/* .format */ .WU)(this.toJSON());
  }
};
const RightProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(CommonProto), {
  _tag: "Right",
  _op: "Right",
  [_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .symbol */ .NA](that) {
    return isEither(that) && isRight(that) && _Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .equals */ .fS(this.right, that.right);
  },
  [_Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .symbol */ .NA]() {
    return _Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .combine */ .$e(_Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .hash */ .vp(this._tag))(_Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .hash */ .vp(this.right));
  },
  toJSON() {
    return {
      _id: "Either",
      _tag: this._tag,
      right: (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_1__/* .toJSON */ .au)(this.right)
    };
  }
});
const LeftProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(CommonProto), {
  _tag: "Left",
  _op: "Left",
  [_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .symbol */ .NA](that) {
    return isEither(that) && isLeft(that) && _Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .equals */ .fS(this.left, that.left);
  },
  [_Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .symbol */ .NA]() {
    return _Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .combine */ .$e(_Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .hash */ .vp(this._tag))(_Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .hash */ .vp(this.left));
  },
  toJSON() {
    return {
      _id: "Either",
      _tag: this._tag,
      left: (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_1__/* .toJSON */ .au)(this.left)
    };
  }
});
/** @internal */
const isEither = input => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_4__/* .hasProperty */ .l$)(input, TypeId);
/** @internal */
const isLeft = ma => ma._tag === "Left";
/** @internal */
const isRight = ma => ma._tag === "Right";
/** @internal */
const left = left => {
  const a = Object.create(LeftProto);
  a.left = left;
  return a;
};
/** @internal */
const right = right => {
  const a = Object.create(RightProto);
  a.right = right;
  return a;
};
/** @internal */
const getLeft = self => isRight(self) ? _option_js__WEBPACK_IMPORTED_MODULE_5__/* .none */ .YP : _option_js__WEBPACK_IMPORTED_MODULE_5__/* .some */ .G(self.left);
/** @internal */
const getRight = self => isLeft(self) ? _option_js__WEBPACK_IMPORTED_MODULE_5__/* .none */ .YP : _option_js__WEBPACK_IMPORTED_MODULE_5__/* .some */ .G(self.right);
/** @internal */
const fromOption = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, onNone) => _option_js__WEBPACK_IMPORTED_MODULE_5__/* .isNone */ .Wi(self) ? left(onNone()) : right(self.value));
//# sourceMappingURL=either.js.map

/***/ }),

/***/ 3910:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ getBugErrorMessage; }
/* harmony export */ });
/**
 * @since 2.0.0
 */
/** @internal */
const getBugErrorMessage = message => `BUG: ${message} - please report an issue at https://github.com/Effect-TS/effect/issues`;
//# sourceMappingURL=errors.js.map

/***/ }),

/***/ 49941:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DS": function() { return /* binding */ isSequential; },
/* harmony export */   "EQ": function() { return /* binding */ match; },
/* harmony export */   "Mf": function() { return /* binding */ parallel; },
/* harmony export */   "Pe": function() { return /* binding */ sequential; },
/* harmony export */   "gM": function() { return /* binding */ isParallelN; },
/* harmony export */   "rN": function() { return /* binding */ isParallel; },
/* harmony export */   "w7": function() { return /* binding */ parallelN; }
/* harmony export */ });
/* unused harmony exports OP_SEQUENTIAL, OP_PARALLEL, OP_PARALLEL_N */
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17316);

/** @internal */
const OP_SEQUENTIAL = "Sequential";
/** @internal */
const OP_PARALLEL = "Parallel";
/** @internal */
const OP_PARALLEL_N = "ParallelN";
/** @internal */
const sequential = {
  _tag: OP_SEQUENTIAL
};
/** @internal */
const parallel = {
  _tag: OP_PARALLEL
};
/** @internal */
const parallelN = parallelism => ({
  _tag: OP_PARALLEL_N,
  parallelism
});
/** @internal */
const isSequential = self => self._tag === OP_SEQUENTIAL;
/** @internal */
const isParallel = self => self._tag === OP_PARALLEL;
/** @internal */
const isParallelN = self => self._tag === OP_PARALLEL_N;
/** @internal */
const match = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, options) => {
  switch (self._tag) {
    case OP_SEQUENTIAL:
      {
        return options.onSequential();
      }
    case OP_PARALLEL:
      {
        return options.onParallel();
      }
    case OP_PARALLEL_N:
      {
        return options.onParallelN(self.parallelism);
      }
  }
});
//# sourceMappingURL=executionStrategy.js.map

/***/ }),

/***/ 63914:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ poll; },
/* harmony export */   "$w": function() { return /* binding */ dump; },
/* harmony export */   "A1": function() { return /* binding */ isFiber; },
/* harmony export */   "AO": function() { return /* binding */ _await; },
/* harmony export */   "Dh": function() { return /* binding */ failCause; },
/* harmony export */   "EQ": function() { return /* binding */ match; },
/* harmony export */   "Fi": function() { return /* binding */ never; },
/* harmony export */   "Hc": function() { return /* binding */ void_; },
/* harmony export */   "IC": function() { return /* binding */ pretty; },
/* harmony export */   "J1": function() { return /* binding */ mapEffect; },
/* harmony export */   "Jy": function() { return /* binding */ mapFiber; },
/* harmony export */   "K2": function() { return /* binding */ interrupted; },
/* harmony export */   "KM": function() { return /* binding */ Order; },
/* harmony export */   "Mt": function() { return /* binding */ interruptAsFork; },
/* harmony export */   "Mz": function() { return /* binding */ isRuntimeFiber; },
/* harmony export */   "O0": function() { return /* binding */ orElseEither; },
/* harmony export */   "QY": function() { return /* binding */ getCurrentFiber; },
/* harmony export */   "R2": function() { return /* binding */ unsafeRoots; },
/* harmony export */   "SH": function() { return /* binding */ fromEffect; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "VK": function() { return /* binding */ roots; },
/* harmony export */   "Wr": function() { return /* binding */ dumpAll; },
/* harmony export */   "Zq": function() { return /* binding */ RuntimeFiberTypeId; },
/* harmony export */   "aT": function() { return /* binding */ done; },
/* harmony export */   "bG": function() { return /* binding */ fail; },
/* harmony export */   "h3": function() { return /* binding */ interruptAllAs; },
/* harmony export */   "i0": function() { return /* binding */ inheritAll; },
/* harmony export */   "i7": function() { return /* binding */ status; },
/* harmony export */   "id": function() { return /* binding */ id; },
/* harmony export */   "kD": function() { return /* binding */ fiberVariance; },
/* harmony export */   "m2": function() { return /* binding */ interruptAll; },
/* harmony export */   "ng": function() { return /* binding */ succeed; },
/* harmony export */   "nv": function() { return /* binding */ currentFiberURI; },
/* harmony export */   "pI": function() { return /* binding */ children; },
/* harmony export */   "tP": function() { return /* binding */ FiberTypeId; },
/* harmony export */   "v_": function() { return /* binding */ join; },
/* harmony export */   "vx": function() { return /* binding */ orElse; }
/* harmony export */ });
/* harmony import */ var _Clock_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9605);
/* harmony import */ var _Either_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87585);
/* harmony import */ var _Exit_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76658);
/* harmony import */ var _FiberId_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57303);
/* harmony import */ var _FiberStatus_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32860);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17316);
/* harmony import */ var _HashSet_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9551);
/* harmony import */ var _Number_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15839);
/* harmony import */ var _Option_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16749);
/* harmony import */ var _Order_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51988);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92817);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71335);
/* harmony import */ var _core_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39355);
/* harmony import */ var _effectable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10020);
/* harmony import */ var _fiberScope_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51770);
/* harmony import */ var _runtimeFlags_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4536);
















/** @internal */
const FiberSymbolKey = "effect/Fiber";
/** @internal */
const FiberTypeId = /*#__PURE__*/Symbol.for(FiberSymbolKey);
/** @internal */
const fiberVariance = {
  /* c8 ignore next */
  _E: _ => _,
  /* c8 ignore next */
  _A: _ => _
};
/** @internal */
const fiberProto = {
  [FiberTypeId]: fiberVariance,
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_0__/* .pipeArguments */ .n)(this, arguments);
  }
};
/** @internal */
const RuntimeFiberSymbolKey = "effect/Fiber";
/** @internal */
const RuntimeFiberTypeId = /*#__PURE__*/Symbol.for(RuntimeFiberSymbolKey);
/** @internal */
const Order = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)( /*#__PURE__*/_Order_js__WEBPACK_IMPORTED_MODULE_2__/* .tuple */ .bc(_Number_js__WEBPACK_IMPORTED_MODULE_3__/* .Order */ .KM, _Number_js__WEBPACK_IMPORTED_MODULE_3__/* .Order */ .KM), /*#__PURE__*/_Order_js__WEBPACK_IMPORTED_MODULE_2__/* .mapInput */ .$H(fiber => [fiber.id().startTimeMillis, fiber.id().id]));
/** @internal */
const isFiber = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_4__/* .hasProperty */ .l$)(u, FiberTypeId);
/** @internal */
const isRuntimeFiber = self => RuntimeFiberTypeId in self;
/** @internal */
const _await = self => self.await;
/** @internal */
const children = self => self.children;
/** @internal */
const done = exit => {
  const _fiber = {
    ..._effectable_js__WEBPACK_IMPORTED_MODULE_5__/* .CommitPrototype */ .ku,
    commit() {
      return join(this);
    },
    ...fiberProto,
    id: () => _FiberId_js__WEBPACK_IMPORTED_MODULE_6__/* .none */ .YP,
    await: _core_js__WEBPACK_IMPORTED_MODULE_7__/* .succeed */ .ng0(exit),
    children: _core_js__WEBPACK_IMPORTED_MODULE_7__/* .succeed */ .ng0([]),
    inheritAll: _core_js__WEBPACK_IMPORTED_MODULE_7__/* ["void"] */ .Hcj,
    poll: _core_js__WEBPACK_IMPORTED_MODULE_7__/* .succeed */ .ng0(_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .some */ .G(exit)),
    interruptAsFork: () => _core_js__WEBPACK_IMPORTED_MODULE_7__/* ["void"] */ .Hcj
  };
  return _fiber;
};
/** @internal */
const dump = self => _core_js__WEBPACK_IMPORTED_MODULE_7__/* .map */ .UID(self.status, status => ({
  id: self.id(),
  status
}));
/** @internal */
const dumpAll = fibers => _core_js__WEBPACK_IMPORTED_MODULE_7__/* .forEachSequential */ .o9$(fibers, dump);
/** @internal */
const fail = error => done(_Exit_js__WEBPACK_IMPORTED_MODULE_9__/* .fail */ .bG(error));
/** @internal */
const failCause = cause => done(_Exit_js__WEBPACK_IMPORTED_MODULE_9__/* .failCause */ .Dh(cause));
/** @internal */
const fromEffect = effect => _core_js__WEBPACK_IMPORTED_MODULE_7__/* .map */ .UID(_core_js__WEBPACK_IMPORTED_MODULE_7__/* .exit */ .JFt(effect), done);
/** @internal */
const id = self => self.id();
/** @internal */
const inheritAll = self => self.inheritAll;
/** @internal */
const interrupted = fiberId => done(_Exit_js__WEBPACK_IMPORTED_MODULE_9__/* .interrupt */ .e1(fiberId));
/** @internal */
const interruptAll = fibers => _core_js__WEBPACK_IMPORTED_MODULE_7__/* .flatMap */ .VSD(_core_js__WEBPACK_IMPORTED_MODULE_7__/* .fiberId */ .ezx, fiberId => (0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(fibers, interruptAllAs(fiberId)));
/** @internal */
const interruptAllAs = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (fibers, fiberId) => (0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(_core_js__WEBPACK_IMPORTED_MODULE_7__/* .forEachSequentialDiscard */ .EaP(fibers, interruptAsFork(fiberId)), _core_js__WEBPACK_IMPORTED_MODULE_7__/* .zipRight */ .qs5((0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(fibers, _core_js__WEBPACK_IMPORTED_MODULE_7__/* .forEachSequentialDiscard */ .EaP(_await)))));
/** @internal */
const interruptAsFork = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, fiberId) => self.interruptAsFork(fiberId));
/** @internal */
const join = self => _core_js__WEBPACK_IMPORTED_MODULE_7__/* .zipLeft */ .Ti7(_core_js__WEBPACK_IMPORTED_MODULE_7__/* .flatten */ .xHg(self.await), self.inheritAll);
/** @internal */
const map = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, f) => mapEffect(self, a => _core_js__WEBPACK_IMPORTED_MODULE_7__/* .sync */ .Z_X(() => f(a))));
/** @internal */
const mapEffect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, f) => {
  const _fiber = {
    ..._effectable_js__WEBPACK_IMPORTED_MODULE_5__/* .CommitPrototype */ .ku,
    commit() {
      return join(this);
    },
    ...fiberProto,
    id: () => self.id(),
    await: _core_js__WEBPACK_IMPORTED_MODULE_7__/* .flatMap */ .VSD(self.await, _Exit_js__WEBPACK_IMPORTED_MODULE_9__/* .forEachEffect */ .jF(f)),
    children: self.children,
    inheritAll: self.inheritAll,
    poll: _core_js__WEBPACK_IMPORTED_MODULE_7__/* .flatMap */ .VSD(self.poll, result => {
      switch (result._tag) {
        case "None":
          return _core_js__WEBPACK_IMPORTED_MODULE_7__/* .succeed */ .ng0(_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .none */ .YP());
        case "Some":
          return (0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(_Exit_js__WEBPACK_IMPORTED_MODULE_9__/* .forEachEffect */ .jF(result.value, f), _core_js__WEBPACK_IMPORTED_MODULE_7__/* .map */ .UID(_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .some */ .G));
      }
    }),
    interruptAsFork: id => self.interruptAsFork(id)
  };
  return _fiber;
});
/** @internal */
const mapFiber = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, f) => _core_js__WEBPACK_IMPORTED_MODULE_7__/* .map */ .UID(self.await, _Exit_js__WEBPACK_IMPORTED_MODULE_9__/* .match */ .EQ({
  onFailure: cause => failCause(cause),
  onSuccess: a => f(a)
})));
/** @internal */
const match = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, {
  onFiber,
  onRuntimeFiber
}) => {
  if (isRuntimeFiber(self)) {
    return onRuntimeFiber(self);
  }
  return onFiber(self);
});
/** @internal */
const _never = {
  ..._effectable_js__WEBPACK_IMPORTED_MODULE_5__/* .CommitPrototype */ .ku,
  commit() {
    return join(this);
  },
  ...fiberProto,
  id: () => _FiberId_js__WEBPACK_IMPORTED_MODULE_6__/* .none */ .YP,
  await: _core_js__WEBPACK_IMPORTED_MODULE_7__/* .never */ .FiN,
  children: /*#__PURE__*/_core_js__WEBPACK_IMPORTED_MODULE_7__/* .succeed */ .ng0([]),
  inheritAll: _core_js__WEBPACK_IMPORTED_MODULE_7__/* .never */ .FiN,
  poll: /*#__PURE__*/_core_js__WEBPACK_IMPORTED_MODULE_7__/* .succeed */ .ng0( /*#__PURE__*/_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .none */ .YP()),
  interruptAsFork: () => _core_js__WEBPACK_IMPORTED_MODULE_7__/* .never */ .FiN
};
/** @internal */
const never = _never;
/** @internal */
const orElse = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, that) => ({
  ..._effectable_js__WEBPACK_IMPORTED_MODULE_5__/* .CommitPrototype */ .ku,
  commit() {
    return join(this);
  },
  ...fiberProto,
  id: () => _FiberId_js__WEBPACK_IMPORTED_MODULE_6__/* .getOrElse */ .fS(self.id(), that.id()),
  await: _core_js__WEBPACK_IMPORTED_MODULE_7__/* .zipWith */ .yL_(self.await, that.await, (exit1, exit2) => _Exit_js__WEBPACK_IMPORTED_MODULE_9__/* .isSuccess */ .d6(exit1) ? exit1 : exit2),
  children: self.children,
  inheritAll: _core_js__WEBPACK_IMPORTED_MODULE_7__/* .zipRight */ .qs5(that.inheritAll, self.inheritAll),
  poll: _core_js__WEBPACK_IMPORTED_MODULE_7__/* .zipWith */ .yL_(self.poll, that.poll, (option1, option2) => {
    switch (option1._tag) {
      case "None":
        {
          return _Option_js__WEBPACK_IMPORTED_MODULE_8__/* .none */ .YP();
        }
      case "Some":
        {
          return _Exit_js__WEBPACK_IMPORTED_MODULE_9__/* .isSuccess */ .d6(option1.value) ? option1 : option2;
        }
    }
  }),
  interruptAsFork: id => (0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(_core_js__WEBPACK_IMPORTED_MODULE_7__/* .interruptAsFiber */ .zU1(self, id), _core_js__WEBPACK_IMPORTED_MODULE_7__/* .zipRight */ .qs5((0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .pipe */ .zG)(that, _core_js__WEBPACK_IMPORTED_MODULE_7__/* .interruptAsFiber */ .zU1(id))), _core_js__WEBPACK_IMPORTED_MODULE_7__/* .asVoid */ .a2S)
}));
/** @internal */
const orElseEither = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_1__/* .dual */ .OB)(2, (self, that) => orElse(map(self, _Either_js__WEBPACK_IMPORTED_MODULE_10__/* .left */ .t$), map(that, _Either_js__WEBPACK_IMPORTED_MODULE_10__/* .right */ .F2)));
/** @internal */
const poll = self => self.poll;
// forked from https://github.com/sindresorhus/parse-ms/blob/4da2ffbdba02c6e288c08236695bdece0adca173/index.js
// MIT License
// Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)
/** @internal */
const parseMs = milliseconds => {
  const roundTowardsZero = milliseconds > 0 ? Math.floor : Math.ceil;
  return {
    days: roundTowardsZero(milliseconds / 86400000),
    hours: roundTowardsZero(milliseconds / 3600000) % 24,
    minutes: roundTowardsZero(milliseconds / 60000) % 60,
    seconds: roundTowardsZero(milliseconds / 1000) % 60,
    milliseconds: roundTowardsZero(milliseconds) % 1000,
    microseconds: roundTowardsZero(milliseconds * 1000) % 1000,
    nanoseconds: roundTowardsZero(milliseconds * 1e6) % 1000
  };
};
/** @internal */
const renderStatus = status => {
  if (_FiberStatus_js__WEBPACK_IMPORTED_MODULE_11__/* .isDone */ ._b(status)) {
    return "Done";
  }
  if (_FiberStatus_js__WEBPACK_IMPORTED_MODULE_11__/* .isRunning */ .An(status)) {
    return "Running";
  }
  const isInterruptible = _runtimeFlags_js__WEBPACK_IMPORTED_MODULE_12__/* .interruptible */ .um(status.runtimeFlags) ? "interruptible" : "uninterruptible";
  return `Suspended(${isInterruptible})`;
};
/** @internal */
const pretty = self => _core_js__WEBPACK_IMPORTED_MODULE_7__/* .flatMap */ .VSD(_Clock_js__WEBPACK_IMPORTED_MODULE_13__/* .currentTimeMillis */ .b4, now => _core_js__WEBPACK_IMPORTED_MODULE_7__/* .map */ .UID(dump(self), dump => {
  const time = now - dump.id.startTimeMillis;
  const {
    days,
    hours,
    milliseconds,
    minutes,
    seconds
  } = parseMs(time);
  const lifeMsg = (days === 0 ? "" : `${days}d`) + (days === 0 && hours === 0 ? "" : `${hours}h`) + (days === 0 && hours === 0 && minutes === 0 ? "" : `${minutes}m`) + (days === 0 && hours === 0 && minutes === 0 && seconds === 0 ? "" : `${seconds}s`) + `${milliseconds}ms`;
  const waitMsg = _FiberStatus_js__WEBPACK_IMPORTED_MODULE_11__/* .isSuspended */ .sy(dump.status) ? (() => {
    const ids = _FiberId_js__WEBPACK_IMPORTED_MODULE_6__/* .ids */ .r$(dump.status.blockingOn);
    return _HashSet_js__WEBPACK_IMPORTED_MODULE_14__/* .size */ .dp(ids) > 0 ? `waiting on ` + Array.from(ids).map(id => `${id}`).join(", ") : "";
  })() : "";
  const statusMsg = renderStatus(dump.status);
  return `[Fiber](#${dump.id.id}) (${lifeMsg}) ${waitMsg}\n   Status: ${statusMsg}`;
}));
/** @internal */
const unsafeRoots = () => Array.from(_fiberScope_js__WEBPACK_IMPORTED_MODULE_15__/* .globalScope.roots */ ._A.roots);
/** @internal */
const roots = /*#__PURE__*/_core_js__WEBPACK_IMPORTED_MODULE_7__/* .sync */ .Z_X(unsafeRoots);
/** @internal */
const status = self => self.status;
/** @internal */
const succeed = value => done(_Exit_js__WEBPACK_IMPORTED_MODULE_9__/* .succeed */ .ng(value));
const void_ = /*#__PURE__*/succeed(void 0);

/** @internal */
const currentFiberURI = "effect/FiberCurrent";
/** @internal */
const getCurrentFiber = () => _Option_js__WEBPACK_IMPORTED_MODULE_8__/* .fromNullable */ .ij(globalThis[currentFiberURI]);
//# sourceMappingURL=fiber.js.map

/***/ }),

/***/ 26219:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "Er": function() { return /* binding */ toOption; },
/* harmony export */   "GZ": function() { return /* binding */ runtime; },
/* harmony export */   "Q9": function() { return /* binding */ threadName; },
/* harmony export */   "Rg": function() { return /* binding */ toSet; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "Wi": function() { return /* binding */ isNone; },
/* harmony export */   "X9": function() { return /* binding */ isRuntime; },
/* harmony export */   "YP": function() { return /* binding */ none; },
/* harmony export */   "aC": function() { return /* binding */ FiberIdTypeId; },
/* harmony export */   "c3": function() { return /* binding */ combineAll; },
/* harmony export */   "ez": function() { return /* binding */ isFiberId; },
/* harmony export */   "fS": function() { return /* binding */ getOrElse; },
/* harmony export */   "h$": function() { return /* binding */ composite; },
/* harmony export */   "k2": function() { return /* binding */ isComposite; },
/* harmony export */   "r$": function() { return /* binding */ ids; },
/* harmony export */   "t0": function() { return /* binding */ unsafeMake; }
/* harmony export */ });
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17316);
/* harmony import */ var _GlobalValue_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4726);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89379);
/* harmony import */ var _HashSet_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9551);
/* harmony import */ var _Inspectable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16371);
/* harmony import */ var _MutableRef_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23182);
/* harmony import */ var _Option_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16749);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71335);









/** @internal */
const FiberIdSymbolKey = "effect/FiberId";
/** @internal */
const FiberIdTypeId = /*#__PURE__*/Symbol.for(FiberIdSymbolKey);
/** @internal */
const OP_NONE = "None";
/** @internal */
const OP_RUNTIME = "Runtime";
/** @internal */
const OP_COMPOSITE = "Composite";
const emptyHash = /*#__PURE__*/_Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(`${FiberIdSymbolKey}-${OP_NONE}`);
/** @internal */
class None {
  [FiberIdTypeId] = FiberIdTypeId;
  _tag = OP_NONE;
  id = -1;
  startTimeMillis = -1;
  [_Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .symbol */ .NA]() {
    return emptyHash;
  }
  [_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .symbol */ .NA](that) {
    return isFiberId(that) && that._tag === OP_NONE;
  }
  toString() {
    return (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_2__/* .format */ .WU)(this.toJSON());
  }
  toJSON() {
    return {
      _id: "FiberId",
      _tag: this._tag
    };
  }
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_2__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  }
}
/** @internal */
class Runtime {
  id;
  startTimeMillis;
  [FiberIdTypeId] = FiberIdTypeId;
  _tag = OP_RUNTIME;
  constructor(id, startTimeMillis) {
    this.id = id;
    this.startTimeMillis = startTimeMillis;
  }
  [_Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .symbol */ .NA]() {
    return _Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .cached */ .HX(this, _Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(`${FiberIdSymbolKey}-${this._tag}-${this.id}-${this.startTimeMillis}`));
  }
  [_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .symbol */ .NA](that) {
    return isFiberId(that) && that._tag === OP_RUNTIME && this.id === that.id && this.startTimeMillis === that.startTimeMillis;
  }
  toString() {
    return (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_2__/* .format */ .WU)(this.toJSON());
  }
  toJSON() {
    return {
      _id: "FiberId",
      _tag: this._tag,
      id: this.id,
      startTimeMillis: this.startTimeMillis
    };
  }
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_2__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  }
}
/** @internal */
class Composite {
  left;
  right;
  [FiberIdTypeId] = FiberIdTypeId;
  _tag = OP_COMPOSITE;
  constructor(left, right) {
    this.left = left;
    this.right = right;
  }
  _hash;
  [_Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .symbol */ .NA]() {
    return (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(_Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(`${FiberIdSymbolKey}-${this._tag}`), _Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .combine */ .$e(_Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .hash */ .vp(this.left)), _Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .combine */ .$e(_Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .hash */ .vp(this.right)), _Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .cached */ .HX(this));
  }
  [_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .symbol */ .NA](that) {
    return isFiberId(that) && that._tag === OP_COMPOSITE && _Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS(this.left, that.left) && _Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS(this.right, that.right);
  }
  toString() {
    return (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_2__/* .format */ .WU)(this.toJSON());
  }
  toJSON() {
    return {
      _id: "FiberId",
      _tag: this._tag,
      left: (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_2__/* .toJSON */ .au)(this.left),
      right: (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_2__/* .toJSON */ .au)(this.right)
    };
  }
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_2__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  }
}
/** @internal */
const none = /*#__PURE__*/new None();
/** @internal */
const runtime = (id, startTimeMillis) => {
  return new Runtime(id, startTimeMillis);
};
/** @internal */
const composite = (left, right) => {
  return new Composite(left, right);
};
/** @internal */
const isFiberId = self => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_4__/* .hasProperty */ .l$)(self, FiberIdTypeId);
/** @internal */
const isNone = self => {
  return self._tag === OP_NONE || (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(toSet(self), _HashSet_js__WEBPACK_IMPORTED_MODULE_5__/* .every */ .yW(id => isNone(id)));
};
/** @internal */
const isRuntime = self => {
  return self._tag === OP_RUNTIME;
};
/** @internal */
const isComposite = self => {
  return self._tag === OP_COMPOSITE;
};
/** @internal */
const combine = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .dual */ .OB)(2, (self, that) => {
  if (self._tag === OP_NONE) {
    return that;
  }
  if (that._tag === OP_NONE) {
    return self;
  }
  return new Composite(self, that);
});
/** @internal */
const combineAll = fiberIds => {
  return (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(fiberIds, _HashSet_js__WEBPACK_IMPORTED_MODULE_5__/* .reduce */ .u4(none, (a, b) => combine(b)(a)));
};
/** @internal */
const getOrElse = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .dual */ .OB)(2, (self, that) => isNone(self) ? that : self);
/** @internal */
const ids = self => {
  switch (self._tag) {
    case OP_NONE:
      {
        return _HashSet_js__WEBPACK_IMPORTED_MODULE_5__/* .empty */ .cS();
      }
    case OP_RUNTIME:
      {
        return _HashSet_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .Sy(self.id);
      }
    case OP_COMPOSITE:
      {
        return (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(ids(self.left), _HashSet_js__WEBPACK_IMPORTED_MODULE_5__/* .union */ .G0(ids(self.right)));
      }
  }
};
const _fiberCounter = /*#__PURE__*/(0,_GlobalValue_js__WEBPACK_IMPORTED_MODULE_6__/* .globalValue */ .K)( /*#__PURE__*/Symbol.for("effect/Fiber/Id/_fiberCounter"), () => _MutableRef_js__WEBPACK_IMPORTED_MODULE_7__/* .make */ .Sy(0));
/** @internal */
const make = (id, startTimeSeconds) => {
  return new Runtime(id, startTimeSeconds);
};
/** @internal */
const threadName = self => {
  const identifiers = Array.from(ids(self)).map(n => `#${n}`).join(",");
  return identifiers;
};
/** @internal */
const toOption = self => {
  const fiberIds = toSet(self);
  if (_HashSet_js__WEBPACK_IMPORTED_MODULE_5__/* .size */ .dp(fiberIds) === 0) {
    return _Option_js__WEBPACK_IMPORTED_MODULE_8__/* .none */ .YP();
  }
  let first = true;
  let acc;
  for (const fiberId of fiberIds) {
    if (first) {
      acc = fiberId;
      first = false;
    } else {
      // @ts-expect-error
      acc = (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(acc, combine(fiberId));
    }
  }
  // @ts-expect-error
  return _Option_js__WEBPACK_IMPORTED_MODULE_8__/* .some */ .G(acc);
};
/** @internal */
const toSet = self => {
  switch (self._tag) {
    case OP_NONE:
      {
        return _HashSet_js__WEBPACK_IMPORTED_MODULE_5__/* .empty */ .cS();
      }
    case OP_RUNTIME:
      {
        return _HashSet_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .Sy(self);
      }
    case OP_COMPOSITE:
      {
        return (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(toSet(self.left), _HashSet_js__WEBPACK_IMPORTED_MODULE_5__/* .union */ .G0(toSet(self.right)));
      }
  }
};
/** @internal */
const unsafeMake = () => {
  const id = _MutableRef_js__WEBPACK_IMPORTED_MODULE_7__/* .get */ .U2(_fiberCounter);
  (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(_fiberCounter, _MutableRef_js__WEBPACK_IMPORTED_MODULE_7__/* .set */ .t8(id + 1));
  return new Runtime(id, Date.now());
};
//# sourceMappingURL=fiberId.js.map

/***/ }),

/***/ 48282:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": function() { return /* binding */ OP_RESUME; },
/* harmony export */   "Df": function() { return /* binding */ OP_YIELD_NOW; },
/* harmony export */   "T4": function() { return /* binding */ yieldNow; },
/* harmony export */   "dQ": function() { return /* binding */ stateful; },
/* harmony export */   "fk": function() { return /* binding */ interruptSignal; },
/* harmony export */   "kp": function() { return /* binding */ OP_STATEFUL; },
/* harmony export */   "ng": function() { return /* binding */ OP_INTERRUPT_SIGNAL; },
/* harmony export */   "v4": function() { return /* binding */ resume; }
/* harmony export */ });
/** @internal */
const OP_INTERRUPT_SIGNAL = "InterruptSignal";
/** @internal */
const OP_STATEFUL = "Stateful";
/** @internal */
const OP_RESUME = "Resume";
/** @internal */
const OP_YIELD_NOW = "YieldNow";
/** @internal */
const interruptSignal = cause => ({
  _tag: OP_INTERRUPT_SIGNAL,
  cause
});
/** @internal */
const stateful = onFiber => ({
  _tag: OP_STATEFUL,
  onFiber
});
/** @internal */
const resume = effect => ({
  _tag: OP_RESUME,
  effect
});
/** @internal */
const yieldNow = () => ({
  _tag: OP_YIELD_NOW
});
//# sourceMappingURL=fiberMessage.js.map

/***/ }),

/***/ 79049:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$v": function() { return /* binding */ delete_; },
/* harmony export */   "$x": function() { return /* binding */ fiberRefs; },
/* harmony export */   "Ao": function() { return /* binding */ joinAs; },
/* harmony export */   "Bi": function() { return /* binding */ setAll; },
/* harmony export */   "CJ": function() { return /* binding */ getOrDefault; },
/* harmony export */   "SJ": function() { return /* binding */ updateAs; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "iH": function() { return /* binding */ FiberRefsSym; },
/* harmony export */   "iW": function() { return /* binding */ updateManyAs; },
/* harmony export */   "t0": function() { return /* binding */ unsafeMake; },
/* harmony export */   "xN": function() { return /* binding */ forkAs; }
/* harmony export */ });
/* unused harmony export FiberRefsImpl */
/* harmony import */ var _Array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37901);
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17316);
/* harmony import */ var _HashSet_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9551);
/* harmony import */ var _Option_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16749);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92817);
/* harmony import */ var _core_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39355);







/** @internal */
function unsafeMake(fiberRefLocals) {
  return new FiberRefsImpl(fiberRefLocals);
}
/** @internal */
function empty() {
  return unsafeMake(new Map());
}
/** @internal */
const FiberRefsSym = /*#__PURE__*/Symbol.for("effect/FiberRefs");
/** @internal */
class FiberRefsImpl {
  locals;
  [FiberRefsSym] = FiberRefsSym;
  constructor(locals) {
    this.locals = locals;
  }
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_0__/* .pipeArguments */ .n)(this, arguments);
  }
}
/** @internal */
const findAncestor = (_ref, _parentStack, _childStack, _childModified = false) => {
  const ref = _ref;
  let parentStack = _parentStack;
  let childStack = _childStack;
  let childModified = _childModified;
  let ret = undefined;
  while (ret === undefined) {
    if (_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonEmptyReadonlyArray */ .Ux(parentStack) && _Array_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonEmptyReadonlyArray */ .Ux(childStack)) {
      const parentFiberId = _Array_js__WEBPACK_IMPORTED_MODULE_1__/* .headNonEmpty */ .dK(parentStack)[0];
      const parentAncestors = _Array_js__WEBPACK_IMPORTED_MODULE_1__/* .tailNonEmpty */ .fm(parentStack);
      const childFiberId = _Array_js__WEBPACK_IMPORTED_MODULE_1__/* .headNonEmpty */ .dK(childStack)[0];
      const childRefValue = _Array_js__WEBPACK_IMPORTED_MODULE_1__/* .headNonEmpty */ .dK(childStack)[1];
      const childAncestors = _Array_js__WEBPACK_IMPORTED_MODULE_1__/* .tailNonEmpty */ .fm(childStack);
      if (parentFiberId.startTimeMillis < childFiberId.startTimeMillis) {
        childStack = childAncestors;
        childModified = true;
      } else if (parentFiberId.startTimeMillis > childFiberId.startTimeMillis) {
        parentStack = parentAncestors;
      } else {
        if (parentFiberId.id < childFiberId.id) {
          childStack = childAncestors;
          childModified = true;
        } else if (parentFiberId.id > childFiberId.id) {
          parentStack = parentAncestors;
        } else {
          ret = [childRefValue, childModified];
        }
      }
    } else {
      ret = [ref.initial, true];
    }
  }
  return ret;
};
/** @internal */
const joinAs = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(3, (self, fiberId, that) => {
  const parentFiberRefs = new Map(self.locals);
  that.locals.forEach((childStack, fiberRef) => {
    const childValue = childStack[0][1];
    if (!childStack[0][0][_Equal_js__WEBPACK_IMPORTED_MODULE_3__/* .symbol */ .NA](fiberId)) {
      if (!parentFiberRefs.has(fiberRef)) {
        if (_Equal_js__WEBPACK_IMPORTED_MODULE_3__/* .equals */ .fS(childValue, fiberRef.initial)) {
          return;
        }
        parentFiberRefs.set(fiberRef, [[fiberId, fiberRef.join(fiberRef.initial, childValue)]]);
        return;
      }
      const parentStack = parentFiberRefs.get(fiberRef);
      const [ancestor, wasModified] = findAncestor(fiberRef, parentStack, childStack);
      if (wasModified) {
        const patch = fiberRef.diff(ancestor, childValue);
        const oldValue = parentStack[0][1];
        const newValue = fiberRef.join(oldValue, fiberRef.patch(patch)(oldValue));
        if (!_Equal_js__WEBPACK_IMPORTED_MODULE_3__/* .equals */ .fS(oldValue, newValue)) {
          let newStack;
          const parentFiberId = parentStack[0][0];
          if (parentFiberId[_Equal_js__WEBPACK_IMPORTED_MODULE_3__/* .symbol */ .NA](fiberId)) {
            newStack = [[parentFiberId, newValue], ...parentStack.slice(1)];
          } else {
            newStack = [[fiberId, newValue], ...parentStack];
          }
          parentFiberRefs.set(fiberRef, newStack);
        }
      }
    }
  });
  return new FiberRefsImpl(parentFiberRefs);
});
/** @internal */
const forkAs = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, childId) => {
  const map = new Map();
  unsafeForkAs(self, map, childId);
  return new FiberRefsImpl(map);
});
const unsafeForkAs = (self, map, fiberId) => {
  self.locals.forEach((stack, fiberRef) => {
    const oldValue = stack[0][1];
    const newValue = fiberRef.patch(fiberRef.fork)(oldValue);
    if (_Equal_js__WEBPACK_IMPORTED_MODULE_3__/* .equals */ .fS(oldValue, newValue)) {
      map.set(fiberRef, stack);
    } else {
      map.set(fiberRef, [[fiberId, newValue], ...stack]);
    }
  });
};
/** @internal */
const fiberRefs = self => _HashSet_js__WEBPACK_IMPORTED_MODULE_4__/* .fromIterable */ .EE(self.locals.keys());
/** @internal */
const setAll = self => _core_js__WEBPACK_IMPORTED_MODULE_5__/* .forEachSequentialDiscard */ .EaP(fiberRefs(self), fiberRef => _core_js__WEBPACK_IMPORTED_MODULE_5__/* .fiberRefSet */ .eqx(fiberRef, getOrDefault(self, fiberRef)));
/** @internal */
const delete_ = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, fiberRef) => {
  const locals = new Map(self.locals);
  locals.delete(fiberRef);
  return new FiberRefsImpl(locals);
});
/** @internal */
const get = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, fiberRef) => {
  if (!self.locals.has(fiberRef)) {
    return _Option_js__WEBPACK_IMPORTED_MODULE_6__/* .none */ .YP();
  }
  return _Option_js__WEBPACK_IMPORTED_MODULE_6__/* .some */ .G(_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .headNonEmpty */ .dK(self.locals.get(fiberRef))[1]);
});
/** @internal */
const getOrDefault = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, fiberRef) => (0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .pipe */ .zG)(get(self, fiberRef), _Option_js__WEBPACK_IMPORTED_MODULE_6__/* .getOrElse */ .fS(() => fiberRef.initial)));
/** @internal */
const updateAs = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, {
  fiberId,
  fiberRef,
  value
}) => {
  if (self.locals.size === 0) {
    return new FiberRefsImpl(new Map([[fiberRef, [[fiberId, value]]]]));
  }
  const locals = new Map(self.locals);
  unsafeUpdateAs(locals, fiberId, fiberRef, value);
  return new FiberRefsImpl(locals);
});
const unsafeUpdateAs = (locals, fiberId, fiberRef, value) => {
  const oldStack = locals.get(fiberRef) ?? [];
  let newStack;
  if (_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonEmptyReadonlyArray */ .Ux(oldStack)) {
    const [currentId, currentValue] = _Array_js__WEBPACK_IMPORTED_MODULE_1__/* .headNonEmpty */ .dK(oldStack);
    if (currentId[_Equal_js__WEBPACK_IMPORTED_MODULE_3__/* .symbol */ .NA](fiberId)) {
      if (_Equal_js__WEBPACK_IMPORTED_MODULE_3__/* .equals */ .fS(currentValue, value)) {
        return;
      } else {
        newStack = [[fiberId, value], ...oldStack.slice(1)];
      }
    } else {
      newStack = [[fiberId, value], ...oldStack];
    }
  } else {
    newStack = [[fiberId, value]];
  }
  locals.set(fiberRef, newStack);
};
/** @internal */
const updateManyAs = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, {
  entries,
  forkAs
}) => {
  if (self.locals.size === 0) {
    return new FiberRefsImpl(new Map(entries));
  }
  const locals = new Map(self.locals);
  if (forkAs !== undefined) {
    unsafeForkAs(self, locals, forkAs);
  }
  entries.forEach(([fiberRef, values]) => {
    if (values.length === 1) {
      unsafeUpdateAs(locals, values[0][0], fiberRef, values[0][1]);
    } else {
      values.forEach(([fiberId, value]) => {
        unsafeUpdateAs(locals, fiberId, fiberRef, value);
      });
    }
  });
  return new FiberRefsImpl(locals);
});
//# sourceMappingURL=fiberRefs.js.map

/***/ }),

/***/ 2108:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "Hg": function() { return /* binding */ diff; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "r$": function() { return /* binding */ patch; }
/* harmony export */ });
/* unused harmony exports OP_EMPTY, OP_ADD, OP_REMOVE, OP_UPDATE, OP_AND_THEN */
/* harmony import */ var _Array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37901);
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17316);
/* harmony import */ var _fiberRefs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79049);




/** @internal */
const OP_EMPTY = "Empty";
/** @internal */
const OP_ADD = "Add";
/** @internal */
const OP_REMOVE = "Remove";
/** @internal */
const OP_UPDATE = "Update";
/** @internal */
const OP_AND_THEN = "AndThen";
/** @internal */
const empty = {
  _tag: OP_EMPTY
};
/** @internal */
const diff = (oldValue, newValue) => {
  const missingLocals = new Map(oldValue.locals);
  let patch = empty;
  for (const [fiberRef, pairs] of newValue.locals.entries()) {
    const newValue = _Array_js__WEBPACK_IMPORTED_MODULE_0__/* .headNonEmpty */ .dK(pairs)[1];
    const old = missingLocals.get(fiberRef);
    if (old !== undefined) {
      const oldValue = _Array_js__WEBPACK_IMPORTED_MODULE_0__/* .headNonEmpty */ .dK(old)[1];
      if (!(0,_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS)(oldValue, newValue)) {
        patch = combine({
          _tag: OP_UPDATE,
          fiberRef,
          patch: fiberRef.diff(oldValue, newValue)
        })(patch);
      }
    } else {
      patch = combine({
        _tag: OP_ADD,
        fiberRef,
        value: newValue
      })(patch);
    }
    missingLocals.delete(fiberRef);
  }
  for (const [fiberRef] of missingLocals.entries()) {
    patch = combine({
      _tag: OP_REMOVE,
      fiberRef
    })(patch);
  }
  return patch;
};
/** @internal */
const combine = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, that) => ({
  _tag: OP_AND_THEN,
  first: self,
  second: that
}));
/** @internal */
const patch = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(3, (self, fiberId, oldValue) => {
  let fiberRefs = oldValue;
  let patches = _Array_js__WEBPACK_IMPORTED_MODULE_0__.of(self);
  while (_Array_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonEmptyReadonlyArray */ .Ux(patches)) {
    const head = _Array_js__WEBPACK_IMPORTED_MODULE_0__/* .headNonEmpty */ .dK(patches);
    const tail = _Array_js__WEBPACK_IMPORTED_MODULE_0__/* .tailNonEmpty */ .fm(patches);
    switch (head._tag) {
      case OP_EMPTY:
        {
          patches = tail;
          break;
        }
      case OP_ADD:
        {
          fiberRefs = _fiberRefs_js__WEBPACK_IMPORTED_MODULE_3__/* .updateAs */ .SJ(fiberRefs, {
            fiberId,
            fiberRef: head.fiberRef,
            value: head.value
          });
          patches = tail;
          break;
        }
      case OP_REMOVE:
        {
          fiberRefs = _fiberRefs_js__WEBPACK_IMPORTED_MODULE_3__/* .delete_ */ .$v(fiberRefs, head.fiberRef);
          patches = tail;
          break;
        }
      case OP_UPDATE:
        {
          const value = _fiberRefs_js__WEBPACK_IMPORTED_MODULE_3__/* .getOrDefault */ .CJ(fiberRefs, head.fiberRef);
          fiberRefs = _fiberRefs_js__WEBPACK_IMPORTED_MODULE_3__/* .updateAs */ .SJ(fiberRefs, {
            fiberId,
            fiberRef: head.fiberRef,
            value: head.fiberRef.patch(head.patch)(value)
          });
          patches = tail;
          break;
        }
      case OP_AND_THEN:
        {
          patches = _Array_js__WEBPACK_IMPORTED_MODULE_0__/* .prepend */ .Ce(head.first)(_Array_js__WEBPACK_IMPORTED_MODULE_0__/* .prepend */ .Ce(head.second)(tail));
          break;
        }
    }
  }
  return fiberRefs;
});
//# sourceMappingURL=patch.js.map

/***/ }),

/***/ 90886:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ou": function() { return /* binding */ FiberRuntime; },
  "S8": function() { return /* binding */ fiberRuntime_acquireRelease; },
  "Ro": function() { return /* binding */ acquireReleaseInterruptible; },
  "yR": function() { return /* binding */ fiberRuntime_addFinalizer; },
  "$6": function() { return /* binding */ fiberRuntime_all; },
  "YI": function() { return /* binding */ allSuccesses; },
  "IZ": function() { return /* binding */ allWith; },
  "gA": function() { return /* binding */ annotateLogsScoped; },
  "o6": function() { return /* binding */ currentSupervisor; },
  "qi": function() { return /* binding */ daemonChildren; },
  "zP": function() { return /* binding */ disconnect; },
  "IH": function() { return /* binding */ fiberRuntime_ensuring; },
  "Gg": function() { return /* binding */ exists; },
  "kC": function() { return /* binding */ fiberAll; },
  "GR": function() { return /* binding */ fiberAwaitAll; },
  "QO": function() { return /* binding */ fiberInterruptFork; },
  "pM": function() { return /* binding */ fiberJoinAll; },
  "tX": function() { return /* binding */ fiberRefLocallyScoped; },
  "lS": function() { return /* binding */ fiberRefLocallyScopedWith; },
  "SI": function() { return /* binding */ fiberScoped; },
  "hX": function() { return /* binding */ fiberRuntime_filter; },
  "qm": function() { return /* binding */ finalizersMask; },
  "Ed": function() { return /* binding */ fiberRuntime_forEach; },
  "rM": function() { return /* binding */ fiberRuntime_fork; },
  "Zp": function() { return /* binding */ fiberRuntime_forkDaemon; },
  "lg": function() { return /* binding */ forkWithErrorHandler; },
  "hu": function() { return /* binding */ interruptWhenPossible; },
  "Ld": function() { return /* binding */ labelMetricsScoped; },
  "ey": function() { return /* binding */ makeSpanScoped; },
  "Jn": function() { return /* binding */ mergeAll; },
  "BE": function() { return /* binding */ parallelFinalizers; },
  "uK": function() { return /* binding */ partition; },
  "S3": function() { return /* binding */ fiberRuntime_race; },
  "xu": function() { return /* binding */ fiberRuntime_raceAll; },
  "q4": function() { return /* binding */ raceFibersWith; },
  "QQ": function() { return /* binding */ raceWith; },
  "rN": function() { return /* binding */ reduceEffect; },
  "AS": function() { return /* binding */ fiberRuntime_replicate; },
  "VT": function() { return /* binding */ fiberRuntime_replicateEffect; },
  "eI": function() { return /* binding */ fiberRuntime_scope; },
  "Vx": function() { return /* binding */ scopeExtend; },
  "RN": function() { return /* binding */ fiberRuntime_scopeMake; },
  "XX": function() { return /* binding */ scopeTag; },
  "y0": function() { return /* binding */ scopeUse; },
  "ZO": function() { return /* binding */ scopeWith; },
  "N1": function() { return /* binding */ scopedEffect; },
  "HK": function() { return /* binding */ scopedWith; },
  "r": function() { return /* binding */ sequentialFinalizers; },
  "en": function() { return /* binding */ tagMetricsScoped; },
  "hU": function() { return /* binding */ fiberRuntime_unsafeFork; },
  "gW": function() { return /* binding */ using; },
  "Gu": function() { return /* binding */ validate; },
  "Kf": function() { return /* binding */ validateAll; },
  "Kt": function() { return /* binding */ validateFirst; },
  "QV": function() { return /* binding */ validateWith; },
  "fH": function() { return /* binding */ whenLogLevel; },
  "Zx": function() { return /* binding */ withClockScoped; },
  "Yk": function() { return /* binding */ withConfigProviderScoped; },
  "KC": function() { return /* binding */ withEarlyRelease; },
  "vY": function() { return /* binding */ withRandomScoped; },
  "fn": function() { return /* binding */ withRuntimeFlagsScoped; },
  "$u": function() { return /* binding */ withSpanScoped; },
  "at": function() { return /* binding */ withTracerScoped; },
  "jr": function() { return /* binding */ zipLeftOptions; },
  "Jq": function() { return /* binding */ zipOptions; },
  "tv": function() { return /* binding */ zipRightOptions; },
  "xn": function() { return /* binding */ zipWithOptions; }
});

// UNUSED EXPORTS: batchedLogger, currentLoggers, currentMinimumLogLevel, currentRuntimeFlags, defaultLogger, fiberActive, fiberFailures, fiberLifetimes, fiberRefMake, fiberRefMakeContext, fiberRefMakeRuntimeFlags, fiberRefMakeWith, fiberRefUnsafeMakeSupervisor, fiberStarted, fiberSuccesses, finalizersMaskInternal, forEachConcurrentDiscard, forEachParN, forEachParUnbounded, invokeWithInterrupt, jsonLogger, logFmtLogger, loggerWithConsoleError, loggerWithConsoleLog, loggerWithLeveledLog, loggerWithSpanAnnotations, parallelNFinalizers, prettyLogger, structuredLogger, tracerLogger, unsafeForkUnstarted, unsafeMakeChildFiber, validateAllPar, validateAllParDiscard

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Array.js + 2 modules
var esm_Array = __webpack_require__(37901);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Boolean.js
var Boolean = __webpack_require__(49349);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Chunk.js
var esm_Chunk = __webpack_require__(14109);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Context.js
var esm_Context = __webpack_require__(20591);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Deferred.js
var Deferred = __webpack_require__(72022);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Effectable.js
var Effectable = __webpack_require__(34744);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/executionStrategy.js
var executionStrategy = __webpack_require__(49941);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/ExecutionStrategy.js

/**
 * Execute effects sequentially.
 *
 * @since 2.0.0
 * @category constructors
 */
const sequential = executionStrategy/* sequential */.Pe;
/**
 * Execute effects in parallel.
 *
 * @since 2.0.0
 * @category constructors
 */
const parallel = executionStrategy/* parallel */.Mf;
/**
 * Execute effects in parallel, up to the specified number of concurrent fibers.
 *
 * @since 2.0.0
 * @category constructors
 */
const parallelN = executionStrategy/* parallelN */.w7;
/**
 * Returns `true` if the specified `ExecutionStrategy` is an instance of
 * `Sequential`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isSequential = executionStrategy/* isSequential */.DS;
/**
 * Returns `true` if the specified `ExecutionStrategy` is an instance of
 * `Sequential`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isParallel = executionStrategy/* isParallel */.rN;
/**
 * Returns `true` if the specified `ExecutionStrategy` is an instance of
 * `Sequential`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isParallelN = executionStrategy/* isParallelN */.gM;
/**
 * Folds over the specified `ExecutionStrategy` using the provided case
 * functions.
 *
 * @since 2.0.0
 * @category folding
 */
const match = executionStrategy/* match */.EQ;
//# sourceMappingURL=ExecutionStrategy.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/FiberId.js
var FiberId = __webpack_require__(57303);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/FiberRefs.js
var esm_FiberRefs = __webpack_require__(6639);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/FiberRefsPatch.js
var FiberRefsPatch = __webpack_require__(58714);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/FiberStatus.js + 1 modules
var FiberStatus = __webpack_require__(32860);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/GlobalValue.js
var GlobalValue = __webpack_require__(4726);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/HashMap.js + 1 modules
var esm_HashMap = __webpack_require__(61952);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/HashSet.js
var HashSet = __webpack_require__(9551);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Inspectable.js
var esm_Inspectable = __webpack_require__(16371);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/LogLevel.js
var LogLevel = __webpack_require__(69783);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equal.js
var esm_Equal = __webpack_require__(67492);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Hash.js
var esm_Hash = __webpack_require__(89379);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/context.js
var context = __webpack_require__(40197);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Pipeable.js
var Pipeable = __webpack_require__(92817);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var Predicate = __webpack_require__(71335);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Utils.js
var Utils = __webpack_require__(70762);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/Micro.js
/**
 * A lightweight alternative to the `Effect` data type, with a subset of the functionality.
 *
 * @since 3.4.0
 * @experimental
 */
















/**
 * @since 3.4.0
 * @experimental
 * @category type ids
 */
const TypeId = /*#__PURE__*/Symbol.for("effect/Micro");
/**
 * @since 3.4.0
 * @experimental
 * @category MicroExit
 */
const MicroExitTypeId = /*#__PURE__*/Symbol.for("effect/Micro/MicroExit");
/**
 * @since 3.4.0
 * @experimental
 * @category guards
 */
const isMicro = u => typeof u === "object" && u !== null && TypeId in u;
// ----------------------------------------------------------------------------
// MicroCause
// ----------------------------------------------------------------------------
/**
 * @since 3.4.6
 * @experimental
 * @category MicroCause
 */
const MicroCauseTypeId = /*#__PURE__*/Symbol.for("effect/Micro/MicroCause");
/**
 * @since 3.6.6
 * @experimental
 * @category guards
 */
const isMicroCause = self => hasProperty(self, MicroCauseTypeId);
const microCauseVariance = {
  _E: Function/* identity */.yR
};
class MicroCauseImpl extends globalThis.Error {
  _tag;
  traces;
  [MicroCauseTypeId];
  constructor(_tag, originalError, traces) {
    const causeName = `MicroCause.${_tag}`;
    let name;
    let message;
    let stack;
    if (originalError instanceof globalThis.Error) {
      name = `(${causeName}) ${originalError.name}`;
      message = originalError.message;
      const messageLines = message.split("\n").length;
      stack = originalError.stack ? `(${causeName}) ${originalError.stack.split("\n").slice(0, messageLines + 3).join("\n")}` : `${name}: ${message}`;
    } else {
      name = causeName;
      message = (0,esm_Inspectable/* toStringUnknown */.OY)(originalError, 0);
      stack = `${name}: ${message}`;
    }
    if (traces.length > 0) {
      stack += `\n    ${traces.join("\n    ")}`;
    }
    super(message);
    this._tag = _tag;
    this.traces = traces;
    this[MicroCauseTypeId] = microCauseVariance;
    this.name = name;
    this.stack = stack;
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
  toString() {
    return this.stack;
  }
  [esm_Inspectable/* NodeInspectSymbol */.j5]() {
    return this.stack;
  }
}
class Fail extends (/* unused pure expression or super */ null && (MicroCauseImpl)) {
  error;
  constructor(error, traces = []) {
    super("Fail", error, traces);
    this.error = error;
  }
}
/**
 * @since 3.4.6
 * @experimental
 * @category MicroCause
 */
const causeFail = (error, traces = []) => new Fail(error, traces);
class Die extends MicroCauseImpl {
  defect;
  constructor(defect, traces = []) {
    super("Die", defect, traces);
    this.defect = defect;
  }
}
/**
 * @since 3.4.6
 * @experimental
 * @category MicroCause
 */
const causeDie = (defect, traces = []) => new Die(defect, traces);
class Interrupt extends MicroCauseImpl {
  constructor(traces = []) {
    super("Interrupt", "interrupted", traces);
  }
}
/**
 * @since 3.4.6
 * @experimental
 * @category MicroCause
 */
const causeInterrupt = (traces = []) => new Interrupt(traces);
/**
 * @since 3.4.6
 * @experimental
 * @category MicroCause
 */
const causeIsFail = self => self._tag === "Fail";
/**
 * @since 3.4.6
 * @experimental
 * @category MicroCause
 */
const causeIsDie = self => self._tag === "Die";
/**
 * @since 3.4.6
 * @experimental
 * @category MicroCause
 */
const causeIsInterrupt = self => self._tag === "Interrupt";
/**
 * @since 3.4.6
 * @experimental
 * @category MicroCause
 */
const causeSquash = self => self._tag === "Fail" ? self.error : self._tag === "Die" ? self.defect : self;
/**
 * @since 3.4.6
 * @experimental
 * @category MicroCause
 */
const causeWithTrace = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, trace) => {
  const traces = [...self.traces, trace];
  switch (self._tag) {
    case "Die":
      return causeDie(self.defect, traces);
    case "Interrupt":
      return causeInterrupt(traces);
    case "Fail":
      return causeFail(self.error, traces);
  }
})));
// ----------------------------------------------------------------------------
// MicroFiber
// ----------------------------------------------------------------------------
/**
 * @since 3.11.0
 * @experimental
 * @category MicroFiber
 */
const MicroFiberTypeId = /*#__PURE__*/Symbol.for("effect/Micro/MicroFiber");
const fiberVariance = {
  _A: Function/* identity */.yR,
  _E: Function/* identity */.yR
};
class MicroFiberImpl {
  context;
  interruptible;
  [MicroFiberTypeId];
  _stack = [];
  _observers = [];
  _exit;
  _children;
  currentOpCount = 0;
  constructor(context, interruptible = true) {
    this.context = context;
    this.interruptible = interruptible;
    this[MicroFiberTypeId] = fiberVariance;
  }
  getRef(ref) {
    return context/* unsafeGetReference */.Gh(this.context, ref);
  }
  addObserver(cb) {
    if (this._exit) {
      cb(this._exit);
      return Function/* constVoid */.Q1;
    }
    this._observers.push(cb);
    return () => {
      const index = this._observers.indexOf(cb);
      if (index >= 0) {
        this._observers.splice(index, 1);
      }
    };
  }
  _interrupted = false;
  unsafeInterrupt() {
    if (this._exit) {
      return;
    }
    this._interrupted = true;
    if (this.interruptible) {
      this.evaluate(exitInterrupt);
    }
  }
  unsafePoll() {
    return this._exit;
  }
  evaluate(effect) {
    if (this._exit) {
      return;
    } else if (this._yielded !== undefined) {
      const yielded = this._yielded;
      this._yielded = undefined;
      yielded();
    }
    const exit = this.runLoop(effect);
    if (exit === Yield) {
      return;
    }
    // the interruptChildren middlware is added in Micro.fork, so it can be
    // tree-shaken if not used
    const interruptChildren = fiberMiddleware.interruptChildren && fiberMiddleware.interruptChildren(this);
    if (interruptChildren !== undefined) {
      return this.evaluate(flatMap(interruptChildren, () => exit));
    }
    this._exit = exit;
    for (let i = 0; i < this._observers.length; i++) {
      this._observers[i](exit);
    }
    this._observers.length = 0;
  }
  runLoop(effect) {
    let yielding = false;
    let current = effect;
    this.currentOpCount = 0;
    try {
      while (true) {
        this.currentOpCount++;
        if (!yielding && this.getRef(CurrentScheduler).shouldYield(this)) {
          yielding = true;
          const prev = current;
          current = flatMap(yieldNow, () => prev);
        }
        current = current[evaluate](this);
        if (current === Yield) {
          const yielded = this._yielded;
          if (MicroExitTypeId in yielded) {
            this._yielded = undefined;
            return yielded;
          }
          return Yield;
        }
      }
    } catch (error) {
      if (!(0,Predicate/* hasProperty */.l$)(current, evaluate)) {
        return exitDie(`MicroFiber.runLoop: Not a valid effect: ${String(current)}`);
      }
      return exitDie(error);
    }
  }
  getCont(symbol) {
    while (true) {
      const op = this._stack.pop();
      if (!op) return undefined;
      const cont = op[ensureCont] && op[ensureCont](this);
      if (cont) return {
        [symbol]: cont
      };
      if (op[symbol]) return op;
    }
  }
  // cancel the yielded operation, or for the yielded exit value
  _yielded = undefined;
  yieldWith(value) {
    this._yielded = value;
    return Yield;
  }
  children() {
    return this._children ??= new Set();
  }
}
const fiberMiddleware = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)("effect/Micro/fiberMiddleware", () => ({
  interruptChildren: undefined
}));
const fiberInterruptChildren = fiber => {
  if (fiber._children === undefined || fiber._children.size === 0) {
    return undefined;
  }
  return fiberInterruptAll(fiber._children);
};
/**
 * @since 3.11.0
 * @experimental
 * @category MicroFiber
 */
const fiberAwait = self => Micro_async(resume => sync(self.addObserver(exit => resume(succeed(exit)))));
/**
 * @since 3.11.2
 * @experimental
 * @category MicroFiber
 */
const fiberJoin = self => flatten(fiberAwait(self));
/**
 * @since 3.11.0
 * @experimental
 * @category MicroFiber
 */
const fiberInterrupt = self => suspend(() => {
  self.unsafeInterrupt();
  return asVoid(fiberAwait(self));
});
/**
 * @since 3.11.0
 * @experimental
 * @category MicroFiber
 */
const fiberInterruptAll = fibers => suspend(() => {
  for (const fiber of fibers) fiber.unsafeInterrupt();
  const iter = fibers[Symbol.iterator]();
  const wait = suspend(() => {
    let result = iter.next();
    while (!result.done) {
      if (result.value.unsafePoll()) {
        result = iter.next();
        continue;
      }
      const fiber = result.value;
      return Micro_async(resume => {
        fiber.addObserver(_ => {
          resume(wait);
        });
      });
    }
    return exitVoid;
  });
  return wait;
});
const identifier = /*#__PURE__*/Symbol.for("effect/Micro/identifier");
const args = /*#__PURE__*/Symbol.for("effect/Micro/args");
const evaluate = /*#__PURE__*/Symbol.for("effect/Micro/evaluate");
const successCont = /*#__PURE__*/Symbol.for("effect/Micro/successCont");
const failureCont = /*#__PURE__*/Symbol.for("effect/Micro/failureCont");
const ensureCont = /*#__PURE__*/Symbol.for("effect/Micro/ensureCont");
const Yield = /*#__PURE__*/Symbol.for("effect/Micro/Yield");
const microVariance = {
  _A: Function/* identity */.yR,
  _E: Function/* identity */.yR,
  _R: Function/* identity */.yR
};
const MicroProto = {
  ...Effectable/* EffectPrototype */.tU,
  _op: "Micro",
  [TypeId]: microVariance,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  },
  [Symbol.iterator]() {
    return new Utils/* SingleShotGen */.U9(new Utils/* YieldWrap */.oY(this));
  },
  toJSON() {
    return {
      _id: "Micro",
      op: this[identifier],
      ...(args in this ? {
        args: this[args]
      } : undefined)
    };
  },
  toString() {
    return (0,esm_Inspectable/* format */.WU)(this);
  },
  [esm_Inspectable/* NodeInspectSymbol */.j5]() {
    return (0,esm_Inspectable/* format */.WU)(this);
  }
};
function defaultEvaluate(_fiber) {
  return exitDie(`Micro.evaluate: Not implemented`);
}
const makePrimitiveProto = options => ({
  ...MicroProto,
  [identifier]: options.op,
  [evaluate]: options.eval ?? defaultEvaluate,
  [successCont]: options.contA,
  [failureCont]: options.contE,
  [ensureCont]: options.ensure
});
const makePrimitive = options => {
  const Proto = makePrimitiveProto(options);
  return function () {
    const self = Object.create(Proto);
    self[args] = options.single === false ? arguments : arguments[0];
    return self;
  };
};
const makeExit = options => {
  const Proto = {
    ...makePrimitiveProto(options),
    [MicroExitTypeId]: MicroExitTypeId,
    _tag: options.op,
    get [options.prop]() {
      return this[args];
    },
    toJSON() {
      return {
        _id: "MicroExit",
        _tag: options.op,
        [options.prop]: this[args]
      };
    },
    [esm_Equal/* symbol */.NA](that) {
      return isMicroExit(that) && that._tag === options.op && esm_Equal/* equals */.fS(this[args], that[args]);
    },
    [esm_Hash/* symbol */.NA]() {
      return esm_Hash/* cached */.HX(this, esm_Hash/* combine */.$e(esm_Hash/* string */.Z_(options.op))(esm_Hash/* hash */.vp(this[args])));
    }
  };
  return function (value) {
    const self = Object.create(Proto);
    self[args] = value;
    self[successCont] = undefined;
    self[failureCont] = undefined;
    self[ensureCont] = undefined;
    return self;
  };
};
/**
 * Creates a `Micro` effect that will succeed with the specified constant value.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const succeed = /*#__PURE__*/makeExit({
  op: "Success",
  prop: "value",
  eval(fiber) {
    const cont = fiber.getCont(successCont);
    return cont ? cont[successCont](this[args], fiber) : fiber.yieldWith(this);
  }
});
/**
 * Creates a `Micro` effect that will fail with the specified `MicroCause`.
 *
 * @since 3.4.6
 * @experimental
 * @category constructors
 */
const failCause = /*#__PURE__*/makeExit({
  op: "Failure",
  prop: "cause",
  eval(fiber) {
    let cont = fiber.getCont(failureCont);
    while (causeIsInterrupt(this[args]) && cont && fiber.interruptible) {
      cont = fiber.getCont(failureCont);
    }
    return cont ? cont[failureCont](this[args], fiber) : fiber.yieldWith(this);
  }
});
/**
 * Creates a `Micro` effect that fails with the given error.
 *
 * This results in a `Fail` variant of the `MicroCause` type, where the error is
 * tracked at the type level.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const fail = error => failCause(causeFail(error));
/**
 * Creates a `Micro` effect that succeeds with a lazily evaluated value.
 *
 * If the evaluation of the value throws an error, the effect will fail with a
 * `Die` variant of the `MicroCause` type.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const sync = /*#__PURE__*/makePrimitive({
  op: "Sync",
  eval(fiber) {
    const value = this[args]();
    const cont = fiber.getCont(successCont);
    return cont ? cont[successCont](value, fiber) : fiber.yieldWith(exitSucceed(value));
  }
});
/**
 * Lazily creates a `Micro` effect from the given side-effect.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const suspend = /*#__PURE__*/makePrimitive({
  op: "Suspend",
  eval(_fiber) {
    return this[args]();
  }
});
/**
 * Pause the execution of the current `Micro` effect, and resume it on the next
 * scheduler tick.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const yieldNowWith = /*#__PURE__*/makePrimitive({
  op: "Yield",
  eval(fiber) {
    let resumed = false;
    fiber.getRef(CurrentScheduler).scheduleTask(() => {
      if (resumed) return;
      fiber.evaluate(exitVoid);
    }, this[args] ?? 0);
    return fiber.yieldWith(() => {
      resumed = true;
    });
  }
});
/**
 * Pause the execution of the current `Micro` effect, and resume it on the next
 * scheduler tick.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const yieldNow = /*#__PURE__*/yieldNowWith(0);
/**
 * Creates a `Micro` effect that will succeed with the value wrapped in `Some`.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const succeedSome = a => succeed(Option.some(a));
/**
 * Creates a `Micro` effect that succeeds with `None`.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const succeedNone = /*#__PURE__*/(/* unused pure expression or super */ null && (succeed( /*#__PURE__*/Option.none())));
/**
 * Creates a `Micro` effect that will fail with the lazily evaluated `MicroCause`.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const failCauseSync = evaluate => suspend(() => failCause(evaluate()));
/**
 * Creates a `Micro` effect that will die with the specified error.
 *
 * This results in a `Die` variant of the `MicroCause` type, where the error is
 * not tracked at the type level.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const die = defect => exitDie(defect);
/**
 * Creates a `Micro` effect that will fail with the lazily evaluated error.
 *
 * This results in a `Fail` variant of the `MicroCause` type, where the error is
 * tracked at the type level.
 *
 * @since 3.4.6
 * @experimental
 * @category constructors
 */
const failSync = error => suspend(() => fail(error()));
/**
 * Converts an `Option` into a `Micro` effect, that will fail with
 * `NoSuchElementException` if the option is `None`. Otherwise, it will succeed with the
 * value of the option.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const fromOption = option => option._tag === "Some" ? succeed(option.value) : fail(new NoSuchElementException({}));
/**
 * Converts an `Either` into a `Micro` effect, that will fail with the left side
 * of the either if it is a `Left`. Otherwise, it will succeed with the right
 * side of the either.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const fromEither = either => either._tag === "Right" ? succeed(either.right) : fail(either.left);
const void_ = /*#__PURE__*/succeed(void 0);

const try_ = options => suspend(() => {
  try {
    return succeed(options.try());
  } catch (err) {
    return fail(options.catch(err));
  }
});

/**
 * Wrap a `Promise` into a `Micro` effect.
 *
 * Any errors will result in a `Die` variant of the `MicroCause` type, where the
 * error is not tracked at the type level.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const promise = evaluate => asyncOptions(function (resume, signal) {
  evaluate(signal).then(a => resume(succeed(a)), e => resume(die(e)));
}, evaluate.length !== 0);
/**
 * Wrap a `Promise` into a `Micro` effect. Any errors will be caught and
 * converted into a specific error type.
 *
 * @example
 * ```ts
 * import { Micro } from "effect"
 *
 * Micro.tryPromise({
 *   try: () => Promise.resolve("success"),
 *   catch: (cause) => new Error("caught", { cause })
 * })
 * ```
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const tryPromise = options => asyncOptions(function (resume, signal) {
  try {
    options.try(signal).then(a => resume(succeed(a)), e => resume(fail(options.catch(e))));
  } catch (err) {
    resume(fail(options.catch(err)));
  }
}, options.try.length !== 0);
/**
 * Create a `Micro` effect using the current `MicroFiber`.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const withMicroFiber = /*#__PURE__*/makePrimitive({
  op: "WithMicroFiber",
  eval(fiber) {
    return this[args](fiber);
  }
});
/**
 * Flush any yielded effects that are waiting to be executed.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const yieldFlush = /*#__PURE__*/(/* unused pure expression or super */ null && (withMicroFiber(fiber => {
  fiber.getRef(CurrentScheduler).flush();
  return exitVoid;
})));
const asyncOptions = /*#__PURE__*/makePrimitive({
  op: "Async",
  single: false,
  eval(fiber) {
    const register = this[args][0];
    let resumed = false;
    let yielded = false;
    const controller = this[args][1] ? new AbortController() : undefined;
    const onCancel = register(effect => {
      if (resumed) return;
      resumed = true;
      if (yielded) {
        fiber.evaluate(effect);
      } else {
        yielded = effect;
      }
    }, controller?.signal);
    if (yielded !== false) return yielded;
    yielded = true;
    fiber._yielded = () => {
      resumed = true;
    };
    if (controller === undefined && onCancel === undefined) {
      return Yield;
    }
    fiber._stack.push(asyncFinalizer(() => {
      resumed = true;
      controller?.abort();
      return onCancel ?? exitVoid;
    }));
    return Yield;
  }
});
const asyncFinalizer = /*#__PURE__*/makePrimitive({
  op: "AsyncFinalizer",
  ensure(fiber) {
    if (fiber.interruptible) {
      fiber.interruptible = false;
      fiber._stack.push(setInterruptible(true));
    }
  },
  contE(cause, _fiber) {
    return causeIsInterrupt(cause) ? flatMap(this[args](), () => failCause(cause)) : failCause(cause);
  }
});
/**
 * Create a `Micro` effect from an asynchronous computation.
 *
 * You can return a cleanup effect that will be run when the effect is aborted.
 * It is also passed an `AbortSignal` that is triggered when the effect is
 * aborted.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const Micro_async = register => asyncOptions(register, register.length >= 2);
/**
 * A `Micro` that will never succeed or fail. It wraps `setInterval` to prevent
 * the Javascript runtime from exiting.
 *
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const never = /*#__PURE__*/(/* unused pure expression or super */ null && (Micro_async(function () {
  const interval = setInterval(constVoid, 2147483646);
  return sync(() => clearInterval(interval));
})));
/**
 * @since 3.4.0
 * @experimental
 * @category constructors
 */
const gen = (...args) => suspend(() => fromIterator(args.length === 1 ? args[0]() : args[1].call(args[0])));
const fromIterator = /*#__PURE__*/makePrimitive({
  op: "Iterator",
  contA(value, fiber) {
    const state = this[args].next(value);
    if (state.done) return succeed(state.value);
    fiber._stack.push(this);
    return (0,Utils/* yieldWrapGet */.Rz)(state.value);
  },
  eval(fiber) {
    return this[successCont](undefined, fiber);
  }
});
// ----------------------------------------------------------------------------
// mapping & sequencing
// ----------------------------------------------------------------------------
/**
 * Create a `Micro` effect that will replace the success value of the given
 * effect.
 *
 * @since 3.4.0
 * @experimental
 * @category mapping & sequencing
 */
const as = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, value) => map(self, _ => value))));
/**
 * Wrap the success value of this `Micro` effect in a `Some`.
 *
 * @since 3.4.0
 * @experimental
 * @category mapping & sequencing
 */
const asSome = self => map(self, Option.some);
/**
 * Swap the error and success types of the `Micro` effect.
 *
 * @since 3.4.0
 * @experimental
 * @category mapping & sequencing
 */
const flip = self => matchEffect(self, {
  onFailure: succeed,
  onSuccess: fail
});
/**
 * A more flexible version of `flatMap` that combines `map` and `flatMap` into a
 * single API.
 *
 * It also lets you directly pass a `Micro` effect, which will be executed after
 * the current effect.
 *
 * @since 3.4.0
 * @experimental
 * @category mapping & sequencing
 */
const andThen = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => flatMap(self, a => {
  const value = isMicro(f) ? f : typeof f === "function" ? f(a) : f;
  return isMicro(value) ? value : succeed(value);
}))));
/**
 * Execute a side effect from the success value of the `Micro` effect.
 *
 * It is similar to the `andThen` api, but the success value is ignored.
 *
 * @since 3.4.0
 * @experimental
 * @category mapping & sequencing
 */
const tap = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => flatMap(self, a => {
  const value = isMicro(f) ? f : typeof f === "function" ? f(a) : f;
  return isMicro(value) ? as(value, a) : succeed(a);
}))));
/**
 * Replace the success value of the `Micro` effect with `void`.
 *
 * @since 3.4.0
 * @experimental
 * @category mapping & sequencing
 */
const asVoid = self => flatMap(self, _ => exitVoid);
/**
 * Access the `MicroExit` of the given `Micro` effect.
 *
 * @since 3.4.6
 * @experimental
 * @category mapping & sequencing
 */
const exit = self => matchCause(self, {
  onFailure: exitFailCause,
  onSuccess: exitSucceed
});
/**
 * Replace the error type of the given `Micro` with the full `MicroCause` object.
 *
 * @since 3.4.0
 * @experimental
 * @category mapping & sequencing
 */
const sandbox = self => catchAllCause(self, fail);
/**
 * Returns an effect that races all the specified effects,
 * yielding the value of the first effect to succeed with a value. Losers of
 * the race will be interrupted immediately
 *
 * @since 3.4.0
 * @experimental
 * @category sequencing
 */
const raceAll = all => withMicroFiber(parent => Micro_async(resume => {
  const effects = Arr.fromIterable(all);
  const len = effects.length;
  let doneCount = 0;
  let done = false;
  const fibers = new Set();
  const causes = [];
  const onExit = exit => {
    doneCount++;
    if (exit._tag === "Failure") {
      causes.push(exit.cause);
      if (doneCount >= len) {
        resume(failCause(causes[0]));
      }
      return;
    }
    done = true;
    resume(fibers.size === 0 ? exit : flatMap(uninterruptible(fiberInterruptAll(fibers)), () => exit));
  };
  for (let i = 0; i < len; i++) {
    if (done) break;
    const fiber = unsafeFork(parent, interruptible(effects[i]), true, true);
    fibers.add(fiber);
    fiber.addObserver(exit => {
      fibers.delete(fiber);
      onExit(exit);
    });
  }
  return fiberInterruptAll(fibers);
}));
/**
 * Returns an effect that races all the specified effects,
 * yielding the value of the first effect to succeed or fail. Losers of
 * the race will be interrupted immediately.
 *
 * @since 3.4.0
 * @experimental
 * @category sequencing
 */
const raceAllFirst = all => withMicroFiber(parent => Micro_async(resume => {
  let done = false;
  const fibers = new Set();
  const onExit = exit => {
    done = true;
    resume(fibers.size === 0 ? exit : flatMap(fiberInterruptAll(fibers), () => exit));
  };
  for (const effect of all) {
    if (done) break;
    const fiber = unsafeFork(parent, interruptible(effect), true, true);
    fibers.add(fiber);
    fiber.addObserver(exit => {
      fibers.delete(fiber);
      onExit(exit);
    });
  }
  return fiberInterruptAll(fibers);
}));
/**
 * Returns an effect that races two effects, yielding the value of the first
 * effect to succeed. Losers of the race will be interrupted immediately.
 *
 * @since 3.4.0
 * @experimental
 * @category sequencing
 */
const race = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => raceAll([self, that]))));
/**
 * Returns an effect that races two effects, yielding the value of the first
 * effect to succeed *or* fail. Losers of the race will be interrupted immediately.
 *
 * @since 3.4.0
 * @experimental
 * @category sequencing
 */
const raceFirst = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => raceAllFirst([self, that]))));
/**
 * Map the success value of this `Micro` effect to another `Micro` effect, then
 * flatten the result.
 *
 * @since 3.4.0
 * @experimental
 * @category mapping & sequencing
 */
const flatMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const onSuccess = Object.create(OnSuccessProto);
  onSuccess[args] = self;
  onSuccess[successCont] = f;
  return onSuccess;
});
const OnSuccessProto = /*#__PURE__*/makePrimitiveProto({
  op: "OnSuccess",
  eval(fiber) {
    fiber._stack.push(this);
    return this[args];
  }
});
// ----------------------------------------------------------------------------
// mapping & sequencing
// ----------------------------------------------------------------------------
/**
 * Flattens any nested `Micro` effects, merging the error and requirement types.
 *
 * @since 3.4.0
 * @experimental
 * @category mapping & sequencing
 */
const flatten = self => flatMap(self, identity);
/**
 * Transforms the success value of the `Micro` effect with the specified
 * function.
 *
 * @since 3.4.0
 * @experimental
 * @category mapping & sequencing
 */
const map = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => flatMap(self, a => succeed(f(a))))));
/**
 * @since 3.4.6
 * @experimental
 * @category MicroExit
 */
const isMicroExit = u => (0,Predicate/* hasProperty */.l$)(u, MicroExitTypeId);
/**
 * @since 3.4.6
 * @experimental
 * @category MicroExit
 */
const exitSucceed = succeed;
/**
 * @since 3.4.6
 * @experimental
 * @category MicroExit
 */
const exitFailCause = failCause;
/**
 * @since 3.4.6
 * @experimental
 * @category MicroExit
 */
const exitInterrupt = /*#__PURE__*/exitFailCause( /*#__PURE__*/causeInterrupt());
/**
 * @since 3.4.6
 * @experimental
 * @category MicroExit
 */
const exitFail = e => exitFailCause(causeFail(e));
/**
 * @since 3.4.6
 * @experimental
 * @category MicroExit
 */
const exitDie = defect => exitFailCause(causeDie(defect));
/**
 * @since 3.4.6
 * @experimental
 * @category MicroExit
 */
const exitIsSuccess = self => self._tag === "Success";
/**
 * @since 3.4.6
 * @experimental
 * @category MicroExit
 */
const exitIsFailure = self => self._tag === "Failure";
/**
 * @since 3.4.6
 * @experimental
 * @category MicroExit
 */
const exitIsInterrupt = self => exitIsFailure(self) && self.cause._tag === "Interrupt";
/**
 * @since 3.4.6
 * @experimental
 * @category MicroExit
 */
const exitIsFail = self => exitIsFailure(self) && self.cause._tag === "Fail";
/**
 * @since 3.4.6
 * @experimental
 * @category MicroExit
 */
const exitIsDie = self => exitIsFailure(self) && self.cause._tag === "Die";
/**
 * @since 3.4.6
 * @experimental
 * @category MicroExit
 */
const exitVoid = /*#__PURE__*/exitSucceed(void 0);
/**
 * @since 3.11.0
 * @experimental
 * @category MicroExit
 */
const exitVoidAll = exits => {
  for (const exit of exits) {
    if (exit._tag === "Failure") {
      return exit;
    }
  }
  return exitVoid;
};
const setImmediate = "setImmediate" in globalThis ? globalThis.setImmediate : f => setTimeout(f, 0);
/**
 * @since 3.5.9
 * @experimental
 * @category scheduler
 */
class MicroSchedulerDefault {
  tasks = [];
  running = false;
  /**
   * @since 3.5.9
   */
  scheduleTask(task, _priority) {
    this.tasks.push(task);
    if (!this.running) {
      this.running = true;
      setImmediate(this.afterScheduled);
    }
  }
  /**
   * @since 3.5.9
   */
  afterScheduled = () => {
    this.running = false;
    this.runTasks();
  };
  /**
   * @since 3.5.9
   */
  runTasks() {
    const tasks = this.tasks;
    this.tasks = [];
    for (let i = 0, len = tasks.length; i < len; i++) {
      tasks[i]();
    }
  }
  /**
   * @since 3.5.9
   */
  shouldYield(fiber) {
    return fiber.currentOpCount >= fiber.getRef(MaxOpsBeforeYield);
  }
  /**
   * @since 3.5.9
   */
  flush() {
    while (this.tasks.length > 0) {
      this.runTasks();
    }
  }
}
/**
 * Access the given `Context.Tag` from the environment.
 *
 * @since 3.4.0
 * @experimental
 * @category environment
 */
const service = tag => withMicroFiber(fiber => succeed(Context.unsafeGet(fiber.context, tag)));
/**
 * Access the given `Context.Tag` from the environment, without tracking the
 * dependency at the type level.
 *
 * It will return an `Option` of the service, depending on whether it is
 * available in the environment or not.
 *
 * @since 3.4.0
 * @experimental
 * @category environment
 */
const serviceOption = tag => withMicroFiber(fiber => succeed(Context.getOption(fiber.context, tag)));
/**
 * Update the Context with the given mapping function.
 *
 * @since 3.11.0
 * @experimental
 * @category environment
 */
const updateContext = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => withMicroFiber(fiber => {
  const prev = fiber.context;
  fiber.context = f(prev);
  return onExit(self, () => {
    fiber.context = prev;
    return void_;
  });
}));
/**
 * Update the service for the given `Context.Tag` in the environment.
 *
 * @since 3.11.0
 * @experimental
 * @category environment
 */
const updateService = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, tag, f) => withMicroFiber(fiber => {
  const prev = Context.unsafeGet(fiber.context, tag);
  fiber.context = Context.add(fiber.context, tag, f(prev));
  return onExit(self, () => {
    fiber.context = Context.add(fiber.context, tag, prev);
    return void_;
  });
}))));
/**
 * Access the current `Context` from the environment.
 *
 * @since 3.4.0
 * @experimental
 * @category environment
 */
const Micro_context = () => getContext;
const getContext = /*#__PURE__*/(/* unused pure expression or super */ null && (withMicroFiber(fiber => succeed(fiber.context))));
/**
 * Merge the given `Context` with the current context.
 *
 * @since 3.4.0
 * @experimental
 * @category environment
 */
const provideContext = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, provided) => updateContext(self, esm_Context/* merge */.TS(provided)));
/**
 * Add the provided service to the current context.
 *
 * @since 3.4.0
 * @experimental
 * @category environment
 */
const provideService = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, tag, service) => updateContext(self, Context.add(tag, service)))));
/**
 * Create a service using the provided `Micro` effect, and add it to the
 * current context.
 *
 * @since 3.4.6
 * @experimental
 * @category environment
 */
const provideServiceEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, tag, acquire) => flatMap(acquire, service => provideService(self, tag, service)))));
// ========================================================================
// References
// ========================================================================
/**
 * @since 3.11.0
 * @experimental
 * @category references
 */
class MaxOpsBeforeYield extends /*#__PURE__*/esm_Context/* Reference */.s3()("effect/Micro/currentMaxOpsBeforeYield", {
  defaultValue: () => 2048
}) {}
/**
 * @since 3.11.0
 * @experimental
 * @category environment refs
 */
class CurrentConcurrency extends /*#__PURE__*/esm_Context/* Reference */.s3()("effect/Micro/currentConcurrency", {
  defaultValue: () => "unbounded"
}) {}
/**
 * @since 3.11.0
 * @experimental
 * @category environment refs
 */
class CurrentScheduler extends /*#__PURE__*/esm_Context/* Reference */.s3()("effect/Micro/currentScheduler", {
  defaultValue: () => new MicroSchedulerDefault()
}) {}
/**
 * If you have a `Micro` that uses `concurrency: "inherit"`, you can use this
 * api to control the concurrency of that `Micro` when it is run.
 *
 * @example
 * ```ts
 * import * as Micro from "effect/Micro"
 *
 * Micro.forEach([1, 2, 3], (n) => Micro.succeed(n), {
 *   concurrency: "inherit"
 * }).pipe(
 *   Micro.withConcurrency(2) // use a concurrency of 2
 * )
 * ```
 *
 * @since 3.4.0
 * @experimental
 * @category environment refs
 */
const withConcurrency = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, concurrency) => provideService(self, CurrentConcurrency, concurrency))));
// ----------------------------------------------------------------------------
// zipping
// ----------------------------------------------------------------------------
/**
 * Combine two `Micro` effects into a single effect that produces a tuple of
 * their results.
 *
 * @since 3.4.0
 * @experimental
 * @category zipping
 */
const zip = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isMicro(args[1]), (self, that, options) => zipWith(self, that, (a, a2) => [a, a2], options))));
/**
 * The `Micro.zipWith` function combines two `Micro` effects and allows you to
 * apply a function to the results of the combined effects, transforming them
 * into a single value.
 *
 * @since 3.4.3
 * @experimental
 * @category zipping
 */
const zipWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isMicro(args[1]), (self, that, f, options) => options?.concurrent
// Use `all` exclusively for concurrent cases, as it introduces additional overhead due to the management of concurrency
? map(Micro_all([self, that], {
  concurrency: 2
}), ([a, a2]) => f(a, a2)) : flatMap(self, a => map(that, a2 => f(a, a2))))));
// ----------------------------------------------------------------------------
// filtering & conditionals
// ----------------------------------------------------------------------------
/**
 * Filter the specified effect with the provided function, failing with specified
 * `MicroCause` if the predicate fails.
 *
 * In addition to the filtering capabilities discussed earlier, you have the option to further
 * refine and narrow down the type of the success channel by providing a
 *
 * @since 3.4.0
 * @experimental
 * @category filtering & conditionals
 */
const filterOrFailCause = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isMicro(args[0]), (self, refinement, orFailWith) => flatMap(self, a => refinement(a) ? succeed(a) : failCause(orFailWith(a))))));
/**
 * Filter the specified effect with the provided function, failing with specified
 * error if the predicate fails.
 *
 * In addition to the filtering capabilities discussed earlier, you have the option to further
 * refine and narrow down the type of the success channel by providing a
 *
 * @since 3.4.0
 * @experimental
 * @category filtering & conditionals
 */
const filterOrFail = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isMicro(args[0]), (self, refinement, orFailWith) => flatMap(self, a => refinement(a) ? succeed(a) : fail(orFailWith(a))))));
/**
 * The moral equivalent of `if (p) exp`.
 *
 * @since 3.4.0
 * @experimental
 * @category filtering & conditionals
 */
const when = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, condition) => flatMap(isMicro(condition) ? condition : sync(condition), pass => pass ? asSome(self) : succeedNone))));
// ----------------------------------------------------------------------------
// repetition
// ----------------------------------------------------------------------------
/**
 * Repeat the given `Micro` using the provided options.
 *
 * The `while` predicate will be checked after each iteration, and can use the
 * fall `MicroExit` of the effect to determine if the repetition should continue.
 *
 * @since 3.4.6
 * @experimental
 * @category repetition
 */
const repeatExit = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, options) => suspend(() => {
  const startedAt = options.schedule ? Date.now() : 0;
  let attempt = 0;
  const loop = flatMap(exit(self), exit => {
    if (options.while !== undefined && !options.while(exit)) {
      return exit;
    } else if (options.times !== undefined && attempt >= options.times) {
      return exit;
    }
    attempt++;
    let delayEffect = yieldNow;
    if (options.schedule !== undefined) {
      const elapsed = Date.now() - startedAt;
      const duration = options.schedule(attempt, elapsed);
      if (Option.isNone(duration)) {
        return exit;
      }
      delayEffect = sleep(duration.value);
    }
    return flatMap(delayEffect, () => loop);
  });
  return loop;
}))));
/**
 * Repeat the given `Micro` effect using the provided options. Only successful
 * results will be repeated.
 *
 * @since 3.4.0
 * @experimental
 * @category repetition
 */
const repeat = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isMicro(args[0]), (self, options) => repeatExit(self, {
  ...options,
  while: exit => exit._tag === "Success" && (options?.while === undefined || options.while(exit.value))
}))));
/**
 * Replicates the given effect `n` times.
 *
 * @since 3.11.0
 * @experimental
 * @category repetition
 */
const replicate = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, n) => Array.from({
  length: n
}, () => self))));
/**
 * Performs this effect the specified number of times and collects the
 * results.
 *
 * @since 3.11.0
 * @category repetition
 */
const replicateEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isMicro(args[0]), (self, n, options) => Micro_all(replicate(self, n), options))));
/**
 * Repeat the given `Micro` effect forever, only stopping if the effect fails.
 *
 * @since 3.4.0
 * @experimental
 * @category repetition
 */
const forever = self => repeat(self);
/**
 * Create a `MicroSchedule` that will stop repeating after the specified number
 * of attempts.
 *
 * @since 3.4.6
 * @experimental
 * @category scheduling
 */
const scheduleRecurs = n => attempt => attempt <= n ? Option.some(0) : Option.none();
/**
 * Create a `MicroSchedule` that will generate a constant delay.
 *
 * @since 3.4.6
 * @experimental
 * @category scheduling
 */
const scheduleSpaced = millis => () => Option.some(millis);
/**
 * Create a `MicroSchedule` that will generate a delay with an exponential backoff.
 *
 * @since 3.4.6
 * @experimental
 * @category scheduling
 */
const scheduleExponential = (baseMillis, factor = 2) => attempt => Option.some(Math.pow(factor, attempt) * baseMillis);
/**
 * Returns a new `MicroSchedule` with an added calculated delay to each delay
 * returned by this schedule.
 *
 * @since 3.4.6
 * @experimental
 * @category scheduling
 */
const scheduleAddDelay = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => (attempt, elapsed) => Option.map(self(attempt, elapsed), duration => duration + f()))));
/**
 * Transform a `MicroSchedule` to one that will have a delay that will never exceed
 * the specified maximum.
 *
 * @since 3.4.6
 * @experimental
 * @category scheduling
 */
const scheduleWithMaxDelay = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, max) => (attempt, elapsed) => Option.map(self(attempt, elapsed), duration => Math.min(duration, max)))));
/**
 * Transform a `MicroSchedule` to one that will stop repeating after the specified
 * amount of time.
 *
 * @since 3.4.6
 * @experimental
 * @category scheduling
 */
const scheduleWithMaxElapsed = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, max) => (attempt, elapsed) => elapsed < max ? self(attempt, elapsed) : Option.none())));
/**
 * Combines two `MicroSchedule`s, by recurring if either schedule wants to
 * recur, using the minimum of the two durations between recurrences.
 *
 * @since 3.4.6
 * @experimental
 * @category scheduling
 */
const scheduleUnion = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => (attempt, elapsed) => Option.zipWith(self(attempt, elapsed), that(attempt, elapsed), (d1, d2) => Math.min(d1, d2)))));
/**
 * Combines two `MicroSchedule`s, by recurring only if both schedules want to
 * recur, using the maximum of the two durations between recurrences.
 *
 * @since 3.4.6
 * @experimental
 * @category scheduling
 */
const scheduleIntersect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => (attempt, elapsed) => Option.zipWith(self(attempt, elapsed), that(attempt, elapsed), (d1, d2) => Math.max(d1, d2)))));
// ----------------------------------------------------------------------------
// error handling
// ----------------------------------------------------------------------------
/**
 * Catch the full `MicroCause` object of the given `Micro` effect, allowing you to
 * recover from any kind of cause.
 *
 * @since 3.4.6
 * @experimental
 * @category error handling
 */
const catchAllCause = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => {
  const onFailure = Object.create(OnFailureProto);
  onFailure[args] = self;
  onFailure[failureCont] = f;
  return onFailure;
})));
const OnFailureProto = /*#__PURE__*/makePrimitiveProto({
  op: "OnFailure",
  eval(fiber) {
    fiber._stack.push(this);
    return this[args];
  }
});
/**
 * Selectively catch a `MicroCause` object of the given `Micro` effect,
 * using the provided predicate to determine if the failure should be caught.
 *
 * @since 3.4.6
 * @experimental
 * @category error handling
 */
const catchCauseIf = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, predicate, f) => catchAllCause(self, cause => predicate(cause) ? f(cause) : failCause(cause)))));
/**
 * Catch the error of the given `Micro` effect, allowing you to recover from it.
 *
 * It only catches expected errors.
 *
 * @since 3.4.6
 * @experimental
 * @category error handling
 */
const catchAll = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => catchCauseIf(self, causeIsFail, cause => f(cause.error)))));
/**
 * Catch any unexpected errors of the given `Micro` effect, allowing you to recover from them.
 *
 * @since 3.4.6
 * @experimental
 * @category error handling
 */
const catchAllDefect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => catchCauseIf(self, causeIsDie, die => f(die.defect)))));
/**
 * Perform a side effect using the full `MicroCause` object of the given `Micro`.
 *
 * @since 3.4.6
 * @experimental
 * @category error handling
 */
const tapErrorCause = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => tapErrorCauseIf(self, constTrue, f))));
/**
 * Perform a side effect using if a `MicroCause` object matches the specified
 * predicate.
 *
 * @since 3.4.0
 * @experimental
 * @category error handling
 */
const tapErrorCauseIf = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, refinement, f) => catchCauseIf(self, refinement, cause => andThen(f(cause), failCause(cause))))));
/**
 * Perform a side effect from expected errors of the given `Micro`.
 *
 * @since 3.4.6
 * @experimental
 * @category error handling
 */
const tapError = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => tapErrorCauseIf(self, causeIsFail, fail => f(fail.error)))));
/**
 * Perform a side effect from unexpected errors of the given `Micro`.
 *
 * @since 3.4.6
 * @experimental
 * @category error handling
 */
const tapDefect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => tapErrorCauseIf(self, causeIsDie, die => f(die.defect)))));
/**
 * Catch any expected errors that match the specified predicate.
 *
 * @since 3.4.0
 * @experimental
 * @category error handling
 */
const catchIf = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, predicate, f) => catchCauseIf(self, f => causeIsFail(f) && predicate(f.error), fail => f(fail.error)))));
/**
 * Recovers from the specified tagged error.
 *
 * @since 3.4.0
 * @experimental
 * @category error handling
 */
const catchTag = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, k, f) => catchIf(self, isTagged(k), f))));
/**
 * Transform the full `MicroCause` object of the given `Micro` effect.
 *
 * @since 3.4.6
 * @experimental
 * @category error handling
 */
const mapErrorCause = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => catchAllCause(self, cause => failCause(f(cause))))));
/**
 * Transform any expected errors of the given `Micro` effect.
 *
 * @since 3.4.0
 * @experimental
 * @category error handling
 */
const mapError = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => catchAll(self, error => fail(f(error))))));
/**
 * Elevate any expected errors of the given `Micro` effect to unexpected errors,
 * resulting in an error type of `never`.
 *
 * @since 3.4.0
 * @experimental
 * @category error handling
 */
const orDie = self => catchAll(self, die);
/**
 * Recover from all errors by succeeding with the given value.
 *
 * @since 3.4.0
 * @experimental
 * @category error handling
 */
const orElseSucceed = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => catchAll(self, _ => sync(f)))));
/**
 * Ignore any expected errors of the given `Micro` effect, returning `void`.
 *
 * @since 3.4.0
 * @experimental
 * @category error handling
 */
const ignore = self => matchEffect(self, {
  onFailure: _ => void_,
  onSuccess: _ => void_
});
/**
 * Ignore any expected errors of the given `Micro` effect, returning `void`.
 *
 * @since 3.4.0
 * @experimental
 * @category error handling
 */
const ignoreLogged = self => matchEffect(self, {
  // eslint-disable-next-line no-console
  onFailure: error => sync(() => console.error(error)),
  onSuccess: _ => void_
});
/**
 * Replace the success value of the given `Micro` effect with an `Option`,
 * wrapping the success value in `Some` and returning `None` if the effect fails
 * with an expected error.
 *
 * @since 3.4.0
 * @experimental
 * @category error handling
 */
const Micro_option = self => Micro_match(self, {
  onFailure: Option.none,
  onSuccess: Option.some
});
/**
 * Replace the success value of the given `Micro` effect with an `Either`,
 * wrapping the success value in `Right` and wrapping any expected errors with
 * a `Left`.
 *
 * @since 3.4.0
 * @experimental
 * @category error handling
 */
const either = self => Micro_match(self, {
  onFailure: Either.left,
  onSuccess: Either.right
});
/**
 * Retry the given `Micro` effect using the provided options.
 *
 * @since 3.4.0
 * @experimental
 * @category error handling
 */
const retry = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(args => isMicro(args[0]), (self, options) => repeatExit(self, {
  ...options,
  while: exit => exit._tag === "Failure" && exit.cause._tag === "Fail" && (options?.while === undefined || options.while(exit.cause.error))
}))));
/**
 * Add a stack trace to any failures that occur in the effect. The trace will be
 * added to the `traces` field of the `MicroCause` object.
 *
 * @since 3.4.0
 * @experimental
 * @category error handling
 */
const withTrace = function () {
  const prevLimit = globalThis.Error.stackTraceLimit;
  globalThis.Error.stackTraceLimit = 2;
  const error = new globalThis.Error();
  globalThis.Error.stackTraceLimit = prevLimit;
  function generate(name, cause) {
    const stack = error.stack;
    if (!stack) {
      return cause;
    }
    const line = stack.split("\n")[2]?.trim().replace(/^at /, "");
    if (!line) {
      return cause;
    }
    const lineMatch = line.match(/\((.*)\)$/);
    return causeWithTrace(cause, `at ${name} (${lineMatch ? lineMatch[1] : line})`);
  }
  const f = name => self => onError(self, cause => failCause(generate(name, cause)));
  if (arguments.length === 2) {
    return f(arguments[1])(arguments[0]);
  }
  return f(arguments[0]);
};
// ----------------------------------------------------------------------------
// pattern matching
// ----------------------------------------------------------------------------
/**
 * @since 3.4.6
 * @experimental
 * @category pattern matching
 */
const matchCauseEffect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, options) => {
  const primitive = Object.create(OnSuccessAndFailureProto);
  primitive[args] = self;
  primitive[successCont] = options.onSuccess;
  primitive[failureCont] = options.onFailure;
  return primitive;
});
const OnSuccessAndFailureProto = /*#__PURE__*/makePrimitiveProto({
  op: "OnSuccessAndFailure",
  eval(fiber) {
    fiber._stack.push(this);
    return this[args];
  }
});
/**
 * @since 3.4.6
 * @experimental
 * @category pattern matching
 */
const matchCause = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, options) => matchCauseEffect(self, {
  onFailure: cause => sync(() => options.onFailure(cause)),
  onSuccess: value => sync(() => options.onSuccess(value))
}))));
/**
 * @since 3.4.6
 * @experimental
 * @category pattern matching
 */
const matchEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, options) => matchCauseEffect(self, {
  onFailure: cause => cause._tag === "Fail" ? options.onFailure(cause.error) : failCause(cause),
  onSuccess: options.onSuccess
}))));
/**
 * @since 3.4.0
 * @experimental
 * @category pattern matching
 */
const Micro_match = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, options) => matchEffect(self, {
  onFailure: error => sync(() => options.onFailure(error)),
  onSuccess: value => sync(() => options.onSuccess(value))
}))));
// ----------------------------------------------------------------------------
// delays & timeouts
// ----------------------------------------------------------------------------
/**
 * Create a `Micro` effect that will sleep for the specified duration.
 *
 * @since 3.4.0
 * @experimental
 * @category delays & timeouts
 */
const sleep = millis => Micro_async(resume => {
  const timeout = setTimeout(() => {
    resume(void_);
  }, millis);
  return sync(() => {
    clearTimeout(timeout);
  });
});
/**
 * Returns an effect that will delay the execution of this effect by the
 * specified duration.
 *
 * @since 3.4.0
 * @experimental
 * @category delays & timeouts
 */
const delay = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, millis) => andThen(sleep(millis), self))));
/**
 * Returns an effect that will timeout this effect, that will execute the
 * fallback effect if the timeout elapses before the effect has produced a value.
 *
 * If the timeout elapses, the running effect will be safely interrupted.
 *
 * @since 3.4.0
 * @experimental
 * @category delays & timeouts
 */
const timeoutOrElse = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, options) => raceFirst(self, andThen(interruptible(sleep(options.duration)), options.onTimeout)))));
/**
 * Returns an effect that will timeout this effect, that will fail with a
 * `TimeoutException` if the timeout elapses before the effect has produced a
 * value.
 *
 * If the timeout elapses, the running effect will be safely interrupted.
 *
 * @since 3.4.0
 * @experimental
 * @category delays & timeouts
 */
const timeout = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, millis) => timeoutOrElse(self, {
  duration: millis,
  onTimeout: () => fail(new TimeoutException())
}))));
/**
 * Returns an effect that will timeout this effect, succeeding with a `None`
 * if the timeout elapses before the effect has produced a value; and `Some` of
 * the produced value otherwise.
 *
 * If the timeout elapses, the running effect will be safely interrupted.
 *
 * @since 3.4.0
 * @experimental
 * @category delays & timeouts
 */
const timeoutOption = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, millis) => raceFirst(asSome(self), as(interruptible(sleep(millis)), Option.none())))));
// ----------------------------------------------------------------------------
// resources & finalization
// ----------------------------------------------------------------------------
/**
 * @since 3.4.0
 * @experimental
 * @category resources & finalization
 */
const MicroScopeTypeId = /*#__PURE__*/Symbol.for("effect/Micro/MicroScope");
/**
 * @since 3.4.0
 * @experimental
 * @category resources & finalization
 */
const MicroScope = /*#__PURE__*/(/* unused pure expression or super */ null && (Context.GenericTag("effect/Micro/MicroScope")));
class MicroScopeImpl {
  [MicroScopeTypeId];
  state = {
    _tag: "Open",
    finalizers: /*#__PURE__*/new Set()
  };
  constructor() {
    this[MicroScopeTypeId] = MicroScopeTypeId;
  }
  unsafeAddFinalizer(finalizer) {
    if (this.state._tag === "Open") {
      this.state.finalizers.add(finalizer);
    }
  }
  addFinalizer(finalizer) {
    return suspend(() => {
      if (this.state._tag === "Open") {
        this.state.finalizers.add(finalizer);
        return void_;
      }
      return finalizer(this.state.exit);
    });
  }
  unsafeRemoveFinalizer(finalizer) {
    if (this.state._tag === "Open") {
      this.state.finalizers.delete(finalizer);
    }
  }
  close(microExit) {
    return suspend(() => {
      if (this.state._tag === "Open") {
        const finalizers = Array.from(this.state.finalizers).reverse();
        this.state = {
          _tag: "Closed",
          exit: microExit
        };
        return flatMap(forEach(finalizers, finalizer => exit(finalizer(microExit))), exitVoidAll);
      }
      return void_;
    });
  }
  get fork() {
    return sync(() => {
      const newScope = new MicroScopeImpl();
      if (this.state._tag === "Closed") {
        newScope.state = this.state;
        return newScope;
      }
      function fin(exit) {
        return newScope.close(exit);
      }
      this.state.finalizers.add(fin);
      newScope.unsafeAddFinalizer(_ => sync(() => this.unsafeRemoveFinalizer(fin)));
      return newScope;
    });
  }
}
/**
 * @since 3.4.0
 * @experimental
 * @category resources & finalization
 */
const scopeMake = /*#__PURE__*/(/* unused pure expression or super */ null && (sync(() => new MicroScopeImpl())));
/**
 * @since 3.4.0
 * @experimental
 * @category resources & finalization
 */
const scopeUnsafeMake = () => new MicroScopeImpl();
/**
 * Access the current `MicroScope`.
 *
 * @since 3.4.0
 * @experimental
 * @category resources & finalization
 */
const scope = /*#__PURE__*/(/* unused pure expression or super */ null && (service(MicroScope)));
/**
 * Provide a `MicroScope` to an effect.
 *
 * @since 3.4.0
 * @experimental
 * @category resources & finalization
 */
const provideScope = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, scope) => provideService(self, MicroScope, scope))));
/**
 * Provide a `MicroScope` to the given effect, closing it after the effect has
 * finished executing.
 *
 * @since 3.4.0
 * @experimental
 * @category resources & finalization
 */
const scoped = self => suspend(() => {
  const scope = new MicroScopeImpl();
  return onExit(provideService(self, MicroScope, scope), exit => scope.close(exit));
});
/**
 * Create a resource with a cleanup `Micro` effect, ensuring the cleanup is
 * executed when the `MicroScope` is closed.
 *
 * @since 3.4.0
 * @experimental
 * @category resources & finalization
 */
const acquireRelease = (acquire, release) => uninterruptible(flatMap(scope, scope => tap(acquire, a => scope.addFinalizer(exit => release(a, exit)))));
/**
 * Add a finalizer to the current `MicroScope`.
 *
 * @since 3.4.0
 * @experimental
 * @category resources & finalization
 */
const addFinalizer = finalizer => flatMap(scope, scope => scope.addFinalizer(finalizer));
/**
 * When the `Micro` effect is completed, run the given finalizer effect with the
 * `MicroExit` of the executed effect.
 *
 * @since 3.4.6
 * @experimental
 * @category resources & finalization
 */
const onExit = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => uninterruptibleMask(restore => matchCauseEffect(restore(self), {
  onFailure: cause => flatMap(f(exitFailCause(cause)), () => failCause(cause)),
  onSuccess: a => flatMap(f(exitSucceed(a)), () => succeed(a))
})));
/**
 * Regardless of the result of the this `Micro` effect, run the finalizer effect.
 *
 * @since 3.4.0
 * @experimental
 * @category resources & finalization
 */
const ensuring = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, finalizer) => onExit(self, _ => finalizer))));
/**
 * When the `Micro` effect is completed, run the given finalizer effect if it
 * matches the specified predicate.
 *
 * @since 3.4.6
 * @experimental
 * @category resources & finalization
 */
const onExitIf = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, refinement, f) => onExit(self, exit => refinement(exit) ? f(exit) : exitVoid))));
/**
 * When the `Micro` effect fails, run the given finalizer effect with the
 * `MicroCause` of the executed effect.
 *
 * @since 3.4.6
 * @experimental
 * @category resources & finalization
 */
const onError = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => onExitIf(self, exitIsFailure, exit => f(exit.cause)))));
/**
 * If this `Micro` effect is aborted, run the finalizer effect.
 *
 * @since 3.4.6
 * @experimental
 * @category resources & finalization
 */
const onInterrupt = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, finalizer) => onExitIf(self, exitIsInterrupt, _ => finalizer))));
/**
 * Acquire a resource, use it, and then release the resource when the `use`
 * effect has completed.
 *
 * @since 3.4.0
 * @experimental
 * @category resources & finalization
 */
const acquireUseRelease = (acquire, use, release) => uninterruptibleMask(restore => flatMap(acquire, a => flatMap(exit(restore(use(a))), exit => andThen(release(a, exit), exit))));
// ----------------------------------------------------------------------------
// interruption
// ----------------------------------------------------------------------------
/**
 * Abort the current `Micro` effect.
 *
 * @since 3.4.6
 * @experimental
 * @category interruption
 */
const interrupt = /*#__PURE__*/(/* unused pure expression or super */ null && (failCause( /*#__PURE__*/causeInterrupt())));
/**
 * Flag the effect as uninterruptible, which means that when the effect is
 * interrupted, it will be allowed to continue running until completion.
 *
 * @since 3.4.0
 * @experimental
 * @category flags
 */
const uninterruptible = self => withMicroFiber(fiber => {
  if (!fiber.interruptible) return self;
  fiber.interruptible = false;
  fiber._stack.push(setInterruptible(true));
  return self;
});
const setInterruptible = /*#__PURE__*/makePrimitive({
  op: "SetInterruptible",
  ensure(fiber) {
    fiber.interruptible = this[args];
    if (fiber._interrupted && fiber.interruptible) {
      return () => exitInterrupt;
    }
  }
});
/**
 * Flag the effect as interruptible, which means that when the effect is
 * interrupted, it will be interrupted immediately.
 *
 * @since 3.4.0
 * @experimental
 * @category flags
 */
const interruptible = self => withMicroFiber(fiber => {
  if (fiber.interruptible) return self;
  fiber.interruptible = true;
  fiber._stack.push(setInterruptible(false));
  if (fiber._interrupted) return exitInterrupt;
  return self;
});
/**
 * Wrap the given `Micro` effect in an uninterruptible region, preventing the
 * effect from being aborted.
 *
 * You can use the `restore` function to restore a `Micro` effect to the
 * interruptibility state before the `uninterruptibleMask` was applied.
 *
 * @example
 * ```ts
 * import * as Micro from "effect/Micro"
 *
 * Micro.uninterruptibleMask((restore) =>
 *   Micro.sleep(1000).pipe( // uninterruptible
 *     Micro.andThen(restore(Micro.sleep(1000))) // interruptible
 *   )
 * )
 * ```
 *
 * @since 3.4.0
 * @experimental
 * @category interruption
 */
const uninterruptibleMask = f => withMicroFiber(fiber => {
  if (!fiber.interruptible) return f(Function/* identity */.yR);
  fiber.interruptible = false;
  fiber._stack.push(setInterruptible(true));
  return f(interruptible);
});
/**
 * Runs all the provided effects in sequence respecting the structure provided in input.
 *
 * Supports multiple arguments, a single argument tuple / array or record / struct.
 *
 * @since 3.4.0
 * @experimental
 * @category collecting & elements
 */
const Micro_all = (arg, options) => {
  if (Array.isArray(arg) || isIterable(arg)) {
    return forEach(arg, identity, options);
  } else if (options?.discard) {
    return forEach(Object.values(arg), identity, options);
  }
  return suspend(() => {
    const out = {};
    return as(forEach(Object.entries(arg), ([key, effect]) => map(effect, value => {
      out[key] = value;
    }), {
      discard: true,
      concurrency: options?.concurrency
    }), out);
  });
};
/**
 * @since 3.11.0
 * @experimental
 * @category collecting & elements
 */
const whileLoop = /*#__PURE__*/makePrimitive({
  op: "While",
  contA(value, fiber) {
    this[args].step(value);
    if (this[args].while()) {
      fiber._stack.push(this);
      return this[args].body();
    }
    return exitVoid;
  },
  eval(fiber) {
    if (this[args].while()) {
      fiber._stack.push(this);
      return this[args].body();
    }
    return exitVoid;
  }
});
/**
 * For each element of the provided iterable, run the effect and collect the
 * results.
 *
 * If the `discard` option is set to `true`, the results will be discarded and
 * the effect will return `void`.
 *
 * The `concurrency` option can be set to control how many effects are run
 * concurrently. By default, the effects are run sequentially.
 *
 * @since 3.4.0
 * @experimental
 * @category collecting & elements
 */
const forEach = (iterable, f, options) => withMicroFiber(parent => {
  const concurrencyOption = options?.concurrency === "inherit" ? parent.getRef(CurrentConcurrency) : options?.concurrency ?? 1;
  const concurrency = concurrencyOption === "unbounded" ? Number.POSITIVE_INFINITY : Math.max(1, concurrencyOption);
  const items = Arr.fromIterable(iterable);
  let length = items.length;
  if (length === 0) {
    return options?.discard ? void_ : succeed([]);
  }
  const out = options?.discard ? undefined : new Array(length);
  let index = 0;
  if (concurrency === 1) {
    return as(whileLoop({
      while: () => index < items.length,
      body: () => f(items[index], index),
      step: out ? b => out[index++] = b : _ => index++
    }), out);
  }
  return Micro_async(resume => {
    const fibers = new Set();
    let result = undefined;
    let inProgress = 0;
    let doneCount = 0;
    let pumping = false;
    let interrupted = false;
    function pump() {
      pumping = true;
      while (inProgress < concurrency && index < length) {
        const currentIndex = index;
        const item = items[currentIndex];
        index++;
        inProgress++;
        try {
          const child = unsafeFork(parent, f(item, currentIndex), true, true);
          fibers.add(child);
          child.addObserver(exit => {
            fibers.delete(child);
            if (interrupted) {
              return;
            } else if (exit._tag === "Failure") {
              if (result === undefined) {
                result = exit;
                length = index;
                fibers.forEach(fiber => fiber.unsafeInterrupt());
              }
            } else if (out !== undefined) {
              out[currentIndex] = exit.value;
            }
            doneCount++;
            inProgress--;
            if (doneCount === length) {
              resume(result ?? succeed(out));
            } else if (!pumping && inProgress < concurrency) {
              pump();
            }
          });
        } catch (err) {
          result = exitDie(err);
          length = index;
          fibers.forEach(fiber => fiber.unsafeInterrupt());
        }
      }
      pumping = false;
    }
    pump();
    return suspend(() => {
      interrupted = true;
      index = length;
      return fiberInterruptAll(fibers);
    });
  });
});
/**
 * Effectfully filter the elements of the provided iterable.
 *
 * Use the `concurrency` option to control how many elements are processed
 * concurrently.
 *
 * @since 3.4.0
 * @experimental
 * @category collecting & elements
 */
const filter = (iterable, f, options) => filterMap(iterable, a => map(f(a), pass => {
  pass = options?.negate ? !pass : pass;
  return pass ? Option.some(a) : Option.none();
}), options);
/**
 * Effectfully filter the elements of the provided iterable.
 *
 * Use the `concurrency` option to control how many elements are processed
 * concurrently.
 *
 * @since 3.4.0
 * @experimental
 * @category collecting & elements
 */
const filterMap = (iterable, f, options) => suspend(() => {
  const out = [];
  return as(forEach(iterable, a => map(f(a), o => {
    if (o._tag === "Some") {
      out.push(o.value);
    }
  }), {
    discard: true,
    concurrency: options?.concurrency
  }), out);
});
// ----------------------------------------------------------------------------
// do notation
// ----------------------------------------------------------------------------
/**
 * Start a do notation block.
 *
 * @since 3.4.0
 * @experimental
 * @category do notation
 */
const Do = /*#__PURE__*/succeed({});
/**
 * Bind the success value of this `Micro` effect to the provided name.
 *
 * @since 3.4.0
 * @experimental
 * @category do notation
 */
const bindTo = /*#__PURE__*/(/* unused pure expression or super */ null && (doNotation.bindTo(map)));
/**
 * Bind the success value of this `Micro` effect to the provided name.
 *
 * @since 3.4.0
 * @experimental
 * @category do notation
 */
const bind = /*#__PURE__*/(/* unused pure expression or super */ null && (doNotation.bind(map, flatMap)));
const let_ = /*#__PURE__*/(/* unused pure expression or super */ null && (doNotation.let_(map)));

// ----------------------------------------------------------------------------
// fibers & forking
// ----------------------------------------------------------------------------
/**
 * Run the `Micro` effect in a new `MicroFiber` that can be awaited, joined, or
 * aborted.
 *
 * When the parent `Micro` finishes, this `Micro` will be aborted.
 *
 * @since 3.4.0
 * @experimental
 * @category fiber & forking
 */
const fork = self => withMicroFiber(fiber => {
  fiberMiddleware.interruptChildren ??= fiberInterruptChildren;
  return succeed(unsafeFork(fiber, self));
});
const unsafeFork = (parent, effect, immediate = false, daemon = false) => {
  const child = new MicroFiberImpl(parent.context, parent.interruptible);
  if (!daemon) {
    parent.children().add(child);
    child.addObserver(() => parent.children().delete(child));
  }
  if (immediate) {
    child.evaluate(effect);
  } else {
    parent.getRef(CurrentScheduler).scheduleTask(() => child.evaluate(effect), 0);
  }
  return child;
};
/**
 * Run the `Micro` effect in a new `MicroFiber` that can be awaited, joined, or
 * aborted.
 *
 * It will not be aborted when the parent `Micro` finishes.
 *
 * @since 3.4.0
 * @experimental
 * @category fiber & forking
 */
const forkDaemon = self => withMicroFiber(fiber => succeed(unsafeFork(fiber, self, false, true)));
/**
 * Run the `Micro` effect in a new `MicroFiber` that can be awaited, joined, or
 * aborted.
 *
 * The lifetime of the handle will be attached to the provided `MicroScope`.
 *
 * @since 3.4.0
 * @experimental
 * @category fiber & forking
 */
const forkIn = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, scope) => uninterruptibleMask(restore => flatMap(scope.fork, scope => tap(restore(forkDaemon(onExit(self, exit => scope.close(exit)))), fiber => scope.addFinalizer(_ => fiberInterrupt(fiber))))))));
/**
 * Run the `Micro` effect in a new `MicroFiber` that can be awaited, joined, or
 * aborted.
 *
 * The lifetime of the handle will be attached to the current `MicroScope`.
 *
 * @since 3.4.0
 * @experimental
 * @category fiber & forking
 */
const forkScoped = self => flatMap(scope, scope => forkIn(self, scope));
// ----------------------------------------------------------------------------
// execution
// ----------------------------------------------------------------------------
/**
 * Execute the `Micro` effect and return a `MicroFiber` that can be awaited, joined,
 * or aborted.
 *
 * You can listen for the result by adding an observer using the handle's
 * `addObserver` method.
 *
 * @example
 * ```ts
 * import * as Micro from "effect/Micro"
 *
 * const handle = Micro.succeed(42).pipe(
 *   Micro.delay(1000),
 *   Micro.runFork
 * )
 *
 * handle.addObserver((exit) => {
 *   console.log(exit)
 * })
 * ```
 *
 * @since 3.4.0
 * @experimental
 * @category execution
 */
const runFork = (effect, options) => {
  const fiber = new MicroFiberImpl(CurrentScheduler.context(options?.scheduler ?? new MicroSchedulerDefault()));
  fiber.evaluate(effect);
  if (options?.signal) {
    if (options.signal.aborted) {
      fiber.unsafeInterrupt();
    } else {
      const abort = () => fiber.unsafeInterrupt();
      options.signal.addEventListener("abort", abort, {
        once: true
      });
      fiber.addObserver(() => options.signal.removeEventListener("abort", abort));
    }
  }
  return fiber;
};
/**
 * Execute the `Micro` effect and return a `Promise` that resolves with the
 * `MicroExit` of the computation.
 *
 * @since 3.4.6
 * @experimental
 * @category execution
 */
const runPromiseExit = (effect, options) => new Promise((resolve, _reject) => {
  const handle = runFork(effect, options);
  handle.addObserver(resolve);
});
/**
 * Execute the `Micro` effect and return a `Promise` that resolves with the
 * successful value of the computation.
 *
 * @since 3.4.0
 * @experimental
 * @category execution
 */
const runPromise = (effect, options) => runPromiseExit(effect, options).then(exit => {
  if (exit._tag === "Failure") {
    throw exit.cause;
  }
  return exit.value;
});
/**
 * Attempt to execute the `Micro` effect synchronously and return the `MicroExit`.
 *
 * If any asynchronous effects are encountered, the function will return a
 * `CauseDie` containing the `MicroFiber`.
 *
 * @since 3.4.6
 * @experimental
 * @category execution
 */
const runSyncExit = effect => {
  const scheduler = new MicroSchedulerDefault();
  const fiber = runFork(effect, {
    scheduler
  });
  scheduler.flush();
  return fiber._exit ?? exitDie(fiber);
};
/**
 * Attempt to execute the `Micro` effect synchronously and return the success
 * value.
 *
 * @since 3.4.0
 * @experimental
 * @category execution
 */
const runSync = effect => {
  const exit = runSyncExit(effect);
  if (exit._tag === "Failure") throw exit.cause;
  return exit.value;
};
const YieldableError = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  class YieldableError extends globalThis.Error {}
  Object.assign(YieldableError.prototype, MicroProto, StructuralPrototype, {
    [identifier]: "Failure",
    [evaluate]() {
      return fail(this);
    },
    toString() {
      return this.message ? `${this.name}: ${this.message}` : this.name;
    },
    toJSON() {
      return {
        ...this
      };
    },
    [NodeInspectSymbol]() {
      const stack = this.stack;
      if (stack) {
        return `${this.toString()}\n${stack.split("\n").slice(1).join("\n")}`;
      }
      return this.toString();
    }
  });
  return YieldableError;
}()));
/**
 * @since 3.4.0
 * @experimental
 * @category errors
 */
const Micro_Error = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  return class extends YieldableError {
    constructor(args) {
      super();
      if (args) {
        Object.assign(this, args);
      }
    }
  };
}()));
/**
 * @since 3.4.0
 * @experimental
 * @category errors
 */
const TaggedError = tag => {
  class Base extends Micro_Error {
    _tag = tag;
  }
  ;
  Base.prototype.name = tag;
  return Base;
};
/**
 * Represents a checked exception which occurs when an expected element was
 * unable to be found.
 *
 * @since 3.4.4
 * @experimental
 * @category errors
 */
class NoSuchElementException extends /*#__PURE__*/(/* unused pure expression or super */ null && (TaggedError("NoSuchElementException"))) {}
/**
 * Represents a checked exception which occurs when a timeout occurs.
 *
 * @since 3.4.4
 * @experimental
 * @category errors
 */
class TimeoutException extends /*#__PURE__*/(/* unused pure expression or super */ null && (TaggedError("TimeoutException"))) {}
//# sourceMappingURL=Micro.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/MutableRef.js
var MutableRef = __webpack_require__(23182);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var esm_Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Ref.js
var Ref = __webpack_require__(2532);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/RuntimeFlagsPatch.js
var RuntimeFlagsPatch = __webpack_require__(26045);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Scheduler.js
var Scheduler = __webpack_require__(22019);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/blockedRequests.js
var blockedRequests = __webpack_require__(96850);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/cause.js + 1 modules
var internal_cause = __webpack_require__(69579);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/clock.js
var clock = __webpack_require__(53318);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/completedRequestMap.js
var completedRequestMap = __webpack_require__(99609);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/core.js + 1 modules
var internal_core = __webpack_require__(39355);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/concurrency.js

/** @internal */
const concurrency_match = (concurrency, sequential, unbounded, bounded) => {
  switch (concurrency) {
    case undefined:
      return sequential();
    case "unbounded":
      return unbounded();
    case "inherit":
      return internal_core/* fiberRefGetWith */.$Dw(internal_core/* currentConcurrency */.vDZ, concurrency => concurrency === "unbounded" ? unbounded() : concurrency > 1 ? bounded(concurrency) : sequential());
    default:
      return concurrency > 1 ? bounded(concurrency) : sequential();
  }
};
/** @internal */
const matchSimple = (concurrency, sequential, concurrent) => {
  switch (concurrency) {
    case undefined:
      return sequential();
    case "unbounded":
      return concurrent();
    case "inherit":
      return internal_core/* fiberRefGetWith */.$Dw(internal_core/* currentConcurrency */.vDZ, concurrency => concurrency === "unbounded" || concurrency > 1 ? concurrent() : sequential());
    default:
      return concurrency > 1 ? concurrent() : sequential();
  }
};
//# sourceMappingURL=concurrency.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/configProvider.js + 4 modules
var configProvider = __webpack_require__(54604);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/core-effect.js + 3 modules
var core_effect = __webpack_require__(53623);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/defaultServices.js
var internal_defaultServices = __webpack_require__(74266);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/defaultServices/console.js
var defaultServices_console = __webpack_require__(2338);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/fiber.js
var internal_fiber = __webpack_require__(63914);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/fiberMessage.js
var fiberMessage = __webpack_require__(48282);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/fiberRefs.js
var internal_fiberRefs = __webpack_require__(79049);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/fiberScope.js
var fiberScope = __webpack_require__(51770);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/List.js
var esm_List = __webpack_require__(16104);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/fiberId.js
var internal_fiberId = __webpack_require__(26219);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/logSpan.js
var logSpan = __webpack_require__(96443);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/logger.js
/* provided dependency */ var process = __webpack_require__(83454);















/** @internal */
const LoggerSymbolKey = "effect/Logger";
/** @internal */
const LoggerTypeId = /*#__PURE__*/Symbol.for(LoggerSymbolKey);
const loggerVariance = {
  /* c8 ignore next */
  _Message: _ => _,
  /* c8 ignore next */
  _Output: _ => _
};
/** @internal */
const makeLogger = log => ({
  [LoggerTypeId]: loggerVariance,
  log,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
});
/** @internal */
const mapInput = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => makeLogger(options => self.log({
  ...options,
  message: f(options.message)
})))));
/** @internal */
const mapInputOptions = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => makeLogger(options => self.log(f(options))))));
/** @internal */
const filterLogLevel = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => makeLogger(options => f(options.logLevel) ? Option.some(self.log(options)) : Option.none()))));
/** @internal */
const logger_map = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => makeLogger(options => f(self.log(options))));
/** @internal */
const none = {
  [LoggerTypeId]: loggerVariance,
  log: Function/* constVoid */.Q1,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
};
/** @internal */
const simple = log => ({
  [LoggerTypeId]: loggerVariance,
  log: ({
    message
  }) => log(message),
  pipe() {
    return pipeArguments(this, arguments);
  }
});
/** @internal */
const logger_succeed = value => {
  return simple(() => value);
};
/** @internal */
const logger_sync = evaluate => {
  return simple(evaluate);
};
/** @internal */
const logger_zip = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => makeLogger(options => [self.log(options), that.log(options)]))));
/** @internal */
const zipLeft = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => logger_map(logger_zip(self, that), tuple => tuple[0]))));
/** @internal */
const zipRight = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => logger_map(logger_zip(self, that), tuple => tuple[1]))));
/**
 * Match strings that do not contain any whitespace characters, double quotes,
 * or equal signs.
 *
 * @internal
 */
const textOnly = /^[^\s"=]*$/;
/**
 * Used by both {@link stringLogger} and {@link logfmtLogger} to render a log
 * message.
 *
 * @internal
 */
const format = (quoteValue, whitespace) => ({
  annotations,
  cause,
  date,
  fiberId,
  logLevel,
  message,
  spans
}) => {
  const formatValue = value => value.match(textOnly) ? value : quoteValue(value);
  const format = (label, value) => `${logSpan/* formatLabel */.N4(label)}=${formatValue(value)}`;
  const append = (label, value) => " " + format(label, value);
  let out = format("timestamp", date.toISOString());
  out += append("level", logLevel.label);
  out += append("fiber", internal_fiberId/* threadName */.Q9(fiberId));
  const messages = esm_Array/* ensure */.zx(message);
  for (let i = 0; i < messages.length; i++) {
    out += append("message", esm_Inspectable/* toStringUnknown */.OY(messages[i], whitespace));
  }
  if (!internal_cause/* isEmptyType */.tg(cause)) {
    out += append("cause", internal_cause/* pretty */.IC(cause, {
      renderErrorCause: true
    }));
  }
  for (const span of spans) {
    out += " " + logSpan/* render */.sY(date.getTime())(span);
  }
  for (const [label, value] of annotations) {
    out += append(label, esm_Inspectable/* toStringUnknown */.OY(value, whitespace));
  }
  return out;
};
/** @internal */
const escapeDoubleQuotes = s => `"${s.replace(/\\([\s\S])|(")/g, "\\$1$2")}"`;
/** @internal */
const stringLogger = /*#__PURE__*/makeLogger( /*#__PURE__*/format(escapeDoubleQuotes));
/** @internal */
const logfmtLogger = /*#__PURE__*/makeLogger( /*#__PURE__*/format(JSON.stringify, 0));
/** @internal */
const structuredLogger = /*#__PURE__*/makeLogger(({
  annotations,
  cause,
  date,
  fiberId,
  logLevel,
  message,
  spans
}) => {
  const now = date.getTime();
  const annotationsObj = {};
  const spansObj = {};
  if (esm_HashMap/* size */.dp(annotations) > 0) {
    for (const [k, v] of annotations) {
      annotationsObj[k] = structuredMessage(v);
    }
  }
  if (esm_List/* isCons */.hg(spans)) {
    for (const span of spans) {
      spansObj[span.label] = now - span.startTime;
    }
  }
  const messageArr = esm_Array/* ensure */.zx(message);
  return {
    message: messageArr.length === 1 ? structuredMessage(messageArr[0]) : messageArr.map(structuredMessage),
    logLevel: logLevel.label,
    timestamp: date.toISOString(),
    cause: internal_cause/* isEmpty */.xb(cause) ? undefined : internal_cause/* pretty */.IC(cause, {
      renderErrorCause: true
    }),
    annotations: annotationsObj,
    spans: spansObj,
    fiberId: internal_fiberId/* threadName */.Q9(fiberId)
  };
});
/** @internal */
const structuredMessage = u => {
  switch (typeof u) {
    case "bigint":
    case "function":
    case "symbol":
      {
        return String(u);
      }
    default:
      {
        return esm_Inspectable/* toJSON */.au(u);
      }
  }
};
/** @internal */
const jsonLogger = /*#__PURE__*/logger_map(structuredLogger, esm_Inspectable/* stringifyCircular */.qk);
/** @internal */
const isLogger = u => {
  return typeof u === "object" && u != null && LoggerTypeId in u;
};
const withColor = (text, ...colors) => {
  let out = "";
  for (let i = 0; i < colors.length; i++) {
    out += `\x1b[${colors[i]}m`;
  }
  return out + text + "\x1b[0m";
};
const withColorNoop = (text, ..._colors) => text;
const colors = {
  bold: "1",
  red: "31",
  green: "32",
  yellow: "33",
  blue: "34",
  cyan: "36",
  white: "37",
  gray: "90",
  black: "30",
  bgBrightRed: "101"
};
const logLevelColors = {
  None: [],
  All: [],
  Trace: [colors.gray],
  Debug: [colors.blue],
  Info: [colors.green],
  Warning: [colors.yellow],
  Error: [colors.red],
  Fatal: [colors.bgBrightRed, colors.black]
};
const logLevelStyle = {
  None: "",
  All: "",
  Trace: "color:gray",
  Debug: "color:blue",
  Info: "color:green",
  Warning: "color:orange",
  Error: "color:red",
  Fatal: "background-color:red;color:white"
};
const defaultDateFormat = date => `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}.${date.getMilliseconds().toString().padStart(3, "0")}`;
const hasProcessStdout = typeof process === "object" && process !== null && typeof process.stdout === "object" && process.stdout !== null;
const processStdoutIsTTY = hasProcessStdout && process.stdout.isTTY === true;
const hasProcessStdoutOrDeno = hasProcessStdout || "Deno" in globalThis;
/** @internal */
const prettyLogger = options => {
  const mode_ = options?.mode ?? "auto";
  const mode = mode_ === "auto" ? hasProcessStdoutOrDeno ? "tty" : "browser" : mode_;
  const isBrowser = mode === "browser";
  const showColors = typeof options?.colors === "boolean" ? options.colors : processStdoutIsTTY || isBrowser;
  const formatDate = options?.formatDate ?? defaultDateFormat;
  return isBrowser ? prettyLoggerBrowser({
    colors: showColors,
    formatDate
  }) : prettyLoggerTty({
    colors: showColors,
    formatDate,
    stderr: options?.stderr === true
  });
};
const prettyLoggerTty = options => {
  const processIsBun = typeof process === "object" && "isBun" in process && process.isBun === true;
  const color = options.colors ? withColor : withColorNoop;
  return makeLogger(({
    annotations,
    cause,
    context,
    date,
    fiberId,
    logLevel,
    message: message_,
    spans
  }) => {
    const services = FiberRefs.getOrDefault(context, defaultServices.currentServices);
    const console = Context.get(services, consoleTag).unsafe;
    const log = options.stderr === true ? console.error : console.log;
    const message = Arr.ensure(message_);
    let firstLine = color(`[${options.formatDate(date)}]`, colors.white) + ` ${color(logLevel.label, ...logLevelColors[logLevel._tag])}` + ` (${fiberId_.threadName(fiberId)})`;
    if (List.isCons(spans)) {
      const now = date.getTime();
      const render = logSpan_.render(now);
      for (const span of spans) {
        firstLine += " " + render(span);
      }
    }
    firstLine += ":";
    let messageIndex = 0;
    if (message.length > 0) {
      const firstMaybeString = structuredMessage(message[0]);
      if (typeof firstMaybeString === "string") {
        firstLine += " " + color(firstMaybeString, colors.bold, colors.cyan);
        messageIndex++;
      }
    }
    log(firstLine);
    if (!processIsBun) console.group();
    if (!Cause.isEmpty(cause)) {
      log(Cause.pretty(cause, {
        renderErrorCause: true
      }));
    }
    if (messageIndex < message.length) {
      for (; messageIndex < message.length; messageIndex++) {
        log(Inspectable.redact(message[messageIndex]));
      }
    }
    if (HashMap.size(annotations) > 0) {
      for (const [key, value] of annotations) {
        log(color(`${key}:`, colors.bold, colors.white), Inspectable.redact(value));
      }
    }
    if (!processIsBun) console.groupEnd();
  });
};
const prettyLoggerBrowser = options => {
  const color = options.colors ? "%c" : "";
  return makeLogger(({
    annotations,
    cause,
    context,
    date,
    fiberId,
    logLevel,
    message: message_,
    spans
  }) => {
    const services = FiberRefs.getOrDefault(context, defaultServices.currentServices);
    const console = Context.get(services, consoleTag).unsafe;
    const message = Arr.ensure(message_);
    let firstLine = `${color}[${options.formatDate(date)}]`;
    const firstParams = [];
    if (options.colors) {
      firstParams.push("color:gray");
    }
    firstLine += ` ${color}${logLevel.label}${color} (${fiberId_.threadName(fiberId)})`;
    if (options.colors) {
      firstParams.push(logLevelStyle[logLevel._tag], "");
    }
    if (List.isCons(spans)) {
      const now = date.getTime();
      const render = logSpan_.render(now);
      for (const span of spans) {
        firstLine += " " + render(span);
      }
    }
    firstLine += ":";
    let messageIndex = 0;
    if (message.length > 0) {
      const firstMaybeString = structuredMessage(message[0]);
      if (typeof firstMaybeString === "string") {
        firstLine += ` ${color}${firstMaybeString}`;
        if (options.colors) {
          firstParams.push("color:deepskyblue");
        }
        messageIndex++;
      }
    }
    console.groupCollapsed(firstLine, ...firstParams);
    if (!Cause.isEmpty(cause)) {
      console.error(Cause.pretty(cause, {
        renderErrorCause: true
      }));
    }
    if (messageIndex < message.length) {
      for (; messageIndex < message.length; messageIndex++) {
        console.log(Inspectable.redact(message[messageIndex]));
      }
    }
    if (HashMap.size(annotations) > 0) {
      for (const [key, value] of annotations) {
        const redacted = Inspectable.redact(value);
        if (options.colors) {
          console.log(`%c${key}:`, "color:gray", redacted);
        } else {
          console.log(`${key}:`, redacted);
        }
      }
    }
    console.groupEnd();
  });
};
/** @internal */
const prettyLoggerDefault = /*#__PURE__*/(/* unused pure expression or super */ null && (globalValue("effect/Logger/prettyLoggerDefault", () => prettyLogger())));
//# sourceMappingURL=logger.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/metric/keyType.js






/** @internal */
const MetricKeyTypeSymbolKey = "effect/MetricKeyType";
/** @internal */
const MetricKeyTypeTypeId = /*#__PURE__*/Symbol.for(MetricKeyTypeSymbolKey);
/** @internal */
const CounterKeyTypeSymbolKey = "effect/MetricKeyType/Counter";
/** @internal */
const CounterKeyTypeTypeId = /*#__PURE__*/Symbol.for(CounterKeyTypeSymbolKey);
/** @internal */
const FrequencyKeyTypeSymbolKey = "effect/MetricKeyType/Frequency";
/** @internal */
const FrequencyKeyTypeTypeId = /*#__PURE__*/Symbol.for(FrequencyKeyTypeSymbolKey);
/** @internal */
const GaugeKeyTypeSymbolKey = "effect/MetricKeyType/Gauge";
/** @internal */
const GaugeKeyTypeTypeId = /*#__PURE__*/Symbol.for(GaugeKeyTypeSymbolKey);
/** @internal */
const HistogramKeyTypeSymbolKey = "effect/MetricKeyType/Histogram";
/** @internal */
const HistogramKeyTypeTypeId = /*#__PURE__*/Symbol.for(HistogramKeyTypeSymbolKey);
/** @internal */
const SummaryKeyTypeSymbolKey = "effect/MetricKeyType/Summary";
/** @internal */
const SummaryKeyTypeTypeId = /*#__PURE__*/Symbol.for(SummaryKeyTypeSymbolKey);
const metricKeyTypeVariance = {
  /* c8 ignore next */
  _In: _ => _,
  /* c8 ignore next */
  _Out: _ => _
};
/** @internal */
class CounterKeyType {
  incremental;
  bigint;
  [MetricKeyTypeTypeId] = metricKeyTypeVariance;
  [CounterKeyTypeTypeId] = CounterKeyTypeTypeId;
  constructor(incremental, bigint) {
    this.incremental = incremental;
    this.bigint = bigint;
    this._hash = esm_Hash/* string */.Z_(CounterKeyTypeSymbolKey);
  }
  _hash;
  [esm_Hash/* symbol */.NA]() {
    return this._hash;
  }
  [esm_Equal/* symbol */.NA](that) {
    return isCounterKey(that);
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
}
const FrequencyKeyTypeHash = /*#__PURE__*/(/* unused pure expression or super */ null && (Hash.string(FrequencyKeyTypeSymbolKey)));
/** @internal */
class FrequencyKeyType {
  preregisteredWords;
  [MetricKeyTypeTypeId] = metricKeyTypeVariance;
  [FrequencyKeyTypeTypeId] = FrequencyKeyTypeTypeId;
  constructor(preregisteredWords) {
    this.preregisteredWords = preregisteredWords;
  }
  [esm_Hash/* symbol */.NA]() {
    return FrequencyKeyTypeHash;
  }
  [esm_Equal/* symbol */.NA](that) {
    return isFrequencyKey(that);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}
const GaugeKeyTypeHash = /*#__PURE__*/(/* unused pure expression or super */ null && (Hash.string(GaugeKeyTypeSymbolKey)));
/** @internal */
class GaugeKeyType {
  bigint;
  [MetricKeyTypeTypeId] = metricKeyTypeVariance;
  [GaugeKeyTypeTypeId] = GaugeKeyTypeTypeId;
  constructor(bigint) {
    this.bigint = bigint;
  }
  [esm_Hash/* symbol */.NA]() {
    return GaugeKeyTypeHash;
  }
  [esm_Equal/* symbol */.NA](that) {
    return isGaugeKey(that);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}
/** @internal */
class HistogramKeyType {
  boundaries;
  [MetricKeyTypeTypeId] = metricKeyTypeVariance;
  [HistogramKeyTypeTypeId] = HistogramKeyTypeTypeId;
  constructor(boundaries) {
    this.boundaries = boundaries;
    this._hash = (0,Function/* pipe */.zG)(esm_Hash/* string */.Z_(HistogramKeyTypeSymbolKey), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.boundaries)));
  }
  _hash;
  [esm_Hash/* symbol */.NA]() {
    return this._hash;
  }
  [esm_Equal/* symbol */.NA](that) {
    return isHistogramKey(that) && esm_Equal/* equals */.fS(this.boundaries, that.boundaries);
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
}
/** @internal */
class SummaryKeyType {
  maxAge;
  maxSize;
  error;
  quantiles;
  [MetricKeyTypeTypeId] = metricKeyTypeVariance;
  [SummaryKeyTypeTypeId] = SummaryKeyTypeTypeId;
  constructor(maxAge, maxSize, error, quantiles) {
    this.maxAge = maxAge;
    this.maxSize = maxSize;
    this.error = error;
    this.quantiles = quantiles;
    this._hash = pipe(Hash.string(SummaryKeyTypeSymbolKey), Hash.combine(Hash.hash(this.maxAge)), Hash.combine(Hash.hash(this.maxSize)), Hash.combine(Hash.hash(this.error)), Hash.combine(Hash.array(this.quantiles)));
  }
  _hash;
  [esm_Hash/* symbol */.NA]() {
    return this._hash;
  }
  [esm_Equal/* symbol */.NA](that) {
    return isSummaryKey(that) && Equal.equals(this.maxAge, that.maxAge) && this.maxSize === that.maxSize && this.error === that.error && Equal.equals(this.quantiles, that.quantiles);
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
}
/** @internal */
const counter = options => new CounterKeyType(options?.incremental ?? false, options?.bigint ?? false);
/** @internal */
const frequency = options => new FrequencyKeyType(options?.preregisteredWords ?? []);
/** @internal */
const gauge = options => new GaugeKeyType(options?.bigint ?? false);
/** @internal */
const histogram = boundaries => {
  return new HistogramKeyType(boundaries);
};
/** @internal */
const summary = options => {
  return new SummaryKeyType(Duration.decode(options.maxAge), options.maxSize, options.error, options.quantiles);
};
/** @internal */
const isMetricKeyType = u => hasProperty(u, MetricKeyTypeTypeId);
/** @internal */
const isCounterKey = u => (0,Predicate/* hasProperty */.l$)(u, CounterKeyTypeTypeId);
/** @internal */
const isFrequencyKey = u => (0,Predicate/* hasProperty */.l$)(u, FrequencyKeyTypeTypeId);
/** @internal */
const isGaugeKey = u => (0,Predicate/* hasProperty */.l$)(u, GaugeKeyTypeTypeId);
/** @internal */
const isHistogramKey = u => (0,Predicate/* hasProperty */.l$)(u, HistogramKeyTypeTypeId);
/** @internal */
const isSummaryKey = u => (0,Predicate/* hasProperty */.l$)(u, SummaryKeyTypeTypeId);
//# sourceMappingURL=keyType.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/metric/key.js









/** @internal */
const MetricKeySymbolKey = "effect/MetricKey";
/** @internal */
const MetricKeyTypeId = /*#__PURE__*/Symbol.for(MetricKeySymbolKey);
const metricKeyVariance = {
  /* c8 ignore next */
  _Type: _ => _
};
const arrayEquivilence = /*#__PURE__*/esm_Array/* getEquivalence */.c5(esm_Equal/* equals */.fS);
/** @internal */
class MetricKeyImpl {
  name;
  keyType;
  description;
  tags;
  [MetricKeyTypeId] = metricKeyVariance;
  constructor(name, keyType, description, tags = []) {
    this.name = name;
    this.keyType = keyType;
    this.description = description;
    this.tags = tags;
    this._hash = (0,Function/* pipe */.zG)(esm_Hash/* string */.Z_(this.name + this.description), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.keyType)), esm_Hash/* combine */.$e(esm_Hash/* array */.IX(this.tags)));
  }
  _hash;
  [esm_Hash/* symbol */.NA]() {
    return this._hash;
  }
  [esm_Equal/* symbol */.NA](u) {
    return isMetricKey(u) && this.name === u.name && esm_Equal/* equals */.fS(this.keyType, u.keyType) && esm_Equal/* equals */.fS(this.description, u.description) && arrayEquivilence(this.tags, u.tags);
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
}
/** @internal */
const isMetricKey = u => (0,Predicate/* hasProperty */.l$)(u, MetricKeyTypeId);
/** @internal */
const key_counter = (name, options) => new MetricKeyImpl(name, counter(options), esm_Option/* fromNullable */.ij(options?.description));
/** @internal */
const key_frequency = (name, options) => new MetricKeyImpl(name, metricKeyType.frequency(options), Option.fromNullable(options?.description));
/** @internal */
const key_gauge = (name, options) => new MetricKeyImpl(name, metricKeyType.gauge(options), Option.fromNullable(options?.description));
/** @internal */
const key_histogram = (name, boundaries, description) => new MetricKeyImpl(name, histogram(boundaries), esm_Option/* fromNullable */.ij(description));
/** @internal */
const key_summary = options => new MetricKeyImpl(options.name, metricKeyType.summary(options), Option.fromNullable(options.description));
/** @internal */
const tagged = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, key, value) => taggedWithLabels(self, [metricLabel.make(key, value)]))));
/** @internal */
const taggedWithLabels = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, extraTags) => extraTags.length === 0 ? self : new MetricKeyImpl(self.name, self.keyType, self.description, esm_Array/* union */.G0(self.tags, extraTags)));
//# sourceMappingURL=key.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/metric/label.js
var label = __webpack_require__(36548);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/MutableHashMap.js
var MutableHashMap = __webpack_require__(30424);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Duration.js
var esm_Duration = __webpack_require__(13571);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Number.js
var esm_Number = __webpack_require__(15839);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/metric/state.js






/** @internal */
const MetricStateSymbolKey = "effect/MetricState";
/** @internal */
const MetricStateTypeId = /*#__PURE__*/Symbol.for(MetricStateSymbolKey);
/** @internal */
const CounterStateSymbolKey = "effect/MetricState/Counter";
/** @internal */
const CounterStateTypeId = /*#__PURE__*/Symbol.for(CounterStateSymbolKey);
/** @internal */
const FrequencyStateSymbolKey = "effect/MetricState/Frequency";
/** @internal */
const FrequencyStateTypeId = /*#__PURE__*/Symbol.for(FrequencyStateSymbolKey);
/** @internal */
const GaugeStateSymbolKey = "effect/MetricState/Gauge";
/** @internal */
const GaugeStateTypeId = /*#__PURE__*/Symbol.for(GaugeStateSymbolKey);
/** @internal */
const HistogramStateSymbolKey = "effect/MetricState/Histogram";
/** @internal */
const HistogramStateTypeId = /*#__PURE__*/Symbol.for(HistogramStateSymbolKey);
/** @internal */
const SummaryStateSymbolKey = "effect/MetricState/Summary";
/** @internal */
const SummaryStateTypeId = /*#__PURE__*/Symbol.for(SummaryStateSymbolKey);
const metricStateVariance = {
  /* c8 ignore next */
  _A: _ => _
};
/** @internal */
class CounterState {
  count;
  [MetricStateTypeId] = metricStateVariance;
  [CounterStateTypeId] = CounterStateTypeId;
  constructor(count) {
    this.count = count;
  }
  [esm_Hash/* symbol */.NA]() {
    return (0,Function/* pipe */.zG)(esm_Hash/* hash */.vp(CounterStateSymbolKey), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.count)), esm_Hash/* cached */.HX(this));
  }
  [esm_Equal/* symbol */.NA](that) {
    return isCounterState(that) && this.count === that.count;
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
}
const arrayEquals = /*#__PURE__*/esm_Array/* getEquivalence */.c5(esm_Equal/* equals */.fS);
/** @internal */
class FrequencyState {
  occurrences;
  [MetricStateTypeId] = metricStateVariance;
  [FrequencyStateTypeId] = FrequencyStateTypeId;
  constructor(occurrences) {
    this.occurrences = occurrences;
  }
  _hash;
  [esm_Hash/* symbol */.NA]() {
    return (0,Function/* pipe */.zG)(esm_Hash/* string */.Z_(FrequencyStateSymbolKey), esm_Hash/* combine */.$e(esm_Hash/* array */.IX(esm_Array/* fromIterable */.EE(this.occurrences.entries()))), esm_Hash/* cached */.HX(this));
  }
  [esm_Equal/* symbol */.NA](that) {
    return isFrequencyState(that) && arrayEquals(esm_Array/* fromIterable */.EE(this.occurrences.entries()), esm_Array/* fromIterable */.EE(that.occurrences.entries()));
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
}
/** @internal */
class GaugeState {
  value;
  [MetricStateTypeId] = metricStateVariance;
  [GaugeStateTypeId] = GaugeStateTypeId;
  constructor(value) {
    this.value = value;
  }
  [esm_Hash/* symbol */.NA]() {
    return (0,Function/* pipe */.zG)(esm_Hash/* hash */.vp(GaugeStateSymbolKey), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.value)), esm_Hash/* cached */.HX(this));
  }
  [esm_Equal/* symbol */.NA](u) {
    return isGaugeState(u) && this.value === u.value;
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
}
/** @internal */
class HistogramState {
  buckets;
  count;
  min;
  max;
  sum;
  [MetricStateTypeId] = metricStateVariance;
  [HistogramStateTypeId] = HistogramStateTypeId;
  constructor(buckets, count, min, max, sum) {
    this.buckets = buckets;
    this.count = count;
    this.min = min;
    this.max = max;
    this.sum = sum;
  }
  [esm_Hash/* symbol */.NA]() {
    return (0,Function/* pipe */.zG)(esm_Hash/* hash */.vp(HistogramStateSymbolKey), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.buckets)), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.count)), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.min)), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.max)), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.sum)), esm_Hash/* cached */.HX(this));
  }
  [esm_Equal/* symbol */.NA](that) {
    return isHistogramState(that) && esm_Equal/* equals */.fS(this.buckets, that.buckets) && this.count === that.count && this.min === that.min && this.max === that.max && this.sum === that.sum;
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
}
/** @internal */
class SummaryState {
  error;
  quantiles;
  count;
  min;
  max;
  sum;
  [MetricStateTypeId] = metricStateVariance;
  [SummaryStateTypeId] = SummaryStateTypeId;
  constructor(error, quantiles, count, min, max, sum) {
    this.error = error;
    this.quantiles = quantiles;
    this.count = count;
    this.min = min;
    this.max = max;
    this.sum = sum;
  }
  [esm_Hash/* symbol */.NA]() {
    return (0,Function/* pipe */.zG)(esm_Hash/* hash */.vp(SummaryStateSymbolKey), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.error)), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.quantiles)), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.count)), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.min)), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.max)), esm_Hash/* combine */.$e(esm_Hash/* hash */.vp(this.sum)), esm_Hash/* cached */.HX(this));
  }
  [esm_Equal/* symbol */.NA](that) {
    return isSummaryState(that) && this.error === that.error && esm_Equal/* equals */.fS(this.quantiles, that.quantiles) && this.count === that.count && this.min === that.min && this.max === that.max && this.sum === that.sum;
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
}
/** @internal */
const state_counter = count => new CounterState(count);
/** @internal */
const state_frequency = occurrences => {
  return new FrequencyState(occurrences);
};
/** @internal */
const state_gauge = count => new GaugeState(count);
/** @internal */
const state_histogram = options => new HistogramState(options.buckets, options.count, options.min, options.max, options.sum);
/** @internal */
const state_summary = options => new SummaryState(options.error, options.quantiles, options.count, options.min, options.max, options.sum);
/** @internal */
const isMetricState = u => hasProperty(u, MetricStateTypeId);
/** @internal */
const isCounterState = u => (0,Predicate/* hasProperty */.l$)(u, CounterStateTypeId);
/**
 * @since 2.0.0
 * @category refinements
 */
const isFrequencyState = u => (0,Predicate/* hasProperty */.l$)(u, FrequencyStateTypeId);
/**
 * @since 2.0.0
 * @category refinements
 */
const isGaugeState = u => (0,Predicate/* hasProperty */.l$)(u, GaugeStateTypeId);
/**
 * @since 2.0.0
 * @category refinements
 */
const isHistogramState = u => (0,Predicate/* hasProperty */.l$)(u, HistogramStateTypeId);
/**
 * @since 2.0.0
 * @category refinements
 */
const isSummaryState = u => (0,Predicate/* hasProperty */.l$)(u, SummaryStateTypeId);
//# sourceMappingURL=state.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/metric/hook.js







/** @internal */
const MetricHookSymbolKey = "effect/MetricHook";
/** @internal */
const MetricHookTypeId = /*#__PURE__*/Symbol.for(MetricHookSymbolKey);
const metricHookVariance = {
  /* c8 ignore next */
  _In: _ => _,
  /* c8 ignore next */
  _Out: _ => _
};
/** @internal */
const make = options => ({
  [MetricHookTypeId]: metricHookVariance,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  },
  ...options
});
/** @internal */
const onModify = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => ({
  [MetricHookTypeId]: metricHookVariance,
  pipe() {
    return pipeArguments(this, arguments);
  },
  get: self.get,
  update: self.update,
  modify: input => {
    self.modify(input);
    return f(input);
  }
}))));
/** @internal */
const onUpdate = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => ({
  [MetricHookTypeId]: metricHookVariance,
  pipe() {
    return pipeArguments(this, arguments);
  },
  get: self.get,
  update: input => {
    self.update(input);
    return f(input);
  },
  modify: self.modify
}))));
const bigint0 = /*#__PURE__*/BigInt(0);
/** @internal */
const hook_counter = key => {
  let sum = key.keyType.bigint ? bigint0 : 0;
  const canUpdate = key.keyType.incremental ? key.keyType.bigint ? value => value >= bigint0 : value => value >= 0 : _value => true;
  const update = value => {
    if (canUpdate(value)) {
      sum = sum + value;
    }
  };
  return make({
    get: () => state_counter(sum),
    update,
    modify: update
  });
};
/** @internal */
const hook_frequency = key => {
  const values = new Map();
  for (const word of key.keyType.preregisteredWords) {
    values.set(word, 0);
  }
  const update = word => {
    const slotCount = values.get(word) ?? 0;
    values.set(word, slotCount + 1);
  };
  return make({
    get: () => state_frequency(values),
    update,
    modify: update
  });
};
/** @internal */
const hook_gauge = (_key, startAt) => {
  let value = startAt;
  return make({
    get: () => state_gauge(value),
    update: v => {
      value = v;
    },
    modify: v => {
      value = value + v;
    }
  });
};
/** @internal */
const hook_histogram = key => {
  const bounds = key.keyType.boundaries.values;
  const size = bounds.length;
  const values = new Uint32Array(size + 1);
  const boundaries = new Float32Array(size);
  let count = 0;
  let sum = 0;
  let min = Number.MAX_VALUE;
  let max = Number.MIN_VALUE;
  (0,Function/* pipe */.zG)(bounds, esm_Array/* sort */.wx(esm_Number/* Order */.KM), esm_Array/* map */.UI((n, i) => {
    boundaries[i] = n;
  }));
  // Insert the value into the right bucket with a binary search
  const update = value => {
    let from = 0;
    let to = size;
    while (from !== to) {
      const mid = Math.floor(from + (to - from) / 2);
      const boundary = boundaries[mid];
      if (value <= boundary) {
        to = mid;
      } else {
        from = mid;
      }
      // The special case when to / from have a distance of one
      if (to === from + 1) {
        if (value <= boundaries[from]) {
          to = from;
        } else {
          from = to;
        }
      }
    }
    values[from] = values[from] + 1;
    count = count + 1;
    sum = sum + value;
    if (value < min) {
      min = value;
    }
    if (value > max) {
      max = value;
    }
  };
  const getBuckets = () => {
    const builder = esm_Array/* allocate */.TK(size);
    let cumulated = 0;
    for (let i = 0; i < size; i++) {
      const boundary = boundaries[i];
      const value = values[i];
      cumulated = cumulated + value;
      builder[i] = [boundary, cumulated];
    }
    return builder;
  };
  return make({
    get: () => state_histogram({
      buckets: getBuckets(),
      count,
      min,
      max,
      sum
    }),
    update,
    modify: update
  });
};
/** @internal */
const hook_summary = key => {
  const {
    error,
    maxAge,
    maxSize,
    quantiles
  } = key.keyType;
  const sortedQuantiles = (0,Function/* pipe */.zG)(quantiles, esm_Array/* sort */.wx(esm_Number/* Order */.KM));
  const values = esm_Array/* allocate */.TK(maxSize);
  let head = 0;
  let count = 0;
  let sum = 0;
  let min = Number.MAX_VALUE;
  let max = Number.MIN_VALUE;
  // Just before the snapshot we filter out all values older than maxAge
  const snapshot = now => {
    const builder = [];
    // If the buffer is not full yet it contains valid items at the 0..last
    // indices and null values at the rest of the positions.
    //
    // If the buffer is already full then all elements contains a valid
    // measurement with timestamp.
    //
    // At any given point in time we can enumerate all the non-null elements in
    // the buffer and filter them by timestamp to get a valid view of a time
    // window.
    //
    // The order does not matter because it gets sorted before passing to
    // `calculateQuantiles`.
    let i = 0;
    while (i !== maxSize - 1) {
      const item = values[i];
      if (item != null) {
        const [t, v] = item;
        const age = esm_Duration/* millis */.YX(now - t);
        if (esm_Duration/* greaterThanOrEqualTo */.wZ(age, esm_Duration/* zero */.bM) && esm_Duration/* lessThanOrEqualTo */.MK(age, maxAge)) {
          builder.push(v);
        }
      }
      i = i + 1;
    }
    return calculateQuantiles(error, sortedQuantiles, esm_Array/* sort */.wx(builder, esm_Number/* Order */.KM));
  };
  const observe = (value, timestamp) => {
    if (maxSize > 0) {
      head = head + 1;
      const target = head % maxSize;
      values[target] = [timestamp, value];
    }
    count = count + 1;
    sum = sum + value;
    if (value < min) {
      min = value;
    }
    if (value > max) {
      max = value;
    }
  };
  return make({
    get: () => state_summary({
      error,
      quantiles: snapshot(Date.now()),
      count,
      min,
      max,
      sum
    }),
    update: ([value, timestamp]) => observe(value, timestamp),
    modify: ([value, timestamp]) => observe(value, timestamp)
  });
};
/** @internal */
const calculateQuantiles = (error, sortedQuantiles, sortedSamples) => {
  // The number of samples examined
  const sampleCount = sortedSamples.length;
  if (!esm_Array/* isNonEmptyReadonlyArray */.Ux(sortedQuantiles)) {
    return esm_Array/* empty */.cS();
  }
  const head = sortedQuantiles[0];
  const tail = sortedQuantiles.slice(1);
  const resolvedHead = resolveQuantile(error, sampleCount, esm_Option/* none */.YP(), 0, head, sortedSamples);
  const resolved = esm_Array.of(resolvedHead);
  tail.forEach(quantile => {
    resolved.push(resolveQuantile(error, sampleCount, resolvedHead.value, resolvedHead.consumed, quantile, resolvedHead.rest));
  });
  return esm_Array/* map */.UI(resolved, rq => [rq.quantile, rq.value]);
};
/** @internal */
const resolveQuantile = (error, sampleCount, current, consumed, quantile, rest) => {
  let error_1 = error;
  let sampleCount_1 = sampleCount;
  let current_1 = current;
  let consumed_1 = consumed;
  let quantile_1 = quantile;
  let rest_1 = rest;
  let error_2 = error;
  let sampleCount_2 = sampleCount;
  let current_2 = current;
  let consumed_2 = consumed;
  let quantile_2 = quantile;
  let rest_2 = rest;
  // eslint-disable-next-line no-constant-condition
  while (1) {
    // If the remaining list of samples is empty, there is nothing more to resolve
    if (!esm_Array/* isNonEmptyReadonlyArray */.Ux(rest_1)) {
      return {
        quantile: quantile_1,
        value: esm_Option/* none */.YP(),
        consumed: consumed_1,
        rest: []
      };
    }
    // If the quantile is the 100% quantile, we can take the maximum of all the
    // remaining values as the result
    if (quantile_1 === 1) {
      return {
        quantile: quantile_1,
        value: esm_Option/* some */.G(esm_Array/* lastNonEmpty */.w4(rest_1)),
        consumed: consumed_1 + rest_1.length,
        rest: []
      };
    }
    // Split into two chunks - the first chunk contains all elements of the same
    // value as the chunk head
    const headValue = esm_Array/* headNonEmpty */.dK(rest_1); // Get head value since rest_1 is non-empty
    const sameHead = esm_Array/* span */.yP(rest_1, n => n === headValue);
    // How many elements do we want to accept for this quantile
    const desired = quantile_1 * sampleCount_1;
    // The error margin
    const allowedError = error_1 / 2 * desired;
    // Taking into account the elements consumed from the samples so far and the
    // number of same elements at the beginning of the chunk, calculate the number
    // of elements we would have if we selected the current head as result
    const candConsumed = consumed_1 + sameHead[0].length;
    const candError = Math.abs(candConsumed - desired);
    // If we haven't got enough elements yet, recurse
    if (candConsumed < desired - allowedError) {
      error_2 = error_1;
      sampleCount_2 = sampleCount_1;
      current_2 = esm_Array/* head */.YM(rest_1);
      consumed_2 = candConsumed;
      quantile_2 = quantile_1;
      rest_2 = sameHead[1];
      error_1 = error_2;
      sampleCount_1 = sampleCount_2;
      current_1 = current_2;
      consumed_1 = consumed_2;
      quantile_1 = quantile_2;
      rest_1 = rest_2;
      continue;
    }
    // If consuming this chunk leads to too many elements (rank is too high)
    if (candConsumed > desired + allowedError) {
      const valueToReturn = esm_Option/* isNone */.Wi(current_1) ? esm_Option/* some */.G(headValue) : current_1;
      return {
        quantile: quantile_1,
        value: valueToReturn,
        consumed: consumed_1,
        rest: rest_1
      };
    }
    // If we are in the target interval, select the current head and hand back the leftover after dropping all elements
    // from the sample chunk that are equal to the current head
    switch (current_1._tag) {
      case "None":
        {
          error_2 = error_1;
          sampleCount_2 = sampleCount_1;
          current_2 = esm_Array/* head */.YM(rest_1);
          consumed_2 = candConsumed;
          quantile_2 = quantile_1;
          rest_2 = sameHead[1];
          error_1 = error_2;
          sampleCount_1 = sampleCount_2;
          current_1 = current_2;
          consumed_1 = consumed_2;
          quantile_1 = quantile_2;
          rest_1 = rest_2;
          continue;
        }
      case "Some":
        {
          const prevError = Math.abs(desired - current_1.value);
          if (candError < prevError) {
            error_2 = error_1;
            sampleCount_2 = sampleCount_1;
            current_2 = esm_Array/* head */.YM(rest_1);
            consumed_2 = candConsumed;
            quantile_2 = quantile_1;
            rest_2 = sameHead[1];
            error_1 = error_2;
            sampleCount_1 = sampleCount_2;
            current_1 = current_2;
            consumed_1 = consumed_2;
            quantile_1 = quantile_2;
            rest_1 = rest_2;
            continue;
          }
          return {
            quantile: quantile_1,
            value: esm_Option/* some */.G(current_1.value),
            consumed: consumed_1,
            rest: rest_1
          };
        }
    }
  }
  throw new Error("BUG: MetricHook.resolveQuantiles - please report an issue at https://github.com/Effect-TS/effect/issues");
};
//# sourceMappingURL=hook.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/metric/pair.js

/** @internal */
const MetricPairSymbolKey = "effect/MetricPair";
/** @internal */
const MetricPairTypeId = /*#__PURE__*/Symbol.for(MetricPairSymbolKey);
const metricPairVariance = {
  /* c8 ignore next */
  _Type: _ => _
};
/** @internal */
const pair_make = (metricKey, metricState) => {
  return {
    [MetricPairTypeId]: metricPairVariance,
    metricKey,
    metricState,
    pipe() {
      return pipeArguments(this, arguments);
    }
  };
};
/** @internal */
const unsafeMake = (metricKey, metricState) => {
  return {
    [MetricPairTypeId]: metricPairVariance,
    metricKey,
    metricState,
    pipe() {
      return (0,Pipeable/* pipeArguments */.n)(this, arguments);
    }
  };
};
//# sourceMappingURL=pair.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/metric/registry.js






/** @internal */
const MetricRegistrySymbolKey = "effect/MetricRegistry";
/** @internal */
const MetricRegistryTypeId = /*#__PURE__*/Symbol.for(MetricRegistrySymbolKey);
/** @internal */
class MetricRegistryImpl {
  [MetricRegistryTypeId] = MetricRegistryTypeId;
  map = /*#__PURE__*/MutableHashMap/* empty */.cS();
  snapshot() {
    const result = [];
    for (const [key, hook] of this.map) {
      result.push(unsafeMake(key, hook.get()));
    }
    return result;
  }
  get(key) {
    const hook = (0,Function/* pipe */.zG)(this.map, MutableHashMap/* get */.U2(key), esm_Option/* getOrUndefined */.jD);
    if (hook == null) {
      if (isCounterKey(key.keyType)) {
        return this.getCounter(key);
      }
      if (isGaugeKey(key.keyType)) {
        return this.getGauge(key);
      }
      if (isFrequencyKey(key.keyType)) {
        return this.getFrequency(key);
      }
      if (isHistogramKey(key.keyType)) {
        return this.getHistogram(key);
      }
      if (isSummaryKey(key.keyType)) {
        return this.getSummary(key);
      }
      throw new Error("BUG: MetricRegistry.get - unknown MetricKeyType - please report an issue at https://github.com/Effect-TS/effect/issues");
    } else {
      return hook;
    }
  }
  getCounter(key) {
    let value = (0,Function/* pipe */.zG)(this.map, MutableHashMap/* get */.U2(key), esm_Option/* getOrUndefined */.jD);
    if (value == null) {
      const counter = hook_counter(key);
      if (!(0,Function/* pipe */.zG)(this.map, MutableHashMap/* has */.e$(key))) {
        (0,Function/* pipe */.zG)(this.map, MutableHashMap/* set */.t8(key, counter));
      }
      value = counter;
    }
    return value;
  }
  getFrequency(key) {
    let value = (0,Function/* pipe */.zG)(this.map, MutableHashMap/* get */.U2(key), esm_Option/* getOrUndefined */.jD);
    if (value == null) {
      const frequency = hook_frequency(key);
      if (!(0,Function/* pipe */.zG)(this.map, MutableHashMap/* has */.e$(key))) {
        (0,Function/* pipe */.zG)(this.map, MutableHashMap/* set */.t8(key, frequency));
      }
      value = frequency;
    }
    return value;
  }
  getGauge(key) {
    let value = (0,Function/* pipe */.zG)(this.map, MutableHashMap/* get */.U2(key), esm_Option/* getOrUndefined */.jD);
    if (value == null) {
      const gauge = hook_gauge(key, key.keyType.bigint ? BigInt(0) : 0);
      if (!(0,Function/* pipe */.zG)(this.map, MutableHashMap/* has */.e$(key))) {
        (0,Function/* pipe */.zG)(this.map, MutableHashMap/* set */.t8(key, gauge));
      }
      value = gauge;
    }
    return value;
  }
  getHistogram(key) {
    let value = (0,Function/* pipe */.zG)(this.map, MutableHashMap/* get */.U2(key), esm_Option/* getOrUndefined */.jD);
    if (value == null) {
      const histogram = hook_histogram(key);
      if (!(0,Function/* pipe */.zG)(this.map, MutableHashMap/* has */.e$(key))) {
        (0,Function/* pipe */.zG)(this.map, MutableHashMap/* set */.t8(key, histogram));
      }
      value = histogram;
    }
    return value;
  }
  getSummary(key) {
    let value = (0,Function/* pipe */.zG)(this.map, MutableHashMap/* get */.U2(key), esm_Option/* getOrUndefined */.jD);
    if (value == null) {
      const summary = hook_summary(key);
      if (!(0,Function/* pipe */.zG)(this.map, MutableHashMap/* has */.e$(key))) {
        (0,Function/* pipe */.zG)(this.map, MutableHashMap/* set */.t8(key, summary));
      }
      value = summary;
    }
    return value;
  }
}
/** @internal */
const registry_make = () => {
  return new MetricRegistryImpl();
};
//# sourceMappingURL=registry.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/metric.js














/** @internal */
const MetricSymbolKey = "effect/Metric";
/** @internal */
const MetricTypeId = /*#__PURE__*/Symbol.for(MetricSymbolKey);
const metricVariance = {
  /* c8 ignore next */
  _Type: _ => _,
  /* c8 ignore next */
  _In: _ => _,
  /* c8 ignore next */
  _Out: _ => _
};
/** @internal */
const globalMetricRegistry = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/Metric/globalMetricRegistry"), () => registry_make());
/** @internal */
const metric_make = function (keyType, unsafeUpdate, unsafeValue, unsafeModify) {
  const metric = Object.assign(effect => internal_core/* tap */.bwX(effect, a => update(metric, a)), {
    [MetricTypeId]: metricVariance,
    keyType,
    unsafeUpdate,
    unsafeValue,
    unsafeModify,
    register() {
      this.unsafeValue([]);
      return this;
    },
    pipe() {
      return (0,Pipeable/* pipeArguments */.n)(this, arguments);
    }
  });
  return metric;
};
/** @internal */
const metric_mapInput = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => metric_make(self.keyType, (input, extraTags) => self.unsafeUpdate(f(input), extraTags), self.unsafeValue, (input, extraTags) => self.unsafeModify(f(input), extraTags)))));
/** @internal */
const metric_counter = (name, options) => fromMetricKey(key_counter(name, options));
/** @internal */
const metric_frequency = (name, options) => fromMetricKey(metricKey.frequency(name, options));
/** @internal */
const withConstantInput = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, input) => metric_mapInput(self, () => input))));
/** @internal */
const fromMetricKey = key => {
  let untaggedHook;
  const hookCache = new WeakMap();
  const hook = extraTags => {
    if (extraTags.length === 0) {
      if (untaggedHook !== undefined) {
        return untaggedHook;
      }
      untaggedHook = globalMetricRegistry.get(key);
      return untaggedHook;
    }
    let hook = hookCache.get(extraTags);
    if (hook !== undefined) {
      return hook;
    }
    hook = globalMetricRegistry.get(taggedWithLabels(key, extraTags));
    hookCache.set(extraTags, hook);
    return hook;
  };
  return metric_make(key.keyType, (input, extraTags) => hook(extraTags).update(input), extraTags => hook(extraTags).get(), (input, extraTags) => hook(extraTags).modify(input));
};
/** @internal */
const metric_gauge = (name, options) => fromMetricKey(metricKey.gauge(name, options));
/** @internal */
const metric_histogram = (name, boundaries, description) => fromMetricKey(key_histogram(name, boundaries, description));
/* @internal */
const increment = self => metricKeyType.isCounterKey(self.keyType) ? update(self, self.keyType.bigint ? BigInt(1) : 1) : modify(self, self.keyType.bigint ? BigInt(1) : 1);
/* @internal */
const incrementBy = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, amount) => metricKeyType.isCounterKey(self.keyType) ? update(self, amount) : modify(self, amount))));
/** @internal */
const metric_map = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => metric_make(self.keyType, self.unsafeUpdate, extraTags => f(self.unsafeValue(extraTags)), self.unsafeModify))));
/** @internal */
const mapType = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => metric_make(f(self.keyType), self.unsafeUpdate, self.unsafeValue, self.unsafeModify))));
/** @internal */
const modify = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, input) => core.fiberRefGetWith(core.currentMetricLabels, tags => core.sync(() => self.unsafeModify(input, tags))))));
/* @internal */
const set = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, value) => update(self, value))));
/** @internal */
const metric_succeed = out => metric_make(void 0, constVoid, () => out, constVoid);
/** @internal */
const metric_sync = evaluate => metric_make(void 0, constVoid, evaluate, constVoid);
/** @internal */
const metric_summary = options => withNow(summaryTimestamp(options));
/** @internal */
const summaryTimestamp = options => fromMetricKey(metricKey.summary(options));
/** @internal */
const metric_tagged = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, key, value) => metric_taggedWithLabels(self, [label/* make */.Sy(key, value)]));
/** @internal */
const taggedWithLabelsInput = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => metric_map(metric_make(self.keyType, (input, extraTags) => self.unsafeUpdate(input, Arr.union(f(input), extraTags)), self.unsafeValue, (input, extraTags) => self.unsafeModify(input, Arr.union(f(input), extraTags))), constVoid))));
/** @internal */
const metric_taggedWithLabels = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, extraTags) => {
  return metric_make(self.keyType, (input, extraTags1) => self.unsafeUpdate(input, esm_Array/* union */.G0(extraTags, extraTags1)), extraTags1 => self.unsafeValue(esm_Array/* union */.G0(extraTags, extraTags1)), (input, extraTags1) => self.unsafeModify(input, esm_Array/* union */.G0(extraTags, extraTags1)));
});
/** @internal */
const timer = (name, description) => {
  const boundaries = metricBoundaries.exponential({
    start: 0.5,
    factor: 2,
    count: 35
  });
  const base = pipe(metric_histogram(name, boundaries, description), metric_tagged("time_unit", "milliseconds"));
  return metric_mapInput(base, Duration.toMillis);
};
/** @internal */
const timerWithBoundaries = (name, boundaries, description) => {
  const base = pipe(metric_histogram(name, metricBoundaries.fromIterable(boundaries), description), metric_tagged("time_unit", "milliseconds"));
  return metric_mapInput(base, Duration.toMillis);
};
/* @internal */
const trackAll = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, input) => effect => core.matchCauseEffect(effect, {
  onFailure: cause => core.zipRight(update(self, input), core.failCause(cause)),
  onSuccess: value => core.zipRight(update(self, input), core.succeed(value))
}))));
/* @internal */
const trackDefect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, metric) => trackDefectWith(self, metric, identity))));
/* @internal */
const trackDefectWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, metric, f) => {
  const updater = defect => update(metric, f(defect));
  return effect_.tapDefect(self, cause => core.forEachSequentialDiscard(Cause.defects(cause), updater));
})));
/* @internal */
const trackDuration = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, metric) => trackDurationWith(self, metric, identity))));
/* @internal */
const trackDurationWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, metric, f) => Clock.clockWith(clock => {
  const startTime = clock.unsafeCurrentTimeNanos();
  return core.tap(self, _ => {
    const endTime = clock.unsafeCurrentTimeNanos();
    const duration = Duration.nanos(endTime - startTime);
    return update(metric, f(duration));
  });
}))));
/* @internal */
const trackError = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, metric) => trackErrorWith(self, metric, a => a))));
/* @internal */
const trackErrorWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, metric, f) => {
  const updater = error => update(metric, f(error));
  return effect_.tapError(self, updater);
})));
/* @internal */
const trackSuccess = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, metric) => trackSuccessWith(self, metric, a => a))));
/* @internal */
const trackSuccessWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, metric, f) => {
  const updater = value => update(metric, f(value));
  return core.tap(self, updater);
})));
/* @internal */
const update = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, input) => internal_core/* fiberRefGetWith */.$Dw(internal_core/* currentMetricLabels */.VPq, tags => internal_core/* sync */.Z_X(() => self.unsafeUpdate(input, tags))));
/* @internal */
const value = self => core.fiberRefGetWith(core.currentMetricLabels, tags => core.sync(() => self.unsafeValue(tags)));
/** @internal */
const withNow = self => metric_mapInput(self, input => [input, Date.now()]);
/** @internal */
const metric_zip = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => metric_make([self.keyType, that.keyType], (input, extraTags) => {
  const [l, r] = input;
  self.unsafeUpdate(l, extraTags);
  that.unsafeUpdate(r, extraTags);
}, extraTags => [self.unsafeValue(extraTags), that.unsafeValue(extraTags)], (input, extraTags) => {
  const [l, r] = input;
  self.unsafeModify(l, extraTags);
  that.unsafeModify(r, extraTags);
}))));
/** @internal */
const unsafeSnapshot = () => globalMetricRegistry.snapshot();
/** @internal */
const snapshot = /*#__PURE__*/(/* unused pure expression or super */ null && (core.sync(unsafeSnapshot)));
//# sourceMappingURL=metric.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/metric/boundaries.js







/** @internal */
const MetricBoundariesSymbolKey = "effect/MetricBoundaries";
/** @internal */
const MetricBoundariesTypeId = /*#__PURE__*/Symbol.for(MetricBoundariesSymbolKey);
/** @internal */
class MetricBoundariesImpl {
  values;
  [MetricBoundariesTypeId] = MetricBoundariesTypeId;
  constructor(values) {
    this.values = values;
    this._hash = (0,Function/* pipe */.zG)(esm_Hash/* string */.Z_(MetricBoundariesSymbolKey), esm_Hash/* combine */.$e(esm_Hash/* array */.IX(this.values)));
  }
  _hash;
  [esm_Hash/* symbol */.NA]() {
    return this._hash;
  }
  [esm_Equal/* symbol */.NA](u) {
    return isMetricBoundaries(u) && esm_Equal/* equals */.fS(this.values, u.values);
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
}
/** @internal */
const isMetricBoundaries = u => (0,Predicate/* hasProperty */.l$)(u, MetricBoundariesTypeId);
/** @internal */
const fromIterable = iterable => {
  const values = (0,Function/* pipe */.zG)(iterable, esm_Array/* appendAll */.oq(esm_Chunk.of(Number.POSITIVE_INFINITY)), esm_Array/* dedupe */.D8);
  return new MetricBoundariesImpl(values);
};
/** @internal */
const linear = options => pipe(Arr.makeBy(options.count - 1, i => options.start + i * options.width), Chunk.unsafeFromArray, fromIterable);
/** @internal */
const exponential = options => (0,Function/* pipe */.zG)(esm_Array/* makeBy */.KB(options.count - 1, i => options.start * Math.pow(options.factor, i)), esm_Chunk/* unsafeFromArray */.JN, fromIterable);
//# sourceMappingURL=boundaries.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/opCodes/effect.js
var opCodes_effect = __webpack_require__(11713);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/random.js
var random = __webpack_require__(94023);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/request.js
var request = __webpack_require__(82913);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/runtimeFlags.js
var internal_runtimeFlags = __webpack_require__(4536);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/supervisor.js
var supervisor = __webpack_require__(34357);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/differ.js
var differ = __webpack_require__(49398);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/differ/chunkPatch.js
var chunkPatch = __webpack_require__(79862);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/differ/contextPatch.js
var contextPatch = __webpack_require__(53621);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/differ/hashMapPatch.js
var hashMapPatch = __webpack_require__(34937);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/differ/hashSetPatch.js
var hashSetPatch = __webpack_require__(27074);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/differ/orPatch.js
var orPatch = __webpack_require__(42702);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/differ/readonlyArrayPatch.js
var readonlyArrayPatch = __webpack_require__(49451);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/Differ.js








/**
 * @since 2.0.0
 * @category symbol
 */
const Differ_TypeId = differ/* DifferTypeId */.M0;
const ChunkPatchTypeId = chunkPatch/* ChunkPatchTypeId */.Lg;
const ContextPatchTypeId = contextPatch/* ContextPatchTypeId */.gy;
const HashMapPatchTypeId = hashMapPatch/* HashMapPatchTypeId */.xH;
const HashSetPatchTypeId = hashSetPatch/* HashSetPatchTypeId */.vv;
const OrPatchTypeId = orPatch/* OrPatchTypeId */._e;
const ReadonlyArrayPatchTypeId = readonlyArrayPatch/* ReadonlyArrayPatchTypeId */.Nb;
/**
 * An empty patch that describes no changes.
 *
 * @since 2.0.0
 * @category patch
 */
const empty = self => self.empty;
/**
 * @since 2.0.0
 * @category patch
 */
const diff = /*#__PURE__*/(/* unused pure expression or super */ null && (Dual.dual(3, (self, oldValue, newValue) => self.diff(oldValue, newValue))));
/**
 * Combines two patches to produce a new patch that describes the updates of
 * the first patch and then the updates of the second patch. The combine
 * operation should be associative. In addition, if the combine operation is
 * commutative then joining multiple fibers concurrently will result in
 * deterministic `FiberRef` values.
 *
 * @since 2.0.0
 * @category patch
 */
const combine = /*#__PURE__*/(/* unused pure expression or super */ null && (Dual.dual(3, (self, first, second) => self.combine(first, second))));
/**
 * Applies a patch to an old value to produce a new value that is equal to the
 * old value with the updates described by the patch.
 *
 * @since 2.0.0
 * @category patch
 */
const patch = /*#__PURE__*/(/* unused pure expression or super */ null && (Dual.dual(3, (self, patch, oldValue) => self.patch(patch, oldValue))));
/**
 * Constructs a new `Differ`.
 *
 * @since 2.0.0
 * @category constructors
 */
const Differ_make = differ/* make */.Sy;
/**
 * Constructs a differ that knows how to diff `Env` values.
 *
 * @since 2.0.0
 * @category constructors
 */
const environment = differ/* environment */.NZ;
/**
 * Constructs a differ that knows how to diff a `Chunk` of values given a
 * differ that knows how to diff the values.
 *
 * @since 2.0.0
 * @category constructors
 */
const chunk = differ/* chunk */.yo;
/**
 * Constructs a differ that knows how to diff a `HashMap` of keys and values given
 * a differ that knows how to diff the values.
 *
 * @since 2.0.0
 * @category constructors
 */
const hashMap = differ/* hashMap */.ar;
/**
 * Constructs a differ that knows how to diff a `HashSet` of values.
 *
 * @since 2.0.0
 * @category constructors
 */
const hashSet = differ/* hashSet */.OS;
/**
 * Combines this differ and the specified differ to produce a differ that
 * knows how to diff the sum of their values.
 *
 * @since 2.0.0
 */
const orElseEither = differ/* orElseEither */.O0;
/**
 * Constructs a differ that knows how to diff a `ReadonlyArray` of values.
 *
 * @since 2.0.0
 * @category constructors
 */
const readonlyArray = differ/* readonlyArray */.Bk;
/**
 * Transforms the type of values that this differ knows how to differ using
 * the specified functions that map the new and old value types to each other.
 *
 * @since 2.0.0
 */
const transform = differ/* transform */.vs;
/**
 * Constructs a differ that just diffs two values by returning a function that
 * sets the value to the new value. This differ does not support combining
 * multiple updates to the value compositionally and should only be used when
 * there is no compositional way to update them.
 *
 * @since 2.0.0
 */
const Differ_update = differ/* update */.Vx;
/**
 * A variant of `update` that allows specifying the function that will be used
 * to combine old values with new values.
 *
 * @since 2.0.0
 */
const updateWith = differ/* updateWith */.ok;
/**
 * Combines this differ and the specified differ to produce a new differ that
 * knows how to diff the product of their values.
 *
 * @since 2.0.0
 */
const Differ_zip = differ/* zip */.$R;
//# sourceMappingURL=Differ.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/supervisor/patch.js






/** @internal */
const OP_EMPTY = "Empty";
/** @internal */
const OP_ADD_SUPERVISOR = "AddSupervisor";
/** @internal */
const OP_REMOVE_SUPERVISOR = "RemoveSupervisor";
/** @internal */
const OP_AND_THEN = "AndThen";
/**
 * The empty `SupervisorPatch`.
 *
 * @internal
 */
const patch_empty = {
  _tag: OP_EMPTY
};
/**
 * Combines two patches to produce a new patch that describes applying the
 * updates from this patch and then the updates from the specified patch.
 *
 * @internal
 */
const patch_combine = (self, that) => {
  return {
    _tag: OP_AND_THEN,
    first: self,
    second: that
  };
};
/**
 * Applies a `SupervisorPatch` to a `Supervisor` to produce a new `Supervisor`.
 *
 * @internal
 */
const patch_patch = (self, supervisor) => {
  return patchLoop(supervisor, esm_Chunk.of(self));
};
/** @internal */
const patchLoop = (_supervisor, _patches) => {
  let supervisor = _supervisor;
  let patches = _patches;
  while (esm_Chunk/* isNonEmpty */.Od(patches)) {
    const head = esm_Chunk/* headNonEmpty */.dK(patches);
    switch (head._tag) {
      case OP_EMPTY:
        {
          patches = esm_Chunk/* tailNonEmpty */.fm(patches);
          break;
        }
      case OP_ADD_SUPERVISOR:
        {
          supervisor = supervisor.zip(head.supervisor);
          patches = esm_Chunk/* tailNonEmpty */.fm(patches);
          break;
        }
      case OP_REMOVE_SUPERVISOR:
        {
          supervisor = removeSupervisor(supervisor, head.supervisor);
          patches = esm_Chunk/* tailNonEmpty */.fm(patches);
          break;
        }
      case OP_AND_THEN:
        {
          patches = esm_Chunk/* prepend */.Ce(head.first)(esm_Chunk/* prepend */.Ce(head.second)(esm_Chunk/* tailNonEmpty */.fm(patches)));
          break;
        }
    }
  }
  return supervisor;
};
/** @internal */
const removeSupervisor = (self, that) => {
  if (esm_Equal/* equals */.fS(self, that)) {
    return supervisor/* none */.YP;
  } else {
    if (supervisor/* isZip */.Xc(self)) {
      return removeSupervisor(self.left, that).zip(removeSupervisor(self.right, that));
    } else {
      return self;
    }
  }
};
/** @internal */
const toSet = self => {
  if (esm_Equal/* equals */.fS(self, supervisor/* none */.YP)) {
    return HashSet/* empty */.cS();
  } else {
    if (supervisor/* isZip */.Xc(self)) {
      return (0,Function/* pipe */.zG)(toSet(self.left), HashSet/* union */.G0(toSet(self.right)));
    } else {
      return HashSet/* make */.Sy(self);
    }
  }
};
/** @internal */
const patch_diff = (oldValue, newValue) => {
  if (esm_Equal/* equals */.fS(oldValue, newValue)) {
    return patch_empty;
  }
  const oldSupervisors = toSet(oldValue);
  const newSupervisors = toSet(newValue);
  const added = (0,Function/* pipe */.zG)(newSupervisors, HashSet/* difference */.e5(oldSupervisors), HashSet/* reduce */.u4(patch_empty, (patch, supervisor) => patch_combine(patch, {
    _tag: OP_ADD_SUPERVISOR,
    supervisor
  })));
  const removed = (0,Function/* pipe */.zG)(oldSupervisors, HashSet/* difference */.e5(newSupervisors), HashSet/* reduce */.u4(patch_empty, (patch, supervisor) => patch_combine(patch, {
    _tag: OP_REMOVE_SUPERVISOR,
    supervisor
  })));
  return patch_combine(added, removed);
};
/** @internal */
const patch_differ = /*#__PURE__*/Differ_make({
  empty: patch_empty,
  patch: patch_patch,
  combine: patch_combine,
  diff: patch_diff
});
//# sourceMappingURL=patch.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/tracer.js
var internal_tracer = __webpack_require__(10434);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/version.js
var version = __webpack_require__(69500);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/fiberRuntime.js






















































/** @internal */
const fiberStarted = /*#__PURE__*/metric_counter("effect_fiber_started", {
  incremental: true
});
/** @internal */
const fiberActive = /*#__PURE__*/metric_counter("effect_fiber_active");
/** @internal */
const fiberSuccesses = /*#__PURE__*/metric_counter("effect_fiber_successes", {
  incremental: true
});
/** @internal */
const fiberFailures = /*#__PURE__*/metric_counter("effect_fiber_failures", {
  incremental: true
});
/** @internal */
const fiberLifetimes = /*#__PURE__*/metric_tagged( /*#__PURE__*/metric_histogram("effect_fiber_lifetimes", /*#__PURE__*/exponential({
  start: 0.5,
  factor: 2,
  count: 35
})), "time_unit", "milliseconds");
/** @internal */
const EvaluationSignalContinue = "Continue";
/** @internal */
const EvaluationSignalDone = "Done";
/** @internal */
const EvaluationSignalYieldNow = "Yield";
const runtimeFiberVariance = {
  /* c8 ignore next */
  _E: _ => _,
  /* c8 ignore next */
  _A: _ => _
};
const absurd = _ => {
  throw new Error(`BUG: FiberRuntime - ${esm_Inspectable/* toStringUnknown */.OY(_)} - please report an issue at https://github.com/Effect-TS/effect/issues`);
};
const YieldedOp = /*#__PURE__*/Symbol.for("effect/internal/fiberRuntime/YieldedOp");
const yieldedOpChannel = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)("effect/internal/fiberRuntime/yieldedOpChannel", () => ({
  currentOp: null
}));
const contOpSuccess = {
  [opCodes_effect/* OP_ON_SUCCESS */.rm]: (_, cont, value) => {
    return (0,Utils/* internalCall */.MS)(() => cont.effect_instruction_i1(value));
  },
  ["OnStep"]: (_, _cont, value) => {
    return internal_core/* exitSucceed */.SID(internal_core/* exitSucceed */.SID(value));
  },
  [opCodes_effect/* OP_ON_SUCCESS_AND_FAILURE */.kf]: (_, cont, value) => {
    return (0,Utils/* internalCall */.MS)(() => cont.effect_instruction_i2(value));
  },
  [opCodes_effect/* OP_REVERT_FLAGS */.JX]: (self, cont, value) => {
    self.patchRuntimeFlags(self.currentRuntimeFlags, cont.patch);
    if (internal_runtimeFlags/* interruptible */.um(self.currentRuntimeFlags) && self.isInterrupted()) {
      return internal_core/* exitFailCause */.KiG(self.getInterruptedCause());
    } else {
      return internal_core/* exitSucceed */.SID(value);
    }
  },
  [opCodes_effect/* OP_WHILE */.Pv]: (self, cont, value) => {
    (0,Utils/* internalCall */.MS)(() => cont.effect_instruction_i2(value));
    if ((0,Utils/* internalCall */.MS)(() => cont.effect_instruction_i0())) {
      self.pushStack(cont);
      return (0,Utils/* internalCall */.MS)(() => cont.effect_instruction_i1());
    } else {
      return internal_core/* void */.Hcj;
    }
  },
  [opCodes_effect/* OP_ITERATOR */.Rm]: (self, cont, value) => {
    const state = (0,Utils/* internalCall */.MS)(() => cont.effect_instruction_i0.next(value));
    if (state.done) return internal_core/* exitSucceed */.SID(state.value);
    self.pushStack(cont);
    return (0,Utils/* yieldWrapGet */.Rz)(state.value);
  }
};
const drainQueueWhileRunningTable = {
  [fiberMessage/* OP_INTERRUPT_SIGNAL */.ng]: (self, runtimeFlags, cur, message) => {
    self.processNewInterruptSignal(message.cause);
    return internal_runtimeFlags/* interruptible */.um(runtimeFlags) ? internal_core/* exitFailCause */.KiG(message.cause) : cur;
  },
  [fiberMessage/* OP_RESUME */.AW]: (_self, _runtimeFlags, _cur, _message) => {
    throw new Error("It is illegal to have multiple concurrent run loops in a single fiber");
  },
  [fiberMessage/* OP_STATEFUL */.kp]: (self, runtimeFlags, cur, message) => {
    message.onFiber(self, FiberStatus/* running */.wC(runtimeFlags));
    return cur;
  },
  [fiberMessage/* OP_YIELD_NOW */.Df]: (_self, _runtimeFlags, cur, _message) => {
    return internal_core/* flatMap */.VSD(internal_core/* yieldNow */.T4Q(), () => cur);
  }
};
/**
 * Executes all requests, submitting requests to each data source in parallel.
 */
const runBlockedRequests = self => internal_core/* forEachSequentialDiscard */.EaP(blockedRequests/* flatten */.xH(self), requestsByRequestResolver => forEachConcurrentDiscard(blockedRequests/* sequentialCollectionToChunk */.U(requestsByRequestResolver), ([dataSource, sequential]) => {
  const map = new Map();
  const arr = [];
  for (const block of sequential) {
    arr.push(esm_Chunk/* toReadonlyArray */.AO(block));
    for (const entry of block) {
      map.set(entry.request, entry);
    }
  }
  const flat = arr.flat();
  return internal_core/* fiberRefLocally */.EXC(invokeWithInterrupt(dataSource.runAll(arr), flat, () => flat.forEach(entry => {
    entry.listeners.interrupted = true;
  })), completedRequestMap/* currentRequestMap */.d, map);
}, false, false));
const _version = /*#__PURE__*/version/* getCurrentVersion */.w();
/** @internal */
class FiberRuntime extends Effectable/* Class */.wT {
  [internal_fiber/* FiberTypeId */.tP] = internal_fiber/* fiberVariance */.kD;
  [internal_fiber/* RuntimeFiberTypeId */.Zq] = runtimeFiberVariance;
  _fiberRefs;
  _fiberId;
  _queue = /*#__PURE__*/new Array();
  _children = null;
  _observers = /*#__PURE__*/new Array();
  _running = false;
  _stack = [];
  _asyncInterruptor = null;
  _asyncBlockingOn = null;
  _exitValue = null;
  _steps = [];
  _isYielding = false;
  currentRuntimeFlags;
  currentOpCount = 0;
  currentSupervisor;
  currentScheduler;
  currentTracer;
  currentSpan;
  currentContext;
  currentDefaultServices;
  constructor(fiberId, fiberRefs0, runtimeFlags0) {
    super();
    this.currentRuntimeFlags = runtimeFlags0;
    this._fiberId = fiberId;
    this._fiberRefs = fiberRefs0;
    if (internal_runtimeFlags/* runtimeMetrics */.LA(runtimeFlags0)) {
      const tags = this.getFiberRef(internal_core/* currentMetricLabels */.VPq);
      fiberStarted.unsafeUpdate(1, tags);
      fiberActive.unsafeUpdate(1, tags);
    }
    this.refreshRefCache();
  }
  commit() {
    return internal_fiber/* join */.v_(this);
  }
  /**
   * The identity of the fiber.
   */
  id() {
    return this._fiberId;
  }
  /**
   * Begins execution of the effect associated with this fiber on in the
   * background. This can be called to "kick off" execution of a fiber after
   * it has been created.
   */
  resume(effect) {
    this.tell(fiberMessage/* resume */.v4(effect));
  }
  /**
   * The status of the fiber.
   */
  get status() {
    return this.ask((_, status) => status);
  }
  /**
   * Gets the fiber runtime flags.
   */
  get runtimeFlags() {
    return this.ask((state, status) => {
      if (FiberStatus/* isDone */._b(status)) {
        return state.currentRuntimeFlags;
      }
      return status.runtimeFlags;
    });
  }
  /**
   * Returns the current `FiberScope` for the fiber.
   */
  scope() {
    return fiberScope/* unsafeMake */.t0(this);
  }
  /**
   * Retrieves the immediate children of the fiber.
   */
  get children() {
    return this.ask(fiber => Array.from(fiber.getChildren()));
  }
  /**
   * Gets the fiber's set of children.
   */
  getChildren() {
    if (this._children === null) {
      this._children = new Set();
    }
    return this._children;
  }
  /**
   * Retrieves the interrupted cause of the fiber, which will be `Cause.empty`
   * if the fiber has not been interrupted.
   *
   * **NOTE**: This method is safe to invoke on any fiber, but if not invoked
   * on this fiber, then values derived from the fiber's state (including the
   * log annotations and log level) may not be up-to-date.
   */
  getInterruptedCause() {
    return this.getFiberRef(internal_core/* currentInterruptedCause */.LFL);
  }
  /**
   * Retrieves the whole set of fiber refs.
   */
  fiberRefs() {
    return this.ask(fiber => fiber.getFiberRefs());
  }
  /**
   * Returns an effect that will contain information computed from the fiber
   * state and status while running on the fiber.
   *
   * This allows the outside world to interact safely with mutable fiber state
   * without locks or immutable data.
   */
  ask(f) {
    return internal_core/* suspend */.RqG(() => {
      const deferred = internal_core/* deferredUnsafeMake */.OJ4(this._fiberId);
      this.tell(fiberMessage/* stateful */.dQ((fiber, status) => {
        internal_core/* deferredUnsafeDone */.zxF(deferred, internal_core/* sync */.Z_X(() => f(fiber, status)));
      }));
      return internal_core/* deferredAwait */.Odg(deferred);
    });
  }
  /**
   * Adds a message to be processed by the fiber on the fiber.
   */
  tell(message) {
    this._queue.push(message);
    if (!this._running) {
      this._running = true;
      this.drainQueueLaterOnExecutor();
    }
  }
  get await() {
    return internal_core/* async */.PFx(resume => {
      const cb = exit => resume(internal_core/* succeed */.ng0(exit));
      this.tell(fiberMessage/* stateful */.dQ((fiber, _) => {
        if (fiber._exitValue !== null) {
          cb(this._exitValue);
        } else {
          fiber.addObserver(cb);
        }
      }));
      return internal_core/* sync */.Z_X(() => this.tell(fiberMessage/* stateful */.dQ((fiber, _) => {
        fiber.removeObserver(cb);
      })));
    }, this.id());
  }
  get inheritAll() {
    return internal_core/* withFiberRuntime */.ECC((parentFiber, parentStatus) => {
      const parentFiberId = parentFiber.id();
      const parentFiberRefs = parentFiber.getFiberRefs();
      const parentRuntimeFlags = parentStatus.runtimeFlags;
      const childFiberRefs = this.getFiberRefs();
      const updatedFiberRefs = internal_fiberRefs/* joinAs */.Ao(parentFiberRefs, parentFiberId, childFiberRefs);
      parentFiber.setFiberRefs(updatedFiberRefs);
      const updatedRuntimeFlags = parentFiber.getFiberRef(currentRuntimeFlags);
      const patch = (0,Function/* pipe */.zG)(internal_runtimeFlags/* diff */.Hg(parentRuntimeFlags, updatedRuntimeFlags),
      // Do not inherit WindDown or Interruption!
      RuntimeFlagsPatch/* exclude */.De(internal_runtimeFlags/* Interruption */.tm), RuntimeFlagsPatch/* exclude */.De(internal_runtimeFlags/* WindDown */.st));
      return internal_core/* updateRuntimeFlags */.$Cr(patch);
    });
  }
  /**
   * Tentatively observes the fiber, but returns immediately if it is not
   * already done.
   */
  get poll() {
    return internal_core/* sync */.Z_X(() => esm_Option/* fromNullable */.ij(this._exitValue));
  }
  /**
   * Unsafely observes the fiber, but returns immediately if it is not
   * already done.
   */
  unsafePoll() {
    return this._exitValue;
  }
  /**
   * In the background, interrupts the fiber as if interrupted from the specified fiber.
   */
  interruptAsFork(fiberId) {
    return internal_core/* sync */.Z_X(() => this.tell(fiberMessage/* interruptSignal */.fk(internal_cause/* interrupt */.e1(fiberId))));
  }
  /**
   * In the background, interrupts the fiber as if interrupted from the specified fiber.
   */
  unsafeInterruptAsFork(fiberId) {
    this.tell(fiberMessage/* interruptSignal */.fk(internal_cause/* interrupt */.e1(fiberId)));
  }
  /**
   * Adds an observer to the list of observers.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  addObserver(observer) {
    if (this._exitValue !== null) {
      observer(this._exitValue);
    } else {
      this._observers.push(observer);
    }
  }
  /**
   * Removes the specified observer from the list of observers that will be
   * notified when the fiber exits.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  removeObserver(observer) {
    this._observers = this._observers.filter(o => o !== observer);
  }
  /**
   * Retrieves all fiber refs of the fiber.
   *
   * **NOTE**: This method is safe to invoke on any fiber, but if not invoked
   * on this fiber, then values derived from the fiber's state (including the
   * log annotations and log level) may not be up-to-date.
   */
  getFiberRefs() {
    this.setFiberRef(currentRuntimeFlags, this.currentRuntimeFlags);
    return this._fiberRefs;
  }
  /**
   * Deletes the specified fiber ref.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  unsafeDeleteFiberRef(fiberRef) {
    this._fiberRefs = internal_fiberRefs/* delete_ */.$v(this._fiberRefs, fiberRef);
  }
  /**
   * Retrieves the state of the fiber ref, or else its initial value.
   *
   * **NOTE**: This method is safe to invoke on any fiber, but if not invoked
   * on this fiber, then values derived from the fiber's state (including the
   * log annotations and log level) may not be up-to-date.
   */
  getFiberRef(fiberRef) {
    if (this._fiberRefs.locals.has(fiberRef)) {
      return this._fiberRefs.locals.get(fiberRef)[0][1];
    }
    return fiberRef.initial;
  }
  /**
   * Sets the fiber ref to the specified value.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  setFiberRef(fiberRef, value) {
    this._fiberRefs = internal_fiberRefs/* updateAs */.SJ(this._fiberRefs, {
      fiberId: this._fiberId,
      fiberRef,
      value
    });
    this.refreshRefCache();
  }
  refreshRefCache() {
    this.currentDefaultServices = this.getFiberRef(internal_defaultServices/* currentServices */.Pm);
    this.currentTracer = this.currentDefaultServices.unsafeMap.get(internal_tracer/* tracerTag.key */.Fl.key);
    this.currentSupervisor = this.getFiberRef(currentSupervisor);
    this.currentScheduler = this.getFiberRef(Scheduler/* currentScheduler */.xt);
    this.currentContext = this.getFiberRef(internal_core/* currentContext */.gbX);
    this.currentSpan = this.currentContext.unsafeMap.get(internal_tracer/* spanTag.key */.N7.key);
  }
  /**
   * Wholesale replaces all fiber refs of this fiber.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  setFiberRefs(fiberRefs) {
    this._fiberRefs = fiberRefs;
    this.refreshRefCache();
  }
  /**
   * Adds a reference to the specified fiber inside the children set.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  addChild(child) {
    this.getChildren().add(child);
  }
  /**
   * Removes a reference to the specified fiber inside the children set.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  removeChild(child) {
    this.getChildren().delete(child);
  }
  /**
   * Transfers all children of this fiber that are currently running to the
   * specified fiber scope.
   *
   * **NOTE**: This method must be invoked by the fiber itself after it has
   * evaluated the effects but prior to exiting.
   */
  transferChildren(scope) {
    const children = this._children;
    // Clear the children of the current fiber
    this._children = null;
    if (children !== null && children.size > 0) {
      for (const child of children) {
        // If the child is still running, add it to the scope
        if (child._exitValue === null) {
          scope.add(this.currentRuntimeFlags, child);
        }
      }
    }
  }
  /**
   * On the current thread, executes all messages in the fiber's inbox. This
   * method may return before all work is done, in the event the fiber executes
   * an asynchronous operation.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  drainQueueOnCurrentThread() {
    let recurse = true;
    while (recurse) {
      let evaluationSignal = EvaluationSignalContinue;
      const prev = globalThis[internal_fiber/* currentFiberURI */.nv];
      globalThis[internal_fiber/* currentFiberURI */.nv] = this;
      try {
        while (evaluationSignal === EvaluationSignalContinue) {
          evaluationSignal = this._queue.length === 0 ? EvaluationSignalDone : this.evaluateMessageWhileSuspended(this._queue.splice(0, 1)[0]);
        }
      } finally {
        this._running = false;
        globalThis[internal_fiber/* currentFiberURI */.nv] = prev;
      }
      // Maybe someone added something to the queue between us checking, and us
      // giving up the drain. If so, we need to restart the draining, but only
      // if we beat everyone else to the restart:
      if (this._queue.length > 0 && !this._running) {
        this._running = true;
        if (evaluationSignal === EvaluationSignalYieldNow) {
          this.drainQueueLaterOnExecutor();
          recurse = false;
        } else {
          recurse = true;
        }
      } else {
        recurse = false;
      }
    }
  }
  /**
   * Schedules the execution of all messages in the fiber's inbox.
   *
   * This method will return immediately after the scheduling
   * operation is completed, but potentially before such messages have been
   * executed.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  drainQueueLaterOnExecutor() {
    this.currentScheduler.scheduleTask(this.run, this.getFiberRef(internal_core/* currentSchedulingPriority */.opO));
  }
  /**
   * Drains the fiber's message queue while the fiber is actively running,
   * returning the next effect to execute, which may be the input effect if no
   * additional effect needs to be executed.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  drainQueueWhileRunning(runtimeFlags, cur0) {
    let cur = cur0;
    while (this._queue.length > 0) {
      const message = this._queue.splice(0, 1)[0];
      // @ts-expect-error
      cur = drainQueueWhileRunningTable[message._tag](this, runtimeFlags, cur, message);
    }
    return cur;
  }
  /**
   * Determines if the fiber is interrupted.
   *
   * **NOTE**: This method is safe to invoke on any fiber, but if not invoked
   * on this fiber, then values derived from the fiber's state (including the
   * log annotations and log level) may not be up-to-date.
   */
  isInterrupted() {
    return !internal_cause/* isEmpty */.xb(this.getFiberRef(internal_core/* currentInterruptedCause */.LFL));
  }
  /**
   * Adds an interruptor to the set of interruptors that are interrupting this
   * fiber.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  addInterruptedCause(cause) {
    const oldSC = this.getFiberRef(internal_core/* currentInterruptedCause */.LFL);
    this.setFiberRef(internal_core/* currentInterruptedCause */.LFL, internal_cause/* sequential */.Pe(oldSC, cause));
  }
  /**
   * Processes a new incoming interrupt signal.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  processNewInterruptSignal(cause) {
    this.addInterruptedCause(cause);
    this.sendInterruptSignalToAllChildren();
  }
  /**
   * Interrupts all children of the current fiber, returning an effect that will
   * await the exit of the children. This method will return null if the fiber
   * has no children.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  sendInterruptSignalToAllChildren() {
    if (this._children === null || this._children.size === 0) {
      return false;
    }
    let told = false;
    for (const child of this._children) {
      child.tell(fiberMessage/* interruptSignal */.fk(internal_cause/* interrupt */.e1(this.id())));
      told = true;
    }
    return told;
  }
  /**
   * Interrupts all children of the current fiber, returning an effect that will
   * await the exit of the children. This method will return null if the fiber
   * has no children.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  interruptAllChildren() {
    if (this.sendInterruptSignalToAllChildren()) {
      const it = this._children.values();
      this._children = null;
      let isDone = false;
      const body = () => {
        const next = it.next();
        if (!next.done) {
          return internal_core/* asVoid */.a2S(next.value.await);
        } else {
          return internal_core/* sync */.Z_X(() => {
            isDone = true;
          });
        }
      };
      return internal_core/* whileLoop */.Hib({
        while: () => !isDone,
        body,
        step: () => {
          //
        }
      });
    }
    return null;
  }
  reportExitValue(exit) {
    if (internal_runtimeFlags/* runtimeMetrics */.LA(this.currentRuntimeFlags)) {
      const tags = this.getFiberRef(internal_core/* currentMetricLabels */.VPq);
      const startTimeMillis = this.id().startTimeMillis;
      const endTimeMillis = Date.now();
      fiberLifetimes.unsafeUpdate(endTimeMillis - startTimeMillis, tags);
      fiberActive.unsafeUpdate(-1, tags);
      switch (exit._tag) {
        case opCodes_effect/* OP_SUCCESS */.x$:
          {
            fiberSuccesses.unsafeUpdate(1, tags);
            break;
          }
        case opCodes_effect/* OP_FAILURE */.N4:
          {
            fiberFailures.unsafeUpdate(1, tags);
            break;
          }
      }
    }
    if (exit._tag === "Failure") {
      const level = this.getFiberRef(internal_core/* currentUnhandledErrorLogLevel */.tDY);
      if (!internal_cause/* isInterruptedOnly */.Jq(exit.cause) && level._tag === "Some") {
        this.log("Fiber terminated with an unhandled error", exit.cause, level);
      }
    }
  }
  setExitValue(exit) {
    this._exitValue = exit;
    this.reportExitValue(exit);
    for (let i = this._observers.length - 1; i >= 0; i--) {
      this._observers[i](exit);
    }
    this._observers = [];
  }
  getLoggers() {
    return this.getFiberRef(currentLoggers);
  }
  log(message, cause, overrideLogLevel) {
    const logLevel = esm_Option/* isSome */.pC(overrideLogLevel) ? overrideLogLevel.value : this.getFiberRef(internal_core/* currentLogLevel */.E0T);
    const minimumLogLevel = this.getFiberRef(currentMinimumLogLevel);
    if (LogLevel/* greaterThan */.tS(minimumLogLevel, logLevel)) {
      return;
    }
    const spans = this.getFiberRef(internal_core/* currentLogSpan */.yVv);
    const annotations = this.getFiberRef(internal_core/* currentLogAnnotations */.cMe);
    const loggers = this.getLoggers();
    const contextMap = this.getFiberRefs();
    if (HashSet/* size */.dp(loggers) > 0) {
      const clockService = esm_Context/* get */.U2(this.getFiberRef(internal_defaultServices/* currentServices */.Pm), clock/* clockTag */.GL);
      const date = new Date(clockService.unsafeCurrentTimeMillis());
      esm_Inspectable/* withRedactableContext */.qU(contextMap, () => {
        for (const logger of loggers) {
          logger.log({
            fiberId: this.id(),
            logLevel,
            message,
            cause,
            context: contextMap,
            spans,
            annotations,
            date
          });
        }
      });
    }
  }
  /**
   * Evaluates a single message on the current thread, while the fiber is
   * suspended. This method should only be called while evaluation of the
   * fiber's effect is suspended due to an asynchronous operation.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  evaluateMessageWhileSuspended(message) {
    switch (message._tag) {
      case fiberMessage/* OP_YIELD_NOW */.Df:
        {
          return EvaluationSignalYieldNow;
        }
      case fiberMessage/* OP_INTERRUPT_SIGNAL */.ng:
        {
          this.processNewInterruptSignal(message.cause);
          if (this._asyncInterruptor !== null) {
            this._asyncInterruptor(internal_core/* exitFailCause */.KiG(message.cause));
            this._asyncInterruptor = null;
          }
          return EvaluationSignalContinue;
        }
      case fiberMessage/* OP_RESUME */.AW:
        {
          this._asyncInterruptor = null;
          this._asyncBlockingOn = null;
          this.evaluateEffect(message.effect);
          return EvaluationSignalContinue;
        }
      case fiberMessage/* OP_STATEFUL */.kp:
        {
          message.onFiber(this, this._exitValue !== null ? FiberStatus/* done */.aT : FiberStatus/* suspended */.rv(this.currentRuntimeFlags, this._asyncBlockingOn));
          return EvaluationSignalContinue;
        }
      default:
        {
          return absurd(message);
        }
    }
  }
  /**
   * Evaluates an effect until completion, potentially asynchronously.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  evaluateEffect(effect0) {
    this.currentSupervisor.onResume(this);
    try {
      let effect = internal_runtimeFlags/* interruptible */.um(this.currentRuntimeFlags) && this.isInterrupted() ? internal_core/* exitFailCause */.KiG(this.getInterruptedCause()) : effect0;
      while (effect !== null) {
        const eff = effect;
        const exit = this.runLoop(eff);
        if (exit === YieldedOp) {
          const op = yieldedOpChannel.currentOp;
          yieldedOpChannel.currentOp = null;
          if (op._op === opCodes_effect/* OP_YIELD */.gl) {
            if (internal_runtimeFlags/* cooperativeYielding */.dY(this.currentRuntimeFlags)) {
              this.tell(fiberMessage/* yieldNow */.T4());
              this.tell(fiberMessage/* resume */.v4(internal_core/* exitVoid */.E7$));
              effect = null;
            } else {
              effect = internal_core/* exitVoid */.E7$;
            }
          } else if (op._op === opCodes_effect/* OP_ASYNC */.m7) {
            // Terminate this evaluation, async resumption will continue evaluation:
            effect = null;
          }
        } else {
          this.currentRuntimeFlags = (0,Function/* pipe */.zG)(this.currentRuntimeFlags, internal_runtimeFlags/* enable */.wp(internal_runtimeFlags/* WindDown */.st));
          const interruption = this.interruptAllChildren();
          if (interruption !== null) {
            effect = internal_core/* flatMap */.VSD(interruption, () => exit);
          } else {
            if (this._queue.length === 0) {
              // No more messages to process, so we will allow the fiber to end life:
              this.setExitValue(exit);
            } else {
              // There are messages, possibly added by the final op executed by
              // the fiber. To be safe, we should execute those now before we
              // allow the fiber to end life:
              this.tell(fiberMessage/* resume */.v4(exit));
            }
            effect = null;
          }
        }
      }
    } finally {
      this.currentSupervisor.onSuspend(this);
    }
  }
  /**
   * Begins execution of the effect associated with this fiber on the current
   * thread. This can be called to "kick off" execution of a fiber after it has
   * been created, in hopes that the effect can be executed synchronously.
   *
   * This is not the normal way of starting a fiber, but it is useful when the
   * express goal of executing the fiber is to synchronously produce its exit.
   */
  start(effect) {
    if (!this._running) {
      this._running = true;
      const prev = globalThis[internal_fiber/* currentFiberURI */.nv];
      globalThis[internal_fiber/* currentFiberURI */.nv] = this;
      try {
        this.evaluateEffect(effect);
      } finally {
        this._running = false;
        globalThis[internal_fiber/* currentFiberURI */.nv] = prev;
        // Because we're special casing `start`, we have to be responsible
        // for spinning up the fiber if there were new messages added to
        // the queue between the completion of the effect and the transition
        // to the not running state.
        if (this._queue.length > 0) {
          this.drainQueueLaterOnExecutor();
        }
      }
    } else {
      this.tell(fiberMessage/* resume */.v4(effect));
    }
  }
  /**
   * Begins execution of the effect associated with this fiber on in the
   * background, and on the correct thread pool. This can be called to "kick
   * off" execution of a fiber after it has been created, in hopes that the
   * effect can be executed synchronously.
   */
  startFork(effect) {
    this.tell(fiberMessage/* resume */.v4(effect));
  }
  /**
   * Takes the current runtime flags, patches them to return the new runtime
   * flags, and then makes any changes necessary to fiber state based on the
   * specified patch.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  patchRuntimeFlags(oldRuntimeFlags, patch) {
    const newRuntimeFlags = internal_runtimeFlags/* patch */.r$(oldRuntimeFlags, patch);
    globalThis[internal_fiber/* currentFiberURI */.nv] = this;
    this.currentRuntimeFlags = newRuntimeFlags;
    return newRuntimeFlags;
  }
  /**
   * Initiates an asynchronous operation, by building a callback that will
   * resume execution, and then feeding that callback to the registration
   * function, handling error cases and repeated resumptions appropriately.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  initiateAsync(runtimeFlags, asyncRegister) {
    let alreadyCalled = false;
    const callback = effect => {
      if (!alreadyCalled) {
        alreadyCalled = true;
        this.tell(fiberMessage/* resume */.v4(effect));
      }
    };
    if (internal_runtimeFlags/* interruptible */.um(runtimeFlags)) {
      this._asyncInterruptor = callback;
    }
    try {
      asyncRegister(callback);
    } catch (e) {
      callback(internal_core/* failCause */.DhG(internal_cause/* die */.Xr(e)));
    }
  }
  pushStack(cont) {
    this._stack.push(cont);
    if (cont._op === "OnStep") {
      this._steps.push({
        refs: this.getFiberRefs(),
        flags: this.currentRuntimeFlags
      });
    }
  }
  popStack() {
    const item = this._stack.pop();
    if (item) {
      if (item._op === "OnStep") {
        this._steps.pop();
      }
      return item;
    }
    return;
  }
  getNextSuccessCont() {
    let frame = this.popStack();
    while (frame) {
      if (frame._op !== opCodes_effect/* OP_ON_FAILURE */.PF) {
        return frame;
      }
      frame = this.popStack();
    }
  }
  getNextFailCont() {
    let frame = this.popStack();
    while (frame) {
      if (frame._op !== opCodes_effect/* OP_ON_SUCCESS */.rm && frame._op !== opCodes_effect/* OP_WHILE */.Pv && frame._op !== opCodes_effect/* OP_ITERATOR */.Rm) {
        return frame;
      }
      frame = this.popStack();
    }
  }
  [opCodes_effect/* OP_TAG */.LU](op) {
    return internal_core/* sync */.Z_X(() => esm_Context/* unsafeGet */.MH(this.currentContext, op));
  }
  ["Left"](op) {
    return internal_core/* fail */.bGj(op.left);
  }
  ["None"](_) {
    return internal_core/* fail */.bGj(new internal_core/* NoSuchElementException */.buj());
  }
  ["Right"](op) {
    return internal_core/* exitSucceed */.SID(op.right);
  }
  ["Some"](op) {
    return internal_core/* exitSucceed */.SID(op.value);
  }
  ["Micro"](op) {
    return internal_core/* unsafeAsync */._OG(microResume => {
      let resume = microResume;
      const fiber = runFork(provideContext(op, this.currentContext));
      fiber.addObserver(exit => {
        if (exit._tag === "Success") {
          return resume(internal_core/* exitSucceed */.SID(exit.value));
        }
        switch (exit.cause._tag) {
          case "Interrupt":
            {
              return resume(internal_core/* exitFailCause */.KiG(internal_cause/* interrupt */.e1(FiberId/* none */.YP)));
            }
          case "Fail":
            {
              return resume(internal_core/* fail */.bGj(exit.cause.error));
            }
          case "Die":
            {
              return resume(internal_core/* die */.Xre(exit.cause.defect));
            }
        }
      });
      return internal_core/* unsafeAsync */._OG(abortResume => {
        resume = _ => {
          abortResume(internal_core/* void */.Hcj);
        };
        fiber.unsafeInterrupt();
      });
    });
  }
  [opCodes_effect/* OP_SYNC */.Q0](op) {
    const value = (0,Utils/* internalCall */.MS)(() => op.effect_instruction_i0());
    const cont = this.getNextSuccessCont();
    if (cont !== undefined) {
      if (!(cont._op in contOpSuccess)) {
        // @ts-expect-error
        absurd(cont);
      }
      // @ts-expect-error
      return contOpSuccess[cont._op](this, cont, value);
    } else {
      yieldedOpChannel.currentOp = internal_core/* exitSucceed */.SID(value);
      return YieldedOp;
    }
  }
  [opCodes_effect/* OP_SUCCESS */.x$](op) {
    const oldCur = op;
    const cont = this.getNextSuccessCont();
    if (cont !== undefined) {
      if (!(cont._op in contOpSuccess)) {
        // @ts-expect-error
        absurd(cont);
      }
      // @ts-expect-error
      return contOpSuccess[cont._op](this, cont, oldCur.effect_instruction_i0);
    } else {
      yieldedOpChannel.currentOp = oldCur;
      return YieldedOp;
    }
  }
  [opCodes_effect/* OP_FAILURE */.N4](op) {
    const cause = op.effect_instruction_i0;
    const cont = this.getNextFailCont();
    if (cont !== undefined) {
      switch (cont._op) {
        case opCodes_effect/* OP_ON_FAILURE */.PF:
        case opCodes_effect/* OP_ON_SUCCESS_AND_FAILURE */.kf:
          {
            if (!(internal_runtimeFlags/* interruptible */.um(this.currentRuntimeFlags) && this.isInterrupted())) {
              return (0,Utils/* internalCall */.MS)(() => cont.effect_instruction_i1(cause));
            } else {
              return internal_core/* exitFailCause */.KiG(internal_cause/* stripFailures */.ly(cause));
            }
          }
        case "OnStep":
          {
            if (!(internal_runtimeFlags/* interruptible */.um(this.currentRuntimeFlags) && this.isInterrupted())) {
              return internal_core/* exitSucceed */.SID(internal_core/* exitFailCause */.KiG(cause));
            } else {
              return internal_core/* exitFailCause */.KiG(internal_cause/* stripFailures */.ly(cause));
            }
          }
        case opCodes_effect/* OP_REVERT_FLAGS */.JX:
          {
            this.patchRuntimeFlags(this.currentRuntimeFlags, cont.patch);
            if (internal_runtimeFlags/* interruptible */.um(this.currentRuntimeFlags) && this.isInterrupted()) {
              return internal_core/* exitFailCause */.KiG(internal_cause/* sequential */.Pe(cause, this.getInterruptedCause()));
            } else {
              return internal_core/* exitFailCause */.KiG(cause);
            }
          }
        default:
          {
            absurd(cont);
          }
      }
    } else {
      yieldedOpChannel.currentOp = internal_core/* exitFailCause */.KiG(cause);
      return YieldedOp;
    }
  }
  [opCodes_effect/* OP_WITH_RUNTIME */.EV](op) {
    return (0,Utils/* internalCall */.MS)(() => op.effect_instruction_i0(this, FiberStatus/* running */.wC(this.currentRuntimeFlags)));
  }
  ["Blocked"](op) {
    const refs = this.getFiberRefs();
    const flags = this.currentRuntimeFlags;
    if (this._steps.length > 0) {
      const frames = [];
      const snap = this._steps[this._steps.length - 1];
      let frame = this.popStack();
      while (frame && frame._op !== "OnStep") {
        frames.push(frame);
        frame = this.popStack();
      }
      this.setFiberRefs(snap.refs);
      this.currentRuntimeFlags = snap.flags;
      const patchRefs = FiberRefsPatch/* diff */.Hg(snap.refs, refs);
      const patchFlags = internal_runtimeFlags/* diff */.Hg(snap.flags, flags);
      return internal_core/* exitSucceed */.SID(internal_core/* blocked */.IN$(op.effect_instruction_i0, internal_core/* withFiberRuntime */.ECC(newFiber => {
        while (frames.length > 0) {
          newFiber.pushStack(frames.pop());
        }
        newFiber.setFiberRefs(FiberRefsPatch/* patch */.r$(newFiber.id(), newFiber.getFiberRefs())(patchRefs));
        newFiber.currentRuntimeFlags = internal_runtimeFlags/* patch */.r$(patchFlags)(newFiber.currentRuntimeFlags);
        return op.effect_instruction_i1;
      })));
    }
    return internal_core/* uninterruptibleMask */.UO$(restore => internal_core/* flatMap */.VSD(fiberRuntime_forkDaemon(internal_core/* runRequestBlock */.f6m(op.effect_instruction_i0)), () => restore(op.effect_instruction_i1)));
  }
  ["RunBlocked"](op) {
    return runBlockedRequests(op.effect_instruction_i0);
  }
  [opCodes_effect/* OP_UPDATE_RUNTIME_FLAGS */.rk](op) {
    const updateFlags = op.effect_instruction_i0;
    const oldRuntimeFlags = this.currentRuntimeFlags;
    const newRuntimeFlags = internal_runtimeFlags/* patch */.r$(oldRuntimeFlags, updateFlags);
    // One more chance to short circuit: if we're immediately going
    // to interrupt. Interruption will cause immediate reversion of
    // the flag, so as long as we "peek ahead", there's no need to
    // set them to begin with.
    if (internal_runtimeFlags/* interruptible */.um(newRuntimeFlags) && this.isInterrupted()) {
      return internal_core/* exitFailCause */.KiG(this.getInterruptedCause());
    } else {
      // Impossible to short circuit, so record the changes
      this.patchRuntimeFlags(this.currentRuntimeFlags, updateFlags);
      if (op.effect_instruction_i1) {
        // Since we updated the flags, we need to revert them
        const revertFlags = internal_runtimeFlags/* diff */.Hg(newRuntimeFlags, oldRuntimeFlags);
        this.pushStack(new internal_core/* RevertFlags */.Zjb(revertFlags, op));
        return (0,Utils/* internalCall */.MS)(() => op.effect_instruction_i1(oldRuntimeFlags));
      } else {
        return internal_core/* exitVoid */.E7$;
      }
    }
  }
  [opCodes_effect/* OP_ON_SUCCESS */.rm](op) {
    this.pushStack(op);
    return op.effect_instruction_i0;
  }
  ["OnStep"](op) {
    this.pushStack(op);
    return op.effect_instruction_i0;
  }
  [opCodes_effect/* OP_ON_FAILURE */.PF](op) {
    this.pushStack(op);
    return op.effect_instruction_i0;
  }
  [opCodes_effect/* OP_ON_SUCCESS_AND_FAILURE */.kf](op) {
    this.pushStack(op);
    return op.effect_instruction_i0;
  }
  [opCodes_effect/* OP_ASYNC */.m7](op) {
    this._asyncBlockingOn = op.effect_instruction_i1;
    this.initiateAsync(this.currentRuntimeFlags, op.effect_instruction_i0);
    yieldedOpChannel.currentOp = op;
    return YieldedOp;
  }
  [opCodes_effect/* OP_YIELD */.gl](op) {
    this._isYielding = false;
    yieldedOpChannel.currentOp = op;
    return YieldedOp;
  }
  [opCodes_effect/* OP_WHILE */.Pv](op) {
    const check = op.effect_instruction_i0;
    const body = op.effect_instruction_i1;
    if (check()) {
      this.pushStack(op);
      return body();
    } else {
      return internal_core/* exitVoid */.E7$;
    }
  }
  [opCodes_effect/* OP_ITERATOR */.Rm](op) {
    return contOpSuccess[opCodes_effect/* OP_ITERATOR */.Rm](this, op, undefined);
  }
  [opCodes_effect/* OP_COMMIT */.vm](op) {
    return (0,Utils/* internalCall */.MS)(() => op.commit());
  }
  /**
   * The main run-loop for evaluating effects.
   *
   * **NOTE**: This method must be invoked by the fiber itself.
   */
  runLoop(effect0) {
    let cur = effect0;
    this.currentOpCount = 0;
    while (true) {
      if ((this.currentRuntimeFlags & internal_runtimeFlags/* OpSupervision */.mP) !== 0) {
        this.currentSupervisor.onEffect(this, cur);
      }
      if (this._queue.length > 0) {
        cur = this.drainQueueWhileRunning(this.currentRuntimeFlags, cur);
      }
      if (!this._isYielding) {
        this.currentOpCount += 1;
        const shouldYield = this.currentScheduler.shouldYield(this);
        if (shouldYield !== false) {
          this._isYielding = true;
          this.currentOpCount = 0;
          const oldCur = cur;
          cur = internal_core/* flatMap */.VSD(internal_core/* yieldNow */.T4Q({
            priority: shouldYield
          }), () => oldCur);
        }
      }
      try {
        // @ts-expect-error
        cur = this.currentTracer.context(() => {
          if (_version !== cur[internal_core/* EffectTypeId */.Hjt]._V) {
            return internal_core/* dieMessage */.lFE(`Cannot execute an Effect versioned ${cur[internal_core/* EffectTypeId */.Hjt]._V} with a Runtime of version ${version/* getCurrentVersion */.w()}`);
          }
          // @ts-expect-error
          return this[cur._op](cur);
        }, this);
        if (cur === YieldedOp) {
          const op = yieldedOpChannel.currentOp;
          if (op._op === opCodes_effect/* OP_YIELD */.gl || op._op === opCodes_effect/* OP_ASYNC */.m7) {
            return YieldedOp;
          }
          yieldedOpChannel.currentOp = null;
          return op._op === opCodes_effect/* OP_SUCCESS */.x$ || op._op === opCodes_effect/* OP_FAILURE */.N4 ? op : internal_core/* exitFailCause */.KiG(internal_cause/* die */.Xr(op));
        }
      } catch (e) {
        if (cur !== YieldedOp && !Predicate/* hasProperty */.l$(cur, "_op") || !(cur._op in this)) {
          cur = internal_core/* dieMessage */.lFE(`Not a valid effect: ${esm_Inspectable/* toStringUnknown */.OY(cur)}`);
        } else if (internal_core/* isInterruptedException */.lNG(e)) {
          cur = internal_core/* exitFailCause */.KiG(internal_cause/* sequential */.Pe(internal_cause/* die */.Xr(e), internal_cause/* interrupt */.e1(FiberId/* none */.YP)));
        } else {
          cur = internal_core/* die */.Xre(e);
        }
      }
    }
  }
  run = () => {
    this.drainQueueOnCurrentThread();
  };
}
// circular with Logger
/** @internal */
const currentMinimumLogLevel = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)("effect/FiberRef/currentMinimumLogLevel", () => internal_core/* fiberRefUnsafeMake */.kgb(LogLevel/* fromLiteral */.ik("Info")));
/** @internal */
const loggerWithConsoleLog = self => makeLogger(opts => {
  const services = esm_FiberRefs/* getOrDefault */.CJ(opts.context, internal_defaultServices/* currentServices */.Pm);
  esm_Context/* get */.U2(services, defaultServices_console/* consoleTag */.KM).unsafe.log(self.log(opts));
});
/** @internal */
const loggerWithLeveledLog = self => internalLogger.makeLogger(opts => {
  const services = FiberRefs.getOrDefault(opts.context, defaultServices.currentServices);
  const unsafeLogger = Context.get(services, consoleTag).unsafe;
  switch (opts.logLevel._tag) {
    case "Debug":
      return unsafeLogger.debug(self.log(opts));
    case "Info":
      return unsafeLogger.info(self.log(opts));
    case "Trace":
      return unsafeLogger.trace(self.log(opts));
    case "Warning":
      return unsafeLogger.warn(self.log(opts));
    case "Error":
    case "Fatal":
      return unsafeLogger.error(self.log(opts));
    default:
      return unsafeLogger.log(self.log(opts));
  }
});
/** @internal */
const loggerWithConsoleError = self => internalLogger.makeLogger(opts => {
  const services = FiberRefs.getOrDefault(opts.context, defaultServices.currentServices);
  Context.get(services, consoleTag).unsafe.error(self.log(opts));
});
/** @internal */
const defaultLogger = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/Logger/defaultLogger"), () => loggerWithConsoleLog(stringLogger));
/** @internal */
const fiberRuntime_jsonLogger = /*#__PURE__*/(/* unused pure expression or super */ null && (globalValue( /*#__PURE__*/Symbol.for("effect/Logger/jsonLogger"), () => loggerWithConsoleLog(internalLogger.jsonLogger))));
/** @internal */
const logFmtLogger = /*#__PURE__*/(/* unused pure expression or super */ null && (globalValue( /*#__PURE__*/Symbol.for("effect/Logger/logFmtLogger"), () => loggerWithConsoleLog(internalLogger.logfmtLogger))));
/** @internal */
const fiberRuntime_prettyLogger = /*#__PURE__*/(/* unused pure expression or super */ null && (globalValue( /*#__PURE__*/Symbol.for("effect/Logger/prettyLogger"), () => internalLogger.prettyLoggerDefault)));
/** @internal */
const fiberRuntime_structuredLogger = /*#__PURE__*/(/* unused pure expression or super */ null && (globalValue( /*#__PURE__*/Symbol.for("effect/Logger/structuredLogger"), () => loggerWithConsoleLog(internalLogger.structuredLogger))));
/** @internal */
const tracerLogger = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/Logger/tracerLogger"), () => makeLogger(({
  annotations,
  cause,
  context,
  fiberId,
  logLevel,
  message
}) => {
  const span = esm_Context/* getOption */.Rl(internal_fiberRefs/* getOrDefault */.CJ(context, internal_core/* currentContext */.gbX), internal_tracer/* spanTag */.N7);
  if (span._tag === "None" || span.value._tag === "ExternalSpan") {
    return;
  }
  const clockService = esm_Context/* unsafeGet */.MH(internal_fiberRefs/* getOrDefault */.CJ(context, internal_defaultServices/* currentServices */.Pm), clock/* clockTag */.GL);
  const attributes = {};
  for (const [key, value] of annotations) {
    attributes[key] = value;
  }
  attributes["effect.fiberId"] = FiberId/* threadName */.Q9(fiberId);
  attributes["effect.logLevel"] = logLevel.label;
  if (cause !== null && cause._tag !== "Empty") {
    attributes["effect.cause"] = internal_cause/* pretty */.IC(cause, {
      renderErrorCause: true
    });
  }
  span.value.event(esm_Inspectable/* toStringUnknown */.OY(Array.isArray(message) ? message[0] : message), clockService.unsafeCurrentTimeNanos(), attributes);
}));
/** @internal */
const loggerWithSpanAnnotations = self => internalLogger.mapInputOptions(self, options => {
  const span = Option.flatMap(fiberRefs.get(options.context, core.currentContext), Context.getOption(tracer.spanTag));
  if (span._tag === "None") {
    return options;
  }
  return {
    ...options,
    annotations: pipe(options.annotations, HashMap.set("effect.traceId", span.value.traceId), HashMap.set("effect.spanId", span.value.spanId), span.value._tag === "Span" ? HashMap.set("effect.spanName", span.value.name) : identity)
  };
});
/** @internal */
const currentLoggers = /*#__PURE__*/(0,GlobalValue/* globalValue */.K)( /*#__PURE__*/Symbol.for("effect/FiberRef/currentLoggers"), () => internal_core/* fiberRefUnsafeMakeHashSet */.WGV(HashSet/* make */.Sy(defaultLogger, tracerLogger)));
/** @internal */
const batchedLogger = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, window, f) => core.flatMap(fiberRuntime_scope, scope => {
  let buffer = [];
  const flush = core.suspend(() => {
    if (buffer.length === 0) {
      return core.void;
    }
    const arr = buffer;
    buffer = [];
    return f(arr);
  });
  return core.uninterruptibleMask(restore => pipe(internalEffect.sleep(window), core.zipRight(flush), internalEffect.forever, restore, fiberRuntime_forkDaemon, core.flatMap(fiber => core.scopeAddFinalizer(scope, core.interruptFiber(fiber))), core.zipRight(fiberRuntime_addFinalizer(() => flush)), core.as(internalLogger.makeLogger(options => {
    buffer.push(self.log(options));
  }))));
}))));
const annotateLogsScoped = function () {
  if (typeof arguments[0] === "string") {
    return fiberRefLocallyScopedWith(internal_core/* currentLogAnnotations */.cMe, esm_HashMap/* set */.t8(arguments[0], arguments[1]));
  }
  const entries = Object.entries(arguments[0]);
  return fiberRefLocallyScopedWith(internal_core/* currentLogAnnotations */.cMe, esm_HashMap/* mutate */.JG(annotations => {
    for (let i = 0; i < entries.length; i++) {
      const [key, value] = entries[i];
      esm_HashMap/* set */.t8(annotations, key, value);
    }
    return annotations;
  }));
};
/** @internal */
const whenLogLevel = /*#__PURE__*/(0,Function/* dual */.OB)(2, (effect, level) => {
  const requiredLogLevel = typeof level === "string" ? LogLevel/* fromLiteral */.ik(level) : level;
  return internal_core/* withFiberRuntime */.ECC(fiberState => {
    const minimumLogLevel = fiberState.getFiberRef(currentMinimumLogLevel);
    // Imitate the behaviour of `FiberRuntime.log`
    if (LogLevel/* greaterThan */.tS(minimumLogLevel, requiredLogLevel)) {
      return internal_core/* succeed */.ng0(esm_Option/* none */.YP());
    }
    return internal_core/* map */.UID(effect, esm_Option/* some */.G);
  });
});
// circular with Effect
/* @internal */
const fiberRuntime_acquireRelease = /*#__PURE__*/(0,Function/* dual */.OB)(args => internal_core/* isEffect */.cdB(args[0]), (acquire, release) => internal_core/* uninterruptible */.wUc(internal_core/* tap */.bwX(acquire, a => fiberRuntime_addFinalizer(exit => release(a, exit)))));
/* @internal */
const acquireReleaseInterruptible = /*#__PURE__*/(0,Function/* dual */.OB)(args => internal_core/* isEffect */.cdB(args[0]), (acquire, release) => fiberRuntime_ensuring(acquire, fiberRuntime_addFinalizer(exit => release(exit))));
/* @internal */
const fiberRuntime_addFinalizer = finalizer => internal_core/* withFiberRuntime */.ECC(runtime => {
  const acquireRefs = runtime.getFiberRefs();
  const acquireFlags = runtime.currentRuntimeFlags;
  return internal_core/* flatMap */.VSD(fiberRuntime_scope, scope => internal_core/* scopeAddFinalizerExit */.veJ(scope, exit => internal_core/* withFiberRuntime */.ECC(runtimeFinalizer => {
    const preRefs = runtimeFinalizer.getFiberRefs();
    const preFlags = runtimeFinalizer.currentRuntimeFlags;
    const patchRefs = FiberRefsPatch/* diff */.Hg(preRefs, acquireRefs);
    const patchFlags = internal_runtimeFlags/* diff */.Hg(preFlags, acquireFlags);
    const inverseRefs = FiberRefsPatch/* diff */.Hg(acquireRefs, preRefs);
    runtimeFinalizer.setFiberRefs(FiberRefsPatch/* patch */.r$(patchRefs, runtimeFinalizer.id(), acquireRefs));
    return fiberRuntime_ensuring(internal_core/* withRuntimeFlags */.ZYt(finalizer(exit), patchFlags), internal_core/* sync */.Z_X(() => {
      runtimeFinalizer.setFiberRefs(FiberRefsPatch/* patch */.r$(inverseRefs, runtimeFinalizer.id(), runtimeFinalizer.getFiberRefs()));
    }));
  })));
});
/* @internal */
const daemonChildren = self => {
  const forkScope = internal_core/* fiberRefLocally */.EXC(internal_core/* currentForkScopeOverride */.ohq, esm_Option/* some */.G(fiberScope/* globalScope */._A));
  return forkScope(self);
};
/** @internal */
const _existsParFound = /*#__PURE__*/Symbol.for("effect/Effect/existsPar/found");
/* @internal */
const exists = /*#__PURE__*/(0,Function/* dual */.OB)(args => Predicate/* isIterable */.TW(args[0]) && !internal_core/* isEffect */.cdB(args[0]), (elements, predicate, options) => matchSimple(options?.concurrency, () => internal_core/* suspend */.RqG(() => existsLoop(elements[Symbol.iterator](), 0, predicate)), () => internal_core/* matchEffect */.PwY(fiberRuntime_forEach(elements, (a, i) => internal_core/* if_ */.pHF(predicate(a, i), {
  onTrue: () => internal_core/* fail */.bGj(_existsParFound),
  onFalse: () => internal_core/* void */.Hcj
}), options), {
  onFailure: e => e === _existsParFound ? internal_core/* succeed */.ng0(true) : internal_core/* fail */.bGj(e),
  onSuccess: () => internal_core/* succeed */.ng0(false)
})));
const existsLoop = (iterator, index, f) => {
  const next = iterator.next();
  if (next.done) {
    return internal_core/* succeed */.ng0(false);
  }
  return (0,Function/* pipe */.zG)(internal_core/* flatMap */.VSD(f(next.value, index), b => b ? internal_core/* succeed */.ng0(b) : existsLoop(iterator, index + 1, f)));
};
/* @internal */
const fiberRuntime_filter = /*#__PURE__*/(0,Function/* dual */.OB)(args => Predicate/* isIterable */.TW(args[0]) && !internal_core/* isEffect */.cdB(args[0]), (elements, predicate, options) => {
  const predicate_ = options?.negate ? (a, i) => internal_core/* map */.UID(predicate(a, i), Boolean/* not */.ff) : predicate;
  return matchSimple(options?.concurrency, () => internal_core/* suspend */.RqG(() => esm_Array/* fromIterable */.EE(elements).reduceRight((effect, a, i) => internal_core/* zipWith */.yL_(effect, internal_core/* suspend */.RqG(() => predicate_(a, i)), (list, b) => b ? [a, ...list] : list), internal_core/* sync */.Z_X(() => new Array()))), () => internal_core/* map */.UID(fiberRuntime_forEach(elements, (a, i) => internal_core/* map */.UID(predicate_(a, i), b => b ? esm_Option/* some */.G(a) : esm_Option/* none */.YP()), options), esm_Array/* getSomes */.Mg));
});
// === all
const allResolveInput = input => {
  if (Array.isArray(input) || Predicate/* isIterable */.TW(input)) {
    return [input, esm_Option/* none */.YP()];
  }
  const keys = Object.keys(input);
  const size = keys.length;
  return [keys.map(k => input[k]), esm_Option/* some */.G(values => {
    const res = {};
    for (let i = 0; i < size; i++) {
      ;
      res[keys[i]] = values[i];
    }
    return res;
  })];
};
const allValidate = (effects, reconcile, options) => {
  const eitherEffects = [];
  for (const effect of effects) {
    eitherEffects.push(internal_core/* either */.wEe(effect));
  }
  return internal_core/* flatMap */.VSD(fiberRuntime_forEach(eitherEffects, Function/* identity */.yR, {
    concurrency: options?.concurrency,
    batching: options?.batching,
    concurrentFinalizers: options?.concurrentFinalizers
  }), eithers => {
    const none = esm_Option/* none */.YP();
    const size = eithers.length;
    const errors = new Array(size);
    const successes = new Array(size);
    let errored = false;
    for (let i = 0; i < size; i++) {
      const either = eithers[i];
      if (either._tag === "Left") {
        errors[i] = esm_Option/* some */.G(either.left);
        errored = true;
      } else {
        successes[i] = either.right;
        errors[i] = none;
      }
    }
    if (errored) {
      return reconcile._tag === "Some" ? internal_core/* fail */.bGj(reconcile.value(errors)) : internal_core/* fail */.bGj(errors);
    } else if (options?.discard) {
      return internal_core/* void */.Hcj;
    }
    return reconcile._tag === "Some" ? internal_core/* succeed */.ng0(reconcile.value(successes)) : internal_core/* succeed */.ng0(successes);
  });
};
const allEither = (effects, reconcile, options) => {
  const eitherEffects = [];
  for (const effect of effects) {
    eitherEffects.push(internal_core/* either */.wEe(effect));
  }
  if (options?.discard) {
    return fiberRuntime_forEach(eitherEffects, Function/* identity */.yR, {
      concurrency: options?.concurrency,
      batching: options?.batching,
      discard: true,
      concurrentFinalizers: options?.concurrentFinalizers
    });
  }
  return internal_core/* map */.UID(fiberRuntime_forEach(eitherEffects, Function/* identity */.yR, {
    concurrency: options?.concurrency,
    batching: options?.batching,
    concurrentFinalizers: options?.concurrentFinalizers
  }), eithers => reconcile._tag === "Some" ? reconcile.value(eithers) : eithers);
};
/* @internal */
const fiberRuntime_all = (arg, options) => {
  const [effects, reconcile] = allResolveInput(arg);
  if (options?.mode === "validate") {
    return allValidate(effects, reconcile, options);
  } else if (options?.mode === "either") {
    return allEither(effects, reconcile, options);
  }
  return options?.discard !== true && reconcile._tag === "Some" ? internal_core/* map */.UID(fiberRuntime_forEach(effects, Function/* identity */.yR, options), reconcile.value) : fiberRuntime_forEach(effects, Function/* identity */.yR, options);
};
/* @internal */
const allWith = options => arg => fiberRuntime_all(arg, options);
/* @internal */
const allSuccesses = (elements, options) => internal_core/* map */.UID(fiberRuntime_all(esm_Array/* fromIterable */.EE(elements).map(internal_core/* exit */.JFt), options), esm_Array/* filterMap */.DZ(exit => internal_core/* exitIsSuccess */.dcz(exit) ? esm_Option/* some */.G(exit.effect_instruction_i0) : esm_Option/* none */.YP()));
/* @internal */
const fiberRuntime_replicate = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, n) => Array.from({
  length: n
}, () => self));
/* @internal */
const fiberRuntime_replicateEffect = /*#__PURE__*/(0,Function/* dual */.OB)(args => internal_core/* isEffect */.cdB(args[0]), (self, n, options) => fiberRuntime_all(fiberRuntime_replicate(self, n), options));
/* @internal */
const fiberRuntime_forEach = /*#__PURE__*/(0,Function/* dual */.OB)(args => Predicate/* isIterable */.TW(args[0]), (self, f, options) => internal_core/* withFiberRuntime */.ECC(r => {
  const isRequestBatchingEnabled = options?.batching === true || options?.batching === "inherit" && r.getFiberRef(internal_core/* currentRequestBatching */.gTV);
  if (options?.discard) {
    return concurrency_match(options.concurrency, () => finalizersMaskInternal(sequential, options?.concurrentFinalizers)(restore => isRequestBatchingEnabled ? forEachConcurrentDiscard(self, (a, i) => restore(f(a, i)), true, false, 1) : internal_core/* forEachSequentialDiscard */.EaP(self, (a, i) => restore(f(a, i)))), () => finalizersMaskInternal(parallel, options?.concurrentFinalizers)(restore => forEachConcurrentDiscard(self, (a, i) => restore(f(a, i)), isRequestBatchingEnabled, false)), n => finalizersMaskInternal(parallelN(n), options?.concurrentFinalizers)(restore => forEachConcurrentDiscard(self, (a, i) => restore(f(a, i)), isRequestBatchingEnabled, false, n)));
  }
  return concurrency_match(options?.concurrency, () => finalizersMaskInternal(sequential, options?.concurrentFinalizers)(restore => isRequestBatchingEnabled ? forEachParN(self, 1, (a, i) => restore(f(a, i)), true) : internal_core/* forEachSequential */.o9$(self, (a, i) => restore(f(a, i)))), () => finalizersMaskInternal(parallel, options?.concurrentFinalizers)(restore => forEachParUnbounded(self, (a, i) => restore(f(a, i)), isRequestBatchingEnabled)), n => finalizersMaskInternal(parallelN(n), options?.concurrentFinalizers)(restore => forEachParN(self, n, (a, i) => restore(f(a, i)), isRequestBatchingEnabled)));
}));
/* @internal */
const forEachParUnbounded = (self, f, batching) => internal_core/* suspend */.RqG(() => {
  const as = esm_Array/* fromIterable */.EE(self);
  const array = new Array(as.length);
  const fn = (a, i) => internal_core/* flatMap */.VSD(f(a, i), b => internal_core/* sync */.Z_X(() => array[i] = b));
  return internal_core/* zipRight */.qs5(forEachConcurrentDiscard(as, fn, batching, false), internal_core/* succeed */.ng0(array));
});
/** @internal */
const forEachConcurrentDiscard = (self, f, batching, processAll, n) => internal_core/* uninterruptibleMask */.UO$(restore => internal_core/* transplant */.Yxn(graft => internal_core/* withFiberRuntime */.ECC(parent => {
  let todos = Array.from(self).reverse();
  let target = todos.length;
  if (target === 0) {
    return internal_core/* void */.Hcj;
  }
  let counter = 0;
  let interrupted = false;
  const fibersCount = n ? Math.min(todos.length, n) : todos.length;
  const fibers = new Set();
  const results = new Array();
  const interruptAll = () => fibers.forEach(fiber => {
    fiber.currentScheduler.scheduleTask(() => {
      fiber.unsafeInterruptAsFork(parent.id());
    }, 0);
  });
  const startOrder = new Array();
  const joinOrder = new Array();
  const residual = new Array();
  const collectExits = () => {
    const exits = results.filter(({
      exit
    }) => exit._tag === "Failure").sort((a, b) => a.index < b.index ? -1 : a.index === b.index ? 0 : 1).map(({
      exit
    }) => exit);
    if (exits.length === 0) {
      exits.push(internal_core/* exitVoid */.E7$);
    }
    return exits;
  };
  const runFiber = (eff, interruptImmediately = false) => {
    const runnable = internal_core/* uninterruptible */.wUc(graft(eff));
    const fiber = unsafeForkUnstarted(runnable, parent, parent.currentRuntimeFlags, fiberScope/* globalScope */._A);
    parent.currentScheduler.scheduleTask(() => {
      if (interruptImmediately) {
        fiber.unsafeInterruptAsFork(parent.id());
      }
      fiber.resume(runnable);
    }, 0);
    return fiber;
  };
  const onInterruptSignal = () => {
    if (!processAll) {
      target -= todos.length;
      todos = [];
    }
    interrupted = true;
    interruptAll();
  };
  const stepOrExit = batching ? internal_core/* step */.Nbs : internal_core/* exit */.JFt;
  const processingFiber = runFiber(internal_core/* async */.PFx(resume => {
    const pushResult = (res, index) => {
      if (res._op === "Blocked") {
        residual.push(res);
      } else {
        results.push({
          index,
          exit: res
        });
        if (res._op === "Failure" && !interrupted) {
          onInterruptSignal();
        }
      }
    };
    const next = () => {
      if (todos.length > 0) {
        const a = todos.pop();
        let index = counter++;
        const returnNextElement = () => {
          const a = todos.pop();
          index = counter++;
          return internal_core/* flatMap */.VSD(internal_core/* yieldNow */.T4Q(), () => internal_core/* flatMap */.VSD(stepOrExit(restore(f(a, index))), onRes));
        };
        const onRes = res => {
          if (todos.length > 0) {
            pushResult(res, index);
            if (todos.length > 0) {
              return returnNextElement();
            }
          }
          return internal_core/* succeed */.ng0(res);
        };
        const todo = internal_core/* flatMap */.VSD(stepOrExit(restore(f(a, index))), onRes);
        const fiber = runFiber(todo);
        startOrder.push(fiber);
        fibers.add(fiber);
        if (interrupted) {
          fiber.currentScheduler.scheduleTask(() => {
            fiber.unsafeInterruptAsFork(parent.id());
          }, 0);
        }
        fiber.addObserver(wrapped => {
          let exit;
          if (wrapped._op === "Failure") {
            exit = wrapped;
          } else {
            exit = wrapped.effect_instruction_i0;
          }
          joinOrder.push(fiber);
          fibers.delete(fiber);
          pushResult(exit, index);
          if (results.length === target) {
            resume(internal_core/* succeed */.ng0(esm_Option/* getOrElse */.fS(internal_core/* exitCollectAll */.jxF(collectExits(), {
              parallel: true
            }), () => internal_core/* exitVoid */.E7$)));
          } else if (residual.length + results.length === target) {
            const exits = collectExits();
            const requests = residual.map(blocked => blocked.effect_instruction_i0).reduce(blockedRequests/* par */.Hb);
            resume(internal_core/* succeed */.ng0(internal_core/* blocked */.IN$(requests, forEachConcurrentDiscard([esm_Option/* getOrElse */.fS(internal_core/* exitCollectAll */.jxF(exits, {
              parallel: true
            }), () => internal_core/* exitVoid */.E7$), ...residual.map(blocked => blocked.effect_instruction_i1)], i => i, batching, true, n))));
          } else {
            next();
          }
        });
      }
    };
    for (let i = 0; i < fibersCount; i++) {
      next();
    }
  }));
  return internal_core/* asVoid */.a2S(internal_core/* onExit */.dsk(internal_core/* flatten */.xHg(restore(internal_fiber/* join */.v_(processingFiber))), internal_core/* exitMatch */.Bs2({
    onFailure: cause => {
      onInterruptSignal();
      const target = residual.length + 1;
      const concurrency = Math.min(typeof n === "number" ? n : residual.length, residual.length);
      const toPop = Array.from(residual);
      return internal_core/* async */.PFx(cb => {
        const exits = [];
        let count = 0;
        let index = 0;
        const check = (index, hitNext) => exit => {
          exits[index] = exit;
          count++;
          if (count === target) {
            cb(internal_core/* exitSucceed */.SID(internal_core/* exitFailCause */.KiG(cause)));
          }
          if (toPop.length > 0 && hitNext) {
            next();
          }
        };
        const next = () => {
          runFiber(toPop.pop(), true).addObserver(check(index, true));
          index++;
        };
        processingFiber.addObserver(check(index, false));
        index++;
        for (let i = 0; i < concurrency; i++) {
          next();
        }
      });
    },
    onSuccess: () => internal_core/* forEachSequential */.o9$(joinOrder, f => f.inheritAll)
  })));
})));
/* @internal */
const forEachParN = (self, n, f, batching) => internal_core/* suspend */.RqG(() => {
  const as = esm_Array/* fromIterable */.EE(self);
  const array = new Array(as.length);
  const fn = (a, i) => internal_core/* map */.UID(f(a, i), b => array[i] = b);
  return internal_core/* zipRight */.qs5(forEachConcurrentDiscard(as, fn, batching, false, n), internal_core/* succeed */.ng0(array));
});
/* @internal */
const fiberRuntime_fork = self => internal_core/* withFiberRuntime */.ECC((state, status) => internal_core/* succeed */.ng0(fiberRuntime_unsafeFork(self, state, status.runtimeFlags)));
/* @internal */
const fiberRuntime_forkDaemon = self => forkWithScopeOverride(self, fiberScope/* globalScope */._A);
/* @internal */
const forkWithErrorHandler = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, handler) => fiberRuntime_fork(internal_core/* onError */.qQ3(self, cause => {
  const either = internal_cause/* failureOrCause */.hl(cause);
  switch (either._tag) {
    case "Left":
      return handler(either.left);
    case "Right":
      return internal_core/* failCause */.DhG(either.right);
  }
})));
/** @internal */
const fiberRuntime_unsafeFork = (effect, parentFiber, parentRuntimeFlags, overrideScope = null) => {
  const childFiber = unsafeMakeChildFiber(effect, parentFiber, parentRuntimeFlags, overrideScope);
  childFiber.resume(effect);
  return childFiber;
};
/** @internal */
const unsafeForkUnstarted = (effect, parentFiber, parentRuntimeFlags, overrideScope = null) => {
  const childFiber = unsafeMakeChildFiber(effect, parentFiber, parentRuntimeFlags, overrideScope);
  return childFiber;
};
/** @internal */
const unsafeMakeChildFiber = (effect, parentFiber, parentRuntimeFlags, overrideScope = null) => {
  const childId = FiberId/* unsafeMake */.t0();
  const parentFiberRefs = parentFiber.getFiberRefs();
  const childFiberRefs = internal_fiberRefs/* forkAs */.xN(parentFiberRefs, childId);
  const childFiber = new FiberRuntime(childId, childFiberRefs, parentRuntimeFlags);
  const childContext = internal_fiberRefs/* getOrDefault */.CJ(childFiberRefs, internal_core/* currentContext */.gbX);
  const supervisor = childFiber.currentSupervisor;
  supervisor.onStart(childContext, effect, esm_Option/* some */.G(parentFiber), childFiber);
  childFiber.addObserver(exit => supervisor.onEnd(exit, childFiber));
  const parentScope = overrideScope !== null ? overrideScope : (0,Function/* pipe */.zG)(parentFiber.getFiberRef(internal_core/* currentForkScopeOverride */.ohq), esm_Option/* getOrElse */.fS(() => parentFiber.scope()));
  parentScope.add(parentRuntimeFlags, childFiber);
  return childFiber;
};
/* @internal */
const forkWithScopeOverride = (self, scopeOverride) => internal_core/* withFiberRuntime */.ECC((parentFiber, parentStatus) => internal_core/* succeed */.ng0(fiberRuntime_unsafeFork(self, parentFiber, parentStatus.runtimeFlags, scopeOverride)));
/* @internal */
const mergeAll = /*#__PURE__*/(0,Function/* dual */.OB)(args => Predicate/* isFunction */.mf(args[2]), (elements, zero, f, options) => matchSimple(options?.concurrency, () => esm_Array/* fromIterable */.EE(elements).reduce((acc, a, i) => internal_core/* zipWith */.yL_(acc, a, (acc, a) => f(acc, a, i)), internal_core/* succeed */.ng0(zero)), () => internal_core/* flatMap */.VSD(Ref/* make */.Sy(zero), acc => internal_core/* flatMap */.VSD(fiberRuntime_forEach(elements, (effect, i) => internal_core/* flatMap */.VSD(effect, a => Ref/* update */.Vx(acc, b => f(b, a, i))), options), () => Ref/* get */.U2(acc)))));
/* @internal */
const partition = /*#__PURE__*/(0,Function/* dual */.OB)(args => Predicate/* isIterable */.TW(args[0]), (elements, f, options) => (0,Function/* pipe */.zG)(fiberRuntime_forEach(elements, (a, i) => internal_core/* either */.wEe(f(a, i)), options), internal_core/* map */.UID(chunk => internal_core/* partitionMap */.tVo(chunk, Function/* identity */.yR))));
/* @internal */
const validateAll = /*#__PURE__*/(0,Function/* dual */.OB)(args => Predicate/* isIterable */.TW(args[0]), (elements, f, options) => internal_core/* flatMap */.VSD(partition(elements, f, {
  concurrency: options?.concurrency,
  batching: options?.batching,
  concurrentFinalizers: options?.concurrentFinalizers
}), ([es, bs]) => esm_Array/* isNonEmptyArray */.Of(es) ? internal_core/* fail */.bGj(es) : options?.discard ? internal_core/* void */.Hcj : internal_core/* succeed */.ng0(bs)));
/* @internal */
const fiberRuntime_raceAll = all => {
  const list = esm_Chunk/* fromIterable */.EE(all);
  if (!esm_Chunk/* isNonEmpty */.Od(list)) {
    return internal_core/* dieSync */.AgX(() => new internal_core/* IllegalArgumentException */.j5q(`Received an empty collection of effects`));
  }
  const self = esm_Chunk/* headNonEmpty */.dK(list);
  const effects = esm_Chunk/* tailNonEmpty */.fm(list);
  const inheritAll = res => (0,Function/* pipe */.zG)(internal_fiber/* inheritAll */.i0(res[1]), internal_core.as(res[0]));
  return (0,Function/* pipe */.zG)(internal_core/* deferredMake */.kPu(), internal_core/* flatMap */.VSD(done => (0,Function/* pipe */.zG)(Ref/* make */.Sy(effects.length), internal_core/* flatMap */.VSD(fails => internal_core/* uninterruptibleMask */.UO$(restore => (0,Function/* pipe */.zG)(fiberRuntime_fork(internal_core/* interruptible */.um_(self)), internal_core/* flatMap */.VSD(head => (0,Function/* pipe */.zG)(effects, internal_core/* forEachSequential */.o9$(effect => fiberRuntime_fork(internal_core/* interruptible */.um_(effect))), internal_core/* map */.UID(fibers => esm_Chunk/* unsafeFromArray */.JN(fibers)), internal_core/* map */.UID(tail => (0,Function/* pipe */.zG)(tail, esm_Chunk/* prepend */.Ce(head))), internal_core/* tap */.bwX(fibers => (0,Function/* pipe */.zG)(fibers, esm_Array/* reduce */.u4(internal_core/* void */.Hcj, (effect, fiber) => (0,Function/* pipe */.zG)(effect, internal_core/* zipRight */.qs5((0,Function/* pipe */.zG)(internal_fiber/* _await */.AO(fiber), internal_core/* flatMap */.VSD(raceAllArbiter(fibers, fiber, done, fails)), fiberRuntime_fork, internal_core/* asVoid */.a2S)))))), internal_core/* flatMap */.VSD(fibers => (0,Function/* pipe */.zG)(restore((0,Function/* pipe */.zG)(Deferred/* await */.Uz(done), internal_core/* flatMap */.VSD(inheritAll))), internal_core/* onInterrupt */.J7b(() => (0,Function/* pipe */.zG)(fibers, esm_Array/* reduce */.u4(internal_core/* void */.Hcj, (effect, fiber) => (0,Function/* pipe */.zG)(effect, internal_core/* zipLeft */.Ti7(internal_core/* interruptFiber */.u_W(fiber))))))))))))))));
};
const raceAllArbiter = (fibers, winner, deferred, fails) => exit => internal_core/* exitMatchEffect */.aoR(exit, {
  onFailure: cause => (0,Function/* pipe */.zG)(Ref/* modify */.Pj(fails, fails => [fails === 0 ? (0,Function/* pipe */.zG)(internal_core/* deferredFailCause */.yd6(deferred, cause), internal_core/* asVoid */.a2S) : internal_core/* void */.Hcj, fails - 1]), internal_core/* flatten */.xHg),
  onSuccess: value => (0,Function/* pipe */.zG)(internal_core/* deferredSucceed */.QtZ(deferred, [value, winner]), internal_core/* flatMap */.VSD(set => set ? (0,Function/* pipe */.zG)(esm_Chunk/* fromIterable */.EE(fibers), esm_Array/* reduce */.u4(internal_core/* void */.Hcj, (effect, fiber) => fiber === winner ? effect : (0,Function/* pipe */.zG)(effect, internal_core/* zipLeft */.Ti7(internal_core/* interruptFiber */.u_W(fiber))))) : internal_core/* void */.Hcj))
});
/* @internal */
const reduceEffect = /*#__PURE__*/(0,Function/* dual */.OB)(args => Predicate/* isIterable */.TW(args[0]) && !internal_core/* isEffect */.cdB(args[0]), (elements, zero, f, options) => matchSimple(options?.concurrency, () => esm_Array/* fromIterable */.EE(elements).reduce((acc, a, i) => internal_core/* zipWith */.yL_(acc, a, (acc, a) => f(acc, a, i)), zero), () => internal_core/* suspend */.RqG(() => (0,Function/* pipe */.zG)(mergeAll([zero, ...elements], esm_Option/* none */.YP(), (acc, elem, i) => {
  switch (acc._tag) {
    case "None":
      {
        return esm_Option/* some */.G(elem);
      }
    case "Some":
      {
        return esm_Option/* some */.G(f(acc.value, elem, i));
      }
  }
}, options), internal_core/* map */.UID(option => {
  switch (option._tag) {
    case "None":
      {
        throw new Error("BUG: Effect.reduceEffect - please report an issue at https://github.com/Effect-TS/effect/issues");
      }
    case "Some":
      {
        return option.value;
      }
  }
})))));
/* @internal */
const parallelFinalizers = self => internal_core/* contextWithEffect */.RuX(context => esm_Option/* match */.EQ(esm_Context/* getOption */.Rl(context, scopeTag), {
  onNone: () => self,
  onSome: scope => {
    switch (scope.strategy._tag) {
      case "Parallel":
        return self;
      case "Sequential":
      case "ParallelN":
        return internal_core/* flatMap */.VSD(internal_core/* scopeFork */.Z5L(scope, parallel), inner => scopeExtend(self, inner));
    }
  }
}));
/* @internal */
const parallelNFinalizers = parallelism => self => internal_core/* contextWithEffect */.RuX(context => esm_Option/* match */.EQ(esm_Context/* getOption */.Rl(context, scopeTag), {
  onNone: () => self,
  onSome: scope => {
    if (scope.strategy._tag === "ParallelN" && scope.strategy.parallelism === parallelism) {
      return self;
    }
    return internal_core/* flatMap */.VSD(internal_core/* scopeFork */.Z5L(scope, parallelN(parallelism)), inner => scopeExtend(self, inner));
  }
}));
/* @internal */
const finalizersMask = strategy => self => finalizersMaskInternal(strategy, true)(self);
/* @internal */
const finalizersMaskInternal = (strategy, concurrentFinalizers) => self => internal_core/* contextWithEffect */.RuX(context => esm_Option/* match */.EQ(esm_Context/* getOption */.Rl(context, scopeTag), {
  onNone: () => self(Function/* identity */.yR),
  onSome: scope => {
    if (concurrentFinalizers === true) {
      const patch = strategy._tag === "Parallel" ? parallelFinalizers : strategy._tag === "Sequential" ? sequentialFinalizers : parallelNFinalizers(strategy.parallelism);
      switch (scope.strategy._tag) {
        case "Parallel":
          return patch(self(parallelFinalizers));
        case "Sequential":
          return patch(self(sequentialFinalizers));
        case "ParallelN":
          return patch(self(parallelNFinalizers(scope.strategy.parallelism)));
      }
    } else {
      return self(Function/* identity */.yR);
    }
  }
}));
/* @internal */
const scopeWith = f => internal_core/* flatMap */.VSD(scopeTag, f);
/** @internal */
const scopedWith = f => internal_core/* flatMap */.VSD(fiberRuntime_scopeMake(), scope => internal_core/* onExit */.dsk(f(scope), exit => scope.close(exit)));
/* @internal */
const scopedEffect = effect => internal_core/* flatMap */.VSD(fiberRuntime_scopeMake(), scope => scopeUse(effect, scope));
/* @internal */
const sequentialFinalizers = self => internal_core/* contextWithEffect */.RuX(context => esm_Option/* match */.EQ(esm_Context/* getOption */.Rl(context, scopeTag), {
  onNone: () => self,
  onSome: scope => {
    switch (scope.strategy._tag) {
      case "Sequential":
        return self;
      case "Parallel":
      case "ParallelN":
        return internal_core/* flatMap */.VSD(internal_core/* scopeFork */.Z5L(scope, sequential), inner => scopeExtend(self, inner));
    }
  }
}));
/* @internal */
const tagMetricsScoped = (key, value) => labelMetricsScoped([label/* make */.Sy(key, value)]);
/* @internal */
const labelMetricsScoped = labels => fiberRefLocallyScopedWith(internal_core/* currentMetricLabels */.VPq, old => esm_Array/* union */.G0(old, labels));
/* @internal */
const using = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, use) => scopedWith(scope => internal_core/* flatMap */.VSD(scopeExtend(self, scope), use)));
/** @internal */
const validate = /*#__PURE__*/(0,Function/* dual */.OB)(args => internal_core/* isEffect */.cdB(args[1]), (self, that, options) => validateWith(self, that, (a, b) => [a, b], options));
/** @internal */
const validateWith = /*#__PURE__*/(0,Function/* dual */.OB)(args => internal_core/* isEffect */.cdB(args[1]), (self, that, f, options) => internal_core/* flatten */.xHg(zipWithOptions(internal_core/* exit */.JFt(self), internal_core/* exit */.JFt(that), (ea, eb) => internal_core/* exitZipWith */.dG6(ea, eb, {
  onSuccess: f,
  onFailure: (ca, cb) => options?.concurrent ? internal_cause/* parallel */.Mf(ca, cb) : internal_cause/* sequential */.Pe(ca, cb)
}), options)));
/* @internal */
const validateAllPar = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (elements, f) => core.flatMap(partition(elements, f), ([es, bs]) => es.length === 0 ? core.succeed(bs) : core.fail(es)))));
/* @internal */
const validateAllParDiscard = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (elements, f) => core.flatMap(partition(elements, f), ([es, _]) => es.length === 0 ? core.void : core.fail(es)))));
/* @internal */
const validateFirst = /*#__PURE__*/(0,Function/* dual */.OB)(args => Predicate/* isIterable */.TW(args[0]), (elements, f, options) => internal_core/* flip */.RRI(fiberRuntime_forEach(elements, (a, i) => internal_core/* flip */.RRI(f(a, i)), options)));
/* @internal */
const withClockScoped = c => fiberRefLocallyScopedWith(internal_defaultServices/* currentServices */.Pm, esm_Context/* add */.IH(clock/* clockTag */.GL, c));
/* @internal */
const withRandomScoped = value => fiberRefLocallyScopedWith(internal_defaultServices/* currentServices */.Pm, esm_Context/* add */.IH(random/* randomTag */.XB, value));
/* @internal */
const withConfigProviderScoped = provider => fiberRefLocallyScopedWith(internal_defaultServices/* currentServices */.Pm, esm_Context/* add */.IH(configProvider/* configProviderTag */.a6, provider));
/* @internal */
const withEarlyRelease = self => scopeWith(parent => internal_core/* flatMap */.VSD(internal_core/* scopeFork */.Z5L(parent, executionStrategy/* sequential */.Pe), child => (0,Function/* pipe */.zG)(self, scopeExtend(child), internal_core/* map */.UID(value => [internal_core/* fiberIdWith */.mrY(fiberId => internal_core/* scopeClose */.roQ(child, internal_core/* exitInterrupt */.eq6(fiberId))), value]))));
/** @internal */
const zipOptions = /*#__PURE__*/(0,Function/* dual */.OB)(args => internal_core/* isEffect */.cdB(args[1]), (self, that, options) => zipWithOptions(self, that, (a, b) => [a, b], options));
/** @internal */
const zipLeftOptions = /*#__PURE__*/(0,Function/* dual */.OB)(args => internal_core/* isEffect */.cdB(args[1]), (self, that, options) => {
  if (options?.concurrent !== true && (options?.batching === undefined || options.batching === false)) {
    return internal_core/* zipLeft */.Ti7(self, that);
  }
  return zipWithOptions(self, that, (a, _) => a, options);
});
/** @internal */
const zipRightOptions = /*#__PURE__*/(0,Function/* dual */.OB)(args => internal_core/* isEffect */.cdB(args[1]), (self, that, options) => {
  if (options?.concurrent !== true && (options?.batching === undefined || options.batching === false)) {
    return internal_core/* zipRight */.qs5(self, that);
  }
  return zipWithOptions(self, that, (_, b) => b, options);
});
/** @internal */
const zipWithOptions = /*#__PURE__*/(0,Function/* dual */.OB)(args => internal_core/* isEffect */.cdB(args[1]), (self, that, f, options) => internal_core/* map */.UID(fiberRuntime_all([self, that], {
  concurrency: options?.concurrent ? 2 : 1,
  batching: options?.batching,
  concurrentFinalizers: options?.concurrentFinalizers
}), ([a, a2]) => f(a, a2)));
/* @internal */
const withRuntimeFlagsScoped = update => {
  if (update === RuntimeFlagsPatch/* empty */.cS) {
    return internal_core/* void */.Hcj;
  }
  return (0,Function/* pipe */.zG)(internal_core/* runtimeFlags */.CpT, internal_core/* flatMap */.VSD(runtimeFlags => {
    const updatedRuntimeFlags = internal_runtimeFlags/* patch */.r$(runtimeFlags, update);
    const revertRuntimeFlags = internal_runtimeFlags/* diff */.Hg(updatedRuntimeFlags, runtimeFlags);
    return (0,Function/* pipe */.zG)(internal_core/* updateRuntimeFlags */.$Cr(update), internal_core/* zipRight */.qs5(fiberRuntime_addFinalizer(() => internal_core/* updateRuntimeFlags */.$Cr(revertRuntimeFlags))), internal_core/* asVoid */.a2S);
  }), internal_core/* uninterruptible */.wUc);
};
// circular with Scope
/** @internal */
const scopeTag = /*#__PURE__*/esm_Context/* GenericTag */.hV("effect/Scope");
/* @internal */
const fiberRuntime_scope = scopeTag;
const scopeUnsafeAddFinalizer = (scope, fin) => {
  if (scope.state._tag === "Open") {
    scope.state.finalizers.set({}, fin);
  }
};
const ScopeImplProto = {
  [internal_core/* ScopeTypeId */.otW]: internal_core/* ScopeTypeId */.otW,
  [internal_core/* CloseableScopeTypeId */.Bcn]: internal_core/* CloseableScopeTypeId */.Bcn,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  },
  fork(strategy) {
    return internal_core/* sync */.Z_X(() => {
      const newScope = fiberRuntime_scopeUnsafeMake(strategy);
      if (this.state._tag === "Closed") {
        newScope.state = this.state;
        return newScope;
      }
      const key = {};
      const fin = exit => newScope.close(exit);
      this.state.finalizers.set(key, fin);
      scopeUnsafeAddFinalizer(newScope, _ => internal_core/* sync */.Z_X(() => {
        if (this.state._tag === "Open") {
          this.state.finalizers.delete(key);
        }
      }));
      return newScope;
    });
  },
  close(exit) {
    return internal_core/* suspend */.RqG(() => {
      if (this.state._tag === "Closed") {
        return internal_core/* void */.Hcj;
      }
      const finalizers = Array.from(this.state.finalizers.values()).reverse();
      this.state = {
        _tag: "Closed",
        exit
      };
      if (finalizers.length === 0) {
        return internal_core/* void */.Hcj;
      }
      return executionStrategy/* isSequential */.DS(this.strategy) ? (0,Function/* pipe */.zG)(internal_core/* forEachSequential */.o9$(finalizers, fin => internal_core/* exit */.JFt(fin(exit))), internal_core/* flatMap */.VSD(results => (0,Function/* pipe */.zG)(internal_core/* exitCollectAll */.jxF(results), esm_Option/* map */.UI(internal_core/* exitAsVoid */.MKG), esm_Option/* getOrElse */.fS(() => internal_core/* exitVoid */.E7$)))) : executionStrategy/* isParallel */.rN(this.strategy) ? (0,Function/* pipe */.zG)(forEachParUnbounded(finalizers, fin => internal_core/* exit */.JFt(fin(exit)), false), internal_core/* flatMap */.VSD(results => (0,Function/* pipe */.zG)(internal_core/* exitCollectAll */.jxF(results, {
        parallel: true
      }), esm_Option/* map */.UI(internal_core/* exitAsVoid */.MKG), esm_Option/* getOrElse */.fS(() => internal_core/* exitVoid */.E7$)))) : (0,Function/* pipe */.zG)(forEachParN(finalizers, this.strategy.parallelism, fin => internal_core/* exit */.JFt(fin(exit)), false), internal_core/* flatMap */.VSD(results => (0,Function/* pipe */.zG)(internal_core/* exitCollectAll */.jxF(results, {
        parallel: true
      }), esm_Option/* map */.UI(internal_core/* exitAsVoid */.MKG), esm_Option/* getOrElse */.fS(() => internal_core/* exitVoid */.E7$))));
    });
  },
  addFinalizer(fin) {
    return internal_core/* suspend */.RqG(() => {
      if (this.state._tag === "Closed") {
        return fin(this.state.exit);
      }
      this.state.finalizers.set({}, fin);
      return internal_core/* void */.Hcj;
    });
  }
};
const fiberRuntime_scopeUnsafeMake = (strategy = executionStrategy/* sequential */.Pe) => {
  const scope = Object.create(ScopeImplProto);
  scope.strategy = strategy;
  scope.state = {
    _tag: "Open",
    finalizers: new Map()
  };
  return scope;
};
/* @internal */
const fiberRuntime_scopeMake = (strategy = executionStrategy/* sequential */.Pe) => internal_core/* sync */.Z_X(() => fiberRuntime_scopeUnsafeMake(strategy));
/* @internal */
const scopeExtend = /*#__PURE__*/(0,Function/* dual */.OB)(2, (effect, scope) => internal_core/* mapInputContext */.nP$(effect,
// @ts-expect-error
esm_Context/* merge */.TS(esm_Context/* make */.Sy(scopeTag, scope))));
/* @internal */
const scopeUse = /*#__PURE__*/(0,Function/* dual */.OB)(2, (effect, scope) => (0,Function/* pipe */.zG)(effect, scopeExtend(scope), internal_core/* onExit */.dsk(exit => scope.close(exit))));
// circular with Supervisor
/** @internal */
const fiberRefUnsafeMakeSupervisor = initial => internal_core/* fiberRefUnsafeMakePatch */.laO(initial, {
  differ: patch_differ,
  fork: patch_empty
});
// circular with FiberRef
/* @internal */
const fiberRefLocallyScoped = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, value) => internal_core/* asVoid */.a2S(fiberRuntime_acquireRelease(internal_core/* flatMap */.VSD(internal_core/* fiberRefGet */.grZ(self), oldValue => internal_core.as(internal_core/* fiberRefSet */.eqx(self, value), oldValue)), oldValue => internal_core/* fiberRefSet */.eqx(self, oldValue))));
/* @internal */
const fiberRefLocallyScopedWith = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => internal_core/* fiberRefGetWith */.$Dw(self, a => fiberRefLocallyScoped(self, f(a))));
/* @internal */
const fiberRefMake = (initial, options) => fiberRefMakeWith(() => core.fiberRefUnsafeMake(initial, options));
/* @internal */
const fiberRefMakeWith = ref => fiberRuntime_acquireRelease(core.tap(core.sync(ref), ref => core.fiberRefUpdate(ref, identity)), fiberRef => core.fiberRefDelete(fiberRef));
/* @internal */
const fiberRefMakeContext = initial => fiberRefMakeWith(() => core.fiberRefUnsafeMakeContext(initial));
/* @internal */
const fiberRefMakeRuntimeFlags = initial => fiberRefMakeWith(() => core.fiberRefUnsafeMakeRuntimeFlags(initial));
/** @internal */
const currentRuntimeFlags = /*#__PURE__*/internal_core/* fiberRefUnsafeMakeRuntimeFlags */.MZf(internal_runtimeFlags/* none */.YP);
/** @internal */
const currentSupervisor = /*#__PURE__*/fiberRefUnsafeMakeSupervisor(supervisor/* none */.YP);
// circular with Fiber
/* @internal */
const fiberAwaitAll = fibers => fiberRuntime_forEach(fibers, internal_fiber/* _await */.AO);
/** @internal */
const fiberAll = fibers => {
  const _fiberAll = {
    ...Effectable/* CommitPrototype */.ku,
    commit() {
      return internal_fiber/* join */.v_(this);
    },
    [internal_fiber/* FiberTypeId */.tP]: internal_fiber/* fiberVariance */.kD,
    id: () => esm_Array/* fromIterable */.EE(fibers).reduce((id, fiber) => FiberId/* combine */.$e(id, fiber.id()), FiberId/* none */.YP),
    await: internal_core/* exit */.JFt(forEachParUnbounded(fibers, fiber => internal_core/* flatten */.xHg(fiber.await), false)),
    children: internal_core/* map */.UID(forEachParUnbounded(fibers, fiber => fiber.children, false), esm_Array/* flatten */.xH),
    inheritAll: internal_core/* forEachSequentialDiscard */.EaP(fibers, fiber => fiber.inheritAll),
    poll: internal_core/* map */.UID(internal_core/* forEachSequential */.o9$(fibers, fiber => fiber.poll), esm_Array/* reduceRight */.nq(esm_Option/* some */.G(internal_core/* exitSucceed */.SID(new Array())), (optionB, optionA) => {
      switch (optionA._tag) {
        case "None":
          {
            return esm_Option/* none */.YP();
          }
        case "Some":
          {
            switch (optionB._tag) {
              case "None":
                {
                  return esm_Option/* none */.YP();
                }
              case "Some":
                {
                  return esm_Option/* some */.G(internal_core/* exitZipWith */.dG6(optionA.value, optionB.value, {
                    onSuccess: (a, chunk) => [a, ...chunk],
                    onFailure: internal_cause/* parallel */.Mf
                  }));
                }
            }
          }
      }
    })),
    interruptAsFork: fiberId => internal_core/* forEachSequentialDiscard */.EaP(fibers, fiber => fiber.interruptAsFork(fiberId))
  };
  return _fiberAll;
};
/* @internal */
const fiberInterruptFork = self => internal_core/* asVoid */.a2S(fiberRuntime_forkDaemon(internal_core/* interruptFiber */.u_W(self)));
/* @internal */
const fiberJoinAll = fibers => internal_fiber/* join */.v_(fiberAll(fibers));
/* @internal */
const fiberScoped = self => fiberRuntime_acquireRelease(internal_core/* succeed */.ng0(self), internal_core/* interruptFiber */.u_W);
//
// circular race
//
/** @internal */
const raceWith = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, other, options) => raceFibersWith(self, other, {
  onSelfWin: (winner, loser) => internal_core/* flatMap */.VSD(winner.await, exit => {
    switch (exit._tag) {
      case opCodes_effect/* OP_SUCCESS */.x$:
        {
          return internal_core/* flatMap */.VSD(winner.inheritAll, () => options.onSelfDone(exit, loser));
        }
      case opCodes_effect/* OP_FAILURE */.N4:
        {
          return options.onSelfDone(exit, loser);
        }
    }
  }),
  onOtherWin: (winner, loser) => internal_core/* flatMap */.VSD(winner.await, exit => {
    switch (exit._tag) {
      case opCodes_effect/* OP_SUCCESS */.x$:
        {
          return internal_core/* flatMap */.VSD(winner.inheritAll, () => options.onOtherDone(exit, loser));
        }
      case opCodes_effect/* OP_FAILURE */.N4:
        {
          return options.onOtherDone(exit, loser);
        }
    }
  })
}));
/** @internal */
const disconnect = self => internal_core/* uninterruptibleMask */.UO$(restore => internal_core/* fiberIdWith */.mrY(fiberId => internal_core/* flatMap */.VSD(fiberRuntime_forkDaemon(restore(self)), fiber => (0,Function/* pipe */.zG)(restore(internal_fiber/* join */.v_(fiber)), internal_core/* onInterrupt */.J7b(() => (0,Function/* pipe */.zG)(fiber, internal_fiber/* interruptAsFork */.Mt(fiberId)))))));
/** @internal */
const fiberRuntime_race = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => internal_core/* fiberIdWith */.mrY(parentFiberId => raceWith(self, that, {
  onSelfDone: (exit, right) => internal_core/* exitMatchEffect */.aoR(exit, {
    onFailure: cause => (0,Function/* pipe */.zG)(internal_fiber/* join */.v_(right), core_effect/* mapErrorCause */.$p(cause2 => internal_cause/* parallel */.Mf(cause, cause2))),
    onSuccess: value => (0,Function/* pipe */.zG)(right, internal_core/* interruptAsFiber */.zU1(parentFiberId), internal_core.as(value))
  }),
  onOtherDone: (exit, left) => internal_core/* exitMatchEffect */.aoR(exit, {
    onFailure: cause => (0,Function/* pipe */.zG)(internal_fiber/* join */.v_(left), core_effect/* mapErrorCause */.$p(cause2 => internal_cause/* parallel */.Mf(cause2, cause))),
    onSuccess: value => (0,Function/* pipe */.zG)(left, internal_core/* interruptAsFiber */.zU1(parentFiberId), internal_core.as(value))
  })
})));
/** @internal */
const raceFibersWith = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, other, options) => internal_core/* withFiberRuntime */.ECC((parentFiber, parentStatus) => {
  const parentRuntimeFlags = parentStatus.runtimeFlags;
  const raceIndicator = MutableRef/* make */.Sy(true);
  const leftFiber = unsafeMakeChildFiber(self, parentFiber, parentRuntimeFlags, options.selfScope);
  const rightFiber = unsafeMakeChildFiber(other, parentFiber, parentRuntimeFlags, options.otherScope);
  return internal_core/* async */.PFx(cb => {
    leftFiber.addObserver(() => completeRace(leftFiber, rightFiber, options.onSelfWin, raceIndicator, cb));
    rightFiber.addObserver(() => completeRace(rightFiber, leftFiber, options.onOtherWin, raceIndicator, cb));
    leftFiber.startFork(self);
    rightFiber.startFork(other);
  }, FiberId/* combine */.$e(leftFiber.id(), rightFiber.id()));
}));
const completeRace = (winner, loser, cont, ab, cb) => {
  if (MutableRef/* compareAndSet */.te(true, false)(ab)) {
    cb(cont(winner, loser));
  }
};
/** @internal */
const fiberRuntime_ensuring = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, finalizer) => internal_core/* uninterruptibleMask */.UO$(restore => internal_core/* matchCauseEffect */.Bpg(restore(self), {
  onFailure: cause1 => internal_core/* matchCauseEffect */.Bpg(finalizer, {
    onFailure: cause2 => internal_core/* failCause */.DhG(internal_cause/* sequential */.Pe(cause1, cause2)),
    onSuccess: () => internal_core/* failCause */.DhG(cause1)
  }),
  onSuccess: a => internal_core.as(finalizer, a)
})));
/** @internal */
const invokeWithInterrupt = (self, entries, onInterrupt) => internal_core/* fiberIdWith */.mrY(id => internal_core/* flatMap */.VSD(internal_core/* flatMap */.VSD(fiberRuntime_forkDaemon(internal_core/* interruptible */.um_(self)), processing => internal_core/* async */.PFx(cb => {
  const counts = entries.map(_ => _.listeners.count);
  const checkDone = () => {
    if (counts.every(count => count === 0)) {
      if (entries.every(_ => {
        if (_.result.state.current._tag === "Pending") {
          return true;
        } else if (_.result.state.current._tag === "Done" && internal_core/* exitIsExit */.fX8(_.result.state.current.effect) && _.result.state.current.effect._tag === "Failure" && internal_cause/* isInterrupted */.td(_.result.state.current.effect.cause)) {
          return true;
        } else {
          return false;
        }
      })) {
        cleanup.forEach(f => f());
        onInterrupt?.();
        cb(internal_core/* interruptFiber */.u_W(processing));
      }
    }
  };
  processing.addObserver(exit => {
    cleanup.forEach(f => f());
    cb(exit);
  });
  const cleanup = entries.map((r, i) => {
    const observer = count => {
      counts[i] = count;
      checkDone();
    };
    r.listeners.addObserver(observer);
    return () => r.listeners.removeObserver(observer);
  });
  checkDone();
  return internal_core/* sync */.Z_X(() => {
    cleanup.forEach(f => f());
  });
})), () => internal_core/* suspend */.RqG(() => {
  const residual = entries.flatMap(entry => {
    if (!entry.state.completed) {
      return [entry];
    }
    return [];
  });
  return internal_core/* forEachSequentialDiscard */.EaP(residual, entry => (0,request/* complete */.N)(entry.request, internal_core/* exitInterrupt */.eq6(id)));
})));
/** @internal */
const interruptWhenPossible = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, all) => internal_core/* fiberRefGetWith */.$Dw(completedRequestMap/* currentRequestMap */.d, map => internal_core/* suspend */.RqG(() => {
  const entries = esm_Array/* fromIterable */.EE(all).flatMap(_ => map.has(_) ? [map.get(_)] : []);
  return invokeWithInterrupt(self, entries);
})));
// circular Tracer
/** @internal */
const makeSpanScoped = (name, options) => {
  options = internal_tracer/* addSpanStackTrace */.W8(options);
  return internal_core/* uninterruptible */.wUc(internal_core/* withFiberRuntime */.ECC(fiber => {
    const scope = esm_Context/* unsafeGet */.MH(fiber.getFiberRef(internal_core/* currentContext */.gbX), scopeTag);
    const span = core_effect/* unsafeMakeSpan */.u1(fiber, name, options);
    const timingEnabled = fiber.getFiberRef(internal_core/* currentTracerTimingEnabled */.of8);
    const clock_ = esm_Context/* get */.U2(fiber.getFiberRef(internal_defaultServices/* currentServices */.Pm), clock/* clockTag */.GL);
    return internal_core.as(internal_core/* scopeAddFinalizerExit */.veJ(scope, exit => core_effect/* endSpan */.n5(span, exit, clock_, timingEnabled)), span);
  }));
};
/* @internal */
const withTracerScoped = value => fiberRefLocallyScopedWith(internal_defaultServices/* currentServices */.Pm, esm_Context/* add */.IH(internal_tracer/* tracerTag */.Fl, value));
/** @internal */
const withSpanScoped = function () {
  const dataFirst = typeof arguments[0] !== "string";
  const name = dataFirst ? arguments[1] : arguments[0];
  const options = internal_tracer/* addSpanStackTrace */.W8(dataFirst ? arguments[2] : arguments[1]);
  if (dataFirst) {
    const self = arguments[0];
    return internal_core/* flatMap */.VSD(makeSpanScoped(name, internal_tracer/* addSpanStackTrace */.W8(options)), span => core_effect/* provideService */.aH(self, internal_tracer/* spanTag */.N7, span));
  }
  return self => internal_core/* flatMap */.VSD(makeSpanScoped(name, internal_tracer/* addSpanStackTrace */.W8(options)), span => core_effect/* provideService */.aH(self, internal_tracer/* spanTag */.N7, span));
};
//# sourceMappingURL=fiberRuntime.js.map

/***/ }),

/***/ 51770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_A": function() { return /* binding */ globalScope; },
/* harmony export */   "t0": function() { return /* binding */ unsafeMake; }
/* harmony export */ });
/* unused harmony export FiberScopeTypeId */
/* harmony import */ var _FiberId_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57303);
/* harmony import */ var _GlobalValue_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4726);
/* harmony import */ var _fiberMessage_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48282);



/** @internal */
const FiberScopeSymbolKey = "effect/FiberScope";
/** @internal */
const FiberScopeTypeId = /*#__PURE__*/Symbol.for(FiberScopeSymbolKey);
/** @internal */
class Global {
  [FiberScopeTypeId] = FiberScopeTypeId;
  fiberId = _FiberId_js__WEBPACK_IMPORTED_MODULE_0__/* .none */ .YP;
  roots = /*#__PURE__*/new Set();
  add(_runtimeFlags, child) {
    this.roots.add(child);
    child.addObserver(() => {
      this.roots.delete(child);
    });
  }
}
/** @internal */
class Local {
  fiberId;
  parent;
  [FiberScopeTypeId] = FiberScopeTypeId;
  constructor(fiberId, parent) {
    this.fiberId = fiberId;
    this.parent = parent;
  }
  add(_runtimeFlags, child) {
    this.parent.tell(_fiberMessage_js__WEBPACK_IMPORTED_MODULE_1__/* .stateful */ .dQ(parentFiber => {
      parentFiber.addChild(child);
      child.addObserver(() => {
        parentFiber.removeChild(child);
      });
    }));
  }
}
/** @internal */
const unsafeMake = fiber => {
  return new Local(fiber.id(), fiber);
};
/** @internal */
const globalScope = /*#__PURE__*/(0,_GlobalValue_js__WEBPACK_IMPORTED_MODULE_2__/* .globalValue */ .K)( /*#__PURE__*/Symbol.for("effect/FiberScope/Global"), () => new Global());
//# sourceMappingURL=fiberScope.js.map

/***/ }),

/***/ 67733:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yh": function() { return /* binding */ HashMapTypeId; },
  "iy": function() { return /* binding */ beginMutation; },
  "oA": function() { return /* binding */ compact; },
  "cS": function() { return /* binding */ empty; },
  "Rx": function() { return /* binding */ endMutation; },
  "qh": function() { return /* binding */ entries; },
  "yW": function() { return /* binding */ every; },
  "hX": function() { return /* binding */ filter; },
  "DZ": function() { return /* binding */ filterMap; },
  "Ew": function() { return /* binding */ findFirst; },
  "VS": function() { return /* binding */ flatMap; },
  "Ed": function() { return /* binding */ forEach; },
  "EE": function() { return /* binding */ fromIterable; },
  "U2": function() { return /* binding */ get; },
  "XR": function() { return /* binding */ getHash; },
  "e$": function() { return /* binding */ has; },
  "u9": function() { return /* binding */ hasHash; },
  "xb": function() { return /* binding */ isEmpty; },
  "c8": function() { return /* binding */ isHashMap; },
  "XP": function() { return /* binding */ keys; },
  "Sy": function() { return /* binding */ hashMap_make; },
  "UI": function() { return /* binding */ map; },
  "Pj": function() { return /* binding */ modify; },
  "cq": function() { return /* binding */ modifyAt; },
  "Hp": function() { return /* binding */ modifyHash; },
  "JG": function() { return /* binding */ mutate; },
  "u4": function() { return /* binding */ reduce; },
  "Od": function() { return /* binding */ remove; },
  "CS": function() { return /* binding */ removeMany; },
  "t8": function() { return /* binding */ set; },
  "dp": function() { return /* binding */ size; },
  "G": function() { return /* binding */ some; },
  "G0": function() { return /* binding */ union; },
  "MH": function() { return /* binding */ unsafeGet; },
  "VO": function() { return /* binding */ values; }
});

// UNUSED EXPORTS: setTree

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equal.js
var Equal = __webpack_require__(67492);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Hash.js
var Hash = __webpack_require__(89379);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Inspectable.js
var Inspectable = __webpack_require__(16371);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Pipeable.js
var Pipeable = __webpack_require__(92817);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var Predicate = __webpack_require__(71335);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/hashMap/config.js
/** @internal */
const SIZE = 5;
/** @internal */
const BUCKET_SIZE = /*#__PURE__*/Math.pow(2, SIZE);
/** @internal */
const MASK = BUCKET_SIZE - 1;
/** @internal */
const MAX_INDEX_NODE = BUCKET_SIZE / 2;
/** @internal */
const MIN_ARRAY_NODE = BUCKET_SIZE / 4;
//# sourceMappingURL=config.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/hashMap/bitwise.js

/**
 * Hamming weight.
 *
 * Taken from: http://jsperf.com/hamming-weight
 *
 * @internal
 */
function popcount(x) {
  x -= x >> 1 & 0x55555555;
  x = (x & 0x33333333) + (x >> 2 & 0x33333333);
  x = x + (x >> 4) & 0x0f0f0f0f;
  x += x >> 8;
  x += x >> 16;
  return x & 0x7f;
}
/** @internal */
function hashFragment(shift, h) {
  return h >>> shift & MASK;
}
/** @internal */
function toBitmap(x) {
  return 1 << x;
}
/** @internal */
function fromBitmap(bitmap, bit) {
  return popcount(bitmap & bit - 1);
}
//# sourceMappingURL=bitwise.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/stack.js
const make = (value, previous) => ({
  value,
  previous
});
//# sourceMappingURL=stack.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/hashMap/array.js
/** @internal */
function arrayUpdate(mutate, at, v, arr) {
  let out = arr;
  if (!mutate) {
    const len = arr.length;
    out = new Array(len);
    for (let i = 0; i < len; ++i) out[i] = arr[i];
  }
  out[at] = v;
  return out;
}
/** @internal */
function arraySpliceOut(mutate, at, arr) {
  const newLen = arr.length - 1;
  let i = 0;
  let g = 0;
  let out = arr;
  if (mutate) {
    i = g = at;
  } else {
    out = new Array(newLen);
    while (i < at) out[g++] = arr[i++];
  }
  ;
  ++i;
  while (i <= newLen) out[g++] = arr[i++];
  if (mutate) {
    out.length = newLen;
  }
  return out;
}
/** @internal */
function arraySpliceIn(mutate, at, v, arr) {
  const len = arr.length;
  if (mutate) {
    let i = len;
    while (i >= at) arr[i--] = arr[i];
    arr[at] = v;
    return arr;
  }
  let i = 0,
    g = 0;
  const out = new Array(len + 1);
  while (i < at) out[g++] = arr[i++];
  out[at] = v;
  while (i < len) out[++g] = arr[i++];
  return out;
}
//# sourceMappingURL=array.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/hashMap/node.js







/** @internal */
class EmptyNode {
  _tag = "EmptyNode";
  modify(edit, _shift, f, hash, key, size) {
    const v = f(Option/* none */.YP());
    if (Option/* isNone */.Wi(v)) return new EmptyNode();
    ++size.value;
    return new LeafNode(edit, hash, key, v);
  }
}
/** @internal */
function isEmptyNode(a) {
  return (0,Predicate/* isTagged */.Bd)(a, "EmptyNode");
}
/** @internal */
function isLeafNode(node) {
  return isEmptyNode(node) || node._tag === "LeafNode" || node._tag === "CollisionNode";
}
/** @internal */
function canEditNode(node, edit) {
  return isEmptyNode(node) ? false : edit === node.edit;
}
/** @internal */
class LeafNode {
  edit;
  hash;
  key;
  value;
  _tag = "LeafNode";
  constructor(edit, hash, key, value) {
    this.edit = edit;
    this.hash = hash;
    this.key = key;
    this.value = value;
  }
  modify(edit, shift, f, hash, key, size) {
    if ((0,Equal/* equals */.fS)(key, this.key)) {
      const v = f(this.value);
      if (v === this.value) return this;else if (Option/* isNone */.Wi(v)) {
        ;
        --size.value;
        return new EmptyNode();
      }
      if (canEditNode(this, edit)) {
        this.value = v;
        return this;
      }
      return new LeafNode(edit, hash, key, v);
    }
    const v = f(Option/* none */.YP());
    if (Option/* isNone */.Wi(v)) return this;
    ++size.value;
    return mergeLeaves(edit, shift, this.hash, this, hash, new LeafNode(edit, hash, key, v));
  }
}
/** @internal */
class CollisionNode {
  edit;
  hash;
  children;
  _tag = "CollisionNode";
  constructor(edit, hash, children) {
    this.edit = edit;
    this.hash = hash;
    this.children = children;
  }
  modify(edit, shift, f, hash, key, size) {
    if (hash === this.hash) {
      const canEdit = canEditNode(this, edit);
      const list = this.updateCollisionList(canEdit, edit, this.hash, this.children, f, key, size);
      if (list === this.children) return this;
      return list.length > 1 ? new CollisionNode(edit, this.hash, list) : list[0]; // collapse single element collision list
    }
    const v = f(Option/* none */.YP());
    if (Option/* isNone */.Wi(v)) return this;
    ++size.value;
    return mergeLeaves(edit, shift, this.hash, this, hash, new LeafNode(edit, hash, key, v));
  }
  updateCollisionList(mutate, edit, hash, list, f, key, size) {
    const len = list.length;
    for (let i = 0; i < len; ++i) {
      const child = list[i];
      if ("key" in child && (0,Equal/* equals */.fS)(key, child.key)) {
        const value = child.value;
        const newValue = f(value);
        if (newValue === value) return list;
        if (Option/* isNone */.Wi(newValue)) {
          ;
          --size.value;
          return arraySpliceOut(mutate, i, list);
        }
        return arrayUpdate(mutate, i, new LeafNode(edit, hash, key, newValue), list);
      }
    }
    const newValue = f(Option/* none */.YP());
    if (Option/* isNone */.Wi(newValue)) return list;
    ++size.value;
    return arrayUpdate(mutate, len, new LeafNode(edit, hash, key, newValue), list);
  }
}
/** @internal */
class IndexedNode {
  edit;
  mask;
  children;
  _tag = "IndexedNode";
  constructor(edit, mask, children) {
    this.edit = edit;
    this.mask = mask;
    this.children = children;
  }
  modify(edit, shift, f, hash, key, size) {
    const mask = this.mask;
    const children = this.children;
    const frag = hashFragment(shift, hash);
    const bit = toBitmap(frag);
    const indx = fromBitmap(mask, bit);
    const exists = mask & bit;
    const canEdit = canEditNode(this, edit);
    if (!exists) {
      const _newChild = new EmptyNode().modify(edit, shift + SIZE, f, hash, key, size);
      if (!_newChild) return this;
      return children.length >= MAX_INDEX_NODE ? expand(edit, frag, _newChild, mask, children) : new IndexedNode(edit, mask | bit, arraySpliceIn(canEdit, indx, _newChild, children));
    }
    const current = children[indx];
    const child = current.modify(edit, shift + SIZE, f, hash, key, size);
    if (current === child) return this;
    let bitmap = mask;
    let newChildren;
    if (isEmptyNode(child)) {
      // remove
      bitmap &= ~bit;
      if (!bitmap) return new EmptyNode();
      if (children.length <= 2 && isLeafNode(children[indx ^ 1])) {
        return children[indx ^ 1]; // collapse
      }
      newChildren = arraySpliceOut(canEdit, indx, children);
    } else {
      // modify
      newChildren = arrayUpdate(canEdit, indx, child, children);
    }
    if (canEdit) {
      this.mask = bitmap;
      this.children = newChildren;
      return this;
    }
    return new IndexedNode(edit, bitmap, newChildren);
  }
}
/** @internal */
class ArrayNode {
  edit;
  size;
  children;
  _tag = "ArrayNode";
  constructor(edit, size, children) {
    this.edit = edit;
    this.size = size;
    this.children = children;
  }
  modify(edit, shift, f, hash, key, size) {
    let count = this.size;
    const children = this.children;
    const frag = hashFragment(shift, hash);
    const child = children[frag];
    const newChild = (child || new EmptyNode()).modify(edit, shift + SIZE, f, hash, key, size);
    if (child === newChild) return this;
    const canEdit = canEditNode(this, edit);
    let newChildren;
    if (isEmptyNode(child) && !isEmptyNode(newChild)) {
      // add
      ;
      ++count;
      newChildren = arrayUpdate(canEdit, frag, newChild, children);
    } else if (!isEmptyNode(child) && isEmptyNode(newChild)) {
      // remove
      ;
      --count;
      if (count <= MIN_ARRAY_NODE) {
        return pack(edit, count, frag, children);
      }
      newChildren = arrayUpdate(canEdit, frag, new EmptyNode(), children);
    } else {
      // modify
      newChildren = arrayUpdate(canEdit, frag, newChild, children);
    }
    if (canEdit) {
      this.size = count;
      this.children = newChildren;
      return this;
    }
    return new ArrayNode(edit, count, newChildren);
  }
}
function pack(edit, count, removed, elements) {
  const children = new Array(count - 1);
  let g = 0;
  let bitmap = 0;
  for (let i = 0, len = elements.length; i < len; ++i) {
    if (i !== removed) {
      const elem = elements[i];
      if (elem && !isEmptyNode(elem)) {
        children[g++] = elem;
        bitmap |= 1 << i;
      }
    }
  }
  return new IndexedNode(edit, bitmap, children);
}
function expand(edit, frag, child, bitmap, subNodes) {
  const arr = [];
  let bit = bitmap;
  let count = 0;
  for (let i = 0; bit; ++i) {
    if (bit & 1) arr[i] = subNodes[count++];
    bit >>>= 1;
  }
  arr[frag] = child;
  return new ArrayNode(edit, count + 1, arr);
}
function mergeLeavesInner(edit, shift, h1, n1, h2, n2) {
  if (h1 === h2) return new CollisionNode(edit, h1, [n2, n1]);
  const subH1 = hashFragment(shift, h1);
  const subH2 = hashFragment(shift, h2);
  if (subH1 === subH2) {
    return child => new IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), [child]);
  } else {
    const children = subH1 < subH2 ? [n1, n2] : [n2, n1];
    return new IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), children);
  }
}
function mergeLeaves(edit, shift, h1, n1, h2, n2) {
  let stack = undefined;
  let currentShift = shift;
  while (true) {
    const res = mergeLeavesInner(edit, currentShift, h1, n1, h2, n2);
    if (typeof res === "function") {
      stack = make(res, stack);
      currentShift = currentShift + SIZE;
    } else {
      let final = res;
      while (stack != null) {
        final = stack.value(final);
        stack = stack.previous;
      }
      return final;
    }
  }
}
//# sourceMappingURL=node.js.map
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/hashMap.js











const HashMapSymbolKey = "effect/HashMap";
/** @internal */
const HashMapTypeId = /*#__PURE__*/Symbol.for(HashMapSymbolKey);
const HashMapProto = {
  [HashMapTypeId]: HashMapTypeId,
  [Symbol.iterator]() {
    return new HashMapIterator(this, (k, v) => [k, v]);
  },
  [Hash/* symbol */.NA]() {
    let hash = Hash/* hash */.vp(HashMapSymbolKey);
    for (const item of this) {
      hash ^= (0,Function/* pipe */.zG)(Hash/* hash */.vp(item[0]), Hash/* combine */.$e(Hash/* hash */.vp(item[1])));
    }
    return Hash/* cached */.HX(this, hash);
  },
  [Equal/* symbol */.NA](that) {
    if (isHashMap(that)) {
      if (that._size !== this._size) {
        return false;
      }
      for (const item of this) {
        const elem = (0,Function/* pipe */.zG)(that, getHash(item[0], Hash/* hash */.vp(item[0])));
        if (Option/* isNone */.Wi(elem)) {
          return false;
        } else {
          if (!Equal/* equals */.fS(item[1], elem.value)) {
            return false;
          }
        }
      }
      return true;
    }
    return false;
  },
  toString() {
    return (0,Inspectable/* format */.WU)(this.toJSON());
  },
  toJSON() {
    return {
      _id: "HashMap",
      values: Array.from(this).map(Inspectable/* toJSON */.au)
    };
  },
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return this.toJSON();
  },
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
};
const makeImpl = (editable, edit, root, size) => {
  const map = Object.create(HashMapProto);
  map._editable = editable;
  map._edit = edit;
  map._root = root;
  map._size = size;
  return map;
};
class HashMapIterator {
  map;
  f;
  v;
  constructor(map, f) {
    this.map = map;
    this.f = f;
    this.v = visitLazy(this.map._root, this.f, undefined);
  }
  next() {
    if (Option/* isNone */.Wi(this.v)) {
      return {
        done: true,
        value: undefined
      };
    }
    const v0 = this.v.value;
    this.v = applyCont(v0.cont);
    return {
      done: false,
      value: v0.value
    };
  }
  [Symbol.iterator]() {
    return new HashMapIterator(this.map, this.f);
  }
}
const applyCont = cont => cont ? visitLazyChildren(cont[0], cont[1], cont[2], cont[3], cont[4]) : Option/* none */.YP();
const visitLazy = (node, f, cont = undefined) => {
  switch (node._tag) {
    case "LeafNode":
      {
        if (Option/* isSome */.pC(node.value)) {
          return Option/* some */.G({
            value: f(node.key, node.value.value),
            cont
          });
        }
        return applyCont(cont);
      }
    case "CollisionNode":
    case "ArrayNode":
    case "IndexedNode":
      {
        const children = node.children;
        return visitLazyChildren(children.length, children, 0, f, cont);
      }
    default:
      {
        return applyCont(cont);
      }
  }
};
const visitLazyChildren = (len, children, i, f, cont) => {
  while (i < len) {
    const child = children[i++];
    if (child && !isEmptyNode(child)) {
      return visitLazy(child, f, [len, children, i, f, cont]);
    }
  }
  return applyCont(cont);
};
const _empty = /*#__PURE__*/makeImpl(false, 0, /*#__PURE__*/new EmptyNode(), 0);
/** @internal */
const empty = () => _empty;
/** @internal */
const hashMap_make = (...entries) => fromIterable(entries);
/** @internal */
const fromIterable = entries => {
  const map = beginMutation(empty());
  for (const entry of entries) {
    set(map, entry[0], entry[1]);
  }
  return endMutation(map);
};
/** @internal */
const isHashMap = u => (0,Predicate/* hasProperty */.l$)(u, HashMapTypeId);
/** @internal */
const isEmpty = self => self && isEmptyNode(self._root);
/** @internal */
const get = /*#__PURE__*/Function/* dual */.OB(2, (self, key) => getHash(self, key, Hash/* hash */.vp(key)));
/** @internal */
const getHash = /*#__PURE__*/Function/* dual */.OB(3, (self, key, hash) => {
  let node = self._root;
  let shift = 0;
  while (true) {
    switch (node._tag) {
      case "LeafNode":
        {
          return Equal/* equals */.fS(key, node.key) ? node.value : Option/* none */.YP();
        }
      case "CollisionNode":
        {
          if (hash === node.hash) {
            const children = node.children;
            for (let i = 0, len = children.length; i < len; ++i) {
              const child = children[i];
              if ("key" in child && Equal/* equals */.fS(key, child.key)) {
                return child.value;
              }
            }
          }
          return Option/* none */.YP();
        }
      case "IndexedNode":
        {
          const frag = hashFragment(shift, hash);
          const bit = toBitmap(frag);
          if (node.mask & bit) {
            node = node.children[fromBitmap(node.mask, bit)];
            shift += SIZE;
            break;
          }
          return Option/* none */.YP();
        }
      case "ArrayNode":
        {
          node = node.children[hashFragment(shift, hash)];
          if (node) {
            shift += SIZE;
            break;
          }
          return Option/* none */.YP();
        }
      default:
        return Option/* none */.YP();
    }
  }
});
/** @internal */
const unsafeGet = /*#__PURE__*/Function/* dual */.OB(2, (self, key) => {
  const element = getHash(self, key, Hash/* hash */.vp(key));
  if (Option/* isNone */.Wi(element)) {
    throw new Error("Expected map to contain key");
  }
  return element.value;
});
/** @internal */
const has = /*#__PURE__*/Function/* dual */.OB(2, (self, key) => Option/* isSome */.pC(getHash(self, key, Hash/* hash */.vp(key))));
/** @internal */
const hasHash = /*#__PURE__*/Function/* dual */.OB(3, (self, key, hash) => Option/* isSome */.pC(getHash(self, key, hash)));
/** @internal */
const set = /*#__PURE__*/Function/* dual */.OB(3, (self, key, value) => modifyAt(self, key, () => Option/* some */.G(value)));
/** @internal */
const setTree = /*#__PURE__*/Function/* dual */.OB(3, (self, newRoot, newSize) => {
  if (self._editable) {
    ;
    self._root = newRoot;
    self._size = newSize;
    return self;
  }
  return newRoot === self._root ? self : makeImpl(self._editable, self._edit, newRoot, newSize);
});
/** @internal */
const keys = self => new HashMapIterator(self, key => key);
/** @internal */
const values = self => new HashMapIterator(self, (_, value) => value);
/** @internal */
const entries = self => new HashMapIterator(self, (key, value) => [key, value]);
/** @internal */
const size = self => self._size;
/** @internal */
const beginMutation = self => makeImpl(true, self._edit + 1, self._root, self._size);
/** @internal */
const endMutation = self => {
  ;
  self._editable = false;
  return self;
};
/** @internal */
const mutate = /*#__PURE__*/Function/* dual */.OB(2, (self, f) => {
  const transient = beginMutation(self);
  f(transient);
  return endMutation(transient);
});
/** @internal */
const modifyAt = /*#__PURE__*/Function/* dual */.OB(3, (self, key, f) => modifyHash(self, key, Hash/* hash */.vp(key), f));
/** @internal */
const modifyHash = /*#__PURE__*/Function/* dual */.OB(4, (self, key, hash, f) => {
  const size = {
    value: self._size
  };
  const newRoot = self._root.modify(self._editable ? self._edit : NaN, 0, f, hash, key, size);
  return (0,Function/* pipe */.zG)(self, setTree(newRoot, size.value));
});
/** @internal */
const modify = /*#__PURE__*/Function/* dual */.OB(3, (self, key, f) => modifyAt(self, key, Option/* map */.UI(f)));
/** @internal */
const union = /*#__PURE__*/Function/* dual */.OB(2, (self, that) => {
  const result = beginMutation(self);
  forEach(that, (v, k) => set(result, k, v));
  return endMutation(result);
});
/** @internal */
const remove = /*#__PURE__*/Function/* dual */.OB(2, (self, key) => modifyAt(self, key, Option/* none */.YP));
/** @internal */
const removeMany = /*#__PURE__*/Function/* dual */.OB(2, (self, keys) => mutate(self, map => {
  for (const key of keys) {
    remove(key)(map);
  }
}));
/**
 * Maps over the entries of the `HashMap` using the specified function.
 *
 * @since 2.0.0
 * @category mapping
 */
const map = /*#__PURE__*/Function/* dual */.OB(2, (self, f) => reduce(self, empty(), (map, value, key) => set(map, key, f(value, key))));
/** @internal */
const flatMap = /*#__PURE__*/Function/* dual */.OB(2, (self, f) => reduce(self, empty(), (zero, value, key) => mutate(zero, map => forEach(f(value, key), (value, key) => set(map, key, value)))));
/** @internal */
const forEach = /*#__PURE__*/Function/* dual */.OB(2, (self, f) => reduce(self, void 0, (_, value, key) => f(value, key)));
/** @internal */
const reduce = /*#__PURE__*/Function/* dual */.OB(3, (self, zero, f) => {
  const root = self._root;
  if (root._tag === "LeafNode") {
    return Option/* isSome */.pC(root.value) ? f(zero, root.value.value, root.key) : zero;
  }
  if (root._tag === "EmptyNode") {
    return zero;
  }
  const toVisit = [root.children];
  let children;
  while (children = toVisit.pop()) {
    for (let i = 0, len = children.length; i < len;) {
      const child = children[i++];
      if (child && !isEmptyNode(child)) {
        if (child._tag === "LeafNode") {
          if (Option/* isSome */.pC(child.value)) {
            zero = f(zero, child.value.value, child.key);
          }
        } else {
          toVisit.push(child.children);
        }
      }
    }
  }
  return zero;
});
/** @internal */
const filter = /*#__PURE__*/Function/* dual */.OB(2, (self, f) => mutate(empty(), map => {
  for (const [k, a] of self) {
    if (f(a, k)) {
      set(map, k, a);
    }
  }
}));
/** @internal */
const compact = self => filterMap(self, Function/* identity */.yR);
/** @internal */
const filterMap = /*#__PURE__*/Function/* dual */.OB(2, (self, f) => mutate(empty(), map => {
  for (const [k, a] of self) {
    const option = f(a, k);
    if (Option/* isSome */.pC(option)) {
      set(map, k, option.value);
    }
  }
}));
/** @internal */
const findFirst = /*#__PURE__*/Function/* dual */.OB(2, (self, predicate) => {
  for (const ka of self) {
    if (predicate(ka[1], ka[0])) {
      return Option/* some */.G(ka);
    }
  }
  return Option/* none */.YP();
});
/** @internal */
const some = /*#__PURE__*/Function/* dual */.OB(2, (self, predicate) => {
  for (const ka of self) {
    if (predicate(ka[1], ka[0])) {
      return true;
    }
  }
  return false;
});
/** @internal */
const every = /*#__PURE__*/Function/* dual */.OB(2, (self, predicate) => !some(self, (a, k) => !predicate(a, k)));
//# sourceMappingURL=hashMap.js.map

/***/ }),

/***/ 686:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EE": function() { return /* binding */ fromIterable; },
/* harmony export */   "Ed": function() { return /* binding */ forEach; },
/* harmony export */   "G": function() { return /* binding */ some; },
/* harmony export */   "G0": function() { return /* binding */ union; },
/* harmony export */   "IH": function() { return /* binding */ add; },
/* harmony export */   "JG": function() { return /* binding */ mutate; },
/* harmony export */   "KX": function() { return /* binding */ isSubset; },
/* harmony export */   "Od": function() { return /* binding */ remove; },
/* harmony export */   "Rd": function() { return /* binding */ makeImpl; },
/* harmony export */   "Rx": function() { return /* binding */ endMutation; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "TG": function() { return /* binding */ HashSetTypeId; },
/* harmony export */   "Tx": function() { return /* binding */ isHashSet; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "VO": function() { return /* binding */ values; },
/* harmony export */   "VS": function() { return /* binding */ flatMap; },
/* harmony export */   "ZN": function() { return /* binding */ toggle; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "dp": function() { return /* binding */ size; },
/* harmony export */   "e$": function() { return /* binding */ has; },
/* harmony export */   "e5": function() { return /* binding */ difference; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "iy": function() { return /* binding */ beginMutation; },
/* harmony export */   "jV": function() { return /* binding */ intersection; },
/* harmony export */   "u4": function() { return /* binding */ reduce; },
/* harmony export */   "uK": function() { return /* binding */ partition; },
/* harmony export */   "yW": function() { return /* binding */ every; }
/* harmony export */ });
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67492);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17316);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89379);
/* harmony import */ var _Inspectable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16371);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92817);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71335);
/* harmony import */ var _hashMap_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67733);







const HashSetSymbolKey = "effect/HashSet";
/** @internal */
const HashSetTypeId = /*#__PURE__*/Symbol.for(HashSetSymbolKey);
const HashSetProto = {
  [HashSetTypeId]: HashSetTypeId,
  [Symbol.iterator]() {
    return _hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .keys */ .XP(this._keyMap);
  },
  [_Hash_js__WEBPACK_IMPORTED_MODULE_1__/* .symbol */ .NA]() {
    return _Hash_js__WEBPACK_IMPORTED_MODULE_1__/* .cached */ .HX(this, _Hash_js__WEBPACK_IMPORTED_MODULE_1__/* .combine */ .$e(_Hash_js__WEBPACK_IMPORTED_MODULE_1__/* .hash */ .vp(this._keyMap))(_Hash_js__WEBPACK_IMPORTED_MODULE_1__/* .hash */ .vp(HashSetSymbolKey)));
  },
  [_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .symbol */ .NA](that) {
    if (isHashSet(that)) {
      return _hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .size */ .dp(this._keyMap) === _hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .size */ .dp(that._keyMap) && _Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .equals */ .fS(this._keyMap, that._keyMap);
    }
    return false;
  },
  toString() {
    return (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_3__/* .format */ .WU)(this.toJSON());
  },
  toJSON() {
    return {
      _id: "HashSet",
      values: Array.from(this).map(_Inspectable_js__WEBPACK_IMPORTED_MODULE_3__/* .toJSON */ .au)
    };
  },
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_3__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  },
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_4__/* .pipeArguments */ .n)(this, arguments);
  }
};
/** @internal */
const makeImpl = keyMap => {
  const set = Object.create(HashSetProto);
  set._keyMap = keyMap;
  return set;
};
/** @internal */
const isHashSet = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_5__/* .hasProperty */ .l$)(u, HashSetTypeId);
const _empty = /*#__PURE__*/makeImpl( /*#__PURE__*/_hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .empty */ .cS());
/** @internal */
const empty = () => _empty;
/** @internal */
const fromIterable = elements => {
  const set = beginMutation(empty());
  for (const value of elements) {
    add(set, value);
  }
  return endMutation(set);
};
/** @internal */
const make = (...elements) => {
  const set = beginMutation(empty());
  for (const value of elements) {
    add(set, value);
  }
  return endMutation(set);
};
/** @internal */
const has = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, value) => _hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .has */ .e$(self._keyMap, value));
/** @internal */
const some = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, f) => {
  let found = false;
  for (const value of self) {
    found = f(value);
    if (found) {
      break;
    }
  }
  return found;
});
/** @internal */
const every = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, refinement) => !some(self, a => !refinement(a)));
/** @internal */
const isSubset = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, that) => every(self, value => has(that, value)));
/** @internal */
const values = self => _hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .keys */ .XP(self._keyMap);
/** @internal */
const size = self => _hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .size */ .dp(self._keyMap);
/** @internal */
const beginMutation = self => makeImpl(_hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .beginMutation */ .iy(self._keyMap));
/** @internal */
const endMutation = self => {
  ;
  self._keyMap._editable = false;
  return self;
};
/** @internal */
const mutate = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, f) => {
  const transient = beginMutation(self);
  f(transient);
  return endMutation(transient);
});
/** @internal */
const add = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, value) => self._keyMap._editable ? (_hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .set */ .t8(value, true)(self._keyMap), self) : makeImpl(_hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .set */ .t8(value, true)(self._keyMap)));
/** @internal */
const remove = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, value) => self._keyMap._editable ? (_hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .remove */ .Od(value)(self._keyMap), self) : makeImpl(_hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .remove */ .Od(value)(self._keyMap)));
/** @internal */
const difference = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, that) => mutate(self, set => {
  for (const value of that) {
    remove(set, value);
  }
}));
/** @internal */
const intersection = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, that) => mutate(empty(), set => {
  for (const value of that) {
    if (has(value)(self)) {
      add(value)(set);
    }
  }
}));
/** @internal */
const union = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, that) => mutate(empty(), set => {
  forEach(self, value => add(set, value));
  for (const value of that) {
    add(set, value);
  }
}));
/** @internal */
const toggle = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, value) => has(self, value) ? remove(self, value) : add(self, value));
/** @internal */
const map = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, f) => mutate(empty(), set => {
  forEach(self, a => {
    const b = f(a);
    if (!has(set, b)) {
      add(set, b);
    }
  });
}));
/** @internal */
const flatMap = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, f) => mutate(empty(), set => {
  forEach(self, a => {
    for (const b of f(a)) {
      if (!has(set, b)) {
        add(set, b);
      }
    }
  });
}));
/** @internal */
const forEach = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, f) => _hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .forEach */ .Ed(self._keyMap, (_, k) => f(k)));
/** @internal */
const reduce = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(3, (self, zero, f) => _hashMap_js__WEBPACK_IMPORTED_MODULE_0__/* .reduce */ .u4(self._keyMap, zero, (z, _, a) => f(z, a)));
/** @internal */
const filter = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, f) => {
  return mutate(empty(), set => {
    const iterator = values(self);
    let next;
    while (!(next = iterator.next()).done) {
      const value = next.value;
      if (f(value)) {
        add(set, value);
      }
    }
  });
});
/** @internal */
const partition = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_6__/* .dual */ .OB)(2, (self, predicate) => {
  const iterator = values(self);
  let next;
  const right = beginMutation(empty());
  const left = beginMutation(empty());
  while (!(next = iterator.next()).done) {
    const value = next.value;
    if (predicate(value)) {
      add(right, value);
    } else {
      add(left, value);
    }
  }
  return [endMutation(left), endMutation(right)];
});
//# sourceMappingURL=hashSet.js.map

/***/ }),

/***/ 58590:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jQ": function() { return /* binding */ CurrentMemoMap; },
  "ow": function() { return /* binding */ LayerTypeId; },
  "$X": function() { return /* binding */ MemoMapTypeId; },
  "z": function() { return /* binding */ annotateLogs; },
  "wV": function() { return /* binding */ annotateSpans; },
  "J_": function() { return /* binding */ build; },
  "eQ": function() { return /* binding */ buildWithMemoMap; },
  "ok": function() { return /* binding */ buildWithScope; },
  "km": function() { return /* binding */ catchAll; },
  "Np": function() { return /* binding */ catchAllCause; },
  "Do": function() { return /* binding */ context; },
  "Xr": function() { return /* binding */ die; },
  "Ag": function() { return /* binding */ dieSync; },
  "eJ": function() { return /* binding */ discard; },
  "uZ": function() { return /* binding */ effect_provide; },
  "cS": function() { return /* binding */ empty; },
  "A2": function() { return /* binding */ extendScope; },
  "bG": function() { return /* binding */ fail; },
  "Dh": function() { return /* binding */ failCause; },
  "eu": function() { return /* binding */ failCauseSync; },
  "zp": function() { return /* binding */ failSync; },
  "EX": function() { return /* binding */ fiberRefLocally; },
  "tX": function() { return /* binding */ fiberRefLocallyScoped; },
  "lS": function() { return /* binding */ fiberRefLocallyScopedWith; },
  "Lz": function() { return /* binding */ fiberRefLocallyWith; },
  "VS": function() { return /* binding */ flatMap; },
  "xH": function() { return /* binding */ flatten; },
  "DQ": function() { return /* binding */ fresh; },
  "SH": function() { return /* binding */ fromEffect; },
  "Cg": function() { return /* binding */ fromEffectContext; },
  "Dg": function() { return /* binding */ fromEffectDiscard; },
  "iT": function() { return /* binding */ fromFunction; },
  "VN": function() { return /* binding */ isFresh; },
  "zS": function() { return /* binding */ isLayer; },
  "uP": function() { return /* binding */ launch; },
  "DM": function() { return /* binding */ locallyEffect; },
  "Qj": function() { return /* binding */ makeMemoMap; },
  "UI": function() { return /* binding */ map; },
  "d1": function() { return /* binding */ mapError; },
  "EQ": function() { return /* binding */ match; },
  "eY": function() { return /* binding */ matchCause; },
  "HP": function() { return /* binding */ memoize; },
  "TS": function() { return /* binding */ merge; },
  "Jn": function() { return /* binding */ mergeAll; },
  "e3": function() { return /* binding */ orDie; },
  "vx": function() { return /* binding */ orElse; },
  "B2": function() { return /* binding */ passthrough; },
  "iV": function() { return /* binding */ project; },
  "JJ": function() { return /* binding */ provide; },
  "hT": function() { return /* binding */ provideMerge; },
  "XD": function() { return /* binding */ retry; },
  "eI": function() { return /* binding */ scope; },
  "Yn": function() { return /* binding */ scoped; },
  "u3": function() { return /* binding */ scopedContext; },
  "oc": function() { return /* binding */ scopedDiscard; },
  "Xn": function() { return /* binding */ service; },
  "ng": function() { return /* binding */ succeed; },
  "zm": function() { return /* binding */ succeedContext; },
  "Rq": function() { return /* binding */ suspend; },
  "Z_": function() { return /* binding */ sync; },
  "$2": function() { return /* binding */ syncContext; },
  "bw": function() { return /* binding */ tap; },
  "sn": function() { return /* binding */ tapError; },
  "OM": function() { return /* binding */ tapErrorCause; },
  "yK": function() { return /* binding */ toRuntime; },
  "CC": function() { return /* binding */ toRuntimeWithMemoMap; },
  "_u": function() { return /* binding */ unwrapEffect; },
  "iA": function() { return /* binding */ unwrapScoped; },
  "cV": function() { return /* binding */ withParentSpan; },
  "cq": function() { return /* binding */ withSpan; },
  "yL": function() { return /* binding */ zipWith; }
});

// UNUSED EXPORTS: proto, unsafeMakeMemoMap

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Cause.js
var Cause = __webpack_require__(91115);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Clock.js
var Clock = __webpack_require__(9605);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Context.js
var Context = __webpack_require__(20591);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Duration.js
var Duration = __webpack_require__(13571);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/FiberRefsPatch.js
var FiberRefsPatch = __webpack_require__(58714);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/HashMap.js + 1 modules
var HashMap = __webpack_require__(61952);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Pipeable.js
var Pipeable = __webpack_require__(92817);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Predicate.js
var Predicate = __webpack_require__(71335);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/ScheduleDecision.js + 1 modules
var ScheduleDecision = __webpack_require__(82429);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/ScheduleIntervals.js + 1 modules
var ScheduleIntervals = __webpack_require__(75313);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Scope.js
var Scope = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/core-effect.js + 3 modules
var core_effect = __webpack_require__(53623);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/core.js + 1 modules
var internal_core = __webpack_require__(39355);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/effect/circular.js
var circular = __webpack_require__(34606);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/fiberRuntime.js + 14 modules
var fiberRuntime = __webpack_require__(90886);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/managedRuntime/circular.js
// circular with Layer
/** @internal */
const TypeId = /*#__PURE__*/Symbol.for("effect/ManagedRuntime");
//# sourceMappingURL=circular.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/opCodes/effect.js
var effect = __webpack_require__(11713);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/opCodes/layer.js
/** @internal */
const OP_EXTEND_SCOPE = "ExtendScope";
/** @internal */
const OP_FOLD = "Fold";
/** @internal */
const OP_FRESH = "Fresh";
/** @internal */
const OP_FROM_EFFECT = "FromEffect";
/** @internal */
const OP_SCOPED = "Scoped";
/** @internal */
const OP_SUSPEND = "Suspend";
/** @internal */
const OP_PROVIDE = "Provide";
/** @internal */
const OP_PROVIDE_MERGE = "ProvideMerge";
/** @internal */
const OP_ZIP_WITH = "ZipWith";
//# sourceMappingURL=layer.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/ref.js
var ref = __webpack_require__(7411);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/runtime.js + 1 modules
var runtime = __webpack_require__(22296);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/runtimeFlags.js
var runtimeFlags = __webpack_require__(4536);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/synchronizedRef.js



/** @internal */
const getAndUpdateEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => self.modifyEffect(value => core.map(f(value), result => [value, result])))));
/** @internal */
const getAndUpdateSomeEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, pf) => self.modifyEffect(value => {
  const result = pf(value);
  switch (result._tag) {
    case "None":
      {
        return core.succeed([value, value]);
      }
    case "Some":
      {
        return core.map(result.value, newValue => [value, newValue]);
      }
  }
}))));
/** @internal */
const modify = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => self.modify(f))));
/** @internal */
const modifyEffect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => self.modifyEffect(f));
/** @internal */
const modifySomeEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, fallback, pf) => self.modifyEffect(value => pipe(pf(value), Option.getOrElse(() => core.succeed([fallback, value])))))));
/** @internal */
const updateEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => self.modifyEffect(value => core.map(f(value), result => [undefined, result])))));
/** @internal */
const updateAndGetEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => self.modifyEffect(value => core.map(f(value), result => [result, result])))));
/** @internal */
const updateSomeEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, pf) => self.modifyEffect(value => {
  const result = pf(value);
  switch (result._tag) {
    case "None":
      {
        return core.succeed([void 0, value]);
      }
    case "Some":
      {
        return core.map(result.value, a => [void 0, a]);
      }
  }
}))));
//# sourceMappingURL=synchronizedRef.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/tracer.js
var tracer = __webpack_require__(10434);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/layer.js
























/** @internal */
const LayerSymbolKey = "effect/Layer";
/** @internal */
const LayerTypeId = /*#__PURE__*/Symbol.for(LayerSymbolKey);
const layerVariance = {
  /* c8 ignore next */
  _RIn: _ => _,
  /* c8 ignore next */
  _E: _ => _,
  /* c8 ignore next */
  _ROut: _ => _
};
/** @internal */
const proto = {
  [LayerTypeId]: layerVariance,
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
};
/** @internal */
const MemoMapTypeIdKey = "effect/Layer/MemoMap";
/** @internal */
const MemoMapTypeId = /*#__PURE__*/Symbol.for(MemoMapTypeIdKey);
/** @internal */
const CurrentMemoMap = /*#__PURE__*/Context/* Reference */.s3()("effect/Layer/CurrentMemoMap", {
  defaultValue: () => unsafeMakeMemoMap()
});
/** @internal */
const isLayer = u => (0,Predicate/* hasProperty */.l$)(u, LayerTypeId);
/** @internal */
const isFresh = self => {
  return self._op_layer === OP_FRESH;
};
// -----------------------------------------------------------------------------
// MemoMap
// -----------------------------------------------------------------------------
/** @internal */
class MemoMapImpl {
  ref;
  [MemoMapTypeId];
  constructor(ref) {
    this.ref = ref;
    this[MemoMapTypeId] = MemoMapTypeId;
  }
  /**
   * Checks the memo map to see if a layer exists. If it is, immediately
   * returns it. Otherwise, obtains the layer, stores it in the memo map,
   * and adds a finalizer to the `Scope`.
   */
  getOrElseMemoize(layer, scope) {
    return (0,Function/* pipe */.zG)(modifyEffect(this.ref, map => {
      const inMap = map.get(layer);
      if (inMap !== undefined) {
        const [acquire, release] = inMap;
        const cached = (0,Function/* pipe */.zG)(acquire, internal_core/* flatMap */.VSD(([patch, b]) => (0,Function/* pipe */.zG)(core_effect/* patchFiberRefs */.au(patch), internal_core.as(b))), internal_core/* onExit */.dsk(internal_core/* exitMatch */.Bs2({
          onFailure: () => internal_core/* void */.Hcj,
          onSuccess: () => internal_core/* scopeAddFinalizerExit */.veJ(scope, release)
        })));
        return internal_core/* succeed */.ng0([cached, map]);
      }
      return (0,Function/* pipe */.zG)(ref/* make */.Sy(0), internal_core/* flatMap */.VSD(observers => (0,Function/* pipe */.zG)(internal_core/* deferredMake */.kPu(), internal_core/* flatMap */.VSD(deferred => (0,Function/* pipe */.zG)(ref/* make */.Sy(() => internal_core/* void */.Hcj), internal_core/* map */.UID(finalizerRef => {
        const resource = internal_core/* uninterruptibleMask */.UO$(restore => (0,Function/* pipe */.zG)(fiberRuntime/* scopeMake */.RN(), internal_core/* flatMap */.VSD(innerScope => (0,Function/* pipe */.zG)(restore(internal_core/* flatMap */.VSD(makeBuilder(layer, innerScope, true), f => core_effect/* diffFiberRefs */.gT(f(this)))), internal_core/* exit */.JFt, internal_core/* flatMap */.VSD(exit => {
          switch (exit._tag) {
            case effect/* OP_FAILURE */.N4:
              {
                return (0,Function/* pipe */.zG)(internal_core/* deferredFailCause */.yd6(deferred, exit.effect_instruction_i0), internal_core/* zipRight */.qs5(internal_core/* scopeClose */.roQ(innerScope, exit)), internal_core/* zipRight */.qs5(internal_core/* failCause */.DhG(exit.effect_instruction_i0)));
              }
            case effect/* OP_SUCCESS */.x$:
              {
                return (0,Function/* pipe */.zG)(ref/* set */.t8(finalizerRef, exit => (0,Function/* pipe */.zG)(internal_core/* scopeClose */.roQ(innerScope, exit), internal_core/* whenEffect */.FNZ(ref/* modify */.Pj(observers, n => [n === 1, n - 1])), internal_core/* asVoid */.a2S)), internal_core/* zipRight */.qs5(ref/* update */.Vx(observers, n => n + 1)), internal_core/* zipRight */.qs5(internal_core/* scopeAddFinalizerExit */.veJ(scope, exit => (0,Function/* pipe */.zG)(internal_core/* sync */.Z_X(() => map.delete(layer)), internal_core/* zipRight */.qs5(ref/* get */.U2(finalizerRef)), internal_core/* flatMap */.VSD(finalizer => finalizer(exit))))), internal_core/* zipRight */.qs5(internal_core/* deferredSucceed */.QtZ(deferred, exit.effect_instruction_i0)), internal_core.as(exit.effect_instruction_i0[1]));
              }
          }
        })))));
        const memoized = [(0,Function/* pipe */.zG)(internal_core/* deferredAwait */.Odg(deferred), internal_core/* onExit */.dsk(internal_core/* exitMatchEffect */.aoR({
          onFailure: () => internal_core/* void */.Hcj,
          onSuccess: () => ref/* update */.Vx(observers, n => n + 1)
        }))), exit => (0,Function/* pipe */.zG)(ref/* get */.U2(finalizerRef), internal_core/* flatMap */.VSD(finalizer => finalizer(exit)))];
        return [resource, isFresh(layer) ? map : map.set(layer, memoized)];
      }))))));
    }), internal_core/* flatten */.xHg);
  }
}
/** @internal */
const makeMemoMap = /*#__PURE__*/internal_core/* suspend */.RqG(() => internal_core/* map */.UID(circular/* makeSynchronized */.yT(new Map()), ref => new MemoMapImpl(ref)));
/** @internal */
const unsafeMakeMemoMap = () => new MemoMapImpl(circular/* unsafeMakeSynchronized */.c2(new Map()));
/** @internal */
const build = self => fiberRuntime/* scopeWith */.ZO(scope => buildWithScope(self, scope));
/** @internal */
const buildWithScope = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, scope) => internal_core/* flatMap */.VSD(makeMemoMap, memoMap => buildWithMemoMap(self, memoMap, scope)));
/** @internal */
const buildWithMemoMap = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, memoMap, scope) => internal_core/* flatMap */.VSD(makeBuilder(self, scope), run => core_effect/* provideService */.aH(run(memoMap), CurrentMemoMap, memoMap)));
const makeBuilder = (self, scope, inMemoMap = false) => {
  const op = self;
  switch (op._op_layer) {
    case "Locally":
      {
        return internal_core/* sync */.Z_X(() => memoMap => op.f(memoMap.getOrElseMemoize(op.self, scope)));
      }
    case "ExtendScope":
      {
        return internal_core/* sync */.Z_X(() => memoMap => fiberRuntime/* scopeWith */.ZO(scope => memoMap.getOrElseMemoize(op.layer, scope)));
      }
    case "Fold":
      {
        return internal_core/* sync */.Z_X(() => memoMap => (0,Function/* pipe */.zG)(memoMap.getOrElseMemoize(op.layer, scope), internal_core/* matchCauseEffect */.Bpg({
          onFailure: cause => memoMap.getOrElseMemoize(op.failureK(cause), scope),
          onSuccess: value => memoMap.getOrElseMemoize(op.successK(value), scope)
        })));
      }
    case "Fresh":
      {
        return internal_core/* sync */.Z_X(() => _ => (0,Function/* pipe */.zG)(op.layer, buildWithScope(scope)));
      }
    case "FromEffect":
      {
        return inMemoMap ? internal_core/* sync */.Z_X(() => _ => op.effect) : internal_core/* sync */.Z_X(() => memoMap => memoMap.getOrElseMemoize(self, scope));
      }
    case "Provide":
      {
        return internal_core/* sync */.Z_X(() => memoMap => (0,Function/* pipe */.zG)(memoMap.getOrElseMemoize(op.first, scope), internal_core/* flatMap */.VSD(env => (0,Function/* pipe */.zG)(memoMap.getOrElseMemoize(op.second, scope), internal_core/* provideContext */.qNZ(env)))));
      }
    case "Scoped":
      {
        return inMemoMap ? internal_core/* sync */.Z_X(() => _ => fiberRuntime/* scopeExtend */.Vx(op.effect, scope)) : internal_core/* sync */.Z_X(() => memoMap => memoMap.getOrElseMemoize(self, scope));
      }
    case "Suspend":
      {
        return internal_core/* sync */.Z_X(() => memoMap => memoMap.getOrElseMemoize(op.evaluate(), scope));
      }
    case "ProvideMerge":
      {
        return internal_core/* sync */.Z_X(() => memoMap => (0,Function/* pipe */.zG)(memoMap.getOrElseMemoize(op.first, scope), internal_core/* zipWith */.yL_(memoMap.getOrElseMemoize(op.second, scope), op.zipK)));
      }
    case "ZipWith":
      {
        return internal_core/* sync */.Z_X(() => memoMap => (0,Function/* pipe */.zG)(memoMap.getOrElseMemoize(op.first, scope), fiberRuntime/* zipWithOptions */.xn(memoMap.getOrElseMemoize(op.second, scope), op.zipK, {
          concurrent: true
        })));
      }
  }
};
// -----------------------------------------------------------------------------
// Layer
// -----------------------------------------------------------------------------
/** @internal */
const catchAll = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, onFailure) => match(self, {
  onFailure,
  onSuccess: succeedContext
}));
/** @internal */
const catchAllCause = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, onFailure) => matchCause(self, {
  onFailure,
  onSuccess: succeedContext
}));
/** @internal */
const die = defect => failCause(Cause/* die */.Xr(defect));
/** @internal */
const dieSync = evaluate => failCauseSync(() => Cause/* die */.Xr(evaluate()));
/** @internal */
const discard = self => map(self, () => Context/* empty */.cS());
/** @internal */
const context = () => fromEffectContext(internal_core/* context */.Do7());
/** @internal */
const extendScope = self => {
  const extendScope = Object.create(proto);
  extendScope._op_layer = OP_EXTEND_SCOPE;
  extendScope.layer = self;
  return extendScope;
};
/** @internal */
const fail = error => failCause(Cause/* fail */.bG(error));
/** @internal */
const failSync = evaluate => failCauseSync(() => Cause/* fail */.bG(evaluate()));
/** @internal */
const failCause = cause => fromEffectContext(internal_core/* failCause */.DhG(cause));
/** @internal */
const failCauseSync = evaluate => fromEffectContext(internal_core/* failCauseSync */.euP(evaluate));
/** @internal */
const flatMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => match(self, {
  onFailure: fail,
  onSuccess: f
}));
/** @internal */
const flatten = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, tag) => flatMap(self, Context/* get */.U2(tag)));
/** @internal */
const fresh = self => {
  const fresh = Object.create(proto);
  fresh._op_layer = OP_FRESH;
  fresh.layer = self;
  return fresh;
};
/** @internal */
const fromEffect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (a, b) => {
  const tagFirst = Context/* isTag */.YR(a);
  const tag = tagFirst ? a : b;
  const effect = tagFirst ? b : a;
  return fromEffectContext(internal_core/* map */.UID(effect, service => Context/* make */.Sy(tag, service)));
});
/** @internal */
const fromEffectDiscard = effect => fromEffectContext(internal_core/* map */.UID(effect, () => Context/* empty */.cS()));
/** @internal */
function fromEffectContext(effect) {
  const fromEffect = Object.create(proto);
  fromEffect._op_layer = OP_FROM_EFFECT;
  fromEffect.effect = effect;
  return fromEffect;
}
/** @internal */
const fiberRefLocally = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, ref, value) => locallyEffect(self, internal_core/* fiberRefLocally */.EXC(ref, value)));
/** @internal */
const locallyEffect = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => {
  const locally = Object.create(proto);
  locally._op_layer = "Locally";
  locally.self = self;
  locally.f = f;
  return locally;
});
/** @internal */
const fiberRefLocallyWith = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, ref, value) => locallyEffect(self, internal_core/* fiberRefLocallyWith */.LzL(ref, value)));
/** @internal */
const fiberRefLocallyScoped = (self, value) => scopedDiscard(fiberRuntime/* fiberRefLocallyScoped */.tX(self, value));
/** @internal */
const fiberRefLocallyScopedWith = (self, value) => scopedDiscard(fiberRuntime/* fiberRefLocallyScopedWith */.lS(self, value));
/** @internal */
const fromFunction = (tagA, tagB, f) => fromEffectContext(internal_core/* map */.UID(tagA, a => Context/* make */.Sy(tagB, f(a))));
/** @internal */
const launch = self => fiberRuntime/* scopedEffect */.N1(internal_core/* zipRight */.qs5(fiberRuntime/* scopeWith */.ZO(scope => (0,Function/* pipe */.zG)(self, buildWithScope(scope))), internal_core/* never */.FiN));
/** @internal */
const map = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => flatMap(self, context => succeedContext(f(context))));
/** @internal */
const mapError = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => catchAll(self, error => failSync(() => f(error))));
/** @internal */
const matchCause = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, {
  onFailure,
  onSuccess
}) => {
  const fold = Object.create(proto);
  fold._op_layer = OP_FOLD;
  fold.layer = self;
  fold.failureK = onFailure;
  fold.successK = onSuccess;
  return fold;
});
/** @internal */
const match = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, {
  onFailure,
  onSuccess
}) => matchCause(self, {
  onFailure: cause => {
    const failureOrCause = Cause/* failureOrCause */.hl(cause);
    switch (failureOrCause._tag) {
      case "Left":
        {
          return onFailure(failureOrCause.left);
        }
      case "Right":
        {
          return failCause(failureOrCause.right);
        }
    }
  },
  onSuccess
}));
/** @internal */
const memoize = self => fiberRuntime/* scopeWith */.ZO(scope => internal_core/* map */.UID(core_effect/* memoize */.HP(buildWithScope(self, scope)), fromEffectContext));
/** @internal */
const merge = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => zipWith(self, that, (a, b) => Context/* merge */.TS(a, b)));
/** @internal */
const mergeAll = (...layers) => {
  let final = layers[0];
  for (let i = 1; i < layers.length; i++) {
    final = merge(final, layers[i]);
  }
  return final;
};
/** @internal */
const orDie = self => catchAll(self, defect => die(defect));
/** @internal */
const orElse = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => catchAll(self, that));
/** @internal */
const passthrough = self => merge(context(), self);
/** @internal */
const project = /*#__PURE__*/(0,Function/* dual */.OB)(4, (self, tagA, tagB, f) => map(self, context => Context/* make */.Sy(tagB, f(Context/* unsafeGet */.MH(context, tagA)))));
/** @internal */
const retry = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, schedule) => suspend(() => {
  const stateTag = Context/* GenericTag */.hV("effect/Layer/retry/{ state: unknown }");
  return (0,Function/* pipe */.zG)(succeed(stateTag, {
    state: schedule.initial
  }), flatMap(env => retryLoop(self, schedule, stateTag, (0,Function/* pipe */.zG)(env, Context/* get */.U2(stateTag)).state)));
}));
const retryLoop = (self, schedule, stateTag, state) => {
  return (0,Function/* pipe */.zG)(self, catchAll(error => (0,Function/* pipe */.zG)(retryUpdate(schedule, stateTag, error, state), flatMap(env => fresh(retryLoop(self, schedule, stateTag, (0,Function/* pipe */.zG)(env, Context/* get */.U2(stateTag)).state))))));
};
const retryUpdate = (schedule, stateTag, error, state) => {
  return fromEffect(stateTag, (0,Function/* pipe */.zG)(Clock/* currentTimeMillis */.b4, internal_core/* flatMap */.VSD(now => (0,Function/* pipe */.zG)(schedule.step(now, error, state), internal_core/* flatMap */.VSD(([state, _, decision]) => ScheduleDecision/* isDone */._b(decision) ? internal_core/* fail */.bGj(error) : (0,Function/* pipe */.zG)(Clock/* sleep */._v(Duration/* millis */.YX(ScheduleIntervals/* start */.BL(decision.intervals) - now)), internal_core.as({
    state
  })))))));
};
/** @internal */
const scoped = /*#__PURE__*/(0,Function/* dual */.OB)(2, (a, b) => {
  const tagFirst = Context/* isTag */.YR(a);
  const tag = tagFirst ? a : b;
  const effect = tagFirst ? b : a;
  return scopedContext(internal_core/* map */.UID(effect, service => Context/* make */.Sy(tag, service)));
});
/** @internal */
const scopedDiscard = effect => scopedContext((0,Function/* pipe */.zG)(effect, internal_core.as(Context/* empty */.cS())));
/** @internal */
const scopedContext = effect => {
  const scoped = Object.create(proto);
  scoped._op_layer = OP_SCOPED;
  scoped.effect = effect;
  return scoped;
};
/** @internal */
const scope = /*#__PURE__*/scopedContext( /*#__PURE__*/internal_core/* map */.UID( /*#__PURE__*/fiberRuntime/* acquireRelease */.S8( /*#__PURE__*/fiberRuntime/* scopeMake */.RN(), (scope, exit) => scope.close(exit)), scope => Context/* make */.Sy(Scope/* Scope */.sX, scope)));
/** @internal */
const service = tag => fromEffect(tag, tag);
/** @internal */
const succeed = /*#__PURE__*/(0,Function/* dual */.OB)(2, (a, b) => {
  const tagFirst = Context/* isTag */.YR(a);
  const tag = tagFirst ? a : b;
  const resource = tagFirst ? b : a;
  return fromEffectContext(internal_core/* succeed */.ng0(Context/* make */.Sy(tag, resource)));
});
/** @internal */
const succeedContext = context => {
  return fromEffectContext(internal_core/* succeed */.ng0(context));
};
/** @internal */
const empty = /*#__PURE__*/succeedContext( /*#__PURE__*/Context/* empty */.cS());
/** @internal */
const suspend = evaluate => {
  const suspend = Object.create(proto);
  suspend._op_layer = OP_SUSPEND;
  suspend.evaluate = evaluate;
  return suspend;
};
/** @internal */
const sync = /*#__PURE__*/(0,Function/* dual */.OB)(2, (a, b) => {
  const tagFirst = Context/* isTag */.YR(a);
  const tag = tagFirst ? a : b;
  const evaluate = tagFirst ? b : a;
  return fromEffectContext(internal_core/* sync */.Z_X(() => Context/* make */.Sy(tag, evaluate())));
});
/** @internal */
const syncContext = evaluate => {
  return fromEffectContext(internal_core/* sync */.Z_X(evaluate));
};
/** @internal */
const tap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => flatMap(self, context => fromEffectContext(internal_core.as(f(context), context))));
/** @internal */
const tapError = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => catchAll(self, e => fromEffectContext(internal_core/* flatMap */.VSD(f(e), () => internal_core/* fail */.bGj(e)))));
/** @internal */
const tapErrorCause = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, f) => catchAllCause(self, cause => fromEffectContext(internal_core/* flatMap */.VSD(f(cause), () => internal_core/* failCause */.DhG(cause)))));
/** @internal */
const toRuntime = self => (0,Function/* pipe */.zG)(fiberRuntime/* scopeWith */.ZO(scope => buildWithScope(self, scope)), internal_core/* flatMap */.VSD(context => (0,Function/* pipe */.zG)(runtime/* runtime */.GZ(), internal_core/* provideContext */.qNZ(context))));
/** @internal */
const toRuntimeWithMemoMap = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, memoMap) => internal_core/* flatMap */.VSD(fiberRuntime/* scopeWith */.ZO(scope => buildWithMemoMap(self, memoMap, scope)), context => (0,Function/* pipe */.zG)(runtime/* runtime */.GZ(), internal_core/* provideContext */.qNZ(context))));
/** @internal */
const provide = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, that) => suspend(() => {
  const provideTo = Object.create(proto);
  provideTo._op_layer = OP_PROVIDE;
  provideTo.first = Object.create(proto, {
    _op_layer: {
      value: OP_PROVIDE_MERGE,
      enumerable: true
    },
    first: {
      value: context(),
      enumerable: true
    },
    second: {
      value: Array.isArray(that) ? mergeAll(...that) : that
    },
    zipK: {
      value: (a, b) => (0,Function/* pipe */.zG)(a, Context/* merge */.TS(b))
    }
  });
  provideTo.second = self;
  return provideTo;
}));
/** @internal */
const provideMerge = /*#__PURE__*/(0,Function/* dual */.OB)(2, (that, self) => {
  const zipWith = Object.create(proto);
  zipWith._op_layer = OP_PROVIDE_MERGE;
  zipWith.first = self;
  zipWith.second = provide(that, self);
  zipWith.zipK = (a, b) => {
    return (0,Function/* pipe */.zG)(a, Context/* merge */.TS(b));
  };
  return zipWith;
});
/** @internal */
const zipWith = /*#__PURE__*/(0,Function/* dual */.OB)(3, (self, that, f) => suspend(() => {
  const zipWith = Object.create(proto);
  zipWith._op_layer = OP_ZIP_WITH;
  zipWith.first = self;
  zipWith.second = that;
  zipWith.zipK = f;
  return zipWith;
}));
/** @internal */
const unwrapEffect = self => {
  const tag = Context/* GenericTag */.hV("effect/Layer/unwrapEffect/Layer.Layer<R1, E1, A>");
  return flatMap(fromEffect(tag, self), context => Context/* get */.U2(context, tag));
};
/** @internal */
const unwrapScoped = self => {
  const tag = Context/* GenericTag */.hV("effect/Layer/unwrapScoped/Layer.Layer<R1, E1, A>");
  return flatMap(scoped(tag, self), context => Context/* get */.U2(context, tag));
};
// -----------------------------------------------------------------------------
// logging
// -----------------------------------------------------------------------------
const annotateLogs = /*#__PURE__*/(0,Function/* dual */.OB)(args => isLayer(args[0]), function () {
  const args = arguments;
  return fiberRefLocallyWith(args[0], internal_core/* currentLogAnnotations */.cMe, typeof args[1] === "string" ? HashMap/* set */.t8(args[1], args[2]) : annotations => Object.entries(args[1]).reduce((acc, [key, value]) => HashMap/* set */.t8(acc, key, value), annotations));
});
// -----------------------------------------------------------------------------
// tracing
// -----------------------------------------------------------------------------
const annotateSpans = /*#__PURE__*/(0,Function/* dual */.OB)(args => isLayer(args[0]), function () {
  const args = arguments;
  return fiberRefLocallyWith(args[0], internal_core/* currentTracerSpanAnnotations */.SUw, typeof args[1] === "string" ? HashMap/* set */.t8(args[1], args[2]) : annotations => Object.entries(args[1]).reduce((acc, [key, value]) => HashMap/* set */.t8(acc, key, value), annotations));
});
/** @internal */
const withSpan = function () {
  const dataFirst = typeof arguments[0] !== "string";
  const name = dataFirst ? arguments[1] : arguments[0];
  const options = tracer/* addSpanStackTrace */.W8(dataFirst ? arguments[2] : arguments[1]);
  if (dataFirst) {
    const self = arguments[0];
    return unwrapScoped(internal_core/* map */.UID(options?.onEnd ? internal_core/* tap */.bwX(fiberRuntime/* makeSpanScoped */.ey(name, options), span => fiberRuntime/* addFinalizer */.yR(exit => options.onEnd(span, exit))) : fiberRuntime/* makeSpanScoped */.ey(name, options), span => withParentSpan(self, span)));
  }
  return self => unwrapScoped(internal_core/* map */.UID(options?.onEnd ? internal_core/* tap */.bwX(fiberRuntime/* makeSpanScoped */.ey(name, options), span => fiberRuntime/* addFinalizer */.yR(exit => options.onEnd(span, exit))) : fiberRuntime/* makeSpanScoped */.ey(name, options), span => withParentSpan(self, span)));
};
/** @internal */
const withParentSpan = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, span) => provide(self, succeedContext(Context/* make */.Sy(tracer/* spanTag */.N7, span))));
// circular with Effect
const provideSomeLayer = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, layer) => fiberRuntime/* scopedWith */.HK(scope => internal_core/* flatMap */.VSD(buildWithScope(layer, scope), context => internal_core/* provideSomeContext */.Jng(self, context))));
const provideSomeRuntime = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, rt) => {
  const patchRefs = FiberRefsPatch/* diff */.Hg(runtime/* defaultRuntime.fiberRefs */.rt.fiberRefs, rt.fiberRefs);
  const patchFlags = runtimeFlags/* diff */.Hg(runtime/* defaultRuntime.runtimeFlags */.rt.runtimeFlags, rt.runtimeFlags);
  return internal_core/* uninterruptibleMask */.UO$(restore => internal_core/* withFiberRuntime */.ECC(fiber => {
    const oldContext = fiber.getFiberRef(internal_core/* currentContext */.gbX);
    const oldRefs = fiber.getFiberRefs();
    const newRefs = FiberRefsPatch/* patch */.r$(fiber.id(), oldRefs)(patchRefs);
    const oldFlags = fiber.currentRuntimeFlags;
    const newFlags = runtimeFlags/* patch */.r$(patchFlags)(oldFlags);
    const rollbackRefs = FiberRefsPatch/* diff */.Hg(newRefs, oldRefs);
    const rollbackFlags = runtimeFlags/* diff */.Hg(newFlags, oldFlags);
    fiber.setFiberRefs(newRefs);
    fiber.currentRuntimeFlags = newFlags;
    return fiberRuntime/* ensuring */.IH(internal_core/* provideSomeContext */.Jng(restore(self), Context/* merge */.TS(oldContext, rt.context)), internal_core/* withFiberRuntime */.ECC(fiber => {
      fiber.setFiberRefs(FiberRefsPatch/* patch */.r$(fiber.id(), fiber.getFiberRefs())(rollbackRefs));
      fiber.currentRuntimeFlags = runtimeFlags/* patch */.r$(rollbackFlags)(fiber.currentRuntimeFlags);
      return internal_core/* void */.Hcj;
    }));
  }));
});
/** @internal */
const effect_provide = /*#__PURE__*/(0,Function/* dual */.OB)(2, (self, source) => {
  if (Array.isArray(source)) {
    // @ts-expect-error
    return provideSomeLayer(self, mergeAll(...source));
  } else if (isLayer(source)) {
    return provideSomeLayer(self, source);
  } else if (Context/* isContext */.PI(source)) {
    return internal_core/* provideSomeContext */.Jng(self, source);
  } else if (TypeId in source) {
    return internal_core/* flatMap */.VSD(source.runtimeEffect, rt => provideSomeRuntime(self, rt));
  } else {
    return provideSomeRuntime(self, source);
  }
});
//# sourceMappingURL=layer.js.map

/***/ }),

/***/ 96443:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N4": function() { return /* binding */ formatLabel; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "sY": function() { return /* binding */ render; }
/* harmony export */ });
/** @internal */
const make = (label, startTime) => ({
  label,
  startTime
});
/**
 * Sanitize a given string by replacing spaces, equal signs, and double quotes with underscores.
 *
 * @internal
 */
const formatLabel = key => key.replace(/[\s="]/g, "_");
/** @internal */
const render = now => self => {
  const label = formatLabel(self.label);
  return `${label}=${now - self.startTime}ms`;
};
//# sourceMappingURL=logSpan.js.map

/***/ }),

/***/ 36548:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports MetricLabelTypeId, isMetricLabel */
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67492);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89379);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92817);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71335);




/** @internal */
const MetricLabelSymbolKey = "effect/MetricLabel";
/** @internal */
const MetricLabelTypeId = /*#__PURE__*/Symbol.for(MetricLabelSymbolKey);
/** @internal */
class MetricLabelImpl {
  key;
  value;
  [MetricLabelTypeId] = MetricLabelTypeId;
  _hash;
  constructor(key, value) {
    this.key = key;
    this.value = value;
    this._hash = _Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(MetricLabelSymbolKey + this.key + this.value);
  }
  [_Hash_js__WEBPACK_IMPORTED_MODULE_0__/* .symbol */ .NA]() {
    return this._hash;
  }
  [_Equal_js__WEBPACK_IMPORTED_MODULE_1__/* .symbol */ .NA](that) {
    return isMetricLabel(that) && this.key === that.key && this.value === that.value;
  }
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_2__/* .pipeArguments */ .n)(this, arguments);
  }
}
/** @internal */
const make = (key, value) => {
  return new MetricLabelImpl(key, value);
};
/** @internal */
const isMetricLabel = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_3__/* .hasProperty */ .l$)(u, MetricLabelTypeId);
//# sourceMappingURL=label.js.map

/***/ }),

/***/ 4219:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ OP_STATE_DONE; },
/* harmony export */   "c": function() { return /* binding */ OP_STATE_PENDING; }
/* harmony export */ });
/** @internal */
const OP_STATE_PENDING = "Pending";
/** @internal */
const OP_STATE_DONE = "Done";
//# sourceMappingURL=deferred.js.map

/***/ }),

/***/ 11713:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EV": function() { return /* binding */ OP_WITH_RUNTIME; },
/* harmony export */   "JX": function() { return /* binding */ OP_REVERT_FLAGS; },
/* harmony export */   "LU": function() { return /* binding */ OP_TAG; },
/* harmony export */   "N4": function() { return /* binding */ OP_FAILURE; },
/* harmony export */   "PF": function() { return /* binding */ OP_ON_FAILURE; },
/* harmony export */   "Pv": function() { return /* binding */ OP_WHILE; },
/* harmony export */   "Q0": function() { return /* binding */ OP_SYNC; },
/* harmony export */   "Rm": function() { return /* binding */ OP_ITERATOR; },
/* harmony export */   "gl": function() { return /* binding */ OP_YIELD; },
/* harmony export */   "kf": function() { return /* binding */ OP_ON_SUCCESS_AND_FAILURE; },
/* harmony export */   "m7": function() { return /* binding */ OP_ASYNC; },
/* harmony export */   "rk": function() { return /* binding */ OP_UPDATE_RUNTIME_FLAGS; },
/* harmony export */   "rm": function() { return /* binding */ OP_ON_SUCCESS; },
/* harmony export */   "vm": function() { return /* binding */ OP_COMMIT; },
/* harmony export */   "x$": function() { return /* binding */ OP_SUCCESS; }
/* harmony export */ });
/** @internal */
const OP_ASYNC = "Async";
/** @internal */
const OP_COMMIT = "Commit";
/** @internal */
const OP_FAILURE = "Failure";
/** @internal */
const OP_ON_FAILURE = "OnFailure";
/** @internal */
const OP_ON_SUCCESS = "OnSuccess";
/** @internal */
const OP_ON_SUCCESS_AND_FAILURE = "OnSuccessAndFailure";
/** @internal */
const OP_SUCCESS = "Success";
/** @internal */
const OP_SYNC = "Sync";
/** @internal */
const OP_TAG = "Tag";
/** @internal */
const OP_UPDATE_RUNTIME_FLAGS = "UpdateRuntimeFlags";
/** @internal */
const OP_WHILE = "While";
/** @internal */
const OP_ITERATOR = "Iterator";
/** @internal */
const OP_WITH_RUNTIME = "WithRuntime";
/** @internal */
const OP_YIELD = "Yield";
/** @internal */
const OP_REVERT_FLAGS = "RevertFlags";
//# sourceMappingURL=effect.js.map

/***/ }),

/***/ 70602:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ some; },
/* harmony export */   "Kn": function() { return /* binding */ isOption; },
/* harmony export */   "Wi": function() { return /* binding */ isNone; },
/* harmony export */   "YP": function() { return /* binding */ none; },
/* harmony export */   "pC": function() { return /* binding */ isSome; }
/* harmony export */ });
/* harmony import */ var _Equal_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67492);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89379);
/* harmony import */ var _Inspectable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16371);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71335);
/* harmony import */ var _effectable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10020);
/**
 * @since 2.0.0
 */





const TypeId = /*#__PURE__*/Symbol.for("effect/Option");
const CommonProto = {
  ..._effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .EffectPrototype */ .tU,
  [TypeId]: {
    _A: _ => _
  },
  [_Inspectable_js__WEBPACK_IMPORTED_MODULE_1__/* .NodeInspectSymbol */ .j5]() {
    return this.toJSON();
  },
  toString() {
    return (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_1__/* .format */ .WU)(this.toJSON());
  }
};
const SomeProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(CommonProto), {
  _tag: "Some",
  _op: "Some",
  [_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .symbol */ .NA](that) {
    return isOption(that) && isSome(that) && _Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .equals */ .fS(this.value, that.value);
  },
  [_Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .symbol */ .NA]() {
    return _Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .cached */ .HX(this, _Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .combine */ .$e(_Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .hash */ .vp(this._tag))(_Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .hash */ .vp(this.value)));
  },
  toJSON() {
    return {
      _id: "Option",
      _tag: this._tag,
      value: (0,_Inspectable_js__WEBPACK_IMPORTED_MODULE_1__/* .toJSON */ .au)(this.value)
    };
  }
});
const NoneHash = /*#__PURE__*/_Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .hash */ .vp("None");
const NoneProto = /*#__PURE__*/Object.assign( /*#__PURE__*/Object.create(CommonProto), {
  _tag: "None",
  _op: "None",
  [_Equal_js__WEBPACK_IMPORTED_MODULE_2__/* .symbol */ .NA](that) {
    return isOption(that) && isNone(that);
  },
  [_Hash_js__WEBPACK_IMPORTED_MODULE_3__/* .symbol */ .NA]() {
    return NoneHash;
  },
  toJSON() {
    return {
      _id: "Option",
      _tag: this._tag
    };
  }
});
/** @internal */
const isOption = input => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_4__/* .hasProperty */ .l$)(input, TypeId);
/** @internal */
const isNone = fa => fa._tag === "None";
/** @internal */
const isSome = fa => fa._tag === "Some";
/** @internal */
const none = /*#__PURE__*/Object.create(NoneProto);
/** @internal */
const some = value => {
  const a = Object.create(SomeProto);
  a.value = value;
  return a;
};
//# sourceMappingURL=option.js.map

/***/ }),

/***/ 94023:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "XB": function() { return /* binding */ randomTag; }
/* harmony export */ });
/* unused harmony export RandomTypeId */
/* harmony import */ var _Chunk_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14109);
/* harmony import */ var _Context_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20591);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17316);
/* harmony import */ var _Hash_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89379);
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70762);
/* harmony import */ var _core_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39355);






/** @internal */
const RandomSymbolKey = "effect/Random";
/** @internal */
const RandomTypeId = /*#__PURE__*/Symbol.for(RandomSymbolKey);
/** @internal */
const randomTag = /*#__PURE__*/_Context_js__WEBPACK_IMPORTED_MODULE_0__/* .GenericTag */ .hV("effect/Random");
/** @internal */
class RandomImpl {
  seed;
  [RandomTypeId] = RandomTypeId;
  PRNG;
  constructor(seed) {
    this.seed = seed;
    this.PRNG = new _Utils_js__WEBPACK_IMPORTED_MODULE_1__/* .PCGRandom */ .Mc(seed);
  }
  get next() {
    return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .sync */ .Z_X(() => this.PRNG.number());
  }
  get nextBoolean() {
    return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UID(this.next, n => n > 0.5);
  }
  get nextInt() {
    return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .sync */ .Z_X(() => this.PRNG.integer(Number.MAX_SAFE_INTEGER));
  }
  nextRange(min, max) {
    return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UID(this.next, n => (max - min) * n + min);
  }
  nextIntBetween(min, max) {
    return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .sync */ .Z_X(() => this.PRNG.integer(max - min) + min);
  }
  shuffle(elements) {
    return shuffleWith(elements, n => this.nextIntBetween(0, n));
  }
}
const shuffleWith = (elements, nextIntBounded) => {
  return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .suspend */ .RqG(() => (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(_core_js__WEBPACK_IMPORTED_MODULE_2__/* .sync */ .Z_X(() => Array.from(elements)), _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(buffer => {
    const numbers = [];
    for (let i = buffer.length; i >= 2; i = i - 1) {
      numbers.push(i);
    }
    return (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(numbers, _core_js__WEBPACK_IMPORTED_MODULE_2__/* .forEachSequentialDiscard */ .EaP(n => (0,_Function_js__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(nextIntBounded(n), _core_js__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UID(k => swap(buffer, n - 1, k)))), _core_js__WEBPACK_IMPORTED_MODULE_2__.as(_Chunk_js__WEBPACK_IMPORTED_MODULE_4__/* .fromIterable */ .EE(buffer)));
  })));
};
const swap = (buffer, index1, index2) => {
  const tmp = buffer[index1];
  buffer[index1] = buffer[index2];
  buffer[index2] = tmp;
  return buffer;
};
const make = seed => new RandomImpl(_Hash_js__WEBPACK_IMPORTED_MODULE_5__/* .hash */ .vp(seed));
//# sourceMappingURL=random.js.map

/***/ }),

/***/ 7411:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CX": function() { return /* binding */ getAndUpdate; },
/* harmony export */   "Dg": function() { return /* binding */ setAndGet; },
/* harmony export */   "HC": function() { return /* binding */ getAndUpdateSome; },
/* harmony export */   "J5": function() { return /* binding */ updateAndGet; },
/* harmony export */   "Mr": function() { return /* binding */ refVariance; },
/* harmony export */   "NY": function() { return /* binding */ updateSomeAndGet; },
/* harmony export */   "Of": function() { return /* binding */ modifySome; },
/* harmony export */   "Pj": function() { return /* binding */ modify; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "Vx": function() { return /* binding */ update; },
/* harmony export */   "n7": function() { return /* binding */ RefTypeId; },
/* harmony export */   "nZ": function() { return /* binding */ updateSome; },
/* harmony export */   "t0": function() { return /* binding */ unsafeMake; },
/* harmony export */   "t8": function() { return /* binding */ set; },
/* harmony export */   "yO": function() { return /* binding */ getAndSet; }
/* harmony export */ });
/* unused harmony export unsafeGet */
/* harmony import */ var _Effectable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34744);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17316);
/* harmony import */ var _MutableRef_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23182);
/* harmony import */ var _Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16749);
/* harmony import */ var _Readable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88005);
/* harmony import */ var _core_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39355);






/** @internal */
const RefTypeId = /*#__PURE__*/Symbol.for("effect/Ref");
/** @internal */
const refVariance = {
  /* c8 ignore next */
  _A: _ => _
};
class RefImpl extends _Effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .Class */ .wT {
  ref;
  commit() {
    return this.get;
  }
  [RefTypeId] = refVariance;
  [_Readable_js__WEBPACK_IMPORTED_MODULE_1__/* .TypeId */ .aC] = _Readable_js__WEBPACK_IMPORTED_MODULE_1__/* .TypeId */ .aC;
  constructor(ref) {
    super();
    this.ref = ref;
    this.get = _core_js__WEBPACK_IMPORTED_MODULE_2__/* .sync */ .Z_X(() => _MutableRef_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(this.ref));
  }
  get;
  modify(f) {
    return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .sync */ .Z_X(() => {
      const current = _MutableRef_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(this.ref);
      const [b, a] = f(current);
      if (current !== a) {
        _MutableRef_js__WEBPACK_IMPORTED_MODULE_3__/* .set */ .t8(a)(this.ref);
      }
      return b;
    });
  }
}
/** @internal */
const unsafeMake = value => new RefImpl(_MutableRef_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .Sy(value));
/** @internal */
const make = value => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .sync */ .Z_X(() => unsafeMake(value));
/** @internal */
const get = self => self.get;
/** @internal */
const set = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_4__/* .dual */ .OB)(2, (self, value) => self.modify(() => [void 0, value]));
/** @internal */
const getAndSet = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_4__/* .dual */ .OB)(2, (self, value) => self.modify(a => [a, value]));
/** @internal */
const getAndUpdate = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_4__/* .dual */ .OB)(2, (self, f) => self.modify(a => [a, f(a)]));
/** @internal */
const getAndUpdateSome = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_4__/* .dual */ .OB)(2, (self, pf) => self.modify(value => {
  const option = pf(value);
  switch (option._tag) {
    case "None":
      {
        return [value, value];
      }
    case "Some":
      {
        return [value, option.value];
      }
  }
}));
/** @internal */
const setAndGet = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_4__/* .dual */ .OB)(2, (self, value) => self.modify(() => [value, value]));
/** @internal */
const modify = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_4__/* .dual */ .OB)(2, (self, f) => self.modify(f));
/** @internal */
const modifySome = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_4__/* .dual */ .OB)(3, (self, fallback, pf) => self.modify(value => {
  const option = pf(value);
  switch (option._tag) {
    case "None":
      {
        return [fallback, value];
      }
    case "Some":
      {
        return option.value;
      }
  }
}));
/** @internal */
const update = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_4__/* .dual */ .OB)(2, (self, f) => self.modify(a => [void 0, f(a)]));
/** @internal */
const updateAndGet = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_4__/* .dual */ .OB)(2, (self, f) => self.modify(a => {
  const result = f(a);
  return [result, result];
}));
/** @internal */
const updateSome = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_4__/* .dual */ .OB)(2, (self, f) => self.modify(a => [void 0, _Option_js__WEBPACK_IMPORTED_MODULE_5__/* .match */ .EQ(f(a), {
  onNone: () => a,
  onSome: b => b
})]));
/** @internal */
const updateSomeAndGet = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_4__/* .dual */ .OB)(2, (self, pf) => self.modify(value => {
  const option = pf(value);
  switch (option._tag) {
    case "None":
      {
        return [value, value];
      }
    case "Some":
      {
        return [option.value, option.value];
      }
  }
}));
/** @internal */
const unsafeGet = self => MutableRef.get(self.ref);
//# sourceMappingURL=ref.js.map

/***/ }),

/***/ 82913:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AM": function() { return /* binding */ completeEffect; },
/* harmony export */   "Dh": function() { return /* binding */ failCause; },
/* harmony export */   "N": function() { return /* binding */ complete; },
/* harmony export */   "NS": function() { return /* binding */ tagged; },
/* harmony export */   "Vd": function() { return /* binding */ RequestTypeId; },
/* harmony export */   "bG": function() { return /* binding */ fail; },
/* harmony export */   "cL": function() { return /* binding */ TaggedClass; },
/* harmony export */   "gJ": function() { return /* binding */ isRequest; },
/* harmony export */   "ng": function() { return /* binding */ succeed; },
/* harmony export */   "of": function() { return /* binding */ of; },
/* harmony export */   "wT": function() { return /* binding */ Class; },
/* harmony export */   "zy": function() { return /* binding */ Listeners; }
/* harmony export */ });
/* unused harmony export filterOutCompleted */
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17316);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71335);
/* harmony import */ var _completedRequestMap_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99609);
/* harmony import */ var _core_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39355);
/* harmony import */ var _effectable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10020);





/** @internal */
const RequestSymbolKey = "effect/Request";
/** @internal */
const RequestTypeId = /*#__PURE__*/Symbol.for(RequestSymbolKey);
const requestVariance = {
  /* c8 ignore next */
  _E: _ => _,
  /* c8 ignore next */
  _A: _ => _
};
const RequestPrototype = {
  ..._effectable_js__WEBPACK_IMPORTED_MODULE_0__/* .StructuralPrototype */ .EO,
  [RequestTypeId]: requestVariance
};
/** @internal */
const isRequest = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_1__/* .hasProperty */ .l$)(u, RequestTypeId);
/** @internal */
const of = () => args => Object.assign(Object.create(RequestPrototype), args);
/** @internal */
const tagged = tag => args => {
  const request = Object.assign(Object.create(RequestPrototype), args);
  request._tag = tag;
  return request;
};
/** @internal */
const Class = /*#__PURE__*/function () {
  function Class(args) {
    if (args) {
      Object.assign(this, args);
    }
  }
  Class.prototype = RequestPrototype;
  return Class;
}();
/** @internal */
const TaggedClass = tag => {
  return class TaggedClass extends Class {
    _tag = tag;
  };
};
/** @internal */
const complete = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, result) => _core_js__WEBPACK_IMPORTED_MODULE_3__/* .fiberRefGetWith */ .$Dw(_completedRequestMap_js__WEBPACK_IMPORTED_MODULE_4__/* .currentRequestMap */ .d, map => _core_js__WEBPACK_IMPORTED_MODULE_3__/* .sync */ .Z_X(() => {
  if (map.has(self)) {
    const entry = map.get(self);
    if (!entry.state.completed) {
      entry.state.completed = true;
      _core_js__WEBPACK_IMPORTED_MODULE_3__/* .deferredUnsafeDone */ .zxF(entry.result, result);
    }
  }
})));
/** @internal */
const completeEffect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, effect) => _core_js__WEBPACK_IMPORTED_MODULE_3__/* .matchEffect */ .PwY(effect, {
  onFailure: error => complete(self, _core_js__WEBPACK_IMPORTED_MODULE_3__/* .exitFail */ .bT5(error)),
  onSuccess: value => complete(self, _core_js__WEBPACK_IMPORTED_MODULE_3__/* .exitSucceed */ .SID(value))
}));
/** @internal */
const fail = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, error) => complete(self, _core_js__WEBPACK_IMPORTED_MODULE_3__/* .exitFail */ .bT5(error)));
/** @internal */
const failCause = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, cause) => complete(self, _core_js__WEBPACK_IMPORTED_MODULE_3__/* .exitFailCause */ .KiG(cause)));
/** @internal */
const succeed = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_2__/* .dual */ .OB)(2, (self, value) => complete(self, _core_js__WEBPACK_IMPORTED_MODULE_3__/* .exitSucceed */ .SID(value)));
/** @internal */
class Listeners {
  count = 0;
  observers = /*#__PURE__*/new Set();
  interrupted = false;
  addObserver(f) {
    this.observers.add(f);
  }
  removeObserver(f) {
    this.observers.delete(f);
  }
  increment() {
    this.count++;
    this.observers.forEach(f => f(this.count));
  }
  decrement() {
    this.count--;
    this.observers.forEach(f => f(this.count));
  }
}
/**
 * @internal
 */
const filterOutCompleted = requests => core.fiberRefGetWith(completedRequestMap.currentRequestMap, map => core.succeed(requests.filter(request => !(map.get(request)?.state.completed === true))));
//# sourceMappingURL=request.js.map

/***/ }),

/***/ 22296:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FW": function() { return /* binding */ asyncEffect; },
  "rt": function() { return /* binding */ defaultRuntime; },
  "GZ": function() { return /* binding */ runtime; },
  "m5": function() { return /* binding */ unsafeForkEffect; },
  "pd": function() { return /* binding */ unsafeRunEffect; },
  "GB": function() { return /* binding */ unsafeRunPromiseEffect; },
  "p6": function() { return /* binding */ unsafeRunPromiseExitEffect; },
  "I7": function() { return /* binding */ unsafeRunSyncEffect; },
  "uv": function() { return /* binding */ unsafeRunSyncExitEffect; }
});

// UNUSED EXPORTS: FiberFailureCauseId, FiberFailureId, RuntimeImpl, defaultRuntimeFlags, deleteFiberRef, disableRuntimeFlag, enableRuntimeFlag, fiberFailure, isAsyncFiberException, isFiberFailure, make, provideService, setFiberRef, unsafeFork, unsafeRunCallback, unsafeRunPromise, unsafeRunPromiseExit, unsafeRunSync, unsafeRunSyncExit, updateContext, updateFiberRefs, updateRuntimeFlags

// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Context.js
var esm_Context = __webpack_require__(20591);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Equal.js
var Equal = __webpack_require__(67492);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Exit.js
var Exit = __webpack_require__(76658);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/core.js + 1 modules
var core = __webpack_require__(39355);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/effect/circular.js
var circular = __webpack_require__(34606);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/fiber.js
var fiber = __webpack_require__(63914);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/fiberRuntime.js + 14 modules
var internal_fiberRuntime = __webpack_require__(90886);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/Fiber.js




/**
 * @since 2.0.0
 * @category symbols
 */
const FiberTypeId = fiber/* FiberTypeId */.tP;
/**
 * @since 2.0.0
 * @category symbols
 */
const RuntimeFiberTypeId = fiber/* RuntimeFiberTypeId */.Zq;
/**
 * @since 2.0.0
 * @category instances
 */
const Order = fiber/* Order */.KM;
/**
 * Returns `true` if the specified value is a `Fiber`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isFiber = fiber/* isFiber */.A1;
/**
 * Returns `true` if the specified `Fiber` is a `RuntimeFiber`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isRuntimeFiber = fiber/* isRuntimeFiber */.Mz;
/**
 * The identity of the fiber.
 *
 * @since 2.0.0
 * @category getters
 */
const id = fiber.id;
const _await = fiber/* _await */.AO;

/**
 * Awaits on all fibers to be completed, successfully or not.
 *
 * @since 2.0.0
 * @category destructors
 */
const awaitAll = internal_fiberRuntime/* fiberAwaitAll */.GR;
/**
 * Retrieves the immediate children of the fiber.
 *
 * @since 2.0.0
 * @category getters
 */
const children = fiber/* children */.pI;
/**
 * Collects all fibers into a single fiber producing an in-order list of the
 * results.
 *
 * @since 2.0.0
 * @category constructors
 */
const Fiber_all = internal_fiberRuntime/* fiberAll */.kC;
/**
 * A fiber that is done with the specified `Exit` value.
 *
 * @since 2.0.0
 * @category constructors
 */
const done = fiber/* done */.aT;
/**
 * @since 2.0.0
 * @category destructors
 */
const dump = fiber/* dump */.$w;
/**
 * @since 2.0.0
 * @category destructors
 */
const dumpAll = fiber/* dumpAll */.Wr;
/**
 * A fiber that has already failed with the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
const fail = fiber/* fail */.bG;
/**
 * Creates a `Fiber` that has already failed with the specified cause.
 *
 * @since 2.0.0
 * @category constructors
 */
const failCause = fiber/* failCause */.Dh;
/**
 * Lifts an `Effect` into a `Fiber`.
 *
 * @since 2.0.0
 * @category conversions
 */
const fromEffect = fiber/* fromEffect */.SH;
/**
 * Gets the current fiber if one is running.
 *
 * @since 2.0.0
 * @category utilities
 */
const getCurrentFiber = fiber/* getCurrentFiber */.QY;
/**
 * Inherits values from all `FiberRef` instances into current fiber. This
 * will resume immediately.
 *
 * @since 2.0.0
 * @category destructors
 */
const inheritAll = fiber/* inheritAll */.i0;
/**
 * Interrupts the fiber from whichever fiber is calling this method. If the
 * fiber has already exited, the returned effect will resume immediately.
 * Otherwise, the effect will resume when the fiber exits.
 *
 * @since 2.0.0
 * @category interruption
 */
const interrupt = core/* interruptFiber */.u_W;
/**
 * Constructrs a `Fiber` that is already interrupted.
 *
 * @since 2.0.0
 * @category constructors
 */
const interrupted = fiber/* interrupted */.K2;
/**
 * Interrupts the fiber as if interrupted from the specified fiber. If the
 * fiber has already exited, the returned effect will resume immediately.
 * Otherwise, the effect will resume when the fiber exits.
 *
 * @since 2.0.0
 * @category interruption
 */
const interruptAs = core/* interruptAsFiber */.zU1;
/**
 * Interrupts the fiber as if interrupted from the specified fiber. If the
 * fiber has already exited, the returned effect will resume immediately.
 * Otherwise, the effect will resume when the fiber exits.
 *
 * @since 2.0.0
 * @category interruption
 */
const interruptAsFork = fiber/* interruptAsFork */.Mt;
/**
 * Interrupts all fibers, awaiting their interruption.
 *
 * @since 2.0.0
 * @category interruption
 */
const interruptAll = fiber/* interruptAll */.m2;
/**
 * Interrupts all fibers as by the specified fiber, awaiting their
 * interruption.
 *
 * @since 2.0.0
 * @category interruption
 */
const interruptAllAs = fiber/* interruptAllAs */.h3;
/**
 * Interrupts the fiber from whichever fiber is calling this method. The
 * interruption will happen in a separate daemon fiber, and the returned
 * effect will always resume immediately without waiting.
 *
 * @since 2.0.0
 * @category interruption
 */
const interruptFork = internal_fiberRuntime/* fiberInterruptFork */.QO;
/**
 * Joins the fiber, which suspends the joining fiber until the result of the
 * fiber has been determined. Attempting to join a fiber that has erred will
 * result in a catchable error. Joining an interrupted fiber will result in an
 * "inner interruption" of this fiber, unlike interruption triggered by
 * another fiber, "inner interruption" can be caught and recovered.
 *
 * @since 2.0.0
 * @category destructors
 */
const join = fiber/* join */.v_;
/**
 * Joins all fibers, awaiting their _successful_ completion. Attempting to
 * join a fiber that has erred will result in a catchable error, _if_ that
 * error does not result from interruption.
 *
 * @since 2.0.0
 * @category destructors
 */
const joinAll = internal_fiberRuntime/* fiberJoinAll */.pM;
/**
 * Maps over the value the Fiber computes.
 *
 * @since 2.0.0
 * @category mapping
 */
const map = fiber/* map */.UI;
/**
 * Effectually maps over the value the fiber computes.
 *
 * @since 2.0.0
 * @category mapping
 */
const mapEffect = fiber/* mapEffect */.J1;
/**
 * Passes the success of this fiber to the specified callback, and continues
 * with the fiber that it returns.
 *
 * @since 2.0.0
 * @category mapping
 */
const mapFiber = fiber/* mapFiber */.Jy;
/**
 * Folds over the `Fiber` or `RuntimeFiber`.
 *
 * @since 2.0.0
 * @category folding
 */
const match = fiber/* match */.EQ;
/**
 * A fiber that never fails or succeeds.
 *
 * @since 2.0.0
 * @category constructors
 */
const never = fiber/* never */.Fi;
/**
 * Returns a fiber that prefers `this` fiber, but falls back to the `that` one
 * when `this` one fails. Interrupting the returned fiber will interrupt both
 * fibers, sequentially, from left to right.
 *
 * @since 2.0.0
 * @category alternatives
 */
const orElse = fiber/* orElse */.vx;
/**
 * Returns a fiber that prefers `this` fiber, but falls back to the `that` one
 * when `this` one fails. Interrupting the returned fiber will interrupt both
 * fibers, sequentially, from left to right.
 *
 * @since 2.0.0
 * @category alternatives
 */
const orElseEither = fiber/* orElseEither */.O0;
/**
 * Tentatively observes the fiber, but returns immediately if it is not
 * already done.
 *
 * @since 2.0.0
 * @category getters
 */
const poll = fiber/* poll */.$l;
/**
 * Pretty-prints a `RuntimeFiber`.
 *
 * @since 2.0.0
 * @category destructors
 */
const pretty = fiber/* pretty */.IC;
/**
 * Returns a chunk containing all root fibers.
 *
 * @since 2.0.0
 * @category constructors
 */
const roots = fiber/* roots */.VK;
/**
 * Returns a chunk containing all root fibers.
 *
 * @since 2.0.0
 * @category constructors
 */
const unsafeRoots = fiber/* unsafeRoots */.R2;
/**
 * Converts this fiber into a scoped effect. The fiber is interrupted when the
 * scope is closed.
 *
 * @since 2.0.0
 * @category destructors
 */
const scoped = internal_fiberRuntime/* fiberScoped */.SI;
/**
 * Returns the `FiberStatus` of a `RuntimeFiber`.
 *
 * @since 2.0.0
 * @category getters
 */
const Fiber_status = fiber/* status */.i7;
/**
 * Returns a fiber that has already succeeded with the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
const succeed = fiber/* succeed */.ng;
const void_ = fiber/* void */.Hc;

/**
 * Zips this fiber and the specified fiber together, producing a tuple of
 * their output.
 *
 * @since 2.0.0
 * @category zipping
 */
const zip = circular/* zipFiber */.D6;
/**
 * Same as `zip` but discards the output of that `Fiber`.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipLeft = circular/* zipLeftFiber */.H4;
/**
 * Same as `zip` but discards the output of this `Fiber`.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipRight = circular/* zipRightFiber */.v9;
/**
 * Zips this fiber with the specified fiber, combining their results using the
 * specified combiner function. Both joins and interruptions are performed in
 * sequential order from left to right.
 *
 * @since 2.0.0
 * @category zipping
 */
const zipWith = circular/* zipWithFiber */.v$;
//# sourceMappingURL=Fiber.js.map
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/FiberId.js
var esm_FiberId = __webpack_require__(57303);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/FiberRefs.js
var esm_FiberRefs = __webpack_require__(6639);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Function.js
var Function = __webpack_require__(17316);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Inspectable.js
var Inspectable = __webpack_require__(16371);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Option.js
var Option = __webpack_require__(16749);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Pipeable.js
var Pipeable = __webpack_require__(92817);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Scheduler.js
var Scheduler = __webpack_require__(22019);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/Scope.js
var Scope = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/cause.js + 1 modules
var internal_cause = __webpack_require__(69579);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/executionStrategy.js
var executionStrategy = __webpack_require__(49941);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/fiberScope.js
var fiberScope = __webpack_require__(51770);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/opCodes/effect.js
var opCodes_effect = __webpack_require__(11713);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/runtimeFlags.js
var internal_runtimeFlags = __webpack_require__(4536);
// EXTERNAL MODULE: ./node_modules/effect/dist/esm/internal/supervisor.js
var internal_supervisor = __webpack_require__(34357);
;// CONCATENATED MODULE: ./node_modules/effect/dist/esm/internal/runtime.js





















const makeDual = f => function () {
  if (arguments.length === 1) {
    const runtime = arguments[0];
    return (effect, ...args) => f(runtime, effect, ...args);
  }
  return f.apply(this, arguments);
};
/** @internal */
const unsafeFork = /*#__PURE__*/makeDual((runtime, self, options) => {
  const fiberId = esm_FiberId/* unsafeMake */.t0();
  const fiberRefUpdates = [[core/* currentContext */.gbX, [[fiberId, runtime.context]]]];
  if (options?.scheduler) {
    fiberRefUpdates.push([Scheduler/* currentScheduler */.xt, [[fiberId, options.scheduler]]]);
  }
  let fiberRefs = esm_FiberRefs/* updateManyAs */.iW(runtime.fiberRefs, {
    entries: fiberRefUpdates,
    forkAs: fiberId
  });
  if (options?.updateRefs) {
    fiberRefs = options.updateRefs(fiberRefs, fiberId);
  }
  const fiberRuntime = new internal_fiberRuntime/* FiberRuntime */.Ou(fiberId, fiberRefs, runtime.runtimeFlags);
  let effect = self;
  if (options?.scope) {
    effect = core/* flatMap */.VSD(Scope/* fork */.rM(options.scope, executionStrategy/* sequential */.Pe), closeableScope => core/* zipRight */.qs5(core/* scopeAddFinalizer */.tFM(closeableScope, core/* fiberIdWith */.mrY(id => (0,Equal/* equals */.fS)(id, fiberRuntime.id()) ? core/* void */.Hcj : core/* interruptAsFiber */.zU1(fiberRuntime, id))), core/* onExit */.dsk(self, exit => Scope/* close */.xv(closeableScope, exit))));
  }
  const supervisor = fiberRuntime.currentSupervisor;
  // we can compare by reference here as _supervisor.none is wrapped with globalValue
  if (supervisor !== internal_supervisor/* none */.YP) {
    supervisor.onStart(runtime.context, effect, Option/* none */.YP(), fiberRuntime);
    fiberRuntime.addObserver(exit => supervisor.onEnd(exit, fiberRuntime));
  }
  fiberScope/* globalScope.add */._A.add(runtime.runtimeFlags, fiberRuntime);
  // Only an explicit false will prevent immediate execution
  if (options?.immediate === false) {
    fiberRuntime.resume(effect);
  } else {
    fiberRuntime.start(effect);
  }
  return fiberRuntime;
});
/** @internal */
const unsafeRunCallback = /*#__PURE__*/makeDual((runtime, effect, options = {}) => {
  const fiberRuntime = unsafeFork(runtime, effect, options);
  if (options.onExit) {
    fiberRuntime.addObserver(exit => {
      options.onExit(exit);
    });
  }
  return (id, cancelOptions) => unsafeRunCallback(runtime)((0,Function/* pipe */.zG)(fiberRuntime, interruptAs(id ?? esm_FiberId/* none */.YP)), {
    ...cancelOptions,
    onExit: cancelOptions?.onExit ? exit => cancelOptions.onExit(Exit/* flatten */.xH(exit)) : undefined
  });
});
/** @internal */
const unsafeRunSync = /*#__PURE__*/makeDual((runtime, effect) => {
  const result = unsafeRunSyncExit(runtime)(effect);
  if (result._tag === "Failure") {
    throw fiberFailure(result.effect_instruction_i0);
  }
  return result.effect_instruction_i0;
});
class AsyncFiberExceptionImpl extends Error {
  fiber;
  _tag = "AsyncFiberException";
  constructor(fiber) {
    super(`Fiber #${fiber.id().id} cannot be resolved synchronously. This is caused by using runSync on an effect that performs async work`);
    this.fiber = fiber;
    this.name = this._tag;
    this.stack = this.message;
  }
}
const asyncFiberException = fiber => {
  const limit = Error.stackTraceLimit;
  Error.stackTraceLimit = 0;
  const error = new AsyncFiberExceptionImpl(fiber);
  Error.stackTraceLimit = limit;
  return error;
};
/** @internal */
const isAsyncFiberException = u => Predicate.isTagged(u, "AsyncFiberException") && "fiber" in u;
/** @internal */
const FiberFailureId = /*#__PURE__*/Symbol.for("effect/Runtime/FiberFailure");
/** @internal */
const FiberFailureCauseId = /*#__PURE__*/Symbol.for("effect/Runtime/FiberFailure/Cause");
class FiberFailureImpl extends Error {
  [FiberFailureId];
  [FiberFailureCauseId];
  constructor(cause) {
    const head = internal_cause/* prettyErrors */.sD(cause)[0];
    super(head?.message || "An error has occurred");
    this[FiberFailureId] = FiberFailureId;
    this[FiberFailureCauseId] = cause;
    this.name = head ? `(FiberFailure) ${head.name}` : "FiberFailure";
    if (head?.stack) {
      this.stack = head.stack;
    }
  }
  toJSON() {
    return {
      _id: "FiberFailure",
      cause: this[FiberFailureCauseId].toJSON()
    };
  }
  toString() {
    return "(FiberFailure) " + internal_cause/* pretty */.IC(this[FiberFailureCauseId], {
      renderErrorCause: true
    });
  }
  [Inspectable/* NodeInspectSymbol */.j5]() {
    return this.toString();
  }
}
/** @internal */
const fiberFailure = cause => {
  const limit = Error.stackTraceLimit;
  Error.stackTraceLimit = 0;
  const error = new FiberFailureImpl(cause);
  Error.stackTraceLimit = limit;
  return error;
};
/** @internal */
const isFiberFailure = u => Predicate.hasProperty(u, FiberFailureId);
const fastPath = effect => {
  const op = effect;
  switch (op._op) {
    case "Failure":
    case "Success":
      {
        // @ts-expect-error
        return op;
      }
    case "Left":
      {
        return core/* exitFail */.bT5(op.left);
      }
    case "Right":
      {
        return core/* exitSucceed */.SID(op.right);
      }
    case "Some":
      {
        return core/* exitSucceed */.SID(op.value);
      }
    case "None":
      {
        // @ts-expect-error
        return core/* exitFail */.bT5(core/* NoSuchElementException */.buj());
      }
  }
};
/** @internal */
const unsafeRunSyncExit = /*#__PURE__*/makeDual((runtime, effect) => {
  const op = fastPath(effect);
  if (op) {
    return op;
  }
  const scheduler = new Scheduler/* SyncScheduler */.$V();
  const fiberRuntime = unsafeFork(runtime)(effect, {
    scheduler
  });
  scheduler.flush();
  const result = fiberRuntime.unsafePoll();
  if (result) {
    return result;
  }
  return core/* exitDie */.ai8(core/* capture */.IED(asyncFiberException(fiberRuntime), core/* currentSpanFromFiber */.vOg(fiberRuntime)));
});
/** @internal */
const unsafeRunPromise = /*#__PURE__*/makeDual((runtime, effect, options) => unsafeRunPromiseExit(runtime, effect, options).then(result => {
  switch (result._tag) {
    case opCodes_effect/* OP_SUCCESS */.x$:
      {
        return result.effect_instruction_i0;
      }
    case opCodes_effect/* OP_FAILURE */.N4:
      {
        throw fiberFailure(result.effect_instruction_i0);
      }
  }
}));
/** @internal */
const unsafeRunPromiseExit = /*#__PURE__*/makeDual((runtime, effect, options) => new Promise(resolve => {
  const op = fastPath(effect);
  if (op) {
    resolve(op);
  }
  const fiber = unsafeFork(runtime)(effect);
  fiber.addObserver(exit => {
    resolve(exit);
  });
  if (options?.signal !== undefined) {
    if (options.signal.aborted) {
      fiber.unsafeInterruptAsFork(fiber.id());
    } else {
      options.signal.addEventListener("abort", () => {
        fiber.unsafeInterruptAsFork(fiber.id());
      }, {
        once: true
      });
    }
  }
}));
/** @internal */
class RuntimeImpl {
  context;
  runtimeFlags;
  fiberRefs;
  constructor(context, runtimeFlags, fiberRefs) {
    this.context = context;
    this.runtimeFlags = runtimeFlags;
    this.fiberRefs = fiberRefs;
  }
  pipe() {
    return (0,Pipeable/* pipeArguments */.n)(this, arguments);
  }
}
/** @internal */
const make = options => new RuntimeImpl(options.context, options.runtimeFlags, options.fiberRefs);
/** @internal */
const runtime = () => core/* withFiberRuntime */.ECC((state, status) => core/* succeed */.ng0(new RuntimeImpl(state.getFiberRef(core/* currentContext */.gbX), status.runtimeFlags, state.getFiberRefs())));
/** @internal */
const defaultRuntimeFlags = /*#__PURE__*/internal_runtimeFlags/* make */.Sy(internal_runtimeFlags/* Interruption */.tm, internal_runtimeFlags/* CooperativeYielding */.d0, internal_runtimeFlags/* RuntimeMetrics */.LC);
/** @internal */
const defaultRuntime = /*#__PURE__*/make({
  context: /*#__PURE__*/esm_Context/* empty */.cS(),
  runtimeFlags: defaultRuntimeFlags,
  fiberRefs: /*#__PURE__*/esm_FiberRefs/* empty */.cS()
});
/** @internal */
const updateRuntimeFlags = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => make({
  context: self.context,
  runtimeFlags: f(self.runtimeFlags),
  fiberRefs: self.fiberRefs
}))));
/** @internal */
const disableRuntimeFlag = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, flag) => updateRuntimeFlags(self, runtimeFlags.disable(flag)))));
/** @internal */
const enableRuntimeFlag = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, flag) => updateRuntimeFlags(self, runtimeFlags.enable(flag)))));
/** @internal */
const updateContext = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => make({
  context: f(self.context),
  runtimeFlags: self.runtimeFlags,
  fiberRefs: self.fiberRefs
}))));
/** @internal */
const provideService = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, tag, service) => updateContext(self, Context.add(tag, service)))));
/** @internal */
const updateFiberRefs = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => make({
  context: self.context,
  runtimeFlags: self.runtimeFlags,
  fiberRefs: f(self.fiberRefs)
}))));
/** @internal */
const setFiberRef = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, fiberRef, value) => updateFiberRefs(self, FiberRefs.updateAs({
  fiberId: FiberId.none,
  fiberRef,
  value
})))));
/** @internal */
const deleteFiberRef = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, fiberRef) => updateFiberRefs(self, FiberRefs.delete(fiberRef)))));
/** @internal */
const unsafeRunEffect = /*#__PURE__*/unsafeRunCallback(defaultRuntime);
/** @internal */
const unsafeForkEffect = /*#__PURE__*/unsafeFork(defaultRuntime);
/** @internal */
const unsafeRunPromiseEffect = /*#__PURE__*/unsafeRunPromise(defaultRuntime);
/** @internal */
const unsafeRunPromiseExitEffect = /*#__PURE__*/unsafeRunPromiseExit(defaultRuntime);
/** @internal */
const unsafeRunSyncEffect = /*#__PURE__*/unsafeRunSync(defaultRuntime);
/** @internal */
const unsafeRunSyncExitEffect = /*#__PURE__*/unsafeRunSyncExit(defaultRuntime);
// circular with Effect
/** @internal */
const asyncEffect = register => core/* suspend */.RqG(() => {
  let cleanup = undefined;
  return core/* flatMap */.VSD(core/* deferredMake */.kPu(), deferred => core/* flatMap */.VSD(runtime(), runtime => core/* uninterruptibleMask */.UO$(restore => core/* zipRight */.qs5(internal_fiberRuntime/* fork */.rM(restore(core/* matchCauseEffect */.Bpg(register(cb => unsafeRunCallback(runtime)(core/* intoDeferred */.S4Q(cb, deferred))), {
    onFailure: cause => core/* deferredFailCause */.yd6(deferred, cause),
    onSuccess: cleanup_ => {
      cleanup = cleanup_;
      return core/* void */.Hcj;
    }
  }))), restore(core/* onInterrupt */.J7b(core/* deferredAwait */.Odg(deferred), () => cleanup ?? core/* void */.Hcj))))));
});
//# sourceMappingURL=runtime.js.map

/***/ }),

/***/ 4536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FZ": function() { return /* binding */ differ; },
/* harmony export */   "GO": function() { return /* binding */ interruption; },
/* harmony export */   "Hg": function() { return /* binding */ diff; },
/* harmony export */   "LA": function() { return /* binding */ runtimeMetrics; },
/* harmony export */   "LC": function() { return /* binding */ RuntimeMetrics; },
/* harmony export */   "Q6": function() { return /* binding */ enabledSet; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "Wu": function() { return /* binding */ disabledSet; },
/* harmony export */   "YP": function() { return /* binding */ none; },
/* harmony export */   "d0": function() { return /* binding */ CooperativeYielding; },
/* harmony export */   "dY": function() { return /* binding */ cooperativeYielding; },
/* harmony export */   "mP": function() { return /* binding */ OpSupervision; },
/* harmony export */   "r$": function() { return /* binding */ patch; },
/* harmony export */   "st": function() { return /* binding */ WindDown; },
/* harmony export */   "tm": function() { return /* binding */ Interruption; },
/* harmony export */   "um": function() { return /* binding */ interruptible; },
/* harmony export */   "wp": function() { return /* binding */ enable; },
/* harmony export */   "yI": function() { return /* binding */ renderPatch; }
/* harmony export */ });
/* unused harmony exports None, allFlags, disable, disableAll, enableAll, isDisabled, isEnabled, opSupervision, render, toSet, windDown */
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17316);
/* harmony import */ var _differ_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49398);
/* harmony import */ var _runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43886);



/** @internal */
const None = 0;
/** @internal */
const Interruption = 1 << 0;
/** @internal */
const OpSupervision = 1 << 1;
/** @internal */
const RuntimeMetrics = 1 << 2;
/** @internal */
const WindDown = 1 << 4;
/** @internal */
const CooperativeYielding = 1 << 5;
/** @internal */
const allFlags = [None, Interruption, OpSupervision, RuntimeMetrics, WindDown, CooperativeYielding];
const print = flag => {
  switch (flag) {
    case CooperativeYielding:
      {
        return "CooperativeYielding";
      }
    case WindDown:
      {
        return "WindDown";
      }
    case RuntimeMetrics:
      {
        return "RuntimeMetrics";
      }
    case OpSupervision:
      {
        return "OpSupervision";
      }
    case Interruption:
      {
        return "Interruption";
      }
    case None:
      {
        return "None";
      }
  }
};
/** @internal */
const cooperativeYielding = self => isEnabled(self, CooperativeYielding);
/** @internal */
const disable = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, flag) => self & ~flag)));
/** @internal */
const disableAll = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, flags) => self & ~flags)));
/** @internal */
const enable = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, flag) => self | flag);
/** @internal */
const enableAll = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, flags) => self | flags)));
/** @internal */
const interruptible = self => interruption(self) && !windDown(self);
/** @internal */
const interruption = self => isEnabled(self, Interruption);
/** @internal */
const isDisabled = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, flag) => !isEnabled(self, flag))));
/** @internal */
const isEnabled = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, flag) => (self & flag) !== 0);
/** @internal */
const make = (...flags) => flags.reduce((a, b) => a | b, 0);
/** @internal */
const none = /*#__PURE__*/make(None);
/** @internal */
const opSupervision = self => isEnabled(self, OpSupervision);
/** @internal */
const render = self => {
  const active = [];
  allFlags.forEach(flag => {
    if (isEnabled(self, flag)) {
      active.push(`${print(flag)}`);
    }
  });
  return `RuntimeFlags(${active.join(", ")})`;
};
/** @internal */
const runtimeMetrics = self => isEnabled(self, RuntimeMetrics);
/** @internal */
const toSet = self => new Set(allFlags.filter(flag => isEnabled(self, flag)));
const windDown = self => isEnabled(self, WindDown);
// circular with RuntimeFlagsPatch
/** @internal */
const enabledSet = self => toSet(_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_1__/* .active */ .bB(self) & _runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_1__/* .enabled */ .am(self));
/** @internal */
const disabledSet = self => toSet(_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_1__/* .active */ .bB(self) & ~_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_1__/* .enabled */ .am(self));
/** @internal */
const diff = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, that) => _runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .Sy(self ^ that, that));
/** @internal */
const patch = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, patch) => self & (_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_1__/* .invert */ .U_(_runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_1__/* .active */ .bB(patch)) | _runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_1__/* .enabled */ .am(patch)) | _runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_1__/* .active */ .bB(patch) & _runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_1__/* .enabled */ .am(patch));
/** @internal */
const renderPatch = self => {
  const enabled = Array.from(enabledSet(self)).map(flag => print(flag)).join(", ");
  const disabled = Array.from(disabledSet(self)).map(flag => print(flag)).join(", ");
  return `RuntimeFlagsPatch(enabled = (${enabled}), disabled = (${disabled}))`;
};
/** @internal */
const differ = /*#__PURE__*/_differ_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .Sy({
  empty: _runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS,
  diff: (oldValue, newValue) => diff(oldValue, newValue),
  combine: (first, second) => _runtimeFlagsPatch_js__WEBPACK_IMPORTED_MODULE_1__/* .andThen */ .Po(second)(first),
  patch: (_patch, oldValue) => patch(oldValue, _patch)
});
//# sourceMappingURL=runtimeFlags.js.map

/***/ }),

/***/ 43886:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "De": function() { return /* binding */ exclude; },
/* harmony export */   "Hk": function() { return /* binding */ both; },
/* harmony export */   "Po": function() { return /* binding */ andThen; },
/* harmony export */   "SO": function() { return /* binding */ inverse; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "U_": function() { return /* binding */ invert; },
/* harmony export */   "_k": function() { return /* binding */ isEnabled; },
/* harmony export */   "am": function() { return /* binding */ enabled; },
/* harmony export */   "bB": function() { return /* binding */ active; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "h$": function() { return /* binding */ disable; },
/* harmony export */   "pK": function() { return /* binding */ isDisabled; },
/* harmony export */   "wE": function() { return /* binding */ either; },
/* harmony export */   "wp": function() { return /* binding */ enable; },
/* harmony export */   "xb": function() { return /* binding */ isEmpty; },
/* harmony export */   "zh": function() { return /* binding */ isActive; }
/* harmony export */ });
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17316);

/** @internal */
const BIT_MASK = 0xff;
/** @internal */
const BIT_SHIFT = 0x08;
/** @internal */
const active = patch => patch & BIT_MASK;
/** @internal */
const enabled = patch => patch >> BIT_SHIFT & BIT_MASK;
/** @internal */
const make = (active, enabled) => (active & BIT_MASK) + ((enabled & active & BIT_MASK) << BIT_SHIFT);
/** @internal */
const empty = /*#__PURE__*/make(0, 0);
/** @internal */
const enable = flag => make(flag, flag);
/** @internal */
const disable = flag => make(flag, 0);
/** @internal */
const isEmpty = patch => patch === 0;
/** @internal */
const isActive = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, flag) => (active(self) & flag) !== 0);
/** @internal */
const isEnabled = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, flag) => (enabled(self) & flag) !== 0);
/** @internal */
const isDisabled = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, flag) => (active(self) & flag) !== 0 && (enabled(self) & flag) === 0);
/** @internal */
const exclude = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, flag) => make(active(self) & ~flag, enabled(self)));
/** @internal */
const both = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, that) => make(active(self) | active(that), enabled(self) & enabled(that)));
/** @internal */
const either = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, that) => make(active(self) | active(that), enabled(self) | enabled(that)));
/** @internal */
const andThen = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .dual */ .OB)(2, (self, that) => self | that);
/** @internal */
const inverse = patch => make(enabled(patch), invert(active(patch)));
/** @internal */
const invert = n => ~n >>> 0 & BIT_MASK;
//# sourceMappingURL=runtimeFlagsPatch.js.map

/***/ }),

/***/ 97200:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gt": function() { return /* binding */ retryOrElse_Effect; },
/* harmony export */   "H": function() { return /* binding */ retry_combined; },
/* harmony export */   "fh": function() { return /* binding */ schedule_Effect; },
/* harmony export */   "kq": function() { return /* binding */ repeat_combined; },
/* harmony export */   "rl": function() { return /* binding */ repeatOrElse_Effect; },
/* harmony export */   "zW": function() { return /* binding */ scheduleFrom_Effect; }
/* harmony export */ });
/* unused harmony exports ScheduleTypeId, isSchedule, ScheduleDriverTypeId, makeWithState, addDelay, addDelayEffect, andThen, andThenEither, as, asVoid, bothInOut, check, checkEffect, collectAllInputs, collectAllOutputs, collectUntil, collectUntilEffect, collectWhile, collectWhileEffect, compose, mapInput, mapInputContext, mapInputEffect, cron, dayOfMonth, dayOfWeek, delayed, delayedEffect, delayedSchedule, delays, mapBoth, mapBothEffect, driver, duration, either, eitherWith, ensuring, exponential, fibonacci, fixed, fromDelay, fromDelays, fromFunction, hourOfDay, identity, intersect, intersectWith, jittered, jitteredWith, linear, map, mapEffect, minuteOfHour, modifyDelay, modifyDelayEffect, onDecision, passthrough, provideContext, provideService, recurUntil, recurUntilEffect, recurUntilOption, recurUpTo, recurWhile, recurWhileEffect, recurs, reduce, reduceEffect, repeatForever, repetitions, resetAfter, resetWhen, run, secondOfMinute, spaced, succeed, sync, tapInput, tapOutput, unfold, union, unionWith, untilInput, untilInputEffect, untilOutput, untilOutputEffect, upTo, whileInput, whileInputEffect, whileOutput, whileOutputEffect, windowed, zipLeft, zipRight, zipWith, beginningOfSecond, endOfSecond, nextSecond, beginningOfMinute, endOfMinute, nextMinute, beginningOfHour, endOfHour, nextHour, beginningOfDay, endOfDay, nextDay, nextDayOfMonth, findNextMonth, repeat_Effect, retry_Effect, count, elapsed, forever, once, stop */
/* harmony import */ var _Clock_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9605);
/* harmony import */ var _Duration_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13571);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17316);
/* harmony import */ var _Option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16749);
/* harmony import */ var _Pipeable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92817);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71335);
/* harmony import */ var _ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82429);
/* harmony import */ var _ScheduleInterval_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51286);
/* harmony import */ var _ScheduleIntervals_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75313);
/* harmony import */ var _cause_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69579);
/* harmony import */ var _core_effect_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53623);
/* harmony import */ var _core_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39355);
/* harmony import */ var _ref_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7411);



















/** @internal */
const ScheduleSymbolKey = "effect/Schedule";
/** @internal */
const ScheduleTypeId = /*#__PURE__*/Symbol.for(ScheduleSymbolKey);
/** @internal */
const isSchedule = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .hasProperty */ .l$)(u, ScheduleTypeId);
/** @internal */
const ScheduleDriverSymbolKey = "effect/ScheduleDriver";
/** @internal */
const ScheduleDriverTypeId = /*#__PURE__*/Symbol.for(ScheduleDriverSymbolKey);
const scheduleVariance = {
  /* c8 ignore next */
  _Out: _ => _,
  /* c8 ignore next */
  _In: _ => _,
  /* c8 ignore next */
  _R: _ => _
};
const scheduleDriverVariance = {
  /* c8 ignore next */
  _Out: _ => _,
  /* c8 ignore next */
  _In: _ => _,
  /* c8 ignore next */
  _R: _ => _
};
/** @internal */
class ScheduleImpl {
  initial;
  step;
  [ScheduleTypeId] = scheduleVariance;
  constructor(initial, step) {
    this.initial = initial;
    this.step = step;
  }
  pipe() {
    return (0,_Pipeable_js__WEBPACK_IMPORTED_MODULE_1__/* .pipeArguments */ .n)(this, arguments);
  }
}
/** @internal */
class ScheduleDriverImpl {
  schedule;
  ref;
  [ScheduleDriverTypeId] = scheduleDriverVariance;
  constructor(schedule, ref) {
    this.schedule = schedule;
    this.ref = ref;
  }
  get state() {
    return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UID(_ref_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(this.ref), tuple => tuple[1]);
  }
  get last() {
    return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(_ref_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(this.ref), ([element, _]) => {
      switch (element._tag) {
        case "None":
          {
            return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .failSync */ .zph(() => new _core_js__WEBPACK_IMPORTED_MODULE_2__/* .NoSuchElementException */ .buj());
          }
        case "Some":
          {
            return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .succeed */ .ng0(element.value);
          }
      }
    });
  }
  get reset() {
    return _ref_js__WEBPACK_IMPORTED_MODULE_3__/* .set */ .t8(this.ref, [_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .none */ .YP(), this.schedule.initial]);
  }
  next(input) {
    return (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(_core_js__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UID(_ref_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(this.ref), tuple => tuple[1]), _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(state => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(_Clock_js__WEBPACK_IMPORTED_MODULE_6__/* .currentTimeMillis */ .b4, _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(now => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(_core_js__WEBPACK_IMPORTED_MODULE_2__/* .suspend */ .RqG(() => this.schedule.step(now, input, state)), _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(([state, out, decision]) => {
      const setState = _ref_js__WEBPACK_IMPORTED_MODULE_3__/* .set */ .t8(this.ref, [_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .some */ .G(out), state]);
      if (_ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__/* .isDone */ ._b(decision)) {
        return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .zipRight */ .qs5(setState, _core_js__WEBPACK_IMPORTED_MODULE_2__/* .fail */ .bGj(_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .none */ .YP()));
      }
      const millis = _ScheduleIntervals_js__WEBPACK_IMPORTED_MODULE_8__/* .start */ .BL(decision.intervals) - now;
      if (millis <= 0) {
        return _core_js__WEBPACK_IMPORTED_MODULE_2__.as(setState, out);
      }
      return (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(setState, _core_js__WEBPACK_IMPORTED_MODULE_2__/* .zipRight */ .qs5(_core_effect_js__WEBPACK_IMPORTED_MODULE_9__/* .sleep */ ._v(_Duration_js__WEBPACK_IMPORTED_MODULE_10__/* .millis */ .YX(millis))), _core_js__WEBPACK_IMPORTED_MODULE_2__.as(out));
    }))))));
  }
}
/** @internal */
const makeWithState = (initial, step) => new ScheduleImpl(initial, step);
/** @internal */
const addDelay = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => addDelayEffect(self, out => core.sync(() => f(out))))));
/** @internal */
const addDelayEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => modifyDelayEffect(self, (out, duration) => core.map(f(out), delay => Duration.sum(duration, Duration.decode(delay)))))));
/** @internal */
const andThen = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => map(andThenEither(self, that), Either.merge))));
/** @internal */
const andThenEither = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => makeWithState([self.initial, that.initial, true], (now, input, state) => state[2] ? core.flatMap(self.step(now, input, state[0]), ([lState, out, decision]) => {
  if (ScheduleDecision.isDone(decision)) {
    return core.map(that.step(now, input, state[1]), ([rState, out, decision]) => [[lState, rState, false], Either.right(out), decision]);
  }
  return core.succeed([[lState, state[1], true], Either.left(out), decision]);
}) : core.map(that.step(now, input, state[1]), ([rState, out, decision]) => [[state[0], rState, false], Either.right(out), decision])))));
/** @internal */
const as = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, out) => map(self, () => out))));
/** @internal */
const asVoid = self => map(self, constVoid);
/** @internal */
const bothInOut = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => makeWithState([self.initial, that.initial], (now, [in1, in2], state) => core.zipWith(self.step(now, in1, state[0]), that.step(now, in2, state[1]), ([lState, out, lDecision], [rState, out2, rDecision]) => {
  if (ScheduleDecision.isContinue(lDecision) && ScheduleDecision.isContinue(rDecision)) {
    const interval = pipe(lDecision.intervals, Intervals.union(rDecision.intervals));
    return [[lState, rState], [out, out2], ScheduleDecision.continue(interval)];
  }
  return [[lState, rState], [out, out2], ScheduleDecision.done];
})))));
/** @internal */
const check = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, test) => checkEffect(self, (input, out) => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .sync */ .Z_X(() => test(input, out))));
/** @internal */
const checkEffect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, test) => makeWithState(self.initial, (now, input, state) => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(self.step(now, input, state), ([state, out, decision]) => {
  if (_ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__/* .isDone */ ._b(decision)) {
    return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .succeed */ .ng0([state, out, _ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__/* .done */ .aT]);
  }
  return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UID(test(input, out), cont => cont ? [state, out, decision] : [state, out, _ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__/* .done */ .aT]);
})));
/** @internal */
const collectAllInputs = () => collectAllOutputs(identity());
/** @internal */
const collectAllOutputs = self => reduce(self, Chunk.empty(), (outs, out) => pipe(outs, Chunk.append(out)));
/** @internal */
const collectUntil = f => collectAllOutputs(recurUntil(f));
/** @internal */
const collectUntilEffect = f => collectAllOutputs(recurUntilEffect(f));
/** @internal */
const collectWhile = f => collectAllOutputs(recurWhile(f));
/** @internal */
const collectWhileEffect = f => collectAllOutputs(recurWhileEffect(f));
/** @internal */
const compose = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => makeWithState([self.initial, that.initial], (now, input, state) => core.flatMap(self.step(now, input, state[0]), ([lState, out, lDecision]) => core.map(that.step(now, out, state[1]), ([rState, out2, rDecision]) => ScheduleDecision.isDone(lDecision) ? [[lState, rState], out2, ScheduleDecision.done] : ScheduleDecision.isDone(rDecision) ? [[lState, rState], out2, ScheduleDecision.done] : [[lState, rState], out2, ScheduleDecision.continue(pipe(lDecision.intervals, Intervals.max(rDecision.intervals)))]))))));
/** @internal */
const mapInput = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => mapInputEffect(self, input2 => core.sync(() => f(input2))))));
/** @internal */
const mapInputContext = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => makeWithState(self.initial, (now, input, state) => core.mapInputContext(self.step(now, input, state), f)))));
/** @internal */
const mapInputEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => makeWithState(self.initial, (now, input2, state) => core.flatMap(f(input2), input => self.step(now, input, state))))));
/** @internal */
const cron = (expression, tz) => {
  const parsed = Cron.isCron(expression) ? Either.right(expression) : Cron.parse(expression, tz);
  return makeWithState([true, [Number.MIN_SAFE_INTEGER, 0, 0]], (now, _, [initial, previous]) => {
    if (now < previous[0]) {
      return core.succeed([[false, previous], [previous[1], previous[2]], ScheduleDecision.continueWith(Interval.make(previous[1], previous[2]))]);
    }
    if (Either.isLeft(parsed)) {
      return core.die(parsed.left);
    }
    const cron = parsed.right;
    const date = new Date(now);
    let next;
    if (initial && Cron.match(cron, date)) {
      next = now;
    }
    next = Cron.next(cron, date).getTime();
    const start = beginningOfSecond(next);
    const end = endOfSecond(next);
    return core.succeed([[false, [next, start, end]], [start, end], ScheduleDecision.continueWith(Interval.make(start, end))]);
  });
};
/** @internal */
const dayOfMonth = day => {
  return makeWithState([Number.NEGATIVE_INFINITY, 0], (now, _, state) => {
    if (!Number.isInteger(day) || day < 1 || 31 < day) {
      return core.dieSync(() => new core.IllegalArgumentException(`Invalid argument in: dayOfMonth(${day}). Must be in range 1...31`));
    }
    const n = state[1];
    const initial = n === 0;
    const day0 = nextDayOfMonth(now, day, initial);
    const start = beginningOfDay(day0);
    const end = endOfDay(day0);
    const interval = Interval.make(start, end);
    return core.succeed([[end, n + 1], n, ScheduleDecision.continueWith(interval)]);
  });
};
/** @internal */
const dayOfWeek = day => {
  return makeWithState([Number.MIN_SAFE_INTEGER, 0], (now, _, state) => {
    if (!Number.isInteger(day) || day < 1 || 7 < day) {
      return core.dieSync(() => new core.IllegalArgumentException(`Invalid argument in: dayOfWeek(${day}). Must be in range 1 (Monday)...7 (Sunday)`));
    }
    const n = state[1];
    const initial = n === 0;
    const day0 = nextDay(now, day, initial);
    const start = beginningOfDay(day0);
    const end = endOfDay(day0);
    const interval = Interval.make(start, end);
    return core.succeed([[end, n + 1], n, ScheduleDecision.continueWith(interval)]);
  });
};
/** @internal */
const delayed = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => delayedEffect(self, duration => core.sync(() => f(duration))))));
/** @internal */
const delayedEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => modifyDelayEffect(self, (_, delay) => f(delay)))));
/** @internal */
const delayedSchedule = schedule => addDelay(schedule, x => x);
/** @internal */
const delays = self => makeWithState(self.initial, (now, input, state) => pipe(self.step(now, input, state), core.flatMap(([state, _, decision]) => {
  if (ScheduleDecision.isDone(decision)) {
    return core.succeed([state, Duration.zero, decision]);
  }
  return core.succeed([state, Duration.millis(Intervals.start(decision.intervals) - now), decision]);
})));
/** @internal */
const mapBoth = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, {
  onInput,
  onOutput
}) => map(mapInput(self, onInput), onOutput))));
/** @internal */
const mapBothEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, {
  onInput,
  onOutput
}) => mapEffect(mapInputEffect(self, onInput), onOutput))));
/** @internal */
const driver = self => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(_ref_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .Sy([_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .none */ .YP(), self.initial]), _core_js__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UID(ref => new ScheduleDriverImpl(self, ref)));
/** @internal */
const duration = durationInput => {
  const duration = Duration.decode(durationInput);
  const durationMillis = Duration.toMillis(duration);
  return makeWithState(true, (now, _, state) => core.succeed(state ? [false, duration, ScheduleDecision.continueWith(Interval.after(now + durationMillis))] : [false, Duration.zero, ScheduleDecision.done]));
};
/** @internal */
const either = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => union(self, that))));
/** @internal */
const eitherWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, that, f) => unionWith(self, that, f))));
/** @internal */
const ensuring = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, finalizer) => makeWithState(self.initial, (now, input, state) => core.flatMap(self.step(now, input, state), ([state, out, decision]) => ScheduleDecision.isDone(decision) ? core.as(finalizer, [state, out, decision]) : core.succeed([state, out, decision]))))));
/** @internal */
const exponential = (baseInput, factor = 2.0) => {
  const base = Duration.decode(baseInput);
  return delayedSchedule(map(forever, i => Duration.times(base, Math.pow(factor, i))));
};
/** @internal */
const fibonacci = oneInput => {
  const one = Duration.decode(oneInput);
  return delayedSchedule(pipe(unfold([one, one], ([a, b]) => [b, Duration.sum(a, b)]), map(out => out[0])));
};
/** @internal */
const fixed = intervalInput => {
  const interval = Duration.decode(intervalInput);
  const intervalMillis = Duration.toMillis(interval);
  return makeWithState([Option.none(), 0], (now, _, [option, n]) => core.sync(() => {
    switch (option._tag) {
      case "None":
        {
          return [[Option.some([now, now + intervalMillis]), n + 1], n, ScheduleDecision.continueWith(Interval.after(now + intervalMillis))];
        }
      case "Some":
        {
          const [startMillis, lastRun] = option.value;
          const runningBehind = now > lastRun + intervalMillis;
          const boundary = Equal.equals(interval, Duration.zero) ? interval : Duration.millis(intervalMillis - (now - startMillis) % intervalMillis);
          const sleepTime = Equal.equals(boundary, Duration.zero) ? interval : boundary;
          const nextRun = runningBehind ? now : now + Duration.toMillis(sleepTime);
          return [[Option.some([startMillis, nextRun]), n + 1], n, ScheduleDecision.continueWith(Interval.after(nextRun))];
        }
    }
  }));
};
/** @internal */
const fromDelay = delay => duration(delay);
/** @internal */
const fromDelays = (delay, ...delays) => makeWithState([[delay, ...delays].map(_ => Duration.decode(_)), true], (now, _, [durations, cont]) => core.sync(() => {
  if (cont) {
    const x = durations[0];
    const interval = Interval.after(now + Duration.toMillis(x));
    if (durations.length >= 2) {
      return [[durations.slice(1), true], x, ScheduleDecision.continueWith(interval)];
    }
    const y = durations.slice(1);
    return [[[x, ...y], false], x, ScheduleDecision.continueWith(interval)];
  }
  return [[durations, false], Duration.zero, ScheduleDecision.done];
}));
/** @internal */
const fromFunction = f => map(identity(), f);
/** @internal */
const hourOfDay = hour => makeWithState([Number.NEGATIVE_INFINITY, 0], (now, _, state) => {
  if (!Number.isInteger(hour) || hour < 0 || 23 < hour) {
    return core.dieSync(() => new core.IllegalArgumentException(`Invalid argument in: hourOfDay(${hour}). Must be in range 0...23`));
  }
  const n = state[1];
  const initial = n === 0;
  const hour0 = nextHour(now, hour, initial);
  const start = beginningOfHour(hour0);
  const end = endOfHour(hour0);
  const interval = Interval.make(start, end);
  return core.succeed([[end, n + 1], n, ScheduleDecision.continueWith(interval)]);
});
/** @internal */
const identity = () => makeWithState(void 0, (now, input, state) => core.succeed([state, input, ScheduleDecision.continueWith(Interval.after(now))]));
/** @internal */
const intersect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, that) => intersectWith(self, that, _ScheduleIntervals_js__WEBPACK_IMPORTED_MODULE_8__/* .intersect */ .wf));
/** @internal */
const intersectWith = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(3, (self, that, f) => makeWithState([self.initial, that.initial], (now, input, state) => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(_core_js__WEBPACK_IMPORTED_MODULE_2__/* .zipWith */ .yL_(self.step(now, input, state[0]), that.step(now, input, state[1]), (a, b) => [a, b]), _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(([[lState, out, lDecision], [rState, out2, rDecision]]) => {
  if (_ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__/* .isContinue */ .Jg(lDecision) && _ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__/* .isContinue */ .Jg(rDecision)) {
    return intersectWithLoop(self, that, input, lState, out, lDecision.intervals, rState, out2, rDecision.intervals, f);
  }
  return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .succeed */ .ng0([[lState, rState], [out, out2], _ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__/* .done */ .aT]);
}))));
/** @internal */
const intersectWithLoop = (self, that, input, lState, out, lInterval, rState, out2, rInterval, f) => {
  const combined = f(lInterval, rInterval);
  if (_ScheduleIntervals_js__WEBPACK_IMPORTED_MODULE_8__/* .isNonEmpty */ .Od(combined)) {
    return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .succeed */ .ng0([[lState, rState], [out, out2], _ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__/* ["continue"] */ .Jx(combined)]);
  }
  if ((0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(lInterval, _ScheduleIntervals_js__WEBPACK_IMPORTED_MODULE_8__/* .lessThan */ .Qj(rInterval))) {
    return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(self.step(_ScheduleIntervals_js__WEBPACK_IMPORTED_MODULE_8__/* .end */ .ut(lInterval), input, lState), ([lState, out, decision]) => {
      if (_ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__/* .isDone */ ._b(decision)) {
        return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .succeed */ .ng0([[lState, rState], [out, out2], _ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__/* .done */ .aT]);
      }
      return intersectWithLoop(self, that, input, lState, out, decision.intervals, rState, out2, rInterval, f);
    });
  }
  return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(that.step(_ScheduleIntervals_js__WEBPACK_IMPORTED_MODULE_8__/* .end */ .ut(rInterval), input, rState), ([rState, out2, decision]) => {
    if (_ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__/* .isDone */ ._b(decision)) {
      return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .succeed */ .ng0([[lState, rState], [out, out2], _ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__/* .done */ .aT]);
    }
    return intersectWithLoop(self, that, input, lState, out, lInterval, rState, out2, decision.intervals, f);
  });
};
/** @internal */
const jittered = self => jitteredWith(self, {
  min: 0.8,
  max: 1.2
});
/** @internal */
const jitteredWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, options) => {
  const {
    max,
    min
  } = Object.assign({
    min: 0.8,
    max: 1.2
  }, options);
  return delayedEffect(self, duration => core.map(Random.next, random => {
    const d = Duration.toMillis(duration);
    const jittered = d * min * (1 - random) + d * max * random;
    return Duration.millis(jittered);
  }));
})));
/** @internal */
const linear = baseInput => {
  const base = Duration.decode(baseInput);
  return delayedSchedule(map(forever, i => Duration.times(base, i + 1)));
};
/** @internal */
const map = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, f) => mapEffect(self, out => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .sync */ .Z_X(() => f(out))));
/** @internal */
const mapEffect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, f) => makeWithState(self.initial, (now, input, state) => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(self.step(now, input, state), ([state, out, decision]) => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UID(f(out), out2 => [state, out2, decision]))));
/** @internal */
const minuteOfHour = minute => makeWithState([Number.MIN_SAFE_INTEGER, 0], (now, _, state) => {
  if (!Number.isInteger(minute) || minute < 0 || 59 < minute) {
    return core.dieSync(() => new core.IllegalArgumentException(`Invalid argument in: minuteOfHour(${minute}). Must be in range 0...59`));
  }
  const n = state[1];
  const initial = n === 0;
  const minute0 = nextMinute(now, minute, initial);
  const start = beginningOfMinute(minute0);
  const end = endOfMinute(minute0);
  const interval = Interval.make(start, end);
  return core.succeed([[end, n + 1], n, ScheduleDecision.continueWith(interval)]);
});
/** @internal */
const modifyDelay = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => modifyDelayEffect(self, (out, duration) => core.sync(() => f(out, duration))))));
/** @internal */
const modifyDelayEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => makeWithState(self.initial, (now, input, state) => core.flatMap(self.step(now, input, state), ([state, out, decision]) => {
  if (ScheduleDecision.isDone(decision)) {
    return core.succeed([state, out, decision]);
  }
  const intervals = decision.intervals;
  const delay = Interval.size(Interval.make(now, Intervals.start(intervals)));
  return core.map(f(out, delay), durationInput => {
    const duration = Duration.decode(durationInput);
    const oldStart = Intervals.start(intervals);
    const newStart = now + Duration.toMillis(duration);
    const delta = newStart - oldStart;
    const newEnd = Math.max(0, Intervals.end(intervals) + delta);
    const newInterval = Interval.make(newStart, newEnd);
    return [state, out, ScheduleDecision.continueWith(newInterval)];
  });
})))));
/** @internal */
const onDecision = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => makeWithState(self.initial, (now, input, state) => core.flatMap(self.step(now, input, state), ([state, out, decision]) => core.as(f(out, decision), [state, out, decision]))))));
/** @internal */
const passthrough = self => makeWithState(self.initial, (now, input, state) => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(self.step(now, input, state), _core_js__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UID(([state, _, decision]) => [state, input, decision])));
/** @internal */
const provideContext = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, context) => makeWithState(self.initial, (now, input, state) => core.provideContext(self.step(now, input, state), context)))));
/** @internal */
const provideService = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, tag, service) => makeWithState(self.initial, (now, input, state) => core.contextWithEffect(env => core.provideContext(
// @ts-expect-error
self.step(now, input, state), Context.add(env, tag, service)))))));
/** @internal */
const recurUntil = f => untilInput(identity(), f);
/** @internal */
const recurUntilEffect = f => untilInputEffect(identity(), f);
/** @internal */
const recurUntilOption = pf => untilOutput(map(identity(), pf), Option.isSome);
/** @internal */
const recurUpTo = durationInput => {
  const duration = Duration.decode(durationInput);
  return whileOutput(elapsed, elapsed => Duration.lessThan(elapsed, duration));
};
/** @internal */
const recurWhile = f => whileInput(identity(), f);
/** @internal */
const recurWhileEffect = f => whileInputEffect(identity(), f);
/** @internal */
const recurs = n => whileOutput(forever, out => out < n);
/** @internal */
const reduce = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, zero, f) => reduceEffect(self, zero, (z, out) => core.sync(() => f(z, out))))));
/** @internal */
const reduceEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, zero, f) => makeWithState([self.initial, zero], (now, input, [s, z]) => core.flatMap(self.step(now, input, s), ([s, out, decision]) => ScheduleDecision.isDone(decision) ? core.succeed([[s, z], z, decision]) : core.map(f(z, out), z2 => [[s, z2], z, decision]))))));
/** @internal */
const repeatForever = self => makeWithState(self.initial, (now, input, state) => {
  const step = (now, input, state) => core.flatMap(self.step(now, input, state), ([state, out, decision]) => ScheduleDecision.isDone(decision) ? step(now, input, self.initial) : core.succeed([state, out, decision]));
  return step(now, input, state);
});
/** @internal */
const repetitions = self => reduce(self, 0, (n, _) => n + 1);
/** @internal */
const resetAfter = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, durationInput) => {
  const duration = Duration.decode(durationInput);
  return pipe(self, intersect(elapsed), resetWhen(([, time]) => Duration.greaterThanOrEqualTo(time, duration)), map(out => out[0]));
})));
/** @internal */
const resetWhen = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => makeWithState(self.initial, (now, input, state) => core.flatMap(self.step(now, input, state), ([state, out, decision]) => f(out) ? self.step(now, input, self.initial) : core.succeed([state, out, decision]))))));
/** @internal */
const run = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, now, input) => pipe(runLoop(self, now, Chunk.fromIterable(input), self.initial, Chunk.empty()), core.map(list => Chunk.reverse(list))))));
/** @internal */
const runLoop = (self, now, inputs, state, acc) => {
  if (!Chunk.isNonEmpty(inputs)) {
    return core.succeed(acc);
  }
  const input = Chunk.headNonEmpty(inputs);
  const nextInputs = Chunk.tailNonEmpty(inputs);
  return core.flatMap(self.step(now, input, state), ([state, out, decision]) => {
    if (ScheduleDecision.isDone(decision)) {
      return core.sync(() => pipe(acc, Chunk.prepend(out)));
    }
    return runLoop(self, Intervals.start(decision.intervals), nextInputs, state, Chunk.prepend(acc, out));
  });
};
/** @internal */
const secondOfMinute = second => makeWithState([Number.NEGATIVE_INFINITY, 0], (now, _, state) => {
  if (!Number.isInteger(second) || second < 0 || 59 < second) {
    return core.dieSync(() => new core.IllegalArgumentException(`Invalid argument in: secondOfMinute(${second}). Must be in range 0...59`));
  }
  const n = state[1];
  const initial = n === 0;
  const second0 = nextSecond(now, second, initial);
  const start = beginningOfSecond(second0);
  const end = endOfSecond(second0);
  const interval = Interval.make(start, end);
  return core.succeed([[end, n + 1], n, ScheduleDecision.continueWith(interval)]);
});
/** @internal */
const spaced = duration => addDelay(forever, () => duration);
/** @internal */
const succeed = value => map(forever, () => value);
/** @internal */
const sync = evaluate => map(forever, evaluate);
/** @internal */
const tapInput = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => makeWithState(self.initial, (now, input, state) => core.zipRight(f(input), self.step(now, input, state))))));
/** @internal */
const tapOutput = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => makeWithState(self.initial, (now, input, state) => core.tap(self.step(now, input, state), ([, out]) => f(out))))));
/** @internal */
const unfold = (initial, f) => makeWithState(initial, (now, _, state) => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .sync */ .Z_X(() => [f(state), state, _ScheduleDecision_js__WEBPACK_IMPORTED_MODULE_7__/* .continueWith */ .y3(_ScheduleInterval_js__WEBPACK_IMPORTED_MODULE_11__/* .after */ .e4(now))]));
/** @internal */
const union = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => unionWith(self, that, Intervals.union))));
/** @internal */
const unionWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, that, f) => makeWithState([self.initial, that.initial], (now, input, state) => core.zipWith(self.step(now, input, state[0]), that.step(now, input, state[1]), ([lState, l, lDecision], [rState, r, rDecision]) => {
  if (ScheduleDecision.isDone(lDecision) && ScheduleDecision.isDone(rDecision)) {
    return [[lState, rState], [l, r], ScheduleDecision.done];
  }
  if (ScheduleDecision.isDone(lDecision) && ScheduleDecision.isContinue(rDecision)) {
    return [[lState, rState], [l, r], ScheduleDecision.continue(rDecision.intervals)];
  }
  if (ScheduleDecision.isContinue(lDecision) && ScheduleDecision.isDone(rDecision)) {
    return [[lState, rState], [l, r], ScheduleDecision.continue(lDecision.intervals)];
  }
  if (ScheduleDecision.isContinue(lDecision) && ScheduleDecision.isContinue(rDecision)) {
    const combined = f(lDecision.intervals, rDecision.intervals);
    return [[lState, rState], [l, r], ScheduleDecision.continue(combined)];
  }
  throw new Error("BUG: Schedule.unionWith - please report an issue at https://github.com/Effect-TS/effect/issues");
})))));
/** @internal */
const untilInput = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => check(self, (input, _) => !f(input)))));
/** @internal */
const untilInputEffect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, f) => checkEffect(self, (input, _) => _core_effect_js__WEBPACK_IMPORTED_MODULE_9__/* .negate */ .tk(f(input))));
/** @internal */
const untilOutput = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => check(self, (_, out) => !f(out)))));
/** @internal */
const untilOutputEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => checkEffect(self, (_, out) => effect.negate(f(out))))));
/** @internal */
const upTo = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, duration) => zipLeft(self, recurUpTo(duration)))));
/** @internal */
const whileInput = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => check(self, (input, _) => f(input)))));
/** @internal */
const whileInputEffect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, f) => checkEffect(self, (input, _) => f(input)));
/** @internal */
const whileOutput = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, f) => check(self, (_, out) => f(out)));
/** @internal */
const whileOutputEffect = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, f) => checkEffect(self, (_, out) => f(out)))));
/** @internal */
const windowed = intervalInput => {
  const interval = Duration.decode(intervalInput);
  const millis = Duration.toMillis(interval);
  return makeWithState([Option.none(), 0], (now, _, [option, n]) => {
    switch (option._tag) {
      case "None":
        {
          return core.succeed([[Option.some(now), n + 1], n, ScheduleDecision.continueWith(Interval.after(now + millis))]);
        }
      case "Some":
        {
          return core.succeed([[Option.some(option.value), n + 1], n, ScheduleDecision.continueWith(Interval.after(now + (millis - (now - option.value) % millis)))]);
        }
    }
  });
};
/** @internal */
const zipLeft = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => map(intersect(self, that), out => out[0]))));
/** @internal */
const zipRight = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(2, (self, that) => map(intersect(self, that), out => out[1]))));
/** @internal */
const zipWith = /*#__PURE__*/(/* unused pure expression or super */ null && (dual(3, (self, that, f) => map(intersect(self, that), ([out, out2]) => f(out, out2)))));
// -----------------------------------------------------------------------------
// Seconds
// -----------------------------------------------------------------------------
/** @internal */
const beginningOfSecond = now => {
  const date = new Date(now);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), 0).getTime();
};
/** @internal */
const endOfSecond = now => {
  const date = new Date(beginningOfSecond(now));
  return date.setSeconds(date.getSeconds() + 1);
};
/** @internal */
const nextSecond = (now, second, initial) => {
  const date = new Date(now);
  if (date.getSeconds() === second && initial) {
    return now;
  }
  if (date.getSeconds() < second) {
    return date.setSeconds(second);
  }
  // Set seconds to the provided value and add one minute
  const newDate = new Date(date.setSeconds(second));
  return newDate.setTime(newDate.getTime() + 1000 * 60);
};
// -----------------------------------------------------------------------------
// Minutes
// -----------------------------------------------------------------------------
/** @internal */
const beginningOfMinute = now => {
  const date = new Date(now);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), 0, 0).getTime();
};
/** @internal */
const endOfMinute = now => {
  const date = new Date(beginningOfMinute(now));
  return date.setMinutes(date.getMinutes() + 1);
};
/** @internal */
const nextMinute = (now, minute, initial) => {
  const date = new Date(now);
  if (date.getMinutes() === minute && initial) {
    return now;
  }
  if (date.getMinutes() < minute) {
    return date.setMinutes(minute);
  }
  // Set minutes to the provided value and add one hour
  const newDate = new Date(date.setMinutes(minute));
  return newDate.setTime(newDate.getTime() + 1000 * 60 * 60);
};
// -----------------------------------------------------------------------------
// Hours
// -----------------------------------------------------------------------------
/** @internal */
const beginningOfHour = now => {
  const date = new Date(now);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 0, 0, 0).getTime();
};
/** @internal */
const endOfHour = now => {
  const date = new Date(beginningOfHour(now));
  return date.setHours(date.getHours() + 1);
};
/** @internal */
const nextHour = (now, hour, initial) => {
  const date = new Date(now);
  if (date.getHours() === hour && initial) {
    return now;
  }
  if (date.getHours() < hour) {
    return date.setHours(hour);
  }
  // Set hours to the provided value and add one day
  const newDate = new Date(date.setHours(hour));
  return newDate.setTime(newDate.getTime() + 1000 * 60 * 60 * 24);
};
// -----------------------------------------------------------------------------
// Days
// -----------------------------------------------------------------------------
/** @internal */
const beginningOfDay = now => {
  const date = new Date(now);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0).getTime();
};
/** @internal */
const endOfDay = now => {
  const date = new Date(beginningOfDay(now));
  return date.setDate(date.getDate() + 1);
};
/** @internal */
const nextDay = (now, dayOfWeek, initial) => {
  const date = new Date(now);
  if (date.getDay() === dayOfWeek && initial) {
    return now;
  }
  const nextDayOfWeek = (7 + dayOfWeek - date.getDay()) % 7;
  return date.setDate(date.getDate() + (nextDayOfWeek === 0 ? 7 : nextDayOfWeek));
};
/** @internal */
const nextDayOfMonth = (now, day, initial) => {
  const date = new Date(now);
  if (date.getDate() === day && initial) {
    return now;
  }
  if (date.getDate() < day) {
    return date.setDate(day);
  }
  return findNextMonth(now, day, 1);
};
/** @internal */
const findNextMonth = (now, day, months) => {
  const d = new Date(now);
  const tmp1 = new Date(d.setDate(day));
  const tmp2 = new Date(tmp1.setMonth(tmp1.getMonth() + months));
  if (tmp2.getDate() === day) {
    const d2 = new Date(now);
    const tmp3 = new Date(d2.setDate(day));
    return tmp3.setMonth(tmp3.getMonth() + months);
  }
  return findNextMonth(now, day, months + 1);
};
// circular with Effect
const ScheduleDefectTypeId = /*#__PURE__*/Symbol.for("effect/Schedule/ScheduleDefect");
class ScheduleDefect {
  error;
  [ScheduleDefectTypeId];
  constructor(error) {
    this.error = error;
    this[ScheduleDefectTypeId] = ScheduleDefectTypeId;
  }
}
const isScheduleDefect = u => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_0__/* .hasProperty */ .l$)(u, ScheduleDefectTypeId);
const scheduleDefectWrap = self => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .catchAll */ .kmb(self, e => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .die */ .Xre(new ScheduleDefect(e)));
const scheduleDefectRefail = self => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .catchAllCause */ .Npq(self, cause => _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .match */ .EQ(_cause_js__WEBPACK_IMPORTED_MODULE_12__/* .find */ .sE(cause, _ => _cause_js__WEBPACK_IMPORTED_MODULE_12__/* .isDieType */ .QV(_) && isScheduleDefect(_.defect) ? _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .some */ .G(_.defect) : _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .none */ .YP()), {
  onNone: () => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .failCause */ .DhG(cause),
  onSome: error => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .fail */ .bGj(error.error)
}));
/** @internal */
const repeat_Effect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, schedule) => repeatOrElse_Effect(self, schedule, (e, _) => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .fail */ .bGj(e)));
/** @internal */
const repeat_combined = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, options) => {
  if (isSchedule(options)) {
    return repeat_Effect(self, options);
  }
  const base = options.schedule ?? passthrough(forever);
  const withWhile = options.while ? whileInputEffect(base, a => {
    const applied = options.while(a);
    if (typeof applied === "boolean") {
      return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .succeed */ .ng0(applied);
    }
    return scheduleDefectWrap(applied);
  }) : base;
  const withUntil = options.until ? untilInputEffect(withWhile, a => {
    const applied = options.until(a);
    if (typeof applied === "boolean") {
      return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .succeed */ .ng0(applied);
    }
    return scheduleDefectWrap(applied);
  }) : withWhile;
  const withTimes = options.times ? intersect(withUntil, recurs(options.times)).pipe(map(intersectionPair => intersectionPair[0])) : withUntil;
  return scheduleDefectRefail(repeat_Effect(self, withTimes));
});
/** @internal */
const repeatOrElse_Effect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(3, (self, schedule, orElse) => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(driver(schedule), driver => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .matchEffect */ .PwY(self, {
  onFailure: error => orElse(error, _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .none */ .YP()),
  onSuccess: value => repeatOrElseEffectLoop(self, driver, orElse, value)
})));
/** @internal */
const repeatOrElseEffectLoop = (self, driver, orElse, value) => {
  return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .matchEffect */ .PwY(driver.next(value), {
    onFailure: () => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .orDie */ .e3I(driver.last),
    onSuccess: b => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .matchEffect */ .PwY(self, {
      onFailure: error => orElse(error, _Option_js__WEBPACK_IMPORTED_MODULE_4__/* .some */ .G(b)),
      onSuccess: value => repeatOrElseEffectLoop(self, driver, orElse, value)
    })
  });
};
/** @internal */
const retry_Effect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, policy) => retryOrElse_Effect(self, policy, (e, _) => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .fail */ .bGj(e)));
/** @internal */
const retry_combined = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, options) => {
  if (isSchedule(options)) {
    return retry_Effect(self, options);
  }
  const base = options.schedule ?? forever;
  const withWhile = options.while ? whileInputEffect(base, e => {
    const applied = options.while(e);
    if (typeof applied === "boolean") {
      return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .succeed */ .ng0(applied);
    }
    return scheduleDefectWrap(applied);
  }) : base;
  const withUntil = options.until ? untilInputEffect(withWhile, e => {
    const applied = options.until(e);
    if (typeof applied === "boolean") {
      return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .succeed */ .ng0(applied);
    }
    return scheduleDefectWrap(applied);
  }) : withWhile;
  const withTimes = options.times ? intersect(withUntil, recurs(options.times)) : withUntil;
  return scheduleDefectRefail(retry_Effect(self, withTimes));
});
/** @internal */
const retryOrElse_Effect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(3, (self, policy, orElse) => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(driver(policy), driver => retryOrElse_EffectLoop(self, driver, orElse)));
/** @internal */
const retryOrElse_EffectLoop = (self, driver, orElse) => {
  return _core_js__WEBPACK_IMPORTED_MODULE_2__/* .catchAll */ .kmb(self, e => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .matchEffect */ .PwY(driver.next(e), {
    onFailure: () => (0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(driver.last, _core_js__WEBPACK_IMPORTED_MODULE_2__/* .orDie */ .e3I, _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(out => orElse(e, out))),
    onSuccess: () => retryOrElse_EffectLoop(self, driver, orElse)
  }));
};
/** @internal */
const schedule_Effect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(2, (self, schedule) => scheduleFrom_Effect(self, void 0, schedule));
/** @internal */
const scheduleFrom_Effect = /*#__PURE__*/(0,_Function_js__WEBPACK_IMPORTED_MODULE_5__/* .dual */ .OB)(3, (self, initial, schedule) => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(driver(schedule), driver => scheduleFrom_EffectLoop(self, initial, driver)));
/** @internal */
const scheduleFrom_EffectLoop = (self, initial, driver) => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .matchEffect */ .PwY(driver.next(initial), {
  onFailure: () => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .orDie */ .e3I(driver.last),
  onSuccess: () => _core_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VSD(self, a => scheduleFrom_EffectLoop(self, a, driver))
});
/** @internal */
const count = /*#__PURE__*/(/* unused pure expression or super */ null && (unfold(0, n => n + 1)));
/** @internal */
const elapsed = /*#__PURE__*/(/* unused pure expression or super */ null && (makeWithState( /*#__PURE__*/Option.none(), (now, _, state) => {
  switch (state._tag) {
    case "None":
      {
        return core.succeed([Option.some(now), Duration.zero, ScheduleDecision.continueWith(Interval.after(now))]);
      }
    case "Some":
      {
        return core.succeed([Option.some(state.value), Duration.millis(now - state.value), ScheduleDecision.continueWith(Interval.after(now))]);
      }
  }
})));
/** @internal */
const forever = /*#__PURE__*/unfold(0, n => n + 1);
/** @internal */
const once = /*#__PURE__*/(/* unused pure expression or super */ null && (asVoid( /*#__PURE__*/recurs(1))));
/** @internal */
const stop = /*#__PURE__*/(/* unused pure expression or super */ null && (asVoid( /*#__PURE__*/recurs(0))));
//# sourceMappingURL=schedule.js.map

/***/ }),

/***/ 34357:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xc": function() { return /* binding */ isZip; },
/* harmony export */   "YP": function() { return /* binding */ none; },
/* harmony export */   "j": function() { return /* binding */ track; }
/* harmony export */ });
/* unused harmony exports SupervisorTypeId, supervisorVariance, ProxySupervisor, Zip, Track, Const, unsafeTrack, fromEffect, fibersIn */
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17316);
/* harmony import */ var _GlobalValue_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4726);
/* harmony import */ var _Predicate_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71335);
/* harmony import */ var _core_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39355);






/** @internal */
const SupervisorSymbolKey = "effect/Supervisor";
/** @internal */
const SupervisorTypeId = /*#__PURE__*/Symbol.for(SupervisorSymbolKey);
/** @internal */
const supervisorVariance = {
  /* c8 ignore next */
  _T: _ => _
};
/** @internal */
class ProxySupervisor {
  underlying;
  value0;
  [SupervisorTypeId] = supervisorVariance;
  constructor(underlying, value0) {
    this.underlying = underlying;
    this.value0 = value0;
  }
  get value() {
    return this.value0;
  }
  onStart(context, effect, parent, fiber) {
    this.underlying.onStart(context, effect, parent, fiber);
  }
  onEnd(value, fiber) {
    this.underlying.onEnd(value, fiber);
  }
  onEffect(fiber, effect) {
    this.underlying.onEffect(fiber, effect);
  }
  onSuspend(fiber) {
    this.underlying.onSuspend(fiber);
  }
  onResume(fiber) {
    this.underlying.onResume(fiber);
  }
  map(f) {
    return new ProxySupervisor(this, (0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .pipe */ .zG)(this.value, _core_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID(f)));
  }
  zip(right) {
    return new Zip(this, right);
  }
}
/** @internal */
class Zip {
  left;
  right;
  _tag = "Zip";
  [SupervisorTypeId] = supervisorVariance;
  constructor(left, right) {
    this.left = left;
    this.right = right;
  }
  get value() {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .zip */ .$Re(this.left.value, this.right.value);
  }
  onStart(context, effect, parent, fiber) {
    this.left.onStart(context, effect, parent, fiber);
    this.right.onStart(context, effect, parent, fiber);
  }
  onEnd(value, fiber) {
    this.left.onEnd(value, fiber);
    this.right.onEnd(value, fiber);
  }
  onEffect(fiber, effect) {
    this.left.onEffect(fiber, effect);
    this.right.onEffect(fiber, effect);
  }
  onSuspend(fiber) {
    this.left.onSuspend(fiber);
    this.right.onSuspend(fiber);
  }
  onResume(fiber) {
    this.left.onResume(fiber);
    this.right.onResume(fiber);
  }
  map(f) {
    return new ProxySupervisor(this, (0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .pipe */ .zG)(this.value, _core_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID(f)));
  }
  zip(right) {
    return new Zip(this, right);
  }
}
/** @internal */
const isZip = self => (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_2__/* .hasProperty */ .l$)(self, SupervisorTypeId) && (0,_Predicate_js__WEBPACK_IMPORTED_MODULE_2__/* .isTagged */ .Bd)(self, "Zip");
/** @internal */
class Track {
  [SupervisorTypeId] = supervisorVariance;
  fibers = /*#__PURE__*/new Set();
  get value() {
    return _core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(() => Array.from(this.fibers));
  }
  onStart(_context, _effect, _parent, fiber) {
    this.fibers.add(fiber);
  }
  onEnd(_value, fiber) {
    this.fibers.delete(fiber);
  }
  onEffect(_fiber, _effect) {
    //
  }
  onSuspend(_fiber) {
    //
  }
  onResume(_fiber) {
    //
  }
  map(f) {
    return new ProxySupervisor(this, (0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .pipe */ .zG)(this.value, _core_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID(f)));
  }
  zip(right) {
    return new Zip(this, right);
  }
  onRun(execution, _fiber) {
    return execution();
  }
}
/** @internal */
class Const {
  effect;
  [SupervisorTypeId] = supervisorVariance;
  constructor(effect) {
    this.effect = effect;
  }
  get value() {
    return this.effect;
  }
  onStart(_context, _effect, _parent, _fiber) {
    //
  }
  onEnd(_value, _fiber) {
    //
  }
  onEffect(_fiber, _effect) {
    //
  }
  onSuspend(_fiber) {
    //
  }
  onResume(_fiber) {
    //
  }
  map(f) {
    return new ProxySupervisor(this, (0,_Function_js__WEBPACK_IMPORTED_MODULE_0__/* .pipe */ .zG)(this.value, _core_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID(f)));
  }
  zip(right) {
    return new Zip(this, right);
  }
  onRun(execution, _fiber) {
    return execution();
  }
}
class FibersIn {
  ref;
  [SupervisorTypeId] = supervisorVariance;
  constructor(ref) {
    this.ref = ref;
  }
  get value() {
    return core.sync(() => MutableRef.get(this.ref));
  }
  onStart(_context, _effect, _parent, fiber) {
    pipe(this.ref, MutableRef.set(pipe(MutableRef.get(this.ref), SortedSet.add(fiber))));
  }
  onEnd(_value, fiber) {
    pipe(this.ref, MutableRef.set(pipe(MutableRef.get(this.ref), SortedSet.remove(fiber))));
  }
  onEffect(_fiber, _effect) {
    //
  }
  onSuspend(_fiber) {
    //
  }
  onResume(_fiber) {
    //
  }
  map(f) {
    return new ProxySupervisor(this, pipe(this.value, core.map(f)));
  }
  zip(right) {
    return new Zip(this, right);
  }
  onRun(execution, _fiber) {
    return execution();
  }
}
/** @internal */
const unsafeTrack = () => {
  return new Track();
};
/** @internal */
const track = /*#__PURE__*/_core_js__WEBPACK_IMPORTED_MODULE_1__/* .sync */ .Z_X(unsafeTrack);
/** @internal */
const fromEffect = effect => {
  return new Const(effect);
};
/** @internal */
const none = /*#__PURE__*/(0,_GlobalValue_js__WEBPACK_IMPORTED_MODULE_3__/* .globalValue */ .K)("effect/Supervisor/none", () => fromEffect(_core_js__WEBPACK_IMPORTED_MODULE_1__/* ["void"] */ .Hcj));
/** @internal */
const fibersIn = ref => core.sync(() => new FibersIn(ref));
//# sourceMappingURL=supervisor.js.map

/***/ }),

/***/ 10434:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fl": function() { return /* binding */ tracerTag; },
/* harmony export */   "N7": function() { return /* binding */ spanTag; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "W8": function() { return /* binding */ addSpanStackTrace; },
/* harmony export */   "i0": function() { return /* binding */ TracerTypeId; },
/* harmony export */   "jS": function() { return /* binding */ DisablePropagation; },
/* harmony export */   "kH": function() { return /* binding */ externalSpan; },
/* harmony export */   "qY": function() { return /* binding */ nativeTracer; }
/* harmony export */ });
/* unused harmony export NativeSpan */
/* harmony import */ var _Context_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20591);
/* harmony import */ var _Function_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17316);
/**
 * @since 2.0.0
 */


/** @internal */
const TracerTypeId = /*#__PURE__*/Symbol.for("effect/Tracer");
/** @internal */
const make = options => ({
  [TracerTypeId]: TracerTypeId,
  ...options
});
/** @internal */
const tracerTag = /*#__PURE__*/_Context_js__WEBPACK_IMPORTED_MODULE_0__/* .GenericTag */ .hV("effect/Tracer");
/** @internal */
const spanTag = /*#__PURE__*/_Context_js__WEBPACK_IMPORTED_MODULE_0__/* .GenericTag */ .hV("effect/ParentSpan");
const randomHexString = /*#__PURE__*/function () {
  const characters = "abcdef0123456789";
  const charactersLength = characters.length;
  return function (length) {
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };
}();
/** @internal */
class NativeSpan {
  name;
  parent;
  context;
  startTime;
  kind;
  _tag = "Span";
  spanId;
  traceId = "native";
  sampled = true;
  status;
  attributes;
  events = [];
  links;
  constructor(name, parent, context, links, startTime, kind) {
    this.name = name;
    this.parent = parent;
    this.context = context;
    this.startTime = startTime;
    this.kind = kind;
    this.status = {
      _tag: "Started",
      startTime
    };
    this.attributes = new Map();
    this.traceId = parent._tag === "Some" ? parent.value.traceId : randomHexString(32);
    this.spanId = randomHexString(16);
    this.links = Array.from(links);
  }
  end(endTime, exit) {
    this.status = {
      _tag: "Ended",
      endTime,
      exit,
      startTime: this.status.startTime
    };
  }
  attribute(key, value) {
    this.attributes.set(key, value);
  }
  event(name, startTime, attributes) {
    this.events.push([name, startTime, attributes ?? {}]);
  }
  addLinks(links) {
    // eslint-disable-next-line no-restricted-syntax
    this.links.push(...links);
  }
}
/** @internal */
const nativeTracer = /*#__PURE__*/make({
  span: (name, parent, context, links, startTime, kind) => new NativeSpan(name, parent, context, links, startTime, kind),
  context: f => f()
});
/** @internal */
const externalSpan = options => ({
  _tag: "ExternalSpan",
  spanId: options.spanId,
  traceId: options.traceId,
  sampled: options.sampled ?? true,
  context: options.context ?? _Context_js__WEBPACK_IMPORTED_MODULE_0__/* .empty */ .cS()
});
/** @internal */
const addSpanStackTrace = options => {
  if (options?.captureStackTrace === false) {
    return options;
  } else if (options?.captureStackTrace !== undefined && typeof options.captureStackTrace !== "boolean") {
    return options;
  }
  const limit = Error.stackTraceLimit;
  Error.stackTraceLimit = 3;
  const traceError = new Error();
  Error.stackTraceLimit = limit;
  let cache = false;
  return {
    ...options,
    captureStackTrace: () => {
      if (cache !== false) {
        return cache;
      }
      if (traceError.stack !== undefined) {
        const stack = traceError.stack.split("\n");
        if (stack[3] !== undefined) {
          cache = stack[3].trim();
          return cache;
        }
      }
    }
  };
};
/** @internal */
const DisablePropagation = /*#__PURE__*/_Context_js__WEBPACK_IMPORTED_MODULE_0__/* .Reference */ .s3()("effect/Tracer/DisablePropagation", {
  defaultValue: _Function_js__WEBPACK_IMPORTED_MODULE_1__/* .constFalse */ .jv
});
//# sourceMappingURL=tracer.js.map

/***/ }),

/***/ 69500:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ getCurrentVersion; }
/* harmony export */ });
/* unused harmony export setCurrentVersion */
let moduleVersion = "3.14.21";
const getCurrentVersion = () => moduleVersion;
const setCurrentVersion = version => {
  moduleVersion = version;
};
//# sourceMappingURL=version.js.map

/***/ }),

/***/ 27001:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ JOB_MONITOR_INTERVAL_MS; },
/* harmony export */   "$d": function() { return /* binding */ MAX_PRICE_AGE_FOR_USE_MS; },
/* harmony export */   "Ab": function() { return /* binding */ PRICEx1e6_DECIMALS; },
/* harmony export */   "B4": function() { return /* reexport safe */ _images_js__WEBPACK_IMPORTED_MODULE_1__.B4; },
/* harmony export */   "Bp": function() { return /* binding */ TOKEN_ADA_TICKER; },
/* harmony export */   "DN": function() { return /* binding */ TOKEN_ADA_DECIMALS; },
/* harmony export */   "Fi": function() { return /* binding */ TX_PROPAGATION_DELAY_MS; },
/* harmony export */   "It": function() { return /* binding */ isEmulator; },
/* harmony export */   "Jg": function() { return /* binding */ isTestnet; },
/* harmony export */   "OO": function() { return /* reexport safe */ _wallets_js__WEBPACK_IMPORTED_MODULE_0__.O; },
/* harmony export */   "P9": function() { return /* binding */ CONNECT_WALLET_WAIT_FOR_WALLET_ACTIVATION_MS; },
/* harmony export */   "Pe": function() { return /* binding */ LUCID_NETWORK_MAINNET_NAME; },
/* harmony export */   "QR": function() { return /* binding */ TOKEN_ADA_MULTIPLIER; },
/* harmony export */   "Qn": function() { return /* binding */ TRANSACTION_STATUS_CONFIRMED; },
/* harmony export */   "Rm": function() { return /* binding */ LUCID_NETWORK_CUSTOM_NAME; },
/* harmony export */   "SO": function() { return /* binding */ TOKEN_ADA_SYMBOL; },
/* harmony export */   "Tu": function() { return /* binding */ LUCID_NETWORK_PREVIEW_NAME; },
/* harmony export */   "XM": function() { return /* binding */ LUCID_NETWORK_TESTNET_ID; },
/* harmony export */   "Xq": function() { return /* binding */ TRANSACTION_STATUS_FAILED; },
/* harmony export */   "YS": function() { return /* binding */ TX_CHECK_INTERVAL_MS; },
/* harmony export */   "YW": function() { return /* binding */ MAX_PRICE_AGE_FOR_APROXIMATED_USE_MS; },
/* harmony export */   "bs": function() { return /* binding */ TRANSACTION_STATUS_TIMEOUT; },
/* harmony export */   "fo": function() { return /* binding */ API_TRY_AGAIN; },
/* harmony export */   "gK": function() { return /* binding */ ITEMS_PER_PAGE; },
/* harmony export */   "hb": function() { return /* binding */ TX_PREPARING_TIME_MS; },
/* harmony export */   "hp": function() { return /* binding */ SYNC_SERVER_TIME_ALWAYS_MS; },
/* harmony export */   "i5": function() { return /* binding */ ADA_TX_FEE_MARGIN; },
/* harmony export */   "kG": function() { return /* binding */ LUCID_NETWORK_MAINNET_ID; },
/* harmony export */   "mC": function() { return /* binding */ isMainnet; },
/* harmony export */   "n6": function() { return /* binding */ PROYECT_NAME; },
/* harmony export */   "ux": function() { return /* binding */ CONNECT_WALLET_WAIT_FOR_API_WALLETS_MS; },
/* harmony export */   "xH": function() { return /* binding */ CONNECT_WALLET_WAIT_FOR_EXTENSIONS_POOL_WALLETS_MS; }
/* harmony export */ });
/* unused harmony exports LUCID_NETWORK_PREPROD_NAME, LUCID_NETWORK_EMULATOR_NAME_MOCK_NO_EXISTE_EN_LUCID, isPreview, isPreprod, getLUCID_NETWORK_ID, VALID_SESSION_DURATION_MS, VALID_SESSION_DURATION_STR, WALLET_CREATEDBY_ADMIN, WALLET_CREATEDBY_LOGIN, API_TIMEOUT, NAVIGATION_TIMEOUT_MS, VALID_TX_TIME_BEFORE_MS, VALID_TX_TIME_RANGE_MS, MAX_TX_EX_MEM, MAX_TX_EX_STEPS, MAX_TX_SIZE, TX_CONSUMING_TIME_MS, TX_TIMEOUT_MS, TX_SIMULATION_SLEEP_TIME_MS, BLOCKFROST_RETRY_TIME_MS, BLOCKFROST_URL_EPOCHS_LATEST_PARAMETERS, TIMEOUT_PROXY_BLOCKFROST_MS, ADA_THRESHOLD, useOraclePrices, VALID_ORACLE_PRICE_TIME_MS, SAFETY_BRIDGE_PRICE_TIME_MS, MIN_TIME_BETWEEN_REFRESHES_MS, MIN_AGE_BEFORE_REFRESH_MS, ORACLE_COUNT, ORACLE_DIFFERENCE, ORACLE_DESVIATION, JOB_MAX_TIME_WAITING_TO_COMPLETE_MS, JOB_TIME_WAITING_TO_TRY_AGAIN_MS, DB_MAX_POOL_SIZE, DB_SERVERSELECCION_TIMEOUT_MS, DB_SOCKET_TIMEOUT_MS, DB_WRITE_TIMEOUT_MS, DB_LOCK_MAX_TIME_WAITING_TO_COMPLETE_MS, DB_LOCK_TIME_WAITING_TO_TRY_AGAIN_MS, DB_USE_TRANSACTIONS, SYNC_SERVER_TIME_OPTIONAL_MS, TOKEN_DEFAULT_DECIMALS, TOKEN_LOVELACE_TICKER, PRICEx1e6, BPx1e2_DECIMALS, BPx1e3_DECIMALS, TRANSACTION_STATUS_CREATED, TRANSACTION_STATUS_PENDING, TRANSACTION_STATUS_CANCELED, TRANSACTION_STATUS_PENDING_TIMEOUT, TRANSACTION_STATUS_SUBMITTED, TRANSACTION_STATUS_PARSE_ERROR */
/* harmony import */ var _wallets_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57103);
/* harmony import */ var _images_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86096);
/* provided dependency */ var process = __webpack_require__(83454);



//----------------------------------------------------------------------
// SEO AND SOCIAL MEDIA
const PROYECT_NAME = "MAYZ-OTC-DAPP" || 0;
//----------------------------------------------------------------------
const LUCID_NETWORK_MAINNET_ID = 1;
const LUCID_NETWORK_TESTNET_ID = 0;
//----------------------------------------------------------------------
const LUCID_NETWORK_MAINNET_NAME = 'Mainnet';
const LUCID_NETWORK_PREVIEW_NAME = 'Preview';
const LUCID_NETWORK_PREPROD_NAME = 'Preprod';
const LUCID_NETWORK_CUSTOM_NAME = 'Custom';
const LUCID_NETWORK_EMULATOR_NAME_MOCK_NO_EXISTE_EN_LUCID = 'Emulator';
//----------------------------------------------------------------------
const isEmulator = "Mainnet" === LUCID_NETWORK_EMULATOR_NAME_MOCK_NO_EXISTE_EN_LUCID;
const isTestnet = "Mainnet" === LUCID_NETWORK_EMULATOR_NAME_MOCK_NO_EXISTE_EN_LUCID ||
    "Mainnet" === LUCID_NETWORK_PREVIEW_NAME ||
    "Mainnet" === LUCID_NETWORK_PREPROD_NAME ||
    "Mainnet" === LUCID_NETWORK_CUSTOM_NAME;
const isPreview = "Mainnet" === LUCID_NETWORK_PREVIEW_NAME;
const isPreprod = "Mainnet" === LUCID_NETWORK_PREPROD_NAME;
const isMainnet = "Mainnet" === LUCID_NETWORK_MAINNET_NAME;
//----------------------------------------------------------------------
function getLUCID_NETWORK_ID() {
    if (isMainnet) {
        return LUCID_NETWORK_MAINNET_ID;
    }
    else {
        return LUCID_NETWORK_TESTNET_ID;
    }
}
//----------------------------------------------------------------------
// SESSION
const VALID_SESSION_DURATION_MS = (/* unused pure expression or super */ null && (30 * 24 * 60 * 60 * 1000)); // 30 days
const VALID_SESSION_DURATION_STR = '30d'; // 30 days
//----------------------------------------------------------------------
// WALLET CONNECT
const CONNECT_WALLET_WAIT_FOR_WALLET_ACTIVATION_MS = 1 * 1000; // = 1 segundos
const CONNECT_WALLET_WAIT_FOR_API_WALLETS_MS = 1 * 4 * 1000; // = 4 segundos
const CONNECT_WALLET_WAIT_FOR_EXTENSIONS_POOL_WALLETS_MS = 1 * 1000; // = 1 segundos
// WALLET CREATED BY
const WALLET_CREATEDBY_ADMIN = 'Admin';
const WALLET_CREATEDBY_LOGIN = 'Login';
//----------------------------------------------------------------------
// FETCH WRAPPER
const API_TIMEOUT = (/* unused pure expression or super */ null && (1 * 10 * 1000)); // = 10 segundos
const API_TRY_AGAIN = 1 * 1000; // = 1 segundos
//----------------------------------------------------------------------
// NAVIGATION
const NAVIGATION_TIMEOUT_MS = 10000; // 10 segundos
//----------------------------------------------------------------------
// TX BUILDING
const VALID_TX_TIME_BEFORE_MS = (/* unused pure expression or super */ null && (2 * 60 * 1000)); // = 2 minutos
const VALID_TX_TIME_RANGE_MS = (/* unused pure expression or super */ null && (15 * 60 * 1000)); // = 15 minutos
//------------------------------------------
// TX LIMITS
const MAX_TX_EX_MEM = 14_000_000;
const MAX_TX_EX_STEPS = 10_000_000_000;
const MAX_TX_SIZE = 16_384;
//----------------------------------------------------------------------
// TX UPDATER
// tiempo que se usa para iterar y controlar las tx confirmadas
const TX_CHECK_INTERVAL_MS = 5 * 1000; // = 5 segundos
// tiempo para esperar entre transacciones, para dar tiemp a blockfrost que todos sus endpoints se actualicen
// tiempo que se espera para que una tx se confirme y se actualicen los diferentes providers de data
const TX_PROPAGATION_DELAY_MS = 15 * 1000; // = 15 segundos
const TX_PREPARING_TIME_MS = 1 * 60 * 1000; // = 5 minutos
const TX_CONSUMING_TIME_MS = (/* unused pure expression or super */ null && (5 * 60 * 1000)); // = 5 minutos
const TX_TIMEOUT_MS = (/* unused pure expression or super */ null && (30 * 60 * 1000)); // = 30 minutos
// en emulador se usa para simular el tiempo de espera entre transacciones
const TX_SIMULATION_SLEEP_TIME_MS = 500; // = 0.5 segundos
//----------------------------------------------------------------------
// BLOCKFRTOST
const BLOCKFROST_RETRY_TIME_MS = 1000; // = 2 segundos
const BLOCKFROST_URL_EPOCHS_LATEST_PARAMETERS = '/epochs/latest/parameters';
const TIMEOUT_PROXY_BLOCKFROST_MS = 25000; // = 25 segundos
//----------------------------------------------------------------------
// FOR CALCULATING FREE AVAILABLE ADA IN WALLET
const ADA_TX_FEE_MARGIN = 10000000n;
const ADA_THRESHOLD = 5000000n;
//------------------------------------------
// ORACLE
const useOraclePrices = process.env.NEXT_PUBLIC_USE_ORACLE_PRICE !== undefined ? process.env.NEXT_PUBLIC_USE_ORACLE_PRICE === 'true' : false;
// oracleData_Valid_Time = 300,000 (5 * 60 * 1000 = 5 minutes)
// This is the real time that the oracle data is valid in the smart contract.
//TODO: reemplazar por DEFAULT_VALID_ORACLE_PRICE_TIME_MS y usarlo solo al crear el protoclo, luego leer de protocol.
const VALID_ORACLE_PRICE_TIME_MS = 5 * 60 * 1000; // 5 minutes
// Safety bridge time used as a buffer to ensure price data remains valid for transactions by accounting for possible delays.
const SAFETY_BRIDGE_PRICE_TIME_MS = 2 * 60 * 1000; // 2 minutes
// Minimum time that must elapse between consecutive price refreshes from the oracle to prevent abuse.
const MIN_TIME_BETWEEN_REFRESHES_MS = 2.5 * 60 * 1000; // 1 minute
// Defines the maximum age a price can be for it to be considered valid for usage.
// This is the valid oracle time minus the safety bridge time.
const MAX_PRICE_AGE_FOR_USE_MS = VALID_ORACLE_PRICE_TIME_MS - SAFETY_BRIDGE_PRICE_TIME_MS;
// Defines the minimum age a price must reach before a refresh is allowed.
// This helps to manage the frequency of updates and reduces unnecessary calls to the oracle.
const MIN_AGE_BEFORE_REFRESH_MS = MAX_PRICE_AGE_FOR_USE_MS - MIN_TIME_BETWEEN_REFRESHES_MS;
// Sets a longer validity period for using an approximated price, useful for less sensitive or non-critical updates.
const MAX_PRICE_AGE_FOR_APROXIMATED_USE_MS = 30 * 60 * 1000; // 30 minutes
const ORACLE_COUNT = 2;
const ORACLE_DIFFERENCE = 0.25;
const ORACLE_DESVIATION = 0.15;
//------------------------------------------
// JOBS
const JOB_MAX_TIME_WAITING_TO_COMPLETE_MS = (/* unused pure expression or super */ null && (10 * 60 * 1000)); // 10 minute
const JOB_TIME_WAITING_TO_TRY_AGAIN_MS = 200; // 0.2 seconds
const JOB_MONITOR_INTERVAL_MS = 2 * 1000; // = 2 segundos
//------------------------------------------
// DB CONCURRENCY
const DB_MAX_POOL_SIZE = 50;
const DB_SERVERSELECCION_TIMEOUT_MS = (/* unused pure expression or super */ null && (5 * 60 * 1000)); // 1 minutos
const DB_SOCKET_TIMEOUT_MS = (/* unused pure expression or super */ null && (1 * 60 * 1000)); // 1 minutos
const DB_WRITE_TIMEOUT_MS = (/* unused pure expression or super */ null && (1 * 60 * 1000)); // 1 minute
const DB_LOCK_MAX_TIME_WAITING_TO_COMPLETE_MS = (/* unused pure expression or super */ null && (1 * 60 * 1000)); // 1 minute
const DB_LOCK_TIME_WAITING_TO_TRY_AGAIN_MS = 200; // 0.2 seconds
const DB_USE_TRANSACTIONS = process.env.DB_USE_TRANSACTIONS === 'true' ? true : false;
//------------------------------------------
// SERVER TIME
// si pasaron mas de SYNC_SERVER_TIME_ALWAYS refresca siempre
// si pasaron mas de SYNC_SERVER_TIME_OPTIONAL minutos refresca si refresh es true
const SYNC_SERVER_TIME_ALWAYS_MS = 10 * 60 * 1000; // 10 minute
const SYNC_SERVER_TIME_OPTIONAL_MS = (/* unused pure expression or super */ null && (2 * 60 * 1000)); // 2 minute
//----------------------------------------------------------------------
// LISTING
const ITEMS_PER_PAGE = 5; // Set the number of items per page
//----------------------------------------------------------------------
// TOKENS
const TOKEN_ADA_DECIMALS = 6;
const TOKEN_DEFAULT_DECIMALS = 6;
const TOKEN_ADA_MULTIPLIER = 1000000;
const TOKEN_ADA_SYMBOL = isTestnet ? 't₳' : '₳';
const TOKEN_ADA_TICKER = isTestnet ? 'tADA' : 'ADA';
const TOKEN_LOVELACE_TICKER = 'lovelace';
const PRICEx1e6 = 1_000_000;
const PRICEx1e6_DECIMALS = 6;
const BPx1e2_DECIMALS = 4; // BP es 1e2 + 1e2 es 1e4
const BPx1e3_DECIMALS = 5; // BP es 1e2 + 1e3 es 1e5
//----------------------------------------------------------------------
// TX STATUS
const TRANSACTION_STATUS_CREATED = 'created'; // recien creada, no tiene hash // NOTE: este se usaria cuando epenas inicia el backend de crear tx, y quiero reservar ya de una unas utxos... pero se puede evitar usar y crear la tx al final del metodo como pending
const TRANSACTION_STATUS_PENDING = 'pending'; // recien creada y en espera de ser firmada. Tiene hash.
const TRANSACTION_STATUS_CANCELED = 'user-canceled';
const TRANSACTION_STATUS_PENDING_TIMEOUT = 'pending-timeout'; // cuando pasa tiempo desde pending y no es firmada y enviada
const TRANSACTION_STATUS_SUBMITTED = 'submitted'; // cuando una pending es firmada y enviada
const TRANSACTION_STATUS_CONFIRMED = 'confirmed'; // cuando una submitted es confirmada
const TRANSACTION_STATUS_FAILED = 'failed'; // cuando hay algun error, luego de ser creada, puede ser al firmar o enviar
const TRANSACTION_STATUS_TIMEOUT = 'timeout'; // cuando es submitted pero no se confirma en la red
// export const TRANSACTION_STATUS_EXPIRED = 'expired';
// export const TRANSACTION_STATUS_UNKNOWN = 'unknown';
const TRANSACTION_STATUS_PARSE_ERROR = 'parseError';
// | typeof TRANSACTION_STATUS_EXPIRED
// | typeof TRANSACTION_STATUS_UNKNOWN;
//-------------------------------------------------------------
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ 86096:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$F": function() { return /* binding */ WALLET_ETERNL_ICON; },
/* harmony export */   "B4": function() { return /* binding */ COPY; },
/* harmony export */   "CN": function() { return /* binding */ WALLET_NAMI_ICON; },
/* harmony export */   "PB": function() { return /* binding */ WALLET_TYPHON_ICON; },
/* harmony export */   "X3": function() { return /* binding */ WALLET_VESPR_ICON; },
/* harmony export */   "eq": function() { return /* binding */ WALLET_YOROI_ICON; },
/* harmony export */   "lU": function() { return /* binding */ WALLET_LACE_ICON; },
/* harmony export */   "uh": function() { return /* binding */ WALLET_NUFI_ICON; }
/* harmony export */ });
/* unused harmony exports ARROW_RIGHT, ARROW_BUTTON, ARROW_BUTTON_HOVER, CHECK, SEARCH, CLOSE, CHEVRON_DOWN, REPEAT, EYE_SHOW, EYE_HIDE, QUESTION, SHARE, ERROR, STAR, STAROFF, COPY2, PORTFOLIO, DISCONNECT, TOKEN_ICON_GENERIC, TOKEN_ICON_ADA, TOKEN_ICON_ADA_DARK, TOKEN_COLOR_GENERIC, TOKEN_COLOR_ADA, WALLET_FLINT_ICON */
//ICONS
//URL Relative to final directory in build
const ARROW_RIGHT = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const ARROW_BUTTON = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const ARROW_BUTTON_HOVER = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const CHECK = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const SEARCH = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const COPY = new URL(/* asset import */ __webpack_require__(43973), __webpack_require__.b);
const CLOSE = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const CHEVRON_DOWN = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const REPEAT = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const EYE_SHOW = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const EYE_HIDE = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const QUESTION = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const SHARE = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const ERROR = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const STAR = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const STAROFF = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const COPY2 = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const PORTFOLIO = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const DISCONNECT = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
//TOKENS
const TOKEN_ICON_GENERIC = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const TOKEN_ICON_ADA = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const TOKEN_ICON_ADA_DARK = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const TOKEN_COLOR_GENERIC = '#a75ee6';
const TOKEN_COLOR_ADA = '#2352B4';
//WALETS
const WALLET_ETERNL_ICON = new URL(/* asset import */ __webpack_require__(32253), __webpack_require__.b);
const WALLET_NAMI_ICON = new URL(/* asset import */ __webpack_require__(76555), __webpack_require__.b);
const WALLET_FLINT_ICON = (/* unused pure expression or super */ null && (/* unused asset import */ undefined));
const WALLET_TYPHON_ICON = new URL(/* asset import */ __webpack_require__(48931), __webpack_require__.b);
const WALLET_NUFI_ICON = new URL(/* asset import */ __webpack_require__(5810), __webpack_require__.b);
const WALLET_YOROI_ICON = new URL(/* asset import */ __webpack_require__(9884), __webpack_require__.b);
const WALLET_LACE_ICON = new URL(/* asset import */ __webpack_require__(68778), __webpack_require__.b);
const WALLET_VESPR_ICON = new URL(/* asset import */ __webpack_require__(33824), __webpack_require__.b);
//# sourceMappingURL=images.js.map

/***/ }),

/***/ 74625:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XP": function() { return /* binding */ protocolParametersForLucid; }
/* harmony export */ });
/* unused harmony exports Mainnet, Preview, Preprod, slotsPerEpochForLucid */
// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// Generated by fetch_protocol_params.sh
const Mainnet = {
    minFeeA: 44,
    minFeeB: 155381,
    maxTxSize: 16384,
    maxValSize: 5000,
    keyDeposit: 2000000n,
    poolDeposit: 500000000n,
    drepDeposit: 500000000n,
    govActionDeposit: 100000000000n,
    priceMem: 0.0577,
    priceStep: 7.21e-5,
    maxTxExMem: 14000000n,
    maxTxExSteps: 10000000000n,
    coinsPerUtxoByte: 4310n,
    collateralPercentage: 150,
    maxCollateralInputs: 3,
    minFeeRefScriptCostPerByte: 15,
    costModels: {
        PlutusV1: {
            'addInteger-cpu-arguments-intercept': 100788,
            'addInteger-cpu-arguments-slope': 420,
            'addInteger-memory-arguments-intercept': 1,
            'addInteger-memory-arguments-slope': 1,
            'appendByteString-cpu-arguments-intercept': 1000,
            'appendByteString-cpu-arguments-slope': 173,
            'appendByteString-memory-arguments-intercept': 0,
            'appendByteString-memory-arguments-slope': 1,
            'appendString-cpu-arguments-intercept': 1000,
            'appendString-cpu-arguments-slope': 59957,
            'appendString-memory-arguments-intercept': 4,
            'appendString-memory-arguments-slope': 1,
            'bData-cpu-arguments': 11183,
            'bData-memory-arguments': 32,
            'blake2b_256-cpu-arguments-intercept': 201305,
            'blake2b_256-cpu-arguments-slope': 8356,
            'blake2b_256-memory-arguments': 4,
            'cekApplyCost-exBudgetCPU': 16000,
            'cekApplyCost-exBudgetMemory': 100,
            'cekBuiltinCost-exBudgetCPU': 16000,
            'cekBuiltinCost-exBudgetMemory': 100,
            'cekConstCost-exBudgetCPU': 16000,
            'cekConstCost-exBudgetMemory': 100,
            'cekDelayCost-exBudgetCPU': 16000,
            'cekDelayCost-exBudgetMemory': 100,
            'cekForceCost-exBudgetCPU': 16000,
            'cekForceCost-exBudgetMemory': 100,
            'cekLamCost-exBudgetCPU': 16000,
            'cekLamCost-exBudgetMemory': 100,
            'cekStartupCost-exBudgetCPU': 100,
            'cekStartupCost-exBudgetMemory': 100,
            'cekVarCost-exBudgetCPU': 16000,
            'cekVarCost-exBudgetMemory': 100,
            'chooseData-cpu-arguments': 94375,
            'chooseData-memory-arguments': 32,
            'chooseList-cpu-arguments': 132994,
            'chooseList-memory-arguments': 32,
            'chooseUnit-cpu-arguments': 61462,
            'chooseUnit-memory-arguments': 4,
            'consByteString-cpu-arguments-intercept': 72010,
            'consByteString-cpu-arguments-slope': 178,
            'consByteString-memory-arguments-intercept': 0,
            'consByteString-memory-arguments-slope': 1,
            'constrData-cpu-arguments': 22151,
            'constrData-memory-arguments': 32,
            'decodeUtf8-cpu-arguments-intercept': 91189,
            'decodeUtf8-cpu-arguments-slope': 769,
            'decodeUtf8-memory-arguments-intercept': 4,
            'decodeUtf8-memory-arguments-slope': 2,
            'divideInteger-cpu-arguments-constant': 85848,
            'divideInteger-cpu-arguments-model-arguments-intercept': 228465,
            'divideInteger-cpu-arguments-model-arguments-slope': 122,
            'divideInteger-memory-arguments-intercept': 0,
            'divideInteger-memory-arguments-minimum': 1,
            'divideInteger-memory-arguments-slope': 1,
            'encodeUtf8-cpu-arguments-intercept': 1000,
            'encodeUtf8-cpu-arguments-slope': 42921,
            'encodeUtf8-memory-arguments-intercept': 4,
            'encodeUtf8-memory-arguments-slope': 2,
            'equalsByteString-cpu-arguments-constant': 24548,
            'equalsByteString-cpu-arguments-intercept': 29498,
            'equalsByteString-cpu-arguments-slope': 38,
            'equalsByteString-memory-arguments': 1,
            'equalsData-cpu-arguments-intercept': 898148,
            'equalsData-cpu-arguments-slope': 27279,
            'equalsData-memory-arguments': 1,
            'equalsInteger-cpu-arguments-intercept': 51775,
            'equalsInteger-cpu-arguments-slope': 558,
            'equalsInteger-memory-arguments': 1,
            'equalsString-cpu-arguments-constant': 39184,
            'equalsString-cpu-arguments-intercept': 1000,
            'equalsString-cpu-arguments-slope': 60594,
            'equalsString-memory-arguments': 1,
            'fstPair-cpu-arguments': 141895,
            'fstPair-memory-arguments': 32,
            'headList-cpu-arguments': 83150,
            'headList-memory-arguments': 32,
            'iData-cpu-arguments': 15299,
            'iData-memory-arguments': 32,
            'ifThenElse-cpu-arguments': 76049,
            'ifThenElse-memory-arguments': 1,
            'indexByteString-cpu-arguments': 13169,
            'indexByteString-memory-arguments': 4,
            'lengthOfByteString-cpu-arguments': 22100,
            'lengthOfByteString-memory-arguments': 10,
            'lessThanByteString-cpu-arguments-intercept': 28999,
            'lessThanByteString-cpu-arguments-slope': 74,
            'lessThanByteString-memory-arguments': 1,
            'lessThanEqualsByteString-cpu-arguments-intercept': 28999,
            'lessThanEqualsByteString-cpu-arguments-slope': 74,
            'lessThanEqualsByteString-memory-arguments': 1,
            'lessThanEqualsInteger-cpu-arguments-intercept': 43285,
            'lessThanEqualsInteger-cpu-arguments-slope': 552,
            'lessThanEqualsInteger-memory-arguments': 1,
            'lessThanInteger-cpu-arguments-intercept': 44749,
            'lessThanInteger-cpu-arguments-slope': 541,
            'lessThanInteger-memory-arguments': 1,
            'listData-cpu-arguments': 33852,
            'listData-memory-arguments': 32,
            'mapData-cpu-arguments': 68246,
            'mapData-memory-arguments': 32,
            'mkCons-cpu-arguments': 72362,
            'mkCons-memory-arguments': 32,
            'mkNilData-cpu-arguments': 7243,
            'mkNilData-memory-arguments': 32,
            'mkNilPairData-cpu-arguments': 7391,
            'mkNilPairData-memory-arguments': 32,
            'mkPairData-cpu-arguments': 11546,
            'mkPairData-memory-arguments': 32,
            'modInteger-cpu-arguments-constant': 85848,
            'modInteger-cpu-arguments-model-arguments-intercept': 228465,
            'modInteger-cpu-arguments-model-arguments-slope': 122,
            'modInteger-memory-arguments-intercept': 0,
            'modInteger-memory-arguments-minimum': 1,
            'modInteger-memory-arguments-slope': 1,
            'multiplyInteger-cpu-arguments-intercept': 90434,
            'multiplyInteger-cpu-arguments-slope': 519,
            'multiplyInteger-memory-arguments-intercept': 0,
            'multiplyInteger-memory-arguments-slope': 1,
            'nullList-cpu-arguments': 74433,
            'nullList-memory-arguments': 32,
            'quotientInteger-cpu-arguments-constant': 85848,
            'quotientInteger-cpu-arguments-model-arguments-intercept': 228465,
            'quotientInteger-cpu-arguments-model-arguments-slope': 122,
            'quotientInteger-memory-arguments-intercept': 0,
            'quotientInteger-memory-arguments-minimum': 1,
            'quotientInteger-memory-arguments-slope': 1,
            'remainderInteger-cpu-arguments-constant': 85848,
            'remainderInteger-cpu-arguments-model-arguments-intercept': 228465,
            'remainderInteger-cpu-arguments-model-arguments-slope': 122,
            'remainderInteger-memory-arguments-intercept': 0,
            'remainderInteger-memory-arguments-minimum': 1,
            'remainderInteger-memory-arguments-slope': 1,
            'sha2_256-cpu-arguments-intercept': 270652,
            'sha2_256-cpu-arguments-slope': 22588,
            'sha2_256-memory-arguments': 4,
            'sha3_256-cpu-arguments-intercept': 1457325,
            'sha3_256-cpu-arguments-slope': 64566,
            'sha3_256-memory-arguments': 4,
            'sliceByteString-cpu-arguments-intercept': 20467,
            'sliceByteString-cpu-arguments-slope': 1,
            'sliceByteString-memory-arguments-intercept': 4,
            'sliceByteString-memory-arguments-slope': 0,
            'sndPair-cpu-arguments': 141992,
            'sndPair-memory-arguments': 32,
            'subtractInteger-cpu-arguments-intercept': 100788,
            'subtractInteger-cpu-arguments-slope': 420,
            'subtractInteger-memory-arguments-intercept': 1,
            'subtractInteger-memory-arguments-slope': 1,
            'tailList-cpu-arguments': 81663,
            'tailList-memory-arguments': 32,
            'trace-cpu-arguments': 59498,
            'trace-memory-arguments': 32,
            'unBData-cpu-arguments': 20142,
            'unBData-memory-arguments': 32,
            'unConstrData-cpu-arguments': 24588,
            'unConstrData-memory-arguments': 32,
            'unIData-cpu-arguments': 20744,
            'unIData-memory-arguments': 32,
            'unListData-cpu-arguments': 25933,
            'unListData-memory-arguments': 32,
            'unMapData-cpu-arguments': 24623,
            'unMapData-memory-arguments': 32,
            'verifyEd25519Signature-cpu-arguments-intercept': 53384111,
            'verifyEd25519Signature-cpu-arguments-slope': 14333,
            'verifyEd25519Signature-memory-arguments': 10,
        },
        PlutusV2: {
            'addInteger-cpu-arguments-intercept': 100788,
            'addInteger-cpu-arguments-slope': 420,
            'addInteger-memory-arguments-intercept': 1,
            'addInteger-memory-arguments-slope': 1,
            'appendByteString-cpu-arguments-intercept': 1000,
            'appendByteString-cpu-arguments-slope': 173,
            'appendByteString-memory-arguments-intercept': 0,
            'appendByteString-memory-arguments-slope': 1,
            'appendString-cpu-arguments-intercept': 1000,
            'appendString-cpu-arguments-slope': 59957,
            'appendString-memory-arguments-intercept': 4,
            'appendString-memory-arguments-slope': 1,
            'bData-cpu-arguments': 11183,
            'bData-memory-arguments': 32,
            'blake2b_256-cpu-arguments-intercept': 201305,
            'blake2b_256-cpu-arguments-slope': 8356,
            'blake2b_256-memory-arguments': 4,
            'cekApplyCost-exBudgetCPU': 16000,
            'cekApplyCost-exBudgetMemory': 100,
            'cekBuiltinCost-exBudgetCPU': 16000,
            'cekBuiltinCost-exBudgetMemory': 100,
            'cekConstCost-exBudgetCPU': 16000,
            'cekConstCost-exBudgetMemory': 100,
            'cekDelayCost-exBudgetCPU': 16000,
            'cekDelayCost-exBudgetMemory': 100,
            'cekForceCost-exBudgetCPU': 16000,
            'cekForceCost-exBudgetMemory': 100,
            'cekLamCost-exBudgetCPU': 16000,
            'cekLamCost-exBudgetMemory': 100,
            'cekStartupCost-exBudgetCPU': 100,
            'cekStartupCost-exBudgetMemory': 100,
            'cekVarCost-exBudgetCPU': 16000,
            'cekVarCost-exBudgetMemory': 100,
            'chooseData-cpu-arguments': 94375,
            'chooseData-memory-arguments': 32,
            'chooseList-cpu-arguments': 132994,
            'chooseList-memory-arguments': 32,
            'chooseUnit-cpu-arguments': 61462,
            'chooseUnit-memory-arguments': 4,
            'consByteString-cpu-arguments-intercept': 72010,
            'consByteString-cpu-arguments-slope': 178,
            'consByteString-memory-arguments-intercept': 0,
            'consByteString-memory-arguments-slope': 1,
            'constrData-cpu-arguments': 22151,
            'constrData-memory-arguments': 32,
            'decodeUtf8-cpu-arguments-intercept': 91189,
            'decodeUtf8-cpu-arguments-slope': 769,
            'decodeUtf8-memory-arguments-intercept': 4,
            'decodeUtf8-memory-arguments-slope': 2,
            'divideInteger-cpu-arguments-constant': 85848,
            'divideInteger-cpu-arguments-model-arguments-intercept': 228465,
            'divideInteger-cpu-arguments-model-arguments-slope': 122,
            'divideInteger-memory-arguments-intercept': 0,
            'divideInteger-memory-arguments-minimum': 1,
            'divideInteger-memory-arguments-slope': 1,
            'encodeUtf8-cpu-arguments-intercept': 1000,
            'encodeUtf8-cpu-arguments-slope': 42921,
            'encodeUtf8-memory-arguments-intercept': 4,
            'encodeUtf8-memory-arguments-slope': 2,
            'equalsByteString-cpu-arguments-constant': 24548,
            'equalsByteString-cpu-arguments-intercept': 29498,
            'equalsByteString-cpu-arguments-slope': 38,
            'equalsByteString-memory-arguments': 1,
            'equalsData-cpu-arguments-intercept': 898148,
            'equalsData-cpu-arguments-slope': 27279,
            'equalsData-memory-arguments': 1,
            'equalsInteger-cpu-arguments-intercept': 51775,
            'equalsInteger-cpu-arguments-slope': 558,
            'equalsInteger-memory-arguments': 1,
            'equalsString-cpu-arguments-constant': 39184,
            'equalsString-cpu-arguments-intercept': 1000,
            'equalsString-cpu-arguments-slope': 60594,
            'equalsString-memory-arguments': 1,
            'fstPair-cpu-arguments': 141895,
            'fstPair-memory-arguments': 32,
            'headList-cpu-arguments': 83150,
            'headList-memory-arguments': 32,
            'iData-cpu-arguments': 15299,
            'iData-memory-arguments': 32,
            'ifThenElse-cpu-arguments': 76049,
            'ifThenElse-memory-arguments': 1,
            'indexByteString-cpu-arguments': 13169,
            'indexByteString-memory-arguments': 4,
            'lengthOfByteString-cpu-arguments': 22100,
            'lengthOfByteString-memory-arguments': 10,
            'lessThanByteString-cpu-arguments-intercept': 28999,
            'lessThanByteString-cpu-arguments-slope': 74,
            'lessThanByteString-memory-arguments': 1,
            'lessThanEqualsByteString-cpu-arguments-intercept': 28999,
            'lessThanEqualsByteString-cpu-arguments-slope': 74,
            'lessThanEqualsByteString-memory-arguments': 1,
            'lessThanEqualsInteger-cpu-arguments-intercept': 43285,
            'lessThanEqualsInteger-cpu-arguments-slope': 552,
            'lessThanEqualsInteger-memory-arguments': 1,
            'lessThanInteger-cpu-arguments-intercept': 44749,
            'lessThanInteger-cpu-arguments-slope': 541,
            'lessThanInteger-memory-arguments': 1,
            'listData-cpu-arguments': 33852,
            'listData-memory-arguments': 32,
            'mapData-cpu-arguments': 68246,
            'mapData-memory-arguments': 32,
            'mkCons-cpu-arguments': 72362,
            'mkCons-memory-arguments': 32,
            'mkNilData-cpu-arguments': 7243,
            'mkNilData-memory-arguments': 32,
            'mkNilPairData-cpu-arguments': 7391,
            'mkNilPairData-memory-arguments': 32,
            'mkPairData-cpu-arguments': 11546,
            'mkPairData-memory-arguments': 32,
            'modInteger-cpu-arguments-constant': 85848,
            'modInteger-cpu-arguments-model-arguments-intercept': 228465,
            'modInteger-cpu-arguments-model-arguments-slope': 122,
            'modInteger-memory-arguments-intercept': 0,
            'modInteger-memory-arguments-minimum': 1,
            'modInteger-memory-arguments-slope': 1,
            'multiplyInteger-cpu-arguments-intercept': 90434,
            'multiplyInteger-cpu-arguments-slope': 519,
            'multiplyInteger-memory-arguments-intercept': 0,
            'multiplyInteger-memory-arguments-slope': 1,
            'nullList-cpu-arguments': 74433,
            'nullList-memory-arguments': 32,
            'quotientInteger-cpu-arguments-constant': 85848,
            'quotientInteger-cpu-arguments-model-arguments-intercept': 228465,
            'quotientInteger-cpu-arguments-model-arguments-slope': 122,
            'quotientInteger-memory-arguments-intercept': 0,
            'quotientInteger-memory-arguments-minimum': 1,
            'quotientInteger-memory-arguments-slope': 1,
            'remainderInteger-cpu-arguments-constant': 85848,
            'remainderInteger-cpu-arguments-model-arguments-intercept': 228465,
            'remainderInteger-cpu-arguments-model-arguments-slope': 122,
            'remainderInteger-memory-arguments-intercept': 0,
            'remainderInteger-memory-arguments-minimum': 1,
            'remainderInteger-memory-arguments-slope': 1,
            'serialiseData-cpu-arguments-intercept': 955506,
            'serialiseData-cpu-arguments-slope': 213312,
            'serialiseData-memory-arguments-intercept': 0,
            'serialiseData-memory-arguments-slope': 2,
            'sha2_256-cpu-arguments-intercept': 270652,
            'sha2_256-cpu-arguments-slope': 22588,
            'sha2_256-memory-arguments': 4,
            'sha3_256-cpu-arguments-intercept': 1457325,
            'sha3_256-cpu-arguments-slope': 64566,
            'sha3_256-memory-arguments': 4,
            'sliceByteString-cpu-arguments-intercept': 20467,
            'sliceByteString-cpu-arguments-slope': 1,
            'sliceByteString-memory-arguments-intercept': 4,
            'sliceByteString-memory-arguments-slope': 0,
            'sndPair-cpu-arguments': 141992,
            'sndPair-memory-arguments': 32,
            'subtractInteger-cpu-arguments-intercept': 100788,
            'subtractInteger-cpu-arguments-slope': 420,
            'subtractInteger-memory-arguments-intercept': 1,
            'subtractInteger-memory-arguments-slope': 1,
            'tailList-cpu-arguments': 81663,
            'tailList-memory-arguments': 32,
            'trace-cpu-arguments': 59498,
            'trace-memory-arguments': 32,
            'unBData-cpu-arguments': 20142,
            'unBData-memory-arguments': 32,
            'unConstrData-cpu-arguments': 24588,
            'unConstrData-memory-arguments': 32,
            'unIData-cpu-arguments': 20744,
            'unIData-memory-arguments': 32,
            'unListData-cpu-arguments': 25933,
            'unListData-memory-arguments': 32,
            'unMapData-cpu-arguments': 24623,
            'unMapData-memory-arguments': 32,
            'verifyEcdsaSecp256k1Signature-cpu-arguments': 43053543,
            'verifyEcdsaSecp256k1Signature-memory-arguments': 10,
            'verifyEd25519Signature-cpu-arguments-intercept': 53384111,
            'verifyEd25519Signature-cpu-arguments-slope': 14333,
            'verifyEd25519Signature-memory-arguments': 10,
            'verifySchnorrSecp256k1Signature-cpu-arguments-intercept': 43574283,
            'verifySchnorrSecp256k1Signature-cpu-arguments-slope': 26308,
            'verifySchnorrSecp256k1Signature-memory-arguments': 10,
        },
        PlutusV3: {
            'addInteger-cpu-arguments-intercept': 100788,
            'addInteger-cpu-arguments-slope': 420,
            'addInteger-memory-arguments-intercept': 1,
            'addInteger-memory-arguments-slope': 1,
            'appendByteString-cpu-arguments-intercept': 1000,
            'appendByteString-cpu-arguments-slope': 173,
            'appendByteString-memory-arguments-intercept': 0,
            'appendByteString-memory-arguments-slope': 1,
            'appendString-cpu-arguments-intercept': 1000,
            'appendString-cpu-arguments-slope': 59957,
            'appendString-memory-arguments-intercept': 4,
            'appendString-memory-arguments-slope': 1,
            'bData-cpu-arguments': 11183,
            'bData-memory-arguments': 32,
            'blake2b_256-cpu-arguments-intercept': 201305,
            'blake2b_256-cpu-arguments-slope': 8356,
            'blake2b_256-memory-arguments': 4,
            'cekApplyCost-exBudgetCPU': 16000,
            'cekApplyCost-exBudgetMemory': 100,
            'cekBuiltinCost-exBudgetCPU': 16000,
            'cekBuiltinCost-exBudgetMemory': 100,
            'cekConstCost-exBudgetCPU': 16000,
            'cekConstCost-exBudgetMemory': 100,
            'cekDelayCost-exBudgetCPU': 16000,
            'cekDelayCost-exBudgetMemory': 100,
            'cekForceCost-exBudgetCPU': 16000,
            'cekForceCost-exBudgetMemory': 100,
            'cekLamCost-exBudgetCPU': 16000,
            'cekLamCost-exBudgetMemory': 100,
            'cekStartupCost-exBudgetCPU': 100,
            'cekStartupCost-exBudgetMemory': 100,
            'cekVarCost-exBudgetCPU': 16000,
            'cekVarCost-exBudgetMemory': 100,
            'chooseData-cpu-arguments': 94375,
            'chooseData-memory-arguments': 32,
            'chooseList-cpu-arguments': 132994,
            'chooseList-memory-arguments': 32,
            'chooseUnit-cpu-arguments': 61462,
            'chooseUnit-memory-arguments': 4,
            'consByteString-cpu-arguments-intercept': 72010,
            'consByteString-cpu-arguments-slope': 178,
            'consByteString-memory-arguments-intercept': 0,
            'consByteString-memory-arguments-slope': 1,
            'constrData-cpu-arguments': 22151,
            'constrData-memory-arguments': 32,
            'decodeUtf8-cpu-arguments-intercept': 91189,
            'decodeUtf8-cpu-arguments-slope': 769,
            'decodeUtf8-memory-arguments-intercept': 4,
            'decodeUtf8-memory-arguments-slope': 2,
            'divideInteger-cpu-arguments-constant': 85848,
            'divideInteger-cpu-arguments-model-arguments-c00': 123203,
            'divideInteger-cpu-arguments-model-arguments-c01': 7305,
            'divideInteger-cpu-arguments-model-arguments-c02': -900,
            'divideInteger-cpu-arguments-model-arguments-c10': 1716,
            'divideInteger-cpu-arguments-model-arguments-c11': 549,
            'divideInteger-cpu-arguments-model-arguments-c20': 57,
            'divideInteger-cpu-arguments-model-arguments-minimum': 85848,
            'divideInteger-memory-arguments-intercept': 0,
            'divideInteger-memory-arguments-minimum': 1,
            'divideInteger-memory-arguments-slope': 1,
            'encodeUtf8-cpu-arguments-intercept': 1000,
            'encodeUtf8-cpu-arguments-slope': 42921,
            'encodeUtf8-memory-arguments-intercept': 4,
            'encodeUtf8-memory-arguments-slope': 2,
            'equalsByteString-cpu-arguments-constant': 24548,
            'equalsByteString-cpu-arguments-intercept': 29498,
            'equalsByteString-cpu-arguments-slope': 38,
            'equalsByteString-memory-arguments': 1,
            'equalsData-cpu-arguments-intercept': 898148,
            'equalsData-cpu-arguments-slope': 27279,
            'equalsData-memory-arguments': 1,
            'equalsInteger-cpu-arguments-intercept': 51775,
            'equalsInteger-cpu-arguments-slope': 558,
            'equalsInteger-memory-arguments': 1,
            'equalsString-cpu-arguments-constant': 39184,
            'equalsString-cpu-arguments-intercept': 1000,
            'equalsString-cpu-arguments-slope': 60594,
            'equalsString-memory-arguments': 1,
            'fstPair-cpu-arguments': 141895,
            'fstPair-memory-arguments': 32,
            'headList-cpu-arguments': 83150,
            'headList-memory-arguments': 32,
            'iData-cpu-arguments': 15299,
            'iData-memory-arguments': 32,
            'ifThenElse-cpu-arguments': 76049,
            'ifThenElse-memory-arguments': 1,
            'indexByteString-cpu-arguments': 13169,
            'indexByteString-memory-arguments': 4,
            'lengthOfByteString-cpu-arguments': 22100,
            'lengthOfByteString-memory-arguments': 10,
            'lessThanByteString-cpu-arguments-intercept': 28999,
            'lessThanByteString-cpu-arguments-slope': 74,
            'lessThanByteString-memory-arguments': 1,
            'lessThanEqualsByteString-cpu-arguments-intercept': 28999,
            'lessThanEqualsByteString-cpu-arguments-slope': 74,
            'lessThanEqualsByteString-memory-arguments': 1,
            'lessThanEqualsInteger-cpu-arguments-intercept': 43285,
            'lessThanEqualsInteger-cpu-arguments-slope': 552,
            'lessThanEqualsInteger-memory-arguments': 1,
            'lessThanInteger-cpu-arguments-intercept': 44749,
            'lessThanInteger-cpu-arguments-slope': 541,
            'lessThanInteger-memory-arguments': 1,
            'listData-cpu-arguments': 33852,
            'listData-memory-arguments': 32,
            'mapData-cpu-arguments': 68246,
            'mapData-memory-arguments': 32,
            'mkCons-cpu-arguments': 72362,
            'mkCons-memory-arguments': 32,
            'mkNilData-cpu-arguments': 7243,
            'mkNilData-memory-arguments': 32,
            'mkNilPairData-cpu-arguments': 7391,
            'mkNilPairData-memory-arguments': 32,
            'mkPairData-cpu-arguments': 11546,
            'mkPairData-memory-arguments': 32,
            'modInteger-cpu-arguments-constant': 85848,
            'modInteger-cpu-arguments-model-arguments-c00': 123203,
            'modInteger-cpu-arguments-model-arguments-c01': 7305,
            'modInteger-cpu-arguments-model-arguments-c02': -900,
            'modInteger-cpu-arguments-model-arguments-c10': 1716,
            'modInteger-cpu-arguments-model-arguments-c11': 549,
            'modInteger-cpu-arguments-model-arguments-c20': 57,
            'modInteger-cpu-arguments-model-arguments-minimum': 85848,
            'modInteger-memory-arguments-intercept': 0,
            'modInteger-memory-arguments-slope': 1,
            'multiplyInteger-cpu-arguments-intercept': 90434,
            'multiplyInteger-cpu-arguments-slope': 519,
            'multiplyInteger-memory-arguments-intercept': 0,
            'multiplyInteger-memory-arguments-slope': 1,
            'nullList-cpu-arguments': 74433,
            'nullList-memory-arguments': 32,
            'quotientInteger-cpu-arguments-constant': 85848,
            'quotientInteger-cpu-arguments-model-arguments-c00': 123203,
            'quotientInteger-cpu-arguments-model-arguments-c01': 7305,
            'quotientInteger-cpu-arguments-model-arguments-c02': -900,
            'quotientInteger-cpu-arguments-model-arguments-c10': 1716,
            'quotientInteger-cpu-arguments-model-arguments-c11': 549,
            'quotientInteger-cpu-arguments-model-arguments-c20': 57,
            'quotientInteger-cpu-arguments-model-arguments-minimum': 85848,
            'quotientInteger-memory-arguments-intercept': 0,
            'quotientInteger-memory-arguments-slope': 1,
            'remainderInteger-cpu-arguments-constant': 1,
            'remainderInteger-cpu-arguments-model-arguments-c00': 85848,
            'remainderInteger-cpu-arguments-model-arguments-c01': 123203,
            'remainderInteger-cpu-arguments-model-arguments-c02': 7305,
            'remainderInteger-cpu-arguments-model-arguments-c10': -900,
            'remainderInteger-cpu-arguments-model-arguments-c11': 1716,
            'remainderInteger-cpu-arguments-model-arguments-c20': 549,
            'remainderInteger-cpu-arguments-model-arguments-minimum': 57,
            'remainderInteger-memory-arguments-intercept': 85848,
            'remainderInteger-memory-arguments-minimum': 0,
            'remainderInteger-memory-arguments-slope': 1,
            'serialiseData-cpu-arguments-intercept': 955506,
            'serialiseData-cpu-arguments-slope': 213312,
            'serialiseData-memory-arguments-intercept': 0,
            'serialiseData-memory-arguments-slope': 2,
            'sha2_256-cpu-arguments-intercept': 270652,
            'sha2_256-cpu-arguments-slope': 22588,
            'sha2_256-memory-arguments': 4,
            'sha3_256-cpu-arguments-intercept': 1457325,
            'sha3_256-cpu-arguments-slope': 64566,
            'sha3_256-memory-arguments': 4,
            'sliceByteString-cpu-arguments-intercept': 20467,
            'sliceByteString-cpu-arguments-slope': 1,
            'sliceByteString-memory-arguments-intercept': 4,
            'sliceByteString-memory-arguments-slope': 0,
            'sndPair-cpu-arguments': 141992,
            'sndPair-memory-arguments': 32,
            'subtractInteger-cpu-arguments-intercept': 100788,
            'subtractInteger-cpu-arguments-slope': 420,
            'subtractInteger-memory-arguments-intercept': 1,
            'subtractInteger-memory-arguments-slope': 1,
            'tailList-cpu-arguments': 81663,
            'tailList-memory-arguments': 32,
            'trace-cpu-arguments': 59498,
            'trace-memory-arguments': 32,
            'unBData-cpu-arguments': 20142,
            'unBData-memory-arguments': 32,
            'unConstrData-cpu-arguments': 24588,
            'unConstrData-memory-arguments': 32,
            'unIData-cpu-arguments': 20744,
            'unIData-memory-arguments': 32,
            'unListData-cpu-arguments': 25933,
            'unListData-memory-arguments': 32,
            'unMapData-cpu-arguments': 24623,
            'unMapData-memory-arguments': 32,
            'verifyEcdsaSecp256k1Signature-cpu-arguments': 43053543,
            'verifyEcdsaSecp256k1Signature-memory-arguments': 10,
            'verifyEd25519Signature-cpu-arguments-intercept': 53384111,
            'verifyEd25519Signature-cpu-arguments-slope': 14333,
            'verifyEd25519Signature-memory-arguments': 10,
            'verifySchnorrSecp256k1Signature-cpu-arguments-intercept': 43574283,
            'verifySchnorrSecp256k1Signature-cpu-arguments-slope': 26308,
            'verifySchnorrSecp256k1Signature-memory-arguments': 10,
            'cekConstrCost-exBudgetCPU': 16000,
            'cekConstrCost-exBudgetMemory': 100,
            'cekCaseCost-exBudgetCPU': 16000,
            'cekCaseCost-exBudgetMemory': 100,
            'bls12_381_G1_add-cpu-arguments': 962335,
            'bls12_381_G1_add-memory-arguments': 18,
            'bls12_381_G1_compress-cpu-arguments': 2780678,
            'bls12_381_G1_compress-memory-arguments': 6,
            'bls12_381_G1_equal-cpu-arguments': 442008,
            'bls12_381_G1_equal-memory-arguments': 1,
            'bls12_381_G1_hashToGroup-cpu-arguments-intercept': 52538055,
            'bls12_381_G1_hashToGroup-cpu-arguments-slope': 3756,
            'bls12_381_G1_hashToGroup-memory-arguments': 18,
            'bls12_381_G1_neg-cpu-arguments': 267929,
            'bls12_381_G1_neg-memory-arguments': 18,
            'bls12_381_G1_scalarMul-cpu-arguments-intercept': 76433006,
            'bls12_381_G1_scalarMul-cpu-arguments-slope': 8868,
            'bls12_381_G1_scalarMul-memory-arguments': 18,
            'bls12_381_G1_uncompress-cpu-arguments': 52948122,
            'bls12_381_G1_uncompress-memory-arguments': 18,
            'bls12_381_G2_add-cpu-arguments': 1995836,
            'bls12_381_G2_add-memory-arguments': 36,
            'bls12_381_G2_compress-cpu-arguments': 3227919,
            'bls12_381_G2_compress-memory-arguments': 12,
            'bls12_381_G2_equal-cpu-arguments': 901022,
            'bls12_381_G2_equal-memory-arguments': 1,
            'bls12_381_G2_hashToGroup-cpu-arguments-intercept': 166917843,
            'bls12_381_G2_hashToGroup-cpu-arguments-slope': 4307,
            'bls12_381_G2_hashToGroup-memory-arguments': 36,
            'bls12_381_G2_neg-cpu-arguments': 284546,
            'bls12_381_G2_neg-memory-arguments': 36,
            'bls12_381_G2_scalarMul-cpu-arguments-intercept': 158221314,
            'bls12_381_G2_scalarMul-cpu-arguments-slope': 26549,
            'bls12_381_G2_scalarMul-memory-arguments': 36,
            'bls12_381_G2_uncompress-cpu-arguments': 74698472,
            'bls12_381_G2_uncompress-memory-arguments': 36,
            'bls12_381_finalVerify-cpu-arguments': 333849714,
            'bls12_381_finalVerify-memory-arguments': 1,
            'bls12_381_millerLoop-cpu-arguments': 254006273,
            'bls12_381_millerLoop-memory-arguments': 72,
            'bls12_381_mulMlResult-cpu-arguments': 2174038,
            'bls12_381_mulMlResult-memory-arguments': 72,
            'keccak_256-cpu-arguments-intercept': 2261318,
            'keccak_256-cpu-arguments-slope': 64571,
            'keccak_256-memory-arguments': 4,
            'blake2b_224-cpu-arguments-intercept': 207616,
            'blake2b_224-cpu-arguments-slope': 8310,
            'blake2b_224-memory-arguments': 4,
            'integerToByteString-cpu-arguments-c0': 1293828,
            'integerToByteString-cpu-arguments-c1': 28716,
            'integerToByteString-cpu-arguments-c2': 63,
            'integerToByteString-memory-arguments-intercept': 0,
            'integerToByteString-memory-arguments-slope': 1,
            'byteStringToInteger-cpu-arguments-c0': 1006041,
            'byteStringToInteger-cpu-arguments-c1': 43623,
            'byteStringToInteger-cpu-arguments-c2': 251,
            'byteStringToInteger-memory-arguments-intercept': 0,
            'byteStringToInteger-memory-arguments-slope': 1,
            'andByteString-cpu-arguments-intercept': 100181,
            'andByteString-cpu-arguments-slope1': 726,
            'andByteString-cpu-arguments-slope2': 719,
            'andByteString-memory-arguments-intercept': 0,
            'andByteString-memory-arguments-slope': 1,
            'orByteString-cpu-arguments-intercept': 100181,
            'orByteString-cpu-arguments-slope1': 726,
            'orByteString-cpu-arguments-slope2': 719,
            'orByteString-memory-arguments-intercept': 0,
            'orByteString-memory-arguments-slope': 1,
            'xorByteString-cpu-arguments-intercept': 100181,
            'xorByteString-cpu-arguments-slope1': 726,
            'xorByteString-cpu-arguments-slope2': 719,
            'xorByteString-memory-arguments-intercept': 0,
            'xorByteString-memory-arguments-slope': 1,
            'complementByteString-cpu-arguments-intercept': 107878,
            'complementByteString-cpu-arguments-slope': 680,
            'complementByteString-memory-arguments-intercept': 0,
            'complementByteString-memory-arguments-slope': 1,
            'readBit-cpu-arguments': 95336,
            'readBit-memory-arguments': 1,
            'writeBits-cpu-arguments-intercept': 281145,
            'writeBits-cpu-arguments-slope': 18848,
            'writeBits-memory-arguments-intercept': 0,
            'writeBits-memory-arguments-slope': 1,
            'replicateByte-cpu-arguments-intercept': 180194,
            'replicateByte-cpu-arguments-slope': 159,
            'replicateByte-memory-arguments-intercept': 1,
            'replicateByte-memory-arguments-slope': 1,
            'shiftByteString-cpu-arguments-intercept': 158519,
            'shiftByteString-cpu-arguments-slope': 8942,
            'shiftByteString-memory-arguments-intercept': 0,
            'shiftByteString-memory-arguments-slope': 1,
            'rotateByteString-cpu-arguments-intercept': 159378,
            'rotateByteString-cpu-arguments-slope': 8813,
            'rotateByteString-memory-arguments-intercept': 0,
            'rotateByteString-memory-arguments-slope': 1,
            'countSetBits-cpu-arguments-intercept': 107490,
            'countSetBits-cpu-arguments-slope': 3298,
            'countSetBits-memory-arguments': 1,
            'findFirstSetBit-cpu-arguments-intercept': 106057,
            'findFirstSetBit-cpu-arguments-slope': 655,
            'findFirstSetBit-memory-arguments': 1,
            'ripemd_160-cpu-arguments-intercept': 1964219,
            'ripemd_160-cpu-arguments-slope': 24520,
            'ripemd_160-memory-arguments': 3,
        },
    },
    slotsPerEpoch: 432000,
};
const Preview = {
    minFeeA: 44,
    minFeeB: 155381,
    maxTxSize: 16384,
    maxValSize: 5000,
    keyDeposit: 2000000n,
    poolDeposit: 500000000n,
    drepDeposit: 500000000n,
    govActionDeposit: 100000000000n,
    priceMem: 0.0577,
    priceStep: 7.21e-5,
    maxTxExMem: 14000000n,
    maxTxExSteps: 10000000000n,
    coinsPerUtxoByte: 4310n,
    collateralPercentage: 150,
    maxCollateralInputs: 3,
    minFeeRefScriptCostPerByte: 15,
    costModels: {
        PlutusV1: {
            'addInteger-cpu-arguments-intercept': 100788,
            'addInteger-cpu-arguments-slope': 420,
            'addInteger-memory-arguments-intercept': 1,
            'addInteger-memory-arguments-slope': 1,
            'appendByteString-cpu-arguments-intercept': 1000,
            'appendByteString-cpu-arguments-slope': 173,
            'appendByteString-memory-arguments-intercept': 0,
            'appendByteString-memory-arguments-slope': 1,
            'appendString-cpu-arguments-intercept': 1000,
            'appendString-cpu-arguments-slope': 59957,
            'appendString-memory-arguments-intercept': 4,
            'appendString-memory-arguments-slope': 1,
            'bData-cpu-arguments': 11183,
            'bData-memory-arguments': 32,
            'blake2b_256-cpu-arguments-intercept': 201305,
            'blake2b_256-cpu-arguments-slope': 8356,
            'blake2b_256-memory-arguments': 4,
            'cekApplyCost-exBudgetCPU': 16000,
            'cekApplyCost-exBudgetMemory': 100,
            'cekBuiltinCost-exBudgetCPU': 16000,
            'cekBuiltinCost-exBudgetMemory': 100,
            'cekConstCost-exBudgetCPU': 16000,
            'cekConstCost-exBudgetMemory': 100,
            'cekDelayCost-exBudgetCPU': 16000,
            'cekDelayCost-exBudgetMemory': 100,
            'cekForceCost-exBudgetCPU': 16000,
            'cekForceCost-exBudgetMemory': 100,
            'cekLamCost-exBudgetCPU': 16000,
            'cekLamCost-exBudgetMemory': 100,
            'cekStartupCost-exBudgetCPU': 100,
            'cekStartupCost-exBudgetMemory': 100,
            'cekVarCost-exBudgetCPU': 16000,
            'cekVarCost-exBudgetMemory': 100,
            'chooseData-cpu-arguments': 94375,
            'chooseData-memory-arguments': 32,
            'chooseList-cpu-arguments': 132994,
            'chooseList-memory-arguments': 32,
            'chooseUnit-cpu-arguments': 61462,
            'chooseUnit-memory-arguments': 4,
            'consByteString-cpu-arguments-intercept': 72010,
            'consByteString-cpu-arguments-slope': 178,
            'consByteString-memory-arguments-intercept': 0,
            'consByteString-memory-arguments-slope': 1,
            'constrData-cpu-arguments': 22151,
            'constrData-memory-arguments': 32,
            'decodeUtf8-cpu-arguments-intercept': 91189,
            'decodeUtf8-cpu-arguments-slope': 769,
            'decodeUtf8-memory-arguments-intercept': 4,
            'decodeUtf8-memory-arguments-slope': 2,
            'divideInteger-cpu-arguments-constant': 85848,
            'divideInteger-cpu-arguments-model-arguments-intercept': 228465,
            'divideInteger-cpu-arguments-model-arguments-slope': 122,
            'divideInteger-memory-arguments-intercept': 0,
            'divideInteger-memory-arguments-minimum': 1,
            'divideInteger-memory-arguments-slope': 1,
            'encodeUtf8-cpu-arguments-intercept': 1000,
            'encodeUtf8-cpu-arguments-slope': 42921,
            'encodeUtf8-memory-arguments-intercept': 4,
            'encodeUtf8-memory-arguments-slope': 2,
            'equalsByteString-cpu-arguments-constant': 24548,
            'equalsByteString-cpu-arguments-intercept': 29498,
            'equalsByteString-cpu-arguments-slope': 38,
            'equalsByteString-memory-arguments': 1,
            'equalsData-cpu-arguments-intercept': 898148,
            'equalsData-cpu-arguments-slope': 27279,
            'equalsData-memory-arguments': 1,
            'equalsInteger-cpu-arguments-intercept': 51775,
            'equalsInteger-cpu-arguments-slope': 558,
            'equalsInteger-memory-arguments': 1,
            'equalsString-cpu-arguments-constant': 39184,
            'equalsString-cpu-arguments-intercept': 1000,
            'equalsString-cpu-arguments-slope': 60594,
            'equalsString-memory-arguments': 1,
            'fstPair-cpu-arguments': 141895,
            'fstPair-memory-arguments': 32,
            'headList-cpu-arguments': 83150,
            'headList-memory-arguments': 32,
            'iData-cpu-arguments': 15299,
            'iData-memory-arguments': 32,
            'ifThenElse-cpu-arguments': 76049,
            'ifThenElse-memory-arguments': 1,
            'indexByteString-cpu-arguments': 13169,
            'indexByteString-memory-arguments': 4,
            'lengthOfByteString-cpu-arguments': 22100,
            'lengthOfByteString-memory-arguments': 10,
            'lessThanByteString-cpu-arguments-intercept': 28999,
            'lessThanByteString-cpu-arguments-slope': 74,
            'lessThanByteString-memory-arguments': 1,
            'lessThanEqualsByteString-cpu-arguments-intercept': 28999,
            'lessThanEqualsByteString-cpu-arguments-slope': 74,
            'lessThanEqualsByteString-memory-arguments': 1,
            'lessThanEqualsInteger-cpu-arguments-intercept': 43285,
            'lessThanEqualsInteger-cpu-arguments-slope': 552,
            'lessThanEqualsInteger-memory-arguments': 1,
            'lessThanInteger-cpu-arguments-intercept': 44749,
            'lessThanInteger-cpu-arguments-slope': 541,
            'lessThanInteger-memory-arguments': 1,
            'listData-cpu-arguments': 33852,
            'listData-memory-arguments': 32,
            'mapData-cpu-arguments': 68246,
            'mapData-memory-arguments': 32,
            'mkCons-cpu-arguments': 72362,
            'mkCons-memory-arguments': 32,
            'mkNilData-cpu-arguments': 7243,
            'mkNilData-memory-arguments': 32,
            'mkNilPairData-cpu-arguments': 7391,
            'mkNilPairData-memory-arguments': 32,
            'mkPairData-cpu-arguments': 11546,
            'mkPairData-memory-arguments': 32,
            'modInteger-cpu-arguments-constant': 85848,
            'modInteger-cpu-arguments-model-arguments-intercept': 228465,
            'modInteger-cpu-arguments-model-arguments-slope': 122,
            'modInteger-memory-arguments-intercept': 0,
            'modInteger-memory-arguments-minimum': 1,
            'modInteger-memory-arguments-slope': 1,
            'multiplyInteger-cpu-arguments-intercept': 90434,
            'multiplyInteger-cpu-arguments-slope': 519,
            'multiplyInteger-memory-arguments-intercept': 0,
            'multiplyInteger-memory-arguments-slope': 1,
            'nullList-cpu-arguments': 74433,
            'nullList-memory-arguments': 32,
            'quotientInteger-cpu-arguments-constant': 85848,
            'quotientInteger-cpu-arguments-model-arguments-intercept': 228465,
            'quotientInteger-cpu-arguments-model-arguments-slope': 122,
            'quotientInteger-memory-arguments-intercept': 0,
            'quotientInteger-memory-arguments-minimum': 1,
            'quotientInteger-memory-arguments-slope': 1,
            'remainderInteger-cpu-arguments-constant': 85848,
            'remainderInteger-cpu-arguments-model-arguments-intercept': 228465,
            'remainderInteger-cpu-arguments-model-arguments-slope': 122,
            'remainderInteger-memory-arguments-intercept': 0,
            'remainderInteger-memory-arguments-minimum': 1,
            'remainderInteger-memory-arguments-slope': 1,
            'sha2_256-cpu-arguments-intercept': 270652,
            'sha2_256-cpu-arguments-slope': 22588,
            'sha2_256-memory-arguments': 4,
            'sha3_256-cpu-arguments-intercept': 1457325,
            'sha3_256-cpu-arguments-slope': 64566,
            'sha3_256-memory-arguments': 4,
            'sliceByteString-cpu-arguments-intercept': 20467,
            'sliceByteString-cpu-arguments-slope': 1,
            'sliceByteString-memory-arguments-intercept': 4,
            'sliceByteString-memory-arguments-slope': 0,
            'sndPair-cpu-arguments': 141992,
            'sndPair-memory-arguments': 32,
            'subtractInteger-cpu-arguments-intercept': 100788,
            'subtractInteger-cpu-arguments-slope': 420,
            'subtractInteger-memory-arguments-intercept': 1,
            'subtractInteger-memory-arguments-slope': 1,
            'tailList-cpu-arguments': 81663,
            'tailList-memory-arguments': 32,
            'trace-cpu-arguments': 59498,
            'trace-memory-arguments': 32,
            'unBData-cpu-arguments': 20142,
            'unBData-memory-arguments': 32,
            'unConstrData-cpu-arguments': 24588,
            'unConstrData-memory-arguments': 32,
            'unIData-cpu-arguments': 20744,
            'unIData-memory-arguments': 32,
            'unListData-cpu-arguments': 25933,
            'unListData-memory-arguments': 32,
            'unMapData-cpu-arguments': 24623,
            'unMapData-memory-arguments': 32,
            'verifyEd25519Signature-cpu-arguments-intercept': 53384111,
            'verifyEd25519Signature-cpu-arguments-slope': 14333,
            'verifyEd25519Signature-memory-arguments': 10,
        },
        PlutusV2: {
            'addInteger-cpu-arguments-intercept': 100788,
            'addInteger-cpu-arguments-slope': 420,
            'addInteger-memory-arguments-intercept': 1,
            'addInteger-memory-arguments-slope': 1,
            'appendByteString-cpu-arguments-intercept': 1000,
            'appendByteString-cpu-arguments-slope': 173,
            'appendByteString-memory-arguments-intercept': 0,
            'appendByteString-memory-arguments-slope': 1,
            'appendString-cpu-arguments-intercept': 1000,
            'appendString-cpu-arguments-slope': 59957,
            'appendString-memory-arguments-intercept': 4,
            'appendString-memory-arguments-slope': 1,
            'bData-cpu-arguments': 11183,
            'bData-memory-arguments': 32,
            'blake2b_256-cpu-arguments-intercept': 201305,
            'blake2b_256-cpu-arguments-slope': 8356,
            'blake2b_256-memory-arguments': 4,
            'cekApplyCost-exBudgetCPU': 16000,
            'cekApplyCost-exBudgetMemory': 100,
            'cekBuiltinCost-exBudgetCPU': 16000,
            'cekBuiltinCost-exBudgetMemory': 100,
            'cekConstCost-exBudgetCPU': 16000,
            'cekConstCost-exBudgetMemory': 100,
            'cekDelayCost-exBudgetCPU': 16000,
            'cekDelayCost-exBudgetMemory': 100,
            'cekForceCost-exBudgetCPU': 16000,
            'cekForceCost-exBudgetMemory': 100,
            'cekLamCost-exBudgetCPU': 16000,
            'cekLamCost-exBudgetMemory': 100,
            'cekStartupCost-exBudgetCPU': 100,
            'cekStartupCost-exBudgetMemory': 100,
            'cekVarCost-exBudgetCPU': 16000,
            'cekVarCost-exBudgetMemory': 100,
            'chooseData-cpu-arguments': 94375,
            'chooseData-memory-arguments': 32,
            'chooseList-cpu-arguments': 132994,
            'chooseList-memory-arguments': 32,
            'chooseUnit-cpu-arguments': 61462,
            'chooseUnit-memory-arguments': 4,
            'consByteString-cpu-arguments-intercept': 72010,
            'consByteString-cpu-arguments-slope': 178,
            'consByteString-memory-arguments-intercept': 0,
            'consByteString-memory-arguments-slope': 1,
            'constrData-cpu-arguments': 22151,
            'constrData-memory-arguments': 32,
            'decodeUtf8-cpu-arguments-intercept': 91189,
            'decodeUtf8-cpu-arguments-slope': 769,
            'decodeUtf8-memory-arguments-intercept': 4,
            'decodeUtf8-memory-arguments-slope': 2,
            'divideInteger-cpu-arguments-constant': 85848,
            'divideInteger-cpu-arguments-model-arguments-intercept': 228465,
            'divideInteger-cpu-arguments-model-arguments-slope': 122,
            'divideInteger-memory-arguments-intercept': 0,
            'divideInteger-memory-arguments-minimum': 1,
            'divideInteger-memory-arguments-slope': 1,
            'encodeUtf8-cpu-arguments-intercept': 1000,
            'encodeUtf8-cpu-arguments-slope': 42921,
            'encodeUtf8-memory-arguments-intercept': 4,
            'encodeUtf8-memory-arguments-slope': 2,
            'equalsByteString-cpu-arguments-constant': 24548,
            'equalsByteString-cpu-arguments-intercept': 29498,
            'equalsByteString-cpu-arguments-slope': 38,
            'equalsByteString-memory-arguments': 1,
            'equalsData-cpu-arguments-intercept': 898148,
            'equalsData-cpu-arguments-slope': 27279,
            'equalsData-memory-arguments': 1,
            'equalsInteger-cpu-arguments-intercept': 51775,
            'equalsInteger-cpu-arguments-slope': 558,
            'equalsInteger-memory-arguments': 1,
            'equalsString-cpu-arguments-constant': 39184,
            'equalsString-cpu-arguments-intercept': 1000,
            'equalsString-cpu-arguments-slope': 60594,
            'equalsString-memory-arguments': 1,
            'fstPair-cpu-arguments': 141895,
            'fstPair-memory-arguments': 32,
            'headList-cpu-arguments': 83150,
            'headList-memory-arguments': 32,
            'iData-cpu-arguments': 15299,
            'iData-memory-arguments': 32,
            'ifThenElse-cpu-arguments': 76049,
            'ifThenElse-memory-arguments': 1,
            'indexByteString-cpu-arguments': 13169,
            'indexByteString-memory-arguments': 4,
            'lengthOfByteString-cpu-arguments': 22100,
            'lengthOfByteString-memory-arguments': 10,
            'lessThanByteString-cpu-arguments-intercept': 28999,
            'lessThanByteString-cpu-arguments-slope': 74,
            'lessThanByteString-memory-arguments': 1,
            'lessThanEqualsByteString-cpu-arguments-intercept': 28999,
            'lessThanEqualsByteString-cpu-arguments-slope': 74,
            'lessThanEqualsByteString-memory-arguments': 1,
            'lessThanEqualsInteger-cpu-arguments-intercept': 43285,
            'lessThanEqualsInteger-cpu-arguments-slope': 552,
            'lessThanEqualsInteger-memory-arguments': 1,
            'lessThanInteger-cpu-arguments-intercept': 44749,
            'lessThanInteger-cpu-arguments-slope': 541,
            'lessThanInteger-memory-arguments': 1,
            'listData-cpu-arguments': 33852,
            'listData-memory-arguments': 32,
            'mapData-cpu-arguments': 68246,
            'mapData-memory-arguments': 32,
            'mkCons-cpu-arguments': 72362,
            'mkCons-memory-arguments': 32,
            'mkNilData-cpu-arguments': 7243,
            'mkNilData-memory-arguments': 32,
            'mkNilPairData-cpu-arguments': 7391,
            'mkNilPairData-memory-arguments': 32,
            'mkPairData-cpu-arguments': 11546,
            'mkPairData-memory-arguments': 32,
            'modInteger-cpu-arguments-constant': 85848,
            'modInteger-cpu-arguments-model-arguments-intercept': 228465,
            'modInteger-cpu-arguments-model-arguments-slope': 122,
            'modInteger-memory-arguments-intercept': 0,
            'modInteger-memory-arguments-minimum': 1,
            'modInteger-memory-arguments-slope': 1,
            'multiplyInteger-cpu-arguments-intercept': 90434,
            'multiplyInteger-cpu-arguments-slope': 519,
            'multiplyInteger-memory-arguments-intercept': 0,
            'multiplyInteger-memory-arguments-slope': 1,
            'nullList-cpu-arguments': 74433,
            'nullList-memory-arguments': 32,
            'quotientInteger-cpu-arguments-constant': 85848,
            'quotientInteger-cpu-arguments-model-arguments-intercept': 228465,
            'quotientInteger-cpu-arguments-model-arguments-slope': 122,
            'quotientInteger-memory-arguments-intercept': 0,
            'quotientInteger-memory-arguments-minimum': 1,
            'quotientInteger-memory-arguments-slope': 1,
            'remainderInteger-cpu-arguments-constant': 85848,
            'remainderInteger-cpu-arguments-model-arguments-intercept': 228465,
            'remainderInteger-cpu-arguments-model-arguments-slope': 122,
            'remainderInteger-memory-arguments-intercept': 0,
            'remainderInteger-memory-arguments-minimum': 1,
            'remainderInteger-memory-arguments-slope': 1,
            'serialiseData-cpu-arguments-intercept': 955506,
            'serialiseData-cpu-arguments-slope': 213312,
            'serialiseData-memory-arguments-intercept': 0,
            'serialiseData-memory-arguments-slope': 2,
            'sha2_256-cpu-arguments-intercept': 270652,
            'sha2_256-cpu-arguments-slope': 22588,
            'sha2_256-memory-arguments': 4,
            'sha3_256-cpu-arguments-intercept': 1457325,
            'sha3_256-cpu-arguments-slope': 64566,
            'sha3_256-memory-arguments': 4,
            'sliceByteString-cpu-arguments-intercept': 20467,
            'sliceByteString-cpu-arguments-slope': 1,
            'sliceByteString-memory-arguments-intercept': 4,
            'sliceByteString-memory-arguments-slope': 0,
            'sndPair-cpu-arguments': 141992,
            'sndPair-memory-arguments': 32,
            'subtractInteger-cpu-arguments-intercept': 100788,
            'subtractInteger-cpu-arguments-slope': 420,
            'subtractInteger-memory-arguments-intercept': 1,
            'subtractInteger-memory-arguments-slope': 1,
            'tailList-cpu-arguments': 81663,
            'tailList-memory-arguments': 32,
            'trace-cpu-arguments': 59498,
            'trace-memory-arguments': 32,
            'unBData-cpu-arguments': 20142,
            'unBData-memory-arguments': 32,
            'unConstrData-cpu-arguments': 24588,
            'unConstrData-memory-arguments': 32,
            'unIData-cpu-arguments': 20744,
            'unIData-memory-arguments': 32,
            'unListData-cpu-arguments': 25933,
            'unListData-memory-arguments': 32,
            'unMapData-cpu-arguments': 24623,
            'unMapData-memory-arguments': 32,
            'verifyEcdsaSecp256k1Signature-cpu-arguments': 43053543,
            'verifyEcdsaSecp256k1Signature-memory-arguments': 10,
            'verifyEd25519Signature-cpu-arguments-intercept': 53384111,
            'verifyEd25519Signature-cpu-arguments-slope': 14333,
            'verifyEd25519Signature-memory-arguments': 10,
            'verifySchnorrSecp256k1Signature-cpu-arguments-intercept': 43574283,
            'verifySchnorrSecp256k1Signature-cpu-arguments-slope': 26308,
            'verifySchnorrSecp256k1Signature-memory-arguments': 10,
        },
        PlutusV3: {
            'addInteger-cpu-arguments-intercept': 100788,
            'addInteger-cpu-arguments-slope': 420,
            'addInteger-memory-arguments-intercept': 1,
            'addInteger-memory-arguments-slope': 1,
            'appendByteString-cpu-arguments-intercept': 1000,
            'appendByteString-cpu-arguments-slope': 173,
            'appendByteString-memory-arguments-intercept': 0,
            'appendByteString-memory-arguments-slope': 1,
            'appendString-cpu-arguments-intercept': 1000,
            'appendString-cpu-arguments-slope': 59957,
            'appendString-memory-arguments-intercept': 4,
            'appendString-memory-arguments-slope': 1,
            'bData-cpu-arguments': 11183,
            'bData-memory-arguments': 32,
            'blake2b_256-cpu-arguments-intercept': 201305,
            'blake2b_256-cpu-arguments-slope': 8356,
            'blake2b_256-memory-arguments': 4,
            'cekApplyCost-exBudgetCPU': 16000,
            'cekApplyCost-exBudgetMemory': 100,
            'cekBuiltinCost-exBudgetCPU': 16000,
            'cekBuiltinCost-exBudgetMemory': 100,
            'cekConstCost-exBudgetCPU': 16000,
            'cekConstCost-exBudgetMemory': 100,
            'cekDelayCost-exBudgetCPU': 16000,
            'cekDelayCost-exBudgetMemory': 100,
            'cekForceCost-exBudgetCPU': 16000,
            'cekForceCost-exBudgetMemory': 100,
            'cekLamCost-exBudgetCPU': 16000,
            'cekLamCost-exBudgetMemory': 100,
            'cekStartupCost-exBudgetCPU': 100,
            'cekStartupCost-exBudgetMemory': 100,
            'cekVarCost-exBudgetCPU': 16000,
            'cekVarCost-exBudgetMemory': 100,
            'chooseData-cpu-arguments': 94375,
            'chooseData-memory-arguments': 32,
            'chooseList-cpu-arguments': 132994,
            'chooseList-memory-arguments': 32,
            'chooseUnit-cpu-arguments': 61462,
            'chooseUnit-memory-arguments': 4,
            'consByteString-cpu-arguments-intercept': 72010,
            'consByteString-cpu-arguments-slope': 178,
            'consByteString-memory-arguments-intercept': 0,
            'consByteString-memory-arguments-slope': 1,
            'constrData-cpu-arguments': 22151,
            'constrData-memory-arguments': 32,
            'decodeUtf8-cpu-arguments-intercept': 91189,
            'decodeUtf8-cpu-arguments-slope': 769,
            'decodeUtf8-memory-arguments-intercept': 4,
            'decodeUtf8-memory-arguments-slope': 2,
            'divideInteger-cpu-arguments-constant': 85848,
            'divideInteger-cpu-arguments-model-arguments-c00': 123203,
            'divideInteger-cpu-arguments-model-arguments-c01': 7305,
            'divideInteger-cpu-arguments-model-arguments-c02': -900,
            'divideInteger-cpu-arguments-model-arguments-c10': 1716,
            'divideInteger-cpu-arguments-model-arguments-c11': 549,
            'divideInteger-cpu-arguments-model-arguments-c20': 57,
            'divideInteger-cpu-arguments-model-arguments-minimum': 85848,
            'divideInteger-memory-arguments-intercept': 0,
            'divideInteger-memory-arguments-minimum': 1,
            'divideInteger-memory-arguments-slope': 1,
            'encodeUtf8-cpu-arguments-intercept': 1000,
            'encodeUtf8-cpu-arguments-slope': 42921,
            'encodeUtf8-memory-arguments-intercept': 4,
            'encodeUtf8-memory-arguments-slope': 2,
            'equalsByteString-cpu-arguments-constant': 24548,
            'equalsByteString-cpu-arguments-intercept': 29498,
            'equalsByteString-cpu-arguments-slope': 38,
            'equalsByteString-memory-arguments': 1,
            'equalsData-cpu-arguments-intercept': 898148,
            'equalsData-cpu-arguments-slope': 27279,
            'equalsData-memory-arguments': 1,
            'equalsInteger-cpu-arguments-intercept': 51775,
            'equalsInteger-cpu-arguments-slope': 558,
            'equalsInteger-memory-arguments': 1,
            'equalsString-cpu-arguments-constant': 39184,
            'equalsString-cpu-arguments-intercept': 1000,
            'equalsString-cpu-arguments-slope': 60594,
            'equalsString-memory-arguments': 1,
            'fstPair-cpu-arguments': 141895,
            'fstPair-memory-arguments': 32,
            'headList-cpu-arguments': 83150,
            'headList-memory-arguments': 32,
            'iData-cpu-arguments': 15299,
            'iData-memory-arguments': 32,
            'ifThenElse-cpu-arguments': 76049,
            'ifThenElse-memory-arguments': 1,
            'indexByteString-cpu-arguments': 13169,
            'indexByteString-memory-arguments': 4,
            'lengthOfByteString-cpu-arguments': 22100,
            'lengthOfByteString-memory-arguments': 10,
            'lessThanByteString-cpu-arguments-intercept': 28999,
            'lessThanByteString-cpu-arguments-slope': 74,
            'lessThanByteString-memory-arguments': 1,
            'lessThanEqualsByteString-cpu-arguments-intercept': 28999,
            'lessThanEqualsByteString-cpu-arguments-slope': 74,
            'lessThanEqualsByteString-memory-arguments': 1,
            'lessThanEqualsInteger-cpu-arguments-intercept': 43285,
            'lessThanEqualsInteger-cpu-arguments-slope': 552,
            'lessThanEqualsInteger-memory-arguments': 1,
            'lessThanInteger-cpu-arguments-intercept': 44749,
            'lessThanInteger-cpu-arguments-slope': 541,
            'lessThanInteger-memory-arguments': 1,
            'listData-cpu-arguments': 33852,
            'listData-memory-arguments': 32,
            'mapData-cpu-arguments': 68246,
            'mapData-memory-arguments': 32,
            'mkCons-cpu-arguments': 72362,
            'mkCons-memory-arguments': 32,
            'mkNilData-cpu-arguments': 7243,
            'mkNilData-memory-arguments': 32,
            'mkNilPairData-cpu-arguments': 7391,
            'mkNilPairData-memory-arguments': 32,
            'mkPairData-cpu-arguments': 11546,
            'mkPairData-memory-arguments': 32,
            'modInteger-cpu-arguments-constant': 85848,
            'modInteger-cpu-arguments-model-arguments-c00': 123203,
            'modInteger-cpu-arguments-model-arguments-c01': 7305,
            'modInteger-cpu-arguments-model-arguments-c02': -900,
            'modInteger-cpu-arguments-model-arguments-c10': 1716,
            'modInteger-cpu-arguments-model-arguments-c11': 549,
            'modInteger-cpu-arguments-model-arguments-c20': 57,
            'modInteger-cpu-arguments-model-arguments-minimum': 85848,
            'modInteger-memory-arguments-intercept': 0,
            'modInteger-memory-arguments-slope': 1,
            'multiplyInteger-cpu-arguments-intercept': 90434,
            'multiplyInteger-cpu-arguments-slope': 519,
            'multiplyInteger-memory-arguments-intercept': 0,
            'multiplyInteger-memory-arguments-slope': 1,
            'nullList-cpu-arguments': 74433,
            'nullList-memory-arguments': 32,
            'quotientInteger-cpu-arguments-constant': 85848,
            'quotientInteger-cpu-arguments-model-arguments-c00': 123203,
            'quotientInteger-cpu-arguments-model-arguments-c01': 7305,
            'quotientInteger-cpu-arguments-model-arguments-c02': -900,
            'quotientInteger-cpu-arguments-model-arguments-c10': 1716,
            'quotientInteger-cpu-arguments-model-arguments-c11': 549,
            'quotientInteger-cpu-arguments-model-arguments-c20': 57,
            'quotientInteger-cpu-arguments-model-arguments-minimum': 85848,
            'quotientInteger-memory-arguments-intercept': 0,
            'quotientInteger-memory-arguments-slope': 1,
            'remainderInteger-cpu-arguments-constant': 1,
            'remainderInteger-cpu-arguments-model-arguments-c00': 85848,
            'remainderInteger-cpu-arguments-model-arguments-c01': 123203,
            'remainderInteger-cpu-arguments-model-arguments-c02': 7305,
            'remainderInteger-cpu-arguments-model-arguments-c10': -900,
            'remainderInteger-cpu-arguments-model-arguments-c11': 1716,
            'remainderInteger-cpu-arguments-model-arguments-c20': 549,
            'remainderInteger-cpu-arguments-model-arguments-minimum': 57,
            'remainderInteger-memory-arguments-intercept': 85848,
            'remainderInteger-memory-arguments-minimum': 0,
            'remainderInteger-memory-arguments-slope': 1,
            'serialiseData-cpu-arguments-intercept': 955506,
            'serialiseData-cpu-arguments-slope': 213312,
            'serialiseData-memory-arguments-intercept': 0,
            'serialiseData-memory-arguments-slope': 2,
            'sha2_256-cpu-arguments-intercept': 270652,
            'sha2_256-cpu-arguments-slope': 22588,
            'sha2_256-memory-arguments': 4,
            'sha3_256-cpu-arguments-intercept': 1457325,
            'sha3_256-cpu-arguments-slope': 64566,
            'sha3_256-memory-arguments': 4,
            'sliceByteString-cpu-arguments-intercept': 20467,
            'sliceByteString-cpu-arguments-slope': 1,
            'sliceByteString-memory-arguments-intercept': 4,
            'sliceByteString-memory-arguments-slope': 0,
            'sndPair-cpu-arguments': 141992,
            'sndPair-memory-arguments': 32,
            'subtractInteger-cpu-arguments-intercept': 100788,
            'subtractInteger-cpu-arguments-slope': 420,
            'subtractInteger-memory-arguments-intercept': 1,
            'subtractInteger-memory-arguments-slope': 1,
            'tailList-cpu-arguments': 81663,
            'tailList-memory-arguments': 32,
            'trace-cpu-arguments': 59498,
            'trace-memory-arguments': 32,
            'unBData-cpu-arguments': 20142,
            'unBData-memory-arguments': 32,
            'unConstrData-cpu-arguments': 24588,
            'unConstrData-memory-arguments': 32,
            'unIData-cpu-arguments': 20744,
            'unIData-memory-arguments': 32,
            'unListData-cpu-arguments': 25933,
            'unListData-memory-arguments': 32,
            'unMapData-cpu-arguments': 24623,
            'unMapData-memory-arguments': 32,
            'verifyEcdsaSecp256k1Signature-cpu-arguments': 43053543,
            'verifyEcdsaSecp256k1Signature-memory-arguments': 10,
            'verifyEd25519Signature-cpu-arguments-intercept': 53384111,
            'verifyEd25519Signature-cpu-arguments-slope': 14333,
            'verifyEd25519Signature-memory-arguments': 10,
            'verifySchnorrSecp256k1Signature-cpu-arguments-intercept': 43574283,
            'verifySchnorrSecp256k1Signature-cpu-arguments-slope': 26308,
            'verifySchnorrSecp256k1Signature-memory-arguments': 10,
            'cekConstrCost-exBudgetCPU': 16000,
            'cekConstrCost-exBudgetMemory': 100,
            'cekCaseCost-exBudgetCPU': 16000,
            'cekCaseCost-exBudgetMemory': 100,
            'bls12_381_G1_add-cpu-arguments': 962335,
            'bls12_381_G1_add-memory-arguments': 18,
            'bls12_381_G1_compress-cpu-arguments': 2780678,
            'bls12_381_G1_compress-memory-arguments': 6,
            'bls12_381_G1_equal-cpu-arguments': 442008,
            'bls12_381_G1_equal-memory-arguments': 1,
            'bls12_381_G1_hashToGroup-cpu-arguments-intercept': 52538055,
            'bls12_381_G1_hashToGroup-cpu-arguments-slope': 3756,
            'bls12_381_G1_hashToGroup-memory-arguments': 18,
            'bls12_381_G1_neg-cpu-arguments': 267929,
            'bls12_381_G1_neg-memory-arguments': 18,
            'bls12_381_G1_scalarMul-cpu-arguments-intercept': 76433006,
            'bls12_381_G1_scalarMul-cpu-arguments-slope': 8868,
            'bls12_381_G1_scalarMul-memory-arguments': 18,
            'bls12_381_G1_uncompress-cpu-arguments': 52948122,
            'bls12_381_G1_uncompress-memory-arguments': 18,
            'bls12_381_G2_add-cpu-arguments': 1995836,
            'bls12_381_G2_add-memory-arguments': 36,
            'bls12_381_G2_compress-cpu-arguments': 3227919,
            'bls12_381_G2_compress-memory-arguments': 12,
            'bls12_381_G2_equal-cpu-arguments': 901022,
            'bls12_381_G2_equal-memory-arguments': 1,
            'bls12_381_G2_hashToGroup-cpu-arguments-intercept': 166917843,
            'bls12_381_G2_hashToGroup-cpu-arguments-slope': 4307,
            'bls12_381_G2_hashToGroup-memory-arguments': 36,
            'bls12_381_G2_neg-cpu-arguments': 284546,
            'bls12_381_G2_neg-memory-arguments': 36,
            'bls12_381_G2_scalarMul-cpu-arguments-intercept': 158221314,
            'bls12_381_G2_scalarMul-cpu-arguments-slope': 26549,
            'bls12_381_G2_scalarMul-memory-arguments': 36,
            'bls12_381_G2_uncompress-cpu-arguments': 74698472,
            'bls12_381_G2_uncompress-memory-arguments': 36,
            'bls12_381_finalVerify-cpu-arguments': 333849714,
            'bls12_381_finalVerify-memory-arguments': 1,
            'bls12_381_millerLoop-cpu-arguments': 254006273,
            'bls12_381_millerLoop-memory-arguments': 72,
            'bls12_381_mulMlResult-cpu-arguments': 2174038,
            'bls12_381_mulMlResult-memory-arguments': 72,
            'keccak_256-cpu-arguments-intercept': 2261318,
            'keccak_256-cpu-arguments-slope': 64571,
            'keccak_256-memory-arguments': 4,
            'blake2b_224-cpu-arguments-intercept': 207616,
            'blake2b_224-cpu-arguments-slope': 8310,
            'blake2b_224-memory-arguments': 4,
            'integerToByteString-cpu-arguments-c0': 1293828,
            'integerToByteString-cpu-arguments-c1': 28716,
            'integerToByteString-cpu-arguments-c2': 63,
            'integerToByteString-memory-arguments-intercept': 0,
            'integerToByteString-memory-arguments-slope': 1,
            'byteStringToInteger-cpu-arguments-c0': 1006041,
            'byteStringToInteger-cpu-arguments-c1': 43623,
            'byteStringToInteger-cpu-arguments-c2': 251,
            'byteStringToInteger-memory-arguments-intercept': 0,
            'byteStringToInteger-memory-arguments-slope': 1,
            'andByteString-cpu-arguments-intercept': 100181,
            'andByteString-cpu-arguments-slope1': 726,
            'andByteString-cpu-arguments-slope2': 719,
            'andByteString-memory-arguments-intercept': 0,
            'andByteString-memory-arguments-slope': 1,
            'orByteString-cpu-arguments-intercept': 100181,
            'orByteString-cpu-arguments-slope1': 726,
            'orByteString-cpu-arguments-slope2': 719,
            'orByteString-memory-arguments-intercept': 0,
            'orByteString-memory-arguments-slope': 1,
            'xorByteString-cpu-arguments-intercept': 100181,
            'xorByteString-cpu-arguments-slope1': 726,
            'xorByteString-cpu-arguments-slope2': 719,
            'xorByteString-memory-arguments-intercept': 0,
            'xorByteString-memory-arguments-slope': 1,
            'complementByteString-cpu-arguments-intercept': 107878,
            'complementByteString-cpu-arguments-slope': 680,
            'complementByteString-memory-arguments-intercept': 0,
            'complementByteString-memory-arguments-slope': 1,
            'readBit-cpu-arguments': 95336,
            'readBit-memory-arguments': 1,
            'writeBits-cpu-arguments-intercept': 281145,
            'writeBits-cpu-arguments-slope': 18848,
            'writeBits-memory-arguments-intercept': 0,
            'writeBits-memory-arguments-slope': 1,
            'replicateByte-cpu-arguments-intercept': 180194,
            'replicateByte-cpu-arguments-slope': 159,
            'replicateByte-memory-arguments-intercept': 1,
            'replicateByte-memory-arguments-slope': 1,
            'shiftByteString-cpu-arguments-intercept': 158519,
            'shiftByteString-cpu-arguments-slope': 8942,
            'shiftByteString-memory-arguments-intercept': 0,
            'shiftByteString-memory-arguments-slope': 1,
            'rotateByteString-cpu-arguments-intercept': 159378,
            'rotateByteString-cpu-arguments-slope': 8813,
            'rotateByteString-memory-arguments-intercept': 0,
            'rotateByteString-memory-arguments-slope': 1,
            'countSetBits-cpu-arguments-intercept': 107490,
            'countSetBits-cpu-arguments-slope': 3298,
            'countSetBits-memory-arguments': 1,
            'findFirstSetBit-cpu-arguments-intercept': 106057,
            'findFirstSetBit-cpu-arguments-slope': 655,
            'findFirstSetBit-memory-arguments': 1,
            'ripemd_160-cpu-arguments-intercept': 1964219,
            'ripemd_160-cpu-arguments-slope': 24520,
            'ripemd_160-memory-arguments': 3,
        },
    },
    slotsPerEpoch: 86400,
};
const Preprod = {
    minFeeA: 44,
    minFeeB: 155381,
    maxTxSize: 16384,
    maxValSize: 5000,
    keyDeposit: 2000000n,
    poolDeposit: 500000000n,
    drepDeposit: 500000000n,
    govActionDeposit: 100000000000n,
    priceMem: 0.0577,
    priceStep: 7.21e-5,
    maxTxExMem: 14000000n,
    maxTxExSteps: 10000000000n,
    coinsPerUtxoByte: 4310n,
    collateralPercentage: 150,
    maxCollateralInputs: 3,
    minFeeRefScriptCostPerByte: 15,
    costModels: {
        PlutusV1: {
            'addInteger-cpu-arguments-intercept': 100788,
            'addInteger-cpu-arguments-slope': 420,
            'addInteger-memory-arguments-intercept': 1,
            'addInteger-memory-arguments-slope': 1,
            'appendByteString-cpu-arguments-intercept': 1000,
            'appendByteString-cpu-arguments-slope': 173,
            'appendByteString-memory-arguments-intercept': 0,
            'appendByteString-memory-arguments-slope': 1,
            'appendString-cpu-arguments-intercept': 1000,
            'appendString-cpu-arguments-slope': 59957,
            'appendString-memory-arguments-intercept': 4,
            'appendString-memory-arguments-slope': 1,
            'bData-cpu-arguments': 11183,
            'bData-memory-arguments': 32,
            'blake2b_256-cpu-arguments-intercept': 201305,
            'blake2b_256-cpu-arguments-slope': 8356,
            'blake2b_256-memory-arguments': 4,
            'cekApplyCost-exBudgetCPU': 16000,
            'cekApplyCost-exBudgetMemory': 100,
            'cekBuiltinCost-exBudgetCPU': 16000,
            'cekBuiltinCost-exBudgetMemory': 100,
            'cekConstCost-exBudgetCPU': 16000,
            'cekConstCost-exBudgetMemory': 100,
            'cekDelayCost-exBudgetCPU': 16000,
            'cekDelayCost-exBudgetMemory': 100,
            'cekForceCost-exBudgetCPU': 16000,
            'cekForceCost-exBudgetMemory': 100,
            'cekLamCost-exBudgetCPU': 16000,
            'cekLamCost-exBudgetMemory': 100,
            'cekStartupCost-exBudgetCPU': 100,
            'cekStartupCost-exBudgetMemory': 100,
            'cekVarCost-exBudgetCPU': 16000,
            'cekVarCost-exBudgetMemory': 100,
            'chooseData-cpu-arguments': 94375,
            'chooseData-memory-arguments': 32,
            'chooseList-cpu-arguments': 132994,
            'chooseList-memory-arguments': 32,
            'chooseUnit-cpu-arguments': 61462,
            'chooseUnit-memory-arguments': 4,
            'consByteString-cpu-arguments-intercept': 72010,
            'consByteString-cpu-arguments-slope': 178,
            'consByteString-memory-arguments-intercept': 0,
            'consByteString-memory-arguments-slope': 1,
            'constrData-cpu-arguments': 22151,
            'constrData-memory-arguments': 32,
            'decodeUtf8-cpu-arguments-intercept': 91189,
            'decodeUtf8-cpu-arguments-slope': 769,
            'decodeUtf8-memory-arguments-intercept': 4,
            'decodeUtf8-memory-arguments-slope': 2,
            'divideInteger-cpu-arguments-constant': 85848,
            'divideInteger-cpu-arguments-model-arguments-intercept': 228465,
            'divideInteger-cpu-arguments-model-arguments-slope': 122,
            'divideInteger-memory-arguments-intercept': 0,
            'divideInteger-memory-arguments-minimum': 1,
            'divideInteger-memory-arguments-slope': 1,
            'encodeUtf8-cpu-arguments-intercept': 1000,
            'encodeUtf8-cpu-arguments-slope': 42921,
            'encodeUtf8-memory-arguments-intercept': 4,
            'encodeUtf8-memory-arguments-slope': 2,
            'equalsByteString-cpu-arguments-constant': 24548,
            'equalsByteString-cpu-arguments-intercept': 29498,
            'equalsByteString-cpu-arguments-slope': 38,
            'equalsByteString-memory-arguments': 1,
            'equalsData-cpu-arguments-intercept': 898148,
            'equalsData-cpu-arguments-slope': 27279,
            'equalsData-memory-arguments': 1,
            'equalsInteger-cpu-arguments-intercept': 51775,
            'equalsInteger-cpu-arguments-slope': 558,
            'equalsInteger-memory-arguments': 1,
            'equalsString-cpu-arguments-constant': 39184,
            'equalsString-cpu-arguments-intercept': 1000,
            'equalsString-cpu-arguments-slope': 60594,
            'equalsString-memory-arguments': 1,
            'fstPair-cpu-arguments': 141895,
            'fstPair-memory-arguments': 32,
            'headList-cpu-arguments': 83150,
            'headList-memory-arguments': 32,
            'iData-cpu-arguments': 15299,
            'iData-memory-arguments': 32,
            'ifThenElse-cpu-arguments': 76049,
            'ifThenElse-memory-arguments': 1,
            'indexByteString-cpu-arguments': 13169,
            'indexByteString-memory-arguments': 4,
            'lengthOfByteString-cpu-arguments': 22100,
            'lengthOfByteString-memory-arguments': 10,
            'lessThanByteString-cpu-arguments-intercept': 28999,
            'lessThanByteString-cpu-arguments-slope': 74,
            'lessThanByteString-memory-arguments': 1,
            'lessThanEqualsByteString-cpu-arguments-intercept': 28999,
            'lessThanEqualsByteString-cpu-arguments-slope': 74,
            'lessThanEqualsByteString-memory-arguments': 1,
            'lessThanEqualsInteger-cpu-arguments-intercept': 43285,
            'lessThanEqualsInteger-cpu-arguments-slope': 552,
            'lessThanEqualsInteger-memory-arguments': 1,
            'lessThanInteger-cpu-arguments-intercept': 44749,
            'lessThanInteger-cpu-arguments-slope': 541,
            'lessThanInteger-memory-arguments': 1,
            'listData-cpu-arguments': 33852,
            'listData-memory-arguments': 32,
            'mapData-cpu-arguments': 68246,
            'mapData-memory-arguments': 32,
            'mkCons-cpu-arguments': 72362,
            'mkCons-memory-arguments': 32,
            'mkNilData-cpu-arguments': 7243,
            'mkNilData-memory-arguments': 32,
            'mkNilPairData-cpu-arguments': 7391,
            'mkNilPairData-memory-arguments': 32,
            'mkPairData-cpu-arguments': 11546,
            'mkPairData-memory-arguments': 32,
            'modInteger-cpu-arguments-constant': 85848,
            'modInteger-cpu-arguments-model-arguments-intercept': 228465,
            'modInteger-cpu-arguments-model-arguments-slope': 122,
            'modInteger-memory-arguments-intercept': 0,
            'modInteger-memory-arguments-minimum': 1,
            'modInteger-memory-arguments-slope': 1,
            'multiplyInteger-cpu-arguments-intercept': 90434,
            'multiplyInteger-cpu-arguments-slope': 519,
            'multiplyInteger-memory-arguments-intercept': 0,
            'multiplyInteger-memory-arguments-slope': 1,
            'nullList-cpu-arguments': 74433,
            'nullList-memory-arguments': 32,
            'quotientInteger-cpu-arguments-constant': 85848,
            'quotientInteger-cpu-arguments-model-arguments-intercept': 228465,
            'quotientInteger-cpu-arguments-model-arguments-slope': 122,
            'quotientInteger-memory-arguments-intercept': 0,
            'quotientInteger-memory-arguments-minimum': 1,
            'quotientInteger-memory-arguments-slope': 1,
            'remainderInteger-cpu-arguments-constant': 85848,
            'remainderInteger-cpu-arguments-model-arguments-intercept': 228465,
            'remainderInteger-cpu-arguments-model-arguments-slope': 122,
            'remainderInteger-memory-arguments-intercept': 0,
            'remainderInteger-memory-arguments-minimum': 1,
            'remainderInteger-memory-arguments-slope': 1,
            'sha2_256-cpu-arguments-intercept': 270652,
            'sha2_256-cpu-arguments-slope': 22588,
            'sha2_256-memory-arguments': 4,
            'sha3_256-cpu-arguments-intercept': 1457325,
            'sha3_256-cpu-arguments-slope': 64566,
            'sha3_256-memory-arguments': 4,
            'sliceByteString-cpu-arguments-intercept': 20467,
            'sliceByteString-cpu-arguments-slope': 1,
            'sliceByteString-memory-arguments-intercept': 4,
            'sliceByteString-memory-arguments-slope': 0,
            'sndPair-cpu-arguments': 141992,
            'sndPair-memory-arguments': 32,
            'subtractInteger-cpu-arguments-intercept': 100788,
            'subtractInteger-cpu-arguments-slope': 420,
            'subtractInteger-memory-arguments-intercept': 1,
            'subtractInteger-memory-arguments-slope': 1,
            'tailList-cpu-arguments': 81663,
            'tailList-memory-arguments': 32,
            'trace-cpu-arguments': 59498,
            'trace-memory-arguments': 32,
            'unBData-cpu-arguments': 20142,
            'unBData-memory-arguments': 32,
            'unConstrData-cpu-arguments': 24588,
            'unConstrData-memory-arguments': 32,
            'unIData-cpu-arguments': 20744,
            'unIData-memory-arguments': 32,
            'unListData-cpu-arguments': 25933,
            'unListData-memory-arguments': 32,
            'unMapData-cpu-arguments': 24623,
            'unMapData-memory-arguments': 32,
            'verifyEd25519Signature-cpu-arguments-intercept': 53384111,
            'verifyEd25519Signature-cpu-arguments-slope': 14333,
            'verifyEd25519Signature-memory-arguments': 10,
        },
        PlutusV2: {
            'addInteger-cpu-arguments-intercept': 100788,
            'addInteger-cpu-arguments-slope': 420,
            'addInteger-memory-arguments-intercept': 1,
            'addInteger-memory-arguments-slope': 1,
            'appendByteString-cpu-arguments-intercept': 1000,
            'appendByteString-cpu-arguments-slope': 173,
            'appendByteString-memory-arguments-intercept': 0,
            'appendByteString-memory-arguments-slope': 1,
            'appendString-cpu-arguments-intercept': 1000,
            'appendString-cpu-arguments-slope': 59957,
            'appendString-memory-arguments-intercept': 4,
            'appendString-memory-arguments-slope': 1,
            'bData-cpu-arguments': 11183,
            'bData-memory-arguments': 32,
            'blake2b_256-cpu-arguments-intercept': 201305,
            'blake2b_256-cpu-arguments-slope': 8356,
            'blake2b_256-memory-arguments': 4,
            'cekApplyCost-exBudgetCPU': 16000,
            'cekApplyCost-exBudgetMemory': 100,
            'cekBuiltinCost-exBudgetCPU': 16000,
            'cekBuiltinCost-exBudgetMemory': 100,
            'cekConstCost-exBudgetCPU': 16000,
            'cekConstCost-exBudgetMemory': 100,
            'cekDelayCost-exBudgetCPU': 16000,
            'cekDelayCost-exBudgetMemory': 100,
            'cekForceCost-exBudgetCPU': 16000,
            'cekForceCost-exBudgetMemory': 100,
            'cekLamCost-exBudgetCPU': 16000,
            'cekLamCost-exBudgetMemory': 100,
            'cekStartupCost-exBudgetCPU': 100,
            'cekStartupCost-exBudgetMemory': 100,
            'cekVarCost-exBudgetCPU': 16000,
            'cekVarCost-exBudgetMemory': 100,
            'chooseData-cpu-arguments': 94375,
            'chooseData-memory-arguments': 32,
            'chooseList-cpu-arguments': 132994,
            'chooseList-memory-arguments': 32,
            'chooseUnit-cpu-arguments': 61462,
            'chooseUnit-memory-arguments': 4,
            'consByteString-cpu-arguments-intercept': 72010,
            'consByteString-cpu-arguments-slope': 178,
            'consByteString-memory-arguments-intercept': 0,
            'consByteString-memory-arguments-slope': 1,
            'constrData-cpu-arguments': 22151,
            'constrData-memory-arguments': 32,
            'decodeUtf8-cpu-arguments-intercept': 91189,
            'decodeUtf8-cpu-arguments-slope': 769,
            'decodeUtf8-memory-arguments-intercept': 4,
            'decodeUtf8-memory-arguments-slope': 2,
            'divideInteger-cpu-arguments-constant': 85848,
            'divideInteger-cpu-arguments-model-arguments-intercept': 228465,
            'divideInteger-cpu-arguments-model-arguments-slope': 122,
            'divideInteger-memory-arguments-intercept': 0,
            'divideInteger-memory-arguments-minimum': 1,
            'divideInteger-memory-arguments-slope': 1,
            'encodeUtf8-cpu-arguments-intercept': 1000,
            'encodeUtf8-cpu-arguments-slope': 42921,
            'encodeUtf8-memory-arguments-intercept': 4,
            'encodeUtf8-memory-arguments-slope': 2,
            'equalsByteString-cpu-arguments-constant': 24548,
            'equalsByteString-cpu-arguments-intercept': 29498,
            'equalsByteString-cpu-arguments-slope': 38,
            'equalsByteString-memory-arguments': 1,
            'equalsData-cpu-arguments-intercept': 898148,
            'equalsData-cpu-arguments-slope': 27279,
            'equalsData-memory-arguments': 1,
            'equalsInteger-cpu-arguments-intercept': 51775,
            'equalsInteger-cpu-arguments-slope': 558,
            'equalsInteger-memory-arguments': 1,
            'equalsString-cpu-arguments-constant': 39184,
            'equalsString-cpu-arguments-intercept': 1000,
            'equalsString-cpu-arguments-slope': 60594,
            'equalsString-memory-arguments': 1,
            'fstPair-cpu-arguments': 141895,
            'fstPair-memory-arguments': 32,
            'headList-cpu-arguments': 83150,
            'headList-memory-arguments': 32,
            'iData-cpu-arguments': 15299,
            'iData-memory-arguments': 32,
            'ifThenElse-cpu-arguments': 76049,
            'ifThenElse-memory-arguments': 1,
            'indexByteString-cpu-arguments': 13169,
            'indexByteString-memory-arguments': 4,
            'lengthOfByteString-cpu-arguments': 22100,
            'lengthOfByteString-memory-arguments': 10,
            'lessThanByteString-cpu-arguments-intercept': 28999,
            'lessThanByteString-cpu-arguments-slope': 74,
            'lessThanByteString-memory-arguments': 1,
            'lessThanEqualsByteString-cpu-arguments-intercept': 28999,
            'lessThanEqualsByteString-cpu-arguments-slope': 74,
            'lessThanEqualsByteString-memory-arguments': 1,
            'lessThanEqualsInteger-cpu-arguments-intercept': 43285,
            'lessThanEqualsInteger-cpu-arguments-slope': 552,
            'lessThanEqualsInteger-memory-arguments': 1,
            'lessThanInteger-cpu-arguments-intercept': 44749,
            'lessThanInteger-cpu-arguments-slope': 541,
            'lessThanInteger-memory-arguments': 1,
            'listData-cpu-arguments': 33852,
            'listData-memory-arguments': 32,
            'mapData-cpu-arguments': 68246,
            'mapData-memory-arguments': 32,
            'mkCons-cpu-arguments': 72362,
            'mkCons-memory-arguments': 32,
            'mkNilData-cpu-arguments': 7243,
            'mkNilData-memory-arguments': 32,
            'mkNilPairData-cpu-arguments': 7391,
            'mkNilPairData-memory-arguments': 32,
            'mkPairData-cpu-arguments': 11546,
            'mkPairData-memory-arguments': 32,
            'modInteger-cpu-arguments-constant': 85848,
            'modInteger-cpu-arguments-model-arguments-intercept': 228465,
            'modInteger-cpu-arguments-model-arguments-slope': 122,
            'modInteger-memory-arguments-intercept': 0,
            'modInteger-memory-arguments-minimum': 1,
            'modInteger-memory-arguments-slope': 1,
            'multiplyInteger-cpu-arguments-intercept': 90434,
            'multiplyInteger-cpu-arguments-slope': 519,
            'multiplyInteger-memory-arguments-intercept': 0,
            'multiplyInteger-memory-arguments-slope': 1,
            'nullList-cpu-arguments': 74433,
            'nullList-memory-arguments': 32,
            'quotientInteger-cpu-arguments-constant': 85848,
            'quotientInteger-cpu-arguments-model-arguments-intercept': 228465,
            'quotientInteger-cpu-arguments-model-arguments-slope': 122,
            'quotientInteger-memory-arguments-intercept': 0,
            'quotientInteger-memory-arguments-minimum': 1,
            'quotientInteger-memory-arguments-slope': 1,
            'remainderInteger-cpu-arguments-constant': 85848,
            'remainderInteger-cpu-arguments-model-arguments-intercept': 228465,
            'remainderInteger-cpu-arguments-model-arguments-slope': 122,
            'remainderInteger-memory-arguments-intercept': 0,
            'remainderInteger-memory-arguments-minimum': 1,
            'remainderInteger-memory-arguments-slope': 1,
            'serialiseData-cpu-arguments-intercept': 955506,
            'serialiseData-cpu-arguments-slope': 213312,
            'serialiseData-memory-arguments-intercept': 0,
            'serialiseData-memory-arguments-slope': 2,
            'sha2_256-cpu-arguments-intercept': 270652,
            'sha2_256-cpu-arguments-slope': 22588,
            'sha2_256-memory-arguments': 4,
            'sha3_256-cpu-arguments-intercept': 1457325,
            'sha3_256-cpu-arguments-slope': 64566,
            'sha3_256-memory-arguments': 4,
            'sliceByteString-cpu-arguments-intercept': 20467,
            'sliceByteString-cpu-arguments-slope': 1,
            'sliceByteString-memory-arguments-intercept': 4,
            'sliceByteString-memory-arguments-slope': 0,
            'sndPair-cpu-arguments': 141992,
            'sndPair-memory-arguments': 32,
            'subtractInteger-cpu-arguments-intercept': 100788,
            'subtractInteger-cpu-arguments-slope': 420,
            'subtractInteger-memory-arguments-intercept': 1,
            'subtractInteger-memory-arguments-slope': 1,
            'tailList-cpu-arguments': 81663,
            'tailList-memory-arguments': 32,
            'trace-cpu-arguments': 59498,
            'trace-memory-arguments': 32,
            'unBData-cpu-arguments': 20142,
            'unBData-memory-arguments': 32,
            'unConstrData-cpu-arguments': 24588,
            'unConstrData-memory-arguments': 32,
            'unIData-cpu-arguments': 20744,
            'unIData-memory-arguments': 32,
            'unListData-cpu-arguments': 25933,
            'unListData-memory-arguments': 32,
            'unMapData-cpu-arguments': 24623,
            'unMapData-memory-arguments': 32,
            'verifyEcdsaSecp256k1Signature-cpu-arguments': 43053543,
            'verifyEcdsaSecp256k1Signature-memory-arguments': 10,
            'verifyEd25519Signature-cpu-arguments-intercept': 53384111,
            'verifyEd25519Signature-cpu-arguments-slope': 14333,
            'verifyEd25519Signature-memory-arguments': 10,
            'verifySchnorrSecp256k1Signature-cpu-arguments-intercept': 43574283,
            'verifySchnorrSecp256k1Signature-cpu-arguments-slope': 26308,
            'verifySchnorrSecp256k1Signature-memory-arguments': 10,
        },
        PlutusV3: {
            'addInteger-cpu-arguments-intercept': 100788,
            'addInteger-cpu-arguments-slope': 420,
            'addInteger-memory-arguments-intercept': 1,
            'addInteger-memory-arguments-slope': 1,
            'appendByteString-cpu-arguments-intercept': 1000,
            'appendByteString-cpu-arguments-slope': 173,
            'appendByteString-memory-arguments-intercept': 0,
            'appendByteString-memory-arguments-slope': 1,
            'appendString-cpu-arguments-intercept': 1000,
            'appendString-cpu-arguments-slope': 59957,
            'appendString-memory-arguments-intercept': 4,
            'appendString-memory-arguments-slope': 1,
            'bData-cpu-arguments': 11183,
            'bData-memory-arguments': 32,
            'blake2b_256-cpu-arguments-intercept': 201305,
            'blake2b_256-cpu-arguments-slope': 8356,
            'blake2b_256-memory-arguments': 4,
            'cekApplyCost-exBudgetCPU': 16000,
            'cekApplyCost-exBudgetMemory': 100,
            'cekBuiltinCost-exBudgetCPU': 16000,
            'cekBuiltinCost-exBudgetMemory': 100,
            'cekConstCost-exBudgetCPU': 16000,
            'cekConstCost-exBudgetMemory': 100,
            'cekDelayCost-exBudgetCPU': 16000,
            'cekDelayCost-exBudgetMemory': 100,
            'cekForceCost-exBudgetCPU': 16000,
            'cekForceCost-exBudgetMemory': 100,
            'cekLamCost-exBudgetCPU': 16000,
            'cekLamCost-exBudgetMemory': 100,
            'cekStartupCost-exBudgetCPU': 100,
            'cekStartupCost-exBudgetMemory': 100,
            'cekVarCost-exBudgetCPU': 16000,
            'cekVarCost-exBudgetMemory': 100,
            'chooseData-cpu-arguments': 94375,
            'chooseData-memory-arguments': 32,
            'chooseList-cpu-arguments': 132994,
            'chooseList-memory-arguments': 32,
            'chooseUnit-cpu-arguments': 61462,
            'chooseUnit-memory-arguments': 4,
            'consByteString-cpu-arguments-intercept': 72010,
            'consByteString-cpu-arguments-slope': 178,
            'consByteString-memory-arguments-intercept': 0,
            'consByteString-memory-arguments-slope': 1,
            'constrData-cpu-arguments': 22151,
            'constrData-memory-arguments': 32,
            'decodeUtf8-cpu-arguments-intercept': 91189,
            'decodeUtf8-cpu-arguments-slope': 769,
            'decodeUtf8-memory-arguments-intercept': 4,
            'decodeUtf8-memory-arguments-slope': 2,
            'divideInteger-cpu-arguments-constant': 85848,
            'divideInteger-cpu-arguments-model-arguments-c00': 123203,
            'divideInteger-cpu-arguments-model-arguments-c01': 7305,
            'divideInteger-cpu-arguments-model-arguments-c02': -900,
            'divideInteger-cpu-arguments-model-arguments-c10': 1716,
            'divideInteger-cpu-arguments-model-arguments-c11': 549,
            'divideInteger-cpu-arguments-model-arguments-c20': 57,
            'divideInteger-cpu-arguments-model-arguments-minimum': 85848,
            'divideInteger-memory-arguments-intercept': 0,
            'divideInteger-memory-arguments-minimum': 1,
            'divideInteger-memory-arguments-slope': 1,
            'encodeUtf8-cpu-arguments-intercept': 1000,
            'encodeUtf8-cpu-arguments-slope': 42921,
            'encodeUtf8-memory-arguments-intercept': 4,
            'encodeUtf8-memory-arguments-slope': 2,
            'equalsByteString-cpu-arguments-constant': 24548,
            'equalsByteString-cpu-arguments-intercept': 29498,
            'equalsByteString-cpu-arguments-slope': 38,
            'equalsByteString-memory-arguments': 1,
            'equalsData-cpu-arguments-intercept': 898148,
            'equalsData-cpu-arguments-slope': 27279,
            'equalsData-memory-arguments': 1,
            'equalsInteger-cpu-arguments-intercept': 51775,
            'equalsInteger-cpu-arguments-slope': 558,
            'equalsInteger-memory-arguments': 1,
            'equalsString-cpu-arguments-constant': 39184,
            'equalsString-cpu-arguments-intercept': 1000,
            'equalsString-cpu-arguments-slope': 60594,
            'equalsString-memory-arguments': 1,
            'fstPair-cpu-arguments': 141895,
            'fstPair-memory-arguments': 32,
            'headList-cpu-arguments': 83150,
            'headList-memory-arguments': 32,
            'iData-cpu-arguments': 15299,
            'iData-memory-arguments': 32,
            'ifThenElse-cpu-arguments': 76049,
            'ifThenElse-memory-arguments': 1,
            'indexByteString-cpu-arguments': 13169,
            'indexByteString-memory-arguments': 4,
            'lengthOfByteString-cpu-arguments': 22100,
            'lengthOfByteString-memory-arguments': 10,
            'lessThanByteString-cpu-arguments-intercept': 28999,
            'lessThanByteString-cpu-arguments-slope': 74,
            'lessThanByteString-memory-arguments': 1,
            'lessThanEqualsByteString-cpu-arguments-intercept': 28999,
            'lessThanEqualsByteString-cpu-arguments-slope': 74,
            'lessThanEqualsByteString-memory-arguments': 1,
            'lessThanEqualsInteger-cpu-arguments-intercept': 43285,
            'lessThanEqualsInteger-cpu-arguments-slope': 552,
            'lessThanEqualsInteger-memory-arguments': 1,
            'lessThanInteger-cpu-arguments-intercept': 44749,
            'lessThanInteger-cpu-arguments-slope': 541,
            'lessThanInteger-memory-arguments': 1,
            'listData-cpu-arguments': 33852,
            'listData-memory-arguments': 32,
            'mapData-cpu-arguments': 68246,
            'mapData-memory-arguments': 32,
            'mkCons-cpu-arguments': 72362,
            'mkCons-memory-arguments': 32,
            'mkNilData-cpu-arguments': 7243,
            'mkNilData-memory-arguments': 32,
            'mkNilPairData-cpu-arguments': 7391,
            'mkNilPairData-memory-arguments': 32,
            'mkPairData-cpu-arguments': 11546,
            'mkPairData-memory-arguments': 32,
            'modInteger-cpu-arguments-constant': 85848,
            'modInteger-cpu-arguments-model-arguments-c00': 123203,
            'modInteger-cpu-arguments-model-arguments-c01': 7305,
            'modInteger-cpu-arguments-model-arguments-c02': -900,
            'modInteger-cpu-arguments-model-arguments-c10': 1716,
            'modInteger-cpu-arguments-model-arguments-c11': 549,
            'modInteger-cpu-arguments-model-arguments-c20': 57,
            'modInteger-cpu-arguments-model-arguments-minimum': 85848,
            'modInteger-memory-arguments-intercept': 0,
            'modInteger-memory-arguments-slope': 1,
            'multiplyInteger-cpu-arguments-intercept': 90434,
            'multiplyInteger-cpu-arguments-slope': 519,
            'multiplyInteger-memory-arguments-intercept': 0,
            'multiplyInteger-memory-arguments-slope': 1,
            'nullList-cpu-arguments': 74433,
            'nullList-memory-arguments': 32,
            'quotientInteger-cpu-arguments-constant': 85848,
            'quotientInteger-cpu-arguments-model-arguments-c00': 123203,
            'quotientInteger-cpu-arguments-model-arguments-c01': 7305,
            'quotientInteger-cpu-arguments-model-arguments-c02': -900,
            'quotientInteger-cpu-arguments-model-arguments-c10': 1716,
            'quotientInteger-cpu-arguments-model-arguments-c11': 549,
            'quotientInteger-cpu-arguments-model-arguments-c20': 57,
            'quotientInteger-cpu-arguments-model-arguments-minimum': 85848,
            'quotientInteger-memory-arguments-intercept': 0,
            'quotientInteger-memory-arguments-slope': 1,
            'remainderInteger-cpu-arguments-constant': 1,
            'remainderInteger-cpu-arguments-model-arguments-c00': 85848,
            'remainderInteger-cpu-arguments-model-arguments-c01': 123203,
            'remainderInteger-cpu-arguments-model-arguments-c02': 7305,
            'remainderInteger-cpu-arguments-model-arguments-c10': -900,
            'remainderInteger-cpu-arguments-model-arguments-c11': 1716,
            'remainderInteger-cpu-arguments-model-arguments-c20': 549,
            'remainderInteger-cpu-arguments-model-arguments-minimum': 57,
            'remainderInteger-memory-arguments-intercept': 85848,
            'remainderInteger-memory-arguments-minimum': 0,
            'remainderInteger-memory-arguments-slope': 1,
            'serialiseData-cpu-arguments-intercept': 955506,
            'serialiseData-cpu-arguments-slope': 213312,
            'serialiseData-memory-arguments-intercept': 0,
            'serialiseData-memory-arguments-slope': 2,
            'sha2_256-cpu-arguments-intercept': 270652,
            'sha2_256-cpu-arguments-slope': 22588,
            'sha2_256-memory-arguments': 4,
            'sha3_256-cpu-arguments-intercept': 1457325,
            'sha3_256-cpu-arguments-slope': 64566,
            'sha3_256-memory-arguments': 4,
            'sliceByteString-cpu-arguments-intercept': 20467,
            'sliceByteString-cpu-arguments-slope': 1,
            'sliceByteString-memory-arguments-intercept': 4,
            'sliceByteString-memory-arguments-slope': 0,
            'sndPair-cpu-arguments': 141992,
            'sndPair-memory-arguments': 32,
            'subtractInteger-cpu-arguments-intercept': 100788,
            'subtractInteger-cpu-arguments-slope': 420,
            'subtractInteger-memory-arguments-intercept': 1,
            'subtractInteger-memory-arguments-slope': 1,
            'tailList-cpu-arguments': 81663,
            'tailList-memory-arguments': 32,
            'trace-cpu-arguments': 59498,
            'trace-memory-arguments': 32,
            'unBData-cpu-arguments': 20142,
            'unBData-memory-arguments': 32,
            'unConstrData-cpu-arguments': 24588,
            'unConstrData-memory-arguments': 32,
            'unIData-cpu-arguments': 20744,
            'unIData-memory-arguments': 32,
            'unListData-cpu-arguments': 25933,
            'unListData-memory-arguments': 32,
            'unMapData-cpu-arguments': 24623,
            'unMapData-memory-arguments': 32,
            'verifyEcdsaSecp256k1Signature-cpu-arguments': 43053543,
            'verifyEcdsaSecp256k1Signature-memory-arguments': 10,
            'verifyEd25519Signature-cpu-arguments-intercept': 53384111,
            'verifyEd25519Signature-cpu-arguments-slope': 14333,
            'verifyEd25519Signature-memory-arguments': 10,
            'verifySchnorrSecp256k1Signature-cpu-arguments-intercept': 43574283,
            'verifySchnorrSecp256k1Signature-cpu-arguments-slope': 26308,
            'verifySchnorrSecp256k1Signature-memory-arguments': 10,
            'cekConstrCost-exBudgetCPU': 16000,
            'cekConstrCost-exBudgetMemory': 100,
            'cekCaseCost-exBudgetCPU': 16000,
            'cekCaseCost-exBudgetMemory': 100,
            'bls12_381_G1_add-cpu-arguments': 962335,
            'bls12_381_G1_add-memory-arguments': 18,
            'bls12_381_G1_compress-cpu-arguments': 2780678,
            'bls12_381_G1_compress-memory-arguments': 6,
            'bls12_381_G1_equal-cpu-arguments': 442008,
            'bls12_381_G1_equal-memory-arguments': 1,
            'bls12_381_G1_hashToGroup-cpu-arguments-intercept': 52538055,
            'bls12_381_G1_hashToGroup-cpu-arguments-slope': 3756,
            'bls12_381_G1_hashToGroup-memory-arguments': 18,
            'bls12_381_G1_neg-cpu-arguments': 267929,
            'bls12_381_G1_neg-memory-arguments': 18,
            'bls12_381_G1_scalarMul-cpu-arguments-intercept': 76433006,
            'bls12_381_G1_scalarMul-cpu-arguments-slope': 8868,
            'bls12_381_G1_scalarMul-memory-arguments': 18,
            'bls12_381_G1_uncompress-cpu-arguments': 52948122,
            'bls12_381_G1_uncompress-memory-arguments': 18,
            'bls12_381_G2_add-cpu-arguments': 1995836,
            'bls12_381_G2_add-memory-arguments': 36,
            'bls12_381_G2_compress-cpu-arguments': 3227919,
            'bls12_381_G2_compress-memory-arguments': 12,
            'bls12_381_G2_equal-cpu-arguments': 901022,
            'bls12_381_G2_equal-memory-arguments': 1,
            'bls12_381_G2_hashToGroup-cpu-arguments-intercept': 166917843,
            'bls12_381_G2_hashToGroup-cpu-arguments-slope': 4307,
            'bls12_381_G2_hashToGroup-memory-arguments': 36,
            'bls12_381_G2_neg-cpu-arguments': 284546,
            'bls12_381_G2_neg-memory-arguments': 36,
            'bls12_381_G2_scalarMul-cpu-arguments-intercept': 158221314,
            'bls12_381_G2_scalarMul-cpu-arguments-slope': 26549,
            'bls12_381_G2_scalarMul-memory-arguments': 36,
            'bls12_381_G2_uncompress-cpu-arguments': 74698472,
            'bls12_381_G2_uncompress-memory-arguments': 36,
            'bls12_381_finalVerify-cpu-arguments': 333849714,
            'bls12_381_finalVerify-memory-arguments': 1,
            'bls12_381_millerLoop-cpu-arguments': 254006273,
            'bls12_381_millerLoop-memory-arguments': 72,
            'bls12_381_mulMlResult-cpu-arguments': 2174038,
            'bls12_381_mulMlResult-memory-arguments': 72,
            'keccak_256-cpu-arguments-intercept': 2261318,
            'keccak_256-cpu-arguments-slope': 64571,
            'keccak_256-memory-arguments': 4,
            'blake2b_224-cpu-arguments-intercept': 207616,
            'blake2b_224-cpu-arguments-slope': 8310,
            'blake2b_224-memory-arguments': 4,
            'integerToByteString-cpu-arguments-c0': 1293828,
            'integerToByteString-cpu-arguments-c1': 28716,
            'integerToByteString-cpu-arguments-c2': 63,
            'integerToByteString-memory-arguments-intercept': 0,
            'integerToByteString-memory-arguments-slope': 1,
            'byteStringToInteger-cpu-arguments-c0': 1006041,
            'byteStringToInteger-cpu-arguments-c1': 43623,
            'byteStringToInteger-cpu-arguments-c2': 251,
            'byteStringToInteger-memory-arguments-intercept': 0,
            'byteStringToInteger-memory-arguments-slope': 1,
            'andByteString-cpu-arguments-intercept': 100181,
            'andByteString-cpu-arguments-slope1': 726,
            'andByteString-cpu-arguments-slope2': 719,
            'andByteString-memory-arguments-intercept': 0,
            'andByteString-memory-arguments-slope': 1,
            'orByteString-cpu-arguments-intercept': 100181,
            'orByteString-cpu-arguments-slope1': 726,
            'orByteString-cpu-arguments-slope2': 719,
            'orByteString-memory-arguments-intercept': 0,
            'orByteString-memory-arguments-slope': 1,
            'xorByteString-cpu-arguments-intercept': 100181,
            'xorByteString-cpu-arguments-slope1': 726,
            'xorByteString-cpu-arguments-slope2': 719,
            'xorByteString-memory-arguments-intercept': 0,
            'xorByteString-memory-arguments-slope': 1,
            'complementByteString-cpu-arguments-intercept': 107878,
            'complementByteString-cpu-arguments-slope': 680,
            'complementByteString-memory-arguments-intercept': 0,
            'complementByteString-memory-arguments-slope': 1,
            'readBit-cpu-arguments': 95336,
            'readBit-memory-arguments': 1,
            'writeBits-cpu-arguments-intercept': 281145,
            'writeBits-cpu-arguments-slope': 18848,
            'writeBits-memory-arguments-intercept': 0,
            'writeBits-memory-arguments-slope': 1,
            'replicateByte-cpu-arguments-intercept': 180194,
            'replicateByte-cpu-arguments-slope': 159,
            'replicateByte-memory-arguments-intercept': 1,
            'replicateByte-memory-arguments-slope': 1,
            'shiftByteString-cpu-arguments-intercept': 158519,
            'shiftByteString-cpu-arguments-slope': 8942,
            'shiftByteString-memory-arguments-intercept': 0,
            'shiftByteString-memory-arguments-slope': 1,
            'rotateByteString-cpu-arguments-intercept': 159378,
            'rotateByteString-cpu-arguments-slope': 8813,
            'rotateByteString-memory-arguments-intercept': 0,
            'rotateByteString-memory-arguments-slope': 1,
            'countSetBits-cpu-arguments-intercept': 107490,
            'countSetBits-cpu-arguments-slope': 3298,
            'countSetBits-memory-arguments': 1,
            'findFirstSetBit-cpu-arguments-intercept': 106057,
            'findFirstSetBit-cpu-arguments-slope': 655,
            'findFirstSetBit-memory-arguments': 1,
            'ripemd_160-cpu-arguments-intercept': 1964219,
            'ripemd_160-cpu-arguments-slope': 24520,
            'ripemd_160-memory-arguments': 3,
        },
    },
    slotsPerEpoch: 432000,
};
const protocolParametersForLucid = {
    Mainnet,
    Preview,
    Preprod,
    Emulator: Preview,
};
const slotsPerEpochForLucid = {
    Mainnet: Mainnet.slotsPerEpoch,
    Preview: Preview.slotsPerEpoch,
    Preprod: Preprod.slotsPerEpoch,
    Emulator: Preview.slotsPerEpoch,
};
//# sourceMappingURL=protocolParameters.js.map

/***/ }),

/***/ 57103:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ CARDANO_WALLETS; }
/* harmony export */ });
/* harmony import */ var _images_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86096);
//----------------------------------------------------------------------

const CARDANO_WALLETS = [
    {
        wallet: 'eternl',
        name: 'Eternl',
        icon: _images_js__WEBPACK_IMPORTED_MODULE_0__/* .WALLET_ETERNL_ICON */ .$F,
        link: 'https://chrome.google.com/webstore/detail/eternl/kmhcihpebfmpgmihbkipmjlmmioameka',
        isInstalled: false,
    },
    {
        wallet: 'lace',
        name: 'Lace',
        icon: _images_js__WEBPACK_IMPORTED_MODULE_0__/* .WALLET_LACE_ICON */ .lU,
        link: 'https://chromewebstore.google.com/detail/lace/gafhhkghbfjjkeiendhlofajokpaflmk',
        isInstalled: false,
    },
    {
        wallet: 'yoroi',
        name: 'Yoroi',
        icon: _images_js__WEBPACK_IMPORTED_MODULE_0__/* .WALLET_YOROI_ICON */ .eq,
        link: 'https://chrome.google.com/webstore/detail/yoroi/ffnbelfdoeiohenkjibnmadjiehjhajb',
        isInstalled: false,
    },
    {
        wallet: 'vespr',
        name: 'VESPR',
        icon: _images_js__WEBPACK_IMPORTED_MODULE_0__/* .WALLET_VESPR_ICON */ .X3,
        link: 'https://chromewebstore.google.com/detail/vespr-wallet/bedogdpgdnifilpgeianmmdabklhfkcn',
        isInstalled: false,
    },
    {
        wallet: 'nami',
        name: 'Nami',
        icon: _images_js__WEBPACK_IMPORTED_MODULE_0__/* .WALLET_NAMI_ICON */ .CN,
        link: 'https://chrome.google.com/webstore/detail/nami/lpfcbjknijpeeillifnkikgncikgfhdo',
        isInstalled: false,
    },
    // {
    //     wallet: 'flint',
    //     name: 'Flint',
    //     icon: WALLET_FLINT_ICON,
    //     link: 'https://chrome.google.com/webstore/detail/flint-wallet/hnhobjmcibchnmglfbldbfabcgaknlkj',
    //     isInstalled: false,
    // },
    {
        wallet: 'typhon',
        name: 'Typhon',
        icon: _images_js__WEBPACK_IMPORTED_MODULE_0__/* .WALLET_TYPHON_ICON */ .PB,
        link: 'https://chrome.google.com/webstore/detail/typhon-wallet/kfdniefadaanbjodldohaedphafoffoh',
        isInstalled: false,
    },
    {
        wallet: 'nufi',
        name: 'Nufi',
        icon: _images_js__WEBPACK_IMPORTED_MODULE_0__/* .WALLET_NUFI_ICON */ .uh,
        link: 'https://chrome.google.com/webstore/detail/nufi/gpnihlnnodeiiaakbikldcihojploeca',
        isInstalled: false,
    },
];
//# sourceMappingURL=wallets.js.map

/***/ }),

/***/ 87502:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports BackEndAppliedFor, BackEndApiHandlersFor */
/* harmony import */ var _registerManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91189);

function BackEndAppliedFor(entity) {
    return function (target) {
        RegistryManager.register(entity.className(), target, 'backEndApplied');
    };
}
function BackEndApiHandlersFor(entity) {
    return function (target) {
        RegistryManager.register(entity.className(), target, 'backEndApiHandlers');
    };
}
//# sourceMappingURL=Decorator.BackEndAppliedFor.js.map

/***/ }),

/***/ 19083:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e0": function() { return /* binding */ Convertible; },
/* harmony export */   "xS": function() { return /* binding */ getCombinedConversionFunctions; }
/* harmony export */ });
/* unused harmony export getFilteredConversionFunctions */
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28660);
/* harmony import */ var _registerManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91189);


// interface GlobalConversions {
//     conversionFunctionsByClass: Map<Function, Map<string, ConversionFunctions<any>>>;
// }
// let globalState: any;
// if (typeof window !== 'undefined') {
//     globalState = window;
// } else {
//     globalState = global;
// }
// if (!globalState.globalConversions) {
//     globalState.globalConversions = {
//         conversionFunctionsByClass: new Map<Function, Map<string, ConversionFunctions<any>>>(),
//     } as GlobalConversions;
// }
// export const conversionFunctionsByClass = globalState.globalConversions.conversionFunctionsByClass as Map<Function, Map<string, ConversionFunctions<any>>>;
function Convertible(conversions = {}) {
    const result = function (target, propertyKey) {
        //------------------------
        const targetName = target.className ? target.className() : target.name ? target.name : target.constructor.name;
        if (targetName === undefined) {
            console.error(`[Convertible] target Name is undefined`);
        }
        //------------------------
        const reflectedType = Reflect.getMetadata(`design:type`, target, propertyKey);
        const isArray = reflectedType === Array || conversions.isArray;
        let type = undefined;
        //------------------------
        if (isArray) {
            if (conversions.type === undefined && conversions.relation !== `OneToMany`) {
                throw `${targetName}: [Convertible] ${propertyKey} is Array, you must set type`;
            }
            type = conversions.type;
        }
        else {
            type = conversions.type ? conversions.type : reflectedType;
        }
        //------------------------
        if (conversions.relation === `OneToOne`) {
            // OneToOne es una relacion de un registro de una tabla con un registro de otra tabla
            if (conversions.typeRelation === undefined) {
                throw `${targetName}: [Convertible] ${propertyKey}: OneToOne must have relation type`;
            }
            if (conversions.propertyToFill === undefined) {
                // de hecho no los voy a usar desde aji
                // a partir de los id yo mismo voy a cargarlos desde la base si cascade load esta activado
                // no se supone que vengan en la interfas los objetos
                throw `${targetName}: [Convertible] ${propertyKey}: OneToOne must have a valid propertyToFill`;
            }
        }
        else if (conversions.relation === `ManyToOne`) {
            // ManyToOne es una relacion de muchos registros de una tabla con un registro de otra tabla
            if (conversions.typeRelation === undefined) {
                throw `${targetName}: [Convertible] ${propertyKey}: ManyToOne must have relation type`;
            }
            if (conversions.propertyToFill === undefined) {
                // de hecho no los voy a usar desde aji
                // a partir de los id yo mismo voy a cargarlos desde la base si cascade load esta activado
                // no se supone que vengan en la interfas los objetos
                throw `${targetName}: [Convertible] ${propertyKey}: ManyToOne must have a valid propertyToFill`;
            }
        }
        else if (conversions.relation === `OneToMany`) {
            // OneToMany es una relacion un registro de esta tabla se relaciona con muchos registros de otra tabla
            if (isArray === false) {
                throw `${targetName}: [Convertible] ${propertyKey}: OneToMany must be an Array`;
            }
            if (conversions.typeRelation === undefined) {
                throw `${targetName}: [Convertible] ${propertyKey}: OneToMany must have relation type`;
            }
            if (conversions.propertyToFill === undefined) {
                throw `${targetName}: [Convertible] ${propertyKey}: OneToMany must have a valid propertyToFill`;
            }
        }
        //------------------------
        // let conversionFunctionsByProperty = getConversionFunctions(target.constructor) as Map<string, ConversionFunctions<any>> | undefined;
        // if (!conversionFunctionsByProperty) {
        //     conversionFunctionsByProperty = new Map<string, ConversionFunctions<any>>();
        //     conversionFunctionsByClass.set(target.constructor, conversionFunctionsByProperty);
        // }
        //------------------------
        let conversionFunctionsByProperty = _registerManager_js__WEBPACK_IMPORTED_MODULE_1__/* .RegistryManager.getFromConversionFunctionsRegistry */ .S.getFromConversionFunctionsRegistry(targetName);
        if (!conversionFunctionsByProperty) {
            conversionFunctionsByProperty = new Map();
            _registerManager_js__WEBPACK_IMPORTED_MODULE_1__/* .RegistryManager.register */ .S.register(targetName, conversionFunctionsByProperty, 'conversionFunctions');
        }
        //------------------------
        conversionFunctionsByProperty.set(propertyKey, { ...conversions, type, isArray });
        //------------------------
    };
    return result;
}
//------------------------
// function getConversionFunctions<T>(target: Function): Map<string, ConversionFunctions<T>> | undefined {
//     // First try a direct match
//     // let conversionFunctions = conversionFunctionsByClass.get(target);
//     // Si no hay coincidencia directa, hacemos comparación completa
//     if (!conversionFunctions) {
//         const key = [...conversionFunctionsByClass.keys()].find(
//             (k) => isSameClass(target, k)
//         );
//         if (key) {
//             conversionFunctions = conversionFunctionsByClass.get(key);
//             // console.log(`✅ Found conversion functions using areClassesEquivalent for ${target.name}`);
//         }
//     }
//     // // If direct match fails, try resolving using instanceof
//     // if (!conversionFunctions) {
//     //     const key = [...conversionFunctionsByClass.keys()].find((k) => target.prototype instanceof k);
//     //     if (key) {
//     //         conversionFunctions = conversionFunctionsByClass.get(key);
//     //         console.log(`✅ Found conversion functions using instanceof for ${target.name}`);
//     //     }
//     // }
//     return conversionFunctions;
// }
//------------------------
function getCombinedConversionFunctions(target) {
    //------------------------
    const combinedConversionFunctions = new Map();
    //------------------------
    let currentTarget = target;
    //------------------------
    while (currentTarget && currentTarget !== Object) {
        //------------------------
        //TODO: fixme: no estoy usando Mixin en las clases con decorators al menos por ahora.
        // UPDATE: si uso Misin
        // asi que todo esto no aplica
        //------------------------
        const currentTargetName = currentTarget.className ? currentTarget.className() : currentTarget.name ? currentTarget.name : currentTarget.constructor.name;
        if (currentTargetName === undefined) {
            console.error(`[Convertible] currentTarget Name is undefined`);
        }
        //------------------------
        if (Object.getPrototypeOf(currentTarget.prototype)?.constructor.name === 'MixedClass') {
            //------------------------
            if (Array.isArray(currentTarget._MixinClassesHierarchy) === false || currentTarget._MixinClassesHierarchy.length === 0) {
                throw `[Convertible] MixedClass must define _MixinClassesHierarchy array with at least one class element`;
            }
            //------------------------
            // cargo los decoratos de esta clase mixin
            const conversionFunctionsByProperty = _registerManager_js__WEBPACK_IMPORTED_MODULE_1__/* .RegistryManager.getFromConversionFunctionsRegistry */ .S.getFromConversionFunctionsRegistry(currentTargetName);
            // const conversionFunctionsByProperty = getConversionFunctions(currentTarget);
            // const conversionFunctionsByProperty = conversionFunctionsByClass.get(currentTarget);
            //------------------------
            if (conversionFunctionsByProperty) {
                for (const [propertyKey, conversionFunctions] of conversionFunctionsByProperty.entries()) {
                    if (!combinedConversionFunctions.has(propertyKey)) {
                        combinedConversionFunctions.set(propertyKey, conversionFunctions);
                    }
                }
            }
            //------------------------
            // cargo los decoratos en orden de las clases definidas en el array
            //------------------------
            const listOfClassesWithDecoratos = currentTarget._MixinClassesHierarchy.reverse();
            //------------------------
            for (const classFunction of listOfClassesWithDecoratos) {
                const classFunctionName = classFunction.className ? classFunction.className() : classFunction.name ? classFunction.name : classFunction.constructor.name;
                if (classFunctionName === undefined) {
                    console.error(`[Convertible] classFunction Name is undefined`);
                }
                const conversionFunctionsByProperty = _registerManager_js__WEBPACK_IMPORTED_MODULE_1__/* .RegistryManager.getFromConversionFunctionsRegistry */ .S.getFromConversionFunctionsRegistry(classFunctionName);
                // const conversionFunctionsByProperty = getConversionFunctions(classFunction);
                // const conversionFunctionsByProperty = conversionFunctionsByClass.get(classFunction);
                if (conversionFunctionsByProperty) {
                    for (const [propertyKey, conversionFunctions] of conversionFunctionsByProperty.entries()) {
                        if (!combinedConversionFunctions.has(propertyKey)) {
                            combinedConversionFunctions.set(propertyKey, conversionFunctions);
                        }
                    }
                }
            }
            //------------------------
            //TODO: comprobar si esta bien, logica y tecnica
            // la logica aun no la tengo clara, cual cadena de prototipo quiero seguir para buscar y definir conversion functions?
            // por ahora dejo que use la ultima de la lista
            // tampoco se si la forma de hacerlo sería asi
            //------------------------
            currentTarget = Object.getPrototypeOf(listOfClassesWithDecoratos[0].prototype)?.constructor;
            // luego se hace de neuvo esta isntruccion para ir a la clase que si corresponde
            //------------------------
        }
        else {
            //------------------------
            // cargo decorators de esta clase
            const conversionFunctionsByProperty = _registerManager_js__WEBPACK_IMPORTED_MODULE_1__/* .RegistryManager.getFromConversionFunctionsRegistry */ .S.getFromConversionFunctionsRegistry(currentTargetName);
            // const conversionFunctionsByProperty = getConversionFunctions(currentTarget);
            // const conversionFunctionsByProperty = conversionFunctionsByClass.get(currentTarget);
            //------------------------
            if (conversionFunctionsByProperty) {
                for (const [propertyKey, conversionFunctions] of conversionFunctionsByProperty.entries()) {
                    if (!combinedConversionFunctions.has(propertyKey)) {
                        combinedConversionFunctions.set(propertyKey, conversionFunctions);
                    }
                }
            }
            //------------------------
        }
        //------------------------
        // subo una clase y vuelvo a empezar a buscar decoratos
        currentTarget = Object.getPrototypeOf(currentTarget.prototype)?.constructor;
        //------------------------
    }
    //------------------------
    if (combinedConversionFunctions === undefined || combinedConversionFunctions.size === 0) {
        // console.log(`No conversion functions found for ${target.name}`);
        // conversionFunctionsByClass.forEach((_, key) => console.log((key as any).name));
        // conversionFunctionsByClass.forEach((_, key) => console.log(key === target, key, target));
        // const conversionFunctionsByProperty = getConversionFunctions(target);
        // console.log(`conversionFunctionsByProperty`, conversionFunctionsByProperty);
        // console.log(`currentTarget`, target);
        // throw `No conversion functions found for ${target.name}`;
    }
    //------------------------
    return combinedConversionFunctions;
}
// Examples:
// const createdAtFields = getFilteredConversionFunctions(Entity, (conversion) => conversion.isCreatedAt === true);
// for (const [propertyKey, conversion] of createdAtFields.entries()) {
//     console.log(`Field with @CreatedAt: ${propertyKey}`);
// }
// const updatedAtFields = getFilteredConversionFunctions(Entity, (conversion) => conversion.isUpdatedAt === true);
// for (const [propertyKey, conversion] of updatedAtFields.entries()) {
//     console.log(`Field with @UpdatedAt: ${propertyKey}`);
// }
// const bigintFields = getFilteredConversionFunctions(Entity, (conversion) => conversion.type === BigInt);
// for (const [propertyKey, conversion] of bigintFields.entries()) {
//     console.log(`BigInt field: ${propertyKey}`);
// }
function getFilteredConversionFunctions(target, filterFn) {
    const combinedConversionFunctions = getCombinedConversionFunctions(target);
    const filteredConversionFunctions = new Map();
    for (const [propertyKey, conversion] of combinedConversionFunctions.entries()) {
        if (filterFn(conversion, propertyKey)) {
            filteredConversionFunctions.set(propertyKey, conversion);
        }
    }
    return filteredConversionFunctions;
}
//# sourceMappingURL=Decorator.Convertible.js.map

/***/ }),

/***/ 67139:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MongoAppliedFor */
/* harmony import */ var _registerManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91189);

function MongoAppliedFor(entities) {
    return function (target) {
        entities.forEach(entity => {
            RegistryManager.register(entity.className(), target, 'mongoSchemas');
        });
    };
}
//# sourceMappingURL=Decorator.MongoAppliedFor.js.map

/***/ }),

/***/ 15760:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PostgreSQLAppliedFor */
/* harmony import */ var _registerManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91189);

function PostgreSQLAppliedFor(entities) {
    return function (target) {
        entities.forEach(entity => {
            RegistryManager.register(entity.className(), target, 'postgreSQLModels');
        });
    };
}
//# sourceMappingURL=Decorator.PostgreSQLAppliedFor.js.map

/***/ }),

/***/ 2607:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ asEntity; }
/* harmony export */ });
/* harmony import */ var _registerManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91189);

function asEntity() {
    return function (target) {
        _registerManager_js__WEBPACK_IMPORTED_MODULE_0__/* .RegistryManager.register */ .S.register(target.className(), target, 'entities');
    };
}
//# sourceMappingURL=Decorator.asEntity.js.map

/***/ }),

/***/ 12676:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ asSmartDBEntity; }
/* harmony export */ });
/* harmony import */ var _registerManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91189);

function asSmartDBEntity() {
    return function (target) {
        _registerManager_js__WEBPACK_IMPORTED_MODULE_0__/* .RegistryManager.register */ .S.register(target.className(), target, 'smartDBEntities');
    };
}
//# sourceMappingURL=Decorator.asSmartDBEntity.js.map

/***/ }),

/***/ 91189:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ RegistryManager; }
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75672);

let globalState;
if (typeof window !== 'undefined') {
    // Client-side environment
    globalState = window;
}
else {
    // Server-side environment (Node.js)
    globalState = global;
}
// registryManager.ts
class RegistryManager {
    constructor() {
        this.entitiesRegistry = new Map();
        this.smartDBEntitiesRegistry = new Map();
        this.backEndAppliedRegistry = new Map();
        this.backEndApiHandlersRegistry = new Map();
        this.mongoSchemasRegistry = new Map();
        this.postgreSQLModelsRegistry = new Map();
        this.conversionFunctionsRegistry = new Map();
    }
    static getInstance() {
        if (!globalState.registryManagerInstance) {
            globalState.registryManagerInstance = new RegistryManager();
        }
        return globalState.registryManagerInstance;
    }
    static register(className, target, registryType) {
        const registry = RegistryManager.getInstance().getRegistryFromType(registryType);
        const existing = registry.get(className);
        if (!existing || ((0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isSubclassOf */ .Hd)(target, existing) && !(0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isSameClass */ .Fi)(target, existing))) {
            registry.set(className, target);
            // console.log(`Registered ${isNullOrBlank(target.name) ? target : target.name} for ${className} in ${registryType}`);
        }
        else {
            // console.log(`Skipped registering ${isNullOrBlank(target.name) ? target : target.name}, ${existing.name} already registered for ${className}`);
        }
    }
    static getRegistry(className, registryType) {
        const registry = RegistryManager.getInstance().getRegistryFromType(registryType);
        return registry.get(className);
    }
    static getAllFromRegistry(registryType) {
        return new Map(RegistryManager.getInstance().getRegistryFromType(registryType));
    }
    getRegistryFromType(type) {
        switch (type) {
            case 'entities':
                return this.entitiesRegistry;
            case 'smartDBEntities':
                return this.smartDBEntitiesRegistry;
            case 'backEndApplied':
                return this.backEndAppliedRegistry;
            case 'backEndApiHandlers':
                return this.backEndApiHandlersRegistry;
            case 'mongoSchemas':
                return this.mongoSchemasRegistry;
            case 'postgreSQLModels':
                return this.postgreSQLModelsRegistry;
            case 'conversionFunctions':
                return this.conversionFunctionsRegistry;
            default:
                throw `Unknown registry type: ${type}`;
        }
    }
    static getFromEntitiesRegistry(className) {
        return RegistryManager.getRegistry(className, 'entities');
    }
    static getFromSmartDBEntitiesRegistry(className) {
        return RegistryManager.getRegistry(className, 'smartDBEntities');
    }
    static getFromBackEndAppliedRegistry(entity) {
        return RegistryManager.getRegistry(entity.className(), 'backEndApplied');
    }
    static getFromBackEndApiHandlersRegistry(entity) {
        return RegistryManager.getRegistry(entity.className(), 'backEndApiHandlers');
    }
    static getFromMongoSchemasRegistry(entity) {
        return RegistryManager.getRegistry(entity.className(), 'mongoSchemas');
    }
    static getFromPostgreSQLModelsRegistry(entity) {
        return RegistryManager.getRegistry(entity.className(), 'postgreSQLModels');
    }
    static getFromConversionFunctionsRegistry(className) {
        return RegistryManager.getRegistry(className, 'conversionFunctions');
    }
    static getAllFromEntitiesRegistry() {
        return new Map(RegistryManager.getInstance().getRegistryFromType('entities'));
    }
    static getAllFromSmartDBEntitiesRegistry() {
        return new Map(RegistryManager.getInstance().getRegistryFromType('smartDBEntities'));
    }
    static getAllFromBackEndAppliedRegistry() {
        return new Map(RegistryManager.getInstance().getRegistryFromType('backEndApplied'));
    }
    static getAllFromBackEndApiHandlersRegistry() {
        return new Map(RegistryManager.getInstance().getRegistryFromType('backEndApiHandlers'));
    }
    static getAllFromMongoSchemasRegistry() {
        return new Map(RegistryManager.getInstance().getRegistryFromType('mongoSchemas'));
    }
    static getAllFromPosgreSQLModelsRegistry() {
        const registry = new Map(RegistryManager.getInstance().getRegistryFromType('postgreSQLModels'));
        // console.log('[Registry] PostgreSQL Models Registered:');
        // for (const [key, value] of registry.entries()) {
        //     console.log(`- ${key}:`, value?.name || value?.constructor?.name || typeof value);
        // }
        return registry;
    }
}
//# sourceMappingURL=registerManager.js.map

/***/ }),

/***/ 69623:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "As": function() { return /* binding */ deserealizeTokenWithMetadataAndAmount; },
/* harmony export */   "PP": function() { return /* binding */ deserealizeBigInt; },
/* harmony export */   "gZ": function() { return /* binding */ deserealizeAssets; },
/* harmony export */   "ye": function() { return /* binding */ deserealizeEmulator; }
/* harmony export */ });
/* unused harmony exports deserealizeTokenWithPriceAndMetadataAndAmount, tokenWithDetailsToUint8Array */
/* harmony import */ var _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76100);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75672);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__]);
_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];


//--------------------------------------------------------
// export const serializeBigInt = (value: bigint | undefined) => {
//     if (value !== undefined) {
//         return value.toString();
//     } else {
//         return undefined;
//     }
// }
const deserealizeBigInt = (value) => {
    if (value !== undefined && value !== null && value !== '') {
        return BigInt(value);
    }
    else {
        return undefined;
    }
};
//--------------------------------------------------------  
// export const serializeAssets = (value: Assets | undefined) => {
//     if (value === undefined) return undefined
//     const assetsSerialized: { [x: string]: string } = {};
//     for (const key in value) {
//         assetsSerialized[key] = value[key].toString();
//     }
//     return assetsSerialized;
// };
const deserealizeAssets = (value) => {
    if (value === undefined)
        return undefined;
    const assets = {};
    for (const key in value) {
        assets[key] = BigInt(value[key]);
    }
    return assets;
};
const deserealizeTokenWithMetadataAndAmount = (value) => {
    if (value === undefined)
        return undefined;
    const tokenMetadataAndAmount = {
        CS: value.CS,
        TN_Hex: value.TN_Hex,
        amount: BigInt(value.amount),
        ticker: value.ticker,
        decimals: value.decimals,
        image: value.image,
        colorHex: value.colorHex,
        metadata_raw: value.metadata,
    };
    return tokenMetadataAndAmount;
};
const deserealizeTokenWithPriceAndMetadataAndAmount = (value) => {
    if (value === undefined)
        return undefined;
    const tokenWithPriceMetadataAndAmount = {
        CS: value.CS,
        TN_Hex: value.TN_Hex,
        priceADAx1e6: value.priceADAx1e6 !== undefined ? BigInt(value.priceADAx1e6) : undefined,
        date: value.date !== undefined ? BigInt(value.date) : undefined,
        signature: value.signature,
        amount: BigInt(value.amount),
        ticker: value.ticker,
        decimals: value.decimals,
        image: value.image,
        colorHex: value.colorHex,
        metadata_raw: value.metadata,
    };
    return tokenWithPriceMetadataAndAmount;
};
//--------------------------------------------------------
// export const serializeEmulator = (emulator: Emulator | undefined) => {
//     if (emulator === undefined) return undefined
//     let serialized: any = {};
//     serialized = JSON.parse(toJson(emulator));
//     for (const key in emulator.ledger) {
//         const assets = serializeAssets(emulator.ledger[key].utxo.assets);
//         serialized.ledger[key].utxo.assets = assets
//     }
//     return serialized;
// };
const deserealizeEmulator = (serialized) => {
    if (serialized === undefined)
        return undefined;
    const emulator = new _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Emulator */ .G2([]);
    Object.assign(emulator, serialized);
    for (const key in serialized.ledger) {
        const assets = deserealizeAssets(serialized.ledger[key].utxo.assets);
        serialized.ledger[key].utxo.assets = assets;
    }
    return emulator;
};
//--------------------------------------------------------
function tokenWithDetailsToUint8Array(data) {
    return concatUint8Arrays([
        stringHexToUint8Array(data.CS),
        stringHexToUint8Array(data.TN_Hex),
        data.priceADAx1e6 !== undefined ? intToUint8Array(data.priceADAx1e6) : new Uint8Array([]),
        data.date !== undefined ? intToUint8Array(data.date) : new Uint8Array([]),
    ]);
}
//--------------------------------------------------------
//# sourceMappingURL=conversions.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 66146:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gU": function() { return /* binding */ itemToLucidData; }
/* harmony export */ });
/* unused harmony exports objToCborHex, objToLucidData */
/* harmony import */ var _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76100);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75672);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__]);
_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
// #region Lucid Data & Cbor Hex serialize and deserialize


function objToCborHex(data, propertyKey) {
    try {
        const lucidData = objToLucidData(data, propertyKey);
        //console.log("LucidData: " + log(lucidData))
        // lucid data to hex
        const dataHex = Data.to(lucidData);
        // hex to plutus data
        const plutusData = CML.PlutusData.from_cbor_hex(dataHex);
        // plutus data to hex
        const cborHex = plutusData.to_canonical_cbor_hex();
        return cborHex;
    }
    catch (error) {
        console.log(`[Helpers] - objToCborHex - Data: ${showData(data)} - Error: ${error}`);
        throw `${propertyKey ? propertyKey + ' - ' : ''} ${error}`;
    }
}
const objToLucidData = (objectValue, propertyKey) => {
    try {
        if (objectValue === undefined) {
            throw `datum field is undefined`;
        }
        const keys = Object.keys(objectValue);
        let list = [];
        keys.forEach((key) => {
            const item = objectValue[key];
            if (key === '_plutusDataIndex' || key === '_plutusDataIsSubType') {
                return;
            }
            const itemData = itemToLucidData(item, key);
            list.push(itemData);
        });
        let _plutusDataIndex = 0;
        if (objectValue.plutusDataIndex && typeof objectValue.plutusDataIndex === 'function') {
            _plutusDataIndex = objectValue.plutusDataIndex();
        }
        else if (objectValue.hasOwnProperty('_plutusDataIndex') && objectValue._plutusDataIndex !== undefined) {
            _plutusDataIndex = objectValue._plutusDataIndex;
        }
        let _plutusDataIsSubType = false;
        if (objectValue.plutusDataIsSubType && typeof objectValue.plutusDataIsSubType === 'function') {
            _plutusDataIsSubType = objectValue.plutusDataIsSubType();
        }
        else if (objectValue.hasOwnProperty('_plutusDataIsSubType') && objectValue._plutusDataIsSubType !== undefined) {
            _plutusDataIsSubType = objectValue._plutusDataIsSubType;
        }
        if (_plutusDataIsSubType) {
            const constrSubtypo = new _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Constr */ .fL(0, list);
            const constrTypo = new _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Constr */ .fL(_plutusDataIndex, [constrSubtypo]);
            return constrTypo;
        }
        else {
            const constrTypo = new _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Constr */ .fL(_plutusDataIndex, list);
            return constrTypo;
        }
    }
    catch (error) {
        console.log(`[Helpers] - objToLucidData - Data: ${(0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .showData */ .rK)(objectValue)} - Error: ${error}`);
        throw `${propertyKey ? propertyKey + ' - ' : ''} ${error}`;
    }
};
const itemToLucidData = (itemValue, propertyKey) => {
    try {
        if (itemValue === undefined) {
            throw `datum field is undefined`;
        }
        if (itemValue?.toPlutusData) {
            return itemValue.toPlutusData();
        }
        else if (typeof itemValue === 'bigint' ||
            typeof itemValue === 'number' ||
            (typeof itemValue === 'string' && !isNaN(parseInt(itemValue)) && itemValue.slice(-1) === 'n')) {
            return BigInt(itemValue);
        }
        else if (typeof itemValue === 'string') {
            return itemValue;
        }
        else if (typeof itemValue === 'boolean') {
            return new _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Constr */ .fL(itemValue ? 1 : 0, []);
        }
        else if (itemValue instanceof _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Constr */ .fL) {
            return itemValue;
        }
        else if (itemValue instanceof Array) {
            let list = [];
            const keys = Object.keys(itemValue);
            keys.forEach((key) => {
                const subItem = itemValue[key];
                list.push(itemToLucidData(subItem, key));
            });
            return list;
        }
        else if (itemValue instanceof Map) {
            //TODO: falta convertir map, pero no uso map, asi que por ahora no lo hago
            return itemValue;
        }
        else if (typeof itemValue === 'object') {
            return objToLucidData(itemValue, propertyKey);
        }
        throw `Cant convert item type. Must be string, number, bigint, Array, Constr or Objetc or if a class, it must define its own toPlutusData method `;
    }
    catch (error) {
        console.log(`[Helpers] - toLucidData - Data: ${(0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .showData */ .rK)(itemValue)} - Error: ${error}`);
        throw `${propertyKey ? propertyKey + ' - ' : ''} ${error}`;
    }
};
// #endregion Lucid Data & Cbor Hex serialize and deserialize
//# sourceMappingURL=data.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 73582:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ explainError; },
/* harmony export */   "u": function() { return /* binding */ explainErrorTx; }
/* harmony export */ });
/* harmony import */ var _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27001);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75672);


//---------------------------------------------------------------
function explainErrorTx(errorIn) {
    //search if substring 'ScriptFailures' is in error
    let res = '';
    let sep = '';
    const error_In2 = `${errorIn?.info || errorIn?.message || errorIn}`;
    const error = typeof error_In2 === 'object' ? (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .Qs)(error_In2) : error_In2;
    // console.error(`Error: ${error}`);
    if (error === undefined || error === null || error === '' || error === null || error === undefined || error === 'null') {
        res += sep + 'Technical problems, please try again!';
        sep = ', ';
        console.error(`Error Explained: ${res}`);
        return res;
    }
    else {
        if (typeof error === 'string') {
            if (error.includes('"Failed to fetch"')) {
                res += sep + 'The connection was lost, please try again later!';
                sep = ', ';
            }
            if (res === '' && error.includes('Failed to fetch')) {
                res += sep + 'Technical problems, please try again!';
                sep = ', ';
            }
            if (res === '' && error.includes('Cannot read properties of undefined')) {
                res += sep + 'Technical problems, please try again!';
                sep = ', ';
            }
            if (res === '' && error.includes('Insufficient input in Transaction')) {
                res += sep + 'You have no funds in your Wallet!';
                sep = ', ';
            }
            if (res === '' && error.includes('Error: 400:') && error.includes('requiredFee')) {
                res += sep + 'There was an incorrect Fee calculation, please try again later!';
                sep = ', ';
            }
            if (res === '' && error.includes('InsufficientCollateral')) {
                res +=
                    sep +
                        `You have no available UTxO with enough ${_Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .TOKEN_ADA_TICKER */ .Bp} to use as collateral! Get more ${_Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .TOKEN_ADA_TICKER */ .Bp} and try split some wallet\'s UTxO to create an UTxO that can be used as collateral.`;
                sep = ', ';
            }
            if (res === '' && error.includes('Error: 400:') && error.includes('consumed')) {
                res +=
                    sep +
                        'A UTxO that is needed does not exists. It may be that another User already consumes it, please try again later! Also check if you are connected with the right wallet and network';
                sep = ', ';
            }
            if (res === '' && error.includes('missing from UTxO set')) {
                res +=
                    sep +
                        'A UTxO that is needed does not exists. It may be that another User already consumes it, please try again later! Also check if you are connected with the right wallet and network';
                sep = ', ';
            }
            if (res === '' && error.includes('BadInputsUTxO')) {
                res +=
                    sep +
                        'A UTxO that is needed does not exists. It may be that another User already consumes it, please try again later! Also check if you are connected with the right wallet and network';
                sep = ', ';
            }
            if (res === '' && error.includes('Error: 400:') && error.includes('maximumExecutionUnits')) {
                res += sep + 'Sorry, the transfer uses too many resources!';
                sep = ', ';
            }
            if (res === '' && (error.includes('overspending the budget') || error.includes('ExUnitsTooBigUTxO') || error.includes('went over budget Mem'))) {
                res += sep + 'Sorry, the transfer uses too many resources!';
                sep = ', ';
            }
            if (res === '' && error.includes('InputsExhaustedError')) {
                res +=
                    sep +
                        'You dont have enought ADAs or Tokens in your Wallet to make this Transaction. It is possible that some transfer is still in the process of being validated. please try again later!';
                sep = ', ';
            }
            if (res === '' && error.includes(`Not enough ADA leftover to cover minADA`)) {
                res +=
                    sep +
                        `You don't have enough ${_Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__/* .TOKEN_ADA_TICKER */ .Bp} or UTxO available. It is possible that some transfer is still in the process of being validated. Please try Split Wallet UTxOs or try again later!`;
                sep = ', ';
            }
            if (res === '' && error.includes('user declined tx')) {
                res += sep + 'You have canceled the transfer!';
                sep = ', ';
            }
            if (res === '' && error.includes('The request was refused due to lack of access - e.g. wallet disconnects.')) {
                res += sep + 'You have canceled the transfer!';
                sep = ', ';
            }
            if (res === '' && error.includes('user declined to sign tx')) {
                res += sep + 'You have canceled the transfer!';
                sep = ', ';
            }
            if (res === '' && error.includes('ExtraneousScriptWitnessesUTXOW')) {
                res += sep + 'Technical problems, please try again later!';
                sep = ', ';
            }
            if (res === '' && error.includes('ValueNotConservedUTxO')) {
                res += sep + 'Technical problems, please try again later!';
                sep = ', ';
            }
            if (res === '' && error.includes('is not valid JSON')) {
                res += sep + 'Technical problems, please try again later!';
                sep = ', ';
            }
            if (res === '' && error.includes('account changed')) {
                res += sep + 'You have changed the wallet in the dApp Connector, please reconnect with your new wallet!';
                sep = ', ';
            }
            if (res === '' && error.includes('OutsideValidityIntervalUTxO')) {
                res += sep + 'Invalid Transaction Date, please try again later!';
                sep = ', ';
            }
            if (res === '' && error.includes('invalidBefore')) {
                res += sep + 'Invalid Transaction Date, please try again later!';
                sep = ', ';
            }
            if (res === '' && error.includes('FiberFailure')) {
                let extracted = '';
                try {
                    // 🧪 Intentamos parsear el error como JSON real
                    const errorObj = JSON.parse(error);
                    const cause = errorObj?.cause?.failure?.cause;
                    if (typeof cause === 'string') {
                        // ✅ Mismo tratamiento de antes (string escapada)
                        let causeText = cause.replace(/\\"/g, '"').replace(/\\\\/g, '\\').trim();
                        if (causeText.startsWith('{') && causeText.endsWith('}')) {
                            causeText = causeText.slice(1, -1).trim();
                        }
                        causeText = causeText.replace(/^Complete:\s*"?/, '');
                        causeText = causeText.replace(/"$/, '');
                        extracted = causeText;
                    }
                    else if (typeof cause === 'object' && cause !== null) {
                        // ✅ Nuevo caso: el cause es un objeto real
                        extracted = Object.entries(cause)
                            .map(([key, val]) => `${key}: ${val}`)
                            .join(', ');
                    }
                }
                catch (_) {
                    // 😬 Fallback: no se pudo hacer JSON.parse → usamos regex como antes
                    const match = error.match(/"failure"\s*:\s*{[^{}]*"cause"\s*:\s*"((?:\\.|[^"])*)"/);
                    if (match && match[1]) {
                        let causeText = match[1]
                            .replace(/\\"/g, '"') // desescapa comillas
                            .replace(/\\\\/g, '\\') // desescapa backslashes
                            .trim();
                        if (causeText.startsWith('{') && causeText.endsWith('}')) {
                            causeText = causeText.slice(1, -1).trim();
                        }
                        causeText = causeText.replace(/^Complete:\s*"?/, '');
                        causeText = causeText.replace(/"$/, '');
                        extracted = causeText;
                    }
                }
                if (extracted) {
                    res += sep + extracted;
                    sep = ', ';
                }
            }
            if (res === '') {
                res = error;
            }
            //console.log('Error explained: ' + res);
            return res;
        }
        else {
            return 'Technical problems, please try again!';
        }
    }
}
function explainError(errorIn) {
    //search if substring 'ScriptFailures' is in error
    let res = '';
    let sep = '';
    const error_In2 = `${errorIn?.info || errorIn?.message || errorIn}`;
    const error = typeof error_In2 === 'object' ? (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .Qs)(error_In2) : error_In2;
    console.log(`Error: ${error}`);
    if (error === undefined || error === null || error === '' || error === null || error === undefined || error === 'null') {
        res += sep + 'Technical problems, please try again!';
        sep = ', ';
        console.log(`Error Explained: ${res}`);
        return res;
    }
    else {
        if (typeof error === 'string') {
            if (error.includes('"Failed to fetch"')) {
                res += sep + 'The connection was lost, please try again later!';
                sep = ', ';
            }
            if (res === '' && error.includes('Failed to fetch')) {
                res += sep + 'Technical problems, please try again!';
                sep = ', ';
            }
            if (res === '' && error.includes('is not valid JSON')) {
                res += sep + 'Technical problems, please try again later!';
                sep = ', ';
            }
            if (res === '' && error.includes('The request was refused due to lack of access - e.g. wallet disconnects.')) {
                res += sep + 'You have canceled the connection!';
                sep = ', ';
            }
            if (res === '' && error.includes('account changed')) {
                res += sep + 'You have changed the wallet in the dApp Connector, please reconnect with your new wallet!';
                sep = ', ';
            }
            if (res === '') {
                res = error;
            }
            //console.log('Error explained: ' + res);
            return res;
        }
        else {
            return 'Technical problems, please try again!';
        }
    }
}
//---------------------------------------------------------------
//# sourceMappingURL=explainError.js.map

/***/ }),

/***/ 86081:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NI": function() { return /* binding */ formatHash; },
/* harmony export */   "Tg": function() { return /* binding */ formatAddress; },
/* harmony export */   "j$": function() { return /* binding */ formatAmountWithUnit; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "s": function() { return /* binding */ formatUTxO; }
/* harmony export */ });
/* unused harmony exports formatNumberRounded, formatPercentage, formatAmount, formatSmallNumber, formatPOXISTime, formatCurrencySymbol, formatTN_Hex, formatTicker */
/* harmony import */ var _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27001);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75672);


//----------------------------------------------------------------------
function formatNumberRounded(amount) {
    const numericString = amount.replace(/,/g, '');
    const value = Number(numericString);
    if (isNaN(value)) {
        return '0.00';
    }
    const absValue = Math.abs(value);
    let formattedValue;
    let suffix = '';
    if (absValue >= 1e9) {
        formattedValue = value / 1e9;
        suffix = 'B';
    }
    else if (absValue >= 1e6) {
        formattedValue = value / 1e6;
        suffix = 'M';
    }
    else if (absValue >= 1e3) {
        formattedValue = value / 1e3;
        suffix = 'K';
    }
    else {
        formattedValue = value;
    }
    return `${formattedValue.toFixed(2)}${suffix}`;
}
//----------------------------------------------------------------------
function formatPercentage(amount, showDecimals = 0, swRoundWithLetter = false, decimalsInBaseUnit = 0, showAtLeastDecimals = 0) {
    return formatAmountWithUnit(amount, '', showDecimals, swRoundWithLetter, decimalsInBaseUnit, showAtLeastDecimals) + '%';
}
function formatAmountWithUnit(amount, unit, //def ''
showDecimals, // def 0
swRoundWithLetter = false, decimalsInBaseUnit = 0, //def 0
showAtLeastDecimals = 0) {
    //-------------
    if (amount === undefined || unit === undefined || showDecimals === undefined) {
        return `...`;
    }
    if (typeof amount !== 'number') {
        amount = Number(amount);
    }
    //-------------
    let isNegative = amount < 0;
    if (isNegative) {
        amount = -amount;
    }
    //-------------
    // calculates real value in base unit
    const pot = Math.pow(10, decimalsInBaseUnit);
    let amountInBaseUnit = amount / pot;
    let amountInBaseUnitRounded = Math.round(amountInBaseUnit);
    // console.log('amountInBaseUnit:', amountInBaseUnit);
    // console.log('amountInBaseUnitRounded:', amountInBaseUnitRounded);
    //-------------
    if (swRoundWithLetter === true) {
        //-------------
        if (amountInBaseUnitRounded >= 1) {
            //-------------
            let unitModifier = '';
            //-------------
            if (Math.round(amountInBaseUnit / 1e18) > 1) {
                amountInBaseUnit /= 1e18;
                unitModifier += 'QT';
            }
            else if (Math.round(amountInBaseUnit / 1e15) > 1) {
                amountInBaseUnit /= 1e15;
                unitModifier += 'Q';
            }
            else if (Math.round(amountInBaseUnit / 1e12) > 1) {
                amountInBaseUnit /= 1e12;
                unitModifier += 'T';
            }
            else if (Math.round(amountInBaseUnit / 1e9) > 1) {
                amountInBaseUnit /= 1e9;
                unitModifier += 'B';
            }
            else if (Math.round(amountInBaseUnit / 1e6) > 1) {
                amountInBaseUnit /= 1e6;
                unitModifier += 'M';
            }
            else if (Math.round(amountInBaseUnit / 1e3) > 1) {
                amountInBaseUnit /= 1e3;
                unitModifier += 'K';
            }
            if (!unit.startsWith(' ') && unit !== '') {
                unit = ' ' + unit;
            }
            //-------------
            return (isNegative ? `-` : ``) + formatAmount(amountInBaseUnit, showDecimals, 0, showAtLeastDecimals) + unitModifier + unit;
        }
        else {
            if (!unit.startsWith(' ') && unit !== '') {
                unit = ' ' + unit;
            }
            return `${isNegative ? '-' : ''}${formatSmallNumber(amountInBaseUnit, showDecimals, showAtLeastDecimals)}${unit}`;
        }
    }
    else {
        //-------------
        if (!unit.startsWith(' ') && unit !== '') {
            unit = ' ' + unit;
        }
        //-------------
        return (isNegative ? `-` : ``) + formatAmount(amountInBaseUnit, showDecimals, 0, showAtLeastDecimals) + unit;
        //-------------
    }
}
function formatAmount(amount, showDecimals, decimalsInAmount = 0, showAtLeastDecimals = 0) {
    //-------------
    if (amount === undefined || showDecimals === undefined) {
        return `...`;
    }
    if (typeof amount !== 'number') {
        amount = Number(amount);
    }
    //----------------
    const potDecimalsInAmount = Math.pow(10, decimalsInAmount);
    let amountInBaseUnit = amount / potDecimalsInAmount;
    //----------------
    if (showAtLeastDecimals > showDecimals) {
        showAtLeastDecimals = showDecimals;
    }
    //----------------
    // NOTE: no hace falta redondear, lo hace la funcion de acuerdo a la cantidad de decimales a mostrar
    let strConDecimals = amountInBaseUnit.toLocaleString('en-US', { minimumFractionDigits: showAtLeastDecimals, maximumFractionDigits: showDecimals });
    //----------------
    let posDec = strConDecimals.indexOf('.');
    if (posDec !== -1) {
        //delete trailing zeros
        strConDecimals = strConDecimals.replace(/0*$/, '');
        strConDecimals = strConDecimals.replace(/\.$/, '');
    }
    //----------------
    return strConDecimals;
}
function formatSmallNumber(amount, showDecimals = 0, showAtLeastDecimals = 0) {
    // Define subscript characters for numbers 0-9
    const subscriptNums = ['₀', '₁', '₂', '₃', '₄', '₅', '₆', '₇', '₈', '₉'];
    // Convert the number to a string to process its decimal part
    const strInitial = amount.toString();
    const [, afterDotInitial = ''] = strInitial.split('.'); // Split into integer and decimal parts
    let totalContinuosZeros = 0; // Total count of consecutive zeros after the decimal
    let currentZeros = 0; // Count of zeros in the current streak
    // Count groups of consecutive zeros in the decimal part
    for (let i = 0; i < afterDotInitial.length; i++) {
        if (afterDotInitial[i] === '0') {
            currentZeros++; // Increment the current streak of zeros
        }
        else {
            if (currentZeros > 1) {
                // If the streak has more than one zero, add the streak minus 1 to the total
                totalContinuosZeros += currentZeros - 1;
            }
            currentZeros = 0; // Reset the streak if a non-zero is encountered
        }
    }
    // Handle trailing zeros in the decimal part
    if (currentZeros > 1) {
        totalContinuosZeros += currentZeros; // Add remaining zeros to the total count
    }
    // Round the number to accommodate necessary decimals and grouped zeros
    const roundedStr = amount.toFixed(showDecimals + totalContinuosZeros);
    const [beforeDot, afterDot = ''] = roundedStr.split('.'); // Split the rounded number into integer and decimal parts
    let formattedParts = []; // Array to store formatted decimal parts
    currentZeros = 0; // Reset current zero streak
    let digitsShown = 0; // Number of digits currently added to the formatted output
    let i = 0; // Pointer to iterate through the decimal part
    // Process the decimal part and format the output
    while (i < afterDot.length && digitsShown < showDecimals) {
        if (afterDot[i] === '0') {
            currentZeros++; // Count consecutive zeros
        }
        else {
            if (currentZeros > 1) {
                // Convert a streak of zeros into a subscript if more than one
                formattedParts.push(subscriptNums[currentZeros]);
                digitsShown += 1; // Increment digits shown
                currentZeros = 0; // Reset zero streak
            }
            else if (currentZeros === 1) {
                // Add a single zero as a normal '0'
                formattedParts.push('0');
                digitsShown += 1;
                currentZeros = 0; // Reset zero streak
            }
            // Add the current non-zero digit to the formatted parts
            if (digitsShown < showDecimals) {
                formattedParts.push(afterDot[i]);
                digitsShown += 1;
            }
        }
        i++;
    }
    // Remove trailing zeros and subscripts from the formatted parts
    if (formattedParts.length > 0) {
        while (formattedParts[formattedParts.length - 1] === '0' || // Remove normal zeros
            subscriptNums.some((n) => n === formattedParts[formattedParts.length - 1]) // Remove subscripted zeros
        ) {
            formattedParts.pop(); // Remove the trailing element
            digitsShown--; // Decrease the count of digits shown
        }
    }
    // Ensure there are enough decimals based on showAtLeastDecimals
    if (showAtLeastDecimals > showDecimals) {
        showAtLeastDecimals = showDecimals;
    }
    while (digitsShown < showAtLeastDecimals) {
        formattedParts.push('0'); // Add normal zeros to meet the minimum requirement
        digitsShown++;
    }
    // Return the final formatted result
    if (formattedParts.length === 0) {
        return beforeDot; // No decimal part, return just the integer part
    }
    else {
        return `${beforeDot}.${formattedParts.join('')}`; // Combine integer and formatted decimal parts
    }
}
function formatPOXISTime(time, format = 'yyyy-MM-dd HH:mm:ss', timeZone) {
    return formatDate(new Date(Number(time)), format, timeZone);
}
function formatDate(date, format = 'yyyy-MM-dd HH:mm:ss', timeZone) {
    // return date.toLocaleString('en-US', {
    //     year: 'numeric',
    //     month: '2-digit',
    //     day: '2-digit',
    //     hour: '2-digit',
    //     minute: '2-digit',
    //     second: '2-digit',
    // });
    if (date === undefined) {
        return '';
    }
    return (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .convertUTCDateToLocalDate */ .Ly)(date, format, timeZone);
}
function formatHash(txHash) {
    return (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .fV)(txHash) ? '' : txHash.slice(0, 4) + '...' + txHash.slice(txHash.length - 4);
}
function formatCurrencySymbol(CS) {
    if (CS === '' || CS === 'lovelace')
        return TOKEN_ADA_TICKER;
    return CS.slice(0, 4) + '...' + CS.slice(CS.length - 4);
}
// export function formatTokenName(TN_Str: string, ADA_Str = TOKEN_ADA_SYMBOL) {
//     if (TN_Str === '') return ADA_Str;
//     if (TN_Str.length > 30) {
//         return TN_Str.slice(0, 27) + '...';
//     }
//     return TN_Str;
// }
function formatTN_Hex(TN_Hex) {
    // ticker = isNullOrBlank(ticker) ? TN_Str : ticker;
    // return formatTokenName(ticker!, TOKEN_ADA_TICKER);
    if (TN_Hex === '')
        return TOKEN_ADA_TICKER;
    const TN_Str = hexToStr(TN_Hex);
    if (TN_Str.length > 30) {
        return TN_Str.slice(0, 27) + '...';
    }
    return TN_Str;
}
function formatTicker(ticker) {
    // ticker = isNullOrBlank(ticker) ? TN_Str : ticker;
    // return formatTokenName(ticker!, TOKEN_ADA_TICKER);
    if (ticker === undefined) {
        return '...';
    }
    if (ticker === '')
        return TOKEN_ADA_TICKER;
    if (ticker.length > 30) {
        return ticker.slice(0, 27) + '...';
    }
    return ticker;
}
function formatAddress(address, isSmall = true) {
    if (isSmall) {
        return (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .fV)(address) ? '' : address.length < 5 + 3 + 4 ? address : address.slice(0, 5) + '...' + address.slice(address.length - 4);
    }
    else {
        return (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .fV)(address) ? '' : address.length < 20 + 3 + 10 ? address : address.slice(0, 20) + '...' + address.slice(address.length - 10);
    }
}
function formatUTxO(txHash, outputIndex) {
    return `${formatHash(txHash)}#${outputIndex}`;
}
//# sourceMappingURL=formatters.js.map

/***/ }),

/***/ 36394:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ isTokenADA; },
/* harmony export */   "Jm": function() { return /* binding */ getTotalOfUnitInUTxOList; },
/* harmony export */   "V8": function() { return /* binding */ isToken_CS_And_TN_Valid; },
/* harmony export */   "V9": function() { return /* binding */ getAssetOfUTxOs; },
/* harmony export */   "Wk": function() { return /* binding */ splitTokenLucidKey; },
/* harmony export */   "_r": function() { return /* binding */ getUrlForImage; },
/* harmony export */   "q$": function() { return /* binding */ addAssets; },
/* harmony export */   "sA": function() { return /* binding */ getFallbackImageLetters; }
/* harmony export */ });
/* unused harmony exports checkIfIsOracleExtenalToken, getOracleExtenalTokenApiRoute, getOutRef, createToken_With_Amount, createToken_ADA_With_Amount, convert_Tokens_To_Assets, convert_Assets_To_Tokens, isValidUrl, isValidHexColor, getScriptFromJson, addressesToPkhs, addressToPubKeyHash, addressToStakePubKeyHash, addressToPaymentPubKeyHashAndStakePubKeyHash, addressFromHexOrBech32, getAddressFromKeyCborHex, getAddressFromPrivateKeyBench32, Ed25519KeyHashToAddress, Bip32PublicKeyToAddress, Bip32PrivateKeyToAddress, pubKeyHashesToAddresses, pubKeyHashToAddress, addAssetsList, subsAssets, subsAssetsList, fixUTxOList, subAssetsFromUtxos, isIncludeValue, sumTokensAmt_From_CS, sumTokensAmt_From_AC_Lucid, createValue_Adding_Tokens_Of_AC_Lucid, getAssetsFromCS, isNFT_With_AC_Lucid_InValue, isToken_With_AC_Lucid_InValue, find_UTxO_Excluding_UTxO_In_UTxOs, find_UTxO_Excluding_TxOutRef_In_UTxOs, find_TxOutRef_In_UTxOs, find_UTxO_In_UTxOs, findSmallerUTxO, findUTxOWithAssets, calculateMinAda, calculateNumAssetsAndPIDS, calculateMinAdaOfAssets, calculateMinAdaOfUTxO, calculateMinAda_OLD, calculateNumAssetsAndPIDS_OLD, calculateMinAdaOfAssets_OLD, signDataByteString, signMessage, verifyMessage, calculateEpochFromSlot */
/* harmony import */ var _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76100);
/* harmony import */ var _Constants_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27001);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75672);
/* harmony import */ var _Constants_protocolParameters_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74625);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__]);
_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];





//---------------------------------------------------------------
function isTokenADA(CS, TN_Hex) {
    return (CS === '' || CS === 'lovelace') && TN_Hex === '';
}
// Verifica si un token es un "Fund Token External"
const checkIfIsOracleExtenalToken = (CS, TN_Hex) => {
    const tokens = TOKENS_EXTERNAL_ORACLE;
    if (!tokens)
        return false;
    return tokens.some((token) => token.CS === CS && token.TN_Hex === TN_Hex);
};
// Obtiene la API para un token específico
const getOracleExtenalTokenApiRoute = (CS, TN_Hex) => {
    const tokens = TOKENS_EXTERNAL_ORACLE;
    if (!tokens)
        return undefined;
    const token = tokens.find((token) => token.CS === CS && token.TN_Hex === TN_Hex);
    return token ? token.Api : undefined;
};
//---------------------------------------------------------------
function isToken_CS_And_TN_Valid(CS, TN_Hex) {
    if (CS === undefined || TN_Hex === undefined) {
        return false;
    }
    if (!isTokenADA(CS, TN_Hex)) {
        if (CS === '' || TN_Hex === '') {
            return false;
        }
        if (!/^[\da-fA-F]{56}$/.test(CS)) {
            return false;
        }
        if (!(0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .isValidHex */ .FX)(TN_Hex)) {
            return false;
        }
    }
    return true;
}
//---------------------------------------------------------------
function getOutRef(txOut) {
    return { txHash: txOut.txHash, outputIndex: txOut.outputIndex };
}
//---------------------------------------------------------------
function getFallbackImageLetters(token) {
    if (!(0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .isNullOrBlank */ .fV)(token.ticker)) {
        return token.ticker.substring(0, 2).toUpperCase();
    }
    else if (!(0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .isNullOrBlank */ .fV)(token.TN_Hex)) {
        return (0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .hexToStr */ .Nd)(token.TN_Hex).substring(0, 2).toUpperCase();
    }
    else if (!(0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .isNullOrBlank */ .fV)(token.CS)) {
        return token.CS.substring(0, 2).toUpperCase();
    }
    return '';
}
//---------------------------------------------------------------
function createToken_With_Amount(CS, TN_Hex, ticker, amount) {
    return { CS, TN_Hex, ticker: ticker === undefined ? hexToStr(TN_Hex) : ticker, amount };
}
function createToken_ADA_With_Amount(amount) {
    return { CS: '', TN_Hex: '', ticker: TOKEN_ADA_TICKER, amount };
}
//---------------------------------------------------------------
function convert_Tokens_To_Assets(Token_With_Metadata_And_Amount) {
    const assets = Token_With_Metadata_And_Amount.reduce((acc, t) => {
        const key = isTokenADA(t.CS, t.TN_Hex) ? 'lovelace' : t.CS + t.TN_Hex;
        if (acc[key]) {
            acc[key] += t.amount;
        }
        else {
            acc[key] = t.amount;
        }
        return acc;
    }, {});
    return assets;
}
//---------------------------------------------------------------
function convert_Assets_To_Tokens(assets) {
    return Object.entries(assets).map(([key, amount]) => {
        if (key === 'lovelace') {
            return { CS: '', TN_Hex: '', amount };
        }
        else {
            const [CS, TN_Hex] = splitTokenLucidKey(key);
            return { CS, TN_Hex, amount };
        }
    });
}
function splitTokenLucidKey(key) {
    // Assuming the key is formed by concatenating CS and TN_Hex for non-ADA tokens
    // You need to provide a way to split the key back into CS and TN_Hex
    // Placeholder implementation:
    const CS = key.slice(0, 56);
    const TN_Hex = key.slice(56);
    return [CS, TN_Hex];
}
//---------------------------------------------------------------
function isValidUrl(url) {
    url = url ?? '';
    // Regular expression to check if the URL is absolute and starts with http://, https://, or ipfs://
    const absoluteUrlPattern = /^(https?:\/\/|ipfs:\/\/).+/;
    // Check if the URL is an absolute URL, starts with a leading slash, or is an IPFS URL
    const res = absoluteUrlPattern.test(url) || url.startsWith('/') || url.startsWith('data:image');
    return res;
}
function getUrlForImage(url) {
    if (isValidUrl(url)) {
        return url.startsWith('ipfs://') ? `https://ipfs.io/ipfs/${url.slice(7)}` : url;
    }
    else {
        return '';
    }
}
//---------------------------------------------------------------
function isValidHexColor(color) {
    // Regular expression to validate hex color (3 or 6 digits, with or without '#')
    const hexColorPattern = /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;
    return hexColorPattern.test(color);
}
//---------------------------------------------------------------
function getScriptFromJson(jsonString) {
    const json = JSON.parse(jsonString);
    const script = {
        type: json.type === 'PlutusScriptV1' ? 'PlutusV1' : json.type === 'PlutusScriptV2' ? 'PlutusV2' : 'PlutusV3',
        script: json.cborHex,
    };
    return script;
}
//--------------------------------------
// #region address and keys conversions
const addressesToPkhs = (addresses) => {
    const addresses_Array = addresses !== undefined && addresses !== '' ? addresses.split(',').map((admin) => admin.trim()) : [];
    const pkh_Array = addresses_Array.map((address) => {
        if (address === '' || address === undefined)
            return undefined;
        try {
            const pkh = getAddressDetails(address)?.paymentCredential?.hash;
            return pkh;
        }
        catch (error) {
            console.log(`[Helpers] - Can't Address: ${address} to Payment Pub Key Hash - Error: ${error}`);
            throw `Can't convert Address: ${address} to Payment Pub Key Hash - ${error}`;
        }
    });
    return pkh_Array.join(',');
};
const addressToPubKeyHash = (bech32Addr) => {
    try {
        const paymentPkh = getAddressDetails(bech32Addr)?.paymentCredential?.hash;
        return paymentPkh;
    }
    catch (error) {
        console.log(`[Helpers] - addressToPubKeyHash - Error: ${error}`);
        throw error;
    }
};
const addressToStakePubKeyHash = (bech32Addr) => {
    try {
        const stakePkh = getAddressDetails(bech32Addr)?.stakeCredential?.hash;
        return stakePkh;
    }
    catch (error) {
        console.log(`[Helpers] - addressToStakePubKeyHash - Error: ${error}`);
        throw error;
    }
};
const addressToPaymentPubKeyHashAndStakePubKeyHash = (bech32Addr) => {
    try {
        const paymentPkh = getAddressDetails(bech32Addr)?.paymentCredential?.hash;
        const stakePkh = getAddressDetails(bech32Addr)?.stakeCredential?.hash;
        return { paymentPkh, stakePkh };
    }
    catch (error) {
        console.log(`[Helpers] - addressToPaymentPubKeyHashAndStakePubKeyHash - Error: ${error}`);
        throw error;
    }
};
function addressFromHexOrBech32(address) {
    try {
        return CML.Address.from_raw_bytes(fromHex(address));
    }
    catch (_e) {
        try {
            return CML.Address.from_bech32(address);
        }
        catch (_e) {
            throw `Could not deserialize address.`;
        }
    }
}
// existen las constantes para usar LUCID_NETWORK_MAINNET_ID = 1
// existen las constantes para usar LUCID_NETWORK_TESTNET_ID = 0
function getAddressFromKeyCborHex(publicKeyCborHex, network_id) {
    const publicKeyBytes = Buffer.from(publicKeyCborHex, 'hex');
    // const publicKey = CML.PublicKey.from_raw_bytes(publicKeyBytes); TODO: verificar este cambio
    const publicKey = CML.PublicKey.from_bytes(new Uint8Array(publicKeyBytes));
    const publicKeyHash = publicKey.hash();
    network_id = network_id !== undefined ? network_id : getLUCID_NETWORK_ID();
    const address = Ed25519KeyHashToAddress(network_id, publicKeyHash);
    return address;
}
// existen las constantes para usar LUCID_NETWORK_MAINNET_ID = 1
// existen las constantes para usar LUCID_NETWORK_TESTNET_ID = 0
function getAddressFromPrivateKeyBench32(privateKeyBench32, network_id) {
    try {
        const priv = CML.PrivateKey.from_bech32(privateKeyBench32);
        const pubKeyHash = priv.to_public().hash();
        network_id = network_id !== undefined ? network_id : getLUCID_NETWORK_ID();
        const address = CML.EnterpriseAddress.new(network_id, CML.Credential.new_pub_key(pubKeyHash)).to_address().to_bech32(undefined);
        return address;
    }
    catch (error) {
        console.log(`[Helpers] - getAddressFromPrivateKeyBench32 - Error: ${error}`);
        throw error;
    }
}
// existen las constantes para usar LUCID_NETWORK_MAINNET_ID = 1
// existen las constantes para usar LUCID_NETWORK_TESTNET_ID = 0
function Ed25519KeyHashToAddress(network_id, keyHash, stakeKeyHash) {
    let address;
    if (stakeKeyHash !== undefined) {
        address = CML.BaseAddress.new(network_id, CML.Credential.new_pub_key(keyHash), CML.Credential.new_pub_key(stakeKeyHash));
    }
    else {
        address = CML.EnterpriseAddress.new(network_id, CML.Credential.new_pub_key(keyHash));
    }
    const bech32 = address.to_address().to_bech32(undefined);
    return bech32;
}
function Bip32PublicKeyToAddress(bip32, network_id) {
    let rootPk = bip32;
    // generate an address pk
    const addressPk = rootPk
        .derive(1852 + 0x80000000) // Cardano uses 1852 for Shelley purpose paths
        .derive(1815 + 0x80000000) // Cardano coin type
        .derive(0 + 0x80000000) // account #0
        .derive(0) // external chain (see bip44)
        .derive(0); // 0th account
    // get the address public key hash
    const keyHash = addressPk
        .to_raw_key() // strips the chain code
        .hash();
    // get bech32 for address
    const bech32 = Ed25519KeyHashToAddress(network_id, keyHash);
    return bech32;
}
function Bip32PrivateKeyToAddress(bip32, network_id) {
    let rootPk = bip32;
    // generate an address pk
    const addressPk = rootPk
        .derive(1852 + 0x80000000) // Cardano uses 1852 for Shelley purpose paths
        .derive(1815 + 0x80000000) // Cardano coin type
        .derive(0 + 0x80000000) // account #0
        .derive(0) // external chain (see bip44)
        .derive(0); // 0th account
    // get the address public key hash
    const keyHash = addressPk
        .to_raw_key() // strips the chain code
        .to_public()
        .hash();
    // get bech32 for address
    const bech32 = Ed25519KeyHashToAddress(network_id, keyHash);
    return bech32;
}
const pubKeyHashesToAddresses = (pkhs, network_id) => {
    const pkhs_Array = pkhs !== undefined && pkhs !== '' ? pkhs.split(',').map((admin) => admin.trim()) : [];
    const addresses_Array = pkhs_Array.map((pkh) => {
        if (pkh === '' || pkh === undefined)
            return undefined;
        try {
            network_id = network_id !== undefined ? network_id : getLUCID_NETWORK_ID();
            const address = pubKeyHashToAddress(network_id, pkh);
            return address;
        }
        catch (error) {
            console.log(`[Helpers] - Can't convert Payment Pub Key Hash: ${pkh} to Address - Error: ${error}`);
            throw `Can't convert Master Payment Pub Key Hash: ${pkh} to Address - ${error}`;
        }
    });
    return addresses_Array.join(',');
};
function pubKeyHashToAddress(network_id, pkh, stakePkh) {
    console.log('pubKeyHashToAddress - pkh: ' + pkh);
    const keyHash = CML.Ed25519KeyHash.from_raw_bytes(fromHex(pkh));
    let stakeKeyHash;
    if (stakePkh !== undefined && stakePkh !== '') {
        stakeKeyHash = CML.Ed25519KeyHash.from_raw_bytes(fromHex(stakePkh));
    }
    else {
        stakeKeyHash = undefined;
    }
    const bech32 = Ed25519KeyHashToAddress(network_id, keyHash, stakeKeyHash);
    return bech32;
}
// #endregion address and keys conversions
// #region assets operations
//for adding two Assets into one
function addAssets(as1, as2) {
    const units1 = Object.keys(as1);
    const units2 = Object.keys(as2);
    const res = {};
    for (let i = 0; i < units1.length; i++) {
        res[units1[i]] = as1[units1[i]];
    }
    for (let i = 0; i < units2.length; i++) {
        if ((0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .searchValueInArray */ .z2)(units1, units2[i])) {
            res[units2[i]] = as2[units2[i]] + as1[units2[i]];
        }
        else {
            res[units2[i]] = as2[units2[i]];
        }
    }
    const units3 = Object.keys(res);
    const res2 = {};
    for (let i = 0; i < units3.length; i++) {
        if (res[units3[i]] !== 0n) {
            res2[units3[i]] = res[units3[i]];
        }
    }
    return res2;
}
function addAssetsList(assetsList) {
    let res = {};
    for (let i = 0; i < assetsList.length; i++) {
        const as1 = assetsList[i];
        res = addAssets(as1, res);
    }
    return res;
}
function subsAssets(as1, as2) {
    const units1 = Object.keys(as1);
    const units2 = Object.keys(as2);
    const res = {};
    for (let i = 0; i < units1.length; i++) {
        res[units1[i]] = as1[units1[i]];
    }
    for (let i = 0; i < units2.length; i++) {
        if (searchValueInArray(units1, units2[i])) {
            res[units2[i]] = res[units2[i]] - as2[units2[i]];
        }
        else {
            res[units2[i]] = -as2[units2[i]];
        }
    }
    const units3 = Object.keys(res);
    const res2 = {};
    for (let i = 0; i < units3.length; i++) {
        if (res[units3[i]] !== 0n) {
            res2[units3[i]] = res[units3[i]];
        }
    }
    return res2;
}
function subsAssetsList(initial, assetsList) {
    let res = initial;
    for (let i = 0; i < assetsList.length; i++) {
        const as1 = assetsList[i];
        res = subsAssets(res, as1);
    }
    return res;
}
// #endregion assets operations
//---------------------------------------------------------------
function fixUTxOList(utxos) {
    return utxos.map((u) => ({
        ...u,
        assets: Object.fromEntries(Object.entries(u.assets).map(([k, v]) => [k, BigInt(v.toString())])),
    }));
}
//---------------------------------------------------------------
function getAssetOfUTxOs(utxos) {
    const utxoVal = {};
    utxos.forEach((u) => {
        const assets = u.assets;
        const ks = Object.keys(assets);
        ks.forEach((k) => {
            let kVal = assets[k];
            kVal = kVal !== undefined ? kVal : 0n;
            let uVal = utxoVal[k];
            uVal = uVal !== undefined ? uVal : 0n;
            utxoVal[k] = BigInt(kVal.toString()) + BigInt(uVal.toString());
        });
    });
    return utxoVal;
}
//---------------------------------------------------------------
// Get new value from utxos substracting a value
function subAssetsFromUtxos(utxos, value) {
    const utxoVal = {};
    const valKs = Object.keys(value);
    utxos.forEach((u) => {
        const assets = u.assets;
        const ks = Object.keys(assets);
        ks.forEach((k) => {
            let kVal = assets[k];
            kVal = kVal !== undefined ? kVal : 0n;
            let uVal = utxoVal[k];
            uVal = uVal !== undefined ? uVal : 0n;
            utxoVal[k] = BigInt(kVal.toString()) + BigInt(uVal.toString());
        });
    });
    valKs.forEach((k) => {
        let kVal = value[k];
        kVal = kVal !== undefined ? kVal : 0n;
        let uVal = utxoVal[k];
        uVal = uVal !== undefined ? uVal : 0n;
        if (kVal > uVal) {
            throw 'Subtraction Failed.';
        }
        utxoVal[k] = BigInt(uVal.toString()) - BigInt(kVal.toString());
    });
    return utxoVal;
}
//---------------------------------------------------------------
function isIncludeValue(find, where) {
    for (const key of Object.keys(find)) {
        if (where[key] === undefined || find[key] > where[key]) {
            return false;
        }
    }
    return true;
}
//---------------------------------------------------------------
function sumTokensAmt_From_CS(assets, token_CS) {
    let total = 0n;
    for (const [key, value] of Object.entries(assets)) {
        const [CS_, TN_Hex_] = splitTokenLucidKey(key);
        if (token_CS === CS_) {
            total += value;
        }
    }
    return total;
}
//---------------------------------------------------------------
function sumTokensAmt_From_AC_Lucid(assets, token_AC_Lucid) {
    let total = 0n;
    for (const [key, value] of Object.entries(assets)) {
        const AC_ = key;
        if (token_AC_Lucid === AC_) {
            total += value;
        }
    }
    return total;
}
//---------------------------------------------------------------
function createValue_Adding_Tokens_Of_AC_Lucid(uTxOsAtWallet, aC_Lucid, amount) {
    // console.log("storeWallet - createValue_Adding_Tokens_Of_AC_Lucid - unit: " + unit + " - amount: " + amount)
    const [CS, TN_Hex] = splitTokenLucidKey(aC_Lucid);
    const isADA = aC_Lucid === 'lovelace';
    const isWithoutTokenName = !isADA && TN_Hex === '';
    const assets = {};
    // console.log("storeWallet - createValue_Adding_Tokens_Of_AC_Lucid - isADA: " + isADA + " - isWithoutTokenName: " + isWithoutTokenName)
    if (isWithoutTokenName) {
        let total = 0n;
        uTxOsAtWallet.forEach((u) => {
            if (total < amount) {
                for (const [key, value] of Object.entries(u.assets)) {
                    if (total < amount) {
                        const [CS_, TN_Hex_] = splitTokenLucidKey(key);
                        if (CS === CS_) {
                            //console.log("storeWallet - createValue_Adding_Tokens_Of_AC_Lucid - CS: " + CS + " - CS_: " + CS_ + " - value: " + value)
                            if (total + value < amount) {
                                total += value;
                                assets[key] = value;
                            }
                            else if (total + value === amount) {
                                total += value;
                                assets[key] = value;
                                return assets;
                            }
                            else {
                                const rest = amount - total;
                                total += rest;
                                assets[key] = rest;
                                return assets;
                            }
                        }
                    }
                }
            }
        });
    }
    else {
        assets[aC_Lucid] = amount;
    }
    // console.log("storeWallet - createValue_Adding_Tokens_Of_AC_Lucid - assets: " + log( assets))
    return assets;
}
//---------------------------------------------------------------
function getTotalOfUnitInUTxOList(aC_Lucid, uTxOsAtWallet, swOnlyAvailable = false) {
    //swOnlyAvailable: available for spending
    //console.log("storeWallet - getTotalOfUnit - unit: " + aC_Lucid)
    const [CS, TN_Hex] = splitTokenLucidKey(aC_Lucid);
    const isADA = isTokenADA(CS, TN_Hex);
    if (isADA) {
        aC_Lucid = 'lovelace';
    }
    const isWithoutTokenName = !isADA && TN_Hex === '';
    //console.log("storeWallet - getTotalOfUnit - isADA: " + isADA + " - isWithoutTokenName: " + isWithoutTokenName)
    let total = 0n;
    let requiredAdaForTokens = 0n; // Sum of minimum ADA required for UTxOs with tokens
    uTxOsAtWallet.forEach((u) => {
        if (isADA) {
            // Calculate the total ADA considering or not the ADA locked with tokens
            const minAdaForThisUTxO = calculateMinAdaOfUTxO(u);
            requiredAdaForTokens += minAdaForThisUTxO;
            total += u.assets[aC_Lucid];
        }
        else if (isWithoutTokenName) {
            for (const [key, value] of Object.entries(u.assets)) {
                const [CS_, TN_Hex_] = splitTokenLucidKey(key);
                if (CS === CS_) {
                    total += value;
                }
            }
        }
        else {
            if (u.assets[aC_Lucid])
                total += u.assets[aC_Lucid];
        }
    });
    // When only the available ADA is requested, subtract the ADA required for UTxOs with tokens
    // and consider the margin for transaction fees.
    if (isADA && swOnlyAvailable) {
        // Subtract the required ADA for tokens and the fee margin from the total ADA
        total = total - requiredAdaForTokens - _Constants_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .ADA_TX_FEE_MARGIN */ .i5;
        if (total < 0n)
            total = 0n;
    }
    //console.log("storeWallet - getTotalOfUnit - total: " + total)
    return BigInt(total.toString());
}
//---------------------------------------------------------------
function getAssetsFromCS(assets, token_CS) {
    const assetsRes = {};
    for (const [key, value] of Object.entries(assets)) {
        let [CS_, TN_Hex_] = splitTokenLucidKey(key);
        const isADA = isTokenADA(CS_, TN_Hex_);
        if (isADA) {
            CS_ = '';
        }
        if (token_CS === 'lovelace') {
            token_CS = '';
        }
        if (token_CS === CS_) {
            assetsRes[key] = value;
        }
    }
    return assetsRes;
}
//---------------------------------------------------------------
function isNFT_With_AC_Lucid_InValue(assets, aC_Lucid) {
    let aC_Lucid2 = aC_Lucid;
    if (aC_Lucid === 'lovelace') {
        aC_Lucid2 = '';
    }
    if (aC_Lucid in assets || aC_Lucid2 in assets) {
        if (assets[aC_Lucid] === 1n) {
            return true;
        }
        else {
            if (assets[aC_Lucid2] === 1n) {
                return true;
            }
            else {
                return false;
            }
        }
    }
    else {
        return false;
    }
}
//---------------------------------------------------------------
function isToken_With_AC_Lucid_InValue(assets, aC_Lucid) {
    let aC_Lucid2 = aC_Lucid;
    if (aC_Lucid === 'lovelace') {
        aC_Lucid2 = '';
    }
    if (aC_Lucid in assets || aC_Lucid2 in assets) {
        if (assets[aC_Lucid] > 0n) {
            return true;
        }
        else {
            if (assets[aC_Lucid2] > 0n) {
                return true;
            }
            else {
                return false;
            }
        }
    }
    else {
        return false;
    }
}
//---------------------------------------------------------------
//for finding UTxO that is different to txOutRef
function find_UTxO_Excluding_UTxO_In_UTxOs(uTxO, UTxOs) {
    for (let i = 0; i < UTxOs.length; i++) {
        if (UTxOs[i] !== uTxO)
            return UTxOs[i];
    }
    return undefined;
}
//---------------------------------------------------------------
//for finding UTxO that is different to txOutRef
function find_UTxO_Excluding_TxOutRef_In_UTxOs(txOutRef, UTxOs) {
    for (let i = 0; i < UTxOs.length; i++) {
        if (UTxOs[i].txHash !== txOutRef.txHash || UTxOs[i].outputIndex !== txOutRef.outputIndex) {
            return UTxOs[i];
        }
    }
    return undefined;
}
//---------------------------------------------------------------
//for finding UTxO that match the txOutRef. Is just the same txOutRef with more data.
function find_TxOutRef_In_UTxOs(txOutRef, uTxOs) {
    for (let i = 0; i < uTxOs.length; i++) {
        if (uTxOs[i].txHash === txOutRef.txHash && uTxOs[i].outputIndex === txOutRef.outputIndex) {
            return uTxOs[i];
        }
    }
    return undefined;
}
//---------------------------------------------------------------
//for finding UTxO that match the txOutRef. Is just the same txOutRef with more data.
function find_UTxO_In_UTxOs(uTxO, uTxOs) {
    for (let i = 0; i < uTxOs.length; i++) {
        if (uTxOs[i].txHash === uTxO.txHash && uTxOs[i].outputIndex === uTxO.outputIndex) {
            return uTxOs[i];
        }
    }
    return undefined;
}
//------------------------------------------------------
function findSmallerUTxO(uTxOs) {
    // if (eUTxOs.length === 0) return undefined
    let [min, minIndex] = [calculateMinAdaOfAssets(uTxOs[0].assets), 0];
    for (let i = 1; i < uTxOs.length; i++) {
        const min_ = calculateMinAdaOfAssets(uTxOs[i].assets);
        if (min_ < min) {
            min = min_;
            minIndex = i;
        }
    }
    return uTxOs[minIndex];
}
//------------------------------------------------------
function findUTxOWithAssets(utxos, value) {
    for (const uTxO of utxos) {
        if (isIncludeValue(value, uTxO.assets)) {
            return uTxO;
        }
    }
    return undefined;
}
//------------------------------------------------------
// export async function findDatumIfMissing(lucid: Lucid, uTxO: UTxO): Promise<UTxO> {
//     console.log ("findDatumIfMissing")
//     if (uTxO.datumHash && !uTxO.datum) {
//         console.log(`findDatumIfMissing - searching datumHash in Database: ${uTxO.datumHash}`)
//         const datum = await apiGetDatumDB(uTxO.datumHash);
//         if (datum) {
//             console.log(`findDatumIfMissing - datum in Database: ${uTxO.datum}`)
//             uTxO.datum = datum;
//         } else {
//             console.log ("findDatumIfMissing - looking for datumHash in lucid")
//             uTxO.datum = await lucid.config().provider.getDatum(uTxO.datumHash);
//             if (uTxO.datum) {
//                 //console.log(`findDatumIfMissing - datum in lucid: ${uTxO.datum }`)
//                 console.log ("findDatumIfMissing - saving datumHash in Database")
//                 await apiSaveDatumDB(uTxO.datumHash, uTxO.datum);
//             } else {
//                 console.error ("findDatumIfMissing - datumHash not found in lucid" )
//             }
//         }
//         return uTxO;
//     }
//     return uTxO;
// }
//---------------------------------------------------------------
function calculateMinAda(thereIsADAAsset, numAssets, sumAssetNameLengths, numPIDs, isHash, datumBytes, scriptBytes) {
    const pidSize = 28;
    const coinsPerUTxOByte = 4310;
    const constantOverheadBytes = 160;
    const hashWords = isHash ? 10 : 0; //si hay data hash suman 10 words
    const hashBytes = hashWords * 8; //si hay data hash suman 10 words
    const addressBytes = 63;
    let extraForAssets = numAssets * 5;
    let sizeBytes = sumAssetNameLengths + numPIDs * pidSize + extraForAssets;
    let sizeBytes2 = sizeBytes + addressBytes + hashBytes + datumBytes + scriptBytes;
    if (sizeBytes2 < 67)
        sizeBytes2 = 67;
    let minADA = coinsPerUTxOByte * (constantOverheadBytes + sizeBytes2);
    let minADAExtra = Math.floor((130 * minADA) / 100); // HACK: 30% mas
    //console.log(toJson({ minADA, minADAExtra, sizeBytes2, thereIsADAAsset, numAssets, sumAssetNameLengths, numPIDs, isHash, datumBytes, scriptBytes }));
    return BigInt(minADAExtra);
}
function calculateNumAssetsAndPIDS(assets) {
    let numPIDs = 0, numAssets = 0, sumAssetNameLengths = 0;
    const pIds = [];
    let swADA = false;
    for (const [key, value] of Object.entries(assets)) {
        if (key !== 'lovelace') {
            const [CS, TN_Hex] = splitTokenLucidKey(key);
            if (!(0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .searchValueInArray */ .z2)(pIds, CS)) {
                pIds.push(CS);
                numPIDs++;
            }
            sumAssetNameLengths += TN_Hex.length / 2;
        }
        else {
            swADA = true;
        }
        numAssets++;
    }
    return { numAssets, sumAssetNameLengths, numPIDs, swADA };
}
//---------------------------------------------------------------
function calculateMinAdaOfAssets(assets) {
    let { numAssets, sumAssetNameLengths, numPIDs, swADA } = calculateNumAssetsAndPIDS(assets);
    const minADA = calculateMinAda(swADA, numAssets, sumAssetNameLengths, numPIDs, false, 0, 0);
    return minADA;
}
function calculateMinAdaOfUTxO(UTxO) {
    let { numAssets, sumAssetNameLengths, numPIDs, swADA } = calculateNumAssetsAndPIDS(UTxO.assets);
    const scriptBytes = UTxO.scriptRef ? UTxO.scriptRef.script.length / 2 + 20 : 0;
    const datumBytes = UTxO.datum ? UTxO.datum.length / 2 + 7 : 0;
    const minADA = calculateMinAda(swADA, numAssets, sumAssetNameLengths, numPIDs, false, datumBytes, scriptBytes);
    return minADA;
}
//---------------------------------------------------------------
function calculateMinAda_OLD(numAssets, sumAssetNameLengths, numPIDs, isHash) {
    //Fixed parameters
    const minUTxOValue = 1_000_000;
    //ADA	The minimum number of ADA that must be present in ADA-only UTxOs.
    const pidSize = 28;
    //Bytes	The number of bytes in a policy ID.
    const coinSize = 2;
    //Bytes	At the Alonzo HFC, this parameter was corrected to be 2 because the original value 0 was an implementation error.
    const utxoEntrySizeWithoutVal = 27;
    //Bytes	The number of bytes in a transaction if there were no value at all in it.
    const adaOnlyUTxOSize = Math.round(utxoEntrySizeWithoutVal + coinSize);
    //Bytes	The number of bytes in a transaction if it were to only contain ADA.
    const coinsPerUTxOWord = Math.floor(minUTxOValue / adaOnlyUTxOSize); // = 34482
    // const coinsPerUTxOByte = Math.floor(coinsPerUTxOWord / 8); // = 4310.25
    const hash = isHash ? 10 : 0; //si hay data hash suman 10 words
    function roundupBytesToWords(b) {
        return Math.floor((b + 7) / 8);
    }
    const sizeWords = 6 + roundupBytesToWords(numAssets * 12 + sumAssetNameLengths + numPIDs * pidSize);
    let minADA = Math.max(minUTxOValue, coinsPerUTxOWord * (utxoEntrySizeWithoutVal + sizeWords + hash));
    minADA = Math.floor((130 * minADA) / 100); // HACK: 30% mas
    return BigInt(minADA);
}
function calculateNumAssetsAndPIDS_OLD(assets) {
    let numPIDs = 0, numAssets = 0, sumAssetNameLengths = 0;
    const pIds = [];
    for (const [key, value] of Object.entries(assets)) {
        if (key !== 'lovelace') {
            const pId = key.slice(0, 56);
            const tn = key.slice(56);
            if (!searchValueInArray(pIds, pId)) {
                pIds.push(pId);
                numPIDs++;
            }
            sumAssetNameLengths += tn.length / 2;
        }
        numAssets++;
    }
    return { numAssets, sumAssetNameLengths, numPIDs };
}
//---------------------------------------------------------------
function calculateMinAdaOfAssets_OLD(assets, isHash) {
    let { numAssets, sumAssetNameLengths, numPIDs } = calculateNumAssetsAndPIDS_OLD(assets);
    const minADA = calculateMinAda_OLD(numAssets, sumAssetNameLengths, numPIDs, isHash);
    return minADA;
}
//---------------------------------------------------------------
function signDataByteString(privateKeyBench32, data) {
    //--------------------------------------
    const paymentKey = CML.PrivateKey.from_bech32(privateKeyBench32);
    //--------------------------------------
    const signedSigStruc = paymentKey.sign(data).to_raw_bytes();
    const signature = bytesUint8ArraToStringHex(signedSigStruc);
    //--------------------------------------
    return signature;
}
//---------------------------------------------------------------
async function signMessage(lucid, privateKeyCborHex, dataStr) {
    //--------------------------------------
    dataStr = dataStr.replace(/:/g, ': ').replace(/,/g, ', ').replace(/\"/g, "'");
    // console.log(`dataStr = ${dataStr}\n`);
    //--------------------------------------
    const dataHex = strToHex(dataStr);
    // console.log(`dataHex = ${dataHex}\n`);
    //--------------------------------------
    let privateKeyBytes = new Uint8Array(Buffer.from(privateKeyCborHex, 'hex'));
    // original length check before slicing
    if (privateKeyBytes.length === 34 || privateKeyBytes.length === 66) {
        privateKeyBytes = privateKeyBytes.slice(2);
    }
    let privateKey;
    if (privateKeyBytes.length === 32) {
        privateKey = CML.PrivateKey.from_normal_bytes(privateKeyBytes);
    }
    else if (privateKeyBytes.length === 64) {
        privateKey = CML.PrivateKey.from_extended_bytes(privateKeyBytes);
    }
    else {
        throw new Error(`Invalid private key length: ${privateKeyBytes.length}`);
    }
    const privateKeyBench32 = privateKey.to_bech32();
    //--------------------------------------
    lucid.selectWallet.fromPrivateKey(privateKeyBench32);
    //--------------------------------------
    const address = await lucid.wallet().address();
    //--------------------------------------
    const signature = await lucid.wallet().signMessage(address, dataHex);
    //--------------------------------------
    return signature;
}
function verifyMessage(lucid, publicKeyCborHex, dataStr, signature, network_id) {
    //--------------------------------------
    dataStr = dataStr.replace(/:/g, ': ').replace(/,/g, ', ').replace(/\"/g, "'");
    // console.log(`dataStr = ${dataStr}\n`);
    const dataHex = strToHex(dataStr);
    // console.log(`dataHex = ${dataHex}\n`);
    //--------------------------------------
    const address = getAddressFromKeyCborHex(publicKeyCborHex, network_id);
    // console.log(`address = ${address}\n`);
    //--------------------------------------
    const { paymentCredential, stakeCredential, address: { bech32, hex }, } = getAddressDetails(address);
    //--------------------------------------
    const keyHash = paymentCredential?.hash || stakeCredential?.hash;
    //--------------------------------------
    if (!keyHash)
        throw new Error('Not a valid address provided.');
    //--------------------------------------
    return verifyData(hex, keyHash, dataHex, signature);
    //--------------------------------------
}
//---------------------------------------------------------------
function calculateEpochFromSlot(slot, network_name) {
    network_name = network_name !== undefined ? network_name : "Mainnet";
    let slotsPerEpoch = slotsPerEpochForLucid[network_name];
    if (slotsPerEpoch === undefined) {
        throw new Error('Unsupported network type');
    }
    return Math.floor(slot / slotsPerEpoch);
}
//---------------------------------------------------------------
//# sourceMappingURL=helpers.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 37813:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$dX": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.$d; },
/* harmony export */   "AbK": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.Ab; },
/* harmony export */   "B4E": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.B4; },
/* harmony export */   "DNq": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.DN; },
/* harmony export */   "F2s": function() { return /* reexport safe */ _Decorators_Decorator_asSmartDBEntity_js__WEBPACK_IMPORTED_MODULE_4__.F; },
/* harmony export */   "Fi7": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.Fi; },
/* harmony export */   "Gre": function() { return /* reexport safe */ _helpers_js__WEBPACK_IMPORTED_MODULE_12__.Gr; },
/* harmony export */   "HD0": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__.HD; },
/* harmony export */   "Itp": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.It; },
/* harmony export */   "Kn2": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__.Kn; },
/* harmony export */   "MQB": function() { return /* reexport safe */ _pushNotification_js__WEBPACK_IMPORTED_MODULE_13__.M; },
/* harmony export */   "NI2": function() { return /* reexport safe */ _formatters_js__WEBPACK_IMPORTED_MODULE_11__.NI; },
/* harmony export */   "NdO": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__.Nd; },
/* harmony export */   "OOZ": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.OO; },
/* harmony export */   "Pem": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.Pe; },
/* harmony export */   "Qnt": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.Qn; },
/* harmony export */   "Qr$": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__.Qr; },
/* harmony export */   "QsJ": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__.Qs; },
/* harmony export */   "R0t": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__.R0; },
/* harmony export */   "Rm5": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.Rm; },
/* harmony export */   "SOG": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.SO; },
/* harmony export */   "Sb4": function() { return /* reexport safe */ _Decorators_registerManager_js__WEBPACK_IMPORTED_MODULE_9__.S; },
/* harmony export */   "Soz": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__.So; },
/* harmony export */   "T2L": function() { return /* reexport safe */ _yupLocale_js__WEBPACK_IMPORTED_MODULE_17__.T; },
/* harmony export */   "TgP": function() { return /* reexport safe */ _formatters_js__WEBPACK_IMPORTED_MODULE_11__.Tg; },
/* harmony export */   "TuU": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.Tu; },
/* harmony export */   "V8b": function() { return /* reexport safe */ _helpers_js__WEBPACK_IMPORTED_MODULE_12__.V8; },
/* harmony export */   "V9b": function() { return /* reexport safe */ _helpers_js__WEBPACK_IMPORTED_MODULE_12__.V9; },
/* harmony export */   "Wkp": function() { return /* reexport safe */ _helpers_js__WEBPACK_IMPORTED_MODULE_12__.Wk; },
/* harmony export */   "XqG": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.Xq; },
/* harmony export */   "Xy7": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__.fV; },
/* harmony export */   "Xyp": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__.Xy; },
/* harmony export */   "YS1": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.YS; },
/* harmony export */   "YW2": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.YW; },
/* harmony export */   "_rQ": function() { return /* reexport safe */ _helpers_js__WEBPACK_IMPORTED_MODULE_12__._r; },
/* harmony export */   "_vH": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__._v; },
/* harmony export */   "bsJ": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.bs; },
/* harmony export */   "dMk": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__.rK; },
/* harmony export */   "e0x": function() { return /* reexport safe */ _Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_6__.e0; },
/* harmony export */   "gKj": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.gK; },
/* harmony export */   "hbx": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.hb; },
/* harmony export */   "hpm": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.hp; },
/* harmony export */   "n6t": function() { return /* reexport safe */ _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__.n6; },
/* harmony export */   "nUd": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__.nU; },
/* harmony export */   "o4X": function() { return /* reexport safe */ _pushNotification_js__WEBPACK_IMPORTED_MODULE_13__.o; },
/* harmony export */   "pzN": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__.pz; },
/* harmony export */   "q$g": function() { return /* reexport safe */ _helpers_js__WEBPACK_IMPORTED_MODULE_12__.q$; },
/* harmony export */   "rCT": function() { return /* reexport safe */ _types_js__WEBPACK_IMPORTED_MODULE_14__.rC; },
/* harmony export */   "sa8": function() { return /* reexport safe */ _formatters_js__WEBPACK_IMPORTED_MODULE_11__.s; },
/* harmony export */   "tA8": function() { return /* reexport safe */ _types_js__WEBPACK_IMPORTED_MODULE_14__.tA; },
/* harmony export */   "uns": function() { return /* reexport safe */ _explainError_js__WEBPACK_IMPORTED_MODULE_10__.u; },
/* harmony export */   "xSF": function() { return /* reexport safe */ _Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_6__.xS; },
/* harmony export */   "yhV": function() { return /* reexport safe */ _utils_js__WEBPACK_IMPORTED_MODULE_16__.yh; }
/* harmony export */ });
/* harmony import */ var _Constants_constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27001);
/* harmony import */ var _conversions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69623);
/* harmony import */ var _data_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66146);
/* harmony import */ var _Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2607);
/* harmony import */ var _Decorators_Decorator_asSmartDBEntity_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12676);
/* harmony import */ var _Decorators_Decorator_BackEndAppliedFor_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87502);
/* harmony import */ var _Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19083);
/* harmony import */ var _Decorators_Decorator_MongoAppliedFor_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67139);
/* harmony import */ var _Decorators_Decorator_PostgreSQLAppliedFor_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15760);
/* harmony import */ var _Decorators_registerManager_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91189);
/* harmony import */ var _explainError_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73582);
/* harmony import */ var _formatters_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86081);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36394);
/* harmony import */ var _pushNotification_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31647);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(94104);
/* harmony import */ var _typesPlutus_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70726);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(75672);
/* harmony import */ var _yupLocale_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(96548);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_conversions_js__WEBPACK_IMPORTED_MODULE_1__, _data_js__WEBPACK_IMPORTED_MODULE_2__, _helpers_js__WEBPACK_IMPORTED_MODULE_12__, _typesPlutus_js__WEBPACK_IMPORTED_MODULE_15__]);
([_conversions_js__WEBPACK_IMPORTED_MODULE_1__, _data_js__WEBPACK_IMPORTED_MODULE_2__, _helpers_js__WEBPACK_IMPORTED_MODULE_12__, _typesPlutus_js__WEBPACK_IMPORTED_MODULE_15__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);



















//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 31647:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ pushWarningNotification; },
/* harmony export */   "o": function() { return /* binding */ pushSucessNotification; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_notifications_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1818);


const { Store } = react_notifications_component__WEBPACK_IMPORTED_MODULE_1__;
//---------------------------------------------------------------
const messageComponent = (message) => (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { dangerouslySetInnerHTML: { __html: message } });
function pushSucessNotification(title, mesagge, swHash = true) {
    let messageForNotification;
    if (swHash) {
        messageForNotification = 'Ok! TxHash: ' + mesagge;
    }
    else {
        messageForNotification = 'Ok! ' + mesagge;
    }
    Store.addNotification({
        title: `${title}`,
        message: messageComponent(`${messageForNotification}`),
        type: 'success',
        insert: 'bottom',
        container: 'bottom-right',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        width: 400,
        dismiss: {
            duration: 3000,
            onScreen: true,
            pauseOnHover: true,
        },
    });
}
//---------------------------------------------------------------
function pushWarningNotification(title, error) {
    Store.addNotification({
        title: `${title}`,
        message: messageComponent(`${error?.info || error?.message || error || ''}`),
        type: 'warning',
        insert: 'bottom',
        container: 'bottom-right',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        width: 400,
        dismiss: {
            duration: 3000,
            onScreen: true,
            pauseOnHover: true,
        },
    });
}
//# sourceMappingURL=pushNotification.js.map

/***/ }),

/***/ 94104:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FH": function() { return /* binding */ optionsGetMinimal; },
/* harmony export */   "rC": function() { return /* binding */ optionsGetOneDefault; },
/* harmony export */   "tA": function() { return /* binding */ optionsGetDefault; }
/* harmony export */ });
/* unused harmony exports optionsGetMinimalWithCallBack, optionsGetMinimalWithSmartUTxO, optionsGetMinimalWithSmartUTxOCompleteFields, optionsGetMinimalWithSmartUTxOWithDates, optionsGetAllFields, optionsCreateOrUpdateDefault, optionsDeleteDefault, lookUpFieldsSchema, yupValidateOptionsGet, yupValidateOptionsGetOne, yupValidateOptionsCreate, yupValidateOptionsUpdate, yupValidateOptionsDelete, scriptSchema, utxoSchema, walletTxParamsSchema */
/* harmony import */ var _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96548);

const optionsGetDefault = {
    // se isan cuando no hay options get seteadas
    skip: undefined,
    limit: undefined,
    sort: undefined,
    fieldsForSelect: undefined, // al ser undefined se remplaza por defaultFieldsWhenUndefined, que es {} por default. {} son todos los campos
    doCallbackAfterLoad: false,
    loadRelations: undefined, // levanta las relaciones segun la definicion de cada entidad de esa relacion
    optionsGetForRelation: undefined,
    // primero veo si vienen option get para la relacion en particular
    // si no, cargo las que estan en la conversion en la definicion de la entidad padre y si no hay, cargo con las mismas opciones las mismas de la entidad padre
    checkRelations: false,
    lookUpFields: undefined,
};
const optionsGetMinimal = {
    skip: undefined,
    limit: undefined,
    sort: undefined,
    fieldsForSelect: { _id: true }, // solo trae el campo id, si lo seteo en {} trae todos los campos
    doCallbackAfterLoad: false,
    loadRelations: {}, // no levanta relaciones
    optionsGetForRelation: undefined,
    checkRelations: false,
    lookUpFields: undefined,
};
const optionsGetMinimalWithCallBack = { ...optionsGetMinimal, doCallbackAfterLoad: true };
const optionsGetMinimalWithSmartUTxO = {
    skip: undefined,
    limit: undefined,
    sort: undefined,
    fieldsForSelect: { _id: true },
    doCallbackAfterLoad: false,
    loadRelations: { smartUTxO_id: true },
    optionsGetForRelation: { smartUTxO_id: { ...optionsGetMinimalWithCallBack, fieldsForSelect: { txHash: true, outputIndex: true } } },
    checkRelations: false,
    lookUpFields: undefined,
};
const optionsGetMinimalWithSmartUTxOCompleteFields = {
    ...optionsGetMinimalWithSmartUTxO,
    optionsGetForRelation: { smartUTxO_id: { ...optionsGetMinimalWithCallBack, fieldsForSelect: {} } },
};
const optionsGetMinimalWithSmartUTxOWithDates = {
    ...optionsGetMinimalWithSmartUTxO,
    optionsGetForRelation: { smartUTxO_id: { ...optionsGetMinimalWithCallBack, fieldsForSelect: {} } },
};
const optionsGetAllFields = {
    fieldsForSelect: {},
};
const optionsGetOneDefault = {
    sort: undefined,
    fieldsForSelect: undefined,
    doCallbackAfterLoad: false,
    loadRelations: undefined,
    optionsGetForRelation: undefined,
    checkRelations: false,
    lookUpFields: undefined,
};
const optionsCreateOrUpdateDefault = {
    doCallbackAfterLoad: false,
    saveRelations: undefined,
    loadRelations: undefined,
};
const optionsDeleteDefault = {
    deleteRelations: undefined,
};
// Schema for validating LookUpFields
const lookUpFieldsSchema = _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object().shape({
    from: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T.string().required(),
    localField: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T.string().required(),
    foreignField: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T.string().required(),
    as: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T.string().required(),
    fieldsForSelect: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object()
        .test('valid-fieldsForSelect', 'FieldsForSelect must be an object with fields and boolean values.', (value) => !value || Object.values(value).every((val) => typeof val === 'boolean')),
});
// Define a placeholder outside the schema to reference it recursively
const optionsGetSchemaPlaceholder = {};
//-------------------------------------------------------------
const yupValidateOptionsGet = {
    skip: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.number */ .T.number().positive().integer().optional(),
    limit: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.number */ .T.number().positive().integer().optional(),
    sort: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object()
        .test('valid-sort', 'Sort must be an object with fields and number values indicating order direction.', (value) => !value || Object.values(value).every((val) => typeof val === 'number' && (val === 1 || val === -1))),
    fieldsForSelect: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object()
        .test('valid-fieldsForSelect', 'FieldsForSelect must be an object with fields and boolean values.', (value) => !value || Object.values(value).every((val) => typeof val === 'boolean')),
    doCallbackAfterLoad: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.boolean */ .T.boolean().optional(),
    loadRelations: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object()
        .test('valid-loadRelations', 'LoadRelations must be an object with relations and boolean values.', (value) => !value || Object.values(value).every((val) => typeof val === 'boolean')),
    //optionsGetForRelation: yup.lazy(() => optionsGetSchemaPlaceholder),
    checkRelations: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.boolean */ .T.boolean().optional(),
    lookUpFields: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.array */ .T.array().of(lookUpFieldsSchema).optional(),
};
// // Assign the actual schema to the placeholder to enable recursion
// optionsGetSchemaPlaceholder.__isYupSchema__ = true;
// optionsGetSchemaPlaceholder.innerType = yupValidateOptionsGet;
const yupValidateOptionsGetOne = {
    sort: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object()
        .test('valid-sort', 'Sort must be an object with fields and number values indicating order direction.', (value) => !value || Object.values(value).every((val) => typeof val === 'number' && (val === 1 || val === -1))),
    fieldsForSelect: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object()
        .test('valid-fieldsForSelect', 'FieldsForSelect must be an object with fields and boolean values.', (value) => !value || Object.values(value).every((val) => typeof val === 'boolean')),
    doCallbackAfterLoad: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.boolean */ .T.boolean().optional(),
    loadRelations: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object()
        .test('valid-loadRelations', 'LoadRelations must be an object with relations and boolean values.', (value) => !value || Object.values(value).every((val) => typeof val === 'boolean')),
    //optionsGetForRelation: yup.lazy(() => optionsGetSchemaPlaceholder),
    checkRelations: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.boolean */ .T.boolean().optional(),
    lookUpFields: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.array */ .T.array().of(lookUpFieldsSchema).optional(),
};
const yupValidateOptionsCreate = {
    doCallbackAfterLoad: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.boolean */ .T.boolean().optional(),
    saveRelations: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object()
        .test('valid-saveRelations', 'SaveRelations must be an object with relations and boolean values.', (value) => !value || Object.values(value).every((val) => typeof val === 'boolean')),
    loadRelations: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object()
        .test('valid-loadRelations', 'LoadRelations must be an object with relations and boolean values.', (value) => !value || Object.values(value).every((val) => typeof val === 'boolean')),
};
const yupValidateOptionsUpdate = (/* unused pure expression or super */ null && (yupValidateOptionsCreate));
const yupValidateOptionsDelete = {
    deleteRelations: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object().test('valid-deleteRelations', 'DeleteRelations must be an object with relations and boolean values.', (value) => {
        return !value || Object.values(value).every((val) => typeof val === 'boolean');
    }),
};
//-------------------------------------------------------------
const scriptSchema = _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object().shape({
    type: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.mixed */ .T.mixed().oneOf(['Native', 'PlutusV1', 'PlutusV2', 'PlutusV3']).required(),
    script: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T.string().required(),
});
const utxoSchema = _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object().shape({
    txHash: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T.string().required(),
    outputIndex: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.number */ .T.number().required(),
    assets: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object().required(), // Define the schema for Assets if needed
    address: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T.string().required(),
    datumHash: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T.string().optional().nullable(),
    datum: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T.string().optional().nullable(),
    // scriptRef: yup.lazy((value) =>
    //     value === undefined ? yup.mixed().optional() : scriptSchema.required()
    // ),
    // scriptRef2: yup.lazy((value) => {
    //     return value ? scriptSchema.required() : yup.object().notRequired().nullable();
    //   }),
});
const walletTxParamsSchema = _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.object */ .T.object().shape({
    pkh: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T.string().required(),
    stakePkh: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T.string().optional(),
    address: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T.string().required(),
    rewardAddress: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.string */ .T.string().optional(),
    utxos: _yupLocale_js__WEBPACK_IMPORTED_MODULE_0__/* .yup.array */ .T.array().of(utxoSchema).required(),
});
//------------------------------------------
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 70726:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zQ": function() { return /* binding */ TxOutRef; }
/* harmony export */ });
/* unused harmony exports AssetClass, Maybe, MinMaxDef */
/* harmony import */ var _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76100);
/* harmony import */ var _data_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66146);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__, _data_js__WEBPACK_IMPORTED_MODULE_1__]);
([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__, _data_js__WEBPACK_IMPORTED_MODULE_1__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);



//-------------------------------------------------------------
//lo uso como class a diferencia del resto, por que a la hora de convertir el datum y el redeemer a plutusData, el campo de Hash aqui no se convierte igual que un string y si no tengo clase no podria diferenciarlo de una string en ese momento.
class TxOutRef {
    constructor(txHash, outputIndex) {
        this._plutusDataIndex = 0;
        this.txHash = txHash;
        this.outputIndex = outputIndex;
    }
    toPlutusData() {
        let list = [];
        list.push(new _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Constr */ .fL(0, [this.txHash]));
        list.push(this.outputIndex);
        const res = new _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Constr */ .fL(this._plutusDataIndex, list);
        return res;
    }
}
//-------------------------------------------------------------
class AssetClass {
    constructor(CS, TN) {
        this._plutusDataIndex = 0;
        this.CS = CS;
        this.TN = TN;
    }
    toPlutusData() {
        let list = [this.CS, this.TN];
        const res = new Constr(this._plutusDataIndex, list);
        return res;
    }
    static fromPlutusData(lucidDataForDatum) {
        const objectInstance = {};
        if (lucidDataForDatum.index === 0) {
            const lucidDataForConstr0 = lucidDataForDatum.fields;
            if (lucidDataForConstr0.length === 2) {
                objectInstance.CS = lucidDataForConstr0[0];
                objectInstance.TN = lucidDataForConstr0[1];
                return new this(objectInstance.CS, objectInstance.TN);
            }
        }
        throw `MinMaxDef - Can't get from Datum`;
    }
    static fromPlainObject(value) {
        const instance = new AssetClass(value.CS, value.TN);
        return instance;
    }
    to_AC_Lucid() {
        let result = this.CS + this.TN;
        return result;
    }
    static from_AC_Lucid(token_AC_Lucid) {
        let result = new AssetClass(token_AC_Lucid.slice(0, 56), token_AC_Lucid.slice(56));
        return result;
    }
}
//-------------------------------------------------------------
class Maybe {
    constructor(val) {
        this._plutusDataIndex = 0 | 1;
        if (val !== undefined) {
            this.val = val;
            this._plutusDataIndex = 0;
        }
        else {
            this.val = undefined;
            this._plutusDataIndex = 1;
        }
    }
    // public static toPlainObject(value: any | undefined): any | undefined {
    //     return value?.val;
    // }
    static fromPlainObject(value) {
        const instance = new Maybe(value?.val);
        return instance;
    }
    // public static toPlainObject_BigInt(value: any | undefined): any | undefined {
    //     return value?.val?.toString();
    // }
    static fromPlainObject_BigInt(value) {
        const val = value?.val === undefined ? undefined : BigInt(value?.val);
        const instance = new Maybe(val);
        return instance;
    }
    toPlutusData() {
        const res = new Constr(this._plutusDataIndex, this.val !== undefined ? [itemToLucidData(this.val, `Maybe Val`)] : []);
        return res;
    }
    static fromPlutusData(lucidDataForDatum) {
        if (lucidDataForDatum.index === 0) {
            if (lucidDataForDatum.fields.length === 1) {
                return new Maybe(lucidDataForDatum.fields[0]);
            }
        }
        else if (lucidDataForDatum.index === 1) {
            if (lucidDataForDatum.fields.length === 0) {
                return new Maybe();
            }
        }
        throw `Maybe - Can't get from Datum`;
    }
    //  public static fromPlutusData_Number = (lucidDataForDatum: any) => {
    static fromPlutusData_Number(lucidDataForDatum) {
        const maybeNumber = Maybe.fromPlutusData(lucidDataForDatum);
        if (maybeNumber.val !== undefined) {
            maybeNumber.val = Number(maybeNumber.val);
        }
        return maybeNumber;
    }
    ;
}
//-------------------------------------------------------------
class MinMaxDef extends (/* unused pure expression or super */ null && (BaseConstructor)) {
    // public static toPlainObject_BigInt(value: any | undefined): any | undefined {
    //     if (value === undefined) return undefined
    //     let serialized: any = {
    //         mmdMin: value?.mmdMin?.toString(),
    //         mmdMax: value?.mmdMax?.toString(),
    //         mmdDef: value?.mmdDef?.toString()
    //     };
    //     return serialized
    // }
    isValid(min) {
        return ((min === undefined || min === null || (min !== undefined && min !== null && this.mmdMin >= min)) &&
            this.mmdMin <= this.mmdMax &&
            this.mmdMin <= this.mmdDef &&
            this.mmdDef <= this.mmdMax);
    }
    static fromPlainObject_BigInt(value) {
        if (value === undefined)
            return undefined;
        const instance = new MinMaxDef({
            mmdMin: BigInt(value?.mmdMin),
            mmdMax: BigInt(value?.mmdMax),
            mmdDef: BigInt(value?.mmdDef),
        });
        return instance;
    }
    toPlutusData() {
        let list = [];
        list.push(itemToLucidData(this.mmdMin, `Min Max Def - min`));
        list.push(itemToLucidData(this.mmdMax, `Min Max Def - max`));
        list.push(itemToLucidData(this.mmdDef, `Min Max Def - def`));
        const res = new Constr(0, list);
        return res;
    }
    static fromPlutusData(lucidDataForDatum) {
        const objectInstance = {};
        if (lucidDataForDatum.index === 0) {
            const lucidDataForConstr0 = lucidDataForDatum.fields;
            if (lucidDataForConstr0.length === 3) {
                objectInstance.mmdMin = lucidDataForConstr0[0];
                objectInstance.mmdMax = lucidDataForConstr0[1];
                objectInstance.mmdDef = lucidDataForConstr0[2];
                return new this({ ...objectInstance });
            }
        }
        throw `MinMaxDef - Can't get from Datum`;
    }
    //public static fromPlutusData_Number = (lucidDataForDatum: any) => {
    static fromPlutusData_Number(lucidDataForDatum) {
        const mmd = MinMaxDef.fromPlutusData(lucidDataForDatum);
        mmd.mmdDef = Number(mmd.mmdDef);
        mmd.mmdMin = Number(mmd.mmdMin);
        mmd.mmdMax = Number(mmd.mmdMax);
        return mmd;
    }
    ;
}
//# sourceMappingURL=typesPlutus.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 75672:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R0": function() { return /* binding */ checkIfUserCanceled; },
  "yh": function() { return /* binding */ convertMillisToTime; },
  "Ly": function() { return /* binding */ convertUTCDateToLocalDate; },
  "So": function() { return /* binding */ createQueryURLString; },
  "nU": function() { return /* binding */ getTxRedeemersDetailsAndResources; },
  "Nd": function() { return /* binding */ hexToStr; },
  "Qr": function() { return /* binding */ isEmptyObject; },
  "Xy": function() { return /* binding */ isEqual; },
  "C4": function() { return /* binding */ isFrontEndEnvironment; },
  "fV": function() { return /* binding */ isNullOrBlank; },
  "Kn": function() { return /* binding */ isObject; },
  "Fi": function() { return /* binding */ isSameClass; },
  "HD": function() { return /* binding */ isString; },
  "Hd": function() { return /* binding */ isSubclassOf; },
  "FX": function() { return /* binding */ isValidHex; },
  "z2": function() { return /* binding */ searchValueInArray; },
  "rK": function() { return /* binding */ showData; },
  "_v": function() { return /* binding */ sleep; },
  "pz": function() { return /* binding */ strToHex; },
  "Qs": function() { return /* binding */ toJson; }
});

// UNUSED EXPORTS: addDays, bigIntMax, bytesUint8ArraToStringHex, bytesUint8ArraToStringHex2, calculateBackoffDelay, capitalizeFirstLetters, concatUint8Arrays, copyToClipboard, daysBetweenDates, delayCall, delayCallAsync, divide_By_Scaled_1e2_And_RoundDownSafe, divide_By_Scaled_1e6_And_RoundDownSafe, divide_By_Scaled_1e6_And_RoundUpSafe, divide_By_Scaled_And_RoundDownSafe, divide_By_Scaled_And_RoundUpSafe, divide_By_Scaled_BPx1e3_And_RoundDownSafe, endOfDay, executeFunction, generateRandomColor, generateRandomHash, getBigIntx1e6, getFieldsAndTypes, getInputValueFromSmallUnitPriceLovelace1xe6, getInstanceVariables, getNumberx1e6, getNumberxBPx1e3, getSmallUnitPriceLovelace1xe6FromInputValue, getUserTimeZone, htmlEscape, htmlUnescape, intToLetter, intToUint8Array, isAllowedTask, isArrayEmpty, isEmptyObject_usingJson, isPromiseFunction, isSameDay, isSubclassOf_Legacy, letterToInt, multiply_By_Scaled_1e2_And_RoundDown, multiply_By_Scaled_1e2_And_RoundUp, multiply_By_Scaled_1e6_And_RoundDown, multiply_By_Scaled_1e6_And_RoundUp, multiply_By_Scaled_And_RoundDown, multiply_By_Scaled_And_RoundUp, multiply_By_Scaled_BPx1e3_And_RoundDown, multiply_By_Scaled_BPx1e3_And_RoundUp, numberArrayToStringHex, removeValueFromArray, sanitizeForDatabase, searchAndGetKeyInObject, searchKeyInObject, setAndLoosePrecision, setAndLoosePrecision1e6GetOnlyNumerator, setAndLoosePrecision1e6GetOnlyNumeratorUsingBigInt, sha256HexStr, startOfDay, stringHexToNumberArray, stringHexToUint8Array, stringToUint8Array, subDays, truncateBigNumber

;// CONCATENATED MODULE: ./node_modules/bignumber.js/bignumber.mjs
/*
 *      bignumber.js v9.3.0
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */


var
  isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
  mathceil = Math.ceil,
  mathfloor = Math.floor,

  bignumberError = '[BigNumber Error] ',
  tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ',

  BASE = 1e14,
  LOG_BASE = 14,
  MAX_SAFE_INTEGER = 0x1fffffffffffff,         // 2^53 - 1
  // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
  POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
  SQRT_BASE = 1e7,

  // EDITABLE
  // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
  // the arguments to toExponential, toFixed, toFormat, and toPrecision.
  MAX = 1E9;                                   // 0 to MAX_INT32


/*
 * Create and return a BigNumber constructor.
 */
function clone(configObject) {
  var div, convertBase, parseNumeric,
    P = BigNumber.prototype = { constructor: BigNumber, toString: null, valueOf: null },
    ONE = new BigNumber(1),


    //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------


    // The default values below must be integers within the inclusive ranges stated.
    // The values can also be changed at run-time using BigNumber.set.

    // The maximum number of decimal places for operations involving division.
    DECIMAL_PLACES = 20,                     // 0 to MAX

    // The rounding mode used when rounding to the above decimal places, and when using
    // toExponential, toFixed, toFormat and toPrecision, and round (default value).
    // UP         0 Away from zero.
    // DOWN       1 Towards zero.
    // CEIL       2 Towards +Infinity.
    // FLOOR      3 Towards -Infinity.
    // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    ROUNDING_MODE = 4,                       // 0 to 8

    // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]

    // The exponent value at and beneath which toString returns exponential notation.
    // Number type: -7
    TO_EXP_NEG = -7,                         // 0 to -MAX

    // The exponent value at and above which toString returns exponential notation.
    // Number type: 21
    TO_EXP_POS = 21,                         // 0 to MAX

    // RANGE : [MIN_EXP, MAX_EXP]

    // The minimum exponent value, beneath which underflow to zero occurs.
    // Number type: -324  (5e-324)
    MIN_EXP = -1e7,                          // -1 to -MAX

    // The maximum exponent value, above which overflow to Infinity occurs.
    // Number type:  308  (1.7976931348623157e+308)
    // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
    MAX_EXP = 1e7,                           // 1 to MAX

    // Whether to use cryptographically-secure random number generation, if available.
    CRYPTO = false,                          // true or false

    // The modulo mode used when calculating the modulus: a mod n.
    // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
    // The remainder (r) is calculated as: r = a - n * q.
    //
    // UP        0 The remainder is positive if the dividend is negative, else is negative.
    // DOWN      1 The remainder has the same sign as the dividend.
    //             This modulo mode is commonly known as 'truncated division' and is
    //             equivalent to (a % n) in JavaScript.
    // FLOOR     3 The remainder has the same sign as the divisor (Python %).
    // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
    // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
    //             The remainder is always positive.
    //
    // The truncated division, floored division, Euclidian division and IEEE 754 remainder
    // modes are commonly used for the modulus operation.
    // Although the other rounding modes can also be used, they may not give useful results.
    MODULO_MODE = 1,                         // 0 to 9

    // The maximum number of significant digits of the result of the exponentiatedBy operation.
    // If POW_PRECISION is 0, there will be unlimited significant digits.
    POW_PRECISION = 0,                       // 0 to MAX

    // The format specification used by the BigNumber.prototype.toFormat method.
    FORMAT = {
      prefix: '',
      groupSize: 3,
      secondaryGroupSize: 0,
      groupSeparator: ',',
      decimalSeparator: '.',
      fractionGroupSize: 0,
      fractionGroupSeparator: '\xA0',        // non-breaking space
      suffix: ''
    },

    // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
    // '-', '.', whitespace, or repeated character.
    // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
    ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz',
    alphabetHasNormalDecimalDigits = true;


  //------------------------------------------------------------------------------------------


  // CONSTRUCTOR


  /*
   * The BigNumber constructor and exported function.
   * Create and return a new instance of a BigNumber object.
   *
   * v {number|string|BigNumber} A numeric value.
   * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
   */
  function BigNumber(v, b) {
    var alphabet, c, caseChanged, e, i, isNum, len, str,
      x = this;

    // Enable constructor call without `new`.
    if (!(x instanceof BigNumber)) return new BigNumber(v, b);

    if (b == null) {

      if (v && v._isBigNumber === true) {
        x.s = v.s;

        if (!v.c || v.e > MAX_EXP) {
          x.c = x.e = null;
        } else if (v.e < MIN_EXP) {
          x.c = [x.e = 0];
        } else {
          x.e = v.e;
          x.c = v.c.slice();
        }

        return;
      }

      if ((isNum = typeof v == 'number') && v * 0 == 0) {

        // Use `1 / n` to handle minus zero also.
        x.s = 1 / v < 0 ? (v = -v, -1) : 1;

        // Fast path for integers, where n < 2147483648 (2**31).
        if (v === ~~v) {
          for (e = 0, i = v; i >= 10; i /= 10, e++);

          if (e > MAX_EXP) {
            x.c = x.e = null;
          } else {
            x.e = e;
            x.c = [v];
          }

          return;
        }

        str = String(v);
      } else {

        if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);

        x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
      }

      // Decimal point?
      if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

      // Exponential form?
      if ((i = str.search(/e/i)) > 0) {

        // Determine exponent.
        if (e < 0) e = i;
        e += +str.slice(i + 1);
        str = str.substring(0, i);
      } else if (e < 0) {

        // Integer.
        e = str.length;
      }

    } else {

      // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
      intCheck(b, 2, ALPHABET.length, 'Base');

      // Allow exponential notation to be used with base 10 argument, while
      // also rounding to DECIMAL_PLACES as with other bases.
      if (b == 10 && alphabetHasNormalDecimalDigits) {
        x = new BigNumber(v);
        return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
      }

      str = String(v);

      if (isNum = typeof v == 'number') {

        // Avoid potential interpretation of Infinity and NaN as base 44+ values.
        if (v * 0 != 0) return parseNumeric(x, str, isNum, b);

        x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;

        // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
        if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) {
          throw Error
           (tooManyDigits + v);
        }
      } else {
        x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
      }

      alphabet = ALPHABET.slice(0, b);
      e = i = 0;

      // Check that str is a valid base b number.
      // Don't use RegExp, so alphabet can contain special characters.
      for (len = str.length; i < len; i++) {
        if (alphabet.indexOf(c = str.charAt(i)) < 0) {
          if (c == '.') {

            // If '.' is not the first character and it has not be found before.
            if (i > e) {
              e = len;
              continue;
            }
          } else if (!caseChanged) {

            // Allow e.g. hexadecimal 'FF' as well as 'ff'.
            if (str == str.toUpperCase() && (str = str.toLowerCase()) ||
                str == str.toLowerCase() && (str = str.toUpperCase())) {
              caseChanged = true;
              i = -1;
              e = 0;
              continue;
            }
          }

          return parseNumeric(x, String(v), isNum, b);
        }
      }

      // Prevent later check for length on converted number.
      isNum = false;
      str = convertBase(str, b, 10, x.s);

      // Decimal point?
      if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
      else e = str.length;
    }

    // Determine leading zeros.
    for (i = 0; str.charCodeAt(i) === 48; i++);

    // Determine trailing zeros.
    for (len = str.length; str.charCodeAt(--len) === 48;);

    if (str = str.slice(i, ++len)) {
      len -= i;

      // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
      if (isNum && BigNumber.DEBUG &&
        len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) {
          throw Error
           (tooManyDigits + (x.s * v));
      }

       // Overflow?
      if ((e = e - i - 1) > MAX_EXP) {

        // Infinity.
        x.c = x.e = null;

      // Underflow?
      } else if (e < MIN_EXP) {

        // Zero.
        x.c = [x.e = 0];
      } else {
        x.e = e;
        x.c = [];

        // Transform base

        // e is the base 10 exponent.
        // i is where to slice str to get the first element of the coefficient array.
        i = (e + 1) % LOG_BASE;
        if (e < 0) i += LOG_BASE;  // i < 1

        if (i < len) {
          if (i) x.c.push(+str.slice(0, i));

          for (len -= LOG_BASE; i < len;) {
            x.c.push(+str.slice(i, i += LOG_BASE));
          }

          i = LOG_BASE - (str = str.slice(i)).length;
        } else {
          i -= len;
        }

        for (; i--; str += '0');
        x.c.push(+str);
      }
    } else {

      // Zero.
      x.c = [x.e = 0];
    }
  }


  // CONSTRUCTOR PROPERTIES


  BigNumber.clone = clone;

  BigNumber.ROUND_UP = 0;
  BigNumber.ROUND_DOWN = 1;
  BigNumber.ROUND_CEIL = 2;
  BigNumber.ROUND_FLOOR = 3;
  BigNumber.ROUND_HALF_UP = 4;
  BigNumber.ROUND_HALF_DOWN = 5;
  BigNumber.ROUND_HALF_EVEN = 6;
  BigNumber.ROUND_HALF_CEIL = 7;
  BigNumber.ROUND_HALF_FLOOR = 8;
  BigNumber.EUCLID = 9;


  /*
   * Configure infrequently-changing library-wide settings.
   *
   * Accept an object with the following optional properties (if the value of a property is
   * a number, it must be an integer within the inclusive range stated):
   *
   *   DECIMAL_PLACES   {number}           0 to MAX
   *   ROUNDING_MODE    {number}           0 to 8
   *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
   *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
   *   CRYPTO           {boolean}          true or false
   *   MODULO_MODE      {number}           0 to 9
   *   POW_PRECISION       {number}           0 to MAX
   *   ALPHABET         {string}           A string of two or more unique characters which does
   *                                       not contain '.'.
   *   FORMAT           {object}           An object with some of the following properties:
   *     prefix                 {string}
   *     groupSize              {number}
   *     secondaryGroupSize     {number}
   *     groupSeparator         {string}
   *     decimalSeparator       {string}
   *     fractionGroupSize      {number}
   *     fractionGroupSeparator {string}
   *     suffix                 {string}
   *
   * (The values assigned to the above FORMAT object properties are not checked for validity.)
   *
   * E.g.
   * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
   *
   * Ignore properties/parameters set to null or undefined, except for ALPHABET.
   *
   * Return an object with the properties current values.
   */
  BigNumber.config = BigNumber.set = function (obj) {
    var p, v;

    if (obj != null) {

      if (typeof obj == 'object') {

        // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
        // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
          v = obj[p];
          intCheck(v, 0, MAX, p);
          DECIMAL_PLACES = v;
        }

        // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
        // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
          v = obj[p];
          intCheck(v, 0, 8, p);
          ROUNDING_MODE = v;
        }

        // EXPONENTIAL_AT {number|number[]}
        // Integer, -MAX to MAX inclusive or
        // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
        // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
          v = obj[p];
          if (v && v.pop) {
            intCheck(v[0], -MAX, 0, p);
            intCheck(v[1], 0, MAX, p);
            TO_EXP_NEG = v[0];
            TO_EXP_POS = v[1];
          } else {
            intCheck(v, -MAX, MAX, p);
            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
          }
        }

        // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
        // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
        // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
        if (obj.hasOwnProperty(p = 'RANGE')) {
          v = obj[p];
          if (v && v.pop) {
            intCheck(v[0], -MAX, -1, p);
            intCheck(v[1], 1, MAX, p);
            MIN_EXP = v[0];
            MAX_EXP = v[1];
          } else {
            intCheck(v, -MAX, MAX, p);
            if (v) {
              MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
            } else {
              throw Error
               (bignumberError + p + ' cannot be zero: ' + v);
            }
          }
        }

        // CRYPTO {boolean} true or false.
        // '[BigNumber Error] CRYPTO not true or false: {v}'
        // '[BigNumber Error] crypto unavailable'
        if (obj.hasOwnProperty(p = 'CRYPTO')) {
          v = obj[p];
          if (v === !!v) {
            if (v) {
              if (typeof crypto != 'undefined' && crypto &&
               (crypto.getRandomValues || crypto.randomBytes)) {
                CRYPTO = v;
              } else {
                CRYPTO = !v;
                throw Error
                 (bignumberError + 'crypto unavailable');
              }
            } else {
              CRYPTO = v;
            }
          } else {
            throw Error
             (bignumberError + p + ' not true or false: ' + v);
          }
        }

        // MODULO_MODE {number} Integer, 0 to 9 inclusive.
        // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
          v = obj[p];
          intCheck(v, 0, 9, p);
          MODULO_MODE = v;
        }

        // POW_PRECISION {number} Integer, 0 to MAX inclusive.
        // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
          v = obj[p];
          intCheck(v, 0, MAX, p);
          POW_PRECISION = v;
        }

        // FORMAT {object}
        // '[BigNumber Error] FORMAT not an object: {v}'
        if (obj.hasOwnProperty(p = 'FORMAT')) {
          v = obj[p];
          if (typeof v == 'object') FORMAT = v;
          else throw Error
           (bignumberError + p + ' not an object: ' + v);
        }

        // ALPHABET {string}
        // '[BigNumber Error] ALPHABET invalid: {v}'
        if (obj.hasOwnProperty(p = 'ALPHABET')) {
          v = obj[p];

          // Disallow if less than two characters,
          // or if it contains '+', '-', '.', whitespace, or a repeated character.
          if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
            alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
            ALPHABET = v;
          } else {
            throw Error
             (bignumberError + p + ' invalid: ' + v);
          }
        }

      } else {

        // '[BigNumber Error] Object expected: {v}'
        throw Error
         (bignumberError + 'Object expected: ' + obj);
      }
    }

    return {
      DECIMAL_PLACES: DECIMAL_PLACES,
      ROUNDING_MODE: ROUNDING_MODE,
      EXPONENTIAL_AT: [TO_EXP_NEG, TO_EXP_POS],
      RANGE: [MIN_EXP, MAX_EXP],
      CRYPTO: CRYPTO,
      MODULO_MODE: MODULO_MODE,
      POW_PRECISION: POW_PRECISION,
      FORMAT: FORMAT,
      ALPHABET: ALPHABET
    };
  };


  /*
   * Return true if v is a BigNumber instance, otherwise return false.
   *
   * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
   *
   * v {any}
   *
   * '[BigNumber Error] Invalid BigNumber: {v}'
   */
  BigNumber.isBigNumber = function (v) {
    if (!v || v._isBigNumber !== true) return false;
    if (!BigNumber.DEBUG) return true;

    var i, n,
      c = v.c,
      e = v.e,
      s = v.s;

    out: if ({}.toString.call(c) == '[object Array]') {

      if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {

        // If the first element is zero, the BigNumber value must be zero.
        if (c[0] === 0) {
          if (e === 0 && c.length === 1) return true;
          break out;
        }

        // Calculate number of digits that c[0] should have, based on the exponent.
        i = (e + 1) % LOG_BASE;
        if (i < 1) i += LOG_BASE;

        // Calculate number of digits of c[0].
        //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
        if (String(c[0]).length == i) {

          for (i = 0; i < c.length; i++) {
            n = c[i];
            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
          }

          // Last element cannot be zero, unless it is the only element.
          if (n !== 0) return true;
        }
      }

    // Infinity/NaN
    } else if (c === null && e === null && (s === null || s === 1 || s === -1)) {
      return true;
    }

    throw Error
      (bignumberError + 'Invalid BigNumber: ' + v);
  };


  /*
   * Return a new BigNumber whose value is the maximum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */
  BigNumber.maximum = BigNumber.max = function () {
    return maxOrMin(arguments, -1);
  };


  /*
   * Return a new BigNumber whose value is the minimum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */
  BigNumber.minimum = BigNumber.min = function () {
    return maxOrMin(arguments, 1);
  };


  /*
   * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
   * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
   * zeros are produced).
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
   * '[BigNumber Error] crypto unavailable'
   */
  BigNumber.random = (function () {
    var pow2_53 = 0x20000000000000;

    // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
    // Check if Math.random() produces more than 32 bits of randomness.
    // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
    // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
    var random53bitInt = (Math.random() * pow2_53) & 0x1fffff
     ? function () { return mathfloor(Math.random() * pow2_53); }
     : function () { return ((Math.random() * 0x40000000 | 0) * 0x800000) +
       (Math.random() * 0x800000 | 0); };

    return function (dp) {
      var a, b, e, k, v,
        i = 0,
        c = [],
        rand = new BigNumber(ONE);

      if (dp == null) dp = DECIMAL_PLACES;
      else intCheck(dp, 0, MAX);

      k = mathceil(dp / LOG_BASE);

      if (CRYPTO) {

        // Browsers supporting crypto.getRandomValues.
        if (crypto.getRandomValues) {

          a = crypto.getRandomValues(new Uint32Array(k *= 2));

          for (; i < k;) {

            // 53 bits:
            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
            //                                     11111 11111111 11111111
            // 0x20000 is 2^21.
            v = a[i] * 0x20000 + (a[i + 1] >>> 11);

            // Rejection sampling:
            // 0 <= v < 9007199254740992
            // Probability that v >= 9e15, is
            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
            if (v >= 9e15) {
              b = crypto.getRandomValues(new Uint32Array(2));
              a[i] = b[0];
              a[i + 1] = b[1];
            } else {

              // 0 <= v <= 8999999999999999
              // 0 <= (v % 1e14) <= 99999999999999
              c.push(v % 1e14);
              i += 2;
            }
          }
          i = k / 2;

        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {

          // buffer
          a = crypto.randomBytes(k *= 7);

          for (; i < k;) {

            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
            // 0x100000000 is 2^32, 0x1000000 is 2^24
            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
            // 0 <= v < 9007199254740992
            v = ((a[i] & 31) * 0x1000000000000) + (a[i + 1] * 0x10000000000) +
               (a[i + 2] * 0x100000000) + (a[i + 3] * 0x1000000) +
               (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];

            if (v >= 9e15) {
              crypto.randomBytes(7).copy(a, i);
            } else {

              // 0 <= (v % 1e14) <= 99999999999999
              c.push(v % 1e14);
              i += 7;
            }
          }
          i = k / 7;
        } else {
          CRYPTO = false;
          throw Error
           (bignumberError + 'crypto unavailable');
        }
      }

      // Use Math.random.
      if (!CRYPTO) {

        for (; i < k;) {
          v = random53bitInt();
          if (v < 9e15) c[i++] = v % 1e14;
        }
      }

      k = c[--i];
      dp %= LOG_BASE;

      // Convert trailing digits to zeros according to dp.
      if (k && dp) {
        v = POWS_TEN[LOG_BASE - dp];
        c[i] = mathfloor(k / v) * v;
      }

      // Remove trailing elements which are zero.
      for (; c[i] === 0; c.pop(), i--);

      // Zero?
      if (i < 0) {
        c = [e = 0];
      } else {

        // Remove leading elements which are zero and adjust exponent accordingly.
        for (e = -1 ; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);

        // Count the digits of the first element of c to determine leading zeros, and...
        for (i = 1, v = c[0]; v >= 10; v /= 10, i++);

        // adjust the exponent accordingly.
        if (i < LOG_BASE) e -= LOG_BASE - i;
      }

      rand.e = e;
      rand.c = c;
      return rand;
    };
  })();


   /*
   * Return a BigNumber whose value is the sum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */
  BigNumber.sum = function () {
    var i = 1,
      args = arguments,
      sum = new BigNumber(args[0]);
    for (; i < args.length;) sum = sum.plus(args[i++]);
    return sum;
  };


  // PRIVATE FUNCTIONS


  // Called by BigNumber and BigNumber.prototype.toString.
  convertBase = (function () {
    var decimal = '0123456789';

    /*
     * Convert string of baseIn to an array of numbers of baseOut.
     * Eg. toBaseOut('255', 10, 16) returns [15, 15].
     * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
     */
    function toBaseOut(str, baseIn, baseOut, alphabet) {
      var j,
        arr = [0],
        arrL,
        i = 0,
        len = str.length;

      for (; i < len;) {
        for (arrL = arr.length; arrL--; arr[arrL] *= baseIn);

        arr[0] += alphabet.indexOf(str.charAt(i++));

        for (j = 0; j < arr.length; j++) {

          if (arr[j] > baseOut - 1) {
            if (arr[j + 1] == null) arr[j + 1] = 0;
            arr[j + 1] += arr[j] / baseOut | 0;
            arr[j] %= baseOut;
          }
        }
      }

      return arr.reverse();
    }

    // Convert a numeric string of baseIn to a numeric string of baseOut.
    // If the caller is toString, we are converting from base 10 to baseOut.
    // If the caller is BigNumber, we are converting from baseIn to base 10.
    return function (str, baseIn, baseOut, sign, callerIsToString) {
      var alphabet, d, e, k, r, x, xc, y,
        i = str.indexOf('.'),
        dp = DECIMAL_PLACES,
        rm = ROUNDING_MODE;

      // Non-integer.
      if (i >= 0) {
        k = POW_PRECISION;

        // Unlimited precision.
        POW_PRECISION = 0;
        str = str.replace('.', '');
        y = new BigNumber(baseIn);
        x = y.pow(str.length - i);
        POW_PRECISION = k;

        // Convert str as if an integer, then restore the fraction part by dividing the
        // result by its base raised to a power.

        y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'),
         10, baseOut, decimal);
        y.e = y.c.length;
      }

      // Convert the number as integer.

      xc = toBaseOut(str, baseIn, baseOut, callerIsToString
       ? (alphabet = ALPHABET, decimal)
       : (alphabet = decimal, ALPHABET));

      // xc now represents str as an integer and converted to baseOut. e is the exponent.
      e = k = xc.length;

      // Remove trailing zeros.
      for (; xc[--k] == 0; xc.pop());

      // Zero?
      if (!xc[0]) return alphabet.charAt(0);

      // Does str represent an integer? If so, no need for the division.
      if (i < 0) {
        --e;
      } else {
        x.c = xc;
        x.e = e;

        // The sign is needed for correct rounding.
        x.s = sign;
        x = div(x, y, dp, rm, baseOut);
        xc = x.c;
        r = x.r;
        e = x.e;
      }

      // xc now represents str converted to baseOut.

      // The index of the rounding digit.
      d = e + dp + 1;

      // The rounding digit: the digit to the right of the digit that may be rounded up.
      i = xc[d];

      // Look at the rounding digits and mode to determine whether to round up.

      k = baseOut / 2;
      r = r || d < 0 || xc[d + 1] != null;

      r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
            : i > k || i == k &&(rm == 4 || r || rm == 6 && xc[d - 1] & 1 ||
             rm == (x.s < 0 ? 8 : 7));

      // If the index of the rounding digit is not greater than zero, or xc represents
      // zero, then the result of the base conversion is zero or, if rounding up, a value
      // such as 0.00001.
      if (d < 1 || !xc[0]) {

        // 1^-dp or 0
        str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
      } else {

        // Truncate xc to the required number of decimal places.
        xc.length = d;

        // Round up?
        if (r) {

          // Rounding up may mean the previous digit has to be rounded up and so on.
          for (--baseOut; ++xc[--d] > baseOut;) {
            xc[d] = 0;

            if (!d) {
              ++e;
              xc = [1].concat(xc);
            }
          }
        }

        // Determine trailing zeros.
        for (k = xc.length; !xc[--k];);

        // E.g. [4, 11, 15] becomes 4bf.
        for (i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));

        // Add leading zeros, decimal point and trailing zeros as required.
        str = toFixedPoint(str, e, alphabet.charAt(0));
      }

      // The caller will add the sign.
      return str;
    };
  })();


  // Perform division in the specified base. Called by div and convertBase.
  div = (function () {

    // Assume non-zero x and k.
    function multiply(x, k, base) {
      var m, temp, xlo, xhi,
        carry = 0,
        i = x.length,
        klo = k % SQRT_BASE,
        khi = k / SQRT_BASE | 0;

      for (x = x.slice(); i--;) {
        xlo = x[i] % SQRT_BASE;
        xhi = x[i] / SQRT_BASE | 0;
        m = khi * xlo + xhi * klo;
        temp = klo * xlo + ((m % SQRT_BASE) * SQRT_BASE) + carry;
        carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
        x[i] = temp % base;
      }

      if (carry) x = [carry].concat(x);

      return x;
    }

    function compare(a, b, aL, bL) {
      var i, cmp;

      if (aL != bL) {
        cmp = aL > bL ? 1 : -1;
      } else {

        for (i = cmp = 0; i < aL; i++) {

          if (a[i] != b[i]) {
            cmp = a[i] > b[i] ? 1 : -1;
            break;
          }
        }
      }

      return cmp;
    }

    function subtract(a, b, aL, base) {
      var i = 0;

      // Subtract b from a.
      for (; aL--;) {
        a[aL] -= i;
        i = a[aL] < b[aL] ? 1 : 0;
        a[aL] = i * base + a[aL] - b[aL];
      }

      // Remove leading zeros.
      for (; !a[0] && a.length > 1; a.splice(0, 1));
    }

    // x: dividend, y: divisor.
    return function (x, y, dp, rm, base) {
      var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0,
        yL, yz,
        s = x.s == y.s ? 1 : -1,
        xc = x.c,
        yc = y.c;

      // Either NaN, Infinity or 0?
      if (!xc || !xc[0] || !yc || !yc[0]) {

        return new BigNumber(

         // Return NaN if either NaN, or both Infinity or 0.
         !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN :

          // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
          xc && xc[0] == 0 || !yc ? s * 0 : s / 0
       );
      }

      q = new BigNumber(s);
      qc = q.c = [];
      e = x.e - y.e;
      s = dp + e + 1;

      if (!base) {
        base = BASE;
        e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
        s = s / LOG_BASE | 0;
      }

      // Result exponent may be one less then the current value of e.
      // The coefficients of the BigNumbers from convertBase may have trailing zeros.
      for (i = 0; yc[i] == (xc[i] || 0); i++);

      if (yc[i] > (xc[i] || 0)) e--;

      if (s < 0) {
        qc.push(1);
        more = true;
      } else {
        xL = xc.length;
        yL = yc.length;
        i = 0;
        s += 2;

        // Normalise xc and yc so highest order digit of yc is >= base / 2.

        n = mathfloor(base / (yc[0] + 1));

        // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
        // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
        if (n > 1) {
          yc = multiply(yc, n, base);
          xc = multiply(xc, n, base);
          yL = yc.length;
          xL = xc.length;
        }

        xi = yL;
        rem = xc.slice(0, yL);
        remL = rem.length;

        // Add zeros to make remainder as long as divisor.
        for (; remL < yL; rem[remL++] = 0);
        yz = yc.slice();
        yz = [0].concat(yz);
        yc0 = yc[0];
        if (yc[1] >= base / 2) yc0++;
        // Not necessary, but to prevent trial digit n > base, when using base 3.
        // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;

        do {
          n = 0;

          // Compare divisor and remainder.
          cmp = compare(yc, rem, yL, remL);

          // If divisor < remainder.
          if (cmp < 0) {

            // Calculate trial digit, n.

            rem0 = rem[0];
            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);

            // n is how many times the divisor goes into the current remainder.
            n = mathfloor(rem0 / yc0);

            //  Algorithm:
            //  product = divisor multiplied by trial digit (n).
            //  Compare product and remainder.
            //  If product is greater than remainder:
            //    Subtract divisor from product, decrement trial digit.
            //  Subtract product from remainder.
            //  If product was less than remainder at the last compare:
            //    Compare new remainder and divisor.
            //    If remainder is greater than divisor:
            //      Subtract divisor from remainder, increment trial digit.

            if (n > 1) {

              // n may be > base only when base is 3.
              if (n >= base) n = base - 1;

              // product = divisor * trial digit.
              prod = multiply(yc, n, base);
              prodL = prod.length;
              remL = rem.length;

              // Compare product and remainder.
              // If product > remainder then trial digit n too high.
              // n is 1 too high about 5% of the time, and is not known to have
              // ever been more than 1 too high.
              while (compare(prod, rem, prodL, remL) == 1) {
                n--;

                // Subtract divisor from product.
                subtract(prod, yL < prodL ? yz : yc, prodL, base);
                prodL = prod.length;
                cmp = 1;
              }
            } else {

              // n is 0 or 1, cmp is -1.
              // If n is 0, there is no need to compare yc and rem again below,
              // so change cmp to 1 to avoid it.
              // If n is 1, leave cmp as -1, so yc and rem are compared again.
              if (n == 0) {

                // divisor < remainder, so n must be at least 1.
                cmp = n = 1;
              }

              // product = divisor
              prod = yc.slice();
              prodL = prod.length;
            }

            if (prodL < remL) prod = [0].concat(prod);

            // Subtract product from remainder.
            subtract(rem, prod, remL, base);
            remL = rem.length;

             // If product was < remainder.
            if (cmp == -1) {

              // Compare divisor and new remainder.
              // If divisor < new remainder, subtract divisor from remainder.
              // Trial digit n too low.
              // n is 1 too low about 5% of the time, and very rarely 2 too low.
              while (compare(yc, rem, yL, remL) < 1) {
                n++;

                // Subtract divisor from remainder.
                subtract(rem, yL < remL ? yz : yc, remL, base);
                remL = rem.length;
              }
            }
          } else if (cmp === 0) {
            n++;
            rem = [0];
          } // else cmp === 1 and n will be 0

          // Add the next digit, n, to the result array.
          qc[i++] = n;

          // Update the remainder.
          if (rem[0]) {
            rem[remL++] = xc[xi] || 0;
          } else {
            rem = [xc[xi]];
            remL = 1;
          }
        } while ((xi++ < xL || rem[0] != null) && s--);

        more = rem[0] != null;

        // Leading zero?
        if (!qc[0]) qc.splice(0, 1);
      }

      if (base == BASE) {

        // To calculate q.e, first get the number of digits of qc[0].
        for (i = 1, s = qc[0]; s >= 10; s /= 10, i++);

        round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);

      // Caller is convertBase.
      } else {
        q.e = e;
        q.r = +more;
      }

      return q;
    };
  })();


  /*
   * Return a string representing the value of BigNumber n in fixed-point or exponential
   * notation rounded to the specified decimal places or significant digits.
   *
   * n: a BigNumber.
   * i: the index of the last digit required (i.e. the digit that may be rounded up).
   * rm: the rounding mode.
   * id: 1 (toExponential) or 2 (toPrecision).
   */
  function format(n, i, rm, id) {
    var c0, e, ne, len, str;

    if (rm == null) rm = ROUNDING_MODE;
    else intCheck(rm, 0, 8);

    if (!n.c) return n.toString();

    c0 = n.c[0];
    ne = n.e;

    if (i == null) {
      str = coeffToString(n.c);
      str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS)
       ? toExponential(str, ne)
       : toFixedPoint(str, ne, '0');
    } else {
      n = round(new BigNumber(n), i, rm);

      // n.e may have changed if the value was rounded up.
      e = n.e;

      str = coeffToString(n.c);
      len = str.length;

      // toPrecision returns exponential notation if the number of significant digits
      // specified is less than the number of digits necessary to represent the integer
      // part of the value in fixed-point notation.

      // Exponential notation.
      if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {

        // Append zeros?
        for (; len < i; str += '0', len++);
        str = toExponential(str, e);

      // Fixed-point notation.
      } else {
        i -= ne;
        str = toFixedPoint(str, e, '0');

        // Append zeros?
        if (e + 1 > len) {
          if (--i > 0) for (str += '.'; i--; str += '0');
        } else {
          i += e - len;
          if (i > 0) {
            if (e + 1 == len) str += '.';
            for (; i--; str += '0');
          }
        }
      }
    }

    return n.s < 0 && c0 ? '-' + str : str;
  }


  // Handle BigNumber.max and BigNumber.min.
  // If any number is NaN, return NaN.
  function maxOrMin(args, n) {
    var k, y,
      i = 1,
      x = new BigNumber(args[0]);

    for (; i < args.length; i++) {
      y = new BigNumber(args[i]);
      if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) {
        x = y;
      }
    }

    return x;
  }


  /*
   * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
   * Called by minus, plus and times.
   */
  function normalise(n, c, e) {
    var i = 1,
      j = c.length;

     // Remove trailing zeros.
    for (; !c[--j]; c.pop());

    // Calculate the base 10 exponent. First get the number of digits of c[0].
    for (j = c[0]; j >= 10; j /= 10, i++);

    // Overflow?
    if ((e = i + e * LOG_BASE - 1) > MAX_EXP) {

      // Infinity.
      n.c = n.e = null;

    // Underflow?
    } else if (e < MIN_EXP) {

      // Zero.
      n.c = [n.e = 0];
    } else {
      n.e = e;
      n.c = c;
    }

    return n;
  }


  // Handle values that fail the validity test in BigNumber.
  parseNumeric = (function () {
    var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i,
      dotAfter = /^([^.]+)\.$/,
      dotBefore = /^\.([^.]+)$/,
      isInfinityOrNaN = /^-?(Infinity|NaN)$/,
      whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;

    return function (x, str, isNum, b) {
      var base,
        s = isNum ? str : str.replace(whitespaceOrPlus, '');

      // No exception on ±Infinity or NaN.
      if (isInfinityOrNaN.test(s)) {
        x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
      } else {
        if (!isNum) {

          // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
          s = s.replace(basePrefix, function (m, p1, p2) {
            base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
            return !b || b == base ? p1 : m;
          });

          if (b) {
            base = b;

            // E.g. '1.' to '1', '.1' to '0.1'
            s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
          }

          if (str != s) return new BigNumber(s, base);
        }

        // '[BigNumber Error] Not a number: {n}'
        // '[BigNumber Error] Not a base {b} number: {n}'
        if (BigNumber.DEBUG) {
          throw Error
            (bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
        }

        // NaN
        x.s = null;
      }

      x.c = x.e = null;
    }
  })();


  /*
   * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
   * If r is truthy, it is known that there are more digits after the rounding digit.
   */
  function round(x, sd, rm, r) {
    var d, i, j, k, n, ni, rd,
      xc = x.c,
      pows10 = POWS_TEN;

    // if x is not Infinity or NaN...
    if (xc) {

      // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
      // n is a base 1e14 number, the value of the element of array x.c containing rd.
      // ni is the index of n within x.c.
      // d is the number of digits of n.
      // i is the index of rd within n including leading zeros.
      // j is the actual index of rd within n (if < 0, rd is a leading zero).
      out: {

        // Get the number of digits of the first element of xc.
        for (d = 1, k = xc[0]; k >= 10; k /= 10, d++);
        i = sd - d;

        // If the rounding digit is in the first element of xc...
        if (i < 0) {
          i += LOG_BASE;
          j = sd;
          n = xc[ni = 0];

          // Get the rounding digit at index j of n.
          rd = mathfloor(n / pows10[d - j - 1] % 10);
        } else {
          ni = mathceil((i + 1) / LOG_BASE);

          if (ni >= xc.length) {

            if (r) {

              // Needed by sqrt.
              for (; xc.length <= ni; xc.push(0));
              n = rd = 0;
              d = 1;
              i %= LOG_BASE;
              j = i - LOG_BASE + 1;
            } else {
              break out;
            }
          } else {
            n = k = xc[ni];

            // Get the number of digits of n.
            for (d = 1; k >= 10; k /= 10, d++);

            // Get the index of rd within n.
            i %= LOG_BASE;

            // Get the index of rd within n, adjusted for leading zeros.
            // The number of leading zeros of n is given by LOG_BASE - d.
            j = i - LOG_BASE + d;

            // Get the rounding digit at index j of n.
            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
          }
        }

        r = r || sd < 0 ||

        // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
         xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);

        r = rm < 4
         ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
         : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 &&

          // Check whether the digit to the left of the rounding digit is odd.
          ((i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10) & 1 ||
           rm == (x.s < 0 ? 8 : 7));

        if (sd < 1 || !xc[0]) {
          xc.length = 0;

          if (r) {

            // Convert sd to decimal places.
            sd -= x.e + 1;

            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
            x.e = -sd || 0;
          } else {

            // Zero.
            xc[0] = x.e = 0;
          }

          return x;
        }

        // Remove excess digits.
        if (i == 0) {
          xc.length = ni;
          k = 1;
          ni--;
        } else {
          xc.length = ni + 1;
          k = pows10[LOG_BASE - i];

          // E.g. 56700 becomes 56000 if 7 is the rounding digit.
          // j > 0 means i > number of leading zeros of n.
          xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
        }

        // Round up?
        if (r) {

          for (; ;) {

            // If the digit to be rounded up is in the first element of xc...
            if (ni == 0) {

              // i will be the length of xc[0] before k is added.
              for (i = 1, j = xc[0]; j >= 10; j /= 10, i++);
              j = xc[0] += k;
              for (k = 1; j >= 10; j /= 10, k++);

              // if i != k the length has increased.
              if (i != k) {
                x.e++;
                if (xc[0] == BASE) xc[0] = 1;
              }

              break;
            } else {
              xc[ni] += k;
              if (xc[ni] != BASE) break;
              xc[ni--] = 0;
              k = 1;
            }
          }
        }

        // Remove trailing zeros.
        for (i = xc.length; xc[--i] === 0; xc.pop());
      }

      // Overflow? Infinity.
      if (x.e > MAX_EXP) {
        x.c = x.e = null;

      // Underflow? Zero.
      } else if (x.e < MIN_EXP) {
        x.c = [x.e = 0];
      }
    }

    return x;
  }


  function valueOf(n) {
    var str,
      e = n.e;

    if (e === null) return n.toString();

    str = coeffToString(n.c);

    str = e <= TO_EXP_NEG || e >= TO_EXP_POS
      ? toExponential(str, e)
      : toFixedPoint(str, e, '0');

    return n.s < 0 ? '-' + str : str;
  }


  // PROTOTYPE/INSTANCE METHODS


  /*
   * Return a new BigNumber whose value is the absolute value of this BigNumber.
   */
  P.absoluteValue = P.abs = function () {
    var x = new BigNumber(this);
    if (x.s < 0) x.s = 1;
    return x;
  };


  /*
   * Return
   *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
   *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
   *   0 if they have the same value,
   *   or null if the value of either is NaN.
   */
  P.comparedTo = function (y, b) {
    return compare(this, new BigNumber(y, b));
  };


  /*
   * If dp is undefined or null or true or false, return the number of decimal places of the
   * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   *
   * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */
  P.decimalPlaces = P.dp = function (dp, rm) {
    var c, n, v,
      x = this;

    if (dp != null) {
      intCheck(dp, 0, MAX);
      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);

      return round(new BigNumber(x), dp + x.e + 1, rm);
    }

    if (!(c = x.c)) return null;
    n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;

    // Subtract the number of trailing zeros of the last number.
    if (v = c[v]) for (; v % 10 == 0; v /= 10, n--);
    if (n < 0) n = 0;

    return n;
  };


  /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
   * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */
  P.dividedBy = P.div = function (y, b) {
    return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
  };


  /*
   * Return a new BigNumber whose value is the integer part of dividing the value of this
   * BigNumber by the value of BigNumber(y, b).
   */
  P.dividedToIntegerBy = P.idiv = function (y, b) {
    return div(this, new BigNumber(y, b), 0, 1);
  };


  /*
   * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
   *
   * If m is present, return the result modulo m.
   * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
   * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
   *
   * The modular power operation works efficiently when x, n, and m are integers, otherwise it
   * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
   *
   * n {number|string|BigNumber} The exponent. An integer.
   * [m] {number|string|BigNumber} The modulus.
   *
   * '[BigNumber Error] Exponent not an integer: {n}'
   */
  P.exponentiatedBy = P.pow = function (n, m) {
    var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y,
      x = this;

    n = new BigNumber(n);

    // Allow NaN and ±Infinity, but not other non-integers.
    if (n.c && !n.isInteger()) {
      throw Error
        (bignumberError + 'Exponent not an integer: ' + valueOf(n));
    }

    if (m != null) m = new BigNumber(m);

    // Exponent of MAX_SAFE_INTEGER is 15.
    nIsBig = n.e > 14;

    // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
    if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {

      // The sign of the result of pow when x is negative depends on the evenness of n.
      // If +n overflows to ±Infinity, the evenness of n would be not be known.
      y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
      return m ? y.mod(m) : y;
    }

    nIsNeg = n.s < 0;

    if (m) {

      // x % m returns NaN if abs(m) is zero, or m is NaN.
      if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);

      isModExp = !nIsNeg && x.isInteger() && m.isInteger();

      if (isModExp) x = x.mod(m);

    // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
    // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
    } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0
      // [1, 240000000]
      ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7
      // [80000000000000]  [99999750000000]
      : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {

      // If x is negative and n is odd, k = -0, else k = 0.
      k = x.s < 0 && isOdd(n) ? -0 : 0;

      // If x >= 1, k = ±Infinity.
      if (x.e > -1) k = 1 / k;

      // If n is negative return ±0, else return ±Infinity.
      return new BigNumber(nIsNeg ? 1 / k : k);

    } else if (POW_PRECISION) {

      // Truncating each coefficient array to a length of k after each multiplication
      // equates to truncating significant digits to POW_PRECISION + [28, 41],
      // i.e. there will be a minimum of 28 guard digits retained.
      k = mathceil(POW_PRECISION / LOG_BASE + 2);
    }

    if (nIsBig) {
      half = new BigNumber(0.5);
      if (nIsNeg) n.s = 1;
      nIsOdd = isOdd(n);
    } else {
      i = Math.abs(+valueOf(n));
      nIsOdd = i % 2;
    }

    y = new BigNumber(ONE);

    // Performs 54 loop iterations for n of 9007199254740991.
    for (; ;) {

      if (nIsOdd) {
        y = y.times(x);
        if (!y.c) break;

        if (k) {
          if (y.c.length > k) y.c.length = k;
        } else if (isModExp) {
          y = y.mod(m);    //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
        }
      }

      if (i) {
        i = mathfloor(i / 2);
        if (i === 0) break;
        nIsOdd = i % 2;
      } else {
        n = n.times(half);
        round(n, n.e + 1, 1);

        if (n.e > 14) {
          nIsOdd = isOdd(n);
        } else {
          i = +valueOf(n);
          if (i === 0) break;
          nIsOdd = i % 2;
        }
      }

      x = x.times(x);

      if (k) {
        if (x.c && x.c.length > k) x.c.length = k;
      } else if (isModExp) {
        x = x.mod(m);    //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
      }
    }

    if (isModExp) return y;
    if (nIsNeg) y = ONE.div(y);

    return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
  };


  /*
   * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
   * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
   */
  P.integerValue = function (rm) {
    var n = new BigNumber(this);
    if (rm == null) rm = ROUNDING_MODE;
    else intCheck(rm, 0, 8);
    return round(n, n.e + 1, rm);
  };


  /*
   * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
   * otherwise return false.
   */
  P.isEqualTo = P.eq = function (y, b) {
    return compare(this, new BigNumber(y, b)) === 0;
  };


  /*
   * Return true if the value of this BigNumber is a finite number, otherwise return false.
   */
  P.isFinite = function () {
    return !!this.c;
  };


  /*
   * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
   * otherwise return false.
   */
  P.isGreaterThan = P.gt = function (y, b) {
    return compare(this, new BigNumber(y, b)) > 0;
  };


  /*
   * Return true if the value of this BigNumber is greater than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */
  P.isGreaterThanOrEqualTo = P.gte = function (y, b) {
    return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;

  };


  /*
   * Return true if the value of this BigNumber is an integer, otherwise return false.
   */
  P.isInteger = function () {
    return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
  };


  /*
   * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
   * otherwise return false.
   */
  P.isLessThan = P.lt = function (y, b) {
    return compare(this, new BigNumber(y, b)) < 0;
  };


  /*
   * Return true if the value of this BigNumber is less than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */
  P.isLessThanOrEqualTo = P.lte = function (y, b) {
    return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
  };


  /*
   * Return true if the value of this BigNumber is NaN, otherwise return false.
   */
  P.isNaN = function () {
    return !this.s;
  };


  /*
   * Return true if the value of this BigNumber is negative, otherwise return false.
   */
  P.isNegative = function () {
    return this.s < 0;
  };


  /*
   * Return true if the value of this BigNumber is positive, otherwise return false.
   */
  P.isPositive = function () {
    return this.s > 0;
  };


  /*
   * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
   */
  P.isZero = function () {
    return !!this.c && this.c[0] == 0;
  };


  /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber minus the value of
   * BigNumber(y, b).
   */
  P.minus = function (y, b) {
    var i, j, t, xLTy,
      x = this,
      a = x.s;

    y = new BigNumber(y, b);
    b = y.s;

    // Either NaN?
    if (!a || !b) return new BigNumber(NaN);

    // Signs differ?
    if (a != b) {
      y.s = -b;
      return x.plus(y);
    }

    var xe = x.e / LOG_BASE,
      ye = y.e / LOG_BASE,
      xc = x.c,
      yc = y.c;

    if (!xe || !ye) {

      // Either Infinity?
      if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);

      // Either zero?
      if (!xc[0] || !yc[0]) {

        // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
        return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x :

         // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
         ROUNDING_MODE == 3 ? -0 : 0);
      }
    }

    xe = bitFloor(xe);
    ye = bitFloor(ye);
    xc = xc.slice();

    // Determine which is the bigger number.
    if (a = xe - ye) {

      if (xLTy = a < 0) {
        a = -a;
        t = xc;
      } else {
        ye = xe;
        t = yc;
      }

      t.reverse();

      // Prepend zeros to equalise exponents.
      for (b = a; b--; t.push(0));
      t.reverse();
    } else {

      // Exponents equal. Check digit by digit.
      j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;

      for (a = b = 0; b < j; b++) {

        if (xc[b] != yc[b]) {
          xLTy = xc[b] < yc[b];
          break;
        }
      }
    }

    // x < y? Point xc to the array of the bigger number.
    if (xLTy) {
      t = xc;
      xc = yc;
      yc = t;
      y.s = -y.s;
    }

    b = (j = yc.length) - (i = xc.length);

    // Append zeros to xc if shorter.
    // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
    if (b > 0) for (; b--; xc[i++] = 0);
    b = BASE - 1;

    // Subtract yc from xc.
    for (; j > a;) {

      if (xc[--j] < yc[j]) {
        for (i = j; i && !xc[--i]; xc[i] = b);
        --xc[i];
        xc[j] += BASE;
      }

      xc[j] -= yc[j];
    }

    // Remove leading zeros and adjust exponent accordingly.
    for (; xc[0] == 0; xc.splice(0, 1), --ye);

    // Zero?
    if (!xc[0]) {

      // Following IEEE 754 (2008) 6.3,
      // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
      y.s = ROUNDING_MODE == 3 ? -1 : 1;
      y.c = [y.e = 0];
      return y;
    }

    // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
    // for finite x and y.
    return normalise(y, xc, ye);
  };


  /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
   * BigNumber(y, b). The result depends on the value of MODULO_MODE.
   */
  P.modulo = P.mod = function (y, b) {
    var q, s,
      x = this;

    y = new BigNumber(y, b);

    // Return NaN if x is Infinity or NaN, or y is NaN or zero.
    if (!x.c || !y.s || y.c && !y.c[0]) {
      return new BigNumber(NaN);

    // Return x if y is Infinity or x is zero.
    } else if (!y.c || x.c && !x.c[0]) {
      return new BigNumber(x);
    }

    if (MODULO_MODE == 9) {

      // Euclidian division: q = sign(y) * floor(x / abs(y))
      // r = x - qy    where  0 <= r < abs(y)
      s = y.s;
      y.s = 1;
      q = div(x, y, 0, 3);
      y.s = s;
      q.s *= s;
    } else {
      q = div(x, y, 0, MODULO_MODE);
    }

    y = x.minus(q.times(y));

    // To match JavaScript %, ensure sign of zero is sign of dividend.
    if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;

    return y;
  };


  /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
   * of BigNumber(y, b).
   */
  P.multipliedBy = P.times = function (y, b) {
    var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc,
      base, sqrtBase,
      x = this,
      xc = x.c,
      yc = (y = new BigNumber(y, b)).c;

    // Either NaN, ±Infinity or ±0?
    if (!xc || !yc || !xc[0] || !yc[0]) {

      // Return NaN if either is NaN, or one is 0 and the other is Infinity.
      if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) {
        y.c = y.e = y.s = null;
      } else {
        y.s *= x.s;

        // Return ±Infinity if either is ±Infinity.
        if (!xc || !yc) {
          y.c = y.e = null;

        // Return ±0 if either is ±0.
        } else {
          y.c = [0];
          y.e = 0;
        }
      }

      return y;
    }

    e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
    y.s *= x.s;
    xcL = xc.length;
    ycL = yc.length;

    // Ensure xc points to longer array and xcL to its length.
    if (xcL < ycL) {
      zc = xc;
      xc = yc;
      yc = zc;
      i = xcL;
      xcL = ycL;
      ycL = i;
    }

    // Initialise the result array with zeros.
    for (i = xcL + ycL, zc = []; i--; zc.push(0));

    base = BASE;
    sqrtBase = SQRT_BASE;

    for (i = ycL; --i >= 0;) {
      c = 0;
      ylo = yc[i] % sqrtBase;
      yhi = yc[i] / sqrtBase | 0;

      for (k = xcL, j = i + k; j > i;) {
        xlo = xc[--k] % sqrtBase;
        xhi = xc[k] / sqrtBase | 0;
        m = yhi * xlo + xhi * ylo;
        xlo = ylo * xlo + ((m % sqrtBase) * sqrtBase) + zc[j] + c;
        c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
        zc[j--] = xlo % base;
      }

      zc[j] = c;
    }

    if (c) {
      ++e;
    } else {
      zc.splice(0, 1);
    }

    return normalise(y, zc, e);
  };


  /*
   * Return a new BigNumber whose value is the value of this BigNumber negated,
   * i.e. multiplied by -1.
   */
  P.negated = function () {
    var x = new BigNumber(this);
    x.s = -x.s || null;
    return x;
  };


  /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber plus the value of
   * BigNumber(y, b).
   */
  P.plus = function (y, b) {
    var t,
      x = this,
      a = x.s;

    y = new BigNumber(y, b);
    b = y.s;

    // Either NaN?
    if (!a || !b) return new BigNumber(NaN);

    // Signs differ?
     if (a != b) {
      y.s = -b;
      return x.minus(y);
    }

    var xe = x.e / LOG_BASE,
      ye = y.e / LOG_BASE,
      xc = x.c,
      yc = y.c;

    if (!xe || !ye) {

      // Return ±Infinity if either ±Infinity.
      if (!xc || !yc) return new BigNumber(a / 0);

      // Either zero?
      // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
      if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
    }

    xe = bitFloor(xe);
    ye = bitFloor(ye);
    xc = xc.slice();

    // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
    if (a = xe - ye) {
      if (a > 0) {
        ye = xe;
        t = yc;
      } else {
        a = -a;
        t = xc;
      }

      t.reverse();
      for (; a--; t.push(0));
      t.reverse();
    }

    a = xc.length;
    b = yc.length;

    // Point xc to the longer array, and b to the shorter length.
    if (a - b < 0) {
      t = yc;
      yc = xc;
      xc = t;
      b = a;
    }

    // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
    for (a = 0; b;) {
      a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
      xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
    }

    if (a) {
      xc = [a].concat(xc);
      ++ye;
    }

    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    // ye = MAX_EXP + 1 possible
    return normalise(y, xc, ye);
  };


  /*
   * If sd is undefined or null or true or false, return the number of significant digits of
   * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   * If sd is true include integer-part trailing zeros in the count.
   *
   * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
   *                     boolean: whether to count integer-part trailing zeros: true or false.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */
  P.precision = P.sd = function (sd, rm) {
    var c, n, v,
      x = this;

    if (sd != null && sd !== !!sd) {
      intCheck(sd, 1, MAX);
      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);

      return round(new BigNumber(x), sd, rm);
    }

    if (!(c = x.c)) return null;
    v = c.length - 1;
    n = v * LOG_BASE + 1;

    if (v = c[v]) {

      // Subtract the number of trailing zeros of the last element.
      for (; v % 10 == 0; v /= 10, n--);

      // Add the number of digits of the first element.
      for (v = c[0]; v >= 10; v /= 10, n++);
    }

    if (sd && x.e + 1 > n) n = x.e + 1;

    return n;
  };


  /*
   * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
   * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
   *
   * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
   */
  P.shiftedBy = function (k) {
    intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
    return this.times('1e' + k);
  };


  /*
   *  sqrt(-n) =  N
   *  sqrt(N) =  N
   *  sqrt(-I) =  N
   *  sqrt(I) =  I
   *  sqrt(0) =  0
   *  sqrt(-0) = -0
   *
   * Return a new BigNumber whose value is the square root of the value of this BigNumber,
   * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */
  P.squareRoot = P.sqrt = function () {
    var m, n, r, rep, t,
      x = this,
      c = x.c,
      s = x.s,
      e = x.e,
      dp = DECIMAL_PLACES + 4,
      half = new BigNumber('0.5');

    // Negative/NaN/Infinity/zero?
    if (s !== 1 || !c || !c[0]) {
      return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
    }

    // Initial estimate.
    s = Math.sqrt(+valueOf(x));

    // Math.sqrt underflow/overflow?
    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
    if (s == 0 || s == 1 / 0) {
      n = coeffToString(c);
      if ((n.length + e) % 2 == 0) n += '0';
      s = Math.sqrt(+n);
      e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);

      if (s == 1 / 0) {
        n = '5e' + e;
      } else {
        n = s.toExponential();
        n = n.slice(0, n.indexOf('e') + 1) + e;
      }

      r = new BigNumber(n);
    } else {
      r = new BigNumber(s + '');
    }

    // Check for zero.
    // r could be zero if MIN_EXP is changed after the this value was created.
    // This would cause a division by zero (x/t) and hence Infinity below, which would cause
    // coeffToString to throw.
    if (r.c[0]) {
      e = r.e;
      s = e + dp;
      if (s < 3) s = 0;

      // Newton-Raphson iteration.
      for (; ;) {
        t = r;
        r = half.times(t.plus(div(x, t, dp, 1)));

        if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {

          // The exponent of r may here be one less than the final result exponent,
          // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
          // are indexed correctly.
          if (r.e < e) --s;
          n = n.slice(s - 3, s + 1);

          // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
          // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
          // iteration.
          if (n == '9999' || !rep && n == '4999') {

            // On the first iteration only, check to see if rounding up gives the
            // exact result as the nines may infinitely repeat.
            if (!rep) {
              round(t, t.e + DECIMAL_PLACES + 2, 0);

              if (t.times(t).eq(x)) {
                r = t;
                break;
              }
            }

            dp += 4;
            s += 4;
            rep = 1;
          } else {

            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
            // result. If not, then there are further digits and m will be truthy.
            if (!+n || !+n.slice(1) && n.charAt(0) == '5') {

              // Truncate to the first rounding digit.
              round(r, r.e + DECIMAL_PLACES + 2, 1);
              m = !r.times(r).eq(x);
            }

            break;
          }
        }
      }
    }

    return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
  };


  /*
   * Return a string representing the value of this BigNumber in exponential notation and
   * rounded using ROUNDING_MODE to dp fixed decimal places.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */
  P.toExponential = function (dp, rm) {
    if (dp != null) {
      intCheck(dp, 0, MAX);
      dp++;
    }
    return format(this, dp, rm, 1);
  };


  /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounding
   * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
   * but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */
  P.toFixed = function (dp, rm) {
    if (dp != null) {
      intCheck(dp, 0, MAX);
      dp = dp + this.e + 1;
    }
    return format(this, dp, rm);
  };


  /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounded
   * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
   * of the format or FORMAT object (see BigNumber.set).
   *
   * The formatting object may contain some or all of the properties shown below.
   *
   * FORMAT = {
   *   prefix: '',
   *   groupSize: 3,
   *   secondaryGroupSize: 0,
   *   groupSeparator: ',',
   *   decimalSeparator: '.',
   *   fractionGroupSize: 0,
   *   fractionGroupSeparator: '\xA0',      // non-breaking space
   *   suffix: ''
   * };
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   * [format] {object} Formatting options. See FORMAT pbject above.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   * '[BigNumber Error] Argument not an object: {format}'
   */
  P.toFormat = function (dp, rm, format) {
    var str,
      x = this;

    if (format == null) {
      if (dp != null && rm && typeof rm == 'object') {
        format = rm;
        rm = null;
      } else if (dp && typeof dp == 'object') {
        format = dp;
        dp = rm = null;
      } else {
        format = FORMAT;
      }
    } else if (typeof format != 'object') {
      throw Error
        (bignumberError + 'Argument not an object: ' + format);
    }

    str = x.toFixed(dp, rm);

    if (x.c) {
      var i,
        arr = str.split('.'),
        g1 = +format.groupSize,
        g2 = +format.secondaryGroupSize,
        groupSeparator = format.groupSeparator || '',
        intPart = arr[0],
        fractionPart = arr[1],
        isNeg = x.s < 0,
        intDigits = isNeg ? intPart.slice(1) : intPart,
        len = intDigits.length;

      if (g2) {
        i = g1;
        g1 = g2;
        g2 = i;
        len -= i;
      }

      if (g1 > 0 && len > 0) {
        i = len % g1 || g1;
        intPart = intDigits.substr(0, i);
        for (; i < len; i += g1) intPart += groupSeparator + intDigits.substr(i, g1);
        if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
        if (isNeg) intPart = '-' + intPart;
      }

      str = fractionPart
       ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize)
        ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'),
         '$&' + (format.fractionGroupSeparator || ''))
        : fractionPart)
       : intPart;
    }

    return (format.prefix || '') + str + (format.suffix || '');
  };


  /*
   * Return an array of two BigNumbers representing the value of this BigNumber as a simple
   * fraction with an integer numerator and an integer denominator.
   * The denominator will be a positive non-zero value less than or equal to the specified
   * maximum denominator. If a maximum denominator is not specified, the denominator will be
   * the lowest value necessary to represent the number exactly.
   *
   * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
   *
   * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
   */
  P.toFraction = function (md) {
    var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s,
      x = this,
      xc = x.c;

    if (md != null) {
      n = new BigNumber(md);

      // Throw if md is less than one or is not an integer, unless it is Infinity.
      if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) {
        throw Error
          (bignumberError + 'Argument ' +
            (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
      }
    }

    if (!xc) return new BigNumber(x);

    d = new BigNumber(ONE);
    n1 = d0 = new BigNumber(ONE);
    d1 = n0 = new BigNumber(ONE);
    s = coeffToString(xc);

    // Determine initial denominator.
    // d is a power of 10 and the minimum max denominator that specifies the value exactly.
    e = d.e = s.length - x.e - 1;
    d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
    md = !md || n.comparedTo(d) > 0 ? (e > 0 ? d : n1) : n;

    exp = MAX_EXP;
    MAX_EXP = 1 / 0;
    n = new BigNumber(s);

    // n0 = d1 = 0
    n0.c[0] = 0;

    for (; ;)  {
      q = div(n, d, 0, 1);
      d2 = d0.plus(q.times(d1));
      if (d2.comparedTo(md) == 1) break;
      d0 = d1;
      d1 = d2;
      n1 = n0.plus(q.times(d2 = n1));
      n0 = d2;
      d = n.minus(q.times(d2 = d));
      n = d2;
    }

    d2 = div(md.minus(d0), d1, 0, 1);
    n0 = n0.plus(d2.times(n1));
    d0 = d0.plus(d2.times(d1));
    n0.s = n1.s = x.s;
    e = e * 2;

    // Determine which fraction is closer to x, n0/d0 or n1/d1
    r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(
        div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [n1, d1] : [n0, d0];

    MAX_EXP = exp;

    return r;
  };


  /*
   * Return the value of this BigNumber converted to a number primitive.
   */
  P.toNumber = function () {
    return +valueOf(this);
  };


  /*
   * Return a string representing the value of this BigNumber rounded to sd significant digits
   * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
   * necessary to represent the integer part of the value in fixed-point notation, then use
   * exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */
  P.toPrecision = function (sd, rm) {
    if (sd != null) intCheck(sd, 1, MAX);
    return format(this, sd, rm, 2);
  };


  /*
   * Return a string representing the value of this BigNumber in base b, or base 10 if b is
   * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
   * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
   * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
   * TO_EXP_NEG, return exponential notation.
   *
   * [b] {number} Integer, 2 to ALPHABET.length inclusive.
   *
   * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
   */
  P.toString = function (b) {
    var str,
      n = this,
      s = n.s,
      e = n.e;

    // Infinity or NaN?
    if (e === null) {
      if (s) {
        str = 'Infinity';
        if (s < 0) str = '-' + str;
      } else {
        str = 'NaN';
      }
    } else {
      if (b == null) {
        str = e <= TO_EXP_NEG || e >= TO_EXP_POS
         ? toExponential(coeffToString(n.c), e)
         : toFixedPoint(coeffToString(n.c), e, '0');
      } else if (b === 10 && alphabetHasNormalDecimalDigits) {
        n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
        str = toFixedPoint(coeffToString(n.c), n.e, '0');
      } else {
        intCheck(b, 2, ALPHABET.length, 'Base');
        str = convertBase(toFixedPoint(coeffToString(n.c), e, '0'), 10, b, s, true);
      }

      if (s < 0 && n.c[0]) str = '-' + str;
    }

    return str;
  };


  /*
   * Return as toString, but do not accept a base argument, and include the minus sign for
   * negative zero.
   */
  P.valueOf = P.toJSON = function () {
    return valueOf(this);
  };


  P._isBigNumber = true;

  P[Symbol.toStringTag] = 'BigNumber';

  // Node.js v10.12.0+
  P[Symbol.for('nodejs.util.inspect.custom')] = P.valueOf;

  if (configObject != null) BigNumber.set(configObject);

  return BigNumber;
}


// PRIVATE HELPER FUNCTIONS

// These functions don't need access to variables,
// e.g. DECIMAL_PLACES, in the scope of the `clone` function above.


function bitFloor(n) {
  var i = n | 0;
  return n > 0 || n === i ? i : i - 1;
}


// Return a coefficient array as a string of base 10 digits.
function coeffToString(a) {
  var s, z,
    i = 1,
    j = a.length,
    r = a[0] + '';

  for (; i < j;) {
    s = a[i++] + '';
    z = LOG_BASE - s.length;
    for (; z--; s = '0' + s);
    r += s;
  }

  // Determine trailing zeros.
  for (j = r.length; r.charCodeAt(--j) === 48;);

  return r.slice(0, j + 1 || 1);
}


// Compare the value of BigNumbers x and y.
function compare(x, y) {
  var a, b,
    xc = x.c,
    yc = y.c,
    i = x.s,
    j = y.s,
    k = x.e,
    l = y.e;

  // Either NaN?
  if (!i || !j) return null;

  a = xc && !xc[0];
  b = yc && !yc[0];

  // Either zero?
  if (a || b) return a ? b ? 0 : -j : i;

  // Signs differ?
  if (i != j) return i;

  a = i < 0;
  b = k == l;

  // Either Infinity?
  if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;

  // Compare exponents.
  if (!b) return k > l ^ a ? 1 : -1;

  j = (k = xc.length) < (l = yc.length) ? k : l;

  // Compare digit by digit.
  for (i = 0; i < j; i++) if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;

  // Compare lengths.
  return k == l ? 0 : k > l ^ a ? 1 : -1;
}


/*
 * Check that n is a primitive number, an integer, and in range, otherwise throw.
 */
function intCheck(n, min, max, name) {
  if (n < min || n > max || n !== mathfloor(n)) {
    throw Error
     (bignumberError + (name || 'Argument') + (typeof n == 'number'
       ? n < min || n > max ? ' out of range: ' : ' not an integer: '
       : ' not a primitive number: ') + String(n));
  }
}


// Assumes finite n.
function isOdd(n) {
  var k = n.c.length - 1;
  return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
}


function toExponential(str, e) {
  return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) +
   (e < 0 ? 'e' : 'e+') + e;
}


function toFixedPoint(str, e, z) {
  var len, zs;

  // Negative exponent?
  if (e < 0) {

    // Prepend zeros.
    for (zs = z + '.'; ++e; zs += z);
    str = zs + str;

  // Positive exponent
  } else {
    len = str.length;

    // Append zeros.
    if (++e > len) {
      for (zs = z, e -= len; --e; zs += z);
      str += zs;
    } else if (e < len) {
      str = str.slice(0, e) + '.' + str.slice(e);
    }
  }

  return str;
}


// EXPORT


var bignumber_BigNumber = clone();

/* harmony default export */ var bignumber = ((/* unused pure expression or super */ null && (bignumber_BigNumber)));

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/crypto-browserify/index.js
var crypto_browserify = __webpack_require__(42474);
;// CONCATENATED MODULE: ./node_modules/date-fns-tz/esm/_lib/tzTokenizeDate/index.js
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */
function tzTokenizeDate(date, timeZone) {
  var dtf = getDateTimeFormat(timeZone)
  return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date)
}

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5,
}

function partsOffset(dtf, date) {
  try {
    var formatted = dtf.formatToParts(date)
    var filled = []
    for (var i = 0; i < formatted.length; i++) {
      var pos = typeToPos[formatted[i].type]

      if (pos >= 0) {
        filled[pos] = parseInt(formatted[i].value, 10)
      }
    }
    return filled
  } catch (error) {
    if (error instanceof RangeError) {
      return [NaN]
    }
    throw error
  }
}

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date)
  var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted)
  // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
  // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
  return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]]
}

// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var dtfCache = {}
function getDateTimeFormat(timeZone) {
  if (!dtfCache[timeZone]) {
    // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
    var testDateFormatted = new Intl.DateTimeFormat('en-US', {
      hourCycle: 'h23',
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(new Date('2014-06-25T04:00:00.123Z'))
    var hourCycleSupported =
      testDateFormatted === '06/25/2014, 00:00:00' ||
      testDateFormatted === '‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00'

    dtfCache[timeZone] = hourCycleSupported
      ? new Intl.DateTimeFormat('en-US', {
          hourCycle: 'h23',
          timeZone: timeZone,
          year: 'numeric',
          month: 'numeric',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
      : new Intl.DateTimeFormat('en-US', {
          hour12: false,
          timeZone: timeZone,
          year: 'numeric',
          month: 'numeric',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
  }
  return dtfCache[timeZone]
}

;// CONCATENATED MODULE: ./node_modules/date-fns-tz/esm/_lib/newDateUTC/index.js
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
  var utcDate = new Date(0)
  utcDate.setUTCFullYear(fullYear, month, day)
  utcDate.setUTCHours(hour, minute, second, millisecond)
  return utcDate
}

;// CONCATENATED MODULE: ./node_modules/date-fns-tz/esm/_lib/tzParseTimezone/index.js



var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000

var patterns = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/,
}

// Parse various time zone offset formats to an offset in milliseconds
function tzParseTimezone(timezoneString, date, isUtcDate) {
  var token
  var absoluteOffset

  // Empty string
  if (!timezoneString) {
    return 0
  }

  // Z
  token = patterns.timezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  var hours

  // ±hh
  token = patterns.timezoneHH.exec(timezoneString)
  if (token) {
    hours = parseInt(token[1], 10)

    if (!validateTimezone(hours)) {
      return NaN
    }

    return -(hours * MILLISECONDS_IN_HOUR)
  }

  // ±hh:mm or ±hhmm
  token = patterns.timezoneHHMM.exec(timezoneString)
  if (token) {
    hours = parseInt(token[2], 10)
    var minutes = parseInt(token[3], 10)

    if (!validateTimezone(hours, minutes)) {
      return NaN
    }

    absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE
    return token[1] === '+' ? -absoluteOffset : absoluteOffset
  }

  // IANA time zone
  if (isValidTimezoneIANAString(timezoneString)) {
    date = new Date(date || Date.now())
    var utcDate = isUtcDate ? date : toUtcDate(date)

    var offset = calcOffset(utcDate, timezoneString)

    var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString)

    return -fixedOffset
  }

  return NaN
}

function toUtcDate(date) {
  return newDateUTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds()
  )
}

function calcOffset(date, timezoneString) {
  var tokens = tzTokenizeDate(date, timezoneString)

  // ms dropped because it's not provided by tzTokenizeDate
  var asUTC = newDateUTC(
    tokens[0],
    tokens[1] - 1,
    tokens[2],
    tokens[3] % 24,
    tokens[4],
    tokens[5],
    0
  ).getTime()

  var asTS = date.getTime()
  var over = asTS % 1000
  asTS -= over >= 0 ? over : 1000 + over
  return asUTC - asTS
}

function fixOffset(date, offset, timezoneString) {
  var localTS = date.getTime()

  // Our UTC time is just a guess because our offset is just a guess
  var utcGuess = localTS - offset

  // Test whether the zone matches the offset for this ts
  var o2 = calcOffset(new Date(utcGuess), timezoneString)

  // If so, offset didn't change, and we're done
  if (offset === o2) {
    return offset
  }

  // If not, change the ts by the difference in the offset
  utcGuess -= o2 - offset

  // If that gives us the local time we want, we're done
  var o3 = calcOffset(new Date(utcGuess), timezoneString)
  if (o2 === o3) {
    return o2
  }

  // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
  return Math.max(o2, o3)
}

function validateTimezone(hours, minutes) {
  return -23 <= hours && hours <= 23 && (minutes == null || (0 <= minutes && minutes <= 59))
}

var validIANATimezoneCache = {}
function isValidTimezoneIANAString(timeZoneString) {
  if (validIANATimezoneCache[timeZoneString]) return true
  try {
    new Intl.DateTimeFormat(undefined, { timeZone: timeZoneString })
    validIANATimezoneCache[timeZoneString] = true
    return true
  } catch (error) {
    return false
  }
}

// EXTERNAL MODULE: ./node_modules/date-fns/_lib/toInteger/index.js
var toInteger = __webpack_require__(82084);
// EXTERNAL MODULE: ./node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(93561);
;// CONCATENATED MODULE: ./node_modules/date-fns-tz/esm/_lib/tzPattern/index.js
/** Regex to identify the presence of a time zone specifier in a date string */
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/

/* harmony default export */ var _lib_tzPattern = (tzPattern);

;// CONCATENATED MODULE: ./node_modules/date-fns-tz/esm/toDate/index.js





var toDate_MILLISECONDS_IN_HOUR = 3600000
var toDate_MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var toDate_patterns = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,

  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/, // 0 additional digits
    /^([+-]\d{3})$/, // 1 additional digit
    /^([+-]\d{4})$/, // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/, // 0 additional digits
    /^([+-]\d{5})/, // 1 additional digit
    /^([+-]\d{6})/, // 2 additional digits
  ],

  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,

  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,

  // time zone tokens (to identify the presence of a tz)
  timeZone: _lib_tzPattern,
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function toDate(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  if (argument === null) {
    return new Date(NaN)
  }

  var options = dirtyOptions || {}

  var additionalDigits =
    options.additionalDigits == null
      ? DEFAULT_ADDITIONAL_DIGITS
      : toInteger(options.additionalDigits)
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2')
  }

  // Clone the date
  if (
    argument instanceof Date ||
    (typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]')
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (
    typeof argument === 'number' ||
    Object.prototype.toString.call(argument) === '[object Number]'
  ) {
    return new Date(argument)
  } else if (
    !(
      typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]'
    )
  ) {
    return new Date(NaN)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (isNaN(date)) {
    return new Date(NaN)
  }

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)

      if (isNaN(time)) {
        return new Date(NaN)
      }
    }

    if (dateStrings.timeZone || options.timeZone) {
      offset = tzParseTimezone(dateStrings.timeZone || options.timeZone, new Date(timestamp + time))
      if (isNaN(offset)) {
        return new Date(NaN)
      }
    } else {
      // get offset accurate to hour in time zones that change offset
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time))
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time + offset))
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(NaN)
  }
}

function splitDateString(dateString) {
  var dateStrings = {}
  var parts = toDate_patterns.dateTimePattern.exec(dateString)
  var timeString

  if (!parts) {
    parts = toDate_patterns.datePattern.exec(dateString)
    if (parts) {
      dateStrings.date = parts[1]
      timeString = parts[2]
    } else {
      dateStrings.date = null
      timeString = dateString
    }
  } else {
    dateStrings.date = parts[1]
    timeString = parts[3]
  }

  if (timeString) {
    var token = toDate_patterns.timeZone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timeZone = token[1].trim()
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear(dateString, additionalDigits) {
  var patternYYY = toDate_patterns.YYY[additionalDigits]
  var patternYYYYY = toDate_patterns.YYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = toDate_patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length),
    }
  }

  // YY or ±YYY
  token = toDate_patterns.YY.exec(dateString) || patternYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length),
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null,
  }
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = toDate_patterns.MM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1

    if (!validateDate(year, month)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = toDate_patterns.DDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)

    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // yyyy-MM-dd or YYYYMMDD
  token = toDate_patterns.MMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)

    if (!validateDate(year, month, day)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = toDate_patterns.Www.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1

    if (!validateWeekDate(year, week)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = toDate_patterns.WwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1

    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime(timeString) {
  var token
  var hours
  var minutes

  // hh
  token = toDate_patterns.HH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))

    if (!validateTime(hours)) {
      return NaN
    }

    return (hours % 24) * toDate_MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = toDate_patterns.HHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))

    if (!validateTime(hours, minutes)) {
      return NaN
    }

    return (hours % 24) * toDate_MILLISECONDS_IN_HOUR + minutes * toDate_MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = toDate_patterns.HHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))

    if (!validateTime(hours, minutes, seconds)) {
      return NaN
    }

    return (hours % 24) * toDate_MILLISECONDS_IN_HOUR + minutes * toDate_MILLISECONDS_IN_MINUTE + seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoWeekYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

// Validation functions

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)
}

function validateDate(year, month, date) {
  if (month < 0 || month > 11) {
    return false
  }

  if (date != null) {
    if (date < 1) {
      return false
    }

    var isLeapYear = isLeapYearIndex(year)
    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false
    }
    if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
      return false
    }
  }

  return true
}

function validateDayOfYearDate(year, dayOfYear) {
  if (dayOfYear < 1) {
    return false
  }

  var isLeapYear = isLeapYearIndex(year)
  if (isLeapYear && dayOfYear > 366) {
    return false
  }
  if (!isLeapYear && dayOfYear > 365) {
    return false
  }

  return true
}

function validateWeekDate(year, week, day) {
  if (week < 0 || week > 52) {
    return false
  }

  if (day != null && (day < 0 || day > 6)) {
    return false
  }

  return true
}

function validateTime(hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false
  }

  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false
  }

  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false
  }

  return true
}

;// CONCATENATED MODULE: ./node_modules/date-fns-tz/esm/utcToZonedTime/index.js



/**
 * @name utcToZonedTime
 * @category Time Zone Helpers
 * @summary Get a date/time representing local time in a given time zone from the UTC date
 *
 * @description
 * Returns a date instance with values representing the local time in the time zone
 * specified of the UTC time from the date provided. In other words, when the new date
 * is formatted it will show the equivalent hours in the target time zone regardless
 * of the current system time zone.
 *
 * @param {Date|String|Number} date - the date with the relevant UTC time
 * @param {String} timeZone - the time zone to get local time for, can be an offset or IANA time zone
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the equivalent time in the time zone
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // In June 10am UTC is 6am in New York (-04:00)
 * const result = utcToZonedTime('2014-06-25T10:00:00.000Z', 'America/New_York')
 * //=> Jun 25 2014 06:00:00
 */
function utcToZonedTime(dirtyDate, timeZone, options) {
  var date = toDate(dirtyDate, options)

  var offsetMilliseconds = tzParseTimezone(timeZone, date, true)

  var d = new Date(date.getTime() - offsetMilliseconds)

  var resultDate = new Date(0)

  resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())

  resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds())

  return resultDate
}

// EXTERNAL MODULE: ./node_modules/date-fns/format/index.js
var format = __webpack_require__(15616);
;// CONCATENATED MODULE: ./node_modules/date-fns-tz/esm/_lib/tzIntlTimeZoneName/index.js
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */
function tzIntlTimeZoneName(length, date, options) {
  var dtf = getDTF(length, options.timeZone, options.locale)
  return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date)
}

function partsTimeZone(dtf, date) {
  var formatted = dtf.formatToParts(date)

  for (var i = formatted.length - 1; i >= 0; --i) {
    if (formatted[i].type === 'timeZoneName') {
      return formatted[i].value
    }
  }
}

function hackyTimeZone(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '')
  var tzNameMatch = / [\w-+ ]+$/.exec(formatted)
  return tzNameMatch ? tzNameMatch[0].substr(1) : ''
}

// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function getDTF(length, timeZone, locale) {
  if (locale && !locale.code) {
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    )
  }
  return new Intl.DateTimeFormat(locale ? [locale.code, 'en-US'] : undefined, {
    timeZone: timeZone,
    timeZoneName: length,
  })
}

;// CONCATENATED MODULE: ./node_modules/date-fns-tz/esm/format/formatters/index.js



var formatters_MILLISECONDS_IN_MINUTE = 60 * 1000

var formatters = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, date)

    if (timezoneOffset === 0) {
      return 'Z'
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset)

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX': // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset)

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, date)

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset)

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx': // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset)

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (GMT)
  O: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, date)

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':')
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, localize, options) {
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return tzIntlTimeZoneName('short', date, options)
      // Long
      case 'zzzz':
      default:
        return tzIntlTimeZoneName('long', date, options)
    }
  },
}

function getTimeZoneOffset(timeZone, originalDate) {
  var timeZoneOffset = timeZone
    ? tzParseTimezone(timeZone, originalDate, true) / formatters_MILLISECONDS_IN_MINUTE
    : originalDate.getTimezoneOffset()
  if (Number.isNaN(timeZoneOffset)) {
    throw new RangeError('Invalid time zone specified: ' + timeZone)
  }
  return timeZoneOffset
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : ''
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return sign + output
}

function formatTimezone(offset, dirtyDelimeter) {
  var delimeter = dirtyDelimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2)
  var minutes = addLeadingZeros(Math.floor(absOffset % 60), 2)
  return sign + hours + delimeter + minutes
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+'
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2)
  }
  return formatTimezone(offset, dirtyDelimeter)
}

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  if (minutes === 0) {
    return sign + String(hours)
  }
  var delimiter = dirtyDelimiter || ''
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2)
}

/* harmony default export */ var format_formatters = (formatters);

;// CONCATENATED MODULE: ./node_modules/date-fns-tz/esm/format/index.js




var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 8     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 8     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | PDT, EST, CEST                    | 6     |
 * |                                 | zzzz    | Pacific Daylight Time             | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are created using the Intl browser API. The output is determined by the
 *    preferred standard of the current locale (en-US by default) which may not always give the expected result.
 *    For this reason it is recommended to supply a `locale` in the format options when formatting a time zone name.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole
 *   library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard
 *   #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table). See [this
 *   post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link
 *   https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See
 *   [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens
 *   (`yy`, `yyyy`). See: https://git.io/fxCyr
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @param {Date|Number} [options.originalDate] - can be used to pass the original unmodified date to `format` to
 *   improve correctness of the replaced timezone token close to the DST threshold.
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see:
 *   https://git.io/fxCyr
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format_format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = String(dirtyFormatStr)
  var options = dirtyOptions || {}

  var matches = formatStr.match(tzFormattingTokensRegExp)
  if (matches) {
    var date = toDate(options.originalDate || dirtyDate, options)
    // Work through each match and replace the tz token in the format string with the quoted
    // formatted time zone so the remaining tokens can be filled in by date-fns#format.
    formatStr = matches.reduce(function (result, token) {
      if (token[0] === "'") {
        return result // This is a quoted portion, matched only to ensure we don't match inside it
      }
      var pos = result.indexOf(token)
      var precededByQuotedSection = result[pos - 1] === "'"
      var replaced = result.replace(
        token,
        "'" + format_formatters[token[0]](date, token, null, options) + "'"
      )
      // If the replacement results in two adjoining quoted strings, the back to back quotes
      // are removed, so it doesn't look like an escaped quote.
      return precededByQuotedSection
        ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1)
        : replaced
    }, formatStr)
  }

  return format(dirtyDate, formatStr, options)
}

// EXTERNAL MODULE: ./node_modules/smart-db/dist/Commons/Constants/constants.js
var constants = __webpack_require__(27001);
;// CONCATENATED MODULE: ./node_modules/smart-db/dist/Commons/utils.js
/* provided dependency */ var process = __webpack_require__(83454);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];





//----------------------------------------------------------------------
// export function createErrorObject(error: unknown): Record<string, any> {
//     let errorObj: Record<string, any>;
//     if (error instanceof Error) {
//         // Standard JavaScript errors
//         errorObj = {
//             name: error.name,
//             message: error.message,
//             stack: error.stack,
//             // Capture additional properties that may exist on the error
//             ...(error as any),
//         };
//     } else if (typeof error === 'object' && !isEmptyObject_usingJson(error)) {
//         // Handle non-empty objects (circular references handled by `toJson`)
//         errorObj = {
//             ...JSON.parse(toJson(error)),
//         };
//     } else {
//         // For any other error types
//         errorObj = {
//             error: String(error),
//         };
//     }
//     return errorObj;
// }
//----------------------------------------------------------------------
const isAllowedTask = (task, allowedTasks) => {
    return allowedTasks.includes(task);
};
//----------------------------------------------------------------------
const sleep = (ms) => {
    console.log(`[SLEEP] Sleeping for ${ms}ms...`);
    return new Promise((resolve) => setTimeout(resolve, ms));
};
function calculateBackoffDelay(retryDelayMs, retries) {
    const cappedRetries = Math.min(retries, 20);
    const baseDelay = cappedRetries * Math.random();
    const result = retryDelayMs * baseDelay;
    console.log(`[SLEEP] Backoff - retryDelayMs: ${retryDelayMs} - retries: ${retries} - delay: ${result}ms`);
    return result;
}
const delayCall = (fn, delay = 1000) => {
    console.log(`[SLEEP] Delaying call for ${delay}ms...`);
    setTimeout(() => {
        fn();
    }, delay);
};
const delayCallAsync = async (fn, delay = 1000) => {
    console.log(`[SLEEP] Delaying async call for ${delay}ms...`);
    return new Promise((resolve, reject) => {
        setTimeout(async () => {
            try {
                const result = await fn();
                resolve(result);
            }
            catch (error) {
                reject(error);
            }
        }, delay);
    });
};
//----------------------------------------------------------------------
const bigIntMax = (...values) => {
    if (values.length === 0)
        throw new Error("bigIntMax requires at least one argument");
    return values.reduce((max, val) => (val > max ? val : max), values[0]);
};
//----------------------------------------------------------------------
function convertMillisToTime(millis) {
    const years = Math.floor(millis / (365 * 24 * 60 * 60 * 1000));
    const yearsMillis = years * 365 * 24 * 60 * 60 * 1000;
    const days = Math.floor((millis - yearsMillis) / (24 * 60 * 60 * 1000));
    const daysMillis = days * 24 * 60 * 60 * 1000;
    const hours = Math.floor((millis - yearsMillis - daysMillis) / (60 * 60 * 1000));
    const hoursMillis = hours * 60 * 60 * 1000;
    const minutes = Math.floor((millis - yearsMillis - daysMillis - hoursMillis) / (60 * 1000));
    const minutesMillis = minutes * 60 * 1000;
    const seconds = Math.floor((millis - yearsMillis - daysMillis - hoursMillis - minutesMillis) / 1000);
    return `${years}y ${days}d ${hours}h ${minutes}m ${seconds}s`;
}
//----------------------------------------------------------------------
function showData(data, swCut = true) {
    if (!Array.isArray(data) && isObject(data) && isEmptyObject(data, true)) {
        return '{}';
    }
    const str = swCut ? toJson(data).slice(0, 256) : toJson(data);
    if (str.includes('[object Object]')) {
        console.log('TODO FIXME [object Object]');
        return '{}';
    }
    return str;
}
//----------------------------------------------------------------------
const sanitizeForDatabase = (input) => {
    const allowedMongoDBOperators = new Set([
        '$eq',
        '$gt',
        '$gte',
        '$in',
        '$lt',
        '$lte',
        '$ne',
        '$nin',
        '$or',
        '$and',
        '$not',
        '$nor',
        '$exists',
        '$type',
        '$expr',
        '$jsonSchema',
        '$mod',
        '$regex',
        '$text',
        '$where',
        '$geoWithin',
        '$geoIntersects',
        '$near',
        '$nearSphere',
        '$all',
        '$elemMatch',
        '$size',
        '$bitsAllClear',
        '$bitsAllSet',
        '$bitsAnyClear',
        '$bitsAnySet',
        // Add more operators as needed
    ]);
    const allowedTags = ['p', 'br', 'strong', 'em', 'u', 'ol', 'ul', 'li', 'h1', 'h2', 'h3', 'a', 'img', 'video', 'iframe', 'div', 'span']; // Agrega las etiquetas permitidas según Quill
    const allowedAttributes = {
        a: ['href', 'target', 'rel'], // Atributos para enlaces
        img: ['src', 'alt', 'width', 'height'], // Atributos para imágenes
        video: ['src', 'width', 'height', 'controls'], // Atributos para videos
        iframe: ['src', 'width', 'height', 'frameborder', 'allow', 'allowfullscreen'], // Atributos para iframes
        '*': ['style'], // Permitir atributos 'style' para cualquier etiqueta
    };
    if (Array.isArray(input)) {
        // If input is an array, recursively sanitize its elements
        return input.map((element) => sanitizeForDatabase(element));
    }
    else if (typeof input === 'object' && input !== null) {
        // If input is an object and not null, recursively sanitize its properties
        const sanitizedObject = {};
        for (const [key, value] of Object.entries(input)) {
            // Only allow properties that don't start with '$', or are in the allowed list
            if (!key.startsWith('$') || allowedMongoDBOperators.has(key)) {
                sanitizedObject[key] = sanitizeForDatabase(value);
            }
        }
        return sanitizedObject;
    }
    else if (typeof input === 'string') {
        //TODO: agregar allowed tags si se necesita, o el encoding
        // Trim and sanitize strings, then encode
        const sanitizedString = sanitizeHtml(input.trim(), {
            allowedTags, // Specify allowed tags if any, or leave empty to allow no tags
            allowedAttributes, // Specify allowed attributes if any, or leave empty to allow no attributes
        });
        return sanitizedString;
        // return he.encode(sanitizedString);
    }
    // Otherwise, keep the value as is
    return input;
};
//----------------------------------------------------------------------
function setAndLoosePrecision(r, n) {
    const num = BigInt(10) ** BigInt(n);
    const numerator = r * BigInt(10) ** BigInt(n);
    return numerator / num;
}
function setAndLoosePrecision1e6GetOnlyNumeratorUsingBigInt(r) {
    const SCALE_FACTOR = 1000000n;
    // Scale the numerator by 1e6, then perform integer division
    return r * SCALE_FACTOR;
}
function setAndLoosePrecision1e6GetOnlyNumerator(r) {
    const scaleFactor = new BigNumber(1_000_000);
    const scaled = r.times(scaleFactor);
    const integerPart = truncateBigNumber(scaled);
    return integerPart;
}
function truncateBigNumber(r) {
    // Direct truncation without relying on string conversion
    const result = BigInt(r.integerValue(BigNumber.ROUND_FLOOR).toString());
    // console.log('truncateBigNumber:', result);
    return result;
}
// export function truncateBigNumber(r: BigNumber): bigint {
//     const string = r.toString();
//     const integerPart = string.includes('.') ? string.split('.')[0] : string;
//     return BigInt(integerPart);
// }
function getBigIntx1e6(value) {
    if (value === undefined)
        return undefined;
    return value / 1000000n;
    // return BigInt(Math.floor(Number(value) / 1_000_000))
}
function getNumberx1e6(value) {
    if (value === undefined)
        return undefined;
    if (typeof value !== 'number' && value !== undefined) {
        value = Number(value);
    }
    return value / 1_000_000;
}
function getNumberxBPx1e3(value) {
    if (value === undefined)
        return undefined;
    if (typeof value !== 'number' && value !== undefined) {
        value = Number(value);
    }
    return value / 10_000_000;
}
//----------------------------------------------------------------------
/**
 * Scaling and Rounding Functions
 *
 * These functions replicate the precise arithmetic scaling and rounding logic
 * from Haskell. The primary use cases involve financial operations and token
 * calculations where precision is critical.
 *
 * Scaling Mechanism:
 * - Numbers are scaled up to enable fractional arithmetic using integers.
 *   - Scaling factors: 1e6, BPx1e3, 1e2.
 * - Rounding Up: Round away from zero.
 * - Rounding Down: Round towards zero (truncate decimals).
 */
/**
 * Generic function to multiply two numbers, scale, and round up.
 */
function multiply_By_Scaled_And_RoundUp(amount, number_scaled, base) {
    const multiplied = amount * number_scaled;
    const remainder = multiplied % base;
    const result = multiplied / base;
    return remainder > 0n ? result + 1n : result;
}
/**
 * Generic function to multiply two numbers, scale, and round down.
 */
function multiply_By_Scaled_And_RoundDown(amount, number_scaled, base) {
    const multiplied = amount * number_scaled;
    return multiplied / base; // BigInt division truncates (rounds down).
}
/**
 * Generic function to divide two numbers with scaling, handling rounding down.
 * Uses pure remainder-based calculation without assuming division behavior.
 */
function divide_By_Scaled_And_RoundDownSafe(amount, number_scaled, base) {
    if (number_scaled === 0n) {
        throw `divide_By_Scaled_And_RoundDownSafe - Division by zero`;
    }
    const rawAmount = amount * base;
    // Get absolute values for calculation
    const absRawAmount = rawAmount >= 0n ? rawAmount : -rawAmount;
    const absNumberScaled = number_scaled >= 0n ? number_scaled : -number_scaled;
    // Calculate remainder first
    const remainder = absRawAmount % absNumberScaled;
    // Calculate rounded down result by subtracting remainder
    const roundedResult = (absRawAmount - remainder) / absNumberScaled;
    // Determine sign: if inputs have same sign, result is positive
    const isPositive = (rawAmount >= 0n && number_scaled >= 0n) || (rawAmount < 0n && number_scaled < 0n);
    return isPositive ? roundedResult : -roundedResult;
}
/**
 * Generic function to divide two numbers with scaling, handling rounding up.
 * Uses pure remainder-based calculation without assuming division behavior.
 */
function divide_By_Scaled_And_RoundUpSafe(amount, number_scaled, base) {
    if (number_scaled === 0n) {
        throw `divide_By_Scaled_And_RoundUpSafe - Division by zero`;
    }
    const rawAmount = amount * base;
    // Get absolute values for calculation
    const absRawAmount = rawAmount >= 0n ? rawAmount : -rawAmount;
    const absNumberScaled = number_scaled >= 0n ? number_scaled : -number_scaled;
    // Calculate remainder first
    const remainder = absRawAmount % absNumberScaled;
    // Calculate result adding the appropriate amount if there's a remainder
    const roundedResult = remainder === 0n ? absRawAmount / absNumberScaled : (absRawAmount - remainder + absNumberScaled) / absNumberScaled;
    // Determine sign: if inputs have same sign, result is positive
    const isPositive = (rawAmount >= 0n && number_scaled >= 0n) || (rawAmount < 0n && number_scaled < 0n);
    return isPositive ? roundedResult : -roundedResult;
}
/**
 * Multiply by 1e6 and round up.
 */
function multiply_By_Scaled_1e6_And_RoundUp(amount, number_1x06) {
    return multiply_By_Scaled_And_RoundUp(amount, number_1x06, 1000000n);
}
/**
 * Multiply by 1e6 and round down.
 */
function multiply_By_Scaled_1e6_And_RoundDown(amount, number_1x06) {
    return multiply_By_Scaled_And_RoundDown(amount, number_1x06, 1000000n);
}
/**
 * Divide by 1e6 and round down safely.
 */
function divide_By_Scaled_1e6_And_RoundDownSafe(amount, number_1e6) {
    return divide_By_Scaled_And_RoundDownSafe(amount, number_1e6, 1000000n);
}
/**
 * Divide by 1e6 and round up safely.
 */
function divide_By_Scaled_1e6_And_RoundUpSafe(amount, number_1e6) {
    return divide_By_Scaled_And_RoundUpSafe(amount, number_1e6, 1000000n);
}
/**
 * Multiply by BPx1e3 (Basis Points x1e3) and round up.
 */
function multiply_By_Scaled_BPx1e3_And_RoundUp(amount, number_BPx1e3) {
    return multiply_By_Scaled_And_RoundUp(amount, number_BPx1e3, 10000000n);
}
/**
 * Multiply by BPx1e3 (Basis Points x1e3) and round down.
 */
function multiply_By_Scaled_BPx1e3_And_RoundDown(amount, number_BPx1e3) {
    return multiply_By_Scaled_And_RoundDown(amount, number_BPx1e3, 10000000n);
}
/**
 * Divide by BPx1e3 and round down safely.
 */
function divide_By_Scaled_BPx1e3_And_RoundDownSafe(amount, number_BPx1e3) {
    return divide_By_Scaled_And_RoundDownSafe(amount, number_BPx1e3, 10000000n);
}
/**
 * Multiply by 1e2 and round up.
 */
function multiply_By_Scaled_1e2_And_RoundUp(amount, number_1e2) {
    return multiply_By_Scaled_And_RoundUp(amount, number_1e2, 100n);
}
/**
 * Multiply by 1e2 and round down.
 */
function multiply_By_Scaled_1e2_And_RoundDown(amount, number_1e2) {
    return multiply_By_Scaled_And_RoundDown(amount, number_1e2, 100n);
}
/**
 * Divide by 1e2 and round down safely.
 */
function divide_By_Scaled_1e2_And_RoundDownSafe(amount, number_1e2) {
    return divide_By_Scaled_And_RoundDownSafe(amount, number_1e2, 100n);
}
//----------------------------------------------------------------------
function getInputValueFromSmallUnitPriceLovelace1xe6(smallUnitPriceLovelace1xe6, decimals) {
    if (smallUnitPriceLovelace1xe6 === undefined)
        return undefined;
    if (typeof smallUnitPriceLovelace1xe6 !== 'number' && smallUnitPriceLovelace1xe6 !== undefined) {
        smallUnitPriceLovelace1xe6 = Number(smallUnitPriceLovelace1xe6);
    }
    const inputDecimales = PRICEx1e6_DECIMALS + TOKEN_ADA_DECIMALS - decimals;
    // const reverseSmallUnitPriceLovelace = smallUnitPriceLovelace1xe6 / 10 ** PRICEx1e6_DECIMALS;
    // console.log(`reverseSmallUnitPriceLovelace: ${reverseSmallUnitPriceLovelace}`);
    // const reverseUnitPriceLovelace = reverseSmallUnitPriceLovelace * 10 ** decimals;
    // console.log(`reverseUnitPriceLovelace: ${reverseUnitPriceLovelace}`);
    // const reverseUnitPriceADA = reverseUnitPriceLovelace / 10 ** ADA_DECIMALS;
    // console.log(`reverseUnitPriceADA: ${reverseUnitPriceADA}`);
    // const reverseInputValue = reverseUnitPriceADA * 10 ** inputDecimales;
    // console.log(`reverseInputValue: ${reverseInputValue}`);
    const reverseInputValue1Step = BigInt(Math.floor(smallUnitPriceLovelace1xe6 * 10 ** (inputDecimales - TOKEN_ADA_DECIMALS + decimals - PRICEx1e6_DECIMALS)));
    // console.log(`reverseInputValue1Step: ${reverseInputValue1Step}`);
    return reverseInputValue1Step;
}
function getSmallUnitPriceLovelace1xe6FromInputValue(inputValue, decimals) {
    if (inputValue === undefined)
        return undefined;
    if (typeof inputValue !== 'number' && inputValue !== undefined) {
        inputValue = Number(inputValue);
    }
    const inputDecimales = PRICEx1e6_DECIMALS + TOKEN_ADA_DECIMALS - decimals;
    // const unitPriceADA = inputValue / 10 ** inputDecimales;
    // console.log(`unitPriceADA: ${unitPriceADA}`);
    // const unitPriceLovelace = unitPriceADA * 10 ** ADA_DECIMALS;
    // console.log(`unitPriceLovelace: ${unitPriceLovelace}`);
    // const smallUnitPriceLovelace = unitPriceLovelace / 10 ** decimals!;
    // console.log(`smallUnitPriceLovelace: ${smallUnitPriceLovelace}`);
    // const smallUnitPriceLovelace1xe6 = (Math.floor(smallUnitPriceLovelace * 10 **PRICEx1e6_DECIMALS));
    // console.log(`smallUnitPriceLovelace1xe6: ${smallUnitPriceLovelace1xe6}`);
    const smallUnitPriceLovelace1xe61Step = BigInt(Math.floor(inputValue * 10 ** (-inputDecimales + TOKEN_ADA_DECIMALS - decimals + PRICEx1e6_DECIMALS)));
    // console.log(`smallUnitPriceLovelace1xe61Step: ${smallUnitPriceLovelace1xe61Step}`);
    return smallUnitPriceLovelace1xe61Step;
}
//----------------------------------------------------------------------
function getInstanceVariables(instance) {
    return Object.keys(instance).filter((key) => typeof instance[key] !== 'function');
}
function getFieldsAndTypes(obj) {
    const fieldTypes = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            fieldTypes[key] = typeof obj[key];
        }
    }
    return fieldTypes;
}
//----------------------------------------------------------------------
function capitalizeFirstLetters(sentence) {
    if (sentence === undefined) {
        return undefined;
    }
    return sentence.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
}
//----------------------------------------------------------------------
async function executeFunction(fn, value1, value2) {
    if (isPromiseFunction(fn)) {
        if (fn.length === 2) {
            return await fn(value1, value2);
        }
        else if (fn.length === 1) {
            return await fn(value1);
        }
        else {
            return await fn();
        }
    }
    else {
        if (fn.length === 2) {
            return fn(value1, value2);
        }
        else if (fn.length === 1) {
            return fn(value1);
        }
        else {
            return fn();
        }
    }
}
//----------------------------------------------------------------------
function isPromiseFunction(fn) {
    return fn.constructor && fn.constructor.name === 'AsyncFunction';
}
//----------------------------------------------------------------------
function isFrontEndEnvironment() {
    if (typeof window !== 'undefined') {
        // console.log('This code is running in the browser (frontend)');
        return true;
    }
    else if (typeof process !== 'undefined') {
        // console.log('This code is running in Node.js (backend)');
        return false;
    }
    return false;
}
//----------------------------------------------------------------------
function createQueryURLString(obj) {
    if (obj === undefined) {
        return '';
    }
    const query = Object.entries(obj)
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    return `?${query}`;
}
//----------------------------------------------------------------------
const generateRandomHash = () => {
    const timestamp = Date.now().toString();
    const dataWithTime = timestamp;
    const hash = createHash('sha256');
    hash.update(dataWithTime);
    return hash.digest('hex');
};
//----------------------------------------------------------------------
function convertUTCDateToLocalDate(date, format_ = 'yyyy-MM-dd HH:mm:ss', timeZone) {
    if (timeZone === undefined)
        timeZone = getUserTimeZone();
    const zonedDate = utcToZonedTime(date, timeZone);
    return format_format(zonedDate, format_, { timeZone });
}
function getUserTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function startOfDay(date) {
    const start = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0));
    return start;
}
function endOfDay(date) {
    const end = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 23, 59, 59, 999));
    return end;
}
function daysBetweenDates(startDate, endDate) {
    const oneDay = 1000 * 60 * 60 * 24; // milliseconds in one day
    const diffInTime = endDate.getTime() - startDate.getTime();
    return Math.ceil(diffInTime / oneDay);
}
function addDays(date, days) {
    const result = new Date(date);
    result.setUTCDate(result.getUTCDate() + days);
    return result;
}
function subDays(date, days) {
    return addDays(date, -days);
}
function isSameDay(date1, date2) {
    return date1.getUTCDate() === date2.getUTCDate() && date1.getUTCMonth() === date2.getUTCMonth() && date1.getUTCFullYear() === date2.getUTCFullYear();
}
//----------------------------------------------------------------------
function intToLetter(number) {
    return String.fromCharCode(65 + number);
}
function letterToInt(letter) {
    return letter.charCodeAt(0) - 65;
}
//----------------------------------------------------------------------
const copyToClipboard = (str) => {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText)
        return navigator.clipboard.writeText(str);
    return Promise.reject('The Clipboard API is not available.');
};
//----------------------------------------------------------------------
//for converting String into Hex representation. It is used for converting the TokenName into Hex
function strToHex(str) {
    let result = '';
    for (let i = 0; i < str.length; i++) {
        result += str.charCodeAt(i).toString(16);
    }
    return result;
}
//for converting Hex into String
function hexToStr(hexStr) {
    if (hexStr === '' || hexStr === undefined) {
        return '';
    }
    if (isValidHex(hexStr) === false) {
        return '';
    }
    const bytes = new Uint8Array(hexStr.length / 2);
    for (let i = 0; i !== bytes.length; i++) {
        bytes[i] = parseInt(hexStr.substr(i * 2, 2), 16);
    }
    return new TextDecoder().decode(bytes);
}
const isValidHex = (hex) => {
    // Ensure the string length is even
    if (hex.length % 2 !== 0) {
        return false;
    }
    // Regular expression to match valid hexadecimal characters
    const hexRegex = /^[0-9A-Fa-f]+$/;
    return hexRegex.test(hex);
};
//----------------------------------------------------------------------
// #region toByteString
function intToUint8Array(x) {
    if (x < 0) {
        return concatUint8Arrays([new Uint8Array([45]), intToUint8Array(-x)]); // 45 is ASCII code for '-'
    }
    if (x / 10n === 0n) {
        return digitToUint8Array(x);
    }
    return concatUint8Arrays([intToUint8Array(x / 10n), digitToUint8Array(x % 10n)]);
    function digitToUint8Array(d) {
        // 48 is ASCII code for '0'
        return new Uint8Array([Number(d) + 48]);
    }
}
function stringToUint8Array(s) {
    return new TextEncoder().encode(s);
}
function stringHexToUint8Array(hexStr) {
    const bytes = new Uint8Array(hexStr.length / 2);
    for (let i = 0; i < hexStr.length; i += 2) {
        bytes[i / 2] = parseInt(hexStr.substr(i, 2), 16);
    }
    return bytes;
}
function bytesUint8ArraToStringHex(bytes) {
    const b = Buffer.from(bytes).toString('hex');
    return b;
}
function bytesUint8ArraToStringHex2(bytes) {
    const toHexString = bytes.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');
    return toHexString;
}
//for converting Hex String to byte array. It is used in sha256 calculation.
function stringHexToNumberArray(hexStr) {
    let bytes = [];
    for (let c = 0; c < hexStr.length; c += 2) {
        bytes.push(parseInt(hexStr.substr(c, 2), 16));
    }
    return bytes;
}
// Convert a byte array to a hex string
function numberArrayToStringHex(bytes) {
    let hex = [];
    for (let i = 0; i < bytes.length; i++) {
        let current = bytes[i] < 0 ? bytes[i] + 256 : bytes[i];
        hex.push((current >>> 4).toString(16));
        hex.push((current & 0xf).toString(16));
    }
    return hex.join('');
}
// Helper function to concatenate Uint8Array
function concatUint8Arrays(arrays) {
    let totalLength = 0;
    arrays.forEach((arr) => (totalLength += arr.length));
    const result = new Uint8Array(totalLength);
    let offset = 0;
    arrays.forEach((arr) => {
        result.set(arr, offset);
        offset += arr.length;
    });
    return result;
}
// #endregion toByteString
//----------------------------------------------------------------------
// //for showing content of pointers
// export function showPtrInHex(ptr: any): string {
//     return ptr.to_cbor_hex();
//     // return Buffer.from(ptr.to_bytes(), 'utf8').toString('hex');
// }
//----------------------------------------------------------------------
//for calculating sha256S hash from hex string
function sha256HexStr(hexStr) {
    //const bytesStr = stringHexToNumberArray (hexStr)
    //const res = createHash('sha256').update(bytesStr).digest('hex');
    const res = createHash('sha256').update(hexStr, 'hex').digest('hex');
    return res;
}
//----------------------------------------------------------------------
//for printing pretty any object
function toJson(data, space, swOnlyDefined = false, swOnlyOwnProperties = true) {
    const getCircularReplacer = () => {
        const parents = []; // Track parent objects
        const parentKeys = []; // Track corresponding keys
        return function (key, value) {
            // Handle bigint conversion
            if (typeof value === 'bigint') {
                return value.toString();
            }
            // Handle primitive values directly
            if (!isObject(value) || value === null) {
                return value;
            }
            // Handle Error objects
            if (value instanceof Error) {
                return {
                    name: value.name,
                    message: value.message,
                    stack: value.stack,
                    ...Object.getOwnPropertyNames(value).reduce((acc, key) => {
                        acc[key] = value[key]; // Include custom properties
                        return acc;
                    }, {}),
                };
            }
            if (isObject(value) && !isEmptyObject(value, swOnlyDefined, swOnlyOwnProperties)) {
                const index = parents.indexOf(this);
                if (index !== -1) {
                    parents.splice(index + 1);
                    parentKeys.splice(index, Infinity, key);
                }
                else {
                    parents.push(this);
                    parentKeys.push(key);
                }
                if (parents.includes(value)) {
                    return 'Object Circular Reference';
                }
            }
            return value;
        };
    };
    if (data !== null && data !== undefined) {
        let json = JSON.stringify(data, getCircularReplacer(), space);
        if (json === '{}' && data.toString !== undefined && !isObject(data)) {
            json = data.toString();
        }
        const jsonreplace = json.replace(/"(-?\d+)n"/g, (_, a) => a);
        return jsonreplace;
    }
    else {
        return '{}';
    }
}
//----------------------------------------------------------------------
function searchValueInArray(array, value) {
    for (let i = 0; i < array.length; i++) {
        if (array[i] === value) {
            return true;
        }
    }
    return false;
}
//remove value from array
function removeValueFromArray(array, value) {
    const res = [];
    for (let i = 0; i < array.length; i++) {
        if (array[i] !== value) {
            res.push(array[i]);
        }
    }
    return res;
}
//search key in object
function searchKeyInObject(obj, key) {
    const keys = Object.keys(obj);
    for (let i = 0; i < keys.length; i++) {
        if (key === keys[i]) {
            return true;
        }
    }
    if (obj.hasOwnProperty(key)) {
        return true;
    }
    else {
        return false;
    }
}
//search and get key in object
function searchAndGetKeyInObject(obj, key) {
    const keys = Object.keys(obj);
    for (let i = 0; i < keys.length; i++) {
        if (key === keys[i]) {
            return obj[key];
        }
    }
    if (obj.hasOwnProperty(key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
//----------------------------------------------------------------------
function htmlEscape(str) {
    return str.replace(/&/g, '&amp').replace(/'/g, '&apos').replace(/"/g, '&quot').replace(/>/g, '&gt').replace(/</g, '&lt');
}
// The opposite function:
function htmlUnescape(str) {
    return str.replace(/&amp/g, '&').replace(/&apos/g, "'").replace(/&quot/g, '"').replace(/&gt/g, '>').replace(/&lt/g, '<');
}
//----------------------------------------------------------------------
function isEqual(obj1, obj2) {
    if (obj1 === obj2) {
        return true;
    }
    if (isObject(obj1) && isObject(obj2)) {
        const props1 = Object.getOwnPropertyNames(obj1);
        const props2 = Object.getOwnPropertyNames(obj2);
        if (props1.length !== props2.length) {
            return false;
        }
        for (const prop of props1) {
            const val1 = obj1[prop];
            const val2 = obj2[prop];
            const areObjects = isObject(val1) && isObject(val2);
            const areArrays = Array.isArray(val1) && Array.isArray(val2);
            if ((areObjects || areArrays) && !isEqual(val1, val2)) {
                return false;
            }
            else if (!areObjects && !areArrays && val1 !== val2) {
                return false;
            }
        }
        return true;
    }
    else if (Array.isArray(obj1) && Array.isArray(obj2)) {
        if (obj1.length !== obj2.length) {
            return false;
        }
        for (let i = 0; i < obj1.length; i++) {
            if (!isEqual(obj1[i], obj2[i])) {
                return false;
            }
        }
        return true;
    }
    return false;
}
function isEmptyObject(obj, swOnlyDefined = false, swOnlyOwnProperties = true) {
    if (!isObject(obj))
        return true;
    const result = !Object.entries(obj).some(([key, value]) => ((swOnlyOwnProperties && (Object.hasOwn(obj, key) || obj.hasOwnProperty(key))) || !swOnlyOwnProperties) && ((swOnlyDefined && value !== undefined) || !swOnlyDefined));
    return result;
    // for (let key in obj) {
    //     if (((swOnlyOwnProperties && obj.hasOwnProperty(key)) || !swOnlyOwnProperties) && ((swOnlyDefined && obj[key] !== undefined) || !swOnlyDefined)) {
    //         return false;
    //     }
    // }
    // return true;
}
function isEmptyObject_usingJson(obj) {
    if (toJson(obj) === '{}') {
        return true;
    }
    return false;
}
function isString(object) {
    return typeof object === 'string';
}
function isObject(object) {
    return object !== null && typeof object === 'object' && object.hasOwnProperty !== undefined;
}
const isNullOrBlank = (value) => {
    return value === undefined || value === null || (typeof value === 'string' && value.trim() === '');
};
const isArrayEmpty = (value) => {
    return value === undefined || value === null || value.length === 0;
};
//----------------------------------------------------------------------
// NOTE: check other implementations
// not for instances
// only for class constructors
// export function isSubclassOf_Legacy(Derived: any, Base: any): boolean {
//     let proto = Object.getPrototypeOf(Derived);
//     while (proto) {
//         if (proto === Base) {
//             return true;
//         }
//         proto = Object.getPrototypeOf(proto);
//     }
//     return false;
// }
// export function isSubclassOf_Legacy2(Derived: any, Base: any): boolean {
//     let proto = Derived;
//     while (proto) {
//         // console.log(`proto === Base: ${proto === Base} - proto.name ${proto.name} === Base.name ${Base.name}: ${proto.name === Base.name} && ${Object.getPrototypeOf(proto)?.name} === ${Object.getPrototypeOf(Base)?.name}: ${Object.getPrototypeOf(proto)?.name === Object.getPrototypeOf(Base)?.name}`);
//         if (proto === Base) {
//             return true;
//         }
//         if (proto.name === Base.name && Object.getPrototypeOf(proto)?.name === Object.getPrototypeOf(Base)?.name) {
//             return true;
//         }
//         proto = Object.getPrototypeOf(proto);
//     }
//     return false;
// }
function isSubclassOf_Legacy(Derived, Base) {
    let proto = Object.getPrototypeOf(Derived);
    while (proto) {
        if (proto === Base) {
            return true;
        }
        proto = Object.getPrototypeOf(proto);
    }
    return false;
}
function isSubclassOf(Derived, Base) {
    let proto = Derived;
    while (proto) {
        // Si coincide con la clase base, devuelve true
        if (isSameClass(proto, Base)) {
            return true;
        }
        proto = Object.getPrototypeOf(proto);
    }
    return false;
}
function isSameClass(ClassA, ClassB) {
    let protoA = ClassA;
    let protoB = ClassB;
    while (protoA && protoB) {
        if (protoA.name !== protoB.name || (protoA._className && protoB._className && protoA._className !== protoB._className)) {
            return false;
        }
        protoA = Object.getPrototypeOf(protoA);
        protoB = Object.getPrototypeOf(protoB);
        // Si llegamos a Object sin encontrar diferencias, es la misma clase
        if (protoA === Object && protoB === Object) {
            return true;
        }
        if (protoA === null && protoB === null) {
            return true;
        }
    }
    return false;
}
//----------------------------------------------------------------------
const generateRandomColor = () => {
    const randomColor = Math.floor(Math.random() * 16777215)
        .toString(16)
        .toUpperCase();
    return `#${randomColor.padStart(6, '0')}`;
};
//----------------------------------------------------------------------
function getTxRedeemersDetailsAndResources(tx) {
    const resultRedeemers = [];
    const resultRedeemersLogs = [];
    const resultTx = [];
    const CMLTx = tx.toTransaction();
    const fee = parseInt(CMLTx.body().fee().toString());
    const txSize = CMLTx.to_cbor_bytes().length;
    const redeemers = CMLTx.witness_set().redeemers();
    var mem_ = 0;
    var cpu_ = 0;
    const TransactionTypes = [
        'Spend', // 0
        'Mint', // 1
        'Cert', // 2
        'Reward', // 3
        'Voting', // 4
        'Proposing', // 5
    ];
    if (redeemers) {
        const arrLegacyRedeemer = redeemers?.as_arr_legacy_redeemer();
        if (arrLegacyRedeemer) {
            for (let i = 0; i < arrLegacyRedeemer.len(); i++) {
                const redeemer = arrLegacyRedeemer.get(i);
                const mem = parseInt(redeemer.ex_units().mem().toString());
                const cpu = parseInt(redeemer.ex_units().steps().toString());
                cpu_ += cpu;
                mem_ += mem;
                resultRedeemers.push({
                    INDEX: Number(redeemer.index().toString()),
                    TAG: TransactionTypes[redeemer.tag()],
                    MEM: mem / 1_000_000,
                    CPU: cpu / 1_000_000_000,
                    CBOR: redeemer.data().to_canonical_cbor_hex(),
                });
                resultRedeemersLogs.push({ INDEX: Number(redeemer.index().toString()), TAG: TransactionTypes[redeemer.tag()], MEM: mem / 1_000_000, CPU: cpu / 1_000_000_000 });
            }
        }
        const mapRedeemerKeyToRedeemerVal = redeemers?.as_map_redeemer_key_to_redeemer_val();
        if (mapRedeemerKeyToRedeemerVal) {
            const keys = mapRedeemerKeyToRedeemerVal.keys();
            for (let i = 0; i < (keys.len() || 0); i++) {
                const key = keys.get(i);
                const value = mapRedeemerKeyToRedeemerVal.get(key);
                if (value !== undefined) {
                    const mem = parseInt(value.ex_units().mem().toString());
                    const cpu = parseInt(value.ex_units().steps().toString());
                    cpu_ += cpu;
                    mem_ += mem;
                    resultRedeemers.push({
                        INDEX: Number(key.index().toString()),
                        TAG: TransactionTypes[key.tag()],
                        MEM: mem / 1_000_000,
                        CPU: cpu / 1_000_000_000,
                        CBOR: key.to_canonical_cbor_hex(),
                    });
                    resultRedeemersLogs.push({ INDEX: Number(key.index().toString()), TAG: TransactionTypes[key.tag()], MEM: mem / 1_000_000, CPU: cpu / 1_000_000_000 });
                }
            }
        }
    }
    resultTx.push({
        SIZE: txSize,
        MEM: mem_ / 1_000_000,
        CPU: cpu_ / 1_000_000_000,
        FEE: fee / constants/* TOKEN_ADA_MULTIPLIER */.QR,
    });
    return { redeemers: resultRedeemers, redeemersLogs: resultRedeemersLogs, tx: resultTx };
}
//---------------------------------------------------------------------
function checkIfUserCanceled(error) {
    const errorList = [
        'User canceled',
        'user declined sign tx',
        'User denied account authorization',
        'User rejected the request',
        'User rejected the transaction',
        'User denied transaction signature',
        'Transaction rejected',
        'Transaction aborted',
    ];
    let errorString = toJson(error);
    return errorList.some((msg) => errorString.includes(msg));
}
//---------------------------------------------------------------------
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 96548:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ index_esm_namespaceObject; }
});

// NAMESPACE OBJECT: ./node_modules/yup/index.esm.js
var index_esm_namespaceObject = {};
__webpack_require__.r(index_esm_namespaceObject);
__webpack_require__.d(index_esm_namespaceObject, {
  "ArraySchema": function() { return ArraySchema; },
  "BooleanSchema": function() { return BooleanSchema; },
  "DateSchema": function() { return DateSchema; },
  "LazySchema": function() { return Lazy; },
  "MixedSchema": function() { return MixedSchema; },
  "NumberSchema": function() { return NumberSchema; },
  "ObjectSchema": function() { return ObjectSchema; },
  "Schema": function() { return Schema; },
  "StringSchema": function() { return StringSchema; },
  "TupleSchema": function() { return TupleSchema; },
  "ValidationError": function() { return ValidationError; },
  "addMethod": function() { return addMethod; },
  "array": function() { return create$2; },
  "bool": function() { return create$7; },
  "boolean": function() { return create$7; },
  "date": function() { return create$4; },
  "defaultLocale": function() { return locale; },
  "getIn": function() { return getIn; },
  "isSchema": function() { return isSchema; },
  "lazy": function() { return create; },
  "mixed": function() { return create$8; },
  "number": function() { return create$5; },
  "object": function() { return create$3; },
  "printValue": function() { return printValue; },
  "reach": function() { return reach; },
  "ref": function() { return create$9; },
  "setLocale": function() { return setLocale; },
  "string": function() { return create$6; },
  "tuple": function() { return create$1; }
});

// EXTERNAL MODULE: ./node_modules/property-expr/index.js
var property_expr = __webpack_require__(55760);
// EXTERNAL MODULE: ./node_modules/tiny-case/index.js
var tiny_case = __webpack_require__(59885);
// EXTERNAL MODULE: ./node_modules/toposort/index.js
var toposort = __webpack_require__(94633);
var toposort_default = /*#__PURE__*/__webpack_require__.n(toposort);
;// CONCATENATED MODULE: ./node_modules/yup/index.esm.js




const index_esm_toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}
function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = index_esm_toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

function toArray(value) {
  return value == null ? [] : [].concat(value);
}

let _Symbol$toStringTag, _Symbol$hasInstance, _Symbol$toStringTag2;
let strReg = /\$\{\s*(\w+)\s*\}/g;
_Symbol$toStringTag = Symbol.toStringTag;
class ValidationErrorNoStack {
  constructor(errorOrErrors, value, field, type) {
    this.name = void 0;
    this.message = void 0;
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = void 0;
    this.inner = void 0;
    this[_Symbol$toStringTag] = 'Error';
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        const innerErrors = err.inner.length ? err.inner : [err];
        this.inner.push(...innerErrors);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
_Symbol$hasInstance = Symbol.hasInstance;
_Symbol$toStringTag2 = Symbol.toStringTag;
class ValidationError extends Error {
  static formatError(message, params) {
    // Attempt to make the path more friendly for error message interpolation.
    const path = params.label || params.path || 'this';
    // Store the original path under `originalPath` so it isn't lost to custom
    // message functions; e.g., ones provided in `setLocale()` calls.
    params = Object.assign({}, params, {
      path,
      originalPath: params.path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }
  static isError(err) {
    return err && err.name === 'ValidationError';
  }
  constructor(errorOrErrors, value, field, type, disableStack) {
    const errorNoStack = new ValidationErrorNoStack(errorOrErrors, value, field, type);
    if (disableStack) {
      return errorNoStack;
    }
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = [];
    this.inner = [];
    this[_Symbol$toStringTag2] = 'Error';
    this.name = errorNoStack.name;
    this.message = errorNoStack.message;
    this.type = errorNoStack.type;
    this.value = errorNoStack.value;
    this.path = errorNoStack.path;
    this.errors = errorNoStack.errors;
    this.inner = errorNoStack.inner;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError);
    }
  }
  static [_Symbol$hasInstance](inst) {
    return ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
  }
}

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  defined: '${path} must be defined',
  notNull: '${path} cannot be null',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.';
    return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${printValue(value, true)}\`` + castMsg;
  }
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  datetime: '${path} must be a valid ISO date-time',
  datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let index_esm_boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}',
  exact: '${path} object contains unknown properties: ${properties}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
let tuple = {
  notType: params => {
    const {
      path,
      value,
      spec
    } = params;
    const typeLen = spec.types.length;
    if (Array.isArray(value)) {
      if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
      if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
    }
    return ValidationError.formatError(mixed.notType, params);
  }
};
var locale = Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean: index_esm_boolean,
  tuple
});

const isSchema = obj => obj && obj.__isYupSchema__;

class Condition {
  static fromOptions(refs, config) {
    if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = config;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);
    return new Condition(refs, (values, schema) => {
      var _branch;
      let branch = check(...values) ? then : otherwise;
      return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
    });
  }
  constructor(refs, builder) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    this.fn = builder;
  }
  resolve(base, options) {
    let values = this.refs.map(ref =>
    // TODO: ? operator here?
    ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn(values, base, options);
    if (schema === undefined ||
    // @ts-ignore this can be base
    schema === base) {
      return base;
    }
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }
}

const prefixes = {
  context: '$',
  value: '.'
};
function create$9(key, options) {
  return new Reference(key, options);
}
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && (0,property_expr.getter)(this.path, true);
    this.map = options.map;
  }
  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }

  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(value) {
    return value && value.__isYupRef;
  }
}

// @ts-ignore
Reference.prototype.__isYupRef = true;

const isAbsent = value => value == null;

function createValidation(config) {
  function validate({
    value,
    path = '',
    options,
    originalValue,
    schema
  }, panic, next) {
    const {
      name,
      test,
      params,
      message,
      skipAbsent
    } = config;
    let {
      parent,
      context,
      abortEarly = schema.spec.abortEarly,
      disableStackTrace = schema.spec.disableStackTrace
    } = options;
    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }
    function createError(overrides = {}) {
      const nextParams = Object.assign({
        value,
        originalValue,
        label: schema.spec.label,
        path: overrides.path || path,
        spec: schema.spec,
        disableStackTrace: overrides.disableStackTrace || disableStackTrace
      }, params, overrides.params);
      for (const key of Object.keys(nextParams)) nextParams[key] = resolve(nextParams[key]);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
      error.params = nextParams;
      return error;
    }
    const invalid = abortEarly ? panic : next;
    let ctx = {
      path,
      parent,
      type: name,
      from: options.from,
      createError,
      resolve,
      options,
      originalValue,
      schema
    };
    const handleResult = validOrError => {
      if (ValidationError.isError(validOrError)) invalid(validOrError);else if (!validOrError) invalid(createError());else next(null);
    };
    const handleError = err => {
      if (ValidationError.isError(err)) invalid(err);else panic(err);
    };
    const shouldSkip = skipAbsent && isAbsent(value);
    if (shouldSkip) {
      return handleResult(true);
    }
    let result;
    try {
      var _result;
      result = test.call(ctx, value, ctx);
      if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
        if (options.sync) {
          throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        }
        return Promise.resolve(result).then(handleResult, handleError);
      }
    } catch (err) {
      handleError(err);
      return;
    }
    handleResult(result);
  }
  validate.OPTIONS = config;
  return validate;
}

function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug;

  // root path: ''
  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  (0,property_expr.forEach)(path, (_part, isBracket, isArray) => {
    let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });
    let isTuple = schema.type === 'tuple';
    let idx = isArray ? parseInt(part, 10) : 0;
    if (schema.innerType || isTuple) {
      if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }
      parent = value;
      value = value && value[idx];
      schema = isTuple ? schema.spec.types[idx] : schema.innerType;
    }

    // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal
    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}
function reach(obj, path, value, context) {
  return getIn(obj, path, value, context).schema;
}

class ReferenceSet extends Set {
  describe() {
    const description = [];
    for (const item of this.values()) {
      description.push(Reference.isRef(item) ? item.describe() : item);
    }
    return description;
  }
  resolveAll(resolve) {
    let result = [];
    for (const item of this.values()) {
      result.push(resolve(item));
    }
    return result;
  }
  clone() {
    return new ReferenceSet(this.values());
  }
  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.forEach(value => next.add(value));
    removeItems.forEach(value => next.delete(value));
    return next;
  }
}

// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function clone(src, seen = new Map()) {
  if (isSchema(src) || !src || typeof src !== 'object') return src;
  if (seen.has(src)) return seen.get(src);
  let copy;
  if (src instanceof Date) {
    // Date
    copy = new Date(src.getTime());
    seen.set(src, copy);
  } else if (src instanceof RegExp) {
    // RegExp
    copy = new RegExp(src);
    seen.set(src, copy);
  } else if (Array.isArray(src)) {
    // Array
    copy = new Array(src.length);
    seen.set(src, copy);
    for (let i = 0; i < src.length; i++) copy[i] = clone(src[i], seen);
  } else if (src instanceof Map) {
    // Map
    copy = new Map();
    seen.set(src, copy);
    for (const [k, v] of src.entries()) copy.set(k, clone(v, seen));
  } else if (src instanceof Set) {
    // Set
    copy = new Set();
    seen.set(src, copy);
    for (const v of src) copy.add(clone(v, seen));
  } else if (src instanceof Object) {
    // Object
    copy = {};
    seen.set(src, copy);
    for (const [k, v] of Object.entries(src)) copy[k] = clone(v, seen);
  } else {
    throw Error(`Unable to clone ${src}`);
  }
  return copy;
}

// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class Schema {
  constructor(options) {
    this.type = void 0;
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this.internalTests = {};
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this._typeCheck = void 0;
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = options.type;
    this._typeCheck = options.check;
    this.spec = Object.assign({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      disableStackTrace: false,
      nullable: false,
      optional: true,
      coerce: true
    }, options == null ? void 0 : options.spec);
    this.withMutation(s => {
      s.nonNullable();
    });
  }

  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    }

    // if the nested value is a schema we can skip cloning, since
    // they are already immutable
    const next = Object.create(Object.getPrototypeOf(this));

    // @ts-expect-error this is readonly
    next.type = this.type;
    next._typeCheck = this._typeCheck;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.internalTests = Object.assign({}, this.internalTests);
    next.exclusiveTests = Object.assign({}, this.exclusiveTests);

    // @ts-expect-error this is readonly
    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(Object.assign({}, this.spec, spec));
    return next;
  }
  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }
  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  }
  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }
  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();
    const mergedSpec = Object.assign({}, base.spec, combined.spec);
    combined.spec = mergedSpec;
    combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);

    // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)
    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);

    // start with the current tests
    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests;

    // manually add the new tests to ensure
    // the deduping logic is consistent
    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }
  isType(v) {
    if (v == null) {
      if (this.spec.nullable && v === null) return true;
      if (this.spec.optional && v === undefined) return true;
      return false;
    }
    return this._typeCheck(v);
  }
  resolve(options) {
    let schema = this;
    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((prevSchema, condition) => condition.resolve(prevSchema, options), schema);
      schema = schema.resolve(options);
    }
    return schema;
  }
  resolveOptions(options) {
    var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
    return Object.assign({}, options, {
      from: options.from || [],
      strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
      abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
      recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
      disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
    });
  }

  /**
   * Run the configured transform pipeline over an input value.
   */

  cast(value, options = {}) {
    let resolvedSchema = this.resolve(Object.assign({
      value
    }, options));
    let allowOptionality = options.assert === 'ignore-optionality';
    let result = resolvedSchema._cast(value, options);
    if (options.assert !== false && !resolvedSchema.isType(result)) {
      if (allowOptionality && isAbsent(result)) {
        return result;
      }
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }
    return result;
  }
  _cast(rawValue, options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn) => fn.call(this, prevValue, rawValue, this), rawValue);
    if (value === undefined) {
      value = this.getDefault(options);
    }
    return value;
  }
  _validate(_value, options = {}, panic, next) {
    let {
      path,
      originalValue = _value,
      strict = this.spec.strict
    } = options;
    let value = _value;
    if (!strict) {
      value = this._cast(value, Object.assign({
        assert: false
      }, options));
    }
    let initialTests = [];
    for (let test of Object.values(this.internalTests)) {
      if (test) initialTests.push(test);
    }
    this.runTests({
      path,
      value,
      originalValue,
      options,
      tests: initialTests
    }, panic, initialErrors => {
      // even if we aren't ending early we can't proceed further if the types aren't correct
      if (initialErrors.length) {
        return next(initialErrors, value);
      }
      this.runTests({
        path,
        value,
        originalValue,
        options,
        tests: this.tests
      }, panic, next);
    });
  }

  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(runOptions, panic, next) {
    let fired = false;
    let {
      tests,
      value,
      originalValue,
      path,
      options
    } = runOptions;
    let panicOnce = arg => {
      if (fired) return;
      fired = true;
      panic(arg, value);
    };
    let nextOnce = arg => {
      if (fired) return;
      fired = true;
      next(arg, value);
    };
    let count = tests.length;
    let nestedErrors = [];
    if (!count) return nextOnce([]);
    let args = {
      value,
      originalValue,
      path,
      options,
      schema: this
    };
    for (let i = 0; i < tests.length; i++) {
      const test = tests[i];
      test(args, panicOnce, function finishTestRun(err) {
        if (err) {
          Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
        }
        if (--count <= 0) {
          nextOnce(nestedErrors);
        }
      });
    }
  }
  asNestedTest({
    key,
    index,
    parent,
    parentPath,
    originalParent,
    options
  }) {
    const k = key != null ? key : index;
    if (k == null) {
      throw TypeError('Must include `key` or `index` for nested validations');
    }
    const isIndex = typeof k === 'number';
    let value = parent[k];
    const testOptions = Object.assign({}, options, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: true,
      parent,
      value,
      originalValue: originalParent[k],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: undefined,
      // index: undefined,
      [isIndex ? 'index' : 'key']: k,
      path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
    });
    return (_, panic, next) => this.resolve(testOptions)._validate(value, testOptions, panic, next);
  }
  validate(value, options) {
    var _options$disableStack2;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
    return new Promise((resolve, reject) => schema._validate(value, options, (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      reject(error);
    }, (errors, validated) => {
      if (errors.length) reject(new ValidationError(errors, validated, undefined, undefined, disableStackTrace));else resolve(validated);
    }));
  }
  validateSync(value, options) {
    var _options$disableStack3;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let result;
    let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
    schema._validate(value, Object.assign({}, options, {
      sync: true
    }), (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      throw error;
    }, (errors, validated) => {
      if (errors.length) throw new ValidationError(errors, value, undefined, undefined, disableStackTrace);
      result = validated;
    });
    return result;
  }
  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }
  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }
  _getDefault(options) {
    let defaultValue = this.spec.default;
    if (defaultValue == null) {
      return defaultValue;
    }
    return typeof defaultValue === 'function' ? defaultValue.call(this, options) : clone(defaultValue);
  }
  getDefault(options
  // If schema is defaulted we know it's at least not undefined
  ) {
    let schema = this.resolve(options || {});
    return schema._getDefault(options);
  }
  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }
    let next = this.clone({
      default: def
    });
    return next;
  }
  strict(isStrict = true) {
    return this.clone({
      strict: isStrict
    });
  }
  nullability(nullable, message) {
    const next = this.clone({
      nullable
    });
    next.internalTests.nullable = createValidation({
      message,
      name: 'nullable',
      test(value) {
        return value === null ? this.schema.spec.nullable : true;
      }
    });
    return next;
  }
  optionality(optional, message) {
    const next = this.clone({
      optional
    });
    next.internalTests.optionality = createValidation({
      message,
      name: 'optionality',
      test(value) {
        return value === undefined ? this.schema.spec.optional : true;
      }
    });
    return next;
  }
  optional() {
    return this.optionality(true);
  }
  defined(message = mixed.defined) {
    return this.optionality(false, message);
  }
  nullable() {
    return this.nullability(true);
  }
  nonNullable(message = mixed.notNull) {
    return this.nullability(false, message);
  }
  required(message = mixed.required) {
    return this.clone().withMutation(next => next.nonNullable(message).defined(message));
  }
  notRequired() {
    return this.clone().withMutation(next => next.nullable().optional());
  }
  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */

  test(...args) {
    let opts;
    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }
    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }
    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }
      return true;
    });
    next.tests.push(validate);
    return next;
  }
  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }
    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore readonly array
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(typeof options === 'function' ? new Condition(deps, options) : Condition.fromOptions(deps, options));
    return next;
  }
  typeError(message) {
    let next = this.clone();
    next.internalTests.typeError = createValidation({
      message,
      name: 'typeError',
      skipAbsent: true,
      test(value) {
        if (!this.schema._typeCheck(value)) return this.createError({
          params: {
            type: this.schema.type
          }
        });
        return true;
      }
    });
    return next;
  }
  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);
      next._blacklist.delete(val);
    });
    next.internalTests.whiteList = createValidation({
      message,
      name: 'oneOf',
      skipAbsent: true,
      test(value) {
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: Array.from(valids).join(', '),
            resolved
          }
        });
      }
    });
    return next;
  }
  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);
      next._whitelist.delete(val);
    });
    next.internalTests.blacklist = createValidation({
      message,
      name: 'notOneOf',
      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: Array.from(invalids).join(', '),
            resolved
          }
        });
        return true;
      }
    });
    return next;
  }
  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const {
      label,
      meta,
      optional,
      nullable
    } = next.spec;
    const description = {
      meta,
      label,
      optional,
      nullable,
      default: next.getDefault(options),
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }
}
// @ts-expect-error
Schema.prototype.__isYupSchema__ = true;
for (const method of ['validate', 'validateSync']) Schema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], Object.assign({}, options, {
    parent,
    path
  }));
};
for (const alias of ['equals', 'is']) Schema.prototype[alias] = Schema.prototype.oneOf;
for (const alias of ['not', 'nope']) Schema.prototype[alias] = Schema.prototype.notOneOf;

const returnsTrue = () => true;
function create$8(spec) {
  return new MixedSchema(spec);
}
class MixedSchema extends Schema {
  constructor(spec) {
    super(typeof spec === 'function' ? {
      type: 'mixed',
      check: spec
    } : Object.assign({
      type: 'mixed',
      check: returnsTrue
    }, spec));
  }
}
create$8.prototype = MixedSchema.prototype;

function create$7() {
  return new BooleanSchema();
}
class BooleanSchema extends Schema {
  constructor() {
    super({
      type: 'boolean',
      check(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === 'boolean';
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (ctx.spec.coerce && !ctx.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }
        return value;
      });
    });
  }
  isTrue(message = index_esm_boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'true'
      },
      test(value) {
        return isAbsent(value) || value === true;
      }
    });
  }
  isFalse(message = index_esm_boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'false'
      },
      test(value) {
        return isAbsent(value) || value === false;
      }
    });
  }
  default(def) {
    return super.default(def);
  }
  defined(msg) {
    return super.defined(msg);
  }
  optional() {
    return super.optional();
  }
  required(msg) {
    return super.required(msg);
  }
  notRequired() {
    return super.notRequired();
  }
  nullable() {
    return super.nullable();
  }
  nonNullable(msg) {
    return super.nonNullable(msg);
  }
  strip(v) {
    return super.strip(v);
  }
}
create$7.prototype = BooleanSchema.prototype;

/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */

// prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  const struct = parseDateStruct(date);
  if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;

  // timestamps without timezone identifiers should be considered local time
  if (struct.z === undefined && struct.plusMinus === undefined) {
    return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
  }
  let totalMinutesOffset = 0;
  if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
    totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
    if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
  }
  return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function parseDateStruct(date) {
  var _regexResult$7$length, _regexResult$;
  const regexResult = isoReg.exec(date);
  if (!regexResult) return null;

  // use of toNumber() avoids NaN timestamps caused by “undefined”
  // values being passed to Date constructor
  return {
    year: toNumber(regexResult[1]),
    month: toNumber(regexResult[2], 1) - 1,
    day: toNumber(regexResult[3], 1),
    hour: toNumber(regexResult[4]),
    minute: toNumber(regexResult[5]),
    second: toNumber(regexResult[6]),
    millisecond: regexResult[7] ?
    // allow arbitrary sub-second precision beyond milliseconds
    toNumber(regexResult[7].substring(0, 3)) : 0,
    precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
    z: regexResult[8] || undefined,
    plusMinus: regexResult[9] || undefined,
    hourOffset: toNumber(regexResult[10]),
    minuteOffset: toNumber(regexResult[11])
  };
}
function toNumber(str, defaultValue = 0) {
  return Number(str) || defaultValue;
}

// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let rEmail =
// eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let rUrl =
// eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

// eslint-disable-next-line
let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let rIsoDateTime = new RegExp(`${yearMonthDay}T${hourMinuteSecond}(\\.\\d+)?${zOrOffset}$`);
let isTrimmed = value => isAbsent(value) || value === value.trim();
let objStringTag = {}.toString();
function create$6() {
  return new StringSchema();
}
class StringSchema extends Schema {
  constructor() {
    super({
      type: 'string',
      check(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (!ctx.spec.coerce || ctx.isType(value)) return value;

        // don't ever convert arrays
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;

        // no one wants plain objects converted to [Object object]
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }
  required(message) {
    return super.required(message).withMutation(schema => schema.test({
      message: message || mixed.required,
      name: 'required',
      skipAbsent: true,
      test: value => !!value.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation(schema => {
      schema.tests = schema.tests.filter(t => t.OPTIONS.name !== 'required');
      return schema;
    });
  }
  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },
      skipAbsent: true,
      test(value) {
        return value.length === this.resolve(length);
      }
    });
  }
  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value.length >= this.resolve(min);
      }
    });
  }
  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value.length <= this.resolve(max);
      }
    });
  }
  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;
    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }
    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      skipAbsent: true,
      test: value => value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }
  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }
  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }
  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  }
  datetime(options) {
    let message = '';
    let allowOffset;
    let precision;
    if (options) {
      if (typeof options === 'object') {
        ({
          message = '',
          allowOffset = false,
          precision = undefined
        } = options);
      } else {
        message = options;
      }
    }
    return this.matches(rIsoDateTime, {
      name: 'datetime',
      message: message || string.datetime,
      excludeEmptyString: true
    }).test({
      name: 'datetime_offset',
      message: message || string.datetime_offset,
      params: {
        allowOffset
      },
      skipAbsent: true,
      test: value => {
        if (!value || allowOffset) return true;
        const struct = parseDateStruct(value);
        if (!struct) return false;
        return !!struct.z;
      }
    }).test({
      name: 'datetime_precision',
      message: message || string.datetime_precision,
      params: {
        precision
      },
      skipAbsent: true,
      test: value => {
        if (!value || precision == undefined) return true;
        const struct = parseDateStruct(value);
        if (!struct) return false;
        return struct.precision === precision;
      }
    });
  }

  //-- transforms --
  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }
  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }
  lowercase(message = string.lowercase) {
    return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      skipAbsent: true,
      test: value => isAbsent(value) || value === value.toLowerCase()
    });
  }
  uppercase(message = string.uppercase) {
    return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      skipAbsent: true,
      test: value => isAbsent(value) || value === value.toUpperCase()
    });
  }
}
create$6.prototype = StringSchema.prototype;

//
// String Interfaces
//

let isNaN$1 = value => value != +value;
function create$5() {
  return new NumberSchema();
}
class NumberSchema extends Schema {
  constructor() {
    super({
      type: 'number',
      check(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === 'number' && !isNaN$1(value);
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (!ctx.spec.coerce) return value;
        let parsed = value;
        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN;
          // don't use parseFloat to avoid positives on alpha-numeric strings
          parsed = +parsed;
        }

        // null -> NaN isn't useful; treat all nulls as null and let it fail on
        // nullability check vs TypeErrors
        if (ctx.isType(parsed) || parsed === null) return parsed;
        return parseFloat(parsed);
      });
    });
  }
  min(min, message = number.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(min);
      }
    });
  }
  max(max, message = number.max) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(max);
      }
    });
  }
  lessThan(less, message = number.lessThan) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        less
      },
      skipAbsent: true,
      test(value) {
        return value < this.resolve(less);
      }
    });
  }
  moreThan(more, message = number.moreThan) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        more
      },
      skipAbsent: true,
      test(value) {
        return value > this.resolve(more);
      }
    });
  }
  positive(msg = number.positive) {
    return this.moreThan(0, msg);
  }
  negative(msg = number.negative) {
    return this.lessThan(0, msg);
  }
  integer(message = number.integer) {
    return this.test({
      name: 'integer',
      message,
      skipAbsent: true,
      test: val => Number.isInteger(val)
    });
  }
  truncate() {
    return this.transform(value => !isAbsent(value) ? value | 0 : value);
  }
  round(method) {
    var _method;
    let avail = ['ceil', 'floor', 'round', 'trunc'];
    method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';

    // this exists for symemtry with the new Math.trunc
    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(value => !isAbsent(value) ? Math[method](value) : value);
  }
}
create$5.prototype = NumberSchema.prototype;

//
// Number Interfaces
//

let invalidDate = new Date('');
let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';
function create$4() {
  return new DateSchema();
}
class DateSchema extends Schema {
  constructor() {
    super({
      type: 'date',
      check(v) {
        return isDate(v) && !isNaN(v.getTime());
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
        // nullability check vs TypeErrors
        if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
        value = parseIsoDate(value);

        // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
        return !isNaN(value) ? new Date(value) : DateSchema.INVALID_DATE;
      });
    });
  }
  prepareParam(ref, name) {
    let param;
    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }
    return param;
  }
  min(min, message = date.min) {
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(limit);
      }
    });
  }
  max(max, message = date.max) {
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(limit);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate;
create$4.prototype = DateSchema.prototype;
create$4.INVALID_DATE = invalidDate;

// @ts-expect-error
function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));
  function addNode(depPath, key) {
    let node = (0,property_expr.split)(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
  }
  for (const key of Object.keys(fields)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }
  return toposort_default().array(Array.from(nodes), edges).reverse();
}

function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;
    if ((_err$path = err.path) != null && _err$path.includes(key)) {
      idx = ii;
      return true;
    }
  });
  return idx;
}
function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

const parseJson = (value, _, ctx) => {
  if (typeof value !== 'string') {
    return value;
  }
  let parsed = value;
  try {
    parsed = JSON.parse(value);
  } catch (err) {
    /* */
  }
  return ctx.isType(parsed) ? parsed : value;
};

// @ts-ignore
function deepPartial(schema) {
  if ('fields' in schema) {
    const partial = {};
    for (const [key, fieldSchema] of Object.entries(schema.fields)) {
      partial[key] = deepPartial(fieldSchema);
    }
    return schema.setFields(partial);
  }
  if (schema.type === 'array') {
    const nextArray = schema.optional();
    if (nextArray.innerType) nextArray.innerType = deepPartial(nextArray.innerType);
    return nextArray;
  }
  if (schema.type === 'tuple') {
    return schema.optional().clone({
      types: schema.spec.types.map(deepPartial)
    });
  }
  if ('optional' in schema) {
    return schema.optional();
  }
  return schema;
}
const deepHas = (obj, p) => {
  const path = [...(0,property_expr.normalizePath)(p)];
  if (path.length === 1) return path[0] in obj;
  let last = path.pop();
  let parent = (0,property_expr.getter)((0,property_expr.join)(path), true)(obj);
  return !!(parent && last in parent);
};
let isObject = obj => Object.prototype.toString.call(obj) === '[object Object]';
function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}
const defaultSort = sortByKeyOrder([]);
function create$3(spec) {
  return new ObjectSchema(spec);
}
class ObjectSchema extends Schema {
  constructor(spec) {
    super({
      type: 'object',
      check(value) {
        return isObject(value) || typeof value === 'function';
      }
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      if (spec) {
        this.shape(spec);
      }
    });
  }
  _cast(_value, options = {}) {
    var _options$stripUnknown;
    let value = super._cast(_value, options);

    //should ignore nulls here
    if (value === undefined) return this.getDefault(options);
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
    let props = [].concat(this._nodes, Object.keys(value).filter(v => !this._nodes.includes(v)));
    let intermediateValue = {}; // is filled during the transform below
    let innerOptions = Object.assign({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });
    let isChanged = false;
    for (const prop of props) {
      let field = fields[prop];
      let exists = (prop in value);
      if (field) {
        let fieldValue;
        let inputValue = value[prop];

        // safe to mutate since this is fired in sequence
        innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = field instanceof Schema ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
        if (fieldSpec != null && fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }
        fieldValue = !options.__validating || !strict ?
        // TODO: use _cast, this is double resolving
        field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }
      if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }
    return isChanged ? intermediateValue : value;
  }
  _validate(_value, options = {}, panic, next) {
    let {
      from = [],
      originalValue = _value,
      recursive = this.spec.recursive
    } = options;
    options.from = [{
      schema: this,
      value: originalValue
    }, ...from];
    // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating
    options.__validating = true;
    options.originalValue = originalValue;
    super._validate(_value, options, panic, (objectErrors, value) => {
      if (!recursive || !isObject(value)) {
        next(objectErrors, value);
        return;
      }
      originalValue = originalValue || value;
      let tests = [];
      for (let key of this._nodes) {
        let field = this.fields[key];
        if (!field || Reference.isRef(field)) {
          continue;
        }
        tests.push(field.asNestedTest({
          options,
          key,
          parent: value,
          parentPath: options.path,
          originalParent: originalValue
        }));
      }
      this.runTests({
        tests,
        value,
        originalValue,
        options
      }, panic, fieldErrors => {
        next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
      });
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    next.fields = Object.assign({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }
  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;
    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];
      nextFields[field] = target === undefined ? schemaOrRef : target;
    }
    return next.withMutation(s =>
    // XXX: excludes here is wrong
    s.setFields(nextFields, [...this._excludedEdges, ...schema._excludedEdges]));
  }
  _getDefault(options) {
    if ('default' in this.spec) {
      return super._getDefault(options);
    }

    // if there is no default set invent one
    if (!this._nodes.length) {
      return undefined;
    }
    let dft = {};
    this._nodes.forEach(key => {
      var _innerOptions;
      const field = this.fields[key];
      let innerOptions = options;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
    });
    return dft;
  }
  setFields(shape, excludedEdges) {
    let next = this.clone();
    next.fields = shape;
    next._nodes = sortFields(shape, excludedEdges);
    next._sortErrors = sortByKeyOrder(Object.keys(shape));
    // XXX: this carries over edges which may not be what you want
    if (excludedEdges) next._excludedEdges = excludedEdges;
    return next;
  }
  shape(additions, excludes = []) {
    return this.clone().withMutation(next => {
      let edges = next._excludedEdges;
      if (excludes.length) {
        if (!Array.isArray(excludes[0])) excludes = [excludes];
        edges = [...next._excludedEdges, ...excludes];
      }

      // XXX: excludes here is wrong
      return next.setFields(Object.assign(next.fields, additions), edges);
    });
  }
  partial() {
    const partial = {};
    for (const [key, schema] of Object.entries(this.fields)) {
      partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
    }
    return this.setFields(partial);
  }
  deepPartial() {
    const next = deepPartial(this);
    return next;
  }
  pick(keys) {
    const picked = {};
    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }
    return this.setFields(picked, this._excludedEdges.filter(([a, b]) => keys.includes(a) && keys.includes(b)));
  }
  omit(keys) {
    const remaining = [];
    for (const key of Object.keys(this.fields)) {
      if (keys.includes(key)) continue;
      remaining.push(key);
    }
    return this.pick(remaining);
  }
  from(from, to, alias) {
    let fromGetter = (0,property_expr.getter)(from, true);
    return this.transform(obj => {
      if (!obj) return obj;
      let newObj = obj;
      if (deepHas(obj, from)) {
        newObj = Object.assign({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }
      return newObj;
    });
  }

  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }

  /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */
  exact(message) {
    return this.test({
      name: 'exact',
      exclusive: true,
      message: message || object.exact,
      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return unknownKeys.length === 0 || this.createError({
          params: {
            properties: unknownKeys.join(', ')
          }
        });
      }
    });
  }
  stripUnknown() {
    return this.clone({
      noUnknown: true
    });
  }
  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow !== 'boolean') {
      message = noAllow;
      noAllow = true;
    }
    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }
    });
    next.spec.noUnknown = noAllow;
    return next;
  }
  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }
  transformKeys(fn) {
    return this.transform(obj => {
      if (!obj) return obj;
      const result = {};
      for (const key of Object.keys(obj)) result[fn(key)] = obj[key];
      return result;
    });
  }
  camelCase() {
    return this.transformKeys(tiny_case.camelCase);
  }
  snakeCase() {
    return this.transformKeys(tiny_case.snakeCase);
  }
  constantCase() {
    return this.transformKeys(key => (0,tiny_case.snakeCase)(key).toUpperCase());
  }
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const base = super.describe(options);
    base.fields = {};
    for (const [key, value] of Object.entries(next.fields)) {
      var _innerOptions2;
      let innerOptions = options;
      if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      base.fields[key] = value.describe(innerOptions);
    }
    return base;
  }
}
create$3.prototype = ObjectSchema.prototype;

function create$2(type) {
  return new ArraySchema(type);
}
class ArraySchema extends Schema {
  constructor(type) {
    super({
      type: 'array',
      spec: {
        types: type
      },
      check(v) {
        return Array.isArray(v);
      }
    });

    // `undefined` specifically means uninitialized, as opposed to "no subtype"
    this.innerType = void 0;
    this.innerType = type;
  }
  _cast(_value, _opts) {
    const value = super._cast(_value, _opts);

    // should ignore nulls here
    if (!this._typeCheck(value) || !this.innerType) {
      return value;
    }
    let isChanged = false;
    const castArray = value.map((v, idx) => {
      const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
        path: `${_opts.path || ''}[${idx}]`
      }));
      if (castElement !== v) {
        isChanged = true;
      }
      return castElement;
    });
    return isChanged ? castArray : value;
  }
  _validate(_value, options = {}, panic, next) {
    var _options$recursive;
    // let sync = options.sync;
    // let path = options.path;
    let innerType = this.innerType;
    // let endEarly = options.abortEarly ?? this.spec.abortEarly;
    let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
    options.originalValue != null ? options.originalValue : _value;
    super._validate(_value, options, panic, (arrayErrors, value) => {
      var _options$originalValu2;
      if (!recursive || !innerType || !this._typeCheck(value)) {
        next(arrayErrors, value);
        return;
      }

      // #950 Ensure that sparse array empty slots are validated
      let tests = new Array(value.length);
      for (let index = 0; index < value.length; index++) {
        var _options$originalValu;
        tests[index] = innerType.asNestedTest({
          options,
          index,
          parent: value,
          parentPath: options.path,
          originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
        });
      }
      this.runTests({
        value,
        tests,
        originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
        options
      }, panic, innerTypeErrors => next(innerTypeErrors.concat(arrayErrors), value));
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    // @ts-expect-error readonly
    next.innerType = this.innerType;
    return next;
  }

  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }
  concat(schema) {
    let next = super.concat(schema);

    // @ts-expect-error readonly
    next.innerType = this.innerType;
    if (schema.innerType)
      // @ts-expect-error readonly
      next.innerType = next.innerType ?
      // @ts-expect-error Lazy doesn't have concat and will break
      next.innerType.concat(schema.innerType) : schema.innerType;
    return next;
  }
  of(schema) {
    // FIXME: this should return a new instance of array without the default to be
    let next = this.clone();
    if (!isSchema(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + printValue(schema));

    // @ts-expect-error readonly
    next.innerType = schema;
    next.spec = Object.assign({}, next.spec, {
      types: schema
    });
    return next;
  }
  length(length, message = array.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },
      skipAbsent: true,
      test(value) {
        return value.length === this.resolve(length);
      }
    });
  }
  min(min, message) {
    message = message || array.min;
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      // FIXME(ts): Array<typeof T>
      test(value) {
        return value.length >= this.resolve(min);
      }
    });
  }
  max(max, message) {
    message = message || array.max;
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value.length <= this.resolve(max);
      }
    });
  }
  ensure() {
    return this.default(() => []).transform((val, original) => {
      // We don't want to return `null` for nullable schema
      if (this._typeCheck(val)) return val;
      return original == null ? [] : [].concat(original);
    });
  }
  compact(rejector) {
    let reject = !rejector ? v => !!v : (v, i, a) => !rejector(v, i, a);
    return this.transform(values => values != null ? values.filter(reject) : values);
  }
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const base = super.describe(options);
    if (next.innerType) {
      var _innerOptions;
      let innerOptions = options;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[0]
        });
      }
      base.innerType = next.innerType.describe(innerOptions);
    }
    return base;
  }
}
create$2.prototype = ArraySchema.prototype;

// @ts-ignore
function create$1(schemas) {
  return new TupleSchema(schemas);
}
class TupleSchema extends Schema {
  constructor(schemas) {
    super({
      type: 'tuple',
      spec: {
        types: schemas
      },
      check(v) {
        const types = this.spec.types;
        return Array.isArray(v) && v.length === types.length;
      }
    });
    this.withMutation(() => {
      this.typeError(tuple.notType);
    });
  }
  _cast(inputValue, options) {
    const {
      types
    } = this.spec;
    const value = super._cast(inputValue, options);
    if (!this._typeCheck(value)) {
      return value;
    }
    let isChanged = false;
    const castArray = types.map((type, idx) => {
      const castElement = type.cast(value[idx], Object.assign({}, options, {
        path: `${options.path || ''}[${idx}]`
      }));
      if (castElement !== value[idx]) isChanged = true;
      return castElement;
    });
    return isChanged ? castArray : value;
  }
  _validate(_value, options = {}, panic, next) {
    let itemTypes = this.spec.types;
    super._validate(_value, options, panic, (tupleErrors, value) => {
      var _options$originalValu2;
      // intentionally not respecting recursive
      if (!this._typeCheck(value)) {
        next(tupleErrors, value);
        return;
      }
      let tests = [];
      for (let [index, itemSchema] of itemTypes.entries()) {
        var _options$originalValu;
        tests[index] = itemSchema.asNestedTest({
          options,
          index,
          parent: value,
          parentPath: options.path,
          originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
        });
      }
      this.runTests({
        value,
        tests,
        originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
        options
      }, panic, innerTypeErrors => next(innerTypeErrors.concat(tupleErrors), value));
    });
  }
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const base = super.describe(options);
    base.innerType = next.spec.types.map((schema, index) => {
      var _innerOptions;
      let innerOptions = options;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[index]
        });
      }
      return schema.describe(innerOptions);
    });
    return base;
  }
}
create$1.prototype = TupleSchema.prototype;

function create(builder) {
  return new Lazy(builder);
}
function catchValidationError(fn) {
  try {
    return fn();
  } catch (err) {
    if (ValidationError.isError(err)) return Promise.reject(err);
    throw err;
  }
}
class Lazy {
  constructor(builder) {
    this.type = 'lazy';
    this.__isYupSchema__ = true;
    this.spec = void 0;
    this._resolve = (value, options = {}) => {
      let schema = this.builder(value, options);
      if (!isSchema(schema)) throw new TypeError('lazy() functions must return a valid schema');
      if (this.spec.optional) schema = schema.optional();
      return schema.resolve(options);
    };
    this.builder = builder;
    this.spec = {
      meta: undefined,
      optional: false
    };
  }
  clone(spec) {
    const next = new Lazy(this.builder);
    next.spec = Object.assign({}, this.spec, spec);
    return next;
  }
  optionality(optional) {
    const next = this.clone({
      optional
    });
    return next;
  }
  optional() {
    return this.optionality(true);
  }
  resolve(options) {
    return this._resolve(options.value, options);
  }
  cast(value, options) {
    return this._resolve(value, options).cast(value, options);
  }
  asNestedTest(config) {
    let {
      key,
      index,
      parent,
      options
    } = config;
    let value = parent[index != null ? index : key];
    return this._resolve(value, Object.assign({}, options, {
      value,
      parent
    })).asNestedTest(config);
  }
  validate(value, options) {
    return catchValidationError(() => this._resolve(value, options).validate(value, options));
  }
  validateSync(value, options) {
    return this._resolve(value, options).validateSync(value, options);
  }
  validateAt(path, value, options) {
    return catchValidationError(() => this._resolve(value, options).validateAt(path, value, options));
  }
  validateSyncAt(path, value, options) {
    return this._resolve(value, options).validateSyncAt(path, value, options);
  }
  isValid(value, options) {
    try {
      return this._resolve(value, options).isValid(value, options);
    } catch (err) {
      if (ValidationError.isError(err)) {
        return Promise.resolve(false);
      }
      throw err;
    }
  }
  isValidSync(value, options) {
    return this._resolve(value, options).isValidSync(value, options);
  }
  describe(options) {
    return options ? this.resolve(options).describe(options) : {
      type: 'lazy',
      meta: this.spec.meta,
      label: undefined
    };
  }
  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  }
}

function setLocale(custom) {
  Object.keys(custom).forEach(type => {
    // @ts-ignore
    Object.keys(custom[type]).forEach(method => {
      // @ts-ignore
      locale[type][method] = custom[type][method];
    });
  });
}

function addMethod(schemaType, name, fn) {
  if (!schemaType || !isSchema(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}



;// CONCATENATED MODULE: ./node_modules/smart-db/dist/Commons/yupLocale.js

setLocale({
    mixed: {
        notType: '${label} is not a valid ${type}',
        // Add more custom messages for other validation types if needed
    },
});
// Add custom validation method to yup
addMethod(create$6, 'isValidID', function (message) {
    return this.test('is-valid-id', message, function (value) {
        const { path, createError } = this;
        // Check if the value is a valid 24-character hex string
        const isHexString = value !== undefined && /^[a-f0-9]{24}$/i.test(value);
        // Check if the value is a 12-byte Uint8Array
        const isUint8Array = value !== undefined && value instanceof Uint8Array && value.length === 12;
        // Check if the value is an integer
        const isInteger = value !== undefined && Number.isInteger(Number(value));
        if (isHexString || isUint8Array || isInteger) {
            return true;
        }
        // Return a custom error message
        return createError({ path, message: message || 'ID must be a 24-character hex string, a 12-byte Uint8Array, or an integer' });
    });
});
// Define a custom validation for bigint
addMethod(create$8, 'bigint', function (message) {
    return this.transform(function (value, originalValue) {
        if (typeof originalValue === 'string' || typeof originalValue === 'number') {
            return BigInt(Number(originalValue)); // Cast to bigint directly here
        }
        return value;
    }).test('bigint', message, function (value) {
        const { path, createError } = this;
        return typeof value === 'bigint' || createError({ path, message: message ?? 'Value must be a bigint' });
    });
});

//# sourceMappingURL=yupLocale.js.map

/***/ }),

/***/ 88691:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ AppGeneral; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useAppGeneral_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72001);
/* harmony import */ var _LoadingSpinner_LoadingSpinner_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9725);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_hooks_useAppGeneral_js__WEBPACK_IMPORTED_MODULE_1__]);
_hooks_useAppGeneral_js__WEBPACK_IMPORTED_MODULE_1__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
'use client';



function AppGeneral({ children, loader = ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", { children: ["Loading application, please wait... ", (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LoadingSpinner_LoadingSpinner_js__WEBPACK_IMPORTED_MODULE_2__/* .LoadingSpinner */ .T, {})] })), onLoadComplete, }) {
    //--------------------------------------
    const { appStore } = (0,_hooks_useAppGeneral_js__WEBPACK_IMPORTED_MODULE_1__/* .useAppGeneral */ .G)({ onLoadComplete });
    //--------------------------------------
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: appStore.swInitApiCompleted === true ? children : loader });
}
//# sourceMappingURL=AppGeneral.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 16740:
/***/ (function(__unused_webpack___webpack_module__, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: CopyButton, useCopyButton

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/smart-db/dist/Commons/Constants/constants.js
var constants = __webpack_require__(27001);
// EXTERNAL MODULE: ./node_modules/smart-db/dist/Commons/pushNotification.js
var pushNotification = __webpack_require__(31647);
;// CONCATENATED MODULE: ./node_modules/smart-db/dist/Components/CopyButton/useCopyButton.js


const useCopyButton_useCopyButton = () => {
    //--------------------------------------
    const handleBtnCopy = async (content) => {
        navigator.clipboard.writeText(content);
        pushSucessNotification(PROYECT_NAME, `Copied to clipboard!`, false);
    };
    //--------------------------------------
    return {
        handleBtnCopy,
    };
    //--------------------------------------
};
//# sourceMappingURL=useCopyButton.js.map
// EXTERNAL MODULE: ./node_modules/smart-db/dist/Commons/Constants/images.js
var Constants_images = __webpack_require__(86096);
// EXTERNAL MODULE: ./node_modules/smart-db/dist/Commons/utils.js + 10 modules
var utils = __webpack_require__(75672);
;// CONCATENATED MODULE: ./node_modules/smart-db/dist/Components/CopyButton/CopyButton.js

// import styles from './CopyButton.module.css';
// comment the import and set classname to avoid css module error



function CopyButton({ content }) {
    //--------------------------------------
    const { handleBtnCopy } = useCopyButton();
    //--------------------------------------
    return (_jsx(_Fragment, { children: isNullOrBlank(content) === false && (_jsx("img", { width: "12", height: "12", className: "CopyButton-icon" // Unique class name for this component
            , src: COPY.toString(), onClick: () => handleBtnCopy(content), alt: "Copy Icon" })) }));
}
//# sourceMappingURL=CopyButton.js.map
;// CONCATENATED MODULE: ./node_modules/smart-db/dist/Components/CopyButton/index.js


//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9725:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ LoadingSpinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
'use client';

function LoadingSpinner({ status, size, border, color, align } = {
    status: 'loading',
    size: 50,
    border: 10,
    color: undefined,
    align: undefined,
}) {
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: `${align ? 'spinner' + align.charAt(0).toUpperCase() + align.slice(1) : ''} 'spinnerContainer'`, children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: "loadingSpinner", style: { width: size, height: size, borderWidth: border } }) }) }));
}
//# sourceMappingURL=LoadingSpinner.js.map

/***/ }),

/***/ 818:
/***/ (function(__unused_webpack___webpack_module__, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: OpenInNewTabButton

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/smart-db/dist/Commons/Constants/images.js
var Constants_images = __webpack_require__(86096);
;// CONCATENATED MODULE: ./node_modules/smart-db/dist/Components/OpenInNewTabButton/OpenInNewTabButton.js


// import styles from './OpenInNewTabButton.module.css';
// comment the import and set classname to avoid css module error
function OpenInNewTabButton({ url }) {
    function handleBtnOpen(url) {
        window.open(url, '_blank');
    }
    return (_jsx("img", { onClick: () => handleBtnOpen(url), width: "19", height: "19", className: "OpenInNewTabButton-icon" // Unique class name for this component
        , src: ARROW_BUTTON.toString(), alt: "Open in new tab" }));
}
//# sourceMappingURL=OpenInNewTabButton.js.map
;// CONCATENATED MODULE: ./node_modules/smart-db/dist/Components/OpenInNewTabButton/index.js

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 61890:
/***/ (function(__webpack_module__, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37813);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_3__]);
_Commons_index_js__WEBPACK_IMPORTED_MODULE_3__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];


// import styles from './TokenLogoWithCircle.module.scss';


const TokenLogo = ({ token, showBorder = true, width = 22, height = 22, className, style }) => {
    //--------------------------------------
    // Adjust size if border is enabled
    const circleWidth = Math.round(width * 1.8);
    const circleHeight = Math.round(height * 1.8);
    //--------------------------------------
    const colorHex = token.colorHex !== undefined && isValidHexColor(token.colorHex) ? token.colorHex : '#000000';
    const percentage = token.percentage !== undefined ? token.percentage : 100n;
    const ticker = token.ticker ?? hexToStr(token.TN_Hex);
    const tokenName = isTokenADA(token.CS, token.TN_Hex) ? `` : ` [${hexToStr(token.TN_Hex)}]`;
    //--------------------------------------
    return (_jsx(Fragment, { children: _jsxs("div", { className: classNames('TokenLogo-logo', className), style: {
                width: `${width}px`,
                height: `${width}px`,
                ...style, // Allow custom styles
            }, title: `${ticker}${tokenName}`, children: [_jsx("div", { className: 'TokenLogo-tokenLogo', children: token.image && isValidUrl(token.image) ? (_jsx("img", { src: getUrlForImage(token.image), alt: ticker, title: `${ticker}${tokenName}`, className: 'TokenLogo-tokenImage', style: { width: '100%', height: '100%', objectFit: 'contain' } })) : (_jsx("div", { className: 'TokenLogo-tokenImageFallback', title: `${ticker}${tokenName}`, style: {
                            borderColor: colorHex,
                        }, children: _jsx("div", { className: 'TokenLogo-tokenImageFallbackText', style: {
                                color: colorHex,
                                fontSize: `${width * 0.5}px`, // Dynamically scales font size
                            }, children: getFallbackImageLetters(token) }) })) }), showBorder && (_jsx("div", { className: 'TokenLogo-border', title: `${ticker}${tokenName}`, style: {
                        width: `${circleWidth}px`,
                        height: `${circleHeight}px`,
                    }, children: _jsxs("svg", { className: 'TokenLogo-fill', style: { stroke: `${colorHex}` }, children: [_jsx("circle", { r: "16", cx: "50%", cy: "50%", pathLength: "100", style: {
                                    fill: 'none',
                                    stroke: '#636363', // Background circle color
                                    strokeWidth: '4',
                                } }), _jsx("circle", { r: "16", cx: "50%", cy: "50%", pathLength: 100, style: {
                                    strokeDasharray: `${percentage} 100`,
                                } })] }) }))] }) }));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (TokenLogo)));
//# sourceMappingURL=TokenLogoWithCircle.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 72017:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Es": function() { return /* reexport safe */ _AppGeneral_AppGeneral_js__WEBPACK_IMPORTED_MODULE_0__.E; }
/* harmony export */ });
/* harmony import */ var _AppGeneral_AppGeneral_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88691);
/* harmony import */ var _CopyButton_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16740);
/* harmony import */ var _LoadingSpinner_LoadingSpinner_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9725);
/* harmony import */ var _OpenInNewTabButton_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(818);
/* harmony import */ var _TokenLogoWithCircle_TokenLogoWithCircle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61890);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_AppGeneral_AppGeneral_js__WEBPACK_IMPORTED_MODULE_0__, _TokenLogoWithCircle_TokenLogoWithCircle_js__WEBPACK_IMPORTED_MODULE_4__]);
([_AppGeneral_AppGeneral_js__WEBPACK_IMPORTED_MODULE_0__, _TokenLogoWithCircle_TokenLogoWithCircle_js__WEBPACK_IMPORTED_MODULE_4__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);





//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 17658:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ AddressToFollowEntity; }
/* harmony export */ });
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28660);
/* harmony import */ var _Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2607);
/* harmony import */ var _Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19083);
/* harmony import */ var _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90194);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_3__]);
_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_3__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




let AddressToFollowEntity = class AddressToFollowEntity extends _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_3__/* .BaseEntity */ .e {
    static { this._apiRoute = 'addressestofollow'; }
    static { this._className = 'Address To Follow'; }
};
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], AddressToFollowEntity.prototype, "address", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], AddressToFollowEntity.prototype, "CS", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], AddressToFollowEntity.prototype, "TN_Str", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", Number)
], AddressToFollowEntity.prototype, "txCount", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], AddressToFollowEntity.prototype, "apiRouteToCall", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], AddressToFollowEntity.prototype, "datumType", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({ isCreatedAt: true }),
    __metadata("design:type", Date)
], AddressToFollowEntity.prototype, "createdAt", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({ isUpdatedAt: true }),
    __metadata("design:type", Date)
], AddressToFollowEntity.prototype, "updatedAt", void 0);
AddressToFollowEntity = __decorate([
    (0,_Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_1__/* .asEntity */ .y)()
], AddressToFollowEntity);

//# sourceMappingURL=AddressToFollow.Entity.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 95425:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ BaseConstructor; }
/* harmony export */ });
class BaseConstructor {
    constructor(properties) {
        if (properties) {
            Object.assign(this, { ...this, ...properties }); // Merge default fields and provided properties
        }
    }
}
//# sourceMappingURL=Base.Constructor.js.map

/***/ }),

/***/ 90194:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ BaseEntity; }
/* harmony export */ });
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28660);
/* harmony import */ var _Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19083);
/* harmony import */ var _Commons_conversions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69623);
/* harmony import */ var _Base_Constructor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95425);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37813);
/* provided dependency */ var process = __webpack_require__(83454);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_conversions_js__WEBPACK_IMPORTED_MODULE_2__, _Commons_index_js__WEBPACK_IMPORTED_MODULE_3__]);
([_Commons_conversions_js__WEBPACK_IMPORTED_MODULE_2__, _Commons_index_js__WEBPACK_IMPORTED_MODULE_3__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





// export interface IBackendMethods {
//     checkIfExists_<T extends BaseEntity>(paramsFilter: Record<string, any> | string): Promise<boolean>;
//     checkIfExists<T extends BaseEntity>(Entity: typeof BaseEntity, paramsFilter: Record<string, any> | string): Promise<boolean>;
//     create<T extends BaseEntity>(instance: T, optionsCreate?: OptionsCreateOrUpdate): Promise<T>;
//     refresh<T extends BaseEntity>(instance: T, optionsGet?: OptionsGet): Promise<void>;
//     update<T extends BaseEntity>(instance: T, optionsUpdate?: OptionsCreateOrUpdate): Promise<void>;
//     updateMeWithParams<T extends BaseEntity>(instance: T, updateFields?: Record<string, any>, optionsUpdate?: OptionsCreateOrUpdate): Promise<void>;
//     updateWithParams_<T extends BaseEntity>(id: string, updateFields?: Record<string, any>, optionsUpdate?: OptionsCreateOrUpdate): Promise<T>;
//     updateWithParams<T extends BaseEntity>(Entity: typeof BaseEntity, id: string, updateFields?: Record<string, any>, optionsUpdate?: OptionsCreateOrUpdate): Promise<T>;
//     getById_<T extends BaseEntity>(id: string, optionsGet?: OptionsGetOne, restricFilter?: Record<string, any>): Promise<T | undefined>;
//     getById<T extends BaseEntity>(Entity: typeof BaseEntity, id: string, optionsGet?: OptionsGetOne, restricFilter?: Record<string, any>): Promise<T | undefined>;
//     getOneByParams_<T extends BaseEntity>(paramsFilter?: Record<string, any>, optionsGet?: OptionsGetOne, restricFilter?: Record<string, any>): Promise<T | undefined>;
//     getOneByParams<T extends BaseEntity>(
//         Entity: typeof BaseEntity,
//         paramsFilter?: Record<string, any>,
//         optionsGet?: OptionsGetOne,
//         restricFilter?: Record<string, any>
//     ): Promise<T | undefined>;
//     getByParams_<T extends BaseEntity>(paramsFilter?: Record<string, any>, optionsGet?: OptionsGet, restricFilter?: Record<string, any>): Promise<T[]>;
//     getByParams<T extends BaseEntity>(Entity: typeof BaseEntity, paramsFilter?: Record<string, any>, optionsGet?: OptionsGet, restricFilter?: Record<string, any>): Promise<T[]>;
//     getAll_<T extends BaseEntity>(optionsGet?: OptionsGet, restricFilter?: Record<string, any>): Promise<T[]>;
//     getAll<T extends BaseEntity>(Entity: typeof BaseEntity, optionsGet?: OptionsGet, restricFilter?: Record<string, any>): Promise<T[]>;
//     deleteById_<T extends BaseEntity>(id: string, optionsDelete?: OptionsDelete): Promise<boolean>;
//     deleteById<T extends BaseEntity>(Entity: typeof BaseEntity, id: string, optionsDelete?: OptionsDelete): Promise<boolean>;
//     delete<T extends BaseEntity>(instance: T, optionsDelete?: OptionsDelete): Promise<boolean>;
//     fillWithRelation<T extends BaseEntity, R extends BaseEntity>(instance: T, relation: string, optionsGet?: OptionsGet, restricFilter?: Record<string, any>): Promise<void>;
//     loadRelationMany<T extends BaseEntity, R extends BaseEntity>(instance: T, relation: string, optionsGet?: OptionsGet, restricFilter?: Record<string, any>): Promise<R[]>;
//     loadRelationOne<T extends BaseEntity, R extends BaseEntity>(
//         instance: T,
//         relation: string,
//         optionsGet?: OptionsGet,
//         restricFilter?: Record<string, any>
//     ): Promise<R | undefined>;
// }
class BaseEntity extends _Base_Constructor_js__WEBPACK_IMPORTED_MODULE_4__/* .BaseConstructor */ .J {
    static { this._className = 'Base'; }
    static { this._apiRoute = 'Must implement Class'; }
    // #endregion fields
    // #region internal class methods
    static getEntityDB() {
        if (process.env.USE_DATABASE === 'mongo') {
            return this.getMongo();
        }
        else if (process.env.USE_DATABASE === 'postgresql') {
            return this.getPostgreSQL();
        }
        else {
            throw `Database not defined`;
        }
    }
    getEntityDB() {
        return this.getStatic().getEntityDB();
    }
    static getMongo() {
        const result = _Commons_index_js__WEBPACK_IMPORTED_MODULE_3__/* .RegistryManager.getFromMongoSchemasRegistry */ .Sb4.getFromMongoSchemasRegistry(this);
        if (!result) {
            throw `Mongo Methods Applied for ${this} not found in registry.`;
        }
        else {
            // console.error (`----- get Mongo for ${this.className()} found`)
            // console.error (`${result} ----`)
        }
        return result;
    }
    getMongo() {
        return this.getStatic().getMongo();
    }
    static getPostgreSQL() {
        const result = _Commons_index_js__WEBPACK_IMPORTED_MODULE_3__/* .RegistryManager.getFromPostgreSQLModelsRegistry */ .Sb4.getFromPostgreSQLModelsRegistry(this);
        if (!result) {
            throw `PostgreSQL Methods Applied for ${this} not found in registry.`;
        }
        else {
            // console.error (`----- get PostgreSQL for ${this.className()} found`)
            // console.error (`${result} ----`)
        }
        return result;
    }
    getPostgreSQL() {
        return this.getStatic().getPostgreSQL();
    }
    // #endregion internal class methods
    // #region db
    static { this.defaultFieldsWhenUndefined = {}; }
    static { this.alwaysFieldsForSelect = {
        _id: true,
    }; }
    static { this.alwaysFieldsForCallbackOnAfterLoad = {}; }
    static { this.defaultSortForSelect = {}; }
    // #endregion db
    // #region internal class methods
    getStatic() {
        return this.constructor;
    }
    static getStatic() {
        return this;
    }
    className() {
        return this.getStatic()._className;
    }
    static className() {
        return this._className;
    }
    apiRoute() {
        return this.getStatic()._apiRoute;
    }
    static apiRoute() {
        return this._apiRoute;
    }
    constructor(properties) {
        super(properties);
        this._DB_id = properties?._DB_id ?? undefined;
    }
    // #endregion internal class methods
    // #region class methods
    show() {
        const object = {};
        if (this.hasOwnProperty('_DB_id') && this['_DB_id'] !== undefined) {
            object._DB_id = this['_DB_id'];
        }
        if (this.hasOwnProperty('name') && this['name'] !== undefined) {
            object.name = this['name'];
        }
        if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isEmptyObject */ .Qr$)(object)) {
            return (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_3__/* .toJson */ .QsJ)(Object.entries(this));
        }
        return (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_3__/* .toJson */ .QsJ)(object);
    }
    static getFields(useInterfaceNames = true) {
        const conversionFunctions = (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_1__/* .getCombinedConversionFunctions */ .xS)(this);
        const fields = [];
        if (conversionFunctions) {
            for (const [propertyKey, conversions] of conversionFunctions.entries()) {
                if (useInterfaceNames) {
                    fields.push(conversions.interfaceName ?? propertyKey);
                }
                else {
                    fields.push(propertyKey);
                }
            }
        }
        return fields;
    }
    static filterByID(id, list) {
        const instance = list.filter((i) => i._DB_id == id);
        if (instance.length > 0) {
            return instance[0];
        }
        else {
            return undefined;
        }
    }
    fillMeFromObject(object) {
        // console.log(`[${this.className()}] - fillMeFromObject - object: ${showData(object)}`);
        Object.assign(this, object);
        return;
    }
    // #endregion class methods
    // #region conversions methods
    toJsonString() {
        return (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_3__/* .toJson */ .QsJ)(this);
    }
    static fromJsonString(json) {
        const data = JSON.parse(json);
        return this.fromPlainObject(data);
    }
    toPlainObject() {
        const conversionFunctions = (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_1__/* .getCombinedConversionFunctions */ .xS)(this.getStatic());
        const plainObject = {};
        if (conversionFunctions) {
            const processValue = (propertyKey, conversions, value) => {
                try {
                    let type = conversions.type;
                    if (value?.toPlainObject) {
                        value = value.toPlainObject();
                    }
                    else if (conversions.toPlainObject) {
                        value = conversions.toPlainObject.call(this, value);
                    }
                    else if (type.toPlainObject) {
                        value = type.toPlainObject(value);
                        // } else if (conversions.type === BigInt) {
                        //     value = serializeBigInt(value)
                    }
                    else if (value?.toJsonString) {
                        value = JSON.parse(value.toJsonString());
                    }
                    else if (value !== undefined && conversions.type !== Number && conversions.type !== String && conversions.type !== Boolean) {
                        value = JSON.parse((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_3__/* .toJson */ .QsJ)(value));
                    }
                    return value;
                }
                catch (error) {
                    throw `${this.className()} - ${propertyKey}: ${error}`;
                }
            };
            for (const [propertyKey, conversions] of conversionFunctions.entries()) {
                if (conversions.relation !== undefined) {
                    let value = undefined;
                    let swProcessValue = false;
                    if (this.hasOwnProperty(propertyKey) || conversions.toPlainObject || this[conversions.propertyToFill]) {
                        value = this[propertyKey];
                        swProcessValue = true;
                    }
                    if (swProcessValue) {
                        // es un tipo de campo con id y objeto en relacion
                        // quiero quedarme con el id y convertir a objeto el value
                        // si es array, OneToMany, quiero convertir todos los elementos en objetos
                        if (conversions.isArray === true) {
                            let array_ids = [];
                            const value_ids = value;
                            if (value_ids) {
                                if (Array.isArray(value_ids) === false) {
                                    throw `${this.className()} - ${propertyKey}: OneToMany value must be an Array`;
                                }
                                for (let i = 0; i < value_ids.length; i++) {
                                    const item = value_ids[i];
                                    array_ids.push(item);
                                }
                            }
                            plainObject[propertyKey] = array_ids;
                            if (conversions.propertyToFill && this.hasOwnProperty(conversions.propertyToFill)) {
                                const relatedClassType = conversions.typeRelation;
                                let array_objects = [];
                                const value_objects = this[conversions.propertyToFill];
                                if (value_objects) {
                                    if (Array.isArray(value_objects) === false) {
                                        throw `${this.className()} - ${propertyKey}: OneToMany value must be an Array`;
                                    }
                                    for (let i = 0; i < value_objects.length; i++) {
                                        const item = processValue(propertyKey, { ...conversions, type: relatedClassType }, value_objects[i]);
                                        array_objects.push(item);
                                    }
                                }
                                plainObject[conversions.propertyToFill] = array_objects;
                            }
                        }
                        else {
                            const value_id = value;
                            plainObject[propertyKey] = value_id;
                            if (conversions.propertyToFill && this.hasOwnProperty(conversions.propertyToFill)) {
                                const relatedClassType = conversions.typeRelation;
                                const value_object = processValue(propertyKey, { ...conversions, type: relatedClassType }, this[conversions.propertyToFill]);
                                plainObject[conversions.propertyToFill] = value_object;
                            }
                        }
                    }
                }
                else {
                    let value = undefined;
                    let swProcessValue = false;
                    if (this.hasOwnProperty(propertyKey) || conversions.toPlainObject) {
                        value = this[propertyKey];
                        swProcessValue = true;
                    }
                    if (swProcessValue) {
                        // es un campo normal
                        if (conversions.isArray === true) {
                            let array = [];
                            if (value) {
                                if (Array.isArray(value) === false) {
                                    throw `${this.className()} - ${propertyKey}: value must be an array`;
                                }
                                for (let i = 0; i < value.length; i++) {
                                    const item = processValue(propertyKey, conversions, value[i]);
                                    array.push(item);
                                }
                            }
                            value = array;
                        }
                        else {
                            value = processValue(propertyKey, conversions, value);
                        }
                        plainObject[propertyKey] = value;
                    }
                }
            }
        }
        return plainObject;
    }
    static fromPlainObject(plainObject) {
        const instance = new this();
        if (plainObject) {
            const conversionFunctions = (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_1__/* .getCombinedConversionFunctions */ .xS)(this);
            if (conversionFunctions) {
                const processValue = (propertyKey, conversions, value) => {
                    try {
                        let type = conversions.type;
                        if (conversions.fromPlainObject) {
                            value = conversions.fromPlainObject.call(this, value);
                        }
                        else if (type.fromPlainObject) {
                            if (type.MongoModel === undefined || value !== undefined) {
                                value = type.fromPlainObject(value);
                            }
                        }
                        else if (conversions.type === BigInt) {
                            value = (0,_Commons_conversions_js__WEBPACK_IMPORTED_MODULE_2__/* .deserealizeBigInt */ .PP)(value);
                        }
                        else if (value !== undefined &&
                            conversions.type !== Number &&
                            conversions.type !== String &&
                            conversions.type !== Boolean &&
                            conversions.type !== Object) {
                            value = new type(value);
                        }
                        return value;
                    }
                    catch (error) {
                        throw `${this.className()} - ${propertyKey}: ${error}`;
                    }
                };
                for (const [propertyKey, conversions] of conversionFunctions.entries()) {
                    if (conversions.relation !== undefined) {
                        let value = undefined;
                        let swProcessValue = false;
                        if (plainObject.hasOwnProperty(propertyKey) || conversions.fromPlainObject || this[conversions.propertyToFill]) {
                            value = plainObject[propertyKey];
                            swProcessValue = true;
                        }
                        if (swProcessValue) {
                            // es un tipo de campo con id y objeto en relacion
                            // quiero quedarme con el id y convertir el value
                            // si es array, OneToMany, quiero convertir todos los elementos
                            if (conversions.isArray === true) {
                                let array_ids = [];
                                let value_ids = value;
                                if (value_ids) {
                                    if (Array.isArray(value_ids) === false) {
                                        throw `${this.className()} - ${propertyKey}: OneToMany value must be an Array`;
                                    }
                                    for (let i = 0; i < value_ids.length; i++) {
                                        const item = value_ids[i];
                                        array_ids.push(item);
                                    }
                                }
                                instance[propertyKey] = array_ids;
                                if (conversions.propertyToFill && plainObject.hasOwnProperty(conversions.propertyToFill)) {
                                    let array_objects = [];
                                    const relatedClassType = conversions.typeRelation;
                                    const value_objects = plainObject[conversions.propertyToFill];
                                    if (value_objects) {
                                        if (Array.isArray(value_objects) === false) {
                                            throw `${this.className()} - ${propertyKey}: OneToMany ${conversions.propertyToFill.toString()} value must be an Array`;
                                        }
                                        for (let i = 0; i < value_objects.length; i++) {
                                            const item = processValue(propertyKey, { ...conversions, type: relatedClassType }, value_objects[i]);
                                            array_objects.push(item);
                                        }
                                    }
                                    instance[conversions.propertyToFill] = array_objects;
                                }
                            }
                            else {
                                let value_id = value;
                                instance[propertyKey] = value_id;
                                if (conversions.propertyToFill && plainObject.hasOwnProperty(conversions.propertyToFill)) {
                                    const relatedClassType = conversions.typeRelation;
                                    const value_object = processValue(propertyKey, { ...conversions, type: relatedClassType }, plainObject[conversions.propertyToFill]);
                                    instance[conversions.propertyToFill] = value_object;
                                }
                            }
                        }
                    }
                    else {
                        let value = undefined;
                        let swProcessValue = false;
                        if (plainObject.hasOwnProperty(propertyKey) || conversions.fromPlainObject) {
                            value = plainObject[propertyKey];
                            swProcessValue = true;
                        }
                        if (swProcessValue) {
                            if (conversions.isArray === true) {
                                let array = [];
                                if (value) {
                                    if (Array.isArray(value) === false) {
                                        throw `${this.className()} - ${propertyKey}: value must be an array`;
                                    }
                                    for (let i = 0; i < value.length; i++) {
                                        const item = processValue(propertyKey, conversions, value[i]);
                                        array.push(item);
                                    }
                                }
                                value = array;
                            }
                            else {
                                value = processValue(propertyKey, conversions, value);
                            }
                            instance[propertyKey] = value;
                        }
                    }
                }
            }
        }
        return instance;
    }
}
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_1__/* .Convertible */ .e0)({ interfaceName: '_id', isDB_id: true }),
    __metadata("design:type", String)
], BaseEntity.prototype, "_DB_id", void 0);
//# sourceMappingURL=Base.Entity.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 72083:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BaseSmartDBEntity; }
/* harmony export */ });
/* harmony import */ var _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76100);
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28660);
/* harmony import */ var _Commons_conversions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69623);
/* harmony import */ var _Commons_data_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66146);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37813);
/* harmony import */ var _SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94093);
/* harmony import */ var _Base_Entity_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90194);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__, _Commons_conversions_js__WEBPACK_IMPORTED_MODULE_2__, _Commons_data_js__WEBPACK_IMPORTED_MODULE_3__, _Commons_index_js__WEBPACK_IMPORTED_MODULE_4__, _SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_5__, _Base_Entity_js__WEBPACK_IMPORTED_MODULE_6__]);
([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__, _Commons_conversions_js__WEBPACK_IMPORTED_MODULE_2__, _Commons_data_js__WEBPACK_IMPORTED_MODULE_3__, _Commons_index_js__WEBPACK_IMPORTED_MODULE_4__, _SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_5__, _Base_Entity_js__WEBPACK_IMPORTED_MODULE_6__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







// export abstract class SmartDBBaseEntity {
//     @OneToOne(() => SmartUTxOPostgres)
//     @JoinColumn({ name: 'smartUTxO_id' })
//     smartUTxO!: Relation<SmartUTxOPostgres>;
// }
// export interface IBaseSmartDBEntity {
//     _creator: PaymentKeyHash;
//     _NET_address: string;
//     _NET_id_CS: string | undefined;
//     _NET_id_TN_Str: string | undefined;
//     _isDeployed: boolean;
//     smartUTxO_id: Types.ObjectId | undefined;
// }
class BaseSmartDBEntity extends _Base_Entity_js__WEBPACK_IMPORTED_MODULE_6__/* .BaseEntity */ .e {
    static { this._plutusDataIndex = 0; }
    static { this._plutusDataIsSubType = true; }
    // si es only datum sera creado cuando se encuentre una utxo y sera eliminando cuando no exista utxo
    static { this._isOnlyDatum = true; }
    // si tiene id NFT en el datum o si es un FT
    static { this._is_NET_id_Unique = true; }
    static { this._className = 'BaseSmartDBEntity'; }
    // @Convertible({ propertyToFill: 'addressToFollow', relation: 'OneToOne', typeRelation: AddressToFollowEntity })
    // addressToFollow_id!: string;
    // addressToFollow!: AddressToFollowEntity | undefined;
    // #endregion fields
    // #region db
    static { this.alwaysFieldsForSelect = {
        ...super.alwaysFieldsForSelect,
        _creator: true,
        _NET_address: true,
        _NET_id_CS: true,
        _NET_id_TN_Str: true,
        _isDeployed: true,
        smartUTxO_id: true,
    }; }
    static datumFieldsForSelect() {
        const fields = {};
        const conversionFunctions = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .getCombinedConversionFunctions */ .xSF)(this);
        if (conversionFunctions) {
            for (const [propertyKey, conversions] of conversionFunctions.entries()) {
                if (conversions.isForDatum === true) {
                    fields[propertyKey] = true;
                }
            }
        }
        return fields;
    }
    // #endregion db
    // #region class methods
    constructor(properties) {
        super(properties); // Call parent constructor
        this._isDeployed = true;
        this._isDeployed = properties?._isDeployed ?? this._isDeployed; // Use provided value or default
    }
    getStatic() {
        return this.constructor;
    }
    static getStatic() {
        return this;
    }
    plutusDataIndex() {
        return this.getStatic()._plutusDataIndex;
    }
    static plutusDataIndex() {
        return this._plutusDataIndex;
    }
    plutusDataIsSubType() {
        return this.getStatic()._plutusDataIsSubType;
    }
    static plutusDataIsSubType() {
        return this._plutusDataIsSubType;
    }
    isOnlyDatum() {
        return this.getStatic()._isOnlyDatum;
    }
    static isOnlyDatum() {
        return this._isOnlyDatum;
    }
    is_NET_id_Unique() {
        return this.getStatic()._is_NET_id_Unique;
    }
    static is_NET_id_Unique() {
        return this._is_NET_id_Unique;
    }
    getNet_Address() {
        return this._NET_address;
    }
    getNET_id_CS() {
        return this._NET_id_CS;
    }
    getNET_id_TN_Str() {
        return this._NET_id_TN_Str;
    }
    getNet_id_AC_Lucid() {
        return this.getNET_id_CS() + (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .strToHex */ .pzN)(this.getNET_id_TN_Str());
    }
    static countDatumFields() {
        const conversionFunctions = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .getCombinedConversionFunctions */ .xSF)(this);
        let count = 0;
        if (conversionFunctions) {
            for (const [propertyKey, conversions] of conversionFunctions.entries()) {
                if (conversions.isForDatum === true) {
                    count = count + 1;
                }
            }
        }
        return count;
    }
    isCreator(pkh) {
        if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .isNullOrBlank */ .Xy7)(pkh)) {
            throw `pkh not defined`;
        }
        return this._creator === pkh;
    }
    // #endregion class methods
    // #region datum methods
    static mkDatumFromPlainObject(plainObject) {
        // usado para que los campos del datum tengan las clases y tipos bien
        let datum = {};
        if (plainObject) {
            const conversionFunctions = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .getCombinedConversionFunctions */ .xSF)(this);
            if (conversionFunctions) {
                const processValue = (propertyKey, conversions, value) => {
                    try {
                        let type = conversions.type;
                        if (conversions.fromPlainObject) {
                            value = conversions.fromPlainObject.call(this, value);
                        }
                        else if (type.fromPlainObject) {
                            if (type.MongoModel === undefined || value !== undefined) {
                                value = type.fromPlainObject(value);
                            }
                        }
                        else if (conversions.type === BigInt) {
                            value = (0,_Commons_conversions_js__WEBPACK_IMPORTED_MODULE_2__/* .deserealizeBigInt */ .PP)(value);
                        }
                        else if (value !== undefined &&
                            conversions.type !== Number &&
                            conversions.type !== String &&
                            conversions.type !== Boolean &&
                            conversions.type !== Object) {
                            value = new type(value);
                        }
                        return value;
                    }
                    catch (error) {
                        throw `${this.className()} - ${propertyKey}: ${error}`;
                    }
                };
                for (const [propertyKey, conversions] of conversionFunctions.entries()) {
                    if (conversions.isForDatum) {
                        if (plainObject.hasOwnProperty(propertyKey) === false) {
                            throw `${this.className()} - ${propertyKey}: missing in datum`;
                        }
                        let value = plainObject[propertyKey];
                        if (conversions.isArray === true) {
                            let array = [];
                            if (value) {
                                if (Array.isArray(value) === false) {
                                    throw `${this.className()} - ${propertyKey}: value must be an array`;
                                }
                                for (let i = 0; i < value.length; i++) {
                                    const item = processValue(propertyKey, conversions, value[i]);
                                    array.push(item);
                                }
                            }
                            value = array;
                        }
                        else {
                            value = processValue(propertyKey, conversions, value);
                        }
                        datum[propertyKey] = value;
                        // (this as any)[propertyKey] = value;
                    }
                }
            }
        }
        return datum;
    }
    static mkDatumFromDatumCborHex(cborHex) {
        // crea un objeto con los tipos y clases correctos desde un cbor hex
        const datum = {};
        const conversionFunctions = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .getCombinedConversionFunctions */ .xSF)(this);
        if (conversionFunctions) {
            const lucidDataForDatum = _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Data.from */ .Vw.from(cborHex);
            if (lucidDataForDatum.index === this.plutusDataIndex()) {
                let lucidDataForFields = [];
                if (this.plutusDataIsSubType() === false) {
                    lucidDataForFields = lucidDataForDatum.fields;
                }
                else {
                    const lucidDataForConstr0 = lucidDataForDatum.fields;
                    //constr para lista de campos
                    if (lucidDataForConstr0[0].index === 0) {
                        lucidDataForFields = lucidDataForConstr0[0].fields;
                    }
                    else {
                        throw `${this.className()} - Can't get Datum - error: expected index 0 at firts level`;
                    }
                }
                const countDatumFields = this.countDatumFields();
                if (lucidDataForFields.length === countDatumFields) {
                    const processValue = (propertyKey, conversions, itemData) => {
                        try {
                            let type = conversions.type;
                            let value;
                            if (conversions.fromPlutusData) {
                                value = conversions.fromPlutusData.call(this, itemData);
                            }
                            else if (type.fromPlutusData) {
                                value = type.fromPlutusData(itemData);
                            }
                            else if (conversions.type !== Number && conversions.type !== BigInt && conversions.type !== String && conversions.type !== Boolean) {
                                //const obj = objFromLucidData(itemData)
                                value = new type(itemData);
                            }
                            else if (conversions.type === Number) {
                                value = Number(itemData);
                            }
                            else if (conversions.type === Boolean) {
                                if (itemData instanceof _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Constr */ .fL && itemData.fields.length === 0) {
                                    value = itemData.index === 1 ? true : false;
                                }
                                else if (typeof itemData === 'boolean') {
                                    value = itemData;
                                }
                                else {
                                    throw `${this.className()} - ${propertyKey}: expected Constr for boolean deserialization`;
                                }
                            }
                            else {
                                value = itemData;
                            }
                            return value;
                        }
                        catch (error) {
                            throw `${this.className()} - ${propertyKey}: ${error}`;
                        }
                    };
                    let indexLucidData = 0;
                    for (const [propertyKey, conversions] of conversionFunctions.entries()) {
                        if (conversions.isForDatum) {
                            let itemData = lucidDataForFields[indexLucidData];
                            if (conversions.isArray === true) {
                                let array = [];
                                if (itemData) {
                                    if (Array.isArray(itemData) === false) {
                                        throw `${this.className()} - ${propertyKey}: value must be an array`;
                                    }
                                    for (let i = 0; i < itemData.length; i++) {
                                        const item = processValue(propertyKey, conversions, itemData[i]);
                                        array.push(item);
                                    }
                                }
                                itemData = array;
                            }
                            else {
                                itemData = processValue(propertyKey, conversions, itemData);
                            }
                            datum[propertyKey] = itemData;
                            indexLucidData = indexLucidData + 1;
                        }
                    }
                }
                else {
                    throw `${this.className()} - Can't get Datum - error: expected ${countDatumFields} fields, found ${lucidDataForFields.length}`;
                }
            }
            else {
                throw `${this.className()} - Can't get Datum - error: plutusDataIndex dont match`;
            }
        }
        return datum;
    }
    static datumToLucidData(datum) {
        // convierte los campos del datum en lucidData
        let list = [];
        const conversionFunctions = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .getCombinedConversionFunctions */ .xSF)(this);
        if (conversionFunctions) {
            const processValue = (propertyKey, conversions, value) => {
                try {
                    let type = conversions.type;
                    if (conversions.toPlutusData) {
                        value = conversions.toPlutusData.call(this, value);
                    }
                    else if (type.toPlutusData) {
                        value = type.toPlutusData(value);
                    }
                    else {
                        value = (0,_Commons_data_js__WEBPACK_IMPORTED_MODULE_3__/* .itemToLucidData */ .gU)(value, propertyKey);
                    }
                    return value;
                }
                catch (error) {
                    throw `${this.className()} - ${propertyKey}: ${error}`;
                }
            };
            for (const [propertyKey, conversions] of conversionFunctions.entries()) {
                if (conversions.isForDatum) {
                    if (datum.hasOwnProperty(propertyKey) === false) {
                        throw `${this.className()} - ${propertyKey}: missing in datum`;
                    }
                    let value = datum[propertyKey];
                    const itemData = processValue(propertyKey, conversions, value);
                    list.push(itemData);
                }
            }
        }
        if (this.plutusDataIsSubType()) {
            const constrSubtypo = new _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Constr */ .fL(0, list);
            const constrTypo = new _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Constr */ .fL(this.plutusDataIndex(), [constrSubtypo]);
            return constrTypo;
        }
        else {
            const constrTypo = new _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Constr */ .fL(this.plutusDataIndex(), list);
            return constrTypo;
        }
    }
    static datumToCborHex(datum) {
        // convierte los campos del datum a cbor hex
        try {
            const data = this.datumToLucidData(datum);
            const dataHex = _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Data.to */ .Vw.to(data);
            const plutusData = _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .CML.PlutusData.from_cbor_hex */ .NR.$zK.from_cbor_hex(dataHex);
            // console.log (`[BaseSmartDBEntity] - datumToCborHex - plutusData2: ${plutusData2.to_canonical_cbor_hex()}`);
            // const plutusData = CML.PlutusData.from_cbor_bytes(fromHex(dataHex));
            // const cborHex = showPtrInHex(plutusData);
            const cborHex = plutusData.to_canonical_cbor_hex();
            return cborHex;
        }
        catch (error) {
            console.log(`[${this.className()}] - toDatumCborHex - Error: ${error}`);
            throw error;
        }
    }
    getMyDatum() {
        // cobtiene objeto con todos los campos del datum
        let datum = {};
        const conversionFunctions = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .getCombinedConversionFunctions */ .xSF)(this.getStatic());
        if (conversionFunctions) {
            for (const [propertyKey, conversions] of conversionFunctions.entries()) {
                if (conversions.isForDatum) {
                    if (this.hasOwnProperty(propertyKey) === false) {
                        throw `${this.className()} - ${propertyKey}: missing in datum fields`;
                    }
                    datum[propertyKey] = this[propertyKey];
                }
            }
        }
        return datum;
    }
    getMyDatumLucidData() {
        // convierte los campos del datum en lucidData
        let datum = this.getMyDatum();
        return this.getStatic().datumToLucidData(datum);
    }
    getMyDatumCborHex() {
        // convierte los campos del datum a cbor hex
        let datum = this.getMyDatum();
        return this.getStatic().datumToCborHex(datum);
    }
    deleteMyDatum() {
        // elimina los campos del datum
        const conversionFunctions = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .getCombinedConversionFunctions */ .xSF)(this.getStatic());
        if (conversionFunctions) {
            for (const [propertyKey, conversions] of conversionFunctions.entries()) {
                if (conversions.isForDatum) {
                    if (this.hasOwnProperty(propertyKey)) {
                        this[propertyKey] = undefined;
                    }
                }
            }
        }
        return;
    }
}
__decorate([
    (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Convertible */ .e0x)(),
    __metadata("design:type", String)
], BaseSmartDBEntity.prototype, "_creator", void 0);
__decorate([
    (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Convertible */ .e0x)({
        toMongoInterface: function (value) {
            if (this.getNet_Address) {
                return this.getNet_Address();
            }
            else {
                return value;
            }
        },
        toPostgreSQLInterface: function (value) {
            if (this.getNet_Address) {
                return this.getNet_Address();
            }
            return value;
        },
        toPlainObject: function (value) {
            if (this.getNet_Address) {
                return this.getNet_Address();
            }
            else {
                return value;
            }
        },
    }),
    __metadata("design:type", String)
], BaseSmartDBEntity.prototype, "_NET_address", void 0);
__decorate([
    (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Convertible */ .e0x)({
        toMongoInterface: function (value) {
            if (this.getNET_id_CS) {
                return this.getNET_id_CS();
            }
            else {
                return value;
            }
        },
        toPostgreSQLInterface: function (value) {
            if (this.getNET_id_CS) {
                return this.getNET_id_CS();
            }
            return value;
        },
        toPlainObject: function (value) {
            if (this.getNET_id_CS) {
                return this.getNET_id_CS();
            }
            else {
                return value;
            }
        },
    }),
    __metadata("design:type", String)
], BaseSmartDBEntity.prototype, "_NET_id_CS", void 0);
__decorate([
    (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Convertible */ .e0x)({
        toMongoInterface: function (value) {
            if (this.getNET_id_TN_Str) {
                return this.getNET_id_TN_Str();
            }
            else {
                return value;
            }
        },
        toPostgreSQLInterface: function (value) {
            if (this.getNET_id_TN_Str) {
                return this.getNET_id_TN_Str();
            }
            return value;
        },
        toPlainObject: function (value) {
            if (this.getNET_id_TN_Str) {
                return this.getNET_id_TN_Str();
            }
            else {
                return value;
            }
        },
    }),
    __metadata("design:type", String)
], BaseSmartDBEntity.prototype, "_NET_id_TN_Str", void 0);
__decorate([
    (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Convertible */ .e0x)(),
    __metadata("design:type", Boolean)
], BaseSmartDBEntity.prototype, "_isDeployed", void 0);
__decorate([
    (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_4__/* .Convertible */ .e0x)({ type: String, propertyToFill: 'smartUTxO', relation: 'OneToOne', typeRelation: _SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_5__/* .SmartUTxOEntity */ .U, cascadeSave: true, cascadeLoad: false }),
    __metadata("design:type", Object)
], BaseSmartDBEntity.prototype, "smartUTxO_id", void 0);
//# sourceMappingURL=Base.SmartDB.Entity.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 87654:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EmulatorEntity; }
/* harmony export */ });
/* harmony import */ var _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76100);
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28660);
/* harmony import */ var _Commons_conversions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69623);
/* harmony import */ var _Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2607);
/* harmony import */ var _Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19083);
/* harmony import */ var _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90194);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__, _Commons_conversions_js__WEBPACK_IMPORTED_MODULE_2__, _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_5__]);
([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__, _Commons_conversions_js__WEBPACK_IMPORTED_MODULE_2__, _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_5__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






let EmulatorEntity = class EmulatorEntity extends _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_5__/* .BaseEntity */ .e {
    static { this._className = 'Emulator'; }
    static { this._apiRoute = 'emulators'; }
    // #endregion fields
    // #region class methods
    static async getTxCountInEmulator(lucid, emulatorDB, address) {
        const count = emulatorDB.emulator.slot;
        return count;
    }
};
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_4__/* .Convertible */ .e0)({ isUnique: true }),
    __metadata("design:type", String)
], EmulatorEntity.prototype, "name", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_4__/* .Convertible */ .e0)(),
    __metadata("design:type", Boolean)
], EmulatorEntity.prototype, "current", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_4__/* .Convertible */ .e0)({
        fromPlainObject: _Commons_conversions_js__WEBPACK_IMPORTED_MODULE_2__/* .deserealizeEmulator */ .ye,
        // toPlainObject: serializeEmulator
    }),
    __metadata("design:type", _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Emulator */ .G2)
], EmulatorEntity.prototype, "emulator", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_4__/* .Convertible */ .e0)(),
    __metadata("design:type", Number)
], EmulatorEntity.prototype, "zeroTime", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_4__/* .Convertible */ .e0)({ type: String }),
    __metadata("design:type", Array)
], EmulatorEntity.prototype, "privateKeys", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_4__/* .Convertible */ .e0)({ isCreatedAt: true }),
    __metadata("design:type", Date)
], EmulatorEntity.prototype, "createdAt", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_4__/* .Convertible */ .e0)({ isUpdatedAt: true }),
    __metadata("design:type", Date)
], EmulatorEntity.prototype, "updatedAt", void 0);
EmulatorEntity = __decorate([
    (0,_Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_3__/* .asEntity */ .y)()
], EmulatorEntity);

//# sourceMappingURL=Emulator.Entity.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 1211:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ JobEntity; }
/* harmony export */ });
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28660);
/* harmony import */ var _Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2607);
/* harmony import */ var _Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19083);
/* harmony import */ var _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90194);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_3__]);
_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_3__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




let JobEntity = class JobEntity extends _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_3__/* .BaseEntity */ .e {
    static { this._apiRoute = 'jobs'; }
    static { this._className = 'Jobs'; }
};
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], JobEntity.prototype, "name", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], JobEntity.prototype, "status", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], JobEntity.prototype, "message", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", Boolean)
], JobEntity.prototype, "result", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], JobEntity.prototype, "error", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({ isCreatedAt: true }),
    __metadata("design:type", Date)
], JobEntity.prototype, "createdAt", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({ isUpdatedAt: true }),
    __metadata("design:type", Date)
], JobEntity.prototype, "updatedAt", void 0);
JobEntity = __decorate([
    (0,_Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_1__/* .asEntity */ .y)()
], JobEntity);

//# sourceMappingURL=Job.Entity.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 96098:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ PriceEntity; }
/* harmony export */ });
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28660);
/* harmony import */ var _Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2607);
/* harmony import */ var _Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19083);
/* harmony import */ var _Commons_formatters_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86081);
/* harmony import */ var _Commons_utils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75672);
/* harmony import */ var _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90194);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_5__]);
_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_5__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






let PriceEntity = class PriceEntity extends _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_5__/* .BaseEntity */ .e {
    static { this._apiRoute = 'prices'; }
    static { this._className = 'Oracle Price'; }
    // #endregion fields
    // #region  db
    static { this.defaultFieldsWhenUndefined = {}; }
    static { this.alwaysFieldsForSelect = {
        ...super.alwaysFieldsForSelect,
        CS: true,
        TN_Hex: true,
        TN_Str: true,
        priceADAx1e6: true,
    }; }
    // #endregion  db
    // #region class methods
    show() {
        return `${(0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_3__/* .formatHash */ .NI)(this.CS)}, ${(0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_4__/* .hexToStr */ .Nd)(this.TN_Hex)}: ${this.priceADAx1e6}`;
    }
};
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], PriceEntity.prototype, "CS", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], PriceEntity.prototype, "TN_Hex", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], PriceEntity.prototype, "TN_Str", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", Date)
], PriceEntity.prototype, "date", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", BigInt)
], PriceEntity.prototype, "priceADAx1e6", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", Object)
], PriceEntity.prototype, "signature", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({ isCreatedAt: true }),
    __metadata("design:type", Date)
], PriceEntity.prototype, "createdAt", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({ isUpdatedAt: true }),
    __metadata("design:type", Date)
], PriceEntity.prototype, "updatedAt", void 0);
PriceEntity = __decorate([
    (0,_Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_1__/* .asEntity */ .y)()
], PriceEntity);

//# sourceMappingURL=Price.Entity.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 3873:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* unused harmony export BaseTxRedeemer */
/* harmony import */ var _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76100);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37813);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__]);
([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);



class BaseTxRedeemer extends (/* unused pure expression or super */ null && (BaseConstructor)) {
    static { this._plutusDataIndex = 0; }
    static { this._plutusDataIsSubType = true; }
    // #region generic methods
    getStatic() {
        return this.constructor;
    }
    plutusDataIndex() {
        return this.getStatic()._plutusDataIndex;
    }
    static plutusDataIndex() {
        return this._plutusDataIndex;
    }
    plutusDataIsSubType() {
        return this.getStatic()._plutusDataIsSubType;
    }
    static plutusDataIsSubType() {
        return this._plutusDataIsSubType;
    }
    // #endregion generic methods
    // #region conversions methods
    redeemerToLucidData() {
        //---------------------------------
        let list = [];
        const redeemer = this;
        //---------------------------------
        const conversionFunctions = getCombinedConversionFunctions(this.getStatic());
        //---------------------------------
        if (conversionFunctions) {
            const processValue = (propertyKey, conversions, value) => {
                try {
                    let type = conversions.type;
                    if (conversions.toPlutusData) {
                        value = conversions.toPlutusData.call(this, value);
                    }
                    else if (type.toPlutusData) {
                        value = type.toPlutusData(value);
                    }
                    else {
                        value = itemToLucidData(value, propertyKey);
                    }
                    return value;
                }
                catch (error) {
                    throw `${propertyKey}: ${error}`;
                }
            };
            //---------------------------------
            for (const [propertyKey, conversions] of conversionFunctions.entries()) {
                if (conversions.isForRedeemer) {
                    if (redeemer.hasOwnProperty(propertyKey) === false) {
                        throw `${propertyKey}: missing in redeemer`;
                    }
                    let value = redeemer[propertyKey];
                    const itemData = processValue(propertyKey, conversions, value);
                    list.push(itemData);
                }
            }
        }
        if (this.plutusDataIsSubType()) {
            const constrSubtypo = new Constr(0, list);
            const constrTypo = new Constr(this.plutusDataIndex(), [constrSubtypo]);
            return constrTypo;
        }
        else {
            const constrTypo = new Constr(this.plutusDataIndex(), list);
            return constrTypo;
        }
    }
    toCborHex() {
        // convierte los campos del redeemer a cbor hex
        try {
            const data = this.redeemerToLucidData();
            const dataHex = Data.to(data);
            const plutusData = CML.PlutusData.from_cbor_hex(dataHex);
            const cborHex = plutusData.to_canonical_cbor_hex();
            return cborHex;
        }
        catch (error) {
            console.log(`[Redeemer] - toCborHex - Error: ${error}`);
            throw error;
        }
    }
    toHash() {
        try {
            const data = this.redeemerToLucidData();
            const dataHex = Data.to(data);
            const plutusData = CML.PlutusData.from_cbor_bytes(fromHex(dataHex));
            const hash = CML.hash_plutus_data(plutusData).to_hex();
            return hash;
        }
        catch (error) {
            console.log(`[Redeemer] - toHash - Error: ${error}`);
            throw error;
        }
    }
    static countRedeemerFields() {
        const conversionFunctions = getCombinedConversionFunctions(this);
        let count = 0;
        if (conversionFunctions) {
            for (const [propertyKey, conversions] of conversionFunctions.entries()) {
                if (conversions.isForRedeemer === true) {
                    count = count + 1;
                }
            }
        }
        return count;
    }
    static mkRedeemerFromRedeemerCborHex(cborHex) {
        //TODO: no lo probe
        // crea un objeto con los tipos y clases correctos desde un cbor hex
        const redeemer = {};
        const conversionFunctions = getCombinedConversionFunctions(this);
        if (conversionFunctions) {
            const lucidDataForDatum = Data.from(cborHex);
            if (lucidDataForDatum.index === this.plutusDataIndex()) {
                let lucidDataForFields = [];
                if (this.plutusDataIsSubType() === false) {
                    lucidDataForFields = lucidDataForDatum.fields;
                }
                else {
                    const lucidDataForConstr0 = lucidDataForDatum.fields;
                    //constr para lista de campos
                    if (lucidDataForConstr0[0].index === 0) {
                        lucidDataForFields = lucidDataForConstr0[0].fields;
                    }
                    else {
                        throw `[Redeemer] - Can't get Datum - error: expected index 0 at firts level`;
                    }
                }
                const countRedeemerFields = this.countRedeemerFields();
                if (lucidDataForFields.length === countRedeemerFields) {
                    const processValue = (propertyKey, conversions, itemData) => {
                        try {
                            let type = conversions?.type;
                            let value;
                            if (conversions?.fromPlutusData) {
                                value = conversions.fromPlutusData.call(this, itemData);
                            }
                            else if (type?.fromPlutusData) {
                                value = type.fromPlutusData(itemData);
                            }
                            else if (conversions?.type !== Number && conversions?.type !== BigInt && conversions?.type !== String && conversions?.type !== Boolean) {
                                //const obj = objFromLucidData(itemData)
                                value = new type(itemData);
                            }
                            else if (conversions?.type === Number) {
                                value = Number(itemData);
                            }
                            else if (conversions.type === Boolean) {
                                if (itemData instanceof Constr && itemData.fields.length === 0) {
                                    value = itemData.index === 1 ? true : false;
                                }
                                else if (typeof itemData === 'boolean') {
                                    value = itemData;
                                }
                                else {
                                    throw `[Redeemer] - ${propertyKey}: expected Constr for boolean deserialization`;
                                }
                            }
                            else {
                                value = itemData;
                            }
                            return value;
                        }
                        catch (error) {
                            throw `[Redeemer] - ${propertyKey}: ${error}`;
                        }
                    };
                    let indexLucidData = 0;
                    for (const [propertyKey, conversions] of conversionFunctions.entries()) {
                        if (conversions.isForRedeemer) {
                            let itemData = lucidDataForFields[indexLucidData];
                            if (conversions.isArray === true) {
                                let array = [];
                                if (itemData) {
                                    if (Array.isArray(itemData) === false) {
                                        throw `[Redeemer] - ${propertyKey}: value must be an array`;
                                    }
                                    for (let i = 0; i < itemData.length; i++) {
                                        const item = processValue(propertyKey, conversions, itemData[i]);
                                        array.push(item);
                                    }
                                }
                                itemData = array;
                            }
                            else {
                                itemData = processValue(propertyKey, conversions, itemData);
                            }
                            redeemer[propertyKey] = itemData;
                            indexLucidData = indexLucidData + 1;
                        }
                    }
                }
                else {
                    throw `[Redeemer] - Can't get Redeemer - error: expected ${countRedeemerFields} fields, found ${lucidDataForFields.length}`;
                }
            }
            else {
                throw `[Redeemer] - Can't get Redeemer - error: plutusDataIndex dont match`;
            }
        }
        return redeemer;
    }
}
//# sourceMappingURL=Base.Redeemer.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 73387:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ SiteSettingsEntity; }
/* harmony export */ });
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28660);
/* harmony import */ var _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27001);
/* harmony import */ var _Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2607);
/* harmony import */ var _Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19083);
/* harmony import */ var _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90194);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_4__]);
_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_4__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





let SiteSettingsEntity = class SiteSettingsEntity extends _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_4__/* .BaseEntity */ .e {
    static { this._className = 'Site'; }
    static { this._apiRoute = 'site-settings'; }
    // #endregion fields
    // #region class methods
    getblockfrost_url_explorer_tx(hash) {
        const url = _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .isMainnet */ .mC ? this.blockfrost_url_explorer_mainnet : this.blockfrost_url_explorer_preview;
        return `${url}tx/${hash}`;
    }
    getblockfrost_url_explorer_utxo(utxo) {
        const url = _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .isMainnet */ .mC ? this.blockfrost_url_explorer_mainnet : this.blockfrost_url_explorer_preview;
        return `${url}tx/${utxo}`;
    }
    getblockfrost_url_explorer_address(address) {
        const url = _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .isMainnet */ .mC ? this.blockfrost_url_explorer_mainnet : this.blockfrost_url_explorer_preview;
        return `${url}address/${address}`;
    }
    getblockfrost_url_explorer_policy(cs) {
        const url = _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .isMainnet */ .mC ? this.blockfrost_url_explorer_mainnet : this.blockfrost_url_explorer_preview;
        return `${url}policy/${cs}`;
    }
    gettaptools_url_explorer_mainnet(cs, tn) {
        const url = this.taptools_url_explorer_mainnet;
        return `${url}${cs}${tn}`;
    }
};
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ isUnique: true }),
    __metadata("design:type", String)
], SiteSettingsEntity.prototype, "name", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], SiteSettingsEntity.prototype, "siteSecret", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], SiteSettingsEntity.prototype, "corsAllowedOrigin", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", Boolean)
], SiteSettingsEntity.prototype, "debug", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], SiteSettingsEntity.prototype, "welcomeMessage", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", Number)
], SiteSettingsEntity.prototype, "welcomeMessageIndex", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], SiteSettingsEntity.prototype, "blockfrost_url_api_mainnet", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], SiteSettingsEntity.prototype, "blockfrost_url_explorer_mainnet", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], SiteSettingsEntity.prototype, "blockfrost_url_api_preview", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], SiteSettingsEntity.prototype, "blockfrost_url_explorer_preview", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], SiteSettingsEntity.prototype, "blockfrost_url_api_preprod", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], SiteSettingsEntity.prototype, "blockfrost_url_explorer_preprod", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], SiteSettingsEntity.prototype, "taptools_url_explorer_mainnet", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], SiteSettingsEntity.prototype, "oracle_wallet_publickey_cborhex", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], SiteSettingsEntity.prototype, "oracle_internal_wallet_publickey_cborhex", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ isCreatedAt: true }),
    __metadata("design:type", Date)
], SiteSettingsEntity.prototype, "createdAt", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ isUpdatedAt: true }),
    __metadata("design:type", Date)
], SiteSettingsEntity.prototype, "updatedAt", void 0);
SiteSettingsEntity = __decorate([
    (0,_Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_2__/* .asEntity */ .y)()
], SiteSettingsEntity);

//# sourceMappingURL=SiteSettings.Entity.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 94093:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ SmartUTxOEntity; }
/* harmony export */ });
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28660);
/* harmony import */ var _Commons_conversions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69623);
/* harmony import */ var _Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2607);
/* harmony import */ var _Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19083);
/* harmony import */ var _Commons_formatters_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86081);
/* harmony import */ var _Commons_typesPlutus_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70726);
/* harmony import */ var _Commons_utils_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75672);
/* harmony import */ var _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90194);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_conversions_js__WEBPACK_IMPORTED_MODULE_1__, _Commons_typesPlutus_js__WEBPACK_IMPORTED_MODULE_5__, _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_7__]);
([_Commons_conversions_js__WEBPACK_IMPORTED_MODULE_1__, _Commons_typesPlutus_js__WEBPACK_IMPORTED_MODULE_5__, _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_7__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








let SmartUTxOEntity = class SmartUTxOEntity extends _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_7__/* .BaseEntity */ .e {
    static { this._className = 'Smart UTxO'; }
    static { this._apiRoute = 'smartutxos'; }
    // #endregion fields
    // #region db
    // #endregion db
    // #region class methods
    show() {
        const object = {
            _DB_id: this._DB_id,
            txHash: this.txHash,
            outputIndex: this.outputIndex,
        };
        return (0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .toJson */ .Qs)(object);
    }
    getTxOutRef() {
        return new _Commons_typesPlutus_js__WEBPACK_IMPORTED_MODULE_5__/* .TxOutRef */ .zQ(this.txHash, this.outputIndex);
    }
    getUTxO() {
        const uTxO = {
            txHash: this.txHash,
            outputIndex: this.outputIndex,
            assets: this.assets,
            address: this.address,
            datumHash: this.datumHash,
            datum: this.datum,
            scriptRef: this.scriptRef,
        };
        return uTxO;
    }
    getOutRef() {
        const outRef = {
            txHash: this.txHash,
            outputIndex: this.outputIndex,
        };
        return outRef;
    }
    showStatus() {
        if (this.isPreparingForConsuming) {
            if (this.isConsuming) {
                return `Reserved for Consuming: Preparing since ${(0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(this.isPreparingForConsuming)}, In transaction since ${(0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(this.isConsuming)}`;
            }
            return `Reserved for Consuming: Preparing since ${(0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(this.isPreparingForConsuming)}`;
        }
        if (this.isConsuming) {
            return `Reserved: In transaction since ${(0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(this.isConsuming)}`;
        }
        if (this.isPreparingForReading) {
            if (this.isReading) {
                return `Reserved for Reading: Preparing since ${(0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(this.isPreparingForReading)}, In reading since ${(0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(this.isReading)}`;
            }
            return `Reserved for Reading: Preparing since ${(0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(this.isPreparingForReading)}`;
        }
        if (this.isReading) {
            return `Reserved: In reading since ${(0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(this.isReading)}`;
        }
        return 'Available';
    }
    // NOTE: estos metodos solo sirven para mostrar en frontend, por que los valores de estos campos no estan actualizados
    // se actualizan con el callbackonload, pero lo mas poreciso es buscar en transactions getReadingAndConsumingDates
    isAvailableForReading() {
        // para que pueda ser usada como utxo de lectura, por referencia, debe estar no en uso para consumo
        // es indiferente si está en uso para lectura por otro proceso
        return this.isPreparingForConsuming === undefined && this.isConsuming === undefined;
    }
    isAvailableForConsuming() {
        // para que pueda ser usada como utxo de consumo, debe estar no en uso para lectura ni consumo
        return this.isPreparingForReading === undefined && this.isReading === undefined && this.isPreparingForConsuming === undefined && this.isConsuming === undefined;
    }
};
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], SmartUTxOEntity.prototype, "address", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], SmartUTxOEntity.prototype, "txHash", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", Number)
], SmartUTxOEntity.prototype, "outputIndex", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ type: Date }),
    __metadata("design:type", Object)
], SmartUTxOEntity.prototype, "isPreparingForReading", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ type: Date }),
    __metadata("design:type", Object)
], SmartUTxOEntity.prototype, "isReading", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ type: Date }),
    __metadata("design:type", Object)
], SmartUTxOEntity.prototype, "isPreparingForConsuming", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ type: Date }),
    __metadata("design:type", Object)
], SmartUTxOEntity.prototype, "isConsuming", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({
        fromPlainObject: _Commons_conversions_js__WEBPACK_IMPORTED_MODULE_1__/* .deserealizeAssets */ .gZ,
        // toPlainObject: serializeAssets
    }),
    __metadata("design:type", Object)
], SmartUTxOEntity.prototype, "assets", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ type: String }),
    __metadata("design:type", Object)
], SmartUTxOEntity.prototype, "datumHash", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ type: String }),
    __metadata("design:type", Object)
], SmartUTxOEntity.prototype, "datum", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", Object)
], SmartUTxOEntity.prototype, "datumObj", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ type: Object }),
    __metadata("design:type", Object)
], SmartUTxOEntity.prototype, "scriptRef", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], SmartUTxOEntity.prototype, "_NET_id_CS", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], SmartUTxOEntity.prototype, "_NET_id_TN_Str", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", Boolean)
], SmartUTxOEntity.prototype, "_is_NET_id_Unique", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], SmartUTxOEntity.prototype, "datumType", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ isCreatedAt: true }),
    __metadata("design:type", Date)
], SmartUTxOEntity.prototype, "createdAt", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ isUpdatedAt: true }),
    __metadata("design:type", Date)
], SmartUTxOEntity.prototype, "updatedAt", void 0);
SmartUTxOEntity = __decorate([
    (0,_Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_2__/* .asEntity */ .y)()
], SmartUTxOEntity);

//# sourceMappingURL=SmartUTxO.Entity.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 22797:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ SmartUTxOWithDetailsEntity; }
/* harmony export */ });
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28660);
/* harmony import */ var _Commons_conversions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69623);
/* harmony import */ var _Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2607);
/* harmony import */ var _Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19083);
/* harmony import */ var _SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94093);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_conversions_js__WEBPACK_IMPORTED_MODULE_1__, _SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_4__]);
([_Commons_conversions_js__WEBPACK_IMPORTED_MODULE_1__, _SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_4__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





let SmartUTxOWithDetailsEntity = class SmartUTxOWithDetailsEntity extends _SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_4__/* .SmartUTxOEntity */ .U {
    static { this._apiRoute = 'smartutxos-with-details'; }
    static { this._className = 'SmartUTxO With Details'; }
    // #endregion fields
    // #region db
    static { this.alwaysFieldsForCallbackOnAfterLoad = {
        ...super.alwaysFieldsForCallbackOnAfterLoad,
        assets: true,
    }; }
};
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({
        type: Object,
        isArray: true,
        fromPlainObject: _Commons_conversions_js__WEBPACK_IMPORTED_MODULE_1__/* .deserealizeTokenWithMetadataAndAmount */ .As,
    }),
    __metadata("design:type", Array)
], SmartUTxOWithDetailsEntity.prototype, "assetsWithDetails", void 0);
SmartUTxOWithDetailsEntity = __decorate([
    (0,_Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_2__/* .asEntity */ .y)()
], SmartUTxOWithDetailsEntity);

//# sourceMappingURL=SmartUTxO.WithDetails.Entity.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 73753:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ TokenMetadataEntity; }
/* harmony export */ });
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28660);
/* harmony import */ var _Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2607);
/* harmony import */ var _Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19083);
/* harmony import */ var _Commons_helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36394);
/* harmony import */ var _Commons_types_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94104);
/* harmony import */ var _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90194);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_helpers_js__WEBPACK_IMPORTED_MODULE_3__, _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_5__]);
([_Commons_helpers_js__WEBPACK_IMPORTED_MODULE_3__, _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_5__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






let TokenMetadataEntity = class TokenMetadataEntity extends _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_5__/* .BaseEntity */ .e {
    constructor() {
        super(...arguments);
        // #endregion db
        // #region class methods
        this.getFallbackImageLetters = () => {
            return (0,_Commons_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .getFallbackImageLetters */ .sA)(this);
        };
        // #endregion class methods
    }
    static { this._apiRoute = 'token-metadata'; }
    static { this._className = 'Token Metadata'; }
    // #endregion fields
    // #region db
    static { this.optionsGetForTokenStore = {
        ..._Commons_types_js__WEBPACK_IMPORTED_MODULE_4__/* .optionsGetMinimal */ .FH,
        fieldsForSelect: { CS: true, TN_Hex: true, TN_Str: true, ticker: true, decimals: true, image: true, colorHex: true },
    }; }
};
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], TokenMetadataEntity.prototype, "CS", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], TokenMetadataEntity.prototype, "TN_Hex", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], TokenMetadataEntity.prototype, "TN_Str", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], TokenMetadataEntity.prototype, "ticker", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({ type: Number }),
    __metadata("design:type", Number)
], TokenMetadataEntity.prototype, "decimals", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], TokenMetadataEntity.prototype, "image", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", String)
], TokenMetadataEntity.prototype, "colorHex", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", Object)
], TokenMetadataEntity.prototype, "metadata_raw", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({}),
    __metadata("design:type", Boolean)
], TokenMetadataEntity.prototype, "swMetadataGenerated", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({ isCreatedAt: true }),
    __metadata("design:type", Date)
], TokenMetadataEntity.prototype, "createdAt", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({ isUpdatedAt: true }),
    __metadata("design:type", Date)
], TokenMetadataEntity.prototype, "updatedAt", void 0);
TokenMetadataEntity = __decorate([
    (0,_Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_1__/* .asEntity */ .y)()
], TokenMetadataEntity);

//# sourceMappingURL=Token.Metadata.Entity.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 32519:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ TransactionEntity; }
/* harmony export */ });
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28660);
/* harmony import */ var _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27001);
/* harmony import */ var _Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2607);
/* harmony import */ var _Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19083);
/* harmony import */ var _Commons_explainError_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73582);
/* harmony import */ var _Commons_utils_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75672);
/* harmony import */ var _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90194);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_6__]);
_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_6__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







let TransactionEntity = class TransactionEntity extends _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_6__/* .BaseEntity */ .e {
    static { this._apiRoute = 'transactions'; }
    static { this._className = 'Transactions'; }
    // #endregion fields
    // #region  db
    static { this.defaultFieldsWhenUndefined = {}; }
    static { this.alwaysFieldsForSelect = {
        ...super.alwaysFieldsForSelect,
        paymentPKH: true,
        date: true,
        type: true,
        hash: true,
        status: true,
        error: true,
        parse_info: true,
        ids: true,
        redeemers: true,
        datums: true,
        consuming_UTxOs: true,
        reading_UTxOs: true,
        valid_from: true,
        valid_until: true,
        unit_mem: true,
        unit_steps: true,
        fee: true,
        CBORHex: true,
        createdAt: true,
        updatedAt: true,
    }; }
    // #endregion  db
    // #region class methods
    prettyError(showForUsers = true, showWallet = true) {
        if (this.status !== _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .TRANSACTION_STATUS_FAILED */ .Xq) {
            return '';
        }
        if ((0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_5__/* .isEmptyObject */ .Qr)(this.error)) {
            return 'Unknown Error';
        }
        let errorMsg;
        if (showForUsers) {
            errorMsg = (0,_Commons_explainError_js__WEBPACK_IMPORTED_MODULE_4__/* .explainErrorTx */ .u)((0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_5__/* .toJson */ .Qs)(this.error.error));
        }
        else {
            errorMsg = this.error.error;
        }
        let res;
        if (showWallet === true) {
            res = (0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_5__/* .toJson */ .Qs)({
                error: errorMsg,
                wallet: this.error?.walletInfo ?? '',
            }, ' ');
        }
        else {
            res = (0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_5__/* .toJson */ .Qs)(errorMsg, ' ');
        }
        return res;
    }
};
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], TransactionEntity.prototype, "hash", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], TransactionEntity.prototype, "paymentPKH", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", Date)
], TransactionEntity.prototype, "date", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], TransactionEntity.prototype, "type", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], TransactionEntity.prototype, "status", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", Object)
], TransactionEntity.prototype, "error", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], TransactionEntity.prototype, "parse_info", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ type: Object }),
    __metadata("design:type", Object)
], TransactionEntity.prototype, "ids", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ type: Object }),
    __metadata("design:type", Object)
], TransactionEntity.prototype, "redeemers", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ type: Object }),
    __metadata("design:type", Object)
], TransactionEntity.prototype, "datums", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ type: Object }),
    __metadata("design:type", Array)
], TransactionEntity.prototype, "consuming_UTxOs", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ type: Object }),
    __metadata("design:type", Array)
], TransactionEntity.prototype, "reading_UTxOs", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", Number)
], TransactionEntity.prototype, "valid_from", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", Number)
], TransactionEntity.prototype, "valid_until", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", Number)
], TransactionEntity.prototype, "unit_mem", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", Number)
], TransactionEntity.prototype, "unit_steps", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", Number)
], TransactionEntity.prototype, "fee", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", Number)
], TransactionEntity.prototype, "size", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], TransactionEntity.prototype, "CBORHex", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ isCreatedAt: true }),
    __metadata("design:type", Date)
], TransactionEntity.prototype, "createdAt", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_3__/* .Convertible */ .e0)({ isUpdatedAt: true }),
    __metadata("design:type", Date)
], TransactionEntity.prototype, "updatedAt", void 0);
TransactionEntity = __decorate([
    (0,_Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_2__/* .asEntity */ .y)()
], TransactionEntity);

//# sourceMappingURL=Transaction.Entity.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 15068:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ WalletEntity; }
/* harmony export */ });
/* harmony import */ var reflect_metadata__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28660);
/* harmony import */ var _Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2607);
/* harmony import */ var _Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19083);
/* harmony import */ var _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90194);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_3__]);
_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_3__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




let WalletEntity = class WalletEntity extends _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_3__/* .BaseEntity */ .e {
    static { this._apiRoute = 'wallets'; }
    static { this._className = 'Wallets'; }
};
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], WalletEntity.prototype, "walletName", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", Boolean)
], WalletEntity.prototype, "walletValidatedWithSignedToken", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], WalletEntity.prototype, "paymentPKH", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], WalletEntity.prototype, "stakePKH", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], WalletEntity.prototype, "name", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], WalletEntity.prototype, "email", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", Boolean)
], WalletEntity.prototype, "isCoreTeam", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], WalletEntity.prototype, "testnet_address", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], WalletEntity.prototype, "mainnet_address", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", String)
], WalletEntity.prototype, "createdBy", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)(),
    __metadata("design:type", Date)
], WalletEntity.prototype, "lastConnection", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({ isCreatedAt: true }),
    __metadata("design:type", Date)
], WalletEntity.prototype, "createdAt", void 0);
__decorate([
    (0,_Commons_Decorators_Decorator_Convertible_js__WEBPACK_IMPORTED_MODULE_2__/* .Convertible */ .e0)({ isUpdatedAt: true }),
    __metadata("design:type", Date)
], WalletEntity.prototype, "updatedAt", void 0);
WalletEntity = __decorate([
    (0,_Commons_Decorators_Decorator_asEntity_js__WEBPACK_IMPORTED_MODULE_1__/* .asEntity */ .y)()
], WalletEntity);

//# sourceMappingURL=Wallet.Entity.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 69302:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* reexport safe */ _Token_Metadata_Entity_js__WEBPACK_IMPORTED_MODULE_10__.Q; },
/* harmony export */   "tw": function() { return /* reexport safe */ _Base_Base_SmartDB_Entity_js__WEBPACK_IMPORTED_MODULE_2__.t; }
/* harmony export */ });
/* harmony import */ var _AddressToFollow_Entity_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17658);
/* harmony import */ var _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90194);
/* harmony import */ var _Base_Base_SmartDB_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72083);
/* harmony import */ var _Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87654);
/* harmony import */ var _Job_Entity_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1211);
/* harmony import */ var _Price_Entity_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96098);
/* harmony import */ var _Redeemers_Base_Redeemer_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3873);
/* harmony import */ var _SiteSettings_Entity_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73387);
/* harmony import */ var _SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94093);
/* harmony import */ var _SmartUTxO_WithDetails_Entity_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22797);
/* harmony import */ var _Token_Metadata_Entity_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73753);
/* harmony import */ var _Transaction_Entity_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32519);
/* harmony import */ var _Wallet_Entity_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15068);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_AddressToFollow_Entity_js__WEBPACK_IMPORTED_MODULE_0__, _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_1__, _Base_Base_SmartDB_Entity_js__WEBPACK_IMPORTED_MODULE_2__, _Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__, _Job_Entity_js__WEBPACK_IMPORTED_MODULE_4__, _Price_Entity_js__WEBPACK_IMPORTED_MODULE_5__, _Redeemers_Base_Redeemer_js__WEBPACK_IMPORTED_MODULE_6__, _SiteSettings_Entity_js__WEBPACK_IMPORTED_MODULE_7__, _SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_8__, _SmartUTxO_WithDetails_Entity_js__WEBPACK_IMPORTED_MODULE_9__, _Token_Metadata_Entity_js__WEBPACK_IMPORTED_MODULE_10__, _Transaction_Entity_js__WEBPACK_IMPORTED_MODULE_11__, _Wallet_Entity_js__WEBPACK_IMPORTED_MODULE_12__]);
([_AddressToFollow_Entity_js__WEBPACK_IMPORTED_MODULE_0__, _Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_1__, _Base_Base_SmartDB_Entity_js__WEBPACK_IMPORTED_MODULE_2__, _Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__, _Job_Entity_js__WEBPACK_IMPORTED_MODULE_4__, _Price_Entity_js__WEBPACK_IMPORTED_MODULE_5__, _Redeemers_Base_Redeemer_js__WEBPACK_IMPORTED_MODULE_6__, _SiteSettings_Entity_js__WEBPACK_IMPORTED_MODULE_7__, _SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_8__, _SmartUTxO_WithDetails_Entity_js__WEBPACK_IMPORTED_MODULE_9__, _Token_Metadata_Entity_js__WEBPACK_IMPORTED_MODULE_10__, _Transaction_Entity_js__WEBPACK_IMPORTED_MODULE_11__, _Wallet_Entity_js__WEBPACK_IMPORTED_MODULE_12__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);














//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 14560:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ AddressToFollowFrontEndApiCalls; }
/* harmony export */ });
/* harmony import */ var _lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66527);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37813);
/* harmony import */ var _Entities_AddressToFollow_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17658);
/* harmony import */ var _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4965);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_AddressToFollow_Entity_js__WEBPACK_IMPORTED_MODULE_2__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__]);
([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_AddressToFollow_Entity_js__WEBPACK_IMPORTED_MODULE_2__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);




class AddressToFollowFrontEndApiCalls extends _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__/* .BaseFrontEndApiCalls */ .b {
    static { this._Entity = _Entities_AddressToFollow_Entity_js__WEBPACK_IMPORTED_MODULE_2__/* .AddressToFollowEntity */ .R; }
    // #region api
    static async syncAddressApi(addressToFollow, force = false) {
        try {
            //-------------------------
            if (!addressToFollow) {
                throw `addressToFollow not defined`;
            }
            //-------------------------
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ event: 'sync', force, tryCountAgain: false });
            //-------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${addressToFollow.apiRouteToCall}/${addressToFollow.address}/${addressToFollow.CS}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            //-------------------------
            if (response.status === 200) {
                console.log(`[${this._Entity.className()}] - syncAddressApi - address: ${addressToFollow.address} - response OK`);
                return true;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - syncAddressApi - Error: ${error}`);
            throw error;
        }
    }
    static async syncAllApi(force = false) {
        try {
            //-------------------------
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ event: 'sync', force });
            //-------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/sync-all`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            //-------------------------
            if (response.status === 200) {
                console.log(`[${this._Entity.className()}] - syncAllApi - response OK`);
                return true;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - syncAllApi - Error: ${error}`);
            throw error;
        }
    }
    static async cleanApi(force = false) {
        try {
            //-------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/clean`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            //-------------------------
            if (response.status === 200) {
                console.log(`[${this._Entity.className()}] - cleanApi - response OK`);
                return true;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - cleanApi - Error: ${error}`);
            throw error;
        }
    }
    static async getByAddressApi(address, CS, optionsGet) {
        try {
            //-------------------------
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(address)) {
                throw `Address not defined`;
            }
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(CS)) {
                throw `Currency Symbol not defined`;
            }
            //-------------------------
            let response;
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isEqual */ .Xyp)(optionsGet, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .optionsGetDefault */ .tA8)) {
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/by-address/${address}/${CS}`);
            }
            else {
                const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)(optionsGet);
                //-------------------------
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/by-address/${address}/${CS}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body,
                });
            }
            //-------------------------
            if (response.status === 200) {
                const datas = await response.json();
                console.log(`[${this._Entity.className()}] - getByAddressApi - response OK`);
                const instances = datas.map((data) => this._Entity.fromPlainObject(data));
                console.log(`[${this._Entity.className()}] - getByAddressApi - address: ${address} - CS: ${CS} - len: ${instances.length}`);
                return instances;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - getByAddressApi - Error: ${error}`);
            throw error;
        }
    }
    static async getFromAndToBlockApi(address) {
        try {
            //-------------------------
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(address)) {
                throw `address not defined`;
            }
            //-------------------------
            let response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/from-to-block/${address}`);
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - getFromAndToBlock - response OK - fromBlock: ${data.fromBlock} - toBlock: ${data.toBlock}`);
                return { fromBlock: data.fromBlock, toBlock: data.toBlock };
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - getFromAndToBlock - Error: ${error}`);
            throw error;
        }
    }
}
//# sourceMappingURL=AddressToFollow.FrontEnd.Api.Calls.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 4965:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ BaseFrontEndApiCalls; }
/* harmony export */ });
/* harmony import */ var _lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66527);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37813);
/* harmony import */ var _Entities_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90194);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_2__]);
([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_2__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);



// es generica, todos los metodos llevan instancia o entidad como parametro
// todas las clases la pueden usar
// pero si se setea uno por Entidad y se setea la entidad, tiene metodos especificos
// ofrece metodos igual que el base pero con _ para cuando es especifico
class BaseFrontEndApiCalls {
    static { this._Entity = _Entities_Base_Base_Entity_js__WEBPACK_IMPORTED_MODULE_2__/* .BaseEntity */ .e; }
    // #region api applied to entity
    static async callGenericPOSTApi_(apiRoute, params) {
        return await this.callGenericPOSTApi(this._Entity, apiRoute, params);
    }
    static async callGeneriGETApi_(apiRoute, params) {
        return await this.callGeneriGETApi(this._Entity, apiRoute, params);
    }
    static async updateWithParamsApi_(id, updateFields, optionsUpdate) {
        return await this.updateWithParamsApi(this._Entity, id, updateFields, optionsUpdate);
    }
    static async checkIfExistsApi_(paramsFilterOrID) {
        return await this.checkIfExistsApi(this._Entity, paramsFilterOrID);
    }
    static async getByIdApi_(id, optionsGet) {
        return await this.getByIdApi(this._Entity, id, optionsGet);
    }
    static async getOneByParamsApi_(paramsFilter, optionsGet) {
        return await this.getOneByParamsApi(this._Entity, paramsFilter, optionsGet);
    }
    static async getByParamsApi_(paramsFilter, optionsGet) {
        return await this.getByParamsApi(this._Entity, paramsFilter, optionsGet);
    }
    static async getAllApi_(optionsGet) {
        return await this.getAllApi(this._Entity, optionsGet);
    }
    static async getCountApi_(paramsFilter) {
        return await this.getCountApi(this._Entity, paramsFilter);
    }
    static async getTotalItemsAndPagesApi_(paramsFilter, itemsPerPage) {
        return await this.getTotalItemsAndPagesApi(this._Entity, paramsFilter, itemsPerPage);
    }
    static async deleteByIdApi_(id, optionsDelete) {
        return await this.deleteByIdApi(this._Entity, id, optionsDelete);
    }
    // #endregion api applied to entity
    // #region api
    static async callGenericPOSTApi(Entity, apiRoute, params) {
        try {
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)(params);
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/${apiRoute}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${Entity.apiRoute()}] - callGenericPOSTApi - OK`);
                return data;
            }
            else {
                const errorData = await response.json();
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${Entity.apiRoute()}] - callGenericPOSTApi - Error: ${error}`);
            throw error;
        }
    }
    static async callGeneriGETApi(Entity, apiRoute, params) {
        try {
            //------------------
            const queryString = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .createQueryURLString */ .Soz)(params);
            //------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/${apiRoute}${queryString}`);
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${Entity.apiRoute()}] - callGeneriGETApi - OK`);
                return data;
            }
            else {
                const errorData = await response.json();
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${Entity.apiRoute()}] - callGeneriGETApi - Error: ${error}`);
            throw error;
        }
    }
    static async createApi(instance, optionsCreate) {
        try {
            //const createFields = instance.toPlainObject();
            const createFields = instance;
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ createFields, ...optionsCreate });
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${instance.apiRoute()}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${instance.className()}] - createApi - response OK`);
                const instance_ = instance.getStatic().fromPlainObject(data);
                console.log(`[${instance.className()}] - createApi - Instance: ${instance_.show()}`);
                return instance_;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${instance.className()}] - createApi - Error: ${error}`);
            throw error;
        }
    }
    static async refreshApi(instance, optionsGet) {
        try {
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(instance._DB_id)) {
                throw `id not defined`;
            }
            const instance_ = await this.getByIdApi(instance.getStatic(), instance._DB_id, optionsGet);
            if (instance_ === undefined) {
                throw `id: ${instance._DB_id} not found`;
            }
            Object.assign(instance, instance_);
        }
        catch (error) {
            console.log(`[${instance.className()}] - refreshApi - Error: ${error}`);
            throw error;
        }
    }
    static async updateApi(instance, optionsUpdate, headers) {
        try {
            const updateFields = instance.toPlainObject();
            await this.updateMeWithParamsApi(instance, updateFields, optionsUpdate, headers);
        }
        catch (error) {
            console.log(`[${instance.className()}] - updateApi - Error: ${error}`);
            throw error;
        }
    }
    static async updateWithParamsApi(Entity, id, updateFields, optionsUpdate) {
        try {
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(id)) {
                throw `id not defined`;
            }
            const instance = await this.getByIdApi(Entity, id, optionsUpdate);
            if (!instance) {
                throw `${Entity.className()} - Not found for Update Api - id: ${id}`;
            }
            await this.updateMeWithParamsApi(instance, updateFields, optionsUpdate);
            return instance;
        }
        catch (error) {
            console.log(`[${Entity.className()}] - updateWithParamsApi - Error: ${error}`);
            throw error;
        }
    }
    static async updateMeWithParamsApi(instance, updateFields, optionsUpdate, headers) {
        try {
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(instance._DB_id)) {
                throw `id not defined`;
            }
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ updateFields, ...optionsUpdate });
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${instance.apiRoute()}/update/${instance._DB_id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...headers,
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${instance.className()}] - updateWithParamsApi - response OK`);
                // const instance_ = this.Entity().fromPlainObject<T>(data);
                // Object.assign(instance, instance_);
                for (let key in updateFields) {
                    instance[key] = updateFields[key];
                }
                console.log(`[${instance.className()}] - updateWithParamsApi - Instance: ${instance.show()}`);
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${instance.className()}] - updateWithParamsApi - Error: ${error}`);
            throw error;
        }
    }
    static async checkIfExistsApi(Entity, paramsFilterOrID) {
        try {
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD0)(paramsFilterOrID) && (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(paramsFilterOrID)) {
                throw `id not defined`;
            }
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isObject */ .Kn2)(paramsFilterOrID) && (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isEmptyObject */ .Qr$)(paramsFilterOrID)) {
                throw `paramsFilter not defined`;
            }
            let response;
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD0)(paramsFilterOrID)) {
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/exists/${paramsFilterOrID}`);
            }
            else {
                const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ paramsFilter: paramsFilterOrID });
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/exists`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body,
                });
            }
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${Entity.className()}] - checkIfExistsApi: ${data.swExists}`);
                return data.swExists;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${Entity.className()}] - checkIfExistsApi - Error: ${error}`);
            throw error;
        }
    }
    static async getByIdApi(Entity, id, optionsGet) {
        try {
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(id)) {
                throw `id not defined`;
            }
            let response;
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isEqual */ .Xyp)(optionsGet, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .optionsGetOneDefault */ .rCT)) {
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/${id}`);
            }
            else {
                const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)(optionsGet);
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/${id}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body,
                });
            }
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${Entity.className()}] - getByIdApi - response OK`);
                const instance = Entity.fromPlainObject(data);
                console.log(`[${Entity.className()}] - getByIdApi - Instance: ${instance.show()}`);
                return instance;
            }
            else if (response.status === 404) {
                console.log(`[${Entity.className()}] - getByIdApi - id: ${id} - Instance not found`);
                return undefined;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${Entity.className()}] - getByIdApi - Error: ${error}`);
            throw error;
        }
    }
    static async getOneByParamsApi(Entity, paramsFilter, optionsGet) {
        try {
            const datas = await this.getByParamsApi(Entity, paramsFilter, { ...optionsGet, limit: 1 });
            const instances = datas.map((data) => Entity.fromPlainObject(data));
            if (instances.length > 0) {
                return instances[0];
            }
            else {
                return undefined;
            }
        }
        catch (error) {
            console.log(`[${Entity.className()}] - getOneByParamsApi - Error: ${error}`);
            throw error;
        }
    }
    static async getByParamsApi(Entity, paramsFilter, optionsGet) {
        try {
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ paramsFilter, ...optionsGet });
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/by-params`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const datas = await response.json();
                console.log(`[${Entity.className()}] - getByParamsApi - response OK`);
                const instances = await Promise.all(datas.map(async (data) => {
                    //-----------------------
                    const instance = Entity.fromPlainObject(data);
                    //-----------------------
                    if (optionsGet !== undefined && optionsGet.lookUpFields !== undefined && optionsGet.lookUpFields.length > 0) {
                        for (let lookUpField of optionsGet.lookUpFields) {
                            const EntityClass = _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .RegistryManager.getFromSmartDBEntitiesRegistry */ .Sb4.getFromSmartDBEntitiesRegistry(lookUpField.from) !== undefined
                                ? _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .RegistryManager.getFromSmartDBEntitiesRegistry */ .Sb4.getFromSmartDBEntitiesRegistry(lookUpField.from)
                                : _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .RegistryManager.getFromEntitiesRegistry */ .Sb4.getFromEntitiesRegistry(lookUpField.from);
                            if (EntityClass !== undefined) {
                                console.log(`[${Entity.className()}] - getByParams - getByParamsApi- LookUpField: ${lookUpField.from} - Loading...`);
                                const instance_ = await EntityClass.fromPlainObject(data[lookUpField.as]);
                                if (instance_ !== undefined) {
                                    instance[lookUpField.as] = instance_;
                                }
                            }
                        }
                    }
                    //-----------------------
                    return instance;
                    //-----------------------
                }));
                console.log(`[${Entity.className()}] - getByParamsApi - params: ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .showData */ .dMk)(paramsFilter)} - len: ${instances.length} - show firts 5: ${instances
                    .slice(0, 5)
                    .map((item) => item.show())
                    .join(', ')}`);
                return instances;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${Entity.className()}] - getByParamsApi - Error: ${error}`);
            throw error;
        }
    }
    static async getAllApi(Entity, optionsGet) {
        try {
            let response;
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isEqual */ .Xyp)(optionsGet, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .optionsGetDefault */ .tA8)) {
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/all`);
            }
            else {
                const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)(optionsGet);
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/all`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body,
                });
            }
            if (response.status === 200) {
                const datas = await response.json();
                console.log(`[${Entity.className()}] - getAllApi - response OK`);
                const instances = datas.map((data) => Entity.fromPlainObject(data));
                console.log(`[${Entity.className()}] - getAllApi - len: ${instances.length}`);
                return instances;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${Entity.className()}] - getAllApi - Error: ${error}`);
            throw error;
        }
    }
    static async getCountApi(Entity, paramsFilter) {
        try {
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ paramsFilter });
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/count`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${Entity.className()}] - getCountApi - count: ${data.count}`);
                return { count: data.count };
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${Entity.className()}] - getCountApi - Error: ${error}`);
            throw error;
        }
    }
    static async getTotalItemsAndPagesApi(Entity, paramsFilter, itemsPerPage) {
        const { count: items } = await this.getCountApi(Entity, paramsFilter);
        const totalPages = Math.ceil(items / (itemsPerPage ?? _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .ITEMS_PER_PAGE */ .gKj));
        return { items, pages: totalPages };
    }
    static async deleteByIdApi(Entity, id, optionsDelete) {
        try {
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(id)) {
                throw `id not defined`;
            }
            //------------------
            const queryString = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .createQueryURLString */ .Soz)(optionsDelete);
            //------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/${id}${queryString}`, {
                method: 'DELETE',
            });
            if (response.status === 200) {
                console.log(`[${Entity.className()}] - deleteByIdApi - Deleted id: ${id}`);
                return true;
            }
            else if (response.status === 404) {
                console.log(`[${Entity.className()}] - deleteByIdApi - id: ${id} - Instance not found`);
                return false;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${Entity.className()}] - deleteByIdApi - Error: ${error}`);
            throw error;
        }
    }
    static async deleteApi(instance, optionsDelete) {
        try {
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(instance._DB_id)) {
                throw `id not defined`;
            }
            //------------------
            const queryString = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .createQueryURLString */ .Soz)(optionsDelete);
            //------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${instance.apiRoute()}/${instance._DB_id}${queryString}`, {
                method: 'DELETE',
            });
            if (response.status === 200) {
                console.log(`[${instance.className()}] - deleteApi - Deleted Instance: ${instance.show()}`);
                return true;
            }
            else if (response.status === 404) {
                console.log(`[${instance.className()}] - deleteApi - id: ${instance._DB_id} - Instance not found`);
                return false;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${instance.className()}] - deleteApi - Error: ${error}`);
            throw error;
        }
    }
    static async fillWithRelationApi(instance, relation, optionsGet) {
        try {
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(relation)) {
                throw `Relation not defined`;
            }
            //--------------------------------------
            const conversionFunctions = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getCombinedConversionFunctions */ .xSF)(instance.getStatic());
            //--------------------------------------
            const conversions = conversionFunctions.get(relation);
            if (conversions === undefined || conversions.relation === undefined) {
                throw `Relation: ${relation} not found`;
            }
            //--------------------------------------
            if (conversions.isArray === true) {
                // OneToMany es una relacion un registro de esta tabla se relaciona con muchos registros de otra tabla
                // OneToMany es array
                const values = await this.loadRelationManyApi(instance, relation, optionsGet);
                //--------------------------------------
                if (instance[conversions.propertyToFill] !== values) {
                    instance[relation] = values.map((item) => item._DB_id);
                    instance[conversions.propertyToFill] = values;
                }
                //--------------------------------------
            }
            else {
                // OneToOne es una relacion de un registro de una tabla con un registro de otra tabla
                // ManyToOne es una relacion de muchos registros de esta tabla con un registro de otra tabla
                //--------------------------------------
                const value = await this.loadRelationOneApi(instance, relation, optionsGet);
                //--------------------------------------
                if (value !== undefined && instance[conversions.propertyToFill] !== value) {
                    instance[relation] = value._DB_id;
                    instance[conversions.propertyToFill] = value;
                }
                //--------------------------------------
            }
        }
        catch (error) {
            console.log(`[${instance.className()}] - fillWithRelationApi - Error: ${error}`);
            throw error;
        }
    }
    static async loadRelationManyApi(instance, relation, optionsGet) {
        try {
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(relation)) {
                throw `Relation not defined`;
            }
            //--------------------------------------
            const conversionFunctions = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getCombinedConversionFunctions */ .xSF)(instance.getStatic());
            if (conversionFunctions === undefined) {
                throw `conversionFunctions not found`;
            }
            //--------------------------------------
            const conversions = conversionFunctions.get(relation);
            if (conversions === undefined || conversions.relation === undefined) {
                throw `Relation: ${relation}  not found`;
            }
            //--------------------------------------
            const relatedClassType = conversions.typeRelation;
            //--------------------------------------
            let response;
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isEqual */ .Xyp)(optionsGet, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .optionsGetDefault */ .tA8)) {
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${instance.apiRoute()}/loadRelationMany/${instance._DB_id}/${relation}`);
            }
            else {
                const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)(optionsGet);
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${instance.apiRoute()}/loadRelationMany/${instance._DB_id}/${relation}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body,
                });
            }
            //--------------------------------------
            if (response.status === 200) {
                const datas = await response.json();
                console.log(`[${instance.className()}] - loadRelationManyApi - response OK`);
                const instances = datas.map((data) => relatedClassType.fromPlainObject(data));
                console.log(`[${instance.className()}] - loadRelationManyApi - len: ${instances.length}`);
                return instances;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${instance.className()}] - loadRelationManyApi - Error: ${error}`);
            throw error;
        }
    }
    static async loadRelationOneApi(instance, relation, optionsGet) {
        try {
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(relation)) {
                throw `relation not defined`;
            }
            //--------------------------------------
            const conversionFunctions = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getCombinedConversionFunctions */ .xSF)(instance.getStatic());
            if (conversionFunctions === undefined) {
                throw `conversionFunctions not found`;
            }
            //--------------------------------------
            const conversions = conversionFunctions.get(relation);
            if (conversions === undefined || conversions.relation === undefined) {
                throw `${relation} relation not found`;
            }
            //--------------------------------------
            const relatedClassType = conversions.typeRelation;
            //--------------------------------------
            let response;
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isEqual */ .Xyp)(optionsGet, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .optionsGetDefault */ .tA8)) {
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${instance.apiRoute()}/loadRelationOne/${instance._DB_id}/${relation}`);
            }
            else {
                const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)(optionsGet);
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${instance.apiRoute()}/loadRelationOne/${instance._DB_id}/${relation}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body,
                });
            }
            //--------------------------------------
            if (response.status === 200) {
                const datas = await response.json();
                console.log(`[${instance.className()}] - loadRelationOneApi - response OK`);
                const instance_ = relatedClassType.fromPlainObject(datas);
                console.log(`[${instance.className()}] - loadRelationOneApi - ${instance_.show()}`);
                return instance_;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${instance.className()}] - loadRelationManyApi - Error: ${error}`);
            throw error;
        }
    }
}
//# sourceMappingURL=Base.FrontEnd.Api.Calls.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 74617:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ BaseSmartDBFrontEndApiCalls; }
/* harmony export */ });
/* harmony import */ var _lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66527);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37813);
/* harmony import */ var _Entities_AddressToFollow_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17658);
/* harmony import */ var _Entities_Base_Base_SmartDB_Entity_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72083);
/* harmony import */ var _AddressToFollow_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14560);
/* harmony import */ var _Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4965);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_AddressToFollow_Entity_js__WEBPACK_IMPORTED_MODULE_2__, _Entities_Base_Base_SmartDB_Entity_js__WEBPACK_IMPORTED_MODULE_3__, _AddressToFollow_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__, _Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_5__]);
([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_AddressToFollow_Entity_js__WEBPACK_IMPORTED_MODULE_2__, _Entities_Base_Base_SmartDB_Entity_js__WEBPACK_IMPORTED_MODULE_3__, _AddressToFollow_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__, _Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_5__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);






// es generica, todos los metodos llevan instancia o entidad como parametro
// todas las clases la pueden usar
// pero si se setea uno por Entidad y se setea la entidad, tiene metodos especificos
// ofrece metodos igual que el base pero con _ para cuando es especifico
class BaseSmartDBFrontEndApiCalls extends _Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_5__/* .BaseFrontEndApiCalls */ .b {
    static { this._Entity = _Entities_Base_Base_SmartDB_Entity_js__WEBPACK_IMPORTED_MODULE_3__/* .BaseSmartDBEntity */ .t; }
    // #region api applied to entity
    static async getDeployedApi_(optionsGet) {
        return await this.getDeployedApi(this._Entity, optionsGet);
    }
    static async createHookApi_(address, CS, TN_Str) {
        return await this.createHookApi(this._Entity, address, CS, TN_Str);
    }
    static async syncWithAddressApi_(address, CS, force = false) {
        return await this.syncWithAddressApi(this._Entity, address, CS, force);
    }
    static async parseBlockchainAddressApi_(address, datumType, block) {
        return await this.parseBlockchainAddressApi(this._Entity, address, datumType, block);
    }
    // #endregion api applied to entity
    // #region api
    static async getDeployedApi(Entity, optionsGet) {
        try {
            let response;
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isEqual */ .Xyp)(optionsGet, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .optionsGetDefault */ .tA8)) {
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/deployed`);
            }
            else {
                const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)(optionsGet);
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/deployed`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body,
                });
            }
            if (response.status === 200) {
                const datas = await response.json();
                console.log(`[${Entity.className()}] - getDeployedApi - response OK`);
                const instances = datas.map((data) => Entity.fromPlainObject(data));
                console.log(`[${Entity.className()}] - getDeployedApi - len: ${instances.length}`);
                return instances;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${Entity.className()}] - getDeployedApi - Error: ${error}`);
            throw error;
        }
    }
    static async createHookApi(Entity, address, CS, TN_Str) {
        try {
            const addressesToFollow = await _AddressToFollow_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__/* .AddressToFollowFrontEndApiCalls.getByAddressApi */ .g.getByAddressApi(address, CS);
            if (addressesToFollow && addressesToFollow.length > 0) {
                // no quiero disparar error si ya existe
                // throw "Webhook already exists"
            }
            else {
                const addressToFollow = new _Entities_AddressToFollow_Entity_js__WEBPACK_IMPORTED_MODULE_2__/* .AddressToFollowEntity */ .R({
                    address,
                    CS,
                    TN_Str,
                    txCount: -1,
                    apiRouteToCall: Entity.apiRoute() + '/sync',
                    datumType: Entity.className(),
                });
                await _AddressToFollow_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__/* .AddressToFollowFrontEndApiCalls.createApi */ .g.createApi(addressToFollow);
            }
        }
        catch (error) {
            console.log(`[${Entity.className()}] - createHookApi - Error: ${error}`);
            throw error;
        }
    }
    static async syncWithAddressApi(Entity, address, CS, force = false) {
        try {
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(address)) {
                throw `address not defined`;
            }
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(CS)) {
                throw `CS not defined`;
            }
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ event: 'sync', force, tryCountAgain: false });
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/sync/${address}/${CS}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                console.log(`[${Entity.className()}] - syncWithAddressApi - address: ${address} - CS: ${CS} - response OK`);
                return true;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${Entity.className()}] - syncWithAddressApi - Error: ${error}`);
            throw error;
        }
    }
    static async parseBlockchainAddressApi(Entity, address, datumType, fromBlock, toBlock) {
        try {
            //-------------------------
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(address)) {
                throw `address not defined`;
            }
            //-------------------------
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ address, datumType, fromBlock, toBlock });
            //-------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${Entity.apiRoute()}/parse-blockchain-address`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            //-------------------------
            if (response.status === 202) {
                const data = await response.json();
                console.log(`[${Entity.className()}] - parseBlockchainAddressApi - jobId: ${data.jobId} - response OK`);
                return data.jobId;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        }
        catch (error) {
            console.log(`[${Entity.className()}] - parseBlockchainAddressApi - Error: ${error}`);
            throw error;
        }
    }
}
//# sourceMappingURL=Base.SmartDB.FrontEnd.Api.Calls.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 45658:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ BaseSmartDBFrontEndTxApiCalls; }
/* harmony export */ });
/* harmony import */ var _Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74617);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_0__]);
_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];

// es generica, todos los metodos llevan instancia o entidad como parametro
// todas las clases la pueden usar
class BaseSmartDBFrontEndTxApiCalls extends _Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_0__/* .BaseSmartDBFrontEndApiCalls */ .$ {
    // #region api applied to entity
    static async callGenericTxApi_(apiRoute, walletTxParams, txParams) {
        return await this.callGenericTxApi(this._Entity, apiRoute, walletTxParams, txParams);
    }
    // #endregion api applied to entity
    // #region api
    static async callGenericTxApi(Entity, txApiRoute, walletTxParams, txParams) {
        try {
            if (txParams === undefined) {
                throw `txParams not defined`;
            }
            const params = { walletTxParams, txParams };
            const data = await this.callGenericPOSTApi_('tx/' + txApiRoute, params);
            return data;
        }
        catch (error) {
            console.log(`[${Entity.apiRoute()}] - callTxApi - Error: ${error}`);
            throw error;
        }
    }
}
//# sourceMappingURL=Base.SmartDB.FrontEnd.Tx.Api.Calls.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 87692:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ EmulatorDBFrontEndApiCalls; }
/* harmony export */ });
/* harmony import */ var _lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66527);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37813);
/* harmony import */ var _Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87654);
/* harmony import */ var _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4965);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_2__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__]);
([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_2__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);




class EmulatorDBFrontEndApiCalls extends _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__/* .BaseFrontEndApiCalls */ .b {
    static { this._Entity = _Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_2__/* .EmulatorEntity */ .Z; }
    // #region api
    static async createInitEmulatorApi(name = 'Init', current = false) {
        try {
            //------------------
            const queryString = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .createQueryURLString */ .Soz)({ name, current });
            //------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/create-init${queryString}`);
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - createInitEmulatorApi - response OK`);
                const instance_ = this._Entity.fromPlainObject(data);
                console.log(`[${this._Entity.className()}] - createInitEmulatorApi - Instance: ${instance_.show()}`);
                return instance_;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - createInitEmulatorApi - Error: ${error}`);
            throw error;
        }
    }
}
//# sourceMappingURL=Emulator.FrontEnd.Api.Calls.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 92961:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ JobFrontEndApiCalls; }
/* harmony export */ });
/* harmony import */ var _Entities_Job_Entity_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1211);
/* harmony import */ var _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4965);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Entities_Job_Entity_js__WEBPACK_IMPORTED_MODULE_0__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_1__]);
([_Entities_Job_Entity_js__WEBPACK_IMPORTED_MODULE_0__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_1__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);


class JobFrontEndApiCalls extends _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_1__/* .BaseFrontEndApiCalls */ .b {
    static { this._Entity = _Entities_Job_Entity_js__WEBPACK_IMPORTED_MODULE_0__/* .JobEntity */ .s; }
}
//# sourceMappingURL=Job.FrontEnd.Api.Calls.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 35240:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PriceFrontEndApiCalls; }
/* harmony export */ });
/* harmony import */ var _lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66527);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37813);
/* harmony import */ var _Entities_Price_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96098);
/* harmony import */ var _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4965);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_Price_Entity_js__WEBPACK_IMPORTED_MODULE_2__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__]);
([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_Price_Entity_js__WEBPACK_IMPORTED_MODULE_2__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);




class PriceFrontEndApiCalls extends _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__/* .BaseFrontEndApiCalls */ .b {
    static { this._Entity = _Entities_Price_Entity_js__WEBPACK_IMPORTED_MODULE_2__/* .PriceEntity */ .m; }
    // #region api
    static async get_Token_PriceADAx1e6_Api(CS, TN_Hex, forceRefresh = false, validityMS, forceUseOracle = false) {
        try {
            //------------------
            if (CS === undefined || TN_Hex === undefined) {
                throw `CS or TN_Hex not defined`;
            }
            if (!(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isToken_CS_And_TN_Valid */ .V8b)(CS, TN_Hex)) {
                throw `CS or TN_Hex not valid`;
            }
            //------------------
            console.log(`[${this._Entity.className()}] - get_Token_PriceADAx1e6_Api - Init - Token: CS: ${CS} - TN_Str: ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(TN_Hex)}`);
            //------------------
            const isADA = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isTokenADA */ .Gre)(CS, TN_Hex);
            //------------------
            if (isADA) {
                const priceADAx1e6 = 1000000n;
                //----------------------------
                const token = { CS, TN_Hex, priceADAx1e6, date: undefined, signature: undefined };
                //----------------------------
                console.log(`[${this._Entity.className()}] - get_Token_PriceADAx1e6_Api - Token: CS: ${CS} - TN_Str: ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(TN_Hex)} - priceADAx1e6: ${priceADAx1e6} - response OK`);
                return token;
            }
            //------------------
            const queryString = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .createQueryURLString */ .Soz)({ CS, TN_Hex, forceRefresh, validityMS, forceUseOracle });
            //------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/get-priceADAx1e6${queryString}`);
            //------------------
            if (response.status === 200) {
                //-------------------------
                console.log(`[${this._Entity.apiRoute()}] - get_Token_PriceADAx1e6_Api - response OK`);
                //-------------------------
                const data = await response.json();
                //----------------------------
                const token = {
                    ...data,
                    priceADAx1e6: data.priceADAx1e6 !== undefined ? BigInt(data.priceADAx1e6) : undefined,
                    date: data.date !== undefined ? BigInt(data.date) : undefined,
                };
                //----------------------------
                console.log(`[${this._Entity.className()}] - get_Token_PriceADAx1e6_Api - Token: CS: ${CS} - TN_Str: ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(TN_Hex)} - priceADAx1e6: ${data.priceADAx1e6 !== undefined ? BigInt(data.priceADAx1e6) : undefined}`);
                return token;
            }
            else if (response.status === 404) {
                console.log(`[${this._Entity.className()}] - get_Token_PriceADAx1e6_Api - CS: ${CS} - TN_Str: ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(TN_Hex)} - Token PriceADAx1e6 not found`);
                return undefined;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - get_Token_PriceADAx1e6_Api - Error: ${error}`);
            throw error;
        }
    }
    static async get_Tokens_PriceADAx1e6_Api(tokens, forceRefresh = false, validityMS, forceUseOracle = false) {
        try {
            //----------------------------
            if (tokens.length === 0 || tokens.some((token) => token.CS === undefined || token.TN_Hex === undefined)) {
                throw `CS or TN_Hex not defined`;
            }
            if (!tokens.every((token) => (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isToken_CS_And_TN_Valid */ .V8b)(token.CS, token.TN_Hex))) {
                throw `CS or TN_Hex not valid`;
            }
            //------------------
            console.log(`[${this._Entity.className()}] - get_Tokens_PriceADAx1e6_Api - Init - Tokens: ${tokens?.map((t) => (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(t.TN_Hex)).join(', ')}`);
            //------------------
            // standarize ADA and remove duplicates in tokens list
            // tokens = tokens.map((token) => {
            //     if (isTokenADA(token.CS, token.TN_Hex)) {
            //         return { ...token, CS: '', TN_Hex: '' };
            //     }
            //     return token;
            // });
            //------------------
            tokens = tokens.filter((token, index) => tokens.findIndex((token_) => token_.CS === token.CS && token_.TN_Hex === token.TN_Hex) === index);
            //----------------------------
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ tokens, forceRefresh, validityMS, forceUseOracle });
            //-------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/get-pricesADAx1e6`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            //-------------------------
            if (response.status === 200) {
                //-------------------------
                console.log(`[${this._Entity.className()}] - get_Tokens_PriceADAx1e6_Api - response OK`);
                //-------------------------
                const data = await response.json(); // assuming `data` is an array of tokens
                // Format each token's data
                const tokensWithPrices = data.map((token) => ({
                    ...token,
                    priceADAx1e6: token.priceADAx1e6 !== undefined ? BigInt(token.priceADAx1e6) : undefined,
                    date: token.date !== undefined ? BigInt(token.date) : undefined,
                }));
                //-------------------------
                console.log(`[${this._Entity.className()}] - get_Tokens_PriceADAx1e6_Api - Tokens: ${tokensWithPrices
                    ?.map((t) => {
                    return `${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(t.TN_Hex)}: ${t.priceADAx1e6 !== undefined ? BigInt(t.priceADAx1e6) : undefined}`;
                })
                    .join(', ')}`);
                //-------------------------
                return tokensWithPrices;
                //-------------------------
            }
            else if (response.status === 404) {
                console.log(`[${this._Entity.className()}] - get_Tokens_PriceADAx1e6_Api - Tokens PriceADAx1e6 not found`);
                return [];
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - get_Tokens_PriceADAx1e6_Api - Error: ${error}`);
            throw error;
        }
    }
    static async set_Token_PriceADAx1e6_Api(CS, TN_Hex, priceADAx1e6) {
        try {
            if (CS === undefined || TN_Hex === undefined) {
                throw `CS or TN_Hex not defined`;
            }
            const isADA = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isTokenADA */ .Gre)(CS, TN_Hex);
            if (!(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isToken_CS_And_TN_Valid */ .V8b)(CS, TN_Hex)) {
                throw `CS or TN_Hex not valid`;
            }
            //------------------
            if (isADA) {
                const priceADAx1e6 = 1000000n;
                //----------------------------
                const token = { CS, TN_Hex, priceADAx1e6, date: undefined, signature: undefined };
                //----------------------------
                console.log(`[${this._Entity.className()}] - set_Token_PriceADAx1e6_Api - Token PriceADAx1e6: ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .showData */ .dMk)(token)} - response OK`);
                return token;
            }
            //-------------------------
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ CS, TN_Hex, priceADAx1e6 });
            //-------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/set-priceADAx1e6`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                //----------------------------
                const token = { ...data, priceADAx1e6: BigInt(data.priceADAx1e6), date: BigInt(data.date) };
                //----------------------------
                console.log(`[${this._Entity.className()}] - set_Token_PriceADAx1e6_Api - Token PriceADAx1e6: ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .showData */ .dMk)(token)}`);
                return token;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - set_Token_PriceADAx1e6_Api - Error: ${error}`);
            throw error;
        }
    }
}
//# sourceMappingURL=Price.FrontEnd.Api.Calls.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 84109:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ SiteSettingsFrontEndApiCalls; }
/* harmony export */ });
/* harmony import */ var _lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66527);
/* harmony import */ var _Entities_SiteSettings_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73387);
/* harmony import */ var _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4965);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Entities_SiteSettings_Entity_js__WEBPACK_IMPORTED_MODULE_1__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__]);
([_Entities_SiteSettings_Entity_js__WEBPACK_IMPORTED_MODULE_1__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);



class SiteSettingsFrontEndApiCalls extends _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__/* .BaseFrontEndApiCalls */ .b {
    static { this._Entity = _Entities_SiteSettings_Entity_js__WEBPACK_IMPORTED_MODULE_1__/* .SiteSettingsEntity */ .L; }
    // #region api
    static async createInitSiteSettingsApi(name = 'Init') {
        try {
            // tambien se crea en AuthBackEnd
            //-------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/create-init`);
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - createInitSiteSettingsApi - response OK`);
                const instance_ = this._Entity.fromPlainObject(data);
                console.log(`[${this._Entity.className()}] - createInitSiteSettingsApi - Instance: ${instance_.show()}`);
                return instance_;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - createInitSiteSettingsApi - Error: ${error}`);
            throw error;
        }
    }
    static async refreshServerSiteSettingsApi(name = 'Init') {
        try {
            // tambien se crea en AuthBackEnd
            //-------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/refresh-server`);
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - refreshSiteSettingsApi - response OK`);
                return data.result;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - refreshSiteSettingsApi - Error: ${error}`);
            throw error;
        }
    }
}
//# sourceMappingURL=SiteSettings.FrontEnd.Api.Calls.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 20342:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* unused harmony export SmartUTxOFrontEndApiCalls */
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37813);
/* harmony import */ var _Entities_SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94093);
/* harmony import */ var _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4965);
/* harmony import */ var _lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66527);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__, _Entities_SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_1__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__]);
([_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__, _Entities_SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_1__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);




class SmartUTxOFrontEndApiCalls extends (/* unused pure expression or super */ null && (BaseFrontEndApiCalls)) {
    static { this._Entity = _Entities_SmartUTxO_Entity_js__WEBPACK_IMPORTED_MODULE_1__/* .SmartUTxOEntity */ .U; }
    // #region api
    static async getByAddressApi(address, optionsGet) {
        try {
            if (isNullOrBlank(address)) {
                throw `address not defined`;
            }
            //------------------
            let response;
            if (isEqual(optionsGet, optionsGetDefault)) {
                response = await fetchWrapper(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/by-address/${address}`);
            }
            else {
                const body = toJson(optionsGet);
                response = await fetchWrapper(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/by-address/${address}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body,
                });
            }
            //------------------
            if (response.status === 200) {
                const datas = await response.json();
                console.log(`[${this._Entity.className()}] - getByAddressApi - response OK`);
                const instances = datas.map((data) => this._Entity.fromPlainObject(data));
                console.log(`[${this._Entity.className()}] - getByAddressApi - address: ${address} - len: ${instances.length}`);
                return instances;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - getByAddressApi - Error: ${error}`);
            throw error;
        }
    }
    static async getByTxHashAndOutputIndexApi(txHash, outputIndex, optionsGet) {
        try {
            if (txHash === undefined || txHash === '' || outputIndex === undefined || outputIndex < 0) {
                throw `txHash or outputIndex not defined`;
            }
            //-------------------------
            let response;
            if (isEqual(optionsGet, optionsGetOneDefault)) {
                response = await fetchWrapper(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/by-txhash-idx/${txHash}/${outputIndex}`);
            }
            else {
                const body = toJson(optionsGet);
                //-------------------------
                response = await fetchWrapper(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/by-txhash-idx/${txHash}/${outputIndex}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body,
                });
            }
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - getByTxHashAndOutputIndexApi - response OK`);
                const instance = this._Entity.fromPlainObject(data);
                console.log(`[${this._Entity.className()}] - getByTxHashAndOutputIndexApi - tx: ${formatUTxO(txHash, outputIndex)} - Instance: ${instance.show()}`);
                return instance;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - getByTxHashAndOutputIndexApi - Error: ${error}`);
            throw error;
        }
    }
}
//# sourceMappingURL=SmartUTxO.FrontEnd.Api.Calls.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 54417:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* unused harmony export SmartUTxOWithDetailsFrontEndApiCalls */
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37813);
/* harmony import */ var _Entities_SmartUTxO_WithDetails_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22797);
/* harmony import */ var _SmartUTxO_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20342);
/* harmony import */ var _Token_Metadata_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13803);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__, _Entities_SmartUTxO_WithDetails_Entity_js__WEBPACK_IMPORTED_MODULE_1__, _SmartUTxO_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__, _Token_Metadata_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__]);
([_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__, _Entities_SmartUTxO_WithDetails_Entity_js__WEBPACK_IMPORTED_MODULE_1__, _SmartUTxO_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__, _Token_Metadata_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);




class SmartUTxOWithDetailsFrontEndApiCalls extends (/* unused pure expression or super */ null && (SmartUTxOFrontEndApiCalls)) {
    static { this._Entity = _Entities_SmartUTxO_WithDetails_Entity_js__WEBPACK_IMPORTED_MODULE_1__/* .SmartUTxOWithDetailsEntity */ ._; }
    // #region api
    static async loadMetadataApi(instance) {
        const assets = instance.assets;
        const assetsWithDetails = [];
        for (const [key, value] of Object.entries(assets)) {
            const [CS, TN_Hex] = splitTokenLucidKey(key);
            const tokenMetadata = await TokenMetadataFrontEndApiCalls.get_Token_MetadataApi(CS, TN_Hex);
            const assetDetails = {
                CS,
                TN_Hex,
                amount: value,
                ticker: tokenMetadata?.ticker,
                decimals: tokenMetadata?.decimals,
                image: tokenMetadata?.image,
                colorHex: tokenMetadata?.colorHex,
                metadata_raw: tokenMetadata?.metadata_raw,
            };
            assetsWithDetails.push(assetDetails);
        }
        instance.assetsWithDetails = assetsWithDetails;
    }
}
//# sourceMappingURL=SmartUTxO.WithDetails.FrontEnd.Api.Calls.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 13803:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ TokenMetadataFrontEndApiCalls; }
/* harmony export */ });
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37813);
/* harmony import */ var _Entities_Token_Metadata_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73753);
/* harmony import */ var _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4965);
/* harmony import */ var _lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66527);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__, _Entities_Token_Metadata_Entity_js__WEBPACK_IMPORTED_MODULE_1__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__]);
([_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__, _Entities_Token_Metadata_Entity_js__WEBPACK_IMPORTED_MODULE_1__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);




class TokenMetadataFrontEndApiCalls extends _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__/* .BaseFrontEndApiCalls */ .b {
    static { this._Entity = _Entities_Token_Metadata_Entity_js__WEBPACK_IMPORTED_MODULE_1__/* .TokenMetadataEntity */ .Q; }
    // #region api
    static async getAssetsWithDetailsApi(assets) {
        //-------------------------
        const tokensMetadata = await this.get_Tokens_MetadataApi(Object.entries(assets).map(([key, value]) => {
            const [CS, TN_Hex] = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .splitTokenLucidKey */ .Wkp)(key);
            return { CS, TN_Hex };
        }), undefined, true, _Entities_Token_Metadata_Entity_js__WEBPACK_IMPORTED_MODULE_1__/* .TokenMetadataEntity.optionsGetForTokenStore */ .Q.optionsGetForTokenStore);
        const assetsWithDetails = [];
        for (const [key, value] of Object.entries(assets)) {
            const [CS, TN_Hex] = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .splitTokenLucidKey */ .Wkp)(key);
            const tokenMetadata = tokensMetadata.find((token) => token.CS === CS && token.TN_Hex === TN_Hex);
            const assetDetails = {
                CS: CS,
                TN_Hex,
                amount: value,
                ticker: tokenMetadata?.ticker,
                decimals: tokenMetadata?.decimals,
                image: tokenMetadata?.image,
                colorHex: tokenMetadata?.colorHex,
                metadata_raw: tokenMetadata?.metadata_raw,
            };
            assetsWithDetails.push(assetDetails);
        }
        return assetsWithDetails;
    }
    static async get_Token_MetadataApi(CS, TN_Hex, forceRefresh = false, swCreateMetadataWhenNotFound = true, optionsGet) {
        //-------------------------
        try {
            if (CS === undefined || TN_Hex === undefined) {
                throw `CS or TN_Hex not defined`;
            }
            if (!(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isToken_CS_And_TN_Valid */ .V8b)(CS, TN_Hex)) {
                throw `CS or TN_Hex not valid`;
            }
            //------------------
            console.log(`[${this._Entity.className()}] - get_Token_MetadataApi - Init - Token: CS: ${CS} - TN_Hex: ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .hexToStr */ .NdO)(TN_Hex)}`);
            //------------------
            const queryString = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .createQueryURLString */ .Soz)({ CS, TN_Hex, forceRefresh, swCreateMetadataWhenNotFound });
            //------------------
            let response;
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isEqual */ .Xyp)(optionsGet, _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .optionsGetDefault */ .tA8)) {
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/metadata-by-Token${queryString}`);
            }
            else {
                const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .toJson */ .QsJ)(optionsGet);
                response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/metadata-by-Token${queryString}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body,
                });
            }
            //------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - get_Token_MetadataApi - CS: ${CS} - TN_Hex: ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .hexToStr */ .NdO)(TN_Hex)} - response OK`);
                const instance = _Entities_Token_Metadata_Entity_js__WEBPACK_IMPORTED_MODULE_1__/* .TokenMetadataEntity.fromPlainObject */ .Q.fromPlainObject(data);
                console.log(`[${this._Entity.className()}] - get_Token_MetadataApi - CS: ${CS} - TN_Hex: ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .hexToStr */ .NdO)(TN_Hex)} - Instance: ${instance.show()}`);
                return instance;
            }
            else if (response.status === 404) {
                console.log(`[${this._Entity.className()}] - get_Token_MetadataApi - CS: ${CS} - TN_Hex: ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .hexToStr */ .NdO)(TN_Hex)} - Token Metadata not found`);
                return undefined;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - get_Token_MetadataApi - Error: ${error}`);
            throw error;
        }
    }
    static async get_Tokens_MetadataApi(tokens, forceRefresh = false, swCreateMetadataWhenNotFound = true, optionsGet) {
        //-------------------------
        try {
            //----------------------------
            if (tokens.length === 0 || tokens.some((token) => token.CS === undefined || token.TN_Hex === undefined)) {
                throw `CS or TN_Hex not defined`;
            }
            if (!tokens.every((token) => (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isToken_CS_And_TN_Valid */ .V8b)(token.CS, token.TN_Hex))) {
                throw `CS or TN_Hex not valid`;
            }
            //------------------
            console.log(`[${this._Entity.className()}] - get_Tokens_MetadataApi - Init - Tokens: ${tokens?.map((t) => (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .hexToStr */ .NdO)(t.TN_Hex)).join(', ')}`);
            //------------------
            // standarize ADA and remove duplicates in tokens list
            // tokens = tokens.map((token) => {
            //     if (isTokenADA(token.CS, token.TN_Hex)) {
            //         return { ...token, CS: '', TN_Hex: '' };
            //     }
            //     return token;
            // });
            tokens = tokens.filter((token, index) => tokens.findIndex((token_) => token_.CS === token.CS && token_.TN_Hex === token.TN_Hex) === index);
            //----------------------------
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .toJson */ .QsJ)({ tokens, forceRefresh, swCreateMetadataWhenNotFound, optionsGet });
            //-------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/metadata-by-Tokens`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            //-------------------------
            if (response.status === 200) {
                const datas = await response.json();
                console.log(`[${this._Entity.className()}] - get_Tokens_MetadataApi - response OK`);
                const instances = datas.map((data) => _Entities_Token_Metadata_Entity_js__WEBPACK_IMPORTED_MODULE_1__/* .TokenMetadataEntity.fromPlainObject */ .Q.fromPlainObject(data));
                console.log(`[${this._Entity.className()}] - get_Tokens_MetadataApi - len: ${instances.length}`);
                //-------------------------
                console.log(`[${this._Entity.className()}] - get_Tokens_MetadataApi - Tokens: ${instances
                    ?.map((t) => {
                    return `${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__/* .hexToStr */ .NdO)(t.TN_Hex)}: ${t.decimals}`;
                })
                    .join(', ')}`);
                //-------------------------
                return instances;
            }
            else if (response.status === 404) {
                console.log(`[${this._Entity.className()}] - get_Tokens_MetadataApi - Tokens Metadata not found`);
                return [];
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - get_Tokens_MetadataApi - Error: ${error}`);
            throw error;
        }
    }
}
//# sourceMappingURL=Token.Metadata.FrontEnd.Api.Calls.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 21309:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ TransactionFrontEndApiCalls; }
/* harmony export */ });
/* harmony import */ var _lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66527);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37813);
/* harmony import */ var _Entities_Transaction_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32519);
/* harmony import */ var _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4965);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_Transaction_Entity_js__WEBPACK_IMPORTED_MODULE_2__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__]);
([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_Transaction_Entity_js__WEBPACK_IMPORTED_MODULE_2__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);




class TransactionFrontEndApiCalls extends _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__/* .BaseFrontEndApiCalls */ .b {
    static { this._Entity = _Entities_Transaction_Entity_js__WEBPACK_IMPORTED_MODULE_2__/* .TransactionEntity */ .e; }
    // #region api
    static async updateCanceledTransactionApi(txHash, error) {
        try {
            //-------------------------
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(txHash)) {
                throw `txHash not defined`;
            }
            //------------------
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ error });
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/update-canceled-transaction/${txHash}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            //------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - updateCanceledTransactionApi - isStarted: ${data.isUpdated} - response OK`);
                return data.isUpdated;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - updateCanceledTransactionApi - Error: ${error}`);
            throw error;
        }
    }
    static async updateFailedTransactionApi(txHash, error) {
        try {
            //-------------------------
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(txHash)) {
                throw `txHash not defined`;
            }
            //------------------
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ error });
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/update-failed-transaction/${txHash}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            //------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - updateFailedTransactionApi - isStarted: ${data.isUpdated} - response OK`);
                return data.isUpdated;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - updateFailedTransactionApi - Error: ${error}`);
            throw error;
        }
    }
    static async beginStatusUpdaterJobApi(swCheckAgainTxTimeOut = false, swCheckAgainTxPendingTimeOut = false, swCheckAgainTxFailed = false) {
        try {
            //------------------
            const queryString = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .createQueryURLString */ .Soz)({ swCheckAgainTxTimeOut, swCheckAgainTxPendingTimeOut, swCheckAgainTxFailed });
            //------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/begin-status-updater${queryString}`);
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - beginStatusUpdaterJobApi - isStarted: ${data.isStarted} - response OK`);
                return data.isStarted;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - beginStatusUpdaterJobApi - Error: ${error}`);
            throw error;
        }
    }
    static async submitAndBeginStatusUpdaterJobApi(txHash) {
        try {
            //-------------------------
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(txHash)) {
                throw `txHash not defined`;
            }
            //-------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/submit-and-begin-status-updater/${txHash}`);
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - transactionSubmitAndStatusUpdaterJobApi - isStarted: ${data.isStarted} - response OK`);
                return data.isStarted;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - transactionSubmitAndStatusUpdaterJobApi - Error: ${error}`);
            throw error;
        }
    }
    static async transactionStatusUpdaterApi(txHash) {
        try {
            //-------------------------
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(txHash)) {
                throw `txHash not defined`;
            }
            //-------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/status-updater/${txHash}`);
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - transactionStatusUpdaterApi - isUpdated: ${data.isUpdated} - response OK`);
                return data.isUpdated;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - transactionStatusUpdaterApi - Error: ${error}`);
            throw error;
        }
    }
    static async getTransactionStatusApi(txHash) {
        try {
            //-------------------------
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(txHash)) {
                throw `txHash not defined`;
            }
            //-------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/get-status/${txHash}`);
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - getTransactionStatusApi - txStatus: ${data.txStatus} - response OK`);
                return data.txStatus;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - getTransactionStatusApi - Error: ${error}`);
            throw error;
        }
    }
    static async releaseUTxOsApi(txHash, swReleaseIsPreparing = true, swReleaseIsConsuming = true) {
        try {
            //-------------------------
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(txHash)) {
                throw `txHash not defined`;
            }
            //-------------------------
            const body = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)({ swReleaseIsPreparing, swReleaseIsConsuming });
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/release-utxos/${txHash}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - releaseUTxOsApi - result: ${data.result} - response OK`);
                return data.result;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - releaseUTxOsApi - Error: ${error}`);
            throw error;
        }
    }
}
//# sourceMappingURL=Transaction.FrontEnd.Api.Calls.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 39078:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ WalletFrontEndApiCalls; }
/* harmony export */ });
/* harmony import */ var _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4965);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37813);
/* harmony import */ var _Entities_Wallet_Entity_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15068);
/* harmony import */ var _lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66527);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_0__, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_Wallet_Entity_js__WEBPACK_IMPORTED_MODULE_2__]);
([_Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_0__, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_Wallet_Entity_js__WEBPACK_IMPORTED_MODULE_2__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);




class WalletFrontEndApiCalls extends _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_0__/* .BaseFrontEndApiCalls */ .b {
    static { this._Entity = _Entities_Wallet_Entity_js__WEBPACK_IMPORTED_MODULE_2__/* .WalletEntity */ .C; }
    // #region api
    static async isCoreTeamApi(pkh) {
        try {
            //-------------------------
            if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrBlank */ .Xy7)(pkh)) {
                throw `pkh not defined`;
            }
            //-------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/${this._Entity.apiRoute()}/is-core-team/${pkh}`);
            //-------------------------
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.className()}] - isCoreTeamApi - pkh: ${pkh} - isCoreTeam: ${data.isCoreTeam} - response OK`);
                return data.isCoreTeam;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //-------------------------
        }
        catch (error) {
            console.log(`[${this._Entity.className()}] - isCoreTeamApi - Error: ${error}`);
            throw error;
        }
    }
}
//# sourceMappingURL=Wallet.FrontEnd.Api.Calls.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 70601:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GG": function() { return /* reexport safe */ _Wallet_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_12__.G; },
/* harmony export */   "GI": function() { return /* reexport safe */ _Price_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_6__.G; },
/* harmony export */   "Gx": function() { return /* reexport safe */ _Token_Metadata_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_10__.G; },
/* harmony export */   "TH": function() { return /* reexport safe */ _Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_11__.T; },
/* harmony export */   "cu": function() { return /* reexport safe */ _Emulator_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__.c; },
/* harmony export */   "jl": function() { return /* reexport safe */ _Base_Base_SmartDB_FrontEnd_Tx_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__.j; },
/* harmony export */   "wy": function() { return /* reexport safe */ _SiteSettings_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_7__.w; }
/* harmony export */ });
/* harmony import */ var _AddressToFollow_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14560);
/* harmony import */ var _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4965);
/* harmony import */ var _Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74617);
/* harmony import */ var _Base_Base_SmartDB_FrontEnd_Tx_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45658);
/* harmony import */ var _Emulator_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87692);
/* harmony import */ var _Job_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92961);
/* harmony import */ var _Price_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35240);
/* harmony import */ var _SiteSettings_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84109);
/* harmony import */ var _SmartUTxO_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20342);
/* harmony import */ var _SmartUTxO_WithDetails_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54417);
/* harmony import */ var _Token_Metadata_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13803);
/* harmony import */ var _Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21309);
/* harmony import */ var _Wallet_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(39078);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_AddressToFollow_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_0__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_1__, _Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__, _Base_Base_SmartDB_FrontEnd_Tx_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__, _Emulator_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__, _Job_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_5__, _Price_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_6__, _SiteSettings_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_7__, _SmartUTxO_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_8__, _SmartUTxO_WithDetails_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_9__, _Token_Metadata_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_10__, _Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_11__, _Wallet_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_12__]);
([_AddressToFollow_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_0__, _Base_Base_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_1__, _Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__, _Base_Base_SmartDB_FrontEnd_Tx_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__, _Emulator_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__, _Job_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_5__, _Price_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_6__, _SiteSettings_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_7__, _SmartUTxO_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_8__, _SmartUTxO_WithDetails_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_9__, _Token_Metadata_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_10__, _Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_11__, _Wallet_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_12__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);













//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 338:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ BaseSmartDBFrontEndBtnHandlers; }
/* harmony export */ });
/* harmony import */ var _Commons_explainError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73582);
/* harmony import */ var _Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31647);
/* harmony import */ var _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36142);
/* harmony import */ var _ApiCalls_AddressToFollow_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14560);
/* harmony import */ var _ApiCalls_Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74617);
/* harmony import */ var _lib_JobManager_JobManager_FrontEnd_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87370);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37813);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__, _ApiCalls_AddressToFollow_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__, _ApiCalls_Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__, _lib_JobManager_JobManager_FrontEnd_js__WEBPACK_IMPORTED_MODULE_5__, _Commons_index_js__WEBPACK_IMPORTED_MODULE_6__]);
([_lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__, _ApiCalls_AddressToFollow_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__, _ApiCalls_Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__, _lib_JobManager_JobManager_FrontEnd_js__WEBPACK_IMPORTED_MODULE_5__, _Commons_index_js__WEBPACK_IMPORTED_MODULE_6__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
// es generica, todos los metodos llevan instancia o entidad como parametro







// todas las clases la pueden usar
class BaseSmartDBFrontEndBtnHandlers {
    // protected static _Entity = BaseSmartDBEntity;
    // #region front end Btn handlers
    static async handleBtnCreateHook(instance) {
        try {
            const addressesToFollow = await _ApiCalls_AddressToFollow_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_3__/* .AddressToFollowFrontEndApiCalls.getByAddressApi */ .g.getByAddressApi(instance.getNet_Address(), instance.getNET_id_CS());
            if (addressesToFollow && addressesToFollow.length > 0) {
                throw `Webhook already exists for this address: ${instance.getNet_Address()} and CS: ${instance.getNET_id_CS()}`;
            }
            else {
                await _ApiCalls_Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__/* .BaseSmartDBFrontEndApiCalls.createHookApi */ .$.createHookApi(instance.getStatic(), instance.getNet_Address(), instance.getNET_id_CS());
                (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushSucessNotification */ .o)(`${instance.className()}`, `Webhook created`, false);
                return true;
            }
        }
        catch (error) {
            console.log(`[${instance.className()}] - handleBtnCreateHook - Error: ${error}`);
            (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushWarningNotification */ .M)(`${instance.className()}`, `Error creating webhook: ${error}`);
            return false;
        }
    }
    static async handleBtnSync(instance, force = false) {
        try {
            await _ApiCalls_Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__/* .BaseSmartDBFrontEndApiCalls.syncWithAddressApi */ .$.syncWithAddressApi(instance.getStatic(), instance.getNet_Address(), instance.getNET_id_CS(), force);
            (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushSucessNotification */ .o)(`${instance.className()}`, `${instance.className()} syncronized`, false);
            return true;
        }
        catch (error) {
            console.log(`[${instance.className()}] - handleBtnSync - Error: ${error}`);
            (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushWarningNotification */ .M)(`${instance.className()}`, `Error syncronizing ${instance.className()}: ${error}`);
            return false;
        }
    }
    // NOTE: esta version es la primera que hice, funciona, pero en las otras cambie el orden de los parametros asi puedo hacer binds con sentido
    static async handleBtnDoTransaction_V1(Entity, name, nameTx, setProcessingTxMessage, setProcessingTxHash, walletStore, txParams, apiTxCall) {
        try {
            //--------------------------------------
            setProcessingTxMessage(name + '...');
            //--------------------------------------
            const { lucid, emulatorDB, walletTxParams } = await _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .LucidToolsFrontEnd.prepareLucidFrontEndForTx */ .f.prepareLucidFrontEndForTx(walletStore);
            //--------------------------------------
            const { txCborHex } = await apiTxCall(walletTxParams, txParams);
            //--------------------------------------
            setProcessingTxMessage('Transaction prepared, waiting for sign to submit...');
            //--------------------------------------
            const txHash = await _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .LucidToolsFrontEnd.signAndSubmitTx */ .f.signAndSubmitTx(lucid, txCborHex, walletStore.info, emulatorDB, walletStore.swDoNotPromtForSigning);
            //--------------------------------------
            setProcessingTxMessage(`Transaction submitted, waiting for confirmation...`);
            setProcessingTxHash(txHash);
            //--------------------------------------
            if (await _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .LucidToolsFrontEnd.awaitTx */ .f.awaitTx(lucid, txHash)) {
                console.log(`${Entity.className()}] - handleBtnTx - waitForTxConfirmation - Tx confirmed - ${txHash}`);
                (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushSucessNotification */ .o)(`${Entity.className()} ${nameTx}`, txHash, true);
            }
            else {
                console.log(`${Entity.className()}] - handleBtnTx - waitForTxConfirmation - Tx not confirmed - ${txHash}`);
                throw `Tx not confirmed`;
            }
            //--------------------------------------
            setProcessingTxMessage(`Syncronizing...`);
            //--------------------------------------
            setProcessingTxMessage(`Refreshing data...`);
            await walletStore.loadWalletData();
            //--------------------------------------
            setProcessingTxMessage(``);
            return true;
        }
        catch (error) {
            const error_explained = (0,_Commons_explainError_js__WEBPACK_IMPORTED_MODULE_0__/* .explainErrorTx */ .u)(error);
            console.log(`[${Entity.className()}] - handleBtnTx - Error: ${error_explained}`);
            (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushWarningNotification */ .M)(`${Entity.className()} ${nameTx}`, error_explained);
            setProcessingTxMessage(error_explained);
            return false;
        }
    }
    static async handleBtnDoTransaction_V2(Entity, modalTitleTx, messageActionTx, lucid, emulatorDB, apiTxCall, setProcessingTxMessage, setProcessingTxHash, walletStore) {
        try {
            //--------------------------------------
            setProcessingTxMessage(messageActionTx);
            //--------------------------------------
            const { txCborHex } = await apiTxCall();
            //--------------------------------------
            let txComplete = lucid.fromTx(txCborHex);
            let txHash = txComplete.toHash();
            setProcessingTxHash(txHash);
            //--------------------------------------
            setProcessingTxMessage('Transaction prepared, waiting for sign to submit...');
            //--------------------------------------
            txHash = await _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .LucidToolsFrontEnd.signAndSubmitTx */ .f.signAndSubmitTx(lucid, txCborHex, walletStore.info, emulatorDB, walletStore.swDoNotPromtForSigning);
            //--------------------------------------
            setProcessingTxMessage(`Transaction submitted, waiting for confirmation...`);
            setProcessingTxHash(txHash);
            //--------------------------------------
            if (await _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .LucidToolsFrontEnd.awaitTx */ .f.awaitTx(lucid, txHash)) {
                console.log(`${Entity.className()}] - handleBtnTx - waitForTxConfirmation - Tx confirmed - ${txHash}`);
                (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushSucessNotification */ .o)(`${Entity.className()} ${modalTitleTx}`, txHash, true);
            }
            else {
                console.log(`${Entity.className()}] - handleBtnTx - waitForTxConfirmation - Tx not confirmed - ${txHash}`);
                throw `Tx not confirmed`;
            }
            //--------------------------------------
            setProcessingTxMessage(`Syncronizing...`);
            //--------------------------------------
            setProcessingTxMessage(`Refreshing data ...`);
            await walletStore.loadWalletData();
            //--------------------------------------
            setProcessingTxMessage(``);
            return true;
        }
        catch (error) {
            const error_explained = (0,_Commons_explainError_js__WEBPACK_IMPORTED_MODULE_0__/* .explainErrorTx */ .u)(error);
            console.log(`[${Entity.className()}] - handleBtnTx - Error: ${error_explained}`);
            (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushWarningNotification */ .M)(`${Entity.className()} ${modalTitleTx}`, error_explained);
            setProcessingTxMessage(error_explained);
            return false;
        }
    }
    // NOTE: esta version no maneja errores aca, si no que los delega a handleBtnDoTransactionExtended de useTransaction hook
    static async handleBtnDoTransaction_V2_NoErrorControl(Entity, modalTitleTx, messageActionTx, lucid, emulatorDB, apiTxCall, setProcessingTxMessage, setProcessingTxHash, walletStore) {
        //--------------------------------------
        setProcessingTxMessage(messageActionTx);
        //--------------------------------------
        const { txCborHex } = await apiTxCall();
        //--------------------------------------
        let txComplete = lucid.fromTx(txCborHex);
        let txHash = txComplete.toHash();
        setProcessingTxHash(txHash);
        //--------------------------------------
        setProcessingTxMessage('Transaction prepared, waiting for sign to submit...');
        //--------------------------------------
        txHash = await _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .LucidToolsFrontEnd.signAndSubmitTx */ .f.signAndSubmitTx(lucid, txCborHex, walletStore.info, emulatorDB, walletStore.swDoNotPromtForSigning);
        //--------------------------------------
        setProcessingTxMessage(`Transaction submitted, waiting for confirmation...`);
        //--------------------------------------
        if (await _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .LucidToolsFrontEnd.awaitTx */ .f.awaitTx(lucid, txHash)) {
            console.log(`${Entity.className()}] - handleBtnTx - waitForTxConfirmation - Tx confirmed - ${txHash}`);
            (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushSucessNotification */ .o)(`${Entity.className()} ${modalTitleTx}`, txHash, true);
        }
        else {
            console.log(`${Entity.className()}] - handleBtnTx - waitForTxConfirmation - Tx not confirmed - ${txHash}`);
            throw `Tx not confirmed`;
        }
        //--------------------------------------
        setProcessingTxMessage(`Syncronizing...`);
        //--------------------------------------
        setProcessingTxMessage(`Refreshing data ...`);
        await walletStore.loadWalletData();
        //--------------------------------------
        setProcessingTxMessage(``);
    }
    static async handleBtnParseBlockchain(Entity, setProcessingMessage, addressesToProcess, fromBlock, toBlock) {
        //--------------------------------------
        try {
            //--------------------------------------
            setProcessingMessage('Parsing Blockchain...');
            //--------------------------------------
            let result = true;
            //--------------------------------------
            for (let index = 0; index < addressesToProcess.length; index++) {
                //--------------------------------------
                const address = addressesToProcess[index].address;
                //--------------------------------------
                console.log(`${Entity.className()} - handleBtnParseBlockchain - Parsing ${addressesToProcess[index].datumType}'s Address: ${address}`);
                //--------------------------------------
                const addressMsg = `Address (${index + 1}/${addressesToProcess.length}): Parsing ${addressesToProcess[index].datumType}'s Address: ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_6__/* .formatAddress */ .TgP)(address)}`;
                setProcessingMessage(`${addressMsg}...`);
                //--------------------------------------
                try {
                    //--------------------------------------
                    const jobId = await _ApiCalls_Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__/* .BaseSmartDBFrontEndApiCalls.parseBlockchainAddressApi */ .$.parseBlockchainAddressApi(Entity, address, addressesToProcess[index].datumType, fromBlock, toBlock);
                    console.log(`[${Entity.className()}] - handleBtnParseBlockchain - jobId: ${jobId}`);
                    //--------------------------------------
                    const { jobPromise } = _lib_JobManager_JobManager_FrontEnd_js__WEBPACK_IMPORTED_MODULE_5__/* .JobManagerFrontEnd.startMonitoringJob */ .P.startMonitoringJob(jobId, setProcessingMessage, addressMsg);
                    //--------------------------------------
                    const job = await jobPromise; // Await the job's completion
                    //--------------------------------------
                    if (job.status === 'completed') {
                        // await JobManagerFrontEnd.removeJob(jobId);
                        const successMessage = job.message || `Parse ${addressesToProcess[index].datumType}'s Address OK`;
                        (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushSucessNotification */ .o)(`${Entity.className()}`, successMessage, false);
                        result = result && true;
                    }
                    else if (job.status === 'failed') {
                        // await JobManagerFrontEnd.removeJob(jobId);
                        const errorMessage = job.error || `Parse ${addressesToProcess[index].datumType}'s Address Error: ${job.message}`;
                        (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushWarningNotification */ .M)(`${Entity.className()}`, errorMessage);
                        setProcessingMessage(errorMessage);
                        return false;
                    }
                    else if (job.status === 'canceled') {
                        // await JobManagerFrontEnd.removeJob(jobId);
                        const errorMessage = job.error || `Parse ${addressesToProcess[index].datumType}'s Address Canceled`;
                        (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushWarningNotification */ .M)(`${Entity.className()}`, errorMessage);
                        setProcessingMessage(errorMessage);
                        return false;
                    }
                }
                catch (error) {
                    const error_explained = (0,_Commons_explainError_js__WEBPACK_IMPORTED_MODULE_0__/* .explainErrorTx */ .u)(error);
                    console.log(`[${Entity.className()}] - handleBtnParseBlockchain - Error: ${error_explained}`);
                    (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushWarningNotification */ .M)(`${Entity.className()}`, `Parse ${addressesToProcess[index].datumType}'s Address Error`);
                    return false;
                }
            }
            //--------------------------------------
            return result;
            //--------------------------------------
        }
        catch (error) {
            const error_explained = (0,_Commons_explainError_js__WEBPACK_IMPORTED_MODULE_0__/* .explainErrorTx */ .u)(error);
            console.log(`[${Entity.className()}] - handleBtnParseBlockchain - Error: ${error_explained}`);
            (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_1__/* .pushWarningNotification */ .M)(`${Entity.className()} Parse Blockchain`, error_explained);
            setProcessingMessage(error_explained);
            return false;
        }
    }
}
//# sourceMappingURL=Base.SmartDB.FrontEnd.Btn.Handlers.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 98479:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* reexport safe */ _Base_Base_SmartDB_FrontEnd_Btn_Handlers_js__WEBPACK_IMPORTED_MODULE_0__.c; }
/* harmony export */ });
/* harmony import */ var _Base_Base_SmartDB_FrontEnd_Btn_Handlers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(338);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Base_Base_SmartDB_FrontEnd_Btn_Handlers_js__WEBPACK_IMPORTED_MODULE_0__]);
_Base_Base_SmartDB_FrontEnd_Btn_Handlers_js__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];

//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 25995:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GG": function() { return /* reexport safe */ _ApiCalls_index_js__WEBPACK_IMPORTED_MODULE_0__.GG; },
/* harmony export */   "GI": function() { return /* reexport safe */ _ApiCalls_index_js__WEBPACK_IMPORTED_MODULE_0__.GI; },
/* harmony export */   "Gx": function() { return /* reexport safe */ _ApiCalls_index_js__WEBPACK_IMPORTED_MODULE_0__.Gx; },
/* harmony export */   "TH": function() { return /* reexport safe */ _ApiCalls_index_js__WEBPACK_IMPORTED_MODULE_0__.TH; },
/* harmony export */   "cr": function() { return /* reexport safe */ _BtnHandlers_index_js__WEBPACK_IMPORTED_MODULE_1__.c; },
/* harmony export */   "cu": function() { return /* reexport safe */ _ApiCalls_index_js__WEBPACK_IMPORTED_MODULE_0__.cu; },
/* harmony export */   "jl": function() { return /* reexport safe */ _ApiCalls_index_js__WEBPACK_IMPORTED_MODULE_0__.jl; },
/* harmony export */   "wy": function() { return /* reexport safe */ _ApiCalls_index_js__WEBPACK_IMPORTED_MODULE_0__.wy; }
/* harmony export */ });
/* harmony import */ var _ApiCalls_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70601);
/* harmony import */ var _BtnHandlers_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98479);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_ApiCalls_index_js__WEBPACK_IMPORTED_MODULE_0__, _BtnHandlers_index_js__WEBPACK_IMPORTED_MODULE_1__]);
([_ApiCalls_index_js__WEBPACK_IMPORTED_MODULE_0__, _BtnHandlers_index_js__WEBPACK_IMPORTED_MODULE_1__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);


//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 81389:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _useWalletActions_js__WEBPACK_IMPORTED_MODULE_4__.Z; },
/* harmony export */   "lT": function() { return /* reexport safe */ _useWalletActions_js__WEBPACK_IMPORTED_MODULE_4__.l; },
/* harmony export */   "nC": function() { return /* reexport safe */ _useTransactions_js__WEBPACK_IMPORTED_MODULE_6__.n; },
/* harmony export */   "sm": function() { return /* reexport safe */ _useList_js__WEBPACK_IMPORTED_MODULE_2__.s; },
/* harmony export */   "st": function() { return /* reexport safe */ _useDetails_js__WEBPACK_IMPORTED_MODULE_1__.s; }
/* harmony export */ });
/* harmony import */ var _useAppGeneral_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72001);
/* harmony import */ var _useDetails_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27895);
/* harmony import */ var _useList_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41473);
/* harmony import */ var _useLocalStorage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22008);
/* harmony import */ var _useWalletActions_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62074);
/* harmony import */ var _useTokensStoreGeneral_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17256);
/* harmony import */ var _useTransactions_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85595);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_useAppGeneral_js__WEBPACK_IMPORTED_MODULE_0__, _useDetails_js__WEBPACK_IMPORTED_MODULE_1__, _useList_js__WEBPACK_IMPORTED_MODULE_2__, _useWalletActions_js__WEBPACK_IMPORTED_MODULE_4__, _useTokensStoreGeneral_js__WEBPACK_IMPORTED_MODULE_5__, _useTransactions_js__WEBPACK_IMPORTED_MODULE_6__]);
([_useAppGeneral_js__WEBPACK_IMPORTED_MODULE_0__, _useDetails_js__WEBPACK_IMPORTED_MODULE_1__, _useList_js__WEBPACK_IMPORTED_MODULE_2__, _useWalletActions_js__WEBPACK_IMPORTED_MODULE_4__, _useTokensStoreGeneral_js__WEBPACK_IMPORTED_MODULE_5__, _useTransactions_js__WEBPACK_IMPORTED_MODULE_6__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);







//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 72001:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useAppGeneral; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84134);
/* harmony import */ var _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25995);
/* harmony import */ var _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36142);
/* harmony import */ var _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27001);
/* harmony import */ var _Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31647);
/* harmony import */ var _lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66527);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_1__, _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_2__, _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_3__]);
([_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_1__, _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_2__, _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_3__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);
'use client';







const useAppGeneral = (props) => {
    //--------------------------------------
    const appStore = (0,_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_1__/* .useAppStore */ .qr)();
    const walletStore = (0,_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_1__/* .useWalletStore */ .X$)();
    const tokensStore = (0,_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_1__/* .useTokensStore */ .ux)();
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (props.onLoadComplete !== undefined && appStore.swInitApiCompleted === true) {
            props.onLoadComplete();
        }
    }, [appStore.swInitApiCompleted, props.onLoadComplete]);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        // MAIN USE EFFECTS TO EXECUTE JOBS OF GETTING TOKEN METADATA, VERY IMPORTANT!!!
        if (tokensStore.jobTokensToAdd.length > 0 && tokensStore.isExecuting === false) {
            tokensStore.executeJobsTokensToAdd();
        }
    }, [tokensStore.jobTokensToAdd, tokensStore.isExecuting]);
    //--------------------------------------
    async function initApi() {
        try {
            //--------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(`${"https://otc.mayz.io/api"}/init`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.status === 200) {
                const datas = await response.json();
                if (!datas.token) {
                    throw `Invalid response format: Challengue Token not found`;
                }
                if (!datas.csrfToken) {
                    throw `Invalid response format: csrf Token not found`;
                }
                //--------------------
                // localStorage.setItem('challengueToken', datas.token);
                // localStorage.setItem('x-csrf-token', datas.csrfToken);
                //--------------------
                window.__CHALLENGE_TOKEN__ = datas.token;
                window.__CSRF_TOKEN__ = datas.csrfToken;
                // window.__NONCE__ = datas.nonce;
                //--------------------
                console.log(`[App] - initApi - response OK - ${datas.status}`);
                //--------------------
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        }
        catch (error) {
            console.log(`[App] - initApi - Error: ${error}`);
            throw error;
        }
    }
    async function loadSiteSettings() {
        try {
            if (appStore.siteSettings !== undefined) {
                console.log(`[App] - Site Settings already set`);
            }
            else {
                //---------------
                console.log(`[App] - Site Settings not set. Preparing...`);
                //---------------
                let siteSettings = undefined;
                //---------------
                siteSettings = await _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_2__/* .SiteSettingsFrontEndApiCalls.getOneByParamsApi_ */ .wy.getOneByParamsApi_({ name: 'Init' });
                //---------------
                if (siteSettings === undefined) {
                    throw `Site Settings Init does not exists`;
                }
                //---------------
                appStore.setSiteSettings(siteSettings);
                //---------------
            }
            //---------------
        }
        catch (error) {
            console.log(`[App] - loadSiteSettings - Error: ${error}`);
            throw error;
        }
    }
    async function loadEmulatorCurrent() {
        try {
            //---------------
            console.log(`[App] - loadEmulator - Preparing Emulator...`);
            //---------------
            let emulatorDB = undefined;
            //---------------
            emulatorDB = await _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_2__/* .EmulatorDBFrontEndApiCalls.getOneByParamsApi_ */ .cu.getOneByParamsApi_({ current: true });
            //---------------
            if (emulatorDB === undefined) {
                throw `Emulator current not found`;
            }
            //---------------
            walletStore.setEmulatorDB(emulatorDB);
            //---------------
            return emulatorDB;
            //---------------
        }
        catch (error) {
            console.log(`[App] - loadEmulator - Error: ${error}`);
            throw error;
        }
    }
    async function initLucidForUseAsUtils(emulatorDB) {
        try {
            console.log(`[App] - initLucidForUseAsUtils - Preparing Lucid for use as Utils...`);
            const { lucid } = await _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_3__/* .LucidToolsFrontEnd.prepareLucidForUseAsUtils */ .f.prepareLucidForUseAsUtils(emulatorDB);
            walletStore.setLucidForUseAsUtils(lucid);
        }
        catch (error) {
            console.log(`[App] - initLucidForUseAsUtils - Error: ${error}`);
            throw error;
        }
    }
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const initGeneral = async () => {
            try {
                //--------------------
                appStore.setSwInitApiCompleted(false);
                //--------------------
                await initApi();
                //--------------------
                await loadSiteSettings();
                //--------------------
                let emulatorDB = undefined;
                if (_Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_4__/* .isEmulator */ .It) {
                    emulatorDB = await loadEmulatorCurrent();
                }
                //--------------------
                await initLucidForUseAsUtils(emulatorDB);
                //--------------------
                walletStore.getCardanoWallets();
                //--------------------
                const existAnyWallet = await appStore.checkIfExistAnyWallet();
                //--------------------
                appStore.checkIfExistAnyWallet();
                //--------------------
                appStore.setSwInitApiCompleted(true);
                //--------------------
                try {
                    const swCheckAgainTxTimeOut = false;
                    const swCheckAgainTxPendingTimeOut = false;
                    const swCheckAgainTxFailed = false;
                    _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_2__/* .TransactionFrontEndApiCalls.beginStatusUpdaterJobApi */ .TH.beginStatusUpdaterJobApi(swCheckAgainTxTimeOut, swCheckAgainTxPendingTimeOut, swCheckAgainTxFailed);
                }
                catch (error) {
                    console.log(`Error starting Tx Updater Job: ${error}`);
                }
            }
            catch (error) {
                console.log(`[App] - init - Error: ${error}`);
                (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_5__/* .pushWarningNotification */ .M)(`SmartDB`, `Error initializing: ${error}`);
            }
        };
        initGeneral();
    }, []);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        // if (appStore.swExistAnyWsallet === false ) {
        //     router.push({
        //         pathname: ROUTES.AdminDashboard,
        //         query: { [TASK_QUERY_NAME.TASK]: TASK.WALLETS },
        //     });
        // }
    }, [appStore.swExistAnyWallet]);
    //--------------------------------------
    return {
        appStore,
        tokensStore,
    };
};
//# sourceMappingURL=useAppGeneral.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 27895:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useDetails; }
/* harmony export */ });
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33299);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84134);
/* harmony import */ var _Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31647);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_2__]);
_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_2__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
'use client';




const useDetails = (props) => {
    //--------------------------------------
    const { nameDetails, loadDetails, checkIfRestricted, dependencies: dependencies_, checkDependencies, onLoadingDetails, onLoadedDetails, isHandlingDetailsEvents: isHandlingDetailsEvents_, } = props;
    //--------------------------------------
    const [triggerScroll, setTriggerScroll] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const isHandlingDetailsEvents = isHandlingDetailsEvents_ ?? true;
    //--------------------------------------
    const dependencies = dependencies_ ?? [];
    //--------------------------------------
    const { data: session, status } = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.useSession)();
    //--------------------------------------
    const walletStore = (0,_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_2__/* .useWalletStore */ .X$)();
    //--------------------------------------
    const detailsDivRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    //--------------------------------------
    function scrollToDetails() {
        if (detailsDivRef.current) {
            const topPos = detailsDivRef.current.getBoundingClientRect().top + window.scrollY;
            console.log(`${nameDetails ? '[' + nameDetails + ']' + ' - ' : ''}[Details] scrollToDetails - ${topPos}`);
            window.scrollTo({ top: topPos, behavior: 'smooth' });
        }
    }
    //--------------------------------------
    const listReducer = (state, action) => {
        switch (action.type) {
            case 'start_loading':
                // console.log(`${nameDetails ? '[' + nameDetails + "]" + ' - ' : ''}start_loading`);
                return { ...state, isLoadedDetails: false, isLoadingDetails: true, doLoading: true, loadingParams: action.payload };
            case 'finish_loading':
                console.log(`${nameDetails ? '[' + nameDetails + ']' + ' - ' : ''}[Details] Details loaded`);
                return { ...state, isLoadedDetails: true, isLoadingDetails: false, current: action.payload, doLoading: false };
            case 'restrict_user':
                return { ...state, isRestricted: true, current: undefined, isLoadedDetails: false };
            case 'unrestrict_user':
                return { ...state, isRestricted: false };
            case 'wasRestricted':
                // console.log(`wasRestricted`)
                return { ...state, wasRestricted: action.payload };
            default:
                throw `Unknown dispach message`;
        }
    };
    //--------------------------------------
    const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(listReducer, {
        isLoadedDetails: false,
        isLoadingDetails: false,
        // isLoadedDetails: initialDetails !== undefined ? true : false,
        // isLoadingDetails: initialDetails === undefined ? true : false,
        doLoading: false,
        // loadingParams: { swUnsetCurrentTask: false, new_id: undefined },
        loadingParams: { new_id: undefined },
        isRestricted: false,
        wasRestricted: true,
        // current: initialDetails,
        current: undefined,
    });
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (state.isLoadingDetails === true && isHandlingDetailsEvents === true) {
            console.log(`${nameDetails ? '[' + nameDetails + ']' + ' - ' : ''}[Details] useEffects isLoadingDetails`);
            if (onLoadingDetails !== undefined) {
                onLoadingDetails();
            }
        }
    }, [state.isLoadingDetails]);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (state.isLoadedDetails === true && isHandlingDetailsEvents === true) {
            console.log(`${nameDetails ? '[' + nameDetails + ']' + ' - ' : ''}[Details] useEffects isLoadedDetails`);
            if (onLoadedDetails !== undefined) {
                onLoadedDetails();
            }
            setTriggerScroll(true);
        }
    }, [state.isLoadedDetails]);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (triggerScroll === true) {
            console.log(`${nameDetails ? '[' + nameDetails + ']' + ' - ' : ''}[Details] useEffects triggerScroll`);
            scrollToDetails();
            setTriggerScroll(false);
        }
    }, [triggerScroll]);
    //--------------------------------------
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        // este se va a usar solamente para cambiar el estado de retriccion del usuario
        if (checkIfRestricted !== undefined) {
            let isUserRestricted = checkIfRestricted(status, session, walletStore);
            // alert(`${nameDetails} - wallet cambio: isUserRestricted ${isUserRestricted}`);
            // console.log(`${nameDetails ? '[' + nameDetails + ']' + ' - ' : ''}[Details] useEffects wallet cambio: isUserRestricted ${isUserRestricted}`);
            dispatch({ type: isUserRestricted ? 'restrict_user' : 'unrestrict_user' });
        }
    }, [status, walletStore.isWalletPrivilegesLoaded]);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        //--------------------------------------
        // console.log(`${nameDetails ? '[' + nameDetails + ']' + ' - ' : ''}[Details] useEffects refreshDetails because was restricted or dependencies changed`);
        //--------------------------------------
        // console.log(`${nameDetails ? '[' + nameDetails + ']' + ' - ' : ''}[Details] useEffects ${toJson(state)} ${toJson(dependencies)}`);
        //--------------------------------------
        if (state.isRestricted === false && state.wasRestricted === true && checkIfRestricted !== undefined) {
            // alert(`${nameDetails ? '[' + nameDetails + ']' + ' - ' : ''}[Details] refreshDetails because was restricted`);
            if (checkDependencies === undefined) {
                refreshDetails();
                dispatch({ type: 'wasRestricted', payload: false });
            }
            else {
                if (checkDependencies() === true) {
                    refreshDetails();
                    dispatch({ type: 'wasRestricted', payload: false });
                }
            }
        }
        else {
            // alert(`${nameDetails} - refreshDetails because dependencies changed`);
            if (checkDependencies === undefined) {
                refreshDetails();
            }
            else {
                if (checkDependencies() === true) {
                    refreshDetails();
                }
            }
        }
    }, [state.isRestricted, ...dependencies]);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        //--------------------------------------
        if (state.doLoading === true) {
            const fetch = async () => {
                try {
                    let details = await loadDetails(state.loadingParams.new_id);
                    // if (state.loadingParams.swUnsetCurrentTask) {
                    //     setCurrentTask(undefined);
                    // }
                    dispatch({ type: 'finish_loading', payload: details });
                }
                catch (error) {
                    console.log(`${nameDetails ? '[' + nameDetails + ']' + ' - ' : ''}[Details] Error fetching details: ${error}`);
                    (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_3__/* .pushWarningNotification */ .M)('SmartDB', 'Error fetching details: ' + error);
                    dispatch({ type: 'finish_loading', payload: undefined });
                }
            };
            fetch();
        }
        //--------------------------------------
    }, [state.doLoading]);
    //--------------------------------------
    const refreshDetails = async (new_id) => {
        // const refreshDetails = async (swUnsetCurrentTask: boolean = true, new_id?: string) => {
        //----------------
        // console.log(`${nameDetails ? '[' + nameDetails + ']' + ' - ' : ''}[Details] refreshDetails`);
        //----------------
        if (state.isRestricted === false) {
            dispatch({ type: 'start_loading', payload: { new_id } });
        }
    };
    //--------------------------------------
    const setCurrent = (current) => {
        dispatch({ type: 'finish_loading', payload: current });
    };
    //--------------------------------------
    return {
        isLoadingDetails: state.isLoadingDetails,
        isLoadedDetails: state.isLoadedDetails,
        current: state.current,
        setCurrent,
        refreshDetails,
        detailsDivRef,
        scrollToDetails, setTriggerScroll
    };
};
//# sourceMappingURL=useDetails.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 41473:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useList; }
/* harmony export */ });
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33299);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27001);
/* harmony import */ var _store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84134);
/* harmony import */ var _Commons_utils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75672);
/* harmony import */ var _Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31647);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_3__]);
_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_3__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
'use client';






const useList = (props) => {
    //--------------------------------------
    const { nameList, loadList, checkIfRestricted, initialCurrent, dependencies: dependencies_, checkDependencies, itemsPerPage: itemsPerPage_, onLoadingList, onLoadedList, isHandlingListEvents: isHandlingListEvents_, } = props;
    //--------------------------------------
    const [triggerScroll, setTriggerScroll] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const isHandlingListEvents = isHandlingListEvents_ ?? true;
    //--------------------------------------
    const dependencies = dependencies_ ?? [];
    const itemsPerPage = itemsPerPage_ ?? _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_2__/* .ITEMS_PER_PAGE */ .gK;
    //--------------------------------------
    const { data: session, status } = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.useSession)();
    //--------------------------------------
    const walletStore = (0,_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_3__/* .useWalletStore */ .X$)();
    //--------------------------------------
    const [currentPage, setCurrentPage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    const [totalPages, setTotalPages] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined);
    const [sortParams, setSortParams] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    //--------------------------------------
    const handlePageChange = (newPage) => {
        if (totalPages === undefined || newPage > totalPages || newPage < 1)
            return;
        setCurrentPage(newPage);
        refreshList(false, newPage);
        // refreshList(false, false, newPage);
    };
    const handleSortChange = (newSortParams) => {
        setSortParams(newSortParams);
    };
    //--------------------------------------
    const listDivRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    //--------------------------------------
    function scrollToList() {
        if (listDivRef.current) {
            const topPos = listDivRef.current.getBoundingClientRect().top + window.scrollY;
            console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] scrollToList - ${topPos}`);
            window.scrollTo({ top: topPos, behavior: 'smooth' });
        }
    }
    // | { type: 'initialListUsed'; payload: boolean };
    //--------------------------------------
    const listReducer = (state, action) => {
        // console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] Reducer State ${toJson(state)}`);
        // console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] Reducer Action ${toJson(action)}`);
        switch (action.type) {
            case 'start_loading':
                console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}start_loading - ${(0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_4__/* .toJson */ .Qs)(action.payload)}`);
                return { ...state, isLoadedList: false, isLoadingList: true, doLoading: true, loadingParams: action.payload };
            case 'finish_loading':
                console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] List loaded`);
                return { ...state, isLoadedList: true, isLoadingList: false, list: action.payload, doLoading: false };
            case 'select':
                // console.log(`select`)
                return { ...state, current: action.payload };
            case 'restrict_user':
                // console.log(`restrict_user`)
                return { ...state, isRestricted: true, list: [], isLoadedList: false };
            case 'unrestrict_user':
                // console.log(`unrestrict_user`)
                return { ...state, isRestricted: false, wasRestricted: state.isRestricted };
            case 'wasRestricted':
                // console.log(`wasRestricted`)
                return { ...state, wasRestricted: action.payload };
            // case 'initialListUsed':
            //     // console.log(`initialListUsed`)
            //     return { ...state, initialListUsed: action.payload };
            default:
                throw `Unknown dispach message`;
        }
    };
    //--------------------------------------
    const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(listReducer, {
        // isLoadedList: initialList !== undefined ? true : false,
        // isLoadingList: initialList === undefined ? true : false,
        isLoadedList: false,
        isLoadingList: false,
        // initialListUsed: false,
        doLoading: false,
        loadingParams: { swCalculateTotalPages: true, newCurrentPage: undefined },
        // loadingParams: { swUnsetCurrentTask: true, swCalculateTotalPages: true, newCurrentPage: 1 },
        isRestricted: false,
        wasRestricted: true,
        list: [],
        // list: initialList !== undefined ? initialList : [],
        current: initialCurrent,
    });
    //--------------------------------------
    const setCurrent = (current) => {
        dispatch({ type: 'select', payload: current });
    };
    //--------------------------------------
    const setList = (current) => {
        dispatch({ type: 'finish_loading', payload: current });
    };
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (state.isLoadingList === true && isHandlingListEvents === true) {
            console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] useEffects isLoadingList`);
            if (onLoadingList !== undefined) {
                onLoadingList();
            }
        }
    }, [state.isLoadingList]);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (state.isLoadedList === true && isHandlingListEvents === true) {
            console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] useEffects isLoadedList`);
            if (onLoadedList !== undefined) {
                onLoadedList();
            }
            setTriggerScroll(true);
        }
    }, [state.isLoadedList]);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (triggerScroll === true) {
            console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] useEffects triggerScroll`);
            scrollToList();
            setTriggerScroll(false);
        }
    }, [triggerScroll]);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        // este se va a usar solamente para cambiar el estado de retriccion del usuario
        if (checkIfRestricted !== undefined) {
            let isUserRestricted = checkIfRestricted(status, session, walletStore);
            // alert(`${nameList} - wallet cambio: isUserRestricted ${isUserRestricted}`);
            // console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] useEffects wallet cambio: isUserRestricted ${isUserRestricted}`);
            dispatch({ type: isUserRestricted ? 'restrict_user' : 'unrestrict_user' });
        }
    }, [status, walletStore.isWalletPrivilegesLoaded]);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        //--------------------------------------
        // console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] useEffects refreshList because was restricted or dependencies changed`);
        //--------------------------------------
        // console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] useEffects ${toJson(state)} ${toJson(dependencies)}`);
        //--------------------------------------
        if (state.isRestricted === false && state.wasRestricted === true && checkIfRestricted !== undefined) {
            // alert(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] refreshList because was restricted`);
            if (checkDependencies === undefined) {
                refreshList();
                dispatch({ type: 'wasRestricted', payload: false });
            }
            else {
                if (checkDependencies() === true) {
                    refreshList();
                    dispatch({ type: 'wasRestricted', payload: false });
                }
            }
        }
        else {
            // alert(`${nameList} - refreshList because dependencies changed`);
            if (checkDependencies === undefined) {
                refreshList();
            }
            else {
                if (checkDependencies() === true) {
                    refreshList();
                }
            }
        }
    }, [state.isRestricted, ...dependencies]);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        //--------------------------------------
        if (state.doLoading === true) {
            //--------------------------------------
            // if (state.initialListUsed === false && initialList !== undefined) {
            //     // siempre comienza en falso y se setea en true la primera vez que se llama refresh
            //     dispatch({ type: 'initialListUsed', payload: true });
            //     dispatch({ type: 'finish_loading', payload: initialList });
            //     setCurrentPage(1);
            //     // pero si hayuna lista inicial, no se hace nada
            //     return
            // }
            //--------------------------------------
            const fetch = async () => {
                try {
                    // console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] useEffect doLoading`);
                    //----------------
                    let currentPage_ = currentPage;
                    if (state.loadingParams.newCurrentPage !== undefined) {
                        currentPage_ = state.loadingParams.newCurrentPage;
                        setCurrentPage(currentPage_);
                    }
                    if (totalPages === undefined || state.loadingParams.swCalculateTotalPages === true) {
                        // currentPage_ = 1;
                        // setCurrentPage(currentPage_);
                        state.loadingParams.swCalculateTotalPages = true;
                    }
                    //----------------
                    let list = await loadList(state.loadingParams.swCalculateTotalPages, currentPage_, itemsPerPage);
                    //----------------
                    // if (state.loadingParams.swUnsetCurrentTask) {
                    //     setCurrentTask(undefined);
                    // }
                    //----------------
                    dispatch({ type: 'finish_loading', payload: list });
                }
                catch (error) {
                    console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] Error fetching list: ${error}`);
                    (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_5__/* .pushWarningNotification */ .M)('SmartDB', 'Error fetching list: ' + error);
                    dispatch({ type: 'finish_loading', payload: [] });
                }
            };
            fetch();
        }
        //--------------------------------------
    }, [state.doLoading]);
    //--------------------------------------
    const refreshList = async (swCalculateTotalPages = true, newCurrentPage) => {
        //----------------
        // console.log(`${nameList ? '[' + nameList + ']' + ' - ' : ''}[List] refreshList`);
        //----------------
        if (state.isRestricted === false) {
            dispatch({ type: 'start_loading', payload: { swCalculateTotalPages, newCurrentPage } });
        }
    };
    //--------------------------------------
    function addPagination(optionsGet, totalPages, currentPage, itemsPerPage_) {
        //--------
        optionsGet = { ...optionsGet, limit: itemsPerPage_ ?? itemsPerPage };
        //--------
        if (currentPage !== undefined && totalPages !== undefined && currentPage > totalPages) {
            currentPage = totalPages;
            setCurrentPage(currentPage);
        }
        //--------
        if (currentPage === 0) {
            currentPage = 1;
            setCurrentPage(currentPage);
        }
        //--------
        if (currentPage > 1) {
            optionsGet = { ...optionsGet, skip: (currentPage - 1) * (itemsPerPage_ ?? itemsPerPage) };
        }
        //--------
        return optionsGet;
    }
    //--------------------------------------
    return {
        isLoadingList: state.isLoadingList,
        isLoadedList: state.isLoadedList,
        list: state.list,
        current: state.current,
        refreshList,
        setCurrent,
        setList,
        listDivRef,
        scrollToList,
        setTriggerScroll,
        handlePageChange,
        setCurrentPage,
        currentPage,
        handleSortChange,
        sortParams,
        setTotalPages,
        totalPages,
        addPagination,
    };
};
//# sourceMappingURL=useList.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 22008:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useLocalStorage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';

//Para guardar datos de forma persistente en el navegador
// Hook
function useLocalStorage(key, initialValue) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            // Get from local storage by key
            const item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            // If error also return initialValue
            console.log(`useLocalStorage - Error: ${error}`);
            return initialValue;
        }
    });
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValueFn = (value) => {
        try {
            // Allow value to be a function so we have same API as useState
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            if (typeof window !== 'undefined') {
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
            }
            return valueToStore;
        }
        catch (error) {
            // A more advanced implementation would handle the error case
            console.log(`useLocalStorage - setValue - Error: ${error}`);
            throw error;
        }
    };
    return [storedValue, setValueFn];
}
//# sourceMappingURL=useLocalStorage.js.map

/***/ }),

/***/ 17256:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* unused harmony export useTokensStoreGeneral */
/* harmony import */ var next_router_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Commons_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75672);
/* harmony import */ var _store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84134);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_3__]);
_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_3__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];
'use client';




const useTokensStoreGeneral = (props) => {
    //--------------------------------------
    const { name, followUp, keepAlive, swAddPrice, swAddMetadata, swCreateMetadataWhenNotFound, tokensToGet: tokensToGet_ } = props;
    //--------------------------------------
    const swAddTimeToName = props.swAddTimeToName === undefined ? true : props.swAddTimeToName;
    const initPriceUpdater = props.initPriceUpdater === undefined ? false : props.initPriceUpdater;
    const swHandleCreateJob = props.swHandleCreateJob === undefined ? true : props.swHandleCreateJob;
    //--------------------------------------
    const [random, setRandom] = useState((Math.random() * 100).toString());
    //--------------------------------------
    const tokensStore = useTokensStore();
    //--------------------------------------
    const router = useRouter();
    //--------------------------------------
    const [tokensToGet, setTokensToGet] = useState(tokensToGet_ ?? []);
    const [tokensFromStore, setTokensFromStore] = useState([]);
    const [isTokensStoreReady, setIsTokensStoreReady] = useState(false);
    const [isTokensStoreLoading, setIsTokensStoreLoading] = useState(false);
    //--------------------------------------
    const conditionInitTokensStoreGeneral = useMemo(() => {
        return () => {
            if (props.conditionInit) {
                const results = props.conditionInit();
                if (results === true) {
                    console.log(`[TokensStore] - Job: ${name}${swAddTimeToName ? random : ''} - conditionInit: ${results}`);
                }
                return results;
            }
            else {
                const results = tokensToGet !== undefined && tokensToGet.length > 0;
                if (results === true) {
                    console.log(`[TokensStore] - Job: ${name}${swAddTimeToName ? random : ''} - conditionInit: ${results}`);
                }
                return results;
            }
        };
    }, [props.conditionInit, tokensToGet, name, swAddTimeToName]);
    //--------------------------------------
    const conditionInit = conditionInitTokensStoreGeneral;
    //--------------------------------------
    const dependenciesInit = props.dependenciesInit === undefined ? [] : props.dependenciesInit;
    //--------------------------------------
    useEffect(() => {
        if (isTokensStoreReady === false && tokensStore.jobTokensToAddFinished.length > 0 && tokensStore.isExecuting === false) {
            //--------------------------------------
            const tokens = tokensStore.getFinishedJobTokensToAdd(`${name}${swAddTimeToName ? random : ''}`);
            if (tokens !== undefined) {
                setIsTokensStoreReady(true);
                setIsTokensStoreLoading(false);
                setTokensFromStore(tokens);
                if (initPriceUpdater === true) {
                    tokensStore.beginUpdateLoop({ doUpdatePricesAutomatically: true });
                }
            }
        }
    }, [tokensStore.jobTokensToAddFinished.length, tokensStore.isExecuting]);
    //--------------------------------------
    useEffect(() => {
        const initStore2 = async () => {
            //--------------------------------------
            console.log(`[TokensStore] - Job: ${name}${swAddTimeToName ? random : ''} - initStore2 - Tokens: ${tokensToGet?.map((t) => hexToStr(t.TN_Hex)).join(', ')}`);
            //--------------------------------------
            tokensStore.createJobTokensToAdd({
                job: `${name}${swAddTimeToName ? random : ''}`,
                tokens: tokensToGet,
                followUp: initPriceUpdater === true ? true : followUp,
                swAddPrice,
                swAddMetadata,
                swCreateMetadataWhenNotFound,
                keepAlive,
            });
            //--------------------------------------
        };
        if (swHandleCreateJob === true && isTokensStoreLoading === true) {
            initStore2();
        }
    }, [isTokensStoreLoading]);
    //--------------------------------------
    useEffect(() => {
        const initStore1 = async () => {
            //--------------------------------------
            setIsTokensStoreReady(false);
            setIsTokensStoreLoading(true);
            //--------------------------------------
            console.log(`[TokensStore] - Job: ${name}${swAddTimeToName ? random : ''} - initStore1 - swHandleCreateJob: ${swHandleCreateJob} - Tokens: ${tokensToGet
                ?.map((t) => hexToStr(t.TN_Hex))
                .join(', ')}`);
        };
        if (isTokensStoreLoading === false && conditionInit() === true) {
            initStore1();
        }
    }, [tokensToGet.length, ...dependenciesInit]);
    //--------------------------------------
    useEffect(() => {
        // const handleRouteChange = () => {
        //     console.log(`[TokensStore] - Job: ${name}${swAddTimeToName ? random : ''} - handleRouteChange`);
        //     if (tokensStore !== undefined && initPriceUpdater === true) {
        //         tokensStore.stopUpdateLoop({ cancelFollowUp: true });
        //     }
        // };
        // router.events.on('routeChangeStart', handleRouteChange);
        return () => {
            console.log(`[TokensStore] - Job: ${name}${swAddTimeToName ? random : ''} - stopUpdateLoop`);
            // router.events.off('routeChangeStart', handleRouteChange);
            if (tokensStore !== undefined && initPriceUpdater === true) {
                tokensStore.stopUpdateLoop({ cancelFollowUp: true });
            }
        };
    }, [router.events]);
    //--------------------------------------
    return {
        tokensStore,
        isTokensStoreReady,
        setIsTokensStoreReady,
        isTokensStoreLoading,
        setIsTokensStoreLoading,
        tokensFromStore,
        setTokensToGet,
        initPriceUpdater,
        isAddingTokens: tokensStore.isAddingTokens,
    };
    //--------------------------------------
};
//# sourceMappingURL=useTokensStoreGeneral.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 85595:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useTransactions; }
/* harmony export */ });
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33299);
/* harmony import */ var next_router_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37813);
/* harmony import */ var _FrontEnd_ApiCalls_Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21309);
/* harmony import */ var _store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84134);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_3__, _FrontEnd_ApiCalls_Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__, _store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_5__]);
([_Commons_index_js__WEBPACK_IMPORTED_MODULE_3__, _FrontEnd_ApiCalls_Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__, _store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_5__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);






const useTransactions = (props) => {
    //--------------------------------------
    const { checkIsValidTx, onTx: onTxProps } = props;
    //--------------------------------------
    const dependenciesValidTx = props.dependenciesValidTx ?? [];
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const router = (0,next_router_js__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    //--------------------------------------
    const { data: session, status } = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.useSession)();
    //--------------------------------------
    const walletStore = (0,_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_5__/* .useWalletStore */ .X$)();
    const appStore = (0,_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_5__/* .useAppStore */ .qr)();
    const tokensStore = (0,_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_5__/* .useTokensStore */ .ux)();
    //--------------------------------------
    const [available_ADA_in_Wallet, setAvailable_ADA_in_Wallet] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0n);
    const [available_forSpend_ADA_in_Wallet, setAvailable_forSpend_ADA_in_Wallet] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0n);
    const [isMaxAmountLoaded, setIsMaxAmountLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        console.log('[Transactions] Component mounted');
        // Function to release UTXOs when page closes or component unmounts
        const releaseUTXOs = async () => {
            if (!(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isNullOrBlank */ .Xy7)(appStore.processingTxHash)) {
                console.warn(`[Transactions] - Releasing locked isPreparing UTXOs for txHash: ${appStore.processingTxHash}`);
                await _FrontEnd_ApiCalls_Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_4__/* .TransactionFrontEndApiCalls.releaseUTxOsApi */ .T.releaseUTxOsApi(appStore.processingTxHash, true, false);
            }
        };
        // Ensure UTXOs are released when page closes
        window.addEventListener('beforeunload', releaseUTXOs);
        return () => {
            console.log('[Transactions] Component unmounted');
            // Ensure UTXOs are released when component is unmounted
            releaseUTXOs();
            // Cleanup event listener to prevent memory leaks
            window.removeEventListener('beforeunload', releaseUTXOs);
        };
    }, []); // Runs only on mount/unmount
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (walletStore.isWalletDataLoaded === true) {
            //--------------------------------------
            setIsMaxAmountLoaded(false);
            //--------------------------------------
            const available_ADA_in_Wallet = walletStore.getTotalOfUnit('lovelace');
            const available_forSpend_ADA_in_Wallet = walletStore.getTotalOfUnit('lovelace', true);
            //-----------
            setAvailable_ADA_in_Wallet(available_ADA_in_Wallet);
            setAvailable_forSpend_ADA_in_Wallet(available_forSpend_ADA_in_Wallet);
            //--------------------------------------
            setIsMaxAmountLoaded(true);
            //-----------
        }
    }, [walletStore.isWalletDataLoaded]);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
        if (checkIsValidTx) {
            const check = async () => {
                const isValidTx = await checkIsValidTx();
                appStore.setIsValidTx(isValidTx);
            };
            check();
        }
    }, [available_ADA_in_Wallet, isMaxAmountLoaded, ...dependenciesValidTx]);
    //--------------------------------------
    const resetTx = async () => {
        // setShowUserConfirmation(false);
        // setShowProcessingTx(false);
        // setIsProcessingTx(false);
        // setIsFaildedTx(false);
        // setIsConfirmedTx(false);
        // setProcessingTxMessage('');
        // setProcessingTxHash('');
        appStore.setTokensGiveWithMetadata([]);
        appStore.setTokensGetWithMetadata([]);
        if (props.resetForm !== undefined) {
            await props.resetForm();
        }
    };
    //--------------------------------------
    const handleBtnShowUserConfirmation = async () => {
        appStore.setShowUserConfirmation(true);
    };
    //--------------------------------------
    // NOTE: funciona ok, pero delega el control de errores al handle button with error control
    const handleBtnDoTransaction_NoErrorControl = async (handleBtnTxWithErrorControl, onTx) => {
        try {
            appStore.setShowUserConfirmation(false);
            appStore.setShowProcessingTx(true);
            appStore.setIsProcessingTx(true);
            appStore.setIsFaildedTx(false);
            appStore.setIsConfirmedTx(false);
            appStore.setProcessingTxMessage('Preparing...');
            appStore.setProcessingTxHash('');
            if (appStore.isValidTx) {
                const result = await handleBtnTxWithErrorControl(appStore.setProcessingTxMessage, appStore.setProcessingTxHash, walletStore);
                if (result === true) {
                    if (onTxProps !== undefined) {
                        await onTxProps();
                    }
                    if (onTx !== undefined) {
                        await onTx();
                    }
                    appStore.setIsConfirmedTx(true);
                    await resetTx();
                }
                else {
                    appStore.setIsFaildedTx(true);
                }
            }
            else {
                appStore.setIsFaildedTx(true);
            }
        }
        catch (error) {
            appStore.setIsFaildedTx(true);
        }
        finally {
            appStore.setIsProcessingTx(false);
        }
    };
    //--------------------------------------
    const handleBtnDoTransaction_WithErrorControl = async (Entity, modalTitleTx, messageActionTx, txApiRoute, fetchParams, txApiCall, handleBtnTxNoErrorControl, onTx) => {
        try {
            appStore.setShowUserConfirmation(false);
            appStore.setShowProcessingTx(true);
            appStore.setProcessingTxName(modalTitleTx);
            appStore.setIsProcessingTx(true);
            appStore.setIsFaildedTx(false);
            appStore.setIsConfirmedTx(false);
            appStore.setProcessingTxMessage('Preparing...');
            appStore.setProcessingTxHash('');
            if (appStore.isValidTx) {
                const { lucid, emulatorDB, walletTxParams, txParams } = await fetchParams();
                const api = txApiCall.bind(txApiCall, Entity, txApiRoute, walletTxParams, txParams);
                await handleBtnTxNoErrorControl(Entity, modalTitleTx, messageActionTx, lucid, emulatorDB, api, appStore.setProcessingTxMessage, appStore.setProcessingTxHash, walletStore);
                if (onTxProps !== undefined) {
                    await onTxProps();
                }
                if (onTx !== undefined) {
                    await onTx();
                }
                appStore.setIsConfirmedTx(true);
                await resetTx();
            }
            else {
                throw new Error('Transaction is not valid');
            }
        }
        catch (error) {
            appStore.setIsFaildedTx(true);
            const error_explained = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_3__/* .explainErrorTx */ .uns)(error);
            console.log(`[${Entity.className()}] - handleBtnDoTransactionExtended - Error: ${error_explained}`);
            (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_3__/* .pushWarningNotification */ .MQB)(`${Entity.className()} ${modalTitleTx}`, error_explained);
            appStore.setProcessingTxMessage(error_explained);
        }
        finally {
            appStore.setIsProcessingTx(false);
        }
    };
    //--------------------------------------
    return {
        appStore,
        walletStore,
        tokensStore,
        session,
        status,
        showUserConfirmation: appStore.showUserConfirmation,
        setShowUserConfirmation: appStore.setShowUserConfirmation,
        showProcessingTx: appStore.showProcessingTx,
        setShowProcessingTx: appStore.setShowProcessingTx,
        isProcessingTx: appStore.isProcessingTx,
        setIsProcessingTx: appStore.setIsProcessingTx,
        isFaildedTx: appStore.isFaildedTx,
        setIsFaildedTx: appStore.setIsFaildedTx,
        isConfirmedTx: appStore.isConfirmedTx,
        setIsConfirmedTx: appStore.setIsConfirmedTx,
        processingTxName: appStore.processingTxName,
        setProcessingTxName: appStore.setProcessingTxName,
        processingTxMessage: appStore.processingTxMessage,
        setProcessingTxMessage: appStore.setProcessingTxMessage,
        processingTxHash: appStore.processingTxHash,
        setProcessingTxHash: appStore.setProcessingTxHash,
        isValidTx: appStore.isValidTx,
        setIsValidTx: appStore.setIsValidTx,
        tokensGiveWithMetadata: appStore.tokensGiveWithMetadata,
        setTokensGiveWithMetadata: appStore.setTokensGiveWithMetadata,
        tokensGetWithMetadata: appStore.tokensGetWithMetadata,
        setTokensGetWithMetadata: appStore.setTokensGetWithMetadata,
        available_ADA_in_Wallet,
        available_forSpend_ADA_in_Wallet,
        isMaxAmountLoaded,
        handleBtnShowUserConfirmation,
        handleBtnDoTransaction_NoErrorControl,
        handleBtnDoTransaction_WithErrorControl,
    };
    //--------------------------------------
};
//# sourceMappingURL=useTransactions.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 62074:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWalletActions; },
/* harmony export */   "l": function() { return /* binding */ useWalletSession; }
/* harmony export */ });
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33299);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84134);
/* harmony import */ var _Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31647);
/* harmony import */ var _Commons_explainError_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73582);
/* harmony import */ var _Commons_utils_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75672);
/* harmony import */ var _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27001);
/* harmony import */ var _useLocalStorage_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22008);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_2__]);
_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_2__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];








function useWalletSession() {
    //--------------------------------------
    const { data: session, status } = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.useSession)();
    //--------------------------------------
    const { checkSessionAndConnectIfNeeded } = useWalletActions();
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (status === 'authenticated') {
            console.log(`[WalletConnector] - Session authenticated, might trigger a wallet connection... (status: ${status})`);
            checkSessionAndConnectIfNeeded();
        }
        else if (status === 'unauthenticated') {
            console.log(`[WalletConnector] - No Session`);
        }
        else if (status === 'loading') {
            console.log(`[WalletConnector] - Loading Session`);
        }
    }, [status]);
}
function useWalletActions() {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const { data: session, status } = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.useSession)();
    //--------------------------------------
    const [walletSelected, setWalletSelected] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    //--------------------------------------
    const [createSignedSession, setCreateSignedSession] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    //--------------------------------------
    const [swHideBalance, setHideBalance] = (0,_useLocalStorage_js__WEBPACK_IMPORTED_MODULE_7__/* .useLocalStorage */ ._)('HideBalance', undefined);
    const [swDoNotPromtForSigning, setSwDoNotPromtForSigning] = (0,_useLocalStorage_js__WEBPACK_IMPORTED_MODULE_7__/* .useLocalStorage */ ._)('DoNotPromtForSigning', undefined);
    //--------------------------------------
    const walletStore = (0,_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_2__/* .useWalletStore */ .X$)();
    const tokensStore = (0,_store_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_2__/* .useTokensStore */ .ux)();
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (walletStore.swDoNotPromtForSigning !== swDoNotPromtForSigning && swDoNotPromtForSigning !== undefined) {
            walletStore.setSwDoNotPromtForSigning(swDoNotPromtForSigning);
        }
    }, [swDoNotPromtForSigning]);
    //--------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (walletStore.swHideBalance !== swHideBalance && swHideBalance !== undefined) {
            walletStore.setSwHideBalance(swHideBalance);
        }
    }, [swHideBalance]);
    //--------------------------------------
    const handleToggleIsHide = () => {
        // walletStore.setSwHideBalance(!walletStore.swHideBalance);
        setHideBalance(!swHideBalance);
    };
    //--------------------------------------
    const handleClickToggleDontPromtForSigning = () => {
        // walletStore.setSwDoNotPromtForSigning(!walletStore.swDoNotPromtForSigning);
        setSwDoNotPromtForSigning(!swDoNotPromtForSigning);
    };
    //--------------------------------------
    const walletConnect = async (wallet, createSignedSession, forceConnect = false, tryAgain = false, closeModal) => {
        console.log('[WalletConnector] - walletConnect: ' + wallet.wallet);
        try {
            setWalletSelected(wallet.wallet);
            if (await walletStore.connectWallet({
                session,
                status,
                walletName: wallet.wallet,
                forceConnect,
                tryAgain,
                useBlockfrostToSubmit: false,
                isWalletFromSeed: false,
                isWalletFromKey: false,
                createSignedSession,
            })) {
                (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_3__/* .pushSucessNotification */ .o)(`WalletConnector`, `Connected with <b> ${wallet.wallet}</b>!`, false);
                if (closeModal) {
                    closeModal();
                }
            }
        }
        catch (error) {
            const error_explained = (0,_Commons_explainError_js__WEBPACK_IMPORTED_MODULE_4__/* .explainError */ .K)(error);
            console.log(`[WalletConnector] - walletConnect - Error: ${error_explained}`);
            (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_3__/* .pushWarningNotification */ .M)(`WalletConnector`, `Error connecting with <b> ${wallet.wallet}</b><br></br> ${error_explained}`);
        }
        finally {
            setWalletSelected(undefined);
        }
    };
    //--------------------------------------
    const walletFromSeedConnect = async (walletName, walletSeed, createSignedSession, forceConnect = false, closeModal) => {
        console.log(`[WalletConnector] - walletFromSeedConnect`);
        try {
            setWalletSelected(walletName);
            if (await walletStore.connectWallet({
                session,
                status,
                walletName: walletName,
                walletSeed: walletSeed,
                forceConnect,
                tryAgain: false,
                useBlockfrostToSubmit: false,
                isWalletFromSeed: true,
                isWalletFromKey: false,
                createSignedSession,
            })) {
                (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_3__/* .pushSucessNotification */ .o)(`WalletConnector`, `Connected with <b> ${walletName}</b>!`, false);
                if (closeModal) {
                    closeModal();
                }
            }
        }
        catch (error) {
            const error_explained = (0,_Commons_explainError_js__WEBPACK_IMPORTED_MODULE_4__/* .explainError */ .K)(error);
            console.log(`[WalletConnector] - walletFromSeedConnect - Error: ${error_explained}`);
            (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_3__/* .pushWarningNotification */ .M)(`WalletConnector`, `Error connecting with <b> ${walletName}</b><br></br> ${error_explained}`);
        }
        finally {
            setWalletSelected(undefined);
        }
    };
    //--------------------------------------
    const walletFromKeyConnect = async (walletName, walletKey, createSignedSession, forceConnect = false, closeModal) => {
        console.log(`[WalletConnector] - walletFromKeyConnect`);
        try {
            setWalletSelected(walletName);
            if (await walletStore.connectWallet({
                session,
                status,
                walletName: walletName,
                walletKey: walletKey,
                forceConnect,
                tryAgain: false,
                useBlockfrostToSubmit: false,
                isWalletFromSeed: false,
                isWalletFromKey: true,
                createSignedSession,
            })) {
                (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_3__/* .pushSucessNotification */ .o)(`WalletConnector`, `Connected with <b> ${walletName}</b>!`, false);
                if (closeModal) {
                    closeModal();
                }
            }
        }
        catch (error) {
            const error_explained = (0,_Commons_explainError_js__WEBPACK_IMPORTED_MODULE_4__/* .explainError */ .K)(error);
            console.log(`[WalletConnector] - walletFromKeyConnect - Error: ${error_explained}`);
            (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_3__/* .pushWarningNotification */ .M)(`WalletConnector`, `Error connecting with <b> ${walletName}</b><br></br> ${error_explained}`);
        }
        finally {
            setWalletSelected(undefined);
        }
    };
    //--------------------------------------
    const walletInstall = async (wallet) => {
        try {
            const url = wallet.link;
            window.open(url, '_blank');
        }
        catch (error) {
            const error_explained = (0,_Commons_explainError_js__WEBPACK_IMPORTED_MODULE_4__/* .explainError */ .K)(error);
            console.log(`[WalletConnector] - Error opening install link: ${error_explained}`);
            (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_3__/* .pushWarningNotification */ .M)(`WalletConnector`, `Error opening install link<br></br> ${error_explained}`);
        }
    };
    const walletRefresh = async () => {
        console.log('[WalletConnector] - walletRefresh: ' + walletStore.info.walletName);
        try {
            await walletStore.loadWalletPrivileges();
            await walletStore.loadWalletData();
        }
        catch (error) {
            const error_explained = (0,_Commons_explainError_js__WEBPACK_IMPORTED_MODULE_4__/* .explainError */ .K)(error);
            console.log(`[WalletConnector] - walletRefresh - Error: ${error_explained}`);
            (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_3__/* .pushWarningNotification */ .M)(`WalletConnector`, `Error refreshing with <b> ${walletStore.info.walletName}</b><br></br> ${error_explained}`);
        }
    };
    //--------------------------------------
    const walletDisconnect = async (closeModal) => {
        console.log(`[WalletConnector] - walletDisconnect`);
        try {
            await walletStore.disconnectWallet({ session, status });
            if (closeModal) {
                closeModal();
            }
        }
        catch (error) {
            const error_explained = (0,_Commons_explainError_js__WEBPACK_IMPORTED_MODULE_4__/* .explainError */ .K)(error);
            console.log(`[WalletConnector] - walletDisconnect - Error: ${error_explained}`);
            (0,_Commons_pushNotification_js__WEBPACK_IMPORTED_MODULE_3__/* .pushWarningNotification */ .M)(`WalletConnector`, `Error Disconnecting Wallet: ${error_explained}`);
            if (status === 'authenticated') {
                await (0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.signOut)({ redirect: false });
            }
        }
    };
    //--------------------------------------
    async function sessionWalletConnect() {
        try {
            if (session && session.user && session.user.walletName) {
                //console.log(`[Session] - walletConnect - session.walletName: ${session.user.walletName}`)
                const foundWallet = walletStore.cardanoWallets.find((wallet) => wallet.wallet === session.user.walletName);
                if (window.cardano !== undefined && (foundWallet || session.user.isWalletFromSeed || session.user.isWalletFromKey)) {
                    //si la wallet estaba conectada en la session anterior, tengo que reconectarla
                    console.log('[WalletConnector] - Triggering a connection with session wallet: ' + session.user.walletName);
                    if (session.user.isWalletFromSeed) {
                        if (session.user.walletSeed === undefined) {
                            throw 'No walletSeed in session';
                        }
                        await walletFromSeedConnect(session.user.walletName, session.user.walletSeed, session.user.isWalletValidatedWithSignedToken, false);
                    }
                    else if (session.user.isWalletFromKey) {
                        if (session.user.walletKey === undefined) {
                            throw 'No walletKey in session';
                        }
                        await walletFromKeyConnect(session.user.walletName, session.user.walletKey, session.user.isWalletValidatedWithSignedToken, false);
                    }
                    else {
                        await (0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_5__/* .sleep */ ._v)(_Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_6__/* .CONNECT_WALLET_WAIT_FOR_WALLET_ACTIVATION_MS */ .P9);
                        await walletConnect(foundWallet, session.user.isWalletValidatedWithSignedToken, false, true);
                    }
                }
                else {
                    console.log('[WalletConnector] - Not connecting to any wallet. Wallet of previus session not found: ' + session.user.walletName);
                    throw 'Wallet of previus session not found';
                }
            }
            else {
                throw 'No wallet in session';
            }
        }
        catch (error) {
            console.log(`[WalletConnector] - sessionWalletConnect - Error: ${error}`);
            await (0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.signOut)({ redirect: false });
        }
    }
    //--------------------------------------
    async function checkSessionAndConnectIfNeeded() {
        if (walletStore.isConnected) {
            let isSessionValid = false;
            if (session && session.user && walletStore.info) {
                isSessionValid = await walletStore.checkSessionValidity({
                    user: session.user,
                    walletInfo: walletStore.info,
                    isCoreTeam: walletStore.isCoreTeam(),
                });
            }
            const swUpdateSession = !isSessionValid;
            if (swUpdateSession) {
                console.log(`[WalletConnector] - Session authenticated and wallet is already connected but not all fields match. Must reconnect wallet. Triggering a connection...`);
                await sessionWalletConnect();
            }
            else {
                console.log(`[WalletConnector] - Session authenticated and wallet is already connected and all fields match.`);
            }
        }
        else {
            if (walletStore.isConnecting) {
                console.log(`[WalletConnector] - Session authenticated and wallet is already connecting... must wait`);
            }
            else {
                console.log(`[WalletConnector] - Session authenticated and wallet is not Connected. Triggering a connection...`);
                await sessionWalletConnect();
            }
        }
    }
    //--------------------------------------
    const handleClickToggleAdminMode = async () => {
        try {
            if (session && session.user && session.user.walletName) {
                const foundWallet = walletStore.cardanoWallets.find((wallet) => wallet.wallet === session.user.walletName);
                if (window.cardano !== undefined && (foundWallet || session.user.isWalletFromSeed || session.user.isWalletFromKey)) {
                    console.log('[WalletConnector] - Triggering a re-connection with wallet: ' + session.user.walletName);
                    if (session.user.isWalletFromSeed) {
                        if (session.user.walletSeed === undefined) {
                            throw 'No walletSeed in session';
                        }
                        await walletFromSeedConnect(session.user.walletName, session.user.walletSeed, !walletStore.info?.isWalletValidatedWithSignedToken, true);
                    }
                    else if (session.user.isWalletFromKey) {
                        if (session.user.walletKey === undefined) {
                            throw 'No walletKey in session';
                        }
                        await walletFromKeyConnect(session.user.walletName, session.user.walletKey, !walletStore.info?.isWalletValidatedWithSignedToken, true);
                    }
                    else {
                        await (0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_5__/* .sleep */ ._v)(_Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_6__/* .CONNECT_WALLET_WAIT_FOR_WALLET_ACTIVATION_MS */ .P9);
                        await walletConnect(foundWallet, !walletStore.info?.isWalletValidatedWithSignedToken, true, true);
                    }
                }
                else {
                    console.log('[WalletConnector] - Not connecting to any wallet. Wallet not found: ' + session.user.walletName);
                    throw 'Wallet not found';
                }
            }
            else {
                throw 'No wallet in session';
            }
        }
        catch (error) {
            console.log(`[WalletConnector] - handleClickToggleAdminMode - Error: ${error}`);
            await (0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.signOut)({ redirect: false });
        }
    };
    //--------------------------------------
    return {
        isRefreshing,
        tokensStore,
        session,
        status,
        walletStore,
        walletSelected,
        setWalletSelected,
        createSignedSession,
        setCreateSignedSession,
        walletConnect,
        walletFromSeedConnect,
        walletFromKeyConnect,
        walletInstall,
        walletRefresh,
        walletDisconnect,
        checkSessionAndConnectIfNeeded,
        handleClickToggleAdminMode,
        handleClickToggleDontPromtForSigning,
        handleToggleIsHide,
    };
    //--------------------------------------
}
//# sourceMappingURL=useWalletActions.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 90365:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4E": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.B4E; },
/* harmony export */   "Esd": function() { return /* reexport safe */ _Components_index_js__WEBPACK_IMPORTED_MODULE_6__.Es; },
/* harmony export */   "F2s": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.F2s; },
/* harmony export */   "Gre": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.Gre; },
/* harmony export */   "Gx9": function() { return /* reexport safe */ _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_2__.Gx; },
/* harmony export */   "Itp": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.Itp; },
/* harmony export */   "MQB": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.MQB; },
/* harmony export */   "NI2": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.NI2; },
/* harmony export */   "NdO": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.NdO; },
/* harmony export */   "OOZ": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.OOZ; },
/* harmony export */   "Pem": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.Pem; },
/* harmony export */   "T2L": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.T2L; },
/* harmony export */   "TuU": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.TuU; },
/* harmony export */   "V9b": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.V9b; },
/* harmony export */   "X$B": function() { return /* reexport safe */ _store_index_js__WEBPACK_IMPORTED_MODULE_4__.X$; },
/* harmony export */   "Xy7": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.Xy7; },
/* harmony export */   "Za7": function() { return /* reexport safe */ _hooks_index_js__WEBPACK_IMPORTED_MODULE_5__.Z; },
/* harmony export */   "_rQ": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__._rQ; },
/* harmony export */   "crd": function() { return /* reexport safe */ _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_2__.cr; },
/* harmony export */   "crs": function() { return /* reexport safe */ _store_index_js__WEBPACK_IMPORTED_MODULE_4__.cr; },
/* harmony export */   "dMk": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.dMk; },
/* harmony export */   "e0x": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.e0x; },
/* harmony export */   "fmW": function() { return /* reexport safe */ _lib_index_js__WEBPACK_IMPORTED_MODULE_3__.fm; },
/* harmony export */   "jl9": function() { return /* reexport safe */ _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_2__.jl; },
/* harmony export */   "lTY": function() { return /* reexport safe */ _hooks_index_js__WEBPACK_IMPORTED_MODULE_5__.lT; },
/* harmony export */   "n6t": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.n6t; },
/* harmony export */   "nCS": function() { return /* reexport safe */ _hooks_index_js__WEBPACK_IMPORTED_MODULE_5__.nC; },
/* harmony export */   "o4X": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.o4X; },
/* harmony export */   "pzN": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.pzN; },
/* harmony export */   "q$g": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.q$g; },
/* harmony export */   "qrW": function() { return /* reexport safe */ _store_index_js__WEBPACK_IMPORTED_MODULE_4__.qr; },
/* harmony export */   "sa8": function() { return /* reexport safe */ _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__.sa8; },
/* harmony export */   "smg": function() { return /* reexport safe */ _hooks_index_js__WEBPACK_IMPORTED_MODULE_5__.sm; },
/* harmony export */   "stq": function() { return /* reexport safe */ _hooks_index_js__WEBPACK_IMPORTED_MODULE_5__.st; },
/* harmony export */   "twE": function() { return /* reexport safe */ _Entities_index_js__WEBPACK_IMPORTED_MODULE_1__.tw; }
/* harmony export */ });
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37813);
/* harmony import */ var _Entities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69302);
/* harmony import */ var _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25995);
/* harmony import */ var _lib_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86624);
/* harmony import */ var _store_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56486);
/* harmony import */ var _hooks_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81389);
/* harmony import */ var _Components_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72017);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__, _Entities_index_js__WEBPACK_IMPORTED_MODULE_1__, _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_2__, _lib_index_js__WEBPACK_IMPORTED_MODULE_3__, _store_index_js__WEBPACK_IMPORTED_MODULE_4__, _hooks_index_js__WEBPACK_IMPORTED_MODULE_5__, _Components_index_js__WEBPACK_IMPORTED_MODULE_6__]);
([_Commons_index_js__WEBPACK_IMPORTED_MODULE_0__, _Entities_index_js__WEBPACK_IMPORTED_MODULE_1__, _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_2__, _lib_index_js__WEBPACK_IMPORTED_MODULE_3__, _store_index_js__WEBPACK_IMPORTED_MODULE_4__, _hooks_index_js__WEBPACK_IMPORTED_MODULE_5__, _Components_index_js__WEBPACK_IMPORTED_MODULE_6__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);







//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 91991:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ AuthApi; }
/* harmony export */ });
/* harmony import */ var _lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66527);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37813);
/* harmony import */ var _Commons_yupLocale_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96548);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__]);
_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];



class AuthApi {
    // #region generic methods
    // #endregion generic methods
    // #region api
    static async generateAuthTokensApi(lucid, credentials, createSignedSession) {
        try {
            //-------------------------
            console.log(`[Auth] - generateAuthToken - Init`);
            //-------------------------
            if (credentials === undefined) {
                throw `Missing credentials`;
            }
            //-------------------------
            const schemaBody = _Commons_yupLocale_js__WEBPACK_IMPORTED_MODULE_2__/* .yup.object */ .T.object().shape({
                address: _Commons_yupLocale_js__WEBPACK_IMPORTED_MODULE_2__/* .yup.string */ .T.string().required().label('Address'),
                walletName: _Commons_yupLocale_js__WEBPACK_IMPORTED_MODULE_2__/* .yup.string */ .T.string().required().label('Wallet name'),
                walletSeed: _Commons_yupLocale_js__WEBPACK_IMPORTED_MODULE_2__/* .yup.string */ .T.string().label('Wallet seed'),
                walletKey: _Commons_yupLocale_js__WEBPACK_IMPORTED_MODULE_2__/* .yup.string */ .T.string().label('Wallet key'),
                useBlockfrostToSubmit: _Commons_yupLocale_js__WEBPACK_IMPORTED_MODULE_2__/* .yup.string */ .T.string().required().label('useBlockfrostToSubmit'),
                isWalletFromSeed: _Commons_yupLocale_js__WEBPACK_IMPORTED_MODULE_2__/* .yup.string */ .T.string().required().label('isWalletFromSeed'),
                isWalletFromKey: _Commons_yupLocale_js__WEBPACK_IMPORTED_MODULE_2__/* .yup.string */ .T.string().required().label('isWalletFromKey'),
            });
            //-------------------------
            let validatedCredentials;
            try {
                validatedCredentials = await schemaBody.validate(credentials);
            }
            catch (error) {
                throw error;
            }
            //----------------------------
            console.log(`[Auth] - generateAuthToken - Getting Challengue Token`);
            const challengue = await this.getChallengueTokenApi();
            if (challengue === undefined) {
                throw `Can't get Challengue Token`;
            }
            //----------------------------
            let signedChallengue = undefined;
            if (createSignedSession === true) {
                signedChallengue = await lucid.wallet().signMessage(validatedCredentials.address, (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .strToHex */ .pzN)(challengue));
            }
            //----------------------------
            const credentialAuthenticated = {
                address: credentials.address,
                walletName: credentials.walletName,
                walletSeed: credentials.walletSeed,
                walletKey: credentials.walletKey,
                useBlockfrostToSubmit: credentials.useBlockfrostToSubmit,
                isWalletFromSeed: credentials.isWalletFromSeed,
                isWalletFromKey: credentials.isWalletFromKey,
                challengue,
                signedChallengue: signedChallengue === undefined ? undefined : (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)(signedChallengue),
            };
            //----------------------------
            console.log(`[Auth] - generateAuthToken - Getting JWT Token`);
            const token = await this.getJWTTokenWithCredentialsApi(credentialAuthenticated);
            if (token === undefined) {
                throw `Can't get JWT Token`;
            }
            //----------------------------
            return token;
        }
        catch (error) {
            console.log(`[Auth] - generateAuthToken - Error: ${error}`);
            throw error;
        }
    }
    static async getJWTTokenWithCredentialsApi(credentials) {
        try {
            //----------------------------
            const urlApi = "https://otc.mayz.io" + '/api/smart-db-auth/get-token';
            const requestOptions = {
                headers: { 'Content-Type': 'application/json' },
                method: 'POST',
                body: (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .QsJ)(credentials),
            };
            //----------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(urlApi, requestOptions);
            //----------------------------
            if (response.status === 200) {
                const datas = await response.json();
                if (!datas.token) {
                    throw `Invalid response format: JWT Token not found`;
                }
                //console.log(`[Auth] - getJWTTokenApi - JWT Token: ${datas.token} - response OK`);
                return datas.token;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //----------------------------
        }
        catch (error) {
            console.log(`[Auth] - getJWTTokenApi - Error: ${error}`);
            throw error;
        }
    }
    static async getChallengueTokenApi() {
        try {
            //----------------------------
            const urlApi = "https://otc.mayz.io" + '/api/smart-db-auth/get-challengue';
            const requestOptions = {
                method: 'GET',
            };
            //----------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(urlApi, requestOptions, false);
            //----------------------------
            if (response.status === 200) {
                const datas = await response.json();
                if (!datas.token) {
                    throw `Invalid response format: Challengue Token not found`;
                }
                // console.log(`[Auth] - getChallengueTokenApi - Challengue Token: ${datas.token} - response OK`);
                return datas.token;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //----------------------------
        }
        catch (error) {
            console.log(`[Auth] - getChallengueTokenApi - Error: ${error}`);
            throw ` ${error}`;
        }
    }
}
//# sourceMappingURL=Auth.FrontEnd.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 73006:
/***/ (function(__webpack_module__, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony import */ var _Auth_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91991);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Auth_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__]);
_Auth_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];


//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 47900:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ BlockfrostCustomProviderFrontEnd; }
/* harmony export */ });
/* unused harmony export BlockFrostFrontEnd */
/* harmony import */ var _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76100);
/* harmony import */ var _Commons_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75672);
/* harmony import */ var _FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66527);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__]);
_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];



const lucid = '0.4.24'; // LucidEvolution version
class BlockfrostCustomProviderFrontEnd extends _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Blockfrost */ .sn {
    // public url: string;
    // public projectId: string;
    // constructor(url: string, projectId?: string) {
    //     this.url = url;
    //     this.projectId = projectId || '';
    // }
    async getProtocolParameters() {
        const result = await (0,_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .fetchWrapper */ .hM)(`${this.url}/epochs/latest/parameters`, {
            headers: { project_id: this.projectId, lucid },
        }).then((res) => res.json());
        return {
            minFeeA: parseInt(result.min_fee_a),
            minFeeB: parseInt(result.min_fee_b),
            maxTxSize: parseInt(result.max_tx_size),
            maxValSize: parseInt(result.max_val_size),
            keyDeposit: BigInt(result.key_deposit),
            poolDeposit: BigInt(result.pool_deposit),
            drepDeposit: BigInt(result.drep_deposit),
            govActionDeposit: BigInt(result.gov_action_deposit),
            priceMem: parseFloat(result.price_mem),
            priceStep: parseFloat(result.price_step),
            maxTxExMem: BigInt(result.max_tx_ex_mem),
            maxTxExSteps: BigInt(result.max_tx_ex_steps),
            coinsPerUtxoByte: BigInt(result.coins_per_utxo_size),
            collateralPercentage: parseInt(result.collateral_percent),
            maxCollateralInputs: parseInt(result.max_collateral_inputs),
            minFeeRefScriptCostPerByte: parseInt(result.min_fee_ref_script_cost_per_byte),
            costModels: result.cost_models,
        };
    }
    async getUtxos(addressOrCredential) {
        const queryPredicate = (() => {
            if (typeof addressOrCredential === 'string')
                return addressOrCredential;
            const credentialBech32 = addressOrCredential.type === 'Key'
                ? _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .CML.Ed25519KeyHash.from_hex */ .NR._Wl.from_hex(addressOrCredential.hash).to_bech32('addr_vkh')
                : _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .CML.ScriptHash.from_hex */ .NR.nJe.from_hex(addressOrCredential.hash).to_bech32('addr_vkh'); // should be 'script' (CIP-0005)
            return credentialBech32;
        })();
        let result = [];
        let page = 1;
        while (true) {
            const pageResult = await (0,_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .fetchWrapper */ .hM)(`${this.url}/addresses/${queryPredicate}/utxos?page=${page}`, { headers: { project_id: this.projectId, lucid } }).then((res) => res.json());
            if (pageResult.error) {
                if (pageResult.status_code === 404) {
                    return [];
                }
                else {
                    throw new Error(`Could not fetchWrapper UTxOs from Blockfrost. Error: ${(0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .Qs)(pageResult.error)}`);
                }
            }
            result = result.concat(pageResult);
            if (pageResult.length <= 0)
                break;
            page++;
        }
        return this.blockfrostUtxosToUtxos2(result);
    }
    async getUtxosWithUnit(addressOrCredential, unit) {
        const queryPredicate = (() => {
            if (typeof addressOrCredential === 'string')
                return addressOrCredential;
            const credentialBech32 = addressOrCredential.type === 'Key'
                ? _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .CML.Ed25519KeyHash.from_hex */ .NR._Wl.from_hex(addressOrCredential.hash).to_bech32('addr_vkh')
                : _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .CML.ScriptHash.from_hex */ .NR.nJe.from_hex(addressOrCredential.hash).to_bech32('addr_vkh'); // should be 'script' (CIP-0005)
            return credentialBech32;
        })();
        let result = [];
        let page = 1;
        while (true) {
            const pageResult = await (0,_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .fetchWrapper */ .hM)(`${this.url}/addresses/${queryPredicate}/utxos/${unit}?page=${page}`, { headers: { project_id: this.projectId, lucid } }).then((res) => res.json());
            if (pageResult.error) {
                if (pageResult.status_code === 404) {
                    return [];
                }
                else {
                    throw new Error(`Could not fetchWrapper UTxOs from Blockfrost. Error: ${(0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .Qs)(pageResult.error)}`);
                }
            }
            result = result.concat(pageResult);
            if (pageResult.length <= 0)
                break;
            page++;
        }
        return this.blockfrostUtxosToUtxos2(result);
    }
    async getUtxoByUnit(unit) {
        const addresses = await (0,_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .fetchWrapper */ .hM)(`${this.url}/assets/${unit}/addresses?count=2`, { headers: { project_id: this.projectId, lucid } }).then((res) => res.json());
        if (!addresses || addresses.error) {
            throw new Error('Unit not found.');
        }
        if (addresses.length > 1) {
            throw new Error('Unit needs to be an NFT or only held by one address.');
        }
        const address = addresses[0].address;
        const utxos = await this.getUtxosWithUnit(address, unit);
        if (utxos.length > 1) {
            throw new Error('Unit needs to be an NFT or only held by one address.');
        }
        return utxos[0];
    }
    async getUtxosByOutRef(outRefs) {
        //TODO: Make sure old already spent UTxOs are not retrievable.
        const queryHashes = [...new Set(outRefs.map((outRef) => outRef.txHash))];
        const utxos = await Promise.all(queryHashes.map(async (txHash) => {
            const result = await (0,_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .fetchWrapper */ .hM)(`${this.url}/txs/${txHash}/utxos`, { headers: { project_id: this.projectId, lucid } }).then((res) => res.json());
            if (!result || result.error) {
                return [];
            }
            const utxosResult = result.outputs.map((
            // deno-lint-ignore no-explicit-any
            r) => ({
                ...r,
                tx_hash: txHash,
            }));
            return this.blockfrostUtxosToUtxos2(utxosResult);
        }));
        return utxos
            .reduce((acc, utxos) => acc.concat(utxos), [])
            .filter((utxo) => outRefs.some((outRef) => utxo.txHash === outRef.txHash && utxo.outputIndex === outRef.outputIndex));
    }
    async getDelegation(rewardAddress) {
        const result = await (0,_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .fetchWrapper */ .hM)(`${this.url}/accounts/${rewardAddress}`, { headers: { project_id: this.projectId, lucid } }).then((res) => res.json());
        if (!result || result.error) {
            return { poolId: null, rewards: 0n };
        }
        return {
            poolId: result.pool_id || null,
            rewards: BigInt(result.withdrawable_amount),
        };
    }
    async getDatum(datumHash) {
        const datum = await (0,_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .fetchWrapper */ .hM)(`${this.url}/scripts/datum/${datumHash}/cbor`, {
            headers: { project_id: this.projectId, lucid },
        })
            .then((res) => res.json())
            .then((res) => res.cbor);
        if (!datum || datum.error) {
            throw new Error(`No datum found for datum hash: ${datumHash}`);
        }
        return datum;
    }
    awaitTx(txHash, checkInterval = 3000) {
        return new Promise((res) => {
            const confirmation = setInterval(async () => {
                const isConfirmed = await (0,_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .fetchWrapper */ .hM)(`${this.url}/txs/${txHash}`, {
                    headers: { project_id: this.projectId, lucid },
                }).then((res) => res.json());
                if (isConfirmed && !isConfirmed.error) {
                    clearInterval(confirmation);
                    await new Promise((res) => setTimeout(() => res(1), 1000));
                    return res(true);
                }
            }, checkInterval);
        });
    }
    async submitTx(tx) {
        const result = await (0,_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .fetchWrapper */ .hM)(`${this.url}/tx/submit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/cbor',
                project_id: this.projectId,
                lucid,
            },
            body: (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .fromHex */ .H_)(tx),
        }).then((res) => res.json());
        if (!result || result.error) {
            if (result?.status_code === 400)
                throw new Error(result.message);
            else
                throw new Error(`Could not submit transaction: ${(0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .toJson */ .Qs)(result)}`);
        }
        return result;
    }
    async blockfrostUtxosToUtxos2(result) {
        return await Promise.all(result.map(async (r) => ({
            txHash: r.tx_hash,
            outputIndex: r.output_index,
            assets: Object.fromEntries(r.amount.map(({ unit, quantity }) => [unit, BigInt(quantity)])),
            address: r.address,
            datumHash: (!r.inline_datum && r.data_hash) || undefined,
            datum: r.inline_datum || undefined,
            scriptRef: r.reference_script_hash
                ? await (async () => {
                    const { type } = await (0,_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .fetchWrapper */ .hM)(`${this.url}/scripts/${r.reference_script_hash}`, {
                        headers: { project_id: this.projectId, lucid },
                    }).then((res) => res.json());
                    //TODO: support native scripts
                    if (type === 'Native' || type === 'native') {
                        throw new Error('Native script ref not implemented!');
                    }
                    const { cbor: script } = await (0,_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_2__/* .fetchWrapper */ .hM)(`${this.url}/scripts/${r.reference_script_hash}/cbor`, {
                        headers: { project_id: this.projectId, lucid },
                    }).then((res) => res.json());
                    return {
                        type: type === 'plutusV1' ? 'PlutusV1' : type === 'plutusV2' ? 'PlutusV2' : 'PlutusV3',
                        script: (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .applyDoubleCborEncoding */ .EE)(script),
                    };
                })()
                : undefined,
        })));
    }
}
class BlockFrostFrontEnd {
}
//# sourceMappingURL=BlockFrost.FrontEnd.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 2461:
/***/ (function(__webpack_module__, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony import */ var _BlockFrost_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47900);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_BlockFrost_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__]);
_BlockFrost_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];

//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 66527:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ FetchWrapper_FrontEnd; },
  "hM": function() { return /* binding */ fetchWrapper; }
});

// UNUSED EXPORTS: createApiRequest

// NAMESPACE OBJECT: ./node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": function() { return hasBrowserEnv; },
  "hasStandardBrowserEnv": function() { return hasStandardBrowserEnv; },
  "hasStandardBrowserWebWorkerEnv": function() { return hasStandardBrowserWebWorkerEnv; },
  "navigator": function() { return _navigator; },
  "origin": function() { return origin; }
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/utils.js
/* provided dependency */ var process = __webpack_require__(83454);




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;
const {iterator, toStringTag} = Symbol;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(toStringTag in val) && !(iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

const [isReadableStream, isRequest, isResponse, isHeaders] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest);

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[iterator];

  const _iterator = generator.call(obj);

  let result;

  while ((result = _iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[toStringTag] === 'FormData' && thing[iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34

const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }

  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({source, data}) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);

    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    }
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === 'function',
  isFunction(_global.postMessage)
);

const asap = typeof queueMicrotask !== 'undefined' ?
  queueMicrotask.bind(_global) : ( typeof process !== 'undefined' && process.nextTick || _setImmediate);

// *********************


const isIterable = (thing) => thing != null && isFunction(thing[iterator]);


/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap,
  isIterable
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ var core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?(object|Function)} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  if (utils.isFunction(options)) {
    options = {
      serialize: options
    };
  } 

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/index.js




/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

const _navigator = typeof navigator === 'object' && navigator || undefined;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = hasBrowserEnv &&
  (!_navigator || ['ReactNative', 'NativeScript', 'NS'].indexOf(_navigator.product) < 0);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();

const origin = hasBrowserEnv && window.location.href || 'http://localhost';



;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/index.js



/* harmony default export */ var platform = ({
  ...common_utils_namespaceObject,
  ...browser
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http', 'fetch'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data) ||
      utils.isReadableStream(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (utils.isResponse(data) || utils.isReadableStream(data)) {
      return data;
    }

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ var lib_defaults = (defaults);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils.isObject(header) && utils.isIterable(header)) {
      let obj = {}, dest, key;
      for (const entry of header) {
        if (!utils.isArray(entry)) {
          throw TypeError('Object iterator must return a key-value pair');
        }

        obj[key = entry[0]] = (dest = obj[key]) ?
          (utils.isArray(dest) ? [...dest, entry[1]] : [dest, entry[1]]) : entry[1];
      }

      setHeaders(obj, valueOrRewrite)
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  getSetCookie() {
    return this.get("set-cookie") || [];
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils.freezeMethods(AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/throttle.js
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;

  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  }

  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if ( passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs)
        }, threshold - passed);
      }
    }
  }

  const flush = () => lastArgs && invoke(lastArgs);

  return [throttled, flush];
}

/* harmony default export */ var helpers_throttle = (throttle);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/progressEventReducer.js




const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return helpers_throttle(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true
    };

    listener(data);
  }, freq);
}

const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;

  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
}

const asyncDecorator = (fn) => (...args) => utils.asap(() => fn(...args));

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isURLSameOrigin.js


/* harmony default export */ var isURLSameOrigin = (platform.hasStandardBrowserEnv ? ((origin, isMSIE) => (url) => {
  url = new URL(url, platform.origin);

  return (
    origin.protocol === url.protocol &&
    origin.host === url.host &&
    (isMSIE || origin.port === url.port)
  );
})(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => true);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/cookies.js



/* harmony default export */ var cookies = (platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils.isString(path) && cookie.push('path=' + path);

      utils.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  });


;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
  let isRelativeUrl = !isAbsoluteURL(requestedURL);
  if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, prop, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, prop , caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, prop , caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, prop , caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b , prop) => mergeDeepProperties(headersToObject(a), headersToObject(b),prop, true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/resolveConfig.js









/* harmony default export */ var resolveConfig = ((config) => {
  const newConfig = mergeConfig({}, config);

  let {data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth} = newConfig;

  newConfig.headers = headers = core_AxiosHeaders.from(headers);

  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);

  // HTTP basic authentication
  if (auth) {
    headers.set('Authorization', 'Basic ' +
      btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : ''))
    );
  }

  let contentType;

  if (utils.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined); // Let the browser set it
    } else if ((contentType = headers.getContentType()) !== false) {
      // fix semicolon duplication issue for ReactNative FormData implementation
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));

    if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(newConfig.url))) {
      // Add xsrf header
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);

      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }

  return newConfig;
});


;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/xhr.js











const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = core_AxiosHeaders.from(_config.headers).normalize();
    let {responseType, onUploadProgress, onDownloadProgress} = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;

    function done() {
      flushUpload && flushUpload(); // flush events
      flushDownload && flushDownload(); // flush events

      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);

      _config.signal && _config.signal.removeEventListener('abort', onCanceled);
    }

    let request = new XMLHttpRequest();

    request.open(_config.method.toUpperCase(), _config.url, true);

    // Set the request timeout in MS
    request.timeout = _config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || defaults_transitional;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }

    // Handle progress if needed
    if (onDownloadProgress) {
      ([downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true));
      request.addEventListener('progress', downloadThrottled);
    }

    // Not all browsers support upload events
    if (onUploadProgress && request.upload) {
      ([uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress));

      request.upload.addEventListener('progress', uploadThrottled);

      request.upload.addEventListener('loadend', flushUpload);
    }

    if (_config.cancelToken || _config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(_config.url);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/composeSignals.js




const composeSignals = (signals, timeout) => {
  const {length} = (signals = signals ? signals.filter(Boolean) : []);

  if (timeout || length) {
    let controller = new AbortController();

    let aborted;

    const onabort = function (reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof core_AxiosError ? err : new cancel_CanceledError(err instanceof Error ? err.message : err));
      }
    }

    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new core_AxiosError(`timeout ${timeout} of ms exceeded`, core_AxiosError.ETIMEDOUT))
    }, timeout)

    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(signal => {
          signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
      }
    }

    signals.forEach((signal) => signal.addEventListener('abort', onabort));

    const {signal} = controller;

    signal.unsubscribe = () => utils.asap(unsubscribe);

    return signal;
  }
}

/* harmony default export */ var helpers_composeSignals = (composeSignals);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/trackStream.js

const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;

  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }

  let pos = 0;
  let end;

  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
}

const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
}

const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }

  const reader = stream.getReader();
  try {
    for (;;) {
      const {done, value} = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
}

const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);

  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  }

  return new ReadableStream({
    async pull(controller) {
      try {
        const {done, value} = await iterator.next();

        if (done) {
         _onFinish();
          controller.close();
          return;
        }

        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  })
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/fetch.js










const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';

// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ?
    ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) :
    async (str) => new Uint8Array(await new Response(str).arrayBuffer())
);

const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false
  }
}

const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;

  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    },
  }).headers.has('Content-Type');

  return duplexAccessed && !hasContentType;
});

const DEFAULT_CHUNK_SIZE = 64 * 1024;

const supportsResponseStream = isReadableStreamSupported &&
  test(() => utils.isReadableStream(new Response('').body));


const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};

isFetchSupported && (((res) => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = utils.isFunction(res[type]) ? (res) => res[type]() :
      (_, config) => {
        throw new core_AxiosError(`Response type '${type}' is not supported`, core_AxiosError.ERR_NOT_SUPPORT, config);
      })
  });
})(new Response));

const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }

  if(utils.isBlob(body)) {
    return body.size;
  }

  if(utils.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: 'POST',
      body,
    });
    return (await _request.arrayBuffer()).byteLength;
  }

  if(utils.isArrayBufferView(body) || utils.isArrayBuffer(body)) {
    return body.byteLength;
  }

  if(utils.isURLSearchParams(body)) {
    body = body + '';
  }

  if(utils.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
}

const resolveBodyLength = async (headers, body) => {
  const length = utils.toFiniteNumber(headers.getContentLength());

  return length == null ? getBodyLength(body) : length;
}

/* harmony default export */ var adapters_fetch = (isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = resolveConfig(config);

  responseType = responseType ? (responseType + '').toLowerCase() : 'text';

  let composedSignal = helpers_composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout);

  let request;

  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
      composedSignal.unsubscribe();
  });

  let requestContentLength;

  try {
    if (
      onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' &&
      (requestContentLength = await resolveBodyLength(headers, data)) !== 0
    ) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });

      let contentTypeHeader;

      if (utils.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader)
      }

      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );

        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }

    if (!utils.isString(withCredentials)) {
      withCredentials = withCredentials ? 'include' : 'omit';
    }

    // Cloudflare Workers throws when credentials are defined
    // see https://github.com/cloudflare/workerd/issues/902
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : undefined
    });

    let response = await fetch(request);

    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');

    if (supportsResponseStream && (onDownloadProgress || (isStreamResponse && unsubscribe))) {
      const options = {};

      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });

      const responseContentLength = utils.toFiniteNumber(response.headers.get('content-length'));

      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];

      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }

    responseType = responseType || 'text';

    let responseData = await resolvers[utils.findKey(resolvers, responseType) || 'text'](response, config);

    !isStreamResponse && unsubscribe && unsubscribe();

    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: core_AxiosHeaders.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      })
    })
  } catch (err) {
    unsubscribe && unsubscribe();

    if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
      throw Object.assign(
        new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      )
    }

    throw core_AxiosError.from(err, err && err.code, config, request);
  }
}));



;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/adapters.js






const knownAdapters = {
  http: helpers_null,
  xhr: xhr,
  fetch: adapters_fetch
}

utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils.isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ var adapters = ({
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new core_AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new core_AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/env/data.js
const VERSION = "1.9.0";
;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

validators.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    // eslint-disable-next-line no-console
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  }
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig || {};
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};

        Error.captureStackTrace ? Error.captureStackTrace(dummy) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.allowAbsoluteUrls
    if (config.allowAbsoluteUrls !== undefined) {
      // do nothing
    } else if (this.defaults.allowAbsoluteUrls !== undefined) {
      config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
    } else {
      config.allowAbsoluteUrls = true;
    }

    validator.assertOptions(config, {
      baseUrl: Axios_validators.spelling('baseURL'),
      withXsrfToken: Axios_validators.spelling('withXSRFToken')
    }, true);

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios);

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  toAbortSignal() {
    const controller = new AbortController();

    const abort = (err) => {
      controller.abort(err);
    };

    this.subscribe(abort);

    controller.signal.unsubscribe = () => this.unsubscribe(abort);

    return controller.signal;
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ./node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);

// EXTERNAL MODULE: ./node_modules/smart-db/dist/Commons/utils.js + 10 modules
var Commons_utils = __webpack_require__(75672);
// EXTERNAL MODULE: ./node_modules/smart-db/dist/Commons/Constants/constants.js
var constants = __webpack_require__(27001);
;// CONCATENATED MODULE: ./node_modules/smart-db/dist/lib/FetchWrapper/FetchWrapper.FrontEnd.js



const fetchWrapper = async (url, options = {}, swAddChallengue = true, retryCount = 0, timeout = 0) => {
    //----------------------
    if ((0,Commons_utils/* isFrontEndEnvironment */.C4)() === false) {
        throw `fetchWrapper - Only use FronEnd environment`;
    }
    //----------------------
    const headers = new Headers(options.headers);
    //----------------------
    if (swAddChallengue === true) {
        //----------------------
        // const challengueToken = localStorage.getItem('challengueToken');
        const challengueToken = window.__CHALLENGE_TOKEN__;
        //----------------------
        if (challengueToken) {
            headers.append('x-challengue-token', challengueToken);
        }
        //----------------------
    }
    //----------------------
    // const csrfToken = localStorage.getItem('x-csrf-token');
    const csrfToken = window.__CSRF_TOKEN__;
    if (csrfToken) {
        headers.append('x-csrf-token', csrfToken);
    }
    //----------------------
    // const nonce = window.__NONCE__
    // if (nonce) {
    //     headers.append('X-CSP-Nonce', nonce);
    // }
    //----------------------
    return createApiRequest(url, options, headers, timeout, retryCount);
    //----------------------
};
function createApiRequest(url, options, headers, timeout, retryCount) {
    //----------------------
    const axiosOptions = {
        url,
        method: options.method,
        baseURL: "https://otc.mayz.io",
        headers: Object.fromEntries(headers), // Converts Headers object back to a plain object
        data: options.body,
        withCredentials: true,
        timeout: timeout > 0 ? timeout : undefined,
    };
    //----------------------
    const errors = []; // Array to store errors from each retry attempt
    //----------------------
    const retry = async (count) => {
        try {
            //----------------------
            const response = await lib_axios(axiosOptions);
            //----------------------
            const fetchResponse = new Response((0,Commons_utils/* toJson */.Qs)(response.data), {
                status: response.status,
                statusText: response.statusText,
                headers: new Headers(Object.entries(response.headers)
                    .filter(([_, value]) => value !== undefined)
                    .map(([key, value]) => [key, value]) // Ensuring tuple type
                ),
            });
            //----------------------
            return fetchResponse;
            //----------------------
        }
        catch (error) {
            let errorInfo = {
                attempt: count + 1,
                error: 'Unknown error',
                message: 'Unknown error',
                status: 500,
                status_code: 500,
                statusText: 'Internal Server Error',
            };
            if (lib_axios.isAxiosError(error)) {
                errorInfo = {
                    attempt: count + 1,
                    error: error.response?.data?.error || error.response?.data || error.message || error.response?.statusText || 'Unknown error',
                    message: error.response?.data?.message || error.message || error.response?.statusText || 'Unknown error',
                    status: error.response?.status || 500,
                    status_code: error.response?.data?.satus_code || error.response?.status || 500,
                    statusText: error.response?.statusText || 'Internal Server Error',
                    config: error.config,
                    code: error.code,
                };
            }
            else if (error?.code === 'ECONNABORTED') {
                errorInfo = {
                    attempt: count + 1,
                    error: 'Request timed out',
                    message: 'Request timed out',
                    status: 408,
                    status_code: 408,
                    statusText: 'Request Timeout',
                    code: error.code,
                };
            }
            else if (error instanceof Error) {
                errorInfo = {
                    attempt: count + 1,
                    error: error.message || 'Unknown error',
                    message: error.message || 'Unknown error',
                    status: 500,
                    status_code: 500,
                    statusText: 'Internal Server Error',
                    name: error.name,
                    stack: error.stack,
                };
            }
            else {
                // Capturar cualquier otro tipo de error
                errorInfo = {
                    attempt: count + 1,
                    error: error || error.message || error.statusText || 'Unknown error',
                    message: error.message || error.statusText || 'Unknown error',
                    status: error.status || 500,
                    status_code: error.status || 500,
                    statusText: error.statusText || 'Internal Server Error',
                };
            }
            //----------------------
            errors.push(errorInfo);
            //----------------------
            // Retry mechanism
            if (count < retryCount) {
                await (0,Commons_utils/* sleep */._v)(constants/* API_TRY_AGAIN */.fo); // Delay before retrying
                return retry(count + 1);
            }
            //----------------------
            let errorBody;
            let responseStatus;
            let responseStatusText;
            //----------------------
            const uniqueErrors = new Set(errors.map((err) => err.status));
            //----------------------
            if (errors.length === 1 || uniqueErrors.size === 1) {
                const singleError = errors[0];
                errorBody = singleError;
                responseStatus = errorBody.status || 500;
                responseStatusText = errorBody.statusText || 'Internal Server Error';
            }
            else {
                errorBody = {
                    error: 'Multiple errors occurred',
                    details: errors,
                };
                responseStatus = 500;
                responseStatusText = 'Internal Server Error';
            }
            //----------------------
            const errorResponse = new Response((0,Commons_utils/* toJson */.Qs)(errorBody), {
                status: responseStatus,
                statusText: responseStatusText,
                headers: new Headers({ 'Content-Type': 'application/json' }),
            });
            //----------------------
            return errorResponse;
        }
    };
    //----------------------
    return retry(0);
}
/* harmony default export */ var FetchWrapper_FrontEnd = (fetchWrapper);
//# sourceMappingURL=FetchWrapper.FrontEnd.js.map

/***/ }),

/***/ 72489:
/***/ (function(__unused_webpack___webpack_module__, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66527);

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 87370:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ JobManagerFrontEnd; }
/* harmony export */ });
/* unused harmony export useJobManager */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27001);
/* harmony import */ var _FrontEnd_ApiCalls_Job_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92961);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_FrontEnd_ApiCalls_Job_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__]);
_FrontEnd_ApiCalls_Job_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];



const useJobManager = () => {
    const [jobIds, setJobIds] = useState([]);
    useEffect(() => {
        JobManagerFrontEnd.initialize(setJobIds);
        return () => {
            console.log('useEffect cleanup');
            JobManagerFrontEnd.clearAllJobs(); // Clear jobs on unmount
            JobManagerFrontEnd.initialize(null); // Remove the callback
        };
    }, []);
    return { jobIds };
};
class JobManagerFrontEnd {
    static { this.jobIds = []; }
    static { this.onChangeCallback = null; } // Callback to invoke when jobIds change
    static { this.cleanups = {}; }
    // Call this method whenever jobIds change
    static notifyJobIdsChanged() {
        if (typeof JobManagerFrontEnd.onChangeCallback === 'function') {
            JobManagerFrontEnd.onChangeCallback(JobManagerFrontEnd.jobIds);
        }
    }
    // Initialize with a callback to be called on jobIds changes
    static initialize(onChangeCallback) {
        JobManagerFrontEnd.onChangeCallback = onChangeCallback;
    }
    static getActiveJobIds() {
        return JobManagerFrontEnd.jobIds;
    }
    // Method to start monitoring a job's status
    static startMonitoringJob(jobId, setProcessingMessage, initialMessage = '') {
        // Add the jobId to the tracking list
        JobManagerFrontEnd.jobIds.push(jobId);
        JobManagerFrontEnd.notifyJobIdsChanged();
        let resolveJob, rejectJob;
        const jobPromise = new Promise((resolve, reject) => {
            resolveJob = resolve;
            rejectJob = reject;
        });
        let timeoutId = setInterval(async () => {
            try {
                const job = await _FrontEnd_ApiCalls_Job_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__/* .JobFrontEndApiCalls.getOneByParamsApi_ */ .l.getOneByParamsApi_({ name: jobId });
                if (job === undefined) {
                    // if (response.status === 404) {
                    //     clearInterval(timeoutId);
                    //     resolveJob({ id: jobId, status: 'failed', message: 'Job not found2', result: false });
                    //     console.log(`Job ${jobId} not found, assuming completion.`);
                    //     return;
                    // }
                    throw 'Failed to fetch job';
                }
                if (job.status === 'completed' || job.status === 'failed' || job.status === 'canceled') {
                    clearInterval(timeoutId);
                    resolveJob(job);
                    return;
                }
                let finalMessage = initialMessage;
                if (job.message) {
                    finalMessage += finalMessage ? ` - ${job.message}` : job.message;
                }
                //finalMessage += ` - ${job.status}`;
                setProcessingMessage(`${finalMessage}`);
            }
            catch (error) {
                clearInterval(timeoutId);
                rejectJob(new Error(`Error monitoring job ${jobId}: ${error}`));
            }
        }, _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .JOB_MONITOR_INTERVAL_MS */ .$);
        // Store the cleanup function for this jobId
        JobManagerFrontEnd.cleanups[jobId] = () => {
            console.log(`Monitoring for job ${jobId} has been stopped.`);
            clearInterval(timeoutId);
        };
        return { jobPromise, cleanup: JobManagerFrontEnd.cleanups[jobId] };
    }
    // Method to cancel a specific job
    static async cancelJob(jobId) {
        const job = await _FrontEnd_ApiCalls_Job_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__/* .JobFrontEndApiCalls.getOneByParamsApi_ */ .l.getOneByParamsApi_({ name: jobId });
        if (job === undefined) {
            throw 'Failed to fetch job';
        }
        job.status = 'canceled';
        await _FrontEnd_ApiCalls_Job_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__/* .JobFrontEndApiCalls.updateApi */ .l.updateApi(job);
        // const response = await fetchWrapperBackEnd(`/api/jobs/cancel/${jobId}`);
        // if (!response.ok) throw new Error('Failed to cancel job');
        // console.log(`Job ${jobId} canceled.`);
        // if (JobManagerFrontEnd.cleanups[jobId]) {
        //     JobManagerFrontEnd.cleanups[jobId](); // Call the cleanup function to clear the interval
        //     delete JobManagerFrontEnd.cleanups[jobId]; // Remove the cleanup reference
        //     // Consider also removing the jobId from jobIds array if you're done with it
        //     //JobManagerFrontEnd.jobIds = JobManagerFrontEnd.jobIds.filter(id => id !== jobId);
        //     // JobManagerFrontEnd.notifyJobIdsChanged();
        //     // Optionally call a backend endpoint to cancel the job there as well
        // }
    }
    // // Method to remove a job from the backend and cleanup resources
    // public static async removeJob(jobId: string): Promise<void> {
    //     try {
    //         if (JobManagerFrontEnd.cleanups[jobId]) {
    //             JobManagerFrontEnd.cleanups[jobId]();
    //             delete JobManagerFrontEnd.cleanups[jobId];
    //         }
    //         // Assume this fetch call correctly hits your backend to remove the job
    //         const response = await fetchWrapperBackEnd(`/api/jobs/remove/${jobId}`); // Adjust as necessary
    //         if (!response.ok) throw new Error('Failed to remove job');
    //         // If successful, remove jobId from tracking and execute its cleanup function
    //         JobManagerFrontEnd.jobIds = JobManagerFrontEnd.jobIds.filter((id) => id !== jobId);
    //         JobManagerFrontEnd.notifyJobIdsChanged();
    //         console.log(`Job ${jobId} removed successfully.`);
    //     } catch (error) {
    //         console.error(`Error removing job ${jobId}:`, error);
    //         throw error;
    //     }
    // }
    // Method to manually trigger cleanup for all jobs
    static clearAllJobs() {
        JobManagerFrontEnd.jobIds.forEach((jobId) => {
            // this.removeJob(jobId);
            if (JobManagerFrontEnd.cleanups[jobId]) {
                JobManagerFrontEnd.cleanups[jobId]();
                delete JobManagerFrontEnd.cleanups[jobId];
            }
        });
        JobManagerFrontEnd.jobIds = [];
        JobManagerFrontEnd.notifyJobIdsChanged();
        JobManagerFrontEnd.cleanups = {};
    }
}
//# sourceMappingURL=JobManager.FrontEnd.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 90785:
/***/ (function(__webpack_module__, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony import */ var _JobManager_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87370);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_JobManager_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__]);
_JobManager_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];

//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 36142:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ LucidToolsFrontEnd; }
/* harmony export */ });
/* harmony import */ var _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76100);
/* harmony import */ var _Commons_Constants_protocolParameters_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74625);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37813);
/* harmony import */ var _Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87654);
/* harmony import */ var _Entities_Transaction_Entity_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32519);
/* harmony import */ var _FrontEnd_ApiCalls_Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74617);
/* harmony import */ var _FrontEnd_ApiCalls_Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21309);
/* harmony import */ var _BlockFrost_BlockFrost_FrontEnd_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47900);
/* harmony import */ var _Time_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15165);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__, _Commons_index_js__WEBPACK_IMPORTED_MODULE_2__, _Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__, _Entities_Transaction_Entity_js__WEBPACK_IMPORTED_MODULE_4__, _FrontEnd_ApiCalls_Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_5__, _FrontEnd_ApiCalls_Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_6__, _BlockFrost_BlockFrost_FrontEnd_js__WEBPACK_IMPORTED_MODULE_7__, _Time_index_js__WEBPACK_IMPORTED_MODULE_8__]);
([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__, _Commons_index_js__WEBPACK_IMPORTED_MODULE_2__, _Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__, _Entities_Transaction_Entity_js__WEBPACK_IMPORTED_MODULE_4__, _FrontEnd_ApiCalls_Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_5__, _FrontEnd_ApiCalls_Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_6__, _BlockFrost_BlockFrost_FrontEnd_js__WEBPACK_IMPORTED_MODULE_7__, _Time_index_js__WEBPACK_IMPORTED_MODULE_8__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);









//--------------------------------------
class LucidToolsFrontEnd {
    // #region initialize lucid
    static { this.initializeLucidWithBlockfrost = async () => {
        console.log(`[Lucid] - initializeLucidWithBlockfrost`);
        try {
            //-----------------
            const protocolParameters = _Commons_Constants_protocolParameters_js__WEBPACK_IMPORTED_MODULE_1__/* .protocolParametersForLucid */ .XP["Mainnet"];
            //-----------------
            const lucid = await (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Lucid */ ._k)(new _BlockFrost_BlockFrost_FrontEnd_js__WEBPACK_IMPORTED_MODULE_7__/* .BlockfrostCustomProviderFrontEnd */ .Y("https://otc.mayz.io" + '/api/blockfrost', 'xxxx'), "Mainnet", {
                presetProtocolParameters: protocolParameters,
            });
            return lucid;
        }
        catch (error) {
            console.log(`[Lucid] - initializeLucidWithBlockfrost - Error: ${error}`);
            throw error;
        }
    }; }
    static { this.initializeLucidWithBlockfrostAndWalletApi = async (walletApi) => {
        console.log(`[Lucid] - initializeLucidWithBlockfrostAndWalletApi`);
        try {
            const lucid = await this.initializeLucidWithBlockfrost();
            if (walletApi !== undefined) {
                lucid.selectWallet.fromAPI(walletApi);
            }
            return lucid;
        }
        catch (error) {
            console.log(`[Lucid] - initializeLucidWithBlockfrostAndWalletApi - Error: ${error}`);
            throw error;
        }
    }; }
    static { this.initializeLucidWithBlockfrostAndWalletFromSeed = async (walletSeed, options) => {
        console.log(`[Lucid] - initializeLucidWithBlockfrostAndWalletFromSeed`);
        try {
            const lucid = await this.initializeLucidWithBlockfrost();
            lucid.selectWallet.fromSeed(walletSeed, options);
            return lucid;
        }
        catch (error) {
            console.log(`[Lucid] - initializeLucidWithBlockfrostAndWalletFromSeed - Error: ${error}`);
            throw error;
        }
    }; }
    static { this.initializeLucidWithBlockfrostAndWalletFromPrivateKey = async (walletPrivateKey) => {
        console.log('[Lucid] - initializeLucidWithBlockfrostAndWalletFromPrivateKey');
        try {
            const lucid = await this.initializeLucidWithBlockfrost();
            lucid.selectWallet.fromPrivateKey(walletPrivateKey);
            return lucid;
        }
        catch (error) {
            console.log(`[Lucid] - initializeLucidWithBlockfrostAndWalletFromPrivateKey - Error: ${error}`);
            throw error;
        }
    }; }
    static { this.initializeLucidWithBlockfrostAndExternalWallet = async (wallet) => {
        console.log('[Lucid] - initializeLucidWithBlockfrostAndExternalWallet');
        try {
            const lucid = await this.initializeLucidWithBlockfrost();
            lucid.selectWallet.fromAddress(wallet.address, wallet.utxos ?? []);
            return lucid;
        }
        catch (error) {
            console.log(`[Lucid] - initializeLucidWithBlockfrostAndExternalWallet - Error: ${error}`);
            throw error;
        }
    }; }
    static { this.initializeLucidWithEmulator = async (emulatorDB) => {
        console.log('[Lucid] - initializeLucidWithEmulator');
        try {
            // los emuladores supuestamente tienen el tiempo de cuando fueron creados y un zlot zero en ese tiempo
            // pero como yo estoy usando los emuladores, al crear lucid con new setea el slot zero en 0 y la fecha del emulador
            // pero el emulador en realidad no esta en slot 0, esta en otro mas avanzado
            // lo que hago aqui es setear el emulador como si estuviera en el tiempo en el que fue creado
            // asi lucid inicializa con ese tiempo y slot zero en 0
            // luego pongo al emulador en el tiempo que correspondia
            //-----------------
            const protocolParameters = _Commons_Constants_protocolParameters_js__WEBPACK_IMPORTED_MODULE_1__/* .protocolParametersForLucid */ .XP["Mainnet"];
            //-----------------
            const emulatorTime = emulatorDB.emulator.time;
            emulatorDB.emulator.time = Number(emulatorDB.zeroTime.toString());
            const lucid = await (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_0__/* .Lucid */ ._k)(emulatorDB.emulator, _Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .LUCID_NETWORK_CUSTOM_NAME */ .Rm5, { presetProtocolParameters: protocolParameters });
            emulatorDB.emulator.time = emulatorTime;
            return lucid;
        }
        catch (error) {
            console.log(`[Lucid] - initializeLucidWithEmulator - Error: ${error}`);
            throw error;
        }
    }; }
    static { this.initializeLucidWithEmulatorAndWalletFromSeed = async (emulatorDB, walletSeed, options) => {
        console.log(`[Lucid] - initializeLucidWithEmulatorAndWalletFromSeed`);
        try {
            const lucid = await this.initializeLucidWithEmulator(emulatorDB);
            lucid.selectWallet.fromSeed(walletSeed, options);
            return lucid;
        }
        catch (error) {
            console.log(`[Lucid] - initializeLucidWithEmulatorAndWalletFromSeed - Error: ${error}`);
            throw error;
        }
    }; }
    static { this.initializeLucidWithEmulatorAndWalletFromPrivateKey = async (emulatorDB, walletPrivateKey) => {
        console.log(`[Lucid] - initializeLucidWithEmulatorAndWalletFromPrivateKey`);
        try {
            const lucid = await this.initializeLucidWithEmulator(emulatorDB);
            lucid.selectWallet.fromPrivateKey(walletPrivateKey);
            return lucid;
        }
        catch (error) {
            console.log(`[Lucid] - initializeLucidWithEmulatorAndWalletFromPrivateKey - Error: ${error}`);
            throw error;
        }
    }; }
    static { this.initializeLucidWithEmulatorAndExternalWallet = async (emulatorDB, wallet) => {
        console.log(`[Lucid] - initializeLucidWithEmulatorAndExternalWallet`);
        try {
            const lucid = await this.initializeLucidWithEmulator(emulatorDB);
            lucid.selectWallet.fromAddress(wallet.address, wallet.utxos ?? []);
            return lucid;
        }
        catch (error) {
            console.log(`[Lucid] - initializeLucidWithEmulatorAndExternalWallet - Error: ${error}`);
            throw error;
        }
    }; }
    // #endregion initialize lucid
    // #region use lucid in front end
    static async prepareLucidForUseAsUtils(emulatorDB) {
        let lucid;
        try {
            console.log(`[Lucid] - prepareLucidForUseAsUtils`);
            if (_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isEmulator */ .Itp) {
                emulatorDB = emulatorDB ?? (await _FrontEnd_ApiCalls_Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_5__/* .BaseSmartDBFrontEndApiCalls.getOneByParamsApi */ .$.getOneByParamsApi(_Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__/* .EmulatorEntity */ .Z, { current: true }));
                if (emulatorDB === undefined) {
                    throw 'emulatorDB current not defined';
                }
                else {
                    lucid = await this.initializeLucidWithEmulator(emulatorDB);
                }
            }
            else {
                lucid = await this.initializeLucidWithBlockfrost();
            }
            return { lucid };
        }
        catch (error) {
            console.log(`[Lucid] - prepareLucidForUseAsUtils - Error: ${error}`);
            throw error;
        }
    }
    static async prepareLucidFrontEndForTx(walletStore) {
        try {
            console.log(`[Lucid] - prepareLucidFrontEndForTx`);
            //--------------------------------------
            if (walletStore.isConnected === false || walletStore.info === undefined) {
                throw `Wallet not connected`;
            }
            //--------------------------------------
            let emulatorDB;
            //--------------------------------------
            if (_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isEmulator */ .Itp) {
                //--------------------------------------
                // solo en emulator. Me aseguro de setear el emulador al tiempo real del server. Va a saltear los slots necesarios.
                await _Time_index_js__WEBPACK_IMPORTED_MODULE_8__/* .TimeApi.syncEmulatorBlockChainWithServerTimeApi */ .q.syncEmulatorBlockChainWithServerTimeApi();
                //--------------------------------------
                emulatorDB = await _FrontEnd_ApiCalls_Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_5__/* .BaseSmartDBFrontEndApiCalls.getOneByParamsApi */ .$.getOneByParamsApi(_Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__/* .EmulatorEntity */ .Z, { current: true });
                if (emulatorDB === undefined) {
                    throw `emulatorDB current not found`;
                }
            }
            //--------------------------------------
            const lucid = await walletStore.getLucid({ emulatorDB });
            if (lucid === undefined || lucid.wallet === undefined) {
                throw `wallet not ready yet`;
            }
            //--------------------------------------
            const address = await lucid.wallet().address();
            const rewardAddress = await lucid.wallet().rewardAddress();
            const utxos = await lucid.wallet().getUtxos();
            const walletTxParams = {
                pkh: walletStore.info.pkh,
                stakePkh: walletStore.info?.stakePkh,
                address,
                rewardAddress: rewardAddress === null ? undefined : rewardAddress,
                utxos,
            };
            return { lucid, emulatorDB, walletTxParams };
        }
        catch (error) {
            console.log(`[Lucid] - prepareLucidFrontEndForTx - Error: ${error}`);
            throw error;
        }
    }
    static async signAndSubmitTx(lucid, txCborHex, walletInfo, emulatorDB, swDoNotPromtForSigning = false) {
        try {
            console.log(`[Lucid] - signAndSubmitTx`);
            //--------------------------------------
            const txComplete = lucid.fromTx(txCborHex);
            //--------------------------------------
            const txCompleteHash = txComplete.toHash();
            //--------------------------------------
            const transaction = await _FrontEnd_ApiCalls_Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_6__/* .TransactionFrontEndApiCalls.getOneByParamsApi */ .T.getOneByParamsApi(_Entities_Transaction_Entity_js__WEBPACK_IMPORTED_MODULE_4__/* .TransactionEntity */ .e, { hash: txCompleteHash });
            //--------------------------------------
            try {
                //--------------------------------------
                // Set timeout to release UTXOs if the signing takes too long
                let timeoutId = setTimeout(async () => {
                    if (transaction) {
                        // alert(`Signing timeout reached! Releasing locked UTXOs for txHash: ${txHash}`);
                        console.warn(`[Lucid] - Signing timeout reached! Releasing locked isPreparing UTXOs for txHash: ${txCompleteHash}`);
                        await _FrontEnd_ApiCalls_Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_6__/* .TransactionFrontEndApiCalls.releaseUTxOsApi */ .T.releaseUTxOsApi(txCompleteHash, true, false);
                    }
                }, _Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .TX_PREPARING_TIME_MS */ .hbx);
                //--------------------------------------
                console.log(`[Lucid] - Tx Resources:`);
                console.warn((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .toJson */ .QsJ)((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getTxRedeemersDetailsAndResources */ .nUd)(txComplete)));
                //--------------------------------------
                let txCompleteSigned;
                try {
                    if (swDoNotPromtForSigning === false && (_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isEmulator */ .Itp || walletInfo?.isWalletFromSeed === true || walletInfo?.isWalletFromKey === true)) {
                        if (confirm('Sign and Submit Tx') === false) {
                            throw 'User canceled';
                        }
                    }
                    txCompleteSigned = await txComplete.sign.withWallet().complete();
                }
                catch (error) {
                    throw error;
                }
                //--------------------------------------
                // Signing completed successfully, clear the timeout
                clearTimeout(timeoutId);
                //--------------------------------------
                // NOTE: es importante usar el provider general de lucid y no el de la wallet, sobre todo en emulator, por que la wallet tiene un provider adentro que no se actualiza una vez que se crea la wallet en lucid
                // de esta forma el provider de lucid esta actualizado y bien podria conectar wallet nuevamente o no usar ningun metodo de wallet, usar siempre desde lucid
                // por ejemplo el getUTXO de la wallet no sirve, hay que llamar al utxosAt de lucid.
                const txCompleteSignedHash = await lucid.config().provider.submitTx(txCompleteSigned.toCBOR());
                //--------------------------------------
                if (_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isEmulator */ .Itp) {
                    if (walletInfo?.walletKey !== undefined) {
                        let walletKey = walletInfo.walletKey;
                        lucid.selectWallet.fromPrivateKey(walletKey);
                    }
                }
                //--------------------------------------
                if (txCompleteHash !== txCompleteSignedHash)
                    alert('txCompleteHash !== txCompleteSignedHash');
                //--------------------------------------
                if (_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isEmulator */ .Itp && emulatorDB !== undefined) {
                    // si es emulador tengo que usar awaitTx de lucid para que se agregue la tx al ledger del emulador de lucid
                    await lucid.awaitTx(txCompleteSignedHash);
                    // y guardarlo para que lo pueda leer en el backend
                    await LucidToolsFrontEnd.syncEmulatorAfterTx(lucid, emulatorDB);
                }
                //--------------------------------------
                if (transaction !== undefined) {
                    //--------------------------------------
                    // setea la tx en submitted e inicia el job en el server para actualizar el status revisando la blockchain
                    // el seteo se hace al llamar al begin status updater, en el back end
                    //--------------------------------------
                    await _FrontEnd_ApiCalls_Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_6__/* .TransactionFrontEndApiCalls.submitAndBeginStatusUpdaterJobApi */ .T.submitAndBeginStatusUpdaterJobApi(transaction.hash);
                }
                //--------------------------------------
                return txCompleteSignedHash;
                //--------------------------------------
            }
            catch (error) {
                if (transaction !== undefined) {
                    if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .checkIfUserCanceled */ .R0t)(error)) {
                        console.log(`[Lucid] - signAndSubmitTx - User canceled`);
                        await _FrontEnd_ApiCalls_Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_6__/* .TransactionFrontEndApiCalls.updateCanceledTransactionApi */ .T.updateCanceledTransactionApi(transaction.hash, { error, walletInfo });
                    }
                    else {
                        console.log(`[Lucid] - signAndSubmitTx - Error: ${error}`);
                        await _FrontEnd_ApiCalls_Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_6__/* .TransactionFrontEndApiCalls.updateFailedTransactionApi */ .T.updateFailedTransactionApi(transaction.hash, { error, walletInfo });
                    }
                }
                throw error;
            }
        }
        catch (error) {
            console.log(`[Lucid] - signAndSubmitTx - Error: ${error}`);
            throw error;
        }
    }
    static async awaitTxSimple(lucid, txHash) {
        try {
            //------------------------
            if (!_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isEmulator */ .Itp) {
                await (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .sleep */ ._vH)(_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .TX_CHECK_INTERVAL_MS */ .YS1);
            }
            //------------------------
            const result = await lucid.awaitTx(txHash);
            //------------------------
            if (!_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isEmulator */ .Itp) {
                await (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .sleep */ ._vH)(_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .TX_PROPAGATION_DELAY_MS */ .Fi7);
            }
            //------------------------
            return result;
        }
        catch (error) {
            console.log(`[Lucid] - awaitTx - Error: ${error}`);
            throw error;
        }
    }
    static async awaitTx(lucid, txHash) {
        try {
            // Initialize result
            let result = null;
            //------------------------
            if (!_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isEmulator */ .Itp) {
                await (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .sleep */ ._vH)(_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .TX_CHECK_INTERVAL_MS */ .YS1);
            }
            //------------------------
            // Start checking
            while (true) {
                //------------------------
                // Call your API to check if the transaction is confirmed
                //------------------------
                const txStatus = await _FrontEnd_ApiCalls_Transaction_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_6__/* .TransactionFrontEndApiCalls.getTransactionStatusApi */ .T.getTransactionStatusApi(txHash);
                if (txStatus === _Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .TRANSACTION_STATUS_CONFIRMED */ .Qnt) {
                    result = true;
                    break;
                }
                else if (txStatus === _Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .TRANSACTION_STATUS_FAILED */ .XqG) {
                    const error = _Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .TRANSACTION_STATUS_FAILED */ .XqG;
                    console.log(`[Lucid] - awaitTx - Error: ${error}`);
                    throw error;
                }
                else if (txStatus === _Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .TRANSACTION_STATUS_TIMEOUT */ .bsJ) {
                    const error = _Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .TRANSACTION_STATUS_TIMEOUT */ .bsJ;
                    console.log(`[Lucid] - awaitTx - Error: ${error}`);
                    throw error;
                }
                //------------------------
                // Sleep before the next iteration
                await (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .sleep */ ._vH)(_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .TX_CHECK_INTERVAL_MS */ .YS1);
            }
            //------------------------
            if (!_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isEmulator */ .Itp) {
                await (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .sleep */ ._vH)(_Commons_index_js__WEBPACK_IMPORTED_MODULE_2__/* .TX_PROPAGATION_DELAY_MS */ .Fi7);
            }
            //------------------------
            return result;
        }
        catch (error) {
            console.log(`[Lucid] - awaitTx - Error: ${error}`);
            throw error;
        }
    }
    static async syncEmulatorAfterTx(lucid, emulatorDB) {
        // cuando se hace la
        console.log(`[Lucid] - syncEmulatorAfterTx - Saving emulator ledger...`);
        emulatorDB.emulator = lucid.config().provider;
        await _FrontEnd_ApiCalls_Base_Base_SmartDB_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_5__/* .BaseSmartDBFrontEndApiCalls.updateApi */ .$.updateApi(emulatorDB);
    }
}
//--------------------------------------
//# sourceMappingURL=LucidTools.FrontEnd.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 69429:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* reexport safe */ _LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__.f; }
/* harmony export */ });
/* harmony import */ var _LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36142);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__]);
_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];

//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 38479:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ TimeApi; }
/* harmony export */ });
/* harmony import */ var _lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66527);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37813);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__]);
_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];


class TimeApi {
    static async getServerTimeApi() {
        try {
            //----------------------------
            const urlApi = "https://otc.mayz.io" + '/api/time/get';
            const requestOptions = {
                method: 'GET',
            };
            //----------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(urlApi, requestOptions);
            //----------------------------
            if (response.status === 200) {
                const data = await response.json();
                if (!data.serverTime) {
                    throw `Invalid response format: Server Time not found`;
                }
                console.log(`[Time] - getServerTimeApi - Server Time: ${data.serverTime} - ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .convertMillisToTime */ .yhV)(data.serverTime)} - response OK`);
                return data.serverTime;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //----------------------------
        }
        catch (error) {
            console.log(`[Time] - getServerTimeApi - Error: ${error}`);
            throw ` ${error}`;
        }
    }
    static async syncEmulatorBlockChainWithServerTimeApi() {
        try {
            //----------------------------
            const urlApi = "https://otc.mayz.io" + '/api/time/sync-emulator-blockchain-time';
            const requestOptions = {
                method: 'GET',
            };
            //----------------------------
            const response = await (0,_lib_FetchWrapper_FetchWrapper_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(urlApi, requestOptions);
            //----------------------------
            if (response.status === 200) {
                const data = await response.json();
                if (!data.serverTime) {
                    throw `Invalid response format: Server Time not found`;
                }
                console.log(`[Time] - syncBlockChainWithServerTimeApi - Server Time: ${data.serverTime} - response OK`);
                return data.serverTime;
            }
            else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
            //----------------------------
        }
        catch (error) {
            console.log(`[Time] - syncBlockChainWithServerTimeApi - Error: ${error}`);
            throw ` ${error}`;
        }
    }
}
//# sourceMappingURL=Time.FrontEnd.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 15165:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* reexport safe */ _Time_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__.q; }
/* harmony export */ });
/* harmony import */ var _Time_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38479);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Time_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__]);
_Time_FrontEnd_js__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];

//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 86624:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fm": function() { return /* reexport safe */ _Lucid_index_js__WEBPACK_IMPORTED_MODULE_4__.f; },
/* harmony export */   "qT": function() { return /* reexport safe */ _Time_index_js__WEBPACK_IMPORTED_MODULE_5__.q; }
/* harmony export */ });
/* harmony import */ var _Auth_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73006);
/* harmony import */ var _BlockFrost_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2461);
/* harmony import */ var _FetchWrapper_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72489);
/* harmony import */ var _JobManager_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90785);
/* harmony import */ var _Lucid_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69429);
/* harmony import */ var _Time_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15165);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Auth_index_js__WEBPACK_IMPORTED_MODULE_0__, _BlockFrost_index_js__WEBPACK_IMPORTED_MODULE_1__, _JobManager_index_js__WEBPACK_IMPORTED_MODULE_3__, _Lucid_index_js__WEBPACK_IMPORTED_MODULE_4__, _Time_index_js__WEBPACK_IMPORTED_MODULE_5__]);
([_Auth_index_js__WEBPACK_IMPORTED_MODULE_0__, _BlockFrost_index_js__WEBPACK_IMPORTED_MODULE_1__, _JobManager_index_js__WEBPACK_IMPORTED_MODULE_3__, _Lucid_index_js__WEBPACK_IMPORTED_MODULE_4__, _Time_index_js__WEBPACK_IMPORTED_MODULE_5__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);






//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 4166:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ AppStoreModel; }
/* harmony export */ });
/* harmony import */ var easy_peasy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27870);
/* harmony import */ var _Entities_SiteSettings_Entity_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73387);
/* harmony import */ var _FrontEnd_ApiCalls_Wallet_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39078);
/* harmony import */ var _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27001);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Entities_SiteSettings_Entity_js__WEBPACK_IMPORTED_MODULE_1__, _FrontEnd_ApiCalls_Wallet_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__]);
([_Entities_SiteSettings_Entity_js__WEBPACK_IMPORTED_MODULE_1__, _FrontEnd_ApiCalls_Wallet_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);




const AppStoreModel = {
    swInitApiCompleted: undefined,
    setSwInitApiCompleted: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, swInitApiCompleted) => {
        state.swInitApiCompleted = swInitApiCompleted;
    }),
    isNavigating: false,
    setIsNavigating: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, isNavigating) => {
        state.isNavigating = isNavigating;
    }),
    navigationTimeoutId: null,
    setNavigationTimeoutId: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, navigationTimeoutId) => {
        state.navigationTimeoutId = navigationTimeoutId;
    }),
    swExistAnyWallet: undefined,
    setSwExistAnyWallet: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, swExistAnyWallet) => {
        state.swExistAnyWallet = swExistAnyWallet;
    }),
    checkIfExistAnyWallet: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, _, helpers) => {
        const state = helpers.getState();
        console.log(`[AppStore] - checkIfExistAnyWallet - Init`);
        try {
            actions.setSwExistAnyWallet(undefined);
            //--------------------------------------
            const { count } = await _FrontEnd_ApiCalls_Wallet_FrontEnd_Api_Calls_js__WEBPACK_IMPORTED_MODULE_2__/* .WalletFrontEndApiCalls.getCountApi_ */ .G.getCountApi_();
            //--------------------------------------
            const result = count > 0;
            //--------------------------------------
            actions.setSwExistAnyWallet(result);
            //--------------------------------------
            console.log(`[AppStore] - checkIfExistAnyWallet - OK`);
            //--------------------------------------
            return result;
            //--------------------------------------
        }
        catch (error) {
            console.log(`[AppStore] - checkIfExistAnyWallet - Error: ${error}`);
            throw error;
        }
    }),
    siteSettings: undefined,
    setSiteSettings: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.siteSettings = new _Entities_SiteSettings_Entity_js__WEBPACK_IMPORTED_MODULE_1__/* .SiteSettingsEntity */ .L(payload);
    }),
    isAppStoreLoading: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => {
        return (state.swInitApiCompleted === false ||
            state.siteSettings === undefined ||
            state.swExistAnyWallet === undefined ||
            (_Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .isEmulator */ .It === true && state.emulatorDB === undefined));
    }),
    isAppStoreLoaded: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => {
        return (state.swInitApiCompleted === true ||
            (state.siteSettings !== undefined && state.swExistAnyWallet !== undefined && (_Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_3__/* .isEmulator */ .It === false || state.emulatorDB !== undefined)));
    }),
    isProcessingTx: false,
    setIsProcessingTx: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.isProcessingTx = payload;
    }),
    isFaildedTx: false,
    setIsFaildedTx: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.isFaildedTx = payload;
    }),
    isConfirmedTx: false,
    setIsConfirmedTx: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.isConfirmedTx = payload;
    }),
    processingTxName: '',
    setProcessingTxName: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.processingTxName = payload;
    }),
    processingTxMessage: '',
    setProcessingTxMessage: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.processingTxMessage = payload;
    }),
    processingTxHash: '',
    setProcessingTxHash: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.processingTxHash = payload;
    }),
    showUserConfirmation: false,
    setShowUserConfirmation: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.showUserConfirmation = payload;
    }),
    showProcessingTx: false,
    setShowProcessingTx: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.showProcessingTx = payload;
    }),
    isValidTx: true,
    setIsValidTx: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.isValidTx = payload;
    }),
    tokensGiveWithMetadata: [],
    setTokensGiveWithMetadata: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.tokensGiveWithMetadata = payload;
    }),
    tokensGetWithMetadata: [],
    setTokensGetWithMetadata: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.tokensGetWithMetadata = payload;
    }),
    isProcessingTask: false,
    setIsProcessingTask: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.isProcessingTask = payload;
    }),
    isFaildedTask: false,
    setIsFaildedTask: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.isFaildedTask = payload;
    }),
    isConfirmedTask: false,
    setIsConfirmedTask: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.isConfirmedTask = payload;
    }),
    processingTaskName: '',
    setProcessingTaskName: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.processingTaskName = payload;
    }),
    processingTaskMessage: '',
    setProcessingTaskMessage: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.processingTaskMessage = payload;
    }),
    showProcessingTask: false,
    setShowProcessingTask: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.showProcessingTask = payload;
    }),
};
//------------------------------------
//# sourceMappingURL=appStoreModel.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 56486:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X$": function() { return /* reexport safe */ _useGlobalStore_js__WEBPACK_IMPORTED_MODULE_0__.X$; },
/* harmony export */   "cr": function() { return /* reexport safe */ _useGlobalStore_js__WEBPACK_IMPORTED_MODULE_0__.cr; },
/* harmony export */   "qr": function() { return /* reexport safe */ _useGlobalStore_js__WEBPACK_IMPORTED_MODULE_0__.qr; }
/* harmony export */ });
/* harmony import */ var _useGlobalStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84134);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_0__]);
_useGlobalStore_js__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];


//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 80643:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ TokenStoreModel; }
/* harmony export */ });
/* harmony import */ var easy_peasy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27870);
/* harmony import */ var _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37813);
/* harmony import */ var _Entities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69302);
/* harmony import */ var _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25995);
/* harmony import */ var _lib_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86624);
/* harmony import */ var _Commons_formatters_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86081);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_index_js__WEBPACK_IMPORTED_MODULE_2__, _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_3__, _lib_index_js__WEBPACK_IMPORTED_MODULE_4__]);
([_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__, _Entities_index_js__WEBPACK_IMPORTED_MODULE_2__, _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_3__, _lib_index_js__WEBPACK_IMPORTED_MODULE_4__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);






const TokenStoreModel = {
    //----------------------------
    serverTime: undefined,
    setServerTime: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.serverTime = payload;
    }),
    //----------------------------
    serverTimeLastFetch: undefined,
    setServerTimeLastFetch: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.serverTimeLastFetch = payload;
    }),
    //----------------------------
    serverTimeDiffWithBrowser: undefined,
    setServerTimeDiffWithBrowser: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.serverTimeDiffWithBrowser = payload;
    }),
    //----------------------------
    isServerTimeLoaded: false,
    setIsServerTimeLoaded: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.isServerTimeLoaded = payload;
    }),
    //----------------------------
    getServerTime: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        //----------------------------
        let state = helpers.getState();
        //----------------------------
        let serverTime = undefined;
        let refreshServerTime = payload?.refresh ?? false;
        //----------------
        if (refreshServerTime === false && state.serverTime !== undefined && state.serverTimeLastFetch !== undefined) {
            // si pasaron mas de 10 minutos refresca siempre
            // si no, no refresca
            //--------------------------------------
            const now = Date.now();
            //--------------------------------------
            const diff = now - state.serverTimeLastFetch;
            refreshServerTime = diff > _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .SYNC_SERVER_TIME_ALWAYS_MS */ .hpm;
            //--------------------------------------
        }
        //----------------
        if (state.serverTime === undefined || state.serverTimeDiffWithBrowser === undefined || state.serverTimeLastFetch === undefined || refreshServerTime === true) {
            //--------------------------------------
            console.log(`[TokensStore] - getServerTime - get real from server`);
            //----------------------------
            serverTime = await _lib_index_js__WEBPACK_IMPORTED_MODULE_4__/* .TimeApi.getServerTimeApi */ .qT.getServerTimeApi();
            //--------------------------------------
            const now = Date.now();
            //--------------------------------------
            actions.setServerTime(serverTime);
            //console.log(`ServerTime: ${serverTime} - JUST FECTH FROM SERVER - ${convertMillisToTime(serverTime!)}`);
            actions.setServerTimeLastFetch(now);
            actions.setServerTimeDiffWithBrowser(serverTime - now);
            actions.setIsServerTimeLoaded(true);
            //--------------------------------------
        }
        else {
            //--------------------------------------
            const now = Date.now();
            serverTime = now + state.serverTimeDiffWithBrowser;
            actions.setServerTime(serverTime);
            //--------------------------------------
        }
        return serverTime;
    }),
    //---------------------------
    jobTokensToAdd: [],
    //---------------------------
    setJobTokensToAdd: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.jobTokensToAdd = payload;
    }),
    //---------------------------
    jobTokensToAddFinished: [],
    //---------------------------
    setJobTokensToAddFinished: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.jobTokensToAddFinished = payload;
    }),
    //---------------------------
    createJobTokensToAdd: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        //----------------------------
        const { job, tokens, followUp, keepAlive, swAddPrice, swAddMetadata, swCreateMetadataWhenNotFound } = payload;
        //----------------------------
        if (state.jobTokensToAdd.some((job) => job.job === payload.job)) {
            console.log(`[TokensStore] - Job: ${job} - createJobTokensToAdd - error job already exists`);
            return;
        }
        //----------------------------
        console.log(`[TokensStore] - Job: ${job} - createJobTokensToAdd - Tokens: ${tokens
            ?.map((t) => (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(t.TN_Hex))
            .join(', ')} - followUp: ${followUp} - swAddPrice: ${swAddPrice} - swAddMetadata: ${swAddMetadata} - swCreateMetadataWhenNotFound: ${swCreateMetadataWhenNotFound} - keepAlive: ${keepAlive}`);
        //----------------------------
        state.jobTokensToAdd.push(payload);
    }),
    //----------------------------
    getFinishedJobTokensToAdd: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (job) => {
        //----------------------------
        const tokensToAddJob = state.jobTokensToAddFinished.find((token) => token.job === job);
        //----------------------------
        if (tokensToAddJob === undefined) {
            return undefined;
        }
        //----------------------------
        // console.log(`[TokensStore] - Job: ${job} - getFinishedJobTokensToAdd - Init - len finished: ${state.jobTokensToAddFinished.length}`);
        //----------------------------
        const tokensToAddTokens = tokensToAddJob.tokens;
        const tokensWithMetadataAndPrice = tokensToAddTokens
            .map((token) => {
            return state.tokensWithDetails.find((token_) => token_.CS === token.CS && token_.TN_Hex === token.TN_Hex) || undefined;
        })
            .filter((token) => token !== undefined); // Filter out any null values (tokens not found)
        //----------------------------
        state.jobTokensToAddFinished = [...state.jobTokensToAddFinished].filter((tokenJob) => tokenJob.job !== job);
        //----------------------------
        // console.log(`[TokensStore] - Job: ${job} - getFinishedJobTokensToAdd - OK - len finished: ${state.jobTokensToAddFinished.length} - len tokens: ${tokensWithMetadataAndPrice.length}`);
        //-----------------------
        console.log(`[TokensStore] - Job: ${job} - getFinishedJobTokensToAdd - OK - Tokens: ${tokensWithMetadataAndPrice?.map((t) => (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(t?.TN_Hex)).join(', ')}`);
        //-----------------------
        return tokensWithMetadataAndPrice;
    }),
    //----------------------------
    isExecuting: false,
    setIsExecuting: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.isExecuting = payload;
    }),
    //----------------------------
    executeJobsTokensToAdd: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        //----------------------------
        // console.log(`[TokensStore] - executeJobsTokensToAdd - Init`);
        //----------------------------
        let state = helpers.getState();
        //----------------------------
        const jobTokensToAdd = [...state.jobTokensToAdd];
        //----------------------------
        actions.setIsExecuting(true);
        actions.setJobTokensToAdd([]);
        //----------------------------
        // let count = 0;
        // for (const tokenToAdd of jobTokensToAdd) {
        //     console.log(`[TokensStore] - executing adding tokens - Job: ${tokenToAdd.job} - ${count++ + 1} of ${state.jobTokensToAdd.length}`);
        //     await actions.addTokens({
        //         tokens: tokenToAdd.tokens,
        //         swAddPrice: tokenToAdd.swAddPrice,
        //         swAddMetadata: tokenToAdd.swAddMetadata,
        //         followUp: tokenToAdd.followUp,
        //         keepAlive: tokenToAdd.keepAlive,
        //     });
        // }
        //----------------------------
        const groupedJobs = jobTokensToAdd.reduce((acc, tokenToAdd) => {
            //----------------------------
            const key = `${tokenToAdd.swAddPrice}-${tokenToAdd.swAddMetadata}-${tokenToAdd.swCreateMetadataWhenNotFound}-${tokenToAdd.followUp}-${tokenToAdd.keepAlive}`;
            //----------------------------
            if (!acc[key]) {
                acc[key] = {
                    tokens: [],
                    swAddPrice: tokenToAdd.swAddPrice,
                    swAddMetadata: tokenToAdd.swAddMetadata,
                    swCreateMetadataWhenNotFound: tokenToAdd.swCreateMetadataWhenNotFound,
                    followUp: tokenToAdd.followUp,
                    keepAlive: tokenToAdd.keepAlive,
                    job: '',
                };
            }
            //----------------------------
            acc[key].tokens.push(...tokenToAdd.tokens);
            acc[key].job = acc[key].job + (acc[key].job.length > 0 ? ', ' : '') + tokenToAdd.job;
            //----------------------------
            return acc;
        }, {});
        //----------------------------
        let count = 0;
        //----------------------------
        const keys = Object.keys(groupedJobs);
        //----------------------------
        for (const key of keys) {
            //----------------------------
            console.log(`[TokensStore] - executing adding grouped tokens - Group: ${count + 1} of ${keys.length} - Jobs: ${groupedJobs[key].job}`);
            //----------------------------
            await actions.addTokens({
                tokens: groupedJobs[key].tokens,
                swAddPrice: groupedJobs[key].swAddPrice,
                swAddMetadata: groupedJobs[key].swAddMetadata,
                swCreateMetadataWhenNotFound: groupedJobs[key].swCreateMetadataWhenNotFound,
                followUp: groupedJobs[key].followUp,
                keepAlive: groupedJobs[key].keepAlive,
            });
            //----------------------------
            count++;
        }
        //----------------------------
        // state = helpers.getState();
        //----------------------------
        actions.setJobTokensToAddFinished([...state.jobTokensToAddFinished, ...jobTokensToAdd]);
        //----------------------------
        actions.setIsExecuting(false);
        //----------------------------
        // console.log(`[TokensStore] - executeJobsTokensToAdd - All Jobs done`);
        //----------------------------
        return true;
    }),
    //----------------------------
    tokensWithDetails: [],
    setTokensWithDetails_: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.tokensWithDetails = payload;
    }),
    //----------------------------
    setTokensWithDetails: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        //----------------------------
        console.log(`[TokensStore] - setTokensWithDetails - ${payload.map((token) => `${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(token.TN_Hex)}`).join(', ')}`);
        //----------------------------
        const tokensWithDetails = payload;
        actions.setTokensWithDetails_(tokensWithDetails);
        //----------------
        let serverTime = await actions.getServerTime();
        //----------------
        if (serverTime === undefined) {
            throw `serverTime is undefined`;
        }
        //----------------
        const newTokensWithDetailsAndValidity = [];
        //----------------
        tokensWithDetails
            .filter((token) => token.followUp === true)
            .map((token) => {
            if (token !== undefined && token.date !== undefined) {
                const currentTimeMs = serverTime;
                const priceTimeMs = Number(token.date.toString());
                const expiryTimeMs = priceTimeMs + _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .MAX_PRICE_AGE_FOR_USE_MS */ .$dX;
                const validTimeSecs = BigInt(Math.floor((expiryTimeMs - currentTimeMs) / 1000));
                const newTokenWithDetailsAndValidity = { ...token, validity: validTimeSecs };
                newTokensWithDetailsAndValidity.push(newTokenWithDetailsAndValidity);
            }
        });
        //----------------
        actions.setTokensWithDetailsAndValidity(newTokensWithDetailsAndValidity);
        //----------------
        // if (doLoop) {
        //     await actions.beginUpdateLoop({ doUpdatePricesAutomatically: state.doUpdatePricesAutomatically });
        // }
        //----------------
    }),
    //----------------------------
    tokensWithDetailsAndValidity: [],
    setTokensWithDetailsAndValidity: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.tokensWithDetailsAndValidity = payload;
    }),
    //----------------------------
    isAddingTokens: false,
    setIsAddingTokens: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.isAddingTokens = payload;
    }),
    //----------------------------
    intervalIdForUpdateLoop: undefined,
    setIntervalIdForUpdateLoop: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.intervalIdForUpdateLoop = payload;
    }),
    //----------------------------
    doUpdatePricesAutomatically: true,
    setDoUpdatePricesAutomatically: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.doUpdatePricesAutomatically = payload;
    }),
    //----------------------------
    beginUpdateLoop: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        //----------------------------
        console.log(`[TokensStore] - beginUpdateLoop`);
        //----------------------------
        let state = helpers.getState();
        //----------------------------
        if (state.intervalIdForUpdateLoop !== undefined) {
            clearInterval(state.intervalIdForUpdateLoop);
            actions.setIntervalIdForUpdateLoop(undefined);
        }
        //----------------------------
        let intervalIdForUpdateLoop = undefined;
        //----------------
        actions.setDoUpdatePricesAutomatically(payload?.doUpdatePricesAutomatically ?? true);
        //----------------
        const updateLoop = async () => {
            //----------------------------
            // console.log(`[TokensStore] - updateLoop`);
            //----------------------------
            let state = helpers.getState();
            //----------------------------
            const newTokensWithDetailsAndValidity = [];
            const newInvalidTokensWithDetailsAndValidity = [];
            //----------------------------
            let serverTime = await actions.getServerTime();
            //----------------
            for (const token_ of state.tokensWithDetails) {
                //----------------------------
                if (token_ !== undefined && token_.date !== undefined && token_.followUp === true) {
                    //----------------------------
                    serverTime = await actions.getServerTime();
                    //----------------
                    //console.log(`ServerTime: ${serverTime} - ${convertMillisToTime(serverTime!)}`);
                    //----------------
                    if (serverTime === undefined) {
                        throw `serverTime is undefined`;
                    }
                    //----------------
                    const currentTimeMs = serverTime;
                    const priceTimeMs = Number(token_.date.toString());
                    const expiryTimeMs = priceTimeMs + _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .MAX_PRICE_AGE_FOR_USE_MS */ .$dX;
                    //----------------
                    const validTimeSecs = BigInt(Math.floor((expiryTimeMs - currentTimeMs) / 1000));
                    //----------------
                    const newTokenWithDetailsAndValidity = { ...token_, validity: validTimeSecs };
                    //----------------
                    newTokensWithDetailsAndValidity.push(newTokenWithDetailsAndValidity);
                    //----------------
                    if (validTimeSecs < 0 && state.doUpdatePricesAutomatically) {
                        newInvalidTokensWithDetailsAndValidity.push(newTokenWithDetailsAndValidity);
                    }
                    //----------------
                }
            }
            //----------------
            actions.setTokensWithDetailsAndValidity(newTokensWithDetailsAndValidity);
            //----------------
            if (state.doUpdatePricesAutomatically === true && newInvalidTokensWithDetailsAndValidity.length > 0) {
                //----------------
                console.log(`[TokensStore] - isLoading Previus: - ${state.isAddingTokens}`);
                // console.log ('setDoUpdatePricesAutomatically2');
                // alert('setDoUpdatePricesAutomatically2');
                //----------------
                actions.setIsAddingTokens(true);
                //----------------
                const newTokensWithDetails = state.tokensWithDetails;
                //----------------
                let tokensToUpdateWithNewPrices = [];
                //----------------
                try {
                    tokensToUpdateWithNewPrices = await _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_3__/* .PriceFrontEndApiCalls.get_Tokens_PriceADAx1e6_Api */ .GI.get_Tokens_PriceADAx1e6_Api(newInvalidTokensWithDetailsAndValidity.map((token) => ({ CS: token.CS, TN_Hex: token.TN_Hex })), true);
                }
                catch (error) {
                    console.error(`[TokensStore] - Error getting tokens prices: ${error}`);
                }
                //----------------
                newInvalidTokensWithDetailsAndValidity.map((token) => {
                    const tokenToUpdateWithNewPrice = tokensToUpdateWithNewPrices.find((token_) => token_.CS === token.CS && token_.TN_Hex === token.TN_Hex);
                    if (tokenToUpdateWithNewPrice !== undefined) {
                        token.priceADAx1e6 = tokenToUpdateWithNewPrice?.priceADAx1e6;
                        token.date = tokenToUpdateWithNewPrice?.date;
                        token.signature = tokenToUpdateWithNewPrice?.signature;
                        //----------------------------
                        const index = newTokensWithDetails.findIndex((token_) => token.CS === token_.CS && token.TN_Hex === token_.TN_Hex);
                        newTokensWithDetails[index] = token;
                        //----------------------------
                    }
                });
                //----------------------------
                actions.setTokensWithDetails(newTokensWithDetails);
                //----------------------------
                actions.setIsAddingTokens(false);
                //----------------------------
            }
        };
        //----------------
        await updateLoop(); // Call it once immediately
        //----------------
        intervalIdForUpdateLoop = setInterval(updateLoop, 1000); // Then set up the interval
        //----------------
        actions.setIntervalIdForUpdateLoop(intervalIdForUpdateLoop);
        //----------------
        // Handle the cleanup (interval clearing) when the component unmounts or tokensWithDetails changes
        // When you call this thunk inside a useEffect in your component,
        // it ensures that the interval gets cleared when the component unmounts or when the dependencies change.
        // useEffect(() => {
        //     return () => {
        //         tokensStore.stopUpdateLoop();
        //     };
        // }, []);
        return intervalIdForUpdateLoop;
    }),
    //----------------------------
    stopUpdateLoop: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        //----------------------------
        const cancelFollowUp = payload?.cancelFollowUp ?? false;
        //----------------------------
        console.log(`[TokensStore] - stopUpdateLoop`);
        //----------------------------
        let state = helpers.getState();
        //----------------------------
        if (state.intervalIdForUpdateLoop !== undefined) {
            clearInterval(state.intervalIdForUpdateLoop);
            actions.setIntervalIdForUpdateLoop(undefined);
        }
        //-----------------------
        if (cancelFollowUp === true) {
            //-----------------------
            //set followUp to false for all tokens
            const newTokensWithDetails = [...state.tokensWithDetails.map((token) => ({ ...token, followUp: false }))]; // Create a copy
            //-----------------------
            await actions.setTokensWithDetails(newTokensWithDetails);
            //----------------------------
        }
    }),
    //----------------------------
    cleanStore: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        //----------------------------
        console.log(`[TokensStore] - cleanStore`);
        //----------------------------
        await actions.stopUpdateLoop();
        //----------------------------
        actions.setJobTokensToAdd([]);
        actions.setJobTokensToAddFinished([]);
        await actions.setTokensWithDetails([]);
        //----------------------------
    }),
    //----------------------------
    addToken: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        //----------------------------
        const { token: newToken } = payload;
        const swAddPrice = payload.swAddPrice ?? true;
        const swAddMetadata = payload.swAddMetadata ?? true;
        const swCreateMetadataWhenNotFound = payload.swCreateMetadataWhenNotFound ?? true;
        const followUp = payload.followUp;
        const keepAlive = payload.keepAlive;
        //----------------------------
        const results = await actions.addTokens({ tokens: [newToken], swAddPrice, swAddMetadata, swCreateMetadataWhenNotFound, followUp, keepAlive });
        //----------------------------
        if (results.length > 0) {
            return results[0];
        }
        //----------------------------
    }),
    //----------------------------
    addTokens: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        //----------------------------
        const { tokens: newTokens } = payload;
        const swAddPrice = payload.swAddPrice ?? true;
        const swAddMetadata = payload.swAddMetadata ?? true;
        const swCreateMetadataWhenNotFound = payload.swCreateMetadataWhenNotFound ?? true;
        const followUp = payload.followUp;
        const keepAlive = payload.keepAlive;
        //----------------------------
        console.log(`[TokensStore] - addTokens - Tokens: ${newTokens
            .map((token) => `${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(token.TN_Hex)}`)
            .join(', ')} - followUp: ${followUp} - swAddPrice: ${swAddPrice} - swAddMetadata: ${swAddMetadata} - swCreateMetadataWhenNotFound: ${swCreateMetadataWhenNotFound} -keepAlive: ${keepAlive}`);
        //----------------------------
        let state = helpers.getState();
        //----------------------------
        const tokensAll = newTokens;
        //-----------------------
        //get all the differents
        const uniqueTokensMap = new Map();
        tokensAll.forEach((token) => {
            const uniqueKey = `${token.CS}-${token.TN_Hex}`; // Combine CS and TN_Hex to create a unique key
            if (!uniqueTokensMap.has(uniqueKey)) {
                uniqueTokensMap.set(uniqueKey, token);
            }
        });
        //-----------------------
        const uniqueTokens = Array.from(uniqueTokensMap.values());
        //-----------------------
        if (uniqueTokens.some((newToken) => (newToken.priceADAx1e6 === undefined && swAddPrice) ||
            ((newToken.ticker === undefined || newToken.decimals === undefined || newToken.image === undefined || newToken.colorHex === undefined) && swAddMetadata))) {
            //    || newToken.metadata_raw === undefined
            actions.setIsAddingTokens(true);
        }
        //-----------------------
        let newTokensWithDetails = [...state.tokensWithDetails]; // Create a copy
        //-----------------------
        const tokensToUpdatePrice = [];
        const tokensToUpdatePriceWithForceRefresh = [];
        const tokensToUpdateMetadata = [];
        //-----------------------
        for (const newToken of uniqueTokens) {
            //----------------------------
            if (!(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isToken_CS_And_TN_Valid */ .V8b)(newToken.CS, newToken.TN_Hex)) {
                console.error(`[TokensStore] - addTokens - invalid CS or TN_Hex - ${newToken.CS} - ${newToken.TN_Hex}`);
                continue;
            }
            //-----------------------
            const priceIndex = newTokensWithDetails.findIndex((price) => price.CS === newToken.CS && price.TN_Hex === newToken.TN_Hex);
            //-----------------------
            if (priceIndex === -1) {
                // si no lo estoy siguiendo
                //-----------------------
                if ((newToken.priceADAx1e6 === undefined || newToken.date === undefined) && swAddPrice) {
                    //-----------------------
                    const finalFolloUp = newToken.followUp ?? followUp;
                    //-----------------------
                    if (finalFolloUp === true) {
                        tokensToUpdatePriceWithForceRefresh.push(newToken);
                    }
                    else {
                        tokensToUpdatePrice.push(newToken);
                    }
                }
                //-----------------------
                if ((newToken.ticker === undefined || newToken.decimals === undefined || newToken.image === undefined || newToken.colorHex === undefined) && swAddMetadata) {
                    tokensToUpdateMetadata.push(newToken);
                }
            }
            else {
                //-----------------------
                // si lo estoy siguiendo,
                //-----------------------
                const oldToken = newTokensWithDetails[priceIndex];
                //-----------------------
                // primero reviso si el nuevo token tiene o no precio y si quiero tenerlo
                //-----------------------
                if ((newToken.priceADAx1e6 === undefined || newToken.date === undefined) && swAddPrice) {
                    //-----------------------
                    const finalFolloUp = newToken.followUp ?? followUp;
                    //-----------------------
                    if (finalFolloUp === true) {
                        tokensToUpdatePriceWithForceRefresh.push(newToken);
                    }
                    else {
                        // si no tiene precio, quiero tenerlo, pero no es folloUp, puedo ver si el antiguo tiene, si no, lo busco
                        if (oldToken.priceADAx1e6 === undefined || oldToken.date === undefined) {
                            tokensToUpdatePrice.push(newToken);
                        }
                    }
                }
                //-----------------------
                // luego reviso si el nuevo token tiene o no metadata y si quiero tenerla
                if ((newToken.ticker === undefined || newToken.decimals === undefined || newToken.image === undefined || newToken.colorHex === undefined) && swAddMetadata) {
                    // si no tiene metadata, quiero tenerla, puedo ver si el antiguo tiene, si no, lo busco
                    if (oldToken.ticker === undefined || oldToken.decimals === undefined || oldToken.image === undefined || oldToken.colorHex === undefined) {
                        tokensToUpdateMetadata.push(newToken);
                    }
                }
            }
        }
        //-----------------------
        let tokensToUpdateWithNewPrices = [];
        if (tokensToUpdatePrice.length > 0) {
            //-----------------------
            console.log(`[TokensStore] - addTokens - Tokens: ${tokensToUpdatePrice.map((token) => `${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(token.TN_Hex)}`).join(', ')} - Fetching prices...`);
            //-----------------------
            tokensToUpdateWithNewPrices = await _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_3__/* .PriceFrontEndApiCalls.get_Tokens_PriceADAx1e6_Api */ .GI.get_Tokens_PriceADAx1e6_Api(tokensToUpdatePrice.map((token) => ({ CS: token.CS, TN_Hex: token.TN_Hex })), false, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .MAX_PRICE_AGE_FOR_APROXIMATED_USE_MS */ .YW2);
        }
        let tokensToUpdateWithForceRefreshWithNewPrices = [];
        if (tokensToUpdatePriceWithForceRefresh.length > 0) {
            //-----------------------
            console.log(`[TokensStore] - addTokens - Tokens: ${tokensToUpdatePriceWithForceRefresh.map((token) => `${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(token.TN_Hex)}`).join(', ')} - Fetching prices...`);
            //-----------------------
            tokensToUpdateWithForceRefreshWithNewPrices = await _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_3__/* .PriceFrontEndApiCalls.get_Tokens_PriceADAx1e6_Api */ .GI.get_Tokens_PriceADAx1e6_Api(tokensToUpdatePriceWithForceRefresh.map((token) => ({ CS: token.CS, TN_Hex: token.TN_Hex })), true);
        }
        let tokensToUpdateMetadataWithNewMetadata = [];
        if (tokensToUpdateMetadata.length > 0) {
            //-----------------------
            console.log(`[TokensStore] - addTokens - Tokens: ${tokensToUpdateMetadata.map((token) => `${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(token.TN_Hex)}`).join(', ')} - Fetching metadatas...`);
            //-----------------------
            tokensToUpdateMetadataWithNewMetadata = await _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_3__/* .TokenMetadataFrontEndApiCalls.get_Tokens_MetadataApi */ .Gx.get_Tokens_MetadataApi(tokensToUpdateMetadata.map((token) => ({ CS: token.CS, TN_Hex: token.TN_Hex })), undefined, swCreateMetadataWhenNotFound, _Entities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .TokenMetadataEntity.optionsGetForTokenStore */ .Qc.optionsGetForTokenStore);
        }
        //----------------
        for (const newToken of uniqueTokens) {
            //-----------------------
            let tokenToUpdateWithNewPrice = tokensToUpdateWithNewPrices.find((token_) => token_.CS === newToken.CS && token_.TN_Hex === newToken.TN_Hex);
            //-----------------------
            if (tokenToUpdateWithNewPrice === undefined) {
                tokenToUpdateWithNewPrice = tokensToUpdateWithForceRefreshWithNewPrices.find((token_) => token_.CS === newToken.CS && token_.TN_Hex === newToken.TN_Hex);
            }
            //-----------------------
            if (tokenToUpdateWithNewPrice !== undefined) {
                newToken.priceADAx1e6 = tokenToUpdateWithNewPrice.priceADAx1e6;
                newToken.date = tokenToUpdateWithNewPrice.date;
                newToken.signature = tokenToUpdateWithNewPrice.signature;
            }
            //-----------------------
            const tokenToUpdateMetadataWithNewMetadata = tokensToUpdateMetadataWithNewMetadata.find((token_) => token_.CS === newToken.CS && token_.TN_Hex === newToken.TN_Hex);
            //-----------------------
            if (tokenToUpdateMetadataWithNewMetadata !== undefined) {
                newToken.ticker = tokenToUpdateMetadataWithNewMetadata.ticker;
                newToken.decimals = tokenToUpdateMetadataWithNewMetadata.decimals;
                newToken.image = tokenToUpdateMetadataWithNewMetadata.image;
                newToken.colorHex = tokenToUpdateMetadataWithNewMetadata.colorHex;
                newToken.metadata_raw = tokenToUpdateMetadataWithNewMetadata.metadata_raw;
            }
            //-----------------------
            const priceIndex = newTokensWithDetails.findIndex((price) => price.CS === newToken.CS && price.TN_Hex === newToken.TN_Hex);
            //-----------------------
            if (priceIndex === -1) {
                //-----------------------
                const newTokenToAdd = {
                    ...newToken,
                    CS: newToken.CS,
                    TN_Hex: newToken.TN_Hex,
                    decimals: newToken.decimals,
                    priceADAx1e6: newToken.priceADAx1e6,
                    date: newToken.date,
                    signature: newToken.signature,
                    isFT: newToken.isFT ?? false,
                    tokensInFT: newToken.tokensInFT ?? [],
                    followUp: newToken.followUp ?? followUp,
                    keepAlive: newToken.keepAlive ?? keepAlive,
                };
                //-----------------------
                newTokensWithDetails.push(newTokenToAdd); // Update the copy
                //-----------------------
                // Separate items into two lists based on `keepAlive`
                const keepAliveItems = newTokensWithDetails.filter((item) => item.keepAlive === true);
                const nonKeepAliveItems = newTokensWithDetails.filter((item) => !(item.keepAlive === true));
                // If nonKeepAliveItems list is longer than 30, remove the first item
                if (nonKeepAliveItems.length > 30) {
                    nonKeepAliveItems.shift(); // Removes the first item of the nonKeepAliveItems list
                }
                // Concatenate the modified nonKeepAliveItems list back with the keepAliveItems list
                newTokensWithDetails = [...keepAliveItems, ...nonKeepAliveItems];
                //-----------------------
            }
            else {
                //-----------------------
                // si lo estoy siguiendo, veo si la fecha del actual es mayor a la del guardado o si en el guardado no tenia fecha
                // ademas controlo que tenga precio antes de suplantarlo
                //-----------------------
                const oldToken = newTokensWithDetails[priceIndex];
                //-----------------------
                let oldTokenUpdated = {
                    ...oldToken,
                };
                //-----------------------
                let swUpdate = false;
                //-----------------------
                const updatePriceADA = (0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isTokenADA */ .Gre)(oldTokenUpdated.CS, oldTokenUpdated.TN_Hex) && newToken.priceADAx1e6 !== undefined;
                const updatePriceOthers = !(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isTokenADA */ .Gre)(oldTokenUpdated.CS, oldTokenUpdated.TN_Hex) &&
                    newToken.date !== undefined &&
                    newToken.priceADAx1e6 !== undefined &&
                    ((oldToken.date !== undefined && newToken.date > oldToken.date) || oldToken.priceADAx1e6 === undefined || oldToken.date === undefined);
                //-----------------------
                if (updatePriceADA || updatePriceOthers) {
                    //-----------------------
                    // si existe voy a actualizarlo
                    //-----------------------
                    oldTokenUpdated = {
                        ...oldTokenUpdated,
                        priceADAx1e6: newToken.priceADAx1e6,
                        date: newToken.date,
                        signature: newToken.signature,
                    };
                    //-----------------------
                    swUpdate = true;
                    //-----------------------
                }
                //-----------------------
                if (newToken.ticker !== undefined) {
                    //-----------------------
                    oldTokenUpdated = {
                        ...oldTokenUpdated,
                        ticker: newToken.ticker,
                    };
                    //-----------------------
                    swUpdate = true;
                    //-----------------------
                }
                if (newToken.decimals !== undefined) {
                    //-----------------------
                    oldTokenUpdated = {
                        ...oldTokenUpdated,
                        decimals: newToken.decimals,
                    };
                    //-----------------------
                    swUpdate = true;
                    //-----------------------
                }
                if (newToken.image !== undefined) {
                    //-----------------------
                    oldTokenUpdated = {
                        ...oldTokenUpdated,
                        image: newToken.image,
                    };
                    //-----------------------
                    swUpdate = true;
                    //-----------------------
                }
                if (newToken.colorHex !== undefined) {
                    //-----------------------
                    oldTokenUpdated = {
                        ...oldTokenUpdated,
                        colorHex: newToken.colorHex,
                    };
                    //-----------------------
                    swUpdate = true;
                    //-----------------------
                }
                if (newToken.metadata_raw !== undefined) {
                    //-----------------------
                    oldTokenUpdated = {
                        ...oldTokenUpdated,
                        metadata_raw: newToken.metadata_raw,
                    };
                    //-----------------------
                    swUpdate = true;
                    //-----------------------
                }
                //-----------------------
                const finalFolloUp = newToken.followUp ?? followUp;
                //-----------------------
                if (finalFolloUp !== undefined) {
                    //-----------------------
                    oldTokenUpdated = {
                        ...oldTokenUpdated,
                        followUp: finalFolloUp,
                    };
                    //-----------------------
                    swUpdate = true;
                    //-----------------------
                }
                //-----------------------
                const finalkeepAlive = newToken.keepAlive ?? keepAlive;
                //-----------------------
                if (finalkeepAlive !== undefined) {
                    //-----------------------
                    oldTokenUpdated = {
                        ...oldTokenUpdated,
                        keepAlive: finalkeepAlive,
                    };
                    //-----------------------
                    swUpdate = true;
                    //-----------------------
                }
                //-----------------------
                if (newToken.isFT !== undefined) {
                    //-----------------------
                    oldTokenUpdated = {
                        ...oldTokenUpdated,
                        isFT: newToken.isFT,
                    };
                    //-----------------------
                    swUpdate = true;
                    //-----------------------
                }
                //-----------------------
                if (newToken.tokensInFT !== undefined) {
                    //-----------------------
                    oldTokenUpdated = {
                        ...oldTokenUpdated,
                        tokensInFT: newToken.tokensInFT,
                    };
                    //-----------------------
                    swUpdate = true;
                    //-----------------------
                }
                //-----------------------
                if (swUpdate === true) {
                    //-----------------------
                    newTokensWithDetails[priceIndex] = oldTokenUpdated; // Update the copy
                    //-----------------------
                }
            }
        }
        //-----------------------
        await actions.setTokensWithDetails(newTokensWithDetails);
        //-----------------------
        state = helpers.getState();
        //-----------------------
        const result = state.getTokensPriceAndMetadata(uniqueTokens);
        //-----------------------
        actions.setIsAddingTokens(false);
        //-----------------------
        console.log(`[TokensStore] - addTokens - OK - Tokens: ${uniqueTokens.map((token) => `${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(token.TN_Hex)}`).join(', ')}`);
        //-----------------------
        return result;
        //-----------------------
    }),
    //----------------------------
    removeToken: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, token, helpers) => {
        //----------------------------
        console.log(`[TokensStore] - removeToken`);
        //----------------------------
        let state = helpers.getState();
        //----------------------------
        const newTokensWithDetails = [...state.tokensWithDetails].filter((token_) => !(token_.CS === token.CS && token_.TN_Hex === token.TN_Hex));
        //----------------------------
        await actions.setTokensWithDetails(newTokensWithDetails);
        //----------------------------
        if (newTokensWithDetails.length === 0 && state.intervalIdForUpdateLoop !== undefined) {
            await actions.stopUpdateLoop();
        }
        //----------------------------
    }),
    //----------------------------
    refreshPrices: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        //----------------------------
        //TODO: forceRefresh estaba defualt true, no se por que, lo puse false
        const forceRefresh = payload?.forceRefresh ?? false;
        const forceUseOracle = payload?.forceUseOracle ?? false;
        //----------------------------
        console.log(`[TokensStore] - refreshPrices - forceRefresh: ${forceRefresh} - forceUseOracle: ${forceUseOracle}`);
        //----------------------------
        let state = helpers.getState();
        //----------------
        actions.getServerTime({ refresh: true });
        //----------------
        const newTokensWithDetails = [];
        //----------------
        const tokensToUpdate = state.tokensWithDetails.filter((token) => token.followUp === true);
        const tokensNoUpdate = state.tokensWithDetails.filter((token) => token.followUp !== true);
        //----------------
        if (tokensToUpdate.length === 0) {
            console.error(`[TokensStore] - Nothing to update`);
            return;
        }
        //----------------
        actions.setIsAddingTokens(true);
        //----------------
        let tokensToUpdateWithNewPrices = [];
        try {
            tokensToUpdateWithNewPrices = await _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_3__/* .PriceFrontEndApiCalls.get_Tokens_PriceADAx1e6_Api */ .GI.get_Tokens_PriceADAx1e6_Api(tokensToUpdate.map((token) => ({ CS: token.CS, TN_Hex: token.TN_Hex })), forceRefresh, undefined, forceUseOracle);
        }
        catch (error) {
            console.error(`[TokensStore] - Error getting tokens prices: ${error}`);
        }
        //----------------
        tokensToUpdate.map((token) => {
            const tokenToUpdateWithNewPrice = tokensToUpdateWithNewPrices.find((token_) => token_.CS === token.CS && token_.TN_Hex === token.TN_Hex);
            if (tokenToUpdateWithNewPrice !== undefined) {
                token.priceADAx1e6 = tokenToUpdateWithNewPrice?.priceADAx1e6;
                token.date = tokenToUpdateWithNewPrice?.date;
                token.signature = tokenToUpdateWithNewPrice?.signature;
                newTokensWithDetails.push(token);
            }
            else {
                newTokensWithDetails.push(token);
            }
        });
        //----------------
        newTokensWithDetails.push(...tokensNoUpdate);
        //----------------
        actions.setIsAddingTokens(false);
        //----------------
        await actions.setTokensWithDetails(newTokensWithDetails);
        //----------------
    }),
    //----------------------------
    isTokenPriceValid: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (CS, TN_Hex) => {
        //-----------------------
        if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isTokenADA */ .Gre)(CS, TN_Hex)) {
            return true;
        }
        //-----------------------
        const validity = state.getTokenValidity(CS, TN_Hex);
        //-----------------------
        if (validity !== undefined) {
            const secondsLeft = Number(validity);
            if (secondsLeft > 0) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }),
    //----------------------------
    getTokenValidity: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (CS, TN_Hex) => {
        //-----------------------
        if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isTokenADA */ .Gre)(CS, TN_Hex)) {
            return BigInt(Number.MAX_SAFE_INTEGER);
        }
        //-----------------------
        const tokenIndex = state.tokensWithDetailsAndValidity.findIndex((token) => token.CS === CS && token.TN_Hex === TN_Hex);
        if (tokenIndex !== -1) {
            return state.tokensWithDetailsAndValidity[tokenIndex].validity;
        }
        else {
            return undefined;
        }
    }),
    //----------------------------
    getTokenPriceAndMetadata: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (CS, TN_Hex) => {
        const tokenIndex = state.tokensWithDetails.findIndex((token) => token.CS === CS && token.TN_Hex === TN_Hex);
        if (tokenIndex !== -1) {
            return state.tokensWithDetails[tokenIndex];
        }
    }),
    //----------------------------
    getTokensPriceAndMetadata: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (tokens) => {
        //----------------------------
        // console.log('[TokensMetadataStore] - getTokens - actual length: ' + state.tokens.length);
        //----------------------------
        const res = tokens
            .map((token) => {
            return state.tokensWithDetails.find((token_) => token_.CS === token.CS && token_.TN_Hex === token.TN_Hex) || undefined;
        })
            .filter((token) => token !== undefined); // Filter out any null values (tokens not found)
        //----------------------------
        return res;
    }),
    //--------------------------
    getTokenDecimals: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (CS, TN_Hex) => {
        const tokenIndex = state.tokensWithDetails.findIndex((token) => token.CS === CS && token.TN_Hex === TN_Hex);
        if (tokenIndex !== -1) {
            return state.tokensWithDetails[tokenIndex].decimals;
        }
    }),
    //----------------------------
    showTokenValidity: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (CS, TN_Hex, swAddValidFor) => {
        //-----------------------
        if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isTokenADA */ .Gre)(CS, TN_Hex)) {
            return `Valid`;
        }
        //-----------------------
        const validity = state.getTokenValidity(CS, TN_Hex);
        //-----------------------
        if (validity !== undefined) {
            //-----------------------
            if (state.isAddingTokens === true) {
                return 'Refreshing...';
            }
            else {
                const secondsLeft = Number(validity);
                if (secondsLeft > 0) {
                    return `${swAddValidFor === true ? `Valid for: ` : ``}${secondsLeft}s`;
                }
                else {
                    return `Refresh Price`;
                }
            }
        }
        else {
            return '...';
        }
    }),
    //----------------------------
    showTokenWithAmount: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (amount, CS, TN_Hex, swRounded = false, showDecimals = 2) => {
        //-----------------------
        if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isTokenADA */ .Gre)(CS, TN_Hex)) {
            return `${(0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_5__/* .formatAmountWithUnit */ .j$)(amount, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_SYMBOL */ .SOG, swRounded ? showDecimals : _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_DECIMALS */ .DNq, swRounded, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_DECIMALS */ .DNq)}`;
        }
        //-----------------------
        const tokenIndex = state.tokensWithDetails.findIndex((token) => token.CS === CS && token.TN_Hex === TN_Hex);
        if (tokenIndex !== -1 && state.tokensWithDetails[tokenIndex].decimals !== undefined) {
            return `${(0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_5__/* .formatAmountWithUnit */ .j$)(amount, state.tokensWithDetails[tokenIndex].ticker, swRounded ? showDecimals : state.tokensWithDetails[tokenIndex].decimals, swRounded, state.tokensWithDetails[tokenIndex].decimals)}`;
        }
        else {
            if (TN_Hex !== undefined) {
                return `... ${(0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .hexToStr */ .NdO)(TN_Hex)}`;
            }
            else {
                return `...`;
            }
        }
    }),
    //----------------------------
    showTokenPrice: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (CS, TN_Hex, swRounded = false, showDecimals = 2) => {
        //-----------------------
        // console.log(`[TokensStore] - showTokenPrice - ${CS} - ${TN_Hex} - swRounded: ${swRounded} - showDecimals: ${showDecimals}`);
        //-----------------------
        if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isTokenADA */ .Gre)(CS, TN_Hex)) {
            const priceADAx1e6 = 1000000n;
            const priceADAx1e6ofTokenBaseUnit = priceADAx1e6 * BigInt(10 ** _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_DECIMALS */ .DNq);
            return `${(0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_5__/* .formatAmountWithUnit */ .j$)(priceADAx1e6ofTokenBaseUnit, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_SYMBOL */ .SOG, swRounded ? showDecimals : _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_DECIMALS */ .DNq, swRounded, (_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_DECIMALS */ .DNq + _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .PRICEx1e6_DECIMALS */ .AbK))}`;
        }
        //-----------------------
        const tokenIndex = state.tokensWithDetails.findIndex((token) => token.CS === CS && token.TN_Hex === TN_Hex);
        if (tokenIndex !== -1) {
            //-----------------------
            const priceADAx1e6ofTokenBaseUnit = state.tokensWithDetails[tokenIndex].priceADAx1e6 !== undefined && state.tokensWithDetails[tokenIndex].decimals !== undefined
                ? BigInt(state.tokensWithDetails[tokenIndex].priceADAx1e6) * BigInt(10 ** state.tokensWithDetails[tokenIndex].decimals)
                : undefined;
            //-----------------------
            const formatPrice = (0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_5__/* .formatAmountWithUnit */ .j$)(priceADAx1e6ofTokenBaseUnit, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_SYMBOL */ .SOG, swRounded ? showDecimals : _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_DECIMALS */ .DNq, swRounded, (_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_DECIMALS */ .DNq + _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .PRICEx1e6_DECIMALS */ .AbK));
            //-----------------------
            return `${formatPrice}`;
        }
        else {
            return `... ${_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_SYMBOL */ .SOG}`;
        }
    }),
    //----------------------------
    showTokenPriceAndValidity: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (CS, TN_Hex, swRounded = false, showDecimals = 2) => {
        //-----------------------
        if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isTokenADA */ .Gre)(CS, TN_Hex)) {
            //-----------------------
            const formatPrice = state.showTokenPrice(CS, TN_Hex, swRounded, showDecimals);
            //-----------------------
            return `${formatPrice} - Valid`;
        }
        //-----------------------
        const tokenIndex = state.tokensWithDetailsAndValidity.findIndex((token) => token.CS === CS && token.TN_Hex === TN_Hex);
        if (tokenIndex !== -1) {
            //-----------------------
            const secondsLeft = state.tokensWithDetailsAndValidity[tokenIndex].validity !== undefined ? Number(state.tokensWithDetailsAndValidity[tokenIndex].validity) : 0;
            //-----------------------
            const formatPrice = state.showTokenPrice(CS, TN_Hex, swRounded, showDecimals);
            //-----------------------
            if (secondsLeft > 0) {
                return `${formatPrice} - Valid for ${secondsLeft} seconds`;
            }
            else {
                return `${formatPrice} - Not Valid - Refresh Price`;
            }
        }
        else {
            return '...';
        }
    }),
    //----------------------------
    showTokenPriceMultipliedByAmount: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (amount, CS, TN_Hex, swRounded = false, showDecimals = 2, decimalsInAmount = 0) => {
        //-----------------------
        if (typeof amount !== 'number' && amount !== undefined) {
            amount = Number(amount);
        }
        if ((0,_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isTokenADA */ .Gre)(CS, TN_Hex)) {
            //-----------------------
            const priceADAx1e6 = 1000000n;
            const priceADAx1e6ByAmount = amount !== undefined ? Number(priceADAx1e6) * amount : undefined;
            //-----------------------
            // const priceADAByAmount = amount !== undefined ? Number(1000000) * amount : undefined;
            return `${(0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_5__/* .formatAmountWithUnit */ .j$)(priceADAx1e6ByAmount, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_SYMBOL */ .SOG, swRounded ? showDecimals : (_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_DECIMALS */ .DNq + decimalsInAmount + _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_DECIMALS */ .DNq), swRounded, (_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_DECIMALS */ .DNq + decimalsInAmount + _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .PRICEx1e6_DECIMALS */ .AbK))}`;
        }
        //-----------------------
        const tokenIndex = state.tokensWithDetails.findIndex((token) => token.CS === CS && token.TN_Hex === TN_Hex);
        if (tokenIndex !== -1) {
            const priceADAx1e6 = state.tokensWithDetails[tokenIndex].priceADAx1e6 !== undefined && state.tokensWithDetails[tokenIndex].decimals !== undefined
                ? BigInt(state.tokensWithDetails[tokenIndex].priceADAx1e6)
                : undefined;
            const priceADAx1e6ByAmount = priceADAx1e6 !== undefined && amount !== undefined ? Number(priceADAx1e6) * amount : undefined;
            //-----------------------
            const formatPrice = (0,_Commons_formatters_js__WEBPACK_IMPORTED_MODULE_5__/* .formatAmountWithUnit */ .j$)(priceADAx1e6ByAmount, _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_SYMBOL */ .SOG, swRounded
                ? showDecimals
                : state.tokensWithDetails[tokenIndex].decimals === undefined
                    ? undefined
                    : (_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_DECIMALS */ .DNq + decimalsInAmount + state.tokensWithDetails[tokenIndex].decimals), swRounded, (_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_DECIMALS */ .DNq + decimalsInAmount + _Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .PRICEx1e6_DECIMALS */ .AbK));
            //-----------------------
            return `${formatPrice}`;
        }
        else {
            return `... ${_Commons_index_js__WEBPACK_IMPORTED_MODULE_1__/* .TOKEN_ADA_SYMBOL */ .SOG}`;
        }
    }),
    //----------------------------
};
//# sourceMappingURL=tokensStoreModel.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 84134:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X$": function() { return /* binding */ useWalletStore; },
/* harmony export */   "cr": function() { return /* binding */ globalStore; },
/* harmony export */   "qr": function() { return /* binding */ useAppStore; },
/* harmony export */   "ux": function() { return /* binding */ useTokensStore; }
/* harmony export */ });
/* harmony import */ var easy_peasy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27870);
/* harmony import */ var _appStoreModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4166);
/* harmony import */ var _walletStoreModel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1796);
/* harmony import */ var _tokensStoreModel_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80643);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_appStoreModel_js__WEBPACK_IMPORTED_MODULE_1__, _walletStoreModel_js__WEBPACK_IMPORTED_MODULE_2__, _tokensStoreModel_js__WEBPACK_IMPORTED_MODULE_3__]);
([_appStoreModel_js__WEBPACK_IMPORTED_MODULE_1__, _walletStoreModel_js__WEBPACK_IMPORTED_MODULE_2__, _tokensStoreModel_js__WEBPACK_IMPORTED_MODULE_3__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);




const GlobalModel = {
    ..._walletStoreModel_js__WEBPACK_IMPORTED_MODULE_2__/* .WalletStoreModel */ .Z,
    ..._appStoreModel_js__WEBPACK_IMPORTED_MODULE_1__/* .AppStoreModel */ .w,
    ..._tokensStoreModel_js__WEBPACK_IMPORTED_MODULE_3__/* .TokenStoreModel */ .T,
};
const globalStore = (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .createStore */ .MT)(GlobalModel);
const { useStoreActions, useStoreState, useStoreDispatch, useStore } = (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .createTypedHooks */ .tl)();
function useWalletStore() {
    const state = useStoreState((state) => state);
    const actions = useStoreActions((actions) => actions);
    return {
        emulatorDB: state.emulatorDB,
        setEmulatorDB: actions.setEmulatorDB,
        cardanoWallets: state.cardanoWallets,
        setCardanoWallets: actions.setCardanoWallets,
        getCardanoWallets: actions.getCardanoWallets,
        isGettingWalletsDone: state.isGettingWalletsDone,
        swDoNotPromtForSigning: state.swDoNotPromtForSigning,
        setSwDoNotPromtForSigning: actions.setSwDoNotPromtForSigning,
        swHideBalance: state.swHideBalance,
        setSwHideBalance: actions.setSwHideBalance,
        swProInterface: state.swProInterface,
        setSwProInterface: actions.setSwProInterface,
        isConnecting: state.isConnecting,
        isConnected: state.isConnected,
        getLucid: actions.getLucid,
        setLucid: actions.setLucid,
        getLucidForUseAsUtils: actions.getLucidForUseAsUtils,
        setLucidForUseAsUtils: actions.setLucidForUseAsUtils,
        protocolParameters: state.protocolParameters,
        info: state.info,
        getPkh: state.getPkh,
        loadWalletPrivileges: actions.loadWalletPrivileges,
        isLoadingAnyData: state.isLoadingAnyData,
        isWalletPrivilegesLoading: state.isWalletPrivilegesLoading,
        isWalletPrivilegesLoaded: state.isWalletPrivilegesLoaded,
        isWalletDataLoading: state.isWalletDataLoading,
        isWalletDataLoaded: state.isWalletDataLoaded,
        uTxOsAtWallet: state.uTxOsAtWallet,
        getUTxOsAtWallet: state.getUTxOsAtWallet,
        isCoreTeam: state.isCoreTeam,
        loadWalletData: actions.loadWalletData,
        checkSessionValidity: actions.checkSessionValidity,
        connectWallet: actions.connectWallet,
        disconnectWallet: actions.disconnectWallet,
        getTotalOfUnit: state.getTotalOfUnit,
        getTotalNumberOfTokens: state.getTotalNumberOfTokens,
    };
}
function useAppStore() {
    const state = useStoreState((state) => state);
    const actions = useStoreActions((actions) => actions);
    return {
        swInitApiCompleted: state.swInitApiCompleted,
        setSwInitApiCompleted: actions.setSwInitApiCompleted,
        isNavigating: state.isNavigating,
        setIsNavigating: actions.setIsNavigating,
        navigationTimeoutId: state.navigationTimeoutId,
        setNavigationTimeoutId: actions.setNavigationTimeoutId,
        swExistAnyWallet: state.swExistAnyWallet,
        checkIfExistAnyWallet: actions.checkIfExistAnyWallet,
        siteSettings: state.siteSettings,
        setSiteSettings: actions.setSiteSettings,
        isAppStoreLoading: state.isAppStoreLoading,
        isAppStoreLoaded: state.isAppStoreLoaded,
        isProcessingTx: state.isProcessingTx,
        setIsProcessingTx: actions.setIsProcessingTx,
        isFaildedTx: state.isFaildedTx,
        setIsFaildedTx: actions.setIsFaildedTx,
        isConfirmedTx: state.isConfirmedTx,
        setIsConfirmedTx: actions.setIsConfirmedTx,
        processingTxName: state.processingTxName,
        setProcessingTxName: actions.setProcessingTxName,
        processingTxMessage: state.processingTxMessage,
        setProcessingTxMessage: actions.setProcessingTxMessage,
        processingTxHash: state.processingTxHash,
        setProcessingTxHash: actions.setProcessingTxHash,
        showUserConfirmation: state.showUserConfirmation,
        setShowUserConfirmation: actions.setShowUserConfirmation,
        showProcessingTx: state.showProcessingTx,
        setShowProcessingTx: actions.setShowProcessingTx,
        isValidTx: state.isValidTx,
        setIsValidTx: actions.setIsValidTx,
        tokensGiveWithMetadata: state.tokensGiveWithMetadata,
        setTokensGiveWithMetadata: actions.setTokensGiveWithMetadata,
        tokensGetWithMetadata: state.tokensGetWithMetadata,
        setTokensGetWithMetadata: actions.setTokensGetWithMetadata,
        isProcessingTask: state.isProcessingTask,
        setIsProcessingTask: actions.setIsProcessingTask,
        isFaildedTask: state.isFaildedTask,
        setIsFaildedTask: actions.setIsFaildedTask,
        isConfirmedTask: state.isConfirmedTask,
        setIsConfirmedTask: actions.setIsConfirmedTask,
        processingTaskName: state.processingTaskName,
        setProcessingTaskName: actions.setProcessingTaskName,
        processingTaskMessage: state.processingTaskMessage,
        setProcessingTaskMessage: actions.setProcessingTaskMessage,
        showProcessingTask: state.showProcessingTask,
        setShowProcessingTask: actions.setShowProcessingTask,
    };
}
function useTokensStore() {
    //--------------------------------------
    const state = useStoreState((state) => state);
    const actions = useStoreActions((actions) => actions);
    //--------------------------------------
    return {
        serverTime: state.serverTime,
        isServerTimeLoaded: state.isServerTimeLoaded,
        jobTokensToAdd: state.jobTokensToAdd,
        jobTokensToAddFinished: state.jobTokensToAddFinished,
        createJobTokensToAdd: actions.createJobTokensToAdd,
        getFinishedJobTokensToAdd: state.getFinishedJobTokensToAdd,
        isExecuting: state.isExecuting,
        executeJobsTokensToAdd: actions.executeJobsTokensToAdd,
        tokensWithDetails: state.tokensWithDetails,
        tokensWithDetailsAndValidity: state.tokensWithDetailsAndValidity,
        isAddingTokens: state.isAddingTokens,
        getServerTime: actions.getServerTime,
        intervalIdForUpdateLoop: state.intervalIdForUpdateLoop,
        setDoUpdatePricesAutomatically: actions.setDoUpdatePricesAutomatically,
        beginUpdateLoop: actions.beginUpdateLoop,
        stopUpdateLoop: actions.stopUpdateLoop,
        cleanStore: actions.cleanStore,
        addToken: actions.addToken,
        addTokens: actions.addTokens,
        removeToken: actions.removeToken,
        refreshPrices: actions.refreshPrices,
        isTokenPriceValid: state.isTokenPriceValid,
        getTokenValidity: state.getTokenValidity,
        getTokenPriceAndMetadata: state.getTokenPriceAndMetadata,
        getTokensPriceAndMetadata: state.getTokensPriceAndMetadata,
        getTokenDecimals: state.getTokenDecimals,
        showTokenPriceAndValidity: state.showTokenPriceAndValidity,
        showTokenPrice: state.showTokenPrice,
        showTokenValidity: state.showTokenValidity,
        showTokenWithAmount: state.showTokenWithAmount,
        showTokenPriceMultipliedByAmount: state.showTokenPriceMultipliedByAmount,
    };
}
//# sourceMappingURL=useGlobalStore.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 1796:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WalletStoreModel; }
/* harmony export */ });
/* harmony import */ var easy_peasy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27870);
/* harmony import */ var _lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76100);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33299);
/* harmony import */ var _Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87654);
/* harmony import */ var _Commons_Constants_wallets_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57103);
/* harmony import */ var _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27001);
/* harmony import */ var _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25995);
/* harmony import */ var _Commons_utils_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75672);
/* harmony import */ var _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36142);
/* harmony import */ var _Commons_explainError_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73582);
/* harmony import */ var _lib_Auth_Auth_FrontEnd_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91991);
/* harmony import */ var _Commons_helpers_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36394);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_1__, _Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__, _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_6__, _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_8__, _lib_Auth_Auth_FrontEnd_js__WEBPACK_IMPORTED_MODULE_10__, _Commons_helpers_js__WEBPACK_IMPORTED_MODULE_11__]);
([_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_1__, _Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__, _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_6__, _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_8__, _lib_Auth_Auth_FrontEnd_js__WEBPACK_IMPORTED_MODULE_10__, _Commons_helpers_js__WEBPACK_IMPORTED_MODULE_11__] = __webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__);












const WalletStoreModel = {
    emulatorDB: undefined,
    setEmulatorDB: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state.emulatorDB = payload;
    }),
    cardanoWallets: _Commons_Constants_wallets_js__WEBPACK_IMPORTED_MODULE_4__/* .CARDANO_WALLETS */ .O,
    setCardanoWallets: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, cardanoWallets) => {
        state.cardanoWallets = cardanoWallets;
    }),
    // si es emulador no tiene que cargar wallets
    isGettingWalletsDone: _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .isEmulator */ .It,
    setIsGettingWalletsDone: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, isGettingWalletsDone) => {
        state.isGettingWalletsDone = isGettingWalletsDone;
    }),
    getCardanoWallets: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        const pollWallets = async (pollWalletsCount = 0) => {
            let walletsFound = [];
            if (window.cardano !== undefined) {
                for (const key in window.cardano) {
                    if (window.cardano[key].enable && walletsFound.indexOf(key) === -1) {
                        walletsFound.push(key);
                    }
                }
            }
            // Proceed if wallets are found or if it's the third attempt
            if (walletsFound.length > 0 || pollWalletsCount === 2) {
                // Get current cardanoWallets from state
                const state = helpers.getState();
                const cardanoWallets = state.cardanoWallets;
                // Update isInstalled flags for found wallets
                walletsFound.forEach((walletName) => {
                    const wallet = cardanoWallets.find((w) => w.wallet === walletName);
                    if (wallet) {
                        wallet.isInstalled = true;
                    }
                });
                // Sort and set new state
                cardanoWallets.sort((a, b) => {
                    // First, sort by isInstalled status
                    if (a.isInstalled && !b.isInstalled) {
                        return -1; // a comes first
                    }
                    else if (!a.isInstalled && b.isInstalled) {
                        return 1; // b comes first
                    }
                    else {
                        // If both have the same isInstalled status, sort alphabetically by name
                        // Assuming the property to sort by is 'name' instead of 'wallet'
                        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
                    }
                });
                actions.setCardanoWallets([...cardanoWallets]);
                actions.setIsGettingWalletsDone(true);
            }
            else if (pollWalletsCount < 2) {
                // Use 2 since count starts from 0 (0, 1, 2)
                setTimeout(() => {
                    pollWallets(pollWalletsCount + 1);
                }, _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .CONNECT_WALLET_WAIT_FOR_EXTENSIONS_POOL_WALLETS_MS */ .xH);
            }
            else {
                // Ensure setIsGettingWalletsDone is called even when no wallets are found
                const state = helpers.getState();
                const cardanoWallets = state.cardanoWallets;
                // Sort and set new state
                cardanoWallets.sort((a, b) => {
                    // First, sort by isInstalled status
                    if (a.isInstalled && !b.isInstalled) {
                        return -1; // a comes first
                    }
                    else if (!a.isInstalled && b.isInstalled) {
                        return 1; // b comes first
                    }
                    else {
                        // If both have the same isInstalled status, sort alphabetically by name
                        // Assuming the property to sort by is 'name' instead of 'wallet'
                        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
                    }
                });
                actions.setCardanoWallets([...cardanoWallets]);
                actions.setIsGettingWalletsDone(true);
            }
        };
        if (!_Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .isEmulator */ .It) {
            await pollWallets();
        }
    }),
    initWallet: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state) => {
        console.log(`[WalletStore] - initWallet`);
        // state.emulatorDB = undefined;
        state.swDoNotPromtForSigning = false;
        state.swHideBalance = true;
        state.isConnecting = false;
        state.isConnected = false;
        state._lucid = undefined;
        state.protocolParameters = undefined;
        state.info = undefined;
        state.isWalletPrivilegesLoading = false;
        state.isWalletPrivilegesLoaded = false;
        state.isWalletDataLoading = false;
        state.isWalletDataLoaded = false;
        state.uTxOsAtWallet = [];
        state._isCoreTeam = false;
    }),
    swDoNotPromtForSigning: false,
    setSwDoNotPromtForSigning: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, swDoNotPromtForSigning) => {
        state.swDoNotPromtForSigning = swDoNotPromtForSigning;
    }),
    swHideBalance: true,
    setSwHideBalance: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, swHideBalance) => {
        state.swHideBalance = swHideBalance;
    }),
    swProInterface: false,
    setSwProInterface: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, swProInterface) => {
        state.swProInterface = swProInterface;
    }),
    isConnecting: false,
    setIsConnecting: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, isConnecting) => {
        state.isConnecting = isConnecting;
    }),
    isConnected: false,
    setIsConnected: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, isConnected) => {
        state.isConnected = isConnected;
    }),
    _lucid: undefined,
    setLucid: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, newLucid) => {
        state._lucid = newLucid;
        // console.log(`[WalletStore] - setLucid - Lucid Network: ${newLucid.config().network}`);
    }),
    getLucid: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload = {}, helpers) => {
        //-------------------------
        // normalmente lucid contiene el provider del emulador siempre actualizado en la misma ventan
        // pero si el emulador fue usado en otro lado, de esta forma me aseguro que se lea de la base de datos y se actualice en lucid
        //-------------------------
        let { emulatorDB } = payload;
        //-------------------------
        let state = helpers.getState();
        //-------------------------
        let lucid = state._lucid;
        //-------------------------
        if (lucid !== undefined) {
            // console.log(`[WalletStore] - getLucid - Lucid Network: ${lucid.config().network}`);
            if (_Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .isEmulator */ .It) {
                if (emulatorDB === undefined) {
                    console.log(`[WalletStore] - getLucid - Getting last updated emulatorDB...`);
                    emulatorDB = await _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_6__/* .EmulatorDBFrontEndApiCalls.getOneByParamsApi */ .cu.getOneByParamsApi(_Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__/* .EmulatorEntity */ .Z, { current: true });
                }
                if (emulatorDB === undefined) {
                    throw 'emulatorDB current not defined';
                }
                else {
                    lucid.switchProvider(emulatorDB.emulator);
                    // NOTE: tengo que reconectar billetera en emulador, por que adentro la billetera tiene provider y el provider de lucid se cambia y no se cambia el de adentro a enos que no recoencte la billetera
                    if (state.info?.walletKey !== undefined) {
                        let walletKey = state.info.walletKey;
                        lucid.selectWallet.fromPrivateKey(walletKey);
                    }
                    actions.setLucid(lucid);
                    actions.setEmulatorDB(emulatorDB);
                }
            }
        }
        return lucid;
    }),
    _lucidForUseAsUtils: undefined,
    setLucidForUseAsUtils: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, payload) => {
        state._lucidForUseAsUtils = payload;
    }),
    getLucidForUseAsUtils: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        // normalmente lucid contiene el provider del emulador siempre actualizado en la misma ventan
        // pero si el emulador fue usado en otro lado, de esta forma me aseguro que se lea de la base de datos y se actualice en lucid
        //-------------------------
        let state = helpers.getState();
        //-------------------------
        let lucid = state._lucidForUseAsUtils;
        //-------------------------
        if (lucid !== undefined) {
            if (_Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .isEmulator */ .It) {
                console.log(`[WalletStore] - getLucidForUseAsUtils - Getting last updated emulatorDB...`);
                let emulatorDB = await _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_6__/* .EmulatorDBFrontEndApiCalls.getOneByParamsApi */ .cu.getOneByParamsApi(_Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__/* .EmulatorEntity */ .Z, { current: true });
                if (emulatorDB === undefined) {
                    throw 'emulatorDB current not defined';
                }
                else {
                    lucid.switchProvider(emulatorDB.emulator);
                    actions.setLucidForUseAsUtils(lucid);
                }
            }
        }
        return lucid;
    }),
    protocolParameters: undefined,
    setProtocolParameters: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, newProtocolParameters) => {
        state.protocolParameters = newProtocolParameters;
    }),
    info: undefined,
    setInfo: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, newInfo) => {
        state.info = newInfo;
    }),
    getPkh: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (swUseSession = false, session, status) => {
        if (state.isConnected && state.info) {
            return state.info.pkh;
        }
        else if (swUseSession === true && status === 'authenticated') {
            if (session && session.user) {
                return session.user.pkh;
            }
        }
        return undefined;
    }),
    isLoadingAnyData: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => {
        return state.isWalletPrivilegesLoading || state.isWalletDataLoading;
    }),
    loadWalletPrivileges: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, _, helpers) => {
        const state = helpers.getState();
        console.log(`[WalletStore] - loadWalletPrivileges - Init`);
        try {
            if (state._lucid && state.info) {
                actions.setIsWalletPrivilegesLoaded(false);
                actions.setIsLoadingWallePrivileges(true);
                const isCoreTeam = await _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_6__/* .WalletFrontEndApiCalls.isCoreTeamApi */ .GG.isCoreTeamApi(state.info.pkh);
                actions.setIsCoreTeam(isCoreTeam ? true : false);
                actions.setIsWalletPrivilegesLoaded(true);
                actions.setIsLoadingWallePrivileges(false);
                console.log(`[WalletStore] - loadWalletPrivileges - OK`);
            }
        }
        catch (error) {
            console.log(`[WalletStore] - loadWalletPrivileges - Error: ${error}`);
            actions.setIsLoadingWallePrivileges(false);
            throw error;
        }
    }),
    loadWalletData: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        //----------
        const state = helpers.getState();
        //----------
        console.log(`[WalletStore] - loadWalletData Init`);
        try {
            if (state.isConnected && state._lucid && state.info) {
                actions.setIsWalletDataLoaded(false);
                actions.setIsWalletDataLoading(true);
                const lucid = await actions.getLucid();
                let uTxOsAtWallet = [];
                try {
                    uTxOsAtWallet = await lucid.wallet().getUtxos();
                }
                catch (error) { }
                console.log('[WalletStore] - loadWalletData - uTxOsAtWallet: ' + uTxOsAtWallet.length);
                actions.setUTxOsAtWallet(uTxOsAtWallet);
                if (uTxOsAtWallet.length === 0) {
                    console.log(`[WalletStore] - loadWalletData: There are no UTxOs available in your Wallet`);
                }
                //--------------------------------------
                actions.setIsWalletDataLoaded(true);
                actions.setIsWalletDataLoading(false);
                //--------------------------------------
                console.log(`[WalletStore] - loadWalletData - OK`);
            }
        }
        catch (error) {
            console.log(`[WalletStore] - loadWalletData - Error: ${error}`);
            actions.setIsWalletDataLoading(false);
            throw error;
        }
    }),
    isWalletPrivilegesLoading: false,
    setIsLoadingWallePrivileges: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, isLoading) => {
        state.isWalletPrivilegesLoading = isLoading;
    }),
    isWalletPrivilegesLoaded: false,
    setIsWalletPrivilegesLoaded: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, isLoaded) => {
        state.isWalletPrivilegesLoaded = isLoaded;
    }),
    isWalletDataLoading: false,
    setIsWalletDataLoading: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, isLoading) => {
        state.isWalletDataLoading = isLoading;
    }),
    isWalletDataLoaded: false,
    setIsWalletDataLoaded: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, isLoaded) => {
        state.isWalletDataLoaded = isLoaded;
    }),
    uTxOsAtWallet: [],
    setUTxOsAtWallet: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, newUTxOs) => {
        state.uTxOsAtWallet = newUTxOs;
    }),
    getUTxOsAtWallet: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => () => {
        return state.uTxOsAtWallet;
    }),
    _isCoreTeam: false,
    setIsCoreTeam: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .action */ .aD)((state, isCore) => {
        state._isCoreTeam = isCore;
    }),
    isCoreTeam: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (swUseSession, session, status) => {
        if (state.isWalletPrivilegesLoaded) {
            return state._isCoreTeam;
        }
        else if (swUseSession === true && status === 'authenticated') {
            if (session && session.user && session.user.isCoreTeam) {
                return session.user.isCoreTeam;
            }
        }
        return false;
    }),
    checkSessionValidity: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        //------------------------------
        const { user, walletInfo, isCoreTeam } = payload;
        //------------------------------
        const swSettedSessionOk = user.address !== undefined &&
            user.pkh !== undefined &&
            (walletInfo.stakePkh === undefined || user.stakePkh !== undefined) &&
            user.walletName !== undefined &&
            user.useBlockfrostToSubmit !== undefined &&
            user.isWalletFromSeed !== undefined &&
            user.isWalletFromKey !== undefined &&
            user.isCoreTeam !== undefined &&
            user.network !== undefined &&
            (walletInfo.isWalletValidatedWithSignedToken === undefined || user.isWalletValidatedWithSignedToken !== undefined);
        //------------------------------
        const prevUser = {
            address: user.address,
            pkh: user.pkh,
            stakePkh: user.stakePkh,
            walletName: user.walletName,
            walletSeed: user.walletSeed,
            walletKey: user.walletKey,
            useBlockfrostToSubmit: user.useBlockfrostToSubmit,
            isWalletFromSeed: user.isWalletFromSeed,
            isWalletFromKey: user.isWalletFromKey,
            isCoreTeam: user.isCoreTeam,
            network: user.network,
            isWalletValidatedWithSignedToken: user.isWalletValidatedWithSignedToken,
        };
        //------------------------------
        const currentUser = {
            address: walletInfo.address,
            pkh: walletInfo.pkh,
            stakePkh: walletInfo.stakePkh,
            walletName: walletInfo.walletName,
            walletSeed: walletInfo.walletSeed,
            walletKey: walletInfo.walletKey,
            useBlockfrostToSubmit: walletInfo.useBlockfrostToSubmit,
            isWalletFromSeed: walletInfo.isWalletFromSeed,
            isWalletFromKey: walletInfo.isWalletFromKey,
            isCoreTeam: isCoreTeam,
            network: "Mainnet",
            isWalletValidatedWithSignedToken: walletInfo.isWalletValidatedWithSignedToken,
        };
        //------------------------------
        const swSessionOk = prevUser.address === currentUser.address &&
            prevUser.pkh === currentUser.pkh &&
            prevUser.stakePkh === currentUser.stakePkh &&
            prevUser.walletName === currentUser.walletName &&
            prevUser.walletSeed === currentUser.walletSeed &&
            prevUser.walletKey === currentUser.walletKey &&
            prevUser.useBlockfrostToSubmit === currentUser.useBlockfrostToSubmit &&
            prevUser.isWalletFromSeed === currentUser.isWalletFromSeed &&
            prevUser.isWalletFromKey === currentUser.isWalletFromKey &&
            prevUser.isCoreTeam === currentUser.isCoreTeam &&
            prevUser.network === currentUser.network &&
            prevUser.isWalletValidatedWithSignedToken === currentUser.isWalletValidatedWithSignedToken;
        //------------------------------
        const isSessionValid = swSessionOk && swSettedSessionOk;
        //------------------------------
        const updatedValues = {};
        Object.entries(prevUser).forEach(([key, value]) => {
            if (currentUser[key] !== value) {
                updatedValues[key] = {
                    from: value,
                    to: currentUser[key],
                };
            }
        });
        //------------------------------
        console.log(`[WalletStore] - checkSessionValidity - all set: ${swSettedSessionOk.toString()} - updated: ${swSessionOk.toString()} - which fields: ${!swSessionOk ? (0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .toJson */ .Qs)({ updatedValues }) : null}`);
        //------------------------------
        return isSessionValid;
    }),
    connectWallet: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        console.log(`[WalletStore] - Connecting Wallet...`);
        //----------------------------
        const { session, status, walletName, walletSeed, walletKey, tryAgain, useBlockfrostToSubmit, forceConnect, createSignedSession } = payload;
        let { emulatorDB } = payload;
        //----------------------------
        const isWalletFromSeed = walletSeed !== undefined;
        const isWalletFromKey = walletKey !== undefined;
        //----------------------------
        let isNewConnection = false;
        //----------------------------
        try {
            let state = helpers.getState();
            //----------------------------
            if (isWalletFromSeed === false && isWalletFromKey === false && window.cardano === undefined) {
                throw `Install a Cardano Wallet and please try again...`;
            }
            //----------------------------
            const isWalletApiEnabled = isWalletFromSeed || isWalletFromKey || (await window.cardano[walletName]?.isEnabled());
            //----------------------------
            const isStoreWalletConnected = state.isConnected && state.info?.walletName === walletName;
            //----------------------------
            let swConnect = forceConnect === true || isWalletApiEnabled === false || isStoreWalletConnected === false;
            //----------------------------
            let isSessionInvalidOrNoExists = undefined;
            if (!swConnect) {
                isSessionInvalidOrNoExists = true;
                if (state.info) {
                    const isSessionValid = await actions.checkSessionValidity({
                        user: session.user,
                        walletInfo: state.info,
                        isCoreTeam: state._isCoreTeam,
                    });
                    isSessionInvalidOrNoExists = !isSessionValid;
                }
                swConnect = isSessionInvalidOrNoExists;
            }
            //----------------------------
            if (swConnect) {
                //----------------------------
                isNewConnection = true;
                //----------------------------
                if (_Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .isEmulator */ .It) {
                    if (emulatorDB === undefined) {
                        console.log(`[WalletStore] - Connecting Wallet with Emulator. Getting last updated emulatorDB...`);
                        emulatorDB = await _FrontEnd_index_js__WEBPACK_IMPORTED_MODULE_6__/* .EmulatorDBFrontEndApiCalls.getOneByParamsApi */ .cu.getOneByParamsApi(_Entities_Emulator_Entity_js__WEBPACK_IMPORTED_MODULE_3__/* .EmulatorEntity */ .Z, { current: true });
                    }
                    if (emulatorDB === undefined) {
                        throw `Emulator engine not ready for connect, please try again...`;
                    }
                }
                //----------------------------
                console.log(`[WalletStore] - Wallet will be connected because its needed: wallet Api not enabled - ${!isWalletApiEnabled} - or wallet not connected - ${!state.isConnected} - or force connect - ${forceConnect} - or invalid session: ${isSessionInvalidOrNoExists}`);
                //----------------------------
                actions.initWallet();
                actions.setIsConnecting(true);
                //----------------------------
                let lucid = undefined;
                //----------------------------
                if (isWalletFromSeed || isWalletFromKey) {
                    //----------------------------
                    try {
                        if (_Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .isEmulator */ .It) {
                            if (isWalletFromSeed) {
                                console.log(`[WalletStore] - Init Lucid with Emulator and Private Key...`);
                                lucid = await _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_8__/* .LucidToolsFrontEnd.initializeLucidWithEmulatorAndWalletFromSeed */ .f.initializeLucidWithEmulatorAndWalletFromSeed(emulatorDB, walletSeed, {
                                    addressType: 'Base',
                                    accountIndex: 0,
                                });
                            }
                            else if (isWalletFromKey) {
                                console.log(`[WalletStore] - Init Lucid with Emulator and Private Key...`);
                                lucid = await _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_8__/* .LucidToolsFrontEnd.initializeLucidWithEmulatorAndWalletFromPrivateKey */ .f.initializeLucidWithEmulatorAndWalletFromPrivateKey(emulatorDB, walletKey);
                            }
                        }
                        else {
                            if (isWalletFromSeed) {
                                console.log(`[WalletStore] - Init Lucid with Wallet from Seed...`);
                                lucid = await _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_8__/* .LucidToolsFrontEnd.initializeLucidWithBlockfrostAndWalletFromSeed */ .f.initializeLucidWithBlockfrostAndWalletFromSeed(walletSeed, { addressType: 'Base', accountIndex: 0 });
                            }
                            else if (isWalletFromKey) {
                                console.log(`[WalletStore] - Init Lucid with Emulator and Private Key...`);
                                lucid = await _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_8__/* .LucidToolsFrontEnd.initializeLucidWithBlockfrostAndWalletFromPrivateKey */ .f.initializeLucidWithBlockfrostAndWalletFromPrivateKey(walletKey);
                            }
                        }
                    }
                    catch (error) {
                        throw error;
                    }
                    //----------------------------
                }
                else {
                    //----------------------------
                    let walletApi = undefined;
                    if (isWalletApiEnabled === false) {
                        console.log(`[WalletStore] - Enabling Wallet Api...`);
                        let countError = 0;
                        let errorStr = '';
                        const maxError = tryAgain ? 2 : 1;
                        while (countError < maxError) {
                            try {
                                if (countError > 0) {
                                    //espero para que se cargue la wallet
                                    await (0,_Commons_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .sleep */ ._v)(_Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .CONNECT_WALLET_WAIT_FOR_API_WALLETS_MS */ .ux);
                                }
                                walletApi = await window.cardano[walletName].enable();
                                break;
                            }
                            catch (error) {
                                console.log('[WalletStore] - Try ' + countError + ' of ' + maxError + ' - Error: ' + error);
                                errorStr = (0,_Commons_explainError_js__WEBPACK_IMPORTED_MODULE_9__/* .explainError */ .K)(error);
                                countError++;
                            }
                        }
                        if (!walletApi) {
                            throw errorStr;
                        }
                    }
                    else {
                        console.log(`[WalletStore] - Wallet Api is already enabled`);
                        // deberia tener guardada la wallet api?
                        walletApi = window.cardano[walletName];
                        walletApi = await window.cardano[walletName].enable();
                    }
                    //----------------------------
                    try {
                        console.log(`[WalletStore] - Init Lucid with Wallet Api...`);
                        const networkId = await walletApi.getNetworkId();
                        console.log(`[WalletStore] - NetworkId: ${networkId}`);
                        if (_Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .isMainnet */ .mC && networkId !== _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .LUCID_NETWORK_MAINNET_ID */ .kG) {
                            throw `Must connect with a Mainnet Cardano Wallet`;
                        }
                        if (_Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .isTestnet */ .Jg && networkId !== _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .LUCID_NETWORK_TESTNET_ID */ .XM) {
                            throw `Must connect with a ${"Mainnet"} Testnet Cardano Wallet`;
                        }
                        lucid = await _lib_Lucid_LucidTools_FrontEnd_js__WEBPACK_IMPORTED_MODULE_8__/* .LucidToolsFrontEnd.initializeLucidWithBlockfrostAndWalletApi */ .f.initializeLucidWithBlockfrostAndWalletApi(walletApi);
                    }
                    catch (error) {
                        throw error;
                    }
                }
                //----------------------------
                if (lucid === undefined) {
                    throw 'Lucid is not defined';
                }
                //----------------------------
                const addressWallet = await lucid.wallet().address();
                const pkh = (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_1__/* .getAddressDetails */ .IL)(addressWallet)?.paymentCredential?.hash;
                const stakePkh = (0,_lucid_evolution_lucid__WEBPACK_IMPORTED_MODULE_1__/* .getAddressDetails */ .IL)(addressWallet)?.stakeCredential?.hash;
                // const stakePkh = addrToStakePubKeyHash (addressWallet)
                //----------------------------
                if (!pkh) {
                    throw `Can't get Payment Credentials from address`;
                }
                //----------------------------
                console.log('[WalletStore] - Wallet connected with Lucid: pkh: ' + pkh);
                console.log('[WalletStore] - Wallet connected with Lucid: addressWallet: ' + addressWallet);
                console.log('[WalletStore] - Loading Wallet details...');
                //----------------------------
                const protocolParameters = lucid.config().protocolParameters;
                //----------------------------
                // let useBlockfrostToSubmit_ = useBlockfrostToSubmit;
                // if (status === 'authenticated') {
                //     if (session && session.user && session.user.useBlockfrostToSubmit) {
                //         useBlockfrostToSubmit_ = session.user.useBlockfrostToSubmit;
                //     }
                // }
                // //----------------------------
                // //seteo a la fuerza el no enviar por blockfrost, por las dudas de que alguien haya creado ya la session con este campo
                // //y yo lo estoy sacando del formulario, no podria desacativarlo
                // useBlockfrostToSubmit_ = false;
                //----------------------------
                const info = {
                    walletName,
                    walletSeed,
                    walletKey,
                    address: addressWallet,
                    pkh,
                    stakePkh,
                    useBlockfrostToSubmit: useBlockfrostToSubmit,
                    isWalletFromSeed,
                    isWalletFromKey,
                    network: "Mainnet",
                    isWalletValidatedWithSignedToken: createSignedSession,
                };
                //----------------------------
                if ((lucid.config().network !== "Mainnet" && _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .isEmulator */ .It === false) ||
                    (lucid.config().network !== _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .LUCID_NETWORK_CUSTOM_NAME */ .Rm && _Commons_Constants_constants_js__WEBPACK_IMPORTED_MODULE_5__/* .isEmulator */ .It === true)) {
                    throw `Connected Wallet is not from the same network as the application ${lucid.config().network} !== ${"Mainnet"}`;
                }
                //----------------------------
                actions.setLucid(lucid);
                if (emulatorDB !== undefined) {
                    actions.setEmulatorDB(emulatorDB);
                }
                actions.setProtocolParameters(protocolParameters);
                actions.setInfo(info);
                //----------------------------
                await actions.loadWalletPrivileges();
                //----------------------------
                state = helpers.getState();
                //----------------------------
                console.log('[WalletStore] - Creating or Updating session... - status: ' + status + ' - session.user.pkh: ' + session?.user?.pkh + ' - pkh: ' + pkh);
                //----------------------------
                let swUpdateSession = status !== 'authenticated';
                if (status === 'authenticated' && session && session.user) {
                    //all the fields must be setted in the session.user
                    let isSessionInvalidOrNoExists = true;
                    if (state.info) {
                        const isSessionValid = await actions.checkSessionValidity({
                            user: session.user,
                            walletInfo: state.info,
                            isCoreTeam: state._isCoreTeam,
                        });
                        isSessionInvalidOrNoExists = !isSessionValid;
                    }
                    swUpdateSession = swUpdateSession || isSessionInvalidOrNoExists;
                }
                //----------------------------
                if (swUpdateSession) {
                    //----------------------------
                    console.log(`[WalletStore] - Need to update Session`);
                    // await signOut({ redirect: false });
                    //--------------------------------------
                    const credentials = {
                        address: info.address,
                        walletName: info.walletName,
                        walletSeed: info.walletSeed,
                        walletKey: info.walletKey,
                        useBlockfrostToSubmit: state.info?.useBlockfrostToSubmit ? 'true' : 'false',
                        isWalletFromSeed: state.info?.isWalletFromSeed ? 'true' : 'false',
                        isWalletFromKey: state.info?.isWalletFromKey ? 'true' : 'false',
                    };
                    //--------------------------------------
                    const token = await _lib_Auth_Auth_FrontEnd_js__WEBPACK_IMPORTED_MODULE_10__/* .AuthApi.generateAuthTokensApi */ .z.generateAuthTokensApi(lucid, credentials, createSignedSession);
                    //--------------------------------------
                    console.log(`[WalletStore] - Signin with JWT Token...`);
                    //--------------------------------------
                    const sessionStatus = await (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signIn)('credentials', {
                        token,
                        redirect: false,
                    });
                    //--------------------------------------
                    if (sessionStatus?.ok === false) {
                        throw sessionStatus.error;
                    }
                    //--------------------------------------
                }
                //----------------------------
                actions.setIsConnected(true);
                actions.setIsConnecting(false);
                //----------------------------
                actions.loadWalletData();
                //----------------------------
                console.log(`[WalletStore] - Wallet connected and session OK`);
                //----------------------------
                return isNewConnection;
            }
            else {
                console.log(`[WalletStore] - Wallet already enabled and connected`);
            }
            //----------------------------
        }
        catch (error) {
            console.log(`[WalletStore] - connectWallet - Error: ${error}`);
            if (status === 'authenticated') {
                try {
                    await (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signOut)({ redirect: false });
                }
                catch (error2) {
                    console.log(`[WalletStore] - connectWallet - Error: ${error}`);
                    throw error + ' | ' + error2;
                }
            }
            throw error;
        }
        finally {
            actions.setIsConnecting(false);
        }
    }),
    disconnectWallet: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .thunk */ .I5)(async (actions, payload, helpers) => {
        console.log(`[WalletStore] - disconnectWallet - Init`);
        const { session, status } = payload;
        actions.initWallet();
        try {
            if (status === 'authenticated') {
                await (0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signOut)({ redirect: false });
            }
        }
        catch (error) {
            console.log(`[WalletStore] - disconnectWallet - Error: ${error}`);
            throw error;
        }
    }),
    getTotalOfUnit: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => (unit, swOnlyAvailable = false) => {
        return (0,_Commons_helpers_js__WEBPACK_IMPORTED_MODULE_11__/* .getTotalOfUnitInUTxOList */ .Jm)(unit, state.uTxOsAtWallet, swOnlyAvailable);
    }),
    getTotalNumberOfTokens: (0,easy_peasy__WEBPACK_IMPORTED_MODULE_0__/* .computed */ .Fl)((state) => {
        const UTxOs = state.uTxOsAtWallet;
        // Collect all token keys from each UTxO's assets
        const allTokenKeys = UTxOs.reduce((accumulatedKeys, utxo) => {
            const assetKeys = Object.keys(utxo.assets || {});
            return accumulatedKeys.concat(assetKeys);
        }, []);
        // Deduplicate the keys to count unique tokens
        const uniqueTokenKeys = new Set(allTokenKeys);
        // The size of the Set represents the count of unique tokens
        const uniqueTokenCount = uniqueTokenKeys.size;
        // console.log(`[WalletStore] - Total unique tokens: ${uniqueTokenCount}`);
        return uniqueTokenCount;
    }),
};
//# sourceMappingURL=walletStoreModel.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 75971:
/***/ (function(__webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.a(__webpack_module__, async function (__webpack_handle_async_dependencies__, __webpack_async_result__) { try {
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4E": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.B4E; },
/* harmony export */   "Esd": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.Esd; },
/* harmony export */   "F2s": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.F2s; },
/* harmony export */   "Gre": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.Gre; },
/* harmony export */   "Gx9": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.Gx9; },
/* harmony export */   "Itp": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.Itp; },
/* harmony export */   "MQB": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.MQB; },
/* harmony export */   "NI2": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.NI2; },
/* harmony export */   "NdO": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.NdO; },
/* harmony export */   "OOZ": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.OOZ; },
/* harmony export */   "Pem": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.Pem; },
/* harmony export */   "T2L": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.T2L; },
/* harmony export */   "TuU": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.TuU; },
/* harmony export */   "V9b": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.V9b; },
/* harmony export */   "X$B": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.X$B; },
/* harmony export */   "Xy7": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.Xy7; },
/* harmony export */   "Za7": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.Za7; },
/* harmony export */   "_rQ": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__._rQ; },
/* harmony export */   "crd": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.crd; },
/* harmony export */   "crs": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.crs; },
/* harmony export */   "dMk": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.dMk; },
/* harmony export */   "e0x": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.e0x; },
/* harmony export */   "fmW": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.fmW; },
/* harmony export */   "jl9": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.jl9; },
/* harmony export */   "lTY": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.lTY; },
/* harmony export */   "n6t": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.n6t; },
/* harmony export */   "nCS": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.nCS; },
/* harmony export */   "o4X": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.o4X; },
/* harmony export */   "pzN": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.pzN; },
/* harmony export */   "q$g": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.q$g; },
/* harmony export */   "qrW": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.qrW; },
/* harmony export */   "sa8": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.sa8; },
/* harmony export */   "smg": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.smg; },
/* harmony export */   "stq": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.stq; },
/* harmony export */   "twE": function() { return /* reexport safe */ _dist_index_js__WEBPACK_IMPORTED_MODULE_0__.twE; }
/* harmony export */ });
/* harmony import */ var _dist_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90365);
var __webpack_async_dependencies__ = __webpack_handle_async_dependencies__([_dist_index_js__WEBPACK_IMPORTED_MODULE_0__]);
_dist_index_js__WEBPACK_IMPORTED_MODULE_0__ = (__webpack_async_dependencies__.then ? (await __webpack_async_dependencies__)() : __webpack_async_dependencies__)[0];

//# sourceMappingURL=index.js.map
__webpack_async_result__();
} catch(e) { __webpack_async_result__(e); } });

/***/ }),

/***/ 46996:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('["的","一","是","在","不","了","有","和","人","这","中","大","为","上","个","国","我","以","要","他","时","来","用","们","生","到","作","地","于","出","就","分","对","成","会","可","主","发","年","动","同","工","也","能","下","过","子","说","产","种","面","而","方","后","多","定","行","学","法","所","民","得","经","十","三","之","进","着","等","部","度","家","电","力","里","如","水","化","高","自","二","理","起","小","物","现","实","加","量","都","两","体","制","机","当","使","点","从","业","本","去","把","性","好","应","开","它","合","还","因","由","其","些","然","前","外","天","政","四","日","那","社","义","事","平","形","相","全","表","间","样","与","关","各","重","新","线","内","数","正","心","反","你","明","看","原","又","么","利","比","或","但","质","气","第","向","道","命","此","变","条","只","没","结","解","问","意","建","月","公","无","系","军","很","情","者","最","立","代","想","已","通","并","提","直","题","党","程","展","五","果","料","象","员","革","位","入","常","文","总","次","品","式","活","设","及","管","特","件","长","求","老","头","基","资","边","流","路","级","少","图","山","统","接","知","较","将","组","见","计","别","她","手","角","期","根","论","运","农","指","几","九","区","强","放","决","西","被","干","做","必","战","先","回","则","任","取","据","处","队","南","给","色","光","门","即","保","治","北","造","百","规","热","领","七","海","口","东","导","器","压","志","世","金","增","争","济","阶","油","思","术","极","交","受","联","什","认","六","共","权","收","证","改","清","美","再","采","转","更","单","风","切","打","白","教","速","花","带","安","场","身","车","例","真","务","具","万","每","目","至","达","走","积","示","议","声","报","斗","完","类","八","离","华","名","确","才","科","张","信","马","节","话","米","整","空","元","况","今","集","温","传","土","许","步","群","广","石","记","需","段","研","界","拉","林","律","叫","且","究","观","越","织","装","影","算","低","持","音","众","书","布","复","容","儿","须","际","商","非","验","连","断","深","难","近","矿","千","周","委","素","技","备","半","办","青","省","列","习","响","约","支","般","史","感","劳","便","团","往","酸","历","市","克","何","除","消","构","府","称","太","准","精","值","号","率","族","维","划","选","标","写","存","候","毛","亲","快","效","斯","院","查","江","型","眼","王","按","格","养","易","置","派","层","片","始","却","专","状","育","厂","京","识","适","属","圆","包","火","住","调","满","县","局","照","参","红","细","引","听","该","铁","价","严","首","底","液","官","德","随","病","苏","失","尔","死","讲","配","女","黄","推","显","谈","罪","神","艺","呢","席","含","企","望","密","批","营","项","防","举","球","英","氧","势","告","李","台","落","木","帮","轮","破","亚","师","围","注","远","字","材","排","供","河","态","封","另","施","减","树","溶","怎","止","案","言","士","均","武","固","叶","鱼","波","视","仅","费","紧","爱","左","章","早","朝","害","续","轻","服","试","食","充","兵","源","判","护","司","足","某","练","差","致","板","田","降","黑","犯","负","击","范","继","兴","似","余","坚","曲","输","修","故","城","夫","够","送","笔","船","占","右","财","吃","富","春","职","觉","汉","画","功","巴","跟","虽","杂","飞","检","吸","助","升","阳","互","初","创","抗","考","投","坏","策","古","径","换","未","跑","留","钢","曾","端","责","站","简","述","钱","副","尽","帝","射","草","冲","承","独","令","限","阿","宣","环","双","请","超","微","让","控","州","良","轴","找","否","纪","益","依","优","顶","础","载","倒","房","突","坐","粉","敌","略","客","袁","冷","胜","绝","析","块","剂","测","丝","协","诉","念","陈","仍","罗","盐","友","洋","错","苦","夜","刑","移","频","逐","靠","混","母","短","皮","终","聚","汽","村","云","哪","既","距","卫","停","烈","央","察","烧","迅","境","若","印","洲","刻","括","激","孔","搞","甚","室","待","核","校","散","侵","吧","甲","游","久","菜","味","旧","模","湖","货","损","预","阻","毫","普","稳","乙","妈","植","息","扩","银","语","挥","酒","守","拿","序","纸","医","缺","雨","吗","针","刘","啊","急","唱","误","训","愿","审","附","获","茶","鲜","粮","斤","孩","脱","硫","肥","善","龙","演","父","渐","血","欢","械","掌","歌","沙","刚","攻","谓","盾","讨","晚","粒","乱","燃","矛","乎","杀","药","宁","鲁","贵","钟","煤","读","班","伯","香","介","迫","句","丰","培","握","兰","担","弦","蛋","沉","假","穿","执","答","乐","谁","顺","烟","缩","征","脸","喜","松","脚","困","异","免","背","星","福","买","染","井","概","慢","怕","磁","倍","祖","皇","促","静","补","评","翻","肉","践","尼","衣","宽","扬","棉","希","伤","操","垂","秋","宜","氢","套","督","振","架","亮","末","宪","庆","编","牛","触","映","雷","销","诗","座","居","抓","裂","胞","呼","娘","景","威","绿","晶","厚","盟","衡","鸡","孙","延","危","胶","屋","乡","临","陆","顾","掉","呀","灯","岁","措","束","耐","剧","玉","赵","跳","哥","季","课","凯","胡","额","款","绍","卷","齐","伟","蒸","殖","永","宗","苗","川","炉","岩","弱","零","杨","奏","沿","露","杆","探","滑","镇","饭","浓","航","怀","赶","库","夺","伊","灵","税","途","灭","赛","归","召","鼓","播","盘","裁","险","康","唯","录","菌","纯","借","糖","盖","横","符","私","努","堂","域","枪","润","幅","哈","竟","熟","虫","泽","脑","壤","碳","欧","遍","侧","寨","敢","彻","虑","斜","薄","庭","纳","弹","饲","伸","折","麦","湿","暗","荷","瓦","塞","床","筑","恶","户","访","塔","奇","透","梁","刀","旋","迹","卡","氯","遇","份","毒","泥","退","洗","摆","灰","彩","卖","耗","夏","择","忙","铜","献","硬","予","繁","圈","雪","函","亦","抽","篇","阵","阴","丁","尺","追","堆","雄","迎","泛","爸","楼","避","谋","吨","野","猪","旗","累","偏","典","馆","索","秦","脂","潮","爷","豆","忽","托","惊","塑","遗","愈","朱","替","纤","粗","倾","尚","痛","楚","谢","奋","购","磨","君","池","旁","碎","骨","监","捕","弟","暴","割","贯","殊","释","词","亡","壁","顿","宝","午","尘","闻","揭","炮","残","冬","桥","妇","警","综","招","吴","付","浮","遭","徐","您","摇","谷","赞","箱","隔","订","男","吹","园","纷","唐","败","宋","玻","巨","耕","坦","荣","闭","湾","键","凡","驻","锅","救","恩","剥","凝","碱","齿","截","炼","麻","纺","禁","废","盛","版","缓","净","睛","昌","婚","涉","筒","嘴","插","岸","朗","庄","街","藏","姑","贸","腐","奴","啦","惯","乘","伙","恢","匀","纱","扎","辩","耳","彪","臣","亿","璃","抵","脉","秀","萨","俄","网","舞","店","喷","纵","寸","汗","挂","洪","贺","闪","柬","爆","烯","津","稻","墙","软","勇","像","滚","厘","蒙","芳","肯","坡","柱","荡","腿","仪","旅","尾","轧","冰","贡","登","黎","削","钻","勒","逃","障","氨","郭","峰","币","港","伏","轨","亩","毕","擦","莫","刺","浪","秘","援","株","健","售","股","岛","甘","泡","睡","童","铸","汤","阀","休","汇","舍","牧","绕","炸","哲","磷","绩","朋","淡","尖","启","陷","柴","呈","徒","颜","泪","稍","忘","泵","蓝","拖","洞","授","镜","辛","壮","锋","贫","虚","弯","摩","泰","幼","廷","尊","窗","纲","弄","隶","疑","氏","宫","姐","震","瑞","怪","尤","琴","循","描","膜","违","夹","腰","缘","珠","穷","森","枝","竹","沟","催","绳","忆","邦","剩","幸","浆","栏","拥","牙","贮","礼","滤","钠","纹","罢","拍","咱","喊","袖","埃","勤","罚","焦","潜","伍","墨","欲","缝","姓","刊","饱","仿","奖","铝","鬼","丽","跨","默","挖","链","扫","喝","袋","炭","污","幕","诸","弧","励","梅","奶","洁","灾","舟","鉴","苯","讼","抱","毁","懂","寒","智","埔","寄","届","跃","渡","挑","丹","艰","贝","碰","拔","爹","戴","码","梦","芽","熔","赤","渔","哭","敬","颗","奔","铅","仲","虎","稀","妹","乏","珍","申","桌","遵","允","隆","螺","仓","魏","锐","晓","氮","兼","隐","碍","赫","拨","忠","肃","缸","牵","抢","博","巧","壳","兄","杜","讯","诚","碧","祥","柯","页","巡","矩","悲","灌","龄","伦","票","寻","桂","铺","圣","恐","恰","郑","趣","抬","荒","腾","贴","柔","滴","猛","阔","辆","妻","填","撤","储","签","闹","扰","紫","砂","递","戏","吊","陶","伐","喂","疗","瓶","婆","抚","臂","摸","忍","虾","蜡","邻","胸","巩","挤","偶","弃","槽","劲","乳","邓","吉","仁","烂","砖","租","乌","舰","伴","瓜","浅","丙","暂","燥","橡","柳","迷","暖","牌","秧","胆","详","簧","踏","瓷","谱","呆","宾","糊","洛","辉","愤","竞","隙","怒","粘","乃","绪","肩","籍","敏","涂","熙","皆","侦","悬","掘","享","纠","醒","狂","锁","淀","恨","牲","霸","爬","赏","逆","玩","陵","祝","秒","浙","貌","役","彼","悉","鸭","趋","凤","晨","畜","辈","秩","卵","署","梯","炎","滩","棋","驱","筛","峡","冒","啥","寿","译","浸","泉","帽","迟","硅","疆","贷","漏","稿","冠","嫩","胁","芯","牢","叛","蚀","奥","鸣","岭","羊","凭","串","塘","绘","酵","融","盆","锡","庙","筹","冻","辅","摄","袭","筋","拒","僚","旱","钾","鸟","漆","沈","眉","疏","添","棒","穗","硝","韩","逼","扭","侨","凉","挺","碗","栽","炒","杯","患","馏","劝","豪","辽","勃","鸿","旦","吏","拜","狗","埋","辊","掩","饮","搬","骂","辞","勾","扣","估","蒋","绒","雾","丈","朵","姆","拟","宇","辑","陕","雕","偿","蓄","崇","剪","倡","厅","咬","驶","薯","刷","斥","番","赋","奉","佛","浇","漫","曼","扇","钙","桃","扶","仔","返","俗","亏","腔","鞋","棱","覆","框","悄","叔","撞","骗","勘","旺","沸","孤","吐","孟","渠","屈","疾","妙","惜","仰","狠","胀","谐","抛","霉","桑","岗","嘛","衰","盗","渗","脏","赖","涌","甜","曹","阅","肌","哩","厉","烃","纬","毅","昨","伪","症","煮","叹","钉","搭","茎","笼","酷","偷","弓","锥","恒","杰","坑","鼻","翼","纶","叙","狱","逮","罐","络","棚","抑","膨","蔬","寺","骤","穆","冶","枯","册","尸","凸","绅","坯","牺","焰","轰","欣","晋","瘦","御","锭","锦","丧","旬","锻","垄","搜","扑","邀","亭","酯","迈","舒","脆","酶","闲","忧","酚","顽","羽","涨","卸","仗","陪","辟","惩","杭","姚","肚","捉","飘","漂","昆","欺","吾","郎","烷","汁","呵","饰","萧","雅","邮","迁","燕","撒","姻","赴","宴","烦","债","帐","斑","铃","旨","醇","董","饼","雏","姿","拌","傅","腹","妥","揉","贤","拆","歪","葡","胺","丢","浩","徽","昂","垫","挡","览","贪","慰","缴","汪","慌","冯","诺","姜","谊","凶","劣","诬","耀","昏","躺","盈","骑","乔","溪","丛","卢","抹","闷","咨","刮","驾","缆","悟","摘","铒","掷","颇","幻","柄","惠","惨","佳","仇","腊","窝","涤","剑","瞧","堡","泼","葱","罩","霍","捞","胎","苍","滨","俩","捅","湘","砍","霞","邵","萄","疯","淮","遂","熊","粪","烘","宿","档","戈","驳","嫂","裕","徙","箭","捐","肠","撑","晒","辨","殿","莲","摊","搅","酱","屏","疫","哀","蔡","堵","沫","皱","畅","叠","阁","莱","敲","辖","钩","痕","坝","巷","饿","祸","丘","玄","溜","曰","逻","彭","尝","卿","妨","艇","吞","韦","怨","矮","歇"]');

/***/ }),

/***/ 4262:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('["的","一","是","在","不","了","有","和","人","這","中","大","為","上","個","國","我","以","要","他","時","來","用","們","生","到","作","地","於","出","就","分","對","成","會","可","主","發","年","動","同","工","也","能","下","過","子","說","產","種","面","而","方","後","多","定","行","學","法","所","民","得","經","十","三","之","進","著","等","部","度","家","電","力","裡","如","水","化","高","自","二","理","起","小","物","現","實","加","量","都","兩","體","制","機","當","使","點","從","業","本","去","把","性","好","應","開","它","合","還","因","由","其","些","然","前","外","天","政","四","日","那","社","義","事","平","形","相","全","表","間","樣","與","關","各","重","新","線","內","數","正","心","反","你","明","看","原","又","麼","利","比","或","但","質","氣","第","向","道","命","此","變","條","只","沒","結","解","問","意","建","月","公","無","系","軍","很","情","者","最","立","代","想","已","通","並","提","直","題","黨","程","展","五","果","料","象","員","革","位","入","常","文","總","次","品","式","活","設","及","管","特","件","長","求","老","頭","基","資","邊","流","路","級","少","圖","山","統","接","知","較","將","組","見","計","別","她","手","角","期","根","論","運","農","指","幾","九","區","強","放","決","西","被","幹","做","必","戰","先","回","則","任","取","據","處","隊","南","給","色","光","門","即","保","治","北","造","百","規","熱","領","七","海","口","東","導","器","壓","志","世","金","增","爭","濟","階","油","思","術","極","交","受","聯","什","認","六","共","權","收","證","改","清","美","再","採","轉","更","單","風","切","打","白","教","速","花","帶","安","場","身","車","例","真","務","具","萬","每","目","至","達","走","積","示","議","聲","報","鬥","完","類","八","離","華","名","確","才","科","張","信","馬","節","話","米","整","空","元","況","今","集","溫","傳","土","許","步","群","廣","石","記","需","段","研","界","拉","林","律","叫","且","究","觀","越","織","裝","影","算","低","持","音","眾","書","布","复","容","兒","須","際","商","非","驗","連","斷","深","難","近","礦","千","週","委","素","技","備","半","辦","青","省","列","習","響","約","支","般","史","感","勞","便","團","往","酸","歷","市","克","何","除","消","構","府","稱","太","準","精","值","號","率","族","維","劃","選","標","寫","存","候","毛","親","快","效","斯","院","查","江","型","眼","王","按","格","養","易","置","派","層","片","始","卻","專","狀","育","廠","京","識","適","屬","圓","包","火","住","調","滿","縣","局","照","參","紅","細","引","聽","該","鐵","價","嚴","首","底","液","官","德","隨","病","蘇","失","爾","死","講","配","女","黃","推","顯","談","罪","神","藝","呢","席","含","企","望","密","批","營","項","防","舉","球","英","氧","勢","告","李","台","落","木","幫","輪","破","亞","師","圍","注","遠","字","材","排","供","河","態","封","另","施","減","樹","溶","怎","止","案","言","士","均","武","固","葉","魚","波","視","僅","費","緊","愛","左","章","早","朝","害","續","輕","服","試","食","充","兵","源","判","護","司","足","某","練","差","致","板","田","降","黑","犯","負","擊","范","繼","興","似","餘","堅","曲","輸","修","故","城","夫","夠","送","筆","船","佔","右","財","吃","富","春","職","覺","漢","畫","功","巴","跟","雖","雜","飛","檢","吸","助","昇","陽","互","初","創","抗","考","投","壞","策","古","徑","換","未","跑","留","鋼","曾","端","責","站","簡","述","錢","副","盡","帝","射","草","衝","承","獨","令","限","阿","宣","環","雙","請","超","微","讓","控","州","良","軸","找","否","紀","益","依","優","頂","礎","載","倒","房","突","坐","粉","敵","略","客","袁","冷","勝","絕","析","塊","劑","測","絲","協","訴","念","陳","仍","羅","鹽","友","洋","錯","苦","夜","刑","移","頻","逐","靠","混","母","短","皮","終","聚","汽","村","雲","哪","既","距","衛","停","烈","央","察","燒","迅","境","若","印","洲","刻","括","激","孔","搞","甚","室","待","核","校","散","侵","吧","甲","遊","久","菜","味","舊","模","湖","貨","損","預","阻","毫","普","穩","乙","媽","植","息","擴","銀","語","揮","酒","守","拿","序","紙","醫","缺","雨","嗎","針","劉","啊","急","唱","誤","訓","願","審","附","獲","茶","鮮","糧","斤","孩","脫","硫","肥","善","龍","演","父","漸","血","歡","械","掌","歌","沙","剛","攻","謂","盾","討","晚","粒","亂","燃","矛","乎","殺","藥","寧","魯","貴","鐘","煤","讀","班","伯","香","介","迫","句","豐","培","握","蘭","擔","弦","蛋","沉","假","穿","執","答","樂","誰","順","煙","縮","徵","臉","喜","松","腳","困","異","免","背","星","福","買","染","井","概","慢","怕","磁","倍","祖","皇","促","靜","補","評","翻","肉","踐","尼","衣","寬","揚","棉","希","傷","操","垂","秋","宜","氫","套","督","振","架","亮","末","憲","慶","編","牛","觸","映","雷","銷","詩","座","居","抓","裂","胞","呼","娘","景","威","綠","晶","厚","盟","衡","雞","孫","延","危","膠","屋","鄉","臨","陸","顧","掉","呀","燈","歲","措","束","耐","劇","玉","趙","跳","哥","季","課","凱","胡","額","款","紹","卷","齊","偉","蒸","殖","永","宗","苗","川","爐","岩","弱","零","楊","奏","沿","露","桿","探","滑","鎮","飯","濃","航","懷","趕","庫","奪","伊","靈","稅","途","滅","賽","歸","召","鼓","播","盤","裁","險","康","唯","錄","菌","純","借","糖","蓋","橫","符","私","努","堂","域","槍","潤","幅","哈","竟","熟","蟲","澤","腦","壤","碳","歐","遍","側","寨","敢","徹","慮","斜","薄","庭","納","彈","飼","伸","折","麥","濕","暗","荷","瓦","塞","床","築","惡","戶","訪","塔","奇","透","梁","刀","旋","跡","卡","氯","遇","份","毒","泥","退","洗","擺","灰","彩","賣","耗","夏","擇","忙","銅","獻","硬","予","繁","圈","雪","函","亦","抽","篇","陣","陰","丁","尺","追","堆","雄","迎","泛","爸","樓","避","謀","噸","野","豬","旗","累","偏","典","館","索","秦","脂","潮","爺","豆","忽","托","驚","塑","遺","愈","朱","替","纖","粗","傾","尚","痛","楚","謝","奮","購","磨","君","池","旁","碎","骨","監","捕","弟","暴","割","貫","殊","釋","詞","亡","壁","頓","寶","午","塵","聞","揭","炮","殘","冬","橋","婦","警","綜","招","吳","付","浮","遭","徐","您","搖","谷","贊","箱","隔","訂","男","吹","園","紛","唐","敗","宋","玻","巨","耕","坦","榮","閉","灣","鍵","凡","駐","鍋","救","恩","剝","凝","鹼","齒","截","煉","麻","紡","禁","廢","盛","版","緩","淨","睛","昌","婚","涉","筒","嘴","插","岸","朗","莊","街","藏","姑","貿","腐","奴","啦","慣","乘","夥","恢","勻","紗","扎","辯","耳","彪","臣","億","璃","抵","脈","秀","薩","俄","網","舞","店","噴","縱","寸","汗","掛","洪","賀","閃","柬","爆","烯","津","稻","牆","軟","勇","像","滾","厘","蒙","芳","肯","坡","柱","盪","腿","儀","旅","尾","軋","冰","貢","登","黎","削","鑽","勒","逃","障","氨","郭","峰","幣","港","伏","軌","畝","畢","擦","莫","刺","浪","秘","援","株","健","售","股","島","甘","泡","睡","童","鑄","湯","閥","休","匯","舍","牧","繞","炸","哲","磷","績","朋","淡","尖","啟","陷","柴","呈","徒","顏","淚","稍","忘","泵","藍","拖","洞","授","鏡","辛","壯","鋒","貧","虛","彎","摩","泰","幼","廷","尊","窗","綱","弄","隸","疑","氏","宮","姐","震","瑞","怪","尤","琴","循","描","膜","違","夾","腰","緣","珠","窮","森","枝","竹","溝","催","繩","憶","邦","剩","幸","漿","欄","擁","牙","貯","禮","濾","鈉","紋","罷","拍","咱","喊","袖","埃","勤","罰","焦","潛","伍","墨","欲","縫","姓","刊","飽","仿","獎","鋁","鬼","麗","跨","默","挖","鏈","掃","喝","袋","炭","污","幕","諸","弧","勵","梅","奶","潔","災","舟","鑑","苯","訟","抱","毀","懂","寒","智","埔","寄","屆","躍","渡","挑","丹","艱","貝","碰","拔","爹","戴","碼","夢","芽","熔","赤","漁","哭","敬","顆","奔","鉛","仲","虎","稀","妹","乏","珍","申","桌","遵","允","隆","螺","倉","魏","銳","曉","氮","兼","隱","礙","赫","撥","忠","肅","缸","牽","搶","博","巧","殼","兄","杜","訊","誠","碧","祥","柯","頁","巡","矩","悲","灌","齡","倫","票","尋","桂","鋪","聖","恐","恰","鄭","趣","抬","荒","騰","貼","柔","滴","猛","闊","輛","妻","填","撤","儲","簽","鬧","擾","紫","砂","遞","戲","吊","陶","伐","餵","療","瓶","婆","撫","臂","摸","忍","蝦","蠟","鄰","胸","鞏","擠","偶","棄","槽","勁","乳","鄧","吉","仁","爛","磚","租","烏","艦","伴","瓜","淺","丙","暫","燥","橡","柳","迷","暖","牌","秧","膽","詳","簧","踏","瓷","譜","呆","賓","糊","洛","輝","憤","競","隙","怒","粘","乃","緒","肩","籍","敏","塗","熙","皆","偵","懸","掘","享","糾","醒","狂","鎖","淀","恨","牲","霸","爬","賞","逆","玩","陵","祝","秒","浙","貌","役","彼","悉","鴨","趨","鳳","晨","畜","輩","秩","卵","署","梯","炎","灘","棋","驅","篩","峽","冒","啥","壽","譯","浸","泉","帽","遲","矽","疆","貸","漏","稿","冠","嫩","脅","芯","牢","叛","蝕","奧","鳴","嶺","羊","憑","串","塘","繪","酵","融","盆","錫","廟","籌","凍","輔","攝","襲","筋","拒","僚","旱","鉀","鳥","漆","沈","眉","疏","添","棒","穗","硝","韓","逼","扭","僑","涼","挺","碗","栽","炒","杯","患","餾","勸","豪","遼","勃","鴻","旦","吏","拜","狗","埋","輥","掩","飲","搬","罵","辭","勾","扣","估","蔣","絨","霧","丈","朵","姆","擬","宇","輯","陝","雕","償","蓄","崇","剪","倡","廳","咬","駛","薯","刷","斥","番","賦","奉","佛","澆","漫","曼","扇","鈣","桃","扶","仔","返","俗","虧","腔","鞋","棱","覆","框","悄","叔","撞","騙","勘","旺","沸","孤","吐","孟","渠","屈","疾","妙","惜","仰","狠","脹","諧","拋","黴","桑","崗","嘛","衰","盜","滲","臟","賴","湧","甜","曹","閱","肌","哩","厲","烴","緯","毅","昨","偽","症","煮","嘆","釘","搭","莖","籠","酷","偷","弓","錐","恆","傑","坑","鼻","翼","綸","敘","獄","逮","罐","絡","棚","抑","膨","蔬","寺","驟","穆","冶","枯","冊","屍","凸","紳","坯","犧","焰","轟","欣","晉","瘦","禦","錠","錦","喪","旬","鍛","壟","搜","撲","邀","亭","酯","邁","舒","脆","酶","閒","憂","酚","頑","羽","漲","卸","仗","陪","闢","懲","杭","姚","肚","捉","飄","漂","昆","欺","吾","郎","烷","汁","呵","飾","蕭","雅","郵","遷","燕","撒","姻","赴","宴","煩","債","帳","斑","鈴","旨","醇","董","餅","雛","姿","拌","傅","腹","妥","揉","賢","拆","歪","葡","胺","丟","浩","徽","昂","墊","擋","覽","貪","慰","繳","汪","慌","馮","諾","姜","誼","兇","劣","誣","耀","昏","躺","盈","騎","喬","溪","叢","盧","抹","悶","諮","刮","駕","纜","悟","摘","鉺","擲","頗","幻","柄","惠","慘","佳","仇","臘","窩","滌","劍","瞧","堡","潑","蔥","罩","霍","撈","胎","蒼","濱","倆","捅","湘","砍","霞","邵","萄","瘋","淮","遂","熊","糞","烘","宿","檔","戈","駁","嫂","裕","徙","箭","捐","腸","撐","曬","辨","殿","蓮","攤","攪","醬","屏","疫","哀","蔡","堵","沫","皺","暢","疊","閣","萊","敲","轄","鉤","痕","壩","巷","餓","禍","丘","玄","溜","曰","邏","彭","嘗","卿","妨","艇","吞","韋","怨","矮","歇"]');

/***/ }),

/***/ 40032:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('["abdikace","abeceda","adresa","agrese","akce","aktovka","alej","alkohol","amputace","ananas","andulka","anekdota","anketa","antika","anulovat","archa","arogance","asfalt","asistent","aspirace","astma","astronom","atlas","atletika","atol","autobus","azyl","babka","bachor","bacil","baculka","badatel","bageta","bagr","bahno","bakterie","balada","baletka","balkon","balonek","balvan","balza","bambus","bankomat","barbar","baret","barman","baroko","barva","baterka","batoh","bavlna","bazalka","bazilika","bazuka","bedna","beran","beseda","bestie","beton","bezinka","bezmoc","beztak","bicykl","bidlo","biftek","bikiny","bilance","biograf","biolog","bitva","bizon","blahobyt","blatouch","blecha","bledule","blesk","blikat","blizna","blokovat","bloudit","blud","bobek","bobr","bodlina","bodnout","bohatost","bojkot","bojovat","bokorys","bolest","borec","borovice","bota","boubel","bouchat","bouda","boule","bourat","boxer","bradavka","brambora","branka","bratr","brepta","briketa","brko","brloh","bronz","broskev","brunetka","brusinka","brzda","brzy","bublina","bubnovat","buchta","buditel","budka","budova","bufet","bujarost","bukvice","buldok","bulva","bunda","bunkr","burza","butik","buvol","buzola","bydlet","bylina","bytovka","bzukot","capart","carevna","cedr","cedule","cejch","cejn","cela","celer","celkem","celnice","cenina","cennost","cenovka","centrum","cenzor","cestopis","cetka","chalupa","chapadlo","charita","chata","chechtat","chemie","chichot","chirurg","chlad","chleba","chlubit","chmel","chmura","chobot","chochol","chodba","cholera","chomout","chopit","choroba","chov","chrapot","chrlit","chrt","chrup","chtivost","chudina","chutnat","chvat","chvilka","chvost","chyba","chystat","chytit","cibule","cigareta","cihelna","cihla","cinkot","cirkus","cisterna","citace","citrus","cizinec","cizost","clona","cokoliv","couvat","ctitel","ctnost","cudnost","cuketa","cukr","cupot","cvaknout","cval","cvik","cvrkot","cyklista","daleko","dareba","datel","datum","dcera","debata","dechovka","decibel","deficit","deflace","dekl","dekret","demokrat","deprese","derby","deska","detektiv","dikobraz","diktovat","dioda","diplom","disk","displej","divadlo","divoch","dlaha","dlouho","dluhopis","dnes","dobro","dobytek","docent","dochutit","dodnes","dohled","dohoda","dohra","dojem","dojnice","doklad","dokola","doktor","dokument","dolar","doleva","dolina","doma","dominant","domluvit","domov","donutit","dopad","dopis","doplnit","doposud","doprovod","dopustit","dorazit","dorost","dort","dosah","doslov","dostatek","dosud","dosyta","dotaz","dotek","dotknout","doufat","doutnat","dovozce","dozadu","doznat","dozorce","drahota","drak","dramatik","dravec","draze","drdol","drobnost","drogerie","drozd","drsnost","drtit","drzost","duben","duchovno","dudek","duha","duhovka","dusit","dusno","dutost","dvojice","dvorec","dynamit","ekolog","ekonomie","elektron","elipsa","email","emise","emoce","empatie","epizoda","epocha","epopej","epos","esej","esence","eskorta","eskymo","etiketa","euforie","evoluce","exekuce","exkurze","expedice","exploze","export","extrakt","facka","fajfka","fakulta","fanatik","fantazie","farmacie","favorit","fazole","federace","fejeton","fenka","fialka","figurant","filozof","filtr","finance","finta","fixace","fjord","flanel","flirt","flotila","fond","fosfor","fotbal","fotka","foton","frakce","freska","fronta","fukar","funkce","fyzika","galeje","garant","genetika","geolog","gilotina","glazura","glejt","golem","golfista","gotika","graf","gramofon","granule","grep","gril","grog","groteska","guma","hadice","hadr","hala","halenka","hanba","hanopis","harfa","harpuna","havran","hebkost","hejkal","hejno","hejtman","hektar","helma","hematom","herec","herna","heslo","hezky","historik","hladovka","hlasivky","hlava","hledat","hlen","hlodavec","hloh","hloupost","hltat","hlubina","hluchota","hmat","hmota","hmyz","hnis","hnojivo","hnout","hoblina","hoboj","hoch","hodiny","hodlat","hodnota","hodovat","hojnost","hokej","holinka","holka","holub","homole","honitba","honorace","horal","horda","horizont","horko","horlivec","hormon","hornina","horoskop","horstvo","hospoda","hostina","hotovost","houba","houf","houpat","houska","hovor","hradba","hranice","hravost","hrazda","hrbolek","hrdina","hrdlo","hrdost","hrnek","hrobka","hromada","hrot","hrouda","hrozen","hrstka","hrubost","hryzat","hubenost","hubnout","hudba","hukot","humr","husita","hustota","hvozd","hybnost","hydrant","hygiena","hymna","hysterik","idylka","ihned","ikona","iluze","imunita","infekce","inflace","inkaso","inovace","inspekce","internet","invalida","investor","inzerce","ironie","jablko","jachta","jahoda","jakmile","jakost","jalovec","jantar","jarmark","jaro","jasan","jasno","jatka","javor","jazyk","jedinec","jedle","jednatel","jehlan","jekot","jelen","jelito","jemnost","jenom","jepice","jeseter","jevit","jezdec","jezero","jinak","jindy","jinoch","jiskra","jistota","jitrnice","jizva","jmenovat","jogurt","jurta","kabaret","kabel","kabinet","kachna","kadet","kadidlo","kahan","kajak","kajuta","kakao","kaktus","kalamita","kalhoty","kalibr","kalnost","kamera","kamkoliv","kamna","kanibal","kanoe","kantor","kapalina","kapela","kapitola","kapka","kaple","kapota","kapr","kapusta","kapybara","karamel","karotka","karton","kasa","katalog","katedra","kauce","kauza","kavalec","kazajka","kazeta","kazivost","kdekoliv","kdesi","kedluben","kemp","keramika","kino","klacek","kladivo","klam","klapot","klasika","klaun","klec","klenba","klepat","klesnout","klid","klima","klisna","klobouk","klokan","klopa","kloub","klubovna","klusat","kluzkost","kmen","kmitat","kmotr","kniha","knot","koalice","koberec","kobka","kobliha","kobyla","kocour","kohout","kojenec","kokos","koktejl","kolaps","koleda","kolize","kolo","komando","kometa","komik","komnata","komora","kompas","komunita","konat","koncept","kondice","konec","konfese","kongres","konina","konkurs","kontakt","konzerva","kopanec","kopie","kopnout","koprovka","korbel","korektor","kormidlo","koroptev","korpus","koruna","koryto","korzet","kosatec","kostka","kotel","kotleta","kotoul","koukat","koupelna","kousek","kouzlo","kovboj","koza","kozoroh","krabice","krach","krajina","kralovat","krasopis","kravata","kredit","krejcar","kresba","kreveta","kriket","kritik","krize","krkavec","krmelec","krmivo","krocan","krok","kronika","kropit","kroupa","krovka","krtek","kruhadlo","krupice","krutost","krvinka","krychle","krypta","krystal","kryt","kudlanka","kufr","kujnost","kukla","kulajda","kulich","kulka","kulomet","kultura","kuna","kupodivu","kurt","kurzor","kutil","kvalita","kvasinka","kvestor","kynolog","kyselina","kytara","kytice","kytka","kytovec","kyvadlo","labrador","lachtan","ladnost","laik","lakomec","lamela","lampa","lanovka","lasice","laso","lastura","latinka","lavina","lebka","leckdy","leden","lednice","ledovka","ledvina","legenda","legie","legrace","lehce","lehkost","lehnout","lektvar","lenochod","lentilka","lepenka","lepidlo","letadlo","letec","letmo","letokruh","levhart","levitace","levobok","libra","lichotka","lidojed","lidskost","lihovina","lijavec","lilek","limetka","linie","linka","linoleum","listopad","litina","litovat","lobista","lodivod","logika","logoped","lokalita","loket","lomcovat","lopata","lopuch","lord","losos","lotr","loudal","louh","louka","louskat","lovec","lstivost","lucerna","lucifer","lump","lusk","lustrace","lvice","lyra","lyrika","lysina","madam","madlo","magistr","mahagon","majetek","majitel","majorita","makak","makovice","makrela","malba","malina","malovat","malvice","maminka","mandle","manko","marnost","masakr","maskot","masopust","matice","matrika","maturita","mazanec","mazivo","mazlit","mazurka","mdloba","mechanik","meditace","medovina","melasa","meloun","mentolka","metla","metoda","metr","mezera","migrace","mihnout","mihule","mikina","mikrofon","milenec","milimetr","milost","mimika","mincovna","minibar","minomet","minulost","miska","mistr","mixovat","mladost","mlha","mlhovina","mlok","mlsat","mluvit","mnich","mnohem","mobil","mocnost","modelka","modlitba","mohyla","mokro","molekula","momentka","monarcha","monokl","monstrum","montovat","monzun","mosaz","moskyt","most","motivace","motorka","motyka","moucha","moudrost","mozaika","mozek","mozol","mramor","mravenec","mrkev","mrtvola","mrzet","mrzutost","mstitel","mudrc","muflon","mulat","mumie","munice","muset","mutace","muzeum","muzikant","myslivec","mzda","nabourat","nachytat","nadace","nadbytek","nadhoz","nadobro","nadpis","nahlas","nahnat","nahodile","nahradit","naivita","najednou","najisto","najmout","naklonit","nakonec","nakrmit","nalevo","namazat","namluvit","nanometr","naoko","naopak","naostro","napadat","napevno","naplnit","napnout","naposled","naprosto","narodit","naruby","narychlo","nasadit","nasekat","naslepo","nastat","natolik","navenek","navrch","navzdory","nazvat","nebe","nechat","necky","nedaleko","nedbat","neduh","negace","nehet","nehoda","nejen","nejprve","neklid","nelibost","nemilost","nemoc","neochota","neonka","nepokoj","nerost","nerv","nesmysl","nesoulad","netvor","neuron","nevina","nezvykle","nicota","nijak","nikam","nikdy","nikl","nikterak","nitro","nocleh","nohavice","nominace","nora","norek","nositel","nosnost","nouze","noviny","novota","nozdra","nuda","nudle","nuget","nutit","nutnost","nutrie","nymfa","obal","obarvit","obava","obdiv","obec","obehnat","obejmout","obezita","obhajoba","obilnice","objasnit","objekt","obklopit","oblast","oblek","obliba","obloha","obluda","obnos","obohatit","obojek","obout","obrazec","obrna","obruba","obrys","obsah","obsluha","obstarat","obuv","obvaz","obvinit","obvod","obvykle","obyvatel","obzor","ocas","ocel","ocenit","ochladit","ochota","ochrana","ocitnout","odboj","odbyt","odchod","odcizit","odebrat","odeslat","odevzdat","odezva","odhadce","odhodit","odjet","odjinud","odkaz","odkoupit","odliv","odluka","odmlka","odolnost","odpad","odpis","odplout","odpor","odpustit","odpykat","odrazka","odsoudit","odstup","odsun","odtok","odtud","odvaha","odveta","odvolat","odvracet","odznak","ofina","ofsajd","ohlas","ohnisko","ohrada","ohrozit","ohryzek","okap","okenice","oklika","okno","okouzlit","okovy","okrasa","okres","okrsek","okruh","okupant","okurka","okusit","olejnina","olizovat","omak","omeleta","omezit","omladina","omlouvat","omluva","omyl","onehdy","opakovat","opasek","operace","opice","opilost","opisovat","opora","opozice","opravdu","oproti","orbital","orchestr","orgie","orlice","orloj","ortel","osada","oschnout","osika","osivo","oslava","oslepit","oslnit","oslovit","osnova","osoba","osolit","ospalec","osten","ostraha","ostuda","ostych","osvojit","oteplit","otisk","otop","otrhat","otrlost","otrok","otruby","otvor","ovanout","ovar","oves","ovlivnit","ovoce","oxid","ozdoba","pachatel","pacient","padouch","pahorek","pakt","palanda","palec","palivo","paluba","pamflet","pamlsek","panenka","panika","panna","panovat","panstvo","pantofle","paprika","parketa","parodie","parta","paruka","paryba","paseka","pasivita","pastelka","patent","patrona","pavouk","pazneht","pazourek","pecka","pedagog","pejsek","peklo","peloton","penalta","pendrek","penze","periskop","pero","pestrost","petarda","petice","petrolej","pevnina","pexeso","pianista","piha","pijavice","pikle","piknik","pilina","pilnost","pilulka","pinzeta","pipeta","pisatel","pistole","pitevna","pivnice","pivovar","placenta","plakat","plamen","planeta","plastika","platit","plavidlo","plaz","plech","plemeno","plenta","ples","pletivo","plevel","plivat","plnit","plno","plocha","plodina","plomba","plout","pluk","plyn","pobavit","pobyt","pochod","pocit","poctivec","podat","podcenit","podepsat","podhled","podivit","podklad","podmanit","podnik","podoba","podpora","podraz","podstata","podvod","podzim","poezie","pohanka","pohnutka","pohovor","pohroma","pohyb","pointa","pojistka","pojmout","pokazit","pokles","pokoj","pokrok","pokuta","pokyn","poledne","polibek","polknout","poloha","polynom","pomalu","pominout","pomlka","pomoc","pomsta","pomyslet","ponechat","ponorka","ponurost","popadat","popel","popisek","poplach","poprosit","popsat","popud","poradce","porce","porod","porucha","poryv","posadit","posed","posila","poskok","poslanec","posoudit","pospolu","postava","posudek","posyp","potah","potkan","potlesk","potomek","potrava","potupa","potvora","poukaz","pouto","pouzdro","povaha","povidla","povlak","povoz","povrch","povstat","povyk","povzdech","pozdrav","pozemek","poznatek","pozor","pozvat","pracovat","prahory","praktika","prales","praotec","praporek","prase","pravda","princip","prkno","probudit","procento","prodej","profese","prohra","projekt","prolomit","promile","pronikat","propad","prorok","prosba","proton","proutek","provaz","prskavka","prsten","prudkost","prut","prvek","prvohory","psanec","psovod","pstruh","ptactvo","puberta","puch","pudl","pukavec","puklina","pukrle","pult","pumpa","punc","pupen","pusa","pusinka","pustina","putovat","putyka","pyramida","pysk","pytel","racek","rachot","radiace","radnice","radon","raft","ragby","raketa","rakovina","rameno","rampouch","rande","rarach","rarita","rasovna","rastr","ratolest","razance","razidlo","reagovat","reakce","recept","redaktor","referent","reflex","rejnok","reklama","rekord","rekrut","rektor","reputace","revize","revma","revolver","rezerva","riskovat","riziko","robotika","rodokmen","rohovka","rokle","rokoko","romaneto","ropovod","ropucha","rorejs","rosol","rostlina","rotmistr","rotoped","rotunda","roubenka","roucho","roup","roura","rovina","rovnice","rozbor","rozchod","rozdat","rozeznat","rozhodce","rozinka","rozjezd","rozkaz","rozloha","rozmar","rozpad","rozruch","rozsah","roztok","rozum","rozvod","rubrika","ruchadlo","rukavice","rukopis","ryba","rybolov","rychlost","rydlo","rypadlo","rytina","ryzost","sadista","sahat","sako","samec","samizdat","samota","sanitka","sardinka","sasanka","satelit","sazba","sazenice","sbor","schovat","sebranka","secese","sedadlo","sediment","sedlo","sehnat","sejmout","sekera","sekta","sekunda","sekvoje","semeno","seno","servis","sesadit","seshora","seskok","seslat","sestra","sesuv","sesypat","setba","setina","setkat","setnout","setrvat","sever","seznam","shoda","shrnout","sifon","silnice","sirka","sirotek","sirup","situace","skafandr","skalisko","skanzen","skaut","skeptik","skica","skladba","sklenice","sklo","skluz","skoba","skokan","skoro","skripta","skrz","skupina","skvost","skvrna","slabika","sladidlo","slanina","slast","slavnost","sledovat","slepec","sleva","slezina","slib","slina","sliznice","slon","sloupek","slovo","sluch","sluha","slunce","slupka","slza","smaragd","smetana","smilstvo","smlouva","smog","smrad","smrk","smrtka","smutek","smysl","snad","snaha","snob","sobota","socha","sodovka","sokol","sopka","sotva","souboj","soucit","soudce","souhlas","soulad","soumrak","souprava","soused","soutok","souviset","spalovna","spasitel","spis","splav","spodek","spojenec","spolu","sponzor","spornost","spousta","sprcha","spustit","sranda","sraz","srdce","srna","srnec","srovnat","srpen","srst","srub","stanice","starosta","statika","stavba","stehno","stezka","stodola","stolek","stopa","storno","stoupat","strach","stres","strhnout","strom","struna","studna","stupnice","stvol","styk","subjekt","subtropy","suchar","sudost","sukno","sundat","sunout","surikata","surovina","svah","svalstvo","svetr","svatba","svazek","svisle","svitek","svoboda","svodidlo","svorka","svrab","sykavka","sykot","synek","synovec","sypat","sypkost","syrovost","sysel","sytost","tabletka","tabule","tahoun","tajemno","tajfun","tajga","tajit","tajnost","taktika","tamhle","tampon","tancovat","tanec","tanker","tapeta","tavenina","tazatel","technika","tehdy","tekutina","telefon","temnota","tendence","tenista","tenor","teplota","tepna","teprve","terapie","termoska","textil","ticho","tiskopis","titulek","tkadlec","tkanina","tlapka","tleskat","tlukot","tlupa","tmel","toaleta","topinka","topol","torzo","touha","toulec","tradice","traktor","tramp","trasa","traverza","trefit","trest","trezor","trhavina","trhlina","trochu","trojice","troska","trouba","trpce","trpitel","trpkost","trubec","truchlit","truhlice","trus","trvat","tudy","tuhnout","tuhost","tundra","turista","turnaj","tuzemsko","tvaroh","tvorba","tvrdost","tvrz","tygr","tykev","ubohost","uboze","ubrat","ubrousek","ubrus","ubytovna","ucho","uctivost","udivit","uhradit","ujednat","ujistit","ujmout","ukazatel","uklidnit","uklonit","ukotvit","ukrojit","ulice","ulita","ulovit","umyvadlo","unavit","uniforma","uniknout","upadnout","uplatnit","uplynout","upoutat","upravit","uran","urazit","usednout","usilovat","usmrtit","usnadnit","usnout","usoudit","ustlat","ustrnout","utahovat","utkat","utlumit","utonout","utopenec","utrousit","uvalit","uvolnit","uvozovka","uzdravit","uzel","uzenina","uzlina","uznat","vagon","valcha","valoun","vana","vandal","vanilka","varan","varhany","varovat","vcelku","vchod","vdova","vedro","vegetace","vejce","velbloud","veletrh","velitel","velmoc","velryba","venkov","veranda","verze","veselka","veskrze","vesnice","vespodu","vesta","veterina","veverka","vibrace","vichr","videohra","vidina","vidle","vila","vinice","viset","vitalita","vize","vizitka","vjezd","vklad","vkus","vlajka","vlak","vlasec","vlevo","vlhkost","vliv","vlnovka","vloupat","vnucovat","vnuk","voda","vodivost","vodoznak","vodstvo","vojensky","vojna","vojsko","volant","volba","volit","volno","voskovka","vozidlo","vozovna","vpravo","vrabec","vracet","vrah","vrata","vrba","vrcholek","vrhat","vrstva","vrtule","vsadit","vstoupit","vstup","vtip","vybavit","vybrat","vychovat","vydat","vydra","vyfotit","vyhledat","vyhnout","vyhodit","vyhradit","vyhubit","vyjasnit","vyjet","vyjmout","vyklopit","vykonat","vylekat","vymazat","vymezit","vymizet","vymyslet","vynechat","vynikat","vynutit","vypadat","vyplatit","vypravit","vypustit","vyrazit","vyrovnat","vyrvat","vyslovit","vysoko","vystavit","vysunout","vysypat","vytasit","vytesat","vytratit","vyvinout","vyvolat","vyvrhel","vyzdobit","vyznat","vzadu","vzbudit","vzchopit","vzdor","vzduch","vzdychat","vzestup","vzhledem","vzkaz","vzlykat","vznik","vzorek","vzpoura","vztah","vztek","xylofon","zabrat","zabydlet","zachovat","zadarmo","zadusit","zafoukat","zahltit","zahodit","zahrada","zahynout","zajatec","zajet","zajistit","zaklepat","zakoupit","zalepit","zamezit","zamotat","zamyslet","zanechat","zanikat","zaplatit","zapojit","zapsat","zarazit","zastavit","zasunout","zatajit","zatemnit","zatknout","zaujmout","zavalit","zavelet","zavinit","zavolat","zavrtat","zazvonit","zbavit","zbrusu","zbudovat","zbytek","zdaleka","zdarma","zdatnost","zdivo","zdobit","zdroj","zdvih","zdymadlo","zelenina","zeman","zemina","zeptat","zezadu","zezdola","zhatit","zhltnout","zhluboka","zhotovit","zhruba","zima","zimnice","zjemnit","zklamat","zkoumat","zkratka","zkumavka","zlato","zlehka","zloba","zlom","zlost","zlozvyk","zmapovat","zmar","zmatek","zmije","zmizet","zmocnit","zmodrat","zmrzlina","zmutovat","znak","znalost","znamenat","znovu","zobrazit","zotavit","zoubek","zoufale","zplodit","zpomalit","zprava","zprostit","zprudka","zprvu","zrada","zranit","zrcadlo","zrnitost","zrno","zrovna","zrychlit","zrzavost","zticha","ztratit","zubovina","zubr","zvednout","zvenku","zvesela","zvon","zvrat","zvukovod","zvyk"]');

/***/ }),

/***/ 24573:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('["abandon","ability","able","about","above","absent","absorb","abstract","absurd","abuse","access","accident","account","accuse","achieve","acid","acoustic","acquire","across","act","action","actor","actress","actual","adapt","add","addict","address","adjust","admit","adult","advance","advice","aerobic","affair","afford","afraid","again","age","agent","agree","ahead","aim","air","airport","aisle","alarm","album","alcohol","alert","alien","all","alley","allow","almost","alone","alpha","already","also","alter","always","amateur","amazing","among","amount","amused","analyst","anchor","ancient","anger","angle","angry","animal","ankle","announce","annual","another","answer","antenna","antique","anxiety","any","apart","apology","appear","apple","approve","april","arch","arctic","area","arena","argue","arm","armed","armor","army","around","arrange","arrest","arrive","arrow","art","artefact","artist","artwork","ask","aspect","assault","asset","assist","assume","asthma","athlete","atom","attack","attend","attitude","attract","auction","audit","august","aunt","author","auto","autumn","average","avocado","avoid","awake","aware","away","awesome","awful","awkward","axis","baby","bachelor","bacon","badge","bag","balance","balcony","ball","bamboo","banana","banner","bar","barely","bargain","barrel","base","basic","basket","battle","beach","bean","beauty","because","become","beef","before","begin","behave","behind","believe","below","belt","bench","benefit","best","betray","better","between","beyond","bicycle","bid","bike","bind","biology","bird","birth","bitter","black","blade","blame","blanket","blast","bleak","bless","blind","blood","blossom","blouse","blue","blur","blush","board","boat","body","boil","bomb","bone","bonus","book","boost","border","boring","borrow","boss","bottom","bounce","box","boy","bracket","brain","brand","brass","brave","bread","breeze","brick","bridge","brief","bright","bring","brisk","broccoli","broken","bronze","broom","brother","brown","brush","bubble","buddy","budget","buffalo","build","bulb","bulk","bullet","bundle","bunker","burden","burger","burst","bus","business","busy","butter","buyer","buzz","cabbage","cabin","cable","cactus","cage","cake","call","calm","camera","camp","can","canal","cancel","candy","cannon","canoe","canvas","canyon","capable","capital","captain","car","carbon","card","cargo","carpet","carry","cart","case","cash","casino","castle","casual","cat","catalog","catch","category","cattle","caught","cause","caution","cave","ceiling","celery","cement","census","century","cereal","certain","chair","chalk","champion","change","chaos","chapter","charge","chase","chat","cheap","check","cheese","chef","cherry","chest","chicken","chief","child","chimney","choice","choose","chronic","chuckle","chunk","churn","cigar","cinnamon","circle","citizen","city","civil","claim","clap","clarify","claw","clay","clean","clerk","clever","click","client","cliff","climb","clinic","clip","clock","clog","close","cloth","cloud","clown","club","clump","cluster","clutch","coach","coast","coconut","code","coffee","coil","coin","collect","color","column","combine","come","comfort","comic","common","company","concert","conduct","confirm","congress","connect","consider","control","convince","cook","cool","copper","copy","coral","core","corn","correct","cost","cotton","couch","country","couple","course","cousin","cover","coyote","crack","cradle","craft","cram","crane","crash","crater","crawl","crazy","cream","credit","creek","crew","cricket","crime","crisp","critic","crop","cross","crouch","crowd","crucial","cruel","cruise","crumble","crunch","crush","cry","crystal","cube","culture","cup","cupboard","curious","current","curtain","curve","cushion","custom","cute","cycle","dad","damage","damp","dance","danger","daring","dash","daughter","dawn","day","deal","debate","debris","decade","december","decide","decline","decorate","decrease","deer","defense","define","defy","degree","delay","deliver","demand","demise","denial","dentist","deny","depart","depend","deposit","depth","deputy","derive","describe","desert","design","desk","despair","destroy","detail","detect","develop","device","devote","diagram","dial","diamond","diary","dice","diesel","diet","differ","digital","dignity","dilemma","dinner","dinosaur","direct","dirt","disagree","discover","disease","dish","dismiss","disorder","display","distance","divert","divide","divorce","dizzy","doctor","document","dog","doll","dolphin","domain","donate","donkey","donor","door","dose","double","dove","draft","dragon","drama","drastic","draw","dream","dress","drift","drill","drink","drip","drive","drop","drum","dry","duck","dumb","dune","during","dust","dutch","duty","dwarf","dynamic","eager","eagle","early","earn","earth","easily","east","easy","echo","ecology","economy","edge","edit","educate","effort","egg","eight","either","elbow","elder","electric","elegant","element","elephant","elevator","elite","else","embark","embody","embrace","emerge","emotion","employ","empower","empty","enable","enact","end","endless","endorse","enemy","energy","enforce","engage","engine","enhance","enjoy","enlist","enough","enrich","enroll","ensure","enter","entire","entry","envelope","episode","equal","equip","era","erase","erode","erosion","error","erupt","escape","essay","essence","estate","eternal","ethics","evidence","evil","evoke","evolve","exact","example","excess","exchange","excite","exclude","excuse","execute","exercise","exhaust","exhibit","exile","exist","exit","exotic","expand","expect","expire","explain","expose","express","extend","extra","eye","eyebrow","fabric","face","faculty","fade","faint","faith","fall","false","fame","family","famous","fan","fancy","fantasy","farm","fashion","fat","fatal","father","fatigue","fault","favorite","feature","february","federal","fee","feed","feel","female","fence","festival","fetch","fever","few","fiber","fiction","field","figure","file","film","filter","final","find","fine","finger","finish","fire","firm","first","fiscal","fish","fit","fitness","fix","flag","flame","flash","flat","flavor","flee","flight","flip","float","flock","floor","flower","fluid","flush","fly","foam","focus","fog","foil","fold","follow","food","foot","force","forest","forget","fork","fortune","forum","forward","fossil","foster","found","fox","fragile","frame","frequent","fresh","friend","fringe","frog","front","frost","frown","frozen","fruit","fuel","fun","funny","furnace","fury","future","gadget","gain","galaxy","gallery","game","gap","garage","garbage","garden","garlic","garment","gas","gasp","gate","gather","gauge","gaze","general","genius","genre","gentle","genuine","gesture","ghost","giant","gift","giggle","ginger","giraffe","girl","give","glad","glance","glare","glass","glide","glimpse","globe","gloom","glory","glove","glow","glue","goat","goddess","gold","good","goose","gorilla","gospel","gossip","govern","gown","grab","grace","grain","grant","grape","grass","gravity","great","green","grid","grief","grit","grocery","group","grow","grunt","guard","guess","guide","guilt","guitar","gun","gym","habit","hair","half","hammer","hamster","hand","happy","harbor","hard","harsh","harvest","hat","have","hawk","hazard","head","health","heart","heavy","hedgehog","height","hello","helmet","help","hen","hero","hidden","high","hill","hint","hip","hire","history","hobby","hockey","hold","hole","holiday","hollow","home","honey","hood","hope","horn","horror","horse","hospital","host","hotel","hour","hover","hub","huge","human","humble","humor","hundred","hungry","hunt","hurdle","hurry","hurt","husband","hybrid","ice","icon","idea","identify","idle","ignore","ill","illegal","illness","image","imitate","immense","immune","impact","impose","improve","impulse","inch","include","income","increase","index","indicate","indoor","industry","infant","inflict","inform","inhale","inherit","initial","inject","injury","inmate","inner","innocent","input","inquiry","insane","insect","inside","inspire","install","intact","interest","into","invest","invite","involve","iron","island","isolate","issue","item","ivory","jacket","jaguar","jar","jazz","jealous","jeans","jelly","jewel","job","join","joke","journey","joy","judge","juice","jump","jungle","junior","junk","just","kangaroo","keen","keep","ketchup","key","kick","kid","kidney","kind","kingdom","kiss","kit","kitchen","kite","kitten","kiwi","knee","knife","knock","know","lab","label","labor","ladder","lady","lake","lamp","language","laptop","large","later","latin","laugh","laundry","lava","law","lawn","lawsuit","layer","lazy","leader","leaf","learn","leave","lecture","left","leg","legal","legend","leisure","lemon","lend","length","lens","leopard","lesson","letter","level","liar","liberty","library","license","life","lift","light","like","limb","limit","link","lion","liquid","list","little","live","lizard","load","loan","lobster","local","lock","logic","lonely","long","loop","lottery","loud","lounge","love","loyal","lucky","luggage","lumber","lunar","lunch","luxury","lyrics","machine","mad","magic","magnet","maid","mail","main","major","make","mammal","man","manage","mandate","mango","mansion","manual","maple","marble","march","margin","marine","market","marriage","mask","mass","master","match","material","math","matrix","matter","maximum","maze","meadow","mean","measure","meat","mechanic","medal","media","melody","melt","member","memory","mention","menu","mercy","merge","merit","merry","mesh","message","metal","method","middle","midnight","milk","million","mimic","mind","minimum","minor","minute","miracle","mirror","misery","miss","mistake","mix","mixed","mixture","mobile","model","modify","mom","moment","monitor","monkey","monster","month","moon","moral","more","morning","mosquito","mother","motion","motor","mountain","mouse","move","movie","much","muffin","mule","multiply","muscle","museum","mushroom","music","must","mutual","myself","mystery","myth","naive","name","napkin","narrow","nasty","nation","nature","near","neck","need","negative","neglect","neither","nephew","nerve","nest","net","network","neutral","never","news","next","nice","night","noble","noise","nominee","noodle","normal","north","nose","notable","note","nothing","notice","novel","now","nuclear","number","nurse","nut","oak","obey","object","oblige","obscure","observe","obtain","obvious","occur","ocean","october","odor","off","offer","office","often","oil","okay","old","olive","olympic","omit","once","one","onion","online","only","open","opera","opinion","oppose","option","orange","orbit","orchard","order","ordinary","organ","orient","original","orphan","ostrich","other","outdoor","outer","output","outside","oval","oven","over","own","owner","oxygen","oyster","ozone","pact","paddle","page","pair","palace","palm","panda","panel","panic","panther","paper","parade","parent","park","parrot","party","pass","patch","path","patient","patrol","pattern","pause","pave","payment","peace","peanut","pear","peasant","pelican","pen","penalty","pencil","people","pepper","perfect","permit","person","pet","phone","photo","phrase","physical","piano","picnic","picture","piece","pig","pigeon","pill","pilot","pink","pioneer","pipe","pistol","pitch","pizza","place","planet","plastic","plate","play","please","pledge","pluck","plug","plunge","poem","poet","point","polar","pole","police","pond","pony","pool","popular","portion","position","possible","post","potato","pottery","poverty","powder","power","practice","praise","predict","prefer","prepare","present","pretty","prevent","price","pride","primary","print","priority","prison","private","prize","problem","process","produce","profit","program","project","promote","proof","property","prosper","protect","proud","provide","public","pudding","pull","pulp","pulse","pumpkin","punch","pupil","puppy","purchase","purity","purpose","purse","push","put","puzzle","pyramid","quality","quantum","quarter","question","quick","quit","quiz","quote","rabbit","raccoon","race","rack","radar","radio","rail","rain","raise","rally","ramp","ranch","random","range","rapid","rare","rate","rather","raven","raw","razor","ready","real","reason","rebel","rebuild","recall","receive","recipe","record","recycle","reduce","reflect","reform","refuse","region","regret","regular","reject","relax","release","relief","rely","remain","remember","remind","remove","render","renew","rent","reopen","repair","repeat","replace","report","require","rescue","resemble","resist","resource","response","result","retire","retreat","return","reunion","reveal","review","reward","rhythm","rib","ribbon","rice","rich","ride","ridge","rifle","right","rigid","ring","riot","ripple","risk","ritual","rival","river","road","roast","robot","robust","rocket","romance","roof","rookie","room","rose","rotate","rough","round","route","royal","rubber","rude","rug","rule","run","runway","rural","sad","saddle","sadness","safe","sail","salad","salmon","salon","salt","salute","same","sample","sand","satisfy","satoshi","sauce","sausage","save","say","scale","scan","scare","scatter","scene","scheme","school","science","scissors","scorpion","scout","scrap","screen","script","scrub","sea","search","season","seat","second","secret","section","security","seed","seek","segment","select","sell","seminar","senior","sense","sentence","series","service","session","settle","setup","seven","shadow","shaft","shallow","share","shed","shell","sheriff","shield","shift","shine","ship","shiver","shock","shoe","shoot","shop","short","shoulder","shove","shrimp","shrug","shuffle","shy","sibling","sick","side","siege","sight","sign","silent","silk","silly","silver","similar","simple","since","sing","siren","sister","situate","six","size","skate","sketch","ski","skill","skin","skirt","skull","slab","slam","sleep","slender","slice","slide","slight","slim","slogan","slot","slow","slush","small","smart","smile","smoke","smooth","snack","snake","snap","sniff","snow","soap","soccer","social","sock","soda","soft","solar","soldier","solid","solution","solve","someone","song","soon","sorry","sort","soul","sound","soup","source","south","space","spare","spatial","spawn","speak","special","speed","spell","spend","sphere","spice","spider","spike","spin","spirit","split","spoil","sponsor","spoon","sport","spot","spray","spread","spring","spy","square","squeeze","squirrel","stable","stadium","staff","stage","stairs","stamp","stand","start","state","stay","steak","steel","stem","step","stereo","stick","still","sting","stock","stomach","stone","stool","story","stove","strategy","street","strike","strong","struggle","student","stuff","stumble","style","subject","submit","subway","success","such","sudden","suffer","sugar","suggest","suit","summer","sun","sunny","sunset","super","supply","supreme","sure","surface","surge","surprise","surround","survey","suspect","sustain","swallow","swamp","swap","swarm","swear","sweet","swift","swim","swing","switch","sword","symbol","symptom","syrup","system","table","tackle","tag","tail","talent","talk","tank","tape","target","task","taste","tattoo","taxi","teach","team","tell","ten","tenant","tennis","tent","term","test","text","thank","that","theme","then","theory","there","they","thing","this","thought","three","thrive","throw","thumb","thunder","ticket","tide","tiger","tilt","timber","time","tiny","tip","tired","tissue","title","toast","tobacco","today","toddler","toe","together","toilet","token","tomato","tomorrow","tone","tongue","tonight","tool","tooth","top","topic","topple","torch","tornado","tortoise","toss","total","tourist","toward","tower","town","toy","track","trade","traffic","tragic","train","transfer","trap","trash","travel","tray","treat","tree","trend","trial","tribe","trick","trigger","trim","trip","trophy","trouble","truck","true","truly","trumpet","trust","truth","try","tube","tuition","tumble","tuna","tunnel","turkey","turn","turtle","twelve","twenty","twice","twin","twist","two","type","typical","ugly","umbrella","unable","unaware","uncle","uncover","under","undo","unfair","unfold","unhappy","uniform","unique","unit","universe","unknown","unlock","until","unusual","unveil","update","upgrade","uphold","upon","upper","upset","urban","urge","usage","use","used","useful","useless","usual","utility","vacant","vacuum","vague","valid","valley","valve","van","vanish","vapor","various","vast","vault","vehicle","velvet","vendor","venture","venue","verb","verify","version","very","vessel","veteran","viable","vibrant","vicious","victory","video","view","village","vintage","violin","virtual","virus","visa","visit","visual","vital","vivid","vocal","voice","void","volcano","volume","vote","voyage","wage","wagon","wait","walk","wall","walnut","want","warfare","warm","warrior","wash","wasp","waste","water","wave","way","wealth","weapon","wear","weasel","weather","web","wedding","weekend","weird","welcome","west","wet","whale","what","wheat","wheel","when","where","whip","whisper","wide","width","wife","wild","will","win","window","wine","wing","wink","winner","winter","wire","wisdom","wise","wish","witness","wolf","woman","wonder","wood","wool","word","work","world","worry","worth","wrap","wreck","wrestle","wrist","write","wrong","yard","year","yellow","you","young","youth","zebra","zero","zone","zoo"]');

/***/ }),

/***/ 11848:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('["abaisser","abandon","abdiquer","abeille","abolir","aborder","aboutir","aboyer","abrasif","abreuver","abriter","abroger","abrupt","absence","absolu","absurde","abusif","abyssal","académie","acajou","acarien","accabler","accepter","acclamer","accolade","accroche","accuser","acerbe","achat","acheter","aciduler","acier","acompte","acquérir","acronyme","acteur","actif","actuel","adepte","adéquat","adhésif","adjectif","adjuger","admettre","admirer","adopter","adorer","adoucir","adresse","adroit","adulte","adverbe","aérer","aéronef","affaire","affecter","affiche","affreux","affubler","agacer","agencer","agile","agiter","agrafer","agréable","agrume","aider","aiguille","ailier","aimable","aisance","ajouter","ajuster","alarmer","alchimie","alerte","algèbre","algue","aliéner","aliment","alléger","alliage","allouer","allumer","alourdir","alpaga","altesse","alvéole","amateur","ambigu","ambre","aménager","amertume","amidon","amiral","amorcer","amour","amovible","amphibie","ampleur","amusant","analyse","anaphore","anarchie","anatomie","ancien","anéantir","angle","angoisse","anguleux","animal","annexer","annonce","annuel","anodin","anomalie","anonyme","anormal","antenne","antidote","anxieux","apaiser","apéritif","aplanir","apologie","appareil","appeler","apporter","appuyer","aquarium","aqueduc","arbitre","arbuste","ardeur","ardoise","argent","arlequin","armature","armement","armoire","armure","arpenter","arracher","arriver","arroser","arsenic","artériel","article","aspect","asphalte","aspirer","assaut","asservir","assiette","associer","assurer","asticot","astre","astuce","atelier","atome","atrium","atroce","attaque","attentif","attirer","attraper","aubaine","auberge","audace","audible","augurer","aurore","automne","autruche","avaler","avancer","avarice","avenir","averse","aveugle","aviateur","avide","avion","aviser","avoine","avouer","avril","axial","axiome","badge","bafouer","bagage","baguette","baignade","balancer","balcon","baleine","balisage","bambin","bancaire","bandage","banlieue","bannière","banquier","barbier","baril","baron","barque","barrage","bassin","bastion","bataille","bateau","batterie","baudrier","bavarder","belette","bélier","belote","bénéfice","berceau","berger","berline","bermuda","besace","besogne","bétail","beurre","biberon","bicycle","bidule","bijou","bilan","bilingue","billard","binaire","biologie","biopsie","biotype","biscuit","bison","bistouri","bitume","bizarre","blafard","blague","blanchir","blessant","blinder","blond","bloquer","blouson","bobard","bobine","boire","boiser","bolide","bonbon","bondir","bonheur","bonifier","bonus","bordure","borne","botte","boucle","boueux","bougie","boulon","bouquin","bourse","boussole","boutique","boxeur","branche","brasier","brave","brebis","brèche","breuvage","bricoler","brigade","brillant","brioche","brique","brochure","broder","bronzer","brousse","broyeur","brume","brusque","brutal","bruyant","buffle","buisson","bulletin","bureau","burin","bustier","butiner","butoir","buvable","buvette","cabanon","cabine","cachette","cadeau","cadre","caféine","caillou","caisson","calculer","calepin","calibre","calmer","calomnie","calvaire","camarade","caméra","camion","campagne","canal","caneton","canon","cantine","canular","capable","caporal","caprice","capsule","capter","capuche","carabine","carbone","caresser","caribou","carnage","carotte","carreau","carton","cascade","casier","casque","cassure","causer","caution","cavalier","caverne","caviar","cédille","ceinture","céleste","cellule","cendrier","censurer","central","cercle","cérébral","cerise","cerner","cerveau","cesser","chagrin","chaise","chaleur","chambre","chance","chapitre","charbon","chasseur","chaton","chausson","chavirer","chemise","chenille","chéquier","chercher","cheval","chien","chiffre","chignon","chimère","chiot","chlorure","chocolat","choisir","chose","chouette","chrome","chute","cigare","cigogne","cimenter","cinéma","cintrer","circuler","cirer","cirque","citerne","citoyen","citron","civil","clairon","clameur","claquer","classe","clavier","client","cligner","climat","clivage","cloche","clonage","cloporte","cobalt","cobra","cocasse","cocotier","coder","codifier","coffre","cogner","cohésion","coiffer","coincer","colère","colibri","colline","colmater","colonel","combat","comédie","commande","compact","concert","conduire","confier","congeler","connoter","consonne","contact","convexe","copain","copie","corail","corbeau","cordage","corniche","corpus","correct","cortège","cosmique","costume","coton","coude","coupure","courage","couteau","couvrir","coyote","crabe","crainte","cravate","crayon","créature","créditer","crémeux","creuser","crevette","cribler","crier","cristal","critère","croire","croquer","crotale","crucial","cruel","crypter","cubique","cueillir","cuillère","cuisine","cuivre","culminer","cultiver","cumuler","cupide","curatif","curseur","cyanure","cycle","cylindre","cynique","daigner","damier","danger","danseur","dauphin","débattre","débiter","déborder","débrider","débutant","décaler","décembre","déchirer","décider","déclarer","décorer","décrire","décupler","dédale","déductif","déesse","défensif","défiler","défrayer","dégager","dégivrer","déglutir","dégrafer","déjeuner","délice","déloger","demander","demeurer","démolir","dénicher","dénouer","dentelle","dénuder","départ","dépenser","déphaser","déplacer","déposer","déranger","dérober","désastre","descente","désert","désigner","désobéir","dessiner","destrier","détacher","détester","détourer","détresse","devancer","devenir","deviner","devoir","diable","dialogue","diamant","dicter","différer","digérer","digital","digne","diluer","dimanche","diminuer","dioxyde","directif","diriger","discuter","disposer","dissiper","distance","divertir","diviser","docile","docteur","dogme","doigt","domaine","domicile","dompter","donateur","donjon","donner","dopamine","dortoir","dorure","dosage","doseur","dossier","dotation","douanier","double","douceur","douter","doyen","dragon","draper","dresser","dribbler","droiture","duperie","duplexe","durable","durcir","dynastie","éblouir","écarter","écharpe","échelle","éclairer","éclipse","éclore","écluse","école","économie","écorce","écouter","écraser","écrémer","écrivain","écrou","écume","écureuil","édifier","éduquer","effacer","effectif","effigie","effort","effrayer","effusion","égaliser","égarer","éjecter","élaborer","élargir","électron","élégant","éléphant","élève","éligible","élitisme","éloge","élucider","éluder","emballer","embellir","embryon","émeraude","émission","emmener","émotion","émouvoir","empereur","employer","emporter","emprise","émulsion","encadrer","enchère","enclave","encoche","endiguer","endosser","endroit","enduire","énergie","enfance","enfermer","enfouir","engager","engin","englober","énigme","enjamber","enjeu","enlever","ennemi","ennuyeux","enrichir","enrobage","enseigne","entasser","entendre","entier","entourer","entraver","énumérer","envahir","enviable","envoyer","enzyme","éolien","épaissir","épargne","épatant","épaule","épicerie","épidémie","épier","épilogue","épine","épisode","épitaphe","époque","épreuve","éprouver","épuisant","équerre","équipe","ériger","érosion","erreur","éruption","escalier","espadon","espèce","espiègle","espoir","esprit","esquiver","essayer","essence","essieu","essorer","estime","estomac","estrade","étagère","étaler","étanche","étatique","éteindre","étendoir","éternel","éthanol","éthique","ethnie","étirer","étoffer","étoile","étonnant","étourdir","étrange","étroit","étude","euphorie","évaluer","évasion","éventail","évidence","éviter","évolutif","évoquer","exact","exagérer","exaucer","exceller","excitant","exclusif","excuse","exécuter","exemple","exercer","exhaler","exhorter","exigence","exiler","exister","exotique","expédier","explorer","exposer","exprimer","exquis","extensif","extraire","exulter","fable","fabuleux","facette","facile","facture","faiblir","falaise","fameux","famille","farceur","farfelu","farine","farouche","fasciner","fatal","fatigue","faucon","fautif","faveur","favori","fébrile","féconder","fédérer","félin","femme","fémur","fendoir","féodal","fermer","féroce","ferveur","festival","feuille","feutre","février","fiasco","ficeler","fictif","fidèle","figure","filature","filetage","filière","filleul","filmer","filou","filtrer","financer","finir","fiole","firme","fissure","fixer","flairer","flamme","flasque","flatteur","fléau","flèche","fleur","flexion","flocon","flore","fluctuer","fluide","fluvial","folie","fonderie","fongible","fontaine","forcer","forgeron","formuler","fortune","fossile","foudre","fougère","fouiller","foulure","fourmi","fragile","fraise","franchir","frapper","frayeur","frégate","freiner","frelon","frémir","frénésie","frère","friable","friction","frisson","frivole","froid","fromage","frontal","frotter","fruit","fugitif","fuite","fureur","furieux","furtif","fusion","futur","gagner","galaxie","galerie","gambader","garantir","gardien","garnir","garrigue","gazelle","gazon","géant","gélatine","gélule","gendarme","général","génie","genou","gentil","géologie","géomètre","géranium","germe","gestuel","geyser","gibier","gicler","girafe","givre","glace","glaive","glisser","globe","gloire","glorieux","golfeur","gomme","gonfler","gorge","gorille","goudron","gouffre","goulot","goupille","gourmand","goutte","graduel","graffiti","graine","grand","grappin","gratuit","gravir","grenat","griffure","griller","grimper","grogner","gronder","grotte","groupe","gruger","grutier","gruyère","guépard","guerrier","guide","guimauve","guitare","gustatif","gymnaste","gyrostat","habitude","hachoir","halte","hameau","hangar","hanneton","haricot","harmonie","harpon","hasard","hélium","hématome","herbe","hérisson","hermine","héron","hésiter","heureux","hiberner","hibou","hilarant","histoire","hiver","homard","hommage","homogène","honneur","honorer","honteux","horde","horizon","horloge","hormone","horrible","houleux","housse","hublot","huileux","humain","humble","humide","humour","hurler","hydromel","hygiène","hymne","hypnose","idylle","ignorer","iguane","illicite","illusion","image","imbiber","imiter","immense","immobile","immuable","impact","impérial","implorer","imposer","imprimer","imputer","incarner","incendie","incident","incliner","incolore","indexer","indice","inductif","inédit","ineptie","inexact","infini","infliger","informer","infusion","ingérer","inhaler","inhiber","injecter","injure","innocent","inoculer","inonder","inscrire","insecte","insigne","insolite","inspirer","instinct","insulter","intact","intense","intime","intrigue","intuitif","inutile","invasion","inventer","inviter","invoquer","ironique","irradier","irréel","irriter","isoler","ivoire","ivresse","jaguar","jaillir","jambe","janvier","jardin","jauger","jaune","javelot","jetable","jeton","jeudi","jeunesse","joindre","joncher","jongler","joueur","jouissif","journal","jovial","joyau","joyeux","jubiler","jugement","junior","jupon","juriste","justice","juteux","juvénile","kayak","kimono","kiosque","label","labial","labourer","lacérer","lactose","lagune","laine","laisser","laitier","lambeau","lamelle","lampe","lanceur","langage","lanterne","lapin","largeur","larme","laurier","lavabo","lavoir","lecture","légal","léger","légume","lessive","lettre","levier","lexique","lézard","liasse","libérer","libre","licence","licorne","liège","lièvre","ligature","ligoter","ligue","limer","limite","limonade","limpide","linéaire","lingot","lionceau","liquide","lisière","lister","lithium","litige","littoral","livreur","logique","lointain","loisir","lombric","loterie","louer","lourd","loutre","louve","loyal","lubie","lucide","lucratif","lueur","lugubre","luisant","lumière","lunaire","lundi","luron","lutter","luxueux","machine","magasin","magenta","magique","maigre","maillon","maintien","mairie","maison","majorer","malaxer","maléfice","malheur","malice","mallette","mammouth","mandater","maniable","manquant","manteau","manuel","marathon","marbre","marchand","mardi","maritime","marqueur","marron","marteler","mascotte","massif","matériel","matière","matraque","maudire","maussade","mauve","maximal","méchant","méconnu","médaille","médecin","méditer","méduse","meilleur","mélange","mélodie","membre","mémoire","menacer","mener","menhir","mensonge","mentor","mercredi","mérite","merle","messager","mesure","métal","météore","méthode","métier","meuble","miauler","microbe","miette","mignon","migrer","milieu","million","mimique","mince","minéral","minimal","minorer","minute","miracle","miroiter","missile","mixte","mobile","moderne","moelleux","mondial","moniteur","monnaie","monotone","monstre","montagne","monument","moqueur","morceau","morsure","mortier","moteur","motif","mouche","moufle","moulin","mousson","mouton","mouvant","multiple","munition","muraille","murène","murmure","muscle","muséum","musicien","mutation","muter","mutuel","myriade","myrtille","mystère","mythique","nageur","nappe","narquois","narrer","natation","nation","nature","naufrage","nautique","navire","nébuleux","nectar","néfaste","négation","négliger","négocier","neige","nerveux","nettoyer","neurone","neutron","neveu","niche","nickel","nitrate","niveau","noble","nocif","nocturne","noirceur","noisette","nomade","nombreux","nommer","normatif","notable","notifier","notoire","nourrir","nouveau","novateur","novembre","novice","nuage","nuancer","nuire","nuisible","numéro","nuptial","nuque","nutritif","obéir","objectif","obliger","obscur","observer","obstacle","obtenir","obturer","occasion","occuper","océan","octobre","octroyer","octupler","oculaire","odeur","odorant","offenser","officier","offrir","ogive","oiseau","oisillon","olfactif","olivier","ombrage","omettre","onctueux","onduler","onéreux","onirique","opale","opaque","opérer","opinion","opportun","opprimer","opter","optique","orageux","orange","orbite","ordonner","oreille","organe","orgueil","orifice","ornement","orque","ortie","osciller","osmose","ossature","otarie","ouragan","ourson","outil","outrager","ouvrage","ovation","oxyde","oxygène","ozone","paisible","palace","palmarès","palourde","palper","panache","panda","pangolin","paniquer","panneau","panorama","pantalon","papaye","papier","papoter","papyrus","paradoxe","parcelle","paresse","parfumer","parler","parole","parrain","parsemer","partager","parure","parvenir","passion","pastèque","paternel","patience","patron","pavillon","pavoiser","payer","paysage","peigne","peintre","pelage","pélican","pelle","pelouse","peluche","pendule","pénétrer","pénible","pensif","pénurie","pépite","péplum","perdrix","perforer","période","permuter","perplexe","persil","perte","peser","pétale","petit","pétrir","peuple","pharaon","phobie","phoque","photon","phrase","physique","piano","pictural","pièce","pierre","pieuvre","pilote","pinceau","pipette","piquer","pirogue","piscine","piston","pivoter","pixel","pizza","placard","plafond","plaisir","planer","plaque","plastron","plateau","pleurer","plexus","pliage","plomb","plonger","pluie","plumage","pochette","poésie","poète","pointe","poirier","poisson","poivre","polaire","policier","pollen","polygone","pommade","pompier","ponctuel","pondérer","poney","portique","position","posséder","posture","potager","poteau","potion","pouce","poulain","poumon","pourpre","poussin","pouvoir","prairie","pratique","précieux","prédire","préfixe","prélude","prénom","présence","prétexte","prévoir","primitif","prince","prison","priver","problème","procéder","prodige","profond","progrès","proie","projeter","prologue","promener","propre","prospère","protéger","prouesse","proverbe","prudence","pruneau","psychose","public","puceron","puiser","pulpe","pulsar","punaise","punitif","pupitre","purifier","puzzle","pyramide","quasar","querelle","question","quiétude","quitter","quotient","racine","raconter","radieux","ragondin","raideur","raisin","ralentir","rallonge","ramasser","rapide","rasage","ratisser","ravager","ravin","rayonner","réactif","réagir","réaliser","réanimer","recevoir","réciter","réclamer","récolter","recruter","reculer","recycler","rédiger","redouter","refaire","réflexe","réformer","refrain","refuge","régalien","région","réglage","régulier","réitérer","rejeter","rejouer","relatif","relever","relief","remarque","remède","remise","remonter","remplir","remuer","renard","renfort","renifler","renoncer","rentrer","renvoi","replier","reporter","reprise","reptile","requin","réserve","résineux","résoudre","respect","rester","résultat","rétablir","retenir","réticule","retomber","retracer","réunion","réussir","revanche","revivre","révolte","révulsif","richesse","rideau","rieur","rigide","rigoler","rincer","riposter","risible","risque","rituel","rival","rivière","rocheux","romance","rompre","ronce","rondin","roseau","rosier","rotatif","rotor","rotule","rouge","rouille","rouleau","routine","royaume","ruban","rubis","ruche","ruelle","rugueux","ruiner","ruisseau","ruser","rustique","rythme","sabler","saboter","sabre","sacoche","safari","sagesse","saisir","salade","salive","salon","saluer","samedi","sanction","sanglier","sarcasme","sardine","saturer","saugrenu","saumon","sauter","sauvage","savant","savonner","scalpel","scandale","scélérat","scénario","sceptre","schéma","science","scinder","score","scrutin","sculpter","séance","sécable","sécher","secouer","sécréter","sédatif","séduire","seigneur","séjour","sélectif","semaine","sembler","semence","séminal","sénateur","sensible","sentence","séparer","séquence","serein","sergent","sérieux","serrure","sérum","service","sésame","sévir","sevrage","sextuple","sidéral","siècle","siéger","siffler","sigle","signal","silence","silicium","simple","sincère","sinistre","siphon","sirop","sismique","situer","skier","social","socle","sodium","soigneux","soldat","soleil","solitude","soluble","sombre","sommeil","somnoler","sonde","songeur","sonnette","sonore","sorcier","sortir","sosie","sottise","soucieux","soudure","souffle","soulever","soupape","source","soutirer","souvenir","spacieux","spatial","spécial","sphère","spiral","stable","station","sternum","stimulus","stipuler","strict","studieux","stupeur","styliste","sublime","substrat","subtil","subvenir","succès","sucre","suffixe","suggérer","suiveur","sulfate","superbe","supplier","surface","suricate","surmener","surprise","sursaut","survie","suspect","syllabe","symbole","symétrie","synapse","syntaxe","système","tabac","tablier","tactile","tailler","talent","talisman","talonner","tambour","tamiser","tangible","tapis","taquiner","tarder","tarif","tartine","tasse","tatami","tatouage","taupe","taureau","taxer","témoin","temporel","tenaille","tendre","teneur","tenir","tension","terminer","terne","terrible","tétine","texte","thème","théorie","thérapie","thorax","tibia","tiède","timide","tirelire","tiroir","tissu","titane","titre","tituber","toboggan","tolérant","tomate","tonique","tonneau","toponyme","torche","tordre","tornade","torpille","torrent","torse","tortue","totem","toucher","tournage","tousser","toxine","traction","trafic","tragique","trahir","train","trancher","travail","trèfle","tremper","trésor","treuil","triage","tribunal","tricoter","trilogie","triomphe","tripler","triturer","trivial","trombone","tronc","tropical","troupeau","tuile","tulipe","tumulte","tunnel","turbine","tuteur","tutoyer","tuyau","tympan","typhon","typique","tyran","ubuesque","ultime","ultrason","unanime","unifier","union","unique","unitaire","univers","uranium","urbain","urticant","usage","usine","usuel","usure","utile","utopie","vacarme","vaccin","vagabond","vague","vaillant","vaincre","vaisseau","valable","valise","vallon","valve","vampire","vanille","vapeur","varier","vaseux","vassal","vaste","vecteur","vedette","végétal","véhicule","veinard","véloce","vendredi","vénérer","venger","venimeux","ventouse","verdure","vérin","vernir","verrou","verser","vertu","veston","vétéran","vétuste","vexant","vexer","viaduc","viande","victoire","vidange","vidéo","vignette","vigueur","vilain","village","vinaigre","violon","vipère","virement","virtuose","virus","visage","viseur","vision","visqueux","visuel","vital","vitesse","viticole","vitrine","vivace","vivipare","vocation","voguer","voile","voisin","voiture","volaille","volcan","voltiger","volume","vorace","vortex","voter","vouloir","voyage","voyelle","wagon","xénon","yacht","zèbre","zénith","zeste","zoologie"]');

/***/ }),

/***/ 72841:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('["abaco","abbaglio","abbinato","abete","abisso","abolire","abrasivo","abrogato","accadere","accenno","accusato","acetone","achille","acido","acqua","acre","acrilico","acrobata","acuto","adagio","addebito","addome","adeguato","aderire","adipe","adottare","adulare","affabile","affetto","affisso","affranto","aforisma","afoso","africano","agave","agente","agevole","aggancio","agire","agitare","agonismo","agricolo","agrumeto","aguzzo","alabarda","alato","albatro","alberato","albo","albume","alce","alcolico","alettone","alfa","algebra","aliante","alibi","alimento","allagato","allegro","allievo","allodola","allusivo","almeno","alogeno","alpaca","alpestre","altalena","alterno","alticcio","altrove","alunno","alveolo","alzare","amalgama","amanita","amarena","ambito","ambrato","ameba","america","ametista","amico","ammasso","ammenda","ammirare","ammonito","amore","ampio","ampliare","amuleto","anacardo","anagrafe","analista","anarchia","anatra","anca","ancella","ancora","andare","andrea","anello","angelo","angolare","angusto","anima","annegare","annidato","anno","annuncio","anonimo","anticipo","anzi","apatico","apertura","apode","apparire","appetito","appoggio","approdo","appunto","aprile","arabica","arachide","aragosta","araldica","arancio","aratura","arazzo","arbitro","archivio","ardito","arenile","argento","argine","arguto","aria","armonia","arnese","arredato","arringa","arrosto","arsenico","arso","artefice","arzillo","asciutto","ascolto","asepsi","asettico","asfalto","asino","asola","aspirato","aspro","assaggio","asse","assoluto","assurdo","asta","astenuto","astice","astratto","atavico","ateismo","atomico","atono","attesa","attivare","attorno","attrito","attuale","ausilio","austria","autista","autonomo","autunno","avanzato","avere","avvenire","avviso","avvolgere","azione","azoto","azzimo","azzurro","babele","baccano","bacino","baco","badessa","badilata","bagnato","baita","balcone","baldo","balena","ballata","balzano","bambino","bandire","baraonda","barbaro","barca","baritono","barlume","barocco","basilico","basso","batosta","battuto","baule","bava","bavosa","becco","beffa","belgio","belva","benda","benevole","benigno","benzina","bere","berlina","beta","bibita","bici","bidone","bifido","biga","bilancia","bimbo","binocolo","biologo","bipede","bipolare","birbante","birra","biscotto","bisesto","bisnonno","bisonte","bisturi","bizzarro","blando","blatta","bollito","bonifico","bordo","bosco","botanico","bottino","bozzolo","braccio","bradipo","brama","branca","bravura","bretella","brevetto","brezza","briglia","brillante","brindare","broccolo","brodo","bronzina","brullo","bruno","bubbone","buca","budino","buffone","buio","bulbo","buono","burlone","burrasca","bussola","busta","cadetto","caduco","calamaro","calcolo","calesse","calibro","calmo","caloria","cambusa","camerata","camicia","cammino","camola","campale","canapa","candela","cane","canino","canotto","cantina","capace","capello","capitolo","capogiro","cappero","capra","capsula","carapace","carcassa","cardo","carisma","carovana","carretto","cartolina","casaccio","cascata","caserma","caso","cassone","castello","casuale","catasta","catena","catrame","cauto","cavillo","cedibile","cedrata","cefalo","celebre","cellulare","cena","cenone","centesimo","ceramica","cercare","certo","cerume","cervello","cesoia","cespo","ceto","chela","chiaro","chicca","chiedere","chimera","china","chirurgo","chitarra","ciao","ciclismo","cifrare","cigno","cilindro","ciottolo","circa","cirrosi","citrico","cittadino","ciuffo","civetta","civile","classico","clinica","cloro","cocco","codardo","codice","coerente","cognome","collare","colmato","colore","colposo","coltivato","colza","coma","cometa","commando","comodo","computer","comune","conciso","condurre","conferma","congelare","coniuge","connesso","conoscere","consumo","continuo","convegno","coperto","copione","coppia","copricapo","corazza","cordata","coricato","cornice","corolla","corpo","corredo","corsia","cortese","cosmico","costante","cottura","covato","cratere","cravatta","creato","credere","cremoso","crescita","creta","criceto","crinale","crisi","critico","croce","cronaca","crostata","cruciale","crusca","cucire","cuculo","cugino","cullato","cupola","curatore","cursore","curvo","cuscino","custode","dado","daino","dalmata","damerino","daniela","dannoso","danzare","datato","davanti","davvero","debutto","decennio","deciso","declino","decollo","decreto","dedicato","definito","deforme","degno","delegare","delfino","delirio","delta","demenza","denotato","dentro","deposito","derapata","derivare","deroga","descritto","deserto","desiderio","desumere","detersivo","devoto","diametro","dicembre","diedro","difeso","diffuso","digerire","digitale","diluvio","dinamico","dinnanzi","dipinto","diploma","dipolo","diradare","dire","dirotto","dirupo","disagio","discreto","disfare","disgelo","disposto","distanza","disumano","dito","divano","divelto","dividere","divorato","doblone","docente","doganale","dogma","dolce","domato","domenica","dominare","dondolo","dono","dormire","dote","dottore","dovuto","dozzina","drago","druido","dubbio","dubitare","ducale","duna","duomo","duplice","duraturo","ebano","eccesso","ecco","eclissi","economia","edera","edicola","edile","editoria","educare","egemonia","egli","egoismo","egregio","elaborato","elargire","elegante","elencato","eletto","elevare","elfico","elica","elmo","elsa","eluso","emanato","emblema","emesso","emiro","emotivo","emozione","empirico","emulo","endemico","enduro","energia","enfasi","enoteca","entrare","enzima","epatite","epilogo","episodio","epocale","eppure","equatore","erario","erba","erboso","erede","eremita","erigere","ermetico","eroe","erosivo","errante","esagono","esame","esanime","esaudire","esca","esempio","esercito","esibito","esigente","esistere","esito","esofago","esortato","esoso","espanso","espresso","essenza","esso","esteso","estimare","estonia","estroso","esultare","etilico","etnico","etrusco","etto","euclideo","europa","evaso","evidenza","evitato","evoluto","evviva","fabbrica","faccenda","fachiro","falco","famiglia","fanale","fanfara","fango","fantasma","fare","farfalla","farinoso","farmaco","fascia","fastoso","fasullo","faticare","fato","favoloso","febbre","fecola","fede","fegato","felpa","feltro","femmina","fendere","fenomeno","fermento","ferro","fertile","fessura","festivo","fetta","feudo","fiaba","fiducia","fifa","figurato","filo","finanza","finestra","finire","fiore","fiscale","fisico","fiume","flacone","flamenco","flebo","flemma","florido","fluente","fluoro","fobico","focaccia","focoso","foderato","foglio","folata","folclore","folgore","fondente","fonetico","fonia","fontana","forbito","forchetta","foresta","formica","fornaio","foro","fortezza","forzare","fosfato","fosso","fracasso","frana","frassino","fratello","freccetta","frenata","fresco","frigo","frollino","fronde","frugale","frutta","fucilata","fucsia","fuggente","fulmine","fulvo","fumante","fumetto","fumoso","fune","funzione","fuoco","furbo","furgone","furore","fuso","futile","gabbiano","gaffe","galateo","gallina","galoppo","gambero","gamma","garanzia","garbo","garofano","garzone","gasdotto","gasolio","gastrico","gatto","gaudio","gazebo","gazzella","geco","gelatina","gelso","gemello","gemmato","gene","genitore","gennaio","genotipo","gergo","ghepardo","ghiaccio","ghisa","giallo","gilda","ginepro","giocare","gioiello","giorno","giove","girato","girone","gittata","giudizio","giurato","giusto","globulo","glutine","gnomo","gobba","golf","gomito","gommone","gonfio","gonna","governo","gracile","grado","grafico","grammo","grande","grattare","gravoso","grazia","greca","gregge","grifone","grigio","grinza","grotta","gruppo","guadagno","guaio","guanto","guardare","gufo","guidare","ibernato","icona","identico","idillio","idolo","idra","idrico","idrogeno","igiene","ignaro","ignorato","ilare","illeso","illogico","illudere","imballo","imbevuto","imbocco","imbuto","immane","immerso","immolato","impacco","impeto","impiego","importo","impronta","inalare","inarcare","inattivo","incanto","incendio","inchino","incisivo","incluso","incontro","incrocio","incubo","indagine","india","indole","inedito","infatti","infilare","inflitto","ingaggio","ingegno","inglese","ingordo","ingrosso","innesco","inodore","inoltrare","inondato","insano","insetto","insieme","insonnia","insulina","intasato","intero","intonaco","intuito","inumidire","invalido","invece","invito","iperbole","ipnotico","ipotesi","ippica","iride","irlanda","ironico","irrigato","irrorare","isolato","isotopo","isterico","istituto","istrice","italia","iterare","labbro","labirinto","lacca","lacerato","lacrima","lacuna","laddove","lago","lampo","lancetta","lanterna","lardoso","larga","laringe","lastra","latenza","latino","lattuga","lavagna","lavoro","legale","leggero","lembo","lentezza","lenza","leone","lepre","lesivo","lessato","lesto","letterale","leva","levigato","libero","lido","lievito","lilla","limatura","limitare","limpido","lineare","lingua","liquido","lira","lirica","lisca","lite","litigio","livrea","locanda","lode","logica","lombare","londra","longevo","loquace","lorenzo","loto","lotteria","luce","lucidato","lumaca","luminoso","lungo","lupo","luppolo","lusinga","lusso","lutto","macabro","macchina","macero","macinato","madama","magico","maglia","magnete","magro","maiolica","malafede","malgrado","malinteso","malsano","malto","malumore","mana","mancia","mandorla","mangiare","manifesto","mannaro","manovra","mansarda","mantide","manubrio","mappa","maratona","marcire","maretta","marmo","marsupio","maschera","massaia","mastino","materasso","matricola","mattone","maturo","mazurca","meandro","meccanico","mecenate","medesimo","meditare","mega","melassa","melis","melodia","meninge","meno","mensola","mercurio","merenda","merlo","meschino","mese","messere","mestolo","metallo","metodo","mettere","miagolare","mica","micelio","michele","microbo","midollo","miele","migliore","milano","milite","mimosa","minerale","mini","minore","mirino","mirtillo","miscela","missiva","misto","misurare","mitezza","mitigare","mitra","mittente","mnemonico","modello","modifica","modulo","mogano","mogio","mole","molosso","monastero","monco","mondina","monetario","monile","monotono","monsone","montato","monviso","mora","mordere","morsicato","mostro","motivato","motosega","motto","movenza","movimento","mozzo","mucca","mucosa","muffa","mughetto","mugnaio","mulatto","mulinello","multiplo","mummia","munto","muovere","murale","musa","muscolo","musica","mutevole","muto","nababbo","nafta","nanometro","narciso","narice","narrato","nascere","nastrare","naturale","nautica","naviglio","nebulosa","necrosi","negativo","negozio","nemmeno","neofita","neretto","nervo","nessuno","nettuno","neutrale","neve","nevrotico","nicchia","ninfa","nitido","nobile","nocivo","nodo","nome","nomina","nordico","normale","norvegese","nostrano","notare","notizia","notturno","novella","nucleo","nulla","numero","nuovo","nutrire","nuvola","nuziale","oasi","obbedire","obbligo","obelisco","oblio","obolo","obsoleto","occasione","occhio","occidente","occorrere","occultare","ocra","oculato","odierno","odorare","offerta","offrire","offuscato","oggetto","oggi","ognuno","olandese","olfatto","oliato","oliva","ologramma","oltre","omaggio","ombelico","ombra","omega","omissione","ondoso","onere","onice","onnivoro","onorevole","onta","operato","opinione","opposto","oracolo","orafo","ordine","orecchino","orefice","orfano","organico","origine","orizzonte","orma","ormeggio","ornativo","orologio","orrendo","orribile","ortensia","ortica","orzata","orzo","osare","oscurare","osmosi","ospedale","ospite","ossa","ossidare","ostacolo","oste","otite","otre","ottagono","ottimo","ottobre","ovale","ovest","ovino","oviparo","ovocito","ovunque","ovviare","ozio","pacchetto","pace","pacifico","padella","padrone","paese","paga","pagina","palazzina","palesare","pallido","palo","palude","pandoro","pannello","paolo","paonazzo","paprica","parabola","parcella","parere","pargolo","pari","parlato","parola","partire","parvenza","parziale","passivo","pasticca","patacca","patologia","pattume","pavone","peccato","pedalare","pedonale","peggio","peloso","penare","pendice","penisola","pennuto","penombra","pensare","pentola","pepe","pepita","perbene","percorso","perdonato","perforare","pergamena","periodo","permesso","perno","perplesso","persuaso","pertugio","pervaso","pesatore","pesista","peso","pestifero","petalo","pettine","petulante","pezzo","piacere","pianta","piattino","piccino","picozza","piega","pietra","piffero","pigiama","pigolio","pigro","pila","pilifero","pillola","pilota","pimpante","pineta","pinna","pinolo","pioggia","piombo","piramide","piretico","pirite","pirolisi","pitone","pizzico","placebo","planare","plasma","platano","plenario","pochezza","poderoso","podismo","poesia","poggiare","polenta","poligono","pollice","polmonite","polpetta","polso","poltrona","polvere","pomice","pomodoro","ponte","popoloso","porfido","poroso","porpora","porre","portata","posa","positivo","possesso","postulato","potassio","potere","pranzo","prassi","pratica","precluso","predica","prefisso","pregiato","prelievo","premere","prenotare","preparato","presenza","pretesto","prevalso","prima","principe","privato","problema","procura","produrre","profumo","progetto","prolunga","promessa","pronome","proposta","proroga","proteso","prova","prudente","prugna","prurito","psiche","pubblico","pudica","pugilato","pugno","pulce","pulito","pulsante","puntare","pupazzo","pupilla","puro","quadro","qualcosa","quasi","querela","quota","raccolto","raddoppio","radicale","radunato","raffica","ragazzo","ragione","ragno","ramarro","ramingo","ramo","randagio","rantolare","rapato","rapina","rappreso","rasatura","raschiato","rasente","rassegna","rastrello","rata","ravveduto","reale","recepire","recinto","recluta","recondito","recupero","reddito","redimere","regalato","registro","regola","regresso","relazione","remare","remoto","renna","replica","reprimere","reputare","resa","residente","responso","restauro","rete","retina","retorica","rettifica","revocato","riassunto","ribadire","ribelle","ribrezzo","ricarica","ricco","ricevere","riciclato","ricordo","ricreduto","ridicolo","ridurre","rifasare","riflesso","riforma","rifugio","rigare","rigettato","righello","rilassato","rilevato","rimanere","rimbalzo","rimedio","rimorchio","rinascita","rincaro","rinforzo","rinnovo","rinomato","rinsavito","rintocco","rinuncia","rinvenire","riparato","ripetuto","ripieno","riportare","ripresa","ripulire","risata","rischio","riserva","risibile","riso","rispetto","ristoro","risultato","risvolto","ritardo","ritegno","ritmico","ritrovo","riunione","riva","riverso","rivincita","rivolto","rizoma","roba","robotico","robusto","roccia","roco","rodaggio","rodere","roditore","rogito","rollio","romantico","rompere","ronzio","rosolare","rospo","rotante","rotondo","rotula","rovescio","rubizzo","rubrica","ruga","rullino","rumine","rumoroso","ruolo","rupe","russare","rustico","sabato","sabbiare","sabotato","sagoma","salasso","saldatura","salgemma","salivare","salmone","salone","saltare","saluto","salvo","sapere","sapido","saporito","saraceno","sarcasmo","sarto","sassoso","satellite","satira","satollo","saturno","savana","savio","saziato","sbadiglio","sbalzo","sbancato","sbarra","sbattere","sbavare","sbendare","sbirciare","sbloccato","sbocciato","sbrinare","sbruffone","sbuffare","scabroso","scadenza","scala","scambiare","scandalo","scapola","scarso","scatenare","scavato","scelto","scenico","scettro","scheda","schiena","sciarpa","scienza","scindere","scippo","sciroppo","scivolo","sclerare","scodella","scolpito","scomparto","sconforto","scoprire","scorta","scossone","scozzese","scriba","scrollare","scrutinio","scuderia","scultore","scuola","scuro","scusare","sdebitare","sdoganare","seccatura","secondo","sedano","seggiola","segnalato","segregato","seguito","selciato","selettivo","sella","selvaggio","semaforo","sembrare","seme","seminato","sempre","senso","sentire","sepolto","sequenza","serata","serbato","sereno","serio","serpente","serraglio","servire","sestina","setola","settimana","sfacelo","sfaldare","sfamato","sfarzoso","sfaticato","sfera","sfida","sfilato","sfinge","sfocato","sfoderare","sfogo","sfoltire","sforzato","sfratto","sfruttato","sfuggito","sfumare","sfuso","sgabello","sgarbato","sgonfiare","sgorbio","sgrassato","sguardo","sibilo","siccome","sierra","sigla","signore","silenzio","sillaba","simbolo","simpatico","simulato","sinfonia","singolo","sinistro","sino","sintesi","sinusoide","sipario","sisma","sistole","situato","slitta","slogatura","sloveno","smarrito","smemorato","smentito","smeraldo","smilzo","smontare","smottato","smussato","snellire","snervato","snodo","sobbalzo","sobrio","soccorso","sociale","sodale","soffitto","sogno","soldato","solenne","solido","sollazzo","solo","solubile","solvente","somatico","somma","sonda","sonetto","sonnifero","sopire","soppeso","sopra","sorgere","sorpasso","sorriso","sorso","sorteggio","sorvolato","sospiro","sosta","sottile","spada","spalla","spargere","spatola","spavento","spazzola","specie","spedire","spegnere","spelatura","speranza","spessore","spettrale","spezzato","spia","spigoloso","spillato","spinoso","spirale","splendido","sportivo","sposo","spranga","sprecare","spronato","spruzzo","spuntino","squillo","sradicare","srotolato","stabile","stacco","staffa","stagnare","stampato","stantio","starnuto","stasera","statuto","stelo","steppa","sterzo","stiletto","stima","stirpe","stivale","stizzoso","stonato","storico","strappo","stregato","stridulo","strozzare","strutto","stuccare","stufo","stupendo","subentro","succoso","sudore","suggerito","sugo","sultano","suonare","superbo","supporto","surgelato","surrogato","sussurro","sutura","svagare","svedese","sveglio","svelare","svenuto","svezia","sviluppo","svista","svizzera","svolta","svuotare","tabacco","tabulato","tacciare","taciturno","tale","talismano","tampone","tannino","tara","tardivo","targato","tariffa","tarpare","tartaruga","tasto","tattico","taverna","tavolata","tazza","teca","tecnico","telefono","temerario","tempo","temuto","tendone","tenero","tensione","tentacolo","teorema","terme","terrazzo","terzetto","tesi","tesserato","testato","tetro","tettoia","tifare","tigella","timbro","tinto","tipico","tipografo","tiraggio","tiro","titanio","titolo","titubante","tizio","tizzone","toccare","tollerare","tolto","tombola","tomo","tonfo","tonsilla","topazio","topologia","toppa","torba","tornare","torrone","tortora","toscano","tossire","tostatura","totano","trabocco","trachea","trafila","tragedia","tralcio","tramonto","transito","trapano","trarre","trasloco","trattato","trave","treccia","tremolio","trespolo","tributo","tricheco","trifoglio","trillo","trincea","trio","tristezza","triturato","trivella","tromba","trono","troppo","trottola","trovare","truccato","tubatura","tuffato","tulipano","tumulto","tunisia","turbare","turchino","tuta","tutela","ubicato","uccello","uccisore","udire","uditivo","uffa","ufficio","uguale","ulisse","ultimato","umano","umile","umorismo","uncinetto","ungere","ungherese","unicorno","unificato","unisono","unitario","unte","uovo","upupa","uragano","urgenza","urlo","usanza","usato","uscito","usignolo","usuraio","utensile","utilizzo","utopia","vacante","vaccinato","vagabondo","vagliato","valanga","valgo","valico","valletta","valoroso","valutare","valvola","vampata","vangare","vanitoso","vano","vantaggio","vanvera","vapore","varano","varcato","variante","vasca","vedetta","vedova","veduto","vegetale","veicolo","velcro","velina","velluto","veloce","venato","vendemmia","vento","verace","verbale","vergogna","verifica","vero","verruca","verticale","vescica","vessillo","vestale","veterano","vetrina","vetusto","viandante","vibrante","vicenda","vichingo","vicinanza","vidimare","vigilia","vigneto","vigore","vile","villano","vimini","vincitore","viola","vipera","virgola","virologo","virulento","viscoso","visione","vispo","vissuto","visura","vita","vitello","vittima","vivanda","vivido","viziare","voce","voga","volatile","volere","volpe","voragine","vulcano","zampogna","zanna","zappato","zattera","zavorra","zefiro","zelante","zelo","zenzero","zerbino","zibetto","zinco","zircone","zitto","zolla","zotico","zucchero","zufolo","zulu","zuppa"]');

/***/ }),

/***/ 94472:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('["あいこくしん","あいさつ","あいだ","あおぞら","あかちゃん","あきる","あけがた","あける","あこがれる","あさい","あさひ","あしあと","あじわう","あずかる","あずき","あそぶ","あたえる","あたためる","あたりまえ","あたる","あつい","あつかう","あっしゅく","あつまり","あつめる","あてな","あてはまる","あひる","あぶら","あぶる","あふれる","あまい","あまど","あまやかす","あまり","あみもの","あめりか","あやまる","あゆむ","あらいぐま","あらし","あらすじ","あらためる","あらゆる","あらわす","ありがとう","あわせる","あわてる","あんい","あんがい","あんこ","あんぜん","あんてい","あんない","あんまり","いいだす","いおん","いがい","いがく","いきおい","いきなり","いきもの","いきる","いくじ","いくぶん","いけばな","いけん","いこう","いこく","いこつ","いさましい","いさん","いしき","いじゅう","いじょう","いじわる","いずみ","いずれ","いせい","いせえび","いせかい","いせき","いぜん","いそうろう","いそがしい","いだい","いだく","いたずら","いたみ","いたりあ","いちおう","いちじ","いちど","いちば","いちぶ","いちりゅう","いつか","いっしゅん","いっせい","いっそう","いったん","いっち","いってい","いっぽう","いてざ","いてん","いどう","いとこ","いない","いなか","いねむり","いのち","いのる","いはつ","いばる","いはん","いびき","いひん","いふく","いへん","いほう","いみん","いもうと","いもたれ","いもり","いやがる","いやす","いよかん","いよく","いらい","いらすと","いりぐち","いりょう","いれい","いれもの","いれる","いろえんぴつ","いわい","いわう","いわかん","いわば","いわゆる","いんげんまめ","いんさつ","いんしょう","いんよう","うえき","うえる","うおざ","うがい","うかぶ","うかべる","うきわ","うくらいな","うくれれ","うけたまわる","うけつけ","うけとる","うけもつ","うける","うごかす","うごく","うこん","うさぎ","うしなう","うしろがみ","うすい","うすぎ","うすぐらい","うすめる","うせつ","うちあわせ","うちがわ","うちき","うちゅう","うっかり","うつくしい","うったえる","うつる","うどん","うなぎ","うなじ","うなずく","うなる","うねる","うのう","うぶげ","うぶごえ","うまれる","うめる","うもう","うやまう","うよく","うらがえす","うらぐち","うらない","うりあげ","うりきれ","うるさい","うれしい","うれゆき","うれる","うろこ","うわき","うわさ","うんこう","うんちん","うんてん","うんどう","えいえん","えいが","えいきょう","えいご","えいせい","えいぶん","えいよう","えいわ","えおり","えがお","えがく","えきたい","えくせる","えしゃく","えすて","えつらん","えのぐ","えほうまき","えほん","えまき","えもじ","えもの","えらい","えらぶ","えりあ","えんえん","えんかい","えんぎ","えんげき","えんしゅう","えんぜつ","えんそく","えんちょう","えんとつ","おいかける","おいこす","おいしい","おいつく","おうえん","おうさま","おうじ","おうせつ","おうたい","おうふく","おうべい","おうよう","おえる","おおい","おおう","おおどおり","おおや","おおよそ","おかえり","おかず","おがむ","おかわり","おぎなう","おきる","おくさま","おくじょう","おくりがな","おくる","おくれる","おこす","おこなう","おこる","おさえる","おさない","おさめる","おしいれ","おしえる","おじぎ","おじさん","おしゃれ","おそらく","おそわる","おたがい","おたく","おだやか","おちつく","おっと","おつり","おでかけ","おとしもの","おとなしい","おどり","おどろかす","おばさん","おまいり","おめでとう","おもいで","おもう","おもたい","おもちゃ","おやつ","おやゆび","およぼす","おらんだ","おろす","おんがく","おんけい","おんしゃ","おんせん","おんだん","おんちゅう","おんどけい","かあつ","かいが","がいき","がいけん","がいこう","かいさつ","かいしゃ","かいすいよく","かいぜん","かいぞうど","かいつう","かいてん","かいとう","かいふく","がいへき","かいほう","かいよう","がいらい","かいわ","かえる","かおり","かかえる","かがく","かがし","かがみ","かくご","かくとく","かざる","がぞう","かたい","かたち","がちょう","がっきゅう","がっこう","がっさん","がっしょう","かなざわし","かのう","がはく","かぶか","かほう","かほご","かまう","かまぼこ","かめれおん","かゆい","かようび","からい","かるい","かろう","かわく","かわら","がんか","かんけい","かんこう","かんしゃ","かんそう","かんたん","かんち","がんばる","きあい","きあつ","きいろ","ぎいん","きうい","きうん","きえる","きおう","きおく","きおち","きおん","きかい","きかく","きかんしゃ","ききて","きくばり","きくらげ","きけんせい","きこう","きこえる","きこく","きさい","きさく","きさま","きさらぎ","ぎじかがく","ぎしき","ぎじたいけん","ぎじにってい","ぎじゅつしゃ","きすう","きせい","きせき","きせつ","きそう","きぞく","きぞん","きたえる","きちょう","きつえん","ぎっちり","きつつき","きつね","きてい","きどう","きどく","きない","きなが","きなこ","きぬごし","きねん","きのう","きのした","きはく","きびしい","きひん","きふく","きぶん","きぼう","きほん","きまる","きみつ","きむずかしい","きめる","きもだめし","きもち","きもの","きゃく","きやく","ぎゅうにく","きよう","きょうりゅう","きらい","きらく","きりん","きれい","きれつ","きろく","ぎろん","きわめる","ぎんいろ","きんかくじ","きんじょ","きんようび","ぐあい","くいず","くうかん","くうき","くうぐん","くうこう","ぐうせい","くうそう","ぐうたら","くうふく","くうぼ","くかん","くきょう","くげん","ぐこう","くさい","くさき","くさばな","くさる","くしゃみ","くしょう","くすのき","くすりゆび","くせげ","くせん","ぐたいてき","くださる","くたびれる","くちこみ","くちさき","くつした","ぐっすり","くつろぐ","くとうてん","くどく","くなん","くねくね","くのう","くふう","くみあわせ","くみたてる","くめる","くやくしょ","くらす","くらべる","くるま","くれる","くろう","くわしい","ぐんかん","ぐんしょく","ぐんたい","ぐんて","けあな","けいかく","けいけん","けいこ","けいさつ","げいじゅつ","けいたい","げいのうじん","けいれき","けいろ","けおとす","けおりもの","げきか","げきげん","げきだん","げきちん","げきとつ","げきは","げきやく","げこう","げこくじょう","げざい","けさき","げざん","けしき","けしごむ","けしょう","げすと","けたば","けちゃっぷ","けちらす","けつあつ","けつい","けつえき","けっこん","けつじょ","けっせき","けってい","けつまつ","げつようび","げつれい","けつろん","げどく","けとばす","けとる","けなげ","けなす","けなみ","けぬき","げねつ","けねん","けはい","げひん","けぶかい","げぼく","けまり","けみかる","けむし","けむり","けもの","けらい","けろけろ","けわしい","けんい","けんえつ","けんお","けんか","げんき","けんげん","けんこう","けんさく","けんしゅう","けんすう","げんそう","けんちく","けんてい","けんとう","けんない","けんにん","げんぶつ","けんま","けんみん","けんめい","けんらん","けんり","こあくま","こいぬ","こいびと","ごうい","こうえん","こうおん","こうかん","ごうきゅう","ごうけい","こうこう","こうさい","こうじ","こうすい","ごうせい","こうそく","こうたい","こうちゃ","こうつう","こうてい","こうどう","こうない","こうはい","ごうほう","ごうまん","こうもく","こうりつ","こえる","こおり","ごかい","ごがつ","ごかん","こくご","こくさい","こくとう","こくない","こくはく","こぐま","こけい","こける","ここのか","こころ","こさめ","こしつ","こすう","こせい","こせき","こぜん","こそだて","こたい","こたえる","こたつ","こちょう","こっか","こつこつ","こつばん","こつぶ","こてい","こてん","ことがら","ことし","ことば","ことり","こなごな","こねこね","このまま","このみ","このよ","ごはん","こひつじ","こふう","こふん","こぼれる","ごまあぶら","こまかい","ごますり","こまつな","こまる","こむぎこ","こもじ","こもち","こもの","こもん","こやく","こやま","こゆう","こゆび","こよい","こよう","こりる","これくしょん","ころっけ","こわもて","こわれる","こんいん","こんかい","こんき","こんしゅう","こんすい","こんだて","こんとん","こんなん","こんびに","こんぽん","こんまけ","こんや","こんれい","こんわく","ざいえき","さいかい","さいきん","ざいげん","ざいこ","さいしょ","さいせい","ざいたく","ざいちゅう","さいてき","ざいりょう","さうな","さかいし","さがす","さかな","さかみち","さがる","さぎょう","さくし","さくひん","さくら","さこく","さこつ","さずかる","ざせき","さたん","さつえい","ざつおん","ざっか","ざつがく","さっきょく","ざっし","さつじん","ざっそう","さつたば","さつまいも","さてい","さといも","さとう","さとおや","さとし","さとる","さのう","さばく","さびしい","さべつ","さほう","さほど","さます","さみしい","さみだれ","さむけ","さめる","さやえんどう","さゆう","さよう","さよく","さらだ","ざるそば","さわやか","さわる","さんいん","さんか","さんきゃく","さんこう","さんさい","ざんしょ","さんすう","さんせい","さんそ","さんち","さんま","さんみ","さんらん","しあい","しあげ","しあさって","しあわせ","しいく","しいん","しうち","しえい","しおけ","しかい","しかく","じかん","しごと","しすう","じだい","したうけ","したぎ","したて","したみ","しちょう","しちりん","しっかり","しつじ","しつもん","してい","してき","してつ","じてん","じどう","しなぎれ","しなもの","しなん","しねま","しねん","しのぐ","しのぶ","しはい","しばかり","しはつ","しはらい","しはん","しひょう","しふく","じぶん","しへい","しほう","しほん","しまう","しまる","しみん","しむける","じむしょ","しめい","しめる","しもん","しゃいん","しゃうん","しゃおん","じゃがいも","しやくしょ","しゃくほう","しゃけん","しゃこ","しゃざい","しゃしん","しゃせん","しゃそう","しゃたい","しゃちょう","しゃっきん","じゃま","しゃりん","しゃれい","じゆう","じゅうしょ","しゅくはく","じゅしん","しゅっせき","しゅみ","しゅらば","じゅんばん","しょうかい","しょくたく","しょっけん","しょどう","しょもつ","しらせる","しらべる","しんか","しんこう","じんじゃ","しんせいじ","しんちく","しんりん","すあげ","すあし","すあな","ずあん","すいえい","すいか","すいとう","ずいぶん","すいようび","すうがく","すうじつ","すうせん","すおどり","すきま","すくう","すくない","すける","すごい","すこし","ずさん","すずしい","すすむ","すすめる","すっかり","ずっしり","ずっと","すてき","すてる","すねる","すのこ","すはだ","すばらしい","ずひょう","ずぶぬれ","すぶり","すふれ","すべて","すべる","ずほう","すぼん","すまい","すめし","すもう","すやき","すらすら","するめ","すれちがう","すろっと","すわる","すんぜん","すんぽう","せあぶら","せいかつ","せいげん","せいじ","せいよう","せおう","せかいかん","せきにん","せきむ","せきゆ","せきらんうん","せけん","せこう","せすじ","せたい","せたけ","せっかく","せっきゃく","ぜっく","せっけん","せっこつ","せっさたくま","せつぞく","せつだん","せつでん","せっぱん","せつび","せつぶん","せつめい","せつりつ","せなか","せのび","せはば","せびろ","せぼね","せまい","せまる","せめる","せもたれ","せりふ","ぜんあく","せんい","せんえい","せんか","せんきょ","せんく","せんげん","ぜんご","せんさい","せんしゅ","せんすい","せんせい","せんぞ","せんたく","せんちょう","せんてい","せんとう","せんぬき","せんねん","せんぱい","ぜんぶ","ぜんぽう","せんむ","せんめんじょ","せんもん","せんやく","せんゆう","せんよう","ぜんら","ぜんりゃく","せんれい","せんろ","そあく","そいとげる","そいね","そうがんきょう","そうき","そうご","そうしん","そうだん","そうなん","そうび","そうめん","そうり","そえもの","そえん","そがい","そげき","そこう","そこそこ","そざい","そしな","そせい","そせん","そそぐ","そだてる","そつう","そつえん","そっかん","そつぎょう","そっけつ","そっこう","そっせん","そっと","そとがわ","そとづら","そなえる","そなた","そふぼ","そぼく","そぼろ","そまつ","そまる","そむく","そむりえ","そめる","そもそも","そよかぜ","そらまめ","そろう","そんかい","そんけい","そんざい","そんしつ","そんぞく","そんちょう","ぞんび","ぞんぶん","そんみん","たあい","たいいん","たいうん","たいえき","たいおう","だいがく","たいき","たいぐう","たいけん","たいこ","たいざい","だいじょうぶ","だいすき","たいせつ","たいそう","だいたい","たいちょう","たいてい","だいどころ","たいない","たいねつ","たいのう","たいはん","だいひょう","たいふう","たいへん","たいほ","たいまつばな","たいみんぐ","たいむ","たいめん","たいやき","たいよう","たいら","たいりょく","たいる","たいわん","たうえ","たえる","たおす","たおる","たおれる","たかい","たかね","たきび","たくさん","たこく","たこやき","たさい","たしざん","だじゃれ","たすける","たずさわる","たそがれ","たたかう","たたく","ただしい","たたみ","たちばな","だっかい","だっきゃく","だっこ","だっしゅつ","だったい","たてる","たとえる","たなばた","たにん","たぬき","たのしみ","たはつ","たぶん","たべる","たぼう","たまご","たまる","だむる","ためいき","ためす","ためる","たもつ","たやすい","たよる","たらす","たりきほんがん","たりょう","たりる","たると","たれる","たれんと","たろっと","たわむれる","だんあつ","たんい","たんおん","たんか","たんき","たんけん","たんご","たんさん","たんじょうび","だんせい","たんそく","たんたい","だんち","たんてい","たんとう","だんな","たんにん","だんねつ","たんのう","たんぴん","だんぼう","たんまつ","たんめい","だんれつ","だんろ","だんわ","ちあい","ちあん","ちいき","ちいさい","ちえん","ちかい","ちから","ちきゅう","ちきん","ちけいず","ちけん","ちこく","ちさい","ちしき","ちしりょう","ちせい","ちそう","ちたい","ちたん","ちちおや","ちつじょ","ちてき","ちてん","ちぬき","ちぬり","ちのう","ちひょう","ちへいせん","ちほう","ちまた","ちみつ","ちみどろ","ちめいど","ちゃんこなべ","ちゅうい","ちゆりょく","ちょうし","ちょさくけん","ちらし","ちらみ","ちりがみ","ちりょう","ちるど","ちわわ","ちんたい","ちんもく","ついか","ついたち","つうか","つうじょう","つうはん","つうわ","つかう","つかれる","つくね","つくる","つけね","つける","つごう","つたえる","つづく","つつじ","つつむ","つとめる","つながる","つなみ","つねづね","つのる","つぶす","つまらない","つまる","つみき","つめたい","つもり","つもる","つよい","つるぼ","つるみく","つわもの","つわり","てあし","てあて","てあみ","ていおん","ていか","ていき","ていけい","ていこく","ていさつ","ていし","ていせい","ていたい","ていど","ていねい","ていひょう","ていへん","ていぼう","てうち","ておくれ","てきとう","てくび","でこぼこ","てさぎょう","てさげ","てすり","てそう","てちがい","てちょう","てつがく","てつづき","でっぱ","てつぼう","てつや","でぬかえ","てぬき","てぬぐい","てのひら","てはい","てぶくろ","てふだ","てほどき","てほん","てまえ","てまきずし","てみじか","てみやげ","てらす","てれび","てわけ","てわたし","でんあつ","てんいん","てんかい","てんき","てんぐ","てんけん","てんごく","てんさい","てんし","てんすう","でんち","てんてき","てんとう","てんない","てんぷら","てんぼうだい","てんめつ","てんらんかい","でんりょく","でんわ","どあい","といれ","どうかん","とうきゅう","どうぐ","とうし","とうむぎ","とおい","とおか","とおく","とおす","とおる","とかい","とかす","ときおり","ときどき","とくい","とくしゅう","とくてん","とくに","とくべつ","とけい","とける","とこや","とさか","としょかん","とそう","とたん","とちゅう","とっきゅう","とっくん","とつぜん","とつにゅう","とどける","ととのえる","とない","となえる","となり","とのさま","とばす","どぶがわ","とほう","とまる","とめる","ともだち","ともる","どようび","とらえる","とんかつ","どんぶり","ないかく","ないこう","ないしょ","ないす","ないせん","ないそう","なおす","ながい","なくす","なげる","なこうど","なさけ","なたでここ","なっとう","なつやすみ","ななおし","なにごと","なにもの","なにわ","なのか","なふだ","なまいき","なまえ","なまみ","なみだ","なめらか","なめる","なやむ","ならう","ならび","ならぶ","なれる","なわとび","なわばり","にあう","にいがた","にうけ","におい","にかい","にがて","にきび","にくしみ","にくまん","にげる","にさんかたんそ","にしき","にせもの","にちじょう","にちようび","にっか","にっき","にっけい","にっこう","にっさん","にっしょく","にっすう","にっせき","にってい","になう","にほん","にまめ","にもつ","にやり","にゅういん","にりんしゃ","にわとり","にんい","にんか","にんき","にんげん","にんしき","にんずう","にんそう","にんたい","にんち","にんてい","にんにく","にんぷ","にんまり","にんむ","にんめい","にんよう","ぬいくぎ","ぬかす","ぬぐいとる","ぬぐう","ぬくもり","ぬすむ","ぬまえび","ぬめり","ぬらす","ぬんちゃく","ねあげ","ねいき","ねいる","ねいろ","ねぐせ","ねくたい","ねくら","ねこぜ","ねこむ","ねさげ","ねすごす","ねそべる","ねだん","ねつい","ねっしん","ねつぞう","ねったいぎょ","ねぶそく","ねふだ","ねぼう","ねほりはほり","ねまき","ねまわし","ねみみ","ねむい","ねむたい","ねもと","ねらう","ねわざ","ねんいり","ねんおし","ねんかん","ねんきん","ねんぐ","ねんざ","ねんし","ねんちゃく","ねんど","ねんぴ","ねんぶつ","ねんまつ","ねんりょう","ねんれい","のいず","のおづま","のがす","のきなみ","のこぎり","のこす","のこる","のせる","のぞく","のぞむ","のたまう","のちほど","のっく","のばす","のはら","のべる","のぼる","のみもの","のやま","のらいぬ","のらねこ","のりもの","のりゆき","のれん","のんき","ばあい","はあく","ばあさん","ばいか","ばいく","はいけん","はいご","はいしん","はいすい","はいせん","はいそう","はいち","ばいばい","はいれつ","はえる","はおる","はかい","ばかり","はかる","はくしゅ","はけん","はこぶ","はさみ","はさん","はしご","ばしょ","はしる","はせる","ぱそこん","はそん","はたん","はちみつ","はつおん","はっかく","はづき","はっきり","はっくつ","はっけん","はっこう","はっさん","はっしん","はったつ","はっちゅう","はってん","はっぴょう","はっぽう","はなす","はなび","はにかむ","はぶらし","はみがき","はむかう","はめつ","はやい","はやし","はらう","はろうぃん","はわい","はんい","はんえい","はんおん","はんかく","はんきょう","ばんぐみ","はんこ","はんしゃ","はんすう","はんだん","ぱんち","ぱんつ","はんてい","はんとし","はんのう","はんぱ","はんぶん","はんぺん","はんぼうき","はんめい","はんらん","はんろん","ひいき","ひうん","ひえる","ひかく","ひかり","ひかる","ひかん","ひくい","ひけつ","ひこうき","ひこく","ひさい","ひさしぶり","ひさん","びじゅつかん","ひしょ","ひそか","ひそむ","ひたむき","ひだり","ひたる","ひつぎ","ひっこし","ひっし","ひつじゅひん","ひっす","ひつぜん","ぴったり","ぴっちり","ひつよう","ひてい","ひとごみ","ひなまつり","ひなん","ひねる","ひはん","ひびく","ひひょう","ひほう","ひまわり","ひまん","ひみつ","ひめい","ひめじし","ひやけ","ひやす","ひよう","びょうき","ひらがな","ひらく","ひりつ","ひりょう","ひるま","ひるやすみ","ひれい","ひろい","ひろう","ひろき","ひろゆき","ひんかく","ひんけつ","ひんこん","ひんしゅ","ひんそう","ぴんち","ひんぱん","びんぼう","ふあん","ふいうち","ふうけい","ふうせん","ぷうたろう","ふうとう","ふうふ","ふえる","ふおん","ふかい","ふきん","ふくざつ","ふくぶくろ","ふこう","ふさい","ふしぎ","ふじみ","ふすま","ふせい","ふせぐ","ふそく","ぶたにく","ふたん","ふちょう","ふつう","ふつか","ふっかつ","ふっき","ふっこく","ぶどう","ふとる","ふとん","ふのう","ふはい","ふひょう","ふへん","ふまん","ふみん","ふめつ","ふめん","ふよう","ふりこ","ふりる","ふるい","ふんいき","ぶんがく","ぶんぐ","ふんしつ","ぶんせき","ふんそう","ぶんぽう","へいあん","へいおん","へいがい","へいき","へいげん","へいこう","へいさ","へいしゃ","へいせつ","へいそ","へいたく","へいてん","へいねつ","へいわ","へきが","へこむ","べにいろ","べにしょうが","へらす","へんかん","べんきょう","べんごし","へんさい","へんたい","べんり","ほあん","ほいく","ぼうぎょ","ほうこく","ほうそう","ほうほう","ほうもん","ほうりつ","ほえる","ほおん","ほかん","ほきょう","ぼきん","ほくろ","ほけつ","ほけん","ほこう","ほこる","ほしい","ほしつ","ほしゅ","ほしょう","ほせい","ほそい","ほそく","ほたて","ほたる","ぽちぶくろ","ほっきょく","ほっさ","ほったん","ほとんど","ほめる","ほんい","ほんき","ほんけ","ほんしつ","ほんやく","まいにち","まかい","まかせる","まがる","まける","まこと","まさつ","まじめ","ますく","まぜる","まつり","まとめ","まなぶ","まぬけ","まねく","まほう","まもる","まゆげ","まよう","まろやか","まわす","まわり","まわる","まんが","まんきつ","まんぞく","まんなか","みいら","みうち","みえる","みがく","みかた","みかん","みけん","みこん","みじかい","みすい","みすえる","みせる","みっか","みつかる","みつける","みてい","みとめる","みなと","みなみかさい","みねらる","みのう","みのがす","みほん","みもと","みやげ","みらい","みりょく","みわく","みんか","みんぞく","むいか","むえき","むえん","むかい","むかう","むかえ","むかし","むぎちゃ","むける","むげん","むさぼる","むしあつい","むしば","むじゅん","むしろ","むすう","むすこ","むすぶ","むすめ","むせる","むせん","むちゅう","むなしい","むのう","むやみ","むよう","むらさき","むりょう","むろん","めいあん","めいうん","めいえん","めいかく","めいきょく","めいさい","めいし","めいそう","めいぶつ","めいれい","めいわく","めぐまれる","めざす","めした","めずらしい","めだつ","めまい","めやす","めんきょ","めんせき","めんどう","もうしあげる","もうどうけん","もえる","もくし","もくてき","もくようび","もちろん","もどる","もらう","もんく","もんだい","やおや","やける","やさい","やさしい","やすい","やすたろう","やすみ","やせる","やそう","やたい","やちん","やっと","やっぱり","やぶる","やめる","ややこしい","やよい","やわらかい","ゆうき","ゆうびんきょく","ゆうべ","ゆうめい","ゆけつ","ゆしゅつ","ゆせん","ゆそう","ゆたか","ゆちゃく","ゆでる","ゆにゅう","ゆびわ","ゆらい","ゆれる","ようい","ようか","ようきゅう","ようじ","ようす","ようちえん","よかぜ","よかん","よきん","よくせい","よくぼう","よけい","よごれる","よさん","よしゅう","よそう","よそく","よっか","よてい","よどがわく","よねつ","よやく","よゆう","よろこぶ","よろしい","らいう","らくがき","らくご","らくさつ","らくだ","らしんばん","らせん","らぞく","らたい","らっか","られつ","りえき","りかい","りきさく","りきせつ","りくぐん","りくつ","りけん","りこう","りせい","りそう","りそく","りてん","りねん","りゆう","りゅうがく","りよう","りょうり","りょかん","りょくちゃ","りょこう","りりく","りれき","りろん","りんご","るいけい","るいさい","るいじ","るいせき","るすばん","るりがわら","れいかん","れいぎ","れいせい","れいぞうこ","れいとう","れいぼう","れきし","れきだい","れんあい","れんけい","れんこん","れんさい","れんしゅう","れんぞく","れんらく","ろうか","ろうご","ろうじん","ろうそく","ろくが","ろこつ","ろじうら","ろしゅつ","ろせん","ろてん","ろめん","ろれつ","ろんぎ","ろんぱ","ろんぶん","ろんり","わかす","わかめ","わかやま","わかれる","わしつ","わじまし","わすれもの","わらう","われる"]');

/***/ }),

/***/ 8013:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('["가격","가끔","가난","가능","가득","가르침","가뭄","가방","가상","가슴","가운데","가을","가이드","가입","가장","가정","가족","가죽","각오","각자","간격","간부","간섭","간장","간접","간판","갈등","갈비","갈색","갈증","감각","감기","감소","감수성","감자","감정","갑자기","강남","강당","강도","강력히","강변","강북","강사","강수량","강아지","강원도","강의","강제","강조","같이","개구리","개나리","개방","개별","개선","개성","개인","객관적","거실","거액","거울","거짓","거품","걱정","건강","건물","건설","건조","건축","걸음","검사","검토","게시판","게임","겨울","견해","결과","결국","결론","결석","결승","결심","결정","결혼","경계","경고","경기","경력","경복궁","경비","경상도","경영","경우","경쟁","경제","경주","경찰","경치","경향","경험","계곡","계단","계란","계산","계속","계약","계절","계층","계획","고객","고구려","고궁","고급","고등학생","고무신","고민","고양이","고장","고전","고집","고춧가루","고통","고향","곡식","골목","골짜기","골프","공간","공개","공격","공군","공급","공기","공동","공무원","공부","공사","공식","공업","공연","공원","공장","공짜","공책","공통","공포","공항","공휴일","과목","과일","과장","과정","과학","관객","관계","관광","관념","관람","관련","관리","관습","관심","관점","관찰","광경","광고","광장","광주","괴로움","굉장히","교과서","교문","교복","교실","교양","교육","교장","교직","교통","교환","교훈","구경","구름","구멍","구별","구분","구석","구성","구속","구역","구입","구청","구체적","국가","국기","국내","국립","국물","국민","국수","국어","국왕","국적","국제","국회","군대","군사","군인","궁극적","권리","권위","권투","귀국","귀신","규정","규칙","균형","그날","그냥","그늘","그러나","그룹","그릇","그림","그제서야","그토록","극복","극히","근거","근교","근래","근로","근무","근본","근원","근육","근처","글씨","글자","금강산","금고","금년","금메달","금액","금연","금요일","금지","긍정적","기간","기관","기념","기능","기독교","기둥","기록","기름","기법","기본","기분","기쁨","기숙사","기술","기억","기업","기온","기운","기원","기적","기준","기침","기혼","기획","긴급","긴장","길이","김밥","김치","김포공항","깍두기","깜빡","깨달음","깨소금","껍질","꼭대기","꽃잎","나들이","나란히","나머지","나물","나침반","나흘","낙엽","난방","날개","날씨","날짜","남녀","남대문","남매","남산","남자","남편","남학생","낭비","낱말","내년","내용","내일","냄비","냄새","냇물","냉동","냉면","냉방","냉장고","넥타이","넷째","노동","노란색","노력","노인","녹음","녹차","녹화","논리","논문","논쟁","놀이","농구","농담","농민","농부","농업","농장","농촌","높이","눈동자","눈물","눈썹","뉴욕","느낌","늑대","능동적","능력","다방","다양성","다음","다이어트","다행","단계","단골","단독","단맛","단순","단어","단위","단점","단체","단추","단편","단풍","달걀","달러","달력","달리","닭고기","담당","담배","담요","담임","답변","답장","당근","당분간","당연히","당장","대규모","대낮","대단히","대답","대도시","대략","대량","대륙","대문","대부분","대신","대응","대장","대전","대접","대중","대책","대출","대충","대통령","대학","대한민국","대합실","대형","덩어리","데이트","도대체","도덕","도둑","도망","도서관","도심","도움","도입","도자기","도저히","도전","도중","도착","독감","독립","독서","독일","독창적","동화책","뒷모습","뒷산","딸아이","마누라","마늘","마당","마라톤","마련","마무리","마사지","마약","마요네즈","마을","마음","마이크","마중","마지막","마찬가지","마찰","마흔","막걸리","막내","막상","만남","만두","만세","만약","만일","만점","만족","만화","많이","말기","말씀","말투","맘대로","망원경","매년","매달","매력","매번","매스컴","매일","매장","맥주","먹이","먼저","먼지","멀리","메일","며느리","며칠","면담","멸치","명단","명령","명예","명의","명절","명칭","명함","모금","모니터","모델","모든","모범","모습","모양","모임","모조리","모집","모퉁이","목걸이","목록","목사","목소리","목숨","목적","목표","몰래","몸매","몸무게","몸살","몸속","몸짓","몸통","몹시","무관심","무궁화","무더위","무덤","무릎","무슨","무엇","무역","무용","무조건","무지개","무척","문구","문득","문법","문서","문제","문학","문화","물가","물건","물결","물고기","물론","물리학","물음","물질","물체","미국","미디어","미사일","미술","미역","미용실","미움","미인","미팅","미혼","민간","민족","민주","믿음","밀가루","밀리미터","밑바닥","바가지","바구니","바나나","바늘","바닥","바닷가","바람","바이러스","바탕","박물관","박사","박수","반대","반드시","반말","반발","반성","반응","반장","반죽","반지","반찬","받침","발가락","발걸음","발견","발달","발레","발목","발바닥","발생","발음","발자국","발전","발톱","발표","밤하늘","밥그릇","밥맛","밥상","밥솥","방금","방면","방문","방바닥","방법","방송","방식","방안","방울","방지","방학","방해","방향","배경","배꼽","배달","배드민턴","백두산","백색","백성","백인","백제","백화점","버릇","버섯","버튼","번개","번역","번지","번호","벌금","벌레","벌써","범위","범인","범죄","법률","법원","법적","법칙","베이징","벨트","변경","변동","변명","변신","변호사","변화","별도","별명","별일","병실","병아리","병원","보관","보너스","보라색","보람","보름","보상","보안","보자기","보장","보전","보존","보통","보편적","보험","복도","복사","복숭아","복습","볶음","본격적","본래","본부","본사","본성","본인","본질","볼펜","봉사","봉지","봉투","부근","부끄러움","부담","부동산","부문","부분","부산","부상","부엌","부인","부작용","부장","부정","부족","부지런히","부친","부탁","부품","부회장","북부","북한","분노","분량","분리","분명","분석","분야","분위기","분필","분홍색","불고기","불과","불교","불꽃","불만","불법","불빛","불안","불이익","불행","브랜드","비극","비난","비닐","비둘기","비디오","비로소","비만","비명","비밀","비바람","비빔밥","비상","비용","비율","비중","비타민","비판","빌딩","빗물","빗방울","빗줄기","빛깔","빨간색","빨래","빨리","사건","사계절","사나이","사냥","사람","사랑","사립","사모님","사물","사방","사상","사생활","사설","사슴","사실","사업","사용","사월","사장","사전","사진","사촌","사춘기","사탕","사투리","사흘","산길","산부인과","산업","산책","살림","살인","살짝","삼계탕","삼국","삼십","삼월","삼촌","상관","상금","상대","상류","상반기","상상","상식","상업","상인","상자","상점","상처","상추","상태","상표","상품","상황","새벽","색깔","색연필","생각","생명","생물","생방송","생산","생선","생신","생일","생활","서랍","서른","서명","서민","서비스","서양","서울","서적","서점","서쪽","서클","석사","석유","선거","선물","선배","선생","선수","선원","선장","선전","선택","선풍기","설거지","설날","설렁탕","설명","설문","설사","설악산","설치","설탕","섭씨","성공","성당","성명","성별","성인","성장","성적","성질","성함","세금","세미나","세상","세월","세종대왕","세탁","센터","센티미터","셋째","소규모","소극적","소금","소나기","소년","소득","소망","소문","소설","소속","소아과","소용","소원","소음","소중히","소지품","소질","소풍","소형","속담","속도","속옷","손가락","손길","손녀","손님","손등","손목","손뼉","손실","손질","손톱","손해","솔직히","솜씨","송아지","송이","송편","쇠고기","쇼핑","수건","수년","수단","수돗물","수동적","수면","수명","수박","수상","수석","수술","수시로","수업","수염","수영","수입","수준","수집","수출","수컷","수필","수학","수험생","수화기","숙녀","숙소","숙제","순간","순서","순수","순식간","순위","숟가락","술병","술집","숫자","스님","스물","스스로","스승","스웨터","스위치","스케이트","스튜디오","스트레스","스포츠","슬쩍","슬픔","습관","습기","승객","승리","승부","승용차","승진","시각","시간","시골","시금치","시나리오","시댁","시리즈","시멘트","시민","시부모","시선","시설","시스템","시아버지","시어머니","시월","시인","시일","시작","시장","시절","시점","시중","시즌","시집","시청","시합","시험","식구","식기","식당","식량","식료품","식물","식빵","식사","식생활","식초","식탁","식품","신고","신규","신념","신문","신발","신비","신사","신세","신용","신제품","신청","신체","신화","실감","실내","실력","실례","실망","실수","실습","실시","실장","실정","실질적","실천","실체","실컷","실태","실패","실험","실현","심리","심부름","심사","심장","심정","심판","쌍둥이","씨름","씨앗","아가씨","아나운서","아드님","아들","아쉬움","아스팔트","아시아","아울러","아저씨","아줌마","아직","아침","아파트","아프리카","아픔","아홉","아흔","악기","악몽","악수","안개","안경","안과","안내","안녕","안동","안방","안부","안주","알루미늄","알코올","암시","암컷","압력","앞날","앞문","애인","애정","액수","앨범","야간","야단","야옹","약간","약국","약속","약수","약점","약품","약혼녀","양념","양력","양말","양배추","양주","양파","어둠","어려움","어른","어젯밤","어쨌든","어쩌다가","어쩐지","언니","언덕","언론","언어","얼굴","얼른","얼음","얼핏","엄마","업무","업종","업체","엉덩이","엉망","엉터리","엊그제","에너지","에어컨","엔진","여건","여고생","여관","여군","여권","여대생","여덟","여동생","여든","여론","여름","여섯","여성","여왕","여인","여전히","여직원","여학생","여행","역사","역시","역할","연결","연구","연극","연기","연락","연설","연세","연속","연습","연애","연예인","연인","연장","연주","연출","연필","연합","연휴","열기","열매","열쇠","열심히","열정","열차","열흘","염려","엽서","영국","영남","영상","영양","영역","영웅","영원히","영하","영향","영혼","영화","옆구리","옆방","옆집","예감","예금","예방","예산","예상","예선","예술","예습","예식장","예약","예전","예절","예정","예컨대","옛날","오늘","오락","오랫동안","오렌지","오로지","오른발","오븐","오십","오염","오월","오전","오직","오징어","오페라","오피스텔","오히려","옥상","옥수수","온갖","온라인","온몸","온종일","온통","올가을","올림픽","올해","옷차림","와이셔츠","와인","완성","완전","왕비","왕자","왜냐하면","왠지","외갓집","외국","외로움","외삼촌","외출","외침","외할머니","왼발","왼손","왼쪽","요금","요일","요즘","요청","용기","용서","용어","우산","우선","우승","우연히","우정","우체국","우편","운동","운명","운반","운전","운행","울산","울음","움직임","웃어른","웃음","워낙","원고","원래","원서","원숭이","원인","원장","원피스","월급","월드컵","월세","월요일","웨이터","위반","위법","위성","위원","위험","위협","윗사람","유난히","유럽","유명","유물","유산","유적","유치원","유학","유행","유형","육군","육상","육십","육체","은행","음력","음료","음반","음성","음식","음악","음주","의견","의논","의문","의복","의식","의심","의외로","의욕","의원","의학","이것","이곳","이념","이놈","이달","이대로","이동","이렇게","이력서","이론적","이름","이민","이발소","이별","이불","이빨","이상","이성","이슬","이야기","이용","이웃","이월","이윽고","이익","이전","이중","이튿날","이틀","이혼","인간","인격","인공","인구","인근","인기","인도","인류","인물","인생","인쇄","인연","인원","인재","인종","인천","인체","인터넷","인하","인형","일곱","일기","일단","일대","일등","일반","일본","일부","일상","일생","일손","일요일","일월","일정","일종","일주일","일찍","일체","일치","일행","일회용","임금","임무","입대","입력","입맛","입사","입술","입시","입원","입장","입학","자가용","자격","자극","자동","자랑","자부심","자식","자신","자연","자원","자율","자전거","자정","자존심","자판","작가","작년","작성","작업","작용","작은딸","작품","잔디","잔뜩","잔치","잘못","잠깐","잠수함","잠시","잠옷","잠자리","잡지","장관","장군","장기간","장래","장례","장르","장마","장면","장모","장미","장비","장사","장소","장식","장애인","장인","장점","장차","장학금","재능","재빨리","재산","재생","재작년","재정","재채기","재판","재학","재활용","저것","저고리","저곳","저녁","저런","저렇게","저번","저울","저절로","저축","적극","적당히","적성","적용","적응","전개","전공","전기","전달","전라도","전망","전문","전반","전부","전세","전시","전용","전자","전쟁","전주","전철","전체","전통","전혀","전후","절대","절망","절반","절약","절차","점검","점수","점심","점원","점점","점차","접근","접시","접촉","젓가락","정거장","정도","정류장","정리","정말","정면","정문","정반대","정보","정부","정비","정상","정성","정오","정원","정장","정지","정치","정확히","제공","제과점","제대로","제목","제발","제법","제삿날","제안","제일","제작","제주도","제출","제품","제한","조각","조건","조금","조깅","조명","조미료","조상","조선","조용히","조절","조정","조직","존댓말","존재","졸업","졸음","종교","종로","종류","종소리","종업원","종종","종합","좌석","죄인","주관적","주름","주말","주머니","주먹","주문","주민","주방","주변","주식","주인","주일","주장","주전자","주택","준비","줄거리","줄기","줄무늬","중간","중계방송","중국","중년","중단","중독","중반","중부","중세","중소기업","중순","중앙","중요","중학교","즉석","즉시","즐거움","증가","증거","증권","증상","증세","지각","지갑","지경","지극히","지금","지급","지능","지름길","지리산","지방","지붕","지식","지역","지우개","지원","지적","지점","지진","지출","직선","직업","직원","직장","진급","진동","진로","진료","진리","진짜","진찰","진출","진통","진행","질문","질병","질서","짐작","집단","집안","집중","짜증","찌꺼기","차남","차라리","차량","차림","차별","차선","차츰","착각","찬물","찬성","참가","참기름","참새","참석","참여","참외","참조","찻잔","창가","창고","창구","창문","창밖","창작","창조","채널","채점","책가방","책방","책상","책임","챔피언","처벌","처음","천국","천둥","천장","천재","천천히","철도","철저히","철학","첫날","첫째","청년","청바지","청소","청춘","체계","체력","체온","체육","체중","체험","초등학생","초반","초밥","초상화","초순","초여름","초원","초저녁","초점","초청","초콜릿","촛불","총각","총리","총장","촬영","최근","최상","최선","최신","최악","최종","추석","추억","추진","추천","추측","축구","축소","축제","축하","출근","출발","출산","출신","출연","출입","출장","출판","충격","충고","충돌","충분히","충청도","취업","취직","취향","치약","친구","친척","칠십","칠월","칠판","침대","침묵","침실","칫솔","칭찬","카메라","카운터","칼국수","캐릭터","캠퍼스","캠페인","커튼","컨디션","컬러","컴퓨터","코끼리","코미디","콘서트","콜라","콤플렉스","콩나물","쾌감","쿠데타","크림","큰길","큰딸","큰소리","큰아들","큰어머니","큰일","큰절","클래식","클럽","킬로","타입","타자기","탁구","탁자","탄생","태권도","태양","태풍","택시","탤런트","터널","터미널","테니스","테스트","테이블","텔레비전","토론","토마토","토요일","통계","통과","통로","통신","통역","통일","통장","통제","통증","통합","통화","퇴근","퇴원","퇴직금","튀김","트럭","특급","특별","특성","특수","특징","특히","튼튼히","티셔츠","파란색","파일","파출소","판결","판단","판매","판사","팔십","팔월","팝송","패션","팩스","팩시밀리","팬티","퍼센트","페인트","편견","편의","편지","편히","평가","평균","평생","평소","평양","평일","평화","포스터","포인트","포장","포함","표면","표정","표준","표현","품목","품질","풍경","풍속","풍습","프랑스","프린터","플라스틱","피곤","피망","피아노","필름","필수","필요","필자","필통","핑계","하느님","하늘","하드웨어","하룻밤","하반기","하숙집","하순","하여튼","하지만","하천","하품","하필","학과","학교","학급","학기","학년","학력","학번","학부모","학비","학생","학술","학습","학용품","학원","학위","학자","학점","한계","한글","한꺼번에","한낮","한눈","한동안","한때","한라산","한마디","한문","한번","한복","한식","한여름","한쪽","할머니","할아버지","할인","함께","함부로","합격","합리적","항공","항구","항상","항의","해결","해군","해답","해당","해물","해석","해설","해수욕장","해안","핵심","핸드백","햄버거","햇볕","햇살","행동","행복","행사","행운","행위","향기","향상","향수","허락","허용","헬기","현관","현금","현대","현상","현실","현장","현재","현지","혈액","협력","형부","형사","형수","형식","형제","형태","형편","혜택","호기심","호남","호랑이","호박","호텔","호흡","혹시","홀로","홈페이지","홍보","홍수","홍차","화면","화분","화살","화요일","화장","화학","확보","확인","확장","확정","환갑","환경","환영","환율","환자","활기","활동","활발히","활용","활짝","회견","회관","회복","회색","회원","회장","회전","횟수","횡단보도","효율적","후반","후춧가루","훈련","훨씬","휴식","휴일","흉내","흐름","흑백","흑인","흔적","흔히","흥미","흥분","희곡","희망","희생","흰색","힘껏"]');

/***/ }),

/***/ 71945:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('["abacate","abaixo","abalar","abater","abduzir","abelha","aberto","abismo","abotoar","abranger","abreviar","abrigar","abrupto","absinto","absoluto","absurdo","abutre","acabado","acalmar","acampar","acanhar","acaso","aceitar","acelerar","acenar","acervo","acessar","acetona","achatar","acidez","acima","acionado","acirrar","aclamar","aclive","acolhida","acomodar","acoplar","acordar","acumular","acusador","adaptar","adega","adentro","adepto","adequar","aderente","adesivo","adeus","adiante","aditivo","adjetivo","adjunto","admirar","adorar","adquirir","adubo","adverso","advogado","aeronave","afastar","aferir","afetivo","afinador","afivelar","aflito","afluente","afrontar","agachar","agarrar","agasalho","agenciar","agilizar","agiota","agitado","agora","agradar","agreste","agrupar","aguardar","agulha","ajoelhar","ajudar","ajustar","alameda","alarme","alastrar","alavanca","albergue","albino","alcatra","aldeia","alecrim","alegria","alertar","alface","alfinete","algum","alheio","aliar","alicate","alienar","alinhar","aliviar","almofada","alocar","alpiste","alterar","altitude","alucinar","alugar","aluno","alusivo","alvo","amaciar","amador","amarelo","amassar","ambas","ambiente","ameixa","amenizar","amido","amistoso","amizade","amolador","amontoar","amoroso","amostra","amparar","ampliar","ampola","anagrama","analisar","anarquia","anatomia","andaime","anel","anexo","angular","animar","anjo","anomalia","anotado","ansioso","anterior","anuidade","anunciar","anzol","apagador","apalpar","apanhado","apego","apelido","apertada","apesar","apetite","apito","aplauso","aplicada","apoio","apontar","aposta","aprendiz","aprovar","aquecer","arame","aranha","arara","arcada","ardente","areia","arejar","arenito","aresta","argiloso","argola","arma","arquivo","arraial","arrebate","arriscar","arroba","arrumar","arsenal","arterial","artigo","arvoredo","asfaltar","asilado","aspirar","assador","assinar","assoalho","assunto","astral","atacado","atadura","atalho","atarefar","atear","atender","aterro","ateu","atingir","atirador","ativo","atoleiro","atracar","atrevido","atriz","atual","atum","auditor","aumentar","aura","aurora","autismo","autoria","autuar","avaliar","avante","avaria","avental","avesso","aviador","avisar","avulso","axila","azarar","azedo","azeite","azulejo","babar","babosa","bacalhau","bacharel","bacia","bagagem","baiano","bailar","baioneta","bairro","baixista","bajular","baleia","baliza","balsa","banal","bandeira","banho","banir","banquete","barato","barbado","baronesa","barraca","barulho","baseado","bastante","batata","batedor","batida","batom","batucar","baunilha","beber","beijo","beirada","beisebol","beldade","beleza","belga","beliscar","bendito","bengala","benzer","berimbau","berlinda","berro","besouro","bexiga","bezerro","bico","bicudo","bienal","bifocal","bifurcar","bigorna","bilhete","bimestre","bimotor","biologia","biombo","biosfera","bipolar","birrento","biscoito","bisneto","bispo","bissexto","bitola","bizarro","blindado","bloco","bloquear","boato","bobagem","bocado","bocejo","bochecha","boicotar","bolada","boletim","bolha","bolo","bombeiro","bonde","boneco","bonita","borbulha","borda","boreal","borracha","bovino","boxeador","branco","brasa","braveza","breu","briga","brilho","brincar","broa","brochura","bronzear","broto","bruxo","bucha","budismo","bufar","bule","buraco","busca","busto","buzina","cabana","cabelo","cabide","cabo","cabrito","cacau","cacetada","cachorro","cacique","cadastro","cadeado","cafezal","caiaque","caipira","caixote","cajado","caju","calafrio","calcular","caldeira","calibrar","calmante","calota","camada","cambista","camisa","camomila","campanha","camuflar","canavial","cancelar","caneta","canguru","canhoto","canivete","canoa","cansado","cantar","canudo","capacho","capela","capinar","capotar","capricho","captador","capuz","caracol","carbono","cardeal","careca","carimbar","carneiro","carpete","carreira","cartaz","carvalho","casaco","casca","casebre","castelo","casulo","catarata","cativar","caule","causador","cautelar","cavalo","caverna","cebola","cedilha","cegonha","celebrar","celular","cenoura","censo","centeio","cercar","cerrado","certeiro","cerveja","cetim","cevada","chacota","chaleira","chamado","chapada","charme","chatice","chave","chefe","chegada","cheiro","cheque","chicote","chifre","chinelo","chocalho","chover","chumbo","chutar","chuva","cicatriz","ciclone","cidade","cidreira","ciente","cigana","cimento","cinto","cinza","ciranda","circuito","cirurgia","citar","clareza","clero","clicar","clone","clube","coado","coagir","cobaia","cobertor","cobrar","cocada","coelho","coentro","coeso","cogumelo","coibir","coifa","coiote","colar","coleira","colher","colidir","colmeia","colono","coluna","comando","combinar","comentar","comitiva","comover","complexo","comum","concha","condor","conectar","confuso","congelar","conhecer","conjugar","consumir","contrato","convite","cooperar","copeiro","copiador","copo","coquetel","coragem","cordial","corneta","coronha","corporal","correio","cortejo","coruja","corvo","cosseno","costela","cotonete","couro","couve","covil","cozinha","cratera","cravo","creche","credor","creme","crer","crespo","criada","criminal","crioulo","crise","criticar","crosta","crua","cruzeiro","cubano","cueca","cuidado","cujo","culatra","culminar","culpar","cultura","cumprir","cunhado","cupido","curativo","curral","cursar","curto","cuspir","custear","cutelo","damasco","datar","debater","debitar","deboche","debulhar","decalque","decimal","declive","decote","decretar","dedal","dedicado","deduzir","defesa","defumar","degelo","degrau","degustar","deitado","deixar","delator","delegado","delinear","delonga","demanda","demitir","demolido","dentista","depenado","depilar","depois","depressa","depurar","deriva","derramar","desafio","desbotar","descanso","desenho","desfiado","desgaste","desigual","deslize","desmamar","desova","despesa","destaque","desviar","detalhar","detentor","detonar","detrito","deusa","dever","devido","devotado","dezena","diagrama","dialeto","didata","difuso","digitar","dilatado","diluente","diminuir","dinastia","dinheiro","diocese","direto","discreta","disfarce","disparo","disquete","dissipar","distante","ditador","diurno","diverso","divisor","divulgar","dizer","dobrador","dolorido","domador","dominado","donativo","donzela","dormente","dorsal","dosagem","dourado","doutor","drenagem","drible","drogaria","duelar","duende","dueto","duplo","duquesa","durante","duvidoso","eclodir","ecoar","ecologia","edificar","edital","educado","efeito","efetivar","ejetar","elaborar","eleger","eleitor","elenco","elevador","eliminar","elogiar","embargo","embolado","embrulho","embutido","emenda","emergir","emissor","empatia","empenho","empinado","empolgar","emprego","empurrar","emulador","encaixe","encenado","enchente","encontro","endeusar","endossar","enfaixar","enfeite","enfim","engajado","engenho","englobar","engomado","engraxar","enguia","enjoar","enlatar","enquanto","enraizar","enrolado","enrugar","ensaio","enseada","ensino","ensopado","entanto","enteado","entidade","entortar","entrada","entulho","envergar","enviado","envolver","enxame","enxerto","enxofre","enxuto","epiderme","equipar","ereto","erguido","errata","erva","ervilha","esbanjar","esbelto","escama","escola","escrita","escuta","esfinge","esfolar","esfregar","esfumado","esgrima","esmalte","espanto","espelho","espiga","esponja","espreita","espumar","esquerda","estaca","esteira","esticar","estofado","estrela","estudo","esvaziar","etanol","etiqueta","euforia","europeu","evacuar","evaporar","evasivo","eventual","evidente","evoluir","exagero","exalar","examinar","exato","exausto","excesso","excitar","exclamar","executar","exemplo","exibir","exigente","exonerar","expandir","expelir","expirar","explanar","exposto","expresso","expulsar","externo","extinto","extrato","fabricar","fabuloso","faceta","facial","fada","fadiga","faixa","falar","falta","familiar","fandango","fanfarra","fantoche","fardado","farelo","farinha","farofa","farpa","fartura","fatia","fator","favorita","faxina","fazenda","fechado","feijoada","feirante","felino","feminino","fenda","feno","fera","feriado","ferrugem","ferver","festejar","fetal","feudal","fiapo","fibrose","ficar","ficheiro","figurado","fileira","filho","filme","filtrar","firmeza","fisgada","fissura","fita","fivela","fixador","fixo","flacidez","flamingo","flanela","flechada","flora","flutuar","fluxo","focal","focinho","fofocar","fogo","foguete","foice","folgado","folheto","forjar","formiga","forno","forte","fosco","fossa","fragata","fralda","frango","frasco","fraterno","freira","frente","fretar","frieza","friso","fritura","fronha","frustrar","fruteira","fugir","fulano","fuligem","fundar","fungo","funil","furador","furioso","futebol","gabarito","gabinete","gado","gaiato","gaiola","gaivota","galega","galho","galinha","galocha","ganhar","garagem","garfo","gargalo","garimpo","garoupa","garrafa","gasoduto","gasto","gata","gatilho","gaveta","gazela","gelado","geleia","gelo","gemada","gemer","gemido","generoso","gengiva","genial","genoma","genro","geologia","gerador","germinar","gesso","gestor","ginasta","gincana","gingado","girafa","girino","glacial","glicose","global","glorioso","goela","goiaba","golfe","golpear","gordura","gorjeta","gorro","gostoso","goteira","governar","gracejo","gradual","grafite","gralha","grampo","granada","gratuito","graveto","graxa","grego","grelhar","greve","grilo","grisalho","gritaria","grosso","grotesco","grudado","grunhido","gruta","guache","guarani","guaxinim","guerrear","guiar","guincho","guisado","gula","guloso","guru","habitar","harmonia","haste","haver","hectare","herdar","heresia","hesitar","hiato","hibernar","hidratar","hiena","hino","hipismo","hipnose","hipoteca","hoje","holofote","homem","honesto","honrado","hormonal","hospedar","humorado","iate","ideia","idoso","ignorado","igreja","iguana","ileso","ilha","iludido","iluminar","ilustrar","imagem","imediato","imenso","imersivo","iminente","imitador","imortal","impacto","impedir","implante","impor","imprensa","impune","imunizar","inalador","inapto","inativo","incenso","inchar","incidir","incluir","incolor","indeciso","indireto","indutor","ineficaz","inerente","infantil","infestar","infinito","inflamar","informal","infrator","ingerir","inibido","inicial","inimigo","injetar","inocente","inodoro","inovador","inox","inquieto","inscrito","inseto","insistir","inspetor","instalar","insulto","intacto","integral","intimar","intocado","intriga","invasor","inverno","invicto","invocar","iogurte","iraniano","ironizar","irreal","irritado","isca","isento","isolado","isqueiro","italiano","janeiro","jangada","janta","jararaca","jardim","jarro","jasmim","jato","javali","jazida","jejum","joaninha","joelhada","jogador","joia","jornal","jorrar","jovem","juba","judeu","judoca","juiz","julgador","julho","jurado","jurista","juro","justa","labareda","laboral","lacre","lactante","ladrilho","lagarta","lagoa","laje","lamber","lamentar","laminar","lampejo","lanche","lapidar","lapso","laranja","lareira","largura","lasanha","lastro","lateral","latido","lavanda","lavoura","lavrador","laxante","lazer","lealdade","lebre","legado","legendar","legista","leigo","leiloar","leitura","lembrete","leme","lenhador","lentilha","leoa","lesma","leste","letivo","letreiro","levar","leveza","levitar","liberal","libido","liderar","ligar","ligeiro","limitar","limoeiro","limpador","linda","linear","linhagem","liquidez","listagem","lisura","litoral","livro","lixa","lixeira","locador","locutor","lojista","lombo","lona","longe","lontra","lorde","lotado","loteria","loucura","lousa","louvar","luar","lucidez","lucro","luneta","lustre","lutador","luva","macaco","macete","machado","macio","madeira","madrinha","magnata","magreza","maior","mais","malandro","malha","malote","maluco","mamilo","mamoeiro","mamute","manada","mancha","mandato","manequim","manhoso","manivela","manobrar","mansa","manter","manusear","mapeado","maquinar","marcador","maresia","marfim","margem","marinho","marmita","maroto","marquise","marreco","martelo","marujo","mascote","masmorra","massagem","mastigar","matagal","materno","matinal","matutar","maxilar","medalha","medida","medusa","megafone","meiga","melancia","melhor","membro","memorial","menino","menos","mensagem","mental","merecer","mergulho","mesada","mesclar","mesmo","mesquita","mestre","metade","meteoro","metragem","mexer","mexicano","micro","migalha","migrar","milagre","milenar","milhar","mimado","minerar","minhoca","ministro","minoria","miolo","mirante","mirtilo","misturar","mocidade","moderno","modular","moeda","moer","moinho","moita","moldura","moleza","molho","molinete","molusco","montanha","moqueca","morango","morcego","mordomo","morena","mosaico","mosquete","mostarda","motel","motim","moto","motriz","muda","muito","mulata","mulher","multar","mundial","munido","muralha","murcho","muscular","museu","musical","nacional","nadador","naja","namoro","narina","narrado","nascer","nativa","natureza","navalha","navegar","navio","neblina","nebuloso","negativa","negociar","negrito","nervoso","neta","neural","nevasca","nevoeiro","ninar","ninho","nitidez","nivelar","nobreza","noite","noiva","nomear","nominal","nordeste","nortear","notar","noticiar","noturno","novelo","novilho","novo","nublado","nudez","numeral","nupcial","nutrir","nuvem","obcecado","obedecer","objetivo","obrigado","obscuro","obstetra","obter","obturar","ocidente","ocioso","ocorrer","oculista","ocupado","ofegante","ofensiva","oferenda","oficina","ofuscado","ogiva","olaria","oleoso","olhar","oliveira","ombro","omelete","omisso","omitir","ondulado","oneroso","ontem","opcional","operador","oponente","oportuno","oposto","orar","orbitar","ordem","ordinal","orfanato","orgasmo","orgulho","oriental","origem","oriundo","orla","ortodoxo","orvalho","oscilar","ossada","osso","ostentar","otimismo","ousadia","outono","outubro","ouvido","ovelha","ovular","oxidar","oxigenar","pacato","paciente","pacote","pactuar","padaria","padrinho","pagar","pagode","painel","pairar","paisagem","palavra","palestra","palheta","palito","palmada","palpitar","pancada","panela","panfleto","panqueca","pantanal","papagaio","papelada","papiro","parafina","parcial","pardal","parede","partida","pasmo","passado","pastel","patamar","patente","patinar","patrono","paulada","pausar","peculiar","pedalar","pedestre","pediatra","pedra","pegada","peitoral","peixe","pele","pelicano","penca","pendurar","peneira","penhasco","pensador","pente","perceber","perfeito","pergunta","perito","permitir","perna","perplexo","persiana","pertence","peruca","pescado","pesquisa","pessoa","petiscar","piada","picado","piedade","pigmento","pilastra","pilhado","pilotar","pimenta","pincel","pinguim","pinha","pinote","pintar","pioneiro","pipoca","piquete","piranha","pires","pirueta","piscar","pistola","pitanga","pivete","planta","plaqueta","platina","plebeu","plumagem","pluvial","pneu","poda","poeira","poetisa","polegada","policiar","poluente","polvilho","pomar","pomba","ponderar","pontaria","populoso","porta","possuir","postal","pote","poupar","pouso","povoar","praia","prancha","prato","praxe","prece","predador","prefeito","premiar","prensar","preparar","presilha","pretexto","prevenir","prezar","primata","princesa","prisma","privado","processo","produto","profeta","proibido","projeto","prometer","propagar","prosa","protetor","provador","publicar","pudim","pular","pulmonar","pulseira","punhal","punir","pupilo","pureza","puxador","quadra","quantia","quarto","quase","quebrar","queda","queijo","quente","querido","quimono","quina","quiosque","rabanada","rabisco","rachar","racionar","radial","raiar","rainha","raio","raiva","rajada","ralado","ramal","ranger","ranhura","rapadura","rapel","rapidez","raposa","raquete","raridade","rasante","rascunho","rasgar","raspador","rasteira","rasurar","ratazana","ratoeira","realeza","reanimar","reaver","rebaixar","rebelde","rebolar","recado","recente","recheio","recibo","recordar","recrutar","recuar","rede","redimir","redonda","reduzida","reenvio","refinar","refletir","refogar","refresco","refugiar","regalia","regime","regra","reinado","reitor","rejeitar","relativo","remador","remendo","remorso","renovado","reparo","repelir","repleto","repolho","represa","repudiar","requerer","resenha","resfriar","resgatar","residir","resolver","respeito","ressaca","restante","resumir","retalho","reter","retirar","retomada","retratar","revelar","revisor","revolta","riacho","rica","rigidez","rigoroso","rimar","ringue","risada","risco","risonho","robalo","rochedo","rodada","rodeio","rodovia","roedor","roleta","romano","roncar","rosado","roseira","rosto","rota","roteiro","rotina","rotular","rouco","roupa","roxo","rubro","rugido","rugoso","ruivo","rumo","rupestre","russo","sabor","saciar","sacola","sacudir","sadio","safira","saga","sagrada","saibro","salada","saleiro","salgado","saliva","salpicar","salsicha","saltar","salvador","sambar","samurai","sanar","sanfona","sangue","sanidade","sapato","sarda","sargento","sarjeta","saturar","saudade","saxofone","sazonal","secar","secular","seda","sedento","sediado","sedoso","sedutor","segmento","segredo","segundo","seiva","seleto","selvagem","semanal","semente","senador","senhor","sensual","sentado","separado","sereia","seringa","serra","servo","setembro","setor","sigilo","silhueta","silicone","simetria","simpatia","simular","sinal","sincero","singular","sinopse","sintonia","sirene","siri","situado","soberano","sobra","socorro","sogro","soja","solda","soletrar","solteiro","sombrio","sonata","sondar","sonegar","sonhador","sono","soprano","soquete","sorrir","sorteio","sossego","sotaque","soterrar","sovado","sozinho","suavizar","subida","submerso","subsolo","subtrair","sucata","sucesso","suco","sudeste","sufixo","sugador","sugerir","sujeito","sulfato","sumir","suor","superior","suplicar","suposto","suprimir","surdina","surfista","surpresa","surreal","surtir","suspiro","sustento","tabela","tablete","tabuada","tacho","tagarela","talher","talo","talvez","tamanho","tamborim","tampa","tangente","tanto","tapar","tapioca","tardio","tarefa","tarja","tarraxa","tatuagem","taurino","taxativo","taxista","teatral","tecer","tecido","teclado","tedioso","teia","teimar","telefone","telhado","tempero","tenente","tensor","tentar","termal","terno","terreno","tese","tesoura","testado","teto","textura","texugo","tiara","tigela","tijolo","timbrar","timidez","tingido","tinteiro","tiragem","titular","toalha","tocha","tolerar","tolice","tomada","tomilho","tonel","tontura","topete","tora","torcido","torneio","torque","torrada","torto","tostar","touca","toupeira","toxina","trabalho","tracejar","tradutor","trafegar","trajeto","trama","trancar","trapo","traseiro","tratador","travar","treino","tremer","trepidar","trevo","triagem","tribo","triciclo","tridente","trilogia","trindade","triplo","triturar","triunfal","trocar","trombeta","trova","trunfo","truque","tubular","tucano","tudo","tulipa","tupi","turbo","turma","turquesa","tutelar","tutorial","uivar","umbigo","unha","unidade","uniforme","urologia","urso","urtiga","urubu","usado","usina","usufruir","vacina","vadiar","vagaroso","vaidoso","vala","valente","validade","valores","vantagem","vaqueiro","varanda","vareta","varrer","vascular","vasilha","vassoura","vazar","vazio","veado","vedar","vegetar","veicular","veleiro","velhice","veludo","vencedor","vendaval","venerar","ventre","verbal","verdade","vereador","vergonha","vermelho","verniz","versar","vertente","vespa","vestido","vetorial","viaduto","viagem","viajar","viatura","vibrador","videira","vidraria","viela","viga","vigente","vigiar","vigorar","vilarejo","vinco","vinheta","vinil","violeta","virada","virtude","visitar","visto","vitral","viveiro","vizinho","voador","voar","vogal","volante","voleibol","voltagem","volumoso","vontade","vulto","vuvuzela","xadrez","xarope","xeque","xeretar","xerife","xingar","zangado","zarpar","zebu","zelador","zombar","zoologia","zumbido"]');

/***/ }),

/***/ 80659:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('["ábaco","abdomen","abeja","abierto","abogado","abono","aborto","abrazo","abrir","abuelo","abuso","acabar","academia","acceso","acción","aceite","acelga","acento","aceptar","ácido","aclarar","acné","acoger","acoso","activo","acto","actriz","actuar","acudir","acuerdo","acusar","adicto","admitir","adoptar","adorno","aduana","adulto","aéreo","afectar","afición","afinar","afirmar","ágil","agitar","agonía","agosto","agotar","agregar","agrio","agua","agudo","águila","aguja","ahogo","ahorro","aire","aislar","ajedrez","ajeno","ajuste","alacrán","alambre","alarma","alba","álbum","alcalde","aldea","alegre","alejar","alerta","aleta","alfiler","alga","algodón","aliado","aliento","alivio","alma","almeja","almíbar","altar","alteza","altivo","alto","altura","alumno","alzar","amable","amante","amapola","amargo","amasar","ámbar","ámbito","ameno","amigo","amistad","amor","amparo","amplio","ancho","anciano","ancla","andar","andén","anemia","ángulo","anillo","ánimo","anís","anotar","antena","antiguo","antojo","anual","anular","anuncio","añadir","añejo","año","apagar","aparato","apetito","apio","aplicar","apodo","aporte","apoyo","aprender","aprobar","apuesta","apuro","arado","araña","arar","árbitro","árbol","arbusto","archivo","arco","arder","ardilla","arduo","área","árido","aries","armonía","arnés","aroma","arpa","arpón","arreglo","arroz","arruga","arte","artista","asa","asado","asalto","ascenso","asegurar","aseo","asesor","asiento","asilo","asistir","asno","asombro","áspero","astilla","astro","astuto","asumir","asunto","atajo","ataque","atar","atento","ateo","ático","atleta","átomo","atraer","atroz","atún","audaz","audio","auge","aula","aumento","ausente","autor","aval","avance","avaro","ave","avellana","avena","avestruz","avión","aviso","ayer","ayuda","ayuno","azafrán","azar","azote","azúcar","azufre","azul","baba","babor","bache","bahía","baile","bajar","balanza","balcón","balde","bambú","banco","banda","baño","barba","barco","barniz","barro","báscula","bastón","basura","batalla","batería","batir","batuta","baúl","bazar","bebé","bebida","bello","besar","beso","bestia","bicho","bien","bingo","blanco","bloque","blusa","boa","bobina","bobo","boca","bocina","boda","bodega","boina","bola","bolero","bolsa","bomba","bondad","bonito","bono","bonsái","borde","borrar","bosque","bote","botín","bóveda","bozal","bravo","brazo","brecha","breve","brillo","brinco","brisa","broca","broma","bronce","brote","bruja","brusco","bruto","buceo","bucle","bueno","buey","bufanda","bufón","búho","buitre","bulto","burbuja","burla","burro","buscar","butaca","buzón","caballo","cabeza","cabina","cabra","cacao","cadáver","cadena","caer","café","caída","caimán","caja","cajón","cal","calamar","calcio","caldo","calidad","calle","calma","calor","calvo","cama","cambio","camello","camino","campo","cáncer","candil","canela","canguro","canica","canto","caña","cañón","caoba","caos","capaz","capitán","capote","captar","capucha","cara","carbón","cárcel","careta","carga","cariño","carne","carpeta","carro","carta","casa","casco","casero","caspa","castor","catorce","catre","caudal","causa","cazo","cebolla","ceder","cedro","celda","célebre","celoso","célula","cemento","ceniza","centro","cerca","cerdo","cereza","cero","cerrar","certeza","césped","cetro","chacal","chaleco","champú","chancla","chapa","charla","chico","chiste","chivo","choque","choza","chuleta","chupar","ciclón","ciego","cielo","cien","cierto","cifra","cigarro","cima","cinco","cine","cinta","ciprés","circo","ciruela","cisne","cita","ciudad","clamor","clan","claro","clase","clave","cliente","clima","clínica","cobre","cocción","cochino","cocina","coco","código","codo","cofre","coger","cohete","cojín","cojo","cola","colcha","colegio","colgar","colina","collar","colmo","columna","combate","comer","comida","cómodo","compra","conde","conejo","conga","conocer","consejo","contar","copa","copia","corazón","corbata","corcho","cordón","corona","correr","coser","cosmos","costa","cráneo","cráter","crear","crecer","creído","crema","cría","crimen","cripta","crisis","cromo","crónica","croqueta","crudo","cruz","cuadro","cuarto","cuatro","cubo","cubrir","cuchara","cuello","cuento","cuerda","cuesta","cueva","cuidar","culebra","culpa","culto","cumbre","cumplir","cuna","cuneta","cuota","cupón","cúpula","curar","curioso","curso","curva","cutis","dama","danza","dar","dardo","dátil","deber","débil","década","decir","dedo","defensa","definir","dejar","delfín","delgado","delito","demora","denso","dental","deporte","derecho","derrota","desayuno","deseo","desfile","desnudo","destino","desvío","detalle","detener","deuda","día","diablo","diadema","diamante","diana","diario","dibujo","dictar","diente","dieta","diez","difícil","digno","dilema","diluir","dinero","directo","dirigir","disco","diseño","disfraz","diva","divino","doble","doce","dolor","domingo","don","donar","dorado","dormir","dorso","dos","dosis","dragón","droga","ducha","duda","duelo","dueño","dulce","dúo","duque","durar","dureza","duro","ébano","ebrio","echar","eco","ecuador","edad","edición","edificio","editor","educar","efecto","eficaz","eje","ejemplo","elefante","elegir","elemento","elevar","elipse","élite","elixir","elogio","eludir","embudo","emitir","emoción","empate","empeño","empleo","empresa","enano","encargo","enchufe","encía","enemigo","enero","enfado","enfermo","engaño","enigma","enlace","enorme","enredo","ensayo","enseñar","entero","entrar","envase","envío","época","equipo","erizo","escala","escena","escolar","escribir","escudo","esencia","esfera","esfuerzo","espada","espejo","espía","esposa","espuma","esquí","estar","este","estilo","estufa","etapa","eterno","ética","etnia","evadir","evaluar","evento","evitar","exacto","examen","exceso","excusa","exento","exigir","exilio","existir","éxito","experto","explicar","exponer","extremo","fábrica","fábula","fachada","fácil","factor","faena","faja","falda","fallo","falso","faltar","fama","familia","famoso","faraón","farmacia","farol","farsa","fase","fatiga","fauna","favor","fax","febrero","fecha","feliz","feo","feria","feroz","fértil","fervor","festín","fiable","fianza","fiar","fibra","ficción","ficha","fideo","fiebre","fiel","fiera","fiesta","figura","fijar","fijo","fila","filete","filial","filtro","fin","finca","fingir","finito","firma","flaco","flauta","flecha","flor","flota","fluir","flujo","flúor","fobia","foca","fogata","fogón","folio","folleto","fondo","forma","forro","fortuna","forzar","fosa","foto","fracaso","frágil","franja","frase","fraude","freír","freno","fresa","frío","frito","fruta","fuego","fuente","fuerza","fuga","fumar","función","funda","furgón","furia","fusil","fútbol","futuro","gacela","gafas","gaita","gajo","gala","galería","gallo","gamba","ganar","gancho","ganga","ganso","garaje","garza","gasolina","gastar","gato","gavilán","gemelo","gemir","gen","género","genio","gente","geranio","gerente","germen","gesto","gigante","gimnasio","girar","giro","glaciar","globo","gloria","gol","golfo","goloso","golpe","goma","gordo","gorila","gorra","gota","goteo","gozar","grada","gráfico","grano","grasa","gratis","grave","grieta","grillo","gripe","gris","grito","grosor","grúa","grueso","grumo","grupo","guante","guapo","guardia","guerra","guía","guiño","guion","guiso","guitarra","gusano","gustar","haber","hábil","hablar","hacer","hacha","hada","hallar","hamaca","harina","haz","hazaña","hebilla","hebra","hecho","helado","helio","hembra","herir","hermano","héroe","hervir","hielo","hierro","hígado","higiene","hijo","himno","historia","hocico","hogar","hoguera","hoja","hombre","hongo","honor","honra","hora","hormiga","horno","hostil","hoyo","hueco","huelga","huerta","hueso","huevo","huida","huir","humano","húmedo","humilde","humo","hundir","huracán","hurto","icono","ideal","idioma","ídolo","iglesia","iglú","igual","ilegal","ilusión","imagen","imán","imitar","impar","imperio","imponer","impulso","incapaz","índice","inerte","infiel","informe","ingenio","inicio","inmenso","inmune","innato","insecto","instante","interés","íntimo","intuir","inútil","invierno","ira","iris","ironía","isla","islote","jabalí","jabón","jamón","jarabe","jardín","jarra","jaula","jazmín","jefe","jeringa","jinete","jornada","joroba","joven","joya","juerga","jueves","juez","jugador","jugo","juguete","juicio","junco","jungla","junio","juntar","júpiter","jurar","justo","juvenil","juzgar","kilo","koala","labio","lacio","lacra","lado","ladrón","lagarto","lágrima","laguna","laico","lamer","lámina","lámpara","lana","lancha","langosta","lanza","lápiz","largo","larva","lástima","lata","látex","latir","laurel","lavar","lazo","leal","lección","leche","lector","leer","legión","legumbre","lejano","lengua","lento","leña","león","leopardo","lesión","letal","letra","leve","leyenda","libertad","libro","licor","líder","lidiar","lienzo","liga","ligero","lima","límite","limón","limpio","lince","lindo","línea","lingote","lino","linterna","líquido","liso","lista","litera","litio","litro","llaga","llama","llanto","llave","llegar","llenar","llevar","llorar","llover","lluvia","lobo","loción","loco","locura","lógica","logro","lombriz","lomo","lonja","lote","lucha","lucir","lugar","lujo","luna","lunes","lupa","lustro","luto","luz","maceta","macho","madera","madre","maduro","maestro","mafia","magia","mago","maíz","maldad","maleta","malla","malo","mamá","mambo","mamut","manco","mando","manejar","manga","maniquí","manjar","mano","manso","manta","mañana","mapa","máquina","mar","marco","marea","marfil","margen","marido","mármol","marrón","martes","marzo","masa","máscara","masivo","matar","materia","matiz","matriz","máximo","mayor","mazorca","mecha","medalla","medio","médula","mejilla","mejor","melena","melón","memoria","menor","mensaje","mente","menú","mercado","merengue","mérito","mes","mesón","meta","meter","método","metro","mezcla","miedo","miel","miembro","miga","mil","milagro","militar","millón","mimo","mina","minero","mínimo","minuto","miope","mirar","misa","miseria","misil","mismo","mitad","mito","mochila","moción","moda","modelo","moho","mojar","molde","moler","molino","momento","momia","monarca","moneda","monja","monto","moño","morada","morder","moreno","morir","morro","morsa","mortal","mosca","mostrar","motivo","mover","móvil","mozo","mucho","mudar","mueble","muela","muerte","muestra","mugre","mujer","mula","muleta","multa","mundo","muñeca","mural","muro","músculo","museo","musgo","música","muslo","nácar","nación","nadar","naipe","naranja","nariz","narrar","nasal","natal","nativo","natural","náusea","naval","nave","navidad","necio","néctar","negar","negocio","negro","neón","nervio","neto","neutro","nevar","nevera","nicho","nido","niebla","nieto","niñez","niño","nítido","nivel","nobleza","noche","nómina","noria","norma","norte","nota","noticia","novato","novela","novio","nube","nuca","núcleo","nudillo","nudo","nuera","nueve","nuez","nulo","número","nutria","oasis","obeso","obispo","objeto","obra","obrero","observar","obtener","obvio","oca","ocaso","océano","ochenta","ocho","ocio","ocre","octavo","octubre","oculto","ocupar","ocurrir","odiar","odio","odisea","oeste","ofensa","oferta","oficio","ofrecer","ogro","oído","oír","ojo","ola","oleada","olfato","olivo","olla","olmo","olor","olvido","ombligo","onda","onza","opaco","opción","ópera","opinar","oponer","optar","óptica","opuesto","oración","orador","oral","órbita","orca","orden","oreja","órgano","orgía","orgullo","oriente","origen","orilla","oro","orquesta","oruga","osadía","oscuro","osezno","oso","ostra","otoño","otro","oveja","óvulo","óxido","oxígeno","oyente","ozono","pacto","padre","paella","página","pago","país","pájaro","palabra","palco","paleta","pálido","palma","paloma","palpar","pan","panal","pánico","pantera","pañuelo","papá","papel","papilla","paquete","parar","parcela","pared","parir","paro","párpado","parque","párrafo","parte","pasar","paseo","pasión","paso","pasta","pata","patio","patria","pausa","pauta","pavo","payaso","peatón","pecado","pecera","pecho","pedal","pedir","pegar","peine","pelar","peldaño","pelea","peligro","pellejo","pelo","peluca","pena","pensar","peñón","peón","peor","pepino","pequeño","pera","percha","perder","pereza","perfil","perico","perla","permiso","perro","persona","pesa","pesca","pésimo","pestaña","pétalo","petróleo","pez","pezuña","picar","pichón","pie","piedra","pierna","pieza","pijama","pilar","piloto","pimienta","pino","pintor","pinza","piña","piojo","pipa","pirata","pisar","piscina","piso","pista","pitón","pizca","placa","plan","plata","playa","plaza","pleito","pleno","plomo","pluma","plural","pobre","poco","poder","podio","poema","poesía","poeta","polen","policía","pollo","polvo","pomada","pomelo","pomo","pompa","poner","porción","portal","posada","poseer","posible","poste","potencia","potro","pozo","prado","precoz","pregunta","premio","prensa","preso","previo","primo","príncipe","prisión","privar","proa","probar","proceso","producto","proeza","profesor","programa","prole","promesa","pronto","propio","próximo","prueba","público","puchero","pudor","pueblo","puerta","puesto","pulga","pulir","pulmón","pulpo","pulso","puma","punto","puñal","puño","pupa","pupila","puré","quedar","queja","quemar","querer","queso","quieto","química","quince","quitar","rábano","rabia","rabo","ración","radical","raíz","rama","rampa","rancho","rango","rapaz","rápido","rapto","rasgo","raspa","rato","rayo","raza","razón","reacción","realidad","rebaño","rebote","recaer","receta","rechazo","recoger","recreo","recto","recurso","red","redondo","reducir","reflejo","reforma","refrán","refugio","regalo","regir","regla","regreso","rehén","reino","reír","reja","relato","relevo","relieve","relleno","reloj","remar","remedio","remo","rencor","rendir","renta","reparto","repetir","reposo","reptil","res","rescate","resina","respeto","resto","resumen","retiro","retorno","retrato","reunir","revés","revista","rey","rezar","rico","riego","rienda","riesgo","rifa","rígido","rigor","rincón","riñón","río","riqueza","risa","ritmo","rito","rizo","roble","roce","rociar","rodar","rodeo","rodilla","roer","rojizo","rojo","romero","romper","ron","ronco","ronda","ropa","ropero","rosa","rosca","rostro","rotar","rubí","rubor","rudo","rueda","rugir","ruido","ruina","ruleta","rulo","rumbo","rumor","ruptura","ruta","rutina","sábado","saber","sabio","sable","sacar","sagaz","sagrado","sala","saldo","salero","salir","salmón","salón","salsa","salto","salud","salvar","samba","sanción","sandía","sanear","sangre","sanidad","sano","santo","sapo","saque","sardina","sartén","sastre","satán","sauna","saxofón","sección","seco","secreto","secta","sed","seguir","seis","sello","selva","semana","semilla","senda","sensor","señal","señor","separar","sepia","sequía","ser","serie","sermón","servir","sesenta","sesión","seta","setenta","severo","sexo","sexto","sidra","siesta","siete","siglo","signo","sílaba","silbar","silencio","silla","símbolo","simio","sirena","sistema","sitio","situar","sobre","socio","sodio","sol","solapa","soldado","soledad","sólido","soltar","solución","sombra","sondeo","sonido","sonoro","sonrisa","sopa","soplar","soporte","sordo","sorpresa","sorteo","sostén","sótano","suave","subir","suceso","sudor","suegra","suelo","sueño","suerte","sufrir","sujeto","sultán","sumar","superar","suplir","suponer","supremo","sur","surco","sureño","surgir","susto","sutil","tabaco","tabique","tabla","tabú","taco","tacto","tajo","talar","talco","talento","talla","talón","tamaño","tambor","tango","tanque","tapa","tapete","tapia","tapón","taquilla","tarde","tarea","tarifa","tarjeta","tarot","tarro","tarta","tatuaje","tauro","taza","tazón","teatro","techo","tecla","técnica","tejado","tejer","tejido","tela","teléfono","tema","temor","templo","tenaz","tender","tener","tenis","tenso","teoría","terapia","terco","término","ternura","terror","tesis","tesoro","testigo","tetera","texto","tez","tibio","tiburón","tiempo","tienda","tierra","tieso","tigre","tijera","tilde","timbre","tímido","timo","tinta","tío","típico","tipo","tira","tirón","titán","títere","título","tiza","toalla","tobillo","tocar","tocino","todo","toga","toldo","tomar","tono","tonto","topar","tope","toque","tórax","torero","tormenta","torneo","toro","torpedo","torre","torso","tortuga","tos","tosco","toser","tóxico","trabajo","tractor","traer","tráfico","trago","traje","tramo","trance","trato","trauma","trazar","trébol","tregua","treinta","tren","trepar","tres","tribu","trigo","tripa","triste","triunfo","trofeo","trompa","tronco","tropa","trote","trozo","truco","trueno","trufa","tubería","tubo","tuerto","tumba","tumor","túnel","túnica","turbina","turismo","turno","tutor","ubicar","úlcera","umbral","unidad","unir","universo","uno","untar","uña","urbano","urbe","urgente","urna","usar","usuario","útil","utopía","uva","vaca","vacío","vacuna","vagar","vago","vaina","vajilla","vale","válido","valle","valor","válvula","vampiro","vara","variar","varón","vaso","vecino","vector","vehículo","veinte","vejez","vela","velero","veloz","vena","vencer","venda","veneno","vengar","venir","venta","venus","ver","verano","verbo","verde","vereda","verja","verso","verter","vía","viaje","vibrar","vicio","víctima","vida","vídeo","vidrio","viejo","viernes","vigor","vil","villa","vinagre","vino","viñedo","violín","viral","virgo","virtud","visor","víspera","vista","vitamina","viudo","vivaz","vivero","vivir","vivo","volcán","volumen","volver","voraz","votar","voto","voz","vuelo","vulgar","yacer","yate","yegua","yema","yerno","yeso","yodo","yoga","yogur","zafiro","zanja","zapato","zarza","zona","zorro","zumo","zurdo"]');

/***/ }),

/***/ 17116:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"z2":[{"title":"otc_nft_policy.otc_nft_policy.mint","redeemer":{"title":"redeemer","schema":{"$ref":"#/definitions/types~1NFTRedeemer"}},"parameters":[{"title":"params","schema":{"$ref":"#/definitions/types~1OTCNFTParams"}}],"compiledCode":"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","hash":"1994f51996e7ee30b1fcc188f9dff3ccbaf64fc0d3c5b06946f814da"},{"title":"otc_nft_policy.otc_nft_policy.else","redeemer":{"schema":{}},"parameters":[{"title":"params","schema":{"$ref":"#/definitions/types~1OTCNFTParams"}}],"compiledCode":"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","hash":"1994f51996e7ee30b1fcc188f9dff3ccbaf64fc0d3c5b06946f814da"},{"title":"otc_validator.otc.spend","datum":{"title":"datum","schema":{"$ref":"#/definitions/types~1OTCDatum"}},"redeemer":{"title":"redeemer","schema":{"$ref":"#/definitions/types~1OTCRedeemer"}},"parameters":[{"title":"params","schema":{"$ref":"#/definitions/types~1OTCParams"}}],"compiledCode":"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","hash":"41063e38393851e8cc2b95ac545f6af888accbb93139b1b1b4bd5427"},{"title":"otc_validator.otc.mint","redeemer":{"title":"redeemer","schema":{"$ref":"#/definitions/types~1OTCRedeemer"}},"parameters":[{"title":"params","schema":{"$ref":"#/definitions/types~1OTCParams"}}],"compiledCode":"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","hash":"41063e38393851e8cc2b95ac545f6af888accbb93139b1b1b4bd5427"},{"title":"otc_validator.otc.else","redeemer":{"schema":{}},"parameters":[{"title":"params","schema":{"$ref":"#/definitions/types~1OTCParams"}}],"compiledCode":"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","hash":"41063e38393851e8cc2b95ac545f6af888accbb93139b1b1b4bd5427"},{"title":"protocol.protocol.spend","datum":{"title":"datum","schema":{"$ref":"#/definitions/types~1ProtocolDatum"}},"redeemer":{"title":"redeemer","schema":{"$ref":"#/definitions/types~1ProtocolRedeemer"}},"parameters":[{"title":"params","schema":{"$ref":"#/definitions/types~1ProtocolParams"}}],"compiledCode":"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","hash":"454ddd49dbe5c9337671accfe7e65598222584e6be2d23b385d60a14"},{"title":"protocol.protocol.mint","redeemer":{"title":"redeemer","schema":{"$ref":"#/definitions/types~1ProtocolRedeemer"}},"parameters":[{"title":"params","schema":{"$ref":"#/definitions/types~1ProtocolParams"}}],"compiledCode":"5917df010100323232323232323232323232322253330073232323232323232323232323232323232323232323232323232323232323232323232323232323232533303030200241323232533333303b02913330210291325333034302530363754002264a66606a604a606e6ea80044c94ccc0d8c09cc0e0dd50020991919299981c9814801099299981d1815981e1baa00113232533303c302d303e37540022646464646464a6608666e5924010c617574686f72697a65643a2000373266032666084006980103d87a80004c0103d879800048810015330433372c92011a76616c69646174655f70726f746f636f6c5f706172616d733a2000373266032666084602c008980103d87a80004c0103d879800048810015330433372c92013270726f746f636f6c5f4f75742e76616c7565203d3d2070726f746f636f6c5f4f75745f56616c75655f436f6e74726f6c3a200037326603266608466ebcc0a8c114dd50029ba60014c103d87a80004c0103d879800048810015330433372c92013070726f746f636f6c446174756d5f4f7574203d3d2070726f746f636f6c446174756d5f4f75745f436f6e74726f6c3a200037326603266608466ebcc04c010c04c009300103d87a80004c0103d879800048810015333042003153330423016004153330423375e6054608a6ea8014dd3000899baf3013004301300214a029405281bab30293044375400e646464606c660906e9cc054dd6181698231baa005330483049003330483049002330483049001330483049304a0013304830193046375401a97ae0304900130480013047304337540046600e06e0126088608a00460860026eb0c108c0fcdd500081d199980e8198031bae3023303e375406c900118201bac3040303d375400206e66660380620086eb8c084c0f0dd501a240042a666072605000426464a6660766058607a6ea80044c8c94ccc0f4c0b8c0fcdd5000899191919191929982219b964910c617574686f72697a65643a2000373266034666086006980103d87a80004c0103d879800048810015330443372c92011a76616c69646174655f70726f746f636f6c5f706172616d733a2000373266034666086602e008980103d87a80004c0103d879800048810015330443372c92013270726f746f636f6c5f4f75742e76616c7565203d3d2070726f746f636f6c5f4f75745f56616c75655f436f6e74726f6c3a200037326603466608666ebcc0acc118dd50029ba60014c103d87a80004c0103d879800048810015330443372c92013070726f746f636f6c446174756d5f4f7574203d3d2070726f746f636f6c446174756d5f4f75745f436f6e74726f6c3a200037326603466608666ebcc050010c050009300103d87a80004c0103d879800048810015333043003153330433017004153330433375e6056608c6ea8014dd3000899baf3014004301400214a029405281980f9bab302a3045375400e66e00cdc0a40006eb4c060c114dd500600499191919181c1982518258021982518258019982518258011982518258009982518259826000998251ba800c4bd7018258009825000982480098221baa00b3300803800a3045304600230440013758608660806ea80040eccccc0780d001cdd71812181f9baa03748008c104dd61820981f1baa001038333301d032005375c6044607a6ea80d52002375a607e60786ea80bc5281119299981d99198008009bac3026303f375400644a66608200229404c94ccc0f8c8c8cc004004dd618231823982398239823982398239823982398219baa00822533304500114a0264a66608466e3cdd718240010020a511330030030013048001375c608800429444cc00c00c004c110004528880099198008009bac3023303e375400644a66608000229404c94ccc0f4ccc0f4c06cc94ccc0f8c0b8c100dd50008a5eb7bdb1804dd5982218209baa0013302a3756604a60806ea8c094c100dd518218011bae302530403754008941288a5113300300300130430013039375405a607860726ea80105281bae303b303837540022a6606c9213665787065637420536372697074286f776e5f76616c696461746f725f6861736829203d207061796d656e745f63726564656e7469616c0016303a303737546074606e6ea8c0e8c0ecc0dcdd5181d181b9baa00115330354916165787065637420536f6d65286f776e5f696e70757429203d0a2020202020206c6973742e66696e6428696e707574732c20666e28696e70757429207b20696e7075742e6f75747075745f7265666572656e6365203d3d206f776e5f726566207d2900163302537586072606c6ea80ac8cdd7980f181b9baa00100302f02f02f02f02f3038303900230370013033375404a2a6660606042048264a66666607204e266603e04e2a666062604460666ea809c54ccc0c4c088c0ccdd5198119bac301b30343754052466ebcc070c0d4dd5000980e181a9baa02d1533303130213033375466660280520026eb8c064c0d0dd501624000264a666064604660686ea80044c8c8c8c8c94cc0e0cdcb2490445313a200037326601c66606e002980103d87a80004c0103d87980004881001325330393372c92010445323a200037326601e666070002980103d87a80004c0103d879800048810013253303a3372c9201054533413a2000373266020604260786ea8019220100153303a3372c9201054533433a20003732660206e98011220100153303a3372c9201054533443a2000373266020666072002980103d87a80004c0103d879800048810013253303b3372c92010445343a2000373266022666074002980103d87a80004c0103d87980004881001533303a0041533303a0031533303a002100114a0294052819baf300a005300a0053375e604060766ea8014dd30019805801981319980f9bab300b3039375405c00c6eb8c078c0e4dd50189980919198008009981d99bb0375200c6e98cc0eccdd8180f181c9baa0314c010101004bd6f7b63025eb7bdb180894ccc0ec00452f5bded8c0266446464a66607e0022a66078920124657870656374205061697228702c205b5f2c202e2e5d206173207829203d20696e6e65720016132333301b0040030012225330404901234475706c696361746520706f6c69637920696e20746865206173736574206c6973742e00163200232323300100100322533304200114984c94ccc10c00454ccc0fcc010dd6982118228010a4c2a6608092011f76616c756520646f65736e277420736174697366792070726564696361746500161323232325333043337206eb8c114010dd718228018a9998219804000899803803998240018010a9982224811f76616c756520646f65736e277420736174697366792070726564696361746500161533044491276b65797320696e207061697273206172656e277420696e20617363656e64696e67206f726465720016375a608a0066090006608c004608a004608a0024666078605a002941289bab303d003375c6076004607a00266004004607c0026eb4c02cc0e0dd5000981d181d801181c8009bac30383035375400206066660260520026eb8c064c0d0dd5016240042a6606492187657870656374204e6f6e65203d0a202020206765745f70726f746f636f6c5f66726f6d5f696e70757473280a2020202020207472616e73616374696f6e2c0a20202020202070726f746f636f6c5f706f6c6963795f69642c0a202020202020706172616d732e70705f70726f746f636f6c5f69645f746e2c0a202020202020302c0a202020202900161533032491b365787065637420536f6d65285f7265666572656e63655f696e70757429203d0a202020206c6973742e66696e64280a2020202020207472616e73616374696f6e2e696e707574732c0a202020202020666e28696e70757429207b0a2020202020202020696e7075742e6f75747075745f7265666572656e6365203d3d20706172616d732e70705f70726f746f636f6c5f706f6c6963795f69645f74785f6f75745f7265660a2020202020207d2c0a2020202029001614a005a05a05a05a05a6eb8c0d8c0ccdd50128a99818a48121496e76616c696420557365206f662050726f746f636f6c2056616c696461746f7200162302333035374e60046eb0c068c0ccdd50009981a980c18199baa00133035301c303337540026606a606c606e606e606e60666ea8004cc0d4c014c0ccdd50009981a980318199baa0014bd7018008009129998198008a5eb804c8c8cc004004cc010010c0e000c894ccc0d80044cc0dcdd4801a5eb804c8c94ccc0d0cdd7a99981a19b9000500214c103d8798000153330343371e00a0042980103d87a800014c103d87b80004c0103d8798000133039375200a660726ea40080044cc0e4dd480119802002000981d0011bae3038001375c606a0024a66605a66e212000375a600660606ea800454ccc0b4ccc0b54ccc0c4dd6180b98181baa00114a22941282511533302d3371290001bad300230303754002266605a603c6e34dd7180a98181baa0014a09445280a5014a046064606660666066606600246062606460646064606460640026002002444a6664666606800626464646464646601800400266e2922010128000025333030337100069007099b80483c80400c54ccc0c0cdc4001a410004266e00cdc0241002800690068b2999819800899b8a4881035b5d2900005133714911035b5f2000333300800133714911025d290000522333009009002300600122333009009002001375860620046eb4c0bc004c8cdd81ba8302f001374e60600026ea800c4c94ccc0c40044cdc52441027b7d00003133714911037b5f200032323300100100322533303400110031533303430370011323330090093033001337149101023a2000333009009303400100430360011323330090093033001337149101023a20003330090093034001300633003003303800230360013371491102207d000033756006264a666062002266e29221025b5d00003133714911035b5f2000333300600133714911015d000032233300700700230040012233300700700200137580066e292201022c2000133005375a0040022646466e2922010268270000132333001001337006e34009200133714911012700003222533302f3371000490000800899191919980300319b8000548004cdc599b80002533303233710004900a0a40c02903719b8b33700002a66606466e2000520141481805206e0043370c004901019b8300148080cdc70020011bae0022222323300100100522533303100110051533303130340011330033033001005133004303300133002002303400122323300100100322533302a301b0011337149110130000031533302a337100029000099b8a489012d003300200233702900000089980299b8400148050cdc599b803370a002900a240c00066002002444a66604e66e2400920001001133300300333708004900a19b8b3370066e14009201448180004894ccc094c05800440084cccc010009220100323200230060013302a337609801014000375000297adef6c60222325333029300700114c103d87a80001301c3302e374c00297ae0323300100100322533302e00113302f337609801014000375000c97adef6c60132323232533302e33720910100002133033337609801014000375001400a2a66605c66e3d22100002132533302f30203031375400226606866ec1301014000303530323754002008200864a66605e6040002298103d87a80001302233034375000297ae03370000201426606666ec0dd48011ba800133006006003375a60600066eb8c0b8008c0c8008c0c000494ccc09c0045288a502222323300100100522533302b00113302c337606ea4014dd300225eb7bdb1804c8c8c8c94ccc0accdc800480109981819bb037520126e9802001454ccc0accdc78048010992999816180e98171baa001133031337606ea4028c0c8c0bcdd5000802080219980380480080409981819bb037520046e98004cc01801800cdd598168019bae302b002302f002302d001300100122533302500114984c94ccc098004526132325333024337206eb8c098c0a8010dd71813001099802802998148010008a99812a481326b65797320696e206173736f63696174697665206c697374206172656e277420696e20617363656e64696e67206f726465720016302a0023028001302800122223253330233370e6012002004264a666048602a604c6ea80044c8c94ccc098c05cc0a0dd50008980c998159ba73302b0023302b302c3029375400297ae04bd700a6103d87a80003009001302a30273754002298103d87a8000300800114c0103d87a80003300d3758601c604a6ea80108c04cccc030dd5980598131baa00100400322223253330223370e6010002004264a6660466028604a6ea80044c8c94ccc094c058c09cdd50008980c198151ba73302a300d3028375400466054605660506ea80052f5c097ae014c103d87a80003008300c302737540026052604c6ea8004530103d87a8000300700114c0103d87a80003300c3758601660486ea80108c048ccc02cdd5980518129baa300a30253754002008006464a66603c601a60406ea80044c94cccccc09c00454ccc07cc040c084dd5000899299981200080f8992999999814800810010099192999813800811099299999981600081181181181189919299981500081289929999998178008130130130130991929998168008140992999999819000814814814814899192999818000815899299999981a800816016016099192999819800817099299999981c000817817817899299981a981c001899198008008089119299981c001098139981c80b25eb804c94cccccc0f40040d00d00d00d04c8c00cc0f4010dd7000981d00118010010181bad00102f30350013035003375a002058606400260640066eb8004c0bc004c0bc00cdd7000981600098160019bae001302900130290033758002040040604c00260446ea8004078078078078078c090c084dd50008a60103d87a80003009302037540024a666040002298103d87a80001300f3302130220014bd70180080091299980f8008a4000266e0120023300200230220012301f302000122232533301b300b301d37540022900009bad3021301e375400264a6660366016603a6ea8004530103d87a80001323300100137566044603e6ea8008894ccc084004530103d87a80001323232325333021337220100042a66604266e3c0200084c050cc098dd4000a5eb80530103d87a8000133006006003375a60460066eb8c084008c094008c08c004cc01c00c0088c07400488c8cc00400400c894ccc07400452f5c026464a666036600a004266040004660080080022660080080026042004603e002460366038603800244646600200200644a666036002298103d87a8000132323232533301b3372200e0042a66603666e3c01c0084c038cc080dd3000a5eb80530103d87a80001330060060033756603a0066eb8c06c008c07c008c074004888c94ccc058c01c00454ccc068c064dd50020a8018010a99980b18030008a99980d180c9baa00415003002153330163005001132533301b0010031325333333020001004004004132533301d302000315006005375a002008603a00260326ea8010008c05cdd50019b8748010dc3a40046e1d200022323300100100322533301600114c0103d87a8000132325333014300500213007330190024bd70099802002000980d001180c0009ba548000c038dd50009808980900118080009808001180700098051baa001149854cc02124011856616c696461746f722072657475726e65642066616c73650013656153300549011a72656465656d65723a2050726f746f636f6c52656465656d6572001615330044919965787065637420536f6d65282870726f746f636f6c5f496e2c205f2929203d0a202020206765745f70726f746f636f6c5f66726f6d5f696e70757473280a2020202020207472616e73616374696f6e2c0a20202020202070726f746f636f6c5f706f6c6963795f69642c0a202020202020706172616d732e70705f70726f746f636f6c5f69645f746e2c0a202020202020312c0a202020202900161533003491ab65787065637420536f6d65282870726f746f636f6c5f4f75742c2070726f746f636f6c446174756d5f4f75742929203d0a202020206765745f70726f746f636f6c5f66726f6d5f6f757470757473280a2020202020207472616e73616374696f6e2c0a20202020202070726f746f636f6c5f706f6c6963795f69642c0a202020202020706172616d732e70705f70726f746f636f6c5f69645f746e2c0a202020202020312c0a2020202029001615330024912265787065637420646174756d3a2050726f746f636f6c446174756d203d206461746100165734ae7155ceaab9e5573eae815d0aba257481","hash":"454ddd49dbe5c9337671accfe7e65598222584e6be2d23b385d60a14"},{"title":"protocol.protocol.else","redeemer":{"schema":{}},"parameters":[{"title":"params","schema":{"$ref":"#/definitions/types~1ProtocolParams"}}],"compiledCode":"5917df010100323232323232323232323232322253330073232323232323232323232323232323232323232323232323232323232323232323232323232323232533303030200241323232533333303b02913330210291325333034302530363754002264a66606a604a606e6ea80044c94ccc0d8c09cc0e0dd50020991919299981c9814801099299981d1815981e1baa00113232533303c302d303e37540022646464646464a6608666e5924010c617574686f72697a65643a2000373266032666084006980103d87a80004c0103d879800048810015330433372c92011a76616c69646174655f70726f746f636f6c5f706172616d733a2000373266032666084602c008980103d87a80004c0103d879800048810015330433372c92013270726f746f636f6c5f4f75742e76616c7565203d3d2070726f746f636f6c5f4f75745f56616c75655f436f6e74726f6c3a200037326603266608466ebcc0a8c114dd50029ba60014c103d87a80004c0103d879800048810015330433372c92013070726f746f636f6c446174756d5f4f7574203d3d2070726f746f636f6c446174756d5f4f75745f436f6e74726f6c3a200037326603266608466ebcc04c010c04c009300103d87a80004c0103d879800048810015333042003153330423016004153330423375e6054608a6ea8014dd3000899baf3013004301300214a029405281bab30293044375400e646464606c660906e9cc054dd6181698231baa005330483049003330483049002330483049001330483049304a0013304830193046375401a97ae0304900130480013047304337540046600e06e0126088608a00460860026eb0c108c0fcdd500081d199980e8198031bae3023303e375406c900118201bac3040303d375400206e66660380620086eb8c084c0f0dd501a240042a666072605000426464a6660766058607a6ea80044c8c94ccc0f4c0b8c0fcdd5000899191919191929982219b964910c617574686f72697a65643a2000373266034666086006980103d87a80004c0103d879800048810015330443372c92011a76616c69646174655f70726f746f636f6c5f706172616d733a2000373266034666086602e008980103d87a80004c0103d879800048810015330443372c92013270726f746f636f6c5f4f75742e76616c7565203d3d2070726f746f636f6c5f4f75745f56616c75655f436f6e74726f6c3a200037326603466608666ebcc0acc118dd50029ba60014c103d87a80004c0103d879800048810015330443372c92013070726f746f636f6c446174756d5f4f7574203d3d2070726f746f636f6c446174756d5f4f75745f436f6e74726f6c3a200037326603466608666ebcc050010c050009300103d87a80004c0103d879800048810015333043003153330433017004153330433375e6056608c6ea8014dd3000899baf3014004301400214a029405281980f9bab302a3045375400e66e00cdc0a40006eb4c060c114dd500600499191919181c1982518258021982518258019982518258011982518258009982518259826000998251ba800c4bd7018258009825000982480098221baa00b3300803800a3045304600230440013758608660806ea80040eccccc0780d001cdd71812181f9baa03748008c104dd61820981f1baa001038333301d032005375c6044607a6ea80d52002375a607e60786ea80bc5281119299981d99198008009bac3026303f375400644a66608200229404c94ccc0f8c8c8cc004004dd618231823982398239823982398239823982398219baa00822533304500114a0264a66608466e3cdd718240010020a511330030030013048001375c608800429444cc00c00c004c110004528880099198008009bac3023303e375400644a66608000229404c94ccc0f4ccc0f4c06cc94ccc0f8c0b8c100dd50008a5eb7bdb1804dd5982218209baa0013302a3756604a60806ea8c094c100dd518218011bae302530403754008941288a5113300300300130430013039375405a607860726ea80105281bae303b303837540022a6606c9213665787065637420536372697074286f776e5f76616c696461746f725f6861736829203d207061796d656e745f63726564656e7469616c0016303a303737546074606e6ea8c0e8c0ecc0dcdd5181d181b9baa00115330354916165787065637420536f6d65286f776e5f696e70757429203d0a2020202020206c6973742e66696e6428696e707574732c20666e28696e70757429207b20696e7075742e6f75747075745f7265666572656e6365203d3d206f776e5f726566207d2900163302537586072606c6ea80ac8cdd7980f181b9baa00100302f02f02f02f02f3038303900230370013033375404a2a6660606042048264a66666607204e266603e04e2a666062604460666ea809c54ccc0c4c088c0ccdd5198119bac301b30343754052466ebcc070c0d4dd5000980e181a9baa02d1533303130213033375466660280520026eb8c064c0d0dd501624000264a666064604660686ea80044c8c8c8c8c94cc0e0cdcb2490445313a200037326601c66606e002980103d87a80004c0103d87980004881001325330393372c92010445323a200037326601e666070002980103d87a80004c0103d879800048810013253303a3372c9201054533413a2000373266020604260786ea8019220100153303a3372c9201054533433a20003732660206e98011220100153303a3372c9201054533443a2000373266020666072002980103d87a80004c0103d879800048810013253303b3372c92010445343a2000373266022666074002980103d87a80004c0103d87980004881001533303a0041533303a0031533303a002100114a0294052819baf300a005300a0053375e604060766ea8014dd30019805801981319980f9bab300b3039375405c00c6eb8c078c0e4dd50189980919198008009981d99bb0375200c6e98cc0eccdd8180f181c9baa0314c010101004bd6f7b63025eb7bdb180894ccc0ec00452f5bded8c0266446464a66607e0022a66078920124657870656374205061697228702c205b5f2c202e2e5d206173207829203d20696e6e65720016132333301b0040030012225330404901234475706c696361746520706f6c69637920696e20746865206173736574206c6973742e00163200232323300100100322533304200114984c94ccc10c00454ccc0fcc010dd6982118228010a4c2a6608092011f76616c756520646f65736e277420736174697366792070726564696361746500161323232325333043337206eb8c114010dd718228018a9998219804000899803803998240018010a9982224811f76616c756520646f65736e277420736174697366792070726564696361746500161533044491276b65797320696e207061697273206172656e277420696e20617363656e64696e67206f726465720016375a608a0066090006608c004608a004608a0024666078605a002941289bab303d003375c6076004607a00266004004607c0026eb4c02cc0e0dd5000981d181d801181c8009bac30383035375400206066660260520026eb8c064c0d0dd5016240042a6606492187657870656374204e6f6e65203d0a202020206765745f70726f746f636f6c5f66726f6d5f696e70757473280a2020202020207472616e73616374696f6e2c0a20202020202070726f746f636f6c5f706f6c6963795f69642c0a202020202020706172616d732e70705f70726f746f636f6c5f69645f746e2c0a202020202020302c0a202020202900161533032491b365787065637420536f6d65285f7265666572656e63655f696e70757429203d0a202020206c6973742e66696e64280a2020202020207472616e73616374696f6e2e696e707574732c0a202020202020666e28696e70757429207b0a2020202020202020696e7075742e6f75747075745f7265666572656e6365203d3d20706172616d732e70705f70726f746f636f6c5f706f6c6963795f69645f74785f6f75745f7265660a2020202020207d2c0a2020202029001614a005a05a05a05a05a6eb8c0d8c0ccdd50128a99818a48121496e76616c696420557365206f662050726f746f636f6c2056616c696461746f7200162302333035374e60046eb0c068c0ccdd50009981a980c18199baa00133035301c303337540026606a606c606e606e606e60666ea8004cc0d4c014c0ccdd50009981a980318199baa0014bd7018008009129998198008a5eb804c8c8cc004004cc010010c0e000c894ccc0d80044cc0dcdd4801a5eb804c8c94ccc0d0cdd7a99981a19b9000500214c103d8798000153330343371e00a0042980103d87a800014c103d87b80004c0103d8798000133039375200a660726ea40080044cc0e4dd480119802002000981d0011bae3038001375c606a0024a66605a66e212000375a600660606ea800454ccc0b4ccc0b54ccc0c4dd6180b98181baa00114a22941282511533302d3371290001bad300230303754002266605a603c6e34dd7180a98181baa0014a09445280a5014a046064606660666066606600246062606460646064606460640026002002444a6664666606800626464646464646601800400266e2922010128000025333030337100069007099b80483c80400c54ccc0c0cdc4001a410004266e00cdc0241002800690068b2999819800899b8a4881035b5d2900005133714911035b5f2000333300800133714911025d290000522333009009002300600122333009009002001375860620046eb4c0bc004c8cdd81ba8302f001374e60600026ea800c4c94ccc0c40044cdc52441027b7d00003133714911037b5f200032323300100100322533303400110031533303430370011323330090093033001337149101023a2000333009009303400100430360011323330090093033001337149101023a20003330090093034001300633003003303800230360013371491102207d000033756006264a666062002266e29221025b5d00003133714911035b5f2000333300600133714911015d000032233300700700230040012233300700700200137580066e292201022c2000133005375a0040022646466e2922010268270000132333001001337006e34009200133714911012700003222533302f3371000490000800899191919980300319b8000548004cdc599b80002533303233710004900a0a40c02903719b8b33700002a66606466e2000520141481805206e0043370c004901019b8300148080cdc70020011bae0022222323300100100522533303100110051533303130340011330033033001005133004303300133002002303400122323300100100322533302a301b0011337149110130000031533302a337100029000099b8a489012d003300200233702900000089980299b8400148050cdc599b803370a002900a240c00066002002444a66604e66e2400920001001133300300333708004900a19b8b3370066e14009201448180004894ccc094c05800440084cccc010009220100323200230060013302a337609801014000375000297adef6c60222325333029300700114c103d87a80001301c3302e374c00297ae0323300100100322533302e00113302f337609801014000375000c97adef6c60132323232533302e33720910100002133033337609801014000375001400a2a66605c66e3d22100002132533302f30203031375400226606866ec1301014000303530323754002008200864a66605e6040002298103d87a80001302233034375000297ae03370000201426606666ec0dd48011ba800133006006003375a60600066eb8c0b8008c0c8008c0c000494ccc09c0045288a502222323300100100522533302b00113302c337606ea4014dd300225eb7bdb1804c8c8c8c94ccc0accdc800480109981819bb037520126e9802001454ccc0accdc78048010992999816180e98171baa001133031337606ea4028c0c8c0bcdd5000802080219980380480080409981819bb037520046e98004cc01801800cdd598168019bae302b002302f002302d001300100122533302500114984c94ccc098004526132325333024337206eb8c098c0a8010dd71813001099802802998148010008a99812a481326b65797320696e206173736f63696174697665206c697374206172656e277420696e20617363656e64696e67206f726465720016302a0023028001302800122223253330233370e6012002004264a666048602a604c6ea80044c8c94ccc098c05cc0a0dd50008980c998159ba73302b0023302b302c3029375400297ae04bd700a6103d87a80003009001302a30273754002298103d87a8000300800114c0103d87a80003300d3758601c604a6ea80108c04cccc030dd5980598131baa00100400322223253330223370e6010002004264a6660466028604a6ea80044c8c94ccc094c058c09cdd50008980c198151ba73302a300d3028375400466054605660506ea80052f5c097ae014c103d87a80003008300c302737540026052604c6ea8004530103d87a8000300700114c0103d87a80003300c3758601660486ea80108c048ccc02cdd5980518129baa300a30253754002008006464a66603c601a60406ea80044c94cccccc09c00454ccc07cc040c084dd5000899299981200080f8992999999814800810010099192999813800811099299999981600081181181181189919299981500081289929999998178008130130130130991929998168008140992999999819000814814814814899192999818000815899299999981a800816016016099192999819800817099299999981c000817817817899299981a981c001899198008008089119299981c001098139981c80b25eb804c94cccccc0f40040d00d00d00d04c8c00cc0f4010dd7000981d00118010010181bad00102f30350013035003375a002058606400260640066eb8004c0bc004c0bc00cdd7000981600098160019bae001302900130290033758002040040604c00260446ea8004078078078078078c090c084dd50008a60103d87a80003009302037540024a666040002298103d87a80001300f3302130220014bd70180080091299980f8008a4000266e0120023300200230220012301f302000122232533301b300b301d37540022900009bad3021301e375400264a6660366016603a6ea8004530103d87a80001323300100137566044603e6ea8008894ccc084004530103d87a80001323232325333021337220100042a66604266e3c0200084c050cc098dd4000a5eb80530103d87a8000133006006003375a60460066eb8c084008c094008c08c004cc01c00c0088c07400488c8cc00400400c894ccc07400452f5c026464a666036600a004266040004660080080022660080080026042004603e002460366038603800244646600200200644a666036002298103d87a8000132323232533301b3372200e0042a66603666e3c01c0084c038cc080dd3000a5eb80530103d87a80001330060060033756603a0066eb8c06c008c07c008c074004888c94ccc058c01c00454ccc068c064dd50020a8018010a99980b18030008a99980d180c9baa00415003002153330163005001132533301b0010031325333333020001004004004132533301d302000315006005375a002008603a00260326ea8010008c05cdd50019b8748010dc3a40046e1d200022323300100100322533301600114c0103d87a8000132325333014300500213007330190024bd70099802002000980d001180c0009ba548000c038dd50009808980900118080009808001180700098051baa001149854cc02124011856616c696461746f722072657475726e65642066616c73650013656153300549011a72656465656d65723a2050726f746f636f6c52656465656d6572001615330044919965787065637420536f6d65282870726f746f636f6c5f496e2c205f2929203d0a202020206765745f70726f746f636f6c5f66726f6d5f696e70757473280a2020202020207472616e73616374696f6e2c0a20202020202070726f746f636f6c5f706f6c6963795f69642c0a202020202020706172616d732e70705f70726f746f636f6c5f69645f746e2c0a202020202020312c0a202020202900161533003491ab65787065637420536f6d65282870726f746f636f6c5f4f75742c2070726f746f636f6c446174756d5f4f75742929203d0a202020206765745f70726f746f636f6c5f66726f6d5f6f757470757473280a2020202020207472616e73616374696f6e2c0a20202020202070726f746f636f6c5f706f6c6963795f69642c0a202020202020706172616d732e70705f70726f746f636f6c5f69645f746e2c0a202020202020312c0a2020202029001615330024912265787065637420646174756d3a2050726f746f636f6c446174756d203d206461746100165734ae7155ceaab9e5573eae815d0aba257481","hash":"454ddd49dbe5c9337671accfe7e65598222584e6be2d23b385d60a14"}]}');

/***/ }),

/***/ 5752:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var WEBPACK_IMPORTED_MODULE_0 = __webpack_require__(20630);
module.exports = __webpack_require__.v(exports, module.id, "b6ba8313b655dbf8", {
	"./cardano_multiplatform_lib_bg.js": {
		"__wbindgen_is_object": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_is_object */ .WlW,
		"__wbindgen_string_new": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_string_new */ .h4u,
		"__wbindgen_object_drop_ref": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_object_drop_ref */ .ug$,
		"__wbindgen_throw": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_throw */ .Or8,
		"__wbindgen_memory": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_memory */ .oHO,
		"__wbindgen_is_function": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_is_function */ .o$X,
		"__wbindgen_is_string": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_is_string */ .eYF,
		"__wbindgen_object_clone_ref": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_object_clone_ref */ .m_1,
		"__wbg_buffer_b7b08af79b0b0974": WEBPACK_IMPORTED_MODULE_0/* .__wbg_buffer_b7b08af79b0b0974 */ .BOx,
		"__wbg_new_a220cf903aa02ca2": WEBPACK_IMPORTED_MODULE_0/* .__wbg_new_a220cf903aa02ca2 */ .ak$,
		"__wbindgen_number_new": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_number_new */ .pT7,
		"__wbg_newnoargs_76313bd6ff35d0f2": WEBPACK_IMPORTED_MODULE_0/* .__wbg_newnoargs_76313bd6ff35d0f2 */ .gg_,
		"__wbg_new_8608a2b51a5f6737": WEBPACK_IMPORTED_MODULE_0/* .__wbg_new_8608a2b51a5f6737 */ .wzW,
		"__wbg_new_525245e2b9901204": WEBPACK_IMPORTED_MODULE_0/* .__wbg_new_525245e2b9901204 */ .R1Q,
		"__wbg_self_3093d5d1f7bcb682": WEBPACK_IMPORTED_MODULE_0/* .__wbg_self_3093d5d1f7bcb682 */ .Glo,
		"__wbg_window_3bcfc4d31bc012f8": WEBPACK_IMPORTED_MODULE_0/* .__wbg_window_3bcfc4d31bc012f8 */ .Ssi,
		"__wbg_globalThis_86b222e13bdf32ed": WEBPACK_IMPORTED_MODULE_0/* .__wbg_globalThis_86b222e13bdf32ed */ .FyC,
		"__wbg_global_e5a3fe56f8be9485": WEBPACK_IMPORTED_MODULE_0/* .__wbg_global_e5a3fe56f8be9485 */ .OLm,
		"__wbindgen_is_undefined": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_is_undefined */ .XP4,
		"__wbg_set_673dda6c73d19609": WEBPACK_IMPORTED_MODULE_0/* .__wbg_set_673dda6c73d19609 */ .kdS,
		"__wbg_call_1084a111329e68ce": WEBPACK_IMPORTED_MODULE_0/* .__wbg_call_1084a111329e68ce */ .u9i,
		"__wbg_call_89af060b4e1523f2": WEBPACK_IMPORTED_MODULE_0/* .__wbg_call_89af060b4e1523f2 */ .D2P,
		"__wbg_set_49185437f0ab06f8": WEBPACK_IMPORTED_MODULE_0/* .__wbg_set_49185437f0ab06f8 */ .N9V,
		"__wbg_newwithbyteoffsetandlength_8a2cb9ca96b27ec9": WEBPACK_IMPORTED_MODULE_0/* .__wbg_newwithbyteoffsetandlength_8a2cb9ca96b27ec9 */ .sG1,
		"__wbg_new_ea1883e1e5e86686": WEBPACK_IMPORTED_MODULE_0/* .__wbg_new_ea1883e1e5e86686 */ .dFT,
		"__wbg_newwithlength_ec548f448387c968": WEBPACK_IMPORTED_MODULE_0/* .__wbg_newwithlength_ec548f448387c968 */ .qeO,
		"__wbg_subarray_7c2e3576afe181d1": WEBPACK_IMPORTED_MODULE_0/* .__wbg_subarray_7c2e3576afe181d1 */ .Dnr,
		"__wbg_set_d1e79e2388520f18": WEBPACK_IMPORTED_MODULE_0/* .__wbg_set_d1e79e2388520f18 */ .eFR,
		"__wbg_crypto_1d1f22824a6a080c": WEBPACK_IMPORTED_MODULE_0/* .__wbg_crypto_1d1f22824a6a080c */ .q4o,
		"__wbg_process_4a72847cc503995b": WEBPACK_IMPORTED_MODULE_0/* .__wbg_process_4a72847cc503995b */ .eoR,
		"__wbg_versions_f686565e586dd935": WEBPACK_IMPORTED_MODULE_0/* .__wbg_versions_f686565e586dd935 */ .uYV,
		"__wbg_node_104a2ff8d6ea03a2": WEBPACK_IMPORTED_MODULE_0/* .__wbg_node_104a2ff8d6ea03a2 */ .qxi,
		"__wbg_require_cca90b1a94a0255b": WEBPACK_IMPORTED_MODULE_0/* .__wbg_require_cca90b1a94a0255b */ .OQ_,
		"__wbg_msCrypto_eb05e62b530a1508": WEBPACK_IMPORTED_MODULE_0/* .__wbg_msCrypto_eb05e62b530a1508 */ .hcz,
		"__wbg_randomFillSync_5c9c955aa56b6049": WEBPACK_IMPORTED_MODULE_0/* .__wbg_randomFillSync_5c9c955aa56b6049 */ .oH7,
		"__wbg_getRandomValues_3aa56aa6edec874c": WEBPACK_IMPORTED_MODULE_0/* .__wbg_getRandomValues_3aa56aa6edec874c */ .Iui,
		"__wbg_String_91fba7ded13ba54c": WEBPACK_IMPORTED_MODULE_0/* .__wbg_String_91fba7ded13ba54c */ .RVh,
		"__wbindgen_error_new": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_error_new */ .hdV,
		"__wbindgen_bigint_from_i64": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_bigint_from_i64 */ .WD8,
		"__wbindgen_bigint_from_u64": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_bigint_from_u64 */ .KxL,
		"__wbg_set_20cbc34131e76824": WEBPACK_IMPORTED_MODULE_0/* .__wbg_set_20cbc34131e76824 */ .Wl7
	}
});

/***/ }),

/***/ 86789:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var WEBPACK_IMPORTED_MODULE_0 = __webpack_require__(78263);
module.exports = __webpack_require__.v(exports, module.id, "32265a2dffa473d7", {
	"./cardano_message_signing_bg.js": {
		"__wbindgen_object_drop_ref": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_object_drop_ref */ .ug,
		"__wbindgen_string_new": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_string_new */ .h4,
		"__wbindgen_debug_string": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_debug_string */ .fY,
		"__wbindgen_throw": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_throw */ .Or
	}
});

/***/ }),

/***/ 46335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var WEBPACK_IMPORTED_MODULE_0 = __webpack_require__(22095);
module.exports = __webpack_require__.v(exports, module.id, "8615b28607c0204e", {
	"./uplc_tx_bg.js": {
		"__wbindgen_string_new": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_string_new */ .h4,
		"__wbindgen_memory": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_memory */ .oH,
		"__wbg_buffer_b7b08af79b0b0974": WEBPACK_IMPORTED_MODULE_0/* .__wbg_buffer_b7b08af79b0b0974 */ .BO,
		"__wbg_newwithbyteoffsetandlength_8a2cb9ca96b27ec9": WEBPACK_IMPORTED_MODULE_0/* .__wbg_newwithbyteoffsetandlength_8a2cb9ca96b27ec9 */ .sG,
		"__wbg_new_ea1883e1e5e86686": WEBPACK_IMPORTED_MODULE_0/* .__wbg_new_ea1883e1e5e86686 */ .dF,
		"__wbindgen_object_drop_ref": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_object_drop_ref */ .ug,
		"__wbg_length_8339fcf5d8ecd12e": WEBPACK_IMPORTED_MODULE_0/* .__wbg_length_8339fcf5d8ecd12e */ .aN,
		"__wbg_set_d1e79e2388520f18": WEBPACK_IMPORTED_MODULE_0/* .__wbg_set_d1e79e2388520f18 */ .eF,
		"__wbindgen_throw": WEBPACK_IMPORTED_MODULE_0/* .__wbindgen_throw */ .Or
	}
});

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6840), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);